var ESe = Object.defineProperty;
var xSe = (e, t, n) => t in e ? ESe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var vi = (e, t, n) => (xSe(e, typeof t != "symbol" ? t + "" : t, n), n), dI = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var lt = (e, t, n) => (dI(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Fn = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, En = (e, t, n, o) => (dI(e, t, "write to private field"), o ? o.call(e, n) : t.set(e, n), n);
var J1 = (e, t, n, o) => ({
  set _(r) {
    En(e, t, r, n);
  },
  get _() {
    return lt(e, t, o);
  }
}), fo = (e, t, n) => (dI(e, t, "access private method"), n);
import gT, { jsx as m, Fragment as nt, jsxs as de } from "react/jsx-runtime";
import * as Ue from "react";
import Fe, { useCallback as Yt, createContext as Cr, useMemo as vn, createElement as pt, useContext as bo, forwardRef as Bt, Children as hg, isValidElement as zd, cloneElement as gf, Fragment as Ha, useEffect as yt, useRef as xt, useState as it, useLayoutEffect as lc, useReducer as A0, Component as mre, useId as I0, useImperativeHandle as fre, useInsertionEffect as gre, createRef as CSe, Suspense as hT, memo as hre, useDebugValue as TSe } from "react";
import * as ASe from "react-dom";
import $v, { flushSync as vre, createPortal as My, unstable_batchedUpdates as bre } from "react-dom";
var wv = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, yy = typeof window > "u" || "Deno" in window;
function kd() {
}
function ISe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function VL(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function yre(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function YB(e, t) {
  const {
    type: n = "all",
    exact: o,
    fetchStatus: r,
    predicate: i,
    queryKey: a,
    stale: s
  } = e;
  if (a) {
    if (o) {
      if (t.queryHash !== b6(a, t.options))
        return !1;
    } else if (!dk(t.queryKey, a))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || typeof r < "u" && r !== t.state.fetchStatus || i && !i(t));
}
function KB(e, t) {
  const { exact: n, status: o, predicate: r, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ag(t.options.mutationKey) !== Ag(i))
        return !1;
    } else if (!dk(t.options.mutationKey, i))
      return !1;
  }
  return !(o && t.state.status !== o || r && !r(t));
}
function b6(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Ag)(e);
}
function Ag(e) {
  return JSON.stringify(
    e,
    (t, n) => BL(n) ? Object.keys(n).sort().reduce((o, r) => (o[r] = n[r], o), {}) : n
  );
}
function dk(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !dk(e[n], t[n])) : !1;
}
function y6(e, t) {
  if (e === t)
    return e;
  const n = ZB(e) && ZB(t);
  if (n || BL(e) && BL(t)) {
    const o = n ? e : Object.keys(e), r = o.length, i = n ? t : Object.keys(t), a = i.length, s = n ? [] : {};
    let c = 0;
    for (let l = 0; l < a; l++) {
      const u = n ? l : i[l];
      !n && e[u] === void 0 && t[u] === void 0 && o.includes(u) ? (s[u] = void 0, c++) : (s[u] = y6(e[u], t[u]), s[u] === e[u] && e[u] !== void 0 && c++);
    }
    return r === a && c === r ? e : s;
  }
  return t;
}
function yx(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function ZB(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function BL(e) {
  if (!XB(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!XB(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function XB(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function OSe(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function UL(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? y6(e, t) : t;
}
function NSe(e, t, n = 0) {
  const o = [...e, t];
  return n && o.length > n ? o.slice(1) : o;
}
function zSe(e, t, n = 0) {
  const o = [t, ...e];
  return n && o.length > n ? o.slice(0, -1) : o;
}
var Uh, og, ey, Boe, RSe = (Boe = class extends wv {
  constructor() {
    super();
    Fn(this, Uh, void 0);
    Fn(this, og, void 0);
    Fn(this, ey, void 0);
    En(this, ey, (t) => {
      if (!yy && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    lt(this, og) || this.setEventListener(lt(this, ey));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = lt(this, og)) == null || t.call(this), En(this, og, void 0));
  }
  setEventListener(t) {
    var n;
    En(this, ey, t), (n = lt(this, og)) == null || n.call(this), En(this, og, t((o) => {
      typeof o == "boolean" ? this.setFocused(o) : this.onFocus();
    }));
  }
  setFocused(t) {
    lt(this, Uh) !== t && (En(this, Uh, t), this.onFocus());
  }
  onFocus() {
    this.listeners.forEach((t) => {
      t();
    });
  }
  isFocused() {
    var t;
    return typeof lt(this, Uh) == "boolean" ? lt(this, Uh) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, Uh = new WeakMap(), og = new WeakMap(), ey = new WeakMap(), Boe), $x = new RSe(), ty, rg, ny, Uoe, PSe = (Uoe = class extends wv {
  constructor() {
    super();
    Fn(this, ty, !0);
    Fn(this, rg, void 0);
    Fn(this, ny, void 0);
    En(this, ny, (t) => {
      if (!yy && window.addEventListener) {
        const n = () => t(!0), o = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", o, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", o);
        };
      }
    });
  }
  onSubscribe() {
    lt(this, rg) || this.setEventListener(lt(this, ny));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = lt(this, rg)) == null || t.call(this), En(this, rg, void 0));
  }
  setEventListener(t) {
    var n;
    En(this, ny, t), (n = lt(this, rg)) == null || n.call(this), En(this, rg, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    lt(this, ty) !== t && (En(this, ty, t), this.listeners.forEach((o) => {
      o(t);
    }));
  }
  isOnline() {
    return lt(this, ty);
  }
}, ty = new WeakMap(), rg = new WeakMap(), ny = new WeakMap(), Uoe), wx = new PSe();
function DSe(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function vT(e) {
  return (e ?? "online") === "online" ? wx.isOnline() : !0;
}
var $re = class {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function _I(e) {
  return e instanceof $re;
}
function wre(e) {
  let t = !1, n = 0, o = !1, r, i, a;
  const s = new Promise((h, $) => {
    i = h, a = $;
  }), c = (h) => {
    var $;
    o || (p(new $re(h)), ($ = e.abort) == null || $.call(e));
  }, l = () => {
    t = !0;
  }, u = () => {
    t = !1;
  }, d = () => !$x.isFocused() || e.networkMode !== "always" && !wx.isOnline(), _ = (h) => {
    var $;
    o || (o = !0, ($ = e.onSuccess) == null || $.call(e, h), r == null || r(), i(h));
  }, p = (h) => {
    var $;
    o || (o = !0, ($ = e.onError) == null || $.call(e, h), r == null || r(), a(h));
  }, g = () => new Promise((h) => {
    var $;
    r = (v) => {
      const b = o || !d();
      return b && h(v), b;
    }, ($ = e.onPause) == null || $.call(e);
  }).then(() => {
    var h;
    r = void 0, o || (h = e.onContinue) == null || h.call(e);
  }), f = () => {
    if (o)
      return;
    let h;
    try {
      h = e.fn();
    } catch ($) {
      h = Promise.reject($);
    }
    Promise.resolve(h).then(_).catch(($) => {
      var N;
      if (o)
        return;
      const v = e.retry ?? (yy ? 0 : 3), b = e.retryDelay ?? DSe, y = typeof b == "function" ? b(n, $) : b, w = v === !0 || typeof v == "number" && n < v || typeof v == "function" && v(n, $);
      if (t || !w) {
        p($);
        return;
      }
      n++, (N = e.onFail) == null || N.call(e, n, $), OSe(y).then(() => {
        if (d())
          return g();
      }).then(() => {
        t ? p($) : f();
      });
    });
  };
  return vT(e.networkMode) ? f() : g().then(f), {
    promise: s,
    cancel: c,
    continue: () => (r == null ? void 0 : r()) ? s : Promise.resolve(),
    cancelRetry: l,
    continueRetry: u
  };
}
function LSe() {
  let e = [], t = 0, n = (_) => {
    _();
  }, o = (_) => {
    _();
  }, r = (_) => setTimeout(_, 0);
  const i = (_) => {
    r = _;
  }, a = (_) => {
    let p;
    t++;
    try {
      p = _();
    } finally {
      t--, t || l();
    }
    return p;
  }, s = (_) => {
    t ? e.push(_) : r(() => {
      n(_);
    });
  }, c = (_) => (...p) => {
    s(() => {
      _(...p);
    });
  }, l = () => {
    const _ = e;
    e = [], _.length && r(() => {
      o(() => {
        _.forEach((p) => {
          n(p);
        });
      });
    });
  };
  return {
    batch: a,
    batchCalls: c,
    schedule: s,
    setNotifyFunction: (_) => {
      n = _;
    },
    setBatchNotifyFunction: (_) => {
      o = _;
    },
    setScheduler: i
  };
}
var Pa = LSe(), Gh, Goe, kre = (Goe = class {
  constructor() {
    Fn(this, Gh, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), VL(this.gcTime) && En(this, Gh, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (yy ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    lt(this, Gh) && (clearTimeout(lt(this, Gh)), En(this, Gh, void 0));
  }
}, Gh = new WeakMap(), Goe), oy, ry, yd, ig, $d, qs, d0, Wh, iy, CE, E_, Ym, Woe, MSe = (Woe = class extends kre {
  constructor(n) {
    super();
    Fn(this, iy);
    Fn(this, E_);
    Fn(this, oy, void 0);
    Fn(this, ry, void 0);
    Fn(this, yd, void 0);
    Fn(this, ig, void 0);
    Fn(this, $d, void 0);
    Fn(this, qs, void 0);
    Fn(this, d0, void 0);
    Fn(this, Wh, void 0);
    En(this, Wh, !1), En(this, d0, n.defaultOptions), fo(this, iy, CE).call(this, n.options), En(this, qs, []), En(this, yd, n.cache), this.queryKey = n.queryKey, this.queryHash = n.queryHash, En(this, oy, n.state || FSe(this.options)), this.state = lt(this, oy), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  optionalRemove() {
    !lt(this, qs).length && this.state.fetchStatus === "idle" && lt(this, yd).remove(this);
  }
  setData(n, o) {
    const r = UL(this.state.data, n, this.options);
    return fo(this, E_, Ym).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: o == null ? void 0 : o.updatedAt,
      manual: o == null ? void 0 : o.manual
    }), r;
  }
  setState(n, o) {
    fo(this, E_, Ym).call(this, { type: "setState", state: n, setStateOptions: o });
  }
  cancel(n) {
    var r;
    const o = lt(this, ig);
    return (r = lt(this, $d)) == null || r.cancel(n), o ? o.then(kd).catch(kd) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(lt(this, oy));
  }
  isActive() {
    return lt(this, qs).some(
      (n) => n.options.enabled !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || lt(this, qs).some((n) => n.getCurrentResult().isStale);
  }
  isStaleByTime(n = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !yre(this.state.dataUpdatedAt, n);
  }
  onFocus() {
    var o;
    const n = lt(this, qs).find((r) => r.shouldFetchOnWindowFocus());
    n == null || n.refetch({ cancelRefetch: !1 }), (o = lt(this, $d)) == null || o.continue();
  }
  onOnline() {
    var o;
    const n = lt(this, qs).find((r) => r.shouldFetchOnReconnect());
    n == null || n.refetch({ cancelRefetch: !1 }), (o = lt(this, $d)) == null || o.continue();
  }
  addObserver(n) {
    lt(this, qs).includes(n) || (lt(this, qs).push(n), this.clearGcTimeout(), lt(this, yd).notify({ type: "observerAdded", query: this, observer: n }));
  }
  removeObserver(n) {
    lt(this, qs).includes(n) && (En(this, qs, lt(this, qs).filter((o) => o !== n)), lt(this, qs).length || (lt(this, $d) && (lt(this, Wh) ? lt(this, $d).cancel({ revert: !0 }) : lt(this, $d).cancelRetry()), this.scheduleGc()), lt(this, yd).notify({ type: "observerRemoved", query: this, observer: n }));
  }
  getObserversCount() {
    return lt(this, qs).length;
  }
  invalidate() {
    this.state.isInvalidated || fo(this, E_, Ym).call(this, { type: "invalidate" });
  }
  fetch(n, o) {
    var u, d, _, p;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && (o != null && o.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (lt(this, ig))
        return (u = lt(this, $d)) == null || u.continueRetry(), lt(this, ig);
    }
    if (n && fo(this, iy, CE).call(this, n), !this.options.queryFn) {
      const g = lt(this, qs).find((f) => f.options.queryFn);
      g && fo(this, iy, CE).call(this, g.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), i = {
      queryKey: this.queryKey,
      meta: this.meta
    }, a = (g) => {
      Object.defineProperty(g, "signal", {
        enumerable: !0,
        get: () => (En(this, Wh, !0), r.signal)
      });
    };
    a(i);
    const s = () => this.options.queryFn ? (En(this, Wh, !1), this.options.persister ? this.options.persister(
      this.options.queryFn,
      i,
      this
    ) : this.options.queryFn(
      i
    )) : Promise.reject(
      new Error(`Missing queryFn: '${this.options.queryHash}'`)
    ), c = {
      fetchOptions: o,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: s
    };
    a(c), (d = this.options.behavior) == null || d.onFetch(
      c,
      this
    ), En(this, ry, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_ = c.fetchOptions) == null ? void 0 : _.meta)) && fo(this, E_, Ym).call(this, { type: "fetch", meta: (p = c.fetchOptions) == null ? void 0 : p.meta });
    const l = (g) => {
      var f, h, $, v;
      _I(g) && g.silent || fo(this, E_, Ym).call(this, {
        type: "error",
        error: g
      }), _I(g) || ((h = (f = lt(this, yd).config).onError) == null || h.call(
        f,
        g,
        this
      ), (v = ($ = lt(this, yd).config).onSettled) == null || v.call(
        $,
        this.state.data,
        g,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return En(this, $d, wre({
      fn: c.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (g) => {
        var f, h, $, v;
        if (typeof g > "u") {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), l(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(g), (h = (f = lt(this, yd).config).onSuccess) == null || h.call(f, g, this), (v = ($ = lt(this, yd).config).onSettled) == null || v.call(
          $,
          g,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: l,
      onFail: (g, f) => {
        fo(this, E_, Ym).call(this, { type: "failed", failureCount: g, error: f });
      },
      onPause: () => {
        fo(this, E_, Ym).call(this, { type: "pause" });
      },
      onContinue: () => {
        fo(this, E_, Ym).call(this, { type: "continue" });
      },
      retry: c.options.retry,
      retryDelay: c.options.retryDelay,
      networkMode: c.options.networkMode
    })), En(this, ig, lt(this, $d).promise), lt(this, ig);
  }
}, oy = new WeakMap(), ry = new WeakMap(), yd = new WeakMap(), ig = new WeakMap(), $d = new WeakMap(), qs = new WeakMap(), d0 = new WeakMap(), Wh = new WeakMap(), iy = new WeakSet(), CE = function(n) {
  this.options = { ...lt(this, d0), ...n }, this.updateGcTime(this.options.gcTime);
}, E_ = new WeakSet(), Ym = function(n) {
  const o = (r) => {
    switch (n.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: n.failureCount,
          fetchFailureReason: n.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          fetchFailureCount: 0,
          fetchFailureReason: null,
          fetchMeta: n.meta ?? null,
          fetchStatus: vT(this.options.networkMode) ? "fetching" : "paused",
          ...!r.dataUpdatedAt && {
            error: null,
            status: "pending"
          }
        };
      case "success":
        return {
          ...r,
          data: n.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: n.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!n.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = n.error;
        return _I(i) && i.revert && lt(this, ry) ? { ...lt(this, ry), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...n.state
        };
    }
  };
  this.state = o(this.state), Pa.batch(() => {
    lt(this, qs).forEach((r) => {
      r.onQueryUpdate();
    }), lt(this, yd).notify({ query: this, type: "updated", action: n });
  });
}, Woe);
function FSe(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = typeof t < "u", o = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? o ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var xp, Hoe, qSe = (Hoe = class extends wv {
  constructor(t = {}) {
    super();
    Fn(this, xp, void 0);
    this.config = t, En(this, xp, /* @__PURE__ */ new Map());
  }
  build(t, n, o) {
    const r = n.queryKey, i = n.queryHash ?? b6(r, n);
    let a = this.get(i);
    return a || (a = new MSe({
      cache: this,
      queryKey: r,
      queryHash: i,
      options: t.defaultQueryOptions(n),
      state: o,
      defaultOptions: t.getQueryDefaults(r)
    }), this.add(a)), a;
  }
  add(t) {
    lt(this, xp).has(t.queryHash) || (lt(this, xp).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = lt(this, xp).get(t.queryHash);
    n && (t.destroy(), n === t && lt(this, xp).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    Pa.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return lt(this, xp).get(t);
  }
  getAll() {
    return [...lt(this, xp).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (o) => YB(n, o)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((o) => YB(t, o)) : n;
  }
  notify(t) {
    Pa.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    Pa.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    Pa.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, xp = new WeakMap(), Hoe), Cp, _0, Eu, ay, Tp, Hf, Yoe, jSe = (Yoe = class extends kre {
  constructor(t) {
    super();
    Fn(this, Tp);
    Fn(this, Cp, void 0);
    Fn(this, _0, void 0);
    Fn(this, Eu, void 0);
    Fn(this, ay, void 0);
    this.mutationId = t.mutationId, En(this, _0, t.defaultOptions), En(this, Eu, t.mutationCache), En(this, Cp, []), this.state = t.state || Sre(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = { ...lt(this, _0), ...t }, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    lt(this, Cp).includes(t) || (lt(this, Cp).push(t), this.clearGcTimeout(), lt(this, Eu).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    En(this, Cp, lt(this, Cp).filter((n) => n !== t)), this.scheduleGc(), lt(this, Eu).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    lt(this, Cp).length || (this.state.status === "pending" ? this.scheduleGc() : lt(this, Eu).remove(this));
  }
  continue() {
    var t;
    return ((t = lt(this, ay)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var r, i, a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w, N, M;
    const n = () => (En(this, ay, wre({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (q, L) => {
        fo(this, Tp, Hf).call(this, { type: "failed", failureCount: q, error: L });
      },
      onPause: () => {
        fo(this, Tp, Hf).call(this, { type: "pause" });
      },
      onContinue: () => {
        fo(this, Tp, Hf).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode
    })), lt(this, ay).promise), o = this.state.status === "pending";
    try {
      if (!o) {
        fo(this, Tp, Hf).call(this, { type: "pending", variables: t }), await ((i = (r = lt(this, Eu).config).onMutate) == null ? void 0 : i.call(
          r,
          t,
          this
        ));
        const L = await ((s = (a = this.options).onMutate) == null ? void 0 : s.call(a, t));
        L !== this.state.context && fo(this, Tp, Hf).call(this, {
          type: "pending",
          context: L,
          variables: t
        });
      }
      const q = await n();
      return await ((l = (c = lt(this, Eu).config).onSuccess) == null ? void 0 : l.call(
        c,
        q,
        t,
        this.state.context,
        this
      )), await ((d = (u = this.options).onSuccess) == null ? void 0 : d.call(u, q, t, this.state.context)), await ((p = (_ = lt(this, Eu).config).onSettled) == null ? void 0 : p.call(
        _,
        q,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((f = (g = this.options).onSettled) == null ? void 0 : f.call(g, q, null, t, this.state.context)), fo(this, Tp, Hf).call(this, { type: "success", data: q }), q;
    } catch (q) {
      try {
        throw await (($ = (h = lt(this, Eu).config).onError) == null ? void 0 : $.call(
          h,
          q,
          t,
          this.state.context,
          this
        )), await ((b = (v = this.options).onError) == null ? void 0 : b.call(
          v,
          q,
          t,
          this.state.context
        )), await ((w = (y = lt(this, Eu).config).onSettled) == null ? void 0 : w.call(
          y,
          void 0,
          q,
          this.state.variables,
          this.state.context,
          this
        )), await ((M = (N = this.options).onSettled) == null ? void 0 : M.call(
          N,
          void 0,
          q,
          t,
          this.state.context
        )), q;
      } finally {
        fo(this, Tp, Hf).call(this, { type: "error", error: q });
      }
    }
  }
}, Cp = new WeakMap(), _0 = new WeakMap(), Eu = new WeakMap(), ay = new WeakMap(), Tp = new WeakSet(), Hf = function(t) {
  const n = (o) => {
    switch (t.type) {
      case "failed":
        return {
          ...o,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...o,
          isPaused: !0
        };
      case "continue":
        return {
          ...o,
          isPaused: !1
        };
      case "pending":
        return {
          ...o,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: !vT(this.options.networkMode),
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...o,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...o,
          data: void 0,
          error: t.error,
          failureCount: o.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), Pa.batch(() => {
    lt(this, Cp).forEach((o) => {
      o.onMutationUpdate(t);
    }), lt(this, Eu).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, Yoe);
function Sre() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var wd, p0, Hh, Koe, VSe = (Koe = class extends wv {
  constructor(t = {}) {
    super();
    Fn(this, wd, void 0);
    Fn(this, p0, void 0);
    Fn(this, Hh, void 0);
    this.config = t, En(this, wd, []), En(this, p0, 0);
  }
  build(t, n, o) {
    const r = new jSe({
      mutationCache: this,
      mutationId: ++J1(this, p0)._,
      options: t.defaultMutationOptions(n),
      state: o
    });
    return this.add(r), r;
  }
  add(t) {
    lt(this, wd).push(t), this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    En(this, wd, lt(this, wd).filter((n) => n !== t)), this.notify({ type: "removed", mutation: t });
  }
  clear() {
    Pa.batch(() => {
      lt(this, wd).forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return lt(this, wd);
  }
  find(t) {
    const n = { exact: !0, ...t };
    return lt(this, wd).find(
      (o) => KB(n, o)
    );
  }
  findAll(t = {}) {
    return lt(this, wd).filter(
      (n) => KB(t, n)
    );
  }
  notify(t) {
    Pa.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    return En(this, Hh, (lt(this, Hh) ?? Promise.resolve()).then(() => {
      const t = lt(this, wd).filter((n) => n.state.isPaused);
      return Pa.batch(
        () => t.reduce(
          (n, o) => n.then(() => o.continue().catch(kd)),
          Promise.resolve()
        )
      );
    }).then(() => {
      En(this, Hh, void 0);
    })), lt(this, Hh);
  }
}, wd = new WeakMap(), p0 = new WeakMap(), Hh = new WeakMap(), Koe);
function GL(e) {
  return {
    onFetch: (t, n) => {
      const o = async () => {
        var g, f, h, $, v;
        const r = t.options, i = (h = (f = (g = t.fetchOptions) == null ? void 0 : g.meta) == null ? void 0 : f.fetchMore) == null ? void 0 : h.direction, a = (($ = t.state.data) == null ? void 0 : $.pages) || [], s = ((v = t.state.data) == null ? void 0 : v.pageParams) || [], c = { pages: [], pageParams: [] };
        let l = !1;
        const u = (b) => {
          Object.defineProperty(b, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? l = !0 : t.signal.addEventListener("abort", () => {
              l = !0;
            }), t.signal)
          });
        }, d = t.options.queryFn || (() => Promise.reject(
          new Error(`Missing queryFn: '${t.options.queryHash}'`)
        )), _ = async (b, y, w) => {
          if (l)
            return Promise.reject();
          if (y == null && b.pages.length)
            return Promise.resolve(b);
          const N = {
            queryKey: t.queryKey,
            pageParam: y,
            direction: w ? "backward" : "forward",
            meta: t.options.meta
          };
          u(N);
          const M = await d(
            N
          ), { maxPages: q } = t.options, L = w ? zSe : NSe;
          return {
            pages: L(b.pages, M, q),
            pageParams: L(b.pageParams, y, q)
          };
        };
        let p;
        if (i && a.length) {
          const b = i === "backward", y = b ? Ere : WL, w = {
            pages: a,
            pageParams: s
          }, N = y(r, w);
          p = await _(w, N, b);
        } else {
          p = await _(
            c,
            s[0] ?? r.initialPageParam
          );
          const b = e ?? a.length;
          for (let y = 1; y < b; y++) {
            const w = WL(r, p);
            p = await _(p, w);
          }
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var r, i;
        return (i = (r = t.options).persister) == null ? void 0 : i.call(
          r,
          o,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = o;
    }
  };
}
function WL(e, { pages: t, pageParams: n }) {
  const o = t.length - 1;
  return e.getNextPageParam(
    t[o],
    t,
    n[o],
    n
  );
}
function Ere(e, { pages: t, pageParams: n }) {
  var o;
  return (o = e.getPreviousPageParam) == null ? void 0 : o.call(
    e,
    t[0],
    t,
    n[0],
    n
  );
}
function BSe(e, t) {
  return t ? WL(e, t) != null : !1;
}
function USe(e, t) {
  return !t || !e.getPreviousPageParam ? !1 : Ere(e, t) != null;
}
var ys, ag, sg, sy, cy, cg, ly, uy, Zoe, xre = (Zoe = class {
  constructor(e = {}) {
    Fn(this, ys, void 0);
    Fn(this, ag, void 0);
    Fn(this, sg, void 0);
    Fn(this, sy, void 0);
    Fn(this, cy, void 0);
    Fn(this, cg, void 0);
    Fn(this, ly, void 0);
    Fn(this, uy, void 0);
    En(this, ys, e.queryCache || new qSe()), En(this, ag, e.mutationCache || new VSe()), En(this, sg, e.defaultOptions || {}), En(this, sy, /* @__PURE__ */ new Map()), En(this, cy, /* @__PURE__ */ new Map()), En(this, cg, 0);
  }
  mount() {
    J1(this, cg)._++, lt(this, cg) === 1 && (En(this, ly, $x.subscribe(() => {
      $x.isFocused() && (this.resumePausedMutations(), lt(this, ys).onFocus());
    })), En(this, uy, wx.subscribe(() => {
      wx.isOnline() && (this.resumePausedMutations(), lt(this, ys).onOnline());
    })));
  }
  unmount() {
    var e, t;
    J1(this, cg)._--, lt(this, cg) === 0 && ((e = lt(this, ly)) == null || e.call(this), En(this, ly, void 0), (t = lt(this, uy)) == null || t.call(this), En(this, uy, void 0));
  }
  isFetching(e) {
    return lt(this, ys).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return lt(this, ag).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var t;
    return (t = lt(this, ys).find({ queryKey: e })) == null ? void 0 : t.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    return t !== void 0 ? Promise.resolve(t) : this.fetchQuery(e);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({ queryKey: t, state: n }) => {
      const o = n.data;
      return [t, o];
    });
  }
  setQueryData(e, t, n) {
    const o = lt(this, ys).find({ queryKey: e }), r = o == null ? void 0 : o.state.data, i = ISe(t, r);
    if (typeof i > "u")
      return;
    const a = this.defaultQueryOptions({ queryKey: e });
    return lt(this, ys).build(this, a).setData(i, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return Pa.batch(
      () => this.getQueryCache().findAll(e).map(({ queryKey: o }) => [
        o,
        this.setQueryData(o, t, n)
      ])
    );
  }
  getQueryState(e) {
    var t;
    return (t = lt(this, ys).find({ queryKey: e })) == null ? void 0 : t.state;
  }
  removeQueries(e) {
    const t = lt(this, ys);
    Pa.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = lt(this, ys), o = {
      type: "active",
      ...e
    };
    return Pa.batch(() => (n.findAll(e).forEach((r) => {
      r.reset();
    }), this.refetchQueries(o, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, o = Pa.batch(
      () => lt(this, ys).findAll(e).map((r) => r.cancel(n))
    );
    return Promise.all(o).then(kd).catch(kd);
  }
  invalidateQueries(e = {}, t = {}) {
    return Pa.batch(() => {
      if (lt(this, ys).findAll(e).forEach((o) => {
        o.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, o = Pa.batch(
      () => lt(this, ys).findAll(e).filter((r) => !r.isDisabled()).map((r) => {
        let i = r.fetch(void 0, n);
        return n.throwOnError || (i = i.catch(kd)), r.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(o).then(kd);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    typeof t.retry > "u" && (t.retry = !1);
    const n = lt(this, ys).build(this, t);
    return n.isStaleByTime(t.staleTime) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(kd).catch(kd);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = GL(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(kd).catch(kd);
  }
  resumePausedMutations() {
    return lt(this, ag).resumePausedMutations();
  }
  getQueryCache() {
    return lt(this, ys);
  }
  getMutationCache() {
    return lt(this, ag);
  }
  getDefaultOptions() {
    return lt(this, sg);
  }
  setDefaultOptions(e) {
    En(this, sg, e);
  }
  setQueryDefaults(e, t) {
    lt(this, sy).set(Ag(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...lt(this, sy).values()];
    let n = {};
    return t.forEach((o) => {
      dk(e, o.queryKey) && (n = { ...n, ...o.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    lt(this, cy).set(Ag(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...lt(this, cy).values()];
    let n = {};
    return t.forEach((o) => {
      dk(e, o.mutationKey) && (n = { ...n, ...o.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const t = {
      ...lt(this, sg).queries,
      ...(e == null ? void 0 : e.queryKey) && this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = b6(
      t.queryKey,
      t
    )), typeof t.refetchOnReconnect > "u" && (t.refetchOnReconnect = t.networkMode !== "always"), typeof t.throwOnError > "u" && (t.throwOnError = !!t.suspense), typeof t.networkMode > "u" && t.persister && (t.networkMode = "offlineFirst"), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...lt(this, sg).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    lt(this, ys).clear(), lt(this, ag).clear();
  }
}, ys = new WeakMap(), ag = new WeakMap(), sg = new WeakMap(), sy = new WeakMap(), cy = new WeakMap(), cg = new WeakMap(), ly = new WeakMap(), uy = new WeakMap(), Zoe), Bl, la, m0, sl, Yh, dy, Ap, f0, _y, py, Kh, Zh, lg, my, Xh, Sw, g0, HL, h0, YL, v0, KL, b0, ZL, y0, XL, $0, JL, w0, QL, fT, Cre, Xoe, O0 = (Xoe = class extends wv {
  constructor(t, n) {
    super();
    Fn(this, Xh);
    Fn(this, g0);
    Fn(this, h0);
    Fn(this, v0);
    Fn(this, b0);
    Fn(this, y0);
    Fn(this, $0);
    Fn(this, w0);
    Fn(this, fT);
    Fn(this, Bl, void 0);
    Fn(this, la, void 0);
    Fn(this, m0, void 0);
    Fn(this, sl, void 0);
    Fn(this, Yh, void 0);
    Fn(this, dy, void 0);
    Fn(this, Ap, void 0);
    Fn(this, f0, void 0);
    Fn(this, _y, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    Fn(this, py, void 0);
    Fn(this, Kh, void 0);
    Fn(this, Zh, void 0);
    Fn(this, lg, void 0);
    Fn(this, my, /* @__PURE__ */ new Set());
    this.options = n, En(this, Bl, t), En(this, Ap, null), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (lt(this, la).addObserver(this), JB(lt(this, la), this.options) ? fo(this, Xh, Sw).call(this) : this.updateResult(), fo(this, b0, ZL).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return eM(
      lt(this, la),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return eM(
      lt(this, la),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), fo(this, y0, XL).call(this), fo(this, $0, JL).call(this), lt(this, la).removeObserver(this);
  }
  setOptions(t, n) {
    const o = this.options, r = lt(this, la);
    if (this.options = lt(this, Bl).defaultQueryOptions(t), yx(o, this.options) || lt(this, Bl).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: lt(this, la),
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = o.queryKey), fo(this, w0, QL).call(this);
    const i = this.hasListeners();
    i && QB(
      lt(this, la),
      r,
      this.options,
      o
    ) && fo(this, Xh, Sw).call(this), this.updateResult(n), i && (lt(this, la) !== r || this.options.enabled !== o.enabled || this.options.staleTime !== o.staleTime) && fo(this, g0, HL).call(this);
    const a = fo(this, h0, YL).call(this);
    i && (lt(this, la) !== r || this.options.enabled !== o.enabled || a !== lt(this, lg)) && fo(this, v0, KL).call(this, a);
  }
  getOptimisticResult(t) {
    const n = lt(this, Bl).getQueryCache().build(lt(this, Bl), t), o = this.createResult(n, t);
    return WSe(this, o) && (En(this, sl, o), En(this, dy, this.options), En(this, Yh, lt(this, la).state)), o;
  }
  getCurrentResult() {
    return lt(this, sl);
  }
  trackResult(t) {
    const n = {};
    return Object.keys(t).forEach((o) => {
      Object.defineProperty(n, o, {
        configurable: !1,
        enumerable: !0,
        get: () => (lt(this, my).add(o), t[o])
      });
    }), n;
  }
  getCurrentQuery() {
    return lt(this, la);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = lt(this, Bl).defaultQueryOptions(t), o = lt(this, Bl).getQueryCache().build(lt(this, Bl), n);
    return o.isFetchingOptimistic = !0, o.fetch().then(() => this.createResult(o, n));
  }
  fetch(t) {
    return fo(this, Xh, Sw).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), lt(this, sl)));
  }
  createResult(t, n) {
    var N;
    const o = lt(this, la), r = this.options, i = lt(this, sl), a = lt(this, Yh), s = lt(this, dy), l = t !== o ? t.state : lt(this, m0), { state: u } = t;
    let { error: d, errorUpdatedAt: _, fetchStatus: p, status: g } = u, f = !1, h;
    if (n._optimisticResults) {
      const M = this.hasListeners(), q = !M && JB(t, n), L = M && QB(t, o, n, r);
      (q || L) && (p = vT(t.options.networkMode) ? "fetching" : "paused", u.dataUpdatedAt || (g = "pending")), n._optimisticResults === "isRestoring" && (p = "idle");
    }
    if (n.select && typeof u.data < "u")
      if (i && u.data === (a == null ? void 0 : a.data) && n.select === lt(this, f0))
        h = lt(this, _y);
      else
        try {
          En(this, f0, n.select), h = n.select(u.data), h = UL(i == null ? void 0 : i.data, h, n), En(this, _y, h), En(this, Ap, null);
        } catch (M) {
          En(this, Ap, M);
        }
    else
      h = u.data;
    if (typeof n.placeholderData < "u" && typeof h > "u" && g === "pending") {
      let M;
      if (i != null && i.isPlaceholderData && n.placeholderData === (s == null ? void 0 : s.placeholderData))
        M = i.data;
      else if (M = typeof n.placeholderData == "function" ? n.placeholderData(
        (N = lt(this, py)) == null ? void 0 : N.state.data,
        lt(this, py)
      ) : n.placeholderData, n.select && typeof M < "u")
        try {
          M = n.select(M), En(this, Ap, null);
        } catch (q) {
          En(this, Ap, q);
        }
      typeof M < "u" && (g = "success", h = UL(
        i == null ? void 0 : i.data,
        M,
        n
      ), f = !0);
    }
    lt(this, Ap) && (d = lt(this, Ap), h = lt(this, _y), _ = Date.now(), g = "error");
    const $ = p === "fetching", v = g === "pending", b = g === "error", y = v && $;
    return {
      status: g,
      fetchStatus: p,
      isPending: v,
      isSuccess: g === "success",
      isError: b,
      isInitialLoading: y,
      isLoading: y,
      data: h,
      dataUpdatedAt: u.dataUpdatedAt,
      error: d,
      errorUpdatedAt: _,
      failureCount: u.fetchFailureCount,
      failureReason: u.fetchFailureReason,
      errorUpdateCount: u.errorUpdateCount,
      isFetched: u.dataUpdateCount > 0 || u.errorUpdateCount > 0,
      isFetchedAfterMount: u.dataUpdateCount > l.dataUpdateCount || u.errorUpdateCount > l.errorUpdateCount,
      isFetching: $,
      isRefetching: $ && !v,
      isLoadingError: b && u.dataUpdatedAt === 0,
      isPaused: p === "paused",
      isPlaceholderData: f,
      isRefetchError: b && u.dataUpdatedAt !== 0,
      isStale: $6(t, n),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const n = lt(this, sl), o = this.createResult(lt(this, la), this.options);
    if (En(this, Yh, lt(this, la).state), En(this, dy, this.options), lt(this, Yh).data !== void 0 && En(this, py, lt(this, la)), yx(o, n))
      return;
    En(this, sl, o);
    const r = {}, i = () => {
      if (!n)
        return !0;
      const { notifyOnChangeProps: a } = this.options, s = typeof a == "function" ? a() : a;
      if (s === "all" || !s && !lt(this, my).size)
        return !0;
      const c = new Set(
        s ?? lt(this, my)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(lt(this, sl)).some((l) => {
        const u = l;
        return lt(this, sl)[u] !== n[u] && c.has(u);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && i() && (r.listeners = !0), fo(this, fT, Cre).call(this, { ...r, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && fo(this, b0, ZL).call(this);
  }
}, Bl = new WeakMap(), la = new WeakMap(), m0 = new WeakMap(), sl = new WeakMap(), Yh = new WeakMap(), dy = new WeakMap(), Ap = new WeakMap(), f0 = new WeakMap(), _y = new WeakMap(), py = new WeakMap(), Kh = new WeakMap(), Zh = new WeakMap(), lg = new WeakMap(), my = new WeakMap(), Xh = new WeakSet(), Sw = function(t) {
  fo(this, w0, QL).call(this);
  let n = lt(this, la).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(kd)), n;
}, g0 = new WeakSet(), HL = function() {
  if (fo(this, y0, XL).call(this), yy || lt(this, sl).isStale || !VL(this.options.staleTime))
    return;
  const n = yre(
    lt(this, sl).dataUpdatedAt,
    this.options.staleTime
  ) + 1;
  En(this, Kh, setTimeout(() => {
    lt(this, sl).isStale || this.updateResult();
  }, n));
}, h0 = new WeakSet(), YL = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(lt(this, la)) : this.options.refetchInterval) ?? !1;
}, v0 = new WeakSet(), KL = function(t) {
  fo(this, $0, JL).call(this), En(this, lg, t), !(yy || this.options.enabled === !1 || !VL(lt(this, lg)) || lt(this, lg) === 0) && En(this, Zh, setInterval(() => {
    (this.options.refetchIntervalInBackground || $x.isFocused()) && fo(this, Xh, Sw).call(this);
  }, lt(this, lg)));
}, b0 = new WeakSet(), ZL = function() {
  fo(this, g0, HL).call(this), fo(this, v0, KL).call(this, fo(this, h0, YL).call(this));
}, y0 = new WeakSet(), XL = function() {
  lt(this, Kh) && (clearTimeout(lt(this, Kh)), En(this, Kh, void 0));
}, $0 = new WeakSet(), JL = function() {
  lt(this, Zh) && (clearInterval(lt(this, Zh)), En(this, Zh, void 0));
}, w0 = new WeakSet(), QL = function() {
  const t = lt(this, Bl).getQueryCache().build(lt(this, Bl), this.options);
  if (t === lt(this, la))
    return;
  const n = lt(this, la);
  En(this, la, t), En(this, m0, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, fT = new WeakSet(), Cre = function(t) {
  Pa.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(lt(this, sl));
    }), lt(this, Bl).getQueryCache().notify({
      query: lt(this, la),
      type: "observerResultsUpdated"
    });
  });
}, Xoe);
function GSe(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function JB(e, t) {
  return GSe(e, t) || e.state.dataUpdatedAt > 0 && eM(e, t, t.refetchOnMount);
}
function eM(e, t, n) {
  if (t.enabled !== !1) {
    const o = typeof n == "function" ? n(e) : n;
    return o === "always" || o !== !1 && $6(e, t);
  }
  return !1;
}
function QB(e, t, n, o) {
  return n.enabled !== !1 && (e !== t || o.enabled === !1) && (!n.suspense || e.state.status !== "error") && $6(e, n);
}
function $6(e, t) {
  return e.isStaleByTime(t.staleTime);
}
function WSe(e, t) {
  return !yx(e.getCurrentResult(), t);
}
function e9(e, t) {
  return e.filter((n) => !t.includes(n));
}
function HSe(e, t, n) {
  const o = e.slice(0);
  return o[t] = n, o;
}
var Jh, fy, gy, xu, k0, hy, vy, TE, S0, tM, E0, nM, x0, oM, C0, rM, Joe, YSe = (Joe = class extends wv {
  constructor(t, n, o) {
    super();
    Fn(this, vy);
    Fn(this, S0);
    Fn(this, E0);
    Fn(this, x0);
    Fn(this, C0);
    Fn(this, Jh, void 0);
    Fn(this, fy, void 0);
    Fn(this, gy, void 0);
    Fn(this, xu, void 0);
    Fn(this, k0, void 0);
    Fn(this, hy, void 0);
    En(this, Jh, t), En(this, gy, []), En(this, xu, []), fo(this, vy, TE).call(this, []), this.setQueries(n, o);
  }
  onSubscribe() {
    this.listeners.size === 1 && lt(this, xu).forEach((t) => {
      t.subscribe((n) => {
        fo(this, x0, oM).call(this, t, n);
      });
    });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), lt(this, xu).forEach((t) => {
      t.destroy();
    });
  }
  setQueries(t, n, o) {
    En(this, gy, t), En(this, k0, n), Pa.batch(() => {
      const r = lt(this, xu), i = fo(this, E0, nM).call(this, lt(this, gy));
      i.forEach(
        (l) => l.observer.setOptions(l.defaultedQueryOptions, o)
      );
      const a = i.map((l) => l.observer), s = a.map(
        (l) => l.getCurrentResult()
      ), c = a.some(
        (l, u) => l !== r[u]
      );
      r.length === a.length && !c || (En(this, xu, a), fo(this, vy, TE).call(this, s), this.hasListeners() && (e9(r, a).forEach((l) => {
        l.destroy();
      }), e9(a, r).forEach((l) => {
        l.subscribe((u) => {
          fo(this, x0, oM).call(this, l, u);
        });
      }), fo(this, C0, rM).call(this)));
    });
  }
  getCurrentResult() {
    return lt(this, hy);
  }
  getQueries() {
    return lt(this, xu).map((t) => t.getCurrentQuery());
  }
  getObservers() {
    return lt(this, xu);
  }
  getOptimisticResult(t, n) {
    const o = fo(this, E0, nM).call(this, t), r = o.map(
      (i) => i.observer.getOptimisticResult(i.defaultedQueryOptions)
    );
    return [
      r,
      (i) => fo(this, S0, tM).call(this, i ?? r, n),
      () => o.map((i, a) => {
        const s = r[a];
        return i.defaultedQueryOptions.notifyOnChangeProps ? s : i.observer.trackResult(s);
      })
    ];
  }
}, Jh = new WeakMap(), fy = new WeakMap(), gy = new WeakMap(), xu = new WeakMap(), k0 = new WeakMap(), hy = new WeakMap(), vy = new WeakSet(), TE = function(t) {
  var n;
  En(this, fy, t), En(this, hy, fo(this, S0, tM).call(this, t, (n = lt(this, k0)) == null ? void 0 : n.combine));
}, S0 = new WeakSet(), tM = function(t, n) {
  return n ? y6(lt(this, hy), n(t)) : t;
}, E0 = new WeakSet(), nM = function(t) {
  const n = lt(this, xu), o = new Map(
    n.map((d) => [d.options.queryHash, d])
  ), r = t.map(
    (d) => lt(this, Jh).defaultQueryOptions(d)
  ), i = r.flatMap((d) => {
    const _ = o.get(d.queryHash);
    return _ != null ? [{ defaultedQueryOptions: d, observer: _ }] : [];
  }), a = new Set(
    i.map((d) => d.defaultedQueryOptions.queryHash)
  ), s = r.filter(
    (d) => !a.has(d.queryHash)
  ), c = (d) => {
    const _ = lt(this, Jh).defaultQueryOptions(d);
    return lt(this, xu).find(
      (g) => g.options.queryHash === _.queryHash
    ) ?? new O0(lt(this, Jh), _);
  }, l = s.map((d) => ({
    defaultedQueryOptions: d,
    observer: c(d)
  })), u = (d, _) => r.indexOf(d.defaultedQueryOptions) - r.indexOf(_.defaultedQueryOptions);
  return i.concat(l).sort(u);
}, x0 = new WeakSet(), oM = function(t, n) {
  const o = lt(this, xu).indexOf(t);
  o !== -1 && (fo(this, vy, TE).call(this, HSe(lt(this, fy), o, n)), fo(this, C0, rM).call(this));
}, C0 = new WeakSet(), rM = function() {
  Pa.batch(() => {
    this.listeners.forEach((t) => {
      t(lt(this, fy));
    });
  });
}, Joe), Tre = class extends O0 {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(e, t) {
    super(e, t);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(e, t) {
    super.setOptions(
      {
        ...e,
        behavior: GL()
      },
      t
    );
  }
  getOptimisticResult(e) {
    return e.behavior = GL(), super.getOptimisticResult(e);
  }
  fetchNextPage(e) {
    return this.fetch({
      ...e,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(e) {
    return this.fetch({
      ...e,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(e, t) {
    var c, l, u, d;
    const { state: n } = e, o = super.createResult(e, t), { isFetching: r, isRefetching: i } = o, a = r && ((l = (c = n.fetchMeta) == null ? void 0 : c.fetchMore) == null ? void 0 : l.direction) === "forward", s = r && ((d = (u = n.fetchMeta) == null ? void 0 : u.fetchMore) == null ? void 0 : d.direction) === "backward";
    return {
      ...o,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: BSe(t, n.data),
      hasPreviousPage: USe(t, n.data),
      isFetchingNextPage: a,
      isFetchingPreviousPage: s,
      isRefetching: i && !a && !s
    };
  }
}, ug, Qm, Cu, ef, by, AE, T0, iM, Qoe, KSe = (Qoe = class extends wv {
  constructor(n, o) {
    super();
    Fn(this, by);
    Fn(this, T0);
    Fn(this, ug, void 0);
    Fn(this, Qm, void 0);
    Fn(this, Cu, void 0);
    Fn(this, ef, void 0);
    En(this, Qm, void 0), En(this, ug, n), this.setOptions(o), this.bindMethods(), fo(this, by, AE).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(n) {
    var r;
    const o = this.options;
    this.options = lt(this, ug).defaultMutationOptions(n), yx(o, this.options) || lt(this, ug).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: lt(this, Cu),
      observer: this
    }), (r = lt(this, Cu)) == null || r.setOptions(this.options), o != null && o.mutationKey && this.options.mutationKey && Ag(o.mutationKey) !== Ag(this.options.mutationKey) && this.reset();
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || (n = lt(this, Cu)) == null || n.removeObserver(this);
  }
  onMutationUpdate(n) {
    fo(this, by, AE).call(this), fo(this, T0, iM).call(this, n);
  }
  getCurrentResult() {
    return lt(this, Qm);
  }
  reset() {
    var n;
    (n = lt(this, Cu)) == null || n.removeObserver(this), En(this, Cu, void 0), fo(this, by, AE).call(this), fo(this, T0, iM).call(this);
  }
  mutate(n, o) {
    var r;
    return En(this, ef, o), (r = lt(this, Cu)) == null || r.removeObserver(this), En(this, Cu, lt(this, ug).getMutationCache().build(lt(this, ug), this.options)), lt(this, Cu).addObserver(this), lt(this, Cu).execute(n);
  }
}, ug = new WeakMap(), Qm = new WeakMap(), Cu = new WeakMap(), ef = new WeakMap(), by = new WeakSet(), AE = function() {
  var o;
  const n = ((o = lt(this, Cu)) == null ? void 0 : o.state) ?? Sre();
  En(this, Qm, {
    ...n,
    isPending: n.status === "pending",
    isSuccess: n.status === "success",
    isError: n.status === "error",
    isIdle: n.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, T0 = new WeakSet(), iM = function(n) {
  Pa.batch(() => {
    var o, r, i, a, s, c, l, u;
    if (lt(this, ef) && this.hasListeners()) {
      const d = lt(this, Qm).variables, _ = lt(this, Qm).context;
      (n == null ? void 0 : n.type) === "success" ? ((r = (o = lt(this, ef)).onSuccess) == null || r.call(o, n.data, d, _), (a = (i = lt(this, ef)).onSettled) == null || a.call(i, n.data, null, d, _)) : (n == null ? void 0 : n.type) === "error" && ((c = (s = lt(this, ef)).onError) == null || c.call(s, n.error, d, _), (u = (l = lt(this, ef)).onSettled) == null || u.call(
        l,
        void 0,
        n.error,
        d,
        _
      ));
    }
    this.listeners.forEach((d) => {
      d(lt(this, Qm));
    });
  });
}, Qoe);
function ZSe(e) {
  return {
    mutationKey: e.options.mutationKey,
    state: e.state,
    ...e.meta && { meta: e.meta }
  };
}
function XSe(e) {
  return {
    state: e.state,
    queryKey: e.queryKey,
    queryHash: e.queryHash,
    ...e.meta && { meta: e.meta }
  };
}
function JSe(e) {
  return e.state.isPaused;
}
function QSe(e) {
  return e.state.status === "success";
}
function eEe(e, t = {}) {
  const n = t.shouldDehydrateMutation ?? JSe, o = e.getMutationCache().getAll().flatMap(
    (a) => n(a) ? [ZSe(a)] : []
  ), r = t.shouldDehydrateQuery ?? QSe, i = e.getQueryCache().getAll().flatMap((a) => r(a) ? [XSe(a)] : []);
  return { mutations: o, queries: i };
}
function t9(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const o = e.getMutationCache(), r = e.getQueryCache(), i = t.mutations || [], a = t.queries || [];
  i.forEach((s) => {
    var c;
    o.build(
      e,
      {
        ...(c = n == null ? void 0 : n.defaultOptions) == null ? void 0 : c.mutations,
        mutationKey: s.mutationKey,
        meta: s.meta
      },
      s.state
    );
  }), a.forEach(({ queryKey: s, state: c, queryHash: l, meta: u }) => {
    var _;
    const d = r.get(l);
    if (d) {
      if (d.state.dataUpdatedAt < c.dataUpdatedAt) {
        const { fetchStatus: p, ...g } = c;
        d.setState(g);
      }
      return;
    }
    r.build(
      e,
      {
        ...(_ = n == null ? void 0 : n.defaultOptions) == null ? void 0 : _.queries,
        queryKey: s,
        queryHash: l,
        meta: u
      },
      // Reset fetch status to idle to avoid
      // query being stuck in fetching state upon hydration
      {
        ...c,
        fetchStatus: "idle"
      }
    );
  });
}
var Are = Ue.createContext(
  void 0
), qc = (e) => {
  const t = Ue.useContext(Are);
  if (e)
    return e;
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, Ire = ({
  client: e,
  children: t
}) => (Ue.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ Ue.createElement(Are.Provider, { value: e }, t)), Ore = Ue.createContext(!1), Nre = () => Ue.useContext(Ore);
Ore.Provider;
function tEe() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var nEe = Ue.createContext(tEe()), zre = () => Ue.useContext(nEe);
function Rre(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var Pre = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, Dre = (e) => {
  Ue.useEffect(() => {
    e.clearReset();
  }, [e]);
}, Lre = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: o
}) => e.isError && !t.isReset() && !e.isFetching && o && Rre(n, [e.error, o]), w6 = (e, t) => typeof t.state.data > "u", Mre = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, oEe = (e, t) => e.isLoading && e.isFetching && !t, aM = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, sM = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function Fre({
  queries: e,
  ...t
}, n) {
  const o = qc(n), r = Nre(), i = zre(), a = Ue.useMemo(
    () => e.map((g) => {
      const f = o.defaultQueryOptions(g);
      return f._optimisticResults = r ? "isRestoring" : "optimistic", f;
    }),
    [e, o, r]
  );
  a.forEach((g) => {
    Mre(g), Pre(g, i);
  }), Dre(i);
  const [s] = Ue.useState(
    () => new YSe(
      o,
      a,
      t
    )
  ), [c, l, u] = s.getOptimisticResult(
    a,
    t.combine
  );
  Ue.useSyncExternalStore(
    Ue.useCallback(
      (g) => r ? () => {
      } : s.subscribe(Pa.batchCalls(g)),
      [s, r]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), Ue.useEffect(() => {
    s.setQueries(
      a,
      t,
      {
        listeners: !1
      }
    );
  }, [a, t, s]);
  const _ = c.some(
    (g, f) => aM(a[f], g)
  ) ? c.flatMap((g, f) => {
    const h = a[f];
    if (h) {
      const $ = new O0(o, h);
      if (aM(h, g))
        return sM(h, $, i);
      oEe(g, r) && sM(h, $, i);
    }
    return [];
  }) : [];
  if (_.length > 0)
    throw Promise.all(_);
  const p = c.find(
    (g, f) => {
      const h = a[f];
      return h && Lre({
        result: g,
        errorResetBoundary: i,
        throwOnError: h.throwOnError,
        query: o.getQueryCache().get(h.queryHash)
      });
    }
  );
  if (p != null && p.error)
    throw p.error;
  return l(u());
}
function bT(e, t, n) {
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const o = qc(n), r = Nre(), i = zre(), a = o.defaultQueryOptions(e);
  a._optimisticResults = r ? "isRestoring" : "optimistic", Mre(a), Pre(a, i), Dre(i);
  const [s] = Ue.useState(
    () => new t(
      o,
      a
    )
  ), c = s.getOptimisticResult(a);
  if (Ue.useSyncExternalStore(
    Ue.useCallback(
      (l) => {
        const u = r ? () => {
        } : s.subscribe(Pa.batchCalls(l));
        return s.updateResult(), u;
      },
      [s, r]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), Ue.useEffect(() => {
    s.setOptions(a, { listeners: !1 });
  }, [a, s]), aM(a, c))
    throw sM(a, s, i);
  if (Lre({
    result: c,
    errorResetBoundary: i,
    throwOnError: a.throwOnError,
    query: o.getQueryCache().get(a.queryHash)
  }))
    throw c.error;
  return a.notifyOnChangeProps ? c : s.trackResult(c);
}
function mr(e, t) {
  return bT(e, O0, t);
}
function rEe(e, t) {
  return bT(
    {
      ...e,
      enabled: !0,
      suspense: !0,
      throwOnError: w6
    },
    O0,
    t
  );
}
function iEe(e, t) {
  return bT(
    {
      ...e,
      enabled: !0,
      suspense: !0,
      throwOnError: w6
    },
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Tre,
    t
  );
}
function aEe(e, t) {
  return Fre(
    {
      ...e,
      queries: e.queries.map((n) => ({
        ...n,
        suspense: !0,
        throwOnError: w6,
        enabled: !0
      }))
    },
    t
  );
}
var sEe = ({
  children: e,
  options: t = {},
  state: n,
  queryClient: o
}) => {
  const r = qc(o), [i, a] = Ue.useState(), s = Ue.useRef(t);
  return s.current = t, Ue.useMemo(() => {
    if (n) {
      if (typeof n != "object")
        return;
      const c = r.getQueryCache(), l = n.queries || [], u = [], d = [];
      for (const _ of l) {
        const p = c.get(_.queryHash);
        if (!p)
          u.push(_);
        else {
          const g = _.state.dataUpdatedAt > p.state.dataUpdatedAt, f = i == null ? void 0 : i.find(
            (h) => h.queryHash === _.queryHash
          );
          g && (!f || _.state.dataUpdatedAt > f.state.dataUpdatedAt) && d.push(_);
        }
      }
      u.length > 0 && t9(r, { queries: u }, s.current), d.length > 0 && a(
        (_) => _ ? [..._, ...d] : d
      );
    }
  }, [r, i, n]), Ue.useEffect(() => {
    i && (t9(r, { queries: i }, s.current), a(void 0));
  }, [r, i]), e;
};
function Hr(e, t) {
  const n = qc(t), [o] = Ue.useState(
    () => new KSe(
      n,
      e
    )
  );
  Ue.useEffect(() => {
    o.setOptions(e);
  }, [o, e]);
  const r = Ue.useSyncExternalStore(
    Ue.useCallback(
      (a) => o.subscribe(Pa.batchCalls(a)),
      [o]
    ),
    () => o.getCurrentResult(),
    () => o.getCurrentResult()
  ), i = Ue.useCallback(
    (a, s) => {
      o.mutate(a, s).catch(cEe);
    },
    [o]
  );
  if (r.error && Rre(o.options.throwOnError, [r.error]))
    throw r.error;
  return { ...r, mutate: i, mutateAsync: r.mutate };
}
function cEe() {
}
function lEe(e, t) {
  return bT(
    e,
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Tre,
    t
  );
}
const rs = {
  me: "me",
  availability: "schedules",
  eventTypes: "event-types",
  bookings: "bookings"
}, Nn = "success", Ig = "error", pI = "x-cal-client-id", n9 = "x-cal-platform-embed", k6 = "2024-06-14", uEe = "2024-06-11", qre = "2024-08-13", Fy = "cal-api-version", dEe = "google_calendar", _Ee = "google", pEe = "office365", IE = "google-meet", zb = "zoom", Rb = "msteams";
var Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function nu(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var r = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var S6 = { exports: {} }, jre = function(t, n) {
  return function() {
    for (var r = new Array(arguments.length), i = 0; i < r.length; i++)
      r[i] = arguments[i];
    return t.apply(n, r);
  };
}, mEe = jre, Fg = Object.prototype.toString;
function E6(e) {
  return Array.isArray(e);
}
function cM(e) {
  return typeof e > "u";
}
function fEe(e) {
  return e !== null && !cM(e) && e.constructor !== null && !cM(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function Vre(e) {
  return Fg.call(e) === "[object ArrayBuffer]";
}
function gEe(e) {
  return Fg.call(e) === "[object FormData]";
}
function hEe(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Vre(e.buffer), t;
}
function vEe(e) {
  return typeof e == "string";
}
function bEe(e) {
  return typeof e == "number";
}
function Bre(e) {
  return e !== null && typeof e == "object";
}
function OE(e) {
  if (Fg.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function yEe(e) {
  return Fg.call(e) === "[object Date]";
}
function $Ee(e) {
  return Fg.call(e) === "[object File]";
}
function wEe(e) {
  return Fg.call(e) === "[object Blob]";
}
function Ure(e) {
  return Fg.call(e) === "[object Function]";
}
function kEe(e) {
  return Bre(e) && Ure(e.pipe);
}
function SEe(e) {
  return Fg.call(e) === "[object URLSearchParams]";
}
function EEe(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function xEe() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function x6(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), E6(e))
      for (var n = 0, o = e.length; n < o; n++)
        t.call(null, e[n], n, e);
    else
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && t.call(null, e[r], r, e);
}
function lM() {
  var e = {};
  function t(r, i) {
    OE(e[i]) && OE(r) ? e[i] = lM(e[i], r) : OE(r) ? e[i] = lM({}, r) : E6(r) ? e[i] = r.slice() : e[i] = r;
  }
  for (var n = 0, o = arguments.length; n < o; n++)
    x6(arguments[n], t);
  return e;
}
function CEe(e, t, n) {
  return x6(t, function(r, i) {
    n && typeof r == "function" ? e[i] = mEe(r, n) : e[i] = r;
  }), e;
}
function TEe(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var ou = {
  isArray: E6,
  isArrayBuffer: Vre,
  isBuffer: fEe,
  isFormData: gEe,
  isArrayBufferView: hEe,
  isString: vEe,
  isNumber: bEe,
  isObject: Bre,
  isPlainObject: OE,
  isUndefined: cM,
  isDate: yEe,
  isFile: $Ee,
  isBlob: wEe,
  isFunction: Ure,
  isStream: kEe,
  isURLSearchParams: SEe,
  isStandardBrowserEnv: xEe,
  forEach: x6,
  merge: lM,
  extend: CEe,
  trim: EEe,
  stripBOM: TEe
}, eb = ou;
function o9(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Gre = function(t, n, o) {
  if (!n)
    return t;
  var r;
  if (o)
    r = o(n);
  else if (eb.isURLSearchParams(n))
    r = n.toString();
  else {
    var i = [];
    eb.forEach(n, function(c, l) {
      c === null || typeof c > "u" || (eb.isArray(c) ? l = l + "[]" : c = [c], eb.forEach(c, function(d) {
        eb.isDate(d) ? d = d.toISOString() : eb.isObject(d) && (d = JSON.stringify(d)), i.push(o9(l) + "=" + o9(d));
      }));
    }), r = i.join("&");
  }
  if (r) {
    var a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return t;
}, AEe = ou;
function yT() {
  this.handlers = [];
}
yT.prototype.use = function(t, n, o) {
  return this.handlers.push({
    fulfilled: t,
    rejected: n,
    synchronous: o ? o.synchronous : !1,
    runWhen: o ? o.runWhen : null
  }), this.handlers.length - 1;
};
yT.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
yT.prototype.forEach = function(t) {
  AEe.forEach(this.handlers, function(o) {
    o !== null && t(o);
  });
};
var IEe = yT, OEe = ou, NEe = function(t, n) {
  OEe.forEach(t, function(r, i) {
    i !== n && i.toUpperCase() === n.toUpperCase() && (t[n] = r, delete t[i]);
  });
}, Wre = function(t, n, o, r, i) {
  return t.config = n, o && (t.code = o), t.request = r, t.response = i, t.isAxiosError = !0, t.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, t;
}, Hre = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, mI, r9;
function Yre() {
  if (r9)
    return mI;
  r9 = 1;
  var e = Wre;
  return mI = function(n, o, r, i, a) {
    var s = new Error(n);
    return e(s, o, r, i, a);
  }, mI;
}
var fI, i9;
function zEe() {
  if (i9)
    return fI;
  i9 = 1;
  var e = Yre();
  return fI = function(n, o, r) {
    var i = r.config.validateStatus;
    !r.status || !i || i(r.status) ? n(r) : o(e(
      "Request failed with status code " + r.status,
      r.config,
      null,
      r.request,
      r
    ));
  }, fI;
}
var gI, a9;
function REe() {
  if (a9)
    return gI;
  a9 = 1;
  var e = ou;
  return gI = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(o, r, i, a, s, c) {
          var l = [];
          l.push(o + "=" + encodeURIComponent(r)), e.isNumber(i) && l.push("expires=" + new Date(i).toGMTString()), e.isString(a) && l.push("path=" + a), e.isString(s) && l.push("domain=" + s), c === !0 && l.push("secure"), document.cookie = l.join("; ");
        },
        read: function(o) {
          var r = document.cookie.match(new RegExp("(^|;\\s*)(" + o + ")=([^;]*)"));
          return r ? decodeURIComponent(r[3]) : null;
        },
        remove: function(o) {
          this.write(o, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), gI;
}
var hI, s9;
function PEe() {
  return s9 || (s9 = 1, hI = function(t) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  }), hI;
}
var vI, c9;
function DEe() {
  return c9 || (c9 = 1, vI = function(t, n) {
    return n ? t.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : t;
  }), vI;
}
var bI, l9;
function LEe() {
  if (l9)
    return bI;
  l9 = 1;
  var e = PEe(), t = DEe();
  return bI = function(o, r) {
    return o && !e(r) ? t(o, r) : r;
  }, bI;
}
var yI, u9;
function MEe() {
  if (u9)
    return yI;
  u9 = 1;
  var e = ou, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return yI = function(o) {
    var r = {}, i, a, s;
    return o && e.forEach(o.split(`
`), function(l) {
      if (s = l.indexOf(":"), i = e.trim(l.substr(0, s)).toLowerCase(), a = e.trim(l.substr(s + 1)), i) {
        if (r[i] && t.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? r[i] = (r[i] ? r[i] : []).concat([a]) : r[i] = r[i] ? r[i] + ", " + a : a;
      }
    }), r;
  }, yI;
}
var $I, d9;
function FEe() {
  if (d9)
    return $I;
  d9 = 1;
  var e = ou;
  return $I = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var n = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a"), r;
      function i(a) {
        var s = a;
        return n && (o.setAttribute("href", s), s = o.href), o.setAttribute("href", s), {
          href: o.href,
          protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
          host: o.host,
          search: o.search ? o.search.replace(/^\?/, "") : "",
          hash: o.hash ? o.hash.replace(/^#/, "") : "",
          hostname: o.hostname,
          port: o.port,
          pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
        };
      }
      return r = i(window.location.href), function(s) {
        var c = e.isString(s) ? i(s) : s;
        return c.protocol === r.protocol && c.host === r.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), $I;
}
var wI, _9;
function $T() {
  if (_9)
    return wI;
  _9 = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, wI = e, wI;
}
var kI, p9;
function m9() {
  if (p9)
    return kI;
  p9 = 1;
  var e = ou, t = zEe(), n = REe(), o = Gre, r = LEe(), i = MEe(), a = FEe(), s = Yre(), c = Hre, l = $T();
  return kI = function(d) {
    return new Promise(function(p, g) {
      var f = d.data, h = d.headers, $ = d.responseType, v;
      function b() {
        d.cancelToken && d.cancelToken.unsubscribe(v), d.signal && d.signal.removeEventListener("abort", v);
      }
      e.isFormData(f) && delete h["Content-Type"];
      var y = new XMLHttpRequest();
      if (d.auth) {
        var w = d.auth.username || "", N = d.auth.password ? unescape(encodeURIComponent(d.auth.password)) : "";
        h.Authorization = "Basic " + btoa(w + ":" + N);
      }
      var M = r(d.baseURL, d.url);
      y.open(d.method.toUpperCase(), o(M, d.params, d.paramsSerializer), !0), y.timeout = d.timeout;
      function q() {
        if (y) {
          var R = "getAllResponseHeaders" in y ? i(y.getAllResponseHeaders()) : null, T = !$ || $ === "text" || $ === "json" ? y.responseText : y.response, D = {
            data: T,
            status: y.status,
            statusText: y.statusText,
            headers: R,
            config: d,
            request: y
          };
          t(function(S) {
            p(S), b();
          }, function(S) {
            g(S), b();
          }, D), y = null;
        }
      }
      if ("onloadend" in y ? y.onloadend = q : y.onreadystatechange = function() {
        !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(q);
      }, y.onabort = function() {
        y && (g(s("Request aborted", d, "ECONNABORTED", y)), y = null);
      }, y.onerror = function() {
        g(s("Network Error", d, null, y)), y = null;
      }, y.ontimeout = function() {
        var T = d.timeout ? "timeout of " + d.timeout + "ms exceeded" : "timeout exceeded", D = d.transitional || c;
        d.timeoutErrorMessage && (T = d.timeoutErrorMessage), g(s(
          T,
          d,
          D.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          y
        )), y = null;
      }, e.isStandardBrowserEnv()) {
        var L = (d.withCredentials || a(M)) && d.xsrfCookieName ? n.read(d.xsrfCookieName) : void 0;
        L && (h[d.xsrfHeaderName] = L);
      }
      "setRequestHeader" in y && e.forEach(h, function(T, D) {
        typeof f > "u" && D.toLowerCase() === "content-type" ? delete h[D] : y.setRequestHeader(D, T);
      }), e.isUndefined(d.withCredentials) || (y.withCredentials = !!d.withCredentials), $ && $ !== "json" && (y.responseType = d.responseType), typeof d.onDownloadProgress == "function" && y.addEventListener("progress", d.onDownloadProgress), typeof d.onUploadProgress == "function" && y.upload && y.upload.addEventListener("progress", d.onUploadProgress), (d.cancelToken || d.signal) && (v = function(R) {
        y && (g(!R || R && R.type ? new l("canceled") : R), y.abort(), y = null);
      }, d.cancelToken && d.cancelToken.subscribe(v), d.signal && (d.signal.aborted ? v() : d.signal.addEventListener("abort", v))), f || (f = null), y.send(f);
    });
  }, kI;
}
var rc = ou, f9 = NEe, qEe = Wre, jEe = Hre, VEe = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function g9(e, t) {
  !rc.isUndefined(e) && rc.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function BEe() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = m9()), e;
}
function UEe(e, t, n) {
  if (rc.isString(e))
    try {
      return (t || JSON.parse)(e), rc.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
var wT = {
  transitional: jEe,
  adapter: BEe(),
  transformRequest: [function(t, n) {
    return f9(n, "Accept"), f9(n, "Content-Type"), rc.isFormData(t) || rc.isArrayBuffer(t) || rc.isBuffer(t) || rc.isStream(t) || rc.isFile(t) || rc.isBlob(t) ? t : rc.isArrayBufferView(t) ? t.buffer : rc.isURLSearchParams(t) ? (g9(n, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : rc.isObject(t) || n && n["Content-Type"] === "application/json" ? (g9(n, "application/json"), UEe(t)) : t;
  }],
  transformResponse: [function(t) {
    var n = this.transitional || wT.transitional, o = n && n.silentJSONParsing, r = n && n.forcedJSONParsing, i = !o && this.responseType === "json";
    if (i || r && rc.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (a) {
        if (i)
          throw a.name === "SyntaxError" ? qEe(a, this, "E_JSON_PARSE") : a;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
rc.forEach(["delete", "get", "head"], function(t) {
  wT.headers[t] = {};
});
rc.forEach(["post", "put", "patch"], function(t) {
  wT.headers[t] = rc.merge(VEe);
});
var C6 = wT, GEe = ou, WEe = C6, HEe = function(t, n, o) {
  var r = this || WEe;
  return GEe.forEach(o, function(a) {
    t = a.call(r, t, n);
  }), t;
}, SI, h9;
function Kre() {
  return h9 || (h9 = 1, SI = function(t) {
    return !!(t && t.__CANCEL__);
  }), SI;
}
var v9 = ou, EI = HEe, YEe = Kre(), KEe = C6, ZEe = $T();
function xI(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ZEe("canceled");
}
var XEe = function(t) {
  xI(t), t.headers = t.headers || {}, t.data = EI.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = v9.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), v9.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(r) {
      delete t.headers[r];
    }
  );
  var n = t.adapter || KEe.adapter;
  return n(t).then(function(r) {
    return xI(t), r.data = EI.call(
      t,
      r.data,
      r.headers,
      t.transformResponse
    ), r;
  }, function(r) {
    return YEe(r) || (xI(t), r && r.response && (r.response.data = EI.call(
      t,
      r.response.data,
      r.response.headers,
      t.transformResponse
    ))), Promise.reject(r);
  });
}, bu = ou, Zre = function(t, n) {
  n = n || {};
  var o = {};
  function r(u, d) {
    return bu.isPlainObject(u) && bu.isPlainObject(d) ? bu.merge(u, d) : bu.isPlainObject(d) ? bu.merge({}, d) : bu.isArray(d) ? d.slice() : d;
  }
  function i(u) {
    if (bu.isUndefined(n[u])) {
      if (!bu.isUndefined(t[u]))
        return r(void 0, t[u]);
    } else
      return r(t[u], n[u]);
  }
  function a(u) {
    if (!bu.isUndefined(n[u]))
      return r(void 0, n[u]);
  }
  function s(u) {
    if (bu.isUndefined(n[u])) {
      if (!bu.isUndefined(t[u]))
        return r(void 0, t[u]);
    } else
      return r(void 0, n[u]);
  }
  function c(u) {
    if (u in n)
      return r(t[u], n[u]);
    if (u in t)
      return r(void 0, t[u]);
  }
  var l = {
    url: a,
    method: a,
    data: a,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: c
  };
  return bu.forEach(Object.keys(t).concat(Object.keys(n)), function(d) {
    var _ = l[d] || i, p = _(d);
    bu.isUndefined(p) && _ !== c || (o[d] = p);
  }), o;
}, CI, b9;
function Xre() {
  return b9 || (b9 = 1, CI = {
    version: "0.26.1"
  }), CI;
}
var JEe = Xre().version, T6 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  T6[e] = function(o) {
    return typeof o === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var y9 = {};
T6.transitional = function(t, n, o) {
  function r(i, a) {
    return "[Axios v" + JEe + "] Transitional option '" + i + "'" + a + (o ? ". " + o : "");
  }
  return function(i, a, s) {
    if (t === !1)
      throw new Error(r(a, " has been removed" + (n ? " in " + n : "")));
    return n && !y9[a] && (y9[a] = !0, console.warn(
      r(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function QEe(e, t, n) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var o = Object.keys(e), r = o.length; r-- > 0; ) {
    var i = o[r], a = t[i];
    if (a) {
      var s = e[i], c = s === void 0 || a(s, i, e);
      if (c !== !0)
        throw new TypeError("option " + i + " must be " + c);
      continue;
    }
    if (n !== !0)
      throw Error("Unknown option " + i);
  }
}
var exe = {
  assertOptions: QEe,
  validators: T6
}, Jre = ou, txe = Gre, $9 = IEe, w9 = XEe, kT = Zre, Qre = exe, tb = Qre.validators;
function N0(e) {
  this.defaults = e, this.interceptors = {
    request: new $9(),
    response: new $9()
  };
}
N0.prototype.request = function(t, n) {
  typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = kT(this.defaults, n), n.method ? n.method = n.method.toLowerCase() : this.defaults.method ? n.method = this.defaults.method.toLowerCase() : n.method = "get";
  var o = n.transitional;
  o !== void 0 && Qre.assertOptions(o, {
    silentJSONParsing: tb.transitional(tb.boolean),
    forcedJSONParsing: tb.transitional(tb.boolean),
    clarifyTimeoutError: tb.transitional(tb.boolean)
  }, !1);
  var r = [], i = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(n) === !1 || (i = i && p.synchronous, r.unshift(p.fulfilled, p.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(p) {
    a.push(p.fulfilled, p.rejected);
  });
  var s;
  if (!i) {
    var c = [w9, void 0];
    for (Array.prototype.unshift.apply(c, r), c = c.concat(a), s = Promise.resolve(n); c.length; )
      s = s.then(c.shift(), c.shift());
    return s;
  }
  for (var l = n; r.length; ) {
    var u = r.shift(), d = r.shift();
    try {
      l = u(l);
    } catch (_) {
      d(_);
      break;
    }
  }
  try {
    s = w9(l);
  } catch (_) {
    return Promise.reject(_);
  }
  for (; a.length; )
    s = s.then(a.shift(), a.shift());
  return s;
};
N0.prototype.getUri = function(t) {
  return t = kT(this.defaults, t), txe(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
Jre.forEach(["delete", "get", "head", "options"], function(t) {
  N0.prototype[t] = function(n, o) {
    return this.request(kT(o || {}, {
      method: t,
      url: n,
      data: (o || {}).data
    }));
  };
});
Jre.forEach(["post", "put", "patch"], function(t) {
  N0.prototype[t] = function(n, o, r) {
    return this.request(kT(r || {}, {
      method: t,
      url: n,
      data: o
    }));
  };
});
var nxe = N0, TI, k9;
function oxe() {
  if (k9)
    return TI;
  k9 = 1;
  var e = $T();
  function t(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    var o;
    this.promise = new Promise(function(a) {
      o = a;
    });
    var r = this;
    this.promise.then(function(i) {
      if (r._listeners) {
        var a, s = r._listeners.length;
        for (a = 0; a < s; a++)
          r._listeners[a](i);
        r._listeners = null;
      }
    }), this.promise.then = function(i) {
      var a, s = new Promise(function(c) {
        r.subscribe(c), a = c;
      }).then(i);
      return s.cancel = function() {
        r.unsubscribe(a);
      }, s;
    }, n(function(a) {
      r.reason || (r.reason = new e(a), o(r.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.prototype.subscribe = function(o) {
    if (this.reason) {
      o(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(o) : this._listeners = [o];
  }, t.prototype.unsubscribe = function(o) {
    if (this._listeners) {
      var r = this._listeners.indexOf(o);
      r !== -1 && this._listeners.splice(r, 1);
    }
  }, t.source = function() {
    var o, r = new t(function(a) {
      o = a;
    });
    return {
      token: r,
      cancel: o
    };
  }, TI = t, TI;
}
var AI, S9;
function rxe() {
  return S9 || (S9 = 1, AI = function(t) {
    return function(o) {
      return t.apply(null, o);
    };
  }), AI;
}
var II, E9;
function ixe() {
  if (E9)
    return II;
  E9 = 1;
  var e = ou;
  return II = function(n) {
    return e.isObject(n) && n.isAxiosError === !0;
  }, II;
}
var x9 = ou, axe = jre, NE = nxe, sxe = Zre, cxe = C6;
function eie(e) {
  var t = new NE(e), n = axe(NE.prototype.request, t);
  return x9.extend(n, NE.prototype, t), x9.extend(n, t), n.create = function(r) {
    return eie(sxe(e, r));
  }, n;
}
var em = eie(cxe);
em.Axios = NE;
em.Cancel = $T();
em.CancelToken = oxe();
em.isCancel = Kre();
em.VERSION = Xre().version;
em.all = function(t) {
  return Promise.all(t);
};
em.spread = rxe();
em.isAxiosError = ixe();
S6.exports = em;
S6.exports.default = em;
var lxe = S6.exports, uxe = lxe;
const tie = /* @__PURE__ */ Mi(uxe), uM = function() {
  const e = tie.create({
    timeout: 1e4,
    headers: {}
  });
  let t = "";
  return {
    instance: e,
    get: e.get,
    post: e.post,
    put: e.put,
    patch: e.patch,
    delete: e.delete,
    responseInterceptor: e.interceptors.response,
    setRefreshUrl: (n) => {
      t = n;
    },
    getRefreshUrl: () => t,
    setUrl: (n) => {
      e.defaults.baseURL = n;
    },
    getUrl: () => e.defaults.baseURL,
    setAuthorizationHeader: (n) => {
      e.defaults.headers.common.Authorization = `Bearer ${n}`;
    },
    getAuthorizationHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n.Authorization) == null ? void 0 : o.toString()) ?? "";
    },
    setClientIdHeader: (n) => {
      e.defaults.headers.common[pI] = n;
    },
    getClientIdHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n[pI]) == null ? void 0 : o.toString()) ?? "";
    },
    setPlatformEmbedHeader: (n) => {
      e.defaults.headers.common[n9] = n.toString();
    },
    getPlatformEmbedHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n[n9]) == null ? void 0 : o.toString()) ?? "";
    },
    setVersionHeader: (n) => {
      e.defaults.headers.common[Fy] = n;
    },
    getVersionHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n[pI]) == null ? void 0 : o.toString()) ?? "";
    },
    refreshTokens: async (n) => {
      const r = await (await fetch(`${n}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: uM.getAuthorizationHeader()
        }
      })).json();
      return r.accessToken ? (uM.setAuthorizationHeader(r.accessToken), r.accessToken) : "";
    }
  };
}(), At = uM;
function Tt() {
  return Tt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Tt.apply(this, arguments);
}
const dxe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tt
}, Symbol.toStringTag, { value: "Module" }));
function jn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function _xe(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function A6(...e) {
  return (t) => e.forEach(
    (n) => _xe(n, t)
  );
}
function ni(...e) {
  return Yt(A6(...e), e);
}
function jc(e, t = []) {
  let n = [];
  function o(i, a) {
    const s = /* @__PURE__ */ Cr(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function l(d) {
      const { scope: _, children: p, ...g } = d, f = (_ == null ? void 0 : _[e][c]) || s, h = vn(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ pt(f.Provider, {
        value: h
      }, p);
    }
    function u(d, _) {
      const p = (_ == null ? void 0 : _[e][c]) || s, g = bo(p);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const r = () => {
    const i = n.map((a) => /* @__PURE__ */ Cr(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return vn(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return r.scopeName = e, [
    o,
    pxe(r, ...t)
  ];
}
function pxe(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map(
      (r) => ({
        useScope: r(),
        scopeName: r.scopeName
      })
    );
    return function(i) {
      const a = o.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return vn(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const av = /* @__PURE__ */ Bt((e, t) => {
  const { children: n, ...o } = e, r = hg.toArray(n), i = r.find(mxe);
  if (i) {
    const a = i.props.children, s = r.map((c) => c === i ? hg.count(a) > 1 ? hg.only(null) : /* @__PURE__ */ zd(a) ? a.props.children : null : c);
    return /* @__PURE__ */ pt(dM, Tt({}, o, {
      ref: t
    }), /* @__PURE__ */ zd(a) ? /* @__PURE__ */ gf(a, void 0, s) : null);
  }
  return /* @__PURE__ */ pt(dM, Tt({}, o, {
    ref: t
  }), n);
});
av.displayName = "Slot";
const dM = /* @__PURE__ */ Bt((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ zd(n) ? /* @__PURE__ */ gf(n, {
    ...fxe(o, n.props),
    ref: t ? A6(t, n.ref) : n.ref
  }) : hg.count(n) > 1 ? hg.only(null) : null;
});
dM.displayName = "SlotClone";
const nie = ({ children: e }) => /* @__PURE__ */ pt(Ha, null, e);
function mxe(e) {
  return /* @__PURE__ */ zd(e) && e.type === nie;
}
function fxe(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      i(...s), r(...s);
    } : r && (n[o] = r) : o === "style" ? n[o] = {
      ...r,
      ...i
    } : o === "className" && (n[o] = [
      r,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const gxe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], nr = gxe.reduce((e, t) => {
  const n = /* @__PURE__ */ Bt((o, r) => {
    const { asChild: i, ...a } = o, s = i ? av : t;
    return yt(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ pt(s, Tt({}, a, {
      ref: r
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function z0(e, t) {
  e && vre(
    () => e.dispatchEvent(t)
  );
}
function ws(e) {
  const t = xt(e);
  return yt(() => {
    t.current = e;
  }), vn(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function I6(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e);
  yt(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o), () => t.removeEventListener("keydown", o);
  }, [
    n,
    t
  ]);
}
const _M = "dismissableLayer.update", hxe = "dismissableLayer.pointerDownOutside", vxe = "dismissableLayer.focusOutside";
let C9;
const bxe = /* @__PURE__ */ Cr({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ST = /* @__PURE__ */ Bt((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, u = bo(bxe), [d, _] = it(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = it({}), f = ni(
    t,
    (q) => _(q)
  ), h = Array.from(u.layers), [$] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = h.indexOf($), b = d ? h.indexOf(d) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, w = b >= v, N = yxe((q) => {
    const L = q.target, R = [
      ...u.branches
    ].some(
      (T) => T.contains(L)
    );
    !w || R || (i == null || i(q), s == null || s(q), q.defaultPrevented || c == null || c());
  }, p), M = $xe((q) => {
    const L = q.target;
    [
      ...u.branches
    ].some(
      (T) => T.contains(L)
    ) || (a == null || a(q), s == null || s(q), q.defaultPrevented || c == null || c());
  }, p);
  return I6((q) => {
    b === u.layers.size - 1 && (r == null || r(q), !q.defaultPrevented && c && (q.preventDefault(), c()));
  }, p), yt(() => {
    if (d)
      return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (C9 = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), T9(), () => {
        o && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = C9);
      };
  }, [
    d,
    p,
    o,
    u
  ]), yt(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), T9());
  }, [
    d,
    u
  ]), yt(() => {
    const q = () => g({});
    return document.addEventListener(_M, q), () => document.removeEventListener(_M, q);
  }, []), /* @__PURE__ */ pt(nr.div, Tt({}, l, {
    ref: f,
    style: {
      pointerEvents: y ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: jn(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: jn(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: jn(e.onPointerDownCapture, N.onPointerDownCapture)
  }));
});
function yxe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e), o = xt(!1), r = xt(() => {
  });
  return yt(() => {
    const i = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          oie(hxe, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      }
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function $xe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e), o = xt(!1);
  return yt(() => {
    const r = (i) => {
      i.target && !o.current && oie(vxe, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function T9() {
  const e = new CustomEvent(_M);
  document.dispatchEvent(e);
}
function oie(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? z0(r, i) : r.dispatchEvent(i);
}
const wxe = globalThis != null && globalThis.document ? lc : () => {
}, kxe = Ue.useId || (() => {
});
let Sxe = 0;
function Pu(e) {
  const [t, n] = Ue.useState(kxe());
  return wxe(() => {
    e || n(
      (o) => o ?? String(Sxe++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function qy(e) {
  return e.split("-")[1];
}
function O6(e) {
  return e === "y" ? "height" : "width";
}
function sf(e) {
  return e.split("-")[0];
}
function kv(e) {
  return ["top", "bottom"].includes(sf(e)) ? "x" : "y";
}
function A9(e, t, n) {
  let { reference: o, floating: r } = e;
  const i = o.x + o.width / 2 - r.width / 2, a = o.y + o.height / 2 - r.height / 2, s = kv(t), c = O6(s), l = o[c] / 2 - r[c] / 2, u = s === "x";
  let d;
  switch (sf(t)) {
    case "top":
      d = { x: i, y: o.y - r.height };
      break;
    case "bottom":
      d = { x: i, y: o.y + o.height };
      break;
    case "right":
      d = { x: o.x + o.width, y: a };
      break;
    case "left":
      d = { x: o.x - r.width, y: a };
      break;
    default:
      d = { x: o.x, y: o.y };
  }
  switch (qy(t)) {
    case "start":
      d[s] -= l * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += l * (n && u ? -1 : 1);
  }
  return d;
}
const Exe = async (e, t, n) => {
  const { placement: o = "bottom", strategy: r = "absolute", middleware: i = [], platform: a } = n, s = i.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({ reference: e, floating: t, strategy: r }), { x: u, y: d } = A9(l, o, c), _ = o, p = {}, g = 0;
  for (let f = 0; f < s.length; f++) {
    const { name: h, fn: $ } = s[f], { x: v, y: b, data: y, reset: w } = await $({ x: u, y: d, initialPlacement: o, placement: _, strategy: r, middlewareData: p, rects: l, platform: a, elements: { reference: e, floating: t } });
    u = v ?? u, d = b ?? d, p = { ...p, [h]: { ...p[h], ...y } }, w && g <= 50 && (g++, typeof w == "object" && (w.placement && (_ = w.placement), w.rects && (l = w.rects === !0 ? await a.getElementRects({ reference: e, floating: t, strategy: r }) : w.rects), { x: u, y: d } = A9(l, _, c)), f = -1);
  }
  return { x: u, y: d, placement: _, strategy: r, middlewareData: p };
};
function hf(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function rie(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function kx(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function _k(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: o, y: r, platform: i, rects: a, elements: s, strategy: c } = e, { boundary: l = "clippingAncestors", rootBoundary: u = "viewport", elementContext: d = "floating", altBoundary: _ = !1, padding: p = 0 } = hf(t, e), g = rie(p), f = s[_ ? d === "floating" ? "reference" : "floating" : d], h = kx(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)), boundary: l, rootBoundary: u, strategy: c })), $ = d === "floating" ? { ...a.floating, x: o, y: r } : a.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), b = await (i.isElement == null ? void 0 : i.isElement(v)) && await (i.getScale == null ? void 0 : i.getScale(v)) || { x: 1, y: 1 }, y = kx(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: $, offsetParent: v, strategy: c }) : $);
  return { top: (h.top - y.top + g.top) / b.y, bottom: (y.bottom - h.bottom + g.bottom) / b.y, left: (h.left - y.left + g.left) / b.x, right: (y.right - h.right + g.right) / b.x };
}
const pk = Math.min, kh = Math.max;
function pM(e, t, n) {
  return kh(e, pk(t, n));
}
const I9 = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { x: n, y: o, placement: r, rects: i, platform: a, elements: s } = t, { element: c, padding: l = 0 } = hf(e, t) || {};
  if (c == null)
    return {};
  const u = rie(l), d = { x: n, y: o }, _ = kv(r), p = O6(_), g = await a.getDimensions(c), f = _ === "y", h = f ? "top" : "left", $ = f ? "bottom" : "right", v = f ? "clientHeight" : "clientWidth", b = i.reference[p] + i.reference[_] - d[_] - i.floating[p], y = d[_] - i.reference[_], w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
  let N = w ? w[v] : 0;
  N && await (a.isElement == null ? void 0 : a.isElement(w)) || (N = s.floating[v] || i.floating[p]);
  const M = b / 2 - y / 2, q = N / 2 - g[p] / 2 - 1, L = pk(u[h], q), R = pk(u[$], q), T = L, D = N - g[p] - R, A = N / 2 - g[p] / 2 + M, S = pM(T, A, D), E = qy(r) != null && A != S && i.reference[p] / 2 - (A < T ? L : R) - g[p] / 2 < 0;
  return { [_]: d[_] - (E ? A < T ? T - A : D - A : 0), data: { [_]: S, centerOffset: A - S } };
} }), iie = ["top", "right", "bottom", "left"];
iie.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
const xxe = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Sx(e) {
  return e.replace(/left|right|bottom|top/g, (t) => xxe[t]);
}
function Cxe(e, t, n) {
  n === void 0 && (n = !1);
  const o = qy(e), r = kv(e), i = O6(r);
  let a = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Sx(a)), { main: a, cross: Sx(a) };
}
const Txe = { start: "end", end: "start" };
function OI(e) {
  return e.replace(/start|end/g, (t) => Txe[t]);
}
const aie = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: o, middlewareData: r, rects: i, initialPlacement: a, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: _ = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: g = !0, ...f } = hf(e, t), h = sf(o), $ = sf(a) === a, v = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || ($ || !g ? [Sx(a)] : function(T) {
      const D = Sx(T);
      return [OI(T), D, OI(D)];
    }(a));
    d || p === "none" || b.push(...function(T, D, A, S) {
      const E = qy(T);
      let x = function(k, I, z) {
        const F = ["left", "right"], P = ["right", "left"], O = ["top", "bottom"], V = ["bottom", "top"];
        switch (k) {
          case "top":
          case "bottom":
            return z ? I ? P : F : I ? F : P;
          case "left":
          case "right":
            return I ? O : V;
          default:
            return [];
        }
      }(sf(T), A === "start", S);
      return E && (x = x.map((k) => k + "-" + E), D && (x = x.concat(x.map(OI)))), x;
    }(a, g, p, v));
    const y = [a, ...b], w = await _k(t, f), N = [];
    let M = ((n = r.flip) == null ? void 0 : n.overflows) || [];
    if (l && N.push(w[h]), u) {
      const { main: T, cross: D } = Cxe(o, i, v);
      N.push(w[T], w[D]);
    }
    if (M = [...M, { placement: o, overflows: N }], !N.every((T) => T <= 0)) {
      var q, L;
      const T = (((q = r.flip) == null ? void 0 : q.index) || 0) + 1, D = y[T];
      if (D)
        return { data: { index: T, overflows: M }, reset: { placement: D } };
      let A = (L = M.filter((S) => S.overflows[0] <= 0).sort((S, E) => S.overflows[1] - E.overflows[1])[0]) == null ? void 0 : L.placement;
      if (!A)
        switch (_) {
          case "bestFit": {
            var R;
            const S = (R = M.map((E) => [E.placement, E.overflows.filter((x) => x > 0).reduce((x, k) => x + k, 0)]).sort((E, x) => E[1] - x[1])[0]) == null ? void 0 : R[0];
            S && (A = S);
            break;
          }
          case "initialPlacement":
            A = a;
        }
      if (o !== A)
        return { reset: { placement: A } };
    }
    return {};
  } };
};
function O9(e, t) {
  return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
}
function N9(e) {
  return iie.some((t) => e[t] >= 0);
}
const sie = function(e) {
  return e === void 0 && (e = {}), { name: "hide", options: e, async fn(t) {
    const { rects: n } = t, { strategy: o = "referenceHidden", ...r } = hf(e, t);
    switch (o) {
      case "referenceHidden": {
        const i = O9(await _k(t, { ...r, elementContext: "reference" }), n.reference);
        return { data: { referenceHiddenOffsets: i, referenceHidden: N9(i) } };
      }
      case "escaped": {
        const i = O9(await _k(t, { ...r, altBoundary: !0 }), n.floating);
        return { data: { escapedOffsets: i, escaped: N9(i) } };
      }
      default:
        return {};
    }
  } };
}, cie = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: o } = t, r = await async function(i, a) {
      const { placement: s, platform: c, elements: l } = i, u = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), d = sf(s), _ = qy(s), p = kv(s) === "x", g = ["left", "top"].includes(d) ? -1 : 1, f = u && p ? -1 : 1, h = hf(a, i);
      let { mainAxis: $, crossAxis: v, alignmentAxis: b } = typeof h == "number" ? { mainAxis: h, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...h };
      return _ && typeof b == "number" && (v = _ === "end" ? -1 * b : b), p ? { x: v * f, y: $ * g } : { x: $ * g, y: v * f };
    }(t, e);
    return { x: n + r.x, y: o + r.y, data: r };
  } };
};
function lie(e) {
  return e === "x" ? "y" : "x";
}
const uie = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: o, placement: r } = t, { mainAxis: i = !0, crossAxis: a = !1, limiter: s = { fn: (h) => {
      let { x: $, y: v } = h;
      return { x: $, y: v };
    } }, ...c } = hf(e, t), l = { x: n, y: o }, u = await _k(t, c), d = kv(sf(r)), _ = lie(d);
    let p = l[d], g = l[_];
    if (i) {
      const h = d === "y" ? "bottom" : "right";
      p = pM(p + u[d === "y" ? "top" : "left"], p, p - u[h]);
    }
    if (a) {
      const h = _ === "y" ? "bottom" : "right";
      g = pM(g + u[_ === "y" ? "top" : "left"], g, g - u[h]);
    }
    const f = s.fn({ ...t, [d]: p, [_]: g });
    return { ...f, data: { x: f.x - n, y: f.y - o } };
  } };
}, die = function(e) {
  return e === void 0 && (e = {}), { options: e, fn(t) {
    const { x: n, y: o, placement: r, rects: i, middlewareData: a } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = hf(e, t), u = { x: n, y: o }, d = kv(r), _ = lie(d);
    let p = u[d], g = u[_];
    const f = hf(s, t), h = typeof f == "number" ? { mainAxis: f, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...f };
    if (c) {
      const b = d === "y" ? "height" : "width", y = i.reference[d] - i.floating[b] + h.mainAxis, w = i.reference[d] + i.reference[b] - h.mainAxis;
      p < y ? p = y : p > w && (p = w);
    }
    if (l) {
      var $, v;
      const b = d === "y" ? "width" : "height", y = ["top", "left"].includes(sf(r)), w = i.reference[_] - i.floating[b] + (y && (($ = a.offset) == null ? void 0 : $[_]) || 0) + (y ? 0 : h.crossAxis), N = i.reference[_] + i.reference[b] + (y ? 0 : ((v = a.offset) == null ? void 0 : v[_]) || 0) - (y ? h.crossAxis : 0);
      g < w ? g = w : g > N && (g = N);
    }
    return { [d]: p, [_]: g };
  } };
}, _ie = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: o, platform: r, elements: i } = t, { apply: a = () => {
    }, ...s } = hf(e, t), c = await _k(t, s), l = sf(n), u = qy(n), d = kv(n) === "x", { width: _, height: p } = o.floating;
    let g, f;
    l === "top" || l === "bottom" ? (g = l, f = u === (await (r.isRTL == null ? void 0 : r.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = l, g = u === "end" ? "top" : "bottom");
    const h = p - c[g], $ = _ - c[f], v = !t.middlewareData.shift;
    let b = h, y = $;
    if (d) {
      const N = _ - c.left - c.right;
      y = u || v ? pk($, N) : N;
    } else {
      const N = p - c.top - c.bottom;
      b = u || v ? pk(h, N) : N;
    }
    if (v && !u) {
      const N = kh(c.left, 0), M = kh(c.right, 0), q = kh(c.top, 0), L = kh(c.bottom, 0);
      d ? y = _ - 2 * (N !== 0 || M !== 0 ? N + M : kh(c.left, c.right)) : b = p - 2 * (q !== 0 || L !== 0 ? q + L : kh(c.top, c.bottom));
    }
    await a({ ...t, availableWidth: y, availableHeight: b });
    const w = await r.getDimensions(i.floating);
    return _ !== w.width || p !== w.height ? { reset: { rects: !0 } } : {};
  } };
};
function Rd(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function P_(e) {
  return Rd(e).getComputedStyle(e);
}
function pie(e) {
  return e instanceof Rd(e).Node;
}
function Og(e) {
  return pie(e) ? (e.nodeName || "").toLowerCase() : "";
}
function L_(e) {
  return e instanceof Rd(e).HTMLElement;
}
function Nu(e) {
  return e instanceof Rd(e).Element;
}
function z9(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof Rd(e).ShadowRoot || e instanceof ShadowRoot;
}
function mk(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = P_(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function Axe(e) {
  return ["table", "td", "th"].includes(Og(e));
}
function mM(e) {
  const t = N6(), n = P_(e);
  return n.transform !== "none" || n.perspective !== "none" || !t && !!n.backdropFilter && n.backdropFilter !== "none" || !t && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function N6() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function ET(e) {
  return ["html", "body", "#document"].includes(Og(e));
}
const R9 = Math.min, Fw = Math.max, Ex = Math.round;
function mie(e) {
  const t = P_(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = L_(e), i = r ? e.offsetWidth : n, a = r ? e.offsetHeight : o, s = Ex(n) !== i || Ex(o) !== a;
  return s && (n = i, o = a), { width: n, height: o, fallback: s };
}
function fie(e) {
  return Nu(e) ? e : e.contextElement;
}
const gie = { x: 1, y: 1 };
function Pb(e) {
  const t = fie(e);
  if (!L_(t))
    return gie;
  const n = t.getBoundingClientRect(), { width: o, height: r, fallback: i } = mie(t);
  let a = (i ? Ex(n.width) : n.width) / o, s = (i ? Ex(n.height) : n.height) / r;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
const P9 = { x: 0, y: 0 };
function hie(e, t, n) {
  var o, r;
  if (t === void 0 && (t = !0), !N6())
    return P9;
  const i = e ? Rd(e) : window;
  return !n || t && n !== i ? P9 : { x: ((o = i.visualViewport) == null ? void 0 : o.offsetLeft) || 0, y: ((r = i.visualViewport) == null ? void 0 : r.offsetTop) || 0 };
}
function sv(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = fie(e);
  let a = gie;
  t && (o ? Nu(o) && (a = Pb(o)) : a = Pb(e));
  const s = hie(i, n, o);
  let c = (r.left + s.x) / a.x, l = (r.top + s.y) / a.y, u = r.width / a.x, d = r.height / a.y;
  if (i) {
    const _ = Rd(i), p = o && Nu(o) ? Rd(o) : o;
    let g = _.frameElement;
    for (; g && o && p !== _; ) {
      const f = Pb(g), h = g.getBoundingClientRect(), $ = getComputedStyle(g);
      h.x += (g.clientLeft + parseFloat($.paddingLeft)) * f.x, h.y += (g.clientTop + parseFloat($.paddingTop)) * f.y, c *= f.x, l *= f.y, u *= f.x, d *= f.y, c += h.x, l += h.y, g = Rd(g).frameElement;
    }
  }
  return kx({ width: u, height: d, x: c, y: l });
}
function vg(e) {
  return ((pie(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function xT(e) {
  return Nu(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function vie(e) {
  return sv(vg(e)).left + xT(e).scrollLeft;
}
function $y(e) {
  if (Og(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || z9(e) && e.host || vg(e);
  return z9(t) ? t.host : t;
}
function bie(e) {
  const t = $y(e);
  return ET(t) ? t.ownerDocument.body : L_(t) && mk(t) ? t : bie(t);
}
function qw(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = bie(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Rd(o);
  return r ? t.concat(i, i.visualViewport || [], mk(o) ? o : []) : t.concat(o, qw(o));
}
function D9(e, t, n) {
  let o;
  if (t === "viewport")
    o = function(r, i) {
      const a = Rd(r), s = vg(r), c = a.visualViewport;
      let l = s.clientWidth, u = s.clientHeight, d = 0, _ = 0;
      if (c) {
        l = c.width, u = c.height;
        const p = N6();
        (!p || p && i === "fixed") && (d = c.offsetLeft, _ = c.offsetTop);
      }
      return { width: l, height: u, x: d, y: _ };
    }(e, n);
  else if (t === "document")
    o = function(r) {
      const i = vg(r), a = xT(r), s = r.ownerDocument.body, c = Fw(i.scrollWidth, i.clientWidth, s.scrollWidth, s.clientWidth), l = Fw(i.scrollHeight, i.clientHeight, s.scrollHeight, s.clientHeight);
      let u = -a.scrollLeft + vie(r);
      const d = -a.scrollTop;
      return P_(s).direction === "rtl" && (u += Fw(i.clientWidth, s.clientWidth) - c), { width: c, height: l, x: u, y: d };
    }(vg(e));
  else if (Nu(t))
    o = function(r, i) {
      const a = sv(r, !0, i === "fixed"), s = a.top + r.clientTop, c = a.left + r.clientLeft, l = L_(r) ? Pb(r) : { x: 1, y: 1 };
      return { width: r.clientWidth * l.x, height: r.clientHeight * l.y, x: c * l.x, y: s * l.y };
    }(t, n);
  else {
    const r = hie(e);
    o = { ...t, x: t.x - r.x, y: t.y - r.y };
  }
  return kx(o);
}
function yie(e, t) {
  const n = $y(e);
  return !(n === t || !Nu(n) || ET(n)) && (P_(n).position === "fixed" || yie(n, t));
}
function L9(e, t) {
  return L_(e) && P_(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function M9(e, t) {
  const n = Rd(e);
  if (!L_(e))
    return n;
  let o = L9(e, t);
  for (; o && Axe(o) && P_(o).position === "static"; )
    o = L9(o, t);
  return o && (Og(o) === "html" || Og(o) === "body" && P_(o).position === "static" && !mM(o)) ? n : o || function(r) {
    let i = $y(r);
    for (; L_(i) && !ET(i); ) {
      if (mM(i))
        return i;
      i = $y(i);
    }
    return null;
  }(e) || n;
}
function Ixe(e, t, n) {
  const o = L_(t), r = vg(t), i = n === "fixed", a = sv(e, !0, i, t);
  let s = { scrollLeft: 0, scrollTop: 0 };
  const c = { x: 0, y: 0 };
  if (o || !o && !i)
    if ((Og(t) !== "body" || mk(r)) && (s = xT(t)), L_(t)) {
      const l = sv(t, !0, i, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else
      r && (c.x = vie(r));
  return { x: a.left + s.scrollLeft - c.x, y: a.top + s.scrollTop - c.y, width: a.width, height: a.height };
}
const Oxe = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: o, strategy: r } = e;
  const i = n === "clippingAncestors" ? function(l, u) {
    const d = u.get(l);
    if (d)
      return d;
    let _ = qw(l).filter((h) => Nu(h) && Og(h) !== "body"), p = null;
    const g = P_(l).position === "fixed";
    let f = g ? $y(l) : l;
    for (; Nu(f) && !ET(f); ) {
      const h = P_(f), $ = mM(f);
      $ || h.position !== "fixed" || (p = null), (g ? !$ && !p : !$ && h.position === "static" && p && ["absolute", "fixed"].includes(p.position) || mk(f) && !$ && yie(l, f)) ? _ = _.filter((v) => v !== f) : p = h, f = $y(f);
    }
    return u.set(l, _), _;
  }(t, this._c) : [].concat(n), a = [...i, o], s = a[0], c = a.reduce((l, u) => {
    const d = D9(t, u, r);
    return l.top = Fw(d.top, l.top), l.right = R9(d.right, l.right), l.bottom = R9(d.bottom, l.bottom), l.left = Fw(d.left, l.left), l;
  }, D9(t, s, r));
  return { width: c.right - c.left, height: c.bottom - c.top, x: c.left, y: c.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: o } = e;
  const r = L_(n), i = vg(n);
  if (n === i)
    return t;
  let a = { scrollLeft: 0, scrollTop: 0 }, s = { x: 1, y: 1 };
  const c = { x: 0, y: 0 };
  if ((r || !r && o !== "fixed") && ((Og(n) !== "body" || mk(i)) && (a = xT(n)), L_(n))) {
    const l = sv(n);
    s = Pb(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return { width: t.width * s.x, height: t.height * s.y, x: t.x * s.x - a.scrollLeft * s.x + c.x, y: t.y * s.y - a.scrollTop * s.y + c.y };
}, isElement: Nu, getDimensions: function(e) {
  return mie(e);
}, getOffsetParent: M9, getDocumentElement: vg, getScale: Pb, async getElementRects(e) {
  let { reference: t, floating: n, strategy: o } = e;
  const r = this.getOffsetParent || M9, i = this.getDimensions;
  return { reference: Ixe(t, await r(n), o), floating: { x: 0, y: 0, ...await i(n) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => P_(e).direction === "rtl" };
function $ie(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: a = !0, animationFrame: s = !1 } = o, c = r || i ? [...Nu(e) ? qw(e) : e.contextElement ? qw(e.contextElement) : [], ...qw(t)] : [];
  c.forEach((_) => {
    const p = !Nu(_) && _.toString().includes("V");
    !r || s && !p || _.addEventListener("scroll", n, { passive: !0 }), i && _.addEventListener("resize", n);
  });
  let l, u = null;
  a && (u = new ResizeObserver(() => {
    n();
  }), Nu(e) && !s && u.observe(e), Nu(e) || !e.contextElement || s || u.observe(e.contextElement), u.observe(t));
  let d = s ? sv(e) : null;
  return s && function _() {
    const p = sv(e);
    !d || p.x === d.x && p.y === d.y && p.width === d.width && p.height === d.height || n(), d = p, l = requestAnimationFrame(_);
  }(), n(), () => {
    var _;
    c.forEach((p) => {
      r && p.removeEventListener("scroll", n), i && p.removeEventListener("resize", n);
    }), (_ = u) == null || _.disconnect(), u = null, s && cancelAnimationFrame(l);
  };
}
const Nxe = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = { platform: Oxe, ...n }, i = { ...r.platform, _c: o };
  return Exe(e, t, { ...r, platform: i });
}, wie = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? I9({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? I9({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
};
var zE = typeof document < "u" ? lc : yt;
function xx(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (o = n; o-- !== 0; )
        if (!xx(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && e.$$typeof) && !xx(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function kie(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function F9(e, t) {
  const n = kie(e);
  return Math.round(t * n) / n;
}
function q9(e) {
  const t = Ue.useRef(e);
  return zE(() => {
    t.current = e;
  }), t;
}
function Sie(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = Ue.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [_, p] = Ue.useState(o);
  xx(_, o) || p(o);
  const [g, f] = Ue.useState(null), [h, $] = Ue.useState(null), v = Ue.useCallback((x) => {
    x != N.current && (N.current = x, f(x));
  }, [f]), b = Ue.useCallback((x) => {
    x !== M.current && (M.current = x, $(x));
  }, [$]), y = i || g, w = a || h, N = Ue.useRef(null), M = Ue.useRef(null), q = Ue.useRef(u), L = q9(c), R = q9(r), T = Ue.useCallback(() => {
    if (!N.current || !M.current)
      return;
    const x = {
      placement: t,
      strategy: n,
      middleware: _
    };
    R.current && (x.platform = R.current), Nxe(N.current, M.current, x).then((k) => {
      const I = {
        ...k,
        isPositioned: !0
      };
      D.current && !xx(q.current, I) && (q.current = I, ASe.flushSync(() => {
        d(I);
      }));
    });
  }, [_, t, n, R]);
  zE(() => {
    l === !1 && q.current.isPositioned && (q.current.isPositioned = !1, d((x) => ({
      ...x,
      isPositioned: !1
    })));
  }, [l]);
  const D = Ue.useRef(!1);
  zE(() => (D.current = !0, () => {
    D.current = !1;
  }), []), zE(() => {
    if (y && (N.current = y), w && (M.current = w), y && w) {
      if (L.current)
        return L.current(y, w, T);
      T();
    }
  }, [y, w, T, L]);
  const A = Ue.useMemo(() => ({
    reference: N,
    floating: M,
    setReference: v,
    setFloating: b
  }), [v, b]), S = Ue.useMemo(() => ({
    reference: y,
    floating: w
  }), [y, w]), E = Ue.useMemo(() => {
    const x = {
      position: n,
      left: 0,
      top: 0
    };
    if (!S.floating)
      return x;
    const k = F9(S.floating, u.x), I = F9(S.floating, u.y);
    return s ? {
      ...x,
      transform: "translate(" + k + "px, " + I + "px)",
      ...kie(S.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: k,
      top: I
    };
  }, [n, s, S.floating, u.x, u.y]);
  return Ue.useMemo(() => ({
    ...u,
    update: T,
    refs: A,
    elements: S,
    floatingStyles: E
  }), [u, T, A, S, E]);
}
const j9 = globalThis != null && globalThis.document ? lc : () => {
}, zxe = globalThis != null && globalThis.document ? lc : () => {
};
function CT(e) {
  const [t, n] = it(void 0);
  return zxe(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return o.observe(e, {
        box: "border-box"
      }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Eie = "Popper", [xie, jy] = jc(Eie), [Rxe, Cie] = xie(Eie), Pxe = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = it(null);
  return /* @__PURE__ */ pt(Rxe, {
    scope: t,
    anchor: o,
    onAnchorChange: r
  }, n);
}, Dxe = "PopperAnchor", Lxe = /* @__PURE__ */ Bt((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = Cie(Dxe, n), a = xt(null), s = ni(t, a);
  return yt(() => {
    i.onAnchorChange((o == null ? void 0 : o.current) || a.current);
  }), o ? null : /* @__PURE__ */ pt(nr.div, Tt({}, r, {
    ref: s
  }));
}), Tie = "PopperContent", [Mxe, Kau] = xie(Tie), Fxe = /* @__PURE__ */ Bt((e, t) => {
  var n, o, r, i, a, s, c, l;
  const { __scopePopper: u, side: d = "bottom", sideOffset: _ = 0, align: p = "center", alignOffset: g = 0, arrowPadding: f = 0, collisionBoundary: h = [], collisionPadding: $ = 0, sticky: v = "partial", hideWhenDetached: b = !1, avoidCollisions: y = !0, onPlaced: w, ...N } = e, M = Cie(Tie, u), [q, L] = it(null), R = ni(
    t,
    (be) => L(be)
  ), [T, D] = it(null), A = CT(T), S = (n = A == null ? void 0 : A.width) !== null && n !== void 0 ? n : 0, E = (o = A == null ? void 0 : A.height) !== null && o !== void 0 ? o : 0, x = d + (p !== "center" ? "-" + p : ""), k = typeof $ == "number" ? $ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...$
  }, I = Array.isArray(h) ? h : [
    h
  ], z = I.length > 0, F = {
    padding: k,
    boundary: I.filter(qxe),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: z
  }, { refs: P, floatingStyles: O, placement: V, isPositioned: U, middlewareData: H } = Sie({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: x,
    whileElementsMounted: $ie,
    elements: {
      reference: M.anchor
    },
    middleware: [
      cie({
        mainAxis: _ + E,
        alignmentAxis: g
      }),
      y && uie({
        mainAxis: !0,
        crossAxis: !1,
        limiter: v === "partial" ? die() : void 0,
        ...F
      }),
      y && aie({
        ...F
      }),
      _ie({
        ...F,
        apply: ({ elements: be, rects: Q, availableWidth: me, availableHeight: ne }) => {
          const { width: pe, height: ge } = Q.reference, ve = be.floating.style;
          ve.setProperty("--radix-popper-available-width", `${me}px`), ve.setProperty("--radix-popper-available-height", `${ne}px`), ve.setProperty("--radix-popper-anchor-width", `${pe}px`), ve.setProperty("--radix-popper-anchor-height", `${ge}px`);
        }
      }),
      T && wie({
        element: T,
        padding: f
      }),
      jxe({
        arrowWidth: S,
        arrowHeight: E
      }),
      b && sie({
        strategy: "referenceHidden"
      })
    ]
  }), [J, le] = Aie(V), ae = ws(w);
  j9(() => {
    U && (ae == null || ae());
  }, [
    U,
    ae
  ]);
  const Y = (r = H.arrow) === null || r === void 0 ? void 0 : r.x, re = (i = H.arrow) === null || i === void 0 ? void 0 : i.y, ie = ((a = H.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [_e, he] = it();
  return j9(() => {
    q && he(window.getComputedStyle(q).zIndex);
  }, [
    q
  ]), /* @__PURE__ */ pt("div", {
    ref: P.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...O,
      transform: U ? O.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: _e,
      "--radix-popper-transform-origin": [
        (s = H.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = H.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ pt(Mxe, {
    scope: u,
    placedSide: J,
    onArrowChange: D,
    arrowX: Y,
    arrowY: re,
    shouldHideArrow: ie
  }, /* @__PURE__ */ pt(nr.div, Tt({
    "data-side": J,
    "data-align": le
  }, N, {
    ref: R,
    style: {
      ...N.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: U ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = H.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function qxe(e) {
  return e !== null;
}
const jxe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, o, r, i, a;
    const { placement: s, rects: c, middlewareData: l } = t, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, _ = d ? 0 : e.arrowWidth, p = d ? 0 : e.arrowHeight, [g, f] = Aie(s), h = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[f], $ = ((o = (r = l.arrow) === null || r === void 0 ? void 0 : r.x) !== null && o !== void 0 ? o : 0) + _ / 2, v = ((i = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let b = "", y = "";
    return g === "bottom" ? (b = d ? h : `${$}px`, y = `${-p}px`) : g === "top" ? (b = d ? h : `${$}px`, y = `${c.floating.height + p}px`) : g === "right" ? (b = `${-p}px`, y = d ? h : `${v}px`) : g === "left" && (b = `${c.floating.width + p}px`, y = d ? h : `${v}px`), {
      data: {
        x: b,
        y
      }
    };
  }
});
function Aie(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const z6 = Pxe, R6 = Lxe, P6 = Fxe, D6 = /* @__PURE__ */ Bt((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ $v.createPortal(/* @__PURE__ */ pt(nr.div, Tt({}, r, {
    ref: t
  })), o) : null;
}), V9 = globalThis != null && globalThis.document ? lc : () => {
};
function Vxe(e, t) {
  return A0((n, o) => {
    const r = t[n][o];
    return r ?? n;
  }, e);
}
const Vc = (e) => {
  const { present: t, children: n } = e, o = Bxe(t), r = typeof n == "function" ? n({
    present: o.isPresent
  }) : hg.only(n), i = ni(o.ref, r.ref);
  return typeof n == "function" || o.isPresent ? /* @__PURE__ */ gf(r, {
    ref: i
  }) : null;
};
Vc.displayName = "Presence";
function Bxe(e) {
  const [t, n] = it(), o = xt({}), r = xt(e), i = xt("none"), a = e ? "mounted" : "unmounted", [s, c] = Vxe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return yt(() => {
    const l = Q1(o.current);
    i.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), V9(() => {
    const l = o.current, u = r.current;
    if (u !== e) {
      const _ = i.current, p = Q1(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && _ !== p ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [
    e,
    c
  ]), V9(() => {
    if (t) {
      const l = (d) => {
        const p = Q1(o.current).includes(d.animationName);
        d.target === t && p && vre(
          () => c("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = Q1(o.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Yt((l) => {
      l && (o.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Q1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Uu({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, r] = Uxe({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : o, s = ws(n), c = Yt((l) => {
    if (i) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && s(d);
    } else
      r(l);
  }, [
    i,
    e,
    r,
    s
  ]);
  return [
    a,
    c
  ];
}
function Uxe({ defaultProp: e, onChange: t }) {
  const n = it(e), [o] = n, r = xt(o), i = ws(t);
  return yt(() => {
    r.current !== o && (i(o), r.current = o);
  }, [
    o,
    r,
    i
  ]), n;
}
const L6 = /* @__PURE__ */ Bt((e, t) => /* @__PURE__ */ pt(nr.span, Tt({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), Gxe = L6, [TT, Zau] = jc("Tooltip", [
  jy
]), M6 = jy(), Wxe = "TooltipProvider", Hxe = 700, fM = "tooltip.open", [Yxe, F6] = TT(Wxe), Iie = (e) => {
  const { __scopeTooltip: t, delayDuration: n = Hxe, skipDelayDuration: o = 300, disableHoverableContent: r = !1, children: i } = e, [a, s] = it(!0), c = xt(!1), l = xt(0);
  return yt(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ pt(Yxe, {
    scope: t,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: Yt(() => {
      window.clearTimeout(l.current), s(!1);
    }, []),
    onClose: Yt(() => {
      window.clearTimeout(l.current), l.current = window.setTimeout(
        () => s(!0),
        o
      );
    }, [
      o
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: Yt((u) => {
      c.current = u;
    }, []),
    disableHoverableContent: r
  }, i);
}, q6 = "Tooltip", [Kxe, AT] = TT(q6), Zxe = (e) => {
  const { __scopeTooltip: t, children: n, open: o, defaultOpen: r = !1, onOpenChange: i, disableHoverableContent: a, delayDuration: s } = e, c = F6(q6, e.__scopeTooltip), l = M6(t), [u, d] = it(null), _ = Pu(), p = xt(0), g = a ?? c.disableHoverableContent, f = s ?? c.delayDuration, h = xt(!1), [$ = !1, v] = Uu({
    prop: o,
    defaultProp: r,
    onChange: (M) => {
      M ? (c.onOpen(), document.dispatchEvent(new CustomEvent(fM))) : c.onClose(), i == null || i(M);
    }
  }), b = vn(() => $ ? h.current ? "delayed-open" : "instant-open" : "closed", [
    $
  ]), y = Yt(() => {
    window.clearTimeout(p.current), h.current = !1, v(!0);
  }, [
    v
  ]), w = Yt(() => {
    window.clearTimeout(p.current), v(!1);
  }, [
    v
  ]), N = Yt(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      h.current = !0, v(!0);
    }, f);
  }, [
    f,
    v
  ]);
  return yt(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ pt(z6, l, /* @__PURE__ */ pt(Kxe, {
    scope: t,
    contentId: _,
    open: $,
    stateAttribute: b,
    trigger: u,
    onTriggerChange: d,
    onTriggerEnter: Yt(() => {
      c.isOpenDelayed ? N() : y();
    }, [
      c.isOpenDelayed,
      N,
      y
    ]),
    onTriggerLeave: Yt(() => {
      g ? w() : window.clearTimeout(p.current);
    }, [
      w,
      g
    ]),
    onOpen: y,
    onClose: w,
    disableHoverableContent: g
  }, n));
}, B9 = "TooltipTrigger", Xxe = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeTooltip: n, ...o } = e, r = AT(B9, n), i = F6(B9, n), a = M6(n), s = xt(null), c = ni(t, s, r.onTriggerChange), l = xt(!1), u = xt(!1), d = Yt(
    () => l.current = !1,
    []
  );
  return yt(() => () => document.removeEventListener("pointerup", d), [
    d
  ]), /* @__PURE__ */ pt(R6, Tt({
    asChild: !0
  }, a), /* @__PURE__ */ pt(nr.button, Tt({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": r.open ? r.contentId : void 0,
    "data-state": r.stateAttribute
  }, o, {
    ref: c,
    onPointerMove: jn(e.onPointerMove, (_) => {
      _.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (r.onTriggerEnter(), u.current = !0);
    }),
    onPointerLeave: jn(e.onPointerLeave, () => {
      r.onTriggerLeave(), u.current = !1;
    }),
    onPointerDown: jn(e.onPointerDown, () => {
      l.current = !0, document.addEventListener("pointerup", d, {
        once: !0
      });
    }),
    onFocus: jn(e.onFocus, () => {
      l.current || r.onOpen();
    }),
    onBlur: jn(e.onBlur, r.onClose),
    onClick: jn(e.onClick, r.onClose)
  })));
}), Jxe = "TooltipPortal", [Xau, Qxe] = TT(Jxe, {
  forceMount: void 0
}), fk = "TooltipContent", eCe = /* @__PURE__ */ Bt((e, t) => {
  const n = Qxe(fk, e.__scopeTooltip), { forceMount: o = n.forceMount, side: r = "top", ...i } = e, a = AT(fk, e.__scopeTooltip);
  return /* @__PURE__ */ pt(Vc, {
    present: o || a.open
  }, a.disableHoverableContent ? /* @__PURE__ */ pt(Oie, Tt({
    side: r
  }, i, {
    ref: t
  })) : /* @__PURE__ */ pt(tCe, Tt({
    side: r
  }, i, {
    ref: t
  })));
}), tCe = /* @__PURE__ */ Bt((e, t) => {
  const n = AT(fk, e.__scopeTooltip), o = F6(fk, e.__scopeTooltip), r = xt(null), i = ni(t, r), [a, s] = it(null), { trigger: c, onClose: l } = n, u = r.current, { onPointerInTransitChange: d } = o, _ = Yt(() => {
    s(null), d(!1);
  }, [
    d
  ]), p = Yt((g, f) => {
    const h = g.currentTarget, $ = {
      x: g.clientX,
      y: g.clientY
    }, v = oCe($, h.getBoundingClientRect()), b = rCe($, v), y = iCe(f.getBoundingClientRect()), w = sCe([
      ...b,
      ...y
    ]);
    s(w), d(!0);
  }, [
    d
  ]);
  return yt(() => () => _(), [
    _
  ]), yt(() => {
    if (c && u) {
      const g = (h) => p(h, u), f = (h) => p(h, c);
      return c.addEventListener("pointerleave", g), u.addEventListener("pointerleave", f), () => {
        c.removeEventListener("pointerleave", g), u.removeEventListener("pointerleave", f);
      };
    }
  }, [
    c,
    u,
    p,
    _
  ]), yt(() => {
    if (a) {
      const g = (f) => {
        const h = f.target, $ = {
          x: f.clientX,
          y: f.clientY
        }, v = (c == null ? void 0 : c.contains(h)) || (u == null ? void 0 : u.contains(h)), b = !aCe($, a);
        v ? _() : b && (_(), l());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [
    c,
    u,
    a,
    l,
    _
  ]), /* @__PURE__ */ pt(Oie, Tt({}, e, {
    ref: i
  }));
}), [nCe, Jau] = TT(q6, {
  isInside: !1
}), Oie = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeTooltip: n, children: o, "aria-label": r, onEscapeKeyDown: i, onPointerDownOutside: a, ...s } = e, c = AT(fk, n), l = M6(n), { onClose: u } = c;
  return yt(() => (document.addEventListener(fM, u), () => document.removeEventListener(fM, u)), [
    u
  ]), yt(() => {
    if (c.trigger) {
      const d = (_) => {
        const p = _.target;
        p != null && p.contains(c.trigger) && u();
      };
      return window.addEventListener("scroll", d, {
        capture: !0
      }), () => window.removeEventListener("scroll", d, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    u
  ]), /* @__PURE__ */ pt(ST, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: a,
    onFocusOutside: (d) => d.preventDefault(),
    onDismiss: u
  }, /* @__PURE__ */ pt(P6, Tt({
    "data-state": c.stateAttribute
  }, l, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ pt(nie, null, o), /* @__PURE__ */ pt(nCe, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ pt(Gxe, {
    id: c.contentId,
    role: "tooltip"
  }, r || o))));
});
function oCe(e, t) {
  const n = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, o, r, i)) {
    case i:
      return "left";
    case r:
      return "right";
    case n:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function rCe(e, t, n = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      o.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      o.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      o.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return o;
}
function iCe(e) {
  const { top: t, right: n, bottom: o, left: r } = e;
  return [
    {
      x: r,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: o
    },
    {
      x: r,
      y: o
    }
  ];
}
function aCe(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, u = t[a].y;
    c > o != u > o && n < (l - s) * (o - c) / (u - c) + s && (r = !r);
  }
  return r;
}
function sCe(e) {
  const t = e.slice();
  return t.sort((n, o) => n.x < o.x ? -1 : n.x > o.x ? 1 : n.y < o.y ? -1 : n.y > o.y ? 1 : 0), cCe(t);
}
function cCe(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (r.y - a.y) >= (i.y - a.y) * (r.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(r);
  }
  t.pop();
  const n = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const r = e[o];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (r.y - a.y) >= (i.y - a.y) * (r.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(r);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const lCe = Iie, uCe = Zxe, dCe = Xxe, _Ce = eCe, pCe = ({ children: e }) => /* @__PURE__ */ m(nt, { children: e }), U9 = Iie, mCe = pCe, fCe = dCe, gCe = lCe, hCe = _Ce, vCe = uCe;
function bCe() {
  for (var e = 0, t, n, o = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Nie(t)) && (o && (o += " "), o += n);
  return o;
}
function Nie(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", o = 0; o < e.length; o++)
    e[o] && (t = Nie(e[o])) && (n && (n += " "), n += t);
  return n;
}
var j6 = "-";
function yCe(e) {
  var t = wCe(e), n = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, r = o === void 0 ? {} : o;
  function i(s) {
    var c = s.split(j6);
    return c[0] === "" && c.length !== 1 && c.shift(), zie(c, t) || $Ce(s);
  }
  function a(s, c) {
    var l = n[s] || [];
    return c && r[s] ? [].concat(l, r[s]) : l;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: a
  };
}
function zie(e, t) {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], o = t.nextPart.get(n), r = o ? zie(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length !== 0) {
    var i = e.join(j6);
    return (a = t.validators.find(function(s) {
      var c = s.validator;
      return c(i);
    })) == null ? void 0 : a.classGroupId;
  }
}
var G9 = /^\[(.+)\]$/;
function $Ce(e) {
  if (G9.test(e)) {
    var t = G9.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function wCe(e) {
  var t = e.theme, n = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, r = SCe(Object.entries(e.classGroups), n);
  return r.forEach(function(i) {
    var a = i[0], s = i[1];
    gM(s, o, a, t);
  }), o;
}
function gM(e, t, n, o) {
  e.forEach(function(r) {
    if (typeof r == "string") {
      var i = r === "" ? t : W9(t, r);
      i.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (kCe(r)) {
        gM(r(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(function(a) {
      var s = a[0], c = a[1];
      gM(c, W9(t, s), n, o);
    });
  });
}
function W9(e, t) {
  var n = e;
  return t.split(j6).forEach(function(o) {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}
function kCe(e) {
  return e.isThemeGetter;
}
function SCe(e, t) {
  return t ? e.map(function(n) {
    var o = n[0], r = n[1], i = r.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var c = s[0], l = s[1];
        return [t + c, l];
      })) : a;
    });
    return [o, i];
  }) : e;
}
function ECe(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function r(i, a) {
    n.set(i, a), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = o.get(a)) !== void 0)
        return r(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : r(a, s);
    }
  };
}
var Rie = "!";
function xCe(e) {
  var t = e.separator || ":", n = t.length === 1, o = t[0], r = t.length;
  return function(a) {
    for (var s = [], c = 0, l = 0, u, d = 0; d < a.length; d++) {
      var _ = a[d];
      if (c === 0) {
        if (_ === o && (n || a.slice(d, d + r) === t)) {
          s.push(a.slice(l, d)), l = d + r;
          continue;
        }
        if (_ === "/") {
          u = d;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    var p = s.length === 0 ? a : a.substring(l), g = p.startsWith(Rie), f = g ? p.substring(1) : p, h = u && u > l ? u - l : void 0;
    return {
      modifiers: s,
      hasImportantModifier: g,
      baseClassName: f,
      maybePostfixModifierPosition: h
    };
  };
}
function CCe(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(o) {
    var r = o[0] === "[";
    r ? (t.push.apply(t, n.sort().concat([o])), n = []) : n.push(o);
  }), t.push.apply(t, n.sort()), t;
}
function TCe(e) {
  return {
    cache: ECe(e.cacheSize),
    splitModifiers: xCe(e),
    ...yCe(e)
  };
}
var ACe = /\s+/;
function ICe(e, t) {
  var n = t.splitModifiers, o = t.getClassGroupId, r = t.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return e.trim().split(ACe).map(function(a) {
    var s = n(a), c = s.modifiers, l = s.hasImportantModifier, u = s.baseClassName, d = s.maybePostfixModifierPosition, _ = o(d ? u.substring(0, d) : u), p = !!d;
    if (!_) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (_ = o(u), !_)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var g = CCe(c).join(":"), f = l ? g + Rie : g;
    return {
      isTailwindClass: !0,
      modifierId: f,
      classGroupId: _,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, c = a.classGroupId, l = a.hasPostfixModifier, u = s + c;
    return i.has(u) ? !1 : (i.add(u), r(c, l).forEach(function(d) {
      return i.add(s + d);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function OCe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var o, r, i, a = s;
  function s(l) {
    var u = t[0], d = t.slice(1), _ = d.reduce(function(p, g) {
      return g(p);
    }, u());
    return o = TCe(_), r = o.cache.get, i = o.cache.set, a = c, c(l);
  }
  function c(l) {
    var u = r(l);
    if (u)
      return u;
    var d = ICe(l, o);
    return i(l, d), d;
  }
  return function() {
    return a(bCe.apply(null, arguments));
  };
}
function aa(e) {
  var t = function(o) {
    return o[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Pie = /^\[(?:([a-z-]+):)?(.+)\]$/i, NCe = /^\d+\/\d+$/, zCe = /* @__PURE__ */ new Set(["px", "full", "screen"]), RCe = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, PCe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, DCe = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function p_(e) {
  return Ph(e) || zCe.has(e) || NCe.test(e) || Yf(e);
}
function Yf(e) {
  return Sv(e, "length", VCe);
}
function LCe(e) {
  return Sv(e, "size", Die);
}
function MCe(e) {
  return Sv(e, "position", Die);
}
function FCe(e) {
  return Sv(e, "url", BCe);
}
function eS(e) {
  return Sv(e, "number", Ph);
}
function Ph(e) {
  return !Number.isNaN(Number(e));
}
function qCe(e) {
  return e.endsWith("%") && Ph(e.slice(0, -1));
}
function F$(e) {
  return H9(e) || Sv(e, "number", H9);
}
function Va(e) {
  return Pie.test(e);
}
function q$() {
  return !0;
}
function Uf(e) {
  return RCe.test(e);
}
function jCe(e) {
  return Sv(e, "", UCe);
}
function Sv(e, t, n) {
  var o = Pie.exec(e);
  return o ? o[1] ? o[1] === t : n(o[2]) : !1;
}
function VCe(e) {
  return PCe.test(e);
}
function Die() {
  return !1;
}
function BCe(e) {
  return e.startsWith("url(");
}
function H9(e) {
  return Number.isInteger(Number(e));
}
function UCe(e) {
  return DCe.test(e);
}
function GCe() {
  var e = aa("colors"), t = aa("spacing"), n = aa("blur"), o = aa("brightness"), r = aa("borderColor"), i = aa("borderRadius"), a = aa("borderSpacing"), s = aa("borderWidth"), c = aa("contrast"), l = aa("grayscale"), u = aa("hueRotate"), d = aa("invert"), _ = aa("gap"), p = aa("gradientColorStops"), g = aa("gradientColorStopPositions"), f = aa("inset"), h = aa("margin"), $ = aa("opacity"), v = aa("padding"), b = aa("saturate"), y = aa("scale"), w = aa("sepia"), N = aa("skew"), M = aa("space"), q = aa("translate"), L = function() {
    return ["auto", "contain", "none"];
  }, R = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, T = function() {
    return ["auto", t];
  }, D = function() {
    return ["", p_];
  }, A = function() {
    return ["auto", Ph, Va];
  }, S = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, E = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, x = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, k = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, I = function() {
    return ["", "0", Va];
  }, z = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, F = function() {
    return [Ph, eS];
  }, P = function() {
    return [Ph, Va];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [q$],
      spacing: [p_],
      blur: ["none", "", Uf, Yf],
      brightness: F(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Uf, Yf],
      borderSpacing: [t],
      borderWidth: D(),
      contrast: F(),
      grayscale: I(),
      hueRotate: P(),
      invert: I(),
      gap: [t],
      gradientColorStops: [e],
      gradientColorStopPositions: [qCe, Yf],
      inset: T(),
      margin: T(),
      opacity: F(),
      padding: [t],
      saturate: F(),
      scale: F(),
      sepia: I(),
      skew: P(),
      space: [t],
      translate: [t]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Va]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Uf]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": z()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": z()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(S(), [Va])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: R()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": R()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": R()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", F$]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: T()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Va]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: I()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: I()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", F$]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [q$]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [F$]
        }, Va]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": A()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": A()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [q$]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [F$]
        }, Va]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": A()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": A()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Va]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Va]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [_]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [_]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [_]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(k())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(k(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(k(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [M]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [M]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", p_]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Uf]
        }, Uf, Yf]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", p_]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Uf, Yf]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", eS]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [q$]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Yf]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ph, eS]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", p_]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Va]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Va]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [$]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [$]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(E(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", p_]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", p_]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [t]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Yf]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Va]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [$]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(S(), [MCe])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", LCe]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, FCe]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [$]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(E(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [$]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: E()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(E())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [p_]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [p_]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: D()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [$]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [p_]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Uf, jCe]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [q$]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [$]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": x()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": x()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Uf, Va]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [w]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [$]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [w]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Va]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: P()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Va]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: P()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Va]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [y]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [y]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [y]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [F$, Va]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [q]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [q]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Va]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Va]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [t]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [t]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [t]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [t]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [t]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [t]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [t]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [t]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [t]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [t]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [t]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [t]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [t]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [t]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [t]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [t]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [t]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [t]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Va]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [p_, eS]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Lie = /* @__PURE__ */ OCe(GCe);
function xe(...e) {
  return Lie(e.filter(Boolean).join(" "));
}
function qt({
  name: e,
  size: t = 16,
  className: n,
  ...o
}) {
  return /* @__PURE__ */ m(
    "svg",
    {
      height: t,
      width: t,
      className: xe("fill-transparent", n),
      ...o,
      "aria-hidden": !0,
      children: /* @__PURE__ */ m("use", { href: `#${e}` })
    }
  );
}
var WCe = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [o, r] = n.split(/ ?: ?/).map((i, a) => a === 0 ? i.replace(/\s+/g, "") : i.trim());
  if (o && r) {
    const i = o.replace(/(\w)-(\w)/g, (s, c, l) => `${c}${l.toUpperCase()}`);
    let a = r.trim();
    Number.isNaN(Number(r)) || (a = Number(r)), t[o.startsWith("-") ? o : i] = a;
  }
  return t;
}, {});
function HCe(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let o = e; o > 0; --o)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var YCe = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], Y9 = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function KCe(e, t) {
  var i;
  const { key: n, level: o, ...r } = t;
  switch (e.nodeType) {
    case 1:
      return Ue.createElement(
        XCe(e.nodeName),
        ZCe(e, n),
        K9(e.childNodes, o, r)
      );
    case 3: {
      const a = ((i = e.nodeValue) == null ? void 0 : i.toString()) ?? "";
      if (!r.allowWhiteSpaces && /^\s+$/.test(a) && !/[\u00A0\u202F]/.test(a))
        return null;
      if (!e.parentNode)
        return a;
      const s = e.parentNode.nodeName.toLowerCase();
      return YCe.includes(s) ? (/\S/.test(a) && console.warn(
        `A textNode is not allowed inside '${s}'. Your text "${a}" will be ignored`
      ), null) : a;
    }
    case 8:
      return null;
    case 11:
      return K9(e.childNodes, o, t);
    default:
      return null;
  }
}
function ZCe(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const o = e.getAttribute("class");
    o && (n.className = o), [...e.attributes].forEach((r) => {
      switch (r.name) {
        case "class":
          break;
        case "style":
          n[r.name] = WCe(r.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[Y9[r.name] || r.name] = !0;
          break;
        default:
          n[Y9[r.name] || r.name] = r.value;
      }
    });
  }
  return n;
}
function K9(e, t, n) {
  const o = [...e].map(
    (r, i) => Cx(r, {
      ...n,
      index: i,
      level: t + 1
    })
  ).filter(Boolean);
  return o.length ? o : null;
}
function XCe(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function Cx(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: o = 0, level: r = 0, randomKey: i } = t;
  let a = e, s = `${r}-${o}`;
  const c = [];
  return i && r === 0 && (s = `${HCe()}-${s}`), Array.isArray(n) && n.forEach((l) => {
    l.condition(a, s, r) && (typeof l.pre == "function" && (a = l.pre(a, s, r), a instanceof Node || (a = e, process.env.NODE_ENV !== "production" && console.warn(
      "The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)"
    ))), typeof l.post == "function" && c.push(l.post(a, s, r)));
  }), c.length ? c : KCe(a, { key: s, level: r, ...t });
}
function JCe(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: o = !1,
    selector: r = "body > *",
    type: i = "text/html"
  } = t;
  try {
    const s = new DOMParser().parseFromString(e, i);
    if (n) {
      const { childNodes: l } = s.body;
      return o ? l : [...l].map((u) => Cx(u, t));
    }
    const c = s.querySelector(r) || s.body.childNodes[0];
    if (!(c instanceof Node))
      throw new TypeError("Error parsing input");
    return o ? c : Cx(c, t);
  } catch (a) {
    process.env.NODE_ENV !== "production" && console.error(a);
  }
  return null;
}
function Mie(e, t = {}) {
  return typeof e == "string" ? JCe(e, t) : e instanceof Node ? Cx(e, t) : null;
}
var QCe = Object.defineProperty, eTe = (e, t, n) => t in e ? QCe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, tS = (e, t, n) => (eTe(e, typeof t != "symbol" ? t + "" : t, n), n), Z9 = "react-inlinesvg", X9 = 10, wi = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function RE() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function tTe() {
  return oTe() && typeof window < "u" && window !== null;
}
async function Fie(e, t) {
  const n = await fetch(e, t), o = n.headers.get("content-type"), [r] = (o ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((i) => r.includes(i)))
    throw new Error(`Content type isn't valid: ${r}`);
  return n.text();
}
function nTe(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function oTe() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
function rTe(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function iTe(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", n = "1234567890", o = `${t}${t.toUpperCase()}${n}`;
  let r = "";
  for (let i = 0; i < e; i++)
    r += rTe(o);
  return r;
}
function aTe(e, ...t) {
  const n = {};
  for (const o in e)
    ({}).hasOwnProperty.call(e, o) && (t.includes(o) || (n[o] = e[o]));
  return n;
}
var sTe = class {
  constructor() {
    tS(this, "cacheApi"), tS(this, "cacheStore"), tS(this, "subscribers", []), tS(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = Z9, t = !1;
    RE() && (e = window.REACT_INLINESVG_CACHE_NAME ?? Z9, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n, this.isReady = !0, this.subscribers.forEach((o) => o());
    }).catch((n) => {
      this.isReady = !0, console.error(`Failed to open cache: ${n.message}`);
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === wi.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === wi.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: wi.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: wi.LOADING });
      try {
        const o = await Fie(e, t);
        this.cacheStore.set(e, { content: o, status: wi.LOADED });
      } catch (o) {
        throw this.cacheStore.set(e, { content: "", status: wi.FAILED }), o;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var r, i, a;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === wi.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === wi.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: wi.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: wi.LOADING });
    const o = await ((r = this.cacheApi) == null ? void 0 : r.match(e));
    if (o) {
      const s = await o.text();
      this.cacheStore.set(e, { content: s, status: wi.LOADED });
      return;
    }
    try {
      await ((i = this.cacheApi) == null ? void 0 : i.add(new Request(e, t)));
      const s = await ((a = this.cacheApi) == null ? void 0 : a.match(e)), c = await (s == null ? void 0 : s.text()) ?? "";
      this.cacheStore.set(e, { content: c, status: wi.LOADED });
    } catch (s) {
      throw this.cacheStore.set(e, { content: "", status: wi.FAILED }), s;
    }
  }
  async handleLoading(e, t) {
    var o;
    let n = 0;
    for (; ((o = this.cacheStore.get(e)) == null ? void 0 : o.status) === wi.LOADING && n < X9; )
      await nTe(0.1), n += 1;
    n >= X9 && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function J9(e) {
  const t = xt();
  return yt(() => {
    t.current = e;
  }), t.current;
}
function cTe(e) {
  const {
    baseURL: t,
    content: n,
    description: o,
    handleError: r,
    hash: i,
    preProcessor: a,
    title: s,
    uniquifyIDs: c = !1
  } = e;
  try {
    const l = lTe(n, a), u = Mie(l, { nodeOnly: !0 });
    if (!u || !(u instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const d = qie(u, { baseURL: t, hash: i, uniquifyIDs: c });
    if (o) {
      const _ = d.querySelector("desc");
      _ != null && _.parentNode && _.parentNode.removeChild(_);
      const p = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      p.innerHTML = o, d.prepend(p);
    }
    if (typeof s < "u") {
      const _ = d.querySelector("title");
      if (_ != null && _.parentNode && _.parentNode.removeChild(_), s) {
        const p = document.createElementNS("http://www.w3.org/2000/svg", "title");
        p.innerHTML = s, d.prepend(p);
      }
    }
    return d;
  } catch (l) {
    return r(l);
  }
}
function lTe(e, t) {
  return t ? t(e) : e;
}
function qie(e, t) {
  const { baseURL: n = "", hash: o, uniquifyIDs: r } = t, i = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], a = ["href", "xlink:href"], s = (c, l) => a.includes(c) && (l ? !l.includes("#") : !1);
  return r && [...e.children].forEach((c) => {
    var l;
    if ((l = c.attributes) != null && l.length) {
      const u = Object.values(c.attributes).map((d) => {
        const _ = d, p = /url\((.*?)\)/.exec(d.value);
        return p != null && p[1] && (_.value = d.value.replace(p[0], `url(${n}${p[1]}__${o})`)), _;
      });
      i.forEach((d) => {
        const _ = u.find((p) => p.name === d);
        _ && !s(d, _.value) && (_.value = `${_.value}__${o}`);
      });
    }
    return c.children.length ? qie(c, t) : c;
  }), e;
}
var Sb;
function uTe(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: o,
    fetchOptions: r,
    innerRef: i,
    loader: a = null,
    onError: s,
    onLoad: c,
    src: l,
    title: u,
    uniqueHash: d
  } = e, [_, p] = A0(
    (S, E) => ({
      ...S,
      ...E
    }),
    {
      content: "",
      element: null,
      isCached: t && Sb.isCached(e.src),
      status: wi.IDLE
    }
  ), { content: g, element: f, isCached: h, status: $ } = _, v = J9(e), b = J9(_), y = xt(d ?? iTe(8)), w = xt(!1), N = xt(!1), M = Yt(
    (S) => {
      w.current && (p({
        status: S.message === "Browser does not support SVG" ? wi.UNSUPPORTED : wi.FAILED
      }), s == null || s(S));
    },
    [s]
  ), q = Yt((S, E = !1) => {
    w.current && p({
      content: S,
      isCached: E,
      status: wi.LOADED
    });
  }, []), L = Yt(async () => {
    const S = await Fie(l, r);
    q(S);
  }, [r, q, l]), R = Yt(() => {
    try {
      const S = cTe({ ...e, handleError: M, hash: y.current, content: g }), E = Mie(S);
      if (!E || !zd(E))
        throw new Error("Could not convert the src to a React element");
      p({
        element: E,
        status: wi.READY
      });
    } catch (S) {
      M(new Error(S.message));
    }
  }, [g, M, e]), T = Yt(async () => {
    const S = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(l);
    let E;
    if (S ? E = S[1] ? window.atob(S[2]) : decodeURIComponent(S[2]) : l.includes("<svg") && (E = l), E) {
      q(E);
      return;
    }
    try {
      if (t) {
        const x = await Sb.get(l, r);
        q(x, !0);
      } else
        await L();
    } catch (x) {
      M(x);
    }
  }, [t, L, r, M, q, l]), D = Yt(async () => {
    w.current && p({
      content: "",
      element: null,
      isCached: !1,
      status: wi.LOADING
    });
  }, []);
  yt(
    () => {
      if (w.current = !0, !RE() || N.current)
        return () => {
        };
      try {
        if ($ === wi.IDLE) {
          if (!tTe())
            throw new Error("Browser does not support SVG");
          if (!l)
            throw new Error("Missing src");
          D();
        }
      } catch (S) {
        M(S);
      }
      return N.current = !0, () => {
        w.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), yt(() => {
    if (RE() && v)
      if (v.src !== l) {
        if (!l) {
          M(new Error("Missing src"));
          return;
        }
        D();
      } else
        (v.title !== u || v.description !== o) && R();
  }, [o, R, M, D, v, l, u]), yt(() => {
    b && (b.status !== wi.LOADING && $ === wi.LOADING && T(), b.status !== wi.LOADED && $ === wi.LOADED && R(), b.status !== wi.READY && $ === wi.READY && (c == null || c(l, h)));
  }, [T, R, h, c, b, l, $]);
  const A = aTe(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return RE() ? f ? gf(f, { ref: i, ...A }) : [wi.UNSUPPORTED, wi.FAILED].includes($) ? n : a : a;
}
function dTe(e) {
  Sb || (Sb = new sTe());
  const { loader: t } = e, n = xt(!1), [o, r] = it(Sb.isReady);
  return yt(() => {
    n.current || (Sb.onReady(() => {
      r(!0);
    }), n.current = !0);
  }, []), o ? /* @__PURE__ */ m(uTe, { ...e }) : t;
}
const Q9 = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA, _Te = Q9 ? `-${Q9.slice(0, 7)}` : "";
function eU() {
  return /* @__PURE__ */ m(
    dTe,
    {
      src: `https://app.cal.com/icons/sprite.svg?v=${process.env.NEXT_PUBLIC_CALCOM_VERSION}-${_Te}`
    }
  );
}
const pTe = Bt(function(t) {
  return /* @__PURE__ */ de(
    "svg",
    {
      className: t.className,
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ m(
          "path",
          {
            className: "fill-default",
            d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
            opacity: ".25"
          }
        ),
        /* @__PURE__ */ m(
          "path",
          {
            className: "animate-spinning fill-emphasis origin-center",
            d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
          }
        )
      ]
    }
  );
}), mTe = Bt(function(t, n) {
  return /* @__PURE__ */ de(
    "svg",
    {
      ref: n,
      className: t.className,
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 360 360",
      children: [
        /* @__PURE__ */ m("title", { children: "Satoshis" }),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "201.48",
            y: "37.16",
            width: "23.49",
            height: "40.14",
            transform: "translate(21.82 -52.79) rotate(14.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "135.03",
            y: "287.5",
            width: "23.49",
            height: "40.14",
            transform: "translate(83.82 -27.36) rotate(14.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "184.27",
            y: "38.29",
            width: "23.49",
            height: "167.49",
            transform: "translate(364.26 -36.11) rotate(104.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "168.36",
            y: "98.26",
            width: "23.49",
            height: "167.49",
            transform: "translate(402.22 54.61) rotate(104.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "152.89",
            y: "156.52",
            width: "23.49",
            height: "167.49",
            transform: "translate(439.1 142.78) rotate(104.87)"
          }
        )
      ]
    }
  );
}), fTe = "Identitätsanbieter", gTe = 'Sie haben noch $t(Tage, {"count": {{days}} }) im Testzeitraum der PRO-Version', hTe = "{{count}} Tag", vTe = "{{count}} Tage", bTe = "{{count}} Sekunde", yTe = "{{count}} Sekunden", $Te = "Jetzt upgraden", wTe = "Ohne Titel", kTe = "Einladung annehmen", STe = "Max. Zeichen", ETe = "Min. Zeichen", xTe = "{{appName}} stellt die Planungsinfrastruktur für absolut jeden bereit.", CTe = "Schließen Sie die Einrichtung Ihres {{appName}}-Kontos ab! Sie sind nur noch wenige Schritte davon entfernt, all Ihre Terminplanungsprobleme zu lösen.", TTe = "Haben Sie Fragen? Wir sind hier um Ihnen zu helfen.", ATe = "{{appName}}: Anleitung zum Zurücksetzen des Passworts", ITe = "{{appName}}: Bestätigen Sie Ihr Konto", OTe = "{{appName}}: Bestätigen Sie Ihre E-Mail-Adresse", NTe = "Schauen Sie in Ihrem E-Mail-Postfach nach", zTe = "Alte E-Mail-Adresse", RTe = "Neue E-Mail-Adresse", PTe = "Wir haben eine E-Mail an {{email}} gesendet. Es ist wichtig, Ihre E-Mail-Adresse zu bestätigen, um die Zustellbarkeit für E-Mails und Kalenderbenachrichtigungen von {{appName}} zu gewährleisten.", DTe = "Bestätigen Sie Ihre E-Mail-Adresse, um die Zustellbarkeit von E-Mails und Kalenderbenachrichtigungen zu gewährleisten", LTe = "Bestätigen Sie Ihre E-Mail-Adresse", MTe = "E-Mail bestätigen", FTe = "Assistent", qTe = "Cal Video-Transkriptions-E-Mails senden", jTe = "E-Mails mit der Transkription des Cal Videos nach Beendigung des Meetings versenden. (Erfordert einen kostenpflichtigen Plan)", VTe = "Sie haben vor kurzem angefordert, die E-Mail-Adresse zu ändern, die Sie verwenden, um sich bei Ihrem {{appName}} Konto anzumelden. Bitte klicken Sie auf die Schaltfläche unten, um Ihre neue E-Mail-Adresse zu bestätigen.", BTe = "Ihre E-Mail wurde auf {{email}} aktualisiert", UTe = "Fehler beim Aktualisieren der E-Mail.", GTe = "Bestätigen Sie Ihre neue {{appName}} E-Mail-Adresse", WTe = "Wir haben einen Bestätigungslink an {{email}} gesendet. Wir werden Ihre E-Mail-Adresse aktualisieren, sobald Sie auf diesen Link klicken.", HTe = "Speichern Sie diesen API-Schlüssel an einem sicheren Ort. Sie können ihn nicht erneut ansehen.", YTe = "Bitte bestätigen Sie Ihre E-Mail-Adresse, indem Sie unten auf die Schaltfläche klicken.", KTe = "Bitte bestätigen Sie Ihre E-Mail-Adresse mit dem unten stehenden Code.", ZTe = "Hier ist der Link, falls Sie lieber keine Schaltflächen anklicken möchten:", XTe = "Geben Sie den Bestätigungscode ein", JTe = "Geben Sie den Bestätigungscode ein, den Sie per E-Mail erhalten haben", QTe = "Der Bestätigungscode ist falsch.", eAe = "E-Mail erfolgreich gesendet", tAe = "Fehler beim Senden der E-Mail aufgetreten", nAe = "Abgelehnt: {{title}} am {{date}}", oAe = "Abgesagt: {{title}} am {{date}}", rAe = "Neu zugewiesen: {{title}} am {{date}}", iAe = "Ihre Event-Anfrage wurde abgelehnt", aAe = "Cal Video-Einstellungen anpassen", sAe = "Konfigurieren Sie Videokonferenz-Präferenzen einschließlich Aufnahmeberechtigungen für Gastgeber und Teilnehmer.", cAe = "Aufnahme für Gäste deaktivieren", lAe = "Automatische Transkription nach Beitritt zum Meeting aktivieren", uAe = "Automatische Aufnahme aktivieren, nachdem der Organisator dem Meeting beigetreten ist", dAe = "Videooptionen", _Ae = "Termin bearbeiten", pAe = "Sitzungsdetails anzeigen", mAe = "Meeting-Sitzungsdetails", fAe = "Meeting-Sitzung", gAe = "Sitzungs-ID", hAe = "Maximale Teilnehmerzahl", vAe = "Unbegrenzt", bAe = "Laufend", yAe = "Beendet", $Ae = "Teilnehmer", wAe = "Anonymer Benutzer", kAe = "Sitzungsdauer", SAe = "Keine Meeting-Sitzungen gefunden", EAe = "Nicht verfügbar", xAe = "Aufnahme für Organisator deaktivieren", CAe = "Transkription für Gäste deaktivieren", TAe = "Transkription für Organisator deaktivieren", AAe = "Ihre wiederkehrende Terminanfrage wurde abgelehnt", IAe = "Ihr geplanter Termin wurde abgesagt", OAe = "Ihr geplanter Termin wurde neu zugewiesen", NAe = "Der Termin wird nicht mehr in Ihrem Kalender erscheinen und Ihre Round-Robin-Wahrscheinlichkeit wird nicht negativ beeinflusst", zAe = "Organisator", RAe = "Neu zugewiesen an", PAe = "Möchten Sie einen neuen Termin finden oder absagen?", DAe = "Sie können die Buchungsdetails unter dieser URL einsehen {{url}} und den Termin zu Ihrem Kalender hinzufügen", LAe = "Keine Optionen verfügbar", MAe = "Grund für Ihre Absage (optional)", FAe = "Abgesagt von", qAe = "Grund für die Absage", jAe = "Warum sagen Sie ab?", VAe = "Der Stornierungsgrund wird mit den Gästen geteilt", BAe = "Warum lehnen Sie ab?", UAe = "Grund für die Ablehnung", GAe = "Die Buchungsanfrage ablehnen?", WAe = "Sind Sie sicher, dass Sie die Buchung ablehnen möchten? Wir werden die Person, die versucht hat zu buchen, informieren. Sie können einen Grund angeben.", HAe = "Buchung ablehnen", YAe = "Diesen Termin verwalten", KAe = "Teammitglied einladen", ZAe = "Person einladen", XAe = "Massenimport", JAe = "Eing.", QAe = "Ihr Termin wurde gebucht", e2e = "Ihr wiederkehrender Termin wurde gebucht", t2e = "Akzeptieren Sie unsere Lizenz, indem Sie die .env-Variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> auf '{{agree}} ' ändern.", n2e = "Um diesen Banner zu entfernen, öffnen Sie bitte Ihre .env-Datei und ändern Sie die <1>NEXT_PUBLIC_LICENSE_CONSENT</1> Variable auf '{{agree}}'.", o2e = "Die Fehlermeldung war: '{{errorMessage}}'", r2e = "Rückerstattung fehlgeschlagen: {{userName}} - {{date}} - {{eventType}}", i2e = "Die Rückerstattung für den Termin {{eventType}} mit {{userName}} am {{date}} ist fehlgeschlagen.", a2e = "Bitte überprüfen Sie bei Ihrem Zahlungsanbieter und {{userName}}, wie Sie damit umgehen.", s2e = "Erstattung fehlgeschlagen", c2e = "Warte auf Zahlung: {{title}} am {{date}}", l2e = "Zahlung für den Termin noch offen", u2e = "Die Farbe des dunklen Designs hat die Kontrastprüfung nicht bestanden. Wir empfehlen Ihnen, diese Farbe zu ändern, damit Ihre Schaltflächen sichtbarer sind.", d2e = "Die Farbe des hellen Designs hat die Kontrastprüfung nicht bestanden. Wir empfehlen Ihnen, diese Farbe zu ändern, damit Ihre Schaltflächen sichtbarer sind.", _2e = "Die Farbe für das helle Design besteht den Kontrasttest nicht. Wir empfehlen, diese Farbe zu ändern, damit Ihre Ereignistypen besser sichtbar sind.", p2e = "Die Farbe für das dunkle Design besteht den Kontrasttest nicht. Wir empfehlen, diese Farbe zu ändern, damit Ihre Ereignistypen besser sichtbar sind.", m2e = "Zahlung konnte nicht erstellt werden", f2e = "Karte konnte nicht für die Zahlung belastet werden", g2e = "Keine verfügbaren Benutzer gefunden. Können Sie es mit einem anderen Zeitfenster versuchen?", h2e = "Der ausgewählte Zeitraum ist nicht mehr verfügbar. <0>Bitte wähle eine neue Zeit</0>", v2e = "Belegt", b2e = "Sie haben gerade eine Verbindung hergestellt. Bitte buchen Sie aus den obigen Zeitfenstern oder versuchen Sie es später erneut.", y2e = "Nicht verfügbarer Zeitslot", $2e = "Der Termin kann zu diesem Zeitpunkt nicht gebucht werden. Möchten Sie einen anderen Zeitslot versuchen?", w2e = "Interner Fehler. Request-Body enthält keinen Endzeitpunkt", k2e = "Kalenderereignis konnte nicht im Kalender des Organisators erstellt werden", S2e = "Kalenderereignis konnte nicht aktualisiert werden.", E2e = "Kalenderereignis konnte nicht gelöscht werden.", x2e = "Sie sind bereits für diese Buchung registriert.", C2e = "Einige der Veranstalter sind nicht für die Buchung verfügbar.", T2e = "Einige der festen Gastgeber sind für Buchungen nicht verfügbar.", A2e = "Round-Robin-Host ist für Buchungen nicht verfügbar.", I2e = "Hilfe", O2e = "Preis", N2e = "Bezahlt", z2e = "Erstattet", R2e = "Aufnehmen", P2e = "Transkribieren", D2e = "Bezahlung", L2e = "Fehlender Eintrag für Karteninformationen", M2e = "Jetzt bezahlen", F2e = "Allgemeine Aufforderung", q2e = "Transkription unterstützt durch KI", j2e = "Aufnahme starten oder stoppen", V2e = "Nachricht starten", B2e = "Die Codebasis muss Open Source bleiben, unabhängig davon, ob sie geändert wurde oder nicht", U2e = "Sie dürfen die Codebasis nicht weiter verkaufen", G2e = "Erwerben Sie eine kommerzielle Lizenz per Email, um diese Bedingungen zu entfernen", W2e = "Zusammenfassung der Bedingungen", H2e = ".env öffnen und unserer Lizenz zustimmen", Y2e = "Ich habe mein .env geändert", K2e = "Lizenz akzeptieren", Z2e = "Ein Termin wartet noch auf Bestätigung", X2e = "Termin-Anfrage wartet: {{attendeeName}} - {{date}} - {{eventType}}", J2e = 'Keine Ergebnisse gefunden für "{{searchTerm}}"', Q2e = "Keine weiteren Ergebnisse", eIe = "Keine Ergebnisse", tIe = "Weitere Ergebnisse laden", nIe = "{{integrationName}} Termin-ID: {{meetingId}}", oIe = "Bestätigt: {{eventType}} mit {{name}} am {{date}}", rIe = "Neue Termin-Anfrage: {{attendeeName}} - {{date}} - {{eventType}}", iIe = "Anfrage bestätigen oder ablehnen", aIe = "Überprüfen Sie Ihre Buchungsseite, um die Buchung zu bestätigen oder abzulehnen.", sIe = "Check-in-Assistent", cIe = "Führt einen ausgehenden Anruf durch, um zu prüfen, ob der geplante Termin funktioniert oder ob Sie ihn verschieben möchten.", lIe = "Erstellen Sie Ihre eigene Aufforderung und verwenden Sie sie für einen ausgehenden Anruf.", uIe = "Ein neuer Termin wartet auf Ihre Bestätigung", dIe = "Ein wiederkehrender Termin wartet auf Ihre Bestätigung", _Ie = "Jemand hat eine Terminanfrage gestellt.", pIe = "Jemand hat einen Link angefordert, um Ihr Passwort zu ändern.", mIe = "Wenn diese E-Mail-Adresse in unserem System existiert, sollten Sie eine Zurücksetzungs-E-Mail erhalten.", fIe = "Wenn Sie dies nicht angefordert haben, können Sie diese E-Mail sicher ignorieren und Ihr Passwort wird nicht geändert.", gIe = "Warte auf Bestätigung: {{title}} um {{date}}", hIe = "Ein Termin wartet noch auf Ihre Bestätigung", vIe = "Termin eingereicht: {{title}} am {{date}}", bIe = "Aufnahme herunterladen: {{title}} am {{date}}", yIe = "Transkript herunterladen: {{title}} am {{date}}", $Ie = "Ihre Aufnahme herunterladen", wIe = "Ihre Transkripte herunterladen", kIe = "Ihr Termin wurde gebucht", SIe = "Ihr {{title}} wurde auf den {{date}} verschoben.", EIe = "Dein {{title}} wurde aktualisiert.", xIe = "Ihr Termin wurde verschoben.", CIe = "Termin wurde aktualisiert", TIe = "Ihr Termin wurde umgeplant", AIe = "{{organizer}} hat den Termin abgesagt und Sie gebeten, eine andere Zeit auszuwählen.", IIe = "Sie haben {{attendee}} zur Neuplanung aufgefordert", OIe = "Sie haben die Buchung storniert und {{attendee}} muss eine neue Buchungszeit mit Ihnen vereinbaren.", NIe = "Anfrage für Neuplanung gesendet: {{eventType}} mit {{name}} am {{date}}", zIe = "Aktion erforderlich - Neuplanung: Bitte buchen Sie eine neue Zeit für „{{eventType}}“ mit {{name}}", RIe = "Hallo, {{name}}", PIe = "{{eventType}} mit {{name}}", DIe = "Es scheint, dass alle unsere Experten momentan beschäftigt sind. Bitte vereinbaren Sie einen Termin zu einem Zeitpunkt, der Ihnen am besten passt, und wir werden bereit sein, Ihnen zu helfen.", LIe = "Stattdessen planen", MIe = "Neuer Termin: {{attendeeName}} - {{date}} - {{eventType}}", FIe = "{{entryPoint}} beitreten", qIe = "Notizen", jIe = "Meine Termine verwalten", VIe = "Sie müssen eine Änderung vornehmen?", BIe = "Ein neuer Termin wurde geplant.", UIe = "Ein neuer wiederkehrender Termin wurde geplant.", GIe = "Teilnehmer-Email", WIe = "Zeitzone der Teilnehmenden", HIe = "Verbleibende Zeit", YIe = "Termintyp", KIe = "Doppelter Ereignistyp", ZIe = "Termin beitreten", XIe = "Videoanbieter", JIe = "Termin-ID", QIe = "Termin-Passwort", eOe = "Termin-URL", tOe = "Meeting-URL nicht gefunden", nOe = "Token nicht gefunden", oOe = "Ein anderer Gastgeber hat das Meeting bereits angenommen. Möchtest du trotzdem teilnehmen? <0>Weiter zum Meeting</0>", rOe = "Ihre Terminanfrage wurde abgelehnt", iOe = "Abgelehnt: {{eventType}} mit {{organizer}} auf {{date}}", aOe = "Hi", sOe = "Team beitreten", cOe = "Dieses Team verwalten", lOe = "Informationen zum Team", uOe = "Meeting beitreten", dOe = "Falls Sie {{toEmail}} lieber nicht als Ihre {{appName}}-E-Mail verwenden möchten oder bereits über ein {{appName}}-Konto verfügen, fordern Sie bitte eine weitere Einladung zu dieser E-Mail an.", _Oe = "Sie wurden eingeladen, dem Team {{teamName}} beizutreten", pOe = "{{user}} hat Sie eingeladen, dem {{entity}} {{team}} auf {{appName}} beizutreten", mOe = "Sie sind in diesem Team ausgeblendet", fOe = "Ihre Teammitgliedschaft ist nicht bezahlt, entweder upgraden Sie Ihren Account auf Pro oder lassen den Team-Organisator wissen, dass er für Ihren Platz im Team bezahlen kann.", gOe = "Sie benötigen einen Pro-Account um die Teamfunktionen zu verweden. Sie werden dem Team nicht angezeigt, bis der Account upgegradet wurde.", hOe = "p.s. Es läuft in {{expiresIn}} Stunden ab.", vOe = "Upgrade auf Pro-Mitglied lizensierung", bOe = "Sitzplatzoption unterstützt keine Bestätigungsanforderung", yOe = "Mehrere Standorte unterstützt die Sitzplätze-Option nicht", $Oe = "Gebühr für das Nichterscheinen unterstützt die Sitzplätze-Option nicht", wOe = "Sitzplätze-Option unterstützt mehrere Standorte nicht", kOe = "Von den {{memberCount}} Mitgliedern in Ihrem Team sind {{unpaidCount}} Sitze(n) unbezahlt. Bei ${{seatPrice}}/m pro Sitzplatz betragen die geschätzten Gesamtkosten Ihrer Mitgliedschaft ${{totalCost}}/m.", SOe = "Vielen Dank, dass Sie unseren neuen Teamplan getestet haben. Wir haben festgestellt, dass Ihr Team „{{teamName}}“ aktualisiert werden muss.", EOe = "Hier aufrüsten", xOe = "Das Update für Ihr Team war erfolgreich!", COe = "Vielen Dank, dass Sie unseren neuen Tarif „Organization“ getestet haben. Wir haben festgestellt, dass Ihre Organization „{{teamName}}“ ein Upgrade benötigt.", TOe = "Das Upgrade für Ihre Organization war erfolgreich!", AOe = "Benutzen Sie den Link, um Ihr Passwort zurückzusetzen", IOe = "Hallo", OOe = "dort", NOe = "Passwort vergessen? - {{appName}}", zOe = "Sind Sie sicher, dass Sie diesen Webhook löschen möchten? Sie werden keine {{appName}}-Meetingdaten mehr unter einer bestimmten URL, in Echtzeit erhalten, wenn ein Ereignis geplant oder abgesagt wird.", ROe = "Ja, Webhook löschen", POe = "Webhook bearbeiten", DOe = "Webhook löschen", LOe = "Webhook-Status", MOe = "Webhook aktiviert", FOe = "Webhook deaktiviert", qOe = "Webhook-Antwort", jOe = "Webhook-Test", VOe = "Webhook-Aktualisierungsformular", BOe = "Fügen Sie Ihrem OAuth-Client einen Webhook hinzu.", UOe = "Webhook verwalten", GOe = "Webhook erfolgreich erstellt!", WOe = "Webhook erfolgreich aktualisiert!", HOe = "Webhook erfolgreich entfernt!", YOe = "Abonnement erforderlich", KOe = "Sie haben kein Platform-Abonnement.", ZOe = "Payload Vorlage", XOe = "Ignorieren", JOe = "Noch keine Daten", QOe = "Pingtest", eNe = "Fügen Sie diese App Ihrem Startbildschirm für schnelleren Zugriff hinzu.", tNe = "Bevorstehende", nNe = "Wiederkehrende", oNe = "Vergangene", rNe = "Datei auswählen...", iNe = "Bild hochladen", aNe = "{{target}} hochladen", sNe = "Kein {{target}}", cNe = "Regler schieben zum zoomen, gedrückt halten zum bewegen", lNe = "Benachrichtigungen anzeigen", uNe = "Öffentliche Seite anzeigen", dNe = "Link zur öffentlichen Seite kopieren", _Ne = "Empfehlungslink kopieren", pNe = "Abmelden", mNe = "Weitere hinzufügen", fNe = "Weitere installieren", gNe = "bis", hNe = "betrieben von", vNe = "Nicht verfügbar", bNe = "Arbeitszeiten festlegen", yNe = "Verfügbarkeit für Buchungen ändern", $Ne = "Auswählen...", wNe = "Text", kNe = "Ihre Telefonnummer", SNe = "Mehrzeiliger Text", ENe = "Nummer", xNe = "Checkbox", CNe = "Erforderlich", TNe = "Dieses Feld als erforderlich markieren", ANe = "Erforderlich", INe = "Optional", ONe = "Eingabetyp", NNe = "Abgelehnt", zNe = "Unbestätigt", RNe = "Gäste", PNe = "Gast", DNe = "Web-Konferenzdetails folgen.", LNe = "Bestätigung", MNe = "Was Ihr Bucher angeben sollte, um Bestätigungen zu erhalten", FNe = "Benutzername", qNe = "ist noch verfügbar.", jNe = "Dokumentation", VNe = "Lernen Sie, wie Sie unsere Tools in Ihre App integrieren", BNe = "API-Referenz", UNe = "Eine vollständige API-Referenz für unsere Bibliotheken", GNe = "Blog", WNe = "Lesen Sie unsere Neuigkeiten und Artikel", HNe = "Treten Sie unserer Community bei", YNe = "Beliebte Seiten", KNe = "Jetzt registrieren", ZNe = "Registrieren", XNe = "Diese Seite existiert nicht.", JNe = "Keine aktive Telefonnummer verfügbar", QNe = "Workflow-Schritt nicht konfiguriert", eze = "Prüfen Sie auf Rechtschreibfehler oder gehen Sie zur vorherigen Seite zurück.", tze = "Wir konnten den Termin nicht finden, den Sie buchen möchten.", nze = "Los geht's", oze = "Passwort", rze = "Leer lassen, um Passwort zu entfernen", ize = "Stellen Sie sicher, dass Ihr Server aus Sicherheitsgründen nur die erwarteten {{appName}}-Anfragen empfängt", aze = "Geheimer Termin", sze = "Stattdessen einloggen", cze = "Konto erstellen", lze = "Loslegen", uze = "Passwort bestätigen", dze = "Legen Sie Ihr neues Passwort mit den Anweisungen fest, die an Ihre E-Mail-Adresse gesendet wurden.", _ze = "Bitte laden Sie Bild mit einer Breite von {{width}} und einer Höhe von {{height}} hoch.", pze = "Melden Sie sich mit Ihrer neuen E-Mail-Adresse und Ihrem Passwort wieder an.", mze = "Erstellen Sie Ihr Konto", fze = "Erstellen Sie Ihr Cal.com-Konto", gze = "Registrieren", hze = "Sie wurden abgemeldet", vze = "Wir hoffen, Sie bald wieder zu sehen!", bze = "Abgemeldet", yze = "Bitte versuchen Sie es erneut und kontaktieren Sie uns, falls das Problem weiterhin besteht.", $ze = "Zwei-Faktor-Code ist falsch.", wze = "Es gibt kein Konto, das mit dieser E-Mail-Adresse übereinstimmt.", kze = "Konto erstellen", Sze = "Sie haben noch kein Konto?", Eze = "Mit Ihrem Konto anmelden", xze = "Anmelden", Cze = "Zurück zur Login-Seite", Tze = "Beim Anmelden ist ein Fehler aufgetreten. Gehen Sie zurück zum Anmeldebildschirm und versuchen Sie es erneut.", Aze = "Passwort zurücksetzen", Ize = "Einladung senden", Oze = "Passwort vergessen", Nze = "Vergessen?", zze = "Erledigt", Rze = "Erledigt!", Pze = "Alle", Dze = "Ihr Konto", Lze = "Verfügbare Apps", Mze = "Verfügbare Apps", Fze = "Sieh dir beliebte Apps unten an und entdecke mehr in unserem <0>App Store</0>", qze = "Füge jeden hinzu, der an der Veranstaltung teilnehmen muss. <0>Mehr erfahren</0>", jze = "Personen in einer Gruppe wechseln sich ab, eine Person aus jeder Gruppe wird bei der Veranstaltung erscheinen.", Vze = "Die Leute in der Gruppe wechseln sich ab und nur eine Person wird für die Veranstaltung erscheinen.", Bze = "Überprüfen Sie Ihre E-Mail. Wir haben Ihnen einen Link zum Zurücksetzen Ihres Passworts gesendet.", Uze = "Fertig", Gze = "Einstellungen für die Sprache und Zeitzone Ihres Teams verwalten", Wze = "Schreiben Sie eine kurze Beschreibung, welche auf Ihrer persönlichen URL-Seite erscheinen wird.", Hze = "Fast fertig", Yze = "Zum Schluss: Eine kurze Beschreibung über Sie und ein Foto helfen wirklich, Buchungen zu erhalten und lassen andere wissen, mit wem sie einen Termin buchen.", Kze = "Definieren Sie Zeiträume, wenn Sie wiederkehrend verfügbar sind. Sie können später weitere Zeiträume erstellen und verschiedenen Kalendern zuordnen.", Zze = "Verfügbarkeit festlegen", Xze = "Legen Sie Zeitpläne für die Zeiten fest, in denen Sie gebucht werden möchten.", Jze = "Link oder Einbettung teilen", Qze = "Teilen Sie Ihren {{appName}} Link oder betten Sie ihn auf Ihrer Website ein.", eRe = "Verfügbarkeitseinstellungen", tRe = "Ohne Kalender fortfahren", nRe = "Mit {{appName}} fortfahren", oRe = "Kalender verbinden", rRe = "Verbinden Sie Ihre Video-Apps", iRe = "Verbinden Sie Ihre Video-Apps, um sie für Ihre Termintypen zu verwenden.", aRe = "Verbinden Sie Ihren Kalender, um automatisch nach belegten Zeiten zu suchen und neue Termine zu erfassen, sobald sie geplant werden.", sRe = "Später einrichten", cRe = "Aktuelle Zeit", lRe = "Details", uRe = "Willkommen", dRe = "Willkommen zurück", _Re = "Willkommen bei {{appName}}", pRe = "Teilen Sie uns mit, wie wir Sie nennen sollen und in welcher Zeitzone Sie sich befinden. Sie können dies später bearbeiten.", mRe = "Mit CalDav-Server verbinden", fRe = "Mit einem ICS-Feed verbinden", gRe = "Verbinden", hRe = "Kostenlos testen", vRe = "Erstellen Sie Ihren eigenen Buchungslink mit {{appName}}", bRe = "Wer", yRe = "Was", $Re = "Wann", wRe = "Wo", kRe = "Zum Kalender hinzufügen", SRe = "Wählen Sie aus, wo Termine hinzugefügt werden sollen, wenn Sie gebucht werden.", ERe = "Termine hinzufügen zu", xRe = "Einen weiteren Kalender hinzufügen", CRe = "Sonstige", TRe = "Ihr Anmelde-Link für {{appName}}", ARe = "Sie treffen sich mit {{user}}. Wir haben eine E-Mail mit einer Kalendereinladung mit den Details an alle gesendet.", IRe = "{{host}} trifft sich mit {{attendee}}. Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details gesendet.", ORe = "Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details gesendet.", NRe = "Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details für das erste dieser wiederkehrenden Events gesendet.", zRe = "Sie treffen sich mit {{user}}. Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details für das erste dieser wiederkehrenden Events gesendet.", RRe = "{{host}} trifft sich mit {{attendee}}. Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details für das erste dieser wiederkehrenden Events gesendet.", PRe = "Wir haben eine E-Mail mit diesen Informationen an alle gesendet.", DRe = "Ihr Termin muss noch bestätigt oder abgelehnt werden.", LRe = "Ihr wiederkehrender Termin muss noch bestätigt oder abgelehnt werden.", MRe = "{{user}} muss den Termin noch bestätigen oder ablehnen.", FRe = "{{user}} muss noch die Terminreihe des wiederkehrenden Termins bestätigen oder ablehnen.", qRe = "Dieser Termin ist geplant", jRe = "Ihr wiederkehrender Termin wurde geplant", VRe = "Ihre Buchung wurde versandt", BRe = "Ihre wiederkehrende Buchung wurde versandt", URe = "Ihr Termin wurde bestätigt", GRe = "Ihr wiederkehrender Termin wurde bestätigt", WRe = "Zahlungen werden bei wiederkehrenden Terminen noch nicht unterstützt", HRe = "Zahlungen werden bei wiederkehrenden Terminen noch nicht unterstützt", YRe = "Geben Sie das neue Passwort ein.", KRe = "Passwort zurücksetzen", ZRe = "Passwort ändern", XRe = "Passwort anzeigen", JRe = "Passwort verbergen", QRe = "Erneut versuchen", ePe = "Diese Anfrage ist abgelaufen.", tPe = "Geben Sie die E-Mail-Adresse Ihres Kontos ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.", nPe = "Diese Anfrage ist abgelaufen. Gehen Sie zurück und geben Sie die E-Mail Ihres Kontos ein und wir senden Ihnen einen weiteren Link zum Zurücksetzen Ihres Passworts.", oPe = "Hoppla", rPe = "Anmelden", iPe = "Das hat geklappt", aPe = "Fehlschlagen", sPe = "Ihr Passwort wurde zurückgesetzt. Sie können sich jetzt mit Ihrem neu erstellten Passwort anmelden.", cPe = "Layout", lPe = "Standardansicht", uPe = "Sie können mehrere auswählen und Ihre Bucher können anschließend die Ansicht wechseln.", dPe = "Buchungslayout", _Pe = "Sie können mehrere auswählen und Bucher können anschließend die Ansicht wechseln. Dies kann pro Termin überschrieben werden.", pPe = "Monat", mPe = "Wöchentlich", fPe = "Spalte", gPe = "Es muss mindestens ein Layout aktiviert sein.", hPe = "Das Layout, das Sie als Standardansicht ausgewählt haben, ist nicht Teil der aktivierten Layouts.", vPe = "Das ausgewählte Layout ist kein gültiges Layout.", bPe = "Du kannst dies für alle deine Ereignistypen in Einstellungen -> <0>Erscheinungsbild</0> verwalten oder <1>überschreiben</1> nur für dieses Ereignis.", yPe = "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es erneut.", $Pe = "Ungültige Zeit am Sonntag", wPe = "Ungültige Zeit am Montag", kPe = "Ungültige Zeit am Dienstag", SPe = "Ungültige Zeit am Mittwoch", EPe = "Ungültige Zeit am Donnerstag", xPe = "Ungültige Zeit am Freitag", CPe = "Ungültige Zeit am Samstag", TPe = "Die Endzeit darf nicht vor der Startzeit liegen", APe = "Die Endzeit darf nicht größer als 24 Stunden sein", IPe = "Zurück zu den Buchungen", OPe = "Sie können jederzeit einen anderen Termin wählen.", NPe = "Abgesagt", zPe = "Keine Buchung", RPe = "Warten auf Gastgeber", PPe = "Stornierung erfolgreich", DPe = "Möchten Sie wirklich stornieren?", LPe = "Sie können diese Buchung nicht stornieren", MPe = "Stattdessen können Sie den Termin auch verschieben.", FPe = "Der Termin ist in der Vergangenheit", qPe = "Der Termin ist eine Instanz eines wiederkehrenden Termins.", jPe = "Dies sind alle verbleibende Instanzen im wiederkehrenden Termin.", VPe = "Ein Fehler mit dem Statuscode {{status}} ist aufgetreten.", BPe = "Ein Termintyp mit dieser URL existiert bereits.", UPe = "Sie können diesen Termin nicht erstellen", GPe = "Sie können diesen Termin nicht bearbeiten", WPe = "Sie können diesen Workflow nicht erstellen", HPe = "Sie können diesen Verfügbarkeitsplan nicht erstellen", YPe = "Dieser Termin wurde bereits abgesagt", KPe = "Diese Buchung wurde bereits angenommen oder abgelehnt", ZPe = "Zurück zum Anfang", XPe = "Oder navigieren Sie zurück", JPe = "Kein Termin gefunden", QPe = "Dieser Termin existiert nicht. Kontaktieren Sie den Ersteller um einen aktuellen Link zu bekommen.", eDe = "Es gibt noch keine {{status}} Buchungen", tDe = "Sie haben keine {{status}} Buchungen. {{description}}", nDe = "{{eventName}} zwischen {{host}} und {{attendeeName}}", oDe = "Buchungen", rDe = "Termin nicht gefunden", iDe = "Sehen Sie anstehende und vergangene Veranstaltungen, die über Ihre Events gebucht wurden.", aDe = "Sobald jemand eine Zeit bei Ihnen bucht können Sie das hier sehen.", sDe = "Sobald jemand einen wiederkehrenden Termin mit Ihnen bucht wird er hier erscheinen.", cDe = "Ihre früheren Buchungen werden hier angezeigt.", lDe = "Ihre abgesagten Termine werden hier angezeigt.", uDe = "Ihre unbestätigten Buchungen werden hier angezeigt.", dDe = "Unbestätigte Buchungen", _De = "auf", pDe = "und", mDe = "Ihr Kalender ist belegt zwischen", fDe = "Problembehandlung", gDe = "Verstehen Sie, warum bestimmte Zeiten verfügbar und andere blockiert sind.", hDe = "Hier ist eine Übersicht Ihres Tages am", vDe = "Tipp: Fahre über die markierten Zeiten um das ganze Datum zu sehen", bDe = "Beginn", yDe = "Ende", $De = "Pufferzeit", wDe = "Vor dem Termin", kDe = "Nach dem Termin", SDe = "Keine Pufferzeit", EDe = "Puffer", xDe = "Ihr Tag beginnt um", CDe = "Ihr Tag endet um", TDe = "Fehlersuche starten", ADe = "Sie können die Problembehandlung nutzen um zu recherchieren warum Ihr Kalender so angezeigt wird, wie er angezeigt wird.", IDe = "Verfügbare Zeiten ändern", ODe = "Ändern Sie Ihre verfügbaren Zeiten", NDe = "Ändern Sie die Anfangs- und Endzeit Ihres Tages", zDe = "Legen Sie die Anfangs- und Endzeit Ihres Tages und einen Puffer zwischen Ihren Meetings fest.", RDe = "Momentan startet Ihr Tag um", PDe = "Die Anfangs- und Endzeiten Ihres Tages wurden erfolgreich aktualisiert.", DDe = "und endet um", LDe = "Hell", MDe = "Dunkel", FDe = "Theme automatisch basierend auf den Einstellungen des Teilnehmers anpassen", qDe = "Einige der Benutzer in der Gruppe haben derzeit dynamische Gruppenbuchungen deaktiviert", jDe = "Gruppenbuchungslinks, die dynamisch durch Hinzufügen mehrerer Benutzernamen mit einem '+' erstellt werden können. Beispiel: '{{appName}}/bailey+peer'", VDe = "Ermöglichen Sie es den Teilnehmenden, Sie über dynamische Gruppenbuchungen zu buchen", BDe = "Dynamische Gruppenlinks", UDe = "Suchmaschinen erlauben, auf Ihre öffentlichen Inhalte zuzugreifen", GDe = "Suchmaschinenindexierung erlauben", WDe = "Browser-Benachrichtigungen zulassen", HDe = "Sie haben Benachrichtigungen abgelehnt. Setzen Sie die Berechtigung in den Browser-Einstellungen zurück, um sie zu aktivieren.", YDe = "Browser-Benachrichtigungen deaktivieren", KDe = "Browser-Benachrichtigungen aktiviert", ZDe = "Browser-Benachrichtigungen deaktiviert", XDe = "Browser-Benachrichtigungen verweigert", JDe = "Bitte erlauben Sie Benachrichtigungen in der Abfrage", QDe = "Push-Benachrichtigungen", e3e = "Erhalten Sie Push-Benachrichtigungen, wenn ein Bucher eine sofortige Terminbuchung vornimmt.", t3e = "Ihr Browser unterstützt keine Push-Benachrichtigungen. Wenn Sie Brave-Nutzer sind, aktivieren Sie die Option 'Google-Dienste für Push-Nachrichten verwenden' unter brave://settings/?search=push+messaging", n3e = "E-Mail", o3e = "max@example.com", r3e = "Vollständiger Name", i3e = "Durchsuchen Sie unsere API Dokumentation", a3e = "Nutzen Sie unsere API für die volle Kontrolle und Anpassbarkeit.", s3e = "Webhook erstellen", c3e = "Sofortiges Meeting erstellt", l3e = "Termin abgesagt", u3e = "Termin verlegt", d3e = "Download-Link der Aufnahme ist nun verfügbar", _3e = "Transkript erstellt", p3e = "Termin erstellt", m3e = "Termin abgelehnt", f3e = "Buchung angefragt", g3e = "Buchungszahlung eingeleitet", h3e = "Meeting beendet", v3e = "Formular gesendet", b3e = "Formular übermittelt, kein Termin gebucht", y3e = "Buchung bezahlt", $3e = "Abwesenheitsnotiz erstellt", w3e = "Buchung als Nichterscheinen aktualisiert", k3e = "Event-Auslöser", S3e = "Subscriber-URL", E3e = "Einen neuen Webhook erstellen", x3e = "Webhooks", C3e = "Team-Webhooks", T3e = "Erstellen Sie einen neuen Webhook in Ihrem Account", A3e = "Neuer Webhook", I3e = "Erhalten Sie in Echtzeit {{appName}}-Termindaten unter einer bestimmten URL, wenn ein Termin geplant oder abgesagt wird.", O3e = "Erhalten Sie in Echtzeit {{appName}}-Termindaten unter einer bestimmten URL, wenn dieser Termin geplant oder abgesagt wird.", N3e = "Responsives Vollbild-iFrame", z3e = "Wird geladen...", R3e = "Lösche...", P3e = "Standard iFrame", D3e = "Entwickler", L3e = "Verwalten Sie Ihre Entwicklereinstellungen.", M3e = "iFrame-Einbettung", F3e = "Der einfachste Weg, {{appName}} auf Ihrer Website einzubinden.", q3e = "Integrieren Sie Cal.com in Ihre Website mit unseren Einbettungs-Optionen oder erhalten Sie Buchungsdaten mit Webhooks.", j3e = "Termin planen", V3e = "Ihre Rechnungsdetails ansehen und verwalten", B3e = "Rechnungsdaten ansehen, bearbeiten oder Abonnement kündigen.", U3e = "Zum Rechnungsportal gehen", G3e = "Brauchen Sie etwas anderes?", W3e = "Wenn Sie weitere Hilfe bei der Rechnungsstellung benötigen, hilft Ihnen unser Support-Team gerne weiter.", H3e = "Kontaktieren Sie", Y3e = "unser Support-Team", K3e = "Kontaktieren Sie unser Support-Team", Z3e = "Uh oh!", X3e = "Dieser Benutzer hat noch keine Termintypen eingerichtet.", J3e = "Logo bearbeiten", Q3e = "Logo hochladen", eLe = "Logo hochladen", tLe = "Logos entfernen", nLe = "Aktivieren", oLe = "Code", rLe = "Code ist falsch.", iLe = "Neues Zeitfenster hinzufügen", aLe = "Fügen Sie Ihrem Konto eine zusätzliche Sicherheitsstufe hinzu, falls Ihr Passwort gestohlen wird.", sLe = "Zwei-Faktor-Authentifizierung aktivieren", cLe = "Zwei-Faktor-Authentifizierung deaktivieren", lLe = "Falls Sie 2FA deaktivieren müssen, empfehlen wir, es so schnell wie möglich wieder zu aktivieren.", uLe = "Fehler beim Deaktivieren der Zwei-Faktor-Authentifizierung", dLe = "Fehler beim Einrichten der Zwei-Faktor-Authentifizierung", _Le = "Sicherheit", pLe = "Verwalten Sie die Sicherheit Ihres Kontos.", mLe = "Passwort", fLe = "Passwort erfolgreich aktualisiert", gLe = "Ihr Passwort wurde erfolgreich geändert.", hLe = "Fehler beim Ändern des Passworts", vLe = "Ihre Sitzungskonfiguration wurde erfolgreich aktualisiert.", bLe = "Fehler beim Aktualisieren der Sitzungskonfiguration", yLe = "Etwas ist schief gelaufen", $Le = "Irgendwas sieht nicht richtig aus?", wLe = "Bitte erneut versuchen", kLe = "Ihr supersicheres neues Passwort", SLe = "Neues Passwort", ELe = "Ihr altes Passwort", xLe = "Aktuelles Passwort", CLe = "Passwort ändern", TLe = "Geheimnis ändern", ALe = "Neues Passwort stimmt mit Ihrem alten Passwort überein. Bitte wählen Sie ein anderes Passwort.", ILe = "Wenn Sie dieses Passwort verloren oder vergessen haben, können Sie es ändern. Bitte beachten Sie, dass alle Integrationen, die dieses Geheimnis nutzen, aktualisiert werden müssen", OLe = "Aktuelles Passwort ist falsch", NLe = "Mischung aus Groß- und Kleinbuchstaben", zLe = "Mindestens 7 Zeichen lang", RLe = "Mindestens 15 Zeichen lang", PLe = "Enthält mindestens 1 Zahl", DLe = "Muss {{limit}} oder weniger Zeichen lang sein", LLe = "Das Passwort muss mindestens {{passwordLength}} Zeichen lang sein und mindestens eine Nummer beinhalten, sowie eine Mischung aus Groß- und Kleinbuchstaben sein", MLe = "Passwort ist falsch", FLe = "Die E-Mail-Adresse oder das Passwort ist falsch.", qLe = "Benutze Einstellung", jLe = "am/pm", VLe = "Zeitoptionen", BLe = "Januar", ULe = "Februar", GLe = "März", WLe = "April", HLe = "Mai", YLe = "Juni", KLe = "Juli", ZLe = "August", XLe = "September", JLe = "Oktober", QLe = "November", eMe = "Dezember", tMe = "Montag", nMe = "Dienstag", oMe = "Mittwoch", rMe = "Donnerstag", iMe = "Freitag", aMe = "Samstag", sMe = "Sonntag", cMe = "Alle Termine bereits vergeben.", lMe = "Die verfügbaren Zeitfenster konnten nicht geladen werden.", uMe = "+ Weitere Gäste", dMe = "Ihr Name", _Me = "Ihr vollständiger Name", pMe = "Kein Name", mMe = "Bitte geben Sie eine Zahl zwischen 1 und {{maxOccurences}} ein", fMe = "Schnell und einfach - kein Konto erforderlich. Perfekt für einmalige Meetings.", gMe = "E-Mail Adresse", hMe = "Bitte geben Sie eine gültige Emaildresse ein", vMe = " Bitte planen Sie einen Anruf in der Zukunft ein, falls wir nicht innerhalb von {{seconds}} Sekunden verfügbar sind", bMe = "Ort", yMe = "Adresse", $Me = "Geben Sie eine Adresse ein", wMe = "Vor Ort (Adresse von Ihnen)", kMe = "Anderer Ort", SMe = "Benutzerdefinierter Teilnehmerort", EMe = "Als Gast fortfahren", xMe = "Als Gast beitreten", CMe = "Ideal für einmalige Anrufe", TMe = "Beliebiger Ort", AMe = "Ja", IMe = "Nein", OMe = "Zusätzliche Notizen", NMe = "Termin konnte nicht gebucht werden.", zMe = "Termin konnte nicht neugeplant werden.", RMe = "Bitten teilen Sie Notizen zur Vorbereitung des Termins, falls nötig.", PMe = "Bestätigen Sie {{eventTypeTitle}} mit {{profileName}}", DMe = "Planen Sie Ihr {{eventTypeTitle}} mit {{profileName}} um", LMe = "Vor-Ort-Termin", MMe = "Vor Ort (Organisator-Adresse)", FMe = "Termin verknüpfen", qMe = "Telefonnummer", jMe = "Telefonnummer", VMe = "Telefonnummer des Organisators", BMe = "Telefonnummer eingeben", UMe = "Neuplanen", GMe = "Stattdessen verschieben", WMe = "Teammitglied stattdessen buchen", HMe = "ODER", YMe = "Zurück", KMe = "E-Mail oder Benutzername", ZMe = "Einladungs-E-Mail senden", XMe = "Rolle", JMe = "Rolle bearbeiten", QMe = "Rolle anzeigen", e4e = "Team bearbeiten", t4e = "Benutzer bearbeiten", n4e = "Organisation bearbeiten", o4e = "Wenn du deine Webhooks bearbeiten oder verwalten möchtest, gehe bitte zu den <0>Webhook-Einstellungen</0>", r4e = "Ablehnen", i4e = "Alle ablehnen", a4e = "Annehmen", s4e = "Verlassen", c4e = "Profil", l4e = "Meine Team-URL", u4e = "Meine Teams", d4e = "Teamname", _4e = "Ihr Teamname", p4e = "Team erfolgreich aktualisiert", m4e = "Ihr Team wurde erfolgreich aktualisiert.", f4e = "Ihre Org wurde erfolgreich aktualisiert.", g4e = "Fehler beim Kopieren in die Zwischenablage", h4e = "Beschreibung", v4e = "Ein paar Sätze über Ihr Team auf der öffentlichen Teamseite.", b4e = "Organisations-ID", y4e = "Organisations-ID kopiert.", $4e = "Ein paar Sätze zu Ihrer Organisation. Dies wird auf der URL-Seite Ihrer Organisation erscheinen.", w4e = "Team-ID", k4e = "Team-ID kopiert.", S4e = "Mitglieder", E4e = "Mitglieder der Organization", x4e = "Mitglied", C4e = "{{count}} Mitglied", T4e = "{{count}} Mitglieder", A4e = "{{count}} ausgewählt", I4e = "Inhaber", O4e = "Administrator", N4e = "Admin API", z4e = "Administrator Benutzer", R4e = "Lass uns als erstes den Administrator Benutzer anlegen.", P4e = "Administrator-Benutzereinrichtung", D4e = "Sie haben bereits einen Administrator-Benutzer erstellt. Sie können sich nun in Ihr Konto einloggen.", L4e = "Neues Mitglied", M4e = "Einladen", F4e = "Teammitglieder hinzufügen", q4e = "Mitglieder hinzufügen", j4e = "Lade andere ein, deinem Team beizutreten", V4e = "Teammitglied hinzufügen", B4e = "Ein neues Mitglied einladen", U4e = "Hinweis: Dies wird <0>einen zusätzlichen Platz (15$/Monat)</0> in deinem Abonnement kosten.", G4e = "Laden Sie jemanden in Ihr Team ein.", W4e = "Eine .csv-Datei hochladen", H4e = "Per E-Mail einladen", Y4e = "Rolle des Teammitglieds ändern", K4e = "{{appName}}-Branding deaktivieren", Z4e = "Blendet alle {{appName}}-Werbung auf Ihren öffentlichen Seiten aus.", X4e = "„Ein Teammitglied buchen“-Schaltfläche ausblenden", J4e = "Blendet die „Ein Teammitglied buchen“-Schaltflächen auf Ihren öffentlichen Seiten aus.", Q4e = "Achtung", e5e = "Seien Sie vorsichtig. Die Kontolöschung kann nicht rückgängig gemacht werden.", t5e = "Seien Sie vorsichtig. Die Teamlöschung kann nicht rückgängig gemacht werden.", n5e = "Zurück", o5e = "Stornieren", r5e = "Alle verbleibenden absagen", i5e = "Anwenden", a5e = "Termin absagen", s5e = "Bestätigen", c5e = "Alle bestätigen", l5e = "Team auflösen", u5e = "Bist du sicher, dass du dieses Team auflösen möchtest? Jeder der diesen Team-Link erhalten hat, kann Sie nicht mehr buchen.", d5e = "Organization auflösen", _5e = "Sind Sie sicher, dass Sie diese Organisation auflösen möchten? Alle Teams und Mitglieder werden gelöscht.", p5e = "Sind Sie sicher, dass Sie dieses Mitglied aus dem Team entfernen möchten?", m5e = "Ja, Team auflösen", f5e = "Ja, Mitglied entfernen", g5e = "Ja, Abonnement kündigen", h5e = "Abonnement kündigen", v5e = "Durch die Kündigung Ihres Abonnements wird Ihr aktueller Plan dauerhaft deaktiviert. Diese Aktion kann nicht rückgängig gemacht werden.", b5e = "Mitglied entfernen", y5e = "Team verwalten", $5e = "Sie haben noch keine Teams.", w5e = "Teams ermöglichen Termine zu buchen, an denen mehrere Mitarbeiter beteiligt sind.", k5e = "Abschicken", S5e = "Ja, Attribut entfernen", E5e = "Attribut entfernen", x5e = "Sind Sie sicher, dass Sie das Attribut '{{name}}' entfernen möchten? Alle Benutzer, die derzeit zugewiesen sind, werden abgemeldet.", C5e = "Aktualisieren", T5e = "Speichern", A5e = "Ausstehend", I5e = "Optionen öffnen", O5e = "Link kopieren", N5e = "Teilen", z5e = "Können Sie einen Termin in meinem Kalender reservieren oder mir Ihren Kalender zukommen lassen?", R5e = "Link zum Team kopieren", P5e = "Team verlassen", D5e = "Ja, Team verlassen", L5e = "Sind Sie sicher, dass Sie dieses Team verlassen möchten? Sie können dann nicht mehr über dieses Team gebucht werden.", M5e = "{{user}} von {{team}}", F5e = "Vorschau", q5e = "Link kopiert!", j5e = "Kopiert!", V5e = "Privater Link kopiert!", B5e = "Link geteilt!", U5e = "Titel", G5e = "Beschreibung", W5e = "Apps-Status", H5e = "Ein schnelles Video-Meeting.", Y5e = "Termintyp", K5e = "Teamvorschau", Z5e = "Kollektiv", X5e = "Planen Sie Meetings, bei denen alle ausgewählten Teammitglieder verfügbar sind.", J5e = "Dauer", Q5e = "Verfügbare Laufzeiten", e6e = "Standardlaufzeit", t6e = "Bitte wählen Sie zuerst die verfügbaren Laufzeiten aus", n6e = "{{count}} $t(minute_timeUnit)", o6e = "{{count}} $t({{unit}}_timeUnit)", r6e = "{{count}}$t({{unit}}_short)", i6e = "Minuten", a6e = "Benutzen Sie Cal.ai, um eine KI-betriebene Nummer zu erhalten oder Anrufe an Gäste zu tätigen.", s6e = "Termination-URI", c6e = "SIP-Trunk-Benutzername", l6e = "SIP-Trunk-Passwort", u6e = "Spitzname", d6e = "Telefonnummer löschen", _6e = "Workflow-Validierung fehlgeschlagen", p6e = "Ein oder mehrere Workflow-Schritte haben leere Nachrichteninhalte", m6e = "Eine oder mehrere Telefonnummern oder E-Mail-Adressen sind nicht verifiziert", f6e = "Optimiere deine Arbeitsabläufe mit Cal.ai", g6e = "Lebensechte KI-Agenten, die Meetings buchen, Erinnerungen senden und mit deinen Kunden Nachfassen.", h6e = "Telefonnummer erfolgreich importiert und mit Agent verknüpft", v6e = "Telefonnummer erfolgreich gelöscht", b6e = "Sind Sie sicher, dass Sie diese Telefonnummer löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.", y6e = "Ja, Telefonnummer löschen", $6e = "Die Nummer, die Sie importieren möchten, muss im E.164-Format sein (+Ländervorwahl gefolgt von der Nummer, ohne Leerzeichen oder Sonderzeichen), z.B. +1234567890", w6e = "Die Termination-URI zur eindeutigen Identifizierung Ihres elastischen SIP-Trunks. Diese wird für ausgehende Anrufe verwendet. Bei Twilio elastischen SIP-Trunks endet sie immer mit .pstn.twilio.com.", k6e = "Der Benutzername zur Authentifizierung des SIP-Trunks.", S6e = "Das Passwort zur Authentifizierung des SIP-Trunks.", E6e = "Spitzname der Nummer. Dies dient nur zu Ihrer Information.", x6e = "Speichern und Testanruf", C6e = "Anruf erfolgreich eingeleitet", T6e = "Bitte geben Sie eine Telefonnummer ein", A6e = "Agent erfolgreich aktualisiert", I6e = "Agent erfolgreich erstellt", O6e = "Ereignistyp erfolgreich hinzugefügt", N6e = "Telefonnummer erfolgreich abgemeldet", z6e = "Dieser Prompt definiert die Rolle und die primären Ziele des Agenten", R6e = "Prompt", P6e = "Anrufen", D6e = "Testanruf zur Überprüfung der Konfiguration durchführen", L6e = "Erste Nachricht", M6e = "Die erste Nachricht, die der Agent beim Starten eines Anrufs sagen wird", F6e = "Probleme beim Importieren?", q6e = "Erfahren", j6e = "Erfahren Sie, wie Sie Ihre Termination URI und SIP-Trunk-Anmeldedaten erhalten", V6e = "Telefonnummer-Abonnement erfolgreich gekündigt", B6e = "Aktualisierung läuft", U6e = "Round Robin", G6e = "Hallo, wie geht es dir?", W6e = "Treffen zwischen mehreren Teammitgliedern durchwechseln.", H6e = "Verwaltetes Ereignis", Y6e = "Benutzername", K6e = "Erstellen und verteilen Sie Ereignistypen im Block an Teammitglieder", Z6e = "Verwaltet", X6e = "„Benutzername“ wird mit dem Benutzernamen der zugewiesenen Mitglieder ausgefüllt", J6e = "Zuordnen zu", Q6e = "Telefonnummer für Testanruf eingeben", eFe = "Testanruf durchführen", tFe = "Neuen Cal.ai Voice-Agenten für Workflow erstellen", nFe = "Erstellen Sie einen neuen Cal.ai Voice-Agenten für Workflow, um Ihre Arbeitsabläufe zu automatisieren", oFe = "Telefonnummer (für unseren Agenten zum Anrufen)", rFe = "Kaufen Sie eine Telefonnummer oder importieren Sie eine, die Sie bereits bei Twilio haben", iFe = "Agent testen", aFe = "Web-Anruf testen", sFe = "Telefonnummern", cFe = "Abmelden", lFe = "Workflow-Schritt löschen", uFe = "Telefonnummer abmelden", dFe = "Neue Nummer kaufen", _Fe = "Sie können nur US-Telefonnummern kaufen. Für andere Länder können Sie Ihre eigene Twilio-Telefonnummer importieren.", pFe = "Kaufen Sie eine US-Nummer für ${{priceInDollars}} pro Monat", mFe = "Unterstützte Anrufziele", fFe = "Keine Telefonnummer verbunden", gFe = "Workflow-Schritt-ID konnte nicht abgerufen werden", hFe = "Cal.ai Agent", vFe = "Cal.ai Agent testen", bFe = "Sind Sie sicher, dass Sie diesen Workflow-Schritt löschen möchten?", yFe = "Möchten Sie die Telefonnummer wirklich von diesem Agent abmelden?", $Fe = "Diese Aktion wird die Telefonnummer vom Agent trennen. Der Agent kann keine Anrufe tätigen, bis eine neue Telefonnummer verbunden wird.", wFe = "Telefonnummern", kFe = "Telefonnummer verbinden", SFe = "Verwalte deine Telefonnummern", EFe = "Nummer importieren", xFe = "Diese Aktion wird auch:", CFe = "Telefonnummer importieren", TFe = "Aktives Abonnement", AFe = "Ihr Telefonnummer-Abonnement kündigen", IFe = "Die zugehörige Telefonnummer löschen", OFe = "Sie sind nicht berechtigt, diesen Workflow zu erstellen", NFe = "Importiere deine Twilio-Telefonnummer zur Verwendung mit Telefon", zFe = "${{price}}/Monat", RFe = "Neue Nummer kaufen", PFe = "Der Kauf einer Telefonnummer kostet ${{priceInDollars}} pro Monat. Ihnen wird monatlich für jede aktive Telefonnummer eine Gebühr berechnet.", DFe = "Vorwahl (Optional)", LFe = "Keine Telefonnummern", MFe = "Telefonnummer erfolgreich erworben", FFe = "Telefonnummer-Abonnement kündigen", qFe = "Ja, Abonnement kündigen", jFe = "Sind Sie sicher, dass Sie dieses Telefonnummer-Abonnement kündigen möchten? Diese Aktion kann nicht rückgängig gemacht werden und Sie verlieren den Zugriff auf diese Telefonnummer.", VFe = "Mitglieder hinzufügen...", BFe = "Mitglieder hinzufügen", UFe = "Keine zugeordneten Mitglieder", GFe = "Zugeordnet zu", WFe = "Sie müssen bei {{url}} angemeldet sein", HFe = "Mit der Zuordnung von Mitgliedern oben beginnen", YFe = "Mitglieder werden dies nicht bearbeiten können", KFe = "Mitglieder können bearbeiten", ZFe = "Diese Option wurde vom Team-Admin gesperrt", XFe = "Vom Team-Admin entsperrt", JFe = "URL", QFe = "Versteckt", eqe = "Schreibgeschützt", tqe = "Einmaliger Link", nqe = "Sie haben gerade den Tarif: {{plan}}.", oqe = "Aktualisieren Sie Ihr Konto auf den Pro-Plan, um alle Funktionen freizuschalten.", rqe = "Sie müssen Ihr Paket upgraden, um mehr als einen aktiven Ereignistyp zu haben.", iqe = "Du musst deinen Plan upgraden, um ein Team zu erstellen.", aqe = "Sie können <1>hier upgraden</1>.", sqe = "Ereignistypen", cqe = "Erstellen Sie teilbare Termine, die andere Personen buchen können.", lqe = "Neuer Ereignistyp", uqe = "Erstellen Sie Ihren ersten Ereignistyp", dqe = "Mit Ereignistypen kann man verfügbare Zeiten im Kalendar freigeben, die andere Personen dann buchen können.", _qe = "{{eventTypeTitle}} Ereignistyp erfolgreich erstellt", pqe = "{{eventTypeTitle}} Termintyp erfolgreich aktualisiert", mqe = "Termintyp erfolgreich gelöscht", fqe = "Stunden", gqe = "Personen", hqe = "Ihre E-Mail-Adresse", vqe = "Profilbild ändern", bqe = "Avatar hochladen", yqe = "Sprache", $qe = "Zeitzone", wqe = "Erster Tag der Woche", kqe = "Wiederholt sich bis zu {{count}} mal", Sqe = "Wiederholt sich bis zu {{count}} mal", Eqe = "Alle {{freq}} für", xqe = "{{count}} Ereignis übrig", Cqe = "{{count}} Termine übrig", Tqe = "Wiederholt sich alle", Aqe = "Vorkommnis", Iqe = "Vorkommnisse", Oqe = "Woche", Nqe = "Wochen", zqe = "Monat", Rqe = "Monate", Pqe = "Jahr", Dqe = "Jahre", Lqe = "{{count}} mehr", Mqe = "Maximal", Fqe = "Einzelnes Theme", qqe = "Markenfarbe", jqe = "Markenfarbe (Helles Theme)", Vqe = "Markenfarbe (Dunkles Theme)", Bqe = "Ereignistyp-Farbe (Helles Design)", Uqe = "Ereignistyp-Farbe (Dunkles Design)", Gqe = "Datei heißt nicht [idOrSlug]/[user]", Wqe = "Team erstellen", Hqe = "Name", Yqe = "Namenloses Team", Kqe = "OAuth-Clients", Zqe = "Verwalten Sie OAuth-Clients für Ihre Organisation", Xqe = "OAuth-Client erstellen", Jqe = "Erstellen Sie einen neuen OAuth-Client für Drittanbieter-Integrationen", Qqe = "OAuth-Client erfolgreich gelöscht", eje = "Erstellen Sie ein neues Team, um mit anderen zusammenzuarbeiten.", tje = "Ein neues Team erstellen", nje = "URL Ihrer Buchungsseite", oje = "URL der Seite, auf der Ihre Nutzer ihre Buchung stornieren können", rje = "URL der Seite, auf der Ihre Nutzer ihre Buchung umplanen können", ije = "Dieser Zeitraum ist nicht mehr verfügbar. Bitte kehren Sie zur vorherigen Seite zurück und wählen Sie eine andere Zeit.", aje = "Offene Einladungen", sje = "Neues Team", cje = "Erstellen Sie Ihr erstes Team und laden Sie andere Benutzer ein, zusammenzuarbeiten.", lje = "Erstellen Sie ein Team um loszulegen", uje = "Teams", dje = "Team", _je = "Organization", pje = "Abrechnung der Teams", mje = "Verwalte die Abrechungen deines Teams", fje = "Wir haben die Abrechnung für Teams geändert", gje = "Es gibt Mitglieder in Ihrem Team ohne Lizenz. Upgraden Sie Ihren Pro-Plan um fehlende Lizenzen abzudecken.", hje = "Ab Januar 2022 berechnen wir pro Sitzplatz für Teammitglieder. Mitglieder deines Teams, die Pro kostenlos hatten, sind jetzt in einer 14 Tage Testphase. Sobald die Testversion abläuft, werden diese Mitglieder vor Ihrem Team verborgen, es sei denn, Sie upgraden jetzt.", vje = "Erstellen und verwalten Sie Teams, um kollaborative Funktionen zu nutzen.", bje = "Diese Funktion ist nur im Pro Plan verfügbar", yje = "Um das {{appName}}-Branding von Ihren Buchungsseiten zu entfernen, müssen Sie auf ein Pro-Konto upgraden.", $je = "Bearbeiten Sie Ihre Profilinformationen, welche bei Ihrem Cal-Link angezeigt werden.", wje = "Möglicherweise müssen Sie sich aus- und einloggen, um die Änderung wirksam zu machen.", kje = "Ein wenig über sich selbst.", Sje = "Profil erfolgreich aktualisiert", Eje = "Ihr Benutzerprofil wurde erfolgreich aktualisiert.", xje = "Ihr Upgrade ist da", Cje = "Verbessern Sie Ihr Buchungserlebnis durch ein Upgrade auf den neuen Plan und genießen Sie die neuen Funktionen.", Tje = "Alles ist eingerichtet", Aje = "Sie nutzen bereits den aktuellsten Plan. Kein Upgrade erforderlich. Genießen Sie die neuen Funktionen und kontaktieren Sie uns bei Fragen!", Ije = "Benutzer scheint eingeloggt zu sein, kann aber nicht in der Datenbank gefunden werden", Oje = "Einbetten & Webhooks", Nje = "Aktiviert", zje = "Deaktiviert", Rje = "Deaktivieren", Pje = "Abrechnung", Dje = "hier", Lje = "Verwalten Sie Ihre Rechnungsinformationen und kündigen Sie Ihr Abonnement.", Mje = "Verfügbarkeit", Fje = "Verfügbarkeit bearbeiten", qje = "Konfigurieren Sie die Zeiten, in denen Sie für Buchungen zur Verfügung stehen.", jje = "Zeiten kopieren in", Vje = "Kopiere Zeiten nach …", Bje = "Wöchentliche Termine ändern", Uje = "Logo", Gje = "Fehler", Wje = "Bitte geben Sie wenigstens ein Zeichen ein", Hje = "Bitte geben Sie mindestens {{count}} Zeichen ein", Yje = "Team-Logo", Kje = "Standort hinzufügen", Zje = "Teilnehmende", Xje = "Teilnehmende hinzufügen", Jje = "Erweiterte Einstellungen anzeigen", Qje = "Erweiterte Einstellungen ausblenden", eVe = "Termin-Name", tVe = "Ereignisname im Kalender", nVe = "Der Name, der in Kalendern angezeigt wird", oVe = "Meeting mit {{attendeeName}}", rVe = "Zusätzliche Notizen", iVe = "Erfordert die Eingabe zusätzlicher Eingaben durch den Planer vor der Terminbestätigung", aVe = "Bezeichnung", sVe = "Platzhalter", cVe = "„Zum Kalender hinzufügen“-E-Mail als Organisator anzeigen", lVe = "Wir werden diese E-Mail-Adresse als Veranstalter anzeigen und Bestätigungs-E-Mails hierhin senden.", uVe = 'Wenn aktiviert, werden wir die E-Mail-Adresse aus Ihrem "Zum Kalender hinzufügen" als Organisator anzeigen und dort Bestätigungs-E-Mails senden', dVe = "Bitte beachten Sie, dass Sie möglicherweise die Verbindung trennen und anschließend Ihr „Zum Kalender hinzufügen“-Konto erneut verbinden müssen, um diese Funktion nutzen zu können.", _Ve = "Typ", pVe = "Bearbeiten", mVe = "Eingabe hinzufügen", fVe = "Notizen im Kalender ausblenden", gVe = "Aus Datenschutzgründen werden zusätzliche Eingaben und Notizen im Kalendereintrag ausgeblendet. Sie werden trotzdem an Ihre E-Mail gesendet.", hVe = "Die Buchung muss manuell bestätigt werden, bevor die Buchungsinformationen an die Integrationen weitergeleitet werden und eine Bestätigungsmail gesendet wird.", vVe = "Unbestätigte Buchungen blockieren trotzdem Kalenderslots.", bVe = "Wiederkehrender Termin", yVe = "Personen können sich für wiederkehrende Termine anmelden", $Ve = "Verbinden und beitreten", wVe = "Es kann nicht mit bezahlten Ereignistypen verwendet werden", kVe = "Softige Meetings werden von wiederkehrenden Ereignissen und Zahlungs-Apps noch nicht unterstützt", SVe = "Experimentell: „Sofortiges Meeting“-Ereignisse sind derzeit eine experimentelle Funktion.", EVe = "Beginnen", xVe = "Gäste deaktivieren", CVe = "Das Hinzufügen zusätzlicher Gäste deaktivieren.", TVe = "Privaten Link generieren", AVe = "Private URL aktivieren", IVe = "Privater Link", OVe = "Ihr privater Link wird nach jeder Nutzung neu generiert", NVe = "Privaten Link kopieren", zVe = "Privaten Link zum Ereignis kopieren", RVe = "Erzeugen Sie einen privaten Link, den Sie teilen können, ohne Ihren {{appName}}-Benutzername preiszugeben", PVe = "Private Links", DVe = "Generieren Sie private URLs ohne den Benutzernamen preiszugeben, mit konfigurierbaren Ablauf- und Nutzungsbeschränkungen", LVe = "Neuen Link hinzufügen", MVe = "Privater Link kopiert", FVe = "Teilnehmende können folgendes buchen", qVe = "Datumszeitraum", jVe = "Kalendertage", VVe = "Werktage", BVe = "Adresse oder Ort festlegen", UVe = "Einen Link zum Termin setzen", GVe = "Kann nicht umgeschaltet werden. Kann nur für untergeordnete Ereignistypen freigeschaltet werden", WVe = "{{appName}} wird Ihren Teilnehmer bitten, vor der Planung eine Telefonnummer einzugeben.", HVe = "{{appName}} wird einen Google Meet Ort zur Verfügung stellen.", YVe = "{{appName}} wird eine Zoom Meeting URL zur Verfügung stellen.", KVe = "{{appName}} wird eine Tandem Meeting URL zur Verfügung stellen.", ZVe = "{{appName}} wird eine Video-Meeting URL zur Verfügung stellen.", XVe = "Cal stellt eine Jitsi Meet URL zur Verfügung.", JVe = "{{appName}} wird eine Huddle01 Video-Meeting URL zur Verfügung stellen.", QVe = "{{appName}} wird eine MS Teams Meeting-URL zur Verfügung stellen. HINWEIS: SIE BRAUCHEN EIN BERUFS- ODER SCHULKONTO", eBe = "Zahlung erforderlich", tBe = "Sie müssen einen Namen hinzufügen", nBe = "Provision pro Transaktion", oBe = "Ihr Termintyp wurde erfolgreich aktualisiert.", rBe = "Termintyp ausblenden", iBe = "Standort bearbeiten", aBe = "in die Zukunft", sBe = "Bei Buchung mit weniger als <0></0> Vorlaufzeit", cBe = "Innerhalb eines Zeitraums", lBe = "Auf unbestimmte Zeit in die Zukunft", uBe = "Neues individuelles Eingabefeld hinzufügen", dBe = "Schneller Chat", _Be = "Neuen Termintyp hinzufügen", pBe = "Neuen Termintyp hinzufügen", mBe = "Erstellen Sie einen neuen Termintyp, mit dem Personen Zeiten buchen können.", fBe = "Länge", gBe = "Mindestvorlaufzeit für eine Buchung", hBe = "Versetzte Startzeiten", vBe = "Versetzt die den Buchern angezeigten Zeitfenster um eine bestimmte Anzahl von Minuten", bBe = "Versetzt um", yBe = "z.B. wird dies Zeitfenster für Ihre Bucher um {{ adjustedTime }} statt {{ originalTime }} anzeigen", $Be = "Zeit-Slot-Intervalle", wBe = "Verwende Terminlänge (Standard)", kBe = "Ereignistyp löschen?", SBe = "Verwalteten Ereignistyp löschen?", EBe = "Jede Person, mit der Sie diesen Link geteilt haben, kann nicht mehr über den Link buchen.", xBe = "Mitglieder, die diesem Ereignistyp zugewiesen sind, werden ebenfalls ihre Ereignistypen gelöscht bekommen.", CBe = "Jeder, mit dem sie ihren Link geteilt haben, wird diesen nicht mehr zur Buchung verwenden können.", TBe = "Ja, löschen", ABe = "Account löschen", IBe = "Ja, Account löschen", OBe = "Sie können dann nicht mehr über Ihre geteilten Links gebucht werden und alle Einstellungen werden gelöscht.", NBe = "Integrationen", zBe = "Apps", RBe = "Hier finden Sie eine Liste Ihrer Apps", PBe = "App-Listing", DBe = "{{category}} Apps", LBe = "App Store", MBe = "Verbindet Menschen, Technologie und den Arbeitsplatz.", FBe = "Verbinden Sie Ihre Videokonferenz-App", qBe = "Einstellungen", jBe = "Die Daten wurden erfolgreich gespeichert", VBe = "Nächster Schritt", BBe = "Schritt überspringen", UBe = "Vorheriger Schritt", GBe = "Installieren", WBe = "Kostenlose Testphase starten", HBe = "Installiert", YBe = "{{count}} aktive Installation", KBe = "{{count}} aktive Installationen", ZBe = "Global installiert", XBe = "App erfolgreich installiert", JBe = "App konnte nicht installiert werden", QBe = "Trennen", e9e = "Fügen Sie Ihren Kalender in Ihre Webseite ein", t9e = "Verbinden Sie Ihre Lieblings-Apps.", n9e = "Automatisierung", o9e = "Konfigurieren Sie, wie Ihre Termin-Typen mit Ihren Kalendern interagieren sollen.", r9e = "Wechseln Sie die Kalender in denen nach Konflikten gesucht werden sollen, um Doppelbuchungen zu vermeiden.", i9e = "Zusätzlichen Kalender verbinden", a9e = "Kalender erfolgreich aktualisiert", s9e = "Hier auswählen", c9e = "Videokonferenzen", l9e = "Kalender", u9e = "Zahlungen", d9e = "Nicht installiert", _9e = "Passwörter stimmen nicht überein.", p9e = "Dieses Feld ist erforderlich.", m9e = "Status", f9e = "Verfügbarkeit des Benutzers anzeigen", g9e = "Der Benutzer muss die Einladung annehmen, um freie Termine zu sehen", h9e = "Stelle deinen Status auf Abwesend", v9e = "Abwesenheitsstatus deaktivieren", b9e = "Fehler beim Aktualisieren des Abwesenheitsstatus", y9e = "Dieser Benutzer ist derzeit abwesend.", $9e = "Die Person, mit der Sie einen Termin buchen wollen, ist zur Zeit abwesend und akzeptiert daher keine neuen Buchungen.", w9e = "Triff Leute mit den selben Token", k9e = "Nur Buchungen von Personen erlauben, die die gleichen Token, DAOs oder NFTs teilen.", S9e = "Ihr Konto wurde mit einem Identitäts-Anbieter erstellt.", E9e = "Ihr Konto wird verwaltet von {{provider}}", x9e = "Um Ihre E-Mail-Adresse, Ihr Passwort, die Zwei-Faktor-Authentifizierung und sonstiges zu ändern, besuchen Sie bitte Ihre {{provider}} -Kontoeinstellungen.", C9e = "Ihr Konto wird von einem anderen Identitätsanbieter verwaltet. Versuchen Sie, sich mit {{provider}} anzumelden.", T9e = "Fehler beim Erstellen eines neuen Benutzers. Bitte versuchen Sie es erneut.", A9e = "Mit Google anmelden", I9e = "Anmelden mit SAML", O9e = "Anmelden mit SAML/OIDC", N9e = "Mit E-Mail fortfahren", z9e = "Mit Google fortfahren", R9e = "Zuletzt verwendet", P9e = "Sie müssen ein Zugriffstoken in ihrem alten Kalender-Tool erzeugen.", D9e = "Importieren von", L9e = "Zugriffs-Token", M9e = "Roadmap", F9e = "Vorgestellte Kategorien", q9e = "Feature-Flags", j9e = "Hier können Sie die Funktionen Ihrer Cal.com-Instanz ein- und ausschalten.", V9e = "Beliebte Kategorien", B9e = "{{count}} Apps", U9e = "{{count}} Apps", G9e = "Angesagte Apps", W9e = "Am beliebtesten", H9e = "Installierte Apps", Y9e = "Kostenlos", K9e = "Keine {{category}} Apps", Z9e = "Alle Apps", X9e = "Fügen Sie eine Kalender-App hinzu, in der nach Konflikten gesucht werden soll, um Doppelbuchungen zu vermeiden", J9e = "Versuchen Sie, eine Konferenz-App für Videoanrufe mit Ihren Kunden hinzuzufügen", Q9e = "Fügen Sie eine Zahlungs-App hinzu, um die Transaktion zwischen Ihnen und Ihren Kunden zu erleichtern", eUe = "Fügen Sie eine Analyse-App für Ihre Buchungsseiten hinzu", tUe = "Fügen Sie eine Automatisierungs-App hinzu, die verwendet werden soll", nUe = "Füge jede beliebige andere Art von App hinzu, um alle möglichen Dinge zu tun", oUe = "Fügen Sie eine Nachrichten-App hinzu, um benutzerdefinierte Benachrichtigungen und Erinnerungen einzurichten", rUe = "Fügen Sie eine CRM-App hinzu, um einen Überblick über die Personen zu behalten, mit denen Sie sich getroffen haben", iUe = "Legen Sie den/die Kalender in denen nach Konflikten gesucht werden sollen fest, um Doppelbuchungen zu vermeiden.", aUe = "Konfigurieren Sie die Zahlungsdienstleister, welcher bei der Belastung Ihrer Kunden verwendet werden sollen.", sUe = "Konfigurieren Sie, welche Analyse-Apps für Ihre Buchungsseiten verwendet werden sollen", cUe = "Alle von Ihnen installierten Apps aus anderen Kategorien.", lUe = "Konfigurieren Sie, welche Konferenz-Apps verwendet werden sollen", uUe = "Konfigurieren Sie, welche Automatisierungs-Apps verwendet werden sollen", dUe = "Konfigurieren Sie zur Einrichtung benutzerdefinierter Benachrichtigungen und Erinnerungen, welche Nachrichten-Apps verwendet werden sollen", _Ue = "Konfigurieren Sie, welche CRM-Apps verwendet werden sollen, um einen Überblick über die Personen zu behalten, mit denen Sie sich getroffen haben", pUe = "Analyse", mUe = "Keine Apps installiert", fUe = "Apps erlauben es Ihnen, Ihren Arbeitsfluss zu verbessern und Ihre Planung viel besser zu gestalten.", gUe = "Durchsuchen Sie den App Store", hUe = "Verwalten Sie Ihre installierten Apps oder ändern Sie die Einstellungen", vUe = "Apps durchsuchen", bUe = "Funktionen", yUe = "Berechtigungen", $Ue = "Nutzungsbedingungen und Datenschutz", wUe = "Veröffentlicht von {{author}}", kUe = "Abonnieren", SUe = "Kaufen", EUe = "App installieren", xUe = "Kategorien", CUe = "Preise", TUe = "Mehr erfahren", AUe = "Jetzt ausprobieren", IUe = "Datenschutzerklärung", OUe = "Nutzungsbedingungen", NUe = "Entfernen", zUe = "Hinzufügen", RUe = "{{count}} installiert", PUe = "Wallet verifizieren", DUe = "Erstelle Termine in:", LUe = "Dies ist eine kommerzielle Funktion", MUe = "Sie können diese Funktion lokal testen, aber nicht in der Produktionsumgebung.", FUe = "Um eine kommerzielle Lizenz zu erwerben, wenden Sie sich bitte an unser Vertriebsteam. Falls bereits ein Lizenzschlüssel vorhanden ist, kontaktieren Sie bitte support@cal.com für Unterstützung.", qUe = "Lizenz fehlt", jUe = "Nächste Schritte", VUe = "Eine kommerzielle Lizenz erwerben", BUe = "Der Infrastrukturplan ist nutzungsbasiert und bietet Startup-freundliche Discounts an.", UUe = "Erstellen Sie ein Konto über Prisma Studio", GUe = "Erfahren Sie, wie Sie Ihren ersten Benutzer einrichten können", WUe = "Vertrieb kontaktieren", HUe = "Fehler 404", YUe = "Als Standard festlegen", KUe = "Neuer Verfügbarkeitsplan", ZUe = "Neuen Verfügbarkeitsplan hinzufügen", XUe = "Neuen Kalender hinzufügen", JUe = "Legen Sie fest, wo neue Events hinzugefügt werden sollen, wenn Sie ausgebucht sind.", QUe = "Verfügbarkeitsplan löschen", eGe = "Das Löschen eines Verfügbarkeitsplanes entfernt ihn von allen Termintypen. Diese Aktion kann nicht rückgängig gemacht werden.", tGe = "{{scheduleName}} -Verfügbarkeitsplan erfolgreich erstellt", nGe = "{{scheduleName}} Zeitplan erfolgreich aktualisiert", oGe = "Verfügbarkeitsplan erfolgreich gelöscht", rGe = "Arbeitszeiten", iGe = "Erstelle einen Verfügbarkeitsplan", aGe = "Das Erstellen eines Verfügbarkeitsplan sorgt dafür, dass Ihre Verfügbarkeit bei mehreren Termintypen genutzt werden kann.", sGe = "Erfordert Besitz eines Tokens, das zu der folgenden Adresse gehört:", cGe = "Max Mustermann", lGe = "Zeitformat", uGe = "Weiterleitung bei Buchung ", dGe = 'Sie werden in $t(second, {"count": {{seconds}} }) auf {{ url }} weitergeleitet.', _Ge = "https://example.com/redirect-to-my-success-page", pGe = "Nach erfolgreicher Buchung auf eine benutzerdefinierte URL weiterleiten", mGe = "Duplizieren", fGe = "Plätze anbieten", gGe = "Bieten Sie Plätze für Buchungen an (dies deaktiviert Gäste & Opt-in-Buchungen)", hGe = "Platz verfügbar", vGe = "Plätze verfügbar", bGe = "Plätze fast voll", yGe = "Plätze werden schnell belegt", $Ge = "Anzahl der Plätze pro Termin", wGe = "Beitrittszeitfenster festlegen (Sekunden): Der Zeitraum in Sekunden, in dem der Gastgeber beitreten und das Meeting starten kann. Nach dieser Zeit läuft die Beitritts-URL ab.", kGe = "Anzahl der Plätze eingeben", SGe = "Sie können Ihren Verfügbarkeitsplan bei Ihren Verfügbarkeiten ändern.", EGe = "Keine weiteren Plätze verfügbar", xGe = "API-Schlüssel", CGe = "API-Schlüssel", TGe = "API-Schlüssel testen", AGe = "Test bestanden!", IGe = "Test fehlgeschlagen", OGe = "API-Schlüssel bereitstellen", NGe = "Mit API-Schlüsseln können Sie API-Aufrufe für Ihren eigenen Account durchführen.", zGe = "Erstellen Sie stattdessen einen Marktplatz oder eine Plattform.", RGe = "Generieren Sie API-Schlüssel für den Zugriff auf Ihren eigenen Account.", PGe = "API-Schlüssel erstellen", DGe = "Diesen Schlüssel benennen", LGe = "z. B. „Entwicklung“", MGe = "API-Schlüssel ohne Namen", FGe = "Dieser API-Schlüssel hat kein Ablaufdatum", qGe = "API-Schlüssel bearbeiten", jGe = "API-Schlüssel erfolgreich erstellt", VGe = "API-Schlüssel erfolgreich aktualisiert", BGe = "Erstellen", UGe = "Speichern Sie diesen API-Schlüssel an einem sicheren Speicherort ab.", GGe = "Sie werden ihn nicht mehr anzeigen können, wenn Sie dieses Dialogfenster schließen.", WGe = "In Zwischenablage kopieren", HGe = "Nach der Aktualisierung aktiviert", YGe = "Der private Link funktioniert nach dem Speichern", KGe = "Diesen API-Schlüssel widerrufen", ZGe = "Umbuchung deaktivieren", XGe = "Gäste können die Veranstaltung nicht mehr über Kalendereinladung oder E-Mail umbuchen", JGe = "Buchung über Umbuchungslink erlauben", QGe = "Wenn aktiviert, können Benutzer eine neue Buchung erstellen, wenn sie versuchen, eine stornierte Buchung umzuplanen", eWe = "Stornierung deaktivieren", tWe = "Gäste können die Veranstaltung nicht mehr über Kalendereinladung oder E-Mail stornieren", nWe = "API-Schlüssel widerrufen", oWe = "API-Schlüssel kopiert!", rWe = "Der API-Schlüssel läuft ab am", iWe = "Diesen API-Schlüssel dauerhaft von Ihrem Konto entfernen?", aWe = "Kopieren", sWe = "Ablaufdatum", cWe = "Abgelaufen", lWe = "Läuft niemals ab", uWe = "Läuft ab", dWe = "Anfrage zur Neuplanung Ihrer Buchung", _We = "Grund für die Neuplanung", pWe = "Neue Zeit buchen", mWe = "Anfrage zur Neuplanung gesendet", fWe = "Damit wird das geplante Meeting abgesagt. Benachrichtigen Sie die Person, die das Meeting geplant hat, und bitten Sie sie, eine neue Zeit auszuwählen.", gWe = "Grund für die Anfrage zur Neuplanung", hWe = "Neuplanung anfordern ", vWe = "Buchung bearbeiten", bWe = "Buchung neu planen", yWe = "Vorherige Zeit", $We = "Gif für Bestätigungsseite", wWe = "Suche", kWe = "Imitieren", SWe = "Benutzeridentitätswechsel", EWe = "Erlaubt es unserem Support-Team, sich vorübergehend mit Ihrem Konto anzumelden, um jegliche Probleme, die Sie gemeldet haben, schneller zu lösen.", xWe = "Ermöglicht den Team-Administratoren, sich vorübergehend als Sie einzuloggen.", CWe = "Für Einzelpersonen kostenlos. Teampläne für kollaborative Funktionen.", TWe = "Organisation privat stellen", AWe = "Wenn diese Einstellung aktiv ist, können Ihre Organisationsmitglieder keine anderen Organisationsmitglieder sehen.", IWe = "Team privat stellen", OWe = "Wenn diese Einstellung aktiv ist, können deine Teammitglieder keine anderen Teammitglieder sehen.", NWe = "Sie können nicht alle Teammitglieder eines privaten Teams sehen.", zWe = "Du kannst keine Teams einer privaten Organisation sehen.", RWe = "Mehrere Dauern erlauben", PWe = "Alle Verwendungen dieser Funktion werden geprüft.", DWe = "Imitiere den Account {{user}}.", LWe = "Klicken Sie hier, um zu stoppen", MWe = "Aktualisiert - Ihr Termin hat den Standort geändert", FWe = "Hinzugefügt - Neue Gäste zu Ihrem Ereignis hinzugefügt", qWe = "Ort geändert: {{eventType}} mit {{name}} am {{date}}", jWe = "Gäste hinzugefügt: {{eventType}} mit {{name}} am {{date}}", VWe = "Aktueller Ort", BWe = "Neuer Ort", UWe = "Sitzung", GWe = "Verwalten Sie Ihre Kontositzung", WWe = "Zeitüberschreitung der Sitzung nach", HWe = "Zeitüberschreitung der Sitzung", YWe = "Erklärt nach einer bestimmten Zeit Ihre Sitzung für ungültig.", KWe = "Kein Ort definiert", ZWe = "Ort festlegen", XWe = "Ort aktualisieren", JWe = "Ort aktualisiert", QWe = "Aktualisierung des Standorts fehlgeschlagen", e8e = "Gäste hinzugefügt", t8e = "Gäste konnten nicht hinzugefügt werden", n8e = "Das sieht nicht wie eine E-Mail-Adresse aus", o8e = "E-Mail-Adressen müssen eindeutig und gültig sein", r8e = "Das sieht nicht wie eine gültige URL aus", i8e = "Kopieren Sie diesen Code an die Stelle in Ihrem HTML, an der Ihr {{appName}}-Widget erscheinen soll.", a8e = "Erstellen oder Aktualisieren einer existierenden Reaktionskomponente wie unten gezeigt.", s8e = "Code kopieren", c8e = "Code kopiert!", l8e = "Wie möchten Sie {{appName}} zu Ihrer Website hinzufügen?", u8e = "Wählen Sie eine der folgenden Möglichkeiten, um {{appName}} in Ihre Website zu integrieren.", d8e = "Einrichtung Ihrer Zapier-Integration", _8e = "Einrichtung Ihrer Make-Integration", p8e = "Api Key generieren", m8e = "Generieren Sie einen API-Schlüssel für {{appName}} unter", f8e = "Ihr eindeutiger API-Key", g8e = "Kopieren Sie diesen API-Schlüssel und speichern Sie ihn an einem sicheren Ort. Wenn Sie diesen Schlüssel verlieren, müssen Sie einen neuen generieren.", h8e = "<0>Loggen Sie sich in Ihr Zapier-Konto ein und erstelle einen neuen Zap.</0><1>Wählen Sie Cal.com als ihre Trigger-App aus. Wählen Sie auch ein Auslöserereignis.</0></1>Wählen Sie ihr Konto aus und geben dann ihren eindeutigen API-Key ein.</2><3>Testen Sie den Trigger.</3><4>Alles fertig!</4>", v8e = "Gehe zu <0>Make Einladungslink</0> und installiere die Cal.com-App.", b8e = "Melde dich bei deinem Make-Konto an und erstelle ein neues Szenario.", y8e = "Wähle Cal.com als deine Trigger-App. Wähle auch ein Trigger-Ereignis.", $8e = "Wähle dein Konto und gib dann deinen einzigartigen API-Schlüssel ein.", w8e = "Teste deinen Trigger.", k8e = "Du bist fertig!", S8e = "Bitte installieren Sie zuerst die Zapier-App im App Store.", E8e = "Bitte installieren Sie zuerst die Make-App im App Store.", x8e = "App-Installation", C8e = "App nicht installiert", T8e = "Entschuldigung, diese App ist nicht auf Ihrem Konto installiert. Bitte besuchen Sie unseren App-Store, um diese und andere großartige Apps zu entdecken und zu erkunden.", A8e = "Mit Apple-Server verbinden", I8e = "Kalender-URL", O8e = "Generieren Sie ein App-spezifisches Passwort für {{appName}} unter", N8e = "Dieses Apple-Kalender-Konto konnte nicht hinzugefügt werden. Bitte stellen Sie sicher, dass Sie ein app-spezifisches Passwort und nicht Ihr Konto-Passwort verwenden.", z8e = "Ihre Zugangsdaten werden verschlüsselt gespeichert.", R8e = "Er wird gespeichert und verschlüsselt.", P8e = "Zum App Store", D8e = "Etwas ist schiefgelaufen. Versuche deinen Kalender mit allen notwendigen Berechtigungen erneut zu verbinden", L8e = "Telefonnummer für den Termin festlegen", M8e = "Keine belegten Zeiten vorhanden", F8e = "Auf der Buchungsseite anzeigen", q8e = "Ort wird sichtbar sein, bevor die Buchung bestätigt wird", j8e = "GIF hinzufügen", V8e = "Giphy durchsuchen", B8e = "Giphy-Link hinzufügen", U8e = "GIF zur Bestätigungsseite hinzufügen", G8e = "Finden Sie GIFs, um Ihre Bestätigungsseite aufzupeppen", W8e = "Feedback teilen", H8e = "Ressourcen", Y8e = "Support Dokumentation", K8e = "Entwickler-Dokumentation", Z8e = "Kontakt aufnehmen", X8e = "Support kontaktieren", J8e = "Premium-Support", Q8e = "Community Support", e7e = "Feedback", t7e = "Vielen Dank für Ihr Feedback!", n7e = "Fehler beim Senden des Feedbacks", o7e = "Kommentare", r7e = "Buchungsdetails", i7e = "oder", a7e = "Abbrechen", s7e = "Gehe zu: ", c7e = "Zapier Einladungs-Link", l7e = "Eine Termin-URL wird angelegt, sobald der Termin bestätigt wurde.", u7e = "Zeigt dynamisch entweder Ihnen den Namen Ihres Teilnehmers bzw. Ihrer Teilnehmerin an oder zeigt Ihrem/Ihrer Teilnehmerin Ihren Namen an", d7e = "Ort des Termins", _7e = "Grund für die Verschiebung (optional)", p7e = "Lassen Sie andere wissen, warum Sie den Termin verschieben müssen", m7e = "Dieser Termin ist abgesagt", f7e = "Wir haben eine E-Mail an alle gesendet, um sie darüber zu informieren.", g7e = "Diese Eingabe wird bei der Buchung dieses Termins angezeigt", h7e = "Termin-URL ist in der Bestätigungsmail", v7e = "URL muss mit http:// oder https:// beginnen", b7e = "Telefonnummer wird angegeben", y7e = "vor Beginn des Termins", $7e = "wenn der Termin abgesagt wird", w7e = "Nachdem die Gastgeber nicht am Cal-Video teilgenommen haben", k7e = "Nachdem die Gäste nicht am Cal-Video teilgenommen haben", S7e = "Am Videoanruf teilnehmen", E7e = "Bei Cal.com anmelden", x7e = "Bei Cal.com anmelden", C7e = "Verfolgen Sie Ihre Meetings, erhalten Sie Benachrichtigungen und verwalten Sie Ihren Zeitplan effektiver.", T7e = "Verfolge deine Meetings und verwalte deinen Zeitplan effektiver", A7e = "Beitritt zum Anruf fehlgeschlagen. Bitte versuche es erneut.", I7e = "Wählen Sie, wie Sie an diesem Anruf teilnehmen möchten", O7e = "Wähle, wie du im Anruf erscheinen möchtest", N7e = "wenn ein neuer Termin gebucht wird", z7e = "E-Mail an den Veranstalter senden", R7e = "E-Mail an Teilnehmende senden", P7e = "SMS an Teilnehmende senden", D7e = "SMS an eine bestimmte Nummer senden", L7e = "Senden Sie Meeting-Erinnerungen einfach per SMS an Ihre Teilnehmer", M7e = "WhatsApp-Nachricht an eine bestimmte Nummer senden", F7e = "WhatsApp-Nachricht an Teilnehmer senden", q7e = "Workflows", j7e = "Neuer Workflow", V7e = "Wie möchtest du beginnen?", B7e = "Einen neuen Workflow hinzufügen", U7e = "wenn das Ereignis neu geplant wird", G7e = "Auslöser", W7e = "Auslöser", H7e = "Aktion", Y7e = "Workflows erstellen, um Benachrichtigungen und Erinnerungen zu automatisieren", K7e = "Workflow-Name", Z7e = "Eigener Workflow", X7e = "{{workflowName}} erfolgreich erstellt", J7e = "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?", Q7e = "Workflow löschen", eHe = "Ja, Workflow löschen", tHe = "Workflow erfolgreich gelöscht", nHe = "Wie lange bevor das Ereignis beginnt?", oHe = "Tage", rHe = "Stunden", iHe = "Minuten", aHe = "Min", sHe = "Std", cHe = "Erstellen Sie Ihren ersten Workflow", lHe = "Workflows ermöglichen Ihnen das automatisierte Versenden von Erinnerungen und Benachrichtigungen.", uHe = "Aktiv am", dHe = "{{workflowName}} Workflow erfolgreich aktualisiert", _He = "Dies ist ein Standard-Benutzername und die Aktualisierung führt Sie zur Rechnungsstellung, um ein Downgrade durchzuführen.", pHe = "Dies ist ein Premium-Benutzername, holen Sie sich Ihren für {{price}}", mHe = "Aktuell", fHe = "Premium", gHe = "Standard", hHe = "Änderung des Benutzernamens bestätigen", vHe = "Da Sie von einem Standard- zu einem Premium-Benutzernamen wechseln, werden Sie zum Upgrade zur Kasse gebracht.", bHe = "Da Sie von einem Premium- zu einem Standard-Benutzernamen wechseln, werden Sie zum Downgrade zur Kasse gebracht.", yHe = "Zur Abrechnung", $He = "Zahlung für Buchungen (0,5 % + 0,10 € Provision pro Transaktion)", wHe = "Ihre Testversion ist abgelaufen", kHe = "App entfernen", SHe = "Ja, App entfernen", EHe = "Sind Sie sicher, dass Sie diese App entfernen möchten?", xHe = "App erfolgreich entfernt", CHe = "Fehler beim Entfernen der App", THe = "Webkonferenz", AHe = "Web-Anruf", IHe = "Web-Anruf starten", OHe = "Anruf beenden", NHe = "Testen Sie Ihren Agenten mit einem Web-Anruf ohne Telefonnummer", zHe = "Telefonanruf", RHe = "Verbindung zum Agenten wird hergestellt...", PHe = "Anruf aktiv", DHe = "Anruf beendet", LHe = "Anruffehler", MHe = "Bereit zum Starten des Anrufs", FHe = "Web-Anruf konnte nicht gestartet werden. Bitte versuchen Sie es erneut.", qHe = "Bei dem Anruf ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", jHe = "Web-Anruf konnte nicht initialisiert werden. Bitte stellen Sie sicher, dass Mikrofonberechtigungen erteilt wurden.", VHe = "Starten Sie einen Anruf, um die Konversation zu sehen", BHe = "Warte auf Konversation...", UHe = "KI-Agent", GHe = "Live", WHe = "Verbinde...", HHe = "Erfordert Bestätigung", YHe = "Erfordert eine Bestätigung bei Buchung mit < {{time}} $t({{unit}}_timeUnit) Vorlauf", KHe = "Kann Bestätigung erfordern", ZHe = "{{count}} Ereignistyp", XHe = "{{count}} Ereignistypen", JHe = "{{count}} Team", QHe = "{{count}} Teams", eYe = "Aktion hinzufügen", tYe = "Whereby Link festlegen", nYe = "Bitte geben Sie einen gültigen Whereby Link ein", oYe = "Around.Co Link festlegen", rYe = "Bitte geben Sie einen gültigen Around Link ein", iYe = "Riverside Link festlegen", aYe = "Bitte geben Sie einen gültigen Riverside Link ein", sYe = "Bitte geben Sie einen gültigen Ping.gg Link ein", cYe = "Exchange 2013-Server verbinden", lYe = "Exchange 2016-Server verbinden", uYe = "Benutzerdefinierte Vorlage", dYe = "Inhalt", _Ye = "Textnachricht", pYe = "Haben Sie ein spezielles Problem", mYe = "Durchsuchen Sie unsere Dokumentation", fYe = "Vorlage auswählen", gYe = "Benutzerdefiniert", hYe = "Erinnerung", vYe = "Neu geplant", bYe = "Neu geplant von", yYe = "Ursprüngliche Buchung", $Ye = "Erledigt", wYe = "Bewertung", kYe = "Erinnerung: {{eventType}} mit {{name}} bei {{date}}", SYe = "Wird nicht für bereits bestehende Buchungen ausgelöst, da der Benutzer bei der Buchung nach einer Telefonnummer gefragt wird.", EYe = "{{count}} Minute", xYe = "{{count}}m", CYe = "{{count}} Minuten", TYe = "{{count}} Stunde", AYe = "{{count}}h", IYe = "{{count}} Stunden", OYe = "Ungültige Eingabe", NYe = "Wir konnten den {{location}}-Meeting-Link nicht zu deinem geplanten Ereignis hinzufügen. Kontaktiere deine Eingeladenen oder aktualisiere deinen Kalendereintrag, um die Details hinzuzufügen. Du kannst entweder <0>deinen Standort im Ereignistyp ändern</0> oder versuchen, <1>die App zu entfernen und erneut hinzuzufügen.</1>", zYe = "Wir konnten Ihren <1>{{calendar}}</1> nicht aktualisieren. <2> Bitte überprüfen Sie die Kalendereinstellungen oder entfernen Sie Ihren Kalender und fügen Sie Ihren Kalender erneut hinzu </2>", RYe = "Name des Teilnehmenden", PYe = "Der vollständige Name der buchenden Person", DYe = "Defekte Integration", LYe = "Beim Hinzufügen eines Video-Links ist ein Problem aufgetreten", MYe = "Es gab ein Problem beim Aktualisieren Ihres Kalenders", FYe = "Aktiv bei {{count}} Ereignistyp", qYe = "Aktiv bei {{count}} Termintypen", jYe = "Aktiv in {{count}} Team", VYe = "Aktiv in {{count}} Teams", BYe = "Aktiv für alle Ereignistypen", UYe = "Aktiv in allen Teams", GYe = "Keine aktiven Termintypen", WYe = "Keine aktiven Teams", HYe = "Neuer Teilnehmer {{name}} beim {{eventType}} am {{date}}", YYe = "Jemand hat sich zu einem Ereignis hinzugefügt", KYe = "Variable", ZYe = "Event Name", XYe = "Teilnehmer", JYe = "Event Datum", QYe = "Event Zeit", eKe = "Organisator Name", tKe = "Um diese Funktion nutzen zu können, müssen Sie ein Upgrade auf einen Pro-Account durchführen.", nKe = "Ungültige Telefonnummer", oKe = "Ungültige URL für {{label}}. Beispiel-URL: {{sampleUrl}}", rKe = "Navigieren", iKe = "Öffnen", aKe = "Schließen", sKe = "Upgraden", cKe = "US-Nummer für {{priceInDollars}}$/Monat kaufen", lKe = "Upgraden, um auf Aufnahmen zuzugreifen", uKe = "Aufnahmen sind nur als Teil unseres Teams-Plans verfügbar. Sie müssen upgraden, um Ihre Anrufe aufzuzeichnen", dKe = "Führen Sie ein Upgrade zum Enterprise-Plan durch, um eine KI-Agent-Telefonnummer zu generieren, die Gäste anrufen und Anrufe planen kann", _Ke = "Aufnahmen sind Teil des Teams-Plans", pKe = "Dies ist eine Team-Funktion. Sie müssen auf die Team-Version upgraden, um die Verfügbarkeit Ihres Teams zu sehen.", mKe = "Dies ist eine Team-Funktion. Sie müssen auf die Team-Version upgraden, um Ihre Termin-Benachrichtigungen und Erinnerungen mit Workflows zu automatisieren.", fKe = "Im Profil anzeigen", gKe = "Einbetten", hKe = "Neuer Benutzername", vKe = "Aktueller Benutzername", bKe = "Beispiel 1", yKe = "Beispiel 2", $Ke = "Buchungsfragenbezeichner", wKe = "Unternehmensgröße", kKe = "Wobei benötigen Sie Hilfe?", SKe = "Variablenformat", EKe = "Webhook Abonnenten-URL ist bereits definiert", xKe = "Ignorieren Sie alle Sonderzeichen der zusätzlichen Eingabebezeichnung (verwenden Sie nur Buchstaben und Zahlen), schreiben Sie alle Buchstaben groß und ersetzen Sie Leerzeichen durch Unterstriche.", CKe = "Wie verwende ich Buchungsfragen als Variablen?", TKe = "Desktop-App herunterladen", AKe = "Ping-Link festlegen", IKe = "Anmeldeversuchsgrenze überschritten", OKe = "Wenn etwas passiert", NKe = "Eine Aktion wird ausgeführt", zKe = "Aktion testen", RKe = "Benachrichtigung gesendet", PKe = "Kein Input", DKe = "Workflow-Aktion testen", LKe = "SMS versenden", MKe = "Sind Sie sicher, dass Sie eine SMS an {{number}} senden möchten?", FKe = "Kein Kalender verknüpft", qKe = "Sie können Ihren Kalender von <1>hier</1> verbinden.", jKe = "Standardkalender", VKe = "Im Profil ausblenden", BKe = "Termin-Einrichtung", UKe = "Keine Verfügbarkeit im Zeitplan gefunden", GKe = "Limits", WKe = "Wie oft können Sie gebucht werden", HKe = "Kalendereinstellungen & mehr...", YKe = "Erweitert", KKe = "Zahlungen für Veranstaltung einrichten", ZKe = "Terminkonfiguration: Mehrere Laufzeiten erfordern mindestens eine Option.", XKe = "Termineinrichtung: Bitte wählen Sie eine gültige Standarddauer.", JKe = "Die Buchungslimits müssen in aufsteigender Reihenfolge sein. [Tag, Woche, Monat, Jahr]", QKe = "Die Zeitlimits müssen aufsteigend sortiert sein. [Tag, Woche, Monat, Jahr]", eZe = "Wählen Sie den Kalender aus, zu dem Termine hinzugefügt werden sollen", tZe = "Eigener Terminname", nZe = "Erstellen Sie benutzerdefinierte Terminnamen, die im Kalendereintrag angezeigt werden sollen", oZe = "Falscher Zwei-Faktor-Authentifizierungscode", rZe = "Auf welchen Termintyp wird dies angewandt?", iZe = "Auf alle anwenden, einschließlich zukünftiger Ereignistypen", aZe = "Auf alle Team- und Benutzer-Ereignistypen anwenden", sZe = "Für welches Team soll dies gelten?", cZe = "Workflows ermöglichen die einfache Automatisierung des Versands von Benachrichtigungen und Erinnerungen, so dass Sie Prozesse rund um Ihre Termine erstellen können.", lZe = "Dies ist eine interne Einstellung, die keinen Einfluss darauf hat, wie die Zeiten auf den öffentlichen Buchungsseiten für Sie oder jemanden, der Sie buchen möchte, angezeigt werden.", uZe = "Einen Workflow erstellen", dZe = "Mache dies", _Ze = "Abschalten", pZe = "Einschalten", mZe = "Stornierte Buchungen können nicht verschoben werden", fZe = "Einstellungen erfolgreich aktualisiert", gZe = "Fehler beim Aktualisieren der Einstellungen", hZe = "Meine persönliche {{appName}}-URL", vZe = "Schreiben Sie eine kurze Beschreibung, welche auf Ihrer persönlichen Profil-Seite erscheinen wird.", bZe = "Einrichtung abschließen und loslegen", yZe = "Dieser Benutzer hat noch keine Bio hinzugefügt.", $Ze = "Biografie", wZe = "Account löschen", kZe = "Sind Sie sicher, dass Sie Ihr {{appName}}-Konto löschen möchten?", SZe = "Meinen Account löschen", EZe = "Wochenstart", xZe = "Aufnahmen", CZe = "Aufnahme", TZe = "Fröhliche Terminplanung", AZe = "Wählen Sie aus, in welchen Kalendern Sie nach Konflikten suchen wollen, um Doppelbuchungen zu vermeiden.", IZe = "Auf Konflikte prüfen", OZe = "Aufnahmen anzeigen", NZe = "Nach Aufnahmen suchen", zZe = "Termine hinzufügen zu", RZe = "Systemeinstellungen folgen", PZe = "Eigene Marken-Farben", DZe = "Passen Sie Ihre eigene Markenfarbe auf Ihrer Buchungsseite an.", LZe = "Pro", MZe = "Entfernt alle {{appName}}-bezogenen Markenzeichen, z. B. „Powered by {{appName}}.“", FZe = "Sofortiges Meeting mit {{name}}", qZe = "Profilbild", jZe = "Upload", VZe = "Profilbild hinzufügen", BZe = "Adresse des Token", UZe = "Blockchain", GZe = "Altes Passwort", WZe = "Ihr sicheres neues Passwort", HZe = "Fehler beim aktualisieren des Passworts", YZe = "Zwei-Faktor-Authentifizierung", KZe = "Einen wiederholenden Zeitplan einrichten", ZZe = "heute", XZe = "Darstellung", JZe = "Mein Account", QZe = "Allgemein", eXe = "Kalender", tXe = "Rechnungen", nXe = "Embeds", oXe = "Benutzeridentitätswechsel", rXe = "Einstellungen zur Verwaltung der Benutzeridentifikation", iXe = "Letzte Identitätswechsel", aXe = "Schneller Identitätswechsel", sXe = "Keine kürzlichen Identitätswechsel", cXe = "Benutzer", lXe = "Benutzer", uXe = "Einstellungen für Ihr {{appName}} Profil verwalten", dXe = "Hier finden Sie eine Liste aller Benutzer", _Xe = "Benutzer-Listing", pXe = "Einstellungen für Ihre Sprache und Zeitzone verwalten", mXe = "Konfigurieren Sie, wie Ihre Event-Typen mit Ihren Kalendern interagieren sollen", fXe = "Einstellungen für Ihre Buchungsdarstellung verwalten", gXe = "Fügen Sie Ihre favorisierten Videokonferenz-Apps für Ihre Meetings hinzu", hXe = "Konferenz-App hinzufügen", vXe = "Einstellungen für Ihre Konto-Passwörter verwalten", bXe = "Zwei-Faktor-Authentifizierung einrichten", yXe = "Wir benötigen nur ein paar grundlegende Informationen, um Ihr Profil einzurichten.", $Xe = "Überspringen", wXe = "Später machen", kXe = "Zeiträume definieren, in denen Sie verfügbar sind", SXe = "Sie können dies alles später auf der Verfügbarkeitsseite anpassen.", EXe = "Verbinden Sie zuerst einen Kalender", xXe = "Vervollständigen Sie Ihr Profil", CXe = "Sie können weitere Kalender aus dem App-Store hinzufügen", TXe = "Konferenz-Apps verbinden", AXe = "Kalender-Apps verbinden", IXe = "Zahlungs-Apps verbinden", OXe = "Automatisierungs-Apps verbinden", NXe = "Analyse-Apps verbinden", zXe = "Andere Apps verbinden", RXe = "Nachrichten-Apps verbinden", PXe = "CRM-Apps verbinden", DXe = "Schritt {{currentStep}} von {{maxSteps}}", LXe = "Variable hinzufügen", MXe = "Benutzerdefinierte Telefonnummer", FXe = "Nachrichtenvorlage", qXe = "Betreff", jXe = "Dynamische Textvariablen hinzufügen", VXe = "Name des Ereignistyps", BXe = "Das Datum der Veranstaltung", UXe = "Die Dauer des Ereignisses", GXe = "Die Startzeit des Termins", WXe = "Ereignistyp nicht gefunden", HXe = "Anzurufende Nummer", YXe = "Die Telefonnummer des Benutzers, den du anrufst", KXe = "Ort", ZXe = "Der Ort des Events", XXe = "Zusätzliche Notizen", JXe = "Die zusätzlichen Anmerkungen der Buchung", QXe = "Name der buchenden Person", eJe = "Name des Organisators", tJe = "An", nJe = "{{workflowName}} Workflow erfolgreich {{offOn}}geschaltet", oJe = "Antworten herunterladen", rJe = "Laden Sie alle Antworten zu Ihrem Formular im CSV-Format herunter.", iJe = "Antworten anzeigen", aJe = "Herunterladen", sJe = "Wird heruntergeladen", cJe = "Aufnahme herunterladen", lJe = "Transkriptionen sind jetzt aktiviert", uJe = "Transkriptionen werden jetzt gestoppt", dJe = "Transkript herunterladen", _Je = "Transkript", pJe = "Eine Aufnahme von Ihrem letzten Anruf auf {{appName}} steht zum Download bereit", mJe = "Transkript von Ihrem letzten Anruf bei {{appName}} ist zum Herunterladen bereit. Links sind nur für 1 Stunde gültig", fJe = "Sie können das Protokoll auch aus den Anhängen herunterladen", gJe = "Hinweis: Der Download-Link ist nur für 12 Stunden gültig. Sie können einen neuen Downloadlink durch das Befolgen der Anweisungen <1>hier</1> generieren.", hJe = "Hinweis: Der Download-Link ist nur 12 Stunden gültig. Sie können einen neuen Download-Link generieren, indem Sie den Anweisungen folgen.", vJe = "Erstellen Sie Ihr erstes Formular", bJe = "Mithilfe von Leitungsformularen können Sie qualifizierende Fragen stellen und zur richtigen Person oder zum richtigen Veranstaltungstyp weiterleiten.", yJe = "Erstellen Sie Ihren ersten Webhook", $Je = "Mit Webhooks können Sie Meetingdaten in Echtzeit erhalten, sobald etwas in {{appName}} passiert.", wJe = "Für maximal", kJe = "Ereignis", SJe = "Termine", EJe = "Einstellungen für Ihr Teamprofil verwalten", xJe = "Einstellungen für Ihr Organization-Profil verwalten", CJe = "Benutzer in der Gruppe", TJe = "Administratoren und Mitglieder in Ihrer Organization verwalten", AJe = "Team-URL", IJe = "Teammitglieder", OJe = "Mehr", NJe = "Cal.ai Arbeitsabläufe", zJe = "und {{count}} mehr", RJe = "Wir betrachten die mobile Anwendung als Erweiterung der Web-Anwendung. Wenn Sie komplizierte Aktionen durchführen, verwenden Sie bitte die Web-Anwendung.", PJe = "Eine Erinnerung per Mail an die Teilnehmer verschicken, 24 Stunden bevor das Event startet", DJe = "Eine Erinnerung per SMS an die Teilnehmer verschicken, eine Stunde bevor das Event startet", LJe = "Benutzerdefinierte E-Mail senden, wenn der Termin zum Moderieren gebucht wird", MJe = "Eine Erinnerung per SMS an die Teilnehmer verschicken, 24 Stunden bevor das Event startet", FJe = "Benutzerdefinierte E-Mail senden, wenn der Termin zum Moderieren neu geplant wird", qJe = "Benutzerdefinierte SMS senden, wenn der Termin zum Moderieren gebucht wird", jJe = "SMS-Erinnerung senden", VJe = "24 Stunden vor Terminbeginn", BJe = "Nachfassen bei Nichterscheinen", UJe = "30 Minuten nach Terminende", GJe = "Teilnehmer erinnern, Ausweis mitzubringen", WJe = "1 Tag vor Terminbeginn", HJe = "E-Mail-Erinnerung", YJe = "1 Stunde vor Terminbeginn", KJe = "Benutzerdefinierte SMS-Erinnerung", ZJe = "Wenn Termin geplant wird", XJe = "Benutzerdefinierte E-Mail-Erinnerung", JJe = "Termin wird für Gastgeber umgeplant", QJe = "Buchungszahlen von verwalteten Ereignistypen einbeziehen", eQe = "Willkommen bei {{appName}}!", tQe = "Du kannst dies später bearbeiten.", nQe = "Ich verbinde meinen Kalender später", oQe = "Beim Speichern Ihrer Daten ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.", rQe = "Fehlende Plätze kaufen", iQe = "Zeitfensterlänge", aQe = "Darstellung der Buchungsseite", sQe = "Einstellungen für die Buchungsdarstellung Ihres Teams verwalten", cQe = "Einstellungen für die Buchungsdarstellung Ihrer Organisation verwalten", lQe = "Nur der Besitzer dieses Teams kann Änderungen an den Buchungen des Teams vornehmen ", uQe = "Entfernt alle {{appName}}-bezogenen Markenzeichen, z. B. „Powered by {{appName}}“", dQe = "{{teamName}} hat Sie eingeladen, dem Team als {{role}} beizutreten", _Qe = "Token ist entweder ungültig oder abgelaufen.", pQe = "Buchung anzeigen", mQe = "Mit Microsoft Exchange verbinden", fQe = "Authentifizierungsmethode", gQe = "Basisauthentifizierung", hQe = "NTLM-Authentifizierung", vQe = "GZip-Kompression", bQe = "Exchange Version", yQe = "2007 SP1", $Qe = "2010", wQe = "2010 SP1", kQe = "2010 SP2", SQe = "2013", EQe = "2013 SP1", xQe = "2015", CQe = "2016", TQe = "Weiterleitung", AQe = "Erstellen Sie Formulare , um Teilnehmer zu den richtigen Stellen weiterzuleiten", IQe = "E-Mail an Eigentümer senden", OQe = "Sendet eine E-Mail an den Eigentümer, wenn das Formular abgeschickt wird", NQe = "E-Mail senden an", zQe = "Neues Formular hinzufügen", RQe = "Neues Formular zu Ihrem Team hinzufügen", PQe = "Erstellen Sie Ihre erste Weiterleitung", DQe = "Anhand der Formularantworten an die richtige Person weiterleiten", LQe = "Formular", MQe = "Erstellen Sie Ihr Formular, um einen Bucher zu anzuleiten", FQe = "Link in Formular kopieren", qQe = "Design der Buchungsseite", jQe = "Dies gilt nur für Ihre öffentlichen Buchungsseiten", VQe = "Dashboard-Design", BQe = "Dies gilt nur für Ihr eingeloggtes Dashboard", UQe = "Systemstandard", GQe = "Team hinzufügen", WQe = "Erhalten Sie Meetingdaten in Echtzeit, wenn etwas in {{appName}} passiert", HQe = "Löst aus, wenn", YQe = "Bitte führen Sie einen Pingtest vor der Erstellung durch.", KQe = "Webhook aktivieren", ZQe = "Webhook hinzufügen", XQe = "Webhook gespeichert", JQe = "Generieren Sie API-Schlüssel für den Zugriff auf Ihren eigenen Account", QQe = "Neuer API-Schlüssel", eet = "Aktiv", tet = "API-Schlüsselname aktualisiert", net = "Fehler beim Aktualisieren des API-Schlüsselnamens", oet = "HTML iframe-Einbettung", ret = "Alle Event-Typen auf Ihrer Website einbetten", iet = "Erstellen Sie Ihren ersten API-Schlüssel", aet = "API-Schlüssel erlauben es anderen Apps, mit {{appName}} zu kommunizieren", set = "Zurück zur Anmeldung", cet = "Zurücksetzungslink gesendet", uet = "Eine E-Mail mit Anweisungen zum Zurücksetzen deines Passworts ist unterwegs an {{email}}.", det = "Falls Sie nicht bald eine E-Mail erhalten, überprüfen Sie, ob die eingegebene E-Mail-Adresse korrekt ist. Überprüfen Sie außerdem Ihren Spam-Ordner oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.", _et = "Passwort aktualisiert!", pet = "Zahlung ausstehend", met = "Offene Einladungen", fet = "Ausstehende Organisationseinladungen", get = "Nicht auf {{appName}}", het = "Kein Kalender installiert", vet = "Sie haben noch keinen Ihrer Kalender verbunden", bet = "Kalender hinzufügen", yet = "Möglicherweise müssen Sie sich ab- und wieder anmelden, um Änderungen wirksam zu sehen.", $et = "Bitte bestätigen Sie Ihr Passwort, bevor Sie Ihre E-Mail-Adresse ändern", wet = "Plätze", ket = "Jede App, die im {{appName}} App Store veröffentlicht wird, ist Open Source und gründlich durch Peer Reviews getestet. {{companyName}} unterstützt oder zertifiziert diese Apps jedoch nicht, es sei denn, sie werden von {{appName}} selbst veröffentlicht. Wenn Sie auf unangemessene Inhalte oder Verhaltensweisen stoßen, melden Sie diese bitte.", Eet = "App melden", xet = "Buchungsfrequenz begrenzen", Cet = "Begrenzen, wie oft dieses Ereignis gebucht werden kann", Tet = "Nur den ersten verfügbaren Zeitslot pro Tag anzeigen", Aet = "Dies beschränkt Ihre Verfügbarkeit für diesen Ereignistyp auf einen Zeitslot pro Tag, der zum frühestmöglichen Zeitpunkt geplant wird.", Iet = "Gesamtbuchungsdauer beschränken", Oet = "Begrenzt die Gesamtanzahl, die dieser Termin gebucht werden kann", Net = "Limit für aktive Buchungen pro Bucher", zet = "Begrenze die Anzahl der aktiven Buchungen, die ein Bucher für diesen Termintyp vornehmen kann", Ret = "Wiederkehrende Termine unterstützen keine Buchungslimits pro Bucher", Pet = "Begrenzung hinzufügen", Det = "Teamname erforderlich", Let = "Teilnehmerinformationen zwischen Gästen teilen", Met = "Anzahl der verfügbaren Plätze anzeigen", Fet = "Wie verwendet man Buchungsfragen als Variablen?", qet = "Format", jet = "Fragen", Vet = "Alle Informationen, die dein Bucher vor der Buchung angeben sollte.", Bet = "Großbuchstaben für alle Buchstaben verwenden", Uet = "Leerzeichen durch Unterstriche ersetzen", Get = "Plattform-Mitglieder", Wet = "Verwalten Sie die Administratoren und Mitglieder in Ihrem Plattform-Team", Het = "Plattform-Abrechnung", Yet = "Abrechnung verwalten", Ket = "Alles zur Abrechnung verwalten", Zet = "Sie verwenden derzeit den KOSTENLOSEN Plan", Xet = "In Teams arbeitet man am Besten. Erweitern Sie Ihre Arbeitsabläufe mit Rundlauf und kollektiven Veranstaltungen und erstellen Sie erweiterte Leitungsformulare", Jet = "Jetzt ausprobieren", Qet = "Abrechnungsportal", ett = "Support kontaktieren", ttt = "Ignorieren Sie Sonderzeichen in Ihrem Buchungsfragenbezeichner. Verwenden Sie nur Buchstaben und Zahlen", ntt = "Erneut versuchen", ott = "Beim Abrufen Ihrer Kalender ist ein Problem aufgetreten. Bitte <1>versuchen Sie es erneut</1> oder wenden Sie sich an den Support.", rtt = "Kalenderverbindung fehlgeschlagen", itt = "Buchungsbestätigung erfolgreich", att = "Buchungsablehnung erfolgreich", stt = "Diese Buchung ist vorläufig", ctt = "Hoppla, ich möchte akzeptieren", ltt = "Wir werden dies nicht erneut anzeigen", utt = "Die Zeitzone konnte nicht aktualisiert werden", dtt = "Zeitzone auf {{formattedCurrentTz}} aktualisiert", _tt = "Zeitzone aktualisieren", ptt = "Zeitzone aktualisieren?", mtt = "Ihre lokale Zeitzone scheint sich zu {{formattedCurrentTz}} geändert zu haben. Es ist sehr wichtig, die richtige Zeitzone zu haben, um Buchungen zu unerwünschten Zeiten zu verhindern. Möchten Sie sie aktualisieren?", ftt = "Nicht aktualisieren", gtt = "Zusätzliche Notizen erforderlich", htt = "Zusätzliche Notizen bei der Buchung erforderlich machen", vtt = "eine E-Mail an eine bestimmte E-Mail-Adresse senden", btt = "nach Ende des Termins", ytt = "wenn eine Buchung abgelehnt wird", $tt = "wenn eine Buchung angefragt wird", wtt = "wenn eine Buchungszahlung eingeleitet wird", ktt = "wenn eine Buchungszahlung erfolgreich ist", Stt = "wenn ein Nichterscheinen bei einer Buchung aktualisiert wird", Ett = "Wie lange nach Ende des Termins?", xtt = "Wie lange nachdem Gastgeber nicht zum Cal-Video-Meeting erscheinen?", Ctt = "Wie lange nachdem Gäste nicht zum Cal-Video-Meeting erscheinen?", Ttt = "Wie viele Minuten nachdem die Teilnehmer nicht zum Cal-Video-Meeting erscheinen?", Att = "Keine verfügbaren Plätze", Itt = "Zeit verfügbar", Ott = "Kannst du nicht die richtige Konferenz-App finden? Besuche unseren <0>App Store</0>.", Ntt = "Neue Kalender-App installieren", ztt = "Telefonnummer für die Buchung des Termins erforderlich machen", Rtt = "{{eventTypeTitle}} | Verfügbarkeit", Ptt = "Fehler beim Bearbeiten der Verfügbarkeit", Dtt = "Ihnen fehlt die Berechtigung, auf diese Ressource zuzugreifen.", Ltt = "Bitte fügen Sie die SAML-Metadaten von Ihrem SAML-Anbieter hier ein", Mtt = "Bitte geben Sie eine E-Mail ein, damit wir Ihren SAML Anbieter finden können", Ftt = "Einzelheiten zum Dienstanbieter", qtt = "Ihr Identitätsanbieter (IdP) bittet Sie um die folgenden Details, um die Konfiguration der SAML Anwendung abzuschließen.", jtt = "ACS-URL", Vtt = "SP-Entitäts-ID", Btt = "ACS-URL kopiert!", Utt = "SP-Entitäts-ID kopiert!", Gtt = "Kalender hinzufügen", Wtt = "Zukünftige Termine begrenzen", Htt = "Begrenzt, wie weit in die Zukunft dieser Termin gebucht werden kann", Ytt = "Keine Termintypen eingerichtet", Ktt = "{{name}} hat keine für Sie buchbaren Termintypen eingerichtet.", Ztt = "Rechnungshäufigkeit", Xtt = "Monatlich", Jtt = "Jährlich", Qtt = "Kasse", ent = "Ihr Team wurde erfolgreich aufgelöst", tnt = "Ihre Organization wurde erfolgreich aufgelöst", nnt = "Fehler beim Erstellen des Teams", ont = "Sie", rnt = "Oder fortfahren mit", int = "E-Mail erneut senden", ant = "Mitglied wurde bereits eingeladen", snt = "Benutzername wird bereits verwendet", cnt = "E-Mail oder Benutzername eingeben", lnt = "E-Mail-Adresse eingeben", unt = "E-Mail-Adressen eingeben", dnt = "Sie sind darauf beschränkt, maximal {{nbUsers}} Benutzer gleichzeitig einzuladen.", _nt = "Dieser Name ist bereits vergeben", pnt = "Team-Name muss eingegeben werden", mnt = "Team-URL muss eingegeben werden", fnt = "Diese URL ist bereits vergeben", gnt = "Es gab ein Problem bei der Registrierung der Subdomain, bitte versuchen Sie es erneut oder kontaktieren Sie einen Administrator", hnt = "Team veröffentlichen", vnt = "Telefonnummer (Textbenachrichtigungen)", bnt = "Telefonnummer (SMS-Benachrichtigungen)", ynt = "Teilnehmer E-Mail", $nt = "Die E-Mail-Adresse der buchenden Person", wnt = "Buchungs-UID", knt = "Geben Sie einen Befehl ein oder suchen Sie ...", Snt = "Oh nein! Es sieht so aus, als ob die Berechtigung abgelaufen ist oder entzogen wurden. Bitte erneut installieren.", Ent = "App neu installieren", xnt = "Verlegungsgrund", Cnt = "Gemeinsamen Zeitplan auswählen", Tnt = "Aktivieren Sie dies, wenn Sie einen gemeinsamen Zeitplan für alle Gastgeber verwenden möchten. Wenn deaktiviert, wird jeder Gastgeber basierend auf seinem Standardzeitplan oder seinem gewählten Zeitplan gebucht.", Ant = "Grund", Int = "Absender-ID", Ont = "Nur Buchstaben, Zahlen und Leerzeichen erlaubt (max. 11 Zeichen)", Nnt = "Testweiterleitungsformular", znt = "Vorschau testen", Rnt = "Weiterleiten zu", Pnt = "Testen Sie Ihr Weiterleitungsformular, ohne Daten zu senden", Dnt = "Testweiterleitung", Lnt = "Ein Administrator hat eine Zahlungs-App deaktiviert", Mnt = "Termintyp bearbeiten", Fnt = "Diese Organisation ist privat und nur der Administrator oder Eigentümer der Organisation kann ihre Mitglieder sehen.", qnt = "Nur der Administrator oder Eigentümer der Organisation kann die SSO-Einstellungen verwalten", jnt = "Nur der Administrator oder Inhaber der Organisation kann die Verzeichnissynchronisierungseinstellungen verwalten", Vnt = "Nur der Administrator oder Inhaber der Organisation kann OAuth-Clients verwalten", Bnt = "Kollektive Terminplanung", Unt = "Machen Sie es einfach, Ihr Team zu buchen, wenn jeder verfügbar ist.", Gnt = "Finden Sie die beste verfügbare Person und rotieren Sie durch Ihr Team.", Wnt = "Festgelegter Round Robin", Hnt = "Fügen Sie einen festen Teilnehmer und einen Round Robin mit einer Reihe von Teilnehmern hinzu.", Ynt = "{{appName}} ist mit Teams noch besser", Knt = "Das {{companyName}}-Team", Znt = "Fügen Sie Ihre Teammitglieder zu Ihren Termintypen hinzu. Nutzen Sie kollektive Planung, um alle einzubinden oder finden Sie die geeignetste Person mit der Round Robin Planung.", Xnt = "Das Buchungslimit für diesen Termintyp wurde erreicht", Jnt = "Das Zeitlimit für diesen Termintyp wurde erreicht", Qnt = "Ein Admin hat {{appName}} deaktiviert", eot = "Dies deaktiviert alle E-Mails an {{recipient}}. Dies umfasst Buchungsbestätigungen, Anfragen, Umbuchungen und Umbuchungsanfragen, Stornierungsmails und alle anderen E-Mails im Zusammenhang mit Buchungsaktualisierungen.<br /><br />Es liegt in deiner Verantwortung sicherzustellen, dass deine {{recipient}} über alle Buchungen und Änderungen ihrer Buchungen informiert sind.", tot = "Ein Admin hat {{appName}} deaktiviert, was Ihren Termintyp {{eventType}} betrifft", not = "Ein Admin hat einen Ihrer Ereignistypen ersetzt", oot = "Ein Teamadministrator hat Ihr Ereignis ersetzt /{{slug}}", rot = "Ein Administrator im <strong>{{teamName}}</strong>-Team hat Ihren Ereignistyp <strong>/{{slug}}</strong> durch einen verwalteten Ereignistyp ersetzt, den er steuert.", iot = "Ihr Link wird weiterhin funktionieren, aber einige Einstellungen werden möglicherweise geändert. Sie können ihn bei Ereignistypen überprüfen.", aot = "Wenn Sie Fragen zum Ereignistyp haben, wenden Sie sich bitte an Ihren Administrator.<br /><br />Fröhliche Terminplanung, <br />Das Cal.com-Team", sot = "Der Administrator hat {{appName}} deaktiviert, was Ihren Termintyp {{title}} beeinflusst. Teilnehmer können diesen Termintyp weiterhin buchen, werden aber nicht zur Zahlung aufgefordert. Sie können den Termintyp ausblenden, um dies zu verhindern, bis Ihr Administrator Ihre Zahlungsmethode wieder aktiviert.", cot = "Teilnehmer können diesen Termintyp weiterhin buchen, werden aber nicht zur Zahlung aufgefordert. Sie können den Termintyp ausblenden, um dies zu verhindern, bis Ihr Administrator Ihre Zahlungsmethode wieder aktiviert.", lot = "Der Admin hat {{appName}} deaktiviert, was Ihren Termintyp {{title}} beeinflusst.", uot = "Der Administrator hat {{appName}} deaktiviert, was Ihre Termintypen beeinflussen kann. Wenn Sie Termintypen mit {{appName}} als Ort haben, wird standardmäßig Cal Video gewählt.", dot = "{{appName}} wurde deaktiviert", _ot = "Zu installierten Apps wechseln", pot = "Wenn Sie einen anderen Kalender installiert haben, werden neue Buchungen zu dem Kalender hinzugefügt. Verbinden Sie andernfalls einen neuen Kalender, damit Sie keine neuen Buchungen verpassen.", mot = "Apps aktivieren", fot = "Apps aktivieren, die Benutzer mit {{appName}} integrieren können", got = "Lizenz kaufen", hot = "Haben Sie bereits ein Konto?", vot = "Ich habe bereits einen Schlüssel:", bot = "Bitte fügen Sie Ihre vorhandene CALCOM_LICENSE_KEY Umgebungsvariable hier ein.", yot = "Lizenzschlüssel erstellen", $ot = "{{appName}} ist aktiviert", wot = "{{appName}} ist deaktiviert", kot = "Schlüssel wurden gespeichert", Sot = "App deaktivieren", Eot = "Das Deaktivieren dieser App kann Probleme mit den Interaktionen Ihrer Nutzer mit Cal verursachen", xot = "Schlüssel bearbeiten", Cot = "Aktivieren Sie Apps für Ihre Instanz von Cal", Tot = "Eine Liste aller Benutzer in Ihrem Konto, einschließlich Name, Titel, E-Mail und Rolle.", Aot = "Hier können Sie einen neuen Benutzer hinzufügen.", Iot = "Hier können Sie einen bestehenden Benutzer bearbeiten.", Oot = "Hier können Sie eine Organisation bearbeiten.", Not = "Neue OAuth-Clients hinzufügen", zot = "SMS-Versand für Benutzer sperren oder entsperren", Rot = "Es gibt keine verfügbaren Apps", Pot = "Bitte stellen Sie sicher, dass sich unter „packages/app-store“ Apps in Ihrem Deployment befinden", Dot = "In dieser Instanz von Cal sind keine Apps aktiviert", Lot = "Es wurde noch keine App konfiguriert", Mot = "Sie können Apps in den Einstellungen aktivieren", Fot = "Bitte kontaktieren Sie Ihren Administrator", qot = "Apps-Einstellungen", jot = "Bitte füllen Sie dieses Feld aus", Vot = "Optionen", Bot = "Option {{index}} eingeben", Uot = "Option hinzufügen", Got = "Dieser Standort existiert bereits. Bitte wählen Sie einen neuen Standort", Wot = "Radio", Hot = "Um Google Meet zu nutzen, müssen Sie Ihren Zielkalender auf einen Google-Kalender einstellen", Yot = "Person", Kot = "Alle Buchungen", Zot = "Alle Benutzer", Xot = "Alle Ereignistypen", Jot = "Ihre Buchungen", Qot = "Meeting-URL", ert = "Die URL der Meeting-Konferenz", trt = "Datumsüberschreibungen", nrt = "Datumsüberschreibungen am {{date}} löschen", ort = "Fügen Sie Termine hinzu, an denen Ihre Verfügbarkeit von Ihren üblichen Geschäftszeiten abweicht.", rrt = "Überschreibungsdaten werden automatisch nach Überschreitung des Datums archiviert", irt = "Zu welchen Stunden sind Sie verfügbar?", art = "Zu welchen Stunden sind Sie beschäftigt?", srt = "Daten zum Überschreiben auswählen", crt = "Ganztägig nicht verfügbar", lrt = "Als nicht verfügbar markieren (Ganztägig)", urt = "An ausgewählten Daten als „nicht verfügbar“ markieren", drt = "Überschreiben aktualisieren", _rt = "Datumsüberbrückung erfolgreich hinzugefügt", prt = "Überschreibung speichern", mrt = "{{slug}}-Kopie", frt = "Als Standard festlegen", grt = "Ereignistyp-Einzelheiten ausblenden", hrt = "Navigation anzeigen", vrt = "Navigation ausblenden", brt = "Bestätigungscode gesendet", yrt = "Erfolgreich bestätigt", $rt = "Bestätigungscode falsch", wrt = "Noch nicht bestätigt", krt = "Keine Verfügbarkeit im {{month}}", Srt = "Terminplanung ist nur bis zu {{days}} im Voraus verfügbar. Bitte schauen Sie bald wieder vorbei.", Ert = "Die Terminplanung endete am {{date}}. Bitte schauen Sie bald wieder vorbei.", xrt = "Vormonat anzeigen", Crt = "Nächsten Monat anzeigen", Trt = "Code senden", Art = "Nummer verifiziert", Irt = "Erstellen Sie Ihren ersten Webhook für diesen Team-Ereignistyp", Ort = "Einen Webhook für diesen Team-Ereignistyp erstellen", Nrt = "Erfolgsseite deaktivieren (funktioniert nur, wenn eine Weiterleitungs-URL vorhanden ist)", zrt = "Sie sind als Admin festgelegt, benutzen allerdings ein Passwort, das kürzer als 15 Zeichen ist oder verwenden noch keine 2FA", Rrt = "Ändern Sie Ihr Passwort, um Administratorzugriff zu erhalten", Prt = "Benutzername ist bereits vergeben", Drt = "Zuordnung", Lrt = "Festgelegte Veranstalter", Mrt = "Festgelegte Veranstalter hinzufügen", Frt = "Round-Robin-Veranstalter", qrt = "Anzahl der Veranstalter, die teilnehmen müssen", jrt = "Veranstalter", Vrt = "Sie müssen ein Team erstellen, um diese Funktion zu aktivieren. Klicken Sie hier, um ein Team zu erstellen.", Brt = "Sie müssen auf unsere Enterprise-Lizenz aktualisieren, um diese Funktion zu aktivieren.", Urt = "Neuer Teilnehmer", Grt = "Wartet auf Genehmigung", Wrt = "Diese App erfordert eine Verbindung mit Google Calendar", Hrt = 'Für die Funktion "Zum Kalender hinzufügen" für diesen Termintyp wird ein Google Kalender benötigt, damit Meet funktioniert. Verbinde ihn <0>hier</0>.', Yrt = "Sie haben ein Google Calendar-Konto verbunden.", Krt = "Die Nutzung von Google Meet erfordert einen verbundenen Google Calendar", Zrt = "Installation von Google Calender fortsetzen", Xrt = "Google Meet installieren", Jrt = "Google Calendar installieren", Qrt = "Absendername", eit = "Teilnehmer bereits eingeladen", tit = "Keine Aufnahmen gefunden", nit = "Neuer Workflow für ...", oit = "Meldungen", rit = "Alle eingehenden Daten anzeigen und als CSV herunterladen", iit = "Teams-Plan benötigt", ait = "Weiterleitungs-Formulare sind eine gute Möglichkeit, Ihre eingehenden Leads zur richtigen Person weiterzuleiten. Upgraden Sie auf einen Teams-Plan, um auf diese Funktion zuzugreifen.", sit = "Wählen Sie eine Lizenz", cit = "Cal.com enthält eine kostenlose AGPLv3-Lizenz, mit einigen Einschränkungen, die jederzeit auf eine Enterprise-Lizenz aufgerüstet werden können. Sie können später jederzeit upgraden.", lit = "Lizenz", uit = "AGPLv3 Lizenz", dit = "Ihr Code muss nicht open-source bleiben", _it = "Einfaches Neuverpacken, Rebranding und Weiterverkaufen", pit = "Eine große Auswahl an Enterprise-Funktionen", mit = "0,00 €/Monat", fit = "Für immer offen & kostenlos", git = "Ihr Code muss open-source bleiben", hit = "Kann nicht einfach neuverpackt, rebrandet und weiterverkauft werden", vit = "Keine Enterprise-Funktionen", bit = "Enterprise-Lizenz", yit = "Alles für einen kommerziellen Einsatzfall mit privatem Hosting, Umverpacken, Rebranding, Wiederverkauf und Zugriff auf exklusive Enterprise-Komponenten.", $it = "Einrichtung", wit = "Cal.com Instanz einrichten", kit = "Konfigurieren", Sit = "Single Sign-On", Eit = "SAML/OIDC SSO konfigurieren und Teammitgliedern erlauben, sich mit einem Identitätsanbieter anzumelden", xit = "SAML/OIDC SSO konfigurieren und Organisationsmitgliedern erlauben, sich mit einem Identitätsanbieter anzumelden", Cit = "SSO mit OIDC", Tit = "Konfigurieren Sie OIDC SSO mit einem Identitätsanbieter Ihrer Wahl.", Ait = "OIDC-Konfiguration", Iit = "Konfigurieren Sie die OIDC-Verbindung zu Ihrem Identitätsanbieter. Sie finden die erforderlichen Informationen in Ihrem Identitätsanbieter.", Oit = "Callback-URL kopiert", Nit = "SSO mit SAML", zit = "Konfigurieren Sie SAML SSO mit Identity Provider Ihrer Wahl.", Rit = "SAML-Konfiguration", Pit = "Konfigurieren Sie SAML-Verbindung zu Ihrem Identitätsanbieter. Sie finden die erforderlichen Informationen in Ihrem Identitätsanbieter.", Dit = "ACS-URL kopiert", Lit = "Entitäts-ID kopiert", Mit = "{{connectionType}}-Konfiguration erfolgreich erstellt", Fit = "{{connectionType}}-Konfiguration erfolgreich gelöscht", qit = "{{connectionType}}-Konfiguration löschen", jit = "Ja, {{connectionType}}-Konfiguration löschen", Vit = "Sind Sie sicher, dass Sie die {{connectionType}}-Konfiguration löschen möchten? Ihre Teammitglieder, die sich über {{connectionType}} anmelden, werden keinen Zugriff mehr auf Cal.com haben.", Bit = "Zeitzone des Veranstalters", Uit = "Einladung anzeigen", Git = "Einladung annehmen", Wit = "Jetzt beitreten", Hit = "Erfolgreich beigetreten", Yit = "Du wurdest eingeladen, einem Team der Organisation {{parentTeamName}} beizutreten", Kit = "Du wurdest eingeladen, einer {{appName}}-Organisation beizutreten", Zit = "{{invitedBy}} hat Sie eingeladen, dem Team in {{appName}} beizutreten. {{appName}} ist der Event-Planer, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne ständiges hin und her zu planen.", Xit = "{{invitedBy}} hat Sie eingeladen, dem Team „{{teamName}}“ in seiner bzw. ihrer Organisation {{parentTeamName}} bei {{appName}} beizutreten. {{appName}} ist der Terminplaner, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.", Jit = "{{invitedBy}} hat Sie eingeladen, ihrer Organisation „{{teamName}}“ in {{appName}} beizutreten. {{appName}} ist der Terminplaner, der es Ihnen und Ihrer Organisation ermöglicht, Meetings ohne ständiges hin und her zu planen.", Qit = "Wir führen dich durch einige kurze Schritte und du wirst in kürzester Zeit stressfreie Terminplanung mit deinem {{entity}} genießen.", eat = "Wählen Sie Ihren Benutzernamen", tat = "Verbinden Sie Ihr Kalenderkonto", nat = "Legen Sie Ihre Verfügbarkeit fest", oat = "Treten Sie {{teamName}} bei", rat = "Fröhliche Terminplanung wünscht das {{appName}} Team", iat = "Sie sind dabei einen Benutzer zu imitieren, was bedeutet, dass Sie Änderungen in ihrem Namen vornehmen können. Bitte seien Sie vorsichtig.", aat = "Verfügbare Variablen", sat = "{Scheduler}", cat = "Keine Workflows", lat = "Ändern Sie den Filter, um Ihre eigenen und Ihre Team-Workflows anzuzeigen.", uat = "Passen Sie Ihre Filteroptionen an, um die Ergebnisse zu sehen.", dat = "Keine Ergebnisse für diesen Filter", _at = "Empfohlene nächste Schritte", pat = "Einen verwalteten Ereignistyp erstellen", mat = "Meetings sind mit den richtigen Teammitgliedern besser. Laden Sie sie jetzt ein.", fat = "Erstellen Sie eine One-on-One-Vorlage für einen Termintyp und verteilen Sie diese an mehrere Mitglieder.", gat = "Kollektiv oder Round-Robin", hat = "Buchen Sie Ihre Teammitglieder zusammen mit Kollektivveranstaltungen oder wählen Sie mit Round-Robin die richtige Person.", vat = "Nimmt nicht mehr an {{title}} am {{date}} teil", bat = "Sie nehmen an diesem Termin nicht mehr teil", yat = "Ein Teilnehmer nimmt nicht mehr an {{title}} am {{date}} teil", $at = "Ein Teilnehmer nimmt nicht mehr an Ihrem Termin teil", wat = "{{name}} hat abgesagt. Dies bedeutet, dass ein Platz in diesem Zeitfenster frei wurde", kat = "Erstelle Termin am", Sat = "Weiterleitungsformular erstellen am", Eat = "Standard-App-Link festlegen", xat = "Mit dem Festlegen eines Standard-App-Links können alle neu erstellten Ereignistypen den App-Link verwenden, den Sie gesetzt haben.", Cat = "Standard-App des Organisators", Tat = "{{organizer}} hat keine Standard-Konferenz-App", Aat = "Wartungsarbeiten", Iat = "Das {{appName}} Team führt geplante Wartungsarbeiten durch. Wenn Sie Fragen haben, wenden Sie sich bitte an den Support.", Oat = "{{numberOfSeats}} Sitze", Nat = "Buchungsfragen", zat = "Passen Sie die Fragen an, die auf der Buchungsseite gefragt werden", Rat = "Frage hinzufügen", Pat = "Bezeichner", Dat = "E-Mail ist doppelt vorhanden", Lat = "Geben Sie eine Weiterleitungs-URL ein, zu der der Teilnehmer gesendet wird, sobald er das Meeting verlässt.", Mat = "Zahlung für dieses Ereignis ist nicht mehr möglich", Fat = "Eine Rückerstattung für diese Buchungszahlung ist auf dem Weg.", qat = "Diese Buchungszahlung wurde zurückerstattet.", jat = "Gemäß der Rückerstattungsrichtlinie des Events ist die Buchungszahlung nicht erstattungsfähig.", Vat = "Das Rückerstattungsfenster für das Event ist abgelaufen. Daher ist die Buchungszahlung nicht erstattungsfähig.", Bat = "Buchungsbestätigung fehlgeschlagen", Uat = "Nicht genügend Plätze", Gat = "Ein Feld mit diesem Namen ist bereits vorhanden", Wat = "Das Gästefeld muss vom Typ 'Mehrere E-Mails' sein", Hat = "Auf der Buchungsseite anzeigen", Yat = "Sie können die Seite der stornierten Buchung besuchen", Kat = "Legen Sie mit Zapier-Vorlagen los", Zat = "Standardvorlagen", Xat = "Cal.ai-Vorlagen", Jat = "{{team}} ist unveröffentlicht", Qat = "Dieser Organisations-Link ist derzeit nicht verfügbar. Bitte kontaktieren Sie den Organisations-Besitzer oder fragen Sie ihn, ob er ihn veröffentlicht.", est = "Dieser {{entity}}-Link ist derzeit nicht verfügbar. Bitte kontaktieren Sie den {{entity}}-Besitzer oder fragen Sie ihn, ob er ihn veröffentlicht.", tst = "Teammitglied", nst = "Ein Weiterleitungsformular", ost = "Formularbeschreibung", rst = "Verbindung mit dem Formular beibehalten", ist = "Alle Änderungen, die am Router oder an den Feldern des zu duplizierenden Formulars vorgenommen werden, spiegeln sich im Duplikat wider. Das Löschen eines Feldes entfernt es jedoch nicht aus dem Duplikat.", ast = "Formular gelöscht", sst = "Möchten Sie dieses Formular wirklich löschen?", cst = "Ja, Formular löschen", lst = "Jede Person, mit der Sie den Link geteilt haben, kann nicht mehr über das Formular buchen.", ust = "Alle zugehörigen Antworten werden gelöscht.", dst = "Weiterleitungs-URL kopiert! Sie können jetzt die URL in Ihrem eigenen Formular einstellen.", _st = "Änderungen in den Feldern und Weiterleitungen der folgenden Formulare werden in diesem Formular reflektiert.", pst = "Verbundene Formulare", mst = "Folgende Formulare wären betroffen, wenn Sie hier Felder oder Weiterleitungen ändern.", fst = "Warten Sie einige Zeit, bis Antworten gesammelt werden. Sie können das Formular auch selbst ausfüllen.", gst = "Dies ist, was Ihre Benutzer sehen würden", hst = "Identifiziert Feld mit diesem Namen.", vst = "1 Option pro Zeile hinzufügen", bst = "Weiterleitungsformular auswählen", yst = "Neue Route hinzufügen", $st = "Treffen Sie mit Insights fundierte Entscheidungen", wst = "Unser Insights-Dashboard deckt alle Aktivitäten in Ihrem Team ab und zeigt Ihnen Trends, die eine bessere Teamplanung und Entscheidungsfindung ermöglichen.", kst = "Buchungen für alle Mitglieder anzeigen", Sst = "Sieh, wer die meisten Buchungen erhält und stelle die beste Verteilung in deinem Team sicher", Est = "Buchungstrends erkennen", xst = "Sehen Sie, welche Wochenzeiten und welche Tageszeiten bei Ihren Buchern beliebt sind", Cst = "Machen Sie beliebte Ereignistypen ausfindig", Tst = "Sehen Sie, welche Ihrer Ereignistypen die meisten Klicks und Buchungen erhalten", Ast = "Noch keine Antworten", Ist = "Keine Weiterleitungsrouten definiert", Ost = "Dies wird der Platzhalter sein", Nst = "Bei der Buchung dieses Termins ist ein Fehler aufgetreten, bitte aktualisieren Sie die Seite und versuchen Sie es erneut", zst = "Kein Zeitfenster ausgewählt", Rst = "Bitte wählen Sie einen Zeitraum aus, um den Termin zu buchen.", Pst = "Zeitfenster auswählen", Dst = "Zur monatlichen Ansicht wechseln", Lst = "Zur Wochenansicht wechseln", Mst = "Zur Tagesansicht wechseln", Fst = "Zur Spaltenansicht wechseln", qst = "{{num}} Veranstaltungsort-Optionen", jst = "Im nächsten Schritt auswählen", Vst = "Dieses Meeting hat noch nicht begonnen", Bst = "{{appName}} benötigt ein verbundenes {{dependencyName}}-Konto", Ust = "{{dependencyName}} verbinden", Gst = "{{dependencyName}} ist verbunden", Wst = "Benötigt {{dependencyName}}", Hst = "Bestätigungscode", Yst = "Können Sie es zu einem anderen Zeitpunkt erneut versuchen?", Kst = "Bestätigen", Zst = "Die Zeitzone der empfangenden Person", Xst = "Zeitzone", Jst = "Endzeitpunkt des Termins", Qst = "Der Endzeitpunkt des Termins", ect = "Absage-URL", tct = "Die URL, um die Buchung abzusagen", nct = "Stornierungsgrund", oct = "Der Grund für die Stornierung der Buchung", rct = "Umplanungs-URL", ict = "Die URL, um die Buchung umzuplanen", act = "Umbuchungsgrund", sct = "Der Grund für die Umbuchung des Termins", cct = "Es gibt eine ungültige Variable in Ihrem Terminnamen", lct = "Alle auswählen", uct = "Massenaktualisierung vorhandener Termintypen", dct = "Standardverfügbarkeitsplan des Mitglieds", _ct = "Vom Team-Admin festgelegt", pct = "Standardstandort des Mitglieds", mct = "Wir werden den Standardverfügbarkeitsplan jedes Mitglieds verwenden. Sie können ihn bearbeiten oder ändern.", fct = "Sie müssen mindestens einen Verfügbarkeitsplan haben", gct = "Orte für die ausgewählten Termintypen aktualisieren", hct = "Aktualisieren Sie die Zeitpläne für die ausgewählten Ereignistypen", vct = "Für Mitglieder gesperrt", bct = "Für Mitglieder freigeschaltet", yct = "Mitglieder können die aktiven Apps sehen, können aber keine App-Einstellungen anpassen", $ct = "Mitglieder können die aktiven Apps sehen und App-Einstellungen anpassen", wct = "Sie können die aktiven Apps sehen, können aber keine App-Einstellungen anpassen", kct = "Sie können die aktiven Apps sehen und App-Einstellungen anpassen", Sct = "Mitglieder können ihre persönlichen Workflows nicht zu diesem Termintyp hinzufügen. Mitglieder können die aktiven Teamworkflows sehen, können aber keine Workflow-Einstellungen bearbeiten.", Ect = "Mitglieder werden ihre persönlichen Workflows zu diesem Termintyp hinzufügen können. Mitglieder können die aktiven Teamworkflows sehen, können aber keine Workflow-Einstellungen bearbeiten.", xct = "Sie werden die aktiven Team-Workflows sehen können, werden aber keine Workflow-Einstellungen ändern oder Ihre persönlichen Workflows zu diesem Termintypen hinzufügen können.", Cct = "Sie werden ihre persönlichen Workflows bei diesem Termintyp aktivieren/deaktivieren können. Sie können die aktiven Teamworkflows sehen, können aber keine Team-Workflow-Einstellungen bearbeiten.", Tct = "Mitglieder können diesem Ereignistyp keine persönlichen Webhooks hinzufügen. Mitglieder können die aktiven Webhooks sehen, aber keine Webhook-Einstellungen bearbeiten.", Act = "Mitglieder können diesem Ereignistyp ihre persönlichen Webhooks hinzufügen. Mitglieder können die aktiven Webhooks sehen, aber keine Webhook-Einstellungen bearbeiten.", Ict = "Sie können die aktiven verwalteten Webhooks sehen, aber keine Webhook-Einstellungen bearbeiten oder diesem Ereignistyp keine persönlichen Webhooks hinzufügen.", Oct = "Sie können diesem Ereignistyp Webhooks hinzufügen. Sie können die aktiven verwalteten Webhooks sehen, können diese aber nicht bearbeiten.", Nct = "Vom Team-Admin gesperrt", zct = "Sie haben kein {{appName}}-Konto verbunden.", Rct = "Jetzt verbinden", Pct = "{{count}} Mitglied ersetzen & benachrichtigen", Dct = "{{count}} Mitglieder ersetzen & benachrichtigen", Lct = "Die URL /{{slug}} wird bereits von {{count}} Mitglied genutzt. Möchten Sie sie ersetzen?", Mct = "Die URL /{{slug}} wird bereits von {{count}} Mitgliedern genutzt. Möchten Sie sie ersetzen?", Fct = "<strong>{{names}}</strong> verwendet bereits die URL <strong>/{{slug}}</strong>-.", qct = "<strong>{{names}}</strong> verwenden bereits die URL <strong>/{{slug}}</strong>-.", jct = "Wenn Sie die URL ersetzen, werden wir sie benachrichtigen. Gehen Sie zurück und entfernen Sie sie, wenn Sie sie nicht überschreiben möchten.", Vct = "Ereignistyp überprüfen", Bct = "Suchen Sie nach weiteren Analysedaten?", Uct = "Möchten Sie mehr Insights?", Gct = "Filter", Wct = "Filter", Hct = "Mitglied hinzufügen", Yct = "Filter hinzufügen", Kct = "Regel hinzufügen", Zct = "Regelgruppe hinzufügen", Xct = "Alle Filter löschen", Jct = "E-Mail bestätigt", Qct = "Benutzer auswählen", elt = "Ereignistyp auswählen", tlt = "Datumsbereich auswählen", nlt = "Beliebte Termine", olt = "Keine Ereignistypen gefunden", rlt = "Durchschnittliche Ereignisdauer", ilt = "Buchungen nach Stunde", alt = "Am häufigsten gebucht", slt = "Am wenigsten gebucht", clt = "Meiste geplante Buchungen", llt = "Wenigste geplante Buchungen", ult = "Meiste abgeschlossene Buchungen", dlt = "Wenigste abgeschlossene Buchungen", _lt = "Termine erstellt", plt = "Termine abgeschlossen", mlt = "Termine abgesagt", flt = "Termine neu geplant", glt = "Termine", hlt = "Leistung", vlt = "seit dem letzten Zeitraum", blt = "Von: {{startDate}} Bis: {{endDate}}", ylt = 'Das Hinzufügen einer Umleitung wird die Erfolgsseite deaktivieren. Erwähnen Sie "Buchung bestätigt" auf Ihrer benutzerdefinierten Erfolgsseite.', $lt = "Ereignistrends", wlt = "Filter löschen", klt = "Löschen", Slt = "Halten", Elt = "Zahlung bei Buchung erhalten", xlt = "Gebühr für das Nichterscheinen berechnen", Clt = "Karte gehalten", Tlt = "Karte belasten", Alt = "Karte belastet", Ilt = "{{amount, currency}} Gebühr für das Nichterscheinen", Olt = "Gebühr für das Nichterscheinen", Nlt = "Karte senden", zlt = "Zahlungsinformationen senden", Rlt = "Ihr Meeting wartet auf eine Zahlungsmethode", Plt = "Gebühr für das Nichterscheinen in Höhe von {{amount, currency}} für {{title}} am {{date}} berechnet", Dlt = "Die Gebühr für das Nichterscheinen wurde berechnet", Llt = "Gebühr für das Nichterscheinen in Höhe von {{amount, currency}} wurde für das folgende Ereignis berechnet", Mlt = "Beim Berechnen der Nichterscheinungsgebühr ist etwas schiefgelaufen. Bitte versuchen Sie es später erneut.", Flt = "Gebühr für das Nichterscheinen anfordern", qlt = "Gebühr für das Nichterscheinen berechnet", jlt = "Zahlung abgelehnt. Bitte versuchen Sie es mit einer anderen Karte oder wenden Sie sich an Ihre Bank.", Vlt = "Dieser Kartentyp wird für diesen Kauf nicht unterstützt. Bitte verwenden Sie eine andere Zahlungsmethode.", Blt = "Der Mindestbetrag für Zahlungen beträgt 0,50 USD. Bitte erhöhen Sie Ihren Zahlungsbetrag.", Ult = "Karte konnte nicht für die Zahlung belastet werden.", Glt = "Erkenntnisse", Wlt = "Weiterleitungsformulare", Hlt = "Keine Daten für den ausgewählten Filter oder das ausgewählte Datum gefunden.", Ylt = "Ich bestätige, dass meiner Karte eine Gebühr von {{amount, currency}} berechnet wird, sofern ich nicht an diesem Ereignis teilnehme.", Klt = "Tage", Zlt = "Karteninformationen", Xlt = "Bei uns ist etwas schiefgelaufen. Kontaktiere unseren Support und wir werden das Problem umgehend für dich beheben.", Jlt = "Bitte geben Sie den folgenden Text an, wenn Sie den Support kontaktieren, damit wir Ihnen besser helfen können", Qlt = "Aktuell können keine Plätze aktiviert oder eine Gebühr für das Nichterscheinen berechnet werden", eut = "Schließen Sie Ihre Buchung ab", tut = "Schließen Sie Ihre Buchung ab: {{title}} am {{date}}", nut = "Bestätigen Sie Ihre Daten", out = "Einladungslink kopieren", rut = "Linkeinstellungen bearbeiten", iut = "Einladungslink kopiert", aut = "Einladungslink gelöscht", sut = "API-Schlüssel gelöscht", cut = "Dies wird den API-Schlüssel dauerhaft löschen. Alle Anwendungen, die diesen Schlüssel verwenden, verlieren sofort den Zugriff auf Ihr Konto. Diese Aktion kann nicht rückgängig gemacht werden.", lut = "Einladungslink-Einstellungen gespeichert", uut = "Links verfallen nach...", dut = "1 Tag", _ut = "7 Tage", put = "30 Tage", mut = "3 Monate", fut = "1 Jahr", gut = "Sie wurden eingeladen, ein Mitglied von {{teamName}} zu werden", hut = "{{amount, currency}}", vut = "Sie sind im Begriff, dem Teilnehmer {{amount, currency}} in Rechnung zu stellen. Sind Sie sicher, dass Sie fortfahren möchten?", but = "Teilnehmer {{amount, currency}} berechnen", yut = "Zahlung erfordern ({{paymentFeePercentage}} % + {{fee, currency}} Provision pro Transaktion)", $ut = "{{email}} wurde eingeladen", wut = "{{userCount}} Benutzer wurden eingeladen", kut = "Kartenfehler", Sut = "Das hochgeladene Bild sollte die maximale Größe von 5 MB nicht überschreiten", Eut = "{{errorCode}}: Sie sind nicht berechtigt, diesen Workflow zu aktivieren oder zu deaktivieren", xut = "Inline-Einbettung", Cut = "Laden Sie Ihren Termintyp direkt inline mit Ihren anderen Website-Inhalten.", Tut = "Bewegliche Pop-Up-Schaltfläche", Aut = "Erstellt einen beweglichen Button auf Ihrer Website, der einen modales Dialogfenster mit Ihrem Termintypen erstellt.", Iut = "Pop-Up über Element-Klick", Out = "Öffnet Ihren Cal-Dialog, wenn jemand ein Bedienelement anklickt.", Nut = "Eigenes Formular verwenden", zut = "Verwenden Sie unsere Headless-Routing-API und nutzen Sie Ihr eigenes Formular für Übermittlungen.", Rut = "Brauchen Sie Hilfe? Sehen Sie sich unsere Anleitungen zum Einbetten von Cal auf Wix, Squarespace, oder WordPress an, schauen Sie sich unsere häufig gestellten Fragen an oder erkunden Sie erweiterte Einbettungsoptionen.", Put = "Mich per Cal buchen", Dut = "Vorname", Lut = "Nachname", Mut = "Vorname, Nachname", Fut = "Einladen als", qut = "Formular erfolgreich aktualisiert.", jut = "Standardmäßige Bestätigungs-E-Mails für Teilnehmer deaktivieren", Vut = "Mindestens ein Workflow, durch den bei Buchung eine E-Mail an die Teilnehmer gesendet wird, ist für diesen Termintyp aktiv.", But = "Standardmäßige Bestätigungs-E-Mails für Veranstalter deaktivieren", Uut = "Mindestens ein Workflow, durch den bei Buchung eine E-Mail an den Veranstalter gesendet wird, ist für diesen Termintyp aktiv.", Gut = "Eine Überschreibung hinzufügen", Wut = "Benutzer aus Google Workspace importieren", Hut = "Google Workspace verbinden", Yut = "Sie müssen ein Workspace-Admin sein, um diese Funktion nutzen zu können", Kut = "Erstellen Sie Ihren ersten Webhook für diesen Termintypen", Zut = "Erstellen Sie Ihren ersten Webhook mit „Sofortiges Meeting erstellt“ als Auslöser für diesen Ereignistyp", Xut = "App installieren auf", Jut = "Erstellen für", Qut = "Währung", edt = "Schaffen Sie eine Umgebung, in der Ihre Teams gemeinsame Apps, Workflows und Termintypen mit Round-Robin- und kollektiver Planung erstellen können.", tdt = "Verwalten Sie Organizations mit mehreren Teams", ndt = "Ihre Organization einrichten", odt = "Richten Sie Ihre Plattform ein", rdt = "Organizations sind geteilte Umgebungen, in denen Teams gemeinsame Termintypen, Apps, Workflows und mehr erstellen können.", idt = "Pläne", adt = "Plattform", sdt = "Verwalten Sie alles, was mit der Plattform zusammenhängt.", cdt = "Mit der Cal.com-Plattform können Sie die Terminplanung mühelos mit Hilfe von Plattform-APIs und -Atoms in Ihre App integrieren.", ldt = "Es muss ein Name für die Organization eingegeben werden", udt = `Sie müssen Ihre Organization-Mailadresse eingeben
`, ddt = "Ihre Organization-E-Mail-Adresse", _dt = "Ihre Admin-E-Mail-Adresse", pdt = "Benutzername des Administrators", mdt = "Name der Organization", fdt = "Plattformname", gdt = "URL der Organization ", hdt = "Bestätigen Sie Ihre Organization-Mailadresse", vdt = "Bitte verwenden Sie den folgenden Code, um Ihre E-Mail-Adresse zu bestätigen, um die Einrichtung Ihrer Organization fortzusetzen.", bdt = "Zusätzliche URL-Parameter", ydt = "Über Ihre Organization", $dt = `Organizations sind geteilte Umgebungen, in denen Sie mehrere Teams mit gemeinsamen Mitgliedern, Termintypen, Apps, Workflows und mehr erstellen können.
`, wdt = "Erstellen Sie Ihre Teams", kdt = "Fangen Sie an, gemeinsam zu planen, indem Sie Ihre Teammitglieder zu Ihrer Organization hinzufügen", Sdt = "Laden Sie die Administratoren Ihrer Organization ein", Edt = "Diese Administratoren haben Zugriff auf alle Teams in Ihrer Organization. Sie können Team-Administratoren und -mitglieder später hinzufügen.", xdt = "Legen Sie ein Passwort fest", Cdt = "Dies wird ein neues Benutzerkonto mit Ihrer Organization-Mailadresse und diesem Passwort erstellen.", Tdt = "Logo der Organization", Adt = "Ein paar Sätze zu Ihrer Organization. Dies wird auf der öffentlichen Profilseite Ihrer Organization erscheinen.", Idt = "Ich werde das später tun", Odt = "Bestätigen Sie Ihre E-Mail-Adresse", Ndt = "Geben Sie den 6-stelligen Code ein, den wir an {{email}} gesendet haben", zdt = "Bestätigen Sie Ihre E-Mail-Adresse, um eine Organization zu erstellen", Rdt = "Der eingegebene Code ist ungültig, versuchen Sie es erneut", Pdt = "Die E-Mail-Adresse wird bereits verwendet", Ddt = "Sie wurden eingeladen, ein Mitglied von {{orgName}} zu werden", Ldt = "Schließen Sie sich Ihrem Team bei {{orgName}} an und konzentrieren Sie sich auf Ihre Meetings, nicht auf das Planen von Meetings!", Mdt = "Die folgenden Teams konnten aufgrund von doppelten Slugs nicht erstellt werden: {{slugs}}", Fdt = "Teamnamen dürfen nicht leer sein", qdt = "Teamnamen dürfen nicht bereits verwendet werden", jdt = "Der Benutzer gehört einer Organization an", Vdt = "Diese Organization hat noch keine Teams", Bdt = "Falls Sie ein Administrator sind, sollten Sie unbedingt Teams erstellen, welche hier angezeigt werden können.", Udt = "Einrichten", Gdt = "Mein Profil", Wdt = "Meine Einstellungen", Hdt = "CRM", Ydt = "Nachrichten", Kdt = "Name oder Nummer, welcher bzw. welche als Absender einer SMS angezeigt wird (einige Länder erlauben keine alphanumerischen Absender-IDs)", Zdt = "Nur der Administrator Ihrer Organization kann neue Teams erstellen", Xdt = "Googles neue Spam-Richtlinie könnte verhindern, dass du E-Mail- und Kalenderbenachrichtigungen über diese Buchung erhältst.", Jdt = "Problem lösen", Qdt = "Beim Erstellen von Teams für diese Organization ist ein Fehler aufgetreten. URL-Slug fehlt.", e_t = "Link zur Organization kopieren", t_t = "Team: {{teamName}}", n_t = "Benutzer: {{userName}}", o_t = "Erfahren Sie mehr über Ihre Termine und Ihr Team", r_t = "Anrufverlauf", i_t = "Anrufverlauf aller Cal.ai-Anrufe anzeigen", a_t = "{{locationCount}} Veranstaltungsort-Optionen", s_t = "Kanaltyp", c_t = "Beendigungsgrund", l_t = "Sitzungsstatus", u_t = "Nutzer-Stimmung", d_t = "Zeit", __t = "Von", p_t = "Maßgeschneiderter Tarif", m_t = "E-Mail Einbettung", f_t = "Zeiten zur E-Mail hinzufügen", g_t = "Zeit auswählen", h_t = "Datum auswählen", v_t = "Nur anzeigen, wenn ein Parameter gesetzt ist", b_t = "Parameter hinzufügen", y_t = "Wir verbinden Sie mit jemandem von {{orgName}}.", $_t = "Bitte schließen oder aktualisieren Sie diese Seite nicht", w_t = "Alle verfügbaren Zeiten ansehen", k_t = "z.B. Marketing-Team", S_t = "z.B. Vertriebsteam", E_t = "z. B. Design-Team", x_t = "z.B. Engineering-Team", C_t = "z.B. Data Analytics Team", T_t = "Weitere Teams können Sie zu einem späteren Zeitpunkt hinzufügen.", A_t = "Worum geht es in diesem Termin?", I_t = "Zum Team hinzufügen", O_t = "Benutzer aus der Organisation entfernen", N_t = "Delegierungsnachweis", z_t = "Der Delegierungsnachweis ermöglicht es Ihnen, den Zugriff auf Google Workspace-Kalender für Ihre Organisation zu verwalten.", R_t = "Fügen Sie diese Client-ID in Google Workspace mit dem folgenden Bereich hinzu", P_t = "Delegierungsnachweis aktiviert", D_t = "Delegierungsnachweis hinzufügen", L_t = "Delegierungsnachweis bearbeiten", M_t = "Domain", F_t = "Keine Workspace-Plattformen", q_t = "Workspace-Plattform", j_t = "Workspace-Plattformen", V_t = "Verwalten Sie Workspace-Plattformen, die für den Delegierungsnachweis verwendet werden können", B_t = "Workspace-Plattform bearbeiten", U_t = "Servicekonto bearbeiten", G_t = "Workspace-Plattform hinzufügen", W_t = "Slug", H_t = "Servicekonto-Schlüssel JSON", Y_t = "Servicekonto-Schlüssel JSON bearbeiten", K_t = "Der Delegierungsnachweis beschränkt das Hinzufügen von mehr als einer Installation", Z_t = "App erfolgreich installiert und verwendet delegierte Anmeldeinformationen", X_t = "Sind Sie sicher, dass Sie {{userCount}} Benutzer aus dieser Organisation entfernen möchten?", J_t = "Benutzer aus Team entfernen", Q_t = "Sind Sie sicher, dass Sie {{userCount}} Benutzer aus diesem Team entfernen möchten?", ept = "Dieser Benutzer hat noch keine Verfügbarkeitspläne eingerichtet", tpt = "Dieser Benutzer ist in keinem Team", npt = "Dieser Benutzer hat noch keine Apps installiert", opt = "Erfordert E-Mail-Verifizierung des Buchenden", rpt = "Um sicherzustellen, dass die E-Mail des Buchenden vor der Terminplanung verifiziert ist", ipt = "Textnachrichten können nur an Teilnehmer gesendet werden, wenn der Ereignistyp bestätigt werden muss.", apt = "Organisationen", spt = "Cal Video Logo hochladen", cpt = "Cal Video Logo aktualisieren", lpt = "Banner hochladen", upt = "Um sicherzustellen, dass Ihr Logo vor dem dunklen Hintergrund von Cal Video gut sichtbar ist, laden Sie bitte ein helles Bild im PNG- oder SVG-Format hoch, um die Transparenz zu erhalten.", dpt = "Weitere Teams", _pt = "Hier können Sie Teams innerhalb Ihrer Organisation sehen, zu denen Sie nicht gehören. Sie können sich bei Bedarf selbst hinzufügen.", ppt = "Sie gehören keiner Organisation an", mpt = "Keine weiteren Teams gefunden", fpt = "Es gibt keine weiteren Teams in dieser Organisation.", gpt = "Vorname des Teilnehmers", hpt = "Nachname des Teilnehmers", vpt = "Vorname der buchenden Person", bpt = "Nachname der buchenden Person", ypt = "Ihre monatliche Statistik", $pt = "Mitgliedsname", wpt = "Beliebteste Termine", kpt = "Hier ist Ihre Zusammenfassung der beliebten Termine für Ihr Team {{teamName}} der letzten 30 Tage", Spt = "Ich", Ept = "Meeting nicht verfügbar", xpt = "Monatliche Zusammenfassungs-E-Mail", Cpt = "Monatliche Statistik E-Mail für Teams", Tpt = "Verifizieren Sie Ihr Team, um das Senden von Nachrichten an Teilnehmer zu aktivieren", Apt = "Mitglied entfernt", Ipt = "Meine Verfügbarkeit", Opt = "Teamverfügbarkeit", Npt = "Sofortige Verfügbarkeit für Meetings", zpt = "Backup-Code", Rpt = "Backup-Codes", Ppt = "Jeder Backup-Code kann genau einmal verwendet werden, um Zugriff ohne Ihren Authentifikator zu gewähren.", Dpt = "Backup-Codes kopiert!", Lpt = "Backup-Code ist falsch.", Mpt = "Zugriff verloren", Fpt = "Keine Backup-Codes gefunden. Bitte generieren Sie diese in Ihren Einstellungen.", qpt = "Neue Organisation erstellt: Ausstehende Aktion", jpt = "Hallo, Administrator", Vpt = "Eine Organisation benötigt DNS-Konfiguration", Bpt = 'Eine Organisation mit slug "{{orgSlug}}" wurde erstellt.<br /><br />Bitte konfigurieren Sie Ihre DNS-Registry so, dass die Subdomain der neuen Organisation auf die Hauptanwendung verweist. Andernfalls wird die Organisation nicht funktionieren.<br /><br />Hier sind nur die grundlegenden Optionen, um eine Subdomain so zu konfigurieren, dass sie auf ihre App verweist, so dass sie die Organisationsprofilseite lädt.<br /><br />SIe können es entweder mit dem A Record machen:', Upt = "Oder der CNAME-Eintrag:", Gpt = "Sobald Sie die Subdomain konfiguriert haben, markieren Sie bitte die DNS-Konfiguration wie in den Organisationen Admin-Einstellungen.", Wpt = "Zu den Organisationen Admin-Einstellungen wechseln", Hpt = "Org wurde verarbeitet", Ypt = "Beim Verarbeiten dieser Organisation ist ein Fehler aufgetreten", Kpt = "Eine Liste aller Organisationen. Wenn Sie eine Organisation akzeptieren, können sich alle Benutzer mit dieser E-Mail-Domain OHNE E-Mail-Überprüfung registrieren.", Zpt = "Nicht verifiziert", Xpt = "Verifiziert", Jpt = "DNS fehlt", Qpt = "DNS konfiguriert", emt = "Als DNS konfiguriert kennzeichnen", tmt = "Wert", nmt = "Ihre Organisation wurde erfolgreich aktualisiert", omt = "Dieses Team hat keine Ereignistypen", rmt = "Platzoption unterstützt mehrere Dauern nicht", imt = "Kalenderereignis hinzufügen", amt = "OAuth", smt = "OAuth-Client-Erstellungsformular", cmt = "Dies ist das Formular zur Erstellung eines neuen OAuth-Clients", lmt = "OAuth-Client-Aktualisierungsformular", umt = "Dies ist das Formular zur Bearbeitung eines bestehenden OAuth-Clients", dmt = "Kürzlich hinzugefügt", _mt = "Verbinden Sie alle Ihre Kalender", pmt = "{{appName}} liest die Verfügbarkeit aus allen Ihren vorhandenen Kalendern.", mmt = "Personalisieren Sie Ihre Planungserfahrung mit Workflows", fmt = "Workflow-Automatisierung", gmt = "Planen Sie Ihr Team mit kollektiver Terminplanung und Round-Robin-Terminplanung", hmt = "Keine Mitglieder gefunden", vmt = "Verzeichnissynchronisierung", bmt = "Verzeichnisname", ymt = "Verzeichnisanbieter", $mt = "SCIM-Basis-URL", wmt = "SCIM-Bearer-Token", kmt = "SCIM-Basis-URL kopiert", Smt = "SCIM-Bearer-Token kopiert", Emt = "Ihr Identitätsanbieter wird nach den folgenden Informationen fragen, um SCIM zu konfigurieren. Befolgen Sie die Anweisungen, um die Einrichtung abzuschließen.", xmt = "Verzeichnissynchronisation konfigurieren", Cmt = "Wählen Sie einen Identitätsanbieter, um das Verzeichnis für Ihr Team zu konfigurieren.", Tmt = "Konfigurieren Sie einen Identitätsanbieter, um mit SCIM zu starten.", Amt = "Verzeichnissynchronisierungs-Verbindung erstellt.", Imt = `Bereitstellen und Entfernen von Nutzern mit Ihrem Verzeichnisanbieter.
`, Omt = "Verzeichnissynchronisierungs-Verbindung gelöscht.", Nmt = "Verbindung löschen", zmt = "Verzeichnissynchronisierungs-Verbindung löschen", Rmt = "Sind Sie sicher, dass Sie diese Verzeichnissynchronisierungs-Verbindung löschen möchten?", Pmt = "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird die Verzeichnissynchronisierungs-Verbindung dauerhaft löschen.", Dmt = "Ereignis-Einrichtung: Die Dauer muss mindestens 1 Minute betragen.", Lmt = "Verfügbarkeitspläne", Mmt = "Nicht authorisiert", Fmt = "{{clientName}} möchte auf Ihr {{appName}} Konto zugreifen", qmt = "Konto oder Team auswählen", jmt = "Dies wird {{clientName}} erlauben", Vmt = "Verknüpfen Sie sich mit Ihren persönlichen Daten von {{clientName}}", Bmt = "Ihre persönlichen Daten einzusehen, einschließlich persönlicher Informationen, die Sie öffentlich zugänglich gemacht haben", Umt = "Ihre primäre E-Mail-Adresse einzusehen", Gmt = "Sich mit Ihren installierten Apps zu verbinden", Wmt = "Lesen, Bearbeiten, Löschen Ihrer Ereignis-Typen", Hmt = "Lesen, Bearbeiten, Löschen Ihrer Verfügbarkeiten", Ymt = "Lesen, Bearbeiten, Löschen Ihrer Termine", Kmt = "{{clientName}} zulassen, dies zu tun?", Zmt = "Indem Sie auf „Erlauben“ klicken, erlauben Sie dieser App, Ihre Informationen gemäß ihrer Nutzungsbedingungen und Datenschutzrichtlinien zu verwenden. Sie können den Zugriff im {{appName}} App Store aufheben.", Xmt = "Zulassen", Jmt = "Dieser Benutzer hat das Onboarding noch nicht abgeschlossen. Sie können seine Verfügbarkeit erst festlegen, wenn er das Onboarding abgeschlossen hat.", Qmt = "Sie sehen die Verfügbarkeit dieses Benutzers. Sie können nur Ihre eigene Verfügbarkeit bearbeiten.", eft = "Sie können dies in den erweiterten Einstellungen pro Termin für jeden Termintyp überschreiben.", tft = "Benutzerverfügbarkeit bearbeiten: {{username}}", nft = "Einladung erneut senden", oft = "Die Einladung wurde erneut gesendet.", rft = "SAML", ift = "Kunde hinzufügen", aft = "Nach dem Kopieren des Geheimnisses können Sie es nicht mehr ansehen", sft = "Neuen Kunden hinzufügen", cft = "Neuen Benutzer hinzufügen", lft = "Diese App wurde noch nicht eingerichtet", uft = "als CSV", dft = "Meinen Kalender überlagern", _ft = "Durch das Verbinden mit Ihrem Kalender akzeptieren Sie unsere Datenschutzerklärung und Nutzungsbedingungen. Sie können den Zugriff jederzeit widerrufen.", pft = "Sehen Sie sich Ihre Kalendertermine an, um Buchungskonflikte zu vermeiden.", mft = "{{eventLocationType}} beitreten", fft = "Problembehandlung", gft = "Kalender, die wir auf Konflikte prüfen", hft = "Verfügbarkeitspläne", vft = "Kalender verwalten", bft = "Verfügbarkeitspläne verwalten", yft = "Gesperrt", $ft = "Freigeschaltet", wft = "Zeitzone auf der Buchungsseite sperren", kft = "Um die Zeitzone auf der Buchungsseite zu sperren, nützlich für Termine in Person.", Sft = "Sie können nur eine Zahlungs-App pro Ereignistyp aktiv haben.", Eft = "Bitte geben Sie die Nummer im internationalen Format ein.", xft = "Kalender installieren", Cft = "Marken-Subdomain", Tft = "Holen Sie sich Ihre eigene Marken-Subdomain, wie z.B. acme.cal.com", Aft = "Organisationsweite Insights", Ift = "Verstehen Sie, wie Ihre gesamte Organisation Zeit verbringt", Oft = "Dedizierte Onboarding- und Engineeringsupport", Nft = "Passen Sie Ihre Planungserfahrung mit Ihrem eigenen Logo, eigenen Farben und mehr an", zft = "Unbegrenzte Teams", Rft = "E-Mail bestätigen", Pft = "Bitte geben Sie die für diese Buchung verwendete E-Mail-Adresse ein, um mit der Stornierung fortzufahren", Dft = "E-Mail stimmt nicht mit der Buchungs-E-Mail überein", Lft = "Fügen Sie Ihrer Organisation so viele Unterteams hinzu, wie notwendig", Mft = "Einheitliche Abrechnung", Fft = "Erweiterte verwaltete Ereignistypen", qft = "Fügen Sie eine einzige Kreditkarte hinzu, um alle Abonnements Ihres Teams zu bezahlen", jft = "Unternehmen", Vft = "Upgraden Sie um Ihre Organisation zu erstellen", Bft = "Erstellen Sie Ihre Organisation", Uft = "Organisation erstellen", Gft = "Upgraden und erhalten Sie eine Subdomain, einheitliche Abrechnungen, Insights, umfangreiches Whitelabeling und mehr", Wft = "Rüsten Sie auf die Enterprise-Version auf, um Zugriff auf Active Directy Sync, SCIM automatische Benutzerbereitstellung, Cal.ai Voice Agents, Admin APIs und mehr zu erhalten!", Hft = "Sie können nur eine Zahlungs-App pro Ereignistyp aktivieren", Yft = "Teams, die Mitglied dieser Organisation sind, werden zusammen mit ihren Ereignistypen ebenfalls gelöscht", Kft = "Benutzer, die Teil der Organisation waren, werden nicht gelöscht, aber ihre Benutzernamen würden geändert werden, um ihnen zu ermöglichen, außerhalb der Organisation zu existieren", Zft = "Benutzer-Ereignistypen, die erstellt wurden, nachdem der Benutzer in der Organisation war, werden gelöscht", Xft = "Migrierte Benutzer-Ereignistypen werden nicht gelöscht", Jft = "{{organizationName}} löschen?", Qft = "Veröffentlicht", egt = "Unveröffentlicht", tgt = "Veröffentlichen", ngt = "Öffnen Sie die Problembehandlung und finden Sie heraus, was mit Ihrem Zeitplan nicht stimmt", ogt = "Brauchst du Hilfe?", rgt = "Problembehandlung", igt = "Nummer zum Anrufen", agt = "Gastname", sgt = "Gast-E-Mail", cgt = "Gastunternehmen", lgt = "Bitte installieren Sie einen Kalender", ugt = "Sofortige Buchung", dgt = "Personen sofort buchen lassen", _gt = "Rüsten Sie auf Enterprise auf und lassen Sie Ihre Gäste an einem Sofortanruf teilnehmen, an dem die Teilnehmer direkt teilnehmen können. Dies ist nur für Team-Ereignistypen verfügbar", pgt = "Sie möchten nicht warten?", mgt = "Meeting gestartet", fgt = "Zum Buchen bezahlen", ggt = "Lassen Sie sich von KI-Agenten buchen", hgt = "Buchung konnte nicht gefunden werden", vgt = "Die Buchungsplätze sind voll", bgt = "Fehlende Zahlungsinformationen", ygt = "Fehlende Zahlungsapp-ID", $gt = "Die Buchung hat nicht genügend Plätze verfügbar", wgt = "{{username}} ist derzeit kurzzeitig abwesend.", kgt = "In der Zwischenzeit wird {{profile.username}} für alle neuen geplanten Meetings im Namen von {{username}} verantwortlich sein.", Sgt = "Abwesend", Egt = "Konfigurieren Sie Aktionen in Ihrem Profil während Sie abwesend sind.", xgt = "Anfrage senden", Cgt = "Startdatum und Enddatum sind erforderlich", Tgt = "Das Startdatum muss vor dem Enddatum liegen", Agt = "Das Startdatum muss in der Zukunft liegen", Igt = "Benutzer nicht gefunden", Ogt = "Weiterleitung auf sich selbst nicht möglich", Ngt = "Abwesenheitseintrag existiert bereits", zgt = "Abwesenheitseintrags-ID erforderlich", Rgt = "Es besteht bereits eine Buchungsumleitung von diesem Benutzer zu Ihnen.", Pgt = "Neuer Eintrag wurde erfolgreich erstellt", Dgt = "Buchungsumleitungsbenachrichtigung", Lgt = "Buchungsumleitungsbenachrichtigung", Mgt = "Sie haben eine Buchungsumleitung von {{eventOwner}} erhalten. Deren Profillinks werden für den Zeitraum {{dates}} auf Ihre umgeleitet.", Fgt = "Benachrichtigung über Änderung der Buchungsumleitung", qgt = "Benachrichtigung über Änderung der Buchungsumleitung", jgt = "Ihre Buchungsumleitung von {{eventOwner}} für den Zeitraum {{oldDates}} wurde aktualisiert. Der neue Zeitraum für die Umleitung ist {{dates}}.", Vgt = "Benachrichtigung über Stornierung der Buchungsumleitung", Bgt = "Benachrichtigung über Stornierung der Buchungsumleitung", Ugt = "Ihre Buchungsumleitung von {{eventOwner}} für den Zeitraum {{dates}} wurde storniert.", Ggt = "Sie haben diese Buchungsumleitungsanfrage akzeptiert.", Wgt = "Sie haben diese Buchungsumleitungsanfrage abgelehnt.", Hgt = "Link zum Teilen der Anfrage kopieren", Ygt = "Buchungsumleitungsanfrage", Kgt = "Teammitglied auswählen", Zgt = "Verreisen Sie? Markieren Sie einfach Ihren Profillink für eine gewisse Zeit als nicht verfügbar.", Xgt = "Leiten Sie Ihr Profil an ein anderes Teammitglied um", Jgt = "Leiten Sie Ihr Profil an ein anderes Teammitglied um (Teamplan erforderlich)", Qgt = "Abwesenheits-Unverfügbarkeitsliste", eht = "Eintrag erfolgreich gelöscht", tht = "Abwesenheitseintrag erfolgreich bearbeitet", nht = "Temporär abwesend?", oht = "Umleitung hinzufügen", rht = "Eintrag erstellen", iht = "Zeitspanne", aht = "Alle Teammitglieder hinzufügen, einschließlich zukünftiger Mitglieder", sht = "Umleiten zu", cht = "Haben Sie Schwierigkeiten, ein Zeitfenster zu finden?", lht = "Mehr anzeigen", uht = "Weiterleitungsparameter wie ?email=...&name=.... und mehr", dht = "Planen Sie Meetings ein, wenn jeder verfügbar ist, oder rotieren Sie durch die Mitglieder Ihres Team", _ht = "Niedrigste", pht = "Niedrig", mht = "Mittel", fht = "Hoch", ght = "Höchste", hht = "Bucher senden an", vht = "Priorität festlegen", bht = "Gewichtung festlegen", yht = "Gewichtungen aktivieren", $ht = "Priorität von {{userName}}", wht = "Gewichtungen bestimmen, wie Meetings unter den Gastgebern verteilt werden. <0>Mehr erfahren</0>", kht = "Gewichtung für {{userName}}", Sht = "Priorität ändern", Eht = "Verwenden Sie Feldbezeichner als Variablen für Ihre benutzerdefinierte Ereignisumleitung", xht = "Verwenden Sie Feldbezeichner als Variablen für Ihre benutzerdefinierte Ereignisumleitung (z. B. {{variable}})", Cht = "Konto ist bereits verknüpft", Tht = "E-Mail senden", Aht = "Teilnehmer mit Cal.ai Sprachassistent anrufen", Iht = "Anruf zur Buchungsbestätigung", Oht = "2 Std. vor Terminbeginn", Nht = "Cal.ai Agent-Konfiguration", zht = "Bitte wählen Sie mindestens einen Ereignistyp aus, um einen Testanruf zu tätigen.", Rht = "Als No-Show markieren", Pht = "Markierung als No-Show entfernen", Dht = "Konto erfolgreich getrennt", Lht = "Beim Trennen der Verknüpfung des Kontos ist ein Fehler aufgetreten", Mht = "Reiseplan", Fht = "Planen Sie Ihre Reise im Voraus, um Ihren bestehenden Zeitplan in einer anderen Zeitzone zu behalten und zu verhindern, dass Sie um Mitternacht gebucht werden.", qht = "Zeitzonenänderung planen", jht = "Datum", Vht = "Geben Sie die allgemeine Aufforderung für den Agenten ein", Bht = "Dies überlappt sich mit einem bestehenden Zeitplan. Bitte wählen Sie ein anderes Datum.", Uht = "Erhalten Sie Benachrichtigungen, wenn Ihr Team keine Verfügbarkeiten hat", Ght = "Admins erhalten E-Mail-Benachrichtigungen, wenn ein Benutzer versucht, ein Teammitglied zu buchen, und „Keine Verfügbarkeit“ sieht. Wir lösen diese E-Mail nach zwei Vorfällen aus und erinnern Sie alle 7 Tage pro Benutzer.  ", Wht = "SMS-Benachrichtigungen für reine Telefon-Eventtypen deaktivieren", Hht = "Automatische SMS-Benachrichtigungen für Eventtypen deaktivieren, die nur Telefonnummer (attendeePhoneNumber) als Pflichtfrage haben, wobei E-Mail optional oder nicht erforderlich ist", Yht = "Ihr aktueller Tarif", Kht = "37 $ pro Benutzer pro Monat", Zht = "Privatsphäre-Einstellungen für Ihre Organisation verwalten", Xht = "Datenschutz", Jht = "Neue Teams werden unter Ihrer Organisation sein", Qht = "Gruppennamen hinzufügen", evt = "Gruppenname", tvt = "Router", nvt = "Primär", ovt = "Zur Primäradresse machen", rvt = "E-Mail-Adresse hinzufügen", ivt = "E-Mails hinzufügen", avt = "Fügen Sie eine E-Mail-Adresse hinzu, um die Ihre primäre E-Mail-Adresse ersetzt, oder als alternative E-Mail in Ihren Ereignistypen verwendet wird.", svt = "Bestätigen Sie Ihre E-Mail-Adresse", cvt = "$t(hey_there) {{name}}, wir bestätigen Ihre Buchung am {{date}}.", lvt = "Der Vorname der buchenden Person", uvt = "Der Nachname der buchenden Person", dvt = "Name des Planers", _vt = "Ihr Vorname", pvt = "Wir haben eine E-Mail an <strong>{{email}}</strong> gesendet. Klicken Sie auf den Link in der E-Mail, um diese Adresse zu bestätigen.", mvt = "Termindetails senden an", fvt = "Zeitzone ohne Enddatum einplanen", gvt = "Mitglieder auswählen", hvt = "Was soll mit den bestehenden Termintypen Ihres Mitglieds geschehen?", vvt = "Alle individuellen Termintypen (außer verwaltete Typen) von Ihren Mitgliedern werden dauerhaft gelöscht. Sie werden nicht in der Lage sein, neue zu erstellen", bvt = "Die individuellen Termintypen werden von Profilen verborgen (abgesehen von verwalteten), die Links werden jedoch weiterhin aktiv sein. Sie werden nicht in der Lage sein, neue zu erstellen.  ", yvt = "Einzelne Termintypen verbergen", $vt = "Einzelne Termintypen löschen", wvt = "Erstellung einzelner Termintypen sperren", kvt = "Mitglieder daran hindern, ihre eigenen Termintypen zu erstellen.", Svt = "Zu Termintyp hinzufügen", Evt = "Kontopasswort erstellen", xvt = "Konto mit SAML erstellen", Cvt = "Passwort konnte nicht erstellt werden", Tvt = "Kann kein Kontopasswort für Cal-Konten erstellen", Avt = "Es kann kein Passwort für bereits erstellte Konten erstellt werden", Ivt = "Sie haben kein Konto-Passwort. Erstellen Sie eines, indem Sie zu Sicherheit -> Passwort navigieren. Die Verbindung kann nicht getrennt werden, bis ein Konto-Passwort erstellt wurde.", Ovt = "Verbundenes Konto trennen", Nvt = "Das Trennen Ihres verbundenen Kontos ändert die Art und Weise, wie Sie sich anmelden. Sie können sich nur mit E-Mail + Passwort bei Ihrem Konto anmelden", zvt = "Ich stimme der Datenschutzerklärung und der Verwendung von Cookies zu", Rvt = "Anruf tätigen", Pvt = "Round-Robin-Zuweisung überspringen, wenn der Kontakt in Salesforce existiert", Dvt = "URL muss die E-Mail des Kontakts als Parameter enthalten, z. B. ?email=contactEmail", Lvt = "Konto auswählen", Mvt = "Installieren Sie {{appName}} auf Ihrem persönlichen Konto oder auf einem Teamkonto.", Fvt = "Termintypen auswählen", qvt = "Auf welchem Termintypen möchten Sie {{appName}} installieren?", jvt = "{{appName}} konfigurieren", Vvt = "App-Einrichtung abschließen. Sie können diese Einstellungen später ändern.", Bvt = "bereits installiert", Uvt = "Nicht angegeben", Gvt = "Urlaub", Wvt = "Verreist", Hvt = "Krankheitsurlaub", Yvt = "Feiertag", Kvt = "Weiterleitung an <0>{{username}}</0>", Zvt = "Keine Weiterleitung", Xvt = "Eine Abwesenheit erstellen", Jvt = "Informieren Sie Ihre Bucher, wann Sie nicht zur Buchung bereitstehen. Sie können immer noch von ihnen bei Ihrer Rückkehr buchen oder sie an ein Teammitglied weiterleiten.", Qvt = "{{displayName}} ist abwesend", ebt = "<0>{{displayName}}</0> kann die Meetings während der Abwesenheit abhalten.", tbt = "{{displayName}} buchen", nbt = "Grund auswählen", obt = "Abwesenheit eintragen", rbt = "Abwesenheitseintrag bearbeiten", ibt = "Feedback absenden", abt = "Ihr Gastgeber ist nicht erschienen", sbt = "Sie können ein anderes Meeting mit ihm bzw. ihr planen", cbt = "Wie können wir unseren Service verbessern?", lbt = "Was gefällt Ihnen am meisten?", ubt = "Überprüfung", dbt = "Überprüft", _bt = "Ungeprüft", pbt = "Bewertungs-URL", mbt = "Die URL für das Bewertungsfeedback-Formular", fbt = "No-Show-URL", gbt = "Die URL für Feedback zum Nichterscheinen anzeigen", hbt = "Keine Unterstützung erforderlich?", vbt = "Unterstützung ausblenden", bbt = "Durchschnittliche Bewertungen", ybt = "Nichterscheinen (Gastgeber)", $bt = "Nichterscheinen (Gast)", wbt = "Aktuelle Bewertungen", kbt = "Keine Bewertungen eingereicht", Sbt = "Fügen Sie einen Workflow mit „Bewertung“ hinzu, um Bewertungen nach Meetings zu sammeln", Ebt = "Meiste Nichterscheinungen", xbt = "Am besten bewertet", Cbt = "Am schlechtesten bewertet", Tbt = "Mitglieder mit den am höchsten bewerteten Meetings", Abt = "Mitglieder mit den am niedrigsten bewerteten Meetings", Ibt = "CSAT-Bewertung", Obt = "Gesperrte SMS", Nbt = "Verlassen, ohne jemanden zuzuordnen?", zbt = "Sind Sie sicher, dass Sie diesen Termin verlassen möchten, ohne Teilnehmer hinzuzufügen?", Rbt = "Wenn Sie niemanden für diesen Termin zuweisen, wird den Buchenden keine Verfügbarkeit angezeigt.", Pbt = "Zurück und zuweisen", Dbt = "Ohne Zuordnung verlassen", Lbt = "Indem Sie fortfahren, stimmen Sie unseren <0>Nutzungsbedingungen</0> und unserer <1>Datenschutzerklärung</1> zu.", Mbt = "Indem Sie fortfahren, stimmen Sie unseren", Fbt = "Nutzungsbedingungen", qbt = "Immer für {{x}} Tage verfügbar", jbt = "Verschiebt das {{x}}-Tage-Buchungsfenster automatisch jeden Tag nach vorne und stellt sicher, dass Ihr Kalender immer die nächsten {{x}} Tage mit verfügbaren Zeitfenstern anzeigt.", Vbt = "Team-Abonnement erfolgreich gekündigt", Bbt = "Fehler bei der Kündigung des Team-Abonnements", Ubt = "Beim Abonnieren des Platform-Plans ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", Gbt = "Beim Aktualisieren des OAuth-Clients ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", Wbt = "Beim Erstellen des OAuth-Clients ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", Hbt = "Farbe des Ereignistyps", Ybt = "Dies wird nur zur Unterscheidung von Ereignistypen und Buchungen innerhalb der App verwendet. Es wird den Buchenden nicht angezeigt.", Kbt = "Als nicht erschienen markieren", Zbt = "{{x}} als No-Show markiert", Xbt = "No-Show-Markierung von {{x}} entfernt", Jbt = "Auslöser für alle Team-Ereignistypen und persönliche Ereignistypen aller Teammitglieder", Qbt = "Verwalte die Einstellungen für dein Team", eyt = "No-Show-Status für Teilnehmer aktualisiert", tyt = "E-Mail kopiert", nyt = "Telefonnummer kopiert", oyt = "Benutzer ist ein ausstehendes Mitglied der Organisation", ryt = "Benutzer ist bereits ein Mitglied oder eingeladen", iyt = "Benutzer ist Mitglied einer Organisation, zu der dieses Team nicht angehört.", ayt = "Buchung wurde neu zugewiesen", syt = "Neu zuweisen", cyt = "Buchung einem anderen verfügbaren Round-Robin-Gastgeber zuweisen", lyt = "Teammitglied zuweisen", uyt = "Überschreiben Sie, welches Teammitglied Sie zuweisen möchten.", dyt = "Keine verfügbaren Gastgeber", _yt = "Round-Robin-Gastgeber neu zuweisen", pyt = "Nicht in den ICS-Feed schreiben", myt = "Eine Umbuchung ist nicht möglich, da das Ereignis abgelaufen ist", fyt = "Dieses Ereignis ist abgelaufen", gyt = "Kontakte nicht erstellen, wenn sie in {{appName}} nicht existieren", hyt = "Wenn Ihr ICS-Link schreibgeschützt ist (z.B. Proton Calendar), aktivieren Sie das obige Kontrollkästchen, um Fehler zu vermeiden. Sie müssen Ihren Kalender auch manuell aktualisieren, um Änderungen zu übernehmen.", vyt = "Attribute", byt = "Neues Attribut", yyt = "Attribute hinzufügen", $yt = "Fügen Sie Ihren Teammitgliedern Attribute hinzu", wyt = "Neue Option", kyt = "Mitglied aktualisieren", Syt = "Attribut", Eyt = "Erstelle ein Attribut für deine Teammitglieder", xyt = "Bearbeite ein Attribut für deine Teammitglieder", Cyt = "Attribut erfolgreich aktualisiert", Tyt = "Attribut erfolgreich gelöscht", Ayt = "Attribute erfolgreich bearbeitet", Iyt = "Verwalten Sie Attribute für Ihre Teammitglieder", Oyt = "Bearbeiten Sie Attribute für Ihre Teammitglieder", Nyt = "Zurück zu den Attributen", zyt = "Sind Sie sicher, dass Sie diese Option löschen möchten?", Ryt = "Diese Option ist {{numberOfUsers}} Mitgliedern zugewiesen. Durch das Löschen wird sie aus deren Profil entfernt.", Pyt = "Standardmäßige E-Mails an Teilnehmer für diesen Ereignistyp deaktivieren", Dyt = "Deaktiviert die standardmäßige E-Mail-Kommunikation für diesen Ereignistyp, einschließlich Buchungsbestätigungen, Erinnerungen und Stornierungen.", Lyt = "Standardmäßige E-Mails an Gastgeber für diesen Ereignistyp deaktivieren", Myt = "Geben Sie 'bestätigen' ein, um fortzufahren", Fyt = "E-Mail deaktivieren", qyt = "Admin-API-Zugriff gewähren", jyt = "Admin-API-Zugriff widerrufen", Vyt = "{{calendar}}-Kalender hinzufügen", Byt = "Apple Kalender verbinden", Uyt = "Apple Kalender verbunden", Gyt = "Apple Kalender wird überprüft", Wyt = "Google Kalender verbinden", Hyt = "Google Kalender verbunden", Yyt = "Google Kalender wird überprüft", Kyt = "Outlook Kalender verbinden", Zyt = "Outlook Kalender verbunden", Xyt = "Outlook Kalender wird überprüft", Jyt = "Mit Stripe verbinden", Qyt = "Stripe verbunden", e$t = "Überprüfe Stripe-Anmeldedaten", t$t = "Variablen für Buchungsfragen-Antworten", n$t = "Verwaltet von {{teamAdmins}}", o$t = "{{count}} Optionen", r$t = "Mit demselben Round-Robin-Gastgeber neu planen", i$t = "Neu geplante Ereignisse werden demselben Gastgeber zugewiesen wie ursprünglich geplant", a$t = "Eingabe deaktivieren, wenn die URL-Kennung vorausgefüllt ist", s$t = "Buchungslimits", c$t = "Buchungslimits für Teammitglieder über alle Team-Ereignistypen hinweg", l$t = "Begrenzen Sie, wie oft Mitglieder über alle Team-Ereignistypen hinweg gebucht werden können", u$t = "Buchungslimits erfolgreich aktualisiert", d$t = "Sie sind nicht berechtigt, diese Änderung an der Buchung vorzunehmen", _$t = "Delegierungsnachweis deaktiviert", p$t = "Passende Mitglieder", m$t = "{{x}} passende Mitglieder", f$t = "Warteschlange für passende Mitglieder (mit Attributgewichtung)", g$t = "Warteschlange für passende Mitglieder (mit Gewichtung der Terminverantwortlichen)", h$t = "Keine passenden Mitglieder gefunden. Es wird auf die dem Ereignistyp zugewiesenen Teammitglieder zurückgegriffen.", v$t = "Keine passenden Mitglieder gefunden. Es wird auf alle dem Ereignistyp zugewiesenen Teammitglieder zurückgegriffen. Erwägen Sie, eine Fallback-Option hinzuzufügen oder die Logik für using_fallback_members zu korrigieren", b$t = "Kalenderereignisdetails in geteilten Kalendern verbergen", y$t = "Wenn ein Kalender geteilt wird, sind Ereignisse für Leser sichtbar, aber ihre Details bleiben für Personen ohne Schreibzugriff verborgen.", $$t = "Letzte {{count}} Tage", w$t = "Aktueller Monat", k$t = "Aktuelles Jahr", S$t = "Benutzerdefinierter Zeitraum", E$t = "Rückerstattungsrichtlinie", x$t = "Immer", C$t = "Nie", T$t = "Zahlungsoption", A$t = "Bei Stornierung", I$t = "vor", O$t = "Alle Spalten anzeigen", N$t = "Spalten ein-/ausblenden", z$t = "Keine Spalten gefunden", R$t = "Bei der Buchung Ereignisse und neue Teilnehmer hinzufügen als:", P$t = "Lead", D$t = "Kontakt unter einem Account", L$t = "Überspringen Sie die Erstellung eines {{entry}}-Datensatzes, wenn dieser nicht in Salesforce existiert", M$t = "Wenn der Kontakt nicht unter einem Account existiert, erstellen Sie einen neuen Lead aus dem Teilnehmer", F$t = "Erstellen Sie einen neuen Kontakt unter einem Account basierend auf der E-Mail-Domain des Teilnehmers und bestehenden Kontakten", q$t = "Datensatzinhaber bei Buchung ändern", j$t = "Attribute massenweise zuweisen", V$t = "Es führt zur Anzeige einer benutzerdefinierten Nachricht. Versuchen Sie, die Antwort zu ändern, um zu einem Ereignis weiterzuleiten", B$t = "Es führt zur Weiterleitung auf {{externalUrl}}. Versuchen Sie, die Antwort zu ändern, um zu einem Ereignis weiterzuleiten", U$t = "Möglicher Gastgeber", G$t = "Aktueller Weiterleitungsstatus", W$t = "Buchung umleiten", H$t = "Leiten Sie die Buchung an andere Teammitglieder um", Y$t = "Neue Route überprüfen", K$t = "Umleiten", Z$t = "Neuer Weiterleitungsstatus", X$t = "Wenn der Teilnehmer in Salesforce existiert, buchen Sie direkt beim Besitzer", J$t = "Entität, deren Besitzer für die direkte Buchung überprüft werden soll", Q$t = "Account", ewt = "Zeitpläne der Gastgeber auswählen", twt = "Sie können für jeden Gastgeber einen anderen Zeitplan auswählen. Standardmäßig wird der Standardzeitplan jedes Gastgebers ausgewählt.", nwt = "Keine Gastgeber zugewiesen. Fügen Sie Gastgeber im Zuweisungs-Tab hinzu.", owt = "Round-Robin-Gastgeber manuell neu zuweisen", rwt = "Round-Robin-Gastgeber manuell einem anderen verfügbaren Gastgeber neu zuweisen", iwt = "Round-Robin-Gastgeber einem anderen verfügbaren Gastgeber neu zuweisen", awt = "Neuer Benutzer ist kein gültiger Round-Robin-Gastgeber für diesen Ereignistyp", swt = "Neuer Benutzer ist ein fester Gastgeber für diesen Ereignistyp", cwt = "Mit gleichem Zeitfenster neu planen", lwt = "Mit gleichem Zeitfenster des neuen Ereignisses neu planen", uwt = "Zum neuen Ereignis mit anderem Zeitfenster neu planen", dwt = "Mit anderem Zeitfenster neu planen", _wt = "Wir haben keine ID für das neue Ereignis. Bitte gehen Sie zum Routing-Formular und speichern Sie es erneut.", pwt = "Buchung erfolgreich umgeleitet. Weiterleitung zur Buchungsseite", mwt = "Bei Buchung in Ereignisobjekt schreiben", fwt = "Feldname", gwt = "Neues Feld hinzufügen", hwt = "Sie haben keine Berechtigung, diese Buchung umzuleiten", vwt = "Formularantwort nicht gefunden", bwt = "Kontaktinhaber", ywt = "Nicht gefunden", $wt = "Verwendung von Fallback-Mitgliedern", wwt = "Gewählte Route", kwt = "Attributlogik zutreffend", Swt = "Attributlogik-Fallback zutreffend", Ewt = "Alle zugewiesenen Mitglieder des Team-Ereignistyps. Erwägen Sie, einige Attributregeln hinzuzufügen.", xwt = "Alle zugewiesenen Mitglieder des Team-Ereignistyps. Erwägen Sie, einige Attributregeln für den Fallback hinzuzufügen.", Cwt = "Alle zugewiesenen Mitglieder des Team-Ereignistyps. Erwägen Sie, den Fallback anzupassen, um eine Übereinstimmung zu erzielen.", Twt = "Warnung", Awt = "Fallback: Wenn keine Teammitglieder übereinstimmen, verwenden Sie diejenigen, die den folgenden Kriterien entsprechen (standardmäßig alle zugewiesenen Teammitglieder des Ereignisses)", Iwt = "Fallback-Warnung", Owt = "Nicht erforderlich", Nwt = "Gastgeber nicht verfügbar", zwt = "Gastgeber verfügbar", Rwt = "Sind Sie sicher, dass Sie diese Buchung einem nicht verfügbaren Gastgeber neu zuweisen möchten?", Pwt = "Sind Sie sicher, dass Sie diese Buchung neu zuweisen möchten?", Dwt = "Ja, neu zuweisen", Lwt = "Nach Attributen filtern", Mwt = "Grund für die Neuzuweisung", Fwt = "Das Ändern des Feldtyps kann zu Datenverlust führen. Bitte erstelle stattdessen ein neues Feld.", qwt = "Neu zugewiesen von", jwt = "Zeile", Vwt = "Zeilen", Bwt = "Zeitzone des Teilnehmers", Uwt = "Ereignis-Startzeit in der Zeitzone des Teilnehmers", Gwt = "Ereignis-Startzeit in der Zeitzone des Teilnehmers", Wwt = "Ereignis-Endzeit in der Zeitzone des Teilnehmers", Hwt = "Ereignis-Endzeit in der Zeitzone des Teilnehmers", Ywt = "Event für Kontakt erstellen, falls vorhanden. Andernfalls auf Lead zurückgreifen", Kwt = "Zu ändernder Besitzername", Zwt = "Kein Filter gesetzt", Xwt = "Buchungs-Testlauf erfolgreich", Jwt = "Der Testlauf wurde erfolgreich abgeschlossen.", Qwt = "Sie haben keinen Zugriff auf diese Seite", ekt = "Um diese Seite anzuzeigen oder mit ihr zu interagieren, benötigen Sie Administrator- oder Eigentümerrechte", tkt = "Feldtyp", nkt = "Wann schreiben", okt = "Bei Buchung in ein benutzerdefiniertes Feld des Teilnehmer-{{record}}-Datensatzes schreiben", rkt = "Bei jeder Buchung", ikt = "Nur wenn das Feld leer ist", akt = "Buchungs-Startdatum", skt = "Buchungs-Erstellungsdatum", ckt = "Buchung an {{host}} neu zugewiesen", lkt = "Kein Kontaktinhaber", ukt = "Erstellte Weiterleitungsformulare", dkt = "Gesamtantworten", _kt = "Gesamtantworten ohne Buchung", pkt = "Gesamtantworten mit Buchung", mkt = "Keine Buchungen", fkt = "Formularname", gkt = "Buchung", hkt = "Keine Buchung", vkt = "Gebucht von", bkt = "Erstellt am", ykt = "Buchungsstatus", $kt = "Gebucht am", wkt = "Eingereicht am", kkt = "Weiterleitungs-URL kopieren", Skt = "Weiterleitungs-URL beim Verlassen", Ekt = "Gesamtbuchungen pro Zeitraum", xkt = "Weitergeleitet pro Zeitraum", Ckt = "Pro Tag", Tkt = "Pro Woche", Akt = "Pro Monat", Ikt = "Zuweisungsgrund", Okt = "Zugriff verweigert", Nkt = "Der Kontaktinhaber wird der Round Robin Host sein, falls verfügbar", zkt = "Neue Teilnehmer hinzufügen als", Rkt = "Der Kontaktinhaber wird nicht erzwungen (kann trotzdem Host sein, wenn die Attribute und Round Robin Kriterien übereinstimmen)", Pkt = "Weiterleitung an einen Benutzer, der mit einem Lookup-Feld eines Accounts übereinstimmt", Dkt = "Salesforce-Option", Lkt = "Name des Lookup-Felds", Mkt = "Bei Teilnehmern mit einer kostenlosen E-Mail-Domain die Eigentümerprüfung überspringen und round robin wie gewohnt durchführen", Fkt = "Ist", qkt = "Ist nicht", jkt = "Enthält", Vkt = "Enthält nicht", Bkt = "Beginnt mit", Ukt = "Endet mit", Gkt = "Ist leer", Wkt = "Ist nicht leer", Hkt = "Titel und Beschreibung automatisch übersetzen", Ykt = "Titel und Beschreibungen automatisch in die Browsersprache des Besuchers mittels KI übersetzen.", Kkt = "Verteilung", Zkt = "Ermöglicht die Optimierung der Verteilung für maximale Verfügbarkeit oder eine ausgewogenere Zuweisung.", Xkt = "Verfügbarkeit maximieren", Jkt = "Ermöglicht Buchenden, Meetings zu buchen, wann immer ein Host verfügbar ist. Nutzen Sie dies, um die Anzahl potenzieller Meetings zu maximieren, wenn die gleichmäßige Verteilung der Meetings auf die Hosts weniger wichtig ist.", Qkt = "Lastverteilung", e0t = "Wir überwachen, wie viele Buchungen bei jedem Host eingegangen sind und vergleichen dies mit anderen. Hosts, die zu weit voraus sind, werden temporär deaktiviert, damit die Buchungen gleichmäßig verteilt werden.", t0t = "Gewichtungen bearbeiten", n0t = "Gewichtungen erfolgreich aktualisiert", o0t = "Bestätigung nur für kostenlose E-Mail-Anbieter erforderlich (z.B. @gmail.com, @outlook.com)", r0t = "E-Mails ausschließen, die ... enthalten", i0t = "E-Mails müssen enthalten ...", a0t = "Bitte geben Sie eine gültige Geschäfts-E-Mail-Adresse ein", s0t = "Sie dürfen mit dieser E-Mail-Domain keine Buchung vornehmen. Bitte kontaktieren Sie den Besitzer dieses Links.", c0t = "Spalten durchsuchen", l0t = "Suchoptionen", u0t = "Öffentliches Organisationsprofil deaktivieren und weiterleiten", d0t = "Leitet {{orgSlug}}.cal.com zu {{destination}} weiter", _0t = "Einfachauswahl", p0t = "Mehrfachauswahl", m0t = "Kalender-Konflikt-Einstellungen", f0t = "Wählen Sie die Kalender aus, die auf Konflikte überprüft werden sollen", g0t = "Gruppenbesprechung", h0t = "Sind Sie sicher, dass Sie diese App entfernen möchten von", v0t = "App trennen von", b0t = "Keine neuen Datensätze für Gäste erstellen, die zur Buchung hinzugefügt wurden", y0t = "Google Meet", $0t = "Zoom", w0t = "MS Teams Video", k0t = "Für Zuweisung sperren", S0t = "Die Sperrung erlaubt Zuweisungen nur über die Verzeichnissynchronisierung", E0t = "Attribut erfolgreich bearbeitet", x0t = "Neue Gruppenoption", C0t = "Gewichtungen aktiviert", T0t = "Durch die Aktivierung von Gewichtungen ist es möglich, bestimmten Attributen pro Benutzer eine höhere Priorität zuzuweisen. Je höher die Gewichtung, desto höher die Priorität.", A0t = "Weitergeleitet", I0t = "Neu zugewiesen", O0t = "Umbuchung vergangener Termine erlauben", N0t = "Wenn diese Option aktiviert ist, können vergangene Termine umgebucht werden", z0t = "Umgeleitet", R0t = "Salesforce-Zuweisung", P0t = "Router-Position", D0t = "Passende Hosts anzeigen", L0t = "Keine aktiven Warteschlangen für diese Eingabe", M0t = "Gewichtung", F0t = "Kalibrierung", q0t = "Fehlmenge", j0t = "Routing-Formular", V0t = "Zurück und speichern", B0t = "Änderungen speichern", U0t = "Ohne speichern verlassen", G0t = "Sind Sie sicher, dass Sie die Änderungen an Ihrem Routing-Formular nicht speichern möchten?", W0t = "Ein unerwarteter Fehler ist aufgetreten", H0t = "Sie führen eine Testbuchung durch.", Y0t = "Icon-Übersicht", K0t = "Icons-Übersicht", Z0t = "Migration vom Team", X0t = "Funktion ist derzeit deaktiviert", J0t = "Option auswählen", Q0t = "Optionswert eingeben", e1t = "Option entfernen", t1t = "Attributgewichtungen verwenden", n1t = "Wenn aktiviert, werden alle im Ereignistyp festgelegten Gewichtungen ignoriert", o1t = "Attribut für Gewichtungen", r1t = "Verwaltete Benutzer", i1t = "Sehen Sie alle verwalteten Benutzer, die von Ihrem OAuth-Client erstellt wurden", a1t = "Können Sie mir etwas erzählen über ", s1t = "Nutzen Sie KI, um Ihre Fragen zu beantworten", c1t = "Fehler beim Abrufen der Antwort ", l1t = "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut", u1t = "OAuth-Client auswählen", d1t = "Bei jeder Instanz", _1t = "Die Funktion für den Delegierungsnachweis ist für Ihre Organisation nicht aktiviert", p1t = "Interner Vermerk", m1t = "Grund, der dem Kunden mitgeteilt wird (optional)", f1t = "Dieser Vermerk ist nur für Mitglieder deines Teams sichtbar", g1t = "Vorlagen für interne Stornierungsvermerke", h1t = "Erstelle Vorlagen für interne Vermerke, die auf Buchungen angewendet werden können", v1t = "Vorlagen für interne Vermerke erfolgreich aktualisiert", b1t = "Vorlage hinzufügen", y1t = "Autorisieren", $1t = "Weiter", w1t = "Ausblenden", k1t = "Anzeigen", S1t = "UTM-Parameter", E1t = "Keine UTM-Parameter verfügbar.", x1t = "Aufsteigend", C1t = "Absteigend", T1t = "E-Mail-Änderung bestätigen", A1t = "Credits kaufen", I1t = "Credits", O1t = "Verbrauchte Credits", N1t = "Verbleibende Gesamtanzahl", z1t = "Sie erhalten 1000 Credits pro Monat pro Teammitglied", R1t = "Sie erhalten 750 Credits pro Monat pro Teammitglied", P1t = "Credits für den Versand von SMS-Nachrichten anzeigen und verwalten", D1t = "Credits für das Senden von SMS-Nachrichten anzeigen und verwalten. Ein Credit entspricht 1¢ (USD). <0>Mehr erfahren</0>", L1t = "Ein Credit entspricht 1¢ (USD). <0>Mehr erfahren</0>", M1t = "Zusätzliche Credits kaufen (0,01 $ pro Credit)", F1t = "Zusätzliche Credit-Ausgaben können Sie in Ihrem Ausgabenprotokoll einsehen", q1t = "Übersicht", j1t = "Der Organisations-Slug ist bereits vergeben", V1t = "Sie können keine Organisation erstellen, da Sie bereits Teil einer Organisation sind", B1t = "Sie müssen das Benutzer-Onboarding abschließen, bevor Sie eine Organisation erstellen können", U1t = "Verwenden Sie die Firmen-E-Mail-Adresse, um eine Organisation zu erstellen", G1t = "Sie können keine Plattform-Organisation erstellen, da Sie bereits Teil eines Teams sind", W1t = "Sie müssen mindestens veröffentlichte Teams haben", H1t = "Sie sind bereits Teil dieser Organisation", Y1t = "Sie sind Teil einer anderen Organisation und können keine neue Organisation erstellen", K1t = "Sie sind Teil einer anderen Plattformorganisation und können keine neue Organisation erstellen", Z1t = "Organisationszahlung erfolgreich", X1t = "Ihre Organisation wurde erfolgreich erstellt", J1t = "Dies kann einige Sekunden dauern...", Q1t = "Status des Organisations-Onboardings", eSt = "Beschreibung des Organisations-Onboarding-Status", tSt = "Zahlung fehlgeschlagen", nSt = "Ihre Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut.", oSt = "Ihre Organisation wird erstellt", rSt = "Organisations-Onboarding bereits abgeschlossen", iSt = "Organisations-Onboarding existiert bereits", aSt = "Organisations-Onboarding nicht gefunden", sSt = "Zahlung erfolgreich!", cSt = "Übergabe-Onboarding", lSt = "Übergabe des Onboardings an den Benutzer", uSt = "Eine organisation mit diesem slug existiert bereits", dSt = "Sie haben keine berechtigung, eine organisation für diese e-mail-adresse zu erstellen", _St = "Sie haben keine berechtigung, eines oder mehrere der teams zu migrieren", pSt = "Die organisation hat bereits ein abonnement", mSt = "Intervall für gewichtetes Round Robin zurücksetzen", fSt = "Intervall", gSt = "Legt fest, wie oft der Round Robin Buchungszähler zurückgesetzt wird, um eine ausgewogene Verteilung zu gewährleisten.", hSt = "Täglich", vSt = "Sie haben kein Enddatum für Ihre Abwesenheit festgelegt", bSt = "Meine Abwesenheit", ySt = "Team-Abwesenheit", $St = "Verwalten Sie die Abwesenheiten Ihres Teams.", wSt = "Abwesenheit erstellen", kSt = "Erstellen Sie eine Abwesenheit für ein Teammitglied", SSt = "Bearbeiten Sie eine Abwesenheit für ein Teammitglied", ESt = "Abwesenheit für Ihr Team erstellen", xSt = "Informieren Sie Bucher, wenn Ihre Teammitglieder nicht für Buchungen verfügbar sind. Sie können bei ihrer Rückkehr immer noch gebucht werden, oder Sie können sie an ein anderes Teammitglied weiterleiten.", CSt = "Abwesenheitsweiterleitung ist nur an ein Mitglied desselben Teams erlaubt.", TSt = "Es gibt bereits eine umgekehrte Weiterleitung zwischen diesen Benutzern.", ASt = "Keine vorherige Abwesenheit gefunden", ISt = "Vorherige", OSt = "Round Robin-Intervall erfolgreich aktualisiert", NSt = "Testmodus", zSt = "Inaktiver Team-Plan", RSt = "Ihr Team-Plan ist inaktiv. Überprüfen Sie Ihr Abonnement oder wenden Sie sich an den Kundensupport", PSt = "Eingeschränkter Zugriff während der Testphase. Funktion nach Ablauf der Testphase verfügbar.", DSt = "Empfehlungsprogramm", LSt = "Verdiene 20% Empfehlungsbonus", MSt = "Du benötigst einen Dub API-Schlüssel und eine Programm-ID, um diese Seite zu nutzen.", FSt = "UID", qSt = "Link", jSt = "Zeilen pro Seite", VSt = "{{currentRange}} von {{totalItems}}", BSt = "Tipp: Sie können ein '+' zwischen Benutzernamen einfügen: cal.com/anna+brian, um ein dynamisches Gruppenmeeting zu erstellen", USt = "Sie haben noch kein Team", GSt = "Sie haben noch keine Teammitglieder", WSt = "Wiederkehrende Events unterstützen die Sitzplatzfunktion nicht. Machen Sie es zu einem einmaligen Event, um Sitzplätze zu aktivieren.", HSt = "Wiederkehrende Ereignisse unterstützen die Funktion zur Buchungsbegrenzung pro Bucher nicht. Deaktiviere die Buchungsbegrenzung pro Bucher, um wiederkehrende Ereignisse zu aktivieren.", YSt = "Die Sitzplatzfunktion unterstützt keine wiederkehrenden Events. Deaktivieren Sie die Sitzplatzfunktion, um es wiederkehrend zu machen.", KSt = "Wiederkehrende Events unterstützen die Sitzplatzfunktion nicht. Deaktivieren Sie die Sitzplatzfunktion oder machen Sie das Event nicht wiederkehrend.", ZSt = "Segment", XSt = "Gespeicherte Filter", JSt = "Umbenennen", QSt = "Segment umbenennen", eEt = "Segment löschen", tEt = "Segment duplizieren", nEt = "Sind Sie sicher, dass Sie dieses Segment löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.", oEt = "Filtersegment aktualisiert", rEt = "Fehler beim Aktualisieren des Filtersegments", iEt = "Filtersegment dupliziert", aEt = "Fehler beim Duplizieren des Filtersegments", sEt = "Filtersegment gelöscht", cEt = "Fehler beim Löschen des Filtersegments", lEt = "Segment speichern", uEt = "Segment nicht gefunden", dEt = "Filtersegment gespeichert", _Et = "Keine Segmente", pEt = "Fehler beim Speichern des Filtersegments", mEt = 'Überschreibungen in "{{name}}" speichern', fEt = "Neues Segment erstellen", gEt = "Für Team speichern", hEt = "Team auswählen", vEt = "Bitte wähle ein Team aus", bEt = "Persönlich", yEt = "Team-Profillink ausblenden", $Et = "Den Team-Profillink auf Buchungsseiten ausblenden", wEt = "Anzeige", kEt = "Konnte keinen Slug finden, um die Organisation zu veröffentlichen", SEt = "Auswahlliste", EEt = "Meiste stornierte Buchungen", xEt = "Oberflächensprache", CEt = "Legen Sie Ihre bevorzugte Sprache für die Buchungsoberfläche fest", TEt = "Browsersprache des Besuchers", AEt = "Name oder E-Mail", IEt = "Wenn kein Kontakt gefunden wird, auf den Lead-Eigentümer zurückgreifen, falls vorhanden", OEt = "Kauf von Credits fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.", NEt = "Mindestens 50 Credits erforderlich", zEt = "Delegierungsnachweis aktivieren", REt = "Gewähren Sie Cal.com automatischen Zugriff auf die Kalender aller Organisationsmitglieder, indem Sie den Delegierungsnachweis aktivieren.", PEt = "Delegierungsnachweis deaktivieren", DEt = "Sobald die Delegationsanmeldedaten deaktiviert sind, müssen Organisationsmitglieder, die ihre Kalender noch nicht verbunden haben, dies manuell tun.", LEt = "Zuletzt aktiv", MEt = "Mitglied seit", FEt = "Zuletzt aktualisiert", qEt = "Bei stornierter Buchung in den Ereignisdatensatz schreiben, anstatt das Ereignis zu löschen", jEt = "Bei jeder Stornierung", VEt = "Problem melden", BEt = "Sie können ein Ticket auf GitHub einreichen oder Ihren Plan upgraden, um Echtzeit-Support mit Entwicklerkonferenzen zu erhalten", UEt = "Problem öffnen", GEt = "Dies ist Ihr aktueller Plan", WEt = "Einen Termin vereinbaren", HEt = "Dies beinhaltet:", YEt = "OAuth-Client erfolgreich aktualisiert", KEt = "OAuth-Client nicht gefunden.", ZEt = "Plattform abonnieren", XEt = "Fehler beim Zugriff auf Webhooks.", JEt = "Aktualisierung des Webhooks fehlgeschlagen.", QEt = "Erstellung des Webhooks fehlgeschlagen.", ext = "Ungültiger Link", txt = "Sie haben derzeit den {{planFirstLetter}}{{planRest}}-Plan abonniert", nxt = "Benutzer/Team", oxt = "Client-ID kopiert!", rxt = "Client-Secret kopiert!", ixt = "Das Cal.com-Team führt geplante Wartungsarbeiten durch. Bei Fragen wenden Sie sich bitte an den Support.", axt = "Ihre Zahlung ist fehlgeschlagen", sxt = "Überprüfen Sie Ihren Posteingang", cxt = "Dein Konto wurde erstellt, aber dein Premium-Name wurde nicht reserviert.", lxt = "Wir haben eine E-Mail an {{email}} mit einem Link zur Aktivierung deines Kontos gesendet.", uxt = "Sobald du dein Konto aktiviert hast, kannst du erneut versuchen, deinen Premium-Benutzernamen zu kaufen oder einen anderen auswählen.", dxt = "In Gmail öffnen", _xt = "Keine E-Mail erhalten?", pxt = "Erneut senden in {{seconds}} Sekunden", mxt = "Erneut senden", fxt = "Bestätigungs-E-Mail gesendet", gxt = "Alle Mitglieder auswählen", hxt = "Wenn du alle Mitglieder auswählst, werden alle zukünftigen Teammitglieder hinzugefügt, sobald sie dem Team beitreten.", vxt = "Formulareinstellungen", bxt = "Whitelist-Status entfernen", yxt = "Benutzer-Workflows zur Whitelist hinzufügen", $xt = "Benutzer-Workflows zur Whitelist hinzugefügt", wxt = "Benutzer-Workflows von der Whitelist entfernt", kxt = "Datum und Uhrzeit", Sxt = "Dies ist eine Erinnerung an Ihre bevorstehende Veranstaltung.", Ext = "Diese Erinnerung wurde durch einen Workflow in Cal ausgelöst.", xxt = "Ereignis", Cxt = "Terminplanung durch", Txt = "Wie war Ihre letzte Erfahrung?", Axt = "Wir arbeiten ständig daran, das Kundenerlebnis zu verbessern.", Ixt = "Wie zufrieden waren Sie mit Ihrer letzten Besprechung?", Oxt = "nicht am Meeting teilgenommen?", Nxt = "Hier neu planen.", zxt = "E-Mail-Adresse des Organisators verbergen", Rxt = "Du bist bereits Teil einer Plattform-Organisation, weshalb du keine neue Organisation erstellen kannst. Jeder Benutzer kann nur einer Organisation angehören. Bitte erstelle ein neues Cal.com-Konto mit einer anderen E-Mail-Adresse und verwende dieses Konto, um das Organisations-Abonnement abzuschließen.", Pxt = "Du bist bereits Teil einer Organisation, weshalb du keine Plattform-Organisation erstellen kannst. Jeder Benutzer kann nur einer Organisation angehören. Bitte erstelle ein neues Cal.com-Konto mit einer anderen E-Mail-Adresse und verwende dieses Konto, um das Plattform-Abonnement abzuschließen.", Dxt = "E-Mail-Adresse des Organisators im Buchungsbildschirm, in E-Mail-Benachrichtigungen und Kalenderereignissen verbergen", Lxt = "Sie &", Mxt = "Verifizierte E-Mail-Adresse auswählen", Fxt = "Verifizierte E-Mail hinzufügen", qxt = "Verifizierte E-Mails hinzufügen", jxt = "Benutzerdefinierte 'Antwort an'-E-Mail", Vxt = "Verwende eine andere E-Mail-Adresse als 'Antwort an' für Bestätigungs-E-Mails anstelle der E-Mail-Adresse des Organisators", Bxt = "Diese Umfrage wurde durch einen Workflow in Cal ausgelöst.", Uxt = "Testphase überspringen", Gxt = "Team-Testphasen erfolgreich übersprungen", Wxt = "Durch die Eingabe deiner Telefonnummer stimmst du zu, SMS-Nachrichten für dieses Event zu erhalten. Es können SMS-Gebühren anfallen.", Hxt = "Weitere Informationen finden Sie in den <0>Routing-Einblicken</0>", Yxt = "Ergebnisse", Kxt = "Formular anzeigen", Zxt = "Senden Sie STOP, um sich von SMS-Nachrichten abzumelden", Xxt = "Ihrem Team {{teamName}} gehen die Credits aus", Jxt = "Ihnen gehen die Credits aus", Qxt = "[Handlung erforderlich] Ihrem Team {{teamName}} sind die Credits ausgegangen", eCt = "[Handlung erforderlich] Ihnen sind die Credits ausgegangen", tCt = "Ihrem Cal.com-Team {{teamName}} gehen die Credits aus. Um Unterbrechungen des Dienstes zu vermeiden, kaufen Sie bitte zusätzliche Credits. Wenn Ihr Guthaben aufgebraucht ist, werden SMS-Nachrichten nicht mehr gesendet und stattdessen als E-Mails verschickt.", nCt = "Ihrem Cal.com-Konto gehen die Credits aus. Um Unterbrechungen des Dienstes zu vermeiden, kaufen Sie bitte zusätzliche Credits. Wenn Ihr Guthaben aufgebraucht ist, werden SMS-Nachrichten nicht mehr gesendet und stattdessen als E-Mails verschickt.", oCt = "Ihrem Cal.com-Team {{teamName}} sind die Credits ausgegangen. Infolgedessen werden SMS-Nachrichten jetzt per E-Mail gesendet. Um wieder SMS zu senden, kaufen Sie bitte zusätzliche Credits.", rCt = "Dein Cal.com-Konto hat keine Credits mehr. Infolgedessen werden SMS-Nachrichten jetzt stattdessen per E-Mail gesendet. Um das Senden von SMS fortzusetzen, kaufe bitte zusätzliche Credits.", iCt = "Aktuelles Guthaben: {{balance}} Credits", aCt = "Aktuelles Guthaben:", sCt = "Benachrichtigung über deine Buchung", cCt = "Monatliche Credits", lCt = "Gesamte Credits: {{totalCredits}}", uCt = "Verbleibende Credits: {{remainingCredits}}", dCt = "Verbleibend", _Ct = "Gesamt", pCt = "Zusätzliche Credits", mCt = "{{count}} nächste in der Warteschlange", fCt = "E-Mail-Antworten senden an", gCt = "Unvollständige Buchungen", hCt = "Nicht erschienene Buchungen in Round-Robin-Berechnungen einbeziehen", vCt = "Kürzliche No-Show-Gäste", bCt = "Zeigt Buchungen, bei denen alle Teilnehmer nicht erschienen sind, keine teilweisen No-Shows", yCt = "Übereinstimmung", $Ct = "Event-Weiterleitung", wCt = "Formular zurücksetzen", kCt = "Round Robin-Einstellungen erfolgreich aktualisiert", SCt = "Verteilungsgrundlage für gewichtetes Round Robin", ECt = "Bestimmt, welcher Ereigniszeitstempel als Grundlage für die gewichtete Round Robin-Verteilung verwendet wird.", xCt = "Erfordert Credits", CCt = "Du benötigst genügend Credits in deinem Konto, um diese Funktion zu nutzen", TCt = "Verfügbare Credits", ACt = "Rolle erstellen", ICt = "Rollen & Berechtigungen", OCt = "Verwalte Rollen und Berechtigungen für deine Organisation", NCt = "Erfahre mehr darüber, wie Berechtigungen funktionieren", zCt = "Rollenname", RCt = "Rollenname ist erforderlich", PCt = "z.B. Vertriebsteam, Support-Mitarbeiter", DCt = "Rollenbeschreibung", LCt = "Beschreibe, wofür diese Rolle gedacht ist und welche Berechtigungen sie benötigt", MCt = "Standardrolle", FCt = "Benutzerdefinierte Rolle", qCt = "Erweitert", jCt = "Berechtigungen suchen", VCt = "Alle Berechtigungen", BCt = "Keine", UCt = "Nur lesen", GCt = "Alle Aktionen für alle Ressourcen", WCt = "Alle Ressourcen", HCt = "Ereignistypen", YCt = "Teams", KCt = "Organization", ZCt = "Buchungen", XCt = "Erkenntnisse", JCt = "Rollen", QCt = "Weiterleitungsformulare", eTt = "Workflows", tTt = "Alle Aktionen", nTt = "Erstellen", oTt = "Ansehen", rTt = "Bearbeiten", iTt = "Löschen", aTt = "Verwalten", sTt = "Einladen", cTt = "Entfernen", lTt = "Mitgliedsrolle ändern", uTt = "Mitglieder auflisten", dTt = "Abrechnung verwalten", _Tt = "Team-Buchungen ansehen", pTt = "Organizations-Buchungen ansehen", mTt = "Aufnahmen anzeigen", fTt = "Imitieren", gTt = "Rolle erfolgreich erstellt", hTt = "Rolle erfolgreich aktualisiert", vTt = "Rolle löschen", bTt = "Sind Sie sicher, dass Sie die Rolle löschen möchten: {{roleName}}. Diese Aktion kann nicht rückgängig gemacht werden.", yTt = "Rolle erfolgreich gelöscht", $Tt = "Fehler beim Erstellen der Rolle", wTt = "Fehler beim Aktualisieren der Rolle", kTt = "Rollen erstellen", STt = "Attribute", ETt = "Organisationsattribute anzeigen", xTt = "Organisationsattribute aktualisieren", CTt = "Organisationsattribute löschen", TTt = "Organisationsattribute erstellen", ATt = "Rollen anzeigen", ITt = "Rollen aktualisieren", OTt = "Rollen löschen", NTt = "Neue Workflows erstellen und einrichten", zTt = "Einrichtung erforderlich", RTt = "Bestehende Workflows und ihre Konfigurationen anzeigen", PTt = "Workflow-Einstellungen bearbeiten und ändern", DTt = "Workflows aus dem System entfernen", LTt = "Webhook", MTt = "Verfügbarkeit", FTt = "Abwesenheit", qTt = "Webhooks erstellen", jTt = "Webhooks anzeigen", VTt = "Webhooks aktualisieren", BTt = "Webhooks löschen", UTt = "Verfügbarkeit erstellen", GTt = "Verfügbarkeit anzeigen", WTt = "Verfügbarkeit aktualisieren", HTt = "Verfügbarkeit löschen", YTt = "Abwesenheit erstellen", KTt = "Abwesenheit anzeigen", ZTt = "Abwesenheit aktualisieren", XTt = "Abwesenheit löschen", JTt = "Vollständiger Verwaltungszugriff auf alle Workflows", QTt = "Ereignistypen erstellen", eAt = "Ereignistypen anzeigen", tAt = "Ereignistypen aktualisieren", nAt = "Ereignistypen löschen", oAt = "Alle Aktionen für Ereignistypen", rAt = "Teams erstellen", iAt = "Teamdetails anzeigen", aAt = "Teameinstellungen aktualisieren", sAt = "Team löschen", cAt = "Teammitglieder einladen", lAt = "Teammitglieder entfernen", uAt = "Rolle von Teammitgliedern ändern", dAt = "Teammitglieder imitieren", _At = "Alle Aktionen für Teams in der gesamten Organisation", pAt = "Organisation erstellen", mAt = "Organisationsdetails anzeigen", fAt = "Organisationsmitglieder auflisten", gAt = "Organisationsmitglieder einladen", hAt = "Organisationsmitglieder entfernen", vAt = "Organisationsabrechnung verwalten", bAt = "Rolle von Organisationsmitgliedern ändern", yAt = "Organisationsmitglieder imitieren", $At = "Organisationseinstellungen bearbeiten", wAt = "Alle Aktionen für Organisationen", kAt = "Buchungen anzeigen", SAt = "Team-Buchungen anzeigen", EAt = "Organisationsbuchungen anzeigen", xAt = "Buchungsaufzeichnungen anzeigen", CAt = "Buchungen aktualisieren", TAt = "Alle Aktionen für Buchungen", AAt = "Team-Insights anzeigen", IAt = "Team-Insights verwalten", OAt = "Weiterleitungsformulare erstellen", NAt = "Weiterleitungsformulare anzeigen", zAt = "Weiterleitungsformulare aktualisieren", RAt = "Weiterleitungsformulare löschen", PAt = "Leseberechtigung wird automatisch aktiviert, wenn eine Ressource erstellt, aktualisiert oder gelöscht wird", DAt = "Einschränkungszeitplan hinzufügen", LAt = "Beschränken Sie die Verfügbarkeit von Gastgebern, um nur Zeitfenster anzuzeigen, die in einen festgelegten Zeitplan fallen.", MAt = "Zeitzone des Buchenden verwenden", FAt = "Den ausgewählten Einschränkungszeitplan in der Zeitzone des Buchenden anwenden", qAt = "Dies deaktiviert die Lastverteilung für alle Ihre Round-Robin-Ereignistypen", jAt = "Lastverteilung ist nur verfügbar, wenn die Zeitstempelbasis auf Buchungserstellungszeit eingestellt ist", VAt = "Lastausgleich ist mit Round-Robin-Gruppen nicht verfügbar", BAt = "Passen Sie die Standard-Round-Robin-Einstellungen für dieses Team an", UAt = "Round-Robin-Einstellungen erfolgreich aktualisiert", GAt = "Erstellungszeit der Buchung", WAt = "Besprechungsstartzeit", HAt = "Betroffene Mitglieder", YAt = "Keine Mitglieder von der Deaktivierung der Delegationsanmeldedaten betroffen", KAt = "Ausgabenprotokoll herunterladen", ZAt = "Fehler beim Herunterladen des Ausgabenprotokolls", XAt = "Angebot zur Umbuchung der letzten aktiven Buchung auf den gewählten Zeitraum", JAt = "Maximale Anzahl aktiver Buchungen des Buchers überschritten", QAt = "Sie haben bereits eine Buchung für dieses Event am {{date}}. Möchten Sie auf die neu gewählte Zeit umbuchen?", e2t = "Die Dauer muss mindestens {{min}} Minute(n) betragen", t2t = "Die Dauer darf {{max}} Minuten (24 Stunden) nicht überschreiten", n2t = "Buchung außerhalb der Verfügbarkeit des Einschränkungsplans.", o2t = "Einschränkungsplan nicht gefunden", r2t = "Bildgrößenlimit überschritten, bitte verwenden Sie ein kleineres Bild, vorzugsweise im JPEG-Format", i2t = "Gruppe hinzufügen", a2t = "Routing-Trichter", s2t = "Gesamtanzahl der Einreichungen", c2t = "Erfolgreiche Weiterleitungen", l2t = "Akzeptierte Buchungen", u2t = "Lizenzschlüssel", d2t = "Wählen Sie ihre Lizenz", _2t = "Wählen Sie, wie Sie Ihre Cal.com-Bereitstellung lizenzieren möchten", p2t = "Verwenden Sie Cal.com unter der AGPLv3 Open-Source-Lizenz", m2t = "Lizenzschlüssel eingeben", f2t = "Zugang zu allen Enterprise-Funktionen", g2t = "Ab 15 $/Benutzer pro Monat", h2t = "Zugang zu allen Enterprise-Funktionen", v2t = "Geben Sie Ihren Lizenzschlüssel ein", b2t = "Lizenzschlüssel speichern", y2t = "Signatur-Token (optional)", $2t = "Das Signatur-Token wird verwendet, um zu überprüfen, ob der Lizenzschlüssel Ihnen gehört, wenn nutzungsbasierte Abrechnungen erhöht werden. Sie finden es in Ihrer Kaufbestätigungs-E-Mail. Wenn Sie eine ältere Lizenz haben, können Sie dieses Feld leer lassen.", w2t = "Benötigen Sie eine Lizenz?", k2t = "Lizenzschlüssel ist erforderlich", S2t = "Ungültiger Lizenzschlüssel", E2t = "Validierung des Lizenzschlüssels fehlgeschlagen", x2t = "Anhänge optional", C2t = "Nachricht senden", T2t = "Beschreiben Sie das Problem", A2t = "Dateigröße überschreitet das Limit", I2t = "Ungültiger Dateityp", O2t = "Ungültiger Dateityp. Akzeptierte Typen: {{acceptedTypes}}", N2t = "Maximale Anzahl an Dateien überschritten", z2t = "Dateien erfolgreich hochgeladen", R2t = "Akzeptierte Typen: {{acceptedTypes}}; Maximale Dateigröße: {{maxSize}}", P2t = "Lizenzschlüssel erfolgreich gespeichert", D2t = "Sie sehen den Bericht basierend auf Ihrer Profil-Zeitzone ({{userTimezone}}), während Ihr Browser auf die Zeitzone ({{browserTimezone}}) eingestellt ist", L2t = "Optimierte Zeitfenster", M2t = "Zeitfenster anordnen, um die Verfügbarkeit zu optimieren.", F2t = "Fehlgeschlagene Buchungen nach Feld", q2t = "Fehlgeschlagene Buchungen", j2t = "Dem Ereignistyp sind keine Gastgeber zugewiesen", V2t = "Cache-Status", B2t = "Zuletzt aktualisiert: {{timestamp}}", U2t = "Zwischengespeicherte Daten löschen", G2t = "Cache erfolgreich gelöscht", W2t = "Fehler beim Löschen des Caches", H2t = "Sind Sie sicher, dass Sie die zwischengespeicherten Daten löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.", Y2t = "Ja, Cache löschen", K2t = "{{remainder}} von {{maximum}} Verwendungen übrig", Z2t = "{{remainder}} von {{maximum}} Verwendung übrig", X2t = "Läuft am {{date}}, Ende des Tages ab", J2t = "Einmalige Verwendung", Q2t = "Zeitbasiertes Ablaufdatum", eIt = "Nutzungsbasiertes Ablaufdatum", tIt = "Anzahl der Verwendungen", nIt = "Läuft ab am", oIt = "Maximale Anzahl der Verwendungen", rIt = "Link-Einstellungen", iIt = "Dieser Link ist am {{date}}, Ende des Tages abgelaufen", aIt = "Nutzungslimit erreicht", sIt = "Maximale Nutzungsanzahl muss größer sein als die aktuelle Nutzungsanzahl", cIt = "Dieser Link ist abgelaufen", lIt = "Dieser Link kann für Buchungen bis zum Ende des {{date}} verwendet werden", uIt = "Dieser Link kann so konfiguriert werden, dass er nach einem festgelegten Datum abläuft", dIt = "Dieser Link kann für {{count}} Buchung verwendet werden", _It = "Dieser Link kann so konfiguriert werden, dass er nach einer festgelegten Anzahl von Buchungen abläuft", pIt = "Dieser Link kann für {{count}} Buchungen verwendet werden", mIt = "Der Name des Auslöseereignisses (z.B. BOOKING_CREATED, BOOKING_CANCELLED)", fIt = "Der Zeitpunkt des Webhooks", gIt = "Der Ereignistyp-Slug", hIt = "Agent einrichten", vIt = "Der Name des Ereignistyps", bIt = "Die Startzeit des Ereignisses", yIt = "Die Endzeit des Ereignisses", $It = "Die Beschreibung des Ereignisses wie in den Ereignistyp-Einstellungen beschrieben", wIt = "Ort des Ereignisses", kIt = "Die UID der Buchung", SIt = "Die UID für die Umbuchung", EIt = "Grund für die Stornierung", xIt = "Grund für die Ablehnung", CIt = "Name des Organisators", TIt = "E-Mail des Organisators", AIt = "Zeitzone des Organisators (z.B. 'America/New_York', 'Asia/Kolkata')", IIt = "Sprache des Organisators (z.B. 'en', 'fr')", OIt = "Benutzername des Organisators (z.B. 'john.doe')", NIt = "Benutzername des Organisators in seiner Organisation (z.B. 'john.doe')", zIt = "Name des ersten Teilnehmers", RIt = "E-Mail des ersten Teilnehmers", PIt = "Zeitzone des ersten Teilnehmers", DIt = "Sprache des ersten Teilnehmers", LIt = "Name des gebuchten Teams", MIt = "Mitglieder des gebuchten Teams", FIt = "Video-Anruf-URL für das Meeting", qIt = "Variablen ausblenden", jIt = "Verfügbare Variablen anzeigen", VIt = "Veranstaltung und Buchung", BIt = "Personen", UIt = "Teams", GIt = "Metadaten", WIt = "Statistiken", HIt = "Buchungsstatus", YIt = "Besuchen", KIt = "Benutzerdefinierte Bezeichnung auf der Buchungsseite", ZIt = "Meeting-Link", XIt = "Sitzungsergebnis", JIt = "Anruf erstellt", QIt = "Sprachnachricht", eOt = "Meine Buchungen", tOt = "Telefon", nOt = "Kostenlos", oOt = "Benutzer-E-Mail", rOt = "Benutzername", iOt = "Panel erweitern", aOt = "Panel einklappen", sOt = "E-Mail-Verifizierung ist für diesen Ereignistyp erforderlich", cOt = "Ungültiger Verifizierungscode angegeben", lOt = "Sie haben ein Team", uOt = "Erwägen Sie die Einrichtung einer Organisation, um Abrechnung, Administrationstools und Analysen für Ihr Team zu vereinheitlichen.", dOt = "Erwägen Sie die Einrichtung einer Organisation, um Abrechnung, Administrationstools und Analysen für Ihre Teams zu vereinheitlichen.", _Ot = "Nachricht gesendet", pOt = "Vielen Dank für Ihre Kontaktaufnahme. Wir werden uns so schnell wie möglich bei Ihnen melden.", mOt = "Variablen durchsuchen", fOt = "Bitte beschreiben Sie das Problem, mit dem Sie konfrontiert sind, z.B. 'Belegte Zeitfenster werden als verfügbar angezeigt', ..., usw.", gOt = "Weitere Nachricht senden", hOt = "Wird gesendet", vOt = "Keine Variablen gefunden", bOt = "Credits erforderlich", yOt = "Web-Anrufe verbrauchen Credits. Stellen Sie sicher, dass Sie genügend Credits haben, um einen Anruf zu starten.", $Ot = "Web-Anrufe erfordern Credits. Sie haben 0 Credits übrig.", wOt = "Credits kaufen", kOt = "Diese Aktion erfordert Credits, um fortzufahren", SOt = "Der Name darf {{max}} Zeichen nicht überschreiten", EOt = "Automatische Berechnung der Ausfallgebühr für kurzfristige Stornierungen", xOt = "Vor dem geplanten Startzeitpunkt", COt = "Ich bestätige, dass mir bei einer Stornierung innerhalb von {{timeValue}} {{timeUnit}} vor dem Startzeitpunkt die Ausfallgebühr von {{amount, currency}} berechnet wird", TOt = "Bei Fragen wenden Sie sich bitte an den Organisator.", AOt = "Buchungszeit", IOt = "Wann die Buchung geplant ist (Anfang bis Ende)", OOt = "Erstellt am", NOt = "Wann die Buchung ursprünglich erstellt wurde", zOt = "Anrufdetails", ROt = "Anruf-ID", POt = "Anrufinformationen", DOt = "Stimmung", LOt = "Trennungsgrund", MOt = "Anrufzusammenfassung", FOt = "Transkription", qOt = "Ereignisdetails", jOt = "Agent", VOt = "Kein Transkript verfügbar", BOt = "Beachten Sie beim Testen dieses Workflows, dass SMS mindestens 15 Minuten im Voraus geplant werden müssen", UOt = "Von Grund auf neu beginnen", GOt = "Erstellen Sie Ihren eigenen Workflow von Grund auf.", WOt = "Cal.ai-Vorlage", HOt = "KI-Agenten, die Meetings buchen, Erinnerungen senden und nachfassen!", YOt = "Stimme", KOt = "Stimme auswählen", ZOt = "Wähle eine Stimme für deinen Agenten", XOt = "Wähle eine Stimme für deinen Agenten", JOt = "Eigenschaft", QOt = "Stimm-ID", eNt = "Stimme verwenden", tNt = "Aktuelle Stimme", nNt = "Eingehenden Agent einrichten", oNt = "Konfigurieren Sie einen KI-Agenten, um eingehende Anrufe auf Ihrer Telefonnummer zu bearbeiten", rNt = "Verbinden Sie zuerst eine Telefonnummer", iNt = "Agent für eingehende Anrufe einrichten", aNt = "Agent für die Bearbeitung eingehender Anrufe konfigurieren", sNt = "Eingehende Anrufe", cNt = "Ausgehende Anrufe", lNt = "Einrichtung des Inbound-Agenten erfolgreich", uNt = "Inbound-Agent konfiguriert", dNt = "Inbound-Agent einrichten", _Nt = "Bitte wählen Sie zuerst einen Ereignistyp aus", pNt = "Konfiguration bearbeiten", mNt = "Eingehende Anrufe können nur einen Ereignistyp buchen. Wählen Sie den Ereignistyp aus, für den Meetings geplant werden, wenn Anrufer Ihren Agenten erreichen.", fNt = "Inbound-Agent für eingehende Anrufe einrichten", gNt = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Fügen Sie Ihre neuen Code-Zeilen über dieser hinzu ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", hNt = {
  identity_provider: fTe,
  trial_days_left: gTe,
  day_one: hTe,
  day_other: vTe,
  second_one: bTe,
  second_other: yTe,
  upgrade_now: $Te,
  untitled: wTe,
  accept_invitation: kTe,
  max_characters: STe,
  min_characters: ETe,
  calcom_explained: xTe,
  calcom_explained_new_user: CTe,
  have_any_questions: TTe,
  reset_password_subject: ATe,
  verify_email_subject: ITe,
  verify_email_subject_verifying_email: OTe,
  check_your_email: NTe,
  old_email_address: zTe,
  new_email_address: RTe,
  verify_email_page_body: PTe,
  verify_email_banner_body: DTe,
  verify_email_email_header: LTe,
  verify_email_button: MTe,
  cal_ai_assistant: FTe,
  send_cal_video_transcription_emails: qTe,
  description_send_cal_video_transcription_emails: jTe,
  verify_email_change_description: VTe,
  verify_email_change_success_toast: BTe,
  verify_email_change_failure_toast: UTe,
  change_of_email: GTe,
  change_of_email_toast: WTe,
  copy_somewhere_safe: HTe,
  verify_email_email_body: YTe,
  verify_email_by_code_email_body: KTe,
  verify_email_email_link_text: ZTe,
  email_verification_code: XTe,
  email_verification_code_placeholder: JTe,
  incorrect_email_verification_code: QTe,
  email_sent: eAe,
  email_not_sent: tAe,
  event_declined_subject: nAe,
  event_cancelled_subject: oAe,
  event_reassigned_subject: rAe,
  event_request_declined: iAe,
  customize_calvideo_settings: aAe,
  calvideo_settings_description: sAe,
  disable_recording_for_guests: cAe,
  enable_automatic_transcription: lAe,
  enable_automatic_recording: uAe,
  video_options: dAe,
  edit_event: _Ae,
  view_session_details: pAe,
  meeting_session_details: mAe,
  meeting_session: fAe,
  session_id: gAe,
  max_participants: hAe,
  unlimited: vAe,
  ongoing: bAe,
  ended: yAe,
  participants: $Ae,
  anonymous_user: wAe,
  session_duration: kAe,
  no_meeting_sessions_found: SAe,
  not_available: EAe,
  disable_recording_for_organizer: xAe,
  disable_transcription_for_guests: CAe,
  disable_transcription_for_organizer: TAe,
  event_request_declined_recurring: AAe,
  event_request_cancelled: IAe,
  event_request_reassigned: OAe,
  event_reassigned_subtitle: NAe,
  organizer: zAe,
  reassigned_to: RAe,
  need_to_reschedule_or_cancel: PAe,
  you_can_view_booking_details_with_this_url: DAe,
  no_options_available: LAe,
  cancellation_reason: MAe,
  cancelled_by: FAe,
  cancellation_reason_host: qAe,
  cancellation_reason_placeholder: jAe,
  notify_attendee_cancellation_reason_warning: VAe,
  rejection_reason_placeholder: BAe,
  rejection_reason: UAe,
  rejection_reason_title: GAe,
  rejection_reason_description: WAe,
  rejection_confirmation: HAe,
  manage_this_event: YAe,
  invite_team_member: KAe,
  invite_team_individual_segment: ZAe,
  invite_team_bulk_segment: XAe,
  invite_team_notifcation_badge: JAe,
  your_event_has_been_scheduled: QAe,
  your_event_has_been_scheduled_recurring: e2e,
  accept_our_license: t2e,
  remove_banner_instructions: n2e,
  error_message: o2e,
  refund_failed_subject: r2e,
  refund_failed: i2e,
  check_with_provider_and_user: a2e,
  a_refund_failed: s2e,
  awaiting_payment_subject: c2e,
  meeting_awaiting_payment: l2e,
  dark_theme_contrast_error: u2e,
  light_theme_contrast_error: d2e,
  event_type_color_light_theme_contrast_error: _2e,
  event_type_color_dark_theme_contrast_error: p2e,
  payment_not_created_error: m2e,
  couldnt_charge_card_error: f2e,
  no_available_users_found_error: g2e,
  timeslot_unavailable_book_a_new_time: h2e,
  timeslot_unavailable_short: v2e,
  just_connected_description: b2e,
  unavailable_timeslot_title: y2e,
  booking_time_out_of_bounds_error: $2e,
  request_body_end_time_internal_error: w2e,
  create_calendar_event_error: k2e,
  update_calendar_event_error: S2e,
  delete_calendar_event_error: E2e,
  already_signed_up_for_this_booking_error: x2e,
  hosts_unavailable_for_booking: C2e,
  fixed_hosts_unavailable_for_booking: T2e,
  round_robin_host_unavailable_for_booking: A2e,
  help: I2e,
  price: O2e,
  paid: N2e,
  refunded: z2e,
  record: R2e,
  transcribe: P2e,
  payment: D2e,
  missing_card_fields: L2e,
  pay_now: M2e,
  general_prompt: F2e,
  transcription_powered_by_ai: q2e,
  start_or_stop_recording: j2e,
  begin_message: V2e,
  codebase_has_to_stay_opensource: B2e,
  cannot_repackage_codebase: U2e,
  acquire_license: G2e,
  terms_summary: W2e,
  open_env: H2e,
  env_changed: Y2e,
  accept_license: K2e,
  still_waiting_for_approval: Z2e,
  event_is_still_waiting: X2e,
  no_result_found_for: J2e,
  no_more_results: Q2e,
  no_results: eIe,
  load_more_results: tIe,
  integration_meeting_id: nIe,
  confirmed_event_type_subject: oIe,
  new_event_request: rIe,
  confirm_or_reject_request: iIe,
  check_bookings_page_to_confirm_or_reject: aIe,
  check_in_assistant: sIe,
  check_in_assistant_description: cIe,
  create_your_own_prompt: lIe,
  event_awaiting_approval: uIe,
  event_awaiting_approval_recurring: dIe,
  someone_requested_an_event: _Ie,
  someone_requested_password_reset: pIe,
  password_reset_email_sent: mIe,
  password_reset_instructions: fIe,
  event_awaiting_approval_subject: gIe,
  event_still_awaiting_approval: hIe,
  booking_submitted_subject: vIe,
  download_recording_subject: bIe,
  download_transcript_email_subject: yIe,
  download_your_recording: $Ie,
  download_your_transcripts: wIe,
  your_meeting_has_been_booked: kIe,
  event_type_has_been_rescheduled_on_time_date: SIe,
  event_type_has_been_updated: EIe,
  event_has_been_rescheduled: xIe,
  event_has_been_updated: CIe,
  your_event_has_been_rescheduled: TIe,
  request_reschedule_subtitle: AIe,
  request_reschedule_title_organizer: IIe,
  request_reschedule_subtitle_organizer: OIe,
  rescheduled_event_type_subject: NIe,
  requested_to_reschedule_subject_attendee: zIe,
  hi_user_name: RIe,
  ics_event_title: PIe,
  please_book_a_time_sometime_later: DIe,
  schedule_instead: LIe,
  new_event_subject: MIe,
  join_by_entrypoint: FIe,
  notes: qIe,
  manage_my_bookings: jIe,
  need_to_make_a_change: VIe,
  new_event_scheduled: BIe,
  new_event_scheduled_recurring: UIe,
  invitee_email: GIe,
  invitee_timezone: WIe,
  time_left: HIe,
  event_type: YIe,
  duplicate_event_type: KIe,
  enter_meeting: ZIe,
  video_call_provider: XIe,
  meeting_id: JIe,
  meeting_password: QIe,
  meeting_url: eOe,
  meeting_url_not_found: tOe,
  token_not_found: nOe,
  some_other_host_already_accepted_the_meeting: oOe,
  meeting_request_rejected: rOe,
  rejected_event_type_with_organizer: iOe,
  hi: aOe,
  join_team: sOe,
  manage_this_team: cOe,
  team_info: lOe,
  join_meeting: uOe,
  request_another_invitation_email: dOe,
  you_have_been_invited: _Oe,
  user_invited_you: pOe,
  hidden_team_member_title: mOe,
  hidden_team_member_message: fOe,
  hidden_team_owner_message: gOe,
  link_expires: hOe,
  upgrade_to_per_seat: vOe,
  seat_options_doesnt_support_confirmation: bOe,
  multilocation_doesnt_support_seats: yOe,
  no_show_fee_doesnt_support_seats: $Oe,
  seats_option_doesnt_support_multi_location: wOe,
  team_upgrade_seats_details: kOe,
  team_upgrade_banner_description: SOe,
  upgrade_banner_action: EOe,
  team_upgraded_successfully: xOe,
  org_upgrade_banner_description: COe,
  org_upgraded_successfully: TOe,
  use_link_to_reset_password: AOe,
  hey_there: IOe,
  there: OOe,
  forgot_your_password_calcom: NOe,
  delete_webhook_confirmation_message: zOe,
  confirm_delete_webhook: ROe,
  edit_webhook: POe,
  delete_webhook: DOe,
  webhook_status: LOe,
  webhook_enabled: MOe,
  webhook_disabled: FOe,
  webhook_response: qOe,
  webhook_test: jOe,
  webhook_update_form: VOe,
  webhook_update_form_description: BOe,
  manage_your_webhook: UOe,
  webhook_created_successfully: GOe,
  webhook_updated_successfully: WOe,
  webhook_removed_successfully: HOe,
  subscription_needed: YOe,
  subscription_needed_description: KOe,
  payload_template: ZOe,
  dismiss: XOe,
  no_data_yet: JOe,
  ping_test: QOe,
  add_to_homescreen: eNe,
  upcoming: tNe,
  recurring: nNe,
  past: oNe,
  choose_a_file: rNe,
  upload_image: iNe,
  upload_target: aNe,
  no_target: sNe,
  slide_zoom_drag_instructions: cNe,
  view_notifications: lNe,
  view_public_page: uNe,
  copy_public_page_link: dNe,
  copy_referral_link: _Ne,
  sign_out: pNe,
  add_another: mNe,
  install_another: fNe,
  until: gNe,
  powered_by: hNe,
  unavailable: vNe,
  set_work_schedule: bNe,
  change_bookings_availability: yNe,
  select: $Ne,
  "2fa_confirm_current_password": "Bestätigen Sie Ihr aktuelles Passwort, um loszulegen.",
  "2fa_scan_image_or_use_code": "Scannen Sie das Bild mit der Authentifizierungs-App auf Ihrem Telefon oder geben Sie stattdessen den Textcode manuell ein.",
  text: wNe,
  your_phone_number: kNe,
  multiline_text: SNe,
  number: ENe,
  checkbox: xNe,
  is_required: CNe,
  make_field_required: TNe,
  required: ANe,
  optional: INe,
  input_type: ONe,
  rejected: NNe,
  unconfirmed: zNe,
  guests: RNe,
  guest: PNe,
  web_conferencing_details_to_follow: DNe,
  confirmation: LNe,
  what_booker_should_provide: MNe,
  "404_the_user": "Der Benutzername",
  username: FNe,
  is_still_available: qNe,
  documentation: jNe,
  documentation_description: VNe,
  api_reference: BNe,
  api_reference_description: UNe,
  blog: GNe,
  blog_description: WNe,
  join_our_community: HNe,
  "404_claim_entity_user": "Benutzername registrieren und Termine vergeben",
  popular_pages: YNe,
  register_now: KNe,
  register: ZNe,
  page_doesnt_exist: XNe,
  no_active_phone_number_available: JNe,
  workflow_step_not_configured: QNe,
  check_spelling_mistakes_or_go_back: eze,
  "404_page_not_found": "Fehler 404: Diese Seite konnte nicht gefunden werden.",
  booker_event_not_found: tze,
  getting_started: nze,
  "15min_meeting": "15 Minuten Termin",
  "30min_meeting": "30 Minuten Termin",
  secret: oze,
  leave_blank_to_remove_secret: rze,
  webhook_secret_key_description: ize,
  secret_meeting: aze,
  login_instead: sze,
  create_account: cze,
  get_started: lze,
  confirm_password: uze,
  reset_your_password: dze,
  org_banner_instructions: _ze,
  email_change: pze,
  create_your_account: mze,
  create_your_calcom_account: fze,
  sign_up: gze,
  youve_been_logged_out: hze,
  hope_to_see_you_soon: vze,
  logged_out: bze,
  please_try_again_and_contact_us: yze,
  incorrect_2fa_code: $ze,
  no_account_exists: wze,
  "2fa_enabled_instructions": "Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein.",
  "2fa_enter_six_digit_code": "Geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein.",
  create_an_account: kze,
  dont_have_an_account: Sze,
  "2fa_code": "Zwei-Faktor-Code",
  sign_in_account: Eze,
  sign_in: xze,
  go_back_login: Cze,
  error_during_login: Tze,
  request_password_reset: Aze,
  send_invite: Ize,
  forgot_password: Oze,
  forgot: Nze,
  done: zze,
  all_done: Rze,
  all: Pze,
  yours: Dze,
  available_apps: Lze,
  available_apps_lower_case: Mze,
  available_apps_desc: Fze,
  fixed_host_helper: qze,
  round_robin_groups_helper: jze,
  round_robin_helper: Vze,
  check_email_reset_password: Bze,
  finish: Uze,
  organization_general_description: Gze,
  few_sentences_about_yourself: Wze,
  nearly_there: Hze,
  nearly_there_instructions: Yze,
  set_availability_instructions: Kze,
  set_availability: Zze,
  set_availbility_description: Xze,
  share_a_link_or_embed: Jze,
  share_a_link_or_embed_description: Qze,
  availability_settings: eRe,
  continue_without_calendar: tRe,
  continue_with: nRe,
  connect_your_calendar: oRe,
  connect_your_video_app: rRe,
  connect_your_video_app_instructions: iRe,
  connect_your_calendar_instructions: aRe,
  set_up_later: sRe,
  current_time: cRe,
  details: lRe,
  welcome: uRe,
  welcome_back: dRe,
  welcome_to_calcom: _Re,
  welcome_instructions: pRe,
  connect_caldav: mRe,
  connect_ics_feed: fRe,
  connect: gRe,
  try_for_free: hRe,
  create_booking_link_with_calcom: vRe,
  who: bRe,
  what: yRe,
  when: $Re,
  where: wRe,
  add_to_calendar: kRe,
  add_to_calendar_description: SRe,
  add_events_to: ERe,
  add_another_calendar: xRe,
  other: CRe,
  email_sign_in_subject: TRe,
  round_robin_emailed_you_and_attendees: ARe,
  round_robin_emailed_host_and_attendee: IRe,
  emailed_host_and_attendee: ORe,
  emailed_host_and_attendee_recurring: NRe,
  round_robin_emailed_you_and_attendees_recurring: zRe,
  round_robin_emailed_host_and_attendee_recurring: RRe,
  emailed_you_and_any_other_attendees: PRe,
  needs_to_be_confirmed_or_rejected: DRe,
  needs_to_be_confirmed_or_rejected_recurring: LRe,
  user_needs_to_confirm_or_reject_booking: MRe,
  user_needs_to_confirm_or_reject_booking_recurring: FRe,
  meeting_is_scheduled: qRe,
  meeting_is_scheduled_recurring: jRe,
  booking_submitted: VRe,
  booking_submitted_recurring: BRe,
  booking_confirmed: URe,
  booking_confirmed_recurring: GRe,
  warning_recurring_event_payment: WRe,
  warning_payment_recurring_event: HRe,
  enter_new_password: YRe,
  reset_password: KRe,
  change_your_password: ZRe,
  show_password: XRe,
  hide_password: JRe,
  try_again: QRe,
  request_is_expired: ePe,
  reset_instructions: tPe,
  request_is_expired_instructions: nPe,
  whoops: oPe,
  login: rPe,
  success: iPe,
  failed: aPe,
  password_has_been_reset_login: sPe,
  layout: cPe,
  bookerlayout_default_title: lPe,
  bookerlayout_description: uPe,
  bookerlayout_user_settings_title: dPe,
  bookerlayout_user_settings_description: _Pe,
  bookerlayout_month_view: pPe,
  bookerlayout_week_view: mPe,
  bookerlayout_column_view: fPe,
  bookerlayout_error_min_one_enabled: gPe,
  bookerlayout_error_default_not_enabled: hPe,
  bookerlayout_error_unknown_layout: vPe,
  bookerlayout_override_global_settings: bPe,
  unexpected_error_try_again: yPe,
  sunday_time_error: $Pe,
  monday_time_error: wPe,
  tuesday_time_error: kPe,
  wednesday_time_error: SPe,
  thursday_time_error: EPe,
  friday_time_error: xPe,
  saturday_time_error: CPe,
  error_end_time_before_start_time: TPe,
  error_end_time_next_day: APe,
  back_to_bookings: IPe,
  free_to_pick_another_event_type: OPe,
  cancelled: NPe,
  no_booking: zPe,
  awaiting_host: RPe,
  cancellation_successful: PPe,
  really_cancel_booking: DPe,
  cannot_cancel_booking: LPe,
  reschedule_instead: MPe,
  event_is_in_the_past: FPe,
  cancelling_event_recurring: qPe,
  cancelling_all_recurring: jPe,
  error_with_status_code_occured: VPe,
  error_event_type_url_duplicate: BPe,
  error_event_type_unauthorized_create: UPe,
  error_event_type_unauthorized_update: GPe,
  error_workflow_unauthorized_create: WPe,
  error_schedule_unauthorized_create: HPe,
  booking_already_cancelled: YPe,
  booking_already_accepted_rejected: KPe,
  go_back_home: ZPe,
  or_go_back_home: XPe,
  no_meeting_found: JPe,
  no_meeting_found_description: QPe,
  no_status_bookings_yet: eDe,
  no_status_bookings_yet_description: tDe,
  event_between_users: nDe,
  bookings: oDe,
  booking_not_found: rDe,
  bookings_description: iDe,
  upcoming_bookings: aDe,
  recurring_bookings: sDe,
  past_bookings: cDe,
  cancelled_bookings: lDe,
  unconfirmed_bookings: uDe,
  unconfirmed_bookings_tooltip: dDe,
  on: _De,
  and: pDe,
  calendar_shows_busy_between: mDe,
  troubleshoot: fDe,
  troubleshoot_description: gDe,
  overview_of_day: hDe,
  hover_over_bold_times_tip: vDe,
  start_time: bDe,
  end_time: yDe,
  buffer_time: $De,
  before_event: wDe,
  after_event: kDe,
  event_buffer_default: SDe,
  buffer: EDe,
  your_day_starts_at: xDe,
  your_day_ends_at: CDe,
  launch_troubleshooter: TDe,
  troubleshoot_availability: ADe,
  change_available_times: IDe,
  change_your_available_times: ODe,
  change_start_end: NDe,
  change_start_end_buffer: zDe,
  current_start_date: RDe,
  start_end_changed_successfully: PDe,
  and_end_at: DDe,
  light: LDe,
  dark: MDe,
  automatically_adjust_theme: FDe,
  user_dynamic_booking_disabled: qDe,
  allow_dynamic_booking_tooltip: jDe,
  allow_dynamic_booking: VDe,
  dynamic_booking: BDe,
  allow_seo_indexing: UDe,
  seo_indexing: GDe,
  allow_browser_notifications: WDe,
  you_have_denied_notifications: HDe,
  disable_browser_notifications: YDe,
  browser_notifications_turned_on: KDe,
  browser_notifications_turned_off: ZDe,
  browser_notifications_denied: XDe,
  please_allow_notifications: JDe,
  push_notifications: QDe,
  push_notifications_description: e3e,
  browser_notifications_not_supported: t3e,
  email: n3e,
  email_placeholder: o3e,
  full_name: r3e,
  browse_api_documentation: i3e,
  leverage_our_api: a3e,
  create_webhook: s3e,
  instant_meeting: c3e,
  booking_cancelled: l3e,
  booking_rescheduled: u3e,
  recording_ready: d3e,
  recording_transcription_generated: _3e,
  booking_created: p3e,
  booking_rejected: m3e,
  booking_requested: f3e,
  booking_payment_initiated: g3e,
  meeting_ended: h3e,
  form_submitted: v3e,
  form_submitted_no_event: b3e,
  booking_paid: y3e,
  ooo_created: $3e,
  booking_no_show_updated: w3e,
  event_triggers: k3e,
  subscriber_url: S3e,
  create_new_webhook: E3e,
  webhooks: x3e,
  team_webhooks: C3e,
  create_new_webhook_to_account: T3e,
  new_webhook: A3e,
  receive_cal_meeting_data: I3e,
  receive_cal_event_meeting_data: O3e,
  responsive_fullscreen_iframe: N3e,
  loading: z3e,
  deleting: R3e,
  standard_iframe: P3e,
  developer: D3e,
  manage_developer_settings: L3e,
  iframe_embed: M3e,
  embed_calcom: F3e,
  integrate_using_embed_or_webhooks: q3e,
  schedule_a_meeting: j3e,
  view_and_manage_billing_details: V3e,
  view_and_edit_billing_details: B3e,
  go_to_billing_portal: U3e,
  need_anything_else: G3e,
  further_billing_help: W3e,
  contact: H3e,
  our_support_team: Y3e,
  contact_our_support_team: K3e,
  uh_oh: Z3e,
  no_event_types_have_been_setup: X3e,
  edit_logo: J3e,
  upload_a_logo: Q3e,
  upload_logo: eLe,
  remove_logo: tLe,
  enable: nLe,
  code: oLe,
  code_is_incorrect: rLe,
  add_time_availability: iLe,
  add_an_extra_layer_of_security: aLe,
  "2fa": "Zwei-Faktor-Authentifizierung",
  "2fa_disabled": "Zwei-Faktor-Authentifizierung kann nur für E-Mail- und Passwort-Authentifizierung aktiviert werden",
  enable_2fa: sLe,
  disable_2fa: cLe,
  disable_2fa_recommendation: lLe,
  error_disabling_2fa: uLe,
  error_enabling_2fa: dLe,
  security: _Le,
  manage_account_security: pLe,
  password: mLe,
  password_updated_successfully: fLe,
  password_has_been_changed: gLe,
  error_changing_password: hLe,
  session_timeout_changed: vLe,
  session_timeout_change_error: bLe,
  something_went_wrong: yLe,
  something_doesnt_look_right: $Le,
  please_try_again: wLe,
  super_secure_new_password: kLe,
  new_password: SLe,
  your_old_password: ELe,
  current_password: xLe,
  change_password: CLe,
  change_secret: TLe,
  new_password_matches_old_password: ALe,
  forgotten_secret_description: ILe,
  current_incorrect_password: OLe,
  password_hint_caplow: NLe,
  password_hint_min: zLe,
  password_hint_admin_min: RLe,
  password_hint_num: PLe,
  max_limit_allowed_hint: DLe,
  invalid_password_hint: LLe,
  incorrect_password: MLe,
  incorrect_email_password: FLe,
  use_setting: qLe,
  am_pm: jLe,
  time_options: VLe,
  january: BLe,
  february: ULe,
  march: GLe,
  april: WLe,
  may: HLe,
  june: YLe,
  july: KLe,
  august: ZLe,
  september: XLe,
  october: JLe,
  november: QLe,
  december: eMe,
  monday: tMe,
  tuesday: nMe,
  wednesday: oMe,
  thursday: rMe,
  friday: iMe,
  saturday: aMe,
  sunday: sMe,
  all_booked_today: cMe,
  slots_load_fail: lMe,
  additional_guests: uMe,
  your_name: dMe,
  your_full_name: _Me,
  no_name: pMe,
  enter_number_between_range: mMe,
  continue_as_guest_description: fMe,
  email_address: gMe,
  enter_valid_email: hMe,
  please_schedule_future_call: vMe,
  location: bMe,
  address: yMe,
  enter_address: $Me,
  in_person_attendee_address: wMe,
  somewhere_else: kMe,
  custom_attendee_location: SMe,
  continue_as_guest: EMe,
  join_as_guest: xMe,
  ideal_for_one_time_calls: CMe,
  any_location: TMe,
  yes: AMe,
  no: IMe,
  additional_notes: OMe,
  booking_fail: NMe,
  reschedule_fail: zMe,
  share_additional_notes: RMe,
  booking_confirmation: PMe,
  booking_reschedule_confirmation: DMe,
  in_person_meeting: LMe,
  in_person: MMe,
  link_meeting: FMe,
  phone_number: qMe,
  attendee_phone_number: jMe,
  organizer_phone_number: VMe,
  enter_phone_number: BMe,
  reschedule: UMe,
  reschedule_this: GMe,
  book_a_team_member: WMe,
  or: HMe,
  go_back: YMe,
  email_or_username: KMe,
  send_invite_email: ZMe,
  role: XMe,
  edit_role: JMe,
  view_role: QMe,
  edit_team: e4e,
  editing_user: t4e,
  editing_org: n4e,
  edit_or_manage_webhooks: o4e,
  reject: r4e,
  reject_all: i4e,
  accept: a4e,
  leave: s4e,
  profile: c4e,
  my_team_url: l4e,
  my_teams: u4e,
  team_name: d4e,
  your_team_name: _4e,
  team_updated_successfully: p4e,
  your_team_updated_successfully: m4e,
  your_org_updated_successfully: f4e,
  error_copying_to_clipboard: g4e,
  about: h4e,
  team_description: v4e,
  organization_id: b4e,
  organization_id_copied: y4e,
  org_description: $4e,
  team_id: w4e,
  team_id_copied: k4e,
  members: S4e,
  organization_members: E4e,
  member: x4e,
  number_member_one: C4e,
  number_member_other: T4e,
  number_selected: A4e,
  owner: I4e,
  admin: O4e,
  admin_api: N4e,
  administrator_user: z4e,
  lets_create_first_administrator_user: R4e,
  admin_user_created: P4e,
  admin_user_created_description: D4e,
  new_member: L4e,
  invite: M4e,
  add_team_members: F4e,
  add_org_members: q4e,
  add_team_members_description: j4e,
  add_team_member: V4e,
  invite_new_member: B4e,
  invite_new_member_description: U4e,
  invite_new_team_member: G4e,
  upload_csv_file: W4e,
  invite_via_email: H4e,
  change_member_role: Y4e,
  disable_cal_branding: K4e,
  disable_cal_branding_description: Z4e,
  hide_book_a_team_member: X4e,
  hide_book_a_team_member_description: J4e,
  danger_zone: Q4e,
  account_deletion_cannot_be_undone: e5e,
  team_deletion_cannot_be_undone: t5e,
  back: n5e,
  cancel: o5e,
  cancel_all_remaining: r5e,
  apply: i5e,
  cancel_event: a5e,
  continue: "Weiter",
  confirm: s5e,
  confirm_all: c5e,
  disband_team: l5e,
  disband_team_confirmation_message: u5e,
  disband_org: d5e,
  disband_org_confirmation_message: _5e,
  remove_member_confirmation_message: p5e,
  confirm_disband_team: m5e,
  confirm_remove_member: f5e,
  confirm_subscription_cancellation: g5e,
  cancel_subscription: h5e,
  cancel_subscription_description: v5e,
  remove_member: b5e,
  manage_your_team: y5e,
  no_teams: $5e,
  no_teams_description: w5e,
  submit: k5e,
  confirm_remove_attribute: S5e,
  remove_attribute: E5e,
  remove_attribute_confirmation_message: x5e,
  delete: "Löschen",
  update: C5e,
  save: T5e,
  pending: A5e,
  open_options: I5e,
  copy_link: O5e,
  share: N5e,
  share_event: z5e,
  copy_link_team: R5e,
  leave_team: P5e,
  confirm_leave_team: D5e,
  leave_team_confirmation_message: L5e,
  user_from_team: M5e,
  preview: F5e,
  link_copied: q5e,
  copied: j5e,
  private_link_copied: V5e,
  link_shared: B5e,
  title: U5e,
  description: G5e,
  apps_status: W5e,
  quick_video_meeting: H5e,
  scheduling_type: Y5e,
  preview_team: K5e,
  collective: Z5e,
  collective_description: X5e,
  duration: J5e,
  available_durations: Q5e,
  default_duration: e6e,
  default_duration_no_options: t6e,
  multiple_duration_mins: n6e,
  multiple_duration_timeUnit: o6e,
  multiple_duration_timeUnit_short: r6e,
  minutes: i6e,
  use_cal_ai_to_make_call_description: a6e,
  termination_uri: s6e,
  sip_trunk_username: c6e,
  sip_trunk_password: l6e,
  nickname: u6e,
  delete_phone_number: d6e,
  workflow_validation_failed: _6e,
  workflow_validation_empty_fields: p6e,
  workflow_validation_unverified_contacts: m6e,
  supercharge_your_workflows_with_cal_ai: f6e,
  supercharge_your_workflows_with_cal_ai_description: g6e,
  phone_number_imported_successfully: h6e,
  phone_number_deleted_successfully: v6e,
  delete_phone_number_confirmation: b6e,
  yes_delete_phone_number: y6e,
  phone_number_info_tooltip: $6e,
  termination_uri_info_tooltip: w6e,
  sip_trunk_username_info_tooltip: k6e,
  sip_trunk_password_info_tooltip: S6e,
  nickname_info_tooltip: E6e,
  save_and_test_call: x6e,
  call_initiated_successfully: C6e,
  please_enter_phone_number: T6e,
  agent_updated_successfully: A6e,
  agent_created_successfully: I6e,
  agent_event_type_updated_successfully: O6e,
  phone_number_unsubscribed_successfully: N6e,
  general_prompt_description: z6e,
  prompt: R6e,
  call_to: P6e,
  make_test_call_to_verify_configuration: D6e,
  initial_message: L6e,
  initial_message_description: M6e,
  having_trouble_importing: F6e,
  learn: q6e,
  learn_how_to_get_your_terminator: j6e,
  phone_number_subscription_cancelled_successfully: V6e,
  updating: B6e,
  round_robin: U6e,
  hi_how_are_you_doing: G6e,
  round_robin_description: W6e,
  managed_event: H6e,
  username_placeholder: Y6e,
  managed_event_description: K6e,
  managed: Z6e,
  managed_event_url_clarification: X6e,
  assign_to: J6e,
  enter_phone_number_to_test_call: Q6e,
  make_test_call: eFe,
  create_new_workflow_agent: tFe,
  create_new_workflow_agent_description: nFe,
  phone_number_for_ai_call: oFe,
  buy_a_phone_number_or_import_one_you_already_have: rFe,
  test_agent: iFe,
  test_web_call: aFe,
  phone_numbers: sFe,
  unsubscribe: cFe,
  delete_workflow_step: lFe,
  unsubscribe_phone_number: uFe,
  buy_a_new_number: dFe,
  only_us_phone_numbers_can_be_purchased_here: _Fe,
  buy_number_for_x_per_month: pFe,
  supported_call_destinations: mFe,
  no_phone_number_connected: fFe,
  failed_to_get_workflow_step_id: gFe,
  cal_ai_agent: hFe,
  test_cal_ai_agent: vFe,
  are_you_sure_you_want_to_delete_workflow_step: bFe,
  do_you_still_want_to_unsubscribe: yFe,
  the_action_will_disconnect_phone_number: $Fe,
  cal_ai_phone_numbers: wFe,
  connect_phone_number: kFe,
  cal_ai_phone_numbers_description: SFe,
  import_number: EFe,
  this_action_will_also: xFe,
  import_phone_number: CFe,
  active_subscription: TFe,
  cancel_your_phone_number_subscription: AFe,
  delete_associated_phone_number: IFe,
  unauthorized_create_workflow: OFe,
  import_phone_number_description: NFe,
  phone_number_cost: zFe,
  buy_new_number: RFe,
  buy_number_cost_x_per_month: PFe,
  area_code_optional: DFe,
  no_phone_numbers: LFe,
  phone_number_purchased_successfully: MFe,
  cancel_phone_number_subscription: FFe,
  yes_cancel_subscription: qFe,
  cancel_phone_number_subscription_confirmation: jFe,
  add_members: VFe,
  add_members_no_ellipsis: BFe,
  no_assigned_members: UFe,
  assigned_to: GFe,
  you_must_be_logged_in_to: WFe,
  start_assigning_members_above: HFe,
  locked_fields_admin_description: YFe,
  unlocked_fields_admin_description: KFe,
  locked_fields_member_description: ZFe,
  unlocked_fields_member_description: XFe,
  url: JFe,
  hidden: QFe,
  readonly: eqe,
  one_time_link: tqe,
  plan_description: nqe,
  plan_upgrade_invitation: oqe,
  plan_upgrade: rqe,
  plan_upgrade_teams: iqe,
  plan_upgrade_instructions: aqe,
  event_types_page_title: sqe,
  event_types_page_subtitle: cqe,
  new: "Neu",
  new_event_type_btn: lqe,
  new_event_type_heading: uqe,
  new_event_type_description: dqe,
  event_type_created_successfully: _qe,
  event_type_updated_successfully: pqe,
  event_type_deleted_successfully: mqe,
  hours: fqe,
  people: gqe,
  your_email: hqe,
  change_avatar: vqe,
  upload_avatar: bqe,
  language: yqe,
  timezone: $qe,
  first_day_of_week: wqe,
  repeats_up_to_one: kqe,
  repeats_up_to_other: Sqe,
  every_for_freq: Eqe,
  event_remaining_one: xqe,
  event_remaining_other: Cqe,
  repeats_every: Tqe,
  occurrence_one: Aqe,
  occurrence_other: Iqe,
  weekly_one: Oqe,
  weekly_other: Nqe,
  monthly_one: zqe,
  monthly_other: Rqe,
  yearly_one: Pqe,
  yearly_other: Dqe,
  plus_more: Lqe,
  max: Mqe,
  single_theme: Fqe,
  brand_color: qqe,
  light_brand_color: jqe,
  dark_brand_color: Vqe,
  light_event_type_color: Bqe,
  dark_event_type_color: Uqe,
  file_not_named: Gqe,
  create_team: Wqe,
  name: Hqe,
  nameless_team: Yqe,
  oauth_clients: Kqe,
  oauth_clients_description: Zqe,
  create_oauth_client: Xqe,
  create_oauth_client_description: Jqe,
  oauth_client_deletion_message: Qqe,
  create_new_team_description: eje,
  create_new_team: tje,
  booking_redirect_uri: nje,
  booking_cancel_redirect_uri: oje,
  booking_reschedule_redirect_uri: rje,
  booking_conflict_error: ije,
  open_invitations: aje,
  new_team: sje,
  create_first_team_and_invite_others: cje,
  create_team_to_get_started: lje,
  teams: uje,
  team: dje,
  organization: _je,
  team_billing: pje,
  team_billing_description: mje,
  upgrade_to_flexible_pro_title: fje,
  upgrade_to_flexible_pro_message: gje,
  changed_team_billing_info: hje,
  create_manage_teams_collaborative: vje,
  only_available_on_pro_plan: bje,
  remove_cal_branding_description: yje,
  edit_profile_info_description: $je,
  change_email_tip: wje,
  little_something_about: kje,
  profile_updated_successfully: Sje,
  your_user_profile_updated_successfully: Eje,
  your_upgrade_is_here: xje,
  your_upgrade_is_here_description: Cje,
  you_are_all_set: Tje,
  you_are_all_set_description: Aje,
  user_cannot_found_db: Ije,
  embed_and_webhooks: Oje,
  enabled: Nje,
  disabled: zje,
  disable: Rje,
  billing: Pje,
  here: Dje,
  manage_your_billing_info: Lje,
  availability: Mje,
  edit_availability: Fje,
  configure_availability: qje,
  copy_times_to: jje,
  copy_times_to_tooltip: Vje,
  change_weekly_schedule: Bje,
  logo: Uje,
  error: Gje,
  at_least_characters_one: Wje,
  at_least_characters_other: Hje,
  team_logo: Yje,
  add_location: Kje,
  attendees: Zje,
  add_attendees: Xje,
  show_advanced_settings: Jje,
  hide_advanced_settings: Qje,
  event_name: eVe,
  event_name_in_calendar: tVe,
  event_name_tooltip: nVe,
  meeting_with_user: oVe,
  additional_inputs: rVe,
  additional_input_description: iVe,
  label: aVe,
  placeholder: sVe,
  display_add_to_calendar_organizer: cVe,
  display_email_as_organizer: lVe,
  if_enabled_email_address_as_organizer: uVe,
  reconnect_calendar_to_use: dVe,
  type: _Ve,
  edit: pVe,
  add_input: mVe,
  disable_notes: fVe,
  disable_notes_description: gVe,
  requires_confirmation_description: hVe,
  requires_confirmation_will_block_slot_description: vVe,
  recurring_event: bVe,
  recurring_event_description: yVe,
  connect_and_join: $Ve,
  cannot_be_used_with_paid_event_types: wVe,
  warning_payment_instant_meeting_event: kVe,
  warning_instant_meeting_experimental: SVe,
  starting: EVe,
  disable_guests: xVe,
  disable_guests_description: CVe,
  private_link: TVe,
  enable_private_url: AVe,
  private_link_label: IVe,
  private_link_hint: OVe,
  copy_private_link: NVe,
  copy_private_link_to_event: zVe,
  private_link_description: RVe,
  multiple_private_links_title: PVe,
  multiple_private_links_description: DVe,
  add_a_multiple_private_link: LVe,
  multiple_private_link_copied: MVe,
  invitees_can_schedule: FVe,
  date_range: qVe,
  calendar_days: jVe,
  business_days: VVe,
  set_address_place: BVe,
  set_link_meeting: UVe,
  managed_event_field_parent_control_disabled: GVe,
  cal_invitee_phone_number_scheduling: WVe,
  cal_provide_google_meet_location: HVe,
  cal_provide_zoom_meeting_url: YVe,
  cal_provide_tandem_meeting_url: KVe,
  cal_provide_video_meeting_url: ZVe,
  cal_provide_jitsi_meeting_url: XVe,
  cal_provide_huddle01_meeting_url: JVe,
  cal_provide_teams_meeting_url: QVe,
  require_payment: eBe,
  you_need_to_add_a_name: tBe,
  commission_per_transaction: nBe,
  event_type_updated_successfully_description: oBe,
  hide_event_type: rBe,
  edit_location: iBe,
  into_the_future: aBe,
  when_booked_with_less_than_notice: sBe,
  within_date_range: cBe,
  indefinitely_into_future: lBe,
  add_new_custom_input_field: uBe,
  quick_chat: dBe,
  add_new_team_event_type: _Be,
  add_new_event_type: pBe,
  new_event_type_to_book_description: mBe,
  length: fBe,
  minimum_booking_notice: gBe,
  offset_toggle: hBe,
  offset_toggle_description: vBe,
  offset_start: bBe,
  offset_start_description: yBe,
  slot_interval: $Be,
  slot_interval_default: wBe,
  delete_event_type: kBe,
  delete_managed_event_type: SBe,
  delete_event_type_description: EBe,
  delete_managed_event_type_description_1: xBe,
  delete_managed_event_type_description_2: CBe,
  confirm_delete_event_type: TBe,
  delete_account: ABe,
  confirm_delete_account: IBe,
  delete_account_confirmation_message: OBe,
  integrations: NBe,
  apps: zBe,
  apps_description: RBe,
  apps_listing: PBe,
  category_apps: DBe,
  app_store: LBe,
  app_store_description: MBe,
  connect_your_video: FBe,
  settings: qBe,
  event_type_moved_successfully: jBe,
  next_step_text: VBe,
  next_step: BBe,
  prev_step: UBe,
  install: GBe,
  start_paid_trial: WBe,
  installed: HBe,
  active_install_one: YBe,
  active_install_other: KBe,
  globally_install: ZBe,
  app_successfully_installed: XBe,
  app_could_not_be_installed: JBe,
  disconnect: QBe,
  embed_your_calendar: e9e,
  connect_your_favourite_apps: t9e,
  automation: n9e,
  configure_how_your_event_types_interact: o9e,
  toggle_calendars_conflict: r9e,
  connect_additional_calendar: i9e,
  calendar_updated_successfully: a9e,
  check_here: s9e,
  conferencing: c9e,
  calendar: l9e,
  payments: u9e,
  not_installed: d9e,
  error_password_mismatch: _9e,
  error_required_field: p9e,
  status: m9e,
  team_view_user_availability: f9e,
  team_view_user_availability_disabled: g9e,
  set_as_away: h9e,
  set_as_free: v9e,
  toggle_away_error: b9e,
  user_away: y9e,
  user_away_description: $9e,
  meet_people_with_the_same_tokens: w9e,
  only_book_people_and_allow: k9e,
  account_created_with_identity_provider: S9e,
  account_managed_by_identity_provider: E9e,
  account_managed_by_identity_provider_description: x9e,
  account_managed_by_identity_provider_error: C9e,
  user_creation_error: T9e,
  signin_with_google: A9e,
  signin_with_saml: I9e,
  signin_with_saml_oidc: O9e,
  continue_with_email: N9e,
  continue_with_google: z9e,
  last_used: R9e,
  you_will_need_to_generate: P9e,
  import: "Importieren",
  import_from: D9e,
  access_token: L9e,
  visit_roadmap: M9e,
  featured_categories: F9e,
  feature_flags: q9e,
  admin_flags_description: j9e,
  popular_categories: V9e,
  number_apps_one: B9e,
  number_apps_other: U9e,
  trending_apps: G9e,
  most_popular: W9e,
  installed_apps: H9e,
  free_to_use_apps: Y9e,
  no_category_apps: K9e,
  all_apps: Z9e,
  no_category_apps_description_calendar: X9e,
  no_category_apps_description_conferencing: J9e,
  no_category_apps_description_payment: Q9e,
  no_category_apps_description_analytics: eUe,
  no_category_apps_description_automation: tUe,
  no_category_apps_description_other: nUe,
  no_category_apps_description_messaging: oUe,
  no_category_apps_description_crm: rUe,
  installed_app_calendar_description: iUe,
  installed_app_payment_description: aUe,
  installed_app_analytics_description: sUe,
  installed_app_other_description: cUe,
  installed_app_conferencing_description: lUe,
  installed_app_automation_description: uUe,
  installed_app_messaging_description: dUe,
  installed_app_crm_description: _Ue,
  analytics: pUe,
  empty_installed_apps_headline: mUe,
  empty_installed_apps_description: fUe,
  empty_installed_apps_button: gUe,
  manage_your_connected_apps: hUe,
  browse_apps: vUe,
  features: bUe,
  permissions: yUe,
  terms_and_privacy: $Ue,
  published_by: wUe,
  subscribe: kUe,
  buy: SUe,
  install_app: EUe,
  categories: xUe,
  pricing: CUe,
  learn_more: TUe,
  try_now: AUe,
  privacy_policy: IUe,
  terms_of_service: OUe,
  remove: NUe,
  add: zUe,
  installed_other: RUe,
  verify_wallet: PUe,
  create_events_on: DUe,
  enterprise_license: LUe,
  enterprise_license_locally: MUe,
  enterprise_license_sales: FUe,
  missing_license: qUe,
  next_steps: jUe,
  acquire_commercial_license: VUe,
  the_infrastructure_plan: BUe,
  prisma_studio_tip: UUe,
  prisma_studio_tip_description: GUe,
  contact_sales: WUe,
  error_404: HUe,
  default: "Standard",
  set_to_default: YUe,
  new_schedule_btn: KUe,
  add_new_schedule: ZUe,
  add_new_calendar: XUe,
  set_calendar: JUe,
  delete_schedule: QUe,
  delete_schedule_description: eGe,
  schedule_created_successfully: tGe,
  availability_updated_successfully: nGe,
  schedule_deleted_successfully: oGe,
  default_schedule_name: rGe,
  new_schedule_heading: iGe,
  new_schedule_description: aGe,
  requires_ownership_of_a_token: sGe,
  example_name: cGe,
  time_format: lGe,
  "12_hour": "12 Stunden",
  "24_hour": "24 Stunden",
  "12_hour_short": "12 Std",
  "24_hour_short": "24 Std",
  redirect_success_booking: uGe,
  you_are_being_redirected: dGe,
  external_redirect_url: _Ge,
  redirect_url_description: pGe,
  duplicate: mGe,
  offer_seats: fGe,
  offer_seats_description: gGe,
  seats_available_one: hGe,
  seats_available_other: vGe,
  seats_nearly_full: bGe,
  seats_half_full: yGe,
  number_of_seats: $Ge,
  set_instant_meeting_expiry_time_offset_description: wGe,
  enter_number_of_seats: kGe,
  you_can_manage_your_schedules: SGe,
  booking_full: EGe,
  api_keys: xGe,
  api_key: CGe,
  test_api_key: TGe,
  test_passed: AGe,
  test_failed: IGe,
  provide_api_key: OGe,
  api_key_modal_subtitle: NGe,
  api_key_modal_subtitle_platform: zGe,
  api_keys_subtitle: RGe,
  create_api_key: PGe,
  personal_note: DGe,
  personal_note_placeholder: LGe,
  api_key_no_note: MGe,
  api_key_never_expires: FGe,
  edit_api_key: qGe,
  success_api_key_created: jGe,
  success_api_key_edited: VGe,
  create: BGe,
  success_api_key_created_bold_tagline: UGe,
  you_will_only_view_it_once: GGe,
  copy_to_clipboard: WGe,
  enabled_after_update: HGe,
  enabled_after_update_description: YGe,
  confirm_delete_api_key: KGe,
  disable_rescheduling: ZGe,
  description_disable_rescheduling: XGe,
  allow_rescheduling_cancelled_bookings: JGe,
  description_allow_rescheduling_cancelled_bookings: QGe,
  disable_cancelling: eWe,
  description_disable_cancelling: tWe,
  revoke_api_key: nWe,
  api_key_copied: oWe,
  api_key_expires_on: rWe,
  delete_api_key_confirm_title: iWe,
  copy: aWe,
  expire_date: sWe,
  expired: cWe,
  never_expires: lWe,
  expires: uWe,
  request_reschedule_booking: dWe,
  reason_for_reschedule: _We,
  book_a_new_time: pWe,
  reschedule_request_sent: mWe,
  reschedule_modal_description: fWe,
  reason_for_reschedule_request: gWe,
  send_reschedule_request: hWe,
  edit_booking: vWe,
  reschedule_booking: bWe,
  former_time: yWe,
  confirmation_page_gif: $We,
  search: wWe,
  impersonate: kWe,
  user_impersonation_heading: SWe,
  user_impersonation_description: EWe,
  team_impersonation_description: xWe,
  cal_signup_description: CWe,
  make_org_private: TWe,
  make_org_private_description: AWe,
  make_team_private: IWe,
  make_team_private_description: OWe,
  you_cannot_see_team_members: NWe,
  you_cannot_see_teams_of_org: zWe,
  allow_multiple_durations: RWe,
  impersonate_user_tip: PWe,
  impersonating_user_warning: DWe,
  impersonating_stop_instructions: LWe,
  event_location_changed: MWe,
  new_guests_added: FWe,
  location_changed_event_type_subject: qWe,
  guests_added_event_type_subject: jWe,
  current_location: VWe,
  new_location: BWe,
  session: UWe,
  session_description: GWe,
  session_timeout_after: WWe,
  session_timeout: HWe,
  session_timeout_description: YWe,
  no_location: KWe,
  set_location: ZWe,
  update_location: XWe,
  location_updated: JWe,
  location_update_failed: QWe,
  guests_added: e8e,
  unable_to_add_guests: t8e,
  email_validation_error: n8e,
  emails_must_be_unique_valid: o8e,
  url_validation_error: r8e,
  place_where_cal_widget_appear: i8e,
  create_update_react_component: a8e,
  copy_code: s8e,
  code_copied: c8e,
  how_you_want_add_cal_site: l8e,
  choose_ways_put_cal_site: u8e,
  setting_up_zapier: d8e,
  setting_up_make: _8e,
  generate_api_key: p8e,
  generate_api_key_description: m8e,
  your_unique_api_key: f8e,
  copy_safe_api_key: g8e,
  zapier_setup_instructions: h8e,
  make_setup_instructions_1: v8e,
  make_setup_instructions_2: b8e,
  make_setup_instructions_3: y8e,
  make_setup_instructions_4: $8e,
  make_setup_instructions_5: w8e,
  make_setup_instructions_6: k8e,
  install_zapier_app: S8e,
  install_make_app: E8e,
  app_installation: x8e,
  app_not_installed: C8e,
  visit_our_app_store: T8e,
  connect_apple_server: A8e,
  calendar_url: I8e,
  apple_server_generate_password: O8e,
  unable_to_add_apple_calendar: N8e,
  credentials_stored_encrypted: z8e,
  it_stored_encrypted: R8e,
  go_to_app_store: P8e,
  calendar_error: D8e,
  set_your_phone_number: L8e,
  calendar_no_busy_slots: M8e,
  display_location_label: F8e,
  display_location_info_badge: q8e,
  add_gif: j8e,
  search_giphy: V8e,
  add_link_from_giphy: B8e,
  add_gif_to_confirmation: U8e,
  find_gif_spice_confirmation: G8e,
  share_feedback: W8e,
  resources: H8e,
  support_documentation: Y8e,
  developer_documentation: K8e,
  get_in_touch: Z8e,
  contact_support: X8e,
  premium_support: J8e,
  community_support: Q8e,
  feedback: e7e,
  submitted_feedback: t7e,
  feedback_error: n7e,
  comments: o7e,
  booking_details: r7e,
  or_lowercase: i7e,
  nevermind: a7e,
  go_to: s7e,
  zapier_invite_link: c7e,
  meeting_url_provided_after_confirmed: l7e,
  dynamically_display_attendee_or_organizer: u7e,
  event_location: d7e,
  reschedule_optional: _7e,
  reschedule_placeholder: p7e,
  event_cancelled: m7e,
  emailed_information_about_cancelled_event: f7e,
  this_input_will_shown_booking_this_event: g7e,
  meeting_url_in_confirmation_email: h7e,
  url_start_with_https: v7e,
  number_provided: b7e,
  before_event_trigger: y7e,
  event_cancelled_trigger: $7e,
  after_hosts_cal_video_no_show: w7e,
  after_guests_cal_video_no_show: k7e,
  join_video_call: S7e,
  sign_in_to_cal_com: E7e,
  log_in_to_cal_com: x7e,
  track_your_meetings: C7e,
  track_meetings_and_manage_schedule: T7e,
  failed_to_join_call: A7e,
  choose_how_you_d_like_to_join_call: I7e,
  choose_how_you_d_like_to_appear_on_the_call: O7e,
  new_event_trigger: N7e,
  email_host_action: z7e,
  email_attendee_action: R7e,
  sms_attendee_action: P7e,
  sms_number_action: D7e,
  send_reminder_sms: L7e,
  whatsapp_number_action: M7e,
  whatsapp_attendee_action: F7e,
  workflows: q7e,
  new_workflow_btn: j7e,
  how_would_you_like_to_start: V7e,
  add_new_workflow: B7e,
  reschedule_event_trigger: U7e,
  trigger: G7e,
  triggers: W7e,
  action: H7e,
  workflows_to_automate_notifications: Y7e,
  workflow_name: K7e,
  custom_workflow: Z7e,
  workflow_created_successfully: X7e,
  delete_workflow_description: J7e,
  delete_workflow: Q7e,
  confirm_delete_workflow: eHe,
  workflow_deleted_successfully: tHe,
  how_long_before: nHe,
  day_timeUnit: oHe,
  hour_timeUnit: rHe,
  minute_timeUnit: iHe,
  minute_short: aHe,
  hour_short: sHe,
  new_workflow_heading: cHe,
  new_workflow_description: lHe,
  active_on: uHe,
  workflow_updated_successfully: dHe,
  premium_to_standard_username_description: _He,
  premium_username: pHe,
  current: mHe,
  premium: fHe,
  standard: gHe,
  confirm_username_change_dialog_title: hHe,
  change_username_standard_to_premium: vHe,
  change_username_premium_to_standard: bHe,
  go_to_stripe_billing: yHe,
  stripe_description: $He,
  trial_expired: wHe,
  remove_app: kHe,
  yes_remove_app: SHe,
  are_you_sure_you_want_to_remove_this_app: EHe,
  app_removed_successfully: xHe,
  error_removing_app: CHe,
  web_conference: THe,
  web_call: AHe,
  start_web_call: IHe,
  end_call: OHe,
  test_your_agent_with_web_call: NHe,
  phone_call: zHe,
  connecting_to_agent: RHe,
  call_active: PHe,
  call_ended: DHe,
  call_error: LHe,
  ready_to_start_call: MHe,
  failed_to_start_web_call_try_again: FHe,
  call_encountered_error_try_again: qHe,
  failed_initialize_web_call_microphone_permissions: jHe,
  start_call_to_see_conversation: VHe,
  waiting_for_conversation: BHe,
  ai_agent: UHe,
  live: GHe,
  connecting: WHe,
  requires_confirmation: HHe,
  requires_confirmation_threshold: YHe,
  may_require_confirmation: KHe,
  nr_event_type_one: ZHe,
  nr_event_type_other: XHe,
  count_team_one: JHe,
  count_team_other: QHe,
  add_action: eYe,
  set_whereby_link: tYe,
  invalid_whereby_link: nYe,
  set_around_link: oYe,
  invalid_around_link: rYe,
  set_riverside_link: iYe,
  invalid_riverside_link: aYe,
  invalid_ping_link: sYe,
  add_exchange2013: cYe,
  add_exchange2016: lYe,
  custom_template: uYe,
  email_body: dYe,
  text_message: _Ye,
  specific_issue: pYe,
  browse_our_docs: mYe,
  choose_template: fYe,
  custom: gYe,
  reminder: hYe,
  rescheduled: vYe,
  rescheduled_by: bYe,
  original_booking: yYe,
  completed: $Ye,
  rating: wYe,
  reminder_email: kYe,
  not_triggering_existing_bookings: SYe,
  minute_one: EYe,
  minute_one_short: xYe,
  minute_other: CYe,
  hour_one: TYe,
  hour_one_short: AYe,
  hour_other: IYe,
  invalid_input: OYe,
  broken_video_action: NYe,
  broken_calendar_action: zYe,
  attendee_name: RYe,
  scheduler_full_name: PYe,
  broken_integration: DYe,
  problem_adding_video_link: LYe,
  problem_updating_calendar: MYe,
  active_on_event_types_one: FYe,
  active_on_event_types_other: qYe,
  active_on_teams_one: jYe,
  active_on_teams_other: VYe,
  active_on_all_event_types: BYe,
  active_on_all_teams: UYe,
  no_active_event_types: GYe,
  no_active_teams: WYe,
  new_seat_subject: HYe,
  new_seat_title: YYe,
  variable: KYe,
  event_name_variable: ZYe,
  attendee_name_variable: XYe,
  event_date_variable: JYe,
  event_time_variable: QYe,
  organizer_name_variable: eKe,
  app_upgrade_description: tKe,
  invalid_number: nKe,
  invalid_url_error_message: oKe,
  navigate: rKe,
  open: iKe,
  close: aKe,
  upgrade: sKe,
  buy_us_number_button: cKe,
  upgrade_to_access_recordings_title: lKe,
  upgrade_to_access_recordings_description: uKe,
  upgrade_to_cal_ai_phone_number_description: dKe,
  recordings_are_part_of_the_teams_plan: _Ke,
  team_feature_teams: pKe,
  team_feature_workflows: mKe,
  show_eventtype_on_profile: fKe,
  embed: gKe,
  new_username: hKe,
  current_username: vKe,
  example_1: bKe,
  example_2: yKe,
  booking_question_identifier: $Ke,
  company_size: wKe,
  what_help_needed: kKe,
  variable_format: SKe,
  webhook_subscriber_url_reserved: EKe,
  custom_input_as_variable_info: xKe,
  using_booking_questions_as_variables: CKe,
  download_desktop_app: TKe,
  set_ping_link: AKe,
  rate_limit_exceeded: IKe,
  when_something_happens: OKe,
  action_is_performed: NKe,
  test_action: zKe,
  notification_sent: RKe,
  no_input: PKe,
  test_workflow_action: DKe,
  send_sms: LKe,
  send_sms_to_number: MKe,
  missing_connected_calendar: FKe,
  connect_your_calendar_and_link: qKe,
  default_calendar_selected: jKe,
  hide_from_profile: VKe,
  basics: BKe,
  availability_not_found_in_schedule_error: UKe,
  event_limit_tab_title: GKe,
  event_limit_tab_description: WKe,
  event_advanced_tab_description: HKe,
  event_advanced_tab_title: YKe,
  event_payments_tab_description: KKe,
  event_setup_multiple_duration_error: ZKe,
  event_setup_multiple_duration_default_error: XKe,
  event_setup_booking_limits_error: JKe,
  event_setup_duration_limits_error: QKe,
  select_which_cal: eZe,
  custom_event_name: tZe,
  custom_event_name_description: nZe,
  "2fa_required": "Zwei-Faktor-Authentifizierung erforderlich",
  incorrect_2fa: oZe,
  which_event_type_apply: rZe,
  apply_to_all_event_types: iZe,
  apply_to_all_teams: aZe,
  which_team_apply: sZe,
  no_workflows_description: cZe,
  timeformat_profile_hint: lZe,
  create_workflow: uZe,
  do_this: dZe,
  turn_off: _Ze,
  turn_on: pZe,
  cancelled_bookings_cannot_be_rescheduled: mZe,
  settings_updated_successfully: fZe,
  error_updating_settings: gZe,
  personal_cal_url: hZe,
  bio_hint: vZe,
  finish_and_start: bZe,
  user_has_no_bio: yZe,
  bio: $Ze,
  delete_account_modal_title: wZe,
  confirm_delete_account_modal: kZe,
  delete_my_account: SZe,
  start_of_week: EZe,
  recordings_title: xZe,
  recording: CZe,
  happy_scheduling: TZe,
  select_calendars: AZe,
  check_for_conflicts: IZe,
  view_recordings: OZe,
  check_for_recordings: NZe,
  adding_events_to: zZe,
  follow_system_preferences: RZe,
  custom_brand_colors: PZe,
  customize_your_brand_colors: DZe,
  pro: LZe,
  removes_cal_branding: MZe,
  instant_meeting_with_title: FZe,
  profile_picture: qZe,
  upload: jZe,
  add_profile_photo: VZe,
  token_address: BZe,
  blockchain: UZe,
  old_password: GZe,
  secure_password: WZe,
  error_updating_password: HZe,
  two_factor_auth: YZe,
  recurring_event_tab_description: KZe,
  today: ZZe,
  appearance: XZe,
  my_account: JZe,
  general: QZe,
  calendars: eXe,
  "2fa_auth": "2 Faktor-Authentifizierung",
  invoices: tXe,
  embeds: nXe,
  impersonation: oXe,
  impersonation_description: rXe,
  recent_impersonations: iXe,
  quick_impersonate: aXe,
  no_recent_impersonations: sXe,
  users: cXe,
  user: lXe,
  profile_description: uXe,
  users_description: dXe,
  users_listing: _Xe,
  general_description: pXe,
  calendars_description: mXe,
  appearance_description: fXe,
  conferencing_description: gXe,
  add_conferencing_app: hXe,
  password_description: vXe,
  set_up_two_factor_authentication: bXe,
  we_just_need_basic_info: yXe,
  skip: $Xe,
  do_this_later: wXe,
  set_availability_getting_started_subtitle_1: kXe,
  set_availability_getting_started_subtitle_2: SXe,
  connect_calendar_first: EXe,
  complete_profile: xXe,
  connect_calendars_from_app_store: CXe,
  connect_conference_apps: TXe,
  connect_calendar_apps: AXe,
  connect_payment_apps: IXe,
  connect_automation_apps: OXe,
  connect_analytics_apps: NXe,
  connect_other_apps: zXe,
  connect_messaging_apps: RXe,
  connect_crm_apps: PXe,
  current_step_of_total: DXe,
  add_variable: LXe,
  custom_phone_number: MXe,
  message_template: FXe,
  email_subject: qXe,
  add_dynamic_variables: jXe,
  event_name_info: VXe,
  event_date_info: BXe,
  event_duration_info: UXe,
  event_time_info: GXe,
  event_type_not_found: WXe,
  number_to_call_variable: HXe,
  number_to_call_info: YXe,
  location_variable: KXe,
  location_info: ZXe,
  additional_notes_variable: XXe,
  additional_notes_info: JXe,
  attendee_name_info: QXe,
  organizer_name_info: eJe,
  to: tJe,
  workflow_turned_on_successfully: nJe,
  download_responses: oJe,
  download_responses_description: rJe,
  view_responses: iJe,
  download: aJe,
  downloading: sJe,
  download_recording: cJe,
  transcription_enabled: lJe,
  transcription_stopped: uJe,
  download_transcript: dJe,
  transcript: _Je,
  recording_from_your_recent_call: pJe,
  transcript_from_previous_call: mJe,
  you_can_download_transcript_from_attachments: fJe,
  link_valid_for_12_hrs: gJe,
  link_valid_for_12_hrs_description: hJe,
  create_your_first_form: vJe,
  create_your_first_form_description: bJe,
  create_your_first_webhook: yJe,
  create_your_first_webhook_description: $Je,
  for_a_maximum_of: wJe,
  event_one: kJe,
  event_other: SJe,
  profile_team_description: EJe,
  profile_org_description: xJe,
  members_team_description: CJe,
  organization_description: TJe,
  team_url: AJe,
  team_members: IJe,
  more: OJe,
  cal_ai_workflows: NJe,
  and_count_more: zJe,
  more_page_footer: RJe,
  workflow_example_1: PJe,
  workflow_example_2: DJe,
  workflow_example_3: LJe,
  workflow_example_4: MJe,
  workflow_example_5: FJe,
  workflow_example_6: qJe,
  send_sms_reminder: jJe,
  send_sms_reminder_description: VJe,
  follow_up_with_no_shows: BJe,
  follow_up_with_no_shows_description: UJe,
  remind_attendees_to_bring_id: GJe,
  remind_attendees_to_bring_id_description: WJe,
  email_to_remind_booking: HJe,
  email_to_remind_booking_description: YJe,
  custom_sms_reminder: KJe,
  custom_sms_reminder_description: ZJe,
  custom_email_reminder: XJe,
  custom_email_reminder_description: JJe,
  count_managed_to_limit: QJe,
  welcome_to_cal_header: eQe,
  edit_form_later_subtitle: tQe,
  connect_calendar_later: nQe,
  problem_saving_user_profile: oQe,
  purchase_missing_seats: rQe,
  slot_length: iQe,
  booking_appearance: aQe,
  appearance_team_description: sQe,
  appearance_org_description: cQe,
  only_owner_change: lQe,
  team_disable_cal_branding_description: uQe,
  invited_by_team: dQe,
  token_invalid_expired: _Qe,
  view_booking: pQe,
  exchange_add: mQe,
  exchange_authentication: fQe,
  exchange_authentication_standard: gQe,
  exchange_authentication_ntlm: hQe,
  exchange_compression: vQe,
  exchange_version: bQe,
  exchange_version_2007_SP1: yQe,
  exchange_version_2010: $Qe,
  exchange_version_2010_SP1: wQe,
  exchange_version_2010_SP2: kQe,
  exchange_version_2013: SQe,
  exchange_version_2013_SP1: EQe,
  exchange_version_2015: xQe,
  exchange_version_2016: CQe,
  routing: TQe,
  routing_forms_description: AQe,
  routing_forms_send_email_owner: IQe,
  routing_forms_send_email_owner_description: OQe,
  routing_forms_send_email_to: NQe,
  add_new_form: zQe,
  add_new_team_form: RQe,
  create_your_first_route: PQe,
  route_to_the_right_person: DQe,
  form: LQe,
  form_description: MQe,
  copy_link_to_form: FQe,
  theme: qQe,
  theme_applies_note: jQe,
  app_theme: VQe,
  app_theme_applies_note: BQe,
  theme_system: UQe,
  add_a_team: GQe,
  add_webhook_description: WQe,
  triggers_when: HQe,
  test_webhook: YQe,
  enable_webhook: KQe,
  add_webhook: ZQe,
  webhook_edited_successfully: XQe,
  api_keys_description: JQe,
  new_api_key: QQe,
  active: eet,
  api_key_updated: tet,
  api_key_update_failed: net,
  embeds_title: oet,
  embeds_description: ret,
  create_first_api_key: iet,
  create_first_api_key_description: aet,
  back_to_signin: set,
  reset_link_sent: cet,
  password_reset_email: uet,
  password_reset_leading: det,
  password_updated: _et,
  pending_payment: pet,
  pending_invites: met,
  pending_organization_invites: fet,
  not_on_cal: get,
  no_calendar_installed: het,
  no_calendar_installed_description: vet,
  add_a_calendar: bet,
  change_email_hint: yet,
  confirm_password_change_email: $et,
  seats: wet,
  every_app_published: ket,
  report_app: Eet,
  limit_booking_frequency: xet,
  limit_booking_frequency_description: Cet,
  only_show_first_available_slot: Tet,
  only_show_first_available_slot_description: Aet,
  limit_total_booking_duration: Iet,
  limit_total_booking_duration_description: Oet,
  booker_booking_limit: Net,
  booker_booking_limit_description: zet,
  recurring_event_doesnt_support_booker_booking_limit: Ret,
  add_limit: Pet,
  team_name_required: Det,
  show_attendees: Let,
  show_available_seats_count: Met,
  how_booking_questions_as_variables: Fet,
  format: qet,
  questions: jet,
  all_info_your_booker_provide: Vet,
  uppercase_for_letters: Bet,
  replace_whitespaces_underscores: Uet,
  platform_members: Get,
  platform_members_description: Wet,
  platform_billing: Het,
  manage_billing: Yet,
  manage_billing_description: Ket,
  billing_freeplan_title: Zet,
  billing_freeplan_description: Xet,
  billing_freeplan_cta: Jet,
  billing_portal: Qet,
  billing_help_cta: ett,
  ignore_special_characters_booking_questions: ttt,
  retry: ntt,
  fetching_calendars_error: ott,
  calendar_connection_fail: rtt,
  booking_confirmation_success: itt,
  booking_rejection_success: att,
  booking_tentative: stt,
  booking_accept_intent: ctt,
  we_wont_show_again: ltt,
  couldnt_update_timezone: utt,
  updated_timezone_to: dtt,
  update_timezone: _tt,
  update_timezone_question: ptt,
  update_timezone_description: mtt,
  dont_update: ftt,
  require_additional_notes: gtt,
  require_additional_notes_description: htt,
  email_address_action: vtt,
  after_event_trigger: btt,
  booking_rejected_trigger: ytt,
  booking_requested_trigger: $tt,
  booking_payment_initiated_trigger: wtt,
  booking_paid_trigger: ktt,
  booking_no_show_updated_trigger: Stt,
  how_long_after: Ett,
  how_long_after_hosts_no_show: xtt,
  how_long_after_guests_no_show: Ctt,
  how_long_after_user_no_show_minutes: Ttt,
  no_available_slots: Att,
  time_available: Itt,
  cant_find_the_right_conferencing_app_visit_our_app_store: Ott,
  install_new_calendar_app: Ntt,
  make_phone_number_required: ztt,
  new_event_type_availability: Rtt,
  error_editing_availability: Ptt,
  dont_have_permission: Dtt,
  saml_configuration_placeholder: Ltt,
  saml_email_required: Mtt,
  saml_sp_title: Ftt,
  saml_sp_description: qtt,
  saml_sp_acs_url: jtt,
  saml_sp_entity_id: Vtt,
  saml_sp_acs_url_copied: Btt,
  saml_sp_entity_id_copied: Utt,
  add_calendar: Gtt,
  limit_future_bookings: Wtt,
  limit_future_bookings_description: Htt,
  no_event_types: Ytt,
  no_event_types_description: Ktt,
  billing_frequency: Ztt,
  monthly: Xtt,
  yearly: Jtt,
  checkout: Qtt,
  your_team_disbanded_successfully: ent,
  your_org_disbanded_successfully: tnt,
  error_creating_team: nnt,
  you: ont,
  or_continue_with: rnt,
  resend_email: int,
  member_already_invited: ant,
  already_in_use_error: snt,
  enter_email_or_username: cnt,
  enter_email: lnt,
  enter_emails: unt,
  too_many_invites: dnt,
  team_name_taken: _nt,
  must_enter_team_name: pnt,
  team_url_required: mnt,
  url_taken: fnt,
  problem_registering_domain: gnt,
  team_publish: hnt,
  number_text_notifications: vnt,
  number_sms_notifications: bnt,
  attendee_email_variable: ynt,
  attendee_email_info: $nt,
  booking_uid: wnt,
  kbar_search_placeholder: knt,
  invalid_credential: Snt,
  invalid_credential_action: Ent,
  reschedule_reason: xnt,
  choose_common_schedule_team_event: Cnt,
  choose_common_schedule_team_event_description: Tnt,
  reason: Ant,
  sender_id: Int,
  sender_id_error_message: Ont,
  test_routing_form: Nnt,
  test_preview: znt,
  route_to: Rnt,
  test_preview_description: Pnt,
  test_routing: Dnt,
  payment_app_disabled: Lnt,
  edit_event_type: Mnt,
  only_admin_can_see_members_of_org: Fnt,
  only_admin_can_manage_sso_org: qnt,
  only_admin_can_manage_directory_sync: jnt,
  only_admin_can_manage_oauth_clients: Vnt,
  collective_scheduling: Bnt,
  make_it_easy_to_book: Unt,
  find_the_best_person: Gnt,
  fixed_round_robin: Wnt,
  add_one_fixed_attendee: Hnt,
  calcom_is_better_with_team: Ynt,
  the_calcom_team: Knt,
  add_your_team_members: Znt,
  booking_limit_reached: Xnt,
  duration_limit_reached: Jnt,
  admin_has_disabled: Qnt,
  disable_attendees_emails_description: eot,
  disabled_app_affects_event_type: tot,
  event_replaced_notice: not,
  email_subject_slug_replacement: oot,
  email_body_slug_replacement_notice: rot,
  email_body_slug_replacement_info: iot,
  email_body_slug_replacement_suggestion: aot,
  disable_payment_app: sot,
  payment_disabled_still_able_to_book: cot,
  app_disabled_with_event_type: lot,
  app_disabled_video: uot,
  app_disabled_subject: dot,
  navigate_installed_apps: _ot,
  disabled_calendar: pot,
  enable_apps: mot,
  enable_apps_description: fot,
  purchase_license: got,
  already_have_account: hot,
  already_have_key: vot,
  already_have_key_suggestion: bot,
  create_license_key: yot,
  app_is_enabled: $ot,
  app_is_disabled: wot,
  keys_have_been_saved: kot,
  disable_app: Sot,
  disable_app_description: Eot,
  edit_keys: xot,
  admin_apps_description: Cot,
  admin_users_description: Tot,
  admin_users_add_description: Aot,
  admin_users_edit_description: Iot,
  admin_orgs_edit_description: Oot,
  admin_oAuth_description: Not,
  admin_lockedSMS_description: zot,
  no_available_apps: Rot,
  no_available_apps_description: Pot,
  no_apps: Dot,
  no_apps_configured: Lot,
  enable_in_settings: Mot,
  please_contact_admin: Fot,
  apps_settings: qot,
  fill_this_field: jot,
  options: Vot,
  enter_option: Bot,
  add_an_option: Uot,
  location_already_exists: Got,
  radio: Wot,
  google_meet_warning: Hot,
  individual: Yot,
  all_bookings_filter_label: Kot,
  all_users_filter_label: Zot,
  all_event_types_filter_label: Xot,
  your_bookings_filter_label: Jot,
  meeting_url_variable: Qot,
  meeting_url_info: ert,
  date_overrides: trt,
  date_overrides_delete_on_date: nrt,
  date_overrides_subtitle: ort,
  date_overrides_info: rrt,
  date_overrides_dialog_which_hours: irt,
  date_overrides_dialog_which_hours_unavailable: art,
  date_overrides_dialog_title: srt,
  date_overrides_unavailable: crt,
  date_overrides_mark_all_day_unavailable_one: lrt,
  date_overrides_mark_all_day_unavailable_other: urt,
  date_overrides_update_btn: drt,
  date_successfully_added: _rt,
  date_overrides_save_btn: prt,
  event_type_duplicate_copy_text: mrt,
  set_as_default: frt,
  hide_eventtype_details: grt,
  show_navigation: hrt,
  hide_navigation: vrt,
  verification_code_sent: brt,
  verified_successfully: yrt,
  wrong_code: $rt,
  not_verified: wrt,
  no_availability_in_month: krt,
  no_availability_rolling: Srt,
  no_availability_range: Ert,
  view_previous_month: xrt,
  view_next_month: Crt,
  send_code: Trt,
  number_verified: Art,
  create_your_first_team_webhook_description: Irt,
  create_webhook_team_event_type: Ort,
  disable_success_page: Nrt,
  invalid_admin_password: zrt,
  change_password_admin: Rrt,
  username_already_taken: Prt,
  assignment: Drt,
  fixed_hosts: Lrt,
  add_fixed_hosts: Mrt,
  round_robin_hosts: Frt,
  minimum_round_robin_hosts_count: qrt,
  hosts: jrt,
  upgrade_to_enable_feature: Vrt,
  orgs_upgrade_to_enable_feature: Brt,
  new_attendee: Urt,
  awaiting_approval: Grt,
  requires_google_calendar: Wrt,
  event_type_requires_google_calendar: Hrt,
  connected_google_calendar: Yrt,
  using_meet_requires_calendar: Krt,
  continue_to_install_google_calendar: Zrt,
  install_google_meet: Xrt,
  install_google_calendar: Jrt,
  sender_name: Qrt,
  already_invited: eit,
  no_recordings_found: tit,
  new_workflow_subtitle: nit,
  reporting: oit,
  reporting_feature: rit,
  teams_plan_required: iit,
  routing_forms_are_a_great_way: ait,
  choose_a_license: sit,
  choose_license_description: cit,
  license: lit,
  agplv3_license: uit,
  no_need_to_keep_your_code_open_source: dit,
  repackage_rebrand_resell: _it,
  a_vast_suite_of_enterprise_features: pit,
  free_license_fee: mit,
  forever_open_and_free: fit,
  required_to_keep_your_code_open_source: git,
  cannot_repackage_and_resell: hit,
  no_enterprise_features: vit,
  step_enterprise_license: bit,
  step_enterprise_license_description: yit,
  setup: $it,
  setup_description: wit,
  configure: kit,
  sso_configuration: Sit,
  sso_configuration_description: Eit,
  sso_configuration_description_orgs: xit,
  sso_oidc_heading: Cit,
  sso_oidc_description: Tit,
  sso_oidc_configuration_title: Ait,
  sso_oidc_configuration_description: Iit,
  sso_oidc_callback_copied: Oit,
  sso_saml_heading: Nit,
  sso_saml_description: zit,
  sso_saml_configuration_title: Rit,
  sso_saml_configuration_description: Pit,
  sso_saml_acsurl_copied: Dit,
  sso_saml_entityid_copied: Lit,
  sso_connection_created_successfully: Mit,
  sso_connection_deleted_successfully: Fit,
  delete_sso_configuration: qit,
  delete_sso_configuration_confirmation: jit,
  delete_sso_configuration_confirmation_description: Vit,
  organizer_timezone: Bit,
  email_user_cta: Uit,
  accept_invite: Git,
  join_now: Wit,
  successfully_joined: Hit,
  email_no_user_invite_heading_subteam: Yit,
  email_no_user_invite_heading_org: Kit,
  email_no_user_invite_subheading: Zit,
  email_user_invite_subheading_subteam: Xit,
  email_user_invite_subheading_org: Jit,
  email_no_user_invite_steps_intro: Qit,
  email_no_user_step_one: eat,
  email_no_user_step_two: tat,
  email_no_user_step_three: nat,
  email_no_user_step_four: oat,
  email_no_user_signoff: rat,
  impersonation_user_tip: iat,
  available_variables: aat,
  scheduler: sat,
  no_workflows: cat,
  change_filter: lat,
  change_filter_common: uat,
  no_results_for_filter: dat,
  recommended_next_steps: _at,
  create_a_managed_event: pat,
  meetings_are_better_with_the_right: mat,
  create_a_one_one_template: fat,
  collective_or_roundrobin: gat,
  book_your_team_members: hat,
  event_no_longer_attending_subject: vat,
  no_longer_attending: bat,
  attendee_no_longer_attending_subject: yat,
  attendee_no_longer_attending: $at,
  attendee_no_longer_attending_subtitle: wat,
  create_event_on: kat,
  create_routing_form_on: Sat,
  default_app_link_title: Eat,
  default_app_link_description: xat,
  organizer_default_conferencing_app: Cat,
  organizer_default_conferencing_app_not_found: Tat,
  under_maintenance: Aat,
  under_maintenance_description: Iat,
  event_type_seats: Oat,
  booking_questions_title: Nat,
  booking_questions_description: zat,
  add_a_booking_question: Rat,
  identifier: Pat,
  duplicate_email: Dat,
  enter_redirect_url_on_exit_description: Lat,
  booking_with_payment_cancelled: Mat,
  booking_with_payment_cancelled_already_paid: Fat,
  booking_with_payment_cancelled_refunded: qat,
  booking_with_payment_cancelled_no_refund: jat,
  booking_with_payment_cancelled_refund_window_expired: Vat,
  booking_confirmation_failed: Bat,
  not_enough_seats: Uat,
  form_builder_field_already_exists: Gat,
  guests_field_must_be_multiemail: Wat,
  show_on_booking_page: Hat,
  visit_cancelled_booking: Yat,
  get_started_zapier_templates: Kat,
  standard_templates: Zat,
  cal_ai_templates: Xat,
  team_is_unpublished: Jat,
  org_is_unpublished_description: Qat,
  team_is_unpublished_description: est,
  team_member: tst,
  a_routing_form: nst,
  form_description_placeholder: ost,
  keep_me_connected_with_form: rst,
  fields_in_form_duplicated: ist,
  form_deleted: ast,
  delete_form: sst,
  delete_form_action: cst,
  delete_form_confirmation: lst,
  delete_form_confirmation_2: ust,
  typeform_redirect_url_copied: dst,
  modifications_in_fields_warning: _st,
  connected_forms: pst,
  form_modifications_warning: mst,
  responses_collection_waiting_description: fst,
  this_is_what_your_users_would_see: gst,
  identifies_name_field: hst,
  add_1_option_per_line: vst,
  select_a_router: bst,
  add_a_new_route: yst,
  make_informed_decisions: $st,
  make_informed_decisions_description: wst,
  view_bookings_across: kst,
  view_bookings_across_description: Sst,
  identify_booking_trends: Est,
  identify_booking_trends_description: xst,
  spot_popular_event_types: Cst,
  spot_popular_event_types_description: Tst,
  no_responses_yet: Ast,
  no_routes_defined: Ist,
  this_will_be_the_placeholder: Ost,
  error_booking_event: Nst,
  timeslot_missing_title: zst,
  timeslot_missing_description: Rst,
  timeslot_missing_cta: Pst,
  switch_monthly: Dst,
  switch_weekly: Lst,
  switch_multiday: Mst,
  switch_columnview: Fst,
  num_locations: qst,
  select_on_next_step: jst,
  this_meeting_has_not_started_yet: Vst,
  this_app_requires_connected_account: Bst,
  connect_app: Ust,
  app_is_connected: Gst,
  requires_app: Wst,
  verification_code: Hst,
  can_you_try_again: Yst,
  verify: Kst,
  timezone_info: Zst,
  timezone_variable: Xst,
  event_end_time_variable: Jst,
  event_end_time_info: Qst,
  cancel_url_variable: ect,
  cancel_url_info: tct,
  cancel_reason_variable: nct,
  cancel_reason_info: oct,
  reschedule_url_variable: rct,
  reschedule_url_info: ict,
  reschedule_reason_variable: act,
  reschedule_reason_info: sct,
  invalid_event_name_variables: cct,
  select_all: lct,
  default_conferencing_bulk_title: uct,
  members_default_schedule: dct,
  set_by_admin: _ct,
  members_default_location: pct,
  members_default_schedule_description: mct,
  requires_at_least_one_schedule: fct,
  default_conferencing_bulk_description: gct,
  default_schedules_bulk_description: hct,
  locked_for_members: vct,
  unlocked_for_members: bct,
  apps_locked_for_members_description: yct,
  apps_unlocked_for_members_description: $ct,
  apps_locked_by_team_admins_description: wct,
  apps_unlocked_by_team_admins_description: kct,
  workflows_locked_for_members_description: Sct,
  workflows_unlocked_for_members_description: Ect,
  workflows_locked_by_team_admins_description: xct,
  workflows_unlocked_by_team_admins_description: Cct,
  webhooks_locked_for_members_description: Tct,
  webhooks_unlocked_for_members_description: Act,
  webhooks_locked_by_team_admins_description: Ict,
  webhooks_unlocked_by_team_admins_description: Oct,
  locked_by_team_admin: Nct,
  app_not_connected: zct,
  connect_now: Rct,
  managed_event_dialog_confirm_button_one: Pct,
  managed_event_dialog_confirm_button_other: Dct,
  managed_event_dialog_title_one: Lct,
  managed_event_dialog_title_other: Mct,
  managed_event_dialog_information_one: Fct,
  managed_event_dialog_information_other: qct,
  managed_event_dialog_clarification: jct,
  review_event_type: Vct,
  looking_for_more_analytics: Bct,
  looking_for_more_insights: Uct,
  filters: Gct,
  filter: Wct,
  add_a_member: Hct,
  add_filter: Yct,
  add_rule: Kct,
  add_rule_group: Zct,
  remove_filters: Xct,
  email_verified: Jct,
  select_user: Qct,
  select_event_type: elt,
  select_date_range: tlt,
  popular_events: nlt,
  no_event_types_found: olt,
  average_event_duration: rlt,
  bookings_by_hour: ilt,
  most_booked_members: alt,
  least_booked_members: slt,
  most_bookings_scheduled: clt,
  least_bookings_scheduled: llt,
  most_bookings_completed: ult,
  least_bookings_completed: dlt,
  events_created: _lt,
  events_completed: plt,
  events_cancelled: mlt,
  events_rescheduled: flt,
  events: glt,
  performance: hlt,
  from_last_period: vlt,
  from_to_date_period: blt,
  redirect_url_warning: ylt,
  event_trends: $lt,
  clear_filters: wlt,
  clear: klt,
  hold: Slt,
  on_booking_option: Elt,
  hold_option: xlt,
  card_held: Clt,
  charge_card: Tlt,
  card_charged: Alt,
  no_show_fee_amount: Ilt,
  no_show_fee: Olt,
  submit_card: Nlt,
  submit_payment_information: zlt,
  meeting_awaiting_payment_method: Rlt,
  no_show_fee_charged_email_subject: Plt,
  no_show_fee_charged_text_body: Dlt,
  no_show_fee_charged_subtitle: Llt,
  error_charging_card: Mlt,
  collect_no_show_fee: Flt,
  no_show_fee_charged: qlt,
  your_card_was_declined: jlt,
  your_card_does_not_support_this_type_of_purchase: Vlt,
  amount_must_convert_to_at_least: Blt,
  could_not_charge_card: Ult,
  insights: Glt,
  routing_forms: Wlt,
  insights_no_data_found_for_filter: Hlt,
  acknowledge_booking_no_show_fee: Ylt,
  days: Klt,
  card_details: Zlt,
  something_went_wrong_on_our_end: Xlt,
  please_provide_following_text_to_suppport: Jlt,
  seats_and_no_show_fee_error: Qlt,
  complete_your_booking: eut,
  complete_your_booking_subject: tut,
  confirm_your_details: nut,
  copy_invite_link: out,
  edit_invite_link: rut,
  invite_link_copied: iut,
  invite_link_deleted: aut,
  api_key_deleted: sut,
  delete_api_key_warning: cut,
  invite_link_updated: lut,
  link_expires_after: uut,
  one_day: dut,
  seven_days: _ut,
  thirty_days: put,
  three_months: mut,
  one_year: fut,
  team_invite_received: gut,
  currency_string: hut,
  charge_card_dialog_body: vut,
  charge_attendee: but,
  payment_app_commission: yut,
  email_invite_team: $ut,
  email_invite_team_bulk: wut,
  error_collecting_card: kut,
  image_size_limit_exceed: Sut,
  unauthorized_workflow_error_message: Eut,
  inline_embed: xut,
  load_inline_content: Cut,
  floating_pop_up_button: Tut,
  floating_button_trigger_modal: Aut,
  pop_up_element_click: Iut,
  open_dialog_with_element_click: Out,
  use_my_own_form: Nut,
  use_our_headless_routing_api: zut,
  need_help_embedding: Rut,
  book_my_cal: Put,
  first_name: Dut,
  last_name: Lut,
  first_last_name: Mut,
  invite_as: Fut,
  form_updated_successfully: qut,
  disable_attendees_confirmation_emails: jut,
  disable_attendees_confirmation_emails_description: Vut,
  disable_host_confirmation_emails: But,
  disable_host_confirmation_emails_description: Uut,
  add_an_override: Gut,
  import_from_google_workspace: Wut,
  connect_google_workspace: Hut,
  google_workspace_admin_tooltip: Yut,
  first_event_type_webhook_description: Kut,
  create_instant_meeting_webhook_description: Zut,
  install_app_on: Xut,
  create_for: Jut,
  currency: Qut,
  organization_banner_description: edt,
  organization_banner_title: tdt,
  set_up_your_organization: ndt,
  set_up_your_platform_organization: odt,
  organizations_description: rdt,
  plans: idt,
  platform: adt,
  platform_description: sdt,
  platform_organization_description: cdt,
  must_enter_organization_name: ldt,
  must_enter_organization_admin_email: udt,
  admin_email: ddt,
  platform_admin_email: _dt,
  admin_username: pdt,
  organization_name: mdt,
  platform_name: fdt,
  organization_url: gdt,
  organization_verify_header: hdt,
  organization_verify_email_body: vdt,
  additional_url_parameters: bdt,
  about_your_organization: ydt,
  about_your_organization_description: $dt,
  create_your_teams: wdt,
  create_your_teams_description: kdt,
  invite_organization_admins: Sdt,
  invite_organization_admins_description: Edt,
  set_a_password: xdt,
  set_a_password_description: Cdt,
  organization_logo: Tdt,
  organization_about_description: Adt,
  ill_do_this_later: Idt,
  verify_your_email: Odt,
  enter_digit_code: Ndt,
  verify_email_organization: zdt,
  code_provided_invalid: Rdt,
  email_already_used: Pdt,
  organization_admin_invited_heading: Ddt,
  organization_admin_invited_body: Ldt,
  duplicated_slugs_warning: Mdt,
  team_names_empty: Fdt,
  team_names_repeated: qdt,
  user_belongs_organization: jdt,
  org_no_teams_yet: Vdt,
  org_no_teams_yet_description: Bdt,
  set_up: Udt,
  my_profile: Gdt,
  my_settings: Wdt,
  crm: Hdt,
  messaging: Ydt,
  sender_id_info: Kdt,
  org_admins_can_create_new_teams: Zdt,
  google_new_spam_policy: Xdt,
  resolve: Jdt,
  no_organization_slug: Qdt,
  copy_link_org: e_t,
  "404_the_org": "Die Organization",
  "404_the_team": "Das Team",
  "404_claim_entity_org": "Beanspruchen Sie Ihre Subdomain für Ihre Organization",
  "404_claim_entity_team": "Dieses Team beanspruchen und gemeinsam mit der Verwaltung von Verfügbarkeitsplänen beginnen",
  insights_team_filter: t_t,
  insights_user_filter: n_t,
  insights_subtitle: o_t,
  call_history: r_t,
  call_history_subtitle: i_t,
  location_options: a_t,
  channel_type: s_t,
  end_reason: c_t,
  session_status: l_t,
  user_sentiment: u_t,
  time_header: d_t,
  from_header: __t,
  custom_plan: p_t,
  email_embed: m_t,
  add_times_to_your_email: f_t,
  select_time: g_t,
  select_date: h_t,
  only_show_if_parameter_set: v_t,
  add_parameter: b_t,
  connecting_you_to_someone: y_t,
  please_do_not_close_this_tab: $_t,
  see_all_available_times: w_t,
  org_team_names_example_1: k_t,
  org_team_names_example_2: S_t,
  org_team_names_example_3: E_t,
  org_team_names_example_4: x_t,
  org_team_names_example_5: C_t,
  org_max_team_warnings: T_t,
  what_is_this_meeting_about: A_t,
  add_to_team: I_t,
  remove_users_from_org: O_t,
  delegation_credential: N_t,
  delegation_credential_description: z_t,
  add_client_id_in_google_workspace_with_below_scope: R_t,
  delegation_credential_enabled: P_t,
  add_delegation_credential: D_t,
  edit_delegation_credential: L_t,
  domain: M_t,
  no_workspace_platforms: F_t,
  workspace_platform: q_t,
  workspace_platforms: j_t,
  workspace_platforms_description: V_t,
  edit_workspace_platform: B_t,
  edit_service_account: U_t,
  add_workspace_platform: G_t,
  slug: W_t,
  service_account_key: H_t,
  edit_service_account_key: Y_t,
  delegation_credential_restricts_adding_more_than_one_installation: K_t,
  app_successfully_installed_and_is_using_delegated_credentials: Z_t,
  remove_users_from_org_confirm: X_t,
  remove_users_from_team: J_t,
  remove_users_from_team_confirm: Q_t,
  user_has_no_schedules: ept,
  user_isnt_in_any_teams: tpt,
  user_has_no_app_installed: npt,
  requires_booker_email_verification: opt,
  description_requires_booker_email_verification: rpt,
  requires_confirmation_mandatory: ipt,
  organizations: apt,
  upload_cal_video_logo: spt,
  update_cal_video_logo: cpt,
  upload_banner: lpt,
  cal_video_logo_upload_instruction: upt,
  org_admin_other_teams: dpt,
  org_admin_other_teams_description: _pt,
  not_part_of_org: ppt,
  no_other_teams_found: mpt,
  no_other_teams_found_description: fpt,
  attendee_first_name_variable: gpt,
  attendee_last_name_variable: hpt,
  attendee_first_name_info: vpt,
  attendee_last_name_info: bpt,
  your_monthly_digest: ypt,
  member_name: $pt,
  most_popular_events: wpt,
  summary_of_events_for_your_team_for_the_last_30_days: kpt,
  me: Spt,
  meeting_unavailable: Ept,
  monthly_digest_email: xpt,
  monthly_digest_email_for_teams: Cpt,
  verify_team_tooltip: Tpt,
  member_removed: Apt,
  my_availability: Ipt,
  team_availability: Opt,
  instant_meeting_availability: Npt,
  backup_code: zpt,
  backup_codes: Rpt,
  backup_code_instructions: Ppt,
  backup_codes_copied: Dpt,
  incorrect_backup_code: Lpt,
  lost_access: Mpt,
  missing_backup_codes: Fpt,
  admin_org_notification_email_subject: qpt,
  hi_admin: jpt,
  admin_org_notification_email_title: Vpt,
  admin_org_notification_email_body_part1: Bpt,
  admin_org_notification_email_body_part2: Upt,
  admin_org_notification_email_body_part3: Gpt,
  admin_org_notification_email_cta: Wpt,
  org_has_been_processed: Hpt,
  org_error_processing: Ypt,
  orgs_page_description: Kpt,
  unverified: Zpt,
  verified: Xpt,
  dns_missing: Jpt,
  dns_configured: Qpt,
  mark_dns_configured: emt,
  value: tmt,
  your_organization_updated_sucessfully: nmt,
  team_no_event_types: omt,
  seat_options_doesnt_multiple_durations: rmt,
  include_calendar_event: imt,
  oAuth: amt,
  oAuth_client_creation_form: smt,
  oAuth_client_creation_form_description: cmt,
  oAuth_client_updation_form: lmt,
  oAuth_client_updation_form_description: umt,
  recently_added: dmt,
  connect_all_calendars: _mt,
  connect_all_calendars_description: pmt,
  workflow_automation_description: mmt,
  scheduling_for_your_team: fmt,
  scheduling_for_your_team_description: gmt,
  no_members_found: hmt,
  directory_sync: vmt,
  directory_name: bmt,
  directory_provider: ymt,
  directory_scim_url: $mt,
  directory_scim_token: wmt,
  directory_scim_url_copied: kmt,
  directory_scim_token_copied: Smt,
  directory_sync_info_description: Emt,
  directory_sync_configure: xmt,
  directory_sync_configure_description: Cmt,
  directory_sync_title: Tmt,
  directory_sync_created: Amt,
  directory_sync_description: Imt,
  directory_sync_deleted: Omt,
  directory_sync_delete_connection: Nmt,
  directory_sync_delete_title: zmt,
  directory_sync_delete_description: Rmt,
  directory_sync_delete_confirmation: Pmt,
  event_setup_length_error: Dmt,
  availability_schedules: Lmt,
  unauthorized: Mmt,
  access_cal_account: Fmt,
  select_account_team: qmt,
  allow_client_to: jmt,
  associate_with_cal_account: Vmt,
  see_personal_info: Bmt,
  see_primary_email_address: Umt,
  connect_installed_apps: Gmt,
  access_event_type: Wmt,
  access_availability: Hmt,
  access_bookings: Ymt,
  allow_client_to_do: Kmt,
  oauth_access_information: Zmt,
  allow: Xmt,
  view_only_edit_availability_not_onboarded: Jmt,
  view_only_edit_availability: Qmt,
  you_can_override_calendar_in_advanced_tab: eft,
  edit_users_availability: tft,
  resend_invitation: nft,
  invitation_resent: oft,
  saml_sso: rft,
  add_client: ift,
  copy_client_secret_info: aft,
  add_new_client: sft,
  add_new_user: cft,
  this_app_is_not_setup_already: lft,
  as_csv: uft,
  overlay_my_calendar: dft,
  overlay_my_calendar_toc: _ft,
  view_overlay_calendar_events: pft,
  join_event_location: mft,
  troubleshooting: fft,
  calendars_were_checking_for_conflicts: gft,
  availabilty_schedules: hft,
  manage_calendars: vft,
  manage_availability_schedules: bft,
  locked: yft,
  unlocked: $ft,
  lock_timezone_toggle_on_booking_page: wft,
  description_lock_timezone_toggle_on_booking_page: kft,
  event_setup_multiple_payment_apps_error: Sft,
  number_in_international_format: Eft,
  install_calendar: xft,
  branded_subdomain: Cft,
  branded_subdomain_description: Tft,
  org_insights: Aft,
  org_insights_description: Ift,
  extensive_whitelabeling: Oft,
  extensive_whitelabeling_description: Nft,
  unlimited_teams: zft,
  verify_email: Rft,
  proceed_with_cancellation_description: Pft,
  proceed_with_cancellation_error: Dft,
  unlimited_teams_description: Lft,
  unified_billing: Mft,
  advanced_managed_events: Fft,
  advanced_managed_events_description: qft,
  enterprise: jft,
  enterprise_description: Vft,
  create_your_org: Bft,
  create_org: Uft,
  create_your_org_description: Gft,
  create_your_enterprise_description: Wft,
  other_payment_app_enabled: Hft,
  admin_delete_organization_description_1: Yft,
  admin_delete_organization_description_2: Kft,
  admin_delete_organization_description_3: Zft,
  admin_delete_organization_description_4: Xft,
  admin_delete_organization_title: Jft,
  published: Qft,
  unpublished: egt,
  publish: tgt,
  troubleshooter_tooltip: ngt,
  need_help: ogt,
  troubleshooter: rgt,
  number_to_call: igt,
  guest_name: agt,
  guest_email: sgt,
  guest_company: cgt,
  please_install_a_calendar: lgt,
  instant_tab_title: ugt,
  instant_event_tab_description: dgt,
  uprade_to_create_instant_bookings: _gt,
  dont_want_to_wait: pgt,
  meeting_started: mgt,
  pay_and_book: fgt,
  cal_ai_event_tab_description: ggt,
  booking_not_found_error: hgt,
  booking_seats_full_error: vgt,
  missing_payment_credential_error: bgt,
  missing_payment_app_id_error: ygt,
  not_enough_available_seats_error: $gt,
  user_redirect_title: wgt,
  user_redirect_description: kgt,
  out_of_office: Sgt,
  out_of_office_description: Egt,
  send_request: xgt,
  start_date_and_end_date_required: Cgt,
  start_date_must_be_before_end_date: Tgt,
  start_date_must_be_in_the_future: Agt,
  user_not_found: Igt,
  cannot_redirect_to_self: Ogt,
  out_of_office_entry_already_exists: Ngt,
  out_of_office_id_required: zgt,
  booking_redirect_infinite_not_allowed: Rgt,
  success_entry_created: Pgt,
  booking_redirect_email_subject: Dgt,
  booking_redirect_email_title: Lgt,
  booking_redirect_email_description: Mgt,
  booking_redirect_updated_email_subject: Fgt,
  booking_redirect_updated_email_title: qgt,
  booking_redirect_updated_email_description: jgt,
  booking_redirect_cancelled_email_subject: Vgt,
  booking_redirect_cancelled_email_title: Bgt,
  booking_redirect_cancelled_email_description: Ugt,
  success_accept_booking_redirect: Ggt,
  success_reject_booking_redirect: Wgt,
  copy_link_booking_redirect_request: Hgt,
  booking_redirect_request_title: Ygt,
  select_team_member: Kgt,
  going_away_title: Zgt,
  redirect_team_enabled: Xgt,
  redirect_team_disabled: Jgt,
  out_of_office_unavailable_list: Qgt,
  success_deleted_entry_out_of_office: eht,
  success_edited_entry_out_of_office: tht,
  temporarily_out_of_office: nht,
  add_a_redirect: oht,
  create_entry: rht,
  time_range: iht,
  automatically_add_all_team_members: aht,
  redirect_to: sht,
  having_trouble_finding_time: cht,
  show_more: lht,
  forward_params_redirect: uht,
  assignment_description: dht,
  lowest: _ht,
  low: pht,
  medium: mht,
  high: fht,
  Highest: ght,
  send_booker_to: hht,
  set_priority: vht,
  set_weight: bht,
  enable_weights: yht,
  priority_for_user: $ht,
  weights_description: wht,
  weight_for_user: kht,
  change_priority: Sht,
  field_identifiers_as_variables: Eht,
  field_identifiers_as_variables_with_example: xht,
  account_already_linked: Cht,
  send_email: Tht,
  cal_ai_phone_call_action: Aht,
  call_to_confirm_booking: Iht,
  cal_ai_phone_call_action_description: Oht,
  cal_ai_agent_configuration: Nht,
  choose_at_least_one_event_type_test_call: zht,
  mark_as_no_show: Rht,
  unmark_as_no_show: Pht,
  account_unlinked_success: Dht,
  account_unlinked_error: Lht,
  travel_schedule: Mht,
  travel_schedule_description: Fht,
  schedule_timezone_change: qht,
  date: jht,
  enter_the_general_prompt_for_the_agent: Vht,
  overlaps_with_existing_schedule: Bht,
  "org_admin_no_slots|heading": "Keine Verfügbarkeit für {{name}} gefunden",
  "org_admin_no_slots|content": "Hallo Organisationsadministratoren,<br /><br />Bitte beachten: Es wurde uns mitgeteilt, dass {{username}} keine Verfügbarkeit hatte, als ein Benutzer {{username}}/{{slug}} besucht hat<br /><br />Es gibt einige Gründe, warum dies passieren könnte<br />Der Benutzer hat keine Kalender verbunden<br />Die mit diesem Termin verknüpften Zeitpläne sind nicht aktiviert<br /> <br />Wir empfehlen, die Verfügbarkeit zu überprüfen, um dieses Problem zu lösen.",
  "org_admin_no_slots|cta": "Benutzerverfügbarkeit öffnen",
  organization_no_slots_notification_switch_title: Uht,
  organization_no_slots_notification_switch_description: Ght,
  organization_disable_phone_only_sms_notifications_switch_title: Wht,
  organization_disable_phone_only_sms_notifications_switch_description: Hht,
  "email_team_invite|subject|added_to_org": "{{user}} hat Sie zur Organisation {{team}} auf {{appName}} hinzugefügt",
  "email_team_invite|subject|invited_to_org": "{{user}} hat Sie eingeladen, der Organisation {{team}} auf {{appName}} beizutreten",
  "email_team_invite|subject|added_to_subteam": "{{user}} hat Sie zum Team {{team}} der Organisation {{parentTeamName}} auf {{appName}} hinzugefügt",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} hat Sie eingeladen, dem Team {{team}} auf {{appName}} beizutreten",
  "email_team_invite|heading|added_to_org": "Du wurdest zu einer {{appName}}-Organisation hinzugefügt",
  "email_team_invite|heading|invited_to_org": "Du wurdest zu einer {{appName}}-Organisation eingeladen",
  "email_team_invite|heading|added_to_subteam": "Du wurdest zu einem Team der {{parentTeamName}}-Organisation hinzugefügt",
  "email_team_invite|heading|invited_to_subteam": "Du wurdest zu einem Team der {{parentTeamName}}-Organisation eingeladen",
  "email_team_invite|heading|invited_to_regular_team": "Du wurdest eingeladen, einem {{appName}}-Team beizutreten",
  "email_team_invite|content|added_to_org": "{{invitedBy}} hat Sie zur <strong>{{teamName}}</strong>-Organisation hinzugefügt.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} hat Sie zur {{teamName}}-Organisation eingeladen.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} hat Sie eingeladen, dem Team {{team}} der Organisation {{parentTeamName}} auf {{appName}} beizutreten",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} hat Sie zum Team <strong>{{teamName}}</strong> in seiner bzw. ihrer Organisation {{parentTeamName}} hinzugefügt. {{appName}} ist der Terminplaner, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} hat Sie zum Team <strong>{{teamName}}</strong> in seiner bzw. ihrer Organisation {{parentTeamName}} eingeladen. {{appName}} ist der Terminplaner, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} hat Sie eingeladen, dem Team „{{teamName}}“ beizutreten. {{appName}} ist der Event-Planer, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.",
  "email|existing_user_added_link_will_change": "Bei Annahme der Einladung wird sich dein Link auf die Domain deiner Organisation ändern, aber keine Sorge, alle vorherigen Links werden weiterhin funktionieren und entsprechend weiterleiten.<br /><br />Bitte beachte: Alle deine persönlichen Ereignistypen werden in die <strong>{{teamName}}</strong> Organisation verschoben, was auch potenzielle persönliche Links einschließen kann. <br /><br />Für persönliche Ereignisse empfehlen wir, ein neues Konto mit einer persönlichen E-Mail-Adresse zu erstellen.",
  "email|existing_user_added_link_changed": "Dein Link wurde von {{a0}} zu {{a1}} geändert, aber keine Sorge, alle vorherigen Links funktionieren weiterhin und leiten entsprechend weiter. <br /><br />Bitte beachte: Alle deine persönlichen Ereignistypen wurden in die <strong>{{teamName}}</strong> Organisation verschoben, was auch potenzielle persönliche Links einschließen kann.<br /><br />Bitte melde dich an und stelle sicher, dass du keine privaten Ereignisse in deinem neuen Organisationskonto hast.<br /><br />Für persönliche Ereignisse empfehlen wir, ein neues Konto mit einer persönlichen E-Mail-Adresse zu erstellen.<br /><br />Genieße deinen neuen übersichtlichen Link: {{a2}}",
  "email_organization_created|subject": "Ihre Organisation wurde erstellt",
  your_current_plan: Yht,
  organization_price_per_user_month: Kht,
  privacy_organization_description: Zht,
  privacy: Xht,
  team_will_be_under_org: Jht,
  add_group_name: Qht,
  group_name: evt,
  routers: tvt,
  primary: nvt,
  make_primary: ovt,
  add_email: rvt,
  add_emails: ivt,
  add_email_description: avt,
  confirm_email: svt,
  confirming_your_booking_sms: cvt,
  scheduler_first_name: lvt,
  scheduler_last_name: uvt,
  scheduler_name: dvt,
  organizer_first_name: _vt,
  confirm_email_description: pvt,
  send_event_details_to: mvt,
  schedule_tz_without_end_date: fvt,
  select_members: gvt,
  lock_event_types_modal_header: hvt,
  org_delete_event_types_org_admin: vvt,
  org_hide_event_types_org_admin: bvt,
  hide_org_eventtypes: yvt,
  delete_org_eventtypes: $vt,
  lock_org_users_eventtypes: wvt,
  lock_org_users_eventtypes_description: kvt,
  add_to_event_type: Svt,
  create_account_password: Evt,
  create_account_with_saml: xvt,
  error_creating_account_password: Cvt,
  cannot_create_account_password_cal_provider: Tvt,
  cannot_create_account_password_already_existing: Avt,
  create_account_password_hint: Ivt,
  disconnect_account: Ovt,
  disconnect_account_hint: Nvt,
  cookie_consent_checkbox: zvt,
  make_a_call: Rvt,
  skip_rr_assignment_label: Pvt,
  skip_rr_description: Dvt,
  select_account_header: Lvt,
  select_account_description: Mvt,
  select_event_types_header: Fvt,
  select_event_types_description: qvt,
  configure_app_header: jvt,
  configure_app_description: Vvt,
  already_installed: Bvt,
  ooo_reasons_unspecified: Uvt,
  ooo_reasons_vacation: Gvt,
  ooo_reasons_travel: Wvt,
  ooo_reasons_sick_leave: Hvt,
  ooo_reasons_public_holiday: Yvt,
  ooo_forwarding_to: Kvt,
  ooo_not_forwarding: Zvt,
  ooo_empty_title: Xvt,
  ooo_empty_description: Jvt,
  ooo_user_is_ooo: Qvt,
  ooo_slots_returning: ebt,
  ooo_slots_book_with: tbt,
  ooo_select_reason: nbt,
  create_an_out_of_office: obt,
  edit_an_out_of_office: rbt,
  submit_feedback: ibt,
  host_no_show: abt,
  no_show_description: sbt,
  how_can_we_improve: cbt,
  most_liked: lbt,
  review: ubt,
  reviewed: dbt,
  unreviewed: _bt,
  rating_url_variable: pbt,
  rating_url_info: mbt,
  no_show_url_variable: fbt,
  no_show_url_info: gbt,
  no_support_needed: hbt,
  hide_support: vbt,
  event_ratings: bbt,
  event_no_show: ybt,
  event_no_show_guest: $bt,
  recent_ratings: wbt,
  no_ratings: kbt,
  no_ratings_description: Sbt,
  most_no_show_host: Ebt,
  highest_rated: xbt,
  lowest_rated: Cbt,
  highest_rated_members: Tbt,
  lowest_rated_members: Abt,
  csat_score: Ibt,
  lockedSMS: Obt,
  leave_without_assigning_anyone: Nbt,
  leave_without_adding_attendees: zbt,
  no_availability_shown_to_bookers: Rbt,
  go_back_and_assign: Pbt,
  leave_without_assigning: Dbt,
  signing_up_terms: Lbt,
  proceeding_agreement: Mbt,
  terms: Fbt,
  always_show_x_days: qbt,
  always_show_x_days_description: jbt,
  team_subscription_cancelled_successfully: Vbt,
  team_subscription_cancellation_error: Bbt,
  unable_to_subscribe_to_the_platform: Ubt,
  updating_oauth_client_error: Gbt,
  creating_oauth_client_error: Wbt,
  event_type_color: Hbt,
  event_type_color_description: Ybt,
  mark_as_no_show_title: Kbt,
  x_marked_as_no_show: Zbt,
  x_unmarked_as_no_show: Xbt,
  team_select_info: Jbt,
  team_settings_description: Qbt,
  no_show_updated: eyt,
  email_copied: tyt,
  phone_number_copied: nyt,
  USER_PENDING_MEMBER_OF_THE_ORG: oyt,
  USER_ALREADY_INVITED_OR_MEMBER: ryt,
  USER_MEMBER_OF_OTHER_ORGANIZATION: iyt,
  booking_reassigned: ayt,
  reassign: syt,
  reassign_to_another_rr_host: cyt,
  assign_team_member: lyt,
  override_team_member_to_assign: uyt,
  no_available_hosts: dyt,
  reassign_round_robin_host: _yt,
  skip_writing_to_calendar: pyt,
  rescheduling_not_possible: myt,
  event_expired: fyt,
  skip_contact_creation: gyt,
  skip_writing_to_calendar_note: hyt,
  attributes: vyt,
  new_attribute: byt,
  add_attributes: yyt,
  add_attributes_description: $yt,
  new_option: wyt,
  update_profile: kyt,
  attribute: Syt,
  create_attribute_description: Eyt,
  edit_attribute_description: xyt,
  attribute_updated_successfully: Cyt,
  attribute_deleted_successfully: Tyt,
  attributes_edited_successfully: Ayt,
  attribute_meta_description: Iyt,
  attributes_edit_description: Oyt,
  back_to_attributes: Nyt,
  delete_attribute: zyt,
  delete_attribute_description: Ryt,
  disable_all_emails_to_attendees: Pyt,
  disable_all_emails_description: Dyt,
  disable_all_emails_to_hosts: Lyt,
  type_confirm_to_continue: Myt,
  disable_email: Fyt,
  grant_admin_api: qyt,
  revoke_admin_api: jyt,
  add_calendar_label: Vyt,
  apple_connect_atom_label: Byt,
  apple_connect_atom_already_connected_label: Uyt,
  apple_connect_atom_loading_label: Gyt,
  google_connect_atom_label: Wyt,
  google_connect_atom_already_connected_label: Hyt,
  google_connect_atom_loading_label: Yyt,
  outlook_connect_atom_label: Kyt,
  outlook_connect_atom_already_connected_label: Zyt,
  outlook_connect_atom_loading_label: Xyt,
  stripe_connect_atom_label: Jyt,
  stripe_connect_atom_already_connected_label: Qyt,
  stripe_connect_atom_loading_label: e$t,
  booking_question_response_variables: t$t,
  managed_by_teamAdmins: n$t,
  number_of_options: o$t,
  reschedule_with_same_round_robin_host_title: r$t,
  reschedule_with_same_round_robin_host_description: i$t,
  disable_input_if_prefilled: a$t,
  booking_limits: s$t,
  booking_limits_team_description: c$t,
  limit_team_booking_frequency_description: l$t,
  booking_limits_updated_successfully: u$t,
  you_are_unauthorized_to_make_this_change_to_the_booking: d$t,
  delegation_credential_disabled: _$t,
  matching_members: p$t,
  x_matching_members: m$t,
  matching_members_queue_using_attribute_weights: f$t,
  matching_members_queue_using_event_assignee_weights: g$t,
  no_matching_members: h$t,
  no_matching_members_will_fallback_to_all_assigned_members: v$t,
  hide_calendar_event_details: b$t,
  description_hide_calendar_event_details: y$t,
  last_number_of_days: $$t,
  month_to_date: w$t,
  year_to_date: k$t,
  custom_range: S$t,
  refund_policy: E$t,
  always: x$t,
  never: C$t,
  payment_option: T$t,
  if_cancelled: A$t,
  before: I$t,
  show_all_columns: O$t,
  toggle_columns: N$t,
  no_columns_found: z$t,
  salesforce_create_record_as: R$t,
  salesforce_lead: P$t,
  salesforce_contact_under_account: D$t,
  salesforce_skip_entry_creation: L$t,
  salesforce_if_account_does_not_exist: M$t,
  salesforce_create_new_contact_under_account: F$t,
  salesforce_change_record_owner_on_booking: q$t,
  mass_assign_attributes: j$t,
  reroute_preview_custom_message: V$t,
  reroute_preview_external_redirect: B$t,
  reroute_preview_possible_host: U$t,
  current_routing_status: G$t,
  reroute_booking: W$t,
  reroute_booking_description: H$t,
  verify_new_route: Y$t,
  reroute: K$t,
  new_routing_status: Z$t,
  salesforce_book_directly_with_attendee_owner: X$t,
  salesforce_check_owner_of: J$t,
  account: Q$t,
  choose_hosts_schedule: ewt,
  hosts_schedule_description: twt,
  no_hosts_description: nwt,
  team_member_round_robin_reassign: owt,
  team_member_round_robin_reassign_description: rwt,
  round_robin_reassign_description: iwt,
  invalid_round_robin_host: awt,
  user_is_round_robin_fixed: swt,
  reschedule_with_same_timeslot: cwt,
  reschedule_with_same_timeslot_of_new_event: lwt,
  reschedule_to_the_new_event_with_different_timeslot: uwt,
  reschedule_with_different_timeslot: dwt,
  we_dont_have_id_for_the_new_event: _wt,
  rerouted_booking_successfully_redirecting_to_booking_page: pwt,
  on_booking_write_to_event_object: mwt,
  field_name: fwt,
  add_new_field: gwt,
  you_dont_have_access_to_reroute_this_booking: hwt,
  form_response_not_found: vwt,
  contact_owner: bwt,
  contact_owner_not_found: ywt,
  using_fallback_members: $wt,
  chosen_route: wwt,
  attribute_logic_matched: kwt,
  attribute_logic_fallback_matched: Swt,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: Ewt,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: xwt,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: Cwt,
  warning: Twt,
  fallback_attribute_logic_description: Awt,
  fallback_attribute_logic_warning: Iwt,
  fallback_not_needed: Owt,
  confirm_reassign_unavailable: Nwt,
  confirm_reassign_available: zwt,
  reassign_unavailable_team_member_description: Rwt,
  reassign_available_team_member_description: Pwt,
  yes_reassign: Dwt,
  filter_by_attributes: Lwt,
  reassign_reason: Mwt,
  field_type_change_suggestion: Fwt,
  reassigned_by: qwt,
  row: jwt,
  rows: Vwt,
  attendee_timezone_variable: Bwt,
  event_start_time_in_attendee_timezone_variable: Uwt,
  event_start_time_in_attendee_timezone_info: Gwt,
  event_end_time_in_attendee_timezone_info: Wwt,
  event_end_time_in_attendee_timezone_variable: Hwt,
  salesforce_create_event_on_contact: Ywt,
  salesforce_owner_name_to_change: Kwt,
  no_filter_set: Zwt,
  booking_dry_run_successful: Xwt,
  booking_dry_run_successful_description: Jwt,
  dont_have_access_this_page: Qwt,
  you_need_admin_or_owner_privileges_to_access: ekt,
  field_type: tkt,
  when_to_write: nkt,
  salesforce_on_booking_write_to_record: okt,
  on_every_booking: rkt,
  only_if_field_is_empty: ikt,
  booking_start_date: akt,
  booking_created_date: skt,
  booking_reassigned_to_host: ckt,
  no_contact_owner: lkt,
  routing_forms_created: ukt,
  routing_forms_total_responses: dkt,
  routing_forms_total_responses_without_booking: _kt,
  routing_forms_total_responses_with_booking: pkt,
  routing_form_insights: mkt,
  routing_form_insights_form_name_header: fkt,
  routing_form_insights_booking_status_header: gkt,
  routing_form_insights_response_no_booking: hkt,
  routing_form_insights_booked_by: vkt,
  routing_form_insights_created_at: bkt,
  routing_form_insights_booking_status: ykt,
  routing_form_insights_booking_at: $kt,
  routing_form_insights_submitted_at: wkt,
  copy_redirect_url: kkt,
  redirect_url_on_exit: Skt,
  total_bookings_per_period: Ekt,
  routed_to_per_period: xkt,
  per_day: Ckt,
  per_week: Tkt,
  per_month: Akt,
  routing_form_insights_assignment_reason: Ikt,
  access_denied: Okt,
  salesforce_route_to_owner: Nkt,
  salesforce_add_attendees_as: zkt,
  salesforce_do_not_route_to_owner: Rkt,
  salesforce_route_to_custom_lookup_field: Pkt,
  salesforce_option: Dkt,
  lookup_field_name: Lkt,
  salesforce_if_free_email_domain_skip_owner_check: Mkt,
  filter_operator_is: Fkt,
  filter_operator_is_not: qkt,
  filter_operator_contains: jkt,
  filter_operator_does_not_contain: Vkt,
  filter_operator_starts_with: Bkt,
  filter_operator_ends_with: Ukt,
  filter_operator_is_empty: Gkt,
  filter_operator_not_empty: Wkt,
  translate_description_button: Hkt,
  translate_description_button_description: Ykt,
  rr_distribution_method: Kkt,
  rr_distribution_method_description: Zkt,
  rr_distribution_method_availability_title: Xkt,
  rr_distribution_method_availability_description: Jkt,
  rr_distribution_method_balanced_title: Qkt,
  rr_distribution_method_balanced_description: e0t,
  edit_team_member_weights: t0t,
  weights_updated_successfully: n0t,
  require_confirmation_for_free_email: o0t,
  exclude_emails_that_contain: r0t,
  require_emails_that_contain: i0t,
  exclude_emails_match_found_error_message: a0t,
  require_emails_no_match_found_error_message: s0t,
  search_columns: c0t,
  search_options: l0t,
  disable_org_url_label: u0t,
  disable_org_url_description: d0t,
  single_select: _0t,
  multi_select: p0t,
  calendar_conflict_settings: m0t,
  select_calendars_conflict_check: f0t,
  group_meeting: g0t,
  are_you_sure_you_want_to_remove_this_app_from: h0t,
  disconnect_app_from: v0t,
  salesforce_ignore_guests: b0t,
  google_meet: y0t,
  zoom: $0t,
  office_365_video: w0t,
  lock_attribute_for_assignment: k0t,
  lock_attribute_for_assignment_description: S0t,
  attribute_edited_successfully: E0t,
  new_group_option: x0t,
  attribute_weight_enabled: C0t,
  attribute_weight_enabled_description: T0t,
  routed: A0t,
  reassigned: I0t,
  allow_rescheduling_past_events: O0t,
  allow_rescheduling_past_events_description: N0t,
  rerouted: z0t,
  salesforce_assigned: R0t,
  router_position: P0t,
  show_matching_hosts: D0t,
  no_active_queues: L0t,
  weight: M0t,
  calibration: F0t,
  shortfall: q0t,
  routing_form: j0t,
  go_back_and_save: V0t,
  save_changes: B0t,
  leave_without_saving: U0t,
  leave_without_saving_description: G0t,
  something_unexpected_occurred: W0t,
  "500_error_message": "Es liegt nicht an Ihnen, sondern an uns.",
  dry_run_mode_active: H0t,
  icon_showcase: Y0t,
  icons_showcase: K0t,
  migrating_from_team: Z0t,
  feature_currently_disabled: X0t,
  choose_an_option: J0t,
  enter_option_value: Q0t,
  remove_option: e1t,
  use_attribute_weights: t1t,
  if_enabled_ignore_event_type_weights: n1t,
  attribute_for_weights: o1t,
  managed_users: r1t,
  managed_users_description: i1t,
  can_you_tell_me_about: a1t,
  use_ai_to_answer_your_questions: s1t,
  error_fetching_answer: c1t,
  k_bar_ai_error: l1t,
  select_oAuth_client: u1t,
  on_every_instance: d1t,
  delegation_credential_feature_not_enabled: _1t,
  internal_booking_note: p1t,
  internal_note_cancellation_reason: m1t,
  internal_booking_note_description: f1t,
  internal_note_presets: g1t,
  internal_note_presets_description: h1t,
  internal_note_presets_updated_successfully: v1t,
  add_preset: b1t,
  authorize: y1t,
  next: $1t,
  hide: w1t,
  show: k1t,
  utm_params: S1t,
  no_utm_params: E1t,
  asc: x1t,
  desc: C1t,
  verify_email_change: T1t,
  buy_credits: A1t,
  credits: I1t,
  credits_used: O1t,
  total_credits_remaining: N1t,
  credits_per_tip_org: z1t,
  credits_per_tip_teams: R1t,
  view_and_manage_credits: P1t,
  view_and_manage_credits_description: D1t,
  credit_worth_description: L1t,
  buy_additional_credits: M1t,
  view_additional_credits_expense_tip: F1t,
  overview: q1t,
  organization_slug_taken: j1t,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: V1t,
  you_need_to_complete_user_onboarding_before_creating_an_organization: B1t,
  use_company_email_to_create_an_organization: U1t,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: G1t,
  you_need_to_have_minimum_published_teams: W1t,
  you_are_part_of_this_organization_already: H1t,
  you_are_part_of_another_organization_cannot_create_organization: Y1t,
  you_are_part_of_another_platform_organization_cannot_create_organization: K1t,
  organization_payment_success: Z1t,
  organization_payment_success_description: X1t,
  this_may_take_a_few_seconds: J1t,
  organization_onboarding_status: Q1t,
  organization_onboarding_status_description: eSt,
  payment_failed: tSt,
  payment_failed_description: nSt,
  creating_your_organization: oSt,
  organization_onboarding_already_completed: rSt,
  organization_onboarding_already_exists: iSt,
  organization_onboarding_not_found: aSt,
  payment_successful: sSt,
  handover_onboarding_page_title: cSt,
  handover_onboarding_page_description: lSt,
  organization_already_exists_with_this_slug: uSt,
  you_do_not_have_permission_to_create_an_organization_for_this_email: dSt,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: _St,
  organization_has_subscription_already: pSt,
  reset_interval_weighted_rr: mSt,
  interval: fSt,
  rr_reset_interval_description: gSt,
  daily: hSt,
  end_date_not_selected: vSt,
  my_ooo: bSt,
  team_ooo: ySt,
  out_of_office_team_description: $St,
  create_ooo_dialog_team_title: wSt,
  create_ooo_dialog_team_subtitle: kSt,
  edit_ooo_dialog_team_subtitle: SSt,
  ooo_team_empty_title: ESt,
  ooo_team_empty_description: xSt,
  forward_to_team_member_only: CSt,
  ooo_team_redirect_infinite_not_allowed: TSt,
  previous_ooo_empty_title: ASt,
  previous: ISt,
  rr_interval_successfully_updated: OSt,
  trial_mode: NSt,
  inactive_team_plan: zSt,
  inactive_team_plan_description: RSt,
  limited_access_trial_mode: PSt,
  referral_program: DSt,
  referral_text: LSt,
  dub_disabled_error_message: MSt,
  uid: FSt,
  link: qSt,
  rows_per_page: jSt,
  pagination_status: VSt,
  tip_username_plus: BSt,
  user_has_no_team_yet: USt,
  no_team_members: GSt,
  recurring_event_doesnt_support_seats: WSt,
  booking_limit_per_booker_doesnt_support_recurring: HSt,
  seats_doesnt_support_recurring: YSt,
  recurring_event_seats_error: KSt,
  segment: ZSt,
  saved_filters: XSt,
  rename: JSt,
  rename_segment: QSt,
  delete_segment: eEt,
  duplicate_segment: tEt,
  delete_segment_confirmation: nEt,
  filter_segment_updated: oEt,
  error_updating_filter_segment: rEt,
  filter_segment_duplicated: iEt,
  error_duplicating_filter_segment: aEt,
  filter_segment_deleted: sEt,
  error_deleting_filter_segment: cEt,
  save_segment: lEt,
  segment_not_found: uEt,
  filter_segment_saved: dEt,
  no_segments: _Et,
  error_saving_filter_segment: pEt,
  override_segment: mEt,
  create_new_segment: fEt,
  save_for_team: gEt,
  select_team: hEt,
  please_select_team: vEt,
  personal: bEt,
  hide_team_profile_link: yEt,
  hide_team_profile_link_description: $Et,
  display: wEt,
  could_not_find_slug_to_publish_org: kEt,
  picklist: SEt,
  most_cancelled_bookings: EEt,
  interface_language: xEt,
  interface_language_description: CEt,
  visitors_browser_language: TEt,
  name_or_email: AEt,
  salesforce_round_robin_skip_fallback_to_lead_owner: IEt,
  credit_purchase_failed: OEt,
  minimum_of_credits_required: NEt,
  enable_delegation_credential: zEt,
  enable_delegation_credential_description: REt,
  disable_delegation_credential: PEt,
  disable_delegation_credential_description: DEt,
  last_active: LEt,
  member_since: MEt,
  last_updated: FEt,
  salesforce_on_cancel_write_to_event: qEt,
  salesforce_on_every_cancellation: jEt,
  report_issue: VEt,
  report_issue_description: BEt,
  open_issue: UEt,
  this_is_your_current_plan: GEt,
  schedule_a_time: WEt,
  this_includes: HEt,
  oauth_client_updated_successfully: YEt,
  oauth_client_not_found: KEt,
  subscribe_to_platform: ZEt,
  error_accessing_webhooks: XEt,
  webhook_update_failed: JEt,
  webhook_create_failed: QEt,
  invalid_link: ext,
  currently_subscribed_to_plan: txt,
  user_team: nxt,
  client_id_copied: oxt,
  client_secret_copied: rxt,
  maintenance_message: ixt,
  your_payment_failed: axt,
  check_your_inbox: sxt,
  account_created_premium_not_reserved: cxt,
  email_sent_with_activation_link: lxt,
  activate_account_to_purchase_username: uxt,
  open_in_gmail: dxt,
  dont_see_email: _xt,
  resend_in_seconds: pxt,
  resend: mxt,
  verification_email_sent: fxt,
  select_all_members: gxt,
  select_all_members_tooltip: hxt,
  form_settings: vxt,
  remove_whitelist_status: bxt,
  whitelist_user_workflows: yxt,
  user_workflows_whitelisted: $xt,
  user_workflows_unwhitelisted: wxt,
  date_and_time: kxt,
  email_reminder_upcoming_event_notice: Sxt,
  email_reminder_triggered_by_workflow: Ext,
  event_upper_case: xxt,
  scheduling_by: Cxt,
  experience_review_prompt: Txt,
  improve_customer_experience_message: Axt,
  meeting_satisfaction_question: Ixt,
  meeting_not_joined_question: Oxt,
  reschedule_cta_short: Nxt,
  hide_organizer_email: zxt,
  platform_customer_cant_create_organization: Rxt,
  organization_customer_cant_create_platform: Pxt,
  hide_organizer_email_description: Dxt,
  you_and_conjunction: Lxt,
  select_verified_email: Mxt,
  add_verified_email: Fxt,
  add_verified_emails: qxt,
  custom_reply_to_email_title: jxt,
  custom_reply_to_email_description: Vxt,
  email_survey_triggered_by_workflow: Bxt,
  skip_trial: Uxt,
  team_trials_skipped_successfully: Gxt,
  sms_workflow_consent: Wxt,
  routing_preview_more_info_found_insights: Hxt,
  results: Yxt,
  view_form: Kxt,
  sms_opt_out_message: Zxt,
  team_credits_low_warning: Xxt,
  user_credits_low_warning: Jxt,
  action_required_out_of_credits: Qxt,
  action_required_user_out_of_credits: eCt,
  low_credits_warning_message: tCt,
  low_credits_warning_message_user: nCt,
  credit_limit_reached_message: oCt,
  credit_limit_reached_message_user: rCt,
  current_credit_balance: iCt,
  current_balance: aCt,
  notification_about_your_booking: sCt,
  monthly_credits: cCt,
  total_credits: lCt,
  remaining_credits: uCt,
  remaining: dCt,
  total: _Ct,
  additional_credits: pCt,
  routing_form_next_in_queue: mCt,
  routing_form_select_members_to_email: fCt,
  routing_incomplete_booking_tab: gCt,
  include_no_show_in_rr_calculation: hCt,
  recent_no_show_guests: vCt,
  recent_no_show_guests_tooltip: bCt,
  matching: yCt,
  event_redirect: $Ct,
  reset_form: wCt,
  rr_settings_successfully_updated: kCt,
  distribution_basis_weighted_rr: SCt,
  timestamp_basis_description: ECt,
  requires_credits: xCt,
  requires_credits_tooltip: CCt,
  available_credits: TCt,
  create_role: ACt,
  roles_and_permissions: ICt,
  roles_and_permissions_description: OCt,
  learn_more_permissions: NCt,
  role_name: zCt,
  role_name_required: RCt,
  role_name_placeholder: PCt,
  role_description: DCt,
  role_description_placeholder: LCt,
  default_role: MCt,
  custom_role: FCt,
  advanced: qCt,
  search_permissions: jCt,
  all_permissions: VCt,
  none: BCt,
  read_only: UCt,
  pbac_desc_all_actions_all_resources: GCt,
  pbac_resource_all: WCt,
  pbac_resource_event_type: HCt,
  pbac_resource_team: YCt,
  pbac_resource_organization: KCt,
  pbac_resource_booking: ZCt,
  pbac_resource_insights: XCt,
  pbac_resource_role: JCt,
  pbac_resource_routing_form: QCt,
  pbac_resource_workflow: eTt,
  pbac_action_all: tTt,
  pbac_action_create: nTt,
  pbac_action_read: oTt,
  pbac_action_update: rTt,
  pbac_action_delete: iTt,
  pbac_action_manage: aTt,
  pbac_action_invite: sTt,
  pbac_action_remove: cTt,
  pbac_action_change_member_role: lTt,
  pbac_action_list_members: uTt,
  pbac_action_manage_billing: dTt,
  pbac_action_read_team_bookings: _Tt,
  pbac_action_read_org_bookings: pTt,
  pbac_action_read_recordings: mTt,
  pbac_action_impersonate: fTt,
  role_created_successfully: gTt,
  role_updated_successfully: hTt,
  delete_role: vTt,
  confirm_delete_role: bTt,
  role_deleted_successfully: yTt,
  error_creating_role: $Tt,
  error_updating_role: wTt,
  pbac_desc_create_roles: kTt,
  pbac_resource_attributes: STt,
  pbac_desc_view_organization_attributes: ETt,
  pbac_desc_update_organization_attributes: xTt,
  pbac_desc_delete_organization_attributes: CTt,
  pbac_desc_create_organization_attributes: TTt,
  pbac_desc_view_roles: ATt,
  pbac_desc_update_roles: ITt,
  pbac_desc_delete_roles: OTt,
  pbac_desc_create_workflows: NTt,
  set_up_required: zTt,
  pbac_desc_view_workflows: RTt,
  pbac_desc_update_workflows: PTt,
  pbac_desc_delete_workflows: DTt,
  pbac_resource_webhook: LTt,
  pbac_resource_availability: MTt,
  pbac_resource_out_of_office: FTt,
  pbac_desc_create_webhooks: qTt,
  pbac_desc_view_webhooks: jTt,
  pbac_desc_update_webhooks: VTt,
  pbac_desc_delete_webhooks: BTt,
  pbac_desc_create_availability: UTt,
  pbac_desc_view_availability: GTt,
  pbac_desc_update_availability: WTt,
  pbac_desc_delete_availability: HTt,
  pbac_desc_create_out_of_office: YTt,
  pbac_desc_view_out_of_office: KTt,
  pbac_desc_update_out_of_office: ZTt,
  pbac_desc_delete_out_of_office: XTt,
  pbac_desc_manage_workflows: JTt,
  pbac_desc_create_event_types: QTt,
  pbac_desc_view_event_types: eAt,
  pbac_desc_update_event_types: tAt,
  pbac_desc_delete_event_types: nAt,
  pbac_desc_manage_event_types: oAt,
  pbac_desc_create_teams: rAt,
  pbac_desc_view_team_details: iAt,
  pbac_desc_update_team_settings: aAt,
  pbac_desc_delete_team: sAt,
  pbac_desc_invite_team_members: cAt,
  pbac_desc_remove_team_members: lAt,
  pbac_desc_change_team_member_role: uAt,
  pbac_desc_impersonate_team_members: dAt,
  pbac_desc_manage_teams: _At,
  pbac_desc_create_organization: pAt,
  pbac_desc_view_organization_details: mAt,
  pbac_desc_list_organization_members: fAt,
  pbac_desc_invite_organization_members: gAt,
  pbac_desc_remove_organization_members: hAt,
  pbac_desc_manage_organization_billing: vAt,
  pbac_desc_change_organization_member_role: bAt,
  pbac_desc_impersonate_organization_members: yAt,
  pbac_desc_edit_organization_settings: $At,
  pbac_desc_manage_organizations: wAt,
  pbac_desc_view_bookings: kAt,
  pbac_desc_view_team_bookings: SAt,
  pbac_desc_view_organization_bookings: EAt,
  pbac_desc_view_booking_recordings: xAt,
  pbac_desc_update_bookings: CAt,
  pbac_desc_manage_bookings: TAt,
  pbac_desc_view_team_insights: AAt,
  pbac_desc_manage_team_insights: IAt,
  pbac_desc_create_routing_forms: OAt,
  pbac_desc_view_routing_forms: NAt,
  pbac_desc_update_routing_forms: zAt,
  pbac_desc_delete_routing_forms: RAt,
  read_permission_auto_enabled_tooltip: PAt,
  choose_restriction_schedule: DAt,
  restriction_schedule_description: LAt,
  use_booker_timezone: MAt,
  use_booker_timezone_info: FAt,
  load_balancing_warning: qAt,
  rr_load_balancing_disabled: jAt,
  rr_load_balancing_disabled_with_groups: VAt,
  round_robin_settings_description: BAt,
  round_robin_settings_updated_successfully: UAt,
  booking_creation_time: GAt,
  meeting_start_time: WAt,
  members_affected_by_disabling_delegation_credential: HAt,
  no_members_affected_by_disabling_delegation_credential: YAt,
  download_expense_log: KAt,
  error_downloading_expense_log: ZAt,
  offer_to_reschedule_last_booking: XAt,
  booker_limit_exceeded_error: JAt,
  booker_limit_exceeded_error_reschedule: QAt,
  duration_min_error: e2t,
  duration_max_error: t2t,
  booking_not_allowed_by_restriction_schedule_error: n2t,
  restriction_schedule_not_found_error: o2t,
  converted_image_size_limit_exceed: r2t,
  add_group: i2t,
  routing_funnel: a2t,
  routing_funnel_total_submissions: s2t,
  routing_funnel_successful_routings: c2t,
  routing_funnel_accepted_bookings: l2t,
  license_key: u2t,
  license_selection_title: d2t,
  license_selection_description: _2t,
  agplv3_license_description: p2t,
  enter_license_key: m2t,
  enter_your_license_key: f2t,
  enter_existing_license: g2t,
  enter_license_key_description: h2t,
  license_key_placeholder: v2t,
  save_license_key: b2t,
  signature_token_optional: y2t,
  signature_token_description: $2t,
  need_a_license: w2t,
  license_key_required: k2t,
  invalid_license_key: S2t,
  license_validation_failed: E2t,
  attachments_optional: x2t,
  send_message: C2t,
  describe_the_issue: T2t,
  file_size_limit_exceed: A2t,
  invalid_file_type: I2t,
  invalid_file_type_extension: O2t,
  max_files_exceeded: N2t,
  files_uploaded_successfully: z2t,
  file_upload_instructions: R2t,
  license_key_saved: P2t,
  timezone_mismatch_tooltip: D2t,
  show_optimized_slots: L2t,
  show_optimized_slots_description: M2t,
  failed_bookings_by_field: F2t,
  failed_bookings: q2t,
  event_type_no_hosts: j2t,
  cache_status: V2t,
  cache_last_updated: B2t,
  delete_cached_data: U2t,
  cache_deleted_successfully: G2t,
  error_deleting_cache: W2t,
  confirm_delete_cache: H2t,
  yes_delete_cache: Y2t,
  remainder_of_maximum_uses_left_plural: K2t,
  remainder_of_maximum_use_left_singular: Z2t,
  expires_on_date: X2t,
  single_use: J2t,
  time_based_expiration: Q2t,
  usage_based_expiration: eIt,
  number_of_uses: tIt,
  expires_on: nIt,
  max_usage_count: oIt,
  link_settings: rIt,
  link_expired_on_date: iIt,
  usage_limit_reached: aIt,
  usage_count_error: sIt,
  private_link_expired: cIt,
  time_based_expiration_description: lIt,
  time_based_generic_expiration_description: uIt,
  usage_based_expiration_description: dIt,
  usage_based_generic_expiration_description: _It,
  usage_based_expiration_description_plural: pIt,
  webhook_trigger_event: mIt,
  webhook_created_at: fIt,
  webhook_type: gIt,
  set_up_agent: hIt,
  webhook_title: vIt,
  webhook_start_time: bIt,
  webhook_end_time: yIt,
  webhook_description: $It,
  webhook_location: wIt,
  webhook_uid: kIt,
  webhook_reschedule_uid: SIt,
  webhook_cancellation_reason: EIt,
  webhook_rejection_reason: xIt,
  webhook_organizer_name: CIt,
  webhook_organizer_email: TIt,
  webhook_organizer_timezone: AIt,
  webhook_organizer_locale: IIt,
  webhook_organizer_username: OIt,
  webhook_organizer_username_in_org: NIt,
  webhook_attendee_name: zIt,
  webhook_attendee_email: RIt,
  webhook_attendee_timezone: PIt,
  webhook_attendee_locale: DIt,
  webhook_team_name: LIt,
  webhook_team_members: MIt,
  webhook_video_call_url: FIt,
  webhook_hide_variables: qIt,
  webhook_show_variable: jIt,
  webhook_event_and_booking: VIt,
  webhook_people: BIt,
  webhook_teams: UIt,
  webhook_metadata: GIt,
  stats: WIt,
  booking_status: HIt,
  visit: YIt,
  location_custom_label_input_label: KIt,
  meeting_link: ZIt,
  session_outcome: XIt,
  call_created: JIt,
  voicemail: QIt,
  my_bookings: eOt,
  phone: tOt,
  free: nOt,
  user_email: oOt,
  user_name: rOt,
  expand_panel: iOt,
  collapse_panel: aOt,
  email_verification_required: sOt,
  invalid_verification_code: cOt,
  you_have_one_team: lOt,
  consider_consolidating_one_team_org: uOt,
  consider_consolidating_multi_team_org: dOt,
  message_sent: _Ot,
  support_message_sent_description: pOt,
  search_variables: mOt,
  support_message_placeholder: fOt,
  send_another_message: gOt,
  sending: hOt,
  no_variables_found: vOt,
  credits_required: bOt,
  web_call_credits_info: yOt,
  web_call_no_credits: $Ot,
  purchase_credits: wOt,
  credits_required_tooltip: kOt,
  api_key_name_too_long: SOt,
  auto_charge_for_last_minute_cancellation: EOt,
  before_scheduled_start_time: xOt,
  cancel_booking_acknowledge_no_show_fee: COt,
  contact_organizer: TOt,
  booking_time_option: AOt,
  booking_time_option_description: IOt,
  created_at_option: OOt,
  created_at_option_description: NOt,
  call_details: zOt,
  call_id: ROt,
  call_information: POt,
  sentiment: DOt,
  disconnect_reason: LOt,
  call_summary: MOt,
  transcription: FOt,
  event_details: qOt,
  agent: jOt,
  no_transcript_available: VOt,
  testing_sms_workflow_info_message: BOt,
  start_from_scratch_title: UOt,
  start_from_scratch_description: GOt,
  cal_ai_template_title: WOt,
  cal_ai_template_description: HOt,
  voice: YOt,
  select_voice: KOt,
  select_voice_for_agent: ZOt,
  choose_a_voice_for_your_agent: XOt,
  trait: JOt,
  voice_id: QOt,
  use_voice: eNt,
  current_voice: tNt,
  setup_incoming_agent: nNt,
  setup_incoming_agent_description: oNt,
  connect_a_phone_number_first: rNt,
  setup_agent_for_incoming_calls: iNt,
  configure_agent_to_handle_incoming_calls: aNt,
  incoming_calls: sNt,
  outgoing_calls: cNt,
  inbound_agent_setup_success: lNt,
  inbound_agent_configured: uNt,
  setup_inbound_agent: dNt,
  please_select_event_type_first: _Nt,
  edit_configuration: pNt,
  select_event_type_for_inbound_calls: mNt,
  setup_inbound_agent_for_incoming_calls: fNt,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: gNt
}, vNt = "Identity provider", bNt = 'You have $t(day, {"count": {{days}} }) left on your PRO trial', yNt = "{{count}} day", $Nt = "{{count}} days", wNt = "{{count}} second", kNt = "{{count}} seconds", SNt = "Upgrade now", ENt = "Untitled", xNt = "Accept Invitation", CNt = "Max. Characters", TNt = "Min. Characters", ANt = "{{appName}} provides scheduling infrastructure for absolutely everyone.", INt = "Finish setting up your {{appName}} account! You're just a few steps away from solving all your scheduling problems.", ONt = "Have questions? We're here to help.", NNt = "{{appName}}: Reset password instructions", zNt = "{{appName}}: Verify your account", RNt = "{{appName}}: Verify your email", PNt = "Check your email", DNt = "Old Email", LNt = "New Email", MNt = "We've sent an email to {{email}}. It is important to verify your email address to guarantee the best email and calendar deliverability from {{appName}}.", FNt = "Verify your email address to guarantee the best email and calendar deliverability", qNt = "Verify your email address", jNt = "Verify email", VNt = "Assistant", BNt = "Send Cal Video Transcription Emails", UNt = "Send emails with the transcription of the Cal Video after the meeting ends. (Requires a paid plan)", GNt = "You have recently requested to change the email address you use to log into your {{appName}} account. Please click the button below to confirm your new email address.", WNt = "Updated your email to {{email}}", HNt = "Failed to update email.", YNt = "Verify your new {{appName}} email address", KNt = "We have sent a verification link to {{email}}. We will update your email address once you click this link.", ZNt = "Save this API key somewhere safe. You will not be able to view it again.", XNt = "Please verify your email address by clicking the button below.", JNt = "Please verify your email address by using the below code.", QNt = "Here's the link in case you don't like clicking buttons:", ezt = "Enter verification code", tzt = "Enter verification code sent to your mail", nzt = "Verification code is incorrect.", ozt = "Email sent successfully", rzt = "Error occurred while sending email", izt = "Declined: {{title}} at {{date}}", azt = "Canceled: {{title}} at {{date}}", szt = "Reassigned: {{title}} at {{date}}", czt = "Your event request has been declined", lzt = "Customize Cal Video Settings", uzt = "Configure video meeting preferences including recording permissions for hosts and attendees.", dzt = "Disable recording for guests", _zt = "Enable automatic transcription after joining the meeting", pzt = "Enable automatic recording after organizer joins the meeting", mzt = "Video Options", fzt = "Edit event", gzt = "View Session Details", hzt = "Meeting Session Details", vzt = "Meeting Session", bzt = "Session ID", yzt = "Max Participants", $zt = "Unlimited", wzt = "Ongoing", kzt = "Ended", Szt = "Participants", Ezt = "Anonymous User", xzt = "Session Duration", Czt = "No meeting sessions found", Tzt = "Not available", Azt = "Disable recording for organizer", Izt = "Disable transcription for guests", Ozt = "Disable transcription for organizer", Nzt = "Your recurring event request has been declined", zzt = "Your scheduled event was canceled", Rzt = "Your scheduled event was reassigned", Pzt = "You will no longer have the event on your calendar and your round robin likelihood will not be negatively impacted", Dzt = "Organizer", Lzt = "Reassigned to", Mzt = "Need to reschedule or cancel?", Fzt = "You can view the booking details from this url {{url}} and add the event to your calendar", qzt = "No options available", jzt = "Reason for cancellation (optional)", Vzt = "Cancelled By", Bzt = "Reason for cancellation", Uzt = "Why are you cancelling?", Gzt = "Cancellation reason will be shared with guests", Wzt = "Why are you rejecting?", Hzt = "Reason for rejecting", Yzt = "Reject the booking request?", Kzt = "Are you sure you want to reject the booking? We'll let the person who tried to book know. You can provide a reason below.", Zzt = "Reject the booking", Xzt = "Report this booking as suspicious. This helps us identify and prevent spam or unwanted bookings.", Jzt = "Spam or unwanted booking", Qzt = "I don't know this person", eRt = "Other", tRt = "Cancel this booking", nRt = "Report all remaining bookings in series", oRt = "Submit Report", rRt = "Please provide additional details about why you're reporting this booking (optional)", iRt = "Manage this event", aRt = "Invite team member", sRt = "Invite individual", cRt = "Bulk import", lRt = "Inv.", uRt = "Your event has been scheduled", dRt = "Your recurring event has been scheduled", _Rt = "Accept our license by changing the .env variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> to '{{agree}}'.", pRt = "To remove this banner, please open your .env file and change the <1>NEXT_PUBLIC_LICENSE_CONSENT</1> variable to '{{agree}}'.", mRt = "The error message was: '{{errorMessage}}'", fRt = "Refund failed: {{name}} - {{date}} - {{eventType}}", gRt = "The refund for the event {{eventType}} with {{userName}} on {{date}} failed.", hRt = "Please check with your payment provider and {{user}} how to handle this.", vRt = "A refund failed", bRt = "Awaiting Payment: {{title}} on {{date}}", yRt = "Your meeting is awaiting payment", $Rt = "Dark Theme color doesn't pass contrast check. We recommend you change this colour so your buttons will be more visible.", wRt = "Light Theme color doesn't pass contrast check. We recommend you change this colour so your buttons will be more visible.", kRt = "Light Theme color doesn't pass contrast check. We recommend you change this color so your event types color will be more visible.", SRt = "Dark Theme color doesn't pass contrast check. We recommend you change this color so your event types color will be more visible.", ERt = "Payment could not be created", xRt = "Could not charge card for Payment", CRt = "No available users found. Could you try another time slot?", TRt = "The selected time slot is no longer available. <0>Please select a new time</0>", ARt = "Taken", IRt = "You’ve just connected. Please book from above slots or retry later.", ORt = "Unavailable timeslot", NRt = "The event type cannot be booked at this time. Could you try another time slot?", zRt = "Internal Error. Request body does not contain end time", RRt = "Unable to create Calendar event in Organizer's calendar", PRt = "Unable to update Calendar event.", DRt = "Unable to delete Calendar event.", LRt = "You are already signed up for this booking.", MRt = "Some of the hosts are unavailable for booking.", FRt = "Some of the fixed hosts are unavailable for booking.", qRt = "Round Robin host is unavailable for booking.", jRt = "Help", VRt = "Price", BRt = "Paid", URt = "Refunded", GRt = "Record", WRt = "Transcribe", HRt = "Payment", YRt = "Missing card fields", KRt = "Pay now", ZRt = "General Prompt", XRt = "Transcription powered by AI", JRt = "Start or stop recording", QRt = "Begin Message", ePt = "The codebase has to stay open source, whether it was modified or not", tPt = "You can not repackage or sell the codebase", nPt = "Acquire a commercial license to remove these terms by emailing", oPt = "Summary of terms", rPt = "Open .env and agree to our License", iPt = "I've changed my .env", aPt = "Accept License", sPt = "An event is still waiting for approval", cPt = "Event request is still waiting: {{attendeeName}} - {{date}} - {{eventType}}", lPt = 'No result found for "{{searchTerm}}"', uPt = "No more results", dPt = "No results", _Pt = "Load more results", pPt = "{{integrationName}} meeting ID: {{meetingId}}", mPt = "Confirmed: {{eventType}} with {{name}} at {{date}}", fPt = "New event request: {{attendeeName}} - {{date}} - {{eventType}}", gPt = "Confirm or reject the request", hPt = "Check your bookings page to confirm or reject the booking.", vPt = "Check-in Assistant", bPt = "Makes an outbound call to check if scheduled appointment works or if you want to reschedule.", yPt = "Create your own prompt and use it to make an outbound call.", $Pt = "An event is waiting for your approval", wPt = "A recurring event is waiting for your approval", kPt = "Someone has requested to schedule an event on your calendar.", SPt = "Someone has requested a link to change your password.", EPt = "If this email exists in our system, you should receive a reset email.", xPt = "If you didn't request this, you can safely ignore this email and your password will not be changed.", CPt = "Awaiting Approval: {{title}} at {{date}}", TPt = "An event is still waiting for your approval", APt = "Booking Submitted: {{title}} at {{date}}", IPt = "Download Recording: {{title}} at {{date}}", OPt = "Download Transcript: {{title}} at {{date}}", NPt = "Download your recording", zPt = "Download your Transcripts", RPt = "Your meeting has been booked", PPt = "Your {{title}} has been rescheduled to {{date}}.", DPt = "Your {{title}} has been updated.", LPt = "Updated - Your event has been rescheduled", MPt = "Event has been updated", FPt = "Your event has been rescheduled", qPt = "{{organizer}} has canceled the booking and requested you to pick another time.", jPt = "You have requested {{attendee}} to reschedule", VPt = "You have canceled the booking and {{attendee}} should pick a new booking time with you.", BPt = "Request for reschedule sent: {{eventType}} with {{name}} at {{date}}", UPt = "Action Required Reschedule: Please book a new time for {{eventType}} with {{name}}", GPt = "Hi {{name}}", WPt = "{{eventType}} with {{name}}", HPt = "It looks like all of our experts are busy right now. Please schedule a call at a time that works best for you and we'll be ready to assist you.", YPt = "Schedule instead", KPt = "New event: {{attendeeName}} - {{date}} - {{eventType}}", ZPt = "Join by {{entryPoint}}", XPt = "Notes", JPt = "Manage my bookings", QPt = "Need to make a change?", eDt = "A new event has been scheduled.", tDt = "A new recurring event has been scheduled.", nDt = "Invitee Email", oDt = "Invitee Time Zone", rDt = "Time left", iDt = "Event Type", aDt = "Duplicate Event Type", sDt = "Enter Meeting", cDt = "Video call provider", lDt = "Meeting ID", uDt = "Meeting Password", dDt = "Meeting URL", _Dt = "Meeting URL not found", pDt = "Token not found", mDt = "Some other host already accepted the meeting. Do you still want to join? <0>Continue to Meeting</0>", fDt = "Your meeting request has been rejected", gDt = "Rejected: {{eventType}} with {{organizer}} on {{date}}", hDt = "Hi", vDt = "Join team", bDt = "Manage this team", yDt = "Team Info", $Dt = "Join Meeting", wDt = "If you prefer not to use {{toEmail}} as your {{appName}} email or already have a {{appName}} account, please request another invitation to that email.", kDt = "You have been invited to join the team {{teamName}}", SDt = "{{user}} invited you to join the {{entity}} {{team}} on {{appName}}", EDt = "You are hidden in this team", xDt = "Your seat is not paid for, either Upgrade to PRO or let the team owner know they can pay for your seat.", CDt = "You need a pro account to use teams, you are hidden until you upgrade.", TDt = "p.s. It expires in {{expiresIn}} hours.", ADt = "Upgrade to Per-Seat", IDt = "Seats option doesn't support confirmation requirement", ODt = "Multiple Locations doesn't support seats option", NDt = "No show fee doesn't support seats option", zDt = "Seats option doesn't support Multiple Locations", RDt = "Of the {{memberCount}} members in your team, {{unpaidCount}} seat(s) are unpaid. At ${{seatPrice}}/month per seat the estimated total cost of your membership is ${{totalCost}}/month.", PDt = `You haven't finished your team setup. Your team "{{teamName}}" needs to be upgraded.`, DDt = "Upgrade here", LDt = "Your team was upgraded successfully!", MDt = 'Thank you for trialing our Organization plan. We noticed your Organization "{{teamName}}" needs to be upgraded.', FDt = "Your Organization was upgraded successfully!", qDt = "Use the link below to reset your password", jDt = "Hey there", VDt = "there", BDt = "Forgot your password? - {{appName}}", UDt = "Are you sure you want to delete this webhook? You will no longer receive {{appName}} meeting data at a specified URL, in real-time, when an event is scheduled or canceled.", GDt = "Yes, delete webhook", WDt = "Edit Webhook", HDt = "Delete Webhook", YDt = "Webhook Status", KDt = "Webhook Enabled", ZDt = "Webhook Disabled", XDt = "Webhook response", JDt = "Webhook test", QDt = "Webhook update form", e3t = "Add a webhook to your OAuthClient.", t3t = "Manage your webhook", n3t = "Webhook created successfully!", o3t = "Webhook updated successfully!", r3t = "Webhook removed successfully!", i3t = "Subscription needed", a3t = "You are not subscribed to a Platform plan.", s3t = "Payload Template", c3t = "Dismiss", l3t = "No data yet", u3t = "Ping test", d3t = "Add this app to your home screen for faster access and improved experience.", _3t = "Upcoming", p3t = "Recurring", m3t = "Past", f3t = "Choose a file...", g3t = "Upload image", h3t = "Upload {{target}}", v3t = "No {{target}}", b3t = "Slide to zoom, drag to reposition", y3t = "View notifications", $3t = "View public page", w3t = "Copy public page link", k3t = "Copy referral link", S3t = "Sign out", E3t = "Add another", x3t = "Install another", C3t = "until", T3t = "powered by", A3t = "Unavailable", I3t = "Set your work schedule", O3t = "Change when you are available for bookings", N3t = "Select...", z3t = "Text", R3t = "Your Phone Number", P3t = "Multiline Text", D3t = "Number", L3t = "Checkbox", M3t = "Is required", F3t = "Make this field required", q3t = "Required", j3t = "Optional", V3t = "Input type", B3t = "Rejected", U3t = "Unconfirmed", G3t = "Guests", W3t = "Guest", H3t = "Web conferencing details to follow in the confirmation email.", Y3t = "Confirmation", K3t = "What your booker should provide to receive confirmations", Z3t = "Username", X3t = "is still available.", J3t = "Documentation", Q3t = "Learn how to integrate our tools with your app", eLt = "API Reference", tLt = "A complete API reference for our libraries", nLt = "Blog", oLt = "Read our latest news and articles", rLt = "Join our community", iLt = "Popular pages", aLt = "Register now", sLt = "Register", cLt = "This page does not exist.", lLt = "No active phone number available", uLt = "Workflow step not configured", dLt = "Check for spelling mistakes or go back to the previous page.", _Lt = "We could not find the event you are trying to book.", pLt = "Getting Started", mLt = "Secret", fLt = "Leave blank to remove secret", gLt = "Ensure your server is only receiving the expected {{appName}} requests for security reasons", hLt = "Secret Meeting", vLt = "Login instead", bLt = "Create Account", yLt = "Get started", $Lt = "Confirm password", wLt = "Set your new password with the instructions sent to your email address.", kLt = "Please upload image of {{width}} width and {{height}} height.", SLt = "Log back in with your new email address and password.", ELt = "Create your account", xLt = "Create your Cal.com account", CLt = "Sign up", TLt = "You've been logged out", ALt = "We hope to see you again soon!", ILt = "Logged out", OLt = "Please try again and contact us if the issue persists.", NLt = "Two-factor code is incorrect.", zLt = "No account exists matching that email address.", RLt = "Create an account", PLt = "Don't have an account?", DLt = "Sign in to your account", LLt = "Sign in", MLt = "Go back to the login page", FLt = "An error occurred when logging you in. Head back to the login screen and try again.", qLt = "Send reset email", jLt = "Send invite", VLt = "Forgot Password?", BLt = "Forgot?", ULt = "Done", GLt = "All done!", WLt = "All", HLt = "Your account", YLt = "Available Apps", KLt = "Available apps", ZLt = "View popular apps below and explore more in our <0>App Store</0>", XLt = "Add anyone who needs to attend the event. <0>Learn more</0>", JLt = "People in a group take turns, one person of each group will show up for the event.", QLt = "People in the group take turns and only one person will show up for the event.", eMt = "Check your email. We sent you a link to reset your password.", tMt = "Finish", nMt = "Manage settings for your team language and timezone", oMt = "A few sentences about yourself. This will appear on your scheduling link.", rMt = "Nearly there!", iMt = "Last thing, a brief description about you and a photo really helps you get bookings and let people know who they're booking with.", aMt = "Define ranges of time when you are available on a recurring basis. You can create more of these later and assign them to different calendars.", sMt = "Set your availability", cMt = "Set schedules for the times you want to be booked.", lMt = "Share a link or embed", uMt = "Share your {{appName}} link or embed on your site.", dMt = "Availability Settings", _Mt = "Continue without calendar", pMt = "Continue with {{appName}}", mMt = "Connect your calendar", fMt = "Connect your video apps", gMt = "Connect your preferred video conferencing app to use it for your meetings.", hMt = "Connect your calendar to automatically check for busy times and new events as they're scheduled.", vMt = "Set up later", bMt = "Current time", yMt = "Details", $Mt = "Welcome", wMt = "Welcome back", kMt = "Welcome to {{appName}}", SMt = "Tell us what to call you and let us know what timezone you're in. You'll be able to edit this later.", EMt = "Connect to CalDav (Beta)", xMt = "Connect to an ICS Feed", CMt = "Connect", TMt = "Try it for free", AMt = "Create your own booking link with {{appName}}", IMt = "Who", OMt = "What", NMt = "When", zMt = "Where", RMt = "Add to calendar", PMt = "Select where to add events when you're booked.", DMt = "Add events to", LMt = "Add another calendar", MMt = "Other", FMt = "Your sign-in link for {{appName}}", qMt = "You are meeting with {{user}}. We sent an email with a calendar invitation with the details to everyone.", jMt = "{{host}} is meeting with {{attendee}}. We sent an email with a calendar invitation with the details to everyone.", VMt = "We sent an email with a calendar invitation with the details to everyone.", BMt = "We sent an email with a calendar invitation with the details to everyone for the first of these recurring events.", UMt = "You are meeting with {{user}}. We sent an email with a calendar invitation with the details to everyone for the first of these recurring events.", GMt = "{{host}} is meeting with {{attendee}}. We sent an email with a calendar invitation with the details to everyone for the first of these recurring events.", WMt = "We sent an email to everyone with this information.", HMt = "Your booking still needs to be confirmed or rejected.", YMt = "Your recurring meeting still needs to be confirmed or rejected.", KMt = "{{user}} still needs to confirm or reject the booking.", ZMt = "{{user}} still needs to confirm or reject each booking of the recurring meeting.", XMt = "This meeting is scheduled", JMt = "The recurring events are scheduled", QMt = "Your booking has been submitted", e4t = "Your recurring meeting has been submitted", t4t = "Your booking has been confirmed", n4t = "Your recurring meeting has been confirmed", o4t = "Payments are not supported with Recurring Events yet", r4t = "Recurring events are not supported with Payments yet", i4t = "Enter the new password you'd like for your account.", a4t = "Reset Password", s4t = "Change your password", c4t = "Show password", l4t = "Hide password", u4t = "Try Again", d4t = "That Request is Expired.", _4t = "Enter the email address associated with your account and we will send you a link to reset your password.", p4t = "That request is expired. Go back and enter the email associated with your account and we will send you another link to reset your password.", m4t = "Whoops", f4t = "Login", g4t = "Success", h4t = "Failed", v4t = "Your password has been reset. You can now login with your newly created password.", b4t = "Layout", y4t = "Default view", $4t = "You can select multiple and your bookers can switch views.", w4t = "Booking layout", k4t = "You can select multiple and bookers can switch views. This can be overridden on a per event basis.", S4t = "Month", E4t = "Weekly", x4t = "Column", C4t = "At least one layout has to be enabled.", T4t = "The layout you selected as the default view is not part of the enabled layouts.", A4t = "The layout you selected is not a valid layout.", I4t = "You can manage this for all your event types in Settings -> <0>Appearance</0> or <1>Override</1> for this event only.", O4t = "An unexpected error occurred. Try again.", N4t = "Invalid time on Sunday", z4t = "Invalid time on Monday", R4t = "Invalid time on Tuesday", P4t = "Invalid time on Wednesday", D4t = "Invalid time on Thursday", L4t = "Invalid time on Friday", M4t = "Invalid time on Saturday", F4t = "End time cannot be before start time", q4t = "End time cannot be greater than 24 hours", j4t = "Back to bookings", V4t = "Feel free to pick another event anytime.", B4t = "Canceled", U4t = "No booking", G4t = "Awaiting host", W4t = "Cancellation successful", H4t = "Really cancel your booking?", Y4t = "You cannot cancel this booking", K4t = "Instead, you could also reschedule it.", Z4t = "The event is in the past", X4t = "The event is one instance of a recurring event.", J4t = "These are all remaining instances in the recurring event.", Q4t = "An error with status code {{status}} occurred.", e5t = "An event type with this URL already exists.", t5t = "You are not able to create this event", n5t = "You are not able to edit this event", o5t = "You are not able to create this workflow", r5t = "You are not able to create this schedule", i5t = "This booking was already canceled", a5t = "This booking was already accepted or rejected", s5t = "Go back home", c5t = "Or go back home", l5t = "No Meeting Found", u5t = "This meeting does not exist. Contact the meeting owner for an updated link.", d5t = "No {{status}} bookings", _5t = "You have no {{status}} bookings. {{description}}", p5t = "{{eventName}} between {{host}} and {{attendeeName}}", m5t = "Bookings", f5t = "Booking not found", g5t = "See upcoming and past events booked through your event type links.", h5t = "As soon as someone books a time with you it will show up here.", v5t = "As soon as someone books a recurring meeting with you it will show up here.", b5t = "Your past bookings will show up here.", y5t = "Your canceled bookings will show up here.", $5t = "Your unconfirmed bookings will show up here.", w5t = "Unconfirmed bookings", k5t = "on", S5t = "and", E5t = "Your calendar shows you as busy between", x5t = "Troubleshoot", C5t = "Understand why certain times are available and others are blocked.", T5t = "Here is an overview of your day on", A5t = "Tip: Hover over the bold times for a full timestamp", I5t = "Start time", O5t = "End time", N5t = "Buffer time", z5t = "Before event", R5t = "After event", P5t = "No buffer time", D5t = "Buffer", L5t = "Your day starts at", M5t = "Your day ends at", F5t = "Launch troubleshooter", q5t = "Troubleshoot your availability to explore why your times are showing as they are.", j5t = "Change available times", V5t = "Change your available times", B5t = "Change the start and end times of your day", U5t = "Set the start and end time of your day and a minimum buffer between your meetings.", G5t = "Currently, your day is set to start at", W5t = "The start and end times for your day have been changed successfully.", H5t = "and end at", Y5t = "Light", K5t = "Dark", Z5t = "Automatically adjust theme based on invitee preferences", X5t = "Some of the users in the group have currently disabled dynamic group bookings", J5t = "Group booking links that can be created dynamically by adding multiple usernames with a '+'. example: '{{appName}}/bailey+peer'", Q5t = "Allow attendees to book you through dynamic group bookings", e6t = "Dynamic group links", t6t = "Allow search engines to access your public content", n6t = "Allow search engine indexing", o6t = "Allow Browser Notifications", r6t = "You have denied notifications. Reset permission in browser settings to enable.", i6t = "Disable Browser Notifications", a6t = "Browser Notifications turned on", s6t = "Browser Notifications turned off", c6t = "Browser Notifications denied", l6t = "Please allow notifications from the prompt", u6t = "Push Notifications", d6t = "Receive push notifications when booker submits instant meeting booking.", _6t = "Your browser does not support Push Notifications. If you are Brave user then enable `Use Google services for push messaging` Option on brave://settings/?search=push+messaging", p6t = "Email", m6t = "jdoe@example.com", f6t = "Full name", g6t = "Browse our API documentation", h6t = "Leverage our API for full control and customizability.", v6t = "Create Webhook", b6t = "Instant Meeting Created", y6t = "Booking Canceled", $6t = "Booking Rescheduled", w6t = "Recording Download Link Ready", k6t = "Transcript Generated", S6t = "Booking Created", E6t = "Booking Rejected", x6t = "Booking Requested", C6t = "Booking Payment Initiated", T6t = "Meeting Ended", A6t = "Form Submitted", I6t = "Form submitted, no event booked", O6t = "Booking Paid", N6t = "Out of Office Created", z6t = "Booking No-Show Updated", R6t = "Event Triggers", P6t = "Subscriber URL", D6t = "Create a new webhook", L6t = "Webhooks", M6t = "Team Webhooks", F6t = "Create a new webhook to your account", q6t = "New Webhook", j6t = "Receive {{appName}} meeting data at a specified URL, in real-time, when an event is scheduled or canceled.", V6t = "Receive {{appName}} meeting data at a specified URL, in real-time, when this event is scheduled or canceled.", B6t = "Responsive full screen iframe", U6t = "Loading...", G6t = "Deleting...", W6t = "Standard iframe", H6t = "Developer", Y6t = "Manage your developer settings.", K6t = "iframe Embed", Z6t = "The easiest way to embed {{appName}} on your website.", X6t = "Integrate with your website using our embed options, or get real-time booking information using custom webhooks.", J6t = "Schedule a meeting", Q6t = "View and manage your billing details", eFt = "View and edit your billing details, as well as cancel your subscription.", tFt = "Go to the billing portal", nFt = "Need anything else?", oFt = "If you need any further help with billing, our support team are here to help.", rFt = "Contact", iFt = "our support team", aFt = "Contact our support team", sFt = "Uh oh!", cFt = "This user hasn't set up any event types yet.", lFt = "Edit logo", uFt = "Upload a logo", dFt = "Upload logo", _Ft = "Remove logo", pFt = "Enable", mFt = "Code", fFt = "Code is incorrect.", gFt = "Add new time slot", hFt = "Add an extra layer of security to your account in case your password is stolen.", vFt = "Enable two-factor authentication", bFt = "Disable two-factor authentication", yFt = "If you need to disable 2FA, we recommend re-enabling it as soon as possible.", $Ft = "Error disabling two-factor authentication", wFt = "Error setting up two-factor authentication", kFt = "Security", SFt = "Manage your account's security.", EFt = "Password", xFt = "Password updated successfully", CFt = "Your password has been successfully changed.", TFt = "Error changing password", AFt = "Your session configuration has been updated successfully.", IFt = "Error updating session configuration", OFt = "Something went wrong.", NFt = "Something doesn't look right?", zFt = "Please try again.", RFt = "Your super secure new password", PFt = "New Password", DFt = "Your old password", LFt = "Current Password", MFt = "Change Password", FFt = "Change Secret", qFt = "New password matches your old password. Please choose a different password.", jFt = "If you have lost or forgotten this secret, you can change it, but be aware that all integrations using this secret will need to be updated", VFt = "Current password is incorrect", BFt = "Mix of uppercase & lowercase letters", UFt = "Minimum 7 characters long", GFt = "Minimum 15 characters long", WFt = "Contain at least 1 number", HFt = "Must be {{limit}} or fewer characters long", YFt = "The password must be a minimum of {{passwordLength}} characters long containing at least one number and have a mixture of uppercase and lowercase letters", KFt = "Password is incorrect.", ZFt = "Email or password is incorrect.", XFt = "Use setting", JFt = "am/pm", QFt = "Time options", eqt = "January", tqt = "February", nqt = "March", oqt = "April", rqt = "May", iqt = "June", aqt = "July", sqt = "August", cqt = "September", lqt = "October", uqt = "November", dqt = "December", _qt = "Monday", pqt = "Tuesday", mqt = "Wednesday", fqt = "Thursday", gqt = "Friday", hqt = "Saturday", vqt = "Sunday", bqt = "All booked.", yqt = "Could not load the available time slots.", $qt = "Add guests", wqt = "Your name", kqt = "Your full name", Sqt = "No name", Eqt = "Please enter a number between 1 and {{maxOccurences}}", xqt = "Quick and easy - no account required. Perfect for one-time meetings.", Cqt = "Email address", Tqt = "Please enter a valid email", Aqt = " Please schedule a future call if we're not available in {{seconds}} seconds", Iqt = "Location", Oqt = "Address", Nqt = "Enter address", zqt = "In Person (Attendee Address)", Rqt = "Somewhere Else", Pqt = "Custom attendee location", Dqt = "Continue as Guest", Lqt = "Join as Guest", Mqt = "Ideal for one-time calls", Fqt = "Any location", qqt = "Yes", jqt = "No", Vqt = "Additional notes", Bqt = "Could not book the meeting.", Uqt = "Could not reschedule the meeting.", Gqt = "Please share anything that will help prepare for our meeting.", Wqt = "Confirm your {{eventTypeTitle}} with {{profileName}}", Hqt = "Reschedule your {{eventTypeTitle}} with {{profileName}}", Yqt = "In-person meeting", Kqt = "In Person (Organizer Address)", Zqt = "Link meeting", Xqt = "Phone Number", Jqt = "Attendee Phone Number", Qqt = "Organizer Phone Number", ejt = "Enter phone number", tjt = "Reschedule", njt = "Reschedule instead", ojt = "Book a team member instead", rjt = "OR", ijt = "Go back", ajt = "Email or Username", sjt = "Send an invite email", cjt = "Role", ljt = "Edit Role", ujt = "View Role", djt = "Edit team", _jt = "Editing user", pjt = "Editing organization", mjt = "If you wish to edit or manage your web hooks, please head over to <0>webhooks settings</0>", fjt = "Reject", gjt = "Reject all", hjt = "Accept", vjt = "Leave", bjt = "Profile", yjt = "My team URL", $jt = "My teams", wjt = "Team Name", kjt = "Your team name", Sjt = "Team updated successfully", Ejt = "Your team has been updated successfully.", xjt = "Your Org has been updated successfully.", Cjt = "Error copying to clipboard", Tjt = "About", Ajt = "A few sentences about your team. This will appear on your team's url page.", Ijt = "Organization ID", Ojt = "Organization ID copied.", Njt = "A few sentences about your organization. This will appear on your organization's url page.", zjt = "Team ID", Rjt = "Team ID copied.", Pjt = "Members", Djt = "Organization members", Ljt = "Member", Mjt = "{{count}} member", Fjt = "{{count}} members", qjt = "{{count}} selected", jjt = "Owner", Vjt = "Admin", Bjt = "Admin API", Ujt = "Administrator user", Gjt = "Let's create the first administrator user.", Wjt = "Administrator user setup", Hjt = "You have already created an administrator user. You can now log in to your account.", Yjt = "New Member", Kjt = "Invite", Zjt = "Add team members", Xjt = "Add members", Jjt = "Invite others to join your team", Qjt = "Add team member", eVt = "Invite a new team member", tVt = "Note: This will <0>cost an extra seat ($15/m)</0> on your subscription.", nVt = "Invite someone to your team.", oVt = "Upload a .csv file", rVt = "Invite via email", iVt = "Change team member role", aVt = "Disable {{appName}} branding", sVt = "Hide all {{appName}} branding from your public pages.", cVt = "Hide Book a Team Member Button", lVt = "Hide Book a Team Member Button from your public pages.", uVt = "Danger zone", dVt = "Be careful. Account deletion cannot be undone.", _Vt = "Be careful. Team deletion cannot be undone.", pVt = "Back", mVt = "Cancel", fVt = "Cancel all remaining", gVt = "Apply", hVt = "Cancel event", vVt = "Report booking", bVt = "Reporting this booking will automatically cancel it", yVt = "Add to report", $Vt = "Reported", wVt = "Confirm", kVt = "Confirm all", SVt = "Disband Team", EVt = "Are you sure you want to disband this team? Anyone who you've shared this team link with will no longer be able to book using it.", xVt = "Disband Organization", CVt = "Are you sure you want to disband this Org? All teams and members will be deleted.", TVt = "Are you sure you want to remove this member from the team?", AVt = "Yes, disband team", IVt = "Yes, remove member", OVt = "Yes, cancel subscription", NVt = "Cancel subscription", zVt = "Cancelling your subscription will permanently deactivate your current plan. This action cannot be undone.", RVt = "Remove member", PVt = "Manage your team", DVt = "You don't have any teams yet.", LVt = "Teams allow others to book events shared between your coworkers.", MVt = "Submit", FVt = "Yes, remove attribute", qVt = "Remove attribute", jVt = "Are you sure you want to remove the attribute '{{name}}'? All users currently assigned to it will be unassigned.", VVt = "View", BVt = "Update", UVt = "Save", GVt = "Pending", WVt = "Open options", HVt = "Copy link to event", YVt = "Share", KVt = "Would you mind booking my cal or send me your link?", ZVt = "Copy link to team", XVt = "Leave team", JVt = "Yes, leave team", QVt = "Are you sure you want to leave this team? You will no longer be able to book using it.", eBt = "{{user}} from {{team}}", tBt = "Preview", nBt = "Link copied!", oBt = "Copied!", rBt = "Private link copied!", iBt = "Link shared!", aBt = "Title", sBt = "Description", cBt = "Apps Status", lBt = "A quick video meeting.", uBt = "Scheduling Type", dBt = "Preview team", _Bt = "Collective", pBt = "Schedule meetings when all selected team members are available.", mBt = "Duration", fBt = "Available durations", gBt = "Default duration", hBt = "Please choose available durations first", vBt = "{{count}} $t(minute_timeUnit)", bBt = "{{count}} $t({{unit}}_timeUnit)", yBt = "{{count}}$t({{unit}}_short)", $Bt = "Minutes", wBt = "Use Cal.ai to get an AI powered phone number or make calls to guests.", kBt = "Termination URI", SBt = "SIP Trunk User Name", EBt = "SIP Trunk Password", xBt = "Nickname", CBt = "Delete Phone Number", TBt = "Workflow validation failed", ABt = "One or more workflow steps have empty message content", IBt = "One or more phone numbers or email addresses are not verified", OBt = "Supercharge your Workflows with Cal.ai", NBt = "Lifelike AI agents that book meetings, send reminders, and follow up with your customers.", zBt = "Phone number imported and linked to agent successfully", RBt = "Phone number deleted successfully", PBt = "Are you sure you want to delete this phone number? This action cannot be undone.", DBt = "Yes, delete phone number", LBt = "The number you are trying to import must be in E.164 format (+country code followed by the number, with no spaces or special characters), e.g. +1234567890", MBt = "The termination URI to uniquely identify your elastic SIP trunk. This is used for outbound calls. For Twilio elastic SIP trunks it always ends with .pstn.twilio.com.", FBt = "The username used to authenticate the SIP trunk.", qBt = "The password used to authenticate the SIP trunk.", jBt = "Nickname of the number. This is for your reference only.", VBt = "Save and Test Call", BBt = "Call initiated successfully", UBt = "Please enter a phone number", GBt = "Agent updated successfully", WBt = "Agent created successfully", HBt = "Event type added successfully", YBt = "Phone number unsubscribed successfully", KBt = "This prompt defines the agent's role and primary objectives", ZBt = "Prompt", XBt = "Call to", JBt = "Make Test Call to Verify Configuration", QBt = "Initial Message", e9t = "The first message the agent will say when starting a call", t9t = "Having trouble importing?", n9t = "Learn", o9t = "Learn how to get your Termination URI and SIP trunk credentials", r9t = "Phone number subscription canceled successfully", i9t = "Updating", a9t = "Round Robin", s9t = "Hi, how are you doing?", c9t = "Cycle meetings between multiple team members.", l9t = "Managed Event", u9t = "username", d9t = "Create & distribute event types in bulk to team members", _9t = "Managed", p9t = '"username" will be filled by the username of the members assigned', m9t = "Assign to", f9t = "Enter phone number to test call", g9t = "Make Test Call", h9t = "Create new workflow cal.ai voice agent", v9t = "Create a new workflow cal.ai voice agent to automate your workflows", b9t = "Phone number (for our agent to call)", y9t = "Buy a phone number or import one you already have on twilio", $9t = "Test Agent", w9t = "Test Web Call", k9t = "Phone Numbers", S9t = "Unsubscribe", E9t = "Delete Workflow Step", x9t = "Unsubscribe Phone Number", C9t = "Buy a new number", T9t = "You can only buy US phone numbers. For other countries, you can import your own Twilio phone number.", A9t = "Buy a US Number for ${{priceInDollars}} per month", I9t = "Supported Call Destinations", O9t = "No phone number connected", N9t = "Failed to get workflow step ID", z9t = "Cal.ai Agent", R9t = "Test Cal.ai Agent", P9t = "Are you sure you want to delete this workflow step?", D9t = "Do you still want to unsubscribe the phone number from this agent?", L9t = "This action will disconnect the phone number from the agent. The agent will not be able to make calls until a new phone number is connected.", M9t = "Phone Numbers", F9t = "Connect Phone Number", q9t = "Manage your Phone Numbers", j9t = "Import Number", V9t = "This action will also:", B9t = "Import Phone Number", U9t = "Active Subscription", G9t = "Cancel your phone number subscription", W9t = "Delete the associated phone number", H9t = "You are not authorized to create this workflow", Y9t = "Import your Twilio phone number to use with Phone", K9t = "${{price}}/month", Z9t = "Buy New Number", X9t = "Buying a phone number costs ${{priceInDollars}} per month. You will be charged monthly for each active phone number.", J9t = "Area Code (Optional)", Q9t = "No phone numbers", eUt = "Phone number purchased successfully", tUt = "Cancel Phone Number Subscription", nUt = "Yes, Cancel Subscription", oUt = "Are you sure you want to cancel this phone number subscription? This action cannot be undone and you will lose access to this phone number.", rUt = "Add members...", iUt = "Add members", aUt = "No assigned members", sUt = "Assigned to", cUt = "You must be logged in to {{url}}", lUt = "Start assigning members above", uUt = "Members can not edit", dUt = "Members can edit", _Ut = "Locked by the team admin", pUt = "Unlocked by team admin", mUt = "URL", fUt = "Hidden", gUt = "Readonly", hUt = "One-time link", vUt = "You're currently on the {{plan}} plan.", bUt = "Upgrade your account to the PRO plan to unlock all of the features we have to offer.", yUt = "You need to upgrade your plan to have more than one active event type.", $Ut = "You need to upgrade your plan to create a team.", wUt = "You can <1>upgrade here</1>.", kUt = "Event Types", SUt = "Create events to share for people to book on your calendar.", EUt = "New event type", xUt = "Create your first event type", CUt = "Event types enable you to share links that show available times on your calendar and allow people to make bookings with you.", TUt = "{{eventTypeTitle}} event type created successfully", AUt = "{{eventTypeTitle}} event type updated successfully", IUt = "Event type deleted successfully", OUt = "Hours", NUt = "People", zUt = "Your Email", RUt = "Change Avatar", PUt = "Upload Avatar", DUt = "Language", LUt = "Timezone", MUt = "First Day of Week", FUt = "Repeats up to {{count}} time", qUt = "Repeats up to {{count}} times", jUt = "Every {{freq}} for", VUt = "{{count}} event remaining", BUt = "{{count}} events remaining", UUt = "Repeats every", GUt = "occurrence", WUt = "occurrences", HUt = "week", YUt = "weeks", KUt = "month", ZUt = "months", XUt = "year", JUt = "years", QUt = "{{count}} more", eGt = "Max", tGt = "Single Theme", nGt = "Brand Color", oGt = "Brand Color (Light Theme)", rGt = "Brand Color (Dark Theme)", iGt = "Event Type Color (Light Theme)", aGt = "Event Type Color (Dark Theme)", sGt = "File is not named [idOrSlug]/[user]", cGt = "Create team", lGt = "Name", uGt = "Nameless Team", dGt = "OAuth Clients", _Gt = "Manage OAuth clients for your organization", pGt = "Create OAuth Client", mGt = "Create a new OAuth client for third-party integrations", fGt = "OAuth client deleted successfully", gGt = "Create a new team to collaborate with users.", hGt = "Create a new team", vGt = "URL of your booking page", bGt = "URL of the page where your users can cancel their booking", yGt = "URL of the page where your users can reschedule their booking", $Gt = "This slot is no longer available. Please return to the previous page and select another time.", wGt = "Open Invitations", kGt = "New Team", SGt = "Create your first team and invite other users to work together.", EGt = "Create a team to get started", xGt = "Teams", CGt = "Team", TGt = "Organization", AGt = "Team Billing", IGt = "Manage billing for your team", OGt = "We've changed billing for teams", NGt = "There are members in your team without a seat. Upgrade your pro plan to cover missing seats.", zGt = "As of January 2022 we charge on a per-seat basis for team members. Members of your team who had PRO for free are now on a 14 day trial. Once their trial expires these members will be hidden from your team unless you upgrade now.", RGt = "Create and manage teams to use collaborative features.", PGt = "This feature is only available in Pro plan", DGt = "In order to remove the {{appName}} branding from your booking pages, you need to upgrade to a Pro account.", LGt = "Edit your profile information, which shows on your scheduling link.", MGt = "You may need to log out and back in to see the change take effect.", FGt = "A little something about yourself.", qGt = "Profile updated successfully", jGt = "Your user profile has been updated successfully.", VGt = "Your upgrade is here", BGt = "Improve your scheduling experience by upgrading to the new plan and enjoy the new features.", UGt = "You are all set", GGt = "You are already on the latest plan. Nothing to upgrade. Enjoy the new features and reach out to us with any questions!", WGt = "User seems logged in but cannot be found in the db", HGt = "Embed & Webhooks", YGt = "Enabled", KGt = "Disabled", ZGt = "Disable", XGt = "Billing", JGt = "here", QGt = "Manage your billing information and cancel your subscription.", eWt = "Availability", tWt = "Edit availability", nWt = "Configure times when you are available for bookings.", oWt = "Copy times to", rWt = "Copy times to …", iWt = "Change your weekly schedule", aWt = "Logo", sWt = "Error", cWt = "Please enter at least one character", lWt = "Please enter at least {{count}} characters", uWt = "Team Logo", dWt = "Add a location", _Wt = "Attendees", pWt = "Add attendees", mWt = "Show advanced settings", fWt = "Hide advanced settings", gWt = "Event Name", hWt = "Calendar event name", vWt = "The name that will appear in calendars", bWt = "{Event type title} between {Organiser} & {Scheduler}", yWt = "Additional Inputs", $Wt = "Require scheduler to input additional inputs prior the booking is confirmed", wWt = "Label", kWt = "Placeholder", SWt = 'Use "Add to calendar" email as the organizer', EWt = "We'll display this email address as the organizer, and send confirmation emails here.", xWt = `If enabled, we'll display the email address from your "Add to calendar" as organizer and send confirmation emails there`, CWt = "Please note that you may need to disconnect and then reconnect your 'Add to Calendar' account to use this feature.", TWt = "Type", AWt = "Edit", IWt = "Add an Input", OWt = "Hide notes in calendar", NWt = "For privacy reasons, additional inputs and notes will be hidden in the calendar entry. They will still be sent to your email.", zWt = "The booking needs to be manually confirmed before it is pushed to your calendar and a confirmation is sent.", RWt = "Unconfirmed bookings still block calendar slots.", PWt = "Recurring Event", DWt = "People can subscribe for recurring events", LWt = "Connect and Join", MWt = "It cannot be used with paid event types", FWt = "Instant Meetings are not supported with recurring events and payment apps yet", qWt = "Experimental: Instant Meeting Events are currently experimental.", jWt = "Starting", VWt = "Disable Guests", BWt = "Disable adding additional guests while booking.", UWt = "Generate private link", GWt = "Enable Private URL", WWt = "Private link", HWt = "Your private link will regenerate after each use", YWt = "Copy private link", KWt = "Copy private link to event", ZWt = "Generate a private URL to share without exposing your {{appName}} username", XWt = "Private Links", JWt = "Generate private URLs without exposing the username, with configurable expiry and usage limits", QWt = "Add new link", e8t = "Private link copied", t8t = "Invitees can schedule", n8t = "Date Range", o8t = "calendar days", r8t = "business days", i8t = "Set an address or place", a8t = "Set a link to the meeting", s8t = "Can't be toggled. It can only be unlocked for child event types", c8t = "{{appName}} will ask your invitee to enter a phone number before scheduling.", l8t = "{{appName}} will provide a Google Meet location.", u8t = "{{appName}} will provide a Zoom meeting URL.", d8t = "{{appName}} will provide a Tandem meeting URL.", _8t = "{{appName}} will provide a video meeting URL.", p8t = "We will generate a Jitsi Meet URL for you.", m8t = "{{appName}} will provide a Huddle01 video meeting URL.", f8t = "{{appName}} will provide a MS Teams meeting URL. NOTE: MUST HAVE A WORK OR SCHOOL ACCOUNT", g8t = "Require Payment", h8t = "You need to add a name", v8t = "commission per transaction", b8t = "Your event type has been updated successfully.", y8t = "Hide event type", $8t = "Edit location", w8t = "into the future", k8t = "When booked with less than <0></0> notice", S8t = "Within a date range", E8t = "Indefinitely into the future", x8t = "Add new custom input field", C8t = "Quick Chat", T8t = "Add a new team event type", A8t = "Add a new event type", I8t = "Set up event types to offer different types of meetings.", O8t = "Length", N8t = "Minimum Notice", z8t = "Offset start times", R8t = "Offset timeslots shown to bookers by a specified number of minutes", P8t = "Offset by", D8t = "e.g. this will show time slots to your bookers at {{ adjustedTime }} instead of {{ originalTime }}", L8t = "Time-slot intervals", M8t = "Use event length (default)", F8t = "Delete event type?", q8t = "Delete managed event type?", j8t = "Anyone who you've shared this link with will no longer be able to book using it.", V8t = "Members assigned to this event type will also have their event types deleted.", B8t = "Anyone who they've shared their link with will no longer be able to book using it.", U8t = "Yes, delete", G8t = "Delete account", W8t = "Yes, delete account", H8t = "Anyone who you've shared your account link with will no longer be able to book using it and any preferences you have saved will be lost.", Y8t = "Integrations", K8t = "Apps", Z8t = "Here you can find a list of your apps", X8t = "App listing", J8t = "{{category}} apps", Q8t = "App Store", e7t = "Connecting people, technology and the workplace.", t7t = "Connect your video conferencing app", n7t = "Settings", o7t = "Event type has been moved successfully", r7t = "Next Step", i7t = "Skip step", a7t = "Prev step", s7t = "Install", c7t = "Start free Trial", l7t = "Installed", u7t = "{{count}} active install", d7t = "{{count}} active installs", _7t = "Globally installed", p7t = "App successfully installed", m7t = "App could not be installed", f7t = "Disconnect", g7t = "Embed your calendar within your webpage", h7t = "Connect your favourite apps.", v7t = "Automation", b7t = "Configure how your event types should interact with your calendars.", y7t = "Toggle the calendars you want to check for conflicts to prevent double bookings.", $7t = "Connect additional calendar", w7t = "Calendar updated successfully", k7t = "Check here", S7t = "Conferencing", E7t = "Calendar", x7t = "Payments", C7t = "Not installed", T7t = "Passwords don't match.", A7t = "This field is required.", I7t = "Status", O7t = "View user availability", N7t = "User needs to accept invite to view availability", z7t = "Set yourself as away", R7t = "Disable away status", P7t = "Error updating away status", D7t = "This user is currently away.", L7t = "The person you are trying to book has set themselves to away, and therefore is not accepting new bookings.", M7t = "Meet people with the same tokens", F7t = "Only book and allow bookings from people who share the same tokens, DAOs, or NFTs.", q7t = "Your account was created using an Identity Provider.", j7t = "Your account is managed by {{provider}}", V7t = "To change your email, password, enable two-factor authentication and more, please visit your {{provider}} account settings.", B7t = "Your account is managed by different identity provider. Try logging in with {{provider}}.", U7t = "Error creating a new user. Please try again.", G7t = "Sign in with Google", W7t = "Sign in with SAML", H7t = "Sign in with SAML/OIDC", Y7t = "Continue with email", K7t = "Continue with Google", Z7t = "Last used", X7t = "You will need to generate an access token from your old scheduling tool.", J7t = "Import from", Q7t = "Access token", eHt = "Roadmap", tHt = "Featured Categories", nHt = "Feature Flags", oHt = "Here you can toggle your Cal.com instance features.", rHt = "Feature assigned successfully", iHt = "Feature unassigned successfully", aHt = "Popular Categories", sHt = "{{count}} App", cHt = "{{count}} Apps", lHt = "Trending Apps", uHt = "Most Popular", dHt = "Installed Apps", _Ht = "Free", pHt = "No {{category}} apps", mHt = "All apps", fHt = "Add a calendar app to check for conflicts to prevent double bookings", gHt = "Try adding a conference app for video calls with your clients", hHt = "Add a payment app to ease transaction between you and your clients", vHt = "Add an analytics app for your booking pages", bHt = "Add an automation app to use", yHt = "Add any other type of app to do all sorts of things", $Ht = "Add a messaging app to set up custom notifications & reminders", wHt = "Add a CRM app to keep track of who you've met with", kHt = "Set the calendars to check for conflicts to prevent double bookings.", SHt = "Configure which payment processing services to use when charging your clients.", EHt = "Configure which analytics apps to use for your booking pages", xHt = "All your installed apps from other categories.", CHt = "Configure which conferencing apps to use", THt = "Configure which automation apps to use", AHt = "Configure which messaging apps to use for setting up custom notifications & reminders", IHt = "Configure which CRM apps to use for keeping track of who you've met with", OHt = "Analytics", NHt = "No apps installed", zHt = "Apps enable you to enhance your workflow and improve your scheduling life significantly.", RHt = "Browse App Store", PHt = "Manage your installed apps or change settings", DHt = "Browse Apps", LHt = "Features", MHt = "Permissions", FHt = "Terms and Privacy", qHt = "Published by {{author}}", jHt = "Subscribe", VHt = "Buy", BHt = "Install App", UHt = "Categories", GHt = "Pricing", WHt = "Learn more", HHt = "Try now", YHt = "Privacy Policy", KHt = "Terms of Service", ZHt = "Remove", XHt = "Add", JHt = "{{count}} installed", QHt = "Verify Wallet", eYt = "Create events on", tYt = "This is a commercial feature", nYt = "You can test this feature locally but not on production.", oYt = "To purchase a commercial license, please reach out to our sales team. If a license key is already in place, please contact support@cal.com for help.", rYt = "Missing License", iYt = "Next Steps", aYt = "Acquire a commercial license", sYt = "The infrastructure plan is usage-based and has startup-friendly discounts.", cYt = "Create an account via Prisma Studio", lYt = "Learn how to set up your first user", uYt = "Contact Sales", dYt = "Error 404", _Yt = "Set as Default", pYt = "New schedule", mYt = "Add a new schedule", fYt = "Add a new calendar", gYt = "Set where to add new events to when you're booked.", hYt = "Delete schedule", vYt = "Deleting a schedule will remove it from all event types. This action cannot be undone.", bYt = "{{scheduleName}} schedule created successfully", yYt = "{{scheduleName}} schedule updated successfully", $Yt = "Schedule deleted successfully", wYt = "Working Hours", kYt = "Create an availability schedule", SYt = "Creating availability schedules allows you to manage availability across event types. They can be applied to one or more event types.", EYt = "Requires ownership of a token belonging to the following address:", xYt = "John Doe", CYt = "Time format", TYt = "Redirect on booking ", AYt = 'You are being redirected to {{ url }} in $t(second, {"count": {{seconds}} }).', IYt = "https://example.com/redirect-to-my-success-page", OYt = "Redirect to a custom URL after a successful booking", NYt = "Duplicate", zYt = "Offer seats", RYt = "Offer seats for booking. This automatically disables guest & opt-in bookings.", PYt = "Seat available", DYt = "Seats available", LYt = "Seats almost full", MYt = "Seats filling fast", FYt = "Number of seats per booking", qYt = "Set meeting join window (seconds): The time frame in seconds within which host can join and start the meeting. After this period, the meeting join url will expire.", jYt = "Enter number of seats", VYt = "You can manage your schedules on the Availability page.", BYt = "No more seats available", UYt = "API keys", GYt = "API key", WYt = "Test API key", HYt = "Test passed!", YYt = "Test failed", KYt = "Provide API key", ZYt = "API keys allow you to make API calls for your own account.", XYt = "Create a marketplace or platform instead.", JYt = "Generate API keys to use for accessing your own account.", QYt = "Create an API key", eKt = "Name this key", tKt = "E.g. Development", nKt = "Nameless API key", oKt = "This API key has no expiration date", rKt = "Edit API key", iKt = "API key created successfully", aKt = "API key updated successfully", sKt = "Create", cKt = "Save this API key somewhere safe.", lKt = "You will not be able to view it again once you close this modal.", uKt = "Copy to clipboard", dKt = "Enabled after update", _Kt = "The private link will work after saving", pKt = "Revoke this API key", mKt = "Disable Rescheduling", fKt = "Guests can no longer reschedule the event with calendar invite or email", gKt = "Allow booking through reschedule link", hKt = "When enabled, users will be able to create a new booking when trying to reschedule a cancelled booking", vKt = "Disable Cancelling", bKt = "Guests can no longer cancel the event with calendar invite or email", yKt = "Revoke API key", $Kt = "API key copied!", wKt = "The API key will expire on", kKt = "Permanently remove this API key from your account?", SKt = "Copy", EKt = "Expiration date", xKt = "Expired", CKt = "Never expires", TKt = "Expires", AKt = "Request to reschedule your booking", IKt = "Reason for reschedule", OKt = "Book a new time", NKt = "Reschedule request sent", zKt = "This will cancel the scheduled meeting, notify the scheduler and ask them to pick a new time.", RKt = "Reason for reschedule request", PKt = "Request reschedule ", DKt = "Edit booking", LKt = "Reschedule booking", MKt = "Former time", FKt = "Add a GIF to your confirmation page", qKt = "Search", jKt = "Impersonate", VKt = "User Impersonation", BKt = "Allows our support team to temporarily sign in as you to help us quickly resolve any issues you report to us.", UKt = "Allows your team Owners/Admins to temporarily sign in as you.", GKt = "Free for individuals. Team plans for collaborative features.", WKt = "Make organization private", HKt = "Your organization members won't be able to see other organization members when this is turned on.", YKt = "Make team private", KKt = "Your team members won't be able to see other team members when this is turned on.", ZKt = "You cannot see all the team members of a private team.", XKt = "You cannot see teams of a private organization.", JKt = "Allow multiple durations", QKt = "All uses of this feature is audited.", eZt = 'Impersonating username "{{user}}".', tZt = "Click here to stop", nZt = "Updated - Your event changed the location", oZt = "Added - New guests added to your event", rZt = "Location Changed: {{eventType}} with {{name}} at {{date}}", iZt = "Guests Added: {{eventType}} with {{name}} at {{date}}", aZt = "Current Location", sZt = "New Location", cZt = "Session", lZt = "Control your account session", uZt = "Timeout session after", dZt = "Session timeout", _Zt = "Invalidate your session after a certain amount of time.", pZt = "No location defined", mZt = "Set Location", fZt = "Update Location", gZt = "Location updated", hZt = "Location update failed", vZt = "Guests added", bZt = "Unable to add guests", yZt = "That doesn't look like an email address", $Zt = "Emails must be unique and valid", wZt = "That doesn't look like a URL", kZt = "Place this code in your HTML where you want your {{appName}} widget to appear.", SZt = "Create or update an existing React component as shown below.", EZt = "Copy Code", xZt = "Code copied!", CZt = "How do you want to add {{appName}} to your site?", TZt = "Choose one of the following ways to put {{appName}} on your site.", AZt = "Setting up your Zapier integration", IZt = "Setting up your Make integration", OZt = "Generate API key", NZt = "Generate an API key to use with {{appName}} at", zZt = "Your unique API key", RZt = "Copy this API key and save it somewhere safe. If you lose this key you have to generate a new one.", PZt = "<0>Log into your Zapier account and create a new Zap.</0><1>Select Cal.com as your Trigger app. Also choose a Trigger event.</1><2>Choose your account and then enter your Unique API Key.</2><3>Test your Trigger.</3><4>You're set!</4>", DZt = "Go to <0>Make Invite Link</0> and install the Cal.com app.", LZt = "Log into your Make account and create a new Scenario.", MZt = "Select Cal.com as your Trigger app. Also choose a Trigger event.", FZt = "Choose your account and then enter your Unique API Key.", qZt = "Test your Trigger.", jZt = "You're set!", VZt = "Please first install the Zapier App in the app store.", BZt = "Please first install the Make App in the app store.", UZt = "App Installation", GZt = "App not installed", WZt = "Sorry, this app isn't installed on your account. Please visit our app store to explore and discover this and other great apps.", HZt = "Connect to Apple Server", YZt = "Calendar URL", KZt = "Generate an app specific password to use with {{appName}} at", ZZt = "Unable to add this Apple Calendar account. Please ensure you're using an app-specific password rather than your account password.", XZt = "Your credentials will be stored and encrypted.", JZt = "It will be stored and encrypted.", QZt = "Go to App Store", eXt = "Try reconnecting your calendar with all necessary permissions", tXt = "Set a phone number for the meeting", nXt = "There are no busy slots", oXt = "Display on booking page", rXt = "Location will be visible before the booking is confirmed", iXt = "Add GIF", aXt = "Search Giphy", sXt = "Add link from Giphy", cXt = "Adding a GIF to confirmation page", lXt = "Find GIF to spice up your confirmation page", uXt = "Share feedback", dXt = "Resources", _Xt = "Support Documentation", pXt = "Developer Documentation", mXt = "Get in touch", fXt = "Contact Support", gXt = "Premium Support", hXt = "Community Support", vXt = "Feedback", bXt = "Thank you for your feedback!", yXt = "Error sending feedback", $Xt = "Share your comments here:", wXt = "Booking details", kXt = "or", SXt = "Nevermind", EXt = "Go to: ", xXt = "Zapier Invite Link", CXt = "A Meeting URL will be created once the event is confirmed.", TXt = "Dynamically display the name of your attendee for you, or your name if it's viewed by your attendee", AXt = "Event's location", IXt = "Reason for rescheduling (optional)", OXt = "Let others know why you need to reschedule", NXt = "This event is canceled", zXt = "We sent an email to everyone to let them know.", RXt = "This input will be shown when booking this event", PXt = "Meeting url is in the confirmation email", DXt = "URL needs to start with http:// or https://", LXt = "Phone number will be provided", MXt = "before event starts", FXt = "when event is canceled", qXt = "After hosts didn't join cal video", jXt = "After guests didn't join cal video", VXt = "Join the video call", BXt = "Sign in to Cal.com", UXt = "Log in to Cal.com", GXt = "Track your meetings, get notifications, and manage your schedule more effectively.", WXt = "Track your meetings and manage your schedule more effectively", HXt = "Failed to join the call. Please try again.", YXt = "Choose how you'd like to join this call", KXt = "Choose how you'd like to appear on the call", ZXt = "when new event is booked", XXt = "send email to host", JXt = "send email to attendees", QXt = "Send email to submitted email address", eJt = "Send SMS to attendee", tJt = "send SMS to a specific number", nJt = "Easily send meeting reminders via SMS to your attendees", oJt = "send WhatsApp message to a specific number", rJt = "send WhatsApp message to attendee", iJt = "Workflows", aJt = "New Workflow", sJt = "How would you like to start?", cJt = "Add a new workflow", lJt = "when event is rescheduled", uJt = "Trigger", dJt = "Triggers", _Jt = "Action", pJt = "Create workflows to automate notifications and reminders", mJt = "Workflow name", fJt = "Custom workflow", gJt = "{{workflowName}} created successfully", hJt = "Are you sure you want to delete this workflow?", vJt = "Delete Workflow", bJt = "Yes, delete workflow", yJt = "Workflow deleted successfully", $Jt = "How long before event starts?", wJt = "days", kJt = "hours", SJt = "mins", EJt = "m", xJt = "h", CJt = "Create your first workflow", TJt = "Workflows enable you to automate sending reminders and notifications.", AJt = "Active on", IJt = "{{workflowName}} workflow updated successfully", OJt = "This is a standard username and updating will take you to billing to downgrade.", NJt = "This is a premium username, get yours for {{price}}", zJt = "Current", RJt = "premium", PJt = "standard", DJt = "Confirm username change", LJt = "As you are changing from a standard to a premium username, you will be taken to the checkout to upgrade.", MJt = "As you are changing from a premium to a standard username, you will be taken to the checkout to downgrade.", FJt = "Go to billing", qJt = "Require payment for bookings (0.5% + €0.10 commission per transaction)", jJt = "Your trial has expired", VJt = "Remove App", BJt = "Yes, remove app", UJt = "Are you sure you want to remove this app?", GJt = "App removed successfully", WJt = "Error removing app", HJt = "Web conference", YJt = "Web call", KJt = "Start web call", ZJt = "End call", XJt = "Test your agent with a web call without requiring a phone number", JJt = "Phone call", QJt = "Connecting to agent...", eQt = "Call active", tQt = "Call ended", nQt = "Call error", oQt = "Ready to start call", rQt = "Failed to start web call. Please try again.", iQt = "Call encountered an error. Please try again.", aQt = "Failed to initialize web call. Please ensure microphone permissions are granted.", sQt = "Start a call to see the conversation", cQt = "Waiting for conversation...", lQt = "AI Agent", uQt = "Live", dQt = "Connecting...", _Qt = "Requires confirmation", pQt = "Requires confirmation if booked with < {{time}} $t({{unit}}_timeUnit) notice", mQt = "May require confirmation", fQt = "{{count}} event type", gQt = "{{count}} event types", hQt = "{{count}} routing form", vQt = "{{count}} routing forms", bQt = "{{count}} team", yQt = "{{count}} teams", $Qt = "Add action", wQt = "Set Whereby link", kQt = "Please enter a valid Whereby Link", SQt = "Set Around.Co link", EQt = "Please enter a valid Around Link", xQt = "Set Riverside link", CQt = "Please enter a valid Riverside Link", TQt = "Please enter a valid Ping.gg Link", AQt = "Connect Exchange 2013 Server", IQt = "Connect Exchange 2016 Server", OQt = "Custom template", NQt = "Email body", zQt = "Text message", RQt = "Have a specific issue?", PQt = "browse our docs", DQt = "Choose a template", LQt = "Custom", MQt = "Reminder", FQt = "Rescheduled", qQt = "Rescheduled by", jQt = "Original booking", VQt = "Completed", BQt = "Rating", UQt = "Reminder: {{eventType}} with {{name}} at {{date}}", GQt = "Won't trigger for already existing bookings as user will be asked for phone number when booking the event.", WQt = "{{count}} minute", HQt = "{{count}}m", YQt = "{{count}} minutes", KQt = "{{count}} hour", ZQt = "{{count}}h", XQt = "{{count}} hours", JQt = "Invalid input", QQt = "We could not add the {{location}} meeting link to your scheduled event. Contact your invitees or update your calendar event to add the details. You can either <0> change your location on the event type </0> or try <1>removing and adding the app again.</1>", een = "We could not update your <1>{{calendar}}</1>. <2> Please check your calendar settings or remove and add your calendar again </2>", ten = "Attendee's name", nen = "The full name of the person booking", oen = "Broken integration", ren = "There was a problem adding a video link", ien = "There was a problem updating your calendar", aen = "Active on {{count}} event type", sen = "Active on {{count}} event types", cen = "Active on {{count}} team", len = "Active on {{count}} teams", uen = "Active on all event types", den = "Active on all teams", _en = "No active event types", pen = "No active teams", men = "New Attendee {{name}} on {{eventType}} at {{date}}", fen = "Someone has added themselves to an event", gen = "Variable", hen = "Event name", ven = "Attendee", ben = "Event date", yen = "Event time", $en = "Organizer name", wen = "In order to use this feature, you need to upgrade to a Pro account.", ken = "Invalid phone number", Sen = "Invalid URL for {{label}}. Sample URL: {{sampleUrl}}", Een = "Navigate", xen = "Open", Cen = "Close", Ten = "Upgrade", Aen = "Buy US number for {{priceInDollars}}$/month", Ien = "Upgrade to access recordings", Oen = "Recordings are only available as part of our teams plan. Upgrade to start recording your calls", Nen = "Upgrade to Enterprise to generate an AI Agent phone number that can call guests to schedule calls", zen = "Recordings are part of the teams plan", Ren = "This is a Team feature. Upgrade to Team to see your team's availability.", Pen = "This is a Team feature. Upgrade to Team to automate your event notifications and reminders with Workflows.", Den = "Show on Profile", Len = "Embed", Men = "New username", Fen = "Current username", qen = "Example 1", jen = "Example 2", Ven = "Booking Question Identifier", Ben = "Company size", Uen = "What do you need help with?", Gen = "Variable format", Wen = "Webhook subscriber url is already defined", Hen = "Ignore all special characters of the additional input label (use only letters and numbers), use uppercase for all letters and replace whitespaces with underscores.", Yen = "How do I use booking questions as variables?", Ken = "Download desktop app", Zen = "Set Ping link", Xen = "Rate limit exceeded", Jen = "When something happens", Qen = "An action is performed", etn = "Test action", ttn = "Notification sent", ntn = "No input", otn = "Test workflow action", rtn = "Send SMS", itn = "Are you sure you want to send a SMS to {{number}}?", atn = "No default calendar connected", stn = "You can connect your calendar from <1>here</1>.", ctn = "Default calendar", ltn = "Hide from profile", utn = "Basics", dtn = "No availability found in schedule", _tn = "Limits", ptn = "How often you can be booked", mtn = "Calendar settings & more...", ftn = "Advanced", gtn = "Set up payments for event", htn = "Event Setup: Multiple durations requires at least 1 option.", vtn = "Event Setup: Please select a valid default duration.", btn = "Booking limits must be in ascending order. [day, week, month, year]", ytn = "Duration limits must be in ascending order. [day, week, month, year]", $tn = "The calendar to add bookings to", wtn = "Custom event name", ktn = "Create customised event names to display on calendar event", Stn = "Incorrect two factor authentication code", Etn = "Which event type will this apply to?", xtn = "Which routing form will this apply to?", Ctn = "Apply to all, including future event types", Ttn = "Apply to all, including future routing forms", Atn = "Apply to all team and user event types", Itn = "Which team will this apply to?", Otn = "Workflows enable simple automation to send notifications & reminders enabling you to build processes around your events.", Ntn = "This is an internal setting and will not affect how times are displayed on public booking pages for you or anyone booking you.", ztn = "Create a workflow", Rtn = "Do this", Ptn = "Turn off", Dtn = "Turn on", Ltn = "Canceled bookings cannot be rescheduled", Mtn = "Settings updated successfully", Ftn = "Error updating settings", qtn = "My personal {{appName}} URL", jtn = "A few sentences about yourself. this will appear on your scheduling link.", Vtn = "Finish setup and get started", Btn = "This user has not added a bio yet.", Utn = "Bio", Gtn = "Delete Account", Wtn = "Are you sure you want to delete your {{appName}} account?", Htn = "Delete my account", Ytn = "Start of week", Ktn = "Recordings", Ztn = "Recording", Xtn = "Happy scheduling", Jtn = "Select which calendars you want to check for conflicts to prevent double bookings.", Qtn = "Check for conflicts", enn = "View recordings", tnn = "Check for recordings", nnn = "Adding events to", onn = "Follow system preferences", rnn = "Custom brand colors", inn = "Customize your own brand colour into your booking page.", ann = "Pro", snn = "Removes any {{appName}} related brandings, i.e. 'Powered by {{appName}}.'", cnn = "Instant Meeting with {{name}}", lnn = "Profile Picture", unn = "Upload", dnn = "Add profile photo", _nn = "Token Address", pnn = "Blockchain", mnn = "Old password", fnn = "Your new super secure password", gnn = "Error updating password", hnn = "Two factor authentication", vnn = "Set up a repeating schedule", bnn = "today", ynn = "Appearance", $nn = "My account", wnn = "General", knn = "Calendars", Snn = "Invoices", Enn = "Embeds", xnn = "Impersonation", Cnn = "Settings to manage user impersonation", Tnn = "Recent Impersonations", Ann = "Quick Impersonate", Inn = "No recent impersonations", Onn = "Users", Nnn = "User", znn = "Manage settings for your {{appName}} profile", Rnn = "Here you can find a list of all users", Pnn = "User listing", Dnn = "Manage settings for your language and timezone", Lnn = "Configure how your event types interact with your calendars", Mnn = "Manage settings for your booking appearance", Fnn = "Add your favourite video conferencing apps for your meetings", qnn = "Add Conferencing App", jnn = "Manage settings for your account passwords", Vnn = "Set up your Two-factor authentication", Bnn = "We just need some basic info to get your profile setup.", Unn = "Skip", Gnn = "Do this later", Wnn = "Define ranges of time when you are available.", Hnn = "Customize it later in the availability page.", Ynn = "Connect a calendar first", Knn = "Complete your profile", Znn = "You can add more calendars from the app store", Xnn = "Connect conference apps", Jnn = "Connect calendar apps", Qnn = "Connect payment apps", eon = "Connect automation apps", ton = "Connect analytics apps", non = "Connect other apps", oon = "Connect messaging apps", ron = "Connect CRM apps", ion = "Step {{currentStep}} of {{maxSteps}}", aon = "Add variable", son = "Custom phone number", con = "Message template", lon = "Email subject", uon = "Add dynamic text variables", don = "The event type name", _on = "The event date", pon = "The event duration", mon = "The event start time", fon = "EventType not Found", gon = "Number to call", hon = "The phone number of the user you are calling", von = "Location", bon = "The location of the event", yon = "Additional notes", $on = "The additional notes of booking", won = "The person booking's name", kon = "Organizer's name", Son = "To", Eon = "{{workflowName}} workflow turned {{offOn}} successfully", xon = "Download responses", Con = "Download all responses to your form in CSV format.", Ton = "View Responses", Aon = "Download", Ion = "Downloading", Oon = "Download Recording", Non = "Transcriptions are enabled now", zon = "Transcriptions are stopped now", Ron = "Download Transcript", Pon = "Transcript", Don = "A recording from your recent call on {{appName}} is ready for download", Lon = "Transcript from your recent call on {{appName}} is ready to download. Links are valid only for 1 Hour", Mon = "You can also download transcript from attachments", Fon = "Note: The download link is valid only for 12 hours. You can generate new download link by following instructions <1>here</1>.", qon = "Note: The download link is only valid for 12 hours. You can generate new download link by following the instructions", jon = "Create your first form", Von = "With Routing Forms you can ask qualifying questions and route to the correct person or event type.", Bon = "Create your first Webhook", Uon = "With Webhooks you can receive meeting data in real-time when something happens in {{appName}}.", Gon = "For a maximum of", Won = "event", Hon = "events", Yon = "Manage settings for your team profile", Kon = "Manage settings for your organization profile", Zon = "Users that are in the group", Xon = "Manage the admins and members in your organization", Jon = "Team URL", Qon = "Team members", ern = "More", trn = "Cal.ai Workflows", nrn = "and {{count}} more", orn = "We view the mobile application as an extension of the web application. If you are performing any complicated actions, please refer back to the web application.", rrn = "Send SMS reminder 24 hours before event starts to attendee", irn = "Send custom SMS when event is rescheduled to attendee", arn = "Send custom email when new event is booked to host", srn = "Send email reminder 1 hour before events starts to attendee", crn = "Send custom email when event is rescheduled to host", lrn = "Send custom SMS when new event is booked to host", urn = "Send SMS reminder", drn = "24 hours before event starts", _rn = "Follow up with no shows", prn = "30m after event ends", mrn = "Remind attendees to bring ID", frn = "1 day before event starts", grn = "Email Reminder", hrn = "1 hour before event starts", vrn = "Custom SMS Reminder", brn = "When event is scheduled", yrn = "Custom Email Reminder", $rn = "Event is rescheduled to host", wrn = "Include booking counts from managed event types", krn = "Welcome to {{appName}}!", Srn = "You'll be able to edit this later.", Ern = "I'll connect my calendar later", xrn = "There was a problem saving your data. Please try again or reach out to customer support.", Crn = "Purchase missing seats", Trn = "Slot length", Arn = "Booking Appearance", Irn = "Manage settings for your team's booking appearance", Orn = "Manage settings for your organization's booking appearance", Nrn = "Only the owner of this team can make changes to the team's booking ", zrn = "Removes any {{appName}} related brandings, i.e. 'Powered by {{appName}}'", Rrn = "{{teamName}} has invited you to join their team as a {{role}}", Prn = "Token is either invalid or expired.", Drn = "View Booking", Lrn = "Connect to Microsoft Exchange", Mrn = "Authentication method", Frn = "Basic authentication", qrn = "NTLM authentication", jrn = "GZip compression", Vrn = "Exchange Version", Brn = "2007 SP1", Urn = "2010", Grn = "2010 SP1", Wrn = "2010 SP2", Hrn = "2013", Yrn = "2013 SP1", Krn = "2015", Zrn = "2016", Xrn = "Routing", Jrn = "Create forms to direct attendees to the correct destinations", Qrn = "Send Email to Owner", ein = "Sends an email to the owner when the form is submitted", tin = "Send Email to", nin = "Add new form", oin = "Add new form to your team", rin = "Create your first route", iin = "Route to the right person based on the answers to your form", ain = "Form", sin = "Create your form to route a booker", cin = "Copy link to form", lin = "Booking page theme", uin = "This only applies to your public booking pages", din = "Dashboard theme", _in = "This only applies to your logged in dashboard", pin = "System default", min = "Add a team", fin = "Receive meeting data in real-time when something happens in {{appName}}", gin = "Triggers when", hin = "Please ping test before creating.", vin = "Enable Webhook", bin = "Add Webhook", yin = "Webhook saved", $in = "Generate API keys for accessing your own account", win = "New API key", kin = "active", Sin = "API key name updated", Ein = "Error updating API key name", xin = "HTML iframe embed", Cin = "Embed all your event types on your website", Tin = "Create your first API key", Ain = "API keys allow other apps to communicate with {{appName}}", Iin = "Back to sign in", Oin = "Reset link sent", Nin = "An email is on it's way to {{email}} with instructions to reset your password.", zin = "If you don't receive an email soon, check that the email address you entered is correct, check your spam folder or reach out to support if the issue persists.", Rin = "Password updated!", Pin = "Pending payment", Din = "Pending Invites", Lin = "Pending Organization Invites", Min = "Not on {{appName}}", Fin = "No calendar installed", qin = "You have not yet connected any of your calendars", jin = "Add a calendar", Vin = "You may need to log out and back in to see any change take effect.", Bin = "Please confirm your password before changing your email address", Uin = "seats", Gin = "Every app published on the {{appName}} App Store is open source and thoroughly tested via peer reviews. Nevertheless, {{companyName}} does not endorse or certify these apps unless they are published by {{appName}}. If you encounter inappropriate content or behaviour please report it.", Win = "Report app", Hin = "Limit booking frequency", Yin = "Limit how many times this event can be booked", Kin = "Only show the first slot of each day as available", Zin = "This will limit your availability for this event type to one slot per day, scheduled at the earliest available time.", Xin = "Limit total booking duration", Jin = "Limit total amount of time that this event can be booked", Qin = "Booker active booking limit", ean = "Limit the number of active bookings a booker can make for this event type", tan = "Recurring events don't support booker booking limit", nan = "Add Limit", oan = "Team name required", ran = "Share attendee information between guests", ian = "Show the number of available seats", aan = "How to use booking questions as variables?", san = "Format", can = "Questions", lan = "All the info your booker should provide before booking with you.", uan = "Use uppercase for all letters", dan = "Replace whitespaces with underscores", _an = "Platform members", pan = "Manage the admins and members in your platform team", man = "Platform billing", fan = "Manage billing", gan = "Manage all things billing", han = "You're currently on the FREE plan", van = "We work better in teams. Extend your workflows with round-robin and collective events and make advanced routing forms", ban = "Try now", yan = "Billing portal", $an = "Contact support", wan = "Ignore special characters in your booking question identifier. Use only letters and numbers", kan = "Retry", San = "There was a problem fetching your calendars. Please <1>try again</1> or reach out to customer support.", Ean = "Calendar connection failed", xan = "Booking confirmation succeeded", Can = "Booking rejection succeeded", Tan = "This booking is tentative", Aan = "Oops, I want to accept", Ian = "We won't show this again", Oan = "We couldn't update the timezone", Nan = "Updated timezone to {{formattedCurrentTz}}", zan = "Update timezone", Ran = "Update Timezone?", Pan = "It seems like your local timezone has changed to {{formattedCurrentTz}}.  It's very important to have the correct timezone to prevent bookings at undesired times. Do you want to update it?", Dan = "Don't update", Lan = "Require additional notes", Man = "Require additional notes to be filled out when booking", Fan = "send email to a specific email address", qan = "after event ends", jan = "when booking is rejected", Van = "when booking is requested", Ban = "when booking payment is initiated", Uan = "when booking payment is successful", Gan = "when booking no-show is updated", Wan = "How long after event ends?", Han = "How long after hosts don't show up on cal video meeting?", Yan = "How long after guests don't show up on cal video meeting?", Kan = "How long after the users don't show up on cal video meeting?", Zan = "No Available slots", Xan = "Time available", Jan = "Can't find the right conferencing app? Visit our <0>App Store</0>.", Qan = "Install new calendar app", esn = "Make phone number required for booking event", tsn = "{{eventTypeTitle}} Availability", nsn = "Error editing availability", osn = "You don't have permission to access this resource.", rsn = "Please paste the SAML metadata from your Identity Provider here", isn = "Please enter an email so we can find your SAML Identity Provider", asn = "Service Provider Details", ssn = "Your Identity Provider (IdP) will ask you for the following details to complete the SAML application configuration.", csn = "ACS URL", lsn = "SP Entity ID", usn = "ACS URL copied!", dsn = "SP Entity ID copied!", _sn = "Add Calendar", psn = "Limit future bookings", msn = "Limit how far in the future this event can be booked", fsn = "No event types setup", gsn = "{{name}} has not setup any event types for you to book.", hsn = "Billing Frequency", vsn = "Monthly", bsn = "Yearly", ysn = "Checkout", $sn = "Your team has been disbanded successfully", wsn = "Your organization has been disbanded successfully", ksn = "Error creating team", Ssn = "You", Esn = "Or continue with", xsn = "Resend email", Csn = "Member has already been invited", Tsn = "Username already in use", Asn = "Enter an email or username", Isn = "Enter an email", Osn = "Enter emails", Nsn = "You are limited to inviting a maximum of {{nbUsers}} users at once.", zsn = "This name is already taken", Rsn = "Must enter a team name", Psn = "Must enter a team URL", Dsn = "This URL is already taken", Lsn = "There was a problem with registering the subdomain, please try again or contact an administrator", Msn = "Publish team", Fsn = "Phone number (Text notifications)", qsn = "Phone number (SMS notifications)", jsn = "Attendee email", Vsn = "The person booking's email", Bsn = "Booking UID", Usn = "Type a command or search...", Gsn = "It looks like permissions expired or were revoked for {{appName}}.", Wsn = "Reinstall app", Hsn = "Reschedule reason", Ysn = "Choose a common schedule", Ksn = "Enable this if you want to use a common schedule between hosts. When disabled, each host will be booked based on their default schedule or their chosen schedule.", Zsn = "Reason", Xsn = "Sender ID", Jsn = "Only letters, numbers and spaces allowed (max. 11 characters)", Qsn = "Test Routing Form", ecn = "Test Preview", tcn = "Route to", ncn = "Test your routing form without submitting any data", ocn = "Test Routing", rcn = "An admin has disabled a payment app", icn = "Edit event type", acn = "This Organization is private, and only the organization's admin or owner can view its members.", scn = "Only the organization's admin or owner can manage SSO settings", ccn = "Only the organization's admin or owner can manage directory sync settings", lcn = "Only the organization's admin or owner can manage OAuth clients", ucn = "Collective Scheduling", dcn = "Make it easy to book your team when everyone is available.", _cn = "Find the best person available and cycle through your team.", pcn = "Fixed round robin", mcn = "Add one fixed attendee and round robin through a number of attendees.", fcn = "{{appName}} is better with teams", gcn = "The {{companyName}} team", hcn = "Add your team members to your event types. Use collective scheduling to include everyone or find the most suitable person with round robin scheduling.", vcn = "Booking Limit for this event type has been reached", bcn = "Duration Limit for this event type has been reached", ycn = "An admin has disabled {{appName}}", $cn = "This will disable all emails to {{recipient}}. This includes booking confirmations, requests, reschedules and reschedule requests, cancellation emails, and any other emails related to booking updates.<br /><br />It is your responsibility to ensure that your {{recipient}} are aware of any bookings and changes to their bookings.", wcn = "An admin has disabled {{appName}} which affects your event type {{eventType}}", kcn = "An admin has replaced one of your event types", Scn = "A team administrator has replaced your event /{{slug}}", Ecn = "An administrator on the <strong>{{teamName}}</strong> team has replaced your event type <strong>/{{slug}}</strong> with a managed event type that they control.", xcn = "Your link will continue to work but some settings for it may have changed. You can review it in event types.", Ccn = "If you have any questions about the event type, please reach out to your administrator.<br /><br />Happy scheduling, <br />The Cal.com team", Tcn = "The admin has disabled {{appName}} which affects your event type {{title}}. Attendees are still able to book this type of event but will not be prompted to pay. You may hide the event type to prevent this until your admin renables your payment method.", Acn = "Attendees are still able to book this type of event but will not be prompted to pay. You may hide the event type to prevent this until your admin reenables your payment method.", Icn = "The admin has disabled {{appName}} which affects your event type {{title}}.", Ocn = "The admin has disabled {{appName}} which may affect your event types. If you have event types with {{appName}} as the location then it will default to Cal Video.", Ncn = "{{appName}} has been disabled", zcn = "Go to installed apps", Rcn = "If you have another calendar installed new bookings will be added to it. If not then connect a new calendar so you do not miss any new bookings.", Pcn = "Enable Apps", Dcn = "Enable apps that users can integrate with {{appName}}", Lcn = "Purchase a License", Mcn = "Already have an account?", Fcn = "I already have a key:", qcn = "Please copy your existing CALCOM_LICENSE_KEY environment variable here.", jcn = "Create License Key", Vcn = "{{appName}} is enabled", Bcn = "{{appName}} is disabled", Ucn = "Keys have been saved", Gcn = "Disable App", Wcn = "Disabling this app could cause problems with how your users interact with Cal", Hcn = "Edit Keys", Ycn = "Enable apps for your instance of Cal", Kcn = "A list of all the users in your account including their name, title, email and role.", Zcn = "Here you can add a new user.", Xcn = "Here you can edit a current user.", Jcn = "Here you can edit an organization.", Qcn = "Add new OAuth Clients", eln = "Lock or unlock SMS sending for users", tln = "There are no available apps", nln = "Please ensure there are apps in your deployment under 'packages/app-store'", oln = "There are no apps enabled in this instance of Cal", rln = "No app has been configured yet", iln = "You can enable apps in the settings", aln = "Please contact your admin", sln = "Apps settings", cln = "Please fill in this field", lln = "Options", uln = "Enter Option {{index}}", dln = "Add an option", _ln = "This location already exists. Please select a new location", pln = "Radio", mln = "In order to use Google Meet, you must set your destination calendar to a Google Calendar", fln = "Individual", gln = "All Bookings", hln = "All Users", vln = "All Event Types", bln = "Your Bookings", yln = "Meeting url", $ln = "The event meeting conference url", wln = "Date overrides", kln = "Delete date overrides on {{date}}", Sln = "Add dates when your availability changes from your daily hours.", Eln = "Date overrides are archived automatically after the date has passed", xln = "Which hours are you free?", Cln = "Which hours are you busy?", Tln = "Select the dates to override", Aln = "Unavailable all day", Iln = "Mark unavailable (All day)", Oln = "Mark unavailable on selected dates", Nln = "Update Override", zln = "Date override added successfully", Rln = "Save Override", Pln = "{{slug}}-copy", Dln = "Set as default", Lln = "Hide event type details", Mln = "Show navigation", Fln = "Hide navigation", qln = "Verification code sent", jln = "Verified successfully", Vln = "Wrong verification code", Bln = "Not yet verified", Uln = "No availability in {{month}}", Gln = "Scheduling is only available up to {{days}} in advance. Please check again soon.", Wln = "Scheduling ended on {{date}}. Please check again soon.", Hln = "View previous month", Yln = "View next month", Kln = "Send code", Zln = "Number verified", Xln = "Create your first webhook for this team event type", Jln = "Create a webhook for this team event type", Qln = "Disable Success Page (only works if you have a redirect URL)", eun = "You are admin but you do not have a password length of at least 15 characters or no 2FA yet", tun = "Change your password to gain admin access", nun = "Username is already taken", oun = "Assignment", run = "Fixed Hosts", iun = "Add fixed hosts", aun = "Round-Robin Hosts", sun = "Number of hosts required to attend", cun = "Hosts", lun = "You need to create a team to enable this feature. Click here to create a team.", uun = "You need to upgrade to our enterprise plan to enable this feature.", dun = "New Attendee", _un = "Awaiting Approval", pun = "This app requires a Google Calendar connection", mun = 'The "Add to calendar" for this event type needs to be a Google Calendar for Meet to work. Connect it <0>here</0>.', fun = "You have connected a Google Calendar account.", gun = "Using Google Meet requires a connected Google Calendar", hun = "Continue to install Google Calendar", vun = "Install Google Meet", bun = "Install Google Calendar", yun = "Sender name", $un = "Attendee already invited", wun = "No recordings found", kun = "New workflow for...", Sun = "Reporting", Eun = "See all incoming form data and download it as a CSV", xun = "Teams plan required", Cun = "Routing forms are a great way to route your incoming leads to the right person. Upgrade to a Teams plan to access this feature.", Tun = "Choose a license", Aun = "Cal.com comes with an accessible and free AGPLv3 license which has limitations. We are onboarding Enterprise customers for the commercial license which you can inquire about by contacting sales below.", Iun = "License", Oun = "AGPLv3 License", Nun = "No need to keep your code open source", zun = "Repackage, rebrand and resell easily", Run = "A vast suite of enterprise features", Pun = "$0.00/month", Dun = "Forever Open & Free", Lun = "Required to keep your code open source", Mun = "Cannot repackage, rebrand and resell easily", Fun = "No enterprise features", qun = "Enterprise License", jun = "Everything for a commercial use case with private hosting, repackaging, rebranding and reselling and access exclusive enterprise components.", Vun = "Setup", Bun = "Setup Cal.com instance", Uun = "Configure", Gun = "Single sign-on", Wun = "Configure SAML/OIDC SSO and allow team members to login using an Identity Provider", Hun = "Configure SAML/OIDC SSO and allow organization members to login using an Identity Provider", Yun = "SSO with OIDC", Kun = "Configure OIDC SSO with Identity Provider of your choice.", Zun = "OIDC Configuration", Xun = "Configure OIDC connection to your identity provider. You can find the required information in your identity provider.", Jun = "Callback URL copied", Qun = "SSO with SAML", edn = "Configure SAML SSO with Identity Provider of your choice.", tdn = "SAML Configuration", ndn = "Configure SAML connection to your identity provider. You can find the required information in your identity provider.", odn = "ACS URL copied", rdn = "Entity ID copied", idn = "{{connectionType}} configuration created successfully", adn = "{{connectionType}} configuration deleted successfully", sdn = "Delete {{connectionType}} configuration", cdn = "Yes, delete {{connectionType}} configuration", ldn = "Are you sure you want to delete the {{connectionType}} configuration? Your team members who use {{connectionType}} login will no longer be able to access Cal.com.", udn = "Organizer timezone", ddn = "View Invitation", _dn = "Accept Invite", pdn = "Join Now", mdn = "Successfully joined", fdn = "You've been invited to join a team of {{parentTeamName}} organization", gdn = "You've been invited to join a {{appName}} organization", hdn = "{{invitedBy}} has invited you to join their team on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.", vdn = "{{invitedBy}} has invited you to join the team {{teamName}} in their organization {{parentTeamName}} on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.", bdn = "{{invitedBy}} has invited you to join their organization {{teamName}} on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your organization to schedule meetings without the email tennis.", ydn = "We'll walk you through a few short steps and you'll be enjoying stress free scheduling with your {{entity}} in no time.", $dn = "Choose your username", wdn = "Connect your calendar account", kdn = "Set your Availability", Sdn = "Join {{teamName}}", Edn = "Happy Scheduling from the {{appName}} team", xdn = "You are about to impersonate a user, which means you can make changes on their behalf. Please be careful.", Cdn = "Available variables", Tdn = "{Scheduler}", Adn = "No workflows", Idn = "Change filter to see your personal and team workflows.", Odn = "Change filter to see the results.", Ndn = "No results for the filter", zdn = "Recommended next steps", Rdn = "Create a managed event type", Pdn = "Meetings are better with the right team members there. Invite them now.", Ddn = "Create a one-one one template for an event type and distribute it to multiple members.", Ldn = "Collective or round-robin", Mdn = "Book your team members together with collective events or cycle through to get the right person with round-robin.", Fdn = "No longer attending {{title}} at {{date}}", qdn = "You are no longer attending this event", jdn = "An attendee is no longer attending {{title}} at {{date}}", Vdn = "An attendee is no longer attending your event", Bdn = "{{name}} has canceled. This means a seat has opened up for this time slot", Udn = "Create event on", Gdn = "Create routing form on", Wdn = "Set a default app link", Hdn = "Setting a default app link allows all newly created event types to use the app link you set.", Ydn = "Organizer's default app", Kdn = "{{organizer}} has no default conferencing app", Zdn = "Down for maintenance", Xdn = "The {{appName}} team are performing scheduled maintenance. If you have any questions, please contact support.", Jdn = "{{numberOfSeats}} seats", Qdn = "Booking questions", e_n = "Customize the questions asked on the booking page", t_n = "Add a question", n_n = "Identifier", o_n = "Email is duplicate", r_n = "Enter a redirect URL to which the attendee will be sent once they leave the meeting.", i_n = "Paying for this event is no longer possible", a_n = "A refund for this booking payment is on its way.", s_n = "This booking payment has been refunded.", c_n = "As per the event's refund policy, the booking payment is non-refundable.", l_n = "The event's refund window has expired. Hence, booking payment is non-refundable.", u_n = "Booking confirmation failed", d_n = "Not enough seats", __n = "A field with this name already exists", p_n = "Guests field must be of type 'Multiple emails'", m_n = "Show on booking page", f_n = "You can visit the canceled booking page", g_n = "Get started with Zapier templates", h_n = "Standard Templates", v_n = "Cal.ai Templates", b_n = "{{team}} is unpublished", y_n = "This organization link is currently not available. Please contact the organization owner or ask them to publish it.", $_n = "This team link is currently not available. Please contact the team owner or ask them to publish it.", w_n = "Team member", k_n = "A Routing Form", S_n = "Form Description", E_n = "Keep me connected with the form", x_n = "Any changes made to the router or fields of the form being duplicated will be reflected in the duplicate. However, deleting a field will not remove it from the duplicate.", C_n = "Form deleted", T_n = "Are you sure you want to delete this form?", A_n = "Yes, delete Form", I_n = "Anyone who you've shared the link with will no longer be able to access it.", O_n = "All associated responses will be deleted.", N_n = "Redirect URL copied! You can go and set the URL in your own form.", z_n = "Modifications in fields and routes of following forms will be reflected in this form.", R_n = "Connected Forms", P_n = "Following forms would be affected when you modify fields or routes here.", D_n = "Wait for some time for responses to be collected. You can go and submit the form yourself as well.", L_n = "This is what your users would see", M_n = "Identifies field by this name.", F_n = "Add 1 option per line", q_n = "Select a router", j_n = "Add a new Route", V_n = "Make informed decisions with Insights", B_n = "Our Insights dashboard surfaces all activity across your team and shows you trends that enable better team scheduling and decision making.", U_n = "View bookings across all members", G_n = "See who's receiving the most bookings and ensure the best distribution across your team", W_n = "Identify booking trends", H_n = "See what times of the week and what times during the day are popular for your bookers", Y_n = "Spot popular event types", K_n = "See which of your event types are receiving the most clicks and bookings", Z_n = "No responses yet", X_n = "No routes defined", J_n = "This will be the placeholder", Q_n = "An error occurred when booking the event, please refresh the page and try again", epn = "No timeslot selected", tpn = "Please select a timeslot to book the event.", npn = "Select timeslot", opn = "Switch to monthly view", rpn = "Switch to weekly view", ipn = "Switch to day view", apn = "Switch to column view", spn = "{{num}} location options", cpn = "Select on the next step", lpn = "This meeting has not started yet", upn = "{{appName}} requires a connected {{dependencyName}} account", dpn = "Connect {{dependencyName}}", _pn = "{{dependencyName}} is connected", ppn = "Requires {{dependencyName}}", mpn = "Verification code", fpn = "Can you try again with a different time?", gpn = "Verify", hpn = "The timezone of the person receiving", vpn = "Timezone", bpn = "Event end time", ypn = "The event end time", $pn = "Cancel URL", wpn = "The URL to cancel the booking", kpn = "Cancellation Reason", Spn = "The reason for canceling the booking", Epn = "Reschedule URL", xpn = "The URL to reschedule the booking", Cpn = "Reschedule Reason", Tpn = "The reason for rescheduling the booking", Apn = "{{item}} is an invalid variable in your event name", Ipn = "Select All", Opn = "Bulk update existing event types", Npn = "Member's default schedule", zpn = "Set by team admin", Rpn = "Member's default location", Ppn = "We will use each members default availability schedule. They will be able to edit or change it.", Dpn = "You are required to have at least one schedule", Lpn = "Update the locations for the selected event types", Mpn = "Update the schedules for the selected event types", Fpn = "Locked for members", qpn = "Unlocked for members", jpn = "Members will be able to see the active apps but will not be able to edit any app settings", Vpn = "Members will be able to see the active apps and will be able to edit any app settings", Bpn = "You will be able to see the active apps but will not be able to edit any app settings", Upn = "You will be able to see the active apps and will be able to edit any app settings", Gpn = "Members can not add their personal workflows to this event type.  Members will be able to see the active team workflows but will not be able to edit any workflow settings.", Wpn = "Members will be able to add their personal workflows to this event type.  Members will be able to see the active team workflows but will not be able to edit any workflow settings.", Hpn = "You will be able to see the active team workflows but will not be able to edit any workflow settings or add your personal workflows to this event type.", Ypn = "You will be able to enable/disable personal workflows on this event type. You will be able to see the active team workflows but will not be able to edit any team workflow settings.", Kpn = "Members can not add their personal webhooks to this event type. Members will be able to see the active webhooks but will not be able to edit any webhook settings.", Zpn = "Members will be able to add their personal webhooks to this event type. Members will be able to see the active webhooks but will not be able to edit any webhook settings.", Xpn = "You are able to see the active managed webhooks but will not be able to edit any webhook settings or add your personal webhooks to this event type.", Jpn = "You can add webhooks to this event type. You are able to see the active managed webhooks but will not be able to edit them.", Qpn = "Locked by team admin", emn = "You have not connected a {{appName}} account.", tmn = "Connect now", nmn = "Replace & notify {{count}} member", omn = "Replace & notify {{count}} members", rmn = "The url /{{slug}} already exists for {{count}} member. Do you want to replace it?", imn = "The url /{{slug}} already exists for {{count}} members. Do you want to replace it?", amn = "<strong>{{names}}</strong> is already using the <strong>/{{slug}}</strong> url.", smn = "<strong>{{names}}</strong> are already using the <strong>/{{slug}}</strong> url.", cmn = "If you choose to replace it, we will notify them. Go back and remove them if you don't want to overwrite it.", lmn = "Review Event Type", umn = "Looking for more analytics?", dmn = "Looking for more Insights?", _mn = "Filters", pmn = "Filter", mmn = "Add a member", fmn = "Add filter", gmn = "Add rule", hmn = "Add rule group", vmn = "Clear all filters", bmn = "Email Verified", ymn = "Select User", $mn = "Select Event Type", wmn = "Select Date Range", kmn = "Popular Events", Smn = "No event types found", Emn = "Average Event Duration", xmn = "Bookings by Hour", Cmn = "Most Booked", Tmn = "Least Booked", Amn = "Most Bookings Scheduled", Imn = "Least Bookings Scheduled", Omn = "Most Bookings Completed", Nmn = "Least Bookings Completed", zmn = "Events Created", Rmn = "Events Completed", Pmn = "Events Cancelled", Dmn = "Events Rescheduled", Lmn = "Events", Mmn = "Performance", Fmn = "from last period", qmn = "From: {{startDate}} To: {{endDate}}", jmn = 'Adding a redirect will disable the success page. Make sure to mention "Booking Confirmed" on your custom success page.', Vmn = "Event Trends", Bmn = "Clear Filters", Umn = "Clear", Gmn = "Hold", Wmn = "Collect payment on booking", Hmn = "Charge no-show fee", Ymn = "Card held", Kmn = "Charge card", Zmn = "Card charged", Xmn = "{{amount, currency}} no-show fee", Jmn = "No-show Fee", Qmn = "Submit card", efn = "Submit payment information", tfn = "Your meeting is awaiting a payment method", nfn = "No-show fee of {{amount, currency}} charged for {{title}} at {{date}}", ofn = "No-show fee was charged", rfn = "No-show fee of {{amount, currency}} was charged for the following event", ifn = "Something went wrong charging the no-show fee. Please try again later.", afn = "Collect no-show fee", sfn = "No-show fee charged", cfn = "Payment declined. Please try a different card or contact your bank for assistance.", lfn = "This card type isn't supported for this purchase. Please use a different payment method.", ufn = "Minimum payment amount is $0.50 USD. Please increase your payment amount.", dfn = "Could not charge card for payment.", _fn = "Insights", pfn = "Routing Forms", mfn = "No data found for the selected filter or selected dates.", ffn = "I acknowledge that if I do not attend this event that a {{amount, currency}} no show fee will be applied to my card.", gfn = "days", hfn = "Card details", vfn = "Something went wrong on our end. Get in touch with our support team, and we'll get it fixed right away for you.", bfn = "Please provide the following text when contacting support to better help you", yfn = "Currently cannot enable seats and charge a no-show fee", $fn = "Complete your booking", wfn = "Complete your booking: {{title}} on {{date}}", kfn = "Confirm your details", Sfn = "Copy invite link", Efn = "Edit link settings", xfn = "Invite link copied", Cfn = "Invite link deleted", Tfn = "API Key deleted", Afn = "This will permanently delete the API key. Any applications using this key will immediately lose access to your account. This action cannot be undone.", Ifn = "Invite link settings saved", Ofn = "Links set to expire after...", Nfn = "1 day", zfn = "7 days", Rfn = "30 days", Pfn = "3 months", Dfn = "1 year", Lfn = "You have been invited to join {{teamName}}", Mfn = "{{amount, currency}}", Ffn = "You are about to charge the attendee {{amount, currency}}. Are you sure you want to continue?", qfn = "Charge attendee {{amount, currency}}", jfn = "Require payment ({{paymentFeePercentage}}% + {{fee, currency}} commission per transaction)", Vfn = "{{email}} has been invited", Bfn = "{{userCount}} users have been invited", Ufn = "Error collecting card", Gfn = "Uploaded image shouldn't exceed 5mb size limit", Wfn = "{{errorCode}}: You are not authorized to enable or disable this workflow", Hfn = "Inline Embed", Yfn = "Loads your event type directly inline with your other website content.", Kfn = "Floating pop-up button", Zfn = "Puts a floating button on your site that triggers a modal with your event type.", Xfn = "Pop up via element click", Jfn = "Open your calendar as a dialog when someone clicks an element.", Qfn = "Use my own form", egn = "Use our headless routing API and use your own form for submissions.", tgn = "Need help? See our guides for embedding Cal on Wix, Squarespace, or WordPress, check our common questions, or explore advanced embed options.", ngn = "Book my Cal", ogn = "First name", rgn = "Last name", ign = "First name, Last name", agn = "Invite as", sgn = "Form updated successfully.", cgn = "Disable default confirmation emails for attendees", lgn = "At least one workflow is active on this event type that sends a booking confirmation to the attendees.", ugn = "Disable default confirmation emails for host", dgn = "At least one workflow is active on this event type that sends an email to the host when the event is booked.", _gn = "Add an override", pgn = "Import users from Google Workspace", mgn = "Connect Google Workspace", fgn = "You must be a Workspace Admin to use this feature", ggn = "Create your first webhook for this event type", hgn = "Create your first webhook with 'Instant Meeting Created' as trigger for this event type", vgn = "Install app on", bgn = "Create for", ygn = "Currency", $gn = "Create an environment where your teams can create shared apps, workflows and event types with round-robin and collective scheduling.", wgn = "Manage organizations with multiple teams", kgn = "Set up your organization", Sgn = "Set up your platform", Egn = "Organizations are shared environments where teams can create shared event types, apps, workflows and more.", xgn = "Plans", Cgn = "Platform", Tgn = "Manage everything related to platform.", Agn = "Cal.com Platform lets you integrate scheduling effortlessly into your app using platform apis and atoms.", Ign = "Must enter an organization name", Ogn = "Must enter your organization email address", Ngn = "Your organization email address", zgn = "Your admin email address", Rgn = "Administrator's username", Pgn = "Organization name", Dgn = "Platform name", Lgn = "Organization URL", Mgn = "Verify your organization email", Fgn = "Please use the code below to verify your email address to continue setting up your organization.", qgn = "Additional URL parameters", jgn = "About your organization", Vgn = "Organizations are shared environments where you can create multiple teams with shared members, event types, apps, workflows and more.", Bgn = "Create your teams", Ugn = "Start scheduling together by adding your team members to your organization", Ggn = "Invite organization members", Wgn = "Invite others to join your organization. You can add members later.", Hgn = "Set a password", Ygn = "This will create a new user account with your organization email and this password.", Kgn = "Organization Logo", Zgn = "A few sentences about your organization. This will appear on your organization public profile page.", Xgn = "I'll do this later", Jgn = "Verify your email", Qgn = "Enter the 6 digit code we sent to {{email}}", ehn = "Verify your email to create an organization", thn = "The code provided is not valid, try again", nhn = "Email already being used", ohn = "You've been invited to join {{orgName}}", rhn = "Join your team at {{orgName}} and start focusing on meeting, not making meetings!", ihn = "The following teams couldn't be created due to duplicated slugs: {{slugs}}", ahn = "Team names can't be empty", shn = "Team names can't be repeated", chn = "User belongs to an organization", lhn = "This organization has no teams yet", uhn = "If you are an administrator, be sure to create teams to be shown here.", dhn = "Set up", _hn = "My profile", phn = "My settings", mhn = "CRM", fhn = "Messaging", ghn = "Name or number shown as the sender of an SMS (some countries do not allow alphanumeric sender IDs)", hhn = "Only the admin of your organization can create new teams", vhn = "Google's new spam policy could prevent you from receiving any email and calendar notifications about this booking.", bhn = "Resolve", yhn = "There was an error creating teams for this organization. Missing URL slug.", $hn = "Copy link to organization", whn = "Team: {{teamName}}", khn = "User: {{userName}}", Shn = "View booking insights across your events", Ehn = "Call History", xhn = "View call history across your Cal.ai calls", Chn = "{{locationCount}} location options", Thn = "Channel Type", Ahn = "End Reason", Ihn = "Session Status", Ohn = "User Sentiment", Nhn = "Time", zhn = "From", Rhn = "Custom Plan", Phn = "Email Embed", Dhn = "Select a few available times and embed them in your Email", Lhn = "Select Time", Mhn = "Select Date", Fhn = "Only show if a parameter is set", qhn = "Add parameter", jhn = "We are connecting you to someone from {{orgName}}.", Vhn = "Please do not close or refresh this page", Bhn = "See all available times", Uhn = "e.g. Marketing Team", Ghn = "e.g. Sales Team", Whn = "e.g. Design Team", Hhn = "e.g. Engineering Team", Yhn = "e.g. Data Analytics Team", Khn = "You will be able to add more teams later on.", Zhn = "What is this meeting about?", Xhn = "Add to team", Jhn = "Remove users from organization", Qhn = "Delegation credential", evn = "Delegation credential allows you to manage access to Google Workspace calendars for your organization.", tvn = "Add this Client Id in Google Workspace with the scope below", nvn = "Delegation credential enabled", ovn = "Add delegation credential", rvn = "Edit delegation credential", ivn = "Domain", avn = "No workspace platforms", svn = "Workspace platform", cvn = "Workspace platforms", lvn = "Manage workspace platforms that can be used for delegation credential", uvn = "Edit workspace platform", dvn = "Edit service account", _vn = "Add workspace platform", pvn = "Slug", mvn = "Service account key JSON", fvn = "Edit service account key JSON", gvn = "Delegation credential restricts adding more than one installation", hvn = "App successfully installed and is using delegated credentials", vvn = "Are you sure you want to remove {{userCount}} users from this organization?", bvn = "Remove users from team", yvn = "Are you sure you want to remove {{userCount}} users from this team?", $vn = "This user has not setup any schedules yet", wvn = "This user is not in any teams", kvn = "This user has not installed any apps yet", Svn = "Requires booker email verification", Evn = "To ensure booker's email verification before scheduling events", xvn = "Text messages can only be sent to attendees when event type requires confirmation.", Cvn = "Organizations", Tvn = "Upload Cal Video Logo", Avn = "Update Cal Video Logo", Ivn = "Upload Banner", Ovn = "To ensure your logo is visible against Cal video's dark background, please upload a light-colored image in PNG or SVG format to maintain transparency.", Nvn = "Other teams", zvn = "Here you can see teams inside your organization that you are not part of. You can add yourself to them if needed.", Rvn = "You are not part of any organization", Pvn = "No other teams found", Dvn = "There are no other teams in this organization.", Lvn = "Attendee first name", Mvn = "Attendee last name", Fvn = "The person booking's first name", qvn = "The person booking's last name", jvn = "Your Monthly Digest", Vvn = "Member Name", Bvn = "Most Popular Events", Uvn = "Here's your summary of popular events for your team {{teamName}} for the last 30 days", Gvn = "Me", Wvn = "Meeting Unavailable", Hvn = "Monthly digest email", Yvn = "Monthly digest email for teams", Kvn = "Verify your team to enable sending messages to attendees", Zvn = "Member removed", Xvn = "My Availability", Jvn = "Team Availability", Qvn = "Instant meeting availability", ebn = "Backup Code", tbn = "Backup Codes", nbn = "Each backup code can be used exactly once to grant access without your authenticator.", obn = "Backup codes copied!", rbn = "Backup code is incorrect.", ibn = "Lost access", abn = "No backup codes found. Please generate them in your settings.", sbn = "New organization created: pending action", cbn = "Hi Administrator", lbn = "An organization requires DNS setup", ubn = 'An organization with slug "{{orgSlug}}" was created.<br /><br />Please be sure to configure your DNS registry to point the subdomain corresponding to the new organization to where the main app is running. Otherwise the organization will not work.<br /><br />Here are just the very basic options to configure a subdomain to point to their app so it loads the organization profile page.<br /><br />You can do it either with the A Record:', dbn = "Or the CNAME record:", _bn = "Once you configure the subdomain, please mark the DNS configuration as done in Organizations Admin Settings.", pbn = "Go to Organizations Admin Settings", mbn = "Org has been processed", fbn = "There has been an error processing this organization", gbn = "A list of all organizations. Accepting an organization will allow all users with that email domain to sign up WITHOUT email verification.", hbn = "Unverified", vbn = "Verified", bbn = "DNS Missing", ybn = "DNS Configured", $bn = "Mark as DNS configured", wbn = "Value", kbn = "Your organization updated successfully", Sbn = "This team has no event types", Ebn = "Seat option doesn't support multiple durations", xbn = "Include calendar event", Cbn = "OAuth", Tbn = "OAuth client creation form", Abn = "This is the form to create a new OAuth client", Ibn = "OAuth client updation form", Obn = "This is the form to edit an existing OAuth client", Nbn = "Recently added", zbn = "Connect all your calendars", Rbn = "{{appName}} reads availability from all your existing calendars.", Pbn = "Personalise your scheduling experience with workflows", Dbn = "Workflow automation", Lbn = "Schedule for your team with collective and round-robin scheduling", Mbn = "No members found", Fbn = "Directory Sync", qbn = "Directory Name", jbn = "Directory Provider", Vbn = "SCIM Base URL", Bbn = "SCIM Bearer Token", Ubn = "SCIM Base URL copied", Gbn = "SCIM Bearer Token copied", Wbn = "Your Identity Provider will ask for the following information to configure SCIM. Follow the instructions to finish the setup.", Hbn = "Configure Directory Sync", Ybn = "Choose an identity provider to configure directory for your team.", Kbn = "Configure an identity provider to get started with SCIM.", Zbn = "Directory sync connection created.", Xbn = "Provision and de-provision users with your directory provider.", Jbn = "Directory sync connection deleted.", Qbn = "Delete Connection", eyn = "Delete Directory Sync Connection", tyn = "Are you sure you want to delete this directory sync connection?", nyn = "This action cannot be undone. This will permanently delete the directory sync connection.", oyn = "Event Setup: The duration must be at least 1 minute.", ryn = "Availability Schedules", iyn = "Unauthorized", ayn = "{{clientName}} would like access to your {{appName}} account", syn = "Select account or team", cyn = "This will allow {{clientName}} to", lyn = "Associate you with your personal info from {{clientName}}", uyn = "See your personal info, including any personal info you've made publicly available", dyn = "See your primary email address", _yn = "Connect to your installed apps", pyn = "Read, edit, delete your event-types", myn = "Read, edit, delete your availability", fyn = "Read, edit, delete your bookings", gyn = "Allow {{clientName}} to do this?", hyn = "By clicking allow, you allow this app to use your information in accordance with their terms of service and privacy policy. You can remove access in the {{appName}} App Store.", vyn = "Allow", byn = "This user has not completed onboarding. You will not be able to set their availability until they have completed onboarding.", yyn = "You are viewing this user's availability. You can only edit your own availability.", $yn = "You can override this on a per-event basis in Advanced settings in each event type.", wyn = "Edit user's availability: {{username}}", kyn = "Resend invitation", Syn = "The invitation was resent.", Eyn = "SAML", xyn = "Add client", Cyn = "After copying the secret you won't be able to view it anymore", Tyn = "Add new Client", Ayn = "Add new user", Iyn = "This app has not been setup yet", Oyn = "as CSV", Nyn = "Overlay my calendar", zyn = "By connecting to your calendar, you accept our privacy policy and terms of use. You may revoke access at any time.", Ryn = "View your calendar events to prevent clashed booking.", Pyn = "Join {{eventLocationType}}", Dyn = "Troubleshooting", Lyn = "Calendars we're checking for conflicts", Myn = "Availability schedules", Fyn = "Manage calendars", qyn = "Manage availability schedules", jyn = "Locked", Vyn = "Unlocked", Byn = "Lock timezone on booking page", Uyn = "To lock the timezone on booking page, useful for in-person events.", Gyn = "You can only have one payment app enabled per event type.", Wyn = "Please enter number in international format.", Hyn = "Install Calendar", Yyn = "Branded Subdomain", Kyn = "Get your own branded subdomain, such as acme.cal.com", Zyn = "Organization-wide Insights", Xyn = "Understand how your entire organization is spending time", Jyn = "Extensive Whitelabeling", Qyn = "Customize your scheduling experience with your own logo, colors, and more", e$n = "Unlimited Teams", t$n = "Verify email", n$n = "Please enter the email address used for this booking to proceed with cancellation", o$n = "Email doesn't match the booking email", r$n = "Add as many subteams as you need to your organization", i$n = "Unified Billing", a$n = "Advanced Managed Event Types", s$n = "Add a single credit card to pay for all your team's subscriptions", c$n = "Enterprise", l$n = "Upgrade to Enterprise to create your Organization", u$n = "Create your Organization", d$n = "Create organization", _$n = "Upgrade to Organizations and receive a subdomain, unified billing, Insights, extensive whitelabeling and more", p$n = "Upgrade to Enterprise and get access to Active Directory Sync, SCIM Automatic User provisioning, Cal.ai Voice Agents, Admin APIs and more!", m$n = "You can only enable one payment app per event type", f$n = "Teams that are member of this organization will also be deleted along with their event-types", g$n = "Users that were part of the organization will not be deleted but their usernames would be changed to allow them to exist outside the organization", h$n = "User event-types created after the user was in the organization will be deleted", v$n = "Migrated user event-types will not be deleted", b$n = "Delete {{organizationName}}?", y$n = "Published", $$n = "Unpublished", w$n = "Publish", k$n = "Open the troubleshooter and figure out what is wrong with your schedule", S$n = "Need help?", E$n = "Troubleshooter", x$n = "Number to Call", C$n = "Guest Name", T$n = "Guest Email", A$n = "Guest Company", I$n = "Please install a calendar", O$n = "Instant Booking", N$n = "Let people book immediately", z$n = "Upgrade to Enterprise and let guests join an instant call that attendees can jump straight into. This is only for team event types", R$n = "Don't want to wait?", P$n = "Meeting Started", D$n = "Pay to book", L$n = "Let AI Agents book you", M$n = "Could not find booking", F$n = "Booking seats are full", q$n = "Missing payment credentials", j$n = "Missing payment app id", V$n = "Booking does not have enough available seats", B$n = "{{username}} is currently away for a brief period of time.", U$n = "In the meantime, {{profile.username}} will be in charge of all the new scheduled meetings on behalf of {{username}}.", G$n = "Out of office", W$n = "Let your bookers know when you're OOO.", H$n = "Send request", Y$n = "Start date and end date are required", K$n = "Start date must be before end date", Z$n = "Start date must be in the future", X$n = "User not found", J$n = "Cannot redirect to self", Q$n = "Out of office entry already exists", ewn = "Out of office entry id required", twn = "There is already a booking redirect from that user to you.", nwn = "Successfully created a new entry", own = "Booking redirect notification", rwn = "Booking Redirect Notification", iwn = "You have received a booking redirection from {{eventOwner}} so their profile links will be redirect to yours for the time interval {{dates}}.", awn = "Booking redirect edit notification", swn = "Booking Redirect Edit Notification", cwn = "Your booking redirection from {{eventOwner}} for the time interval {{oldDates}} has been udpated. New time interval for the redirection is {{dates}}.", lwn = "Booking redirect cancel notification", uwn = "Booking Redirect Cancel Notification", dwn = "Your booking redirection from {{eventOwner}}, for time interval {{dates}} has been canceled.", _wn = "You have accepted this booking redirect request.", pwn = "You have rejected this booking redirect request.", mwn = "Copy link to share request", fwn = "Booking Redirect Request", gwn = "Select team member", hwn = "Going away? Simply mark your profile link as unavailable for a period of time.", vwn = "Provide a link to a team member when OOO", bwn = "Provide a link to a team member when OOO (Team plan required)", ywn = "Out of office unavailability list", $wn = "Successfully deleted entry", wwn = "Successfully edited entry", kwn = "Temporarily Out-Of-Office?", Swn = "Add a redirect", Ewn = "Create entry", xwn = "Time range", Cwn = "Add all team members, including future members", Twn = "Redirect to", Awn = "Having trouble finding a time?", Iwn = "Show more", Own = "Forward parameters such as ?email=...&name=.... and more", Nwn = "Schedule meetings when everyone is available or rotate through members on your team", zwn = "lowest", Rwn = "low", Pwn = "medium", Dwn = "high", Lwn = "highest", Mwn = "Send Booker to", Fwn = "Set Priority", qwn = "Set Weight", jwn = "Enable Weights", Vwn = "Priority for {{userName}}", Bwn = "Weights determine how meetings are distributed among hosts. <0>Learn more</0>", Uwn = "Weight for {{userName}}", Gwn = "change priority", Wwn = "Use field identifiers as variables for your custom event redirect", Hwn = "Use field identifiers as variables for your custom event redirect (e.g. {{variable}})", Ywn = "Account is already linked", Kwn = "Send email", Zwn = "Call attendee using Cal.ai Voice Agent", Xwn = "Call to confirm booking", Jwn = "2 hrs before event starts", Qwn = "Cal.ai Agent Configuration", ekn = "Please choose at least one event type to make a test call.", tkn = "Mark as no-show", nkn = "Unmark no-show", okn = "Account unlinked successfully", rkn = "There was an error unlinking the account", ikn = "Travel Schedule", akn = "Plan your trip ahead to keep your existing schedule in a different timezone and prevent being booked at midnight.", skn = "Schedule timezone change", ckn = "Date", lkn = "Enter the general prompt for the agent", ukn = "This overlaps with an existing schedule. Please select a different date.", dkn = "Get notifications when your team has no availability", _kn = "Admins will get email notifications when a user tries to book a team member and is faced with 'No availability'. We trigger this email after two occurrences and remind you every 7 days per user.  ", pkn = "Disable SMS notifications for phone only event types", mkn = "Disable automated SMS notifications for event types that only have phone number(attendeePhoneNumber) as required question with email as optional or not required", fkn = "Your current plan", gkn = "$37 per user per month", hkn = "Manage privacy settings for your organization", vkn = "Privacy", bkn = "Privacy & Security", ykn = "New teams will be under your organization", $kn = "Add group name", wkn = "Group Name", kkn = "Routers", Skn = "Primary", Ekn = "Make primary", xkn = "Add Email", Ckn = "Add Emails", Tkn = "Add an email address to replace your primary or to use as an alternative email on your event types.", Akn = "Confirm your email", Ikn = "$t(hey_there) {{name}}, confirming your booking on {{date}}.", Okn = "The first name of the person booking", Nkn = "The last name of the person booking", zkn = "Scheduler Name", Rkn = "Your first name", Pkn = "We sent an email to <strong>{{email}}</strong>. Click the link in the email to verify this address.", Dkn = "Send event details to", Lkn = "Schedule timezone without end date", Mkn = "Select members", Fkn = "What should we do with your member's existing event types?", qkn = "All of your members individual event types (except managed ones) will be permanently deleted. They will not be able to create new ones", jkn = "Your members individual event types will be hidden (except managed ones) from profiles but the links will still be active. They will not be able to create new ones.  ", Vkn = "Hide individual event types", Bkn = "Delete individual event types", Ukn = "Lock individual event type creation", Gkn = "Prevent members from creating their own event types.", Wkn = "Add to event type", Hkn = "Create account password", Ykn = "Create Account with SAML", Kkn = "Failed to create account password", Zkn = "Cannot create account password for cal accounts", Xkn = "Cannot create account password for already created ones", Jkn = "You don't have an account password, create one by navigating to Security -> Password. Can't disconnect until an account password is created.", Qkn = "Disconnect connected account", e0n = "Disconnecting your connected account will change the way you log in. You will only be able to login to your account using email + password", t0n = "I agree to the privacy policy and cookie usage", n0n = "Make a Call", o0n = "Skip round robin assignment if contact exists in Salesforce", r0n = "URL must contain the contacts email as a parameter ex. ?email=contactEmail", i0n = "Select Account", a0n = "Install {{appName}} on your personal account or on a team account.", s0n = "Select Event Types", c0n = "On which event type do you want to install {{appName}}?", l0n = "Configure {{appName}}", u0n = "Finalise the App setup. You can change these settings later.", d0n = "already installed", _0n = "Unspecified", p0n = "Vacation", m0n = "Travel", f0n = "Sick leave", g0n = "Public holiday", h0n = "Forwarding to <0>{{username}}</0>", v0n = "No forwarding", b0n = "Create an OOO", y0n = "Communicate to your bookers when you're not available to take bookings. They can still book you upon your return or you can forward them to a team member.", $0n = "{{displayName}} is OOO", w0n = "<0>{{displayName}}</0> can take their meetings while they are away.", k0n = "Book {{displayName}}", S0n = "Select reason", E0n = "Go Out of Office", x0n = "Edit Out of Office Entry", C0n = "Submit Feedback", T0n = "Your host didn't show up", A0n = "You can reschedule another meeting with them", I0n = "How can we improve our service?", O0n = "What did you like the most?", N0n = "Review", z0n = "Reviewed", R0n = "Unreviewed", P0n = "Rating url", D0n = "The URL for Rating Feedback Form", L0n = "No Show url", M0n = "The URL for No Show Feedback", F0n = "No Support Needed?", q0n = "Hide Support", j0n = "Average Ratings", V0n = "No-Show (Host)", B0n = "No-Show (Guest)", U0n = "Recent Ratings", G0n = "No ratings submitted", W0n = "Add a workflow with 'Rating' to collect ratings after meetings", H0n = "Most No-Show", Y0n = "Highest Rated", K0n = "Lowest Rated", Z0n = "Members with highest rated meetings", X0n = "Members with lowest rated meetings", J0n = "CSAT Score", Q0n = "Locked SMS", e1n = "Leave without assigning anyone?", t1n = "Are you sure want to leave this event without adding attendees?", n1n = "If you don't assign anyone for this event, there will be no availability shown to bookers.", o1n = "Go back and Assign", r1n = "Leave without Assigning", i1n = "By proceeding, you agree to our <0>Terms</0> and <1>Privacy Policy</1>.", a1n = "By proceeding, you agree to our", s1n = "Terms", c1n = "Always {{x}} days available", l1n = "Automatically moves the {{x}}-day booking window forward each day, ensuring your calendar always shows the next {{x}} days of available slots.", u1n = "Team subscription cancelled successfully", d1n = "Error while cancelling the team subscription", _1n = "An error occurred while trying to subscribe to the platform plan, please try again later", p1n = "An error occurred while updating the OAuth client, please try again later", m1n = "An error occurred while creating the OAuth client, please try again later", f1n = "Event type color", g1n = "This is only used for event type & booking differentiation within the app. It is not displayed to bookers.", h1n = "Mark as no show", v1n = "{{x}} marked as no-show", b1n = "{{x}} unmarked as no-show", y1n = "triggers for all team event types and all team members' personal event types", $1n = "Manage settings for you team", w1n = "No-show status updated for attendees", k1n = "Email copied", S1n = "Phone Number Copied", E1n = "User is a pending member of the organization", x1n = "User is already invited or a member", C1n = "User is member of an organization that this team is not a part of.", T1n = "Booking has been reassigned", A1n = "Reassign", I1n = "Reassign booking to another available round robin host", O1n = "Assign team member", N1n = "Override which team member you want to assign to.", z1n = "No available hosts", R1n = "Reassign round robin host", P1n = "Do not write to the ICS feed", D1n = "Rescheduling is not possible as the event has expired", L1n = "This event is expired", M1n = "Skip creating contacts if they do not exist in {{appName}} ", F1n = "If your ICS link is read-only (e.g., Proton Calendar), check the box above to avoid errors. You'll also need to manually update your calendar for changes.", q1n = "Attributes", j1n = "New attribute", V1n = "Add attributes", B1n = "Add attributes to your team members", U1n = "New option", G1n = "Update member", W1n = "Attribute", H1n = "Create an attribute for your team members", Y1n = "Edit an attribute for your team members", K1n = "Attribute updated successfully", Z1n = "Attribute deleted successfully", X1n = "Attributes edited successfully", J1n = "Manage attributes for your team members", Q1n = "Edit attributes for your team members", eSn = "Back to attributes", tSn = "Are you sure you want to delete this option?", nSn = "This option is assigned to {{numberOfUsers}} members. Deleting it will remove it from their profile.", oSn = "Disable standard emails to attendees related to this event type", rSn = "Disables standard email communication related to this event type, including booking confirmations, reminders, and cancellations.", iSn = "Disable standard emails to hosts related to this event type", aSn = "Type confirm to continue", sSn = "Disable email", cSn = "Grant Admin API Access", lSn = "Revoke Admin API Access", uSn = "Add {{calendar}} Calendar", dSn = "Connect Apple Calendar", _Sn = "Connected Apple Calendar", pSn = "Checking Apple Calendar", mSn = "Connect Google Calendar", fSn = "Connected Google Calendar", gSn = "Checking Google Calendar", hSn = "Connect Outlook Calendar", vSn = "Connected Outlook Calendar", bSn = "Checking Outlook Calendar", ySn = "Connect to Stripe", $Sn = "Connected Stripe", wSn = "Checking Stripe credentials", kSn = "Booking question response variables", SSn = "Managed by {{teamAdmins}}", ESn = "{{count}} options", xSn = "Reschedule with same Round-Robin host", CSn = "Rescheduled events will be assigned to the same host as initially scheduled", TSn = "Disable input if the URL identifier is prefilled", ASn = "Booking Limits", ISn = "Booking limits for team members across all team event types", OSn = "Limit how many times members can be booked across all team event types", NSn = "Booking limits updated successfully", zSn = "You are unauthorized to make this change to the booking", RSn = "Delegation credential disabled", PSn = "Matching members", DSn = "{{x}} matching members", LSn = "Matching members queue (using attribute weights)", MSn = "Matching members queue (using event assignee weights)", FSn = "No matching members. It will fallback to using the team members assigned to the event type.", qSn = "No matching members. It will fallback to using the team members assigned to the event type. Consider adding a fallback or correcting the logic of using_fallback_members", jSn = "Hide calendar event details on shared calendars", VSn = "When a calendar is shared, events are visible to readers but their details are hidden from those without write access.", BSn = "Last {{count}} days", USn = "Month to date", GSn = "Year to date", WSn = "Custom range", HSn = "Refund Policy", YSn = "Always", KSn = "Never", ZSn = "Payment Option", XSn = "If cancelled", JSn = "before", QSn = "Show all columns", eEn = "Toggle columns", tEn = "No columns found", nEn = "On booking, add events on and new attendees as:", oEn = "Lead", rEn = "Contact under an account", iEn = "Skip creating {{entry}} record if they do not exist in Salesforce", aEn = "If the contact does not exist under an account, create new lead from attendee", sEn = "Create a new contact under an account based on email domain of attendee and existing contacts", cEn = "Change record owner on booking", lEn = "Mass assign attributes", uEn = "It results in showing custom message. Try changing the response to route to an event", dEn = "It results in redirecting to {{externalUrl}}. Try changing the response to route to an event", _En = "Possible host", pEn = "Current routing status", mEn = "Reroute booking", fEn = "Reroute the booking to different team members", gEn = "Verify new route", hEn = "Reroute", vEn = "New routing status", bEn = "If attendee exists in Salesforce, book directly with the owner", yEn = "Entity to check owner of to book directly", $En = "Account", wEn = "Choose host schedules", kEn = "You can select a different schedule for each host. Each host's default schedule is chosen by default.", SEn = "No hosts assigned, add hosts in assignment tab.", EEn = "Manually reassign round robin host", xEn = "Manually reassign round robin host to another available host", CEn = "Reassign round robin host to another available host", TEn = "New user is not a valid round-robin host for this event type", AEn = "New user is a fixed host for this event type", IEn = "Reschedule with same timeslot", OEn = "Reschedule with same timeslot of the new event", NEn = "Reschedule to the new event with different timeslot", zEn = "Reschedule with different timeslot", REn = "We don't have ID for the new event. Please go to the Routing Form and save it again.", PEn = "Rerouted booking successfully. Redirecting to booking page", DEn = "On booking, write to event object", LEn = "Field name", MEn = "Add new field", FEn = "You don't have access to reroute this booking", qEn = "Form response not found", jEn = "Contact owner", VEn = "Not found", BEn = "Using fallback members", UEn = "Chosen Route", GEn = "Attribute logic matched", WEn = "Attribute logic fallback matched", HEn = "All assigned members of the team event type. Consider adding some attribute rules.", YEn = "All assigned members of the team event type. Consider adding some attribute rules to fallback.", KEn = "All assigned members of the team event type. Consider tweaking fallback to have a match.", ZEn = "Warning", XEn = "Fallback: If no Team Members match, use those that match the following criteria (matches all assigned team members of the event by default)", JEn = "Fallback warning", QEn = "Not needed", exn = "Host unavailable", txn = "Host available", nxn = "Are you sure you want to reassign this booking to an unavailable host?", oxn = "Are you sure you want to reassign this booking?", rxn = "Yes, reassign", ixn = "Filter by attributes", axn = "Reason for reassigning", sxn = "Changing the field type may cause data loss. Please create a new field instead.", cxn = "Reassigned by", lxn = "row", uxn = "rows", dxn = "Attendee Timezone", _xn = "Event Start Time In Attendee Timezone", pxn = "Event Start Time In Attendee Timezone", mxn = "Event End Time In Attendee Timezone", fxn = "Event End Time In Attendee Timezone", gxn = "Create event on contact, if it exists. Else fallback to lead", hxn = "Owner name to change", vxn = "No filter set", bxn = "Booking dry run successful", yxn = "The dry run was completed successfully.", $xn = "You don't have access to this page", wxn = "In order to view or interact with this page, you must have admin or owner privileges", kxn = "Field type", Sxn = "When to write", Exn = "On booking, write to a custom field on the attendee {{record}} record", xxn = "On every booking", Cxn = "Only if field is empty", Txn = "Booking start date", Axn = "Booking created date", Ixn = "Booking reassigned to {{host}}", Oxn = "No contact owner", Nxn = "Routing Forms Created", zxn = "Total Responses", Rxn = "Total Responses Without Booking", Pxn = "Total Responses With Booking", Dxn = "No Bookings", Lxn = "Form Name", Mxn = "Booking", Fxn = "No Booking", qxn = "Booked by", jxn = "Created at", Vxn = "Booking Status", Bxn = "Booking At", Uxn = "Submitted At", Gxn = "Copy Redirect URL", Wxn = "Redirect URL on Exit", Hxn = "Total Bookings per period", Yxn = "Routed to per period", Kxn = "Per day", Zxn = "Per week", Xxn = "Per month", Jxn = "Assignment Reason", Qxn = "Access Denied", eCn = "Contact owner will be the Round Robin host if available", tCn = "Add new attendees as", nCn = "Contact owner will not be forced (can still be host if it matches the attributes and Round Robin criteria)", oCn = "Route to a user that matches a lookup field on an account", rCn = "Salesforce Option", iCn = "Lookup Field Name", aCn = "If attendee has a free email domain, skip the ownership check and round robin as normal", sCn = "Is", cCn = "Is not", lCn = "Contains", uCn = "Does not contain", dCn = "Starts with", _Cn = "Ends with", pCn = "Is empty", mCn = "Not empty", fCn = "Auto translate title and description", gCn = "Automatically translate titles and descriptions to the visitor’s browser language using AI.", hCn = "Distribution", vCn = "Allows for optimising distribution for maximum availability or to aim for a more balanced assignment.", bCn = "Maximize availability", yCn = "Allows bookers to book meetings whenever a host is available. Use this to maximize the number of potential meetings booked and when the even distribution of meetings across hosts is less important.", $Cn = "Load balancing", wCn = "We will monitor how many bookings have been made with each host and compare this with others, disabling some hosts that are too far ahead so bookings are evenly distributed.", kCn = "Edit Weights", SCn = "Weights updated successfully", ECn = "Only require confirmation for free email providers (Ex. @gmail.com, @outlook.com)", xCn = "Exclude emails that contain", CCn = "Require emails that contain", TCn = "Please enter a valid work email address", ACn = "You are not allowed to book with this email domain. Please contact the owner of this link.", ICn = "Search columns", OCn = "Search options", NCn = "Disable public organization profile and redirect", zCn = "Redirects {{orgSlug}}.cal.com to {{destination}}", RCn = "Single Select", PCn = "Multi Select", DCn = "Calendar Conflict Settings", LCn = "Select which calendars to check for conflicts", MCn = "Group Meeting", FCn = "Are you sure you want to remove this app from", qCn = "Disconnect app from", jCn = "Do not create new records for guests added to the booking", VCn = "Google Meet", BCn = "Zoom", UCn = "MS Teams Video", GCn = "Lock for assignment", WCn = "Locking would only allow assignments from Directory Sync", HCn = "Attribute edited successfully", YCn = "New group option", KCn = "Weights enabled", ZCn = "By enabling weights, it would be possible to assign higher priority to certain attributes per user. The higher the weight, the higher the priority.", XCn = "Routed", JCn = "Reassigned", QCn = "Allow rescheduling past events", eTn = "Enabling this option allows for past events to be rescheduled", tTn = "Rerouted", nTn = "Salesforce assignment", oTn = "Router Position", rTn = "Show matching hosts", iTn = "No active queues for this input", aTn = "Weight", sTn = "Calibration", cTn = "Shortfall", lTn = "Routing Form", uTn = "Go back and save", dTn = "Save changes", _Tn = "Leave without saving", pTn = "Are you sure you want to leave without saving changes to your routing form?", mTn = "Something unexpected occurred", fTn = "You are doing a test booking.", gTn = "Icon showcase", hTn = "Icons showcase", vTn = "Migrating from team", bTn = "Feature is currently disabled", yTn = "Choose an option", $Tn = "Enter option value", wTn = "Remove option", kTn = "Use Attribute weights", STn = "If enabled, all weights set within the event type will be ignored", ETn = "Attribute for weights", xTn = "Managed Users", CTn = "See all the managed users created by your OAuth client", TTn = "Can you tell me about ", ATn = "Use AI to answer your questions", ITn = "Error while fetching answer ", OTn = "An unexpected error occured. Please try again later", NTn = "Select Oauth Client", zTn = "On every instance", RTn = "Delegation credential feature is not enabled for your organization", PTn = "Internal Note", DTn = "Reason shared with customer (optional)", LTn = "This note will be visible to only members of your team", MTn = "Internal Cancelation Notes Presets", FTn = "Create presets for internal notes that can be applied to bookings", qTn = "Internal note presets updated successfully", jTn = "Add Preset", VTn = "Authorize", BTn = "Next", UTn = "Hide", GTn = "Show", WTn = "UTM parameters", HTn = "No UTM parameters available.", YTn = "Asc", KTn = "Desc", ZTn = "Verify email change", XTn = "Buy Credits", JTn = "Credits", QTn = "Credits used", eAn = "Total remaining", tAn = "You receive 1000 credits per month, per team member", nAn = "You receive 750 credits per month, per team member", oAn = "View and manage credits for sending SMS messages", rAn = "View and manage credits for sending SMS messages. One credit is worth 1¢ (USD). <0>Learn more</0>", iAn = "One credit is worth 1¢ (USD). <0>Learn more</0>", aAn = "Buy additional credits ($0.01 per credit)", sAn = "You can view Additional credit spending in your expense log", cAn = "Overview", lAn = "Organization slug is already taken", uAn = "You cannot create an organization as you are already a part of an organization", dAn = "You need to complete user onboarding before creating an organization", _An = "Use company email to create an organization", pAn = "You cannot create a platform organization as you are already a part of a team", mAn = "You need to have minimum published teams", fAn = "You are part of this organization already", gAn = "You are part of another organization, cannot create a new organization", hAn = "You are part of another platform organization, cannot create a new organization", vAn = "Organization payment success", bAn = "Your organization has been created successfully", yAn = "This may take a few seconds...", $An = "Organization onboarding status", wAn = "Organization onboarding status description", kAn = "Payment failed", SAn = "Your payment has failed. Please try again.", EAn = "Creating your organization", xAn = "Organization onboarding already completed", CAn = "Organization onboarding already exists", TAn = "Organization onboarding not found", AAn = "No onboarding ID provided", IAn = "Onboarding not found", OAn = "Onboarding already complete", NAn = "This onboarding has already been completed. You can view your organization in settings.", zAn = "Resume Onboarding", RAn = "Continue with your organization onboarding process", PAn = "Payment successful!", DAn = "Handover onboarding", LAn = "Handover onboarding to the user", MAn = "Organization already exists with this slug", FAn = "You do not have permission to create an organization for this email", qAn = "You do not have permission to migrate one or more of the teams", jAn = "Organization has a subscription already", VAn = "Reset interval for weighted Round Robin", BAn = "Interval", UAn = "Determines how often the round robin booking count resets to ensure balanced distribution.", GAn = "Daily", WAn = "You didn't set an end date for your OOO", HAn = "My OOO", YAn = "Team OOO", KAn = "Manage your teams OOO.", ZAn = "Create Out of Office", XAn = "Create an OOO for a team member", JAn = "Edit an OOO for a team member", QAn = "Create OOO for your team", e2n = "Communicate to bookers when your team members are not available to take bookings. They can still be booked upon their return or you can forward them to another team member.", t2n = "OOO forwarding is only allowed to a member of the same team.", n2n = "There is already a reverse forwarding between these users.", o2n = "No previous OOO found", r2n = "Previous", i2n = "Round Robin interval successfully updated", a2n = "Trial mode", s2n = "Inactive team plan", c2n = "Your team plan is inactive. Check your subcription or reach out to customer support", l2n = "Limited access during trial. Feature available after trial ends.", u2n = "Referral Program", d2n = "Refer and earn", _2n = "You need a Dub API Key and Program Id to use this page.", p2n = "UID", m2n = "Link", f2n = "rows per page", g2n = "{{currentRange}} of {{totalItems}}", h2n = "Tip: You can add a '+' between usernames: cal.com/anna+brian to make a dynamic group meeting", v2n = "You don't have a team yet", b2n = "You don't have team members yet", y2n = "Recurring event doesn't support seats feature. Make it non-recurring to enable seats.", $2n = "Recurring event doesn't support booking limit per booker feature. Disable booking limit per booker to enable Recurring event.", w2n = "Seats feature doesn't support recurring event. Disable seats feature to make it recurring.", k2n = "Recurring event doesn't support seats feature. Disable seats feature or make the event non-recurring.", S2n = "Segment", E2n = "Saved filters", x2n = "Rename", C2n = "Rename Segment", T2n = "Delete Segment", A2n = "Duplicate Segment", I2n = "Are you sure you want to delete this segment? This action cannot be undone.", O2n = "Filter segment updated", N2n = "Error updating filter segment", z2n = "Filter segment duplicated", R2n = "Error duplicating filter segment", P2n = "Filter segment deleted", D2n = "Error deleting filter segment", L2n = "Save Segment", M2n = "Segment not found", F2n = "Filter segment saved", q2n = "No segments", j2n = "Error saving filter segment", V2n = 'Save overrides to "{{name}}"', B2n = "Create new segment", U2n = "Save for team", G2n = "Select team", W2n = "Please select a team", H2n = "Personal", Y2n = "Hide Team Profile Link", K2n = "Hide the team profile link on booking pages", Z2n = "Display", X2n = "Could not find slug to publish the organization", J2n = "Picklist", Q2n = "Most Cancelled", eIn = "Interface Language", tIn = "Set your preferred language for the booking interface", nIn = "Visitor's browser language", oIn = "Name or Email", rIn = "If no contact is found, fallback to lead owner if it exists", iIn = "Credit purchase failed. Please try again or contact support.", aIn = "Minimum of 50 credits required", sIn = "Enable Delegation Credential", cIn = "Grant Cal.com automatic access to the calendars of all organization members by enabling delegation credential.", lIn = "Disable Delegation Credential", uIn = "Once delegation credential is disabled, organization members who haven't connected their calendars will need to do so manually.", dIn = "Last Active", _In = "Member Since", pIn = "Last Updated", mIn = "On cancelled booking, write to event record instead of deleting event", fIn = "On every cancellation", gIn = "Report issue", hIn = "You can submit a ticket on GitHub or upgrade your plan to receive real-time support with developer conferences", vIn = "Open Issue", bIn = "This is your current plan", yIn = "Schedule a time", $In = "This includes:", wIn = "OAuth client updated successfully", kIn = "OAuth Client not found.", SIn = "Subscribe to Platform", EIn = "Error while trying to access webhooks.", xIn = "Failed to update webhook.", CIn = "Failed to create webhook.", TIn = "Invalid Link", AIn = "You are currently subscribed to {{planFirstLetter}}{{planRest}} plan", IIn = "User/Team", OIn = "Client ID copied!", NIn = "Client secret copied!", zIn = "The Cal.com team are performing scheduled maintenance. If you have any questions, please contact support.", RIn = "Your payment failed", PIn = "Check your Inbox", DIn = "Your account has been created, but your premium has not been reserved.", LIn = "We have sent an email to {{email}} with a link to activate your account.", MIn = "Once you activate your account you will be able to try purchase your premium username again or select a different one.", FIn = "Open in Gmail", qIn = "Don't seen an email?", jIn = "Resend in {{seconds}} seconds", VIn = "Resend", BIn = "Verification email sent", UIn = "Select all members", GIn = "Selecting all members will add all future team members when they are added to the team.", WIn = "Form Settings", HIn = "Remove whitelist status", YIn = "Whitelist user workflows", KIn = "User workflows whitelisted", ZIn = "User workflows unwhitelisted", XIn = "Date & Time", JIn = "This is a reminder about your upcoming event.", QIn = "This reminder was triggered by a Workflow in Cal.", eOn = "Event", tOn = "Scheduling by", nOn = "How was your recent experience?", oOn = "We're always looking to improve our customer's experience.", rOn = "How satisfied were you with your recent meeting?", iOn = "didn't join the meeting?", aOn = "Reschedule here.", sOn = "Hide organizer's email", cOn = "You are already part of a platform organization which is why you can't create a new organization. Each user can only belong to one organization. Please, create a new cal.com account with a different email and use that account to subscribe to the organizations plan.", lOn = "You are already part of an organization which is why you can't create a platform organization. Each user can only belong to one organization. Please, create a new cal.com account with a different email and use that account to subscribe to the platform plan.", uOn = "Hide organizer's email address from the booking screen, email notifications, and calendar events", dOn = "You &", _On = "Select a verified email", pOn = "Add verified email", mOn = "Add verified emails", fOn = "Custom 'Reply-To' email", gOn = "Use a different email address as the replyTo for confirmation emails instead of the organizer's email", hOn = "This survey was triggered by a Workflow in Cal.", vOn = "Skip trial period", bOn = "Team trials skipped successfully", yOn = "By entering your phone number you consent to receive SMS messages for this event. SMS rates may apply.", $On = "More info can be found in <0>Routing Insights</0>", wOn = "Results", kOn = "View Form", SOn = "Text STOP to opt-out of SMS messages", EOn = "Your team {{teamName}} is running low on credits", xOn = "You are running low on credits", COn = "[Action Required] Your team {{teamName}} has run out of credits", TOn = "[Action Required] You have run out of credits", AOn = "Your Cal.com team {{teamName}} is running low on credits. To avoid any disruption in service, please purchase additional credits. If your balance runs out, SMS messages will stop sending and will be sent as emails instead.", IOn = "Your Cal.com account is running low on credits. To avoid any disruption in service, please purchase additional credits. If your balance runs out, SMS messages will stop sending and will be sent as emails instead.", OOn = "Your Cal.com team {{teamName}} has run out of credits. As a result, SMS messages are now being sent via email instead. To resume sending SMS, please purchase additional credits.", NOn = "Your Cal.com account has run out of credits. As a result, SMS messages are now being sent via email instead. To resume sending SMS, please purchase additional credits.", zOn = "Current balance: {{balance}} credits", ROn = "Current balance:", POn = "Notification about your booking", DOn = "Monthly credits", LOn = "Total credits: {{totalCredits}}", MOn = "Remaining credits: {{remainingCredits}}", FOn = "Remaining", qOn = "Total", jOn = "Additional credits", VOn = "{{count}} next in queue", BOn = "Send email responses to", UOn = "Incomplete Bookings", GOn = "Include no show bookings in round robin calculations", WOn = "Recent No-Show Guests", HOn = "Shows bookings where all attendees were no-shows, not partial no-shows", YOn = "Matching", KOn = "Event Redirect", ZOn = "Reset Form", XOn = "Round Robin settings successfully updated", JOn = "Distribution basis for weighted Round Robin", QOn = "Determines which event timestamp is used as the basis for weighted round robin distribution.", eNn = "Requires credits", tNn = "You need enough credits in your account to use this feature", nNn = "Available credits", oNn = "Create role", rNn = "Roles", iNn = "Roles & Permissions", aNn = "Manage roles and permissions for your organization", sNn = "Learn more about how Permissions work", cNn = "Role name", lNn = "Role name is required", uNn = "e.g. Sales Team, Support Staff", dNn = "Role description", _Nn = "Describe what this role is for and what permissions it needs", pNn = "Default role", mNn = "Custom role", fNn = "Advanced", gNn = "Search permissions", hNn = "All permissions", vNn = "None", bNn = "Read only", yNn = "All actions on all resources", $Nn = "All Resources", wNn = "Event Types", kNn = "Teams", SNn = "Organization", ENn = "Bookings", xNn = "Insights", CNn = "Roles", TNn = "Routing Forms", ANn = "Workflows", INn = "All Actions", ONn = "Create", NNn = "View", zNn = "Edit", RNn = "Delete", PNn = "Manage", DNn = "Invite", LNn = "Remove", MNn = "Change Member Role", FNn = "List Members", qNn = "Manage Billing", jNn = "View Team Bookings", VNn = "View Organization Bookings", BNn = "View Recordings", UNn = "Impersonate", GNn = "Role created successfully", WNn = "Role updated successfully", HNn = "Delete role", YNn = "Are you sure you want to delete role: {{roleName}}. This action cannot be undone.", KNn = "Role deleted successfully", ZNn = "Error creating role", XNn = "Error updating role", JNn = "Create roles", QNn = "Attributes", ezn = "View organization attributes", tzn = "Update organization attributes", nzn = "Delete organization attributes", ozn = "Create organization attributes", rzn = "View roles", izn = "Update roles", azn = "Delete roles", szn = "Create and set up new workflows", czn = "Set up required", lzn = "View existing workflows and their configurations", uzn = "Edit and modify workflow settings", dzn = "Remove workflows from the system", _zn = "Webhook", pzn = "Availability", mzn = "Out of Office", fzn = "Blocklist", gzn = "Create webhooks", hzn = "View webhooks", vzn = "Update webhooks", bzn = "Delete webhooks", yzn = "Create availability", $zn = "View availability", wzn = "Update availability", kzn = "Delete availability", Szn = "Create out of office", Ezn = "View out of office", xzn = "Update out of office", Czn = "Delete out of office", Tzn = "Full management access to all workflows", Azn = "Create event types", Izn = "View event types", Ozn = "Update event types", Nzn = "Delete event types", zzn = "All actions on event types", Rzn = "Create teams", Pzn = "View team details", Dzn = "Update team settings", Lzn = "Delete team", Mzn = "Invite team members", Fzn = "Remove team members", qzn = "Change role of team members", jzn = "Impersonate team members", Vzn = "All actions on teams across organization teams", Bzn = "Create organization", Uzn = "View organization details", Gzn = "List organization members", Wzn = "Invite organization members", Hzn = "Remove organization members", Yzn = "Manage organization billing", Kzn = "Change role of organization members", Zzn = "Impersonate organization members", Xzn = "Edit organization settings", Jzn = "All actions on organizations", Qzn = "View bookings", eRn = "View team bookings", tRn = "View organization bookings", nRn = "View booking recordings", oRn = "Update bookings", rRn = "All actions on bookings", iRn = "View team insights", aRn = "Manage team insights", sRn = "Create routing forms", cRn = "View routing forms", lRn = "Update routing forms", uRn = "Delete routing forms", dRn = "Enable Roles & Permissions for your organization", _Rn = "Take control of your organization with customizable roles and granular permissions for your team members.", pRn = "Custom roles", mRn = "Create custom roles tailored to your organization's unique workflow", fRn = "Granular permissions", gRn = "Control exactly what team members can view, edit, and manage", hRn = "Team member assignment", vRn = "Easily assign roles to team members as your team grows", bRn = "Enhanced security", yRn = "Protect sensitive data with organization-wide security controls", $Rn = "Enable PBAC", wRn = "Successfully enabled PBAC for your organization", kRn = "Failed to enable PBAC for your organization", SRn = "Read permission is automatically enabled when creating, updating, or deleting a resource", ERn = "Add restriction schedule", xRn = "Limit availability of hosts to only display slots that fall within a specified schedule.", CRn = "Use booker's timezone", TRn = "Apply the selected restriction schedule in the booker's timezone", ARn = "This will disable Load Balancing on all your Round Robin event types", IRn = "Load Balancing is only available when the timestamp basis is set to Booking Creation Time", ORn = "Load Balancing is not available with Round Robin Groups", NRn = "Customize the default round robin settings for this team", zRn = "Round Robin settings updated successfully", RRn = "Booking creation time", PRn = "Meeting start time", DRn = "Affected members", LRn = "No members affected by disabling delegation credential", MRn = "Download Expense Log", FRn = "Error downloading expense log", qRn = "Prevent Impersonation on Bookings", jRn = "When enabled, anyone trying to book events using your email address must verify they own it via a one time code or be logged in to prevent impersonation", VRn = "Offer to reschedule last active booking to chosen time slot", BRn = "Booker maximum active booking limit exceeded", URn = "You already have a booking for this event on {{date}}. Would you like to reschedule to the new selected time?", GRn = "Duration must be at least {{min}} minute(s)", WRn = "Duration cannot exceed {{max}} minutes (24 hours)", HRn = "Booking outside restriction schedule availability.", YRn = "Restriction schedule not found", KRn = "Image size limit exceeded, please use a smaller image preferably in JPEG format", ZRn = "Add Group", XRn = "Routing Funnel", JRn = "Total Submissions", QRn = "Successful Routings", ePn = "Accepted Bookings", tPn = "License key", nPn = "Choose your license", oPn = "Select how you want to license your Cal.com deployment", rPn = "Use Cal.com under the AGPLv3 open source license", iPn = "Enter License Key", aPn = "Access to all enterprise features", sPn = "Starting at $15/user per month", cPn = "Access to all enterprise features", lPn = "Enter your license key", uPn = "Save License Key", dPn = "Signature token (optional)", _Pn = "Signature token is used to verify the license key is yours when incrementing usage based billing. You can find it in your purchase confirmation email. If you are on a legacy license, you can leave this blank.", pPn = "Need a license?", mPn = "License key is required", fPn = "Invalid license key", gPn = "Failed to validate license key", hPn = "Attachments Optional", vPn = "Send Message", bPn = "Describe the issue", yPn = "File size exceeds limit", $Pn = "Invalid file type", wPn = "Invalid file type. Accepted types: {{acceptedTypes}}", kPn = "Maximum number of files exceeded", SPn = "Files uploaded successfully", EPn = "Accepted types: {{acceptedTypes}}; Max file size: {{maxSize}}", xPn = "License key saved successfully", CPn = "You are viewing the report based on your profile timezone ({{userTimezone}}), while your browser is set to timezone ({{browserTimezone}})", TPn = "Optimized slots", APn = "Arrange time slots to optimize availability.", IPn = "Failed Bookings By Field", OPn = "Failed bookings", NPn = "No hosts are assigned to event type", zPn = "Cache Status", RPn = "Last updated: {{timestamp}}", PPn = "Delete cached data", DPn = "Cache deleted successfully", LPn = "Error deleting cache", MPn = "Are you sure you want to delete the cached data? This action cannot be undone.", FPn = "Yes, delete cache", qPn = "{{remainder}} of {{maximum}} uses left", jPn = "{{remainder}} of {{maximum}} use left", VPn = "Expires on {{date}}, end of day", BPn = "Single use", UPn = "Time-based expiration", GPn = "Usage-based expiration", WPn = "Number of uses", HPn = "Expires on", YPn = "Maximum number of uses", KPn = "Link Settings", ZPn = "This link expired on {{date}}, end of day", XPn = "Usage limit reached", JPn = "Maximum usage count must be greater than current usage count", QPn = "This link has expired", eDn = "This link can be used for bookings until the end of {{date}}", tDn = "This link can be configured to expire after a set date", nDn = "This link can be used for {{count}} booking", oDn = "This link can be configured to expire after a set number of bookings", rDn = "This link can be used for {{count}} bookings", iDn = "The name of the trigger event (e.g., BOOKING_CREATED, BOOKING_CANCELLED)", aDn = "The time of the webhook", sDn = "The event type slug", cDn = "Set up Agent", lDn = "The event type name", uDn = "The event's start time", dDn = "The event's end time", _Dn = "The event's description as described in the event type settings", pDn = "Location of the event", mDn = "The UID of the booking", fDn = "The UID for rescheduling", gDn = "Reason for cancellation", hDn = "Reason for rejection", vDn = "Name of the organizer", bDn = "Email of the organizer", yDn = "Timezone of the organizer (e.g., 'America/New_York', 'Asia/Kolkata')", $Dn = "Locale of the organizer (e.g., 'en', 'fr')", wDn = "Username of the organizer (e.g., 'john.doe')", kDn = "Username of the organizer in their organization (e.g., 'john.doe')", SDn = "Name of the first attendee", EDn = "Email of the first attendee", xDn = "Timezone of the first attendee", CDn = "Locale of the first attendee", TDn = "Name of the team booked", ADn = "Members of the team booked", IDn = "Video call URL for the meeting", ODn = "Hide variables", NDn = "Show available variables", zDn = "Event and Booking", RDn = "People", PDn = "Teams", DDn = "Metadata", LDn = "Stats", MDn = "Booking status", FDn = "When routing form is submitted", qDn = "When routing form is submitted and no booking is created", jDn = "How long after the form was submitted?", VDn = "Visit", BDn = "Custom label on booking page", UDn = "Meeting link", GDn = "Session Outcome", WDn = "Call Created", HDn = "Voicemail", YDn = "My Bookings", KDn = "Phone", ZDn = "Free", XDn = "User Email", JDn = "User Name", QDn = "Expand Panel", e3n = "Collapse Panel", t3n = "Email verification is required for this event type", n3n = "Invalid verification code provided", o3n = "You have one team", r3n = "Consider setting up an organization to unify billing, admin tools, and analytics across your team.", i3n = "Consider setting up an organization to unify billing, admin tools, and analytics across your teams.", a3n = "Message Sent", s3n = "Thank you for contacting us. We'll get back to you as soon as possible.", c3n = "Search variables", l3n = "Please describe the issue you're facing, e.g. 'Busy slots are marked available', ..., etc.", u3n = "Send another message", d3n = "Sending", _3n = "No variables found", p3n = "Credits Required", m3n = "Web calls consume credits. Make sure you have enough credits to start a call.", f3n = "Web calls require credits. You have 0 credits remaining.", g3n = "Purchase Credits", h3n = "This action requires credits to proceed", v3n = "Name must not exceed {{max}} characters", b3n = "Auto charge no-show fee for last minute cancellations", y3n = "Before scheduled start time", $3n = "I acknowledge that by cancelling the booking within {{timeValue}} {{timeUnit}} of the start time I will be charged the no show fee of {{amount, currency}}", w3n = "If you have any questions, please contact the organizer.", k3n = "Booking time", S3n = "When the booking is scheduled (start to end)", E3n = "Created at", x3n = "When the booking was originally created", C3n = "Call Details", T3n = "Call ID", A3n = "Call Information", I3n = "Sentiment", O3n = "Disconnect Reason", N3n = "Call Summary", z3n = "Transcription", R3n = "Event Details", P3n = "Agent", D3n = "No transcript available", L3n = "When testing this workflow, be aware that SMS need to be scheduled at least 15 minutes in advance", M3n = "Start from scratch", F3n = "Create your own workflow from scratch.", q3n = "Cal.ai template", j3n = "AI agents that book meetings, send reminders, and follow up!", V3n = "Voice", B3n = "Select Voice", U3n = "Select a voice for your agent", G3n = "Choose a voice for your agent", W3n = "Trait", H3n = "Voice ID", Y3n = "Use Voice", K3n = "Current Voice", Z3n = "Set up incoming agent", X3n = "Configure an AI agent to handle incoming calls on your phone number", J3n = "Connect a Phone Number first", Q3n = "Set up Agent for incoming calls", eLn = "Configure agent to handle incoming calls", tLn = "Incoming Calls", nLn = "Outgoing Calls", oLn = "Both Email and Attendee Phone Number cannot be hidden", rLn = "At least Email or Attendee Phone Number must be a required field", iLn = "Attendee Phone Number must be required when Email is hidden", aLn = "Email must be required when Attendee Phone Number is hidden", sLn = "Inbound agent setup successful", cLn = "Inbound agent configured", lLn = "Set up Inbound Agent", uLn = "Please select an event type first", dLn = "Edit Configuration", _Ln = "Inbound calls can book only one event type. Select the event type where meetings will be scheduled when callers reach your agent.", pLn = "Set up inbound agent for incoming calls", mLn = "Create Block Entry", fLn = "Blocklist Entry Details", gLn = "Blocklist entry not found", hLn = "Blocklist entry created successfully", vLn = "Blocklist entry deleted successfully", bLn = "Audit History", yLn = "No audit history available", $Ln = "Delete Blocklist Entry", wLn = 'Are you sure you want to remove "{{value}}" from the blocklist? This action cannot be undone.', kLn = "Created By", SLn = "Blocked By", ELn = "By", xLn = "Added", CLn = "No description provided", TLn = "Organization Blocklist", ALn = "Manage blocked emails and domains for your organization", ILn = "Invalid domain format. Example: example.com", OLn = "Invalid email address. Example: user@example.com", NLn = "Reason for adding to blocklist", zLn = "What would you like to block?", RLn = "Domain Name", PLn = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Add your new strings above here ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", Tx = {
  identity_provider: vNt,
  trial_days_left: bNt,
  day_one: yNt,
  day_other: $Nt,
  second_one: wNt,
  second_other: kNt,
  upgrade_now: SNt,
  untitled: ENt,
  accept_invitation: xNt,
  max_characters: CNt,
  min_characters: TNt,
  calcom_explained: ANt,
  calcom_explained_new_user: INt,
  have_any_questions: ONt,
  reset_password_subject: NNt,
  verify_email_subject: zNt,
  verify_email_subject_verifying_email: RNt,
  check_your_email: PNt,
  old_email_address: DNt,
  new_email_address: LNt,
  verify_email_page_body: MNt,
  verify_email_banner_body: FNt,
  verify_email_email_header: qNt,
  verify_email_button: jNt,
  cal_ai_assistant: VNt,
  send_cal_video_transcription_emails: BNt,
  description_send_cal_video_transcription_emails: UNt,
  verify_email_change_description: GNt,
  verify_email_change_success_toast: WNt,
  verify_email_change_failure_toast: HNt,
  change_of_email: YNt,
  change_of_email_toast: KNt,
  copy_somewhere_safe: ZNt,
  verify_email_email_body: XNt,
  verify_email_by_code_email_body: JNt,
  verify_email_email_link_text: QNt,
  email_verification_code: ezt,
  email_verification_code_placeholder: tzt,
  incorrect_email_verification_code: nzt,
  email_sent: ozt,
  email_not_sent: rzt,
  event_declined_subject: izt,
  event_cancelled_subject: azt,
  event_reassigned_subject: szt,
  event_request_declined: czt,
  customize_calvideo_settings: lzt,
  calvideo_settings_description: uzt,
  disable_recording_for_guests: dzt,
  enable_automatic_transcription: _zt,
  enable_automatic_recording: pzt,
  video_options: mzt,
  edit_event: fzt,
  view_session_details: gzt,
  meeting_session_details: hzt,
  meeting_session: vzt,
  session_id: bzt,
  max_participants: yzt,
  unlimited: $zt,
  ongoing: wzt,
  ended: kzt,
  participants: Szt,
  anonymous_user: Ezt,
  session_duration: xzt,
  no_meeting_sessions_found: Czt,
  not_available: Tzt,
  disable_recording_for_organizer: Azt,
  disable_transcription_for_guests: Izt,
  disable_transcription_for_organizer: Ozt,
  event_request_declined_recurring: Nzt,
  event_request_cancelled: zzt,
  event_request_reassigned: Rzt,
  event_reassigned_subtitle: Pzt,
  organizer: Dzt,
  reassigned_to: Lzt,
  need_to_reschedule_or_cancel: Mzt,
  you_can_view_booking_details_with_this_url: Fzt,
  no_options_available: qzt,
  cancellation_reason: jzt,
  cancelled_by: Vzt,
  cancellation_reason_host: Bzt,
  cancellation_reason_placeholder: Uzt,
  notify_attendee_cancellation_reason_warning: Gzt,
  rejection_reason_placeholder: Wzt,
  rejection_reason: Hzt,
  rejection_reason_title: Yzt,
  rejection_reason_description: Kzt,
  rejection_confirmation: Zzt,
  report_booking_description: Xzt,
  report_reason_spam: Jzt,
  report_reason_dont_know_person: Qzt,
  report_reason_other: eRt,
  cancel_booking_when_reporting: tRt,
  report_all_remaining_bookings: nRt,
  submit_report: oRt,
  report_booking_description_placeholder: rRt,
  manage_this_event: iRt,
  invite_team_member: aRt,
  invite_team_individual_segment: sRt,
  invite_team_bulk_segment: cRt,
  invite_team_notifcation_badge: lRt,
  your_event_has_been_scheduled: uRt,
  your_event_has_been_scheduled_recurring: dRt,
  accept_our_license: _Rt,
  remove_banner_instructions: pRt,
  error_message: mRt,
  refund_failed_subject: fRt,
  refund_failed: gRt,
  check_with_provider_and_user: hRt,
  a_refund_failed: vRt,
  awaiting_payment_subject: bRt,
  meeting_awaiting_payment: yRt,
  dark_theme_contrast_error: $Rt,
  light_theme_contrast_error: wRt,
  event_type_color_light_theme_contrast_error: kRt,
  event_type_color_dark_theme_contrast_error: SRt,
  payment_not_created_error: ERt,
  couldnt_charge_card_error: xRt,
  no_available_users_found_error: CRt,
  timeslot_unavailable_book_a_new_time: TRt,
  timeslot_unavailable_short: ARt,
  just_connected_description: IRt,
  unavailable_timeslot_title: ORt,
  booking_time_out_of_bounds_error: NRt,
  request_body_end_time_internal_error: zRt,
  create_calendar_event_error: RRt,
  update_calendar_event_error: PRt,
  delete_calendar_event_error: DRt,
  already_signed_up_for_this_booking_error: LRt,
  hosts_unavailable_for_booking: MRt,
  fixed_hosts_unavailable_for_booking: FRt,
  round_robin_host_unavailable_for_booking: qRt,
  help: jRt,
  price: VRt,
  paid: BRt,
  refunded: URt,
  record: GRt,
  transcribe: WRt,
  payment: HRt,
  missing_card_fields: YRt,
  pay_now: KRt,
  general_prompt: ZRt,
  transcription_powered_by_ai: XRt,
  start_or_stop_recording: JRt,
  begin_message: QRt,
  codebase_has_to_stay_opensource: ePt,
  cannot_repackage_codebase: tPt,
  acquire_license: nPt,
  terms_summary: oPt,
  open_env: rPt,
  env_changed: iPt,
  accept_license: aPt,
  still_waiting_for_approval: sPt,
  event_is_still_waiting: cPt,
  no_result_found_for: lPt,
  no_more_results: uPt,
  no_results: dPt,
  load_more_results: _Pt,
  integration_meeting_id: pPt,
  confirmed_event_type_subject: mPt,
  new_event_request: fPt,
  confirm_or_reject_request: gPt,
  check_bookings_page_to_confirm_or_reject: hPt,
  check_in_assistant: vPt,
  check_in_assistant_description: bPt,
  create_your_own_prompt: yPt,
  event_awaiting_approval: $Pt,
  event_awaiting_approval_recurring: wPt,
  someone_requested_an_event: kPt,
  someone_requested_password_reset: SPt,
  password_reset_email_sent: EPt,
  password_reset_instructions: xPt,
  event_awaiting_approval_subject: CPt,
  event_still_awaiting_approval: TPt,
  booking_submitted_subject: APt,
  download_recording_subject: IPt,
  download_transcript_email_subject: OPt,
  download_your_recording: NPt,
  download_your_transcripts: zPt,
  your_meeting_has_been_booked: RPt,
  event_type_has_been_rescheduled_on_time_date: PPt,
  event_type_has_been_updated: DPt,
  event_has_been_rescheduled: LPt,
  event_has_been_updated: MPt,
  your_event_has_been_rescheduled: FPt,
  request_reschedule_subtitle: qPt,
  request_reschedule_title_organizer: jPt,
  request_reschedule_subtitle_organizer: VPt,
  rescheduled_event_type_subject: BPt,
  requested_to_reschedule_subject_attendee: UPt,
  hi_user_name: GPt,
  ics_event_title: WPt,
  please_book_a_time_sometime_later: HPt,
  schedule_instead: YPt,
  new_event_subject: KPt,
  join_by_entrypoint: ZPt,
  notes: XPt,
  manage_my_bookings: JPt,
  need_to_make_a_change: QPt,
  new_event_scheduled: eDt,
  new_event_scheduled_recurring: tDt,
  invitee_email: nDt,
  invitee_timezone: oDt,
  time_left: rDt,
  event_type: iDt,
  duplicate_event_type: aDt,
  enter_meeting: sDt,
  video_call_provider: cDt,
  meeting_id: lDt,
  meeting_password: uDt,
  meeting_url: dDt,
  meeting_url_not_found: _Dt,
  token_not_found: pDt,
  some_other_host_already_accepted_the_meeting: mDt,
  meeting_request_rejected: fDt,
  rejected_event_type_with_organizer: gDt,
  hi: hDt,
  join_team: vDt,
  manage_this_team: bDt,
  team_info: yDt,
  join_meeting: $Dt,
  request_another_invitation_email: wDt,
  you_have_been_invited: kDt,
  user_invited_you: SDt,
  hidden_team_member_title: EDt,
  hidden_team_member_message: xDt,
  hidden_team_owner_message: CDt,
  link_expires: TDt,
  upgrade_to_per_seat: ADt,
  seat_options_doesnt_support_confirmation: IDt,
  multilocation_doesnt_support_seats: ODt,
  no_show_fee_doesnt_support_seats: NDt,
  seats_option_doesnt_support_multi_location: zDt,
  team_upgrade_seats_details: RDt,
  team_upgrade_banner_description: PDt,
  upgrade_banner_action: DDt,
  team_upgraded_successfully: LDt,
  org_upgrade_banner_description: MDt,
  org_upgraded_successfully: FDt,
  use_link_to_reset_password: qDt,
  hey_there: jDt,
  there: VDt,
  forgot_your_password_calcom: BDt,
  delete_webhook_confirmation_message: UDt,
  confirm_delete_webhook: GDt,
  edit_webhook: WDt,
  delete_webhook: HDt,
  webhook_status: YDt,
  webhook_enabled: KDt,
  webhook_disabled: ZDt,
  webhook_response: XDt,
  webhook_test: JDt,
  webhook_update_form: QDt,
  webhook_update_form_description: e3t,
  manage_your_webhook: t3t,
  webhook_created_successfully: n3t,
  webhook_updated_successfully: o3t,
  webhook_removed_successfully: r3t,
  subscription_needed: i3t,
  subscription_needed_description: a3t,
  payload_template: s3t,
  dismiss: c3t,
  no_data_yet: l3t,
  ping_test: u3t,
  add_to_homescreen: d3t,
  upcoming: _3t,
  recurring: p3t,
  past: m3t,
  choose_a_file: f3t,
  upload_image: g3t,
  upload_target: h3t,
  no_target: v3t,
  slide_zoom_drag_instructions: b3t,
  view_notifications: y3t,
  view_public_page: $3t,
  copy_public_page_link: w3t,
  copy_referral_link: k3t,
  sign_out: S3t,
  add_another: E3t,
  install_another: x3t,
  until: C3t,
  powered_by: T3t,
  unavailable: A3t,
  set_work_schedule: I3t,
  change_bookings_availability: O3t,
  select: N3t,
  "2fa_confirm_current_password": "Confirm your current password to get started.",
  "2fa_scan_image_or_use_code": "Scan the image below with the authenticator app on your phone or manually enter the text code instead.",
  text: z3t,
  your_phone_number: R3t,
  multiline_text: P3t,
  number: D3t,
  checkbox: L3t,
  is_required: M3t,
  make_field_required: F3t,
  required: q3t,
  optional: j3t,
  input_type: V3t,
  rejected: B3t,
  unconfirmed: U3t,
  guests: G3t,
  guest: W3t,
  web_conferencing_details_to_follow: H3t,
  confirmation: Y3t,
  what_booker_should_provide: K3t,
  "404_the_user": "The username",
  username: Z3t,
  is_still_available: X3t,
  documentation: J3t,
  documentation_description: Q3t,
  api_reference: eLt,
  api_reference_description: tLt,
  blog: nLt,
  blog_description: oLt,
  join_our_community: rLt,
  "404_claim_entity_user": "Claim your username and schedule events",
  popular_pages: iLt,
  register_now: aLt,
  register: sLt,
  page_doesnt_exist: cLt,
  no_active_phone_number_available: lLt,
  workflow_step_not_configured: uLt,
  check_spelling_mistakes_or_go_back: dLt,
  "404_page_not_found": "404: This page could not be found.",
  booker_event_not_found: _Lt,
  getting_started: pLt,
  "15min_meeting": "15 Min Meeting",
  "30min_meeting": "30 Min Meeting",
  secret: mLt,
  leave_blank_to_remove_secret: fLt,
  webhook_secret_key_description: gLt,
  secret_meeting: hLt,
  login_instead: vLt,
  create_account: bLt,
  get_started: yLt,
  confirm_password: $Lt,
  reset_your_password: wLt,
  org_banner_instructions: kLt,
  email_change: SLt,
  create_your_account: ELt,
  create_your_calcom_account: xLt,
  sign_up: CLt,
  youve_been_logged_out: TLt,
  hope_to_see_you_soon: ALt,
  logged_out: ILt,
  please_try_again_and_contact_us: OLt,
  incorrect_2fa_code: NLt,
  no_account_exists: zLt,
  "2fa_enabled_instructions": "Two-factor authentication enabled. Please enter the six-digit code from your authenticator app.",
  "2fa_enter_six_digit_code": "Enter the six-digit code from your authenticator app below.",
  create_an_account: RLt,
  dont_have_an_account: PLt,
  "2fa_code": "Two-Factor Code",
  sign_in_account: DLt,
  sign_in: LLt,
  go_back_login: MLt,
  error_during_login: FLt,
  request_password_reset: qLt,
  send_invite: jLt,
  forgot_password: VLt,
  forgot: BLt,
  done: ULt,
  all_done: GLt,
  all: WLt,
  yours: HLt,
  available_apps: YLt,
  available_apps_lower_case: KLt,
  available_apps_desc: ZLt,
  fixed_host_helper: XLt,
  round_robin_groups_helper: JLt,
  round_robin_helper: QLt,
  check_email_reset_password: eMt,
  finish: tMt,
  organization_general_description: nMt,
  few_sentences_about_yourself: oMt,
  nearly_there: rMt,
  nearly_there_instructions: iMt,
  set_availability_instructions: aMt,
  set_availability: sMt,
  set_availbility_description: cMt,
  share_a_link_or_embed: lMt,
  share_a_link_or_embed_description: uMt,
  availability_settings: dMt,
  continue_without_calendar: _Mt,
  continue_with: pMt,
  connect_your_calendar: mMt,
  connect_your_video_app: fMt,
  connect_your_video_app_instructions: gMt,
  connect_your_calendar_instructions: hMt,
  set_up_later: vMt,
  current_time: bMt,
  details: yMt,
  welcome: $Mt,
  welcome_back: wMt,
  welcome_to_calcom: kMt,
  welcome_instructions: SMt,
  connect_caldav: EMt,
  connect_ics_feed: xMt,
  connect: CMt,
  try_for_free: TMt,
  create_booking_link_with_calcom: AMt,
  who: IMt,
  what: OMt,
  when: NMt,
  where: zMt,
  add_to_calendar: RMt,
  add_to_calendar_description: PMt,
  add_events_to: DMt,
  add_another_calendar: LMt,
  other: MMt,
  email_sign_in_subject: FMt,
  round_robin_emailed_you_and_attendees: qMt,
  round_robin_emailed_host_and_attendee: jMt,
  emailed_host_and_attendee: VMt,
  emailed_host_and_attendee_recurring: BMt,
  round_robin_emailed_you_and_attendees_recurring: UMt,
  round_robin_emailed_host_and_attendee_recurring: GMt,
  emailed_you_and_any_other_attendees: WMt,
  needs_to_be_confirmed_or_rejected: HMt,
  needs_to_be_confirmed_or_rejected_recurring: YMt,
  user_needs_to_confirm_or_reject_booking: KMt,
  user_needs_to_confirm_or_reject_booking_recurring: ZMt,
  meeting_is_scheduled: XMt,
  meeting_is_scheduled_recurring: JMt,
  booking_submitted: QMt,
  booking_submitted_recurring: e4t,
  booking_confirmed: t4t,
  booking_confirmed_recurring: n4t,
  warning_recurring_event_payment: o4t,
  warning_payment_recurring_event: r4t,
  enter_new_password: i4t,
  reset_password: a4t,
  change_your_password: s4t,
  show_password: c4t,
  hide_password: l4t,
  try_again: u4t,
  request_is_expired: d4t,
  reset_instructions: _4t,
  request_is_expired_instructions: p4t,
  whoops: m4t,
  login: f4t,
  success: g4t,
  failed: h4t,
  password_has_been_reset_login: v4t,
  layout: b4t,
  bookerlayout_default_title: y4t,
  bookerlayout_description: $4t,
  bookerlayout_user_settings_title: w4t,
  bookerlayout_user_settings_description: k4t,
  bookerlayout_month_view: S4t,
  bookerlayout_week_view: E4t,
  bookerlayout_column_view: x4t,
  bookerlayout_error_min_one_enabled: C4t,
  bookerlayout_error_default_not_enabled: T4t,
  bookerlayout_error_unknown_layout: A4t,
  bookerlayout_override_global_settings: I4t,
  unexpected_error_try_again: O4t,
  sunday_time_error: N4t,
  monday_time_error: z4t,
  tuesday_time_error: R4t,
  wednesday_time_error: P4t,
  thursday_time_error: D4t,
  friday_time_error: L4t,
  saturday_time_error: M4t,
  error_end_time_before_start_time: F4t,
  error_end_time_next_day: q4t,
  back_to_bookings: j4t,
  free_to_pick_another_event_type: V4t,
  cancelled: B4t,
  no_booking: U4t,
  awaiting_host: G4t,
  cancellation_successful: W4t,
  really_cancel_booking: H4t,
  cannot_cancel_booking: Y4t,
  reschedule_instead: K4t,
  event_is_in_the_past: Z4t,
  cancelling_event_recurring: X4t,
  cancelling_all_recurring: J4t,
  error_with_status_code_occured: Q4t,
  error_event_type_url_duplicate: e5t,
  error_event_type_unauthorized_create: t5t,
  error_event_type_unauthorized_update: n5t,
  error_workflow_unauthorized_create: o5t,
  error_schedule_unauthorized_create: r5t,
  booking_already_cancelled: i5t,
  booking_already_accepted_rejected: a5t,
  go_back_home: s5t,
  or_go_back_home: c5t,
  no_meeting_found: l5t,
  no_meeting_found_description: u5t,
  no_status_bookings_yet: d5t,
  no_status_bookings_yet_description: _5t,
  event_between_users: p5t,
  bookings: m5t,
  booking_not_found: f5t,
  bookings_description: g5t,
  upcoming_bookings: h5t,
  recurring_bookings: v5t,
  past_bookings: b5t,
  cancelled_bookings: y5t,
  unconfirmed_bookings: $5t,
  unconfirmed_bookings_tooltip: w5t,
  on: k5t,
  and: S5t,
  calendar_shows_busy_between: E5t,
  troubleshoot: x5t,
  troubleshoot_description: C5t,
  overview_of_day: T5t,
  hover_over_bold_times_tip: A5t,
  start_time: I5t,
  end_time: O5t,
  buffer_time: N5t,
  before_event: z5t,
  after_event: R5t,
  event_buffer_default: P5t,
  buffer: D5t,
  your_day_starts_at: L5t,
  your_day_ends_at: M5t,
  launch_troubleshooter: F5t,
  troubleshoot_availability: q5t,
  change_available_times: j5t,
  change_your_available_times: V5t,
  change_start_end: B5t,
  change_start_end_buffer: U5t,
  current_start_date: G5t,
  start_end_changed_successfully: W5t,
  and_end_at: H5t,
  light: Y5t,
  dark: K5t,
  automatically_adjust_theme: Z5t,
  user_dynamic_booking_disabled: X5t,
  allow_dynamic_booking_tooltip: J5t,
  allow_dynamic_booking: Q5t,
  dynamic_booking: e6t,
  allow_seo_indexing: t6t,
  seo_indexing: n6t,
  allow_browser_notifications: o6t,
  you_have_denied_notifications: r6t,
  disable_browser_notifications: i6t,
  browser_notifications_turned_on: a6t,
  browser_notifications_turned_off: s6t,
  browser_notifications_denied: c6t,
  please_allow_notifications: l6t,
  push_notifications: u6t,
  push_notifications_description: d6t,
  browser_notifications_not_supported: _6t,
  email: p6t,
  email_placeholder: m6t,
  full_name: f6t,
  browse_api_documentation: g6t,
  leverage_our_api: h6t,
  create_webhook: v6t,
  instant_meeting: b6t,
  booking_cancelled: y6t,
  booking_rescheduled: $6t,
  recording_ready: w6t,
  recording_transcription_generated: k6t,
  booking_created: S6t,
  booking_rejected: E6t,
  booking_requested: x6t,
  booking_payment_initiated: C6t,
  meeting_ended: T6t,
  form_submitted: A6t,
  form_submitted_no_event: I6t,
  booking_paid: O6t,
  ooo_created: N6t,
  booking_no_show_updated: z6t,
  event_triggers: R6t,
  subscriber_url: P6t,
  create_new_webhook: D6t,
  webhooks: L6t,
  team_webhooks: M6t,
  create_new_webhook_to_account: F6t,
  new_webhook: q6t,
  receive_cal_meeting_data: j6t,
  receive_cal_event_meeting_data: V6t,
  responsive_fullscreen_iframe: B6t,
  loading: U6t,
  deleting: G6t,
  standard_iframe: W6t,
  developer: H6t,
  manage_developer_settings: Y6t,
  iframe_embed: K6t,
  embed_calcom: Z6t,
  integrate_using_embed_or_webhooks: X6t,
  schedule_a_meeting: J6t,
  view_and_manage_billing_details: Q6t,
  view_and_edit_billing_details: eFt,
  go_to_billing_portal: tFt,
  need_anything_else: nFt,
  further_billing_help: oFt,
  contact: rFt,
  our_support_team: iFt,
  contact_our_support_team: aFt,
  uh_oh: sFt,
  no_event_types_have_been_setup: cFt,
  edit_logo: lFt,
  upload_a_logo: uFt,
  upload_logo: dFt,
  remove_logo: _Ft,
  enable: pFt,
  code: mFt,
  code_is_incorrect: fFt,
  add_time_availability: gFt,
  add_an_extra_layer_of_security: hFt,
  "2fa": "Two-Factor Authentication",
  "2fa_disabled": "Two-Factor authentication can only be enabled for email and password authentication",
  enable_2fa: vFt,
  disable_2fa: bFt,
  disable_2fa_recommendation: yFt,
  error_disabling_2fa: $Ft,
  error_enabling_2fa: wFt,
  security: kFt,
  manage_account_security: SFt,
  password: EFt,
  password_updated_successfully: xFt,
  password_has_been_changed: CFt,
  error_changing_password: TFt,
  session_timeout_changed: AFt,
  session_timeout_change_error: IFt,
  something_went_wrong: OFt,
  something_doesnt_look_right: NFt,
  please_try_again: zFt,
  super_secure_new_password: RFt,
  new_password: PFt,
  your_old_password: DFt,
  current_password: LFt,
  change_password: MFt,
  change_secret: FFt,
  new_password_matches_old_password: qFt,
  forgotten_secret_description: jFt,
  current_incorrect_password: VFt,
  password_hint_caplow: BFt,
  password_hint_min: UFt,
  password_hint_admin_min: GFt,
  password_hint_num: WFt,
  max_limit_allowed_hint: HFt,
  invalid_password_hint: YFt,
  incorrect_password: KFt,
  incorrect_email_password: ZFt,
  use_setting: XFt,
  am_pm: JFt,
  time_options: QFt,
  january: eqt,
  february: tqt,
  march: nqt,
  april: oqt,
  may: rqt,
  june: iqt,
  july: aqt,
  august: sqt,
  september: cqt,
  october: lqt,
  november: uqt,
  december: dqt,
  monday: _qt,
  tuesday: pqt,
  wednesday: mqt,
  thursday: fqt,
  friday: gqt,
  saturday: hqt,
  sunday: vqt,
  all_booked_today: bqt,
  slots_load_fail: yqt,
  additional_guests: $qt,
  your_name: wqt,
  your_full_name: kqt,
  no_name: Sqt,
  enter_number_between_range: Eqt,
  continue_as_guest_description: xqt,
  email_address: Cqt,
  enter_valid_email: Tqt,
  please_schedule_future_call: Aqt,
  location: Iqt,
  address: Oqt,
  enter_address: Nqt,
  in_person_attendee_address: zqt,
  somewhere_else: Rqt,
  custom_attendee_location: Pqt,
  continue_as_guest: Dqt,
  join_as_guest: Lqt,
  ideal_for_one_time_calls: Mqt,
  any_location: Fqt,
  yes: qqt,
  no: jqt,
  additional_notes: Vqt,
  booking_fail: Bqt,
  reschedule_fail: Uqt,
  share_additional_notes: Gqt,
  booking_confirmation: Wqt,
  booking_reschedule_confirmation: Hqt,
  in_person_meeting: Yqt,
  in_person: Kqt,
  link_meeting: Zqt,
  phone_number: Xqt,
  attendee_phone_number: Jqt,
  organizer_phone_number: Qqt,
  enter_phone_number: ejt,
  reschedule: tjt,
  reschedule_this: njt,
  book_a_team_member: ojt,
  or: rjt,
  go_back: ijt,
  email_or_username: ajt,
  send_invite_email: sjt,
  role: cjt,
  edit_role: ljt,
  view_role: ujt,
  edit_team: djt,
  editing_user: _jt,
  editing_org: pjt,
  edit_or_manage_webhooks: mjt,
  reject: fjt,
  reject_all: gjt,
  accept: hjt,
  leave: vjt,
  profile: bjt,
  my_team_url: yjt,
  my_teams: $jt,
  team_name: wjt,
  your_team_name: kjt,
  team_updated_successfully: Sjt,
  your_team_updated_successfully: Ejt,
  your_org_updated_successfully: xjt,
  error_copying_to_clipboard: Cjt,
  about: Tjt,
  team_description: Ajt,
  organization_id: Ijt,
  organization_id_copied: Ojt,
  org_description: Njt,
  team_id: zjt,
  team_id_copied: Rjt,
  members: Pjt,
  organization_members: Djt,
  member: Ljt,
  number_member_one: Mjt,
  number_member_other: Fjt,
  number_selected: qjt,
  owner: jjt,
  admin: Vjt,
  admin_api: Bjt,
  administrator_user: Ujt,
  lets_create_first_administrator_user: Gjt,
  admin_user_created: Wjt,
  admin_user_created_description: Hjt,
  new_member: Yjt,
  invite: Kjt,
  add_team_members: Zjt,
  add_org_members: Xjt,
  add_team_members_description: Jjt,
  add_team_member: Qjt,
  invite_new_member: eVt,
  invite_new_member_description: tVt,
  invite_new_team_member: nVt,
  upload_csv_file: oVt,
  invite_via_email: rVt,
  change_member_role: iVt,
  disable_cal_branding: aVt,
  disable_cal_branding_description: sVt,
  hide_book_a_team_member: cVt,
  hide_book_a_team_member_description: lVt,
  danger_zone: uVt,
  account_deletion_cannot_be_undone: dVt,
  team_deletion_cannot_be_undone: _Vt,
  back: pVt,
  cancel: mVt,
  cancel_all_remaining: fVt,
  apply: gVt,
  cancel_event: hVt,
  report_booking: vVt,
  report_booking_will_cancel_description: bVt,
  add_to_report: yVt,
  reported: $Vt,
  continue: "Continue",
  confirm: wVt,
  confirm_all: kVt,
  disband_team: SVt,
  disband_team_confirmation_message: EVt,
  disband_org: xVt,
  disband_org_confirmation_message: CVt,
  remove_member_confirmation_message: TVt,
  confirm_disband_team: AVt,
  confirm_remove_member: IVt,
  confirm_subscription_cancellation: OVt,
  cancel_subscription: NVt,
  cancel_subscription_description: zVt,
  remove_member: RVt,
  manage_your_team: PVt,
  no_teams: DVt,
  no_teams_description: LVt,
  submit: MVt,
  confirm_remove_attribute: FVt,
  remove_attribute: qVt,
  remove_attribute_confirmation_message: jVt,
  delete: "Delete",
  view: VVt,
  update: BVt,
  save: UVt,
  pending: GVt,
  open_options: WVt,
  copy_link: HVt,
  share: YVt,
  share_event: KVt,
  copy_link_team: ZVt,
  leave_team: XVt,
  confirm_leave_team: JVt,
  leave_team_confirmation_message: QVt,
  user_from_team: eBt,
  preview: tBt,
  link_copied: nBt,
  copied: oBt,
  private_link_copied: rBt,
  link_shared: iBt,
  title: aBt,
  description: sBt,
  apps_status: cBt,
  quick_video_meeting: lBt,
  scheduling_type: uBt,
  preview_team: dBt,
  collective: _Bt,
  collective_description: pBt,
  duration: mBt,
  available_durations: fBt,
  default_duration: gBt,
  default_duration_no_options: hBt,
  multiple_duration_mins: vBt,
  multiple_duration_timeUnit: bBt,
  multiple_duration_timeUnit_short: yBt,
  minutes: $Bt,
  use_cal_ai_to_make_call_description: wBt,
  termination_uri: kBt,
  sip_trunk_username: SBt,
  sip_trunk_password: EBt,
  nickname: xBt,
  delete_phone_number: CBt,
  workflow_validation_failed: TBt,
  workflow_validation_empty_fields: ABt,
  workflow_validation_unverified_contacts: IBt,
  supercharge_your_workflows_with_cal_ai: OBt,
  supercharge_your_workflows_with_cal_ai_description: NBt,
  phone_number_imported_successfully: zBt,
  phone_number_deleted_successfully: RBt,
  delete_phone_number_confirmation: PBt,
  yes_delete_phone_number: DBt,
  phone_number_info_tooltip: LBt,
  termination_uri_info_tooltip: MBt,
  sip_trunk_username_info_tooltip: FBt,
  sip_trunk_password_info_tooltip: qBt,
  nickname_info_tooltip: jBt,
  save_and_test_call: VBt,
  call_initiated_successfully: BBt,
  please_enter_phone_number: UBt,
  agent_updated_successfully: GBt,
  agent_created_successfully: WBt,
  agent_event_type_updated_successfully: HBt,
  phone_number_unsubscribed_successfully: YBt,
  general_prompt_description: KBt,
  prompt: ZBt,
  call_to: XBt,
  make_test_call_to_verify_configuration: JBt,
  initial_message: QBt,
  initial_message_description: e9t,
  having_trouble_importing: t9t,
  learn: n9t,
  learn_how_to_get_your_terminator: o9t,
  phone_number_subscription_cancelled_successfully: r9t,
  updating: i9t,
  round_robin: a9t,
  hi_how_are_you_doing: s9t,
  round_robin_description: c9t,
  managed_event: l9t,
  username_placeholder: u9t,
  managed_event_description: d9t,
  managed: _9t,
  managed_event_url_clarification: p9t,
  assign_to: m9t,
  enter_phone_number_to_test_call: f9t,
  make_test_call: g9t,
  create_new_workflow_agent: h9t,
  create_new_workflow_agent_description: v9t,
  phone_number_for_ai_call: b9t,
  buy_a_phone_number_or_import_one_you_already_have: y9t,
  test_agent: $9t,
  test_web_call: w9t,
  phone_numbers: k9t,
  unsubscribe: S9t,
  delete_workflow_step: E9t,
  unsubscribe_phone_number: x9t,
  buy_a_new_number: C9t,
  only_us_phone_numbers_can_be_purchased_here: T9t,
  buy_number_for_x_per_month: A9t,
  supported_call_destinations: I9t,
  no_phone_number_connected: O9t,
  failed_to_get_workflow_step_id: N9t,
  cal_ai_agent: z9t,
  test_cal_ai_agent: R9t,
  are_you_sure_you_want_to_delete_workflow_step: P9t,
  do_you_still_want_to_unsubscribe: D9t,
  the_action_will_disconnect_phone_number: L9t,
  cal_ai_phone_numbers: M9t,
  connect_phone_number: F9t,
  cal_ai_phone_numbers_description: q9t,
  import_number: j9t,
  this_action_will_also: V9t,
  import_phone_number: B9t,
  active_subscription: U9t,
  cancel_your_phone_number_subscription: G9t,
  delete_associated_phone_number: W9t,
  unauthorized_create_workflow: H9t,
  import_phone_number_description: Y9t,
  phone_number_cost: K9t,
  buy_new_number: Z9t,
  buy_number_cost_x_per_month: X9t,
  area_code_optional: J9t,
  no_phone_numbers: Q9t,
  phone_number_purchased_successfully: eUt,
  cancel_phone_number_subscription: tUt,
  yes_cancel_subscription: nUt,
  cancel_phone_number_subscription_confirmation: oUt,
  add_members: rUt,
  add_members_no_ellipsis: iUt,
  no_assigned_members: aUt,
  assigned_to: sUt,
  you_must_be_logged_in_to: cUt,
  start_assigning_members_above: lUt,
  locked_fields_admin_description: uUt,
  unlocked_fields_admin_description: dUt,
  locked_fields_member_description: _Ut,
  unlocked_fields_member_description: pUt,
  url: mUt,
  hidden: fUt,
  readonly: gUt,
  one_time_link: hUt,
  plan_description: vUt,
  plan_upgrade_invitation: bUt,
  plan_upgrade: yUt,
  plan_upgrade_teams: $Ut,
  plan_upgrade_instructions: wUt,
  event_types_page_title: kUt,
  event_types_page_subtitle: SUt,
  new: "New",
  new_event_type_btn: EUt,
  new_event_type_heading: xUt,
  new_event_type_description: CUt,
  event_type_created_successfully: TUt,
  event_type_updated_successfully: AUt,
  event_type_deleted_successfully: IUt,
  hours: OUt,
  people: NUt,
  your_email: zUt,
  change_avatar: RUt,
  upload_avatar: PUt,
  language: DUt,
  timezone: LUt,
  first_day_of_week: MUt,
  repeats_up_to_one: FUt,
  repeats_up_to_other: qUt,
  every_for_freq: jUt,
  event_remaining_one: VUt,
  event_remaining_other: BUt,
  repeats_every: UUt,
  occurrence_one: GUt,
  occurrence_other: WUt,
  weekly_one: HUt,
  weekly_other: YUt,
  monthly_one: KUt,
  monthly_other: ZUt,
  yearly_one: XUt,
  yearly_other: JUt,
  plus_more: QUt,
  max: eGt,
  single_theme: tGt,
  brand_color: nGt,
  light_brand_color: oGt,
  dark_brand_color: rGt,
  light_event_type_color: iGt,
  dark_event_type_color: aGt,
  file_not_named: sGt,
  create_team: cGt,
  name: lGt,
  nameless_team: uGt,
  oauth_clients: dGt,
  oauth_clients_description: _Gt,
  create_oauth_client: pGt,
  create_oauth_client_description: mGt,
  oauth_client_deletion_message: fGt,
  create_new_team_description: gGt,
  create_new_team: hGt,
  booking_redirect_uri: vGt,
  booking_cancel_redirect_uri: bGt,
  booking_reschedule_redirect_uri: yGt,
  booking_conflict_error: $Gt,
  open_invitations: wGt,
  new_team: kGt,
  create_first_team_and_invite_others: SGt,
  create_team_to_get_started: EGt,
  teams: xGt,
  team: CGt,
  organization: TGt,
  team_billing: AGt,
  team_billing_description: IGt,
  upgrade_to_flexible_pro_title: OGt,
  upgrade_to_flexible_pro_message: NGt,
  changed_team_billing_info: zGt,
  create_manage_teams_collaborative: RGt,
  only_available_on_pro_plan: PGt,
  remove_cal_branding_description: DGt,
  edit_profile_info_description: LGt,
  change_email_tip: MGt,
  little_something_about: FGt,
  profile_updated_successfully: qGt,
  your_user_profile_updated_successfully: jGt,
  your_upgrade_is_here: VGt,
  your_upgrade_is_here_description: BGt,
  you_are_all_set: UGt,
  you_are_all_set_description: GGt,
  user_cannot_found_db: WGt,
  embed_and_webhooks: HGt,
  enabled: YGt,
  disabled: KGt,
  disable: ZGt,
  billing: XGt,
  here: JGt,
  manage_your_billing_info: QGt,
  availability: eWt,
  edit_availability: tWt,
  configure_availability: nWt,
  copy_times_to: oWt,
  copy_times_to_tooltip: rWt,
  change_weekly_schedule: iWt,
  logo: aWt,
  error: sWt,
  at_least_characters_one: cWt,
  at_least_characters_other: lWt,
  team_logo: uWt,
  add_location: dWt,
  attendees: _Wt,
  add_attendees: pWt,
  show_advanced_settings: mWt,
  hide_advanced_settings: fWt,
  event_name: gWt,
  event_name_in_calendar: hWt,
  event_name_tooltip: vWt,
  meeting_with_user: bWt,
  additional_inputs: yWt,
  additional_input_description: $Wt,
  label: wWt,
  placeholder: kWt,
  display_add_to_calendar_organizer: SWt,
  display_email_as_organizer: EWt,
  if_enabled_email_address_as_organizer: xWt,
  reconnect_calendar_to_use: CWt,
  type: TWt,
  edit: AWt,
  add_input: IWt,
  disable_notes: OWt,
  disable_notes_description: NWt,
  requires_confirmation_description: zWt,
  requires_confirmation_will_block_slot_description: RWt,
  recurring_event: PWt,
  recurring_event_description: DWt,
  connect_and_join: LWt,
  cannot_be_used_with_paid_event_types: MWt,
  warning_payment_instant_meeting_event: FWt,
  warning_instant_meeting_experimental: qWt,
  starting: jWt,
  disable_guests: VWt,
  disable_guests_description: BWt,
  private_link: UWt,
  enable_private_url: GWt,
  private_link_label: WWt,
  private_link_hint: HWt,
  copy_private_link: YWt,
  copy_private_link_to_event: KWt,
  private_link_description: ZWt,
  multiple_private_links_title: XWt,
  multiple_private_links_description: JWt,
  add_a_multiple_private_link: QWt,
  multiple_private_link_copied: e8t,
  invitees_can_schedule: t8t,
  date_range: n8t,
  calendar_days: o8t,
  business_days: r8t,
  set_address_place: i8t,
  set_link_meeting: a8t,
  managed_event_field_parent_control_disabled: s8t,
  cal_invitee_phone_number_scheduling: c8t,
  cal_provide_google_meet_location: l8t,
  cal_provide_zoom_meeting_url: u8t,
  cal_provide_tandem_meeting_url: d8t,
  cal_provide_video_meeting_url: _8t,
  cal_provide_jitsi_meeting_url: p8t,
  cal_provide_huddle01_meeting_url: m8t,
  cal_provide_teams_meeting_url: f8t,
  require_payment: g8t,
  you_need_to_add_a_name: h8t,
  commission_per_transaction: v8t,
  event_type_updated_successfully_description: b8t,
  hide_event_type: y8t,
  edit_location: $8t,
  into_the_future: w8t,
  when_booked_with_less_than_notice: k8t,
  within_date_range: S8t,
  indefinitely_into_future: E8t,
  add_new_custom_input_field: x8t,
  quick_chat: C8t,
  add_new_team_event_type: T8t,
  add_new_event_type: A8t,
  new_event_type_to_book_description: I8t,
  length: O8t,
  minimum_booking_notice: N8t,
  offset_toggle: z8t,
  offset_toggle_description: R8t,
  offset_start: P8t,
  offset_start_description: D8t,
  slot_interval: L8t,
  slot_interval_default: M8t,
  delete_event_type: F8t,
  delete_managed_event_type: q8t,
  delete_event_type_description: j8t,
  delete_managed_event_type_description_1: V8t,
  delete_managed_event_type_description_2: B8t,
  confirm_delete_event_type: U8t,
  delete_account: G8t,
  confirm_delete_account: W8t,
  delete_account_confirmation_message: H8t,
  integrations: Y8t,
  apps: K8t,
  apps_description: Z8t,
  apps_listing: X8t,
  category_apps: J8t,
  app_store: Q8t,
  app_store_description: e7t,
  connect_your_video: t7t,
  settings: n7t,
  event_type_moved_successfully: o7t,
  next_step_text: r7t,
  next_step: i7t,
  prev_step: a7t,
  install: s7t,
  start_paid_trial: c7t,
  installed: l7t,
  active_install_one: u7t,
  active_install_other: d7t,
  globally_install: _7t,
  app_successfully_installed: p7t,
  app_could_not_be_installed: m7t,
  disconnect: f7t,
  embed_your_calendar: g7t,
  connect_your_favourite_apps: h7t,
  automation: v7t,
  configure_how_your_event_types_interact: b7t,
  toggle_calendars_conflict: y7t,
  connect_additional_calendar: $7t,
  calendar_updated_successfully: w7t,
  check_here: k7t,
  conferencing: S7t,
  calendar: E7t,
  payments: x7t,
  not_installed: C7t,
  error_password_mismatch: T7t,
  error_required_field: A7t,
  status: I7t,
  team_view_user_availability: O7t,
  team_view_user_availability_disabled: N7t,
  set_as_away: z7t,
  set_as_free: R7t,
  toggle_away_error: P7t,
  user_away: D7t,
  user_away_description: L7t,
  meet_people_with_the_same_tokens: M7t,
  only_book_people_and_allow: F7t,
  account_created_with_identity_provider: q7t,
  account_managed_by_identity_provider: j7t,
  account_managed_by_identity_provider_description: V7t,
  account_managed_by_identity_provider_error: B7t,
  user_creation_error: U7t,
  signin_with_google: G7t,
  signin_with_saml: W7t,
  signin_with_saml_oidc: H7t,
  continue_with_email: Y7t,
  continue_with_google: K7t,
  last_used: Z7t,
  you_will_need_to_generate: X7t,
  import: "Import",
  import_from: J7t,
  access_token: Q7t,
  visit_roadmap: eHt,
  featured_categories: tHt,
  feature_flags: nHt,
  admin_flags_description: oHt,
  feature_assigned_successfully: rHt,
  feature_unassigned_successfully: iHt,
  popular_categories: aHt,
  number_apps_one: sHt,
  number_apps_other: cHt,
  trending_apps: lHt,
  most_popular: uHt,
  installed_apps: dHt,
  free_to_use_apps: _Ht,
  no_category_apps: pHt,
  all_apps: mHt,
  no_category_apps_description_calendar: fHt,
  no_category_apps_description_conferencing: gHt,
  no_category_apps_description_payment: hHt,
  no_category_apps_description_analytics: vHt,
  no_category_apps_description_automation: bHt,
  no_category_apps_description_other: yHt,
  no_category_apps_description_messaging: $Ht,
  no_category_apps_description_crm: wHt,
  installed_app_calendar_description: kHt,
  installed_app_payment_description: SHt,
  installed_app_analytics_description: EHt,
  installed_app_other_description: xHt,
  installed_app_conferencing_description: CHt,
  installed_app_automation_description: THt,
  installed_app_messaging_description: AHt,
  installed_app_crm_description: IHt,
  analytics: OHt,
  empty_installed_apps_headline: NHt,
  empty_installed_apps_description: zHt,
  empty_installed_apps_button: RHt,
  manage_your_connected_apps: PHt,
  browse_apps: DHt,
  features: LHt,
  permissions: MHt,
  terms_and_privacy: FHt,
  published_by: qHt,
  subscribe: jHt,
  buy: VHt,
  install_app: BHt,
  categories: UHt,
  pricing: GHt,
  learn_more: WHt,
  try_now: HHt,
  privacy_policy: YHt,
  terms_of_service: KHt,
  remove: ZHt,
  add: XHt,
  installed_other: JHt,
  verify_wallet: QHt,
  create_events_on: eYt,
  enterprise_license: tYt,
  enterprise_license_locally: nYt,
  enterprise_license_sales: oYt,
  missing_license: rYt,
  next_steps: iYt,
  acquire_commercial_license: aYt,
  the_infrastructure_plan: sYt,
  prisma_studio_tip: cYt,
  prisma_studio_tip_description: lYt,
  contact_sales: uYt,
  error_404: dYt,
  default: "Default",
  set_to_default: _Yt,
  new_schedule_btn: pYt,
  add_new_schedule: mYt,
  add_new_calendar: fYt,
  set_calendar: gYt,
  delete_schedule: hYt,
  delete_schedule_description: vYt,
  schedule_created_successfully: bYt,
  availability_updated_successfully: yYt,
  schedule_deleted_successfully: $Yt,
  default_schedule_name: wYt,
  new_schedule_heading: kYt,
  new_schedule_description: SYt,
  requires_ownership_of_a_token: EYt,
  example_name: xYt,
  time_format: CYt,
  "12_hour": "12 hour",
  "24_hour": "24 hour",
  "12_hour_short": "12h",
  "24_hour_short": "24h",
  redirect_success_booking: TYt,
  you_are_being_redirected: AYt,
  external_redirect_url: IYt,
  redirect_url_description: OYt,
  duplicate: NYt,
  offer_seats: zYt,
  offer_seats_description: RYt,
  seats_available_one: PYt,
  seats_available_other: DYt,
  seats_nearly_full: LYt,
  seats_half_full: MYt,
  number_of_seats: FYt,
  set_instant_meeting_expiry_time_offset_description: qYt,
  enter_number_of_seats: jYt,
  you_can_manage_your_schedules: VYt,
  booking_full: BYt,
  api_keys: UYt,
  api_key: GYt,
  test_api_key: WYt,
  test_passed: HYt,
  test_failed: YYt,
  provide_api_key: KYt,
  api_key_modal_subtitle: ZYt,
  api_key_modal_subtitle_platform: XYt,
  api_keys_subtitle: JYt,
  create_api_key: QYt,
  personal_note: eKt,
  personal_note_placeholder: tKt,
  api_key_no_note: nKt,
  api_key_never_expires: oKt,
  edit_api_key: rKt,
  success_api_key_created: iKt,
  success_api_key_edited: aKt,
  create: sKt,
  success_api_key_created_bold_tagline: cKt,
  you_will_only_view_it_once: lKt,
  copy_to_clipboard: uKt,
  enabled_after_update: dKt,
  enabled_after_update_description: _Kt,
  confirm_delete_api_key: pKt,
  disable_rescheduling: mKt,
  description_disable_rescheduling: fKt,
  allow_rescheduling_cancelled_bookings: gKt,
  description_allow_rescheduling_cancelled_bookings: hKt,
  disable_cancelling: vKt,
  description_disable_cancelling: bKt,
  revoke_api_key: yKt,
  api_key_copied: $Kt,
  api_key_expires_on: wKt,
  delete_api_key_confirm_title: kKt,
  copy: SKt,
  expire_date: EKt,
  expired: xKt,
  never_expires: CKt,
  expires: TKt,
  request_reschedule_booking: AKt,
  reason_for_reschedule: IKt,
  book_a_new_time: OKt,
  reschedule_request_sent: NKt,
  reschedule_modal_description: zKt,
  reason_for_reschedule_request: RKt,
  send_reschedule_request: PKt,
  edit_booking: DKt,
  reschedule_booking: LKt,
  former_time: MKt,
  confirmation_page_gif: FKt,
  search: qKt,
  impersonate: jKt,
  user_impersonation_heading: VKt,
  user_impersonation_description: BKt,
  team_impersonation_description: UKt,
  cal_signup_description: GKt,
  make_org_private: WKt,
  make_org_private_description: HKt,
  make_team_private: YKt,
  make_team_private_description: KKt,
  you_cannot_see_team_members: ZKt,
  you_cannot_see_teams_of_org: XKt,
  allow_multiple_durations: JKt,
  impersonate_user_tip: QKt,
  impersonating_user_warning: eZt,
  impersonating_stop_instructions: tZt,
  event_location_changed: nZt,
  new_guests_added: oZt,
  location_changed_event_type_subject: rZt,
  guests_added_event_type_subject: iZt,
  current_location: aZt,
  new_location: sZt,
  session: cZt,
  session_description: lZt,
  session_timeout_after: uZt,
  session_timeout: dZt,
  session_timeout_description: _Zt,
  no_location: pZt,
  set_location: mZt,
  update_location: fZt,
  location_updated: gZt,
  location_update_failed: hZt,
  guests_added: vZt,
  unable_to_add_guests: bZt,
  email_validation_error: yZt,
  emails_must_be_unique_valid: $Zt,
  url_validation_error: wZt,
  place_where_cal_widget_appear: kZt,
  create_update_react_component: SZt,
  copy_code: EZt,
  code_copied: xZt,
  how_you_want_add_cal_site: CZt,
  choose_ways_put_cal_site: TZt,
  setting_up_zapier: AZt,
  setting_up_make: IZt,
  generate_api_key: OZt,
  generate_api_key_description: NZt,
  your_unique_api_key: zZt,
  copy_safe_api_key: RZt,
  zapier_setup_instructions: PZt,
  make_setup_instructions_1: DZt,
  make_setup_instructions_2: LZt,
  make_setup_instructions_3: MZt,
  make_setup_instructions_4: FZt,
  make_setup_instructions_5: qZt,
  make_setup_instructions_6: jZt,
  install_zapier_app: VZt,
  install_make_app: BZt,
  app_installation: UZt,
  app_not_installed: GZt,
  visit_our_app_store: WZt,
  connect_apple_server: HZt,
  calendar_url: YZt,
  apple_server_generate_password: KZt,
  unable_to_add_apple_calendar: ZZt,
  credentials_stored_encrypted: XZt,
  it_stored_encrypted: JZt,
  go_to_app_store: QZt,
  calendar_error: eXt,
  set_your_phone_number: tXt,
  calendar_no_busy_slots: nXt,
  display_location_label: oXt,
  display_location_info_badge: rXt,
  add_gif: iXt,
  search_giphy: aXt,
  add_link_from_giphy: sXt,
  add_gif_to_confirmation: cXt,
  find_gif_spice_confirmation: lXt,
  share_feedback: uXt,
  resources: dXt,
  support_documentation: _Xt,
  developer_documentation: pXt,
  get_in_touch: mXt,
  contact_support: fXt,
  premium_support: gXt,
  community_support: hXt,
  feedback: vXt,
  submitted_feedback: bXt,
  feedback_error: yXt,
  comments: $Xt,
  booking_details: wXt,
  or_lowercase: kXt,
  nevermind: SXt,
  go_to: EXt,
  zapier_invite_link: xXt,
  meeting_url_provided_after_confirmed: CXt,
  dynamically_display_attendee_or_organizer: TXt,
  event_location: AXt,
  reschedule_optional: IXt,
  reschedule_placeholder: OXt,
  event_cancelled: NXt,
  emailed_information_about_cancelled_event: zXt,
  this_input_will_shown_booking_this_event: RXt,
  meeting_url_in_confirmation_email: PXt,
  url_start_with_https: DXt,
  number_provided: LXt,
  before_event_trigger: MXt,
  event_cancelled_trigger: FXt,
  after_hosts_cal_video_no_show: qXt,
  after_guests_cal_video_no_show: jXt,
  join_video_call: VXt,
  sign_in_to_cal_com: BXt,
  log_in_to_cal_com: UXt,
  track_your_meetings: GXt,
  track_meetings_and_manage_schedule: WXt,
  failed_to_join_call: HXt,
  choose_how_you_d_like_to_join_call: YXt,
  choose_how_you_d_like_to_appear_on_the_call: KXt,
  new_event_trigger: ZXt,
  email_host_action: XXt,
  email_attendee_action: JXt,
  email_attendee_action_form: QXt,
  sms_attendee_action: eJt,
  sms_number_action: tJt,
  send_reminder_sms: nJt,
  whatsapp_number_action: oJt,
  whatsapp_attendee_action: rJt,
  workflows: iJt,
  new_workflow_btn: aJt,
  how_would_you_like_to_start: sJt,
  add_new_workflow: cJt,
  reschedule_event_trigger: lJt,
  trigger: uJt,
  triggers: dJt,
  action: _Jt,
  workflows_to_automate_notifications: pJt,
  workflow_name: mJt,
  custom_workflow: fJt,
  workflow_created_successfully: gJt,
  delete_workflow_description: hJt,
  delete_workflow: vJt,
  confirm_delete_workflow: bJt,
  workflow_deleted_successfully: yJt,
  how_long_before: $Jt,
  day_timeUnit: wJt,
  hour_timeUnit: kJt,
  minute_timeUnit: SJt,
  minute_short: EJt,
  hour_short: xJt,
  new_workflow_heading: CJt,
  new_workflow_description: TJt,
  active_on: AJt,
  workflow_updated_successfully: IJt,
  premium_to_standard_username_description: OJt,
  premium_username: NJt,
  current: zJt,
  premium: RJt,
  standard: PJt,
  confirm_username_change_dialog_title: DJt,
  change_username_standard_to_premium: LJt,
  change_username_premium_to_standard: MJt,
  go_to_stripe_billing: FJt,
  stripe_description: qJt,
  trial_expired: jJt,
  remove_app: VJt,
  yes_remove_app: BJt,
  are_you_sure_you_want_to_remove_this_app: UJt,
  app_removed_successfully: GJt,
  error_removing_app: WJt,
  web_conference: HJt,
  web_call: YJt,
  start_web_call: KJt,
  end_call: ZJt,
  test_your_agent_with_web_call: XJt,
  phone_call: JJt,
  connecting_to_agent: QJt,
  call_active: eQt,
  call_ended: tQt,
  call_error: nQt,
  ready_to_start_call: oQt,
  failed_to_start_web_call_try_again: rQt,
  call_encountered_error_try_again: iQt,
  failed_initialize_web_call_microphone_permissions: aQt,
  start_call_to_see_conversation: sQt,
  waiting_for_conversation: cQt,
  ai_agent: lQt,
  live: uQt,
  connecting: dQt,
  requires_confirmation: _Qt,
  requires_confirmation_threshold: pQt,
  may_require_confirmation: mQt,
  nr_event_type_one: fQt,
  nr_event_type_other: gQt,
  nr_routing_form_one: hQt,
  nr_routing_form_other: vQt,
  count_team_one: bQt,
  count_team_other: yQt,
  add_action: $Qt,
  set_whereby_link: wQt,
  invalid_whereby_link: kQt,
  set_around_link: SQt,
  invalid_around_link: EQt,
  set_riverside_link: xQt,
  invalid_riverside_link: CQt,
  invalid_ping_link: TQt,
  add_exchange2013: AQt,
  add_exchange2016: IQt,
  custom_template: OQt,
  email_body: NQt,
  text_message: zQt,
  specific_issue: RQt,
  browse_our_docs: PQt,
  choose_template: DQt,
  custom: LQt,
  reminder: MQt,
  rescheduled: FQt,
  rescheduled_by: qQt,
  original_booking: jQt,
  completed: VQt,
  rating: BQt,
  reminder_email: UQt,
  not_triggering_existing_bookings: GQt,
  minute_one: WQt,
  minute_one_short: HQt,
  minute_other: YQt,
  hour_one: KQt,
  hour_one_short: ZQt,
  hour_other: XQt,
  invalid_input: JQt,
  broken_video_action: QQt,
  broken_calendar_action: een,
  attendee_name: ten,
  scheduler_full_name: nen,
  broken_integration: oen,
  problem_adding_video_link: ren,
  problem_updating_calendar: ien,
  active_on_event_types_one: aen,
  active_on_event_types_other: sen,
  active_on_teams_one: cen,
  active_on_teams_other: len,
  active_on_all_event_types: uen,
  active_on_all_teams: den,
  no_active_event_types: _en,
  no_active_teams: pen,
  new_seat_subject: men,
  new_seat_title: fen,
  variable: gen,
  event_name_variable: hen,
  attendee_name_variable: ven,
  event_date_variable: ben,
  event_time_variable: yen,
  organizer_name_variable: $en,
  app_upgrade_description: wen,
  invalid_number: ken,
  invalid_url_error_message: Sen,
  navigate: Een,
  open: xen,
  close: Cen,
  upgrade: Ten,
  buy_us_number_button: Aen,
  upgrade_to_access_recordings_title: Ien,
  upgrade_to_access_recordings_description: Oen,
  upgrade_to_cal_ai_phone_number_description: Nen,
  recordings_are_part_of_the_teams_plan: zen,
  team_feature_teams: Ren,
  team_feature_workflows: Pen,
  show_eventtype_on_profile: Den,
  embed: Len,
  new_username: Men,
  current_username: Fen,
  example_1: qen,
  example_2: jen,
  booking_question_identifier: Ven,
  company_size: Ben,
  what_help_needed: Uen,
  variable_format: Gen,
  webhook_subscriber_url_reserved: Wen,
  custom_input_as_variable_info: Hen,
  using_booking_questions_as_variables: Yen,
  download_desktop_app: Ken,
  set_ping_link: Zen,
  rate_limit_exceeded: Xen,
  when_something_happens: Jen,
  action_is_performed: Qen,
  test_action: etn,
  notification_sent: ttn,
  no_input: ntn,
  test_workflow_action: otn,
  send_sms: rtn,
  send_sms_to_number: itn,
  missing_connected_calendar: atn,
  connect_your_calendar_and_link: stn,
  default_calendar_selected: ctn,
  hide_from_profile: ltn,
  basics: utn,
  availability_not_found_in_schedule_error: dtn,
  event_limit_tab_title: _tn,
  event_limit_tab_description: ptn,
  event_advanced_tab_description: mtn,
  event_advanced_tab_title: ftn,
  event_payments_tab_description: gtn,
  event_setup_multiple_duration_error: htn,
  event_setup_multiple_duration_default_error: vtn,
  event_setup_booking_limits_error: btn,
  event_setup_duration_limits_error: ytn,
  select_which_cal: $tn,
  custom_event_name: wtn,
  custom_event_name_description: ktn,
  "2fa_required": "Two factor authentication required",
  incorrect_2fa: Stn,
  which_event_type_apply: Etn,
  which_routing_form_apply: xtn,
  apply_to_all_event_types: Ctn,
  apply_to_all_routing_forms: Ttn,
  apply_to_all_teams: Atn,
  which_team_apply: Itn,
  no_workflows_description: Otn,
  timeformat_profile_hint: Ntn,
  create_workflow: ztn,
  do_this: Rtn,
  turn_off: Ptn,
  turn_on: Dtn,
  cancelled_bookings_cannot_be_rescheduled: Ltn,
  settings_updated_successfully: Mtn,
  error_updating_settings: Ftn,
  personal_cal_url: qtn,
  bio_hint: jtn,
  finish_and_start: Vtn,
  user_has_no_bio: Btn,
  bio: Utn,
  delete_account_modal_title: Gtn,
  confirm_delete_account_modal: Wtn,
  delete_my_account: Htn,
  start_of_week: Ytn,
  recordings_title: Ktn,
  recording: Ztn,
  happy_scheduling: Xtn,
  select_calendars: Jtn,
  check_for_conflicts: Qtn,
  view_recordings: enn,
  check_for_recordings: tnn,
  adding_events_to: nnn,
  follow_system_preferences: onn,
  custom_brand_colors: rnn,
  customize_your_brand_colors: inn,
  pro: ann,
  removes_cal_branding: snn,
  instant_meeting_with_title: cnn,
  profile_picture: lnn,
  upload: unn,
  add_profile_photo: dnn,
  token_address: _nn,
  blockchain: pnn,
  old_password: mnn,
  secure_password: fnn,
  error_updating_password: gnn,
  two_factor_auth: hnn,
  recurring_event_tab_description: vnn,
  today: bnn,
  appearance: ynn,
  my_account: $nn,
  general: wnn,
  calendars: knn,
  "2fa_auth": "Two factor auth",
  invoices: Snn,
  embeds: Enn,
  impersonation: xnn,
  impersonation_description: Cnn,
  recent_impersonations: Tnn,
  quick_impersonate: Ann,
  no_recent_impersonations: Inn,
  users: Onn,
  user: Nnn,
  profile_description: znn,
  users_description: Rnn,
  users_listing: Pnn,
  general_description: Dnn,
  calendars_description: Lnn,
  appearance_description: Mnn,
  conferencing_description: Fnn,
  add_conferencing_app: qnn,
  password_description: jnn,
  set_up_two_factor_authentication: Vnn,
  we_just_need_basic_info: Bnn,
  skip: Unn,
  do_this_later: Gnn,
  set_availability_getting_started_subtitle_1: Wnn,
  set_availability_getting_started_subtitle_2: Hnn,
  connect_calendar_first: Ynn,
  complete_profile: Knn,
  connect_calendars_from_app_store: Znn,
  connect_conference_apps: Xnn,
  connect_calendar_apps: Jnn,
  connect_payment_apps: Qnn,
  connect_automation_apps: eon,
  connect_analytics_apps: ton,
  connect_other_apps: non,
  connect_messaging_apps: oon,
  connect_crm_apps: ron,
  current_step_of_total: ion,
  add_variable: aon,
  custom_phone_number: son,
  message_template: con,
  email_subject: lon,
  add_dynamic_variables: uon,
  event_name_info: don,
  event_date_info: _on,
  event_duration_info: pon,
  event_time_info: mon,
  event_type_not_found: fon,
  number_to_call_variable: gon,
  number_to_call_info: hon,
  location_variable: von,
  location_info: bon,
  additional_notes_variable: yon,
  additional_notes_info: $on,
  attendee_name_info: won,
  organizer_name_info: kon,
  to: Son,
  workflow_turned_on_successfully: Eon,
  download_responses: xon,
  download_responses_description: Con,
  view_responses: Ton,
  download: Aon,
  downloading: Ion,
  download_recording: Oon,
  transcription_enabled: Non,
  transcription_stopped: zon,
  download_transcript: Ron,
  transcript: Pon,
  recording_from_your_recent_call: Don,
  transcript_from_previous_call: Lon,
  you_can_download_transcript_from_attachments: Mon,
  link_valid_for_12_hrs: Fon,
  link_valid_for_12_hrs_description: qon,
  create_your_first_form: jon,
  create_your_first_form_description: Von,
  create_your_first_webhook: Bon,
  create_your_first_webhook_description: Uon,
  for_a_maximum_of: Gon,
  event_one: Won,
  event_other: Hon,
  profile_team_description: Yon,
  profile_org_description: Kon,
  members_team_description: Zon,
  organization_description: Xon,
  team_url: Jon,
  team_members: Qon,
  more: ern,
  cal_ai_workflows: trn,
  and_count_more: nrn,
  more_page_footer: orn,
  workflow_example_1: rrn,
  workflow_example_2: irn,
  workflow_example_3: arn,
  workflow_example_4: srn,
  workflow_example_5: crn,
  workflow_example_6: lrn,
  send_sms_reminder: urn,
  send_sms_reminder_description: drn,
  follow_up_with_no_shows: _rn,
  follow_up_with_no_shows_description: prn,
  remind_attendees_to_bring_id: mrn,
  remind_attendees_to_bring_id_description: frn,
  email_to_remind_booking: grn,
  email_to_remind_booking_description: hrn,
  custom_sms_reminder: vrn,
  custom_sms_reminder_description: brn,
  custom_email_reminder: yrn,
  custom_email_reminder_description: $rn,
  count_managed_to_limit: wrn,
  welcome_to_cal_header: krn,
  edit_form_later_subtitle: Srn,
  connect_calendar_later: Ern,
  problem_saving_user_profile: xrn,
  purchase_missing_seats: Crn,
  slot_length: Trn,
  booking_appearance: Arn,
  appearance_team_description: Irn,
  appearance_org_description: Orn,
  only_owner_change: Nrn,
  team_disable_cal_branding_description: zrn,
  invited_by_team: Rrn,
  token_invalid_expired: Prn,
  view_booking: Drn,
  exchange_add: Lrn,
  exchange_authentication: Mrn,
  exchange_authentication_standard: Frn,
  exchange_authentication_ntlm: qrn,
  exchange_compression: jrn,
  exchange_version: Vrn,
  exchange_version_2007_SP1: Brn,
  exchange_version_2010: Urn,
  exchange_version_2010_SP1: Grn,
  exchange_version_2010_SP2: Wrn,
  exchange_version_2013: Hrn,
  exchange_version_2013_SP1: Yrn,
  exchange_version_2015: Krn,
  exchange_version_2016: Zrn,
  routing: Xrn,
  routing_forms_description: Jrn,
  routing_forms_send_email_owner: Qrn,
  routing_forms_send_email_owner_description: ein,
  routing_forms_send_email_to: tin,
  add_new_form: nin,
  add_new_team_form: oin,
  create_your_first_route: rin,
  route_to_the_right_person: iin,
  form: ain,
  form_description: sin,
  copy_link_to_form: cin,
  theme: lin,
  theme_applies_note: uin,
  app_theme: din,
  app_theme_applies_note: _in,
  theme_system: pin,
  add_a_team: min,
  add_webhook_description: fin,
  triggers_when: gin,
  test_webhook: hin,
  enable_webhook: vin,
  add_webhook: bin,
  webhook_edited_successfully: yin,
  api_keys_description: $in,
  new_api_key: win,
  active: kin,
  api_key_updated: Sin,
  api_key_update_failed: Ein,
  embeds_title: xin,
  embeds_description: Cin,
  create_first_api_key: Tin,
  create_first_api_key_description: Ain,
  back_to_signin: Iin,
  reset_link_sent: Oin,
  password_reset_email: Nin,
  password_reset_leading: zin,
  password_updated: Rin,
  pending_payment: Pin,
  pending_invites: Din,
  pending_organization_invites: Lin,
  not_on_cal: Min,
  no_calendar_installed: Fin,
  no_calendar_installed_description: qin,
  add_a_calendar: jin,
  change_email_hint: Vin,
  confirm_password_change_email: Bin,
  seats: Uin,
  every_app_published: Gin,
  report_app: Win,
  limit_booking_frequency: Hin,
  limit_booking_frequency_description: Yin,
  only_show_first_available_slot: Kin,
  only_show_first_available_slot_description: Zin,
  limit_total_booking_duration: Xin,
  limit_total_booking_duration_description: Jin,
  booker_booking_limit: Qin,
  booker_booking_limit_description: ean,
  recurring_event_doesnt_support_booker_booking_limit: tan,
  add_limit: nan,
  team_name_required: oan,
  show_attendees: ran,
  show_available_seats_count: ian,
  how_booking_questions_as_variables: aan,
  format: san,
  questions: can,
  all_info_your_booker_provide: lan,
  uppercase_for_letters: uan,
  replace_whitespaces_underscores: dan,
  platform_members: _an,
  platform_members_description: pan,
  platform_billing: man,
  manage_billing: fan,
  manage_billing_description: gan,
  billing_freeplan_title: han,
  billing_freeplan_description: van,
  billing_freeplan_cta: ban,
  billing_portal: yan,
  billing_help_cta: $an,
  ignore_special_characters_booking_questions: wan,
  retry: kan,
  fetching_calendars_error: San,
  calendar_connection_fail: Ean,
  booking_confirmation_success: xan,
  booking_rejection_success: Can,
  booking_tentative: Tan,
  booking_accept_intent: Aan,
  we_wont_show_again: Ian,
  couldnt_update_timezone: Oan,
  updated_timezone_to: Nan,
  update_timezone: zan,
  update_timezone_question: Ran,
  update_timezone_description: Pan,
  dont_update: Dan,
  require_additional_notes: Lan,
  require_additional_notes_description: Man,
  email_address_action: Fan,
  after_event_trigger: qan,
  booking_rejected_trigger: jan,
  booking_requested_trigger: Van,
  booking_payment_initiated_trigger: Ban,
  booking_paid_trigger: Uan,
  booking_no_show_updated_trigger: Gan,
  how_long_after: Wan,
  how_long_after_hosts_no_show: Han,
  how_long_after_guests_no_show: Yan,
  how_long_after_user_no_show_minutes: Kan,
  no_available_slots: Zan,
  time_available: Xan,
  cant_find_the_right_conferencing_app_visit_our_app_store: Jan,
  install_new_calendar_app: Qan,
  make_phone_number_required: esn,
  new_event_type_availability: tsn,
  error_editing_availability: nsn,
  dont_have_permission: osn,
  saml_configuration_placeholder: rsn,
  saml_email_required: isn,
  saml_sp_title: asn,
  saml_sp_description: ssn,
  saml_sp_acs_url: csn,
  saml_sp_entity_id: lsn,
  saml_sp_acs_url_copied: usn,
  saml_sp_entity_id_copied: dsn,
  add_calendar: _sn,
  limit_future_bookings: psn,
  limit_future_bookings_description: msn,
  no_event_types: fsn,
  no_event_types_description: gsn,
  billing_frequency: hsn,
  monthly: vsn,
  yearly: bsn,
  checkout: ysn,
  your_team_disbanded_successfully: $sn,
  your_org_disbanded_successfully: wsn,
  error_creating_team: ksn,
  you: Ssn,
  or_continue_with: Esn,
  resend_email: xsn,
  member_already_invited: Csn,
  already_in_use_error: Tsn,
  enter_email_or_username: Asn,
  enter_email: Isn,
  enter_emails: Osn,
  too_many_invites: Nsn,
  team_name_taken: zsn,
  must_enter_team_name: Rsn,
  team_url_required: Psn,
  url_taken: Dsn,
  problem_registering_domain: Lsn,
  team_publish: Msn,
  number_text_notifications: Fsn,
  number_sms_notifications: qsn,
  attendee_email_variable: jsn,
  attendee_email_info: Vsn,
  booking_uid: Bsn,
  kbar_search_placeholder: Usn,
  invalid_credential: Gsn,
  invalid_credential_action: Wsn,
  reschedule_reason: Hsn,
  choose_common_schedule_team_event: Ysn,
  choose_common_schedule_team_event_description: Ksn,
  reason: Zsn,
  sender_id: Xsn,
  sender_id_error_message: Jsn,
  test_routing_form: Qsn,
  test_preview: ecn,
  route_to: tcn,
  test_preview_description: ncn,
  test_routing: ocn,
  payment_app_disabled: rcn,
  edit_event_type: icn,
  only_admin_can_see_members_of_org: acn,
  only_admin_can_manage_sso_org: scn,
  only_admin_can_manage_directory_sync: ccn,
  only_admin_can_manage_oauth_clients: lcn,
  collective_scheduling: ucn,
  make_it_easy_to_book: dcn,
  find_the_best_person: _cn,
  fixed_round_robin: pcn,
  add_one_fixed_attendee: mcn,
  calcom_is_better_with_team: fcn,
  the_calcom_team: gcn,
  add_your_team_members: hcn,
  booking_limit_reached: vcn,
  duration_limit_reached: bcn,
  admin_has_disabled: ycn,
  disable_attendees_emails_description: $cn,
  disabled_app_affects_event_type: wcn,
  event_replaced_notice: kcn,
  email_subject_slug_replacement: Scn,
  email_body_slug_replacement_notice: Ecn,
  email_body_slug_replacement_info: xcn,
  email_body_slug_replacement_suggestion: Ccn,
  disable_payment_app: Tcn,
  payment_disabled_still_able_to_book: Acn,
  app_disabled_with_event_type: Icn,
  app_disabled_video: Ocn,
  app_disabled_subject: Ncn,
  navigate_installed_apps: zcn,
  disabled_calendar: Rcn,
  enable_apps: Pcn,
  enable_apps_description: Dcn,
  purchase_license: Lcn,
  already_have_account: Mcn,
  already_have_key: Fcn,
  already_have_key_suggestion: qcn,
  create_license_key: jcn,
  app_is_enabled: Vcn,
  app_is_disabled: Bcn,
  keys_have_been_saved: Ucn,
  disable_app: Gcn,
  disable_app_description: Wcn,
  edit_keys: Hcn,
  admin_apps_description: Ycn,
  admin_users_description: Kcn,
  admin_users_add_description: Zcn,
  admin_users_edit_description: Xcn,
  admin_orgs_edit_description: Jcn,
  admin_oAuth_description: Qcn,
  admin_lockedSMS_description: eln,
  no_available_apps: tln,
  no_available_apps_description: nln,
  no_apps: oln,
  no_apps_configured: rln,
  enable_in_settings: iln,
  please_contact_admin: aln,
  apps_settings: sln,
  fill_this_field: cln,
  options: lln,
  enter_option: uln,
  add_an_option: dln,
  location_already_exists: _ln,
  radio: pln,
  google_meet_warning: mln,
  individual: fln,
  all_bookings_filter_label: gln,
  all_users_filter_label: hln,
  all_event_types_filter_label: vln,
  your_bookings_filter_label: bln,
  meeting_url_variable: yln,
  meeting_url_info: $ln,
  date_overrides: wln,
  date_overrides_delete_on_date: kln,
  date_overrides_subtitle: Sln,
  date_overrides_info: Eln,
  date_overrides_dialog_which_hours: xln,
  date_overrides_dialog_which_hours_unavailable: Cln,
  date_overrides_dialog_title: Tln,
  date_overrides_unavailable: Aln,
  date_overrides_mark_all_day_unavailable_one: Iln,
  date_overrides_mark_all_day_unavailable_other: Oln,
  date_overrides_update_btn: Nln,
  date_successfully_added: zln,
  date_overrides_save_btn: Rln,
  event_type_duplicate_copy_text: Pln,
  set_as_default: Dln,
  hide_eventtype_details: Lln,
  show_navigation: Mln,
  hide_navigation: Fln,
  verification_code_sent: qln,
  verified_successfully: jln,
  wrong_code: Vln,
  not_verified: Bln,
  no_availability_in_month: Uln,
  no_availability_rolling: Gln,
  no_availability_range: Wln,
  view_previous_month: Hln,
  view_next_month: Yln,
  send_code: Kln,
  number_verified: Zln,
  create_your_first_team_webhook_description: Xln,
  create_webhook_team_event_type: Jln,
  disable_success_page: Qln,
  invalid_admin_password: eun,
  change_password_admin: tun,
  username_already_taken: nun,
  assignment: oun,
  fixed_hosts: run,
  add_fixed_hosts: iun,
  round_robin_hosts: aun,
  minimum_round_robin_hosts_count: sun,
  hosts: cun,
  upgrade_to_enable_feature: lun,
  orgs_upgrade_to_enable_feature: uun,
  new_attendee: dun,
  awaiting_approval: _un,
  requires_google_calendar: pun,
  event_type_requires_google_calendar: mun,
  connected_google_calendar: fun,
  using_meet_requires_calendar: gun,
  continue_to_install_google_calendar: hun,
  install_google_meet: vun,
  install_google_calendar: bun,
  sender_name: yun,
  already_invited: $un,
  no_recordings_found: wun,
  new_workflow_subtitle: kun,
  reporting: Sun,
  reporting_feature: Eun,
  teams_plan_required: xun,
  routing_forms_are_a_great_way: Cun,
  choose_a_license: Tun,
  choose_license_description: Aun,
  license: Iun,
  agplv3_license: Oun,
  no_need_to_keep_your_code_open_source: Nun,
  repackage_rebrand_resell: zun,
  a_vast_suite_of_enterprise_features: Run,
  free_license_fee: Pun,
  forever_open_and_free: Dun,
  required_to_keep_your_code_open_source: Lun,
  cannot_repackage_and_resell: Mun,
  no_enterprise_features: Fun,
  step_enterprise_license: qun,
  step_enterprise_license_description: jun,
  setup: Vun,
  setup_description: Bun,
  configure: Uun,
  sso_configuration: Gun,
  sso_configuration_description: Wun,
  sso_configuration_description_orgs: Hun,
  sso_oidc_heading: Yun,
  sso_oidc_description: Kun,
  sso_oidc_configuration_title: Zun,
  sso_oidc_configuration_description: Xun,
  sso_oidc_callback_copied: Jun,
  sso_saml_heading: Qun,
  sso_saml_description: edn,
  sso_saml_configuration_title: tdn,
  sso_saml_configuration_description: ndn,
  sso_saml_acsurl_copied: odn,
  sso_saml_entityid_copied: rdn,
  sso_connection_created_successfully: idn,
  sso_connection_deleted_successfully: adn,
  delete_sso_configuration: sdn,
  delete_sso_configuration_confirmation: cdn,
  delete_sso_configuration_confirmation_description: ldn,
  organizer_timezone: udn,
  email_user_cta: ddn,
  accept_invite: _dn,
  join_now: pdn,
  successfully_joined: mdn,
  email_no_user_invite_heading_subteam: fdn,
  email_no_user_invite_heading_org: gdn,
  email_no_user_invite_subheading: hdn,
  email_user_invite_subheading_subteam: vdn,
  email_user_invite_subheading_org: bdn,
  email_no_user_invite_steps_intro: ydn,
  email_no_user_step_one: $dn,
  email_no_user_step_two: wdn,
  email_no_user_step_three: kdn,
  email_no_user_step_four: Sdn,
  email_no_user_signoff: Edn,
  impersonation_user_tip: xdn,
  available_variables: Cdn,
  scheduler: Tdn,
  no_workflows: Adn,
  change_filter: Idn,
  change_filter_common: Odn,
  no_results_for_filter: Ndn,
  recommended_next_steps: zdn,
  create_a_managed_event: Rdn,
  meetings_are_better_with_the_right: Pdn,
  create_a_one_one_template: Ddn,
  collective_or_roundrobin: Ldn,
  book_your_team_members: Mdn,
  event_no_longer_attending_subject: Fdn,
  no_longer_attending: qdn,
  attendee_no_longer_attending_subject: jdn,
  attendee_no_longer_attending: Vdn,
  attendee_no_longer_attending_subtitle: Bdn,
  create_event_on: Udn,
  create_routing_form_on: Gdn,
  default_app_link_title: Wdn,
  default_app_link_description: Hdn,
  organizer_default_conferencing_app: Ydn,
  organizer_default_conferencing_app_not_found: Kdn,
  under_maintenance: Zdn,
  under_maintenance_description: Xdn,
  event_type_seats: Jdn,
  booking_questions_title: Qdn,
  booking_questions_description: e_n,
  add_a_booking_question: t_n,
  identifier: n_n,
  duplicate_email: o_n,
  enter_redirect_url_on_exit_description: r_n,
  booking_with_payment_cancelled: i_n,
  booking_with_payment_cancelled_already_paid: a_n,
  booking_with_payment_cancelled_refunded: s_n,
  booking_with_payment_cancelled_no_refund: c_n,
  booking_with_payment_cancelled_refund_window_expired: l_n,
  booking_confirmation_failed: u_n,
  not_enough_seats: d_n,
  form_builder_field_already_exists: __n,
  guests_field_must_be_multiemail: p_n,
  show_on_booking_page: m_n,
  visit_cancelled_booking: f_n,
  get_started_zapier_templates: g_n,
  standard_templates: h_n,
  cal_ai_templates: v_n,
  team_is_unpublished: b_n,
  org_is_unpublished_description: y_n,
  team_is_unpublished_description: $_n,
  team_member: w_n,
  a_routing_form: k_n,
  form_description_placeholder: S_n,
  keep_me_connected_with_form: E_n,
  fields_in_form_duplicated: x_n,
  form_deleted: C_n,
  delete_form: T_n,
  delete_form_action: A_n,
  delete_form_confirmation: I_n,
  delete_form_confirmation_2: O_n,
  typeform_redirect_url_copied: N_n,
  modifications_in_fields_warning: z_n,
  connected_forms: R_n,
  form_modifications_warning: P_n,
  responses_collection_waiting_description: D_n,
  this_is_what_your_users_would_see: L_n,
  identifies_name_field: M_n,
  add_1_option_per_line: F_n,
  select_a_router: q_n,
  add_a_new_route: j_n,
  make_informed_decisions: V_n,
  make_informed_decisions_description: B_n,
  view_bookings_across: U_n,
  view_bookings_across_description: G_n,
  identify_booking_trends: W_n,
  identify_booking_trends_description: H_n,
  spot_popular_event_types: Y_n,
  spot_popular_event_types_description: K_n,
  no_responses_yet: Z_n,
  no_routes_defined: X_n,
  this_will_be_the_placeholder: J_n,
  error_booking_event: Q_n,
  timeslot_missing_title: epn,
  timeslot_missing_description: tpn,
  timeslot_missing_cta: npn,
  switch_monthly: opn,
  switch_weekly: rpn,
  switch_multiday: ipn,
  switch_columnview: apn,
  num_locations: spn,
  select_on_next_step: cpn,
  this_meeting_has_not_started_yet: lpn,
  this_app_requires_connected_account: upn,
  connect_app: dpn,
  app_is_connected: _pn,
  requires_app: ppn,
  verification_code: mpn,
  can_you_try_again: fpn,
  verify: gpn,
  timezone_info: hpn,
  timezone_variable: vpn,
  event_end_time_variable: bpn,
  event_end_time_info: ypn,
  cancel_url_variable: $pn,
  cancel_url_info: wpn,
  cancel_reason_variable: kpn,
  cancel_reason_info: Spn,
  reschedule_url_variable: Epn,
  reschedule_url_info: xpn,
  reschedule_reason_variable: Cpn,
  reschedule_reason_info: Tpn,
  invalid_event_name_variables: Apn,
  select_all: Ipn,
  default_conferencing_bulk_title: Opn,
  members_default_schedule: Npn,
  set_by_admin: zpn,
  members_default_location: Rpn,
  members_default_schedule_description: Ppn,
  requires_at_least_one_schedule: Dpn,
  default_conferencing_bulk_description: Lpn,
  default_schedules_bulk_description: Mpn,
  locked_for_members: Fpn,
  unlocked_for_members: qpn,
  apps_locked_for_members_description: jpn,
  apps_unlocked_for_members_description: Vpn,
  apps_locked_by_team_admins_description: Bpn,
  apps_unlocked_by_team_admins_description: Upn,
  workflows_locked_for_members_description: Gpn,
  workflows_unlocked_for_members_description: Wpn,
  workflows_locked_by_team_admins_description: Hpn,
  workflows_unlocked_by_team_admins_description: Ypn,
  webhooks_locked_for_members_description: Kpn,
  webhooks_unlocked_for_members_description: Zpn,
  webhooks_locked_by_team_admins_description: Xpn,
  webhooks_unlocked_by_team_admins_description: Jpn,
  locked_by_team_admin: Qpn,
  app_not_connected: emn,
  connect_now: tmn,
  managed_event_dialog_confirm_button_one: nmn,
  managed_event_dialog_confirm_button_other: omn,
  managed_event_dialog_title_one: rmn,
  managed_event_dialog_title_other: imn,
  managed_event_dialog_information_one: amn,
  managed_event_dialog_information_other: smn,
  managed_event_dialog_clarification: cmn,
  review_event_type: lmn,
  looking_for_more_analytics: umn,
  looking_for_more_insights: dmn,
  filters: _mn,
  filter: pmn,
  add_a_member: mmn,
  add_filter: fmn,
  add_rule: gmn,
  add_rule_group: hmn,
  remove_filters: vmn,
  email_verified: bmn,
  select_user: ymn,
  select_event_type: $mn,
  select_date_range: wmn,
  popular_events: kmn,
  no_event_types_found: Smn,
  average_event_duration: Emn,
  bookings_by_hour: xmn,
  most_booked_members: Cmn,
  least_booked_members: Tmn,
  most_bookings_scheduled: Amn,
  least_bookings_scheduled: Imn,
  most_bookings_completed: Omn,
  least_bookings_completed: Nmn,
  events_created: zmn,
  events_completed: Rmn,
  events_cancelled: Pmn,
  events_rescheduled: Dmn,
  events: Lmn,
  performance: Mmn,
  from_last_period: Fmn,
  from_to_date_period: qmn,
  redirect_url_warning: jmn,
  event_trends: Vmn,
  clear_filters: Bmn,
  clear: Umn,
  hold: Gmn,
  on_booking_option: Wmn,
  hold_option: Hmn,
  card_held: Ymn,
  charge_card: Kmn,
  card_charged: Zmn,
  no_show_fee_amount: Xmn,
  no_show_fee: Jmn,
  submit_card: Qmn,
  submit_payment_information: efn,
  meeting_awaiting_payment_method: tfn,
  no_show_fee_charged_email_subject: nfn,
  no_show_fee_charged_text_body: ofn,
  no_show_fee_charged_subtitle: rfn,
  error_charging_card: ifn,
  collect_no_show_fee: afn,
  no_show_fee_charged: sfn,
  your_card_was_declined: cfn,
  your_card_does_not_support_this_type_of_purchase: lfn,
  amount_must_convert_to_at_least: ufn,
  could_not_charge_card: dfn,
  insights: _fn,
  routing_forms: pfn,
  insights_no_data_found_for_filter: mfn,
  acknowledge_booking_no_show_fee: ffn,
  days: gfn,
  card_details: hfn,
  something_went_wrong_on_our_end: vfn,
  please_provide_following_text_to_suppport: bfn,
  seats_and_no_show_fee_error: yfn,
  complete_your_booking: $fn,
  complete_your_booking_subject: wfn,
  confirm_your_details: kfn,
  copy_invite_link: Sfn,
  edit_invite_link: Efn,
  invite_link_copied: xfn,
  invite_link_deleted: Cfn,
  api_key_deleted: Tfn,
  delete_api_key_warning: Afn,
  invite_link_updated: Ifn,
  link_expires_after: Ofn,
  one_day: Nfn,
  seven_days: zfn,
  thirty_days: Rfn,
  three_months: Pfn,
  one_year: Dfn,
  team_invite_received: Lfn,
  currency_string: Mfn,
  charge_card_dialog_body: Ffn,
  charge_attendee: qfn,
  payment_app_commission: jfn,
  email_invite_team: Vfn,
  email_invite_team_bulk: Bfn,
  error_collecting_card: Ufn,
  image_size_limit_exceed: Gfn,
  unauthorized_workflow_error_message: Wfn,
  inline_embed: Hfn,
  load_inline_content: Yfn,
  floating_pop_up_button: Kfn,
  floating_button_trigger_modal: Zfn,
  pop_up_element_click: Xfn,
  open_dialog_with_element_click: Jfn,
  use_my_own_form: Qfn,
  use_our_headless_routing_api: egn,
  need_help_embedding: tgn,
  book_my_cal: ngn,
  first_name: ogn,
  last_name: rgn,
  first_last_name: ign,
  invite_as: agn,
  form_updated_successfully: sgn,
  disable_attendees_confirmation_emails: cgn,
  disable_attendees_confirmation_emails_description: lgn,
  disable_host_confirmation_emails: ugn,
  disable_host_confirmation_emails_description: dgn,
  add_an_override: _gn,
  import_from_google_workspace: pgn,
  connect_google_workspace: mgn,
  google_workspace_admin_tooltip: fgn,
  first_event_type_webhook_description: ggn,
  create_instant_meeting_webhook_description: hgn,
  install_app_on: vgn,
  create_for: bgn,
  currency: ygn,
  organization_banner_description: $gn,
  organization_banner_title: wgn,
  set_up_your_organization: kgn,
  set_up_your_platform_organization: Sgn,
  organizations_description: Egn,
  plans: xgn,
  platform: Cgn,
  platform_description: Tgn,
  platform_organization_description: Agn,
  must_enter_organization_name: Ign,
  must_enter_organization_admin_email: Ogn,
  admin_email: Ngn,
  platform_admin_email: zgn,
  admin_username: Rgn,
  organization_name: Pgn,
  platform_name: Dgn,
  organization_url: Lgn,
  organization_verify_header: Mgn,
  organization_verify_email_body: Fgn,
  additional_url_parameters: qgn,
  about_your_organization: jgn,
  about_your_organization_description: Vgn,
  create_your_teams: Bgn,
  create_your_teams_description: Ugn,
  invite_organization_admins: Ggn,
  invite_organization_admins_description: Wgn,
  set_a_password: Hgn,
  set_a_password_description: Ygn,
  organization_logo: Kgn,
  organization_about_description: Zgn,
  ill_do_this_later: Xgn,
  verify_your_email: Jgn,
  enter_digit_code: Qgn,
  verify_email_organization: ehn,
  code_provided_invalid: thn,
  email_already_used: nhn,
  organization_admin_invited_heading: ohn,
  organization_admin_invited_body: rhn,
  duplicated_slugs_warning: ihn,
  team_names_empty: ahn,
  team_names_repeated: shn,
  user_belongs_organization: chn,
  org_no_teams_yet: lhn,
  org_no_teams_yet_description: uhn,
  set_up: dhn,
  my_profile: _hn,
  my_settings: phn,
  crm: mhn,
  messaging: fhn,
  sender_id_info: ghn,
  org_admins_can_create_new_teams: hhn,
  google_new_spam_policy: vhn,
  resolve: bhn,
  no_organization_slug: yhn,
  copy_link_org: $hn,
  "404_the_org": "The organization",
  "404_the_team": "The team",
  "404_claim_entity_org": "Claim your subdomain for your organization",
  "404_claim_entity_team": "Claim this team and start managing schedules collectively",
  insights_team_filter: whn,
  insights_user_filter: khn,
  insights_subtitle: Shn,
  call_history: Ehn,
  call_history_subtitle: xhn,
  location_options: Chn,
  channel_type: Thn,
  end_reason: Ahn,
  session_status: Ihn,
  user_sentiment: Ohn,
  time_header: Nhn,
  from_header: zhn,
  custom_plan: Rhn,
  email_embed: Phn,
  add_times_to_your_email: Dhn,
  select_time: Lhn,
  select_date: Mhn,
  only_show_if_parameter_set: Fhn,
  add_parameter: qhn,
  connecting_you_to_someone: jhn,
  please_do_not_close_this_tab: Vhn,
  see_all_available_times: Bhn,
  org_team_names_example_1: Uhn,
  org_team_names_example_2: Ghn,
  org_team_names_example_3: Whn,
  org_team_names_example_4: Hhn,
  org_team_names_example_5: Yhn,
  org_max_team_warnings: Khn,
  what_is_this_meeting_about: Zhn,
  add_to_team: Xhn,
  remove_users_from_org: Jhn,
  delegation_credential: Qhn,
  delegation_credential_description: evn,
  add_client_id_in_google_workspace_with_below_scope: tvn,
  delegation_credential_enabled: nvn,
  add_delegation_credential: ovn,
  edit_delegation_credential: rvn,
  domain: ivn,
  no_workspace_platforms: avn,
  workspace_platform: svn,
  workspace_platforms: cvn,
  workspace_platforms_description: lvn,
  edit_workspace_platform: uvn,
  edit_service_account: dvn,
  add_workspace_platform: _vn,
  slug: pvn,
  service_account_key: mvn,
  edit_service_account_key: fvn,
  delegation_credential_restricts_adding_more_than_one_installation: gvn,
  app_successfully_installed_and_is_using_delegated_credentials: hvn,
  remove_users_from_org_confirm: vvn,
  remove_users_from_team: bvn,
  remove_users_from_team_confirm: yvn,
  user_has_no_schedules: $vn,
  user_isnt_in_any_teams: wvn,
  user_has_no_app_installed: kvn,
  requires_booker_email_verification: Svn,
  description_requires_booker_email_verification: Evn,
  requires_confirmation_mandatory: xvn,
  organizations: Cvn,
  upload_cal_video_logo: Tvn,
  update_cal_video_logo: Avn,
  upload_banner: Ivn,
  cal_video_logo_upload_instruction: Ovn,
  org_admin_other_teams: Nvn,
  org_admin_other_teams_description: zvn,
  not_part_of_org: Rvn,
  no_other_teams_found: Pvn,
  no_other_teams_found_description: Dvn,
  attendee_first_name_variable: Lvn,
  attendee_last_name_variable: Mvn,
  attendee_first_name_info: Fvn,
  attendee_last_name_info: qvn,
  your_monthly_digest: jvn,
  member_name: Vvn,
  most_popular_events: Bvn,
  summary_of_events_for_your_team_for_the_last_30_days: Uvn,
  me: Gvn,
  meeting_unavailable: Wvn,
  monthly_digest_email: Hvn,
  monthly_digest_email_for_teams: Yvn,
  verify_team_tooltip: Kvn,
  member_removed: Zvn,
  my_availability: Xvn,
  team_availability: Jvn,
  instant_meeting_availability: Qvn,
  backup_code: ebn,
  backup_codes: tbn,
  backup_code_instructions: nbn,
  backup_codes_copied: obn,
  incorrect_backup_code: rbn,
  lost_access: ibn,
  missing_backup_codes: abn,
  admin_org_notification_email_subject: sbn,
  hi_admin: cbn,
  admin_org_notification_email_title: lbn,
  admin_org_notification_email_body_part1: ubn,
  admin_org_notification_email_body_part2: dbn,
  admin_org_notification_email_body_part3: _bn,
  admin_org_notification_email_cta: pbn,
  org_has_been_processed: mbn,
  org_error_processing: fbn,
  orgs_page_description: gbn,
  unverified: hbn,
  verified: vbn,
  dns_missing: bbn,
  dns_configured: ybn,
  mark_dns_configured: $bn,
  value: wbn,
  your_organization_updated_sucessfully: kbn,
  team_no_event_types: Sbn,
  seat_options_doesnt_multiple_durations: Ebn,
  include_calendar_event: xbn,
  oAuth: Cbn,
  oAuth_client_creation_form: Tbn,
  oAuth_client_creation_form_description: Abn,
  oAuth_client_updation_form: Ibn,
  oAuth_client_updation_form_description: Obn,
  recently_added: Nbn,
  connect_all_calendars: zbn,
  connect_all_calendars_description: Rbn,
  workflow_automation_description: Pbn,
  scheduling_for_your_team: Dbn,
  scheduling_for_your_team_description: Lbn,
  no_members_found: Mbn,
  directory_sync: Fbn,
  directory_name: qbn,
  directory_provider: jbn,
  directory_scim_url: Vbn,
  directory_scim_token: Bbn,
  directory_scim_url_copied: Ubn,
  directory_scim_token_copied: Gbn,
  directory_sync_info_description: Wbn,
  directory_sync_configure: Hbn,
  directory_sync_configure_description: Ybn,
  directory_sync_title: Kbn,
  directory_sync_created: Zbn,
  directory_sync_description: Xbn,
  directory_sync_deleted: Jbn,
  directory_sync_delete_connection: Qbn,
  directory_sync_delete_title: eyn,
  directory_sync_delete_description: tyn,
  directory_sync_delete_confirmation: nyn,
  event_setup_length_error: oyn,
  availability_schedules: ryn,
  unauthorized: iyn,
  access_cal_account: ayn,
  select_account_team: syn,
  allow_client_to: cyn,
  associate_with_cal_account: lyn,
  see_personal_info: uyn,
  see_primary_email_address: dyn,
  connect_installed_apps: _yn,
  access_event_type: pyn,
  access_availability: myn,
  access_bookings: fyn,
  allow_client_to_do: gyn,
  oauth_access_information: hyn,
  allow: vyn,
  view_only_edit_availability_not_onboarded: byn,
  view_only_edit_availability: yyn,
  you_can_override_calendar_in_advanced_tab: $yn,
  edit_users_availability: wyn,
  resend_invitation: kyn,
  invitation_resent: Syn,
  saml_sso: Eyn,
  add_client: xyn,
  copy_client_secret_info: Cyn,
  add_new_client: Tyn,
  add_new_user: Ayn,
  this_app_is_not_setup_already: Iyn,
  as_csv: Oyn,
  overlay_my_calendar: Nyn,
  overlay_my_calendar_toc: zyn,
  view_overlay_calendar_events: Ryn,
  join_event_location: Pyn,
  troubleshooting: Dyn,
  calendars_were_checking_for_conflicts: Lyn,
  availabilty_schedules: Myn,
  manage_calendars: Fyn,
  manage_availability_schedules: qyn,
  locked: jyn,
  unlocked: Vyn,
  lock_timezone_toggle_on_booking_page: Byn,
  description_lock_timezone_toggle_on_booking_page: Uyn,
  event_setup_multiple_payment_apps_error: Gyn,
  number_in_international_format: Wyn,
  install_calendar: Hyn,
  branded_subdomain: Yyn,
  branded_subdomain_description: Kyn,
  org_insights: Zyn,
  org_insights_description: Xyn,
  extensive_whitelabeling: Jyn,
  extensive_whitelabeling_description: Qyn,
  unlimited_teams: e$n,
  verify_email: t$n,
  proceed_with_cancellation_description: n$n,
  proceed_with_cancellation_error: o$n,
  unlimited_teams_description: r$n,
  unified_billing: i$n,
  advanced_managed_events: a$n,
  advanced_managed_events_description: s$n,
  enterprise: c$n,
  enterprise_description: l$n,
  create_your_org: u$n,
  create_org: d$n,
  create_your_org_description: _$n,
  create_your_enterprise_description: p$n,
  other_payment_app_enabled: m$n,
  admin_delete_organization_description_1: f$n,
  admin_delete_organization_description_2: g$n,
  admin_delete_organization_description_3: h$n,
  admin_delete_organization_description_4: v$n,
  admin_delete_organization_title: b$n,
  published: y$n,
  unpublished: $$n,
  publish: w$n,
  troubleshooter_tooltip: k$n,
  need_help: S$n,
  troubleshooter: E$n,
  number_to_call: x$n,
  guest_name: C$n,
  guest_email: T$n,
  guest_company: A$n,
  please_install_a_calendar: I$n,
  instant_tab_title: O$n,
  instant_event_tab_description: N$n,
  uprade_to_create_instant_bookings: z$n,
  dont_want_to_wait: R$n,
  meeting_started: P$n,
  pay_and_book: D$n,
  cal_ai_event_tab_description: L$n,
  booking_not_found_error: M$n,
  booking_seats_full_error: F$n,
  missing_payment_credential_error: q$n,
  missing_payment_app_id_error: j$n,
  not_enough_available_seats_error: V$n,
  user_redirect_title: B$n,
  user_redirect_description: U$n,
  out_of_office: G$n,
  out_of_office_description: W$n,
  send_request: H$n,
  start_date_and_end_date_required: Y$n,
  start_date_must_be_before_end_date: K$n,
  start_date_must_be_in_the_future: Z$n,
  user_not_found: X$n,
  cannot_redirect_to_self: J$n,
  out_of_office_entry_already_exists: Q$n,
  out_of_office_id_required: ewn,
  booking_redirect_infinite_not_allowed: twn,
  success_entry_created: nwn,
  booking_redirect_email_subject: own,
  booking_redirect_email_title: rwn,
  booking_redirect_email_description: iwn,
  booking_redirect_updated_email_subject: awn,
  booking_redirect_updated_email_title: swn,
  booking_redirect_updated_email_description: cwn,
  booking_redirect_cancelled_email_subject: lwn,
  booking_redirect_cancelled_email_title: uwn,
  booking_redirect_cancelled_email_description: dwn,
  success_accept_booking_redirect: _wn,
  success_reject_booking_redirect: pwn,
  copy_link_booking_redirect_request: mwn,
  booking_redirect_request_title: fwn,
  select_team_member: gwn,
  going_away_title: hwn,
  redirect_team_enabled: vwn,
  redirect_team_disabled: bwn,
  out_of_office_unavailable_list: ywn,
  success_deleted_entry_out_of_office: $wn,
  success_edited_entry_out_of_office: wwn,
  temporarily_out_of_office: kwn,
  add_a_redirect: Swn,
  create_entry: Ewn,
  time_range: xwn,
  automatically_add_all_team_members: Cwn,
  redirect_to: Twn,
  having_trouble_finding_time: Awn,
  show_more: Iwn,
  forward_params_redirect: Own,
  assignment_description: Nwn,
  lowest: zwn,
  low: Rwn,
  medium: Pwn,
  high: Dwn,
  Highest: Lwn,
  send_booker_to: Mwn,
  set_priority: Fwn,
  set_weight: qwn,
  enable_weights: jwn,
  priority_for_user: Vwn,
  weights_description: Bwn,
  weight_for_user: Uwn,
  change_priority: Gwn,
  field_identifiers_as_variables: Wwn,
  field_identifiers_as_variables_with_example: Hwn,
  account_already_linked: Ywn,
  send_email: Kwn,
  cal_ai_phone_call_action: Zwn,
  call_to_confirm_booking: Xwn,
  cal_ai_phone_call_action_description: Jwn,
  cal_ai_agent_configuration: Qwn,
  choose_at_least_one_event_type_test_call: ekn,
  mark_as_no_show: tkn,
  unmark_as_no_show: nkn,
  account_unlinked_success: okn,
  account_unlinked_error: rkn,
  travel_schedule: ikn,
  travel_schedule_description: akn,
  schedule_timezone_change: skn,
  date: ckn,
  enter_the_general_prompt_for_the_agent: lkn,
  overlaps_with_existing_schedule: ukn,
  "org_admin_no_slots|heading": "No availability found for {{name}}",
  "org_admin_no_slots|content": "Hello Organization Admins,<br /><br />Please note: It has been brought to our attention that {{username}} has not had any availability when a user has visited {{username}}/{{slug}}<br /><br />There's a few reasons why this could be happening<br />The user does not have any calendars connected<br />Their schedules attached to this event are not enabled<br /> <br />We recommend checking their availability to resolve this.",
  "org_admin_no_slots|cta": "Open users availability",
  organization_no_slots_notification_switch_title: dkn,
  organization_no_slots_notification_switch_description: _kn,
  organization_disable_phone_only_sms_notifications_switch_title: pkn,
  organization_disable_phone_only_sms_notifications_switch_description: mkn,
  "email_team_invite|subject|added_to_org": "{{user}} added you to the organization {{team}} on {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} invited you to join the organization {{team}} on {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} added you to the team {{team}} of organization {{parentTeamName}} on {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} invited you to join the team {{team}} on {{appName}}",
  "email_team_invite|heading|added_to_org": "You've been added to a {{appName}} organization",
  "email_team_invite|heading|invited_to_org": "You've been invited to a {{appName}} organization",
  "email_team_invite|heading|added_to_subteam": "You've been added to a team of {{parentTeamName}} organization",
  "email_team_invite|heading|invited_to_subteam": "You've been invited to a team of {{parentTeamName}} organization",
  "email_team_invite|heading|invited_to_regular_team": "You've been invited to join a {{appName}} team",
  "email_team_invite|content|added_to_org": "{{invitedBy}} has added you to the <strong>{{teamName}}</strong> organization.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} has invited you to join the {{teamName}} organization.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} invited you to join the team {{team}} of organization {{parentTeamName}} on {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} has added you to the team <strong>{{teamName}}</strong> in their organization {{parentTeamName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} has invited you to join the team <strong>{{teamName}}</strong> in their organization {{parentTeamName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} has invited you to join their team {{teamName}} on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.",
  "email|existing_user_added_link_will_change": "On accepting the invite, your link will change to your organization domain but don't worry, all previous links will still work and redirect appropriately.<br /><br />Please note: All of your personal event types will be moved into the <strong>{{teamName}}</strong> organization, which may also include potential personal link.  <br /><br />For personal events we recommend creating a new account with a personal email address.",
  "email|existing_user_added_link_changed": "Your link has been changed from {{a0}} to {{a1}} but don't worry, all previous links still work and redirect appropriately. <br /><br />Please note: All of your personal event types have been moved into the <strong>{{teamName}}</strong> organisation, which may also include potential personal link.<br /><br />Please log in and make sure you have no private events on your new organisational account.<br /><br />For personal events we recommend creating a new account with a personal email address.<br /><br />Enjoy your new clean link: {{a2}}",
  "email_organization_created|subject": "Your organization has been created",
  your_current_plan: fkn,
  organization_price_per_user_month: gkn,
  privacy_organization_description: hkn,
  privacy: vkn,
  privacy_and_security: bkn,
  team_will_be_under_org: ykn,
  add_group_name: $kn,
  group_name: wkn,
  routers: kkn,
  primary: Skn,
  make_primary: Ekn,
  add_email: xkn,
  add_emails: Ckn,
  add_email_description: Tkn,
  confirm_email: Akn,
  confirming_your_booking_sms: Ikn,
  scheduler_first_name: Okn,
  scheduler_last_name: Nkn,
  scheduler_name: zkn,
  organizer_first_name: Rkn,
  confirm_email_description: Pkn,
  send_event_details_to: Dkn,
  schedule_tz_without_end_date: Lkn,
  select_members: Mkn,
  lock_event_types_modal_header: Fkn,
  org_delete_event_types_org_admin: qkn,
  org_hide_event_types_org_admin: jkn,
  hide_org_eventtypes: Vkn,
  delete_org_eventtypes: Bkn,
  lock_org_users_eventtypes: Ukn,
  lock_org_users_eventtypes_description: Gkn,
  add_to_event_type: Wkn,
  create_account_password: Hkn,
  create_account_with_saml: Ykn,
  error_creating_account_password: Kkn,
  cannot_create_account_password_cal_provider: Zkn,
  cannot_create_account_password_already_existing: Xkn,
  create_account_password_hint: Jkn,
  disconnect_account: Qkn,
  disconnect_account_hint: e0n,
  cookie_consent_checkbox: t0n,
  make_a_call: n0n,
  skip_rr_assignment_label: o0n,
  skip_rr_description: r0n,
  select_account_header: i0n,
  select_account_description: a0n,
  select_event_types_header: s0n,
  select_event_types_description: c0n,
  configure_app_header: l0n,
  configure_app_description: u0n,
  already_installed: d0n,
  ooo_reasons_unspecified: _0n,
  ooo_reasons_vacation: p0n,
  ooo_reasons_travel: m0n,
  ooo_reasons_sick_leave: f0n,
  ooo_reasons_public_holiday: g0n,
  ooo_forwarding_to: h0n,
  ooo_not_forwarding: v0n,
  ooo_empty_title: b0n,
  ooo_empty_description: y0n,
  ooo_user_is_ooo: $0n,
  ooo_slots_returning: w0n,
  ooo_slots_book_with: k0n,
  ooo_select_reason: S0n,
  create_an_out_of_office: E0n,
  edit_an_out_of_office: x0n,
  submit_feedback: C0n,
  host_no_show: T0n,
  no_show_description: A0n,
  how_can_we_improve: I0n,
  most_liked: O0n,
  review: N0n,
  reviewed: z0n,
  unreviewed: R0n,
  rating_url_variable: P0n,
  rating_url_info: D0n,
  no_show_url_variable: L0n,
  no_show_url_info: M0n,
  no_support_needed: F0n,
  hide_support: q0n,
  event_ratings: j0n,
  event_no_show: V0n,
  event_no_show_guest: B0n,
  recent_ratings: U0n,
  no_ratings: G0n,
  no_ratings_description: W0n,
  most_no_show_host: H0n,
  highest_rated: Y0n,
  lowest_rated: K0n,
  highest_rated_members: Z0n,
  lowest_rated_members: X0n,
  csat_score: J0n,
  lockedSMS: Q0n,
  leave_without_assigning_anyone: e1n,
  leave_without_adding_attendees: t1n,
  no_availability_shown_to_bookers: n1n,
  go_back_and_assign: o1n,
  leave_without_assigning: r1n,
  signing_up_terms: i1n,
  proceeding_agreement: a1n,
  terms: s1n,
  always_show_x_days: c1n,
  always_show_x_days_description: l1n,
  team_subscription_cancelled_successfully: u1n,
  team_subscription_cancellation_error: d1n,
  unable_to_subscribe_to_the_platform: _1n,
  updating_oauth_client_error: p1n,
  creating_oauth_client_error: m1n,
  event_type_color: f1n,
  event_type_color_description: g1n,
  mark_as_no_show_title: h1n,
  x_marked_as_no_show: v1n,
  x_unmarked_as_no_show: b1n,
  team_select_info: y1n,
  team_settings_description: $1n,
  no_show_updated: w1n,
  email_copied: k1n,
  phone_number_copied: S1n,
  USER_PENDING_MEMBER_OF_THE_ORG: E1n,
  USER_ALREADY_INVITED_OR_MEMBER: x1n,
  USER_MEMBER_OF_OTHER_ORGANIZATION: C1n,
  booking_reassigned: T1n,
  reassign: A1n,
  reassign_to_another_rr_host: I1n,
  assign_team_member: O1n,
  override_team_member_to_assign: N1n,
  no_available_hosts: z1n,
  reassign_round_robin_host: R1n,
  skip_writing_to_calendar: P1n,
  rescheduling_not_possible: D1n,
  event_expired: L1n,
  skip_contact_creation: M1n,
  skip_writing_to_calendar_note: F1n,
  attributes: q1n,
  new_attribute: j1n,
  add_attributes: V1n,
  add_attributes_description: B1n,
  new_option: U1n,
  update_profile: G1n,
  attribute: W1n,
  create_attribute_description: H1n,
  edit_attribute_description: Y1n,
  attribute_updated_successfully: K1n,
  attribute_deleted_successfully: Z1n,
  attributes_edited_successfully: X1n,
  attribute_meta_description: J1n,
  attributes_edit_description: Q1n,
  back_to_attributes: eSn,
  delete_attribute: tSn,
  delete_attribute_description: nSn,
  disable_all_emails_to_attendees: oSn,
  disable_all_emails_description: rSn,
  disable_all_emails_to_hosts: iSn,
  type_confirm_to_continue: aSn,
  disable_email: sSn,
  grant_admin_api: cSn,
  revoke_admin_api: lSn,
  add_calendar_label: uSn,
  apple_connect_atom_label: dSn,
  apple_connect_atom_already_connected_label: _Sn,
  apple_connect_atom_loading_label: pSn,
  google_connect_atom_label: mSn,
  google_connect_atom_already_connected_label: fSn,
  google_connect_atom_loading_label: gSn,
  outlook_connect_atom_label: hSn,
  outlook_connect_atom_already_connected_label: vSn,
  outlook_connect_atom_loading_label: bSn,
  stripe_connect_atom_label: ySn,
  stripe_connect_atom_already_connected_label: $Sn,
  stripe_connect_atom_loading_label: wSn,
  booking_question_response_variables: kSn,
  managed_by_teamAdmins: SSn,
  number_of_options: ESn,
  reschedule_with_same_round_robin_host_title: xSn,
  reschedule_with_same_round_robin_host_description: CSn,
  disable_input_if_prefilled: TSn,
  booking_limits: ASn,
  booking_limits_team_description: ISn,
  limit_team_booking_frequency_description: OSn,
  booking_limits_updated_successfully: NSn,
  you_are_unauthorized_to_make_this_change_to_the_booking: zSn,
  delegation_credential_disabled: RSn,
  matching_members: PSn,
  x_matching_members: DSn,
  matching_members_queue_using_attribute_weights: LSn,
  matching_members_queue_using_event_assignee_weights: MSn,
  no_matching_members: FSn,
  no_matching_members_will_fallback_to_all_assigned_members: qSn,
  hide_calendar_event_details: jSn,
  description_hide_calendar_event_details: VSn,
  last_number_of_days: BSn,
  month_to_date: USn,
  year_to_date: GSn,
  custom_range: WSn,
  refund_policy: HSn,
  always: YSn,
  never: KSn,
  payment_option: ZSn,
  if_cancelled: XSn,
  before: JSn,
  show_all_columns: QSn,
  toggle_columns: eEn,
  no_columns_found: tEn,
  salesforce_create_record_as: nEn,
  salesforce_lead: oEn,
  salesforce_contact_under_account: rEn,
  salesforce_skip_entry_creation: iEn,
  salesforce_if_account_does_not_exist: aEn,
  salesforce_create_new_contact_under_account: sEn,
  salesforce_change_record_owner_on_booking: cEn,
  mass_assign_attributes: lEn,
  reroute_preview_custom_message: uEn,
  reroute_preview_external_redirect: dEn,
  reroute_preview_possible_host: _En,
  current_routing_status: pEn,
  reroute_booking: mEn,
  reroute_booking_description: fEn,
  verify_new_route: gEn,
  reroute: hEn,
  new_routing_status: vEn,
  salesforce_book_directly_with_attendee_owner: bEn,
  salesforce_check_owner_of: yEn,
  account: $En,
  choose_hosts_schedule: wEn,
  hosts_schedule_description: kEn,
  no_hosts_description: SEn,
  team_member_round_robin_reassign: EEn,
  team_member_round_robin_reassign_description: xEn,
  round_robin_reassign_description: CEn,
  invalid_round_robin_host: TEn,
  user_is_round_robin_fixed: AEn,
  reschedule_with_same_timeslot: IEn,
  reschedule_with_same_timeslot_of_new_event: OEn,
  reschedule_to_the_new_event_with_different_timeslot: NEn,
  reschedule_with_different_timeslot: zEn,
  we_dont_have_id_for_the_new_event: REn,
  rerouted_booking_successfully_redirecting_to_booking_page: PEn,
  on_booking_write_to_event_object: DEn,
  field_name: LEn,
  add_new_field: MEn,
  you_dont_have_access_to_reroute_this_booking: FEn,
  form_response_not_found: qEn,
  contact_owner: jEn,
  contact_owner_not_found: VEn,
  using_fallback_members: BEn,
  chosen_route: UEn,
  attribute_logic_matched: GEn,
  attribute_logic_fallback_matched: WEn,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: HEn,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: YEn,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: KEn,
  warning: ZEn,
  fallback_attribute_logic_description: XEn,
  fallback_attribute_logic_warning: JEn,
  fallback_not_needed: QEn,
  confirm_reassign_unavailable: exn,
  confirm_reassign_available: txn,
  reassign_unavailable_team_member_description: nxn,
  reassign_available_team_member_description: oxn,
  yes_reassign: rxn,
  filter_by_attributes: ixn,
  reassign_reason: axn,
  field_type_change_suggestion: sxn,
  reassigned_by: cxn,
  row: lxn,
  rows: uxn,
  attendee_timezone_variable: dxn,
  event_start_time_in_attendee_timezone_variable: _xn,
  event_start_time_in_attendee_timezone_info: pxn,
  event_end_time_in_attendee_timezone_info: mxn,
  event_end_time_in_attendee_timezone_variable: fxn,
  salesforce_create_event_on_contact: gxn,
  salesforce_owner_name_to_change: hxn,
  no_filter_set: vxn,
  booking_dry_run_successful: bxn,
  booking_dry_run_successful_description: yxn,
  dont_have_access_this_page: $xn,
  you_need_admin_or_owner_privileges_to_access: wxn,
  field_type: kxn,
  when_to_write: Sxn,
  salesforce_on_booking_write_to_record: Exn,
  on_every_booking: xxn,
  only_if_field_is_empty: Cxn,
  booking_start_date: Txn,
  booking_created_date: Axn,
  booking_reassigned_to_host: Ixn,
  no_contact_owner: Oxn,
  routing_forms_created: Nxn,
  routing_forms_total_responses: zxn,
  routing_forms_total_responses_without_booking: Rxn,
  routing_forms_total_responses_with_booking: Pxn,
  routing_form_insights: Dxn,
  routing_form_insights_form_name_header: Lxn,
  routing_form_insights_booking_status_header: Mxn,
  routing_form_insights_response_no_booking: Fxn,
  routing_form_insights_booked_by: qxn,
  routing_form_insights_created_at: jxn,
  routing_form_insights_booking_status: Vxn,
  routing_form_insights_booking_at: Bxn,
  routing_form_insights_submitted_at: Uxn,
  copy_redirect_url: Gxn,
  redirect_url_on_exit: Wxn,
  total_bookings_per_period: Hxn,
  routed_to_per_period: Yxn,
  per_day: Kxn,
  per_week: Zxn,
  per_month: Xxn,
  routing_form_insights_assignment_reason: Jxn,
  access_denied: Qxn,
  salesforce_route_to_owner: eCn,
  salesforce_add_attendees_as: tCn,
  salesforce_do_not_route_to_owner: nCn,
  salesforce_route_to_custom_lookup_field: oCn,
  salesforce_option: rCn,
  lookup_field_name: iCn,
  salesforce_if_free_email_domain_skip_owner_check: aCn,
  filter_operator_is: sCn,
  filter_operator_is_not: cCn,
  filter_operator_contains: lCn,
  filter_operator_does_not_contain: uCn,
  filter_operator_starts_with: dCn,
  filter_operator_ends_with: _Cn,
  filter_operator_is_empty: pCn,
  filter_operator_not_empty: mCn,
  translate_description_button: fCn,
  translate_description_button_description: gCn,
  rr_distribution_method: hCn,
  rr_distribution_method_description: vCn,
  rr_distribution_method_availability_title: bCn,
  rr_distribution_method_availability_description: yCn,
  rr_distribution_method_balanced_title: $Cn,
  rr_distribution_method_balanced_description: wCn,
  edit_team_member_weights: kCn,
  weights_updated_successfully: SCn,
  require_confirmation_for_free_email: ECn,
  exclude_emails_that_contain: xCn,
  require_emails_that_contain: CCn,
  exclude_emails_match_found_error_message: TCn,
  require_emails_no_match_found_error_message: ACn,
  search_columns: ICn,
  search_options: OCn,
  disable_org_url_label: NCn,
  disable_org_url_description: zCn,
  single_select: RCn,
  multi_select: PCn,
  calendar_conflict_settings: DCn,
  select_calendars_conflict_check: LCn,
  group_meeting: MCn,
  are_you_sure_you_want_to_remove_this_app_from: FCn,
  disconnect_app_from: qCn,
  salesforce_ignore_guests: jCn,
  google_meet: VCn,
  zoom: BCn,
  office_365_video: UCn,
  lock_attribute_for_assignment: GCn,
  lock_attribute_for_assignment_description: WCn,
  attribute_edited_successfully: HCn,
  new_group_option: YCn,
  attribute_weight_enabled: KCn,
  attribute_weight_enabled_description: ZCn,
  routed: XCn,
  reassigned: JCn,
  allow_rescheduling_past_events: QCn,
  allow_rescheduling_past_events_description: eTn,
  rerouted: tTn,
  salesforce_assigned: nTn,
  router_position: oTn,
  show_matching_hosts: rTn,
  no_active_queues: iTn,
  weight: aTn,
  calibration: sTn,
  shortfall: cTn,
  routing_form: lTn,
  go_back_and_save: uTn,
  save_changes: dTn,
  leave_without_saving: _Tn,
  leave_without_saving_description: pTn,
  something_unexpected_occurred: mTn,
  "500_error_message": "It's not you, it's us.",
  dry_run_mode_active: fTn,
  icon_showcase: gTn,
  icons_showcase: hTn,
  migrating_from_team: vTn,
  feature_currently_disabled: bTn,
  choose_an_option: yTn,
  enter_option_value: $Tn,
  remove_option: wTn,
  use_attribute_weights: kTn,
  if_enabled_ignore_event_type_weights: STn,
  attribute_for_weights: ETn,
  managed_users: xTn,
  managed_users_description: CTn,
  can_you_tell_me_about: TTn,
  use_ai_to_answer_your_questions: ATn,
  error_fetching_answer: ITn,
  k_bar_ai_error: OTn,
  select_oAuth_client: NTn,
  on_every_instance: zTn,
  delegation_credential_feature_not_enabled: RTn,
  internal_booking_note: PTn,
  internal_note_cancellation_reason: DTn,
  internal_booking_note_description: LTn,
  internal_note_presets: MTn,
  internal_note_presets_description: FTn,
  internal_note_presets_updated_successfully: qTn,
  add_preset: jTn,
  authorize: VTn,
  next: BTn,
  hide: UTn,
  show: GTn,
  utm_params: WTn,
  no_utm_params: HTn,
  asc: YTn,
  desc: KTn,
  verify_email_change: ZTn,
  buy_credits: XTn,
  credits: JTn,
  credits_used: QTn,
  total_credits_remaining: eAn,
  credits_per_tip_org: tAn,
  credits_per_tip_teams: nAn,
  view_and_manage_credits: oAn,
  view_and_manage_credits_description: rAn,
  credit_worth_description: iAn,
  buy_additional_credits: aAn,
  view_additional_credits_expense_tip: sAn,
  overview: cAn,
  organization_slug_taken: lAn,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: uAn,
  you_need_to_complete_user_onboarding_before_creating_an_organization: dAn,
  use_company_email_to_create_an_organization: _An,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: pAn,
  you_need_to_have_minimum_published_teams: mAn,
  you_are_part_of_this_organization_already: fAn,
  you_are_part_of_another_organization_cannot_create_organization: gAn,
  you_are_part_of_another_platform_organization_cannot_create_organization: hAn,
  organization_payment_success: vAn,
  organization_payment_success_description: bAn,
  this_may_take_a_few_seconds: yAn,
  organization_onboarding_status: $An,
  organization_onboarding_status_description: wAn,
  payment_failed: kAn,
  payment_failed_description: SAn,
  creating_your_organization: EAn,
  organization_onboarding_already_completed: xAn,
  organization_onboarding_already_exists: CAn,
  organization_onboarding_not_found: TAn,
  no_onboarding_id_provided: AAn,
  onboarding_not_found: IAn,
  onboarding_already_complete: OAn,
  onboarding_already_complete_description: NAn,
  resume_onboarding: zAn,
  resume_onboarding_description: RAn,
  payment_successful: PAn,
  handover_onboarding_page_title: DAn,
  handover_onboarding_page_description: LAn,
  organization_already_exists_with_this_slug: MAn,
  you_do_not_have_permission_to_create_an_organization_for_this_email: FAn,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: qAn,
  organization_has_subscription_already: jAn,
  reset_interval_weighted_rr: VAn,
  interval: BAn,
  rr_reset_interval_description: UAn,
  daily: GAn,
  end_date_not_selected: WAn,
  my_ooo: HAn,
  team_ooo: YAn,
  out_of_office_team_description: KAn,
  create_ooo_dialog_team_title: ZAn,
  create_ooo_dialog_team_subtitle: XAn,
  edit_ooo_dialog_team_subtitle: JAn,
  ooo_team_empty_title: QAn,
  ooo_team_empty_description: e2n,
  forward_to_team_member_only: t2n,
  ooo_team_redirect_infinite_not_allowed: n2n,
  previous_ooo_empty_title: o2n,
  previous: r2n,
  rr_interval_successfully_updated: i2n,
  trial_mode: a2n,
  inactive_team_plan: s2n,
  inactive_team_plan_description: c2n,
  limited_access_trial_mode: l2n,
  referral_program: u2n,
  referral_text: d2n,
  dub_disabled_error_message: _2n,
  uid: p2n,
  link: m2n,
  rows_per_page: f2n,
  pagination_status: g2n,
  tip_username_plus: h2n,
  user_has_no_team_yet: v2n,
  no_team_members: b2n,
  recurring_event_doesnt_support_seats: y2n,
  booking_limit_per_booker_doesnt_support_recurring: $2n,
  seats_doesnt_support_recurring: w2n,
  recurring_event_seats_error: k2n,
  segment: S2n,
  saved_filters: E2n,
  rename: x2n,
  rename_segment: C2n,
  delete_segment: T2n,
  duplicate_segment: A2n,
  delete_segment_confirmation: I2n,
  filter_segment_updated: O2n,
  error_updating_filter_segment: N2n,
  filter_segment_duplicated: z2n,
  error_duplicating_filter_segment: R2n,
  filter_segment_deleted: P2n,
  error_deleting_filter_segment: D2n,
  save_segment: L2n,
  segment_not_found: M2n,
  filter_segment_saved: F2n,
  no_segments: q2n,
  error_saving_filter_segment: j2n,
  override_segment: V2n,
  create_new_segment: B2n,
  save_for_team: U2n,
  select_team: G2n,
  please_select_team: W2n,
  personal: H2n,
  hide_team_profile_link: Y2n,
  hide_team_profile_link_description: K2n,
  display: Z2n,
  could_not_find_slug_to_publish_org: X2n,
  picklist: J2n,
  most_cancelled_bookings: Q2n,
  interface_language: eIn,
  interface_language_description: tIn,
  visitors_browser_language: nIn,
  name_or_email: oIn,
  salesforce_round_robin_skip_fallback_to_lead_owner: rIn,
  credit_purchase_failed: iIn,
  minimum_of_credits_required: aIn,
  enable_delegation_credential: sIn,
  enable_delegation_credential_description: cIn,
  disable_delegation_credential: lIn,
  disable_delegation_credential_description: uIn,
  last_active: dIn,
  member_since: _In,
  last_updated: pIn,
  salesforce_on_cancel_write_to_event: mIn,
  salesforce_on_every_cancellation: fIn,
  report_issue: gIn,
  report_issue_description: hIn,
  open_issue: vIn,
  this_is_your_current_plan: bIn,
  schedule_a_time: yIn,
  this_includes: $In,
  oauth_client_updated_successfully: wIn,
  oauth_client_not_found: kIn,
  subscribe_to_platform: SIn,
  error_accessing_webhooks: EIn,
  webhook_update_failed: xIn,
  webhook_create_failed: CIn,
  invalid_link: TIn,
  currently_subscribed_to_plan: AIn,
  user_team: IIn,
  client_id_copied: OIn,
  client_secret_copied: NIn,
  maintenance_message: zIn,
  your_payment_failed: RIn,
  check_your_inbox: PIn,
  account_created_premium_not_reserved: DIn,
  email_sent_with_activation_link: LIn,
  activate_account_to_purchase_username: MIn,
  open_in_gmail: FIn,
  dont_see_email: qIn,
  resend_in_seconds: jIn,
  resend: VIn,
  verification_email_sent: BIn,
  select_all_members: UIn,
  select_all_members_tooltip: GIn,
  form_settings: WIn,
  remove_whitelist_status: HIn,
  whitelist_user_workflows: YIn,
  user_workflows_whitelisted: KIn,
  user_workflows_unwhitelisted: ZIn,
  date_and_time: XIn,
  email_reminder_upcoming_event_notice: JIn,
  email_reminder_triggered_by_workflow: QIn,
  event_upper_case: eOn,
  scheduling_by: tOn,
  experience_review_prompt: nOn,
  improve_customer_experience_message: oOn,
  meeting_satisfaction_question: rOn,
  meeting_not_joined_question: iOn,
  reschedule_cta_short: aOn,
  hide_organizer_email: sOn,
  platform_customer_cant_create_organization: cOn,
  organization_customer_cant_create_platform: lOn,
  hide_organizer_email_description: uOn,
  you_and_conjunction: dOn,
  select_verified_email: _On,
  add_verified_email: pOn,
  add_verified_emails: mOn,
  custom_reply_to_email_title: fOn,
  custom_reply_to_email_description: gOn,
  email_survey_triggered_by_workflow: hOn,
  skip_trial: vOn,
  team_trials_skipped_successfully: bOn,
  sms_workflow_consent: yOn,
  routing_preview_more_info_found_insights: $On,
  results: wOn,
  view_form: kOn,
  sms_opt_out_message: SOn,
  team_credits_low_warning: EOn,
  user_credits_low_warning: xOn,
  action_required_out_of_credits: COn,
  action_required_user_out_of_credits: TOn,
  low_credits_warning_message: AOn,
  low_credits_warning_message_user: IOn,
  credit_limit_reached_message: OOn,
  credit_limit_reached_message_user: NOn,
  current_credit_balance: zOn,
  current_balance: ROn,
  notification_about_your_booking: POn,
  monthly_credits: DOn,
  total_credits: LOn,
  remaining_credits: MOn,
  remaining: FOn,
  total: qOn,
  additional_credits: jOn,
  routing_form_next_in_queue: VOn,
  routing_form_select_members_to_email: BOn,
  routing_incomplete_booking_tab: UOn,
  include_no_show_in_rr_calculation: GOn,
  recent_no_show_guests: WOn,
  recent_no_show_guests_tooltip: HOn,
  matching: YOn,
  event_redirect: KOn,
  reset_form: ZOn,
  rr_settings_successfully_updated: XOn,
  distribution_basis_weighted_rr: JOn,
  timestamp_basis_description: QOn,
  requires_credits: eNn,
  requires_credits_tooltip: tNn,
  available_credits: nNn,
  create_role: oNn,
  roles: rNn,
  roles_and_permissions: iNn,
  roles_and_permissions_description: aNn,
  learn_more_permissions: sNn,
  role_name: cNn,
  role_name_required: lNn,
  role_name_placeholder: uNn,
  role_description: dNn,
  role_description_placeholder: _Nn,
  default_role: pNn,
  custom_role: mNn,
  advanced: fNn,
  search_permissions: gNn,
  all_permissions: hNn,
  none: vNn,
  read_only: bNn,
  pbac_desc_all_actions_all_resources: yNn,
  pbac_resource_all: $Nn,
  pbac_resource_event_type: wNn,
  pbac_resource_team: kNn,
  pbac_resource_organization: SNn,
  pbac_resource_booking: ENn,
  pbac_resource_insights: xNn,
  pbac_resource_role: CNn,
  pbac_resource_routing_form: TNn,
  pbac_resource_workflow: ANn,
  pbac_action_all: INn,
  pbac_action_create: ONn,
  pbac_action_read: NNn,
  pbac_action_update: zNn,
  pbac_action_delete: RNn,
  pbac_action_manage: PNn,
  pbac_action_invite: DNn,
  pbac_action_remove: LNn,
  pbac_action_change_member_role: MNn,
  pbac_action_list_members: FNn,
  pbac_action_manage_billing: qNn,
  pbac_action_read_team_bookings: jNn,
  pbac_action_read_org_bookings: VNn,
  pbac_action_read_recordings: BNn,
  pbac_action_impersonate: UNn,
  role_created_successfully: GNn,
  role_updated_successfully: WNn,
  delete_role: HNn,
  confirm_delete_role: YNn,
  role_deleted_successfully: KNn,
  error_creating_role: ZNn,
  error_updating_role: XNn,
  pbac_desc_create_roles: JNn,
  pbac_resource_attributes: QNn,
  pbac_desc_view_organization_attributes: ezn,
  pbac_desc_update_organization_attributes: tzn,
  pbac_desc_delete_organization_attributes: nzn,
  pbac_desc_create_organization_attributes: ozn,
  pbac_desc_view_roles: rzn,
  pbac_desc_update_roles: izn,
  pbac_desc_delete_roles: azn,
  pbac_desc_create_workflows: szn,
  set_up_required: czn,
  pbac_desc_view_workflows: lzn,
  pbac_desc_update_workflows: uzn,
  pbac_desc_delete_workflows: dzn,
  pbac_resource_webhook: _zn,
  pbac_resource_availability: pzn,
  pbac_resource_out_of_office: mzn,
  pbac_resource_blocklist: fzn,
  pbac_desc_create_webhooks: gzn,
  pbac_desc_view_webhooks: hzn,
  pbac_desc_update_webhooks: vzn,
  pbac_desc_delete_webhooks: bzn,
  pbac_desc_create_availability: yzn,
  pbac_desc_view_availability: $zn,
  pbac_desc_update_availability: wzn,
  pbac_desc_delete_availability: kzn,
  pbac_desc_create_out_of_office: Szn,
  pbac_desc_view_out_of_office: Ezn,
  pbac_desc_update_out_of_office: xzn,
  pbac_desc_delete_out_of_office: Czn,
  pbac_desc_manage_workflows: Tzn,
  pbac_desc_create_event_types: Azn,
  pbac_desc_view_event_types: Izn,
  pbac_desc_update_event_types: Ozn,
  pbac_desc_delete_event_types: Nzn,
  pbac_desc_manage_event_types: zzn,
  pbac_desc_create_teams: Rzn,
  pbac_desc_view_team_details: Pzn,
  pbac_desc_update_team_settings: Dzn,
  pbac_desc_delete_team: Lzn,
  pbac_desc_invite_team_members: Mzn,
  pbac_desc_remove_team_members: Fzn,
  pbac_desc_change_team_member_role: qzn,
  pbac_desc_impersonate_team_members: jzn,
  pbac_desc_manage_teams: Vzn,
  pbac_desc_create_organization: Bzn,
  pbac_desc_view_organization_details: Uzn,
  pbac_desc_list_organization_members: Gzn,
  pbac_desc_invite_organization_members: Wzn,
  pbac_desc_remove_organization_members: Hzn,
  pbac_desc_manage_organization_billing: Yzn,
  pbac_desc_change_organization_member_role: Kzn,
  pbac_desc_impersonate_organization_members: Zzn,
  pbac_desc_edit_organization_settings: Xzn,
  pbac_desc_manage_organizations: Jzn,
  pbac_desc_view_bookings: Qzn,
  pbac_desc_view_team_bookings: eRn,
  pbac_desc_view_organization_bookings: tRn,
  pbac_desc_view_booking_recordings: nRn,
  pbac_desc_update_bookings: oRn,
  pbac_desc_manage_bookings: rRn,
  pbac_desc_view_team_insights: iRn,
  pbac_desc_manage_team_insights: aRn,
  pbac_desc_create_routing_forms: sRn,
  pbac_desc_view_routing_forms: cRn,
  pbac_desc_update_routing_forms: lRn,
  pbac_desc_delete_routing_forms: uRn,
  pbac_opt_in_title: dRn,
  pbac_opt_in_description: _Rn,
  pbac_opt_in_custom_roles_title: pRn,
  pbac_opt_in_custom_roles_desc: mRn,
  pbac_opt_in_granular_permissions_title: fRn,
  pbac_opt_in_granular_permissions_desc: gRn,
  pbac_opt_in_team_assignment_title: hRn,
  pbac_opt_in_team_assignment_desc: vRn,
  pbac_opt_in_enhanced_security_title: bRn,
  pbac_opt_in_enhanced_security_desc: yRn,
  pbac_opt_in_enable_button: $Rn,
  pbac_enabled_success: wRn,
  pbac_enabled_error: kRn,
  read_permission_auto_enabled_tooltip: SRn,
  choose_restriction_schedule: ERn,
  restriction_schedule_description: xRn,
  use_booker_timezone: CRn,
  use_booker_timezone_info: TRn,
  load_balancing_warning: ARn,
  rr_load_balancing_disabled: IRn,
  rr_load_balancing_disabled_with_groups: ORn,
  round_robin_settings_description: NRn,
  round_robin_settings_updated_successfully: zRn,
  booking_creation_time: RRn,
  meeting_start_time: PRn,
  members_affected_by_disabling_delegation_credential: DRn,
  no_members_affected_by_disabling_delegation_credential: LRn,
  download_expense_log: MRn,
  error_downloading_expense_log: FRn,
  require_booker_email_verification: qRn,
  require_booker_email_verification_description: jRn,
  offer_to_reschedule_last_booking: VRn,
  booker_limit_exceeded_error: BRn,
  booker_limit_exceeded_error_reschedule: URn,
  duration_min_error: GRn,
  duration_max_error: WRn,
  booking_not_allowed_by_restriction_schedule_error: HRn,
  restriction_schedule_not_found_error: YRn,
  converted_image_size_limit_exceed: KRn,
  add_group: ZRn,
  routing_funnel: XRn,
  routing_funnel_total_submissions: JRn,
  routing_funnel_successful_routings: QRn,
  routing_funnel_accepted_bookings: ePn,
  license_key: tPn,
  license_selection_title: nPn,
  license_selection_description: oPn,
  agplv3_license_description: rPn,
  enter_license_key: iPn,
  enter_your_license_key: aPn,
  enter_existing_license: sPn,
  enter_license_key_description: cPn,
  license_key_placeholder: lPn,
  save_license_key: uPn,
  signature_token_optional: dPn,
  signature_token_description: _Pn,
  need_a_license: pPn,
  license_key_required: mPn,
  invalid_license_key: fPn,
  license_validation_failed: gPn,
  attachments_optional: hPn,
  send_message: vPn,
  describe_the_issue: bPn,
  file_size_limit_exceed: yPn,
  invalid_file_type: $Pn,
  invalid_file_type_extension: wPn,
  max_files_exceeded: kPn,
  files_uploaded_successfully: SPn,
  file_upload_instructions: EPn,
  license_key_saved: xPn,
  timezone_mismatch_tooltip: CPn,
  show_optimized_slots: TPn,
  show_optimized_slots_description: APn,
  failed_bookings_by_field: IPn,
  failed_bookings: OPn,
  event_type_no_hosts: NPn,
  cache_status: zPn,
  cache_last_updated: RPn,
  delete_cached_data: PPn,
  cache_deleted_successfully: DPn,
  error_deleting_cache: LPn,
  confirm_delete_cache: MPn,
  yes_delete_cache: FPn,
  remainder_of_maximum_uses_left_plural: qPn,
  remainder_of_maximum_use_left_singular: jPn,
  expires_on_date: VPn,
  single_use: BPn,
  time_based_expiration: UPn,
  usage_based_expiration: GPn,
  number_of_uses: WPn,
  expires_on: HPn,
  max_usage_count: YPn,
  link_settings: KPn,
  link_expired_on_date: ZPn,
  usage_limit_reached: XPn,
  usage_count_error: JPn,
  private_link_expired: QPn,
  time_based_expiration_description: eDn,
  time_based_generic_expiration_description: tDn,
  usage_based_expiration_description: nDn,
  usage_based_generic_expiration_description: oDn,
  usage_based_expiration_description_plural: rDn,
  webhook_trigger_event: iDn,
  webhook_created_at: aDn,
  webhook_type: sDn,
  set_up_agent: cDn,
  webhook_title: lDn,
  webhook_start_time: uDn,
  webhook_end_time: dDn,
  webhook_description: _Dn,
  webhook_location: pDn,
  webhook_uid: mDn,
  webhook_reschedule_uid: fDn,
  webhook_cancellation_reason: gDn,
  webhook_rejection_reason: hDn,
  webhook_organizer_name: vDn,
  webhook_organizer_email: bDn,
  webhook_organizer_timezone: yDn,
  webhook_organizer_locale: $Dn,
  webhook_organizer_username: wDn,
  webhook_organizer_username_in_org: kDn,
  webhook_attendee_name: SDn,
  webhook_attendee_email: EDn,
  webhook_attendee_timezone: xDn,
  webhook_attendee_locale: CDn,
  webhook_team_name: TDn,
  webhook_team_members: ADn,
  webhook_video_call_url: IDn,
  webhook_hide_variables: ODn,
  webhook_show_variable: NDn,
  webhook_event_and_booking: zDn,
  webhook_people: RDn,
  webhook_teams: PDn,
  webhook_metadata: DDn,
  stats: LDn,
  booking_status: MDn,
  form_submitted_trigger: FDn,
  form_submitted_no_event_trigger: qDn,
  how_long_after_form_submitted_no_event: jDn,
  visit: VDn,
  location_custom_label_input_label: BDn,
  meeting_link: UDn,
  session_outcome: GDn,
  call_created: WDn,
  voicemail: HDn,
  my_bookings: YDn,
  phone: KDn,
  free: ZDn,
  user_email: XDn,
  user_name: JDn,
  expand_panel: QDn,
  collapse_panel: e3n,
  email_verification_required: t3n,
  invalid_verification_code: n3n,
  you_have_one_team: o3n,
  consider_consolidating_one_team_org: r3n,
  consider_consolidating_multi_team_org: i3n,
  message_sent: a3n,
  support_message_sent_description: s3n,
  search_variables: c3n,
  support_message_placeholder: l3n,
  send_another_message: u3n,
  sending: d3n,
  no_variables_found: _3n,
  credits_required: p3n,
  web_call_credits_info: m3n,
  web_call_no_credits: f3n,
  purchase_credits: g3n,
  credits_required_tooltip: h3n,
  api_key_name_too_long: v3n,
  auto_charge_for_last_minute_cancellation: b3n,
  before_scheduled_start_time: y3n,
  cancel_booking_acknowledge_no_show_fee: $3n,
  contact_organizer: w3n,
  booking_time_option: k3n,
  booking_time_option_description: S3n,
  created_at_option: E3n,
  created_at_option_description: x3n,
  call_details: C3n,
  call_id: T3n,
  call_information: A3n,
  sentiment: I3n,
  disconnect_reason: O3n,
  call_summary: N3n,
  transcription: z3n,
  event_details: R3n,
  agent: P3n,
  no_transcript_available: D3n,
  testing_sms_workflow_info_message: L3n,
  start_from_scratch_title: M3n,
  start_from_scratch_description: F3n,
  cal_ai_template_title: q3n,
  cal_ai_template_description: j3n,
  voice: V3n,
  select_voice: B3n,
  select_voice_for_agent: U3n,
  choose_a_voice_for_your_agent: G3n,
  trait: W3n,
  voice_id: H3n,
  use_voice: Y3n,
  current_voice: K3n,
  setup_incoming_agent: Z3n,
  setup_incoming_agent_description: X3n,
  connect_a_phone_number_first: J3n,
  setup_agent_for_incoming_calls: Q3n,
  configure_agent_to_handle_incoming_calls: eLn,
  incoming_calls: tLn,
  outgoing_calls: nLn,
  booking_fields_email_and_phone_both_hidden: oLn,
  booking_fields_email_or_phone_required: rLn,
  booking_fields_phone_required_when_email_hidden: iLn,
  booking_fields_email_required_when_phone_hidden: aLn,
  inbound_agent_setup_success: sLn,
  inbound_agent_configured: cLn,
  setup_inbound_agent: lLn,
  please_select_event_type_first: uLn,
  edit_configuration: dLn,
  select_event_type_for_inbound_calls: _Ln,
  setup_inbound_agent_for_incoming_calls: pLn,
  create_block_entry: mLn,
  blocklist_entry_details: fLn,
  blocklist_entry_not_found: gLn,
  blocklist_entry_created: hLn,
  blocklist_entry_deleted: vLn,
  audit_history: bLn,
  no_audit_history: yLn,
  delete_blocklist_entry: $Ln,
  delete_blocklist_entry_confirmation: wLn,
  created_by: kLn,
  blocked_by: SLn,
  by: ELn,
  added: xLn,
  no_description_provided: CLn,
  organization_blocklist: TLn,
  manage_blocked_emails_and_domains: ALn,
  invalid_domain_format: ILn,
  invalid_email_address: OLn,
  reason_for_adding_to_blocklist: NLn,
  what_would_you_like_to_block: zLn,
  domain_name: RLn,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: PLn
}, DLn = "Proveedor de identidad", LLn = 'Tienes $t(day, {"count": {{days}} }) restantes en tu prueba PRO', MLn = "{{count}} día", FLn = "{{count}} días", qLn = "{{count}} segundo", jLn = "{{count}} segundos", VLn = "Actualizar ahora", BLn = "Sin título", ULn = "Aceptar invitación", GLn = "Máx. caracteres", WLn = "Mín. caracteres", HLn = "{{appName}} proporciona una infraestructura de programación para absolutamente todo el mundo.", YLn = "¡Termine de configurar su cuenta de {{appName}}! Está a solo unos pasos de resolver todos sus problemas de programación.", KLn = "¿Tienes preguntas? Estamos aquí para ayudar.", ZLn = "{{appName}}: Instrucciones para restablecer la contraseña", XLn = "{{appName}}: Verifique su cuenta", JLn = "{{appName}}: Verifica tu correo electrónico", QLn = "Revise su correo electrónico", eMn = "Correo electrónico antiguo", tMn = "Correo electrónico nuevo", nMn = "Enviamos un correo electrónico a {{email}}. Es importante que verifique su dirección de correo electrónico para garantizar que {{appName}} le ofrezca el mejor servicio de entrega de correos y calendarios.", oMn = "Verifique su dirección de correo electrónico para garantizar la mejor entrega de correo electrónico y calendario", rMn = "Verifique su dirección de correo electrónico", iMn = "Verificar correo electrónico", aMn = "Asistente", sMn = "Enviar correos con transcripción de Cal Video", cMn = "Enviar correos electrónicos con la transcripción del Cal Video después de que finalice la reunión. (Requiere un plan de pago)", lMn = "Recientemente has solicitado cambiar la dirección de correo electrónico que usas para iniciar sesión en tu cuenta de {{appName}}. Por favor, haz clic en el botón de abajo para confirmar tu nueva dirección de correo electrónico.", uMn = "Se ha actualizado tu correo electrónico a {{email}}", dMn = "No se pudo actualizar el correo electrónico.", _Mn = "Verifica tu nuevo correo electrónico de {{appName}}", pMn = "Hemos enviado un enlace de verificación a {{email}}. Actualizaremos tu dirección de correo electrónico una vez que hagas clic en este enlace.", mMn = "Guarde esta clave API en algún lugar seguro. No podrá volver a verla.", fMn = "Verifique su dirección de correo electrónico al hacer clic en el botón a continuación.", gMn = "Verifique su dirección de correo electrónico al hacer clic en el botón a continuación.", hMn = "Este es el enlace en caso de que no prefiera hacer clic en los botones:", vMn = "Ingrese el código de verificación", bMn = "Ingrese el código de verificación enviado a su correo", yMn = "El código de verificación es incorrecto.", $Mn = "Correo electrónico enviado correctamente", wMn = "Se produjo un error al enviar el correo electrónico", kMn = "Rechazado: {{title}} en {{date}}", SMn = "Cancelado: {{title}} el {{date}}", EMn = "Reasignado: {{title}} el {{date}}", xMn = "Su solicitud de reunión ha sido rechazada", CMn = "Personalizar ajustes de Cal Video", TMn = "Configura las preferencias de reuniones por video, incluyendo permisos de grabación para anfitriones y asistentes.", AMn = "Desactivar grabación para invitados", IMn = "Activar transcripción automática después de unirse a la reunión", OMn = "Habilitar grabación automática después de que el organizador se una a la reunión", NMn = "Opciones de video", zMn = "Editar evento", RMn = "Ver detalles de la sesión", PMn = "Detalles de la sesión de reunión", DMn = "Sesión de reunión", LMn = "ID de sesión", MMn = "Máximo de participantes", FMn = "Ilimitado", qMn = "En curso", jMn = "Finalizada", VMn = "Participantes", BMn = "Usuario anónimo", UMn = "Duración de la sesión", GMn = "No se encontraron sesiones de reunión", WMn = "No disponible", HMn = "Desactivar grabación para organizador", YMn = "Desactivar transcripción para invitados", KMn = "Desactivar transcripción para el organizador", ZMn = "Su solicitud de evento recurrente se ha rechazado", XMn = "Se canceló su evento programado", JMn = "Tu evento programado ha sido reasignado", QMn = "Ya no tendrás el evento en tu calendario y tu probabilidad de round robin no se verá afectada negativamente", e4n = "Organizador", t4n = "Reasignado a", n4n = "¿Necesita reprogramar o cancelar?", o4n = "Puedes ver los detalles de la reserva desde esta URL {{url}} y añadir el evento a tu calendario", r4n = "No hay opciones disponibles", i4n = "Motivo de la cancelación (opcional)", a4n = "Cancelado por", s4n = "Motivo de cancelación", c4n = "¿Por qué razón está cancelando?", l4n = "El motivo de la cancelación se compartirá con los invitados", u4n = "¿Por qué estás rechazando?", d4n = "Motivo del rechazo", _4n = "¿Rechazar la solicitud de reserva?", p4n = "¿Estás seguro de que deseas rechazar la reserva? Le haremos saber a la persona que ha intentado reservar. Puedes indicar una razón a continuación.", m4n = "Rechazar la reserva", f4n = "Administrar este evento", g4n = "Invite a un miembro del equipo", h4n = "Invitar individualmente", v4n = "Importar en masa", b4n = "Inv.", y4n = "Tu evento ha sido programado", $4n = "Su evento recurrente se ha programado", w4n = "Acepte nuestra licencia cambiando la variable .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> a '{{agree}}'.", k4n = "Para eliminar este banner, abra su archivo .env y cambie la variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> a '{{agree}}'.", S4n = "El mensaje de error fue: '{{errorMessage}}'", E4n = "Reembolso fallido: {{userName}} - {{date}} - {{eventType}}", x4n = "El reembolso del evento {{eventType}} con {{userName}} en {{date}} falló.", C4n = "Por favor, compruebe con su proveedor de pago y {{userName}} cómo manejar esto.", T4n = "Un reembolso falló", A4n = "Esperando pago: {{title}} en {{date}}", I4n = "Su reunión está a la espera de pago", O4n = "El color del tema oscuro no pasa la verificación de contraste. Recomendamos cambiar este color para que tus botones sean más visibles.", N4n = "El color del tema claro no pasa la verificación de contraste. Recomendamos cambiar este color para que tus botones sean más visibles.", z4n = "El color del tema claro no pasa la verificación de contraste. Recomendamos cambiar este color para que el color de tus tipos de eventos sea más visible.", R4n = "El color del tema oscuro no pasa la verificación de contraste. Recomendamos cambiar este color para que el color de tus tipos de eventos sea más visible.", P4n = "No se pudo crear el pago", D4n = "No se pudo cargar la tarjeta para el pago", L4n = "No se encontraron usuarios disponibles. ¿Podrías intentar en otro horario?", M4n = "El horario seleccionado ya no está disponible. <0>Por favor selecciona un nuevo horario</0>", F4n = "Ocupado", q4n = "Acabas de conectarte. Por favor, reserva desde los espacios de arriba o inténtalo más tarde.", j4n = "Horario no disponible", V4n = "Este tipo de evento no se puede reservar en este momento. ¿Podrías intentar con otro horario?", B4n = "Error interno. El cuerpo de la solicitud no contiene la hora de finalización", U4n = "No se pudo crear el evento en el calendario del organizador", G4n = "No se pudo actualizar el evento del calendario.", W4n = "No se pudo eliminar el evento del calendario.", H4n = "Ya estás registrado para esta reserva.", Y4n = "Algunos de los anfitriones no están disponibles para la reserva.", K4n = "Algunos de los anfitriones fijos no están disponibles para reservar.", Z4n = "El anfitrión de Round Robin no está disponible para reservas.", X4n = "Ayuda", J4n = "Precio", Q4n = "Pagado", e5n = "Reembolsado", t5n = "Grabar", n5n = "Transcribir", o5n = "Pago", r5n = "Faltan campos de la tarjeta", i5n = "Paga ahora", a5n = "Mensaje General", s5n = "Transcripción impulsada por IA", c5n = "Iniciar o detener grabación", l5n = "Iniciar Mensaje", u5n = "El código base debe permanecer en código abierto, si fue modificado o no", d5n = "No puede reempaquetar o vender el código base", _5n = "Adquiera una licencia comercial para eliminar estos términos por correo electrónico", p5n = "Resumen de los términos", m5n = "Abra .env y acepte nuestra licencia", f5n = "He cambiado mi .env", g5n = "Aceptar licencia", h5n = "Un evento aún está esperando su aprobación", v5n = "La solicitud del evento todavía está esperando: {{attendeeName}} - {{date}} - {{eventType}}", b5n = 'No se encontraron resultados para "{{searchTerm}}"', y5n = "No hay más resultados", $5n = "Sin resultados", w5n = "Cargar más resultados", k5n = "ID de la reunión {{integrationName}}: {{meetingId}}", S5n = "Confirma: {{eventType}} con {{name}} en {{date}}", E5n = "Nueva solicitud de evento: {{attendeeName}} - {{date}} - {{eventType}}", x5n = "Confirmar o rechazar la solicitud", C5n = "Consulta la página de reservas para confirmar o rechazar la reserva.", T5n = "Asistente de Registro", A5n = "Realiza una llamada saliente para verificar si la cita programada funciona o si deseas reprogramarla.", I5n = "Crea tu propio mensaje y úsalo para hacer una llamada saliente.", O5n = "Un nuevo evento espera su aprobación", N5n = "Un nuevo evento está esperando su aprobación", z5n = "Alguien ha solicitado programar un evento en su calendario.", R5n = "Alguien ha solicitado un enlace para cambiar su contraseña.", P5n = "Si este correo electrónico existe en nuestro sistema, debería recibir un correo electrónico de restablecimiento.", D5n = "Si usted no solicitó esto, puede ignorar este correo electrónico de forma segura y su contraseña no se cambiará.", L5n = "Esperando aprobación: {{title}} en {{date}}", M5n = "Un evento aún está esperando su aprobación", F5n = "Reserva enviada:{{title}} el {{date}}", q5n = "Descargar grabación: {{title}} el {{date}}", j5n = "Descargar Transcripción: {{title}} en {{date}}", V5n = "Descargue su grabación", B5n = "Descarga tus Transcripciones", U5n = "Su reunión ha sido reservada", G5n = "Tu {{title}} ha sido reprogramado para el {{date}}.", W5n = "Tu {{title}} ha sido actualizado.", H5n = "Tu evento ha sido reprogramado.", Y5n = "El evento ha sido actualizado", K5n = "Tu evento ha sido reprogramado", Z5n = "{{organizer}} ha cancelado la reserva y le ha solicitado que elija otra hora.", X5n = "Le ha solicitado a {{attendee}} que reprograme", J5n = "Usted ha cancelado la reserva y {{attendee}} deberá seleccionar una nueva hora de reserva con usted.", Q5n = "Solicitud de reprogramación enviada: {{eventType}} con {{name}} el {{date}}", e6n = "Reprogramar acción requerida: reserva una nueva hora para {{eventType}} con {{name}}", t6n = "Hola {{name}}", n6n = "{{eventType}} con {{name}}", o6n = "Parece que todos nuestros expertos están ocupados en este momento. Por favor, programa una llamada en el horario que mejor te convenga y estaremos listos para ayudarte.", r6n = "Programar ahora", i6n = "Nuevo Evento: {{attendeeName}} - {{date}} - {{eventType}}", a6n = "Únase por {{entryPoint}}", s6n = "Notas", c6n = "Gestionar mis reservas", l6n = "¿Necesitas hacer un cambio?", u6n = "Un nuevo evento ha sido programado.", d6n = "Se ha programado un nuevo evento recurrente.", _6n = "Email del Invitado", p6n = "Zona horaria del Invitado", m6n = "Tiempo restante", f6n = "Tipo de Evento", g6n = "Tipo de Evento Duplicado", h6n = "Entrar a la reunión", v6n = "Proveedor de videollamadas", b6n = "ID de Reunión", y6n = "Contraseña de la reunión", $6n = "URL de la reunión", w6n = "URL de la reunión no encontrada", k6n = "Token no encontrado", S6n = "Otro anfitrión ya aceptó la reunión. ¿Aún deseas unirte? <0>Continuar a la reunión</0>", E6n = "Su solicitud de reunión ha sido rechazada", x6n = "Rechazado: {{eventType}} con {{organizer}} en {{date}}", C6n = "Hola", T6n = "Unirse al Equipo", A6n = "Administrar este equipo", I6n = "Información del equipo", O6n = "Unirse a la Reunión", N6n = "Si prefiere no utilizar {{toEmail}} como su correo electrónico de {{appName}} o ya tiene una cuenta de {{appName}}, por favor solicite otra invitación a ese email.", z6n = "Has sido invitado a unirte al equipo {{teamName}}", R6n = "{{user}} lo invitó a unirse al equipo {{entity}} {{team}} en {{appName}}", P6n = "Estás oculto en este equipo", D6n = "No está paga tu plaza, actualiza a PRO o infórmale al propietario del equipo para que pague tu plaza.", L6n = "Necesitas una cuenta Pro para gestionar equipos, permanecerás oculto hasta que se realice la mejora.", M6n = "p.s. Expira en {{expiresIn}} horas.", F6n = "Actualiza a Por-Asiento", q6n = "La opción de plazas no admite el requisito de confirmación", j6n = "Múltiples ubicaciones no soportan la opción de asientos", V6n = "La tarifa por no presentarse no soporta la opción de asientos", B6n = "La opción de asientos no soporta múltiples ubicaciones", U6n = "De los {{memberCount}} miembros de su equipo, no se han pagado {{unpaidCount}} licencia(s). A {{seatPrice}} $/m por licencia, el coste total estimado de su membresía es de {{totalCost}} $/mes.", G6n = 'Gracias por probar nuestro nuevo plan de equipo. Notamos que su equipo "{{teamName}}" necesita actualizarse.', W6n = "Actualizar aquí", H6n = "¡Tu equipo se actualizó con éxito!", Y6n = 'Gracias por probar nuestro nuevo plan Organization. Notamos que su Organization "{{teamName}}" necesita actualizarse.', K6n = "Su Organization se actualizó con éxito.", Z6n = "Utilice el enlace de abajo para restablecer su contraseña", X6n = "Hola", J6n = "ahí", Q6n = "¿Olvidaste tu contraseña? - {{appName}}", eFn = "¿Está seguro de que desea eliminar este webhook? Ya no recibirá datos de reuniones de {{appName}} en una URL específica, en tiempo real, cuando se programe o cancele un evento.", tFn = "Sí, elimina este webhook", nFn = "Editar Webhook", oFn = "Eliminar Webhook", rFn = "Estado del Webhook", iFn = "Webhook habilitado", aFn = "Webhook Desactivado", sFn = "Respuesta del Webhook", cFn = "Prueba del Webhook", lFn = "Formulario de actualización de webhook", uFn = "Añade un webhook a tu cliente OAuth.", dFn = "Administra tu webhook", _Fn = "¡Webhook creado con éxito!", pFn = "¡Webhook actualizado con éxito!", mFn = "¡Webhook eliminado correctamente!", fFn = "Se requiere suscripción", gFn = "No estás suscrito a un plan de la plataforma.", hFn = "Plantilla de carga", vFn = "Rechazar", bFn = "Todavía no hay datos", yFn = "Prueba Ping", $Fn = "Agregue esta aplicación a su pantalla de inicio para un acceso más rápido y una experiencia mejorada.", wFn = "Próximamente", kFn = "Recurrente", SFn = "Pasado", EFn = "Elija un archivo...", xFn = "Cargar imagen", CFn = "Cargar {{target}}", TFn = "No {{target}}", AFn = "Desliza para hacer zoom, arrastra para reposicionar", IFn = "Ver notificaciones", OFn = "Ver página pública", NFn = "Copiar enlace de página pública", zFn = "Copiar enlace de referencia", RFn = "Cerrar sesión", PFn = "Añadir otro", DFn = "Instalar otra", LFn = "hasta el", MFn = "con tecnología de", FFn = "Indisponible", qFn = "Establezca su horario de trabajo", jFn = "Cambiar cuando está disponible para reservas", VFn = "Seleccionar...", BFn = "Texto", UFn = "Su número de teléfono", GFn = "Texto de varias líneas", WFn = "Número", HFn = "Casilla", YFn = "Es requerido", KFn = "Hacer que este campo sea obligatorio", ZFn = "Requerido", XFn = "Opcional", JFn = "Tipo de entrada", QFn = "Rechazado", eqn = "Sin confirmar", tqn = "Invitados", nqn = "Invitado", oqn = "Los detalles a seguir de su conferencia, en el correo de confirmación.", rqn = "Confirmación", iqn = "Lo que tu reservador debe proporcionar para recibir confirmaciones", aqn = "Usuario", sqn = "aún está disponible.", cqn = "Documentación", lqn = "Aprende cómo integrar nuestras herramientas con tu aplicación", uqn = "Referencia de API", dqn = "Una referencia completa de la API para nuestras bibliotecas", _qn = "Blog", pqn = "Lee nuestras últimas noticias y artículos", mqn = "Únete a nuestra comunidad", fqn = "Páginas Populares", gqn = "Regístrate Ahora", hqn = "Registrar", vqn = "Esta página no existe.", bqn = "No hay número de teléfono activo disponible", yqn = "Paso de flujo de trabajo no configurado", $qn = "Comprueba errores ortográficos o vuelve a la página anterior.", wqn = "No pudimos encontrar el evento que está intentando reservar.", kqn = "Empezar", Sqn = "Secreto", Eqn = "Dejar en blanco para eliminar el secreto", xqn = "Verifica que tu servidor solo esté recibiendo las solicitudes previstas de {{appName}} por motivos de seguridad", Cqn = "Reunión Secreta", Tqn = "Iniciar Sesión en su lugar", Aqn = "Crear Cuenta", Iqn = "Comenzar", Oqn = "Confirmar Contraseña", Nqn = "Establezca su nueva contraseña con las instrucciones enviadas a su dirección de correo electrónico.", zqn = "Por favor, sube una imagen de {{width}} de ancho y {{height}} de alto.", Rqn = "Vuelva a iniciar sesión con su nueva dirección de correo electrónico y contraseña.", Pqn = "Crea tu Cuenta", Dqn = "Crea tu cuenta en Cal.com", Lqn = "Regístrate", Mqn = "Has cerrado la sesión", Fqn = "¡Esperamos volver a verte pronto!", qqn = "Sesión Cerrada", jqn = "Por favor, inténtelo de nuevo y contáctenos si el problema persiste.", Vqn = "Código de doble factor es incorrecto.", Bqn = "No existe una cuenta que coincida con ese email.", Uqn = "Crear una Cuenta", Gqn = "¿No tienes una cuenta?", Wqn = "Iniciar sesión en tu cuenta", Hqn = "Iniciar Sesión", Yqn = "Volver a la página de inicio", Kqn = "Se ha producido un error al iniciar sesión. Vuelve a la pantalla de inicio de sesión e inténtalo de nuevo.", Zqn = "Restablecer contraseña", Xqn = "Enviar invitación", Jqn = "Olvidé la contraseña", Qqn = "¿Olvidado?", ejn = "Hecho", tjn = "¡Todo listo!", njn = "Todos", ojn = "Su cuenta", rjn = "Aplicaciones disponibles", ijn = "Aplicaciones disponibles", ajn = "Mira las aplicaciones populares a continuación y explora más en nuestra <0>Tienda de aplicaciones</0>", sjn = "Añade a cualquier persona que necesite asistir al evento. <0>Más información</0>", cjn = "Las personas en un grupo se turnan, una persona de cada grupo se presentará al evento.", ljn = "Las personas del grupo se turnan y solo una persona se presentará al evento.", ujn = "Revisa tu email. Te hemos enviado un enlace para restablecer tu contraseña.", djn = "Terminar", _jn = "Administre los ajustes para el idioma y la zona horaria de su equipo", pjn = "Unas pocas frases sobre ti mismo. Esto aparecerá en tu página de url personal.", mjn = "¡Ya casi está!", fjn = "Por último, una breve descripción sobre ti y una foto realmente ayuda a conseguir reservas y permite a las personas saber con quién están reservando.", gjn = "Defina los intervalos de tiempo cuando esté disponible de forma recurrente. Puede crear más tarde y asignarlos a diferentes calendarios.", hjn = "Establecer Disponibilidad", vjn = "Establece horarios para los momentos en que deseas ser reservado.", bjn = "Comparte un enlace o incrusta", yjn = "Comparte tu enlace de {{appName}} o incrústalo en tu sitio.", $jn = "Configuración de disponibilidad", wjn = "Continuar sin calendario", kjn = "Continuar con {{appName}}", Sjn = "Conecta tu calendario", Ejn = "Conecte sus aplicaciones favoritas", xjn = "Conecte sus aplicaciones de vídeo para usarlas en sus tipos de eventos.", Cjn = "Conecta tu calendario para verificar automáticamente los horarios ocupados y nuevos eventos a medida que se programan.", Tjn = "Configurar más tarde", Ajn = "Hora Actual", Ijn = "Detalles", Ojn = "Bienvenido", Njn = "Bienvenido de nuevo", zjn = "Bienvenido a {{appName}}", Rjn = "Dinos cómo quieres que te llamemos e indícanos en qué zona horaria te encuentras. Podrás editar esto más tarde.", Pjn = "Conectar con CalDav (Beta)", Djn = "Conectar a una fuente ICS", Ljn = "Conectar", Mjn = "Pruébalo Gratis", Fjn = "Crea tu propio enlace de reserva con {{appName}}", qjn = "Quien", jjn = "Qué", Vjn = "Cuándo", Bjn = "Donde", Ujn = "Añadir al Calendario", Gjn = "Selecciona dónde añadir eventos cuando te reserven.", Wjn = "Agregar eventos a", Hjn = "Añadir otro calendario", Yjn = "Otro", Kjn = "Su enlace de inicio de sesión para {{appName}}", Zjn = "Te reunirás con {{user}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos.", Xjn = "{{host}} se reunirá con {{attendee}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos.", Jjn = "Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos.", Qjn = "Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos para el primero de estos eventos recurrentes.", eVn = "Te reunirás con {{user}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos para el primero de estos eventos recurrentes.", tVn = "{{host}} se reunirá con {{attendee}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos para el primero de estos eventos recurrentes.", nVn = "Usted y cualquier otro asistente han recibido esta información.", oVn = "Su reserva todavía necesita ser confirmada o rechazada.", rVn = "Su reunión recurrente todavía necesita confirmarse o rechazarse.", iVn = "{{user}} aún necesita confirmar o rechazar la reserva.", aVn = "El {{user}} todavía necesita confirmar o rechazar cada reserva de la reunión recurrente.", sVn = "Esta reunión está programada", cVn = "Se han programado los eventos recurrentes", lVn = "Reserva enviada", uVn = "Su reunión recurrente se ha enviado", dVn = "Reserva confirmada", _Vn = "Su reunión recurrente se ha confirmado", pVn = "Todavía no se puede cobrar por los eventos recurrentes", mVn = "Los eventos recurrentes aún no son compatibles con los pagos", fVn = "Introduce la nueva contraseña que te gustaría para tu cuenta.", gVn = "Restablecer Contraseña", hVn = "Cambiar Contraseña", vVn = "Mostrar contraseña", bVn = "Ocultar contraseña", yVn = "Volver a Intentarlo", $Vn = "Esta solicitud ha caducado.", wVn = "Introduzca el email asociado a su cuenta y le enviaremos un enlace para restablecer su contraseña.", kVn = "La solicitud ha caducado. Vuelve e introduce el email asociado a tu cuenta y te enviaremos otro enlace para restablecer tu contraseña.", SVn = "Ups", EVn = "Entrar", xVn = "Éxito", CVn = "Falló", TVn = "Su contraseña ha sido restablecida. Ahora puede iniciar sesión con su nueva contraseña.", AVn = "Diseño", IVn = "Vista predeterminada", OVn = "Puede seleccionar varias y quienes le reserven pueden cambiar de vista.", NVn = "Diseño de reserva", zVn = "Puede seleccionar varios y quienes le reservan pueden cambiar de vista. Esto se puede anular por evento.", RVn = "Mes", PVn = "Semanal", DVn = "Columna", LVn = "Al menos un diseño tiene que estar habilitado.", MVn = "El diseño que seleccionó como vista predeterminada no es parte de los diseños habilitados.", FVn = "El diseño seleccionado no es un diseño válido.", qVn = "Puedes gestionar esto para todos tus tipos de eventos en Configuración -> <0>Apariencia</0> o <1>Personalizar</1> solo para este evento.", jVn = "Ocurrió un error inesperado. Inténtelo de nuevo.", VVn = "Hora inválida del domingo", BVn = "Hora inválida del lunes", UVn = "Hora inválida del martes", GVn = "Hora inválida del miércoles", WVn = "Hora inválida del jueves", HVn = "Hora inválida del viernes", YVn = "Hora inválida del sábado", KVn = "La hora final no puede ser anterior a la hora de inicio", ZVn = "La hora final no puede ser mayor de 24 horas", XVn = "Volver a Reservas", JVn = "No dude en elegir otro evento en cualquier momento.", QVn = "Cancelado", eBn = "Sin reserva", tBn = "Esperando al anfitrión", nBn = "Cancelación Realizada", oBn = "¿Realmente deseas cancelar tu reserva?", rBn = "No puedes cancelar esta reserva", iBn = "En su lugar, también puedes reprogramarlo.", aBn = "El evento es en el pasado", sBn = "El evento es un caso de un evento recurrente.", cBn = "Todas estas son instancias restantes en el evento recurrente.", lBn = "Se produjo un error con el código de estado {{status}}.", uBn = "Ya existe un tipo de evento con esta URL.", dBn = "No puede crear este evento", _Bn = "No puede editar este evento", pBn = "No puede crear este flujo de trabajo", mBn = "No puede crear este programa", fBn = "Esta reserva ya se canceló", gBn = "Esta reserva ya se aceptó o rechazó", hBn = "Volver a Inicio", vBn = "O Volver al Inicio", bBn = "Reunión no Encontrada", yBn = "Esta reunión no existe. Póngase en contacto con el responsable de la reunión para obtener un enlace actualizado.", $Bn = "Aún no hay reservas {{status}}", wBn = "No tienes {{status}} reservas. {{description}}", kBn = "{{eventName}} entre {{host}} y {{attendeeName}}", SBn = "Reservas", EBn = "Reserva no encontrada", xBn = "Vea eventos futuros y pasados reservados a través de sus enlaces de tipo de eventos.", CBn = "Tan pronto como alguien reserve una hora contigo, aparecerá aquí.", TBn = "Tan pronto como alguien reserve una reunión recurrente con usted, aparecerá aquí.", ABn = "Sus reservas pasadas aparecerán aquí.", IBn = "Las reservas canceladas aparecerán aquí.", OBn = "Las reservas sin confirmar aparecerán aquí.", NBn = "Reservas sin confirmar", zBn = "en", RBn = "y", PBn = "Tu calendario te muestra como ocupado entre", DBn = "Resolución de Problemas", LBn = "Comprenda por qué ciertos horarios están disponibles y otros están bloqueados.", MBn = "Aquí tienes un resumen de tu día el", FBn = "Consejo: Supera los tiempos en negrita para una marca de tiempo completa", qBn = "Hora de Inicio", jBn = "Hora de finalización", VBn = "Tiempo de búfer", BBn = "Antes del evento", UBn = "Después del evento", GBn = "Sin tiempo de búfer", WBn = "Búfer", HBn = "Tu día empieza a las", YBn = "Tu día termina a las", KBn = "Iniciar solucionador de problemas", ZBn = "Solucione problemas de disponibilidad para explorar por qué sus tiempos se muestran como son.", XBn = "Cambiar Horas Disponibles", JBn = "Cambiar las Horas Disponibles", QBn = "Cambiar las horas de inicio y fin de tu día", e9n = "Establezca la hora de inicio y finalización de su día y un búfer mínimo entre sus reuniones.", t9n = "Actualmente, tu día está listo para comenzar a las", n9n = "La hora de inicio y fin de tu día se ha cambiado correctamente.", o9n = "y terminar a las", r9n = "Claro", i9n = "Oscuro", a9n = "Ajusta automáticamente el tema según las preferencias de los invitados", s9n = "Actualmente, algunos de los usuarios del grupo tienen desactivadas las reservas dinámicas grupales", c9n = "Los enlaces de reservas grupales se pueden crear dinámicamente añadiendo varios nombres de usuario con un '+'. Ejemplo: '{{appName}}/bailey+peer'", l9n = "Permitir que los asistentes lo reserven a través de reservas dinámicas de grupo", u9n = "Enlaces dinámicos de grupo", d9n = "Permita que los motores de búsqueda accedan a su contenido público", _9n = "Permitir indexación en motores de búsqueda", p9n = "Permitir notificaciones del navegador", m9n = "Has denegado las notificaciones. Restablece el permiso en la configuración del navegador para habilitarlas.", f9n = "Desactivar notificaciones del navegador", g9n = "Notificaciones del navegador activadas", h9n = "Notificaciones del navegador desactivadas", v9n = "Notificaciones del navegador denegadas", b9n = "Por favor, permite las notificaciones desde el aviso", y9n = "Notificaciones push", $9n = "Recibe notificaciones push cuando el usuario realiza una reserva instantánea de reunión.", w9n = "Tu navegador no soporta las notificaciones push. Si usas Brave, habilita la opción `Usar servicios de Google para la mensajería push` en brave://settings/?search=push+messaging", k9n = "Correo electrónico", S9n = "nombre@ejemplo.com", E9n = "Nombre Completo", x9n = "Consulte la documentación de nuestra API", C9n = "Aproveche nuestra API para un control total y personalización.", T9n = "Crear Webhook", A9n = "Reunión instantánea creada", I9n = "Reserva cancelada", O9n = "Reserva habilitada", N9n = "Enlace de descarga de grabación listo", z9n = "Transcripción generada", R9n = "Reserva Creada", P9n = "Reserva rechazada", D9n = "Reserva solicitada", L9n = "Pago de la reserva iniciado", M9n = "Reunión finalizada", F9n = "Formulario enviado", q9n = "Formulario enviado, ningún evento reservado", j9n = "Reserva pagada", V9n = "Fuera de la oficina creado", B9n = "Reserva de no presentación actualizada", U9n = "Activadores de Eventos", G9n = "URL del suscriptor", W9n = "Crear un nuevo Webhook", H9n = "Webhooks", Y9n = "Webhooks del equipo", K9n = "Crear un nuevo webhook en tu cuenta", Z9n = "Nuevo Webhook", X9n = "Reciba datos de reuniones de {{appName}} en una URL específica, en tiempo real, cuando se programe o cancele un evento.", J9n = "Reciba datos de reuniones de {{appName}} en una URL específica, en tiempo real, cuando se programe o cancele un evento.", Q9n = "Iframe receptivo a pantalla completa", eUn = "Cargando...", tUn = "Eliminando...", nUn = "Iframe estándar", oUn = "Desarrollador", rUn = "Administre sus configuraciones de desarrollador.", iUn = "incrustar iframe", aUn = "La forma más sencilla de integrar {{appName}} en su sitio web.", sUn = "Intégrese con su sitio web utilizando nuestras opciones de inserción u obtenga información de reserva en tiempo real utilizando webhooks personalizados.", cUn = "Programar una reunión", lUn = "Ver y administrar sus datos de facturación", uUn = "Vea y edite sus datos de facturación, así como cancele su suscripción.", dUn = "Ir al portal de facturación", _Un = "¿Necesita algo más?", pUn = "Si necesita más ayuda con la facturación, nuestro equipo de soporte está aquí para ayudarlo.", mUn = "Contactar", fUn = "nuestro equipo de soporte", gUn = "Contacte con nuestro equipo de soporte", hUn = "Uh oh!", vUn = "Este usuario aún no ha configurado ningún tipo de evento.", bUn = "Cambiar la marca", yUn = "Subir una marca", $Un = "Cargar logo", wUn = "Quitar logo", kUn = "Habilitar", SUn = "Código", EUn = "El código es incorrecto.", xUn = "Añadir nuevo intervalo de tiempo", CUn = "Agregue una capa adicional de seguridad a su cuenta en caso de que le roben su contraseña.", TUn = "Habilitar la autenticación de dos factores", AUn = "Deshabilitar la autenticación de dos factores", IUn = "Si necesita deshabilitar 2FA, le recomendamos que lo vuelva a habilitar lo antes posible.", OUn = "Error al deshabilitar la autenticación de dos factores", NUn = "Error al configurar la autenticación de dos factores", zUn = "Seguridad", RUn = "Administra la seguridad de tu cuenta.", PUn = "Contraseña", DUn = "Contraseña Actualizada con Éxito", LUn = "Su contraseña se ha cambiado correctamente.", MUn = "Error al cambiar la contraseña", FUn = "La configuración de su sesión se ha actualizado correctamente.", qUn = "Error al actualizar la configuración de la sesión", jUn = "Algo ha Fallado.", VUn = "¿Algo no se ve bien?", BUn = "Por Favor, Inténtalo de Nuevo.", UUn = "Su nueva contraseña super segura", GUn = "Nueva contraseña", WUn = "Su contraseña antigua", HUn = "Contraseña Actual", YUn = "Cambiar Contraseña", KUn = "Cambiar secreto", ZUn = "La nueva contraseña coincide con su contraseña antigua. Por favor, elija una contraseña diferente.", XUn = "Si has perdido u olvidado este secreto, puedes cambiarlo, pero ten en cuenta que todas las integraciones que usen este secreto tendrán que actualizarse", JUn = "La Contraseña Actual es Incorrecta", QUn = "Mezcla de letras mayúsculas y minúsculas", eGn = "Mínimo 7 caracteres", tGn = "Longitud mínima de 15 caracteres", nGn = "Debe contener al menos 1 número", oGn = "Debe tener {{limit}} o menos caracteres", rGn = "La contraseña debe tener un mínimo de {{passwordLength}} caracteres que contengan al menos un número y una mezcla de letras mayúsculas y minúsculas", iGn = "La Contraseña es Incorrecta.", aGn = "El correo electrónico o la contraseña son incorrectos.", sGn = "Usar Ajuste", cGn = "am/pm", lGn = "Opciones Horas", uGn = "Enero", dGn = "Febrero", _Gn = "Marzo", pGn = "Abril", mGn = "Mayo", fGn = "Junio", gGn = "Julio", hGn = "Agosto", vGn = "Septiembre", bGn = "Octubre", yGn = "Noviembre", $Gn = "Diciembre", wGn = "Lunes", kGn = "Martes", SGn = "Miércoles", EGn = "Jueves", xGn = "Viernes", CGn = "Sábado", TGn = "Domingo", AGn = "Todo reservado.", IGn = "No se pudo cargar el intervalo de tiempo disponible.", OGn = "Añadir invitados", NGn = "Tu Nombre", zGn = "Su nombre completo", RGn = "Sin nombre", PGn = "Introduzca un número entre 1 y {{maxOccurences}}", DGn = "Rápido y sencillo - no se requiere cuenta. Perfecto para reuniones puntuales.", LGn = "Email", MGn = "Ingresa un correo electrónico válido", FGn = "Por favor, programa una llamada futura si no estamos disponibles en {{seconds}} segundos", qGn = "Ubicación", jGn = "Ubicación", VGn = "Ingrese la dirección", BGn = "En persona (dirección del asistente)", UGn = "Otro lugar", GGn = "Ubicación personalizada del asistente", WGn = "Continuar como invitado", HGn = "Unirse como invitado", YGn = "Ideal para llamadas únicas", KGn = "Cualquier ubicación", ZGn = "Sí", XGn = "No", JGn = "Notas Adicionales", QGn = "No se ha podido reservar la reunión.", eWn = "No se ha podido reprogramar la reunión.", tWn = "Por favor, comparta cualquier cosa que ayude a preparar nuestra reunión.", nWn = "Confirma tu {{eventTypeTitle}} con {{profileName}}", oWn = "Reprogramar tu {{eventTypeTitle}} con {{profileName}}", rWn = "Reunión en Persona", iWn = "En persona (dirección del organizador)", aWn = "Enlace de la reunión", sWn = "Nª de Telefono", cWn = "Número de teléfono del asistente", lWn = "Número de teléfono del organizador", uWn = "Introducir Nº de Telefono", dWn = "Reprogramar", _Wn = "Reprogramar en su lugar", pWn = "Reservar un miembro del equipo en su lugar", mWn = "O", fWn = "Volver", gWn = "Email o Nombre de Usuario", hWn = "Enviar Invitación por Email", vWn = "Rol", bWn = "Editar Rol", yWn = "Ver rol", $Wn = "Editar Equipo", wWn = "Editando usuario", kWn = "Editando organización", SWn = "Si deseas editar o gestionar tus webhooks, dirígete a la <0>configuración de webhooks</0>", EWn = "Rechazar", xWn = "Rechazar todo", CWn = "Aceptar", TWn = "Abandonar", AWn = "Perfil", IWn = "URL de Mi Equipo", OWn = "Mis equipos", NWn = "Nombre del equipo", zWn = "Nombre de tu Equipo", RWn = "Equipo Actualizado Correctamente", PWn = "Tu equipo ha sido actualizado con éxito.", DWn = "Su organización se ha actualizado correctamente.", LWn = "Error al copiar al portapapeles", MWn = "Acerca de", FWn = "Comentarios sobre tu equipo. Esta información aparecerá en la página de la URL de tu equipo.", qWn = "ID de la organización", jWn = "ID de la organización copiado.", VWn = "Algunas frases sobre su organización. Esto aparecerá en la página de la URL de su organización.", BWn = "ID del equipo", UWn = "ID del equipo copiado.", GWn = "Miembros", WWn = "Miembros de Organization", HWn = "Miembro", YWn = "{{count}} miembro", KWn = "{{count}} miembros", ZWn = "{{count}} seleccionados", XWn = "Propietario", JWn = "Administrador", QWn = "API de administración", e8n = "Usuario administrador", t8n = "Vamos a crear el primer usuario administrador.", n8n = "Configuración del usuario administrador", o8n = "Ya ha creado un usuario administrador. Ahora puede iniciar sesión en su cuenta.", r8n = "Nuevo Miembro", i8n = "Invitación", a8n = "Añadir miembros del equipo", s8n = "Agregar miembros", c8n = "Invitar a otros a unirse a tu equipo", l8n = "Añadir miembro del equipo", u8n = "Invitar a un nuevo miembro", d8n = "Nota: Esto <0>costará un asiento adicional (15$/mes)</0> en tu suscripción.", _8n = "Invita a alguien a tu equipo.", p8n = "Cargar un archivo .csv", m8n = "Invitar por correo electrónico", f8n = "Cambiar rol del miembro del equipo", g8n = "Desactivar la marca de {{appName}}", h8n = "Ocultar todas las marcas de {{appName}} de sus páginas públicas.", v8n = "Ocultar el botón Reservar un miembro del equipo", b8n = "Ocultar el botón Reservar un miembro del equipo de sus páginas públicas.", y8n = "Paso definitivo", $8n = "Ten cuidado. La eliminación de la cuenta no se puede deshacer.", w8n = "Ten cuidado. La eliminación del equipo no se puede deshacer.", k8n = "Atrás", S8n = "Cancelar", E8n = "Cancelar todos los restantes", x8n = "Aplicar", C8n = "Cancelar este evento", T8n = "Confirmar", A8n = "Confirmar todo", I8n = "Disolver Equipo", O8n = "¿Estás seguro de que quieres disolver este equipo? Cualquiera con quien has compartido este enlace de equipo ya no podrá reservar usando el mismo.", N8n = "Disolver la organización", z8n = "¿Está seguro de que desea disolver esta organización? Todos los equipos y miembros se eliminarán.", R8n = "¿Estás seguro de que quieres eliminar este miembro del equipo?", P8n = "Sí, Disolver Equipo", D8n = "Sí, Eliminar Miembro", L8n = "Sí, cancelar suscripción", M8n = "Cancelar suscripción", F8n = "Al cancelar tu suscripción se desactivará permanentemente tu plan actual. Esta acción no se puede deshacer.", q8n = "Eliminar Miembro", j8n = "Administra tu Equipo", V8n = "Todavía no tienes ningún equipo.", B8n = "Los equipos permiten que otros reserven eventos compartidos entre tus compañeros de trabajo.", U8n = "Enviar", G8n = "Sí, eliminar atributo", W8n = "Eliminar atributo", H8n = "¿Estás seguro de que deseas eliminar el atributo '{{name}}'? Todos los usuarios asignados actualmente serán desvinculados.", Y8n = "Actualizar", K8n = "Guardar", Z8n = "Pendiente", X8n = "Abrir Opciones", J8n = "Copiar Enlace", Q8n = "Compartir", e7n = "¿Quieres reservar mi Cal o enviarme tu enlace?", t7n = "Copiar enlace al equipo", n7n = "Abandonar equipo", o7n = "Sí, abandonar equipo", r7n = "¿Estás seguro de que quieres salir de este equipo? Ya no podrás reservar usándolo.", i7n = "{{user}} de {{team}}", a7n = "Vista Previa", s7n = "¡Enlace Copiado!", c7n = "¡Copiado!", l7n = "¡Enlace privado copiado!", u7n = "¡Enlace compartido!", d7n = "Título", _7n = "Descripción", p7n = "Estado de las aplicaciones", m7n = "Reunión de Vídeo Rápida.", f7n = "Tipo de Programación", g7n = "Ver Equipo", h7n = "Colectivo", v7n = "Programe reuniones cuando todos los miembros del equipo seleccionados estén disponibles.", b7n = "Duración", y7n = "Duraciones disponibles", $7n = "Duración predeterminada", w7n = "Seleccione primero las duraciones disponibles", k7n = "{{count}} $t(minute_timeUnit)", S7n = "{{count}} $t({{unit}}_timeUnit)", E7n = "{{count}}$t({{unit}}_short)", x7n = "Minutos", C7n = "Usa Cal.ai para obtener un número de teléfono con inteligencia artificial o hacer llamadas a invitados.", T7n = "URI de terminación", A7n = "Nombre de usuario del troncal SIP", I7n = "Contraseña del troncal SIP", O7n = "Apodo", N7n = "Eliminar número de teléfono", z7n = "La validación del flujo de trabajo falló", R7n = "Uno o más pasos del flujo de trabajo tienen contenido de mensaje vacío", P7n = "Uno o más números de teléfono o direcciones de correo electrónico no están verificados", D7n = "Potencia tus flujos de trabajo con Cal.ai", L7n = "Agentes de IA realistas que programan reuniones, envían recordatorios y hacen seguimiento con tus clientes.", M7n = "Número de teléfono importado y vinculado al agente con éxito", F7n = "Número de teléfono eliminado con éxito", q7n = "¿Estás seguro de que quieres eliminar este número de teléfono? Esta acción no se puede deshacer.", j7n = "Sí, eliminar número de teléfono", V7n = "El número que estás intentando importar debe estar en formato E.164 (código de país seguido por el número, sin espacios ni caracteres especiales), por ejemplo, +1234567890", B7n = "El URI de terminación para identificar de forma única tu troncal SIP elástico. Esto se utiliza para llamadas salientes. Para troncales SIP elásticos de Twilio siempre termina con .pstn.twilio.com.", U7n = "El nombre de usuario utilizado para autenticar el troncal SIP.", G7n = "La contraseña utilizada para autenticar el troncal SIP.", W7n = "Apodo del número. Esto es solo para tu referencia.", H7n = "Guardar y probar llamada", Y7n = "Llamada iniciada con éxito", K7n = "Por favor, introduce un número de teléfono", Z7n = "Agente actualizado con éxito", X7n = "Agente creado con éxito", J7n = "Tipo de evento añadido con éxito", Q7n = "Número de teléfono dado de baja correctamente", eHn = "Este prompt define el rol del agente y sus objetivos principales", tHn = "Prompt", nHn = "Llamar a", oHn = "Realizar llamada de prueba para verificar la configuración", rHn = "Mensaje inicial", iHn = "El primer mensaje que dirá el agente al iniciar una llamada", aHn = "¿Problemas al importar?", sHn = "Aprender", cHn = "Aprende cómo obtener tu URI de terminación y credenciales de troncal SIP", lHn = "Suscripción del número de teléfono cancelada correctamente", uHn = "Actualizando", dHn = "Petición Firmada por Turnos", _Hn = "Hola, ¿cómo estás?", pHn = "Ciclo de reuniones entre varios miembros del equipo.", mHn = "Evento gestionado", fHn = "nombre de usuario", gHn = "Cree y distribuya tipos de eventos de forma masiva a los miembros del equipo", hHn = "Gestionado", vHn = 'El "nombre de usuario" se completará con el nombre de usuario de los miembros asignados', bHn = "Asignar a", yHn = "Introduce un número de teléfono para la llamada de prueba", $Hn = "Realizar llamada de prueba", wHn = "Crear nuevo agente de voz cal.ai para flujo de trabajo", kHn = "Crea un nuevo agente de voz cal.ai para automatizar tus flujos de trabajo", SHn = "Número de teléfono (para que nuestro agente llame)", EHn = "Compra un número de teléfono o importa uno que ya tengas en twilio", xHn = "Probar agente", CHn = "Probar llamada web", THn = "Números de teléfono", AHn = "Dar de baja", IHn = "Eliminar paso del flujo de trabajo", OHn = "Dar de baja el número de teléfono", NHn = "Comprar un nuevo número", zHn = "Solo puedes comprar números de teléfono de EE. UU. Para otros países, puedes importar tu propio número de teléfono de Twilio.", RHn = "Compre un número de EE. UU. por ${{priceInDollars}} al mes", PHn = "Destinos de llamadas compatibles", DHn = "No hay número de teléfono conectado", LHn = "Error al obtener el ID del paso del flujo de trabajo", MHn = "Agente Cal.ai", FHn = "Probar agente Cal.ai", qHn = "¿Está seguro que desea eliminar este paso del flujo de trabajo?", jHn = "¿Todavía desea dar de baja el número de teléfono de este agente?", VHn = "Esta acción desconectará el número de teléfono del agente. El agente no podrá realizar llamadas hasta que se conecte un nuevo número de teléfono.", BHn = "Números de teléfono", UHn = "Conectar número de teléfono", GHn = "Gestiona tus números de teléfono", WHn = "Importar número", HHn = "Esta acción también:", YHn = "Importar número de teléfono", KHn = "Suscripción activa", ZHn = "Cancelar su suscripción de número de teléfono", XHn = "Eliminar el número de teléfono asociado", JHn = "No está autorizado para crear este flujo de trabajo", QHn = "Importa tu número de teléfono de Twilio para usar con Phone", eYn = "${{price}}/mes", tYn = "Comprar nuevo número", nYn = "Comprar un número de teléfono cuesta ${{priceInDollars}} al mes. Se le cobrará mensualmente por cada número de teléfono activo.", oYn = "Código de área (opcional)", rYn = "No hay números de teléfono", iYn = "Número de teléfono comprado con éxito", aYn = "Cancelar suscripción de número de teléfono", sYn = "Sí, cancelar suscripción", cYn = "¿Está seguro de que desea cancelar esta suscripción de número de teléfono? Esta acción no se puede deshacer y perderá el acceso a este número de teléfono.", lYn = "Agregar miembros...", uYn = "Agregar miembros", dYn = "No hay miembros asignados", _Yn = "Asignado a", pYn = "Debes iniciar sesión en {{url}}", mYn = "Empezar a asignar miembros más arriba", fYn = "Los miembros no podrán editar esto", gYn = "Los miembros pueden editar", hYn = "El administrador del equipo bloqueó esta opción", vYn = "Desbloqueado por el administrador del equipo", bYn = "URL", yYn = "Oculto", $Yn = "Sólo Lectura", wYn = "Enlace de una sola vez", kYn = "Actualmente estás en el plan {{plan}}.", SYn = "Actualiza tu cuenta al plan Pro para poder utilizar todas las funciones que ofrecemos.", EYn = "Necesitas actualizar tu plan para tener más de un tipo de evento activo.", xYn = "Necesita actualizar su plan para crear un equipo.", CYn = "Puedes <1>actualizar aquí</1>.", TYn = "Tipos de Evento", AYn = "Crea eventos para que la gente que invites reserve en tu calendario.", IYn = "Nuevo Tipo de Evento", OYn = "Crea tu primer tipo de evento", NYn = "Los tipos de eventos te permiten compartir enlaces que muestran las horas disponibles en tu calendario y permitir que la gente haga reservas contigo.", zYn = "{{eventTypeTitle}} tipo de evento creado con éxito", RYn = "{{eventTypeTitle}} tipo de evento actualizado con éxito", PYn = "Tipo de evento eliminado con éxito", DYn = "Horas", LYn = "Personas", MYn = "Tu Email", FYn = "Cambiar Avatar", qYn = "Cargar avatar", jYn = "Lenguaje", VYn = "Zona Horaria", BYn = "Primer dia de la semana", UYn = "Se repite hasta {{count}} vez", GYn = "Se repite hasta {{count}} veces", WYn = "Cada {{freq}} para", HYn = "{{count}} evento restante", YYn = "{{count}} eventos restantes", KYn = "Se repite cada", ZYn = "repetición", XYn = "repeticiones", JYn = "semana", QYn = "semanas", eKn = "mes", tKn = "meses", nKn = "año", oKn = "años", rKn = "{{count}} más", iKn = "Máx.", aKn = "Tema", sKn = "Color de marca", cKn = "Color de la marca (Tema claro)", lKn = "Color de la marca (Tema oscuro)", uKn = "Color del tipo de evento (Tema claro)", dKn = "Color del tipo de evento (Tema oscuro)", _Kn = "El archivo no se llama [idOrSlug] / [user]", pKn = "Crear equipo", mKn = "Nombre", fKn = "Equipo sin nombre", gKn = "Clientes OAuth", hKn = "Gestione clientes OAuth para su organización", vKn = "Crear cliente OAuth", bKn = "Cree un nuevo cliente OAuth para integraciones de terceros", yKn = "Cliente OAuth eliminado correctamente", $Kn = "Crea un nuevo equipo para colaborar con los usuarios.", wKn = "Crear Nuevo Equipo", kKn = "URL de tu página de reservas", SKn = "URL de la página donde tus usuarios pueden cancelar su reserva", EKn = "URL de la página donde tus usuarios pueden reprogramar su reserva", xKn = "Este horario ya no está disponible. Por favor, regresa a la página anterior y selecciona otro horario.", CKn = "Invitaciones Abiertas", TKn = "Nuevo Equipo", AKn = "Cree su primer equipo e invite a otros usuarios a trabajar juntos.", IKn = "Crea un equipo para empezar", OKn = "Equipos", NKn = "Equipo", zKn = "Organization", RKn = "Facturación del equipo", PKn = "Gestione la facturación para su equipo", DKn = "Hemos cambiado la facturación de los equipos", LKn = "Hay miembros en tu equipo sin asiento. Actualiza al plan Pro para cubrir los asientos restantes.", MKn = "A partir de enero de 2022 cobramos por licencia para los miembros del equipo. Los miembros de tu equipo que tenían el plan Pro de forma gratuita están ahora en una prueba de 14 días. Una vez que caduque su prueba, estos miembros estarán ocultos para tu equipo a menos que actualices ahora.", FKn = "Cree y gestiona equipos para utilizar las funciones colaborativas.", qKn = "Esta función solo está disponible en el plan Pro", jKn = "Para eliminar la marca {{appName}} de sus páginas de reserva, debe actualizar a una cuenta Pro.", VKn = "Edite la información de su perfil, que se muestra en su enlace de programación.", BKn = "Es posible que tengas que cerrar sesión y volver a entrar para ver el cambio realizado.", UKn = "Algo sobre ti.", GKn = "Perfil Actualizado con Éxito", WKn = "Su perfil de usuario se ha actualizado correctamente.", HKn = "Tu actualización está lista", YKn = "Mejora tu experiencia de programación actualizando al nuevo plan y disfruta de las nuevas funcionalidades.", KKn = "Todo está listo", ZKn = "Ya estás en el último plan. No hay nada que actualizar. ¡Disfruta de las nuevas funcionalidades y contáctanos si tienes alguna pregunta!", XKn = "El usuario parece haber iniciado sesión pero no se puede encontrar en la base de datos", JKn = "Incrustrar y Webhooks", QKn = "Activado", eZn = "Desactivado", tZn = "Deshabilitar", nZn = "Facturación", oZn = "aquí", rZn = "Gestione su información de facturación y cancele su suscripción.", iZn = "Disponibilidad", aZn = "Editar disponibilidad", sZn = "Configure los horarios en los que está disponible para realizar reservas.", cZn = "Copiar tiempos en", lZn = "Copiar tiempos a …", uZn = "Cambia tu Horario Semanal", dZn = "Logotipo", _Zn = "Error", pZn = "Introduce al menos un carácter", mZn = "Introduce al menos {{count}} caracteres", fZn = "Logo del Equipo", gZn = "Añadir Localización", hZn = "Asistentes", vZn = "Añadir Asistentes", bZn = "Mostrar Opciones Avanzadas", yZn = "Ocultar ajustes avanzados", $Zn = "Nombre del Evento", wZn = "Nombre del evento en el calendario", kZn = "Nombre que aparecerá en los calendarios", SZn = "Reunión con {{attendeeName}}", EZn = "Campos Adicionales", xZn = "Se requiere que el planificador introduzca entradas adicionales antes de confirmar la reserva", CZn = "Etiqueta", TZn = "Marcador de posición", AZn = 'Usa el correo electrónico "Agregar al calendario" como el organizador', IZn = "Mostraremos esta dirección de correo electrónico como el organizador y enviaremos correos de confirmación aquí.", OZn = 'Si está habilitado, mostraremos la dirección de correo electrónico de tu "Agregar al calendario" como organizador y enviaremos correos de confirmación allí.', NZn = "Ten en cuenta que puede que necesites desconectar y luego volver a conectar tu cuenta de 'Agregar al calendario' para usar esta función.", zZn = "Tipo", RZn = "Editar", PZn = "Agregar una entrada", DZn = "Ocultar notas en el calendario", LZn = "Por razones de privacidad, las entradas y notas adicionales se ocultarán en la entrada del calendario. Seguirán enviándose a su correo electrónico.", MZn = "La reserva debe confirmarse manualmente antes de que se envíe a las integraciones y se genere un correo de confirmación.", FZn = "Las reservas no confirmadas aún bloquean los espacios en el calendario.", qZn = "Evento recurrente", jZn = "Las personas pueden suscribirse a eventos recurrentes", VZn = "Conecta y únete", BZn = "No se puede usar con tipos de eventos de pago.", UZn = "Las reuniones instantáneas no son compatibles con eventos recurrentes y aplicaciones de pago todavía.", GZn = "Experimental: Los eventos de reuniones instantáneas son actualmente experimentales.", WZn = "A partir", HZn = "Desactivar Invitados", YZn = "Desactiva agregar invitados adicionales al hacer la reserva.", KZn = "Generar una URL privada", ZZn = "Activar URL privada", XZn = "Enlace privado", JZn = "Su enlace privado se regenera después de cada uso", QZn = "Copiar enlace privado", eXn = "Copiar enlace privado al evento", tXn = "Generar una URL privada para compartir sin exponer su nombre de usuario de {{appName}}", nXn = "Enlaces privados", oXn = "Generar URLs privadas sin exponer el nombre de usuario, con límites configurables de caducidad y uso", rXn = "Agregar nuevo enlace", iXn = "Enlace privado copiado", aXn = "Los invitados pueden programar", sXn = "Rango de Fechas", cXn = "Días del Calendário", lXn = "Días Laborales", uXn = "Establecer una dirección o un lugar", dXn = "Establecer un enlace a la reunión", _Xn = "No se puede alternar. Solo se puede desbloquear para tipos de eventos secundarios", pXn = "{{appName}} le pedirá a su invitado que introduzca un número de teléfono antes de agendar.", mXn = "{{appName}} proporcionará una URL de reunión de Google Meet.", fXn = "{{appName}} proporcionará una URL de reunión de Zoom.", gXn = "{{appName}} proporcionará una URL de reunión de Tandem.", hXn = "{{appName}} proporcionará una URL de la video llamada.", vXn = "Cal proporcionará una URL de reunión de Jitsi Meet.", bXn = "{{appName}} proporcionará una URL de la videollamada de Huddle01 Web3.", yXn = "{{appName}} proporcionará una URL de reunión de MS Teams. NOTA: DEBE TENER UNA CUENTA DE TRABAJO O INSTITUCIÓN", $Xn = "Requiere Pago", wXn = "Necesita agregar un nombre", kXn = "Comisión por Transacción", SXn = "Tu Evento fue Actualizado con Éxito.", EXn = "Ocultar Tipo de Evento", xXn = "Editar Localización", CXn = "en el futuro", TXn = "Cuando se reserva con menos de <0></0> de antelación", AXn = "Dentro de un rango de fechas", IXn = "Indefinidamente en el futuro", OXn = "Agregar nuevo campo de entrada personalizado", NXn = "Chat Rápido", zXn = "Crear Nuevo Tipo de Evento para Equipo", RXn = "Crear Nuevo Tipo de Evento", PXn = "Crea un nuevo tipo de evento para que las personas reserven horarios.", DXn = "Tamaño", LXn = "Aviso de Reserva", MXn = "Desplazar horas de inicio", FXn = "Desplazar las franjas horarias que se muestran a los que reservan por un número específico de minutos", qXn = "Desplazar por", jXn = "por ejemplo, esto mostrará las franjas horarias a quienes reservan a las {{ adjustedTime }} en lugar de {{ originalTime }}", VXn = "Intervalos de tiempo", BXn = "Usar duración del evento (por defecto)", UXn = "¿Eliminar tipo de evento?", GXn = "¿Eliminar tipo de evento gestionado?", WXn = "Cualquier persona con la que haya compartido este enlace ya no podrá reservar con él.", HXn = "Los miembros asignados a este tipo de evento también tendrán sus tipos de eventos eliminados.", YXn = "Cualquier persona con quien hayan compartido su enlace ya no podrá reservar usándolo.", KXn = "Sí, eliminar", ZXn = "Eliminar cuenta", XXn = "Sí, eliminar cuenta", JXn = "Cualquier persona con la que hayas compartido el enlace de tu cuenta ya no podrá agendar con ella y cualquier preferencia que hayas guardado se perderá.", QXn = "Integraciones", eJn = "Aplicaciones", tJn = "Aquí puede encontrar una lista de sus aplicaciones", nJn = "Lista de aplicaciones", oJn = "Aplicaciones {{category}}", rJn = "App Store", iJn = "Conectar personas, tecnología y lugar de trabajo.", aJn = "Conecte su aplicación de videoconferencia", sJn = "Ajustes", cJn = "El tipo de evento se ha movido correctamente", lJn = "Siguiente paso", uJn = "Saltar paso", dJn = "Paso anterior", _Jn = "Instalar", pJn = "Comenzar prueba gratuita", mJn = "Instalado", fJn = "{{count}} instalación activa", gJn = "{{count}} instalaciones activas", hJn = "Instalado globalmente", vJn = "Aplicación instalada correctamente", bJn = "No se ha podido instalar la aplicación", yJn = "Desconectar", $Jn = "Incorpora tu calendario en tu página web", wJn = "Conecta tus aplicaciones favoritas.", kJn = "Automatización", SJn = "Configure cómo deben interactuar sus tipos de eventos con sus calendarios.", EJn = "Activa/desactiva los calendarios en los que desees comprobar conflictos para evitar reservas dobles.", xJn = "Conectar calendario adicional", CJn = "Calendario actualizado correctamente", TJn = "Verificar aquí", AJn = "Conferencias", IJn = "Calendario", OJn = "Pagos", NJn = "No instalado", zJn = "Las contraseñas no coinciden.", RJn = "Este campo es requerido.", PJn = "Estado", DJn = "Ver disponibilidad de usuario", LJn = "El usuario necesita aceptar la invitación para ver su disponibilidad", MJn = "Activar estado Ausente", FJn = "Desactivar estado Ausente", qJn = "Error al actualizar el estado ausente", jJn = "Este usuario se encuentra Ausente.", VJn = "La persona a la que estás intentando reservar se ha marcado a sí misma como Ausente, por lo tanto, no acepta nuevas reservas por ahora.", BJn = "Conoce personas con los mismos tokens", UJn = "Solo reservar y permitir reservas de personas que compartan los mismos tokens, DAO o NFT.", GJn = "Tu cuenta se creó mediante un Proveedor de Identidad.", WJn = "Tu cuenta es administrada por {{provider}}", HJn = "Para cambiar tu correo electrónico, contraseña, habilitar la autenticación de doble factor y más, por favor visita la configuración de tu cuenta de {{provider}}.", YJn = "Tu cuenta está gestionada por un proveedor de identidad diferente. Intenta iniciar sesión con {{provider}}.", KJn = "Error al crear un nuevo usuario. Por favor, inténtalo de nuevo.", ZJn = "Iniciar sesión con Google", XJn = "Iniciar sesión con SAML", JJn = "Inicie sesión con SAML/OIDC", QJn = "Continuar con correo electrónico", eQn = "Continuar con Google", tQn = "Último uso", nQn = "Necesitarás generar un token de acceso desde tu antigua herramienta de programación.", oQn = "Importar desde", rQn = "Token de acceso", iQn = "Hoja de ruta", aQn = "Categorías destacadas", sQn = "Indicadores de funciones", cQn = "Aquí puedes activar o desactivar las funciones de tu instancia de Cal.com.", lQn = "Categorías populares", uQn = "{{count}} aplicación", dQn = "{{count}} aplicaciones", _Qn = "Aplicaciones populares", pQn = "Más popular", mQn = "Apps instaladas", fQn = "Gratis", gQn = "No hay aplicaciones de {{category}}", hQn = "Todas las aplicaciones", vQn = "Añade una aplicación de calendario para comprobar si hay conflictos y evitar reservas duplicadas", bQn = "Intente agregar una aplicación de conferencia para videollamadas con sus clientes", yQn = "Añade una aplicación de pagos para facilitar las transacciones con tus clientes", $Qn = "Añada una aplicación de análisis para sus páginas de reserva", wQn = "Añada una aplicación de automatización para utilizar", kQn = "Añade cualquier otro tipo de aplicación para hacer todo tipo de tareas", SQn = "Agregue una aplicación de mensajería para configurar notificaciones y recordatorios personalizados", EQn = "Agregue una aplicación CRM para realizar un seguimiento de con quiénes se ha reunido", xQn = "Configure el(los) calendario(s) para comprobar conflictos y evitar reservas duplicadas.", CQn = "Configura los servicios de procesamiento de pagos que vas a utilizar para cobrar a tus clientes.", TQn = "Configure qué aplicaciones de análisis va a utilizar para sus páginas de reserva", AQn = "Todas tus aplicaciones instaladas de otras categorías.", IQn = "Configure qué aplicaciones de conferencia usará", OQn = "Configure qué aplicaciones de automatización va a utilizar", NQn = "Configure qué aplicaciones de mensajería usar para configurar notificaciones y recordatorios personalizados", zQn = "Configure qué aplicaciones de CRM usar para realizar un seguimiento de las personas con las que se ha reunido", RQn = "Análisis", PQn = "No hay aplicaciones instaladas", DQn = "Las aplicaciones te permiten mejorar significativamente tu flujo de trabajo y mejorar tu agendamiento.", LQn = "Explore la tienda de aplicaciones", MQn = "Administra tus aplicaciones instaladas o cambia la configuración", FQn = "Ver aplicaciones", qQn = "Características", jQn = "Permisos", VQn = "Términos y privacidad", BQn = "Publicado por {{author}}", UQn = "Suscribirse", GQn = "Comprar", WQn = "Instalar aplicación", HQn = "Categorías", YQn = "Precios", KQn = "Más información", ZQn = "Prueba ahora", XQn = "Política de privacidad", JQn = "Términos de servicio", QQn = "Eliminar", eeo = "Añadir", teo = "{{count}} instaladas", neo = "Verificar billetera", oeo = "Crear eventos en", reo = "Esta es una función comercial", ieo = "Puedes probar esta función localmente pero no en producción.", aeo = "Para adquirir una licencia comercial, por favor contacta a nuestro equipo de ventas. Si ya tienes una clave de licencia, contacta a support@cal.com para obtener ayuda.", seo = "Falta la licencia", ceo = "Pasos siguientes", leo = "Adquirir una licencia comercial", ueo = "El plan de infraestructura está basado en el uso y tiene descuentos favorables para empresas emergentes.", deo = "Crea una cuenta a través de Prisma Studio", _eo = "Aprende cómo configurar tu primer usuario", peo = "Contactar con Ventas", meo = "Error 404", feo = "Establecer como predeterminado", geo = "Nuevo agenda", heo = "Añadir un nuevo agenda", veo = "Añadir un calendario nuevo", beo = "Especifica dónde se añadirán los eventos nuevos cuando haya reservas.", yeo = "Eliminar agenda", $eo = "Al borrar un horario se eliminará de todos los tipos de eventos. Esta acción no se puede deshacer.", weo = "Horario {{scheduleName}} creado con éxito", keo = "El horario de {{scheduleName}} se actualizó correctamente", Seo = "Programación eliminada exitosamente", Eeo = "Horas laborables", xeo = "Crear un horario de disponibilidad", Ceo = "Crear horarios de disponibilidad le permite gestionar la disponibilidad a través de tipos de eventos. Pueden aplicarse a uno o más tipos de eventos.", Teo = "Requiere la propiedad de un token perteneciente a la siguiente dirección:", Aeo = "Juan Pérez", Ieo = "Formato de hora", Oeo = "Redirigir al reservar ", Neo = 'Estás siendo redirigido a {{ url }} en $t(second, {"count": {{seconds}} }).', zeo = "https://example.com/redirect-to-my-success-page", Reo = "Redirija a una URL personalizada después de una reserva exitosa", Peo = "Duplicado", Deo = "Ofrecer plazas", Leo = "Ofrecer plazas para las reservas (desactiva las reservas de invitados y las optativas)", Meo = "Asiento disponible", Feo = "Asientos disponibles", qeo = "Cupos casi llenos", jeo = "Los cupos se están copando rápido", Veo = "Número de plazas por reserva", Beo = "Establecer ventana de unión a la reunión (segundos): El período de tiempo en segundos dentro del cual el anfitrión puede unirse y comenzar la reunión. Después de este período, la URL de unión a la reunión expirará.", Ueo = "Introduzca el número de plazas", Geo = "Puede administrar sus horarios en la página Disponibilidad.", Weo = "No hay más plazas disponibles", Heo = "Claves API", Yeo = "Clave API", Keo = "Probar clave API", Zeo = "¡Prueba aprobada!", Xeo = "Prueba fallida", Jeo = "Proporcionar clave API", Qeo = "Las claves API le permiten realizar llamadas API para su propia cuenta.", eto = "Crea un marketplace o plataforma en su lugar.", tto = "Genere claves API que se usarán para acceder a su propia cuenta.", nto = "Crear una clave API", oto = "Nombrar esta clave", rto = "Por ejemplo: Desarrollo", ito = "Clave API sin nombre", ato = "Esta clave API no tiene fecha de caducidad", sto = "Editar clave API", cto = "Clave API creada exitosamente", lto = "Clave API actualizada exitosamente", uto = "Crear", dto = "Guarde esta clave API en algún lugar seguro.", _to = "No podrá volver a verla una vez que cierre esta ventana modal.", pto = "Copiar al portapapeles", mto = "Habilitado tras la actualización", fto = "El enlace privado funcionará después de guardar", gto = "Revocar esta clave API", hto = "Desactivar reprogramación", vto = "Los invitados ya no pueden reprogramar el evento con la invitación del calendario o correo electrónico", bto = "Permitir reservas a través del enlace de reprogramación", yto = "Cuando está habilitado, los usuarios podrán crear una nueva reserva al intentar reprogramar una reserva cancelada", $to = "Desactivar cancelación", wto = "Los invitados ya no pueden cancelar el evento con la invitación del calendario o correo electrónico", kto = "Revocar clave API", Sto = "¡Clave API copiada!", Eto = "La clave API caducará el", xto = "¿Eliminar permanentemente esta clave de API de tu cuenta?", Cto = "Copiar", Tto = "Fecha de caducidad", Ato = "Caducó", Ito = "Nunca caduca", Oto = "Caduca", Nto = "Solicitud para reprogramar tu reserva", zto = "Motivo de la reprogramación", Rto = "Reserva una nueva hora", Pto = "Solicitud de reprogramación enviada", Dto = "Esto cancelará la reunión programada, notificará al planificador y te pedirá que escojas una nueva hora.", Lto = "Motivo de la solicitud de reprogramación", Mto = "Solicitar reprogramación ", Fto = "Editar reserva", qto = "Reprogramar reserva", jto = "Hora anterior", Vto = "Añade un GIF a tu página de confirmación", Bto = "Buscar", Uto = "Suplantar", Gto = "Suplantación de usuario", Wto = "Permite a nuestro equipo de soporte iniciar sesión temporalmente para ayudar a resolver rápidamente cualquier problema reportado.", Hto = "Permita a los administradores de su equipo iniciar sesión temporalmente como usted.", Yto = "Gratis para individuos. Planes de equipo para funciones colaborativas.", Kto = "Hacer la organización privada", Zto = "Los miembros de tu organización no podrán ver a otros miembros de la organización cuando esto esté activado.", Xto = "Hacer que el equipo sea privado", Jto = "Los miembros de su equipo no podrán ver a otros miembros del equipo cuando esto esté activado.", Qto = "No puede ver a todos los miembros de un equipo privado.", eno = "No puedes ver los equipos de una organización privada.", tno = "Permitir múltiples duraciones", nno = "Todos los usos de esta función son revisados.", ono = 'Suplantando nombre de usuario "{{user}}".', rno = "Haga clic aquí para detener.", ino = "Actualizado - Su evento cambió la ubicación", ano = "Añadido - Nuevos invitados añadidos a tu evento", sno = "Ubicación cambiada: {{eventType}} con {{name}} el {{date}}", cno = "Invitados añadidos: {{eventType}} con {{name}} el {{date}}", lno = "Ubicación actual", uno = "Nueva ubicación", dno = "Sesión", _no = "Controle la sesión de su cuenta", pno = "Tiempo de sesión agotado después de", mno = "Tiempo de sesión agotado", fno = "Invalide su sesión después de una cierta cantidad de tiempo.", gno = "No se ha definido ninguna ubicación", hno = "Establecer ubicación", vno = "Actualizar ubicación", bno = "Ubicación actualizada", yno = "La actualización de la ubicación ha fallado", $no = "Invitados añadidos", wno = "No se pueden añadir invitados", kno = "Eso no parece una dirección de correo electrónico", Sno = "Los correos electrónicos deben ser únicos y válidos", Eno = "Eso no parece una URL", xno = "Coloque este código en su HTML donde desea que aparezca su widget de {{appName}}.", Cno = "Cree o actualice un componente React existente como se muestra a continuación.", Tno = "Copiar código", Ano = "¡Código copiado!", Ino = "¿Cómo quiere añadir {{appName}} a su sitio?", Ono = "Elija una de las siguientes maneras de poner {{appName}} en su sitio.", Nno = "Configurando su integración con Zapier", zno = "Configurando su integración Make", Rno = "Generar clave API", Pno = "Generar una clave API para usar con {{appName}} en", Dno = "Su clave API única", Lno = "Copie esta clave API y guárdela en algún lugar seguro. Si pierde esta clave tendrá que generar una nueva.", Mno = "<0>Inicie sesión en su cuenta de Zapier y cree un nuevo Zap.</0><1>Seleccione Cal.com cómo su aplicación Trigger. También elija un evento Trigger.</1><2>Seleccione su cuenta e ingrese su Clave API única.</2><3>Pruebe su Trigger.</3><4>¡Listo!</4>", Fno = "Ve a <0>Enlace de invitación de Make</0> e instala la aplicación de Cal.com.", qno = "Inicia sesión en tu cuenta de Make y crea un nuevo escenario.", jno = "Selecciona Cal.com como tu aplicación de activación. También elige un evento de activación.", Vno = "Elige tu cuenta y luego ingresa tu clave API única.", Bno = "Prueba tu activador.", Uno = "¡Ya está listo!", Gno = "Instale primero la aplicación Zapier desde la App Store.", Wno = "Instale primero la aplicación Make desde la App Store.", Hno = "Instalación de la aplicación", Yno = "Aplicación no instalada", Kno = "Lo sentimos, esta aplicación no está instalada en tu cuenta. Por favor visita nuestra tienda de aplicaciones para explorar y descubrir esta y otras grandes aplicaciones.", Zno = "Conectar con Apple Server", Xno = "URL del calendario", Jno = "Genere una contraseña específica de la aplicación para utilizarla con {{appName}} en", Qno = "No se puede añadir esta cuenta de Apple Calendar. Por favor asegúrate de estar usando una contraseña específica para la aplicación en lugar de la contraseña de tu cuenta.", eoo = "Sus credenciales serán almacenadas y cifradas.", too = "Se almacenará y cifrará.", noo = "Ir a App Store", ooo = "Intenta volver a conectar tu calendario con todos los permisos necesarios", roo = "Configurar un número de teléfono para la reunión", ioo = "No hay franjas horarias ocupadas", aoo = "Mostrar en la página de reservas", soo = "La ubicación será visible antes de confirmar la reserva", coo = "Añadir GIF", loo = "Buscar en Giphy", uoo = "Añadir enlace de Giphy", doo = "Añadiendo un GIF a la página de confirmación", _oo = "Busque un GIF para mejorar su página de confirmación", poo = "Comparta sus comentarios", moo = "Recursos", foo = "Documentación de soporte", goo = "Documentación del desarrollador", hoo = "Póngase en contacto", voo = "Contactar con Soporte", boo = "Soporte Premium", yoo = "Soporte comunitario", $oo = "Comentarios", woo = "¡Gracias por sus comentarios!", koo = "Error al enviar comentarios", Soo = "Comparte tus comentarios aquí:", Eoo = "Detalles de la reserva", xoo = "o", Coo = "No tiene importancia", Too = "Ir a: ", Aoo = "Zapier Invite Link", Ioo = "Se creará una URL de la reunión una vez que se confirme el evento.", Ooo = "Mostrar dinámicamente el nombre de su asistente para usted, o su nombre si es visto por su asistente", Noo = "Ubicación del evento", zoo = "Razón para reagendar (opcional)", Roo = "Informa a los demás la razón por la que necesitas reagendar", Poo = "Este evento se canceló", Doo = "Le enviamos un correo electrónico a usted y a los demás asistentes para informarles.", Loo = "Esta entrada se mostrará al reservar este evento.", Moo = "La URL de la reunión está en el correo de confirmación", Foo = "La URL debe empezar por http:// o https://", qoo = "Se proporcionará el número de teléfono", joo = "antes del inicio del evento", Voo = "cuando se cancela el evento", Boo = "Después de que los anfitriones no se unieron al video de Cal", Uoo = "Después de que los invitados no se unieron al video de Cal", Goo = "Unirse a la videollamada", Woo = "Iniciar sesión en Cal.com", Hoo = "Iniciar sesión en Cal.com", Yoo = "Haz seguimiento de tus reuniones, recibe notificaciones y gestiona tu agenda de manera más efectiva.", Koo = "Haz seguimiento de tus reuniones y gestiona tu agenda de manera más efectiva", Zoo = "No se pudo unir a la llamada. Por favor, inténtalo de nuevo.", Xoo = "Elige cómo te gustaría unirte a esta llamada", Joo = "Elige cómo quieres aparecer en la llamada", Qoo = "cuando se reserva un nuevo evento", ero = "enviar correo electrónico al anfitrión", tro = "enviar correo electrónico a los asistentes", nro = "Enviar un SMS al asistente", oro = "enviar SMS a un número específico", rro = "Envíe fácilmente recordatorios de reuniones por SMS a sus asistentes", iro = "enviar un mensaje de Whatsapp a un número específico", aro = "enviar un mensae de Whatsapp al asistente", sro = "Flujos de trabajo", cro = "Flujo de trabajo nuevo", lro = "¿Cómo te gustaría empezar?", uro = "Agregar un flujo de trabajo nuevo", dro = "cuando el evento se vuelva a programar", _ro = "Desencadenante", pro = "Desencadenantes", mro = "Acción", fro = "Crear flujos de trabajo para automatizar notificaciones y recordatorios", gro = "Nombre del flujo de trabajo", hro = "Flujo de trabajo personalizado", vro = "{{workflowName}} creado exitosamente", bro = "¿Está seguro que desea eliminar este flujo de trabajo?", yro = "Eliminar flujo de trabajo", $ro = "Sí, eliminar el flujo de trabajo", wro = "Flujo de trabajo eliminado correctamente", kro = "¿Cuánto tiempo antes de que comience el evento?", Sro = "días", Ero = "horas", xro = "minutos", Cro = "m", Tro = "h", Aro = "Cree su primer workflow", Iro = "Los flujos de trabajo te permiten automatizar el envío de recordatorios y notificaciones.", Oro = "Activo en", Nro = "Flujo de trabajo {{workflowName}} actualizado correctamente", zro = "Este es un nombre de usuario estándar y la actualización te llevará a la facturación para bajar de categoría.", Rro = "Este es un nombre de usuario premium, obtenga el suyo por {{price}}", Pro = "Actual", Dro = "premium", Lro = "estándar", Mro = "Confirmar cambio de nombre de usuario", Fro = "Como estás cambiando de un nombre de usuario estándar a un nombre de usuario premium, se te llevará al pago para actualizarlo.", qro = "Como estás cambiando de un nombre de usuario premium a un nombre de usuario estándar, se te llevará al pago para bajar de categoría.", jro = "Ir a facturación", Vro = "Se requiere un pago para las reservas (0,5 % + 0,10 € de comisión por transacción)", Bro = "Tu prueba ha caducado", Uro = "Eliminar aplicación", Gro = "Sí, eliminar aplicación", Wro = "¿Está seguro de que desea eliminar esta aplicación?", Hro = "Aplicación eliminada correctamente", Yro = "Error al eliminar la aplicación", Kro = "Conferencia web", Zro = "Llamada web", Xro = "Iniciar llamada web", Jro = "Finalizar llamada", Qro = "Prueba tu agente con una llamada web sin necesidad de un número de teléfono", eio = "Llamada telefónica", tio = "Conectando con el agente...", nio = "Llamada activa", oio = "Llamada finalizada", rio = "Error en la llamada", iio = "Listo para iniciar la llamada", aio = "No se pudo iniciar la llamada web. Por favor, inténtalo de nuevo.", sio = "La llamada encontró un error. Por favor, inténtalo de nuevo.", cio = "No se pudo inicializar la llamada web. Asegúrate de que los permisos del micrófono estén concedidos.", lio = "Inicia una llamada para ver la conversación", uio = "Esperando conversación...", dio = "Agente de IA", _io = "En vivo", pio = "Conectando...", mio = "Requiere confirmación", fio = "Requiere confirmación si se reservó con < {{time}} $t({{unit}}_timeUnit) de aviso", gio = "Puede requerir confirmación", hio = "{{count}} tipo de evento", vio = "{{count}} tipos de eventos", bio = "{{count}} equipo", yio = "{{count}} equipos", $io = "Agregar acción", wio = "Establecer enlace Whereby", kio = "Introduce un enlace Whereby válido", Sio = "Establecer enlace Around.Co", Eio = "Introduce un enlace Around válido", xio = "Establecer enlace Riverside", Cio = "Introduce un enlace Riverside válido", Tio = "Introduce un enlace Ping.gg válido", Aio = "Conectar con Exchange 2013 Server", Iio = "Conectar con Exchange 2016 Server", Oio = "Plantilla personalizada", Nio = "Cuerpo del mensaje", zio = "Mensaje de texto", Rio = "¿Tienes un problema específico?", Pio = "navega por nuestros documentos", Dio = "Elija una plantilla", Lio = "Personalizado", Mio = "Recordatorio", Fio = "Reprogramado", qio = "Reprogramado por", jio = "Reserva original", Vio = "Completado", Bio = "Calificación", Uio = "Recordatorio: {{eventType}} con {{name}} el {{date}}", Gio = "No se activará para las reservas ya existentes, ya que se le pedirá al usuario un número de teléfono al reservar el evento.", Wio = "{{count}} minuto", Hio = "{{count}}m", Yio = "{{count}} minutos", Kio = "{{count}} hora", Zio = "{{count}}h", Xio = "{{count}} horas", Jio = "Entrada inválida", Qio = "No pudimos añadir el enlace de la reunión de {{location}} a tu evento programado. Contacta a tus invitados o actualiza tu evento en el calendario para añadir los detalles. Puedes <0>cambiar tu ubicación en el tipo de evento</0> o intentar <1>eliminar y añadir la aplicación nuevamente.</1>", eao = "No pudimos actualizar tu <1>{{calendar}}</1>. <2> Comprueba la configuración de tu calendario o elimina y añade tu calendario de nuevo </2>", tao = "Nombre del asistente", nao = "El nombre completo de la persona que reserva", oao = "Integración rota", rao = "Hubo un problema al añadir un enlace de vídeo", iao = "Hubo un problema al actualizar tu calendario", aao = "Activo en {{count}} tipo de evento", sao = "Activo en {{count}} tipos de eventos", cao = "Activo en {{count}} equipo", lao = "Activo en {{count}} equipos", uao = "Activo en todos los tipos de eventos", dao = "Activo en todos los equipos", _ao = "No hay tipos de evento activos", pao = "No hay equipos activos", mao = "Nuevo asistente {{name}} en {{eventType}} el {{date}}", fao = "Alguien se ha añadido a un evento", gao = "Variable", hao = "Nombre del evento", vao = "Nombre completo del asistente", bao = "Fecha del evento", yao = "Hora del evento", $ao = "Nombre del organizador", wao = "Para poder usar esta función, necesita actualizarse a una cuenta Pro.", kao = "Número de teléfono no válido", Sao = "URL no válida para {{label}}. URL de ejemplo: {{sampleUrl}}", Eao = "Navegar", xao = "Abrir", Cao = "Cerrar", Tao = "Actualizar", Aao = "Comprar número de EE.UU. por {{priceInDollars}}$/mes", Iao = "Actualizar para acceder a las grabaciones", Oao = "Las grabaciones solo están disponibles como parte de nuestro plan de equipos. Actualice para comenzar a grabar sus llamadas", Nao = "Actualiza a Enterprise para generar un número de teléfono de Agente AI que pueda llamar a los invitados para programar llamadas", zao = "Las grabaciones son parte del plan de equipos", Rao = "Esta es una función Team. Actualiza a Team para ver la disponibilidad de tu equipo.", Pao = "Esta es una función Team. Actualiza a Team para automatizar los recordadorios y las notificaciones de eventos con flujos de trabajo.", Dao = "Mostrar en perfil", Lao = "Insertar", Mao = "Nombre de usuario nuevo", Fao = "Nombre de usuario actual", qao = "Ejemplo 1", jao = "Ejemplo 2", Vao = "Identificador de preguntas de reserva", Bao = "Tamaño de la empresa", Uao = "¿Con qué necesitas ayuda?", Gao = "Formato variable", Wao = "La URL del suscriptor de Webhook ya está definida", Hao = "Ignore todos los caracteres especiales de la etiqueta de entrada adicional (utilice solo letras y números), utilice mayúsculas para todas las letras y sustituya los espacios en blanco por guiones bajos.", Yao = "¿Cómo uso las preguntas de reserva como variables?", Kao = "Descargar la aplicación de escritorio", Zao = "Establecer enlace Ping", Xao = "Límite de tasa excedido", Jao = "Cuando algo sucede", Qao = "Una acción es realizada", eso = "Probar acción", tso = "Notificación enviada", nso = "Sin entrada", oso = "Probar acción de flujo de trabajo", rso = "Enviar SMS", iso = "¿Está seguro de que desea enviar un SMS al {{number}}?", aso = "No hay ningún calendario predeterminado conectado", sso = "Puede conectar su calendario desde <1>aquí</1>.", cso = "Calendario predeterminado", lso = "Ocultar del perfil", uso = "Configuración del evento", dso = "No se encontró disponibilidad en el horario", _so = "Límites", pso = "Con qué frecuencia se puede reservar", mso = "Ajustes del calendario y más...", fso = "Avanzado", gso = "Configurar pagos para el evento", hso = "Configuración de eventos: varias duraciones requieren al menos una opción.", vso = "Configuración de eventos: seleccione una duración predeterminada válida.", bso = "Los límites de las reservas deben estar en orden ascendente. [día, semana, mes, año]", yso = "Los límites de duración deben estar en orden ascendente. [día, semana, mes, año]", $so = "Seleccione a qué calendario añadir reservas", wso = "Nombre de evento personalizado", kso = "Cree nombres de eventos personalizados para que el evento aparezca en el calendario", Sso = "Código de autenticación de dos factores incorrecto", Eso = "¿A qué tipo de evento se aplicará esto?", xso = "Aplicar a todos, incluidos los tipos de eventos futuros", Cso = "Aplicar a todos los tipos de eventos de equipo y usuario", Tso = "¿A qué equipo se aplicará esto?", Aso = "Los flujos de trabajo permiten una automatización simple para enviar notificaciones y recordatorios que le permiten crear procesos para sus eventos.", Iso = "Esta es una configuración interna y no afectará la manera en que se muestran los horarios en las páginas de reservas públicas para usted o para cualquier persona que lo solicite.", Oso = "Crear un flujo de trabajo", Nso = "Hacer esto", zso = "Apagar", Rso = "Activar", Pso = "Las reservas canceladas no se pueden reprogramar", Dso = "Configuración actualizada correctamente", Lso = "Error al actualizar la configuración", Mso = "Mi URL personal de {{appName}}", Fso = "Algunas frases sobre usted, esta información aparecerá en la página de su URL personal.", qso = "Finalizar configuración y comenzar", jso = "Este usuario no ha añadido una biografía todavía.", Vso = "Biografía", Bso = "Eliminar cuenta", Uso = "¿Está seguro que desea eliminar su cuenta de {{appName}}?", Gso = "Eliminar mi cuenta", Wso = "Inicio de la semana", Hso = "Grabaciones", Yso = "Grabación", Kso = "Feliz programación", Zso = "Seleccione los calendarios en los que desee comprobar conflictos para evitar reservas dobles.", Xso = "Comprobar conflictos", Jso = "Ver grabaciones", Qso = "Comprobar si hay grabaciones", eco = "Agregando eventos a", tco = "Siga las preferencias del sistema", nco = "Colores de marca personalizados", oco = "Personalice el color de su propia marca en su página de reservas.", rco = "Pro", ico = 'Elimina cualquier marca relacionada con {{appName}}, p. ej., "Powered by {{appName}}".', aco = "Reunión instantánea con {{name}}", sco = "Imagen de perfil", cco = "Cargar", lco = "Agregar foto de perfil", uco = "Dirección del token", dco = "Blockchain", _co = "Contraseña anterior", pco = "Su contraseña nueva supersegura", mco = "Error al actualizar la contraseña", fco = "Autenticación de dos factores", gco = "Configurar un calendario repetitivo", hco = "hoy", vco = "Aspecto", bco = "Mi cuenta", yco = "General", $co = "Calendarios", wco = "Facturas", kco = "Inserciones", Sco = "Suplantación", Eco = "Configuración para administrar la suplantación del usuario", xco = "Suplantaciones recientes", Cco = "Suplantar rápidamente", Tco = "No hay suplantaciones recientes", Aco = "Usuarios", Ico = "Usuario", Oco = "Administra los ajustes para tu perfil de {{appName}}", Nco = "Aquí puede encontrar una lista de todos los usuarios", zco = "Lista de usuarios", Rco = "Administre los ajustes para tu idioma y zona horaria", Pco = "Configura cómo interactúan tus tipos de eventos con tus calendarios", Dco = "Administra los ajustes para el aspecto de tu reserva", Lco = "Añada sus aplicaciones de videoconferencia favoritas para sus reuniones", Mco = "Añadir aplicación de conferencia", Fco = "Administra los ajustes para las contraseñas de tu cuenta", qco = "Configure su autenticación de doble factor", jco = "Solo necesitamos información básica para configurar tu perfil.", Vco = "Omitir", Bco = "Hacerlo más tarde", Uco = "Define los rangos de tiempo en los que estás disponible", Gco = "Puedes personalizar todo esto más tarde en la página de disponibilidad.", Wco = "Conecte un calendario primero", Hco = "Complete su perfil", Yco = "Puedes añadir más calendarios desde la tienda de aplicaciones", Kco = "Conectar aplicaciones de conferencia", Zco = "Conectar aplicaciones de calendario", Xco = "Conectar aplicaciones de pago", Jco = "Conecte aplicaciones de automatización", Qco = "Conecte aplicaciones de análisis", elo = "Conectar otras aplicaciones", tlo = "Conectar aplicaciones de mensajería", nlo = "Conectar aplicaciones CRM", olo = "Paso {{currentStep}} de {{maxSteps}}", rlo = "Añadir variable", ilo = "Número de teléfono personalizado", alo = "Plantilla de mensaje", slo = "Asunto del correo electrónico", clo = "Añadir variables de texto dinámico", llo = "Nombre del tipo de evento", ulo = "Fecha del evento", dlo = "La duración del evento", _lo = "Hora de inicio del evento", plo = "Tipo de evento no encontrado", mlo = "Número para llamar", flo = "El número de teléfono del usuario al que estás llamando", glo = "Ubicación", hlo = "Ubicación del evento", vlo = "Notas adicionales", blo = "Notas adicionales de la reserva", ylo = "Nombre completo de la persona que reserva", $lo = "Nombre del organizador", wlo = "Para", klo = "El flujo de trabajo {{workflowName}} se ha activado {{offOn}} con éxito", Slo = "Descargar respuestas", Elo = "Descargue todas las respuestas de su formulario en formato CSV.", xlo = "Ver respuestas", Clo = "Descargar", Tlo = "Descargando", Alo = "Descargar grabación", Ilo = "Las transcripciones están habilitadas ahora", Olo = "Las transcripciones están detenidas ahora", Nlo = "Descargar transcripción", zlo = "Transcripción", Rlo = "Una grabación de su llamada reciente en {{appName}} está lista para descargar", Plo = "La transcripción de su llamada reciente en {{appName}} está lista para descargar. Los enlaces son válidos solo por 1 hora.", Dlo = "También puedes descargar la transcripción desde los archivos adjuntos", Llo = "Nota: El enlace de descarga es válido solo por 12 horas. Puede generar un nuevo enlace de descarga siguiendo las instrucciones <1>aquí</1>.", Mlo = "Nota: El enlace de descarga es válido solo por 12 horas. Puedes generar un nuevo enlace de descarga siguiendo las instrucciones.", Flo = "Crea tu primer formulario", qlo = "Con los formularios de orientación puedes hacer preguntas calificadoras y encaminarte hacia la persona o tipo de evento correctos.", jlo = "Crea tu primer Webhook", Vlo = "Con Webhooks puedes recibir datos de reuniones en tiempo real cuando suceda algo en {{appName}}.", Blo = "Para un máximo de", Ulo = "evento", Glo = "eventos", Wlo = "Administra los ajustes para el perfil de tu equipo", Hlo = "Administre la configuración para el perfil de su organización", Ylo = "Usuarios que están en el grupo", Klo = "Gestione los administradores y miembros de su organización", Zlo = "URL del equipo", Xlo = "Miembros del equipo", Jlo = "Más", Qlo = "Flujos de trabajo de Cal.ai", euo = "y {{count}} más", tuo = "Consideramos la aplicación móvil como una extensión de la aplicación web. Si está realizando acciones complicadas, consulta la aplicación web.", nuo = "Enviar recordatorio por SMS al asistente, 24 horas antes de que el evento comience", ouo = "Enviar SMS personalizado al asistente cuando se reprograma el evento", ruo = "Enviar correo electrónico personalizado al anfitrión cuando se reserve un evento nuevo", iuo = "Enviar recordatorio por correo electrónico al asistente, 1 hora antes de que el evento comience", auo = "Enviar correo electrónico personalizado al anfitrión cuando se reprograme el evento", suo = "Enviar SMS personalizado al anfitrión cuando se reserve un evento nuevo", cuo = "Enviar recordatorio por SMS", luo = "24 horas antes del inicio del evento", uuo = "Seguimiento de ausencias", duo = "30 minutos después de finalizar el evento", _uo = "Recordar a los asistentes que traigan identificación", puo = "1 día antes del inicio del evento", muo = "Recordatorio por email", fuo = "1 hora antes del inicio del evento", guo = "Recordatorio SMS personalizado", huo = "Cuando se programa el evento", vuo = "Recordatorio por email personalizado", buo = "Evento reprogramado para el anfitrión", yuo = "Incluir el conteo de reservas de los tipos de eventos gestionados", $uo = "¡Bienvenido a {{appName}}!", wuo = "Podrás editarlo más tarde.", kuo = "Conectaré mi calendario más tarde", Suo = "Se produjo un problema al guardar tus datos. Inténtalo de nuevo o ponte en contacto con el servicio de atención al cliente.", Euo = "Adquirir las plazas que faltan", xuo = "Duración de la franja", Cuo = "Aspecto de la reserva", Tuo = "Administra los ajustes para el aspecto de la reserva de tu equipo", Auo = "Administre la configuración de la apariencia de las reservas de su organización", Iuo = "Solo el propietario de este equipo puede hacer cambios en la reserva ", Ouo = 'Elimina cualquier marca relacionada con {{appName}}, p. ej., "Powered by {{appName}}"', Nuo = "{{teamName}} te invitó a unirte a su equipo como {{role}}", zuo = "El token no es válido o ha caducado.", Ruo = "Ver reserva", Puo = "Conectar a Microsoft Exchange", Duo = "Método de autenticación", Luo = "Autenticación básica", Muo = "Autenticación NTLM", Fuo = "Compresión GZip", quo = "Versión de Exchange", juo = "2007 SP1", Vuo = "2010", Buo = "2010 SP1", Uuo = "2010 SP2", Guo = "2013", Wuo = "2013 SP1", Huo = "2015", Yuo = "2016", Kuo = "Enrutamiento", Zuo = "Crea formularios para dirigir a los asistentes a sus destinos correctos", Xuo = "Enviar correo electrónico al propietario", Juo = "Mande un correo electrónico al propietario cuando se envía el formulario", Quo = "Enviar correo electrónico a", edo = "Añadir formulario nuevo", tdo = "Añada un nuevo formulario a su equipo", ndo = "Cree su primera ruta", odo = "Ruta a la persona adecuada en función de las respuestas a su formulario", rdo = "Formulario", ido = "Crea tu formulario para dirigirlo a un agente de reservas", ado = "Copiar enlace al formulario", sdo = "Tema de la página de reserva", cdo = "Esto sólo se aplica a tus páginas públicas de reservas", ldo = "Tema del panel de control", udo = "Esto solo se aplica a su tabla de control conectada", ddo = "Predeterminado del sistema", _do = "Añadir un equipo", pdo = "Recibe los datos de la reunión en tiempo real cuando ocurra algo en {{appName}}", mdo = "Se activa cuando", fdo = "Antes de crear, ejecuta una prueba de ping.", gdo = "Activar Webhook", hdo = "Añadir Webhook", vdo = "Webhook guardado", bdo = "Genera claves API para acceder a tu propia cuenta", ydo = "Clave API nueva", $do = "activo", wdo = "Nombre de la clave API actualizado", kdo = "Error al actualizar el nombre de la clave API", Sdo = "Inserción de iframe HTML", Edo = "Incorpora todos tus tipos de eventos en tu sitio web", xdo = "Genera tu primera clave API", Cdo = "Las claves API permiten a otras aplicaciones comunicarse con {{appName}}", Tdo = "Volver a iniciar sesión", Ado = "Enlace de restablecimiento enviado", Ido = "Se ha enviado un correo electrónico a {{email}} con instrucciones para restablecer tu contraseña.", Odo = "Si no recibe un correo electrónico pronto, compruebe que la dirección de correo que ha introducido sea correcta, revise su carpeta de correo no deseado o comuníquese con el equipo de soporte si el problema persiste.", Ndo = "¡Contraseña actualizada!", zdo = "Pago pendiente", Rdo = "Invitaciones pendientes", Pdo = "Invitaciones pendientes de la organización", Ddo = "No estás en {{appName}}", Ldo = "No hay ningún calendario instalado", Mdo = "Aún no has conectado ninguno de tus calendarios", Fdo = "Añadir un calendario", qdo = "Es posible que necesites cerrar sesión y volver a iniciarla para ver los cambios aplicados.", jdo = "Confirma tu contraseña antes de cambiar la dirección de correo electrónico", Vdo = "plazas", Bdo = "Todas las aplicaciones publicadas en la tienda de aplicaciones de {{appName}} son de código abierto y han sido probadas exhaustivamente mediante revisiones por parte de los usuarios. Sin embargo, {{companyName}} no respalda ni certifica estas aplicaciones a menos que sean publicadas por {{appName}}. Si encuentras contenidos o comportamientos inapropiados, notifícalos.", Udo = "Denunciar aplicación", Gdo = "Limite la frecuencia de reserva", Wdo = "Limite la cantidad de veces que se puede reservar este evento", Hdo = "Mostrar solo el primer horario disponible de cada día", Ydo = "Esto limitará su disponibilidad para este tipo de evento a un horario por día, programado a la hora más temprana disponible.", Kdo = "Limitar la duración total de la reserva", Zdo = "Limitar la cantidad total de tiempo que se puede reservar este evento", Xdo = "Límite de reservas activas del solicitante", Jdo = "Limita el número de reservas activas que un solicitante puede hacer para este tipo de evento", Qdo = "Los eventos recurrentes no admiten límite de reservas del solicitante", e_o = "Agregue un límite", t_o = "Nombre de equipo requerido", n_o = "Comparta información de los asistentes entre los invitados", o_o = "Mostrar el número de cupos disponibles", r_o = "¿Cómo utilizar las preguntas de reserva como variables?", i_o = "Formato", a_o = "Preguntas", s_o = "Toda la información que tu solicitante debe proporcionar antes de reservar contigo.", c_o = "Use mayúsculas para todas las letras", l_o = "Reemplace espacios en blanco con guiones bajos", u_o = "Miembros de la plataforma", d_o = "Gestiona los administradores y miembros en tu equipo de plataforma", __o = "Facturación de la plataforma", p_o = "Gestione la facturación", m_o = "Gestione todo lo relacionado con la facturación", f_o = "Actualmente está en el plan GRATUITO", g_o = "Trabajamos mejor en equipo. Amplíe sus flujos de trabajo con eventos colectivos y rotativos y genere formularios de enrutamiento avanzados", h_o = "Pruebe ahora", v_o = "Portal de facturación", b_o = "Contacte con soporte", y_o = "Ignore los caracteres especiales en su identificador de pregunta de reserva. Use solo letras y números", $_o = "Reintentar", w_o = "Se produjo un problema al recuperar sus calendarios. <1>Inténtelo de nuevo</1> o contacte con el servicio de atención al cliente.", k_o = "Error de conexión con el calendario", S_o = "Confirmación de reserva exitosa", E_o = "Rechazo de reserva exitoso", x_o = "Esta reserva es provisional", C_o = "Ups, quiero aceptar", T_o = "No mostraremos esto de nuevo", A_o = "No pudimos actualizar la zona horaria", I_o = "Zona horaria actualizada a {{formattedCurrentTz}}", O_o = "Actualizar zona horaria", N_o = "¿Actualizar zona horaria?", z_o = "Parece que su zona horaria local ha cambiado a {{formattedCurrentTz}}. Es muy importante tener la zona horaria correcta para evitar reservas en tiempos no deseados. ¿Desea actualizarla?", R_o = "No actualizar", P_o = "Solicitar notas adicionales", D_o = "Solicitar completar las notas adicionales al reservar", L_o = "enviar un correo electrónico a una dirección específica", M_o = "después de que el evento termine", F_o = "cuando la reserva es rechazada", q_o = "cuando la reserva es solicitada", j_o = "cuando el pago de la reserva es iniciado", V_o = "cuando el pago de la reserva es exitoso", B_o = "cuando la no presentación de la reserva es actualizada", U_o = "¿Cuánto tiempo después de que termine el evento?", G_o = "¿Cuánto tiempo después de que los anfitriones no se presenten en la reunión de video de Cal?", W_o = "¿Cuánto tiempo después de que los invitados no se presenten en la reunión de video de Cal?", H_o = "¿Cuánto tiempo después de que los usuarios no se presenten en la reunión de video de Cal?", Y_o = "No hay espacios disponibles", K_o = "Tiempo disponible", Z_o = "¿No encuentras la aplicación de conferencias adecuada? Visita nuestra <0>Tienda de aplicaciones</0>.", X_o = "Instalar nueva aplicación de calendario", J_o = "Solicitar número de teléfono para reservar el evento", Q_o = "Disponibilidad para {{eventTypeTitle}}", epo = "Error al editar la disponibilidad", tpo = "No tiene permiso para acceder a este recurso.", npo = "Pega los metadatos SAML de tu Proveedor de Identidad aquí", opo = "Por favor, introduce un correo electrónico para que podamos encontrar tu Proveedor de Identidad SAML", rpo = "Detalles del proveedor de servicios", ipo = "Su proveedor de identidad (IdP) le pedirá los siguientes detalles para completar la configuración de la aplicación SAML.", apo = "URL de ACS", spo = "ID de entidad SP", cpo = "¡URL de ACS copiada!", lpo = "¡ID de entidad SP copiado!", upo = "Añadir un calendario", dpo = "Limitar reservas futuras", _po = "Limite hasta qué punto se puede reservar este evento en el futuro", ppo = "No hay tipos de eventos configurados", mpo = "{{name}} no ha configurado ningún tipo de evento para que usted reserve.", fpo = "Frecuencia de facturación", gpo = "Mensual", hpo = "Anual", vpo = "Proceder al pago", bpo = "Su equipo se ha disuelto con éxito", ypo = "Su organización se ha disuelto con éxito", $po = "Error al crear el equipo", wpo = "Usted", kpo = "O continuar con", Spo = "Reenviar correo electrónico", Epo = "El miembro ya se ha invitado", xpo = "El nombre de usuario ya está en uso", Cpo = "Introduzca un correo electrónico o nombre de usuario", Tpo = "Ingrese un correo electrónico", Apo = "Ingrese correos electrónicos", Ipo = "Está limitado a invitar a un máximo de {{nbUsers}} usuarios a la vez.", Opo = "Este nombre ya está en uso", Npo = "Debe introducir un nombre de equipo", zpo = "Debe introducir una URL del equipo", Rpo = "Esta URL ya está en uso", Ppo = "Hubo un problema con el registro del subdominio, intente nuevamente o comuníquese con un administrador", Dpo = "Publicar equipo", Lpo = "Número de teléfono (Notificaciones de texto)", Mpo = "Número de teléfono (notificaciones SMS)", Fpo = "Correo electrónico del asistente", qpo = "El correo electrónico de la persona que reserva", jpo = "UID de reserva", Vpo = "Escriba un comando o búsqueda...", Bpo = "¡Oh no! Parece que el permiso ha caducado o se ha revocado. Vuelva a instalarlo.", Upo = "Reinstalar aplicación", Gpo = "Razón de la reprogramación", Wpo = "Elige un horario común para todos", Hpo = "Activa esto si quieres usar un horario común entre anfitriones. Cuando está desactivado, cada anfitrión será reservado según su horario predeterminado o el horario que hayan elegido.", Ypo = "Motivo", Kpo = "ID del remitente", Zpo = "Sólo se permiten letras, números y espacios (máx. 11 caracteres)", Xpo = "Prueba de formulario de ruta", Jpo = "Probar vista previa", Qpo = "Ruta hacia", emo = "Pruebe su formulario de ruta sin enviar ningún dato", tmo = "Prueba de ruta", nmo = "Un administrador desactivó una aplicación de pago", omo = "Editar tipo de evento", rmo = "Esta organización es privada, y solo el administrador o propietario de la organización puede ver a sus miembros.", imo = "Solo el administrador o propietario de la organización puede gestionar la configuración de SSO", amo = "Solo el administrador o propietario de la organización puede gestionar la configuración de sincronización de directorios", smo = "Solo el administrador o propietario de la organización puede gestionar los clientes OAuth", cmo = "Programación colectiva", lmo = "Haga que sea fácil reservar su equipo cuando todos estén disponibles.", umo = "Encuentre a la mejor persona disponible y haga una rotación en su equipo.", dmo = "Rotación fija por turnos", _mo = "Agregue un asistente fijo y realice rotación por turnos a través de un número de asistentes.", pmo = "{{appName}} funciona mejor con equipos", mmo = "El equipo de {{companyName}}", fmo = "Añada los miembros de su equipo a sus tipos de eventos. Utilice la programación colectiva para incluir a todos o encuentre a la persona más adecuada con programación de rotación por turnos.", gmo = "Se ha alcanzado el límite de reserva para este tipo de evento", hmo = "Se ha alcanzado el límite de duración para este tipo de evento", vmo = "Un administrador desactivó {{appName}}", bmo = "Esto desactivará todos los correos electrónicos para {{recipient}}. Esto incluye confirmaciones de reserva, solicitudes, reprogramaciones y solicitudes de reprogramación, correos de cancelación y cualquier otro correo relacionado con actualizaciones de reservas.<br /><br />Es tu responsabilidad asegurarte de que tus {{recipient}} estén al tanto de cualquier reserva y cambios en sus reservas.", ymo = "Un administrador desactivó {{appName}}, lo que afecta a su tipo de evento {{eventType}}", $mo = "Un administrador ha reemplazado uno de sus tipos de eventos", wmo = "Un administrador del equipo ha reemplazado su evento /{{slug}}", kmo = "Un administrador del equipo <strong>{{teamName}}</strong> reemplazó su tipo de evento <strong>/{{slug}}</strong> con un tipo de evento gestionado que él controla.", Smo = "Su enlace seguirá funcionando, pero algunas configuraciones pueden haber cambiado. Puede revisarlo en tipos de eventos.", Emo = "Si tiene alguna pregunta sobre el tipo de evento, comuníquese con su administrador.<br /><br />Feliz programación, <br />El equipo de Cal.com", xmo = "El administrador ha desactivado {{appName}}, lo que afecta a tu tipo de evento {{title}}. Los asistentes aún pueden reservar este tipo de evento, pero no se les pedirá que paguen. Puedes ocultar el tipo de evento para evitar esto hasta que tu administrador vuelva a habilitar tu método de pago.", Cmo = "Los asistentes aún pueden reservar este tipo de evento, pero no se les pedirá que paguen. Puedes ocultar el tipo de evento para evitar esto hasta que tu administrador vuelva a habilitar tu método de pago.", Tmo = "El administrador desactivó {{appName}}, lo que afecta a su tipo de evento {{title}}.", Amo = "El administrador ha desactivado {{appName}}, lo que puede afectar a sus tipos de evento. Si tiene tipos de eventos con {{appName}} como localización, entonces el valor predeterminado será Cal Video.", Imo = "{{appName}} se desactivó", Omo = "Ir a las aplicaciones instaladas", Nmo = "Si tiene otro calendario instalado, las nuevas reservas se añadirán a él. De lo contrario, conecte un nuevo calendario para que no se pierda ninguna reserva nueva.", zmo = "Activar aplicaciones", Rmo = "Habilite las aplicaciones que los usuarios pueden integrar con {{appName}}", Pmo = "Compre una licencia", Dmo = "¿Ya tienes una cuenta?", Lmo = "Ya tengo una clave:", Mmo = "Copie aquí su variable de entorno CALCOM_LICENSE_KEY existente.", Fmo = "Crear clave de licencia", qmo = "{{appName}} está activada", jmo = "{{appName}} está desactivada", Vmo = "Se han guardado las claves", Bmo = "Desactivar aplicación", Umo = "Desactivar esta aplicación puede causar problemas con la forma en que sus usuarios interactúan con Cal", Gmo = "Editar claves", Wmo = "Habilite aplicaciones para su instancia de Cal", Hmo = "Una lista de todos los usuarios en tu cuenta, incluyendo su nombre, título, correo electrónico y rol.", Ymo = "Aquí puedes añadir un nuevo usuario.", Kmo = "Aquí puedes editar un usuario existente.", Zmo = "Aquí puedes editar una organización.", Xmo = "Añadir nuevos clientes OAuth", Jmo = "Bloquear o desbloquear el envío de SMS para los usuarios", Qmo = "No hay aplicaciones disponibles", efo = "Verifique que haya aplicaciones en su implementación en 'packages/app-store'", tfo = "No hay aplicaciones activadas en esta instancia de Cal", nfo = "Aún no se ha configurado ninguna aplicación", ofo = "Puede activar aplicaciones en la configuración", rfo = "Póngase en contacto con su administrador", ifo = "Configuración de aplicaciones", afo = "Complete este campo", sfo = "Opciones", cfo = "Introduzca la opción {{index}}", lfo = "Agregue una opción", ufo = "Esta ubicación ya existe. Por favor, selecciona una nueva ubicación", dfo = "Botón radial", _fo = "Para usar Google Meet, debes configurar tu calendario de destino como un calendario de Google", pfo = "Individuo", mfo = "Todas las reservas", ffo = "Todos los usuarios", gfo = "Todos los tipos de eventos", hfo = "Sus reservas", vfo = "URL de la reunión", bfo = "URL de la reunión del evento", yfo = "Anular fechas", $fo = "Eliminar anulaciones de fecha el {{date}}", wfo = "Agregue fechas cuando su disponibilidad difiera de su horario diario.", kfo = "Las anulaciones de fecha se archivan automáticamente después de que haya pasado la fecha", Sfo = "¿En qué horas está disponible?", Efo = "¿En qué horas está ocupado(a)?", xfo = "Seleccione las fechas para anular", Cfo = "No disponible todo el día", Tfo = "Marcar como no disponible (Todo el día)", Afo = "Marcar como no disponible en las fechas seleccionadas", Ifo = "Actualizar anulación", Ofo = "Sustitución de fechas añadida correctamente", Nfo = "Guardar excepción", zfo = "{{slug}}-copia", Rfo = "Establecer como predeterminado", Pfo = "Ocultar detalles del tipo de evento", Dfo = "Mostrar navegación", Lfo = "Ocultar navegación", Mfo = "Se envió el código de verificación", Ffo = "Verificado exitosamente", qfo = "Código de verificación incorrecto", jfo = "Aún no se ha verificado", Vfo = "Sin disponibilidad en {{month}}", Bfo = "La programación solo está disponible hasta {{days}} días por adelantado. Por favor, vuelve a consultar pronto.", Ufo = "La programación terminó el {{date}}. Por favor, comprueba de nuevo pronto.", Gfo = "Ver mes anterior", Wfo = "Ver el próximo mes", Hfo = "Enviar código", Yfo = "Número verificado", Kfo = "Cree su primer webhook para este tipo de evento de equipo", Zfo = "Crear un webhook para este tipo de evento de equipo", Xfo = "Desactivar página de éxito (solo funciona si tiene una URL de redireccionamiento)", Jfo = "Usted es administrador pero no tiene una contraseña de al menos 15 caracteres o una autenticación de 2 factores aún", Qfo = "Cambia tu contraseña para obtener acceso de administrador", ego = "Este nombre de usuario ya está en uso", tgo = "Asignación", ngo = "Anfitriones fijos", ogo = "Añadir anfitriones fijos", rgo = "Anfitriones por turnos", igo = "Número de anfitriones requeridos para asistir", ago = "Anfitriones", sgo = "Necesitas crear un equipo para habilitar esta función. Haz clic aquí para crear un equipo.", cgo = "Debe pasarse a nuestro plan Enterprise para habilitar esta función.", lgo = "Nuevo asistente", ugo = "En espera de aprobación", dgo = "Esta aplicación requiere una conexión con Google Calendar", _go = 'El "Añadir al calendario" para este tipo de evento necesita ser un Google Calendar para que Meet funcione. Conéctalo <0>aquí</0>.', pgo = "Ha conectado una cuenta de Google Calendar.", mgo = "El uso de Google Meet requiere un Google Calendar conectado", fgo = "Siga con la instalación de Google Calendar", ggo = "Instale Google Meet", hgo = "Instale Google Calendar", vgo = "Nombre del remitente", bgo = "Asistente ya invitado", ygo = "No se encontraron grabaciones", $go = "Nuevo flujo de trabajo para...", wgo = "Reportando", kgo = "Vea todos los datos entrantes y descárguelos como un CSV", Sgo = "Se requiere un plan de Equipos", Ego = "Los formularios de enrutamiento son una excelente manera de dirigir sus clientes potenciales entrantes a la persona adecuada. Actualice a un plan de Equipos para acceder a esta función.", xgo = "Elija una licencia", Cgo = "Cal.com viene con una licencia AGPLv3 accesible y gratuita, la cual tiene algunas limitaciones. Esta licencia se puede actualizar a una licencia Empresarial en cualquier momento. Puede actualizarla más tarde.", Tgo = "Licencia", Ago = "Licencia AGPLv3", Igo = "No es necesario mantener su código abierto", Ogo = "Vuelva a empaquetar, cambie la marca y revenda fácilmente", Ngo = "Un amplio conjunto de funciones empresariales", zgo = "$0,00/mes", Rgo = "Siempre abierto y gratis", Pgo = "Necesario para mantener su código abierto", Dgo = "No se puede volver a empaquetar, cambiar la marca y revender fácilmente", Lgo = "Sin características empresariales", Mgo = "Licencia Empresarial", Fgo = "Todo para un caso de uso comercial con alojamiento privado, reempaquetado, cambio de marca y reventa, además de acceso a componentes empresariales exclusivos.", qgo = "Configuración", jgo = "Configurar la instancia de Cal.com", Vgo = "Configurar", Bgo = "Inicio de sesión único", Ugo = "Configure SAML/OIDC SSO y permita que los miembros del equipo inicien sesión con un proveedor de identidad", Ggo = "Configure SSO SAML/OIDC y permita que los miembros de la organización inicien sesión utilizando un proveedor de identidad", Wgo = "SSO con OIDC", Hgo = "Configure OIDC SSO con el proveedor de identidad de su elección.", Ygo = "Configuración de OIDC", Kgo = "Configure la conexión OIDC a su proveedor de identidad. Puede encontrar la información requerida en su proveedor de identidad.", Zgo = "URL de devolución de llamada copiada", Xgo = "SSO con SAML", Jgo = "Configure SAML SSO con el proveedor de identidad de su elección.", Qgo = "Configuración de SAML", eho = "Configure la conexión SAML a su proveedor de identidad. Puede encontrar la información requerida en su proveedor de identidad.", tho = "URL de ACS copiada", nho = "ID de entidad copiado", oho = "Configuración de {{connectionType}} creada con éxito", rho = "Configuración de {{connectionType}} eliminada con éxito", iho = "Eliminar la configuración de {{connectionType}}", aho = "Sí, eliminar la configuración de {{connectionType}}", sho = "¿Está seguro de que desea eliminar la configuración de {{connectionType}}? Los miembros de su equipo que utilicen el inicio de sesión {{connectionType}} ya no podrán acceder a Cal.com.", cho = "Zona horaria del organizador", lho = "Ver la invitación", uho = "Aceptar invitación", dho = "Unirse ahora", _ho = "Unido con éxito", pho = "Has sido invitado a unirte a un equipo de la organización {{parentTeamName}}", mho = "Has sido invitado a unirte a una organización de {{appName}}", fho = "{{invitedBy}} lo invitó a unirse a su equipo en {{appName}}. {{appName}} es el programador de eventos que les permite a usted y a su equipo programar reuniones sin necesidad de enviar correos electrónicos.", gho = "{{invitedBy}} le ha invitado a unirse al equipo {{teamName}} en su organización {{parentTeamName}} en {{appName}}. {{appName}} es el programador de eventos que le permite a usted y a su equipo programar reuniones sin el intercambio constante de correos electrónicos.", hho = '{{invitedBy}} lo ha invitado a unirse a su organización "{{teamName}}" en {{appName}}. {{appName}} es el programador de eventos que le permite a usted y a su organización programar reuniones sin el tenis del correo electrónico.', vho = "Te guiaremos a través de unos breves pasos y estarás disfrutando de programación sin estrés con tu {{entity}} en poco tiempo.", bho = "Elija su nombre de usuario", yho = "Conecte su cuenta de calendario", $ho = "Establezca su disponibilidad", who = "Únase a {{teamName}}", kho = "Feliz programación le desea el equipo de {{appName}}", Sho = "Está a punto de suplantar a un usuario, lo que significa que puede hacer cambios en su nombre. Tenga cuidado.", Eho = "Variables disponibles", xho = "{Scheduler}", Cho = "No hay flujos de trabajo", Tho = "Cambie el filtro para ver sus flujos de trabajo personales y de equipo.", Aho = "Cambie el filtro para ver los resultados.", Iho = "No hay resultados para el filtro", Oho = "Siguientes pasos recomendados", Nho = "Crear un tipo de evento administrado", zho = "Las reuniones son mejores si están los miembros adecuados del equipo. Invítelos ahora.", Rho = "Cree una plantilla de reunión individual para un tipo de evento y distribúyala a varios miembros.", Pho = "Colectivo o turnos rotativos", Dho = "Reserve a los miembros de su equipo juntos con eventos colectivos o por ciclos para conseguir a la persona adecuada con turnos rotativos.", Lho = "Ya no asistirá a {{title}} a las {{date}}", Mho = "Ya no asistirá a este evento", Fho = "Un asistente ya no asistirá a {{title}} a las {{date}}", qho = "Un asistente ya no asistirá a su evento", jho = "{{name}} ha cancelado. Esto significa que está disponible una plaza para esta franja horaria", Vho = "Crear evento en", Bho = "Crear formulario de enrutamiento en", Uho = "Establecer un enlace de aplicación predeterminado", Gho = "Establecer un enlace de aplicación predeterminado permite que todos los tipos de eventos recién creados utilicen el enlace de aplicación que establezca.", Who = "Aplicación por defecto del organizador", Hho = "{{organizer}} no tiene una aplicación de conferencias predeterminada", Yho = "Fuera de servicio por mantenimiento", Kho = "El equipo de {{appName}} está realizando un mantenimiento programado. Si tiene alguna pregunta, comuníquese con soporte.", Zho = "{{numberOfSeats}} plazas", Xho = "Preguntas sobre la reserva", Jho = "Personalice las preguntas que se hacen en la página de reservas", Qho = "Agregar una pregunta", evo = "Identificador", tvo = "El correo electrónico está duplicado", nvo = "Introduce una URL de redirección a la que se enviará al asistente una vez que abandone la reunión.", ovo = "Ya no es posible pagar por este evento", rvo = "Un reembolso por el pago de esta reserva está en camino.", ivo = "El pago de esta reserva se ha reembolsado.", avo = "Según la política de reembolso del evento, el pago de la reserva no es reembolsable.", svo = "El período de reembolso del evento ha expirado. Por lo tanto, el pago de la reserva no es reembolsable.", cvo = "Error al confirmar la reserva", lvo = "No hay suficientes plazas", uvo = "Ya existe un campo con este nombre", dvo = "El campo de invitados debe ser de tipo 'Múltiples correos electrónicos'", _vo = "Mostrar en la página de reserva", pvo = "Puedes visitar la página de la reserva cancelada", mvo = "Comience con las plantillas de Zapier", fvo = "Plantillas estándar", gvo = "Plantillas de Cal.ai", hvo = "{{team}} no está publicado", vvo = "El enlace de esta organización no está disponible actualmente. Comuníquese con el propietario de la organización o pídale que lo publique.", bvo = "Este enlace de {{entity}} no está disponible actualmente. Póngase en contacto con el propietario de {{entity}} o pídale que lo publique.", yvo = "Miembro del equipo", $vo = "Un formulario de enrutamiento", wvo = "Descripción del formulario", kvo = "Mantenerme conectado con el formulario", Svo = "Cualquier cambio realizado en el enrutador o en los campos del formulario que se está duplicando se reflejará en el duplicado. Sin embargo, eliminar un campo no lo eliminará del duplicado.", Evo = "Formulario eliminado", xvo = "¿Está seguro de que desea eliminar este formulario?", Cvo = "Sí, eliminar formulario", Tvo = "Cualquier persona con la que hayas compartido el enlace ya no podrá acceder a él.", Avo = "Se eliminarán todas las respuestas asociadas.", Ivo = "¡URL de redirección copiada! Puedes ir y configurar la URL en tu propio formulario.", Ovo = "Las modificaciones en los campos y rutas de los siguientes formularios se reflejarán en este formulario.", Nvo = "Formularios conectados", zvo = "Los siguientes formularios se verían afectados cuando modifique campos o rutas aquí.", Rvo = "Espere un tiempo para que se recopilen las respuestas. También puede proceder y enviar el formulario usted mismo.", Pvo = "Esto es lo que verían sus usuarios", Dvo = "Identifique el campo con este nombre.", Lvo = "Agregue 1 opción por línea", Mvo = "Seleccione un enrutador", Fvo = "Agregar una ruta nueva", qvo = "Tome decisiones informadas con Insights", jvo = "Nuestro panel de Insights muestra toda la actividad de su equipo y las tendencias que permiten una mejor programación y toma de decisiones.", Vvo = "Ver reservas de todos los miembros", Bvo = "Mira quién está recibiendo más reservas y asegura la mejor distribución en tu equipo", Uvo = "Identificar tendencias de reserva", Gvo = "Consultar cuáles son las horas de la semana y del día más populares para sus reservas", Wvo = "Detectar tipos de eventos populares", Hvo = "Consulte cuál de sus tipos de eventos están recibiendo más clics y reservas", Yvo = "Aún no hay respuestas", Kvo = "No hay rutas definidas", Zvo = "Este será el marcador de posición", Xvo = "Ocurrió un error al reservar el evento, actualice la página e intente nuevamente", Jvo = "No hay intervalo de tiempo seleccionado", Qvo = "Seleccione un intervalo de tiempo para reservar el evento.", ebo = "Seleccionar intervalo de tiempo", tbo = "Cambiar a la vista mensual", nbo = "Cambiar a la vista semanal", obo = "Cambiar a la vista diaria", rbo = "Cambiar a la vista de columna", ibo = "{{num}} opciones de ubicación", abo = "Seleccionar en el siguiente paso", sbo = "Esta reunión aún no ha comenzado", cbo = "{{appName}} requiere una cuenta {{dependencyName}} conectada", lbo = "Conectar {{dependencyName}}", ubo = "{{dependencyName}} está conectada", dbo = "Requiere {{dependencyName}}", _bo = "Código de verificación", pbo = "¿Puede intentarlo de nuevo con una hora diferente?", mbo = "Verificar", fbo = "Zona horaria de la persona que recibe", gbo = "Zona horaria", hbo = "Hora de finalización del evento", vbo = "La hora de finalización del evento", bbo = "URL de cancelación", ybo = "La URL para cancelar la reserva", $bo = "Motivo de cancelación", wbo = "El motivo de la cancelación de la reserva", kbo = "URL de reprogramación", Sbo = "La URL para reprogramar la reserva", Ebo = "Motivo de reprogramación", xbo = "El motivo de la reprogramación de la reserva", Cbo = "Hay una variable no válida en el nombre de su evento", Tbo = "Seleccionar todo", Abo = "Actualización masiva de los tipos de eventos existentes", Ibo = "Horario predeterminado del miembro", Obo = "Establecido por el administrador del equipo", Nbo = "Ubicación predeterminada del miembro", zbo = "Usaremos el horario de disponibilidad predeterminado de cada miembro. Este se podrá editar o cambiar.", Rbo = "Es necesario tener al menos un horario", Pbo = "Actualizar las ubicaciones para los tipos de eventos seleccionados", Dbo = "Actualiza los horarios para los tipos de eventos seleccionados", Lbo = "Bloqueado para miembros", Mbo = "Desbloqueado para miembros", Fbo = "Los miembros podrán ver las aplicaciones activas, pero no podrán editar ninguna configuración de la aplicación", qbo = "Los miembros podrán ver las aplicaciones activas y podrán editar cualquier configuración de la aplicación", jbo = "Podrás ver las aplicaciones activas pero no podrás editar ninguna configuración de la aplicación", Vbo = "Podrás ver las aplicaciones activas y podrás editar cualquier configuración de la aplicación", Bbo = "Los miembros no pueden agregar sus flujos de trabajo personales a este tipo de evento. Los miembros podrán ver los flujos de trabajo del equipo activos pero no podrán editar ninguna configuración del flujo de trabajo.", Ubo = "Los miembros podrán agregar sus flujos de trabajo personales a este tipo de evento. Los miembros podrán ver los flujos de trabajo del equipo activos pero no podrán editar ninguna configuración del flujo de trabajo.", Gbo = "Podrás ver los flujos de trabajo del equipo activos pero no podrás editar ninguna configuración del flujo de trabajo ni agregar tus flujos de trabajo personales a este tipo de evento.", Wbo = "Podrás habilitar/deshabilitar flujos de trabajo personales en este tipo de evento. Podrás ver los flujos de trabajo del equipo activos pero no podrás editar ninguna configuración del flujo de trabajo del equipo.", Hbo = "Los miembros no pueden añadir sus webhooks personales a este tipo de evento. Los miembros podrán ver los webhooks activos pero no podrán editar ninguna configuración de webhook.", Ybo = "Los miembros podrán añadir sus webhooks personales a este tipo de evento. Los miembros podrán ver los webhooks activos pero no podrán editar ninguna configuración de webhook.", Kbo = "Puedes ver los webhooks administrados activos pero no podrás editar ninguna configuración de webhook ni añadir tus webhooks personales a este tipo de evento.", Zbo = "Puedes añadir webhooks a este tipo de evento. Puedes ver los webhooks administrados activos pero no podrás editarlos.", Xbo = "Bloqueado por el administrador del equipo", Jbo = "No ha conectado una cuenta de {{appName}}.", Qbo = "Conectar ahora", eyo = "Reemplazar y notificar a {{count}} miembro", tyo = "Reemplazar y notificar a {{count}} miembros", nyo = "La url /{{slug}} ya existe para {{count}} miembro. ¿Desea reemplazarla?", oyo = "La url /{{slug}} ya existe para {{count}} miembros. ¿Desea reemplazarla?", ryo = "<strong>{{names}}</strong> ya usa la url <strong>/{{slug}}</strong>.", iyo = "<strong>{{names}}</strong> ya usan la url <strong>/{{slug}}</strong>.", ayo = "Si elige reemplazarlo, se lo notificaremos. Regrese y elimínelos si no desea sobrescribirlo.", syo = "Revisar tipo de evento", cyo = "¿Busca más datos de análisis?", lyo = "¿Quiere saber más sobre Insights?", uyo = "Filtros", dyo = "Filtrar", _yo = "Añadir un miembro", pyo = "Añadir filtro", myo = "Añadir regla", fyo = "Añadir grupo de reglas", gyo = "Borrar todos los filtros", hyo = "Correo electrónico verificado", vyo = "Seleccionar usuario", byo = "Seleccionar tipo de evento", yyo = "Seleccionar rango de fechas", $yo = "Eventos populares", wyo = "No se encontraron tipos de eventos", kyo = "Duración promedio del evento", Syo = "Reservas por hora", Eyo = "Miembros más reservados", xyo = "Miembros menos reservados", Cyo = "Mayor número de reservas programadas", Tyo = "Menor número de reservas programadas", Ayo = "Mayor número de reservas completadas", Iyo = "Menor número de reservas completadas", Oyo = "Eventos creados", Nyo = "Eventos completados", zyo = "Eventos cancelados", Ryo = "Eventos reprogramados", Pyo = "Eventos", Dyo = "Rendimiento", Lyo = "desde el último período", Myo = "Desde: {{startDate}} Hasta: {{endDate}}", Fyo = 'Agregar una redirección deshabilitará la página de éxito. Asegúrese de mencionar "Reserva confirmada" en su página de éxito personalizada.', qyo = "Tendencias del evento", jyo = "Eliminar filtros", Vyo = "Borrar", Byo = "Retener", Uyo = "Cobrar el pago durante la reserva", Gyo = "Cobrar comisión por no presentarse", Wyo = "Tarjeta retenida", Hyo = "Cargar la tarjeta", Yyo = "Se le cobró a la tarjeta", Kyo = "{{amount, currency}} cargo por no presentarse", Zyo = "Comisión por no presentarse", Xyo = "Enviar tarjeta", Jyo = "Enviar información de pago", Qyo = "Su reunión está esperando un método de pago", e$o = "Comisión por no presentarse de {{amount, currency}} cobrada para {{title}} el {{date}}", t$o = "Se cobró una tarifa por no presentarse", n$o = "Se cobró una comisión de {{amount, currency}} por no presentarse al siguiente evento", o$o = "Algo salió mal al cobrar la tarifa por no presentarse. Inténtelo de nuevo más tarde.", r$o = "Cobrar comisión por no presentarse", i$o = "Comisión por no presentarse cobrada", a$o = "Pago rechazado. Por favor, intente con otra tarjeta o contacte a su banco para obtener ayuda.", s$o = "Este tipo de tarjeta no es compatible con esta compra. Por favor, utilice un método de pago diferente.", c$o = "El monto mínimo de pago es $0.50 USD. Por favor, aumente su monto de pago.", l$o = "No se pudo cargar la tarjeta para el pago.", u$o = "Perspectivas", d$o = "Formularios de enrutamiento", _$o = "No se encontraron datos para el filtro seleccionado o las fechas seleccionadas.", p$o = "Reconozco que si no asisto a este evento, se aplicará a mi tarjeta una tarifa de {{amount, currency}} por no presentarme.", m$o = "días", f$o = "Detalles de la tarjeta", g$o = "Algo salió mal por nuestra parte. Ponte en contacto con nuestro equipo de soporte y lo solucionaremos de inmediato.", h$o = "Proporcione el siguiente texto cuando se comunique con el soporte para ayudarlo mejor", v$o = "Actualmente, no se pueden habilitar cupos ni cobrar una tarifa por no presentarse", b$o = "Complete su reserva", y$o = "Complete su reserva: {{title}} el {{date}}", $$o = "Confirme sus datos", w$o = "Copiar enlace de invitación", k$o = "Editar ajustes de enlace", S$o = "Enlace de invitación copiado", E$o = "Enlace de invitación eliminado", x$o = "Clave API eliminada", C$o = "Esto eliminará permanentemente la clave API. Cualquier aplicación que use esta clave perderá inmediatamente el acceso a tu cuenta. Esta acción no se puede deshacer.", T$o = "Configuración de enlace de invitación guardada", A$o = "Enlaces establecidos para expirar después de...", I$o = "1 día", O$o = "7 días", N$o = "30 días", z$o = "3 meses", R$o = "1 año", P$o = "Lo han invitado a unirse a {{teamName}}", D$o = "{{amount, currency}}", L$o = "Está a punto de cobrarle {{amount, currency}} al asistente. ¿Está seguro de que desea continuar?", M$o = "Cobrar al asistente {{amount, currency}}", F$o = "Solicitar pago ({{paymentFeePercentage}}% + {{fee, currency}} comisión por transacción)", q$o = "Se ha invitado a {{email}}", j$o = "Se han invitado {{userCount}} usuarios", V$o = "Error al cargar la tarjeta", B$o = "La imagen cargada no debe exceder el límite de tamaño de 5 Mb", U$o = "{{errorCode}}: No está autorizado para habilitar o deshabilitar este flujo de trabajo", G$o = "Incrustar en línea", W$o = "Carga su tipo de evento directamente en línea con otro contenido de su sitio web.", H$o = "Botón emergente flotante", Y$o = "Pone un botón flotante en su sitio que activa un modal con su tipo de evento.", K$o = "Aparece mediante un clic en el elemento", Z$o = "Abre su cuadro de diálogo Cal cuando alguien hace clic en un elemento.", X$o = "Usar mi propio formulario", J$o = "Use nuestra API de enrutamiento sin interfaz y utilice su propio formulario para envíos.", Q$o = "¿Necesita ayuda? Consulte nuestras guías para incrustar Cal en Wix, Squarespace o WordPress, consulte nuestras preguntas comunes o explore las opciones avanzadas de incrustación.", ewo = "Reservar mi Cal", two = "Nombre", nwo = "Nombre", owo = "Nombre, Apellido", rwo = "Invitar como", iwo = "Formulario actualizado con éxito.", awo = "Desactivar los correos electrónicos de confirmación predeterminados para los asistentes", swo = "Al menos un flujo de trabajo está activo en este tipo de evento que envía un correo electrónico a los asistentes cuando se reserva el evento.", cwo = "Desactivar los correos electrónicos de confirmación predeterminados para el anfitrión", lwo = "Al menos un flujo de trabajo está activo en este tipo de evento que envía un correo electrónico al anfitrión cuando se reserva el evento.", uwo = "Agregar una anulación", dwo = "Importar usuarios de Google Workspace", _wo = "Conectar Google Workspace", pwo = "Debe ser administrador para usar esta función", mwo = "Cree su primer webhook para este tipo de evento", fwo = "Crea tu primer webhook con 'Reunión instantánea creada' como desencadenante para este tipo de evento", gwo = "Instalar aplicación en", hwo = "Crear para", vwo = "Moneda", bwo = "Crea un entorno donde tus equipos puedan crear aplicaciones compartidas, flujos de trabajo y tipos de eventos con programación round robin y colectiva.", ywo = "Gestione organizaciones con varios equipos", $wo = "Configure su organización", wwo = "Configura tu plataforma", kwo = "Las organizaciones son entornos compartidos donde los equipos pueden crear tipos de eventos, aplicaciones, flujos de trabajo compartidos y más.", Swo = "Planes", Ewo = "Plataforma", xwo = "Gestiona todo lo relacionado con la plataforma.", Cwo = "Cal.com Platform te permite integrar la programación sin esfuerzo en tu aplicación utilizando APIs y átomos de la plataforma.", Two = "Debe introducir el nombre de una organización", Awo = "Debe introducir la dirección de correo electrónico de su organización", Iwo = "Dirección de correo electrónico de su organización", Owo = "Tu dirección de correo electrónico de administrador", Nwo = "Nombre de usuario del administrador", zwo = "Nombre de la organización", Rwo = "Nombre de la plataforma", Pwo = "URL de la organización", Dwo = "Verifique el correo electrónico de su organización", Lwo = "Utilice el siguiente código para verificar su dirección de correo electrónico y continuar con la configuración de su organización.", Mwo = "Parámetros adicionales de URL", Fwo = "Acerca de su organización", qwo = "Las organizaciones son entornos compartidos donde puede crear varios equipos con miembros, tipos de eventos, aplicaciones, flujos de trabajo compartidos y más.", jwo = "Cree sus equipos", Vwo = "Comiencen a programar juntos agregando miembros de su equipo a su organización", Bwo = "Invite a los administradores de su organización", Uwo = "Estos administradores tendrán acceso a todos los equipos de su organización. Puede agregar administradores y miembros del equipo más tarde.", Gwo = "Establezca una contraseña", Wwo = "Esto creará una nueva cuenta de usuario con el correo electrónico de su organización y esta contraseña.", Hwo = "Logo de la organización", Ywo = "Algunas frases sobre su organización. Esto aparecerá en la página de perfil público de su organización.", Kwo = "Lo haré más tarde", Zwo = "Verifique su correo electrónico", Xwo = "Ingrese el código de 6 dígitos que enviamos a {{email}}", Jwo = "Verifique su correo electrónico para crear una organización", Qwo = "El código proporcionado no es válido, inténtelo de nuevo", eko = "El correo electrónico ya se está utilizando", tko = "Lo han invitado a unirse a {{orgName}}", nko = "Únase a su equipo en {{orgName}} y comience a concentrarse en las reuniones, no en hacer reuniones.", oko = "No se pudieron crear los siguientes equipos debido a slugs duplicados: {{slugs}}", rko = "Los nombres de equipo no pueden estar vacíos", iko = "Los nombres de equipo no se pueden repetir", ako = "El usuario pertenece a una organización", sko = "Esta organización aún no tiene equipos", cko = "Si usted es un administrador, asegúrese de crear equipos para que se muestren aquí.", lko = "Configurar", uko = "Mi perfil", dko = "Mi configuración", _ko = "CRM", pko = "Mensajería", mko = "Nombre o número que se muestra como el remitente de un SMS (algunos países no permiten ID de remitente alfanumérico)", fko = "Sólo el administrador de su organización puede crear nuevos equipos", gko = "La nueva política de spam de Google podría impedir que recibas notificaciones por correo electrónico y calendario sobre esta reserva.", hko = "Resolver", vko = "Hubo un error al crear equipos para esta organización. Falta el slug de URL.", bko = "Copiar enlace a la organización", yko = "Equipo: {{teamName}}", $ko = "Usuario: {{userName}}", wko = "Mire información de insights en todos sus eventos", kko = "Historial de llamadas", Sko = "Ver historial de llamadas de tus llamadas con Cal.ai", Eko = "{{locationCount}} opciones de ubicación", xko = "Tipo de canal", Cko = "Motivo de finalización", Tko = "Estado de la sesión", Ako = "Sentimiento del usuario", Iko = "Hora", Oko = "De", Nko = "Plan personalizado", zko = "Incrustado en el correo electrónico", Rko = "Seleccione algunos horarios disponibles e incrústelos en su correo electrónico", Pko = "Seleccione la hora", Dko = "Seleccione la fecha", Lko = "Mostrar solo si se establece un parámetro", Mko = "Agregar parámetro", Fko = "Te estamos conectando con alguien de {{orgName}}.", qko = "Por favor, no cierres ni actualices esta página", jko = "Ver todas las horas disponibles", Vko = "ej. Equipo de marketing", Bko = "ej. Equipo de ventas", Uko = "ej. Equipo de diseño", Gko = "ej. Equipo de ingeniería", Wko = "ej. Equipo de análisis de datos", Hko = "Más adelante podrá añadir más equipos.", Yko = "¿De qué trata esta reunión?", Kko = "Agregar al equipo", Zko = "Eliminar usuarios de la organización", Xko = "Credencial de delegación", Jko = "La credencial de delegación te permite gestionar el acceso a los calendarios de Google Workspace para tu organización.", Qko = "Añade este ID de cliente en Google Workspace con el siguiente alcance", e0o = "Credencial de delegación habilitada", t0o = "Añadir credencial de delegación", n0o = "Editar credencial de delegación", o0o = "Dominio", r0o = "No hay plataformas de trabajo", i0o = "Plataforma de trabajo", a0o = "Plataformas de trabajo", s0o = "Gestiona las plataformas de trabajo que se pueden usar para la credencial de delegación", c0o = "Editar plataforma de trabajo", l0o = "Editar cuenta de servicio", u0o = "Añadir plataforma de trabajo", d0o = "Slug", _0o = "JSON de la clave de cuenta de servicio", p0o = "Editar JSON de la clave de cuenta de servicio", m0o = "La credencial de delegación restringe añadir más de una instalación", f0o = "Aplicación instalada correctamente y está usando credenciales delegadas", g0o = "¿Está seguro de que desea eliminar {{userCount}} usuarios de esta organización?", h0o = "Eliminar usuarios del equipo", v0o = "¿Estás seguro de que quieres eliminar a {{userCount}} usuarios de este equipo?", b0o = "Este usuario no ha configurado ningún horario todavía", y0o = "Este usuario no está en ningún equipo", $0o = "Este usuario aún no ha instalado ninguna aplicación", w0o = "Requiere verificación por correo electrónico de quien reserva", k0o = "Para asegurar la verificación del correo electrónico de quien reserva antes de programar eventos", S0o = "Los mensajes de texto solo se pueden enviar a los asistentes cuando el tipo de evento requiere confirmación.", E0o = "Organizaciones", x0o = "Subir logo de Cal Video", C0o = "Actualizar logo de Cal Video", T0o = "Subir banner", A0o = "Para asegurar que tu logo sea visible contra el fondo oscuro de Cal Video, por favor sube una imagen de color claro en formato PNG o SVG para mantener la transparencia.", I0o = "Otros equipos", O0o = "Aquí puede ver los equipos dentro de su organización de los que no forma parte. Puede agregarse a ellos si es necesario.", N0o = "No formas parte de ninguna organización", z0o = "No se encontraron otros equipos", R0o = "No hay otros equipos en esta organización.", P0o = "Nombre del asistente", D0o = "Apellido del asistente", L0o = "Primer nombre de la persona que reserva", M0o = "Apellido de la persona que reserva", F0o = "Su resumen mensual", q0o = "Nombre del miembro", j0o = "Eventos más populares", V0o = "Este es el resumen de los eventos populares de su equipo {{teamName}} durante los últimos 30 días", B0o = "Yo", U0o = "Reunión no disponible", G0o = "Correo electrónico de resumen mensual", W0o = "Correo electrónico de resumen mensual para equipos", H0o = "Verifique su equipo para activar el envío de mensajes a los asistentes", Y0o = "Miembro eliminado", K0o = "Mi disponibilidad", Z0o = "Disponibilidad del equipo", X0o = "Disponibilidad para reuniones instantáneas", J0o = "Código de respaldo", Q0o = "Códigos de respaldo", e1o = "Cada código de respaldo se puede utilizar exactamente una vez para conceder acceso sin su autenticador.", t1o = "¡Códigos de respaldo copiados!", n1o = "El código de respaldo no es correcto.", o1o = "Acceso perdido", r1o = "No se encontraron códigos de respaldo. Genere los códigos en su configuración.", i1o = "Nueva organización creada: acción pendiente", a1o = "Hola Administrador", s1o = "Una organización requiere la configuración DNS", c1o = 'Se creó una organización con slug "{{orgSlug}}".<br /><br />Asegúrese de configurar su registro DNS para que apunte el subdominio correspondiente a la nueva organización hacia donde se ejecuta la aplicación principal. De lo contrario, la organización no funcionará.<br /><br />Estas son solo las opciones muy básicas para configurar un subdominio para que apunte a su aplicación para que cargue la página de perfil de la organización.<br /><br />Puede hacerlo ya sea con el Registro A:', l1o = "O el registro CNAME:", u1o = "Una vez que configure el subdominio, marque la configuración DNS como se hace en la Configuración de administrador.", d1o = "Ir a la Configuración del administrador de organizaciones", _1o = "Se procesó la organización", p1o = "Ocurrió un error al procesar esta organización", m1o = "Una lista de todas las organizaciones. Aceptar una organización permitirá que todos los usuarios con ese dominio de correo electrónico se registren SIN verificación de correo electrónico.", f1o = "Sin verificar", g1o = "Verificado", h1o = "Falta el DNS", v1o = "DNS Configurado", b1o = "Marcar como DNS configurado", y1o = "Valor", $1o = "Su organization se actualizó con éxito", w1o = "Este equipo no tiene tipos de eventos", k1o = "La opción Cupo no soporta múltiples duraciones", S1o = "Incluir evento del calendario", E1o = "OAuth", x1o = "Formulario de creación de cliente OAuth", C1o = "Este es el formulario para crear un nuevo cliente OAuth", T1o = "Formulario de actualización de cliente OAuth", A1o = "Este es el formulario para editar un cliente OAuth existente", I1o = "Añadido recientemente", O1o = "Conecte todos sus calendarios", N1o = "{{appName}} lee la disponibilidad de todos tus calendarios existentes.", z1o = "Personaliza tu experiencia de programación con flujos de trabajo", R1o = "Automatización del flujo de trabajo", P1o = "Programa para tu equipo con programación colectiva y en turnos rotativos", D1o = "No se encontraron miembros", L1o = "Directory Sync", M1o = "Nombre del directorio", F1o = "Proveedor del directorio", q1o = "URL base de SCIM", j1o = "Token de portador SCIM", V1o = "URL base de SCIM copiada", B1o = "Token de portador SCIM copiado", U1o = "Tu proveedor de identidad solicitará la siguiente información para configurar SCIM. Sigue las instrucciones para finalizar la configuración.", G1o = "Configurar sincronización de directorio", W1o = "Elige un proveedor de identidad para configurar el directorio para tu equipo.", H1o = "Configura un proveedor de identidad para empezar con SCIM.", Y1o = "Conexión de sincronización de directorio creada.", K1o = "Provisiona y desprovisiona usuarios con tu proveedor de directorio.", Z1o = "Conexión de sincronización de directorio eliminada.", X1o = "Eliminar Conexión", J1o = "Eliminar Conexión de Sincronización de Directorio", Q1o = "¿Estás seguro de que quieres eliminar esta conexión de sincronización de directorio?", eSo = "Esta acción no se puede deshacer. Esto eliminará permanentemente la conexión de sincronización de directorio.", tSo = "Configuración del evento: la duración debe ser de al menos 1 minuto.", nSo = "Horarios de disponibilidad", oSo = "Sin autorización", rSo = "{{clientName}} quiere acceder a su cuenta de {{appName}}", iSo = "Seleccionar cuenta o equipo", aSo = "Esto permitirá que {{clientName}}", sSo = "Lo asocie con su información personal de {{clientName}}", cSo = "Consulte su información personal, incluida la información personal que haya hecho pública", lSo = "Consulte su dirección de correo electrónico principal", uSo = "Se conecte a sus aplicaciones instaladas", dSo = "Lea, edite y elimine sus tipos de eventos", _So = "Lea, edite y elimine su disponibilidad", pSo = "Lea, edite y elimine sus reservas", mSo = "¿Desea permitir que {{clientName}} haga esto?", fSo = "Al hacer clic en permitir, permite que esta aplicación utilice su información de acuerdo con sus términos de servicio y política de privacidad. Puede eliminar el acceso en la App Store de {{appName}}.", gSo = "Permitir", hSo = "Este usuario no ha completado la incorporación. No podrá establecer su disponibilidad hasta que haya completado la incorporación.", vSo = "Está viendo la disponibilidad de este usuario. Sólo puede editar su propia disponibilidad.", bSo = "Puede anular esto por evento en la Configuración avanzada de cada tipo de evento.", ySo = "Editar disponibilidad del usuario: {{username}}", $So = "Reenviar invitación", wSo = "Se reenvió la invitación.", kSo = "SAML", SSo = "Agregar cliente", ESo = "Después de copiar el secreto, ya no podrá volver a verlo", xSo = "Agregar nuevo cliente", CSo = "Añadir nuevo usuario", TSo = "Esta aplicación aún no se ha configurado", ASo = "como CSV", ISo = "Superponer mi calendario", OSo = "Al conectarse a su calendario, acepta nuestra política de privacidad y nuestros términos de uso. Puede revocar el acceso en cualquier momento.", NSo = "Consulte los eventos de su calendario para evitar el conflicto de reservas.", zSo = "Únete a {{eventLocationType}}", RSo = "Solución de problemas", PSo = "Calendarios que estamos comprobando para conflictos", DSo = "Horarios de disponibilidad", LSo = "Gestionar calendarios", MSo = "Gestionar horarios de disponibilidad", FSo = "Bloqueado", qSo = "Desbloqueado", jSo = "Bloquear la zona horaria en la página de reserva", VSo = "Bloquear la zona horaria en la página de reserva, es útil para eventos en persona.", BSo = "Solo puedes tener una aplicación de pago habilitada por tipo de evento.", USo = "Por favor, introduce el número en formato internacional.", GSo = "Instalar Calendario", WSo = "Subdominio personalizado", HSo = "Obtén tu propio subdominio personalizado, como acme.cal.com", YSo = "Perspectivas de toda la organización", KSo = "Entiende cómo toda tu organización está utilizando el tiempo", ZSo = "Asistencia dedicada en materia de incorporación e ingeniería", XSo = "Personaliza tu experiencia de programación con tu propio logo, colores y más", JSo = "Equipos Ilimitados", QSo = "Verificar correo electrónico", eEo = "Por favor, introduzca la dirección de correo electrónico utilizada para esta reserva para proceder con la cancelación", tEo = "El correo electrónico no coincide con el correo de la reserva", nEo = "Añade tantos subequipos como necesites a tu organización", oEo = "Facturación Unificada", rEo = "Tipos de Eventos Avanzados Gestionados", iEo = "Añade una sola tarjeta de crédito para pagar todas las suscripciones de tu equipo", aEo = "Empresa", sEo = "Actualiza a Enterprise para crear tu Organización", cEo = "Crea tu Organización", lEo = "Crear organización", uEo = "Actualiza a Organizaciones y recibe un subdominio, facturación unificada, Insights, personalización extensa y más", dEo = "Actualiza a Enterprise y obtén acceso a la sincronización de Active Directory, aprovisionamiento automático de usuarios SCIM, agentes de voz de Cal.ai, APIs de administración y más", _Eo = "Solo puedes habilitar una aplicación de pago por tipo de evento", pEo = "Los equipos que son miembros de esta organización también serán eliminados junto con sus tipos de eventos", mEo = "Los usuarios que formaban parte de la organización no serán eliminados, pero sus nombres de usuario se cambiarán para permitirles existir fuera de la organización", fEo = "Los tipos de eventos de usuario creados después de que el usuario estuviera en la organización serán eliminados", gEo = "Los tipos de eventos de usuario migrados no serán eliminados", hEo = "¿Eliminar {{organizationName}}?", vEo = "Publicado", bEo = "No Publicado", yEo = "Publicar", $Eo = "Abre el solucionador de problemas y averigua qué está mal con tu horario", wEo = "¿Necesita ayuda?", kEo = "Solucionador de Problemas", SEo = "Número a Llamar", EEo = "Nombre del Invitado", xEo = "Correo Electrónico del Invitado", CEo = "Empresa del Invitado", TEo = "Por favor, instala un calendario", AEo = "Reserva Instantánea", IEo = "Permite que la gente reserve inmediatamente", OEo = "Actualiza a Enterprise y permite que los invitados se unan a una llamada instantánea a la que los asistentes pueden entrar directamente. Esto es solo para tipos de eventos de equipo", NEo = "¿No quieres esperar?", zEo = "Reunión Iniciada", REo = "Pagar para reservar", PEo = "Permite que Agentes de IA te reserven", DEo = "No se pudo encontrar la reserva", LEo = "No hay asientos disponibles para la reserva", MEo = "Faltan credenciales de pago", FEo = "Falta el ID de la aplicación de pago", qEo = "No hay suficientes asientos disponibles para la reserva", jEo = "{{username}} está ausente por un breve período de tiempo.", VEo = "Mientras tanto, {{profile.username}} se encargará de todas las nuevas reuniones programadas en nombre de {{username}}.", BEo = "Fuera de la oficina", UEo = "Informa a tus reservadores cuando estés fuera de la oficina.", GEo = "Enviar solicitud", WEo = "Se requieren fecha de inicio y fecha de fin", HEo = "La fecha de inicio debe ser antes de la fecha de fin", YEo = "La fecha de inicio debe estar en el futuro", KEo = "Usuario no encontrado", ZEo = "No se puede redirigir a sí mismo", XEo = "Ya existe una entrada de fuera de la oficina", JEo = "Se requiere el ID de la entrada de fuera de la oficina", QEo = "Ya existe una redirección de reserva de ese usuario hacia ti.", exo = "Entrada creada con éxito", txo = "Notificación de redirección de reserva", nxo = "Notificación de Redirección de Reserva", oxo = "Has recibido una redirección de reserva de {{eventOwner}}, por lo que los enlaces de su perfil se redirigirán al tuyo durante el intervalo de tiempo {{dates}}.", rxo = "Notificación de edición de redirección de reserva", ixo = "Notificación de Edición de Redirección de Reserva", axo = "Tu redirección de reserva de {{eventOwner}} para el intervalo de tiempo {{oldDates}} ha sido actualizada. El nuevo intervalo de tiempo para la redirección es {{dates}}.", sxo = "Notificación de cancelación de redirección de reserva", cxo = "Notificación de Cancelación de Redirección de Reserva", lxo = "Tu redirección de reserva de {{eventOwner}} para el intervalo de tiempo {{dates}} ha sido cancelada.", uxo = "Has aceptado esta solicitud de redirección de reserva.", dxo = "Has rechazado esta solicitud de redirección de reserva.", _xo = "Copiar enlace para compartir solicitud", pxo = "Solicitud de Redirección de Reserva", mxo = "Seleccionar miembro del equipo", fxo = "¿Te vas? Simplemente marca el enlace de tu perfil como no disponible por un período de tiempo.", gxo = "Proporciona un enlace a un miembro del equipo cuando estés fuera de la oficina", hxo = "Proporciona un enlace a un miembro del equipo cuando estés fuera de la oficina (Se requiere plan de equipo)", vxo = "Lista de indisponibilidad fuera de la oficina", bxo = "Entrada eliminada con éxito", yxo = "Entrada editada con éxito", $xo = "¿Fuera de la oficina temporalmente?", wxo = "Agregar una redirección", kxo = "Crear entrada", Sxo = "Rango de tiempo", Exo = "Agregar a todos los miembros del equipo, incluidos los futuros", xxo = "Redirigir a", Cxo = "¿Tienes problemas para encontrar un tiempo?", Txo = "Mostrar más", Axo = "Reenviar parámetros como ?email=...&name=... y más", Ixo = "Programa reuniones cuando todos estén disponibles o rota entre los miembros de tu equipo", Oxo = "más bajo", Nxo = "bajo", zxo = "medio", Rxo = "alto", Pxo = "más alto", Dxo = "Enviar a Booker a", Lxo = "Establecer prioridad", Mxo = "Establecer peso", Fxo = "Habilitar pesos", qxo = "Prioridad para {{userName}}", jxo = "Los pesos determinan cómo se distribuyen las reuniones entre los anfitriones. <0>Más información</0>", Vxo = "Peso para {{userName}}", Bxo = "cambiar prioridad", Uxo = "Usa identificadores de campo como variables para tu redirección de eventos personalizada", Gxo = "Usa identificadores de campo como variables para tu redirección de eventos personalizada (por ejemplo, {{variable}})", Wxo = "La cuenta ya está vinculada", Hxo = "Enviar correo electrónico", Yxo = "Llamar al asistente usando el agente de voz de Cal.ai", Kxo = "Llamada para confirmar reserva", Zxo = "2 horas antes del inicio del evento", Xxo = "Configuración del agente Cal.ai", Jxo = "Por favor, elige al menos un tipo de evento para realizar una llamada de prueba.", Qxo = "Marcar como no presentado", eCo = "Desmarcar como no presentado", tCo = "Cuenta desvinculada con éxito", nCo = "Hubo un error al desvincular la cuenta", oCo = "Horario de viaje", rCo = "Planifica tu viaje con anticipación para mantener tu horario existente en una zona horaria diferente y evitar ser reservado a medianoche.", iCo = "Programar cambio de zona horaria", aCo = "Fecha", sCo = "Introduce la indicación general para el agente", cCo = "Esto se superpone con un horario existente. Por favor selecciona una fecha diferente.", lCo = "Recibir notificaciones cuando tu equipo no tenga disponibilidad", uCo = "Los administradores recibirán notificaciones por correo electrónico cuando un usuario intente reservar con un miembro del equipo y no haya disponibilidad. Enviamos este correo después de dos intentos y te recordamos cada 7 días por usuario.", dCo = "Desactivar notificaciones SMS para tipos de eventos solo con teléfono", _Co = "Desactivar notificaciones SMS automáticas para tipos de eventos que solo tienen número de teléfono (attendeePhoneNumber) como pregunta obligatoria con correo electrónico opcional o no requerido", pCo = "Tu plan actual", mCo = "$37 por usuario al mes", fCo = "Gestiona la configuración de privacidad para tu organización", gCo = "Privacidad", hCo = "Los nuevos equipos estarán bajo tu organización", vCo = "Añadir nombre del grupo", bCo = "Nombre del grupo", yCo = "Enrutadores", $Co = "Primario", wCo = "Hacer primario", kCo = "Añadir correo electrónico", SCo = "Añadir correos electrónicos", ECo = "Añade una dirección de correo electrónico para reemplazar tu principal o para usar como correo alternativo en tus tipos de eventos.", xCo = "Confirma tu correo electrónico", CCo = "$t(hey_there) {{name}}, confirmando tu reserva para el {{date}}.", TCo = "El nombre de la persona que reserva", ACo = "El apellido de la persona que reserva", ICo = "Nombre del programador", OCo = "Tu nombre", NCo = "Enviamos un correo electrónico a <strong>{{email}}</strong>. Haz clic en el enlace del correo para verificar esta dirección.", zCo = "Enviar detalles del evento a", RCo = "Programar zona horaria sin fecha de finalización", PCo = "Seleccionar miembros", DCo = "¿Qué debemos hacer con los tipos de eventos existentes de tu miembro?", LCo = "Todos los tipos de eventos individuales de tus miembros (excepto los gestionados) se eliminarán permanentemente. No podrán crear nuevos.", MCo = "Los tipos de eventos individuales de tus miembros (excepto los gestionados) se ocultarán de los perfiles, pero los enlaces seguirán activos. No podrán crear nuevos.", FCo = "Ocultar tipos de eventos individuales", qCo = "Eliminar tipos de eventos individuales", jCo = "Bloquear la creación de tipos de eventos individuales", VCo = "Evitar que los miembros creen sus propios tipos de eventos.", BCo = "Añadir al tipo de evento", UCo = "Crear contraseña de cuenta", GCo = "Crear cuenta con SAML", WCo = "Error al crear la contraseña de la cuenta", HCo = "No se puede crear la contraseña de la cuenta para cuentas de calendario", YCo = "No se puede crear la contraseña de la cuenta para las ya existentes", KCo = "No tienes una contraseña de cuenta, crea una navegando a Seguridad -> Contraseña. No puedes desconectar hasta que se cree una contraseña de cuenta.", ZCo = "Desconectar cuenta conectada", XCo = "Desconectar tu cuenta conectada cambiará la forma en que inicias sesión. Solo podrás iniciar sesión en tu cuenta usando correo electrónico + contraseña", JCo = "Estoy de acuerdo con la política de privacidad y el uso de cookies", QCo = "Hacer una llamada", eTo = "Omitir asignación de turnos si el contacto existe en Salesforce", tTo = "La URL debe contener el correo electrónico del contacto como parámetro, por ejemplo, ?email=contactEmail", nTo = "Seleccionar cuenta", oTo = "Instala {{appName}} en tu cuenta personal o en una cuenta de equipo.", rTo = "Seleccionar tipos de eventos", iTo = "¿En qué tipo de evento quieres instalar {{appName}}?", aTo = "Configurar {{appName}}", sTo = "Finaliza la configuración de la aplicación. Puedes cambiar estos ajustes más tarde.", cTo = "ya instalado", lTo = "No especificado", uTo = "Vacaciones", dTo = "Viaje", _To = "Baja por enfermedad", pTo = "Día festivo", mTo = "Reenviando a <0>{{username}}</0>", fTo = "Sin reenvío", gTo = "Crear un OOO", hTo = "Comunica a tus reservadores cuando no estés disponible para tomar reservas. Aún pueden reservarte a tu regreso o puedes reenviarlos a un miembro del equipo.", vTo = "{{displayName}} está fuera de la oficina", bTo = "<0>{{displayName}}</0> puede tomar sus reuniones mientras está fuera.", yTo = "Reservar con {{displayName}}", $To = "Seleccionar motivo", wTo = "Salir de la oficina", kTo = "Editar Entrada de Fuera de la Oficina", STo = "Enviar comentarios", ETo = "Tu anfitrión no se presentó", xTo = "Puedes reprogramar otra reunión con ellos", CTo = "¿Cómo podemos mejorar nuestro servicio?", TTo = "¿Qué te gustó más?", ATo = "Reseña", ITo = "Reseñado", OTo = "Sin revisar", NTo = "URL de valoración", zTo = "La URL para el formulario de retroalimentación de calificaciones", RTo = "URL de no asistencia", PTo = "La URL para la retroalimentación de no asistencia", DTo = "¿No se necesita soporte?", LTo = "Ocultar soporte", MTo = "Calificaciones promedio", FTo = "No presentado (Anfitrión)", qTo = "No presentado (Invitado)", jTo = "Calificaciones recientes", VTo = "No se han enviado calificaciones", BTo = "Agrega un flujo de trabajo con 'Calificación' para recopilar calificaciones después de las reuniones", UTo = "Mayor ausencia", GTo = "Mejor calificado", WTo = "Peor calificado", HTo = "Miembros con reuniones mejor calificadas", YTo = "Miembros con reuniones peor calificadas", KTo = "Puntuación CSAT", ZTo = "SMS bloqueado", XTo = "¿Salir sin asignar a nadie?", JTo = "¿Estás seguro de que quieres salir de este evento sin agregar asistentes?", QTo = "Si no asignas a nadie para este evento, no habrá disponibilidad mostrada a los reservadores.", eAo = "Volver y asignar", tAo = "Salir sin asignar", nAo = "Al continuar, acepta nuestras <0>condiciones de uso</0> y nuestra <1>política de privacidad</1>.", oAo = "Al continuar, aceptas nuestros", rAo = "Términos", iAo = "Siempre {{x}} días disponibles", aAo = "Mueve automáticamente la ventana de reservas de {{x}} días hacia adelante cada día, asegurando que tu calendario siempre muestre los próximos {{x}} días de espacios disponibles.", sAo = "Suscripción del equipo cancelada con éxito", cAo = "Error al cancelar la suscripción del equipo", lAo = "Ocurrió un error al intentar suscribirse al plan de la plataforma, por favor intente de nuevo más tarde", uAo = "Ocurrió un error al actualizar el cliente OAuth, por favor intente de nuevo más tarde", dAo = "Ocurrió un error al crear el cliente OAuth, por favor intente de nuevo más tarde", _Ao = "Color del tipo de evento", pAo = "Esto solo se usa para diferenciar el tipo de evento y la reserva dentro de la aplicación. No se muestra a los reservadores.", mAo = "Marcar como no presentado", fAo = "{{x}} marcado como no presentado", gAo = "{{x}} desmarcado como no presentado", hAo = "se activa para todos los tipos de eventos del equipo y los tipos de eventos personales de todos los miembros del equipo", vAo = "Administra la configuración de tu equipo", bAo = "Estado de no presentado actualizado para los asistentes", yAo = "Correo electrónico copiado", $Ao = "Número de teléfono copiado", wAo = "El usuario es un miembro pendiente de la organización", kAo = "El usuario ya está invitado o es miembro", SAo = "El usuario es miembro de una organización de la que este equipo no forma parte.", EAo = "La reserva ha sido reasignada", xAo = "Reasignar", CAo = "Reasignar la reserva a otro anfitrión disponible de round robin", TAo = "Asignar miembro del equipo", AAo = "Anular qué miembro del equipo desea asignar.", IAo = "No hay anfitriones disponibles", OAo = "Reasignar anfitrión de round robin", NAo = "No escribir en el feed ICS", zAo = "No es posible reprogramar ya que el evento ha expirado", RAo = "Este evento ha expirado", PAo = "Omitir la creación de contactos si no existen en {{appName}}", DAo = "Si su enlace ICS es de solo lectura (por ejemplo, Proton Calendar), marque la casilla de arriba para evitar errores. También deberá actualizar manualmente su calendario para los cambios.", LAo = "Atributos", MAo = "Nuevo atributo", FAo = "Agregar atributos", qAo = "Añadir atributos a los miembros de tu equipo", jAo = "Nueva opción", VAo = "Actualizar miembro", BAo = "Atributo", UAo = "Crear un atributo para los miembros de tu equipo", GAo = "Editar un atributo para los miembros de tu equipo", WAo = "Atributo actualizado con éxito", HAo = "Atributo eliminado con éxito", YAo = "Atributos editados con éxito", KAo = "Gestionar atributos para los miembros de tu equipo", ZAo = "Editar atributos para los miembros de tu equipo", XAo = "Volver a atributos", JAo = "¿Estás seguro de que quieres eliminar esta opción?", QAo = "Esta opción está asignada a {{numberOfUsers}} miembros. Eliminarla la quitará de sus perfiles.", e2o = "Desactivar correos electrónicos estándar a los asistentes relacionados con este tipo de evento", t2o = "Desactiva la comunicación por correo electrónico estándar relacionada con este tipo de evento, incluidas las confirmaciones de reserva, recordatorios y cancelaciones.", n2o = "Desactivar correos electrónicos estándar a los anfitriones relacionados con este tipo de evento", o2o = "Escribe confirmar para continuar", r2o = "Desactivar correo electrónico", i2o = "Conceder acceso a la API de administrador", a2o = "Revocar acceso a la API de administrador", s2o = "Agregar calendario de {{calendar}}", c2o = "Conectar Calendario de Apple", l2o = "Calendario de Apple conectado", u2o = "Comprobando Calendario de Apple", d2o = "Conectar Calendario de Google", _2o = "Calendario de Google conectado", p2o = "Comprobando Calendario de Google", m2o = "Conectar Calendario de Outlook", f2o = "Calendario de Outlook conectado", g2o = "Comprobando el calendario de Outlook", h2o = "Conectar con Stripe", v2o = "Stripe conectado", b2o = "Verificando credenciales de Stripe", y2o = "Variables de respuesta a preguntas de reserva", $2o = "Gestionado por {{teamAdmins}}", w2o = "{{count}} opciones", k2o = "Reprogramar con el mismo anfitrión de Round-Robin", S2o = "Los eventos reprogramados se asignarán al mismo anfitrión que inicialmente", E2o = "Desactivar entrada si el identificador de URL está prellenado", x2o = "Límites de Reservas", C2o = "Límites de reservas para los miembros del equipo en todos los tipos de eventos del equipo", T2o = "Limitar cuántas veces se pueden reservar los miembros en todos los tipos de eventos del equipo", A2o = "Límites de reservas actualizados con éxito", I2o = "No tienes autorización para realizar este cambio en la reserva", O2o = "Credencial de delegación deshabilitada", N2o = "Miembros coincidentes", z2o = "{{x}} miembros coincidentes", R2o = "Cola de miembros coincidentes (usando pesos de atributos)", P2o = "Cola de miembros coincidentes (usando pesos de asignados al evento)", D2o = "No hay miembros coincidentes. Se utilizarán los miembros del equipo asignados al tipo de evento como alternativa.", L2o = "No hay miembros coincidentes. Se utilizarán los miembros del equipo asignados al tipo de evento como alternativa. Considera añadir una opción de respaldo o corregir la lógica de using_fallback_members", M2o = "Ocultar detalles de eventos del calendario en calendarios compartidos", F2o = "Cuando se comparte un calendario, los eventos son visibles para los lectores, pero sus detalles están ocultos para aquellos sin acceso de escritura.", q2o = "Últimos {{count}} días", j2o = "Mes hasta la fecha", V2o = "Año hasta la fecha", B2o = "Rango personalizado", U2o = "Política de reembolso", G2o = "Siempre", W2o = "Nunca", H2o = "Opción de pago", Y2o = "Si se cancela", K2o = "antes", Z2o = "Mostrar todas las columnas", X2o = "Alternar columnas", J2o = "No se encontraron columnas", Q2o = "Al reservar, agregar eventos y nuevos asistentes como:", eIo = "Cliente potencial", tIo = "Contacto bajo una cuenta", nIo = "Omitir la creación del registro de {{entry}} si no existe en Salesforce", oIo = "Si el contacto no existe bajo una cuenta, crear un nuevo cliente potencial a partir del asistente", rIo = "Crear un nuevo contacto bajo una cuenta basado en el dominio de correo electrónico del asistente y los contactos existentes", iIo = "Cambiar propietario del registro en la reserva", aIo = "Asignar atributos en masa", sIo = "Resulta en mostrar un mensaje personalizado. Intenta cambiar la respuesta para redirigir a un evento", cIo = "Resulta en redirigir a {{externalUrl}}. Intenta cambiar la respuesta para redirigir a un evento", lIo = "Posible anfitrión", uIo = "Estado actual de enrutamiento", dIo = "Redirigir reserva", _Io = "Redirige la reserva a diferentes miembros del equipo", pIo = "Verificar nueva ruta", mIo = "Redirigir", fIo = "Nuevo estado de enrutamiento", gIo = "Si el asistente existe en Salesforce, reservar directamente con el propietario", hIo = "Entidad de la que verificar el propietario para reservar directamente", vIo = "Cuenta", bIo = "Elegir horarios de los anfitriones", yIo = "Puedes seleccionar un horario diferente para cada anfitrión. Por defecto, se elige el horario predeterminado de cada anfitrión.", $Io = "No hay anfitriones asignados, añade anfitriones en la pestaña de asignación.", wIo = "Reasignar manualmente el anfitrión de round robin", kIo = "Reasignar manualmente el anfitrión de round robin a otro anfitrión disponible", SIo = "Reasignar el anfitrión de round robin a otro anfitrión disponible", EIo = "El nuevo usuario no es un anfitrión válido de round robin para este tipo de evento", xIo = "El nuevo usuario es un anfitrión fijo para este tipo de evento", CIo = "Reprogramar con el mismo horario", TIo = "Reprogramar con el mismo horario del nuevo evento", AIo = "Reprogramar al nuevo evento con un horario diferente", IIo = "Reprogramar con un horario diferente", OIo = "No tenemos ID para el nuevo evento. Por favor, ve al Formulario de Enrutamiento y guárdalo de nuevo.", NIo = "Reserva redirigida con éxito. Redirigiendo a la página de reserva", zIo = "Al reservar, escribir en el objeto del evento", RIo = "Nombre del campo", PIo = "Añadir nuevo campo", DIo = "No tienes acceso para redirigir esta reserva", LIo = "Respuesta del formulario no encontrada", MIo = "Propietario del contacto", FIo = "No encontrado", qIo = "Usando miembros de respaldo", jIo = "Ruta elegida", VIo = "Lógica de atributos coincidente", BIo = "Lógica de atributos de respaldo coincidente", UIo = "Todos los miembros asignados al tipo de evento del equipo. Considera añadir algunas reglas de atributos.", GIo = "Todos los miembros asignados al tipo de evento del equipo. Considera añadir algunas reglas de atributos como respaldo.", WIo = "Todos los miembros asignados al tipo de evento del equipo. Considera ajustar el respaldo para obtener una coincidencia.", HIo = "Advertencia", YIo = "Respaldo: Si ningún miembro del equipo coincide, usa aquellos que cumplan los siguientes criterios (por defecto, coincide con todos los miembros del equipo asignados al evento)", KIo = "Advertencia de lógica de atributos de respaldo", ZIo = "No es necesario", XIo = "Anfitrión no disponible", JIo = "Anfitrión disponible", QIo = "¿Estás seguro de que quieres reasignar esta reserva a un anfitrión no disponible?", eOo = "¿Estás seguro de que quieres reasignar esta reserva?", tOo = "Sí, reasignar", nOo = "Filtrar por atributos", oOo = "Motivo de la reasignación", rOo = "Cambiar el tipo de campo puede causar pérdida de datos. Por favor, crea un nuevo campo en su lugar.", iOo = "Reasignado por", aOo = "fila", sOo = "filas", cOo = "Zona horaria del asistente", lOo = "Hora de inicio del evento en la zona horaria del asistente", uOo = "Hora de inicio del evento en la zona horaria del asistente", dOo = "Hora de finalización del evento en la zona horaria del asistente", _Oo = "Hora de finalización del evento en la zona horaria del asistente", pOo = "Crear evento en el contacto, si existe. De lo contrario, usar el lead", mOo = "Nombre del propietario a cambiar", fOo = "Ningún filtro establecido", gOo = "Prueba de reserva exitosa", hOo = "La prueba de simulación se completó con éxito.", vOo = "No tienes acceso a esta página", bOo = "Para ver o interactuar con esta página, debes tener privilegios de administrador o propietario", yOo = "Tipo de campo", $Oo = "Cuándo escribir", wOo = "Al reservar, escribir en un campo personalizado en el registro {{record}} del asistente", kOo = "En cada reserva", SOo = "Solo si el campo está vacío", EOo = "Fecha de inicio de la reserva", xOo = "Fecha de creación de la reserva", COo = "Reserva reasignada a {{host}}", TOo = "Sin propietario del contacto", AOo = "Formularios de enrutamiento creados", IOo = "Total de respuestas", OOo = "Total de respuestas sin reserva", NOo = "Total de respuestas con reserva", zOo = "Sin reservas", ROo = "Nombre del formulario", POo = "Reserva", DOo = "Sin reserva", LOo = "Reservado por", MOo = "Creado el", FOo = "Estado de la reserva", qOo = "Fecha de reserva", jOo = "Fecha de envío", VOo = "Copiar URL de redirección", BOo = "URL de redirección al salir", UOo = "Total de reservas por período", GOo = "Enrutado a por período", WOo = "Por día", HOo = "Por semana", YOo = "Por mes", KOo = "Motivo de asignación", ZOo = "Acceso denegado", XOo = "El propietario del contacto será el anfitrión de Round Robin si está disponible", JOo = "Añadir nuevos asistentes como", QOo = "No se forzará al propietario del contacto (aún puede ser anfitrión si coincide con los atributos y criterios de Round Robin)", eNo = "Dirigir a un usuario que coincida con un campo de búsqueda en una cuenta", tNo = "Opción de Salesforce", nNo = "Nombre del campo de búsqueda", oNo = "Si el asistente tiene un dominio de correo gratuito, omitir la verificación de propiedad y distribuir round robin de forma normal", rNo = "Es", iNo = "No es", aNo = "Contiene", sNo = "No contiene", cNo = "Empieza con", lNo = "Termina con", uNo = "Está vacío", dNo = "No está vacío", _No = "Auto traducir título y descripción", pNo = "Traduce automáticamente títulos y descripciones al idioma del navegador del visitante usando IA.", mNo = "Distribución", fNo = "Permite optimizar la distribución para maximizar la disponibilidad o lograr una asignación más equilibrada.", gNo = "Maximizar disponibilidad", hNo = "Permite a los usuarios reservar reuniones cuando un anfitrión esté disponible. Utiliza esta opción para maximizar el número de reuniones potenciales y cuando la distribución equitativa entre anfitriones sea menos importante.", vNo = "Equilibrio de carga", bNo = "Monitorizaremos cuántas reservas se han realizado con cada anfitrión y las compararemos con otros, deshabilitando algunos anfitriones que estén muy por delante para que las reservas se distribuyan uniformemente.", yNo = "Editar pesos", $No = "Pesos actualizados correctamente", wNo = "Solo requerir confirmación para proveedores de correo gratuito (Ej. @gmail.com, @outlook.com)", kNo = "Excluir correos que contengan...", SNo = "Requerir correos que contengan...", ENo = "Por favor, introduce una dirección de correo electrónico laboral válida", xNo = "No tienes permiso para agendar con este dominio de correo electrónico. Por favor, contacta al propietario de este enlace.", CNo = "Buscar columnas", TNo = "Opciones de búsqueda", ANo = "Desactivar perfil público de la organización y redireccionar", INo = "Redirecciona {{orgSlug}}.cal.com a {{destination}}", ONo = "Selección única", NNo = "Selección múltiple", zNo = "Configuración de conflictos de calendario", RNo = "Selecciona qué calendarios comprobar para detectar conflictos", PNo = "Reunión grupal", DNo = "¿Está seguro de que desea eliminar esta aplicación de", LNo = "Desconectar aplicación de", MNo = "No crear nuevos registros para invitados añadidos a la reserva", FNo = "Google Meet", qNo = "Zoom", jNo = "Video de MS Teams", VNo = "Bloquear para asignación", BNo = "El bloqueo solo permitirá asignaciones desde la sincronización del directorio", UNo = "Atributo editado correctamente", GNo = "Nueva opción de grupo", WNo = "Pesos habilitados", HNo = "Al habilitar los pesos, sería posible asignar mayor prioridad a ciertos atributos por usuario. Cuanto mayor sea el peso, mayor será la prioridad.", YNo = "Enrutado", KNo = "Reasignado", ZNo = "Permitir reprogramar eventos pasados", XNo = "Al habilitar esta opción se permite reprogramar eventos pasados", JNo = "Reenrutado", QNo = "Asignación de Salesforce", ezo = "Posición del enrutador", tzo = "Mostrar hosts coincidentes", nzo = "No hay colas activas para esta entrada", ozo = "Peso", rzo = "Calibración", izo = "Déficit", azo = "Formulario de enrutamiento", szo = "Volver y guardar", czo = "Guardar cambios", lzo = "Salir sin guardar", uzo = "¿Estás seguro de que quieres salir sin guardar los cambios en tu formulario de enrutamiento?", dzo = "Algo inesperado ha ocurrido", _zo = "Estás haciendo una reserva de prueba.", pzo = "Muestra de iconos", mzo = "Muestra de iconos", fzo = "Migrando desde el equipo", gzo = "La función está actualmente desactivada", hzo = "Elige una opción", vzo = "Ingresa el valor de la opción", bzo = "Eliminar opción", yzo = "Usar pesos de atributos", $zo = "Si está activado, se ignorarán todos los pesos establecidos dentro del tipo de evento", wzo = "Atributo para pesos", kzo = "Usuarios gestionados", Szo = "Ver todos los usuarios gestionados creados por tu cliente OAuth", Ezo = "¿Puedes contarme sobre ", xzo = "Usa la IA para responder tus preguntas", Czo = "Error al obtener la respuesta ", Tzo = "Ocurrió un error inesperado. Por favor, inténtalo de nuevo más tarde", Azo = "Seleccionar cliente OAuth", Izo = "En cada instancia", Ozo = "La función de credencial de delegación no está habilitada para tu organización", Nzo = "Nota interna", zzo = "Motivo compartido con el cliente (opcional)", Rzo = "Esta nota solo será visible para los miembros de tu equipo", Pzo = "Plantillas de notas internas de cancelación", Dzo = "Crea plantillas para notas internas que se pueden aplicar a las reservas", Lzo = "Las plantillas de notas internas se actualizaron correctamente", Mzo = "Agregar plantilla", Fzo = "Autorizar", qzo = "Siguiente", jzo = "Ocultar", Vzo = "Mostrar", Bzo = "Parámetros UTM", Uzo = "No hay parámetros UTM disponibles.", Gzo = "Asc", Wzo = "Desc", Hzo = "Verificar cambio de correo electrónico", Yzo = "Comprar créditos", Kzo = "Créditos", Zzo = "Créditos utilizados", Xzo = "Total restante", Jzo = "Recibes 1000 créditos por mes, por miembro del equipo", Qzo = "Recibes 750 créditos por mes, por miembro del equipo", eRo = "Ver y gestionar créditos para enviar mensajes SMS", tRo = "Ver y gestionar créditos para enviar mensajes SMS. Un crédito equivale a 1¢ (USD). <0>Más información</0>", nRo = "Un crédito vale 1¢ (USD). <0>Más información</0>", oRo = "Comprar créditos adicionales ($0.01 por crédito)", rRo = "Puedes ver el gasto de créditos adicionales en tu registro de gastos", iRo = "Resumen", aRo = "El slug de la organización ya está en uso", sRo = "No puedes crear una organización ya que ya formas parte de una", cRo = "Necesitas completar la incorporación de usuario antes de crear una organización", lRo = "Usa el correo electrónico de la empresa para crear una organización", uRo = "No puedes crear una organización de plataforma ya que ya formas parte de un equipo", dRo = "Necesitas tener un mínimo de equipos publicados", _Ro = "Ya formas parte de esta organización", pRo = "Formas parte de otra organización, no puedes crear una nueva", mRo = "Formas parte de otra organización de plataforma, no puedes crear una nueva organización", fRo = "Pago de la organización exitoso", gRo = "Tu organización se ha creado con éxito", hRo = "Esto puede tardar unos segundos...", vRo = "Estado de incorporación de la organización", bRo = "Descripción del estado de incorporación de la organización", yRo = "El pago ha fallado", $Ro = "Tu pago ha fallado. Por favor, inténtalo de nuevo.", wRo = "Creando tu organización", kRo = "La incorporación de la organización ya se ha completado", SRo = "La incorporación de la organización ya existe", ERo = "No se encontró la incorporación de la organización", xRo = "¡Pago exitoso!", CRo = "Traspaso de incorporación", TRo = "Traspaso de incorporación al usuario", ARo = "Ya existe una organización con este slug", IRo = "No tienes permiso para crear una organización con este correo electrónico", ORo = "No tienes permiso para migrar uno o más de los equipos", NRo = "La organización ya tiene una suscripción", zRo = "Intervalo de reinicio para Round Robin ponderado", RRo = "Intervalo", PRo = "Determina con qué frecuencia se reinicia el conteo de reservas de rotación para asegurar una distribución equilibrada.", DRo = "Diario", LRo = "No has establecido una fecha de finalización para tu ausencia", MRo = "Mi ausencia", FRo = "Ausencia del equipo", qRo = "Gestiona las ausencias de tu equipo.", jRo = "Crear ausencia", VRo = "Crear una ausencia para un miembro del equipo", BRo = "Editar una ausencia para un miembro del equipo", URo = "Crear ausencia para tu equipo", GRo = "Comunica a los reservadores cuándo los miembros de tu equipo no están disponibles para aceptar reservas. Aún pueden ser reservados a su regreso o puedes redirigirlos a otro miembro del equipo.", WRo = "El reenvío de ausencias solo está permitido a un miembro del mismo equipo.", HRo = "Ya existe un reenvío inverso entre estos usuarios.", YRo = "No se encontraron ausencias anteriores", KRo = "Anterior", ZRo = "Intervalo de Round Robin actualizado con éxito", XRo = "Modo de prueba", JRo = "Plan de equipo inactivo", QRo = "Tu plan de equipo está inactivo. Revisa tu suscripción o contacta con el soporte al cliente", ePo = "Acceso limitado durante la prueba. Función disponible después de que termine la prueba.", tPo = "Programa de referidos", nPo = "Gana 20% de referencia", oPo = "Necesitas una clave API de Dub y un ID de programa para usar esta página.", rPo = "UID", iPo = "Enlace", aPo = "filas por página", sPo = "{{currentRange}} de {{totalItems}}", cPo = "Consejo: Puedes añadir un '+' entre nombres de usuario: cal.com/anna+brian para crear una reunión grupal dinámica", lPo = "Aún no tienes un equipo", uPo = "Aún no tienes miembros en tu equipo", dPo = "Los eventos recurrentes no admiten la función de asientos. Hazlo no recurrente para habilitar asientos.", _Po = "El evento recurrente no es compatible con la función de límite de reservas por persona. Desactiva el límite de reservas por persona para habilitar el evento recurrente.", pPo = "La función de asientos no admite eventos recurrentes. Desactiva la función de asientos para hacerlo recurrente.", mPo = "Los eventos recurrentes no admiten la función de asientos. Desactiva la función de asientos o haz que el evento no sea recurrente.", fPo = "Segmento", gPo = "Filtros guardados", hPo = "Renombrar", vPo = "Renombrar segmento", bPo = "Eliminar segmento", yPo = "Duplicar segmento", $Po = "¿Estás seguro de que quieres eliminar este segmento? Esta acción no se puede deshacer.", wPo = "Segmento de filtro actualizado", kPo = "Error al actualizar el segmento de filtro", SPo = "Segmento de filtro duplicado", EPo = "Error al duplicar el segmento de filtro", xPo = "Segmento de filtro eliminado", CPo = "Error al eliminar el segmento de filtro", TPo = "Guardar segmento", APo = "Segmento no encontrado", IPo = "Segmento de filtro guardado", OPo = "Sin segmentos", NPo = "Error al guardar el segmento de filtro", zPo = 'Guardar cambios en "{{name}}"', RPo = "Crear nuevo segmento", PPo = "Guardar para el equipo", DPo = "Seleccionar equipo", LPo = "Por favor, selecciona un equipo", MPo = "Personal", FPo = "Ocultar enlace del perfil del equipo", qPo = "Ocultar el enlace del perfil del equipo en las páginas de reserva", jPo = "Mostrar", VPo = "No se pudo encontrar el slug para publicar la organización", BPo = "Lista de selección", UPo = "Más cancelaciones", GPo = "Idioma de la interfaz", WPo = "Establece tu idioma preferido para la interfaz de reservas", HPo = "Idioma del navegador del visitante", YPo = "Nombre o correo electrónico", KPo = "Si no se encuentra ningún contacto, recurrir al propietario del lead si existe", ZPo = "La compra de créditos falló. Por favor, inténtalo de nuevo o contacta con soporte.", XPo = "Se requiere un mínimo de 50 créditos", JPo = "Habilitar credencial de delegación", QPo = "Concede a Cal.com acceso automático a los calendarios de todos los miembros de la organización habilitando la credencial de delegación.", eDo = "Deshabilitar credencial de delegación", tDo = "Una vez que se desactiva la credencial de delegación, los miembros de la organización que no hayan conectado sus calendarios deberán hacerlo manualmente.", nDo = "Última actividad", oDo = "Miembro desde", rDo = "Última actualización", iDo = "Al cancelar la reserva, escribir en el registro del evento en lugar de eliminarlo", aDo = "En cada cancelación", sDo = "Informar de un problema", cDo = "Puedes enviar un ticket en GitHub o actualizar tu plan para recibir soporte en tiempo real con conferencias de desarrolladores", lDo = "Abrir incidencia", uDo = "Este es tu plan actual", dDo = "Programar una hora", _Do = "Esto incluye:", pDo = "Cliente OAuth actualizado correctamente", mDo = "Cliente OAuth no encontrado.", fDo = "Suscribirse a la plataforma", gDo = "Error al intentar acceder a los webhooks.", hDo = "Error al actualizar el webhook.", vDo = "Error al crear el webhook.", bDo = "Enlace no válido", yDo = "Actualmente estás suscrito al plan {{planFirstLetter}}{{planRest}}", $Do = "Usuario/Equipo", wDo = "¡ID de cliente copiado!", kDo = "¡Secreto de cliente copiado!", SDo = "El equipo de Cal.com está realizando mantenimiento programado. Si tienes alguna pregunta, contacta con soporte.", EDo = "Tu pago ha fallado", xDo = "Revisa tu bandeja de entrada", CDo = "Tu cuenta ha sido creada, pero tu premium no ha sido reservado.", TDo = "Hemos enviado un correo electrónico a {{email}} con un enlace para activar tu cuenta.", ADo = "Una vez que actives tu cuenta, podrás intentar comprar tu nombre de usuario premium nuevamente o seleccionar uno diferente.", IDo = "Abrir en Gmail", ODo = "¿No ves un correo electrónico?", NDo = "Reenviar en {{seconds}} segundos", zDo = "Reenviar", RDo = "Correo de verificación enviado", PDo = "Seleccionar todos los miembros", DDo = "Al seleccionar todos los miembros se añadirán todos los futuros miembros del equipo cuando se agreguen al equipo.", LDo = "Configuración del formulario", MDo = "Eliminar estado de lista blanca", FDo = "Incluir flujos de trabajo de usuario en lista blanca", qDo = "Flujos de trabajo de usuario incluidos en lista blanca", jDo = "Flujos de trabajo de usuario eliminados de lista blanca", VDo = "Fecha y hora", BDo = "Este es un recordatorio sobre su próximo evento.", UDo = "Este recordatorio fue activado por un flujo de trabajo en Cal.", GDo = "Evento", WDo = "Programado por", HDo = "¿Cómo fue tu experiencia reciente?", YDo = "Siempre buscamos mejorar la experiencia de nuestros clientes.", KDo = "¿Qué tan satisfecho estuvo con su última reunión?", ZDo = "¿no asististe a la reunión?", XDo = "Reprogramar aquí.", JDo = "Ocultar correo electrónico del organizador", QDo = "Ya formas parte de una organización de plataforma, por lo que no puedes crear una nueva organización. Cada usuario solo puede pertenecer a una organización. Por favor, crea una nueva cuenta de cal.com con un correo electrónico diferente y usa esa cuenta para suscribirte al plan de organizaciones.", e3o = "Ya formas parte de una organización, por lo que no puedes crear una organización de plataforma. Cada usuario solo puede pertenecer a una organización. Por favor, crea una nueva cuenta de cal.com con un correo electrónico diferente y usa esa cuenta para suscribirte al plan de plataforma.", t3o = "Ocultar la dirección de correo electrónico del organizador en la pantalla de reserva, notificaciones por correo electrónico y eventos del calendario", n3o = "Tú &", o3o = "Seleccionar un correo electrónico verificado", r3o = "Añadir correo electrónico verificado", i3o = "Añadir correos electrónicos verificados", a3o = "Correo electrónico personalizado para 'Responder a'", s3o = "Usar una dirección de correo electrónico diferente como destinatario de respuesta para los correos de confirmación en lugar del correo del organizador", c3o = "Esta encuesta fue activada por un Workflow en Cal.", l3o = "Omitir período de prueba", u3o = "Períodos de prueba del equipo omitidos con éxito", d3o = "Al ingresar tu número de teléfono, consientes recibir mensajes SMS para este evento. Pueden aplicarse tarifas de SMS.", _3o = "Más información disponible en <0>Estadísticas de enrutamiento</0>", p3o = "Resultados", m3o = "Ver formulario", f3o = "Envía STOP para cancelar los mensajes SMS", g3o = "Tu equipo {{teamName}} se está quedando sin créditos", h3o = "Te estás quedando sin créditos", v3o = "[Acción requerida] Tu equipo {{teamName}} se ha quedado sin créditos", b3o = "[Acción requerida] Te has quedado sin créditos", y3o = "Tu equipo de Cal.com {{teamName}} se está quedando sin créditos. Para evitar cualquier interrupción en el servicio, por favor compra créditos adicionales. Si tu saldo se agota, los mensajes SMS dejarán de enviarse y se enviarán como correos electrónicos en su lugar.", $3o = "Tu cuenta de Cal.com se está quedando sin créditos. Para evitar cualquier interrupción en el servicio, por favor compra créditos adicionales. Si tu saldo se agota, los mensajes SMS dejarán de enviarse y se enviarán como correos electrónicos en su lugar.", w3o = "Tu equipo de Cal.com {{teamName}} se ha quedado sin créditos. Como resultado, los mensajes SMS ahora se están enviando por correo electrónico. Para reanudar el envío de SMS, por favor compra créditos adicionales.", k3o = "Tu cuenta de Cal.com se ha quedado sin créditos. Como resultado, los mensajes SMS ahora se envían por correo electrónico. Para reanudar el envío de SMS, por favor compra créditos adicionales.", S3o = "Saldo actual: {{balance}} créditos", E3o = "Saldo actual:", x3o = "Notificación sobre tu reserva", C3o = "Créditos mensuales", T3o = "Créditos totales: {{totalCredits}}", A3o = "Créditos restantes: {{remainingCredits}}", I3o = "Restante", O3o = "Total", N3o = "Créditos adicionales", z3o = "{{count}} siguiente(s) en cola", R3o = "Enviar respuestas por correo electrónico a", P3o = "Reservas incompletas", D3o = "Incluir reservas no presentadas en los cálculos de round robin", L3o = "Invitados recientes que no asistieron", M3o = "Muestra las reservas donde todos los asistentes no se presentaron, no ausencias parciales", F3o = "Coincidencia", q3o = "Redirección de evento", j3o = "Restablecer formulario", V3o = "Configuración de Round Robin actualizada con éxito", B3o = "Base de distribución para Round Robin ponderado", U3o = "Determina qué marca de tiempo del evento se utiliza como base para la distribución ponderada de round robin.", G3o = "Requiere créditos", W3o = "Necesitas tener suficientes créditos en tu cuenta para usar esta función", H3o = "Créditos disponibles", Y3o = "Crear rol", K3o = "Roles y permisos", Z3o = "Gestiona roles y permisos para tu organización", X3o = "Aprende más sobre cómo funcionan los permisos", J3o = "Nombre del rol", Q3o = "El nombre del rol es obligatorio", eLo = "p. ej. Equipo de ventas, Personal de soporte", tLo = "Descripción del rol", nLo = "Describe para qué sirve este rol y qué permisos necesita", oLo = "Rol predeterminado", rLo = "Rol personalizado", iLo = "Avanzado", aLo = "Buscar permisos", sLo = "Todos los permisos", cLo = "Ninguno", lLo = "Solo lectura", uLo = "Todas las acciones en todos los recursos", dLo = "Todos los recursos", _Lo = "Tipos de evento", pLo = "Equipos", mLo = "Organización", fLo = "Reservas", gLo = "Perspectivas", hLo = "Roles", vLo = "Formularios de enrutamiento", bLo = "Flujos de trabajo", yLo = "Todas las acciones", $Lo = "Crear", wLo = "Ver", kLo = "Editar", SLo = "Eliminar", ELo = "Gestionar", xLo = "Invitar", CLo = "Eliminar", TLo = "Cambiar rol de miembro", ALo = "Listar miembros", ILo = "Gestionar facturación", OLo = "Ver reservas del equipo", NLo = "Ver reservas de la organización", zLo = "Ver grabaciones", RLo = "Suplantar", PLo = "Rol creado con éxito", DLo = "Rol actualizado con éxito", LLo = "Eliminar rol", MLo = "¿Estás seguro de que quieres eliminar el rol: {{roleName}}? Esta acción no se puede deshacer.", FLo = "Rol eliminado con éxito", qLo = "Error al crear el rol", jLo = "Error al actualizar el rol", VLo = "Crear roles", BLo = "Atributos", ULo = "Ver atributos de la organización", GLo = "Actualizar atributos de la organización", WLo = "Eliminar atributos de la organización", HLo = "Crear atributos de la organización", YLo = "Ver roles", KLo = "Actualizar roles", ZLo = "Eliminar roles", XLo = "Crear y configurar nuevos flujos de trabajo", JLo = "Configuración requerida", QLo = "Ver flujos de trabajo existentes y sus configuraciones", eMo = "Editar y modificar ajustes de flujos de trabajo", tMo = "Eliminar flujos de trabajo del sistema", nMo = "Webhook", oMo = "Disponibilidad", rMo = "Fuera de la oficina", iMo = "Crear webhooks", aMo = "Ver webhooks", sMo = "Actualizar webhooks", cMo = "Eliminar webhooks", lMo = "Crear disponibilidad", uMo = "Ver disponibilidad", dMo = "Actualizar disponibilidad", _Mo = "Eliminar disponibilidad", pMo = "Crear fuera de la oficina", mMo = "Ver fuera de la oficina", fMo = "Actualizar fuera de la oficina", gMo = "Eliminar fuera de la oficina", hMo = "Acceso completo de gestión a todos los flujos de trabajo", vMo = "Crear tipos de eventos", bMo = "Ver tipos de eventos", yMo = "Actualizar tipos de eventos", $Mo = "Eliminar tipos de eventos", wMo = "Todas las acciones en tipos de eventos", kMo = "Crear equipos", SMo = "Ver detalles del equipo", EMo = "Actualizar configuración del equipo", xMo = "Eliminar equipo", CMo = "Invitar miembros al equipo", TMo = "Eliminar miembros del equipo", AMo = "Cambiar rol de los miembros del equipo", IMo = "Suplantar miembros del equipo", OMo = "Todas las acciones en equipos a través de los equipos de la organización", NMo = "Crear organización", zMo = "Ver detalles de la organización", RMo = "Listar miembros de la organización", PMo = "Invitar miembros a la organización", DMo = "Eliminar miembros de la organización", LMo = "Gestionar facturación de la organización", MMo = "Cambiar rol de los miembros de la organización", FMo = "Suplantar miembros de la organización", qMo = "Editar configuración de la organización", jMo = "Todas las acciones en organizaciones", VMo = "Ver reservas", BMo = "Ver reservas del equipo", UMo = "Ver reservas de la organización", GMo = "Ver grabaciones de reservas", WMo = "Actualizar reservas", HMo = "Todas las acciones en reservas", YMo = "Ver estadísticas del equipo", KMo = "Gestionar estadísticas del equipo", ZMo = "Crear formularios de enrutamiento", XMo = "Ver formularios de enrutamiento", JMo = "Actualizar formularios de enrutamiento", QMo = "Eliminar formularios de enrutamiento", e4o = "El permiso de lectura se habilita automáticamente al crear, actualizar o eliminar un recurso", t4o = "Añadir horario de restricción", n4o = "Limita la disponibilidad de los anfitriones para mostrar solo los espacios que se encuentran dentro de un horario específico.", o4o = "Usar zona horaria del reservante", r4o = "Aplicar el horario de restricción seleccionado en la zona horaria del reservante", i4o = "Esto desactivará el Balanceo de Carga en todos tus tipos de eventos round robin", a4o = "El Balanceo de Carga solo está disponible cuando la base de tiempo está configurada como Momento de Creación de la Reserva", s4o = "El balanceo de carga no está disponible con Grupos de Round Robin", c4o = "Personalice la configuración predeterminada de round robin para este equipo", l4o = "Configuración de Round Robin actualizada correctamente", u4o = "Hora de creación de la reserva", d4o = "Hora de inicio de la reunión", _4o = "Miembros afectados", p4o = "Ningún miembro afectado por la desactivación de la credencial de delegación", m4o = "Descargar registro de gastos", f4o = "Error al descargar el registro de gastos", g4o = "Ofrecer reprogramar la última reserva activa al horario elegido", h4o = "Se ha excedido el límite máximo de reservas activas del usuario", v4o = "Ya tienes una reserva para este evento el {{date}}. ¿Quieres reprogramarla para el nuevo horario seleccionado?", b4o = "La duración debe ser de al menos {{min}} minuto(s)", y4o = "La duración no puede exceder {{max}} minutos (24 horas)", $4o = "Reserva fuera de la disponibilidad del horario de restricción.", w4o = "Horario de restricción no encontrado", k4o = "Límite de tamaño de imagen excedido, utilice una imagen más pequeña preferiblemente en formato JPEG", S4o = "Añadir grupo", E4o = "Embudo de enrutamiento", x4o = "Total de envíos", C4o = "Enrutamientos exitosos", T4o = "Reservas aceptadas", A4o = "Clave de licencia", I4o = "Elija su licencia", O4o = "Seleccione cómo desea licenciar su implementación de Cal.com", N4o = "Utilice Cal.com bajo la licencia de código abierto AGPLv3", z4o = "Introducir clave de licencia", R4o = "Acceso a todas las funciones empresariales", P4o = "Desde $15/usuario al mes", D4o = "Acceso a todas las funciones empresariales", L4o = "Introduzca su clave de licencia", M4o = "Guardar clave de licencia", F4o = "Token de firma (opcional)", q4o = "El token de firma se utiliza para verificar que la clave de licencia es tuya al incrementar la facturación basada en el uso. Puedes encontrarlo en tu correo electrónico de confirmación de compra. Si tienes una licencia antigua, puedes dejar esto en blanco.", j4o = "¿Necesitas una licencia?", V4o = "La clave de licencia es obligatoria", B4o = "Clave de licencia no válida", U4o = "No se pudo validar la clave de licencia", G4o = "Archivos adjuntos opcionales", W4o = "Enviar mensaje", H4o = "Describe el problema", Y4o = "El tamaño del archivo excede el límite", K4o = "Tipo de archivo no válido", Z4o = "Tipo de archivo no válido. Tipos aceptados: {{acceptedTypes}}", X4o = "Número máximo de archivos excedido", J4o = "Archivos subidos correctamente", Q4o = "Tipos aceptados: {{acceptedTypes}}; Tamaño máximo de archivo: {{maxSize}}", e5o = "Clave de licencia guardada correctamente", t5o = "Estás viendo el informe basado en la zona horaria de tu perfil ({{userTimezone}}), mientras que tu navegador está configurado en la zona horaria ({{browserTimezone}})", n5o = "Franjas optimizadas", o5o = "Organiza las franjas horarias para optimizar la disponibilidad.", r5o = "Reservas fallidas por campo", i5o = "Reservas fallidas", a5o = "No hay anfitriones asignados al tipo de evento", s5o = "Estado de la caché", c5o = "Última actualización: {{timestamp}}", l5o = "Eliminar datos en caché", u5o = "Caché eliminada correctamente", d5o = "Error al eliminar la caché", _5o = "¿Estás seguro de que quieres eliminar los datos en caché? Esta acción no se puede deshacer.", p5o = "Sí, eliminar caché", m5o = "Quedan {{remainder}} de {{maximum}} usos", f5o = "Queda {{remainder}} de {{maximum}} uso", g5o = "Caduca el {{date}}, al final del día", h5o = "Un solo uso", v5o = "Caducidad basada en tiempo", b5o = "Caducidad basada en uso", y5o = "Número de usos", $5o = "Caduca el", w5o = "Número máximo de usos", k5o = "Configuración del enlace", S5o = "Este enlace caducó el {{date}}, al final del día", E5o = "Límite de uso alcanzado", x5o = "El número máximo de usos debe ser mayor que el uso actual", C5o = "Este enlace ha caducado", T5o = "Este enlace puede usarse para reservas hasta el final del {{date}}", A5o = "Este enlace puede configurarse para caducar después de una fecha determinada", I5o = "Este enlace puede usarse para {{count}} reserva", O5o = "Este enlace puede configurarse para caducar después de un número determinado de reservas", N5o = "Este enlace puede usarse para {{count}} reservas", z5o = "El nombre del evento desencadenante (p. ej., BOOKING_CREATED, BOOKING_CANCELLED)", R5o = "La hora del webhook", P5o = "El slug del tipo de evento", D5o = "Configurar agente", L5o = "El nombre del tipo de evento", M5o = "La hora de inicio del evento", F5o = "La hora de finalización del evento", q5o = "La descripción del evento según se describe en la configuración del tipo de evento", j5o = "Ubicación del evento", V5o = "El UID de la reserva", B5o = "El UID para reprogramar", U5o = "Motivo de cancelación", G5o = "Motivo del rechazo", W5o = "Nombre del organizador", H5o = "Correo electrónico del organizador", Y5o = "Zona horaria del organizador (p. ej., 'America/New_York', 'Asia/Kolkata')", K5o = "Configuración regional del organizador (p. ej., 'en', 'fr')", Z5o = "Nombre de usuario del organizador (p. ej., 'john.doe')", X5o = "Nombre de usuario del organizador en su organización (p. ej., 'john.doe')", J5o = "Nombre del primer asistente", Q5o = "Correo electrónico del primer asistente", e6o = "Zona horaria del primer asistente", t6o = "Configuración regional del primer asistente", n6o = "Nombre del equipo reservado", o6o = "Miembros del equipo reservado", r6o = "URL de videollamada para la reunión", i6o = "Ocultar variables", a6o = "Mostrar variables disponibles", s6o = "Evento y reserva", c6o = "Personas", l6o = "Equipos", u6o = "Metadatos", d6o = "Estadísticas", _6o = "Estado de la reserva", p6o = "Visitar", m6o = "Etiqueta personalizada en la página de reservas", f6o = "Enlace de la reunión", g6o = "Resultado de la sesión", h6o = "Llamada creada", v6o = "Buzón de voz", b6o = "Mis reservas", y6o = "Teléfono", $6o = "Gratis", w6o = "Correo electrónico del usuario", k6o = "Nombre de usuario", S6o = "Expandir panel", E6o = "Contraer panel", x6o = "Se requiere verificación de correo electrónico para este tipo de evento", C6o = "Código de verificación proporcionado no válido", T6o = "Tienes un equipo", A6o = "Considera configurar una organización para unificar la facturación, herramientas de administración y análisis en tu equipo.", I6o = "Considera configurar una organización para unificar la facturación, herramientas de administración y análisis en tus equipos.", O6o = "Mensaje enviado", N6o = "Gracias por contactarnos. Te responderemos lo antes posible.", z6o = "Buscar variables", R6o = "Por favor describe el problema que estás enfrentando, por ejemplo: 'Los horarios ocupados aparecen como disponibles', ..., etc.", P6o = "Enviar otro mensaje", D6o = "Enviando", L6o = "No se encontraron variables", M6o = "Créditos requeridos", F6o = "Las llamadas web consumen créditos. Asegúrate de tener suficientes créditos para iniciar una llamada.", q6o = "Las llamadas web requieren créditos. Te quedan 0 créditos.", j6o = "Comprar créditos", V6o = "Esta acción requiere créditos para continuar", B6o = "El nombre no debe exceder los {{max}} caracteres", U6o = "Cobrar automáticamente la tarifa por no presentarse en caso de cancelaciones de último minuto", G6o = "Antes de la hora de inicio programada", W6o = "Reconozco que al cancelar la reserva dentro de los {{timeValue}} {{timeUnit}} previos a la hora de inicio, se me cobrará la tarifa por no presentarme de {{amount, currency}}", H6o = "Si tienes alguna pregunta, por favor contacta al organizador.", Y6o = "Hora de reserva", K6o = "Cuando se programa la reserva (inicio a fin)", Z6o = "Creado el", X6o = "Cuando se creó originalmente la reserva", J6o = "Detalles de la llamada", Q6o = "ID de llamada", eFo = "Información de la llamada", tFo = "Sentimiento", nFo = "Motivo de desconexión", oFo = "Resumen de la llamada", rFo = "Transcripción", iFo = "Detalles del evento", aFo = "Agente", sFo = "No hay transcripción disponible", cFo = "Al probar este flujo de trabajo, ten en cuenta que los SMS deben programarse con al menos 15 minutos de antelación", lFo = "Comenzar desde cero", uFo = "Crea tu propio flujo de trabajo desde cero.", dFo = "Plantilla de Cal.ai", _Fo = "¡Agentes de IA que programan reuniones, envían recordatorios y hacen seguimiento!", pFo = "Voz", mFo = "Seleccionar voz", fFo = "Selecciona una voz para tu agente", gFo = "Elige una voz para tu agente", hFo = "Característica", vFo = "ID de voz", bFo = "Usar voz", yFo = "Voz actual", $Fo = "Configurar agente entrante", wFo = "Configura un agente de IA para gestionar las llamadas entrantes en tu número de teléfono", kFo = "Conecta primero un número de teléfono", SFo = "Configurar agente para llamadas entrantes", EFo = "Configurar agente para gestionar llamadas entrantes", xFo = "Llamadas entrantes", CFo = "Llamadas salientes", TFo = "Configuración de agente entrante exitosa", AFo = "Agente entrante configurado", IFo = "Configurar agente entrante", OFo = "Por favor, selecciona primero un tipo de evento", NFo = "Editar configuración", zFo = "Las llamadas entrantes solo pueden reservar un tipo de evento. Selecciona el tipo de evento donde se programarán las reuniones cuando los llamantes contacten con tu agente.", RFo = "Configurar agente entrante para llamadas entrantes", PFo = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Agregue sus nuevas cadenas arriba ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", DFo = {
  identity_provider: DLn,
  trial_days_left: LLn,
  day_one: MLn,
  day_other: FLn,
  second_one: qLn,
  second_other: jLn,
  upgrade_now: VLn,
  untitled: BLn,
  accept_invitation: ULn,
  max_characters: GLn,
  min_characters: WLn,
  calcom_explained: HLn,
  calcom_explained_new_user: YLn,
  have_any_questions: KLn,
  reset_password_subject: ZLn,
  verify_email_subject: XLn,
  verify_email_subject_verifying_email: JLn,
  check_your_email: QLn,
  old_email_address: eMn,
  new_email_address: tMn,
  verify_email_page_body: nMn,
  verify_email_banner_body: oMn,
  verify_email_email_header: rMn,
  verify_email_button: iMn,
  cal_ai_assistant: aMn,
  send_cal_video_transcription_emails: sMn,
  description_send_cal_video_transcription_emails: cMn,
  verify_email_change_description: lMn,
  verify_email_change_success_toast: uMn,
  verify_email_change_failure_toast: dMn,
  change_of_email: _Mn,
  change_of_email_toast: pMn,
  copy_somewhere_safe: mMn,
  verify_email_email_body: fMn,
  verify_email_by_code_email_body: gMn,
  verify_email_email_link_text: hMn,
  email_verification_code: vMn,
  email_verification_code_placeholder: bMn,
  incorrect_email_verification_code: yMn,
  email_sent: $Mn,
  email_not_sent: wMn,
  event_declined_subject: kMn,
  event_cancelled_subject: SMn,
  event_reassigned_subject: EMn,
  event_request_declined: xMn,
  customize_calvideo_settings: CMn,
  calvideo_settings_description: TMn,
  disable_recording_for_guests: AMn,
  enable_automatic_transcription: IMn,
  enable_automatic_recording: OMn,
  video_options: NMn,
  edit_event: zMn,
  view_session_details: RMn,
  meeting_session_details: PMn,
  meeting_session: DMn,
  session_id: LMn,
  max_participants: MMn,
  unlimited: FMn,
  ongoing: qMn,
  ended: jMn,
  participants: VMn,
  anonymous_user: BMn,
  session_duration: UMn,
  no_meeting_sessions_found: GMn,
  not_available: WMn,
  disable_recording_for_organizer: HMn,
  disable_transcription_for_guests: YMn,
  disable_transcription_for_organizer: KMn,
  event_request_declined_recurring: ZMn,
  event_request_cancelled: XMn,
  event_request_reassigned: JMn,
  event_reassigned_subtitle: QMn,
  organizer: e4n,
  reassigned_to: t4n,
  need_to_reschedule_or_cancel: n4n,
  you_can_view_booking_details_with_this_url: o4n,
  no_options_available: r4n,
  cancellation_reason: i4n,
  cancelled_by: a4n,
  cancellation_reason_host: s4n,
  cancellation_reason_placeholder: c4n,
  notify_attendee_cancellation_reason_warning: l4n,
  rejection_reason_placeholder: u4n,
  rejection_reason: d4n,
  rejection_reason_title: _4n,
  rejection_reason_description: p4n,
  rejection_confirmation: m4n,
  manage_this_event: f4n,
  invite_team_member: g4n,
  invite_team_individual_segment: h4n,
  invite_team_bulk_segment: v4n,
  invite_team_notifcation_badge: b4n,
  your_event_has_been_scheduled: y4n,
  your_event_has_been_scheduled_recurring: $4n,
  accept_our_license: w4n,
  remove_banner_instructions: k4n,
  error_message: S4n,
  refund_failed_subject: E4n,
  refund_failed: x4n,
  check_with_provider_and_user: C4n,
  a_refund_failed: T4n,
  awaiting_payment_subject: A4n,
  meeting_awaiting_payment: I4n,
  dark_theme_contrast_error: O4n,
  light_theme_contrast_error: N4n,
  event_type_color_light_theme_contrast_error: z4n,
  event_type_color_dark_theme_contrast_error: R4n,
  payment_not_created_error: P4n,
  couldnt_charge_card_error: D4n,
  no_available_users_found_error: L4n,
  timeslot_unavailable_book_a_new_time: M4n,
  timeslot_unavailable_short: F4n,
  just_connected_description: q4n,
  unavailable_timeslot_title: j4n,
  booking_time_out_of_bounds_error: V4n,
  request_body_end_time_internal_error: B4n,
  create_calendar_event_error: U4n,
  update_calendar_event_error: G4n,
  delete_calendar_event_error: W4n,
  already_signed_up_for_this_booking_error: H4n,
  hosts_unavailable_for_booking: Y4n,
  fixed_hosts_unavailable_for_booking: K4n,
  round_robin_host_unavailable_for_booking: Z4n,
  help: X4n,
  price: J4n,
  paid: Q4n,
  refunded: e5n,
  record: t5n,
  transcribe: n5n,
  payment: o5n,
  missing_card_fields: r5n,
  pay_now: i5n,
  general_prompt: a5n,
  transcription_powered_by_ai: s5n,
  start_or_stop_recording: c5n,
  begin_message: l5n,
  codebase_has_to_stay_opensource: u5n,
  cannot_repackage_codebase: d5n,
  acquire_license: _5n,
  terms_summary: p5n,
  open_env: m5n,
  env_changed: f5n,
  accept_license: g5n,
  still_waiting_for_approval: h5n,
  event_is_still_waiting: v5n,
  no_result_found_for: b5n,
  no_more_results: y5n,
  no_results: $5n,
  load_more_results: w5n,
  integration_meeting_id: k5n,
  confirmed_event_type_subject: S5n,
  new_event_request: E5n,
  confirm_or_reject_request: x5n,
  check_bookings_page_to_confirm_or_reject: C5n,
  check_in_assistant: T5n,
  check_in_assistant_description: A5n,
  create_your_own_prompt: I5n,
  event_awaiting_approval: O5n,
  event_awaiting_approval_recurring: N5n,
  someone_requested_an_event: z5n,
  someone_requested_password_reset: R5n,
  password_reset_email_sent: P5n,
  password_reset_instructions: D5n,
  event_awaiting_approval_subject: L5n,
  event_still_awaiting_approval: M5n,
  booking_submitted_subject: F5n,
  download_recording_subject: q5n,
  download_transcript_email_subject: j5n,
  download_your_recording: V5n,
  download_your_transcripts: B5n,
  your_meeting_has_been_booked: U5n,
  event_type_has_been_rescheduled_on_time_date: G5n,
  event_type_has_been_updated: W5n,
  event_has_been_rescheduled: H5n,
  event_has_been_updated: Y5n,
  your_event_has_been_rescheduled: K5n,
  request_reschedule_subtitle: Z5n,
  request_reschedule_title_organizer: X5n,
  request_reschedule_subtitle_organizer: J5n,
  rescheduled_event_type_subject: Q5n,
  requested_to_reschedule_subject_attendee: e6n,
  hi_user_name: t6n,
  ics_event_title: n6n,
  please_book_a_time_sometime_later: o6n,
  schedule_instead: r6n,
  new_event_subject: i6n,
  join_by_entrypoint: a6n,
  notes: s6n,
  manage_my_bookings: c6n,
  need_to_make_a_change: l6n,
  new_event_scheduled: u6n,
  new_event_scheduled_recurring: d6n,
  invitee_email: _6n,
  invitee_timezone: p6n,
  time_left: m6n,
  event_type: f6n,
  duplicate_event_type: g6n,
  enter_meeting: h6n,
  video_call_provider: v6n,
  meeting_id: b6n,
  meeting_password: y6n,
  meeting_url: $6n,
  meeting_url_not_found: w6n,
  token_not_found: k6n,
  some_other_host_already_accepted_the_meeting: S6n,
  meeting_request_rejected: E6n,
  rejected_event_type_with_organizer: x6n,
  hi: C6n,
  join_team: T6n,
  manage_this_team: A6n,
  team_info: I6n,
  join_meeting: O6n,
  request_another_invitation_email: N6n,
  you_have_been_invited: z6n,
  user_invited_you: R6n,
  hidden_team_member_title: P6n,
  hidden_team_member_message: D6n,
  hidden_team_owner_message: L6n,
  link_expires: M6n,
  upgrade_to_per_seat: F6n,
  seat_options_doesnt_support_confirmation: q6n,
  multilocation_doesnt_support_seats: j6n,
  no_show_fee_doesnt_support_seats: V6n,
  seats_option_doesnt_support_multi_location: B6n,
  team_upgrade_seats_details: U6n,
  team_upgrade_banner_description: G6n,
  upgrade_banner_action: W6n,
  team_upgraded_successfully: H6n,
  org_upgrade_banner_description: Y6n,
  org_upgraded_successfully: K6n,
  use_link_to_reset_password: Z6n,
  hey_there: X6n,
  there: J6n,
  forgot_your_password_calcom: Q6n,
  delete_webhook_confirmation_message: eFn,
  confirm_delete_webhook: tFn,
  edit_webhook: nFn,
  delete_webhook: oFn,
  webhook_status: rFn,
  webhook_enabled: iFn,
  webhook_disabled: aFn,
  webhook_response: sFn,
  webhook_test: cFn,
  webhook_update_form: lFn,
  webhook_update_form_description: uFn,
  manage_your_webhook: dFn,
  webhook_created_successfully: _Fn,
  webhook_updated_successfully: pFn,
  webhook_removed_successfully: mFn,
  subscription_needed: fFn,
  subscription_needed_description: gFn,
  payload_template: hFn,
  dismiss: vFn,
  no_data_yet: bFn,
  ping_test: yFn,
  add_to_homescreen: $Fn,
  upcoming: wFn,
  recurring: kFn,
  past: SFn,
  choose_a_file: EFn,
  upload_image: xFn,
  upload_target: CFn,
  no_target: TFn,
  slide_zoom_drag_instructions: AFn,
  view_notifications: IFn,
  view_public_page: OFn,
  copy_public_page_link: NFn,
  copy_referral_link: zFn,
  sign_out: RFn,
  add_another: PFn,
  install_another: DFn,
  until: LFn,
  powered_by: MFn,
  unavailable: FFn,
  set_work_schedule: qFn,
  change_bookings_availability: jFn,
  select: VFn,
  "2fa_confirm_current_password": "Confirma tu contraseña actual para empezar.",
  "2fa_scan_image_or_use_code": "Escanee la imagen a continuación con la aplicación de autenticación en su teléfono o ingrese manualmente el código de texto.",
  text: BFn,
  your_phone_number: UFn,
  multiline_text: GFn,
  number: WFn,
  checkbox: HFn,
  is_required: YFn,
  make_field_required: KFn,
  required: ZFn,
  optional: XFn,
  input_type: JFn,
  rejected: QFn,
  unconfirmed: eqn,
  guests: tqn,
  guest: nqn,
  web_conferencing_details_to_follow: oqn,
  confirmation: rqn,
  what_booker_should_provide: iqn,
  "404_the_user": "El Nombre de Usuario",
  username: aqn,
  is_still_available: sqn,
  documentation: cqn,
  documentation_description: lqn,
  api_reference: uqn,
  api_reference_description: dqn,
  blog: _qn,
  blog_description: pqn,
  join_our_community: mqn,
  "404_claim_entity_user": "Reclama tu nombre de usuario y programa eventos",
  popular_pages: fqn,
  register_now: gqn,
  register: hqn,
  page_doesnt_exist: vqn,
  no_active_phone_number_available: bqn,
  workflow_step_not_configured: yqn,
  check_spelling_mistakes_or_go_back: $qn,
  "404_page_not_found": "404: Esta página no se ha encontrado.",
  booker_event_not_found: wqn,
  getting_started: kqn,
  "15min_meeting": "Reunión de 15 min",
  "30min_meeting": "Reunión de 30 min",
  secret: Sqn,
  leave_blank_to_remove_secret: Eqn,
  webhook_secret_key_description: xqn,
  secret_meeting: Cqn,
  login_instead: Tqn,
  create_account: Aqn,
  get_started: Iqn,
  confirm_password: Oqn,
  reset_your_password: Nqn,
  org_banner_instructions: zqn,
  email_change: Rqn,
  create_your_account: Pqn,
  create_your_calcom_account: Dqn,
  sign_up: Lqn,
  youve_been_logged_out: Mqn,
  hope_to_see_you_soon: Fqn,
  logged_out: qqn,
  please_try_again_and_contact_us: jqn,
  incorrect_2fa_code: Vqn,
  no_account_exists: Bqn,
  "2fa_enabled_instructions": "Autenticación de doble factor activada. Introduzca el código de seis dígitos de su aplicación de autenticación.",
  "2fa_enter_six_digit_code": "Ingrese el código de seis dígitos de su aplicación de autenticación a continuación.",
  create_an_account: Uqn,
  dont_have_an_account: Gqn,
  "2fa_code": "Código de Dos Factores",
  sign_in_account: Wqn,
  sign_in: Hqn,
  go_back_login: Yqn,
  error_during_login: Kqn,
  request_password_reset: Zqn,
  send_invite: Xqn,
  forgot_password: Jqn,
  forgot: Qqn,
  done: ejn,
  all_done: tjn,
  all: njn,
  yours: ojn,
  available_apps: rjn,
  available_apps_lower_case: ijn,
  available_apps_desc: ajn,
  fixed_host_helper: sjn,
  round_robin_groups_helper: cjn,
  round_robin_helper: ljn,
  check_email_reset_password: ujn,
  finish: djn,
  organization_general_description: _jn,
  few_sentences_about_yourself: pjn,
  nearly_there: mjn,
  nearly_there_instructions: fjn,
  set_availability_instructions: gjn,
  set_availability: hjn,
  set_availbility_description: vjn,
  share_a_link_or_embed: bjn,
  share_a_link_or_embed_description: yjn,
  availability_settings: $jn,
  continue_without_calendar: wjn,
  continue_with: kjn,
  connect_your_calendar: Sjn,
  connect_your_video_app: Ejn,
  connect_your_video_app_instructions: xjn,
  connect_your_calendar_instructions: Cjn,
  set_up_later: Tjn,
  current_time: Ajn,
  details: Ijn,
  welcome: Ojn,
  welcome_back: Njn,
  welcome_to_calcom: zjn,
  welcome_instructions: Rjn,
  connect_caldav: Pjn,
  connect_ics_feed: Djn,
  connect: Ljn,
  try_for_free: Mjn,
  create_booking_link_with_calcom: Fjn,
  who: qjn,
  what: jjn,
  when: Vjn,
  where: Bjn,
  add_to_calendar: Ujn,
  add_to_calendar_description: Gjn,
  add_events_to: Wjn,
  add_another_calendar: Hjn,
  other: Yjn,
  email_sign_in_subject: Kjn,
  round_robin_emailed_you_and_attendees: Zjn,
  round_robin_emailed_host_and_attendee: Xjn,
  emailed_host_and_attendee: Jjn,
  emailed_host_and_attendee_recurring: Qjn,
  round_robin_emailed_you_and_attendees_recurring: eVn,
  round_robin_emailed_host_and_attendee_recurring: tVn,
  emailed_you_and_any_other_attendees: nVn,
  needs_to_be_confirmed_or_rejected: oVn,
  needs_to_be_confirmed_or_rejected_recurring: rVn,
  user_needs_to_confirm_or_reject_booking: iVn,
  user_needs_to_confirm_or_reject_booking_recurring: aVn,
  meeting_is_scheduled: sVn,
  meeting_is_scheduled_recurring: cVn,
  booking_submitted: lVn,
  booking_submitted_recurring: uVn,
  booking_confirmed: dVn,
  booking_confirmed_recurring: _Vn,
  warning_recurring_event_payment: pVn,
  warning_payment_recurring_event: mVn,
  enter_new_password: fVn,
  reset_password: gVn,
  change_your_password: hVn,
  show_password: vVn,
  hide_password: bVn,
  try_again: yVn,
  request_is_expired: $Vn,
  reset_instructions: wVn,
  request_is_expired_instructions: kVn,
  whoops: SVn,
  login: EVn,
  success: xVn,
  failed: CVn,
  password_has_been_reset_login: TVn,
  layout: AVn,
  bookerlayout_default_title: IVn,
  bookerlayout_description: OVn,
  bookerlayout_user_settings_title: NVn,
  bookerlayout_user_settings_description: zVn,
  bookerlayout_month_view: RVn,
  bookerlayout_week_view: PVn,
  bookerlayout_column_view: DVn,
  bookerlayout_error_min_one_enabled: LVn,
  bookerlayout_error_default_not_enabled: MVn,
  bookerlayout_error_unknown_layout: FVn,
  bookerlayout_override_global_settings: qVn,
  unexpected_error_try_again: jVn,
  sunday_time_error: VVn,
  monday_time_error: BVn,
  tuesday_time_error: UVn,
  wednesday_time_error: GVn,
  thursday_time_error: WVn,
  friday_time_error: HVn,
  saturday_time_error: YVn,
  error_end_time_before_start_time: KVn,
  error_end_time_next_day: ZVn,
  back_to_bookings: XVn,
  free_to_pick_another_event_type: JVn,
  cancelled: QVn,
  no_booking: eBn,
  awaiting_host: tBn,
  cancellation_successful: nBn,
  really_cancel_booking: oBn,
  cannot_cancel_booking: rBn,
  reschedule_instead: iBn,
  event_is_in_the_past: aBn,
  cancelling_event_recurring: sBn,
  cancelling_all_recurring: cBn,
  error_with_status_code_occured: lBn,
  error_event_type_url_duplicate: uBn,
  error_event_type_unauthorized_create: dBn,
  error_event_type_unauthorized_update: _Bn,
  error_workflow_unauthorized_create: pBn,
  error_schedule_unauthorized_create: mBn,
  booking_already_cancelled: fBn,
  booking_already_accepted_rejected: gBn,
  go_back_home: hBn,
  or_go_back_home: vBn,
  no_meeting_found: bBn,
  no_meeting_found_description: yBn,
  no_status_bookings_yet: $Bn,
  no_status_bookings_yet_description: wBn,
  event_between_users: kBn,
  bookings: SBn,
  booking_not_found: EBn,
  bookings_description: xBn,
  upcoming_bookings: CBn,
  recurring_bookings: TBn,
  past_bookings: ABn,
  cancelled_bookings: IBn,
  unconfirmed_bookings: OBn,
  unconfirmed_bookings_tooltip: NBn,
  on: zBn,
  and: RBn,
  calendar_shows_busy_between: PBn,
  troubleshoot: DBn,
  troubleshoot_description: LBn,
  overview_of_day: MBn,
  hover_over_bold_times_tip: FBn,
  start_time: qBn,
  end_time: jBn,
  buffer_time: VBn,
  before_event: BBn,
  after_event: UBn,
  event_buffer_default: GBn,
  buffer: WBn,
  your_day_starts_at: HBn,
  your_day_ends_at: YBn,
  launch_troubleshooter: KBn,
  troubleshoot_availability: ZBn,
  change_available_times: XBn,
  change_your_available_times: JBn,
  change_start_end: QBn,
  change_start_end_buffer: e9n,
  current_start_date: t9n,
  start_end_changed_successfully: n9n,
  and_end_at: o9n,
  light: r9n,
  dark: i9n,
  automatically_adjust_theme: a9n,
  user_dynamic_booking_disabled: s9n,
  allow_dynamic_booking_tooltip: c9n,
  allow_dynamic_booking: l9n,
  dynamic_booking: u9n,
  allow_seo_indexing: d9n,
  seo_indexing: _9n,
  allow_browser_notifications: p9n,
  you_have_denied_notifications: m9n,
  disable_browser_notifications: f9n,
  browser_notifications_turned_on: g9n,
  browser_notifications_turned_off: h9n,
  browser_notifications_denied: v9n,
  please_allow_notifications: b9n,
  push_notifications: y9n,
  push_notifications_description: $9n,
  browser_notifications_not_supported: w9n,
  email: k9n,
  email_placeholder: S9n,
  full_name: E9n,
  browse_api_documentation: x9n,
  leverage_our_api: C9n,
  create_webhook: T9n,
  instant_meeting: A9n,
  booking_cancelled: I9n,
  booking_rescheduled: O9n,
  recording_ready: N9n,
  recording_transcription_generated: z9n,
  booking_created: R9n,
  booking_rejected: P9n,
  booking_requested: D9n,
  booking_payment_initiated: L9n,
  meeting_ended: M9n,
  form_submitted: F9n,
  form_submitted_no_event: q9n,
  booking_paid: j9n,
  ooo_created: V9n,
  booking_no_show_updated: B9n,
  event_triggers: U9n,
  subscriber_url: G9n,
  create_new_webhook: W9n,
  webhooks: H9n,
  team_webhooks: Y9n,
  create_new_webhook_to_account: K9n,
  new_webhook: Z9n,
  receive_cal_meeting_data: X9n,
  receive_cal_event_meeting_data: J9n,
  responsive_fullscreen_iframe: Q9n,
  loading: eUn,
  deleting: tUn,
  standard_iframe: nUn,
  developer: oUn,
  manage_developer_settings: rUn,
  iframe_embed: iUn,
  embed_calcom: aUn,
  integrate_using_embed_or_webhooks: sUn,
  schedule_a_meeting: cUn,
  view_and_manage_billing_details: lUn,
  view_and_edit_billing_details: uUn,
  go_to_billing_portal: dUn,
  need_anything_else: _Un,
  further_billing_help: pUn,
  contact: mUn,
  our_support_team: fUn,
  contact_our_support_team: gUn,
  uh_oh: hUn,
  no_event_types_have_been_setup: vUn,
  edit_logo: bUn,
  upload_a_logo: yUn,
  upload_logo: $Un,
  remove_logo: wUn,
  enable: kUn,
  code: SUn,
  code_is_incorrect: EUn,
  add_time_availability: xUn,
  add_an_extra_layer_of_security: CUn,
  "2fa": "Autorización de dos factores",
  "2fa_disabled": "La autenticación de dos factores solo se puede habilitar para la autenticación por correo electrónico y contraseña",
  enable_2fa: TUn,
  disable_2fa: AUn,
  disable_2fa_recommendation: IUn,
  error_disabling_2fa: OUn,
  error_enabling_2fa: NUn,
  security: zUn,
  manage_account_security: RUn,
  password: PUn,
  password_updated_successfully: DUn,
  password_has_been_changed: LUn,
  error_changing_password: MUn,
  session_timeout_changed: FUn,
  session_timeout_change_error: qUn,
  something_went_wrong: jUn,
  something_doesnt_look_right: VUn,
  please_try_again: BUn,
  super_secure_new_password: UUn,
  new_password: GUn,
  your_old_password: WUn,
  current_password: HUn,
  change_password: YUn,
  change_secret: KUn,
  new_password_matches_old_password: ZUn,
  forgotten_secret_description: XUn,
  current_incorrect_password: JUn,
  password_hint_caplow: QUn,
  password_hint_min: eGn,
  password_hint_admin_min: tGn,
  password_hint_num: nGn,
  max_limit_allowed_hint: oGn,
  invalid_password_hint: rGn,
  incorrect_password: iGn,
  incorrect_email_password: aGn,
  use_setting: sGn,
  am_pm: cGn,
  time_options: lGn,
  january: uGn,
  february: dGn,
  march: _Gn,
  april: pGn,
  may: mGn,
  june: fGn,
  july: gGn,
  august: hGn,
  september: vGn,
  october: bGn,
  november: yGn,
  december: $Gn,
  monday: wGn,
  tuesday: kGn,
  wednesday: SGn,
  thursday: EGn,
  friday: xGn,
  saturday: CGn,
  sunday: TGn,
  all_booked_today: AGn,
  slots_load_fail: IGn,
  additional_guests: OGn,
  your_name: NGn,
  your_full_name: zGn,
  no_name: RGn,
  enter_number_between_range: PGn,
  continue_as_guest_description: DGn,
  email_address: LGn,
  enter_valid_email: MGn,
  please_schedule_future_call: FGn,
  location: qGn,
  address: jGn,
  enter_address: VGn,
  in_person_attendee_address: BGn,
  somewhere_else: UGn,
  custom_attendee_location: GGn,
  continue_as_guest: WGn,
  join_as_guest: HGn,
  ideal_for_one_time_calls: YGn,
  any_location: KGn,
  yes: ZGn,
  no: XGn,
  additional_notes: JGn,
  booking_fail: QGn,
  reschedule_fail: eWn,
  share_additional_notes: tWn,
  booking_confirmation: nWn,
  booking_reschedule_confirmation: oWn,
  in_person_meeting: rWn,
  in_person: iWn,
  link_meeting: aWn,
  phone_number: sWn,
  attendee_phone_number: cWn,
  organizer_phone_number: lWn,
  enter_phone_number: uWn,
  reschedule: dWn,
  reschedule_this: _Wn,
  book_a_team_member: pWn,
  or: mWn,
  go_back: fWn,
  email_or_username: gWn,
  send_invite_email: hWn,
  role: vWn,
  edit_role: bWn,
  view_role: yWn,
  edit_team: $Wn,
  editing_user: wWn,
  editing_org: kWn,
  edit_or_manage_webhooks: SWn,
  reject: EWn,
  reject_all: xWn,
  accept: CWn,
  leave: TWn,
  profile: AWn,
  my_team_url: IWn,
  my_teams: OWn,
  team_name: NWn,
  your_team_name: zWn,
  team_updated_successfully: RWn,
  your_team_updated_successfully: PWn,
  your_org_updated_successfully: DWn,
  error_copying_to_clipboard: LWn,
  about: MWn,
  team_description: FWn,
  organization_id: qWn,
  organization_id_copied: jWn,
  org_description: VWn,
  team_id: BWn,
  team_id_copied: UWn,
  members: GWn,
  organization_members: WWn,
  member: HWn,
  number_member_one: YWn,
  number_member_other: KWn,
  number_selected: ZWn,
  owner: XWn,
  admin: JWn,
  admin_api: QWn,
  administrator_user: e8n,
  lets_create_first_administrator_user: t8n,
  admin_user_created: n8n,
  admin_user_created_description: o8n,
  new_member: r8n,
  invite: i8n,
  add_team_members: a8n,
  add_org_members: s8n,
  add_team_members_description: c8n,
  add_team_member: l8n,
  invite_new_member: u8n,
  invite_new_member_description: d8n,
  invite_new_team_member: _8n,
  upload_csv_file: p8n,
  invite_via_email: m8n,
  change_member_role: f8n,
  disable_cal_branding: g8n,
  disable_cal_branding_description: h8n,
  hide_book_a_team_member: v8n,
  hide_book_a_team_member_description: b8n,
  danger_zone: y8n,
  account_deletion_cannot_be_undone: $8n,
  team_deletion_cannot_be_undone: w8n,
  back: k8n,
  cancel: S8n,
  cancel_all_remaining: E8n,
  apply: x8n,
  cancel_event: C8n,
  continue: "Continuar",
  confirm: T8n,
  confirm_all: A8n,
  disband_team: I8n,
  disband_team_confirmation_message: O8n,
  disband_org: N8n,
  disband_org_confirmation_message: z8n,
  remove_member_confirmation_message: R8n,
  confirm_disband_team: P8n,
  confirm_remove_member: D8n,
  confirm_subscription_cancellation: L8n,
  cancel_subscription: M8n,
  cancel_subscription_description: F8n,
  remove_member: q8n,
  manage_your_team: j8n,
  no_teams: V8n,
  no_teams_description: B8n,
  submit: U8n,
  confirm_remove_attribute: G8n,
  remove_attribute: W8n,
  remove_attribute_confirmation_message: H8n,
  delete: "Eliminar",
  update: Y8n,
  save: K8n,
  pending: Z8n,
  open_options: X8n,
  copy_link: J8n,
  share: Q8n,
  share_event: e7n,
  copy_link_team: t7n,
  leave_team: n7n,
  confirm_leave_team: o7n,
  leave_team_confirmation_message: r7n,
  user_from_team: i7n,
  preview: a7n,
  link_copied: s7n,
  copied: c7n,
  private_link_copied: l7n,
  link_shared: u7n,
  title: d7n,
  description: _7n,
  apps_status: p7n,
  quick_video_meeting: m7n,
  scheduling_type: f7n,
  preview_team: g7n,
  collective: h7n,
  collective_description: v7n,
  duration: b7n,
  available_durations: y7n,
  default_duration: $7n,
  default_duration_no_options: w7n,
  multiple_duration_mins: k7n,
  multiple_duration_timeUnit: S7n,
  multiple_duration_timeUnit_short: E7n,
  minutes: x7n,
  use_cal_ai_to_make_call_description: C7n,
  termination_uri: T7n,
  sip_trunk_username: A7n,
  sip_trunk_password: I7n,
  nickname: O7n,
  delete_phone_number: N7n,
  workflow_validation_failed: z7n,
  workflow_validation_empty_fields: R7n,
  workflow_validation_unverified_contacts: P7n,
  supercharge_your_workflows_with_cal_ai: D7n,
  supercharge_your_workflows_with_cal_ai_description: L7n,
  phone_number_imported_successfully: M7n,
  phone_number_deleted_successfully: F7n,
  delete_phone_number_confirmation: q7n,
  yes_delete_phone_number: j7n,
  phone_number_info_tooltip: V7n,
  termination_uri_info_tooltip: B7n,
  sip_trunk_username_info_tooltip: U7n,
  sip_trunk_password_info_tooltip: G7n,
  nickname_info_tooltip: W7n,
  save_and_test_call: H7n,
  call_initiated_successfully: Y7n,
  please_enter_phone_number: K7n,
  agent_updated_successfully: Z7n,
  agent_created_successfully: X7n,
  agent_event_type_updated_successfully: J7n,
  phone_number_unsubscribed_successfully: Q7n,
  general_prompt_description: eHn,
  prompt: tHn,
  call_to: nHn,
  make_test_call_to_verify_configuration: oHn,
  initial_message: rHn,
  initial_message_description: iHn,
  having_trouble_importing: aHn,
  learn: sHn,
  learn_how_to_get_your_terminator: cHn,
  phone_number_subscription_cancelled_successfully: lHn,
  updating: uHn,
  round_robin: dHn,
  hi_how_are_you_doing: _Hn,
  round_robin_description: pHn,
  managed_event: mHn,
  username_placeholder: fHn,
  managed_event_description: gHn,
  managed: hHn,
  managed_event_url_clarification: vHn,
  assign_to: bHn,
  enter_phone_number_to_test_call: yHn,
  make_test_call: $Hn,
  create_new_workflow_agent: wHn,
  create_new_workflow_agent_description: kHn,
  phone_number_for_ai_call: SHn,
  buy_a_phone_number_or_import_one_you_already_have: EHn,
  test_agent: xHn,
  test_web_call: CHn,
  phone_numbers: THn,
  unsubscribe: AHn,
  delete_workflow_step: IHn,
  unsubscribe_phone_number: OHn,
  buy_a_new_number: NHn,
  only_us_phone_numbers_can_be_purchased_here: zHn,
  buy_number_for_x_per_month: RHn,
  supported_call_destinations: PHn,
  no_phone_number_connected: DHn,
  failed_to_get_workflow_step_id: LHn,
  cal_ai_agent: MHn,
  test_cal_ai_agent: FHn,
  are_you_sure_you_want_to_delete_workflow_step: qHn,
  do_you_still_want_to_unsubscribe: jHn,
  the_action_will_disconnect_phone_number: VHn,
  cal_ai_phone_numbers: BHn,
  connect_phone_number: UHn,
  cal_ai_phone_numbers_description: GHn,
  import_number: WHn,
  this_action_will_also: HHn,
  import_phone_number: YHn,
  active_subscription: KHn,
  cancel_your_phone_number_subscription: ZHn,
  delete_associated_phone_number: XHn,
  unauthorized_create_workflow: JHn,
  import_phone_number_description: QHn,
  phone_number_cost: eYn,
  buy_new_number: tYn,
  buy_number_cost_x_per_month: nYn,
  area_code_optional: oYn,
  no_phone_numbers: rYn,
  phone_number_purchased_successfully: iYn,
  cancel_phone_number_subscription: aYn,
  yes_cancel_subscription: sYn,
  cancel_phone_number_subscription_confirmation: cYn,
  add_members: lYn,
  add_members_no_ellipsis: uYn,
  no_assigned_members: dYn,
  assigned_to: _Yn,
  you_must_be_logged_in_to: pYn,
  start_assigning_members_above: mYn,
  locked_fields_admin_description: fYn,
  unlocked_fields_admin_description: gYn,
  locked_fields_member_description: hYn,
  unlocked_fields_member_description: vYn,
  url: bYn,
  hidden: yYn,
  readonly: $Yn,
  one_time_link: wYn,
  plan_description: kYn,
  plan_upgrade_invitation: SYn,
  plan_upgrade: EYn,
  plan_upgrade_teams: xYn,
  plan_upgrade_instructions: CYn,
  event_types_page_title: TYn,
  event_types_page_subtitle: AYn,
  new: "Nuevo",
  new_event_type_btn: IYn,
  new_event_type_heading: OYn,
  new_event_type_description: NYn,
  event_type_created_successfully: zYn,
  event_type_updated_successfully: RYn,
  event_type_deleted_successfully: PYn,
  hours: DYn,
  people: LYn,
  your_email: MYn,
  change_avatar: FYn,
  upload_avatar: qYn,
  language: jYn,
  timezone: VYn,
  first_day_of_week: BYn,
  repeats_up_to_one: UYn,
  repeats_up_to_other: GYn,
  every_for_freq: WYn,
  event_remaining_one: HYn,
  event_remaining_other: YYn,
  repeats_every: KYn,
  occurrence_one: ZYn,
  occurrence_other: XYn,
  weekly_one: JYn,
  weekly_other: QYn,
  monthly_one: eKn,
  monthly_other: tKn,
  yearly_one: nKn,
  yearly_other: oKn,
  plus_more: rKn,
  max: iKn,
  single_theme: aKn,
  brand_color: sKn,
  light_brand_color: cKn,
  dark_brand_color: lKn,
  light_event_type_color: uKn,
  dark_event_type_color: dKn,
  file_not_named: _Kn,
  create_team: pKn,
  name: mKn,
  nameless_team: fKn,
  oauth_clients: gKn,
  oauth_clients_description: hKn,
  create_oauth_client: vKn,
  create_oauth_client_description: bKn,
  oauth_client_deletion_message: yKn,
  create_new_team_description: $Kn,
  create_new_team: wKn,
  booking_redirect_uri: kKn,
  booking_cancel_redirect_uri: SKn,
  booking_reschedule_redirect_uri: EKn,
  booking_conflict_error: xKn,
  open_invitations: CKn,
  new_team: TKn,
  create_first_team_and_invite_others: AKn,
  create_team_to_get_started: IKn,
  teams: OKn,
  team: NKn,
  organization: zKn,
  team_billing: RKn,
  team_billing_description: PKn,
  upgrade_to_flexible_pro_title: DKn,
  upgrade_to_flexible_pro_message: LKn,
  changed_team_billing_info: MKn,
  create_manage_teams_collaborative: FKn,
  only_available_on_pro_plan: qKn,
  remove_cal_branding_description: jKn,
  edit_profile_info_description: VKn,
  change_email_tip: BKn,
  little_something_about: UKn,
  profile_updated_successfully: GKn,
  your_user_profile_updated_successfully: WKn,
  your_upgrade_is_here: HKn,
  your_upgrade_is_here_description: YKn,
  you_are_all_set: KKn,
  you_are_all_set_description: ZKn,
  user_cannot_found_db: XKn,
  embed_and_webhooks: JKn,
  enabled: QKn,
  disabled: eZn,
  disable: tZn,
  billing: nZn,
  here: oZn,
  manage_your_billing_info: rZn,
  availability: iZn,
  edit_availability: aZn,
  configure_availability: sZn,
  copy_times_to: cZn,
  copy_times_to_tooltip: lZn,
  change_weekly_schedule: uZn,
  logo: dZn,
  error: _Zn,
  at_least_characters_one: pZn,
  at_least_characters_other: mZn,
  team_logo: fZn,
  add_location: gZn,
  attendees: hZn,
  add_attendees: vZn,
  show_advanced_settings: bZn,
  hide_advanced_settings: yZn,
  event_name: $Zn,
  event_name_in_calendar: wZn,
  event_name_tooltip: kZn,
  meeting_with_user: SZn,
  additional_inputs: EZn,
  additional_input_description: xZn,
  label: CZn,
  placeholder: TZn,
  display_add_to_calendar_organizer: AZn,
  display_email_as_organizer: IZn,
  if_enabled_email_address_as_organizer: OZn,
  reconnect_calendar_to_use: NZn,
  type: zZn,
  edit: RZn,
  add_input: PZn,
  disable_notes: DZn,
  disable_notes_description: LZn,
  requires_confirmation_description: MZn,
  requires_confirmation_will_block_slot_description: FZn,
  recurring_event: qZn,
  recurring_event_description: jZn,
  connect_and_join: VZn,
  cannot_be_used_with_paid_event_types: BZn,
  warning_payment_instant_meeting_event: UZn,
  warning_instant_meeting_experimental: GZn,
  starting: WZn,
  disable_guests: HZn,
  disable_guests_description: YZn,
  private_link: KZn,
  enable_private_url: ZZn,
  private_link_label: XZn,
  private_link_hint: JZn,
  copy_private_link: QZn,
  copy_private_link_to_event: eXn,
  private_link_description: tXn,
  multiple_private_links_title: nXn,
  multiple_private_links_description: oXn,
  add_a_multiple_private_link: rXn,
  multiple_private_link_copied: iXn,
  invitees_can_schedule: aXn,
  date_range: sXn,
  calendar_days: cXn,
  business_days: lXn,
  set_address_place: uXn,
  set_link_meeting: dXn,
  managed_event_field_parent_control_disabled: _Xn,
  cal_invitee_phone_number_scheduling: pXn,
  cal_provide_google_meet_location: mXn,
  cal_provide_zoom_meeting_url: fXn,
  cal_provide_tandem_meeting_url: gXn,
  cal_provide_video_meeting_url: hXn,
  cal_provide_jitsi_meeting_url: vXn,
  cal_provide_huddle01_meeting_url: bXn,
  cal_provide_teams_meeting_url: yXn,
  require_payment: $Xn,
  you_need_to_add_a_name: wXn,
  commission_per_transaction: kXn,
  event_type_updated_successfully_description: SXn,
  hide_event_type: EXn,
  edit_location: xXn,
  into_the_future: CXn,
  when_booked_with_less_than_notice: TXn,
  within_date_range: AXn,
  indefinitely_into_future: IXn,
  add_new_custom_input_field: OXn,
  quick_chat: NXn,
  add_new_team_event_type: zXn,
  add_new_event_type: RXn,
  new_event_type_to_book_description: PXn,
  length: DXn,
  minimum_booking_notice: LXn,
  offset_toggle: MXn,
  offset_toggle_description: FXn,
  offset_start: qXn,
  offset_start_description: jXn,
  slot_interval: VXn,
  slot_interval_default: BXn,
  delete_event_type: UXn,
  delete_managed_event_type: GXn,
  delete_event_type_description: WXn,
  delete_managed_event_type_description_1: HXn,
  delete_managed_event_type_description_2: YXn,
  confirm_delete_event_type: KXn,
  delete_account: ZXn,
  confirm_delete_account: XXn,
  delete_account_confirmation_message: JXn,
  integrations: QXn,
  apps: eJn,
  apps_description: tJn,
  apps_listing: nJn,
  category_apps: oJn,
  app_store: rJn,
  app_store_description: iJn,
  connect_your_video: aJn,
  settings: sJn,
  event_type_moved_successfully: cJn,
  next_step_text: lJn,
  next_step: uJn,
  prev_step: dJn,
  install: _Jn,
  start_paid_trial: pJn,
  installed: mJn,
  active_install_one: fJn,
  active_install_other: gJn,
  globally_install: hJn,
  app_successfully_installed: vJn,
  app_could_not_be_installed: bJn,
  disconnect: yJn,
  embed_your_calendar: $Jn,
  connect_your_favourite_apps: wJn,
  automation: kJn,
  configure_how_your_event_types_interact: SJn,
  toggle_calendars_conflict: EJn,
  connect_additional_calendar: xJn,
  calendar_updated_successfully: CJn,
  check_here: TJn,
  conferencing: AJn,
  calendar: IJn,
  payments: OJn,
  not_installed: NJn,
  error_password_mismatch: zJn,
  error_required_field: RJn,
  status: PJn,
  team_view_user_availability: DJn,
  team_view_user_availability_disabled: LJn,
  set_as_away: MJn,
  set_as_free: FJn,
  toggle_away_error: qJn,
  user_away: jJn,
  user_away_description: VJn,
  meet_people_with_the_same_tokens: BJn,
  only_book_people_and_allow: UJn,
  account_created_with_identity_provider: GJn,
  account_managed_by_identity_provider: WJn,
  account_managed_by_identity_provider_description: HJn,
  account_managed_by_identity_provider_error: YJn,
  user_creation_error: KJn,
  signin_with_google: ZJn,
  signin_with_saml: XJn,
  signin_with_saml_oidc: JJn,
  continue_with_email: QJn,
  continue_with_google: eQn,
  last_used: tQn,
  you_will_need_to_generate: nQn,
  import: "Importar",
  import_from: oQn,
  access_token: rQn,
  visit_roadmap: iQn,
  featured_categories: aQn,
  feature_flags: sQn,
  admin_flags_description: cQn,
  popular_categories: lQn,
  number_apps_one: uQn,
  number_apps_other: dQn,
  trending_apps: _Qn,
  most_popular: pQn,
  installed_apps: mQn,
  free_to_use_apps: fQn,
  no_category_apps: gQn,
  all_apps: hQn,
  no_category_apps_description_calendar: vQn,
  no_category_apps_description_conferencing: bQn,
  no_category_apps_description_payment: yQn,
  no_category_apps_description_analytics: $Qn,
  no_category_apps_description_automation: wQn,
  no_category_apps_description_other: kQn,
  no_category_apps_description_messaging: SQn,
  no_category_apps_description_crm: EQn,
  installed_app_calendar_description: xQn,
  installed_app_payment_description: CQn,
  installed_app_analytics_description: TQn,
  installed_app_other_description: AQn,
  installed_app_conferencing_description: IQn,
  installed_app_automation_description: OQn,
  installed_app_messaging_description: NQn,
  installed_app_crm_description: zQn,
  analytics: RQn,
  empty_installed_apps_headline: PQn,
  empty_installed_apps_description: DQn,
  empty_installed_apps_button: LQn,
  manage_your_connected_apps: MQn,
  browse_apps: FQn,
  features: qQn,
  permissions: jQn,
  terms_and_privacy: VQn,
  published_by: BQn,
  subscribe: UQn,
  buy: GQn,
  install_app: WQn,
  categories: HQn,
  pricing: YQn,
  learn_more: KQn,
  try_now: ZQn,
  privacy_policy: XQn,
  terms_of_service: JQn,
  remove: QQn,
  add: eeo,
  installed_other: teo,
  verify_wallet: neo,
  create_events_on: oeo,
  enterprise_license: reo,
  enterprise_license_locally: ieo,
  enterprise_license_sales: aeo,
  missing_license: seo,
  next_steps: ceo,
  acquire_commercial_license: leo,
  the_infrastructure_plan: ueo,
  prisma_studio_tip: deo,
  prisma_studio_tip_description: _eo,
  contact_sales: peo,
  error_404: meo,
  default: "Predeterminado",
  set_to_default: feo,
  new_schedule_btn: geo,
  add_new_schedule: heo,
  add_new_calendar: veo,
  set_calendar: beo,
  delete_schedule: yeo,
  delete_schedule_description: $eo,
  schedule_created_successfully: weo,
  availability_updated_successfully: keo,
  schedule_deleted_successfully: Seo,
  default_schedule_name: Eeo,
  new_schedule_heading: xeo,
  new_schedule_description: Ceo,
  requires_ownership_of_a_token: Teo,
  example_name: Aeo,
  time_format: Ieo,
  "12_hour": "12 horas",
  "24_hour": "24 horas",
  "12_hour_short": "12 h",
  "24_hour_short": "24hs",
  redirect_success_booking: Oeo,
  you_are_being_redirected: Neo,
  external_redirect_url: zeo,
  redirect_url_description: Reo,
  duplicate: Peo,
  offer_seats: Deo,
  offer_seats_description: Leo,
  seats_available_one: Meo,
  seats_available_other: Feo,
  seats_nearly_full: qeo,
  seats_half_full: jeo,
  number_of_seats: Veo,
  set_instant_meeting_expiry_time_offset_description: Beo,
  enter_number_of_seats: Ueo,
  you_can_manage_your_schedules: Geo,
  booking_full: Weo,
  api_keys: Heo,
  api_key: Yeo,
  test_api_key: Keo,
  test_passed: Zeo,
  test_failed: Xeo,
  provide_api_key: Jeo,
  api_key_modal_subtitle: Qeo,
  api_key_modal_subtitle_platform: eto,
  api_keys_subtitle: tto,
  create_api_key: nto,
  personal_note: oto,
  personal_note_placeholder: rto,
  api_key_no_note: ito,
  api_key_never_expires: ato,
  edit_api_key: sto,
  success_api_key_created: cto,
  success_api_key_edited: lto,
  create: uto,
  success_api_key_created_bold_tagline: dto,
  you_will_only_view_it_once: _to,
  copy_to_clipboard: pto,
  enabled_after_update: mto,
  enabled_after_update_description: fto,
  confirm_delete_api_key: gto,
  disable_rescheduling: hto,
  description_disable_rescheduling: vto,
  allow_rescheduling_cancelled_bookings: bto,
  description_allow_rescheduling_cancelled_bookings: yto,
  disable_cancelling: $to,
  description_disable_cancelling: wto,
  revoke_api_key: kto,
  api_key_copied: Sto,
  api_key_expires_on: Eto,
  delete_api_key_confirm_title: xto,
  copy: Cto,
  expire_date: Tto,
  expired: Ato,
  never_expires: Ito,
  expires: Oto,
  request_reschedule_booking: Nto,
  reason_for_reschedule: zto,
  book_a_new_time: Rto,
  reschedule_request_sent: Pto,
  reschedule_modal_description: Dto,
  reason_for_reschedule_request: Lto,
  send_reschedule_request: Mto,
  edit_booking: Fto,
  reschedule_booking: qto,
  former_time: jto,
  confirmation_page_gif: Vto,
  search: Bto,
  impersonate: Uto,
  user_impersonation_heading: Gto,
  user_impersonation_description: Wto,
  team_impersonation_description: Hto,
  cal_signup_description: Yto,
  make_org_private: Kto,
  make_org_private_description: Zto,
  make_team_private: Xto,
  make_team_private_description: Jto,
  you_cannot_see_team_members: Qto,
  you_cannot_see_teams_of_org: eno,
  allow_multiple_durations: tno,
  impersonate_user_tip: nno,
  impersonating_user_warning: ono,
  impersonating_stop_instructions: rno,
  event_location_changed: ino,
  new_guests_added: ano,
  location_changed_event_type_subject: sno,
  guests_added_event_type_subject: cno,
  current_location: lno,
  new_location: uno,
  session: dno,
  session_description: _no,
  session_timeout_after: pno,
  session_timeout: mno,
  session_timeout_description: fno,
  no_location: gno,
  set_location: hno,
  update_location: vno,
  location_updated: bno,
  location_update_failed: yno,
  guests_added: $no,
  unable_to_add_guests: wno,
  email_validation_error: kno,
  emails_must_be_unique_valid: Sno,
  url_validation_error: Eno,
  place_where_cal_widget_appear: xno,
  create_update_react_component: Cno,
  copy_code: Tno,
  code_copied: Ano,
  how_you_want_add_cal_site: Ino,
  choose_ways_put_cal_site: Ono,
  setting_up_zapier: Nno,
  setting_up_make: zno,
  generate_api_key: Rno,
  generate_api_key_description: Pno,
  your_unique_api_key: Dno,
  copy_safe_api_key: Lno,
  zapier_setup_instructions: Mno,
  make_setup_instructions_1: Fno,
  make_setup_instructions_2: qno,
  make_setup_instructions_3: jno,
  make_setup_instructions_4: Vno,
  make_setup_instructions_5: Bno,
  make_setup_instructions_6: Uno,
  install_zapier_app: Gno,
  install_make_app: Wno,
  app_installation: Hno,
  app_not_installed: Yno,
  visit_our_app_store: Kno,
  connect_apple_server: Zno,
  calendar_url: Xno,
  apple_server_generate_password: Jno,
  unable_to_add_apple_calendar: Qno,
  credentials_stored_encrypted: eoo,
  it_stored_encrypted: too,
  go_to_app_store: noo,
  calendar_error: ooo,
  set_your_phone_number: roo,
  calendar_no_busy_slots: ioo,
  display_location_label: aoo,
  display_location_info_badge: soo,
  add_gif: coo,
  search_giphy: loo,
  add_link_from_giphy: uoo,
  add_gif_to_confirmation: doo,
  find_gif_spice_confirmation: _oo,
  share_feedback: poo,
  resources: moo,
  support_documentation: foo,
  developer_documentation: goo,
  get_in_touch: hoo,
  contact_support: voo,
  premium_support: boo,
  community_support: yoo,
  feedback: $oo,
  submitted_feedback: woo,
  feedback_error: koo,
  comments: Soo,
  booking_details: Eoo,
  or_lowercase: xoo,
  nevermind: Coo,
  go_to: Too,
  zapier_invite_link: Aoo,
  meeting_url_provided_after_confirmed: Ioo,
  dynamically_display_attendee_or_organizer: Ooo,
  event_location: Noo,
  reschedule_optional: zoo,
  reschedule_placeholder: Roo,
  event_cancelled: Poo,
  emailed_information_about_cancelled_event: Doo,
  this_input_will_shown_booking_this_event: Loo,
  meeting_url_in_confirmation_email: Moo,
  url_start_with_https: Foo,
  number_provided: qoo,
  before_event_trigger: joo,
  event_cancelled_trigger: Voo,
  after_hosts_cal_video_no_show: Boo,
  after_guests_cal_video_no_show: Uoo,
  join_video_call: Goo,
  sign_in_to_cal_com: Woo,
  log_in_to_cal_com: Hoo,
  track_your_meetings: Yoo,
  track_meetings_and_manage_schedule: Koo,
  failed_to_join_call: Zoo,
  choose_how_you_d_like_to_join_call: Xoo,
  choose_how_you_d_like_to_appear_on_the_call: Joo,
  new_event_trigger: Qoo,
  email_host_action: ero,
  email_attendee_action: tro,
  sms_attendee_action: nro,
  sms_number_action: oro,
  send_reminder_sms: rro,
  whatsapp_number_action: iro,
  whatsapp_attendee_action: aro,
  workflows: sro,
  new_workflow_btn: cro,
  how_would_you_like_to_start: lro,
  add_new_workflow: uro,
  reschedule_event_trigger: dro,
  trigger: _ro,
  triggers: pro,
  action: mro,
  workflows_to_automate_notifications: fro,
  workflow_name: gro,
  custom_workflow: hro,
  workflow_created_successfully: vro,
  delete_workflow_description: bro,
  delete_workflow: yro,
  confirm_delete_workflow: $ro,
  workflow_deleted_successfully: wro,
  how_long_before: kro,
  day_timeUnit: Sro,
  hour_timeUnit: Ero,
  minute_timeUnit: xro,
  minute_short: Cro,
  hour_short: Tro,
  new_workflow_heading: Aro,
  new_workflow_description: Iro,
  active_on: Oro,
  workflow_updated_successfully: Nro,
  premium_to_standard_username_description: zro,
  premium_username: Rro,
  current: Pro,
  premium: Dro,
  standard: Lro,
  confirm_username_change_dialog_title: Mro,
  change_username_standard_to_premium: Fro,
  change_username_premium_to_standard: qro,
  go_to_stripe_billing: jro,
  stripe_description: Vro,
  trial_expired: Bro,
  remove_app: Uro,
  yes_remove_app: Gro,
  are_you_sure_you_want_to_remove_this_app: Wro,
  app_removed_successfully: Hro,
  error_removing_app: Yro,
  web_conference: Kro,
  web_call: Zro,
  start_web_call: Xro,
  end_call: Jro,
  test_your_agent_with_web_call: Qro,
  phone_call: eio,
  connecting_to_agent: tio,
  call_active: nio,
  call_ended: oio,
  call_error: rio,
  ready_to_start_call: iio,
  failed_to_start_web_call_try_again: aio,
  call_encountered_error_try_again: sio,
  failed_initialize_web_call_microphone_permissions: cio,
  start_call_to_see_conversation: lio,
  waiting_for_conversation: uio,
  ai_agent: dio,
  live: _io,
  connecting: pio,
  requires_confirmation: mio,
  requires_confirmation_threshold: fio,
  may_require_confirmation: gio,
  nr_event_type_one: hio,
  nr_event_type_other: vio,
  count_team_one: bio,
  count_team_other: yio,
  add_action: $io,
  set_whereby_link: wio,
  invalid_whereby_link: kio,
  set_around_link: Sio,
  invalid_around_link: Eio,
  set_riverside_link: xio,
  invalid_riverside_link: Cio,
  invalid_ping_link: Tio,
  add_exchange2013: Aio,
  add_exchange2016: Iio,
  custom_template: Oio,
  email_body: Nio,
  text_message: zio,
  specific_issue: Rio,
  browse_our_docs: Pio,
  choose_template: Dio,
  custom: Lio,
  reminder: Mio,
  rescheduled: Fio,
  rescheduled_by: qio,
  original_booking: jio,
  completed: Vio,
  rating: Bio,
  reminder_email: Uio,
  not_triggering_existing_bookings: Gio,
  minute_one: Wio,
  minute_one_short: Hio,
  minute_other: Yio,
  hour_one: Kio,
  hour_one_short: Zio,
  hour_other: Xio,
  invalid_input: Jio,
  broken_video_action: Qio,
  broken_calendar_action: eao,
  attendee_name: tao,
  scheduler_full_name: nao,
  broken_integration: oao,
  problem_adding_video_link: rao,
  problem_updating_calendar: iao,
  active_on_event_types_one: aao,
  active_on_event_types_other: sao,
  active_on_teams_one: cao,
  active_on_teams_other: lao,
  active_on_all_event_types: uao,
  active_on_all_teams: dao,
  no_active_event_types: _ao,
  no_active_teams: pao,
  new_seat_subject: mao,
  new_seat_title: fao,
  variable: gao,
  event_name_variable: hao,
  attendee_name_variable: vao,
  event_date_variable: bao,
  event_time_variable: yao,
  organizer_name_variable: $ao,
  app_upgrade_description: wao,
  invalid_number: kao,
  invalid_url_error_message: Sao,
  navigate: Eao,
  open: xao,
  close: Cao,
  upgrade: Tao,
  buy_us_number_button: Aao,
  upgrade_to_access_recordings_title: Iao,
  upgrade_to_access_recordings_description: Oao,
  upgrade_to_cal_ai_phone_number_description: Nao,
  recordings_are_part_of_the_teams_plan: zao,
  team_feature_teams: Rao,
  team_feature_workflows: Pao,
  show_eventtype_on_profile: Dao,
  embed: Lao,
  new_username: Mao,
  current_username: Fao,
  example_1: qao,
  example_2: jao,
  booking_question_identifier: Vao,
  company_size: Bao,
  what_help_needed: Uao,
  variable_format: Gao,
  webhook_subscriber_url_reserved: Wao,
  custom_input_as_variable_info: Hao,
  using_booking_questions_as_variables: Yao,
  download_desktop_app: Kao,
  set_ping_link: Zao,
  rate_limit_exceeded: Xao,
  when_something_happens: Jao,
  action_is_performed: Qao,
  test_action: eso,
  notification_sent: tso,
  no_input: nso,
  test_workflow_action: oso,
  send_sms: rso,
  send_sms_to_number: iso,
  missing_connected_calendar: aso,
  connect_your_calendar_and_link: sso,
  default_calendar_selected: cso,
  hide_from_profile: lso,
  basics: uso,
  availability_not_found_in_schedule_error: dso,
  event_limit_tab_title: _so,
  event_limit_tab_description: pso,
  event_advanced_tab_description: mso,
  event_advanced_tab_title: fso,
  event_payments_tab_description: gso,
  event_setup_multiple_duration_error: hso,
  event_setup_multiple_duration_default_error: vso,
  event_setup_booking_limits_error: bso,
  event_setup_duration_limits_error: yso,
  select_which_cal: $so,
  custom_event_name: wso,
  custom_event_name_description: kso,
  "2fa_required": "Se requiere autenticación de dos factores",
  incorrect_2fa: Sso,
  which_event_type_apply: Eso,
  apply_to_all_event_types: xso,
  apply_to_all_teams: Cso,
  which_team_apply: Tso,
  no_workflows_description: Aso,
  timeformat_profile_hint: Iso,
  create_workflow: Oso,
  do_this: Nso,
  turn_off: zso,
  turn_on: Rso,
  cancelled_bookings_cannot_be_rescheduled: Pso,
  settings_updated_successfully: Dso,
  error_updating_settings: Lso,
  personal_cal_url: Mso,
  bio_hint: Fso,
  finish_and_start: qso,
  user_has_no_bio: jso,
  bio: Vso,
  delete_account_modal_title: Bso,
  confirm_delete_account_modal: Uso,
  delete_my_account: Gso,
  start_of_week: Wso,
  recordings_title: Hso,
  recording: Yso,
  happy_scheduling: Kso,
  select_calendars: Zso,
  check_for_conflicts: Xso,
  view_recordings: Jso,
  check_for_recordings: Qso,
  adding_events_to: eco,
  follow_system_preferences: tco,
  custom_brand_colors: nco,
  customize_your_brand_colors: oco,
  pro: rco,
  removes_cal_branding: ico,
  instant_meeting_with_title: aco,
  profile_picture: sco,
  upload: cco,
  add_profile_photo: lco,
  token_address: uco,
  blockchain: dco,
  old_password: _co,
  secure_password: pco,
  error_updating_password: mco,
  two_factor_auth: fco,
  recurring_event_tab_description: gco,
  today: hco,
  appearance: vco,
  my_account: bco,
  general: yco,
  calendars: $co,
  "2fa_auth": "Autenticación de dos factores",
  invoices: wco,
  embeds: kco,
  impersonation: Sco,
  impersonation_description: Eco,
  recent_impersonations: xco,
  quick_impersonate: Cco,
  no_recent_impersonations: Tco,
  users: Aco,
  user: Ico,
  profile_description: Oco,
  users_description: Nco,
  users_listing: zco,
  general_description: Rco,
  calendars_description: Pco,
  appearance_description: Dco,
  conferencing_description: Lco,
  add_conferencing_app: Mco,
  password_description: Fco,
  set_up_two_factor_authentication: qco,
  we_just_need_basic_info: jco,
  skip: Vco,
  do_this_later: Bco,
  set_availability_getting_started_subtitle_1: Uco,
  set_availability_getting_started_subtitle_2: Gco,
  connect_calendar_first: Wco,
  complete_profile: Hco,
  connect_calendars_from_app_store: Yco,
  connect_conference_apps: Kco,
  connect_calendar_apps: Zco,
  connect_payment_apps: Xco,
  connect_automation_apps: Jco,
  connect_analytics_apps: Qco,
  connect_other_apps: elo,
  connect_messaging_apps: tlo,
  connect_crm_apps: nlo,
  current_step_of_total: olo,
  add_variable: rlo,
  custom_phone_number: ilo,
  message_template: alo,
  email_subject: slo,
  add_dynamic_variables: clo,
  event_name_info: llo,
  event_date_info: ulo,
  event_duration_info: dlo,
  event_time_info: _lo,
  event_type_not_found: plo,
  number_to_call_variable: mlo,
  number_to_call_info: flo,
  location_variable: glo,
  location_info: hlo,
  additional_notes_variable: vlo,
  additional_notes_info: blo,
  attendee_name_info: ylo,
  organizer_name_info: $lo,
  to: wlo,
  workflow_turned_on_successfully: klo,
  download_responses: Slo,
  download_responses_description: Elo,
  view_responses: xlo,
  download: Clo,
  downloading: Tlo,
  download_recording: Alo,
  transcription_enabled: Ilo,
  transcription_stopped: Olo,
  download_transcript: Nlo,
  transcript: zlo,
  recording_from_your_recent_call: Rlo,
  transcript_from_previous_call: Plo,
  you_can_download_transcript_from_attachments: Dlo,
  link_valid_for_12_hrs: Llo,
  link_valid_for_12_hrs_description: Mlo,
  create_your_first_form: Flo,
  create_your_first_form_description: qlo,
  create_your_first_webhook: jlo,
  create_your_first_webhook_description: Vlo,
  for_a_maximum_of: Blo,
  event_one: Ulo,
  event_other: Glo,
  profile_team_description: Wlo,
  profile_org_description: Hlo,
  members_team_description: Ylo,
  organization_description: Klo,
  team_url: Zlo,
  team_members: Xlo,
  more: Jlo,
  cal_ai_workflows: Qlo,
  and_count_more: euo,
  more_page_footer: tuo,
  workflow_example_1: nuo,
  workflow_example_2: ouo,
  workflow_example_3: ruo,
  workflow_example_4: iuo,
  workflow_example_5: auo,
  workflow_example_6: suo,
  send_sms_reminder: cuo,
  send_sms_reminder_description: luo,
  follow_up_with_no_shows: uuo,
  follow_up_with_no_shows_description: duo,
  remind_attendees_to_bring_id: _uo,
  remind_attendees_to_bring_id_description: puo,
  email_to_remind_booking: muo,
  email_to_remind_booking_description: fuo,
  custom_sms_reminder: guo,
  custom_sms_reminder_description: huo,
  custom_email_reminder: vuo,
  custom_email_reminder_description: buo,
  count_managed_to_limit: yuo,
  welcome_to_cal_header: $uo,
  edit_form_later_subtitle: wuo,
  connect_calendar_later: kuo,
  problem_saving_user_profile: Suo,
  purchase_missing_seats: Euo,
  slot_length: xuo,
  booking_appearance: Cuo,
  appearance_team_description: Tuo,
  appearance_org_description: Auo,
  only_owner_change: Iuo,
  team_disable_cal_branding_description: Ouo,
  invited_by_team: Nuo,
  token_invalid_expired: zuo,
  view_booking: Ruo,
  exchange_add: Puo,
  exchange_authentication: Duo,
  exchange_authentication_standard: Luo,
  exchange_authentication_ntlm: Muo,
  exchange_compression: Fuo,
  exchange_version: quo,
  exchange_version_2007_SP1: juo,
  exchange_version_2010: Vuo,
  exchange_version_2010_SP1: Buo,
  exchange_version_2010_SP2: Uuo,
  exchange_version_2013: Guo,
  exchange_version_2013_SP1: Wuo,
  exchange_version_2015: Huo,
  exchange_version_2016: Yuo,
  routing: Kuo,
  routing_forms_description: Zuo,
  routing_forms_send_email_owner: Xuo,
  routing_forms_send_email_owner_description: Juo,
  routing_forms_send_email_to: Quo,
  add_new_form: edo,
  add_new_team_form: tdo,
  create_your_first_route: ndo,
  route_to_the_right_person: odo,
  form: rdo,
  form_description: ido,
  copy_link_to_form: ado,
  theme: sdo,
  theme_applies_note: cdo,
  app_theme: ldo,
  app_theme_applies_note: udo,
  theme_system: ddo,
  add_a_team: _do,
  add_webhook_description: pdo,
  triggers_when: mdo,
  test_webhook: fdo,
  enable_webhook: gdo,
  add_webhook: hdo,
  webhook_edited_successfully: vdo,
  api_keys_description: bdo,
  new_api_key: ydo,
  active: $do,
  api_key_updated: wdo,
  api_key_update_failed: kdo,
  embeds_title: Sdo,
  embeds_description: Edo,
  create_first_api_key: xdo,
  create_first_api_key_description: Cdo,
  back_to_signin: Tdo,
  reset_link_sent: Ado,
  password_reset_email: Ido,
  password_reset_leading: Odo,
  password_updated: Ndo,
  pending_payment: zdo,
  pending_invites: Rdo,
  pending_organization_invites: Pdo,
  not_on_cal: Ddo,
  no_calendar_installed: Ldo,
  no_calendar_installed_description: Mdo,
  add_a_calendar: Fdo,
  change_email_hint: qdo,
  confirm_password_change_email: jdo,
  seats: Vdo,
  every_app_published: Bdo,
  report_app: Udo,
  limit_booking_frequency: Gdo,
  limit_booking_frequency_description: Wdo,
  only_show_first_available_slot: Hdo,
  only_show_first_available_slot_description: Ydo,
  limit_total_booking_duration: Kdo,
  limit_total_booking_duration_description: Zdo,
  booker_booking_limit: Xdo,
  booker_booking_limit_description: Jdo,
  recurring_event_doesnt_support_booker_booking_limit: Qdo,
  add_limit: e_o,
  team_name_required: t_o,
  show_attendees: n_o,
  show_available_seats_count: o_o,
  how_booking_questions_as_variables: r_o,
  format: i_o,
  questions: a_o,
  all_info_your_booker_provide: s_o,
  uppercase_for_letters: c_o,
  replace_whitespaces_underscores: l_o,
  platform_members: u_o,
  platform_members_description: d_o,
  platform_billing: __o,
  manage_billing: p_o,
  manage_billing_description: m_o,
  billing_freeplan_title: f_o,
  billing_freeplan_description: g_o,
  billing_freeplan_cta: h_o,
  billing_portal: v_o,
  billing_help_cta: b_o,
  ignore_special_characters_booking_questions: y_o,
  retry: $_o,
  fetching_calendars_error: w_o,
  calendar_connection_fail: k_o,
  booking_confirmation_success: S_o,
  booking_rejection_success: E_o,
  booking_tentative: x_o,
  booking_accept_intent: C_o,
  we_wont_show_again: T_o,
  couldnt_update_timezone: A_o,
  updated_timezone_to: I_o,
  update_timezone: O_o,
  update_timezone_question: N_o,
  update_timezone_description: z_o,
  dont_update: R_o,
  require_additional_notes: P_o,
  require_additional_notes_description: D_o,
  email_address_action: L_o,
  after_event_trigger: M_o,
  booking_rejected_trigger: F_o,
  booking_requested_trigger: q_o,
  booking_payment_initiated_trigger: j_o,
  booking_paid_trigger: V_o,
  booking_no_show_updated_trigger: B_o,
  how_long_after: U_o,
  how_long_after_hosts_no_show: G_o,
  how_long_after_guests_no_show: W_o,
  how_long_after_user_no_show_minutes: H_o,
  no_available_slots: Y_o,
  time_available: K_o,
  cant_find_the_right_conferencing_app_visit_our_app_store: Z_o,
  install_new_calendar_app: X_o,
  make_phone_number_required: J_o,
  new_event_type_availability: Q_o,
  error_editing_availability: epo,
  dont_have_permission: tpo,
  saml_configuration_placeholder: npo,
  saml_email_required: opo,
  saml_sp_title: rpo,
  saml_sp_description: ipo,
  saml_sp_acs_url: apo,
  saml_sp_entity_id: spo,
  saml_sp_acs_url_copied: cpo,
  saml_sp_entity_id_copied: lpo,
  add_calendar: upo,
  limit_future_bookings: dpo,
  limit_future_bookings_description: _po,
  no_event_types: ppo,
  no_event_types_description: mpo,
  billing_frequency: fpo,
  monthly: gpo,
  yearly: hpo,
  checkout: vpo,
  your_team_disbanded_successfully: bpo,
  your_org_disbanded_successfully: ypo,
  error_creating_team: $po,
  you: wpo,
  or_continue_with: kpo,
  resend_email: Spo,
  member_already_invited: Epo,
  already_in_use_error: xpo,
  enter_email_or_username: Cpo,
  enter_email: Tpo,
  enter_emails: Apo,
  too_many_invites: Ipo,
  team_name_taken: Opo,
  must_enter_team_name: Npo,
  team_url_required: zpo,
  url_taken: Rpo,
  problem_registering_domain: Ppo,
  team_publish: Dpo,
  number_text_notifications: Lpo,
  number_sms_notifications: Mpo,
  attendee_email_variable: Fpo,
  attendee_email_info: qpo,
  booking_uid: jpo,
  kbar_search_placeholder: Vpo,
  invalid_credential: Bpo,
  invalid_credential_action: Upo,
  reschedule_reason: Gpo,
  choose_common_schedule_team_event: Wpo,
  choose_common_schedule_team_event_description: Hpo,
  reason: Ypo,
  sender_id: Kpo,
  sender_id_error_message: Zpo,
  test_routing_form: Xpo,
  test_preview: Jpo,
  route_to: Qpo,
  test_preview_description: emo,
  test_routing: tmo,
  payment_app_disabled: nmo,
  edit_event_type: omo,
  only_admin_can_see_members_of_org: rmo,
  only_admin_can_manage_sso_org: imo,
  only_admin_can_manage_directory_sync: amo,
  only_admin_can_manage_oauth_clients: smo,
  collective_scheduling: cmo,
  make_it_easy_to_book: lmo,
  find_the_best_person: umo,
  fixed_round_robin: dmo,
  add_one_fixed_attendee: _mo,
  calcom_is_better_with_team: pmo,
  the_calcom_team: mmo,
  add_your_team_members: fmo,
  booking_limit_reached: gmo,
  duration_limit_reached: hmo,
  admin_has_disabled: vmo,
  disable_attendees_emails_description: bmo,
  disabled_app_affects_event_type: ymo,
  event_replaced_notice: $mo,
  email_subject_slug_replacement: wmo,
  email_body_slug_replacement_notice: kmo,
  email_body_slug_replacement_info: Smo,
  email_body_slug_replacement_suggestion: Emo,
  disable_payment_app: xmo,
  payment_disabled_still_able_to_book: Cmo,
  app_disabled_with_event_type: Tmo,
  app_disabled_video: Amo,
  app_disabled_subject: Imo,
  navigate_installed_apps: Omo,
  disabled_calendar: Nmo,
  enable_apps: zmo,
  enable_apps_description: Rmo,
  purchase_license: Pmo,
  already_have_account: Dmo,
  already_have_key: Lmo,
  already_have_key_suggestion: Mmo,
  create_license_key: Fmo,
  app_is_enabled: qmo,
  app_is_disabled: jmo,
  keys_have_been_saved: Vmo,
  disable_app: Bmo,
  disable_app_description: Umo,
  edit_keys: Gmo,
  admin_apps_description: Wmo,
  admin_users_description: Hmo,
  admin_users_add_description: Ymo,
  admin_users_edit_description: Kmo,
  admin_orgs_edit_description: Zmo,
  admin_oAuth_description: Xmo,
  admin_lockedSMS_description: Jmo,
  no_available_apps: Qmo,
  no_available_apps_description: efo,
  no_apps: tfo,
  no_apps_configured: nfo,
  enable_in_settings: ofo,
  please_contact_admin: rfo,
  apps_settings: ifo,
  fill_this_field: afo,
  options: sfo,
  enter_option: cfo,
  add_an_option: lfo,
  location_already_exists: ufo,
  radio: dfo,
  google_meet_warning: _fo,
  individual: pfo,
  all_bookings_filter_label: mfo,
  all_users_filter_label: ffo,
  all_event_types_filter_label: gfo,
  your_bookings_filter_label: hfo,
  meeting_url_variable: vfo,
  meeting_url_info: bfo,
  date_overrides: yfo,
  date_overrides_delete_on_date: $fo,
  date_overrides_subtitle: wfo,
  date_overrides_info: kfo,
  date_overrides_dialog_which_hours: Sfo,
  date_overrides_dialog_which_hours_unavailable: Efo,
  date_overrides_dialog_title: xfo,
  date_overrides_unavailable: Cfo,
  date_overrides_mark_all_day_unavailable_one: Tfo,
  date_overrides_mark_all_day_unavailable_other: Afo,
  date_overrides_update_btn: Ifo,
  date_successfully_added: Ofo,
  date_overrides_save_btn: Nfo,
  event_type_duplicate_copy_text: zfo,
  set_as_default: Rfo,
  hide_eventtype_details: Pfo,
  show_navigation: Dfo,
  hide_navigation: Lfo,
  verification_code_sent: Mfo,
  verified_successfully: Ffo,
  wrong_code: qfo,
  not_verified: jfo,
  no_availability_in_month: Vfo,
  no_availability_rolling: Bfo,
  no_availability_range: Ufo,
  view_previous_month: Gfo,
  view_next_month: Wfo,
  send_code: Hfo,
  number_verified: Yfo,
  create_your_first_team_webhook_description: Kfo,
  create_webhook_team_event_type: Zfo,
  disable_success_page: Xfo,
  invalid_admin_password: Jfo,
  change_password_admin: Qfo,
  username_already_taken: ego,
  assignment: tgo,
  fixed_hosts: ngo,
  add_fixed_hosts: ogo,
  round_robin_hosts: rgo,
  minimum_round_robin_hosts_count: igo,
  hosts: ago,
  upgrade_to_enable_feature: sgo,
  orgs_upgrade_to_enable_feature: cgo,
  new_attendee: lgo,
  awaiting_approval: ugo,
  requires_google_calendar: dgo,
  event_type_requires_google_calendar: _go,
  connected_google_calendar: pgo,
  using_meet_requires_calendar: mgo,
  continue_to_install_google_calendar: fgo,
  install_google_meet: ggo,
  install_google_calendar: hgo,
  sender_name: vgo,
  already_invited: bgo,
  no_recordings_found: ygo,
  new_workflow_subtitle: $go,
  reporting: wgo,
  reporting_feature: kgo,
  teams_plan_required: Sgo,
  routing_forms_are_a_great_way: Ego,
  choose_a_license: xgo,
  choose_license_description: Cgo,
  license: Tgo,
  agplv3_license: Ago,
  no_need_to_keep_your_code_open_source: Igo,
  repackage_rebrand_resell: Ogo,
  a_vast_suite_of_enterprise_features: Ngo,
  free_license_fee: zgo,
  forever_open_and_free: Rgo,
  required_to_keep_your_code_open_source: Pgo,
  cannot_repackage_and_resell: Dgo,
  no_enterprise_features: Lgo,
  step_enterprise_license: Mgo,
  step_enterprise_license_description: Fgo,
  setup: qgo,
  setup_description: jgo,
  configure: Vgo,
  sso_configuration: Bgo,
  sso_configuration_description: Ugo,
  sso_configuration_description_orgs: Ggo,
  sso_oidc_heading: Wgo,
  sso_oidc_description: Hgo,
  sso_oidc_configuration_title: Ygo,
  sso_oidc_configuration_description: Kgo,
  sso_oidc_callback_copied: Zgo,
  sso_saml_heading: Xgo,
  sso_saml_description: Jgo,
  sso_saml_configuration_title: Qgo,
  sso_saml_configuration_description: eho,
  sso_saml_acsurl_copied: tho,
  sso_saml_entityid_copied: nho,
  sso_connection_created_successfully: oho,
  sso_connection_deleted_successfully: rho,
  delete_sso_configuration: iho,
  delete_sso_configuration_confirmation: aho,
  delete_sso_configuration_confirmation_description: sho,
  organizer_timezone: cho,
  email_user_cta: lho,
  accept_invite: uho,
  join_now: dho,
  successfully_joined: _ho,
  email_no_user_invite_heading_subteam: pho,
  email_no_user_invite_heading_org: mho,
  email_no_user_invite_subheading: fho,
  email_user_invite_subheading_subteam: gho,
  email_user_invite_subheading_org: hho,
  email_no_user_invite_steps_intro: vho,
  email_no_user_step_one: bho,
  email_no_user_step_two: yho,
  email_no_user_step_three: $ho,
  email_no_user_step_four: who,
  email_no_user_signoff: kho,
  impersonation_user_tip: Sho,
  available_variables: Eho,
  scheduler: xho,
  no_workflows: Cho,
  change_filter: Tho,
  change_filter_common: Aho,
  no_results_for_filter: Iho,
  recommended_next_steps: Oho,
  create_a_managed_event: Nho,
  meetings_are_better_with_the_right: zho,
  create_a_one_one_template: Rho,
  collective_or_roundrobin: Pho,
  book_your_team_members: Dho,
  event_no_longer_attending_subject: Lho,
  no_longer_attending: Mho,
  attendee_no_longer_attending_subject: Fho,
  attendee_no_longer_attending: qho,
  attendee_no_longer_attending_subtitle: jho,
  create_event_on: Vho,
  create_routing_form_on: Bho,
  default_app_link_title: Uho,
  default_app_link_description: Gho,
  organizer_default_conferencing_app: Who,
  organizer_default_conferencing_app_not_found: Hho,
  under_maintenance: Yho,
  under_maintenance_description: Kho,
  event_type_seats: Zho,
  booking_questions_title: Xho,
  booking_questions_description: Jho,
  add_a_booking_question: Qho,
  identifier: evo,
  duplicate_email: tvo,
  enter_redirect_url_on_exit_description: nvo,
  booking_with_payment_cancelled: ovo,
  booking_with_payment_cancelled_already_paid: rvo,
  booking_with_payment_cancelled_refunded: ivo,
  booking_with_payment_cancelled_no_refund: avo,
  booking_with_payment_cancelled_refund_window_expired: svo,
  booking_confirmation_failed: cvo,
  not_enough_seats: lvo,
  form_builder_field_already_exists: uvo,
  guests_field_must_be_multiemail: dvo,
  show_on_booking_page: _vo,
  visit_cancelled_booking: pvo,
  get_started_zapier_templates: mvo,
  standard_templates: fvo,
  cal_ai_templates: gvo,
  team_is_unpublished: hvo,
  org_is_unpublished_description: vvo,
  team_is_unpublished_description: bvo,
  team_member: yvo,
  a_routing_form: $vo,
  form_description_placeholder: wvo,
  keep_me_connected_with_form: kvo,
  fields_in_form_duplicated: Svo,
  form_deleted: Evo,
  delete_form: xvo,
  delete_form_action: Cvo,
  delete_form_confirmation: Tvo,
  delete_form_confirmation_2: Avo,
  typeform_redirect_url_copied: Ivo,
  modifications_in_fields_warning: Ovo,
  connected_forms: Nvo,
  form_modifications_warning: zvo,
  responses_collection_waiting_description: Rvo,
  this_is_what_your_users_would_see: Pvo,
  identifies_name_field: Dvo,
  add_1_option_per_line: Lvo,
  select_a_router: Mvo,
  add_a_new_route: Fvo,
  make_informed_decisions: qvo,
  make_informed_decisions_description: jvo,
  view_bookings_across: Vvo,
  view_bookings_across_description: Bvo,
  identify_booking_trends: Uvo,
  identify_booking_trends_description: Gvo,
  spot_popular_event_types: Wvo,
  spot_popular_event_types_description: Hvo,
  no_responses_yet: Yvo,
  no_routes_defined: Kvo,
  this_will_be_the_placeholder: Zvo,
  error_booking_event: Xvo,
  timeslot_missing_title: Jvo,
  timeslot_missing_description: Qvo,
  timeslot_missing_cta: ebo,
  switch_monthly: tbo,
  switch_weekly: nbo,
  switch_multiday: obo,
  switch_columnview: rbo,
  num_locations: ibo,
  select_on_next_step: abo,
  this_meeting_has_not_started_yet: sbo,
  this_app_requires_connected_account: cbo,
  connect_app: lbo,
  app_is_connected: ubo,
  requires_app: dbo,
  verification_code: _bo,
  can_you_try_again: pbo,
  verify: mbo,
  timezone_info: fbo,
  timezone_variable: gbo,
  event_end_time_variable: hbo,
  event_end_time_info: vbo,
  cancel_url_variable: bbo,
  cancel_url_info: ybo,
  cancel_reason_variable: $bo,
  cancel_reason_info: wbo,
  reschedule_url_variable: kbo,
  reschedule_url_info: Sbo,
  reschedule_reason_variable: Ebo,
  reschedule_reason_info: xbo,
  invalid_event_name_variables: Cbo,
  select_all: Tbo,
  default_conferencing_bulk_title: Abo,
  members_default_schedule: Ibo,
  set_by_admin: Obo,
  members_default_location: Nbo,
  members_default_schedule_description: zbo,
  requires_at_least_one_schedule: Rbo,
  default_conferencing_bulk_description: Pbo,
  default_schedules_bulk_description: Dbo,
  locked_for_members: Lbo,
  unlocked_for_members: Mbo,
  apps_locked_for_members_description: Fbo,
  apps_unlocked_for_members_description: qbo,
  apps_locked_by_team_admins_description: jbo,
  apps_unlocked_by_team_admins_description: Vbo,
  workflows_locked_for_members_description: Bbo,
  workflows_unlocked_for_members_description: Ubo,
  workflows_locked_by_team_admins_description: Gbo,
  workflows_unlocked_by_team_admins_description: Wbo,
  webhooks_locked_for_members_description: Hbo,
  webhooks_unlocked_for_members_description: Ybo,
  webhooks_locked_by_team_admins_description: Kbo,
  webhooks_unlocked_by_team_admins_description: Zbo,
  locked_by_team_admin: Xbo,
  app_not_connected: Jbo,
  connect_now: Qbo,
  managed_event_dialog_confirm_button_one: eyo,
  managed_event_dialog_confirm_button_other: tyo,
  managed_event_dialog_title_one: nyo,
  managed_event_dialog_title_other: oyo,
  managed_event_dialog_information_one: ryo,
  managed_event_dialog_information_other: iyo,
  managed_event_dialog_clarification: ayo,
  review_event_type: syo,
  looking_for_more_analytics: cyo,
  looking_for_more_insights: lyo,
  filters: uyo,
  filter: dyo,
  add_a_member: _yo,
  add_filter: pyo,
  add_rule: myo,
  add_rule_group: fyo,
  remove_filters: gyo,
  email_verified: hyo,
  select_user: vyo,
  select_event_type: byo,
  select_date_range: yyo,
  popular_events: $yo,
  no_event_types_found: wyo,
  average_event_duration: kyo,
  bookings_by_hour: Syo,
  most_booked_members: Eyo,
  least_booked_members: xyo,
  most_bookings_scheduled: Cyo,
  least_bookings_scheduled: Tyo,
  most_bookings_completed: Ayo,
  least_bookings_completed: Iyo,
  events_created: Oyo,
  events_completed: Nyo,
  events_cancelled: zyo,
  events_rescheduled: Ryo,
  events: Pyo,
  performance: Dyo,
  from_last_period: Lyo,
  from_to_date_period: Myo,
  redirect_url_warning: Fyo,
  event_trends: qyo,
  clear_filters: jyo,
  clear: Vyo,
  hold: Byo,
  on_booking_option: Uyo,
  hold_option: Gyo,
  card_held: Wyo,
  charge_card: Hyo,
  card_charged: Yyo,
  no_show_fee_amount: Kyo,
  no_show_fee: Zyo,
  submit_card: Xyo,
  submit_payment_information: Jyo,
  meeting_awaiting_payment_method: Qyo,
  no_show_fee_charged_email_subject: e$o,
  no_show_fee_charged_text_body: t$o,
  no_show_fee_charged_subtitle: n$o,
  error_charging_card: o$o,
  collect_no_show_fee: r$o,
  no_show_fee_charged: i$o,
  your_card_was_declined: a$o,
  your_card_does_not_support_this_type_of_purchase: s$o,
  amount_must_convert_to_at_least: c$o,
  could_not_charge_card: l$o,
  insights: u$o,
  routing_forms: d$o,
  insights_no_data_found_for_filter: _$o,
  acknowledge_booking_no_show_fee: p$o,
  days: m$o,
  card_details: f$o,
  something_went_wrong_on_our_end: g$o,
  please_provide_following_text_to_suppport: h$o,
  seats_and_no_show_fee_error: v$o,
  complete_your_booking: b$o,
  complete_your_booking_subject: y$o,
  confirm_your_details: $$o,
  copy_invite_link: w$o,
  edit_invite_link: k$o,
  invite_link_copied: S$o,
  invite_link_deleted: E$o,
  api_key_deleted: x$o,
  delete_api_key_warning: C$o,
  invite_link_updated: T$o,
  link_expires_after: A$o,
  one_day: I$o,
  seven_days: O$o,
  thirty_days: N$o,
  three_months: z$o,
  one_year: R$o,
  team_invite_received: P$o,
  currency_string: D$o,
  charge_card_dialog_body: L$o,
  charge_attendee: M$o,
  payment_app_commission: F$o,
  email_invite_team: q$o,
  email_invite_team_bulk: j$o,
  error_collecting_card: V$o,
  image_size_limit_exceed: B$o,
  unauthorized_workflow_error_message: U$o,
  inline_embed: G$o,
  load_inline_content: W$o,
  floating_pop_up_button: H$o,
  floating_button_trigger_modal: Y$o,
  pop_up_element_click: K$o,
  open_dialog_with_element_click: Z$o,
  use_my_own_form: X$o,
  use_our_headless_routing_api: J$o,
  need_help_embedding: Q$o,
  book_my_cal: ewo,
  first_name: two,
  last_name: nwo,
  first_last_name: owo,
  invite_as: rwo,
  form_updated_successfully: iwo,
  disable_attendees_confirmation_emails: awo,
  disable_attendees_confirmation_emails_description: swo,
  disable_host_confirmation_emails: cwo,
  disable_host_confirmation_emails_description: lwo,
  add_an_override: uwo,
  import_from_google_workspace: dwo,
  connect_google_workspace: _wo,
  google_workspace_admin_tooltip: pwo,
  first_event_type_webhook_description: mwo,
  create_instant_meeting_webhook_description: fwo,
  install_app_on: gwo,
  create_for: hwo,
  currency: vwo,
  organization_banner_description: bwo,
  organization_banner_title: ywo,
  set_up_your_organization: $wo,
  set_up_your_platform_organization: wwo,
  organizations_description: kwo,
  plans: Swo,
  platform: Ewo,
  platform_description: xwo,
  platform_organization_description: Cwo,
  must_enter_organization_name: Two,
  must_enter_organization_admin_email: Awo,
  admin_email: Iwo,
  platform_admin_email: Owo,
  admin_username: Nwo,
  organization_name: zwo,
  platform_name: Rwo,
  organization_url: Pwo,
  organization_verify_header: Dwo,
  organization_verify_email_body: Lwo,
  additional_url_parameters: Mwo,
  about_your_organization: Fwo,
  about_your_organization_description: qwo,
  create_your_teams: jwo,
  create_your_teams_description: Vwo,
  invite_organization_admins: Bwo,
  invite_organization_admins_description: Uwo,
  set_a_password: Gwo,
  set_a_password_description: Wwo,
  organization_logo: Hwo,
  organization_about_description: Ywo,
  ill_do_this_later: Kwo,
  verify_your_email: Zwo,
  enter_digit_code: Xwo,
  verify_email_organization: Jwo,
  code_provided_invalid: Qwo,
  email_already_used: eko,
  organization_admin_invited_heading: tko,
  organization_admin_invited_body: nko,
  duplicated_slugs_warning: oko,
  team_names_empty: rko,
  team_names_repeated: iko,
  user_belongs_organization: ako,
  org_no_teams_yet: sko,
  org_no_teams_yet_description: cko,
  set_up: lko,
  my_profile: uko,
  my_settings: dko,
  crm: _ko,
  messaging: pko,
  sender_id_info: mko,
  org_admins_can_create_new_teams: fko,
  google_new_spam_policy: gko,
  resolve: hko,
  no_organization_slug: vko,
  copy_link_org: bko,
  "404_the_org": "La organización",
  "404_the_team": "El equipo",
  "404_claim_entity_org": "Reclame su subdominio para su organización",
  "404_claim_entity_team": "Reclame este equipo y empiece a gestionar los horarios de forma colectiva",
  insights_team_filter: yko,
  insights_user_filter: $ko,
  insights_subtitle: wko,
  call_history: kko,
  call_history_subtitle: Sko,
  location_options: Eko,
  channel_type: xko,
  end_reason: Cko,
  session_status: Tko,
  user_sentiment: Ako,
  time_header: Iko,
  from_header: Oko,
  custom_plan: Nko,
  email_embed: zko,
  add_times_to_your_email: Rko,
  select_time: Pko,
  select_date: Dko,
  only_show_if_parameter_set: Lko,
  add_parameter: Mko,
  connecting_you_to_someone: Fko,
  please_do_not_close_this_tab: qko,
  see_all_available_times: jko,
  org_team_names_example_1: Vko,
  org_team_names_example_2: Bko,
  org_team_names_example_3: Uko,
  org_team_names_example_4: Gko,
  org_team_names_example_5: Wko,
  org_max_team_warnings: Hko,
  what_is_this_meeting_about: Yko,
  add_to_team: Kko,
  remove_users_from_org: Zko,
  delegation_credential: Xko,
  delegation_credential_description: Jko,
  add_client_id_in_google_workspace_with_below_scope: Qko,
  delegation_credential_enabled: e0o,
  add_delegation_credential: t0o,
  edit_delegation_credential: n0o,
  domain: o0o,
  no_workspace_platforms: r0o,
  workspace_platform: i0o,
  workspace_platforms: a0o,
  workspace_platforms_description: s0o,
  edit_workspace_platform: c0o,
  edit_service_account: l0o,
  add_workspace_platform: u0o,
  slug: d0o,
  service_account_key: _0o,
  edit_service_account_key: p0o,
  delegation_credential_restricts_adding_more_than_one_installation: m0o,
  app_successfully_installed_and_is_using_delegated_credentials: f0o,
  remove_users_from_org_confirm: g0o,
  remove_users_from_team: h0o,
  remove_users_from_team_confirm: v0o,
  user_has_no_schedules: b0o,
  user_isnt_in_any_teams: y0o,
  user_has_no_app_installed: $0o,
  requires_booker_email_verification: w0o,
  description_requires_booker_email_verification: k0o,
  requires_confirmation_mandatory: S0o,
  organizations: E0o,
  upload_cal_video_logo: x0o,
  update_cal_video_logo: C0o,
  upload_banner: T0o,
  cal_video_logo_upload_instruction: A0o,
  org_admin_other_teams: I0o,
  org_admin_other_teams_description: O0o,
  not_part_of_org: N0o,
  no_other_teams_found: z0o,
  no_other_teams_found_description: R0o,
  attendee_first_name_variable: P0o,
  attendee_last_name_variable: D0o,
  attendee_first_name_info: L0o,
  attendee_last_name_info: M0o,
  your_monthly_digest: F0o,
  member_name: q0o,
  most_popular_events: j0o,
  summary_of_events_for_your_team_for_the_last_30_days: V0o,
  me: B0o,
  meeting_unavailable: U0o,
  monthly_digest_email: G0o,
  monthly_digest_email_for_teams: W0o,
  verify_team_tooltip: H0o,
  member_removed: Y0o,
  my_availability: K0o,
  team_availability: Z0o,
  instant_meeting_availability: X0o,
  backup_code: J0o,
  backup_codes: Q0o,
  backup_code_instructions: e1o,
  backup_codes_copied: t1o,
  incorrect_backup_code: n1o,
  lost_access: o1o,
  missing_backup_codes: r1o,
  admin_org_notification_email_subject: i1o,
  hi_admin: a1o,
  admin_org_notification_email_title: s1o,
  admin_org_notification_email_body_part1: c1o,
  admin_org_notification_email_body_part2: l1o,
  admin_org_notification_email_body_part3: u1o,
  admin_org_notification_email_cta: d1o,
  org_has_been_processed: _1o,
  org_error_processing: p1o,
  orgs_page_description: m1o,
  unverified: f1o,
  verified: g1o,
  dns_missing: h1o,
  dns_configured: v1o,
  mark_dns_configured: b1o,
  value: y1o,
  your_organization_updated_sucessfully: $1o,
  team_no_event_types: w1o,
  seat_options_doesnt_multiple_durations: k1o,
  include_calendar_event: S1o,
  oAuth: E1o,
  oAuth_client_creation_form: x1o,
  oAuth_client_creation_form_description: C1o,
  oAuth_client_updation_form: T1o,
  oAuth_client_updation_form_description: A1o,
  recently_added: I1o,
  connect_all_calendars: O1o,
  connect_all_calendars_description: N1o,
  workflow_automation_description: z1o,
  scheduling_for_your_team: R1o,
  scheduling_for_your_team_description: P1o,
  no_members_found: D1o,
  directory_sync: L1o,
  directory_name: M1o,
  directory_provider: F1o,
  directory_scim_url: q1o,
  directory_scim_token: j1o,
  directory_scim_url_copied: V1o,
  directory_scim_token_copied: B1o,
  directory_sync_info_description: U1o,
  directory_sync_configure: G1o,
  directory_sync_configure_description: W1o,
  directory_sync_title: H1o,
  directory_sync_created: Y1o,
  directory_sync_description: K1o,
  directory_sync_deleted: Z1o,
  directory_sync_delete_connection: X1o,
  directory_sync_delete_title: J1o,
  directory_sync_delete_description: Q1o,
  directory_sync_delete_confirmation: eSo,
  event_setup_length_error: tSo,
  availability_schedules: nSo,
  unauthorized: oSo,
  access_cal_account: rSo,
  select_account_team: iSo,
  allow_client_to: aSo,
  associate_with_cal_account: sSo,
  see_personal_info: cSo,
  see_primary_email_address: lSo,
  connect_installed_apps: uSo,
  access_event_type: dSo,
  access_availability: _So,
  access_bookings: pSo,
  allow_client_to_do: mSo,
  oauth_access_information: fSo,
  allow: gSo,
  view_only_edit_availability_not_onboarded: hSo,
  view_only_edit_availability: vSo,
  you_can_override_calendar_in_advanced_tab: bSo,
  edit_users_availability: ySo,
  resend_invitation: $So,
  invitation_resent: wSo,
  saml_sso: kSo,
  add_client: SSo,
  copy_client_secret_info: ESo,
  add_new_client: xSo,
  add_new_user: CSo,
  this_app_is_not_setup_already: TSo,
  as_csv: ASo,
  overlay_my_calendar: ISo,
  overlay_my_calendar_toc: OSo,
  view_overlay_calendar_events: NSo,
  join_event_location: zSo,
  troubleshooting: RSo,
  calendars_were_checking_for_conflicts: PSo,
  availabilty_schedules: DSo,
  manage_calendars: LSo,
  manage_availability_schedules: MSo,
  locked: FSo,
  unlocked: qSo,
  lock_timezone_toggle_on_booking_page: jSo,
  description_lock_timezone_toggle_on_booking_page: VSo,
  event_setup_multiple_payment_apps_error: BSo,
  number_in_international_format: USo,
  install_calendar: GSo,
  branded_subdomain: WSo,
  branded_subdomain_description: HSo,
  org_insights: YSo,
  org_insights_description: KSo,
  extensive_whitelabeling: ZSo,
  extensive_whitelabeling_description: XSo,
  unlimited_teams: JSo,
  verify_email: QSo,
  proceed_with_cancellation_description: eEo,
  proceed_with_cancellation_error: tEo,
  unlimited_teams_description: nEo,
  unified_billing: oEo,
  advanced_managed_events: rEo,
  advanced_managed_events_description: iEo,
  enterprise: aEo,
  enterprise_description: sEo,
  create_your_org: cEo,
  create_org: lEo,
  create_your_org_description: uEo,
  create_your_enterprise_description: dEo,
  other_payment_app_enabled: _Eo,
  admin_delete_organization_description_1: pEo,
  admin_delete_organization_description_2: mEo,
  admin_delete_organization_description_3: fEo,
  admin_delete_organization_description_4: gEo,
  admin_delete_organization_title: hEo,
  published: vEo,
  unpublished: bEo,
  publish: yEo,
  troubleshooter_tooltip: $Eo,
  need_help: wEo,
  troubleshooter: kEo,
  number_to_call: SEo,
  guest_name: EEo,
  guest_email: xEo,
  guest_company: CEo,
  please_install_a_calendar: TEo,
  instant_tab_title: AEo,
  instant_event_tab_description: IEo,
  uprade_to_create_instant_bookings: OEo,
  dont_want_to_wait: NEo,
  meeting_started: zEo,
  pay_and_book: REo,
  cal_ai_event_tab_description: PEo,
  booking_not_found_error: DEo,
  booking_seats_full_error: LEo,
  missing_payment_credential_error: MEo,
  missing_payment_app_id_error: FEo,
  not_enough_available_seats_error: qEo,
  user_redirect_title: jEo,
  user_redirect_description: VEo,
  out_of_office: BEo,
  out_of_office_description: UEo,
  send_request: GEo,
  start_date_and_end_date_required: WEo,
  start_date_must_be_before_end_date: HEo,
  start_date_must_be_in_the_future: YEo,
  user_not_found: KEo,
  cannot_redirect_to_self: ZEo,
  out_of_office_entry_already_exists: XEo,
  out_of_office_id_required: JEo,
  booking_redirect_infinite_not_allowed: QEo,
  success_entry_created: exo,
  booking_redirect_email_subject: txo,
  booking_redirect_email_title: nxo,
  booking_redirect_email_description: oxo,
  booking_redirect_updated_email_subject: rxo,
  booking_redirect_updated_email_title: ixo,
  booking_redirect_updated_email_description: axo,
  booking_redirect_cancelled_email_subject: sxo,
  booking_redirect_cancelled_email_title: cxo,
  booking_redirect_cancelled_email_description: lxo,
  success_accept_booking_redirect: uxo,
  success_reject_booking_redirect: dxo,
  copy_link_booking_redirect_request: _xo,
  booking_redirect_request_title: pxo,
  select_team_member: mxo,
  going_away_title: fxo,
  redirect_team_enabled: gxo,
  redirect_team_disabled: hxo,
  out_of_office_unavailable_list: vxo,
  success_deleted_entry_out_of_office: bxo,
  success_edited_entry_out_of_office: yxo,
  temporarily_out_of_office: $xo,
  add_a_redirect: wxo,
  create_entry: kxo,
  time_range: Sxo,
  automatically_add_all_team_members: Exo,
  redirect_to: xxo,
  having_trouble_finding_time: Cxo,
  show_more: Txo,
  forward_params_redirect: Axo,
  assignment_description: Ixo,
  lowest: Oxo,
  low: Nxo,
  medium: zxo,
  high: Rxo,
  Highest: Pxo,
  send_booker_to: Dxo,
  set_priority: Lxo,
  set_weight: Mxo,
  enable_weights: Fxo,
  priority_for_user: qxo,
  weights_description: jxo,
  weight_for_user: Vxo,
  change_priority: Bxo,
  field_identifiers_as_variables: Uxo,
  field_identifiers_as_variables_with_example: Gxo,
  account_already_linked: Wxo,
  send_email: Hxo,
  cal_ai_phone_call_action: Yxo,
  call_to_confirm_booking: Kxo,
  cal_ai_phone_call_action_description: Zxo,
  cal_ai_agent_configuration: Xxo,
  choose_at_least_one_event_type_test_call: Jxo,
  mark_as_no_show: Qxo,
  unmark_as_no_show: eCo,
  account_unlinked_success: tCo,
  account_unlinked_error: nCo,
  travel_schedule: oCo,
  travel_schedule_description: rCo,
  schedule_timezone_change: iCo,
  date: aCo,
  enter_the_general_prompt_for_the_agent: sCo,
  overlaps_with_existing_schedule: cCo,
  "org_admin_no_slots|heading": "No se encontró disponibilidad para {{name}}",
  "org_admin_no_slots|content": "Hola Administradores de la Organización,<br /><br />Nota: Se ha señalado a nuestra atención que {{username}} no ha tenido disponibilidad cuando un usuario ha visitado {{username}}/{{slug}}<br /><br />Hay algunas razones por las que esto podría estar sucediendo<br />El usuario no tiene calendarios conectados<br />Sus horarios adjuntos a este evento no están habilitados<br /> <br />Recomendamos verificar su disponibilidad para resolver esto.",
  "org_admin_no_slots|cta": "Abrir disponibilidad de usuarios",
  organization_no_slots_notification_switch_title: lCo,
  organization_no_slots_notification_switch_description: uCo,
  organization_disable_phone_only_sms_notifications_switch_title: dCo,
  organization_disable_phone_only_sms_notifications_switch_description: _Co,
  "email_team_invite|subject|added_to_org": "{{user}} te ha añadido a la organización {{team}} en {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} te ha invitado a unirte a la organización {{team}} en {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} te ha añadido al equipo {{team}} de la organización {{parentTeamName}} en {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} te invitó a unirte al equipo {{team}} en {{appName}}",
  "email_team_invite|heading|added_to_org": "Has sido añadido a una organización de {{appName}}",
  "email_team_invite|heading|invited_to_org": "Has sido invitado a una organización de {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Has sido añadido a un equipo de la organización {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Has sido invitado a un equipo de la organización {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Has sido invitado a unirte a un equipo de {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} te ha añadido a la organización <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} te ha invitado a unirte a la organización {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} te ha invitado a unirte al equipo {{team}} de la organización {{parentTeamName}} en {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} te ha añadido al equipo <strong>{{teamName}}</strong> en su organización {{parentTeamName}}. {{appName}} es el programador de eventos que permite a ti y a tu equipo agendar reuniones sin el ir y venir de correos electrónicos.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} te ha invitado a unirte al equipo <strong>{{teamName}}</strong> en su organización {{parentTeamName}}. {{appName}} es el programador de eventos que permite a ti y a tu equipo agendar reuniones sin el ir y venir de correos electrónicos.",
  "email_team_invite|content|invited_to_regular_team": '{{invitedBy}} lo ha invitado a unirse a su equipo "{{teamName}}" en {{appName}}. {{appName}} es el planificador de eventos que le permite a usted y a su equipo programar reuniones sin correos electrónicos de ida y vuelta.',
  "email|existing_user_added_link_will_change": "Al aceptar la invitación, tu enlace cambiará al dominio de tu organización, pero no te preocupes, todos los enlaces anteriores seguirán funcionando y redireccionando adecuadamente.<br /><br />Ten en cuenta: Todos tus tipos de eventos personales se moverán a la organización <strong>{{teamName}}</strong>, lo que también puede incluir un posible enlace personal. <br /><br />Para eventos personales, recomendamos crear una nueva cuenta con una dirección de correo electrónico personal.",
  "email|existing_user_added_link_changed": "Tu enlace ha cambiado de {{a0}} a {{a1}} pero no te preocupes, todos los enlaces anteriores siguen funcionando y redireccionando adecuadamente. <br /><br />Ten en cuenta: Todos tus tipos de eventos personales se han movido a la organización <strong>{{teamName}}</strong>, lo que también puede incluir un posible enlace personal.<br /><br />Por favor, inicia sesión y asegúrate de que no tienes eventos privados en tu nueva cuenta organizacional.<br /><br />Para eventos personales, recomendamos crear una nueva cuenta con una dirección de correo electrónico personal.<br /><br />Disfruta de tu nuevo enlace limpio: {{a2}}",
  "email_organization_created|subject": "Tu organización ha sido creada",
  your_current_plan: pCo,
  organization_price_per_user_month: mCo,
  privacy_organization_description: fCo,
  privacy: gCo,
  team_will_be_under_org: hCo,
  add_group_name: vCo,
  group_name: bCo,
  routers: yCo,
  primary: $Co,
  make_primary: wCo,
  add_email: kCo,
  add_emails: SCo,
  add_email_description: ECo,
  confirm_email: xCo,
  confirming_your_booking_sms: CCo,
  scheduler_first_name: TCo,
  scheduler_last_name: ACo,
  scheduler_name: ICo,
  organizer_first_name: OCo,
  confirm_email_description: NCo,
  send_event_details_to: zCo,
  schedule_tz_without_end_date: RCo,
  select_members: PCo,
  lock_event_types_modal_header: DCo,
  org_delete_event_types_org_admin: LCo,
  org_hide_event_types_org_admin: MCo,
  hide_org_eventtypes: FCo,
  delete_org_eventtypes: qCo,
  lock_org_users_eventtypes: jCo,
  lock_org_users_eventtypes_description: VCo,
  add_to_event_type: BCo,
  create_account_password: UCo,
  create_account_with_saml: GCo,
  error_creating_account_password: WCo,
  cannot_create_account_password_cal_provider: HCo,
  cannot_create_account_password_already_existing: YCo,
  create_account_password_hint: KCo,
  disconnect_account: ZCo,
  disconnect_account_hint: XCo,
  cookie_consent_checkbox: JCo,
  make_a_call: QCo,
  skip_rr_assignment_label: eTo,
  skip_rr_description: tTo,
  select_account_header: nTo,
  select_account_description: oTo,
  select_event_types_header: rTo,
  select_event_types_description: iTo,
  configure_app_header: aTo,
  configure_app_description: sTo,
  already_installed: cTo,
  ooo_reasons_unspecified: lTo,
  ooo_reasons_vacation: uTo,
  ooo_reasons_travel: dTo,
  ooo_reasons_sick_leave: _To,
  ooo_reasons_public_holiday: pTo,
  ooo_forwarding_to: mTo,
  ooo_not_forwarding: fTo,
  ooo_empty_title: gTo,
  ooo_empty_description: hTo,
  ooo_user_is_ooo: vTo,
  ooo_slots_returning: bTo,
  ooo_slots_book_with: yTo,
  ooo_select_reason: $To,
  create_an_out_of_office: wTo,
  edit_an_out_of_office: kTo,
  submit_feedback: STo,
  host_no_show: ETo,
  no_show_description: xTo,
  how_can_we_improve: CTo,
  most_liked: TTo,
  review: ATo,
  reviewed: ITo,
  unreviewed: OTo,
  rating_url_variable: NTo,
  rating_url_info: zTo,
  no_show_url_variable: RTo,
  no_show_url_info: PTo,
  no_support_needed: DTo,
  hide_support: LTo,
  event_ratings: MTo,
  event_no_show: FTo,
  event_no_show_guest: qTo,
  recent_ratings: jTo,
  no_ratings: VTo,
  no_ratings_description: BTo,
  most_no_show_host: UTo,
  highest_rated: GTo,
  lowest_rated: WTo,
  highest_rated_members: HTo,
  lowest_rated_members: YTo,
  csat_score: KTo,
  lockedSMS: ZTo,
  leave_without_assigning_anyone: XTo,
  leave_without_adding_attendees: JTo,
  no_availability_shown_to_bookers: QTo,
  go_back_and_assign: eAo,
  leave_without_assigning: tAo,
  signing_up_terms: nAo,
  proceeding_agreement: oAo,
  terms: rAo,
  always_show_x_days: iAo,
  always_show_x_days_description: aAo,
  team_subscription_cancelled_successfully: sAo,
  team_subscription_cancellation_error: cAo,
  unable_to_subscribe_to_the_platform: lAo,
  updating_oauth_client_error: uAo,
  creating_oauth_client_error: dAo,
  event_type_color: _Ao,
  event_type_color_description: pAo,
  mark_as_no_show_title: mAo,
  x_marked_as_no_show: fAo,
  x_unmarked_as_no_show: gAo,
  team_select_info: hAo,
  team_settings_description: vAo,
  no_show_updated: bAo,
  email_copied: yAo,
  phone_number_copied: $Ao,
  USER_PENDING_MEMBER_OF_THE_ORG: wAo,
  USER_ALREADY_INVITED_OR_MEMBER: kAo,
  USER_MEMBER_OF_OTHER_ORGANIZATION: SAo,
  booking_reassigned: EAo,
  reassign: xAo,
  reassign_to_another_rr_host: CAo,
  assign_team_member: TAo,
  override_team_member_to_assign: AAo,
  no_available_hosts: IAo,
  reassign_round_robin_host: OAo,
  skip_writing_to_calendar: NAo,
  rescheduling_not_possible: zAo,
  event_expired: RAo,
  skip_contact_creation: PAo,
  skip_writing_to_calendar_note: DAo,
  attributes: LAo,
  new_attribute: MAo,
  add_attributes: FAo,
  add_attributes_description: qAo,
  new_option: jAo,
  update_profile: VAo,
  attribute: BAo,
  create_attribute_description: UAo,
  edit_attribute_description: GAo,
  attribute_updated_successfully: WAo,
  attribute_deleted_successfully: HAo,
  attributes_edited_successfully: YAo,
  attribute_meta_description: KAo,
  attributes_edit_description: ZAo,
  back_to_attributes: XAo,
  delete_attribute: JAo,
  delete_attribute_description: QAo,
  disable_all_emails_to_attendees: e2o,
  disable_all_emails_description: t2o,
  disable_all_emails_to_hosts: n2o,
  type_confirm_to_continue: o2o,
  disable_email: r2o,
  grant_admin_api: i2o,
  revoke_admin_api: a2o,
  add_calendar_label: s2o,
  apple_connect_atom_label: c2o,
  apple_connect_atom_already_connected_label: l2o,
  apple_connect_atom_loading_label: u2o,
  google_connect_atom_label: d2o,
  google_connect_atom_already_connected_label: _2o,
  google_connect_atom_loading_label: p2o,
  outlook_connect_atom_label: m2o,
  outlook_connect_atom_already_connected_label: f2o,
  outlook_connect_atom_loading_label: g2o,
  stripe_connect_atom_label: h2o,
  stripe_connect_atom_already_connected_label: v2o,
  stripe_connect_atom_loading_label: b2o,
  booking_question_response_variables: y2o,
  managed_by_teamAdmins: $2o,
  number_of_options: w2o,
  reschedule_with_same_round_robin_host_title: k2o,
  reschedule_with_same_round_robin_host_description: S2o,
  disable_input_if_prefilled: E2o,
  booking_limits: x2o,
  booking_limits_team_description: C2o,
  limit_team_booking_frequency_description: T2o,
  booking_limits_updated_successfully: A2o,
  you_are_unauthorized_to_make_this_change_to_the_booking: I2o,
  delegation_credential_disabled: O2o,
  matching_members: N2o,
  x_matching_members: z2o,
  matching_members_queue_using_attribute_weights: R2o,
  matching_members_queue_using_event_assignee_weights: P2o,
  no_matching_members: D2o,
  no_matching_members_will_fallback_to_all_assigned_members: L2o,
  hide_calendar_event_details: M2o,
  description_hide_calendar_event_details: F2o,
  last_number_of_days: q2o,
  month_to_date: j2o,
  year_to_date: V2o,
  custom_range: B2o,
  refund_policy: U2o,
  always: G2o,
  never: W2o,
  payment_option: H2o,
  if_cancelled: Y2o,
  before: K2o,
  show_all_columns: Z2o,
  toggle_columns: X2o,
  no_columns_found: J2o,
  salesforce_create_record_as: Q2o,
  salesforce_lead: eIo,
  salesforce_contact_under_account: tIo,
  salesforce_skip_entry_creation: nIo,
  salesforce_if_account_does_not_exist: oIo,
  salesforce_create_new_contact_under_account: rIo,
  salesforce_change_record_owner_on_booking: iIo,
  mass_assign_attributes: aIo,
  reroute_preview_custom_message: sIo,
  reroute_preview_external_redirect: cIo,
  reroute_preview_possible_host: lIo,
  current_routing_status: uIo,
  reroute_booking: dIo,
  reroute_booking_description: _Io,
  verify_new_route: pIo,
  reroute: mIo,
  new_routing_status: fIo,
  salesforce_book_directly_with_attendee_owner: gIo,
  salesforce_check_owner_of: hIo,
  account: vIo,
  choose_hosts_schedule: bIo,
  hosts_schedule_description: yIo,
  no_hosts_description: $Io,
  team_member_round_robin_reassign: wIo,
  team_member_round_robin_reassign_description: kIo,
  round_robin_reassign_description: SIo,
  invalid_round_robin_host: EIo,
  user_is_round_robin_fixed: xIo,
  reschedule_with_same_timeslot: CIo,
  reschedule_with_same_timeslot_of_new_event: TIo,
  reschedule_to_the_new_event_with_different_timeslot: AIo,
  reschedule_with_different_timeslot: IIo,
  we_dont_have_id_for_the_new_event: OIo,
  rerouted_booking_successfully_redirecting_to_booking_page: NIo,
  on_booking_write_to_event_object: zIo,
  field_name: RIo,
  add_new_field: PIo,
  you_dont_have_access_to_reroute_this_booking: DIo,
  form_response_not_found: LIo,
  contact_owner: MIo,
  contact_owner_not_found: FIo,
  using_fallback_members: qIo,
  chosen_route: jIo,
  attribute_logic_matched: VIo,
  attribute_logic_fallback_matched: BIo,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: UIo,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: GIo,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: WIo,
  warning: HIo,
  fallback_attribute_logic_description: YIo,
  fallback_attribute_logic_warning: KIo,
  fallback_not_needed: ZIo,
  confirm_reassign_unavailable: XIo,
  confirm_reassign_available: JIo,
  reassign_unavailable_team_member_description: QIo,
  reassign_available_team_member_description: eOo,
  yes_reassign: tOo,
  filter_by_attributes: nOo,
  reassign_reason: oOo,
  field_type_change_suggestion: rOo,
  reassigned_by: iOo,
  row: aOo,
  rows: sOo,
  attendee_timezone_variable: cOo,
  event_start_time_in_attendee_timezone_variable: lOo,
  event_start_time_in_attendee_timezone_info: uOo,
  event_end_time_in_attendee_timezone_info: dOo,
  event_end_time_in_attendee_timezone_variable: _Oo,
  salesforce_create_event_on_contact: pOo,
  salesforce_owner_name_to_change: mOo,
  no_filter_set: fOo,
  booking_dry_run_successful: gOo,
  booking_dry_run_successful_description: hOo,
  dont_have_access_this_page: vOo,
  you_need_admin_or_owner_privileges_to_access: bOo,
  field_type: yOo,
  when_to_write: $Oo,
  salesforce_on_booking_write_to_record: wOo,
  on_every_booking: kOo,
  only_if_field_is_empty: SOo,
  booking_start_date: EOo,
  booking_created_date: xOo,
  booking_reassigned_to_host: COo,
  no_contact_owner: TOo,
  routing_forms_created: AOo,
  routing_forms_total_responses: IOo,
  routing_forms_total_responses_without_booking: OOo,
  routing_forms_total_responses_with_booking: NOo,
  routing_form_insights: zOo,
  routing_form_insights_form_name_header: ROo,
  routing_form_insights_booking_status_header: POo,
  routing_form_insights_response_no_booking: DOo,
  routing_form_insights_booked_by: LOo,
  routing_form_insights_created_at: MOo,
  routing_form_insights_booking_status: FOo,
  routing_form_insights_booking_at: qOo,
  routing_form_insights_submitted_at: jOo,
  copy_redirect_url: VOo,
  redirect_url_on_exit: BOo,
  total_bookings_per_period: UOo,
  routed_to_per_period: GOo,
  per_day: WOo,
  per_week: HOo,
  per_month: YOo,
  routing_form_insights_assignment_reason: KOo,
  access_denied: ZOo,
  salesforce_route_to_owner: XOo,
  salesforce_add_attendees_as: JOo,
  salesforce_do_not_route_to_owner: QOo,
  salesforce_route_to_custom_lookup_field: eNo,
  salesforce_option: tNo,
  lookup_field_name: nNo,
  salesforce_if_free_email_domain_skip_owner_check: oNo,
  filter_operator_is: rNo,
  filter_operator_is_not: iNo,
  filter_operator_contains: aNo,
  filter_operator_does_not_contain: sNo,
  filter_operator_starts_with: cNo,
  filter_operator_ends_with: lNo,
  filter_operator_is_empty: uNo,
  filter_operator_not_empty: dNo,
  translate_description_button: _No,
  translate_description_button_description: pNo,
  rr_distribution_method: mNo,
  rr_distribution_method_description: fNo,
  rr_distribution_method_availability_title: gNo,
  rr_distribution_method_availability_description: hNo,
  rr_distribution_method_balanced_title: vNo,
  rr_distribution_method_balanced_description: bNo,
  edit_team_member_weights: yNo,
  weights_updated_successfully: $No,
  require_confirmation_for_free_email: wNo,
  exclude_emails_that_contain: kNo,
  require_emails_that_contain: SNo,
  exclude_emails_match_found_error_message: ENo,
  require_emails_no_match_found_error_message: xNo,
  search_columns: CNo,
  search_options: TNo,
  disable_org_url_label: ANo,
  disable_org_url_description: INo,
  single_select: ONo,
  multi_select: NNo,
  calendar_conflict_settings: zNo,
  select_calendars_conflict_check: RNo,
  group_meeting: PNo,
  are_you_sure_you_want_to_remove_this_app_from: DNo,
  disconnect_app_from: LNo,
  salesforce_ignore_guests: MNo,
  google_meet: FNo,
  zoom: qNo,
  office_365_video: jNo,
  lock_attribute_for_assignment: VNo,
  lock_attribute_for_assignment_description: BNo,
  attribute_edited_successfully: UNo,
  new_group_option: GNo,
  attribute_weight_enabled: WNo,
  attribute_weight_enabled_description: HNo,
  routed: YNo,
  reassigned: KNo,
  allow_rescheduling_past_events: ZNo,
  allow_rescheduling_past_events_description: XNo,
  rerouted: JNo,
  salesforce_assigned: QNo,
  router_position: ezo,
  show_matching_hosts: tzo,
  no_active_queues: nzo,
  weight: ozo,
  calibration: rzo,
  shortfall: izo,
  routing_form: azo,
  go_back_and_save: szo,
  save_changes: czo,
  leave_without_saving: lzo,
  leave_without_saving_description: uzo,
  something_unexpected_occurred: dzo,
  "500_error_message": "No eres tú, somos nosotros.",
  dry_run_mode_active: _zo,
  icon_showcase: pzo,
  icons_showcase: mzo,
  migrating_from_team: fzo,
  feature_currently_disabled: gzo,
  choose_an_option: hzo,
  enter_option_value: vzo,
  remove_option: bzo,
  use_attribute_weights: yzo,
  if_enabled_ignore_event_type_weights: $zo,
  attribute_for_weights: wzo,
  managed_users: kzo,
  managed_users_description: Szo,
  can_you_tell_me_about: Ezo,
  use_ai_to_answer_your_questions: xzo,
  error_fetching_answer: Czo,
  k_bar_ai_error: Tzo,
  select_oAuth_client: Azo,
  on_every_instance: Izo,
  delegation_credential_feature_not_enabled: Ozo,
  internal_booking_note: Nzo,
  internal_note_cancellation_reason: zzo,
  internal_booking_note_description: Rzo,
  internal_note_presets: Pzo,
  internal_note_presets_description: Dzo,
  internal_note_presets_updated_successfully: Lzo,
  add_preset: Mzo,
  authorize: Fzo,
  next: qzo,
  hide: jzo,
  show: Vzo,
  utm_params: Bzo,
  no_utm_params: Uzo,
  asc: Gzo,
  desc: Wzo,
  verify_email_change: Hzo,
  buy_credits: Yzo,
  credits: Kzo,
  credits_used: Zzo,
  total_credits_remaining: Xzo,
  credits_per_tip_org: Jzo,
  credits_per_tip_teams: Qzo,
  view_and_manage_credits: eRo,
  view_and_manage_credits_description: tRo,
  credit_worth_description: nRo,
  buy_additional_credits: oRo,
  view_additional_credits_expense_tip: rRo,
  overview: iRo,
  organization_slug_taken: aRo,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: sRo,
  you_need_to_complete_user_onboarding_before_creating_an_organization: cRo,
  use_company_email_to_create_an_organization: lRo,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: uRo,
  you_need_to_have_minimum_published_teams: dRo,
  you_are_part_of_this_organization_already: _Ro,
  you_are_part_of_another_organization_cannot_create_organization: pRo,
  you_are_part_of_another_platform_organization_cannot_create_organization: mRo,
  organization_payment_success: fRo,
  organization_payment_success_description: gRo,
  this_may_take_a_few_seconds: hRo,
  organization_onboarding_status: vRo,
  organization_onboarding_status_description: bRo,
  payment_failed: yRo,
  payment_failed_description: $Ro,
  creating_your_organization: wRo,
  organization_onboarding_already_completed: kRo,
  organization_onboarding_already_exists: SRo,
  organization_onboarding_not_found: ERo,
  payment_successful: xRo,
  handover_onboarding_page_title: CRo,
  handover_onboarding_page_description: TRo,
  organization_already_exists_with_this_slug: ARo,
  you_do_not_have_permission_to_create_an_organization_for_this_email: IRo,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: ORo,
  organization_has_subscription_already: NRo,
  reset_interval_weighted_rr: zRo,
  interval: RRo,
  rr_reset_interval_description: PRo,
  daily: DRo,
  end_date_not_selected: LRo,
  my_ooo: MRo,
  team_ooo: FRo,
  out_of_office_team_description: qRo,
  create_ooo_dialog_team_title: jRo,
  create_ooo_dialog_team_subtitle: VRo,
  edit_ooo_dialog_team_subtitle: BRo,
  ooo_team_empty_title: URo,
  ooo_team_empty_description: GRo,
  forward_to_team_member_only: WRo,
  ooo_team_redirect_infinite_not_allowed: HRo,
  previous_ooo_empty_title: YRo,
  previous: KRo,
  rr_interval_successfully_updated: ZRo,
  trial_mode: XRo,
  inactive_team_plan: JRo,
  inactive_team_plan_description: QRo,
  limited_access_trial_mode: ePo,
  referral_program: tPo,
  referral_text: nPo,
  dub_disabled_error_message: oPo,
  uid: rPo,
  link: iPo,
  rows_per_page: aPo,
  pagination_status: sPo,
  tip_username_plus: cPo,
  user_has_no_team_yet: lPo,
  no_team_members: uPo,
  recurring_event_doesnt_support_seats: dPo,
  booking_limit_per_booker_doesnt_support_recurring: _Po,
  seats_doesnt_support_recurring: pPo,
  recurring_event_seats_error: mPo,
  segment: fPo,
  saved_filters: gPo,
  rename: hPo,
  rename_segment: vPo,
  delete_segment: bPo,
  duplicate_segment: yPo,
  delete_segment_confirmation: $Po,
  filter_segment_updated: wPo,
  error_updating_filter_segment: kPo,
  filter_segment_duplicated: SPo,
  error_duplicating_filter_segment: EPo,
  filter_segment_deleted: xPo,
  error_deleting_filter_segment: CPo,
  save_segment: TPo,
  segment_not_found: APo,
  filter_segment_saved: IPo,
  no_segments: OPo,
  error_saving_filter_segment: NPo,
  override_segment: zPo,
  create_new_segment: RPo,
  save_for_team: PPo,
  select_team: DPo,
  please_select_team: LPo,
  personal: MPo,
  hide_team_profile_link: FPo,
  hide_team_profile_link_description: qPo,
  display: jPo,
  could_not_find_slug_to_publish_org: VPo,
  picklist: BPo,
  most_cancelled_bookings: UPo,
  interface_language: GPo,
  interface_language_description: WPo,
  visitors_browser_language: HPo,
  name_or_email: YPo,
  salesforce_round_robin_skip_fallback_to_lead_owner: KPo,
  credit_purchase_failed: ZPo,
  minimum_of_credits_required: XPo,
  enable_delegation_credential: JPo,
  enable_delegation_credential_description: QPo,
  disable_delegation_credential: eDo,
  disable_delegation_credential_description: tDo,
  last_active: nDo,
  member_since: oDo,
  last_updated: rDo,
  salesforce_on_cancel_write_to_event: iDo,
  salesforce_on_every_cancellation: aDo,
  report_issue: sDo,
  report_issue_description: cDo,
  open_issue: lDo,
  this_is_your_current_plan: uDo,
  schedule_a_time: dDo,
  this_includes: _Do,
  oauth_client_updated_successfully: pDo,
  oauth_client_not_found: mDo,
  subscribe_to_platform: fDo,
  error_accessing_webhooks: gDo,
  webhook_update_failed: hDo,
  webhook_create_failed: vDo,
  invalid_link: bDo,
  currently_subscribed_to_plan: yDo,
  user_team: $Do,
  client_id_copied: wDo,
  client_secret_copied: kDo,
  maintenance_message: SDo,
  your_payment_failed: EDo,
  check_your_inbox: xDo,
  account_created_premium_not_reserved: CDo,
  email_sent_with_activation_link: TDo,
  activate_account_to_purchase_username: ADo,
  open_in_gmail: IDo,
  dont_see_email: ODo,
  resend_in_seconds: NDo,
  resend: zDo,
  verification_email_sent: RDo,
  select_all_members: PDo,
  select_all_members_tooltip: DDo,
  form_settings: LDo,
  remove_whitelist_status: MDo,
  whitelist_user_workflows: FDo,
  user_workflows_whitelisted: qDo,
  user_workflows_unwhitelisted: jDo,
  date_and_time: VDo,
  email_reminder_upcoming_event_notice: BDo,
  email_reminder_triggered_by_workflow: UDo,
  event_upper_case: GDo,
  scheduling_by: WDo,
  experience_review_prompt: HDo,
  improve_customer_experience_message: YDo,
  meeting_satisfaction_question: KDo,
  meeting_not_joined_question: ZDo,
  reschedule_cta_short: XDo,
  hide_organizer_email: JDo,
  platform_customer_cant_create_organization: QDo,
  organization_customer_cant_create_platform: e3o,
  hide_organizer_email_description: t3o,
  you_and_conjunction: n3o,
  select_verified_email: o3o,
  add_verified_email: r3o,
  add_verified_emails: i3o,
  custom_reply_to_email_title: a3o,
  custom_reply_to_email_description: s3o,
  email_survey_triggered_by_workflow: c3o,
  skip_trial: l3o,
  team_trials_skipped_successfully: u3o,
  sms_workflow_consent: d3o,
  routing_preview_more_info_found_insights: _3o,
  results: p3o,
  view_form: m3o,
  sms_opt_out_message: f3o,
  team_credits_low_warning: g3o,
  user_credits_low_warning: h3o,
  action_required_out_of_credits: v3o,
  action_required_user_out_of_credits: b3o,
  low_credits_warning_message: y3o,
  low_credits_warning_message_user: $3o,
  credit_limit_reached_message: w3o,
  credit_limit_reached_message_user: k3o,
  current_credit_balance: S3o,
  current_balance: E3o,
  notification_about_your_booking: x3o,
  monthly_credits: C3o,
  total_credits: T3o,
  remaining_credits: A3o,
  remaining: I3o,
  total: O3o,
  additional_credits: N3o,
  routing_form_next_in_queue: z3o,
  routing_form_select_members_to_email: R3o,
  routing_incomplete_booking_tab: P3o,
  include_no_show_in_rr_calculation: D3o,
  recent_no_show_guests: L3o,
  recent_no_show_guests_tooltip: M3o,
  matching: F3o,
  event_redirect: q3o,
  reset_form: j3o,
  rr_settings_successfully_updated: V3o,
  distribution_basis_weighted_rr: B3o,
  timestamp_basis_description: U3o,
  requires_credits: G3o,
  requires_credits_tooltip: W3o,
  available_credits: H3o,
  create_role: Y3o,
  roles_and_permissions: K3o,
  roles_and_permissions_description: Z3o,
  learn_more_permissions: X3o,
  role_name: J3o,
  role_name_required: Q3o,
  role_name_placeholder: eLo,
  role_description: tLo,
  role_description_placeholder: nLo,
  default_role: oLo,
  custom_role: rLo,
  advanced: iLo,
  search_permissions: aLo,
  all_permissions: sLo,
  none: cLo,
  read_only: lLo,
  pbac_desc_all_actions_all_resources: uLo,
  pbac_resource_all: dLo,
  pbac_resource_event_type: _Lo,
  pbac_resource_team: pLo,
  pbac_resource_organization: mLo,
  pbac_resource_booking: fLo,
  pbac_resource_insights: gLo,
  pbac_resource_role: hLo,
  pbac_resource_routing_form: vLo,
  pbac_resource_workflow: bLo,
  pbac_action_all: yLo,
  pbac_action_create: $Lo,
  pbac_action_read: wLo,
  pbac_action_update: kLo,
  pbac_action_delete: SLo,
  pbac_action_manage: ELo,
  pbac_action_invite: xLo,
  pbac_action_remove: CLo,
  pbac_action_change_member_role: TLo,
  pbac_action_list_members: ALo,
  pbac_action_manage_billing: ILo,
  pbac_action_read_team_bookings: OLo,
  pbac_action_read_org_bookings: NLo,
  pbac_action_read_recordings: zLo,
  pbac_action_impersonate: RLo,
  role_created_successfully: PLo,
  role_updated_successfully: DLo,
  delete_role: LLo,
  confirm_delete_role: MLo,
  role_deleted_successfully: FLo,
  error_creating_role: qLo,
  error_updating_role: jLo,
  pbac_desc_create_roles: VLo,
  pbac_resource_attributes: BLo,
  pbac_desc_view_organization_attributes: ULo,
  pbac_desc_update_organization_attributes: GLo,
  pbac_desc_delete_organization_attributes: WLo,
  pbac_desc_create_organization_attributes: HLo,
  pbac_desc_view_roles: YLo,
  pbac_desc_update_roles: KLo,
  pbac_desc_delete_roles: ZLo,
  pbac_desc_create_workflows: XLo,
  set_up_required: JLo,
  pbac_desc_view_workflows: QLo,
  pbac_desc_update_workflows: eMo,
  pbac_desc_delete_workflows: tMo,
  pbac_resource_webhook: nMo,
  pbac_resource_availability: oMo,
  pbac_resource_out_of_office: rMo,
  pbac_desc_create_webhooks: iMo,
  pbac_desc_view_webhooks: aMo,
  pbac_desc_update_webhooks: sMo,
  pbac_desc_delete_webhooks: cMo,
  pbac_desc_create_availability: lMo,
  pbac_desc_view_availability: uMo,
  pbac_desc_update_availability: dMo,
  pbac_desc_delete_availability: _Mo,
  pbac_desc_create_out_of_office: pMo,
  pbac_desc_view_out_of_office: mMo,
  pbac_desc_update_out_of_office: fMo,
  pbac_desc_delete_out_of_office: gMo,
  pbac_desc_manage_workflows: hMo,
  pbac_desc_create_event_types: vMo,
  pbac_desc_view_event_types: bMo,
  pbac_desc_update_event_types: yMo,
  pbac_desc_delete_event_types: $Mo,
  pbac_desc_manage_event_types: wMo,
  pbac_desc_create_teams: kMo,
  pbac_desc_view_team_details: SMo,
  pbac_desc_update_team_settings: EMo,
  pbac_desc_delete_team: xMo,
  pbac_desc_invite_team_members: CMo,
  pbac_desc_remove_team_members: TMo,
  pbac_desc_change_team_member_role: AMo,
  pbac_desc_impersonate_team_members: IMo,
  pbac_desc_manage_teams: OMo,
  pbac_desc_create_organization: NMo,
  pbac_desc_view_organization_details: zMo,
  pbac_desc_list_organization_members: RMo,
  pbac_desc_invite_organization_members: PMo,
  pbac_desc_remove_organization_members: DMo,
  pbac_desc_manage_organization_billing: LMo,
  pbac_desc_change_organization_member_role: MMo,
  pbac_desc_impersonate_organization_members: FMo,
  pbac_desc_edit_organization_settings: qMo,
  pbac_desc_manage_organizations: jMo,
  pbac_desc_view_bookings: VMo,
  pbac_desc_view_team_bookings: BMo,
  pbac_desc_view_organization_bookings: UMo,
  pbac_desc_view_booking_recordings: GMo,
  pbac_desc_update_bookings: WMo,
  pbac_desc_manage_bookings: HMo,
  pbac_desc_view_team_insights: YMo,
  pbac_desc_manage_team_insights: KMo,
  pbac_desc_create_routing_forms: ZMo,
  pbac_desc_view_routing_forms: XMo,
  pbac_desc_update_routing_forms: JMo,
  pbac_desc_delete_routing_forms: QMo,
  read_permission_auto_enabled_tooltip: e4o,
  choose_restriction_schedule: t4o,
  restriction_schedule_description: n4o,
  use_booker_timezone: o4o,
  use_booker_timezone_info: r4o,
  load_balancing_warning: i4o,
  rr_load_balancing_disabled: a4o,
  rr_load_balancing_disabled_with_groups: s4o,
  round_robin_settings_description: c4o,
  round_robin_settings_updated_successfully: l4o,
  booking_creation_time: u4o,
  meeting_start_time: d4o,
  members_affected_by_disabling_delegation_credential: _4o,
  no_members_affected_by_disabling_delegation_credential: p4o,
  download_expense_log: m4o,
  error_downloading_expense_log: f4o,
  offer_to_reschedule_last_booking: g4o,
  booker_limit_exceeded_error: h4o,
  booker_limit_exceeded_error_reschedule: v4o,
  duration_min_error: b4o,
  duration_max_error: y4o,
  booking_not_allowed_by_restriction_schedule_error: $4o,
  restriction_schedule_not_found_error: w4o,
  converted_image_size_limit_exceed: k4o,
  add_group: S4o,
  routing_funnel: E4o,
  routing_funnel_total_submissions: x4o,
  routing_funnel_successful_routings: C4o,
  routing_funnel_accepted_bookings: T4o,
  license_key: A4o,
  license_selection_title: I4o,
  license_selection_description: O4o,
  agplv3_license_description: N4o,
  enter_license_key: z4o,
  enter_your_license_key: R4o,
  enter_existing_license: P4o,
  enter_license_key_description: D4o,
  license_key_placeholder: L4o,
  save_license_key: M4o,
  signature_token_optional: F4o,
  signature_token_description: q4o,
  need_a_license: j4o,
  license_key_required: V4o,
  invalid_license_key: B4o,
  license_validation_failed: U4o,
  attachments_optional: G4o,
  send_message: W4o,
  describe_the_issue: H4o,
  file_size_limit_exceed: Y4o,
  invalid_file_type: K4o,
  invalid_file_type_extension: Z4o,
  max_files_exceeded: X4o,
  files_uploaded_successfully: J4o,
  file_upload_instructions: Q4o,
  license_key_saved: e5o,
  timezone_mismatch_tooltip: t5o,
  show_optimized_slots: n5o,
  show_optimized_slots_description: o5o,
  failed_bookings_by_field: r5o,
  failed_bookings: i5o,
  event_type_no_hosts: a5o,
  cache_status: s5o,
  cache_last_updated: c5o,
  delete_cached_data: l5o,
  cache_deleted_successfully: u5o,
  error_deleting_cache: d5o,
  confirm_delete_cache: _5o,
  yes_delete_cache: p5o,
  remainder_of_maximum_uses_left_plural: m5o,
  remainder_of_maximum_use_left_singular: f5o,
  expires_on_date: g5o,
  single_use: h5o,
  time_based_expiration: v5o,
  usage_based_expiration: b5o,
  number_of_uses: y5o,
  expires_on: $5o,
  max_usage_count: w5o,
  link_settings: k5o,
  link_expired_on_date: S5o,
  usage_limit_reached: E5o,
  usage_count_error: x5o,
  private_link_expired: C5o,
  time_based_expiration_description: T5o,
  time_based_generic_expiration_description: A5o,
  usage_based_expiration_description: I5o,
  usage_based_generic_expiration_description: O5o,
  usage_based_expiration_description_plural: N5o,
  webhook_trigger_event: z5o,
  webhook_created_at: R5o,
  webhook_type: P5o,
  set_up_agent: D5o,
  webhook_title: L5o,
  webhook_start_time: M5o,
  webhook_end_time: F5o,
  webhook_description: q5o,
  webhook_location: j5o,
  webhook_uid: V5o,
  webhook_reschedule_uid: B5o,
  webhook_cancellation_reason: U5o,
  webhook_rejection_reason: G5o,
  webhook_organizer_name: W5o,
  webhook_organizer_email: H5o,
  webhook_organizer_timezone: Y5o,
  webhook_organizer_locale: K5o,
  webhook_organizer_username: Z5o,
  webhook_organizer_username_in_org: X5o,
  webhook_attendee_name: J5o,
  webhook_attendee_email: Q5o,
  webhook_attendee_timezone: e6o,
  webhook_attendee_locale: t6o,
  webhook_team_name: n6o,
  webhook_team_members: o6o,
  webhook_video_call_url: r6o,
  webhook_hide_variables: i6o,
  webhook_show_variable: a6o,
  webhook_event_and_booking: s6o,
  webhook_people: c6o,
  webhook_teams: l6o,
  webhook_metadata: u6o,
  stats: d6o,
  booking_status: _6o,
  visit: p6o,
  location_custom_label_input_label: m6o,
  meeting_link: f6o,
  session_outcome: g6o,
  call_created: h6o,
  voicemail: v6o,
  my_bookings: b6o,
  phone: y6o,
  free: $6o,
  user_email: w6o,
  user_name: k6o,
  expand_panel: S6o,
  collapse_panel: E6o,
  email_verification_required: x6o,
  invalid_verification_code: C6o,
  you_have_one_team: T6o,
  consider_consolidating_one_team_org: A6o,
  consider_consolidating_multi_team_org: I6o,
  message_sent: O6o,
  support_message_sent_description: N6o,
  search_variables: z6o,
  support_message_placeholder: R6o,
  send_another_message: P6o,
  sending: D6o,
  no_variables_found: L6o,
  credits_required: M6o,
  web_call_credits_info: F6o,
  web_call_no_credits: q6o,
  purchase_credits: j6o,
  credits_required_tooltip: V6o,
  api_key_name_too_long: B6o,
  auto_charge_for_last_minute_cancellation: U6o,
  before_scheduled_start_time: G6o,
  cancel_booking_acknowledge_no_show_fee: W6o,
  contact_organizer: H6o,
  booking_time_option: Y6o,
  booking_time_option_description: K6o,
  created_at_option: Z6o,
  created_at_option_description: X6o,
  call_details: J6o,
  call_id: Q6o,
  call_information: eFo,
  sentiment: tFo,
  disconnect_reason: nFo,
  call_summary: oFo,
  transcription: rFo,
  event_details: iFo,
  agent: aFo,
  no_transcript_available: sFo,
  testing_sms_workflow_info_message: cFo,
  start_from_scratch_title: lFo,
  start_from_scratch_description: uFo,
  cal_ai_template_title: dFo,
  cal_ai_template_description: _Fo,
  voice: pFo,
  select_voice: mFo,
  select_voice_for_agent: fFo,
  choose_a_voice_for_your_agent: gFo,
  trait: hFo,
  voice_id: vFo,
  use_voice: bFo,
  current_voice: yFo,
  setup_incoming_agent: $Fo,
  setup_incoming_agent_description: wFo,
  connect_a_phone_number_first: kFo,
  setup_agent_for_incoming_calls: SFo,
  configure_agent_to_handle_incoming_calls: EFo,
  incoming_calls: xFo,
  outgoing_calls: CFo,
  inbound_agent_setup_success: TFo,
  inbound_agent_configured: AFo,
  setup_inbound_agent: IFo,
  please_select_event_type_first: OFo,
  edit_configuration: NFo,
  select_event_type_for_inbound_calls: zFo,
  setup_inbound_agent_for_incoming_calls: RFo,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: PFo
}, LFo = "Fournisseur d'identité", MFo = 'Il vous reste $t(day, {"count": {{days}} }) pour votre essai Pro', FFo = "{{count}} jour", qFo = "{{count}} jours", jFo = "{{count}} seconde", VFo = "{{count}} secondes", BFo = "Mettre à niveau maintenant", UFo = "Sans titre", GFo = "Accepter l'invitation", WFo = "Caractères max.", HFo = "Caractères min.", YFo = "{{appName}} fournit une infrastructure de planification pour absolument tout le monde.", KFo = "Finalisez la configuration de votre compte {{appName}} ! Vous n'êtes qu'à quelques étapes de résoudre tous vos problèmes de planification.", ZFo = "Vous avez des questions ? Nous sommes là pour vous aider.", XFo = "{{appName}} : Instructions de réinitialisation de mot de passe", JFo = "{{appName}} : Vérifiez votre compte", QFo = "{{appName}} : Faites vérifier votre adresse e-mail", eqo = "Vérifiez votre e-mail", tqo = "Ancienne adresse e-mail", nqo = "Nouvelle adresse e-mail", oqo = "Nous avons envoyé un e-mail à {{email}}. Il est important de vérifier votre adresse e-mail pour garantir la meilleure délivrabilité des e-mails et des calendriers de {{appName}}.", rqo = "Vérifiez votre adresse e-mail pour garantir la meilleure délivrabilité des e-mails et des calendriers", iqo = "Vérifiez votre adresse e-mail", aqo = "Vérifier l'e-mail", sqo = "Assistant", cqo = "Envoyer les e-mails de transcription vidéo Cal", lqo = "Envoyer des e-mails avec la transcription de la vidéo Cal après la fin de la réunion. (Nécessite un abonnement payant)", uqo = "Vous avez récemment demandé à changer l'adresse e-mail que vous utilisez pour vous connecter à votre compte {{appName}}. Veuillez cliquer sur le bouton ci-dessous pour confirmer votre nouvelle adresse e-mail.", dqo = "Mise à jour de votre adresse e-mail. Nouvelle : {{email}}", _qo = "Échec de la mise à jour de l'adresse e-mail.", pqo = "Faites vérifier votre nouvelle adresse e-mail {{appName}}", mqo = "Nous avons envoyé un lien de vérification à {{email}}. Nous mettrons à jour votre adresse e-mail une fois que vous aurez cliqué sur ce lien.", fqo = "Sauvegardez cette clé API dans un endroit sûr. Vous ne pourrez plus la revoir.", gqo = "Veuillez vérifier votre adresse e-mail en cliquant sur le bouton ci-dessous.", hqo = "Veuillez vérifier votre adresse e-mail en utilisant le code ci-dessous.", vqo = "Si vous n'aimez pas cliquer sur les boutons, voici le lien :", bqo = "Saisissez le code de vérification", yqo = "Saisissez le code de vérification envoyé à votre adresse e-mail", $qo = "Le code de vérification est incorrect.", wqo = "E-mail envoyé avec succès", kqo = "Une erreur s'est produite lors de l'envoi de l'e-mail", Sqo = "Refusé : {{title}} le {{date}}", Eqo = "Annulé : {{title}} le {{date}}", xqo = "Réaffecté : {{title}} le {{date}}", Cqo = "Votre demande d'événement a été refusée", Tqo = "Personnaliser les paramètres de Cal Video", Aqo = "Configurez les préférences de réunion vidéo, y compris les autorisations d'enregistrement pour les hôtes et les participants.", Iqo = "Désactiver l'enregistrement pour les invités", Oqo = "Activer la transcription automatique après avoir rejoint la réunion", Nqo = "Activer l'enregistrement automatique après que l'organisateur rejoint la réunion", zqo = "Options vidéo", Rqo = "Modifier l'événement", Pqo = "Voir les détails de la session", Dqo = "Détails de la session de réunion", Lqo = "Session de réunion", Mqo = "ID de session", Fqo = "Nombre maximum de participants", qqo = "Illimité", jqo = "En cours", Vqo = "Terminée", Bqo = "Participants", Uqo = "Utilisateur anonyme", Gqo = "Durée de la session", Wqo = "Aucune session de réunion trouvée", Hqo = "Non disponible", Yqo = "Désactiver l'enregistrement pour l'organisateur", Kqo = "Désactiver la transcription pour les invités", Zqo = "Désactiver la transcription pour l'organisateur", Xqo = "Votre demande d'événement récurrent a été refusée", Jqo = "Votre événement planifié a été annulé", Qqo = "Votre événement programmé a été réaffecté", ejo = "L'événement ne sera plus dans votre calendrier et votre probabilité de round robin ne sera pas affectée négativement", tjo = "Organisateur", njo = "Réaffecté à", ojo = "Besoin de replanifier ou d'annuler ?", rjo = "Vous pouvez consulter les détails de la réservation à partir de cette URL {{url}} et ajouter l'événement à votre calendrier", ijo = "Aucune option disponible", ajo = "Motif de l'annulation (facultatif)", sjo = "Annulé par", cjo = "Motif d'annulation", ljo = "Pourquoi annulez-vous ?", ujo = "La raison de l'annulation sera partagée avec les invités", djo = "Pourquoi refusez-vous ?", _jo = "Motif de refus", pjo = "Refuser la demande de réservation ?", mjo = "Voulez-vous vraiment refuser la réservation ? Nous informerons la personne qui a tenté de réserver. Vous pouvez fournir un motif ci-dessous.", fjo = "Refuser la réservation", gjo = "Gérer cet événement", hjo = "Inviter un membre d'équipe", vjo = "Inviter une personne", bjo = "Importation multiple", yjo = "Inv.", $jo = "Votre événement a été planifié", wjo = "Votre événement récurrent a été planifié", kjo = "Acceptez notre licence en changeant la variable .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> en « {{agree}} ».", Sjo = "Pour supprimer cette bannière, veuillez ouvrir votre fichier .env et changer la variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> en « {{agree}} ».", Ejo = "Le message d'erreur était : « {{errorMessage}} »", xjo = "Le remboursement a échoué : {{name}} - {{date}} - {{eventType}}", Cjo = "Le remboursement de l'événement {{eventType}} avec {{userName}} le {{date}} a échoué.", Tjo = "Veuillez vérifier avec votre fournisseur de paiement et {{user}} comment gérer cela.", Ajo = "Un remboursement a échoué", Ijo = "En attente de paiement : {{title}} le {{date}}", Ojo = "Votre rendez-vous est en attente de paiement", Njo = "La couleur du thème sombre ne passe pas la vérification du contraste. Nous vous recommandons de modifier cette couleur afin que vos boutons soient plus visibles.", zjo = "La couleur du thème clair ne passe pas la vérification du contraste. Nous vous recommandons de modifier cette couleur afin que vos boutons soient plus visibles.", Rjo = "La couleur du thème clair ne passe pas le contrôle de contraste. Nous vous recommandons de changer cette couleur pour que vos types d'événements soient plus visibles.", Pjo = "La couleur du thème sombre ne passe pas le contrôle de contraste. Nous vous recommandons de changer cette couleur pour que vos types d'événements soient plus visibles.", Djo = "Le paiement n'a pas pu être créé", Ljo = "Impossible de débiter la carte pour le Paiement", Mjo = "Aucun utilisateur disponible n'a été trouvé. Pourriez-vous essayer un autre créneau horaire ?", Fjo = "Le créneau horaire sélectionné n'est plus disponible. <0>Veuillez sélectionner un nouvel horaire</0>", qjo = "Pris", jjo = "Vous venez de vous connecter. Veuillez réserver parmi les créneaux ci-dessus ou réessayer plus tard.", Vjo = "Créneau indisponible", Bjo = "Le type d'événement ne peut pas être réservé à ce moment. Pourriez-vous essayer un autre créneau horaire ?", Ujo = "Erreur interne. Le corps de la demande ne contient pas l'heure de fin", Gjo = "Impossible de créer un événement de Calendrier dans le calendrier de l'Organisateur", Wjo = "Impossible de mettre à jour l'événement de Calendrier.", Hjo = "Impossible de supprimer l'événement de Calendrier.", Yjo = "Vous êtes déjà inscrit(e) à cette réservation.", Kjo = "Certains hôtes sont indisponibles pour la réservation.", Zjo = "Certains des hôtes fixes ne sont pas disponibles pour la réservation.", Xjo = "L'hôte du tour de rôle n'est pas disponible pour la réservation.", Jjo = "Aide", Qjo = "Prix", eVo = "Payé", tVo = "Remboursé", nVo = "Enregistrer", oVo = "Transcrire", rVo = "Paiement", iVo = "Champs de carte manquants", aVo = "Payer maintenant", sVo = "Invite générale", cVo = "Transcription alimentée par l'IA", lVo = "Démarrer ou arrêter l'enregistrement", uVo = "Commencer le message", dVo = "La base de code doit rester open source, qu'elle ait été modifiée ou non", _Vo = "Vous ne pouvez pas restructurer ou vendre la base de code", pVo = "Obtenez une licence commerciale pour supprimer ces termes en envoyant un e-mail", mVo = "Résumé des conditions", fVo = "Ouvrez le fichier .env et acceptez notre licence", gVo = "J'ai modifié mon fichier .env", hVo = "Accepter la licence", vVo = "Un événement est toujours en attente de validation", bVo = "La demande d'événement est toujours en attente : {{attendeeName}} - {{date}} - {{eventType}}", yVo = 'Aucun résultat trouvé pour "{{searchTerm}}"', $Vo = "Il n'y a plus de résultats", wVo = "Aucun résultat", kVo = "Charger plus de résultats", SVo = "Identifiant du rendez-vous {{integrationName}} : {{meetingId}}", EVo = "Confirmé : {{eventType}} avec {{name}} le {{date}}", xVo = "Nouvelle demande d'événement : {{attendeeName}} - {{date}} - {{eventType}}", CVo = "Confirmer ou refuser la demande", TVo = "Consultez votre page de réservation pour confirmer ou refuser la réservation.", AVo = "Assistant de vérification", IVo = "Effectue un appel sortant pour vérifier si le rendez-vous prévu convient ou si vous souhaitez le reprogrammer.", OVo = "Créez votre propre invite et utilisez-la pour passer un appel sortant.", NVo = "Un nouvel événement attend votre validation", zVo = "Un événement récurrent attend votre validation", RVo = "Quelqu'un a demandé à planifier un événement sur votre calendrier.", PVo = "Quelqu'un a demandé un lien pour modifier votre mot de passe.", DVo = "Si cette adresse e-mail existe dans notre système, vous devriez recevoir un e-mail de réinitialisation.", LVo = "Si vous n'en avez pas fait la demande, vous pouvez ignorer cet e-mail en toute sécurité et votre mot de passe ne sera pas modifié.", MVo = "En attente de validation : {{title}} le {{date}}", FVo = "Un événement est toujours en attente de votre validation", qVo = "En attente de validation: {{title}} le {{date}}", jVo = "Télécharger l'enregistrement : {{title}} le {{date}}", VVo = "Télécharger l'enregistrement : {{title}} le {{date}}", BVo = "Télécharger votre enregistrement", UVo = "Téléchargez vos transcriptions", GVo = "Votre rendez-vous a été réservé", WVo = "Votre {{title}} a été replanifié le {{date}}", HVo = "Votre {{title}} a été mis(e) à jour.", YVo = "Mise à jour - Votre événement a été replanifié", KVo = "L'événement a été mis à jour", ZVo = "Votre événement a été replanifié", XVo = "{{organizer}} a annulé la réservation et vous a demandé de choisir un autre moment.", JVo = "Vous avez demandé à {{attendee}} de replanifier la réservation", QVo = "Vous avez annulé la réservation et {{attendee}} doit choisir un nouveau créneau de réservation.", eBo = "Demande de replanification envoyée : {{eventType}} avec {{name}} le {{date}}", tBo = "Replanification requise : veuillez réserver un nouveau créneau pour {{eventType}} avec {{name}}", nBo = "Bonjour {{name}}", oBo = "{{eventType}} avec {{name}}", rBo = "Il semble que tous nos experts soient occupés pour le moment. Veuillez planifier un appel à un moment qui vous convient le mieux et nous serons prêts à vous aider.", iBo = "Planifier à la place", aBo = "Nouvel événement : {{attendeeName}} - {{date}} - {{eventType}}", sBo = "Rejoindre par {{entryPoint}}", cBo = "Notes", lBo = "Gérer mes réservations", uBo = "Besoin de faire un changement ?", dBo = "Un nouvel événement a été planifié", _Bo = "Un nouvel événement récurrent a été planifié", pBo = "E-mail de l'invité", mBo = "Fuseau horaire de l'invité", fBo = "Temps restant", gBo = "Type d'événement", hBo = "Dupliquer le type d'événement", vBo = "Rejoindre le rendez-vous", bBo = "Service d'appel vidéo", yBo = "ID du rendez-vous", $Bo = "Mot de passe du rendez-vous", wBo = "Lien du rendez-vous", kBo = "L'URL du rendez-vous est introuvable", SBo = "Jeton introuvable", EBo = "Un autre hôte a déjà accepté la réunion. Souhaitez-vous quand même y participer ? <0>Continuer vers la réunion</0>", xBo = "Votre demande de rendez-vous a été refusée", CBo = "Refusé : {{eventType}} avec {{organizer}} le {{date}}", TBo = "Bonjour", ABo = "Rejoindre l'équipe", IBo = "Gérer cette équipe", OBo = "Informations sur l'équipe", NBo = "Rejoindre le rendez-vous", zBo = "Si vous préférez ne pas utiliser {{toEmail}} comme votre adresse e-mail {{appName}} ou si vous avez déjà un compte {{appName}}, veuillez demander une autre invitation à cette adresse.", RBo = "Vous avez été invité à rejoindre l'équipe {{teamName}}", PBo = "{{user}} vous a invité à rejoindre l'{{entity}} {{team}} sur {{appName}}", DBo = "Vous êtes masqué dans cette équipe", LBo = "Votre place n'est pas payée, passez au plan Pro ou faites savoir au propriétaire de l'équipe qu'il peut payer votre place.", MBo = "Vous avez besoin d'un compte Pro pour utiliser les équipes, vous êtes masqué jusqu'à ce que vous mettiez à niveau.", FBo = "p.s. Il expire dans {{expiresIn}} heures.", qBo = "Mise à niveau vers la place", jBo = "L'option de places ne prend pas en charge l'exigence de confirmation", VBo = "Plusieurs lieux ne prennent pas en charge l'option de places", BBo = "Les frais d'absence ne prennent pas en charge l'option de places", UBo = "L'option de places ne prend pas en charge plusieurs lieux", GBo = "Parmi les {{memberCount}} membres de votre équipe, {{unpaidCount}} place(s) sont impayées. À {{seatPrice}} $/mois par place, le coût total estimé de votre abonnement est de {{totalCost}} $/mois.", WBo = "Vous n'avez pas terminé la configuration de votre équipe. Votre équipe « {{teamName}} » doit être mise à niveau.", HBo = "Mettre à niveau", YBo = "Votre équipe a été mise à niveau avec succès !", KBo = "Merci d'avoir testé notre plan Organisation. Nous avons remarqué que votre organisation « {{teamName}} » doit être mise à niveau.", ZBo = "Votre organisation a été mise à niveau avec succès !", XBo = "Utilisez le lien ci-dessous pour réinitialiser votre mot de passe", JBo = "Bonjour", QBo = "là", e9o = "Mot de passe oublié ? - {{appName}}", t9o = "Voulez-vous vraiment supprimer ce webhook ? Vous ne recevrez plus les données de rendez-vous de {{appName}} à un lien spécifié, en temps réel, lorsqu'un événement est planifié ou annulé.", n9o = "Oui, supprimer le webhook", o9o = "Modifier le webhook", r9o = "Supprimer le webhook", i9o = "Statut du webhook", a9o = "Webhook activé", s9o = "Webhook désactivé", c9o = "Réponse du webhook", l9o = "Test du webhook", u9o = "Formulaire de mise à jour du webhook", d9o = "Ajoutez un webhook à votre client OAuth.", _9o = "Gérez votre webhook", p9o = "Webhook créé avec succès !", m9o = "Webhook mis à jour avec succès !", f9o = "Webhook supprimé avec succès !", g9o = "Abonnement requis", h9o = "Vous n'êtes pas abonné à un plan Platform.", v9o = "Modèle de charge utile", b9o = "Ignorer", y9o = "Aucune donnée pour l'instant", $9o = "Tester le ping", w9o = "Ajoutez cette application à votre écran d'accueil pour un accès plus rapide et une meilleure expérience.", k9o = "À venir", S9o = "Récurrence", E9o = "Passées", x9o = "Choisir un fichier...", C9o = "Télécharger une image", T9o = "Télécharger un {{target}}", A9o = "Pas de {{target}}", I9o = "Faites glisser pour zoomer, déplacer pour repositionner", O9o = "Voir les notifications", N9o = "Voir la page publique", z9o = "Copier le lien de la page publique", R9o = "Copier le lien de parrainage", P9o = "Se déconnecter", D9o = "Ajouter un autre", L9o = "Installer une autre", M9o = "jusqu'au", F9o = "propulsé par", q9o = "Indisponible", j9o = "Définissez vos horaires de travail", V9o = "Modifiez vos disponibilités pour les réservations", B9o = "Sélectionner...", U9o = "Texte", G9o = "Votre numéro de téléphone", W9o = "Zone de texte", H9o = "Nombre", Y9o = "Case à cocher", K9o = "Obligatoire", Z9o = "Rendre ce champ obligatoire", X9o = "Obligatoire", J9o = "Facultatif", Q9o = "Type de champ", eUo = "Refusé", tUo = "Non confirmées", nUo = "Invités", oUo = "Invité", rUo = "Les détails du rendez-vous sont à retrouver dans l'e-mail de confirmation.", iUo = "Confirmation", aUo = "Ce que votre réservateur doit fournir pour recevoir des confirmations", sUo = "Nom d'utilisateur", cUo = "est toujours disponible.", lUo = "Documentation", uUo = "Découvrez comment intégrer nos outils à votre application", dUo = "Référence API", _Uo = "Une référence API complète pour nos bibliothèques", pUo = "Blog", mUo = "Lire nos dernières actualités et articles", fUo = "Rejoignez notre communauté", gUo = "Pages populaires", hUo = "S'inscrire maintenant", vUo = "S'inscrire", bUo = "Cette page n'existe pas.", yUo = "Aucun numéro de téléphone actif disponible", $Uo = "Étape de workflow non configurée", wUo = "Vérifiez s'il y a des erreurs d'orthographe ou retournez à la page précédente.", kUo = "Nous n'avons pas pu trouver l'événement que vous essayez de réserver.", SUo = "Commencer", EUo = "Secret", xUo = "Laissez vide pour supprimer le secret.", CUo = "Assurez-vous que votre serveur ne reçoit que les demandes attendues de {{appName}} pour des raisons de sécurité", TUo = "Rendez-vous secret", AUo = "Se connecter à la place", IUo = "Créer un compte", OUo = "Commencer", NUo = "Confirmer le mot de passe", zUo = "Définissez votre nouveau mot de passe avec les instructions envoyées à votre adresse e-mail.", RUo = "Veuillez télécharger une image d'une largeur de {{width}} et d'une hauteur de {{height}}.", PUo = "Reconnectez-vous avec votre nouvelle adresse e-mail et votre nouveau mot de passe.", DUo = "Créez votre compte", LUo = "Créez votre compte Cal.com", MUo = "S'inscrire", FUo = "Vous avez été déconnecté", qUo = "Nous espérons vous revoir bientôt !", jUo = "Déconnecté", VUo = "Veuillez réessayer et nous contacter si le problème persiste.", BUo = "Le code de double authentification est incorrect.", UUo = "Aucun compte ne correspond à cette adresse email.", GUo = "Créer un compte", WUo = "Vous n'avez pas de compte ?", HUo = "Connectez-vous à votre compte", YUo = "Se connecter", KUo = "Retour à la page de connexion", ZUo = "Une erreur s'est produite lors de votre connexion. Retournez à l'écran de connexion et réessayez.", XUo = "Envoyer l'email de réinitialisation", JUo = "Envoyer l'invitation", QUo = "Mot de passe oublié ?", eGo = "Oublié ?", tGo = "Terminé", nGo = "Terminé !", oGo = "Tous", rGo = "Votre compte", iGo = "Applications disponibles", aGo = "Applications disponibles", sGo = "Consultez les applications populaires ci-dessous et explorez-en davantage dans notre <0>App Store</0>", cGo = "Ajoutez toute personne qui doit assister à l'événement. <0>En savoir plus</0>", lGo = "Les personnes d'un groupe se relaient, une personne de chaque groupe se présentera à l'événement.", uGo = "Les membres du groupe se relaient et une seule personne se présentera à l'événement.", dGo = "Vérifiez vos e-mails. Nous vous avons envoyé un lien pour réinitialiser votre mot de passe.", _Go = "Terminer", pGo = "Gérez les paramètres de langue et de fuseau horaire de votre équipe.", mGo = "Quelques mots à propos de vous. Ces informations apparaîtront sur votre page publique.", fGo = "C'est bientôt terminé !", gGo = "Dernière chose, une brève description de vous et une photo vous aident vraiment à obtenir des réservations et permettent aux gens de savoir avec qui ils réservent.", hGo = "Définissez des plages de temps pendant lesquelles vous êtes disponible de manière récurrente. Vous pourrez en créer d'autres ultérieurement et les assigner à différents calendriers.", vGo = "Définissez vos disponibilités", bGo = "Définissez des horaires pour les périodes où vous souhaitez être réservé.", yGo = "Partagez un lien ou une intégration", $Go = "Partagez votre lien ou intégration {{appName}} sur votre site.", wGo = "Paramètres de disponibilité", kGo = "Continuer sans calendrier", SGo = "Continuer avec {{appName}}", EGo = "Connectez votre calendrier", xGo = "Connectez vos applications vidéo", CGo = "Connectez vos applications vidéo pour les utiliser sur vos types d'événements.", TGo = "Connectez votre calendrier pour vérifier automatiquement les périodes d'indisponibilité et les nouveaux événements au fur et à mesure qu'ils sont programmés.", AGo = "Configurer plus tard", IGo = "Heure actuelle", OGo = "Détails", NGo = "Bienvenue", zGo = "Content de vous revoir", RGo = "Bienvenue sur {{appName}}", PGo = "Dites-nous comment vous appeler et indiquez-nous dans quel fuseau horaire vous vous trouvez. Vous pourrez modifier ces informations ultérieurement.", DGo = "Se connecter au serveur CalDAV (Bêta)", LGo = "Connexion à un flux ICS", MGo = "Connecter", FGo = "Essayez gratuitement", qGo = "Créez votre propre lien de réservation avec {{appName}}", jGo = "Qui", VGo = "Quoi", BGo = "Quand", UGo = "Où", GGo = "Ajouter au calendrier", WGo = "Sélectionnez où ajouter les événements lorsque vous êtes réservé.", HGo = "Ajouter les événements à", YGo = "Ajouter un autre calendrier", KGo = "Autre", ZGo = "Votre lien de connexion pour {{appName}}", XGo = "Vous avez rendez-vous avec {{user}}. Nous avons envoyé un e-mail avec une invitation de calendrier comprenant les détails à tout le monde.", JGo = "{{host}} a un rendez-vous avec {{attendee}}. Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants.", QGo = "Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants.", eWo = "Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants pour le premier de ces événements récurrents.", tWo = "Vous avez un rendez-vous avec {{user}}. Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants pour le premier de ces événements récurrents.", nWo = "{{host}} a un rendez-vous avec {{attendee}}. Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants pour le premier de ces événements récurrents.", oWo = "Nous avons envoyé cette information à tout le monde par e-mail.", rWo = "Votre réservation doit encore être confirmée ou refusée.", iWo = "Votre rendez-vous récurrent doit encore être confirmé ou refusé.", aWo = "{{user}} doit encore confirmer ou refuser la réservation.", sWo = "{{user}} doit encore confirmer ou refuser chaque réservation du rendez-vous récurrent.", cWo = "Le rendez-vous est planifié", lWo = "Les événements récurrents sont planifiés", uWo = "Votre réservation a été envoyée", dWo = "Votre rendez-vous récurrent a été envoyé", _Wo = "Votre réservation a été confirmée", pWo = "Votre rendez-vous récurrent a été confirmé", mWo = "Les paiements ne sont pas encore compatibles avec les événements récurrents", fWo = "Les événements récurrents ne sont pas encore compatibles avec les paiements", gWo = "Saisissez le nouveau mot de passe que vous souhaitez pour votre compte.", hWo = "Réinitialiser le mot de passe", vWo = "Modifier votre mot de passe", bWo = "Afficher le mot de passe", yWo = "Masquer le mot de passe", $Wo = "Réessayer", wWo = "Cette requête a expiré.", kWo = "Saisissez l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.", SWo = "Cette requête a expiré. Revenez en arrière et saisissez l'adresse e-mail associée à votre compte. Nous vous enverrons un autre lien pour réinitialiser votre mot de passe.", EWo = "Oups", xWo = "Connexion", CWo = "Succès", TWo = "Échoué", AWo = "Votre mot de passe a été réinitialisé. Vous pouvez désormais vous connecter avec votre nouveau mot de passe.", IWo = "Mise en page", OWo = "Vue par défaut", NWo = "Vous pouvez en sélectionner plusieurs, vos utilisateurs peuvent basculer entre les vues.", zWo = "Mise en page de réservation", RWo = "Vous pouvez en sélectionner plusieurs, les utilisateurs peuvent basculer entre les vues. Cela peut être remplacé individuellement pour événement.", PWo = "Mensuelle", DWo = "Hebdomadaire", LWo = "Colonnes", MWo = "Au moins une mise en page doit être activée.", FWo = "La mise en page sélectionnée comme vue par défaut ne fait pas partie des mises en page activées.", qWo = "La mise en page que vous avez sélectionnée n'est pas une mise en page valide.", jWo = "Vous pouvez gérer cela pour tous vos types d'événements dans Paramètres -> <0>Apparence</0> ou <1>Remplacer</1> pour cet événement uniquement.", VWo = "Une erreur inattendue s'est produite. Veuillez réessayer.", BWo = "Heure non valide le dimanche", UWo = "Créneau invalide le lundi", GWo = "Créneau invalide le mardi", WWo = "Créneau invalide le mercredi", HWo = "Créneau invalide le jeudi", YWo = "Créneau invalide le vendredi", KWo = "Créneau invalide le samedi", ZWo = "L'heure de fin ne peut être antérieure à l'heure de début", XWo = "L'heure de fin ne peut pas être supérieure à 24 heures", JWo = "Retour aux réservations", QWo = "N'hésitez pas à choisir un autre événement à tout moment.", e8o = "Annulées", t8o = "Aucune réservation", n8o = "En attente de l'hôte", o8o = "Annulation réussie", r8o = "Voulez-vous vraiment annuler votre réservation ?", i8o = "Vous ne pouvez pas annuler cette réservation", a8o = "Au lieu de cela, vous pouvez également le replanifier.", s8o = "L'événement est dans le passé", c8o = "L'événement est une instance d'un événement récurrent.", l8o = "Voici toutes les instances restantes dans l'événement récurrent.", u8o = "Une erreur avec le code de statut {{status}} est survenue.", d8o = "Un type d'événement avec cette URL existe déjà.", _8o = "Vous n'êtes pas autorisé à créer cet événement", p8o = "Vous n'êtes pas autorisé à modifier cet événement", m8o = "Vous n'êtes pas autorisé à créer ce workflow", f8o = "Vous n'êtes pas autorisé à créer ce planning", g8o = "Cette réservation a déjà été annulée", h8o = "Cette réservation a déjà été acceptée ou refusée.", v8o = "Retour à la page d'accueil", b8o = "Retour à la page d'accueil", y8o = "Aucun rendez-vous trouvé", $8o = "Ce rendez-vous n'existe pas. Contactez le propriétaire du rendez-vous pour obtenir un lien mis à jour.", w8o = "Aucune réservation {{status}} pour le moment", k8o = "Vous n'avez pas de réservations {{status}}. {{description}}", S8o = "{{eventName}} entre {{host}} et {{attendeeName}}", E8o = "Réservations", x8o = "Réservation introuvable", C8o = "Consultez les événements à venir et passés réservés via vos liens de type d'événement.", T8o = "Dès que quelqu'un réservera un rendez-vous avec vous, il apparaîtra ici.", A8o = "Dès que quelqu'un réserve un rendez-vous récurrent avec vous, il apparaît ici.", I8o = "Vos réservations passées apparaîtront ici.", O8o = "Vos réservations annulées apparaîtront ici.", N8o = "Vos réservations non confirmées apparaîtront ici.", z8o = "Réservations non confirmées", R8o = "le", P8o = "et", D8o = "Votre calendrier indique que vous êtes occupé entre", L8o = "Dépannage", M8o = "Comprendre pourquoi certains créneaux sont disponibles et d'autres sont bloquées.", F8o = "Voici un aperçu de votre journée le", q8o = "Astuce : Survolez les heures en gras pour obtenir un horodatage complet.", j8o = "Début", V8o = "Fin", B8o = "Marge de temps", U8o = "Avant l'événement", G8o = "Après l'événement", W8o = "Aucune marge de temps", H8o = "Intervalle", Y8o = "Votre journée commence à", K8o = "Votre journée se termine à", Z8o = "Lancer le dépannage", X8o = "Dépannez vos disponibilités pour découvrir pourquoi elles s'affichent comme cela.", J8o = "Changer les horaires de disponibilité", Q8o = "Changer vos horaires de disponibilité", e7o = "Modifier vos heures de début et de fin de journées", t7o = "Définissez l'heure de début et de fin de votre journée ainsi qu'une marge minimum entre vos rendez-vous.", n7o = "Actuellement, votre journée est configurée pour commencer à", o7o = "Les heures de début et de fin de votre journée ont été modifiées avec succès.", r7o = "et se termine à", i7o = "Clair", a7o = "Sombre", s7o = "Ajuster automatiquement l'apparence en fonction des préférences de l'invité", c7o = "Certains utilisateurs du groupe ont actuellement désactivé les réservations de groupe dynamiques", l7o = "Les liens de réservation de groupe peuvent être créés dynamiquement en ajoutant plusieurs noms d'utilisateur séparés par un « + ». Exemple : « {{appName}}/bailey+peer ».", u7o = "Autorisez les participants à prendre rendez-vous avec vous via des réservations de groupe dynamiques.", d7o = "Liens de groupe dynamiques", _7o = "Autorisez les moteurs de recherche à accéder à votre contenu public.", p7o = "Autoriser l'indexation par les moteurs de recherche", m7o = "Autoriser les notifications du navigateur", f7o = "Vous avez refusé les notifications. Réinitialisez l'autorisation dans les paramètres du navigateur pour les activer.", g7o = "Désactiver les notifications du navigateur", h7o = "Notifications du navigateur activées", v7o = "Notifications du navigateur désactivées", b7o = "Notifications du navigateur refusées", y7o = "Veuillez autoriser les notifications dans l'invite", $7o = "Notifications push", w7o = "Recevez des notifications push lorsqu'un utilisateur soumet une réservation de réunion instantanée.", k7o = "Votre navigateur ne prend pas en charge les notifications push. Si vous utilisez Brave, activez l'option 'Utiliser les services Google pour la messagerie push' dans brave://settings/?search=push+messaging", S7o = "E-mail", E7o = "jdoe@exemple.com", x7o = "Nom complet", C7o = "Parcourez la documentation de l'API", T7o = "Profitez de notre API pour tout personnaliser et contrôler.", A7o = "Créer un webhook", I7o = "Rendez-vous instantané créé", O7o = "Réservation annulée", N7o = "Réservation replanifiée", z7o = "Lien de téléchargement de l'enregistrement prêt", R7o = "Transcription générée", P7o = "Réservation créée", D7o = "Réservation rejetée", L7o = "Réservation demandée", M7o = "Paiement de la réservation initiée", F7o = "Rendez-vous terminé", q7o = "Formulaire envoyé", j7o = "Formulaire soumis, aucun événement réservé", V7o = "Réservation payée", B7o = "Absence créée", U7o = "Absence au rendez-vous mise à jour", G7o = "Déclencheurs d'événement", W7o = "Lien de l'abonné", H7o = "Créez un nouveau webhook", Y7o = "Webhooks", K7o = "Webhooks d’équipe", Z7o = "Créez un nouveau webhook sur votre compte", X7o = "Nouveau webhook", J7o = "Recevez les données de rendez-vous {{appName}} à un lien spécifié, en temps réel, lorsqu'un événement est planifié ou annulé.", Q7o = "Recevez les données de rendez-vous {{appName}} à un lien spécifié, en temps réel, lorsque cet événement est planifié ou annulé.", eHo = "iframe plein écran réactif", tHo = "Chargement...", nHo = "Suppression en cours...", oHo = "iframe standard", rHo = "Développeur", iHo = "Gérez vos paramètres de développeur.", aHo = "iframe intégré", sHo = "La façon la plus simple d'intégrer {{appName}} sur votre site web.", cHo = "Intégrez sur votre site web à l'aide de nos options d'intégration ou obtenez des informations sur les réservations en temps réel à l'aide de webhooks personnalisés.", lHo = "Planifier un rendez-vous", uHo = "Consultez et gérez vos informations de facturation.", dHo = "Consultez et modifiez vos informations de facturation, et annulez votre abonnement.", _Ho = "Accéder au portail de facturation", pHo = "Besoin d'autre chose ?", mHo = "Si vous avez besoin d'aide pour la facturation, notre équipe d'assistance est là pour vous aider.", fHo = "Contacter", gHo = "notre équipe d'assistance", hHo = "Contactez notre équipe d'assistance", vHo = "Oups !", bHo = "Cet utilisateur n'a pas encore configuré de type d'événement.", yHo = "Modifier le logo", $Ho = "Télécharger un logo", wHo = "Télécharger un logo", kHo = "Supprimer le logo", SHo = "Activer", EHo = "Code", xHo = "Le code est incorrect.", CHo = "Ajouter un créneau horaire", THo = "Ajoutez une sécurité supplémentaire à votre compte en cas de vol de votre mot de passe.", AHo = "Activer la double authentification", IHo = "Désactiver la double authentification", OHo = "Si vous avez besoin de désactiver la double authentification, nous vous recommandons de la réactiver dès que possible.", NHo = "Erreur lors de la désactivation de la double authentification", zHo = "Erreur lors de la configuration de la double authentification", RHo = "Sécurité", PHo = "Gérez la sécurité de votre compte.", DHo = "Mot de passe", LHo = "Mot de passe mis à jour avec succès", MHo = "Votre mot de passe a été modifié avec succès.", FHo = "Erreur lors de la modification du mot de passe", qHo = "La configuration de votre session a été mise à jour avec succès.", jHo = "Erreur lors de la mise à jour de la configuration de la session", VHo = "Une erreur s'est produite.", BHo = "Quelque chose ne va pas ?", UHo = "Veuillez réessayer.", GHo = "Votre nouveau mot de passe super sécurisé", WHo = "Nouveau mot de passe", HHo = "Votre ancien mot de passe", YHo = "Mot de passe actuel", KHo = "Modifier le mot de passe", ZHo = "Changer le secret", XHo = "Le nouveau mot de passe est identique à l'ancien. Veuillez choisir un mot de passe différent.", JHo = "Vous pouvez modifier ce secret si vous l'avez perdu ou oublié. Soyez cependant conscient que toutes les intégrations l'utilisant devront être mises à jour.", QHo = "Le mot de passe actuel est incorrect", eYo = "Mélange de lettres majuscules et minuscules", tYo = "7 caractères minimum", nYo = "Minimum 15 caractères", oYo = "Doit contenir au moins 1 chiffre", rYo = "Doit contenir {{limit}} caractères ou moins", iYo = "Le mot de passe doit contenir au moins {{passwordLength}} caractères, un chiffre et un mélange de lettres majuscules et minuscules.", aYo = "Le mot de passe est incorrect.", sYo = "L’adresse e-mail ou le mot de passe est incorrect.", cYo = "Utiliser le paramètre", lYo = "AM/PM", uYo = "Options de temps", dYo = "Janvier", _Yo = "Février", pYo = "Mars", mYo = "Avril", fYo = "Mai", gYo = "Juin", hYo = "Juillet", vYo = "Août", bYo = "Septembre", yYo = "Octobre", $Yo = "Novembre", wYo = "Décembre", kYo = "Lundi", SYo = "Mardi", EYo = "Mercredi", xYo = "Jeudi", CYo = "Vendredi", TYo = "Samedi", AYo = "Dimanche", IYo = "Tout est réservé.", OYo = "Impossible de charger les créneaux disponibles.", NYo = "Ajouter des invités", zYo = "Votre nom", RYo = "Votre nom complet", PYo = "Pas de nom", DYo = "Veuillez entrer un nombre entre 1 et {{maxOccurences}}", LYo = "Rapide et facile - aucun compte requis. Parfait pour les réunions ponctuelles.", MYo = "Adresse e-mail", FYo = "Veuillez saisir une adresse e-mail valide", qYo = " Veuillez programmer un appel ultérieur si nous ne sommes pas disponibles dans {{seconds}} secondes", jYo = "Lieu", VYo = "Adresse", BYo = "Entrer une adresse", UYo = "En personne (adresse du participant)", GYo = "Autre lieu", WYo = "Lieu personnalisé du participant", HYo = "Continuer en tant qu'invité", YYo = "Rejoindre en tant qu'invité", KYo = "Idéal pour les appels ponctuels", ZYo = "N'importe quel lieu", XYo = "Oui", JYo = "Non", QYo = "Notes supplémentaires", eKo = "Le rendez-vous n'a pas pu être réservé.", tKo = "Le rendez-vous n'a pas pu être replanifié.", nKo = "Merci de renseigner tout ce qui aidera à préparer notre rendez-vous.", oKo = "Confirmez votre {{eventTypeTitle}} avec {{profileName}}", rKo = "Replanifiez votre {{eventTypeTitle}} avec {{profileName}}", iKo = "Rendez-vous en personne", aKo = "En personne (adresse de l'organisateur)", sKo = "Rendez-vous avec lien", cKo = "Numéro de téléphone", lKo = "Numéro de téléphone du participant", uKo = "Numéro de téléphone de l'organisateur", dKo = "Saisissez votre numéro de téléphone", _Ko = "Replanifier", pKo = "Replanifier à la place", mKo = "Réserver plutôt un membre de l'équipe", fKo = "OU", gKo = "Retour", hKo = "Adresse e-mail ou identifiant", vKo = "Envoyer une invitation par e-mail", bKo = "Rôle", yKo = "Modifier le rôle", $Ko = "Voir le rôle", wKo = "Modifier l'équipe", kKo = "Modification de l'utilisateur", SKo = "Modification de l'organisation", EKo = "Si vous souhaitez modifier ou gérer vos webhooks, veuillez vous rendre dans les <0>paramètres des webhooks</0>", xKo = "Refuser", CKo = "Tout refuser", TKo = "Accepter", AKo = "Quitter", IKo = "Profil", OKo = "Lien de mon équipe", NKo = "Mes équipes", zKo = "Nom de l'équipe", RKo = "Nom de votre équipe", PKo = "Équipe mise à jour avec succès", DKo = "Votre équipe a été mise à jour avec succès.", LKo = "Votre organisation a été mise à jour avec succès.", MKo = "Erreur lors de la copie dans le presse-papiers", FKo = "À propos", qKo = "Quelques mots à propos de votre équipe. Ces informations apparaîtront sur la page publique de votre équipe.", jKo = "ID de l'organisation", VKo = "ID de l'organisation copié.", BKo = "Quelques phrases à propos de votre organisation. Elles apparaîtront sur la page de profil public de votre organisation.", UKo = "ID de l'équipe", GKo = "ID de l'équipe copié.", WKo = "Membres", HKo = "Membres de l'organisation", YKo = "Membre", KKo = "{{count}} membre", ZKo = "{{count}} membres", XKo = "{{count}} sélectionnés", JKo = "Propriétaire", QKo = "Administrateur", eZo = "API admin", tZo = "Utilisateur administrateur", nZo = "Nous allons créer le premier utilisateur administrateur.", oZo = "Utilisateur administrateur configuré", rZo = "Vous avez déjà créé un utilisateur administrateur. Vous pouvez maintenant vous connecter à votre compte.", iZo = "Nouveau membre", aZo = "Inviter", sZo = "Ajouter des membres d'équipe", cZo = "Ajouter des membres", lZo = "Invitez d'autres personnes à rejoindre votre équipe.", uZo = "Ajouter un membre d'équipe", dZo = "Inviter un nouveau membre d'équipe", _Zo = "Remarque : Cela <0>coûtera une place supplémentaire (15 $/mois)</0> sur votre abonnement.", pZo = "Invitez quelqu'un à rejoindre votre équipe.", mZo = "Télécharger un fichier .csv", fZo = "Inviter par e-mail", gZo = "Changer le rôle du membre de l'équipe", hZo = "Désactiver les références à la marque {{appName}}", vZo = "Supprimez toutes les références à la marque {{appName}} de vos pages publiques.", bZo = "Masquer le bouton Réserver un membre d'équipe", yZo = "Masquez le bouton Réserver un membre d'équipe de vos pages publiques.", $Zo = "Zone de danger", wZo = "Attention. La suppression du compte ne peut pas être annulée.", kZo = "Attention. La suppression de l'équipe ne peut pas être annulée.", SZo = "Retour", EZo = "Annuler", xZo = "Annuler tous les événements restants", CZo = "Appliquer", TZo = "Annuler l'événement", AZo = "Confirmer", IZo = "Confirmer tout", OZo = "Dissoudre l'équipe", NZo = "Voulez-vous vraiment dissoudre cette équipe ? Toute personne avec qui vous avez partagé ce lien d'équipe ne pourra plus faire de réservation en l'utilisant.", zZo = "Dissoudre l'organisation", RZo = "Voulez-vous vraiment dissoudre cette organisation ? Toutes les équipes et tous les membres seront supprimés.", PZo = "Voulez-vous vraiment supprimer ce membre de l'équipe ?", DZo = "Oui, dissoudre l'équipe", LZo = "Oui, supprimer le membre", MZo = "Oui, annuler l'abonnement", FZo = "Annuler l'abonnement", qZo = "L'annulation de votre abonnement désactivera définitivement votre forfait actuel. Cette action ne peut pas être annulée.", jZo = "Supprimer le membre", VZo = "Gérez votre équipe", BZo = "Vous n'avez pas encore d'équipe.", UZo = "Les équipes permettent aux autres de réserver des événements partagés entre vos collègues.", GZo = "Envoyer", WZo = "Oui, supprimer l'attribut", HZo = "Supprimer l'attribut", YZo = "Êtes-vous sûr de vouloir supprimer l'attribut '{{name}}' ? Tous les utilisateurs actuellement assignés à cet attribut seront désassignés.", KZo = "Mettre à jour", ZZo = "Enregistrer", XZo = "En attente", JZo = "Ouvrir les options", QZo = "Copier le lien vers l'événement", eXo = "Partager", tXo = "Voulez-vous réserver mon cal ou m'envoyer votre lien ?", nXo = "Copier le lien vers l'équipe", oXo = "Quitter l'équipe", rXo = "Oui, quitter l'équipe", iXo = "Voulez-vous vraiment quitter cette équipe ? Vous ne pourrez plus l'utiliser pour effectuer des réservations.", aXo = "{{user}} de {{team}}", sXo = "Aperçu", cXo = "Lien copié !", lXo = "Copié !", uXo = "Lien privé copié !", dXo = "Lien partagé !", _Xo = "Titre", pXo = "Description", mXo = "Statut des applications", fXo = "Un court rendez-vous vidéo.", gXo = "Type de planification", hXo = "Aperçu de l'équipe", vXo = "Collective", bXo = "Planifiez des rendez-vous lorsque tous les membres de l'équipe sélectionnés sont disponibles.", yXo = "Durée", $Xo = "Durées disponibles", wXo = "Durée par défaut", kXo = "Veuillez d'abord choisir les durées disponibles", SXo = "{{count}} $t(minute_timeUnit)", EXo = "{{count}} $t({{unit}}_timeUnit)", xXo = "{{count}}$t({{unit}}_short)", CXo = "minutes", TXo = "Utilisez Cal.ai pour obtenir un numéro de téléphone géré par une IA ou pour passer des appels à des invités.", AXo = "URI de terminaison", IXo = "Nom d'utilisateur du trunk SIP", OXo = "Mot de passe du trunk SIP", NXo = "Surnom", zXo = "Supprimer le numéro de téléphone", RXo = "La validation du workflow a échoué", PXo = "Un ou plusieurs étapes du workflow ont un contenu de message vide", DXo = "Un ou plusieurs numéros de téléphone ou adresses e-mail ne sont pas vérifiés", LXo = "Optimisez vos flux de travail avec Cal.ai", MXo = "Des agents IA réalistes qui réservent des réunions, envoient des rappels et assurent le suivi avec vos clients.", FXo = "Numéro de téléphone importé et lié à l'agent avec succès", qXo = "Numéro de téléphone supprimé avec succès", jXo = "Êtes-vous sûr de vouloir supprimer ce numéro de téléphone ? Cette action ne peut pas être annulée.", VXo = "Oui, supprimer le numéro de téléphone", BXo = "Le numéro que vous essayez d'importer doit être au format E.164 (indicatif du pays suivi du numéro, sans espaces ni caractères spéciaux), par exemple +1234567890", UXo = "L'URI de terminaison pour identifier de manière unique votre trunk SIP élastique. Il est utilisé pour les appels sortants. Pour les trunks SIP élastiques Twilio, il se termine toujours par .pstn.twilio.com.", GXo = "Le nom d'utilisateur utilisé pour authentifier le trunk SIP.", WXo = "Le mot de passe utilisé pour authentifier le trunk SIP.", HXo = "Surnom du numéro. Ceci est uniquement pour votre référence.", YXo = "Enregistrer et tester l'appel", KXo = "Appel initié avec succès", ZXo = "Veuillez saisir un numéro de téléphone", XXo = "Agent mis à jour avec succès", JXo = "Agent créé avec succès", QXo = "Type d'événement ajouté avec succès", eJo = "Numéro de téléphone désabonné avec succès", tJo = "Cette invite définit le rôle et les objectifs principaux de l'agent", nJo = "Invite", oJo = "Appeler", rJo = "Effectuer un appel test pour vérifier la configuration", iJo = "Message initial", aJo = "Le premier message que l'agent dira au début d'un appel", sJo = "Des difficultés à importer ?", cJo = "Apprendre", lJo = "Apprenez comment obtenir votre URI de terminaison et vos identifiants de trunk SIP", uJo = "Abonnement au numéro de téléphone annulé avec succès", dJo = "Mise à jour en cours", _Jo = "Round-robin", pJo = "Bonjour, comment allez-vous ?", mJo = "Alternez vos rendez-vous entre plusieurs membres d'équipe.", fJo = "Événement géré", gJo = "nom d'utilisateur", hJo = "Créez et distribuez plusieurs types d'événements aux membres de l'équipe.", vJo = "Géré", bJo = "« nom d'utilisateur » sera rempli par le nom d'utilisateur des membres assignés", yJo = "Assigner à", $Jo = "Saisissez un numéro de téléphone pour tester l'appel", wJo = "Effectuer un appel test", kJo = "Créer un nouvel agent vocal cal.ai pour workflow", SJo = "Créez un nouvel agent vocal cal.ai pour automatiser vos workflows", EJo = "Numéro de téléphone (pour que notre agent puisse appeler)", xJo = "Achetez un numéro de téléphone ou importez-en un que vous possédez déjà sur Twilio", CJo = "Tester l'agent", TJo = "Tester l'appel web", AJo = "Numéros de téléphone", IJo = "Se désabonner", OJo = "Supprimer l'étape du workflow", NJo = "Désabonner le numéro de téléphone", zJo = "Acheter un nouveau numéro", RJo = "Vous ne pouvez acheter que des numéros de téléphone américains. Pour les autres pays, vous pouvez importer votre propre numéro Twilio.", PJo = "Acheter un numéro américain pour ${{priceInDollars}} par mois", DJo = "Destinations d'appel prises en charge", LJo = "Aucun numéro de téléphone connecté", MJo = "Échec de récupération de l'ID de l'étape du workflow", FJo = "Agent Cal.ai", qJo = "Tester l'agent Cal.ai", jJo = "Êtes-vous sûr de vouloir supprimer cette étape du workflow ?", VJo = "Voulez-vous toujours désabonner ce numéro de téléphone de cet agent ?", BJo = "Cette action déconnectera le numéro de téléphone de l'agent. L'agent ne pourra pas passer d'appels tant qu'un nouveau numéro de téléphone ne sera pas connecté.", UJo = "Numéros de téléphone", GJo = "Connecter un numéro de téléphone", WJo = "Gérez vos numéros de téléphone", HJo = "Importer un numéro", YJo = "Cette action va également :", KJo = "Importer un numéro de téléphone", ZJo = "Abonnement actif", XJo = "Annuler votre abonnement de numéro de téléphone", JJo = "Supprimer le numéro de téléphone associé", QJo = "Vous n'êtes pas autorisé à créer ce workflow", eQo = "Importez votre numéro de téléphone Twilio pour l'utiliser avec Phone", tQo = "${{price}}/mois", nQo = "Acheter un nouveau numéro", oQo = "L'achat d'un numéro de téléphone coûte ${{priceInDollars}} par mois. Vous serez facturé mensuellement pour chaque numéro de téléphone actif.", rQo = "Indicatif régional (facultatif)", iQo = "Aucun numéro de téléphone", aQo = "Numéro de téléphone acheté avec succès", sQo = "Annuler l'abonnement au numéro de téléphone", cQo = "Oui, annuler l'abonnement", lQo = "Êtes-vous sûr de vouloir annuler cet abonnement au numéro de téléphone ? Cette action ne peut pas être annulée et vous perdrez l'accès à ce numéro de téléphone.", uQo = "Ajouter des membres...", dQo = "Ajouter des membres", _Qo = "Aucun membre assigné", pQo = "Assigné à", mQo = "Vous devez être connecté(e) à {{url}}", fQo = "Commencez à assigner des membres ci-dessus", gQo = "Les membres ne pourront pas modifier ceci.", hQo = "Les membres peuvent modifier", vQo = "Cette option a été verrouillée par l'administrateur de l'équipe.", bQo = "Déverrouillé par l'administrateur de l'équipe", yQo = "Lien", $Qo = "Masqué", wQo = "Lecture seule", kQo = "Lien à usage unique", SQo = "Vous êtes actuellement sur le plan {{plan}}.", EQo = "Mettez à niveau votre compte vers le plan Pro pour débloquer toutes les fonctionnalités que nous avons à proposer.", xQo = "Vous devez mettre à niveau votre plan pour avoir plus d'un type d'événement actif.", CQo = "Vous devez mettre à niveau votre plan pour créer une équipe.", TQo = "Vous pouvez <1>mettre à niveau ici</1>.", AQo = "Types d'évènements", IQo = "Créez des événements à partager pour que les personnes puissent réserver des créneaux sur votre calendrier.", OQo = "Nouveau type d'événement", NQo = "Créez votre premier type d'événement", zQo = "Les types d'événements vous permettent de partager des liens qui affichent vos disponibilités sur votre calendrier et permettent aux personnes de réserver des créneaux.", RQo = "{{eventTypeTitle}} type d'événement créé avec succès", PQo = "{{eventTypeTitle}} type d'événement mis à jour avec succès", DQo = "Type d'événement supprimé avec succès", LQo = "heures", MQo = "Personnes", FQo = "Votre adresse e-mail", qQo = "Changer d'avatar", jQo = "Télécharger un avatar", VQo = "Langue", BQo = "Fuseau horaire", UQo = "Premier jour de la semaine", GQo = "Répéter jusqu'à {{count}} fois", WQo = "Répéter jusqu'à {{count}} fois", HQo = "Chaque {{freq}} pour", YQo = "{{count}} événement restant", KQo = "{{count}} événements restants", ZQo = "Répéter chaque", XQo = "occurrence", JQo = "occurrences", QQo = "semaine", eer = "semaines", ter = "mois", ner = "mois", oer = "année", rer = "années", ier = "{{count}} de plus", aer = "max.", ser = "Thème unique", cer = "Couleur de la marque", ler = "Couleur de la marque (clair)", uer = "Couleur de la marque (sombre)", der = "Couleur du type d'événement (Thème clair)", _er = "Couleur du type d'événement (Thème sombre)", per = "Le fichier n'est pas nommé [idOrSlug]/[user]", mer = "Créer une équipe", fer = "Nom", ger = "Équipe sans nom", her = "Clients OAuth", ver = "Gérer les clients OAuth pour votre organisation", ber = "Créer un client OAuth", yer = "Créer un nouveau client OAuth pour les intégrations tierces", $er = "Client OAuth supprimé avec succès", wer = "Créez une nouvelle équipe pour collaborer avec les utilisateurs.", ker = "Créer une nouvelle équipe", Ser = "URL de votre page de réservation", Eer = "URL de la page où vos utilisateurs peuvent annuler leur réservation", xer = "URL de la page où vos utilisateurs peuvent replanifier leur réservation", Cer = "Ce créneau n'est plus disponible. Veuillez revenir à la page précédente et sélectionner un autre horaire.", Ter = "Invitations ouvertes", Aer = "Nouvelle équipe", Ier = "Créez votre première équipe et invitez d'autres utilisateurs à travailler ensemble.", Oer = "Créez une équipe pour commencer", Ner = "Équipes", zer = "Équipe", Rer = "Organisation", Per = "Facturation de l'équipe", Der = "Gérez la facturation pour votre équipe.", Ler = "Nous avons modifié la facturation pour les équipes", Mer = "Des membres dans votre équipe n'ont pas de place. Mettez à niveau votre plan Pro pour couvrir les places manquantes.", Fer = "Depuis janvier 2022, nous facturons chaque place aux membres de l'équipe. Les membres de votre équipe qui ont eu le plan Pro gratuitement disposent maintenant d'un essai de 14 jours. Une fois leur période d'essai expirée, ces membres seront masqués pour votre équipe sauf si vous mettez à niveau maintenant.", qer = "Créez et gérez des équipes pour utiliser les fonctionnalités collaboratives.", jer = "Cette fonctionnalité n'est disponible que dans le plan Pro", Ver = "Pour supprimer les références à la marque {{appName}} de vos pages de réservation, vous devez passer à un compte Pro.", Ber = "Modifiez les informations de votre profil, qui apparaissent sur votre lien de réservation.", Uer = "Vous devrez peut-être vous reconnecter pour que la modification prenne effet.", Ger = "Quelque mots à propos de vous.", Wer = "Profil mis à jour avec succès", Her = "Votre profil utilisateur a été mis à jour avec succès.", Yer = "Votre mise à niveau est disponible", Ker = "Améliorez votre expérience de planification en passant au nouveau plan et profitez des nouvelles fonctionnalités.", Zer = "Tout est prêt", Xer = "Vous disposez déjà du dernier plan. Aucune mise à niveau nécessaire. Profitez des nouvelles fonctionnalités et contactez-nous pour toute question !", Jer = "L'utilisateur semble connecté, mais est introuvable dans la base de données.", Qer = "Intégrations et webhooks", etr = "Activé", ttr = "Désactivé", ntr = "Désactiver", otr = "Facturation", rtr = "ici", itr = "Gérez vos informations de facturation et annulez votre abonnement.", atr = "Disponibilités", str = "Modifier les disponibilités", ctr = "Définissez les moments où vous êtes disponible pour les réservations.", ltr = "Copier les créneaux vers", utr = "Copier les horaires dans…", dtr = "Modifier votre planning hebdomadaire", _tr = "Logo", ptr = "Erreur", mtr = "Veuillez saisir au moins un caractère", ftr = "Veuillez saisir au moins {{count}} caractères", gtr = "Logo de l'équipe", htr = "Ajouter un lieu", vtr = "Participants", btr = "Ajouter des participants", ytr = "Afficher les paramètres avancés", $tr = "Masquer les paramètres avancés", wtr = "Nom de l'événement", ktr = "Nom de l'événement dans le calendrier", Str = "Le nom qui apparaîtra dans les calendriers", Etr = "{Event type title} entre {Organiser} et {Scheduler}", xtr = "Champs supplémentaires", Ctr = "Exiger que le planificateur saisisse des champs supplémentaires avant la confirmation de la réservation.", Ttr = "Libellé", Atr = "Texte de substitution", Itr = "Afficher l'e-mail « Ajouter au calendrier » en tant qu'organisateur", Otr = "Nous afficherons cette adresse e-mail en tant qu'organisateur et enverrons les e-mails de confirmation à cette adresse.", Ntr = "Si cette option est activée, nous afficherons l'adresse e-mail de votre « Ajouter au calendrier » en tant qu'organisateur et nous enverrons des e-mails de confirmation à cette adresse", ztr = "Veuillez noter que vous devrez peut-être vous déconnecter puis reconnecter votre compte 'Ajouter au calendrier' pour utiliser cette fonctionnalité.", Rtr = "Type", Ptr = "Modifier", Dtr = "Ajouter un champ", Ltr = "Masquer les notes dans le calendrier", Mtr = "Pour des raisons de confidentialité, les champs et notes supplémentaires seront masquées dans l'entrée du calendrier. Elles vous seront tout de même envoyées par e-mail.", Ftr = "La réservation doit être confirmée manuellement avant d'être poussée vers les intégrations et qu'un e-mail de confirmation soit envoyé.", qtr = "Les réservations non confirmées bloquent quand même les créneaux du calendrier.", jtr = "Événement récurrent", Vtr = "Les personnes peuvent s'inscrire à des événements récurrents.", Btr = "Se connecter et rejoindre", Utr = "À ne pas utiliser avec les types d'événement payants", Gtr = "Les Rendez-vous instantanés ne sont pas encore pris en charge par les événements récurrents et les applications de paiement", Wtr = "Expérimental : Les événements de Rendez-vous instantané sont actuellement expérimentaux.", Htr = "Début", Ytr = "Désactiver les invités", Ktr = "Désactivez l'ajout d'invités supplémentaires lors de la réservation.", Ztr = "Générer un lien privé", Xtr = "Rendre le lien privé", Jtr = "Lien privé", Qtr = "Votre lien privé sera régénéré après chaque utilisation", enr = "Copier le lien privé", tnr = "Copier le lien privé de l'événement", nnr = "Générez un lien privé à partager sans révéler votre nom d'utilisateur {{appName}}.", onr = "Liens privés", rnr = "Générer des URL privées sans exposer le nom d'utilisateur, avec des limites d'expiration et d'utilisation configurables", inr = "Ajouter un nouveau lien", anr = "Lien privé copié", snr = "Les invités peuvent réserver", cnr = "Plage de dates", lnr = "jours calendaires", unr = "jours ouvrés", dnr = "Définir une adresse ou un lieu", _nr = "Définir un lien vers le rendez-vous", pnr = "Ne peut pas être modifié. Il ne peut être déverrouillé que pour les types d'événements enfants", mnr = "{{appName}} demandera à votre invité d'entrer un numéro de téléphone avant de faire une réservation.", fnr = "{{appName}} fournira un lien Google Meet.", gnr = "{{appName}} fournira un lien de rendez-vous Zoom.", hnr = "{{appName}} fournira un lien de rendez-vous Tandem.", vnr = "{{appName}} fournira un lien de rendez-vous vidéo.", bnr = "Nous générerons un lien de réunion Jitsi Meet pour vous.", ynr = "{{appName}} fournira un lien de rendez-vous vidéo Huddle01.", $nr = "{{appName}} fournira un lien de rendez-vous MS Teams. NOTE : IL FAUT AVOIR UN COMPTE PROFESSIONNEL OU SCOLAIRE", wnr = "Exiger un paiement", knr = "Vous devez ajouter un nom", Snr = "commission par transaction", Enr = "Votre type d'événement a été mis à jour avec succès.", xnr = "Masquer le type d'événement", Cnr = "Modifier le lieu", Tnr = "dans le futur", Anr = "Lorsque réservé avec moins de <0></0> de préavis", Inr = "Dans une plage de dates", Onr = "Indéfiniment dans le futur", Nnr = "Ajouter un nouveau champ personnalisé", znr = "Conversation rapide", Rnr = "Ajouter un nouveau type d'événement d'équipe", Pnr = "Ajouter un nouveau type d'événement", Dnr = "Créez un nouveau type d’événement pour que les personnes puissent effectuer des réservations.", Lnr = "Durée", Mnr = "Préavis minimum", Fnr = "Décalage de l'heure de début", qnr = "Appliquez un décalage de durée spécifique aux créneaux horaires affichés aux utilisateurs.", jnr = "Décalage de", Vnr = "p. ex. cela affichera les créneaux à vos utilisateurs à {{ adjustedTime }} au lieu de {{ originalTime }}", Bnr = "Fréquence de créneaux horaires", Unr = "Utiliser la durée de l'événement (par défaut)", Gnr = "Supprimer le type d'événement ?", Wnr = "Supprimer le type d'événement géré ?", Hnr = "Toute personne avec qui vous avez partagé ce lien ne pourra plus réserver avec.", Ynr = "Les membres assignés à ce type d'événement verront également leurs types d'événements supprimés.", Knr = "Toute personne avec qui ils ont partagé leur lien ne pourra plus réserver en l'utilisant.", Znr = "Oui, supprimer", Xnr = "Supprimer le compte", Jnr = "Oui, supprimer le compte", Qnr = "Toute personne avec qui vous avez partagé le lien de votre compte ne pourra plus réserver en utilisant ce lien et toutes les préférences que vous avez sauvegardées seront perdues.", eor = "Intégrations", tor = "Applications", nor = "Vous trouverez ici une liste de vos applications.", oor = "Liste des applications", ror = "Applications {{category}}", ior = "App Store", aor = "Connecter les personnes, la technologie et l'espace de travail.", sor = "Connectez votre application de visioconférence", cor = "Paramètres", lor = "Le type d'événement a été déplacé avec succès", uor = "Prochaine étape", dor = "Passer l'étape", _or = "Étape précédente", por = "Installer", mor = "Démarrer l'essai gratuit", gor = "Installée", hor = "{{count}} installation active", vor = "{{count}} installations actives", bor = "Installée globalement", yor = "Application installée avec succès", $or = "L'application n'a pas pu être installée", wor = "Déconnecter", kor = "Intégrez votre calendrier dans votre page web", Sor = "Connectez vos applications favorites.", Eor = "Automatisation", xor = "Configurez la manière dont vos types d'événements doivent interagir avec vos calendriers.", Cor = "Activez/désactivez les calendriers pour lesquels vous souhaitez vérifier les conflits afin d'éviter les doubles réservations.", Tor = "Connecter un calendrier supplémentaire", Aor = "Calendrier mis à jour avec succès", Ior = "Vérifier ici", Oor = "Visioconférence", Nor = "Calendrier", zor = "Paiements", Ror = "Non installé", Por = "Les mots de passe ne correspondent pas.", Dor = "Ce champ est obligatoire.", Lor = "Statut", Mor = "Voir les disponibilités de l'utilisateur", For = "L'utilisateur doit accepter l'invitation pour voir les disponibilités", qor = "Se définir comme absent", jor = "Désactiver le statut absent", Vor = "Erreur lors de la mise à jour du statut d'absence", Bor = "Cet utilisateur est actuellement absent.", Uor = "La personne avec qui vous essayez de prendre rendez-vous est absente et n'accepte donc pas de nouvelles réservations.", Gor = "Rencontrez des personnes avec les mêmes tokens", Wor = "Réservez et autorisez uniquement les réservations de personnes qui partagent les mêmes tokens, DAO ou NFT.", Hor = "Votre compte a été créé à l'aide d'un fournisseur d'identité.", Yor = "Votre compte est géré par {{provider}}", Kor = "Pour modifier votre adresse e-mail et/ou votre mot de passe, activez l'authentification à deux facteurs et plus, veuillez consulter les paramètres de votre compte {{provider}}.", Zor = "Votre compte est géré par un fournisseur d'identité différent. Essayez de vous connecter avec {{provider}}.", Xor = "Erreur lors de la création d'un nouvel utilisateur. Veuillez réessayer.", Jor = "Se connecter avec Google", Qor = "Se connecter avec SAML", err = "Se connecter avec SAML/OIDC", trr = "Continuer avec l'e-mail", nrr = "Continuer avec Google", orr = "Dernière utilisation", rrr = "Vous devrez générer un token d'accès à partir de votre ancien outil de planification.", irr = "Importer depuis", arr = "Token d'accès", srr = "Feuille de route", crr = "Catégories en vedette", lrr = "Drapeaux de fonctionnalités", urr = "Ici, vous pouvez activer ou désactiver les fonctionnalités de votre instance Cal.com.", drr = "Catégories populaires", _rr = "{{count}} Application", prr = "{{count}} applications", mrr = "Applications populaires", frr = "Les plus populaires", grr = "Apps installées", hrr = "Gratuit", vrr = "Aucune application {{category}}", brr = "Toutes les apps", yrr = "Ajoutez une application de calendrier pour vérifier les conflits et éviter les doubles réservations.", $rr = "Essayez d'ajouter une application de visioconférence pour les appels vidéo avec vos clients.", wrr = "Ajoutez une application de paiement pour faciliter les transactions entre vous et vos clients.", krr = "Ajoutez une application d'analyse pour vos pages de réservation.", Srr = "Ajoutez une application d'automatisation.", Err = "Ajoutez n'importe quel autre type d'application pour faire toutes sortes de choses.", xrr = "Ajoutez une application de messagerie pour configurer des notifications et des rappels personnalisés.", Crr = "Ajoutez une application de CRM pour garder une trace des personnes que vous avez rencontrées.", Trr = "Définissez les calendriers pour vérifier les conflits afin d'éviter les doubles réservations.", Arr = "Configurez les services de traitement de paiement à utiliser lors de la facturation de vos clients.", Irr = "Configurez les applications d'analyse à utiliser pour vos pages de réservation.", Orr = "Toutes vos applications installées à partir d'autres catégories.", Nrr = "Configurez les applications de conférence à utiliser.", zrr = "Configurez les applications d'automatisation à utiliser.", Rrr = "Configurez les applications de messagerie à utiliser pour configurer des notifications et des rappels personnalisés.", Prr = "Configurez les applications de CRM à utiliser pour garder une trace des personnes que vous avez rencontrées.", Drr = "Analytiques", Lrr = "Aucune application installée", Mrr = "Les applications vous permettent d'améliorer votre workflow et votre processus de planification de façon significative.", Frr = "Explorer l'App Store", qrr = "Gérez vos applications installées ou modifiez les paramètres.", jrr = "Parcourir les applications", Vrr = "Fonctionnalités", Brr = "Permissions", Urr = "Conditions et confidentialité", Grr = "Publiée par {{author}}", Wrr = "S'abonner", Hrr = "Acheter", Yrr = "Installer l'application", Krr = "Catégories", Zrr = "Prix", Xrr = "En savoir plus", Jrr = "Essayer maintenant", Qrr = "Politique de confidentialité", eir = "Conditions d'utilisation", tir = "Supprimer", nir = "Ajouter", oir = "{{count}} installation(s)", rir = "Vérifier le portefeuille", iir = "Créer des événements dans :", air = "Ceci est une fonctionnalité commerciale", sir = "Vous pouvez tester cette fonctionnalité en local, mais pas en production.", cir = "Pour acheter une licence commerciale, veuillez contacter notre équipe commerciale. Si une clé de licence est déjà en place, veuillez contacter support@cal.com pour obtenir de l'aide.", lir = "Licence manquante", uir = "Prochaines étapes", dir = "Obtenir une licence commerciale", _ir = "Le plan d'infrastructure est basé sur l'utilisation et propose des réductions adaptées aux startups.", pir = "Créer un compte via Prisma Studio", mir = "Découvrez comment configurer votre premier utilisateur", fir = "Contacter le service commercial", gir = "Erreur 404", hir = "Définir par défaut", vir = "Nouveau planning", bir = "Ajouter un nouveau planning", yir = "Ajouter un nouveau calendrier", $ir = "Définissez où ajouter les nouveaux événements après une réservation.", wir = "Supprimer le planning", kir = "La suppression d'un planning l'enlèvera de tous les types d'événements. Cette action ne peut pas être annulée.", Sir = "Planning {{scheduleName}} créé avec succès", Eir = "Planning {{scheduleName}} mis à jour avec succès", xir = "Planning supprimé avec succès", Cir = "Heures de travail", Tir = "Créer un planning de disponibilité", Air = "La création de plannings de disponibilité vous permet de gérer la disponibilité pour tous les types d'événements. Ils peuvent être appliqués à un ou plusieurs types d'événements.", Iir = "Nécessite la propriété d'un token appartenant à l'adresse suivante :", Oir = "Jean Dupont", Nir = "Format horaire", zir = "Rediriger après la réservation", Rir = 'Vous allez être redirigé vers {{ url }} dans $t(second, {"count": {{seconds}} }).', Pir = "https://example.com/redirect-to-my-success-page", Dir = "Redirigez l'utilisateur vers un lien personnalisé après une réservation réussie.", Lir = "Dupliquer", Mir = "Proposer des places", Fir = "Proposez des places de réservation. Cela désactive automatiquement les réservations d'invités et d'opt-in.", qir = "Place disponible", jir = "Places disponibles", Vir = "Places presque toutes occupées", Bir = "Les places partent vite", Uir = "Nombre de places par réservation", Gir = "Définir la fenêtre de participation à la réunion (secondes) : La période en secondes pendant laquelle l'hôte peut rejoindre et démarrer la réunion. Après cette période, l'URL de participation à la réunion expirera.", Wir = "Saisir le nombre de places", Hir = "Vous pouvez gérer vos disponibilités sur la page Disponibilité.", Yir = "Plus de places disponibles", Kir = "Clés API", Zir = "Clé API", Xir = "Tester la clé API", Jir = "Test réussi !", Qir = "Échec du test", ear = "Fournir une clé d'API", tar = "Les clés API vous permettent d'effectuer des appels API pour votre propre compte.", nar = "Créez plutôt une place de marché ou une plateforme.", oar = "Générer des clés API à utiliser pour accéder à votre propre compte.", rar = "Créer une clé API", iar = "Nommer cette clé", aar = "Par exemple : développement", sar = "Clé API sans nom", car = "Cette clé API n'a pas de date d'expiration", lar = "Modifier la clé API", uar = "Clé API créée avec succès", dar = "Clé API mise à jour avec succès", _ar = "Créer", par = "Enregistrez cette clé API dans un endroit sûr.", mar = "Vous ne pourrez plus la revoir après avoir fermé cette boîte de dialogue.", far = "Copier dans le presse-papiers", gar = "Activée après mise à jour", har = "Le lien privé fonctionnera après l'enregistrement", bar = "Révoquer cette clé API", yar = "Désactiver le report", $ar = "Les invités ne peuvent plus reporter l'événement via l'invitation au calendrier ou l'e-mail", war = "Autoriser la réservation via le lien de replanification", kar = "Lorsque cette option est activée, les utilisateurs pourront créer une nouvelle réservation lorsqu'ils essaient de reprogrammer une réservation annulée", Sar = "Désactiver l'annulation", Ear = "Les invités ne peuvent plus annuler l'événement via l'invitation au calendrier ou l'e-mail", xar = "Révoquer la clé API", Car = "Clé API copiée !", Tar = "La clé API expirera le", Aar = "Supprimer définitivement cette clé API de votre compte ?", Iar = "Copier", Oar = "Date d'expiration", Nar = "Expirée", zar = "N'expire jamais", Rar = "Expire", Par = "Demander une replanification de votre réservation", Dar = "Raison de la replanification", Lar = "Réserver un nouveau créneau", Mar = "Demande de replanification envoyée", Far = "Ceci annulera le rendez-vous planifié et demandera à l'invité de choisir un nouveau créneau.", qar = "Raison de la demande de replanification", jar = "Demander une replanification ", Var = "Modifier la réservation", Bar = "Replanifier la réservation", Uar = "Ancien créneau", Gar = "Ajouter un GIF à la page de confirmation", War = "Rechercher", Har = "Emprunt d'identité", Yar = "Emprunt d'identité", Kar = "Autorisez notre équipe d'assistance à se connecter temporairement à votre place pour nous aider à résoudre les problèmes que vous pourriez nous signaler.", Zar = "Autorisez les propriétaires/administrateurs de votre équipe à se connecter temporairement à votre place.", Xar = "Gratuit pour les particuliers. Plans Équipes pour les fonctionnalités collaboratives.", Jar = "Rendre l'organisation privée", Qar = "Les membres de votre organisation ne pourront pas voir les autres membres de l'organisation lorsque cette option est activée.", esr = "Rendre l'équipe privée", tsr = "Les membres de votre équipe ne pourront pas voir les autres membres de l'équipe si cette option est activée.", nsr = "Vous ne pouvez pas voir tous les membres d'une équipe privée.", osr = "Vous ne pouvez pas voir les équipes d'une organisation privée.", rsr = "Autoriser plusieurs durées", isr = "Toutes les utilisations de cette fonctionnalité sont vérifiées.", asr = "Emprunt du nom d'utilisateur « {{user}} ».", ssr = "Cliquez ici pour arrêter", csr = "Mise à jour - Votre événement a changé de lieu", lsr = "Ajoutés - Nouveaux invités ajoutés à votre événement", usr = "Lieu modifié : {{eventType}} avec {{name}} le {{date}}", dsr = "Invités ajoutés : {{eventType}} avec {{name}} le {{date}}", _sr = "Lieu actuel", psr = "Nouveau lieu", msr = "Session", fsr = "Contrôlez la session de votre compte.", gsr = "Expiration de la session après", hsr = "Expiration de la session", vsr = "Invalidez votre session après un certain temps.", bsr = "Aucun lieu défini", ysr = "Définir le lieu", $sr = "Mettre à jour le lieu", wsr = "Lieu mis à jour", ksr = "La mise à jour du lieu a échoué", Ssr = "Invités ajoutés", Esr = "Impossible d'ajouter des invités", xsr = "Ceci ne ressemble pas à une adresse e-mail", Csr = "Les adresses e-mail doivent être uniques et valides", Tsr = "Cela ne ressemble pas à une URL valide", Asr = "Placez ce code dans votre HTML à l'endroit où vous souhaitez que votre widget {{appName}} apparaisse.", Isr = "Créez ou mettez à jour un composant React existant comme indiqué ci-dessous.", Osr = "Copier le code", Nsr = "Code copié !", zsr = "Comment souhaitez-vous ajouter {{appName}} à votre site ?", Rsr = "Choisissez l'une des méthodes suivantes pour mettre {{appName}} sur votre site.", Psr = "Configuration de votre intégration Zapier", Dsr = "Configuration de votre intégration Make", Lsr = "Générer une clé API", Msr = "Générer une clé API à utiliser avec {{appName}} sur", Fsr = "Votre clé API unique", qsr = "Copiez cette clé API et conservez-la dans un endroit sûr. Si vous perdez cette clé, vous devrez en générer une nouvelle.", jsr = "<0>Connectez-vous à votre compte Zapier et créez un nouveau Zap.</0><1>Sélectionnez Cal.com comme application déclencheur. Choisissez également un événement déclencheur.</1><2>Choisissez votre compte, puis saisissez votre clé API unique.</2><3>Testez votre déclencheur.</3><4>Vous êtes prêt !</4>", Vsr = "Accédez à <0>Make Invite Link</0> et installez l'application Cal.com.", Bsr = "Connectez-vous à votre compte Make et créez un nouveau scénario.", Usr = "Sélectionnez Cal.com comme application déclencheur. Choisissez également un événement déclencheur.", Gsr = "Choisissez votre compte puis saisissez votre clé API unique.", Wsr = "Testez votre déclencheur.", Hsr = "Vous êtes prêt !", Ysr = "Veuillez d'abord installer l'application Zapier dans l'App Store.", Ksr = "Veuillez d'abord installer l'application Make dans l'App Store.", Zsr = "Installation de l'application", Xsr = "Application non installée", Jsr = "Désolé, cette application n'est pas installée sur votre compte. Veuillez visiter notre boutique d'applications pour explorer et découvrir celle-ci et d'autres applications intéressantes.", Qsr = "Se connecter au serveur d'Apple", ecr = "Lien du calendrier", tcr = "Générez un mot de passe pour application à utiliser avec {{appName}} sur", ncr = "Impossible d'ajouter ce compte Apple Calendar. Veuillez vous assurer que vous utilisez un mot de passe spécifique à l'application plutôt que le mot de passe de votre compte.", ocr = "Vos identifiants seront stockés et chiffrés.", rcr = "Elle sera stockée et chiffrée.", icr = "Accéder à l'App Store", acr = "Une erreur est survenue, essayez de reconnecter votre calendrier avec toutes les autorisations nécessaires", scr = "Définir un numéro de téléphone pour le rendez-vous", ccr = "Aucun créneau n'est occupé", lcr = "Afficher sur la page de réservation", ucr = "Le lieu sera visible avant la confirmation de la réservation", dcr = "Ajouter un GIF", _cr = "Rechercher dans Giphy", pcr = "Ajouter un lien depuis Giphy", mcr = "Ajout d'un GIF à la page de confirmation", fcr = "Trouvez un GIF pour agrémenter votre page de confirmation", gcr = "Partagez vos commentaires", hcr = "Ressources", vcr = "Documentation d'assistance", bcr = "Documentation pour développeurs", ycr = "Contactez-nous", $cr = "Contacter l'assistance", wcr = "Assistance Premium", kcr = "Aide communautaire", Scr = "Commentaires", Ecr = "Merci pour vos commentaires !", xcr = "Erreur lors de l'envoi du commentaire", Ccr = "Partagez vos commentaires ici :", Tcr = "Informations sur la réservation", Acr = "ou", Icr = "Annuler", Ocr = "Aller à : ", Ncr = "Lien d'invitation Zapier", zcr = "Un lien de rendez-vous sera créé une fois l'événement confirmé.", Rcr = "Affiche dynamiquement le nom du participant pour vous ou votre nom s'il est vu par le participant", Pcr = "Lieu de l'événement", Dcr = "Raison de la replanification (facultatif)", Lcr = "Faites savoir aux autres pourquoi vous devez replanifier le rendez-vous.", Mcr = "Cet événement est annulé", Fcr = "Nous avons envoyé un e-mail à tout le monde pour les en informer.", qcr = "Ce champ sera affiché lors de la réservation de cet événement.", jcr = "Le lien du rendez-vous est dans l'e-mail de confirmation", Vcr = "Le lien doit commencer par http:// ou https://", Bcr = "Un numéro de téléphone sera fourni", Ucr = "avant le début de l'événement", Gcr = "lorsque l'événement est annulé", Wcr = "Après que les hôtes ne se sont pas connectés à l'appel vidéo", Hcr = "Après que les invités ne se sont pas connectés à l'appel vidéo", Ycr = "Rejoindre l'appel vidéo", Kcr = "Se connecter à Cal.com", Zcr = "Connectez-vous à Cal.com", Xcr = "Suivez vos réunions, recevez des notifications et gérez votre emploi du temps plus efficacement.", Jcr = "Suivez vos réunions et gérez votre emploi du temps plus efficacement", Qcr = "Échec de la connexion à l'appel. Veuillez réessayer.", elr = "Choisissez comment vous souhaitez rejoindre cet appel", tlr = "Choisissez comment vous souhaitez apparaître lors de l'appel", nlr = "lorsqu'un nouvel événement est réservé", olr = "envoyer un e-mail à l'hôte", rlr = "envoyer un e-mail aux participants", ilr = "Envoyer un SMS au participant", alr = "envoyer un SMS à un numéro spécifique", slr = "Envoyez facilement des rappels de rendez-vous par SMS à vos participants", clr = "envoyer un message WhatsApp à un numéro spécifique", llr = "envoyer un message WhatsApp au participant", ulr = "Workflows", dlr = "Nouveau workflow", _lr = "Comment souhaitez-vous commencer ?", plr = "Ajouter un nouveau workflow", mlr = "lorsque l'événement est replanifié", flr = "Déclencheur", glr = "Déclencheurs", hlr = "Action", vlr = "Créez des workflows pour automatiser les notifications et les rappels.", blr = "Nom du workflow", ylr = "Workflow personnalisé", $lr = "{{workflowName}} créé avec succès", wlr = "Voulez-vous vraiment supprimer ce workflow ?", klr = "Supprimer le workflow", Slr = "Oui, supprimer le workflow", Elr = "Workflow supprimé avec succès", xlr = "Combien de temps avant le début de l'événement ?", Clr = "jours", Tlr = "heures", Alr = "minutes", Ilr = "min", Olr = "h", Nlr = "Créez votre premier workflow", zlr = "Les workflows vous permettent d'automatiser l'envoi de rappels et de notifications.", Rlr = "Actif sur", Plr = "Workflow {{workflowName}} mis à jour avec succès", Dlr = "Il s'agit d'un nom d'utilisateur standard et l'appliquer vous redirigera vers la facturation pour résilier votre plan.", Llr = "Il s'agit d'un nom d'utilisateur premium, obtenez-le pour {{price}}", Mlr = "Actuel", Flr = "premium", qlr = "standard", jlr = "Confirmer le changement de nom d'utilisateur", Vlr = "Il s'agit d'un nom d'utilisateur premium et l'appliquer vous redirigera vers la facturation pour valider le changement.", Blr = "Il s'agit d'un nom d'utilisateur standard et l'appliquer vous redirigera vers la facturation pour résilier votre plan.", Ulr = "Accéder à la facturation", Glr = "Exigez un paiement pour les réservations (0,5 % + 0,10 € de commission par transaction).", Wlr = "Votre période d'essai a expiré", Hlr = "Supprimer l'application", Ylr = "Oui, supprimer l'application", Klr = "Voulez-vous vraiment supprimer cette application ?", Zlr = "Application supprimée avec succès", Xlr = "Erreur lors de la suppression de l'application", Jlr = "Visioconférence", Qlr = "Appel web", eur = "Démarrer l'appel web", tur = "Terminer l'appel", nur = "Testez votre agent avec un appel web sans nécessiter de numéro de téléphone", our = "Appel téléphonique", rur = "Connexion à l'agent...", iur = "Appel en cours", aur = "Appel terminé", sur = "Erreur d'appel", cur = "Prêt à démarrer l'appel", lur = "Échec du démarrage de l'appel web. Veuillez réessayer.", uur = "L'appel a rencontré une erreur. Veuillez réessayer.", dur = "Échec d'initialisation de l'appel web. Veuillez vous assurer que les permissions du microphone sont accordées.", _ur = "Démarrez un appel pour voir la conversation", pur = "En attente de conversation...", mur = "Agent IA", fur = "En direct", gur = "Connexion en cours...", hur = "Nécessite une confirmation", vur = "Une confirmation est requise si réservé avec un préavis de moins de {{time}} $t({{unit}}_timeUnit)", bur = "Peut nécessiter une confirmation", yur = "{{count}} type d'événement", $ur = "{{count}} types d'événements", wur = "{{count}} équipe", kur = "{{count}} équipes", Sur = "Ajouter une action", Eur = "Définir le lien Whereby", xur = "Veuillez saisir un lien Whereby valide", Cur = "Définir un lien Around.Co", Tur = "Veuillez saisir un lien Around.Co valide", Aur = "Définir un lien Riverside", Iur = "Veuillez saisir un lien Riverside valide", Our = "Veuillez saisir un lien Ping.gg valide", Nur = "Connecter le serveur Exchange 2013", zur = "Connecter le serveur Exchange 2016", Rur = "Modèle personnalisé", Pur = "Corps", Dur = "Message texte", Lur = "Vous avez un problème particulier ?", Mur = "parcourir notre documentation", Fur = "Choisir un modèle", qur = "Personnalisé", jur = "Rappel", Vur = "Replanifié", Bur = "Replanifié par", Uur = "Réservation initiale", Gur = "Terminé", Wur = "Évaluation", Hur = "Rappel : {{eventType}} avec {{name}} le {{date}}", Yur = "Ne se déclenchera pas pour les réservations déjà existantes car l'utilisateur sera invité à fournir un numéro de téléphone lors de la réservation de l'événement.", Kur = "{{count}} minute", Zur = "{{count}}min", Xur = "{{count}} minutes", Jur = "{{count}} heure", Qur = "{{count}}h", edr = "{{count}} heures", tdr = "Saisie non valide", ndr = "Nous n'avons pas pu ajouter le lien de réunion {{location}} à votre événement programmé. Contactez vos invités ou mettez à jour votre événement de calendrier pour ajouter les détails. Vous pouvez soit <0>modifier votre lieu sur le type d'événement</0> ou essayer de <1>supprimer et d'ajouter à nouveau l'application.</1>", odr = "Nous n'avons pas pu mettre à jour votre <1>{{calendar}}</1>. <2> Veuillez vérifier les paramètres de votre calendrier ou supprimer et ajouter votre calendrier à nouveau </2>", rdr = "Nom du participant", idr = "Le nom complet de la personne qui effectue la réservation", adr = "Intégration défaillante", sdr = "Un problème est survenu lors de l'ajout d'un lien vidéo", cdr = "Un problème est survenu lors de la mise à jour de votre calendrier", ldr = "Actif sur {{count}} type d'événement", udr = "Actif sur {{count}} types d'événements", ddr = "Actif sur {{count}} équipe", _dr = "Actif sur {{count}} équipes", pdr = "Actif sur tous les types d'événements", mdr = "Actif sur toutes les équipes", fdr = "Aucun type d’événement actif", gdr = "Aucune équipe active", hdr = "Nouveau participant : {{name}} pour {{eventType}} le {{date}}", vdr = "Quelqu'un s'est ajouté à un événement", bdr = "Variable", ydr = "Nom de l'événement", $dr = "Nom du participant", wdr = "Date de l'événement", kdr = "Heure de l'événement", Sdr = "Nom de l'organisateur", Edr = "Pour pouvoir utiliser cette fonctionnalité, vous devez passer à un compte Pro.", xdr = "Numéro de téléphone invalide", Cdr = "URL non valide pour {{label}}. Exemple d'URL : {{sampleUrl}}", Tdr = "Naviguer", Adr = "Ouvrir", Idr = "Fermer", Odr = "Mettre à niveau", Ndr = "Acheter un numéro US pour {{priceInDollars}}$/mois", zdr = "Mettez à niveau pour accéder aux enregistrements", Rdr = "Les enregistrements ne sont disponibles que dans le plan Équipes. Mettez à niveau pour commencer à enregistrer vos appels.", Pdr = "Passez à la version Entreprise pour générer un numéro de téléphone d'agent IA capable d'appeler les invités pour planifier des appels", Ddr = "Les enregistrements font partie du plan Équipes", Ldr = "Ceci est une fonctionnalité d'équipe. Mettez à jour vers le plan Équipes pour voir les disponibilités de votre équipe.", Mdr = "Ceci est une fonctionnalité d'équipe. Mettez à jour vers le plan Équipes pour automatiser vos notifications et rappels d'événements avec les workflows.", Fdr = "Afficher sur le profil", qdr = "Intégrer", jdr = "Nouveau nom d'utilisateur", Vdr = "Nom d'utilisateur actuel", Bdr = "Exemple 1", Udr = "Exemple 2", Gdr = "Identifiant de la question de réservation", Wdr = "Taille de l'entreprise", Hdr = "Avez-vous besoin d'aide ?", Ydr = "Format des variables", Kdr = "Le lien de l'abonné webhook est déjà défini", Zdr = "Ignorer tous les caractères spéciaux du libellé de champ supplémentaire (utiliser uniquement des lettres et des chiffres), utiliser des majuscules pour toutes les lettres et remplacer les espaces par des tirets bas.", Xdr = "Comment puis-je utiliser les questions de réservation comme variables ?", Jdr = "Télécharger l'application de bureau", Qdr = "Définir le lien Ping", e_r = "Limite dépassée", t_r = "Quand quelque chose se passe.", n_r = "Une action est effectuée.", o_r = "Tester l'action", r_r = "Notification envoyée", i_r = "Aucun champ", a_r = "Tester l'action du workflow", s_r = "Envoyer un SMS", c_r = "Voulez-vous vraiment envoyer un SMS au {{number}} ?", l_r = "Aucun calendrier par défaut connecté", u_r = "Vous pouvez connecter votre calendrier depuis <1>ici</1>.", d_r = "Calendrier par défaut", __r = "Masquer du profil", p_r = "Configuration", m_r = "Aucune disponibilité trouvée dans le planning", f_r = "Limites", g_r = "Fréquence de réservation", h_r = "Paramètres du calendrier, etc.", v_r = "Avancé", b_r = "Configurer les paiements pour l'événement", y_r = "Configuration de l'événement : plusieurs durées requièrent au moins une option.", $_r = "Configuration de l'événement : veuillez sélectionner une durée par défaut valide.", w_r = "Les limites de réservation doivent être dans l'ordre croissant. [jour, semaine, mois, année]", k_r = "Les limites de durée doivent être dans l'ordre croissant. [jour, semaine, mois, année]", S_r = "Sélectionnez le calendrier auquel ajouter les réservations.", E_r = "Nom d'événement personnalisé", x_r = "Créez des noms d'événement personnalisés à afficher sur l'événement du calendrier", C_r = "Code de double authentification incorrect", T_r = "À quel type d'événement s'appliquera-t-il ?", A_r = "Appliquer à tous, y compris aux futurs types d'événements", I_r = "Appliquer à tous les types d'événements d'équipe et d'utilisateur", O_r = "À quelle équipe cela s'appliquera-t-il ?", N_r = "Les workflows permettent une automatisation simple pour envoyer des notifications et des rappels vous permettant de créer des processus autour de vos événements.", z_r = "Il s'agit d'un paramètre interne qui n'affectera pas la façon dont les horaires sont affichés sur les pages de réservation publiques, que ce soit pour vous ou toute personne prenant rendez-vous avec vous.", R_r = "Créer un workflow", P_r = "Effectuer ceci", D_r = "Désactiver", L_r = "Activer", M_r = "Les réservations annulées ne peuvent pas être reprogrammées", F_r = "Paramètres mis à jour avec succès", q_r = "Erreur lors de la mise à jour des paramètres", j_r = "Mon lien {{appName}} personnel", V_r = "Quelques mots à propos de vous. Ces informations apparaîtront sur votre page publique.", B_r = "Terminez la configuration et commencez", U_r = "Cet utilisateur n'a pas encore ajouté de description.", G_r = "Bio", W_r = "Supprimer le compte", H_r = "Voulez-vous vraiment supprimer votre compte {{appName}} ?", Y_r = "Supprimer mon compte", K_r = "Début de la semaine", Z_r = "Enregistrements", X_r = "Enregistrement", J_r = "Bonne planification", Q_r = "Sélectionnez les calendriers dont vous souhaitez vérifier les conflits afin d'éviter les doubles réservations.", epr = "Vérifier les conflits", tpr = "Voir les enregistrements", npr = "Chercher des enregistrements", opr = "Ajout d'événements", rpr = "Suivre les préférences système", ipr = "Couleurs de marque personnalisées", apr = "Personnalisez la couleur de votre page de réservation à l'image de votre marque.", spr = "Pro", cpr = "Supprimez toutes les références à la marque {{appName}}, par exemple « Propulsé par {{appName}} ».", lpr = "Rendez-vous instantané avec {{name}}", upr = "Photo de profil", dpr = "Télécharger", _pr = "Ajouter une photo de profil", ppr = "Adresse du token", mpr = "Blockchain", fpr = "Ancien mot de passe", gpr = "Votre nouveau mot de passe super sécurisé", hpr = "Erreur lors de la mise à jour du mot de passe", vpr = "Double authentification", bpr = "Configurer une disponibilité récurrente", ypr = "aujourd'hui", $pr = "Apparence", wpr = "Mon compte", kpr = "Général", Spr = "Calendriers", Epr = "Factures", xpr = "Intégrations", Cpr = "Emprunt d'identité", Tpr = "Gérez les paramètres d'emprunt d'identité.", Apr = "Usurpations récentes", Ipr = "Usurpation rapide", Opr = "Aucune usurpation récente", Npr = "Utilisateurs", zpr = "Utilisateur", Rpr = "Gérez les paramètres de votre profil {{appName}}.", Ppr = "Vous trouverez ici une liste de tous les utilisateurs", Dpr = "Liste des utilisateurs", Lpr = "Gérez les paramètres de votre langue et de votre fuseau horaire.", Mpr = "Configurez la manière dont vos types d'événements interagissent avec vos calendriers.", Fpr = "Gérez les paramètres d'apparence de vos réservations.", qpr = "Ajoutez vos applications de visioconférence préférées pour vos rendez-vous.", jpr = "Ajouter une application de conférence", Vpr = "Gérez les paramètres pour les mots de passe de votre compte.", Bpr = "Configurez votre double authentification", Upr = "Nous avons juste besoin de quelques informations de base pour configurer votre profil.", Gpr = "Ignorer", Wpr = "Plus tard", Hpr = "Définissez les plages horaires durant lesquelles vous êtes disponible.", Ypr = "Vous pouvez personnaliser tout cela plus tard dans la page Disponibilités.", Kpr = "Connectez d'abord un calendrier", Zpr = "Complétez votre profil", Xpr = "Vous pouvez ajouter plus de calendriers depuis l'App Store", Jpr = "Connecter les applications de visioconférence", Qpr = "Connecter des apps de calendrier", emr = "Connecter des apps de paiement", tmr = "Connecter des apps d'automatisation", nmr = "Connecter des apps d'analytique", omr = "Connecter d'autres applications", rmr = "Connecter des apps de messagerie", imr = "Connecter des apps de CRM", amr = "Étape {{currentStep}} sur {{maxSteps}}", smr = "Ajouter une variable", cmr = "Numéro de téléphone personnalisé", lmr = "Modèle de message", umr = "Objet", dmr = "Ajouter des variables de texte dynamiques", _mr = "Nom du type d'événement", pmr = "Date de l'événement", mmr = "La durée de l'événement", fmr = "Heure de début de l'événement", gmr = "Type d'événement introuvable", hmr = "Numéro à appeler", vmr = "Le numéro de téléphone de l'utilisateur que vous appelez", bmr = "Lieu", ymr = "Lieu de l'événement", $mr = "Notes supplémentaires", wmr = "Notes supplémentaires de la réservation", kmr = "Nom du participant", Smr = "Nom de l'organisateur", Emr = "À", xmr = "Le workflow {{workflowName}} a été {{offOn}} avec succès", Cmr = "Télécharger les réponses", Tmr = "Téléchargez toutes les réponses à votre formulaire au format CSV.", Amr = "Voir les réponses", Imr = "Télécharger", Omr = "Téléchargement en cours", Nmr = "Télécharger l'enregistrement", zmr = "Les transcriptions sont désormais activées", Rmr = "Les transcriptions sont désormais arrêtées", Pmr = "Télécharger la transcription", Dmr = "Transcription", Lmr = "Un enregistrement de votre appel récent sur {{appName}} est prêt à être téléchargé", Mmr = "La transcription de votre récent appel sur {{appName}} est prête à être téléchargée. Les liens ne sont valides que pendant 1 heure", Fmr = "Vous pouvez également télécharger la transcription depuis les pièces jointes", qmr = "Remarque : le lien de téléchargement n'est valide que pendant 12 heures. Vous pouvez générer un nouveau lien de téléchargement en suivant les instructions <1>ici</1>.", jmr = "Remarque : le lien de téléchargement n'est valable que pendant 12 heures. Vous pouvez générer un nouveau lien de téléchargement en suivant les instructions.", Vmr = "Créez votre premier formulaire", Bmr = "Avec les formulaires de routage, vous pouvez poser des questions de qualification et rediriger vers la bonne personne ou le bon type d'événement.", Umr = "Créez votre premier webhook", Gmr = "Avec les webhooks, vous pouvez recevoir les données de rendez-vous en temps réel lorsque quelque chose se passe sur {{appName}}.", Wmr = "Pour un maximum de", Hmr = "événement", Ymr = "événements", Kmr = "Gérez les paramètres du profil de votre équipe.", Zmr = "Gérez les paramètres de votre profil d'organisation.", Xmr = "Utilisateurs présents dans le groupe.", Jmr = "Gérez les administrateurs et les membres de votre organisation.", Qmr = "Lien de l'équipe", efr = "Membres de l'équipe", tfr = "Plus", nfr = "Flux de travail Cal.ai", ofr = "et {{count}} de plus", rfr = "Nous considérons l'application mobile comme une extension de l'application web. Si vous effectuez des actions complexes, veuillez vous référer à l'application web.", ifr = "Envoyer un rappel par SMS 24 heures avant le début de l'événement", afr = "Envoyer un SMS personnalisé au participant lorsque l'événement est replanifié", sfr = "Envoyer un e-mail personnalisé à l'hôte lorsqu'un nouvel événement est réservé", cfr = "Envoyer un rappel par e-mail aux participants 1 heure avant le début des événements", lfr = "Envoyer un e-mail personnalisé à l'hôte lorsque l'événement est replanifié", ufr = "Envoyer un SMS personnalisé à l'hôte lorsqu'un nouvel événement est réservé", dfr = "Envoyer un rappel par SMS", _fr = "24 heures avant le début de l'événement", pfr = "Suivi des absents", mfr = "30 minutes après la fin de l'événement", ffr = "Rappeler aux participants d'apporter une pièce d'identité", gfr = "1 jour avant le début de l'événement", hfr = "Rappel par e-mail", vfr = "1 heure avant le début de l'événement", bfr = "Rappel SMS personnalisé", yfr = "Lorsque l'événement est programmé", $fr = "Rappel par e-mail personnalisé", wfr = "L'événement est replanifié pour l'hôte", kfr = "Inclure les compteurs de réservation des types d'événements gérés", Sfr = "Bienvenue sur {{appName}} !", Efr = "Vous pourrez modifier cela ultérieurement.", xfr = "Je connecterai mon calendrier plus tard", Cfr = "Un problème est survenu lors de l'enregistrement de vos données. Veuillez réessayer ou contacter le service client.", Tfr = "Acheter des places manquantes", Afr = "Durée du créneau", Ifr = "Apparence", Ofr = "Gérez les paramètres d'apparence de vos réservations d'équipe.", Nfr = "Gérez les paramètres d'apparence de vos réservations d'organisation", zfr = "Seul le propriétaire de cette équipe peut apporter des modifications à la réservation de l'équipe ", Rfr = "Supprimez toutes les références à la marque {{appName}}, par exemple « Propulsé par {{appName}} ».", Pfr = "{{teamName}} vous a invité à rejoindre son équipe en tant que {{role}}", Dfr = "Le token est invalide ou a expiré.", Lfr = "Voir la réservation", Mfr = "Se connecter à Microsoft Exchange", Ffr = "Méthode d'authentification", qfr = "Authentification de base", jfr = "Authentification NTLM", Vfr = "Compression GZip", Bfr = "Version d'Exchange", Ufr = "2007 SP1", Gfr = "2010", Wfr = "2010 SP1", Hfr = "2010 SP2", Yfr = "2013", Kfr = "2013 SP1", Zfr = "2015", Xfr = "2016", Jfr = "Routage", Qfr = "Créez des formulaires pour acheminer les participants vers les bonnes destinations.", egr = "Envoyer un e-mail au propriétaire", tgr = "Envoie un e-mail au propriétaire lorsque le formulaire est soumis", ngr = "Envoyer un e-mail à", ogr = "Ajouter un nouveau formulaire", rgr = "Ajouter un nouveau formulaire à votre équipe", igr = "Créez votre première route", agr = "Acheminez vers la bonne personne en fonction des réponses à votre formulaire.", sgr = "Formulaire", cgr = "Créez votre formulaire pour rediriger un utilisateur.", lgr = "Copier le lien vers le formulaire", ugr = "Thème de la page de réservation", dgr = "Ceci s'applique uniquement à vos pages publiques de réservation.", _gr = "Thème du tableau de bord", pgr = "Cela s'applique uniquement à votre tableau de bord connecté", mgr = "Automatique", fgr = "Ajouter une équipe", ggr = "Recevez les données de rendez-vous en temps réel lorsque quelque chose se passe sur {{appName}}.", hgr = "Se déclenche quand", vgr = "Veuillez faire un test de ping avant de le créer.", bgr = "Activer le webhook", ygr = "Ajouter un webhook", $gr = "Webhook enregistré", wgr = "Générez des clés API pour accéder à votre propre compte.", kgr = "Nouvelle clé API", Sgr = "actif", Egr = "Nom de clé API mis à jour", xgr = "Erreur lors de la mise à jour du nom de la clé API", Cgr = "Intégration d'iframe HTML", Tgr = "Intégrez tous vos types d'événements sur votre site web.", Agr = "Créez votre première clé API", Igr = "Les clés API permettent à d'autres applications de communiquer avec {{appName}}.", Ogr = "Retour à la connexion", Ngr = "Lien de réinitialisation envoyé", zgr = "Un e-mail est en route vers {{email}} avec les instructions pour réinitialiser votre mot de passe.", Rgr = "Si vous ne recevez pas d'e-mail bientôt, vérifiez que l'adresse e-mail que vous avez saisie est correcte, vérifiez vos spams ou contactez l'assistance si le problème persiste.", Pgr = "Mot de passe mis à jour !", Dgr = "Paiement en attente", Lgr = "Invitations en attente", Mgr = "Invitations de l'organisation en attente", Fgr = "Pas sur {{appName}}", qgr = "Aucun calendrier installé", jgr = "Vous n'avez pas encore connecté vos calendriers.", Vgr = "Ajouter un calendrier", Bgr = "Vous devrez peut-être vous déconnecter et vous reconnecter pour voir les changements prendre effet.", Ugr = "Veuillez confirmer votre mot de passe avant de changer votre adresse e-mail", Ggr = "places", Wgr = "Chaque application publiée sur l'App Store de {{appName}} est open source et soigneusement testée via des évaluations par les pairs. Néanmoins, {{companyName}} n'approuve ni ne certifie ces applications à moins qu'elles ne soient publiées par {{appName}}. Si vous rencontrez un contenu ou comportement inapproprié, veuillez le signaler.", Hgr = "Signaler l'application", Ygr = "Limiter la fréquence de réservation", Kgr = "Limitez le nombre de réservations possibles pour cet événement.", Zgr = "N'afficher que le premier créneau disponible de chaque jour", Xgr = "Cela limitera votre disponibilité pour ce type d'événement à un créneau par jour, programmé au plus tôt possible.", Jgr = "Limiter la durée totale de réservation", Qgr = "Limitez la durée totale pendant laquelle cet événement peut être réservé.", ehr = "Limite de réservations actives par utilisateur", thr = "Limitez le nombre de réservations actives qu'un utilisateur peut effectuer pour ce type d'événement", nhr = "Les événements récurrents ne prennent pas en charge la limite de réservation par utilisateur", ohr = "Ajouter une limite", rhr = "Nom d'équipe requis", ihr = "Partagez les informations des participants entre les invités", ahr = "Afficher le nombre de places disponibles", shr = "Comment utiliser les questions de réservation comme variables ?", chr = "Format", lhr = "Questions", uhr = "Toutes les informations que votre utilisateur doit fournir avant de réserver avec vous.", dhr = "Utilisez des majuscules pour toutes les lettres.", _hr = "Remplacez les espaces par des tirets bas.", phr = "Membres de la plateforme", mhr = "Gérez les administrateurs et les membres de votre équipe sur la plateforme", fhr = "Facturation de la plateforme", ghr = "Gérer la facturation", hhr = "Gérez tout ce qui est en lien avec la facturation.", vhr = "Vous êtes actuellement sur le plan Gratuit", bhr = "Nous travaillons mieux en équipe. Élargissez vos workflows avec les événements round-robin et collectifs et produisez des formulaires de routage avancés.", yhr = "Essayer maintenant", $hr = "Portail de facturation", whr = "Contacter l'assistance", khr = "Ignorez les caractères spéciaux dans l'identifiant de votre question de réservation, utilisez uniquement des lettres et des chiffres.", Shr = "Réessayer", Ehr = "Un problème est survenu lors de la récupération de vos calendriers. Veuillez <1>réessayer</1> ou contacter le service client.", xhr = "Échec de la connexion au calendrier", Chr = "Confirmation de la réservation réussie", Thr = "Refus de la réservation réussi", Ahr = "Cette réservation est provisoire", Ihr = "Oups, je veux accepter", Ohr = "Nous n'afficherons plus ceci", Nhr = "Nous n'avons pas pu mettre à jour le fuseau horaire", zhr = "Fuseau horaire mis à jour vers {{formattedCurrentTz}}", Rhr = "Mettre à jour le fuseau horaire", Phr = "Mettre à jour le fuseau horaire ?", Dhr = "Votre fuseau horaire local semble être passé sur {{formattedCurrentTz}}. Il est très important d'avoir le bon fuseau horaire pour éviter les réservations à des heures indésirables. Souhaitez-vous le mettre à jour ?", Lhr = "Ne pas mettre à jour", Mhr = "Notes supplémentaires obligatoires", Fhr = "Exigez des notes supplémentaires à saisir lors de la réservation.", qhr = "envoyer un e-mail à une adresse e-mail spécifique", jhr = "après la fin de l'événement", Vhr = "lorsque la réservation est rejetée", Bhr = "lorsque la réservation est demandée", Uhr = "lorsque le paiement de la réservation est initié", Ghr = "lorsque le paiement de la réservation est réussi", Whr = "lorsque l'absence au rendez-vous est mise à jour", Hhr = "Combien de temps après la fin de l'événement ?", Yhr = "Combien de temps après que les hôtes ne se présentent pas à la réunion vidéo Cal ?", Khr = "Combien de temps après que les invités ne se présentent pas à la réunion vidéo Cal ?", Zhr = "Combien de minutes après que les utilisateurs ne se présentent pas à la réunion vidéo Cal ?", Xhr = "Aucun créneau disponible", Jhr = "Disponibilités", Qhr = "Vous ne trouvez pas l'application de conférence adaptée ? Visitez notre <0>App Store</0>.", evr = "Installer une nouvelle application de calendrier", tvr = "Rendre le numéro de téléphone obligatoire pour la réservation de l'événement", nvr = "Disponibilités de {{eventTypeTitle}}", ovr = "Erreur lors de la modification des disponibilités", rvr = "Vous n'avez pas la permission d'accéder à cette ressource.", ivr = "Veuillez coller les métadonnées SAML de votre fournisseur d'identité ici.", avr = "Veuillez saisir une adresse e-mail pour que nous puissions trouver votre fournisseur d'identité SAML", svr = "Informations sur le fournisseur de services", cvr = "Votre fournisseur d'identité (IdP) vous demandera les détails suivants pour compléter la configuration de l'application SAML.", lvr = "Lien ACS", uvr = "Identifiant SP Entity", dvr = "Lien ACS copié !", _vr = "Identifiant SP Entity copié !", pvr = "Ajouter un calendrier", mvr = "Limiter les réservations futures", fvr = "Limitez jusqu'à quand cet événement peut être réservé dans le futur.", gvr = "Aucun type d’événement configuré", hvr = "{{name}} n'a pas configuré de type d'événement que vous pouvez réserver.", vvr = "Fréquence de facturation", bvr = "Mensuellement", yvr = "Annuellement", $vr = "Paiement", wvr = "Votre équipe a bien été dissoute", kvr = "Votre organisation a bien été dissoute", Svr = "Erreur lors de la création de l'équipe", Evr = "Vous", xvr = "Ou continuez avec", Cvr = "Renvoyer l’e-mail", Tvr = "Le membre a déjà été invité", Avr = "Nom d'utilisateur déjà utilisé", Ivr = "Saisissez une adresse e-mail ou un nom d'utilisateur", Ovr = "Saisissez une adresse e-mail", Nvr = "Saisissez des adresses e-mail", zvr = "Vous ne pouvez inviter qu'un maximum de {{nbUsers}} utilisateurs à la fois.", Rvr = "Ce nom est déjà pris", Pvr = "Vous devez saisir un nom d'équipe", Dvr = "Vous devez saisir un lien d'équipe", Lvr = "Ce lien est déjà pris", Mvr = "Un problème est survenu lors de l'enregistrement du sous-domaine, veuillez réessayer ou contacter un administrateur", Fvr = "Publier l'équipe", qvr = "Numéro de téléphone (notifications par SMS)", jvr = "Numéro de téléphone (notifications par SMS)", Vvr = "Adresse e-mail du participant", Bvr = "Adresse e-mail du participant", Uvr = "UID de réservation", Gvr = "Saisissez une commande ou une recherche...", Wvr = "Oh non ! On dirait que l’autorisation a expiré ou a été révoquée. Veuillez la réinstaller.", Hvr = "Réinstaller l'application", Yvr = "Raison de la replanification", Kvr = "Choisissez un horaire commun", Zvr = "Activez cette option si vous souhaitez utiliser un planning commun entre les hôtes. Lorsqu'elle est désactivée, chaque hôte sera réservé en fonction de son planning par défaut ou de son planning choisi.", Xvr = "Raison", Jvr = "ID de l'expéditeur", Qvr = "Seules les lettres, chiffres et espaces sont autorisés (max. 11 caractères)", ebr = "Tester le formulaire de routage", tbr = "Tester l'aperçu", nbr = "Rediriger vers", obr = "Tester votre formulaire de routage sans envoyer de données", rbr = "Tester le routage", ibr = "Un administrateur a désactivé une application de paiement", abr = "Modifier le type d'événement", sbr = "Cette organisation est privée et seuls son administrateur ou son propriétaire peuvent en voir les membres.", cbr = "Seuls l'administrateur ou le propriétaire de l'organisation peuvent gérer les paramètres SSO", lbr = "Seul l'administrateur ou le propriétaire de l'organisation peut gérer les paramètres de synchronisation d'annuaire", ubr = "Seul l'administrateur ou le propriétaire de l'organisation peut gérer les clients OAuth", dbr = "Planification collective", _br = "Facilitez la réservation de votre équipe lorsque tout le monde est disponible.", pbr = "Trouvez la meilleure personne disponible et alternez à travers votre équipe.", mbr = "Round-robin fixe", fbr = "Ajoutez un participant fixe et le round-robin via un certain nombre de participants.", gbr = "{{appName}} est meilleur en équipe", hbr = "L'équipe {{companyName}}", vbr = "Ajoutez les membres de votre équipe à vos types d'événements. Utilisez la planification collective pour inclure tout le monde ou trouvez la personne la plus appropriée avec la planification round-robin.", bbr = "La limite de réservation pour ce type d'événement a été atteinte", ybr = "La limite de durée pour ce type d'événement a été atteinte", $br = "Un administrateur a désactivé {{appName}}", wbr = "Cela désactivera tous les e-mails destinés à {{recipient}}. Cela inclut les confirmations de réservation, les demandes, les reprogrammations et les demandes de reprogrammation, les e-mails d'annulation et tout autre e-mail lié aux mises à jour de réservation.<br /><br />Il est de votre responsabilité de vous assurer que vos {{recipient}} sont informés de toute réservation et des modifications apportées à leurs réservations.", kbr = "Un administrateur a désactivé {{appName}} qui affecte votre type d'événement {{eventType}}", Sbr = "Un administrateur a remplacé l'un de vos types d'événements", Ebr = "Un administrateur d'équipe a remplacé votre événement /{{slug}}", xbr = "Un administrateur de l'équipe <strong>{{teamName}}</strong> a remplacé votre type d'événement <strong>/{{slug}}</strong> par un type d'événement géré qu'il contrôle.", Cbr = "Votre lien continuera de fonctionner, mais certains de ses paramètres peuvent avoir changé. Vous pouvez l'examiner dans les types d'événements.", Tbr = "Si vous avez des questions sur le type d'événement, veuillez contacter votre administrateur.<br /><br />Bonne planification, <br />L'équipe Cal.com", Abr = "L'administrateur a désactivé {{appName}}, ce qui affecte votre type d'événement {{title}}. Les participants peuvent toujours réserver ce type d'événement mais ne seront pas invités à payer. Vous pouvez masquer le type d'événement pour éviter cela jusqu'à ce que votre administrateur réactive votre mode de paiement.", Ibr = "Les participants peuvent toujours réserver ce type d'événement mais ne seront pas invités à payer. Vous pouvez masquer le type d'événement pour éviter cela jusqu'à ce que votre administrateur réactive votre mode de paiement.", Obr = "L'administrateur a désactivé {{appName}} qui affecte votre type d'événement {{title}}.", Nbr = "L'administrateur a désactivé {{appName}}, ce qui peut affecter vos types d'événements. Si vous avez des types d'événements avec {{appName}} comme emplacement, Cal Video sera alors utilisé par défaut.", zbr = "{{appName}} a été désactivé", Rbr = "Accéder aux applications installées", Pbr = "Si un autre calendrier est installé, les nouvelles réservations y seront ajoutées. Si ce n'est pas le cas, connectez un nouveau calendrier pour ne pas manquer de nouvelles réservations.", Dbr = "Activer les applications", Lbr = "Activer les applications que les utilisateurs peuvent intégrer à {{appName}}", Mbr = "Acheter une licence", Fbr = "J'ai déjà un compte", qbr = "J'ai déjà une clé :", jbr = "Veuillez copier votre variable d'environnement CALCOM_LICENSE_KEY existante ici.", Vbr = "Créer une clé de licence", Bbr = "{{appName}} est activé", Ubr = "{{appName}} est désactivé", Gbr = "Les clés ont été sauvegardées", Wbr = "Désactiver l'application", Hbr = "Désactiver cette application peut causer des problèmes avec la façon dont vos utilisateurs interagissent avec Cal", Ybr = "Modifier les clés", Kbr = "Activer les applications pour votre instance de Cal", Zbr = "Une liste de tous les utilisateurs de votre compte, incluant leur nom, titre, e-mail et rôle.", Xbr = "Ici, vous pouvez ajouter un nouvel utilisateur.", Jbr = "Ici, vous pouvez modifier un utilisateur existant.", Qbr = "Ici, vous pouvez modifier une organisation.", eyr = "Ajouter de nouveaux clients OAuth", tyr = "Verrouiller ou déverrouiller l'envoi de SMS pour les utilisateurs", nyr = "Il n'y a aucune application disponible", oyr = `Veuillez vous assurer qu'il y a des applications dans votre déploiement sous "packages/app-store"`, ryr = "Aucune application n'est activée dans cette instance de Cal", iyr = "Aucune application n'a encore été configurée", ayr = "Vous pouvez activer les applications dans les paramètres", syr = "Veuillez contacter votre administrateur", cyr = "Paramètres des applications", lyr = "Veuillez remplir ce champ", uyr = "Options", dyr = "Entrer l'option {{index}}", _yr = "Ajouter une option", pyr = "Cet emplacement existe déjà. Veuillez sélectionner un nouvel emplacement", myr = "Radio", fyr = "Pour utiliser Google Meet, vous devez définir votre calendrier de destination comme un calendrier Google", gyr = "Particulier", hyr = "Toutes les réservations", vyr = "Tous les utilisateurs", byr = "Tous les types d'événement", yyr = "Vos réservations", $yr = "Lien du rendez-vous", wyr = "Lien de la visioconférence du rendez-vous", kyr = "Superpositions de dates", Syr = "Supprimer les superpositions de date le {{date}}", Eyr = "Ajoutez les dates où vos disponibilités changent de vos heures quotidiennes.", xyr = "Les superpositions de dates sont archivées automatiquement une fois la date passée", Cyr = "À quelles heures êtes-vous disponible ?", Tyr = "À quelles heures êtes-vous occupé ?", Ayr = "Sélectionnez les dates à superposer", Iyr = "Indisponible toute la journée", Oyr = "Marquer comme indisponible (toute la journée)", Nyr = "Marquer comme indisponible aux dates sélectionnées", zyr = "Mettre à jour la superposition", Ryr = "Ajout du remplacement de date réussi", Pyr = "Enregistrer l'exception", Dyr = "{{slug}}-copie", Lyr = "Définir par défaut", Myr = "Masquer les détails du type d'événement", Fyr = "Afficher la navigation", qyr = "Masquer la navigation", jyr = "Code de vérification envoyé", Vyr = "Vérification réussie", Byr = "Code de vérification incorrect", Uyr = "Pas encore vérifié", Gyr = "Aucune disponibilité en {{month}}", Wyr = "La planification n'est disponible que jusqu'à {{days}} jours à l'avance. Veuillez vérifier à nouveau prochainement.", Hyr = "La planification s'est terminée le {{date}}. Veuillez vérifier à nouveau prochainement.", Yyr = "Voir le mois précédent", Kyr = "Voir le mois suivant", Zyr = "Envoyer le code", Xyr = "Numéro vérifié", Jyr = "Créez votre premier webhook pour ce type d'événement d'équipe", Qyr = "Créez un webhook pour ce type d'événement d'équipe.", e$r = "Désactiver la page de validation (fonctionne uniquement si vous avez un lien de redirection)", t$r = "Vous êtes administrateur, mais votre mot de passe ne fait pas au moins 15 caractères ou la double authentification n'est pas définie", n$r = "Changez votre mot de passe pour obtenir l'accès administrateur", o$r = "Ce nom d'utilisateur est déjà pris", r$r = "Affectation", i$r = "Hôtes fixes", a$r = "Ajouter des hôtes fixes", s$r = "Hôtes round-robin", c$r = "Nombre d'hôtes requis pour participer", l$r = "Hôtes", u$r = "Vous devez créer une équipe pour activer cette fonctionnalité. Cliquez ici pour créer une équipe.", d$r = "Vous devez passer sur notre formule entreprise pour activer cette fonctionnalité.", _$r = "Nouveau participant", p$r = "En attente de validation", m$r = "Cette application nécessite une connexion à Google Agenda", f$r = `L'option "Ajouter au calendrier" pour ce type d'événement doit être un Google Calendar pour que Meet fonctionne. Connectez-le <0>ici</0>.`, g$r = "Vous avez connecté un compte Google Agenda.", h$r = "L'utilisation de Google Meet nécessite un calendrier Google connecté", v$r = "Continuer à installer Google Agenda", b$r = "Installer Google Meet", y$r = "Installer Google Agenda", $$r = "Nom de l'expéditeur", w$r = "Participant déjà invité", k$r = "Aucun enregistrement trouvé", S$r = "Nouveau workflow pour...", E$r = "Rapports", x$r = "Voir toutes les données entrantes et les télécharger au format CSV.", C$r = "Le plan Équipes est requis", T$r = "Les formulaires de routage sont un excellent moyen d'acheminer vos prospects entrants vers la bonne personne. Passez au plan Équipes pour accéder à cette fonctionnalité.", A$r = "Choisir une licence", I$r = "Cal.com est fourni avec une licence AGPLv3 accessible et gratuite mais comportant des limitations. Nous sommes en train d'intégrer les clients du plan Entreprise pour la licence commerciale. Vous pouvez vous renseigner à ce sujet en contactant le service commercial ci-dessous.", O$r = "Licence", N$r = "Licence AGPLv3", z$r = "Pas besoin de garder votre code open source", R$r = "Restructurez, changez de marque et revendez facilement", P$r = "Une vaste suite de fonctionnalités d'entreprise", D$r = "0,00 $/mois", L$r = "Ouvert et gratuit pour toujours", M$r = "Votre code doit rester open source", F$r = "Impossible de restructurer, changer de marque et revendre facilement", q$r = "Aucune fonctionnalité d'entreprise", j$r = "Licence Entreprise", V$r = "Tout pour une utilisation commerciale avec hébergement privé, restructuration, changement de marque, revente et accès à des composants d'entreprise exclusifs.", B$r = "Configurer", U$r = "Configurez l'instance Cal.com.", G$r = "Configurer", W$r = "Authentification unique", H$r = "Configurez le SSO SAML/OIDC et autorisez les membres d'équipe à se connecter à l'aide d'un fournisseur d'identité.", Y$r = "Configurez le SSO SAML/OIDC et autorisez les membres de l'organisation à se connecter à l'aide d'un fournisseur d'identité", K$r = "SSO avec OIDC", Z$r = "Configurez le SSO OIDC avec le fournisseur d'identité de votre choix.", X$r = "Configuration OIDC", J$r = "Configurez la connexion OIDC à votre fournisseur d'identité. Vous pouvez trouver les informations requises dans votre fournisseur d'identité.", Q$r = "Lien de rappel copié", ewr = "SSO avec SAML", twr = "Configurez le SSO SAML avec le fournisseur d'identité de votre choix.", nwr = "Configuration SAML", owr = "Configurez la connexion SAML à votre fournisseur d'identité. Vous pouvez trouver les informations requises dans votre fournisseur d'identité.", rwr = "Lien ACS copié", iwr = "ID d'entité copié", awr = "Configuration {{connectionType}} créée avec succès", swr = "Configuration {{connectionType}} supprimée avec succès", cwr = "Supprimer la configuration {{connectionType}}", lwr = "Oui, supprimer la configuration {{connectionType}}", uwr = "Voulez-vous vraiment supprimer la configuration {{connectionType}} ? Les membres de votre équipe utilisant la connexion {{connectionType}} ne pourront plus accéder à Cal.com.", dwr = "Fuseau horaire de l'organisateur", _wr = "Voir l'invitation", pwr = "Accepter l'invitation", mwr = "Rejoindre maintenant", fwr = "Rejoint avec succès", gwr = "Vous avez été invité à rejoindre une équipe de l'organisation {{parentTeamName}}", hwr = "Vous avez été invité à rejoindre une organisation {{appName}}", vwr = "{{invitedBy}} vous a invité à rejoindre son équipe sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.", bwr = "{{invitedBy}} vous a invité(e) à rejoindre son équipe {{teamName}} dans son organisation {{parentTeamName}} sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.", ywr = "{{invitedBy}} vous a invité à rejoindre son organisation « {{teamName}} » sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre organisation d'organiser des rendez-vous sans échanges d'e-mails.", $wr = "Nous vous guiderons à travers quelques étapes rapides et vous profiterez bientôt d'une planification sans stress avec votre {{entity}}.", wwr = "Choisissez votre nom d'utilisateur", kwr = "Connectez votre compte de calendrier", Swr = "Définissez vos disponibilités", Ewr = "Rejoignez {{teamName}}", xwr = "Bonne planification de la part de l'équipe {{appName}}", Cwr = "Vous êtes sur le point d'emprunter l'identité d'un utilisateur, ce qui signifie que vous pouvez effectuer des modifications en son nom. S'il vous plaît, soyez prudent.", Twr = "Variables disponibles", Awr = "{Scheduler}", Iwr = "Aucun workflow", Owr = "Changez le filtre pour voir vos workflows personnels et d'équipe.", Nwr = "Changez le filtre pour voir les résultats.", zwr = "Aucun résultat pour le filtre", Rwr = "Étapes suivantes recommandées", Pwr = "Créer un type d'événement géré", Dwr = "Les rendez-vous sont meilleurs avec les bons membres d'équipe. Invitez-les maintenant.", Lwr = "Créez un modèle unique pour un type d'événement et distribuez-le à plusieurs membres.", Mwr = "Collective ou round-robin", Fwr = "Réservez les membres de votre équipe entre eux avec des événements collectifs ou mettez en place un cycle pour obtenir la bonne personne avec le round-robin.", qwr = "Ne participe plus à {{title}} le {{date}}", jwr = "Vous ne participez plus à cet événement", Vwr = "Un participant ne participe plus à {{title}} le {{date}}", Bwr = "Un participant ne participe plus à votre événement", Uwr = "{{name}} a annulé. Cela signifie qu'une place s'est libérée pour ce créneau horaire", Gwr = "Créer un événement dans", Wwr = "Créer un formulaire de routage sur", Hwr = "Définir un lien d'application par défaut", Ywr = "Définir un lien d'application par défaut permet à tous les nouveaux types d'événements d'utiliser le lien d'application que vous avez défini.", Kwr = "Application par défaut de l'organisateur", Zwr = "{{organizer}} n'a pas d'application de conférence par défaut", Xwr = "En cours de maintenance", Jwr = "L'équipe {{appName}} effectue une maintenance planifiée. Si vous avez des questions, veuillez contacter l'assistance.", Qwr = "{{numberOfSeats}} places", ekr = "Questions de réservation", tkr = "Personnalisez les questions posées sur la page de réservation.", nkr = "Ajouter une question", okr = "Identifiant", rkr = "L'adresse e-mail existe déjà", ikr = "Saisissez une URL de redirection vers laquelle le participant sera dirigé une fois qu'il quittera la réunion.", akr = "Payer pour cet événement n'est plus possible", skr = "Un remboursement pour ce paiement de réservation est en route.", ckr = "Ce paiement de réservation a été remboursé.", lkr = "Conformément à la politique de remboursement de l'événement, le paiement de la réservation n'est pas remboursable.", ukr = "La période de remboursement de l'événement a expiré. Par conséquent, le paiement de la réservation n'est pas remboursable.", dkr = "Échec de la confirmation de la réservation", _kr = "Pas assez de places", pkr = "Un champ avec ce nom existe déjà", mkr = "Le champ invités doit être de type 'Emails multiples'", fkr = "Afficher sur la page de réservation", gkr = "Vous pouvez consulter la page de réservation annulée", hkr = "Démarrer avec les modèles Zapier", vkr = "Modèles standard", bkr = "Modèles Cal.ai", ykr = "{{team}} n'est pas publiée", $kr = "Ce lien d'organisation n'est actuellement pas disponible. Veuillez contacter le propriétaire de l'organisation ou lui demander de le publier.", wkr = "Ce lien d'équipe n'est actuellement pas disponible. Veuillez contacter le propriétaire de l'équipe ou lui demander de le publier.", kkr = "Membre d'équipe", Skr = "Un formulaire de routage", Ekr = "Description du formulaire", xkr = "Rester connecté avec le formulaire", Ckr = "Toute modification apportée au routeur ou aux champs du formulaire en cours de duplication sera reflétée dans la copie. Cependant, la suppression d'un champ ne l'enlèvera pas de la copie.", Tkr = "Formulaire supprimé", Akr = "Voulez-vous vraiment supprimer ce formulaire ?", Ikr = "Oui, supprimer le formulaire", Okr = "Toute personne avec qui vous avez partagé le lien ne pourra plus y accéder.", Nkr = "Toutes les réponses associées seront supprimées.", zkr = "URL de redirection copiée ! Vous pouvez maintenant définir l'URL dans votre propre formulaire.", Rkr = "Les modifications dans les champs et les routes des formulaires suivants seront répercutées dans ce formulaire.", Pkr = "Formulaires connectés", Dkr = "Les formulaires suivants seraient affectés lorsque vous modifieriez des champs ou des routes ici.", Lkr = "Attendez un certain temps que les réponses soient collectées. Vous pouvez également envoyer le formulaire vous-même.", Mkr = "Voici ce que vos utilisateurs verraient", Fkr = "Identifie le champ par ce nom.", qkr = "Ajouter une option par ligne", jkr = "Sélectionner un routeur", Vkr = "Ajouter une nouvelle route", Bkr = "Prenez des décisions éclairées grâce aux statistiques", Ukr = "Notre tableau de bord de statistiques analyse l'activité de votre équipe et vous révèle les tendances qui permettent d'améliorer la planification et la prise de décision au sein de l'équipe.", Gkr = "Visualisez les réservations de tous les membres", Wkr = "Voyez qui reçoit le plus de réservations et assurez la meilleure distribution au sein de votre équipe", Hkr = "Identifiez les tendances de réservation", Ykr = "Découvrez quels jours de la semaine et quelles heures de la journée sont populaires auprès de vos utilisateurs.", Kkr = "Identifiez les types d'événements populaires", Zkr = "Découvrez lesquels de vos types d'événements reçoivent le plus de clics et de réservations.", Xkr = "Aucune réponse pour l'instant", Jkr = "Aucune route définie", Qkr = "Ce sera le texte de substitution", e0r = "Une erreur s'est produite lors de la réservation de l'événement, veuillez actualiser la page et réessayer", t0r = "Aucun créneau sélectionné", n0r = "Veuillez sélectionner un créneau pour réserver l'événement.", o0r = "Sélectionner un créneau", r0r = "Passer en vue mensuelle", i0r = "Passer en vue hebdomadaire", a0r = "Passer en vue journalière", s0r = "Passer en vue colonnes", c0r = "{{num}} options de lieu", l0r = "Sélectionner à l'étape suivante", u0r = "Ce rendez-vous n'a pas encore commencé", d0r = "{{appName}} requiert un compte {{dependencyName}} connecté", _0r = "Connecter {{dependencyName}}", p0r = "{{dependencyName}} est connectée", m0r = "Requiert {{dependencyName}}", f0r = "Code de vérification", g0r = "Pouvez-vous réessayer avec un autre créneau ?", h0r = "Vérifier", v0r = "Le fuseau horaire du destinataire", b0r = "Fuseau horaire", y0r = "Heure de fin de l'événement", $0r = "L'heure de fin de l'événement", w0r = "Lien d'annulation", k0r = "Le lien d'annulation de la réservation", S0r = "Motif d'annulation", E0r = "Le motif de l'annulation de la réservation", x0r = "Lien de replanification", C0r = "Le lien de replanification de la réservation", T0r = "Motif de report", A0r = "Le motif du report de la réservation", I0r = "Il y a une variable invalide dans le nom de votre événement", O0r = "Tout sélectionner", N0r = "Mise à jour multiple des types d'événements existants", z0r = "Planning par défaut du membre", R0r = "Défini par l'administrateur de l'équipe", P0r = "Lieu par défaut du membre", D0r = "Nous utiliserons le calendrier de disponibilité par défaut de chaque membre. Ils pourront le modifier ou le changer.", L0r = "Vous devez avoir au moins un planning", M0r = "Mettez à jour les emplacements pour les types d'événements sélectionnés.", F0r = "Mettre à jour les horaires pour les types d'événements sélectionnés", q0r = "Verrouillé pour les membres", j0r = "Déverrouillé pour les membres", V0r = "Les membres pourront voir les applications actives, mais ne pourront pas modifier leurs paramètres.", B0r = "Les membres pourront voir les applications actives et modifier leurs paramètres", U0r = "Vous pourrez voir les applications actives, mais ne pourrez pas modifier leurs paramètres", G0r = "Vous pourrez voir les applications actives et modifier leurs paramètres", W0r = "Les membres ne peuvent pas ajouter leurs propres flux de travail à ce type d'évènement.  Ils pourront voir les flux de travail actifs de l'équipe, mais ne pourront pas en modifier les paramètres.", H0r = "Les membres pourront ajouter leurs propres flux de travail à ce type d'évènement.  Ils pourront voir les flux de travail actifs de l'équipe, mais ne pourront pas en modifier les paramètres.", Y0r = "Vous pourrez voir les flux de travail actifs de l'équipe, mais vous ne pourrez pas modifier les paramètres de flux de travail ni ajouter vos flux de travail personnels à ce type d'évènement.", K0r = "Vous pourrez activer/désactiver les flux de travail personnels pour ce type d'évènement. Vous pourrez voir les flux de travail d'équipe actifs, mais vous ne pourrez pas modifier les paramètres des flux de travail d'équipe.", Z0r = "Les membres ne peuvent pas ajouter leurs webhooks personnels à ce type d'événement. Les membres pourront voir les webhooks actifs mais ne pourront pas modifier les paramètres des webhooks.", X0r = "Les membres pourront ajouter leurs webhooks personnels à ce type d'événement. Les membres pourront voir les webhooks actifs mais ne pourront pas modifier les paramètres des webhooks.", J0r = "Vous pouvez voir les webhooks gérés actifs mais vous ne pourrez pas modifier les paramètres des webhooks ni ajouter vos webhooks personnels à ce type d'événement.", Q0r = "Vous pouvez ajouter des webhooks à ce type d'événement. Vous pouvez voir les webhooks gérés actifs mais vous ne pourrez pas les modifier.", e1r = "Verrouillé par l'administrateur de l'équipe", t1r = "Vous n'avez pas connecté de compte {{appName}}.", n1r = "Connecter maintenant", o1r = "Remplacer et notifier {{count}} membre", r1r = "Remplacer et notifier {{count}} membres", i1r = "Le lien /{{slug}} existe déjà pour {{count}} membre. Voulez-vous le remplacer ?", a1r = "Le lien /{{slug}} existe déjà pour {{count}} membres. Voulez-vous le remplacer ?", s1r = "<strong>{{names}}</strong> utilise déjà le lien <strong>/{{slug}}</strong>.", c1r = "<strong>{{names}}</strong> utilisent déjà l'URL <strong>/{{slug}}</strong>.", l1r = "Si vous choisissez de le remplacer, nous les en informerons. Revenez en arrière et supprimez-les si vous ne souhaitez pas l'écraser.", u1r = "Examiner le type d'événement", d1r = "Vous cherchez plus d'analyses ?", _1r = "Vous cherchez plus de statistiques ?", p1r = "Filtres", m1r = "Filtrer", f1r = "Ajouter un membre", g1r = "Ajouter un filtre", h1r = "Ajouter une règle", v1r = "Ajouter un groupe de règles", b1r = "Effacer les filtres", y1r = "E-mail vérifié", $1r = "Sélectionner un utilisateur", w1r = "Sélectionner un type d'événement", k1r = "Sélectionner une plage de dates", S1r = "Événements populaires", E1r = "Aucun type d’événement trouvé", x1r = "Durée moyenne de l'événement", C1r = "Réservations par heure", T1r = "Membres les plus réservés", A1r = "Membres les moins réservés", I1r = "Plus grand nombre de réservations planifiées", O1r = "Plus petit nombre de réservations planifiées", N1r = "Plus grand nombre de réservations terminées", z1r = "Plus petit nombre de réservations terminées", R1r = "Événements créés", P1r = "Événements terminés", D1r = "Événements annulés", L1r = "Événements replanifiés", M1r = "Événements", F1r = "Performance", q1r = "depuis la dernière période", j1r = "De : {{startDate}} À : {{endDate}}", V1r = "L'ajout d'une redirection désactivera la page de succès. Assurez-vous de mentionner « Réservation confirmée » sur votre page de succès personnalisée.", B1r = "Tendances de l'événement", U1r = "Effacer les filtres", G1r = "Effacer", W1r = "Retenir", H1r = "Percevoir le paiement à la réservation", Y1r = "Facturer des frais d'absence", K1r = "Carte retenue", Z1r = "Débiter la carte", X1r = "Carte débitée", J1r = "Frais d'absence de {{amount, currency}}", Q1r = "Frais d'absence", eSr = "Soumettre la carte", tSr = "Soumettre les informations de paiement", nSr = "Votre rendez-vous est en attente d'un moyen de paiement", oSr = "Frais d'absence de {{amount, currency}} facturés pour {{title}} le {{date}}", rSr = "Des frais d'absence ont été facturés", iSr = "Des frais d'absence de {{amount, currency}} ont été facturés pour l'événement suivant", aSr = "Une erreur s'est produite lors de la facturation des frais d'absence. Veuillez réessayer plus tard.", sSr = "Percevoir les frais d'absence", cSr = "Frais d'absence facturés", lSr = "Paiement refusé. Veuillez essayer une autre carte ou contacter votre banque pour obtenir de l'aide.", uSr = "Ce type de carte n'est pas pris en charge pour cet achat. Veuillez utiliser un autre moyen de paiement.", dSr = "Le montant minimum de paiement est de 0,50 $ USD. Veuillez augmenter votre montant de paiement.", _Sr = "Impossible de débiter la carte pour le paiement.", pSr = "Statistiques", mSr = "Formulaires de routage", fSr = "Aucune donnée trouvée pour le filtre ou les dates sélectionnés.", gSr = "Je reconnais que si je ne participe pas à cet événement, des frais d'absence de {{amount, currency}} seront appliqués à ma carte.", hSr = "jours", vSr = "Détails de la carte", bSr = "Un problème est survenu de notre côté. Contactez notre équipe d'assistance, et nous le résoudrons immédiatement pour vous.", ySr = "Veuillez fournir le texte suivant lorsque vous contactez le support pour mieux vous aider", $Sr = "Il n'est pas possible d'activer les places et de facturer des frais d'absence pour le moment", wSr = "Terminez votre réservation", kSr = "Terminez votre réservation : {{title}} le {{date}}", SSr = "Confirmez vos coordonnées", ESr = "Copier le lien d'invitation", xSr = "Modifier les paramètres du lien", CSr = "Lien d'invitation copié", TSr = "Lien d'invitation supprimé", ASr = "Clé API supprimée", ISr = "Cela supprimera définitivement la clé API. Toutes les applications utilisant cette clé perdront immédiatement l'accès à votre compte. Cette action ne peut pas être annulée.", OSr = "Paramètres de lien d'invitation enregistrés", NSr = "Les liens ont été définis pour expirer après...", zSr = "1 jour", RSr = "7 jours", PSr = "30 jours", DSr = "3 mois", LSr = "1 an", MSr = "Vous avez été invité à rejoindre {{teamName}}", FSr = "{{amount, currency}}", qSr = "Vous êtes sur le point de facturer {{amount, currency}} au participant. Voulez-vous vraiment continuer ?", jSr = "Facturer {{amount, currency}} au participant", VSr = "Exiger un paiement ({{paymentFeePercentage}} % + {{fee, currency}} de commission par transaction)", BSr = "{{email}} a été invité", USr = "{{userCount}} utilisateurs ont été invités", GSr = "Erreur lors de la récupération de la carte", WSr = "L'image téléchargée ne doit pas dépasser 5 Mo", HSr = "{{errorCode}} : Vous n'êtes pas autorisé à activer ou désactiver ce workflow", YSr = "Intégration en ligne", KSr = "Charge votre type d'événement directement dans le contenu de votre site web.", ZSr = "Bouton flottant", XSr = "Place un bouton flottant sur votre site qui déclenche une modale avec votre type d'événement.", JSr = "Clic sur un élément", QSr = "Ouvre votre calendrier sous forme de boîte de dialogue lorsque quelqu'un clique sur un élément.", eEr = "Utiliser mon propre formulaire", tEr = "Utilisez notre API de routage headless et votre propre formulaire pour les soumissions.", nEr = "Besoin d'aide ? Consultez nos guides pour intégrer Cal sur Wix, Squarespace ou WordPress, consultez nos questions fréquentes ou explorez les options d'intégration avancées.", oEr = "Prendre rendez-vous", rEr = "Prénom", iEr = "Nom", aEr = "Prénom, Nom", sEr = "Inviter en tant que", cEr = "Formulaire mis à jour avec succès.", lEr = "Désactiver les e-mails de confirmation par défaut pour les participants", uEr = "Au moins un workflow est actif sur ce type d'événement qui envoie un e-mail aux participants lorsque l'événement est réservé.", dEr = "Désactiver les e-mails de confirmation par défaut pour l'hôte", _Er = "Au moins un workflow est actif sur ce type d'événement qui envoie un e-mail à l'hôte lorsque l'événement est réservé.", pEr = "Ajouter une superposition", mEr = "Importer des utilisateurs depuis Google Workspace", fEr = "Connecter Google Workspace", gEr = "Vous devez être un administrateur d'espace de travail pour utiliser cette fonctionnalité", hEr = "Créez votre premier webhook pour ce type d'événement", vEr = "Créez votre premier webhook avec « Rendez-vous instantané créé » comme déclencheur pour ce type d'événement", bEr = "Installer l’application sur", yEr = "Créer pour", $Er = "Devise", wEr = "Créez un environnement où vos équipes peuvent créer des applications, des flux de travail et des types d'événements partagés avec une planification round robin et collective.", kEr = "Gérer les organisations avec plusieurs équipes", SEr = "Configurer votre organisation", EEr = "Configurer votre plateforme", xEr = "Les organisations sont des environnements partagés dans lesquels les équipes peuvent créer des types d'événements partagés, des applications, des workflows, etc.", CEr = "Plans", TEr = "Plateforme", AEr = "Gérez tout ce qui concerne la plateforme.", IEr = "La plateforme Cal.com vous permet d'intégrer sans effort la planification dans votre application en utilisant les API et atoms de la plateforme.", OEr = "Vous devez entrer un nom d'organisation", NEr = "Vous devez entrer l'adresse e-mail de votre organisation", zEr = "Adresse e-mail de votre organisation", REr = "Adresse e-mail de votre administrateur", PEr = "Nom d'utilisateur de l'administrateur", DEr = "Nom de l'organisation", LEr = "Nom de la plateforme", MEr = "Lien de l'organisation", FEr = "Vérifier l'adresse e-mail de votre organisation", qEr = "Veuillez utiliser le code ci-dessous pour vérifier votre adresse e-mail et continuer à configurer votre organisation.", jEr = "Paramètres d'URL supplémentaires", VEr = "À propos de votre organisation", BEr = "Les organisations sont des environnements partagés dans lesquels vous pouvez créer plusieurs équipes avec des membres partagés, des types d'événements, des applications, des workflows, etc.", UEr = "Créer vos équipes", GEr = "Commencez à planifier ensemble en ajoutant les membres de votre équipe à votre organisation", WEr = "Inviter les administrateurs de votre organisation", HEr = "Ces administrateurs auront accès à toutes les équipes de votre organisation. Vous pouvez ajouter des administrateurs et des membres d'équipe plus tard.", YEr = "Définir un mot de passe", KEr = "Cela créera un nouveau compte utilisateur avec l'adresse e-mail de votre organisation et ce mot de passe.", ZEr = "Logo de l'organisation", XEr = "Quelques phrases à propos de votre organisation. Elles apparaîtront sur la page de profil public de votre organisation.", JEr = "Je le ferai plus tard", QEr = "Vérifier votre adresse e-mail", exr = "Entrez le code à 6 chiffres que nous avons envoyé à {{email}}", txr = "Vérifiez votre adresse e-mail pour créer une organisation", nxr = "Le code fourni n'est pas valide, veuillez réessayer", oxr = "L'adresse e-mail est déjà utilisée", rxr = "Vous avez été invité à rejoindre {{orgName}}", ixr = "Rejoignez votre équipe à {{orgName}} et commencez à vous concentrer sur les rendez-vous, pas sur leur préparation !", axr = "Les équipes suivantes n'ont pas pu être créées en raison de slugs identiques : {{slugs}}", sxr = "Les noms d'équipe ne peuvent pas être vides", cxr = "Les noms d'équipe ne peuvent pas être répétés", lxr = "L'utilisateur appartient à une organisation", uxr = "Cette organisation n'a pas encore d'équipe", dxr = "Si vous êtes un administrateur, assurez-vous de créer des équipes à afficher ici.", _xr = "Configurer", pxr = "Mon profil", mxr = "Mes paramètres", fxr = "CRM", gxr = "Messagerie", hxr = "Nom ou numéro affiché comme expéditeur d'un SMS (certains pays n'autorisent pas les ID d'expéditeur alphanumériques)", vxr = "Seul l'administrateur de votre organisation peut créer de nouvelles équipes", bxr = "La nouvelle politique anti-spam de Google pourrait vous empêcher de recevoir des notifications par e-mail et calendrier concernant cette réservation.", yxr = "Résoudre", $xr = "Une erreur s'est produite lors de la création des équipes pour cette organisation. Le slug du lien est manquant.", wxr = "Copier le lien vers l’organisation", kxr = "Équipe : {{teamName}}", Sxr = "Utilisateur : {{userName}}", Exr = "Visualisez les statistiques de réservation à travers vos événements", xxr = "Historique des appels", Cxr = "Consultez l'historique des appels pour tous vos appels Cal.ai", Txr = "{{locationCount}} options de lieu", Axr = "Type de canal", Ixr = "Raison de fin", Oxr = "Statut de la session", Nxr = "Sentiment de l'utilisateur", zxr = "Heure", Rxr = "De", Pxr = "Plan personnalisé", Dxr = "Intégration aux e-mails", Lxr = "Sélectionnez quelques créneaux disponibles et intégrez-les dans votre e-mail.", Mxr = "Sélectionner un créneau", Fxr = "Sélectionner une date", qxr = "Afficher uniquement si un paramètre est défini", jxr = "Ajouter un paramètre", Vxr = "Nous vous mettons en relation avec quelqu'un de {{orgName}}.", Bxr = "Veuillez ne pas fermer ou actualiser cette page", Uxr = "Voir tous les créneaux disponibles", Gxr = "p. ex. Équipe marketing", Wxr = "p. ex. Équipe de vente", Hxr = "p. ex. Équipe de design", Yxr = "p. ex. Équipe d'ingénierie", Kxr = "p. ex. Équipe d'analyse de données", Zxr = "Vous pourrez ajouter plus d'équipes plus tard.", Xxr = "En quoi consiste ce rendez-vous ?", Jxr = "Ajouter à l'équipe", Qxr = "Supprimer des utilisateurs de l'organisation", eCr = "Identifiant de délégation", tCr = "L'identifiant de délégation vous permet de gérer l'accès aux calendriers Google Workspace pour votre organisation.", nCr = "Ajoutez cet identifiant client dans Google Workspace avec la portée ci-dessous", oCr = "Identifiant de délégation activé", rCr = "Ajouter un identifiant de délégation", iCr = "Modifier l'identifiant de délégation", aCr = "Domaine", sCr = "Aucune plateforme workspace", cCr = "Plateforme workspace", lCr = "Plateformes workspace", uCr = "Gérez les plateformes workspace qui peuvent être utilisées pour l'identifiant de délégation", dCr = "Modifier la plateforme workspace", _Cr = "Modifier le compte de service", pCr = "Ajouter une plateforme workspace", mCr = "Slug", fCr = "Clé JSON du compte de service", gCr = "Modifier la clé JSON du compte de service", hCr = "L'identifiant de délégation limite l'ajout à une seule installation", vCr = "L'application a été installée avec succès et utilise les identifiants délégués", bCr = "Voulez-vous vraiment supprimer {{userCount}} utilisateurs de cette organisation ?", yCr = "Retirer des utilisateurs de l'équipe", $Cr = "Êtes-vous sûr de vouloir retirer {{userCount}} utilisateurs de cette équipe ?", wCr = "Cet utilisateur n'a pas encore configuré de planning", kCr = "Cet utilisateur n'est dans aucune équipe", SCr = "Cet utilisateur n'a pas encore installé d'applications", ECr = "Nécessite la vérification par e-mail du participant", xCr = "Pour assurer la vérification par e-mail du participant avant la planification des événements.", CCr = "Les messages ne peuvent être envoyés aux participants que lorsque le type d'événement nécessite une confirmation.", TCr = "Organisations", ACr = "Téléverser un logo vidéo Cal", ICr = "Mettre à jour un logo vidéo Cal", OCr = "Télécharger une bannière", NCr = "Pour assurer que votre logo reste visible sur le fond sombre de la vidéo Cal, veuillez téléverser une image de couleur claire au format PNG ou SVG afin de maintenir la transparence.", zCr = "Autres équipes", RCr = "Ici, vous pouvez voir les équipes au sein de votre organisation dont vous ne faites pas partie. Vous pouvez vous y ajouter si nécessaire.", PCr = "Vous ne faites partie d'aucune organisation", DCr = "Aucune autre équipe trouvée", LCr = "Il n'y a pas d'autres équipes dans cette organisation.", MCr = "Prénom du participant", FCr = "Nom du participant", qCr = "Le prénom du participant", jCr = "Le nom de famille du participant", VCr = "Votre résumé mensuel", BCr = "Nom du membre", UCr = "Événements les plus populaires", GCr = "Voici votre résumé des événements populaires pour votre équipe {{teamName}} au cours des 30 derniers jours", WCr = "Moi", HCr = "Réunion indisponible", YCr = "E-mail de synthèse mensuelle", KCr = "E-mail de résumé mensuel pour les équipes.", ZCr = "Vérifiez votre équipe pour activer l'envoi de messages aux participants", XCr = "Membre supprimé", JCr = "Mes disponibilités", QCr = "Disponibilités de l'équipe", eTr = "Disponibilité immédiate pour une réunion", tTr = "Code de récupération", nTr = "Codes de récupération", oTr = "Chaque code de récupération peut être utilisé une seule fois pour accorder l'accès sans votre authentificateur.", rTr = "Codes de récupération copiés !", iTr = "Le code de récupération est incorrect.", aTr = "Accès perdu", sTr = "Aucun code de récupération trouvé. Merci de les générer dans vos paramètres.", cTr = "Nouvelle organisation créée : action en attente", lTr = "Bonjour administrateur", uTr = "Une organisation nécessite une configuration DNS", dTr = "Une organisation avec le slug « {{orgSlug}} » a été créée.<br /><br />Assurez-vous de configurer votre registre DNS pour pointer le sous-domaine correspondant à la nouvelle organisation où l'application principale est en cours d'exécution. Autrement, l'organisation ne fonctionnera pas.<br /><br />Voici les options de base pour configurer un sous-domaine pour qu'il pointe vers son application afin qu'il charge la page de profil de l'organisation.<br /><br />Vous pouvez le faire soit avec l'enregistrement A :", _Tr = "Ou l'enregistrement CNAME :", pTr = "Une fois le sous-domaine configuré, veuillez marquer la configuration DNS comme terminée dans les paramètres d'administration des organisations.", mTr = "Accéder aux paramètres d'administration des organisations", fTr = "L'organisation a été traitée", gTr = "Une erreur s'est produite lors du traitement de cette organisation", hTr = "Une liste de toutes les organisations. Accepter une organisation permettra à tous les utilisateurs avec ce domaine de messagerie de s'inscrire SANS vérification d'e-mail.", vTr = "Non vérifié", bTr = "Vérifié", yTr = "DNS manquant", $Tr = "DNS configuré", wTr = "Marquer comme DNS configuré", kTr = "Valeur", STr = "Votre organisation a été mise à jour avec succès", ETr = "Cette équipe n'a aucun type d'événement", xTr = "L'option par place ne prend pas en charge les durées multiples", CTr = "Inclure l'événement du calendrier", TTr = "OAuth", ATr = "Formulaire de création de client OAuth", ITr = "Ceci est le formulaire pour créer un nouveau client OAuth", OTr = "Formulaire de mise à jour du client OAuth", NTr = "Ceci est le formulaire pour modifier un client OAuth existant", zTr = "Ajoutées récemment", RTr = "Connectez vos calendriers", PTr = "{{appName}} relève la disponibilité de tous vos calendriers existants.", DTr = "Personnalisez votre expérience de planification avec les workflows", LTr = "Automatisation de workflows", MTr = "Planifiez pour votre équipe grâce à la planification collective et par permutation circulaire", FTr = "Aucun membre trouvé", qTr = "Synchronisation des dossiers", jTr = "Nom du répertoire", VTr = "Fournisseur du répertoire", BTr = "URL de base SCIM", UTr = "Jeton du porteur SCIM", GTr = "URL de base SCIM copiée", WTr = "Le jeton SCIM Bearer a été copié", HTr = "Votre Fournisseur d'identité vous demandera les informations suivantes pour configurer SCIM. Suivez les instructions pour terminer l'installation.", YTr = "Configurer la synchronisation du répertoire", KTr = "Choisissez un fournisseur d'identité pour configurer le répertoire de votre équipe.", ZTr = "Configurer un fournisseur d'identité pour commencer avec SCIM.", XTr = "Connexion de synchronisation du répertoire créée.", JTr = "Fourniture et dispense des utilisateurs avec votre fournisseur de répertoire.", QTr = "Connexion de synchronisation du répertoire supprimé.", eAr = "Supprimer la connexion", tAr = "Supprimer la connexion de synchronisation de répertoire", nAr = "Êtes-vous sûr de vouloir supprimer cette connexion de synchronisation de répertoire?", oAr = "Cette action ne peut pas être annulée. Cela supprimera définitivement la connexion de synchronisation du répertoire.", rAr = "Configuration de l'événement : la durée doit être d'au moins 1 minute.", iAr = "Horaires de disponibilité", aAr = "Non autorisé", sAr = "{{clientName}} aimerait accéder à votre compte {{appName}}", cAr = "Sélectionner un compte ou une équipe", lAr = "Cela permettra au {{clientName}} de", uAr = "Vous associer à vos informations personnelles de {{clientName}}", dAr = "Voir vos informations personnelles, y compris celles que vous avez rendues publiques", _Ar = "Voir votre adresse e-mail principale", pAr = "Vous connecter à vos applications installées", mAr = "Lire, modifier, supprimer vos types d'événements", fAr = "Lire, modifier, supprimer vos disponibilités", gAr = "Lire, modifier, supprimer vos réservations", hAr = "Autoriser {{clientName}} à faire cela ?", vAr = "En cliquant sur autoriser, vous autorisez cette application à utiliser vos informations conformément à ses conditions de service et à sa politique de confidentialité. Vous pouvez supprimer l'accès dans l'App Store de {{appName}}.", bAr = "Autoriser", yAr = "Cet utilisateur n'a pas terminé son intégration. Vous ne pourrez pas définir sa disponibilité tant qu'il n'aura pas terminé son intégration.", $Ar = "Vous consultez les disponibilités de cet utilisateur. Vous ne pouvez modifier que vos propres disponibilités.", wAr = "Vous pouvez modifier ceci pour chaque événement dans les paramètres avancés de chaque type d'événement.", kAr = "Modifier la disponibilité de l'utilisateur : {{username}}", SAr = "Renvoyer l'invitation", EAr = "L'invitation a été renvoyée.", xAr = "SAML", CAr = "Ajouter un client", TAr = "Après avoir copié le secret, vous ne pourrez plus le voir", AAr = "Ajouter un nouveau client", IAr = "Ajouter un nouvel utilisateur", OAr = "Cette application n'a pas encore été configurée", NAr = "au format CSV", zAr = "Superposer mon calendrier", RAr = "En vous connectant à votre calendrier, vous acceptez notre politique de confidentialité et nos conditions d'utilisation. Vous pouvez révoquer cet accès à tout moment.", PAr = "Consultez les événements de votre calendrier afin d'éviter les réservations incompatibles.", DAr = "Rejoignez {{eventLocationType}}", LAr = "Dépannage", MAr = "Calendriers que nous vérifions pour les conflits", FAr = "Horaires de disponibilité", qAr = "Gérer les calendriers", jAr = "Gérer les horaires de disponibilité", VAr = "Verrouillé", BAr = "Déverrouillé", UAr = "Verrouiller le fuseau horaire sur la page de réservation", GAr = "Pour verrouiller le fuseau horaire sur la page de réservation, utile pour les événements en personne.", WAr = "Vous ne pouvez activer qu'une seule application de paiement par type d'événement.", HAr = "Veuillez entrer le numéro au format international.", YAr = "Installer Calendrier", KAr = "Sous-domaine de marque", ZAr = "Obtenez votre propre sous-domaine de marque, tel que acme.cal.com", XAr = "Statistiques à l'échelle de l'organisation", JAr = "Comprenez comment l'ensemble de votre organisation passe son temps", QAr = "Marque blanche étendue", e2r = "Personnalisez votre expérience de planification avec votre propre logo, vos couleurs, etc.", t2r = "Équipes illimitées", n2r = "Vérifier l'e-mail", o2r = "Veuillez saisir l'adresse e-mail utilisée pour cette réservation afin de procéder à l'annulation", r2r = "L'e-mail ne correspond pas à l'e-mail de réservation", i2r = "Ajoutez autant de sous-équipes que nécessaire à votre organisation", a2r = "Facturation unifiée", s2r = "Types d'événements gérés avancés", c2r = "Ajoutez une seule carte de crédit pour payer tous les abonnements de votre équipe", l2r = "Entreprise", u2r = "Passez en Entreprise pour créer votre organisation", d2r = "Créer votre organisation", _2r = "Créer une organisation", p2r = "Passez en Organizations et recevez un sous-domaine, une facturation unifiée, des statistiques, un marquage blanc extensif et plus encore", m2r = "Passez à la version Entreprise et accédez à Synchronisation Active Directory, au provisionnement automatique des utilisateurs SCIM, aux agents vocaux Cal.ai, aux API d'administration et à bien d'autres choses encore !", f2r = "Vous ne pouvez activer qu'une seule application de paiement par type d'événement", g2r = "Les équipes membres de cette organisation seront également supprimées avec leurs types d'événements", h2r = "Les utilisateurs qui faisaient partie de l'organisation ne seront pas supprimés, mais leurs noms d'utilisateur seraient modifiés pour leur permettre d'exister en dehors de l'organisation", v2r = "Les types d'événements utilisateur créés après l'intégration de l'utilisateur dans l'organisation seront supprimés", b2r = "Les types d'événements utilisateur migrés ne seront pas supprimés", y2r = "Supprimer {{organizationName}} ?", $2r = "Publiée", w2r = "Non publiée", k2r = "Publier", S2r = "Ouvrez l'outil de dépannage et déterminez ce qui ne va pas avec votre planning", E2r = "Besoin d'aide ?", x2r = "Dépannage", C2r = "Numéro à appeler", T2r = "Nom de l'invité", A2r = "Adresse e-mail de l'invité", I2r = "Entreprise de l'invité", O2r = "Veuillez installer un publier", N2r = "Réservation instantanée", z2r = "Autoriser les gens à réserver immédiatement", R2r = "Passez en Entreprise et autorisez les invités à rejoindre un appel instantané auquel les participants peuvent accéder directement. Ceci n'est valable que pour les types d'événements d'équipe", P2r = "Vous ne voulez pas attendre ?", D2r = "Le rendez-vous a commencé", L2r = "Payer pour réserver", M2r = "Laissez les agents IA vous réserver", F2r = "Impossible de trouver la réservation", q2r = "Les places de réservation sont complètes", j2r = "Identifiants de paiement manquants", V2r = "Id de l'application de paiement manquant", B2r = "La réservation n'a pas assez de places disponibles", U2r = "{{username}} est actuellement en absence de courte durée.", G2r = "Pendant ce temps, {{profile.username}} sera responsable de tous les rendez-vous programmés de la part de {{username}}.", W2r = "Absent du bureau", H2r = "Configurez des actions dans votre profil pendant votre absence.", Y2r = "Envoyer une demande", K2r = "Les dates de début et de fin sont requises", Z2r = "La date de début doit être antérieure à la date de fin", X2r = "La date de début doit être dans le futur", J2r = "Utilisateur introuvable", Q2r = "Impossible de rediriger vers soi-même", eIr = "L'entrée absent du bureau existe déjà", tIr = "L'id de l'entrée absent du bureau est requis", nIr = "Une redirection de réservation de cet utilisateur vers vous existe déjà.", oIr = "Création d'une nouvelle entrée réussie", rIr = "Notification de redirection de réservation", iIr = "Notification de redirection de réservation", aIr = "Vous avez reçu une redirection de réservation de la part de {{eventOwner}}. Leurs liens de profil seront redirigés vers le vôtre pour la période du {{dates}}.", sIr = "Notification de modification de redirection de réservation", cIr = "Notification de modification de redirection de réservation", lIr = "Votre redirection de réservation de la part de {{eventOwner}} pour la période du {{oldDates}} a été mise à jour. La nouvelle période de redirection est du {{dates}}.", uIr = "Notification d'annulation de redirection de réservation", dIr = "Notification d'annulation de redirection de réservation", _Ir = "Votre redirection de réservation de la part de {{eventOwner}}, pour la période du {{dates}}, a été annulée.", pIr = "Vous avez accepté cette demande de redirection de réservation.", mIr = "Vous avez refusé cette demande de redirection de réservation.", fIr = "Copier le lien pour partager la demande", gIr = "Demande de redirection de réservation", hIr = "Sélectionner un membre de l'équipe", vIr = "Vous partez? Marquez simplement le lien de votre profil comme étant indisponible pendant un certain temps.", bIr = "Redirigez votre profil vers un autre membre de l'équipe", yIr = "Redirigez votre profil vers un autre membre de l'équipe (formule Équipe requise)", $Ir = "Liste des indisponibilités absent du bureau", wIr = "Suppression de l'entrée réussie", kIr = "Entrée modifiée avec succès", SIr = "Temporairement absent du bureau?", EIr = "Ajouter une redirection", xIr = "Créer une entrée", CIr = "Plage temporelle", TIr = "Ajouter tous les membres de l'équipe, y compris les futurs membres", AIr = "Redirection vers", IIr = "Vous avez du mal à trouver un créneau?", OIr = "En voir plus", NIr = "Transmettez des paramètres tels que ?email=...&name=.... et plus", zIr = "Planifiez des rendez-vous lorsque tout le monde est disponible ou faites une rotation entre les membres de votre équipe", RIr = "le plus bas", PIr = "bas", DIr = "moyen", LIr = "élevé", MIr = "le plus élevé", FIr = "Envoyer un utilisateur vers", qIr = "Définir la priorité", jIr = "Définir la pondération", VIr = "Activer les pondérations", BIr = "Priorité pour {{userName}}", UIr = "Les pondérations déterminent comment les réunions sont distribuées entre les hôtes. <0>En savoir plus</0>", GIr = "Pondération pour {{userName}}", WIr = "changer la priorité", HIr = "Utiliser les identifiants de champs comme variables pour la redirection de votre événement personnalisé", YIr = "Utiliser les identifiants de champs comme variables pour la redirection de votre événement personnalisé (par ex. : {{variable}})", KIr = "Le compte est déjà associé", ZIr = "Envoyer un e-mail", XIr = "Appeler le participant en utilisant l'agent vocal Cal.ai", JIr = "Appel pour confirmer la réservation", QIr = "2 heures avant le début de l'événement", eOr = "Configuration de l'agent Cal.ai", tOr = "Veuillez choisir au moins un type d'événement pour effectuer un appel test.", nOr = "Marquer comme absence", oOr = "Ne plus marquer comme absence", rOr = "Dissociation du compte réussie", iOr = "Une erreur est survenue lors de la dissociation du compte", aOr = "Programme de voyage", sOr = "Planifiez votre voyage à l'avance pour conserver votre horaire actuel dans un fuseau horaire différent et éviter d'être réservé à minuit.", cOr = "Changement de fuseau horaire", lOr = "Date", uOr = "Saisissez l'invite générale pour l'agent", dOr = "Cette date chevauche un horaire existant. Veuillez sélectionner une autre date.", _Or = "Recevez des notifications lorsque votre équipe n'est pas disponible", pOr = "Les administrateurs recevront des notifications par e-mail lorsqu'un utilisateur essaiera de réserver un membre de l'équipe et qu'il rencontrera la mention « Pas de disponibilité ». Nous déclenchons cet e-mail après deux occurrences et nous vous rappelons tous les 7 jours par utilisateur.  ", mOr = "Désactiver les notifications SMS pour les types d'événements par téléphone uniquement", fOr = "Désactiver les notifications SMS automatisées pour les types d'événements qui n'ont que le numéro de téléphone (attendeePhoneNumber) comme question obligatoire avec l'email en option ou non requis", gOr = "Votre formule actuelle", hOr = "37 $ par utilisateur par mois", vOr = "Gérez les paramètres de confidentialité de votre organisation", bOr = "Confidentialité", yOr = "De nouvelles équipes seront rattachées à votre organisation", $Or = "Ajouter un nom de groupe", wOr = "Nom de groupe", kOr = "Routeurs", SOr = "Primaire", EOr = "Rendre primaire", xOr = "Ajouter un e-mail", COr = "Ajouter des e-mails", TOr = "Ajoutez une adresse e-mail pour remplacer votre adresse principale ou pour utiliser comme adresse de courriel alternative sur vos types d'événements.", AOr = "Confirmez votre adresse e-mail", IOr = "$t(hey_there) {{name}}, confirmation de votre réservation le {{date}}.", OOr = "Le prénom de la personne qui effectue la réservation", NOr = "Le nom de famille de la personne qui effectue la réservation", zOr = "Nom du planificateur", ROr = "Votre prénom", POr = "Nous avons envoyé un e-mail à <strong>{{email}}</strong>. Cliquez sur le lien dans l'e-mail pour vérifier cette adresse.", DOr = "Envoyer les détails de l'événement à", LOr = "Fuseau horaire de la planification sans date de fin", MOr = "Sélectionner les membres", FOr = "Que devons-nous faire des types d'évènements existants de votre membre ?", qOr = "Tous les types d'évènements individuels de vos membres (à l'exception des évènements gérés) seront définitivement supprimés. Ils ne pourront plus en créer de nouveaux", jOr = "Les types d'évènements individuels de vos membres seront masqués (à l'exception des évènements gérés) dans les profils, mais les liens seront toujours actifs. Ils ne pourront pas en créer de nouveaux.  ", VOr = "Masquer les types d'évènements individuels", BOr = "Supprimer les types d'évènements individuels", UOr = "Verrouiller la création de types d'évènements individuels", GOr = "Empêchez les membres de créer leurs propres types d'évènements.", WOr = "Ajouter un type d'évènement", HOr = "Créer le mot de passe du compte", YOr = "Créer un compte avec SAML", KOr = "Échec de la création du mot de passe du compte", ZOr = "Impossible de créer un mot de passe pour les comptes cal", XOr = "Impossible de créer un mot de passe pour un compte déjà créé", JOr = "Vous n'avez pas de mot de passe pour votre compte. Créez-en un depuis Sécurité -> Mot de passe. Vous ne pouvez pas vous déconnecter tant que le mot de passe du compte n'a pas été créé.", QOr = "Déconnecter le compte connecté", eNr = "La déconnexion de votre compte connecté modifiera votre façon de vous connecter. Vous ne pourrez plus vous connecter à votre compte qu'en utilisant votre adresse e-mail et votre mot de passe", tNr = "J'accepte la politique de confidentialité et l'utilisation des cookies", nNr = "Passer un appel", oNr = "Ignorer l'affectation par permutation circulaire si le contact existe dans Salesforce", rNr = "L'URL doit contenir l'adresse e-mail du contact en tant que paramètre. Ex. : ?email=contactEmail", iNr = "Sélectionnez un compte", aNr = "Installez {{appName}} sur votre compte personnel ou sur le compte d'une équipe.", sNr = "Sélectionner des types d'évènement", cNr = "Sur quel type d'évènement voulez-vous installer {{appName}} ?", lNr = "Configurer {{appName}}", uNr = "Finalisez la configuration de l'application. Vous pourrez modifier ces paramètres ultérieurement.", dNr = "déjà installé", _Nr = "Non spécifiée", pNr = "Vacances", mNr = "Voyage", fNr = "Congé maladie", gNr = "Jour férié", hNr = "Transfert vers <0>{{username}}</0>", vNr = "Pas de transfert", bNr = "Créer une absence", yNr = "Communiquez à vos utilisateurs lorsque vous n'êtes pas disponible pour prendre des réservations. Ils peuvent toujours prendre une réservation à votre retour ou vous pouvez les transmettre à un membre de l'équipe.", $Nr = "{{displayName}} est en absence", wNr = "<0>{{displayName}}</0> peut prendre vos rendez-vous quand vous n'êtes pas là.", kNr = "Réserver {{displayName}}", SNr = "Sélectionnez une raison", ENr = "Passer en absence", xNr = "Modifier une entrée d'absence", CNr = "Envoyer un commentaire", TNr = "Votre hôte ne s'est pas présenté", ANr = "Vous pouvez reprogrammer un autre rendez-vous avec lui ou elle", INr = "Comment pouvons-nous améliorer notre service ?", ONr = "Qu'avez-vous préféré ?", NNr = "Examiner", zNr = "Évalué", RNr = "Sans évaluation", PNr = "URL d'évaluation", DNr = "L'URL du formulaire de commentaire et d'évaluation", LNr = "URL d'absence", MNr = "L'URL de commentaire en cas de non présentation", FNr = "Pas besoin d'assistance ?", qNr = "Masquer l'assistance", jNr = "Évaluations moyennes", VNr = "Absence (hôte)", BNr = "Absence (invité)", UNr = "Évaluations récentes", GNr = "Aucune évaluation envoyée", WNr = "Ajoutez un flux de travail avec « Évaluation » pour récupérer les évaluations après les réunions", HNr = "Hôte avec le plus d'absences", YNr = "Mieux noté", KNr = "Moins bien noté", ZNr = "Membres dont les réunions sont les mieux notées", XNr = "Membres dont les réunions sont les moins bien notées", JNr = "Score CSAT", QNr = "SMS verrouillé", ezr = "Partir sans affecter personne ?", tzr = "Voulez-vous vraiment quitter cet évènement sans ajouter de participants ?", nzr = "Si vous n'affectez personne à cet évènement, aucune disponibilité ne sera indiquée aux personnes qui effectuent une réservation.", ozr = "Revenir en arrière et affecter", rzr = "Quitter sans affecter", izr = "En poursuivant, vous acceptez nos <0>Conditions d'utilisation</0> et <1>Politique de confidentialité</1>.", azr = "En continuant, vous acceptez nos", szr = "Conditions", czr = "Tout disponible pendant {{x}} jours", lzr = "Déplace automatiquement la fenêtre de réservation de {{x}} jours chaque jour, garantissant que votre calendrier affiche toujours les {{x}} prochains jours de créneaux disponibles.", uzr = "Abonnement d'équipe annulé avec succès", dzr = "Erreur lors de l'annulation de l'abonnement d'équipe", _zr = "Une erreur est survenue lors de la souscription à l'offre de plateforme. Veuillez réessayer plus tard", pzr = "Une erreur est survenue lors de la mise à jour du client OAuth. Veuillez réessayer plus tard", mzr = "Une erreur est survenue lors de la création du client OAuth. Veuillez réessayer plus tard", fzr = "Couleur du type d'événement", gzr = "Cette couleur est uniquement utilisée pour différencier les types d'événements et les réservations dans l'application. Elle n'est pas affichée aux personnes qui réservent.", hzr = "Marquer comme absence", vzr = "{{x}} marqués comme absences", bzr = "{{x}} plus marqués comme absences", yzr = "déclencheurs pour tous les types d'événements d'équipe et les types d'événements personnels de tous les membres de l'équipe", $zr = "Gérez les paramètres de votre équipe", wzr = "Statut absence mis à jour pour les participants", kzr = "E-mail copié", Szr = "Numéro de téléphone copié", Ezr = "L'utilisateur est un membre en attente de l'organisation", xzr = "L'utilisateur a déjà été invité ou est déjà membre", Czr = "L'utilisateur est membre d'une organisation dont cette équipe ne fait pas partie.", Tzr = "La réservation a été réaffectée", Azr = "Réaffecter", Izr = "Réaffecter la réservation à un autre hôte round robin disponible", Ozr = "Assigner un membre de l'équipe", Nzr = "Remplacer le membre de l'équipe que vous souhaitez assigner.", zzr = "Aucun hôte disponible", Rzr = "Réaffecter l'hôte round robin", Pzr = "Ne pas écrire dans le flux ICS", Dzr = "Le report n'est pas possible car l'événement a expiré", Lzr = "Cet événement a expiré", Mzr = "Ne pas créer de contacts s'ils n'existent pas dans {{appName}}", Fzr = "Si votre lien ICS est en lecture seule (par exemple, Proton Calendar), cochez la case ci-dessus pour éviter les erreurs. Vous devrez également mettre à jour manuellement votre calendrier pour les changements.", qzr = "Attributs", jzr = "Nouvel attribut", Vzr = "Ajouter des attributs", Bzr = "Ajouter des attributs à vos membres d'équipe", Uzr = "Nouvelle option", Gzr = "Mettre à jour le membre", Wzr = "Attribut", Hzr = "Créer un attribut pour les membres de votre équipe", Yzr = "Modifier un attribut pour les membres de votre équipe", Kzr = "Attribut mis à jour avec succès", Zzr = "Attribut supprimé avec succès", Xzr = "Attributs modifiés avec succès", Jzr = "Gérer les attributs de vos membres d'équipe", Qzr = "Modifier les attributs de vos membres d'équipe", eRr = "Retour aux attributs", tRr = "Êtes-vous sûr de vouloir supprimer cette option ?", nRr = "Cette option est attribuée à {{numberOfUsers}} membres. Sa suppression l'enlèvera de leur profil.", oRr = "Désactiver les e-mails standard aux participants liés à ce type d'événement", rRr = "Désactive la communication par e-mail standard liée à ce type d'événement, y compris les confirmations de réservation, les rappels et les annulations.", iRr = "Désactiver les e-mails standard aux hôtes liés à ce type d'événement", aRr = "Tapez 'confirmer' pour continuer", sRr = "Désactiver l'e-mail", cRr = "Accorder l'accès à l'API d'administration", lRr = "Révoquer l'accès à l'API d'administration", uRr = "Ajouter le calendrier {{calendar}}", dRr = "Connecter le calendrier Apple", _Rr = "Calendrier Apple connecté", pRr = "Vérification du calendrier Apple", mRr = "Connecter le calendrier Google", fRr = "Calendrier Google connecté", gRr = "Vérification du calendrier Google", hRr = "Connecter le calendrier Outlook", vRr = "Calendrier Outlook connecté", bRr = "Vérification du calendrier Outlook", yRr = "Se connecter à Stripe", $Rr = "Stripe connecté", wRr = "Vérification des identifiants Stripe", kRr = "Variables de réponse aux questions de réservation", SRr = "Géré par {{teamAdmins}}", ERr = "{{count}} options", xRr = "Reprogrammer avec le même hôte round-robin", CRr = "Les événements reprogrammés seront attribués au même hôte que celui initialement prévu", TRr = "Désactiver la saisie si l'identifiant URL est prérempli", ARr = "Limites de réservation", IRr = "Limites de réservation pour les membres de l'équipe sur tous les types d'événements d'équipe", ORr = "Limiter le nombre de fois où les membres peuvent être réservés pour tous les types d'événements d'équipe", NRr = "Limites de réservation mises à jour avec succès", zRr = "Vous n'êtes pas autorisé à apporter cette modification à la réservation", RRr = "Identifiant de délégation désactivé", PRr = "Membres correspondants", DRr = "{{x}} membres correspondants", LRr = "File d'attente des membres correspondants (selon les pondérations d'attributs)", MRr = "File d'attente des membres correspondants (selon les pondérations des assignés à l'événement)", FRr = "Aucun membre correspondant. Par défaut, les membres de l'équipe assignés au type d'événement seront utilisés.", qRr = "Aucun membre correspondant. Le système utilisera par défaut les membres de l'équipe assignés au type d'événement. Envisagez d'ajouter une solution de repli ou de corriger la logique d'utilisation des membres de repli", jRr = "Masquer les détails des événements du calendrier sur les calendriers partagés", VRr = "Lorsqu'un calendrier est partagé, les événements sont visibles pour les lecteurs, mais leurs détails sont cachés pour ceux qui n'ont pas d'accès en écriture.", BRr = "{{count}} derniers jours", URr = "Mois en cours", GRr = "Année en cours", WRr = "Période personnalisée", HRr = "Politique de remboursement", YRr = "Toujours", KRr = "Jamais", ZRr = "Option de paiement", XRr = "Si annulé", JRr = "avant", QRr = "Afficher toutes les colonnes", ePr = "Basculer les colonnes", tPr = "Aucune colonne trouvée", nPr = "Lors de la réservation, ajouter les événements et les nouveaux participants en tant que :", oPr = "Prospect", rPr = "Contact sous un compte", iPr = "Ne pas créer d'enregistrement {{entry}} s'il n'existe pas dans Salesforce", aPr = "Si le contact n'existe pas sous un compte, créer un nouveau prospect à partir du participant", sPr = "Créer un nouveau contact sous un compte basé sur le domaine e-mail du participant et les contacts existants", cPr = "Changer le propriétaire de l'enregistrement lors de la réservation", lPr = "Attribuer des attributs en masse", uPr = "Cela affiche un message personnalisé. Essayez de modifier la réponse pour rediriger vers un événement", dPr = "Cela entraîne une redirection vers {{externalUrl}}. Essayez de modifier la réponse pour rediriger vers un événement", _Pr = "Hôte possible", pPr = "Statut d'acheminement actuel", mPr = "Réacheminer la réservation", fPr = "Réacheminer la réservation vers différents membres de l'équipe", gPr = "Vérifier le nouvel itinéraire", hPr = "Réacheminer", vPr = "Nouveau statut d'acheminement", bPr = "Si le participant existe dans Salesforce, réserver directement avec le propriétaire", yPr = "Entité dont il faut vérifier le propriétaire pour réserver directement", $Pr = "Compte", wPr = "Choisir les horaires des hôtes", kPr = "Vous pouvez sélectionner un horaire différent pour chaque hôte. L'horaire par défaut de chaque hôte est choisi par défaut.", SPr = "Aucun hôte assigné, ajoutez des hôtes dans l'onglet d'affectation.", EPr = "Réassigner manuellement l'hôte round robin", xPr = "Réassigner manuellement l'hôte round robin à un autre hôte disponible", CPr = "Réassigner l'hôte round robin à un autre hôte disponible", TPr = "Le nouvel utilisateur n'est pas un hôte round robin valide pour ce type d'événement", APr = "Le nouvel utilisateur est un hôte fixe pour ce type d'événement", IPr = "Replanifier avec le même créneau horaire", OPr = "Replanifier avec le même créneau horaire du nouvel événement", NPr = "Replanifier vers le nouvel événement avec un créneau horaire différent", zPr = "Replanifier avec un créneau horaire différent", RPr = "Nous n'avons pas d'identifiant pour le nouvel événement. Veuillez retourner au formulaire de routage et l'enregistrer à nouveau.", PPr = "Réservation réacheminée avec succès. Redirection vers la page de réservation", DPr = "Lors de la réservation, écrire dans l'objet de l'événement", LPr = "Nom du champ", MPr = "Ajouter un nouveau champ", FPr = "Vous n'avez pas accès pour rediriger cette réservation", qPr = "Réponse du formulaire non trouvée", jPr = "Propriétaire du contact", VPr = "Non trouvé", BPr = "Utilisation des membres de repli", UPr = "Itinéraire choisi", GPr = "Logique d'attribut correspondante", WPr = "Logique de repli d'attribut correspondante", HPr = "Tous les membres assignés au type d'événement d'équipe. Envisagez d'ajouter des règles d'attributs.", YPr = "Tous les membres assignés au type d'événement d'équipe. Envisagez d'ajouter des règles d'attributs pour le repli.", KPr = "Tous les membres assignés au type d'événement d'équipe. Envisagez d'ajuster le repli pour obtenir une correspondance.", ZPr = "Avertissement", XPr = "Repli : si aucun membre de l'équipe ne correspond, utilisez ceux qui correspondent aux critères suivants (correspond par défaut à tous les membres de l'équipe assignés à l'événement)", JPr = "Avertissement de repli", QPr = "Non nécessaire", eDr = "Hôte indisponible", tDr = "Hôte disponible", nDr = "Êtes-vous sûr de vouloir réassigner cette réservation à un hôte indisponible ?", oDr = "Êtes-vous sûr de vouloir réassigner cette réservation ?", rDr = "Oui, réassigner", iDr = "Filtrer par attributs", aDr = "Raison de la réassignation", sDr = "La modification du type de champ peut entraîner une perte de données. Veuillez plutôt créer un nouveau champ.", cDr = "Réassigné par", lDr = "ligne", uDr = "lignes", dDr = "Fuseau horaire du participant", _Dr = "Heure de début de l'événement dans le fuseau horaire du participant", pDr = "Heure de début de l'événement dans le fuseau horaire du participant", mDr = "Heure de fin de l'événement dans le fuseau horaire du participant", fDr = "Heure de fin de l'événement dans le fuseau horaire du participant", gDr = "Créer un événement sur le contact, s'il existe. Sinon, utiliser le lead comme alternative", hDr = "Nom du propriétaire à modifier", vDr = "Aucun filtre défini", bDr = "Test de réservation réussi", yDr = "Le test à blanc a été effectué avec succès.", $Dr = "Vous n'avez pas accès à cette page", wDr = "Pour voir ou interagir avec cette page, vous devez avoir des privilèges d'administrateur ou de propriétaire", kDr = "Type de champ", SDr = "Quand écrire", EDr = "Lors de la réservation, écrire dans un champ personnalisé sur l'enregistrement {{record}} du participant", xDr = "À chaque réservation", CDr = "Seulement si le champ est vide", TDr = "Date de début de la réservation", ADr = "Date de création de la réservation", IDr = "Réservation réassignée à {{host}}", ODr = "Aucun propriétaire de contact", NDr = "Formulaires de routage créés", zDr = "Réponses totales", RDr = "Réponses totales sans réservation", PDr = "Réponses totales avec réservation", DDr = "Aucune réservation", LDr = "Nom du formulaire", MDr = "Réservation", FDr = "Aucune réservation", qDr = "Réservé par", jDr = "Créé le", VDr = "Statut de la réservation", BDr = "Réservé le", UDr = "Soumis le", GDr = "Copier l'URL de redirection", WDr = "URL de redirection à la sortie", HDr = "Total des réservations par période", YDr = "Acheminé vers par période", KDr = "Par jour", ZDr = "Par semaine", XDr = "Par mois", JDr = "Motif d'attribution", QDr = "Accès refusé", e3r = "Le propriétaire du contact sera l'hôte Round Robin si disponible", t3r = "Ajouter de nouveaux participants en tant que", n3r = "Le propriétaire du contact ne sera pas forcé (peut toujours être l'hôte si cela correspond aux attributs et aux critères Round Robin)", o3r = "Acheminer vers un utilisateur correspondant à un champ de recherche sur un compte", r3r = "Option Salesforce", i3r = "Nom du champ de recherche", a3r = "Si le participant a un domaine de messagerie gratuit, ignorer la vérification du propriétaire et procéder au round robin normalement", s3r = "Est", c3r = "N'est pas", l3r = "Contient", u3r = "Ne contient pas", d3r = "Commence par", _3r = "Se termine par", p3r = "Est vide", m3r = "N'est pas vide", f3r = "Traduction automatique du titre et de la description", g3r = "Traduit automatiquement les titres et descriptions dans la langue du navigateur du visiteur en utilisant l'IA.", h3r = "Distribution", v3r = "Permet d'optimiser la distribution pour une disponibilité maximale ou pour viser une répartition plus équilibrée.", b3r = "Maximiser la disponibilité", y3r = "Permet aux participants de réserver des réunions dès qu'un hôte est disponible. Utilisez cette option pour maximiser le nombre potentiel de réunions réservées lorsque la distribution équitable des réunions entre les hôtes est moins importante.", $3r = "Équilibrage de charge", w3r = "Nous surveillerons le nombre de réservations effectuées avec chaque hôte et le comparerons avec les autres, en désactivant certains hôtes trop en avance pour que les réservations soient réparties équitablement.", k3r = "Modifier les pondérations", S3r = "Pondérations mises à jour avec succès", E3r = "Exiger une confirmation uniquement pour les fournisseurs de messagerie gratuits (Ex. @gmail.com, @outlook.com)", x3r = "Exclure les e-mails contenant ...", C3r = "Exiger des e-mails qui contiennent...", T3r = "Veuillez entrer une adresse e-mail professionnelle valide", A3r = "Vous n'êtes pas autorisé à effectuer une réservation avec ce domaine e-mail. Veuillez contacter le propriétaire de ce lien.", I3r = "Rechercher dans les colonnes", O3r = "Options de recherche", N3r = "Désactiver le profil public de l'organisation et rediriger", z3r = "Redirige {{orgSlug}}.cal.com vers {{destination}}", R3r = "Sélection unique", P3r = "Sélection multiple", D3r = "Paramètres de conflit de calendrier", L3r = "Sélectionnez les calendriers à vérifier pour les conflits", M3r = "Réunion de groupe", F3r = "Êtes-vous sûr de vouloir supprimer cette application de", q3r = "Déconnecter l'application de", j3r = "Ne pas créer de nouveaux enregistrements pour les invités ajoutés à la réservation", V3r = "Google Meet", B3r = "Zoom", U3r = "Vidéo MS Teams", G3r = "Verrouiller pour l'attribution", W3r = "Le verrouillage n'autorisera que les attributions depuis la synchronisation d'annuaire", H3r = "Attribut modifié avec succès", Y3r = "Nouvelle option de groupe", K3r = "Pondération activée", Z3r = "En activant la pondération, il sera possible d'attribuer une priorité plus élevée à certains attributs par utilisateur. Plus le poids est élevé, plus la priorité est importante.", X3r = "Acheminé", J3r = "Réaffecté", Q3r = "Autoriser la reprogrammation des événements passés", eLr = "L'activation de cette option permet de reprogrammer les événements passés", tLr = "Réacheminé", nLr = "Affectation Salesforce", oLr = "Position du routeur", rLr = "Afficher les hôtes correspondants", iLr = "Aucune file d'attente active pour cette entrée", aLr = "Poids", sLr = "Calibrage", cLr = "Déficit", lLr = "Formulaire de routage", uLr = "Retourner et sauvegarder", dLr = "Enregistrer les modifications", _Lr = "Quitter sans sauvegarder", pLr = "Êtes-vous sûr de vouloir quitter sans sauvegarder les modifications de votre formulaire de routage ?", mLr = "Une erreur inattendue s'est produite", fLr = "Vous effectuez une réservation test.", gLr = "Présentation des icônes", hLr = "Présentation des icônes", vLr = "Migration depuis l'équipe", bLr = "La fonctionnalité est actuellement désactivée", yLr = "Choisir une option", $Lr = "Saisir la valeur de l'option", wLr = "Supprimer l'option", kLr = "Utiliser les pondérations d'attributs", SLr = "Si activé, toutes les pondérations définies dans le type d'événement seront ignorées", ELr = "Attribut pour les pondérations", xLr = "Utilisateurs gérés", CLr = "Voir tous les utilisateurs gérés créés par votre client OAuth", TLr = "Pouvez-vous me parler de ", ALr = "Utilisez l'IA pour répondre à vos questions", ILr = "Erreur lors de la récupération de la réponse ", OLr = "Une erreur inattendue s'est produite. Veuillez réessayer plus tard", NLr = "Sélectionner le client OAuth", zLr = "Sur chaque instance", RLr = "La fonctionnalité d'identifiant de délégation n'est pas activée pour votre organisation", PLr = "Note interne", DLr = "Raison partagée avec le client (facultatif)", LLr = "Cette note sera visible uniquement par les membres de votre équipe", MLr = "Modèles de notes d'annulation internes", FLr = "Créez des modèles de notes internes qui peuvent être appliqués aux réservations", qLr = "Modèles de notes internes mis à jour avec succès", jLr = "Ajouter un modèle", VLr = "Autoriser", BLr = "Suivant", ULr = "Masquer", GLr = "Afficher", WLr = "Paramètres UTM", HLr = "Aucun paramètre UTM disponible.", YLr = "Asc", KLr = "Desc", ZLr = "Vérifier le changement d'e-mail", XLr = "Acheter des crédits", JLr = "Crédits", QLr = "Crédits utilisés", eMr = "Total restant", tMr = "Vous recevez 1000 crédits par mois, par membre de l'équipe", nMr = "Vous recevez 750 crédits par mois, par membre de l'équipe", oMr = "Consulter et gérer les crédits pour l'envoi de SMS", rMr = "Consultez et gérez les crédits pour l'envoi de SMS. Un crédit vaut 1¢ (USD). <0>En savoir plus</0>", iMr = "Un crédit vaut 1¢ (USD). <0>En savoir plus</0>", aMr = "Acheter des crédits supplémentaires (0,01 $ par crédit)", sMr = "Vous pouvez consulter les dépenses de crédits supplémentaires dans votre journal des dépenses", cMr = "Aperçu", lMr = "L'identifiant de l'organisation est déjà pris", uMr = "Vous ne pouvez pas créer une organisation car vous faites déjà partie d'une organisation", dMr = "Vous devez terminer l'intégration utilisateur avant de créer une organisation", _Mr = "Utilisez l'e-mail de l'entreprise pour créer une organisation", pMr = "Vous ne pouvez pas créer une organisation plateforme car vous faites déjà partie d'une équipe", mMr = "Vous devez avoir un minimum d'équipes publiées", fMr = "Vous faites déjà partie de cette organisation", gMr = "Vous faites partie d'une autre organisation, impossible de créer une nouvelle organisation", hMr = "Vous faites partie d'une autre organisation de plateforme, impossible de créer une nouvelle organisation", vMr = "Paiement de l'organisation réussi", bMr = "Votre organisation a été créée avec succès", yMr = "Cela peut prendre quelques secondes...", $Mr = "Statut d'intégration de l'organisation", wMr = "Description du statut d'intégration de l'organisation", kMr = "Le paiement a échoué", SMr = "Votre paiement a échoué. Veuillez réessayer.", EMr = "Création de votre organisation", xMr = "L'intégration de l'organisation est déjà terminée", CMr = "L'intégration de l'organisation existe déjà", TMr = "Intégration de l'organisation non trouvée", AMr = "Paiement réussi !", IMr = "Transfert de l'intégration", OMr = "Transfert de l'intégration à l'utilisateur", NMr = "Une organisation existe déjà avec ce slug", zMr = "Vous n'avez pas la permission de créer une organisation pour cet e-mail", RMr = "Vous n'avez pas la permission de migrer une ou plusieurs des équipes", PMr = "L'organisation a déjà un abonnement", DMr = "Réinitialiser l'intervalle pour le Round Robin pondéré", LMr = "Intervalle", MMr = "Détermine la fréquence à laquelle le compteur de réservations round-robin se réinitialise pour assurer une distribution équilibrée.", FMr = "Quotidien", qMr = "Vous n'avez pas défini de date de fin pour votre absence", jMr = "Mes absences", VMr = "Absences de l'équipe", BMr = "Gérez les absences de votre équipe.", UMr = "Créer une absence", GMr = "Créer une absence pour un membre de l'équipe", WMr = "Modifier une absence pour un membre de l'équipe", HMr = "Créer une absence pour votre équipe", YMr = "Informez les utilisateurs lorsque les membres de votre équipe ne sont pas disponibles pour prendre des réservations. Ils peuvent toujours être réservés à leur retour ou vous pouvez les rediriger vers un autre membre de l'équipe.", KMr = "La redirection des absences n'est autorisée que vers un membre de la même équipe.", ZMr = "Il existe déjà une redirection inverse entre ces utilisateurs.", XMr = "Aucune absence précédente trouvée", JMr = "Précédent", QMr = "Intervalle Round Robin mis à jour avec succès", e4r = "Mode d'essai", t4r = "Plan d'équipe inactif", n4r = "Votre plan d'équipe est inactif. Vérifiez votre abonnement ou contactez le support client", o4r = "Accès limité pendant l'essai. Fonctionnalité disponible après la fin de l'essai.", r4r = "Programme de parrainage", i4r = "Gagnez 20% de parrainage", a4r = "Vous avez besoin d'une clé API Dub et d'un identifiant de programme pour utiliser cette page.", s4r = "UID", c4r = "Lien", l4r = "lignes par page", u4r = "{{currentRange}} sur {{totalItems}}", d4r = "Astuce : vous pouvez ajouter un '+' entre les noms d'utilisateurs : cal.com/anna+brian pour créer une réunion de groupe dynamique", _4r = "Vous n'avez pas encore d'équipe", p4r = "Vous n'avez pas encore de membres d'équipe", m4r = "Les événements récurrents ne prennent pas en charge la fonctionnalité de places. Rendez-le non récurrent pour activer les places.", f4r = "L'événement récurrent ne prend pas en charge la fonctionnalité de limite de réservation par réservateur. Désactivez la limite de réservation par réservateur pour activer l'événement récurrent.", g4r = "La fonctionnalité de places ne prend pas en charge les événements récurrents. Désactivez la fonctionnalité de places pour le rendre récurrent.", h4r = "Les événements récurrents ne prennent pas en charge la fonctionnalité de places. Désactivez la fonctionnalité de places ou rendez l'événement non récurrent.", v4r = "Segment", b4r = "Filtres enregistrés", y4r = "Renommer", $4r = "Renommer le segment", w4r = "Supprimer le segment", k4r = "Dupliquer le segment", S4r = "Êtes-vous sûr de vouloir supprimer ce segment ? Cette action ne peut pas être annulée.", E4r = "Segment de filtre mis à jour", x4r = "Erreur lors de la mise à jour du segment de filtre", C4r = "Segment de filtre dupliqué", T4r = "Erreur lors de la duplication du segment de filtre", A4r = "Segment de filtre supprimé", I4r = "Erreur lors de la suppression du segment de filtre", O4r = "Enregistrer le segment", N4r = "Segment introuvable", z4r = "Segment de filtre enregistré", R4r = "Aucun segment", P4r = "Erreur lors de l'enregistrement du segment de filtre", D4r = 'Enregistrer les remplacements pour "{{name}}"', L4r = "Créer un nouveau segment", M4r = "Enregistrer pour l'équipe", F4r = "Sélectionner une équipe", q4r = "Veuillez sélectionner une équipe", j4r = "Personnel", V4r = "Masquer le lien du profil d'équipe", B4r = "Masquer le lien du profil d'équipe sur les pages de réservation", U4r = "Affichage", G4r = "Impossible de trouver le slug pour publier l'organisation", W4r = "Liste de sélection", H4r = "Plus d'annulations", Y4r = "Langue de l'interface", K4r = "Définissez votre langue préférée pour l'interface de réservation", Z4r = "Langue du navigateur du visiteur", X4r = "Nom ou e-mail", J4r = "Si aucun contact n'est trouvé, se rabattre sur le propriétaire du lead s'il existe", Q4r = "L'achat de crédits a échoué. Veuillez réessayer ou contacter le support.", e5r = "Minimum de 50 crédits requis", t5r = "Activer l'identifiant de délégation", n5r = "Accordez à Cal.com un accès automatique aux calendriers de tous les membres de l'organisation en activant l'identifiant de délégation.", o5r = "Désactiver l'identifiant de délégation", r5r = "Une fois les identifiants de délégation désactivés, les membres de l'organisation qui n'ont pas connecté leurs calendriers devront le faire manuellement.", i5r = "Dernière activité", a5r = "Membre depuis", s5r = "Dernière mise à jour", c5r = "Lors de l'annulation d'une réservation, écrire dans l'enregistrement de l'événement au lieu de le supprimer", l5r = "À chaque annulation", u5r = "Signaler un problème", d5r = "Vous pouvez soumettre un ticket sur GitHub ou mettre à niveau votre forfait pour bénéficier d'une assistance en temps réel avec des conférences de développeurs", _5r = "Ouvrir un problème", p5r = "Ceci est votre forfait actuel", m5r = "Planifier un horaire", f5r = "Cela comprend :", g5r = "Client OAuth mis à jour avec succès", h5r = "Client OAuth introuvable.", v5r = "S'abonner à la plateforme", b5r = "Erreur lors de la tentative d'accès aux webhooks.", y5r = "Échec de la mise à jour du webhook.", $5r = "Échec de la création du webhook.", w5r = "Lien invalide", k5r = "Vous êtes actuellement abonné au forfait {{planFirstLetter}}{{planRest}}", S5r = "Utilisateur/Équipe", E5r = "ID client copié !", x5r = "Secret client copié !", C5r = "L'équipe de Cal.com effectue une maintenance planifiée. Si vous avez des questions, veuillez contacter le support.", T5r = "Votre paiement a échoué", A5r = "Vérifiez votre boîte de réception", I5r = "Votre compte a été créé, mais votre premium n'a pas été réservé.", O5r = "Nous avons envoyé un e-mail à {{email}} avec un lien pour activer votre compte.", N5r = "Une fois votre compte activé, vous pourrez essayer d'acheter votre nom d'utilisateur premium à nouveau ou en sélectionner un autre.", z5r = "Ouvrir dans Gmail", R5r = "Vous ne voyez pas d'e-mail ?", P5r = "Renvoyer dans {{seconds}} secondes", D5r = "Renvoyer", L5r = "E-mail de vérification envoyé", M5r = "Sélectionner tous les membres", F5r = "La sélection de tous les membres ajoutera automatiquement tous les futurs membres de l'équipe lorsqu'ils seront ajoutés à l'équipe.", q5r = "Paramètres du formulaire", j5r = "Supprimer le statut de liste blanche", V5r = "Mettre les workflows utilisateur en liste blanche", B5r = "Workflows utilisateur mis en liste blanche", U5r = "Workflows utilisateur retirés de la liste blanche", G5r = "Date et heure", W5r = "Ceci est un rappel concernant votre événement à venir.", H5r = "Ce rappel a été déclenché par un workflow dans Cal.", Y5r = "Événement", K5r = "Planifié par", Z5r = "Comment s'est déroulée votre dernière expérience ?", X5r = "Nous cherchons toujours à améliorer l'expérience client.", J5r = "Dans quelle mesure étiez-vous satisfait de votre dernière réunion ?", Q5r = "vous n'avez pas participé à la réunion ?", e6r = "Reprogrammer ici.", t6r = "Masquer l'e-mail de l'organisateur", n6r = "Vous faites déjà partie d'une organisation de plateforme, c'est pourquoi vous ne pouvez pas créer une nouvelle organisation. Chaque utilisateur ne peut appartenir qu'à une seule organisation. Veuillez créer un nouveau compte cal.com avec une adresse e-mail différente et utiliser ce compte pour vous abonner au plan des organisations.", o6r = "Vous faites déjà partie d'une organisation, c'est pourquoi vous ne pouvez pas créer une organisation de plateforme. Chaque utilisateur ne peut appartenir qu'à une seule organisation. Veuillez créer un nouveau compte cal.com avec une adresse e-mail différente et utiliser ce compte pour vous abonner au plan de plateforme.", r6r = "Masquer l'adresse e-mail de l'organisateur sur l'écran de réservation, les notifications par e-mail et les événements du calendrier", i6r = "Vous &", a6r = "Sélectionner un e-mail vérifié", s6r = "Ajouter une adresse e-mail vérifiée", c6r = "Ajouter des adresses e-mail vérifiées", l6r = "E-mail 'Répondre à' personnalisé", u6r = "Utiliser une adresse e-mail différente comme destinataire de réponse pour les e-mails de confirmation au lieu de l'e-mail de l'organisateur", d6r = "Ce questionnaire a été déclenché par un Workflow dans Cal.", _6r = "Ignorer la période d'essai", p6r = "Périodes d'essai d'équipe ignorées avec succès", m6r = "En saisissant votre numéro de téléphone, vous consentez à recevoir des SMS pour cet événement. Des frais de SMS peuvent s'appliquer.", f6r = "Plus d'informations sont disponibles dans <0>Analyses de routage</0>", g6r = "Résultats", h6r = "Voir le formulaire", v6r = "Envoyez STOP pour vous désinscrire des messages SMS", b6r = "Votre équipe {{teamName}} manque de crédits", y6r = "Vous manquez de crédits", $6r = "[Action requise] Votre équipe {{teamName}} n'a plus de crédits", w6r = "[Action requise] Vous n'avez plus de crédits", k6r = "Votre équipe Cal.com {{teamName}} manque de crédits. Pour éviter toute interruption de service, veuillez acheter des crédits supplémentaires. Si votre solde est épuisé, les SMS cesseront d'être envoyés et seront envoyés par e-mail à la place.", S6r = "Votre compte Cal.com manque de crédits. Pour éviter toute interruption de service, veuillez acheter des crédits supplémentaires. Si votre solde est épuisé, les SMS cesseront d'être envoyés et seront envoyés par e-mail à la place.", E6r = "Votre équipe Cal.com {{teamName}} n'a plus de crédits. Par conséquent, les SMS sont maintenant envoyés par e-mail. Pour reprendre l'envoi de SMS, veuillez acheter des crédits supplémentaires.", x6r = "Votre compte Cal.com n'a plus de crédits. Par conséquent, les messages SMS sont désormais envoyés par e-mail. Pour reprendre l'envoi de SMS, veuillez acheter des crédits supplémentaires.", C6r = "Solde actuel : {{balance}} crédits", T6r = "Solde actuel :", A6r = "Notification concernant votre réservation", I6r = "Crédits mensuels", O6r = "Total des crédits : {{totalCredits}}", N6r = "Crédits restants : {{remainingCredits}}", z6r = "Restant", R6r = "Total", P6r = "Crédits supplémentaires", D6r = "{{count}} suivant(s) dans la file d'attente", L6r = "Envoyer les réponses par e-mail à", M6r = "Réservations incomplètes", F6r = "Inclure les réservations non honorées dans les calculs de round robin", q6r = "Participants récemment absents", j6r = "Affiche les réservations où tous les participants étaient absents, et non les absences partielles", V6r = "Correspondance", B6r = "Redirection d'événement", U6r = "Réinitialiser le formulaire", G6r = "Paramètres Round Robin mis à jour avec succès", W6r = "Base de distribution pour le Round Robin pondéré", H6r = "Détermine quel horodatage d'événement est utilisé comme base pour la distribution Round Robin pondérée.", Y6r = "Nécessite des crédits", K6r = "Vous devez avoir suffisamment de crédits sur votre compte pour utiliser cette fonctionnalité", Z6r = "Crédits disponibles", X6r = "Créer un rôle", J6r = "Rôles et permissions", Q6r = "Gérer les rôles et les permissions pour votre organisation", eFr = "En savoir plus sur le fonctionnement des permissions", tFr = "Nom du rôle", nFr = "Le nom du rôle est requis", oFr = "ex. Équipe commerciale, Personnel de support", rFr = "Description du rôle", iFr = "Décrivez à quoi sert ce rôle et quelles permissions il nécessite", aFr = "Rôle par défaut", sFr = "Rôle personnalisé", cFr = "Avancé", lFr = "Rechercher des permissions", uFr = "Toutes les permissions", dFr = "Aucune", _Fr = "Lecture seule", pFr = "Toutes les actions sur toutes les ressources", mFr = "Toutes les ressources", fFr = "Types d'événements", gFr = "Équipes", hFr = "Organisation", vFr = "Réservations", bFr = "Statistiques", yFr = "Rôles", $Fr = "Formulaires de routage", wFr = "Workflows", kFr = "Toutes les actions", SFr = "Créer", EFr = "Voir", xFr = "Modifier", CFr = "Supprimer", TFr = "Gérer", AFr = "Inviter", IFr = "Supprimer", OFr = "Changer le rôle d'un membre", NFr = "Lister les membres", zFr = "Gérer la facturation", RFr = "Voir les réservations d'équipe", PFr = "Voir les réservations de l'organisation", DFr = "Voir les enregistrements", LFr = "Emprunt d'identité", MFr = "Rôle créé avec succès", FFr = "Rôle mis à jour avec succès", qFr = "Supprimer le rôle", jFr = "Êtes-vous sûr de vouloir supprimer le rôle : {{roleName}} ? Cette action ne peut pas être annulée.", VFr = "Rôle supprimé avec succès", BFr = "Erreur lors de la création du rôle", UFr = "Erreur lors de la mise à jour du rôle", GFr = "Créer des rôles", WFr = "Attributs", HFr = "Voir les attributs de l'organisation", YFr = "Mettre à jour les attributs de l'organisation", KFr = "Supprimer les attributs de l'organisation", ZFr = "Créer des attributs d'organisation", XFr = "Voir les rôles", JFr = "Mettre à jour les rôles", QFr = "Supprimer des rôles", eqr = "Créer et configurer de nouveaux workflows", tqr = "Configuration requise", nqr = "Voir les workflows existants et leurs configurations", oqr = "Éditer et modifier les paramètres des workflows", rqr = "Supprimer des workflows du système", iqr = "Webhook", aqr = "Disponibilités", sqr = "Absence du bureau", cqr = "Créer des webhooks", lqr = "Consulter les webhooks", uqr = "Mettre à jour les webhooks", dqr = "Supprimer les webhooks", _qr = "Créer des disponibilités", pqr = "Voir les disponibilités", mqr = "Mettre à jour les disponibilités", fqr = "Supprimer des disponibilités", gqr = "Créer une absence", hqr = "Voir les absences", vqr = "Mettre à jour une absence", bqr = "Supprimer une absence", yqr = "Accès complet à la gestion de tous les workflows", $qr = "Créer des types d'événements", wqr = "Voir les types d'événements", kqr = "Mettre à jour les types d'événements", Sqr = "Supprimer des types d'événements", Eqr = "Toutes les actions sur les types d'événements", xqr = "Créer des équipes", Cqr = "Voir les détails de l'équipe", Tqr = "Mettre à jour les paramètres de l'équipe", Aqr = "Supprimer l'équipe", Iqr = "Inviter des membres d'équipe", Oqr = "Supprimer des membres d'équipe", Nqr = "Changer le rôle des membres de l'équipe", zqr = "Emprunter l'identité des membres de l'équipe", Rqr = "Toutes les actions sur les équipes à travers les équipes de l'organisation", Pqr = "Créer une organisation", Dqr = "Voir les détails de l'organisation", Lqr = "Lister les membres de l'organisation", Mqr = "Inviter des membres dans l'organisation", Fqr = "Supprimer des membres de l'organisation", qqr = "Gérer la facturation de l'organisation", jqr = "Modifier le rôle des membres de l'organisation", Vqr = "Emprunter l'identité des membres de l'organisation", Bqr = "Modifier les paramètres de l'organisation", Uqr = "Toutes les actions sur les organisations", Gqr = "Voir les réservations", Wqr = "Voir les réservations de l'équipe", Hqr = "Voir les réservations de l'organisation", Yqr = "Voir les enregistrements des réservations", Kqr = "Mettre à jour les réservations", Zqr = "Toutes les actions sur les réservations", Xqr = "Voir les analyses de l'équipe", Jqr = "Gérer les analyses de l'équipe", Qqr = "Créer des formulaires de routage", ejr = "Voir les formulaires de routage", tjr = "Mettre à jour les formulaires de routage", njr = "Supprimer les formulaires de routage", ojr = "L'autorisation de lecture est automatiquement activée lors de la création, la mise à jour ou la suppression d'une ressource", rjr = "Ajouter un calendrier de restriction", ijr = "Limiter la disponibilité des hôtes pour n'afficher que les créneaux qui correspondent à un horaire spécifié.", ajr = "Utiliser le fuseau horaire du réservateur", sjr = "Appliquer le calendrier de restriction sélectionné dans le fuseau horaire du réservateur", cjr = "Cela désactivera l'équilibrage de charge sur tous vos types d'événements round robin", ljr = "L'équilibrage de charge est uniquement disponible lorsque la base temporelle est définie sur l'heure de création de la réservation", ujr = "L'équilibrage de charge n'est pas disponible avec les groupes round robin", djr = "Personnaliser les paramètres par défaut du tour de rôle pour cette équipe", _jr = "Paramètres du tour de rôle mis à jour avec succès", pjr = "Heure de création de la réservation", mjr = "Heure de début de la réunion", fjr = "Membres affectés", gjr = "Aucun membre affecté par la désactivation des identifiants de délégation", hjr = "Télécharger le journal des dépenses", vjr = "Erreur lors du téléchargement du journal des dépenses", bjr = "Proposer de reprogrammer la dernière réservation active au créneau horaire choisi", yjr = "Limite maximale de réservations actives dépassée", $jr = "Vous avez déjà une réservation pour cet événement le {{date}}. Souhaitez-vous la reprogrammer à la nouvelle heure sélectionnée ?", wjr = "La durée doit être d'au moins {{min}} minute(s)", kjr = "La durée ne peut pas dépasser {{max}} minutes (24 heures)", Sjr = "Réservation en dehors de la disponibilité du calendrier de restriction.", Ejr = "Calendrier de restriction introuvable", xjr = "Limite de taille d'image dépassée, veuillez utiliser une image plus petite, de préférence au format JPEG", Cjr = "Ajouter un groupe", Tjr = "Entonnoir de routage", Ajr = "Total des soumissions", Ijr = "Routages réussis", Ojr = "Réservations acceptées", Njr = "Clé de licence", zjr = "Choisir votre licence", Rjr = "Sélectionnez comment vous souhaitez licencier votre déploiement Cal.com", Pjr = "Utiliser Cal.com sous la licence open source AGPLv3", Djr = "Saisir la clé de licence", Ljr = "Accès à toutes les fonctionnalités entreprise", Mjr = "À partir de 15$/utilisateur par mois", Fjr = "Accès à toutes les fonctionnalités entreprise", qjr = "Saisissez votre clé de licence", jjr = "Enregistrer la clé de licence", Vjr = "Jeton de signature (facultatif)", Bjr = "Le jeton de signature est utilisé pour vérifier que la clé de licence est la vôtre lors de l'incrémentation de la facturation basée sur l'utilisation. Vous pouvez le trouver dans votre e-mail de confirmation d'achat. Si vous utilisez une licence héritée, vous pouvez laisser ce champ vide.", Ujr = "Besoin d'une licence ?", Gjr = "La clé de licence est requise", Wjr = "Clé de licence invalide", Hjr = "Échec de la validation de la clé de licence", Yjr = "Pièces jointes optionnelles", Kjr = "Envoyer le message", Zjr = "Décrivez le problème", Xjr = "La taille du fichier dépasse la limite", Jjr = "Type de fichier invalide", Qjr = "Type de fichier invalide. Types acceptés : {{acceptedTypes}}", eVr = "Nombre maximum de fichiers dépassé", tVr = "Fichiers téléchargés avec succès", nVr = "Types acceptés : {{acceptedTypes}} ; Taille maximale : {{maxSize}}", oVr = "Clé de licence enregistrée avec succès", rVr = "Vous consultez le rapport selon le fuseau horaire de votre profil ({{userTimezone}}), alors que votre navigateur est configuré sur le fuseau horaire ({{browserTimezone}})", iVr = "Créneaux optimisés", aVr = "Organiser les créneaux horaires pour optimiser la disponibilité.", sVr = "Réservations échouées par champ", cVr = "Réservations échouées", lVr = "Aucun hôte n'est assigné à ce type d'événement", uVr = "État du cache", dVr = "Dernière mise à jour : {{timestamp}}", _Vr = "Supprimer les données en cache", pVr = "Cache supprimé avec succès", mVr = "Erreur lors de la suppression du cache", fVr = "Êtes-vous sûr de vouloir supprimer les données en cache ? Cette action ne peut pas être annulée.", gVr = "Oui, supprimer le cache", hVr = "{{remainder}} utilisations restantes sur {{maximum}}", vVr = "{{remainder}} utilisation restante sur {{maximum}}", bVr = "Expire le {{date}}, fin de journée", yVr = "Usage unique", $Vr = "Expiration basée sur le temps", wVr = "Expiration basée sur l'utilisation", kVr = "Nombre d'utilisations", SVr = "Expire le", EVr = "Nombre maximum d'utilisations", xVr = "Paramètres du lien", CVr = "Ce lien a expiré le {{date}}, fin de journée", TVr = "Limite d'utilisation atteinte", AVr = "Le nombre maximum d'utilisations doit être supérieur au nombre d'utilisations actuel", IVr = "Ce lien a expiré", OVr = "Ce lien peut être utilisé pour des réservations jusqu'à la fin du {{date}}", NVr = "Ce lien peut être configuré pour expirer après une date définie", zVr = "Ce lien peut être utilisé pour {{count}} réservation", RVr = "Ce lien peut être configuré pour expirer après un nombre défini de réservations", PVr = "Ce lien peut être utilisé pour {{count}} réservations", DVr = "Le nom de l'événement déclencheur (par ex., BOOKING_CREATED, BOOKING_CANCELLED)", LVr = "L'heure du webhook", MVr = "Le slug du type d'événement", FVr = "Configurer l'agent", qVr = "Le nom du type d'événement", jVr = "L'heure de début de l'événement", VVr = "L'heure de fin de l'événement", BVr = "La description de l'événement telle que définie dans les paramètres du type d'événement", UVr = "Lieu de l'événement", GVr = "L'UID de la réservation", WVr = "L'UID pour le report", HVr = "Motif d'annulation", YVr = "Motif de refus", KVr = "Nom de l'organisateur", ZVr = "Email de l'organisateur", XVr = "Fuseau horaire de l'organisateur (par ex., 'America/New_York', 'Asia/Kolkata')", JVr = "Locale de l'organisateur (par ex., 'en', 'fr')", QVr = "Nom d'utilisateur de l'organisateur (par ex., 'john.doe')", eBr = "Nom d'utilisateur de l'organisateur dans son organisation (par ex., 'john.doe')", tBr = "Nom du premier participant", nBr = "Email du premier participant", oBr = "Fuseau horaire du premier participant", rBr = "Locale du premier participant", iBr = "Nom de l'équipe réservée", aBr = "Membres de l'équipe réservée", sBr = "URL d'appel vidéo pour la réunion", cBr = "Masquer les variables", lBr = "Afficher les variables disponibles", uBr = "Événement et réservation", dBr = "Personnes", _Br = "Équipes", pBr = "Métadonnées", mBr = "Statistiques", fBr = "Statut de la réservation", gBr = "Visiter", hBr = "Étiquette personnalisée sur la page de réservation", vBr = "Lien de réunion", bBr = "Résultat de la session", yBr = "Appel créé", $Br = "Messagerie vocale", wBr = "Mes réservations", kBr = "Téléphone", SBr = "Gratuit", EBr = "Email de l'utilisateur", xBr = "Nom d'utilisateur", CBr = "Développer le panneau", TBr = "Réduire le panneau", ABr = "La vérification de l'e-mail est requise pour ce type d'événement", IBr = "Code de vérification fourni invalide", OBr = "Vous avez une équipe", NBr = "Envisagez de créer une organisation pour unifier la facturation, les outils d'administration et les analyses pour votre équipe.", zBr = "Envisagez de créer une organisation pour unifier la facturation, les outils d'administration et les analyses pour vos équipes.", RBr = "Message envoyé", PBr = "Merci de nous avoir contactés. Nous vous répondrons dès que possible.", DBr = "Rechercher des variables", LBr = 'Veuillez décrire le problème que vous rencontrez, par ex. "Les créneaux occupés sont marqués comme disponibles", ..., etc.', MBr = "Envoyer un autre message", FBr = "Envoi en cours", qBr = "Aucune variable trouvée", jBr = "Crédits requis", VBr = "Les appels web consomment des crédits. Assurez-vous d'avoir suffisamment de crédits pour démarrer un appel.", BBr = "Les appels web nécessitent des crédits. Il vous reste 0 crédit.", UBr = "Acheter des crédits", GBr = "Cette action nécessite des crédits pour continuer", WBr = "Le nom ne doit pas dépasser {{max}} caractères", HBr = "Facturer automatiquement des frais de non-présentation pour les annulations de dernière minute", YBr = "Avant l'heure de début prévue", KBr = "Je reconnais qu'en annulant la réservation dans les {{timeValue}} {{timeUnit}} précédant l'heure de début, des frais de non-présentation de {{amount, currency}} me seront facturés", ZBr = "Si vous avez des questions, veuillez contacter l'organisateur.", XBr = "Heure de réservation", JBr = "Quand la réservation est programmée (début à fin)", QBr = "Créé le", e9r = "Quand la réservation a été initialement créée", t9r = "Détails de l'appel", n9r = "ID d'appel", o9r = "Informations d'appel", r9r = "Sentiment", i9r = "Raison de déconnexion", a9r = "Résumé de l'appel", s9r = "Transcription", c9r = "Détails de l'événement", l9r = "Agent", u9r = "Aucune transcription disponible", d9r = "Lors du test de ce workflow, sachez que les SMS doivent être programmés au moins 15 minutes à l'avance", _9r = "Commencer de zéro", p9r = "Créez votre propre workflow à partir de zéro.", m9r = "Modèle Cal.ai", f9r = "Agents IA qui réservent des réunions, envoient des rappels et assurent le suivi !", g9r = "Voix", h9r = "Sélectionner une voix", v9r = "Sélectionner une voix pour votre agent", b9r = "Choisissez une voix pour votre agent", y9r = "Caractéristique", $9r = "ID de voix", w9r = "Utiliser la voix", k9r = "Voix actuelle", S9r = "Configurer l'agent entrant", E9r = "Configurez un agent IA pour gérer les appels entrants sur votre numéro de téléphone", x9r = "Connectez d'abord un numéro de téléphone", C9r = "Configurer l'agent pour les appels entrants", T9r = "Configurer l'agent pour gérer les appels entrants", A9r = "Appels entrants", I9r = "Appels sortants", O9r = "Configuration de l'agent entrant réussie", N9r = "Agent entrant configuré", z9r = "Configurer l'agent entrant", R9r = "Veuillez d'abord sélectionner un type d'événement", P9r = "Modifier la configuration", D9r = "Les appels entrants ne peuvent réserver qu'un seul type d'événement. Sélectionnez le type d'événement où les réunions seront programmées lorsque les appelants joignent votre agent.", L9r = "Configurer l'agent entrant pour les appels entrants", M9r = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Ajoutez vos nouvelles chaînes ci-dessus ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", F9r = {
  identity_provider: LFo,
  trial_days_left: MFo,
  day_one: FFo,
  day_other: qFo,
  second_one: jFo,
  second_other: VFo,
  upgrade_now: BFo,
  untitled: UFo,
  accept_invitation: GFo,
  max_characters: WFo,
  min_characters: HFo,
  calcom_explained: YFo,
  calcom_explained_new_user: KFo,
  have_any_questions: ZFo,
  reset_password_subject: XFo,
  verify_email_subject: JFo,
  verify_email_subject_verifying_email: QFo,
  check_your_email: eqo,
  old_email_address: tqo,
  new_email_address: nqo,
  verify_email_page_body: oqo,
  verify_email_banner_body: rqo,
  verify_email_email_header: iqo,
  verify_email_button: aqo,
  cal_ai_assistant: sqo,
  send_cal_video_transcription_emails: cqo,
  description_send_cal_video_transcription_emails: lqo,
  verify_email_change_description: uqo,
  verify_email_change_success_toast: dqo,
  verify_email_change_failure_toast: _qo,
  change_of_email: pqo,
  change_of_email_toast: mqo,
  copy_somewhere_safe: fqo,
  verify_email_email_body: gqo,
  verify_email_by_code_email_body: hqo,
  verify_email_email_link_text: vqo,
  email_verification_code: bqo,
  email_verification_code_placeholder: yqo,
  incorrect_email_verification_code: $qo,
  email_sent: wqo,
  email_not_sent: kqo,
  event_declined_subject: Sqo,
  event_cancelled_subject: Eqo,
  event_reassigned_subject: xqo,
  event_request_declined: Cqo,
  customize_calvideo_settings: Tqo,
  calvideo_settings_description: Aqo,
  disable_recording_for_guests: Iqo,
  enable_automatic_transcription: Oqo,
  enable_automatic_recording: Nqo,
  video_options: zqo,
  edit_event: Rqo,
  view_session_details: Pqo,
  meeting_session_details: Dqo,
  meeting_session: Lqo,
  session_id: Mqo,
  max_participants: Fqo,
  unlimited: qqo,
  ongoing: jqo,
  ended: Vqo,
  participants: Bqo,
  anonymous_user: Uqo,
  session_duration: Gqo,
  no_meeting_sessions_found: Wqo,
  not_available: Hqo,
  disable_recording_for_organizer: Yqo,
  disable_transcription_for_guests: Kqo,
  disable_transcription_for_organizer: Zqo,
  event_request_declined_recurring: Xqo,
  event_request_cancelled: Jqo,
  event_request_reassigned: Qqo,
  event_reassigned_subtitle: ejo,
  organizer: tjo,
  reassigned_to: njo,
  need_to_reschedule_or_cancel: ojo,
  you_can_view_booking_details_with_this_url: rjo,
  no_options_available: ijo,
  cancellation_reason: ajo,
  cancelled_by: sjo,
  cancellation_reason_host: cjo,
  cancellation_reason_placeholder: ljo,
  notify_attendee_cancellation_reason_warning: ujo,
  rejection_reason_placeholder: djo,
  rejection_reason: _jo,
  rejection_reason_title: pjo,
  rejection_reason_description: mjo,
  rejection_confirmation: fjo,
  manage_this_event: gjo,
  invite_team_member: hjo,
  invite_team_individual_segment: vjo,
  invite_team_bulk_segment: bjo,
  invite_team_notifcation_badge: yjo,
  your_event_has_been_scheduled: $jo,
  your_event_has_been_scheduled_recurring: wjo,
  accept_our_license: kjo,
  remove_banner_instructions: Sjo,
  error_message: Ejo,
  refund_failed_subject: xjo,
  refund_failed: Cjo,
  check_with_provider_and_user: Tjo,
  a_refund_failed: Ajo,
  awaiting_payment_subject: Ijo,
  meeting_awaiting_payment: Ojo,
  dark_theme_contrast_error: Njo,
  light_theme_contrast_error: zjo,
  event_type_color_light_theme_contrast_error: Rjo,
  event_type_color_dark_theme_contrast_error: Pjo,
  payment_not_created_error: Djo,
  couldnt_charge_card_error: Ljo,
  no_available_users_found_error: Mjo,
  timeslot_unavailable_book_a_new_time: Fjo,
  timeslot_unavailable_short: qjo,
  just_connected_description: jjo,
  unavailable_timeslot_title: Vjo,
  booking_time_out_of_bounds_error: Bjo,
  request_body_end_time_internal_error: Ujo,
  create_calendar_event_error: Gjo,
  update_calendar_event_error: Wjo,
  delete_calendar_event_error: Hjo,
  already_signed_up_for_this_booking_error: Yjo,
  hosts_unavailable_for_booking: Kjo,
  fixed_hosts_unavailable_for_booking: Zjo,
  round_robin_host_unavailable_for_booking: Xjo,
  help: Jjo,
  price: Qjo,
  paid: eVo,
  refunded: tVo,
  record: nVo,
  transcribe: oVo,
  payment: rVo,
  missing_card_fields: iVo,
  pay_now: aVo,
  general_prompt: sVo,
  transcription_powered_by_ai: cVo,
  start_or_stop_recording: lVo,
  begin_message: uVo,
  codebase_has_to_stay_opensource: dVo,
  cannot_repackage_codebase: _Vo,
  acquire_license: pVo,
  terms_summary: mVo,
  open_env: fVo,
  env_changed: gVo,
  accept_license: hVo,
  still_waiting_for_approval: vVo,
  event_is_still_waiting: bVo,
  no_result_found_for: yVo,
  no_more_results: $Vo,
  no_results: wVo,
  load_more_results: kVo,
  integration_meeting_id: SVo,
  confirmed_event_type_subject: EVo,
  new_event_request: xVo,
  confirm_or_reject_request: CVo,
  check_bookings_page_to_confirm_or_reject: TVo,
  check_in_assistant: AVo,
  check_in_assistant_description: IVo,
  create_your_own_prompt: OVo,
  event_awaiting_approval: NVo,
  event_awaiting_approval_recurring: zVo,
  someone_requested_an_event: RVo,
  someone_requested_password_reset: PVo,
  password_reset_email_sent: DVo,
  password_reset_instructions: LVo,
  event_awaiting_approval_subject: MVo,
  event_still_awaiting_approval: FVo,
  booking_submitted_subject: qVo,
  download_recording_subject: jVo,
  download_transcript_email_subject: VVo,
  download_your_recording: BVo,
  download_your_transcripts: UVo,
  your_meeting_has_been_booked: GVo,
  event_type_has_been_rescheduled_on_time_date: WVo,
  event_type_has_been_updated: HVo,
  event_has_been_rescheduled: YVo,
  event_has_been_updated: KVo,
  your_event_has_been_rescheduled: ZVo,
  request_reschedule_subtitle: XVo,
  request_reschedule_title_organizer: JVo,
  request_reschedule_subtitle_organizer: QVo,
  rescheduled_event_type_subject: eBo,
  requested_to_reschedule_subject_attendee: tBo,
  hi_user_name: nBo,
  ics_event_title: oBo,
  please_book_a_time_sometime_later: rBo,
  schedule_instead: iBo,
  new_event_subject: aBo,
  join_by_entrypoint: sBo,
  notes: cBo,
  manage_my_bookings: lBo,
  need_to_make_a_change: uBo,
  new_event_scheduled: dBo,
  new_event_scheduled_recurring: _Bo,
  invitee_email: pBo,
  invitee_timezone: mBo,
  time_left: fBo,
  event_type: gBo,
  duplicate_event_type: hBo,
  enter_meeting: vBo,
  video_call_provider: bBo,
  meeting_id: yBo,
  meeting_password: $Bo,
  meeting_url: wBo,
  meeting_url_not_found: kBo,
  token_not_found: SBo,
  some_other_host_already_accepted_the_meeting: EBo,
  meeting_request_rejected: xBo,
  rejected_event_type_with_organizer: CBo,
  hi: TBo,
  join_team: ABo,
  manage_this_team: IBo,
  team_info: OBo,
  join_meeting: NBo,
  request_another_invitation_email: zBo,
  you_have_been_invited: RBo,
  user_invited_you: PBo,
  hidden_team_member_title: DBo,
  hidden_team_member_message: LBo,
  hidden_team_owner_message: MBo,
  link_expires: FBo,
  upgrade_to_per_seat: qBo,
  seat_options_doesnt_support_confirmation: jBo,
  multilocation_doesnt_support_seats: VBo,
  no_show_fee_doesnt_support_seats: BBo,
  seats_option_doesnt_support_multi_location: UBo,
  team_upgrade_seats_details: GBo,
  team_upgrade_banner_description: WBo,
  upgrade_banner_action: HBo,
  team_upgraded_successfully: YBo,
  org_upgrade_banner_description: KBo,
  org_upgraded_successfully: ZBo,
  use_link_to_reset_password: XBo,
  hey_there: JBo,
  there: QBo,
  forgot_your_password_calcom: e9o,
  delete_webhook_confirmation_message: t9o,
  confirm_delete_webhook: n9o,
  edit_webhook: o9o,
  delete_webhook: r9o,
  webhook_status: i9o,
  webhook_enabled: a9o,
  webhook_disabled: s9o,
  webhook_response: c9o,
  webhook_test: l9o,
  webhook_update_form: u9o,
  webhook_update_form_description: d9o,
  manage_your_webhook: _9o,
  webhook_created_successfully: p9o,
  webhook_updated_successfully: m9o,
  webhook_removed_successfully: f9o,
  subscription_needed: g9o,
  subscription_needed_description: h9o,
  payload_template: v9o,
  dismiss: b9o,
  no_data_yet: y9o,
  ping_test: $9o,
  add_to_homescreen: w9o,
  upcoming: k9o,
  recurring: S9o,
  past: E9o,
  choose_a_file: x9o,
  upload_image: C9o,
  upload_target: T9o,
  no_target: A9o,
  slide_zoom_drag_instructions: I9o,
  view_notifications: O9o,
  view_public_page: N9o,
  copy_public_page_link: z9o,
  copy_referral_link: R9o,
  sign_out: P9o,
  add_another: D9o,
  install_another: L9o,
  until: M9o,
  powered_by: F9o,
  unavailable: q9o,
  set_work_schedule: j9o,
  change_bookings_availability: V9o,
  select: B9o,
  "2fa_confirm_current_password": "Confirmez votre mot de passe actuel pour commencer.",
  "2fa_scan_image_or_use_code": "Scannez l'image ci-dessous avec votre application d'authentification ou saisissez manuellement le code.",
  text: U9o,
  your_phone_number: G9o,
  multiline_text: W9o,
  number: H9o,
  checkbox: Y9o,
  is_required: K9o,
  make_field_required: Z9o,
  required: X9o,
  optional: J9o,
  input_type: Q9o,
  rejected: eUo,
  unconfirmed: tUo,
  guests: nUo,
  guest: oUo,
  web_conferencing_details_to_follow: rUo,
  confirmation: iUo,
  what_booker_should_provide: aUo,
  "404_the_user": "Le nom d'utilisateur",
  username: sUo,
  is_still_available: cUo,
  documentation: lUo,
  documentation_description: uUo,
  api_reference: dUo,
  api_reference_description: _Uo,
  blog: pUo,
  blog_description: mUo,
  join_our_community: fUo,
  "404_claim_entity_user": "Réservez votre nom d'utilisateur et planifiez des événements",
  popular_pages: gUo,
  register_now: hUo,
  register: vUo,
  page_doesnt_exist: bUo,
  no_active_phone_number_available: yUo,
  workflow_step_not_configured: $Uo,
  check_spelling_mistakes_or_go_back: wUo,
  "404_page_not_found": "404 : Cette page est introuvable.",
  booker_event_not_found: kUo,
  getting_started: SUo,
  "15min_meeting": "Rendez-vous de 15 min",
  "30min_meeting": "Rendez-vous de 30 min",
  secret: EUo,
  leave_blank_to_remove_secret: xUo,
  webhook_secret_key_description: CUo,
  secret_meeting: TUo,
  login_instead: AUo,
  create_account: IUo,
  get_started: OUo,
  confirm_password: NUo,
  reset_your_password: zUo,
  org_banner_instructions: RUo,
  email_change: PUo,
  create_your_account: DUo,
  create_your_calcom_account: LUo,
  sign_up: MUo,
  youve_been_logged_out: FUo,
  hope_to_see_you_soon: qUo,
  logged_out: jUo,
  please_try_again_and_contact_us: VUo,
  incorrect_2fa_code: BUo,
  no_account_exists: UUo,
  "2fa_enabled_instructions": "La double authentification est activée. Veuillez entrer le code à six chiffres de votre application d'authentification.",
  "2fa_enter_six_digit_code": "Saisissez le code à six chiffres de votre application d'authentification ci-dessous.",
  create_an_account: GUo,
  dont_have_an_account: WUo,
  "2fa_code": "Code de double authentification",
  sign_in_account: HUo,
  sign_in: YUo,
  go_back_login: KUo,
  error_during_login: ZUo,
  request_password_reset: XUo,
  send_invite: JUo,
  forgot_password: QUo,
  forgot: eGo,
  done: tGo,
  all_done: nGo,
  all: oGo,
  yours: rGo,
  available_apps: iGo,
  available_apps_lower_case: aGo,
  available_apps_desc: sGo,
  fixed_host_helper: cGo,
  round_robin_groups_helper: lGo,
  round_robin_helper: uGo,
  check_email_reset_password: dGo,
  finish: _Go,
  organization_general_description: pGo,
  few_sentences_about_yourself: mGo,
  nearly_there: fGo,
  nearly_there_instructions: gGo,
  set_availability_instructions: hGo,
  set_availability: vGo,
  set_availbility_description: bGo,
  share_a_link_or_embed: yGo,
  share_a_link_or_embed_description: $Go,
  availability_settings: wGo,
  continue_without_calendar: kGo,
  continue_with: SGo,
  connect_your_calendar: EGo,
  connect_your_video_app: xGo,
  connect_your_video_app_instructions: CGo,
  connect_your_calendar_instructions: TGo,
  set_up_later: AGo,
  current_time: IGo,
  details: OGo,
  welcome: NGo,
  welcome_back: zGo,
  welcome_to_calcom: RGo,
  welcome_instructions: PGo,
  connect_caldav: DGo,
  connect_ics_feed: LGo,
  connect: MGo,
  try_for_free: FGo,
  create_booking_link_with_calcom: qGo,
  who: jGo,
  what: VGo,
  when: BGo,
  where: UGo,
  add_to_calendar: GGo,
  add_to_calendar_description: WGo,
  add_events_to: HGo,
  add_another_calendar: YGo,
  other: KGo,
  email_sign_in_subject: ZGo,
  round_robin_emailed_you_and_attendees: XGo,
  round_robin_emailed_host_and_attendee: JGo,
  emailed_host_and_attendee: QGo,
  emailed_host_and_attendee_recurring: eWo,
  round_robin_emailed_you_and_attendees_recurring: tWo,
  round_robin_emailed_host_and_attendee_recurring: nWo,
  emailed_you_and_any_other_attendees: oWo,
  needs_to_be_confirmed_or_rejected: rWo,
  needs_to_be_confirmed_or_rejected_recurring: iWo,
  user_needs_to_confirm_or_reject_booking: aWo,
  user_needs_to_confirm_or_reject_booking_recurring: sWo,
  meeting_is_scheduled: cWo,
  meeting_is_scheduled_recurring: lWo,
  booking_submitted: uWo,
  booking_submitted_recurring: dWo,
  booking_confirmed: _Wo,
  booking_confirmed_recurring: pWo,
  warning_recurring_event_payment: mWo,
  warning_payment_recurring_event: fWo,
  enter_new_password: gWo,
  reset_password: hWo,
  change_your_password: vWo,
  show_password: bWo,
  hide_password: yWo,
  try_again: $Wo,
  request_is_expired: wWo,
  reset_instructions: kWo,
  request_is_expired_instructions: SWo,
  whoops: EWo,
  login: xWo,
  success: CWo,
  failed: TWo,
  password_has_been_reset_login: AWo,
  layout: IWo,
  bookerlayout_default_title: OWo,
  bookerlayout_description: NWo,
  bookerlayout_user_settings_title: zWo,
  bookerlayout_user_settings_description: RWo,
  bookerlayout_month_view: PWo,
  bookerlayout_week_view: DWo,
  bookerlayout_column_view: LWo,
  bookerlayout_error_min_one_enabled: MWo,
  bookerlayout_error_default_not_enabled: FWo,
  bookerlayout_error_unknown_layout: qWo,
  bookerlayout_override_global_settings: jWo,
  unexpected_error_try_again: VWo,
  sunday_time_error: BWo,
  monday_time_error: UWo,
  tuesday_time_error: GWo,
  wednesday_time_error: WWo,
  thursday_time_error: HWo,
  friday_time_error: YWo,
  saturday_time_error: KWo,
  error_end_time_before_start_time: ZWo,
  error_end_time_next_day: XWo,
  back_to_bookings: JWo,
  free_to_pick_another_event_type: QWo,
  cancelled: e8o,
  no_booking: t8o,
  awaiting_host: n8o,
  cancellation_successful: o8o,
  really_cancel_booking: r8o,
  cannot_cancel_booking: i8o,
  reschedule_instead: a8o,
  event_is_in_the_past: s8o,
  cancelling_event_recurring: c8o,
  cancelling_all_recurring: l8o,
  error_with_status_code_occured: u8o,
  error_event_type_url_duplicate: d8o,
  error_event_type_unauthorized_create: _8o,
  error_event_type_unauthorized_update: p8o,
  error_workflow_unauthorized_create: m8o,
  error_schedule_unauthorized_create: f8o,
  booking_already_cancelled: g8o,
  booking_already_accepted_rejected: h8o,
  go_back_home: v8o,
  or_go_back_home: b8o,
  no_meeting_found: y8o,
  no_meeting_found_description: $8o,
  no_status_bookings_yet: w8o,
  no_status_bookings_yet_description: k8o,
  event_between_users: S8o,
  bookings: E8o,
  booking_not_found: x8o,
  bookings_description: C8o,
  upcoming_bookings: T8o,
  recurring_bookings: A8o,
  past_bookings: I8o,
  cancelled_bookings: O8o,
  unconfirmed_bookings: N8o,
  unconfirmed_bookings_tooltip: z8o,
  on: R8o,
  and: P8o,
  calendar_shows_busy_between: D8o,
  troubleshoot: L8o,
  troubleshoot_description: M8o,
  overview_of_day: F8o,
  hover_over_bold_times_tip: q8o,
  start_time: j8o,
  end_time: V8o,
  buffer_time: B8o,
  before_event: U8o,
  after_event: G8o,
  event_buffer_default: W8o,
  buffer: H8o,
  your_day_starts_at: Y8o,
  your_day_ends_at: K8o,
  launch_troubleshooter: Z8o,
  troubleshoot_availability: X8o,
  change_available_times: J8o,
  change_your_available_times: Q8o,
  change_start_end: e7o,
  change_start_end_buffer: t7o,
  current_start_date: n7o,
  start_end_changed_successfully: o7o,
  and_end_at: r7o,
  light: i7o,
  dark: a7o,
  automatically_adjust_theme: s7o,
  user_dynamic_booking_disabled: c7o,
  allow_dynamic_booking_tooltip: l7o,
  allow_dynamic_booking: u7o,
  dynamic_booking: d7o,
  allow_seo_indexing: _7o,
  seo_indexing: p7o,
  allow_browser_notifications: m7o,
  you_have_denied_notifications: f7o,
  disable_browser_notifications: g7o,
  browser_notifications_turned_on: h7o,
  browser_notifications_turned_off: v7o,
  browser_notifications_denied: b7o,
  please_allow_notifications: y7o,
  push_notifications: $7o,
  push_notifications_description: w7o,
  browser_notifications_not_supported: k7o,
  email: S7o,
  email_placeholder: E7o,
  full_name: x7o,
  browse_api_documentation: C7o,
  leverage_our_api: T7o,
  create_webhook: A7o,
  instant_meeting: I7o,
  booking_cancelled: O7o,
  booking_rescheduled: N7o,
  recording_ready: z7o,
  recording_transcription_generated: R7o,
  booking_created: P7o,
  booking_rejected: D7o,
  booking_requested: L7o,
  booking_payment_initiated: M7o,
  meeting_ended: F7o,
  form_submitted: q7o,
  form_submitted_no_event: j7o,
  booking_paid: V7o,
  ooo_created: B7o,
  booking_no_show_updated: U7o,
  event_triggers: G7o,
  subscriber_url: W7o,
  create_new_webhook: H7o,
  webhooks: Y7o,
  team_webhooks: K7o,
  create_new_webhook_to_account: Z7o,
  new_webhook: X7o,
  receive_cal_meeting_data: J7o,
  receive_cal_event_meeting_data: Q7o,
  responsive_fullscreen_iframe: eHo,
  loading: tHo,
  deleting: nHo,
  standard_iframe: oHo,
  developer: rHo,
  manage_developer_settings: iHo,
  iframe_embed: aHo,
  embed_calcom: sHo,
  integrate_using_embed_or_webhooks: cHo,
  schedule_a_meeting: lHo,
  view_and_manage_billing_details: uHo,
  view_and_edit_billing_details: dHo,
  go_to_billing_portal: _Ho,
  need_anything_else: pHo,
  further_billing_help: mHo,
  contact: fHo,
  our_support_team: gHo,
  contact_our_support_team: hHo,
  uh_oh: vHo,
  no_event_types_have_been_setup: bHo,
  edit_logo: yHo,
  upload_a_logo: $Ho,
  upload_logo: wHo,
  remove_logo: kHo,
  enable: SHo,
  code: EHo,
  code_is_incorrect: xHo,
  add_time_availability: CHo,
  add_an_extra_layer_of_security: THo,
  "2fa": "Double authentification",
  "2fa_disabled": "La double authentification ne peut être activée que pour l'authentification par e-mail et mot de passe",
  enable_2fa: AHo,
  disable_2fa: IHo,
  disable_2fa_recommendation: OHo,
  error_disabling_2fa: NHo,
  error_enabling_2fa: zHo,
  security: RHo,
  manage_account_security: PHo,
  password: DHo,
  password_updated_successfully: LHo,
  password_has_been_changed: MHo,
  error_changing_password: FHo,
  session_timeout_changed: qHo,
  session_timeout_change_error: jHo,
  something_went_wrong: VHo,
  something_doesnt_look_right: BHo,
  please_try_again: UHo,
  super_secure_new_password: GHo,
  new_password: WHo,
  your_old_password: HHo,
  current_password: YHo,
  change_password: KHo,
  change_secret: ZHo,
  new_password_matches_old_password: XHo,
  forgotten_secret_description: JHo,
  current_incorrect_password: QHo,
  password_hint_caplow: eYo,
  password_hint_min: tYo,
  password_hint_admin_min: nYo,
  password_hint_num: oYo,
  max_limit_allowed_hint: rYo,
  invalid_password_hint: iYo,
  incorrect_password: aYo,
  incorrect_email_password: sYo,
  use_setting: cYo,
  am_pm: lYo,
  time_options: uYo,
  january: dYo,
  february: _Yo,
  march: pYo,
  april: mYo,
  may: fYo,
  june: gYo,
  july: hYo,
  august: vYo,
  september: bYo,
  october: yYo,
  november: $Yo,
  december: wYo,
  monday: kYo,
  tuesday: SYo,
  wednesday: EYo,
  thursday: xYo,
  friday: CYo,
  saturday: TYo,
  sunday: AYo,
  all_booked_today: IYo,
  slots_load_fail: OYo,
  additional_guests: NYo,
  your_name: zYo,
  your_full_name: RYo,
  no_name: PYo,
  enter_number_between_range: DYo,
  continue_as_guest_description: LYo,
  email_address: MYo,
  enter_valid_email: FYo,
  please_schedule_future_call: qYo,
  location: jYo,
  address: VYo,
  enter_address: BYo,
  in_person_attendee_address: UYo,
  somewhere_else: GYo,
  custom_attendee_location: WYo,
  continue_as_guest: HYo,
  join_as_guest: YYo,
  ideal_for_one_time_calls: KYo,
  any_location: ZYo,
  yes: XYo,
  no: JYo,
  additional_notes: QYo,
  booking_fail: eKo,
  reschedule_fail: tKo,
  share_additional_notes: nKo,
  booking_confirmation: oKo,
  booking_reschedule_confirmation: rKo,
  in_person_meeting: iKo,
  in_person: aKo,
  link_meeting: sKo,
  phone_number: cKo,
  attendee_phone_number: lKo,
  organizer_phone_number: uKo,
  enter_phone_number: dKo,
  reschedule: _Ko,
  reschedule_this: pKo,
  book_a_team_member: mKo,
  or: fKo,
  go_back: gKo,
  email_or_username: hKo,
  send_invite_email: vKo,
  role: bKo,
  edit_role: yKo,
  view_role: $Ko,
  edit_team: wKo,
  editing_user: kKo,
  editing_org: SKo,
  edit_or_manage_webhooks: EKo,
  reject: xKo,
  reject_all: CKo,
  accept: TKo,
  leave: AKo,
  profile: IKo,
  my_team_url: OKo,
  my_teams: NKo,
  team_name: zKo,
  your_team_name: RKo,
  team_updated_successfully: PKo,
  your_team_updated_successfully: DKo,
  your_org_updated_successfully: LKo,
  error_copying_to_clipboard: MKo,
  about: FKo,
  team_description: qKo,
  organization_id: jKo,
  organization_id_copied: VKo,
  org_description: BKo,
  team_id: UKo,
  team_id_copied: GKo,
  members: WKo,
  organization_members: HKo,
  member: YKo,
  number_member_one: KKo,
  number_member_other: ZKo,
  number_selected: XKo,
  owner: JKo,
  admin: QKo,
  admin_api: eZo,
  administrator_user: tZo,
  lets_create_first_administrator_user: nZo,
  admin_user_created: oZo,
  admin_user_created_description: rZo,
  new_member: iZo,
  invite: aZo,
  add_team_members: sZo,
  add_org_members: cZo,
  add_team_members_description: lZo,
  add_team_member: uZo,
  invite_new_member: dZo,
  invite_new_member_description: _Zo,
  invite_new_team_member: pZo,
  upload_csv_file: mZo,
  invite_via_email: fZo,
  change_member_role: gZo,
  disable_cal_branding: hZo,
  disable_cal_branding_description: vZo,
  hide_book_a_team_member: bZo,
  hide_book_a_team_member_description: yZo,
  danger_zone: $Zo,
  account_deletion_cannot_be_undone: wZo,
  team_deletion_cannot_be_undone: kZo,
  back: SZo,
  cancel: EZo,
  cancel_all_remaining: xZo,
  apply: CZo,
  cancel_event: TZo,
  continue: "Continuer",
  confirm: AZo,
  confirm_all: IZo,
  disband_team: OZo,
  disband_team_confirmation_message: NZo,
  disband_org: zZo,
  disband_org_confirmation_message: RZo,
  remove_member_confirmation_message: PZo,
  confirm_disband_team: DZo,
  confirm_remove_member: LZo,
  confirm_subscription_cancellation: MZo,
  cancel_subscription: FZo,
  cancel_subscription_description: qZo,
  remove_member: jZo,
  manage_your_team: VZo,
  no_teams: BZo,
  no_teams_description: UZo,
  submit: GZo,
  confirm_remove_attribute: WZo,
  remove_attribute: HZo,
  remove_attribute_confirmation_message: YZo,
  delete: "Supprimer",
  update: KZo,
  save: ZZo,
  pending: XZo,
  open_options: JZo,
  copy_link: QZo,
  share: eXo,
  share_event: tXo,
  copy_link_team: nXo,
  leave_team: oXo,
  confirm_leave_team: rXo,
  leave_team_confirmation_message: iXo,
  user_from_team: aXo,
  preview: sXo,
  link_copied: cXo,
  copied: lXo,
  private_link_copied: uXo,
  link_shared: dXo,
  title: _Xo,
  description: pXo,
  apps_status: mXo,
  quick_video_meeting: fXo,
  scheduling_type: gXo,
  preview_team: hXo,
  collective: vXo,
  collective_description: bXo,
  duration: yXo,
  available_durations: $Xo,
  default_duration: wXo,
  default_duration_no_options: kXo,
  multiple_duration_mins: SXo,
  multiple_duration_timeUnit: EXo,
  multiple_duration_timeUnit_short: xXo,
  minutes: CXo,
  use_cal_ai_to_make_call_description: TXo,
  termination_uri: AXo,
  sip_trunk_username: IXo,
  sip_trunk_password: OXo,
  nickname: NXo,
  delete_phone_number: zXo,
  workflow_validation_failed: RXo,
  workflow_validation_empty_fields: PXo,
  workflow_validation_unverified_contacts: DXo,
  supercharge_your_workflows_with_cal_ai: LXo,
  supercharge_your_workflows_with_cal_ai_description: MXo,
  phone_number_imported_successfully: FXo,
  phone_number_deleted_successfully: qXo,
  delete_phone_number_confirmation: jXo,
  yes_delete_phone_number: VXo,
  phone_number_info_tooltip: BXo,
  termination_uri_info_tooltip: UXo,
  sip_trunk_username_info_tooltip: GXo,
  sip_trunk_password_info_tooltip: WXo,
  nickname_info_tooltip: HXo,
  save_and_test_call: YXo,
  call_initiated_successfully: KXo,
  please_enter_phone_number: ZXo,
  agent_updated_successfully: XXo,
  agent_created_successfully: JXo,
  agent_event_type_updated_successfully: QXo,
  phone_number_unsubscribed_successfully: eJo,
  general_prompt_description: tJo,
  prompt: nJo,
  call_to: oJo,
  make_test_call_to_verify_configuration: rJo,
  initial_message: iJo,
  initial_message_description: aJo,
  having_trouble_importing: sJo,
  learn: cJo,
  learn_how_to_get_your_terminator: lJo,
  phone_number_subscription_cancelled_successfully: uJo,
  updating: dJo,
  round_robin: _Jo,
  hi_how_are_you_doing: pJo,
  round_robin_description: mJo,
  managed_event: fJo,
  username_placeholder: gJo,
  managed_event_description: hJo,
  managed: vJo,
  managed_event_url_clarification: bJo,
  assign_to: yJo,
  enter_phone_number_to_test_call: $Jo,
  make_test_call: wJo,
  create_new_workflow_agent: kJo,
  create_new_workflow_agent_description: SJo,
  phone_number_for_ai_call: EJo,
  buy_a_phone_number_or_import_one_you_already_have: xJo,
  test_agent: CJo,
  test_web_call: TJo,
  phone_numbers: AJo,
  unsubscribe: IJo,
  delete_workflow_step: OJo,
  unsubscribe_phone_number: NJo,
  buy_a_new_number: zJo,
  only_us_phone_numbers_can_be_purchased_here: RJo,
  buy_number_for_x_per_month: PJo,
  supported_call_destinations: DJo,
  no_phone_number_connected: LJo,
  failed_to_get_workflow_step_id: MJo,
  cal_ai_agent: FJo,
  test_cal_ai_agent: qJo,
  are_you_sure_you_want_to_delete_workflow_step: jJo,
  do_you_still_want_to_unsubscribe: VJo,
  the_action_will_disconnect_phone_number: BJo,
  cal_ai_phone_numbers: UJo,
  connect_phone_number: GJo,
  cal_ai_phone_numbers_description: WJo,
  import_number: HJo,
  this_action_will_also: YJo,
  import_phone_number: KJo,
  active_subscription: ZJo,
  cancel_your_phone_number_subscription: XJo,
  delete_associated_phone_number: JJo,
  unauthorized_create_workflow: QJo,
  import_phone_number_description: eQo,
  phone_number_cost: tQo,
  buy_new_number: nQo,
  buy_number_cost_x_per_month: oQo,
  area_code_optional: rQo,
  no_phone_numbers: iQo,
  phone_number_purchased_successfully: aQo,
  cancel_phone_number_subscription: sQo,
  yes_cancel_subscription: cQo,
  cancel_phone_number_subscription_confirmation: lQo,
  add_members: uQo,
  add_members_no_ellipsis: dQo,
  no_assigned_members: _Qo,
  assigned_to: pQo,
  you_must_be_logged_in_to: mQo,
  start_assigning_members_above: fQo,
  locked_fields_admin_description: gQo,
  unlocked_fields_admin_description: hQo,
  locked_fields_member_description: vQo,
  unlocked_fields_member_description: bQo,
  url: yQo,
  hidden: $Qo,
  readonly: wQo,
  one_time_link: kQo,
  plan_description: SQo,
  plan_upgrade_invitation: EQo,
  plan_upgrade: xQo,
  plan_upgrade_teams: CQo,
  plan_upgrade_instructions: TQo,
  event_types_page_title: AQo,
  event_types_page_subtitle: IQo,
  new: "Nouveau",
  new_event_type_btn: OQo,
  new_event_type_heading: NQo,
  new_event_type_description: zQo,
  event_type_created_successfully: RQo,
  event_type_updated_successfully: PQo,
  event_type_deleted_successfully: DQo,
  hours: LQo,
  people: MQo,
  your_email: FQo,
  change_avatar: qQo,
  upload_avatar: jQo,
  language: VQo,
  timezone: BQo,
  first_day_of_week: UQo,
  repeats_up_to_one: GQo,
  repeats_up_to_other: WQo,
  every_for_freq: HQo,
  event_remaining_one: YQo,
  event_remaining_other: KQo,
  repeats_every: ZQo,
  occurrence_one: XQo,
  occurrence_other: JQo,
  weekly_one: QQo,
  weekly_other: eer,
  monthly_one: ter,
  monthly_other: ner,
  yearly_one: oer,
  yearly_other: rer,
  plus_more: ier,
  max: aer,
  single_theme: ser,
  brand_color: cer,
  light_brand_color: ler,
  dark_brand_color: uer,
  light_event_type_color: der,
  dark_event_type_color: _er,
  file_not_named: per,
  create_team: mer,
  name: fer,
  nameless_team: ger,
  oauth_clients: her,
  oauth_clients_description: ver,
  create_oauth_client: ber,
  create_oauth_client_description: yer,
  oauth_client_deletion_message: $er,
  create_new_team_description: wer,
  create_new_team: ker,
  booking_redirect_uri: Ser,
  booking_cancel_redirect_uri: Eer,
  booking_reschedule_redirect_uri: xer,
  booking_conflict_error: Cer,
  open_invitations: Ter,
  new_team: Aer,
  create_first_team_and_invite_others: Ier,
  create_team_to_get_started: Oer,
  teams: Ner,
  team: zer,
  organization: Rer,
  team_billing: Per,
  team_billing_description: Der,
  upgrade_to_flexible_pro_title: Ler,
  upgrade_to_flexible_pro_message: Mer,
  changed_team_billing_info: Fer,
  create_manage_teams_collaborative: qer,
  only_available_on_pro_plan: jer,
  remove_cal_branding_description: Ver,
  edit_profile_info_description: Ber,
  change_email_tip: Uer,
  little_something_about: Ger,
  profile_updated_successfully: Wer,
  your_user_profile_updated_successfully: Her,
  your_upgrade_is_here: Yer,
  your_upgrade_is_here_description: Ker,
  you_are_all_set: Zer,
  you_are_all_set_description: Xer,
  user_cannot_found_db: Jer,
  embed_and_webhooks: Qer,
  enabled: etr,
  disabled: ttr,
  disable: ntr,
  billing: otr,
  here: rtr,
  manage_your_billing_info: itr,
  availability: atr,
  edit_availability: str,
  configure_availability: ctr,
  copy_times_to: ltr,
  copy_times_to_tooltip: utr,
  change_weekly_schedule: dtr,
  logo: _tr,
  error: ptr,
  at_least_characters_one: mtr,
  at_least_characters_other: ftr,
  team_logo: gtr,
  add_location: htr,
  attendees: vtr,
  add_attendees: btr,
  show_advanced_settings: ytr,
  hide_advanced_settings: $tr,
  event_name: wtr,
  event_name_in_calendar: ktr,
  event_name_tooltip: Str,
  meeting_with_user: Etr,
  additional_inputs: xtr,
  additional_input_description: Ctr,
  label: Ttr,
  placeholder: Atr,
  display_add_to_calendar_organizer: Itr,
  display_email_as_organizer: Otr,
  if_enabled_email_address_as_organizer: Ntr,
  reconnect_calendar_to_use: ztr,
  type: Rtr,
  edit: Ptr,
  add_input: Dtr,
  disable_notes: Ltr,
  disable_notes_description: Mtr,
  requires_confirmation_description: Ftr,
  requires_confirmation_will_block_slot_description: qtr,
  recurring_event: jtr,
  recurring_event_description: Vtr,
  connect_and_join: Btr,
  cannot_be_used_with_paid_event_types: Utr,
  warning_payment_instant_meeting_event: Gtr,
  warning_instant_meeting_experimental: Wtr,
  starting: Htr,
  disable_guests: Ytr,
  disable_guests_description: Ktr,
  private_link: Ztr,
  enable_private_url: Xtr,
  private_link_label: Jtr,
  private_link_hint: Qtr,
  copy_private_link: enr,
  copy_private_link_to_event: tnr,
  private_link_description: nnr,
  multiple_private_links_title: onr,
  multiple_private_links_description: rnr,
  add_a_multiple_private_link: inr,
  multiple_private_link_copied: anr,
  invitees_can_schedule: snr,
  date_range: cnr,
  calendar_days: lnr,
  business_days: unr,
  set_address_place: dnr,
  set_link_meeting: _nr,
  managed_event_field_parent_control_disabled: pnr,
  cal_invitee_phone_number_scheduling: mnr,
  cal_provide_google_meet_location: fnr,
  cal_provide_zoom_meeting_url: gnr,
  cal_provide_tandem_meeting_url: hnr,
  cal_provide_video_meeting_url: vnr,
  cal_provide_jitsi_meeting_url: bnr,
  cal_provide_huddle01_meeting_url: ynr,
  cal_provide_teams_meeting_url: $nr,
  require_payment: wnr,
  you_need_to_add_a_name: knr,
  commission_per_transaction: Snr,
  event_type_updated_successfully_description: Enr,
  hide_event_type: xnr,
  edit_location: Cnr,
  into_the_future: Tnr,
  when_booked_with_less_than_notice: Anr,
  within_date_range: Inr,
  indefinitely_into_future: Onr,
  add_new_custom_input_field: Nnr,
  quick_chat: znr,
  add_new_team_event_type: Rnr,
  add_new_event_type: Pnr,
  new_event_type_to_book_description: Dnr,
  length: Lnr,
  minimum_booking_notice: Mnr,
  offset_toggle: Fnr,
  offset_toggle_description: qnr,
  offset_start: jnr,
  offset_start_description: Vnr,
  slot_interval: Bnr,
  slot_interval_default: Unr,
  delete_event_type: Gnr,
  delete_managed_event_type: Wnr,
  delete_event_type_description: Hnr,
  delete_managed_event_type_description_1: Ynr,
  delete_managed_event_type_description_2: Knr,
  confirm_delete_event_type: Znr,
  delete_account: Xnr,
  confirm_delete_account: Jnr,
  delete_account_confirmation_message: Qnr,
  integrations: eor,
  apps: tor,
  apps_description: nor,
  apps_listing: oor,
  category_apps: ror,
  app_store: ior,
  app_store_description: aor,
  connect_your_video: sor,
  settings: cor,
  event_type_moved_successfully: lor,
  next_step_text: uor,
  next_step: dor,
  prev_step: _or,
  install: por,
  start_paid_trial: mor,
  installed: gor,
  active_install_one: hor,
  active_install_other: vor,
  globally_install: bor,
  app_successfully_installed: yor,
  app_could_not_be_installed: $or,
  disconnect: wor,
  embed_your_calendar: kor,
  connect_your_favourite_apps: Sor,
  automation: Eor,
  configure_how_your_event_types_interact: xor,
  toggle_calendars_conflict: Cor,
  connect_additional_calendar: Tor,
  calendar_updated_successfully: Aor,
  check_here: Ior,
  conferencing: Oor,
  calendar: Nor,
  payments: zor,
  not_installed: Ror,
  error_password_mismatch: Por,
  error_required_field: Dor,
  status: Lor,
  team_view_user_availability: Mor,
  team_view_user_availability_disabled: For,
  set_as_away: qor,
  set_as_free: jor,
  toggle_away_error: Vor,
  user_away: Bor,
  user_away_description: Uor,
  meet_people_with_the_same_tokens: Gor,
  only_book_people_and_allow: Wor,
  account_created_with_identity_provider: Hor,
  account_managed_by_identity_provider: Yor,
  account_managed_by_identity_provider_description: Kor,
  account_managed_by_identity_provider_error: Zor,
  user_creation_error: Xor,
  signin_with_google: Jor,
  signin_with_saml: Qor,
  signin_with_saml_oidc: err,
  continue_with_email: trr,
  continue_with_google: nrr,
  last_used: orr,
  you_will_need_to_generate: rrr,
  import: "Importer",
  import_from: irr,
  access_token: arr,
  visit_roadmap: srr,
  featured_categories: crr,
  feature_flags: lrr,
  admin_flags_description: urr,
  popular_categories: drr,
  number_apps_one: _rr,
  number_apps_other: prr,
  trending_apps: mrr,
  most_popular: frr,
  installed_apps: grr,
  free_to_use_apps: hrr,
  no_category_apps: vrr,
  all_apps: brr,
  no_category_apps_description_calendar: yrr,
  no_category_apps_description_conferencing: $rr,
  no_category_apps_description_payment: wrr,
  no_category_apps_description_analytics: krr,
  no_category_apps_description_automation: Srr,
  no_category_apps_description_other: Err,
  no_category_apps_description_messaging: xrr,
  no_category_apps_description_crm: Crr,
  installed_app_calendar_description: Trr,
  installed_app_payment_description: Arr,
  installed_app_analytics_description: Irr,
  installed_app_other_description: Orr,
  installed_app_conferencing_description: Nrr,
  installed_app_automation_description: zrr,
  installed_app_messaging_description: Rrr,
  installed_app_crm_description: Prr,
  analytics: Drr,
  empty_installed_apps_headline: Lrr,
  empty_installed_apps_description: Mrr,
  empty_installed_apps_button: Frr,
  manage_your_connected_apps: qrr,
  browse_apps: jrr,
  features: Vrr,
  permissions: Brr,
  terms_and_privacy: Urr,
  published_by: Grr,
  subscribe: Wrr,
  buy: Hrr,
  install_app: Yrr,
  categories: Krr,
  pricing: Zrr,
  learn_more: Xrr,
  try_now: Jrr,
  privacy_policy: Qrr,
  terms_of_service: eir,
  remove: tir,
  add: nir,
  installed_other: oir,
  verify_wallet: rir,
  create_events_on: iir,
  enterprise_license: air,
  enterprise_license_locally: sir,
  enterprise_license_sales: cir,
  missing_license: lir,
  next_steps: uir,
  acquire_commercial_license: dir,
  the_infrastructure_plan: _ir,
  prisma_studio_tip: pir,
  prisma_studio_tip_description: mir,
  contact_sales: fir,
  error_404: gir,
  default: "Par défaut",
  set_to_default: hir,
  new_schedule_btn: vir,
  add_new_schedule: bir,
  add_new_calendar: yir,
  set_calendar: $ir,
  delete_schedule: wir,
  delete_schedule_description: kir,
  schedule_created_successfully: Sir,
  availability_updated_successfully: Eir,
  schedule_deleted_successfully: xir,
  default_schedule_name: Cir,
  new_schedule_heading: Tir,
  new_schedule_description: Air,
  requires_ownership_of_a_token: Iir,
  example_name: Oir,
  time_format: Nir,
  "12_hour": "12 heures",
  "24_hour": "24 heures",
  "12_hour_short": "12 h",
  "24_hour_short": "24 h",
  redirect_success_booking: zir,
  you_are_being_redirected: Rir,
  external_redirect_url: Pir,
  redirect_url_description: Dir,
  duplicate: Lir,
  offer_seats: Mir,
  offer_seats_description: Fir,
  seats_available_one: qir,
  seats_available_other: jir,
  seats_nearly_full: Vir,
  seats_half_full: Bir,
  number_of_seats: Uir,
  set_instant_meeting_expiry_time_offset_description: Gir,
  enter_number_of_seats: Wir,
  you_can_manage_your_schedules: Hir,
  booking_full: Yir,
  api_keys: Kir,
  api_key: Zir,
  test_api_key: Xir,
  test_passed: Jir,
  test_failed: Qir,
  provide_api_key: ear,
  api_key_modal_subtitle: tar,
  api_key_modal_subtitle_platform: nar,
  api_keys_subtitle: oar,
  create_api_key: rar,
  personal_note: iar,
  personal_note_placeholder: aar,
  api_key_no_note: sar,
  api_key_never_expires: car,
  edit_api_key: lar,
  success_api_key_created: uar,
  success_api_key_edited: dar,
  create: _ar,
  success_api_key_created_bold_tagline: par,
  you_will_only_view_it_once: mar,
  copy_to_clipboard: far,
  enabled_after_update: gar,
  enabled_after_update_description: har,
  confirm_delete_api_key: bar,
  disable_rescheduling: yar,
  description_disable_rescheduling: $ar,
  allow_rescheduling_cancelled_bookings: war,
  description_allow_rescheduling_cancelled_bookings: kar,
  disable_cancelling: Sar,
  description_disable_cancelling: Ear,
  revoke_api_key: xar,
  api_key_copied: Car,
  api_key_expires_on: Tar,
  delete_api_key_confirm_title: Aar,
  copy: Iar,
  expire_date: Oar,
  expired: Nar,
  never_expires: zar,
  expires: Rar,
  request_reschedule_booking: Par,
  reason_for_reschedule: Dar,
  book_a_new_time: Lar,
  reschedule_request_sent: Mar,
  reschedule_modal_description: Far,
  reason_for_reschedule_request: qar,
  send_reschedule_request: jar,
  edit_booking: Var,
  reschedule_booking: Bar,
  former_time: Uar,
  confirmation_page_gif: Gar,
  search: War,
  impersonate: Har,
  user_impersonation_heading: Yar,
  user_impersonation_description: Kar,
  team_impersonation_description: Zar,
  cal_signup_description: Xar,
  make_org_private: Jar,
  make_org_private_description: Qar,
  make_team_private: esr,
  make_team_private_description: tsr,
  you_cannot_see_team_members: nsr,
  you_cannot_see_teams_of_org: osr,
  allow_multiple_durations: rsr,
  impersonate_user_tip: isr,
  impersonating_user_warning: asr,
  impersonating_stop_instructions: ssr,
  event_location_changed: csr,
  new_guests_added: lsr,
  location_changed_event_type_subject: usr,
  guests_added_event_type_subject: dsr,
  current_location: _sr,
  new_location: psr,
  session: msr,
  session_description: fsr,
  session_timeout_after: gsr,
  session_timeout: hsr,
  session_timeout_description: vsr,
  no_location: bsr,
  set_location: ysr,
  update_location: $sr,
  location_updated: wsr,
  location_update_failed: ksr,
  guests_added: Ssr,
  unable_to_add_guests: Esr,
  email_validation_error: xsr,
  emails_must_be_unique_valid: Csr,
  url_validation_error: Tsr,
  place_where_cal_widget_appear: Asr,
  create_update_react_component: Isr,
  copy_code: Osr,
  code_copied: Nsr,
  how_you_want_add_cal_site: zsr,
  choose_ways_put_cal_site: Rsr,
  setting_up_zapier: Psr,
  setting_up_make: Dsr,
  generate_api_key: Lsr,
  generate_api_key_description: Msr,
  your_unique_api_key: Fsr,
  copy_safe_api_key: qsr,
  zapier_setup_instructions: jsr,
  make_setup_instructions_1: Vsr,
  make_setup_instructions_2: Bsr,
  make_setup_instructions_3: Usr,
  make_setup_instructions_4: Gsr,
  make_setup_instructions_5: Wsr,
  make_setup_instructions_6: Hsr,
  install_zapier_app: Ysr,
  install_make_app: Ksr,
  app_installation: Zsr,
  app_not_installed: Xsr,
  visit_our_app_store: Jsr,
  connect_apple_server: Qsr,
  calendar_url: ecr,
  apple_server_generate_password: tcr,
  unable_to_add_apple_calendar: ncr,
  credentials_stored_encrypted: ocr,
  it_stored_encrypted: rcr,
  go_to_app_store: icr,
  calendar_error: acr,
  set_your_phone_number: scr,
  calendar_no_busy_slots: ccr,
  display_location_label: lcr,
  display_location_info_badge: ucr,
  add_gif: dcr,
  search_giphy: _cr,
  add_link_from_giphy: pcr,
  add_gif_to_confirmation: mcr,
  find_gif_spice_confirmation: fcr,
  share_feedback: gcr,
  resources: hcr,
  support_documentation: vcr,
  developer_documentation: bcr,
  get_in_touch: ycr,
  contact_support: $cr,
  premium_support: wcr,
  community_support: kcr,
  feedback: Scr,
  submitted_feedback: Ecr,
  feedback_error: xcr,
  comments: Ccr,
  booking_details: Tcr,
  or_lowercase: Acr,
  nevermind: Icr,
  go_to: Ocr,
  zapier_invite_link: Ncr,
  meeting_url_provided_after_confirmed: zcr,
  dynamically_display_attendee_or_organizer: Rcr,
  event_location: Pcr,
  reschedule_optional: Dcr,
  reschedule_placeholder: Lcr,
  event_cancelled: Mcr,
  emailed_information_about_cancelled_event: Fcr,
  this_input_will_shown_booking_this_event: qcr,
  meeting_url_in_confirmation_email: jcr,
  url_start_with_https: Vcr,
  number_provided: Bcr,
  before_event_trigger: Ucr,
  event_cancelled_trigger: Gcr,
  after_hosts_cal_video_no_show: Wcr,
  after_guests_cal_video_no_show: Hcr,
  join_video_call: Ycr,
  sign_in_to_cal_com: Kcr,
  log_in_to_cal_com: Zcr,
  track_your_meetings: Xcr,
  track_meetings_and_manage_schedule: Jcr,
  failed_to_join_call: Qcr,
  choose_how_you_d_like_to_join_call: elr,
  choose_how_you_d_like_to_appear_on_the_call: tlr,
  new_event_trigger: nlr,
  email_host_action: olr,
  email_attendee_action: rlr,
  sms_attendee_action: ilr,
  sms_number_action: alr,
  send_reminder_sms: slr,
  whatsapp_number_action: clr,
  whatsapp_attendee_action: llr,
  workflows: ulr,
  new_workflow_btn: dlr,
  how_would_you_like_to_start: _lr,
  add_new_workflow: plr,
  reschedule_event_trigger: mlr,
  trigger: flr,
  triggers: glr,
  action: hlr,
  workflows_to_automate_notifications: vlr,
  workflow_name: blr,
  custom_workflow: ylr,
  workflow_created_successfully: $lr,
  delete_workflow_description: wlr,
  delete_workflow: klr,
  confirm_delete_workflow: Slr,
  workflow_deleted_successfully: Elr,
  how_long_before: xlr,
  day_timeUnit: Clr,
  hour_timeUnit: Tlr,
  minute_timeUnit: Alr,
  minute_short: Ilr,
  hour_short: Olr,
  new_workflow_heading: Nlr,
  new_workflow_description: zlr,
  active_on: Rlr,
  workflow_updated_successfully: Plr,
  premium_to_standard_username_description: Dlr,
  premium_username: Llr,
  current: Mlr,
  premium: Flr,
  standard: qlr,
  confirm_username_change_dialog_title: jlr,
  change_username_standard_to_premium: Vlr,
  change_username_premium_to_standard: Blr,
  go_to_stripe_billing: Ulr,
  stripe_description: Glr,
  trial_expired: Wlr,
  remove_app: Hlr,
  yes_remove_app: Ylr,
  are_you_sure_you_want_to_remove_this_app: Klr,
  app_removed_successfully: Zlr,
  error_removing_app: Xlr,
  web_conference: Jlr,
  web_call: Qlr,
  start_web_call: eur,
  end_call: tur,
  test_your_agent_with_web_call: nur,
  phone_call: our,
  connecting_to_agent: rur,
  call_active: iur,
  call_ended: aur,
  call_error: sur,
  ready_to_start_call: cur,
  failed_to_start_web_call_try_again: lur,
  call_encountered_error_try_again: uur,
  failed_initialize_web_call_microphone_permissions: dur,
  start_call_to_see_conversation: _ur,
  waiting_for_conversation: pur,
  ai_agent: mur,
  live: fur,
  connecting: gur,
  requires_confirmation: hur,
  requires_confirmation_threshold: vur,
  may_require_confirmation: bur,
  nr_event_type_one: yur,
  nr_event_type_other: $ur,
  count_team_one: wur,
  count_team_other: kur,
  add_action: Sur,
  set_whereby_link: Eur,
  invalid_whereby_link: xur,
  set_around_link: Cur,
  invalid_around_link: Tur,
  set_riverside_link: Aur,
  invalid_riverside_link: Iur,
  invalid_ping_link: Our,
  add_exchange2013: Nur,
  add_exchange2016: zur,
  custom_template: Rur,
  email_body: Pur,
  text_message: Dur,
  specific_issue: Lur,
  browse_our_docs: Mur,
  choose_template: Fur,
  custom: qur,
  reminder: jur,
  rescheduled: Vur,
  rescheduled_by: Bur,
  original_booking: Uur,
  completed: Gur,
  rating: Wur,
  reminder_email: Hur,
  not_triggering_existing_bookings: Yur,
  minute_one: Kur,
  minute_one_short: Zur,
  minute_other: Xur,
  hour_one: Jur,
  hour_one_short: Qur,
  hour_other: edr,
  invalid_input: tdr,
  broken_video_action: ndr,
  broken_calendar_action: odr,
  attendee_name: rdr,
  scheduler_full_name: idr,
  broken_integration: adr,
  problem_adding_video_link: sdr,
  problem_updating_calendar: cdr,
  active_on_event_types_one: ldr,
  active_on_event_types_other: udr,
  active_on_teams_one: ddr,
  active_on_teams_other: _dr,
  active_on_all_event_types: pdr,
  active_on_all_teams: mdr,
  no_active_event_types: fdr,
  no_active_teams: gdr,
  new_seat_subject: hdr,
  new_seat_title: vdr,
  variable: bdr,
  event_name_variable: ydr,
  attendee_name_variable: $dr,
  event_date_variable: wdr,
  event_time_variable: kdr,
  organizer_name_variable: Sdr,
  app_upgrade_description: Edr,
  invalid_number: xdr,
  invalid_url_error_message: Cdr,
  navigate: Tdr,
  open: Adr,
  close: Idr,
  upgrade: Odr,
  buy_us_number_button: Ndr,
  upgrade_to_access_recordings_title: zdr,
  upgrade_to_access_recordings_description: Rdr,
  upgrade_to_cal_ai_phone_number_description: Pdr,
  recordings_are_part_of_the_teams_plan: Ddr,
  team_feature_teams: Ldr,
  team_feature_workflows: Mdr,
  show_eventtype_on_profile: Fdr,
  embed: qdr,
  new_username: jdr,
  current_username: Vdr,
  example_1: Bdr,
  example_2: Udr,
  booking_question_identifier: Gdr,
  company_size: Wdr,
  what_help_needed: Hdr,
  variable_format: Ydr,
  webhook_subscriber_url_reserved: Kdr,
  custom_input_as_variable_info: Zdr,
  using_booking_questions_as_variables: Xdr,
  download_desktop_app: Jdr,
  set_ping_link: Qdr,
  rate_limit_exceeded: e_r,
  when_something_happens: t_r,
  action_is_performed: n_r,
  test_action: o_r,
  notification_sent: r_r,
  no_input: i_r,
  test_workflow_action: a_r,
  send_sms: s_r,
  send_sms_to_number: c_r,
  missing_connected_calendar: l_r,
  connect_your_calendar_and_link: u_r,
  default_calendar_selected: d_r,
  hide_from_profile: __r,
  basics: p_r,
  availability_not_found_in_schedule_error: m_r,
  event_limit_tab_title: f_r,
  event_limit_tab_description: g_r,
  event_advanced_tab_description: h_r,
  event_advanced_tab_title: v_r,
  event_payments_tab_description: b_r,
  event_setup_multiple_duration_error: y_r,
  event_setup_multiple_duration_default_error: $_r,
  event_setup_booking_limits_error: w_r,
  event_setup_duration_limits_error: k_r,
  select_which_cal: S_r,
  custom_event_name: E_r,
  custom_event_name_description: x_r,
  "2fa_required": "Double authentification requise",
  incorrect_2fa: C_r,
  which_event_type_apply: T_r,
  apply_to_all_event_types: A_r,
  apply_to_all_teams: I_r,
  which_team_apply: O_r,
  no_workflows_description: N_r,
  timeformat_profile_hint: z_r,
  create_workflow: R_r,
  do_this: P_r,
  turn_off: D_r,
  turn_on: L_r,
  cancelled_bookings_cannot_be_rescheduled: M_r,
  settings_updated_successfully: F_r,
  error_updating_settings: q_r,
  personal_cal_url: j_r,
  bio_hint: V_r,
  finish_and_start: B_r,
  user_has_no_bio: U_r,
  bio: G_r,
  delete_account_modal_title: W_r,
  confirm_delete_account_modal: H_r,
  delete_my_account: Y_r,
  start_of_week: K_r,
  recordings_title: Z_r,
  recording: X_r,
  happy_scheduling: J_r,
  select_calendars: Q_r,
  check_for_conflicts: epr,
  view_recordings: tpr,
  check_for_recordings: npr,
  adding_events_to: opr,
  follow_system_preferences: rpr,
  custom_brand_colors: ipr,
  customize_your_brand_colors: apr,
  pro: spr,
  removes_cal_branding: cpr,
  instant_meeting_with_title: lpr,
  profile_picture: upr,
  upload: dpr,
  add_profile_photo: _pr,
  token_address: ppr,
  blockchain: mpr,
  old_password: fpr,
  secure_password: gpr,
  error_updating_password: hpr,
  two_factor_auth: vpr,
  recurring_event_tab_description: bpr,
  today: ypr,
  appearance: $pr,
  my_account: wpr,
  general: kpr,
  calendars: Spr,
  "2fa_auth": "Double authentification",
  invoices: Epr,
  embeds: xpr,
  impersonation: Cpr,
  impersonation_description: Tpr,
  recent_impersonations: Apr,
  quick_impersonate: Ipr,
  no_recent_impersonations: Opr,
  users: Npr,
  user: zpr,
  profile_description: Rpr,
  users_description: Ppr,
  users_listing: Dpr,
  general_description: Lpr,
  calendars_description: Mpr,
  appearance_description: Fpr,
  conferencing_description: qpr,
  add_conferencing_app: jpr,
  password_description: Vpr,
  set_up_two_factor_authentication: Bpr,
  we_just_need_basic_info: Upr,
  skip: Gpr,
  do_this_later: Wpr,
  set_availability_getting_started_subtitle_1: Hpr,
  set_availability_getting_started_subtitle_2: Ypr,
  connect_calendar_first: Kpr,
  complete_profile: Zpr,
  connect_calendars_from_app_store: Xpr,
  connect_conference_apps: Jpr,
  connect_calendar_apps: Qpr,
  connect_payment_apps: emr,
  connect_automation_apps: tmr,
  connect_analytics_apps: nmr,
  connect_other_apps: omr,
  connect_messaging_apps: rmr,
  connect_crm_apps: imr,
  current_step_of_total: amr,
  add_variable: smr,
  custom_phone_number: cmr,
  message_template: lmr,
  email_subject: umr,
  add_dynamic_variables: dmr,
  event_name_info: _mr,
  event_date_info: pmr,
  event_duration_info: mmr,
  event_time_info: fmr,
  event_type_not_found: gmr,
  number_to_call_variable: hmr,
  number_to_call_info: vmr,
  location_variable: bmr,
  location_info: ymr,
  additional_notes_variable: $mr,
  additional_notes_info: wmr,
  attendee_name_info: kmr,
  organizer_name_info: Smr,
  to: Emr,
  workflow_turned_on_successfully: xmr,
  download_responses: Cmr,
  download_responses_description: Tmr,
  view_responses: Amr,
  download: Imr,
  downloading: Omr,
  download_recording: Nmr,
  transcription_enabled: zmr,
  transcription_stopped: Rmr,
  download_transcript: Pmr,
  transcript: Dmr,
  recording_from_your_recent_call: Lmr,
  transcript_from_previous_call: Mmr,
  you_can_download_transcript_from_attachments: Fmr,
  link_valid_for_12_hrs: qmr,
  link_valid_for_12_hrs_description: jmr,
  create_your_first_form: Vmr,
  create_your_first_form_description: Bmr,
  create_your_first_webhook: Umr,
  create_your_first_webhook_description: Gmr,
  for_a_maximum_of: Wmr,
  event_one: Hmr,
  event_other: Ymr,
  profile_team_description: Kmr,
  profile_org_description: Zmr,
  members_team_description: Xmr,
  organization_description: Jmr,
  team_url: Qmr,
  team_members: efr,
  more: tfr,
  cal_ai_workflows: nfr,
  and_count_more: ofr,
  more_page_footer: rfr,
  workflow_example_1: ifr,
  workflow_example_2: afr,
  workflow_example_3: sfr,
  workflow_example_4: cfr,
  workflow_example_5: lfr,
  workflow_example_6: ufr,
  send_sms_reminder: dfr,
  send_sms_reminder_description: _fr,
  follow_up_with_no_shows: pfr,
  follow_up_with_no_shows_description: mfr,
  remind_attendees_to_bring_id: ffr,
  remind_attendees_to_bring_id_description: gfr,
  email_to_remind_booking: hfr,
  email_to_remind_booking_description: vfr,
  custom_sms_reminder: bfr,
  custom_sms_reminder_description: yfr,
  custom_email_reminder: $fr,
  custom_email_reminder_description: wfr,
  count_managed_to_limit: kfr,
  welcome_to_cal_header: Sfr,
  edit_form_later_subtitle: Efr,
  connect_calendar_later: xfr,
  problem_saving_user_profile: Cfr,
  purchase_missing_seats: Tfr,
  slot_length: Afr,
  booking_appearance: Ifr,
  appearance_team_description: Ofr,
  appearance_org_description: Nfr,
  only_owner_change: zfr,
  team_disable_cal_branding_description: Rfr,
  invited_by_team: Pfr,
  token_invalid_expired: Dfr,
  view_booking: Lfr,
  exchange_add: Mfr,
  exchange_authentication: Ffr,
  exchange_authentication_standard: qfr,
  exchange_authentication_ntlm: jfr,
  exchange_compression: Vfr,
  exchange_version: Bfr,
  exchange_version_2007_SP1: Ufr,
  exchange_version_2010: Gfr,
  exchange_version_2010_SP1: Wfr,
  exchange_version_2010_SP2: Hfr,
  exchange_version_2013: Yfr,
  exchange_version_2013_SP1: Kfr,
  exchange_version_2015: Zfr,
  exchange_version_2016: Xfr,
  routing: Jfr,
  routing_forms_description: Qfr,
  routing_forms_send_email_owner: egr,
  routing_forms_send_email_owner_description: tgr,
  routing_forms_send_email_to: ngr,
  add_new_form: ogr,
  add_new_team_form: rgr,
  create_your_first_route: igr,
  route_to_the_right_person: agr,
  form: sgr,
  form_description: cgr,
  copy_link_to_form: lgr,
  theme: ugr,
  theme_applies_note: dgr,
  app_theme: _gr,
  app_theme_applies_note: pgr,
  theme_system: mgr,
  add_a_team: fgr,
  add_webhook_description: ggr,
  triggers_when: hgr,
  test_webhook: vgr,
  enable_webhook: bgr,
  add_webhook: ygr,
  webhook_edited_successfully: $gr,
  api_keys_description: wgr,
  new_api_key: kgr,
  active: Sgr,
  api_key_updated: Egr,
  api_key_update_failed: xgr,
  embeds_title: Cgr,
  embeds_description: Tgr,
  create_first_api_key: Agr,
  create_first_api_key_description: Igr,
  back_to_signin: Ogr,
  reset_link_sent: Ngr,
  password_reset_email: zgr,
  password_reset_leading: Rgr,
  password_updated: Pgr,
  pending_payment: Dgr,
  pending_invites: Lgr,
  pending_organization_invites: Mgr,
  not_on_cal: Fgr,
  no_calendar_installed: qgr,
  no_calendar_installed_description: jgr,
  add_a_calendar: Vgr,
  change_email_hint: Bgr,
  confirm_password_change_email: Ugr,
  seats: Ggr,
  every_app_published: Wgr,
  report_app: Hgr,
  limit_booking_frequency: Ygr,
  limit_booking_frequency_description: Kgr,
  only_show_first_available_slot: Zgr,
  only_show_first_available_slot_description: Xgr,
  limit_total_booking_duration: Jgr,
  limit_total_booking_duration_description: Qgr,
  booker_booking_limit: ehr,
  booker_booking_limit_description: thr,
  recurring_event_doesnt_support_booker_booking_limit: nhr,
  add_limit: ohr,
  team_name_required: rhr,
  show_attendees: ihr,
  show_available_seats_count: ahr,
  how_booking_questions_as_variables: shr,
  format: chr,
  questions: lhr,
  all_info_your_booker_provide: uhr,
  uppercase_for_letters: dhr,
  replace_whitespaces_underscores: _hr,
  platform_members: phr,
  platform_members_description: mhr,
  platform_billing: fhr,
  manage_billing: ghr,
  manage_billing_description: hhr,
  billing_freeplan_title: vhr,
  billing_freeplan_description: bhr,
  billing_freeplan_cta: yhr,
  billing_portal: $hr,
  billing_help_cta: whr,
  ignore_special_characters_booking_questions: khr,
  retry: Shr,
  fetching_calendars_error: Ehr,
  calendar_connection_fail: xhr,
  booking_confirmation_success: Chr,
  booking_rejection_success: Thr,
  booking_tentative: Ahr,
  booking_accept_intent: Ihr,
  we_wont_show_again: Ohr,
  couldnt_update_timezone: Nhr,
  updated_timezone_to: zhr,
  update_timezone: Rhr,
  update_timezone_question: Phr,
  update_timezone_description: Dhr,
  dont_update: Lhr,
  require_additional_notes: Mhr,
  require_additional_notes_description: Fhr,
  email_address_action: qhr,
  after_event_trigger: jhr,
  booking_rejected_trigger: Vhr,
  booking_requested_trigger: Bhr,
  booking_payment_initiated_trigger: Uhr,
  booking_paid_trigger: Ghr,
  booking_no_show_updated_trigger: Whr,
  how_long_after: Hhr,
  how_long_after_hosts_no_show: Yhr,
  how_long_after_guests_no_show: Khr,
  how_long_after_user_no_show_minutes: Zhr,
  no_available_slots: Xhr,
  time_available: Jhr,
  cant_find_the_right_conferencing_app_visit_our_app_store: Qhr,
  install_new_calendar_app: evr,
  make_phone_number_required: tvr,
  new_event_type_availability: nvr,
  error_editing_availability: ovr,
  dont_have_permission: rvr,
  saml_configuration_placeholder: ivr,
  saml_email_required: avr,
  saml_sp_title: svr,
  saml_sp_description: cvr,
  saml_sp_acs_url: lvr,
  saml_sp_entity_id: uvr,
  saml_sp_acs_url_copied: dvr,
  saml_sp_entity_id_copied: _vr,
  add_calendar: pvr,
  limit_future_bookings: mvr,
  limit_future_bookings_description: fvr,
  no_event_types: gvr,
  no_event_types_description: hvr,
  billing_frequency: vvr,
  monthly: bvr,
  yearly: yvr,
  checkout: $vr,
  your_team_disbanded_successfully: wvr,
  your_org_disbanded_successfully: kvr,
  error_creating_team: Svr,
  you: Evr,
  or_continue_with: xvr,
  resend_email: Cvr,
  member_already_invited: Tvr,
  already_in_use_error: Avr,
  enter_email_or_username: Ivr,
  enter_email: Ovr,
  enter_emails: Nvr,
  too_many_invites: zvr,
  team_name_taken: Rvr,
  must_enter_team_name: Pvr,
  team_url_required: Dvr,
  url_taken: Lvr,
  problem_registering_domain: Mvr,
  team_publish: Fvr,
  number_text_notifications: qvr,
  number_sms_notifications: jvr,
  attendee_email_variable: Vvr,
  attendee_email_info: Bvr,
  booking_uid: Uvr,
  kbar_search_placeholder: Gvr,
  invalid_credential: Wvr,
  invalid_credential_action: Hvr,
  reschedule_reason: Yvr,
  choose_common_schedule_team_event: Kvr,
  choose_common_schedule_team_event_description: Zvr,
  reason: Xvr,
  sender_id: Jvr,
  sender_id_error_message: Qvr,
  test_routing_form: ebr,
  test_preview: tbr,
  route_to: nbr,
  test_preview_description: obr,
  test_routing: rbr,
  payment_app_disabled: ibr,
  edit_event_type: abr,
  only_admin_can_see_members_of_org: sbr,
  only_admin_can_manage_sso_org: cbr,
  only_admin_can_manage_directory_sync: lbr,
  only_admin_can_manage_oauth_clients: ubr,
  collective_scheduling: dbr,
  make_it_easy_to_book: _br,
  find_the_best_person: pbr,
  fixed_round_robin: mbr,
  add_one_fixed_attendee: fbr,
  calcom_is_better_with_team: gbr,
  the_calcom_team: hbr,
  add_your_team_members: vbr,
  booking_limit_reached: bbr,
  duration_limit_reached: ybr,
  admin_has_disabled: $br,
  disable_attendees_emails_description: wbr,
  disabled_app_affects_event_type: kbr,
  event_replaced_notice: Sbr,
  email_subject_slug_replacement: Ebr,
  email_body_slug_replacement_notice: xbr,
  email_body_slug_replacement_info: Cbr,
  email_body_slug_replacement_suggestion: Tbr,
  disable_payment_app: Abr,
  payment_disabled_still_able_to_book: Ibr,
  app_disabled_with_event_type: Obr,
  app_disabled_video: Nbr,
  app_disabled_subject: zbr,
  navigate_installed_apps: Rbr,
  disabled_calendar: Pbr,
  enable_apps: Dbr,
  enable_apps_description: Lbr,
  purchase_license: Mbr,
  already_have_account: Fbr,
  already_have_key: qbr,
  already_have_key_suggestion: jbr,
  create_license_key: Vbr,
  app_is_enabled: Bbr,
  app_is_disabled: Ubr,
  keys_have_been_saved: Gbr,
  disable_app: Wbr,
  disable_app_description: Hbr,
  edit_keys: Ybr,
  admin_apps_description: Kbr,
  admin_users_description: Zbr,
  admin_users_add_description: Xbr,
  admin_users_edit_description: Jbr,
  admin_orgs_edit_description: Qbr,
  admin_oAuth_description: eyr,
  admin_lockedSMS_description: tyr,
  no_available_apps: nyr,
  no_available_apps_description: oyr,
  no_apps: ryr,
  no_apps_configured: iyr,
  enable_in_settings: ayr,
  please_contact_admin: syr,
  apps_settings: cyr,
  fill_this_field: lyr,
  options: uyr,
  enter_option: dyr,
  add_an_option: _yr,
  location_already_exists: pyr,
  radio: myr,
  google_meet_warning: fyr,
  individual: gyr,
  all_bookings_filter_label: hyr,
  all_users_filter_label: vyr,
  all_event_types_filter_label: byr,
  your_bookings_filter_label: yyr,
  meeting_url_variable: $yr,
  meeting_url_info: wyr,
  date_overrides: kyr,
  date_overrides_delete_on_date: Syr,
  date_overrides_subtitle: Eyr,
  date_overrides_info: xyr,
  date_overrides_dialog_which_hours: Cyr,
  date_overrides_dialog_which_hours_unavailable: Tyr,
  date_overrides_dialog_title: Ayr,
  date_overrides_unavailable: Iyr,
  date_overrides_mark_all_day_unavailable_one: Oyr,
  date_overrides_mark_all_day_unavailable_other: Nyr,
  date_overrides_update_btn: zyr,
  date_successfully_added: Ryr,
  date_overrides_save_btn: Pyr,
  event_type_duplicate_copy_text: Dyr,
  set_as_default: Lyr,
  hide_eventtype_details: Myr,
  show_navigation: Fyr,
  hide_navigation: qyr,
  verification_code_sent: jyr,
  verified_successfully: Vyr,
  wrong_code: Byr,
  not_verified: Uyr,
  no_availability_in_month: Gyr,
  no_availability_rolling: Wyr,
  no_availability_range: Hyr,
  view_previous_month: Yyr,
  view_next_month: Kyr,
  send_code: Zyr,
  number_verified: Xyr,
  create_your_first_team_webhook_description: Jyr,
  create_webhook_team_event_type: Qyr,
  disable_success_page: e$r,
  invalid_admin_password: t$r,
  change_password_admin: n$r,
  username_already_taken: o$r,
  assignment: r$r,
  fixed_hosts: i$r,
  add_fixed_hosts: a$r,
  round_robin_hosts: s$r,
  minimum_round_robin_hosts_count: c$r,
  hosts: l$r,
  upgrade_to_enable_feature: u$r,
  orgs_upgrade_to_enable_feature: d$r,
  new_attendee: _$r,
  awaiting_approval: p$r,
  requires_google_calendar: m$r,
  event_type_requires_google_calendar: f$r,
  connected_google_calendar: g$r,
  using_meet_requires_calendar: h$r,
  continue_to_install_google_calendar: v$r,
  install_google_meet: b$r,
  install_google_calendar: y$r,
  sender_name: $$r,
  already_invited: w$r,
  no_recordings_found: k$r,
  new_workflow_subtitle: S$r,
  reporting: E$r,
  reporting_feature: x$r,
  teams_plan_required: C$r,
  routing_forms_are_a_great_way: T$r,
  choose_a_license: A$r,
  choose_license_description: I$r,
  license: O$r,
  agplv3_license: N$r,
  no_need_to_keep_your_code_open_source: z$r,
  repackage_rebrand_resell: R$r,
  a_vast_suite_of_enterprise_features: P$r,
  free_license_fee: D$r,
  forever_open_and_free: L$r,
  required_to_keep_your_code_open_source: M$r,
  cannot_repackage_and_resell: F$r,
  no_enterprise_features: q$r,
  step_enterprise_license: j$r,
  step_enterprise_license_description: V$r,
  setup: B$r,
  setup_description: U$r,
  configure: G$r,
  sso_configuration: W$r,
  sso_configuration_description: H$r,
  sso_configuration_description_orgs: Y$r,
  sso_oidc_heading: K$r,
  sso_oidc_description: Z$r,
  sso_oidc_configuration_title: X$r,
  sso_oidc_configuration_description: J$r,
  sso_oidc_callback_copied: Q$r,
  sso_saml_heading: ewr,
  sso_saml_description: twr,
  sso_saml_configuration_title: nwr,
  sso_saml_configuration_description: owr,
  sso_saml_acsurl_copied: rwr,
  sso_saml_entityid_copied: iwr,
  sso_connection_created_successfully: awr,
  sso_connection_deleted_successfully: swr,
  delete_sso_configuration: cwr,
  delete_sso_configuration_confirmation: lwr,
  delete_sso_configuration_confirmation_description: uwr,
  organizer_timezone: dwr,
  email_user_cta: _wr,
  accept_invite: pwr,
  join_now: mwr,
  successfully_joined: fwr,
  email_no_user_invite_heading_subteam: gwr,
  email_no_user_invite_heading_org: hwr,
  email_no_user_invite_subheading: vwr,
  email_user_invite_subheading_subteam: bwr,
  email_user_invite_subheading_org: ywr,
  email_no_user_invite_steps_intro: $wr,
  email_no_user_step_one: wwr,
  email_no_user_step_two: kwr,
  email_no_user_step_three: Swr,
  email_no_user_step_four: Ewr,
  email_no_user_signoff: xwr,
  impersonation_user_tip: Cwr,
  available_variables: Twr,
  scheduler: Awr,
  no_workflows: Iwr,
  change_filter: Owr,
  change_filter_common: Nwr,
  no_results_for_filter: zwr,
  recommended_next_steps: Rwr,
  create_a_managed_event: Pwr,
  meetings_are_better_with_the_right: Dwr,
  create_a_one_one_template: Lwr,
  collective_or_roundrobin: Mwr,
  book_your_team_members: Fwr,
  event_no_longer_attending_subject: qwr,
  no_longer_attending: jwr,
  attendee_no_longer_attending_subject: Vwr,
  attendee_no_longer_attending: Bwr,
  attendee_no_longer_attending_subtitle: Uwr,
  create_event_on: Gwr,
  create_routing_form_on: Wwr,
  default_app_link_title: Hwr,
  default_app_link_description: Ywr,
  organizer_default_conferencing_app: Kwr,
  organizer_default_conferencing_app_not_found: Zwr,
  under_maintenance: Xwr,
  under_maintenance_description: Jwr,
  event_type_seats: Qwr,
  booking_questions_title: ekr,
  booking_questions_description: tkr,
  add_a_booking_question: nkr,
  identifier: okr,
  duplicate_email: rkr,
  enter_redirect_url_on_exit_description: ikr,
  booking_with_payment_cancelled: akr,
  booking_with_payment_cancelled_already_paid: skr,
  booking_with_payment_cancelled_refunded: ckr,
  booking_with_payment_cancelled_no_refund: lkr,
  booking_with_payment_cancelled_refund_window_expired: ukr,
  booking_confirmation_failed: dkr,
  not_enough_seats: _kr,
  form_builder_field_already_exists: pkr,
  guests_field_must_be_multiemail: mkr,
  show_on_booking_page: fkr,
  visit_cancelled_booking: gkr,
  get_started_zapier_templates: hkr,
  standard_templates: vkr,
  cal_ai_templates: bkr,
  team_is_unpublished: ykr,
  org_is_unpublished_description: $kr,
  team_is_unpublished_description: wkr,
  team_member: kkr,
  a_routing_form: Skr,
  form_description_placeholder: Ekr,
  keep_me_connected_with_form: xkr,
  fields_in_form_duplicated: Ckr,
  form_deleted: Tkr,
  delete_form: Akr,
  delete_form_action: Ikr,
  delete_form_confirmation: Okr,
  delete_form_confirmation_2: Nkr,
  typeform_redirect_url_copied: zkr,
  modifications_in_fields_warning: Rkr,
  connected_forms: Pkr,
  form_modifications_warning: Dkr,
  responses_collection_waiting_description: Lkr,
  this_is_what_your_users_would_see: Mkr,
  identifies_name_field: Fkr,
  add_1_option_per_line: qkr,
  select_a_router: jkr,
  add_a_new_route: Vkr,
  make_informed_decisions: Bkr,
  make_informed_decisions_description: Ukr,
  view_bookings_across: Gkr,
  view_bookings_across_description: Wkr,
  identify_booking_trends: Hkr,
  identify_booking_trends_description: Ykr,
  spot_popular_event_types: Kkr,
  spot_popular_event_types_description: Zkr,
  no_responses_yet: Xkr,
  no_routes_defined: Jkr,
  this_will_be_the_placeholder: Qkr,
  error_booking_event: e0r,
  timeslot_missing_title: t0r,
  timeslot_missing_description: n0r,
  timeslot_missing_cta: o0r,
  switch_monthly: r0r,
  switch_weekly: i0r,
  switch_multiday: a0r,
  switch_columnview: s0r,
  num_locations: c0r,
  select_on_next_step: l0r,
  this_meeting_has_not_started_yet: u0r,
  this_app_requires_connected_account: d0r,
  connect_app: _0r,
  app_is_connected: p0r,
  requires_app: m0r,
  verification_code: f0r,
  can_you_try_again: g0r,
  verify: h0r,
  timezone_info: v0r,
  timezone_variable: b0r,
  event_end_time_variable: y0r,
  event_end_time_info: $0r,
  cancel_url_variable: w0r,
  cancel_url_info: k0r,
  cancel_reason_variable: S0r,
  cancel_reason_info: E0r,
  reschedule_url_variable: x0r,
  reschedule_url_info: C0r,
  reschedule_reason_variable: T0r,
  reschedule_reason_info: A0r,
  invalid_event_name_variables: I0r,
  select_all: O0r,
  default_conferencing_bulk_title: N0r,
  members_default_schedule: z0r,
  set_by_admin: R0r,
  members_default_location: P0r,
  members_default_schedule_description: D0r,
  requires_at_least_one_schedule: L0r,
  default_conferencing_bulk_description: M0r,
  default_schedules_bulk_description: F0r,
  locked_for_members: q0r,
  unlocked_for_members: j0r,
  apps_locked_for_members_description: V0r,
  apps_unlocked_for_members_description: B0r,
  apps_locked_by_team_admins_description: U0r,
  apps_unlocked_by_team_admins_description: G0r,
  workflows_locked_for_members_description: W0r,
  workflows_unlocked_for_members_description: H0r,
  workflows_locked_by_team_admins_description: Y0r,
  workflows_unlocked_by_team_admins_description: K0r,
  webhooks_locked_for_members_description: Z0r,
  webhooks_unlocked_for_members_description: X0r,
  webhooks_locked_by_team_admins_description: J0r,
  webhooks_unlocked_by_team_admins_description: Q0r,
  locked_by_team_admin: e1r,
  app_not_connected: t1r,
  connect_now: n1r,
  managed_event_dialog_confirm_button_one: o1r,
  managed_event_dialog_confirm_button_other: r1r,
  managed_event_dialog_title_one: i1r,
  managed_event_dialog_title_other: a1r,
  managed_event_dialog_information_one: s1r,
  managed_event_dialog_information_other: c1r,
  managed_event_dialog_clarification: l1r,
  review_event_type: u1r,
  looking_for_more_analytics: d1r,
  looking_for_more_insights: _1r,
  filters: p1r,
  filter: m1r,
  add_a_member: f1r,
  add_filter: g1r,
  add_rule: h1r,
  add_rule_group: v1r,
  remove_filters: b1r,
  email_verified: y1r,
  select_user: $1r,
  select_event_type: w1r,
  select_date_range: k1r,
  popular_events: S1r,
  no_event_types_found: E1r,
  average_event_duration: x1r,
  bookings_by_hour: C1r,
  most_booked_members: T1r,
  least_booked_members: A1r,
  most_bookings_scheduled: I1r,
  least_bookings_scheduled: O1r,
  most_bookings_completed: N1r,
  least_bookings_completed: z1r,
  events_created: R1r,
  events_completed: P1r,
  events_cancelled: D1r,
  events_rescheduled: L1r,
  events: M1r,
  performance: F1r,
  from_last_period: q1r,
  from_to_date_period: j1r,
  redirect_url_warning: V1r,
  event_trends: B1r,
  clear_filters: U1r,
  clear: G1r,
  hold: W1r,
  on_booking_option: H1r,
  hold_option: Y1r,
  card_held: K1r,
  charge_card: Z1r,
  card_charged: X1r,
  no_show_fee_amount: J1r,
  no_show_fee: Q1r,
  submit_card: eSr,
  submit_payment_information: tSr,
  meeting_awaiting_payment_method: nSr,
  no_show_fee_charged_email_subject: oSr,
  no_show_fee_charged_text_body: rSr,
  no_show_fee_charged_subtitle: iSr,
  error_charging_card: aSr,
  collect_no_show_fee: sSr,
  no_show_fee_charged: cSr,
  your_card_was_declined: lSr,
  your_card_does_not_support_this_type_of_purchase: uSr,
  amount_must_convert_to_at_least: dSr,
  could_not_charge_card: _Sr,
  insights: pSr,
  routing_forms: mSr,
  insights_no_data_found_for_filter: fSr,
  acknowledge_booking_no_show_fee: gSr,
  days: hSr,
  card_details: vSr,
  something_went_wrong_on_our_end: bSr,
  please_provide_following_text_to_suppport: ySr,
  seats_and_no_show_fee_error: $Sr,
  complete_your_booking: wSr,
  complete_your_booking_subject: kSr,
  confirm_your_details: SSr,
  copy_invite_link: ESr,
  edit_invite_link: xSr,
  invite_link_copied: CSr,
  invite_link_deleted: TSr,
  api_key_deleted: ASr,
  delete_api_key_warning: ISr,
  invite_link_updated: OSr,
  link_expires_after: NSr,
  one_day: zSr,
  seven_days: RSr,
  thirty_days: PSr,
  three_months: DSr,
  one_year: LSr,
  team_invite_received: MSr,
  currency_string: FSr,
  charge_card_dialog_body: qSr,
  charge_attendee: jSr,
  payment_app_commission: VSr,
  email_invite_team: BSr,
  email_invite_team_bulk: USr,
  error_collecting_card: GSr,
  image_size_limit_exceed: WSr,
  unauthorized_workflow_error_message: HSr,
  inline_embed: YSr,
  load_inline_content: KSr,
  floating_pop_up_button: ZSr,
  floating_button_trigger_modal: XSr,
  pop_up_element_click: JSr,
  open_dialog_with_element_click: QSr,
  use_my_own_form: eEr,
  use_our_headless_routing_api: tEr,
  need_help_embedding: nEr,
  book_my_cal: oEr,
  first_name: rEr,
  last_name: iEr,
  first_last_name: aEr,
  invite_as: sEr,
  form_updated_successfully: cEr,
  disable_attendees_confirmation_emails: lEr,
  disable_attendees_confirmation_emails_description: uEr,
  disable_host_confirmation_emails: dEr,
  disable_host_confirmation_emails_description: _Er,
  add_an_override: pEr,
  import_from_google_workspace: mEr,
  connect_google_workspace: fEr,
  google_workspace_admin_tooltip: gEr,
  first_event_type_webhook_description: hEr,
  create_instant_meeting_webhook_description: vEr,
  install_app_on: bEr,
  create_for: yEr,
  currency: $Er,
  organization_banner_description: wEr,
  organization_banner_title: kEr,
  set_up_your_organization: SEr,
  set_up_your_platform_organization: EEr,
  organizations_description: xEr,
  plans: CEr,
  platform: TEr,
  platform_description: AEr,
  platform_organization_description: IEr,
  must_enter_organization_name: OEr,
  must_enter_organization_admin_email: NEr,
  admin_email: zEr,
  platform_admin_email: REr,
  admin_username: PEr,
  organization_name: DEr,
  platform_name: LEr,
  organization_url: MEr,
  organization_verify_header: FEr,
  organization_verify_email_body: qEr,
  additional_url_parameters: jEr,
  about_your_organization: VEr,
  about_your_organization_description: BEr,
  create_your_teams: UEr,
  create_your_teams_description: GEr,
  invite_organization_admins: WEr,
  invite_organization_admins_description: HEr,
  set_a_password: YEr,
  set_a_password_description: KEr,
  organization_logo: ZEr,
  organization_about_description: XEr,
  ill_do_this_later: JEr,
  verify_your_email: QEr,
  enter_digit_code: exr,
  verify_email_organization: txr,
  code_provided_invalid: nxr,
  email_already_used: oxr,
  organization_admin_invited_heading: rxr,
  organization_admin_invited_body: ixr,
  duplicated_slugs_warning: axr,
  team_names_empty: sxr,
  team_names_repeated: cxr,
  user_belongs_organization: lxr,
  org_no_teams_yet: uxr,
  org_no_teams_yet_description: dxr,
  set_up: _xr,
  my_profile: pxr,
  my_settings: mxr,
  crm: fxr,
  messaging: gxr,
  sender_id_info: hxr,
  org_admins_can_create_new_teams: vxr,
  google_new_spam_policy: bxr,
  resolve: yxr,
  no_organization_slug: $xr,
  copy_link_org: wxr,
  "404_the_org": "L'organisation",
  "404_the_team": "L'équipe",
  "404_claim_entity_org": "Réservez votre sous-domaine pour votre organisation",
  "404_claim_entity_team": "Revendiquez cette équipe et commencez à gérer vos plannings collectivement",
  insights_team_filter: kxr,
  insights_user_filter: Sxr,
  insights_subtitle: Exr,
  call_history: xxr,
  call_history_subtitle: Cxr,
  location_options: Txr,
  channel_type: Axr,
  end_reason: Ixr,
  session_status: Oxr,
  user_sentiment: Nxr,
  time_header: zxr,
  from_header: Rxr,
  custom_plan: Pxr,
  email_embed: Dxr,
  add_times_to_your_email: Lxr,
  select_time: Mxr,
  select_date: Fxr,
  only_show_if_parameter_set: qxr,
  add_parameter: jxr,
  connecting_you_to_someone: Vxr,
  please_do_not_close_this_tab: Bxr,
  see_all_available_times: Uxr,
  org_team_names_example_1: Gxr,
  org_team_names_example_2: Wxr,
  org_team_names_example_3: Hxr,
  org_team_names_example_4: Yxr,
  org_team_names_example_5: Kxr,
  org_max_team_warnings: Zxr,
  what_is_this_meeting_about: Xxr,
  add_to_team: Jxr,
  remove_users_from_org: Qxr,
  delegation_credential: eCr,
  delegation_credential_description: tCr,
  add_client_id_in_google_workspace_with_below_scope: nCr,
  delegation_credential_enabled: oCr,
  add_delegation_credential: rCr,
  edit_delegation_credential: iCr,
  domain: aCr,
  no_workspace_platforms: sCr,
  workspace_platform: cCr,
  workspace_platforms: lCr,
  workspace_platforms_description: uCr,
  edit_workspace_platform: dCr,
  edit_service_account: _Cr,
  add_workspace_platform: pCr,
  slug: mCr,
  service_account_key: fCr,
  edit_service_account_key: gCr,
  delegation_credential_restricts_adding_more_than_one_installation: hCr,
  app_successfully_installed_and_is_using_delegated_credentials: vCr,
  remove_users_from_org_confirm: bCr,
  remove_users_from_team: yCr,
  remove_users_from_team_confirm: $Cr,
  user_has_no_schedules: wCr,
  user_isnt_in_any_teams: kCr,
  user_has_no_app_installed: SCr,
  requires_booker_email_verification: ECr,
  description_requires_booker_email_verification: xCr,
  requires_confirmation_mandatory: CCr,
  organizations: TCr,
  upload_cal_video_logo: ACr,
  update_cal_video_logo: ICr,
  upload_banner: OCr,
  cal_video_logo_upload_instruction: NCr,
  org_admin_other_teams: zCr,
  org_admin_other_teams_description: RCr,
  not_part_of_org: PCr,
  no_other_teams_found: DCr,
  no_other_teams_found_description: LCr,
  attendee_first_name_variable: MCr,
  attendee_last_name_variable: FCr,
  attendee_first_name_info: qCr,
  attendee_last_name_info: jCr,
  your_monthly_digest: VCr,
  member_name: BCr,
  most_popular_events: UCr,
  summary_of_events_for_your_team_for_the_last_30_days: GCr,
  me: WCr,
  meeting_unavailable: HCr,
  monthly_digest_email: YCr,
  monthly_digest_email_for_teams: KCr,
  verify_team_tooltip: ZCr,
  member_removed: XCr,
  my_availability: JCr,
  team_availability: QCr,
  instant_meeting_availability: eTr,
  backup_code: tTr,
  backup_codes: nTr,
  backup_code_instructions: oTr,
  backup_codes_copied: rTr,
  incorrect_backup_code: iTr,
  lost_access: aTr,
  missing_backup_codes: sTr,
  admin_org_notification_email_subject: cTr,
  hi_admin: lTr,
  admin_org_notification_email_title: uTr,
  admin_org_notification_email_body_part1: dTr,
  admin_org_notification_email_body_part2: _Tr,
  admin_org_notification_email_body_part3: pTr,
  admin_org_notification_email_cta: mTr,
  org_has_been_processed: fTr,
  org_error_processing: gTr,
  orgs_page_description: hTr,
  unverified: vTr,
  verified: bTr,
  dns_missing: yTr,
  dns_configured: $Tr,
  mark_dns_configured: wTr,
  value: kTr,
  your_organization_updated_sucessfully: STr,
  team_no_event_types: ETr,
  seat_options_doesnt_multiple_durations: xTr,
  include_calendar_event: CTr,
  oAuth: TTr,
  oAuth_client_creation_form: ATr,
  oAuth_client_creation_form_description: ITr,
  oAuth_client_updation_form: OTr,
  oAuth_client_updation_form_description: NTr,
  recently_added: zTr,
  connect_all_calendars: RTr,
  connect_all_calendars_description: PTr,
  workflow_automation_description: DTr,
  scheduling_for_your_team: LTr,
  scheduling_for_your_team_description: MTr,
  no_members_found: FTr,
  directory_sync: qTr,
  directory_name: jTr,
  directory_provider: VTr,
  directory_scim_url: BTr,
  directory_scim_token: UTr,
  directory_scim_url_copied: GTr,
  directory_scim_token_copied: WTr,
  directory_sync_info_description: HTr,
  directory_sync_configure: YTr,
  directory_sync_configure_description: KTr,
  directory_sync_title: ZTr,
  directory_sync_created: XTr,
  directory_sync_description: JTr,
  directory_sync_deleted: QTr,
  directory_sync_delete_connection: eAr,
  directory_sync_delete_title: tAr,
  directory_sync_delete_description: nAr,
  directory_sync_delete_confirmation: oAr,
  event_setup_length_error: rAr,
  availability_schedules: iAr,
  unauthorized: aAr,
  access_cal_account: sAr,
  select_account_team: cAr,
  allow_client_to: lAr,
  associate_with_cal_account: uAr,
  see_personal_info: dAr,
  see_primary_email_address: _Ar,
  connect_installed_apps: pAr,
  access_event_type: mAr,
  access_availability: fAr,
  access_bookings: gAr,
  allow_client_to_do: hAr,
  oauth_access_information: vAr,
  allow: bAr,
  view_only_edit_availability_not_onboarded: yAr,
  view_only_edit_availability: $Ar,
  you_can_override_calendar_in_advanced_tab: wAr,
  edit_users_availability: kAr,
  resend_invitation: SAr,
  invitation_resent: EAr,
  saml_sso: xAr,
  add_client: CAr,
  copy_client_secret_info: TAr,
  add_new_client: AAr,
  add_new_user: IAr,
  this_app_is_not_setup_already: OAr,
  as_csv: NAr,
  overlay_my_calendar: zAr,
  overlay_my_calendar_toc: RAr,
  view_overlay_calendar_events: PAr,
  join_event_location: DAr,
  troubleshooting: LAr,
  calendars_were_checking_for_conflicts: MAr,
  availabilty_schedules: FAr,
  manage_calendars: qAr,
  manage_availability_schedules: jAr,
  locked: VAr,
  unlocked: BAr,
  lock_timezone_toggle_on_booking_page: UAr,
  description_lock_timezone_toggle_on_booking_page: GAr,
  event_setup_multiple_payment_apps_error: WAr,
  number_in_international_format: HAr,
  install_calendar: YAr,
  branded_subdomain: KAr,
  branded_subdomain_description: ZAr,
  org_insights: XAr,
  org_insights_description: JAr,
  extensive_whitelabeling: QAr,
  extensive_whitelabeling_description: e2r,
  unlimited_teams: t2r,
  verify_email: n2r,
  proceed_with_cancellation_description: o2r,
  proceed_with_cancellation_error: r2r,
  unlimited_teams_description: i2r,
  unified_billing: a2r,
  advanced_managed_events: s2r,
  advanced_managed_events_description: c2r,
  enterprise: l2r,
  enterprise_description: u2r,
  create_your_org: d2r,
  create_org: _2r,
  create_your_org_description: p2r,
  create_your_enterprise_description: m2r,
  other_payment_app_enabled: f2r,
  admin_delete_organization_description_1: g2r,
  admin_delete_organization_description_2: h2r,
  admin_delete_organization_description_3: v2r,
  admin_delete_organization_description_4: b2r,
  admin_delete_organization_title: y2r,
  published: $2r,
  unpublished: w2r,
  publish: k2r,
  troubleshooter_tooltip: S2r,
  need_help: E2r,
  troubleshooter: x2r,
  number_to_call: C2r,
  guest_name: T2r,
  guest_email: A2r,
  guest_company: I2r,
  please_install_a_calendar: O2r,
  instant_tab_title: N2r,
  instant_event_tab_description: z2r,
  uprade_to_create_instant_bookings: R2r,
  dont_want_to_wait: P2r,
  meeting_started: D2r,
  pay_and_book: L2r,
  cal_ai_event_tab_description: M2r,
  booking_not_found_error: F2r,
  booking_seats_full_error: q2r,
  missing_payment_credential_error: j2r,
  missing_payment_app_id_error: V2r,
  not_enough_available_seats_error: B2r,
  user_redirect_title: U2r,
  user_redirect_description: G2r,
  out_of_office: W2r,
  out_of_office_description: H2r,
  send_request: Y2r,
  start_date_and_end_date_required: K2r,
  start_date_must_be_before_end_date: Z2r,
  start_date_must_be_in_the_future: X2r,
  user_not_found: J2r,
  cannot_redirect_to_self: Q2r,
  out_of_office_entry_already_exists: eIr,
  out_of_office_id_required: tIr,
  booking_redirect_infinite_not_allowed: nIr,
  success_entry_created: oIr,
  booking_redirect_email_subject: rIr,
  booking_redirect_email_title: iIr,
  booking_redirect_email_description: aIr,
  booking_redirect_updated_email_subject: sIr,
  booking_redirect_updated_email_title: cIr,
  booking_redirect_updated_email_description: lIr,
  booking_redirect_cancelled_email_subject: uIr,
  booking_redirect_cancelled_email_title: dIr,
  booking_redirect_cancelled_email_description: _Ir,
  success_accept_booking_redirect: pIr,
  success_reject_booking_redirect: mIr,
  copy_link_booking_redirect_request: fIr,
  booking_redirect_request_title: gIr,
  select_team_member: hIr,
  going_away_title: vIr,
  redirect_team_enabled: bIr,
  redirect_team_disabled: yIr,
  out_of_office_unavailable_list: $Ir,
  success_deleted_entry_out_of_office: wIr,
  success_edited_entry_out_of_office: kIr,
  temporarily_out_of_office: SIr,
  add_a_redirect: EIr,
  create_entry: xIr,
  time_range: CIr,
  automatically_add_all_team_members: TIr,
  redirect_to: AIr,
  having_trouble_finding_time: IIr,
  show_more: OIr,
  forward_params_redirect: NIr,
  assignment_description: zIr,
  lowest: RIr,
  low: PIr,
  medium: DIr,
  high: LIr,
  Highest: MIr,
  send_booker_to: FIr,
  set_priority: qIr,
  set_weight: jIr,
  enable_weights: VIr,
  priority_for_user: BIr,
  weights_description: UIr,
  weight_for_user: GIr,
  change_priority: WIr,
  field_identifiers_as_variables: HIr,
  field_identifiers_as_variables_with_example: YIr,
  account_already_linked: KIr,
  send_email: ZIr,
  cal_ai_phone_call_action: XIr,
  call_to_confirm_booking: JIr,
  cal_ai_phone_call_action_description: QIr,
  cal_ai_agent_configuration: eOr,
  choose_at_least_one_event_type_test_call: tOr,
  mark_as_no_show: nOr,
  unmark_as_no_show: oOr,
  account_unlinked_success: rOr,
  account_unlinked_error: iOr,
  travel_schedule: aOr,
  travel_schedule_description: sOr,
  schedule_timezone_change: cOr,
  date: lOr,
  enter_the_general_prompt_for_the_agent: uOr,
  overlaps_with_existing_schedule: dOr,
  "org_admin_no_slots|heading": "Aucune disponibilité trouvée pour {{name}}",
  "org_admin_no_slots|content": "Bonjour aux administrateurs de l'organisation,<br /><br />Veuillez noter : il a été porté à notre attention que {{username}} n'a pas eu de disponibilité lorsqu'un utilisateur a visité {{username}}/{{slug}}<br /><br />Il y a plusieurs raisons pour lesquelles cela pourrait se produire<br />L'utilisateur n'a pas de calendriers connectés<br />Leurs horaires attachés à cet événement ne sont pas activés<br /> <br />Nous vous recommandons de vérifier leur disponibilité pour résoudre ce problème.",
  "org_admin_no_slots|cta": "Ouvrir les disponibilités de l'utilisateur",
  organization_no_slots_notification_switch_title: _Or,
  organization_no_slots_notification_switch_description: pOr,
  organization_disable_phone_only_sms_notifications_switch_title: mOr,
  organization_disable_phone_only_sms_notifications_switch_description: fOr,
  "email_team_invite|subject|added_to_org": "{{user}} vous a ajouté(e) à l'organisation {{team}} sur {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} vous a invité(e) à rejoindre l'organisation {{team}} sur {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} vous a ajouté(e) à l'équipe {{team}} de l'organisation {{parentTeamName}} sur {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} vous a invité à rejoindre l'équipe {{team}} sur {{appName}}",
  "email_team_invite|heading|added_to_org": "Vous avez été ajouté à une organisation {{appName}}",
  "email_team_invite|heading|invited_to_org": "Vous avez été invité à une organisation {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Vous avez été ajouté à une équipe de l'organisation {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Vous avez été invité à une équipe de l'organisation {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Vous avez été invité à rejoindre une équipe {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} vous a ajouté(e) à l'organisation <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} vous a invité(e) à rejoindre l'organisation {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} vous a invité(e) à rejoindre l'équipe {{team}} de l'organisation {{parentTeamName}} sur {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} vous a ajouté(e) à son équipe <strong>{{teamName}}</strong> de son organisation {{parentTeamName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} vous a invité(e) à rejoindre son équipe <strong>{{teamName}}</strong> de son organisation {{parentTeamName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} vous a invité à rejoindre son équipe « {{teamName}} » sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.",
  "email|existing_user_added_link_will_change": "En acceptant l'invitation, votre lien changera pour le domaine de votre organisation, mais ne vous inquiétez pas, tous les liens précédents fonctionneront toujours et redirigeront correctement.<br /><br />Veuillez noter : Tous vos types d'événements personnels seront déplacés dans l'organisation <strong>{{teamName}}</strong>, ce qui peut également inclure un lien personnel potentiel. <br /><br />Pour les événements personnels, nous vous recommandons de créer un nouveau compte avec une adresse e-mail personnelle.",
  "email|existing_user_added_link_changed": "Votre lien a été modifié de {{a0}} à {{a1}}, mais ne vous inquiétez pas, tous les liens précédents fonctionnent toujours et redirigent correctement. <br /><br />Veuillez noter : Tous vos types d'événements personnels ont été déplacés dans l'organisation <strong>{{teamName}}</strong>, ce qui peut également inclure un lien personnel potentiel.<br /><br />Veuillez vous connecter et vérifier que vous n'avez pas d'événements privés sur votre nouveau compte organisationnel.<br /><br />Pour les événements personnels, nous vous recommandons de créer un nouveau compte avec une adresse e-mail personnelle.<br /><br />Profitez de votre nouveau lien épuré : {{a2}}",
  "email_organization_created|subject": "Votre organisation a été créée",
  your_current_plan: gOr,
  organization_price_per_user_month: hOr,
  privacy_organization_description: vOr,
  privacy: bOr,
  team_will_be_under_org: yOr,
  add_group_name: $Or,
  group_name: wOr,
  routers: kOr,
  primary: SOr,
  make_primary: EOr,
  add_email: xOr,
  add_emails: COr,
  add_email_description: TOr,
  confirm_email: AOr,
  confirming_your_booking_sms: IOr,
  scheduler_first_name: OOr,
  scheduler_last_name: NOr,
  scheduler_name: zOr,
  organizer_first_name: ROr,
  confirm_email_description: POr,
  send_event_details_to: DOr,
  schedule_tz_without_end_date: LOr,
  select_members: MOr,
  lock_event_types_modal_header: FOr,
  org_delete_event_types_org_admin: qOr,
  org_hide_event_types_org_admin: jOr,
  hide_org_eventtypes: VOr,
  delete_org_eventtypes: BOr,
  lock_org_users_eventtypes: UOr,
  lock_org_users_eventtypes_description: GOr,
  add_to_event_type: WOr,
  create_account_password: HOr,
  create_account_with_saml: YOr,
  error_creating_account_password: KOr,
  cannot_create_account_password_cal_provider: ZOr,
  cannot_create_account_password_already_existing: XOr,
  create_account_password_hint: JOr,
  disconnect_account: QOr,
  disconnect_account_hint: eNr,
  cookie_consent_checkbox: tNr,
  make_a_call: nNr,
  skip_rr_assignment_label: oNr,
  skip_rr_description: rNr,
  select_account_header: iNr,
  select_account_description: aNr,
  select_event_types_header: sNr,
  select_event_types_description: cNr,
  configure_app_header: lNr,
  configure_app_description: uNr,
  already_installed: dNr,
  ooo_reasons_unspecified: _Nr,
  ooo_reasons_vacation: pNr,
  ooo_reasons_travel: mNr,
  ooo_reasons_sick_leave: fNr,
  ooo_reasons_public_holiday: gNr,
  ooo_forwarding_to: hNr,
  ooo_not_forwarding: vNr,
  ooo_empty_title: bNr,
  ooo_empty_description: yNr,
  ooo_user_is_ooo: $Nr,
  ooo_slots_returning: wNr,
  ooo_slots_book_with: kNr,
  ooo_select_reason: SNr,
  create_an_out_of_office: ENr,
  edit_an_out_of_office: xNr,
  submit_feedback: CNr,
  host_no_show: TNr,
  no_show_description: ANr,
  how_can_we_improve: INr,
  most_liked: ONr,
  review: NNr,
  reviewed: zNr,
  unreviewed: RNr,
  rating_url_variable: PNr,
  rating_url_info: DNr,
  no_show_url_variable: LNr,
  no_show_url_info: MNr,
  no_support_needed: FNr,
  hide_support: qNr,
  event_ratings: jNr,
  event_no_show: VNr,
  event_no_show_guest: BNr,
  recent_ratings: UNr,
  no_ratings: GNr,
  no_ratings_description: WNr,
  most_no_show_host: HNr,
  highest_rated: YNr,
  lowest_rated: KNr,
  highest_rated_members: ZNr,
  lowest_rated_members: XNr,
  csat_score: JNr,
  lockedSMS: QNr,
  leave_without_assigning_anyone: ezr,
  leave_without_adding_attendees: tzr,
  no_availability_shown_to_bookers: nzr,
  go_back_and_assign: ozr,
  leave_without_assigning: rzr,
  signing_up_terms: izr,
  proceeding_agreement: azr,
  terms: szr,
  always_show_x_days: czr,
  always_show_x_days_description: lzr,
  team_subscription_cancelled_successfully: uzr,
  team_subscription_cancellation_error: dzr,
  unable_to_subscribe_to_the_platform: _zr,
  updating_oauth_client_error: pzr,
  creating_oauth_client_error: mzr,
  event_type_color: fzr,
  event_type_color_description: gzr,
  mark_as_no_show_title: hzr,
  x_marked_as_no_show: vzr,
  x_unmarked_as_no_show: bzr,
  team_select_info: yzr,
  team_settings_description: $zr,
  no_show_updated: wzr,
  email_copied: kzr,
  phone_number_copied: Szr,
  USER_PENDING_MEMBER_OF_THE_ORG: Ezr,
  USER_ALREADY_INVITED_OR_MEMBER: xzr,
  USER_MEMBER_OF_OTHER_ORGANIZATION: Czr,
  booking_reassigned: Tzr,
  reassign: Azr,
  reassign_to_another_rr_host: Izr,
  assign_team_member: Ozr,
  override_team_member_to_assign: Nzr,
  no_available_hosts: zzr,
  reassign_round_robin_host: Rzr,
  skip_writing_to_calendar: Pzr,
  rescheduling_not_possible: Dzr,
  event_expired: Lzr,
  skip_contact_creation: Mzr,
  skip_writing_to_calendar_note: Fzr,
  attributes: qzr,
  new_attribute: jzr,
  add_attributes: Vzr,
  add_attributes_description: Bzr,
  new_option: Uzr,
  update_profile: Gzr,
  attribute: Wzr,
  create_attribute_description: Hzr,
  edit_attribute_description: Yzr,
  attribute_updated_successfully: Kzr,
  attribute_deleted_successfully: Zzr,
  attributes_edited_successfully: Xzr,
  attribute_meta_description: Jzr,
  attributes_edit_description: Qzr,
  back_to_attributes: eRr,
  delete_attribute: tRr,
  delete_attribute_description: nRr,
  disable_all_emails_to_attendees: oRr,
  disable_all_emails_description: rRr,
  disable_all_emails_to_hosts: iRr,
  type_confirm_to_continue: aRr,
  disable_email: sRr,
  grant_admin_api: cRr,
  revoke_admin_api: lRr,
  add_calendar_label: uRr,
  apple_connect_atom_label: dRr,
  apple_connect_atom_already_connected_label: _Rr,
  apple_connect_atom_loading_label: pRr,
  google_connect_atom_label: mRr,
  google_connect_atom_already_connected_label: fRr,
  google_connect_atom_loading_label: gRr,
  outlook_connect_atom_label: hRr,
  outlook_connect_atom_already_connected_label: vRr,
  outlook_connect_atom_loading_label: bRr,
  stripe_connect_atom_label: yRr,
  stripe_connect_atom_already_connected_label: $Rr,
  stripe_connect_atom_loading_label: wRr,
  booking_question_response_variables: kRr,
  managed_by_teamAdmins: SRr,
  number_of_options: ERr,
  reschedule_with_same_round_robin_host_title: xRr,
  reschedule_with_same_round_robin_host_description: CRr,
  disable_input_if_prefilled: TRr,
  booking_limits: ARr,
  booking_limits_team_description: IRr,
  limit_team_booking_frequency_description: ORr,
  booking_limits_updated_successfully: NRr,
  you_are_unauthorized_to_make_this_change_to_the_booking: zRr,
  delegation_credential_disabled: RRr,
  matching_members: PRr,
  x_matching_members: DRr,
  matching_members_queue_using_attribute_weights: LRr,
  matching_members_queue_using_event_assignee_weights: MRr,
  no_matching_members: FRr,
  no_matching_members_will_fallback_to_all_assigned_members: qRr,
  hide_calendar_event_details: jRr,
  description_hide_calendar_event_details: VRr,
  last_number_of_days: BRr,
  month_to_date: URr,
  year_to_date: GRr,
  custom_range: WRr,
  refund_policy: HRr,
  always: YRr,
  never: KRr,
  payment_option: ZRr,
  if_cancelled: XRr,
  before: JRr,
  show_all_columns: QRr,
  toggle_columns: ePr,
  no_columns_found: tPr,
  salesforce_create_record_as: nPr,
  salesforce_lead: oPr,
  salesforce_contact_under_account: rPr,
  salesforce_skip_entry_creation: iPr,
  salesforce_if_account_does_not_exist: aPr,
  salesforce_create_new_contact_under_account: sPr,
  salesforce_change_record_owner_on_booking: cPr,
  mass_assign_attributes: lPr,
  reroute_preview_custom_message: uPr,
  reroute_preview_external_redirect: dPr,
  reroute_preview_possible_host: _Pr,
  current_routing_status: pPr,
  reroute_booking: mPr,
  reroute_booking_description: fPr,
  verify_new_route: gPr,
  reroute: hPr,
  new_routing_status: vPr,
  salesforce_book_directly_with_attendee_owner: bPr,
  salesforce_check_owner_of: yPr,
  account: $Pr,
  choose_hosts_schedule: wPr,
  hosts_schedule_description: kPr,
  no_hosts_description: SPr,
  team_member_round_robin_reassign: EPr,
  team_member_round_robin_reassign_description: xPr,
  round_robin_reassign_description: CPr,
  invalid_round_robin_host: TPr,
  user_is_round_robin_fixed: APr,
  reschedule_with_same_timeslot: IPr,
  reschedule_with_same_timeslot_of_new_event: OPr,
  reschedule_to_the_new_event_with_different_timeslot: NPr,
  reschedule_with_different_timeslot: zPr,
  we_dont_have_id_for_the_new_event: RPr,
  rerouted_booking_successfully_redirecting_to_booking_page: PPr,
  on_booking_write_to_event_object: DPr,
  field_name: LPr,
  add_new_field: MPr,
  you_dont_have_access_to_reroute_this_booking: FPr,
  form_response_not_found: qPr,
  contact_owner: jPr,
  contact_owner_not_found: VPr,
  using_fallback_members: BPr,
  chosen_route: UPr,
  attribute_logic_matched: GPr,
  attribute_logic_fallback_matched: WPr,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: HPr,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: YPr,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: KPr,
  warning: ZPr,
  fallback_attribute_logic_description: XPr,
  fallback_attribute_logic_warning: JPr,
  fallback_not_needed: QPr,
  confirm_reassign_unavailable: eDr,
  confirm_reassign_available: tDr,
  reassign_unavailable_team_member_description: nDr,
  reassign_available_team_member_description: oDr,
  yes_reassign: rDr,
  filter_by_attributes: iDr,
  reassign_reason: aDr,
  field_type_change_suggestion: sDr,
  reassigned_by: cDr,
  row: lDr,
  rows: uDr,
  attendee_timezone_variable: dDr,
  event_start_time_in_attendee_timezone_variable: _Dr,
  event_start_time_in_attendee_timezone_info: pDr,
  event_end_time_in_attendee_timezone_info: mDr,
  event_end_time_in_attendee_timezone_variable: fDr,
  salesforce_create_event_on_contact: gDr,
  salesforce_owner_name_to_change: hDr,
  no_filter_set: vDr,
  booking_dry_run_successful: bDr,
  booking_dry_run_successful_description: yDr,
  dont_have_access_this_page: $Dr,
  you_need_admin_or_owner_privileges_to_access: wDr,
  field_type: kDr,
  when_to_write: SDr,
  salesforce_on_booking_write_to_record: EDr,
  on_every_booking: xDr,
  only_if_field_is_empty: CDr,
  booking_start_date: TDr,
  booking_created_date: ADr,
  booking_reassigned_to_host: IDr,
  no_contact_owner: ODr,
  routing_forms_created: NDr,
  routing_forms_total_responses: zDr,
  routing_forms_total_responses_without_booking: RDr,
  routing_forms_total_responses_with_booking: PDr,
  routing_form_insights: DDr,
  routing_form_insights_form_name_header: LDr,
  routing_form_insights_booking_status_header: MDr,
  routing_form_insights_response_no_booking: FDr,
  routing_form_insights_booked_by: qDr,
  routing_form_insights_created_at: jDr,
  routing_form_insights_booking_status: VDr,
  routing_form_insights_booking_at: BDr,
  routing_form_insights_submitted_at: UDr,
  copy_redirect_url: GDr,
  redirect_url_on_exit: WDr,
  total_bookings_per_period: HDr,
  routed_to_per_period: YDr,
  per_day: KDr,
  per_week: ZDr,
  per_month: XDr,
  routing_form_insights_assignment_reason: JDr,
  access_denied: QDr,
  salesforce_route_to_owner: e3r,
  salesforce_add_attendees_as: t3r,
  salesforce_do_not_route_to_owner: n3r,
  salesforce_route_to_custom_lookup_field: o3r,
  salesforce_option: r3r,
  lookup_field_name: i3r,
  salesforce_if_free_email_domain_skip_owner_check: a3r,
  filter_operator_is: s3r,
  filter_operator_is_not: c3r,
  filter_operator_contains: l3r,
  filter_operator_does_not_contain: u3r,
  filter_operator_starts_with: d3r,
  filter_operator_ends_with: _3r,
  filter_operator_is_empty: p3r,
  filter_operator_not_empty: m3r,
  translate_description_button: f3r,
  translate_description_button_description: g3r,
  rr_distribution_method: h3r,
  rr_distribution_method_description: v3r,
  rr_distribution_method_availability_title: b3r,
  rr_distribution_method_availability_description: y3r,
  rr_distribution_method_balanced_title: $3r,
  rr_distribution_method_balanced_description: w3r,
  edit_team_member_weights: k3r,
  weights_updated_successfully: S3r,
  require_confirmation_for_free_email: E3r,
  exclude_emails_that_contain: x3r,
  require_emails_that_contain: C3r,
  exclude_emails_match_found_error_message: T3r,
  require_emails_no_match_found_error_message: A3r,
  search_columns: I3r,
  search_options: O3r,
  disable_org_url_label: N3r,
  disable_org_url_description: z3r,
  single_select: R3r,
  multi_select: P3r,
  calendar_conflict_settings: D3r,
  select_calendars_conflict_check: L3r,
  group_meeting: M3r,
  are_you_sure_you_want_to_remove_this_app_from: F3r,
  disconnect_app_from: q3r,
  salesforce_ignore_guests: j3r,
  google_meet: V3r,
  zoom: B3r,
  office_365_video: U3r,
  lock_attribute_for_assignment: G3r,
  lock_attribute_for_assignment_description: W3r,
  attribute_edited_successfully: H3r,
  new_group_option: Y3r,
  attribute_weight_enabled: K3r,
  attribute_weight_enabled_description: Z3r,
  routed: X3r,
  reassigned: J3r,
  allow_rescheduling_past_events: Q3r,
  allow_rescheduling_past_events_description: eLr,
  rerouted: tLr,
  salesforce_assigned: nLr,
  router_position: oLr,
  show_matching_hosts: rLr,
  no_active_queues: iLr,
  weight: aLr,
  calibration: sLr,
  shortfall: cLr,
  routing_form: lLr,
  go_back_and_save: uLr,
  save_changes: dLr,
  leave_without_saving: _Lr,
  leave_without_saving_description: pLr,
  something_unexpected_occurred: mLr,
  "500_error_message": "Ce n'est pas vous, c'est nous.",
  dry_run_mode_active: fLr,
  icon_showcase: gLr,
  icons_showcase: hLr,
  migrating_from_team: vLr,
  feature_currently_disabled: bLr,
  choose_an_option: yLr,
  enter_option_value: $Lr,
  remove_option: wLr,
  use_attribute_weights: kLr,
  if_enabled_ignore_event_type_weights: SLr,
  attribute_for_weights: ELr,
  managed_users: xLr,
  managed_users_description: CLr,
  can_you_tell_me_about: TLr,
  use_ai_to_answer_your_questions: ALr,
  error_fetching_answer: ILr,
  k_bar_ai_error: OLr,
  select_oAuth_client: NLr,
  on_every_instance: zLr,
  delegation_credential_feature_not_enabled: RLr,
  internal_booking_note: PLr,
  internal_note_cancellation_reason: DLr,
  internal_booking_note_description: LLr,
  internal_note_presets: MLr,
  internal_note_presets_description: FLr,
  internal_note_presets_updated_successfully: qLr,
  add_preset: jLr,
  authorize: VLr,
  next: BLr,
  hide: ULr,
  show: GLr,
  utm_params: WLr,
  no_utm_params: HLr,
  asc: YLr,
  desc: KLr,
  verify_email_change: ZLr,
  buy_credits: XLr,
  credits: JLr,
  credits_used: QLr,
  total_credits_remaining: eMr,
  credits_per_tip_org: tMr,
  credits_per_tip_teams: nMr,
  view_and_manage_credits: oMr,
  view_and_manage_credits_description: rMr,
  credit_worth_description: iMr,
  buy_additional_credits: aMr,
  view_additional_credits_expense_tip: sMr,
  overview: cMr,
  organization_slug_taken: lMr,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: uMr,
  you_need_to_complete_user_onboarding_before_creating_an_organization: dMr,
  use_company_email_to_create_an_organization: _Mr,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: pMr,
  you_need_to_have_minimum_published_teams: mMr,
  you_are_part_of_this_organization_already: fMr,
  you_are_part_of_another_organization_cannot_create_organization: gMr,
  you_are_part_of_another_platform_organization_cannot_create_organization: hMr,
  organization_payment_success: vMr,
  organization_payment_success_description: bMr,
  this_may_take_a_few_seconds: yMr,
  organization_onboarding_status: $Mr,
  organization_onboarding_status_description: wMr,
  payment_failed: kMr,
  payment_failed_description: SMr,
  creating_your_organization: EMr,
  organization_onboarding_already_completed: xMr,
  organization_onboarding_already_exists: CMr,
  organization_onboarding_not_found: TMr,
  payment_successful: AMr,
  handover_onboarding_page_title: IMr,
  handover_onboarding_page_description: OMr,
  organization_already_exists_with_this_slug: NMr,
  you_do_not_have_permission_to_create_an_organization_for_this_email: zMr,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: RMr,
  organization_has_subscription_already: PMr,
  reset_interval_weighted_rr: DMr,
  interval: LMr,
  rr_reset_interval_description: MMr,
  daily: FMr,
  end_date_not_selected: qMr,
  my_ooo: jMr,
  team_ooo: VMr,
  out_of_office_team_description: BMr,
  create_ooo_dialog_team_title: UMr,
  create_ooo_dialog_team_subtitle: GMr,
  edit_ooo_dialog_team_subtitle: WMr,
  ooo_team_empty_title: HMr,
  ooo_team_empty_description: YMr,
  forward_to_team_member_only: KMr,
  ooo_team_redirect_infinite_not_allowed: ZMr,
  previous_ooo_empty_title: XMr,
  previous: JMr,
  rr_interval_successfully_updated: QMr,
  trial_mode: e4r,
  inactive_team_plan: t4r,
  inactive_team_plan_description: n4r,
  limited_access_trial_mode: o4r,
  referral_program: r4r,
  referral_text: i4r,
  dub_disabled_error_message: a4r,
  uid: s4r,
  link: c4r,
  rows_per_page: l4r,
  pagination_status: u4r,
  tip_username_plus: d4r,
  user_has_no_team_yet: _4r,
  no_team_members: p4r,
  recurring_event_doesnt_support_seats: m4r,
  booking_limit_per_booker_doesnt_support_recurring: f4r,
  seats_doesnt_support_recurring: g4r,
  recurring_event_seats_error: h4r,
  segment: v4r,
  saved_filters: b4r,
  rename: y4r,
  rename_segment: $4r,
  delete_segment: w4r,
  duplicate_segment: k4r,
  delete_segment_confirmation: S4r,
  filter_segment_updated: E4r,
  error_updating_filter_segment: x4r,
  filter_segment_duplicated: C4r,
  error_duplicating_filter_segment: T4r,
  filter_segment_deleted: A4r,
  error_deleting_filter_segment: I4r,
  save_segment: O4r,
  segment_not_found: N4r,
  filter_segment_saved: z4r,
  no_segments: R4r,
  error_saving_filter_segment: P4r,
  override_segment: D4r,
  create_new_segment: L4r,
  save_for_team: M4r,
  select_team: F4r,
  please_select_team: q4r,
  personal: j4r,
  hide_team_profile_link: V4r,
  hide_team_profile_link_description: B4r,
  display: U4r,
  could_not_find_slug_to_publish_org: G4r,
  picklist: W4r,
  most_cancelled_bookings: H4r,
  interface_language: Y4r,
  interface_language_description: K4r,
  visitors_browser_language: Z4r,
  name_or_email: X4r,
  salesforce_round_robin_skip_fallback_to_lead_owner: J4r,
  credit_purchase_failed: Q4r,
  minimum_of_credits_required: e5r,
  enable_delegation_credential: t5r,
  enable_delegation_credential_description: n5r,
  disable_delegation_credential: o5r,
  disable_delegation_credential_description: r5r,
  last_active: i5r,
  member_since: a5r,
  last_updated: s5r,
  salesforce_on_cancel_write_to_event: c5r,
  salesforce_on_every_cancellation: l5r,
  report_issue: u5r,
  report_issue_description: d5r,
  open_issue: _5r,
  this_is_your_current_plan: p5r,
  schedule_a_time: m5r,
  this_includes: f5r,
  oauth_client_updated_successfully: g5r,
  oauth_client_not_found: h5r,
  subscribe_to_platform: v5r,
  error_accessing_webhooks: b5r,
  webhook_update_failed: y5r,
  webhook_create_failed: $5r,
  invalid_link: w5r,
  currently_subscribed_to_plan: k5r,
  user_team: S5r,
  client_id_copied: E5r,
  client_secret_copied: x5r,
  maintenance_message: C5r,
  your_payment_failed: T5r,
  check_your_inbox: A5r,
  account_created_premium_not_reserved: I5r,
  email_sent_with_activation_link: O5r,
  activate_account_to_purchase_username: N5r,
  open_in_gmail: z5r,
  dont_see_email: R5r,
  resend_in_seconds: P5r,
  resend: D5r,
  verification_email_sent: L5r,
  select_all_members: M5r,
  select_all_members_tooltip: F5r,
  form_settings: q5r,
  remove_whitelist_status: j5r,
  whitelist_user_workflows: V5r,
  user_workflows_whitelisted: B5r,
  user_workflows_unwhitelisted: U5r,
  date_and_time: G5r,
  email_reminder_upcoming_event_notice: W5r,
  email_reminder_triggered_by_workflow: H5r,
  event_upper_case: Y5r,
  scheduling_by: K5r,
  experience_review_prompt: Z5r,
  improve_customer_experience_message: X5r,
  meeting_satisfaction_question: J5r,
  meeting_not_joined_question: Q5r,
  reschedule_cta_short: e6r,
  hide_organizer_email: t6r,
  platform_customer_cant_create_organization: n6r,
  organization_customer_cant_create_platform: o6r,
  hide_organizer_email_description: r6r,
  you_and_conjunction: i6r,
  select_verified_email: a6r,
  add_verified_email: s6r,
  add_verified_emails: c6r,
  custom_reply_to_email_title: l6r,
  custom_reply_to_email_description: u6r,
  email_survey_triggered_by_workflow: d6r,
  skip_trial: _6r,
  team_trials_skipped_successfully: p6r,
  sms_workflow_consent: m6r,
  routing_preview_more_info_found_insights: f6r,
  results: g6r,
  view_form: h6r,
  sms_opt_out_message: v6r,
  team_credits_low_warning: b6r,
  user_credits_low_warning: y6r,
  action_required_out_of_credits: $6r,
  action_required_user_out_of_credits: w6r,
  low_credits_warning_message: k6r,
  low_credits_warning_message_user: S6r,
  credit_limit_reached_message: E6r,
  credit_limit_reached_message_user: x6r,
  current_credit_balance: C6r,
  current_balance: T6r,
  notification_about_your_booking: A6r,
  monthly_credits: I6r,
  total_credits: O6r,
  remaining_credits: N6r,
  remaining: z6r,
  total: R6r,
  additional_credits: P6r,
  routing_form_next_in_queue: D6r,
  routing_form_select_members_to_email: L6r,
  routing_incomplete_booking_tab: M6r,
  include_no_show_in_rr_calculation: F6r,
  recent_no_show_guests: q6r,
  recent_no_show_guests_tooltip: j6r,
  matching: V6r,
  event_redirect: B6r,
  reset_form: U6r,
  rr_settings_successfully_updated: G6r,
  distribution_basis_weighted_rr: W6r,
  timestamp_basis_description: H6r,
  requires_credits: Y6r,
  requires_credits_tooltip: K6r,
  available_credits: Z6r,
  create_role: X6r,
  roles_and_permissions: J6r,
  roles_and_permissions_description: Q6r,
  learn_more_permissions: eFr,
  role_name: tFr,
  role_name_required: nFr,
  role_name_placeholder: oFr,
  role_description: rFr,
  role_description_placeholder: iFr,
  default_role: aFr,
  custom_role: sFr,
  advanced: cFr,
  search_permissions: lFr,
  all_permissions: uFr,
  none: dFr,
  read_only: _Fr,
  pbac_desc_all_actions_all_resources: pFr,
  pbac_resource_all: mFr,
  pbac_resource_event_type: fFr,
  pbac_resource_team: gFr,
  pbac_resource_organization: hFr,
  pbac_resource_booking: vFr,
  pbac_resource_insights: bFr,
  pbac_resource_role: yFr,
  pbac_resource_routing_form: $Fr,
  pbac_resource_workflow: wFr,
  pbac_action_all: kFr,
  pbac_action_create: SFr,
  pbac_action_read: EFr,
  pbac_action_update: xFr,
  pbac_action_delete: CFr,
  pbac_action_manage: TFr,
  pbac_action_invite: AFr,
  pbac_action_remove: IFr,
  pbac_action_change_member_role: OFr,
  pbac_action_list_members: NFr,
  pbac_action_manage_billing: zFr,
  pbac_action_read_team_bookings: RFr,
  pbac_action_read_org_bookings: PFr,
  pbac_action_read_recordings: DFr,
  pbac_action_impersonate: LFr,
  role_created_successfully: MFr,
  role_updated_successfully: FFr,
  delete_role: qFr,
  confirm_delete_role: jFr,
  role_deleted_successfully: VFr,
  error_creating_role: BFr,
  error_updating_role: UFr,
  pbac_desc_create_roles: GFr,
  pbac_resource_attributes: WFr,
  pbac_desc_view_organization_attributes: HFr,
  pbac_desc_update_organization_attributes: YFr,
  pbac_desc_delete_organization_attributes: KFr,
  pbac_desc_create_organization_attributes: ZFr,
  pbac_desc_view_roles: XFr,
  pbac_desc_update_roles: JFr,
  pbac_desc_delete_roles: QFr,
  pbac_desc_create_workflows: eqr,
  set_up_required: tqr,
  pbac_desc_view_workflows: nqr,
  pbac_desc_update_workflows: oqr,
  pbac_desc_delete_workflows: rqr,
  pbac_resource_webhook: iqr,
  pbac_resource_availability: aqr,
  pbac_resource_out_of_office: sqr,
  pbac_desc_create_webhooks: cqr,
  pbac_desc_view_webhooks: lqr,
  pbac_desc_update_webhooks: uqr,
  pbac_desc_delete_webhooks: dqr,
  pbac_desc_create_availability: _qr,
  pbac_desc_view_availability: pqr,
  pbac_desc_update_availability: mqr,
  pbac_desc_delete_availability: fqr,
  pbac_desc_create_out_of_office: gqr,
  pbac_desc_view_out_of_office: hqr,
  pbac_desc_update_out_of_office: vqr,
  pbac_desc_delete_out_of_office: bqr,
  pbac_desc_manage_workflows: yqr,
  pbac_desc_create_event_types: $qr,
  pbac_desc_view_event_types: wqr,
  pbac_desc_update_event_types: kqr,
  pbac_desc_delete_event_types: Sqr,
  pbac_desc_manage_event_types: Eqr,
  pbac_desc_create_teams: xqr,
  pbac_desc_view_team_details: Cqr,
  pbac_desc_update_team_settings: Tqr,
  pbac_desc_delete_team: Aqr,
  pbac_desc_invite_team_members: Iqr,
  pbac_desc_remove_team_members: Oqr,
  pbac_desc_change_team_member_role: Nqr,
  pbac_desc_impersonate_team_members: zqr,
  pbac_desc_manage_teams: Rqr,
  pbac_desc_create_organization: Pqr,
  pbac_desc_view_organization_details: Dqr,
  pbac_desc_list_organization_members: Lqr,
  pbac_desc_invite_organization_members: Mqr,
  pbac_desc_remove_organization_members: Fqr,
  pbac_desc_manage_organization_billing: qqr,
  pbac_desc_change_organization_member_role: jqr,
  pbac_desc_impersonate_organization_members: Vqr,
  pbac_desc_edit_organization_settings: Bqr,
  pbac_desc_manage_organizations: Uqr,
  pbac_desc_view_bookings: Gqr,
  pbac_desc_view_team_bookings: Wqr,
  pbac_desc_view_organization_bookings: Hqr,
  pbac_desc_view_booking_recordings: Yqr,
  pbac_desc_update_bookings: Kqr,
  pbac_desc_manage_bookings: Zqr,
  pbac_desc_view_team_insights: Xqr,
  pbac_desc_manage_team_insights: Jqr,
  pbac_desc_create_routing_forms: Qqr,
  pbac_desc_view_routing_forms: ejr,
  pbac_desc_update_routing_forms: tjr,
  pbac_desc_delete_routing_forms: njr,
  read_permission_auto_enabled_tooltip: ojr,
  choose_restriction_schedule: rjr,
  restriction_schedule_description: ijr,
  use_booker_timezone: ajr,
  use_booker_timezone_info: sjr,
  load_balancing_warning: cjr,
  rr_load_balancing_disabled: ljr,
  rr_load_balancing_disabled_with_groups: ujr,
  round_robin_settings_description: djr,
  round_robin_settings_updated_successfully: _jr,
  booking_creation_time: pjr,
  meeting_start_time: mjr,
  members_affected_by_disabling_delegation_credential: fjr,
  no_members_affected_by_disabling_delegation_credential: gjr,
  download_expense_log: hjr,
  error_downloading_expense_log: vjr,
  offer_to_reschedule_last_booking: bjr,
  booker_limit_exceeded_error: yjr,
  booker_limit_exceeded_error_reschedule: $jr,
  duration_min_error: wjr,
  duration_max_error: kjr,
  booking_not_allowed_by_restriction_schedule_error: Sjr,
  restriction_schedule_not_found_error: Ejr,
  converted_image_size_limit_exceed: xjr,
  add_group: Cjr,
  routing_funnel: Tjr,
  routing_funnel_total_submissions: Ajr,
  routing_funnel_successful_routings: Ijr,
  routing_funnel_accepted_bookings: Ojr,
  license_key: Njr,
  license_selection_title: zjr,
  license_selection_description: Rjr,
  agplv3_license_description: Pjr,
  enter_license_key: Djr,
  enter_your_license_key: Ljr,
  enter_existing_license: Mjr,
  enter_license_key_description: Fjr,
  license_key_placeholder: qjr,
  save_license_key: jjr,
  signature_token_optional: Vjr,
  signature_token_description: Bjr,
  need_a_license: Ujr,
  license_key_required: Gjr,
  invalid_license_key: Wjr,
  license_validation_failed: Hjr,
  attachments_optional: Yjr,
  send_message: Kjr,
  describe_the_issue: Zjr,
  file_size_limit_exceed: Xjr,
  invalid_file_type: Jjr,
  invalid_file_type_extension: Qjr,
  max_files_exceeded: eVr,
  files_uploaded_successfully: tVr,
  file_upload_instructions: nVr,
  license_key_saved: oVr,
  timezone_mismatch_tooltip: rVr,
  show_optimized_slots: iVr,
  show_optimized_slots_description: aVr,
  failed_bookings_by_field: sVr,
  failed_bookings: cVr,
  event_type_no_hosts: lVr,
  cache_status: uVr,
  cache_last_updated: dVr,
  delete_cached_data: _Vr,
  cache_deleted_successfully: pVr,
  error_deleting_cache: mVr,
  confirm_delete_cache: fVr,
  yes_delete_cache: gVr,
  remainder_of_maximum_uses_left_plural: hVr,
  remainder_of_maximum_use_left_singular: vVr,
  expires_on_date: bVr,
  single_use: yVr,
  time_based_expiration: $Vr,
  usage_based_expiration: wVr,
  number_of_uses: kVr,
  expires_on: SVr,
  max_usage_count: EVr,
  link_settings: xVr,
  link_expired_on_date: CVr,
  usage_limit_reached: TVr,
  usage_count_error: AVr,
  private_link_expired: IVr,
  time_based_expiration_description: OVr,
  time_based_generic_expiration_description: NVr,
  usage_based_expiration_description: zVr,
  usage_based_generic_expiration_description: RVr,
  usage_based_expiration_description_plural: PVr,
  webhook_trigger_event: DVr,
  webhook_created_at: LVr,
  webhook_type: MVr,
  set_up_agent: FVr,
  webhook_title: qVr,
  webhook_start_time: jVr,
  webhook_end_time: VVr,
  webhook_description: BVr,
  webhook_location: UVr,
  webhook_uid: GVr,
  webhook_reschedule_uid: WVr,
  webhook_cancellation_reason: HVr,
  webhook_rejection_reason: YVr,
  webhook_organizer_name: KVr,
  webhook_organizer_email: ZVr,
  webhook_organizer_timezone: XVr,
  webhook_organizer_locale: JVr,
  webhook_organizer_username: QVr,
  webhook_organizer_username_in_org: eBr,
  webhook_attendee_name: tBr,
  webhook_attendee_email: nBr,
  webhook_attendee_timezone: oBr,
  webhook_attendee_locale: rBr,
  webhook_team_name: iBr,
  webhook_team_members: aBr,
  webhook_video_call_url: sBr,
  webhook_hide_variables: cBr,
  webhook_show_variable: lBr,
  webhook_event_and_booking: uBr,
  webhook_people: dBr,
  webhook_teams: _Br,
  webhook_metadata: pBr,
  stats: mBr,
  booking_status: fBr,
  visit: gBr,
  location_custom_label_input_label: hBr,
  meeting_link: vBr,
  session_outcome: bBr,
  call_created: yBr,
  voicemail: $Br,
  my_bookings: wBr,
  phone: kBr,
  free: SBr,
  user_email: EBr,
  user_name: xBr,
  expand_panel: CBr,
  collapse_panel: TBr,
  email_verification_required: ABr,
  invalid_verification_code: IBr,
  you_have_one_team: OBr,
  consider_consolidating_one_team_org: NBr,
  consider_consolidating_multi_team_org: zBr,
  message_sent: RBr,
  support_message_sent_description: PBr,
  search_variables: DBr,
  support_message_placeholder: LBr,
  send_another_message: MBr,
  sending: FBr,
  no_variables_found: qBr,
  credits_required: jBr,
  web_call_credits_info: VBr,
  web_call_no_credits: BBr,
  purchase_credits: UBr,
  credits_required_tooltip: GBr,
  api_key_name_too_long: WBr,
  auto_charge_for_last_minute_cancellation: HBr,
  before_scheduled_start_time: YBr,
  cancel_booking_acknowledge_no_show_fee: KBr,
  contact_organizer: ZBr,
  booking_time_option: XBr,
  booking_time_option_description: JBr,
  created_at_option: QBr,
  created_at_option_description: e9r,
  call_details: t9r,
  call_id: n9r,
  call_information: o9r,
  sentiment: r9r,
  disconnect_reason: i9r,
  call_summary: a9r,
  transcription: s9r,
  event_details: c9r,
  agent: l9r,
  no_transcript_available: u9r,
  testing_sms_workflow_info_message: d9r,
  start_from_scratch_title: _9r,
  start_from_scratch_description: p9r,
  cal_ai_template_title: m9r,
  cal_ai_template_description: f9r,
  voice: g9r,
  select_voice: h9r,
  select_voice_for_agent: v9r,
  choose_a_voice_for_your_agent: b9r,
  trait: y9r,
  voice_id: $9r,
  use_voice: w9r,
  current_voice: k9r,
  setup_incoming_agent: S9r,
  setup_incoming_agent_description: E9r,
  connect_a_phone_number_first: x9r,
  setup_agent_for_incoming_calls: C9r,
  configure_agent_to_handle_incoming_calls: T9r,
  incoming_calls: A9r,
  outgoing_calls: I9r,
  inbound_agent_setup_success: O9r,
  inbound_agent_configured: N9r,
  setup_inbound_agent: z9r,
  please_select_event_type_first: R9r,
  edit_configuration: P9r,
  select_event_type_for_inbound_calls: D9r,
  setup_inbound_agent_for_incoming_calls: L9r,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: M9r
}, q9r = "Provider di identità", j9r = 'Ti rimangono $t(day, {"count": {{days}} }) di prova con il piano PRO', V9r = "{{count}} giorno", B9r = "{{count}} giorni", U9r = "{{count}} secondo", G9r = "{{count}} secondi", W9r = "Cambia piano", H9r = "Senza titolo", Y9r = "Accetta Invito", K9r = "Caratteri max.", Z9r = "Caratteri min.", X9r = "{{appName}} fornisce un'infrastruttura di panificazione aperta a tutti.", J9r = "Completa la configurazione del tuo account {{appName}}! Sei a pochi passi dalla soluzione di tutti i tuoi problemi di pianificazione.", Q9r = "Hai domande? Siamo qui per aiutare.", eUr = "{{appName}}: istruzioni per reimpostare la password", tUr = "{{appName}}: verifica il tuo account", nUr = "{{appName}}: Verifica la tua email", oUr = "Controlla la tua e-mail", rUr = "Vecchio indirizzo email", iUr = "Nuovo indirizzo email", aUr = "Abbiamo inviato un'e-mail a {{email}}. È importante verificare il tuo indirizzo e-mail per garantire la consegna delle e-mail e delle notifiche del calendario {{appName}}.", sUr = "Verifica il tuo indirizzo e-mail per garantire la consegna delle e-mail e delle notifiche del calendario", cUr = "Verifica il tuo indirizzo e-mail", lUr = "Verifica email", uUr = "Assistente", dUr = "Invia email con trascrizione video Cal", _Ur = "Invia email con la trascrizione del video Cal dopo la fine della riunione. (Richiede un piano a pagamento)", pUr = "Hai recentemente chiesto di cambiare l'indirizzo email che utilizzi per accedere al tuo account {{appName}}. Fai clic sul pulsante qui sotto pe confermare il tuo nuovo indirizzo email.", mUr = "Indirizzo email aggiornato: {{email}}", fUr = "Aggiornamento email non riuscito.", gUr = "Verifica il tuo nuovo indirizzo email per {{appName}}", hUr = "Abbiamo inviato un link di verifica a {{email}}. Aggiorneremo il tuo indirizzo email quando farai clic sul link.", vUr = "Salva questa chiave API in un posto sicuro. Non potrai visualizzarla in seguito.", bUr = "Verifica il tuo indirizzo e-mail facendo clic sul pulsante qui sotto.", yUr = "Verifica il tuo indirizzo e-mail utilizzando il codice sottostante.", $Ur = "Se non ti piacciono i pulsanti, puoi usare questo link:", wUr = "Inserisci il codice di verifica", kUr = "Inserisci il codice di verifica che hai ricevuto via e-mail", SUr = "Il codice di verifica è errato.", EUr = "Email inviata", xUr = "Si è verificato un errore durante l'invito dell'e-mail", CUr = "Rifiutato: {{title}} il {{date}}", TUr = "Cancellato: {{title}} il {{date}}", AUr = "Riassegnato: {{title}} il {{date}}", IUr = "La tua richiesta per l'evento è stata rifiutata", OUr = "Personalizza impostazioni Cal Video", NUr = "Configura le preferenze per le riunioni video, incluse le autorizzazioni di registrazione per host e partecipanti.", zUr = "Disabilita registrazione per gli ospiti", RUr = "Abilita la trascrizione automatica dopo l'ingresso alla riunione", PUr = "Abilita registrazione automatica dopo che l'organizzatore si unisce alla riunione", DUr = "Opzioni video", LUr = "Modifica evento", MUr = "Visualizza dettagli sessione", FUr = "Dettagli della sessione di riunione", qUr = "Sessione di riunione", jUr = "ID sessione", VUr = "Numero massimo di partecipanti", BUr = "Illimitato", UUr = "In corso", GUr = "Terminata", WUr = "Partecipanti", HUr = "Utente anonimo", YUr = "Durata della sessione", KUr = "Nessuna sessione di riunione trovata", ZUr = "Non disponibile", XUr = "Disabilita registrazione per l'organizzatore", JUr = "Disabilita la trascrizione per gli ospiti", QUr = "Disabilita la trascrizione per l'organizzatore", eGr = "La tua richiesta per l'evento ricorrente è stata rifiutata", tGr = "Il tuo evento programmato è stato cancellato", nGr = "Il tuo evento programmato è stato riassegnato", oGr = "L'evento non sarà più presente nel tuo calendario e la tua probabilità di round robin non sarà influenzata negativamente", rGr = "Organizzatore", iGr = "Riassegnato a", aGr = "È necessario riprogrammare o annullare?", sGr = "Puoi visualizzare i dettagli della prenotazione da questo URL {{url}} e aggiungere l'evento al tuo calendario", cGr = "Nessuna opzione disponibile", lGr = "Motivo dell'annullamento (facoltativo)", uGr = "Cancellato da", dGr = "Motivo della cancellazione", _Gr = "Perché stai annullando?", pGr = "Il motivo della cancellazione sarà condiviso con gli ospiti", mGr = "Perché stai rifiutando?", fGr = "Motivo del rifiuto", gGr = "Rifiutare la richiesta di prenotazione?", hGr = "Sei sicuro di voler rifiutare la prenotazione? Informeremo la persona che ha cercato di prenotare. Puoi indicare il motivo qui sotto.", vGr = "Rifiuta la prenotazione", bGr = "Gestisci questo evento", yGr = "Invia un membro del team", $Gr = "Invita una persona", wGr = "Importazione in blocco", kGr = "Inv.", SGr = "Il tuo evento è stato programmato", EGr = "Il tuo evento ricorrente è stato programmato", xGr = "Accetta la nostra licenza cambiando la variabile .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> a '{{agree}}'.", CGr = "Per rimuovere questo banner, apri il tuo file .env e cambia la variabile <1>NEXT_PUBLIC_LICENSE_CONSENT</1> in '{{agree}}'.", TGr = "Il messaggio di errore era: '{{errorMessage}}'", AGr = "Rimborso non riuscito: {{name}} - {{date}} - {{eventType}}", IGr = "Il rimborso per l'evento {{eventType}} di {{userName}} del {{date}} non è riuscito.", OGr = "Verifica con il tuo fornitore di servizi di pagamento e {{user}} come gestirlo.", NGr = "Un rimborso non è riuscito", zGr = "In attesa del pagamento: {{title}} il {{date}}", RGr = "La tua riunione è in attesa di pagamento", PGr = "Il colore del tema scuro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore in modo che i pulsanti siano più visibili.", DGr = "Il colore del tema chiaro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore in modo che i pulsanti siano più visibili.", LGr = "Il colore del tema chiaro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore affinché il colore dei tuoi tipi di evento sia più visibile.", MGr = "Il colore del tema scuro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore affinché il colore dei tuoi tipi di evento sia più visibile.", FGr = "Non è stato possibile creare il pagamento", qGr = "Non è stato possibile addebitare la carta per il pagamento", jGr = "Nessun utente disponibile. Puoi provare un altro intervallo temporale?", VGr = "La fascia oraria selezionata non è più disponibile. <0>Seleziona un nuovo orario</0>", BGr = "Occupato", UGr = "Ti sei appena connesso. Prenota dagli slot sopra indicati o riprova più tardi.", GGr = "Intervallo non disponibile", WGr = "Non è possibile prenotare questo tipo di evento in questo momento. Potresti provare un altro orario?", HGr = "Errore interno. La richiesta non contiene l'ora finale", YGr = "Impossibile creare l'evento nel calendario dell'organizzatore", KGr = "Impossibile aggiornare l'evento nel calendario.", ZGr = "Impossibile eliminare l'evento dal calendario.", XGr = "Ti sei già registrato per questa prenotazione.", JGr = "Alcuni degli organizzatori non sono disponibili per la prenotazione.", QGr = "Alcuni degli host fissi non sono disponibili per la prenotazione.", eWr = "L'host Round Robin non è disponibile per la prenotazione.", tWr = "Guida", nWr = "Prezzo", oWr = "Pagato", rWr = "Rimborsato", iWr = "Registra", aWr = "Trascrivi", sWr = "Pagamento", cWr = "Campi della carta mancanti", lWr = "Paga ora", uWr = "General Prompt", dWr = "Trascrizione alimentata dall'IA", _Wr = "Avvia o interrompi la registrazione", pWr = "Inizia messaggio", mWr = "Il codebase deve rimanere open source, che sia stato modificato o meno", fWr = "Non è possibile rimontare o vendere il codebase", gWr = "Acquista una licenza commerciale per rimuovere questi termini via email", hWr = "Riassunto dei termini", vWr = "Apri .env e accetta la nostra licenza", bWr = "Ho cambiato il mio .env", yWr = "Accetta Licenza", $Wr = "Un evento è ancora in attesa di approvazione", wWr = "La richiesta d'evento è ancora in attesa: {{attendeeName}} - {{date}} - {{eventType}}", kWr = 'Nessun risultato trovato per "{{searchTerm}}"', SWr = "Nessun altro risultato", EWr = "Nessun risultato", xWr = "Carica più risultati", CWr = "{{integrationName}} meeting ID: {{meetingId}}", TWr = "Confermato: {{eventType}} con {{name}} il {{date}}", AWr = "Richiesta di nuovo evento: {{attendeeName}} - {{date}} - {{eventType}}", IWr = "Conferma o rifiuta la richiesta", OWr = "Controlla la pagina delle prenotazioni per confermare o rifiutare la prenotazione.", NWr = "Assistente Check-in", zWr = "Effettua una chiamata in uscita per verificare se l'appuntamento programmato è confermato o se desideri riprogrammare.", RWr = "Crea il tuo prompt e usalo per effettuare una chiamata in uscita.", PWr = "Un evento aspetta la tua approvazione", DWr = "Un evento ricorrente è in attesa della tua approvazione", LWr = "Qualcuno ha richiesto di programmare un evento sul tuo calendario.", MWr = "Qualcuno ha richiesto un link per cambiare la tua password.", FWr = "Se questo indirizzo e-mail esiste nel nostro sistema, riceverai un'e-mail per la reimpostazione.", qWr = "Se non l'hai richiesto, puoi tranquillamente ignorare questa email e la tua password non verrà modificata.", jWr = "In attesa di approvazione: {{title}} il {{date}}", VWr = "Un evento è ancora in attesa della tua approvazione", BWr = "Prenotazione inviata: {{title}} il {{date}}", UWr = "Scarica registrazione: {{title}} alle {{date}}", GWr = "Scarica trascrizione: {{title}} il {{date}}", WWr = "Scarica la tua registrazione", HWr = "Scarica le trascrizioni", YWr = "Il tuo meeting è stata prenotato", KWr = "Il tuo {{title}} è stato riprogrammato per il {{date}}.", ZWr = "Il tuo {{title}} è stato aggiornato.", XWr = "Aggiornato: il tuo evento è stato riprogrammato", JWr = "L'evento è stato aggiornato", QWr = "Il tuo evento è stato riprogrammato", e8r = "{{organizer}} ha cancellato la prenotazione e ti ha chiesto di scegliere un altro orario.", t8r = "Hai richiesto a {{attendee}} di riprogrammare", n8r = "Hai cancellato la prenotazione e {{attendee}} deve selezionare un nuovo orario per la prenotazione.", o8r = "Richiesta di riprogrammazione inviata: {{eventType}} con {{name}} il {{date}}", r8r = "Azione richiesta per la riprogrammazione: prenota un nuovo orario per {{eventType}} con {{name}}", i8r = "Ciao {{name}}", a8r = "{{eventType}} con {{name}}", s8r = "Sembra che tutti i nostri esperti siano occupati al momento. Ti invitiamo a programmare una chiamata in un momento che ti sia più comodo e saremo pronti ad assisterti.", c8r = "Programma invece", l8r = "Richiesta di nuovo evento: {{attendeeName}} - {{date}} - {{eventType}}", u8r = "Entra da {{entryPoint}}", d8r = "Osservazioni", _8r = "Gestisci le mie prenotazioni", p8r = "Hai bisogno di fare una modifica?", m8r = "Un nuovo evento è stato riprogrammato.", f8r = "È stato programmato un nuovo evento ricorrente.", g8r = "Email dell'invitato", h8r = "Fuso Orario dell' invitato", v8r = "Tempo rimanente", b8r = "Tipo di Evento", y8r = "Duplica tipo di evento", $8r = "Inserisci Riunione", w8r = "Provider di videochiamate", k8r = "Meeting ID", S8r = "Password del meeting", E8r = "URL del Meeting", x8r = "URL della riunione non trovato", C8r = "Token non trovato", T8r = "Un altro host ha già accettato la riunione. Vuoi comunque partecipare? <0>Continua alla riunione</0>", A8r = "La tua richiesta di riunione è stata rifiutata", I8r = "Rifiutato: {{eventType}} con {{organizer}} il {{date}}", O8r = "Ciao", N8r = "Unisciti al team", z8r = "Gestisci questo team", R8r = "Informazioni sul team", P8r = "Partecipa alla riunione", D8r = "Se preferisci non usare {{toEmail}} come email {{appName}} o già hai un account {{appName}}, per favore richiedi un altro invito a quella email.", L8r = "Sei stato invitato ad unirti al team {{teamName}}", M8r = "{{user}} ti ha invitato a unirti a {{entity}} {{team}} su {{appName}}", F8r = "Sei nascosto in questo team", q8r = "Il tuo posto non è pagato. Passa a Pro oppure informa il proprietario del team che può pagare il tuo posto.", j8r = "Per utilizzare i team ti occorre un account Pro. Sarai nascosto finché non cambierai piano.", V8r = "p.s. Scade tra {{expiresIn}} ore.", B8r = "Passa al piano Per-posto", U8r = "L'opzione di prenotazione dei posti non è disponibile per le prenotazioni che richiedono conferma", G8r = "Le ubicazioni multiple non sono compatibili con l'opzione di prenotazione dei posti", W8r = "La penale per mancata presentazione non è compatibile con l'opzione di prenotazione dei posti", H8r = "L'opzione di prenotazione dei posti non supporta ubicazioni multiple", Y8r = "Per i {{memberCount}} membri del tuo team, {{unpaidCount}} posti non sono pagati. A € {{seatPrice}}/m per posto, il costo totale stimato della tua adesione è di € {{totalCost}}/m.", K8r = `Grazie per aver provato il nostro piano team. Abbiamo notato che è necessario effettuare l'upgrade del tuo team "{{teamName}}".`, Z8r = "Effettua l'upgrade", X8r = "Il tuo team è stato aggiornato!", J8r = `Grazie per aver provato il nostro piano Organization. Abbiamo notato che è necessario eseguire l'upgrade del piano Organization per "{{teamName}}".`, Q8r = "È stato eseguito l'upgrade del piano Organization!", e7r = "Usa il link qui sotto per reimpostare la tua password", t7r = "Ciao", n7r = "lì", o7r = "Hai dimenticato la password? - {{appName}}", r7r = "Sei sicuro di voler eliminare questo webhook? Non riceverai più {{appName}} dati di riunione in un URL specificato, in tempo reale, quando un evento è programmato o annullato.", i7r = "Sì, elimina webhook", a7r = "Modifica Webhook", s7r = "Elimina Webhook", c7r = "Stato Webhook", l7r = "Webhook Abilitato", u7r = "Webhook Disabilitato", d7r = "Risposta Webhook", _7r = "Test Webhook", p7r = "Modulo di aggiornamento webhook", m7r = "Aggiungi un webhook al tuo OAuthClient.", f7r = "Gestisci il tuo webhook", g7r = "Webhook creato con successo!", h7r = "Webhook aggiornato con successo!", v7r = "Webhook rimosso con successo!", b7r = "Abbonamento necessario", y7r = "Non sei abbonato a un piano Platform.", $7r = "Modello di Payload", w7r = "Ignora", k7r = "Ancora nessun dato", S7r = "Test Ping", E7r = "Aggiungi questa app alla schermata iniziale per un accesso più veloce e un'esperienza migliore.", x7r = "Prossimi", C7r = "Ricorrente", T7r = "Passati", A7r = "Scegli un file...", I7r = "Carica immagine", O7r = "Carica {{target}}", N7r = "Nessun {{target}}", z7r = "Scorri per ingrandire, trascina per riposizionare", R7r = "Visualizza notifiche", P7r = "Visualizza la pagina pubblica", D7r = "Copia link della pagina pubblica", L7r = "Copia il link di riferimento", M7r = "Esci", F7r = "Aggiungi un altro", q7r = "Installane un'altra", j7r = "fino a", V7r = "offerto da", B7r = "Non Disponibile", U7r = "Imposta il tuo programma di lavoro", G7r = "Cambia quando sei disponibile per le prenotazioni", W7r = "Seleziona...", H7r = "Testo", Y7r = "Il tuo numero di telefono", K7r = "Testo Multilinea", Z7r = "Numero", X7r = "Casella di controllo", J7r = "È obbligatorio", Q7r = "Rendi questo campo obbligatorio", eHr = "Obbligatorio", tHr = "Facoltativo", nHr = "Tipo di input", oHr = "Rifiutato", rHr = "Non Confermato", iHr = "Ospiti", aHr = "Ospite", sHr = "Dettagli della conferenza web da seguire.", cHr = "Conferma", lHr = "Cosa deve fornire chi prenota per ricevere le conferme", uHr = "Username", dHr = "è ancora disponibile.", _Hr = "Documentazione", pHr = "Scopri come integrare i nostri strumenti con la tua app", mHr = "Riferimento API", fHr = "Un riferimento API completo per le nostre librerie", gHr = "Blog", hHr = "Leggi le nostre ultime notizie e articoli", vHr = "Unisciti alla nostra community", bHr = "Pagine popolari", yHr = "Registrati ora", $Hr = "Registrati", wHr = "Questa pagina non esiste.", kHr = "Nessun numero di telefono attivo disponibile", SHr = "Passaggio del flusso di lavoro non configurato", EHr = "Controlla gli errori di ortografia o torna alla pagina precedente.", xHr = "Non siamo riusciti a trovare l'evento che stai cercando di prenotare.", CHr = "Stiamo iniziando", THr = "Parola segreta", AHr = "Lasciare vuoto per rimuovere la parola segreta", IHr = "Per motivi di sicurezza, assicurati che il tuo server riceva soltanto le richieste previste di {{appName}}", OHr = "Riunione Segreta", NHr = "Effettua il login invece", zHr = "Crea Account", RHr = "Inizia", PHr = "Conferma password", DHr = "Imposta la nuova password seguendo le istruzioni che ti sono state inviate via e-mail.", LHr = "Carica un'immagine larga {{width}} e alta {{height}}.", MHr = "Accedi di nuovo con il nuovo indirizzo e-mail e la nuova password.", FHr = "Crea il tuo account", qHr = "Crea il tuo accout Cal.com", jHr = "Registrati", VHr = "Hai fatto il log out", BHr = "Speriamo di rivederti presto!", UHr = "Hai fatto il log out", GHr = "Si prega di riprovare e contattarci se il problema persiste.", WHr = "Il codice a due fattori non è corretto.", HHr = "Nessun account esiste corrispondente a quell'indirizzo email.", YHr = "Crea il tuo account", KHr = "Non hai un account?", ZHr = "Accedi al tuo account", XHr = "Accedi", JHr = "Torna alla pagina di accesso", QHr = "Si è verificato un errore durante il login. Torna alla schermata di accesso e riprova.", eYr = "Invia email di ripristino", tYr = "Invia invito", nYr = "Password dimenticata?", oYr = "Dimenticato?", rYr = "Fatto", iYr = "Operazione completata!", aYr = "Tutte", sYr = "Il tuo account", cYr = "Applicazioni disponibili", lYr = "Applicazioni disponibili", uYr = "Visualizza le app popolari qui sotto ed esplora altre nel nostro <0>App Store</0>", dYr = "Aggiungi chiunque debba partecipare all'evento. <0>Scopri di più</0>", _Yr = "Le persone in un gruppo fanno a turno, una persona di ciascun gruppo si presenterà all'evento.", pYr = "Le persone nel gruppo fanno a turno e una sola persona si presenterà all'evento.", mYr = "Controlla la tua email. Ti abbiamo inviato un link per reimpostare la password.", fYr = "Fine", gYr = "Gestisci le impostazioni della lingua e del fuso orario per il tuo team", hYr = "Alcune frasi su di te. Questo apparirà sulla tua pagina url personale.", vYr = "Ci siamo quasi", bYr = "Ultima cosa, una breve descrizione su di te e una foto aiutano davvero a ottenere prenotazioni e a far sapere alle persone con chi stanno prenotando.", yYr = "Definisci intervalli di tempo di quando sei disponibile su una base ricorrente. Puoi crearne di più in seguito e assegnarli a calendari diversi.", $Yr = "Imposta la tua disponibilità", wYr = "Programma gli orari in cui vuoi essere prenotato.", kYr = "Condividi o pubblica un link", SYr = "Condividi il tuo link {{appName}} o inseriscilo nel tuo sito.", EYr = "Impostazioni di disponibilità", xYr = "Continua senza calendario", CYr = "Continua con {{appName}}", TYr = "Collega il tuo calendario", AYr = "Collega le tue applicazioni video", IYr = "Collega le tue applicazioni video per utilizzarle per i tuoi tipi di evento.", OYr = "Collega il tuo calendario per verificare automaticamente gli orari occupati e i nuovi eventi man mano che vengono programmati.", NYr = "Configura più tardi", zYr = "Orario corrente", RYr = "Dettagli", PYr = "Benvenuto", DYr = "Bentornato", LYr = "Benvenuto in {{appName}}", MYr = "Dicci come vuoi essere chiamato e facci sapere in quale fuso orario ti trovi. Potrai modificare queste informazioni in seguito.", FYr = "Connetti al server CalDav", qYr = "Collega a un feed ICS", jYr = "Connetti", VYr = "Provalo gratuitamente", BYr = "Crea il tuo link di prenotazione con {{appName}}", UYr = "Chi", GYr = "Cosa", WYr = "Quando", HYr = "Dove", YYr = "Aggiungi al calendario", KYr = "Seleziona dove aggiungere gli eventi quando vieni prenotato.", ZYr = "Aggiungi eventi a", XYr = "Aggiungi un altro calendario", JYr = "Altro", QYr = "Link di accesso a {{appName}}", eKr = "Avrai un incontro con {{user}}. Abbiamo inviato a tutti un'email di invito contenente tutte le informazioni.", tKr = "{{host}} si incontra con {{attendee}}. Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti.", nKr = "Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti.", oKr = "Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti per il primo di questi eventi ricorrenti.", rKr = "Ti incontri con {{user}}. Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti per il primo di questi eventi ricorrenti.", iKr = "{{host}} si incontra con {{attendee}}. Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti per il primo di questi eventi ricorrenti.", aKr = "Tu e tutti gli altri partecipanti siete stati invitati via email con queste informazioni.", sKr = "La tua prenotazione deve ancora essere confermata o rifiutata.", cKr = "La tua riunione ricorrente deve ancora essere confermata o rifiutata.", lKr = "{{user}} deve ancora confermare o rifiutare la prenotazione.", uKr = "{{user}} deve ancora confermare o rifiutare ciascuna prenotazione della riunione ricorrente.", dKr = "Questo incontro è in programma", _Kr = "Gli eventi ricorrenti sono programmati", pKr = "Prenotazione Inviata", mKr = "La tua riunione ricorrente è stata inviata", fKr = "Prenotazione Confermata", gKr = "La tua riunione ricorrente è stata confermata", hKr = "I pagamenti per gli eventi ricorrenti non sono ancora supportati", vKr = "I pagamenti per gli eventi ricorrenti non sono ancora supportati", bKr = "Inserisci la nuova password che desideri per il tuo account.", yKr = "Reimposta Password", $Kr = "Cambia la tua password", wKr = "Mostra password", kKr = "Nascondi password", SKr = "Prova Di Nuovo", EKr = "Quella richiesta è scaduta.", xKr = "Inserisci l'indirizzo email associato al tuo account e ti invieremo un link per reimpostare la password.", CKr = "La richiesta è scaduta. Torna indietro e inserisci l'email associata al tuo account e ti invieremo un altro link per reimpostare la password.", TKr = "Oops", AKr = "Login", IKr = "Riuscito", OKr = "Fallito", NKr = "La tua password è stata reimpostata. Ora puoi accedere con la tua password appena creata.", zKr = "Layout", RKr = "Vista predefinita", PKr = "Puoi selezionarne diverse e le persone che prenotano possono cambiare visualizzazione.", DKr = "Layout prenotazioni", LKr = "Puoi selezionarne diverse e le persone che prenotano possono cambiare visualizzazione. È possibile definire impostazioni specifiche per ciascun evento.", MKr = "Mese", FKr = "Settimanale", qKr = "Colonna", jKr = "Deve essere abilitato almeno un layout.", VKr = "Il layout selezionato come vista predefinita non è tra quelli abilitati.", BKr = "Il layout selezionato non è un layout valido.", UKr = "Puoi gestire questo per tutti i tuoi tipi di eventi in Impostazioni -> <0>Aspetto</0> o <1>Sovrascrivi</1> solo per questo evento.", GKr = "Si è verificato un errore imprevisto. Riprova.", WKr = "Ora non valida la domenica", HKr = "Ora non valida il lunedì", YKr = "Ora non valida il martedì", KKr = "Ora non valida il mercoledì", ZKr = "Ora non valida il giovedì", XKr = "Ora non valida il venerdì", JKr = "Ora non valida il sabato", QKr = "L'ora di conclusione non può precedere l'ora di inizio", eZr = "L'ora di conclusione non può essere maggiore di 24 ore", tZr = "Torna alle prenotazioni", nZr = "Sentiti libero di scegliere un altro evento in qualsiasi momento.", oZr = "Cancellato", rZr = "Nessuna prenotazione", iZr = "In attesa dell'host", aZr = "Cancellazione riuscita", sZr = "Davvero vuoi annullare la prenotazione?", cZr = "Non puoi annullare questa prenotazione", lZr = "Invece, lo potresti riprogrammare.", uZr = "L'evento è nel passato", dZr = "L'evento è un'istanza di un evento ricorrente.", _Zr = "Queste sono tutte le istanze rimanenti dell'evento ricorrente.", pZr = "Si è verificato un errore con il codice di stato {{status}}.", mZr = "Esiste già un tipo di evento con questo URL.", fZr = "Non puoi creare questo evento", gZr = "Non puoi modificare questo evento", hZr = "Non puoi creare questo flusso di lavoro", vZr = "Non puoi creare questo programma", bZr = "Questa prenotazione è stata già cancellata", yZr = "Questa prenotazione è già stata accettata o rifiutata", $Zr = "Torna alla home", wZr = "Torna alla home", kZr = "Nessuna Riunione Trovata", SZr = "Questa riunione non esiste. Contatta il proprietario della riunione per un link aggiornato.", EZr = "Nessuna prenotazione in {{status}}", xZr = "Non hai {{status}} prenotazioni. {{description}}", CZr = "{{eventName}} tra {{host}} e {{attendeeName}}", TZr = "Prenotazioni", AZr = "Prenotazione non trovata", IZr = "Vedi gli eventi imminenti e passati prenotati attraverso i link di tipo evento.", OZr = "Non appena qualcuno prenota una riunione con voi apparirà qui.", NZr = "Quando qualcuno prenoterà una riunione ricorrente con te, la riunione apparirà qui.", zZr = "Le tue prenotazioni passate appariranno qui.", RZr = "Le prenotazioni cancellate appariranno qui.", PZr = "Le tue prenotazioni non confermate appariranno qui.", DZr = "Prenotazioni non confermate", LZr = "su", MZr = "e", FZr = "Il tuo calendario ti mostra come occupato tra", qZr = "Risoluzione Dei Problemi", jZr = "Capisci perché determinati tempi sono disponibili e altri sono bloccati.", VZr = "Ecco una panoramica della tua giornata", BZr = "Suggerimento: Passa sui tempi in grassetto per un timestamp completo", UZr = "Ora di inizio", GZr = "Ora di fine", WZr = "Tempo buffer", HZr = "Prima dell'evento", YZr = "Dopo l'evento", KZr = "Nessun tempo buffer", ZZr = "Buffer", XZr = "La tua giornata inizia alle", JZr = "La tua giornata termina alle", QZr = "Avvia la risoluzione dei problemi", eXr = "Risolvi i problemi della vostra disponibilità per esplorare il motivo per cui i vostri orari di disponibilità si stanno mostrando come sono.", tXr = "Cambia gli orari disponibili", nXr = "Cambia gli orari disponibili", oXr = "Cambia gli orari di inizio e fine della giornata", rXr = "Imposta l'ora di inizio e di fine della giornata e un buffer minimo tra le riunioni.", iXr = "Attualmente, il tuo giorno è impostato per iniziare a", aXr = "Gli orari di inizio e di fine della giornata sono stati modificati con successo.", sXr = "e termina a", cXr = "Chiaro", lXr = "Scuro", uXr = "Regola automaticamente il tema in base alle preferenze dell'invito", dXr = "Alcuni degli utenti del gruppo hanno attualmente disabilitato le prenotazioni di gruppo dinamiche", _Xr = "È possibile creare dinamicamente collegamenti a prenotazioni di gruppo inserendo più nomi utente separati da '+'. Esempio: '{{appName}}/bailey+peer'", pXr = "Consenti ai partecipanti di prenotare per te utilizzando le prenotazioni di gruppo dinamiche", mXr = "Collegamenti dinamici di gruppo", fXr = "Consenti ai motori di ricerca di accedere ai tuoi contenuti pubblici", gXr = "Consenti l'indicizzazione dei motori di ricerca", hXr = "Consenti notifiche del browser", vXr = "Hai negato le notifiche. Reimposta i permessi nelle impostazioni del browser per abilitarle.", bXr = "Disabilita notifiche del browser", yXr = "Notifiche del browser attivate", $Xr = "Notifiche del browser disattivate", wXr = "Notifiche del browser negate", kXr = "Consenti le notifiche dal prompt", SXr = "Notifiche push", EXr = "Ricevi notifiche push quando un utente invia una prenotazione immediata di un incontro.", xXr = "Il tuo browser non supporta le notifiche push. Se usi Brave, abilita l'opzione `Usa i servizi di Google per la messaggistica push` su brave://settings/?search=push+messaging", CXr = "Email", TXr = "jdoe@example.com", AXr = "Nome completo", IXr = "Sfoglia la nostra documentazione API", OXr = "Sfrutta la nostra API per il pieno controllo e la personalizzabilità.", NXr = "Crea Webhook", zXr = "Riunione immediata creata", RXr = "Prenotazione cancellata", PXr = "Prenotazione Riprogrammata", DXr = "Il link per scaricare la registrazione è pronto", LXr = "Trascrizione generata", MXr = "Prenotazione Creata", FXr = "Prenotazione Rifiutata", qXr = "Richiesta di prenotazione inviata", jXr = "Pagamento della prenotazione iniziato", VXr = "Riunione terminata", BXr = "Modulo inviato", UXr = "Modulo inviato, nessun evento prenotato", GXr = "Prenotazione pagata", WXr = "Fuori sede creato", HXr = "Prenotazione No-Show aggiornata", YXr = "Attivatori Evento", KXr = "URL abbonato", ZXr = "Crea un nuovo webhook", XXr = "Webhook", JXr = "Webhook del team", QXr = "Crea un nuovo webhook sul tuo account", eJr = "Nuovo Webhook", tJr = "Ricevi i dati delle riunioni {{appName}} a un URL specificato in tempo reale quando un evento viene programmato o cancellato.", nJr = "Ricevi i dati della riunione {{appName}} a un URL specificato in tempo reale quando questo evento viene programmato o cancellato.", oJr = "Iframe full screen responsive", rJr = "Caricamento...", iJr = "Eliminazione...", aJr = "Iframe standard", sJr = "Sviluppatore", cJr = "Gestisci le impostazioni sviluppatore.", lJr = "iframe Incorporato", uJr = "Il modo più semplice per incorporare {{appName}} sul tuo sito web.", dJr = "Integra con il tuo sito web utilizzando le nostre opzioni incorporate, o ottieni informazioni di prenotazione in tempo reale utilizzando webhooks personalizzati.", _Jr = "Pianifica una riunione", pJr = "Visualizza e gestisci i tuoi dettagli di fatturazione", mJr = "Visualizza e modifica i tuoi dati di fatturazione, puoi anche modificare la tua subcription.", fJr = "Vai al portale di fatturazione", gJr = "Hai bisogno di altro?", hJr = "Se hai bisogno di ulteriore aiuto per la fatturazione, il nostro team di supporto è qui per aiutarti.", vJr = "Contatta", bJr = "il nostro team di supporto", yJr = "Contatta il nostro team di supporto", $Jr = "Uh oh!", wJr = "Questo utente non ha ancora impostato alcun tipo di evento.", kJr = "Modifica logo", SJr = "Carica un logo", EJr = "Carica logo", xJr = "Rimuovi logo", CJr = "Abilita", TJr = "Codice", AJr = "Il codice non è corretto.", IJr = "Aggiungi nuova fascia oraria", OJr = "Aggiungi un ulteriore livello di sicurezza al tuo account nel caso in cui la password venga rubata.", NJr = "Abilita autenticazione a due fattori", zJr = "Disabilita autenticazione a due fattori", RJr = "Se è necessario disattivare 2FA, si consiglia di riattivarlo il prima possibile.", PJr = "Disabilita autenticazione a due fattori", DJr = "Disabilita autenticazione a due fattori", LJr = "Sicurezza", MJr = "Gestisci la sicurezza del tuo account.", FJr = "Password", qJr = "Webhook aggiornato con successo", jJr = "La password è stata cambiata con successo.", VJr = "Errore nel cambiare la password", BJr = "La configurazione della sessione è stata aggiornata correttamente.", UJr = "Errore durante l'aggiornamento della configurazione della sessione", GJr = "Qualcosa è andato storto.", WJr = "Qualcosa non sembra giusto?", HJr = "Per favore riprova.", YJr = "La tua nuova password super sicura", KJr = "Nuova Password", ZJr = "La tua vecchia password", XJr = "Password Attuale", JJr = "Cambia la tua password", QJr = "Cambia parola segreta", eQr = "La nuova password corrisponde alla vecchia password. Scegli una password diversa.", tQr = "Nel caso la parola segreta venga persa o dimenticata, è possibile cambiarla, ma tieni presente che tutte le integrazioni che la utilizzano dovranno essere aggiornate", nQr = "La password attuale non è corretta", oQr = "Combinazione di caratteri maiuscoli e minuscoli", rQr = "La lunghezza minima è di 7 caratteri", iQr = "La lunghezza minima è di 15 caratteri", aQr = "Deve contenere almeno 1 numero", sQr = "Deve avere una lunghezza massima di {{limit}} caratteri", cQr = "La password deve avere una lunghezza minima di {{passwordLength}} caratteri e deve contenere almeno 1 numero e una combinazione di caratteri maiuscoli e minuscoli", lQr = "La password non è corretta.", uQr = "Indirizzo e-mail o password errati.", dQr = "Usa impostazione", _Qr = "am/pm", pQr = "Opzioni tempo", mQr = "Gennaio", fQr = "Febbraio", gQr = "Marzo", hQr = "Aprile", vQr = "Maggio", bQr = "Giugno", yQr = "Luglio", $Qr = "Agosto", wQr = "Settembre", kQr = "Ottobre", SQr = "Novembre", EQr = "Dicembre", xQr = "Lunedì", CQr = "Martedì", TQr = "Mercoledì", AQr = "Giovedì", IQr = "Venerdì", OQr = "Sabato", NQr = "Domenica", zQr = "Nessuna disponibilità.", RQr = "Impossibile caricare gli intervalli di tempo disponibili.", PQr = "Aggiungi ospiti", DQr = "Il tuo nome", LQr = "Nome completo", MQr = "Nessun nome", FQr = "Insrisci un numero compreso tra 1 e {{maxOccurences}}", qQr = "Veloce e facile - nessun account richiesto. Perfetto per incontri occasionali.", jQr = "Indirizzo email", VQr = "Immettere un indirizzo e-mail valido", BQr = " Pianifica una chiamata futura se non siamo disponibili entro {{seconds}} secondi", UQr = "Luogo", GQr = "Indirizzo", WQr = "Immettere l'indirizzo", HQr = "Di persona (indirizzo del partecipante)", YQr = "Altrove", KQr = "Posizione personalizzata del partecipante", ZQr = "Continua come ospite", XQr = "Partecipa come ospite", JQr = "Ideale per chiamate occasionali", QQr = "Qualsiasi posizione", eei = "Sì", tei = "No", nei = "Note aggiuntive", oei = "Impossibile prenotare la riunione.", rei = "Impossibile riprogrammare la riunione.", iei = "Si prega di condividere tutto ciò che aiuterà a preparare il nostro incontro.", aei = "Conferma il tuo {{eventTypeTitle}} con {{profileName}}", sei = "Riprogramma il tuo {{eventTypeTitle}} con {{profileName}}", cei = "Link o riunione di persona", lei = "Di persona (indirizzo dell'organizzatore)", uei = "Collegamento riunione", dei = "Numero Di Telefono", _ei = "Numero di telefono del partecipante", pei = "Numero di telefono organizzatore", mei = "Inserisci numero di telefono", fei = "Riprogramma", gei = "Riprogramma", hei = "Prenota invece un membro del team", vei = "O", bei = "Torna indietro", yei = "Email o Username", $ei = "Invia un'email di invito", wei = "Ruolo", kei = "Modifica Ruolo", Sei = "Visualizza ruolo", Eei = "Modifica team", xei = "Modifica utente", Cei = "Modifica organizzazione", Tei = "Se desideri modificare o gestire i tuoi webhook, vai alle <0>impostazioni dei webhook</0>", Aei = "Rifiuta", Iei = "Rifiuta tutto", Oei = "Accetta", Nei = "Abbandona", zei = "Profilo", Rei = "Url del mio team", Pei = "I miei team", Dei = "Nome del team", Lei = "Nome del tuo team", Mei = "Team aggiornato con successo", Fei = "Il tuo team è stato aggiornato con successo.", qei = "La tua organizzazione è stata aggiornata con successo.", jei = "Errore durante la copia negli appunti", Vei = "Informazioni", Bei = "Alcune frasi sul tuo team. Appariranno nella pagina URL del team.", Uei = "ID organizzazione", Gei = "ID organizzazione copiato.", Wei = "Qualche informazione sulla tua organizzazione. Le informazioni appariranno nella pagina di profilo dell'organizzazione.", Hei = "ID team", Yei = "ID team copiato.", Kei = "Membri", Zei = "Membri dell'organizzazione", Xei = "Membri", Jei = "{{count}} membro", Qei = "{{count}} membri", eti = "{{count}} selezionato/i", tti = "Proprietario", nti = "Amministratore", oti = "API di amministrazione", rti = "Utente amministratore", iti = "Creiamo il primo utente amministratore.", ati = "Impostazione utente amministratore", sti = "Hai già creato un utente amministratore. Puoi effettuare l'accesso al tuo account.", cti = "Nuovo Membro", lti = "Invita", uti = "Aggiungi membri del team", dti = "Aggiungi membri", _ti = "Invita altri utenti a unirsi al tuo team", pti = "Aggiungi un membro del team", mti = "Invita un nuovo membro", fti = "Nota: Questo <0>costerà un posto aggiuntivo (15$/m)</0> sul tuo abbonamento.", gti = "Invita qualcuno nel tuo team.", hti = "Carica un file .csv", vti = "Invita via e-mail", bti = "Cambia il ruolo del membro del team", yti = "Disabilita il branding {{appName}}", $ti = "Nascondi tutti i brand {{appName}} dalle tue pagine pubbliche.", wti = "Nascondi pulsante Prenota un membro del team", kti = "Nasconde il pulsante Prenota un membro del team nelle pagine pubbliche.", Sti = "Zona pericolosa", Eti = "Attenzione. L'eliminazione dell'account non può essere annullata.", xti = "Attenzione. L'eliminazione del team non può essere annullata.", Cti = "Indietro", Tti = "Annulla", Ati = "Annulla tutti i rimanenti", Iti = "Applica", Oti = "Annulla questo evento", Nti = "Conferma", zti = "Conferma tutto", Rti = "Sciogli Squadra", Pti = "Sei sicuro di voler sciogliere questo team? Chiunque tu&apos;abbia condiviso questo link di squadra con non sarà più in grado di prenotare utilizzandolo.", Dti = "Sciogli organizzazione", Lti = "Desideri sciogliere questa organizzazione? Tutti i team e i membri verranno eliminati.", Mti = "Sei sicuro di voler rimuovere questo membro dalla squadra?", Fti = "Sì, disband team", qti = "Sì, rimuovi membro", jti = "Sì, annulla l'abbonamento", Vti = "Annulla abbonamento", Bti = "L'annullamento dell'abbonamento disattiverà permanentemente il tuo piano attuale. Questa azione non può essere annullata.", Uti = "Rimuovi membro", Gti = "Gestisci il tuo team", Wti = "Non hai ancora alcun team.", Hti = "I team permettono ad altri di prenotare eventi in condivisione con i tuoi collaboratori.", Yti = "Invia", Kti = "Sì, rimuovi attributo", Zti = "Rimuovi attributo", Xti = "Sei sicuro di voler rimuovere l'attributo '{{name}}'? Tutti gli utenti attualmente assegnati verranno disassegnati.", Jti = "Aggiorna", Qti = "Salva", eni = "In Attesa", tni = "Apri opzioni", nni = "Copia link all'evento", oni = "Condividi", rni = "Ti dispiacerebbe prenotare sul mio calendario o inviarmi il tuo link?", ini = "Copia il link al team", ani = "Lascia il team", sni = "Sì, lascio il team", cni = "Sei sicuro di voler lasciare questo team? Non potrai più utilizzarlo per prenotare.", lni = "{{user}} da {{team}}", uni = "Anteprima", dni = "Link copiato!", _ni = "Copiato!", pni = "Link privato copiato!", mni = "Link condiviso!", fni = "Titolo", gni = "Descrizione", hni = "Stato delle applicazioni", vni = "Una riunione video veloce.", bni = "Tipo Di Pianificazione", yni = "Anteprima team", $ni = "Collettivo", wni = "Pianifica le riunioni quando tutti i membri del team selezionati sono disponibili.", kni = "Durata", Sni = "Durate disponibili", Eni = "Durata predefinita", xni = "Scegliere prima delle durate disponibili", Cni = "{{count}} $t(minute_timeUnit)", Tni = "{{count}} $t({{unit}}_timeUnit)", Ani = "{{count}}$t({{unit}}_short)", Ini = "Minuti", Oni = "Usa Cal.ai per avere un numero di telefono gestito dalla IA o per chiamare agli ospiti.", Nni = "URI di terminazione", zni = "Nome utente SIP Trunk", Rni = "Password SIP Trunk", Pni = "Nickname", Dni = "Elimina numero di telefono", Lni = "Validazione del flusso di lavoro fallita", Mni = "Uno o più passaggi del flusso di lavoro hanno contenuti del messaggio vuoti", Fni = "Uno o più numeri di telefono o indirizzi email non sono verificati", qni = "Potenzia i tuoi flussi di lavoro con Cal.ai", jni = "Agenti AI realistici che prenotano incontri, inviano promemoria e seguono i tuoi clienti.", Vni = "Numero di telefono importato e collegato all'agente con successo", Bni = "Numero di telefono eliminato con successo", Uni = "Sei sicuro di voler eliminare questo numero di telefono? Questa azione non può essere annullata.", Gni = "Sì, elimina il numero di telefono", Wni = "Il numero che stai cercando di importare deve essere in formato E.164 (prefisso internazionale seguito dal numero, senza spazi o caratteri speciali), ad esempio +1234567890", Hni = "L'URI di terminazione per identificare in modo univoco il tuo trunk SIP elastico. Viene utilizzato per le chiamate in uscita. Per i trunk SIP elastici di Twilio termina sempre con .pstn.twilio.com.", Yni = "Il nome utente utilizzato per autenticare il trunk SIP.", Kni = "La password utilizzata per autenticare il trunk SIP.", Zni = "Nickname del numero. Questo è solo per tuo riferimento.", Xni = "Salva e testa chiamata", Jni = "Chiamata avviata con successo", Qni = "Inserisci un numero di telefono", eoi = "Agente aggiornato con successo", toi = "Agente creato con successo", noi = "Tipo di evento aggiunto con successo", ooi = "Numero di telefono disiscritto con successo", roi = "Questo prompt definisce il ruolo e gli obiettivi principali dell'agente", ioi = "Prompt", aoi = "Chiama a", soi = "Effettua una chiamata di prova per verificare la configurazione", coi = "Messaggio iniziale", loi = "Il primo messaggio che l'agente dirà all'inizio di una chiamata", uoi = "Problemi con l'importazione?", doi = "Scopri", _oi = "Scopri come ottenere il tuo URI di terminazione e le credenziali del trunk SIP", poi = "Abbonamento al numero di telefono annullato con successo", moi = "Aggiornamento in corso", foi = "Round Robin", goi = "Ciao, come stai?", hoi = "Ciclo di riunioni tra più membri del team.", voi = "Evento gestito", boi = "username", yoi = "Crea e distribuisci tipi di evento in blocco ai membri del team", $oi = "Gestito", woi = 'il campo "username" può essere compilato solo con il nome utente dei membri assegnati', koi = "Assegna a", Soi = "Inserisci il numero di telefono per la chiamata di prova", Eoi = "Effettua una chiamata di prova", xoi = "Crea un nuovo agente vocale cal.ai per il workflow", Coi = "Crea un nuovo agente vocale cal.ai per automatizzare i tuoi workflow", Toi = "Numero di telefono (che il nostro agente chiamerà)", Aoi = "Acquista un numero di telefono o importane uno che hai già su Twilio", Ioi = "Testa l'agente", Ooi = "Prova chiamata web", Noi = "Numeri di telefono", zoi = "Disiscriviti", Roi = "Elimina fase del workflow", Poi = "Disiscriviti dal numero di telefono", Doi = "Acquista un nuovo numero", Loi = "Puoi acquistare solo numeri di telefono statunitensi. Per altri paesi, puoi importare il tuo numero di telefono Twilio.", Moi = "Acquista un numero USA per ${{priceInDollars}} al mese", Foi = "Destinazioni di chiamata supportate", qoi = "Nessun numero di telefono collegato", joi = "Impossibile ottenere l'ID del passaggio del flusso di lavoro", Voi = "Agente Cal.ai", Boi = "Testa l'agente Cal.ai", Uoi = "Sei sicuro di voler eliminare questo passaggio del flusso di lavoro?", Goi = "Vuoi ancora disattivare l'abbonamento del numero di telefono da questo agente?", Woi = "Questa azione disconnetterà il numero di telefono dall'agente. L'agente non sarà in grado di effettuare chiamate finché non verrà collegato un nuovo numero di telefono.", Hoi = "Numeri di telefono", Yoi = "Collega numero di telefono", Koi = "Gestisci i tuoi numeri di telefono", Zoi = "Importa numero", Xoi = "Questa azione inoltre:", Joi = "Importa numero di telefono", Qoi = "Abbonamento attivo", eri = "Annulla l'abbonamento al tuo numero di telefono", tri = "Elimina il numero di telefono associato", nri = "Non sei autorizzato a creare questo flusso di lavoro", ori = "Importa il tuo numero di telefono Twilio da utilizzare con Phone", rri = "${{price}}/mese", iri = "Acquista nuovo numero", ari = "L'acquisto di un numero di telefono costa ${{priceInDollars}} al mese. Ti verrà addebitato un costo mensile per ogni numero di telefono attivo.", sri = "Prefisso (Opzionale)", cri = "Nessun numero di telefono", lri = "Numero di telefono acquistato con successo", uri = "Annulla abbonamento numero di telefono", dri = "Sì, annulla abbonamento", _ri = "Sei sicuro di voler annullare questo abbonamento al numero di telefono? Questa azione non può essere annullata e perderai l'accesso a questo numero di telefono.", pri = "Aggiungi membri...", mri = "Aggiungi membri", fri = "Nessun membro assegnato", gri = "Assegnato a", hri = "Devi effettuare l'accesso a {{url}}", vri = "Inizia ad assegnare membri in alto", bri = "I membri non potranno fare modifiche", yri = "I membri possono fare modifiche", $ri = "Questa opzione è stata bloccata dall'amministratore del team", wri = "Sbloccato dall'amministratore del team", kri = "URL", Sri = "Nascosto", Eri = "Sola lettura", xri = "Link monouso", Cri = "Al momento sei nel piano {{plan}}.", Tri = "Passa al piano Pro per sbloccare tutte le funzionalità che abbiamo da offrire.", Ari = "È necessario aggiornare il piano per avere più di un tipo di evento attivo.", Iri = "Devi aggiornare il tuo piano per creare un team.", Ori = "Puoi <1>cambiare piano qui</1>.", Nri = "Tipo di Evento", zri = "Crea eventi da condividere per le persone che prenotano sul tuo calendario.", Rri = "Nuovo tipo di evento", Pri = "Crea il tuo primo tipo di evento", Dri = "I tipi di eventi ti permettono di condividere i link che mostrano gli orari disponibili sul tuo calendario e consentire alle persone di effettuare prenotazioni con te.", Lri = "{{eventTypeTitle}} tipo di evento creato con successo", Mri = "{{eventTypeTitle}} tipo di evento aggiornato con successo", Fri = "Tipo di evento eliminato con successo", qri = "Ore", jri = "Persone", Vri = "La Tua Email", Bri = "Cambia Avatar", Uri = "Carica avatar", Gri = "Lingua", Wri = "Timezone", Hri = "Primo giorno della settimana", Yri = "Si ripete {{count}} volta", Kri = "Si ripete {{count}} volte", Zri = "Ogni {{freq}} per", Xri = "{{count}} evento rimanente", Jri = "{{count}} eventi rimanenti", Qri = "Si ripete ogni", eii = "occorrenza", tii = "occorrenze", nii = "settimana", oii = "settimane", rii = "mese", iii = "mesi", aii = "anno", sii = "anni", cii = "Altri {{count}}", lii = "Max", uii = "Tema Singolo", dii = "Colore del Marchio", _ii = "Colore del marchio (tema chiaro)", pii = "Colore del marchio (tema scuro)", mii = "Colore del tipo di evento (Tema chiaro)", fii = "Colore del tipo di evento (Tema scuro)", gii = "Il file non è chiamato [idOrSlug]/[user]", hii = "Crea team", vii = "Nome", bii = "Team senza nome", yii = "Client OAuth", $ii = "Gestisci i client OAuth per la tua organizzazione", wii = "Crea client OAuth", kii = "Crea un nuovo client OAuth per integrazioni di terze parti", Sii = "Client OAuth eliminato con successo", Eii = "Crea un nuovo team per collaborare con gli utenti.", xii = "Crea un nuovo team", Cii = "URL della tua pagina di prenotazione", Tii = "URL della pagina dove i tuoi utenti possono cancellare la prenotazione", Aii = "URL della pagina dove i tuoi utenti possono riprogrammare la prenotazione", Iii = "Questo slot non è più disponibile. Torna alla pagina precedente e seleziona un altro orario.", Oii = "Inviti Aperti", Nii = "Nuovo Team", zii = "Crea il tuo primo team e invita altri utenti a lavorare insieme.", Rii = "Crea una squadra per iniziare", Pii = "Team", Dii = "Team", Lii = "Organizzazione", Mii = "Fatturazione team", Fii = "Gestisci la fatturazione per il tuo team", qii = "Abbiamo cambiato la fatturazione per i team", jii = "Alcuni membri del tuo team non hanno un posto. Aggiorna il tuo piano Pro per coprire i posti mancanti.", Vii = "A partire da gennaio 2022, applichiamo una tariffazione in base ai posti per i membri dei team. I membri del tuo team che utilizzavano Pro gratuitamente dispongono ora di un periodo di prova di 14 giorni. Terminata la prova, questi membri saranno nascosti dal tuo team, se non aggiornerai il piano.", Bii = "Crea e gestisci team per utilizzare funzionalità di collaborazione.", Uii = "Questa funzione è disponibile solo nel piano Pro", Gii = "Al fine di rimuovere il marchio {{appName}} dalle pagine di prenotazione, è necessario acquistare un account Pro.", Wii = "Modifica le informazioni del tuo profilo, che verranno visualizzate sul tuo link di pianificazione.", Hii = "Perché la modifica abbia effetto, potrebbe essere necessario disconnettersi e accedere nuovamente.", Yii = "Qualcosa su di te.", Kii = "Profilo aggiornato con successo", Zii = "Il tuo profilo utente è stato aggiornato con successo.", Xii = "Il tuo upgrade è disponibile", Jii = "Migliora la tua esperienza di pianificazione passando al nuovo piano e goditi le nuove funzionalità.", Qii = "Sei a posto", eai = "Sei già sul piano più recente. Nessun upgrade necessario. Goditi le nuove funzionalità e contattaci per qualsiasi domanda!", tai = "L'utente sembra loggato ma non può essere trovato nel database", nai = "Incorpora e webhook", oai = "Abilitato", rai = "Disabilitato", iai = "Disabilitato", aai = "Fatturazione", sai = "qui", cai = "Gestisci le tue informazioni di fatturazione e annulla il tuo abbonamento.", lai = "Disponibilità", uai = "Modifica disponibilità", dai = "Cambia quando sei disponibile per le prenotazioni.", _ai = "Copia orari in", pai = "Copia orari in…", mai = "Cambia il tuo programma settimanale", fai = "Logo", gai = "Errore", hai = "Immettere almeno un carattere", vai = "Immettere almeno {{count}} caratteri", bai = "Logo Del Team", yai = "Aggiungi un luogo", $ai = "Partecipanti", wai = "Aggiungi partecipanti", kai = "Mostra impostazioni avanzate", Sai = "Nascondi impostazioni avanzate", Eai = "Nome Dell'Evento", xai = "Nome dell'evento nel calendario", Cai = "Il nome che apparirà nei calendari", Tai = "Riunione con {{attendeeName}}", Aai = "Input Aggiuntivi", Iai = "Chiedi al creatore del programma di inserire dei campi di input aggiuntivi prima che la prenotazione sia confermata", Oai = "Etichetta", Nai = "Segnaposto", zai = `Visualizza l'email "Aggiungi al calendario" come organizzatore`, Rai = "Indicheremo questo indirizzo email come organizzatore e invieremo qui le email di conferma.", Pai = `Se attivata, indicheremo l'indirizzo email del tuo "Aggiungi al calendario" come organizzatore e invieremo a tale indirizzo le email di conferma`, Dai = `Nota che potrebbe essere necessario disconnettere e poi riconnettere l'account "Aggiungi al calendario" per utilizzare questa funzione.`, Lai = "Tipo", Mai = "Modifica", Fai = "Aggiungi un input", qai = "Nascondi le note nel calendario", jai = "Per motivi di privacy, gli input e le note aggiuntivi saranno nascosti nella voce del calendario. Verranno comunque invitati alla tua email.", Vai = "La prenotazione deve essere confermata manualmente prima di essere inviata alle integrazioni e che venga inviata una e-mail di conferma.", Bai = "Le prenotazioni non confermate bloccano comunque gli slot del calendario.", Uai = "Evento ricorrente", Gai = "Le persone possono iscriversi a eventi ricorrenti", Wai = "Connettiti e partecipa", Hai = "Non può essere utilizzato con i tipi di evento a pagamento", Yai = "Le riunioni immediate non sono ancora disponibili con gli eventi ricorrenti e le app di pagamento", Kai = "Sperimentale: gli eventi Riunione immediata al momento sono in fase di sperimentazione.", Zai = "Inizio", Xai = "Disabilita Ospiti", Jai = "Disabilita l'aggiunta di ulteriori ospiti durante la prenotazione.", Qai = "Genera URL privato", esi = "Abilita URL privato", tsi = "Link privato", nsi = "Il tuo link privato verrà rigenerato dopo ogni utilizzo", osi = "Copia link privato", rsi = "Copia link privato nell'evento", isi = "Genera un URL privato da condividere senza mostrare il tuo nome utente {{appName}}", asi = "Link Privati", ssi = "Genera URL privati senza esporre il nome utente, con limiti di scadenza e utilizzo configurabili", csi = "Aggiungi nuovo link", lsi = "Link privato copiato", usi = "Gli inviti possono programmare", dsi = "Range di date", _si = "giorni del calendario", psi = "giorni lavorativi", msi = "Imposta un indirizzo o un luogo", fsi = "Imposta un collegamento alla riunione", gsi = "Non può essere attivato. Può essere sbloccato solo per i tipi di eventi figli", hsi = "{{appName}} chiederà al tuo invitato di inserire un numero di telefono prima della pianificazione.", vsi = "{{appName}} fornirà un Google Meet location.", bsi = "{{appName}} fornirà un URL di riunione Zoom.", ysi = "{{appName}} fornirà un URL di riunione Tandem.", $si = "{{appName}} fornirà un URL di riunione Daily video.", wsi = "{{appName}} fornirà un URL di riunione Jitsi Meet.", ksi = "{{appName}} fornirà un URL di riunione Huddle01 video.", Ssi = "{{appName}} fornirà un URL per la riunione MS Teams. NOTA: È NECESSARIO POSSEDERE UN ACCOUNT LAVORATIVO O SCOLASTICO", Esi = "Richiedi Pagamento", xsi = "Indica un nome", Csi = "commissione per transazione", Tsi = "Il tuo team è stato aggiornato con successo.", Asi = "Nascondi tipo evento", Isi = "Aggiungi un luogo", Osi = "nel futuro", Nsi = "Quando prenotato con meno di <0></0> di preavviso", zsi = "All'interno di un intervallo di date", Rsi = "Indefinitamente nel futuro", Psi = "Aggiungi un nuovo campo di input personalizzato", Dsi = "Chat Veloce", Lsi = "Aggiungi un nuovo tipo di evento del team", Msi = "Aggiungi un nuovo tipo di evento", Fsi = "Crea un nuovo tipo di evento per le persone con cui prenotare.", qsi = "Durata", jsi = "Preavviso minimo", Vsi = "Sposta orari di inizio", Bsi = "Sposta le fasce orarie mostrate alle persone che prenotano di un numero specificato di minuti", Usi = "Sposta di", Gsi = "ad es., le persone che prenotano vedranno le fasce orarie alle {{ adjustedTime }} anziché alle {{ originalTime }}", Wsi = "Intervalli di fascia oraria", Hsi = "Usa durata evento (impostazione predefinita)", Ysi = "Eliminare il tipo di evento?", Ksi = "Eliminare il tipo di evento gestito?", Zsi = "Gli utenti con cui hai condiviso il link non saranno più in grado di usarlo per prenotare.", Xsi = "I membri assegnati a questo tipo di evento avranno anche i loro tipi di evento eliminati.", Jsi = "Chiunque con cui abbiano condiviso il loro link non sarà più in grado di prenotare utilizzandolo.", Qsi = "Sì, elimina", eci = "Elimina account", tci = "Sì, elimina account", nci = "Chiunque abbia il link del tuo account non potrà più utilizzarlo per prenotare e le preferenze che hai salvato andranno perse.", oci = "Integrazioni", rci = "App", ici = "Qui puoi trovare l'elenco delle tue app", aci = "Elenco delle app", sci = "App {{category}}", cci = "App Store", lci = "Collegare persone, tecnologia e luogo di lavoro.", uci = "Connetti la tua app di videoconferenza", dci = "Impostazioni", _ci = "Il tipo di evento è stato spostato con successo", pci = "Prossimo passo", mci = "Salta passo", fci = "Passo precedente", gci = "Installa", hci = "Inizia la prova gratuita", vci = "Installato", bci = "{{count}} installazione attiva", yci = "{{count}} installazioni attive", $ci = "Installato a livello globale", wci = "App installata correttamente", kci = "Impossibile installare l'app", Sci = "Disconnetti", Eci = "Incorpora il tuo calendario nella tua pagina web", xci = "Collega le tue app preferite.", Cci = "Automazione", Tci = "Configura come i tipi di eventi dovrebbero interagire con i tuoi calendari.", Aci = "Attiva/disattiva i calendari in cui desideri controllare i conflitti per evitare doppie prenotazioni.", Ici = "Collega calendario aggiuntivo", Oci = "Calendario aggiornato correttamente", Nci = "Controlla qui", zci = "Conferenze", Rci = "Calendario", Pci = "Pagamenti", Dci = "Non installato", Lci = "Le password non corrispondono.", Mci = "Questo campo è richiesto.", Fci = "Stato", qci = "Visualizza la disponibilità degli utenti", jci = "L'utente deve accettare l'invito per visualizzare la disponibilità", Vci = "Segnalati assente", Bci = 'Disabilita lo stato "assente"', Uci = `Errore durante l'aggiornamento dello stato "assente"`, Gci = "Questo utente è attualmente assente.", Wci = "La persona che stai cercando di prenotare si è segnalata assente, quindi non accetta nuove prenotazioni.", Hci = "Incontra persone con gli stessi token", Yci = "Prenota e accetta prenotazioni solo con persone che condividono gli stessi token, DAO o NFT.", Kci = "Il tuo account è stato creato utilizzando un provider di identità.", Zci = "Il tuo account è gestito da {{provider}}", Xci = "Per modificare la tua email o la tua password, per abilitare l'autenticazione a due fattori e altro ancora, consulta le impostazioni del tuo account {{provider}}.", Jci = "Il tuo account è gestito da un provider di identità diverso. Prova ad accedere con {{provider}}.", Qci = "Errore durante la creazione di un nuovo utente. Riprova.", eli = "Accedi con Google", tli = "Accedi con SAML", nli = "Accedi con SAML/OIDC", oli = "Continua con l'email", rli = "Continua con Google", ili = "Ultimo utilizzo", ali = "Dovrai generare un token di accesso con il tuo vecchio strumento di pianificazione.", sli = "Importa da", cli = "Token di accesso", lli = "Roadmap", uli = "Categorie in evidenza", dli = "Flag delle funzionalità", _li = "Qui puoi attivare o disattivare le funzionalità della tua istanza Cal.com.", pli = "Categorie popolari", mli = "{{count}} App", fli = "{{count}} app", gli = "App di tendenza", hli = "Più popolari", vli = "App installate", bli = "Gratuito", yli = "Nessuna app {{category}}", $li = "Tutte le app", wli = "Aggiungi un'app di calendario per controllare i conflitti ed evitare doppie prenotazioni", kli = "Prova ad aggiungere un'app di conferenza per effettuare videochiamate con i clienti", Sli = "Aggiungi un'app di pagamento per facilitare le transazioni con i clienti", Eli = "Aggiungi un'app di analisi per le tue pagine di prenotazione", xli = "Aggiungi un'app di automazione da usare", Cli = "Aggiungi qualsiasi altra app per fare altre attività", Tli = "Aggiungi un'app di messaggistica per impostare notifiche e promemoria personalizzati", Ali = "Aggiungi un'app CRM per tenere traccia delle persone che hai incontrato", Ili = "Imposta uno o più calendari per controllare i conflitti ed evitare doppie prenotazioni.", Oli = "Configura quale servizio di elaborazione dei pagamenti usare per addebitare i clienti.", Nli = "Imposta quali app di analisi usare per le tue pagine di prenotazione", zli = "Tutte le app installate appartenenti ad altre categorie.", Rli = "Scegli quali app di conferenza utilizzare", Pli = "Imposta quali app di automazione usare", Dli = "Scegli le app di messaggistica da usare per impostare notifiche e promemoria personalizzati", Lli = "Scegli quali app CRM utilizzare per tenere traccia delle persone che hai incontrato", Mli = "Analisi", Fli = "Nessuna app installata", qli = "Le app consentono di ottimizzare il flusso di lavoro e di migliorare significativamente la pianificazione.", jli = "Esplora l'App Store", Vli = "Gestisci le app installate o modifica le impostazioni", Bli = "Sfoglia app", Uli = "Funzionalità", Gli = "Autorizzazioni", Wli = "Termini e informativa privacy", Hli = "Pubblicato da {{author}}", Yli = "Abbonati", Kli = "Acquista", Zli = "Installa app", Xli = "Categorie", Jli = "Prezzi", Qli = "Ulteriori informazioni", eui = "Prova ora", tui = "Informativa sulla privacy", nui = "Termini del servizio", oui = "Rimuovi", rui = "Aggiungi", iui = "{{count}} installate", aui = "Verifica Wallet", sui = "Crea eventi su:", cui = "Questa è una funzionalità commerciale", lui = "Puoi testare questa funzione localmente ma non in ambiente di produzione.", uui = "Per acquistare una licenza commerciale, contatta il nostro team di vendita. Se hai già una chiave di licenza, contatta support@cal.com per assistenza.", dui = "Licenza mancante", _ui = "Prossimi Passi", pui = "Acquista una licenza commerciale", mui = "Il piano infrastrutturale è basato sull'utilizzo e ha sconti rivolti alle startup.", fui = "Crea un account tramite Prisma Studio", gui = "Scopri come configurare il tuo primo utente", hui = "Contatta reparto commerciale", vui = "Errore 404", bui = "Imposta come predefinito", yui = "Nuovo programma", $ui = "Aggiungi un nuovo programma", wui = "Aggiungi un nuovo calendario", kui = "Imposta dove aggiungere nuovi eventi quando c'è una prenotazione.", Sui = "Elimina programma", Eui = "L'eliminazione di una pianificazione comporterà la sua rimozione da tutti i tipi di eventi. L'azione non può essere annullata.", xui = "Programma {{scheduleName}} creato", Cui = "Disponibilità aggiornata con successo", Tui = "Programma eliminato", Aui = "Orario lavorativo", Iui = "Crea un programma di disponibilità", Oui = "La creazione di programmi di disponibilità consente di gestire la disponibilità per i diversi tipi di eventi. I programmi possono essere applicati a uno o più tipi di evento.", Nui = "Richiede il possesso di un token appartenente al seguente indirizzo:", zui = "Paolo Rossi", Rui = "Formato dell'orario", Pui = "Reindirizza su prenotazione ", Dui = 'Verrai reindirizzato a {{ url }} tra $t(second, {"count": {{seconds}} }).', Lui = "https://example.com/redirect-to-my-success-page", Mui = "Dopo una prenotazione, reindirizza a un URL personalizzato", Fui = "Duplica", qui = "Imposta posti", jui = "Indica i posti disponibili (ciò disabiliterà le prenotazioni ospite e le prenotazioni opt-in).", Vui = "Posto disponibile", Bui = "Posti disponibili", Uui = "Quasi tutti i posti sono al completo", Gui = "I posti si esauriscono in fretta", Wui = "Numero di posti per prenotazione", Hui = "Imposta la finestra di accesso alla riunione (secondi): Il periodo di tempo in secondi entro il quale l'host può accedere e avviare la riunione. Dopo questo periodo, l'URL di accesso alla riunione scadrà.", Yui = "Immettere il numero di posti", Kui = "Puoi gestire i tuoi programmi dalla pagina Disponibilità.", Zui = "Non ci sono più posti disponibili", Xui = "Chiavi API", Jui = "Chiave API", Qui = "Prova chiave API", edi = "Test superato!", tdi = "Prova non superata", ndi = "Fornisci chiave API", odi = "Le chiavi API consentono di effettuare chiamate API per il proprio account.", rdi = "Crea invece un marketplace o una piattaforma.", idi = "Genera chiavi API da usare per accedere al tuo account.", adi = "Crea una chiave API", sdi = "Assegna un nome a questa chiave", cdi = "Ad es. Sviluppo", ldi = "Chiave API senza nome", udi = "Questa chiave API non ha data di scadenza", ddi = "Modifica chiave API", _di = "Chiave API creata", pdi = "Chiave API aggiornata", mdi = "Crea", fdi = "Salva questa chiave API in un posto sicuro.", gdi = "Una volta chiusa questa finestra non sarà più possibila visualizzarla.", hdi = "Copia negli Appunti", vdi = "Abilitato dopo l'aggiornamento", bdi = "Il link privato funzionerà dopo il salvataggio", ydi = "Revoca questa chiave API", $di = "Disabilita riprogrammazione", wdi = "Gli ospiti non possono più riprogrammare l'evento tramite invito di calendario o email", kdi = "Consenti la prenotazione tramite link di riprogrammazione", Sdi = "Quando abilitato, gli utenti potranno creare una nuova prenotazione quando tentano di riprogrammare una prenotazione annullata", Edi = "Disabilita cancellazione", xdi = "Gli ospiti non possono più cancellare l'evento tramite invito di calendario o email", Cdi = "Revoca chiave API", Tdi = "Chiave API copiata", Adi = "La chiave API scadrà il", Idi = "Rimuovere definitivamente questa chiave API dal tuo account?", Odi = "Copia", Ndi = "Data di scadenza", zdi = "Scaduta", Rdi = "Nessuna scadenza", Pdi = "Scade", Ddi = "Richiesta di riprogrammare la prenotazione", Ldi = "Motivo della riprogrammazione", Mdi = "Prenota un nuovo orario", Fdi = "Richiesta di riprogrammazione inviata", qdi = "Questa operazione annullerà la riunione programmata, avviserà il creatore del programma e gli chiederà di scegliere una nuova ora.", jdi = "Motivo della richiesta di riprogrammazione", Vdi = "Richiedi riprogrammazione ", Bdi = "Modifica prenotazione", Udi = "Riprogramma prenotazione", Gdi = "Orario precedente", Wdi = "Aggiungi GIF per la pagina di conferma", Hdi = "Cerca", Ydi = "Accedi con altra identità", Kdi = "Accesso con altra identità", Zdi = "Consente al nostro team di supporto di effettuare l'accesso temporaneo a tuo nome per risolvere rapidamente gli eventuali problemi da te segnalati.", Xdi = "Consente ai proprietari/amministratori del tuo team di accedere temporaneamente con il tuo nome.", Jdi = "Gratuito per le singole pesone. Piani collettivi per le funzionalità di collaborazione.", Qdi = "Rendi l'organizzazione privata", e_i = "Quando questa opzione è attivata, i membri della tua organizzazione non possono vedere gli altri membri.", t_i = "Rendi il team privato", n_i = "Quando questa opzione è attivata, i membri del tuo team non potranno vedere gli altri membri del team.", o_i = "Non è possibile vedere tutti i membri di un team privato.", r_i = "Non puoi vedere i team di un'organizzazione privata.", i_i = "Consenti durate multiple", a_i = "Ogni utilizzo di questa funzionalità viene controllato.", s_i = `Accesso con l'identità dell'utente "{{user}}".`, c_i = "Fai clic qui per interrompere", l_i = "Aggiornato: è cambiato il luogo del tuo evento", u_i = "Aggiunti - Nuovi ospiti aggiunti al tuo evento", d_i = "Luogo cambiato: {{eventType}} con {{name}} il {{date}}", __i = "Ospiti aggiunti: {{eventType}} con {{name}} il {{date}}", p_i = "Luogo corrente", m_i = "Nuovo luogo", f_i = "Sessione", g_i = "Controlla la sessione del tuo account", h_i = "Timeout sessione dopo", v_i = "Timeout sessione", b_i = "Invalida la sessione dopo un determinato periodo di tempo.", y_i = "Nessun luogo definito", $_i = "Imposta luogo", w_i = "Aggiorna luogo", k_i = "Luogo aggiornato", S_i = "Aggiornamento della posizione fallito", E_i = "Ospiti aggiunti", x_i = "Impossibile aggiungere ospiti", C_i = "Questo non sembra un indirizzo email valido", T_i = "Le email devono essere uniche e valide", A_i = "Questo non sembra un URL", I_i = "Inserisci questo codice nel tuo HTML nel punto in cui vuoi che appaia il widget {{appName}}.", O_i = "Crea o aggiorna un componente React esistente come mostrato di seguito.", N_i = "Copia codice", z_i = "Codice copiato!", R_i = "Come desideri aggiungere {{appName}} al tuo sito?", P_i = "Scegli uno dei seguenti modi per inserire {{appName}} nel tuo sito.", D_i = "Configurare l'integrazione con Zapier", L_i = "Configurare l'integrazione con Make", M_i = "Genera una chiave API", F_i = "Genera una chiave API da usare con {{appName}} su", q_i = "La tua chiave API univoca", j_i = "Copia questa chiave API e conservala in un posto sicuro. Se perdi la chiave, dovrai generarne una nuova.", V_i = "<0>Accedi al tuo account Zapier e crea un nuovo Zap.</0><1>Seleziona Cal.com come app trigger. Scegli l'evento trigger.</1><2>Seleziona il tuo account e immetti la tua chiave API univoca.</2><3>Fai una prova del tuo trigger.</3><4>Fatto!</4>", B_i = "Vai su <0>Make Invite Link</0> e installa l'app Cal.com.", U_i = "Accedi al tuo account Make e crea un nuovo Scenario.", G_i = "Seleziona Cal.com come app Trigger. Scegli anche un evento Trigger.", W_i = "Scegli il tuo account e inserisci la tua Chiave API Unica.", H_i = "Testa il tuo Trigger.", Y_i = "Hai finito!", K_i = "Prima è necessario installare l'app Zapier, disponibile nell'App Store.", Z_i = "Prima è necessario installare l'applicazione Make, disponibile nell'App Store.", X_i = "Installazione app", J_i = "App non installata", Q_i = "Spiacenti, questa app non è installata sul tuo account. Visita il nostro app store per esplorare e scoprire questa e altre fantastiche app.", epi = "Connetti al server Apple", tpi = "URL del calendario", npi = "Genera una password specifica dell'app da usare con {{appName}} presso", opi = "Impossibile aggiungere questo account Apple Calendar. Assicurati di usare una password specifica per l'app e non la password del tuo account.", rpi = "Le tue credenziali verranno memorizzate e crittografate.", ipi = "Sarà memorizzata e crittografata.", api = "Vai all'App Store", spi = "Prova a riconnettere il calendario con tutti i permessi necessari", cpi = "Imposta un numero di telefono per la riunione", lpi = "Non ci sono intervalli orari occupati", upi = "Mostra nella pagina di prenotazione", dpi = "Il luogo sarà visibile prima della conferma della prenotazione", _pi = "Aggiungi GIF", ppi = "Cerca su Giphy", mpi = "Aggiungi link da Giphy", fpi = "Aggiungere una GIF alla pagina di conferma", gpi = "Trova una GIF per ravvivare la pagina di conferma", hpi = "Condividi feedback", vpi = "Risorse", bpi = "Documentazione di supporto", ypi = "Documentazione sviluppatore", $pi = "Contattaci", wpi = "Contatta il supporto", kpi = "Assistenza Premium", Spi = "Supporto della community", Epi = "Feedback", xpi = "Grazie per il tuo feedback!", Cpi = "Errore durante l'invio del feedback", Tpi = "Condividi qui i tuoi commenti:", Api = "Dettagli della prenotazione", Ipi = "o", Opi = "Non importa", Npi = "Vai a: ", zpi = "Link di invito Zapier", Rpi = "Una volta confermato l'evento, verrà creato un URL di riunione.", Ppi = "Visualizza dinamicamente il nome del partecipante oppure il tuo nome, se visualizzato dal partecipante", Dpi = "Luogo dell'evento", Lpi = "Motivo della riprogrammazione (facoltativo)", Mpi = "Fai sapere agli alti perché hai bisogno di riprogrammare", Fpi = "Questo evento è stato cancellato", qpi = "Abbiamo inviato un'e-mail di notifica a te e agli altri partecipanti.", jpi = "Questo input verrà mostrato durante la prenotazione di questo evento", Vpi = "L'URL della riunione è riportato nell'e-mail di conferma", Bpi = "L'URL deve iniziare con http:// o https://", Upi = "Verrà fornito il numero di telefono", Gpi = "prima dell'inizio dell'evento", Wpi = "quando l'evento viene cancellato", Hpi = "Dopo che gli host non si sono uniti alla videochiamata", Ypi = "Dopo che gli ospiti non si sono uniti alla videochiamata", Kpi = "Partecipa alla videochiamata", Zpi = "Accedi a Cal.com", Xpi = "Accedi a Cal.com", Jpi = "Tieni traccia dei tuoi incontri, ricevi notifiche e gestisci il tuo calendario in modo più efficace.", Qpi = "Tieni traccia dei tuoi incontri e gestisci il tuo calendario in modo più efficace", emi = "Impossibile partecipare alla chiamata. Riprova.", tmi = "Scegli come vuoi partecipare a questa chiamata", nmi = "Scegli come desideri apparire nella chiamata", omi = "quando viene prenotato un nuovo evento", rmi = "invia e-mail all'organizzatore", imi = "invia e-mail ai partecipanti", ami = "Invia SMS al partecipante", smi = "invia SMS a un numero specifico", cmi = "Invia facilmente dei promemoria di riunioni via SMS ai partecipanti", lmi = "invia un messaggio Whatsapp a un numero specifico", umi = "invia un messaggio Whatsapp al partecipante", dmi = "Flussi di lavoro", _mi = "Nuovo flusso di lavoro", pmi = "Come vorresti iniziare?", mmi = "Aggiungi un nuovo flusso di lavoro", fmi = "quando un evento viene riprogrammato", gmi = "Attivatore", hmi = "Attivatori", vmi = "Azione", bmi = "Crea flussi di lavoro per automatizzare notifiche e promemoria", ymi = "Nome flusso di lavoro", $mi = "Flusso di lavoro personalizzato", wmi = "{{workflowName}} creato correttamente", kmi = "Eliminare questo flusso di lavoro?", Smi = "Elimina flusso di lavoro", Emi = "Sì, elimina flusso di lavoro", xmi = "Flusso di lavoro eliminato", Cmi = "Quanto tempo prima dell'inizio dell'evento?", Tmi = "giorni", Ami = "ore", Imi = "minuti", Omi = "m", Nmi = "h", zmi = "Crea il tuo primo flusso di lavoro", Rmi = "I flussi di lavoro consentono di automatizzare l'invio di promemoria e notifiche.", Pmi = "Data attivazione", Dmi = "Flusso di lavoro {{workflowName}} aggiornato correttamente", Lmi = "Questo è un nome utente standard e l'aggiornamento ti porterà alla fatturazione per il downgrade.", Mmi = "Questo è un nome utente premium, ottieni il tuo per {{price}}", Fmi = "Corrente", qmi = "premium", jmi = "standard", Vmi = "Conferma modifica nome utente", Bmi = "Poiché stai passando da un nome utente standard a un nome utente premium, sarai portato alla pagina di pagamento per effettuare l'upgrade.", Umi = "Poiché stai passando da un nome utente premium a un nome utente standard, sarai portato alla pagina di pagamento per effettuare il downgrade.", Gmi = "Vai alla fatturazione", Wmi = "Richiedi pagamento per le prenotazioni (0,5% + 0,10 € di commissione per transazione)", Hmi = "Il periodo di prova è scaduto", Ymi = "Rimuovi app", Kmi = "Sì, rimuovi l'app", Zmi = "Rimuovere questa app?", Xmi = "App rimossa correttamente", Jmi = "Errore durante la rimozione dell'app", Qmi = "Conferenza Web", efi = "Chiamata web", tfi = "Inizia chiamata web", nfi = "Termina chiamata", ofi = "Prova il tuo agente con una chiamata web senza richiedere un numero di telefono", rfi = "Chiamata telefonica", ifi = "Connessione all'agente in corso...", afi = "Chiamata attiva", sfi = "Chiamata terminata", cfi = "Errore nella chiamata", lfi = "Pronto per iniziare la chiamata", ufi = "Impossibile avviare la chiamata web. Riprova.", dfi = "La chiamata ha riscontrato un errore. Riprova.", _fi = "Impossibile inizializzare la chiamata web. Assicurati che i permessi del microfono siano concessi.", pfi = "Inizia una chiamata per vedere la conversazione", mfi = "In attesa della conversazione...", ffi = "Agente IA", gfi = "In diretta", hfi = "Connessione in corso...", vfi = "Richiede conferma", bfi = "Richiede conferma se si prenota con un preavviso di < {{time}} $t({{unit}}_timeUnit)", yfi = "Può richiedere conferma", $fi = "{{count}} tipo di evento", wfi = "{{count}} tipi di evento", kfi = "{{count}} team", Sfi = "{{count}} team", Efi = "Aggiungi azione", xfi = "Imposta link Whereby", Cfi = "Inserisci un link Whereby valido", Tfi = "Imposta link Around.Co", Afi = "Inserisci un link Around.Co valido", Ifi = "Imposta link Riverside", Ofi = "Inserisci un link Riverside valido", Nfi = "Inserire un link Ping.gg valido", zfi = "Connetti al server Exchange 2013", Rfi = "Connetti al server Exchange 2016", Pfi = "Modello personalizzato", Dfi = "Testo email", Lfi = "Messaggio di testo", Mfi = "Hai un problema specifico?", Ffi = "sfoglia i nostri documenti", qfi = "Scegli un modello", jfi = "Personalizzato", Vfi = "Promemoria", Bfi = "Riprogrammato", Ufi = "Riprogrammato da", Gfi = "Prenotazione originale", Wfi = "Completato", Hfi = "Valutazione", Yfi = "Promemoria: {{eventType}} con {{name}} il {{date}}", Kfi = "Non verrà attivato per le prenotazioni già esistenti, in quanto agli utenti verrà chiesto di specificare il numero di telefono al momento della prenotazione dell'evento.", Zfi = "{{count}} minuto", Xfi = "{{count}}m", Jfi = "{{count}} minuti", Qfi = "{{count}} ora", egi = "{{count}}h", tgi = "{{count}} ore", ngi = "Input non valido", ogi = "Non è stato possibile aggiungere il link alla riunione {{location}} al tuo evento programmato. Contatta i tuoi invitati o aggiorna l'evento nel calendario per aggiungere i dettagli. Puoi <0>modificare la posizione sul tipo di evento</0> o provare a <1>rimuovere e aggiungere nuovamente l'app.</1>", rgi = "Non è stato possibile aggiornare il tuo <1>{{calendar}}</1>. <2> Controlla le impostazioni del tuo calendario oppure rimuovi il calendario e aggiungilo nuovamente </2>", igi = "Nome del partecipante", agi = "Nome completo della persona che prenota", sgi = "Integrazione non funzionante", cgi = "Si è verificato un problema durante l'aggiunta di un collegamento video", lgi = "Si è verificato un problema durante l'aggiornamento del calendario", ugi = "Attivo per {{count}} tipo di evento", dgi = "Attivo per {{count}} tipi di evento", _gi = "Attivo su {{count}} team", pgi = "Attivo su {{count}} team", mgi = "Attivo su tutti i tipi di eventi", fgi = "Attivo su tutti i team", ggi = "Non ci sono tipi di evento attivi", hgi = "Nessun team attivo", vgi = "Nuovo partecipante {{name}} a {{eventType}} il {{date}}", bgi = "Qualcuno ha aggiunto se stesso a un evento", ygi = "Variabile", $gi = "Nome evento", wgi = "Partecipante", kgi = "Data evento", Sgi = "Ora evento", Egi = "Nome organizzatore", xgi = "Per poter utilizzare questa funzionalità, è necessario passare a un account Pro.", Cgi = "Numero di telefono non valido", Tgi = "URL non valido per {{label}}. URL di esempio: {{sampleUrl}}", Agi = "Esplora", Igi = "Apri", Ogi = "Chiudi", Ngi = "Effettua l'upgrade", zgi = "Acquista numero US per {{priceInDollars}}$/mese", Rgi = "Effettua l'upgrade per accedere alle registrazioni", Pgi = "Le registrazioni sono disponibili solo con il piano team. Effettua l'upgrade per registrare le tue chiamate", Dgi = "Passa a Enterprise per generare un numero di telefono con operatore IA, in grado di contattare gli ospiti per pianificare le chiamate", Lgi = "Le registrazioni sono disponibili con il piano team", Mgi = "Questa è una funzionalità del piano Team. Effettua l'upgrade al piano Team per vedere la disponibilità del tuo team.", Fgi = "Questa è una funzionalità del piano Team. Effettua l'upgrade al piano Team per automatizzare le notifiche e i promemoria degli eventi con i flussi di lavoro.", qgi = "Mostra nel profilo", jgi = "Incorpora", Vgi = "Nuovo nome utente", Bgi = "Nome utente corrente", Ugi = "Esempio 1", Ggi = "Esempio 2", Wgi = "Identificatore della domanda posta in fase di prenotazione", Hgi = "Dimensione dell'azienda", Ygi = "Per cosa ti serve assistenza?", Kgi = "Formato variabile", Zgi = "URL dell'abbonato Webhook già definito", Xgi = "Ignora tutti i caratteri speciali dell'etichetta del campo di input aggiuntivo (usa solo lettere e numeri), usa solo lettere maiuscole e sostituisci gli spazi con il trattino basso.", Jgi = "Come posso utilizzare le domande poste nella pagina di prenotazione come variabili?", Qgi = "Scarica app desktop", ehi = "Imposta link di Ping", thi = "Limite superato", nhi = "Quando succede qualcosa", ohi = "Viene eseguita un'azione", rhi = "Verifica azione", ihi = "Notifica inviata", ahi = "Nessun input", shi = "Verifica azione del flusso di lavoro", chi = "Invia SMS", lhi = "Inviare un SMS a {{number}}?", uhi = "Nessun calendario predefinito collegato", dhi = "Puoi collegare il tuo calendario <1>qui</1>.", _hi = "Calendario predefinito", phi = "Nascondi nel profilo", mhi = "Impostazione evento", fhi = "Nessuna disponibilità trovata nel programma", ghi = "Limiti", hhi = "Con quale frequenza è possibile fare una prenotazione", vhi = "Impostazioni calendario e altro...", bhi = "Avanzate", yhi = "Configura i pagamenti per l'evento", $hi = "Impostazione evento: In caso di più durate è richiesta almeno 1 opzione.", whi = "Impostazione evento: Selezionare una durata predefinita valida.", khi = "I limiti per le prenotazioni devono essere specificati in ordine crescente [giorno,settimana,mese,anno]", Shi = "I limiti di durata devono essere specificati in ordine crescente [giorno, settimana, mese, anno]", Ehi = "Seleziona il calendario al quale aggiungere prenotazioni", xhi = "Nome evento personalizzato", Chi = "Crea nomi di eventi personalizzati da visualizzare nell'evento del calendario", Thi = "Codice di autenticazione a due fattori errato", Ahi = "A quale tipo di evento si applicherà?", Ihi = "Applica a tutti, inclusi i tipi di eventi futuri", Ohi = "Applica a tutti i tipi di eventi di team e utenti", Nhi = "A quale team si applica?", zhi = "I flussi di lavoro attivano una semplice automazione per inviare notifiche e promemoria che ti consentono di creare processi per i tuoi eventi.", Rhi = "Questa è un'impostazione interna e non influenzerà il modo in cui gli orari sono visualizzati nelle pagine di prenotazione pubbliche a te e a chiunque faccia una prenotazione.", Phi = "Crea un flusso di lavoro", Dhi = "Esegui questa operazione", Lhi = "Disattiva", Mhi = "Attiva", Fhi = "Le prenotazioni annullate non possono essere riprogrammate", qhi = "Impostazioni aggiornate correttamente", jhi = "Errore durante l'aggiornamento delle impostazioni", Vhi = "Il mio URL personale di {{appName}}", Bhi = "Scrivi qualcosa di te. Queste informazioni appariranno nella tua pagina personale.", Uhi = "Completa la configurazione e inizia", Ghi = "Questo utente non ha ancora aggiunto una biografia.", Whi = "Biografia", Hhi = "Elimina account", Yhi = "Eliminare il tuo account {{appName}}?", Khi = "Elimina il mio account", Zhi = "Inizio della settimana", Xhi = "Registrazioni", Jhi = "Registrazione", Qhi = "Buona pianificazione", evi = "Seleziona su quali calendari desideri controllare i conflitti per evitare doppie prenotazioni.", tvi = "Controlla conflitti", nvi = "Visualizza registrazioni", ovi = "Controlla le registrazioni", rvi = "Aggiungendo eventi a", ivi = "Segui le preferenze di sistema", avi = "Colori del marchio personalizzati", svi = "Personalizza la tua pagina di prenotazione con i colori del tuo marchio.", cvi = "Pro", lvi = "Rimuove tutte le scritte con il marchio {{appName}}, ad es., 'Powered by {{appName}}.'", uvi = "Riunione immediata con {{name}}", dvi = "Immagine del profilo", _vi = "Carica", pvi = "Aggiungi foto del profilo", mvi = "Indirizzo token", fvi = "Blockchain", gvi = "Vecchia password", hvi = "La tua nuova password super sicura", vvi = "Errore durante l'aggiornamento della password", bvi = "Autenticazione a due fattori", yvi = "Imposta una pianificazione ricorrente", $vi = "oggi", wvi = "Aspetto", kvi = "Il mio account", Svi = "Generale", Evi = "Calendari", xvi = "Fatture", Cvi = "Integrazioni", Tvi = "Accesso con altra identità", Avi = "Impostazioni per gestire gli accessi con altra identità", Ivi = "Impersonificazioni recenti", Ovi = "Impersonificazione rapida", Nvi = "Nessuna impersonificazione recente", zvi = "Utenti", Rvi = "Utente", Pvi = "Gestisci le impostazioni del tuo profilo {{appName}}", Dvi = "Qui è possibile trovare l'elenco di tutti gli utenti", Lvi = "Elenco degli utenti", Mvi = "Gestisci le impostazioni di lingua e fuso orario", Fvi = "Configura come i tipi di eventi devono interagire con i tuoi calendari", qvi = "Gestisci le impostazioni di aspetto delle tue prenotazioni", jvi = "Aggiungi le tue app di videoconferenza preferite per le tue riunioni", Vvi = "Aggiungi app di videoconferenza", Bvi = "Gestisci le impostazioni relative alle password del tuo account", Uvi = "Imposta l'autenticazione a due fattori", Gvi = "Abbiamo bisogno di alcune semplici informazioni per completare la configurazione del tuo profilo.", Wvi = "Salta", Hvi = "Più tardi", Yvi = "Definisci gli intervalli di tempo in cui sei disponibile", Kvi = "È possibile personalizzare queste impostazioni in un secondo tempo nella pagina della disponibilità.", Zvi = "Connetti prima un calendario", Xvi = "Completa il tuo profilo", Jvi = "È possibile aggiungere altri calendari dall'App store", Qvi = "Connetti app di conferenza", ebi = "Connetti app di calendario", tbi = "Connetti app di pagamento", nbi = "Connetti app di automazione", obi = "Connetti app di analisi", rbi = "Connetti altre app", ibi = "Connetti app di messaggistica", abi = "Connetti app CRM", sbi = "Passo {{currentStep}} di {{maxSteps}}", cbi = "Aggiungi variabile", lbi = "Numero di telefono personalizzato", ubi = "Modello di messaggio", dbi = "Oggetto e-mail", _bi = "Aggiungi variabili di testo dinamico", pbi = "Nome del tipo di evento", mbi = "Data dell'evento", fbi = "La durata dell'evento", gbi = "Ora di inizio dell'evento", hbi = "EventType non trovato", vbi = "Numero da chiamare", bbi = "Il numero di telefono dell'utente che stai chiamando", ybi = "Luogo", $bi = "Luogo dell'evento", wbi = "Note aggiuntive", kbi = "Note aggiuntive sulla prenotazione", Sbi = "Nome del partecipante", Ebi = "Nome dell'organizzatore", xbi = "A", Cbi = "Il flusso di lavoro {{workflowName}} è stato impostato come {{offOn}}", Tbi = "Scarica risposte", Abi = "Scarica tutte le risposte al tuo modulo in formato CSV.", Ibi = "Visualizza risposte", Obi = "Scarica", Nbi = "Download in corso", zbi = "Scarica registrazione", Rbi = "Le trascrizioni sono attivate", Pbi = "Le trascrizioni non sono attive", Dbi = "Scarica trascrizione", Lbi = "Trascrizione", Mbi = "La registrazione della tua recente chiamata su {{appName}} è pronta per il download", Fbi = "La trascrizione dalla tua recente chiamata su {{appName}} è pronta per essere scaricata. I link sono validi solo per 1 ora", qbi = "Puoi anche scaricare la trascrizione dagli allegati", jbi = "Nota: Il link per il download è valido solo per 12 ore. Puoi generare un nuovo link di download seguendo le istruzioni <1>qui</1>.", Vbi = "Nota: il link per il download è valido solo per 12 ore. Puoi generare un nuovo link per il download seguendo le istruzioni.", Bbi = "Crea il tuo primo modulo", Ubi = "I Moduli di instradamento consentono di porre domande qualificanti agli utenti per indirizzarli a persone o eventi pertinenti.", Gbi = "Crea il tuo primo Webhook", Wbi = "I Webhook consentono di ricevere in tempo reale le informazioni sulle riunioni quando succede qualcosa su {{appName}}.", Hbi = "Per un massimo di", Ybi = "evento", Kbi = "eventi", Zbi = "Gestisci le impostazioni del profilo del tuo team", Xbi = "Gestisci le impostazioni del profilo della tua organizzazione", Jbi = "Utenti nel gruppo", Qbi = "Gestisci gli amministratori e i membri della tua organizzazione", eyi = "URL del team", tyi = "Membri del team", nyi = "Altro", oyi = "Flussi di lavoro Cal.ai", ryi = "e altri {{count}}", iyi = "Consideriamo l'applicazione mobile un'estensione dell'applicazione web. Se stai eseguendo delle azioni complesse, ti invitiamo a fare riferimento all'applicazione web.", ayi = "Invia al partecipante un promemoria via SMS 24 ore prima dell'inizio dell'evento", syi = "Invia al partecipante un SMS personalizzato se l'evento viene riprogrammato", cyi = "Invia all'organizzatore un'e-mail personalizzata quando viene prenotato un nuovo evento", lyi = "Invia al partecipante un promemoria via e-mail un'ora prima dell'inizio dell'evento", uyi = "Invia all'organizzatore un'e-mail personalizzata se l'evento viene riprogrammato", dyi = "Invia all'organizzatore un SMS personalizzato quando viene prenotato un nuovo evento", _yi = "Invia promemoria SMS", pyi = "24 ore prima dell'inizio dell'evento", myi = "Segui chi non si presenta", fyi = "30 minuti dopo la fine dell'evento", gyi = "Ricorda ai partecipanti di portare un documento d'identità", hyi = "1 giorno prima dell'inizio dell'evento", vyi = "Promemoria via email", byi = "1 ora prima dell'inizio dell'evento", yyi = "Promemoria SMS personalizzato", $yi = "Quando l'evento viene programmato", wyi = "Promemoria email personalizzato", kyi = "L'evento viene riprogrammato per l'organizzatore", Syi = "Includi i conteggi delle prenotazioni dai tipi di eventi gestiti", Eyi = "Benvenuto in {{appName}}!", xyi = "Potrai modificarlo in seguito.", Cyi = "Connetterò il mio calendario più tardi", Tyi = "Si è verificato un problema durante il salvataggio dei dati. Riprova o contatta l'assistenza clienti.", Ayi = "Acquista posti mancanti", Iyi = "Durata della fascia oraria", Oyi = "Aspetto prenotazione", Nyi = "Gestisci le impostazioni di aspetto delle prenotazioni del tuo team", zyi = "Imposta l'aspetto delle prenotazioni per la tua organizzazione", Ryi = "Solo il proprietario del team può apportare modifiche alla prenotazione del team ", Pyi = "Rimuove tutte le scritte con il marchio {{appName}}, ad es., 'Powered by {{appName}}'", Dyi = "{{teamName}} ti ha invitato a unirti al team come {{role}}", Lyi = "Il token non è valido o è scaduto.", Myi = "Visualizza prenotazione", Fyi = "Connetti a Microsoft Exchange", qyi = "Metodo di autenticazione", jyi = "Autenticazione di base", Vyi = "Autenticazione NTLM", Byi = "Compressione GZip", Uyi = "Versione di Exchange", Gyi = "2007 SP1", Wyi = "2010", Hyi = "2010 SP1", Yyi = "2010 SP2", Kyi = "2013", Zyi = "2013 SP1", Xyi = "2015", Jyi = "2016", Qyi = "Instradamento", e$i = "Crea moduli per indirizzare i partecipanti alle destinazioni corrette", t$i = "Invia e-mail al proprietario", n$i = "Invia un'e-mail al proprietario quando il modulo viene inviato", o$i = "Invia email a", r$i = "Aggiungi nuovo modulo", i$i = "Aggiungi un nuovo modulo per il tuo team", a$i = "Crea il tuo primo percorso", s$i = "Instrada gli utenti verso la persona giusta in base alle risposte al modulo", c$i = "Modulo", l$i = "Crea un modulo per instradare le persone che prenotano", u$i = "Copia il link del modulo", d$i = "Tema della pagina di prenotazione", _$i = "Si applica solo alle pagine di prenotazione pubbliche", p$i = "Tema della dashboard", m$i = "Questo riguarda solo il pannello di controllo per cui hai effettuato l'accesso", f$i = "Predefinito di sistema", g$i = "Aggiungi un team", h$i = "Ricevi in tempo reale le informazioni sulle riunioni quando succede qualcosa su {{appName}}", v$i = "Viene attivato quando", b$i = "Esegui un test ping prima di creare.", y$i = "Abilita Webhook", $$i = "Aggiungi Webhook", w$i = "Webhook salvato", k$i = "Genera chiavi API per accedere al tuo account", S$i = "Nuova chiave API", E$i = "attivo", x$i = "Nome chiave API aggiornato", C$i = "Errore durante l'aggiornamento del nome della chiave API", T$i = "iframe HTML incorporato", A$i = "Incorpora tutti i tipi di eventi nel tuo sito web", I$i = "Crea la tua prima chiave API", O$i = "Le chiavi API consentono alle altre applicazioni di comunicare con {{appName}}", N$i = "Torna alla pagina di accesso", z$i = "Link per la reimpostazione inviato", R$i = "Un'email è in arrivo a {{email}} con le istruzioni per reimpostare la password.", P$i = "Se un'e-mail non ti dovesse arrivare a breve, assicurati che l'indirizzo specificato sia corretto e controlla la cartella della posta indesiderata. Se il problema persiste, contatta l'assistenza clienti.", D$i = "Password aggiornata!", L$i = "Pagamento in sospeso", M$i = "Inviti in sospeso", F$i = "Inviti in sospeso dell'organizzazione", q$i = "Non presente su {{appName}}", j$i = "Nessun calendario installato", V$i = "Non hai ancora collegato alcun calendario", B$i = "Aggiungi un calendario", U$i = "Potrebbe essere necessario disconnettersi e riconnettersi per vedere le modifiche applicate.", G$i = "Conferma la password prima di cambiare l'indirizzo e-mail", W$i = "posti", H$i = "Tutte le applicazioni pubblicate nell'App store di {{appName}} sono open source e sono state testate in modo approfondito attraverso una valutazione tra pari. Tuttavia, {{companyName}} non promuove né certifica tali applicazioni, a meno che siano pubblicate da {{appName}}. Se noti contenuti o comportamenti inappropriati, ti invitiamo a segnalarceli.", Y$i = "Segnala app", K$i = "Limita frequenza di prenotazione", Z$i = "Indica quante volte è possibile prenotare questo evento", X$i = "Mostra solo il primo slot disponibile di ogni giorno", J$i = "Questo limiterà la tua disponibilità per questo tipo di evento a uno slot al giorno, programmato al primo orario disponibile.", Q$i = "Limita durata totale prenotazione", ewi = "Indicare la quantità di tempo totale disponibile per prenotare questo evento", twi = "Limite di prenotazioni attive per il prenotante", nwi = "Limita il numero di prenotazioni attive che un prenotante può effettuare per questo tipo di evento", owi = "Gli eventi ricorrenti non supportano il limite di prenotazioni per il prenotante", rwi = "Aggiungi limite", iwi = "Nome del team richiesto", awi = "Condividi le informazioni dei partecipanti tra gli ospiti", swi = "Mostra il numero di posti disponibili", cwi = "Come utilizzare le domande poste nella pagina di prenotazione come variabili?", lwi = "Formato", uwi = "Domande", dwi = "Tutte le informazioni che il tuo prenotante dovrebbe fornire prima di prenotare con te.", _wi = "Usa tutte lettere maiuscole", pwi = "Sostituisci spazi con sottolineature", mwi = "Membri della piattaforma", fwi = "Gestisci gli amministratori e i membri del tuo team della piattaforma", gwi = "Fatturazione della piattaforma", hwi = "Gestisci fatturazione", vwi = "Gestisci tutto ciò che riguarda la fatturazione", bwi = "Attualmente stai usando il piano GRATUITO", ywi = "Si lavora meglio in squadra. Migliora i tuoi flussi di lavoro con eventi round robin o di gruppo e crea moduli di instradamento avanzati", $wi = "Prova ora", wwi = "Portale di fatturazione", kwi = "Contatta l'assistenza", Swi = "Ignora i caratteri speciali nell'identificatore della domanda posta in fase di prenotazione. Usa solo lettere e numeri", Ewi = "Riprova", xwi = "Si è verificato un problema durante il recupero dei calendari. <1>Riprova</1> o contatta l'assistenza clienti.", Cwi = "Impossibile connettersi al calendario", Twi = "Prenotazione confermata correttamente", Awi = "Prenotazione rifiutata correttamente", Iwi = "Questa prenotazione è provvisoria", Owi = "Ops! Desidero accettare", Nwi = "Questo messaggio non verrà più visualizzato", zwi = "Impossibile aggiornare il fuso orario", Rwi = "Fuso orario aggiornato a {{formattedCurrentTz}}", Pwi = "Aggiorna fuso orario", Dwi = "Aggiornare il fuso orario?", Lwi = "Sembra che il fuso orario locale sia stato cambiato in {{formattedCurrentTz}}. È molto importante che il fuso orario sia impostato correttamente per evitare prenotazioni in orari indesiderati. Vuoi aggiornare il fuso orario?", Mwi = "Non aggiornare", Fwi = "Richiedi note aggiuntive", qwi = "Chiedi di compilare le note aggiuntive al momento della prenotazione", jwi = "invia e-mail a un indirizzo e-mail specifico", Vwi = "dopo la fine dell'evento", Bwi = "quando la prenotazione viene rifiutata", Uwi = "quando viene richiesta una prenotazione", Gwi = "quando viene avviato il pagamento della prenotazione", Wwi = "quando il pagamento della prenotazione è andato a buon fine", Hwi = "quando lo stato no-show della prenotazione viene aggiornato", Ywi = "Quanto tempo dopo la fine dell'evento?", Kwi = "Quanto tempo dopo che gli host non si presentano alla riunione video di Cal?", Zwi = "Quanto tempo dopo che gli ospiti non si presentano alla riunione video di Cal?", Xwi = "Quanto tempo dopo che gli utenti non si presentano alla riunione video di Cal?", Jwi = "Nessuna fascia oraria disponibile", Qwi = "Tempo disponibile", eki = "Non trovi l'app di videoconferenza giusta? Visita il nostro <0>App Store</0>.", tki = "Installa nuova app di calendario", nki = "Rendi obbligatorio il numero di telefono per prenotare un evento", oki = "Disponibilità {{eventTypeTitle}}", rki = "Errore durante la modifica della disponibilità", iki = "Non hai l'autorizzazione per accedere a questa risorsa.", aki = "Incolla qui i metadati SAML forniti dal tuo provider di identità", ski = "Inserisci un indirizzo email che consenta di individuare il tuo provider di identità SAML", cki = "Dettagli del provider", lki = "Il tuo provider di identità (IdP) ti chiederà le seguenti informazioni per completare la configurazione dell'applicazione SAML.", uki = "URL dell'ACS", dki = "ID Entità SP", _ki = "URL dell'ACS copiato!", pki = "ID entità SP copiato!", mki = "Aggiungi calendario", fki = "Limita le prenotazioni future", gki = "Indica fino a che data è possibile prenotare questo evento", hki = "Nessun tipo di evento impostato", vki = "{{name}} non ha impostato alcun tipo di evento che puoi prenotare.", bki = "Frequenza di fatturazione", yki = "Mensile", $ki = "Annuale", wki = "Pagamento", kki = "Il tuo team è stato sciolto correttamente", Ski = "La tua organizzazione è stata sciolta", Eki = "Errore durante la creazione del team", xki = "Tu", Cki = "Oppure continua con", Tki = "Invia di nuovo l'e-mail", Aki = "Membro già invitato", Iki = "Nome utente già in uso", Oki = "Immettere un indirizzo e-mail o un nome utente", Nki = "Inserisci un'email", zki = "Inserisci email", Rki = "Puoi invitare un massimo di {{nbUsers}} utenti alla volta.", Pki = "Nome già utilizzato", Dki = "Necessario immettere un nome per il team", Lki = "Immettere un URL per il team", Mki = "URL già occupato", Fki = "Si è verificato un problema durante la registrazione del sottodominio, riprova o contatta un amministratore", qki = "Pubblica team", jki = "Numero di telefono (notifiche di testo)", Vki = "Numero di telefono (notifiche SMS)", Bki = "E-mail partecipante", Uki = "E-mail della persona che prenota", Gki = "UID prenotazione", Wki = "Digita un comando o esegui una ricerca...", Hki = "Errore! Sembra che l'autorizzazione sia scaduta o che sia stata revocata. Prova a reinstallare.", Yki = "Reinstalla app", Kki = "Motivo della riprogrammazione", Zki = "Scegli un programma comune", Xki = "Abilita questa opzione se desideri utilizzare un programma comune tra gli host. Quando disabilitata, ogni host sarà prenotato in base al proprio programma predefinito o a quello scelto.", Jki = "Motivo", Qki = "Id mittente", e0i = "Sono consentiti solo lettere, numeri e spazi (massimo 11 caratteri)", t0i = "Test modulo di instradamento", n0i = "Test anteprima", o0i = "Instrada a", r0i = "Esegui un test del modulo di instradamento senza inviare alcun dato", i0i = "Test instradamento", a0i = "Un amministratore ha disabilitato un'app di pagamento", s0i = "Modifica tipo di evento", c0i = "Questa organizzazione è privata e solo l'amministratore o il proprietario dell'organizzazione può visualizzare i suoi membri.", l0i = "Solo l'amministratore o il proprietario dell'organizzazione può gestire le impostazioni SSO", u0i = "Solo l'amministratore o il proprietario dell'organizzazione può gestire le impostazioni di sincronizzazione della directory", d0i = "Solo l'amministratore o il proprietario dell'organizzazione può gestire i client OAuth", _0i = "Pianificazione collettiva", p0i = "Facilita la prenotazione del tuo team quando tutti sono disponibili.", m0i = "Trova la persona più adatta disponibile e fai ruotare i membri del team.", f0i = "Round robin fisso", g0i = "Aggiungi un partecipante fisso e fai intervenire a turno altri partecipanti.", h0i = "{{appName}} funziona meglio in team", v0i = "Il team {{companyName}}", b0i = "Aggiungi i membri del tuo team ai tuoi tipi di eventi. Usa la pianificazione collettiva per includere tutti o trova la persona più adatta con la pianificazione round robin.", y0i = "È stato raggiunto il limite di prenotazione per questo tipo di evento", $0i = "È stato raggiunto il limite di durata per questo tipo di evento", w0i = "Un amministratore ha disabilitato {{appName}}", k0i = "Questo disabiliterà tutte le email a {{recipient}}. Ciò include conferme di prenotazione, richieste, riprogrammazioni e richieste di riprogrammazione, email di cancellazione e qualsiasi altra email relativa agli aggiornamenti delle prenotazioni.<br /><br />È tua responsabilità assicurarti che i tuoi {{recipient}} siano a conoscenza di eventuali prenotazioni e modifiche alle loro prenotazioni.", S0i = "Un amministratore ha disabilitato {{appName}}, il che ha effetto sul tuo tipo di evento {{eventType}}", E0i = "Un amministratore ha sostituito uno dei tuoi tipi di evento", x0i = "Un amministratore di team ha sostituito il tuo evento /{{slug}}", C0i = "Un amministratore del team <strong>{{teamName}}</strong> ha sostituito il tuo tipo di evento <strong>/{{slug}}</strong> con un tipo di evento gestito da lui controllato.", T0i = "Il tuo link continuerà a funzionare, ma alcune delle sue impostazioni potrebbero essere state cambiate. Puoi verificarlo nella sezione Tipi di evento.", A0i = "Per qualsiasi domanda sul tipo di evento, contatta il tuo amministratore.<br /><br />Ti auguriamo una piacevole esperienza di pianificazione, <br />Il team Cal.com", I0i = "L'amministratore ha disabilitato {{appName}} che influisce sul tuo tipo di evento {{title}}. I partecipanti possono ancora prenotare questo tipo di evento ma non verrà richiesto loro di pagare. Puoi nascondere il tipo di evento per evitare questo fino a quando l'amministratore non riabiliterà il tuo metodo di pagamento.", O0i = "I partecipanti possono ancora prenotare questo tipo di evento ma non verrà richiesto loro di pagare. Puoi nascondere il tipo di evento per evitare questo fino a quando l'amministratore non riabiliterà il tuo metodo di pagamento.", N0i = "L'amministratore ha disabilitato {{appName}}, il che ha effetto sul tuo tipo di evento {{title}}.", z0i = "L'amministratore ha disabilitato {{appName}}, il che potrebbe avere effetto sui tuoi tipi di eventi. Se hai dei tipi di eventi che utilizzano {{appName}} come luogo, allora verrà usato Cal Video come luogo predefinito.", R0i = "{{appName}} è stato disabilitato", P0i = "Vai alle app installate", D0i = "Se hai un altro calendario installato, le nuove prenotazioni saranno aggiunte a quel calendario. Altrimenti, collega un nuovo calendario in modo da non perdere nessuna nuova prenotazione.", L0i = "Abilita app", M0i = "Abilita le app che gli utenti possono integrare con {{appName}}", F0i = "Acquista una licenza", q0i = "Hai già un account?", j0i = "Ho già una chiave:", V0i = "Copia qui la variabile di ambiente CALCOM_LICENSE_KEY esistente.", B0i = "Crea Chiave di Licenza", U0i = "{{appName}} è abilitato", G0i = "{{appName}} è disabilitato", W0i = "Le chiavi sono state salvate", H0i = "Disabilita app", Y0i = "La disattivazione di questa app potrebbe causare problemi nell'interazione dei tuoi utenti con Cal", K0i = "Modifica chiavi", Z0i = "Abilita le app per la tua istanza di Cal", X0i = "Un elenco di tutti gli utenti nel tuo account, inclusi nome, titolo, email e ruolo.", J0i = "Qui puoi aggiungere un nuovo utente.", Q0i = "Qui puoi modificare un utente esistente.", e1i = "Qui puoi modificare un'organizzazione.", t1i = "Aggiungi nuovi client OAuth", n1i = "Blocca o sblocca l'invio di SMS per gli utenti", o1i = "Nessuna app disponibile", r1i = "Controlla che ci siano delle applicazioni nella tua distribuzione, in 'packages/app-store'", i1i = "Non ci sono applicazioni abilitate in questa istanza di Cal", a1i = "Nessuna applicazione configurata al momento", s1i = "È possibile abilitare le applicazioni nelle impostazioni", c1i = "Contatta il tuo amministratore", l1i = "Impostazioni delle app", u1i = "Compilare il campo", d1i = "Opzioni", _1i = "Immetti opzione {{index}}", p1i = "Aggiungi un'opzione", m1i = "Questa località esiste già. Seleziona una nuova località", f1i = "Pulsante di opzione", g1i = "Per utilizzare Google Meet, devi impostare il tuo calendario di destinazione su Google Calendar", h1i = "Persona", v1i = "Tutte le prenotazioni", b1i = "Tutti gli utenti", y1i = "Tutti i tipi di evento", $1i = "Le tue prenotazioni", w1i = "URL della riunione", k1i = "URL dell'evento, dell'incontro o della conferenza", S1i = "Configurazione date specifiche", E1i = "Cancella configurazione specifica per il {{date}}", x1i = "Aggiungi le date in cui la tua disponibilità differisce dall'orario giornaliero.", C1i = "Le configurazioni valide per date specifiche vengono archiviate automaticamente dopo tali date", T1i = "In quali orari sei libero/a?", A1i = "In quali orari sei occupato/a?", I1i = "Seleziona le date da configurare", O1i = "Non disponibile, per tutto il giorno", N1i = "Segna come non disponibile (tutto il giorno)", z1i = "Segna come non disponibile nelle date selezionate", R1i = "Aggiorna configurazione data specifica", P1i = "Configurazione delle date aggiunta correttamente", D1i = "Salva modifica", L1i = "{{slug}}-copia", M1i = "Imposta come predefinito", F1i = "Nascondi dettagli del tipo di evento", q1i = "Mostra navigazione", j1i = "Nascondi navigazione", V1i = "Codice di verifica inviato", B1i = "Verifica completata", U1i = "Codice di verifica errato", G1i = "Non ancora verificato", W1i = "Nessuna disponibilità in {{month}}", H1i = "La programmazione è disponibile solo fino a {{days}} giorni in anticipo. Controlla di nuovo a breve.", Y1i = "La pianificazione è terminata il {{date}}. Si prega di controllare nuovamente a breve.", K1i = "Visualizza mese precedente", Z1i = "Visualizza il mese successivo", X1i = "Invia codice", J1i = "Numero verificato", Q1i = "Crea il primo webhook per questo tipo di evento del team", eSi = "Crea un webhook per questo tipo di evento del team", tSi = "Disabilita pagina di conferma dell'esito (funziona solo se si dispone di un URL di reindirizzamento)", nSi = "Sei un amministratore, ma la tua password non ha la lunghezza minima di 15 caratteri, oppure non utilizzi ancora l'autenticazione a due fattori", oSi = "Cambia la tua password per ottenere l'accesso come amministratore", rSi = "Nome utente già in uso", iSi = "Assegnazione", aSi = "Organizzatori fissi", sSi = "Aggiungi organizzatori fissi", cSi = "Organizzatori round robin", lSi = "Numero di organizzatori necessario per partecipare", uSi = "Organizzatori", dSi = "Devi creare un team per abilitare questa funzionalità. Clicca qui per creare un team.", _Si = "Per abilitare questa funzione, è necessario eseguire l'upgrade al nostro piano Enterprise.", pSi = "Nuovo partecipante", mSi = "In attesa di approvazione", fSi = "L'app richiede una connessione a Google Calendar", gSi = `L'opzione "Aggiungi al calendario" per questo tipo di evento deve essere un Google Calendar affinché Meet funzioni. Collegalo <0>qui</0>.`, hSi = "È stato connesso un account di Google Calendar.", vSi = "Per usare Google Meet, è necessario connettere un account di Google Calendar", bSi = "Continua e installa Google Calendar", ySi = "Installa Google Meet", $Si = "Installa Google Calendar", wSi = "Nome mittente", kSi = "Partecipante già invitato", SSi = "Nessuna registrazione trovata", ESi = "Nuovo flusso di lavoro per...", xSi = "Reporting", CSi = "Visualizza tutti i dati in arrivo e scaricali in formato CSV", TSi = "Piano Team richiesto", ASi = "I moduli di instradamento sono un ottimo strumento per instradare i contatti in entrata verso le persone giuste. Per accedere a questa funzione, effettua l'upgrade al piano Team.", ISi = "Scegli una licenza", OSi = "Cal.com viene fornito con una licenza AGPLv3 accessibile e gratuita che ha alcune limitazioni e può essere convertita in una licenza Enterprise in qualsiasi momento. È possibile effettuare l'upgrade in un secondo tempo.", NSi = "Licenza", zSi = "Licenza AGPLv3", RSi = "Non è necessario che il codice rimanga open source", PSi = "Rivendi facilmente con un nuovo marchio", DSi = "Un'estesa suite di funzionalità enterprise", LSi = "0,00 $/mese", MSi = "Aperto e gratuito per sempre", FSi = "È necessario che il codice rimanga open source", qSi = "Non è possibile rivenderlo facilmente con un nuovo marchio", jSi = "Nessuna funzionalità enterprise", VSi = "Licenza Enterprise", BSi = "Tutto per un uso commerciale con hosting privato, rivendita con nuovo marchio e accesso ai componenti enterprise esclusivi.", USi = "Impostazione", GSi = "Imposta istanza Cal.com", WSi = "Configura", HSi = "Configurazione Single Sign-On", YSi = "Configura accesso SSO tramite SAML/OIDC e consenti ai membri del team di accedere utilizzando un provider di identità", KSi = "Configura l'accesso SSO con SAML/OIDC per consentire ai membri dell'organizzazione di accedere utilizzando un provider di identità", ZSi = "SSO con OIDC", XSi = "Configura accesso SSO tramite OIDC con un provider di identità di tua scelta.", JSi = "Configurazione OIDC", QSi = "Configura la connessione OIDC al tuo provider di identità. Puoi trovare le informazioni necessarie presso il tuo provider di identità.", eEi = "URL di callback copiato", tEi = "SSO con SAML", nEi = "Configura accesso SSO tramite SAML con un provider di identità di tua scelta.", oEi = "Configurazione SAML", rEi = "Configura la connessione SAML al tuo provider di identità. Puoi trovare le informazioni necessarie presso il tuo provider di identità.", iEi = "URL dell'ACS copiato", aEi = "ID entità copiato", sEi = "Configurazione {{connectionType}} creata correttamente", cEi = "Configurazione {{connectionType}} eliminata correttamente", lEi = "Eliminare la configurazione {{connectionType}}", uEi = "Sì, elimina la configurazione {{connectionType}}", dEi = "Eliminare la configurazione {{connectionType}}? I membri del tuo team che utilizzano l'accesso {{connectionType}} non saranno più in grado di accedere a Cal.com.", _Ei = "Fuso orario organizzatore", pEi = "Visualizza invito", mEi = "Accetta Invito", fEi = "Unisciti Ora", gEi = "Iscrizione completata con successo", hEi = "Sei stato invitato a unirti a un team dell'organizzazione {{parentTeamName}}", vEi = "Sei stato invitato a unirti a un'organizzazione {{appName}}", bEi = "{{invitedBy}} ti ha invitato a unirti al suo team su {{appName}}. {{appName}} è uno strumento di pianificazione di eventi che permette al tuo team di pianificare le riunioni senza scambiare decine di e-mail.", yEi = "{{invitedBy}} ti ha invitato a entrare nel team {{teamName}} della sua organizzazione {{parentTeamName}} su {{appName}}. {{appName}} è lo strumento di programmazione degli eventi che consente a te e al tuo team di programmare riunioni senza lo scambio di infinite email.", $Ei = "{{invitedBy}} ti ha invitato a unirti alla sua organizzazione `{{teamName}}` su {{appName}}. {{appName}} è uno strumento di pianificazione di eventi che permette a te e alla tua organizzazione di pianificare le riunioni senza scambiare decine di e-mail.", wEi = "Ti guideremo attraverso alcuni brevi passaggi e potrai goderti la pianificazione senza stress con la tua {{entity}} in pochissimo tempo.", kEi = "Scegli il tuo nome utente", SEi = "Collega il tuo account di calendario", EEi = "Imposta la tua disponibilità", xEi = "Unisciti a {{teamName}}", CEi = "Il team {{appName}} ti augura una piacevole esperienza di pianificazione", TEi = "Stai per effettuare l'accesso con altra identità; potrai cioè apportare modifiche a nome di un altro utente. Procedi con cautela.", AEi = "Variabili disponibili", IEi = "{Scheduler}", OEi = "Nessun flusso di lavoro", NEi = "Modifica il filtro per vedere i flussi di lavoro personali e di squadra.", zEi = "Cambia i criteri di filtro per vedere i risultati.", REi = "Nessun risultato per il filtro", PEi = "Passaggi successivi consigliati", DEi = "Crea un tipo di evento gestito", LEi = "Le riunioni sono efficaci quando sono presenti le persone giuste. Invitale adesso.", MEi = "Crea un modello uno a uno per un tipo di evento e distribuiscilo a più membri.", FEi = "Di gruppo o round robin", qEi = "Usa eventi di gruppo per riunire tutti i membri del team o eventi round robin per fare partecipare a rotazione le persone giuste.", jEi = "Non partecipa più a {{title}} con il seguente orario: {{date}}", VEi = "Non partecipi più a questo evento", BEi = "Un partecipante non partecipa più a {{title}} con il seguente orario {{date}}", UEi = "Un partecipante non partecipa più al tuo evento", GEi = "{{name}} ha disdetto. Di conseguenza, si è liberato un posto in questa fascia oraria", WEi = "Crea evento in", HEi = "Crea modulo di instradamento su", YEi = "Imposta il link dell'app predefinita", KEi = "L'impostazione di un link dell'app predefinita permette a tutti i nuovi tipi di eventi di usare il link dell'app impostato.", ZEi = "Applicazione predefinita dell'organizzatore", XEi = "{{organizer}} non ha un'app di conferenza predefinita", JEi = "Inattivo per manutenzione", QEi = "Il team di {{appName}} sta eseguendo la manutenzione programmata. Per qualsiasi domanda, contattare il supporto.", exi = "{{numberOfSeats}} posti", txi = "Domande per la prenotazione", nxi = "Personalizza le domande poste nella pagina di prenotazione", oxi = "Aggiungi una domanda", rxi = "Identificatore", ixi = "Indirizzo e-mail duplicato", axi = "Inserisci un URL di reindirizzamento verso cui il partecipante verrà inviato una volta terminata la riunione.", sxi = "Non è più possibile pagare per questo evento", cxi = "È in corso il rimborso del pagamento per questa prenotazione.", lxi = "Il pagamento per questa prenotazione è stato rimborsato.", uxi = "In base alla politica di rimborso dell'evento, il pagamento della prenotazione non è rimborsabile.", dxi = "Il periodo di rimborso dell'evento è scaduto. Pertanto, il pagamento della prenotazione non è rimborsabile.", _xi = "Conferma prenotazione non riuscita", pxi = "Posti insufficienti", mxi = "Esiste già un campo con questo nome", fxi = "Il campo ospiti deve essere di tipo 'Email multiple'", gxi = "Mostra nella pagina di prenotazione", hxi = "Puoi visitare la pagina della prenotazione annullata", vxi = "Inizia con i modelli Zapier", bxi = "Template standard", yxi = "Template Cal.ai", $xi = "{{team}} non è pubblicato", wxi = "Il link di questa organizzazione non è attualmente disponibile. Contatta il proprietario dell'organizzazione o chiedigli di pubblicarlo.", kxi = "Questo link di {{entity}} non è attualmente disponibile. Contatta il proprietario di {{entity}} o chiedigli di pubblicarlo.", Sxi = "Membro del team", Exi = "Un modulo di instradamento", xxi = "Descrizione modulo", Cxi = "Mantieni la connessione con il modulo", Txi = "Qualsiasi modifica apportata al router o ai campi del modulo duplicato si rifletterà nella copia. Tuttavia, l'eliminazione di un campo non lo rimuoverà dalla copia.", Axi = "Modulo eliminato", Ixi = "Confermi l'eliminazione del modulo?", Oxi = "Sì, elimina modulo", Nxi = "Gli utenti con cui hai condiviso il link non potranno più accedervi.", zxi = "Tutte le risposte associate verranno eliminate.", Rxi = "URL di reindirizzamento copiato! Puoi andare a impostare l'URL nel tuo modulo.", Pxi = "Le eventuali modifiche apportate ai campi e ai percorsi dei seguenti moduli si rifletteranno in questo modulo.", Dxi = "Moduli connessi", Lxi = "Le modifiche qui apportate a campi e percorsi si rifletteranno nei seguenti moduli.", Mxi = "Attendere che vengano raccolte alcune risposte. È possibile anche compilare e inviare il modulo personalmente.", Fxi = "Ecco cosa vedranno gli utenti", qxi = "Identifica il campo con questo nome.", jxi = "Aggiungi 1 opzione per riga", Vxi = "Seleziona un instradatore", Bxi = "Aggiungi un nuovo percorso", Uxi = "Prendi decisioni informate con Insights", Gxi = "Il pannello di controllo Insights offre una panoramica di tutte le attività del team e mostra le tendenze, il che consente di migliorare la pianificazione di gruppo e il processo decisionale.", Wxi = "Visualizza le prenotazioni di tutti i membri", Hxi = "Vedi chi riceve più prenotazioni e assicura la migliore distribuzione nel tuo team", Yxi = "Identifica le tendenze di prenotazione", Kxi = "Scopri quali giorni della settimana e quali fasce orarie sono popolari tra le persone che prenotano", Zxi = "Individua i tipi di evento popolari", Xxi = "Scopri quali tipi di evento ricevono più clic e prenotazioni", Jxi = "Per ora non ci sono risposte", Qxi = "Nessun percorso definito", eCi = "Questo sarà il segnaposto", tCi = "Si è verificato un errore durante la prenotazione dell'evento. Aggiorna la pagina e riprova", nCi = "Nessuna fascia oraria selezionata", oCi = "Seleziona una fascia oraria per prenotare l'evento.", rCi = "Seleziona fascia oraria", iCi = "Passa alla vista mensile", aCi = "Passa alla vista settimanale", sCi = "Passa alla vista giornaliera", cCi = "Passa alla vista colonna", lCi = "{{num}} opzioni di luogo", uCi = "Seleziona nel passaggio successivo", dCi = "Questa riunione non è ancora iniziata", _Ci = "{{appName}} richiede un account di {{dependencyName}} connesso", pCi = "Connetti {{dependencyName}}", mCi = "{{dependencyName}} è connesso", fCi = "Richiede {{dependencyName}}", gCi = "Codice di verifica", hCi = "Riprovare specificando un orario differente.", vCi = "Verifica", bCi = "Il fuso orario della persona che riceve la prenotazione", yCi = "Timezone", $Ci = "Ora di conclusione dell'evento", wCi = "Ora di conclusione dell'evento", kCi = "URL di annullamento", SCi = "URL per annullare la prenotazione", ECi = "Motivo della cancellazione", xCi = "Il motivo per la cancellazione della prenotazione", CCi = "URL di riprogrammazione", TCi = "URL per riprogrammare la prenotazione", ACi = "Motivo del cambio data", ICi = "Il motivo per il cambio data della prenotazione", OCi = "Nel nome dell'evento è presente una variabile non valida", NCi = "Seleziona tutto", zCi = "Aggiorna in blocco i tipi di eventi esistenti", RCi = "Pianificazione predefinita membro", PCi = "Impostato dall'amministratore del team", DCi = "Posizione predefinita del membro", LCi = "Useremo il programma di disponibilità predefinito di ciascun membro. I membri potranno modificarlo.", MCi = "È necessario avere almeno un programma", FCi = "Aggiorna le posizioni per i tipi di eventi selezionati", qCi = "Aggiorna i programmi per i tipi di eventi selezionati", jCi = "Bloccato per i membri", VCi = "Sbloccato per i membri", BCi = "I membri potranno vedere le app attive, ma non potranno modificare le impostazioni delle app", UCi = "I membri potranno vedere le app attive e modificare le impostazioni delle app", GCi = "Potrai vedere le app attive, ma non potrai modificare le impostazioni delle app", WCi = "Potrai vedere le app attive e modificare le impostazioni delle app", HCi = "I membri non possono aggiungere i loro flussi di lavoro personali a questo tipo di evento. I membri potranno vedere i flussi di lavoro attivi del team, ma non potranno modificare le impostazioni dei flussi di lavoro.", YCi = "I membri possono aggiungere i loro flussi di lavoro personali a questo tipo di evento. I membri potranno vedere i flussi di lavoro attivi del team, ma non potranno modificare le impostazioni dei flussi di lavoro.", KCi = "Potrai vedere i flussi di lavoro attivi del team, ma non potrai modificare le impostazioni dei flussi di lavoro né aggiungere i tuoi flussi di lavoro personali a questo tipo di evento.", ZCi = "Potrai attivare/disattivare flussi di lavoro personali su questo tipo di evento. Potrai vedere i flussi di lavoro attivi del team, ma non potrai modificare le impostazioni dei flussi di lavoro.", XCi = "I membri non possono aggiungere i propri webhook personali a questo tipo di evento. I membri potranno vedere i webhook attivi ma non potranno modificare alcuna impostazione dei webhook.", JCi = "I membri potranno aggiungere i propri webhook personali a questo tipo di evento. I membri potranno vedere i webhook attivi ma non potranno modificare alcuna impostazione dei webhook.", QCi = "Puoi vedere i webhook gestiti attivi ma non potrai modificare alcuna impostazione dei webhook o aggiungere i tuoi webhook personali a questo tipo di evento.", eTi = "Puoi aggiungere webhook a questo tipo di evento. Puoi vedere i webhook gestiti attivi ma non potrai modificarli.", tTi = "Bloccato dall'amministratore del team", nTi = "Non è stato connesso un account di {{appName}}.", oTi = "Connetti ora", rTi = "Sostituisci e invia notifica a {{count}} membro", iTi = "Sostituisci e invia notifica a {{count}} membri", aTi = "L'URL /{{slug}} esiste già per {{count}} membro. Vuoi sostituirlo?", sTi = "L'URL /{{slug}} esiste già per {{count}} membri. Vuoi sostituirlo?", cTi = "<strong>{{names}}</strong> utilizza già l'URL <strong>/{{slug}}</strong>.", lTi = "<strong>{{names}}</strong> utilizzano già l'URL <strong>/{{slug}}</strong>.", uTi = "Se decidi di sostituirlo, i membri ne saranno avvisati. Torna indietro e rimuovili se non desideri sovrascriverlo.", dTi = "Rivedi tipo di evento", _Ti = "Hai bisogno di più dati analitici?", pTi = "Ti servono più Insights?", mTi = "Filtri", fTi = "Filtra", gTi = "Aggiungi un membro", hTi = "Aggiungi filtro", vTi = "Aggiungi regola", bTi = "Aggiungi gruppo di regole", yTi = "Cancella tutti i filtri", $Ti = "Email verificata", wTi = "Seleziona utente", kTi = "Seleziona tipo di evento", STi = "Seleziona intervallo di date", ETi = "Eventi popolari", xTi = "Nessun tipo di evento trovato", CTi = "Durata media evento", TTi = "Prenotazioni per ora", ATi = "Membri più prenotati", ITi = "Membri meno prenotati", OTi = "Maggior numero di prenotazioni programmate", NTi = "Minor numero di prenotazioni programmate", zTi = "Maggior numero di prenotazioni completate", RTi = "Minor numero di prenotazioni completate", PTi = "Eventi creati", DTi = "Eventi completati", LTi = "Eventi annullati", MTi = "Eventi riprogrammati", FTi = "Eventi", qTi = "Prestazioni", jTi = "dal periodo precedente", VTi = "Da: {{startDate}} A: {{endDate}}", BTi = `Aggiungendo un reindirizzamento, viene disabilitata la pagina di conferma dell'esito. Assicurati che nella pagina di conferma dell'esito personalizzata compaia la dicitura "Prenotazione confermata".`, UTi = "Tendenze eventi", GTi = "Cancella filtri", WTi = "Cancella", HTi = "Preautorizzazione", YTi = "Raccogli pagamento alla prenotazione", KTi = "Addebita penale per mancata presentazione", ZTi = "Preautorizzazione carta", XTi = "Addebita carta", JTi = "Carta addebitata", QTi = "Penale per mancata presentazione: {{amount, currency}}", eAi = "Penale per mancata presentazione", tAi = "Invia carta", nAi = "Invia informazioni di pagamento", oAi = "La tua riunione è in attesa di un metodo di pagamento", rAi = "Una penale per mancata presentazione di {{amount, currency}} è stata addebitata per {{title}} alle {{date}}", iAi = "È stata addebitata una penale per mancata presentazione", aAi = "Una penale per mancata presentazione di {{amount, currency}} è stata addebitata per il seguente evento", sAi = "L'addebito della penale per mancata presentazione non è andato a buon fine. Riprovare più tardi.", cAi = "Riscuoti penale per mancata presentazione", lAi = "Penale per mancata presentazione addebitata", uAi = "Pagamento rifiutato. Prova con una carta diversa o contatta la tua banca per assistenza.", dAi = "Questo tipo di carta non è supportato per questo acquisto. Utilizza un metodo di pagamento diverso.", _Ai = "L'importo minimo del pagamento è $0.50 USD. Aumenta l'importo del pagamento.", pAi = "Non è stato possibile addebitare la carta per il pagamento.", mAi = "Approfondimenti", fAi = "Moduli di Routing", gAi = "Nessun dato trovato per il filtro selezionato o le date selezionate.", hAi = "Confermo che in caso di mia mancata partecipazione a questo evento, una penale per mancata presentazione di {{amount, currency}} verrà addebitata sulla mia carta.", vAi = "giorni", bAi = "Dati della carta", yAi = "Qualcosa è andato storto da parte nostra. Contatta il nostro team di supporto e risolveremo il problema immediatamente per te.", $Ai = "Fornisci il seguente testo quando contatterai il team di supporto per permeterci di aiutarti meglio", wAi = "Attualmente non è possibile abilitare i posti e addebitare la penale per mancata presentazione", kAi = "Completa la prenotazione", SAi = "Completa la prenotazione: {{title}} del {{date}}", EAi = "Conferma i tuoi dati", xAi = "Copia link d'invito", CAi = "Modifica impostazioni link", TAi = "Link d'invito copiato", AAi = "Link d'invito eliminato", IAi = "Chiave API eliminata", OAi = "Questa azione eliminerà permanentemente la chiave API. Tutte le applicazioni che utilizzano questa chiave perderanno immediatamente l'accesso al tuo account. Questa azione non può essere annullata.", NAi = "Impostazioni link d'invito salvate", zAi = "La scadenza dei link è impostata dopo...", RAi = "1 giorno", PAi = "7 giorni", DAi = "30 giorni", LAi = "3 mesi", MAi = "1 anno", FAi = "Hai ricevuto un invito a unirti al team {{teamName}}", qAi = "{{amount, currency}}", jAi = "Stai per addebitare {{amount, currency}} al partecipante. Confermi di voler proseguire?", VAi = "Addebita {{amount, currency}} al partecipante", BAi = "Richiedi un pagamento ({{paymentFeePercentage}}% + {{fee, currency}} di commissione per transazione)", UAi = "{{email}} è stato invitato", GAi = "{{userCount}} utenti sono stati invitati", WAi = "Errore durante l'elaborazione della carta", HAi = "Le dimensioni dell'immagine caricata non devono superare il limite di 5 MB", YAi = "{{errorCode}}: Non hai l'autorizzazione ad abilitare o disabilitare questo flusso di lavoro", KAi = "Elemento incorporato nella pagina", ZAi = "Carica il tuo tipo di evento direttamente nella pagina con gli altri contenuti del sito web.", XAi = "Pulsante a comparsa mobile", JAi = "Inserisce nel sito un pulsante mobile che attiva una finestra modale con il tuo tipo di evento.", QAi = "Finestra popup tramite clic su un elemento", e2i = "Apre la finestra di dialogo di Cal quando un utente fa clic su un elemento.", t2i = "Usa il mio modulo", n2i = "Usa la nostra API di routing headless e utilizza il tuo modulo per le sottomissioni.", o2i = "Hai bisogno di aiuto? Consulta le nostre guide per integrare Cal su Wix, Squarespace o WordPress, leggi le risposte alle domande più frequenti o esplora le opzioni di incorporamento avanzate.", r2i = "Prenota su Cal", i2i = "Nome", a2i = "Cognome", s2i = "Nome, cognome", c2i = "Invita come", l2i = "Modulo aggiornato correttamente.", u2i = "Disabilita le e-mail di conferma predefinite per i partecipanti", d2i = "Per questo tipo di evento è attivo almeno un flusso di lavoro che invia un'e-mail ai partecipanti quando l'evento viene prenotato.", _2i = "Disabilita le e-mail di conferma predefinite per gli organizzatori", p2i = "Per questo tipo di evento è attivo almeno un flusso di lavoro che invia un'e-mail agli organizzatori quando l'evento viene prenotato.", m2i = "Aggiungi configurazione specifica", f2i = "Importa utenti da Google Workspace", g2i = "Collega Google Workspace", h2i = "Per usare questa funzione è necessario essere amministratori di Workspace", v2i = "Crea il primo webhook per questo tipo di evento", b2i = 'Crea il tuo primo webhook con "Riunione immediata creata" come attivatore per questo tipo di evento', y2i = "Installa l'app su", $2i = "Crea per", w2i = "Valuta", k2i = "Crea un ambiente in cui i tuoi team possono creare app condivise, flussi di lavoro e tipi di eventi con round robin e pianificazione collettiva.", S2i = "Gestisci organizzazioni con più team", E2i = "Imposta la tua organizzazione", x2i = "Configura la tua piattaforma", C2i = "Le organizzazioni sono ambienti condivisi dove i team possono creare e condividere tipi di eventi, applicazioni, flussi di lavoro e altro ancora.", T2i = "Piani", A2i = "Piattaforma", I2i = "Gestisci tutto ciò che riguarda la piattaforma.", O2i = "La piattaforma Cal.com ti permette di integrare facilmente la pianificazione nella tua app utilizzando API e atom della piattaforma.", N2i = "È necessario inserire il nome dell'organizzazione", z2i = "È necessario inserire l'indirizzo e-mail dell'organizzazione", R2i = "Il tuo indirizzo e-mail nell'organizzazione", P2i = "Indirizzo email dell'amministratore", D2i = "Nome utente dell'amministratore", L2i = "Nome dell'organizzazione", M2i = "Nome della piattaforma", F2i = "URL dell'organizzazione", q2i = "Verifica il tuo indirizzo e-mail", j2i = "Usa il codice sottostante per verificare il tuo indirizzo e-mail e proseguire la configurazione dell'organizzazione.", V2i = "Parametri aggiuntivi dell'URL", B2i = "Informazioni sulla tua organizzazione", U2i = "Le organizzazioni sono ambienti condivisi dove è possibile creare dei team con condivisione di membri, tipi di eventi, applicazioni, flussi di lavoro e altro ancora.", G2i = "Crea i tuoi team", W2i = "Inizia la pianificazione condivisa aggiungendo i membri del tuo team alla tua organizzazione", H2i = "Invita gli amministratori dell'organizzazione", Y2i = "Gli amministratori avranno accesso a tutti i team della tua organizzazione. Puoi aggiungere amministratori e membri dei team in un secondo tempo.", K2i = "Imposta una password", Z2i = "Verrà creato un nuovo account utente con l'indirizzo e-mail della tua organizzazione e questa password.", X2i = "Logo dell'organizzazione", J2i = "Qualche informazione sulla tua organizzazione. Le informazioni appariranno nella pagina del profilo pubblico dell'organizzazione.", Q2i = "Lo farò più tardi", eIi = "Verifica l'e-mail", tIi = "Immetti il codice di 6 cifre che è stato inviato a {{email}}", nIi = "Verifica il tuo indirizzo e-mail per creare un'organizzazione", oIi = "Il codice immesso non è valido, riprova", rIi = "Indirizzo e-mail già in uso", iIi = "Hai ricevuto un invito a unirti a {{orgName}}", aIi = "Unisciti al tuo team su {{orgName}}, per concentrarti sulle riunioni e non sulla loro pianificazione!", sIi = "Non è stato possibile creare i seguenti team a causa di slug duplicati: {{slugs}}", cIi = "I nomi di team non possono essere vuoti", lIi = "I nomi di team devono essere unici", uIi = "L'utente appartiene a un'organizzazione", dIi = "Questa organizzazione non ha ancora alcun team", _Ii = "Se sei un amministratore, assicurati di creare dei team da mostrare qui.", pIi = "Imposta", mIi = "Il mio profilo", fIi = "Le mie impostazioni", gIi = "CRM", hIi = "Messaggistica", vIi = "Nome o numero mostrato come mittente di un SMS (alcuni paesi non consentono ID alfanumerici dei mittenti)", bIi = "Solo l'amministratore della tua organizzazione può creare nuovi team", yIi = "La nuova politica anti-spam di Google potrebbe impedirti di ricevere email e notifiche di calendario relative a questa prenotazione.", $Ii = "Risolvi", wIi = "Si è verificato un errore durante la creazione dei team per questa organizzazione. Slug URL mancante.", kIi = "Copia link all'organizzazione", SIi = "Team: {{teamName}}", EIi = "Utente: {{userName}}", xIi = "Visualizza insight sulle prenotazioni per tutti i tuoi eventi", CIi = "Cronologia chiamate", TIi = "Visualizza la cronologia delle chiamate effettuate con Cal.ai", AIi = "{{locationCount}} opzioni di luogo", IIi = "Tipo di canale", OIi = "Motivo di fine", NIi = "Stato della sessione", zIi = "Sentiment dell'utente", RIi = "Ora", PIi = "Da", DIi = "Piano personalizzato", LIi = "Incorporamento nell'e-mail", MIi = "Seleziona alcuni orari disponibili e incorporali nella tua e-mail", FIi = "Seleziona l'ora", qIi = "Seleziona la data", jIi = "Mostra solo se un parametro è impostato", VIi = "Aggiungi parametro", BIi = "Ti stiamo mettendo in contatto con qualcuno di {{orgName}}.", UIi = "Per favore, non chiudere o aggiornare questa pagina", GIi = "Vedi tutti gli orari disponibili", WIi = "ad es., team di marketing", HIi = "ad es., team vendite", YIi = "ad es., team di progettazione", KIi = "ad es., team di ingegneria", ZIi = "ad es., team di analisi dei dati", XIi = "Sarà possibile aggiungere altri team in un secondo momento.", JIi = "Qual è l'oggetto della riunione?", QIi = "Aggiungi al team", eOi = "Rimuovi utenti dall'organizzazione", tOi = "Credenziale di delega", nOi = "La credenziale di delega ti permette di gestire l'accesso ai calendari di Google Workspace per la tua organizzazione.", oOi = "Aggiungi questo Client Id in Google Workspace con lo scope indicato sotto", rOi = "Credenziale di delega abilitata", iOi = "Aggiungi credenziale di delega", aOi = "Modifica credenziale di delega", sOi = "Dominio", cOi = "Nessuna piattaforma workspace", lOi = "Piattaforma workspace", uOi = "Piattaforme workspace", dOi = "Gestisci le piattaforme workspace che possono essere utilizzate per la credenziale di delega", _Oi = "Modifica piattaforma workspace", pOi = "Modifica account di servizio", mOi = "Aggiungi piattaforma workspace", fOi = "Slug", gOi = "JSON chiave account di servizio", hOi = "Modifica JSON chiave account di servizio", vOi = "La credenziale di delega limita l'aggiunta di più di un'installazione", bOi = "App installata con successo e sta utilizzando le credenziali delegate", yOi = "Rimuovere {{userCount}} utenti da questa organizzazione?", $Oi = "Rimuovi utenti dal team", wOi = "Sei sicuro di voler rimuovere {{userCount}} utenti da questo team?", kOi = "Questo utente non ha ancora impostato alcuna pianificazione", SOi = "Questo utente non fa parte di nessun team", EOi = "Questo utente non ha ancora installato alcuna app", xOi = "Richiede la verifica dell'indirizzo e-mail della persona che prenota", COi = "Per garantire la verifica dell'indirizzo e-mail della persona che prenota prima di panificare eventi", TOi = "I messaggi di testo possono solo essere invitati ai partecipanti quando il tipo di evento richiede una conferma.", AOi = "Organizzazioni", IOi = "Carica il logo Cal Video", OOi = "Aggiorna il logo Cal Video", NOi = "Carica banner", zOi = "Per fare in modo che il tuo logo sia visibile sullo sfondo scuro del video Cal, carica un'immagine di colore chiaro in formato PNG o SVG per mantenere la trasparenza.", ROi = "Atri team", POi = "Qui puoi vedere i team di cui non fai parte all'interno della tua organizzazione. Puoi entrare a far parte di tali team se necessario.", DOi = "Non fai parte di alcuna organizzazione", LOi = "Nessun altro team trovato", MOi = "Non ci sono altri team in questa organizzazione.", FOi = "Nome del partecipante", qOi = "Cognome del partecipante", jOi = "Nome della persona che prenota", VOi = "Cognome della persona che prenota", BOi = "Riepilogo mensile", UOi = "Nome del membro", GOi = "Eventi più popolari", WOi = "Ecco il riepilogo degli eventi popolari per il tuo team {{teamName}} negli ultimi 30 giorni", HOi = "Io", YOi = "Incontro non disponibile", KOi = "Email di riepilogo mensile", ZOi = "E-mail di riepilogo mensili per i team", XOi = "Effettua la verifica del tuo team per abilitare l'invio di messaggi ai partecipanti", JOi = "Membro rimosso", QOi = "La mia disponibilità", eNi = "La disponibilità del team", tNi = "Disponibilità immediata per riunioni", nNi = "Codice di backup", oNi = "Codici di backup", rNi = "Ogni codice di backup può essere utilizzato soltanto una volta per concedere l'accesso senza l'autenticatore.", iNi = "Codici di backup copiati!", aNi = "Il codice di backup è errato.", sNi = "Accesso perso", cNi = "Nessun codice di backup trovato. Puoi generarli nelle impostazioni.", lNi = "Nuova organizzazione creata: azione in sospeso", uNi = "Ciao amministratore", dNi = "Un'organizzazione richiede la configurazione DNS", _Ni = `È stata creata un'organizzazione con lo slug "{{orgSlug}}".<br /><br />Assicurati di configurare il registro DNS in modo che il sottodominio corrispondente alla nuova organizzazione punti verso dov'è eseguita l'applicazione principale, altrimenti l'organizzazione non funzionerà.<br /><br />Ecco solo alcune opzioni molto basilari per configurare un sottodominio in modo che punti alla propria app e carichi la pagina del profilo dell'organizzazione.<br /><br />È possibile farlo utilizzando il record A:`, pNi = "O il record CNAME:", mNi = "Dopo aver configurato il sottodominio, contrassegnare la configurazione del DNS come completata nelle impostazioni di amministrazione dell'organizzazione.", fNi = "Vai alle impostazioni di amministrazione dell'organizzazione", gNi = "Organizzazione elaborata", hNi = "Si è verificato un errore durante l'elaborazione di questa organizzazione", vNi = "Un elenco di tutte le organizzazioni. Accettando un'organizzazione, tutti gli utenti con il rispettivo dominio e-mail potranno registrarsi SENZA verificare l'indirizzo e-mail.", bNi = "Non verificato", yNi = "Verificato", $Ni = "DNS mancante", wNi = "DNS Configurato", kNi = "Contrassegna DNS come configurato", SNi = "Valore", ENi = "L'organizzazione è stata aggiornata correttamente", xNi = "Questo team non ha nessun tipo di evento", CNi = "L'opzione di prenotazione dei posti non supporta durate multiple", TNi = "Includi evento del calendario", ANi = "OAuth", INi = "Modulo di creazione client OAuth", ONi = "Questo è il modulo per creare un nuovo client OAuth", NNi = "Modulo di aggiornamento client OAuth", zNi = "Questo è il modulo per modificare un client OAuth esistente", RNi = "Aggiunti di recente", PNi = "Collega tutti i tuoi calendari", DNi = "{{appName}} legge la disponibilità da tutti i tuoi calendari esistenti.", LNi = "Personalizza la tua esperienza di programmazione con i flussi di lavoro", MNi = "Automazione dei flussi di lavoro", FNi = "Usa la programmazione collettiva e round robin per il tuo team", qNi = "Nessun membro trovato", jNi = "Directory Sync", VNi = "Nome directory", BNi = "Provider directory", UNi = "URL base SCIM", GNi = "Token SCIM al portatore", WNi = "ULR base SCIM copiato", HNi = "Token SCIM al portatore copiato", YNi = "Il tuo provider di identità chiederà le seguenti informazioni per configurare SCIM. Segui le istruzioni per completare la configurazione.", KNi = "Configura sincronizzazione directory", ZNi = "Scegli un provider di identità per configurare la directory per il tuo team.", XNi = "Configurare un provider di identità per iniziare con SCIM.", JNi = "Connessione per sincronizzazione directory creata.", QNi = "Crea ed elimina account degli utenti presso il servizio di directory.", ezi = "Connessione per sincronizzazione directory eliminata.", tzi = "Elimina Connessione", nzi = "Elimina connessione di sincronizzazione directory", ozi = "Confermi di voler eliminare questa connessione di sincronizzazione directory?", rzi = "Questa operazione non può essere annullata. Eliminerà definitivamente la connessione di sincronizzazione della directory.", izi = "Impostazione evento: la durata deve essere di almeno 1 minuto.", azi = "Calendario disponibilità", szi = "Non autorizzato", czi = "{{clientName}} vorrebbe accedere al tuo account {{appName}}", lzi = "Seleziona un account o un team", uzi = "Ciò consentirà a {{clientName}} di", dzi = "Associarti con i tuoi dati personali da {{clientName}}", _zi = "Vedere i tuoi dati personali, inclusi i dati personali che hai reso disponibili al pubblico", pzi = "Vedere il tuo indirizzo e-mail principale", mzi = "Connettersi alle tue applicazioni installate", fzi = "Leggere, modificare, eliminare i tuoi tipi di eventi", gzi = "Leggere, modificare, eliminare la tua disponibilità", hzi = "Leggere, modificare, eliminare le tue prenotazioni", vzi = "Consentire a {{clientName}} di farlo?", bzi = "Facendo clic su Consenti, consentirai a questa applicazione di usare i tuoi dati in conformità ai suoi termini di servizio e informativa sulla privacy. Puoi revocare l'accesso nelle impostazioni di {{appName}} nell'App Store.", yzi = "Consenti", $zi = "Questo utente non ha completato l'onboarding. Non sarai in grado di impostare la sua disponibilità fino a quando non avrà completato l'onboarding.", wzi = "Stai visualizzando la disponibilità di questo utente. Puoi solo modificare la tua disponibilità.", kzi = "Puoi configurare queste impostazioni su base per evento nelle impostazioni avanzate di ciascun tipo di evento.", Szi = "Modifica la disponibilità dell'utente: {{username}}", Ezi = "Invia di nuovo l'invito", xzi = "L'invito è stato inviato di nuovo.", Czi = "SAML", Tzi = "Aggiungi cliente", Azi = "Dopo aver copiato questa parola segreta non sarai più in grado di vederla", Izi = "Aggiungi nuovo cliente", Ozi = "Aggiungi nuovo utente", Nzi = "Questa applicazione non è stata ancora impostata", zzi = "come CSV", Rzi = "Sovrapponi il mio calendario", Pzi = "Collegando il tuo calendario, accetti la nostra informativa sulla privacy e i termini di servizio. Puoi revocare l'accesso in qualsiasi momento.", Dzi = "Visualizza gli eventi del tuo calendario per prevenire prenotazioni in conflitto.", Lzi = "Partecipa a {{eventLocationType}}", Mzi = "Risoluzione problemi", Fzi = "Calendari che stiamo controllando per conflitti", qzi = "Programmi di disponibilità", jzi = "Gestisci calendari", Vzi = "Gestisci programmi di disponibilità", Bzi = "Bloccato", Uzi = "Sbloccato", Gzi = "Blocca fuso orario nella pagina di prenotazione", Wzi = "Per bloccare il fuso orario nella pagina di prenotazione, utile per gli eventi di persona.", Hzi = "Puoi avere solo un'app di pagamento abilitata per ciascun tipo di evento.", Yzi = "Inserisci il numero in formato internazionale.", Kzi = "Installa Calendario", Zzi = "Sottodominio del marchio", Xzi = "Crea un sottodominio per il tuo marchio, come acme.cal.com", Jzi = "Approfondimenti a livello di organizzazione", Qzi = "Comprendi come la tua organizzazione utilizza il tempo", eRi = "Assistenza per l'onboarding e supporto tecnico dedicati", tRi = "Personalizza la tua esperienza di programmazione con il tuo logo, colori e altro ancora", nRi = "Numero illimitato di team", oRi = "Verifica email", rRi = "Inserisci l'indirizzo email utilizzato per questa prenotazione per procedere con la cancellazione", iRi = "L'email non corrisponde all'email di prenotazione", aRi = "Aggiungi alla tua organizzazione tutti i sotto-team necessari", sRi = "Fatturazione unificata", cRi = "Tipi di evento gestiti avanzati", lRi = "Indica una singola carta di credito per pagare tutti gli abbonamenti del tuo team", uRi = "Impresa", dRi = "Passa a Enterprise per creare la tua organizzazione", _Ri = "Crea la tua organizzazione", pRi = "Crea organizzazione", mRi = "Passa a Organizations per avere sottodominio, fatturazione unificata, approfondimenti, personalizzazione completa e altro ancora", fRi = "Passa a Enterprise per poter utilizzare la sincronizzazione per Active Directory, la configurazione automatica SCIM degli utenti, gli operatori vocali Cal.ai, l'API di amministrazione e altro ancora!", gRi = "Puoi attivare solo un'app di pagamento per ciascun tipo di evento", hRi = "I team che sono membri di questa organizzazione saranno eliminati insieme ai loro tipi di eventi", vRi = "Gli utenti che facevano parte dell'organizzazione non saranno eliminati, ma i loro nomi utente verranno modificati per consentire loro di esistere al di fuori dell'organizzazione", bRi = "I tipi di eventi utente creati dopo che l'utente è entrato nell'organizzazione saranno eliminati", yRi = "I tipi di eventi utente migrati non saranno eliminati", $Ri = "Eliminare {{organizationName}}?", wRi = "Pubblicato", kRi = "Pubblicazione annullata", SRi = "Pubblica", ERi = "Apri lo strumento di soluzione dei problemi per individuare il problema del tuo programma", xRi = "Hai bisogno di aiuto?", CRi = "Risoluzione problemi", TRi = "Numero da chiamare", ARi = "Nome ospite", IRi = "E-mail ospite", ORi = "Azienda ospite", NRi = "Installa un calendario", zRi = "Prenotazione immediata", RRi = "Consenti alle persone di prenotare immediatamente", PRi = "Passa a Enterprise e permetti agli ospiti di partecipare a una chiamata immediata a cui i partecipanti possono accedere direttamente. Ciò è riservato agli eventi per team", DRi = "Non vuoi aspettare?", LRi = "Riunione iniziata", MRi = "Pagare per prenotare", FRi = "Consenti agli operatori IA di prenotare", qRi = "Prenotazione non trovata", jRi = "I posti sono esauriti", VRi = "Credenziali di pagamento mancanti", BRi = "ID dell'app di pagamento mancante", URi = "La prenotazione non ha abbastanza posti disponibili", GRi = "{{username}} è attualmente assente per un breve periodo.", WRi = "Nel frattempo, {{profile.username}} sarà responsabile di tutte le nuove riunioni programmate per conto di {{username}}.", HRi = "Assente", YRi = "Configura le azioni nel tuo profilo mentre sei assente.", KRi = "Invia richiesta", ZRi = "Data iniziale e data finale sono obbligatorie", XRi = "La data iniziale deve precedere quella finale", JRi = "La data iniziale deve essere nel futuro", QRi = "Utente non trovato", ePi = "Impossibile reindirizzare a se stesso", tPi = "La voce per l'assenza esiste già", nPi = "L'ID della voce per l'assenza è obbligatorio", oPi = "Esiste già un reindirizzamento della prenotazione dall'utente a te.", rPi = "Nuova voce creata correttamente", iPi = "Notifica di reindirizzamento prenotazione", aPi = "Notifica di reindirizzamento prenotazione", sPi = "Hai ricevuto un reindirizzamento di prenotazione da {{eventOwner}}, quindi i loro link del profilo saranno reindirizzati ai tuoi per l'intervallo di tempo {{dates}}.", cPi = "Notifica di modifica del reindirizzamento della prenotazione", lPi = "Notifica di Modifica del Reindirizzamento della Prenotazione", uPi = "Il tuo reindirizzamento di prenotazione da {{eventOwner}} per l'intervallo di tempo {{oldDates}} è stato aggiornato. Il nuovo intervallo di tempo per il reindirizzamento è {{dates}}.", dPi = "Notifica di cancellazione del reindirizzamento della prenotazione", _Pi = "Notifica di Cancellazione del Reindirizzamento della Prenotazione", pPi = "Il tuo reindirizzamento di prenotazione da {{eventOwner}}, per l'intervallo di tempo {{dates}}, è stato annullato.", mPi = "Hai accettato questa richiesta di reindirizzamento delle prenotazioni.", fPi = "Hai rifiutato questa richiesta di reindirizzamento delle prenotazioni.", gPi = "Copia link per condividere la richiesta", hPi = "Richiesta di reindirizzamento delle prenotazioni", vPi = "Seleziona un membro del team", bPi = "Devi assentarti? Segnala che il link al tuo profilo non è disponibile per un periodo.", yPi = "Rendirizza il tuo profilo a un altro membro del team", $Pi = "Reindirizza il tuo profilo a un altro membro del team (è necessario il piano Team)", wPi = "Elenco di indisponibilità per assenza", kPi = "Voce eliminata", SPi = "Voce modificata con successo", EPi = "Temporaneamente assente?", xPi = "Aggiungi un reindirizzamento", CPi = "Crea una voce", TPi = "Intervallo temporale", APi = "Aggiungi tutti i membri del team, compresi quelli futuri", IPi = "Reindirizza a", OPi = "Non riesci a trovare un orario?", NPi = "Mostra altro", zPi = "Parametri di inoltro come ?email=...&name=.... e altri", RPi = "Pianifica le riunioni quando tutti sono disponibili, oppure ruota tra i membri del tuo team", PPi = "più basso", DPi = "basso", LPi = "medio", MPi = "alto", FPi = "più alto", qPi = "Rimanda la persona che prenota a", jPi = "Imposta priorità", VPi = "Imposta Peso", BPi = "Abilita Pesi", UPi = "Priorità per {{userName}}", GPi = "I pesi determinano come le riunioni vengono distribuite tra gli host. <0>Scopri di più</0>", WPi = "Peso per {{userName}}", HPi = "cambia priorità", YPi = "Usa gli identificatori di campo come variabili per il reindirizzamento dell'evento personalizzato", KPi = "Usa gli identificatori di campo come variabili per il reindirizzamento dell'evento personalizzato (es: {{variable}})", ZPi = "L'account è già collegato", XPi = "Invia e-mail", JPi = "Chiama il partecipante usando l'agente vocale Cal.ai", QPi = "Chiama per confermare la prenotazione", eDi = "2 ore prima dell'inizio dell'evento", tDi = "Configurazione agente Cal.ai", nDi = "Seleziona almeno un tipo di evento per effettuare una chiamata di prova.", oDi = "Contrassegna come Mancata presentazione", rDi = "Elimina contrassegno di Mancata presentazione", iDi = "Account scollegato correttamente", aDi = "Si è verificato un errore nello scollegare l'account", sDi = "Programma di viaggio", cDi = "Pianifica il tuo viaggio anticipatamente per mantenere il tuo programma esistente in un fuso orario diverso ed evitare di avere prenotazioni a mezzanotte.", lDi = "Programma un cambio di fuso orario", uDi = "Data", dDi = "Inserisci il prompt generale per l'agente", _Di = "Si sovrappone con un altro programma. Seleziona una data diversa.", pDi = "Ricevi una notifica quando il tuo team non ha disponibilità", mDi = 'Gli amministratori riceveranno una notifica via email quando un utente cerca di prenotare un membro del team e riceve il messaggio "Nessuna disponibilità". Questa email viene attivata dopo due casi, e riceverai un promemoria ogni 7 giorni per ciascun utente.  ', fDi = "Disabilita le notifiche SMS per i tipi di evento solo telefonici", gDi = "Disabilita le notifiche SMS automatiche per i tipi di evento che hanno solo il numero di telefono (attendeePhoneNumber) come domanda obbligatoria con email facoltativa o non richiesta", hDi = "Il tuo piano attuale", vDi = "$37 per utente al mese", bDi = "Gestisci le impostazioni della privacy per la tua organizzazione", yDi = "Privacy", $Di = "I nuovi team saranno nella tua organizzazione", wDi = "Aggiungi nome gruppo", kDi = "Nome gruppo", SDi = "Instradatori", EDi = "Principale", xDi = "Rendi principale", CDi = "Aggiungi Email", TDi = "Aggiungi Email", ADi = "Aggiungi un indirizzo email con cui sostituire quello principale o da utilizzare come email alternativa per i tipi di evento.", IDi = "Conferma la tua email", ODi = "$t(hey_there) {{name}}, confermiamo la tua prenotazione per il {{date}}.", NDi = "Nome della persona che prenota", zDi = "Cognome della persona che prenota", RDi = "Nome del Pianificatore", PDi = "Il tuo nome", DDi = "Abbiamo inviato un'email a <strong>{{email}}</strong>. Clicca sul link nell'email per verificare questo indirizzo.", LDi = "Invia dettagli evento a", MDi = "Pianifica fuso orario senza data finale", FDi = "Seleziona membri", qDi = "Cosa si deve fare con i tipi di eventi esistenti di questo membro?", jDi = "Tutti i tipi di evento individuali dei membri (tranne quelli gestiti) verranno eliminati definitivamente. Non potranno crearne di nuovi", VDi = "I tipi di eventi individuali dei membri (tranne quelli gestiti) non saranno visibili nei profili, ma i link rimarranno attivi. Non potranno crearne di nuovi.  ", BDi = "Nascondi tipi di evento individuali", UDi = "Elimina tipi di evento individuali", GDi = "Blocca la creazione di tipi di evento individuali", WDi = "Impedisci ai membri di creare propri tipi di evento.", HDi = "Aggiungi al tipo di evento", YDi = "Crea password per l'account", KDi = "Crea un account con SAML", ZDi = "Non è stato possibile creare la password per l'account", XDi = "Impossibile creare password per gli account cal", JDi = "Impossibile creare password per account già creati", QDi = "Non hai una password per l'account, creane una andando su Sicurezza -> Password. La disconnessione non è possibile finché non viene creata una password per l'account.", e3i = "Disconnetti l'account", t3i = "La disconnessione dell'account modifica la tua modalità di accesso. Potrai accedere all'account solamente tramite email + password", n3i = "Accetto l'informativa sulla privacy e l'uso dei cookie", o3i = "Fai una chiamata", r3i = "Salta assegnazione round robin se il contatto è esistente in Salesforce", i3i = "L'URL deve contenere l'email del contatto come parametro. Esempio: ?email=contactEmail", a3i = "Seleziona account", s3i = "Installa {{appName}} nel tuo account personale o in un account di gruppo.", c3i = "Seleziona tipi di evento", l3i = "Su quale tipo di evento vuoi installare {{appName}}?", u3i = "Configura {{appName}}", d3i = "Completa l'installazione dell'app. Puoi modificare le impostazioni in seguito.", _3i = "già installata", p3i = "Non specificato", m3i = "Vacanza", f3i = "Viaggio", g3i = "Assenza per malattia", h3i = "Festività pubblica", v3i = "Inoltro a <0>{{username}}</0>", b3i = "Nessun inoltro", y3i = "Crea un'assenza", $3i = "Comunica alle persone interessate quando non sarai disponibile per le prenotazioni. Potranno comunque prenotare incontri con te al tuo ritorno, oppure puoi indirizzarli a un altro membro del tuo team.", w3i = "{{displayName}} è assente", k3i = "<0>{{displayName}}</0> può incaricarsi delle sue riunioni durante la sua assenza.", S3i = "Prenota {{displayName}}", E3i = "Seleziona motivo", x3i = "Inizia assenza", C3i = "Modifica Voce Fuori Ufficio", T3i = "Invia feedback", A3i = "L'organizzatore non si è presentato", I3i = "Puoi programmare un nuovo incontro", O3i = "Come possiamo migliorare il nostro servizio?", N3i = "Cosa ti è piaciuto di più?", z3i = "Rivedere", R3i = "Con recensione", P3i = "Senza recensione", D3i = "URL di valutazione", L3i = "L'URL del modulo di valutazione", M3i = "URL per mancata presenza", F3i = "L'URL del modulo per Mancata presentazione", q3i = "Assistenza non necessaria?", j3i = "Nascondi assistenza", V3i = "Valutazione media", B3i = "Assenza (Host)", U3i = "Assenza (Ospite)", G3i = "Valutazioni recenti", W3i = "Nessuna valutazione inviata", H3i = 'Aggiungi un flusso di lavoro con "Valutazione" per raccogliere valutazioni dopo gli incontri', Y3i = "Host con più assenze", K3i = "Valutazione più alta", Z3i = "Valutazione più bassa", X3i = "Membri con la valutazione più alta per gli incontri", J3i = "Membri con la valutazione più bassa per gli incontri", Q3i = "Punteggio CSAT", eLi = "SMS bloccati", tLi = "Uscire senza effettuare assegnazioni?", nLi = "Confermi di voler uscire da questo evento senza aggiungere partecipanti?", oLi = "Se non assegni nessuno a questo evento, chi prenota non vedrà alcuna disponibilità.", rLi = "Torna indietro ed effettua assegnazione", iLi = "Esci senza assegnazioni", aLi = "Proseguendo, accetti i nostri <0>Termini</0> e l'<1>Informativa sulla privacy</1>.", sLi = "Procedendo, accetti i nostri", cLi = "Termini", lLi = "Sempre {{x}} giorni disponibili", uLi = "Sposta automaticamente avanti ogni giorno la finestra di prenotazione di {{x}} giorni, assicurando che il tuo calendario mostri sempre i prossimi {{x}} giorni di slot disponibili.", dLi = "Abbonamento del team annullato con successo", _Li = "Errore durante l'annullamento dell'abbonamento del team", pLi = "Si è verificato un errore durante il tentativo di abbonamento al piano Platform, riprova più tardi", mLi = "Si è verificato un errore durante l'aggiornamento del client OAuth, riprova più tardi", fLi = "Si è verificato un errore in fase di creazione del client OAuth, riprova più tardi", gLi = "Colore del tipo di evento", hLi = "Questo è utilizzato solo per la differenziazione dei tipi di eventi e delle prenotazioni all'interno dell'app. Non viene visualizzato ai prenotatori.", vLi = "Contrassegna come Mancata presentazione", bLi = "{{x}} contrassegnati come Mancata presentazione", yLi = "Rimossi {{x}} contrassegni di Mancata presentazione", $Li = "attiva per tutti i tipi di eventi del team e per tutti i tipi di eventi personali dei membri del team", wLi = "Gestisci le impostazioni del tuo team", kLi = "Stato di Mancata presentazione aggiornato per i partecipanti", SLi = "Email copiata", ELi = "Numero di telefono copiato", xLi = "L'utente è un membro in sospeso dell'organizzazione", CLi = "L'utente è già stato invitato o è un membro", TLi = "L'utente è membro di un'organizzazione di cui questo team non fa parte.", ALi = "La prenotazione è stata riassegnata", ILi = "Riassegna", OLi = "Riassegna la prenotazione a un altro host round robin disponibile", NLi = "Assegna membro del team", zLi = "Sostituisci il membro del team che vuoi assegnare.", RLi = "Nessun host disponibile", PLi = "Riassegna host round robin", DLi = "Non scrivere nel feed ICS", LLi = "Non è possibile riprogrammare poiché l'evento è scaduto", MLi = "Questo evento è scaduto", FLi = "Salta la creazione di contatti se non esistono in {{appName}}", qLi = "Se il tuo link ICS è in sola lettura (ad esempio, Proton Calendar), seleziona la casella sopra per evitare errori. Dovrai anche aggiornare manualmente il tuo calendario per le modifiche.", jLi = "Attributi", VLi = "Nuovo attributo", BLi = "Aggiungi attributi", ULi = "Aggiungi attributi ai membri del tuo team", GLi = "Nuova opzione", WLi = "Aggiorna membro", HLi = "Attributo", YLi = "Crea un attributo per i membri del tuo team", KLi = "Modifica un attributo per i membri del tuo team", ZLi = "Attributo aggiornato con successo", XLi = "Attributo eliminato con successo", JLi = "Attributi modificati con successo", QLi = "Gestisci gli attributi per i membri del tuo team", eMi = "Modifica gli attributi per i membri del tuo team", tMi = "Torna agli attributi", nMi = "Sei sicuro di voler eliminare questa opzione?", oMi = "Questa opzione è assegnata a {{numberOfUsers}} membri. Eliminandola, verrà rimossa dal loro profilo.", rMi = "Disabilita le email standard ai partecipanti relative a questo tipo di evento", iMi = "Disabilita la comunicazione email standard relativa a questo tipo di evento, incluse le conferme di prenotazione, i promemoria e le cancellazioni.", aMi = "Disabilita le email standard agli host relative a questo tipo di evento", sMi = "Digita conferma per continuare", cMi = "Disabilita email", lMi = "Concedi accesso API amministratore", uMi = "Revoca accesso API amministratore", dMi = "Aggiungi il calendario {{calendar}}", _Mi = "Connetti Calendario Apple", pMi = "Calendario Apple connesso", mMi = "Verifica Calendario Apple", fMi = "Connetti Calendario Google", gMi = "Calendario Google connesso", hMi = "Verifica Calendario Google", vMi = "Connetti Calendario Outlook", bMi = "Calendario Outlook connesso", yMi = "Verifica Calendario Outlook", $Mi = "Collegati a Stripe", wMi = "Stripe collegato", kMi = "Verifica delle credenziali Stripe in corso", SMi = "Variabili di risposta alle domande di prenotazione", EMi = "Gestito da {{teamAdmins}}", xMi = "{{count}} opzioni", CMi = "Ripianifica con lo stesso host Round-Robin", TMi = "Gli eventi ripianificati saranno assegnati allo stesso host inizialmente programmato", AMi = "Disabilita input se l'identificatore URL è precompilato", IMi = "Limiti di Prenotazione", OMi = "Limiti di prenotazione per i membri del team in tutti i tipi di eventi del team", NMi = "Limita quante volte i membri possono essere prenotati su tutti i tipi di eventi del team", zMi = "Limiti di prenotazione aggiornati con successo", RMi = "Non sei autorizzato a effettuare questa modifica alla prenotazione", PMi = "Credenziale di delega disabilitata", DMi = "Membri corrispondenti", LMi = "{{x}} membri corrispondenti", MMi = "Coda di membri corrispondenti (utilizzando i pesi degli attributi)", FMi = "Coda di membri corrispondenti (utilizzando i pesi degli assegnatari dell'evento)", qMi = "Nessun membro corrispondente. Verrà utilizzato il fallback con i membri del team assegnati al tipo di evento.", jMi = "Nessun membro corrispondente. Si utilizzeranno i membri del team assegnati al tipo di evento come fallback. Considera di aggiungere un fallback o correggere la logica di using_fallback_members", VMi = "Nascondi i dettagli degli eventi del calendario nei calendari condivisi", BMi = "Quando un calendario è condiviso, gli eventi sono visibili ai lettori ma i loro dettagli sono nascosti a chi non ha accesso in scrittura.", UMi = "Ultimi {{count}} giorni", GMi = "Mese corrente", WMi = "Anno corrente", HMi = "Intervallo personalizzato", YMi = "Politica di rimborso", KMi = "Sempre", ZMi = "Mai", XMi = "Opzione di pagamento", JMi = "Se cancellato", QMi = "prima", e4i = "Mostra tutte le colonne", t4i = "Attiva/disattiva colonne", n4i = "Nessuna colonna trovata", o4i = "Al momento della prenotazione, aggiungi eventi e nuovi partecipanti come:", r4i = "Lead", i4i = "Contatto sotto un account", a4i = "Salta la creazione del record {{entry}} se non esistono in Salesforce", s4i = "Se il contatto non esiste sotto un account, crea un nuovo lead dal partecipante", c4i = "Crea un nuovo contatto sotto un account basato sul dominio email del partecipante e contatti esistenti", l4i = "Cambia proprietario del record alla prenotazione", u4i = "Assegna attributi in massa", d4i = "Risulta nella visualizzazione di un messaggio personalizzato. Prova a modificare la risposta per indirizzare a un evento", _4i = "Risulta nel reindirizzamento a {{externalUrl}}. Prova a modificare la risposta per indirizzare a un evento", p4i = "Possibile host", m4i = "Stato di instradamento attuale", f4i = "Reindirizza prenotazione", g4i = "Reindirizza la prenotazione a diversi membri del team", h4i = "Verifica nuovo percorso", v4i = "Reindirizza", b4i = "Nuovo stato di instradamento", y4i = "Se il partecipante esiste in Salesforce, prenota direttamente con il proprietario", $4i = "Entità per verificare il proprietario per prenotare direttamente", w4i = "Account", k4i = "Scegli gli orari degli host", S4i = "Puoi selezionare un orario diverso per ogni host. L'orario predefinito di ciascun host è selezionato di default.", E4i = "Nessun host assegnato, aggiungi host nella scheda di assegnazione.", x4i = "Riassegna manualmente l'host round robin", C4i = "Riassegna manualmente l'host round robin a un altro host disponibile", T4i = "Riassegna l'host round robin a un altro host disponibile", A4i = "Il nuovo utente non è un host round robin valido per questo tipo di evento", I4i = "Il nuovo utente è un host fisso per questo tipo di evento", O4i = "Riprogramma con lo stesso slot orario", N4i = "Riprogramma con lo stesso slot orario del nuovo evento", z4i = "Riprogramma al nuovo evento con slot orario diverso", R4i = "Riprogramma con slot orario diverso", P4i = "Non abbiamo l'ID per il nuovo evento. Per favore, vai al Modulo di Instradamento e salvalo di nuovo.", D4i = "Prenotazione reindirizzata con successo. Reindirizzamento alla pagina di prenotazione", L4i = "Alla prenotazione, scrivi nell'oggetto evento", M4i = "Nome del campo", F4i = "Aggiungi nuovo campo", q4i = "Non hai l'accesso per reindirizzare questa prenotazione", j4i = "Risposta del modulo non trovata", V4i = "Proprietario del contatto", B4i = "Non trovato", U4i = "Utilizzo dei membri di fallback", G4i = "Percorso scelto", W4i = "Logica degli attributi corrispondente", H4i = "Logica di fallback degli attributi corrispondente", Y4i = "Tutti i membri assegnati al tipo di evento del team. Considera di aggiungere alcune regole di attributo.", K4i = "Tutti i membri assegnati al tipo di evento del team. Considera di aggiungere alcune regole di attributo al fallback.", Z4i = "Tutti i membri assegnati al tipo di evento del team. Considera di modificare il fallback per ottenere una corrispondenza.", X4i = "Attenzione", J4i = "Fallback: se nessun membro del team corrisponde, usa quelli che soddisfano i seguenti criteri (corrisponde a tutti i membri del team assegnati all'evento per impostazione predefinita)", Q4i = "Avviso di fallback", e5i = "Non necessario", t5i = "Host non disponibile", n5i = "Host disponibile", o5i = "Sei sicuro di voler riassegnare questa prenotazione a un host non disponibile?", r5i = "Sei sicuro di voler riassegnare questa prenotazione?", i5i = "Sì, riassegna", a5i = "Filtra per attributi", s5i = "Motivo della riassegnazione", c5i = "La modifica del tipo di campo potrebbe causare perdita di dati. Si consiglia di creare un nuovo campo.", l5i = "Riassegnato da", u5i = "riga", d5i = "righe", _5i = "Fuso orario del partecipante", p5i = "Ora di inizio evento nel fuso orario del partecipante", m5i = "Ora di inizio evento nel fuso orario del partecipante", f5i = "Ora di fine evento nel fuso orario del partecipante", g5i = "Ora di fine evento nel fuso orario del partecipante", h5i = "Crea evento sul contatto, se esiste. Altrimenti, passa al lead", v5i = "Nome del proprietario da modificare", b5i = "Nessun filtro impostato", y5i = "Test di prenotazione completato con successo", $5i = "Il test di prova è stato completato con successo.", w5i = "Non hai accesso a questa pagina", k5i = "Per visualizzare o interagire con questa pagina, devi avere privilegi di amministratore o proprietario", S5i = "Tipo di campo", E5i = "Quando scrivere", x5i = "Al momento della prenotazione, scrivi in un campo personalizzato nel record {{record}} del partecipante", C5i = "Ad ogni prenotazione", T5i = "Solo se il campo è vuoto", A5i = "Data di inizio prenotazione", I5i = "Data di creazione della prenotazione", O5i = "Prenotazione riassegnata a {{host}}", N5i = "Nessun proprietario del contatto", z5i = "Moduli di instradamento creati", R5i = "Risposte totali", P5i = "Risposte totali senza prenotazione", D5i = "Risposte totali con prenotazione", L5i = "Nessuna prenotazione", M5i = "Nome del modulo", F5i = "Prenotazione", q5i = "Nessuna prenotazione", j5i = "Prenotato da", V5i = "Creato il", B5i = "Stato della prenotazione", U5i = "Data prenotazione", G5i = "Data invio", W5i = "Copia URL di reindirizzamento", H5i = "URL di reindirizzamento all'uscita", Y5i = "Prenotazioni totali per periodo", K5i = "Instradamenti per periodo", Z5i = "Al giorno", X5i = "A settimana", J5i = "Al mese", Q5i = "Motivo dell'assegnazione", e6i = "Accesso negato", t6i = "Il proprietario del contatto sarà l'host del Round Robin se disponibile", n6i = "Aggiungi nuovi partecipanti come", o6i = "Il proprietario del contatto non sarà obbligato (può comunque essere l'host se corrisponde agli attributi e ai criteri del Round Robin)", r6i = "Instrada a un utente che corrisponde a un campo di ricerca su un account", i6i = "Opzione Salesforce", a6i = "Nome del campo di ricerca", s6i = "Se il partecipante ha un dominio email gratuito, salta il controllo della proprietà e procedi con il round robin normalmente", c6i = "È", l6i = "Non è", u6i = "Contiene", d6i = "Non contiene", _6i = "Inizia con", p6i = "Finisce con", m6i = "È vuoto", f6i = "Non è vuoto", g6i = "Auto traduci titolo e descrizione", h6i = "Traduci automaticamente titoli e descrizioni nella lingua del browser del visitatore utilizzando l'IA.", v6i = "Distribuzione", b6i = "Permette di ottimizzare la distribuzione per massimizzare la disponibilità o per ottenere un'assegnazione più bilanciata.", y6i = "Massimizza disponibilità", $6i = "Permette ai prenotanti di fissare incontri ogni volta che un host è disponibile. Usa questa opzione per massimizzare il numero di potenziali incontri prenotabili e quando la distribuzione uniforme degli incontri tra gli host è meno importante.", w6i = "Bilanciamento del carico", k6i = "Monitoreremo quante prenotazioni sono state effettuate con ciascun host e le confronteremo con gli altri, disabilitando alcuni host che sono troppo avanti per garantire una distribuzione uniforme delle prenotazioni.", S6i = "Modifica pesi", E6i = "Pesi aggiornati con successo", x6i = "Richiedi conferma solo per i provider di posta elettronica gratuiti (Es. @gmail.com, @outlook.com)", C6i = "Escludi le email che contengono ...", T6i = "Richiedi email che contengono ...", A6i = "Inserisci un indirizzo email di lavoro valido", I6i = "Non sei autorizzato a prenotare con questo dominio email. Contatta il proprietario di questo link.", O6i = "Cerca colonne", N6i = "Opzioni di ricerca", z6i = "Disabilita il profilo pubblico dell'organizzazione e reindirizza", R6i = "Reindirizza {{orgSlug}}.cal.com a {{destination}}", P6i = "Selezione singola", D6i = "Selezione multipla", L6i = "Impostazioni conflitti calendario", M6i = "Seleziona quali calendari controllare per i conflitti", F6i = "Riunione di gruppo", q6i = "Sei sicuro di voler rimuovere questa app da", j6i = "Disconnetti l'app da", V6i = "Non creare nuovi record per gli ospiti aggiunti alla prenotazione", B6i = "Google Meet", U6i = "Zoom", G6i = "Video MS Teams", W6i = "Blocca per assegnazione", H6i = "Il blocco consentirà solo le assegnazioni da Directory Sync", Y6i = "Attributo modificato con successo", K6i = "Nuova opzione gruppo", Z6i = "Pesi abilitati", X6i = "Abilitando i pesi, sarà possibile assegnare una priorità più alta a determinati attributi per utente. Maggiore è il peso, maggiore è la priorità.", J6i = "Instradato", Q6i = "Riassegnato", eFi = "Consenti la riprogrammazione di eventi passati", tFi = "L'attivazione di questa opzione permette di riprogrammare eventi già conclusi", nFi = "Reindirizzato", oFi = "Assegnazione Salesforce", rFi = "Posizione del router", iFi = "Mostra host corrispondenti", aFi = "Nessuna coda attiva per questo input", sFi = "Peso", cFi = "Calibrazione", lFi = "Deficit", uFi = "Modulo di instradamento", dFi = "Torna indietro e salva", _Fi = "Salva modifiche", pFi = "Esci senza salvare", mFi = "Sei sicuro di voler uscire senza salvare le modifiche al tuo modulo di instradamento?", fFi = "Si è verificato un errore imprevisto", gFi = "Stai effettuando una prenotazione di prova.", hFi = "Galleria delle icone", vFi = "Galleria delle icone", bFi = "Migrazione dal team", yFi = "La funzionalità è attualmente disattivata", $Fi = "Scegli un'opzione", wFi = "Inserisci il valore dell'opzione", kFi = "Rimuovi opzione", SFi = "Usa pesi degli attributi", EFi = "Se abilitato, tutti i pesi impostati nel tipo di evento verranno ignorati", xFi = "Attributo per i pesi", CFi = "Utenti gestiti", TFi = "Visualizza tutti gli utenti gestiti creati dal tuo client OAuth", AFi = "Puoi dirmi qualcosa su ", IFi = "Usa l'IA per rispondere alle tue domande", OFi = "Errore durante il recupero della risposta ", NFi = "Si è verificato un errore imprevisto. Per favore, riprova più tardi", zFi = "Seleziona client OAuth", RFi = "Su ogni istanza", PFi = "La funzionalità di credenziale di delega non è abilitata per la tua organizzazione", DFi = "Nota interna", LFi = "Motivo condiviso con il cliente (opzionale)", MFi = "Questa nota sarà visibile solo ai membri del tuo team", FFi = "Modelli di note interne di cancellazione", qFi = "Crea modelli per note interne che possono essere applicati alle prenotazioni", jFi = "Modelli di note interne aggiornati con successo", VFi = "Aggiungi modello", BFi = "Autorizza", UFi = "Avanti", GFi = "Nascondi", WFi = "Mostra", HFi = "Parametri UTM", YFi = "Nessun parametro UTM disponibile.", KFi = "Crescente", ZFi = "Decrescente", XFi = "Verifica la modifica dell'email", JFi = "Acquista crediti", QFi = "Crediti", eqi = "Crediti utilizzati", tqi = "Totale rimanente", nqi = "Ricevi 1000 crediti al mese per ogni membro del team", oqi = "Ricevi 750 crediti al mese per ogni membro del team", rqi = "Visualizza e gestisci i crediti per l'invio di messaggi SMS", iqi = "Visualizza e gestisci i crediti per l'invio di messaggi SMS. Un credito vale 1¢ (USD). <0>Scopri di più</0>", aqi = "Un credito vale 1¢ (USD). <0>Scopri di più</0>", sqi = "Acquista crediti aggiuntivi ($0.01 per credito)", cqi = "Puoi visualizzare la spesa di crediti aggiuntivi nel registro delle spese", lqi = "Panoramica", uqi = "Lo slug dell'organizzazione è già stato preso", dqi = "Non puoi creare un'organizzazione poiché fai già parte di un'organizzazione", _qi = "Devi completare l'onboarding utente prima di creare un'organizzazione", pqi = "Usa l'email aziendale per creare un'organizzazione", mqi = "Non puoi creare un'organizzazione piattaforma poiché fai già parte di un team", fqi = "Devi avere un numero minimo di team pubblicati", gqi = "Fai già parte di questa organizzazione", hqi = "Fai parte di un'altra organizzazione, non puoi creare una nuova organizzazione", vqi = "Fai parte di un'altra organizzazione della piattaforma, non puoi creare una nuova organizzazione", bqi = "Pagamento dell'organizzazione riuscito", yqi = "La tua organizzazione è stata creata con successo", $qi = "Questo potrebbe richiedere alcuni secondi...", wqi = "Stato dell'onboarding dell'organizzazione", kqi = "Descrizione dello stato dell'onboarding dell'organizzazione", Sqi = "Pagamento fallito", Eqi = "Il tuo pagamento non è andato a buon fine. Per favore, riprova.", xqi = "Creazione della tua organizzazione", Cqi = "Onboarding dell'organizzazione già completato", Tqi = "L'onboarding dell'organizzazione esiste già", Aqi = "Onboarding dell'organizzazione non trovato", Iqi = "Pagamento riuscito!", Oqi = "Passaggio di consegne dell'onboarding", Nqi = "Passaggio di consegne dell'onboarding all'utente", zqi = "Un'organizzazione con questo slug esiste già", Rqi = "Non hai il permesso di creare un'organizzazione per questa email", Pqi = "Non hai il permesso di migrare uno o più team", Dqi = "L'organizzazione ha già un abbonamento", Lqi = "Intervallo di reset per Round Robin ponderato", Mqi = "Intervallo", Fqi = "Determina la frequenza con cui il conteggio delle prenotazioni round robin viene azzerato per garantire una distribuzione equilibrata.", qqi = "Giornaliero", jqi = "Non hai impostato una data di fine per la tua assenza", Vqi = "Le mie assenze", Bqi = "Assenze del team", Uqi = "Gestisci le assenze del tuo team.", Gqi = "Crea assenza", Wqi = "Crea un'assenza per un membro del team", Hqi = "Modifica un'assenza per un membro del team", Yqi = "Crea assenze per il tuo team", Kqi = "Comunica ai prenotatori quando i membri del tuo team non sono disponibili per le prenotazioni. Potranno comunque essere prenotati al loro ritorno o puoi reindirizzarli a un altro membro del team.", Zqi = "Il reindirizzamento delle assenze è consentito solo a un membro dello stesso team.", Xqi = "Esiste già un reindirizzamento inverso tra questi utenti.", Jqi = "Nessuna assenza precedente trovata", Qqi = "Precedente", eji = "Intervallo Round Robin aggiornato con successo", tji = "Modalità di prova", nji = "Piano team inattivo", oji = "Il tuo piano team è inattivo. Controlla il tuo abbonamento o contatta l'assistenza clienti", rji = "Accesso limitato durante la prova. Funzionalità disponibile al termine del periodo di prova.", iji = "Programma di referral", aji = "Guadagna il 20% di referral", sji = "Hai bisogno di una chiave API Dub e di un ID programma per utilizzare questa pagina.", cji = "UID", lji = "Link", uji = "righe per pagina", dji = "{{currentRange}} di {{totalItems}}", _ji = "Suggerimento: puoi aggiungere un '+' tra i nomi utente: cal.com/anna+brian per creare un incontro di gruppo dinamico", pji = "Non hai ancora un team", mji = "Non hai ancora membri del team", fji = "L'evento ricorrente non supporta la funzionalità dei posti. Rendilo non ricorrente per abilitare i posti.", gji = "L'evento ricorrente non supporta la funzionalità di limite di prenotazione per prenotatore. Disabilita il limite di prenotazione per prenotatore per abilitare l'evento ricorrente.", hji = "La funzionalità dei posti non supporta eventi ricorrenti. Disabilita la funzionalità dei posti per renderlo ricorrente.", vji = "L'evento ricorrente non supporta la funzionalità dei posti. Disabilita la funzionalità dei posti o rendi l'evento non ricorrente.", bji = "Segmento", yji = "Filtri salvati", $ji = "Rinomina", wji = "Rinomina segmento", kji = "Elimina segmento", Sji = "Duplica segmento", Eji = "Sei sicuro di voler eliminare questo segmento? Questa azione non può essere annullata.", xji = "Segmento di filtro aggiornato", Cji = "Errore durante l'aggiornamento del segmento di filtro", Tji = "Segmento di filtro duplicato", Aji = "Errore durante la duplicazione del segmento di filtro", Iji = "Segmento di filtro eliminato", Oji = "Errore durante l'eliminazione del segmento di filtro", Nji = "Salva segmento", zji = "Segmento non trovato", Rji = "Segmento di filtro salvato", Pji = "Nessun segmento", Dji = "Errore durante il salvataggio del segmento di filtro", Lji = 'Salva modifiche in "{{name}}"', Mji = "Crea nuovo segmento", Fji = "Salva per il team", qji = "Seleziona team", jji = "Per favore seleziona un team", Vji = "Personale", Bji = "Nascondi link al profilo del team", Uji = "Nascondi il link al profilo del team nelle pagine di prenotazione", Gji = "Visualizzazione", Wji = "Impossibile trovare lo slug per pubblicare l'organizzazione", Hji = "Lista di selezione", Yji = "Prenotazioni più cancellate", Kji = "Lingua dell'interfaccia", Zji = "Imposta la tua lingua preferita per l'interfaccia di prenotazione", Xji = "Lingua del browser del visitatore", Jji = "Nome o email", Qji = "Se non viene trovato alcun contatto, passa al proprietario del lead se esiste", eVi = "Acquisto crediti fallito. Riprova o contatta l'assistenza.", tVi = "Minimo di 50 crediti richiesti", nVi = "Abilita credenziale di delega", oVi = "Concedi a Cal.com l'accesso automatico ai calendari di tutti i membri dell'organizzazione abilitando la credenziale di delega.", rVi = "Disabilita credenziale di delega", iVi = "Una volta disabilitata la credenziale di delega, i membri dell'organizzazione che non hanno collegato i propri calendari dovranno farlo manualmente.", aVi = "Ultima attività", sVi = "Membro dal", cVi = "Ultimo aggiornamento", lVi = "In caso di prenotazione annullata, scrivi nel record dell'evento invece di eliminarlo", uVi = "Ad ogni cancellazione", dVi = "Segnala un problema", _Vi = "Puoi inviare un ticket su GitHub o aggiornare il tuo piano per ricevere supporto in tempo reale con conferenze per sviluppatori", pVi = "Apri segnalazione", mVi = "Questo è il tuo piano attuale", fVi = "Programma un orario", gVi = "Questo include:", hVi = "Client OAuth aggiornato con successo", vVi = "Client OAuth non trovato.", bVi = "Abbonati alla piattaforma", yVi = "Errore durante il tentativo di accesso ai webhook.", $Vi = "Aggiornamento del webhook fallito.", wVi = "Creazione del webhook fallita.", kVi = "Link non valido", SVi = "Attualmente sei abbonato al piano {{planFirstLetter}}{{planRest}}", EVi = "Utente/Team", xVi = "ID client copiato!", CVi = "Secret del client copiato!", TVi = "Il team di Cal.com sta eseguendo una manutenzione programmata. Per qualsiasi domanda, contatta l'assistenza.", AVi = "Il tuo pagamento è fallito", IVi = "Controlla la tua casella di posta", OVi = "Il tuo account è stato creato, ma il tuo premium non è stato riservato.", NVi = "Abbiamo inviato un'email a {{email}} con un link per attivare il tuo account.", zVi = "Una volta attivato l'account potrai provare ad acquistare il tuo nome utente premium o selezionarne uno diverso.", RVi = "Apri in Gmail", PVi = "Non vedi un'email?", DVi = "Reinvia tra {{seconds}} secondi", LVi = "Reinvia", MVi = "Email di verifica inviata", FVi = "Seleziona tutti i membri", qVi = "Selezionando tutti i membri verranno aggiunti tutti i futuri membri del team quando vengono aggiunti al team.", jVi = "Impostazioni modulo", VVi = "Rimuovi stato whitelist", BVi = "Inserisci in whitelist i flussi di lavoro utente", UVi = "Flussi di lavoro utente inseriti in whitelist", GVi = "Flussi di lavoro utente rimossi dalla whitelist", WVi = "Data e ora", HVi = "Questo è un promemoria per il tuo prossimo evento.", YVi = "Questo promemoria è stato attivato da un Workflow in Cal.", KVi = "Evento", ZVi = "Pianificato da", XVi = "Come è stata la tua recente esperienza?", JVi = "Cerchiamo sempre di migliorare l'esperienza dei clienti.", QVi = "Quanto sei soddisfatto del tuo ultimo incontro?", eBi = "non hai partecipato all'incontro?", tBi = "Riprogramma qui.", nBi = "Nascondi email dell'organizzatore", oBi = "Fai già parte di un'organizzazione della piattaforma, per questo motivo non puoi creare una nuova organizzazione. Ogni utente può appartenere a una sola organizzazione. Per favore, crea un nuovo account cal.com con un'email diversa e usa quell'account per iscriverti al piano organizzazioni.", rBi = "Fai già parte di un'organizzazione, per questo motivo non puoi creare un'organizzazione della piattaforma. Ogni utente può appartenere a una sola organizzazione. Per favore, crea un nuovo account cal.com con un'email diversa e usa quell'account per iscriverti al piano piattaforma.", iBi = "Nascondi l'indirizzo email dell'organizzatore dalla schermata di prenotazione, dalle notifiche email e dagli eventi del calendario", aBi = "Tu &", sBi = "Seleziona un'email verificata", cBi = "Aggiungi email verificata", lBi = "Aggiungi email verificate", uBi = "Email 'Rispondi a' personalizzata", dBi = "Usa un indirizzo email diverso come replyTo per le email di conferma invece dell'email dell'organizzatore", _Bi = "Questo sondaggio è stato attivato da un Workflow in Cal.", pBi = "Salta periodo di prova", mBi = "Periodi di prova del team saltati con successo", fBi = "Inserendo il tuo numero di telefono acconsenti a ricevere messaggi SMS per questo evento. Potrebbero essere applicate tariffe SMS.", gBi = "Maggiori informazioni sono disponibili in <0>Analisi di instradamento</0>", hBi = "Risultati", vBi = "Visualizza modulo", bBi = "Invia STOP per disattivare i messaggi SMS", yBi = "Il tuo team {{teamName}} sta esaurendo i crediti", $Bi = "Stai esaurendo i crediti", wBi = "[Azione richiesta] Il tuo team {{teamName}} ha esaurito i crediti", kBi = "[Azione richiesta] Hai esaurito i crediti", SBi = "Il tuo team Cal.com {{teamName}} sta esaurendo i crediti. Per evitare interruzioni del servizio, acquista crediti aggiuntivi. Se il saldo si esaurisce, i messaggi SMS smetteranno di essere inviati e verranno inviati come email.", EBi = "Il tuo account Cal.com sta esaurendo i crediti. Per evitare interruzioni del servizio, acquista crediti aggiuntivi. Se il saldo si esaurisce, i messaggi SMS smetteranno di essere inviati e verranno inviati come email.", xBi = "Il tuo team Cal.com {{teamName}} ha esaurito i crediti. Di conseguenza, i messaggi SMS vengono ora inviati tramite email. Per riprendere l'invio di SMS, acquista crediti aggiuntivi.", CBi = "Il tuo account Cal.com ha esaurito i crediti. Di conseguenza, i messaggi SMS vengono ora inviati tramite email. Per riprendere l'invio di SMS, acquista crediti aggiuntivi.", TBi = "Saldo attuale: {{balance}} crediti", ABi = "Saldo attuale:", IBi = "Notifica sulla tua prenotazione", OBi = "Crediti mensili", NBi = "Crediti totali: {{totalCredits}}", zBi = "Crediti rimanenti: {{remainingCredits}}", RBi = "Rimanente", PBi = "Totale", DBi = "Crediti aggiuntivi", LBi = "{{count}} successivi in coda", MBi = "Invia risposte email a", FBi = "Prenotazioni incomplete", qBi = "Includi prenotazioni non presentate nei calcoli round robin", jBi = "Ospiti recenti non presentati", VBi = "Mostra le prenotazioni in cui tutti i partecipanti non si sono presentati, non le assenze parziali", BBi = "Corrispondenza", UBi = "Reindirizzamento evento", GBi = "Reimposta modulo", WBi = "Impostazioni Round Robin aggiornate con successo", HBi = "Base di distribuzione per Round Robin ponderato", YBi = "Determina quale timestamp dell'evento viene utilizzato come base per la distribuzione Round Robin ponderata.", KBi = "Richiede crediti", ZBi = "Devi avere abbastanza crediti nel tuo account per utilizzare questa funzionalità", XBi = "Crediti disponibili", JBi = "Crea ruolo", QBi = "Ruoli e permessi", e9i = "Gestisci ruoli e permessi per la tua organizzazione", t9i = "Scopri di più su come funzionano i permessi", n9i = "Nome del ruolo", o9i = "Il nome del ruolo è obbligatorio", r9i = "es. Team vendite, Staff di supporto", i9i = "Descrizione del ruolo", a9i = "Descrivi a cosa serve questo ruolo e quali permessi necessita", s9i = "Ruolo predefinito", c9i = "Ruolo personalizzato", l9i = "Avanzate", u9i = "Cerca autorizzazioni", d9i = "Tutte le autorizzazioni", _9i = "Nessuna", p9i = "Sola lettura", m9i = "Tutte le azioni su tutte le risorse", f9i = "Tutte le risorse", g9i = "Tipi di evento", h9i = "Team", v9i = "Organizzazione", b9i = "Prenotazioni", y9i = "Approfondimenti", $9i = "Ruoli", w9i = "Moduli di instradamento", k9i = "Flussi di lavoro", S9i = "Tutte le azioni", E9i = "Crea", x9i = "Visualizza", C9i = "Modifica", T9i = "Elimina", A9i = "Gestisci", I9i = "Invita", O9i = "Rimuovi", N9i = "Cambia ruolo membro", z9i = "Elenca membri", R9i = "Gestisci fatturazione", P9i = "Visualizza prenotazioni del team", D9i = "Visualizza prenotazioni dell'organizzazione", L9i = "Visualizza registrazioni", M9i = "Accedi con altra identità", F9i = "Ruolo creato con successo", q9i = "Ruolo aggiornato con successo", j9i = "Elimina ruolo", V9i = "Sei sicuro di voler eliminare il ruolo: {{roleName}}? Questa azione non può essere annullata.", B9i = "Ruolo eliminato con successo", U9i = "Errore durante la creazione del ruolo", G9i = "Errore durante l'aggiornamento del ruolo", W9i = "Crea ruoli", H9i = "Attributi", Y9i = "Visualizza attributi dell'organizzazione", K9i = "Aggiorna attributi dell'organizzazione", Z9i = "Elimina attributi dell'organizzazione", X9i = "Crea attributi dell'organizzazione", J9i = "Visualizza ruoli", Q9i = "Aggiorna ruoli", eUi = "Elimina ruoli", tUi = "Crea e configura nuovi flussi di lavoro", nUi = "Configurazione richiesta", oUi = "Visualizza flussi di lavoro esistenti e le loro configurazioni", rUi = "Modifica e cambia le impostazioni dei flussi di lavoro", iUi = "Rimuovi flussi di lavoro dal sistema", aUi = "Webhook", sUi = "Disponibilità", cUi = "Fuori sede", lUi = "Crea webhook", uUi = "Visualizza webhook", dUi = "Aggiorna webhook", _Ui = "Elimina webhook", pUi = "Crea disponibilità", mUi = "Visualizza disponibilità", fUi = "Aggiorna disponibilità", gUi = "Elimina disponibilità", hUi = "Crea fuori sede", vUi = "Visualizza fuori sede", bUi = "Aggiorna fuori sede", yUi = "Elimina fuori sede", $Ui = "Accesso completo alla gestione di tutti i flussi di lavoro", wUi = "Crea tipi di evento", kUi = "Visualizza tipi di evento", SUi = "Aggiorna tipi di evento", EUi = "Elimina tipi di evento", xUi = "Tutte le azioni sui tipi di evento", CUi = "Crea team", TUi = "Visualizza dettagli del team", AUi = "Aggiorna impostazioni del team", IUi = "Elimina team", OUi = "Invita membri del team", NUi = "Rimuovi membri del team", zUi = "Cambia ruolo dei membri del team", RUi = "Accedi con l'identità dei membri del team", PUi = "Tutte le azioni sui team dell'organizzazione", DUi = "Crea organizzazione", LUi = "Visualizza dettagli dell'organizzazione", MUi = "Elenca membri dell'organizzazione", FUi = "Invita membri dell'organizzazione", qUi = "Rimuovi membri dell'organizzazione", jUi = "Gestisci fatturazione dell'organizzazione", VUi = "Cambia ruolo dei membri dell'organizzazione", BUi = "Accedi con l'identità dei membri dell'organizzazione", UUi = "Modifica impostazioni dell'organizzazione", GUi = "Tutte le azioni sulle organizzazioni", WUi = "Visualizza prenotazioni", HUi = "Visualizza prenotazioni del team", YUi = "Visualizza prenotazioni dell'organizzazione", KUi = "Visualizza registrazioni delle prenotazioni", ZUi = "Aggiorna prenotazioni", XUi = "Tutte le azioni sulle prenotazioni", JUi = "Visualizza insight del team", QUi = "Gestisci insight del team", eGi = "Crea moduli di instradamento", tGi = "Visualizza moduli di instradamento", nGi = "Aggiorna moduli di instradamento", oGi = "Elimina moduli di instradamento", rGi = "Il permesso di lettura viene abilitato automaticamente quando si crea, aggiorna o elimina una risorsa", iGi = "Aggiungi programma di restrizione", aGi = "Limita la disponibilità degli host per mostrare solo gli slot che rientrano in un programma specificato.", sGi = "Usa fuso orario del prenotante", cGi = "Applica il programma di restrizione selezionato nel fuso orario del prenotante", lGi = "Questo disabiliterà il bilanciamento del carico su tutti i tuoi tipi di evento round robin", uGi = "Il bilanciamento del carico è disponibile solo quando la base temporale è impostata su Orario di creazione della prenotazione", dGi = "Il bilanciamento del carico non è disponibile con i gruppi Round Robin", _Gi = "Personalizza le impostazioni predefinite del round robin per questo team", pGi = "Impostazioni Round Robin aggiornate con successo", mGi = "Orario di creazione prenotazione", fGi = "Orario di inizio meeting", gGi = "Membri interessati", hGi = "Nessun membro interessato dalla disabilitazione delle credenziali di delega", vGi = "Scarica il registro delle spese", bGi = "Errore durante il download del registro delle spese", yGi = "Offri di riprogrammare l'ultima prenotazione attiva nella fascia oraria scelta", $Gi = "Limite massimo di prenotazioni attive superato", wGi = "Hai già una prenotazione per questo evento il {{date}}. Vuoi riprogrammarla al nuovo orario selezionato?", kGi = "La durata deve essere di almeno {{min}} minuto/i", SGi = "La durata non può superare {{max}} minuti (24 ore)", EGi = "Prenotazione al di fuori della disponibilità del programma di restrizione.", xGi = "Programma di restrizione non trovato", CGi = "Limite di dimensione dell'immagine superato, utilizza un'immagine più piccola preferibilmente in formato JPEG", TGi = "Aggiungi gruppo", AGi = "Funnel di instradamento", IGi = "Invii totali", OGi = "Instradamenti riusciti", NGi = "Prenotazioni accettate", zGi = "Chiave di licenza", RGi = "Scegli la tua licenza", PGi = "Seleziona come vuoi concedere in licenza la tua implementazione di Cal.com", DGi = "Utilizza Cal.com con la licenza open source AGPLv3", LGi = "Inserisci la chiave di licenza", MGi = "Accesso a tutte le funzionalità enterprise", FGi = "A partire da 15$/utente al mese", qGi = "Accesso a tutte le funzionalità enterprise", jGi = "Inserisci la tua chiave di licenza", VGi = "Salva chiave di licenza", BGi = "Token di firma (opzionale)", UGi = "Il token di firma viene utilizzato per verificare che la chiave di licenza sia tua quando incrementi la fatturazione basata sull'utilizzo. Puoi trovarlo nell'email di conferma dell'acquisto. Se hai una licenza precedente, puoi lasciare questo campo vuoto.", GGi = "Hai bisogno di una licenza?", WGi = "La chiave di licenza è obbligatoria", HGi = "Chiave di licenza non valida", YGi = "Impossibile convalidare la chiave di licenza", KGi = "Allegati opzionali", ZGi = "Invia messaggio", XGi = "Descrivi il problema", JGi = "La dimensione del file supera il limite", QGi = "Tipo di file non valido", eWi = "Tipo di file non valido. Tipi accettati: {{acceptedTypes}}", tWi = "Numero massimo di file superato", nWi = "File caricati con successo", oWi = "Tipi accettati: {{acceptedTypes}}; Dimensione massima del file: {{maxSize}}", rWi = "Chiave di licenza salvata con successo", iWi = "Stai visualizzando il report in base al fuso orario del tuo profilo ({{userTimezone}}), mentre il tuo browser è impostato sul fuso orario ({{browserTimezone}})", aWi = "Slot ottimizzati", sWi = "Organizza gli slot temporali per ottimizzare la disponibilità.", cWi = "Prenotazioni fallite per campo", lWi = "Prenotazioni fallite", uWi = "Nessun host è assegnato al tipo di evento", dWi = "Stato della cache", _Wi = "Ultimo aggiornamento: {{timestamp}}", pWi = "Elimina dati in cache", mWi = "Cache eliminata con successo", fWi = "Errore durante l'eliminazione della cache", gWi = "Sei sicuro di voler eliminare i dati in cache? Questa azione non può essere annullata.", hWi = "Sì, elimina cache", vWi = "{{remainder}} di {{maximum}} utilizzi rimasti", bWi = "{{remainder}} di {{maximum}} utilizzo rimasto", yWi = "Scade il {{date}}, a fine giornata", $Wi = "Uso singolo", wWi = "Scadenza basata sul tempo", kWi = "Scadenza basata sull'utilizzo", SWi = "Numero di utilizzi", EWi = "Scade il", xWi = "Numero massimo di utilizzi", CWi = "Impostazioni link", TWi = "Questo link è scaduto il {{date}}, a fine giornata", AWi = "Limite di utilizzo raggiunto", IWi = "Il numero massimo di utilizzi deve essere maggiore del conteggio di utilizzo attuale", OWi = "Questo link è scaduto", NWi = "Questo link può essere utilizzato per prenotazioni fino alla fine del {{date}}", zWi = "Questo link può essere configurato per scadere dopo una data stabilita", RWi = "Questo link può essere utilizzato per {{count}} prenotazione", PWi = "Questo link può essere configurato per scadere dopo un numero stabilito di prenotazioni", DWi = "Questo link può essere utilizzato per {{count}} prenotazioni", LWi = "Il nome dell'evento trigger (es. BOOKING_CREATED, BOOKING_CANCELLED)", MWi = "L'ora del webhook", FWi = "Lo slug del tipo di evento", qWi = "Configura Agente", jWi = "Il nome del tipo di evento", VWi = "L'ora di inizio dell'evento", BWi = "L'ora di conclusione dell'evento", UWi = "La descrizione dell'evento come indicata nelle impostazioni del tipo di evento", GWi = "Luogo dell'evento", WWi = "L'UID della prenotazione", HWi = "L'UID per la riprogrammazione", YWi = "Motivo della cancellazione", KWi = "Motivo del rifiuto", ZWi = "Nome dell'organizzatore", XWi = "Email dell'organizzatore", JWi = "Fuso orario dell'organizzatore (es. 'America/New_York', 'Asia/Kolkata')", QWi = "Locale dell'organizzatore (es. 'en', 'fr')", e8i = "Nome utente dell'organizzatore (es. 'john.doe')", t8i = "Nome utente dell'organizzatore nella propria organizzazione (es. 'john.doe')", n8i = "Nome del primo partecipante", o8i = "Email del primo partecipante", r8i = "Fuso orario del primo partecipante", i8i = "Locale del primo partecipante", a8i = "Nome del team prenotato", s8i = "Membri del team prenotato", c8i = "URL della videochiamata per la riunione", l8i = "Nascondi variabili", u8i = "Mostra variabili disponibili", d8i = "Evento e prenotazione", _8i = "Persone", p8i = "Team", m8i = "Metadati", f8i = "Statistiche", g8i = "Stato della prenotazione", h8i = "Visita", v8i = "Etichetta personalizzata sulla pagina di prenotazione", b8i = "Link della riunione", y8i = "Esito della sessione", $8i = "Chiamata creata", w8i = "Segreteria telefonica", k8i = "Le mie prenotazioni", S8i = "Telefono", E8i = "Gratuito", x8i = "Email utente", C8i = "Nome utente", T8i = "Espandi pannello", A8i = "Comprimi pannello", I8i = "La verifica dell'email è richiesta per questo tipo di evento", O8i = "Codice di verifica fornito non valido", N8i = "Hai un team", z8i = "Considera la creazione di un'organizzazione per unificare fatturazione, strumenti di amministrazione e analisi per il tuo team.", R8i = "Considera la creazione di un'organizzazione per unificare fatturazione, strumenti di amministrazione e analisi per i tuoi team.", P8i = "Messaggio inviato", D8i = "Grazie per averci contattato. Ti risponderemo il prima possibile.", L8i = "Cerca variabili", M8i = "Per favore descrivi il problema che stai riscontrando, ad esempio 'Gli slot occupati sono segnati come disponibili', ..., ecc.", F8i = "Invia un altro messaggio", q8i = "Invio in corso", j8i = "Nessuna variabile trovata", V8i = "Crediti richiesti", B8i = "Le chiamate web consumano crediti. Assicurati di avere crediti sufficienti per iniziare una chiamata.", U8i = "Le chiamate web richiedono crediti. Hai 0 crediti rimanenti.", G8i = "Acquista crediti", W8i = "Questa azione richiede crediti per procedere", H8i = "Il nome non deve superare i {{max}} caratteri", Y8i = "Addebita automaticamente la penale per cancellazioni dell'ultimo minuto", K8i = "Prima dell'orario di inizio programmato", Z8i = "Riconosco che cancellando la prenotazione entro {{timeValue}} {{timeUnit}} dall'orario di inizio mi verrà addebitata la penale di mancata presenza di {{amount, currency}}", X8i = "Per qualsiasi domanda, contatta l'organizzatore.", J8i = "Orario di prenotazione", Q8i = "Quando la prenotazione è programmata (inizio e fine)", e7i = "Creato il", t7i = "Quando la prenotazione è stata originariamente creata", n7i = "Dettagli chiamata", o7i = "ID chiamata", r7i = "Informazioni chiamata", i7i = "Sentimento", a7i = "Motivo disconnessione", s7i = "Riepilogo chiamata", c7i = "Trascrizione", l7i = "Dettagli evento", u7i = "Agente", d7i = "Nessuna trascrizione disponibile", _7i = "Quando testi questo flusso di lavoro, tieni presente che gli SMS devono essere programmati con almeno 15 minuti di anticipo", p7i = "Inizia da zero", m7i = "Crea il tuo flusso di lavoro da zero.", f7i = "Template Cal.ai", g7i = "Agenti AI che prenotano riunioni, inviano promemoria e fanno follow-up!", h7i = "Voce", v7i = "Seleziona voce", b7i = "Seleziona una voce per il tuo agente", y7i = "Scegli una voce per il tuo agente", $7i = "Caratteristica", w7i = "ID voce", k7i = "Usa voce", S7i = "Voce attuale", E7i = "Configura agente in entrata", x7i = "Configura un agente AI per gestire le chiamate in entrata sul tuo numero di telefono", C7i = "Connetti prima un numero di telefono", T7i = "Configura agente per chiamate in entrata", A7i = "Configura agente per gestire chiamate in entrata", I7i = "Chiamate in entrata", O7i = "Chiamate in uscita", N7i = "Configurazione agente in entrata completata con successo", z7i = "Agente in entrata configurato", R7i = "Configura agente in entrata", P7i = "Seleziona prima un tipo di evento", D7i = "Modifica configurazione", L7i = "Le chiamate in entrata possono prenotare solo un tipo di evento. Seleziona il tipo di evento in cui verranno programmati gli incontri quando i chiamanti raggiungono il tuo agente.", M7i = "Configura agente in entrata per chiamate in entrata", F7i = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Aggiungi le tue nuove stringhe qui sopra ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", q7i = {
  identity_provider: q9r,
  trial_days_left: j9r,
  day_one: V9r,
  day_other: B9r,
  second_one: U9r,
  second_other: G9r,
  upgrade_now: W9r,
  untitled: H9r,
  accept_invitation: Y9r,
  max_characters: K9r,
  min_characters: Z9r,
  calcom_explained: X9r,
  calcom_explained_new_user: J9r,
  have_any_questions: Q9r,
  reset_password_subject: eUr,
  verify_email_subject: tUr,
  verify_email_subject_verifying_email: nUr,
  check_your_email: oUr,
  old_email_address: rUr,
  new_email_address: iUr,
  verify_email_page_body: aUr,
  verify_email_banner_body: sUr,
  verify_email_email_header: cUr,
  verify_email_button: lUr,
  cal_ai_assistant: uUr,
  send_cal_video_transcription_emails: dUr,
  description_send_cal_video_transcription_emails: _Ur,
  verify_email_change_description: pUr,
  verify_email_change_success_toast: mUr,
  verify_email_change_failure_toast: fUr,
  change_of_email: gUr,
  change_of_email_toast: hUr,
  copy_somewhere_safe: vUr,
  verify_email_email_body: bUr,
  verify_email_by_code_email_body: yUr,
  verify_email_email_link_text: $Ur,
  email_verification_code: wUr,
  email_verification_code_placeholder: kUr,
  incorrect_email_verification_code: SUr,
  email_sent: EUr,
  email_not_sent: xUr,
  event_declined_subject: CUr,
  event_cancelled_subject: TUr,
  event_reassigned_subject: AUr,
  event_request_declined: IUr,
  customize_calvideo_settings: OUr,
  calvideo_settings_description: NUr,
  disable_recording_for_guests: zUr,
  enable_automatic_transcription: RUr,
  enable_automatic_recording: PUr,
  video_options: DUr,
  edit_event: LUr,
  view_session_details: MUr,
  meeting_session_details: FUr,
  meeting_session: qUr,
  session_id: jUr,
  max_participants: VUr,
  unlimited: BUr,
  ongoing: UUr,
  ended: GUr,
  participants: WUr,
  anonymous_user: HUr,
  session_duration: YUr,
  no_meeting_sessions_found: KUr,
  not_available: ZUr,
  disable_recording_for_organizer: XUr,
  disable_transcription_for_guests: JUr,
  disable_transcription_for_organizer: QUr,
  event_request_declined_recurring: eGr,
  event_request_cancelled: tGr,
  event_request_reassigned: nGr,
  event_reassigned_subtitle: oGr,
  organizer: rGr,
  reassigned_to: iGr,
  need_to_reschedule_or_cancel: aGr,
  you_can_view_booking_details_with_this_url: sGr,
  no_options_available: cGr,
  cancellation_reason: lGr,
  cancelled_by: uGr,
  cancellation_reason_host: dGr,
  cancellation_reason_placeholder: _Gr,
  notify_attendee_cancellation_reason_warning: pGr,
  rejection_reason_placeholder: mGr,
  rejection_reason: fGr,
  rejection_reason_title: gGr,
  rejection_reason_description: hGr,
  rejection_confirmation: vGr,
  manage_this_event: bGr,
  invite_team_member: yGr,
  invite_team_individual_segment: $Gr,
  invite_team_bulk_segment: wGr,
  invite_team_notifcation_badge: kGr,
  your_event_has_been_scheduled: SGr,
  your_event_has_been_scheduled_recurring: EGr,
  accept_our_license: xGr,
  remove_banner_instructions: CGr,
  error_message: TGr,
  refund_failed_subject: AGr,
  refund_failed: IGr,
  check_with_provider_and_user: OGr,
  a_refund_failed: NGr,
  awaiting_payment_subject: zGr,
  meeting_awaiting_payment: RGr,
  dark_theme_contrast_error: PGr,
  light_theme_contrast_error: DGr,
  event_type_color_light_theme_contrast_error: LGr,
  event_type_color_dark_theme_contrast_error: MGr,
  payment_not_created_error: FGr,
  couldnt_charge_card_error: qGr,
  no_available_users_found_error: jGr,
  timeslot_unavailable_book_a_new_time: VGr,
  timeslot_unavailable_short: BGr,
  just_connected_description: UGr,
  unavailable_timeslot_title: GGr,
  booking_time_out_of_bounds_error: WGr,
  request_body_end_time_internal_error: HGr,
  create_calendar_event_error: YGr,
  update_calendar_event_error: KGr,
  delete_calendar_event_error: ZGr,
  already_signed_up_for_this_booking_error: XGr,
  hosts_unavailable_for_booking: JGr,
  fixed_hosts_unavailable_for_booking: QGr,
  round_robin_host_unavailable_for_booking: eWr,
  help: tWr,
  price: nWr,
  paid: oWr,
  refunded: rWr,
  record: iWr,
  transcribe: aWr,
  payment: sWr,
  missing_card_fields: cWr,
  pay_now: lWr,
  general_prompt: uWr,
  transcription_powered_by_ai: dWr,
  start_or_stop_recording: _Wr,
  begin_message: pWr,
  codebase_has_to_stay_opensource: mWr,
  cannot_repackage_codebase: fWr,
  acquire_license: gWr,
  terms_summary: hWr,
  open_env: vWr,
  env_changed: bWr,
  accept_license: yWr,
  still_waiting_for_approval: $Wr,
  event_is_still_waiting: wWr,
  no_result_found_for: kWr,
  no_more_results: SWr,
  no_results: EWr,
  load_more_results: xWr,
  integration_meeting_id: CWr,
  confirmed_event_type_subject: TWr,
  new_event_request: AWr,
  confirm_or_reject_request: IWr,
  check_bookings_page_to_confirm_or_reject: OWr,
  check_in_assistant: NWr,
  check_in_assistant_description: zWr,
  create_your_own_prompt: RWr,
  event_awaiting_approval: PWr,
  event_awaiting_approval_recurring: DWr,
  someone_requested_an_event: LWr,
  someone_requested_password_reset: MWr,
  password_reset_email_sent: FWr,
  password_reset_instructions: qWr,
  event_awaiting_approval_subject: jWr,
  event_still_awaiting_approval: VWr,
  booking_submitted_subject: BWr,
  download_recording_subject: UWr,
  download_transcript_email_subject: GWr,
  download_your_recording: WWr,
  download_your_transcripts: HWr,
  your_meeting_has_been_booked: YWr,
  event_type_has_been_rescheduled_on_time_date: KWr,
  event_type_has_been_updated: ZWr,
  event_has_been_rescheduled: XWr,
  event_has_been_updated: JWr,
  your_event_has_been_rescheduled: QWr,
  request_reschedule_subtitle: e8r,
  request_reschedule_title_organizer: t8r,
  request_reschedule_subtitle_organizer: n8r,
  rescheduled_event_type_subject: o8r,
  requested_to_reschedule_subject_attendee: r8r,
  hi_user_name: i8r,
  ics_event_title: a8r,
  please_book_a_time_sometime_later: s8r,
  schedule_instead: c8r,
  new_event_subject: l8r,
  join_by_entrypoint: u8r,
  notes: d8r,
  manage_my_bookings: _8r,
  need_to_make_a_change: p8r,
  new_event_scheduled: m8r,
  new_event_scheduled_recurring: f8r,
  invitee_email: g8r,
  invitee_timezone: h8r,
  time_left: v8r,
  event_type: b8r,
  duplicate_event_type: y8r,
  enter_meeting: $8r,
  video_call_provider: w8r,
  meeting_id: k8r,
  meeting_password: S8r,
  meeting_url: E8r,
  meeting_url_not_found: x8r,
  token_not_found: C8r,
  some_other_host_already_accepted_the_meeting: T8r,
  meeting_request_rejected: A8r,
  rejected_event_type_with_organizer: I8r,
  hi: O8r,
  join_team: N8r,
  manage_this_team: z8r,
  team_info: R8r,
  join_meeting: P8r,
  request_another_invitation_email: D8r,
  you_have_been_invited: L8r,
  user_invited_you: M8r,
  hidden_team_member_title: F8r,
  hidden_team_member_message: q8r,
  hidden_team_owner_message: j8r,
  link_expires: V8r,
  upgrade_to_per_seat: B8r,
  seat_options_doesnt_support_confirmation: U8r,
  multilocation_doesnt_support_seats: G8r,
  no_show_fee_doesnt_support_seats: W8r,
  seats_option_doesnt_support_multi_location: H8r,
  team_upgrade_seats_details: Y8r,
  team_upgrade_banner_description: K8r,
  upgrade_banner_action: Z8r,
  team_upgraded_successfully: X8r,
  org_upgrade_banner_description: J8r,
  org_upgraded_successfully: Q8r,
  use_link_to_reset_password: e7r,
  hey_there: t7r,
  there: n7r,
  forgot_your_password_calcom: o7r,
  delete_webhook_confirmation_message: r7r,
  confirm_delete_webhook: i7r,
  edit_webhook: a7r,
  delete_webhook: s7r,
  webhook_status: c7r,
  webhook_enabled: l7r,
  webhook_disabled: u7r,
  webhook_response: d7r,
  webhook_test: _7r,
  webhook_update_form: p7r,
  webhook_update_form_description: m7r,
  manage_your_webhook: f7r,
  webhook_created_successfully: g7r,
  webhook_updated_successfully: h7r,
  webhook_removed_successfully: v7r,
  subscription_needed: b7r,
  subscription_needed_description: y7r,
  payload_template: $7r,
  dismiss: w7r,
  no_data_yet: k7r,
  ping_test: S7r,
  add_to_homescreen: E7r,
  upcoming: x7r,
  recurring: C7r,
  past: T7r,
  choose_a_file: A7r,
  upload_image: I7r,
  upload_target: O7r,
  no_target: N7r,
  slide_zoom_drag_instructions: z7r,
  view_notifications: R7r,
  view_public_page: P7r,
  copy_public_page_link: D7r,
  copy_referral_link: L7r,
  sign_out: M7r,
  add_another: F7r,
  install_another: q7r,
  until: j7r,
  powered_by: V7r,
  unavailable: B7r,
  set_work_schedule: U7r,
  change_bookings_availability: G7r,
  select: W7r,
  "2fa_confirm_current_password": "Conferma la tua password attuale per iniziare.",
  "2fa_scan_image_or_use_code": "Scansiona l'immagine qui sotto con l'app di autenticazione sul tuo telefono o inserisci manualmente il codice di testo.",
  text: H7r,
  your_phone_number: Y7r,
  multiline_text: K7r,
  number: Z7r,
  checkbox: X7r,
  is_required: J7r,
  make_field_required: Q7r,
  required: eHr,
  optional: tHr,
  input_type: nHr,
  rejected: oHr,
  unconfirmed: rHr,
  guests: iHr,
  guest: aHr,
  web_conferencing_details_to_follow: sHr,
  confirmation: cHr,
  what_booker_should_provide: lHr,
  "404_the_user": "Il nome utente",
  username: uHr,
  is_still_available: dHr,
  documentation: _Hr,
  documentation_description: pHr,
  api_reference: mHr,
  api_reference_description: fHr,
  blog: gHr,
  blog_description: hHr,
  join_our_community: vHr,
  "404_claim_entity_user": "Richiedi il tuo nome utente e pianifica eventi",
  popular_pages: bHr,
  register_now: yHr,
  register: $Hr,
  page_doesnt_exist: wHr,
  no_active_phone_number_available: kHr,
  workflow_step_not_configured: SHr,
  check_spelling_mistakes_or_go_back: EHr,
  "404_page_not_found": "404: Questa pagina non è stata trovata.",
  booker_event_not_found: xHr,
  getting_started: CHr,
  "15min_meeting": "Meeting di 15 minuti",
  "30min_meeting": "Meeting di 30 minuti",
  secret: THr,
  leave_blank_to_remove_secret: AHr,
  webhook_secret_key_description: IHr,
  secret_meeting: OHr,
  login_instead: NHr,
  create_account: zHr,
  get_started: RHr,
  confirm_password: PHr,
  reset_your_password: DHr,
  org_banner_instructions: LHr,
  email_change: MHr,
  create_your_account: FHr,
  create_your_calcom_account: qHr,
  sign_up: jHr,
  youve_been_logged_out: VHr,
  hope_to_see_you_soon: BHr,
  logged_out: UHr,
  please_try_again_and_contact_us: GHr,
  incorrect_2fa_code: WHr,
  no_account_exists: HHr,
  "2fa_enabled_instructions": "Autenticazione a due fattori abilitata. Inserisci il codice a sei cifre dalla tua app di autenticazione.",
  "2fa_enter_six_digit_code": "Inserisci il codice a sei cifre dall'app di autenticazione qui sotto.",
  create_an_account: YHr,
  dont_have_an_account: KHr,
  "2fa_code": "Codice A Due Fattori",
  sign_in_account: ZHr,
  sign_in: XHr,
  go_back_login: JHr,
  error_during_login: QHr,
  request_password_reset: eYr,
  send_invite: tYr,
  forgot_password: nYr,
  forgot: oYr,
  done: rYr,
  all_done: iYr,
  all: aYr,
  yours: sYr,
  available_apps: cYr,
  available_apps_lower_case: lYr,
  available_apps_desc: uYr,
  fixed_host_helper: dYr,
  round_robin_groups_helper: _Yr,
  round_robin_helper: pYr,
  check_email_reset_password: mYr,
  finish: fYr,
  organization_general_description: gYr,
  few_sentences_about_yourself: hYr,
  nearly_there: vYr,
  nearly_there_instructions: bYr,
  set_availability_instructions: yYr,
  set_availability: $Yr,
  set_availbility_description: wYr,
  share_a_link_or_embed: kYr,
  share_a_link_or_embed_description: SYr,
  availability_settings: EYr,
  continue_without_calendar: xYr,
  continue_with: CYr,
  connect_your_calendar: TYr,
  connect_your_video_app: AYr,
  connect_your_video_app_instructions: IYr,
  connect_your_calendar_instructions: OYr,
  set_up_later: NYr,
  current_time: zYr,
  details: RYr,
  welcome: PYr,
  welcome_back: DYr,
  welcome_to_calcom: LYr,
  welcome_instructions: MYr,
  connect_caldav: FYr,
  connect_ics_feed: qYr,
  connect: jYr,
  try_for_free: VYr,
  create_booking_link_with_calcom: BYr,
  who: UYr,
  what: GYr,
  when: WYr,
  where: HYr,
  add_to_calendar: YYr,
  add_to_calendar_description: KYr,
  add_events_to: ZYr,
  add_another_calendar: XYr,
  other: JYr,
  email_sign_in_subject: QYr,
  round_robin_emailed_you_and_attendees: eKr,
  round_robin_emailed_host_and_attendee: tKr,
  emailed_host_and_attendee: nKr,
  emailed_host_and_attendee_recurring: oKr,
  round_robin_emailed_you_and_attendees_recurring: rKr,
  round_robin_emailed_host_and_attendee_recurring: iKr,
  emailed_you_and_any_other_attendees: aKr,
  needs_to_be_confirmed_or_rejected: sKr,
  needs_to_be_confirmed_or_rejected_recurring: cKr,
  user_needs_to_confirm_or_reject_booking: lKr,
  user_needs_to_confirm_or_reject_booking_recurring: uKr,
  meeting_is_scheduled: dKr,
  meeting_is_scheduled_recurring: _Kr,
  booking_submitted: pKr,
  booking_submitted_recurring: mKr,
  booking_confirmed: fKr,
  booking_confirmed_recurring: gKr,
  warning_recurring_event_payment: hKr,
  warning_payment_recurring_event: vKr,
  enter_new_password: bKr,
  reset_password: yKr,
  change_your_password: $Kr,
  show_password: wKr,
  hide_password: kKr,
  try_again: SKr,
  request_is_expired: EKr,
  reset_instructions: xKr,
  request_is_expired_instructions: CKr,
  whoops: TKr,
  login: AKr,
  success: IKr,
  failed: OKr,
  password_has_been_reset_login: NKr,
  layout: zKr,
  bookerlayout_default_title: RKr,
  bookerlayout_description: PKr,
  bookerlayout_user_settings_title: DKr,
  bookerlayout_user_settings_description: LKr,
  bookerlayout_month_view: MKr,
  bookerlayout_week_view: FKr,
  bookerlayout_column_view: qKr,
  bookerlayout_error_min_one_enabled: jKr,
  bookerlayout_error_default_not_enabled: VKr,
  bookerlayout_error_unknown_layout: BKr,
  bookerlayout_override_global_settings: UKr,
  unexpected_error_try_again: GKr,
  sunday_time_error: WKr,
  monday_time_error: HKr,
  tuesday_time_error: YKr,
  wednesday_time_error: KKr,
  thursday_time_error: ZKr,
  friday_time_error: XKr,
  saturday_time_error: JKr,
  error_end_time_before_start_time: QKr,
  error_end_time_next_day: eZr,
  back_to_bookings: tZr,
  free_to_pick_another_event_type: nZr,
  cancelled: oZr,
  no_booking: rZr,
  awaiting_host: iZr,
  cancellation_successful: aZr,
  really_cancel_booking: sZr,
  cannot_cancel_booking: cZr,
  reschedule_instead: lZr,
  event_is_in_the_past: uZr,
  cancelling_event_recurring: dZr,
  cancelling_all_recurring: _Zr,
  error_with_status_code_occured: pZr,
  error_event_type_url_duplicate: mZr,
  error_event_type_unauthorized_create: fZr,
  error_event_type_unauthorized_update: gZr,
  error_workflow_unauthorized_create: hZr,
  error_schedule_unauthorized_create: vZr,
  booking_already_cancelled: bZr,
  booking_already_accepted_rejected: yZr,
  go_back_home: $Zr,
  or_go_back_home: wZr,
  no_meeting_found: kZr,
  no_meeting_found_description: SZr,
  no_status_bookings_yet: EZr,
  no_status_bookings_yet_description: xZr,
  event_between_users: CZr,
  bookings: TZr,
  booking_not_found: AZr,
  bookings_description: IZr,
  upcoming_bookings: OZr,
  recurring_bookings: NZr,
  past_bookings: zZr,
  cancelled_bookings: RZr,
  unconfirmed_bookings: PZr,
  unconfirmed_bookings_tooltip: DZr,
  on: LZr,
  and: MZr,
  calendar_shows_busy_between: FZr,
  troubleshoot: qZr,
  troubleshoot_description: jZr,
  overview_of_day: VZr,
  hover_over_bold_times_tip: BZr,
  start_time: UZr,
  end_time: GZr,
  buffer_time: WZr,
  before_event: HZr,
  after_event: YZr,
  event_buffer_default: KZr,
  buffer: ZZr,
  your_day_starts_at: XZr,
  your_day_ends_at: JZr,
  launch_troubleshooter: QZr,
  troubleshoot_availability: eXr,
  change_available_times: tXr,
  change_your_available_times: nXr,
  change_start_end: oXr,
  change_start_end_buffer: rXr,
  current_start_date: iXr,
  start_end_changed_successfully: aXr,
  and_end_at: sXr,
  light: cXr,
  dark: lXr,
  automatically_adjust_theme: uXr,
  user_dynamic_booking_disabled: dXr,
  allow_dynamic_booking_tooltip: _Xr,
  allow_dynamic_booking: pXr,
  dynamic_booking: mXr,
  allow_seo_indexing: fXr,
  seo_indexing: gXr,
  allow_browser_notifications: hXr,
  you_have_denied_notifications: vXr,
  disable_browser_notifications: bXr,
  browser_notifications_turned_on: yXr,
  browser_notifications_turned_off: $Xr,
  browser_notifications_denied: wXr,
  please_allow_notifications: kXr,
  push_notifications: SXr,
  push_notifications_description: EXr,
  browser_notifications_not_supported: xXr,
  email: CXr,
  email_placeholder: TXr,
  full_name: AXr,
  browse_api_documentation: IXr,
  leverage_our_api: OXr,
  create_webhook: NXr,
  instant_meeting: zXr,
  booking_cancelled: RXr,
  booking_rescheduled: PXr,
  recording_ready: DXr,
  recording_transcription_generated: LXr,
  booking_created: MXr,
  booking_rejected: FXr,
  booking_requested: qXr,
  booking_payment_initiated: jXr,
  meeting_ended: VXr,
  form_submitted: BXr,
  form_submitted_no_event: UXr,
  booking_paid: GXr,
  ooo_created: WXr,
  booking_no_show_updated: HXr,
  event_triggers: YXr,
  subscriber_url: KXr,
  create_new_webhook: ZXr,
  webhooks: XXr,
  team_webhooks: JXr,
  create_new_webhook_to_account: QXr,
  new_webhook: eJr,
  receive_cal_meeting_data: tJr,
  receive_cal_event_meeting_data: nJr,
  responsive_fullscreen_iframe: oJr,
  loading: rJr,
  deleting: iJr,
  standard_iframe: aJr,
  developer: sJr,
  manage_developer_settings: cJr,
  iframe_embed: lJr,
  embed_calcom: uJr,
  integrate_using_embed_or_webhooks: dJr,
  schedule_a_meeting: _Jr,
  view_and_manage_billing_details: pJr,
  view_and_edit_billing_details: mJr,
  go_to_billing_portal: fJr,
  need_anything_else: gJr,
  further_billing_help: hJr,
  contact: vJr,
  our_support_team: bJr,
  contact_our_support_team: yJr,
  uh_oh: $Jr,
  no_event_types_have_been_setup: wJr,
  edit_logo: kJr,
  upload_a_logo: SJr,
  upload_logo: EJr,
  remove_logo: xJr,
  enable: CJr,
  code: TJr,
  code_is_incorrect: AJr,
  add_time_availability: IJr,
  add_an_extra_layer_of_security: OJr,
  "2fa": "Autenticazione A Due Fattori",
  "2fa_disabled": "L'autenticazione a due fattori può essere abilitata solo per l'autenticazione tramite e-mail e password",
  enable_2fa: NJr,
  disable_2fa: zJr,
  disable_2fa_recommendation: RJr,
  error_disabling_2fa: PJr,
  error_enabling_2fa: DJr,
  security: LJr,
  manage_account_security: MJr,
  password: FJr,
  password_updated_successfully: qJr,
  password_has_been_changed: jJr,
  error_changing_password: VJr,
  session_timeout_changed: BJr,
  session_timeout_change_error: UJr,
  something_went_wrong: GJr,
  something_doesnt_look_right: WJr,
  please_try_again: HJr,
  super_secure_new_password: YJr,
  new_password: KJr,
  your_old_password: ZJr,
  current_password: XJr,
  change_password: JJr,
  change_secret: QJr,
  new_password_matches_old_password: eQr,
  forgotten_secret_description: tQr,
  current_incorrect_password: nQr,
  password_hint_caplow: oQr,
  password_hint_min: rQr,
  password_hint_admin_min: iQr,
  password_hint_num: aQr,
  max_limit_allowed_hint: sQr,
  invalid_password_hint: cQr,
  incorrect_password: lQr,
  incorrect_email_password: uQr,
  use_setting: dQr,
  am_pm: _Qr,
  time_options: pQr,
  january: mQr,
  february: fQr,
  march: gQr,
  april: hQr,
  may: vQr,
  june: bQr,
  july: yQr,
  august: $Qr,
  september: wQr,
  october: kQr,
  november: SQr,
  december: EQr,
  monday: xQr,
  tuesday: CQr,
  wednesday: TQr,
  thursday: AQr,
  friday: IQr,
  saturday: OQr,
  sunday: NQr,
  all_booked_today: zQr,
  slots_load_fail: RQr,
  additional_guests: PQr,
  your_name: DQr,
  your_full_name: LQr,
  no_name: MQr,
  enter_number_between_range: FQr,
  continue_as_guest_description: qQr,
  email_address: jQr,
  enter_valid_email: VQr,
  please_schedule_future_call: BQr,
  location: UQr,
  address: GQr,
  enter_address: WQr,
  in_person_attendee_address: HQr,
  somewhere_else: YQr,
  custom_attendee_location: KQr,
  continue_as_guest: ZQr,
  join_as_guest: XQr,
  ideal_for_one_time_calls: JQr,
  any_location: QQr,
  yes: eei,
  no: tei,
  additional_notes: nei,
  booking_fail: oei,
  reschedule_fail: rei,
  share_additional_notes: iei,
  booking_confirmation: aei,
  booking_reschedule_confirmation: sei,
  in_person_meeting: cei,
  in_person: lei,
  link_meeting: uei,
  phone_number: dei,
  attendee_phone_number: _ei,
  organizer_phone_number: pei,
  enter_phone_number: mei,
  reschedule: fei,
  reschedule_this: gei,
  book_a_team_member: hei,
  or: vei,
  go_back: bei,
  email_or_username: yei,
  send_invite_email: $ei,
  role: wei,
  edit_role: kei,
  view_role: Sei,
  edit_team: Eei,
  editing_user: xei,
  editing_org: Cei,
  edit_or_manage_webhooks: Tei,
  reject: Aei,
  reject_all: Iei,
  accept: Oei,
  leave: Nei,
  profile: zei,
  my_team_url: Rei,
  my_teams: Pei,
  team_name: Dei,
  your_team_name: Lei,
  team_updated_successfully: Mei,
  your_team_updated_successfully: Fei,
  your_org_updated_successfully: qei,
  error_copying_to_clipboard: jei,
  about: Vei,
  team_description: Bei,
  organization_id: Uei,
  organization_id_copied: Gei,
  org_description: Wei,
  team_id: Hei,
  team_id_copied: Yei,
  members: Kei,
  organization_members: Zei,
  member: Xei,
  number_member_one: Jei,
  number_member_other: Qei,
  number_selected: eti,
  owner: tti,
  admin: nti,
  admin_api: oti,
  administrator_user: rti,
  lets_create_first_administrator_user: iti,
  admin_user_created: ati,
  admin_user_created_description: sti,
  new_member: cti,
  invite: lti,
  add_team_members: uti,
  add_org_members: dti,
  add_team_members_description: _ti,
  add_team_member: pti,
  invite_new_member: mti,
  invite_new_member_description: fti,
  invite_new_team_member: gti,
  upload_csv_file: hti,
  invite_via_email: vti,
  change_member_role: bti,
  disable_cal_branding: yti,
  disable_cal_branding_description: $ti,
  hide_book_a_team_member: wti,
  hide_book_a_team_member_description: kti,
  danger_zone: Sti,
  account_deletion_cannot_be_undone: Eti,
  team_deletion_cannot_be_undone: xti,
  back: Cti,
  cancel: Tti,
  cancel_all_remaining: Ati,
  apply: Iti,
  cancel_event: Oti,
  continue: "Continua",
  confirm: Nti,
  confirm_all: zti,
  disband_team: Rti,
  disband_team_confirmation_message: Pti,
  disband_org: Dti,
  disband_org_confirmation_message: Lti,
  remove_member_confirmation_message: Mti,
  confirm_disband_team: Fti,
  confirm_remove_member: qti,
  confirm_subscription_cancellation: jti,
  cancel_subscription: Vti,
  cancel_subscription_description: Bti,
  remove_member: Uti,
  manage_your_team: Gti,
  no_teams: Wti,
  no_teams_description: Hti,
  submit: Yti,
  confirm_remove_attribute: Kti,
  remove_attribute: Zti,
  remove_attribute_confirmation_message: Xti,
  delete: "Elimina",
  update: Jti,
  save: Qti,
  pending: eni,
  open_options: tni,
  copy_link: nni,
  share: oni,
  share_event: rni,
  copy_link_team: ini,
  leave_team: ani,
  confirm_leave_team: sni,
  leave_team_confirmation_message: cni,
  user_from_team: lni,
  preview: uni,
  link_copied: dni,
  copied: _ni,
  private_link_copied: pni,
  link_shared: mni,
  title: fni,
  description: gni,
  apps_status: hni,
  quick_video_meeting: vni,
  scheduling_type: bni,
  preview_team: yni,
  collective: $ni,
  collective_description: wni,
  duration: kni,
  available_durations: Sni,
  default_duration: Eni,
  default_duration_no_options: xni,
  multiple_duration_mins: Cni,
  multiple_duration_timeUnit: Tni,
  multiple_duration_timeUnit_short: Ani,
  minutes: Ini,
  use_cal_ai_to_make_call_description: Oni,
  termination_uri: Nni,
  sip_trunk_username: zni,
  sip_trunk_password: Rni,
  nickname: Pni,
  delete_phone_number: Dni,
  workflow_validation_failed: Lni,
  workflow_validation_empty_fields: Mni,
  workflow_validation_unverified_contacts: Fni,
  supercharge_your_workflows_with_cal_ai: qni,
  supercharge_your_workflows_with_cal_ai_description: jni,
  phone_number_imported_successfully: Vni,
  phone_number_deleted_successfully: Bni,
  delete_phone_number_confirmation: Uni,
  yes_delete_phone_number: Gni,
  phone_number_info_tooltip: Wni,
  termination_uri_info_tooltip: Hni,
  sip_trunk_username_info_tooltip: Yni,
  sip_trunk_password_info_tooltip: Kni,
  nickname_info_tooltip: Zni,
  save_and_test_call: Xni,
  call_initiated_successfully: Jni,
  please_enter_phone_number: Qni,
  agent_updated_successfully: eoi,
  agent_created_successfully: toi,
  agent_event_type_updated_successfully: noi,
  phone_number_unsubscribed_successfully: ooi,
  general_prompt_description: roi,
  prompt: ioi,
  call_to: aoi,
  make_test_call_to_verify_configuration: soi,
  initial_message: coi,
  initial_message_description: loi,
  having_trouble_importing: uoi,
  learn: doi,
  learn_how_to_get_your_terminator: _oi,
  phone_number_subscription_cancelled_successfully: poi,
  updating: moi,
  round_robin: foi,
  hi_how_are_you_doing: goi,
  round_robin_description: hoi,
  managed_event: voi,
  username_placeholder: boi,
  managed_event_description: yoi,
  managed: $oi,
  managed_event_url_clarification: woi,
  assign_to: koi,
  enter_phone_number_to_test_call: Soi,
  make_test_call: Eoi,
  create_new_workflow_agent: xoi,
  create_new_workflow_agent_description: Coi,
  phone_number_for_ai_call: Toi,
  buy_a_phone_number_or_import_one_you_already_have: Aoi,
  test_agent: Ioi,
  test_web_call: Ooi,
  phone_numbers: Noi,
  unsubscribe: zoi,
  delete_workflow_step: Roi,
  unsubscribe_phone_number: Poi,
  buy_a_new_number: Doi,
  only_us_phone_numbers_can_be_purchased_here: Loi,
  buy_number_for_x_per_month: Moi,
  supported_call_destinations: Foi,
  no_phone_number_connected: qoi,
  failed_to_get_workflow_step_id: joi,
  cal_ai_agent: Voi,
  test_cal_ai_agent: Boi,
  are_you_sure_you_want_to_delete_workflow_step: Uoi,
  do_you_still_want_to_unsubscribe: Goi,
  the_action_will_disconnect_phone_number: Woi,
  cal_ai_phone_numbers: Hoi,
  connect_phone_number: Yoi,
  cal_ai_phone_numbers_description: Koi,
  import_number: Zoi,
  this_action_will_also: Xoi,
  import_phone_number: Joi,
  active_subscription: Qoi,
  cancel_your_phone_number_subscription: eri,
  delete_associated_phone_number: tri,
  unauthorized_create_workflow: nri,
  import_phone_number_description: ori,
  phone_number_cost: rri,
  buy_new_number: iri,
  buy_number_cost_x_per_month: ari,
  area_code_optional: sri,
  no_phone_numbers: cri,
  phone_number_purchased_successfully: lri,
  cancel_phone_number_subscription: uri,
  yes_cancel_subscription: dri,
  cancel_phone_number_subscription_confirmation: _ri,
  add_members: pri,
  add_members_no_ellipsis: mri,
  no_assigned_members: fri,
  assigned_to: gri,
  you_must_be_logged_in_to: hri,
  start_assigning_members_above: vri,
  locked_fields_admin_description: bri,
  unlocked_fields_admin_description: yri,
  locked_fields_member_description: $ri,
  unlocked_fields_member_description: wri,
  url: kri,
  hidden: Sri,
  readonly: Eri,
  one_time_link: xri,
  plan_description: Cri,
  plan_upgrade_invitation: Tri,
  plan_upgrade: Ari,
  plan_upgrade_teams: Iri,
  plan_upgrade_instructions: Ori,
  event_types_page_title: Nri,
  event_types_page_subtitle: zri,
  new: "Nuovo",
  new_event_type_btn: Rri,
  new_event_type_heading: Pri,
  new_event_type_description: Dri,
  event_type_created_successfully: Lri,
  event_type_updated_successfully: Mri,
  event_type_deleted_successfully: Fri,
  hours: qri,
  people: jri,
  your_email: Vri,
  change_avatar: Bri,
  upload_avatar: Uri,
  language: Gri,
  timezone: Wri,
  first_day_of_week: Hri,
  repeats_up_to_one: Yri,
  repeats_up_to_other: Kri,
  every_for_freq: Zri,
  event_remaining_one: Xri,
  event_remaining_other: Jri,
  repeats_every: Qri,
  occurrence_one: eii,
  occurrence_other: tii,
  weekly_one: nii,
  weekly_other: oii,
  monthly_one: rii,
  monthly_other: iii,
  yearly_one: aii,
  yearly_other: sii,
  plus_more: cii,
  max: lii,
  single_theme: uii,
  brand_color: dii,
  light_brand_color: _ii,
  dark_brand_color: pii,
  light_event_type_color: mii,
  dark_event_type_color: fii,
  file_not_named: gii,
  create_team: hii,
  name: vii,
  nameless_team: bii,
  oauth_clients: yii,
  oauth_clients_description: $ii,
  create_oauth_client: wii,
  create_oauth_client_description: kii,
  oauth_client_deletion_message: Sii,
  create_new_team_description: Eii,
  create_new_team: xii,
  booking_redirect_uri: Cii,
  booking_cancel_redirect_uri: Tii,
  booking_reschedule_redirect_uri: Aii,
  booking_conflict_error: Iii,
  open_invitations: Oii,
  new_team: Nii,
  create_first_team_and_invite_others: zii,
  create_team_to_get_started: Rii,
  teams: Pii,
  team: Dii,
  organization: Lii,
  team_billing: Mii,
  team_billing_description: Fii,
  upgrade_to_flexible_pro_title: qii,
  upgrade_to_flexible_pro_message: jii,
  changed_team_billing_info: Vii,
  create_manage_teams_collaborative: Bii,
  only_available_on_pro_plan: Uii,
  remove_cal_branding_description: Gii,
  edit_profile_info_description: Wii,
  change_email_tip: Hii,
  little_something_about: Yii,
  profile_updated_successfully: Kii,
  your_user_profile_updated_successfully: Zii,
  your_upgrade_is_here: Xii,
  your_upgrade_is_here_description: Jii,
  you_are_all_set: Qii,
  you_are_all_set_description: eai,
  user_cannot_found_db: tai,
  embed_and_webhooks: nai,
  enabled: oai,
  disabled: rai,
  disable: iai,
  billing: aai,
  here: sai,
  manage_your_billing_info: cai,
  availability: lai,
  edit_availability: uai,
  configure_availability: dai,
  copy_times_to: _ai,
  copy_times_to_tooltip: pai,
  change_weekly_schedule: mai,
  logo: fai,
  error: gai,
  at_least_characters_one: hai,
  at_least_characters_other: vai,
  team_logo: bai,
  add_location: yai,
  attendees: $ai,
  add_attendees: wai,
  show_advanced_settings: kai,
  hide_advanced_settings: Sai,
  event_name: Eai,
  event_name_in_calendar: xai,
  event_name_tooltip: Cai,
  meeting_with_user: Tai,
  additional_inputs: Aai,
  additional_input_description: Iai,
  label: Oai,
  placeholder: Nai,
  display_add_to_calendar_organizer: zai,
  display_email_as_organizer: Rai,
  if_enabled_email_address_as_organizer: Pai,
  reconnect_calendar_to_use: Dai,
  type: Lai,
  edit: Mai,
  add_input: Fai,
  disable_notes: qai,
  disable_notes_description: jai,
  requires_confirmation_description: Vai,
  requires_confirmation_will_block_slot_description: Bai,
  recurring_event: Uai,
  recurring_event_description: Gai,
  connect_and_join: Wai,
  cannot_be_used_with_paid_event_types: Hai,
  warning_payment_instant_meeting_event: Yai,
  warning_instant_meeting_experimental: Kai,
  starting: Zai,
  disable_guests: Xai,
  disable_guests_description: Jai,
  private_link: Qai,
  enable_private_url: esi,
  private_link_label: tsi,
  private_link_hint: nsi,
  copy_private_link: osi,
  copy_private_link_to_event: rsi,
  private_link_description: isi,
  multiple_private_links_title: asi,
  multiple_private_links_description: ssi,
  add_a_multiple_private_link: csi,
  multiple_private_link_copied: lsi,
  invitees_can_schedule: usi,
  date_range: dsi,
  calendar_days: _si,
  business_days: psi,
  set_address_place: msi,
  set_link_meeting: fsi,
  managed_event_field_parent_control_disabled: gsi,
  cal_invitee_phone_number_scheduling: hsi,
  cal_provide_google_meet_location: vsi,
  cal_provide_zoom_meeting_url: bsi,
  cal_provide_tandem_meeting_url: ysi,
  cal_provide_video_meeting_url: $si,
  cal_provide_jitsi_meeting_url: wsi,
  cal_provide_huddle01_meeting_url: ksi,
  cal_provide_teams_meeting_url: Ssi,
  require_payment: Esi,
  you_need_to_add_a_name: xsi,
  commission_per_transaction: Csi,
  event_type_updated_successfully_description: Tsi,
  hide_event_type: Asi,
  edit_location: Isi,
  into_the_future: Osi,
  when_booked_with_less_than_notice: Nsi,
  within_date_range: zsi,
  indefinitely_into_future: Rsi,
  add_new_custom_input_field: Psi,
  quick_chat: Dsi,
  add_new_team_event_type: Lsi,
  add_new_event_type: Msi,
  new_event_type_to_book_description: Fsi,
  length: qsi,
  minimum_booking_notice: jsi,
  offset_toggle: Vsi,
  offset_toggle_description: Bsi,
  offset_start: Usi,
  offset_start_description: Gsi,
  slot_interval: Wsi,
  slot_interval_default: Hsi,
  delete_event_type: Ysi,
  delete_managed_event_type: Ksi,
  delete_event_type_description: Zsi,
  delete_managed_event_type_description_1: Xsi,
  delete_managed_event_type_description_2: Jsi,
  confirm_delete_event_type: Qsi,
  delete_account: eci,
  confirm_delete_account: tci,
  delete_account_confirmation_message: nci,
  integrations: oci,
  apps: rci,
  apps_description: ici,
  apps_listing: aci,
  category_apps: sci,
  app_store: cci,
  app_store_description: lci,
  connect_your_video: uci,
  settings: dci,
  event_type_moved_successfully: _ci,
  next_step_text: pci,
  next_step: mci,
  prev_step: fci,
  install: gci,
  start_paid_trial: hci,
  installed: vci,
  active_install_one: bci,
  active_install_other: yci,
  globally_install: $ci,
  app_successfully_installed: wci,
  app_could_not_be_installed: kci,
  disconnect: Sci,
  embed_your_calendar: Eci,
  connect_your_favourite_apps: xci,
  automation: Cci,
  configure_how_your_event_types_interact: Tci,
  toggle_calendars_conflict: Aci,
  connect_additional_calendar: Ici,
  calendar_updated_successfully: Oci,
  check_here: Nci,
  conferencing: zci,
  calendar: Rci,
  payments: Pci,
  not_installed: Dci,
  error_password_mismatch: Lci,
  error_required_field: Mci,
  status: Fci,
  team_view_user_availability: qci,
  team_view_user_availability_disabled: jci,
  set_as_away: Vci,
  set_as_free: Bci,
  toggle_away_error: Uci,
  user_away: Gci,
  user_away_description: Wci,
  meet_people_with_the_same_tokens: Hci,
  only_book_people_and_allow: Yci,
  account_created_with_identity_provider: Kci,
  account_managed_by_identity_provider: Zci,
  account_managed_by_identity_provider_description: Xci,
  account_managed_by_identity_provider_error: Jci,
  user_creation_error: Qci,
  signin_with_google: eli,
  signin_with_saml: tli,
  signin_with_saml_oidc: nli,
  continue_with_email: oli,
  continue_with_google: rli,
  last_used: ili,
  you_will_need_to_generate: ali,
  import: "Importa",
  import_from: sli,
  access_token: cli,
  visit_roadmap: lli,
  featured_categories: uli,
  feature_flags: dli,
  admin_flags_description: _li,
  popular_categories: pli,
  number_apps_one: mli,
  number_apps_other: fli,
  trending_apps: gli,
  most_popular: hli,
  installed_apps: vli,
  free_to_use_apps: bli,
  no_category_apps: yli,
  all_apps: $li,
  no_category_apps_description_calendar: wli,
  no_category_apps_description_conferencing: kli,
  no_category_apps_description_payment: Sli,
  no_category_apps_description_analytics: Eli,
  no_category_apps_description_automation: xli,
  no_category_apps_description_other: Cli,
  no_category_apps_description_messaging: Tli,
  no_category_apps_description_crm: Ali,
  installed_app_calendar_description: Ili,
  installed_app_payment_description: Oli,
  installed_app_analytics_description: Nli,
  installed_app_other_description: zli,
  installed_app_conferencing_description: Rli,
  installed_app_automation_description: Pli,
  installed_app_messaging_description: Dli,
  installed_app_crm_description: Lli,
  analytics: Mli,
  empty_installed_apps_headline: Fli,
  empty_installed_apps_description: qli,
  empty_installed_apps_button: jli,
  manage_your_connected_apps: Vli,
  browse_apps: Bli,
  features: Uli,
  permissions: Gli,
  terms_and_privacy: Wli,
  published_by: Hli,
  subscribe: Yli,
  buy: Kli,
  install_app: Zli,
  categories: Xli,
  pricing: Jli,
  learn_more: Qli,
  try_now: eui,
  privacy_policy: tui,
  terms_of_service: nui,
  remove: oui,
  add: rui,
  installed_other: iui,
  verify_wallet: aui,
  create_events_on: sui,
  enterprise_license: cui,
  enterprise_license_locally: lui,
  enterprise_license_sales: uui,
  missing_license: dui,
  next_steps: _ui,
  acquire_commercial_license: pui,
  the_infrastructure_plan: mui,
  prisma_studio_tip: fui,
  prisma_studio_tip_description: gui,
  contact_sales: hui,
  error_404: vui,
  default: "Predefinito",
  set_to_default: bui,
  new_schedule_btn: yui,
  add_new_schedule: $ui,
  add_new_calendar: wui,
  set_calendar: kui,
  delete_schedule: Sui,
  delete_schedule_description: Eui,
  schedule_created_successfully: xui,
  availability_updated_successfully: Cui,
  schedule_deleted_successfully: Tui,
  default_schedule_name: Aui,
  new_schedule_heading: Iui,
  new_schedule_description: Oui,
  requires_ownership_of_a_token: Nui,
  example_name: zui,
  time_format: Rui,
  "12_hour": "12 ore",
  "24_hour": "24 ore",
  "12_hour_short": "12h",
  "24_hour_short": "24 ore",
  redirect_success_booking: Pui,
  you_are_being_redirected: Dui,
  external_redirect_url: Lui,
  redirect_url_description: Mui,
  duplicate: Fui,
  offer_seats: qui,
  offer_seats_description: jui,
  seats_available_one: Vui,
  seats_available_other: Bui,
  seats_nearly_full: Uui,
  seats_half_full: Gui,
  number_of_seats: Wui,
  set_instant_meeting_expiry_time_offset_description: Hui,
  enter_number_of_seats: Yui,
  you_can_manage_your_schedules: Kui,
  booking_full: Zui,
  api_keys: Xui,
  api_key: Jui,
  test_api_key: Qui,
  test_passed: edi,
  test_failed: tdi,
  provide_api_key: ndi,
  api_key_modal_subtitle: odi,
  api_key_modal_subtitle_platform: rdi,
  api_keys_subtitle: idi,
  create_api_key: adi,
  personal_note: sdi,
  personal_note_placeholder: cdi,
  api_key_no_note: ldi,
  api_key_never_expires: udi,
  edit_api_key: ddi,
  success_api_key_created: _di,
  success_api_key_edited: pdi,
  create: mdi,
  success_api_key_created_bold_tagline: fdi,
  you_will_only_view_it_once: gdi,
  copy_to_clipboard: hdi,
  enabled_after_update: vdi,
  enabled_after_update_description: bdi,
  confirm_delete_api_key: ydi,
  disable_rescheduling: $di,
  description_disable_rescheduling: wdi,
  allow_rescheduling_cancelled_bookings: kdi,
  description_allow_rescheduling_cancelled_bookings: Sdi,
  disable_cancelling: Edi,
  description_disable_cancelling: xdi,
  revoke_api_key: Cdi,
  api_key_copied: Tdi,
  api_key_expires_on: Adi,
  delete_api_key_confirm_title: Idi,
  copy: Odi,
  expire_date: Ndi,
  expired: zdi,
  never_expires: Rdi,
  expires: Pdi,
  request_reschedule_booking: Ddi,
  reason_for_reschedule: Ldi,
  book_a_new_time: Mdi,
  reschedule_request_sent: Fdi,
  reschedule_modal_description: qdi,
  reason_for_reschedule_request: jdi,
  send_reschedule_request: Vdi,
  edit_booking: Bdi,
  reschedule_booking: Udi,
  former_time: Gdi,
  confirmation_page_gif: Wdi,
  search: Hdi,
  impersonate: Ydi,
  user_impersonation_heading: Kdi,
  user_impersonation_description: Zdi,
  team_impersonation_description: Xdi,
  cal_signup_description: Jdi,
  make_org_private: Qdi,
  make_org_private_description: e_i,
  make_team_private: t_i,
  make_team_private_description: n_i,
  you_cannot_see_team_members: o_i,
  you_cannot_see_teams_of_org: r_i,
  allow_multiple_durations: i_i,
  impersonate_user_tip: a_i,
  impersonating_user_warning: s_i,
  impersonating_stop_instructions: c_i,
  event_location_changed: l_i,
  new_guests_added: u_i,
  location_changed_event_type_subject: d_i,
  guests_added_event_type_subject: __i,
  current_location: p_i,
  new_location: m_i,
  session: f_i,
  session_description: g_i,
  session_timeout_after: h_i,
  session_timeout: v_i,
  session_timeout_description: b_i,
  no_location: y_i,
  set_location: $_i,
  update_location: w_i,
  location_updated: k_i,
  location_update_failed: S_i,
  guests_added: E_i,
  unable_to_add_guests: x_i,
  email_validation_error: C_i,
  emails_must_be_unique_valid: T_i,
  url_validation_error: A_i,
  place_where_cal_widget_appear: I_i,
  create_update_react_component: O_i,
  copy_code: N_i,
  code_copied: z_i,
  how_you_want_add_cal_site: R_i,
  choose_ways_put_cal_site: P_i,
  setting_up_zapier: D_i,
  setting_up_make: L_i,
  generate_api_key: M_i,
  generate_api_key_description: F_i,
  your_unique_api_key: q_i,
  copy_safe_api_key: j_i,
  zapier_setup_instructions: V_i,
  make_setup_instructions_1: B_i,
  make_setup_instructions_2: U_i,
  make_setup_instructions_3: G_i,
  make_setup_instructions_4: W_i,
  make_setup_instructions_5: H_i,
  make_setup_instructions_6: Y_i,
  install_zapier_app: K_i,
  install_make_app: Z_i,
  app_installation: X_i,
  app_not_installed: J_i,
  visit_our_app_store: Q_i,
  connect_apple_server: epi,
  calendar_url: tpi,
  apple_server_generate_password: npi,
  unable_to_add_apple_calendar: opi,
  credentials_stored_encrypted: rpi,
  it_stored_encrypted: ipi,
  go_to_app_store: api,
  calendar_error: spi,
  set_your_phone_number: cpi,
  calendar_no_busy_slots: lpi,
  display_location_label: upi,
  display_location_info_badge: dpi,
  add_gif: _pi,
  search_giphy: ppi,
  add_link_from_giphy: mpi,
  add_gif_to_confirmation: fpi,
  find_gif_spice_confirmation: gpi,
  share_feedback: hpi,
  resources: vpi,
  support_documentation: bpi,
  developer_documentation: ypi,
  get_in_touch: $pi,
  contact_support: wpi,
  premium_support: kpi,
  community_support: Spi,
  feedback: Epi,
  submitted_feedback: xpi,
  feedback_error: Cpi,
  comments: Tpi,
  booking_details: Api,
  or_lowercase: Ipi,
  nevermind: Opi,
  go_to: Npi,
  zapier_invite_link: zpi,
  meeting_url_provided_after_confirmed: Rpi,
  dynamically_display_attendee_or_organizer: Ppi,
  event_location: Dpi,
  reschedule_optional: Lpi,
  reschedule_placeholder: Mpi,
  event_cancelled: Fpi,
  emailed_information_about_cancelled_event: qpi,
  this_input_will_shown_booking_this_event: jpi,
  meeting_url_in_confirmation_email: Vpi,
  url_start_with_https: Bpi,
  number_provided: Upi,
  before_event_trigger: Gpi,
  event_cancelled_trigger: Wpi,
  after_hosts_cal_video_no_show: Hpi,
  after_guests_cal_video_no_show: Ypi,
  join_video_call: Kpi,
  sign_in_to_cal_com: Zpi,
  log_in_to_cal_com: Xpi,
  track_your_meetings: Jpi,
  track_meetings_and_manage_schedule: Qpi,
  failed_to_join_call: emi,
  choose_how_you_d_like_to_join_call: tmi,
  choose_how_you_d_like_to_appear_on_the_call: nmi,
  new_event_trigger: omi,
  email_host_action: rmi,
  email_attendee_action: imi,
  sms_attendee_action: ami,
  sms_number_action: smi,
  send_reminder_sms: cmi,
  whatsapp_number_action: lmi,
  whatsapp_attendee_action: umi,
  workflows: dmi,
  new_workflow_btn: _mi,
  how_would_you_like_to_start: pmi,
  add_new_workflow: mmi,
  reschedule_event_trigger: fmi,
  trigger: gmi,
  triggers: hmi,
  action: vmi,
  workflows_to_automate_notifications: bmi,
  workflow_name: ymi,
  custom_workflow: $mi,
  workflow_created_successfully: wmi,
  delete_workflow_description: kmi,
  delete_workflow: Smi,
  confirm_delete_workflow: Emi,
  workflow_deleted_successfully: xmi,
  how_long_before: Cmi,
  day_timeUnit: Tmi,
  hour_timeUnit: Ami,
  minute_timeUnit: Imi,
  minute_short: Omi,
  hour_short: Nmi,
  new_workflow_heading: zmi,
  new_workflow_description: Rmi,
  active_on: Pmi,
  workflow_updated_successfully: Dmi,
  premium_to_standard_username_description: Lmi,
  premium_username: Mmi,
  current: Fmi,
  premium: qmi,
  standard: jmi,
  confirm_username_change_dialog_title: Vmi,
  change_username_standard_to_premium: Bmi,
  change_username_premium_to_standard: Umi,
  go_to_stripe_billing: Gmi,
  stripe_description: Wmi,
  trial_expired: Hmi,
  remove_app: Ymi,
  yes_remove_app: Kmi,
  are_you_sure_you_want_to_remove_this_app: Zmi,
  app_removed_successfully: Xmi,
  error_removing_app: Jmi,
  web_conference: Qmi,
  web_call: efi,
  start_web_call: tfi,
  end_call: nfi,
  test_your_agent_with_web_call: ofi,
  phone_call: rfi,
  connecting_to_agent: ifi,
  call_active: afi,
  call_ended: sfi,
  call_error: cfi,
  ready_to_start_call: lfi,
  failed_to_start_web_call_try_again: ufi,
  call_encountered_error_try_again: dfi,
  failed_initialize_web_call_microphone_permissions: _fi,
  start_call_to_see_conversation: pfi,
  waiting_for_conversation: mfi,
  ai_agent: ffi,
  live: gfi,
  connecting: hfi,
  requires_confirmation: vfi,
  requires_confirmation_threshold: bfi,
  may_require_confirmation: yfi,
  nr_event_type_one: $fi,
  nr_event_type_other: wfi,
  count_team_one: kfi,
  count_team_other: Sfi,
  add_action: Efi,
  set_whereby_link: xfi,
  invalid_whereby_link: Cfi,
  set_around_link: Tfi,
  invalid_around_link: Afi,
  set_riverside_link: Ifi,
  invalid_riverside_link: Ofi,
  invalid_ping_link: Nfi,
  add_exchange2013: zfi,
  add_exchange2016: Rfi,
  custom_template: Pfi,
  email_body: Dfi,
  text_message: Lfi,
  specific_issue: Mfi,
  browse_our_docs: Ffi,
  choose_template: qfi,
  custom: jfi,
  reminder: Vfi,
  rescheduled: Bfi,
  rescheduled_by: Ufi,
  original_booking: Gfi,
  completed: Wfi,
  rating: Hfi,
  reminder_email: Yfi,
  not_triggering_existing_bookings: Kfi,
  minute_one: Zfi,
  minute_one_short: Xfi,
  minute_other: Jfi,
  hour_one: Qfi,
  hour_one_short: egi,
  hour_other: tgi,
  invalid_input: ngi,
  broken_video_action: ogi,
  broken_calendar_action: rgi,
  attendee_name: igi,
  scheduler_full_name: agi,
  broken_integration: sgi,
  problem_adding_video_link: cgi,
  problem_updating_calendar: lgi,
  active_on_event_types_one: ugi,
  active_on_event_types_other: dgi,
  active_on_teams_one: _gi,
  active_on_teams_other: pgi,
  active_on_all_event_types: mgi,
  active_on_all_teams: fgi,
  no_active_event_types: ggi,
  no_active_teams: hgi,
  new_seat_subject: vgi,
  new_seat_title: bgi,
  variable: ygi,
  event_name_variable: $gi,
  attendee_name_variable: wgi,
  event_date_variable: kgi,
  event_time_variable: Sgi,
  organizer_name_variable: Egi,
  app_upgrade_description: xgi,
  invalid_number: Cgi,
  invalid_url_error_message: Tgi,
  navigate: Agi,
  open: Igi,
  close: Ogi,
  upgrade: Ngi,
  buy_us_number_button: zgi,
  upgrade_to_access_recordings_title: Rgi,
  upgrade_to_access_recordings_description: Pgi,
  upgrade_to_cal_ai_phone_number_description: Dgi,
  recordings_are_part_of_the_teams_plan: Lgi,
  team_feature_teams: Mgi,
  team_feature_workflows: Fgi,
  show_eventtype_on_profile: qgi,
  embed: jgi,
  new_username: Vgi,
  current_username: Bgi,
  example_1: Ugi,
  example_2: Ggi,
  booking_question_identifier: Wgi,
  company_size: Hgi,
  what_help_needed: Ygi,
  variable_format: Kgi,
  webhook_subscriber_url_reserved: Zgi,
  custom_input_as_variable_info: Xgi,
  using_booking_questions_as_variables: Jgi,
  download_desktop_app: Qgi,
  set_ping_link: ehi,
  rate_limit_exceeded: thi,
  when_something_happens: nhi,
  action_is_performed: ohi,
  test_action: rhi,
  notification_sent: ihi,
  no_input: ahi,
  test_workflow_action: shi,
  send_sms: chi,
  send_sms_to_number: lhi,
  missing_connected_calendar: uhi,
  connect_your_calendar_and_link: dhi,
  default_calendar_selected: _hi,
  hide_from_profile: phi,
  basics: mhi,
  availability_not_found_in_schedule_error: fhi,
  event_limit_tab_title: ghi,
  event_limit_tab_description: hhi,
  event_advanced_tab_description: vhi,
  event_advanced_tab_title: bhi,
  event_payments_tab_description: yhi,
  event_setup_multiple_duration_error: $hi,
  event_setup_multiple_duration_default_error: whi,
  event_setup_booking_limits_error: khi,
  event_setup_duration_limits_error: Shi,
  select_which_cal: Ehi,
  custom_event_name: xhi,
  custom_event_name_description: Chi,
  "2fa_required": "Autenticazione a due fattori necessaria",
  incorrect_2fa: Thi,
  which_event_type_apply: Ahi,
  apply_to_all_event_types: Ihi,
  apply_to_all_teams: Ohi,
  which_team_apply: Nhi,
  no_workflows_description: zhi,
  timeformat_profile_hint: Rhi,
  create_workflow: Phi,
  do_this: Dhi,
  turn_off: Lhi,
  turn_on: Mhi,
  cancelled_bookings_cannot_be_rescheduled: Fhi,
  settings_updated_successfully: qhi,
  error_updating_settings: jhi,
  personal_cal_url: Vhi,
  bio_hint: Bhi,
  finish_and_start: Uhi,
  user_has_no_bio: Ghi,
  bio: Whi,
  delete_account_modal_title: Hhi,
  confirm_delete_account_modal: Yhi,
  delete_my_account: Khi,
  start_of_week: Zhi,
  recordings_title: Xhi,
  recording: Jhi,
  happy_scheduling: Qhi,
  select_calendars: evi,
  check_for_conflicts: tvi,
  view_recordings: nvi,
  check_for_recordings: ovi,
  adding_events_to: rvi,
  follow_system_preferences: ivi,
  custom_brand_colors: avi,
  customize_your_brand_colors: svi,
  pro: cvi,
  removes_cal_branding: lvi,
  instant_meeting_with_title: uvi,
  profile_picture: dvi,
  upload: _vi,
  add_profile_photo: pvi,
  token_address: mvi,
  blockchain: fvi,
  old_password: gvi,
  secure_password: hvi,
  error_updating_password: vvi,
  two_factor_auth: bvi,
  recurring_event_tab_description: yvi,
  today: $vi,
  appearance: wvi,
  my_account: kvi,
  general: Svi,
  calendars: Evi,
  "2fa_auth": "Autenticazione a due fattori",
  invoices: xvi,
  embeds: Cvi,
  impersonation: Tvi,
  impersonation_description: Avi,
  recent_impersonations: Ivi,
  quick_impersonate: Ovi,
  no_recent_impersonations: Nvi,
  users: zvi,
  user: Rvi,
  profile_description: Pvi,
  users_description: Dvi,
  users_listing: Lvi,
  general_description: Mvi,
  calendars_description: Fvi,
  appearance_description: qvi,
  conferencing_description: jvi,
  add_conferencing_app: Vvi,
  password_description: Bvi,
  set_up_two_factor_authentication: Uvi,
  we_just_need_basic_info: Gvi,
  skip: Wvi,
  do_this_later: Hvi,
  set_availability_getting_started_subtitle_1: Yvi,
  set_availability_getting_started_subtitle_2: Kvi,
  connect_calendar_first: Zvi,
  complete_profile: Xvi,
  connect_calendars_from_app_store: Jvi,
  connect_conference_apps: Qvi,
  connect_calendar_apps: ebi,
  connect_payment_apps: tbi,
  connect_automation_apps: nbi,
  connect_analytics_apps: obi,
  connect_other_apps: rbi,
  connect_messaging_apps: ibi,
  connect_crm_apps: abi,
  current_step_of_total: sbi,
  add_variable: cbi,
  custom_phone_number: lbi,
  message_template: ubi,
  email_subject: dbi,
  add_dynamic_variables: _bi,
  event_name_info: pbi,
  event_date_info: mbi,
  event_duration_info: fbi,
  event_time_info: gbi,
  event_type_not_found: hbi,
  number_to_call_variable: vbi,
  number_to_call_info: bbi,
  location_variable: ybi,
  location_info: $bi,
  additional_notes_variable: wbi,
  additional_notes_info: kbi,
  attendee_name_info: Sbi,
  organizer_name_info: Ebi,
  to: xbi,
  workflow_turned_on_successfully: Cbi,
  download_responses: Tbi,
  download_responses_description: Abi,
  view_responses: Ibi,
  download: Obi,
  downloading: Nbi,
  download_recording: zbi,
  transcription_enabled: Rbi,
  transcription_stopped: Pbi,
  download_transcript: Dbi,
  transcript: Lbi,
  recording_from_your_recent_call: Mbi,
  transcript_from_previous_call: Fbi,
  you_can_download_transcript_from_attachments: qbi,
  link_valid_for_12_hrs: jbi,
  link_valid_for_12_hrs_description: Vbi,
  create_your_first_form: Bbi,
  create_your_first_form_description: Ubi,
  create_your_first_webhook: Gbi,
  create_your_first_webhook_description: Wbi,
  for_a_maximum_of: Hbi,
  event_one: Ybi,
  event_other: Kbi,
  profile_team_description: Zbi,
  profile_org_description: Xbi,
  members_team_description: Jbi,
  organization_description: Qbi,
  team_url: eyi,
  team_members: tyi,
  more: nyi,
  cal_ai_workflows: oyi,
  and_count_more: ryi,
  more_page_footer: iyi,
  workflow_example_1: ayi,
  workflow_example_2: syi,
  workflow_example_3: cyi,
  workflow_example_4: lyi,
  workflow_example_5: uyi,
  workflow_example_6: dyi,
  send_sms_reminder: _yi,
  send_sms_reminder_description: pyi,
  follow_up_with_no_shows: myi,
  follow_up_with_no_shows_description: fyi,
  remind_attendees_to_bring_id: gyi,
  remind_attendees_to_bring_id_description: hyi,
  email_to_remind_booking: vyi,
  email_to_remind_booking_description: byi,
  custom_sms_reminder: yyi,
  custom_sms_reminder_description: $yi,
  custom_email_reminder: wyi,
  custom_email_reminder_description: kyi,
  count_managed_to_limit: Syi,
  welcome_to_cal_header: Eyi,
  edit_form_later_subtitle: xyi,
  connect_calendar_later: Cyi,
  problem_saving_user_profile: Tyi,
  purchase_missing_seats: Ayi,
  slot_length: Iyi,
  booking_appearance: Oyi,
  appearance_team_description: Nyi,
  appearance_org_description: zyi,
  only_owner_change: Ryi,
  team_disable_cal_branding_description: Pyi,
  invited_by_team: Dyi,
  token_invalid_expired: Lyi,
  view_booking: Myi,
  exchange_add: Fyi,
  exchange_authentication: qyi,
  exchange_authentication_standard: jyi,
  exchange_authentication_ntlm: Vyi,
  exchange_compression: Byi,
  exchange_version: Uyi,
  exchange_version_2007_SP1: Gyi,
  exchange_version_2010: Wyi,
  exchange_version_2010_SP1: Hyi,
  exchange_version_2010_SP2: Yyi,
  exchange_version_2013: Kyi,
  exchange_version_2013_SP1: Zyi,
  exchange_version_2015: Xyi,
  exchange_version_2016: Jyi,
  routing: Qyi,
  routing_forms_description: e$i,
  routing_forms_send_email_owner: t$i,
  routing_forms_send_email_owner_description: n$i,
  routing_forms_send_email_to: o$i,
  add_new_form: r$i,
  add_new_team_form: i$i,
  create_your_first_route: a$i,
  route_to_the_right_person: s$i,
  form: c$i,
  form_description: l$i,
  copy_link_to_form: u$i,
  theme: d$i,
  theme_applies_note: _$i,
  app_theme: p$i,
  app_theme_applies_note: m$i,
  theme_system: f$i,
  add_a_team: g$i,
  add_webhook_description: h$i,
  triggers_when: v$i,
  test_webhook: b$i,
  enable_webhook: y$i,
  add_webhook: $$i,
  webhook_edited_successfully: w$i,
  api_keys_description: k$i,
  new_api_key: S$i,
  active: E$i,
  api_key_updated: x$i,
  api_key_update_failed: C$i,
  embeds_title: T$i,
  embeds_description: A$i,
  create_first_api_key: I$i,
  create_first_api_key_description: O$i,
  back_to_signin: N$i,
  reset_link_sent: z$i,
  password_reset_email: R$i,
  password_reset_leading: P$i,
  password_updated: D$i,
  pending_payment: L$i,
  pending_invites: M$i,
  pending_organization_invites: F$i,
  not_on_cal: q$i,
  no_calendar_installed: j$i,
  no_calendar_installed_description: V$i,
  add_a_calendar: B$i,
  change_email_hint: U$i,
  confirm_password_change_email: G$i,
  seats: W$i,
  every_app_published: H$i,
  report_app: Y$i,
  limit_booking_frequency: K$i,
  limit_booking_frequency_description: Z$i,
  only_show_first_available_slot: X$i,
  only_show_first_available_slot_description: J$i,
  limit_total_booking_duration: Q$i,
  limit_total_booking_duration_description: ewi,
  booker_booking_limit: twi,
  booker_booking_limit_description: nwi,
  recurring_event_doesnt_support_booker_booking_limit: owi,
  add_limit: rwi,
  team_name_required: iwi,
  show_attendees: awi,
  show_available_seats_count: swi,
  how_booking_questions_as_variables: cwi,
  format: lwi,
  questions: uwi,
  all_info_your_booker_provide: dwi,
  uppercase_for_letters: _wi,
  replace_whitespaces_underscores: pwi,
  platform_members: mwi,
  platform_members_description: fwi,
  platform_billing: gwi,
  manage_billing: hwi,
  manage_billing_description: vwi,
  billing_freeplan_title: bwi,
  billing_freeplan_description: ywi,
  billing_freeplan_cta: $wi,
  billing_portal: wwi,
  billing_help_cta: kwi,
  ignore_special_characters_booking_questions: Swi,
  retry: Ewi,
  fetching_calendars_error: xwi,
  calendar_connection_fail: Cwi,
  booking_confirmation_success: Twi,
  booking_rejection_success: Awi,
  booking_tentative: Iwi,
  booking_accept_intent: Owi,
  we_wont_show_again: Nwi,
  couldnt_update_timezone: zwi,
  updated_timezone_to: Rwi,
  update_timezone: Pwi,
  update_timezone_question: Dwi,
  update_timezone_description: Lwi,
  dont_update: Mwi,
  require_additional_notes: Fwi,
  require_additional_notes_description: qwi,
  email_address_action: jwi,
  after_event_trigger: Vwi,
  booking_rejected_trigger: Bwi,
  booking_requested_trigger: Uwi,
  booking_payment_initiated_trigger: Gwi,
  booking_paid_trigger: Wwi,
  booking_no_show_updated_trigger: Hwi,
  how_long_after: Ywi,
  how_long_after_hosts_no_show: Kwi,
  how_long_after_guests_no_show: Zwi,
  how_long_after_user_no_show_minutes: Xwi,
  no_available_slots: Jwi,
  time_available: Qwi,
  cant_find_the_right_conferencing_app_visit_our_app_store: eki,
  install_new_calendar_app: tki,
  make_phone_number_required: nki,
  new_event_type_availability: oki,
  error_editing_availability: rki,
  dont_have_permission: iki,
  saml_configuration_placeholder: aki,
  saml_email_required: ski,
  saml_sp_title: cki,
  saml_sp_description: lki,
  saml_sp_acs_url: uki,
  saml_sp_entity_id: dki,
  saml_sp_acs_url_copied: _ki,
  saml_sp_entity_id_copied: pki,
  add_calendar: mki,
  limit_future_bookings: fki,
  limit_future_bookings_description: gki,
  no_event_types: hki,
  no_event_types_description: vki,
  billing_frequency: bki,
  monthly: yki,
  yearly: $ki,
  checkout: wki,
  your_team_disbanded_successfully: kki,
  your_org_disbanded_successfully: Ski,
  error_creating_team: Eki,
  you: xki,
  or_continue_with: Cki,
  resend_email: Tki,
  member_already_invited: Aki,
  already_in_use_error: Iki,
  enter_email_or_username: Oki,
  enter_email: Nki,
  enter_emails: zki,
  too_many_invites: Rki,
  team_name_taken: Pki,
  must_enter_team_name: Dki,
  team_url_required: Lki,
  url_taken: Mki,
  problem_registering_domain: Fki,
  team_publish: qki,
  number_text_notifications: jki,
  number_sms_notifications: Vki,
  attendee_email_variable: Bki,
  attendee_email_info: Uki,
  booking_uid: Gki,
  kbar_search_placeholder: Wki,
  invalid_credential: Hki,
  invalid_credential_action: Yki,
  reschedule_reason: Kki,
  choose_common_schedule_team_event: Zki,
  choose_common_schedule_team_event_description: Xki,
  reason: Jki,
  sender_id: Qki,
  sender_id_error_message: e0i,
  test_routing_form: t0i,
  test_preview: n0i,
  route_to: o0i,
  test_preview_description: r0i,
  test_routing: i0i,
  payment_app_disabled: a0i,
  edit_event_type: s0i,
  only_admin_can_see_members_of_org: c0i,
  only_admin_can_manage_sso_org: l0i,
  only_admin_can_manage_directory_sync: u0i,
  only_admin_can_manage_oauth_clients: d0i,
  collective_scheduling: _0i,
  make_it_easy_to_book: p0i,
  find_the_best_person: m0i,
  fixed_round_robin: f0i,
  add_one_fixed_attendee: g0i,
  calcom_is_better_with_team: h0i,
  the_calcom_team: v0i,
  add_your_team_members: b0i,
  booking_limit_reached: y0i,
  duration_limit_reached: $0i,
  admin_has_disabled: w0i,
  disable_attendees_emails_description: k0i,
  disabled_app_affects_event_type: S0i,
  event_replaced_notice: E0i,
  email_subject_slug_replacement: x0i,
  email_body_slug_replacement_notice: C0i,
  email_body_slug_replacement_info: T0i,
  email_body_slug_replacement_suggestion: A0i,
  disable_payment_app: I0i,
  payment_disabled_still_able_to_book: O0i,
  app_disabled_with_event_type: N0i,
  app_disabled_video: z0i,
  app_disabled_subject: R0i,
  navigate_installed_apps: P0i,
  disabled_calendar: D0i,
  enable_apps: L0i,
  enable_apps_description: M0i,
  purchase_license: F0i,
  already_have_account: q0i,
  already_have_key: j0i,
  already_have_key_suggestion: V0i,
  create_license_key: B0i,
  app_is_enabled: U0i,
  app_is_disabled: G0i,
  keys_have_been_saved: W0i,
  disable_app: H0i,
  disable_app_description: Y0i,
  edit_keys: K0i,
  admin_apps_description: Z0i,
  admin_users_description: X0i,
  admin_users_add_description: J0i,
  admin_users_edit_description: Q0i,
  admin_orgs_edit_description: e1i,
  admin_oAuth_description: t1i,
  admin_lockedSMS_description: n1i,
  no_available_apps: o1i,
  no_available_apps_description: r1i,
  no_apps: i1i,
  no_apps_configured: a1i,
  enable_in_settings: s1i,
  please_contact_admin: c1i,
  apps_settings: l1i,
  fill_this_field: u1i,
  options: d1i,
  enter_option: _1i,
  add_an_option: p1i,
  location_already_exists: m1i,
  radio: f1i,
  google_meet_warning: g1i,
  individual: h1i,
  all_bookings_filter_label: v1i,
  all_users_filter_label: b1i,
  all_event_types_filter_label: y1i,
  your_bookings_filter_label: $1i,
  meeting_url_variable: w1i,
  meeting_url_info: k1i,
  date_overrides: S1i,
  date_overrides_delete_on_date: E1i,
  date_overrides_subtitle: x1i,
  date_overrides_info: C1i,
  date_overrides_dialog_which_hours: T1i,
  date_overrides_dialog_which_hours_unavailable: A1i,
  date_overrides_dialog_title: I1i,
  date_overrides_unavailable: O1i,
  date_overrides_mark_all_day_unavailable_one: N1i,
  date_overrides_mark_all_day_unavailable_other: z1i,
  date_overrides_update_btn: R1i,
  date_successfully_added: P1i,
  date_overrides_save_btn: D1i,
  event_type_duplicate_copy_text: L1i,
  set_as_default: M1i,
  hide_eventtype_details: F1i,
  show_navigation: q1i,
  hide_navigation: j1i,
  verification_code_sent: V1i,
  verified_successfully: B1i,
  wrong_code: U1i,
  not_verified: G1i,
  no_availability_in_month: W1i,
  no_availability_rolling: H1i,
  no_availability_range: Y1i,
  view_previous_month: K1i,
  view_next_month: Z1i,
  send_code: X1i,
  number_verified: J1i,
  create_your_first_team_webhook_description: Q1i,
  create_webhook_team_event_type: eSi,
  disable_success_page: tSi,
  invalid_admin_password: nSi,
  change_password_admin: oSi,
  username_already_taken: rSi,
  assignment: iSi,
  fixed_hosts: aSi,
  add_fixed_hosts: sSi,
  round_robin_hosts: cSi,
  minimum_round_robin_hosts_count: lSi,
  hosts: uSi,
  upgrade_to_enable_feature: dSi,
  orgs_upgrade_to_enable_feature: _Si,
  new_attendee: pSi,
  awaiting_approval: mSi,
  requires_google_calendar: fSi,
  event_type_requires_google_calendar: gSi,
  connected_google_calendar: hSi,
  using_meet_requires_calendar: vSi,
  continue_to_install_google_calendar: bSi,
  install_google_meet: ySi,
  install_google_calendar: $Si,
  sender_name: wSi,
  already_invited: kSi,
  no_recordings_found: SSi,
  new_workflow_subtitle: ESi,
  reporting: xSi,
  reporting_feature: CSi,
  teams_plan_required: TSi,
  routing_forms_are_a_great_way: ASi,
  choose_a_license: ISi,
  choose_license_description: OSi,
  license: NSi,
  agplv3_license: zSi,
  no_need_to_keep_your_code_open_source: RSi,
  repackage_rebrand_resell: PSi,
  a_vast_suite_of_enterprise_features: DSi,
  free_license_fee: LSi,
  forever_open_and_free: MSi,
  required_to_keep_your_code_open_source: FSi,
  cannot_repackage_and_resell: qSi,
  no_enterprise_features: jSi,
  step_enterprise_license: VSi,
  step_enterprise_license_description: BSi,
  setup: USi,
  setup_description: GSi,
  configure: WSi,
  sso_configuration: HSi,
  sso_configuration_description: YSi,
  sso_configuration_description_orgs: KSi,
  sso_oidc_heading: ZSi,
  sso_oidc_description: XSi,
  sso_oidc_configuration_title: JSi,
  sso_oidc_configuration_description: QSi,
  sso_oidc_callback_copied: eEi,
  sso_saml_heading: tEi,
  sso_saml_description: nEi,
  sso_saml_configuration_title: oEi,
  sso_saml_configuration_description: rEi,
  sso_saml_acsurl_copied: iEi,
  sso_saml_entityid_copied: aEi,
  sso_connection_created_successfully: sEi,
  sso_connection_deleted_successfully: cEi,
  delete_sso_configuration: lEi,
  delete_sso_configuration_confirmation: uEi,
  delete_sso_configuration_confirmation_description: dEi,
  organizer_timezone: _Ei,
  email_user_cta: pEi,
  accept_invite: mEi,
  join_now: fEi,
  successfully_joined: gEi,
  email_no_user_invite_heading_subteam: hEi,
  email_no_user_invite_heading_org: vEi,
  email_no_user_invite_subheading: bEi,
  email_user_invite_subheading_subteam: yEi,
  email_user_invite_subheading_org: $Ei,
  email_no_user_invite_steps_intro: wEi,
  email_no_user_step_one: kEi,
  email_no_user_step_two: SEi,
  email_no_user_step_three: EEi,
  email_no_user_step_four: xEi,
  email_no_user_signoff: CEi,
  impersonation_user_tip: TEi,
  available_variables: AEi,
  scheduler: IEi,
  no_workflows: OEi,
  change_filter: NEi,
  change_filter_common: zEi,
  no_results_for_filter: REi,
  recommended_next_steps: PEi,
  create_a_managed_event: DEi,
  meetings_are_better_with_the_right: LEi,
  create_a_one_one_template: MEi,
  collective_or_roundrobin: FEi,
  book_your_team_members: qEi,
  event_no_longer_attending_subject: jEi,
  no_longer_attending: VEi,
  attendee_no_longer_attending_subject: BEi,
  attendee_no_longer_attending: UEi,
  attendee_no_longer_attending_subtitle: GEi,
  create_event_on: WEi,
  create_routing_form_on: HEi,
  default_app_link_title: YEi,
  default_app_link_description: KEi,
  organizer_default_conferencing_app: ZEi,
  organizer_default_conferencing_app_not_found: XEi,
  under_maintenance: JEi,
  under_maintenance_description: QEi,
  event_type_seats: exi,
  booking_questions_title: txi,
  booking_questions_description: nxi,
  add_a_booking_question: oxi,
  identifier: rxi,
  duplicate_email: ixi,
  enter_redirect_url_on_exit_description: axi,
  booking_with_payment_cancelled: sxi,
  booking_with_payment_cancelled_already_paid: cxi,
  booking_with_payment_cancelled_refunded: lxi,
  booking_with_payment_cancelled_no_refund: uxi,
  booking_with_payment_cancelled_refund_window_expired: dxi,
  booking_confirmation_failed: _xi,
  not_enough_seats: pxi,
  form_builder_field_already_exists: mxi,
  guests_field_must_be_multiemail: fxi,
  show_on_booking_page: gxi,
  visit_cancelled_booking: hxi,
  get_started_zapier_templates: vxi,
  standard_templates: bxi,
  cal_ai_templates: yxi,
  team_is_unpublished: $xi,
  org_is_unpublished_description: wxi,
  team_is_unpublished_description: kxi,
  team_member: Sxi,
  a_routing_form: Exi,
  form_description_placeholder: xxi,
  keep_me_connected_with_form: Cxi,
  fields_in_form_duplicated: Txi,
  form_deleted: Axi,
  delete_form: Ixi,
  delete_form_action: Oxi,
  delete_form_confirmation: Nxi,
  delete_form_confirmation_2: zxi,
  typeform_redirect_url_copied: Rxi,
  modifications_in_fields_warning: Pxi,
  connected_forms: Dxi,
  form_modifications_warning: Lxi,
  responses_collection_waiting_description: Mxi,
  this_is_what_your_users_would_see: Fxi,
  identifies_name_field: qxi,
  add_1_option_per_line: jxi,
  select_a_router: Vxi,
  add_a_new_route: Bxi,
  make_informed_decisions: Uxi,
  make_informed_decisions_description: Gxi,
  view_bookings_across: Wxi,
  view_bookings_across_description: Hxi,
  identify_booking_trends: Yxi,
  identify_booking_trends_description: Kxi,
  spot_popular_event_types: Zxi,
  spot_popular_event_types_description: Xxi,
  no_responses_yet: Jxi,
  no_routes_defined: Qxi,
  this_will_be_the_placeholder: eCi,
  error_booking_event: tCi,
  timeslot_missing_title: nCi,
  timeslot_missing_description: oCi,
  timeslot_missing_cta: rCi,
  switch_monthly: iCi,
  switch_weekly: aCi,
  switch_multiday: sCi,
  switch_columnview: cCi,
  num_locations: lCi,
  select_on_next_step: uCi,
  this_meeting_has_not_started_yet: dCi,
  this_app_requires_connected_account: _Ci,
  connect_app: pCi,
  app_is_connected: mCi,
  requires_app: fCi,
  verification_code: gCi,
  can_you_try_again: hCi,
  verify: vCi,
  timezone_info: bCi,
  timezone_variable: yCi,
  event_end_time_variable: $Ci,
  event_end_time_info: wCi,
  cancel_url_variable: kCi,
  cancel_url_info: SCi,
  cancel_reason_variable: ECi,
  cancel_reason_info: xCi,
  reschedule_url_variable: CCi,
  reschedule_url_info: TCi,
  reschedule_reason_variable: ACi,
  reschedule_reason_info: ICi,
  invalid_event_name_variables: OCi,
  select_all: NCi,
  default_conferencing_bulk_title: zCi,
  members_default_schedule: RCi,
  set_by_admin: PCi,
  members_default_location: DCi,
  members_default_schedule_description: LCi,
  requires_at_least_one_schedule: MCi,
  default_conferencing_bulk_description: FCi,
  default_schedules_bulk_description: qCi,
  locked_for_members: jCi,
  unlocked_for_members: VCi,
  apps_locked_for_members_description: BCi,
  apps_unlocked_for_members_description: UCi,
  apps_locked_by_team_admins_description: GCi,
  apps_unlocked_by_team_admins_description: WCi,
  workflows_locked_for_members_description: HCi,
  workflows_unlocked_for_members_description: YCi,
  workflows_locked_by_team_admins_description: KCi,
  workflows_unlocked_by_team_admins_description: ZCi,
  webhooks_locked_for_members_description: XCi,
  webhooks_unlocked_for_members_description: JCi,
  webhooks_locked_by_team_admins_description: QCi,
  webhooks_unlocked_by_team_admins_description: eTi,
  locked_by_team_admin: tTi,
  app_not_connected: nTi,
  connect_now: oTi,
  managed_event_dialog_confirm_button_one: rTi,
  managed_event_dialog_confirm_button_other: iTi,
  managed_event_dialog_title_one: aTi,
  managed_event_dialog_title_other: sTi,
  managed_event_dialog_information_one: cTi,
  managed_event_dialog_information_other: lTi,
  managed_event_dialog_clarification: uTi,
  review_event_type: dTi,
  looking_for_more_analytics: _Ti,
  looking_for_more_insights: pTi,
  filters: mTi,
  filter: fTi,
  add_a_member: gTi,
  add_filter: hTi,
  add_rule: vTi,
  add_rule_group: bTi,
  remove_filters: yTi,
  email_verified: $Ti,
  select_user: wTi,
  select_event_type: kTi,
  select_date_range: STi,
  popular_events: ETi,
  no_event_types_found: xTi,
  average_event_duration: CTi,
  bookings_by_hour: TTi,
  most_booked_members: ATi,
  least_booked_members: ITi,
  most_bookings_scheduled: OTi,
  least_bookings_scheduled: NTi,
  most_bookings_completed: zTi,
  least_bookings_completed: RTi,
  events_created: PTi,
  events_completed: DTi,
  events_cancelled: LTi,
  events_rescheduled: MTi,
  events: FTi,
  performance: qTi,
  from_last_period: jTi,
  from_to_date_period: VTi,
  redirect_url_warning: BTi,
  event_trends: UTi,
  clear_filters: GTi,
  clear: WTi,
  hold: HTi,
  on_booking_option: YTi,
  hold_option: KTi,
  card_held: ZTi,
  charge_card: XTi,
  card_charged: JTi,
  no_show_fee_amount: QTi,
  no_show_fee: eAi,
  submit_card: tAi,
  submit_payment_information: nAi,
  meeting_awaiting_payment_method: oAi,
  no_show_fee_charged_email_subject: rAi,
  no_show_fee_charged_text_body: iAi,
  no_show_fee_charged_subtitle: aAi,
  error_charging_card: sAi,
  collect_no_show_fee: cAi,
  no_show_fee_charged: lAi,
  your_card_was_declined: uAi,
  your_card_does_not_support_this_type_of_purchase: dAi,
  amount_must_convert_to_at_least: _Ai,
  could_not_charge_card: pAi,
  insights: mAi,
  routing_forms: fAi,
  insights_no_data_found_for_filter: gAi,
  acknowledge_booking_no_show_fee: hAi,
  days: vAi,
  card_details: bAi,
  something_went_wrong_on_our_end: yAi,
  please_provide_following_text_to_suppport: $Ai,
  seats_and_no_show_fee_error: wAi,
  complete_your_booking: kAi,
  complete_your_booking_subject: SAi,
  confirm_your_details: EAi,
  copy_invite_link: xAi,
  edit_invite_link: CAi,
  invite_link_copied: TAi,
  invite_link_deleted: AAi,
  api_key_deleted: IAi,
  delete_api_key_warning: OAi,
  invite_link_updated: NAi,
  link_expires_after: zAi,
  one_day: RAi,
  seven_days: PAi,
  thirty_days: DAi,
  three_months: LAi,
  one_year: MAi,
  team_invite_received: FAi,
  currency_string: qAi,
  charge_card_dialog_body: jAi,
  charge_attendee: VAi,
  payment_app_commission: BAi,
  email_invite_team: UAi,
  email_invite_team_bulk: GAi,
  error_collecting_card: WAi,
  image_size_limit_exceed: HAi,
  unauthorized_workflow_error_message: YAi,
  inline_embed: KAi,
  load_inline_content: ZAi,
  floating_pop_up_button: XAi,
  floating_button_trigger_modal: JAi,
  pop_up_element_click: QAi,
  open_dialog_with_element_click: e2i,
  use_my_own_form: t2i,
  use_our_headless_routing_api: n2i,
  need_help_embedding: o2i,
  book_my_cal: r2i,
  first_name: i2i,
  last_name: a2i,
  first_last_name: s2i,
  invite_as: c2i,
  form_updated_successfully: l2i,
  disable_attendees_confirmation_emails: u2i,
  disable_attendees_confirmation_emails_description: d2i,
  disable_host_confirmation_emails: _2i,
  disable_host_confirmation_emails_description: p2i,
  add_an_override: m2i,
  import_from_google_workspace: f2i,
  connect_google_workspace: g2i,
  google_workspace_admin_tooltip: h2i,
  first_event_type_webhook_description: v2i,
  create_instant_meeting_webhook_description: b2i,
  install_app_on: y2i,
  create_for: $2i,
  currency: w2i,
  organization_banner_description: k2i,
  organization_banner_title: S2i,
  set_up_your_organization: E2i,
  set_up_your_platform_organization: x2i,
  organizations_description: C2i,
  plans: T2i,
  platform: A2i,
  platform_description: I2i,
  platform_organization_description: O2i,
  must_enter_organization_name: N2i,
  must_enter_organization_admin_email: z2i,
  admin_email: R2i,
  platform_admin_email: P2i,
  admin_username: D2i,
  organization_name: L2i,
  platform_name: M2i,
  organization_url: F2i,
  organization_verify_header: q2i,
  organization_verify_email_body: j2i,
  additional_url_parameters: V2i,
  about_your_organization: B2i,
  about_your_organization_description: U2i,
  create_your_teams: G2i,
  create_your_teams_description: W2i,
  invite_organization_admins: H2i,
  invite_organization_admins_description: Y2i,
  set_a_password: K2i,
  set_a_password_description: Z2i,
  organization_logo: X2i,
  organization_about_description: J2i,
  ill_do_this_later: Q2i,
  verify_your_email: eIi,
  enter_digit_code: tIi,
  verify_email_organization: nIi,
  code_provided_invalid: oIi,
  email_already_used: rIi,
  organization_admin_invited_heading: iIi,
  organization_admin_invited_body: aIi,
  duplicated_slugs_warning: sIi,
  team_names_empty: cIi,
  team_names_repeated: lIi,
  user_belongs_organization: uIi,
  org_no_teams_yet: dIi,
  org_no_teams_yet_description: _Ii,
  set_up: pIi,
  my_profile: mIi,
  my_settings: fIi,
  crm: gIi,
  messaging: hIi,
  sender_id_info: vIi,
  org_admins_can_create_new_teams: bIi,
  google_new_spam_policy: yIi,
  resolve: $Ii,
  no_organization_slug: wIi,
  copy_link_org: kIi,
  "404_the_org": "L'organizzazione",
  "404_the_team": "Il team",
  "404_claim_entity_org": "Richiedi il sottodominio per la tua organizzazione",
  "404_claim_entity_team": "Richiedi l'accesso a questo team per iniziare a gestire le pianificazioni collettivamente",
  insights_team_filter: SIi,
  insights_user_filter: EIi,
  insights_subtitle: xIi,
  call_history: CIi,
  call_history_subtitle: TIi,
  location_options: AIi,
  channel_type: IIi,
  end_reason: OIi,
  session_status: NIi,
  user_sentiment: zIi,
  time_header: RIi,
  from_header: PIi,
  custom_plan: DIi,
  email_embed: LIi,
  add_times_to_your_email: MIi,
  select_time: FIi,
  select_date: qIi,
  only_show_if_parameter_set: jIi,
  add_parameter: VIi,
  connecting_you_to_someone: BIi,
  please_do_not_close_this_tab: UIi,
  see_all_available_times: GIi,
  org_team_names_example_1: WIi,
  org_team_names_example_2: HIi,
  org_team_names_example_3: YIi,
  org_team_names_example_4: KIi,
  org_team_names_example_5: ZIi,
  org_max_team_warnings: XIi,
  what_is_this_meeting_about: JIi,
  add_to_team: QIi,
  remove_users_from_org: eOi,
  delegation_credential: tOi,
  delegation_credential_description: nOi,
  add_client_id_in_google_workspace_with_below_scope: oOi,
  delegation_credential_enabled: rOi,
  add_delegation_credential: iOi,
  edit_delegation_credential: aOi,
  domain: sOi,
  no_workspace_platforms: cOi,
  workspace_platform: lOi,
  workspace_platforms: uOi,
  workspace_platforms_description: dOi,
  edit_workspace_platform: _Oi,
  edit_service_account: pOi,
  add_workspace_platform: mOi,
  slug: fOi,
  service_account_key: gOi,
  edit_service_account_key: hOi,
  delegation_credential_restricts_adding_more_than_one_installation: vOi,
  app_successfully_installed_and_is_using_delegated_credentials: bOi,
  remove_users_from_org_confirm: yOi,
  remove_users_from_team: $Oi,
  remove_users_from_team_confirm: wOi,
  user_has_no_schedules: kOi,
  user_isnt_in_any_teams: SOi,
  user_has_no_app_installed: EOi,
  requires_booker_email_verification: xOi,
  description_requires_booker_email_verification: COi,
  requires_confirmation_mandatory: TOi,
  organizations: AOi,
  upload_cal_video_logo: IOi,
  update_cal_video_logo: OOi,
  upload_banner: NOi,
  cal_video_logo_upload_instruction: zOi,
  org_admin_other_teams: ROi,
  org_admin_other_teams_description: POi,
  not_part_of_org: DOi,
  no_other_teams_found: LOi,
  no_other_teams_found_description: MOi,
  attendee_first_name_variable: FOi,
  attendee_last_name_variable: qOi,
  attendee_first_name_info: jOi,
  attendee_last_name_info: VOi,
  your_monthly_digest: BOi,
  member_name: UOi,
  most_popular_events: GOi,
  summary_of_events_for_your_team_for_the_last_30_days: WOi,
  me: HOi,
  meeting_unavailable: YOi,
  monthly_digest_email: KOi,
  monthly_digest_email_for_teams: ZOi,
  verify_team_tooltip: XOi,
  member_removed: JOi,
  my_availability: QOi,
  team_availability: eNi,
  instant_meeting_availability: tNi,
  backup_code: nNi,
  backup_codes: oNi,
  backup_code_instructions: rNi,
  backup_codes_copied: iNi,
  incorrect_backup_code: aNi,
  lost_access: sNi,
  missing_backup_codes: cNi,
  admin_org_notification_email_subject: lNi,
  hi_admin: uNi,
  admin_org_notification_email_title: dNi,
  admin_org_notification_email_body_part1: _Ni,
  admin_org_notification_email_body_part2: pNi,
  admin_org_notification_email_body_part3: mNi,
  admin_org_notification_email_cta: fNi,
  org_has_been_processed: gNi,
  org_error_processing: hNi,
  orgs_page_description: vNi,
  unverified: bNi,
  verified: yNi,
  dns_missing: $Ni,
  dns_configured: wNi,
  mark_dns_configured: kNi,
  value: SNi,
  your_organization_updated_sucessfully: ENi,
  team_no_event_types: xNi,
  seat_options_doesnt_multiple_durations: CNi,
  include_calendar_event: TNi,
  oAuth: ANi,
  oAuth_client_creation_form: INi,
  oAuth_client_creation_form_description: ONi,
  oAuth_client_updation_form: NNi,
  oAuth_client_updation_form_description: zNi,
  recently_added: RNi,
  connect_all_calendars: PNi,
  connect_all_calendars_description: DNi,
  workflow_automation_description: LNi,
  scheduling_for_your_team: MNi,
  scheduling_for_your_team_description: FNi,
  no_members_found: qNi,
  directory_sync: jNi,
  directory_name: VNi,
  directory_provider: BNi,
  directory_scim_url: UNi,
  directory_scim_token: GNi,
  directory_scim_url_copied: WNi,
  directory_scim_token_copied: HNi,
  directory_sync_info_description: YNi,
  directory_sync_configure: KNi,
  directory_sync_configure_description: ZNi,
  directory_sync_title: XNi,
  directory_sync_created: JNi,
  directory_sync_description: QNi,
  directory_sync_deleted: ezi,
  directory_sync_delete_connection: tzi,
  directory_sync_delete_title: nzi,
  directory_sync_delete_description: ozi,
  directory_sync_delete_confirmation: rzi,
  event_setup_length_error: izi,
  availability_schedules: azi,
  unauthorized: szi,
  access_cal_account: czi,
  select_account_team: lzi,
  allow_client_to: uzi,
  associate_with_cal_account: dzi,
  see_personal_info: _zi,
  see_primary_email_address: pzi,
  connect_installed_apps: mzi,
  access_event_type: fzi,
  access_availability: gzi,
  access_bookings: hzi,
  allow_client_to_do: vzi,
  oauth_access_information: bzi,
  allow: yzi,
  view_only_edit_availability_not_onboarded: $zi,
  view_only_edit_availability: wzi,
  you_can_override_calendar_in_advanced_tab: kzi,
  edit_users_availability: Szi,
  resend_invitation: Ezi,
  invitation_resent: xzi,
  saml_sso: Czi,
  add_client: Tzi,
  copy_client_secret_info: Azi,
  add_new_client: Izi,
  add_new_user: Ozi,
  this_app_is_not_setup_already: Nzi,
  as_csv: zzi,
  overlay_my_calendar: Rzi,
  overlay_my_calendar_toc: Pzi,
  view_overlay_calendar_events: Dzi,
  join_event_location: Lzi,
  troubleshooting: Mzi,
  calendars_were_checking_for_conflicts: Fzi,
  availabilty_schedules: qzi,
  manage_calendars: jzi,
  manage_availability_schedules: Vzi,
  locked: Bzi,
  unlocked: Uzi,
  lock_timezone_toggle_on_booking_page: Gzi,
  description_lock_timezone_toggle_on_booking_page: Wzi,
  event_setup_multiple_payment_apps_error: Hzi,
  number_in_international_format: Yzi,
  install_calendar: Kzi,
  branded_subdomain: Zzi,
  branded_subdomain_description: Xzi,
  org_insights: Jzi,
  org_insights_description: Qzi,
  extensive_whitelabeling: eRi,
  extensive_whitelabeling_description: tRi,
  unlimited_teams: nRi,
  verify_email: oRi,
  proceed_with_cancellation_description: rRi,
  proceed_with_cancellation_error: iRi,
  unlimited_teams_description: aRi,
  unified_billing: sRi,
  advanced_managed_events: cRi,
  advanced_managed_events_description: lRi,
  enterprise: uRi,
  enterprise_description: dRi,
  create_your_org: _Ri,
  create_org: pRi,
  create_your_org_description: mRi,
  create_your_enterprise_description: fRi,
  other_payment_app_enabled: gRi,
  admin_delete_organization_description_1: hRi,
  admin_delete_organization_description_2: vRi,
  admin_delete_organization_description_3: bRi,
  admin_delete_organization_description_4: yRi,
  admin_delete_organization_title: $Ri,
  published: wRi,
  unpublished: kRi,
  publish: SRi,
  troubleshooter_tooltip: ERi,
  need_help: xRi,
  troubleshooter: CRi,
  number_to_call: TRi,
  guest_name: ARi,
  guest_email: IRi,
  guest_company: ORi,
  please_install_a_calendar: NRi,
  instant_tab_title: zRi,
  instant_event_tab_description: RRi,
  uprade_to_create_instant_bookings: PRi,
  dont_want_to_wait: DRi,
  meeting_started: LRi,
  pay_and_book: MRi,
  cal_ai_event_tab_description: FRi,
  booking_not_found_error: qRi,
  booking_seats_full_error: jRi,
  missing_payment_credential_error: VRi,
  missing_payment_app_id_error: BRi,
  not_enough_available_seats_error: URi,
  user_redirect_title: GRi,
  user_redirect_description: WRi,
  out_of_office: HRi,
  out_of_office_description: YRi,
  send_request: KRi,
  start_date_and_end_date_required: ZRi,
  start_date_must_be_before_end_date: XRi,
  start_date_must_be_in_the_future: JRi,
  user_not_found: QRi,
  cannot_redirect_to_self: ePi,
  out_of_office_entry_already_exists: tPi,
  out_of_office_id_required: nPi,
  booking_redirect_infinite_not_allowed: oPi,
  success_entry_created: rPi,
  booking_redirect_email_subject: iPi,
  booking_redirect_email_title: aPi,
  booking_redirect_email_description: sPi,
  booking_redirect_updated_email_subject: cPi,
  booking_redirect_updated_email_title: lPi,
  booking_redirect_updated_email_description: uPi,
  booking_redirect_cancelled_email_subject: dPi,
  booking_redirect_cancelled_email_title: _Pi,
  booking_redirect_cancelled_email_description: pPi,
  success_accept_booking_redirect: mPi,
  success_reject_booking_redirect: fPi,
  copy_link_booking_redirect_request: gPi,
  booking_redirect_request_title: hPi,
  select_team_member: vPi,
  going_away_title: bPi,
  redirect_team_enabled: yPi,
  redirect_team_disabled: $Pi,
  out_of_office_unavailable_list: wPi,
  success_deleted_entry_out_of_office: kPi,
  success_edited_entry_out_of_office: SPi,
  temporarily_out_of_office: EPi,
  add_a_redirect: xPi,
  create_entry: CPi,
  time_range: TPi,
  automatically_add_all_team_members: APi,
  redirect_to: IPi,
  having_trouble_finding_time: OPi,
  show_more: NPi,
  forward_params_redirect: zPi,
  assignment_description: RPi,
  lowest: PPi,
  low: DPi,
  medium: LPi,
  high: MPi,
  Highest: FPi,
  send_booker_to: qPi,
  set_priority: jPi,
  set_weight: VPi,
  enable_weights: BPi,
  priority_for_user: UPi,
  weights_description: GPi,
  weight_for_user: WPi,
  change_priority: HPi,
  field_identifiers_as_variables: YPi,
  field_identifiers_as_variables_with_example: KPi,
  account_already_linked: ZPi,
  send_email: XPi,
  cal_ai_phone_call_action: JPi,
  call_to_confirm_booking: QPi,
  cal_ai_phone_call_action_description: eDi,
  cal_ai_agent_configuration: tDi,
  choose_at_least_one_event_type_test_call: nDi,
  mark_as_no_show: oDi,
  unmark_as_no_show: rDi,
  account_unlinked_success: iDi,
  account_unlinked_error: aDi,
  travel_schedule: sDi,
  travel_schedule_description: cDi,
  schedule_timezone_change: lDi,
  date: uDi,
  enter_the_general_prompt_for_the_agent: dDi,
  overlaps_with_existing_schedule: _Di,
  "org_admin_no_slots|heading": "Nessuna disponibilità trovata per {{name}}",
  "org_admin_no_slots|content": "Salve Amministratori dell'Organizzazione,<br /><br />Vi informiamo che: è stato portato alla nostra attenzione che {{username}} non ha avuto disponibilità quando un utente ha visitato {{username}}/{{slug}}<br /><br />Ci sono alcuni motivi per cui questo potrebbe accadere<br />L'utente non ha calendari collegati<br />I suoi orari associati a questo evento non sono abilitati<br /> <br />Consigliamo di controllare la sua disponibilità per risolvere questo problema.",
  "org_admin_no_slots|cta": "Apri disponibilità utenti",
  organization_no_slots_notification_switch_title: pDi,
  organization_no_slots_notification_switch_description: mDi,
  organization_disable_phone_only_sms_notifications_switch_title: fDi,
  organization_disable_phone_only_sms_notifications_switch_description: gDi,
  "email_team_invite|subject|added_to_org": "{{user}} ti ha inserito nell'organizzazione {{team}} su {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} ti ha invitato nell'organizzazione {{team}} su {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} ti ha inserito nel team {{team}} dell'organizzazione {{parentTeamName}} su {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} ti ha invitato a unirti alla squadra {{team}} su {{appName}}",
  "email_team_invite|heading|added_to_org": "Sei stato aggiunto a un'organizzazione {{appName}}",
  "email_team_invite|heading|invited_to_org": "Sei stato invitato a un'organizzazione {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Sei stato aggiunto a un team dell'organizzazione {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Sei stato invitato a un team dell'organizzazione {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Sei stato invitato a unirti a un team {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} ti ha inserito nell'organizzazione <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} ti ha invitato nell'organizzazione {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} ti ha invitato a unirti al team {{team}} dell'organizzazione {{parentTeamName}} su {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} ti ha inserito nel team <strong>{{teamName}}</strong> della sua organizzazione {{parentTeamName}}. {{appName}} è lo strumento di programmazione degli eventi che consente a te e al tuo team di programmare riunioni senza infiniti scambi di email.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} ti ha invitato nel team <strong>{{teamName}}</strong> della sua organizzazione {{parentTeamName}}. {{appName}} è lo strumento di programmazione degli eventi che consente a te e al tuo team di programmare riunioni senza infiniti scambi di email.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} ti ha invitato a unirti al suo team `{{teamName}}` su {{appName}}. {{appName}} è uno strumento di pianificazione di eventi che permette a te e al tuo team di pianificare le riunioni senza scambiare decine di e-mail.",
  "email|existing_user_added_link_will_change": "Accettando l'invito, il tuo link cambierà nel dominio della tua organizzazione, ma non preoccuparti, tutti i link precedenti continueranno a funzionare e reindirizzeranno correttamente.<br /><br />Nota: tutti i tuoi tipi di eventi personali saranno trasferiti nell'organizzazione <strong>{{teamName}}</strong>, che potrebbe includere anche potenziali link personali. <br /><br />Per gli eventi personali consigliamo di creare un nuovo account con un indirizzo email personale.",
  "email|existing_user_added_link_changed": "Il tuo link è stato modificato da {{a0}} a {{a1}} ma non preoccuparti, tutti i link precedenti funzionano ancora e reindirizzano correttamente. <br /><br />Nota: tutti i tuoi tipi di eventi personali sono stati trasferiti nell'organizzazione <strong>{{teamName}}</strong>, che potrebbe includere anche potenziali link personali.<br /><br />Accedi e assicurati di non avere eventi privati sul tuo nuovo account organizzativo.<br /><br />Per gli eventi personali consigliamo di creare un nuovo account con un indirizzo email personale.<br /><br />Goditi il tuo nuovo link pulito: {{a2}}",
  "email_organization_created|subject": "La tua organizzazione è stata creata",
  your_current_plan: hDi,
  organization_price_per_user_month: vDi,
  privacy_organization_description: bDi,
  privacy: yDi,
  team_will_be_under_org: $Di,
  add_group_name: wDi,
  group_name: kDi,
  routers: SDi,
  primary: EDi,
  make_primary: xDi,
  add_email: CDi,
  add_emails: TDi,
  add_email_description: ADi,
  confirm_email: IDi,
  confirming_your_booking_sms: ODi,
  scheduler_first_name: NDi,
  scheduler_last_name: zDi,
  scheduler_name: RDi,
  organizer_first_name: PDi,
  confirm_email_description: DDi,
  send_event_details_to: LDi,
  schedule_tz_without_end_date: MDi,
  select_members: FDi,
  lock_event_types_modal_header: qDi,
  org_delete_event_types_org_admin: jDi,
  org_hide_event_types_org_admin: VDi,
  hide_org_eventtypes: BDi,
  delete_org_eventtypes: UDi,
  lock_org_users_eventtypes: GDi,
  lock_org_users_eventtypes_description: WDi,
  add_to_event_type: HDi,
  create_account_password: YDi,
  create_account_with_saml: KDi,
  error_creating_account_password: ZDi,
  cannot_create_account_password_cal_provider: XDi,
  cannot_create_account_password_already_existing: JDi,
  create_account_password_hint: QDi,
  disconnect_account: e3i,
  disconnect_account_hint: t3i,
  cookie_consent_checkbox: n3i,
  make_a_call: o3i,
  skip_rr_assignment_label: r3i,
  skip_rr_description: i3i,
  select_account_header: a3i,
  select_account_description: s3i,
  select_event_types_header: c3i,
  select_event_types_description: l3i,
  configure_app_header: u3i,
  configure_app_description: d3i,
  already_installed: _3i,
  ooo_reasons_unspecified: p3i,
  ooo_reasons_vacation: m3i,
  ooo_reasons_travel: f3i,
  ooo_reasons_sick_leave: g3i,
  ooo_reasons_public_holiday: h3i,
  ooo_forwarding_to: v3i,
  ooo_not_forwarding: b3i,
  ooo_empty_title: y3i,
  ooo_empty_description: $3i,
  ooo_user_is_ooo: w3i,
  ooo_slots_returning: k3i,
  ooo_slots_book_with: S3i,
  ooo_select_reason: E3i,
  create_an_out_of_office: x3i,
  edit_an_out_of_office: C3i,
  submit_feedback: T3i,
  host_no_show: A3i,
  no_show_description: I3i,
  how_can_we_improve: O3i,
  most_liked: N3i,
  review: z3i,
  reviewed: R3i,
  unreviewed: P3i,
  rating_url_variable: D3i,
  rating_url_info: L3i,
  no_show_url_variable: M3i,
  no_show_url_info: F3i,
  no_support_needed: q3i,
  hide_support: j3i,
  event_ratings: V3i,
  event_no_show: B3i,
  event_no_show_guest: U3i,
  recent_ratings: G3i,
  no_ratings: W3i,
  no_ratings_description: H3i,
  most_no_show_host: Y3i,
  highest_rated: K3i,
  lowest_rated: Z3i,
  highest_rated_members: X3i,
  lowest_rated_members: J3i,
  csat_score: Q3i,
  lockedSMS: eLi,
  leave_without_assigning_anyone: tLi,
  leave_without_adding_attendees: nLi,
  no_availability_shown_to_bookers: oLi,
  go_back_and_assign: rLi,
  leave_without_assigning: iLi,
  signing_up_terms: aLi,
  proceeding_agreement: sLi,
  terms: cLi,
  always_show_x_days: lLi,
  always_show_x_days_description: uLi,
  team_subscription_cancelled_successfully: dLi,
  team_subscription_cancellation_error: _Li,
  unable_to_subscribe_to_the_platform: pLi,
  updating_oauth_client_error: mLi,
  creating_oauth_client_error: fLi,
  event_type_color: gLi,
  event_type_color_description: hLi,
  mark_as_no_show_title: vLi,
  x_marked_as_no_show: bLi,
  x_unmarked_as_no_show: yLi,
  team_select_info: $Li,
  team_settings_description: wLi,
  no_show_updated: kLi,
  email_copied: SLi,
  phone_number_copied: ELi,
  USER_PENDING_MEMBER_OF_THE_ORG: xLi,
  USER_ALREADY_INVITED_OR_MEMBER: CLi,
  USER_MEMBER_OF_OTHER_ORGANIZATION: TLi,
  booking_reassigned: ALi,
  reassign: ILi,
  reassign_to_another_rr_host: OLi,
  assign_team_member: NLi,
  override_team_member_to_assign: zLi,
  no_available_hosts: RLi,
  reassign_round_robin_host: PLi,
  skip_writing_to_calendar: DLi,
  rescheduling_not_possible: LLi,
  event_expired: MLi,
  skip_contact_creation: FLi,
  skip_writing_to_calendar_note: qLi,
  attributes: jLi,
  new_attribute: VLi,
  add_attributes: BLi,
  add_attributes_description: ULi,
  new_option: GLi,
  update_profile: WLi,
  attribute: HLi,
  create_attribute_description: YLi,
  edit_attribute_description: KLi,
  attribute_updated_successfully: ZLi,
  attribute_deleted_successfully: XLi,
  attributes_edited_successfully: JLi,
  attribute_meta_description: QLi,
  attributes_edit_description: eMi,
  back_to_attributes: tMi,
  delete_attribute: nMi,
  delete_attribute_description: oMi,
  disable_all_emails_to_attendees: rMi,
  disable_all_emails_description: iMi,
  disable_all_emails_to_hosts: aMi,
  type_confirm_to_continue: sMi,
  disable_email: cMi,
  grant_admin_api: lMi,
  revoke_admin_api: uMi,
  add_calendar_label: dMi,
  apple_connect_atom_label: _Mi,
  apple_connect_atom_already_connected_label: pMi,
  apple_connect_atom_loading_label: mMi,
  google_connect_atom_label: fMi,
  google_connect_atom_already_connected_label: gMi,
  google_connect_atom_loading_label: hMi,
  outlook_connect_atom_label: vMi,
  outlook_connect_atom_already_connected_label: bMi,
  outlook_connect_atom_loading_label: yMi,
  stripe_connect_atom_label: $Mi,
  stripe_connect_atom_already_connected_label: wMi,
  stripe_connect_atom_loading_label: kMi,
  booking_question_response_variables: SMi,
  managed_by_teamAdmins: EMi,
  number_of_options: xMi,
  reschedule_with_same_round_robin_host_title: CMi,
  reschedule_with_same_round_robin_host_description: TMi,
  disable_input_if_prefilled: AMi,
  booking_limits: IMi,
  booking_limits_team_description: OMi,
  limit_team_booking_frequency_description: NMi,
  booking_limits_updated_successfully: zMi,
  you_are_unauthorized_to_make_this_change_to_the_booking: RMi,
  delegation_credential_disabled: PMi,
  matching_members: DMi,
  x_matching_members: LMi,
  matching_members_queue_using_attribute_weights: MMi,
  matching_members_queue_using_event_assignee_weights: FMi,
  no_matching_members: qMi,
  no_matching_members_will_fallback_to_all_assigned_members: jMi,
  hide_calendar_event_details: VMi,
  description_hide_calendar_event_details: BMi,
  last_number_of_days: UMi,
  month_to_date: GMi,
  year_to_date: WMi,
  custom_range: HMi,
  refund_policy: YMi,
  always: KMi,
  never: ZMi,
  payment_option: XMi,
  if_cancelled: JMi,
  before: QMi,
  show_all_columns: e4i,
  toggle_columns: t4i,
  no_columns_found: n4i,
  salesforce_create_record_as: o4i,
  salesforce_lead: r4i,
  salesforce_contact_under_account: i4i,
  salesforce_skip_entry_creation: a4i,
  salesforce_if_account_does_not_exist: s4i,
  salesforce_create_new_contact_under_account: c4i,
  salesforce_change_record_owner_on_booking: l4i,
  mass_assign_attributes: u4i,
  reroute_preview_custom_message: d4i,
  reroute_preview_external_redirect: _4i,
  reroute_preview_possible_host: p4i,
  current_routing_status: m4i,
  reroute_booking: f4i,
  reroute_booking_description: g4i,
  verify_new_route: h4i,
  reroute: v4i,
  new_routing_status: b4i,
  salesforce_book_directly_with_attendee_owner: y4i,
  salesforce_check_owner_of: $4i,
  account: w4i,
  choose_hosts_schedule: k4i,
  hosts_schedule_description: S4i,
  no_hosts_description: E4i,
  team_member_round_robin_reassign: x4i,
  team_member_round_robin_reassign_description: C4i,
  round_robin_reassign_description: T4i,
  invalid_round_robin_host: A4i,
  user_is_round_robin_fixed: I4i,
  reschedule_with_same_timeslot: O4i,
  reschedule_with_same_timeslot_of_new_event: N4i,
  reschedule_to_the_new_event_with_different_timeslot: z4i,
  reschedule_with_different_timeslot: R4i,
  we_dont_have_id_for_the_new_event: P4i,
  rerouted_booking_successfully_redirecting_to_booking_page: D4i,
  on_booking_write_to_event_object: L4i,
  field_name: M4i,
  add_new_field: F4i,
  you_dont_have_access_to_reroute_this_booking: q4i,
  form_response_not_found: j4i,
  contact_owner: V4i,
  contact_owner_not_found: B4i,
  using_fallback_members: U4i,
  chosen_route: G4i,
  attribute_logic_matched: W4i,
  attribute_logic_fallback_matched: H4i,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: Y4i,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: K4i,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: Z4i,
  warning: X4i,
  fallback_attribute_logic_description: J4i,
  fallback_attribute_logic_warning: Q4i,
  fallback_not_needed: e5i,
  confirm_reassign_unavailable: t5i,
  confirm_reassign_available: n5i,
  reassign_unavailable_team_member_description: o5i,
  reassign_available_team_member_description: r5i,
  yes_reassign: i5i,
  filter_by_attributes: a5i,
  reassign_reason: s5i,
  field_type_change_suggestion: c5i,
  reassigned_by: l5i,
  row: u5i,
  rows: d5i,
  attendee_timezone_variable: _5i,
  event_start_time_in_attendee_timezone_variable: p5i,
  event_start_time_in_attendee_timezone_info: m5i,
  event_end_time_in_attendee_timezone_info: f5i,
  event_end_time_in_attendee_timezone_variable: g5i,
  salesforce_create_event_on_contact: h5i,
  salesforce_owner_name_to_change: v5i,
  no_filter_set: b5i,
  booking_dry_run_successful: y5i,
  booking_dry_run_successful_description: $5i,
  dont_have_access_this_page: w5i,
  you_need_admin_or_owner_privileges_to_access: k5i,
  field_type: S5i,
  when_to_write: E5i,
  salesforce_on_booking_write_to_record: x5i,
  on_every_booking: C5i,
  only_if_field_is_empty: T5i,
  booking_start_date: A5i,
  booking_created_date: I5i,
  booking_reassigned_to_host: O5i,
  no_contact_owner: N5i,
  routing_forms_created: z5i,
  routing_forms_total_responses: R5i,
  routing_forms_total_responses_without_booking: P5i,
  routing_forms_total_responses_with_booking: D5i,
  routing_form_insights: L5i,
  routing_form_insights_form_name_header: M5i,
  routing_form_insights_booking_status_header: F5i,
  routing_form_insights_response_no_booking: q5i,
  routing_form_insights_booked_by: j5i,
  routing_form_insights_created_at: V5i,
  routing_form_insights_booking_status: B5i,
  routing_form_insights_booking_at: U5i,
  routing_form_insights_submitted_at: G5i,
  copy_redirect_url: W5i,
  redirect_url_on_exit: H5i,
  total_bookings_per_period: Y5i,
  routed_to_per_period: K5i,
  per_day: Z5i,
  per_week: X5i,
  per_month: J5i,
  routing_form_insights_assignment_reason: Q5i,
  access_denied: e6i,
  salesforce_route_to_owner: t6i,
  salesforce_add_attendees_as: n6i,
  salesforce_do_not_route_to_owner: o6i,
  salesforce_route_to_custom_lookup_field: r6i,
  salesforce_option: i6i,
  lookup_field_name: a6i,
  salesforce_if_free_email_domain_skip_owner_check: s6i,
  filter_operator_is: c6i,
  filter_operator_is_not: l6i,
  filter_operator_contains: u6i,
  filter_operator_does_not_contain: d6i,
  filter_operator_starts_with: _6i,
  filter_operator_ends_with: p6i,
  filter_operator_is_empty: m6i,
  filter_operator_not_empty: f6i,
  translate_description_button: g6i,
  translate_description_button_description: h6i,
  rr_distribution_method: v6i,
  rr_distribution_method_description: b6i,
  rr_distribution_method_availability_title: y6i,
  rr_distribution_method_availability_description: $6i,
  rr_distribution_method_balanced_title: w6i,
  rr_distribution_method_balanced_description: k6i,
  edit_team_member_weights: S6i,
  weights_updated_successfully: E6i,
  require_confirmation_for_free_email: x6i,
  exclude_emails_that_contain: C6i,
  require_emails_that_contain: T6i,
  exclude_emails_match_found_error_message: A6i,
  require_emails_no_match_found_error_message: I6i,
  search_columns: O6i,
  search_options: N6i,
  disable_org_url_label: z6i,
  disable_org_url_description: R6i,
  single_select: P6i,
  multi_select: D6i,
  calendar_conflict_settings: L6i,
  select_calendars_conflict_check: M6i,
  group_meeting: F6i,
  are_you_sure_you_want_to_remove_this_app_from: q6i,
  disconnect_app_from: j6i,
  salesforce_ignore_guests: V6i,
  google_meet: B6i,
  zoom: U6i,
  office_365_video: G6i,
  lock_attribute_for_assignment: W6i,
  lock_attribute_for_assignment_description: H6i,
  attribute_edited_successfully: Y6i,
  new_group_option: K6i,
  attribute_weight_enabled: Z6i,
  attribute_weight_enabled_description: X6i,
  routed: J6i,
  reassigned: Q6i,
  allow_rescheduling_past_events: eFi,
  allow_rescheduling_past_events_description: tFi,
  rerouted: nFi,
  salesforce_assigned: oFi,
  router_position: rFi,
  show_matching_hosts: iFi,
  no_active_queues: aFi,
  weight: sFi,
  calibration: cFi,
  shortfall: lFi,
  routing_form: uFi,
  go_back_and_save: dFi,
  save_changes: _Fi,
  leave_without_saving: pFi,
  leave_without_saving_description: mFi,
  something_unexpected_occurred: fFi,
  "500_error_message": "Non è colpa tua, è colpa nostra.",
  dry_run_mode_active: gFi,
  icon_showcase: hFi,
  icons_showcase: vFi,
  migrating_from_team: bFi,
  feature_currently_disabled: yFi,
  choose_an_option: $Fi,
  enter_option_value: wFi,
  remove_option: kFi,
  use_attribute_weights: SFi,
  if_enabled_ignore_event_type_weights: EFi,
  attribute_for_weights: xFi,
  managed_users: CFi,
  managed_users_description: TFi,
  can_you_tell_me_about: AFi,
  use_ai_to_answer_your_questions: IFi,
  error_fetching_answer: OFi,
  k_bar_ai_error: NFi,
  select_oAuth_client: zFi,
  on_every_instance: RFi,
  delegation_credential_feature_not_enabled: PFi,
  internal_booking_note: DFi,
  internal_note_cancellation_reason: LFi,
  internal_booking_note_description: MFi,
  internal_note_presets: FFi,
  internal_note_presets_description: qFi,
  internal_note_presets_updated_successfully: jFi,
  add_preset: VFi,
  authorize: BFi,
  next: UFi,
  hide: GFi,
  show: WFi,
  utm_params: HFi,
  no_utm_params: YFi,
  asc: KFi,
  desc: ZFi,
  verify_email_change: XFi,
  buy_credits: JFi,
  credits: QFi,
  credits_used: eqi,
  total_credits_remaining: tqi,
  credits_per_tip_org: nqi,
  credits_per_tip_teams: oqi,
  view_and_manage_credits: rqi,
  view_and_manage_credits_description: iqi,
  credit_worth_description: aqi,
  buy_additional_credits: sqi,
  view_additional_credits_expense_tip: cqi,
  overview: lqi,
  organization_slug_taken: uqi,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: dqi,
  you_need_to_complete_user_onboarding_before_creating_an_organization: _qi,
  use_company_email_to_create_an_organization: pqi,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: mqi,
  you_need_to_have_minimum_published_teams: fqi,
  you_are_part_of_this_organization_already: gqi,
  you_are_part_of_another_organization_cannot_create_organization: hqi,
  you_are_part_of_another_platform_organization_cannot_create_organization: vqi,
  organization_payment_success: bqi,
  organization_payment_success_description: yqi,
  this_may_take_a_few_seconds: $qi,
  organization_onboarding_status: wqi,
  organization_onboarding_status_description: kqi,
  payment_failed: Sqi,
  payment_failed_description: Eqi,
  creating_your_organization: xqi,
  organization_onboarding_already_completed: Cqi,
  organization_onboarding_already_exists: Tqi,
  organization_onboarding_not_found: Aqi,
  payment_successful: Iqi,
  handover_onboarding_page_title: Oqi,
  handover_onboarding_page_description: Nqi,
  organization_already_exists_with_this_slug: zqi,
  you_do_not_have_permission_to_create_an_organization_for_this_email: Rqi,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: Pqi,
  organization_has_subscription_already: Dqi,
  reset_interval_weighted_rr: Lqi,
  interval: Mqi,
  rr_reset_interval_description: Fqi,
  daily: qqi,
  end_date_not_selected: jqi,
  my_ooo: Vqi,
  team_ooo: Bqi,
  out_of_office_team_description: Uqi,
  create_ooo_dialog_team_title: Gqi,
  create_ooo_dialog_team_subtitle: Wqi,
  edit_ooo_dialog_team_subtitle: Hqi,
  ooo_team_empty_title: Yqi,
  ooo_team_empty_description: Kqi,
  forward_to_team_member_only: Zqi,
  ooo_team_redirect_infinite_not_allowed: Xqi,
  previous_ooo_empty_title: Jqi,
  previous: Qqi,
  rr_interval_successfully_updated: eji,
  trial_mode: tji,
  inactive_team_plan: nji,
  inactive_team_plan_description: oji,
  limited_access_trial_mode: rji,
  referral_program: iji,
  referral_text: aji,
  dub_disabled_error_message: sji,
  uid: cji,
  link: lji,
  rows_per_page: uji,
  pagination_status: dji,
  tip_username_plus: _ji,
  user_has_no_team_yet: pji,
  no_team_members: mji,
  recurring_event_doesnt_support_seats: fji,
  booking_limit_per_booker_doesnt_support_recurring: gji,
  seats_doesnt_support_recurring: hji,
  recurring_event_seats_error: vji,
  segment: bji,
  saved_filters: yji,
  rename: $ji,
  rename_segment: wji,
  delete_segment: kji,
  duplicate_segment: Sji,
  delete_segment_confirmation: Eji,
  filter_segment_updated: xji,
  error_updating_filter_segment: Cji,
  filter_segment_duplicated: Tji,
  error_duplicating_filter_segment: Aji,
  filter_segment_deleted: Iji,
  error_deleting_filter_segment: Oji,
  save_segment: Nji,
  segment_not_found: zji,
  filter_segment_saved: Rji,
  no_segments: Pji,
  error_saving_filter_segment: Dji,
  override_segment: Lji,
  create_new_segment: Mji,
  save_for_team: Fji,
  select_team: qji,
  please_select_team: jji,
  personal: Vji,
  hide_team_profile_link: Bji,
  hide_team_profile_link_description: Uji,
  display: Gji,
  could_not_find_slug_to_publish_org: Wji,
  picklist: Hji,
  most_cancelled_bookings: Yji,
  interface_language: Kji,
  interface_language_description: Zji,
  visitors_browser_language: Xji,
  name_or_email: Jji,
  salesforce_round_robin_skip_fallback_to_lead_owner: Qji,
  credit_purchase_failed: eVi,
  minimum_of_credits_required: tVi,
  enable_delegation_credential: nVi,
  enable_delegation_credential_description: oVi,
  disable_delegation_credential: rVi,
  disable_delegation_credential_description: iVi,
  last_active: aVi,
  member_since: sVi,
  last_updated: cVi,
  salesforce_on_cancel_write_to_event: lVi,
  salesforce_on_every_cancellation: uVi,
  report_issue: dVi,
  report_issue_description: _Vi,
  open_issue: pVi,
  this_is_your_current_plan: mVi,
  schedule_a_time: fVi,
  this_includes: gVi,
  oauth_client_updated_successfully: hVi,
  oauth_client_not_found: vVi,
  subscribe_to_platform: bVi,
  error_accessing_webhooks: yVi,
  webhook_update_failed: $Vi,
  webhook_create_failed: wVi,
  invalid_link: kVi,
  currently_subscribed_to_plan: SVi,
  user_team: EVi,
  client_id_copied: xVi,
  client_secret_copied: CVi,
  maintenance_message: TVi,
  your_payment_failed: AVi,
  check_your_inbox: IVi,
  account_created_premium_not_reserved: OVi,
  email_sent_with_activation_link: NVi,
  activate_account_to_purchase_username: zVi,
  open_in_gmail: RVi,
  dont_see_email: PVi,
  resend_in_seconds: DVi,
  resend: LVi,
  verification_email_sent: MVi,
  select_all_members: FVi,
  select_all_members_tooltip: qVi,
  form_settings: jVi,
  remove_whitelist_status: VVi,
  whitelist_user_workflows: BVi,
  user_workflows_whitelisted: UVi,
  user_workflows_unwhitelisted: GVi,
  date_and_time: WVi,
  email_reminder_upcoming_event_notice: HVi,
  email_reminder_triggered_by_workflow: YVi,
  event_upper_case: KVi,
  scheduling_by: ZVi,
  experience_review_prompt: XVi,
  improve_customer_experience_message: JVi,
  meeting_satisfaction_question: QVi,
  meeting_not_joined_question: eBi,
  reschedule_cta_short: tBi,
  hide_organizer_email: nBi,
  platform_customer_cant_create_organization: oBi,
  organization_customer_cant_create_platform: rBi,
  hide_organizer_email_description: iBi,
  you_and_conjunction: aBi,
  select_verified_email: sBi,
  add_verified_email: cBi,
  add_verified_emails: lBi,
  custom_reply_to_email_title: uBi,
  custom_reply_to_email_description: dBi,
  email_survey_triggered_by_workflow: _Bi,
  skip_trial: pBi,
  team_trials_skipped_successfully: mBi,
  sms_workflow_consent: fBi,
  routing_preview_more_info_found_insights: gBi,
  results: hBi,
  view_form: vBi,
  sms_opt_out_message: bBi,
  team_credits_low_warning: yBi,
  user_credits_low_warning: $Bi,
  action_required_out_of_credits: wBi,
  action_required_user_out_of_credits: kBi,
  low_credits_warning_message: SBi,
  low_credits_warning_message_user: EBi,
  credit_limit_reached_message: xBi,
  credit_limit_reached_message_user: CBi,
  current_credit_balance: TBi,
  current_balance: ABi,
  notification_about_your_booking: IBi,
  monthly_credits: OBi,
  total_credits: NBi,
  remaining_credits: zBi,
  remaining: RBi,
  total: PBi,
  additional_credits: DBi,
  routing_form_next_in_queue: LBi,
  routing_form_select_members_to_email: MBi,
  routing_incomplete_booking_tab: FBi,
  include_no_show_in_rr_calculation: qBi,
  recent_no_show_guests: jBi,
  recent_no_show_guests_tooltip: VBi,
  matching: BBi,
  event_redirect: UBi,
  reset_form: GBi,
  rr_settings_successfully_updated: WBi,
  distribution_basis_weighted_rr: HBi,
  timestamp_basis_description: YBi,
  requires_credits: KBi,
  requires_credits_tooltip: ZBi,
  available_credits: XBi,
  create_role: JBi,
  roles_and_permissions: QBi,
  roles_and_permissions_description: e9i,
  learn_more_permissions: t9i,
  role_name: n9i,
  role_name_required: o9i,
  role_name_placeholder: r9i,
  role_description: i9i,
  role_description_placeholder: a9i,
  default_role: s9i,
  custom_role: c9i,
  advanced: l9i,
  search_permissions: u9i,
  all_permissions: d9i,
  none: _9i,
  read_only: p9i,
  pbac_desc_all_actions_all_resources: m9i,
  pbac_resource_all: f9i,
  pbac_resource_event_type: g9i,
  pbac_resource_team: h9i,
  pbac_resource_organization: v9i,
  pbac_resource_booking: b9i,
  pbac_resource_insights: y9i,
  pbac_resource_role: $9i,
  pbac_resource_routing_form: w9i,
  pbac_resource_workflow: k9i,
  pbac_action_all: S9i,
  pbac_action_create: E9i,
  pbac_action_read: x9i,
  pbac_action_update: C9i,
  pbac_action_delete: T9i,
  pbac_action_manage: A9i,
  pbac_action_invite: I9i,
  pbac_action_remove: O9i,
  pbac_action_change_member_role: N9i,
  pbac_action_list_members: z9i,
  pbac_action_manage_billing: R9i,
  pbac_action_read_team_bookings: P9i,
  pbac_action_read_org_bookings: D9i,
  pbac_action_read_recordings: L9i,
  pbac_action_impersonate: M9i,
  role_created_successfully: F9i,
  role_updated_successfully: q9i,
  delete_role: j9i,
  confirm_delete_role: V9i,
  role_deleted_successfully: B9i,
  error_creating_role: U9i,
  error_updating_role: G9i,
  pbac_desc_create_roles: W9i,
  pbac_resource_attributes: H9i,
  pbac_desc_view_organization_attributes: Y9i,
  pbac_desc_update_organization_attributes: K9i,
  pbac_desc_delete_organization_attributes: Z9i,
  pbac_desc_create_organization_attributes: X9i,
  pbac_desc_view_roles: J9i,
  pbac_desc_update_roles: Q9i,
  pbac_desc_delete_roles: eUi,
  pbac_desc_create_workflows: tUi,
  set_up_required: nUi,
  pbac_desc_view_workflows: oUi,
  pbac_desc_update_workflows: rUi,
  pbac_desc_delete_workflows: iUi,
  pbac_resource_webhook: aUi,
  pbac_resource_availability: sUi,
  pbac_resource_out_of_office: cUi,
  pbac_desc_create_webhooks: lUi,
  pbac_desc_view_webhooks: uUi,
  pbac_desc_update_webhooks: dUi,
  pbac_desc_delete_webhooks: _Ui,
  pbac_desc_create_availability: pUi,
  pbac_desc_view_availability: mUi,
  pbac_desc_update_availability: fUi,
  pbac_desc_delete_availability: gUi,
  pbac_desc_create_out_of_office: hUi,
  pbac_desc_view_out_of_office: vUi,
  pbac_desc_update_out_of_office: bUi,
  pbac_desc_delete_out_of_office: yUi,
  pbac_desc_manage_workflows: $Ui,
  pbac_desc_create_event_types: wUi,
  pbac_desc_view_event_types: kUi,
  pbac_desc_update_event_types: SUi,
  pbac_desc_delete_event_types: EUi,
  pbac_desc_manage_event_types: xUi,
  pbac_desc_create_teams: CUi,
  pbac_desc_view_team_details: TUi,
  pbac_desc_update_team_settings: AUi,
  pbac_desc_delete_team: IUi,
  pbac_desc_invite_team_members: OUi,
  pbac_desc_remove_team_members: NUi,
  pbac_desc_change_team_member_role: zUi,
  pbac_desc_impersonate_team_members: RUi,
  pbac_desc_manage_teams: PUi,
  pbac_desc_create_organization: DUi,
  pbac_desc_view_organization_details: LUi,
  pbac_desc_list_organization_members: MUi,
  pbac_desc_invite_organization_members: FUi,
  pbac_desc_remove_organization_members: qUi,
  pbac_desc_manage_organization_billing: jUi,
  pbac_desc_change_organization_member_role: VUi,
  pbac_desc_impersonate_organization_members: BUi,
  pbac_desc_edit_organization_settings: UUi,
  pbac_desc_manage_organizations: GUi,
  pbac_desc_view_bookings: WUi,
  pbac_desc_view_team_bookings: HUi,
  pbac_desc_view_organization_bookings: YUi,
  pbac_desc_view_booking_recordings: KUi,
  pbac_desc_update_bookings: ZUi,
  pbac_desc_manage_bookings: XUi,
  pbac_desc_view_team_insights: JUi,
  pbac_desc_manage_team_insights: QUi,
  pbac_desc_create_routing_forms: eGi,
  pbac_desc_view_routing_forms: tGi,
  pbac_desc_update_routing_forms: nGi,
  pbac_desc_delete_routing_forms: oGi,
  read_permission_auto_enabled_tooltip: rGi,
  choose_restriction_schedule: iGi,
  restriction_schedule_description: aGi,
  use_booker_timezone: sGi,
  use_booker_timezone_info: cGi,
  load_balancing_warning: lGi,
  rr_load_balancing_disabled: uGi,
  rr_load_balancing_disabled_with_groups: dGi,
  round_robin_settings_description: _Gi,
  round_robin_settings_updated_successfully: pGi,
  booking_creation_time: mGi,
  meeting_start_time: fGi,
  members_affected_by_disabling_delegation_credential: gGi,
  no_members_affected_by_disabling_delegation_credential: hGi,
  download_expense_log: vGi,
  error_downloading_expense_log: bGi,
  offer_to_reschedule_last_booking: yGi,
  booker_limit_exceeded_error: $Gi,
  booker_limit_exceeded_error_reschedule: wGi,
  duration_min_error: kGi,
  duration_max_error: SGi,
  booking_not_allowed_by_restriction_schedule_error: EGi,
  restriction_schedule_not_found_error: xGi,
  converted_image_size_limit_exceed: CGi,
  add_group: TGi,
  routing_funnel: AGi,
  routing_funnel_total_submissions: IGi,
  routing_funnel_successful_routings: OGi,
  routing_funnel_accepted_bookings: NGi,
  license_key: zGi,
  license_selection_title: RGi,
  license_selection_description: PGi,
  agplv3_license_description: DGi,
  enter_license_key: LGi,
  enter_your_license_key: MGi,
  enter_existing_license: FGi,
  enter_license_key_description: qGi,
  license_key_placeholder: jGi,
  save_license_key: VGi,
  signature_token_optional: BGi,
  signature_token_description: UGi,
  need_a_license: GGi,
  license_key_required: WGi,
  invalid_license_key: HGi,
  license_validation_failed: YGi,
  attachments_optional: KGi,
  send_message: ZGi,
  describe_the_issue: XGi,
  file_size_limit_exceed: JGi,
  invalid_file_type: QGi,
  invalid_file_type_extension: eWi,
  max_files_exceeded: tWi,
  files_uploaded_successfully: nWi,
  file_upload_instructions: oWi,
  license_key_saved: rWi,
  timezone_mismatch_tooltip: iWi,
  show_optimized_slots: aWi,
  show_optimized_slots_description: sWi,
  failed_bookings_by_field: cWi,
  failed_bookings: lWi,
  event_type_no_hosts: uWi,
  cache_status: dWi,
  cache_last_updated: _Wi,
  delete_cached_data: pWi,
  cache_deleted_successfully: mWi,
  error_deleting_cache: fWi,
  confirm_delete_cache: gWi,
  yes_delete_cache: hWi,
  remainder_of_maximum_uses_left_plural: vWi,
  remainder_of_maximum_use_left_singular: bWi,
  expires_on_date: yWi,
  single_use: $Wi,
  time_based_expiration: wWi,
  usage_based_expiration: kWi,
  number_of_uses: SWi,
  expires_on: EWi,
  max_usage_count: xWi,
  link_settings: CWi,
  link_expired_on_date: TWi,
  usage_limit_reached: AWi,
  usage_count_error: IWi,
  private_link_expired: OWi,
  time_based_expiration_description: NWi,
  time_based_generic_expiration_description: zWi,
  usage_based_expiration_description: RWi,
  usage_based_generic_expiration_description: PWi,
  usage_based_expiration_description_plural: DWi,
  webhook_trigger_event: LWi,
  webhook_created_at: MWi,
  webhook_type: FWi,
  set_up_agent: qWi,
  webhook_title: jWi,
  webhook_start_time: VWi,
  webhook_end_time: BWi,
  webhook_description: UWi,
  webhook_location: GWi,
  webhook_uid: WWi,
  webhook_reschedule_uid: HWi,
  webhook_cancellation_reason: YWi,
  webhook_rejection_reason: KWi,
  webhook_organizer_name: ZWi,
  webhook_organizer_email: XWi,
  webhook_organizer_timezone: JWi,
  webhook_organizer_locale: QWi,
  webhook_organizer_username: e8i,
  webhook_organizer_username_in_org: t8i,
  webhook_attendee_name: n8i,
  webhook_attendee_email: o8i,
  webhook_attendee_timezone: r8i,
  webhook_attendee_locale: i8i,
  webhook_team_name: a8i,
  webhook_team_members: s8i,
  webhook_video_call_url: c8i,
  webhook_hide_variables: l8i,
  webhook_show_variable: u8i,
  webhook_event_and_booking: d8i,
  webhook_people: _8i,
  webhook_teams: p8i,
  webhook_metadata: m8i,
  stats: f8i,
  booking_status: g8i,
  visit: h8i,
  location_custom_label_input_label: v8i,
  meeting_link: b8i,
  session_outcome: y8i,
  call_created: $8i,
  voicemail: w8i,
  my_bookings: k8i,
  phone: S8i,
  free: E8i,
  user_email: x8i,
  user_name: C8i,
  expand_panel: T8i,
  collapse_panel: A8i,
  email_verification_required: I8i,
  invalid_verification_code: O8i,
  you_have_one_team: N8i,
  consider_consolidating_one_team_org: z8i,
  consider_consolidating_multi_team_org: R8i,
  message_sent: P8i,
  support_message_sent_description: D8i,
  search_variables: L8i,
  support_message_placeholder: M8i,
  send_another_message: F8i,
  sending: q8i,
  no_variables_found: j8i,
  credits_required: V8i,
  web_call_credits_info: B8i,
  web_call_no_credits: U8i,
  purchase_credits: G8i,
  credits_required_tooltip: W8i,
  api_key_name_too_long: H8i,
  auto_charge_for_last_minute_cancellation: Y8i,
  before_scheduled_start_time: K8i,
  cancel_booking_acknowledge_no_show_fee: Z8i,
  contact_organizer: X8i,
  booking_time_option: J8i,
  booking_time_option_description: Q8i,
  created_at_option: e7i,
  created_at_option_description: t7i,
  call_details: n7i,
  call_id: o7i,
  call_information: r7i,
  sentiment: i7i,
  disconnect_reason: a7i,
  call_summary: s7i,
  transcription: c7i,
  event_details: l7i,
  agent: u7i,
  no_transcript_available: d7i,
  testing_sms_workflow_info_message: _7i,
  start_from_scratch_title: p7i,
  start_from_scratch_description: m7i,
  cal_ai_template_title: f7i,
  cal_ai_template_description: g7i,
  voice: h7i,
  select_voice: v7i,
  select_voice_for_agent: b7i,
  choose_a_voice_for_your_agent: y7i,
  trait: $7i,
  voice_id: w7i,
  use_voice: k7i,
  current_voice: S7i,
  setup_incoming_agent: E7i,
  setup_incoming_agent_description: x7i,
  connect_a_phone_number_first: C7i,
  setup_agent_for_incoming_calls: T7i,
  configure_agent_to_handle_incoming_calls: A7i,
  incoming_calls: I7i,
  outgoing_calls: O7i,
  inbound_agent_setup_success: N7i,
  inbound_agent_configured: z7i,
  setup_inbound_agent: R7i,
  please_select_event_type_first: P7i,
  edit_configuration: D7i,
  select_event_type_for_inbound_calls: L7i,
  setup_inbound_agent_for_incoming_calls: M7i,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: F7i
}, j7i = "Identiteitsprovider", V7i = 'U heeft nog $t(day, {"count": {{days}} }) over van uw PRO-proefperiode', B7i = "{{count}} dag", U7i = "{{count}} dagen", G7i = "{{count}} seconde", W7i = "{{count}} seconden", H7i = "Nu upgraden", Y7i = "Naamloos", K7i = "Uitnodiging accepteren", Z7i = "Max. Karakters", X7i = "Min. Karakters", J7i = "{{appName}} is het open source Calendly-alternatief waarmee u uw eigen gegevens, werkstroom en uiterlijk in de hand houdt.", Q7i = "Voltooi de instelling van uw {{appName}}-account! U bent nog maar een paar stappen verwijderd van het oplossen van al uw planningsproblemen.", eHi = "Heeft u vragen? We zijn er om te helpen.", tHi = "{{appName}}: Instructies voor het opnieuw instellen van uw wachtwoord", nHi = "{{appName}}: verifieer je account", oHi = "{{appName}}: Verifieer je e-mailadres", rHi = "Controleer uw e-mail", iHi = "Oud e-mailadres", aHi = "Nieuw e-mailadres", sHi = "We hebben een e-mail naar {{email}} gestuurd. Het is belangrijk om uw e-mailadres te verifiëren om de beste bezorgbaarheid van e-mails en agenda's van {{appName}} te garanderen.", cHi = "Verifieer uw e-mailadres om de beste bezorgbaarheid van e-mails en agenda's te garanderen", lHi = "Verifieer uw e-mailadres", uHi = "E-mail verifiëren", dHi = "Assistent", _Hi = "Cal Video transcriptie-e-mails versturen", pHi = "Verstuur e-mails met de transcriptie van de Cal Video na afloop van de meeting. (Vereist een betaald abonnement)", mHi = "Je hebt onlangs verzocht om het e-mailadres te wijzigen dat je gebruikt om in te loggen op je {{appName}}-account. Klik op de onderstaande knop om je nieuwe e-mailadres te bevestigen.", fHi = "Je e-mailadres is bijgewerkt naar {{email}}", gHi = "Het bijwerken van het e-mailadres is mislukt.", hHi = "Verifieer je nieuwe {{appName}} e-mailadres", vHi = "We hebben een verificatielink gestuurd naar {{email}}. We zullen je e-mailadres bijwerken zodra je op deze link klikt.", bHi = "Sla deze API-sleutel ergens veilig op. U kunt deze niet opnieuw bekijken.", yHi = "Verifieer uw e-mailadres door op de onderstaande knop te klikken.", $Hi = "Verifieer je e-mailadres door onderstaande code te gebruiken.", wHi = "Hier is de link voor het geval u niet graag op knoppen klikt:", kHi = "Voer verificatiecode in", SHi = "Voer de verificatiecode in die u per e-mail is toegestuurd", EHi = "Verificatiecode is onjuist.", xHi = "E-mail verzonden", CHi = "Fout opgetreden tijdens het versturen van e-mail", THi = "Afgewezen: {{title}}", AHi = "Geannuleerd: {{title}} op {{date}}", IHi = "Opnieuw toegewezen: {{title}} op {{date}}", OHi = "Uw gebeurtenisverzoek is geweigerd", NHi = "Cal video-instellingen aanpassen", zHi = "Configureer voorkeuren voor videovergaderingen, inclusief opnamerechten voor hosts en deelnemers.", RHi = "Opname uitschakelen voor gasten", PHi = "Automatische transcriptie inschakelen na deelname aan de vergadering", DHi = "Automatische opname inschakelen nadat organisator deelneemt aan de vergadering", LHi = "Video-opties", MHi = "Evenement bewerken", FHi = "Sessiedetails bekijken", qHi = "Vergadersessiegegevens", jHi = "Vergadersessie", VHi = "Sessie-ID", BHi = "Max. deelnemers", UHi = "Onbeperkt", GHi = "Lopend", WHi = "Beëindigd", HHi = "Deelnemers", YHi = "Anonieme gebruiker", KHi = "Sessieduur", ZHi = "Geen vergadersessies gevonden", XHi = "Niet beschikbaar", JHi = "Opname uitschakelen voor organisator", QHi = "Transcriptie uitschakelen voor gasten", eYi = "Transcriptie uitschakelen voor organisator", tYi = "Uw verzoek voor een terugkerende gebeurtenis is geweigerd", nYi = "Uw geplande gebeurtenis is geannuleerd", oYi = "Je geplande afspraak is opnieuw toegewezen", rYi = "De afspraak staat niet meer in je agenda en je round robin-kans wordt niet negatief beïnvloed", iYi = "Organisator", aYi = "Opnieuw toegewezen aan", sYi = "Moet u verplaatsen of annuleren?", cYi = "Je kunt de boekingsdetails bekijken via deze url {{url}} en het evenement aan je agenda toevoegen", lYi = "Geen opties beschikbaar", uYi = "Reden voor annulering (optioneel)", dYi = "Geannuleerd door", _Yi = "Reden voor annulering", pYi = "Waarom annuleert u?", mYi = "De annuleringsreden wordt gedeeld met gasten", fYi = "Waarom wijs je dit af?", gYi = "Reden voor weigering", hYi = "Boekingsverzoek weigeren?", vYi = "Weet u zeker dat u de boeking wilt weigeren? We informeren de persoon die probeerde te boeken. U kunt hieronder een reden opgeven.", bYi = "Boeking weigeren", yYi = "Deze gebeurtenis beheren", $Yi = "Teamlid uitnodigen", wYi = "Persoon uitnodigen", kYi = "Bulkimport", SYi = "Uitg.", EYi = "Uw gebeurtenis is gepland", xYi = "Uw terugkerende gebeurtenis is gepland", CYi = "Accepteer onze licentie door de variable .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> te veranderen in '{{agree}}'.", TYi = "Om deze banner te verwijderen, opent u het .env bestand en verandert <1>NEXT_PUBLIC_LICENSE_CONSENT</1> in '{{agree}}'.", AYi = "De foutmelding was: '{{errorMessage}}'", IYi = "Terugbetaling mislukt: {{name}} - {{date}} - {{eventType}}", OYi = "De terugbetaling voor het evenement {{eventType}} met {{userName}} op {{date}} is mislukt.", NYi = "Neem contact op met uw betalingsverwerker en {{user}} om dit op te lossen.", zYi = "Een terugbetaling is mislukt", RYi = "In afwachting van betaling: {{title}} op {{date}}", PYi = "Er is een openstaande betaling voor uw vergadering", DYi = "De kleur van het donkere thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat je knoppen beter zichtbaar zijn.", LYi = "De kleur van het lichte thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat je knoppen beter zichtbaar zijn.", MYi = "De kleur van het lichte thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat de kleur van je evenementtypen beter zichtbaar is.", FYi = "De kleur van het donkere thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat de kleur van je evenementtypen beter zichtbaar is.", qYi = "Betaling kon niet worden aangemaakt", jYi = "Kon de kaart niet belasten voor betaling", VYi = "Geen beschikbare gebruikers gevonden. Kun je een ander tijdslot proberen?", BYi = "Het geselecteerde tijdslot is niet meer beschikbaar. <0>Selecteer alstublieft een nieuwe tijd</0>", UYi = "Bezet", GYi = "Je hebt zojuist verbinding gemaakt. Boek een tijdslot hierboven of probeer het later opnieuw.", WYi = "Niet-beschikbaar tijdslot", HYi = "Het afspraaktype kan op dit moment niet worden geboekt. Zou je een ander tijdslot willen proberen?", YYi = "Interne fout. Verzoek bevat geen eindtijd", KYi = "Kan geen agenda-evenement aanmaken in de agenda van de organisator", ZYi = "Kan de agenda-afspraak niet bijwerken.", XYi = "Kan de agenda-afspraak niet verwijderen.", JYi = "Je bent al ingeschreven voor deze boeking.", QYi = "Sommige hosts zijn niet beschikbaar voor boeking.", eKi = "Sommige vaste hosts zijn niet beschikbaar voor boeking.", tKi = "Round Robin host is niet beschikbaar voor boekingen.", nKi = "Help", oKi = "Prijs", rKi = "Betaald", iKi = "Terugbetaald", aKi = "Opnemen", sKi = "Transcriberen", cKi = "Betaling", lKi = "Velden voor creditcard ontbreken", uKi = "Nu betalen", dKi = "Algemene Prompt", _Ki = "Transcriptie aangedreven door AI", pKi = "Opname starten of stoppen", mKi = "Begin Bericht", fKi = "De codebase moet open source blijven, ongeacht of deze is gewijzigd of niet", gKi = "U kunt de codebase niet opnieuw verpakken of verkopen", hKi = "Schaf via e-mail een commerciële licentie aan om deze voorwaarden te verwijderen", vKi = "Samenvatting van voorwaarden", bKi = "Open .env en ga akkoord met onze voorwaarden", yKi = "Ik heb mijn .env gewijzigd", $Ki = "Licentie accepteren", wKi = "Er is nog een openstaande goedkeuring voor een evenement", kKi = "Openstaand verzoek voor evenement: {{attendeeName}} - {{date}} - {{eventType}}", SKi = 'Geen resultaten gevonden voor "{{searchTerm}}"', EKi = "Geen verdere resultaten", xKi = "Geen resultaten", CKi = "Meer resultaten laden", TKi = "{{integrationName}} afspraak ID: {{meetingId}}", AKi = "Bevestigd: {{eventType}} met {{name}} op {{date}}", IKi = "Nieuwe afspraakaanvraag: {{attendeeName}} - {{date}} - {{eventType}}", OKi = "Bevestig of weiger het verzoek", NKi = "Controleer uw boekingen om de boeking te bevestigen of te verwerpen.", zKi = "Check-in Assistent", RKi = "Pleit een uitgaande oproep om te controleren of de geplande afspraak werkt of als je wilt herplannen.", PKi = "Maak je eigen prompt en gebruik deze om een uitgaande oproep te doen.", DKi = "Een gebeurtenis wacht op uw goedkeuring", LKi = "Een terugkerende gebeurtenis wacht op uw goedkeuring", MKi = "Iemand heeft verzocht om een gebeurtenis op uw kalender te plannen.", FKi = "Iemand heeft een link verzocht om uw wachtwoord te wijzigen.", qKi = "Als dit e-mailadres in ons systeem bestaat, zou u een e-mail voor het opnieuw instellen van uw wachtwoord moeten ontvangen.", jKi = "Als dit niet heeft verzocht, kunt u deze e-mail gerust negeren en wordt uw wachtwoord niet gewijzigd.", VKi = "In afwachting van goedkeuring: {{title}} om {{date}}", BKi = "Een gebeurtenis wacht nog op uw goedkeuring", UKi = "Boeking verzonden: {{title}} om {{date}}", GKi = "Opname downloaden: {{title}} op {{date}}", WKi = "Download Transcript: {{title}} op {{date}}", HKi = "Download uw opname", YKi = "Download je Transcripts", KKi = "Uw afspraak is geboekt", ZKi = "Uw {{title}} is verplaatst naar {{date}}.", XKi = "Je {{title}} is bijgewerkt.", JKi = "Bijgewerkt - Uw gebeurtenis is verplaatst", QKi = "Afspraak is bijgewerkt", eZi = "Je afspraak is verzet", tZi = "{{organizer}} heeft de boeking geannuleerd en u verzocht een andere tijd te kiezen.", nZi = "U heeft {{attendee}} gevraagd om te verplaatsen", oZi = "U heeft de boeking geannuleerd en {{attendee}} moet samen met u een nieuwe boekingstijd kiezen.", rZi = "Verplaatst: {{eventType}} met {{name}} op {{date}}", iZi = "Actie vereist voor verplaatsing: boek een nieuwe tijd voor {{eventType}} met {{name}}", aZi = "Hallo {{name}}", sZi = "{{eventType}} met {{name}}", cZi = "Het lijkt erop dat al onze experts momenteel bezet zijn. Plan een gesprek in op een moment dat jou het beste uitkomt en we staan klaar om je te helpen.", lZi = "Plan in plaats daarvan", uZi = "Nieuwe afspraak: {{attendeeName}} - {{date}} - {{eventType}}", dZi = "Word lid via {{entryPoint}}", _Zi = "Opmerkingen", pZi = "Mijn boekingen beheren", mZi = "Moet u iets veranderen?", fZi = "Er is een nieuwe afspraak gemaakt.", gZi = "Er is een nieuwe terugkerende gebeurtenis gepland.", hZi = "E-mail", vZi = "Tijdzone", bZi = "Resterende tijd", yZi = "Evenement", $Zi = "Dubbel Event Type", wZi = "Deelnemen", kZi = "Videobellen via", SZi = "Afspraakcode", EZi = "Deelneming wachtwoord", xZi = "URL afspraak", CZi = "Vergader-URL niet gevonden", TZi = "Token niet gevonden", AZi = "Een andere host heeft de vergadering al geaccepteerd. Wil je nog steeds deelnemen? <0>Doorgaan naar vergadering</0>", IZi = "Uw afspraak is helaas afgewezen", OZi = "Afgewezen: {{eventType}} met {{organizer}} op {{date}}", NZi = "Hallo", zZi = "Lidverzoek accepteren", RZi = "Dit team beheren", PZi = "Teaminformatie", DZi = "Deelnemen aan Vergadering", LZi = "Als u {{toEmail}} liever niet als uw {{appName}} e-mail wilt gebruiken of al een {{appName}} account heeft, vraag dan een andere uitnodiging aan voor die e-mail.", MZi = "U bent uitgenodigd om lid te worden van het team {{teamName}}", FZi = "{{user}} heeft u uitgenodigd om lid te worden van het {{entity}} {{team}} op {{appName}}", qZi = "U bent verborgen in dit team", jZi = "Uw plaats is niet betaald. Upgrade naar Pro of laat de teameigenaar weten dat deze uw plaats kan betalen.", VZi = "U heeft een Pro-account nodig om teams te gebruiken, u bent verborgen tot u upgradet.", BZi = "p.s. De uitnodiging verloopt over {{expiresIn}} uur.", UZi = "Upgraden naar per plaats", GZi = "De optie plaatsen optie ondersteunt geen bevestigingseis", WZi = "Meerdere Locaties ondersteunt geen plaatsenoptie", HZi = "No-show vergoeding ondersteunt geen plaatsenoptie", YZi = "Plaatsenoptie ondersteunt geen Meerdere Locaties", KZi = "Van de {{memberCount}} leden in uw team zijn {{unpaidCount}} plaats(en) onbetaald. Voor $ {{seatPrice}}/maand per plaats bedragen de geschatte totale kosten van uw abonnement $ {{totalCost}}/maand.", ZZi = 'Bedankt voor het testen van ons nieuwe teamabonnement. We hebben geconstateerd dat uw team "{{teamName}}" moet worden geüpgraded.', XZi = "Hier upgraden", JZi = "Uw team is geüpgraded!", QZi = 'Bedankt voor het testen van ons organisatieabonnement. We hebben geconstateerd dat uw organisatie "{{teamName}}" moet worden geüpgraded.', eXi = "Uw organisatie is geüpgraded!", tXi = "Gebruik de onderstaande link om uw wachtwoord te resetten", nXi = "Hoi daar", oXi = "daar", rXi = "Wachtwoord vergeten? - {{appName}}", iXi = "Weet u zeker dat u deze webhook wilt verwijderen? U ontvangt dan niet langer {{appName}} vergadergegevens op een opgegeven URL, in real-time, wanneer een evenement is geboekt of geannuleerd.", aXi = "Ja, webhook verwijderen", sXi = "Webhook bewerken", cXi = "Webhook verwijderen", lXi = "Webhook status", uXi = "Webhook ingeschakeld", dXi = "Webhook uitgeschakeld", _Xi = "Webhook melding", pXi = "Webhook testen", mXi = "Webhook-updateformulier", fXi = "Voeg een webhook toe aan je OAuthClient.", gXi = "Beheer uw webhook", hXi = "Webhook succesvol toegevoegd!", vXi = "Webhook succesvol bijgewerkt!", bXi = "Webhook succesvol verwijderd!", yXi = "Abonnement vereist", $Xi = "Je hebt geen abonnement op een Platform-plan.", wXi = "Gegevenssjabloon", kXi = "Negeer", SXi = "Nog geen gegevens", EXi = "Ping test", xXi = "Voeg deze app toe aan uw startscherm voor een snellere toegang en verbeterde ervaring.", CXi = "Toekomstige", TXi = "Terugkerend", AXi = "Verleden", IXi = "Bestand kiezen...", OXi = "Afbeelding uploaden", NXi = "Upload {{target}}", zXi = "Geen {{target}}", RXi = "Schuif om in te zoomen, sleep om de positie te wijzigen", PXi = "Notificaties bekijken", DXi = "Publieke pagina bekijken", LXi = "Link openbare pagina kopiëren", MXi = "Kopieer verwijzingslink", FXi = "Log uit", qXi = "Nog een toevoegen", jXi = "Nog een installeren", VXi = "tot", BXi = "mogelijk gemaakt door", UXi = "Niet beschikbaar", GXi = "Uw werkschema instellen", WXi = "Verander tijden wanneer u beschikbaar bent voor afspraken", HXi = "Selecteer...", YXi = "Tekst", KXi = "Uw telefoonnummer", ZXi = "Meerdere regels tekst", XXi = "Nummer", JXi = "Selectievakje", QXi = "Is verplicht", eJi = "Maak dit veld verplicht", tJi = "Vereist", nJi = "Optioneel", oJi = "Input type", rJi = "Geweigerd", iJi = "Niet-bevestigd", aJi = "Bezoekers", sJi = "Gast", cJi = "Details van de web conferentie zullen volgen.", lJi = "Bevestiging", uJi = "Wat je boeker moet verstrekken om bevestigingen te ontvangen", dJi = "Gebruikersnaam", _Ji = "is nog steeds beschikbaar.", pJi = "Documentatie", mJi = "Leer hoe u onze tools kunt integreren met uw app", fJi = "API Referentie", gJi = "Een complete API-referentie voor onze database", hJi = "Blog", vJi = "Lees ons laatste nieuws en artikelen", bJi = "Word lid van onze community", yJi = "Populaire pagina's", $Ji = "Registreer nu", wJi = "Registreer", kJi = "Deze pagina bestaat niet.", SJi = "Geen actief telefoonnummer beschikbaar", EJi = "Workflowstap niet geconfigureerd", xJi = "Controleer op spelfouten of ga terug naar de vorige pagina.", CJi = "We kunnen de gebeurtenis die u probeert te boeken niet vinden.", TJi = "Aan de slag", AJi = "Geheim", IJi = "Leeglaten om geheim te verwijderen", OJi = "Zorg om beveiligingsredenen ervoor dat uw server alleen de verwachte {{appName}}-verzoeken ontvangt", NJi = "Geheime Afspraak", zJi = "In plaats daarvan inloggen", RJi = "Account Aanmaken", PJi = "Aan de slag", DJi = "Wachtwoord bevestigen", LJi = "Stel uw nieuwe wachtwoord in met de instructies die u per e-mail zijn toegestuurd.", MJi = "Upload een afbeelding van {{width}} breedte en {{height}} hoogte.", FJi = "Log opnieuw in met uw nieuwe e-mailadres en wachtwoord.", qJi = "Uw account aanmaken", jJi = "Maak je Cal.com-account aan", VJi = "Registreer nu", BJi = "U bent uitgelogd", UJi = "We hopen u spoedig weer te zien!", GJi = "Uitgelogd", WJi = "Probeer het opnieuw en neem contact met ons op als het probleem zich blijft voordoen.", HJi = "Tweestapsverificatie code is onjuist.", YJi = "Er bestaat geen account met dat e-mailadres.", KJi = "Account aanmaken", ZJi = "Heeft u nog geen account?", XJi = "Log in op uw account", JJi = "Log in", QJi = "Ga terug naar de inlogpagina", eQi = "Er is een fout opgetreden tijdens het inloggen. Ga terug naar de inlogpagina en probeer het opnieuw.", tQi = "E-mail voor opnieuw instellen van wachtwoord versturen", nQi = "Uitnodiging versturen", oQi = "Wachtwoord vergeten?", rQi = "Vergeten?", iQi = "Voltooid", aQi = "Helemaal klaar!", sQi = "Alle", cQi = "Uw account", lQi = "Beschikbare apps", uQi = "Beschikbare apps", dQi = "Bekijk populaire apps hieronder en ontdek meer in onze <0>App Store</0>", _Qi = "Voeg iedereen toe die bij het evenement aanwezig moet zijn. <0>Meer informatie</0>", pQi = "Mensen in een groep wisselen elkaar af, één persoon van elke groep zal aanwezig zijn bij de gebeurtenis.", mQi = "Mensen in de groep wisselen elkaar af en er komt maar één persoon opdagen voor de gebeurtenis.", fQi = "Controleer uw e-mail. We hebben u een link gestuurd om uw wachtwoord opnieuw in te stellen.", gQi = "Voltooien", hQi = "Beheer de instellingen voor de taal en tijdzone van uw team", vQi = "Een korte introductie over uzelf. Dit wordt weergegeven op uw persoonlijke pagina.", bQi = "Bijna klaar!", yQi = "Als laatste, een korte beschrijving over jezelf en een foto helpt echt bij het krijgen van boekingen en laat mensen weten met wie ze een afspraak maken.", $Qi = "Bepaal tijdbereiken waarin u periodiek beschikbaar bent. U kunt op een later tijdstip terugkomen en hier meer van aanmaken en toewijzen aan verschillende kalenders.", wQi = "Beschikbaarheid bepalen", kQi = "Stel schema's in voor de tijden waarop je geboekt wilt worden.", SQi = "Deel een link of embed", EQi = "Deel je {{appName}}-link of embed deze op je site.", xQi = "Beschikbaarheidsinstellingen", CQi = "Doorgaan zonder kalender", TQi = "Ga door met {{appName}}", AQi = "Koppel uw agenda", IQi = "Koppel uw videoapps", OQi = "Koppel uw videoapps om ze op uw gebeurtenistypes te gebruiken.", NQi = "Verbind je agenda om automatisch te controleren op bezette tijden en nieuwe afspraken zodra deze worden gepland.", zQi = "Later instellen", RQi = "Huidige tijd", PQi = "Details", DQi = "Welkom", LQi = "Welkom terug", MQi = "Welkom bij {{appName}}", FQi = "Vertel ons hoe we je moeten noemen en laat ons weten in welke tijdzone je je bevindt. Je kunt dit later bewerken.", qQi = "Verbinding maken met de CalDav (Beta)", jQi = "Verbind met een ICS-feed", VQi = "Koppelen", BQi = "Probeer het gratis", UQi = "Maak uw eigen boekingslink met {{appName}}", GQi = "Wie", WQi = "Wat", HQi = "Wanneer", YQi = "Waar", KQi = "Toevoegen aan kalender", ZQi = "Selecteer waar je evenementen wilt toevoegen wanneer je geboekt bent.", XQi = "Voeg gebeurtenissen toe aan", JQi = "Andere agenda toevoegen", QQi = "Overige", eea = "Uw aanmeldingslink voor {{appName}}", tea = "Je hebt een afspraak met {{user}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd.", nea = "{{host}} heeft een afspraak met {{attendee}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd.", oea = "We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd.", rea = "We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd voor de eerste van deze terugkerende evenementen.", iea = "Je hebt een afspraak met {{user}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd voor de eerste van deze terugkerende evenementen.", aea = "{{host}} heeft een afspraak met {{attendee}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd voor de eerste van deze terugkerende evenementen.", sea = "U en alle andere deelnemers zijn gemaild met deze informatie.", cea = "Uw boeking moet nog steeds worden bevestigd of geweigerd.", lea = "Uw terugkerende afspraak moet nog steeds bevestigd of geweigerd worden.", uea = "{{user}} moet de boeking nog steeds bevestigen of weigeren.", dea = "{{user}} moet nog steeds elke boeking van de terugkerende afspraak bevestigen of weigeren.", _ea = "Deze afspraak is ingeboekt", pea = "De terugkerende gebeurtenissen zijn gepland", mea = "Afspraak Verzonden", fea = "Uw terugkerende afspraak is verzonden", gea = "Afspraak bevestigd", hea = "Uw terugkerende vergadering is bevestigd", vea = "Betalingen worden nog niet ondersteund voor terugkerende gebeurtenissen", bea = "Terugkerende gebeurtenissen worden nog niet ondersteund met betalingen", yea = "Voer het nieuwe wachtwoord in dat u wilt gebruiken voor uw account.", $ea = "Wachtwoord opnieuw instellen", wea = "Uw wachtwoord wijzigen", kea = "Wachtwoord tonen", Sea = "Wachtwoord verbergen", Eea = "Opnieuw proberen", xea = "Dat verzoek is verlopen.", Cea = "Voer het e-mailadres van uw account in en wij sturen u een link om uw wachtwoord opnieuw in te stellen.", Tea = "Dat verzoek is verlopen. Ga terug en voer het e-mailadres in dat gekoppeld is aan uw account en wij sturen u een andere link om uw wachtwoord opnieuw in te stellen.", Aea = "Oeps", Iea = "Inloggen", Oea = "Geslaagd", Nea = "Mislukt", zea = "Uw wachtwoord is opnieuw ingesteld. U kunt nu inloggen met uw nieuwe wachtwoord.", Rea = "Indeling", Pea = "Standaardweergave", Dea = "U kunt er meerdere selecteren en uw boekers kunnen van weergave wisselen.", Lea = "Boekingsindeling", Mea = "U kunt er meerdere selecteren en boekers kunnen van weergave wisselen. Dit kan per gebeurtenis worden aangepast.", Fea = "Maand", qea = "Wekelijks", jea = "Kolom", Vea = "Minimaal één indeling moet ingeschakeld zijn.", Bea = "De indeling die u als standaardweergave heeft geselecteerd, behoort niet tot de ingeschakelde indelingen.", Uea = "De door u geselecteerde indeling is geen geldige indeling.", Gea = "Je kunt dit voor al je evenementtypes beheren in Instellingen -> <0>Weergave</0> of <1>Overschrijven</1> alleen voor dit evenement.", Wea = "Er is een onverwachte fout opgetreden. Probeer het opnieuw.", Hea = "Ongeldige tijd op zondag", Yea = "Ongeldige tijd op maandag", Kea = "Ongeldige tijd op dinsdag", Zea = "Ongeldige tijd op woensdag", Xea = "Ongeldige tijd op donderdag", Jea = "Ongeldige tijd op vrijdag", Qea = "Ongeldige tijd op zaterdag", eta = "De eindtijd mag niet voor de begintijd zijn", tta = "De eindtijd mag niet meer dan 24 uur later zijn", nta = "Terug naar afspraken", ota = "U kunt op elk moment een andere afspraak maken.", rta = "Geannuleerd", ita = "Geen boeking", ata = "Wachten op host", sta = "Annulering geslaagd", cta = "Weet u zeker dat u deze afspraak wilt annuleren?", lta = "U kunt deze afspraak niet annuleren", uta = "U kunt de afspraak ook verzetten.", dta = "De afspraak is verlopen", _ta = "De gebeurtenis is één exemplaar van een terugkerende gebeurtenis.", pta = "Dit zijn alle resterende exemplaren van de terugkerende gebeurtenis.", mta = "Er is een fout opgetreden met de code {{status}}.", fta = "Er bestaat al een gebeurtenistype met deze URL.", gta = "U kunt deze gebeurtenis niet maken", hta = "U kunt deze gebeurtenis niet bewerken", vta = "U kunt deze werkstroom niet maken", bta = "U kunt deze planning niet maken", yta = "Deze boeking is al geannuleerd", $ta = "Deze boeking is al geaccepteerd of geweigerd", wta = "Terug naar startpagina", kta = "Of ga terug naar de startpagina", Sta = "Afspraak Niet Gevonden", Eta = "Kan deze afspraak niet vinden. Neem contact op met de organisator voor een nieuwe link.", xta = "Geen {{status}} afspraken", Cta = "U heeft nog geen {{status}} afspraken. {{description}}", Tta = "{{eventName}} tussen {{host}} en {{attendeeName}}", Ata = "Afspraken", Ita = "Boeking niet gevonden", Ota = "Bekijk geplande en voorgaande afspraken die geboekt zijn door middel van uw links.", Nta = "Zodra iemand een tijd boekt zal deze hier verschijnen.", zta = "Zodra iemand een terugkerende afspraak met u boekt, verschijnt die hier.", Rta = "Uw oude afspraken zullen hier verschijnen.", Pta = "Uw geannuleerde boekingen worden hier weergegeven.", Dta = "Uw niet-bevestigde afspraken zullen hier verschijnen.", Lta = "Niet-bevestigde boekingen", Mta = "aan", Fta = "en", qta = "Uw agenda toont u als bezig tussen", jta = "Probleemoplosser", Vta = "Begrijp waarom bepaalde tijden beschikbaar zijn en andere worden geblokkeerd.", Bta = "Hier is een overzicht van uw dag op", Uta = "Tip: Beweeg over de dik gedrukte tijden voor een volledige weergave", Gta = "Begin tijd", Wta = "Eind tijd", Hta = "Buffertijd", Yta = "Voor gebeurtenis", Kta = "Na gebeurtenis", Zta = "Geen buffertijd", Xta = "Buffer", Jta = "Uw dag begint om", Qta = "Uw dag eindigt om", ena = "Probleemoplosser openen", tna = "Bekijk uw beschikbaarheid om te ontdekken waarom uw tijden zo zichtbaar zijn.", nna = "Verander beschikbare tijden", ona = "Verander uw beschikbare tijden", rna = "Wijzig de begin- en eindtijden van uw dag", ina = "Stel de begin- en eindtijd van uw dag in en een minimale buffer tussen uw afspraken.", ana = "Momenteel is uw dag ingesteld om te starten op", sna = "De begin- en eindtijden voor uw dag zijn succesvol gewijzigd.", cna = "en eindigt om", lna = "Licht", una = "Donker", dna = "Thema automatisch aanpassen op basis van voorkeur genodigde", _na = "Sommige gebruikers in de groep hebben momenteel dynamische groepsboekingen uitgeschakeld", pna = 'Groepsboekingslinks die dynamisch kunnen worden aangemaakt door meerdere gebruikersnamen toe te voegen met een "+", bijvoorbeeld: "{{appName}}/bailey+peer', mna = "Sta deelnemers toe om u te boeken via dynamische groepsboekingen", fna = "Dynamische groepslinks", gna = "Geef zoekmachines toegang tot uw openbare content", hna = "Indexering door zoekmachines toestaan", vna = "Browsermeldingen toestaan", bna = "Je hebt meldingen geweigerd. Stel de toestemming opnieuw in via de browserinstellingen om deze in te schakelen.", yna = "Browsermeldingen uitschakelen", $na = "Browsermeldingen ingeschakeld", wna = "Browsermeldingen uitgeschakeld", kna = "Browsermeldingen geweigerd", Sna = "Sta meldingen toe via de prompt", Ena = "Pushmeldingen", xna = "Ontvang pushmeldingen wanneer een boeker een directe afspraak maakt.", Cna = "Je browser ondersteunt geen pushmeldingen. Als je Brave gebruikt, schakel dan de optie `Google-services gebruiken voor pushberichten` in op brave://settings/?search=push+messaging", Tna = "E-mailadres", Ana = "jjansen@voorbeeld.nl", Ina = "Volledige naam", Ona = "Bekijk onze API-documentatie", Nna = "Gebruik onze API voor volledige controle en aanpasbaarheid.", zna = "Webhook maken", Rna = "Directe Vergadering Aangemaakt", Pna = "Boeking geannuleerd", Dna = "Afspraak verplaatst", Lna = "Opnamedownloadlink gereed", Mna = "Transcriptie gegenereerd", Fna = "Boeking aangemaakt", qna = "Boeking geweigerd", jna = "Boeking aangevraagd", Vna = "Betaling boeking gestart", Bna = "Vergadering beëindigd", Una = "Formulier verzonden", Gna = "Formulier ingediend, geen afspraak geboekt", Wna = "Boeking betaald", Hna = "Out of Office aangemaakt", Yna = "Boeking No-Show Bijgewerkt", Kna = "Webhook activaties", Zna = "Abonnee-URL", Xna = "Nieuwe webhook aanmaken", Jna = "Webhooks", Qna = "Teamwebhooks", eoa = "Maak een nieuwe webhook aan voor uw account", toa = "Maak een Webhook", noa = "Ontvang afspraakgegevens van {{appName}} in realtime op een opgegeven URL wanneer een gebeurtenis wordt gepland of geannuleerd.", ooa = "Ontvang afspraakgegevens van {{appName}} in realtime op een opgegeven URL wanneer deze gebeurtenis wordt gepland of geannuleerd.", roa = "Responsieve iframe", ioa = "Laden...", aoa = "Verwijderen...", soa = "Standaard iframe", coa = "Ontwikkelaar", loa = "Beheer uw ontwikkelaarsinstellingen.", uoa = "iframe insluiten", doa = "De makkelijkste manier om {{appName}} op uw website in te sluiten.", _oa = "Integreer met uw eigen website met behulp van onze insluitingsopties, of ontvang informatie over afspraken met behulp van webhooks.", poa = "Afspraak maken", moa = "Bekijk en beheer uw betalingsgegevens", foa = "Uw betalingsgegevens bekijken of uw account opzeggen.", goa = "Ga naar het facturatiepaneel", hoa = "Nog iets nodig?", voa = "Als u verdere hulp nodig heeft bij facturering, is ons ondersteuningsteam er om u te helpen.", boa = "Contact", yoa = "ons ondersteuningsteam", $oa = "Neem contact op met onze klantenservice", woa = "Oeps!", koa = "Deze gebruiker heeft nog geen evenementen.", Soa = "Bewerk logo", Eoa = "Logo uploaden", xoa = "Logo uploaden", Coa = "Logo verwijderen", Toa = "Inschakelen", Aoa = "Code", Ioa = "Code is ongeldig.", Ooa = "Nieuw tijdslot toevoegen", Noa = "Voeg een extra beveiligingslaag toe aan uw account in het geval uw wachtwoord gestolen wordt.", zoa = "Tweestapsverificatie inschakelen", Roa = "Tweestapsverificatie uitschakelen", Poa = "Als u tweestapsverificatie wilt deactiveren, raden wij aan om dit zo snel mogelijk ongedaan te maken.", Doa = "Er ging iets mis bij het deactiveren van tweestapsverificatie", Loa = "Er ging iets mis bij het activeren van tweestapsverificatie", Moa = "Beveiliging", Foa = "Uw account beveiligen.", qoa = "Wachtwoord", joa = "Wachtwoord met succes bijgewerkt", Voa = "Uw wachtwoord is met succes gewijzigd.", Boa = "Er ging iets mis tijdens het wijzigen van uw wachtwoord", Uoa = "Uw sessieconfiguratie is bijgewerkt.", Goa = "Fout bij het bijwerken van de sessieconfiguratie", Woa = "Er ging iets fout.", Hoa = "Iets ziet er niet correct uit?", Yoa = "Probeer het nogmaals.", Koa = "Uw veilige nieuwe wachtwoord", Zoa = "Nieuw Wachtwoord", Xoa = "Uw oude wachtwoord", Joa = "Huidig Wachtwoord", Qoa = "Wachtwoord wijzigen", era = "Geheim wijzigen", tra = "Het nieuwe wachtwoord komt overeen met uw oude wachtwoord. Kies een ander wachtwoord.", nra = "Als u dit geheim vergeten of verloren bent, kunt u het wijzigen. Maar wees u ervan bewust dat alle integraties die dit geheim gebruiken bijgewerkt moeten worden", ora = "Uw wachtwoord is verkeerd", rra = "Mix van hoofd- en kleine letters", ira = "Minimaal 7 tekens lang", ara = "Minimaal 15 tekens lang", sra = "Minimaal 1 cijfer bevatten", cra = "Moet {{limit}}} of minder tekens lang zijn", lra = "Het wachtwoord moet minimaal {{passwordLength}} tekens lang zijn, minimaal 1 cijfer bevatten en bestaan uit een mix van hoofd- en kleine letters", ura = "Uw wachtwoord is incorrect.", dra = "E-mailadres of wachtwoord is onjuist.", _ra = "Instelling gebruiken", pra = "am/pm", mra = "Tijd, datum en tijdzone instellen", fra = "Januari", gra = "Februari", hra = "Maart", vra = "April", bra = "Mei", yra = "Juni", $ra = "Juli", wra = "Augustus", kra = "September", Sra = "Oktober", Era = "November", xra = "December", Cra = "Maandag", Tra = "Dinsdag", Ara = "Woensdag", Ira = "Donderdag", Ora = "Vrijdag", Nra = "Zaterdag", zra = "Zondag", Rra = "Alles geboekt.", Pra = "De beschikbare tijdsperiodes konden niet worden geladen.", Dra = "Gasten toevoegen", Lra = "Uw naam", Mra = "Uw volledige naam", Fra = "Geen naam", qra = "Voer een getal in tussen 1 en {{maxOccurences}}", jra = "Snel en eenvoudig - geen account vereist. Perfect voor eenmalige afspraken.", Vra = "E-mail adres", Bra = "Voer een geldig e-mailadres in", Ura = "Plan een toekomstige oproep als we niet beschikbaar zijn in {{seconds}} seconden", Gra = "Locatie", Wra = "Adres", Hra = "Voer adres in", Yra = "Persoonlijk (adres deelnemer)", Kra = "Elders", Zra = "Aangepaste locatie deelnemer", Xra = "Doorgaan als gast", Jra = "Deelnemen als gast", Qra = "Ideaal voor eenmalige gesprekken", eia = "Elke locatie", tia = "Ja", nia = "Nee", oia = "Aanvullende notities", ria = "De afspraak kon niet geboekt worden.", iia = "De afspraak kon niet opnieuw gepland worden.", aia = "Deel alstublieft alles wat kan helpen bij de voorbereiding van onze afspraak.", sia = "Bevestig uw {{eventTypeTitle}} met {{profileName}}", cia = "Opnieuw plannen van uw {{eventTypeTitle}} met {{profileName}}", lia = "Online of persoonlijk afspreken", uia = "Persoonlijk (adres organisator)", dia = "Vergadering koppelen", _ia = "Telefoon nummer", pia = "Telefoonnummer deelnemer", mia = "Telefoonnummer organisator", fia = "Telefoonnummer", gia = "Boeking wijzigen", hia = "Verplaatst in plaats daarvan", via = "Of, reserveer een teamlid", bia = "OF", yia = "Ga terug", $ia = "E-mail of gebruikersnaam", wia = "Verstuur een uitnodigingsmail", kia = "Functie", Sia = "Rol bewerken", Eia = "Rol bekijken", xia = "Bewerk team", Cia = "Gebruiker bewerken", Tia = "Organisatie bewerken", Aia = "Als je je webhooks wilt bewerken of beheren, ga dan naar <0>webhooks instellingen</0>", Iia = "Weigeren", Oia = "Alles weigeren", Nia = "Aanvaarden", zia = "Verlaat", Ria = "Profiel", Pia = "Mijn team URL", Dia = "Mijn teams", Lia = "Teamnaam", Mia = "Naam van uw team", Fia = "Team bijgewerkt", qia = "Uw team is succesvol bijgewerkt.", jia = "Uw organisatie is bijgewerkt.", Via = "Fout bij kopiëren naar klembord", Bia = "Introductie", Uia = "Een paar zinnen over uw team. Dit is zichtbaar op uw teampagina.", Gia = "Organisatie-ID", Wia = "Organisatie-ID gekopieerd.", Hia = "Een paar zinnen over uw organisatie. Dit wordt weergegeven op op uw organisatiepagina.", Yia = "Team-ID", Kia = "Team-ID gekopieerd.", Zia = "Leden", Xia = "Organisatieleden", Jia = "Lid", Qia = "{{count}} lid", eaa = "{{count}} leden", taa = "{{count}} geselecteerd", naa = "Eigenaar", oaa = "Beheerder", raa = "Admin API", iaa = "Beheerdersgebruiker", aaa = "Laten we de eerste beheerdersgebruiker aanmaken.", saa = "Beheerdersgebruikerconfiguratie", caa = "U heeft al een beheerdergebruiker gemaakt. U kunt nu inloggen op uw account.", laa = "Nieuw Lid", uaa = "Uitnodigen", daa = "Teamleden toevoegen", _aa = "Leden toevoegen", paa = "Anderen uitnodigen om deel te nemen aan uw team", maa = "Teamlid toevoegen", faa = "Nieuw teamlid uitnodigen", gaa = "Let op: Dit zal <0>een extra zetel kosten (€15/m)</0> op je abonnement.", haa = "Nodig iemand uit tot uw team.", vaa = "Upload een .csv-bestand", baa = "Uitnodigen via e-mail", yaa = "Rol teamlid wijzigen", $aa = "{{appName}}-merk uitschakelen", waa = "Verberg alle {{appName}} branding op uw openbare pagina's.", kaa = "Knop 'Teamlid boeken' verbergen", Saa = "Verberg de knop 'Teamlid boeken' op uw openbare pagina's.", Eaa = "Gevarenzone", xaa = "Wees voorzichtig. Het verwijderen van een account kan niet ongedaan worden gemaakt.", Caa = "Wees voorzichtig. Het verwijderen van een team kan niet ongedaan worden gemaakt.", Taa = "Terug", Aaa = "Annuleren", Iaa = "Alle resterende annuleren", Oaa = "Toepassen", Naa = "Gebeurtenis annuleren", zaa = "Bevestig", Raa = "Alles bevestigen", Paa = "Team ontbinden", Daa = "Weet u zeker dat u dit team wilt ontbinden? Iedereen met wie u deze teampagina heeft gedeeld zal hem niet meer kunnen gebruiken om te boeken.", Laa = "Organisatie ontbinden", Maa = "Weet u zeker dat u deze organisatie wilt ontbinden? Alle teams en leden worden verwijderd.", Faa = "Weet u zeker dat u dit lid uit het team wilt verwijderen?", qaa = "Ja, ontbind team", jaa = "Ja, verwijder lid", Vaa = "Ja, abonnement opzeggen", Baa = "Abonnement opzeggen", Uaa = "Door je abonnement op te zeggen wordt je huidige plan permanent gedeactiveerd. Deze actie kan niet ongedaan worden gemaakt.", Gaa = "Verwijder lid", Waa = "Beheer uw team", Haa = "U heeft nog geen teams.", Yaa = "Teams geven anderen de mogelijkheid om gebeurtenissen te boeken die zijn gedeeld tussen uw collega's.", Kaa = "Opslaan", Zaa = "Ja, attribuut verwijderen", Xaa = "Attribuut verwijderen", Jaa = "Weet u zeker dat u het attribuut '{{name}}' wilt verwijderen? Alle gebruikers die momenteel zijn toegewezen, zullen worden losgekoppeld.", Qaa = "Bijwerken", esa = "Opslaan", tsa = "In afwachting", nsa = "Opties openen", osa = "Link naar afspraak kopiëren", rsa = "Delen", isa = "Zou u mijn Cal willen boeken of mij uw link willen sturen?", asa = "Link naar team kopiëren", ssa = "Team verlaten", csa = "Ja, team verlaten", lsa = "Weet u zeker dat u dit team wilt verlaten? U kunt er niet meer mee boeken.", usa = "{{user}} van {{team}}", dsa = "Voorbeeld", _sa = "Link gekopieerd!", psa = "Gekopieerd!", msa = "Privélink gekopieerd!", fsa = "Link gedeeld!", gsa = "Titel", hsa = "Beschrijving", vsa = "Apps-status", bsa = "Een korte videovergadering.", ysa = "Planning Type", $sa = "Bekijk team", wsa = "Collectief", ksa = "Plan vergaderingen wanneer alle geselecteerde teamleden beschikbaar zijn.", Ssa = "Looptijd", Esa = "Beschikbare duur", xsa = "Standaardduur", Csa = "Kies eerst de beschikbare duur", Tsa = "{{count}} $t(minute_timeUnit)", Asa = "{{count}} $t({{unit}}_timeUnit)", Isa = "{{count}}$t({{unit}}_short)", Osa = "Minuten", Nsa = "Gebruik Cal.ai om een AI-gestuurd telefoonnummer te krijgen of om oproepen te doen naar gasten.", zsa = "Beëindigings-URI", Rsa = "SIP Trunk gebruikersnaam", Psa = "SIP Trunk wachtwoord", Dsa = "Bijnaam", Lsa = "Telefoonnummer verwijderen", Msa = "Workflow-validatie mislukt", Fsa = "Een of meer workflow-stappen hebben lege berichtinhoud", qsa = "Een of meer telefoonnummers of e-mailadressen zijn niet geverifieerd", jsa = "Versterk je workflows met Cal.ai", Vsa = "Levensechte AI-agenten die afspraken boeken, herinneringen sturen en opvolgen met je klanten.", Bsa = "Telefoonnummer succesvol geïmporteerd en gekoppeld aan agent", Usa = "Telefoonnummer succesvol verwijderd", Gsa = "Weet je zeker dat je dit telefoonnummer wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.", Wsa = "Ja, verwijder telefoonnummer", Hsa = "Het nummer dat je probeert te importeren moet in E.164-formaat zijn (+landcode gevolgd door het nummer, zonder spaties of speciale tekens), bijv. +1234567890", Ysa = "De beëindigings-URI om je elastische SIP-trunk uniek te identificeren. Dit wordt gebruikt voor uitgaande gesprekken. Voor Twilio elastische SIP-trunks eindigt het altijd met .pstn.twilio.com.", Ksa = "De gebruikersnaam die wordt gebruikt om de SIP-trunk te authenticeren.", Zsa = "Het wachtwoord dat wordt gebruikt om de SIP-trunk te authenticeren.", Xsa = "Bijnaam van het nummer. Dit is alleen voor je eigen referentie.", Jsa = "Opslaan en testgesprek", Qsa = "Gesprek succesvol gestart", eca = "Voer een telefoonnummer in", tca = "Agent succesvol bijgewerkt", nca = "Agent succesvol aangemaakt", oca = "Evenementtype succesvol toegevoegd", rca = "Telefoonnummer succesvol afgemeld", ica = "Deze prompt definieert de rol en primaire doelstellingen van de agent", aca = "Prompt", sca = "Bellen naar", cca = "Maak een testgesprek om de configuratie te verifiëren", lca = "Eerste bericht", uca = "Het eerste bericht dat de agent zal zeggen bij het begin van een gesprek", dca = "Problemen met importeren?", _ca = "Leren", pca = "Leer hoe je je Termination URI en SIP-trunk inloggegevens kunt verkrijgen", mca = "Telefoonnummer-abonnement succesvol geannuleerd", fca = "Bijwerken", gca = "Round Robin", hca = "Hoi, hoe gaat het met je?", vca = "Afspraken wisselen tussen meerdere teamleden.", bca = "Beheerde gebeurtenis", yca = "gebruikersnaam", $ca = "Maak en distribueer gebeurtenistypen in bulk naar teamleden", wca = "Beheerd", kca = '"username" wordt gevuld met de gebruikersnaam van de toegewezen leden', Sca = "Toewijzen aan", Eca = "Voer telefoonnummer in voor testgesprek", xca = "Maak testgesprek", Cca = "Nieuwe workflow cal.ai spraakagent aanmaken", Tca = "Maak een nieuwe workflow cal.ai spraakagent om je workflows te automatiseren", Aca = "Telefoonnummer (voor onze agent om te bellen)", Ica = "Koop een telefoonnummer of importeer er een die je al hebt bij Twilio", Oca = "Test agent", Nca = "Test webgesprek", zca = "Telefoonnummers", Rca = "Afmelden", Pca = "Workflow-stap verwijderen", Dca = "Telefoonnummer afmelden", Lca = "Koop een nieuw nummer", Mca = "Je kunt alleen Amerikaanse telefoonnummers kopen. Voor andere landen kun je je eigen Twilio-telefoonnummer importeren.", Fca = "Koop een Amerikaans nummer voor ${{priceInDollars}} per maand", qca = "Ondersteunde belbestemmingen", jca = "Geen telefoonnummer verbonden", Vca = "Ophalen van werkstroom-stap ID mislukt", Bca = "Cal.ai Agent", Uca = "Test Cal.ai Agent", Gca = "Weet u zeker dat u deze werkstroomstap wilt verwijderen?", Wca = "Wilt u het telefoonnummer nog steeds afmelden bij deze agent?", Hca = "Deze actie zal het telefoonnummer loskoppelen van de agent. De agent kan geen oproepen meer maken totdat er een nieuw telefoonnummer is verbonden.", Yca = "Telefoonnummers", Kca = "Telefoonnummer verbinden", Zca = "Beheer je telefoonnummers", Xca = "Nummer importeren", Jca = "Deze actie zal ook:", Qca = "Telefoonnummer importeren", ela = "Actief abonnement", tla = "Uw telefoonnummerabonnement opzeggen", nla = "Het bijbehorende telefoonnummer verwijderen", ola = "U bent niet gemachtigd om deze werkstroom aan te maken", rla = "Importeer je Twilio-telefoonnummer om te gebruiken met Telefoon", ila = "${{price}}/maand", ala = "Nieuw nummer kopen", sla = "Een telefoonnummer kopen kost ${{priceInDollars}} per maand. U wordt maandelijks gefactureerd voor elk actief telefoonnummer.", cla = "Netnummer (optioneel)", lla = "Geen telefoonnummers", ula = "Telefoonnummer succesvol aangeschaft", dla = "Telefoonnummer-abonnement opzeggen", _la = "Ja, abonnement opzeggen", pla = "Weet u zeker dat u dit telefoonnummer-abonnement wilt opzeggen? Deze actie kan niet ongedaan worden gemaakt en u verliest toegang tot dit telefoonnummer.", mla = "Leden toevoegen...", fla = "Leden toevoegen", gla = "Geen toegewezen leden", hla = "Toegewezen aan", vla = "Je moet ingelogd zijn op {{url}}", bla = "Begin met het toewijzen van leden hierboven", yla = "Leden kunnen dit niet bewerken", $la = "Leden kunnen bewerken", wla = "Deze optie is vergrendeld door de teambeheerder", kla = "Vrijgegeven door teambeheerder", Sla = "Link", Ela = "Verborgen", xla = "Enkel-lezen", Cla = "Eenmalige link", Tla = "U heeft momenteel het {{plan}}-abonnement.", Ala = "Upgrade uw account naar het Pro-abonnement om alle functies te ontgrendelen die we te bieden hebben.", Ila = "U moet uw abonnement upgraden om meer dan één actief afspraaktype te hebben.", Ola = "U moet uw abonnement upgraden om een team aan te maken.", Nla = "U kunt <1>hier upgraden</1>.", zla = "Evenementen", Rla = "Maak deelbare evenementen die bezoekers kunnen gebruiken om afspraken in uw agenda te boeken.", Pla = "Nieuw evenement", Dla = "Maak uw eerste evenement aan", Lla = "Evenementen stellen u in staat om links te delen die beschikbare tijden tonen op uw agenda en bezoekers hiervan kunnen deze gebruiken om afspraken te maken.", Mla = "{{eventTypeTitle}} evenement met succes aangemaakt", Fla = "Evenement is bijgewerkt", qla = "Evenement is verwijderd", jla = "Uren", Vla = "Mensen", Bla = "Uw E-mailadres", Ula = "Wijzig avatar", Gla = "Avatar uploaden", Wla = "Taal", Hla = "Tijdzone", Yla = "Eerste dag van de week", Kla = "Wordt tot {{count}} keer herhaald", Zla = "Wordt tot {{count}} keer herhaald", Xla = "Elke {{freq}} gedurende", Jla = "{{count}} gebeurtenis resterend", Qla = "{{count}} gebeurtenissen resterend", eua = "Wordt herhaald om de", tua = "herhaling", nua = "keer", oua = "week", rua = "weken", iua = "maand", aua = "maanden", sua = "jaar", cua = "jaar", lua = "Nog {{count}}", uua = "Max.", dua = "Enkel Thema", _ua = "Merkkleur", pua = "Merkkleur (licht thema)", mua = "Merkkleur (donker thema)", fua = "Kleur van evenementtype (Licht Thema)", gua = "Kleur van evenementtype (Donker Thema)", hua = "Bestandsnaam is niet [idOrSlug]/[user]", vua = "Team aanmaken", bua = "Naam", yua = "Naamloos team", $ua = "OAuth-clients", wua = "Beheer OAuth-clients voor uw organisatie", kua = "OAuth-client aanmaken", Sua = "Maak een nieuwe OAuth-client voor integraties met derden", Eua = "OAuth-client succesvol verwijderd", xua = "Maak een nieuw team aan om met andere gebruikers samen te werken.", Cua = "Nieuw team aanmaken", Tua = "URL van je boekingspagina", Aua = "URL van de pagina waar je gebruikers hun boeking kunnen annuleren", Iua = "URL van de pagina waar je gebruikers hun boeking kunnen verzetten", Oua = "Dit tijdslot is niet meer beschikbaar. Ga terug naar de vorige pagina en kies een andere tijd.", Nua = "Openstaande uitnodigingen", zua = "Nieuw Team", Rua = "Maak uw eerste team en nodig andere gebruikers uit om samen te werken.", Pua = "Maak een team aan om aan de slag te gaan", Dua = "Teams", Lua = "Team", Mua = "Organisatie", Fua = "Teamfacturatie", qua = "Beheer de facturering voor uw team", jua = "We hebben het factureren gewijzigd voor teams", Vua = "Er zijn leden in uw team zonder een plaats. Upgrade uw Pro-abonnement om de ontbrekende plaatsen te dekken.", Bua = "Vanaf januari 2022 rekenen we per plaats voor teamleden. Leden van uw team die Pro gratis hadden, hebben nu een proefperiode van 14 dagen. Zodra hun proefperiode afloopt, worden deze leden verborgen voor uw team, tenzij u nu upgradet.", Uua = "Maak en beheer teams om gezamenlijke functies te gebruiken.", Gua = "Deze functie is alleen beschikbaar in het Pro-pakket", Wua = "Om de {{appName}} branding van uw boekpagina's te verwijderen, moet u upgraden naar een Pro-account.", Hua = "Bewerk profielgegevens die worden weergegeven op uw boekpagina.", Yua = "U moet zich mogelijk afmelden en weer aanmelden voordat de wijziging ingaat.", Kua = "Een introductie over uzelf.", Zua = "Profiel bijgewerkt", Xua = "Uw profiel is is met succes bijgewerkt.", Jua = "Je upgrade is beschikbaar", Qua = "Verbeter je planningservaring door te upgraden naar het nieuwe plan en geniet van de nieuwe functies.", eda = "Je bent helemaal klaar", tda = "Je gebruikt al het nieuwste plan. Geen upgrade nodig. Geniet van de nieuwe functies en neem contact met ons op als je vragen hebt!", nda = "Gebruiker lijkt ingelogd maar kan niet gevonden worden in de db", oda = "Insluiten & Webhooks", rda = "Ingeschakeld", ida = "Uitgeschakeld", ada = "Uitschakelen", sda = "Abonnement", cda = "hier", lda = "Beheer uw betalingsgegevens en annuleer uw abonnement.", uda = "Beschikbaarheid", dda = "Beschikbaarheid bewerken", _da = "Configureer tijden wanneer u beschikbaar bent voor afspraken.", pda = "Tijden kopiëren naar", mda = "Tijden kopiëren naar …", fda = "Verander uw weekschema", gda = "Logo", hda = "Foutmelding", vda = "Voer minimaal één teken in", bda = "Voer minimaal {{count}} tekens in", yda = "Team Logo", $da = "Een locatie toevoegen", wda = "Deelnemers", kda = "Deelnemers toevoegen", Sda = "Toon geavanceerde instellingen", Eda = "Geavanceerde instellingen verbergen", xda = "Naam van evenement", Cda = "Gebeurtenisnaam in agenda", Tda = "De naam die in kalenders wordt weergegeven", Ada = "Afspraak met {{attendeeName}}", Ida = "Extra invoer", Oda = "Planner vereist om extra gegevens in te voeren voordat de boeking wordt bevestigd", Nda = "Omschrijving", zda = "Plaatsaanduiding", Rda = 'Gebruik "Toevoegen aan kalender"-e-mail als organisator', Pda = "We tonen dit e-mailadres als organisator en sturen hier bevestigingsmails naartoe.", Dda = 'Als ingeschakeld, tonen we het e-mailadres van je "Toevoegen aan kalender" als organisator en sturen we hier bevestigingsmails naartoe.', Lda = "Let op dat je mogelijk je 'Toevoegen aan kalender'-account moet loskoppelen en opnieuw verbinden om deze functie te gebruiken.", Mda = "Type", Fda = "Wijzigen", qda = "Voeg een invoer toe", jda = "Notities verbergen in kalender", Vda = "Om privacyredenen worden extra invoer en notities verborgen in het kalenderitem. Ze worden nog wel naar uw e-mail verzonden.", Bda = "De boeking moet handmatig bevestigd worden voordat deze naar de integraties wordt gepusht en een bevestigings-e-mail wordt verzonden.", Uda = "Onbevestigde boekingen blokkeren nog steeds de kalender slots.", Gda = "Terugkerende gebeurtenis", Wda = "Mensen kunnen zich abonneren op terugkerende gebeurtenissen", Hda = "Verbind en doe mee", Yda = "Het kan niet worden gebruikt met betaalde evenementtypes", Kda = "Directe Vergaderingen worden nog niet ondersteund met terugkerende evenementen en betalingsapps", Zda = "Experimenteel: Instant Meeting Events zijn momenteel experimenteel.", Xda = "Vanaf", Jda = "Gasten uitschakelen", Qda = "Schakel toevoegen van extra gasten uit tijdens het boeken.", e_a = "Privélink genereren", t_a = "Privé-URL inschakelen", n_a = "Privélink", o_a = "Uw privélink wordt na elk gebruik opnieuw gegenereerd", r_a = "Privélink kopiëren", i_a = "Kopieer privélink naar evenement", a_a = "Genereer een privé-URL om te delen zonder uw {{appName}}-gebruikersnaam te onthullen", s_a = "Privélinks", c_a = "Genereer privé-URL's zonder de gebruikersnaam bloot te geven, met configureerbare verval- en gebruikslimieten", l_a = "Nieuwe link toevoegen", u_a = "Privélink gekopieerd", d_a = "Genodigden kunnen plannen", __a = "Date Range", p_a = "kalender dagen", m_a = "werkdagen", f_a = "Een adres of plaats instellen", g_a = "Stel een link in naar de vergadering", h_a = "Kan niet worden in- of uitgeschakeld. Kan alleen worden ontgrendeld voor subgebeurtenistypen", v_a = "{{appName}} zal de genodigde om een telefoonnummer vragen.", b_a = "{{appName}} zal een Google Meet meeting-URL meegeven in de afspraak bevestiging.", y_a = "{{appName}} zal een Zoom meeting-URL meegeven in de afspraak bevestiging.", $_a = "{{appName}} zal een Tandem meeting-URL meegeven in de afspraak bevestiging.", w_a = "{{appName}} zal een Daily meeting-URL meegeven in de afspraak bevestiging.", k_a = "{{appName}} zal een Jitsi Meet meeting-URL meegeven in de afspraak bevestiging.", S_a = "{{appName}} zal een Huddle01 meeting-URL meegeven in de afspraak bevestiging.", E_a = "{{appName}} geeft een vergaderings-URL voor MS Teams. OPMERKING: MOET EEN WERK- OF SCHOOLACCOUNT HEBBEN", x_a = "Betaling vereisen", C_a = "U moet een naam toevoegen", T_a = "commissie per transactie", A_a = "Uw evenement is met succes bijgewerkt.", I_a = "Verberg evenement", O_a = "Locatie wijzigen", N_a = "in de toekomst", z_a = "Wanneer geboekt met minder dan <0></0> vooraf", R_a = "Binnen een datumbereik", P_a = "Voor onbepaalde tijd", D_a = "Nieuw invoerveld toevoegen", L_a = "Kort Gesprek", M_a = "Een nieuw type vergadering toevoegen", F_a = "Een nieuw type afspraak toevoegen", q_a = "Maak een nieuw afspraak type voor bezoekers om tijden mee te reserveren.", j_a = "Lengte", V_a = "Minimale kennisgevingstermijn", B_a = "Verschuiving begintijden", U_a = "Verschuif de aan boekers weergegeven tijdslots met een opgegeven aantal minuten", G_a = "Verschuiven met", W_a = "dit geeft bijvoorbeeld tijdslots aan uw boekers weer op {{ adjustedTime }} in plaats van {{ originalTime }}", H_a = "Tijdslot intervallen", Y_a = "Gebruik evenement lengte (standaard)", K_a = "Gebeurtenistype verwijderen?", Z_a = "Type beheerde gebeurtenis verwijderen?", X_a = "Iedereen met wie u deze link hebt gedeeld, kan niet meer boeken via deze link.", J_a = "Leden die aan dit evenementtype zijn toegewezen, zullen ook hun evenementtypes verwijderd zien worden.", Q_a = "Iedereen met wie ze hun link hebben gedeeld, zal deze niet meer kunnen gebruiken om te boeken.", epa = "Ja, verwijderen", tpa = "Account verwijderen", npa = "Ja, account verwijderen", opa = "Iedereen met wie u uw accountlink gedeeld heeft, kan er niet meer mee boeken en alle voorkeuren die u opgeslagen heeft gaan verloren.", rpa = "Integraties", ipa = "Apps", apa = "Hier vindt u een lijst van uw apps", spa = "App-beschrijving", cpa = "apps voor {{category}}", lpa = "App Store", upa = "Mensen, technologie en de werkplek verbinden.", dpa = "Verbind uw videovergaderapp", _pa = "Instellingen", ppa = "Gebeurtenistype is verplaatst", mpa = "Volgende stap", fpa = "Stap overslaan", gpa = "Vorige stap", hpa = "Installeren", vpa = "Start gratis proefperiode", bpa = "Geinstalleerd", ypa = "{{count}} actieve installatie", $pa = "{{count}} actieve installaties", wpa = "Wereldwijd geïnstalleerd", kpa = "De app is geïnstalleerd", Spa = "De app kon niet geïnstalleerd worden", Epa = "Ontkoppelen", xpa = "Voeg {{appName}} toe aan uw webpagina", Cpa = "Koppel je favoriete apps.", Tpa = "Automatisering", Apa = "Stel in hoe uw evenementen met uw agenda wilt verbinden.", Ipa = "Schakel de agenda's in die u wilt controleren op conflicten om dubbele boekingen te voorkomen.", Opa = "Extra agenda kopppelen", Npa = "Agenda bijgewerkt", zpa = "Controleer hier", Rpa = "Confereren", Ppa = "Agenda", Dpa = "Betalingen", Lpa = "Niet geïnstalleerd", Mpa = "Wachtwoorden komen niet overeen.", Fpa = "Dit veld is verplicht.", qpa = "Status", jpa = "Beschikbaarheid van gebruikers weergeven", Vpa = "Gebruiker moet de uitnodiging accepteren om beschikbaarheid weer te geven", Bpa = "Zet uzelf op afwezig", Upa = "Status afwezig uitschakelen", Gpa = "Fout bij het bijwerken van de status afwezig", Wpa = "Deze gebruiker is momenteel afwezig.", Hpa = "De persoon die u probeert te boeken heeft zichzelf op afwezig gezet en accepteert dus geen nieuwe boekingen.", Ypa = "Ontmoet mensen met dezelfde tokens", Kpa = "Boek alleen en laat boekingen toe van mensen die dezelfde tokens,, DAO's of NFT's delen.", Zpa = "Uw account is aangemaakt met behulp van een identiteitsprovider.", Xpa = "Uw account wordt beheerd door {{provider}}", Jpa = "Ga naar uw accountinstellingen bij {{provider}} om uw e-mailadres en wachtwoord te wijzigen, tweestapsverificatie in te schakelen en meer.", Qpa = "Je account wordt beheerd door een andere identiteitsprovider. Probeer in te loggen met {{provider}}.", ema = "Fout bij het aanmaken van een nieuwe gebruiker. Probeer het opnieuw.", tma = "Aanmelden met Google", nma = "Aanmelden met SAML", oma = "Aanmelden met SAML/OIDC", rma = "Doorgaan met e-mail", ima = "Doorgaan met Google", ama = "Laatst gebruikt", sma = "U moet een toegangstoken genereren van uw oude planningstool.", cma = "Importeren van", lma = "Toegangstoken", uma = "Routekaart", dma = "Uitgelichte categorieën", _ma = "Functievlaggen", pma = "Hier kunt u de functies van uw Cal.com-instantie in- en uitschakelen.", mma = "Populaire categorieën", fma = "{{count}} app", gma = "{{count}} apps", hma = "Trending apps", vma = "Meest populair", bma = "Geinstalleerde apps", yma = "Gratis", $ma = "Geen apps voor {{category}}", wma = "Alle apps", kma = "Voeg een agenda-app toe om te controleren op conflicten om dubbele boekingen te voorkomen", Sma = "Probeer een conferentieapp toe te voegen voor videogesprekken met uw klanten", Ema = "Voeg een betaalapp toe om transacties tussen u en uw klanten te vergemakkelijken", xma = "Voeg een analyse-app toe aan uw boekingspagina's", Cma = "Voeg een automatiseringsapp toe om te gebruiken", Tma = "Voeg een ander type app toe om allerlei soorten dingen te doen", Ama = "Voeg een berichtenapp toe om aangepaste meldingen en herinneringen in te stellen", Ima = "Voeg een CRM-app toe om bij te houden met wie u heeft ontmoet", Oma = "Stel de agenda('s) in om te controleren op conflicten om dubbele boekingen te voorkomen.", Nma = "Configureer welke betalingsverwerkingsdiensten u wilt gebruiken bij het factureren aan uw klanten.", zma = "Configureer welke analyse-apps moeten worden gebruikt voor uw boekingspagina's", Rma = "Alle geïnstalleerde apps uit andere categorieën.", Pma = "Configureer welke conferentieapps moeten worden gebruikt", Dma = "Configureer welke automatiseringsapps moeten worden gebruikt", Lma = "Configureer welke berichtenapps moeten worden gebruikt voor het instellen van aangepaste meldingen en herinneringen", Mma = "Configureer welke CRM-apps moeten worden gebruikt voor het bijhouden van wie u hebt ontmoet", Fma = "Analyse", qma = "Geen apps geïnstalleerd", jma = "Met apps kunt u uw workflow en uw planning aanzienlijk verbeteren.", Vma = "Bladeren in App Store", Bma = "Beheer uw geïnstalleerde apps of wijzig instellingen", Uma = "Door apps bladeren", Gma = "Functies", Wma = "Machtigingen", Hma = "Voorwaarden en privacy", Yma = "Gepubliceerd door {{author}}", Kma = "Abonneren", Zma = "Kopen", Xma = "App installeren", Jma = "Categorieën", Qma = "Prijzen", efa = "Meer informatie", tfa = "Nu proberen", nfa = "Privacybeleid", ofa = "Gebruiksvoorwaarden", rfa = "Verwijderen", ifa = "Toevoegen", afa = "{{count}} keer geïnstalleerd", sfa = "Wallet verifiëren", cfa = "Maak gebeurtenissen aan in de", lfa = "Dit is een commerciële functie", ufa = "Je kunt deze functie lokaal testen, maar niet in productie.", dfa = "Neem contact op met ons verkoopteam om een commerciële licentie aan te schaffen. Als er al een licentiesleutel aanwezig is, neem dan contact op met support@cal.com voor hulp.", _fa = "Ontbrekende licentie", pfa = "Volgende stappen", mfa = "Verkrijg een commerciële licentie", ffa = "Het infrastructuurabonnement is gebaseerd op gebruik en heeft speciale kortingen voor start-ups.", gfa = "Maak een account aan via Prisma Studio", hfa = "Leer hoe u uw eerste gebruiker instelt", vfa = "Contact met Sales", bfa = "Fout 404", yfa = "Als standaard instellen", $fa = "Nieuwe planning", wfa = "Voeg een nieuwe planning toe", kfa = "Voeg een nieuwe agenda toe", Sfa = "Stel in waar nieuwe gebeurtenissen worden toegevoegd wanneer u boekt.", Efa = "Planning verwijderen", xfa = "Het verwijderen van een planning verwijdert deze uit alle gebeurtenistypen. Deze actie kan niet ongedaan worden gemaakt.", Cfa = "Planning {{scheduleName}} aangemaakt", Tfa = "Beschikbaarheid bijgewerkt", Afa = "Planning verwijderd", Ifa = "Werktijden", Ofa = "Beschikbaarheidsschema aanmaken", Nfa = "Door beschikbaarheidsschema's te maken kunt u de beschikbaarheid beheren voor verschillende gebeurteenistypes. Ze kunnen worden toegepast op één of meer gebeurtenistypes.", zfa = "Vereist eigendom van een token dat aan het volgende adres toebehoort:", Rfa = "Jan Pietersen", Pfa = "Tijdnotatie", Dfa = "Omleiding bij boeking ", Lfa = 'U wordt omgeleid naar {{ url }} over $t(seconde, {"count": {{seconden}} }).', Mfa = "https://example.com/redirect-to-my-success-page", Ffa = "Leid door naar een aangepaste URL na een geslaagde boeking", qfa = "Dupliceren", jfa = "Plaatsen aanbieden", Vfa = "Bied beschikbare plaatsen aan voor boekingen. Hiermee worden gastboekingen en aanmeldingsboekingen automatisch uitgeschakeld.", Bfa = "Plaats beschikbaar", Ufa = "Plaatsen beschikbaar", Gfa = "Plaatsen bijna vol", Wfa = "Plaatsen raken snel vol", Hfa = "Aantal plaatsen per boeking", Yfa = "Stel vergaderingsvenster in (seconden): De tijdsperiode in seconden waarin de host de vergadering kan joinen en starten. Na deze periode verloopt de join-URL van de vergadering.", Kfa = "Voer het aantal plaatsen in", Zfa = "U kunt uw schema's beheren op de beschikbaarheidspagina.", Xfa = "Geen plaatsen meer beschikbaar", Jfa = "API-sleutels", Qfa = "API-sleutel", ega = "API-sleutel testen", tga = "Test gelukt!", nga = "Test mislukt", oga = "API-sleutel verstrekken", rga = "Met API-sleutels kunt API-aanroepen naar uw eigen account doen.", iga = "Maak in plaats daarvan een marktplaats of platform.", aga = "Genereer API-sleutels voor toegang tot uw eigen account.", sga = "Maak een API-sleutel aan", cga = "Geef deze sleutel een naam", lga = "Bijvoorbeeld Ontwikkeling", uga = "Naamloze API-sleutel", dga = "Deze API-sleutel heeft geen verloopdatum", _ga = "API-sleutel bewerken", pga = "API-sleutel aangemaakt", mga = "API-sleutel bijgewerkt", fga = "Aanmaken", gga = "Sla deze API-sleutel ergens veilig op.", hga = "U kunt hem niet opnieuw bekijken zodra u dit venster sluit.", vga = "Naar klembord kopiëren", bga = "Ingeschakeld na update", yga = "De privélink werkt na opslaan", $ga = "Deze API-sleutel intrekken", wga = "Herschikken uitschakelen", kga = "Gasten kunnen het evenement niet meer herschikken via de kalenderuitnodiging of e-mail", Sga = "Boeken via herplanningslink toestaan", Ega = "Indien ingeschakeld, kunnen gebruikers een nieuwe boeking maken wanneer ze proberen een geannuleerde boeking te verzetten", xga = "Annuleren uitschakelen", Cga = "Gasten kunnen het evenement niet meer annuleren via de kalenderuitnodiging of e-mail", Tga = "API-sleutel intrekken", Aga = "API-sleutel gekopieerd!", Iga = "De API-sleutel verloopt op", Oga = "Deze API-sleutel permanent van uw account verwijderen?", Nga = "Kopiëren", zga = "Verloopdatum", Rga = "Verlopen", Pga = "Verloopt nooit", Dga = "Verloopt", Lga = "Aanvraag om uw boeking te verplaatsen", Mga = "Reden voor verplaatsen", Fga = "Boek een nieuwe tijd", qga = "Verplaatsingsaanvraag verzonden", jga = "Hierdoor wordt de geplande vergadering geannuleerd, wordt de planner geïnformeerd en wordt hem/haar gevraagd een nieuwe tijd te kiezen.", Vga = "Reden voor verplaatsingsaanvraag", Bga = "Verplaatsing aanvragen ", Uga = "Boeking bewerken", Gga = "Boeking verplaatsen", Wga = "Vorige tijd", Hga = "Voeg een GIF toe aan uw bevestigingspagina", Yga = "Zoeken", Kga = "Imiteren", Zga = "Imitatie van gebruiker", Xga = "Hiermee kan ons ondersteuningsteam tijdelijk als u inloggen zodat we eventuele problemen die u aan ons meldt snel op kunnen lossen.", Jga = "Hiermee kunnen uw teamleden zich tijdelijk aanmelden als u.", Qga = "Gratis voor individuen. Teamplannen voor samenwerkingsfuncties.", eha = "Maak organisatie privé", tha = "Je organisatieleden kunnen andere organisatieleden niet zien wanneer dit is ingeschakeld.", nha = "Team privé maken", oha = "Uw teamleden kunnen geen andere teamleden zien wanneer dit ingeschakeld is.", rha = "U kunt niet alle teamleden van een privéteam zien.", iha = "Je kunt de teams van een privéorganisatie niet zien.", aha = "Meerdere tijdsduren toestaan", sha = "Alle gebruik van deze functie wordt gecontroleerd.", cha = 'Gebruikersnaam "{{user}}" wordt geïmiteerd.', lha = "Klik hier om te stoppen", uha = "Bijgewerkt - de locatie van uw gebeurtenis is gewijzigd", dha = "Toegevoegd - Nieuwe gasten toegevoegd aan je evenement", _ha = "Locatie gewijzigd: {{eventType}} met {{name}} op {{date}}", pha = "Gasten Toegevoegd: {{eventType}} met {{name}} op {{date}}", mha = "Huidige locatie", fha = "Nieuwe locatie", gha = "Sessie", hha = "Beheer uw accountsessie", vha = "Sessietime-out na", bha = "Sessietime-out", yha = "Maak uw sessie ongeldig na een bepaalde tijd.", $ha = "Geen locatie bepaald", wha = "Locatie instellen", kha = "Locatie bijwerken", Sha = "Locatie bijgewerkt", Eha = "Locatie-update mislukt", xha = "Gasten toegevoegd", Cha = "Kan geen gasten toevoegen", Tha = "Dat lijkt niet op een e-mailadres", Aha = "E-mails moeten uniek en geldig zijn", Iha = "Dat lijkt niet op een URL", Oha = "Plaats deze code in uw HTML op de plaats waar u uw {{appName}}-widget wilt hebben.", Nha = "Maak een bestaande React-component of werk deze bij, zoals hieronder weergegeven.", zha = "Code kopiëren", Rha = "Code gekopieerd!", Pha = "Hoe wilt u {{appName}} aan uw website toevoegen?", Dha = "Kies een van de volgende manieren om {{appName}} op uw website te plaatsen.", Lha = "Uw Zapier-integratie configureren", Mha = "Uw Make-integratie configureren", Fha = "API-sleutel genereren", qha = "Genereer een API-sleutel die gebruikt moet worden met {{appName}} op", jha = "Uw unieke API-sleutel", Vha = "Kopieer deze API-sleutel en sla deze ergens veilig op. Als u deze sleutel verliest, moet u een nieuwe genereren.", Bha = "<0>Meld u aan op uw Zapier-account en maak een nieuwe Zap.</0><1>Selecteer {{appName}} als uw activatie-app. Kies ook een activatiegebeurtenis.</1><2>Kies uw account en voer vervolgens uw unieke API-sleutel in.</2><3>Test uw activatie.</3><4>U bent er klaar voor!</4>", Uha = "Ga naar <0>Make Uitnodigingslink</0> en installeer de Cal.com app.", Gha = "Log in op je Make account en maak een nieuw scenario.", Wha = "Selecteer Cal.com als je trigger-app. Kies ook een trigger-gebeurtenis.", Hha = "Kies je account en voer vervolgens je unieke API-sleutel in.", Yha = "Test je trigger.", Kha = "Je bent klaar!", Zha = "Installeer eerst de Zapier-app in de App Store.", Xha = "Installeer eerst de Make-app uit de appstore.", Jha = "App-installatie", Qha = "App niet geïnstalleerd", eva = "Sorry, deze app is niet geïnstalleerd op je account. Bezoek onze app store om deze en andere geweldige apps te ontdekken.", tva = "Verbinding maken met Apple Server", nva = "Agenda-URL", ova = "Genereer een appspecifiek wachtwoord voor gebruik met {{appName}} op", rva = "Kan deze Apple Calendar-account niet toevoegen. Zorg ervoor dat je een app-specifiek wachtwoord gebruikt in plaats van je accountwachtwoord.", iva = "Uw inloggegevens worden opgeslagen en versleuteld.", ava = "Deze wordt opgeslagen en versleuteld.", sva = "Naar App Store", cva = "Probeer uw agenda opnieuw te verbinden met alle benodigde machtigingen", lva = "Stel een telefoonnummer in voor de afspraak", uva = "Er zijn geen drukke tijdvakken", dva = "Weergeven op boekingspagina", _va = "De locatie is zichtbaar voordat de boeking bevestigd wordt", pva = "GIF toevoegen", mva = "Giphy zoeken", fva = "Link van Giphy toevoegen", gva = "GIF toevoegen aan bevestigingspagina", hva = "Zoek een GIF om uw bevestigingspagina op te leuken", vva = "Feedback delen", bva = "Hulpmiddelen", yva = "Ondersteuningsdocumentatie", $va = "Ontwikkelaarsdocumentatie", wva = "Neem contact op", kva = "Neem contact op met de ondersteuning", Sva = "Premium Ondersteuning", Eva = "Ondersteuning door de community", xva = "Feedback", Cva = "Bedankt voor uw feedback!", Tva = "Fout bij verzenden van feedback", Ava = "Geef hier uw opmerkingen:", Iva = "Boekingsgegevens", Ova = "of", Nva = "Laat maar", zva = "Ga naar: ", Rva = "Zapier-uitnodigingslink", Pva = "Er wordt een afspraak-URL gemaakt zodra de gebeurtenis bevestigd is.", Dva = "Geef dynamisch de naam van uw deelnemer weer aan u of uw naam als het door uw deelnemer bekeken wordt", Lva = "Locatie gebeurtenis", Mva = "Reden voor verplaatsen (optioneel)", Fva = "Informeer anderen waarom u het moet verplaatsen", qva = "Deze gebeurtenis is geannuleerd", jva = "We hebben u en de andere deelnemers een e-mail gestuurd om hen te informeren.", Vva = "Deze invoer wordt getoond tijdens het boeken van dit evenement", Bva = "De vergader-URL wordt vermeld in de bevestigings-e-mail", Uva = "URL moet beginnen met http:// of https://", Gva = "Telefoonnummer wordt verstrekt", Wva = "voordat de gebeurtenis begint", Hva = "wanneer de gebeurtenis is geannuleerd", Yva = "Nadat hosts niet bij de cal video zijn gekomen", Kva = "Nadat gasten niet bij de cal video zijn gekomen", Zva = "Deelnemen aan de videogesprek", Xva = "Inloggen bij Cal.com", Jva = "Inloggen bij Cal.com", Qva = "Houd je afspraken bij, ontvang meldingen en beheer je agenda effectiever.", eba = "Volg je afspraken en beheer je agenda effectiever", tba = "Kon niet deelnemen aan het gesprek. Probeer het opnieuw.", nba = "Kies hoe je aan dit gesprek wilt deelnemen", oba = "Kies hoe je wilt verschijnen in het gesprek", rba = "wanneer een nieuwe gebeurtenis is geboekt", iba = "e-mail naar organisator versturen", aba = "e-mail naar deelnemers versturen", sba = "Sms verzenden naar deelnemer", cba = "sms naar een specifiek nummer sturen", lba = "Stuur eenvoudig vergaderherinneringen via sms naar uw deelnemers", uba = "WhatsApp-bericht naar een specifiek nummer versturen", dba = "WhatsApp-bericht naar deelnemer versturen", _ba = "Werkstromen", pba = "Nieuwe werkstroom", mba = "Hoe wil je beginnen?", fba = "Een nieuwe werkstroom toevoegen", gba = "wanneer de gebeurtenis verplaatst wordt", hba = "Activatie", vba = "Activaties", bba = "Actie", yba = "Maak werkstromen om meldingen en herinneringen te automatiseren", $ba = "Naam werkstroom", wba = "Aangepaste werkstroom", kba = "{{workflowName}} aangemaakt", Sba = "Weet u zeker dat u deze werkstroom wilt verwijderen?", Eba = "Werkstroom verwijderen", xba = "Ja, verwijder werkstroom", Cba = "Werkstroom verwijderd", Tba = "Hoelang voordat de gebeurtenis begint?", Aba = "dagen", Iba = "uur", Oba = "min.", Nba = "m", zba = "u", Rba = "Maak uw eerste werkstroom aan", Pba = "Met werkstromen kunt u het verzenden van herinneringen en meldingen automatiseren.", Dba = "Actief op", Lba = "Werkstroom {{workflowName}} bijgewerkt", Mba = "Dit is een standaard gebruikersnaam. Als u deze bijwerkt, gaat u naar facturering om te downgraden.", Fba = "Dit is een premium gebruikersnaam, koop de uwe voor {{price}}", qba = "Huidig", jba = "premium", Vba = "standaard", Bba = "Bevestig wijziging gebruikersnaam", Uba = "Omdat je van een standaard naar een premium gebruikersnaam verandert, word je naar de kassa geleid om te upgraden.", Gba = "Omdat je van een premium naar een standaard gebruikersnaam verandert, word je naar de kassa geleid om te downgraden.", Wba = "Naar facturatie", Hba = "Vereis betaling voor boekingen (0,5% en € 0,10 provisie per transactie)", Yba = "Uw proefperiode is verlopen", Kba = "App verwijderen", Zba = "Ja, verwijder app", Xba = "Weet u zeker dat u deze app wilt verwijderen?", Jba = "De app is verwijderd", Qba = "Fout bij het verwijderen van de app", eya = "Webconferentie", tya = "Webgesprek", nya = "Start webgesprek", oya = "Gesprek beëindigen", rya = "Test je agent met een webgesprek zonder dat een telefoonnummer nodig is", iya = "Telefoongesprek", aya = "Verbinding maken met agent...", sya = "Gesprek actief", cya = "Gesprek beëindigd", lya = "Gespreksfout", uya = "Klaar om gesprek te starten", dya = "Webgesprek starten mislukt. Probeer het opnieuw.", _ya = "Er is een fout opgetreden tijdens het gesprek. Probeer het opnieuw.", pya = "Initialiseren van webgesprek mislukt. Zorg ervoor dat microfoonrechten zijn toegestaan.", mya = "Start een gesprek om de conversatie te zien", fya = "Wachten op conversatie...", gya = "AI-agent", hya = "Live", vya = "Verbinding maken...", bya = "Vereist bevestiging", yya = "Vereist bevestiging indien geboekt met < {{time}} $t({{unit}}_timeUnit) kennisgeving", $ya = "Kan bevestiging vereisen", wya = "{{count}} gebeurtenistype", kya = "{{count}} gebeurtenistypen", Sya = "{{count}} team", Eya = "{{count}} teams", xya = "Actie toevoegen", Cya = "Whereby-link instellen", Tya = "Voer een geldige Whereby-link in", Aya = "Around.Co-link instellen", Iya = "Voer een geldige Around.Co-link in", Oya = "Riverside-link instellen", Nya = "Voer een geldige Riverside-link in", zya = "Voer een geldige Ping.gg-link in", Rya = "Verbinding maken met Exchange 2013 Server", Pya = "Verbinding maken met Exchange 2016 Server", Dya = "Aangepast sjabloon", Lya = "E-mailtekst", Mya = "Tekstbericht", Fya = "Heeft u een specifiek probleem?", qya = "door onze documenten bladen", jya = "Kies een sjabloon", Vya = "Aangepast", Bya = "Herinnering", Uya = "Opnieuw gepland", Gya = "Opnieuw gepland door", Wya = "Oorspronkelijke boeking", Hya = "Voltooid", Yya = "Beoordeling", Kya = "Herinnering: {{eventType}} met {{name}} op {{date}}", Zya = "Wordt niet geactiveerd voor bestaande boekingen, omdat de gebruiker om zijn/haar telefoonnummer gevraagd wordt bij het boeken van de gebeurtenis.", Xya = "{{count}} minuut", Jya = "{{count}}m", Qya = "{{count}} minuten", e$a = "{{count}} uur", t$a = "{{count}}u", n$a = "{{count}} uur", o$a = "Ongeldige invoer", r$a = "We konden de {{location}} vergaderlink niet toevoegen aan je geplande evenement. Neem contact op met je genodigden of werk je agenda-evenement bij om de details toe te voegen. Je kunt ofwel <0>je locatie wijzigen op het evenementtype</0> of proberen <1>de app te verwijderen en opnieuw toe te voegen.</1>", i$a = "We konden uw <1>{{calendar}}</1> niet bijwerken. <2>Controleer uw agenda-instellingen of verwijder uw agenda en voeg uw agenda opnieuw toe </2>", a$a = "Naam deelnemer", s$a = "De volledige naam van de persoon die boekt", c$a = "Beschadigde integratie", l$a = "Er was een probleem met het toevoegen van een videolink", u$a = "Er was een probleem met het bijwerken van uw agenda", d$a = "Actief op {{count}} gebeurtenistype", _$a = "Actief op {{count}} gebeurtenistypen", p$a = "Actief in {{count}} team", m$a = "Actief in {{count}} teams", f$a = "Actief voor alle evenementtypen", g$a = "Actief in alle teams", h$a = "Geen actieve gebeurtenistypen", v$a = "Geen actieve teams", b$a = "Nieuwe deelnemer {{name}} op {{eventType}} om {{date}}", y$a = "Iemand heeft zichzelf toegevoegd aan een evenement", $$a = "Variabel", w$a = "Naam gebeurtenis", k$a = "Deelnemer", S$a = "Datum gebeurtenis", E$a = "Tijd gebeurtenis", x$a = "Naam organisator", C$a = "Om deze functie te gebruiken, moet u upgraden naar een Pro-account.", T$a = "Ongeldig telefoonnummer", A$a = "Ongeldige URL voor {{label}}. Voorbeeld-URL: {{sampleUrl}}", I$a = "Navigeren", O$a = "Openen", N$a = "Sluiten", z$a = "Upgraden", R$a = "Koop US-nummer voor {{priceInDollars}}$/maand", P$a = "Upgrade om toegang te krijgen tot opnames", D$a = "Opnames zijn alleen beschikbaar als onderdeel van ons teamsabonnement. Upgrade om te beginnen met het opnemen van uw gesprekken", L$a = "Upgrade naar Enterprise om een AI-agent telefoonnummer te genereren dat gasten kan bellen om afspraken in te plannen", M$a = "Opnames zijn onderdeel van het teamsabonnement", F$a = "Dit is een Team-functie. Upgrade naar Team om de beschikbaarheid van uw team te zien.", q$a = "Dit is een Team-functie. Upgrade naar Team om uw meldingen en herinneringen van gebeurtenissen te automatiseren met werkstromen.", j$a = "Op profiel tonen", V$a = "Insluiten", B$a = "Nieuwe gebruikersnaam", U$a = "Huidige gebruikersnaam", G$a = "Voorbeeld 1", W$a = "Voorbeeld 2", H$a = "Boekingsvraag-ID", Y$a = "Bedrijfsgrootte", K$a = "Waar heeft u hulp bij nodig?", Z$a = "Variabele indeling", X$a = "De abonnee-URL voor Webhook is al gedefinieerd", J$a = "Negeer alle speciale tekens van het label voor aanvullende invoer (gebruik alleen letters en cijfers) en gebruik hoofdletters voor alle letters en vervang spaties door onderstrepingstekens.", Q$a = "Hoe gebruik ik boekingsvragen als variabelen?", ewa = "Desktop-app downloaden", twa = "Ping-link instellen", nwa = "Tariefgrenswaarde overschreden", owa = "Als er iets gebeurt", rwa = "Er wordt een actie uitgevoerd", iwa = "Actie testen", awa = "Melding verzonden", swa = "Geen invoer", cwa = "Werkstroomactie testen", lwa = "Sms versturen", uwa = "Weet u zeker dat u een sms naar {{number}} wilt versturen?", dwa = "Geen standaard agenda verbonden", _wa = "U kunt uw agenda koppelen vanaf <1>hier</1>.", pwa = "Standaardagenda", mwa = "In profiel verbergen", fwa = "Configuratie gebeurtenis", gwa = "Geen beschikbaarheid gevonden in het schema", hwa = "Grenswaarden", vwa = "Hoe vaak u geboekt kunt worden", bwa = "Agenda-instellingen en meer...", ywa = "Geavanceerd", $wa = "Betalingen instellen voor evenement", wwa = "Gebeurtenisconfiguratie: voor meerdere duren is minimaal 1 optie vereist.", kwa = "Gebeurtenisconfiguratie: selecteer een geldige standaardduur.", Swa = "Reserveringslimieten moeten in oplopende volgorde zijn. [dag, week, maand, jaar]", Ewa = "Duurlimieten moeten in oplopende volgorde zijn. [dag, week, maand, jaar]", xwa = "Selecteer aan welke agenda u boekingen wilt toevoegen", Cwa = "Aangepaste gebeurtenisnaam", Twa = "Maak aangepaste gebeurtenisnamen om weer te geven op agendagebeurtenissen", Awa = "Onjuiste tweestapsverificatiecode", Iwa = "Op welk type gebeurtenis is dit van toepassing?", Owa = "Toepassen op alle, inclusief toekomstige evenementtypen", Nwa = "Toepassen op alle team- en gebruikersgebeurtenistypen", zwa = "Op welk team zal dit van toepassing zijn?", Rwa = "Werkstromen maken eenvoudige automatisering van het versturen van meldingen en herinneringen mogelijk, zodat u processen rond uw gebeurtenissen kunt opbouwen.", Pwa = "Dit is een interne instelling en heeft geen invloed op hoe de tijden worden weergegeven op de openbare boekingspagina's voor u of voor iemand die u boekt.", Dwa = "Maak een werkstroom", Lwa = "Doe dit", Mwa = "Uitschakelen", Fwa = "Inschakelen", qwa = "Geannuleerde boekingen kunnen niet opnieuw worden ingepland", jwa = "Instellingen bijgewerkt", Vwa = "Fout bij het bijwerken van de instellingen", Bwa = "Mijn persoonlijke {{appName}}-URL", Uwa = "Een korte introductie over uzelf. Dit wordt weergegeven op uw persoonlijke pagina.", Gwa = "Installatie voltooien en beginnen", Wwa = "Deze gebruiker heeft nog geen bio toegevoegd.", Hwa = "Bio", Ywa = "Account verwijderen", Kwa = "Weet u zeker dat u uw {{appName}}-account wilt verwijderen?", Zwa = "Verwijder mijn account", Xwa = "Begin van de week", Jwa = "Opnames", Qwa = "Opname", eka = "Veel plezier met plannen", tka = "Selecteer de agenda's die u wilt controleren op conflicten om dubbele boekingen te voorkomen.", nka = "Controleer op conflicten", oka = "Opnames weergeven", rka = "Controleer op opnames", ika = "Toevoegen van gebeurtenissen aan", aka = "Volg systeemvoorkeuren", ska = "Aangepaste merkkleuren", cka = "Pas uw eigen merkkleur aan op uw boekingspagina.", lka = "Pro", uka = 'Verwijdert alle {{appName}}-gerelateerde merken, zoals "Mogelijk gemaakt door {{appName}}".', dka = "Directe vergadering met {{name}}", _ka = "Profielafbeelding", pka = "Uploaden", mka = "Profielfoto toevoegen", fka = "Tokenadres", gka = "Blockchain", hka = "Oude wachtwoord", vka = "Uw nieuwe superveilige wachtwoord", bka = "Fout bij het bijwerken van het wachtwoord", yka = "Tweestapsverificatie", $ka = "Stel een herhalingsschema in", wka = "vandaag", kka = "Weergave", Ska = "Mijn account", Eka = "Algemeen", xka = "Agenda's", Cka = "Facturen", Tka = "Ingesloten opties", Aka = "Imitatie", Ika = "Instellingen voor imitatie van gebruiker beheren", Oka = "Recente identiteitsovernames", Nka = "Snel identiteit overnemen", zka = "Geen recente identiteitsovernames", Rka = "Gebruikers", Pka = "Gebruiker", Dka = "Beheer de instellingen van uw {{appName}}-profiel", Lka = "Hier vindt u een lijst met alle gebruikers", Mka = "Gebruikersbeschrijving", Fka = "Beheer de instellingen voor uw taal en tijdzone", qka = "Configureer hoe uw typen gebeurtenissen samenwerken met uw agenda's", jka = "Beheer de instellingen voor uw boekingsweergave", Vka = "Beheer uw favoriete apps voor videoconferenties voor uw vergaderingen", Bka = "Conferentieapp toevoegen", Uka = "Beheer de instellingen voor uw accountwachtwoorden", Gka = "Stel uw tweestapsverificatie in", Wka = "We hebben alleen wat basisinformatie nodig om uw profiel te kunnen configureren.", Hka = "Overslaan", Yka = "Doe dit later", Kka = "Bepaal de tijdvakken waarin u beschikbaar bent", Zka = "U kunt dit allemaal later aanpassen op de beschikbaarheidspagina.", Xka = "Verbind eerst een agenda", Jka = "Voltooi uw profiel", Qka = "U kunt meer agenda's toevoegen vanuit de App Store", e0a = "Conferentieapps koppelen", t0a = "Agenda-apps koppelen", n0a = "Betaalapps koppelen", o0a = "Koppel automatiseringsapps", r0a = "Koppel analyse-apps", i0a = "Andere apps koppelen", a0a = "Berichtenapps koppelen", s0a = "CRM-apps koppelen", c0a = "Stap {{currentStep}} van {{maxSteps}}", l0a = "Variabele toevoegen", u0a = "Aangepast telefoonnummer", d0a = "Berichtsjabloon", _0a = "E-mailonderwerp", p0a = "Voeg dynamische tekstvariabelen toe", m0a = "Naam van het type gebeurtenis", f0a = "De datum van de gebeurtenis", g0a = "De duur van het evenement", h0a = "De begintijd van de gebeurtenis", v0a = "EvenementType niet gevonden", b0a = "Te bellen nummer", y0a = "Het telefoonnummer van de gebruiker die je belt", $0a = "Locatie", w0a = "De locatie van de gebeurtenis", k0a = "Aanvullende notities", S0a = "De aanvullende opmerkingen bij de boeking", E0a = "De naam van de persoon die boekt", x0a = "Naam van de organisator", C0a = "Aan", T0a = "De werkstroom {{workflowName}} is {{offOn}}", A0a = "Reacties downloaden", I0a = "Download alle reacties op uw formulier in CSV-indeling.", O0a = "Reacties bekijken", N0a = "Downloaden", z0a = "Bezig met downloaden", R0a = "Opname downloaden", P0a = "Transcripties zijn nu ingeschakeld", D0a = "Transcripties zijn nu gestopt", L0a = "Transcriptie downloaden", M0a = "Transcript", F0a = "Een opname van uw recente gesprek op {{appName}} is klaar om te downloaden", q0a = "Transcriptie van uw recente gesprek op {{appName}} is klaar om te downloaden. Links zijn slechts 1 uur geldig", j0a = "Je kunt het transcript ook downloaden via de bijlagen", V0a = "Opmerking: De downloadlink is slechts 12 uur geldig. U kunt een nieuwe downloadlink genereren door de instructies <1>hier</1> te volgen.", B0a = "Opmerking: De downloadlink is slechts 12 uur geldig. Je kunt een nieuwe downloadlink genereren door de instructies te volgen.", U0a = "Maak uw eerste formulier", G0a = "Met routeringsformulieren kunt u kwalificerende vragen stellen en doorverwijzen naar de juiste persoon of het juiste type gebeurtenis.", W0a = "Maak uw eerste webhook", H0a = "Met Webhooks kunt u in realtime vergadergegevens ontvangen wanneer er iets gebeurt in {{appName}}.", Y0a = "Voor maximaal", K0a = "gebeurtenis", Z0a = "gebeurtenissen", X0a = "Beheer de instellingen van uw teamprofiel", J0a = "Beheer de instellingen van uw organisatieprofiel", Q0a = "Gebruikers in de groep", e1a = "Beheer de beheerders en leden in uw organisatie", t1a = "Team-URL", n1a = "Teamleden", o1a = "Meer", r1a = "Cal.ai Workflows", i1a = "en nog {{count}}", a1a = "We zien de mobiele app als een verlengstuk van de webapp. Voor ingewikkelde acties raden we u aan de webapp te gebruiken.", s1a = "24 uur voor het begin van de gebeurtenis een sms-herinnering naar deelnemer versturen", c1a = "Aangepaste sms versturen naar deelnemer wanneer gebeurtenis wordt verplaatst", l1a = "Aangepaste e-mail versturen naar organisator wanneer een nieuwe gebeurtenis wordt geboekt", u1a = "1 uur voor het begin van gebeurtenissen een e-mailherinnering naar deelnemer versturen", d1a = "Aangepaste e-mail versturen naar organisator wanneer gebeurtenis wordt verplaatst", _1a = "Aangepaste sms versturen naar organisator wanneer een nieuwe gebeurtenis wordt geboekt", p1a = "SMS-herinnering versturen", m1a = "24 uur voor aanvang van de afspraak", f1a = "Opvolgen bij no-shows", g1a = "30 minuten na afloop van de afspraak", h1a = "Herinner deelnemers om ID mee te nemen", v1a = "1 dag voor aanvang van de afspraak", b1a = "E-mailherinnering", y1a = "1 uur voor aanvang van de afspraak", $1a = "Aangepaste SMS-herinnering", w1a = "Wanneer afspraak is gepland", k1a = "Aangepaste e-mailherinnering", S1a = "Afspraak is verzet naar host", E1a = "Inclusief boekingsaantallen van beheerde evenementtypen", x1a = "Welkom bij {{appName}}!", C1a = "Je kunt dit later bewerken.", T1a = "Ik koppel mijn agenda later", A1a = "Er is een probleem opgetreden bij het opslaan van uw gegevens. Probeer het opnieuw of neem contact op met de klantenservice.", I1a = "Ontbrekende plaatsen kopen", O1a = "Lengte van tijdvak", N1a = "Boekingsweergave", z1a = "Beheer de instellingen voor de boekingsweergave van uw team", R1a = "Beheer instellingen voor de boekingsweergave van uw organisatie", P1a = "Alleen de eigenaar van dit team kan wijzigingen aanbrengen in de boeking van het team ", D1a = 'Verwijdert alle {{appName}}-gerelateerde merken, zoals "Mogelijk gemaakt door {{appName}}"', L1a = "{{teamName}} heeft u uitgenodigd om deel te nemen aan hun team als {{role}}", M1a = "Token is ongeldig of verlopen.", F1a = "Boeking bekijken", q1a = "Koppel met Microsoft Exchange", j1a = "Verificatiemethode", V1a = "Basisverificatie", B1a = "NTLM-verificatie", U1a = "GZip-compressie", G1a = "Exchange-versie", W1a = "2007 SP1", H1a = "2010", Y1a = "2010 SP1", K1a = "2010 SP2", Z1a = "2013", X1a = "2013 SP1", J1a = "2015", Q1a = "2016", eSa = "Routering", tSa = "Maak formulieren om deelnemers naar de juiste bestemmingen te verwijzen", nSa = "E-mail naar eigenaar versturen", oSa = "Verstuurt een e-mail naar de eigenaar wanneer het formulier is verzonden", rSa = "E-mail verzenden naar", iSa = "Nieuw formulier toevoegen", aSa = "Voeg een nieuw formulier toe aan uw team", sSa = "Maak uw eerste route", cSa = "Route naar de juiste persoon op basis van de antwoorden op uw formulier", lSa = "Formulier", uSa = "Maak uw formulier om naar een boeker door te verwijzen", dSa = "Link kopiëren naar formulier", _Sa = "Thema van de boekingspagina", pSa = "Dit is alleen van toepassing op uw openbare boekingspagina's", mSa = "Dashboard-thema", fSa = "Dit is alleen van toepassing op uw aangemelde dashboard", gSa = "Systeemstandaard", hSa = "Voeg een team toe", vSa = "Ontvang in realtime vergadergegevens wanneer er iets gebeurt in {{appName}}", bSa = "Wordt geactiveerd wanneer", ySa = "Voer een pingtest uit voordat u dit aanmaakt.", $Sa = "Webhook inschakelen", wSa = "Webhook toevoegen", kSa = "Webhook opgeslagen", SSa = "Genereer API-sleutels voor toegang tot uw eigen account", ESa = "Nieuwe API-sleutel", xSa = "Actief", CSa = "Naam van API-sleutel bijgewerkt", TSa = "Fout bij het bijwerken van de naam van de API-sleutel", ASa = "HTML-iframe insluiten", ISa = "Sluit al uw type gebeurtenissen in op uw website", OSa = "Maak uw eerste API-sleutel", NSa = "Met API-sleutels kunnen andere apps communiceren met {{appName}}", zSa = "Terug naar aanmelden", RSa = "Link om opnieuw in te stellen is verzonden", PSa = "Er is een e-mail onderweg naar {{email}} met instructies om je wachtwoord opnieuw in te stellen.", DSa = "Als u niet spoedig een e-mail ontvangt, controleer dan of het ingevoerde e-mailadres correct is, controleer uw spamfolder of neem contact op met de ondersteuning als het probleem zich blijft voordoen.", LSa = "Wachtwoord bijgewerkt!", MSa = "In afwachting van betaling", FSa = "Openstaande uitnodigingen", qSa = "Openstaande organisatie-uitnodigingen", jSa = "Niet op {{appName}}", VSa = "Geen agenda geïnstalleerd", BSa = "U heeft nog geen agenda's gekoppeld", USa = "Voeg een agenda toe", GSa = "Mogelijk moet u uit- en weer inloggen om de wijziging te zien.", WSa = "Bevestig uw wachtwoord voordat u uw e-mailadres wijzigt", HSa = "plaatsen", YSa = "Elke app die in de App Store van {{appName}} wordt gepubliceerd is open source en grondig getest via collegiale beoordelingen. Desondanks onderschrijft of certificeert {{companyName}} deze apps niet, tenzij ze zijn gepubliceerd door {{appName}}. Meld het als u ongepaste inhoud of gedrag tegenkomt.", KSa = "App melden", ZSa = "Boekingsfrequentie beperken", XSa = "Beperk hoe vaak deze gebeurtenis kan worden geboekt", JSa = "Toon alleen de eerste beschikbare tijdslot", QSa = "Dit beperkt je beschikbaarheid voor dit type evenement tot één tijdslot per dag, gepland op de vroegst beschikbare tijd.", eEa = "Totale boekingsduur beperken", tEa = "Beperk de totale tijd dat deze gebeurtenis kan worden geboekt", nEa = "Limiet voor actieve boekingen per boeker", oEa = "Beperk het aantal actieve boekingen dat een boeker kan maken voor dit afspraaktype", rEa = "Terugkerende afspraken ondersteunen geen limiet voor boekingen per boeker", iEa = "Voeg een limiet toe", aEa = "Teamnaam verplicht", sEa = "Deel de deelnemersinformatie met de gasten", cEa = "Aantal beschikbare plaatsen weergeven", lEa = "Hoe gebruik ik boekingsvragen als variabelen?", uEa = "Formatteren", dEa = "Vragen", _Ea = "Alle informatie die je boeker moet verstrekken voordat ze bij jou boeken.", pEa = "Gebruik hoofdletters voor alle letters", mEa = "Vervang spaties door onderstrepingstekens", fEa = "Platformleden", gEa = "Beheer de beheerders en leden in je platformteam", hEa = "Platformfacturering", vEa = "Facturering beheren", bEa = "Alles beheren wat met facturering te maken heeft", yEa = "U heeft momenteel het GRATIS abonnement", $Ea = "We werken beter in teams. Breid uw werkstromen uit met Round Robin en collectieve gebeurtenissen en maak geavanceerde routeringsformulieren", wEa = "Nu proberen", kEa = "Factureringsportaal", SEa = "Contact opnemen met de ondersteuning", EEa = "Negeer speciale tekens in uw boekingsvraag-ID. Gebruik alleen letters en cijfers", xEa = "Opnieuw proberen", CEa = "Er is een probleem opgetreden bij het ophalen van uw agenda's. <1>Probeer het opnieuw</1> of neem contact op met de klantenservice.", TEa = "Agendaverbinding mislukt", AEa = "Boekingsbevestiging gelukt", IEa = "Boekingsweigering gelukt", OEa = "Deze boeking is voorlopig", NEa = "Oeps, ik wil accepteren", zEa = "We zullen dit niet opnieuw weergeven", REa = "We konden de tijdzone niet bijwerken", PEa = "Tijdzone bijgewerkt naar {{formattedCurrentTz}}", DEa = "Werk de tijdzone bij", LEa = "Tijdzone bijwerken?", MEa = "Het lijkt erop dat uw lokale tijdzone is gewijzigd in {{formattedCurrentTz}}.  Het is erg belangrijk dat de juiste tijdzone is ingesteld om boekingen op ongewenste tijden te voorkomen. Wilt u het bijwerken?", FEa = "Niet bijwerken", qEa = "Aanvullende opmerkingen vereisen", jEa = "Vereisen dat extra opmerkingen worden ingevuld tijdens het boeken", VEa = "e-mail versturen naar een specifiek e-mailadres", BEa = "na afloop van gebeurtenis", UEa = "wanneer boeking wordt geweigerd", GEa = "wanneer boeking wordt aangevraagd", WEa = "wanneer betaling voor boeking wordt gestart", HEa = "wanneer betaling voor boeking succesvol is", YEa = "wanneer boeking no-show wordt bijgewerkt", KEa = "Hoelang na afloop van de gebeurtenis?", ZEa = "Hoe lang nadat hosts niet verschijnen bij een cal videovergadering?", XEa = "Hoe lang nadat gasten niet verschijnen bij een cal videovergadering?", JEa = "Hoe lang nadat gebruikers niet verschijnen bij een cal videovergadering?", QEa = "Geen beschikbare tijdvakken", exa = "Tijd beschikbaar", txa = "Kun je de juiste vergader-app niet vinden? Bezoek onze <0>App Store</0>.", nxa = "Installeer een nieuwe agenda-app", oxa = "Een telefoonnummer verplicht stellen voor het boeken van een gebeurtenis", rxa = "Beschikbaarheid {{eventTypeTitle}}", ixa = "Fout bij het bewerken van de beschikbaarheid", axa = "U heeft geen machting voor toegang tot dit hulpmiddel.", sxa = "Plak de SAML-metagegevens van uw identiteitsprovider hier", cxa = "Voer een e-mailadres in zodat we uw SAML-identiteitsprovider kunnen vinden", lxa = "Serviceprovidergegevens", uxa = "Uw identiteitsprovider (IdP) zal u om de volgende gegevens vragen om de configuratie van de SAML-applicatie te voltooien.", dxa = "ACS-URL", _xa = "SP-entiteits-ID", pxa = "ACS-URL gekopieerd!", mxa = "SP-entiteits-ID gekopieerd!", fxa = "Agenda toevoegen", gxa = "Toekomstige boekingen beperken", hxa = "Beperk hoe ver in de toekomst dezew gebeurtenis kan worden geboekt", vxa = "Geen gebeurtenistype ingesteld", bxa = "{{name}} heeft geen gebeurtenistypen ingesteld die u kunt boeken.", yxa = "Factureringsfrequentie", $xa = "Maandelijks", wxa = "Jaarlijks", kxa = "Kassa", Sxa = "Uw team is ontbonden", Exa = "Uw organisatie is ontbonden", xxa = "Fout bij het aanmaken van team", Cxa = "U", Txa = "Of ga verder met", Axa = "E-mail opnieuw verzenden", Ixa = "Lid is al uitgenodigd", Oxa = "Gebruikersnaam al in gebruik", Nxa = "Voer een e-mailadres of gebruikersnaam in", zxa = "Voer een e-mailadres in", Rxa = "Voer e-mailadressen in", Pxa = "Je kunt maximaal {{nbUsers}} gebruikers tegelijk uitnodigen.", Dxa = "Deze naam is al in gebruik", Lxa = "Moet een teamnaam invoeren", Mxa = "Moet een team-URL invoeren", Fxa = "Deze URL is al in gebruik", qxa = "Er is een probleem opgetreden bij het registreren van het subdomein. Probeer het opnieuw of neem contact op met een beheerder", jxa = "Team publiceren", Vxa = "Telefoonnummer (sms-meldingen)", Bxa = "Telefoonnummer (sms-meldingen)", Uxa = "E-mailadres deelnemer", Gxa = "Het e-mailadres van de persoon die boekt", Wxa = "Boeking UID", Hxa = "Typ een opdracht of zoek...", Yxa = "Oh nee! Het lijkt erop dat de machtiging is verlopen of is ingetrokken. Installeer het opnieuw.", Kxa = "Herinstalleer de app", Zxa = "Reden voor opnieuw plannen", Xxa = "Kies een gezamenlijke planning", Jxa = "Schakel dit in als je een gemeenschappelijk schema wilt gebruiken tussen hosts. Wanneer uitgeschakeld, wordt elke host geboekt op basis van hun standaardschema of hun gekozen schema.", Qxa = "Reden", eCa = "Afzender-ID", tCa = "Alleen letters, cijfers en spaties toegestaan (max. 11 tekens)", nCa = "Routeringsformulier testen", oCa = "Voorbeeld testen", rCa = "Routeren naar", iCa = "Test uw routeringsformulier zonder gegevens te versturen", aCa = "Routering testen", sCa = "Een beheerder heeft een betaalapp uitgeschakeld", cCa = "Gebeurtenistype bewerken", lCa = "Deze organisatie is privé, en alleen de beheerder of eigenaar van de organisatie kan de leden zien.", uCa = "Alleen de beheerder of eigenaar van de organisatie kan SSO-instellingen beheren", dCa = "Alleen de beheerder of eigenaar van de organisatie kan directory-synchronisatie-instellingen beheren", _Ca = "Alleen de beheerder of eigenaar van de organisatie kan OAuth-clients beheren", pCa = "Collectieve planning", mCa = "Maak het gemakkelijk om uw team te boeken wanneer iedereen beschikbaar is.", fCa = "Zoek de beste beschikbare persoon en blader door uw team.", gCa = "Vaste round-robin", hCa = "Voeg één vaste deelnemer en round-robin toe via een aantal deelnemers.", vCa = "{{appName}} is beter met teams", bCa = "Het team van {{companyName}}", yCa = "Voeg uw teamleden toe aan uw gebeurtenistypes. Gebruik collectieve planning om iedereen op te nemen of zoek de meest geschikte persoon met round robin-planning.", $Ca = "Boekingslimiet voor dit gebeurtenistype is bereikt", wCa = "Duurlimiet voor dit gebeurtenistype is bereikt", kCa = "Een beheerder heeft {{appName}} uitgeschakeld", SCa = "Dit zal alle e-mails naar {{recipient}} uitschakelen. Dit omvat boekingsbevestigingen, verzoeken, herplanningen en herplanningsverzoeken, annuleringsmails en alle andere e-mails met betrekking tot boekingsupdates.<br /><br />Het is jouw verantwoordelijkheid om ervoor te zorgen dat je {{recipient}} op de hoogte zijn van boekingen en wijzigingen in hun boekingen.", ECa = "Een beheerder heeft {{appName}} uitgeschakeld die van invloed is op uw gebeurtenistype {{eventType}}", xCa = "Een beheerder heeft een van uw gebeurtenistypen vervangen", CCa = "Een teambeheerder heeft uw gebeurtenis vervangen /{{slug}}", TCa = "Een beheerder van het team <strong>{{teamName}}</strong> heeft uw gebeurtenistype <strong>/{{slug}}</strong> vervangen door een type beheerde gebeurtenis dat deze beheert.", ACa = "Uw link blijft werken, maar sommige instellingen ervoor kunnen gewijzigd zijn. U kunt deze bekijken in gebeurtenistypen.", ICa = "Neem contact op met uw beheerder als u vragen hebt over het gebeurtenistype.<br /><br />Veel plezier met plannen, <br />Het Cal.com-team", OCa = "De beheerder heeft {{appName}} uitgeschakeld, wat invloed heeft op je afspraaktype {{title}}. Deelnemers kunnen dit type afspraak nog steeds boeken, maar worden niet gevraagd te betalen. Je kunt het afspraaktype verbergen om dit te voorkomen totdat je beheerder je betaalmethode opnieuw inschakelt.", NCa = "Deelnemers kunnen dit type afspraak nog steeds boeken, maar worden niet gevraagd te betalen. Je kunt het afspraaktype verbergen om dit te voorkomen totdat je beheerder je betaalmethode opnieuw inschakelt.", zCa = "De beheerder heeft {{appName}} uitgeschakeld die van invloed is op uw gebeurtenistype {{title}}.", RCa = "De beheerder heeft {{appName}} uitgeschakeld, wat van invloed kan zijn op uw gebeurtenistypes. Als u gebeurtenistypes heeft met {{appName}} als locatie, is het standaard Cal Video.", PCa = "{{appName}} is uitgeschakeld", DCa = "Naar geïnstalleerde apps", LCa = "Als u een andere agenda heeft geïnstalleerd, worden nieuwe boekingen daaraan toegevoegd. Zo niet, koppel dan een nieuwe agenda zodat u geen nieuwe boekingen mist.", MCa = "Apps inschakelen", FCa = "Schakel apps in die gebruikers kunnen integreren met {{appName}}", qCa = "Koop een licentie", jCa = "Heeft u al een account?", VCa = "Ik heb al een code:", BCa = "Kopieer hier uw bestaande CALCOM_LICENSE_KEY-omgevingsvariabele.", UCa = "Licentiesleutel aanmaken", GCa = "{{appName}} is ingeschakeld", WCa = "{{appName}} is uitgeschakeld", HCa = "Sleutels zijn opgeslagen", YCa = "App uitschakelen", KCa = "Het uitschakelen van deze app kan problemen veroorzaken met de interactie tussen uw gebruikers en Cal", ZCa = "Sleutels bewerken", XCa = "Schakel apps in voor uw exemplaar van Cal", JCa = "Een lijst van alle gebruikers in uw account, inclusief hun naam, functie, e-mail en rol.", QCa = "Hier kunt u een nieuwe gebruiker toevoegen.", eTa = "Hier kunt u een huidige gebruiker bewerken.", tTa = "Hier kunt u een organisatie bewerken.", nTa = "Nieuwe OAuth-clients toevoegen", oTa = "SMS-verzending voor gebruikers vergrendelen of ontgrendelen", rTa = "Er zijn geen beschikbare apps", iTa = 'Zorg ervoor dat er apps zijn in uw implementatie onder "packages/app-store"', aTa = "Er zijn geen apps ingeschakeld in dit exemplaar van Cal", sTa = "Er is nog geen app geconfigureerd", cTa = "U kunt apps inschakelen in de instellingen", lTa = "Neem contact op met uw beheerder", uTa = "Appsinstellingen", dTa = "Vul dit veld in", _Ta = "Opties", pTa = "Voer optie {{index}} in", mTa = "Voeg een optie toe", fTa = "Deze locatie bestaat al. Kies een nieuwe locatie", gTa = "Radio", hTa = "Om Google Meet te gebruiken, moet je je doelkalender instellen als een Google Agenda", vTa = "Individueel", bTa = "Alle boekingen", yTa = "Alle gebruikers", $Ta = "Alle evenementtypes", wTa = "Uw boekingen", kTa = "Vergaderings-URL", STa = "De vergaderingsconferentie-url van de gebeurtenis", ETa = "Datumoverschrijvingen", xTa = "Verwijder datumoverschrijvingen op {{date}}", CTa = "Voeg datums toe wanneer uw beschikbaarheid afwijkt van uw dagelijkse tijden.", TTa = "Datumoverschrijvingen worden automatisch gearchiveerd nadat de datum is verstreken", ATa = "Welke tijden bent u beschikbaar?", ITa = "Welke tijden bent u bezet?", OTa = "Selecteer de datums om te overschrijven", NTa = "Hele dag niet beschikbaar", zTa = "Markeren als niet beschikbaar (hele dag)", RTa = "Markeren als niet beschikbaar op geselecteerde datums", PTa = "Overschrijving bijwerken", DTa = "Datumoverschrijing toegevoegd", LTa = "Uitzondering opslaan", MTa = "{{slug}}-kopie", FTa = "Als standaard instellen", qTa = "Gebeurtenistypegegevens verbergen", jTa = "Navigatie weergeven", VTa = "Navigatie verbergen", BTa = "Verificatiecode verzonden", UTa = "Geverifieerd", GTa = "Onjuiste verificatiecode", WTa = "Nog niet geverifieerd", HTa = "Geen beschikbaarheid in {{month}}", YTa = "Afspraken kunnen alleen tot {{days}} dagen vooruit worden gepland. Kijk binnenkort nog eens.", KTa = "Plannen is geëindigd op {{date}}. Kijk binnenkort nog eens.", ZTa = "Vorige maand bekijken", XTa = "Volgende maand weergeven", JTa = "Code verzenden", QTa = "Nummer geverifieerd", eAa = "Maak uw eerste webhook voor dit teamgebeurtenistype", tAa = "Maak een webhook voor dit teamgebeurtenistype", nAa = "Succespagina uitschakelen (werkt alleen als u een omleidings-URL heeft)", oAa = "U bent beheerder, maar u hebt geen wachtwoord van minimaal 15 tekens of nog geen tweestapsverificatie", rAa = "Wijzig je wachtwoord om beheerderstoegang te krijgen", iAa = "De gebruikersnaam is al in gebruik", aAa = "Toewijzing", sAa = "Vaste hosts", cAa = "Vaste hosts toevoegen", lAa = "Round-robin-hosts", uAa = "Aantal vereiste hosts voor deelname", dAa = "Hosts", _Aa = "Je moet een team aanmaken om deze functie in te schakelen. Klik hier om een team aan te maken.", pAa = "U moet upgraden naar ons Enterprise-abonnement om deze functie in te schakelen.", mAa = "Nieuwe deelnemer", fAa = "In afwachting van goedkeuring", gAa = "Deze app vereist een Google Agenda-koppeling", hAa = 'De "Toevoegen aan agenda" voor dit afspraaktype moet een Google Agenda zijn om Meet te laten werken. Verbind het <0>hier</0>.', vAa = "U heeft een Google Agenda-account gekoppeld.", bAa = "Het gebruik van Google Meet vereist een gekoppelde Google-agenda", yAa = "Ga door met het installeren van Google Agenda", $Aa = "Google Meet installeren", wAa = "Google Agenda installeren", kAa = "Afzendernaam", SAa = "Deelnemer reeds uitgenodigd", EAa = "Geen opnames gevonden", xAa = "Nieuwe werkstroom voor...", CAa = "Rapportage", TAa = "Bekijk alle inkomende gegevens en download ze als een CSV-bestand", AAa = "Teams-abonnement vereist", IAa = "Routeringsformulieren zijn een geweldige manier om uw inkomende leads naar de juiste persoon te leiden. Upgrade naar een Teams-abonnement om toegang te krijgen tot deze functie.", OAa = "Kies een licentie", NAa = "Cal.com wordt geleverd met een toegankelijke en gratis AGPLv3-licentie met enkele beperkingen die op elk moment kan worden geüpgraded naar een bedrijfslicentie. U kunt later altijd upgraden.", zAa = "Licentie", RAa = "AGPLv3-licentie", PAa = "Uw code hoeft niet open source te zijn", DAa = "Gemakkelijk opnieuw verpakken, rebranden en doorverkopen", LAa = "Een uitgebreid pakket bedrijfsfuncties", MAa = "$ 0,00/maand", FAa = "Voor altijd open en gratis", qAa = "Vereist om uw code open source te houden", jAa = "Kan niet gemakkelijk opnieuw verpakken, rebranden en doorverkopen", VAa = "Geen bedrijfsfuncties", BAa = "Enterprise-licentie", UAa = "Alles voor commerciële toepassing met privéhosting, opnieuw verpakken, rebranden en doorverkopen en toegang tot exclusieve bedrijfscomponenten.", GAa = "Configuratie", WAa = "Cal.com-exemplaar configureren", HAa = "Configureren", YAa = "Single sign-on", KAa = "SAML/OIDC SSO configureren en teamleden laten inloggen met behulp van een identiteitsprovider", ZAa = "Configureer SAML/OIDC SSO en laat organisatieleden inloggen met een Identity Provider", XAa = "SSO met OIDC", JAa = "Configureer OIDC SSO met de identiteitsprovider van uw keuze.", QAa = "OIDC-configuratie", e2a = "Configureer de OIDC-verbinding met uw identiteitsprovider. U kunt de vereiste informatie vinden bij uw identiteitsprovider.", t2a = "URL voor terugbellen gekopieerd", n2a = "SSO met SAML", o2a = "Configureer SAML SSO met de identiteitsprovider van uw keuze.", r2a = "SAML-configuratie", i2a = "Configureer de SAML-verbinding met uw identiteitsprovider. U kunt de vereiste informatie vinden bij uw identiteitsprovider.", a2a = "ACS-URL gekopieerd", s2a = "Entiteits-ID gekopieerd", c2a = "{{connectionType}}-configuratie gemaakt", l2a = "{{connectionType}}-configuratie verwijderd", u2a = "{{connectionType}}-configuratie verwijderen", d2a = "Ja, verwijder de {{connectionType}}-configuratie", _2a = "Weet u zeker dat u de {{connectionType}}-configuratie wilt verwijderen? Uw teamleden die {{connectionType}}-aanmelding gebruiken hebben niet langer toegang tot Cal.com.", p2a = "Tijdzone organisator", m2a = "Uitnodiging weergeven", f2a = "Uitnodiging accepteren", g2a = "Nu deelnemen", h2a = "Succesvol deelgenomen", v2a = "Je bent uitgenodigd om lid te worden van een team binnen de {{parentTeamName}} organisatie", b2a = "Je bent uitgenodigd om lid te worden van een {{appName}} organisatie", y2a = "{{invitedBy}} heeft u uitgenodigd om lid te worden van zijn team op {{appName}}. {{appName}} is de gebeurtenissenplanner die u en uw team in staat stelt vergaderingen te plannen zonder heen en weer te e-mailen.", $2a = "{{invitedBy}} heeft je uitgenodigd om lid te worden van het team {{teamName}} in hun organisatie {{parentTeamName}} op {{appName}}. {{appName}} is de planner die jou en je team in staat stelt om vergaderingen te plannen zonder eindeloos heen en weer te mailen.", w2a = "{{invitedBy}} heeft u uitgenodigd om lid te worden van zijn organisatie '{{teamName}}' op {{appName}}. {{appName}} is de gebeurtenissenplanner die u en uw organisatie in staat stelt afspraken te plannen zonder heen en weer te e-mailen.", k2a = "We leiden je door een paar korte stappen en je kunt in een mum van tijd genieten van stressvrij plannen met je {{entity}}.", S2a = "Kies uw gebruikersnaam", E2a = "Koppel uw agenda-account", x2a = "Stel uw beschikbaarheid in", C2a = "Neem deel aan {{teamName}}", T2a = "Veel plezier met het plannen van het {{appName}}-team", A2a = "U staat op het punt zich voor te doen als een gebruiker, wat betekent dat u namens hem wijzigingen kunt aanbrengen. Wees voorzichtig.", I2a = "Beschikbare variabelen", O2a = "{Scheduler}", N2a = "Geen werkstromen", z2a = "Wijzig het filter om uw persoonlijke en teamwerkstromen te zien.", R2a = "Wijzig het filter om de resultaten te zien.", P2a = "Geen resultaten voor het filter", D2a = "Aanbevolen volgende stappen", L2a = "Maak een beheerd gebeurtenistype", M2a = "Vergaderingen zijn beter met de juiste teamleden erbij. Nodig ze nu uit.", F2a = "Maak een een-op-een sjabloon voor een gebeurtenistype en verspreid het onder meerdere leden.", q2a = "Collectief of round-robin", j2a = "Boek uw teamleden samen met collectieve gebeurtenissen of blader voor de juiste persoon met round-robin.", V2a = "Neemt niet langer deel aan {{title}} op {{date}}", B2a = "U neemt niet langer deel aan deze gebeurtenis", U2a = "Een deelnemer neemt niet langer deel aan {{title}} op {{date}}", G2a = "Een deelnemer neemt niet langer deel aan uw gebeurtenis", W2a = "{{name}} heeft geannuleerd. Dit betekent dat er een plaats is vrijgekomen voor dit tijdslot", H2a = "Gebeurtenis aanmaken op", Y2a = "Routeringsformulier maken op", K2a = "Stel een standaard app-link in", Z2a = "Door een standaard app-link in te stellen kunnen alle nieuw gemaakte gebeurtenistypes de door u ingestelde app-link gebruiken.", X2a = "Standaardapp organisator", J2a = "{{organizer}} heeft geen standaard vergaderapp", Q2a = "Onbereikbaar wegens onderhoud", eIa = "Het {{appName}}-team voert gepland onderhoud uit. Neem contact op met de ondersteuning als u vragen heeft.", tIa = "{{numberOfSeats}} plaatsen", nIa = "Boekingsvragen", oIa = "Pas de gestelde vragen op de boekingspagina aan", rIa = "Vraag toevoegen", iIa = "ID", aIa = "E-mailadres dubbel", sIa = "Voer een doorverwijzings-URL in waarnaar de deelnemer wordt gestuurd zodra deze de vergadering verlaat.", cIa = "Betalen voor deze gebeurtenis is niet meer mogelijk", lIa = "Een terugbetaling voor deze boeking is onderweg.", uIa = "Deze boekingsbetaling is terugbetaald.", dIa = "Volgens het restitutiebeleid van het evenement is de boekingsbetaling niet-restitueerbaar.", _Ia = "De restitutieperiode van het evenement is verlopen. Daarom is de boekingsbetaling niet-restitueerbaar.", pIa = "Boekingsbevestiging mislukt", mIa = "Onvoldoende plaatsen", fIa = "Een veld met deze naam bestaat al", gIa = "Gastveld moet van het type 'Meerdere e-mails' zijn", hIa = "Weergeven op boekingspagina", vIa = "Je kunt de pagina van de geannuleerde boeking bezoeken", bIa = "Aan de slag met Zapier-sjablonen", yIa = "Standaard sjablonen", $Ia = "Cal.ai sjablonen", wIa = "{{team}} is niet gepubliceerd", kIa = "Deze organisatiekoppeling is momenteel niet beschikbaar. Neem contact op met de organisatie-eigenaar of vraag om het te publiceren.", SIa = "Deze {{entity}}-link is momenteel niet beschikbaar. Neem contact op met de {{entity}}-eigenaar of vraag hem het te publiceren.", EIa = "Teamlid", xIa = "Een routeringsformulier", CIa = "Formulierbeschrijving", TIa = "Houd me verbonden met het formulier", AIa = "Alle wijzigingen die worden aangebracht in de router of velden van het formulier dat wordt gedupliceerd, worden weergegeven in het duplicaat. Het verwijderen van een veld zal het echter niet uit het duplicaat verwijderen.", IIa = "Formulier verwijderd", OIa = "Weet u zeker dat u dit formulier wilt verwijderen?", NIa = "Ja, verwijder het formulier", zIa = "Iedereen met wie u de link heeft gedeeld heeft dan geen toegang meer ertoe.", RIa = "Alle bijbehorende reacties worden verwijderd.", PIa = "Doorverwijzings-URL gekopieerd! Je kunt nu de URL in je eigen formulier instellen.", DIa = "Wijzigingen in velden en routes van de volgende formulieren worden in dit formulier verwerkt.", LIa = "Verbonden formulieren", MIa = "De volgende formulieren worden beïnvloed wanneer u hier velden of routes wijzigt.", FIa = "Wacht enige tijd tot de reacties zijn verzameld. U kunt het formulier ook zelf indienen.", qIa = "Dit is wat uw gebruikers te zien krijgen", jIa = "Identificeert het veld met deze naam.", VIa = "Voeg 1 optie per regel toe", BIa = "Selecteer een router", UIa = "Voeg een nieuwe route toe", GIa = "Neem geïnformeerde beslissingen met Insights", WIa = "Ons Insights-dashboard geeft alle activiteiten in uw team weer en toont u trends die betere teamplanning en besluitvorming mogelijk maken.", HIa = "Geef boekingen van alle leden weer", YIa = "Bekijk wie de meeste boekingen ontvangt en zorg voor de beste verdeling binnen je team", KIa = "Identificeer boekingstrends", ZIa = "Bekijk welke tijden van de week en welke tijden overdag populair zijn voor uw boekers", XIa = "Spot populaire gebeurtenistypen", JIa = "Bekijk welke van uw gebeurtenistypen de meeste kliks en boekingen ontvangen", QIa = "Nog geen reacties", eOa = "Geen routes gedefinieerd", tOa = "Dit wordt de plaatshouder", nOa = "Er is een fout opgetreden bij het boeken van de gebeurtenis. Vernieuw de pagina en probeer het opnieuw", oOa = "Geen tijdslot geselecteerd", rOa = "Selecteer een tijdslot om de gebeurtenis te boeken.", iOa = "Tijdslot selecteren", aOa = "Overschakelen naar maandelijkse weergave", sOa = "Overschakelen naar wekelijkse weergave", cOa = "Overschakelen naar dagelijkse weergave", lOa = "Overschakelen naar kolomweergave", uOa = "{{num}} locatieopties", dOa = "Selecteer bij de volgende stap", _Oa = "Deze vergadering is nog niet begonnen", pOa = "{{appName}} vereist een gekoppeld {{dependencyName}}-account", mOa = "{{dependencyName}} koppelen", fOa = "{{dependencyName}} is gekoppeld", gOa = "Vereist {{dependencyName}}", hOa = "Verificatiecode", vOa = "Kunt u het opnieuw proberen met een andere tijd?", bOa = "Verifiëren", yOa = "De tijdzone van de ontvanger", $Oa = "Tijdzone", wOa = "Eindtijd gebeurtenis", kOa = "De eindtijd van de gebeurtenis", SOa = "Annulerings-URL", EOa = "De URL om de boeking te annuleren", xOa = "Annuleringsreden", COa = "De reden voor het annuleren van de boeking", TOa = "Verplaatsings-URL", AOa = "De URL om de boeking te verplaatsen", IOa = "Reden voor verzetten", OOa = "De reden voor het verzetten van de boeking", NOa = "Uw gebeurtenisnaam bevat een ongeldige variabele", zOa = "Alles selecteren", ROa = "Bestaande gebeurtenistypen in bulk bijwerken", POa = "Standaardschema lid", DOa = "Ingesteld door teambeheerder", LOa = "Standaardlocatie lid", MOa = "Wij gebruiken de standaard beschikbaarheidsplanning van elk lid. Leden kunnen dit bewerken of wijzigen.", FOa = "U moet ten minste één planning hebben", qOa = "Werk de locaties voor de geselecteerde gebeurtenistypen bij", jOa = "Werk de schema's bij voor de geselecteerde evenementtypes", VOa = "Vergrendeld voor leden", BOa = "Ontgrendeld voor leden", UOa = "Leden kunnen de actieve apps zien, maar kunnen geen appinstellingen bewerken", GOa = "Leden kunnen de actieve apps zien en alle app-instellingen bewerken", WOa = "Je kunt de actieve apps zien, maar je kunt geen app-instellingen bewerken", HOa = "Je zult de actieve apps kunnen zien en de instellingen van elke app kunnen bewerken.", YOa = "Leden kunnen hun persoonlijke workflows niet toevoegen aan dit type evenement. Leden kunnen de actieve teamworkflows zien, maar kunnen geen workflow-instellingen bewerken.", KOa = "Leden kunnen hun persoonlijke workflows toevoegen aan dit type evenement. Leden kunnen de actieve teamworkflows zien, maar kunnen geen workflow-instellingen bewerken.", ZOa = "Je zult de actieve teamworkflows kunnen zien, maar je kunt geen workflow-instellingen bewerken of je persoonlijke workflows toevoegen aan dit type evenement.", XOa = "Je kunt persoonlijke workflows in- of uitschakelen voor dit type evenement. Je zult de actieve teamworkflows kunnen zien, maar je kunt geen teamworkflow-instellingen bewerken.", JOa = "Leden kunnen geen persoonlijke webhooks toevoegen aan dit afspraaktype. Leden kunnen wel de actieve webhooks zien, maar kunnen geen webhook-instellingen bewerken.", QOa = "Leden kunnen hun persoonlijke webhooks toevoegen aan dit afspraaktype. Leden kunnen de actieve webhooks zien, maar kunnen geen webhook-instellingen bewerken.", eNa = "Je kunt de actieve beheerde webhooks zien, maar je kunt geen webhook-instellingen bewerken of je persoonlijke webhooks toevoegen aan dit afspraaktype.", tNa = "Je kunt webhooks toevoegen aan dit afspraaktype. Je kunt de actieve beheerde webhooks zien, maar je kunt deze niet bewerken.", nNa = "Vergrendeld door teambeheerder", oNa = "U hebt geen {{appName}}-account gekoppeld.", rNa = "Nu koppelen", iNa = "{{count}} lid vervangen en informeren", aNa = "{{count}} leden vervangen en informeren", sNa = "De URL /{{slug}} bestaat al voor {{count}} lid. Wilt u deze vervangen?", cNa = "De URL /{{slug}} bestaat al voor {{count}} leden. Wilt u deze vervangen?", lNa = "<strong>{{names}}</strong> gebruikt de URL <strong>/{{slug}}</strong> al.", uNa = "<strong>{{names}}</strong> gebruiken de URL <strong>/{{slug}}</strong> al.", dNa = "Als u ervoor kiest om de URL te vervangen, informeren wij de leden daarover. Ga terug en verwijder ze als u de URL niet wilt overschrijven.", _Na = "Gebeurtenistype bekijken", pNa = "Op zoek naar meer analyses?", mNa = "Op zoek naar meer Insights?", fNa = "Filters", gNa = "Filter", hNa = "Lid toevoegen", vNa = "Filter toevoegen", bNa = "Regel toevoegen", yNa = "Regelgroep toevoegen", $Na = "Alle filters wissen", wNa = "E-mail geverifieerd", kNa = "Selecteer gebruiker", SNa = "Selecteer gebeurtenistype", ENa = "Selecteer datumbereik", xNa = "Populaire gebeurtenissen", CNa = "Geen gebeurtenistypen gevonden", TNa = "Gemiddelde gebeurtenisduur", ANa = "Boekingen per uur", INa = "Meest geboekt", ONa = "Minst geboekt", NNa = "Meeste boekingen gepland", zNa = "Minste boekingen gepland", RNa = "Meeste boekingen voltooid", PNa = "Minste boekingen voltooid", DNa = "Gemaakte gebeurtenissen", LNa = "Voltooide gebeurtenissen", MNa = "Afspraken geannuleerd", FNa = "Verplaatste gebeurtenissen", qNa = "Evenementen", jNa = "Prestaties", VNa = "van afgelopen periode", BNa = "Van: {{startDate}} Tot: {{endDate}}", UNa = 'Als u een omleiding toevoegt, wordt de succespagina uitgeschakeld. Zorg ervoor dat u op uw aangepaste succespagina "Boeking bevestigd" vermeldt.', GNa = "Gebeurtenistrends", WNa = "Filters wissen", HNa = "Wissen", YNa = "Vasthouden", KNa = "Betaling ontvangen bij boeken", ZNa = "Afwezigheidsvergoeding in rekening brengen", XNa = "Kaartbetaling vastgehouden", JNa = "In rekening brengen op kaart", QNa = "In rekening gebracht op kaart", eza = "{{amount, currency}} afwezigheidsvergoeding", tza = "Afwezigheidsvergoeding", nza = "Kaart verzenden", oza = "Betaalgegevens verzenden", rza = "Uw vergadering wacht op een betaalmethode", iza = "Afwezigheidsvergoeding van {{amount, currency}} in rekening gebracht voor {{title}} om {{date}}", aza = "Afwezigheidsvergoeding is in rekening gebracht", sza = "Er is een afwezigheidsvergoeding van {{amount, currency}} in rekening gebracht voor de volgende gebeurtenis", cza = "Er is iets misgegaan met het in rekening brengen van de afwezigheidsvergoeding. Probeer het later opnieuw.", lza = "Afwezigheidsvergoeding innen", uza = "Afwezigheidsvergoeding in rekening gebracht", dza = "Betaling geweigerd. Probeer een andere kaart of neem contact op met uw bank voor hulp.", _za = "Dit kaarttype wordt niet ondersteund voor deze aankoop. Gebruik een andere betaalmethode.", pza = "Minimaal betalingsbedrag is $0.50 USD. Verhoog uw betalingsbedrag.", mza = "Kon de kaart niet belasten voor betaling.", fza = "Inzichten", gza = "Routeringsformulieren", hza = "Geen gegevens gevonden voor het geselecteerde filter of de geselecteerde datums.", vza = "Ik erken dat als ik deze gebeurtenis niet bijwoon, er {{amount, currency}} aan afwezigheidsvergoeding van mijn kaart worden afgeschreven.", bza = "dagen", yza = "Kaartgegevens", $za = "Er is iets misgegaan aan onze kant. Neem contact op met ons ondersteuningsteam, en we lossen het meteen voor je op.", wza = "Vermeld de volgende tekst wanneer u contact opneemt met ondersteuning, zodat we u beter kunnen helpen", kza = "Kan op dit moment geen plaatsen inschakelen en afwezigheidsvergoeding in rekening brengen", Sza = "Voltooi uw boeking", Eza = "Voltooi uw boeking: {{title}} op {{date}}", xza = "Bevestig uw gegevens", Cza = "Uitnodigingslink kopiëren", Tza = "Linkinstellingen bewerken", Aza = "Uitnodigingslink gekopieerd", Iza = "Uitnodigingslink verwijderd", Oza = "API-sleutel verwijderd", Nza = "Dit zal de API-sleutel permanent verwijderen. Alle applicaties die deze sleutel gebruiken, verliezen onmiddellijk toegang tot je account. Deze actie kan niet ongedaan worden gemaakt.", zza = "Uitnodigingslinkinstellingen opgeslagen", Rza = "Links verlopen na...", Pza = "1 dag", Dza = "7 dagen", Lza = "30 dagen", Mza = "3 maanden", Fza = "1 jaar", qza = "U bent uitgenodigd om lid te worden van {{teamName}}", jza = "{{amount, currency}}", Vza = "U staat op het punt om de deelnemer {{amount, currency}} in rekening te brengen. Weet u zeker dat u wilt doorgaan?", Bza = "Deelnemer {{amount, currency}} in rekening brengen", Uza = "Betaling vereisen ({{paymentFeePercentage}}% + {{fee, currency}} commissie per transactie)", Gza = "{{email}} is uitgenodigd", Wza = "{{userCount}} gebruikers zijn uitgenodigd", Hza = "Fout bij incasseren van kaart", Yza = "De geüploade afbeelding mag niet groter zijn dan 5 MB", Kza = "{{errorCode}}: u bent niet geautoriseerd om deze werkstroom in of uit te schakelen", Zza = "Inline insluiting", Xza = "Laadt uw gebeurtenistype rechtstreeks inline met uw andere websitecontent.", Jza = "Zwevende pop-upknop", Qza = "Plaatst een zwevende knop op uw site die een dialoogvenster met uw gebeurtenistype activeert.", eRa = "Pop-up via elementklik", tRa = "Open uw Cal-dialoogvenster wanneer iemand op een element klikt.", nRa = "Mijn eigen formulier gebruiken", oRa = "Gebruik onze headless routing API en gebruik uw eigen formulier voor inzendingen.", rRa = "Hulp nodig? Bekijk onze handleidingen voor het insluiten van Cal op Wix, Squarespace of WordPress. Bekijk onze veelgestelde vragen of ontdek geavanceerde insluitopties.", iRa = "Boeken op Cal", aRa = "Voornaam", sRa = "Achternaam", cRa = "Voornaam, achternaam", lRa = "Uitnodigen als", uRa = "Formulier bijgewerkt.", dRa = "Standaardbevestigings-e-mails voor deelnemers uitschakelen", _Ra = "Er is minstens één werkstroom actief voor dit gebeurtenistype die een e-mail naar de deelnemers stuurt wanneer de gebeurtenis geboekt is.", pRa = "Standaardbevestigings-e-mails voor organisator uitschakelen", mRa = "Er is minstens één werkstroom actief voor dit gebeurtenistype die een e-mail naar de organisator stuurt wanneer de gebeurtenis geboekt is.", fRa = "Voeg een overschrijving toe", gRa = "Gebruikers importeren uit Google Workspace", hRa = "Google Workspace koppelen", vRa = "U moet een Google Workspace-beheerder zijn om deze functie te gebruiken", bRa = "Maak uw eerste webhook voor dit gebeurtenistype", yRa = "Maak je eerste webhook met 'Instant Meeting Created' als trigger voor dit type evenement.", $Ra = "App installeren op", wRa = "Maken voor", kRa = "Valuta", SRa = "Creëer een omgeving waarin je teams gedeelde apps, workflows en afspraaktypes kunnen maken met round-robin en collectieve planning.", ERa = "Beheer organisaties met meerdere teams", xRa = "Stel uw organisatie in", CRa = "Stel je platform in", TRa = "Organisaties zijn gedeelde omgevingen waar teams gedeelde gebeurtenistypen, apps, werkstromen en meer kunnen maken.", ARa = "Abonnementen", IRa = "Platform", ORa = "Beheer alles wat met het platform te maken heeft.", NRa = "Cal.com Platform stelt je in staat om plannen moeiteloos te integreren in je app met behulp van platform-API's en -atomen.", zRa = "U moet een organisatienaam invoeren", RRa = "U moet het e-mailadres van uw organisatie invoeren", PRa = "E-mailadres van uw organisatie", DRa = "Je beheerders e-mailadres", LRa = "Gebruikersnaam beheerder", MRa = "Organisatienaam", FRa = "Platformnaam", qRa = "Organisatie-URL", jRa = "Verifieer het e-mailadres van uw organisatie", VRa = "Gebruik de onderstaande code om uw e-mailadres te verifiëren en door te gaan met het instellen van uw organisatie.", BRa = "Extra URL-parameters", URa = "Over uw organisatie", GRa = "Organisaties zijn gedeelde omgevingen waar u meerdere teams met gedeelde gebeurtenistypen, apps, werkstromen en meer kunt maken.", WRa = "Maak uw teams", HRa = "Begin met samen plannen door uw teamleden aan uw organisatie toe te voegen", YRa = "Nodig uw organisatiebeheerders uit", KRa = "Deze beheerders hebben toegang tot alle teams in uw organisatie. U kunt later teambeheerders en -leden toevoegen.", ZRa = "Stel een wachtwoord in", XRa = "Hierdoor wordt een nieuwe gebruikersaccount gemaakt met het e-mailadres van uw organisatie en dit wachtwoord.", JRa = "Organisatielogo", QRa = "Een paar zinnen over uw organisatie. Dit wordt weergegeven op de openbare profielpagina van uw organisatie.", ePa = "Ik doe dit later", tPa = "Verifieer uw e-mailadres", nPa = "Voer de 6-cijferige code in die we naar {{email}} hebben gestuurd", oPa = "Verifieer uw e-mailadres om een organisatie te maken", rPa = "De opgegeven code is ongeldig, probeer het opnieuw", iPa = "Het e-mailadres wordt al gebruikt", aPa = "U bent uitgenodigd om lid te worden van {{orgName}}", sPa = "Word lid van uw team bij {{orgName}} en begin met het richten op afspraken, niet op het maken van afspraken!", cPa = "De volgende teams konden niet worden gemaakt vanwege dubbele slugs: {{slugs}}", lPa = "Teamnamen mogen niet leeg zijn", uPa = "Teamnamen mogen niet herhaald worden", dPa = "Gebruiker behoort tot een organisatie", _Pa = "Deze organisatie heeft nog geen teams", pPa = "Als u een beheerder bent, zorg er dan voor dat u teams maakt die hier weergegeven worden.", mPa = "Instellen", fPa = "Mijn profiel", gPa = "Mijn instellingen", hPa = "CRM", vPa = "Berichten", bPa = "Naam of nummer weergegeven als de afzender van een sms (sommige landen staan geen alfanumerieke afzender-ID's toe)", yPa = "Alleen de beheerder van uw organisatie kan nieuwe teams maken", $Pa = "Google's nieuwe spambeleid kan voorkomen dat je e-mail- en agendameldingen over deze boeking ontvangt.", wPa = "Oplossen", kPa = "Er is een fout opgetreden bij het maken van teams voor deze organisatie. Ontbrekende URL-slug.", SPa = "Link kopiëren naar organisatie", EPa = "Team: {{teamName}}", xPa = "Gebruiker: {{userName}}", CPa = "Bekijk boekingsinsights voor al uw gebeurtenissen", TPa = "Belgeschiedenis", APa = "Bekijk belgeschiedenis van al je Cal.ai gesprekken", IPa = "{{locationCount}} locatieopties", OPa = "Kanaaltype", NPa = "Reden van beëindiging", zPa = "Sessiestatus", RPa = "Gebruikerssentiment", PPa = "Tijd", DPa = "Van", LPa = "Aangepast abonnement", MPa = "E-mail insluiten", FPa = "Selecteer enkele beschikbare tijden en voeg ze toe aan uw e-mail", qPa = "Tijd selecteren", jPa = "Datum selecteren", VPa = "Alleen tonen als een parameter is ingesteld", BPa = "Parameter toevoegen", UPa = "We verbinden je met iemand van {{orgName}}.", GPa = "Sluit of vernieuw deze pagina niet", WPa = "Bekijk alle beschikbare tijden", HPa = "bijvoorbeeld Marketingteam", YPa = "bijvoorbeeld Verkoopteam", KPa = "bijvoorbeeld Ontwerpteam", ZPa = "bijvoorbeeld Engineeringteam", XPa = "bijvoorbeeld Gegevensanalyseteam", JPa = "U kunt later meer teams toevoegen.", QPa = "Waar gaat deze afspraak over?", eDa = "Voeg toe aan team", tDa = "Gebruikers verwijderen uit organisatie", nDa = "Delegatiereferentie", oDa = "Met een delegatiereferentie kunt u de toegang tot Google Workspace-agenda's voor uw organisatie beheren.", rDa = "Voeg deze Client ID toe in Google Workspace met onderstaande scope", iDa = "Delegatiereferentie ingeschakeld", aDa = "Delegatiereferentie toevoegen", sDa = "Delegatiereferentie bewerken", cDa = "Domein", lDa = "Geen workspace-platforms", uDa = "Workspace-platform", dDa = "Workspace-platforms", _Da = "Beheer workspace-platforms die kunnen worden gebruikt voor delegatiereferenties", pDa = "Workspace-platform bewerken", mDa = "Serviceaccount bewerken", fDa = "Workspace-platform toevoegen", gDa = "Slug", hDa = "Serviceaccount-sleutel JSON", vDa = "Serviceaccount-sleutel JSON bewerken", bDa = "Delegatiereferentie beperkt het toevoegen van meer dan één installatie", yDa = "App succesvol geïnstalleerd en gebruikt gedelegeerde inloggegevens", $Da = "Weet u zeker dat u {{userCount}} gebruikers uit deze organisatie wilt verwijderen?", wDa = "Gebruikers uit team verwijderen", kDa = "Weet je zeker dat je {{userCount}} gebruikers uit dit team wilt verwijderen?", SDa = "Deze gebruiker heeft nog geen planningen ingesteld", EDa = "Deze gebruiker zit niet in een team", xDa = "Deze gebruiker heeft nog geen apps geïnstalleerd", CDa = "E-mailverificatie door boeker vereist", TDa = "Om te zorgen voor de e-mailverificatie door de boeker voordat gebeurtenissen worden gepland", ADa = "Sms-berichten kunnen alleen naar deelnemers worden verzonden als het gebeurtenistype bevestiging vereist.", IDa = "Organisaties", ODa = "Upload Cal Video Logo", NDa = "Update Cal Video Logo", zDa = "Upload Banner", RDa = "Om ervoor te zorgen dat je logo zichtbaar is tegen de donkere achtergrond van Cal video, upload een lichtgekleurde afbeelding in PNG- of SVG-formaat om transparantie te behouden.", PDa = "Andere teams", DDa = "Hier kunt u teams binnen uw organisatie zien waar u geen deel van uitmaakt. U kunt uzelf aan hen toevoegen indien nodig.", LDa = "Je maakt geen deel uit van een organisatie", MDa = "Geen andere teams gevonden", FDa = "Er zijn geen andere teams binnen deze organisatie.", qDa = "Voornaam deelnemer", jDa = "Achternaam deelnemer", VDa = "De voornaam van de persoon die boekt", BDa = "De achternaam van de persoon die boekt", UDa = "Uw maandelijks overzicht", GDa = "Lidnaam", WDa = "Populairste gebeurtenissen", HDa = "Dit is uw overzicht van populaire evenementen voor uw team {{teamName}} van de afgelopen 30 dagen", YDa = "Ik", KDa = "Afspraak niet beschikbaar", ZDa = "Maandelijkse overzichtsmail", XDa = "Maandelijks overzichts-e-mail voor teams", JDa = "Verifieer uw team om het versturen van berichten naar deelnemers in te schakelen", QDa = "Lid verwijderd", e3a = "Mijn beschikbaarheid", t3a = "Beschikbaarheid team", n3a = "Directe beschikbaarheid voor vergaderingen", o3a = "Back-upcode", r3a = "Back-upcodes", i3a = "Elke back-upcode kan slechts één keer gebruikt worden om toegang te verlenen zonder uw authenticator.", a3a = "Back-upcodes gekopieerd!", s3a = "De back-upcode is onjuist.", c3a = "Toegang verloren", l3a = "Geen back-upcodes gevonden. Genereer ze in uw instellingen.", u3a = "Nieuwe organisatie gemaakt: in afwachting van actie", d3a = "Hallo beheerder", _3a = "Een organisatie vereist DNS-configuratie", p3a = 'Een organisatie met de slug "{{orgSlug}}" is gemaakt.<br /><br />Zorg ervoor dat u uw DNS-register configureert om het subdomein dat overeenkomt met de nieuwe organisatie te verwijzen naar waar de hoofd-app draait. Anders werkt de organisatie niet.<br /><br />Hier zijn slechts de basisopties om een subdomein te laten verwijzen naar de app, zodat de organisatieprofielpagina wordt geladen.<br /><br />U kunt dit doen met het A-record:', m3a = "Of het CNAME-record:", f3a = "Zodra u het subdomein heeft geconfigureerd, markeert u de DNS-configuratie als voltooid in Beheerdersinstellingen voor organisaties.", g3a = "Naar Beheerdersinstellingen voor organisaties", h3a = "Organisatie is verwerkt", v3a = "Er is een fout opgetreden bij het verwerken van deze organisatie", b3a = "Een lijst met alle organisaties. Als u een organisatie accepteert, kunnen alle gebruikers met dat e-maildomein zich aanmelden ZONDER e-mailverificatie.", y3a = "Niet-geverifieerd", $3a = "Geverifieerd", w3a = "DNS ontbreekt", k3a = "DNS Geconfigureerd", S3a = "Markeer als DNS geconfigureerd", E3a = "Waarde", x3a = "Uw organisatie is bijgewerkt", C3a = "Dit team heeft geen gebeurtenistypes", T3a = "De plaatsoptie ondersteunt geen meerdere duren", A3a = "Agendagebeurtenis opnemen", I3a = "OAuth", O3a = "OAuth-client aanmaakformulier", N3a = "Dit is het formulier om een nieuwe OAuth-client aan te maken", z3a = "OAuth-client bewerkingsformulier", R3a = "Dit is het formulier om een bestaande OAuth-client te bewerken", P3a = "Recent toegevoegd", D3a = "Koppel al uw agenda's", L3a = "{{appName}} leest beschikbaarheid van al je bestaande agenda's.", M3a = "Personaliseer je planningservaring met workflows", F3a = "Automatisering van de werkstroom", q3a = "Plan voor je team met collectieve en round-robin planning", j3a = "Geen leden gevonden", V3a = "Mapsynchronisatie", B3a = "Directory Naam", U3a = "Directory Provider", G3a = "SCIM Basis URL", W3a = "SCIM Bearer Token", H3a = "SCIM Basis URL gekopieerd", Y3a = "SCIM Bearer Token gekopieerd", K3a = "Je Identity Provider zal om de volgende informatie vragen om SCIM te configureren. Volg de instructies om de setup te voltooien.", Z3a = "Configureer Directory Sync", X3a = "Kies een identity provider om de directory voor je team te configureren.", J3a = "Configureer een identity provider om te beginnen met SCIM.", Q3a = "Directory sync verbinding gecreëerd.", eLa = "Voorzie en verwijder gebruikers met je directory provider.", tLa = "Directory sync verbinding verwijderd.", nLa = "Verbinding Verwijderen", oLa = "Verwijder Directory Sync Verbinding", rLa = "Weet je zeker dat je deze directory sync-verbinding wilt verwijderen?", iLa = "Deze actie kan niet ongedaan worden gemaakt. Dit zal de directory sync-verbinding permanent verwijderen.", aLa = "Gebeurtenisconfiguratie: de duur moet minimaal 1 minuut zijn.", sLa = "Beschikbaarheidsschema's", cLa = "Ongeautoriseerd", lLa = "{{clientName}} wil graag toegang tot uw {{appName}}-account", uLa = "Account of team selecteren", dLa = "Hierdoor kan {{clientName}}", _La = "U koppelen aan uw persoonsgegevens van {{clientName}}", pLa = "Uw persoonsgegevens bekijken, waaronder alle persoonsgegevens die u openbaar heeft gemaakt", mLa = "Uw primaire e-mailadres bekijken", fLa = "Koppelen met uw geïnstalleerde apps", gLa = "Uw gebeurtenistypes lezen, bewerken en verwijderen", hLa = "Uw beschikbaarheid lezen, bewerken en verwijderen", vLa = "Uw boekingen lezen, bewerken en verwijderen", bLa = "Dit toestaan voor {{clientName}}?", yLa = "Door op Toestaan te klikken, geeft u deze app toestemming om uw gegevens te gebruiken in overeenstemming met hun gebruiksvoorwaarden en privacybeleid. U kunt de toegang verwijderen in de {{appName}} App Store.", $La = "Toestaan", wLa = "Deze gebruiker heeft de onboarding nog niet voltooid. U kunt diens beschikbaarheid pas instellen nadat ze men de onboarding heeft voltooid.", kLa = "U bekijkt de beschikbaarheid van deze gebruiker. U kunt alleen uw eigen beschikbaarheid bewerken.", SLa = "U kunt dit per gebeurtenis overschrijven in Geavanceerde instellingen voor elk gebeurtenistype.", ELa = "Beschikbaarheid van gebruiker bewerken: {{username}}", xLa = "Uitnodiging opnieuw versturen", CLa = "De uitnodiging is opnieuw verstuurd.", TLa = "SAML", ALa = "Klant toevoegen", ILa = "Na het kopiëren van het geheim kunt u het niet meer bekijken", OLa = "Nieuwe klant toevoegen", NLa = "Nieuwe gebruiker toevoegen", zLa = "Deze app is nog niet ingesteld", RLa = "als CSV", PLa = "Mijn agenda overleggen", DLa = "Door uw agenda te koppelen accepteert u ons privacybeleid en onze gebruiksvoorwaarden. U kunt de toegang op elk moment weer intrekken.", LLa = "Bekijk uw agendagebeurtenissen om dubbele boekingen te voorkomen.", MLa = "Deelnemen aan {{eventLocationType}}", FLa = "Probleemoplossing", qLa = "Agenda's die we controleren op conflicten", jLa = "Beschikbaarheidsroosters", VLa = "Kalenders beheren", BLa = "Beschikbaarheidsroosters beheren", ULa = "Vergrendeld", GLa = "Ontgrendeld", WLa = "Tijdzone vergrendelen op boekingspagina", HLa = "Om de tijdzone op de boekingspagina te vergrendelen, handig voor persoonlijke gebeurtenissen.", YLa = "Je kunt slechts één betalingsapp per evenementtype inschakelen.", KLa = "Voer het nummer in internationaal formaat in.", ZLa = "Kalender installeren", XLa = "Gemerkt subdomein", JLa = "Krijg je eigen gemerkte subdomein, zoals acme.cal.com", QLa = "Inzichten voor de hele organisatie", eMa = "Begrijp hoe je hele organisatie tijd besteedt", tMa = "Speciale onboarding en technische ondersteuning", nMa = "Pas je planningservaring aan met je eigen logo, kleuren en meer", oMa = "Onbeperkte teams", rMa = "E-mail verifiëren", iMa = "Voer het e-mailadres in dat voor deze boeking is gebruikt om door te gaan met annulering", aMa = "E-mail komt niet overeen met het e-mailadres van de boeking", sMa = "Voeg zoveel subteams toe als je nodig hebt voor je organisatie", cMa = "Gecombineerde facturering", lMa = "Geavanceerde beheerde evenementtypes", uMa = "Voeg een enkele creditcard toe om voor alle abonnementen van je team te betalen", dMa = "Onderneming", _Ma = "Upgrade naar Enterprise om je Organisatie te creëren", pMa = "Creëer je Organisatie", mMa = "Organisatie aanmaken", fMa = "Upgrade naar Organisaties en ontvang een subdomein, uniforme facturering, inzichten, uitgebreide whitelabeling en meer", gMa = "Upgrade naar Enterprise en krijg toegang tot Active Directory Sync, SCIM Automatische Gebruikersprovisioning, Cal.ai Voice Agents, Admin API's en meer!", hMa = "Je kunt slechts één betalingsapp per evenementtype inschakelen", vMa = "Teams die lid zijn van deze organisatie worden ook verwijderd samen met hun afspraaktypes", bMa = "Gebruikers die deel uitmaakten van de organisatie worden niet verwijderd, maar hun gebruikersnamen worden gewijzigd zodat ze buiten de organisatie kunnen bestaan", yMa = "Gebruikersafspraaktypes die zijn aangemaakt nadat de gebruiker in de organisatie zat, worden verwijderd", $Ma = "Gemigreerde gebruikersafspraaktypes worden niet verwijderd", wMa = "{{organizationName}} verwijderen?", kMa = "Gepubliceerd", SMa = "Niet gepubliceerd", EMa = "Publiceren", xMa = "Open de probleemoplosser en ontdek wat er mis is met je schema", CMa = "Hulp nodig?", TMa = "Probleemoplosser", AMa = "Te bellen nummer", IMa = "Naam gast", OMa = "E-mail gast", NMa = "Bedrijf gast", zMa = "Installeer een kalender", RMa = "Direct boeken", PMa = "Laat mensen direct boeken", DMa = "Upgrade naar Enterprise en laat gasten deelnemen aan een direct gesprek waar deelnemers meteen in kunnen springen. Dit is alleen voor team evenementtypes", LMa = "Wil je niet wachten?", MMa = "Vergadering gestart", FMa = "Betalen om te boeken", qMa = "Laat AI-agenten voor je boeken", jMa = "Boeking niet gevonden", VMa = "Boekingsplaatsen zijn vol", BMa = "Ontbrekende betalingsgegevens", UMa = "Ontbrekende betalingsapp-id", GMa = "Niet genoeg beschikbare plaatsen voor de boeking", WMa = "{{username}} is momenteel even weg.", HMa = "In de tussentijd zal {{profile.username}} alle nieuwe geplande vergaderingen namens {{username}} beheren.", YMa = "Afwezig", KMa = "Laat je boekers weten wanneer je afwezig bent.", ZMa = "Verzoek versturen", XMa = "Startdatum en einddatum zijn vereist", JMa = "Startdatum moet voor de einddatum liggen", QMa = "Startdatum moet in de toekomst liggen", e4a = "Gebruiker niet gevonden", t4a = "Kan niet naar zichzelf doorverwijzen", n4a = "Afwezigheidsvermelding bestaat al", o4a = "Afwezigheidsvermelding-id vereist", r4a = "Er is al een boekingsomleiding van die gebruiker naar jou.", i4a = "Nieuwe vermelding succesvol aangemaakt", a4a = "Boekingsomleidingsmelding", s4a = "Boekingsomleidingsmelding", c4a = "Je hebt een boekingsomleiding ontvangen van {{eventOwner}}, zodat hun profielkoppelingen naar die van jou worden omgeleid voor de tijdsperiode {{dates}}.", l4a = "Melding van wijziging in boekingsomleiding", u4a = "Melding van Wijziging in Boekingsomleiding", d4a = "Je boekingsomleiding van {{eventOwner}} voor de tijdsperiode {{oldDates}} is bijgewerkt. De nieuwe tijdsperiode voor de omleiding is {{dates}}.", _4a = "Melding van annulering van boekingsomleiding", p4a = "Melding van Annulering van Boekingsomleiding", m4a = "Je boekingsomleiding van {{eventOwner}} voor de tijdsperiode {{dates}} is geannuleerd.", f4a = "Je hebt dit boekingsomleidingsverzoek geaccepteerd.", g4a = "Je hebt dit boekingsomleidingsverzoek afgewezen.", h4a = "Kopieer link om verzoek te delen", v4a = "Verzoek om omleiding van boeking", b4a = "Selecteer teamlid", y4a = "Gaat u weg? Markeer eenvoudig uw profiel als niet beschikbaar voor een bepaalde periode.", $4a = "Geef een link naar een teamlid wanneer u afwezig bent", w4a = "Geef een link naar een teamlid wanneer u afwezig bent (Teamplan vereist)", k4a = "Lijst van onbeschikbaarheid buiten kantoor", S4a = "Invoer succesvol verwijderd", E4a = "Inschrijving succesvol bewerkt", x4a = "Tijdelijk afwezig?", C4a = "Voeg een omleiding toe", T4a = "Invoer maken", A4a = "Tijdsbereik", I4a = "Voeg alle teamleden toe, inclusief toekomstige leden", O4a = "Omleiden naar", N4a = "Moeite met het vinden van een tijd?", z4a = "Meer weergeven", R4a = "Stuur parameters door zoals ?email=...&name=... en meer", P4a = "Plan vergaderingen wanneer iedereen beschikbaar is of roteer door teamleden", D4a = "laagste", L4a = "laag", M4a = "gemiddeld", F4a = "hoog", q4a = "hoogste", j4a = "Stuur boeker naar", V4a = "Stel prioriteit in", B4a = "Stel gewicht in", U4a = "Schakel gewichten in", G4a = "Prioriteit voor {{userName}}", W4a = "Gewichten bepalen hoe afspraken worden verdeeld onder hosts. <0>Meer informatie</0>", H4a = "Gewicht voor {{userName}}", Y4a = "prioriteit wijzigen", K4a = "Gebruik veldidentificatoren als variabelen voor je aangepaste evenementomleiding", Z4a = "Gebruik veldidentificatoren als variabelen voor je aangepaste evenementomleiding (bijv. {{variable}})", X4a = "Account is al gekoppeld", J4a = "E-mail versturen", Q4a = "Bel deelnemer met Cal.ai spraakassistent", e5a = "Bel om boeking te bevestigen", t5a = "2 uur voor aanvang van het evenement", n5a = "Cal.ai agent configuratie", o5a = "Kies ten minste één evenementtype om een testgesprek te maken.", r5a = "Markeren als no-show", i5a = "No-show markering verwijderen", a5a = "Account succesvol ontkoppeld", s5a = "Er is een fout opgetreden bij het ontkoppelen van het account", c5a = "Reisschema", l5a = "Plan je reis van tevoren om je bestaande schema in een andere tijdzone te behouden en te voorkomen dat je midden in de nacht wordt geboekt.", u5a = "Wijziging tijdzone plannen", d5a = "Datum", _5a = "Voer de algemene prompt voor de agent in", p5a = "Dit overlapt met een bestaand schema. Kies een andere datum.", m5a = "Ontvang meldingen wanneer je team geen beschikbaarheid heeft", f5a = "Beheerders ontvangen e-mailmeldingen wanneer een gebruiker probeert een teamlid te boeken en wordt geconfronteerd met 'Geen beschikbaarheid'. We sturen deze e-mail na twee voorvallen en herinneren je elke 7 dagen per gebruiker.", g5a = "SMS-meldingen uitschakelen voor alleen-telefoon evenementtypes", h5a = "Schakel geautomatiseerde SMS-meldingen uit voor evenementtypes die alleen telefoonnummer (attendeePhoneNumber) als verplichte vraag hebben met e-mail als optioneel of niet vereist", v5a = "Uw huidige plan", b5a = "$37 per gebruiker per maand", y5a = "Beheer privacy-instellingen voor uw organisatie", $5a = "Privacy", w5a = "Nieuwe teams vallen onder uw organisatie", k5a = "Groepsnaam toevoegen", S5a = "Groepsnaam", E5a = "Routers", x5a = "Primair", C5a = "Maak primair", T5a = "E-mailadres toevoegen", A5a = "E-mailadressen toevoegen", I5a = "Voeg een e-mailadres toe om uw primaire te vervangen of als alternatief e-mailadres voor uw evenementtypes te gebruiken.", O5a = "Bevestig uw e-mailadres", N5a = "$t(hey_there) {{name}}, bevestiging van je boeking op {{date}}.", z5a = "De voornaam van de persoon die boekt", R5a = "De achternaam van de persoon die boekt", P5a = "Naam van de planner", D5a = "Uw voornaam", L5a = "We hebben een e-mail gestuurd naar <strong>{{email}}</strong>. Klik op de link in de e-mail om dit adres te verifiëren.", M5a = "Stuur evenementdetails naar", F5a = "Plan tijdzone zonder einddatum", q5a = "Selecteer leden", j5a = "Wat moeten we doen met de bestaande evenementtypes van uw lid?", V5a = "Alle individuele evenementtypen van uw leden (behalve beheerde) worden permanent verwijderd. Ze zullen geen nieuwe kunnen aanmaken.", B5a = "De individuele evenementtypen van uw leden worden verborgen (behalve beheerde) van profielen, maar de links blijven actief. Ze zullen geen nieuwe kunnen aanmaken.", U5a = "Verberg individuele evenementtypen", G5a = "Verwijder individuele evenementtypen", W5a = "Blokkeer het aanmaken van individuele evenementtypen", H5a = "Voorkom dat leden hun eigen evenementtypen aanmaken.", Y5a = "Toevoegen aan evenementtype", K5a = "Maak een accountwachtwoord aan", Z5a = "Account aanmaken met SAML", X5a = "Het aanmaken van een accountwachtwoord is mislukt", J5a = "Kan geen accountwachtwoord aanmaken voor cal-accounts", Q5a = "Kan geen accountwachtwoord aanmaken voor reeds bestaande accounts", e6a = "U heeft geen accountwachtwoord, maak er een aan door naar Beveiliging -> Wachtwoord te navigeren. U kunt niet loskoppelen totdat een accountwachtwoord is aangemaakt.", t6a = "Koppel verbonden account los", n6a = "Het loskoppelen van uw verbonden account zal de manier waarop u inlogt veranderen. U kunt alleen inloggen met e-mail + wachtwoord.", o6a = "Ik ga akkoord met het privacybeleid en het gebruik van cookies", r6a = "Bel", i6a = "Sla round robin-toewijzing over als contact in Salesforce bestaat", a6a = "URL moet het e-mailadres van de contactpersoon als parameter bevatten, bijv. ?email=contactEmail", s6a = "Selecteer Account", c6a = "Installeer {{appName}} op uw persoonlijke account of op een teamaccount.", l6a = "Selecteer Evenementtypen", u6a = "Op welk evenementtype wilt u {{appName}} installeren?", d6a = "Configureer {{appName}}", _6a = "Rond de app-configuratie af. Je kunt deze instellingen later wijzigen.", p6a = "al geïnstalleerd", m6a = "Niet gespecificeerd", f6a = "Vakantie", g6a = "Reis", h6a = "Ziekteverlof", v6a = "Feestdag", b6a = "Doorsturen naar <0>{{username}}</0>", y6a = "Geen doorgifte", $6a = "Maak een OOO", w6a = "Communiceer aan je boekers wanneer je niet beschikbaar bent voor boekingen. Ze kunnen je nog steeds boeken na je terugkeer of je kunt ze doorsturen naar een teamlid.", k6a = "{{displayName}} is OOO", S6a = "<0>{{displayName}}</0> kan hun vergaderingen aannemen terwijl ze weg zijn.", E6a = "Boek {{displayName}}", x6a = "Selecteer reden", C6a = "Ga Out of Office", T6a = "Bewerk Afwezigheidsmelding", A6a = "Feedback indienen", I6a = "Je gastheer is niet komen opdagen", O6a = "Je kunt een andere vergadering met hen plannen", N6a = "Hoe kunnen we onze service verbeteren?", z6a = "Wat vond je het leukst?", R6a = "Beoordeling", P6a = "Beoordeeld", D6a = "Niet beoordeeld", L6a = "Beoordelings-url", M6a = "De URL voor het feedbackformulier voor beoordelingen", F6a = "No-show url", q6a = "De URL voor No Show Feedback", j6a = "Geen ondersteuning nodig?", V6a = "Ondersteuning verbergen", B6a = "Gemiddelde beoordelingen", U6a = "No-show (host)", G6a = "No-show (gast)", W6a = "Recente beoordelingen", H6a = "Geen beoordelingen ingediend", Y6a = "Voeg een workflow met 'Beoordeling' toe om beoordelingen na vergaderingen te verzamelen", K6a = "Meeste no-shows", Z6a = "Hoogst beoordeeld", X6a = "Laagst beoordeeld", J6a = "Leden met de hoogste beoordeelde vergaderingen", Q6a = "Leden met de laagste beoordeelde vergaderingen", eFa = "CSAT-score", tFa = "Vergrendelde SMS", nFa = "Vertrekken zonder iemand toe te wijzen?", oFa = "Weet je zeker dat je dit evenement wilt verlaten zonder deelnemers toe te voegen?", rFa = "Als je niemand toewijst voor dit evenement, zal er geen beschikbaarheid worden getoond aan boekers.", iFa = "Ga terug en wijs toe", aFa = "Vertrekken zonder toe te wijzen", sFa = "Door verder te gaan, ga je akkoord met onze <0>Voorwaarden</0> en <1>Privacybeleid</1>.", cFa = "Door verder te gaan ga je akkoord met onze", lFa = "Voorwaarden", uFa = "Altijd {{x}} dagen beschikbaar", dFa = "Verplaatst het {{x}}-daagse boekingsvenster elke dag automatisch vooruit, zodat je agenda altijd de komende {{x}} dagen aan beschikbare tijdslots toont.", _Fa = "Teamabonnement succesvol opgezegd", pFa = "Fout bij het opzeggen van het teamabonnement", mFa = "Er is een fout opgetreden bij het proberen te abonneren op het platformplan, probeer het later opnieuw", fFa = "Er is een fout opgetreden bij het bijwerken van de OAuth-client, probeer het later opnieuw", gFa = "Er is een fout opgetreden bij het aanmaken van de OAuth-client, probeer het later opnieuw", hFa = "Kleur van evenementtype", vFa = "Dit wordt alleen gebruikt voor het onderscheiden van evenementtypes en boekingen binnen de app. Het wordt niet getoond aan boekers.", bFa = "Markeren als no-show", yFa = "{{x}} gemarkeerd als no-show", $Fa = "{{x}} niet langer gemarkeerd als no-show", wFa = "triggers voor alle evenementtypes van het team en persoonlijke evenementtypes van alle teamleden", kFa = "Beheer instellingen voor je team", SFa = "No-show status bijgewerkt voor deelnemers", EFa = "E-mail gekopieerd", xFa = "Telefoonnummer gekopieerd", CFa = "Gebruiker is een in afwachting zijnd lid van de organisatie", TFa = "Gebruiker is al uitgenodigd of een lid", AFa = "Gebruiker is lid van een organisatie waar dit team geen deel van uitmaakt.", IFa = "Boeking is opnieuw toegewezen", OFa = "Opnieuw toewijzen", NFa = "Boeking opnieuw toewijzen aan een andere beschikbare round robin host", zFa = "Teamlid toewijzen", RFa = "Overschrijf welk teamlid je wilt toewijzen.", PFa = "Geen beschikbare hosts", DFa = "Round robin host opnieuw toewijzen", LFa = "Niet naar de ICS-feed schrijven", MFa = "Herschikken is niet mogelijk omdat het evenement is verlopen", FFa = "Dit evenement is verlopen", qFa = "Contacten overslaan als ze niet bestaan in {{appName}}", jFa = "Als je ICS-link alleen-lezen is (bijv. Proton Calendar), vink het vakje hierboven aan om fouten te voorkomen. Je moet je agenda handmatig bijwerken voor wijzigingen.", VFa = "Attributen", BFa = "Nieuw attribuut", UFa = "Attributen toevoegen", GFa = "Voeg attributen toe aan je teamleden", WFa = "Nieuwe optie", HFa = "Lid bijwerken", YFa = "Kenmerk", KFa = "Maak een kenmerk aan voor je teamleden", ZFa = "Bewerk een kenmerk voor je teamleden", XFa = "Attribuut succesvol bijgewerkt", JFa = "Attribuut succesvol verwijderd", QFa = "Attributen succesvol bewerkt", eqa = "Beheer attributen voor je teamleden", tqa = "Bewerk attributen voor je teamleden", nqa = "Terug naar attributen", oqa = "Weet je zeker dat je deze optie wilt verwijderen?", rqa = "Deze optie is toegewezen aan {{numberOfUsers}} leden. Het verwijderen ervan zal het uit hun profiel verwijderen.", iqa = "Schakel standaard e-mails naar deelnemers uit met betrekking tot dit type evenement", aqa = "Schakelt standaard e-mailcommunicatie uit met betrekking tot dit type evenement, inclusief boekingsbevestigingen, herinneringen en annuleringen.", sqa = "Schakel standaard e-mails naar hosts uit met betrekking tot dit type evenement", cqa = "Typ bevestigen om door te gaan", lqa = "E-mail uitschakelen", uqa = "Geef Admin API-toegang", dqa = "Admin API-toegang intrekken", _qa = "Voeg {{calendar}} kalender toe", pqa = "Apple Agenda verbinden", mqa = "Verbonden Apple Agenda", fqa = "Apple Agenda controleren", gqa = "Google Agenda verbinden", hqa = "Verbonden Google Agenda", vqa = "Google Agenda controleren", bqa = "Outlook Agenda verbinden", yqa = "Verbonden Outlook-agenda", $qa = "Outlook-agenda controleren", wqa = "Verbinden met Stripe", kqa = "Stripe verbonden", Sqa = "Stripe-gegevens controleren", Eqa = "Variabelen voor boekingsvraagreacties", xqa = "Beheerd door {{teamAdmins}}", Cqa = "{{count}} opties", Tqa = "Opnieuw plannen met dezelfde Round-Robin host", Aqa = "Opnieuw geplande evenementen worden toegewezen aan dezelfde host als oorspronkelijk gepland", Iqa = "Invoer uitschakelen als de URL-identificatie vooraf is ingevuld", Oqa = "Boekingslimieten", Nqa = "Boekingslimieten voor teamleden voor alle soorten teamevenementen", zqa = "Beperk hoe vaak leden kunnen worden geboekt voor alle team evenementtypen", Rqa = "Boekingslimieten succesvol bijgewerkt", Pqa = "U bent niet gemachtigd om deze wijziging in de boeking aan te brengen", Dqa = "Delegatiereferentie uitgeschakeld", Lqa = "Overeenkomende leden", Mqa = "{{x}} overeenkomende leden", Fqa = "Wachtrij voor overeenkomende leden (op basis van kenmerkengewicht)", qqa = "Wachtrij voor overeenkomende leden (op basis van toewijzingsgewicht)", jqa = "Geen overeenkomende leden. Er wordt teruggevallen op de teamleden die aan het type evenement zijn toegewezen.", Vqa = "Geen overeenkomende leden. Er wordt teruggevallen op de teamleden die aan het evenementtype zijn toegewezen. Overweeg een fallback toe te voegen of de logica van using_fallback_members te corrigeren", Bqa = "Verberg details van kalendergebeurtenissen op gedeelde kalenders", Uqa = "Wanneer een kalender wordt gedeeld, zijn gebeurtenissen zichtbaar voor lezers, maar hun details zijn verborgen voor degenen zonder schrijfrechten.", Gqa = "Laatste {{count}} dagen", Wqa = "Maand tot nu toe", Hqa = "Jaar tot nu toe", Yqa = "Aangepaste periode", Kqa = "Restitutiebeleid", Zqa = "Altijd", Xqa = "Nooit", Jqa = "Betalingsoptie", Qqa = "Indien geannuleerd", eja = "voor", tja = "Toon alle kolommen", nja = "Kolommen wisselen", oja = "Geen kolommen gevonden", rja = "Bij boeking, voeg evenementen toe en nieuwe deelnemers als:", ija = "Lead", aja = "Contact onder een account", sja = "Sla het aanmaken van {{entry}} record over als deze niet in Salesforce bestaat", cja = "Als de contactpersoon niet onder een account bestaat, maak een nieuwe lead van de deelnemer", lja = "Maak een nieuw contact onder een account op basis van het e-maildomein van de deelnemer en bestaande contacten", uja = "Eigenaar van record wijzigen bij boeking", dja = "Attribuuttoewijzing in bulk", _ja = "Dit resulteert in het tonen van een aangepast bericht. Probeer het antwoord te wijzigen om naar een evenement te routeren", pja = "Dit resulteert in een doorverwijzing naar {{externalUrl}}. Probeer het antwoord te wijzigen om naar een evenement te routeren", mja = "Mogelijke host", fja = "Huidige routeringsstatus", gja = "Boeking omleiden", hja = "Leid de boeking om naar verschillende teamleden", vja = "Nieuwe route verifiëren", bja = "Omleiden", yja = "Nieuwe routeringsstatus", $ja = "Als de deelnemer in Salesforce bestaat, boek direct met de eigenaar", wja = "Entiteit om eigenaar van te controleren voor directe boeking", kja = "Account", Sja = "Kies hostschema's", Eja = "U kunt een ander schema selecteren voor elke host. Standaard is het standaardschema van elke host geselecteerd.", xja = "Geen hosts toegewezen, voeg hosts toe in het toewijzingstabblad.", Cja = "Handmatig round robin host opnieuw toewijzen", Tja = "Wijs handmatig een round robin host opnieuw toe aan een andere beschikbare host", Aja = "Wijs round robin host opnieuw toe aan een andere beschikbare host", Ija = "Nieuwe gebruiker is geen geldige round robin host voor dit afspraaktype", Oja = "Nieuwe gebruiker is een vaste host voor dit afspraaktype", Nja = "Opnieuw plannen met hetzelfde tijdslot", zja = "Opnieuw plannen met hetzelfde tijdslot van het nieuwe evenement", Rja = "Opnieuw plannen naar het nieuwe evenement met een ander tijdslot", Pja = "Opnieuw plannen met een ander tijdslot", Dja = "We hebben geen ID voor het nieuwe evenement. Ga naar het Routeringsformulier en sla het opnieuw op.", Lja = "Boeking succesvol omgeleid. U wordt doorgestuurd naar de boekingspagina", Mja = "Bij boeking, schrijf naar event object", Fja = "Veldnaam", qja = "Nieuw veld toevoegen", jja = "Je hebt geen toegang om deze boeking om te leiden", Vja = "Formulierreactie niet gevonden", Bja = "Contacteigenaar", Uja = "Niet gevonden", Gja = "Gebruik van fallback-leden", Wja = "Gekozen route", Hja = "Attribuutlogica komt overeen", Yja = "Attribuutlogica fallback komt overeen", Kja = "Alle toegewezen leden van het team-evenementtype. Overweeg enkele attribuutregels toe te voegen.", Zja = "Alle toegewezen leden van het team-evenementtype. Overweeg enkele attribuutregels toe te voegen aan de fallback.", Xja = "Alle toegewezen leden van het team-evenementtype. Overweeg de fallback aan te passen om een match te krijgen.", Jja = "Waarschuwing", Qja = "Fallback: Als er geen teamleden overeenkomen, gebruik dan degenen die aan de volgende criteria voldoen (standaard alle toegewezen teamleden van het evenement)", eVa = "Fallback-waarschuwing", tVa = "Niet nodig", nVa = "Host niet beschikbaar", oVa = "Host beschikbaar", rVa = "Weet je zeker dat je deze boeking wilt toewijzen aan een niet-beschikbare host?", iVa = "Weet je zeker dat je deze boeking opnieuw wilt toewijzen?", aVa = "Ja, opnieuw toewijzen", sVa = "Filteren op kenmerken", cVa = "Reden voor opnieuw toewijzen", lVa = "Het wijzigen van het veldtype kan gegevensverlies veroorzaken. Maak in plaats daarvan een nieuw veld aan.", uVa = "Opnieuw toegewezen door", dVa = "rij", _Va = "rijen", pVa = "Tijdzone deelnemer", mVa = "Starttijd evenement in tijdzone deelnemer", fVa = "Starttijd evenement in tijdzone deelnemer", gVa = "Eindtijd evenement in tijdzone deelnemer", hVa = "Eindtijd evenement in tijdzone deelnemer", vVa = "Maak een evenement aan op het contact, indien aanwezig. Anders terugvallen op lead", bVa = "Eigenaarsnaam om te wijzigen", yVa = "Geen filter ingesteld", $Va = "Boeking test succesvol", wVa = "De testrun is succesvol afgerond.", kVa = "Je hebt geen toegang tot deze pagina", SVa = "Om deze pagina te bekijken of ermee te communiceren, moet je over admin- of eigenaarsrechten beschikken", EVa = "Veldtype", xVa = "Wanneer schrijven", CVa = "Bij boeking, schrijf naar een aangepast veld op het {{record}}-record van de deelnemer", TVa = "Bij elke boeking", AVa = "Alleen als het veld leeg is", IVa = "Startdatum boeking", OVa = "Aanmaakdatum boeking", NVa = "Boeking opnieuw toegewezen aan {{host}}", zVa = "Geen contacteigenaar", RVa = "Routeringsformulieren aangemaakt", PVa = "Totaal aantal reacties", DVa = "Totaal aantal reacties zonder boeking", LVa = "Totaal aantal reacties met boeking", MVa = "Geen boekingen", FVa = "Formuliernaam", qVa = "Boeking", jVa = "Geen boeking", VVa = "Geboekt door", BVa = "Aangemaakt op", UVa = "Boekingsstatus", GVa = "Geboekt op", WVa = "Ingediend op", HVa = "Kopieer doorverwijzings-URL", YVa = "Doorverwijzings-URL bij afsluiten", KVa = "Totaal aantal boekingen per periode", ZVa = "Doorverwezen naar per periode", XVa = "Per dag", JVa = "Per week", QVa = "Per maand", eBa = "Toewijzingsreden", tBa = "Toegang geweigerd", nBa = "Contacteigenaar zal de Round Robin host zijn indien beschikbaar", oBa = "Nieuwe deelnemers toevoegen als", rBa = "Contacteigenaar wordt niet geforceerd (kan nog steeds host zijn als het overeenkomt met de attributen en Round Robin criteria)", iBa = "Routeer naar een gebruiker die overeenkomt met een zoekveld op een account", aBa = "Salesforce-optie", sBa = "Zoekveldnaam", cBa = "Als de deelnemer een gratis e-maildomein heeft, sla dan de eigendomscontrole over en gebruik round robin zoals normaal", lBa = "Is", uBa = "Is niet", dBa = "Bevat", _Ba = "Bevat niet", pBa = "Begint met", mBa = "Eindigt met", fBa = "Is leeg", gBa = "Is niet leeg", hBa = "Titel en beschrijving automatisch vertalen", vBa = "Titels en beschrijvingen automatisch vertalen naar de browsertaal van de bezoeker met behulp van AI.", bBa = "Distributie", yBa = "Maakt het mogelijk om de distributie te optimaliseren voor maximale beschikbaarheid of voor een meer gebalanceerde toewijzing.", $Ba = "Maximale beschikbaarheid", wBa = "Stelt boekers in staat om afspraken te maken wanneer een host beschikbaar is. Gebruik dit om het aantal potentiële afspraken te maximaliseren en wanneer de gelijke verdeling van afspraken over hosts minder belangrijk is.", kBa = "Evenredige verdeling", SBa = "We monitoren hoeveel boekingen er bij elke host zijn gemaakt en vergelijken dit met anderen. Hosts die te ver voorlopen worden tijdelijk uitgeschakeld zodat boekingen gelijkmatig worden verdeeld.", EBa = "Gewichten bewerken", xBa = "Gewichten succesvol bijgewerkt", CBa = "Vereist alleen bevestiging voor gratis e-mailproviders (bijv. @gmail.com, @outlook.com)", TBa = "E-mailadressen uitsluiten die ... bevatten", ABa = "E-mailadressen moeten bevatten ...", IBa = "Voer een geldig zakelijk e-mailadres in", OBa = "Je mag niet boeken met dit e-maildomein. Neem contact op met de eigenaar van deze link.", NBa = "Kolommen zoeken", zBa = "Zoekopties", RBa = "Openbaar organisatieprofiel uitschakelen en doorverwijzen", PBa = "Verwijst {{orgSlug}}.cal.com door naar {{destination}}", DBa = "Enkele selectie", LBa = "Meervoudige selectie", MBa = "Agenda-conflictinstellingen", FBa = "Selecteer welke agenda's gecontroleerd moeten worden op conflicten", qBa = "Groepsbijeenkomst", jBa = "Weet u zeker dat u deze app wilt verwijderen van", VBa = "App ontkoppelen van", BBa = "Maak geen nieuwe records aan voor gasten die aan de boeking zijn toegevoegd", UBa = "Google Meet", GBa = "Zoom", WBa = "MS Teams Video", HBa = "Vergrendelen voor toewijzing", YBa = "Vergrendeling staat alleen toewijzingen toe via Directory Sync", KBa = "Attribuut succesvol bewerkt", ZBa = "Nieuwe groepsoptie", XBa = "Gewichten ingeschakeld", JBa = "Door gewichten in te schakelen is het mogelijk om een hogere prioriteit toe te kennen aan bepaalde attributen per gebruiker. Hoe hoger het gewicht, hoe hoger de prioriteit.", QBa = "Doorgestuurd", e9a = "Opnieuw toegewezen", t9a = "Sta het verzetten van afgelopen afspraken toe", n9a = "Door deze optie in te schakelen kunnen afgelopen afspraken worden verzet", o9a = "Omgeleid", r9a = "Salesforce toewijzing", i9a = "Router positie", a9a = "Toon overeenkomende hosts", s9a = "Geen actieve wachtrijen voor deze invoer", c9a = "Gewicht", l9a = "Kalibratie", u9a = "Tekort", d9a = "Routeringsformulier", _9a = "Ga terug en sla op", p9a = "Wijzigingen opslaan", m9a = "Verlaten zonder opslaan", f9a = "Weet je zeker dat je wilt verlaten zonder de wijzigingen in je routeringsformulier op te slaan?", g9a = "Er is iets onverwachts gebeurd", h9a = "Je doet een testboeking.", v9a = "Icoon overzicht", b9a = "Iconen overzicht", y9a = "Migreren van team", $9a = "Functie is momenteel uitgeschakeld", w9a = "Kies een optie", k9a = "Voer optiewaarde in", S9a = "Optie verwijderen", E9a = "Gebruik attribuutgewichten", x9a = "Indien ingeschakeld worden alle gewichten binnen het afspraaktype genegeerd", C9a = "Attribuut voor gewichten", T9a = "Beheerde gebruikers", A9a = "Bekijk alle beheerde gebruikers die zijn aangemaakt door je OAuth-client", I9a = "Kun je me vertellen over ", O9a = "Gebruik AI om je vragen te beantwoorden", N9a = "Fout bij het ophalen van het antwoord ", z9a = "Er is een onverwachte fout opgetreden. Probeer het later opnieuw", R9a = "Selecteer OAuth-client", P9a = "Op elke instantie", D9a = "De functie voor delegatiereferenties is niet ingeschakeld voor uw organisatie", L9a = "Interne notitie", M9a = "Reden gedeeld met klant (optioneel)", F9a = "Deze notitie is alleen zichtbaar voor leden van je team", q9a = "Voorinstellingen voor interne annuleringsnotities", j9a = "Maak voorinstellingen voor interne notities die kunnen worden toegepast op boekingen", V9a = "Voorinstellingen voor interne notities zijn succesvol bijgewerkt", B9a = "Voorinstelling toevoegen", U9a = "Autoriseren", G9a = "Volgende", W9a = "Verbergen", H9a = "Tonen", Y9a = "UTM-parameters", K9a = "Geen UTM-parameters beschikbaar.", Z9a = "Oplopend", X9a = "Aflopend", J9a = "Verifieer e-mailwijziging", Q9a = "Credits kopen", eUa = "Credits", tUa = "Gebruikte credits", nUa = "Totaal resterend", oUa = "Je ontvangt 1000 credits per maand, per teamlid", rUa = "Je ontvangt 750 credits per maand, per teamlid", iUa = "Bekijk en beheer credits voor het versturen van sms-berichten", aUa = "Bekijk en beheer credits voor het versturen van SMS-berichten. Eén credit is 1¢ (USD) waard. <0>Meer informatie</0>", sUa = "Eén credit is 1¢ (USD) waard. <0>Meer informatie</0>", cUa = "Extra credits kopen ($0.01 per credit)", lUa = "Je kunt extra credituitgaven bekijken in je uitgavenlogboek", uUa = "Overzicht", dUa = "Organisatie-slug is al in gebruik", _Ua = "Je kunt geen organisatie aanmaken omdat je al deel uitmaakt van een organisatie", pUa = "Je moet de gebruikers-onboarding voltooien voordat je een organisatie kunt aanmaken", mUa = "Gebruik een bedrijfse-mail om een organisatie aan te maken", fUa = "Je kunt geen platformorganisatie aanmaken omdat je al deel uitmaakt van een team", gUa = "Je moet minimaal gepubliceerde teams hebben", hUa = "Je maakt al deel uit van deze organisatie", vUa = "Je maakt deel uit van een andere organisatie, kan geen nieuwe organisatie aanmaken", bUa = "Je maakt deel uit van een andere platformorganisatie, kan geen nieuwe organisatie aanmaken", yUa = "Organisatiebetaling geslaagd", $Ua = "Je organisatie is succesvol aangemaakt", wUa = "Dit kan een paar seconden duren...", kUa = "Status organisatie-onboarding", SUa = "Beschrijving status organisatie-onboarding", EUa = "Betaling mislukt", xUa = "Je betaling is mislukt. Probeer het opnieuw.", CUa = "Je organisatie wordt aangemaakt", TUa = "Organisatie-onboarding al voltooid", AUa = "Organisatie-onboarding bestaat al", IUa = "Organisatie-onboarding niet gevonden", OUa = "Betaling geslaagd!", NUa = "Overdracht onboarding", zUa = "Overdracht onboarding aan de gebruiker", RUa = "Er bestaat al een organisatie met deze slug", PUa = "Je hebt geen toestemming om een organisatie aan te maken voor dit e-mailadres", DUa = "Je hebt geen toestemming om een of meer teams te migreren", LUa = "De organisatie heeft al een abonnement", MUa = "Reset-interval voor gewogen Round Robin", FUa = "Interval", qUa = "Bepaalt hoe vaak de round robin boekingstelling wordt gereset om een evenwichtige verdeling te garanderen.", jUa = "Dagelijks", VUa = "U heeft geen einddatum ingesteld voor uw OOO", BUa = "Mijn OOO", UUa = "Team OOO", GUa = "Beheer de OOO van uw team.", WUa = "Out of Office aanmaken", HUa = "Maak een OOO aan voor een teamlid", YUa = "Bewerk een OOO voor een teamlid", KUa = "Maak OOO aan voor uw team", ZUa = "Communiceer naar boekers wanneer uw teamleden niet beschikbaar zijn voor boekingen. Ze kunnen nog steeds geboekt worden bij hun terugkeer of u kunt ze doorverwijzen naar een ander teamlid.", XUa = "OOO-doorverwijzing is alleen toegestaan naar een lid van hetzelfde team.", JUa = "Er is al een omgekeerde doorverwijzing tussen deze gebruikers.", QUa = "Geen eerdere OOO gevonden", eGa = "Vorige", tGa = "Round Robin-interval succesvol bijgewerkt", nGa = "Proefmodus", oGa = "Inactief teamabonnement", rGa = "Uw teamabonnement is inactief. Controleer uw abonnement of neem contact op met de klantenondersteuning", iGa = "Beperkte toegang tijdens proefperiode. Functie beschikbaar na afloop van de proefperiode.", aGa = "Verwijzingsprogramma", sGa = "Verdien 20% verwijzingsbonus", cGa = "Je hebt een Dub API-sleutel en programma-ID nodig om deze pagina te gebruiken.", lGa = "UID", uGa = "Link", dGa = "rijen per pagina", _Ga = "{{currentRange}} van {{totalItems}}", pGa = "Tip: Je kunt een '+' tussen gebruikersnamen toevoegen: cal.com/anna+brian om een dynamische groepsbijeenkomst te maken", mGa = "U heeft nog geen team", fGa = "U heeft nog geen teamleden", gGa = "Terugkerend evenement ondersteunt geen stoelfunctie. Maak het niet-terugkerend om stoelen in te schakelen.", hGa = "Terugkerende afspraken ondersteunen geen boekingslimiet per boeker. Schakel de boekingslimiet per boeker uit om terugkerende afspraken mogelijk te maken.", vGa = "Stoelfunctie ondersteunt geen terugkerend evenement. Schakel stoelfunctie uit om het terugkerend te maken.", bGa = "Terugkerend evenement ondersteunt geen stoelfunctie. Schakel stoelfunctie uit of maak het evenement niet-terugkerend.", yGa = "Segment", $Ga = "Opgeslagen filters", wGa = "Hernoemen", kGa = "Segment hernoemen", SGa = "Segment verwijderen", EGa = "Segment dupliceren", xGa = "Weet je zeker dat je dit segment wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.", CGa = "Filtersegment bijgewerkt", TGa = "Fout bij het bijwerken van filtersegment", AGa = "Filtersegment gedupliceerd", IGa = "Fout bij het dupliceren van filtersegment", OGa = "Filtersegment verwijderd", NGa = "Fout bij het verwijderen van filtersegment", zGa = "Segment opslaan", RGa = "Segment niet gevonden", PGa = "Filtersegment opgeslagen", DGa = "Geen segmenten", LGa = "Fout bij het opslaan van filtersegment", MGa = 'Wijzigingen opslaan naar "{{name}}"', FGa = "Nieuw segment maken", qGa = "Opslaan voor team", jGa = "Team selecteren", VGa = "Selecteer een team", BGa = "Persoonlijk", UGa = "Teamprofiellink verbergen", GGa = "Verberg de teamprofiellink op boekingspagina's", WGa = "Weergave", HGa = "Kon geen slug vinden om de organisatie te publiceren", YGa = "Keuzelijst", KGa = "Meest geannuleerd", ZGa = "Interfacetaal", XGa = "Stel je voorkeurstaal in voor de boekingsinterface", JGa = "Taal van de browser van de bezoeker", QGa = "Naam of e-mail", eWa = "Als er geen contactpersoon wordt gevonden, val dan terug op de lead-eigenaar als deze bestaat", tWa = "Aankoop van credits mislukt. Probeer het opnieuw of neem contact op met de klantenservice.", nWa = "Minimaal 50 credits vereist", oWa = "Delegatiereferentie inschakelen", rWa = "Geef Cal.com automatisch toegang tot de agenda's van alle organisatieleden door delegatiereferentie in te schakelen.", iWa = "Delegatiereferentie uitschakelen", aWa = "Zodra de delegatiereferentie is uitgeschakeld, moeten organisatieleden die hun agenda's nog niet hebben gekoppeld dit handmatig doen.", sWa = "Laatst actief", cWa = "Lid sinds", lWa = "Laatst bijgewerkt", uWa = "Bij geannuleerde boeking, schrijf naar evenementrecord in plaats van evenement verwijderen", dWa = "Bij elke annulering", _Wa = "Probleem melden", pWa = "Je kunt een ticket indienen op GitHub of je abonnement upgraden om realtime ondersteuning te krijgen met ontwikkelaarsconferenties", mWa = "Issue openen", fWa = "Dit is je huidige abonnement", gWa = "Plan een tijdstip", hWa = "Dit omvat:", vWa = "OAuth-client succesvol bijgewerkt", bWa = "OAuth-client niet gevonden.", yWa = "Abonneren op platform", $Wa = "Fout bij het proberen toegang te krijgen tot webhooks.", wWa = "Webhook bijwerken mislukt.", kWa = "Webhook aanmaken mislukt.", SWa = "Ongeldige link", EWa = "Je hebt momenteel een abonnement op het {{planFirstLetter}}{{planRest}}-abonnement", xWa = "Gebruiker/team", CWa = "Client-ID gekopieerd!", TWa = "Client secret gekopieerd!", AWa = "Het Cal.com-team voert gepland onderhoud uit. Als je vragen hebt, neem dan contact op met de klantenservice.", IWa = "Je betaling is mislukt", OWa = "Controleer je inbox", NWa = "Je account is aangemaakt, maar je premium is niet gereserveerd.", zWa = "We hebben een e-mail gestuurd naar {{email}} met een link om je account te activeren.", RWa = "Zodra je je account activeert, kun je opnieuw proberen je premium gebruikersnaam te kopen of een andere kiezen.", PWa = "Openen in Gmail", DWa = "Geen e-mail ontvangen?", LWa = "Opnieuw verzenden over {{seconds}} seconden", MWa = "Opnieuw verzenden", FWa = "Verificatie-e-mail verzonden", qWa = "Selecteer alle leden", jWa = "Door alle leden te selecteren worden alle toekomstige teamleden toegevoegd wanneer ze aan het team worden toegevoegd.", VWa = "Formulierinstellingen", BWa = "Whitelist-status verwijderen", UWa = "Whitelist gebruikersworkflows", GWa = "Gebruikersworkflows op whitelist geplaatst", WWa = "Gebruikersworkflows van whitelist verwijderd", HWa = "Datum en tijd", YWa = "Dit is een herinnering voor je aankomende evenement.", KWa = "Deze herinnering is geactiveerd door een Workflow in Cal.", ZWa = "Evenement", XWa = "Gepland door", JWa = "Hoe was uw recente ervaring?", QWa = "We werken continu aan betere klantervaringen.", e8a = "Hoe tevreden was u met uw laatste vergadering?", t8a = "heeft u niet deelgenomen aan de vergadering?", n8a = "Hier opnieuw plannen.", o8a = "E-mail van organisator verbergen", r8a = "Je maakt al deel uit van een platformorganisatie, daarom kun je geen nieuwe organisatie aanmaken. Elke gebruiker kan slechts tot één organisatie behoren. Maak een nieuw cal.com-account aan met een ander e-mailadres en gebruik dat account om je te abonneren op het organisatieplan.", i8a = "Je maakt al deel uit van een organisatie, daarom kun je geen platformorganisatie aanmaken. Elke gebruiker kan slechts tot één organisatie behoren. Maak een nieuw cal.com-account aan met een ander e-mailadres en gebruik dat account om je te abonneren op het platformplan.", a8a = "Verberg het e-mailadres van de organisator op het boekingsscherm, in e-mailnotificaties en in agenda-afspraken", s8a = "U &", c8a = "Selecteer een geverifieerd e-mailadres", l8a = "Geverifieerde e-mail toevoegen", u8a = "Geverifieerde e-mails toevoegen", d8a = "Aangepast 'Antwoord-aan' e-mailadres", _8a = "Gebruik een ander e-mailadres als antwoordadres voor bevestigingsmails in plaats van het e-mailadres van de organisator", p8a = "Deze enquête is geactiveerd door een Workflow in Cal.", m8a = "Proefperiode overslaan", f8a = "Teamproefperiodes succesvol overgeslagen", g8a = "Door je telefoonnummer in te voeren, stem je ermee in sms-berichten te ontvangen voor dit evenement. Sms-tarieven kunnen van toepassing zijn.", h8a = "Meer informatie is te vinden in <0>Routeringsinzichten</0>", v8a = "Resultaten", b8a = "Formulier bekijken", y8a = "Stuur STOP om je af te melden voor sms-berichten", $8a = "Je team {{teamName}} heeft bijna geen credits meer", w8a = "Je hebt bijna geen credits meer", k8a = "[Actie vereist] Je team {{teamName}} heeft geen credits meer", S8a = "[Actie vereist] Je hebt geen credits meer", E8a = "Het Cal.com-team {{teamName}} heeft bijna geen credits meer. Om onderbrekingen in de service te voorkomen, koop je extra credits. Als je saldo op is, worden SMS-berichten niet meer verzonden en worden ze in plaats daarvan als e-mails verzonden.", x8a = "Je Cal.com-account heeft bijna geen credits meer. Om onderbrekingen in de service te voorkomen, koop je extra credits. Als je saldo op is, worden SMS-berichten niet meer verzonden en worden ze in plaats daarvan als e-mails verzonden.", C8a = "Je Cal.com-team {{teamName}} heeft geen credits meer. Hierdoor worden SMS-berichten nu via e-mail verzonden. Om weer SMS-berichten te kunnen versturen, koop je extra credits.", T8a = "Je Cal.com-account heeft geen credits meer. Hierdoor worden sms-berichten nu via e-mail verzonden. Om weer sms-berichten te kunnen versturen, koop je extra credits.", A8a = "Huidige saldo: {{balance}} credits", I8a = "Huidige saldo:", O8a = "Melding over je boeking", N8a = "Maandelijkse credits", z8a = "Totaal credits: {{totalCredits}}", R8a = "Resterende credits: {{remainingCredits}}", P8a = "Resterend", D8a = "Totaal", L8a = "Extra credits", M8a = "{{count}} volgende in wachtrij", F8a = "Stuur e-mailreacties naar", q8a = "Onvolledige boekingen", j8a = "Niet-verschenen boekingen meenemen in round robin berekeningen", V8a = "Recente no-show gasten", B8a = "Toont boekingen waarbij alle deelnemers niet zijn komen opdagen, geen gedeeltelijke no-shows", U8a = "Overeenkomend", G8a = "Evenement doorverwijzing", W8a = "Formulier resetten", H8a = "Round Robin-instellingen succesvol bijgewerkt", Y8a = "Verdelingsbasis voor gewogen Round Robin", K8a = "Bepaalt welke gebeurtenistijdstempel wordt gebruikt als basis voor de gewogen round robin-verdeling.", Z8a = "Vereist credits", X8a = "Je hebt voldoende credits op je account nodig om deze functie te gebruiken", J8a = "Beschikbare credits", Q8a = "Rol aanmaken", e7a = "Rollen & rechten", t7a = "Beheer rollen en rechten voor je organisatie", n7a = "Meer informatie over hoe rechten werken", o7a = "Rolnaam", r7a = "Rolnaam is vereist", i7a = "bijv. Verkoopteam, Supportmedewerkers", a7a = "Rolbeschrijving", s7a = "Beschrijf waarvoor deze rol dient en welke rechten deze nodig heeft", c7a = "Standaardrol", l7a = "Aangepaste rol", u7a = "Geavanceerd", d7a = "Zoek machtigingen", _7a = "Alle machtigingen", p7a = "Geen", m7a = "Alleen lezen", f7a = "Alle acties op alle hulpmiddelen", g7a = "Alle hulpmiddelen", h7a = "Evenementen", v7a = "Teams", b7a = "Organisatie", y7a = "Afspraken", $7a = "Inzichten", w7a = "Functies", k7a = "Routeringsformulieren", S7a = "Werkstromen", E7a = "Alle acties", x7a = "Aanmaken", C7a = "Bekijken", T7a = "Wijzigen", A7a = "Verwijderen", I7a = "Beheren", O7a = "Uitnodigen", N7a = "Verwijderen", z7a = "Functie van lid wijzigen", R7a = "Leden weergeven", P7a = "Facturering beheren", D7a = "Team afspraken bekijken", L7a = "Organisatie afspraken bekijken", M7a = "Opnames bekijken", F7a = "Imiteren", q7a = "Rol succesvol aangemaakt", j7a = "Rol succesvol bijgewerkt", V7a = "Rol verwijderen", B7a = "Weet je zeker dat je de rol wilt verwijderen: {{roleName}}. Deze actie kan niet ongedaan worden gemaakt.", U7a = "Rol succesvol verwijderd", G7a = "Fout bij het aanmaken van rol", W7a = "Fout bij het bijwerken van rol", H7a = "Rollen aanmaken", Y7a = "Attributen", K7a = "Organisatieattributen bekijken", Z7a = "Organisatieattributen bijwerken", X7a = "Organisatieattributen verwijderen", J7a = "Organisatieattributen aanmaken", Q7a = "Rollen bekijken", eHa = "Rollen bijwerken", tHa = "Rollen verwijderen", nHa = "Nieuwe werkstromen maken en instellen", oHa = "Instellen vereist", rHa = "Bestaande werkstromen en hun configuraties bekijken", iHa = "Werkstroominstellingen bewerken en wijzigen", aHa = "Werkstromen uit het systeem verwijderen", sHa = "Webhook", cHa = "Beschikbaarheid", lHa = "Afwezigheid", uHa = "Webhooks maken", dHa = "Webhooks bekijken", _Ha = "Webhooks bijwerken", pHa = "Webhooks verwijderen", mHa = "Beschikbaarheid aanmaken", fHa = "Beschikbaarheid bekijken", gHa = "Beschikbaarheid bijwerken", hHa = "Beschikbaarheid verwijderen", vHa = "Afwezigheid aanmaken", bHa = "Afwezigheid bekijken", yHa = "Afwezigheid bijwerken", $Ha = "Afwezigheid verwijderen", wHa = "Volledige beheertoegang tot alle werkstromen", kHa = "Gebeurtenistypes aanmaken", SHa = "Gebeurtenistypes bekijken", EHa = "Gebeurtenistypes bijwerken", xHa = "Gebeurtenistypes verwijderen", CHa = "Alle acties op gebeurtenistypes", THa = "Teams aanmaken", AHa = "Teamdetails bekijken", IHa = "Teaminstellingen bijwerken", OHa = "Team verwijderen", NHa = "Teamleden uitnodigen", zHa = "Teamleden verwijderen", RHa = "Rol van teamleden wijzigen", PHa = "Teamleden imiteren", DHa = "Alle acties op teams binnen organisatieteams", LHa = "Organisatie aanmaken", MHa = "Organisatiedetails bekijken", FHa = "Organisatieleden weergeven", qHa = "Organisatieleden uitnodigen", jHa = "Organisatieleden verwijderen", VHa = "Organisatiefacturering beheren", BHa = "Rol van organisatieleden wijzigen", UHa = "Organisatieleden imiteren", GHa = "Organisatie-instellingen bewerken", WHa = "Alle acties op organisaties", HHa = "Boekingen bekijken", YHa = "Teamboekingen bekijken", KHa = "Organisatieboekingen bekijken", ZHa = "Boekingsopnames bekijken", XHa = "Boekingen bijwerken", JHa = "Alle acties op boekingen", QHa = "Team-inzichten bekijken", eYa = "Team-inzichten beheren", tYa = "Routeringsformulieren maken", nYa = "Routeringsformulieren bekijken", oYa = "Routeringsformulieren bijwerken", rYa = "Routeringsformulieren verwijderen", iYa = "Leesrechten worden automatisch ingeschakeld bij het aanmaken, bijwerken of verwijderen van een resource", aYa = "Beperkingsschema toevoegen", sYa = "Beperk beschikbaarheid van hosts om alleen tijdsloten weer te geven die binnen een specifiek schema vallen.", cYa = "Gebruik tijdzone van de boeker", lYa = "Pas het geselecteerde beperkingsschema toe in de tijdzone van de boeker", uYa = "Dit zal Load Balancing uitschakelen op al je round robin evenementtypes", dYa = "Load Balancing is alleen beschikbaar wanneer de tijdstempelbasis is ingesteld op Boekingsaanmaaktijd", _Ya = "Load balancing is niet beschikbaar met round robin groepen", pYa = "Pas de standaard round robin-instellingen aan voor dit team", mYa = "Round Robin-instellingen succesvol bijgewerkt", fYa = "Aanmaaktijd boeking", gYa = "Starttijd vergadering", hYa = "Getroffen leden", vYa = "Geen leden getroffen door het uitschakelen van delegatiereferentie", bYa = "Download uitgavenlogboek", yYa = "Fout bij het downloaden van uitgavenlogboek", $Ya = "Bied aan om de laatste actieve boeking te verplaatsen naar het gekozen tijdslot", wYa = "Maximaal aantal actieve boekingen voor de boeker overschreden", kYa = "Je hebt al een boeking voor dit evenement op {{date}}. Wil je deze verplaatsen naar de nieuw geselecteerde tijd?", SYa = "Duur moet minimaal {{min}} minu(u)t(en) zijn", EYa = "Duur mag niet langer zijn dan {{max}} minuten (24 uur)", xYa = "Boeken buiten de beschikbaarheid van het beperkingsschema.", CYa = "Beperkingsschema niet gevonden", TYa = "Afbeeldingsgrootte overschreden, gebruik een kleinere afbeelding bij voorkeur in JPEG-formaat", AYa = "Groep toevoegen", IYa = "Routeringstrechter", OYa = "Totaal aantal inzendingen", NYa = "Succesvolle routeringen", zYa = "Geaccepteerde boekingen", RYa = "Licentiesleutel", PYa = "Kies je licentie", DYa = "Selecteer hoe je je Cal.com-implementatie wilt licenseren", LYa = "Gebruik Cal.com onder de AGPLv3 open source licentie", MYa = "Voer licentiesleutel in", FYa = "Toegang tot alle enterprise-functies", qYa = "Vanaf €15/gebruiker per maand", jYa = "Toegang tot alle enterprise-functies", VYa = "Voer je licentiesleutel in", BYa = "Licentiesleutel opslaan", UYa = "Handtekeningtoken (optioneel)", GYa = "Handtekeningtoken wordt gebruikt om te verifiëren dat de licentiesleutel van jou is bij het verhogen van gebruiksgebaseerde facturering. Je kunt het vinden in je aankoopbevestigingsmail. Als je een oudere licentie hebt, kun je dit leeg laten.", WYa = "Heb je een licentie nodig?", HYa = "Licentiesleutel is vereist", YYa = "Ongeldige licentiesleutel", KYa = "Validatie van licentiesleutel mislukt", ZYa = "Bijlagen optioneel", XYa = "Bericht versturen", JYa = "Beschrijf het probleem", QYa = "Bestandsgrootte overschrijdt limiet", eKa = "Ongeldig bestandstype", tKa = "Ongeldig bestandstype. Geaccepteerde types: {{acceptedTypes}}", nKa = "Maximaal aantal bestanden overschreden", oKa = "Bestanden succesvol geüpload", rKa = "Geaccepteerde types: {{acceptedTypes}}; Max. bestandsgrootte: {{maxSize}}", iKa = "Licentiesleutel succesvol opgeslagen", aKa = "Je bekijkt het rapport op basis van je profieltijdzone ({{userTimezone}}), terwijl je browser is ingesteld op tijdzone ({{browserTimezone}})", sKa = "Geoptimaliseerde tijdsloten", cKa = "Tijdsloten rangschikken om beschikbaarheid te optimaliseren.", lKa = "Mislukte boekingen per veld", uKa = "Mislukte boekingen", dKa = "Geen hosts toegewezen aan evenementtype", _Ka = "Cache-status", pKa = "Laatst bijgewerkt: {{timestamp}}", mKa = "Gecachte gegevens verwijderen", fKa = "Cache succesvol verwijderd", gKa = "Fout bij verwijderen cache", hKa = "Weet je zeker dat je de gecachte gegevens wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.", vKa = "Ja, cache verwijderen", bKa = "{{remainder}} van {{maximum}} gebruiken over", yKa = "{{remainder}} van {{maximum}} gebruik over", $Ka = "Verloopt op {{date}}, einde van de dag", wKa = "Eenmalig gebruik", kKa = "Tijdgebaseerde vervaldatum", SKa = "Gebruiksgebaseerde vervaldatum", EKa = "Aantal gebruiken", xKa = "Verloopt op", CKa = "Maximaal aantal gebruiken", TKa = "Linkinstellingen", AKa = "Deze link is verlopen op {{date}}, einde van de dag", IKa = "Gebruikslimiet bereikt", OKa = "Maximaal aantal gebruiken moet groter zijn dan het huidige aantal gebruiken", NKa = "Deze link is verlopen", zKa = "Deze link kan worden gebruikt voor boekingen tot het einde van {{date}}", RKa = "Deze link kan worden ingesteld om te verlopen na een bepaalde datum", PKa = "Deze link kan worden gebruikt voor {{count}} boeking", DKa = "Deze link kan worden ingesteld om te verlopen na een bepaald aantal boekingen", LKa = "Deze link kan worden gebruikt voor {{count}} boekingen", MKa = "De naam van de trigger-gebeurtenis (bijv. BOOKING_CREATED, BOOKING_CANCELLED)", FKa = "Het tijdstip van de webhook", qKa = "De slug van het gebeurtenistype", jKa = "Agent instellen", VKa = "De naam van het gebeurtenistype", BKa = "De starttijd van de gebeurtenis", UKa = "De eindtijd van de gebeurtenis", GKa = "De beschrijving van de gebeurtenis zoals beschreven in de instellingen van het gebeurtenistype", WKa = "Locatie van de gebeurtenis", HKa = "De UID van de boeking", YKa = "De UID voor het opnieuw plannen", KKa = "Reden voor annulering", ZKa = "Reden voor weigering", XKa = "Naam van de organisator", JKa = "E-mail van de organisator", QKa = "Tijdzone van de organisator (bijv. 'America/New_York', 'Asia/Kolkata')", eZa = "Taalinstelling van de organisator (bijv. 'en', 'fr')", tZa = "Gebruikersnaam van de organisator (bijv. 'john.doe')", nZa = "Gebruikersnaam van de organisator in hun organisatie (bijv. 'john.doe')", oZa = "Naam van de eerste deelnemer", rZa = "E-mail van de eerste deelnemer", iZa = "Tijdzone van de eerste deelnemer", aZa = "Taalinstelling van de eerste deelnemer", sZa = "Naam van het geboekte team", cZa = "Leden van het geboekte team", lZa = "Video-oproep URL voor de vergadering", uZa = "Variabelen verbergen", dZa = "Beschikbare variabelen tonen", _Za = "Evenement en boeking", pZa = "Mensen", mZa = "Teams", fZa = "Metadata", gZa = "Statistieken", hZa = "Boekingsstatus", vZa = "Bezoek", bZa = "Aangepast label op boekingspagina", yZa = "Vergaderlink", $Za = "Sessieresultaat", wZa = "Gesprek aangemaakt", kZa = "Voicemail", SZa = "Mijn boekingen", EZa = "Telefoon", xZa = "Gratis", CZa = "E-mailadres gebruiker", TZa = "Gebruikersnaam", AZa = "Paneel uitklappen", IZa = "Paneel inklappen", OZa = "E-mailverificatie is vereist voor dit afspraaktype", NZa = "Ongeldige verificatiecode opgegeven", zZa = "Je hebt één team", RZa = "Overweeg een organisatie op te zetten om facturering, beheerderstools en analyses voor je team te verenigen.", PZa = "Overweeg een organisatie op te zetten om facturering, beheerderstools en analyses voor je teams te verenigen.", DZa = "Bericht verzonden", LZa = "Bedankt voor je bericht. We nemen zo snel mogelijk contact met je op.", MZa = "Variabelen zoeken", FZa = "Beschrijf het probleem dat je ondervindt, bijv. 'Bezette tijdslots worden als beschikbaar weergegeven', ..., etc.", qZa = "Nog een bericht versturen", jZa = "Bezig met verzenden", VZa = "Geen variabelen gevonden", BZa = "Credits vereist", UZa = "Webgesprekken verbruiken credits. Zorg ervoor dat je voldoende credits hebt om een gesprek te starten.", GZa = "Webgesprekken vereisen credits. Je hebt 0 credits over.", WZa = "Credits kopen", HZa = "Deze actie vereist credits om verder te gaan", YZa = "Naam mag niet langer zijn dan {{max}} tekens", KZa = "Automatisch no-show kosten in rekening brengen voor last-minute annuleringen", ZZa = "Voor geplande starttijd", XZa = "Ik erken dat door de boeking te annuleren binnen {{timeValue}} {{timeUnit}} voor de starttijd, mij de no-show kosten van {{amount, currency}} in rekening worden gebracht", JZa = "Als je vragen hebt, neem dan contact op met de organisator.", QZa = "Boekingstijd", eXa = "Wanneer de boeking is gepland (begin tot eind)", tXa = "Aangemaakt op", nXa = "Wanneer de boeking oorspronkelijk is aangemaakt", oXa = "Gespreksdetails", rXa = "Gesprek-ID", iXa = "Gespreksinformatie", aXa = "Sentiment", sXa = "Reden voor verbreken", cXa = "Gespreksoverzicht", lXa = "Transcriptie", uXa = "Afspraakdetails", dXa = "Agent", _Xa = "Geen transcript beschikbaar", pXa = "Houd er bij het testen van deze workflow rekening mee dat sms'en minimaal 15 minuten van tevoren moeten worden gepland", mXa = "Begin vanaf nul", fXa = "Maak je eigen workflow vanaf nul.", gXa = "Cal.ai sjabloon", hXa = "AI-agents die afspraken boeken, herinneringen sturen en opvolgen!", vXa = "Stem", bXa = "Selecteer stem", yXa = "Selecteer een stem voor je agent", $Xa = "Kies een stem voor je agent", wXa = "Eigenschap", kXa = "Stem-ID", SXa = "Gebruik stem", EXa = "Huidige stem", xXa = "Inkomende agent instellen", CXa = "Configureer een AI-agent om inkomende gesprekken op je telefoonnummer af te handelen", TXa = "Verbind eerst een telefoonnummer", AXa = "Agent instellen voor inkomende gesprekken", IXa = "Agent configureren om inkomende gesprekken af te handelen", OXa = "Inkomende gesprekken", NXa = "Uitgaande gesprekken", zXa = "Inkomende agent succesvol ingesteld", RXa = "Inkomende agent geconfigureerd", PXa = "Inkomende agent instellen", DXa = "Selecteer eerst een evenementtype", LXa = "Configuratie bewerken", MXa = "Inkomende gesprekken kunnen slechts één evenementtype boeken. Selecteer het evenementtype waarbij afspraken worden gepland wanneer bellers je agent bereiken.", FXa = "Inkomende agent instellen voor inkomende gesprekken", qXa = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Voeg uw nieuwe strings hierboven toe ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", jXa = {
  identity_provider: j7i,
  trial_days_left: V7i,
  day_one: B7i,
  day_other: U7i,
  second_one: G7i,
  second_other: W7i,
  upgrade_now: H7i,
  untitled: Y7i,
  accept_invitation: K7i,
  max_characters: Z7i,
  min_characters: X7i,
  calcom_explained: J7i,
  calcom_explained_new_user: Q7i,
  have_any_questions: eHi,
  reset_password_subject: tHi,
  verify_email_subject: nHi,
  verify_email_subject_verifying_email: oHi,
  check_your_email: rHi,
  old_email_address: iHi,
  new_email_address: aHi,
  verify_email_page_body: sHi,
  verify_email_banner_body: cHi,
  verify_email_email_header: lHi,
  verify_email_button: uHi,
  cal_ai_assistant: dHi,
  send_cal_video_transcription_emails: _Hi,
  description_send_cal_video_transcription_emails: pHi,
  verify_email_change_description: mHi,
  verify_email_change_success_toast: fHi,
  verify_email_change_failure_toast: gHi,
  change_of_email: hHi,
  change_of_email_toast: vHi,
  copy_somewhere_safe: bHi,
  verify_email_email_body: yHi,
  verify_email_by_code_email_body: $Hi,
  verify_email_email_link_text: wHi,
  email_verification_code: kHi,
  email_verification_code_placeholder: SHi,
  incorrect_email_verification_code: EHi,
  email_sent: xHi,
  email_not_sent: CHi,
  event_declined_subject: THi,
  event_cancelled_subject: AHi,
  event_reassigned_subject: IHi,
  event_request_declined: OHi,
  customize_calvideo_settings: NHi,
  calvideo_settings_description: zHi,
  disable_recording_for_guests: RHi,
  enable_automatic_transcription: PHi,
  enable_automatic_recording: DHi,
  video_options: LHi,
  edit_event: MHi,
  view_session_details: FHi,
  meeting_session_details: qHi,
  meeting_session: jHi,
  session_id: VHi,
  max_participants: BHi,
  unlimited: UHi,
  ongoing: GHi,
  ended: WHi,
  participants: HHi,
  anonymous_user: YHi,
  session_duration: KHi,
  no_meeting_sessions_found: ZHi,
  not_available: XHi,
  disable_recording_for_organizer: JHi,
  disable_transcription_for_guests: QHi,
  disable_transcription_for_organizer: eYi,
  event_request_declined_recurring: tYi,
  event_request_cancelled: nYi,
  event_request_reassigned: oYi,
  event_reassigned_subtitle: rYi,
  organizer: iYi,
  reassigned_to: aYi,
  need_to_reschedule_or_cancel: sYi,
  you_can_view_booking_details_with_this_url: cYi,
  no_options_available: lYi,
  cancellation_reason: uYi,
  cancelled_by: dYi,
  cancellation_reason_host: _Yi,
  cancellation_reason_placeholder: pYi,
  notify_attendee_cancellation_reason_warning: mYi,
  rejection_reason_placeholder: fYi,
  rejection_reason: gYi,
  rejection_reason_title: hYi,
  rejection_reason_description: vYi,
  rejection_confirmation: bYi,
  manage_this_event: yYi,
  invite_team_member: $Yi,
  invite_team_individual_segment: wYi,
  invite_team_bulk_segment: kYi,
  invite_team_notifcation_badge: SYi,
  your_event_has_been_scheduled: EYi,
  your_event_has_been_scheduled_recurring: xYi,
  accept_our_license: CYi,
  remove_banner_instructions: TYi,
  error_message: AYi,
  refund_failed_subject: IYi,
  refund_failed: OYi,
  check_with_provider_and_user: NYi,
  a_refund_failed: zYi,
  awaiting_payment_subject: RYi,
  meeting_awaiting_payment: PYi,
  dark_theme_contrast_error: DYi,
  light_theme_contrast_error: LYi,
  event_type_color_light_theme_contrast_error: MYi,
  event_type_color_dark_theme_contrast_error: FYi,
  payment_not_created_error: qYi,
  couldnt_charge_card_error: jYi,
  no_available_users_found_error: VYi,
  timeslot_unavailable_book_a_new_time: BYi,
  timeslot_unavailable_short: UYi,
  just_connected_description: GYi,
  unavailable_timeslot_title: WYi,
  booking_time_out_of_bounds_error: HYi,
  request_body_end_time_internal_error: YYi,
  create_calendar_event_error: KYi,
  update_calendar_event_error: ZYi,
  delete_calendar_event_error: XYi,
  already_signed_up_for_this_booking_error: JYi,
  hosts_unavailable_for_booking: QYi,
  fixed_hosts_unavailable_for_booking: eKi,
  round_robin_host_unavailable_for_booking: tKi,
  help: nKi,
  price: oKi,
  paid: rKi,
  refunded: iKi,
  record: aKi,
  transcribe: sKi,
  payment: cKi,
  missing_card_fields: lKi,
  pay_now: uKi,
  general_prompt: dKi,
  transcription_powered_by_ai: _Ki,
  start_or_stop_recording: pKi,
  begin_message: mKi,
  codebase_has_to_stay_opensource: fKi,
  cannot_repackage_codebase: gKi,
  acquire_license: hKi,
  terms_summary: vKi,
  open_env: bKi,
  env_changed: yKi,
  accept_license: $Ki,
  still_waiting_for_approval: wKi,
  event_is_still_waiting: kKi,
  no_result_found_for: SKi,
  no_more_results: EKi,
  no_results: xKi,
  load_more_results: CKi,
  integration_meeting_id: TKi,
  confirmed_event_type_subject: AKi,
  new_event_request: IKi,
  confirm_or_reject_request: OKi,
  check_bookings_page_to_confirm_or_reject: NKi,
  check_in_assistant: zKi,
  check_in_assistant_description: RKi,
  create_your_own_prompt: PKi,
  event_awaiting_approval: DKi,
  event_awaiting_approval_recurring: LKi,
  someone_requested_an_event: MKi,
  someone_requested_password_reset: FKi,
  password_reset_email_sent: qKi,
  password_reset_instructions: jKi,
  event_awaiting_approval_subject: VKi,
  event_still_awaiting_approval: BKi,
  booking_submitted_subject: UKi,
  download_recording_subject: GKi,
  download_transcript_email_subject: WKi,
  download_your_recording: HKi,
  download_your_transcripts: YKi,
  your_meeting_has_been_booked: KKi,
  event_type_has_been_rescheduled_on_time_date: ZKi,
  event_type_has_been_updated: XKi,
  event_has_been_rescheduled: JKi,
  event_has_been_updated: QKi,
  your_event_has_been_rescheduled: eZi,
  request_reschedule_subtitle: tZi,
  request_reschedule_title_organizer: nZi,
  request_reschedule_subtitle_organizer: oZi,
  rescheduled_event_type_subject: rZi,
  requested_to_reschedule_subject_attendee: iZi,
  hi_user_name: aZi,
  ics_event_title: sZi,
  please_book_a_time_sometime_later: cZi,
  schedule_instead: lZi,
  new_event_subject: uZi,
  join_by_entrypoint: dZi,
  notes: _Zi,
  manage_my_bookings: pZi,
  need_to_make_a_change: mZi,
  new_event_scheduled: fZi,
  new_event_scheduled_recurring: gZi,
  invitee_email: hZi,
  invitee_timezone: vZi,
  time_left: bZi,
  event_type: yZi,
  duplicate_event_type: $Zi,
  enter_meeting: wZi,
  video_call_provider: kZi,
  meeting_id: SZi,
  meeting_password: EZi,
  meeting_url: xZi,
  meeting_url_not_found: CZi,
  token_not_found: TZi,
  some_other_host_already_accepted_the_meeting: AZi,
  meeting_request_rejected: IZi,
  rejected_event_type_with_organizer: OZi,
  hi: NZi,
  join_team: zZi,
  manage_this_team: RZi,
  team_info: PZi,
  join_meeting: DZi,
  request_another_invitation_email: LZi,
  you_have_been_invited: MZi,
  user_invited_you: FZi,
  hidden_team_member_title: qZi,
  hidden_team_member_message: jZi,
  hidden_team_owner_message: VZi,
  link_expires: BZi,
  upgrade_to_per_seat: UZi,
  seat_options_doesnt_support_confirmation: GZi,
  multilocation_doesnt_support_seats: WZi,
  no_show_fee_doesnt_support_seats: HZi,
  seats_option_doesnt_support_multi_location: YZi,
  team_upgrade_seats_details: KZi,
  team_upgrade_banner_description: ZZi,
  upgrade_banner_action: XZi,
  team_upgraded_successfully: JZi,
  org_upgrade_banner_description: QZi,
  org_upgraded_successfully: eXi,
  use_link_to_reset_password: tXi,
  hey_there: nXi,
  there: oXi,
  forgot_your_password_calcom: rXi,
  delete_webhook_confirmation_message: iXi,
  confirm_delete_webhook: aXi,
  edit_webhook: sXi,
  delete_webhook: cXi,
  webhook_status: lXi,
  webhook_enabled: uXi,
  webhook_disabled: dXi,
  webhook_response: _Xi,
  webhook_test: pXi,
  webhook_update_form: mXi,
  webhook_update_form_description: fXi,
  manage_your_webhook: gXi,
  webhook_created_successfully: hXi,
  webhook_updated_successfully: vXi,
  webhook_removed_successfully: bXi,
  subscription_needed: yXi,
  subscription_needed_description: $Xi,
  payload_template: wXi,
  dismiss: kXi,
  no_data_yet: SXi,
  ping_test: EXi,
  add_to_homescreen: xXi,
  upcoming: CXi,
  recurring: TXi,
  past: AXi,
  choose_a_file: IXi,
  upload_image: OXi,
  upload_target: NXi,
  no_target: zXi,
  slide_zoom_drag_instructions: RXi,
  view_notifications: PXi,
  view_public_page: DXi,
  copy_public_page_link: LXi,
  copy_referral_link: MXi,
  sign_out: FXi,
  add_another: qXi,
  install_another: jXi,
  until: VXi,
  powered_by: BXi,
  unavailable: UXi,
  set_work_schedule: GXi,
  change_bookings_availability: WXi,
  select: HXi,
  "2fa_confirm_current_password": "Bevestig uw huidige wachtwoord om aan de slag te gaan.",
  "2fa_scan_image_or_use_code": "Scan de afbeelding hieronder met de authenticator-app op uw telefoon of voer de tekstcode handmatig in.",
  text: YXi,
  your_phone_number: KXi,
  multiline_text: ZXi,
  number: XXi,
  checkbox: JXi,
  is_required: QXi,
  make_field_required: eJi,
  required: tJi,
  optional: nJi,
  input_type: oJi,
  rejected: rJi,
  unconfirmed: iJi,
  guests: aJi,
  guest: sJi,
  web_conferencing_details_to_follow: cJi,
  confirmation: lJi,
  what_booker_should_provide: uJi,
  "404_the_user": "De gebruikersnaam",
  username: dJi,
  is_still_available: _Ji,
  documentation: pJi,
  documentation_description: mJi,
  api_reference: fJi,
  api_reference_description: gJi,
  blog: hJi,
  blog_description: vJi,
  join_our_community: bJi,
  "404_claim_entity_user": "Claim uw gebruikersnaam en plan evenementen",
  popular_pages: yJi,
  register_now: $Ji,
  register: wJi,
  page_doesnt_exist: kJi,
  no_active_phone_number_available: SJi,
  workflow_step_not_configured: EJi,
  check_spelling_mistakes_or_go_back: xJi,
  "404_page_not_found": "404: Deze pagina kan niet worden gevonden.",
  booker_event_not_found: CJi,
  getting_started: TJi,
  "15min_meeting": "15 Minuten afspraak",
  "30min_meeting": "30 Minuten afspraak",
  secret: AJi,
  leave_blank_to_remove_secret: IJi,
  webhook_secret_key_description: OJi,
  secret_meeting: NJi,
  login_instead: zJi,
  create_account: RJi,
  get_started: PJi,
  confirm_password: DJi,
  reset_your_password: LJi,
  org_banner_instructions: MJi,
  email_change: FJi,
  create_your_account: qJi,
  create_your_calcom_account: jJi,
  sign_up: VJi,
  youve_been_logged_out: BJi,
  hope_to_see_you_soon: UJi,
  logged_out: GJi,
  please_try_again_and_contact_us: WJi,
  incorrect_2fa_code: HJi,
  no_account_exists: YJi,
  "2fa_enabled_instructions": "Tweestapsverificatie ingeschakeld. Voer de zescijferige code in vanuit uw authenticatie-app.",
  "2fa_enter_six_digit_code": "Voer hieronder de zescijferige code van uw authenticatie-app in.",
  create_an_account: KJi,
  dont_have_an_account: ZJi,
  "2fa_code": "Tweestapsverificatie code",
  sign_in_account: XJi,
  sign_in: JJi,
  go_back_login: QJi,
  error_during_login: eQi,
  request_password_reset: tQi,
  send_invite: nQi,
  forgot_password: oQi,
  forgot: rQi,
  done: iQi,
  all_done: aQi,
  all: sQi,
  yours: cQi,
  available_apps: lQi,
  available_apps_lower_case: uQi,
  available_apps_desc: dQi,
  fixed_host_helper: _Qi,
  round_robin_groups_helper: pQi,
  round_robin_helper: mQi,
  check_email_reset_password: fQi,
  finish: gQi,
  organization_general_description: hQi,
  few_sentences_about_yourself: vQi,
  nearly_there: bQi,
  nearly_there_instructions: yQi,
  set_availability_instructions: $Qi,
  set_availability: wQi,
  set_availbility_description: kQi,
  share_a_link_or_embed: SQi,
  share_a_link_or_embed_description: EQi,
  availability_settings: xQi,
  continue_without_calendar: CQi,
  continue_with: TQi,
  connect_your_calendar: AQi,
  connect_your_video_app: IQi,
  connect_your_video_app_instructions: OQi,
  connect_your_calendar_instructions: NQi,
  set_up_later: zQi,
  current_time: RQi,
  details: PQi,
  welcome: DQi,
  welcome_back: LQi,
  welcome_to_calcom: MQi,
  welcome_instructions: FQi,
  connect_caldav: qQi,
  connect_ics_feed: jQi,
  connect: VQi,
  try_for_free: BQi,
  create_booking_link_with_calcom: UQi,
  who: GQi,
  what: WQi,
  when: HQi,
  where: YQi,
  add_to_calendar: KQi,
  add_to_calendar_description: ZQi,
  add_events_to: XQi,
  add_another_calendar: JQi,
  other: QQi,
  email_sign_in_subject: eea,
  round_robin_emailed_you_and_attendees: tea,
  round_robin_emailed_host_and_attendee: nea,
  emailed_host_and_attendee: oea,
  emailed_host_and_attendee_recurring: rea,
  round_robin_emailed_you_and_attendees_recurring: iea,
  round_robin_emailed_host_and_attendee_recurring: aea,
  emailed_you_and_any_other_attendees: sea,
  needs_to_be_confirmed_or_rejected: cea,
  needs_to_be_confirmed_or_rejected_recurring: lea,
  user_needs_to_confirm_or_reject_booking: uea,
  user_needs_to_confirm_or_reject_booking_recurring: dea,
  meeting_is_scheduled: _ea,
  meeting_is_scheduled_recurring: pea,
  booking_submitted: mea,
  booking_submitted_recurring: fea,
  booking_confirmed: gea,
  booking_confirmed_recurring: hea,
  warning_recurring_event_payment: vea,
  warning_payment_recurring_event: bea,
  enter_new_password: yea,
  reset_password: $ea,
  change_your_password: wea,
  show_password: kea,
  hide_password: Sea,
  try_again: Eea,
  request_is_expired: xea,
  reset_instructions: Cea,
  request_is_expired_instructions: Tea,
  whoops: Aea,
  login: Iea,
  success: Oea,
  failed: Nea,
  password_has_been_reset_login: zea,
  layout: Rea,
  bookerlayout_default_title: Pea,
  bookerlayout_description: Dea,
  bookerlayout_user_settings_title: Lea,
  bookerlayout_user_settings_description: Mea,
  bookerlayout_month_view: Fea,
  bookerlayout_week_view: qea,
  bookerlayout_column_view: jea,
  bookerlayout_error_min_one_enabled: Vea,
  bookerlayout_error_default_not_enabled: Bea,
  bookerlayout_error_unknown_layout: Uea,
  bookerlayout_override_global_settings: Gea,
  unexpected_error_try_again: Wea,
  sunday_time_error: Hea,
  monday_time_error: Yea,
  tuesday_time_error: Kea,
  wednesday_time_error: Zea,
  thursday_time_error: Xea,
  friday_time_error: Jea,
  saturday_time_error: Qea,
  error_end_time_before_start_time: eta,
  error_end_time_next_day: tta,
  back_to_bookings: nta,
  free_to_pick_another_event_type: ota,
  cancelled: rta,
  no_booking: ita,
  awaiting_host: ata,
  cancellation_successful: sta,
  really_cancel_booking: cta,
  cannot_cancel_booking: lta,
  reschedule_instead: uta,
  event_is_in_the_past: dta,
  cancelling_event_recurring: _ta,
  cancelling_all_recurring: pta,
  error_with_status_code_occured: mta,
  error_event_type_url_duplicate: fta,
  error_event_type_unauthorized_create: gta,
  error_event_type_unauthorized_update: hta,
  error_workflow_unauthorized_create: vta,
  error_schedule_unauthorized_create: bta,
  booking_already_cancelled: yta,
  booking_already_accepted_rejected: $ta,
  go_back_home: wta,
  or_go_back_home: kta,
  no_meeting_found: Sta,
  no_meeting_found_description: Eta,
  no_status_bookings_yet: xta,
  no_status_bookings_yet_description: Cta,
  event_between_users: Tta,
  bookings: Ata,
  booking_not_found: Ita,
  bookings_description: Ota,
  upcoming_bookings: Nta,
  recurring_bookings: zta,
  past_bookings: Rta,
  cancelled_bookings: Pta,
  unconfirmed_bookings: Dta,
  unconfirmed_bookings_tooltip: Lta,
  on: Mta,
  and: Fta,
  calendar_shows_busy_between: qta,
  troubleshoot: jta,
  troubleshoot_description: Vta,
  overview_of_day: Bta,
  hover_over_bold_times_tip: Uta,
  start_time: Gta,
  end_time: Wta,
  buffer_time: Hta,
  before_event: Yta,
  after_event: Kta,
  event_buffer_default: Zta,
  buffer: Xta,
  your_day_starts_at: Jta,
  your_day_ends_at: Qta,
  launch_troubleshooter: ena,
  troubleshoot_availability: tna,
  change_available_times: nna,
  change_your_available_times: ona,
  change_start_end: rna,
  change_start_end_buffer: ina,
  current_start_date: ana,
  start_end_changed_successfully: sna,
  and_end_at: cna,
  light: lna,
  dark: una,
  automatically_adjust_theme: dna,
  user_dynamic_booking_disabled: _na,
  allow_dynamic_booking_tooltip: pna,
  allow_dynamic_booking: mna,
  dynamic_booking: fna,
  allow_seo_indexing: gna,
  seo_indexing: hna,
  allow_browser_notifications: vna,
  you_have_denied_notifications: bna,
  disable_browser_notifications: yna,
  browser_notifications_turned_on: $na,
  browser_notifications_turned_off: wna,
  browser_notifications_denied: kna,
  please_allow_notifications: Sna,
  push_notifications: Ena,
  push_notifications_description: xna,
  browser_notifications_not_supported: Cna,
  email: Tna,
  email_placeholder: Ana,
  full_name: Ina,
  browse_api_documentation: Ona,
  leverage_our_api: Nna,
  create_webhook: zna,
  instant_meeting: Rna,
  booking_cancelled: Pna,
  booking_rescheduled: Dna,
  recording_ready: Lna,
  recording_transcription_generated: Mna,
  booking_created: Fna,
  booking_rejected: qna,
  booking_requested: jna,
  booking_payment_initiated: Vna,
  meeting_ended: Bna,
  form_submitted: Una,
  form_submitted_no_event: Gna,
  booking_paid: Wna,
  ooo_created: Hna,
  booking_no_show_updated: Yna,
  event_triggers: Kna,
  subscriber_url: Zna,
  create_new_webhook: Xna,
  webhooks: Jna,
  team_webhooks: Qna,
  create_new_webhook_to_account: eoa,
  new_webhook: toa,
  receive_cal_meeting_data: noa,
  receive_cal_event_meeting_data: ooa,
  responsive_fullscreen_iframe: roa,
  loading: ioa,
  deleting: aoa,
  standard_iframe: soa,
  developer: coa,
  manage_developer_settings: loa,
  iframe_embed: uoa,
  embed_calcom: doa,
  integrate_using_embed_or_webhooks: _oa,
  schedule_a_meeting: poa,
  view_and_manage_billing_details: moa,
  view_and_edit_billing_details: foa,
  go_to_billing_portal: goa,
  need_anything_else: hoa,
  further_billing_help: voa,
  contact: boa,
  our_support_team: yoa,
  contact_our_support_team: $oa,
  uh_oh: woa,
  no_event_types_have_been_setup: koa,
  edit_logo: Soa,
  upload_a_logo: Eoa,
  upload_logo: xoa,
  remove_logo: Coa,
  enable: Toa,
  code: Aoa,
  code_is_incorrect: Ioa,
  add_time_availability: Ooa,
  add_an_extra_layer_of_security: Noa,
  "2fa": "Tweestapsverificatie",
  "2fa_disabled": "Tweestapsverificatie kan alleen worden ingeschakeld voor e-mail- en wachtwoordverificatie",
  enable_2fa: zoa,
  disable_2fa: Roa,
  disable_2fa_recommendation: Poa,
  error_disabling_2fa: Doa,
  error_enabling_2fa: Loa,
  security: Moa,
  manage_account_security: Foa,
  password: qoa,
  password_updated_successfully: joa,
  password_has_been_changed: Voa,
  error_changing_password: Boa,
  session_timeout_changed: Uoa,
  session_timeout_change_error: Goa,
  something_went_wrong: Woa,
  something_doesnt_look_right: Hoa,
  please_try_again: Yoa,
  super_secure_new_password: Koa,
  new_password: Zoa,
  your_old_password: Xoa,
  current_password: Joa,
  change_password: Qoa,
  change_secret: era,
  new_password_matches_old_password: tra,
  forgotten_secret_description: nra,
  current_incorrect_password: ora,
  password_hint_caplow: rra,
  password_hint_min: ira,
  password_hint_admin_min: ara,
  password_hint_num: sra,
  max_limit_allowed_hint: cra,
  invalid_password_hint: lra,
  incorrect_password: ura,
  incorrect_email_password: dra,
  use_setting: _ra,
  am_pm: pra,
  time_options: mra,
  january: fra,
  february: gra,
  march: hra,
  april: vra,
  may: bra,
  june: yra,
  july: $ra,
  august: wra,
  september: kra,
  october: Sra,
  november: Era,
  december: xra,
  monday: Cra,
  tuesday: Tra,
  wednesday: Ara,
  thursday: Ira,
  friday: Ora,
  saturday: Nra,
  sunday: zra,
  all_booked_today: Rra,
  slots_load_fail: Pra,
  additional_guests: Dra,
  your_name: Lra,
  your_full_name: Mra,
  no_name: Fra,
  enter_number_between_range: qra,
  continue_as_guest_description: jra,
  email_address: Vra,
  enter_valid_email: Bra,
  please_schedule_future_call: Ura,
  location: Gra,
  address: Wra,
  enter_address: Hra,
  in_person_attendee_address: Yra,
  somewhere_else: Kra,
  custom_attendee_location: Zra,
  continue_as_guest: Xra,
  join_as_guest: Jra,
  ideal_for_one_time_calls: Qra,
  any_location: eia,
  yes: tia,
  no: nia,
  additional_notes: oia,
  booking_fail: ria,
  reschedule_fail: iia,
  share_additional_notes: aia,
  booking_confirmation: sia,
  booking_reschedule_confirmation: cia,
  in_person_meeting: lia,
  in_person: uia,
  link_meeting: dia,
  phone_number: _ia,
  attendee_phone_number: pia,
  organizer_phone_number: mia,
  enter_phone_number: fia,
  reschedule: gia,
  reschedule_this: hia,
  book_a_team_member: via,
  or: bia,
  go_back: yia,
  email_or_username: $ia,
  send_invite_email: wia,
  role: kia,
  edit_role: Sia,
  view_role: Eia,
  edit_team: xia,
  editing_user: Cia,
  editing_org: Tia,
  edit_or_manage_webhooks: Aia,
  reject: Iia,
  reject_all: Oia,
  accept: Nia,
  leave: zia,
  profile: Ria,
  my_team_url: Pia,
  my_teams: Dia,
  team_name: Lia,
  your_team_name: Mia,
  team_updated_successfully: Fia,
  your_team_updated_successfully: qia,
  your_org_updated_successfully: jia,
  error_copying_to_clipboard: Via,
  about: Bia,
  team_description: Uia,
  organization_id: Gia,
  organization_id_copied: Wia,
  org_description: Hia,
  team_id: Yia,
  team_id_copied: Kia,
  members: Zia,
  organization_members: Xia,
  member: Jia,
  number_member_one: Qia,
  number_member_other: eaa,
  number_selected: taa,
  owner: naa,
  admin: oaa,
  admin_api: raa,
  administrator_user: iaa,
  lets_create_first_administrator_user: aaa,
  admin_user_created: saa,
  admin_user_created_description: caa,
  new_member: laa,
  invite: uaa,
  add_team_members: daa,
  add_org_members: _aa,
  add_team_members_description: paa,
  add_team_member: maa,
  invite_new_member: faa,
  invite_new_member_description: gaa,
  invite_new_team_member: haa,
  upload_csv_file: vaa,
  invite_via_email: baa,
  change_member_role: yaa,
  disable_cal_branding: $aa,
  disable_cal_branding_description: waa,
  hide_book_a_team_member: kaa,
  hide_book_a_team_member_description: Saa,
  danger_zone: Eaa,
  account_deletion_cannot_be_undone: xaa,
  team_deletion_cannot_be_undone: Caa,
  back: Taa,
  cancel: Aaa,
  cancel_all_remaining: Iaa,
  apply: Oaa,
  cancel_event: Naa,
  continue: "Doorgaan",
  confirm: zaa,
  confirm_all: Raa,
  disband_team: Paa,
  disband_team_confirmation_message: Daa,
  disband_org: Laa,
  disband_org_confirmation_message: Maa,
  remove_member_confirmation_message: Faa,
  confirm_disband_team: qaa,
  confirm_remove_member: jaa,
  confirm_subscription_cancellation: Vaa,
  cancel_subscription: Baa,
  cancel_subscription_description: Uaa,
  remove_member: Gaa,
  manage_your_team: Waa,
  no_teams: Haa,
  no_teams_description: Yaa,
  submit: Kaa,
  confirm_remove_attribute: Zaa,
  remove_attribute: Xaa,
  remove_attribute_confirmation_message: Jaa,
  delete: "Verwijderen",
  update: Qaa,
  save: esa,
  pending: tsa,
  open_options: nsa,
  copy_link: osa,
  share: rsa,
  share_event: isa,
  copy_link_team: asa,
  leave_team: ssa,
  confirm_leave_team: csa,
  leave_team_confirmation_message: lsa,
  user_from_team: usa,
  preview: dsa,
  link_copied: _sa,
  copied: psa,
  private_link_copied: msa,
  link_shared: fsa,
  title: gsa,
  description: hsa,
  apps_status: vsa,
  quick_video_meeting: bsa,
  scheduling_type: ysa,
  preview_team: $sa,
  collective: wsa,
  collective_description: ksa,
  duration: Ssa,
  available_durations: Esa,
  default_duration: xsa,
  default_duration_no_options: Csa,
  multiple_duration_mins: Tsa,
  multiple_duration_timeUnit: Asa,
  multiple_duration_timeUnit_short: Isa,
  minutes: Osa,
  use_cal_ai_to_make_call_description: Nsa,
  termination_uri: zsa,
  sip_trunk_username: Rsa,
  sip_trunk_password: Psa,
  nickname: Dsa,
  delete_phone_number: Lsa,
  workflow_validation_failed: Msa,
  workflow_validation_empty_fields: Fsa,
  workflow_validation_unverified_contacts: qsa,
  supercharge_your_workflows_with_cal_ai: jsa,
  supercharge_your_workflows_with_cal_ai_description: Vsa,
  phone_number_imported_successfully: Bsa,
  phone_number_deleted_successfully: Usa,
  delete_phone_number_confirmation: Gsa,
  yes_delete_phone_number: Wsa,
  phone_number_info_tooltip: Hsa,
  termination_uri_info_tooltip: Ysa,
  sip_trunk_username_info_tooltip: Ksa,
  sip_trunk_password_info_tooltip: Zsa,
  nickname_info_tooltip: Xsa,
  save_and_test_call: Jsa,
  call_initiated_successfully: Qsa,
  please_enter_phone_number: eca,
  agent_updated_successfully: tca,
  agent_created_successfully: nca,
  agent_event_type_updated_successfully: oca,
  phone_number_unsubscribed_successfully: rca,
  general_prompt_description: ica,
  prompt: aca,
  call_to: sca,
  make_test_call_to_verify_configuration: cca,
  initial_message: lca,
  initial_message_description: uca,
  having_trouble_importing: dca,
  learn: _ca,
  learn_how_to_get_your_terminator: pca,
  phone_number_subscription_cancelled_successfully: mca,
  updating: fca,
  round_robin: gca,
  hi_how_are_you_doing: hca,
  round_robin_description: vca,
  managed_event: bca,
  username_placeholder: yca,
  managed_event_description: $ca,
  managed: wca,
  managed_event_url_clarification: kca,
  assign_to: Sca,
  enter_phone_number_to_test_call: Eca,
  make_test_call: xca,
  create_new_workflow_agent: Cca,
  create_new_workflow_agent_description: Tca,
  phone_number_for_ai_call: Aca,
  buy_a_phone_number_or_import_one_you_already_have: Ica,
  test_agent: Oca,
  test_web_call: Nca,
  phone_numbers: zca,
  unsubscribe: Rca,
  delete_workflow_step: Pca,
  unsubscribe_phone_number: Dca,
  buy_a_new_number: Lca,
  only_us_phone_numbers_can_be_purchased_here: Mca,
  buy_number_for_x_per_month: Fca,
  supported_call_destinations: qca,
  no_phone_number_connected: jca,
  failed_to_get_workflow_step_id: Vca,
  cal_ai_agent: Bca,
  test_cal_ai_agent: Uca,
  are_you_sure_you_want_to_delete_workflow_step: Gca,
  do_you_still_want_to_unsubscribe: Wca,
  the_action_will_disconnect_phone_number: Hca,
  cal_ai_phone_numbers: Yca,
  connect_phone_number: Kca,
  cal_ai_phone_numbers_description: Zca,
  import_number: Xca,
  this_action_will_also: Jca,
  import_phone_number: Qca,
  active_subscription: ela,
  cancel_your_phone_number_subscription: tla,
  delete_associated_phone_number: nla,
  unauthorized_create_workflow: ola,
  import_phone_number_description: rla,
  phone_number_cost: ila,
  buy_new_number: ala,
  buy_number_cost_x_per_month: sla,
  area_code_optional: cla,
  no_phone_numbers: lla,
  phone_number_purchased_successfully: ula,
  cancel_phone_number_subscription: dla,
  yes_cancel_subscription: _la,
  cancel_phone_number_subscription_confirmation: pla,
  add_members: mla,
  add_members_no_ellipsis: fla,
  no_assigned_members: gla,
  assigned_to: hla,
  you_must_be_logged_in_to: vla,
  start_assigning_members_above: bla,
  locked_fields_admin_description: yla,
  unlocked_fields_admin_description: $la,
  locked_fields_member_description: wla,
  unlocked_fields_member_description: kla,
  url: Sla,
  hidden: Ela,
  readonly: xla,
  one_time_link: Cla,
  plan_description: Tla,
  plan_upgrade_invitation: Ala,
  plan_upgrade: Ila,
  plan_upgrade_teams: Ola,
  plan_upgrade_instructions: Nla,
  event_types_page_title: zla,
  event_types_page_subtitle: Rla,
  new: "Nieuw",
  new_event_type_btn: Pla,
  new_event_type_heading: Dla,
  new_event_type_description: Lla,
  event_type_created_successfully: Mla,
  event_type_updated_successfully: Fla,
  event_type_deleted_successfully: qla,
  hours: jla,
  people: Vla,
  your_email: Bla,
  change_avatar: Ula,
  upload_avatar: Gla,
  language: Wla,
  timezone: Hla,
  first_day_of_week: Yla,
  repeats_up_to_one: Kla,
  repeats_up_to_other: Zla,
  every_for_freq: Xla,
  event_remaining_one: Jla,
  event_remaining_other: Qla,
  repeats_every: eua,
  occurrence_one: tua,
  occurrence_other: nua,
  weekly_one: oua,
  weekly_other: rua,
  monthly_one: iua,
  monthly_other: aua,
  yearly_one: sua,
  yearly_other: cua,
  plus_more: lua,
  max: uua,
  single_theme: dua,
  brand_color: _ua,
  light_brand_color: pua,
  dark_brand_color: mua,
  light_event_type_color: fua,
  dark_event_type_color: gua,
  file_not_named: hua,
  create_team: vua,
  name: bua,
  nameless_team: yua,
  oauth_clients: $ua,
  oauth_clients_description: wua,
  create_oauth_client: kua,
  create_oauth_client_description: Sua,
  oauth_client_deletion_message: Eua,
  create_new_team_description: xua,
  create_new_team: Cua,
  booking_redirect_uri: Tua,
  booking_cancel_redirect_uri: Aua,
  booking_reschedule_redirect_uri: Iua,
  booking_conflict_error: Oua,
  open_invitations: Nua,
  new_team: zua,
  create_first_team_and_invite_others: Rua,
  create_team_to_get_started: Pua,
  teams: Dua,
  team: Lua,
  organization: Mua,
  team_billing: Fua,
  team_billing_description: qua,
  upgrade_to_flexible_pro_title: jua,
  upgrade_to_flexible_pro_message: Vua,
  changed_team_billing_info: Bua,
  create_manage_teams_collaborative: Uua,
  only_available_on_pro_plan: Gua,
  remove_cal_branding_description: Wua,
  edit_profile_info_description: Hua,
  change_email_tip: Yua,
  little_something_about: Kua,
  profile_updated_successfully: Zua,
  your_user_profile_updated_successfully: Xua,
  your_upgrade_is_here: Jua,
  your_upgrade_is_here_description: Qua,
  you_are_all_set: eda,
  you_are_all_set_description: tda,
  user_cannot_found_db: nda,
  embed_and_webhooks: oda,
  enabled: rda,
  disabled: ida,
  disable: ada,
  billing: sda,
  here: cda,
  manage_your_billing_info: lda,
  availability: uda,
  edit_availability: dda,
  configure_availability: _da,
  copy_times_to: pda,
  copy_times_to_tooltip: mda,
  change_weekly_schedule: fda,
  logo: gda,
  error: hda,
  at_least_characters_one: vda,
  at_least_characters_other: bda,
  team_logo: yda,
  add_location: $da,
  attendees: wda,
  add_attendees: kda,
  show_advanced_settings: Sda,
  hide_advanced_settings: Eda,
  event_name: xda,
  event_name_in_calendar: Cda,
  event_name_tooltip: Tda,
  meeting_with_user: Ada,
  additional_inputs: Ida,
  additional_input_description: Oda,
  label: Nda,
  placeholder: zda,
  display_add_to_calendar_organizer: Rda,
  display_email_as_organizer: Pda,
  if_enabled_email_address_as_organizer: Dda,
  reconnect_calendar_to_use: Lda,
  type: Mda,
  edit: Fda,
  add_input: qda,
  disable_notes: jda,
  disable_notes_description: Vda,
  requires_confirmation_description: Bda,
  requires_confirmation_will_block_slot_description: Uda,
  recurring_event: Gda,
  recurring_event_description: Wda,
  connect_and_join: Hda,
  cannot_be_used_with_paid_event_types: Yda,
  warning_payment_instant_meeting_event: Kda,
  warning_instant_meeting_experimental: Zda,
  starting: Xda,
  disable_guests: Jda,
  disable_guests_description: Qda,
  private_link: e_a,
  enable_private_url: t_a,
  private_link_label: n_a,
  private_link_hint: o_a,
  copy_private_link: r_a,
  copy_private_link_to_event: i_a,
  private_link_description: a_a,
  multiple_private_links_title: s_a,
  multiple_private_links_description: c_a,
  add_a_multiple_private_link: l_a,
  multiple_private_link_copied: u_a,
  invitees_can_schedule: d_a,
  date_range: __a,
  calendar_days: p_a,
  business_days: m_a,
  set_address_place: f_a,
  set_link_meeting: g_a,
  managed_event_field_parent_control_disabled: h_a,
  cal_invitee_phone_number_scheduling: v_a,
  cal_provide_google_meet_location: b_a,
  cal_provide_zoom_meeting_url: y_a,
  cal_provide_tandem_meeting_url: $_a,
  cal_provide_video_meeting_url: w_a,
  cal_provide_jitsi_meeting_url: k_a,
  cal_provide_huddle01_meeting_url: S_a,
  cal_provide_teams_meeting_url: E_a,
  require_payment: x_a,
  you_need_to_add_a_name: C_a,
  commission_per_transaction: T_a,
  event_type_updated_successfully_description: A_a,
  hide_event_type: I_a,
  edit_location: O_a,
  into_the_future: N_a,
  when_booked_with_less_than_notice: z_a,
  within_date_range: R_a,
  indefinitely_into_future: P_a,
  add_new_custom_input_field: D_a,
  quick_chat: L_a,
  add_new_team_event_type: M_a,
  add_new_event_type: F_a,
  new_event_type_to_book_description: q_a,
  length: j_a,
  minimum_booking_notice: V_a,
  offset_toggle: B_a,
  offset_toggle_description: U_a,
  offset_start: G_a,
  offset_start_description: W_a,
  slot_interval: H_a,
  slot_interval_default: Y_a,
  delete_event_type: K_a,
  delete_managed_event_type: Z_a,
  delete_event_type_description: X_a,
  delete_managed_event_type_description_1: J_a,
  delete_managed_event_type_description_2: Q_a,
  confirm_delete_event_type: epa,
  delete_account: tpa,
  confirm_delete_account: npa,
  delete_account_confirmation_message: opa,
  integrations: rpa,
  apps: ipa,
  apps_description: apa,
  apps_listing: spa,
  category_apps: cpa,
  app_store: lpa,
  app_store_description: upa,
  connect_your_video: dpa,
  settings: _pa,
  event_type_moved_successfully: ppa,
  next_step_text: mpa,
  next_step: fpa,
  prev_step: gpa,
  install: hpa,
  start_paid_trial: vpa,
  installed: bpa,
  active_install_one: ypa,
  active_install_other: $pa,
  globally_install: wpa,
  app_successfully_installed: kpa,
  app_could_not_be_installed: Spa,
  disconnect: Epa,
  embed_your_calendar: xpa,
  connect_your_favourite_apps: Cpa,
  automation: Tpa,
  configure_how_your_event_types_interact: Apa,
  toggle_calendars_conflict: Ipa,
  connect_additional_calendar: Opa,
  calendar_updated_successfully: Npa,
  check_here: zpa,
  conferencing: Rpa,
  calendar: Ppa,
  payments: Dpa,
  not_installed: Lpa,
  error_password_mismatch: Mpa,
  error_required_field: Fpa,
  status: qpa,
  team_view_user_availability: jpa,
  team_view_user_availability_disabled: Vpa,
  set_as_away: Bpa,
  set_as_free: Upa,
  toggle_away_error: Gpa,
  user_away: Wpa,
  user_away_description: Hpa,
  meet_people_with_the_same_tokens: Ypa,
  only_book_people_and_allow: Kpa,
  account_created_with_identity_provider: Zpa,
  account_managed_by_identity_provider: Xpa,
  account_managed_by_identity_provider_description: Jpa,
  account_managed_by_identity_provider_error: Qpa,
  user_creation_error: ema,
  signin_with_google: tma,
  signin_with_saml: nma,
  signin_with_saml_oidc: oma,
  continue_with_email: rma,
  continue_with_google: ima,
  last_used: ama,
  you_will_need_to_generate: sma,
  import: "Importeren",
  import_from: cma,
  access_token: lma,
  visit_roadmap: uma,
  featured_categories: dma,
  feature_flags: _ma,
  admin_flags_description: pma,
  popular_categories: mma,
  number_apps_one: fma,
  number_apps_other: gma,
  trending_apps: hma,
  most_popular: vma,
  installed_apps: bma,
  free_to_use_apps: yma,
  no_category_apps: $ma,
  all_apps: wma,
  no_category_apps_description_calendar: kma,
  no_category_apps_description_conferencing: Sma,
  no_category_apps_description_payment: Ema,
  no_category_apps_description_analytics: xma,
  no_category_apps_description_automation: Cma,
  no_category_apps_description_other: Tma,
  no_category_apps_description_messaging: Ama,
  no_category_apps_description_crm: Ima,
  installed_app_calendar_description: Oma,
  installed_app_payment_description: Nma,
  installed_app_analytics_description: zma,
  installed_app_other_description: Rma,
  installed_app_conferencing_description: Pma,
  installed_app_automation_description: Dma,
  installed_app_messaging_description: Lma,
  installed_app_crm_description: Mma,
  analytics: Fma,
  empty_installed_apps_headline: qma,
  empty_installed_apps_description: jma,
  empty_installed_apps_button: Vma,
  manage_your_connected_apps: Bma,
  browse_apps: Uma,
  features: Gma,
  permissions: Wma,
  terms_and_privacy: Hma,
  published_by: Yma,
  subscribe: Kma,
  buy: Zma,
  install_app: Xma,
  categories: Jma,
  pricing: Qma,
  learn_more: efa,
  try_now: tfa,
  privacy_policy: nfa,
  terms_of_service: ofa,
  remove: rfa,
  add: ifa,
  installed_other: afa,
  verify_wallet: sfa,
  create_events_on: cfa,
  enterprise_license: lfa,
  enterprise_license_locally: ufa,
  enterprise_license_sales: dfa,
  missing_license: _fa,
  next_steps: pfa,
  acquire_commercial_license: mfa,
  the_infrastructure_plan: ffa,
  prisma_studio_tip: gfa,
  prisma_studio_tip_description: hfa,
  contact_sales: vfa,
  error_404: bfa,
  default: "standaard keuze",
  set_to_default: yfa,
  new_schedule_btn: $fa,
  add_new_schedule: wfa,
  add_new_calendar: kfa,
  set_calendar: Sfa,
  delete_schedule: Efa,
  delete_schedule_description: xfa,
  schedule_created_successfully: Cfa,
  availability_updated_successfully: Tfa,
  schedule_deleted_successfully: Afa,
  default_schedule_name: Ifa,
  new_schedule_heading: Ofa,
  new_schedule_description: Nfa,
  requires_ownership_of_a_token: zfa,
  example_name: Rfa,
  time_format: Pfa,
  "12_hour": "12 uur",
  "24_hour": "24 uur",
  "12_hour_short": "12 uur",
  "24_hour_short": "24u",
  redirect_success_booking: Dfa,
  you_are_being_redirected: Lfa,
  external_redirect_url: Mfa,
  redirect_url_description: Ffa,
  duplicate: qfa,
  offer_seats: jfa,
  offer_seats_description: Vfa,
  seats_available_one: Bfa,
  seats_available_other: Ufa,
  seats_nearly_full: Gfa,
  seats_half_full: Wfa,
  number_of_seats: Hfa,
  set_instant_meeting_expiry_time_offset_description: Yfa,
  enter_number_of_seats: Kfa,
  you_can_manage_your_schedules: Zfa,
  booking_full: Xfa,
  api_keys: Jfa,
  api_key: Qfa,
  test_api_key: ega,
  test_passed: tga,
  test_failed: nga,
  provide_api_key: oga,
  api_key_modal_subtitle: rga,
  api_key_modal_subtitle_platform: iga,
  api_keys_subtitle: aga,
  create_api_key: sga,
  personal_note: cga,
  personal_note_placeholder: lga,
  api_key_no_note: uga,
  api_key_never_expires: dga,
  edit_api_key: _ga,
  success_api_key_created: pga,
  success_api_key_edited: mga,
  create: fga,
  success_api_key_created_bold_tagline: gga,
  you_will_only_view_it_once: hga,
  copy_to_clipboard: vga,
  enabled_after_update: bga,
  enabled_after_update_description: yga,
  confirm_delete_api_key: $ga,
  disable_rescheduling: wga,
  description_disable_rescheduling: kga,
  allow_rescheduling_cancelled_bookings: Sga,
  description_allow_rescheduling_cancelled_bookings: Ega,
  disable_cancelling: xga,
  description_disable_cancelling: Cga,
  revoke_api_key: Tga,
  api_key_copied: Aga,
  api_key_expires_on: Iga,
  delete_api_key_confirm_title: Oga,
  copy: Nga,
  expire_date: zga,
  expired: Rga,
  never_expires: Pga,
  expires: Dga,
  request_reschedule_booking: Lga,
  reason_for_reschedule: Mga,
  book_a_new_time: Fga,
  reschedule_request_sent: qga,
  reschedule_modal_description: jga,
  reason_for_reschedule_request: Vga,
  send_reschedule_request: Bga,
  edit_booking: Uga,
  reschedule_booking: Gga,
  former_time: Wga,
  confirmation_page_gif: Hga,
  search: Yga,
  impersonate: Kga,
  user_impersonation_heading: Zga,
  user_impersonation_description: Xga,
  team_impersonation_description: Jga,
  cal_signup_description: Qga,
  make_org_private: eha,
  make_org_private_description: tha,
  make_team_private: nha,
  make_team_private_description: oha,
  you_cannot_see_team_members: rha,
  you_cannot_see_teams_of_org: iha,
  allow_multiple_durations: aha,
  impersonate_user_tip: sha,
  impersonating_user_warning: cha,
  impersonating_stop_instructions: lha,
  event_location_changed: uha,
  new_guests_added: dha,
  location_changed_event_type_subject: _ha,
  guests_added_event_type_subject: pha,
  current_location: mha,
  new_location: fha,
  session: gha,
  session_description: hha,
  session_timeout_after: vha,
  session_timeout: bha,
  session_timeout_description: yha,
  no_location: $ha,
  set_location: wha,
  update_location: kha,
  location_updated: Sha,
  location_update_failed: Eha,
  guests_added: xha,
  unable_to_add_guests: Cha,
  email_validation_error: Tha,
  emails_must_be_unique_valid: Aha,
  url_validation_error: Iha,
  place_where_cal_widget_appear: Oha,
  create_update_react_component: Nha,
  copy_code: zha,
  code_copied: Rha,
  how_you_want_add_cal_site: Pha,
  choose_ways_put_cal_site: Dha,
  setting_up_zapier: Lha,
  setting_up_make: Mha,
  generate_api_key: Fha,
  generate_api_key_description: qha,
  your_unique_api_key: jha,
  copy_safe_api_key: Vha,
  zapier_setup_instructions: Bha,
  make_setup_instructions_1: Uha,
  make_setup_instructions_2: Gha,
  make_setup_instructions_3: Wha,
  make_setup_instructions_4: Hha,
  make_setup_instructions_5: Yha,
  make_setup_instructions_6: Kha,
  install_zapier_app: Zha,
  install_make_app: Xha,
  app_installation: Jha,
  app_not_installed: Qha,
  visit_our_app_store: eva,
  connect_apple_server: tva,
  calendar_url: nva,
  apple_server_generate_password: ova,
  unable_to_add_apple_calendar: rva,
  credentials_stored_encrypted: iva,
  it_stored_encrypted: ava,
  go_to_app_store: sva,
  calendar_error: cva,
  set_your_phone_number: lva,
  calendar_no_busy_slots: uva,
  display_location_label: dva,
  display_location_info_badge: _va,
  add_gif: pva,
  search_giphy: mva,
  add_link_from_giphy: fva,
  add_gif_to_confirmation: gva,
  find_gif_spice_confirmation: hva,
  share_feedback: vva,
  resources: bva,
  support_documentation: yva,
  developer_documentation: $va,
  get_in_touch: wva,
  contact_support: kva,
  premium_support: Sva,
  community_support: Eva,
  feedback: xva,
  submitted_feedback: Cva,
  feedback_error: Tva,
  comments: Ava,
  booking_details: Iva,
  or_lowercase: Ova,
  nevermind: Nva,
  go_to: zva,
  zapier_invite_link: Rva,
  meeting_url_provided_after_confirmed: Pva,
  dynamically_display_attendee_or_organizer: Dva,
  event_location: Lva,
  reschedule_optional: Mva,
  reschedule_placeholder: Fva,
  event_cancelled: qva,
  emailed_information_about_cancelled_event: jva,
  this_input_will_shown_booking_this_event: Vva,
  meeting_url_in_confirmation_email: Bva,
  url_start_with_https: Uva,
  number_provided: Gva,
  before_event_trigger: Wva,
  event_cancelled_trigger: Hva,
  after_hosts_cal_video_no_show: Yva,
  after_guests_cal_video_no_show: Kva,
  join_video_call: Zva,
  sign_in_to_cal_com: Xva,
  log_in_to_cal_com: Jva,
  track_your_meetings: Qva,
  track_meetings_and_manage_schedule: eba,
  failed_to_join_call: tba,
  choose_how_you_d_like_to_join_call: nba,
  choose_how_you_d_like_to_appear_on_the_call: oba,
  new_event_trigger: rba,
  email_host_action: iba,
  email_attendee_action: aba,
  sms_attendee_action: sba,
  sms_number_action: cba,
  send_reminder_sms: lba,
  whatsapp_number_action: uba,
  whatsapp_attendee_action: dba,
  workflows: _ba,
  new_workflow_btn: pba,
  how_would_you_like_to_start: mba,
  add_new_workflow: fba,
  reschedule_event_trigger: gba,
  trigger: hba,
  triggers: vba,
  action: bba,
  workflows_to_automate_notifications: yba,
  workflow_name: $ba,
  custom_workflow: wba,
  workflow_created_successfully: kba,
  delete_workflow_description: Sba,
  delete_workflow: Eba,
  confirm_delete_workflow: xba,
  workflow_deleted_successfully: Cba,
  how_long_before: Tba,
  day_timeUnit: Aba,
  hour_timeUnit: Iba,
  minute_timeUnit: Oba,
  minute_short: Nba,
  hour_short: zba,
  new_workflow_heading: Rba,
  new_workflow_description: Pba,
  active_on: Dba,
  workflow_updated_successfully: Lba,
  premium_to_standard_username_description: Mba,
  premium_username: Fba,
  current: qba,
  premium: jba,
  standard: Vba,
  confirm_username_change_dialog_title: Bba,
  change_username_standard_to_premium: Uba,
  change_username_premium_to_standard: Gba,
  go_to_stripe_billing: Wba,
  stripe_description: Hba,
  trial_expired: Yba,
  remove_app: Kba,
  yes_remove_app: Zba,
  are_you_sure_you_want_to_remove_this_app: Xba,
  app_removed_successfully: Jba,
  error_removing_app: Qba,
  web_conference: eya,
  web_call: tya,
  start_web_call: nya,
  end_call: oya,
  test_your_agent_with_web_call: rya,
  phone_call: iya,
  connecting_to_agent: aya,
  call_active: sya,
  call_ended: cya,
  call_error: lya,
  ready_to_start_call: uya,
  failed_to_start_web_call_try_again: dya,
  call_encountered_error_try_again: _ya,
  failed_initialize_web_call_microphone_permissions: pya,
  start_call_to_see_conversation: mya,
  waiting_for_conversation: fya,
  ai_agent: gya,
  live: hya,
  connecting: vya,
  requires_confirmation: bya,
  requires_confirmation_threshold: yya,
  may_require_confirmation: $ya,
  nr_event_type_one: wya,
  nr_event_type_other: kya,
  count_team_one: Sya,
  count_team_other: Eya,
  add_action: xya,
  set_whereby_link: Cya,
  invalid_whereby_link: Tya,
  set_around_link: Aya,
  invalid_around_link: Iya,
  set_riverside_link: Oya,
  invalid_riverside_link: Nya,
  invalid_ping_link: zya,
  add_exchange2013: Rya,
  add_exchange2016: Pya,
  custom_template: Dya,
  email_body: Lya,
  text_message: Mya,
  specific_issue: Fya,
  browse_our_docs: qya,
  choose_template: jya,
  custom: Vya,
  reminder: Bya,
  rescheduled: Uya,
  rescheduled_by: Gya,
  original_booking: Wya,
  completed: Hya,
  rating: Yya,
  reminder_email: Kya,
  not_triggering_existing_bookings: Zya,
  minute_one: Xya,
  minute_one_short: Jya,
  minute_other: Qya,
  hour_one: e$a,
  hour_one_short: t$a,
  hour_other: n$a,
  invalid_input: o$a,
  broken_video_action: r$a,
  broken_calendar_action: i$a,
  attendee_name: a$a,
  scheduler_full_name: s$a,
  broken_integration: c$a,
  problem_adding_video_link: l$a,
  problem_updating_calendar: u$a,
  active_on_event_types_one: d$a,
  active_on_event_types_other: _$a,
  active_on_teams_one: p$a,
  active_on_teams_other: m$a,
  active_on_all_event_types: f$a,
  active_on_all_teams: g$a,
  no_active_event_types: h$a,
  no_active_teams: v$a,
  new_seat_subject: b$a,
  new_seat_title: y$a,
  variable: $$a,
  event_name_variable: w$a,
  attendee_name_variable: k$a,
  event_date_variable: S$a,
  event_time_variable: E$a,
  organizer_name_variable: x$a,
  app_upgrade_description: C$a,
  invalid_number: T$a,
  invalid_url_error_message: A$a,
  navigate: I$a,
  open: O$a,
  close: N$a,
  upgrade: z$a,
  buy_us_number_button: R$a,
  upgrade_to_access_recordings_title: P$a,
  upgrade_to_access_recordings_description: D$a,
  upgrade_to_cal_ai_phone_number_description: L$a,
  recordings_are_part_of_the_teams_plan: M$a,
  team_feature_teams: F$a,
  team_feature_workflows: q$a,
  show_eventtype_on_profile: j$a,
  embed: V$a,
  new_username: B$a,
  current_username: U$a,
  example_1: G$a,
  example_2: W$a,
  booking_question_identifier: H$a,
  company_size: Y$a,
  what_help_needed: K$a,
  variable_format: Z$a,
  webhook_subscriber_url_reserved: X$a,
  custom_input_as_variable_info: J$a,
  using_booking_questions_as_variables: Q$a,
  download_desktop_app: ewa,
  set_ping_link: twa,
  rate_limit_exceeded: nwa,
  when_something_happens: owa,
  action_is_performed: rwa,
  test_action: iwa,
  notification_sent: awa,
  no_input: swa,
  test_workflow_action: cwa,
  send_sms: lwa,
  send_sms_to_number: uwa,
  missing_connected_calendar: dwa,
  connect_your_calendar_and_link: _wa,
  default_calendar_selected: pwa,
  hide_from_profile: mwa,
  basics: fwa,
  availability_not_found_in_schedule_error: gwa,
  event_limit_tab_title: hwa,
  event_limit_tab_description: vwa,
  event_advanced_tab_description: bwa,
  event_advanced_tab_title: ywa,
  event_payments_tab_description: $wa,
  event_setup_multiple_duration_error: wwa,
  event_setup_multiple_duration_default_error: kwa,
  event_setup_booking_limits_error: Swa,
  event_setup_duration_limits_error: Ewa,
  select_which_cal: xwa,
  custom_event_name: Cwa,
  custom_event_name_description: Twa,
  "2fa_required": "Tweestapsverificatie vereist",
  incorrect_2fa: Awa,
  which_event_type_apply: Iwa,
  apply_to_all_event_types: Owa,
  apply_to_all_teams: Nwa,
  which_team_apply: zwa,
  no_workflows_description: Rwa,
  timeformat_profile_hint: Pwa,
  create_workflow: Dwa,
  do_this: Lwa,
  turn_off: Mwa,
  turn_on: Fwa,
  cancelled_bookings_cannot_be_rescheduled: qwa,
  settings_updated_successfully: jwa,
  error_updating_settings: Vwa,
  personal_cal_url: Bwa,
  bio_hint: Uwa,
  finish_and_start: Gwa,
  user_has_no_bio: Wwa,
  bio: Hwa,
  delete_account_modal_title: Ywa,
  confirm_delete_account_modal: Kwa,
  delete_my_account: Zwa,
  start_of_week: Xwa,
  recordings_title: Jwa,
  recording: Qwa,
  happy_scheduling: eka,
  select_calendars: tka,
  check_for_conflicts: nka,
  view_recordings: oka,
  check_for_recordings: rka,
  adding_events_to: ika,
  follow_system_preferences: aka,
  custom_brand_colors: ska,
  customize_your_brand_colors: cka,
  pro: lka,
  removes_cal_branding: uka,
  instant_meeting_with_title: dka,
  profile_picture: _ka,
  upload: pka,
  add_profile_photo: mka,
  token_address: fka,
  blockchain: gka,
  old_password: hka,
  secure_password: vka,
  error_updating_password: bka,
  two_factor_auth: yka,
  recurring_event_tab_description: $ka,
  today: wka,
  appearance: kka,
  my_account: Ska,
  general: Eka,
  calendars: xka,
  "2fa_auth": "Tweestapsverificatie",
  invoices: Cka,
  embeds: Tka,
  impersonation: Aka,
  impersonation_description: Ika,
  recent_impersonations: Oka,
  quick_impersonate: Nka,
  no_recent_impersonations: zka,
  users: Rka,
  user: Pka,
  profile_description: Dka,
  users_description: Lka,
  users_listing: Mka,
  general_description: Fka,
  calendars_description: qka,
  appearance_description: jka,
  conferencing_description: Vka,
  add_conferencing_app: Bka,
  password_description: Uka,
  set_up_two_factor_authentication: Gka,
  we_just_need_basic_info: Wka,
  skip: Hka,
  do_this_later: Yka,
  set_availability_getting_started_subtitle_1: Kka,
  set_availability_getting_started_subtitle_2: Zka,
  connect_calendar_first: Xka,
  complete_profile: Jka,
  connect_calendars_from_app_store: Qka,
  connect_conference_apps: e0a,
  connect_calendar_apps: t0a,
  connect_payment_apps: n0a,
  connect_automation_apps: o0a,
  connect_analytics_apps: r0a,
  connect_other_apps: i0a,
  connect_messaging_apps: a0a,
  connect_crm_apps: s0a,
  current_step_of_total: c0a,
  add_variable: l0a,
  custom_phone_number: u0a,
  message_template: d0a,
  email_subject: _0a,
  add_dynamic_variables: p0a,
  event_name_info: m0a,
  event_date_info: f0a,
  event_duration_info: g0a,
  event_time_info: h0a,
  event_type_not_found: v0a,
  number_to_call_variable: b0a,
  number_to_call_info: y0a,
  location_variable: $0a,
  location_info: w0a,
  additional_notes_variable: k0a,
  additional_notes_info: S0a,
  attendee_name_info: E0a,
  organizer_name_info: x0a,
  to: C0a,
  workflow_turned_on_successfully: T0a,
  download_responses: A0a,
  download_responses_description: I0a,
  view_responses: O0a,
  download: N0a,
  downloading: z0a,
  download_recording: R0a,
  transcription_enabled: P0a,
  transcription_stopped: D0a,
  download_transcript: L0a,
  transcript: M0a,
  recording_from_your_recent_call: F0a,
  transcript_from_previous_call: q0a,
  you_can_download_transcript_from_attachments: j0a,
  link_valid_for_12_hrs: V0a,
  link_valid_for_12_hrs_description: B0a,
  create_your_first_form: U0a,
  create_your_first_form_description: G0a,
  create_your_first_webhook: W0a,
  create_your_first_webhook_description: H0a,
  for_a_maximum_of: Y0a,
  event_one: K0a,
  event_other: Z0a,
  profile_team_description: X0a,
  profile_org_description: J0a,
  members_team_description: Q0a,
  organization_description: e1a,
  team_url: t1a,
  team_members: n1a,
  more: o1a,
  cal_ai_workflows: r1a,
  and_count_more: i1a,
  more_page_footer: a1a,
  workflow_example_1: s1a,
  workflow_example_2: c1a,
  workflow_example_3: l1a,
  workflow_example_4: u1a,
  workflow_example_5: d1a,
  workflow_example_6: _1a,
  send_sms_reminder: p1a,
  send_sms_reminder_description: m1a,
  follow_up_with_no_shows: f1a,
  follow_up_with_no_shows_description: g1a,
  remind_attendees_to_bring_id: h1a,
  remind_attendees_to_bring_id_description: v1a,
  email_to_remind_booking: b1a,
  email_to_remind_booking_description: y1a,
  custom_sms_reminder: $1a,
  custom_sms_reminder_description: w1a,
  custom_email_reminder: k1a,
  custom_email_reminder_description: S1a,
  count_managed_to_limit: E1a,
  welcome_to_cal_header: x1a,
  edit_form_later_subtitle: C1a,
  connect_calendar_later: T1a,
  problem_saving_user_profile: A1a,
  purchase_missing_seats: I1a,
  slot_length: O1a,
  booking_appearance: N1a,
  appearance_team_description: z1a,
  appearance_org_description: R1a,
  only_owner_change: P1a,
  team_disable_cal_branding_description: D1a,
  invited_by_team: L1a,
  token_invalid_expired: M1a,
  view_booking: F1a,
  exchange_add: q1a,
  exchange_authentication: j1a,
  exchange_authentication_standard: V1a,
  exchange_authentication_ntlm: B1a,
  exchange_compression: U1a,
  exchange_version: G1a,
  exchange_version_2007_SP1: W1a,
  exchange_version_2010: H1a,
  exchange_version_2010_SP1: Y1a,
  exchange_version_2010_SP2: K1a,
  exchange_version_2013: Z1a,
  exchange_version_2013_SP1: X1a,
  exchange_version_2015: J1a,
  exchange_version_2016: Q1a,
  routing: eSa,
  routing_forms_description: tSa,
  routing_forms_send_email_owner: nSa,
  routing_forms_send_email_owner_description: oSa,
  routing_forms_send_email_to: rSa,
  add_new_form: iSa,
  add_new_team_form: aSa,
  create_your_first_route: sSa,
  route_to_the_right_person: cSa,
  form: lSa,
  form_description: uSa,
  copy_link_to_form: dSa,
  theme: _Sa,
  theme_applies_note: pSa,
  app_theme: mSa,
  app_theme_applies_note: fSa,
  theme_system: gSa,
  add_a_team: hSa,
  add_webhook_description: vSa,
  triggers_when: bSa,
  test_webhook: ySa,
  enable_webhook: $Sa,
  add_webhook: wSa,
  webhook_edited_successfully: kSa,
  api_keys_description: SSa,
  new_api_key: ESa,
  active: xSa,
  api_key_updated: CSa,
  api_key_update_failed: TSa,
  embeds_title: ASa,
  embeds_description: ISa,
  create_first_api_key: OSa,
  create_first_api_key_description: NSa,
  back_to_signin: zSa,
  reset_link_sent: RSa,
  password_reset_email: PSa,
  password_reset_leading: DSa,
  password_updated: LSa,
  pending_payment: MSa,
  pending_invites: FSa,
  pending_organization_invites: qSa,
  not_on_cal: jSa,
  no_calendar_installed: VSa,
  no_calendar_installed_description: BSa,
  add_a_calendar: USa,
  change_email_hint: GSa,
  confirm_password_change_email: WSa,
  seats: HSa,
  every_app_published: YSa,
  report_app: KSa,
  limit_booking_frequency: ZSa,
  limit_booking_frequency_description: XSa,
  only_show_first_available_slot: JSa,
  only_show_first_available_slot_description: QSa,
  limit_total_booking_duration: eEa,
  limit_total_booking_duration_description: tEa,
  booker_booking_limit: nEa,
  booker_booking_limit_description: oEa,
  recurring_event_doesnt_support_booker_booking_limit: rEa,
  add_limit: iEa,
  team_name_required: aEa,
  show_attendees: sEa,
  show_available_seats_count: cEa,
  how_booking_questions_as_variables: lEa,
  format: uEa,
  questions: dEa,
  all_info_your_booker_provide: _Ea,
  uppercase_for_letters: pEa,
  replace_whitespaces_underscores: mEa,
  platform_members: fEa,
  platform_members_description: gEa,
  platform_billing: hEa,
  manage_billing: vEa,
  manage_billing_description: bEa,
  billing_freeplan_title: yEa,
  billing_freeplan_description: $Ea,
  billing_freeplan_cta: wEa,
  billing_portal: kEa,
  billing_help_cta: SEa,
  ignore_special_characters_booking_questions: EEa,
  retry: xEa,
  fetching_calendars_error: CEa,
  calendar_connection_fail: TEa,
  booking_confirmation_success: AEa,
  booking_rejection_success: IEa,
  booking_tentative: OEa,
  booking_accept_intent: NEa,
  we_wont_show_again: zEa,
  couldnt_update_timezone: REa,
  updated_timezone_to: PEa,
  update_timezone: DEa,
  update_timezone_question: LEa,
  update_timezone_description: MEa,
  dont_update: FEa,
  require_additional_notes: qEa,
  require_additional_notes_description: jEa,
  email_address_action: VEa,
  after_event_trigger: BEa,
  booking_rejected_trigger: UEa,
  booking_requested_trigger: GEa,
  booking_payment_initiated_trigger: WEa,
  booking_paid_trigger: HEa,
  booking_no_show_updated_trigger: YEa,
  how_long_after: KEa,
  how_long_after_hosts_no_show: ZEa,
  how_long_after_guests_no_show: XEa,
  how_long_after_user_no_show_minutes: JEa,
  no_available_slots: QEa,
  time_available: exa,
  cant_find_the_right_conferencing_app_visit_our_app_store: txa,
  install_new_calendar_app: nxa,
  make_phone_number_required: oxa,
  new_event_type_availability: rxa,
  error_editing_availability: ixa,
  dont_have_permission: axa,
  saml_configuration_placeholder: sxa,
  saml_email_required: cxa,
  saml_sp_title: lxa,
  saml_sp_description: uxa,
  saml_sp_acs_url: dxa,
  saml_sp_entity_id: _xa,
  saml_sp_acs_url_copied: pxa,
  saml_sp_entity_id_copied: mxa,
  add_calendar: fxa,
  limit_future_bookings: gxa,
  limit_future_bookings_description: hxa,
  no_event_types: vxa,
  no_event_types_description: bxa,
  billing_frequency: yxa,
  monthly: $xa,
  yearly: wxa,
  checkout: kxa,
  your_team_disbanded_successfully: Sxa,
  your_org_disbanded_successfully: Exa,
  error_creating_team: xxa,
  you: Cxa,
  or_continue_with: Txa,
  resend_email: Axa,
  member_already_invited: Ixa,
  already_in_use_error: Oxa,
  enter_email_or_username: Nxa,
  enter_email: zxa,
  enter_emails: Rxa,
  too_many_invites: Pxa,
  team_name_taken: Dxa,
  must_enter_team_name: Lxa,
  team_url_required: Mxa,
  url_taken: Fxa,
  problem_registering_domain: qxa,
  team_publish: jxa,
  number_text_notifications: Vxa,
  number_sms_notifications: Bxa,
  attendee_email_variable: Uxa,
  attendee_email_info: Gxa,
  booking_uid: Wxa,
  kbar_search_placeholder: Hxa,
  invalid_credential: Yxa,
  invalid_credential_action: Kxa,
  reschedule_reason: Zxa,
  choose_common_schedule_team_event: Xxa,
  choose_common_schedule_team_event_description: Jxa,
  reason: Qxa,
  sender_id: eCa,
  sender_id_error_message: tCa,
  test_routing_form: nCa,
  test_preview: oCa,
  route_to: rCa,
  test_preview_description: iCa,
  test_routing: aCa,
  payment_app_disabled: sCa,
  edit_event_type: cCa,
  only_admin_can_see_members_of_org: lCa,
  only_admin_can_manage_sso_org: uCa,
  only_admin_can_manage_directory_sync: dCa,
  only_admin_can_manage_oauth_clients: _Ca,
  collective_scheduling: pCa,
  make_it_easy_to_book: mCa,
  find_the_best_person: fCa,
  fixed_round_robin: gCa,
  add_one_fixed_attendee: hCa,
  calcom_is_better_with_team: vCa,
  the_calcom_team: bCa,
  add_your_team_members: yCa,
  booking_limit_reached: $Ca,
  duration_limit_reached: wCa,
  admin_has_disabled: kCa,
  disable_attendees_emails_description: SCa,
  disabled_app_affects_event_type: ECa,
  event_replaced_notice: xCa,
  email_subject_slug_replacement: CCa,
  email_body_slug_replacement_notice: TCa,
  email_body_slug_replacement_info: ACa,
  email_body_slug_replacement_suggestion: ICa,
  disable_payment_app: OCa,
  payment_disabled_still_able_to_book: NCa,
  app_disabled_with_event_type: zCa,
  app_disabled_video: RCa,
  app_disabled_subject: PCa,
  navigate_installed_apps: DCa,
  disabled_calendar: LCa,
  enable_apps: MCa,
  enable_apps_description: FCa,
  purchase_license: qCa,
  already_have_account: jCa,
  already_have_key: VCa,
  already_have_key_suggestion: BCa,
  create_license_key: UCa,
  app_is_enabled: GCa,
  app_is_disabled: WCa,
  keys_have_been_saved: HCa,
  disable_app: YCa,
  disable_app_description: KCa,
  edit_keys: ZCa,
  admin_apps_description: XCa,
  admin_users_description: JCa,
  admin_users_add_description: QCa,
  admin_users_edit_description: eTa,
  admin_orgs_edit_description: tTa,
  admin_oAuth_description: nTa,
  admin_lockedSMS_description: oTa,
  no_available_apps: rTa,
  no_available_apps_description: iTa,
  no_apps: aTa,
  no_apps_configured: sTa,
  enable_in_settings: cTa,
  please_contact_admin: lTa,
  apps_settings: uTa,
  fill_this_field: dTa,
  options: _Ta,
  enter_option: pTa,
  add_an_option: mTa,
  location_already_exists: fTa,
  radio: gTa,
  google_meet_warning: hTa,
  individual: vTa,
  all_bookings_filter_label: bTa,
  all_users_filter_label: yTa,
  all_event_types_filter_label: $Ta,
  your_bookings_filter_label: wTa,
  meeting_url_variable: kTa,
  meeting_url_info: STa,
  date_overrides: ETa,
  date_overrides_delete_on_date: xTa,
  date_overrides_subtitle: CTa,
  date_overrides_info: TTa,
  date_overrides_dialog_which_hours: ATa,
  date_overrides_dialog_which_hours_unavailable: ITa,
  date_overrides_dialog_title: OTa,
  date_overrides_unavailable: NTa,
  date_overrides_mark_all_day_unavailable_one: zTa,
  date_overrides_mark_all_day_unavailable_other: RTa,
  date_overrides_update_btn: PTa,
  date_successfully_added: DTa,
  date_overrides_save_btn: LTa,
  event_type_duplicate_copy_text: MTa,
  set_as_default: FTa,
  hide_eventtype_details: qTa,
  show_navigation: jTa,
  hide_navigation: VTa,
  verification_code_sent: BTa,
  verified_successfully: UTa,
  wrong_code: GTa,
  not_verified: WTa,
  no_availability_in_month: HTa,
  no_availability_rolling: YTa,
  no_availability_range: KTa,
  view_previous_month: ZTa,
  view_next_month: XTa,
  send_code: JTa,
  number_verified: QTa,
  create_your_first_team_webhook_description: eAa,
  create_webhook_team_event_type: tAa,
  disable_success_page: nAa,
  invalid_admin_password: oAa,
  change_password_admin: rAa,
  username_already_taken: iAa,
  assignment: aAa,
  fixed_hosts: sAa,
  add_fixed_hosts: cAa,
  round_robin_hosts: lAa,
  minimum_round_robin_hosts_count: uAa,
  hosts: dAa,
  upgrade_to_enable_feature: _Aa,
  orgs_upgrade_to_enable_feature: pAa,
  new_attendee: mAa,
  awaiting_approval: fAa,
  requires_google_calendar: gAa,
  event_type_requires_google_calendar: hAa,
  connected_google_calendar: vAa,
  using_meet_requires_calendar: bAa,
  continue_to_install_google_calendar: yAa,
  install_google_meet: $Aa,
  install_google_calendar: wAa,
  sender_name: kAa,
  already_invited: SAa,
  no_recordings_found: EAa,
  new_workflow_subtitle: xAa,
  reporting: CAa,
  reporting_feature: TAa,
  teams_plan_required: AAa,
  routing_forms_are_a_great_way: IAa,
  choose_a_license: OAa,
  choose_license_description: NAa,
  license: zAa,
  agplv3_license: RAa,
  no_need_to_keep_your_code_open_source: PAa,
  repackage_rebrand_resell: DAa,
  a_vast_suite_of_enterprise_features: LAa,
  free_license_fee: MAa,
  forever_open_and_free: FAa,
  required_to_keep_your_code_open_source: qAa,
  cannot_repackage_and_resell: jAa,
  no_enterprise_features: VAa,
  step_enterprise_license: BAa,
  step_enterprise_license_description: UAa,
  setup: GAa,
  setup_description: WAa,
  configure: HAa,
  sso_configuration: YAa,
  sso_configuration_description: KAa,
  sso_configuration_description_orgs: ZAa,
  sso_oidc_heading: XAa,
  sso_oidc_description: JAa,
  sso_oidc_configuration_title: QAa,
  sso_oidc_configuration_description: e2a,
  sso_oidc_callback_copied: t2a,
  sso_saml_heading: n2a,
  sso_saml_description: o2a,
  sso_saml_configuration_title: r2a,
  sso_saml_configuration_description: i2a,
  sso_saml_acsurl_copied: a2a,
  sso_saml_entityid_copied: s2a,
  sso_connection_created_successfully: c2a,
  sso_connection_deleted_successfully: l2a,
  delete_sso_configuration: u2a,
  delete_sso_configuration_confirmation: d2a,
  delete_sso_configuration_confirmation_description: _2a,
  organizer_timezone: p2a,
  email_user_cta: m2a,
  accept_invite: f2a,
  join_now: g2a,
  successfully_joined: h2a,
  email_no_user_invite_heading_subteam: v2a,
  email_no_user_invite_heading_org: b2a,
  email_no_user_invite_subheading: y2a,
  email_user_invite_subheading_subteam: $2a,
  email_user_invite_subheading_org: w2a,
  email_no_user_invite_steps_intro: k2a,
  email_no_user_step_one: S2a,
  email_no_user_step_two: E2a,
  email_no_user_step_three: x2a,
  email_no_user_step_four: C2a,
  email_no_user_signoff: T2a,
  impersonation_user_tip: A2a,
  available_variables: I2a,
  scheduler: O2a,
  no_workflows: N2a,
  change_filter: z2a,
  change_filter_common: R2a,
  no_results_for_filter: P2a,
  recommended_next_steps: D2a,
  create_a_managed_event: L2a,
  meetings_are_better_with_the_right: M2a,
  create_a_one_one_template: F2a,
  collective_or_roundrobin: q2a,
  book_your_team_members: j2a,
  event_no_longer_attending_subject: V2a,
  no_longer_attending: B2a,
  attendee_no_longer_attending_subject: U2a,
  attendee_no_longer_attending: G2a,
  attendee_no_longer_attending_subtitle: W2a,
  create_event_on: H2a,
  create_routing_form_on: Y2a,
  default_app_link_title: K2a,
  default_app_link_description: Z2a,
  organizer_default_conferencing_app: X2a,
  organizer_default_conferencing_app_not_found: J2a,
  under_maintenance: Q2a,
  under_maintenance_description: eIa,
  event_type_seats: tIa,
  booking_questions_title: nIa,
  booking_questions_description: oIa,
  add_a_booking_question: rIa,
  identifier: iIa,
  duplicate_email: aIa,
  enter_redirect_url_on_exit_description: sIa,
  booking_with_payment_cancelled: cIa,
  booking_with_payment_cancelled_already_paid: lIa,
  booking_with_payment_cancelled_refunded: uIa,
  booking_with_payment_cancelled_no_refund: dIa,
  booking_with_payment_cancelled_refund_window_expired: _Ia,
  booking_confirmation_failed: pIa,
  not_enough_seats: mIa,
  form_builder_field_already_exists: fIa,
  guests_field_must_be_multiemail: gIa,
  show_on_booking_page: hIa,
  visit_cancelled_booking: vIa,
  get_started_zapier_templates: bIa,
  standard_templates: yIa,
  cal_ai_templates: $Ia,
  team_is_unpublished: wIa,
  org_is_unpublished_description: kIa,
  team_is_unpublished_description: SIa,
  team_member: EIa,
  a_routing_form: xIa,
  form_description_placeholder: CIa,
  keep_me_connected_with_form: TIa,
  fields_in_form_duplicated: AIa,
  form_deleted: IIa,
  delete_form: OIa,
  delete_form_action: NIa,
  delete_form_confirmation: zIa,
  delete_form_confirmation_2: RIa,
  typeform_redirect_url_copied: PIa,
  modifications_in_fields_warning: DIa,
  connected_forms: LIa,
  form_modifications_warning: MIa,
  responses_collection_waiting_description: FIa,
  this_is_what_your_users_would_see: qIa,
  identifies_name_field: jIa,
  add_1_option_per_line: VIa,
  select_a_router: BIa,
  add_a_new_route: UIa,
  make_informed_decisions: GIa,
  make_informed_decisions_description: WIa,
  view_bookings_across: HIa,
  view_bookings_across_description: YIa,
  identify_booking_trends: KIa,
  identify_booking_trends_description: ZIa,
  spot_popular_event_types: XIa,
  spot_popular_event_types_description: JIa,
  no_responses_yet: QIa,
  no_routes_defined: eOa,
  this_will_be_the_placeholder: tOa,
  error_booking_event: nOa,
  timeslot_missing_title: oOa,
  timeslot_missing_description: rOa,
  timeslot_missing_cta: iOa,
  switch_monthly: aOa,
  switch_weekly: sOa,
  switch_multiday: cOa,
  switch_columnview: lOa,
  num_locations: uOa,
  select_on_next_step: dOa,
  this_meeting_has_not_started_yet: _Oa,
  this_app_requires_connected_account: pOa,
  connect_app: mOa,
  app_is_connected: fOa,
  requires_app: gOa,
  verification_code: hOa,
  can_you_try_again: vOa,
  verify: bOa,
  timezone_info: yOa,
  timezone_variable: $Oa,
  event_end_time_variable: wOa,
  event_end_time_info: kOa,
  cancel_url_variable: SOa,
  cancel_url_info: EOa,
  cancel_reason_variable: xOa,
  cancel_reason_info: COa,
  reschedule_url_variable: TOa,
  reschedule_url_info: AOa,
  reschedule_reason_variable: IOa,
  reschedule_reason_info: OOa,
  invalid_event_name_variables: NOa,
  select_all: zOa,
  default_conferencing_bulk_title: ROa,
  members_default_schedule: POa,
  set_by_admin: DOa,
  members_default_location: LOa,
  members_default_schedule_description: MOa,
  requires_at_least_one_schedule: FOa,
  default_conferencing_bulk_description: qOa,
  default_schedules_bulk_description: jOa,
  locked_for_members: VOa,
  unlocked_for_members: BOa,
  apps_locked_for_members_description: UOa,
  apps_unlocked_for_members_description: GOa,
  apps_locked_by_team_admins_description: WOa,
  apps_unlocked_by_team_admins_description: HOa,
  workflows_locked_for_members_description: YOa,
  workflows_unlocked_for_members_description: KOa,
  workflows_locked_by_team_admins_description: ZOa,
  workflows_unlocked_by_team_admins_description: XOa,
  webhooks_locked_for_members_description: JOa,
  webhooks_unlocked_for_members_description: QOa,
  webhooks_locked_by_team_admins_description: eNa,
  webhooks_unlocked_by_team_admins_description: tNa,
  locked_by_team_admin: nNa,
  app_not_connected: oNa,
  connect_now: rNa,
  managed_event_dialog_confirm_button_one: iNa,
  managed_event_dialog_confirm_button_other: aNa,
  managed_event_dialog_title_one: sNa,
  managed_event_dialog_title_other: cNa,
  managed_event_dialog_information_one: lNa,
  managed_event_dialog_information_other: uNa,
  managed_event_dialog_clarification: dNa,
  review_event_type: _Na,
  looking_for_more_analytics: pNa,
  looking_for_more_insights: mNa,
  filters: fNa,
  filter: gNa,
  add_a_member: hNa,
  add_filter: vNa,
  add_rule: bNa,
  add_rule_group: yNa,
  remove_filters: $Na,
  email_verified: wNa,
  select_user: kNa,
  select_event_type: SNa,
  select_date_range: ENa,
  popular_events: xNa,
  no_event_types_found: CNa,
  average_event_duration: TNa,
  bookings_by_hour: ANa,
  most_booked_members: INa,
  least_booked_members: ONa,
  most_bookings_scheduled: NNa,
  least_bookings_scheduled: zNa,
  most_bookings_completed: RNa,
  least_bookings_completed: PNa,
  events_created: DNa,
  events_completed: LNa,
  events_cancelled: MNa,
  events_rescheduled: FNa,
  events: qNa,
  performance: jNa,
  from_last_period: VNa,
  from_to_date_period: BNa,
  redirect_url_warning: UNa,
  event_trends: GNa,
  clear_filters: WNa,
  clear: HNa,
  hold: YNa,
  on_booking_option: KNa,
  hold_option: ZNa,
  card_held: XNa,
  charge_card: JNa,
  card_charged: QNa,
  no_show_fee_amount: eza,
  no_show_fee: tza,
  submit_card: nza,
  submit_payment_information: oza,
  meeting_awaiting_payment_method: rza,
  no_show_fee_charged_email_subject: iza,
  no_show_fee_charged_text_body: aza,
  no_show_fee_charged_subtitle: sza,
  error_charging_card: cza,
  collect_no_show_fee: lza,
  no_show_fee_charged: uza,
  your_card_was_declined: dza,
  your_card_does_not_support_this_type_of_purchase: _za,
  amount_must_convert_to_at_least: pza,
  could_not_charge_card: mza,
  insights: fza,
  routing_forms: gza,
  insights_no_data_found_for_filter: hza,
  acknowledge_booking_no_show_fee: vza,
  days: bza,
  card_details: yza,
  something_went_wrong_on_our_end: $za,
  please_provide_following_text_to_suppport: wza,
  seats_and_no_show_fee_error: kza,
  complete_your_booking: Sza,
  complete_your_booking_subject: Eza,
  confirm_your_details: xza,
  copy_invite_link: Cza,
  edit_invite_link: Tza,
  invite_link_copied: Aza,
  invite_link_deleted: Iza,
  api_key_deleted: Oza,
  delete_api_key_warning: Nza,
  invite_link_updated: zza,
  link_expires_after: Rza,
  one_day: Pza,
  seven_days: Dza,
  thirty_days: Lza,
  three_months: Mza,
  one_year: Fza,
  team_invite_received: qza,
  currency_string: jza,
  charge_card_dialog_body: Vza,
  charge_attendee: Bza,
  payment_app_commission: Uza,
  email_invite_team: Gza,
  email_invite_team_bulk: Wza,
  error_collecting_card: Hza,
  image_size_limit_exceed: Yza,
  unauthorized_workflow_error_message: Kza,
  inline_embed: Zza,
  load_inline_content: Xza,
  floating_pop_up_button: Jza,
  floating_button_trigger_modal: Qza,
  pop_up_element_click: eRa,
  open_dialog_with_element_click: tRa,
  use_my_own_form: nRa,
  use_our_headless_routing_api: oRa,
  need_help_embedding: rRa,
  book_my_cal: iRa,
  first_name: aRa,
  last_name: sRa,
  first_last_name: cRa,
  invite_as: lRa,
  form_updated_successfully: uRa,
  disable_attendees_confirmation_emails: dRa,
  disable_attendees_confirmation_emails_description: _Ra,
  disable_host_confirmation_emails: pRa,
  disable_host_confirmation_emails_description: mRa,
  add_an_override: fRa,
  import_from_google_workspace: gRa,
  connect_google_workspace: hRa,
  google_workspace_admin_tooltip: vRa,
  first_event_type_webhook_description: bRa,
  create_instant_meeting_webhook_description: yRa,
  install_app_on: $Ra,
  create_for: wRa,
  currency: kRa,
  organization_banner_description: SRa,
  organization_banner_title: ERa,
  set_up_your_organization: xRa,
  set_up_your_platform_organization: CRa,
  organizations_description: TRa,
  plans: ARa,
  platform: IRa,
  platform_description: ORa,
  platform_organization_description: NRa,
  must_enter_organization_name: zRa,
  must_enter_organization_admin_email: RRa,
  admin_email: PRa,
  platform_admin_email: DRa,
  admin_username: LRa,
  organization_name: MRa,
  platform_name: FRa,
  organization_url: qRa,
  organization_verify_header: jRa,
  organization_verify_email_body: VRa,
  additional_url_parameters: BRa,
  about_your_organization: URa,
  about_your_organization_description: GRa,
  create_your_teams: WRa,
  create_your_teams_description: HRa,
  invite_organization_admins: YRa,
  invite_organization_admins_description: KRa,
  set_a_password: ZRa,
  set_a_password_description: XRa,
  organization_logo: JRa,
  organization_about_description: QRa,
  ill_do_this_later: ePa,
  verify_your_email: tPa,
  enter_digit_code: nPa,
  verify_email_organization: oPa,
  code_provided_invalid: rPa,
  email_already_used: iPa,
  organization_admin_invited_heading: aPa,
  organization_admin_invited_body: sPa,
  duplicated_slugs_warning: cPa,
  team_names_empty: lPa,
  team_names_repeated: uPa,
  user_belongs_organization: dPa,
  org_no_teams_yet: _Pa,
  org_no_teams_yet_description: pPa,
  set_up: mPa,
  my_profile: fPa,
  my_settings: gPa,
  crm: hPa,
  messaging: vPa,
  sender_id_info: bPa,
  org_admins_can_create_new_teams: yPa,
  google_new_spam_policy: $Pa,
  resolve: wPa,
  no_organization_slug: kPa,
  copy_link_org: SPa,
  "404_the_org": "De organisatie",
  "404_the_team": "Het team",
  "404_claim_entity_org": "Claim uw subdomein voor uw organisatie",
  "404_claim_entity_team": "Claim dit team en begin met het gezamenlijk beheren van planningen",
  insights_team_filter: EPa,
  insights_user_filter: xPa,
  insights_subtitle: CPa,
  call_history: TPa,
  call_history_subtitle: APa,
  location_options: IPa,
  channel_type: OPa,
  end_reason: NPa,
  session_status: zPa,
  user_sentiment: RPa,
  time_header: PPa,
  from_header: DPa,
  custom_plan: LPa,
  email_embed: MPa,
  add_times_to_your_email: FPa,
  select_time: qPa,
  select_date: jPa,
  only_show_if_parameter_set: VPa,
  add_parameter: BPa,
  connecting_you_to_someone: UPa,
  please_do_not_close_this_tab: GPa,
  see_all_available_times: WPa,
  org_team_names_example_1: HPa,
  org_team_names_example_2: YPa,
  org_team_names_example_3: KPa,
  org_team_names_example_4: ZPa,
  org_team_names_example_5: XPa,
  org_max_team_warnings: JPa,
  what_is_this_meeting_about: QPa,
  add_to_team: eDa,
  remove_users_from_org: tDa,
  delegation_credential: nDa,
  delegation_credential_description: oDa,
  add_client_id_in_google_workspace_with_below_scope: rDa,
  delegation_credential_enabled: iDa,
  add_delegation_credential: aDa,
  edit_delegation_credential: sDa,
  domain: cDa,
  no_workspace_platforms: lDa,
  workspace_platform: uDa,
  workspace_platforms: dDa,
  workspace_platforms_description: _Da,
  edit_workspace_platform: pDa,
  edit_service_account: mDa,
  add_workspace_platform: fDa,
  slug: gDa,
  service_account_key: hDa,
  edit_service_account_key: vDa,
  delegation_credential_restricts_adding_more_than_one_installation: bDa,
  app_successfully_installed_and_is_using_delegated_credentials: yDa,
  remove_users_from_org_confirm: $Da,
  remove_users_from_team: wDa,
  remove_users_from_team_confirm: kDa,
  user_has_no_schedules: SDa,
  user_isnt_in_any_teams: EDa,
  user_has_no_app_installed: xDa,
  requires_booker_email_verification: CDa,
  description_requires_booker_email_verification: TDa,
  requires_confirmation_mandatory: ADa,
  organizations: IDa,
  upload_cal_video_logo: ODa,
  update_cal_video_logo: NDa,
  upload_banner: zDa,
  cal_video_logo_upload_instruction: RDa,
  org_admin_other_teams: PDa,
  org_admin_other_teams_description: DDa,
  not_part_of_org: LDa,
  no_other_teams_found: MDa,
  no_other_teams_found_description: FDa,
  attendee_first_name_variable: qDa,
  attendee_last_name_variable: jDa,
  attendee_first_name_info: VDa,
  attendee_last_name_info: BDa,
  your_monthly_digest: UDa,
  member_name: GDa,
  most_popular_events: WDa,
  summary_of_events_for_your_team_for_the_last_30_days: HDa,
  me: YDa,
  meeting_unavailable: KDa,
  monthly_digest_email: ZDa,
  monthly_digest_email_for_teams: XDa,
  verify_team_tooltip: JDa,
  member_removed: QDa,
  my_availability: e3a,
  team_availability: t3a,
  instant_meeting_availability: n3a,
  backup_code: o3a,
  backup_codes: r3a,
  backup_code_instructions: i3a,
  backup_codes_copied: a3a,
  incorrect_backup_code: s3a,
  lost_access: c3a,
  missing_backup_codes: l3a,
  admin_org_notification_email_subject: u3a,
  hi_admin: d3a,
  admin_org_notification_email_title: _3a,
  admin_org_notification_email_body_part1: p3a,
  admin_org_notification_email_body_part2: m3a,
  admin_org_notification_email_body_part3: f3a,
  admin_org_notification_email_cta: g3a,
  org_has_been_processed: h3a,
  org_error_processing: v3a,
  orgs_page_description: b3a,
  unverified: y3a,
  verified: $3a,
  dns_missing: w3a,
  dns_configured: k3a,
  mark_dns_configured: S3a,
  value: E3a,
  your_organization_updated_sucessfully: x3a,
  team_no_event_types: C3a,
  seat_options_doesnt_multiple_durations: T3a,
  include_calendar_event: A3a,
  oAuth: I3a,
  oAuth_client_creation_form: O3a,
  oAuth_client_creation_form_description: N3a,
  oAuth_client_updation_form: z3a,
  oAuth_client_updation_form_description: R3a,
  recently_added: P3a,
  connect_all_calendars: D3a,
  connect_all_calendars_description: L3a,
  workflow_automation_description: M3a,
  scheduling_for_your_team: F3a,
  scheduling_for_your_team_description: q3a,
  no_members_found: j3a,
  directory_sync: V3a,
  directory_name: B3a,
  directory_provider: U3a,
  directory_scim_url: G3a,
  directory_scim_token: W3a,
  directory_scim_url_copied: H3a,
  directory_scim_token_copied: Y3a,
  directory_sync_info_description: K3a,
  directory_sync_configure: Z3a,
  directory_sync_configure_description: X3a,
  directory_sync_title: J3a,
  directory_sync_created: Q3a,
  directory_sync_description: eLa,
  directory_sync_deleted: tLa,
  directory_sync_delete_connection: nLa,
  directory_sync_delete_title: oLa,
  directory_sync_delete_description: rLa,
  directory_sync_delete_confirmation: iLa,
  event_setup_length_error: aLa,
  availability_schedules: sLa,
  unauthorized: cLa,
  access_cal_account: lLa,
  select_account_team: uLa,
  allow_client_to: dLa,
  associate_with_cal_account: _La,
  see_personal_info: pLa,
  see_primary_email_address: mLa,
  connect_installed_apps: fLa,
  access_event_type: gLa,
  access_availability: hLa,
  access_bookings: vLa,
  allow_client_to_do: bLa,
  oauth_access_information: yLa,
  allow: $La,
  view_only_edit_availability_not_onboarded: wLa,
  view_only_edit_availability: kLa,
  you_can_override_calendar_in_advanced_tab: SLa,
  edit_users_availability: ELa,
  resend_invitation: xLa,
  invitation_resent: CLa,
  saml_sso: TLa,
  add_client: ALa,
  copy_client_secret_info: ILa,
  add_new_client: OLa,
  add_new_user: NLa,
  this_app_is_not_setup_already: zLa,
  as_csv: RLa,
  overlay_my_calendar: PLa,
  overlay_my_calendar_toc: DLa,
  view_overlay_calendar_events: LLa,
  join_event_location: MLa,
  troubleshooting: FLa,
  calendars_were_checking_for_conflicts: qLa,
  availabilty_schedules: jLa,
  manage_calendars: VLa,
  manage_availability_schedules: BLa,
  locked: ULa,
  unlocked: GLa,
  lock_timezone_toggle_on_booking_page: WLa,
  description_lock_timezone_toggle_on_booking_page: HLa,
  event_setup_multiple_payment_apps_error: YLa,
  number_in_international_format: KLa,
  install_calendar: ZLa,
  branded_subdomain: XLa,
  branded_subdomain_description: JLa,
  org_insights: QLa,
  org_insights_description: eMa,
  extensive_whitelabeling: tMa,
  extensive_whitelabeling_description: nMa,
  unlimited_teams: oMa,
  verify_email: rMa,
  proceed_with_cancellation_description: iMa,
  proceed_with_cancellation_error: aMa,
  unlimited_teams_description: sMa,
  unified_billing: cMa,
  advanced_managed_events: lMa,
  advanced_managed_events_description: uMa,
  enterprise: dMa,
  enterprise_description: _Ma,
  create_your_org: pMa,
  create_org: mMa,
  create_your_org_description: fMa,
  create_your_enterprise_description: gMa,
  other_payment_app_enabled: hMa,
  admin_delete_organization_description_1: vMa,
  admin_delete_organization_description_2: bMa,
  admin_delete_organization_description_3: yMa,
  admin_delete_organization_description_4: $Ma,
  admin_delete_organization_title: wMa,
  published: kMa,
  unpublished: SMa,
  publish: EMa,
  troubleshooter_tooltip: xMa,
  need_help: CMa,
  troubleshooter: TMa,
  number_to_call: AMa,
  guest_name: IMa,
  guest_email: OMa,
  guest_company: NMa,
  please_install_a_calendar: zMa,
  instant_tab_title: RMa,
  instant_event_tab_description: PMa,
  uprade_to_create_instant_bookings: DMa,
  dont_want_to_wait: LMa,
  meeting_started: MMa,
  pay_and_book: FMa,
  cal_ai_event_tab_description: qMa,
  booking_not_found_error: jMa,
  booking_seats_full_error: VMa,
  missing_payment_credential_error: BMa,
  missing_payment_app_id_error: UMa,
  not_enough_available_seats_error: GMa,
  user_redirect_title: WMa,
  user_redirect_description: HMa,
  out_of_office: YMa,
  out_of_office_description: KMa,
  send_request: ZMa,
  start_date_and_end_date_required: XMa,
  start_date_must_be_before_end_date: JMa,
  start_date_must_be_in_the_future: QMa,
  user_not_found: e4a,
  cannot_redirect_to_self: t4a,
  out_of_office_entry_already_exists: n4a,
  out_of_office_id_required: o4a,
  booking_redirect_infinite_not_allowed: r4a,
  success_entry_created: i4a,
  booking_redirect_email_subject: a4a,
  booking_redirect_email_title: s4a,
  booking_redirect_email_description: c4a,
  booking_redirect_updated_email_subject: l4a,
  booking_redirect_updated_email_title: u4a,
  booking_redirect_updated_email_description: d4a,
  booking_redirect_cancelled_email_subject: _4a,
  booking_redirect_cancelled_email_title: p4a,
  booking_redirect_cancelled_email_description: m4a,
  success_accept_booking_redirect: f4a,
  success_reject_booking_redirect: g4a,
  copy_link_booking_redirect_request: h4a,
  booking_redirect_request_title: v4a,
  select_team_member: b4a,
  going_away_title: y4a,
  redirect_team_enabled: $4a,
  redirect_team_disabled: w4a,
  out_of_office_unavailable_list: k4a,
  success_deleted_entry_out_of_office: S4a,
  success_edited_entry_out_of_office: E4a,
  temporarily_out_of_office: x4a,
  add_a_redirect: C4a,
  create_entry: T4a,
  time_range: A4a,
  automatically_add_all_team_members: I4a,
  redirect_to: O4a,
  having_trouble_finding_time: N4a,
  show_more: z4a,
  forward_params_redirect: R4a,
  assignment_description: P4a,
  lowest: D4a,
  low: L4a,
  medium: M4a,
  high: F4a,
  Highest: q4a,
  send_booker_to: j4a,
  set_priority: V4a,
  set_weight: B4a,
  enable_weights: U4a,
  priority_for_user: G4a,
  weights_description: W4a,
  weight_for_user: H4a,
  change_priority: Y4a,
  field_identifiers_as_variables: K4a,
  field_identifiers_as_variables_with_example: Z4a,
  account_already_linked: X4a,
  send_email: J4a,
  cal_ai_phone_call_action: Q4a,
  call_to_confirm_booking: e5a,
  cal_ai_phone_call_action_description: t5a,
  cal_ai_agent_configuration: n5a,
  choose_at_least_one_event_type_test_call: o5a,
  mark_as_no_show: r5a,
  unmark_as_no_show: i5a,
  account_unlinked_success: a5a,
  account_unlinked_error: s5a,
  travel_schedule: c5a,
  travel_schedule_description: l5a,
  schedule_timezone_change: u5a,
  date: d5a,
  enter_the_general_prompt_for_the_agent: _5a,
  overlaps_with_existing_schedule: p5a,
  "org_admin_no_slots|heading": "Geen beschikbaarheid gevonden voor {{name}}",
  "org_admin_no_slots|content": "Hallo organisatiebeheerders,<br /><br />Let op: het is onder onze aandacht gebracht dat {{username}} geen beschikbaarheid had toen een gebruiker {{username}}/{{slug}} heeft bezocht<br /><br />Er zijn een paar redenen waarom dit zou kunnen gebeuren<br />De gebruiker heeft geen agenda's verbonden<br />Hun schema's gekoppeld aan deze afspraak zijn niet ingeschakeld<br /> <br />We raden aan om hun beschikbaarheid te controleren om dit op te lossen.",
  "org_admin_no_slots|cta": "Open beschikbaarheid van gebruikers",
  organization_no_slots_notification_switch_title: m5a,
  organization_no_slots_notification_switch_description: f5a,
  organization_disable_phone_only_sms_notifications_switch_title: g5a,
  organization_disable_phone_only_sms_notifications_switch_description: h5a,
  "email_team_invite|subject|added_to_org": "{{user}} heeft je toegevoegd aan de organisatie {{team}} op {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} heeft je uitgenodigd om deel te nemen aan de organisatie {{team}} op {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} heeft je toegevoegd aan het team {{team}} van de organisatie {{parentTeamName}} op {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} heeft u uitgenodigd om lid te worden van het team {{team}} op {{appName}}",
  "email_team_invite|heading|added_to_org": "Je bent toegevoegd aan een {{appName}} organisatie",
  "email_team_invite|heading|invited_to_org": "Je bent uitgenodigd voor een {{appName}} organisatie",
  "email_team_invite|heading|added_to_subteam": "Je bent toegevoegd aan een team van de {{parentTeamName}} organisatie",
  "email_team_invite|heading|invited_to_subteam": "Je bent uitgenodigd voor een team van de {{parentTeamName}} organisatie",
  "email_team_invite|heading|invited_to_regular_team": "Je bent uitgenodigd om lid te worden van een {{appName}} team",
  "email_team_invite|content|added_to_org": "{{invitedBy}} heeft je toegevoegd aan de <strong>{{teamName}}</strong> organisatie.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} heeft je uitgenodigd om deel te nemen aan de {{teamName}} organisatie.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} heeft u uitgenodigd om lid te worden van het team {{team}} van de organisatie {{parentTeamName}} op {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} heeft je toegevoegd aan het team <strong>{{teamName}}</strong> in hun organisatie {{parentTeamName}}. {{appName}} is de planner die jou en je team in staat stelt om vergaderingen te plannen zonder eindeloos heen en weer te mailen.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} heeft je uitgenodigd om deel te nemen aan het team <strong>{{teamName}}</strong> in hun organisatie {{parentTeamName}}. {{appName}} is de planner die jou en je team in staat stelt om vergaderingen te plannen zonder eindeloos heen en weer te mailen.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} heeft u uitgenodigd om lid te worden van zijn team '{{teamName}}' op {{appName}}. {{appName}} is de gebeurtenissenplanner die u en uw team in staat stelt afspraken te plannen zonder heen en weer te e-mailen.",
  "email|existing_user_added_link_will_change": "Bij het accepteren van de uitnodiging zal je link veranderen naar het domein van je organisatie, maar maak je geen zorgen, alle vorige links blijven werken en worden correct doorverwezen.<br /><br />Let op: al je persoonlijke afspraaktypes worden verplaatst naar de <strong>{{teamName}}</strong> organisatie, wat mogelijk ook een persoonlijke link kan bevatten. <br /><br />Voor persoonlijke afspraken raden we aan om een nieuw account aan te maken met een persoonlijk e-mailadres.",
  "email|existing_user_added_link_changed": "Je link is gewijzigd van {{a0}} naar {{a1}} maar maak je geen zorgen, alle vorige links werken nog steeds en worden correct doorverwezen. <br /><br />Let op: al je persoonlijke afspraaktypes zijn verplaatst naar de <strong>{{teamName}}</strong> organisatie, wat mogelijk ook een persoonlijke link kan bevatten.<br /><br />Log in en controleer of je geen privé-afspraken hebt op je nieuwe organisatieaccount.<br /><br />Voor persoonlijke afspraken raden we aan om een nieuw account aan te maken met een persoonlijk e-mailadres.<br /><br />Geniet van je nieuwe nette link: {{a2}}",
  "email_organization_created|subject": "Uw organisatie is aangemaakt",
  your_current_plan: v5a,
  organization_price_per_user_month: b5a,
  privacy_organization_description: y5a,
  privacy: $5a,
  team_will_be_under_org: w5a,
  add_group_name: k5a,
  group_name: S5a,
  routers: E5a,
  primary: x5a,
  make_primary: C5a,
  add_email: T5a,
  add_emails: A5a,
  add_email_description: I5a,
  confirm_email: O5a,
  confirming_your_booking_sms: N5a,
  scheduler_first_name: z5a,
  scheduler_last_name: R5a,
  scheduler_name: P5a,
  organizer_first_name: D5a,
  confirm_email_description: L5a,
  send_event_details_to: M5a,
  schedule_tz_without_end_date: F5a,
  select_members: q5a,
  lock_event_types_modal_header: j5a,
  org_delete_event_types_org_admin: V5a,
  org_hide_event_types_org_admin: B5a,
  hide_org_eventtypes: U5a,
  delete_org_eventtypes: G5a,
  lock_org_users_eventtypes: W5a,
  lock_org_users_eventtypes_description: H5a,
  add_to_event_type: Y5a,
  create_account_password: K5a,
  create_account_with_saml: Z5a,
  error_creating_account_password: X5a,
  cannot_create_account_password_cal_provider: J5a,
  cannot_create_account_password_already_existing: Q5a,
  create_account_password_hint: e6a,
  disconnect_account: t6a,
  disconnect_account_hint: n6a,
  cookie_consent_checkbox: o6a,
  make_a_call: r6a,
  skip_rr_assignment_label: i6a,
  skip_rr_description: a6a,
  select_account_header: s6a,
  select_account_description: c6a,
  select_event_types_header: l6a,
  select_event_types_description: u6a,
  configure_app_header: d6a,
  configure_app_description: _6a,
  already_installed: p6a,
  ooo_reasons_unspecified: m6a,
  ooo_reasons_vacation: f6a,
  ooo_reasons_travel: g6a,
  ooo_reasons_sick_leave: h6a,
  ooo_reasons_public_holiday: v6a,
  ooo_forwarding_to: b6a,
  ooo_not_forwarding: y6a,
  ooo_empty_title: $6a,
  ooo_empty_description: w6a,
  ooo_user_is_ooo: k6a,
  ooo_slots_returning: S6a,
  ooo_slots_book_with: E6a,
  ooo_select_reason: x6a,
  create_an_out_of_office: C6a,
  edit_an_out_of_office: T6a,
  submit_feedback: A6a,
  host_no_show: I6a,
  no_show_description: O6a,
  how_can_we_improve: N6a,
  most_liked: z6a,
  review: R6a,
  reviewed: P6a,
  unreviewed: D6a,
  rating_url_variable: L6a,
  rating_url_info: M6a,
  no_show_url_variable: F6a,
  no_show_url_info: q6a,
  no_support_needed: j6a,
  hide_support: V6a,
  event_ratings: B6a,
  event_no_show: U6a,
  event_no_show_guest: G6a,
  recent_ratings: W6a,
  no_ratings: H6a,
  no_ratings_description: Y6a,
  most_no_show_host: K6a,
  highest_rated: Z6a,
  lowest_rated: X6a,
  highest_rated_members: J6a,
  lowest_rated_members: Q6a,
  csat_score: eFa,
  lockedSMS: tFa,
  leave_without_assigning_anyone: nFa,
  leave_without_adding_attendees: oFa,
  no_availability_shown_to_bookers: rFa,
  go_back_and_assign: iFa,
  leave_without_assigning: aFa,
  signing_up_terms: sFa,
  proceeding_agreement: cFa,
  terms: lFa,
  always_show_x_days: uFa,
  always_show_x_days_description: dFa,
  team_subscription_cancelled_successfully: _Fa,
  team_subscription_cancellation_error: pFa,
  unable_to_subscribe_to_the_platform: mFa,
  updating_oauth_client_error: fFa,
  creating_oauth_client_error: gFa,
  event_type_color: hFa,
  event_type_color_description: vFa,
  mark_as_no_show_title: bFa,
  x_marked_as_no_show: yFa,
  x_unmarked_as_no_show: $Fa,
  team_select_info: wFa,
  team_settings_description: kFa,
  no_show_updated: SFa,
  email_copied: EFa,
  phone_number_copied: xFa,
  USER_PENDING_MEMBER_OF_THE_ORG: CFa,
  USER_ALREADY_INVITED_OR_MEMBER: TFa,
  USER_MEMBER_OF_OTHER_ORGANIZATION: AFa,
  booking_reassigned: IFa,
  reassign: OFa,
  reassign_to_another_rr_host: NFa,
  assign_team_member: zFa,
  override_team_member_to_assign: RFa,
  no_available_hosts: PFa,
  reassign_round_robin_host: DFa,
  skip_writing_to_calendar: LFa,
  rescheduling_not_possible: MFa,
  event_expired: FFa,
  skip_contact_creation: qFa,
  skip_writing_to_calendar_note: jFa,
  attributes: VFa,
  new_attribute: BFa,
  add_attributes: UFa,
  add_attributes_description: GFa,
  new_option: WFa,
  update_profile: HFa,
  attribute: YFa,
  create_attribute_description: KFa,
  edit_attribute_description: ZFa,
  attribute_updated_successfully: XFa,
  attribute_deleted_successfully: JFa,
  attributes_edited_successfully: QFa,
  attribute_meta_description: eqa,
  attributes_edit_description: tqa,
  back_to_attributes: nqa,
  delete_attribute: oqa,
  delete_attribute_description: rqa,
  disable_all_emails_to_attendees: iqa,
  disable_all_emails_description: aqa,
  disable_all_emails_to_hosts: sqa,
  type_confirm_to_continue: cqa,
  disable_email: lqa,
  grant_admin_api: uqa,
  revoke_admin_api: dqa,
  add_calendar_label: _qa,
  apple_connect_atom_label: pqa,
  apple_connect_atom_already_connected_label: mqa,
  apple_connect_atom_loading_label: fqa,
  google_connect_atom_label: gqa,
  google_connect_atom_already_connected_label: hqa,
  google_connect_atom_loading_label: vqa,
  outlook_connect_atom_label: bqa,
  outlook_connect_atom_already_connected_label: yqa,
  outlook_connect_atom_loading_label: $qa,
  stripe_connect_atom_label: wqa,
  stripe_connect_atom_already_connected_label: kqa,
  stripe_connect_atom_loading_label: Sqa,
  booking_question_response_variables: Eqa,
  managed_by_teamAdmins: xqa,
  number_of_options: Cqa,
  reschedule_with_same_round_robin_host_title: Tqa,
  reschedule_with_same_round_robin_host_description: Aqa,
  disable_input_if_prefilled: Iqa,
  booking_limits: Oqa,
  booking_limits_team_description: Nqa,
  limit_team_booking_frequency_description: zqa,
  booking_limits_updated_successfully: Rqa,
  you_are_unauthorized_to_make_this_change_to_the_booking: Pqa,
  delegation_credential_disabled: Dqa,
  matching_members: Lqa,
  x_matching_members: Mqa,
  matching_members_queue_using_attribute_weights: Fqa,
  matching_members_queue_using_event_assignee_weights: qqa,
  no_matching_members: jqa,
  no_matching_members_will_fallback_to_all_assigned_members: Vqa,
  hide_calendar_event_details: Bqa,
  description_hide_calendar_event_details: Uqa,
  last_number_of_days: Gqa,
  month_to_date: Wqa,
  year_to_date: Hqa,
  custom_range: Yqa,
  refund_policy: Kqa,
  always: Zqa,
  never: Xqa,
  payment_option: Jqa,
  if_cancelled: Qqa,
  before: eja,
  show_all_columns: tja,
  toggle_columns: nja,
  no_columns_found: oja,
  salesforce_create_record_as: rja,
  salesforce_lead: ija,
  salesforce_contact_under_account: aja,
  salesforce_skip_entry_creation: sja,
  salesforce_if_account_does_not_exist: cja,
  salesforce_create_new_contact_under_account: lja,
  salesforce_change_record_owner_on_booking: uja,
  mass_assign_attributes: dja,
  reroute_preview_custom_message: _ja,
  reroute_preview_external_redirect: pja,
  reroute_preview_possible_host: mja,
  current_routing_status: fja,
  reroute_booking: gja,
  reroute_booking_description: hja,
  verify_new_route: vja,
  reroute: bja,
  new_routing_status: yja,
  salesforce_book_directly_with_attendee_owner: $ja,
  salesforce_check_owner_of: wja,
  account: kja,
  choose_hosts_schedule: Sja,
  hosts_schedule_description: Eja,
  no_hosts_description: xja,
  team_member_round_robin_reassign: Cja,
  team_member_round_robin_reassign_description: Tja,
  round_robin_reassign_description: Aja,
  invalid_round_robin_host: Ija,
  user_is_round_robin_fixed: Oja,
  reschedule_with_same_timeslot: Nja,
  reschedule_with_same_timeslot_of_new_event: zja,
  reschedule_to_the_new_event_with_different_timeslot: Rja,
  reschedule_with_different_timeslot: Pja,
  we_dont_have_id_for_the_new_event: Dja,
  rerouted_booking_successfully_redirecting_to_booking_page: Lja,
  on_booking_write_to_event_object: Mja,
  field_name: Fja,
  add_new_field: qja,
  you_dont_have_access_to_reroute_this_booking: jja,
  form_response_not_found: Vja,
  contact_owner: Bja,
  contact_owner_not_found: Uja,
  using_fallback_members: Gja,
  chosen_route: Wja,
  attribute_logic_matched: Hja,
  attribute_logic_fallback_matched: Yja,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: Kja,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: Zja,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: Xja,
  warning: Jja,
  fallback_attribute_logic_description: Qja,
  fallback_attribute_logic_warning: eVa,
  fallback_not_needed: tVa,
  confirm_reassign_unavailable: nVa,
  confirm_reassign_available: oVa,
  reassign_unavailable_team_member_description: rVa,
  reassign_available_team_member_description: iVa,
  yes_reassign: aVa,
  filter_by_attributes: sVa,
  reassign_reason: cVa,
  field_type_change_suggestion: lVa,
  reassigned_by: uVa,
  row: dVa,
  rows: _Va,
  attendee_timezone_variable: pVa,
  event_start_time_in_attendee_timezone_variable: mVa,
  event_start_time_in_attendee_timezone_info: fVa,
  event_end_time_in_attendee_timezone_info: gVa,
  event_end_time_in_attendee_timezone_variable: hVa,
  salesforce_create_event_on_contact: vVa,
  salesforce_owner_name_to_change: bVa,
  no_filter_set: yVa,
  booking_dry_run_successful: $Va,
  booking_dry_run_successful_description: wVa,
  dont_have_access_this_page: kVa,
  you_need_admin_or_owner_privileges_to_access: SVa,
  field_type: EVa,
  when_to_write: xVa,
  salesforce_on_booking_write_to_record: CVa,
  on_every_booking: TVa,
  only_if_field_is_empty: AVa,
  booking_start_date: IVa,
  booking_created_date: OVa,
  booking_reassigned_to_host: NVa,
  no_contact_owner: zVa,
  routing_forms_created: RVa,
  routing_forms_total_responses: PVa,
  routing_forms_total_responses_without_booking: DVa,
  routing_forms_total_responses_with_booking: LVa,
  routing_form_insights: MVa,
  routing_form_insights_form_name_header: FVa,
  routing_form_insights_booking_status_header: qVa,
  routing_form_insights_response_no_booking: jVa,
  routing_form_insights_booked_by: VVa,
  routing_form_insights_created_at: BVa,
  routing_form_insights_booking_status: UVa,
  routing_form_insights_booking_at: GVa,
  routing_form_insights_submitted_at: WVa,
  copy_redirect_url: HVa,
  redirect_url_on_exit: YVa,
  total_bookings_per_period: KVa,
  routed_to_per_period: ZVa,
  per_day: XVa,
  per_week: JVa,
  per_month: QVa,
  routing_form_insights_assignment_reason: eBa,
  access_denied: tBa,
  salesforce_route_to_owner: nBa,
  salesforce_add_attendees_as: oBa,
  salesforce_do_not_route_to_owner: rBa,
  salesforce_route_to_custom_lookup_field: iBa,
  salesforce_option: aBa,
  lookup_field_name: sBa,
  salesforce_if_free_email_domain_skip_owner_check: cBa,
  filter_operator_is: lBa,
  filter_operator_is_not: uBa,
  filter_operator_contains: dBa,
  filter_operator_does_not_contain: _Ba,
  filter_operator_starts_with: pBa,
  filter_operator_ends_with: mBa,
  filter_operator_is_empty: fBa,
  filter_operator_not_empty: gBa,
  translate_description_button: hBa,
  translate_description_button_description: vBa,
  rr_distribution_method: bBa,
  rr_distribution_method_description: yBa,
  rr_distribution_method_availability_title: $Ba,
  rr_distribution_method_availability_description: wBa,
  rr_distribution_method_balanced_title: kBa,
  rr_distribution_method_balanced_description: SBa,
  edit_team_member_weights: EBa,
  weights_updated_successfully: xBa,
  require_confirmation_for_free_email: CBa,
  exclude_emails_that_contain: TBa,
  require_emails_that_contain: ABa,
  exclude_emails_match_found_error_message: IBa,
  require_emails_no_match_found_error_message: OBa,
  search_columns: NBa,
  search_options: zBa,
  disable_org_url_label: RBa,
  disable_org_url_description: PBa,
  single_select: DBa,
  multi_select: LBa,
  calendar_conflict_settings: MBa,
  select_calendars_conflict_check: FBa,
  group_meeting: qBa,
  are_you_sure_you_want_to_remove_this_app_from: jBa,
  disconnect_app_from: VBa,
  salesforce_ignore_guests: BBa,
  google_meet: UBa,
  zoom: GBa,
  office_365_video: WBa,
  lock_attribute_for_assignment: HBa,
  lock_attribute_for_assignment_description: YBa,
  attribute_edited_successfully: KBa,
  new_group_option: ZBa,
  attribute_weight_enabled: XBa,
  attribute_weight_enabled_description: JBa,
  routed: QBa,
  reassigned: e9a,
  allow_rescheduling_past_events: t9a,
  allow_rescheduling_past_events_description: n9a,
  rerouted: o9a,
  salesforce_assigned: r9a,
  router_position: i9a,
  show_matching_hosts: a9a,
  no_active_queues: s9a,
  weight: c9a,
  calibration: l9a,
  shortfall: u9a,
  routing_form: d9a,
  go_back_and_save: _9a,
  save_changes: p9a,
  leave_without_saving: m9a,
  leave_without_saving_description: f9a,
  something_unexpected_occurred: g9a,
  "500_error_message": "Het ligt niet aan jou, het ligt aan ons.",
  dry_run_mode_active: h9a,
  icon_showcase: v9a,
  icons_showcase: b9a,
  migrating_from_team: y9a,
  feature_currently_disabled: $9a,
  choose_an_option: w9a,
  enter_option_value: k9a,
  remove_option: S9a,
  use_attribute_weights: E9a,
  if_enabled_ignore_event_type_weights: x9a,
  attribute_for_weights: C9a,
  managed_users: T9a,
  managed_users_description: A9a,
  can_you_tell_me_about: I9a,
  use_ai_to_answer_your_questions: O9a,
  error_fetching_answer: N9a,
  k_bar_ai_error: z9a,
  select_oAuth_client: R9a,
  on_every_instance: P9a,
  delegation_credential_feature_not_enabled: D9a,
  internal_booking_note: L9a,
  internal_note_cancellation_reason: M9a,
  internal_booking_note_description: F9a,
  internal_note_presets: q9a,
  internal_note_presets_description: j9a,
  internal_note_presets_updated_successfully: V9a,
  add_preset: B9a,
  authorize: U9a,
  next: G9a,
  hide: W9a,
  show: H9a,
  utm_params: Y9a,
  no_utm_params: K9a,
  asc: Z9a,
  desc: X9a,
  verify_email_change: J9a,
  buy_credits: Q9a,
  credits: eUa,
  credits_used: tUa,
  total_credits_remaining: nUa,
  credits_per_tip_org: oUa,
  credits_per_tip_teams: rUa,
  view_and_manage_credits: iUa,
  view_and_manage_credits_description: aUa,
  credit_worth_description: sUa,
  buy_additional_credits: cUa,
  view_additional_credits_expense_tip: lUa,
  overview: uUa,
  organization_slug_taken: dUa,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: _Ua,
  you_need_to_complete_user_onboarding_before_creating_an_organization: pUa,
  use_company_email_to_create_an_organization: mUa,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: fUa,
  you_need_to_have_minimum_published_teams: gUa,
  you_are_part_of_this_organization_already: hUa,
  you_are_part_of_another_organization_cannot_create_organization: vUa,
  you_are_part_of_another_platform_organization_cannot_create_organization: bUa,
  organization_payment_success: yUa,
  organization_payment_success_description: $Ua,
  this_may_take_a_few_seconds: wUa,
  organization_onboarding_status: kUa,
  organization_onboarding_status_description: SUa,
  payment_failed: EUa,
  payment_failed_description: xUa,
  creating_your_organization: CUa,
  organization_onboarding_already_completed: TUa,
  organization_onboarding_already_exists: AUa,
  organization_onboarding_not_found: IUa,
  payment_successful: OUa,
  handover_onboarding_page_title: NUa,
  handover_onboarding_page_description: zUa,
  organization_already_exists_with_this_slug: RUa,
  you_do_not_have_permission_to_create_an_organization_for_this_email: PUa,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: DUa,
  organization_has_subscription_already: LUa,
  reset_interval_weighted_rr: MUa,
  interval: FUa,
  rr_reset_interval_description: qUa,
  daily: jUa,
  end_date_not_selected: VUa,
  my_ooo: BUa,
  team_ooo: UUa,
  out_of_office_team_description: GUa,
  create_ooo_dialog_team_title: WUa,
  create_ooo_dialog_team_subtitle: HUa,
  edit_ooo_dialog_team_subtitle: YUa,
  ooo_team_empty_title: KUa,
  ooo_team_empty_description: ZUa,
  forward_to_team_member_only: XUa,
  ooo_team_redirect_infinite_not_allowed: JUa,
  previous_ooo_empty_title: QUa,
  previous: eGa,
  rr_interval_successfully_updated: tGa,
  trial_mode: nGa,
  inactive_team_plan: oGa,
  inactive_team_plan_description: rGa,
  limited_access_trial_mode: iGa,
  referral_program: aGa,
  referral_text: sGa,
  dub_disabled_error_message: cGa,
  uid: lGa,
  link: uGa,
  rows_per_page: dGa,
  pagination_status: _Ga,
  tip_username_plus: pGa,
  user_has_no_team_yet: mGa,
  no_team_members: fGa,
  recurring_event_doesnt_support_seats: gGa,
  booking_limit_per_booker_doesnt_support_recurring: hGa,
  seats_doesnt_support_recurring: vGa,
  recurring_event_seats_error: bGa,
  segment: yGa,
  saved_filters: $Ga,
  rename: wGa,
  rename_segment: kGa,
  delete_segment: SGa,
  duplicate_segment: EGa,
  delete_segment_confirmation: xGa,
  filter_segment_updated: CGa,
  error_updating_filter_segment: TGa,
  filter_segment_duplicated: AGa,
  error_duplicating_filter_segment: IGa,
  filter_segment_deleted: OGa,
  error_deleting_filter_segment: NGa,
  save_segment: zGa,
  segment_not_found: RGa,
  filter_segment_saved: PGa,
  no_segments: DGa,
  error_saving_filter_segment: LGa,
  override_segment: MGa,
  create_new_segment: FGa,
  save_for_team: qGa,
  select_team: jGa,
  please_select_team: VGa,
  personal: BGa,
  hide_team_profile_link: UGa,
  hide_team_profile_link_description: GGa,
  display: WGa,
  could_not_find_slug_to_publish_org: HGa,
  picklist: YGa,
  most_cancelled_bookings: KGa,
  interface_language: ZGa,
  interface_language_description: XGa,
  visitors_browser_language: JGa,
  name_or_email: QGa,
  salesforce_round_robin_skip_fallback_to_lead_owner: eWa,
  credit_purchase_failed: tWa,
  minimum_of_credits_required: nWa,
  enable_delegation_credential: oWa,
  enable_delegation_credential_description: rWa,
  disable_delegation_credential: iWa,
  disable_delegation_credential_description: aWa,
  last_active: sWa,
  member_since: cWa,
  last_updated: lWa,
  salesforce_on_cancel_write_to_event: uWa,
  salesforce_on_every_cancellation: dWa,
  report_issue: _Wa,
  report_issue_description: pWa,
  open_issue: mWa,
  this_is_your_current_plan: fWa,
  schedule_a_time: gWa,
  this_includes: hWa,
  oauth_client_updated_successfully: vWa,
  oauth_client_not_found: bWa,
  subscribe_to_platform: yWa,
  error_accessing_webhooks: $Wa,
  webhook_update_failed: wWa,
  webhook_create_failed: kWa,
  invalid_link: SWa,
  currently_subscribed_to_plan: EWa,
  user_team: xWa,
  client_id_copied: CWa,
  client_secret_copied: TWa,
  maintenance_message: AWa,
  your_payment_failed: IWa,
  check_your_inbox: OWa,
  account_created_premium_not_reserved: NWa,
  email_sent_with_activation_link: zWa,
  activate_account_to_purchase_username: RWa,
  open_in_gmail: PWa,
  dont_see_email: DWa,
  resend_in_seconds: LWa,
  resend: MWa,
  verification_email_sent: FWa,
  select_all_members: qWa,
  select_all_members_tooltip: jWa,
  form_settings: VWa,
  remove_whitelist_status: BWa,
  whitelist_user_workflows: UWa,
  user_workflows_whitelisted: GWa,
  user_workflows_unwhitelisted: WWa,
  date_and_time: HWa,
  email_reminder_upcoming_event_notice: YWa,
  email_reminder_triggered_by_workflow: KWa,
  event_upper_case: ZWa,
  scheduling_by: XWa,
  experience_review_prompt: JWa,
  improve_customer_experience_message: QWa,
  meeting_satisfaction_question: e8a,
  meeting_not_joined_question: t8a,
  reschedule_cta_short: n8a,
  hide_organizer_email: o8a,
  platform_customer_cant_create_organization: r8a,
  organization_customer_cant_create_platform: i8a,
  hide_organizer_email_description: a8a,
  you_and_conjunction: s8a,
  select_verified_email: c8a,
  add_verified_email: l8a,
  add_verified_emails: u8a,
  custom_reply_to_email_title: d8a,
  custom_reply_to_email_description: _8a,
  email_survey_triggered_by_workflow: p8a,
  skip_trial: m8a,
  team_trials_skipped_successfully: f8a,
  sms_workflow_consent: g8a,
  routing_preview_more_info_found_insights: h8a,
  results: v8a,
  view_form: b8a,
  sms_opt_out_message: y8a,
  team_credits_low_warning: $8a,
  user_credits_low_warning: w8a,
  action_required_out_of_credits: k8a,
  action_required_user_out_of_credits: S8a,
  low_credits_warning_message: E8a,
  low_credits_warning_message_user: x8a,
  credit_limit_reached_message: C8a,
  credit_limit_reached_message_user: T8a,
  current_credit_balance: A8a,
  current_balance: I8a,
  notification_about_your_booking: O8a,
  monthly_credits: N8a,
  total_credits: z8a,
  remaining_credits: R8a,
  remaining: P8a,
  total: D8a,
  additional_credits: L8a,
  routing_form_next_in_queue: M8a,
  routing_form_select_members_to_email: F8a,
  routing_incomplete_booking_tab: q8a,
  include_no_show_in_rr_calculation: j8a,
  recent_no_show_guests: V8a,
  recent_no_show_guests_tooltip: B8a,
  matching: U8a,
  event_redirect: G8a,
  reset_form: W8a,
  rr_settings_successfully_updated: H8a,
  distribution_basis_weighted_rr: Y8a,
  timestamp_basis_description: K8a,
  requires_credits: Z8a,
  requires_credits_tooltip: X8a,
  available_credits: J8a,
  create_role: Q8a,
  roles_and_permissions: e7a,
  roles_and_permissions_description: t7a,
  learn_more_permissions: n7a,
  role_name: o7a,
  role_name_required: r7a,
  role_name_placeholder: i7a,
  role_description: a7a,
  role_description_placeholder: s7a,
  default_role: c7a,
  custom_role: l7a,
  advanced: u7a,
  search_permissions: d7a,
  all_permissions: _7a,
  none: p7a,
  read_only: m7a,
  pbac_desc_all_actions_all_resources: f7a,
  pbac_resource_all: g7a,
  pbac_resource_event_type: h7a,
  pbac_resource_team: v7a,
  pbac_resource_organization: b7a,
  pbac_resource_booking: y7a,
  pbac_resource_insights: $7a,
  pbac_resource_role: w7a,
  pbac_resource_routing_form: k7a,
  pbac_resource_workflow: S7a,
  pbac_action_all: E7a,
  pbac_action_create: x7a,
  pbac_action_read: C7a,
  pbac_action_update: T7a,
  pbac_action_delete: A7a,
  pbac_action_manage: I7a,
  pbac_action_invite: O7a,
  pbac_action_remove: N7a,
  pbac_action_change_member_role: z7a,
  pbac_action_list_members: R7a,
  pbac_action_manage_billing: P7a,
  pbac_action_read_team_bookings: D7a,
  pbac_action_read_org_bookings: L7a,
  pbac_action_read_recordings: M7a,
  pbac_action_impersonate: F7a,
  role_created_successfully: q7a,
  role_updated_successfully: j7a,
  delete_role: V7a,
  confirm_delete_role: B7a,
  role_deleted_successfully: U7a,
  error_creating_role: G7a,
  error_updating_role: W7a,
  pbac_desc_create_roles: H7a,
  pbac_resource_attributes: Y7a,
  pbac_desc_view_organization_attributes: K7a,
  pbac_desc_update_organization_attributes: Z7a,
  pbac_desc_delete_organization_attributes: X7a,
  pbac_desc_create_organization_attributes: J7a,
  pbac_desc_view_roles: Q7a,
  pbac_desc_update_roles: eHa,
  pbac_desc_delete_roles: tHa,
  pbac_desc_create_workflows: nHa,
  set_up_required: oHa,
  pbac_desc_view_workflows: rHa,
  pbac_desc_update_workflows: iHa,
  pbac_desc_delete_workflows: aHa,
  pbac_resource_webhook: sHa,
  pbac_resource_availability: cHa,
  pbac_resource_out_of_office: lHa,
  pbac_desc_create_webhooks: uHa,
  pbac_desc_view_webhooks: dHa,
  pbac_desc_update_webhooks: _Ha,
  pbac_desc_delete_webhooks: pHa,
  pbac_desc_create_availability: mHa,
  pbac_desc_view_availability: fHa,
  pbac_desc_update_availability: gHa,
  pbac_desc_delete_availability: hHa,
  pbac_desc_create_out_of_office: vHa,
  pbac_desc_view_out_of_office: bHa,
  pbac_desc_update_out_of_office: yHa,
  pbac_desc_delete_out_of_office: $Ha,
  pbac_desc_manage_workflows: wHa,
  pbac_desc_create_event_types: kHa,
  pbac_desc_view_event_types: SHa,
  pbac_desc_update_event_types: EHa,
  pbac_desc_delete_event_types: xHa,
  pbac_desc_manage_event_types: CHa,
  pbac_desc_create_teams: THa,
  pbac_desc_view_team_details: AHa,
  pbac_desc_update_team_settings: IHa,
  pbac_desc_delete_team: OHa,
  pbac_desc_invite_team_members: NHa,
  pbac_desc_remove_team_members: zHa,
  pbac_desc_change_team_member_role: RHa,
  pbac_desc_impersonate_team_members: PHa,
  pbac_desc_manage_teams: DHa,
  pbac_desc_create_organization: LHa,
  pbac_desc_view_organization_details: MHa,
  pbac_desc_list_organization_members: FHa,
  pbac_desc_invite_organization_members: qHa,
  pbac_desc_remove_organization_members: jHa,
  pbac_desc_manage_organization_billing: VHa,
  pbac_desc_change_organization_member_role: BHa,
  pbac_desc_impersonate_organization_members: UHa,
  pbac_desc_edit_organization_settings: GHa,
  pbac_desc_manage_organizations: WHa,
  pbac_desc_view_bookings: HHa,
  pbac_desc_view_team_bookings: YHa,
  pbac_desc_view_organization_bookings: KHa,
  pbac_desc_view_booking_recordings: ZHa,
  pbac_desc_update_bookings: XHa,
  pbac_desc_manage_bookings: JHa,
  pbac_desc_view_team_insights: QHa,
  pbac_desc_manage_team_insights: eYa,
  pbac_desc_create_routing_forms: tYa,
  pbac_desc_view_routing_forms: nYa,
  pbac_desc_update_routing_forms: oYa,
  pbac_desc_delete_routing_forms: rYa,
  read_permission_auto_enabled_tooltip: iYa,
  choose_restriction_schedule: aYa,
  restriction_schedule_description: sYa,
  use_booker_timezone: cYa,
  use_booker_timezone_info: lYa,
  load_balancing_warning: uYa,
  rr_load_balancing_disabled: dYa,
  rr_load_balancing_disabled_with_groups: _Ya,
  round_robin_settings_description: pYa,
  round_robin_settings_updated_successfully: mYa,
  booking_creation_time: fYa,
  meeting_start_time: gYa,
  members_affected_by_disabling_delegation_credential: hYa,
  no_members_affected_by_disabling_delegation_credential: vYa,
  download_expense_log: bYa,
  error_downloading_expense_log: yYa,
  offer_to_reschedule_last_booking: $Ya,
  booker_limit_exceeded_error: wYa,
  booker_limit_exceeded_error_reschedule: kYa,
  duration_min_error: SYa,
  duration_max_error: EYa,
  booking_not_allowed_by_restriction_schedule_error: xYa,
  restriction_schedule_not_found_error: CYa,
  converted_image_size_limit_exceed: TYa,
  add_group: AYa,
  routing_funnel: IYa,
  routing_funnel_total_submissions: OYa,
  routing_funnel_successful_routings: NYa,
  routing_funnel_accepted_bookings: zYa,
  license_key: RYa,
  license_selection_title: PYa,
  license_selection_description: DYa,
  agplv3_license_description: LYa,
  enter_license_key: MYa,
  enter_your_license_key: FYa,
  enter_existing_license: qYa,
  enter_license_key_description: jYa,
  license_key_placeholder: VYa,
  save_license_key: BYa,
  signature_token_optional: UYa,
  signature_token_description: GYa,
  need_a_license: WYa,
  license_key_required: HYa,
  invalid_license_key: YYa,
  license_validation_failed: KYa,
  attachments_optional: ZYa,
  send_message: XYa,
  describe_the_issue: JYa,
  file_size_limit_exceed: QYa,
  invalid_file_type: eKa,
  invalid_file_type_extension: tKa,
  max_files_exceeded: nKa,
  files_uploaded_successfully: oKa,
  file_upload_instructions: rKa,
  license_key_saved: iKa,
  timezone_mismatch_tooltip: aKa,
  show_optimized_slots: sKa,
  show_optimized_slots_description: cKa,
  failed_bookings_by_field: lKa,
  failed_bookings: uKa,
  event_type_no_hosts: dKa,
  cache_status: _Ka,
  cache_last_updated: pKa,
  delete_cached_data: mKa,
  cache_deleted_successfully: fKa,
  error_deleting_cache: gKa,
  confirm_delete_cache: hKa,
  yes_delete_cache: vKa,
  remainder_of_maximum_uses_left_plural: bKa,
  remainder_of_maximum_use_left_singular: yKa,
  expires_on_date: $Ka,
  single_use: wKa,
  time_based_expiration: kKa,
  usage_based_expiration: SKa,
  number_of_uses: EKa,
  expires_on: xKa,
  max_usage_count: CKa,
  link_settings: TKa,
  link_expired_on_date: AKa,
  usage_limit_reached: IKa,
  usage_count_error: OKa,
  private_link_expired: NKa,
  time_based_expiration_description: zKa,
  time_based_generic_expiration_description: RKa,
  usage_based_expiration_description: PKa,
  usage_based_generic_expiration_description: DKa,
  usage_based_expiration_description_plural: LKa,
  webhook_trigger_event: MKa,
  webhook_created_at: FKa,
  webhook_type: qKa,
  set_up_agent: jKa,
  webhook_title: VKa,
  webhook_start_time: BKa,
  webhook_end_time: UKa,
  webhook_description: GKa,
  webhook_location: WKa,
  webhook_uid: HKa,
  webhook_reschedule_uid: YKa,
  webhook_cancellation_reason: KKa,
  webhook_rejection_reason: ZKa,
  webhook_organizer_name: XKa,
  webhook_organizer_email: JKa,
  webhook_organizer_timezone: QKa,
  webhook_organizer_locale: eZa,
  webhook_organizer_username: tZa,
  webhook_organizer_username_in_org: nZa,
  webhook_attendee_name: oZa,
  webhook_attendee_email: rZa,
  webhook_attendee_timezone: iZa,
  webhook_attendee_locale: aZa,
  webhook_team_name: sZa,
  webhook_team_members: cZa,
  webhook_video_call_url: lZa,
  webhook_hide_variables: uZa,
  webhook_show_variable: dZa,
  webhook_event_and_booking: _Za,
  webhook_people: pZa,
  webhook_teams: mZa,
  webhook_metadata: fZa,
  stats: gZa,
  booking_status: hZa,
  visit: vZa,
  location_custom_label_input_label: bZa,
  meeting_link: yZa,
  session_outcome: $Za,
  call_created: wZa,
  voicemail: kZa,
  my_bookings: SZa,
  phone: EZa,
  free: xZa,
  user_email: CZa,
  user_name: TZa,
  expand_panel: AZa,
  collapse_panel: IZa,
  email_verification_required: OZa,
  invalid_verification_code: NZa,
  you_have_one_team: zZa,
  consider_consolidating_one_team_org: RZa,
  consider_consolidating_multi_team_org: PZa,
  message_sent: DZa,
  support_message_sent_description: LZa,
  search_variables: MZa,
  support_message_placeholder: FZa,
  send_another_message: qZa,
  sending: jZa,
  no_variables_found: VZa,
  credits_required: BZa,
  web_call_credits_info: UZa,
  web_call_no_credits: GZa,
  purchase_credits: WZa,
  credits_required_tooltip: HZa,
  api_key_name_too_long: YZa,
  auto_charge_for_last_minute_cancellation: KZa,
  before_scheduled_start_time: ZZa,
  cancel_booking_acknowledge_no_show_fee: XZa,
  contact_organizer: JZa,
  booking_time_option: QZa,
  booking_time_option_description: eXa,
  created_at_option: tXa,
  created_at_option_description: nXa,
  call_details: oXa,
  call_id: rXa,
  call_information: iXa,
  sentiment: aXa,
  disconnect_reason: sXa,
  call_summary: cXa,
  transcription: lXa,
  event_details: uXa,
  agent: dXa,
  no_transcript_available: _Xa,
  testing_sms_workflow_info_message: pXa,
  start_from_scratch_title: mXa,
  start_from_scratch_description: fXa,
  cal_ai_template_title: gXa,
  cal_ai_template_description: hXa,
  voice: vXa,
  select_voice: bXa,
  select_voice_for_agent: yXa,
  choose_a_voice_for_your_agent: $Xa,
  trait: wXa,
  voice_id: kXa,
  use_voice: SXa,
  current_voice: EXa,
  setup_incoming_agent: xXa,
  setup_incoming_agent_description: CXa,
  connect_a_phone_number_first: TXa,
  setup_agent_for_incoming_calls: AXa,
  configure_agent_to_handle_incoming_calls: IXa,
  incoming_calls: OXa,
  outgoing_calls: NXa,
  inbound_agent_setup_success: zXa,
  inbound_agent_configured: RXa,
  setup_inbound_agent: PXa,
  please_select_event_type_first: DXa,
  edit_configuration: LXa,
  select_event_type_for_inbound_calls: MXa,
  setup_inbound_agent_for_incoming_calls: FXa,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: qXa
}, VXa = "Provedor de identidade", BXa = 'Você tem $t(day, {"count": {{days}} }) restantes no seu período de testes da versão PRO', UXa = "{{count}} dia", GXa = "{{count}} dias", WXa = "{{count}} segundo", HXa = "{{count}} segundos", YXa = "Atualizar agora", KXa = "Sem título", ZXa = "Aceitar convite", XXa = "Máx. Caracteres", JXa = "Mín. Caracteres", QXa = "{{appName}} é a alternativa de código aberto ao Calendly que coloca você no controle dos seus dados, fluxo de trabalho e aparência.", eJa = "Conclua a configuração da sua conta {{appName}}! Você está a poucos passos de resolver todos os seus problemas de agendamento.", tJa = "Precisa de ajuda? Estamos aqui para ajudar.", nJa = "{{appName}}: Instruções para redefinir sua senha", oJa = "{{appName}}: Verifique sua conta", rJa = "{{appName}}: Verifique seu e-mail", iJa = "Verifique seu e-mail", aJa = "E-mail antigo", sJa = "Novo e-mail", cJa = "Enviamos um e-mail para {{email}}. É importante verificar seu endereço de e-mail para garantir o melhor envio de e-mail e calendário do {{appName}}.", lJa = "Verifique seu endereço de e-mail para garantir o fornecimento do melhor e-mail e calendário", uJa = "Verifique seu endereço de e-mail", dJa = "Verificar e-mail", _Ja = "Assistente", pJa = "Enviar e-mails com transcrição do Cal Video", mJa = "Enviar e-mails com a transcrição do Cal Video após o término da reunião. (Requer um plano pago)", fJa = "Você solicitou recentemente a alteração do endereço de e-mail que você usa para entrar em sua conta {{appName}}. Por favor, clique no botão abaixo para confirmar o seu novo endereço de e-mail.", gJa = "Seu e-mail foi atualizado para {{email}}", hJa = "Não foi possível atualizar o e-mail.", vJa = "Verifique seu novo endereço de e-mail da sua conta {{appName}}", bJa = "Enviamos um link de verificação para {{email}}. Atualizaremos seu endereço de e-mail quando você clicar neste link.", yJa = "Salve esta chave de API em um lugar seguro. Você não será capaz de vê-la novamente.", $Ja = "Por favor, verifique seu endereço de e-mail clicando no botão abaixo.", wJa = "Por favor, verifique seu endereço de e-mail usando o código abaixo.", kJa = "Aqui está o link caso você não goste de usar botões:", SJa = "Insira o código de verificação", EJa = "Insira o código de verificação enviado para seu e-mail", xJa = "O código de verificação está incorreto.", CJa = "E-mail enviado com sucesso", TJa = "Ocorreu um erro ao enviar o e-mail", AJa = "Recusado: {{title}} em {{date}}", IJa = "Cancelado: {{title}} em {{date}}", OJa = "Reatribuído: {{title}} em {{date}}", NJa = "Sua solicitação de reunião foi recusada", zJa = "Personalizar configurações do Cal Video", RJa = "Configure preferências de reuniões por vídeo, incluindo permissões de gravação para anfitriões e participantes.", PJa = "Desativar gravação para convidados", DJa = "Ativar transcrição automática após entrar na reunião", LJa = "Ativar gravação automática após o organizador entrar na reunião", MJa = "Opções de vídeo", FJa = "Editar evento", qJa = "Ver detalhes da sessão", jJa = "Detalhes da sessão de reunião", VJa = "Sessão de reunião", BJa = "ID da sessão", UJa = "Máximo de participantes", GJa = "Ilimitado", WJa = "Em andamento", HJa = "Finalizada", YJa = "Participantes", KJa = "Usuário anônimo", ZJa = "Duração da sessão", XJa = "Nenhuma sessão de reunião encontrada", JJa = "Não disponível", QJa = "Desativar gravação para organizador", eQa = "Desativar transcrição para convidados", tQa = "Desativar transcrição para organizador", nQa = "Sua solicitação de evento recorrente foi recusada", oQa = "Seu evento agendado foi cancelado", rQa = "Seu evento agendado foi reatribuído", iQa = "O evento não estará mais em seu calendário e sua probabilidade de round robin não será afetada negativamente", aQa = "Organizador", sQa = "Reatribuído para", cQa = "Precisa reagendar ou cancelar?", lQa = "Você pode ver os detalhes da reserva neste URL {{url}} e adicionar o evento ao seu calendário", uQa = "Sem opções disponíveis", dQa = "Motivo do cancelamento", _Qa = "Cancelado por", pQa = "Motivo do cancelamento", mQa = "Por que você está cancelando?", fQa = "O motivo do cancelamento será compartilhado com os convidados", gQa = "Por que você está rejeitando?", hQa = "Motivo da recusa", vQa = "Recusar a solicitação de reserva?", bQa = "Tem certeza de que deseja recusar a reserva? Avisaremos a pessoa que tentou reservar. Se quiser, informe um motivo abaixo.", yQa = "Recusar a reserva", $Qa = "Gerenciar este evento", wQa = "Convidar membro da equipe", kQa = "Convite individual", SQa = "Importação em massa", EQa = "Con.", xQa = "A sua reunião foi agendada", CQa = "Seu evento recorrente foi agendado", TQa = "Aceite a nossa licença alterando a variável no arquivo .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> para '{{agree}}'.", AQa = "Para remover este banner, por favor abra seu arquivo .env e altere a variável <1>NEXT_PUBLIC_LICENSE_CONSENT</1> para '{{agree}}'.", IQa = "A mensagem de erro: '{{errorMessage}}'", OQa = "O reembolso falhou: {{name}} - {{date}} - {{eventType}}", NQa = "O reembolso do evento {{eventType}} com {{userName}} em {{date}} falhou.", zQa = "Por favor, tente resolver junto do seu fornecedor de pagamentos e com o {{user}}.", RQa = "Um reembolso falhou", PQa = "Aguardando pagamento: {{title}} em {{date}}", DQa = "Sua reunião está aguardando o pagamento", LQa = "A cor do tema escuro não foi aprovada pela verificação de contraste. Recomendamos que você altere esta cor para que seus botões fiquem mais visíveis.", MQa = "A cor do tema claro não foi aprovada pela verificação de contraste. Recomendamos que você altere esta cor para que seus botões fiquem mais visíveis.", FQa = "A cor do Tema Claro não passa na verificação de contraste. Recomendamos que você altere essa cor para que a cor dos seus tipos de eventos seja mais visível.", qQa = "A cor do Tema Escuro não passa na verificação de contraste. Recomendamos que você altere essa cor para que a cor dos seus tipos de eventos seja mais visível.", jQa = "O pagamento não pôde ser criado", VQa = "Não foi possível cobrar o cartão para o pagamento", BQa = "Nenhum usuário disponível foi encontrado. Você poderia tentar outra faixa horária?", UQa = "O horário selecionado não está mais disponível. <0>Por favor, selecione um novo horário</0>", GQa = "Ocupado", WQa = "Você acabou de se conectar. Por favor, reserve um dos horários acima ou tente novamente mais tarde.", HQa = "Horário indisponível", YQa = "O tipo de evento não pode ser agendado neste horário. Você poderia tentar outro horário?", KQa = "Erro interno. O corpo da solicitação não contém a hora final", ZQa = "Não foi possível criar um evento no calendário do organizador", XQa = "Não foi possível atualizar o evento.", JQa = "Não foi possível deletar o evento.", QQa = "Você já está inscrito para esta reserva.", ees = "Algum dos anfitriões não está disponível para reserva.", tes = "Alguns dos anfitriões fixos não estão disponíveis para reserva.", nes = "O anfitrião do Round Robin não está disponível para agendamento.", oes = "Ajuda", res = "Preço", ies = "Pago", aes = "Reembolsado", ses = "Gravar", ces = "Transcrever", les = "Pagamento", ues = "Faltam campos do cartão", des = "Pagar agora", _es = "Solicitação Geral", pes = "Transcrição alimentada por IA", mes = "Iniciar ou parar gravação", fes = "Inicie a Mensagem", ges = "Todo o código deverá permanecer em código aberto, quer seja modificado ou não", hes = "Você não pode redistribuir ou vender o código", ves = "Envie um e-mail para adquirir uma licença comercial e remover estes termos", bes = "Resumo dos termos", yes = "Abra o arquivo .env e aceite a nossa licença", $es = "Alterei o meu arquivo .env", wes = "Aceitar licença", kes = "Um evento ainda aguarda aprovação", Ses = "Solicitação de evento pendente: {{attendeeName}} - {{date}} - {{eventType}}", Ees = 'Nenhum resultado encontrado para "{{searchTerm}}"', xes = "Não existem mais resultados", Ces = "Nenhum resultado", Tes = "Carregar mais resultados", Aes = "ID da reunião de {{integrationName}}: {{meetingId}}", Ies = "Confirmado: {{eventType}} com {{name}} em {{date}}", Oes = "Solicitação de novo evento: {{attendeeName}} - {{date}} - {{eventType}}", Nes = "Confirmar ou recusar a reserva", zes = "Consulte a sua página de reservas para confirmar ou recusar a reserva.", Res = "Assistente de Check-in", Pes = "Faz uma chamada para verificar se o compromisso agendado funciona ou se você deseja reagendar.", Des = "Crie seu próprio prompt e use-o para fazer uma chamada.", Les = "Um evento está aguardando a sua aprovação", Mes = "Um evento recorrente aguarda a sua aprovação", Fes = "Alguém solicitou o agendamento de um evento em sua agenda.", qes = "Alguém solicitou um link para alterar sua senha.", jes = "Se estee-mail existir em nosso sistema, você receberá um e-mail de redefinição.", Ves = "Se você não fez essa solicitação, você pode ignorar este e-mail e sua senha não será alterada.", Bes = "Aguardando aprovação: {{title}} em {{date}}", Ues = "Um evento está aguardando a sua aprovação", Ges = "Reserva enviada: {{title}} em {{date}}", Wes = "Baixar gravação: {{title}} em {{date}}", Hes = "Baixe a transcrição: {{title}} em {{date}}", Yes = "Baixe sua gravação", Kes = "Baixe suas transcrições", Zes = "A sua reunião foi agendada", Xes = "Seu {{title}} foi remarcado para {{date}}.", Jes = "Seu {{title}} foi atualizado.", Qes = "Atualização - O seu evento foi reagendado", ets = "O evento foi atualizado", tts = "Seu evento foi reagendado", nts = "{{organizer}} cancelou a reserva e solicitou que você escolhesse outro horário.", ots = "Você solicitou que {{attendee}} reagendasse", rts = "Você cancelou a reserva e {{attendee}} escolherá um novo horário.", its = "Solicitação de reagendamento enviado: {{eventType}} com {{name}} às {{date}}", ats = "Ação de reagendamento necessária: reserve outro horário para {{eventType}} com {{name}}", sts = "Olá {{name}}", cts = "{{eventType}} com {{name}}", lts = "Parece que todos os nossos especialistas estão ocupados no momento. Por favor, agende uma chamada em um horário que seja mais conveniente para você e estaremos prontos para ajudar.", uts = "Agendar agora", dts = "Novo evento: {{attendeeName}} - {{date}} - {{eventType}}", _ts = "Junte-se através de {{entryPoint}}", pts = "Notas", mts = "Gerenciar minhas reservas", fts = "Precisa alterar?", gts = "Um novo evento foi agendado.", hts = "Um novo evento recorrente foi agendado.", vts = "E-mail do participante", bts = "Fuso horário do participante", yts = "Tempo restante", $ts = "Tipo do evento", wts = "Tipo de evento duplicado", kts = "Entrar na reunião", Sts = "Fornecedor de videochamada", Ets = "ID da reunião", xts = "Senha da reunião", Cts = "URL da reunião", Tts = "URL da reunião não encontrada", Ats = "Token não encontrado", Its = "Outro anfitrião já aceitou a reunião. Você ainda deseja participar? <0>Continuar para a reunião</0>", Ots = "A sua solicitação de reunião foi rejeitada", Nts = "Rejeitado: {{eventType}} com {{organizer}} em {{date}}", zts = "Olá", Rts = "Entrar no time", Pts = "Gerenciar esta equipe", Dts = "Informações da equipe", Lts = "Entrar na reunião", Mts = "Se não quiser utilizar {{toEmail}} como e-mail do {{appName}}, ou já tem uma conta em {{appName}}, por favor peça outro convite para esse e-mail.", Fts = "Você recebeu um convite para se juntar ao time {{teamName}}", qts = "{{user}} convidou para ingressar na equipe {{team}} de {{entity}} em {{appName}}", jts = "Você está oculto nesta equipe", Vts = "Seu assento não é pago, atualize para a versão Pro ou avise o proprietário da equipe de que é possível pagar pelo seu assento.", Bts = "É preciso ter uma conta Pro para usar equipes, você permanecerá oculto até a atualização.", Uts = "P.S.: Expira em {{expiresIn}} horas.", Gts = 'Atualize para "Por assento"', Wts = "Não é possível usar reservas com assento quando a reserva exigir confirmação", Hts = "Múltiplas Localizações não suportam a opção de assentos", Yts = "A taxa de não comparecimento não suporta a opção de assentos", Kts = "A opção de assentos não suporta Múltiplas Localizações", Zts = "Dos {{memberCount}} membros da sua equipe, há {{unpaidCount}} assento(s) não pago(s). A ${{seatPrice}}/mês por assento, o custo total estimado da sua assinatura é de ${{totalCost}}/mês.", Xts = 'Agradecemos por testar nosso novo plano de equipe. Notamos que a sua equipe "{{teamName}}" precisa ser atualizada.', Jts = "Atualizar aqui", Qts = "Sua equipe foi atualizada com êxito!", ens = 'Agradecemos por testar nosso novo plano Organization. Notamos que a sua organização "{{teamName}}" precisa ser atualizada.', tns = "Sua Organização foi atualizada com êxito!", nns = "Use o link abaixo para redefinir a sua senha", ons = "Olá", rns = "lá", ins = "Esqueceu sua senha? - {{appName}}", ans = "Você tem certeza que quer remover este Webhook? Você não receberá mais dados de reuniões de {{appName}} na URL especificada, em tempo real, quando um evento for agendado ou cancelado.", sns = "Sim, remover o Webhook", cns = "Editar Webhook", lns = "Excluir Webhook", uns = "Status do Webhook", dns = "Webhook ativado", _ns = "Webhook desativado", pns = "Resposta do Webhook", mns = "Teste do Webhook", fns = "Formulário de atualização de webhook", gns = "Adicione um webhook ao seu OAuthClient.", hns = "Gerenciar o seu Webhook", vns = "Webhook criado com sucesso!", bns = "Webhook atualizado com sucesso!", yns = "Webhook removido com sucesso!", $ns = "Assinatura necessária", wns = "Você não está inscrito em um plano da plataforma.", kns = "Modelo de carga", Sns = "Descartar", Ens = "Ainda não há dados", xns = "Teste de ping", Cns = "Adicione este aplicativo à sua tela inicial para acesso mais rápido e melhor experiência.", Tns = "Próximos", Ans = "Recorrente", Ins = "Anteriores", Ons = "Escolher um arquivo...", Nns = "Enviar imagem", zns = "Enviar {{target}}", Rns = "Nenhum {{target}}", Pns = "Deslize para ampliar, arraste para reposicionar", Dns = "Ver notificações", Lns = "Ver página pública", Mns = "Copiar link de página pública", Fns = "Copiar link de indicação", qns = "Sair", jns = "Adicionar outro", Vns = "Instalar outro", Bns = "até", Uns = "desenvolvido por", Gns = "Indisponível", Wns = "Defina o seu horário de trabalho", Hns = "Altere a sua disponibilidade para reservas", Yns = "Selecionar...", Kns = "Texto", Zns = "Seu número de telefone", Xns = "Múltiplas linhas de texto", Jns = "Número", Qns = "Caixa de seleção", eos = "É obrigatório", tos = "Tornar este campo obrigatório", nos = "Obrigatório", oos = "Opcional", ros = "Tipo de campo", ios = "Recusado", aos = "Não confirmado", sos = "Participantes", cos = "Participante", los = "Os detalhes para a vídeo chamada serão fornecidos em breve.", uos = "Confirmação", dos = "O que seu agendador deve fornecer para receber confirmações", _os = "Nome de usuário", pos = "ainda está disponível.", mos = "Documentação", fos = "Saiba como integrar as nossas ferramentas com a sua aplicação", gos = "Referência da API", hos = "Uma referência completa da API para as nossas bibliotecas", vos = "Blog", bos = "Leia as nossas últimas notícias e artigos", yos = "Junte-se à nossa comunidade", $os = "Páginas populares", wos = "Inscreva-se agora", kos = "Inscrição", Sos = "Esta página não existe.", Eos = "Nenhum número de telefone ativo disponível", xos = "Etapa do fluxo de trabalho não configurada", Cos = "Verificar erros ortográficos ou voltar à página anterior.", Tos = "Não foi possível achar o evento que você está tentando reservar.", Aos = "Começar", Ios = "Segredo", Oos = "Deixe em branco para remover o segredo", Nos = "Verifique se o seu servidor está recebendo apenas as solicitações esperadas do {{appName}} por razões de segurança", zos = "Reunião secreta", Ros = "Em vez disso, faça login", Pos = "Criar Conta", Dos = "Começar", Los = "Confirmar senha", Mos = "Defina sua nova senha com as instruções enviadas para seu endereço de e-mail.", Fos = "Faça upload de uma imagem com largura {{width}} e altura {{height}} .", qos = "Volte a entrar com seu novo endereço de e-mail e senha.", jos = "Criar sua conta", Vos = "Crie sua conta Cal.com", Bos = "Cadastro", Uos = "A sessão foi encerrada", Gos = "Esperamos te ver novamente em breve!", Wos = "Sessão Encerrada", Hos = "Por favor, tente novamente e contate-nos se o problema persistir.", Yos = "O código de dois fatores está incorreto.", Kos = "Não existe nenhuma conta associada a este endereço de e-mail.", Zos = "Criar uma conta", Xos = "Não tem uma conta?", Jos = "Fazer login em sua conta", Qos = "Iniciar sessão", ers = "Voltar à página de login", trs = "Ocorreu um erro ao iniciar sessão. Volte a tela de login e tente novamente.", nrs = "Solicitar redefinição da senha", ors = "Enviar convite", rrs = "Esqueceu a senha?", irs = "Esqueceu?", ars = "Concluído", srs = "Tudo pronto!", crs = "Todos", lrs = "Sua conta", urs = "Aplicativos disponíveis", drs = "Aplicativos disponíveis", _rs = "Veja aplicativos populares abaixo e explore mais em nossa <0>App Store</0>", prs = "Adicione qualquer pessoa que precise participar do evento. <0>Saiba mais</0>", mrs = "As pessoas em um grupo se revezam, uma pessoa de cada grupo aparecerá para o evento.", frs = "As pessoas do grupo se revezam, e apenas uma aparecerá para o evento.", grs = "Verifique o seu e-mail. Enviamos um link para redefinir a sua senha.", hrs = "Finalizar", vrs = "Gerencie as configurações para o idioma e o fuso horário da sua equipe", brs = "Fale um pouco sobre você. Isto será exibido em sua página pessoal.", yrs = "Quase lá!", $rs = "Por último, uma breve descrição sobre você e uma foto realmente ajudam a conseguir agendamentos e permitem que as pessoas saibam com quem estão agendando.", wrs = "Definir períodos em que você está disponível de forma recorrente. Mais tarde você poderá criar outros períodos e atribuí-los a diferentes calendários.", krs = "Definir disponibilidade", Srs = "Defina os horários que você quer que estejam disponíveis para reservas.", Ers = "Compartilhe um link ou incorpore", xrs = "Compartilhe o link da sua conta {{appName}} ou incorpore no seu site.", Crs = "Configurações de disponibilidade", Trs = "Continuar sem calendário", Ars = "Continuar com {{appName}}", Irs = "Conectar seu calendário", Ors = "Conecte seus aplicativos de vídeo", Nrs = "Conecte seus aplicativos de vídeo para usá-los nos seus tipos de evento.", zrs = "Conecte seu calendário para verificar automaticamente horários ocupados e novos eventos conforme são agendados.", Rrs = "Configurar mais tarde", Prs = "Hora atual", Drs = "Detalhes", Lrs = "Bem vindo", Mrs = "Bem-vindo(a) novamente", Frs = "Bem vindo ao {{appName}}", qrs = "Diga-nos como devemos chamá-lo e informe em qual fuso horário você está. Você poderá editar isso mais tarde.", jrs = "Conectar a um servidor CalDav", Vrs = "Conectar a um feed ICS", Brs = "Conectar", Urs = "Experimente gratuitamente", Grs = "Crie o seu próprio link para reservas com {{appName}}", Wrs = "Quem", Hrs = "O quê", Yrs = "Quando", Krs = "Onde", Zrs = "Adicionar ao calendário", Xrs = "Selecione onde adicionar eventos quando você for agendado.", Jrs = "Adicionar eventos a", Qrs = "Adicionar outro calendário", eis = "Outras", tis = "Seu link de login para {{appName}}", nis = "Você está reunindo-se com {{user}}. Nós enviamos um e-mail com um convite de calendário com todos os detalhes para todos.", ois = "{{host}} terá uma reunião com {{attendee}}. Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes.", ris = "Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes.", iis = "Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes para o primeiro destes eventos recorrentes.", ais = "Você terá uma reunião com {{user}}. Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes para o primeiro destes eventos recorrentes.", sis = "{{host}} terá uma reunião com {{attendee}}. Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes para o primeiro destes eventos recorrentes.", cis = "Esta informação foi enviada para você e para todos os outros participantes.", lis = "A sua reserva ainda precisa de ser confirmada ou recusada.", uis = "A sua reunião recorrente ainda precisa ser confirmada ou recusada.", dis = "{{user}} ainda tem de confirmar ou recusar a reserva.", _is = "{{user}} ainda precisa confirmar ou recusar cada reserva da reunião recorrente.", pis = "Esta reunião está agendada", mis = "Os eventos recorrentes foram agendados", fis = "Reserva efetuada", gis = "Sua reunião recorrente foi enviada", his = "Reserva confirmada", vis = "Sua reunião recorrente foi confirmada", bis = "Os pagamentos ainda não são compatíveis com eventos recorrentes", yis = "Eventos recorrentes ainda não são compatíveis com os pagamentos", $is = "Insira a nova senha que você deseja utilizar.", wis = "Redefinir senha", kis = "Alterar sua senha", Sis = "Exibir senha", Eis = "Ocultar senha", xis = "Tente novamente", Cis = "Este pedido expirou.", Tis = "Digite o endereço de e-mail associado à sua conta e um link para redefinir sua senha será enviado.", Ais = "Este pedido expirou. Volte atrás e digite o e-mail associado à sua conta para lhe enviarmos uma nova ligação para redefinir a sua senha.", Iis = "Ops", Ois = "Login", Nis = "Sucesso", zis = "Falhou", Ris = "A sua senha foi redefinida. Agora pode fazer login com a sua senha recém-criada.", Pis = "Layout", Dis = "Visualização padrão", Lis = "Você pode selecionar várias opções, e os reservantes podem alternar entre as visualizações.", Mis = "Layout da reserva", Fis = "Você pode selecionar várias opções, e os reservantes podem alternar entre as visualizações. Pode ser sobrescrito a cada evento.", qis = "Mês", jis = "Semanalmente", Vis = "Coluna", Bis = "Pelo menos um layout precisa ser habilitado.", Uis = "O layout selecionado como visualização padrão não faz parte dos layouts habilitados.", Gis = "O layout selecionado não é válido.", Wis = "Você pode gerenciar isso para todos os seus tipos de eventos em Configurações -> <0>Aparência</0> ou <1>Substituir</1> apenas para este evento.", His = "Ocorreu um erro inesperado. Tente novamente.", Yis = "Horário inválido no domingo", Kis = "Horário inválido na segunda-feira", Zis = "Horário inválido na terça-feira", Xis = "Horário inválido na quarta-feira", Jis = "Horário inválido na quinta-feira", Qis = "Horário inválido na sexta-feira", eas = "Horário inválido no sábado", tas = "O horário de término não pode ser anterior ao de início", nas = "O horário de término não pode ser maior do que 24 horas", oas = "Voltar às Reservas", ras = "Sinta-se à vontade para escolher outro evento a qualquer hora.", ias = "Cancelado", aas = "Sem agendamento", sas = "Aguardando anfitrião", cas = "Cancelado com Sucesso", las = "Deseja realmente cancelar a sua reserva?", uas = "Você não pode cancelar esta reserva", das = "Em vez disso, você também pode reagendar.", _as = "Este evento já aconteceu", pas = "O evento é uma instância de um evento recorrente.", mas = "Estas são todas as instâncias restantes no evento recorrente.", fas = "Ocorreu um erro com o status code {{status}}.", gas = "Já existe um tipo de evento para este URL.", has = "Não é possível criar este evento", vas = "Não é possível editar este evento", bas = "Não é possível criar este fluxo de trabalho", yas = "Não é possível criar esta agenda", $as = "Esta agenda já foi cancelada", was = "Esta reserva já foi aceita ou recusada", kas = "Voltar à Página Inicial", Sas = "Ou volte à página inicial", Eas = "Nenhuma reunião encontrada", xas = "Esta reunião não existe. Contate o organizador da reunião para obter um link atualizado.", Cas = "Ainda não tem reservas {{status}}", Tas = "Você não possui reservas {{status}}. {{description}}", Aas = "{{eventName}} entre {{host}} e {{attendeeName}}", Ias = "Reservas", Oas = "Reserva não encontrada", Nas = "Veja os eventos futuros e passados reservados através dos links de tipos de eventos.", zas = "Assim que alguém reservar uma hora, ela aparecerá aqui.", Ras = "Assim que alguém reservar uma reunião recorrente com você, essa pessoa aparecerá aqui.", Pas = "As suas reservas anteriores aparecerão aqui.", Das = "Suas reservas canceladas aparecerão aqui.", Las = "Suas reservas não confirmadas aparecerão aqui.", Mas = "Reservas não confirmadas", Fas = "em", qas = "e", jas = "O seu calendário mostra que você está ocupado entre", Vas = "Solucionar problemas", Bas = "Entenda por que há certos horários disponíveis e outros estão bloqueados.", Uas = "Aqui está uma visão geral do seu dia em", Gas = "Dica: passe o mouse sobre os horários em negrito para um visão completa", Was = "Hora de início", Has = "Hora de término", Yas = "Horário de intervalo", Kas = "Antes do evento", Zas = "Após o evento", Xas = "Sem horário de intervalo", Jas = "Intervalo", Qas = "O seu dia começa às", ess = "O seu dia termina às", tss = "Iniciar o solucionador de problemas", nss = "Utilize o solucionador de problemas para descobrir o porque os seus horários estão aparecendo desta forma.", oss = "Alterar os horários disponíveis", rss = "Alterar os horários disponíveis", iss = "Alterar as horas de início e término do seu dia", ass = "Defina a hora de início e término do seu dia e um intervalo mínimo entre as suas reuniões.", sss = "Atualmente, o seu dia está definido para começar as", css = "As horas de início e término do seu dia foram alteradas com sucesso.", lss = "e termina em", uss = "Claro", dss = "Escuro", _ss = "Ajustar tema automaticamente com base nas preferências do usuário", pss = "Alguns usuários do grupo desativaram as reservas de grupos dinâmicas", mss = 'Agrupe links de reserva que podem ser criados dinamicamente ao adicionar vários nomes de usuário com "+", por exemplo: "{{appName}}/bailey+peer"', fss = "Permita que os participantes façam reservas com as reservas de grupo dinâmicas", gss = "Links de grupo dinâmicos", hss = "Permitir que mecanismos de busca acessem seu conteúdo público", vss = "Permitir indexação por motores de busca", bss = "Permitir notificações do navegador", yss = "Você negou as notificações. Redefina a permissão nas configurações do navegador para ativar.", $ss = "Desativar notificações do navegador", wss = "Notificações do navegador ativadas", kss = "Notificações do navegador desativadas", Sss = "Notificações do navegador negadas", Ess = "Por favor, permita notificações no prompt", xss = "Notificações push", Css = "Receba notificações push quando o agendador fizer uma reserva instantânea de reunião.", Tss = "Seu navegador não suporta notificações push. Se você é usuário do Brave, ative a opção `Usar serviços do Google para mensagens push` em brave://settings/?search=push+messaging", Ass = "E-mail", Iss = "nome@exemplo.com", Oss = "Nome Completo", Nss = "Consulte a nossa documentação da API", zss = "Utilize nossa API para controle e personalização completa.", Rss = "Criar Webhook", Pss = "Reunião instantânea criada", Dss = "Reserva cancelada", Lss = "Reserva Reagendada", Mss = "Link para download de gravação pronto", Fss = "Transcrição Gerada", qss = "Reserva Criada", jss = "Reserva recusada", Vss = "Reserva solicitada", Bss = "Pagamento da reserva iniciado", Uss = "Reunião encerrada", Gss = "Formulário enviado", Wss = "Formulário enviado, nenhum evento agendado", Hss = "Reserva paga", Yss = "Fora do Escritório Criado", Kss = "Não Comparecimento Atualizado", Zss = "Gatilhos de eventos", Xss = "URL do assinante", Jss = "Criar um novo webhook", Qss = "Webhooks", ecs = "Webhooks da equipe", tcs = "Criar um webhook para sua conta", ncs = "Novo Webhook", ocs = "Receba dados da reunião {{appName}} em uma, URL especificada, em tempo real, quando um evento for agendado ou cancelado.", rcs = "Receba em tempo real dados da reunião do {{appName}} em um URL especificada quando este evento for agendado ou cancelado.", ics = "Iframe responsivo de tela inteira", acs = "Carregando...", scs = "Excluindo...", ccs = "Iframe padrão", lcs = "Desenvolvedor", ucs = "Gerencie suas configurações de desenvolvedor.", dcs = "Incorporar iframe", _cs = "A maneira mais fácil de incorporar o {{appName}} no seu site.", pcs = "Integre em seu site utilizando as nossas opções para embutir ou obtenha informações da reserva em tempo real utilizando webhooks personalizados.", mcs = "Agende uma Reunião", fcs = "Visualizar e gerenciar os seus detalhes de faturamento", gcs = "Ver e editar os seus dados de faturamento, bem como cancelar a sua assinatura.", hcs = "Ir para o portal de pagamento", vcs = "Precisa de algo mais?", bcs = "Se precisar de mais ajuda com o faturamento, o nosso time de suporte está aqui para ajudar.", ycs = "Contato", $cs = "a nossa equipe de suporte", wcs = "Fale com a nossa equipe de suporte", kcs = "Oh oh!", Scs = "Este usuário ainda não definiu nenhum tipo de evento.", Ecs = "Editar logotipo", xcs = "Envie um logotipo", Ccs = "Carregar logotipo", Tcs = "Remover logotipo", Acs = "Ativado", Ics = "Código", Ocs = "Código incorreto.", Ncs = "Adicionar novo horário", zcs = "Adicione uma camada extra de segurança à sua conta, caso sua senha seja comprometida.", Rcs = "Ativar autenticação de dois fatores", Pcs = "Desativar autenticação de dois fatores", Dcs = "Se precisar desativar a autenticação de dois fatores, recomendamos reativá-la o mais rápido possível.", Lcs = "Erro ao desativar autenticação de dois fatores", Mcs = "Erro ao configurar autenticação de dois fatores", Fcs = "Segurança", qcs = "Gerenciar a segurança da sua conta.", jcs = "Senha", Vcs = "Senha atualizada com sucesso", Bcs = "Sua senha foi alterada com sucesso.", Ucs = "Erro ao alterar senha", Gcs = "Sua configuração da sessão foi atualizada com sucesso.", Wcs = "Erro ao atualizar a configuração da sessão", Hcs = "Ocorreu um erro.", Ycs = "Algo parece errado?", Kcs = "Por favor, tente novamente.", Zcs = "Sua nova senha super segura", Xcs = "Nova Senha", Jcs = "Sua senha antiga", Qcs = "Senha Atual", els = "Alterar Senha", tls = "Alterar segredo", nls = "Nova senha é idêntica à sua senha antiga. Por favor, escolha uma senha diferente.", ols = "Caso tenha perdido ou esquecido o segredo, você poderá alterá-lo. Mas fique ciente de que todas as integrações com esse segredo precisarão ser atualizadas", rls = "Senha atual está incorreta", ils = "Mistura de letras maiúsculas e minúsculas", als = "Mínimo de sete caracteres", sls = "No mínimo 15 caracteres", cls = "Contém pelo menos um número", lls = "O tamanho deve ser de {{limit}} ou menos caracteres", uls = "A senha precisa ter pelo menos sete caracteres com pelo menos um número e ser uma combinação de letras maiúsculas e minúsculas", dls = "Senha incorreta.", _ls = "A senha ou o nome de usuário está incorreto.", pls = "Usar configurações", mls = "manhã/tarde", fls = "Opções de horário", gls = "Janeiro", hls = "Fevereiro", vls = "Março", bls = "Abril", yls = "Maio", $ls = "Junho", wls = "Julho", kls = "Agosto", Sls = "Setembro", Els = "Outubro", xls = "Novembro", Cls = "Dezembro", Tls = "Segunda-feira", Als = "Terça-feira", Ils = "Quarta-feira", Ols = "Quinta-feira", Nls = "Sexta-feira", zls = "Sábado", Rls = "Domingo", Pls = "Tudo reservado.", Dls = "Não foi possível carregar os horários disponíveis.", Lls = "+ Participantes Adicionais", Mls = "Seu nome", Fls = "Seu nome completo", qls = "Sem nome", jls = "Por favor, insira um número entre 1 e {{maxOccurences}}", Vls = "Rápido e fácil - sem necessidade de conta. Perfeito para reuniões únicas.", Bls = "Endereço de e-mail", Uls = "Insira um e-mail válido", Gls = " Por favor, agende uma chamada futura se não estivermos disponíveis em {{seconds}} segundos", Wls = "Local", Hls = "Local", Yls = "Insira o endereço", Kls = "Pessoalmente (endereço do participante)", Zls = "Outro Lugar", Xls = "Localização personalizada do participante", Jls = "Continuar como convidado", Qls = "Entrar como convidado", eus = "Ideal para chamadas únicas", tus = "Qualquer localização", nus = "Sim", ous = "Não", rus = "Observações adicionais", ius = "Não foi possível agendar a reunião.", aus = "Não foi possível reagendar a reunião.", sus = "Por favor, compartilhe qualquer coisa que nos ajude a nos preparar para nossa reunião.", cus = "Confirme seu {{eventTypeTitle}} com {{profileName}}", lus = "Reagende seu {{eventTypeTitle}} com {{profileName}}", uus = "Reunião presencial", dus = "Pessoalmente (endereço do organizador)", _us = "Vincular reunião", pus = "Número de Telefone", mus = "Número de telefone do participante", fus = "Número de telefone do organizador", gus = "Digite o número de telefone", hus = "Reagendar", vus = "Ou reagendar", bus = "Agende um membro da equipe no lugar", yus = "OU", $us = "Retornar", wus = "E-mail ou Nome de Usuário", kus = "Enviar um convite por e-mail", Sus = "Função", Eus = "Editar função", xus = "Ver função", Cus = "Editar time", Tus = "Editando usuário", Aus = "Editando organização", Ius = "Se você deseja editar ou gerenciar seus webhooks, acesse as <0>configurações de webhooks</0>", Ous = "Recusar", Nus = "Recusar tudo", zus = "Aceitar", Rus = "Sair", Pus = "Perfil", Dus = "URL do meu time", Lus = "Meus times", Mus = "Nome do time", Fus = "Nome do seu time", qus = "Time atualizado com sucesso", jus = "Seu time foi atualizado com sucesso.", Vus = "Sua organização foi atualizada com sucesso.", Bus = "Erro ao copiar para a área de transferência", Uus = "Sobre", Gus = "Fale um pouco sobre seu time. Isso aparecerá na página pública do seu time.", Wus = "ID da organização", Hus = "ID da organização copiado.", Yus = "Uma breve descrição sobre sua organização. Isso aparecerá na página principal da sua organização.", Kus = "ID da equipe", Zus = "ID da equipe copiado.", Xus = "Membros", Jus = "Membros da organização", Qus = "Membro", eds = "{{count}} membro", tds = "{{count}} membros", nds = "{{count}} selecionados", ods = "Proprietário", rds = "Admin", ids = "API de Admin", ads = "Usuário administrador", sds = "Vamos criar o primeiro usuário administrador.", cds = "Configuração de usuário administrador", lds = "Você já criou um usuário administrador. Já é possível fazer login na sua conta.", uds = "Novo Membro", dds = "Convidar", _ds = "Adicionar membros da equipe", pds = "Adicionar membros", mds = "Convidar outros para se juntar à sua equipe", fds = "Adicionar membro da equipe", gds = "Convidar um novo membro", hds = "Nota: Isso <0>custará um assento adicional (R$15/mês)</0> em sua assinatura.", vds = "Convidar alguém para seu time.", bds = "Carregar arquivo .csv", yds = "Convidar via e-mail", $ds = "Alterar função de membro da equipe", wds = "Remover a marca {{appName}}", kds = "Ocultar todas as marcas de {{appName}} de suas páginas públicas.", Sds = "Ocultar botão de agendar um membro da equipe", Eds = "Oculte o botão de agendar um membro da equipe em suas páginas públicas.", xds = "Zona de perigo", Cds = "Cuidado. A exclusão da conta não pode ser desfeita.", Tds = "Cuidado. A exclusão da equipe não pode ser desfeita.", Ads = "Voltar", Ids = "Cancelar", Ods = "Cancelar todos os restantes", Nds = "Aplicar", zds = "Cancelar este evento", Rds = "Confirmar", Pds = "Confirmar tudo", Dds = "Desfazer Time", Lds = "Tem certeza de que deseja desfazer esta equipe? Qualquer pessoa com quem você compartilhou este link da equipe não será mais capaz de fazer novos agendamentos.", Mds = "Desfazer organização", Fds = "Tem certeza de que deseja desfazer esta Org? Todos os membros e equipes serão excluídos.", qds = "Tem certeza de que deseja remover este membro do time?", jds = "Sim, disfazer time", Vds = "Sim, remover membro", Bds = "Sim, cancelar assinatura", Uds = "Cancelar assinatura", Gds = "Cancelar sua assinatura desativará permanentemente seu plano atual. Esta ação não pode ser desfeita.", Wds = "Remover membro", Hds = "Gerenciar sua equipe", Yds = "Você ainda não tem nenhuma equipe.", Kds = "Equipes permitem que outras pessoas reservem eventos compartilhados entre seus colegas de trabalho.", Zds = "Enviar", Xds = "Sim, remover atributo", Jds = "Remover atributo", Qds = "Você tem certeza de que deseja remover o atributo '{{name}}'? Todos os usuários atualmente atribuídos a ele serão desassociados.", e_s = "Atualizar", t_s = "Salvar", n_s = "Pendente", o_s = "Abrir opções", r_s = "Copiar link do evento", i_s = "Compartilhar", a_s = "Você se importa de fazer uma reserva para mim no Cal ou enviar seu link?", s_s = "Copiar link do time", c_s = "Sair do time", l_s = "Sim, sair do time", u_s = "Você tem certeza de que deseja sair deste time? Você não conseguirá reservar mais utilizando esse time.", d_s = "{{user}} do {{team}}", __s = "Pré-visualizar", p_s = "Link copiado!", m_s = "Copiado!", f_s = "Link privado copiado!", g_s = "Link compartilhado!", h_s = "Título", v_s = "Descrição", b_s = "Status de apps", y_s = "Uma chamada rápida de video.", $_s = "Tipo de Agendamento", w_s = "Pré-visualizar time", k_s = "Coletivo", S_s = "Agende reuniões quando todos os membros selecionados do time estiverem disponíveis.", E_s = "Duração", x_s = "Durações disponíveis", C_s = "Duração padrão", T_s = "Escolha as durações disponíveis primeiro", A_s = "{{count}} $t(minute_timeUnit)", I_s = "{{count}} $t({{unit}}_timeUnit)", O_s = "{{count}}$t({{unit}}_short)", N_s = "Minutos", z_s = "Use Cal.ai para adquirir um número de telefone com IA ou faça ligações para convidados.", R_s = "URI de terminação", P_s = "Nome de usuário do tronco SIP", D_s = "Senha do tronco SIP", L_s = "Apelido", M_s = "Excluir número de telefone", F_s = "Falha na validação do fluxo de trabalho", q_s = "Uma ou mais etapas do fluxo de trabalho têm conteúdo de mensagem vazio", j_s = "Um ou mais números de telefone ou endereços de e-mail não estão verificados", V_s = "Potencialize seus fluxos de trabalho com Cal.ai", B_s = "Agentes de IA realistas que marcam reuniões, enviam lembretes e fazem acompanhamento com seus clientes.", U_s = "Número de telefone importado e vinculado ao agente com sucesso", G_s = "Número de telefone excluído com sucesso", W_s = "Tem certeza de que deseja excluir este número de telefone? Esta ação não pode ser desfeita.", H_s = "Sim, excluir número de telefone", Y_s = "O número que você está tentando importar deve estar no formato E.164 (+código do país seguido pelo número, sem espaços ou caracteres especiais), por exemplo, +1234567890", K_s = "O URI de terminação para identificar exclusivamente seu tronco SIP elástico. Isso é usado para chamadas de saída. Para troncos SIP elásticos da Twilio, sempre termina com .pstn.twilio.com.", Z_s = "O nome de usuário usado para autenticar o tronco SIP.", X_s = "A senha usada para autenticar o tronco SIP.", J_s = "Apelido do número. Isso é apenas para sua referência.", Q_s = "Salvar e testar chamada", eps = "Chamada iniciada com sucesso", tps = "Por favor, insira um número de telefone", nps = "Agente atualizado com sucesso", ops = "Agente criado com sucesso", rps = "Tipo de evento adicionado com sucesso", ips = "Número de telefone cancelado com sucesso", aps = "Este prompt define o papel e os objetivos principais do agente", sps = "Prompt", cps = "Ligar para", lps = "Fazer ligação de teste para verificar a configuração", ups = "Mensagem inicial", dps = "A primeira mensagem que o agente dirá ao iniciar uma chamada", _ps = "Está tendo problemas para importar?", pps = "Aprender", mps = "Aprenda como obter seu URI de terminação e credenciais de tronco SIP", fps = "Assinatura do número de telefone cancelada com sucesso", gps = "Atualizando", hps = "Round Robin", vps = "Olá, como você está?", bps = "Reuniões recorrentes entre vários membros da equipe.", yps = "Evento gerenciado", $ps = "nome de usuário", wps = "Crie e distribua tipos de eventos em massa para os membros da equipe", kps = "Gerenciado", Sps = 'o "nome de usuário" será preenchido com o nome de usuário dos membros atribuídos', Eps = "Atribuir a", xps = "Digite o número de telefone para teste de chamada", Cps = "Fazer ligação de teste", Tps = "Criar novo agente de voz cal.ai para fluxo de trabalho", Aps = "Crie um novo agente de voz cal.ai para fluxo de trabalho para automatizar seus processos", Ips = "Número de telefone (para nosso agente ligar)", Ops = "Compre um número de telefone ou importe um que você já tenha na Twilio", Nps = "Testar agente", zps = "Testar chamada web", Rps = "Números de telefone", Pps = "Cancelar inscrição", Dps = "Excluir etapa do fluxo de trabalho", Lps = "Cancelar inscrição do número de telefone", Mps = "Comprar um novo número", Fps = "Você só pode comprar números de telefone dos EUA. Para outros países, você pode importar seu próprio número de telefone da Twilio.", qps = "Compre um número dos EUA por ${{priceInDollars}} por mês", jps = "Destinos de chamada compatíveis", Vps = "Nenhum número de telefone conectado", Bps = "Falha ao obter o ID da etapa do fluxo de trabalho", Ups = "Agente Cal.ai", Gps = "Testar agente Cal.ai", Wps = "Tem certeza que deseja excluir esta etapa do fluxo de trabalho?", Hps = "Você ainda deseja cancelar a assinatura do número de telefone deste agente?", Yps = "Esta ação desconectará o número de telefone do agente. O agente não poderá fazer chamadas até que um novo número de telefone seja conectado.", Kps = "Números de telefone", Zps = "Conectar número de telefone", Xps = "Gerencie seus números de telefone", Jps = "Importar número", Qps = "Esta ação também irá:", ems = "Importar número de telefone", tms = "Assinatura ativa", nms = "Cancelar sua assinatura de número de telefone", oms = "Excluir o número de telefone associado", rms = "Você não está autorizado a criar este fluxo de trabalho", ims = "Importe seu número de telefone Twilio para usar com o Phone", ams = "${{price}}/mês", sms = "Comprar novo número", cms = "Comprar um número de telefone custa ${{priceInDollars}} por mês. Você será cobrado mensalmente por cada número de telefone ativo.", lms = "Código de área (opcional)", ums = "Nenhum número de telefone", dms = "Número de telefone comprado com sucesso", _ms = "Cancelar assinatura do número de telefone", pms = "Sim, cancelar assinatura", mms = "Tem certeza que deseja cancelar esta assinatura de número de telefone? Esta ação não pode ser desfeita e você perderá o acesso a este número de telefone.", fms = "Adicionar membros...", gms = "Adicionar membros", hms = "Nenhum membro atribuído", vms = "Atribuído a", bms = "Você deve estar logado em {{url}}", yms = "Começar a atribuir os membros acima", $ms = "Os membros não poderão editar isto", wms = "Membros podem editar", kms = "Esta opção foi bloqueada pelo administrador da equipe", Sms = "Desbloqueado pelo administrador da equipe", Ems = "URL", xms = "Esconder", Cms = "Somente leitura", Tms = "Link único", Ams = "Atualmente você está no plano {{plan}}.", Ims = "Atualize a sua conta para o plano Pro e desbloqueie todos os recursos que temos para oferecer.", Oms = "Você precisa fazer um upgrade do seu plano para ter mais de um tipo de evento ativo.", Nms = "Você precisa fazer upgrade do seu plano para criar um time.", zms = "Você pode <1>atualizar aqui</1>.", Rms = "Tipos de Eventos", Pms = "Crie eventos para que as pessoas possam fazer agendamentos em seu calendário.", Dms = "Novo tipo de evento", Lms = "Crie seu primeiro evento", Mms = "Os eventos permitem que você compartilhe links que mostram os horários disponíveis no seu calendário para que os usuários façam agendamentos com você.", Fms = "{{eventTypeTitle}} evento criado com sucesso", qms = "{{eventTypeTitle}} tipo de evento atualizado com sucesso", jms = "Tipo de evento removido com sucesso", Vms = "Horas", Bms = "Pessoas", Ums = "Seu E-mail", Gms = "Alterar Avatar", Wms = "Enviar avatar", Hms = "Idioma", Yms = "Fuso Horário", Kms = "Primeiro Dia da Semana", Zms = "Repete-se até {{count}} vez", Xms = "Repete-se até {{count}} vezes", Jms = "A cada {{freq}} durante", Qms = "{{count}} evento restante", efs = "{{count}} eventos restantes", tfs = "Repete-se a cada", nfs = "ocorrência", ofs = "ocorrências", rfs = "semana", ifs = "semanas", afs = "mês", sfs = "meses", cfs = "ano", lfs = "anos", ufs = "Mais {{count}}", dfs = "Máx", _fs = "Tema", pfs = "Cor da Marca", mfs = "Cor da marca (tema claro)", ffs = "Cor da marca (tema escuro)", gfs = "Cor do Tipo de Evento (Tema Claro)", hfs = "Cor do Tipo de Evento (Tema Escuro)", vfs = "Arquivo não é [idOrSlug]/[user]", bfs = "Criar equipe", yfs = "Nome", $fs = "Equipe sem nome", wfs = "Clientes OAuth", kfs = "Gerencie clientes OAuth para sua organização", Sfs = "Criar cliente OAuth", Efs = "Crie um novo cliente OAuth para integrações de terceiros", xfs = "Cliente OAuth excluído com sucesso", Cfs = "Crie um time para colaborar com os usuários.", Tfs = "Criar um novo time", Afs = "URL da sua página de agendamento", Ifs = "URL da página onde seus usuários podem cancelar o agendamento", Ofs = "URL da página onde seus usuários podem reagendar", Nfs = "Este horário não está mais disponível. Por favor, volte à página anterior e selecione outro horário.", zfs = "Convites enviados", Rfs = "Novo time", Pfs = "Crie seu primeiro time e convide outros usuários para trabalharem com você.", Dfs = "Criar um time para começar", Lfs = "Times", Mfs = "Equipe", Ffs = "Organização", qfs = "Cobrança da equipe", jfs = "Gerenciar cobrança para sua equipe", Vfs = "Alteramos a cobrança para equipes", Bfs = "Há membros da sua equipe que não têm assento. Atualize para o plano Pro para incluir os assentos faltando.", Ufs = "A partir de janeiro de 2022, a cobrança dos membros de equipe será realizada por assento. Os membros da sua equipe que tinham o plano PRO gratuito receberam um teste de 14 dias. Ao fim do teste, eles serão ocultos da sua equipe, a não ser que você atualize agora.", Gfs = "Criar e gerenciar times para usar recursos de colaboração.", Wfs = "Este recurso só está disponível no plano Pro", Hfs = "Para remover a marca {{appName}} das suas páginas de reservas, você precisar fazer o upgrade para uma conta Pro.", Yfs = "Edite as informações do seu perfil, que aparecem na sua página de reservas.", Kfs = "Você precisa sair e entrar novamente para as alterações surtirem efeito.", Zfs = "Fale um pouco mais sobre você.", Xfs = "Perfil atualizado com sucesso", Jfs = "O seu perfil foi atualizado com sucesso.", Qfs = "Sua atualização chegou", egs = "Melhore sua experiência de agendamento atualizando para o novo plano e aproveite os novos recursos.", tgs = "Está tudo pronto", ngs = "Você já está no plano mais recente. Não há nada para atualizar. Aproveite os novos recursos e entre em contato conosco se tiver alguma dúvida!", ogs = "O usuário parece estar logado, mas não foi encontrado no banco de dados", rgs = "Incorporar & Webhooks", igs = "Ativado", ags = "Desativado", sgs = "Desativar", cgs = "Faturamento", lgs = "aqui", ugs = "Gerenciar as suas informações de faturamento e cancelar a sua assinatura.", dgs = "Disponibilidade", _gs = "Editar disponibilidade", pgs = "Configure os horários em que estiver disponível para reservas.", mgs = "Copiar tipos para", fgs = "Copiar horários para…", ggs = "Altere a sua agenda semanal", hgs = "Logotipo", vgs = "Erro", bgs = "Insira pelo menos um caractere", ygs = "Insira pelo menos {{count}} caracteres", $gs = "Logotipo do time", wgs = "Adicionar uma localização", kgs = "Participantes", Sgs = "Adicionar Participantes", Egs = "Mostrar Configurações Avançadas", xgs = "Ocultar configurações avançadas", Cgs = "Nome do Evento", Tgs = "Nome do evento no calendário", Ags = "O nome que aparecerá nos calendários", Igs = "Reunião com {{attendeeName}}", Ogs = "Campos adicionais", Ngs = "Solicitar que o agendador insira entradas adicionais antes que o pedido seja confirmado", zgs = "Etiqueta", Rgs = "Preenchimento", Pgs = "Exibir o e-mail 'Adicionar ao calendário' como organizador", Dgs = "Iremos exibir este endereço de e-mail como o organizador, e enviaremos e-mails de confirmação aqui.", Lgs = 'Se habilitado, iremos exibir o endereço de e-mail do seu "Adicionar ao calendário" como organizador e enviaremos e-mails de confirmação lá', Mgs = "Observe que pode ser necessário desconectar e reconectar sua conta 'Adicionar ao calendário' para usar esse recurso.", Fgs = "Tipo", qgs = "Editar", jgs = "Adicionar um campo", Vgs = "Ocultar notas no calendário", Bgs = "Por motivo de privacidade, notas e dados adicionais serão ocultos na entrada do calendário. Serão enviadas por e-mail.", Ugs = "A reserva precisa ser confirmada manualmente antes de ser enviada para as integrações e ser enviado um e-mail de confirmação.", Ggs = "Reservas não confirmadas ainda bloqueiam os horários no calendário.", Wgs = "Evento recorrente", Hgs = "As pessoas podem se inscrever em eventos recorrentes", Ygs = "Conecte-se e participe", Kgs = "Não pode ser usado com eventos pagos", Zgs = "Reuniões instantâneas ainda não são compatíveis com eventos recorrentes e aplicativos de pagamento", Xgs = "Experimental: reunião instantânea são atualmente experimentais.", Jgs = "Iniciando", Qgs = "Desativar participantes", ehs = "Desativar a adição de participantes adicionais durante a reserva.", ths = "Gerar link privado", nhs = "Ativar URL privada", ohs = "Link privado", rhs = "Seu link privado será reaproveitado após cada uso", ihs = "Copiar link privado", ahs = "Copiar link privado para evento", shs = "Gere um URL privado para compartilhar sem expor seu nome de usuário do {{appName}}", chs = "Links Privados", lhs = "Gere URLs privados sem expor o nome de usuário, com limites configuráveis de expiração e uso", uhs = "Adicionar novo link", dhs = "Link privado copiado", _hs = "Os convidados podem agendar", phs = "Intervalo de Datas", mhs = "dias da agenda", fhs = "dias úteis", ghs = "Defina um endereço ou local", hhs = "Defina um link para a reunião", vhs = "Não pode ser alternado. Só pode ser desbloqueado para tipos de eventos filhos", bhs = "{{appName}} solicitará ao seu convidado que insira um número de telefone antes de agendar.", yhs = "{{appName}} fornecerá um link para o Google Meet.", $hs = "{{appName}} fornecerá uma URL de reunião do Zoom.", whs = "{{appName}} fornecerá um URL de reunião do Tandem.", khs = "O {{appName}} irá fornecer um URL de reunião do Daily video.", Shs = "O Cal fornecerá um URL de reunião do Jitsi Meet.", Ehs = "O {{appName}} fornecerá um URL de reunião do Huddle01 Web3 video.", xhs = "O {{appName}} enviará um URL da reunião para o MS Teams. OBSERVAÇÃO: É PRECISO TER UMA CONTA ESCOLAR OU CORPORATIVA", Chs = "Requerer Pagamento", Ths = "Você precisa adicionar um nome", Ahs = "comissão por transação", Ihs = "O seu tipo de evento foi atualizado com sucesso.", Ohs = "Ocultar Tipo de Evento", Nhs = "Editar Localização", zhs = "no futuro", Rhs = "Quando agendado com menos de <0></0> de antecedência", Phs = "Dentro de um período", Dhs = "Indefinidamente no futuro", Lhs = "Adicionar novo campo personalizado", Mhs = "Bate papo rápido", Fhs = "Adicionar um novo tipo de evento de equipe", qhs = "Adicionar um novo tipo de evento", jhs = "Crie um novo tipo de evento para as pessoas agendarem horários.", Vhs = "Comprimento", Bhs = "Aviso mínimo", Uhs = "Deslocar horários de início", Ghs = "Deslocar em uma quantidade específica de minutos as alocações de horário mostradas aos reservantes", Whs = "Deslocar em", Hhs = "ex.: serão mostradas aos seus reservantes alocações de horário à(s) {{ adjustedTime }} em vez de {{ originalTime }}", Yhs = "Intervalos de tempo", Khs = "Usar a duração do evento (padrão)", Zhs = "Excluir tipo de evento?", Xhs = "Excluir tipo de evento gerenciado?", Jhs = "Este link não poderá mais ser usado para fazer reserva por qualquer pessoa com quem tenha sido compartilhado.", Qhs = "Os membros atribuídos a este tipo de evento também terão seus tipos de eventos excluídos.", evs = "Qualquer pessoa com quem eles compartilharam seu link não poderá mais agendar usando-o.", tvs = "Sim, excluir", nvs = "Apagar conta", ovs = "Sim, apagar conta", rvs = "Qualquer pessoa que você compartilhou seu link de reservas não poderá mais utilizá-lo para agendar novos eventos e todas as suas preferências serão perdidas.", ivs = "Integrações", avs = "Apps", svs = "Aqui você poderá encontrar uma lista de todos os seus aplicativos", cvs = "Listagem de aplicativos", lvs = "Aplicativos de {{category}}", uvs = "App Store", dvs = "Conectando pessoas, tecnologia e o ambiente de trabalho.", _vs = "Conecte seu aplicativo de videoconferência", pvs = "Configurações", mvs = "Tipo de evento atualizado com sucesso", fvs = "Próximo Passo", gvs = "Ignorar passo", hvs = "Passo anterior", vvs = "Instalar", bvs = "Comece o teste gratuito", yvs = "Instalado", $vs = "{{count}} instalação ativa", wvs = "{{count}} instalações ativas", kvs = "Instalado globalmente", Svs = "Aplicativo instalado com sucesso", Evs = "Não foi possível instalar o aplicativo", xvs = "Desconectar", Cvs = "Incorpore o seu calendário no seu site", Tvs = "Conecte as suas aplicações favoritas.", Avs = "Automatização", Ivs = "Configure como os seus tipos de evento deverão interagir com os seus calendários.", Ovs = "Ative/desative os calendários que você quiser para verificar conflitos e evitar reservas repetidas.", Nvs = "Conectar calendário adicional", zvs = "Calendário atualizado com êxito", Rvs = "Verifique aqui", Pvs = "Conferência", Dvs = "Calendário", Lvs = "Pagamentos", Mvs = "Não instalado", Fvs = "As senhas inseridas são difererentes.", qvs = "Este campo é obrigatório.", jvs = "Status", Vvs = "Ver disponibilidade do usuário", Bvs = "O usuário precisa aceitar o convite para ver a disponibilidade", Uvs = "Definir-se como indisponível", Gvs = "Desativar status indisponível", Wvs = "Erro ao atualizar status de ausência", Hvs = "Este usuário está indisponível no momento.", Yvs = "A pessoa que você está tentando realizar uma reserva está indisponível no momento e, portanto, não está aceitando novas reservas.", Kvs = "Conheça pessoas com os mesmos tokens", Zvs = "Faça ou permita reservas apenas de pessoas que compartilham os mesmos tokens, DAOs ou NFTs.", Xvs = "Sua conta foi criada através de um provedor de identidade.", Jvs = "Sua conta é gerenciada por {{provider}}", Qvs = "Para alterar o seu endereço de e-mail, senha, ativar a autenticação de dois fatores e outras alterações, por favor utilize as configurações de seu provedor de identidade {{provider}}.", ebs = "Sua conta é gerenciada por um provedor de identidade diferente. Tente fazer login com {{provider}}.", tbs = "Erro ao criar um novo usuário. Por favor, tente novamente.", nbs = "Entrar com Google", obs = "Entrar com SAML", rbs = "Entrar com SAML/OIDC", ibs = "Continuar com e-mail", abs = "Continuar com o Google", sbs = "Último uso", cbs = "Você precisa gerar um token de acesso na ferramenta de agendamento antiga.", lbs = "Importar de", ubs = "Token de acesso", dbs = "Roadmap", _bs = "Categorias em destaque", pbs = "Flags de recursos", mbs = "Aqui você pode ativar ou desativar os recursos da sua instância do Cal.com.", fbs = "Categorias populares", gbs = "{{count}} Aplicativo", hbs = "{{count}} aplicativos", vbs = "Apps em alta", bbs = "Mais popular", ybs = "Apps instalados", $bs = "Grátis", wbs = "Sem aplicativos de {{category}}", kbs = "Todos os aplicativos", Sbs = "Adicione um aplicativo de calendário para verificar se há conflitos para evitar agendamentos duplos", Ebs = "Tente adicionar um aplicativo para chamadas de vídeo com seus clientes", xbs = "Adicione um aplicativo de pagamento para facilitar a transação entre você e seus clientes", Cbs = "Adicione um aplicativo de análise às suas páginas de reservas", Tbs = "Adicione um aplicativo de automação para usar", Abs = "Adicione qualquer outro tipo de aplicativo para fazer todos os tipos de coisas", Ibs = "Adicione um aplicativo de mensagem para definir lembretes e notificações personalizados", Obs = "Adicione um aplicativo CRM para acompanhar todos os integrantes das suas reuniões", Nbs = "Defina o(s) calendário(s) para verificar se há conflitos e evitar reservas duplas.", zbs = "Configure quais serviços de processamento de pagamento serão usados no carregamento de seus clientes.", Rbs = "Configure quais aplicativos de análise serão usados nas suas páginas de reservas", Pbs = "Todos os seus aplicativos instalados de outras categorias.", Dbs = "Configure quais aplicativos de conferência serão usados", Lbs = "Configure quais aplicativos de automação serão usados", Mbs = "Configure quais aplicativos de mensagem usar para definir lembretes e notificações", Fbs = "Configure quais aplicativos CRM usar para acompanhar os integrantes das suas reuniões", qbs = "Análise", jbs = "Nenhum app instalado", Vbs = "Os aplicativos permitem que você melhore o fluxo de trabalho e melhore significativamente sua vida de agendamento.", Bbs = "Navegue na App Store", Ubs = "Gerencie os apps instalados ou altere as configurações", Gbs = "Procurar apps", Wbs = "Recursos", Hbs = "Permissões", Ybs = "Termos e privacidade", Kbs = "Publicado por {{author}}", Zbs = "Assinar", Xbs = "Comprar", Jbs = "Instalar app", Qbs = "Categorias", eys = "Preço", tys = "Saiba mais", nys = "Experimente agora", oys = "Política de privacidade", rys = "Termos de serviço", iys = "Remover", ays = "Adicionar", sys = "{{count}} instalado(s)", cys = "Verificar carteira", lys = "Criar eventos em", uys = "Este é um recurso comercial", dys = "Você pode testar este recurso localmente mas não em produção.", _ys = "Para adquirir uma licença comercial, entre em contato com nossa equipe de vendas. Se você já possui uma chave de licença, por favor, entre em contato com support@cal.com para obter ajuda.", pys = "Falta a licença", mys = "Próximos passos", fys = "Adquira uma licença comercial", gys = "O plano de infraestrutura é baseado no uso e tem descontos acessíveis para novos usuários.", hys = "Crie uma conta com o Prisma Studio", vys = "Aprenda a configurar seu primeiro usuário", bys = "Fale com a equipe de vendas", yys = "Erro 404", $ys = "Definir como padrão", wys = "Nova agenda", kys = "Adicionar nova agenda", Sys = "Adicionar um novo calendário", Eys = "Definir onde adicionar novos eventos quando você estiver com a reserva feita.", xys = "Excluir agenda", Cys = "A exclusão da agenda vai removê-la de todos os tipos de evento. Essa ação não pode ser desfeita.", Tys = "Agenda {{scheduleName}} criada com êxito", Ays = "Agenda {{scheduleName}} criada com êxito", Iys = "Agenda removida com êxito", Oys = "Horas de trabalho", Nys = "Criar agenda de disponibilidade", zys = "A criação de agendas de disponibilidade permite gerenciar a disponibilidade em tipos de evento. Podem ser aplicadas a um ou mais tipos de evento.", Rys = "Requer que o usuário que agendar tenha um token que pertence ao endereço a seguir:", Pys = "João da Silva", Dys = "Formato de hora", Lys = "Redirecionar após a reserva ", Mys = 'Você está sendo redirecionado para {{ url }} em $t(second, {"count": {{seconds}} }).', Fys = "https://example.com/redirect-to-my-success-page", qys = "Redirecione para um URL personalizado após realizar uma reserva", jys = "Duplicar", Vys = "Oferecer assentos", Bys = "Oferecer assentos para reserva. Isto desativa automaticamente reservas de convidados e confirmações.", Uys = "Assento disponível", Gys = "Assentos disponíveis", Wys = "Assentos quase preenchidos", Hys = "Assentos sendo preenchidos rapidamente", Yys = "Número de assentos por reserva", Kys = "Defina a janela de entrada da reunião (segundos): O período de tempo em segundos dentro do qual o anfitrião pode entrar e iniciar a reunião. Após esse período, a URL de entrada da reunião expirará.", Zys = "Insira a quantidade de assentos", Xys = "Você pode gerenciar suas agendas na página de Disponibilidade.", Jys = "Não há mais assentos disponíveis", Qys = "Chaves de API", e$s = "Chave de API", t$s = "Testar chave de API", n$s = "Teste aprovado!", o$s = "Teste com falha", r$s = "Informe a chave de API", i$s = "Chaves de API permitem criar chamadas de API para a sua própria conta.", a$s = "Crie um marketplace ou plataforma em vez disso.", s$s = "Gere chaves de API e use-as para acessar a sua própria conta.", c$s = "Criar uma chave de API", l$s = "Nomear essa chave", u$s = "Exemplo: Desenvolvimento", d$s = "Chave de API sem nome", _$s = "Esta chave de API não data de vencimento", p$s = "Editar chave de API", m$s = "Chave de API criada com êxito", f$s = "Chave de API atualizada com êxito", g$s = "Criar", h$s = "Salve esta chave de API em um local seguro.", v$s = "Não será possível visualizá-la novamente ao fechar esta janela.", b$s = "Copiar para a área de transferência", y$s = "Ativado após a atualização", $$s = "O link privado funcionará após salvar", w$s = "Revogar esta chave de API", k$s = "Desativar reagendamento", S$s = "Os convidados não podem mais reagendar o evento pelo convite do calendário ou e-mail", E$s = "Permitir agendamento através do link de reagendamento", x$s = "Quando ativado, os usuários poderão criar uma nova reserva ao tentar reagendar uma reserva cancelada", C$s = "Desativar cancelamento", T$s = "Os convidados não podem mais cancelar o evento pelo convite do calendário ou e-mail", A$s = "Revogar chave de API", I$s = "Chave de API copiada!", O$s = "A chave de API expira em", N$s = "Remover permanentemente esta chave de API da sua conta?", z$s = "Copiar", R$s = "Data de vencimento", P$s = "Expirada", D$s = "Nunca expira", L$s = "Expira", M$s = "Solicitar o reagendamento da sua reserva", F$s = "Motivo do reagendamento", q$s = "Agendar um novo horário", j$s = "Solicitação de reagendamento enviada", V$s = "Isso cancelará a reunião agendada, notifique quem agendou e peça que escolha outro horário.", B$s = "Motivo da solicitação de reagendamento", U$s = "Solicitar reagendamento ", G$s = "Editar reserva", W$s = "Reagendar reserva", H$s = "Horário anterior", Y$s = "Adicionar um GIF à sua página de confirmação", K$s = "Procurar", Z$s = "Representar", X$s = "Representação do usuário", J$s = "Permite que a nossa equipe de suporte entre temporariamente como você para ajudar a resolver rapidamente os problemas relatados.", Q$s = "Permite que os administradores da sua equipe façam login como você.", ews = "Gratuito para pessoas. Planos de equipe para recursos colaborativos.", tws = "Tornar a organização privada", nws = "Os membros da sua organização não poderão ver outros membros da organização quando esta opção estiver ativada.", ows = "Tornar equipe privada", rws = "Os membros da sua equipe não poderão ver outros membros da equipe após habilitar isso.", iws = "Você não pode ver todos os membros da equipe de uma equipe privada.", aws = "Você não pode equipes de uma organização privada.", sws = "Permitir múltiplas durações", cws = "Todos os usos desse recurso são auditados.", lws = 'Representando o nome de usuário "{{user}}".', uws = "Clique aqui para parar", dws = "Atualização: o local do seu evento foi alterado", _ws = "Adicionado - Novos convidados adicionados ao seu evento", pws = "Local alterado: {{eventType}} com {{name}} em {{date}}", mws = "Convidados Adicionados: {{eventType}} com {{name}} em {{date}}", fws = "Local atual", gws = "Novo local", hws = "Sessão", vws = "Controle sua sessão da conta", bws = "Tempo esgotado de sessão após", yws = "Tempo de sessão esgotado", $ws = "Invalide sua sessão após um certo tempo.", wws = "Nenhum local definido", kws = "Definir local", Sws = "Atualizar local", Ews = "Local atualizado", xws = "Falha na atualização da localização", Cws = "Convidados adicionados", Tws = "Não foi possível adicionar convidados", Aws = "Isso não parece um endereço de e-mail", Iws = "Os e-mails devem ser únicos e válidos", Ows = "Isso não parece ser uma URL", Nws = "Coloque este código no seu HTML onde você quiser que o seu widget do {{appName}} apareça.", zws = "Crie ou atualize um componente existente do React como demonstrado abaixo.", Rws = "Copiar código", Pws = "Código copiado!", Dws = "Como deseja adicionar o {{appName}} ao seu site?", Lws = "Escolha uma das maneiras a seguir para colocar o {{appName}} no seu site.", Mws = "Configurando a sua integração com o Zapier", Fws = "Configurando a sua integração com o Make", qws = "Gerar chave de API", jws = "Gerar uma chave de API para usar com o {{appName}} em", Vws = "Sua chave de API única", Bws = "Copie esta chave de API e salve em um local seguro. Se perder a chave, será preciso gerar uma nova.", Uws = "<0>Entre na conta do Zapier e crie um novo Zap.</0><1>Selecione {{appName}} como seu app de gatilho. Escolha também um evento de gatilho.</1><2>Escolha sua conta e insira sua chave de API única.</2><3>Teste seu gatilho.</3><4>Tudo pronto!</4>", Gws = "Vá para <0>Link de Convite do Make</0> e instale o aplicativo Cal.com.", Wws = "Faça login na sua conta Make e crie um novo Cenário.", Hws = "Selecione Cal.com como seu aplicativo de Gatilho. Escolha também um evento de Gatilho.", Yws = "Escolha sua conta e insira sua Chave API Única.", Kws = "Teste seu Gatilho.", Zws = "Tudo pronto!", Xws = "Instale primeiro o app do Zapier na loja de apps.", Jws = "Instale primeiro o aplicativo do Make na loja de aplicativos.", Qws = "Instalação do app", eks = "Aplicativo não instalado", tks = "Desculpe, este aplicativo não está instalado na sua conta. Por favor, visite nossa loja de aplicativos para explorar e descobrir este e outros ótimos aplicativos.", nks = "Conectar com o servidor da Apple", oks = "URL do calendário", rks = "Gerar uma senha específica de app para usar com o {{appName}} em", iks = "Não é possível adicionar esta conta de calendário da Apple. Por favor, verifique se você está usando uma senha específica para aplicativos ao invés de uma senha de conta.", aks = "As suas credenciais serão armazenadas e encriptadas.", sks = "Será armazenada e criptografada.", cks = "Ir para a loja de apps", lks = "Algo deu errado, tente reconectar seu calendário com todas as permissões necessárias", uks = "Defina um número de telefone para a reunião", dks = "Não há espaços ocupados", _ks = "Exibir na página de reserva", pks = "A localização estará visível antes da confirmação da reserva", mks = "Adicionar GIF", fks = "Procurar Giphy", gks = "Adicionar link de Giphy", hks = "Adicionando GIF à página de confirmação", vks = "Encontre um GIF para animar a sua página de confirmação", bks = "Compartilhar comentário", yks = "Recursos", $ks = "Documentação de suporte", wks = "Documentação do desenvolvedor", kks = "Entrar em contato", Sks = "Fale com o suporte", Eks = "Suporte Premium", xks = "Suporte da comunidade", Cks = "Comentário", Tks = "Agradecemos o seu comentário!", Aks = "Erro ao enviar comentário", Iks = "Compartilhe seus comentários aqui:", Oks = "Detalhes da reserva", Nks = "ou", zks = "Não importa", Rks = "Ir para: ", Pks = "Link de convite do Zapier", Dks = "Um URL de Reunião será criado assim que o evento for confirmado.", Lks = "Exibe dinamicamente o nome do participante para você, ou seu nome se for visto pelo seu participante", Mks = "Local do evento", Fks = "Motivo de reagendamento (opcional)", qks = "Diga por que você precisa reagendar", jks = "Este evento foi cancelado", Vks = "Avisamos por e-mail aos outros participantes e a você.", Bks = "Este campo será mostrado na reserva deste evento", Uks = "O URL da reunião está no e-mail de confirmação", Gks = "O URL precisa começar com http:// ou https://", Wks = "O número de telefone será fornecido", Hks = "antes do início do evento", Yks = "quando o evento for cancelado", Kks = "Após os anfitriões não entrarem na videochamada do Cal", Zks = "Após os convidados não entrarem na videochamada do Cal", Xks = "Entrar na videochamada", Jks = "Entrar no Cal.com", Qks = "Entrar no Cal.com", e0s = "Acompanhe suas reuniões, receba notificações e gerencie sua agenda com mais eficiência.", t0s = "Acompanhe suas reuniões e gerencie sua agenda com mais eficiência", n0s = "Falha ao entrar na chamada. Por favor, tente novamente.", o0s = "Escolha como você gostaria de entrar nesta chamada", r0s = "Escolha como você gostaria de aparecer na chamada", i0s = "quando um novo evento for reservado", a0s = "enviar e-mail para a(o) anfitriã(o)", s0s = "enviar e-mail aos participantes", c0s = "Enviar SMS para participante", l0s = "enviar SMS para um número específico", u0s = "Envie lembretes de reuniões facilmente aos participantes por SMS", d0s = "enviar mensagem por WhatsApp para um número específico", _0s = "enviar mensagem por WhatsApp para participante", p0s = "Fluxos de trabalho", m0s = "Novo fluxo de trabalho", f0s = "Como você gostaria de começar?", g0s = "Adicionar um novo workflow", h0s = "quando o evento for reagendado", v0s = "Gatilho", b0s = "Gatilhos", y0s = "Acão", $0s = "Crie fluxos de trabalho para automatizar notificações e lembretes", w0s = "Nome do fluxo de trabalho", k0s = "Fluxo de trabalho personalizado", S0s = "{{workflowName}} criado com sucesso", E0s = "Tem certeza que deseja excluir este fluxo de trabalho?", x0s = "Excluir fluxo de trabalho", C0s = "Sim, excluir fluxo de trabalho", T0s = "Fluxo de trabalho excluído com sucesso", A0s = "Quanto tempo antes do início do evento?", I0s = "dias", O0s = "hours", N0s = "minutos", z0s = "m", R0s = "h", P0s = "Criar seu primeiro fluxo de trabalho", D0s = "Fluxos de trabalho permitem que você automatize o envio de lembretes e notificações.", L0s = "Ativar em", M0s = "Fluxo de trabalho {{workflowName}} atualizado com sucesso", F0s = "Este é um nome de usuário padrão. Para atualizá-lo, levaremos você para fazer downgrade na cobrança.", q0s = "Este é um nome de usuário premium, obtenha o seu por {{price}}", j0s = "Atual", V0s = "premium", B0s = "padrão", U0s = "Confirmar alteração de nome de usuário", G0s = "O nome de usuário será alterado de padrão para premium, por isso levaremos você para atualizar na conclusão.", W0s = "O nome de usuário será alterado de premium para padrão, por isso levaremos você para fazer downgrade na conclusão.", H0s = "Ir para cobrança", Y0s = "Solicitar pagamento de reservas (0,5% + €0.10 de comissão por transação)", K0s = "Seu teste expirou", Z0s = "Remover app", X0s = "Sim, remover o app", J0s = "Tem certeza de que deseja remover este app?", Q0s = "Aplicativo removido com sucesso", e1s = "Erro ao remover o aplicativo", t1s = "Conferência via web", n1s = "Chamada web", o1s = "Iniciar chamada web", r1s = "Encerrar chamada", i1s = "Teste seu agente com uma chamada web sem precisar de um número de telefone", a1s = "Chamada telefônica", s1s = "Conectando ao agente...", c1s = "Chamada ativa", l1s = "Chamada encerrada", u1s = "Erro na chamada", d1s = "Pronto para iniciar a chamada", _1s = "Falha ao iniciar a chamada web. Por favor, tente novamente.", p1s = "A chamada encontrou um erro. Por favor, tente novamente.", m1s = "Falha ao inicializar a chamada web. Verifique se as permissões do microfone estão concedidas.", f1s = "Inicie uma chamada para ver a conversa", g1s = "Aguardando conversa...", h1s = "Agente de IA", v1s = "Ao vivo", b1s = "Conectando...", y1s = "Requer confirmação", $1s = "Requer confirmação caso a reserva seja feita com menos de {{time}} $t({{unit}}_timeUnit) de antecedência", w1s = "Pode exigir confirmação", k1s = "{{count}} tipo de evento", S1s = "{{count}} tipos de evento", E1s = "{{count}} equipe", x1s = "{{count}} equipes", C1s = "Adicionar ação", T1s = "Definir link do Whereby", A1s = "Insira um link válido do Whereby", I1s = "Definir link do Around.Co", O1s = "Insira um link válido do Around.Co", N1s = "Definir link do Riverside", z1s = "Insira um link válido do Riverside", R1s = "Insira um link de Ping.gg válido", P1s = "Conectar com o servidor do Exchange 2013", D1s = "Conectar com o servidor do Exchange 2016", L1s = "Modelo personalizado", M1s = "Corpo do e-mail", F1s = "Mensagem de texto", q1s = "Tem um problema específico?", j1s = "pesquisar nos nossos documentos", V1s = "Escolher um modelo", B1s = "Personalizado", U1s = "Lembrete", G1s = "Reagendado", W1s = "Reagendado por", H1s = "Agendamento original", Y1s = "Concluído", K1s = "Nota", Z1s = "Lembrete: {{eventType}} com {{name}} em {{date}}", X1s = "Não será acionado para reservas já existentes, pois o usuário deverá fornecer o número de telefone ao fazer um pedido no evento.", J1s = "{{count}} minuto", Q1s = "{{count}}m", eSs = "{{count}} minutos", tSs = "{{count}} hora", nSs = "{{count}}h", oSs = "{{count}} horas", rSs = "Entrada inválida", iSs = "Não foi possível adicionar o link da reunião {{location}} ao seu evento agendado. Entre em contato com seus convidados ou atualize seu evento no calendário para adicionar os detalhes. Você pode <0>alterar sua localização no tipo de evento</0> ou tentar <1>remover e adicionar o aplicativo novamente.</1>", aSs = "Não foi possível atualizar seu <1>{{calendar}}</1>. <2> Confira as configurações do seu calendário ou remova e adicione seu calendário novamente </2>", sSs = "Nome do participante", cSs = "O nome completo da pessoa que está fazendo a reserva", lSs = "Integração com falha", uSs = "Ocorreu um problema ao adicionar um link de vídeo", dSs = "Ocorreu um problema ao atualizar seu calendário", _Ss = "Ativo em {{count}} tipo de evento", pSs = "Ativo em {{count}} tipos de eventos", mSs = "Ativo em {{count}} equipe", fSs = "Ativo em {{count}} equipes", gSs = "Ativo em todos os tipos de eventos", hSs = "Ativo em todas as equipes", vSs = "Nenhum tipo de evento ativo", bSs = "Nenhuma equipe ativa", ySs = "Novo participante {{name}} no {{eventType}} em {{date}}", $Ss = "Alguém se adicionou a um evento", wSs = "Variável", kSs = "Nome do evento", SSs = "Nome do participante", ESs = "Data do evento", xSs = "Horário do evento", CSs = "Nome do organizador", TSs = "Para usar este recurso, atualize para uma conta Pro.", ASs = "Número de telefone inválido", ISs = "URL inválida para {{label}}. URL de amostra: {{sampleUrl}}", OSs = "Navegar", NSs = "Abrir", zSs = "Fechar", RSs = "Atualizar", PSs = "Comprar número dos EUA por {{priceInDollars}}$/mês", DSs = "Atualize para acessar as gravações", LSs = "Gravações estão disponíveis apenas como parte do plano Teams. Atualize para começar a gravar suas chamadas", MSs = "Atualize para Enterprise para poder criar um número de telefone de Assistente de IA que pode ligar para convidados para agendar ligações", FSs = "Gravações fazem parte do plano Teams", qSs = "Este é um recurso de Equipe. Atualize para Equipe para ver a disponibilidade da sua equipe.", jSs = "Este é um recurso de Equipe. Atualize para a Equipe para automatizar suas notificações de eventos e lembretes com fluxos de trabalho.", VSs = "Exibir no perfil", BSs = "Inserir", USs = "Novo nome de usuário", GSs = "Nome de usuário atual", WSs = "Exemplo 1", HSs = "Exemplo 2", YSs = "Identificador de pergunta de reserva", KSs = "Tamanho da empresa", ZSs = "Em que você precisa de ajuda?", XSs = "Formato variável", JSs = "URL de assinante de webhook já está definida", QSs = "Ignore todos os caracteres especiais da etiqueta de entrada adicional (use apenas letras e números), use todas as letras maiúsculas e substitua espaços em branco por sublinhados.", eEs = "Como usar perguntas de reserva como variáveis?", tEs = "Baixar app para desktop", nEs = "Definir link do Ping", oEs = "Limite excedido", rEs = "Quando algo acontece", iEs = "Uma ação é realizada", aEs = "Ação de teste", sEs = "Notificação enviada", cEs = "Sem dados", lEs = "Testar ação do fluxo de trabalho", uEs = "Enviar SMS", dEs = "Tem certeza de que deseja enviar um SMS para {{number}}?", _Es = "Nenhum calendário padrão conectado", pEs = "Você pode conectar seu calendário por <1>aqui</1>.", mEs = "Calendário padrão", fEs = "Ocultar do perfil", gEs = "Configuração de eventos", hEs = "Nenhuma disponibilidade encontrada na programação", vEs = "Limites", bEs = "Com que frequência você pode receber reserva", yEs = "Configurações de calendário e muito mais...", $Es = "Avançado", wEs = "Configurar pagamentos para o evento", kEs = "Configuração do evento: múltiplas durações requerem pelo menos uma opção.", SEs = "Configuração de evento: selecione uma duração padrão válida.", EEs = "Limites de reserva devem estar em ordem crescente. [dia, semana, mês, ano,]", xEs = "Limites de duração devem estar em ordem crescente. [dia, semana, mês, ano,]", CEs = "Selecione para qual calendário adicionar reservas", TEs = "Nome de evento personalizado", AEs = "Criar nomes de eventos personalizados para exibir no evento do calendário", IEs = "Código de autenticação de dois fatores incorreto", OEs = "A que tipo de evento isto se aplica?", NEs = "Aplicar a todos, incluindo futuros tipos de eventos", zEs = "Aplicar a todos os tipos de eventos de equipe e usuário", REs = "A qual equipe isso se aplicará?", PEs = "Fluxo de trabalho permitem uma simples automação para enviar notificações e lembretes que permitem que você crie processos em torno de seus eventos.", DEs = "Esta é uma configuração interna e não afetará a quantidade de exibições em páginas públicas de reservas para você ou outra pessoa que estiver fazendo reserva.", LEs = "Criar fluxo de trabalho", MEs = "Faça isso", FEs = "Desligar", qEs = "Ligar", jEs = "Reservas canceladas não podem ser remarcadas", VEs = "Configurações atualizadas com sucesso", BEs = "Erro ao atualizar configurações", UEs = "Meu URL pessoal da {{appName}}", GEs = "Escreva algumas frases sobre você. Isso aparecerá no URL da sua página pessoal.", WEs = "Finalizar configuração e começar", HEs = "Este usuário ainda não adicionou uma biografia.", YEs = "Biografia", KEs = "Excluir conta", ZEs = "Tem certeza de que deseja excluir sua conta {{appName}}?", XEs = "Excluir minha conta", JEs = "Início da semana", QEs = "Gravações", exs = "Gravação", txs = "Bom agendamento", nxs = "Selecionar em quais calendários você deseja verificar se há conflitos para evitar dupla reserva.", oxs = "Verificar se há conflitos", rxs = "Ver gravações", ixs = "Verificar gravações", axs = "Adicionando eventos a", sxs = "Seguir preferências do sistema", cxs = "Cores personalizadas da marca", lxs = "Personalizar a cor da sua marca na página de reservas.", uxs = "Pro", dxs = 'Remover qualquer marca relacionada a {{appName}}, ex.: "Desenvolvido pela {{appName}}".', _xs = "Reunião instantânea com {{name}}", pxs = "Imagem do perfil", mxs = "Enviar", fxs = "Adicionar foto do perfil", gxs = "Endereço do Token", hxs = "Blockchain", vxs = "Senha antiga", bxs = "Sua nova senha supersegura", yxs = "Erro ao atualizar senha", $xs = "Autenticação de dois fatores", wxs = "Configurar um cronograma repetido", kxs = "hoje", Sxs = "Aparência", Exs = "Minha conta", xxs = "Geral", Cxs = "Calendários", Txs = "Faturas", Axs = "Incorporados", Ixs = "Representação", Oxs = "Configurações para gerenciar representação de usuário", Nxs = "Personificações recentes", zxs = "Personificação rápida", Rxs = "Sem personificações recentes", Pxs = "Usuários", Dxs = "Usuário", Lxs = "Gerencie as configurações para o seu perfil {{appName}}", Mxs = "Aqui você poderá encontrar uma lista de todos os usuários", Fxs = "Listagem de usuários", qxs = "Gerencie as configurações para seu idioma e fuso horário", jxs = "Configure como seus tipos de evento interagem com seus calendários", Vxs = "Gerencie as configurações da aparência da sua reserva", Bxs = "Gerencie seus aplicativos de videoconferência para suas reuniões", Uxs = "Adicionar aplicativo de conferência", Gxs = "Gerencie as configurações para as senhas da sua conta", Wxs = "Definir autenticação de dois fatores", Hxs = "Precisamos apenas de algumas informações básicas para configurar seu perfil.", Yxs = "Pular", Kxs = "Mais tarde", Zxs = "Definir intervalos de tempo quando você estiver disponível", Xxs = "Você pode personalizar tudo isso mais tarde na página de disponibilidade.", Jxs = "Conecte um calendário primeiro", Qxs = "Complete seu perfil", eCs = "Você pode adicionar mais calendários da loja de aplicativos", tCs = "Conectar aplicativos de conferência", nCs = "Conectar aplicativos de calendário", oCs = "Conectar aplicativos de pagamento", rCs = "Conecte aplicativos de automação", iCs = "Conecte aplicativos de análise", aCs = "Conectar outros aplicativos", sCs = "Conectar com aplicativos de mensagem", cCs = "Conecte aplicativos CRM", lCs = "Passo {{currentStep}} de {{maxSteps}}", uCs = "Adicionar variável", dCs = "Número de telefone personalizado", _Cs = "Modelo de mensagem", pCs = "Assunto do e-mail", mCs = "Adicionar variáveis de texto dinâmicas", fCs = "O nome do tipo de evento", gCs = "A data do evento", hCs = "A duração do evento", vCs = "O horário inicial do evento", bCs = "Tipo de evento não encontrado", yCs = "Número para ligar", $Cs = "O número de telefone do usuário que você está chamando", wCs = "Local", kCs = "O local do evento", SCs = "Observações adicionais", ECs = "Notas adicionais da reserva", xCs = "O nome da pessoa que fez a reserva", CCs = "Nome do organizador", TCs = "Para", ACs = "Fluxo de trabalho {{workflowName}} atualizado para {{offOn}} com sucesso", ICs = "Baixar respostas", OCs = "Baixe todas as respostas para seu formulário em formato CSV.", NCs = "Ver respostas", zCs = "Baixar", RCs = "Baixando", PCs = "Baixar gravação", DCs = "As transcrições foram habilitadas", LCs = "As transcrições foram desabilitadas", MCs = "Baixar Transcrição", FCs = "Transcrição", qCs = "Uma gravação da sua chamada recente no {{appName}} está pronta para ser baixada", jCs = "As transcrições da sua ligação recente no {{appName}} já estão prontas para serem baixadas. Os links são válidos por apenas 1 hora", VCs = "Você também pode baixar a transcrição dos anexos", BCs = "Nota: O link para baixar só é válido por 12 horas. Você pode gerar um novo link para baixar seguindo as seguintes instruções <1>aqui</1>.", UCs = "Nota: O link de download é válido apenas por 12 horas. Você pode gerar um novo link de download seguindo as instruções.", GCs = "Criar seu primeiro formulário", WCs = "Com os Formulários de roteamento, você pode fazer perguntas e encaminhar para a pessoa correta ou o tipo de evento.", HCs = "Criar seu primeiro Webhook", YCs = "Com Webhooks, você pode receber dados de reuniões em tempo real quando algo acontece na {{appName}}.", KCs = "Por um máximo de", ZCs = "evento", XCs = "eventos", JCs = "Gerenciar as configurações para o perfil da sua equipe", QCs = "Gerencie as configurações para o perfil da sua organização", eTs = "Usuários que estão no grupo", tTs = "Gerencie os administradores e membros da sua organização", nTs = "URL da equipe", oTs = "Membros da equipe", rTs = "Mais", iTs = "Fluxos de trabalho Cal.ai", aTs = "e mais {{count}}", sTs = "Nós vemos o aplicativo móvel como uma extensão do aplicativo da web. Se você estiver realizando alguma ação complicada, consulte o aplicativo da web.", cTs = "Enviar lembrete por SMS 24 horas antes do evento começar para o participante", lTs = "Enviar SMS personalizado quando o evento for reagendado para o participante", uTs = "Enviar e-mail personalizado quando o novo evento for agendado para a(o) anfitriã(o)", dTs = "Enviar um lembrete por e-mail 1 hora antes dos eventos começarem para o participante", _Ts = "Enviar e-mail personalizado quando o evento for reagendado para a(o) anfitriã(o)", pTs = "Enviar SMS personalizado quando o novo evento for agendado para a(o) anfitriã(o)", mTs = "Enviar lembrete por SMS", fTs = "24 horas antes do início do evento", gTs = "Acompanhamento de ausentes", hTs = "30 minutos após o término do evento", vTs = "Lembrar participantes de trazer identificação", bTs = "1 dia antes do início do evento", yTs = "Lembrete por email", $Ts = "1 hora antes do início do evento", wTs = "Lembrete SMS personalizado", kTs = "Quando o evento é agendado", STs = "Lembrete de email personalizado", ETs = "Evento é reagendado para o anfitrião", xTs = "Incluir contagens de reservas de tipos de eventos gerenciados", CTs = "Bem-vindo(a) à {{appName}}!", TTs = "Você poderá editar isso mais tarde.", ATs = "Vou conectar a meu calendário mais tarde", ITs = "Houve um problema ao salvar seus dados. Tente novamente ou entre em contato com o suporte ao cliente.", OTs = "Compre assentos faltantes", NTs = "Extensão do espaço", zTs = "Aparência da reserva", RTs = "Gerenciar as configurações de aparência da reserva da sua equipe", PTs = "Gerencie as configurações da aparência da sua organização", DTs = "Apenas o proprietário desta equipe pode fazer alterações na reserva da equipe ", LTs = 'Remover qualquer marca relacionada a {{appName}}, ex.: "Desenvolvido pela {{appName}}"', MTs = "{{teamName}} enviou um convite para juntar-se à equipe como {{role}}", FTs = "O token é inválido ou expirou.", qTs = "Ver Reserva", jTs = "Conectar-se ao Microsoft Exchange", VTs = "Método de autenticação", BTs = "Autenticação básica", UTs = "Autenticação NTLM", GTs = "Compressão GZip", WTs = "Versão do Exchange", HTs = "2007 SP1", YTs = "2010", KTs = "2010 SP1", ZTs = "2010 SP2", XTs = "2013", JTs = "2013 SP1", QTs = "2015", eAs = "2016", tAs = "Roteamento", nAs = "Criar formulários para direcionar os participantes para os destinos corretos", oAs = "Enviar e-mail ao proprietário", rAs = "Envia um e-mail ao proprietário após o envio do formulário", iAs = "Enviar E-mail para", aAs = "Adicionar novo formulário", sAs = "Adicionar novo formulário à sua equipe", cAs = "Crie sua primeira rota", lAs = "Roteie para a pessoa certa com base nas respostas do seu formulário", uAs = "Formulário", dAs = "Crie o seu formulário para encaminhar um reservante", _As = "Copiar link para formulário", pAs = "Tema da página de agendamento", mAs = "Isto só se aplica às suas páginas de reservas públicas", fAs = "Tema do painel", gAs = "Isso se aplica apenas ao seu painel conectado", hAs = "Padrão do sistema", vAs = "Adicionar uma equipe", bAs = "Receber dados de reunião em tempo real quando algo acontecer na {{appName}}", yAs = "Executar quando", $As = "Faça o teste de ping antes de criar.", wAs = "Habilitar webhook", kAs = "Adicionar Webhook", SAs = "Webhook salvo", EAs = "Gerar chaves de API para acessar sua própria conta", xAs = "Nova chave de API", CAs = "ativo", TAs = "Nome da chave API atualizada", AAs = "Erro ao atualizar nome da chave API", IAs = "Iframe HTML incorporado", OAs = "Incorpore todos os tipos de evento no seu site", NAs = "Crie a sua primeira chave de API", zAs = "As chaves API permitem que outros aplicativos se comuniquem com a {{appName}}", RAs = "Voltar para o registro", PAs = "Link de redefinição enviado", DAs = "Um e-mail está a caminho para {{email}} com instruções para redefinir sua senha.", LAs = "Se não receber um e-mail em breve, verifique se o endereço de e-mail digitado está correto, verifique sua pasta de spam ou entre em contato com o suporte se o problema persistir.", MAs = "Senha atualizada!", FAs = "Pagamento pendente", qAs = "Convites pendentes", jAs = "Convites pendentes da organização", VAs = "Não está na {{appName}}", BAs = "Nenhum calendário instalado", UAs = "Você ainda não conectou nenhum de seus calendários", GAs = "Adicionar um calendário", WAs = "Pode ser necessário sair e entrar novamente para ver as alterações aplicadas.", HAs = "Confirme sua senha antes de alterar o endereço de e-mail", YAs = "assentos", KAs = "Todos os aplicativos publicados na App Store da {{appName}} são de código aberto e testados minuciosamente por meio de avaliações por pares. No entanto, a {{companyName}} não endossa ou certifica esses aplicativos a não ser que sejam publicados pela {{appName}}. Se você encontrar conteúdo ou comportamento inadequado, denuncie.", ZAs = "Denunciar aplicativo", XAs = "Limite frequência de reserva", JAs = "Limite quantas vezes este evento pode ser reservado", QAs = "Mostrar apenas o primeiro horário disponível de cada dia", e2s = "Isso limitará sua disponibilidade para este tipo de evento a um horário por dia, agendado no primeiro horário disponível.", t2s = "Limitar duração total de reserva", n2s = "Limite de quanto tempo este evento pode ser reservado", o2s = "Limite de reservas ativas do agendador", r2s = "Limite o número de reservas ativas que um agendador pode fazer para este tipo de evento", i2s = "Eventos recorrentes não suportam limite de reservas do agendador", a2s = "Adicione limite", s2s = "Nome da equipe obrigatório", c2s = "Compartilhe informações do participante entre convidados", l2s = "Mostrar a quantidade de assentos disponíveis", u2s = "Como usar perguntas de reserva como variáveis?", d2s = "Formato", _2s = "Perguntas", p2s = "Todas as informações que seu agendador deve fornecer antes de fazer uma reserva com você.", m2s = "Use letras maiúsculas para todas as letras", f2s = "Substituir espaços em branco com sublinhados", g2s = "Membros da plataforma", h2s = "Gerencie os administradores e membros da sua equipe da plataforma", v2s = "Faturamento da plataforma", b2s = "Gerencie o faturamento", y2s = "Gerencie tudo do faturamento", $2s = "No momento, você está no plano GRÁTIS", w2s = "Trabalhamos melhor em equipe. Amplie seus fluxos de trabalho com eventos circulares e coletivos e faça formulários avançados de roteamento", k2s = "Tentar agora", S2s = "Portal de Cobrança", E2s = "Falar com o suporte", x2s = "Ignore caracteres especiais no seu identificador de pergunta de reserva. Use apenas letras e números", C2s = "Repetir", T2s = "Houve um problema ao buscar suas agendas. <1>Tente novamente</1> ou entre em contato com o suporte ao cliente.", A2s = "Falha na conexão com a agenda", I2s = "Reserva confirmada com sucesso", O2s = "Recusa de reserva realizada", N2s = "Esta reserva é provisória", z2s = "Ops, quero aceitar", R2s = "Não exibiremos isso novamente", P2s = "Não foi possível atualizar o fuso horário", D2s = "Fuso horário atualizado para {{formattedCurrentTz}}", L2s = "Atualize o fuso horário", M2s = "Atualizar fuso horário?", F2s = "Parece que seu fuso horário local mudou para {{formattedCurrentTz}}. É muito importante ter o fuso horário correto para evitar reservas em horários indesejados. Você deseja atualizá-lo?", q2s = "Não atualizar", j2s = "Solicitar notas adicionais", V2s = "Solicitar que as notas adicionais sejam preenchidas no momento da reserva", B2s = "enviar e-mail para um endereço de e-mail específico", U2s = "após o término do evento", G2s = "quando a reserva é recusada", W2s = "quando a reserva é solicitada", H2s = "quando o pagamento da reserva é iniciado", Y2s = "quando o pagamento da reserva é bem-sucedido", K2s = "quando o não comparecimento da reserva é atualizado", Z2s = "Quanto tempo após o término do evento?", X2s = "Quanto tempo após os anfitriões não aparecerem na reunião de vídeo do Cal?", J2s = "Quanto tempo após os convidados não aparecerem na reunião de vídeo do Cal?", Q2s = "Quanto tempo após os usuários não aparecerem na reunião de vídeo do Cal?", eIs = "Não há espaços disponíveis", tIs = "Tempo disponível", nIs = "Não encontra o aplicativo de conferência certo? Visite nossa <0>App Store</0>.", oIs = "Instale novo aplicativo de calendário", rIs = "Torne o número de telefone necessário para o evento de reserva", iIs = "Disponibilidade de {{eventTypeTitle}}", aIs = "Erro ao editar disponibilidade", sIs = "Você não tem permissão para acessar este recurso.", cIs = "Por favor cole o SAML metadata do seu Provedor de Identidade aqui", lIs = "Por favor insira um endereço de e-mail para que possamos encontrar o seu Provedor de Identidade", uIs = "Detalhes do Provedor de Serviços", dIs = "Seu Provedor de Identidade (IdP) solicitará os seguintes detalhes para concluir a configuração da aplicação SAML.", _Is = "URL do ACS", pIs = "ID da Entidade SP", mIs = "URL do ACS copiada!", fIs = "ID da Entidade SP copiada!", gIs = "Adicionar calendário", hIs = "Limitar reservas futuras", vIs = "Limita o tempo de antecedência com que este evento pode ser reservado", bIs = "Nenhuma configuração de tipo de evento", yIs = "{{name}} não configurou nenhum tipo de evento para você reservar.", $Is = "Frequência de cobrança", wIs = "Mensal", kIs = "Anual", SIs = "Finalizar compra", EIs = "Sua equipe foi desfeita com êxito", xIs = "Sua organização foi desfeita com êxito", CIs = "Erro ao criar equipe", TIs = "Você", AIs = "Ou continue com", IIs = "Reenviar e-mail", OIs = "O membro já foi convidado", NIs = "Este nome de usuário já está em uso", zIs = "Insira um e-mail ou nome de usuário", RIs = "Insira um e-mail", PIs = "Insira e-mails", DIs = "Você está limitado a convidar no máximo {{nbUsers}} usuários de uma só vez.", LIs = "Este nome já está em uso", MIs = "É preciso inserir um nome de equipe", FIs = "É preciso inserir uma URL de equipe", qIs = "Este URL já está em uso", jIs = "Houve um problema ao registrar o subdomínio, tente novamente ou fale com o administrador", VIs = "Publicar equipe", BIs = "Número de telefone (notificações via texto)", UIs = "Número de telefone (notificações SMS)", GIs = "E-mail do participante", WIs = "O e-mail da pessoa que fez a reserva", HIs = "UID da reserva", YIs = "Digite um comando ou procure...", KIs = "Ah, não! Parece que a permissão expirou ou foi revogada. Reinstale novamente.", ZIs = "Reinstale o aplicativo", XIs = "Motivo de reagendamento", JIs = "Escolha uma agenda compartilhada", QIs = "Ative isso se quiser usar uma agenda comum entre os anfitriões. Quando desativado, cada anfitrião será agendado com base em sua agenda padrão ou na agenda escolhida.", eOs = "Motivo", tOs = "ID do remetente", nOs = "Apenas letras, números e espaços permitidos (no máx. 11 caracteres)", oOs = "Testar formulário de roteamento", rOs = "Visualizar teste", iOs = "Direcionar para", aOs = "Teste seu formulário de roteamento sem enviar dados", sOs = "Testar roteamento", cOs = "Um administrador desativou um aplicativo de pagamento", lOs = "Editar tipo de evento", uOs = "Esta Organização é privada, e apenas o administrador ou dono da organização podem ver seus membros.", dOs = "Apenas o administrador ou dono da organização podem gerenciar configurações de SSO", _Os = "Apenas o administrador ou proprietário da organização pode gerenciar as configurações de sincronização de diretório", pOs = "Apenas o administrador ou proprietário da organização pode gerenciar clientes OAuth", mOs = "Programação coletiva", fOs = "Facilite a reserva da sua equipe quando todos estiverem disponíveis.", gOs = "Encontre a pessoa mais indicada disponível e percorra sua equipe.", hOs = "Round-robin fixo", vOs = "Adicione um participante fixo e utilize o round-robin em uma determinada quantidade de participantes.", bOs = "{{appName}} é melhor com equipes", yOs = "A equipe de {{companyName}}", $Os = "Adicione membros da sua equipe aos seus tipos de evento. Use programação coletiva para incluir todos ou encontre a pessoa mais apropriada pela programação com round-robin.", wOs = "O limite de reseva para este tipo de evento foi atingido", kOs = "O limite de duração para este tipo de evento foi atingido", SOs = "Um administrador desativou {{appName}}", EOs = "Isso desativará todos os e-mails para {{recipient}}. Isso inclui confirmações de agendamento, solicitações, reagendamentos e pedidos de reagendamento, e-mails de cancelamento e quaisquer outros e-mails relacionados a atualizações de agendamento.<br /><br />É sua responsabilidade garantir que seus {{recipient}} estejam cientes de quaisquer agendamentos e alterações em seus agendamentos.", xOs = "Um administrador desativou {{appName}}, afetando seu tipo de evento {{eventType}}", COs = "Um administrador substituiu um dos seus tipos de evento", TOs = "Um administrador de equipe substituiu seu evento /{{slug}}", AOs = "Um administrador na equipe <strong>{{teamName}}</strong> substituiu seu tipo de evento <strong>/{{slug}}</strong> por um tipo de evento controlado por ele.", IOs = "Seu link continuará a funcionar, mas algumas configurações podem ter sido alteradas. Você pode revisar nos tipos de evento.", OOs = "Se tiver alguma pergunta sobre o tipo de evento, fale com o seu administrador.<br /><br />Bom agendamento, <br/>Equipe do Cal.com", NOs = "O administrador desativou o {{appName}}, o que afeta seu tipo de evento {{title}}. Os participantes ainda podem agendar este tipo de evento, mas não serão solicitados a pagar. Você pode ocultar o tipo de evento para evitar isso até que seu administrador reative seu método de pagamento.", zOs = "Os participantes ainda podem agendar este tipo de evento, mas não serão solicitados a pagar. Você pode ocultar o tipo de evento para evitar isso até que seu administrador reative seu método de pagamento.", ROs = "O administrador desativou {{appName}}, afetando seu tipo de evento {{title}}.", POs = "O administrador desativou {{appName}}, afetando seus tipos de evento. Se você tiver tipos de evento com {{appName}} como localização, Vídeo do Cal será definido como padrão.", DOs = "{{appName}} foi desativado", LOs = "Ir para aplicativos instalados", MOs = "Se você tiver outro calendário instalado, novas reservas serão adicionadas a ele. Caso contrário, conecte um novo calendário para não perder novas reservas.", FOs = "Ativar aplicativos", qOs = "Ative aplicativos que os usuários podem integrar com o {{appName}}", jOs = "Comprar uma licença", VOs = "Já tem uma conta?", BOs = "Já tenho uma chave:", UOs = "Copie a variável de ambiente CALCOM_LICENSE_KEY existente aqui.", GOs = "Criar Chave de Licença", WOs = "{{appName}} foi ativado", HOs = "{{appName}} foi desativado", YOs = "As chaves foram salvas", KOs = "Desativar aplicativo", ZOs = "Desativar este aplicativo pode causar problemas para a interação dos usuários com o Cal", XOs = "Editar chaves", JOs = "Ativar apps para sua instância do Cal", QOs = "Uma lista de todos os usuários em sua conta, incluindo nome, cargo, e-mail e função.", eNs = "Aqui você pode adicionar um novo usuário.", tNs = "Aqui você pode editar um usuário atual.", nNs = "Aqui você pode editar uma organização.", oNs = "Adicionar novos clientes OAuth", rNs = "Bloquear ou desbloquear o envio de SMS para usuários", iNs = "Não há aplicativos disponíveis", aNs = 'Verifique se há aplicativos na sua implantação, em "packages/app-store"', sNs = "Não há aplicativos ativados nesta instância do Cal", cNs = "Nenhum aplicativo foi configurado ainda", lNs = "Você pode habilitar aplicativos nas configurações", uNs = "Entre em contato com o administrador", dNs = "Configurações do app", _Ns = "Preencha este campo", pNs = "Opções", mNs = "insira a opção {{index}}", fNs = "Adicionar uma opção", gNs = "Esta localização já existe. Por favor, selecione uma nova localização", hNs = "Rádio", vNs = "Para usar o Google Meet, você deve definir seu calendário de destino como um Google Calendar", bNs = "Individual", yNs = "Todas as reservas", $Ns = "Todos os usuários", wNs = "Todos os tipos de eventos", kNs = "Suas reservas", SNs = "URL da reunião", ENs = "O URL da conferência de reunião do evento", xNs = "Substituições de data", CNs = "Apagar a data sobrescreve em {{date}}", TNs = "Adicione datas quando sua disponibilidade mudar em relação às suas horas diárias.", ANs = "Substituições de data são realizadas automaticamente quando uma data tiver passado", INs = "Que horas você está livre?", ONs = "Que horas você está ocupado(a)?", NNs = "Selecione as datas para substituir", zNs = "Indisponível o dia todo", RNs = "Marcar indisponível (o dia todo)", PNs = "Marcar indisponível nas datas selecionadas", DNs = "Atualizar substituição", LNs = "Substituição de data adicionada com sucesso", MNs = "Salvar Substituição", FNs = "Cópia de {{slug}}", qNs = "Definir como padrão", jNs = "Ocultar detalhes do tipo de evento", VNs = "Mostrar navegação", BNs = "Ocultar navegação", UNs = "Código de verificação enviado", GNs = "Verificação bem-sucedida", WNs = "Código de verificação incorreto", HNs = "Verificação ainda não realizada", YNs = "Sem disponibilidade em {{month}}", KNs = "O agendamento só está disponível até {{days}} dias à frente. Por favor, verifique novamente em breve.", ZNs = "O agendamento terminou em {{date}}. Por favor, verifique novamente em breve.", XNs = "Ver mês anterior", JNs = "Ver próximo mês", QNs = "Enviar código", ezs = "Número verificado", tzs = "Crie seu primeiro webhook para este tipo de evento em equipe", nzs = "Crie um webhook para este tipo de evento em equipe", ozs = "Desativar página de reserva bem-sucedida (funciona apenas se você tiver uma URL de redirecionamento)", rzs = "Você é administrador, mas ainda não tem uma senha de pelo menos 15 caracteres ou 2FA", izs = "Altere sua senha para obter acesso de administrador", azs = "O nome do usuário já está em uso", szs = "Atribuição", czs = "Anfitriões fixos", lzs = "Adicionar anfitriões fixos", uzs = "Anfitriões em Round-Robin", dzs = "Número de anfitriões necessários para participar", _zs = "Anfitriões", pzs = "Você precisa criar uma equipe para ativar este recurso. Clique aqui para criar uma equipe.", mzs = "Você precisa atualizar para nosso plano empresarial para ativar esse recurso.", fzs = "Novo participante", gzs = "Aguardando aprovação", hzs = "Este aplicativo requer uma conexão com o Google Calendar", vzs = 'O "Adicionar ao calendário" para este tipo de evento precisa ser um Google Calendar para que o Meet funcione. Conecte-o <0>aqui</0>.', bzs = "Você se conectou com uma conta do Google Calendar.", yzs = "É preciso ter um Google Calendar conectado para usar o Google Meet", $zs = "Continuar para instalar o Google Calendar", wzs = "Instalar o Google Meet", kzs = "Instalar o Google Calendar", Szs = "Nome do remetente", Ezs = "Participante já convidado", xzs = "Nenhum registro encontrado", Czs = "Novo fluxo de trabalho para...", Tzs = "Relatando", Azs = "Veja todos os dados recebidos e baixe como CSV", Izs = "Plano da equipe obrigatório", Ozs = "Formulários de roteamento são uma ótima maneira de direcionar os clientes potenciais recebidos para a pessoa certa. Atualize para o plano Teams e acesse esse recurso.", Nzs = "Escolha uma licença", zzs = "O Cal.com vem com uma licença AGPLv3 acessível e gratuita, mas tem algumas limitações, que podem ser resolvidas atualizando para a licença Enterprise a qualquer momento. Você poderá fazer isso mais tarde, quando quiser.", Rzs = "Licença", Pzs = "Licença AGPLv3", Dzs = "Não precisa manter seu código em código aberto", Lzs = "Reempacote, troque de marca e revenda com facilidade", Mzs = "Uma ampla variedade de recursos empresariais", Fzs = "$0,00/mês", qzs = "Aberto e gratuito permanentemente", jzs = "Obrigatório para manter seu código em código aberto", Vzs = "Não é possível reempacotar, trocar de marca e revender facilmente", Bzs = "Sem recursos corporativos", Uzs = "Licença Enterprise", Gzs = "Tudo para um caso de uso comercial com hospedagem privada, reempacotamento, troca de marca e revenda, além de acesso a componentes corporativos exclusivos.", Wzs = "Configuração", Hzs = "Instância de configuração do Cal.com", Yzs = "Configurar", Kzs = "Configuração de login único", Zzs = "Configure o SAML/OIDC SSO e permita que membros da equipe façam login com um provedor de identidade", Xzs = "Configure o SAML/OIDC SSO e permita que membros da organização façam login usando um provedor de identidade", Jzs = "SSO com OIDC", Qzs = "Configure o OIDC SSO com o provedor de identidade de sua escolha.", eRs = "Configuração do OIDC", tRs = "Configure a conexão do OIDC com seu provedor de identidade. Confira as informações necessárias nele.", nRs = "URL de chamada de retorno copiada", oRs = "SSO com SAML", rRs = "Configure o SAML SSO com o provedor de identidade de sua escolha.", iRs = "Configuração do SAML", aRs = "Configure a conexão do SAML com seu provedor de identidade. Confira as informações necessárias nele.", sRs = "URL do ACS copiada", cRs = "ID da entidade copiada", lRs = "Configuração de {{connectionType}} criada com sucesso", uRs = "Configuração de {{connectionType}} excluída com sucesso", dRs = "Excluir a configuração de {{connectionType}}", _Rs = "Sim, excluir a configuração de {{connectionType}}", pRs = "Você tem certeza que deseja remover a configuração de {{connectionType}}? Os membros do seu time que utilizam {{connectionType}} para fazer login não conseguirão acessar o Cal.com.", mRs = "Fuso horário do organizador", fRs = "Ver convite", gRs = "Aceitar convite", hRs = "Participar agora", vRs = "Participação bem-sucedida", bRs = "Você foi convidado para participar de uma equipe da organização {{parentTeamName}}", yRs = "Você foi convidado para participar de uma organização {{appName}}", $Rs = "Você recebeu um convite de {{invitedBy}} para ingressar em sua equipe em {{appName}}. {{appName}} é um agendador que concilia eventos e permite que sua equipe agende reuniões sem precisar trocar e-mails.", wRs = "{{invitedBy}} convidou você para se juntar à equipe {{teamName}} na organização {{parentTeamName}} em {{appName}} . {{appName}} é o agendador de eventos que permite que você e sua equipe agendem reuniões sem o envio de e-mail.", kRs = 'Você recebeu um convite de {{invitedBy}} para ingressar na organização "{{teamName}}" em {{appName}}. {{appName}} é um agendador que concilia eventos e permite que sua organização agende reuniões sem precisar trocar e-mails.', SRs = "Vamos guiá-lo por algumas etapas rápidas e você estará aproveitando agendamentos sem estresse com seu {{entity}} em pouco tempo.", ERs = "Escolha seu nome de usuário", xRs = "Conecte com sua conta de calendário", CRs = "Defina sua disponibilidade", TRs = "Ingresse em {{teamName}}", ARs = "Divirta-se com os agendamentos, equipe do {{appName}}", IRs = "Você está preses a representar um usuário, ou seja, tem possibilidade de realizar mudanças em nome dele. Tenha cuidado.", ORs = "Variáveis disponíveis", NRs = "{Scheduler}", zRs = "Sem fluxos de trabalho", RRs = "Mude o filtro para ver seus fluxos de trabalho pessoais e da equipe.", PRs = "Altere o filtro para ver os resultados.", DRs = "Nenhum resultado para filtrar", LRs = "Próximos passos recomendados", MRs = "Crie um tipo de evento gerenciado", FRs = "Reuniões são melhores com a presença dos membros certos da equipe. Convide-os agora.", qRs = "Crie um modelo um a um para um tipo de evento e distribua para vários membros.", jRs = "Coletivo ou round-robin", VRs = "Reúna os membros da sua equipe com eventos coletivos, ou selecione a pessoa certa com o round-robin.", BRs = "Não está mais participando de {{title}} às {{date}}", URs = "Você não está mais participando deste evento", GRs = "Um participante não está mais participando de {{title}} às {{date}}", WRs = "Um participante não está mais participando do seu evento", HRs = "{{name}} cancelou. Quer dizer que um assento foi liberado para este período de tempo", YRs = "Criar evento em", KRs = "Criar formulário de roteamento em", ZRs = "Defina um link padrão para o app", XRs = "Definir um link padrão para o app permite que todos os tipos de evento recém-criados usem o link definido para o app.", JRs = "Aplicativo padrão do organizador", QRs = "{{organizer}} não possui um aplicativo de conferência padrão", ePs = "Serviço interrompido para manutenção", tPs = "A equipe do {{appName}} está realizando uma manutenção programada. Se tiver alguma dúvida, fale com o suporte.", nPs = "{{numberOfSeats}} assentos", oPs = "Perguntas sobre reserva", rPs = "Personalize as perguntas feitas na página de reservas", iPs = "Adicione uma pergunta", aPs = "Identificador", sPs = "Este e-mail já existe", cPs = "Insira uma URL de redirecionamento para a qual o participante será enviado ao sair da reunião.", lPs = "Não é mais possível pagar por este evento", uPs = "Um reembolso pelo pagamento desta reserva está a caminho.", dPs = "O pagamento desta reserva foi reembolsado.", _Ps = "De acordo com a política de reembolso do evento, o pagamento da reserva não é reembolsável.", pPs = "O prazo para reembolso do evento expirou. Portanto, o pagamento da reserva não é reembolsável.", mPs = "Falhar ao confirmar reserva", fPs = "Sem assentos suficientes", gPs = "Já existe um campo com este nome", hPs = "O campo de convidados deve ser do tipo 'Múltiplos e-mails'", vPs = "Mostrar na página de reservas", bPs = "Você pode visitar a página de reserva cancelada", yPs = "Comece agora com modelos do Zapier", $Ps = "Modelos Padrão", wPs = "Modelos Cal.ai", kPs = "Publicação de {{team}} cancelada", SPs = "Este link da organização não está disponível no momento. Entre em contato com o proprietário da organização ou peça que seja publicado.", EPs = "O link de {{entity}} não está disponível por enquanto. Fale com o proprietário de {{entity}} ou peça que seja publicado.", xPs = "Membro da equipe", CPs = "Formulário de roteamento", TPs = "Descrição do formulário", APs = "Mantenha minha conexão com o formulário", IPs = "Quaisquer alterações feitas no roteador ou nos campos do formulário que está sendo duplicado serão refletidas na cópia. No entanto, excluir um campo não o removerá da cópia.", OPs = "Formulário excluído", NPs = "Tem certeza de que deseja excluir este formulário?", zPs = "Sim, excluir formulário", RPs = "Este link não será mais acessível para qualquer pessoa com quem tenha sido compartilhado.", PPs = "Todas as respostas associadas serão excluídas.", DPs = "URL de redirecionamento copiada! Você pode ir e definir a URL no seu próprio formulário.", LPs = "Modificações nos campos e rotas dos formulários a seguir afetarão este formulário.", MPs = "Formulários conectados", FPs = "Os formulários a seguir serão afetados ao modificar os campos e rotas aqui.", qPs = "Aguarde um pouco até as respostas serem coletadas. Você também pode acessar e enviar o formulário por conta própria.", jPs = "Isto é o que seus usuários verão", VPs = "Identifica campo por este nome.", BPs = "Adiciona uma opção por linha", UPs = "Selecione um formulário de roteamento", GPs = "Adicione uma nova Rota", WPs = "Tome decisões conscientes com o Insights", HPs = "Nosso painel de informações do Insights apresenta todas as atividades da sua equipe e mostra as tendências que permitem melhor tomada de decisão e agendamento da equipe.", YPs = "Ver reservas em todos os membros", KPs = "Veja quem está recebendo mais reservas e garanta a melhor distribuição em sua equipe", ZPs = "Identificar tendências de reserva", XPs = "Veja quais são os horários da semana e do dia mais procurados pelos reservantes", JPs = "Localizar tipos de evento populares", QPs = "Veja quais tipos de eventos estão recebendo a maioria dos cliques e reservas", eDs = "Sem respostas por enquanto", tDs = "Nenhuma rota definida", nDs = "Este será o espaço reservado", oDs = "Ocorreu um erro ao reservar o evento, atualize a página e tente novamente", rDs = "Nenhuma alocação de tempo selecionada", iDs = "Selecione uma alocação de tempo para reservar o evento.", aDs = "Selecione a alocação de tempo", sDs = "Trocar para visualização mensal", cDs = "Trocar para visualização semanal", lDs = "Trocar para visualização diária", uDs = "Trocar para visualização de coluna", dDs = "{{num}} opções de local", _Ds = "Selecione na próxima etapa", pDs = "Esta reunião ainda não começou", mDs = "{{appName}} requer uma conta de {{dependencyName}} conectada", fDs = "Conectar {{dependencyName}}", gDs = "{{dependencyName}} se conectou", hDs = "Requer {{dependencyName}}", vDs = "Código de verificação", bDs = "Poderia tentar novamente em um horário diferente?", yDs = "Verificar", $Ds = "O fuso horário do destinatário", wDs = "Fuso horário", kDs = "Horário de término do evento", SDs = "O horário de término do evento", EDs = "Cancelar URL", xDs = "O URL para cancelar a reserva", CDs = "Motivo do cancelamento", TDs = "O motivo para cancelar o agendamento", ADs = "URL de reagendamento", IDs = "O URL para reagendar a reserva", ODs = "Motivo do reagendamento", NDs = "O motivo para reagendar o agendamento", zDs = "Há uma variável inválida no seu nome do evento", RDs = "Selecionar tudo", PDs = "Atualize em massa os tipos de evento existentes", DDs = "Agenda padrão do membro", LDs = "Definido pelo administrador da equipe", MDs = "Local padrão do membro", FDs = "Usaremos a agenda de disponibilidade padrão de cada membro. Não será possível editar ou alterar.", qDs = "Você precisa ter pelo menos uma agenda", jDs = "Atualize as localizações para os tipos de evento selecionados", VDs = "Atualize os horários para os tipos de eventos selecionados", BDs = "Bloqueado para membros", UDs = "Desbloqueado para membros", GDs = "Os membros poderão ver os aplicativos ativos, mas não poderão editar as configurações", WDs = "Os membros poderão ver os aplicativos ativos e poderão editar as configurações", HDs = "Você poderá ver os aplicativos ativos mas não poderá editar as configurações", YDs = "Você poderá ver os aplicativos ativos e poderá editar as configurações", KDs = "Membros não podem adicionar seus fluxos de trabalho pessoais a este tipo de evento. Membros poderão ver os fluxos de trabalho ativos da equipe mas não poderão editar configurações de fluxo de trabalho.", ZDs = "Membros poderão adicionar seus fluxos de trabalho pessoais a este tipo de evento. Membros poderão ver os fluxos de trabalho ativos da equipe mas não poderão editar configurações de fluxo de trabalho.", XDs = "Você pode ver os fluxos de trabalho ativos da equipe mas não poderá editar as configurações ou adicionar seus fluxos de trabalho pessoais a este tipo de evento.", JDs = "Você poderá habilitar/desabilitar fluxos de trabalho pessoais neste tipo de evento. Você poderá ver os fluxos de trabalho ativos da equipe mas não poderá editar configurações de fluxo de trabalho.", QDs = "Os membros não podem adicionar seus webhooks pessoais a este tipo de evento. Os membros poderão ver os webhooks ativos, mas não poderão editar nenhuma configuração de webhook.", e3s = "Os membros poderão adicionar seus webhooks pessoais a este tipo de evento. Os membros poderão ver os webhooks ativos, mas não poderão editar nenhuma configuração de webhook.", t3s = "Você pode ver os webhooks gerenciados ativos, mas não poderá editar nenhuma configuração de webhook ou adicionar seus webhooks pessoais a este tipo de evento.", n3s = "Você pode adicionar webhooks a este tipo de evento. Você pode ver os webhooks gerenciados ativos, mas não poderá editá-los.", o3s = "Bloqueado pelo administrador da equipe", r3s = "Você não conectou uma conta do {{appName}}.", i3s = "Conectar agora", a3s = "Substituir e notificar {{count}} membro", s3s = "Substituir e notificar {{count}} membros", c3s = "O url/{{slug}} já existe para {{count}} membro. Deseja substituir?", l3s = "O url/{{slug}} já existe para {{count}} membros. Deseja substituir?", u3s = "<strong>{{names}}</strong> já está usando o url <strong>/{{slug}}</strong>.", d3s = "<strong>{{names}}</strong> já estão usando o url <strong>/{{slug}}</strong>.", _3s = "Se você escolher substituir, serão enviadas notificações. Volte e remova caso não queira sobrescrever.", p3s = "Revisar tipo de evento", m3s = "Procurando mais análises?", f3s = "Procurando mais Insights?", g3s = "Filtros", h3s = "Filtrar", v3s = "Adicionar um membro", b3s = "Adicionar filtro", y3s = "Adicionar regra", $3s = "Adicionar grupo de regras", w3s = "Limpar todos os filtros", k3s = "E-mail Verificado", S3s = "Selecionar usuário", E3s = "Selecionar tipo de evento", x3s = "Selecionar intervalo de data", C3s = "Eventos populares", T3s = "Nenhum tipo de evento encontrado", A3s = "Duração média de evento", I3s = "Reservas por hora", O3s = "Membros mais reservados", N3s = "Membros menos reservados", z3s = "Mais agendamentos marcados", R3s = "Menos agendamentos marcados", P3s = "Mais agendamentos concluídos", D3s = "Menos agendamentos concluídos", L3s = "Eventos criados", M3s = "Eventos concluídos", F3s = "Eventos cancelados", q3s = "Eventos reagendados", j3s = "Eventos", V3s = "Desempenho", B3s = "do último período", U3s = "De: {{startDate}} Para: {{endDate}}", G3s = 'A página de sucesso será desabilitada ao adicionar um redirecionamento. Não se esqueça de mencionar "Reserva confirmada" na sua página de sucesso personalizada.', W3s = "Tendências de evento", H3s = "Limpar filtros", Y3s = "Limpar", K3s = "Segurar", Z3s = "Coletar pagamento na reserva", X3s = "Carregar taxa de não comparecimento", J3s = "Cartão em posse", Q3s = "Carregar cartão", eLs = "Cartão carregado", tLs = "{{amount, currency}} de taxa de não comparecimento", nLs = "Taxa de não comparecimento", oLs = "Enviar cartão", rLs = "Enviar informações de pagamento", iLs = "Sua reunião está aguardando um método de pagamento", aLs = "Foi cobrada uma taxa de não comparecimento de {{amount, currency}} para {{title}} à(s) {{date}}", sLs = "Taxa de não comparecimento cobrada", cLs = "Foi cobrada uma taxa de não comparecimento de {{amount, currency}} para o evento seguinte", lLs = "Algo deu errado ao cobrar a taxa de não comparecimento. Tente novamente mais tarde.", uLs = "Coletar taxa de não comparecimento", dLs = "Taxa de não comparecimento cobrada", _Ls = "Pagamento recusado. Por favor, tente outro cartão ou entre em contato com seu banco para obter assistência.", pLs = "Este tipo de cartão não é compatível com esta compra. Por favor, use um método de pagamento diferente.", mLs = "O valor mínimo de pagamento é $0,50 USD. Por favor, aumente o valor do seu pagamento.", fLs = "Não foi possível cobrar o cartão para pagamento.", gLs = "Insights", hLs = "Formulários de Roteamento", vLs = "Nenhum dado encontrado para o filtro ou dados selecionados.", bLs = "Estou ciente de que, se eu não comparecer a este evento, será cobrada no meu cartão uma taxa de não comparecimento de {{amount, currency}}.", yLs = "dias", $Ls = "Detalhes do cartão", wLs = "Algo deu errado do nosso lado. Entre em contato com nossa equipe de suporte, e resolveremos isso imediatamente para você.", kLs = "Para obter mais ajuda, insira o texto a seguir ao entrar em contato com o suporte", SLs = "Neste momento, não é possível habilitar assentos e cobrar taxa de não comparecimento", ELs = "Conclua sua reserva", xLs = "Conclua sua reserva: {{title}} à(s) {{date}}", CLs = "Confirme suas informações", TLs = "Copiar link de convite", ALs = "Editar configurações do link", ILs = "Link de convite copiado", OLs = "Link de convite excluído", NLs = "Chave da API excluída", zLs = "Isso excluirá permanentemente a chave de API. Qualquer aplicativo que use esta chave perderá imediatamente o acesso à sua conta. Esta ação não pode ser desfeita.", RLs = "Configurações do link de convite salvas", PLs = "Link configurado para expirar após...", DLs = "1 dia", LLs = "7 dias", MLs = "30 dias", FLs = "3 meses", qLs = "1 ano", jLs = "Você recebeu um convite para ingressar em {{teamName}}", VLs = "{{amount, currency}}", BLs = "Você está prestes a cobrar {{amount, currency}} do participante. Tem certeza de que deseja continuar?", ULs = "Cobrar {{amount, currency}} do participante", GLs = "Solicitar pagamento ({{paymentFeePercentage}}% + {{fee, currency}} de comissão a cada transação)", WLs = "{{email}} recebeu um convite", HLs = "{{userCount}} usuários foram convidados", YLs = "Erro ao coletar cartão", KLs = "A imagem carregada não deve ultrapassar o limite de 5 MB", ZLs = "{{errorCode}}: você não tem autorização para habilidar ou desabilitar este fluxo de trabalho", XLs = "Inserção embutida", JLs = "Carrega seu tipo de evento embutido diretamente no conteúdo restante do site.", QLs = "Botão pop-up flutuante", eMs = "Insere um botão flutuante no seu site para ativar um modal com seu tipo de evento.", tMs = "Pop-up ao clicar em elemento", nMs = "Abra uma caixa de diálogo quando alguém clicar em um elemento.", oMs = "Usar meu próprio formulário", rMs = "Use nossa API de roteamento headless e use seu próprio formulário para envios.", iMs = "Precisa de ajuda? Confira nosso guia para incorporar o Cal no Wix, Squarespace ou WordPress. Consulte as perguntas frequentes ou explore opções de incorporação avançadas.", aMs = "Reservar meu Cal", sMs = "Primeiro nome", cMs = "Sobrenome", lMs = "Primeiro nome, Sobrenome", uMs = "Convidar como", dMs = "Formulário atualizado com êxito.", _Ms = "Desative os e-mails de confirmação padrão para participantes", pMs = "Pelo menos um fluxo de trabalho está ativo neste tipo de evento, que envia um e-mail aos participantes quando o evento for reservado.", mMs = "Desative e-mails de confirmação padrão para anfitriões", fMs = "Pelo menos um fluxo de trabalho está ativo neste tipo de evento, que envia um e-mail aos anfitriões quando o evento for reservado.", gMs = "Adicionar uma substituição", hMs = "Importar usuários do Google Workspace", vMs = "Conectar com o Google Workspace", bMs = "Você deve ser administrador do Google Workspace para usar este recurso", yMs = "Crie seu primeiro webhook para este tipo de evento", $Ms = "Crie seu primeiro webhook com 'Reunião instantânea criada' como gatilho para este tipo de evento", wMs = "Instalar aplicativo em", kMs = "Criar para", SMs = "Moeda", EMs = "Crie um ambiente onde suas equipes possam criar aplicativos compartilhados, fluxos de trabalho e tipos de eventos com agendamento round-robin e coletivo.", xMs = "Gerenciar organizações com múltiplas equipes", CMs = "Configurar sua organização", TMs = "Configurar sua plataforma", AMs = "Organizações são ambientes compartilhados em que as equipes podem criar fluxos de trabalho, aplicativos, tipos de evento compartilhados e muito mais.", IMs = "Planos", OMs = "Plataforma", NMs = "Gerencie tudo relacionado à plataforma.", zMs = "A Plataforma Cal.com permite que você facilmente integre agendadores no seu aplicativo usando APIs e módulos da plataforma.", RMs = "Requer um nome de organização", PMs = "Requer o endereço de e-mail da sua organização", DMs = "Endereço de e-mail da sua organização", LMs = "Seu endereço de e-mail de administrador", MMs = "Nome do usuário do administrador", FMs = "Nome da organização", qMs = "Nome da plataforma", jMs = "URL da organização", VMs = "Verifique o e-mail da sua organização", BMs = "Use o código abaixo para verificar seu endereço de e-mail e continuar a configuração da sua organização.", UMs = "Parâmetros adicionais de URL", GMs = "Sobre a sua organização", WMs = "Organizações são ambientes compartilhados em que você pode criar múltiplas equipes com membros, fluxos de trabalho, aplicativos, tipos de evento compartilhados e muito mais.", HMs = "Criar suas equipes", YMs = "Comece a agendar juntos ao adicionar os membros das suas equipes à sua organização", KMs = "Convidar administradores da sua organização", ZMs = "Estes administradores terão acesso a todas as equipes na sua organização. Você pode adicionar administradores e membros da equipe mais tarde.", XMs = "Definir senha", JMs = "Será criada uma nova conta de usuário com o e-mail da sua organização e esta senha.", QMs = "Logotipo da organização", e4s = "Uma breve descrição sobre sua organização. Isso aparecerá na página do perfil público da sua organização.", t4s = "Farei isso mais tarde", n4s = "Verifique seu e-mail", o4s = "Insira o código de seis dígitos enviado para {{email}}", r4s = "Verifique seu e-mail para criar uma organização", i4s = "O código inserido não é válido, tente novamente", a4s = "Este e-mail já está sendo usado", s4s = "Você recebeu um convite para ingressar em {{orgName}}", c4s = "Ingresse na sua equipe em {{orgName}} e comece a focar na reunião, não em fazer reuniões!", l4s = "Não foi possível criar as equipes a seguir devido a campos de dados dinâmicos: {{slugs}}", u4s = "Nomes de equipe não podem ser vazios", d4s = "Nomes de equipe não podem ser repetidos", _4s = "O usuário pertence a uma organização", p4s = "Esta organização ainda não tem nenhuma equipe", m4s = "Se você for administrador, não se esqueça de criar equipes para mostrar aqui.", f4s = "Configurar", g4s = "Meu perfil", h4s = "Minhas configurações", v4s = "CRM", b4s = "Mensagens", y4s = "Nome ou número mostrado como remetente do SMS (alguns países não permitem IDs de remetentes com caracteres alfanuméricos)", $4s = "Apenas o administrador da sua organização pode criar equipes novas", w4s = "A nova política de spam do Google pode impedir que você receba e-mails e notificações de calendário sobre esta reserva.", k4s = "Resolver", S4s = "Houve um erro ao criar equipes para esta organizazção. Falta o campo de dados dinâmico do URL.", E4s = "Copiar link para a organização", x4s = "Equipe: {{teamName}}", C4s = "Usuário: {{userName}}", T4s = "Veja insights de reserva em seus eventos", A4s = "Histórico de Chamadas", I4s = "Visualize o histórico de chamadas em todas as suas chamadas Cal.ai", O4s = "{{locationCount}} opções de local", N4s = "Tipo de Canal", z4s = "Motivo de Encerramento", R4s = "Status da Sessão", P4s = "Sentimento do Usuário", D4s = "Hora", L4s = "De", M4s = "Plano personalizado", F4s = "Incorporação de e-mail", q4s = "Selecione alguns horários disponíveis e incorpore-os no seu e-mail", j4s = "Selecione o horário", V4s = "Selecione a data", B4s = "Mostrar apenas se um parâmetro estiver definido", U4s = "Adicionar parâmetro", G4s = "Estamos conectando você a alguém da {{orgName}}.", W4s = "Por favor, não feche ou atualize esta página", H4s = "Veja todos os horários disponíveis", Y4s = "ex.: Time de Marketing", K4s = "ex: Time de Vendas", Z4s = "ex: Time de Design", X4s = "ex: Time de Engenharia", J4s = "ex: Time de Análise de Dados", Q4s = "Você poderá adicionar mais equipes depois.", e5s = "De que se trata esta reunião?", t5s = "Adicionar à equipe", n5s = "Remover usuários da organização", o5s = "Credencial de delegação", r5s = "A credencial de delegação permite que você gerencie o acesso aos calendários do Google Workspace para sua organização.", i5s = "Adicione este ID do Cliente no Google Workspace com o escopo abaixo", a5s = "Credencial de delegação ativada", s5s = "Adicionar credencial de delegação", c5s = "Editar credencial de delegação", l5s = "Domínio", u5s = "Nenhuma plataforma de workspace", d5s = "Plataforma de workspace", _5s = "Plataformas de workspace", p5s = "Gerencie as plataformas de workspace que podem ser usadas para credencial de delegação", m5s = "Editar plataforma de workspace", f5s = "Editar conta de serviço", g5s = "Adicionar plataforma de workspace", h5s = "Slug", v5s = "JSON da chave da conta de serviço", b5s = "Editar JSON da chave da conta de serviço", y5s = "A credencial de delegação restringe a adição de mais de uma instalação", $5s = "Aplicativo instalado com sucesso e está usando credenciais delegadas", w5s = "Tem certeza de que deseja remover {{userCount}} usuários desta organização?", k5s = "Remover usuários da equipe", S5s = "Tem certeza de que deseja remover {{userCount}} usuários desta equipe?", E5s = "Este usuário ainda não definiu nenhuma agenda", x5s = "Este usuário não está em nenhuma equipe", C5s = "Este usuário ainda não instalou nenhum aplicativo", T5s = "Requer verificação de e-mail do reservante", A5s = "Para assegurar a verificação do e-mail do reservante antes de agendar eventos", I5s = "Mensagens de texto só podem ser enviadas a participantes quando este tipo de evento exigir confirmação.", O5s = "Organizações", N5s = "Carregar Logotipo do Vídeo Cal", z5s = "Atualizar logotipo do vídeo Cal", R5s = "Carregar Banner", P5s = "Para garantir que seu logotipo fique visível no fundo escuro do vídeo Cal, carregue uma imagem de cor clara em formato PNG ou SVG para manter a transparência.", D5s = "Outros times", L5s = "Aqui você pode conferir os times da sua organização dos quais você não faz parte. Se necessário, você pode se adicionar a eles.", M5s = "Você não faz parte de nenhuma organização", F5s = "Nenhum outro time encontrado", q5s = "Não há outros times nesta organização.", j5s = "Nome do participante", V5s = "Sobrenome do participante", B5s = "Nome da pessoa que fez a reserva", U5s = "O sobrenome da pessoa que fez a reserva", G5s = "Seu Resumo Mensal", W5s = "Nome do Membro", H5s = "Eventos Mais Populares", Y5s = "Aqui está seu resumo dos eventos populares da sua equipe {{teamName}} nos últimos 30 dias", K5s = "Eu", Z5s = "Reunião indisponível", X5s = "E-mail de resumo mensal", J5s = "E-mail de resumo mensal para as equipes", Q5s = "Verifique seu time para habilitar o envio de mensagens aos participantes", e6s = "Membro removido", t6s = "Minha disponibilidade", n6s = "Disponibilidade da equipe", o6s = "Disponibilidade imediata para reuniões", r6s = "Código de reserva", i6s = "Códigos de reserva", a6s = "Cada código de reserva pode ser usado exatamente uma vez para conceder acesso sem seu autenticador.", s6s = "Códigos de reserva copiados!", c6s = "O código de reserva está incorreto.", l6s = "Acesso perdido", u6s = "Nenhum código de reserva encontrado. Gere nas suas configurações.", d6s = "Nova organização criada: ação pendente", _6s = "Olá, administrador", p6s = "A organização exige uma configuração de DNS", m6s = 'Foi criada uma organização com um campo de dados dinâmicos "{{orgSlug}}".<br /><br />Configure seu registro de DNS para apontar o subdomínio correspondente da nova organização para onde o aplicativo principal está sendo executado. Se não fizer isso, a organização não funcionará.<br /><br />Confira algumas opções muito básicas de configuração para que o subdomínio aponte para seu aplicativo e a página do perfil da organização seja carregada.<br /><br />É possível fazer isso com um registro de endereço:', f6s = "Ou o registro CNAME:", g6s = "Após configurar o subdomínio, marque a configuração do DNS com concluída nas Configurações de administrador das organizações.", h6s = "Ir para Configurações de administrador das organizações", v6s = "A organização foi processada", b6s = "Ocorreu um erro ao processar esta organização", y6s = "Uma lista de todas as organizações. Ao aceitar uma organização, todos os usuários com aquele domínio de e-mail poderão entrar SEM a verificação do e-mail.", $6s = "Sem verificação", w6s = "Verificado", k6s = "DNS ausente", S6s = "DNS configurado", E6s = "Marcar como DNS configurado", x6s = "Valor", C6s = "Sua organização foi atualizada com êxito", T6s = "Sua equipe não tem tipos de evento", A6s = "A opção de assento não é compatível com múltiplas durações", I6s = "Incluir evento do calendário", O6s = "OAuth", N6s = "Formulário de criação de cliente OAuth", z6s = "Este é o formulário para criar um novo cliente OAuth", R6s = "Formulário de atualização de cliente OAuth", P6s = "Este é o formulário para editar um cliente OAuth existente", D6s = "Adicionou recentemente", L6s = "Conecte todos os seus calendários", M6s = "{{appName}} lê a disponibilidade de todos os seus calendários existentes.", F6s = "Personalize sua experiência de agendamento com fluxos de trabalho", q6s = "Automação de fluxo de trabalho", j6s = "Agende para sua equipe com agendamento coletivo e round-robin", V6s = "Nenhum membro encontrado", B6s = "Sincronização de diretório", U6s = "Nome do diretório", G6s = "Provedor de diretório", W6s = "URL base do SCIM", H6s = "Bearer Token SCIM", Y6s = "URL base do SCIM copiado", K6s = "Bearer Token SCIM copiado", Z6s = "Seu provedor de identidade solicitará as seguintes informações para configurar o SCIM. Siga as instruções para finalizar a configuração.", X6s = "Configurar sincronização de diretório", J6s = "Escolha um provedor de identidade para configurar o diretório da sua equipe.", Q6s = "Configure um provedor de identidade para começar a usar o SCIM.", eFs = "Conexão de sincronização de diretório criada.", tFs = "Provisione e desprovisione usuários com seu provedor de diretório.", nFs = "Conexão de sincronização de diretório excluída.", oFs = "Excluir conexão", rFs = "Excluir conexão de sincronização de diretório", iFs = "Tem certeza de que deseja excluir esta conexão de sincronização de diretório?", aFs = "Essa ação não pode ser desfeita. Isso excluirá permanentemente a conexão de sincronização de diretório.", sFs = "Configuração do evento: deve ter pelo menos 1 minuto de duração.", cFs = "Agendamentos de disponibilidade", lFs = "Não autorizado", uFs = "{{clientName}} gostaria de acessar a sua conta {{appName}}", dFs = "Selecionar conta ou equipe", _Fs = "Isso permitirá ao {{clientName}}", pFs = "Associar você com suas informações pessoais de {{clientName}}", mFs = "Veja suas informações pessoais, incluindo quaisquer informações pessoais disponibilizadas publicamente", fFs = "Veja seu endereço de e-mail principal", gFs = "Conecte-se aos seus aplicativos instalados", hFs = "Ler, editar, excluir os seus tipos de eventos", vFs = "Ler, editar, excluir sua disponibilidade", bFs = "Ler, editar, excluir suas reservas", yFs = "Permitir que {{clientName}} faça isto?", $Fs = "Ao clicar em Permitir, você autoriza que este aplicativo use suas informações, de acordo com os termos de serviço e política de privacidade. Você pode remover o acesso na App Store do {{appName}}.", wFs = "Permitir", kFs = "Este usuário não concluiu a integração. Não será possível definir a disponibilidade antes de concluir a integração.", SFs = "Você está vendo a disponibilidade deste usuário. Você só pode editar sua disponibilidade.", EFs = "Você pode substituir isso por evento nas configurações Avançadas em cada tipo de evento.", xFs = "Editar disponibilidade do usuário: {{username}}", CFs = "Reenviar convite", TFs = "O convite foi reenviado.", AFs = "SAML", IFs = "Adicionar cliente", OFs = "Depois de copiar o segredo, você não poderá mais visualizá-lo", NFs = "Adicionar novo cliente", zFs = "Adicionar novo usuário", RFs = "Este app ainda não foi configurado", PFs = "como CSV", DFs = "Sobrepor meu calendário", LFs = "Ao conectar-se à seu Calendário, você aceita nossa política de privacidade e termos de uso. Você pode revogar o acesso a qualquer momento.", MFs = "Veja seus eventos do calendário para evitar conflito nos agendamentos.", FFs = "Junte-se a {{eventLocationType}}", qFs = "Solução de problemas", jFs = "Calendários que estamos verificando para conflitos", VFs = "Horários de disponibilidade", BFs = "Gerenciar calendários", UFs = "Gerenciar agendas de disponibilidade", GFs = "Bloqueado", WFs = "Desbloqueado", HFs = "Bloquear fuso horário na página de reserva", YFs = "Bloquear o fuso horário na página de reservas, útil para eventos presenciais.", KFs = "Você só pode ter um aplicativo de pagamento ativado por tipo de evento.", ZFs = "Insira o número em formato internacional.", XFs = "Instalar Calendário", JFs = "Subdomínio próprio", QFs = "Obtenha seu próprio subdomínio, como acme.cal.com", eqs = "Insights de toda a organização", tqs = "Entenda como toda a sua organização está gastando o tempo", nqs = "Marca própria abrangente", oqs = "Personalize sua experiência de agendamento com seu próprio logotipo, cores e muito mais", rqs = "Equipes ilimitadas", iqs = "Verificar e-mail", aqs = "Por favor, digite o endereço de e-mail usado para esta reserva para prosseguir com o cancelamento", sqs = "O e-mail não corresponde ao e-mail da reserva", cqs = "Adicione quantas subequipes forem necessárias à sua organização", lqs = "Faturamento Unificado", uqs = "Tipos de eventos gerenciados avançados", dqs = "Adicione um único cartão de crédito para pagar todas as assinaturas da sua equipe", _qs = "Empresa", pqs = "Atualize para Enterprise para criar sua organização", mqs = "Crie sua organização", fqs = "Criar organização", gqs = "Atualize para Organizations e receba um subdomínio, faturamento unificado, insights, whitelabeling abrangente e muito mais", hqs = "Atualize para Enterprise e ganhe acesso à Sincronização de Diretório Ativo, Provisionamento Automático de Usuários SCIM, Agentes de Voz Cal.ai, APIs de Administrador e mais!", vqs = "Você só pode ativar um aplicativo de pagamento por tipo de evento", bqs = "Equipes que são membros desta organização também serão excluídas junto com seus tipos de eventos", yqs = "Usuários que faziam parte da organização não serão excluídos, mas seus nomes de usuário seriam alterados para permitir que existam fora da organização", $qs = "Tipos de eventos de usuário criados após o usuário estar na organização serão excluídos", wqs = "Tipos de eventos de usuário migrados não serão excluídos", kqs = "Excluir {{organizationName}} ?", Sqs = "Publicado", Eqs = "Não publicado", xqs = "Publicar", Cqs = "Abra o solucionador de problemas e descubra o que há de errado com sua programação", Tqs = "Precisa de ajuda?", Aqs = "Solucionador de problemas", Iqs = "Número para Ligar", Oqs = "Nome do Convidado", Nqs = "E-mail do Convidado", zqs = "Empresa do Convidado", Rqs = "Instale um calendário", Pqs = "Reserva instantânea", Dqs = "Deixe as pessoas reservarem imediatamente", Lqs = "Atualize para Enterprise e permita que os convidados participem de uma chamada instantânea na qual os participantes possam participar diretamente. Isso é apenas para tipos de eventos de equipe", Mqs = "Não quer esperar?", Fqs = "Reunião iniciada", qqs = "Pague para reservar", jqs = "Deixe Assistentes de IA agendarem para você", Vqs = "Não foi possível encontrar a reserva", Bqs = "A reserva de assentos está lotada", Uqs = "Credenciais de pagamento ausentes", Gqs = "ID do aplicativo de pagamento ausente", Wqs = "A reserva não tem assentos disponíveis suficientes", Hqs = "{{username}} está ausente por um breve período de tempo.", Yqs = "Enquanto isso, {{profile.username}} será responsável por todas as novas reuniões agendadas em nome de {{username}} .", Kqs = "Ausente", Zqs = "Configure ações em seu perfil enquanto estiver ausente.", Xqs = "Enviar pedido", Jqs = "A data de início e a data de término são obrigatórias", Qqs = "A data de início deve ser anterior à data de término", ejs = "A data de início deve ser no futuro", tjs = "Usuário não encontrado", njs = "Não é possível redirecionar para si mesmo", ojs = "Ausência já existente", rjs = "ID de ausência obrigatório", ijs = "Já existe um redirecionamento de reserva desse usuário para você.", ajs = "Entrada criada com sucesso", sjs = "Notificação de redirecionamento de reserva", cjs = "Notificação de redirecionamento de reserva", ljs = "Você recebeu um redirecionamento de agendamento de {{eventOwner}}, então os links do perfil deles serão redirecionados para o seu durante o intervalo de tempo {{dates}}.", ujs = "Notificação de edição de redirecionamento de agendamento", djs = "Notificação de Edição de Redirecionamento de Agendamento", _js = "Seu redirecionamento de agendamento de {{eventOwner}} para o intervalo de tempo {{oldDates}} foi atualizado. O novo intervalo de tempo para o redirecionamento é {{dates}}.", pjs = "Notificação de cancelamento de redirecionamento de agendamento", mjs = "Notificação de Cancelamento de Redirecionamento de Agendamento", fjs = "Seu redirecionamento de agendamento de {{eventOwner}} para o intervalo de tempo {{dates}} foi cancelado.", gjs = "Você aceitou esta solicitação de redirecionamento de reserva.", hjs = "Você rejeitou esta solicitação de redirecionamento de reserva.", vjs = "Copiar link para solicitação de compartilhamento", bjs = "Solicitação de redirecionamento de reserva", yjs = "Selecione o membro da equipe", $js = "Indo embora? Basta marcar o link do seu perfil como indisponível por um período de tempo.", wjs = "Redirecione seu perfil para outro membro da equipe", kjs = "Redirecione seu perfil para outro membro da equipe (é necessário plano de equipe)", Sjs = "Lista de indisponibilidade", Ejs = "Entrada excluída com sucesso", xjs = "Entrada editada com sucesso", Cjs = "Temporariamente ausente?", Tjs = "Adicionar um redirecionamento", Ajs = "Criar entrada", Ijs = "Intervalo de tempo", Ojs = "Adicione todos os membros da equipe, incluindo futuros membros", Njs = "Redirecionar para", zjs = "Está tendo problemas para encontrar um horário?", Rjs = "Mostrar mais", Pjs = "Encaminhar parâmetros como ?email=...&name=.... e mais", Djs = "Agende reuniões quando todos estiverem disponíveis ou alterne entre os membros da sua equipe", Ljs = "mais baixo", Mjs = "baixo", Fjs = "médio", qjs = "alto", jjs = "mais alto", Vjs = "Enviar reserva para", Bjs = "Definir prioridade", Ujs = "Definir Peso", Gjs = "Habilitar Pesos", Wjs = "Prioridade para {{userName}}", Hjs = "Os pesos determinam como as reuniões são distribuídas entre os anfitriões. <0>Saiba mais</0>", Yjs = "Peso para {{userName}}", Kjs = "alterar prioridade", Zjs = "Use identificadores de campo como variáveis para seu redirecionamento de evento personalizado", Xjs = "Use identificadores de campo como variáveis para seu redirecionamento de evento personalizado (por exemplo {{variable}} )", Jjs = "A conta já está vinculada", Qjs = "Enviar e-mail", eVs = "Ligar para o participante usando o Agente de Voz Cal.ai", tVs = "Ligar para confirmar reserva", nVs = "2 horas antes do início do evento", oVs = "Configuração do agente Cal.ai", rVs = "Por favor, escolha pelo menos um tipo de evento para fazer uma chamada de teste.", iVs = "Marcar como não compareceu", aVs = "Desmarcar como não compareceu", sVs = "Conta vinculada com sucesso", cVs = "Houve um erro ao desvincular a conta", lVs = "Agendar Viagem", uVs = "Planeje sua viagem com antecedência para manter seus agendamento existentes em um fuso horário diferente e evitar ser agendado à meia-noite.", dVs = "Agende mudança de fuso horário", _Vs = "Data", pVs = "Digite o prompt geral para o agente", mVs = "Isto se sobrepõe com um agendamento existente. Por favor, selecione uma data diferente.", fVs = "Receber notificações quando seu time não tem disponibilidade", gVs = "Administradores receberão notificações de e-mail quando um usuário tentar agendar um membro da equipe e receber 'Sem disponibilidade'. Nós enviamos este e-mail depois de duas ocorrências e te lembramos a cada 7 dias para cada usuário.  ", hVs = "Desativar notificações por SMS para tipos de eventos apenas com telefone", vVs = "Desativar notificações automáticas por SMS para tipos de eventos que têm apenas número de telefone (attendeePhoneNumber) como pergunta obrigatória, com e-mail opcional ou não obrigatório", bVs = "Seu plano atual", yVs = "$37 por usuário por mês", $Vs = "Gerencie as configurações de privacidade da sua organização", wVs = "Privacidade", kVs = "Novos times estarão sob sua organização", SVs = "Adicionar nome do grupo", EVs = "Nome do Grupo", xVs = "Roteadores", CVs = "Primário", TVs = "Tornar primário", AVs = "Adicionar e-mail", IVs = "Adicionar e-mails", OVs = "Adicione um endereço de e-mail para substituir seu e-mail principal ou para usar como e-mail alternativo em seus tipos de eventos.", NVs = "Confirme seu e-mail", zVs = "$t(hey_there) {{name}}, confirmando sua reserva em {{date}}.", RVs = "O primeiro nome da pessoa que está agendando", PVs = "O sobrenome da pessoa que está agendando", DVs = "Nome do agendador", LVs = "Seu primeiro nome", MVs = "Enviamos um e-mail para <strong>{{email}}</strong> . Clique no link do e-mail para verificar este endereço.", FVs = "Envie detalhes do evento para", qVs = "Agendar fuso horário sem data final", jVs = "Selecionar membros", VVs = "O que nós devemos fazer com os tipos de evento do seu membro?", BVs = "Todos os tipos de evento individuais dos seus membros (exceto os gerenciados) serão permanentemente apagados. Eles não conseguirão criar novos", UVs = "Os tipos de evento individuais dos seus membros serão ocultados dos perfis (exceto os gerenciados) mas os links ainda ficarão ativos. Eles não serão capazes de criar novos.  ", GVs = "Ocultar tipos de evento individuais", WVs = "Apagar tipos de evento individuais", HVs = "Bloquear criação de tipos de evento individuais", YVs = "Impedir membros de criar seus próprios tipos de evento.", KVs = "Adicionar ao tipo de evento", ZVs = "Crie a senha da conta", XVs = "Criar conta com SAML", JVs = "Erro ao criar senha da conta", QVs = "Não é permitido criar senha de conta para contas cal", eBs = "Não é permitido criar senha de conta para senhas já criadas", tBs = "Você não tem uma senha de conta, crie uma em Securança -> Senha. Não é possível disconectar até uma senha de conta ser criada.", nBs = "Disconecte contas conectadas", oBs = "Disconectar sua conta conectada mudará a maneira como você faz login. Você só poderá fazer login usando e-mail + senha", rBs = "Eu concordo com a política de privacidade e o uso de cookies", iBs = "Fazer uma Ligação", aBs = "Pular atribuição round robin se o contato existir no Salesforce", sBs = "A URL deve conter o e-mail do contato como um parâmetro, ex. ?email=contactEmail", cBs = "Selecionar Conta", lBs = "Instale {{appName}} na sua conta pessoal ou em uma conta de equipe.", uBs = "Selecionar Tipos de Evento", dBs = "Em qual tipo de evento você deseja instalar {{appName}}?", _Bs = "Configurar {{appName}}", pBs = "Finalize a configuração do App. Você pode alterar essas configurações mais tarde.", mBs = "já instalado", fBs = "Não especificado", gBs = "Férias", hBs = "Viagem", vBs = "Doente", bBs = "Feriado", yBs = "Encaminhando para <0>{{username}}</0>", $Bs = "Não é possível encaminhar", wBs = "Crie uma política Ausente", kBs = "Comunique aos seus agendadores quando você não estiver disponível para receber agendamentos. Eles ainda poderão agendar com você após seu retorno ou você pode encaminhá-los a um membro da equipe.", SBs = "{{displayName}} está ausente", EBs = "<0>{{displayName}}</0> participará das reuniões enquanto ele(a) estiver ausente.", xBs = "Agende com {{displayName}}", CBs = "Selecione motivo", TBs = "Criar política Ausente", ABs = "Editar Entrada de Ausência", IBs = "Enviar Feedback", OBs = "A(O) anfitriã(o) não apareceu", NBs = "Você pode agendar outra reunião com ele(a)", zBs = "Como podemos melhorar nosso serviço?", RBs = "O que você mais gostou?", PBs = "Revisar", DBs = "Revisado", LBs = "Não revisado", MBs = "URL de avaliação", FBs = "URL para o Formulário de Avaliação", qBs = "URL de não comparecimento", jBs = "URL para Feedback de Não-Comparecimento", VBs = "Não precisa de ajuda?", BBs = "Ocultar ajuda", UBs = "Média de Avaliações", GBs = "Não comparecimento (Anfitrião)", WBs = "Não comparecimento (Convidado)", HBs = "Avaliações recentes", YBs = "Nenhuma avaliação enviada", KBs = "Adicione um fluxo de trabalho com 'Avaliação' para receber avaliações após as reuniões", ZBs = "Maior ausência", XBs = "Melhor avaliado", JBs = "Pior avaliado", QBs = "Membros com a maior taxa de reuniões", e9s = "Membros com a menor taxa de reuniões", t9s = "Pontuação CSAT", n9s = "SMS Bloqueado", o9s = "Sair sem atribuir ninguém?", r9s = "Tem certeza de que deseja sair deste evento sem adicionar participantes?", i9s = "Se você não atribuir ninguém para este evento, não haverá disponibilidade mostrada para os agendadores.", a9s = "Voltar e Atribuir", s9s = "Sair sem Atribuir", c9s = "Ao continuar, você concorda com nossos <0>Termos</0> e <1>Política de Privacidade</1>.", l9s = "Ao prosseguir, você concorda com nossos", u9s = "Termos", d9s = "Sempre {{x}} dias disponíveis", _9s = "Move automaticamente a janela de agendamento de {{x}} dias para frente a cada dia, garantindo que seu calendário sempre mostre os próximos {{x}} dias de horários disponíveis.", p9s = "Assinatura da equipe cancelada com sucesso", m9s = "Erro ao cancelar a assinatura da equipe", f9s = "Um erro ocorreu ao tentar adicionar ao plano da plataforma, por favor tente novamente mais tarde", g9s = "Um erro ocorreu ao tentar atualizar o cliente OAuth, por favor tente novamente mais tarde", h9s = "Um erro ocorreu ao tentar criar o cliente OAuth, por favor tente novamente mais tarde", v9s = "Cor do tipo de evento", b9s = "Isso é usado apenas para diferenciação de tipo de evento e agendamento dentro do aplicativo. Não é exibido para os agendadores.", y9s = "Marcar como não compareceu", $9s = "{{x}} marcado como não compareceu", w9s = "{{x}} desmarcado como não compareceu", k9s = "disparadores para todos os tipos de eventos da equipe e todos os tipos de eventos pessoais dos membros da equipe", S9s = "Gerencie as configurações da sua equipe", E9s = "Status de não comparecimento atualizado para os participantes", x9s = "Email copiado", C9s = "Número de telefone copiado", T9s = "Usuário é um membro pendente da organização", A9s = "Usuário já foi convidado ou é membro", I9s = "Usuário é membro de uma organização que esta equipe não faz parte.", O9s = "Reserva foi reatribuída", N9s = "Reatribuir", z9s = "Reatribuir reserva para outro anfitrião disponível de round robin", R9s = "Atribuir membro da equipe", P9s = "Substituir qual membro da equipe você deseja atribuir.", D9s = "Nenhum anfitrião disponível", L9s = "Reatribuir anfitrião de round robin", M9s = "Não escrever no feed ICS", F9s = "Reagendamento não é possível, pois o evento expirou", q9s = "Este evento expirou", j9s = "Pular criação de contatos se eles não existirem no {{appName}}", V9s = "Se o seu link ICS for somente leitura (por exemplo, Proton Calendar), marque a caixa acima para evitar erros. Você também precisará atualizar manualmente seu calendário para mudanças.", B9s = "Atributos", U9s = "Novo atributo", G9s = "Adicionar atributos", W9s = "Adicionar atributos aos membros da sua equipe", H9s = "Nova opção", Y9s = "Atualizar membro", K9s = "Atributo", Z9s = "Criar um atributo para os membros da sua equipe", X9s = "Editar um atributo para os membros da sua equipe", J9s = "Atributo atualizado com sucesso", Q9s = "Atributo excluído com sucesso", eUs = "Atributos editados com sucesso", tUs = "Gerencie atributos para os membros da sua equipe", nUs = "Edite atributos para os membros da sua equipe", oUs = "Voltar para atributos", rUs = "Tem certeza de que deseja excluir esta opção?", iUs = "Esta opção está atribuída a {{numberOfUsers}} membros. Excluí-la a removerá de seus perfis.", aUs = "Desativar e-mails padrão para participantes relacionados a este tipo de evento", sUs = "Desativa a comunicação por e-mail padrão relacionada a este tipo de evento, incluindo confirmações de reserva, lembretes e cancelamentos.", cUs = "Desativar e-mails padrão para anfitriões relacionados a este tipo de evento", lUs = "Digite confirmar para continuar", uUs = "Desativar e-mail", dUs = "Conceder acesso à API de administrador", _Us = "Revogar acesso à API de administrador", pUs = "Adicionar calendário {{calendar}}", mUs = "Conectar Calendário Apple", fUs = "Calendário Apple conectado", gUs = "Verificando Calendário Apple", hUs = "Conectar Calendário Google", vUs = "Calendário Google conectado", bUs = "Verificando Calendário Google", yUs = "Conectar Calendário Outlook", $Us = "Calendário Outlook conectado", wUs = "Verificando Calendário Outlook", kUs = "Conectar ao Stripe", SUs = "Stripe Conectado", EUs = "Verificando credenciais do Stripe", xUs = "Variáveis de resposta de perguntas de reserva", CUs = "Gerenciado por {{teamAdmins}}", TUs = "{{count}} opções", AUs = "Reagendar com o mesmo anfitrião Round-Robin", IUs = "Eventos reagendados serão atribuídos ao mesmo anfitrião inicialmente agendado", OUs = "Desativar entrada se o identificador da URL estiver preenchido", NUs = "Limites de Agendamento", zUs = "Limites de agendamento para membros da equipe em todos os tipos de eventos da equipe", RUs = "Limitar quantas vezes os membros podem ser reservados em todos os tipos de eventos da equipe", PUs = "Limites de agendamento atualizados com sucesso", DUs = "Você não tem autorização para fazer essa alteração na reserva", LUs = "Credencial de delegação desativada", MUs = "Membros correspondentes", FUs = "{{x}} membros correspondentes", qUs = "Fila de membros correspondentes (usando pesos de atributos)", jUs = "Fila de membros correspondentes (usando pesos de designados do evento)", VUs = "Nenhum membro correspondente. Será utilizado como alternativa os membros da equipe atribuídos ao tipo de evento.", BUs = "Nenhum membro correspondente. Será usado como fallback os membros da equipe atribuídos ao tipo de evento. Considere adicionar um fallback ou corrigir a lógica de using_fallback_members", UUs = "Ocultar detalhes dos eventos do calendário em calendários compartilhados", GUs = "Quando um calendário é compartilhado, os eventos são visíveis para os leitores, mas seus detalhes são ocultados para aqueles que não têm acesso de escrita.", WUs = "Últimos {{count}} dias", HUs = "Mês até hoje", YUs = "Ano até hoje", KUs = "Período personalizado", ZUs = "Política de reembolso", XUs = "Sempre", JUs = "Nunca", QUs = "Opção de pagamento", eGs = "Se cancelado", tGs = "antes", nGs = "Mostrar todas as colunas", oGs = "Alternar colunas", rGs = "Nenhuma coluna encontrada", iGs = "Ao agendar, adicione eventos e novos participantes como:", aGs = "Lead", sGs = "Contato em uma conta", cGs = "Pular a criação do registro de {{entry}} se não existir no Salesforce", lGs = "Se o contato não existir em uma conta, criar novo lead a partir do participante", uGs = "Criar um novo contato em uma conta com base no domínio de e-mail do participante e contatos existentes", dGs = "Alterar proprietário do registro na reserva", _Gs = "Atribuir atributos em massa", pGs = "Isso resulta na exibição de uma mensagem personalizada. Tente alterar a resposta para redirecionar a um evento", mGs = "Isso resulta no redirecionamento para {{externalUrl}}. Tente alterar a resposta para redirecionar a um evento", fGs = "Possível anfitrião", gGs = "Status atual de roteamento", hGs = "Redirecionar agendamento", vGs = "Redirecionar o agendamento para diferentes membros da equipe", bGs = "Verificar nova rota", yGs = "Redirecionar", $Gs = "Novo status de roteamento", wGs = "Se o participante existir no Salesforce, agendar diretamente com o proprietário", kGs = "Entidade para verificar o proprietário para agendar diretamente", SGs = "Conta", EGs = "Escolher horários dos anfitriões", xGs = "Você pode selecionar um horário diferente para cada anfitrião. O horário padrão de cada anfitrião é escolhido por padrão.", CGs = "Nenhum anfitrião atribuído, adicione anfitriões na aba de atribuição.", TGs = "Reatribuir manualmente o anfitrião round robin", AGs = "Reatribuir manualmente o anfitrião round robin para outro anfitrião disponível", IGs = "Reatribuir o anfitrião round robin para outro anfitrião disponível", OGs = "O novo usuário não é um anfitrião round robin válido para este tipo de evento", NGs = "O novo usuário é um anfitrião fixo para este tipo de evento", zGs = "Reagendar com o mesmo horário", RGs = "Reagendar com o mesmo horário do novo evento", PGs = "Reagendar para o novo evento com horário diferente", DGs = "Reagendar com horário diferente", LGs = "Não temos o ID para o novo evento. Por favor, vá para o Formulário de Roteamento e salve-o novamente.", MGs = "Agendamento redirecionado com sucesso. Redirecionando para a página de agendamento", FGs = "Na reserva, escrever no objeto do evento", qGs = "Nome do campo", jGs = "Adicionar novo campo", VGs = "Você não tem acesso para redirecionar esta reserva", BGs = "Resposta do formulário não encontrada", UGs = "Proprietário do contato", GGs = "Não encontrado", WGs = "Usando membros de fallback", HGs = "Rota escolhida", YGs = "Lógica de atributos correspondida", KGs = "Lógica de atributos de fallback correspondida", ZGs = "Todos os membros atribuídos ao tipo de evento da equipe. Considere adicionar algumas regras de atributos.", XGs = "Todos os membros atribuídos ao tipo de evento da equipe. Considere adicionar algumas regras de atributos para fallback.", JGs = "Todos os membros atribuídos ao tipo de evento da equipe. Considere ajustar o fallback para obter uma correspondência.", QGs = "Aviso", eWs = "Fallback: Se nenhum membro da equipe corresponder, use aqueles que atendam aos seguintes critérios (por padrão, corresponde a todos os membros da equipe atribuídos ao evento)", tWs = "Aviso de fallback", nWs = "Não necessário", oWs = "Anfitrião indisponível", rWs = "Anfitrião disponível", iWs = "Tem certeza de que deseja reatribuir esta reserva a um anfitrião indisponível?", aWs = "Tem certeza de que deseja reatribuir esta reserva?", sWs = "Sim, reatribuir", cWs = "Filtrar por atributos", lWs = "Motivo da reatribuição", uWs = "Alterar o tipo de campo pode causar perda de dados. Por favor, crie um novo campo em vez disso.", dWs = "Reatribuído por", _Ws = "linha", pWs = "linhas", mWs = "Fuso horário do participante", fWs = "Hora de início do evento no fuso horário do participante", gWs = "Hora de início do evento no fuso horário do participante", hWs = "Hora de término do evento no fuso horário do participante", vWs = "Hora de término do evento no fuso horário do participante", bWs = "Criar evento no contato, se existir. Caso contrário, usar lead como alternativa", yWs = "Nome do proprietário a ser alterado", $Ws = "Nenhum filtro definido", wWs = "Simulação de agendamento bem-sucedida", kWs = "O teste simulado foi concluído com sucesso.", SWs = "Você não tem acesso a esta página", EWs = "Para visualizar ou interagir com esta página, você deve ter privilégios de administrador ou proprietário", xWs = "Tipo de campo", CWs = "Quando escrever", TWs = "Ao fazer uma reserva, escrever em um campo personalizado no registro {{record}} do participante", AWs = "Em cada reserva", IWs = "Apenas se o campo estiver vazio", OWs = "Data de início da reserva", NWs = "Data de criação da reserva", zWs = "Reserva reatribuída para {{host}}", RWs = "Sem proprietário do contato", PWs = "Formulários de Roteamento Criados", DWs = "Total de Respostas", LWs = "Total de Respostas Sem Agendamento", MWs = "Total de Respostas Com Agendamento", FWs = "Sem Agendamentos", qWs = "Nome do Formulário", jWs = "Agendamento", VWs = "Sem Agendamento", BWs = "Agendado por", UWs = "Criado em", GWs = "Status do Agendamento", WWs = "Agendado em", HWs = "Enviado em", YWs = "Copiar URL de redirecionamento", KWs = "URL de redirecionamento ao sair", ZWs = "Total de agendamentos por período", XWs = "Encaminhados por período", JWs = "Por dia", QWs = "Por semana", e8s = "Por mês", t8s = "Motivo da atribuição", n8s = "Acesso negado", o8s = "O proprietário do contato será o anfitrião do Round Robin se disponível", r8s = "Adicionar novos participantes como", i8s = "O proprietário do contato não será forçado (ainda pode ser anfitrião se corresponder aos atributos e critérios do Round Robin)", a8s = "Direcionar para um usuário que corresponda a um campo de pesquisa em uma conta", s8s = "Opção do Salesforce", c8s = "Nome do campo de pesquisa", l8s = "Se o participante tiver um domínio de e-mail gratuito, ignore a verificação de propriedade e faça o round robin normalmente", u8s = "É", d8s = "Não é", _8s = "Contém", p8s = "Não contém", m8s = "Começa com", f8s = "Termina com", g8s = "Está vazio", h8s = "Não está vazio", v8s = "Traduzir título e descrição automaticamente", b8s = "Traduz automaticamente títulos e descrições para o idioma do navegador do visitante usando IA.", y8s = "Distribuição", $8s = "Permite otimizar a distribuição para máxima disponibilidade ou buscar uma atribuição mais equilibrada.", w8s = "Maximizar disponibilidade", k8s = "Permite que os agendadores marquem reuniões sempre que um anfitrião estiver disponível. Use isso para maximizar o número de reuniões potenciais agendadas quando a distribuição uniforme de reuniões entre os anfitriões for menos importante.", S8s = "Balanceamento de carga", E8s = "Monitoraremos quantas reservas foram feitas com cada anfitrião e compararemos com os outros, desativando alguns anfitriões que estão muito à frente para que as reservas sejam distribuídas uniformemente.", x8s = "Editar pesos", C8s = "Pesos atualizados com sucesso", T8s = "Exigir confirmação apenas para provedores de e-mail gratuitos (Ex. @gmail.com, @outlook.com)", A8s = "Excluir e-mails que contêm ...", I8s = "Exigir emails que contenham ...", O8s = "Por favor, insira um endereço de e-mail corporativo válido", N8s = "Você não tem permissão para agendar com este domínio de email. Por favor, entre em contato com o proprietário deste link.", z8s = "Buscar colunas", R8s = "Opções de busca", P8s = "Desativar perfil público da organização e redirecionar", D8s = "Redireciona {{orgSlug}}.cal.com para {{destination}}", L8s = "Seleção única", M8s = "Seleção múltipla", F8s = "Configurações de conflito de agenda", q8s = "Selecione quais agendas verificar para conflitos", j8s = "Reunião em grupo", V8s = "Tem certeza de que deseja remover este aplicativo de", B8s = "Desconectar aplicativo de", U8s = "Não criar novos registros para convidados adicionados ao agendamento", G8s = "Google Meet", W8s = "Zoom", H8s = "Vídeo do MS Teams", Y8s = "Bloquear para atribuição", K8s = "O bloqueio permitirá apenas atribuições do Directory Sync", Z8s = "Atributo editado com sucesso", X8s = "Nova opção de grupo", J8s = "Pesos habilitados", Q8s = "Ao habilitar os pesos, será possível atribuir maior prioridade a determinados atributos por usuário. Quanto maior o peso, maior a prioridade.", e7s = "Encaminhado", t7s = "Reatribuído", n7s = "Permitir reagendamento de eventos passados", o7s = "Ativar esta opção permite que eventos passados sejam reagendados", r7s = "Reencaminhado", i7s = "Atribuição do Salesforce", a7s = "Posição do roteador", s7s = "Mostrar hosts correspondentes", c7s = "Não há filas ativas para esta entrada", l7s = "Peso", u7s = "Calibração", d7s = "Déficit", _7s = "Formulário de roteamento", p7s = "Voltar e salvar", m7s = "Salvar alterações", f7s = "Sair sem salvar", g7s = "Tem certeza que deseja sair sem salvar as alterações no seu formulário de roteamento?", h7s = "Algo inesperado aconteceu", v7s = "Você está fazendo um agendamento de teste.", b7s = "Mostruário de ícones", y7s = "Mostruário de ícones", $7s = "Migrando da equipe", w7s = "O recurso está desativado no momento", k7s = "Escolha uma opção", S7s = "Digite o valor da opção", E7s = "Remover opção", x7s = "Usar pesos dos atributos", C7s = "Se ativado, todos os pesos definidos no tipo de evento serão ignorados", T7s = "Atributo para pesos", A7s = "Usuários gerenciados", I7s = "Veja todos os usuários gerenciados criados pelo seu cliente OAuth", O7s = "Você pode me falar sobre ", N7s = "Use a IA para responder suas perguntas", z7s = "Erro ao buscar resposta ", R7s = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde", P7s = "Selecionar cliente OAuth", D7s = "Em cada instância", L7s = "O recurso de credencial de delegação não está habilitado para sua organização", M7s = "Nota interna", F7s = "Motivo compartilhado com o cliente (opcional)", q7s = "Esta nota será visível apenas para membros da sua equipe", j7s = "Modelos de notas internas de cancelamento", V7s = "Crie modelos de notas internas que podem ser aplicados às reservas", B7s = "Modelos de notas internas atualizados com sucesso", U7s = "Adicionar modelo", G7s = "Autorizar", W7s = "Próximo", H7s = "Ocultar", Y7s = "Mostrar", K7s = "Parâmetros UTM", Z7s = "Nenhum parâmetro UTM disponível.", X7s = "Crescente", J7s = "Decrescente", Q7s = "Verificar alteração de e-mail", eHs = "Comprar créditos", tHs = "Créditos", nHs = "Créditos utilizados", oHs = "Total restante", rHs = "Você recebe 1000 créditos por mês, por membro da equipe", iHs = "Você recebe 750 créditos por mês, por membro da equipe", aHs = "Visualizar e gerenciar créditos para envio de mensagens SMS", sHs = "Visualize e gerencie créditos para envio de mensagens SMS. Um crédito vale 1¢ (USD). <0>Saiba mais</0>", cHs = "Um crédito vale 1¢ (USD). <0>Saiba mais</0>", lHs = "Comprar créditos adicionais ($0.01 por crédito)", uHs = "Você pode visualizar gastos de créditos adicionais no seu registro de despesas", dHs = "Visão geral", _Hs = "O slug da organização já está em uso", pHs = "Você não pode criar uma organização, pois já faz parte de uma", mHs = "Você precisa concluir a integração do usuário antes de criar uma organização", fHs = "Use o e-mail da empresa para criar uma organização", gHs = "Você não pode criar uma organização de plataforma, pois já faz parte de uma equipe", hHs = "Você precisa ter um número mínimo de equipes publicadas", vHs = "Você já faz parte desta organização", bHs = "Você faz parte de outra organização, não é possível criar uma nova", yHs = "Você faz parte de outra organização da plataforma, não é possível criar uma nova organização", $Hs = "Pagamento da organização bem-sucedido", wHs = "Sua organização foi criada com sucesso", kHs = "Isso pode levar alguns segundos...", SHs = "Status de integração da organização", EHs = "Descrição do status de integração da organização", xHs = "Falha no pagamento", CHs = "Seu pagamento falhou. Por favor, tente novamente.", THs = "Criando sua organização", AHs = "Integração da organização já concluída", IHs = "Integração da organização já existe", OHs = "Integração da organização não encontrada", NHs = "Pagamento bem-sucedido!", zHs = "Transferência de integração", RHs = "Transferir integração para o usuário", PHs = "Já existe uma organização com este slug", DHs = "Você não tem permissão para criar uma organização para este e-mail", LHs = "Você não tem permissão para migrar uma ou mais das equipes", MHs = "A organização já possui uma assinatura", FHs = "Intervalo de reinicialização para Round Robin ponderado", qHs = "Intervalo", jHs = "Determina com que frequência a contagem de reservas do round robin é reiniciada para garantir uma distribuição equilibrada.", VHs = "Diariamente", BHs = "Você não definiu uma data de término para sua ausência", UHs = "Minha ausência", GHs = "Ausência da equipe", WHs = "Gerencie as ausências da sua equipe.", HHs = "Criar ausência", YHs = "Criar uma ausência para um membro da equipe", KHs = "Editar uma ausência para um membro da equipe", ZHs = "Criar ausência para sua equipe", XHs = "Comunique aos agendadores quando os membros da sua equipe não estão disponíveis para receber agendamentos. Eles ainda podem ser agendados após o retorno ou você pode encaminhá-los para outro membro da equipe.", JHs = "O encaminhamento de ausência só é permitido para um membro da mesma equipe.", QHs = "Já existe um encaminhamento reverso entre esses usuários.", eYs = "Nenhuma ausência anterior encontrada", tYs = "Anterior", nYs = "Intervalo de Round Robin atualizado com sucesso", oYs = "Modo de teste", rYs = "Plano de equipe inativo", iYs = "Seu plano de equipe está inativo. Verifique sua assinatura ou entre em contato com o suporte ao cliente", aYs = "Acesso limitado durante o período de teste. Recurso disponível após o término do teste.", sYs = "Programa de indicação", cYs = "Ganhe 20% de indicação", lYs = "Você precisa de uma chave de API Dub e um ID de programa para usar esta página.", uYs = "UID", dYs = "Link", _Ys = "linhas por página", pYs = "{{currentRange}} de {{totalItems}}", mYs = "Dica: Você pode adicionar um '+' entre nomes de usuário: cal.com/anna+brian para criar uma reunião de grupo dinâmica", fYs = "Você ainda não tem uma equipe", gYs = "Você ainda não tem membros na equipe", hYs = "Eventos recorrentes não suportam o recurso de assentos. Torne-o não recorrente para habilitar assentos.", vYs = "Evento recorrente não suporta o recurso de limite de reservas por agendador. Desative o limite de reservas por agendador para habilitar o evento recorrente.", bYs = "O recurso de assentos não suporta eventos recorrentes. Desative o recurso de assentos para torná-lo recorrente.", yYs = "Eventos recorrentes não suportam o recurso de assentos. Desative o recurso de assentos ou torne o evento não recorrente.", $Ys = "Segmento", wYs = "Filtros salvos", kYs = "Renomear", SYs = "Renomear segmento", EYs = "Excluir segmento", xYs = "Duplicar segmento", CYs = "Tem certeza que deseja excluir este segmento? Esta ação não pode ser desfeita.", TYs = "Segmento de filtro atualizado", AYs = "Erro ao atualizar segmento de filtro", IYs = "Segmento de filtro duplicado", OYs = "Erro ao duplicar segmento de filtro", NYs = "Segmento de filtro excluído", zYs = "Erro ao excluir segmento de filtro", RYs = "Salvar segmento", PYs = "Segmento não encontrado", DYs = "Segmento de filtro salvo", LYs = "Sem segmentos", MYs = "Erro ao salvar segmento de filtro", FYs = 'Salvar substituições para "{{name}}"', qYs = "Criar novo segmento", jYs = "Salvar para equipe", VYs = "Selecionar equipe", BYs = "Por favor, selecione uma equipe", UYs = "Pessoal", GYs = "Ocultar link do perfil da equipe", WYs = "Ocultar o link do perfil da equipe nas páginas de agendamento", HYs = "Exibir", YYs = "Não foi possível encontrar o slug para publicar a organização", KYs = "Lista de seleção", ZYs = "Mais cancelamentos", XYs = "Idioma da interface", JYs = "Defina seu idioma preferido para a interface de agendamento", QYs = "Idioma do navegador do visitante", eKs = "Nome ou e-mail", tKs = "Se nenhum contato for encontrado, recorrer ao proprietário do lead, se existir", nKs = "Compra de créditos falhou. Tente novamente ou entre em contato com o suporte.", oKs = "Mínimo de 50 créditos necessários", rKs = "Ativar credencial de delegação", iKs = "Conceda ao Cal.com acesso automático aos calendários de todos os membros da organização ativando a credencial de delegação.", aKs = "Desativar credencial de delegação", sKs = "Uma vez que a credencial de delegação for desativada, os membros da organização que não conectaram seus calendários precisarão fazê-lo manualmente.", cKs = "Último ativo", lKs = "Membro desde", uKs = "Última atualização", dKs = "Ao cancelar a reserva, escrever no registro do evento em vez de excluí-lo", _Ks = "Em cada cancelamento", pKs = "Reportar problema", mKs = "Você pode enviar um ticket no GitHub ou fazer upgrade do seu plano para receber suporte em tempo real com conferências de desenvolvedores", fKs = "Abrir problema", gKs = "Este é seu plano atual", hKs = "Agendar um horário", vKs = "Isso inclui:", bKs = "Cliente OAuth atualizado com sucesso", yKs = "Cliente OAuth não encontrado.", $Ks = "Assinar a plataforma", wKs = "Erro ao tentar acessar webhooks.", kKs = "Falha ao atualizar webhook.", SKs = "Falha ao criar webhook.", EKs = "Link inválido", xKs = "Você está atualmente inscrito no plano {{planFirstLetter}}{{planRest}}", CKs = "Usuário/Equipe", TKs = "ID do cliente copiado!", AKs = "Segredo do cliente copiado!", IKs = "A equipe do Cal.com está realizando manutenção programada. Se você tiver alguma dúvida, entre em contato com o suporte.", OKs = "Seu pagamento falhou", NKs = "Verifique sua caixa de entrada", zKs = "Sua conta foi criada, mas seu premium não foi reservado.", RKs = "Enviamos um e-mail para {{email}} com um link para ativar sua conta.", PKs = "Depois de ativar sua conta, você poderá tentar comprar seu nome de usuário premium novamente ou selecionar um diferente.", DKs = "Abrir no Gmail", LKs = "Não recebeu um e-mail?", MKs = "Reenviar em {{seconds}} segundos", FKs = "Reenviar", qKs = "E-mail de verificação enviado", jKs = "Selecionar todos os membros", VKs = "Selecionar todos os membros adicionará todos os futuros membros da equipe quando eles forem adicionados à equipe.", BKs = "Configurações do formulário", UKs = "Remover status de lista branca", GKs = "Adicionar fluxos de trabalho do usuário à lista branca", WKs = "Fluxos de trabalho do usuário adicionados à lista branca", HKs = "Fluxos de trabalho do usuário removidos da lista branca", YKs = "Data e horário", KKs = "Este é um lembrete sobre seu próximo evento.", ZKs = "Este lembrete foi acionado por um Workflow no Cal.", XKs = "Evento", JKs = "Agendado por", QKs = "Como foi sua experiência recente?", eZs = "Sempre buscamos melhorar a experiência do cliente.", tZs = "Quão satisfeito você está com sua última reunião?", nZs = "não participou da reunião?", oZs = "Reagende aqui.", rZs = "Ocultar e-mail do organizador", iZs = "Você já faz parte de uma organização de plataforma, por isso não pode criar uma nova organização. Cada usuário só pode pertencer a uma organização. Por favor, crie uma nova conta cal.com com um e-mail diferente e use essa conta para assinar o plano de organizações.", aZs = "Você já faz parte de uma organização, por isso não pode criar uma organização de plataforma. Cada usuário só pode pertencer a uma organização. Por favor, crie uma nova conta cal.com com um e-mail diferente e use essa conta para assinar o plano de plataforma.", sZs = "Ocultar o endereço de e-mail do organizador na tela de agendamento, notificações por e-mail e eventos do calendário", cZs = "Você &", lZs = "Selecione um e-mail verificado", uZs = "Adicionar e-mail verificado", dZs = "Adicionar e-mails verificados", _Zs = "E-mail personalizado para 'Responder a'", pZs = "Use um endereço de e-mail diferente como resposta para e-mails de confirmação em vez do e-mail do organizador", mZs = "Esta pesquisa foi acionada por um Workflow no Cal.", fZs = "Pular período de teste", gZs = "Períodos de teste da equipe pulados com sucesso", hZs = "Ao inserir seu número de telefone, você consente em receber mensagens SMS para este evento. Tarifas de SMS podem ser aplicadas.", vZs = "Mais informações podem ser encontradas em <0>Insights de Roteamento</0>", bZs = "Resultados", yZs = "Visualizar formulário", $Zs = "Envie STOP para cancelar o recebimento de mensagens SMS", wZs = "Sua equipe {{teamName}} está com poucos créditos", kZs = "Você está com poucos créditos", SZs = "[Ação necessária] Sua equipe {{teamName}} ficou sem créditos", EZs = "[Ação necessária] Você ficou sem créditos", xZs = "Sua equipe Cal.com {{teamName}} está com poucos créditos. Para evitar qualquer interrupção no serviço, compre créditos adicionais. Se seu saldo acabar, as mensagens SMS deixarão de ser enviadas e serão enviadas como e-mails.", CZs = "Sua conta Cal.com está com poucos créditos. Para evitar qualquer interrupção no serviço, compre créditos adicionais. Se seu saldo acabar, as mensagens SMS deixarão de ser enviadas e serão enviadas como e-mails.", TZs = "Sua equipe Cal.com {{teamName}} ficou sem créditos. Como resultado, as mensagens SMS agora estão sendo enviadas por e-mail. Para retomar o envio de SMS, compre créditos adicionais.", AZs = "Sua conta Cal.com ficou sem créditos. Como resultado, as mensagens SMS agora estão sendo enviadas por e-mail. Para retomar o envio de SMS, adquira créditos adicionais.", IZs = "Saldo atual: {{balance}} créditos", OZs = "Saldo atual:", NZs = "Notificação sobre seu agendamento", zZs = "Créditos mensais", RZs = "Total de créditos: {{totalCredits}}", PZs = "Créditos restantes: {{remainingCredits}}", DZs = "Restante", LZs = "Total", MZs = "Créditos adicionais", FZs = "{{count}} próximo na fila", qZs = "Enviar respostas por e-mail para", jZs = "Agendamentos incompletos", VZs = "Incluir agendamentos não comparecidos nos cálculos de round robin", BZs = "Participantes recentes que não compareceram", UZs = "Mostra reservas onde todos os participantes não compareceram, não ausências parciais", GZs = "Correspondência", WZs = "Redirecionamento de evento", HZs = "Redefinir formulário", YZs = "Configurações de Round Robin atualizadas com sucesso", KZs = "Base de distribuição para Round Robin ponderado", ZZs = "Determina qual timestamp do evento é usado como base para a distribuição ponderada do round robin.", XZs = "Requer créditos", JZs = "Você precisa ter créditos suficientes em sua conta para usar este recurso", QZs = "Créditos disponíveis", eXs = "Criar função", tXs = "Funções e permissões", nXs = "Gerencie funções e permissões para sua organização", oXs = "Saiba mais sobre como as permissões funcionam", rXs = "Nome da função", iXs = "Nome da função é obrigatório", aXs = "ex. Equipe de vendas, Equipe de suporte", sXs = "Descrição da função", cXs = "Descreva para que serve esta função e quais permissões ela precisa", lXs = "Função padrão", uXs = "Função personalizada", dXs = "Avançado", _Xs = "Buscar permissões", pXs = "Todas as permissões", mXs = "Nenhum", fXs = "Somente leitura", gXs = "Todas as ações em todos os recursos", hXs = "Todos os recursos", vXs = "Tipos de eventos", bXs = "Times", yXs = "Organização", $Xs = "Reservas", wXs = "Insights", kXs = "Funções", SXs = "Formulários de Roteamento", EXs = "Fluxos de trabalho", xXs = "Todas as ações", CXs = "Criar", TXs = "Visualizar", AXs = "Editar", IXs = "Excluir", OXs = "Gerenciar", NXs = "Convidar", zXs = "Remover", RXs = "Alterar função do membro", PXs = "Listar membros", DXs = "Gerenciar faturamento", LXs = "Visualizar reservas da equipe", MXs = "Visualizar reservas da organização", FXs = "Ver Gravações", qXs = "Representar", jXs = "Função criada com sucesso", VXs = "Função atualizada com sucesso", BXs = "Excluir função", UXs = "Tem certeza que deseja excluir a função: {{roleName}}? Esta ação não pode ser desfeita.", GXs = "Função excluída com sucesso", WXs = "Erro ao criar função", HXs = "Erro ao atualizar função", YXs = "Criar funções", KXs = "Atributos", ZXs = "Visualizar atributos da organização", XXs = "Atualizar atributos da organização", JXs = "Excluir atributos da organização", QXs = "Criar atributos da organização", eJs = "Ver funções", tJs = "Atualizar funções", nJs = "Excluir funções", oJs = "Criar e configurar novos fluxos de trabalho", rJs = "Configuração necessária", iJs = "Visualizar fluxos de trabalho existentes e suas configurações", aJs = "Editar e modificar configurações de fluxo de trabalho", sJs = "Remover fluxos de trabalho do sistema", cJs = "Webhook", lJs = "Disponibilidade", uJs = "Ausente", dJs = "Criar webhooks", _Js = "Visualizar webhooks", pJs = "Atualizar webhooks", mJs = "Excluir webhooks", fJs = "Criar disponibilidade", gJs = "Visualizar disponibilidade", hJs = "Atualizar disponibilidade", vJs = "Excluir disponibilidade", bJs = "Criar ausência", yJs = "Visualizar ausência", $Js = "Atualizar ausência", wJs = "Excluir ausência", kJs = "Acesso completo de gerenciamento a todos os fluxos de trabalho", SJs = "Criar tipos de eventos", EJs = "Ver tipos de eventos", xJs = "Atualizar tipos de eventos", CJs = "Excluir tipos de eventos", TJs = "Todas as ações em tipos de eventos", AJs = "Criar equipes", IJs = "Ver detalhes da equipe", OJs = "Atualizar configurações da equipe", NJs = "Excluir equipe", zJs = "Convidar membros para a equipe", RJs = "Remover membros da equipe", PJs = "Alterar função dos membros da equipe", DJs = "Representar membros da equipe", LJs = "Todas as ações em equipes entre as equipes da organização", MJs = "Criar organização", FJs = "Ver detalhes da organização", qJs = "Listar membros da organização", jJs = "Convidar membros para a organização", VJs = "Remover membros da organização", BJs = "Gerenciar faturamento da organização", UJs = "Alterar função dos membros da organização", GJs = "Representar membros da organização", WJs = "Editar configurações da organização", HJs = "Todas as ações em organizações", YJs = "Ver reservas", KJs = "Ver reservas da equipe", ZJs = "Ver reservas da organização", XJs = "Ver gravações de reservas", JJs = "Atualizar reservas", QJs = "Todas as ações em reservas", eQs = "Ver insights da equipe", tQs = "Gerenciar insights da equipe", nQs = "Criar formulários de roteamento", oQs = "Visualizar formulários de roteamento", rQs = "Atualizar formulários de roteamento", iQs = "Excluir formulários de roteamento", aQs = "A permissão de leitura é ativada automaticamente ao criar, atualizar ou excluir um recurso", sQs = "Adicionar agenda de restrição", cQs = "Limite a disponibilidade dos anfitriões para exibir apenas horários que se enquadrem em um cronograma específico.", lQs = "Usar fuso horário do agendador", uQs = "Aplicar a agenda de restrição selecionada no fuso horário do agendador", dQs = "Isso desativará o Balanceamento de Carga em todos os seus tipos de eventos round robin", _Qs = "O Balanceamento de Carga só está disponível quando a base de timestamp está definida como Hora de Criação da Reserva", pQs = "O balanceamento de carga não está disponível com Grupos Round Robin", mQs = "Personalize as configurações padrão de rodízio para esta equipe", fQs = "Configurações de rodízio atualizadas com sucesso", gQs = "Horário de criação do agendamento", hQs = "Horário de início da reunião", vQs = "Membros afetados", bQs = "Nenhum membro afetado pela desativação da credencial de delegação", yQs = "Baixar registro de despesas", $Qs = "Erro ao baixar registro de despesas", wQs = "Oferecer reagendamento da última reserva ativa para o horário escolhido", kQs = "Limite máximo de reservas ativas do agendador excedido", SQs = "Você já tem uma reserva para este evento em {{date}}. Gostaria de reagendar para o novo horário selecionado?", EQs = "A duração deve ser de pelo menos {{min}} minuto(s)", xQs = "A duração não pode exceder {{max}} minutos (24 horas)", CQs = "Reserva fora da disponibilidade do cronograma de restrição.", TQs = "Cronograma de restrição não encontrado", AQs = "Limite de tamanho da imagem excedido, por favor use uma imagem menor preferencialmente em formato JPEG", IQs = "Adicionar grupo", OQs = "Funil de Roteamento", NQs = "Total de Envios", zQs = "Roteamentos Bem-sucedidos", RQs = "Reservas Aceitas", PQs = "Chave de licença", DQs = "Escolha sua licença", LQs = "Selecione como você deseja licenciar sua implantação do Cal.com", MQs = "Use o Cal.com sob a licença de código aberto AGPLv3", FQs = "Inserir chave de licença", qQs = "Acesso a todos os recursos empresariais", jQs = "A partir de $15/usuário por mês", VQs = "Acesso a todos os recursos empresariais", BQs = "Insira sua chave de licença", UQs = "Salvar chave de licença", GQs = "Token de assinatura (opcional)", WQs = "O token de assinatura é usado para verificar se a chave de licença é sua ao incrementar o faturamento baseado em uso. Você pode encontrá-lo no e-mail de confirmação de compra. Se você estiver usando uma licença legada, pode deixar este campo em branco.", HQs = "Precisa de uma licença?", YQs = "A chave de licença é obrigatória", KQs = "Chave de licença inválida", ZQs = "Falha ao validar a chave de licença", XQs = "Anexos Opcionais", JQs = "Enviar Mensagem", QQs = "Descreva o problema", eec = "Tamanho do arquivo excede o limite", tec = "Tipo de arquivo inválido", nec = "Tipo de arquivo inválido. Tipos aceitos: {{acceptedTypes}}", oec = "Número máximo de arquivos excedido", rec = "Arquivos enviados com sucesso", iec = "Tipos aceitos: {{acceptedTypes}}; Tamanho máximo do arquivo: {{maxSize}}", aec = "Chave de licença salva com sucesso", sec = "Você está visualizando o relatório com base no fuso horário do seu perfil ({{userTimezone}}), enquanto seu navegador está configurado para o fuso horário ({{browserTimezone}})", cec = "Horários otimizados", lec = "Organize os horários para otimizar a disponibilidade.", uec = "Reservas Falhas por Campo", dec = "Reservas com falha", _ec = "Nenhum anfitrião está atribuído ao tipo de evento", pec = "Status do Cache", mec = "Última atualização: {{timestamp}}", fec = "Excluir dados em cache", gec = "Cache excluído com sucesso", hec = "Erro ao excluir cache", vec = "Tem certeza de que deseja excluir os dados em cache? Esta ação não pode ser desfeita.", bec = "Sim, excluir cache", yec = "{{remainder}} de {{maximum}} usos restantes", $ec = "{{remainder}} de {{maximum}} uso restante", wec = "Expira em {{date}}, final do dia", kec = "Uso único", Sec = "Expiração baseada em tempo", Eec = "Expiração baseada em uso", xec = "Número de usos", Cec = "Expira em", Tec = "Número máximo de usos", Aec = "Configurações do link", Iec = "Este link expirou em {{date}}, final do dia", Oec = "Limite de uso atingido", Nec = "O número máximo de usos deve ser maior que o uso atual", zec = "Este link expirou", Rec = "Este link pode ser usado para agendamentos até o final de {{date}}", Pec = "Este link pode ser configurado para expirar após uma data definida", Dec = "Este link pode ser usado para {{count}} agendamento", Lec = "Este link pode ser configurado para expirar após um número definido de agendamentos", Mec = "Este link pode ser usado para {{count}} agendamentos", Fec = "O nome do evento de gatilho (ex.: BOOKING_CREATED, BOOKING_CANCELLED)", qec = "O horário do webhook", jec = "O slug do tipo de evento", Vec = "Configurar Agente", Bec = "O nome do tipo de evento", Uec = "O horário de início do evento", Gec = "O horário de término do evento", Wec = "A descrição do evento conforme descrito nas configurações do tipo de evento", Hec = "Local do evento", Yec = "O UID da reserva", Kec = "O UID para reagendamento", Zec = "Motivo do cancelamento", Xec = "Motivo da recusa", Jec = "Nome do organizador", Qec = "Email do organizador", etc = "Fuso horário do organizador (ex.: 'America/New_York', 'Asia/Kolkata')", ttc = "Idioma do organizador (ex.: 'en', 'fr')", ntc = "Nome de usuário do organizador (ex.: 'john.doe')", otc = "Nome de usuário do organizador na organização (ex.: 'john.doe')", rtc = "Nome do primeiro participante", itc = "Email do primeiro participante", atc = "Fuso horário do primeiro participante", stc = "Idioma do primeiro participante", ctc = "Nome da equipe reservada", ltc = "Membros da equipe reservada", utc = "URL da videochamada para a reunião", dtc = "Ocultar variáveis", _tc = "Mostrar variáveis disponíveis", ptc = "Evento e reserva", mtc = "Pessoas", ftc = "Times", gtc = "Metadados", htc = "Estatísticas", vtc = "Status da reserva", btc = "Visitar", ytc = "Rótulo personalizado na página de reserva", $tc = "Link da reunião", wtc = "Resultado da Sessão", ktc = "Chamada Criada", Stc = "Correio de Voz", Etc = "Minhas reservas", xtc = "Telefone", Ctc = "Grátis", Ttc = "E-mail do usuário", Atc = "Nome do usuário", Itc = "Expandir painel", Otc = "Recolher painel", Ntc = "A verificação de e-mail é necessária para este tipo de evento", ztc = "Código de verificação fornecido é inválido", Rtc = "Você tem uma equipe", Ptc = "Considere configurar uma organização para unificar faturamento, ferramentas administrativas e análises em sua equipe.", Dtc = "Considere configurar uma organização para unificar faturamento, ferramentas administrativas e análises em suas equipes.", Ltc = "Mensagem enviada", Mtc = "Obrigado por entrar em contato conosco. Responderemos o mais breve possível.", Ftc = "Pesquisar variáveis", qtc = "Por favor, descreva o problema que você está enfrentando, por exemplo, 'Horários ocupados estão marcados como disponíveis', ..., etc.", jtc = "Enviar outra mensagem", Vtc = "Enviando", Btc = "Nenhuma variável encontrada", Utc = "Créditos necessários", Gtc = "Chamadas web consomem créditos. Certifique-se de ter créditos suficientes para iniciar uma chamada.", Wtc = "Chamadas web requerem créditos. Você tem 0 créditos restantes.", Htc = "Comprar créditos", Ytc = "Esta ação requer créditos para prosseguir", Ktc = "O nome não deve exceder {{max}} caracteres", Ztc = "Cobrar automaticamente taxa de não comparecimento para cancelamentos de última hora", Xtc = "Antes do horário de início agendado", Jtc = "Reconheço que, ao cancelar a reserva dentro de {{timeValue}} {{timeUnit}} antes do horário de início, serei cobrado pela taxa de não comparecimento de {{amount, currency}}", Qtc = "Se você tiver alguma dúvida, entre em contato com o organizador.", enc = "Horário da reserva", tnc = "Quando a reserva está agendada (início ao fim)", nnc = "Criado em", onc = "Quando a reserva foi originalmente criada", rnc = "Detalhes da Chamada", inc = "ID da Chamada", anc = "Informações da Chamada", snc = "Sentimento", cnc = "Motivo da Desconexão", lnc = "Resumo da Chamada", unc = "Transcrição", dnc = "Detalhes do Evento", _nc = "Agente", pnc = "Nenhuma transcrição disponível", mnc = "Ao testar este fluxo de trabalho, esteja ciente de que as mensagens SMS precisam ser agendadas com pelo menos 15 minutos de antecedência", fnc = "Começar do zero", gnc = "Crie seu próprio fluxo de trabalho do zero.", hnc = "Modelo Cal.ai", vnc = "Agentes de IA que agendam reuniões, enviam lembretes e fazem acompanhamento!", bnc = "Voz", ync = "Selecionar voz", $nc = "Selecione uma voz para seu agente", wnc = "Escolha uma voz para seu agente", knc = "Característica", Snc = "ID da voz", Enc = "Usar voz", xnc = "Voz atual", Cnc = "Configurar agente de entrada", Tnc = "Configure um agente de IA para atender chamadas recebidas em seu número de telefone", Anc = "Conecte um número de telefone primeiro", Inc = "Configurar agente para chamadas recebidas", Onc = "Configurar agente para atender chamadas recebidas", Nnc = "Chamadas recebidas", znc = "Chamadas realizadas", Rnc = "Configuração do agente de entrada bem-sucedida", Pnc = "Agente de entrada configurado", Dnc = "Configurar agente de entrada", Lnc = "Por favor, selecione um tipo de evento primeiro", Mnc = "Editar configuração", Fnc = "Chamadas recebidas podem agendar apenas um tipo de evento. Selecione o tipo de evento onde as reuniões serão agendadas quando os chamadores alcançarem seu agente.", qnc = "Configurar agente de entrada para chamadas recebidas", jnc = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Adicione suas novas strings aqui em cima ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", Vnc = {
  identity_provider: VXa,
  trial_days_left: BXa,
  day_one: UXa,
  day_other: GXa,
  second_one: WXa,
  second_other: HXa,
  upgrade_now: YXa,
  untitled: KXa,
  accept_invitation: ZXa,
  max_characters: XXa,
  min_characters: JXa,
  calcom_explained: QXa,
  calcom_explained_new_user: eJa,
  have_any_questions: tJa,
  reset_password_subject: nJa,
  verify_email_subject: oJa,
  verify_email_subject_verifying_email: rJa,
  check_your_email: iJa,
  old_email_address: aJa,
  new_email_address: sJa,
  verify_email_page_body: cJa,
  verify_email_banner_body: lJa,
  verify_email_email_header: uJa,
  verify_email_button: dJa,
  cal_ai_assistant: _Ja,
  send_cal_video_transcription_emails: pJa,
  description_send_cal_video_transcription_emails: mJa,
  verify_email_change_description: fJa,
  verify_email_change_success_toast: gJa,
  verify_email_change_failure_toast: hJa,
  change_of_email: vJa,
  change_of_email_toast: bJa,
  copy_somewhere_safe: yJa,
  verify_email_email_body: $Ja,
  verify_email_by_code_email_body: wJa,
  verify_email_email_link_text: kJa,
  email_verification_code: SJa,
  email_verification_code_placeholder: EJa,
  incorrect_email_verification_code: xJa,
  email_sent: CJa,
  email_not_sent: TJa,
  event_declined_subject: AJa,
  event_cancelled_subject: IJa,
  event_reassigned_subject: OJa,
  event_request_declined: NJa,
  customize_calvideo_settings: zJa,
  calvideo_settings_description: RJa,
  disable_recording_for_guests: PJa,
  enable_automatic_transcription: DJa,
  enable_automatic_recording: LJa,
  video_options: MJa,
  edit_event: FJa,
  view_session_details: qJa,
  meeting_session_details: jJa,
  meeting_session: VJa,
  session_id: BJa,
  max_participants: UJa,
  unlimited: GJa,
  ongoing: WJa,
  ended: HJa,
  participants: YJa,
  anonymous_user: KJa,
  session_duration: ZJa,
  no_meeting_sessions_found: XJa,
  not_available: JJa,
  disable_recording_for_organizer: QJa,
  disable_transcription_for_guests: eQa,
  disable_transcription_for_organizer: tQa,
  event_request_declined_recurring: nQa,
  event_request_cancelled: oQa,
  event_request_reassigned: rQa,
  event_reassigned_subtitle: iQa,
  organizer: aQa,
  reassigned_to: sQa,
  need_to_reschedule_or_cancel: cQa,
  you_can_view_booking_details_with_this_url: lQa,
  no_options_available: uQa,
  cancellation_reason: dQa,
  cancelled_by: _Qa,
  cancellation_reason_host: pQa,
  cancellation_reason_placeholder: mQa,
  notify_attendee_cancellation_reason_warning: fQa,
  rejection_reason_placeholder: gQa,
  rejection_reason: hQa,
  rejection_reason_title: vQa,
  rejection_reason_description: bQa,
  rejection_confirmation: yQa,
  manage_this_event: $Qa,
  invite_team_member: wQa,
  invite_team_individual_segment: kQa,
  invite_team_bulk_segment: SQa,
  invite_team_notifcation_badge: EQa,
  your_event_has_been_scheduled: xQa,
  your_event_has_been_scheduled_recurring: CQa,
  accept_our_license: TQa,
  remove_banner_instructions: AQa,
  error_message: IQa,
  refund_failed_subject: OQa,
  refund_failed: NQa,
  check_with_provider_and_user: zQa,
  a_refund_failed: RQa,
  awaiting_payment_subject: PQa,
  meeting_awaiting_payment: DQa,
  dark_theme_contrast_error: LQa,
  light_theme_contrast_error: MQa,
  event_type_color_light_theme_contrast_error: FQa,
  event_type_color_dark_theme_contrast_error: qQa,
  payment_not_created_error: jQa,
  couldnt_charge_card_error: VQa,
  no_available_users_found_error: BQa,
  timeslot_unavailable_book_a_new_time: UQa,
  timeslot_unavailable_short: GQa,
  just_connected_description: WQa,
  unavailable_timeslot_title: HQa,
  booking_time_out_of_bounds_error: YQa,
  request_body_end_time_internal_error: KQa,
  create_calendar_event_error: ZQa,
  update_calendar_event_error: XQa,
  delete_calendar_event_error: JQa,
  already_signed_up_for_this_booking_error: QQa,
  hosts_unavailable_for_booking: ees,
  fixed_hosts_unavailable_for_booking: tes,
  round_robin_host_unavailable_for_booking: nes,
  help: oes,
  price: res,
  paid: ies,
  refunded: aes,
  record: ses,
  transcribe: ces,
  payment: les,
  missing_card_fields: ues,
  pay_now: des,
  general_prompt: _es,
  transcription_powered_by_ai: pes,
  start_or_stop_recording: mes,
  begin_message: fes,
  codebase_has_to_stay_opensource: ges,
  cannot_repackage_codebase: hes,
  acquire_license: ves,
  terms_summary: bes,
  open_env: yes,
  env_changed: $es,
  accept_license: wes,
  still_waiting_for_approval: kes,
  event_is_still_waiting: Ses,
  no_result_found_for: Ees,
  no_more_results: xes,
  no_results: Ces,
  load_more_results: Tes,
  integration_meeting_id: Aes,
  confirmed_event_type_subject: Ies,
  new_event_request: Oes,
  confirm_or_reject_request: Nes,
  check_bookings_page_to_confirm_or_reject: zes,
  check_in_assistant: Res,
  check_in_assistant_description: Pes,
  create_your_own_prompt: Des,
  event_awaiting_approval: Les,
  event_awaiting_approval_recurring: Mes,
  someone_requested_an_event: Fes,
  someone_requested_password_reset: qes,
  password_reset_email_sent: jes,
  password_reset_instructions: Ves,
  event_awaiting_approval_subject: Bes,
  event_still_awaiting_approval: Ues,
  booking_submitted_subject: Ges,
  download_recording_subject: Wes,
  download_transcript_email_subject: Hes,
  download_your_recording: Yes,
  download_your_transcripts: Kes,
  your_meeting_has_been_booked: Zes,
  event_type_has_been_rescheduled_on_time_date: Xes,
  event_type_has_been_updated: Jes,
  event_has_been_rescheduled: Qes,
  event_has_been_updated: ets,
  your_event_has_been_rescheduled: tts,
  request_reschedule_subtitle: nts,
  request_reschedule_title_organizer: ots,
  request_reschedule_subtitle_organizer: rts,
  rescheduled_event_type_subject: its,
  requested_to_reschedule_subject_attendee: ats,
  hi_user_name: sts,
  ics_event_title: cts,
  please_book_a_time_sometime_later: lts,
  schedule_instead: uts,
  new_event_subject: dts,
  join_by_entrypoint: _ts,
  notes: pts,
  manage_my_bookings: mts,
  need_to_make_a_change: fts,
  new_event_scheduled: gts,
  new_event_scheduled_recurring: hts,
  invitee_email: vts,
  invitee_timezone: bts,
  time_left: yts,
  event_type: $ts,
  duplicate_event_type: wts,
  enter_meeting: kts,
  video_call_provider: Sts,
  meeting_id: Ets,
  meeting_password: xts,
  meeting_url: Cts,
  meeting_url_not_found: Tts,
  token_not_found: Ats,
  some_other_host_already_accepted_the_meeting: Its,
  meeting_request_rejected: Ots,
  rejected_event_type_with_organizer: Nts,
  hi: zts,
  join_team: Rts,
  manage_this_team: Pts,
  team_info: Dts,
  join_meeting: Lts,
  request_another_invitation_email: Mts,
  you_have_been_invited: Fts,
  user_invited_you: qts,
  hidden_team_member_title: jts,
  hidden_team_member_message: Vts,
  hidden_team_owner_message: Bts,
  link_expires: Uts,
  upgrade_to_per_seat: Gts,
  seat_options_doesnt_support_confirmation: Wts,
  multilocation_doesnt_support_seats: Hts,
  no_show_fee_doesnt_support_seats: Yts,
  seats_option_doesnt_support_multi_location: Kts,
  team_upgrade_seats_details: Zts,
  team_upgrade_banner_description: Xts,
  upgrade_banner_action: Jts,
  team_upgraded_successfully: Qts,
  org_upgrade_banner_description: ens,
  org_upgraded_successfully: tns,
  use_link_to_reset_password: nns,
  hey_there: ons,
  there: rns,
  forgot_your_password_calcom: ins,
  delete_webhook_confirmation_message: ans,
  confirm_delete_webhook: sns,
  edit_webhook: cns,
  delete_webhook: lns,
  webhook_status: uns,
  webhook_enabled: dns,
  webhook_disabled: _ns,
  webhook_response: pns,
  webhook_test: mns,
  webhook_update_form: fns,
  webhook_update_form_description: gns,
  manage_your_webhook: hns,
  webhook_created_successfully: vns,
  webhook_updated_successfully: bns,
  webhook_removed_successfully: yns,
  subscription_needed: $ns,
  subscription_needed_description: wns,
  payload_template: kns,
  dismiss: Sns,
  no_data_yet: Ens,
  ping_test: xns,
  add_to_homescreen: Cns,
  upcoming: Tns,
  recurring: Ans,
  past: Ins,
  choose_a_file: Ons,
  upload_image: Nns,
  upload_target: zns,
  no_target: Rns,
  slide_zoom_drag_instructions: Pns,
  view_notifications: Dns,
  view_public_page: Lns,
  copy_public_page_link: Mns,
  copy_referral_link: Fns,
  sign_out: qns,
  add_another: jns,
  install_another: Vns,
  until: Bns,
  powered_by: Uns,
  unavailable: Gns,
  set_work_schedule: Wns,
  change_bookings_availability: Hns,
  select: Yns,
  "2fa_confirm_current_password": "Insira a sua senha atual para começar.",
  "2fa_scan_image_or_use_code": "Digitalize a imagem abaixo com o aplicativo autenticador no seu telefone, ou insira o código manualmente.",
  text: Kns,
  your_phone_number: Zns,
  multiline_text: Xns,
  number: Jns,
  checkbox: Qns,
  is_required: eos,
  make_field_required: tos,
  required: nos,
  optional: oos,
  input_type: ros,
  rejected: ios,
  unconfirmed: aos,
  guests: sos,
  guest: cos,
  web_conferencing_details_to_follow: los,
  confirmation: uos,
  what_booker_should_provide: dos,
  "404_the_user": "O nome de usuário",
  username: _os,
  is_still_available: pos,
  documentation: mos,
  documentation_description: fos,
  api_reference: gos,
  api_reference_description: hos,
  blog: vos,
  blog_description: bos,
  join_our_community: yos,
  "404_claim_entity_user": "Obtenha o seu nome de usuário e agende eventos",
  popular_pages: $os,
  register_now: wos,
  register: kos,
  page_doesnt_exist: Sos,
  no_active_phone_number_available: Eos,
  workflow_step_not_configured: xos,
  check_spelling_mistakes_or_go_back: Cos,
  "404_page_not_found": "404: Não foi possível encontrar esta página.",
  booker_event_not_found: Tos,
  getting_started: Aos,
  "15min_meeting": "Reunião de 15 min",
  "30min_meeting": "Reunião de 30 min",
  secret: Ios,
  leave_blank_to_remove_secret: Oos,
  webhook_secret_key_description: Nos,
  secret_meeting: zos,
  login_instead: Ros,
  create_account: Pos,
  get_started: Dos,
  confirm_password: Los,
  reset_your_password: Mos,
  org_banner_instructions: Fos,
  email_change: qos,
  create_your_account: jos,
  create_your_calcom_account: Vos,
  sign_up: Bos,
  youve_been_logged_out: Uos,
  hope_to_see_you_soon: Gos,
  logged_out: Wos,
  please_try_again_and_contact_us: Hos,
  incorrect_2fa_code: Yos,
  no_account_exists: Kos,
  "2fa_enabled_instructions": "A autenticação de dois fatores está ativada. Por favor, insira o código de seis dígitos do seu aplicativo autenticador.",
  "2fa_enter_six_digit_code": "Insira abaixo o código de seis dígitos do seu aplicativo autenticador.",
  create_an_account: Zos,
  dont_have_an_account: Xos,
  "2fa_code": "Código de dois fatores",
  sign_in_account: Jos,
  sign_in: Qos,
  go_back_login: ers,
  error_during_login: trs,
  request_password_reset: nrs,
  send_invite: ors,
  forgot_password: rrs,
  forgot: irs,
  done: ars,
  all_done: srs,
  all: crs,
  yours: lrs,
  available_apps: urs,
  available_apps_lower_case: drs,
  available_apps_desc: _rs,
  fixed_host_helper: prs,
  round_robin_groups_helper: mrs,
  round_robin_helper: frs,
  check_email_reset_password: grs,
  finish: hrs,
  organization_general_description: vrs,
  few_sentences_about_yourself: brs,
  nearly_there: yrs,
  nearly_there_instructions: $rs,
  set_availability_instructions: wrs,
  set_availability: krs,
  set_availbility_description: Srs,
  share_a_link_or_embed: Ers,
  share_a_link_or_embed_description: xrs,
  availability_settings: Crs,
  continue_without_calendar: Trs,
  continue_with: Ars,
  connect_your_calendar: Irs,
  connect_your_video_app: Ors,
  connect_your_video_app_instructions: Nrs,
  connect_your_calendar_instructions: zrs,
  set_up_later: Rrs,
  current_time: Prs,
  details: Drs,
  welcome: Lrs,
  welcome_back: Mrs,
  welcome_to_calcom: Frs,
  welcome_instructions: qrs,
  connect_caldav: jrs,
  connect_ics_feed: Vrs,
  connect: Brs,
  try_for_free: Urs,
  create_booking_link_with_calcom: Grs,
  who: Wrs,
  what: Hrs,
  when: Yrs,
  where: Krs,
  add_to_calendar: Zrs,
  add_to_calendar_description: Xrs,
  add_events_to: Jrs,
  add_another_calendar: Qrs,
  other: eis,
  email_sign_in_subject: tis,
  round_robin_emailed_you_and_attendees: nis,
  round_robin_emailed_host_and_attendee: ois,
  emailed_host_and_attendee: ris,
  emailed_host_and_attendee_recurring: iis,
  round_robin_emailed_you_and_attendees_recurring: ais,
  round_robin_emailed_host_and_attendee_recurring: sis,
  emailed_you_and_any_other_attendees: cis,
  needs_to_be_confirmed_or_rejected: lis,
  needs_to_be_confirmed_or_rejected_recurring: uis,
  user_needs_to_confirm_or_reject_booking: dis,
  user_needs_to_confirm_or_reject_booking_recurring: _is,
  meeting_is_scheduled: pis,
  meeting_is_scheduled_recurring: mis,
  booking_submitted: fis,
  booking_submitted_recurring: gis,
  booking_confirmed: his,
  booking_confirmed_recurring: vis,
  warning_recurring_event_payment: bis,
  warning_payment_recurring_event: yis,
  enter_new_password: $is,
  reset_password: wis,
  change_your_password: kis,
  show_password: Sis,
  hide_password: Eis,
  try_again: xis,
  request_is_expired: Cis,
  reset_instructions: Tis,
  request_is_expired_instructions: Ais,
  whoops: Iis,
  login: Ois,
  success: Nis,
  failed: zis,
  password_has_been_reset_login: Ris,
  layout: Pis,
  bookerlayout_default_title: Dis,
  bookerlayout_description: Lis,
  bookerlayout_user_settings_title: Mis,
  bookerlayout_user_settings_description: Fis,
  bookerlayout_month_view: qis,
  bookerlayout_week_view: jis,
  bookerlayout_column_view: Vis,
  bookerlayout_error_min_one_enabled: Bis,
  bookerlayout_error_default_not_enabled: Uis,
  bookerlayout_error_unknown_layout: Gis,
  bookerlayout_override_global_settings: Wis,
  unexpected_error_try_again: His,
  sunday_time_error: Yis,
  monday_time_error: Kis,
  tuesday_time_error: Zis,
  wednesday_time_error: Xis,
  thursday_time_error: Jis,
  friday_time_error: Qis,
  saturday_time_error: eas,
  error_end_time_before_start_time: tas,
  error_end_time_next_day: nas,
  back_to_bookings: oas,
  free_to_pick_another_event_type: ras,
  cancelled: ias,
  no_booking: aas,
  awaiting_host: sas,
  cancellation_successful: cas,
  really_cancel_booking: las,
  cannot_cancel_booking: uas,
  reschedule_instead: das,
  event_is_in_the_past: _as,
  cancelling_event_recurring: pas,
  cancelling_all_recurring: mas,
  error_with_status_code_occured: fas,
  error_event_type_url_duplicate: gas,
  error_event_type_unauthorized_create: has,
  error_event_type_unauthorized_update: vas,
  error_workflow_unauthorized_create: bas,
  error_schedule_unauthorized_create: yas,
  booking_already_cancelled: $as,
  booking_already_accepted_rejected: was,
  go_back_home: kas,
  or_go_back_home: Sas,
  no_meeting_found: Eas,
  no_meeting_found_description: xas,
  no_status_bookings_yet: Cas,
  no_status_bookings_yet_description: Tas,
  event_between_users: Aas,
  bookings: Ias,
  booking_not_found: Oas,
  bookings_description: Nas,
  upcoming_bookings: zas,
  recurring_bookings: Ras,
  past_bookings: Pas,
  cancelled_bookings: Das,
  unconfirmed_bookings: Las,
  unconfirmed_bookings_tooltip: Mas,
  on: Fas,
  and: qas,
  calendar_shows_busy_between: jas,
  troubleshoot: Vas,
  troubleshoot_description: Bas,
  overview_of_day: Uas,
  hover_over_bold_times_tip: Gas,
  start_time: Was,
  end_time: Has,
  buffer_time: Yas,
  before_event: Kas,
  after_event: Zas,
  event_buffer_default: Xas,
  buffer: Jas,
  your_day_starts_at: Qas,
  your_day_ends_at: ess,
  launch_troubleshooter: tss,
  troubleshoot_availability: nss,
  change_available_times: oss,
  change_your_available_times: rss,
  change_start_end: iss,
  change_start_end_buffer: ass,
  current_start_date: sss,
  start_end_changed_successfully: css,
  and_end_at: lss,
  light: uss,
  dark: dss,
  automatically_adjust_theme: _ss,
  user_dynamic_booking_disabled: pss,
  allow_dynamic_booking_tooltip: mss,
  allow_dynamic_booking: fss,
  dynamic_booking: gss,
  allow_seo_indexing: hss,
  seo_indexing: vss,
  allow_browser_notifications: bss,
  you_have_denied_notifications: yss,
  disable_browser_notifications: $ss,
  browser_notifications_turned_on: wss,
  browser_notifications_turned_off: kss,
  browser_notifications_denied: Sss,
  please_allow_notifications: Ess,
  push_notifications: xss,
  push_notifications_description: Css,
  browser_notifications_not_supported: Tss,
  email: Ass,
  email_placeholder: Iss,
  full_name: Oss,
  browse_api_documentation: Nss,
  leverage_our_api: zss,
  create_webhook: Rss,
  instant_meeting: Pss,
  booking_cancelled: Dss,
  booking_rescheduled: Lss,
  recording_ready: Mss,
  recording_transcription_generated: Fss,
  booking_created: qss,
  booking_rejected: jss,
  booking_requested: Vss,
  booking_payment_initiated: Bss,
  meeting_ended: Uss,
  form_submitted: Gss,
  form_submitted_no_event: Wss,
  booking_paid: Hss,
  ooo_created: Yss,
  booking_no_show_updated: Kss,
  event_triggers: Zss,
  subscriber_url: Xss,
  create_new_webhook: Jss,
  webhooks: Qss,
  team_webhooks: ecs,
  create_new_webhook_to_account: tcs,
  new_webhook: ncs,
  receive_cal_meeting_data: ocs,
  receive_cal_event_meeting_data: rcs,
  responsive_fullscreen_iframe: ics,
  loading: acs,
  deleting: scs,
  standard_iframe: ccs,
  developer: lcs,
  manage_developer_settings: ucs,
  iframe_embed: dcs,
  embed_calcom: _cs,
  integrate_using_embed_or_webhooks: pcs,
  schedule_a_meeting: mcs,
  view_and_manage_billing_details: fcs,
  view_and_edit_billing_details: gcs,
  go_to_billing_portal: hcs,
  need_anything_else: vcs,
  further_billing_help: bcs,
  contact: ycs,
  our_support_team: $cs,
  contact_our_support_team: wcs,
  uh_oh: kcs,
  no_event_types_have_been_setup: Scs,
  edit_logo: Ecs,
  upload_a_logo: xcs,
  upload_logo: Ccs,
  remove_logo: Tcs,
  enable: Acs,
  code: Ics,
  code_is_incorrect: Ocs,
  add_time_availability: Ncs,
  add_an_extra_layer_of_security: zcs,
  "2fa": "Autenticação de dois fatores",
  "2fa_disabled": "A autenticação de dois fatores pode ser habilitada para autenticação de senha e e-mail",
  enable_2fa: Rcs,
  disable_2fa: Pcs,
  disable_2fa_recommendation: Dcs,
  error_disabling_2fa: Lcs,
  error_enabling_2fa: Mcs,
  security: Fcs,
  manage_account_security: qcs,
  password: jcs,
  password_updated_successfully: Vcs,
  password_has_been_changed: Bcs,
  error_changing_password: Ucs,
  session_timeout_changed: Gcs,
  session_timeout_change_error: Wcs,
  something_went_wrong: Hcs,
  something_doesnt_look_right: Ycs,
  please_try_again: Kcs,
  super_secure_new_password: Zcs,
  new_password: Xcs,
  your_old_password: Jcs,
  current_password: Qcs,
  change_password: els,
  change_secret: tls,
  new_password_matches_old_password: nls,
  forgotten_secret_description: ols,
  current_incorrect_password: rls,
  password_hint_caplow: ils,
  password_hint_min: als,
  password_hint_admin_min: sls,
  password_hint_num: cls,
  max_limit_allowed_hint: lls,
  invalid_password_hint: uls,
  incorrect_password: dls,
  incorrect_email_password: _ls,
  use_setting: pls,
  am_pm: mls,
  time_options: fls,
  january: gls,
  february: hls,
  march: vls,
  april: bls,
  may: yls,
  june: $ls,
  july: wls,
  august: kls,
  september: Sls,
  october: Els,
  november: xls,
  december: Cls,
  monday: Tls,
  tuesday: Als,
  wednesday: Ils,
  thursday: Ols,
  friday: Nls,
  saturday: zls,
  sunday: Rls,
  all_booked_today: Pls,
  slots_load_fail: Dls,
  additional_guests: Lls,
  your_name: Mls,
  your_full_name: Fls,
  no_name: qls,
  enter_number_between_range: jls,
  continue_as_guest_description: Vls,
  email_address: Bls,
  enter_valid_email: Uls,
  please_schedule_future_call: Gls,
  location: Wls,
  address: Hls,
  enter_address: Yls,
  in_person_attendee_address: Kls,
  somewhere_else: Zls,
  custom_attendee_location: Xls,
  continue_as_guest: Jls,
  join_as_guest: Qls,
  ideal_for_one_time_calls: eus,
  any_location: tus,
  yes: nus,
  no: ous,
  additional_notes: rus,
  booking_fail: ius,
  reschedule_fail: aus,
  share_additional_notes: sus,
  booking_confirmation: cus,
  booking_reschedule_confirmation: lus,
  in_person_meeting: uus,
  in_person: dus,
  link_meeting: _us,
  phone_number: pus,
  attendee_phone_number: mus,
  organizer_phone_number: fus,
  enter_phone_number: gus,
  reschedule: hus,
  reschedule_this: vus,
  book_a_team_member: bus,
  or: yus,
  go_back: $us,
  email_or_username: wus,
  send_invite_email: kus,
  role: Sus,
  edit_role: Eus,
  view_role: xus,
  edit_team: Cus,
  editing_user: Tus,
  editing_org: Aus,
  edit_or_manage_webhooks: Ius,
  reject: Ous,
  reject_all: Nus,
  accept: zus,
  leave: Rus,
  profile: Pus,
  my_team_url: Dus,
  my_teams: Lus,
  team_name: Mus,
  your_team_name: Fus,
  team_updated_successfully: qus,
  your_team_updated_successfully: jus,
  your_org_updated_successfully: Vus,
  error_copying_to_clipboard: Bus,
  about: Uus,
  team_description: Gus,
  organization_id: Wus,
  organization_id_copied: Hus,
  org_description: Yus,
  team_id: Kus,
  team_id_copied: Zus,
  members: Xus,
  organization_members: Jus,
  member: Qus,
  number_member_one: eds,
  number_member_other: tds,
  number_selected: nds,
  owner: ods,
  admin: rds,
  admin_api: ids,
  administrator_user: ads,
  lets_create_first_administrator_user: sds,
  admin_user_created: cds,
  admin_user_created_description: lds,
  new_member: uds,
  invite: dds,
  add_team_members: _ds,
  add_org_members: pds,
  add_team_members_description: mds,
  add_team_member: fds,
  invite_new_member: gds,
  invite_new_member_description: hds,
  invite_new_team_member: vds,
  upload_csv_file: bds,
  invite_via_email: yds,
  change_member_role: $ds,
  disable_cal_branding: wds,
  disable_cal_branding_description: kds,
  hide_book_a_team_member: Sds,
  hide_book_a_team_member_description: Eds,
  danger_zone: xds,
  account_deletion_cannot_be_undone: Cds,
  team_deletion_cannot_be_undone: Tds,
  back: Ads,
  cancel: Ids,
  cancel_all_remaining: Ods,
  apply: Nds,
  cancel_event: zds,
  continue: "Continuar",
  confirm: Rds,
  confirm_all: Pds,
  disband_team: Dds,
  disband_team_confirmation_message: Lds,
  disband_org: Mds,
  disband_org_confirmation_message: Fds,
  remove_member_confirmation_message: qds,
  confirm_disband_team: jds,
  confirm_remove_member: Vds,
  confirm_subscription_cancellation: Bds,
  cancel_subscription: Uds,
  cancel_subscription_description: Gds,
  remove_member: Wds,
  manage_your_team: Hds,
  no_teams: Yds,
  no_teams_description: Kds,
  submit: Zds,
  confirm_remove_attribute: Xds,
  remove_attribute: Jds,
  remove_attribute_confirmation_message: Qds,
  delete: "Apagar",
  update: e_s,
  save: t_s,
  pending: n_s,
  open_options: o_s,
  copy_link: r_s,
  share: i_s,
  share_event: a_s,
  copy_link_team: s_s,
  leave_team: c_s,
  confirm_leave_team: l_s,
  leave_team_confirmation_message: u_s,
  user_from_team: d_s,
  preview: __s,
  link_copied: p_s,
  copied: m_s,
  private_link_copied: f_s,
  link_shared: g_s,
  title: h_s,
  description: v_s,
  apps_status: b_s,
  quick_video_meeting: y_s,
  scheduling_type: $_s,
  preview_team: w_s,
  collective: k_s,
  collective_description: S_s,
  duration: E_s,
  available_durations: x_s,
  default_duration: C_s,
  default_duration_no_options: T_s,
  multiple_duration_mins: A_s,
  multiple_duration_timeUnit: I_s,
  multiple_duration_timeUnit_short: O_s,
  minutes: N_s,
  use_cal_ai_to_make_call_description: z_s,
  termination_uri: R_s,
  sip_trunk_username: P_s,
  sip_trunk_password: D_s,
  nickname: L_s,
  delete_phone_number: M_s,
  workflow_validation_failed: F_s,
  workflow_validation_empty_fields: q_s,
  workflow_validation_unverified_contacts: j_s,
  supercharge_your_workflows_with_cal_ai: V_s,
  supercharge_your_workflows_with_cal_ai_description: B_s,
  phone_number_imported_successfully: U_s,
  phone_number_deleted_successfully: G_s,
  delete_phone_number_confirmation: W_s,
  yes_delete_phone_number: H_s,
  phone_number_info_tooltip: Y_s,
  termination_uri_info_tooltip: K_s,
  sip_trunk_username_info_tooltip: Z_s,
  sip_trunk_password_info_tooltip: X_s,
  nickname_info_tooltip: J_s,
  save_and_test_call: Q_s,
  call_initiated_successfully: eps,
  please_enter_phone_number: tps,
  agent_updated_successfully: nps,
  agent_created_successfully: ops,
  agent_event_type_updated_successfully: rps,
  phone_number_unsubscribed_successfully: ips,
  general_prompt_description: aps,
  prompt: sps,
  call_to: cps,
  make_test_call_to_verify_configuration: lps,
  initial_message: ups,
  initial_message_description: dps,
  having_trouble_importing: _ps,
  learn: pps,
  learn_how_to_get_your_terminator: mps,
  phone_number_subscription_cancelled_successfully: fps,
  updating: gps,
  round_robin: hps,
  hi_how_are_you_doing: vps,
  round_robin_description: bps,
  managed_event: yps,
  username_placeholder: $ps,
  managed_event_description: wps,
  managed: kps,
  managed_event_url_clarification: Sps,
  assign_to: Eps,
  enter_phone_number_to_test_call: xps,
  make_test_call: Cps,
  create_new_workflow_agent: Tps,
  create_new_workflow_agent_description: Aps,
  phone_number_for_ai_call: Ips,
  buy_a_phone_number_or_import_one_you_already_have: Ops,
  test_agent: Nps,
  test_web_call: zps,
  phone_numbers: Rps,
  unsubscribe: Pps,
  delete_workflow_step: Dps,
  unsubscribe_phone_number: Lps,
  buy_a_new_number: Mps,
  only_us_phone_numbers_can_be_purchased_here: Fps,
  buy_number_for_x_per_month: qps,
  supported_call_destinations: jps,
  no_phone_number_connected: Vps,
  failed_to_get_workflow_step_id: Bps,
  cal_ai_agent: Ups,
  test_cal_ai_agent: Gps,
  are_you_sure_you_want_to_delete_workflow_step: Wps,
  do_you_still_want_to_unsubscribe: Hps,
  the_action_will_disconnect_phone_number: Yps,
  cal_ai_phone_numbers: Kps,
  connect_phone_number: Zps,
  cal_ai_phone_numbers_description: Xps,
  import_number: Jps,
  this_action_will_also: Qps,
  import_phone_number: ems,
  active_subscription: tms,
  cancel_your_phone_number_subscription: nms,
  delete_associated_phone_number: oms,
  unauthorized_create_workflow: rms,
  import_phone_number_description: ims,
  phone_number_cost: ams,
  buy_new_number: sms,
  buy_number_cost_x_per_month: cms,
  area_code_optional: lms,
  no_phone_numbers: ums,
  phone_number_purchased_successfully: dms,
  cancel_phone_number_subscription: _ms,
  yes_cancel_subscription: pms,
  cancel_phone_number_subscription_confirmation: mms,
  add_members: fms,
  add_members_no_ellipsis: gms,
  no_assigned_members: hms,
  assigned_to: vms,
  you_must_be_logged_in_to: bms,
  start_assigning_members_above: yms,
  locked_fields_admin_description: $ms,
  unlocked_fields_admin_description: wms,
  locked_fields_member_description: kms,
  unlocked_fields_member_description: Sms,
  url: Ems,
  hidden: xms,
  readonly: Cms,
  one_time_link: Tms,
  plan_description: Ams,
  plan_upgrade_invitation: Ims,
  plan_upgrade: Oms,
  plan_upgrade_teams: Nms,
  plan_upgrade_instructions: zms,
  event_types_page_title: Rms,
  event_types_page_subtitle: Pms,
  new: "Novo",
  new_event_type_btn: Dms,
  new_event_type_heading: Lms,
  new_event_type_description: Mms,
  event_type_created_successfully: Fms,
  event_type_updated_successfully: qms,
  event_type_deleted_successfully: jms,
  hours: Vms,
  people: Bms,
  your_email: Ums,
  change_avatar: Gms,
  upload_avatar: Wms,
  language: Hms,
  timezone: Yms,
  first_day_of_week: Kms,
  repeats_up_to_one: Zms,
  repeats_up_to_other: Xms,
  every_for_freq: Jms,
  event_remaining_one: Qms,
  event_remaining_other: efs,
  repeats_every: tfs,
  occurrence_one: nfs,
  occurrence_other: ofs,
  weekly_one: rfs,
  weekly_other: ifs,
  monthly_one: afs,
  monthly_other: sfs,
  yearly_one: cfs,
  yearly_other: lfs,
  plus_more: ufs,
  max: dfs,
  single_theme: _fs,
  brand_color: pfs,
  light_brand_color: mfs,
  dark_brand_color: ffs,
  light_event_type_color: gfs,
  dark_event_type_color: hfs,
  file_not_named: vfs,
  create_team: bfs,
  name: yfs,
  nameless_team: $fs,
  oauth_clients: wfs,
  oauth_clients_description: kfs,
  create_oauth_client: Sfs,
  create_oauth_client_description: Efs,
  oauth_client_deletion_message: xfs,
  create_new_team_description: Cfs,
  create_new_team: Tfs,
  booking_redirect_uri: Afs,
  booking_cancel_redirect_uri: Ifs,
  booking_reschedule_redirect_uri: Ofs,
  booking_conflict_error: Nfs,
  open_invitations: zfs,
  new_team: Rfs,
  create_first_team_and_invite_others: Pfs,
  create_team_to_get_started: Dfs,
  teams: Lfs,
  team: Mfs,
  organization: Ffs,
  team_billing: qfs,
  team_billing_description: jfs,
  upgrade_to_flexible_pro_title: Vfs,
  upgrade_to_flexible_pro_message: Bfs,
  changed_team_billing_info: Ufs,
  create_manage_teams_collaborative: Gfs,
  only_available_on_pro_plan: Wfs,
  remove_cal_branding_description: Hfs,
  edit_profile_info_description: Yfs,
  change_email_tip: Kfs,
  little_something_about: Zfs,
  profile_updated_successfully: Xfs,
  your_user_profile_updated_successfully: Jfs,
  your_upgrade_is_here: Qfs,
  your_upgrade_is_here_description: egs,
  you_are_all_set: tgs,
  you_are_all_set_description: ngs,
  user_cannot_found_db: ogs,
  embed_and_webhooks: rgs,
  enabled: igs,
  disabled: ags,
  disable: sgs,
  billing: cgs,
  here: lgs,
  manage_your_billing_info: ugs,
  availability: dgs,
  edit_availability: _gs,
  configure_availability: pgs,
  copy_times_to: mgs,
  copy_times_to_tooltip: fgs,
  change_weekly_schedule: ggs,
  logo: hgs,
  error: vgs,
  at_least_characters_one: bgs,
  at_least_characters_other: ygs,
  team_logo: $gs,
  add_location: wgs,
  attendees: kgs,
  add_attendees: Sgs,
  show_advanced_settings: Egs,
  hide_advanced_settings: xgs,
  event_name: Cgs,
  event_name_in_calendar: Tgs,
  event_name_tooltip: Ags,
  meeting_with_user: Igs,
  additional_inputs: Ogs,
  additional_input_description: Ngs,
  label: zgs,
  placeholder: Rgs,
  display_add_to_calendar_organizer: Pgs,
  display_email_as_organizer: Dgs,
  if_enabled_email_address_as_organizer: Lgs,
  reconnect_calendar_to_use: Mgs,
  type: Fgs,
  edit: qgs,
  add_input: jgs,
  disable_notes: Vgs,
  disable_notes_description: Bgs,
  requires_confirmation_description: Ugs,
  requires_confirmation_will_block_slot_description: Ggs,
  recurring_event: Wgs,
  recurring_event_description: Hgs,
  connect_and_join: Ygs,
  cannot_be_used_with_paid_event_types: Kgs,
  warning_payment_instant_meeting_event: Zgs,
  warning_instant_meeting_experimental: Xgs,
  starting: Jgs,
  disable_guests: Qgs,
  disable_guests_description: ehs,
  private_link: ths,
  enable_private_url: nhs,
  private_link_label: ohs,
  private_link_hint: rhs,
  copy_private_link: ihs,
  copy_private_link_to_event: ahs,
  private_link_description: shs,
  multiple_private_links_title: chs,
  multiple_private_links_description: lhs,
  add_a_multiple_private_link: uhs,
  multiple_private_link_copied: dhs,
  invitees_can_schedule: _hs,
  date_range: phs,
  calendar_days: mhs,
  business_days: fhs,
  set_address_place: ghs,
  set_link_meeting: hhs,
  managed_event_field_parent_control_disabled: vhs,
  cal_invitee_phone_number_scheduling: bhs,
  cal_provide_google_meet_location: yhs,
  cal_provide_zoom_meeting_url: $hs,
  cal_provide_tandem_meeting_url: whs,
  cal_provide_video_meeting_url: khs,
  cal_provide_jitsi_meeting_url: Shs,
  cal_provide_huddle01_meeting_url: Ehs,
  cal_provide_teams_meeting_url: xhs,
  require_payment: Chs,
  you_need_to_add_a_name: Ths,
  commission_per_transaction: Ahs,
  event_type_updated_successfully_description: Ihs,
  hide_event_type: Ohs,
  edit_location: Nhs,
  into_the_future: zhs,
  when_booked_with_less_than_notice: Rhs,
  within_date_range: Phs,
  indefinitely_into_future: Dhs,
  add_new_custom_input_field: Lhs,
  quick_chat: Mhs,
  add_new_team_event_type: Fhs,
  add_new_event_type: qhs,
  new_event_type_to_book_description: jhs,
  length: Vhs,
  minimum_booking_notice: Bhs,
  offset_toggle: Uhs,
  offset_toggle_description: Ghs,
  offset_start: Whs,
  offset_start_description: Hhs,
  slot_interval: Yhs,
  slot_interval_default: Khs,
  delete_event_type: Zhs,
  delete_managed_event_type: Xhs,
  delete_event_type_description: Jhs,
  delete_managed_event_type_description_1: Qhs,
  delete_managed_event_type_description_2: evs,
  confirm_delete_event_type: tvs,
  delete_account: nvs,
  confirm_delete_account: ovs,
  delete_account_confirmation_message: rvs,
  integrations: ivs,
  apps: avs,
  apps_description: svs,
  apps_listing: cvs,
  category_apps: lvs,
  app_store: uvs,
  app_store_description: dvs,
  connect_your_video: _vs,
  settings: pvs,
  event_type_moved_successfully: mvs,
  next_step_text: fvs,
  next_step: gvs,
  prev_step: hvs,
  install: vvs,
  start_paid_trial: bvs,
  installed: yvs,
  active_install_one: $vs,
  active_install_other: wvs,
  globally_install: kvs,
  app_successfully_installed: Svs,
  app_could_not_be_installed: Evs,
  disconnect: xvs,
  embed_your_calendar: Cvs,
  connect_your_favourite_apps: Tvs,
  automation: Avs,
  configure_how_your_event_types_interact: Ivs,
  toggle_calendars_conflict: Ovs,
  connect_additional_calendar: Nvs,
  calendar_updated_successfully: zvs,
  check_here: Rvs,
  conferencing: Pvs,
  calendar: Dvs,
  payments: Lvs,
  not_installed: Mvs,
  error_password_mismatch: Fvs,
  error_required_field: qvs,
  status: jvs,
  team_view_user_availability: Vvs,
  team_view_user_availability_disabled: Bvs,
  set_as_away: Uvs,
  set_as_free: Gvs,
  toggle_away_error: Wvs,
  user_away: Hvs,
  user_away_description: Yvs,
  meet_people_with_the_same_tokens: Kvs,
  only_book_people_and_allow: Zvs,
  account_created_with_identity_provider: Xvs,
  account_managed_by_identity_provider: Jvs,
  account_managed_by_identity_provider_description: Qvs,
  account_managed_by_identity_provider_error: ebs,
  user_creation_error: tbs,
  signin_with_google: nbs,
  signin_with_saml: obs,
  signin_with_saml_oidc: rbs,
  continue_with_email: ibs,
  continue_with_google: abs,
  last_used: sbs,
  you_will_need_to_generate: cbs,
  import: "Importar",
  import_from: lbs,
  access_token: ubs,
  visit_roadmap: dbs,
  featured_categories: _bs,
  feature_flags: pbs,
  admin_flags_description: mbs,
  popular_categories: fbs,
  number_apps_one: gbs,
  number_apps_other: hbs,
  trending_apps: vbs,
  most_popular: bbs,
  installed_apps: ybs,
  free_to_use_apps: $bs,
  no_category_apps: wbs,
  all_apps: kbs,
  no_category_apps_description_calendar: Sbs,
  no_category_apps_description_conferencing: Ebs,
  no_category_apps_description_payment: xbs,
  no_category_apps_description_analytics: Cbs,
  no_category_apps_description_automation: Tbs,
  no_category_apps_description_other: Abs,
  no_category_apps_description_messaging: Ibs,
  no_category_apps_description_crm: Obs,
  installed_app_calendar_description: Nbs,
  installed_app_payment_description: zbs,
  installed_app_analytics_description: Rbs,
  installed_app_other_description: Pbs,
  installed_app_conferencing_description: Dbs,
  installed_app_automation_description: Lbs,
  installed_app_messaging_description: Mbs,
  installed_app_crm_description: Fbs,
  analytics: qbs,
  empty_installed_apps_headline: jbs,
  empty_installed_apps_description: Vbs,
  empty_installed_apps_button: Bbs,
  manage_your_connected_apps: Ubs,
  browse_apps: Gbs,
  features: Wbs,
  permissions: Hbs,
  terms_and_privacy: Ybs,
  published_by: Kbs,
  subscribe: Zbs,
  buy: Xbs,
  install_app: Jbs,
  categories: Qbs,
  pricing: eys,
  learn_more: tys,
  try_now: nys,
  privacy_policy: oys,
  terms_of_service: rys,
  remove: iys,
  add: ays,
  installed_other: sys,
  verify_wallet: cys,
  create_events_on: lys,
  enterprise_license: uys,
  enterprise_license_locally: dys,
  enterprise_license_sales: _ys,
  missing_license: pys,
  next_steps: mys,
  acquire_commercial_license: fys,
  the_infrastructure_plan: gys,
  prisma_studio_tip: hys,
  prisma_studio_tip_description: vys,
  contact_sales: bys,
  error_404: yys,
  default: "Padrão",
  set_to_default: $ys,
  new_schedule_btn: wys,
  add_new_schedule: kys,
  add_new_calendar: Sys,
  set_calendar: Eys,
  delete_schedule: xys,
  delete_schedule_description: Cys,
  schedule_created_successfully: Tys,
  availability_updated_successfully: Ays,
  schedule_deleted_successfully: Iys,
  default_schedule_name: Oys,
  new_schedule_heading: Nys,
  new_schedule_description: zys,
  requires_ownership_of_a_token: Rys,
  example_name: Pys,
  time_format: Dys,
  "12_hour": "12 horas",
  "24_hour": "24 horas",
  "12_hour_short": "12h",
  "24_hour_short": "24h",
  redirect_success_booking: Lys,
  you_are_being_redirected: Mys,
  external_redirect_url: Fys,
  redirect_url_description: qys,
  duplicate: jys,
  offer_seats: Vys,
  offer_seats_description: Bys,
  seats_available_one: Uys,
  seats_available_other: Gys,
  seats_nearly_full: Wys,
  seats_half_full: Hys,
  number_of_seats: Yys,
  set_instant_meeting_expiry_time_offset_description: Kys,
  enter_number_of_seats: Zys,
  you_can_manage_your_schedules: Xys,
  booking_full: Jys,
  api_keys: Qys,
  api_key: e$s,
  test_api_key: t$s,
  test_passed: n$s,
  test_failed: o$s,
  provide_api_key: r$s,
  api_key_modal_subtitle: i$s,
  api_key_modal_subtitle_platform: a$s,
  api_keys_subtitle: s$s,
  create_api_key: c$s,
  personal_note: l$s,
  personal_note_placeholder: u$s,
  api_key_no_note: d$s,
  api_key_never_expires: _$s,
  edit_api_key: p$s,
  success_api_key_created: m$s,
  success_api_key_edited: f$s,
  create: g$s,
  success_api_key_created_bold_tagline: h$s,
  you_will_only_view_it_once: v$s,
  copy_to_clipboard: b$s,
  enabled_after_update: y$s,
  enabled_after_update_description: $$s,
  confirm_delete_api_key: w$s,
  disable_rescheduling: k$s,
  description_disable_rescheduling: S$s,
  allow_rescheduling_cancelled_bookings: E$s,
  description_allow_rescheduling_cancelled_bookings: x$s,
  disable_cancelling: C$s,
  description_disable_cancelling: T$s,
  revoke_api_key: A$s,
  api_key_copied: I$s,
  api_key_expires_on: O$s,
  delete_api_key_confirm_title: N$s,
  copy: z$s,
  expire_date: R$s,
  expired: P$s,
  never_expires: D$s,
  expires: L$s,
  request_reschedule_booking: M$s,
  reason_for_reschedule: F$s,
  book_a_new_time: q$s,
  reschedule_request_sent: j$s,
  reschedule_modal_description: V$s,
  reason_for_reschedule_request: B$s,
  send_reschedule_request: U$s,
  edit_booking: G$s,
  reschedule_booking: W$s,
  former_time: H$s,
  confirmation_page_gif: Y$s,
  search: K$s,
  impersonate: Z$s,
  user_impersonation_heading: X$s,
  user_impersonation_description: J$s,
  team_impersonation_description: Q$s,
  cal_signup_description: ews,
  make_org_private: tws,
  make_org_private_description: nws,
  make_team_private: ows,
  make_team_private_description: rws,
  you_cannot_see_team_members: iws,
  you_cannot_see_teams_of_org: aws,
  allow_multiple_durations: sws,
  impersonate_user_tip: cws,
  impersonating_user_warning: lws,
  impersonating_stop_instructions: uws,
  event_location_changed: dws,
  new_guests_added: _ws,
  location_changed_event_type_subject: pws,
  guests_added_event_type_subject: mws,
  current_location: fws,
  new_location: gws,
  session: hws,
  session_description: vws,
  session_timeout_after: bws,
  session_timeout: yws,
  session_timeout_description: $ws,
  no_location: wws,
  set_location: kws,
  update_location: Sws,
  location_updated: Ews,
  location_update_failed: xws,
  guests_added: Cws,
  unable_to_add_guests: Tws,
  email_validation_error: Aws,
  emails_must_be_unique_valid: Iws,
  url_validation_error: Ows,
  place_where_cal_widget_appear: Nws,
  create_update_react_component: zws,
  copy_code: Rws,
  code_copied: Pws,
  how_you_want_add_cal_site: Dws,
  choose_ways_put_cal_site: Lws,
  setting_up_zapier: Mws,
  setting_up_make: Fws,
  generate_api_key: qws,
  generate_api_key_description: jws,
  your_unique_api_key: Vws,
  copy_safe_api_key: Bws,
  zapier_setup_instructions: Uws,
  make_setup_instructions_1: Gws,
  make_setup_instructions_2: Wws,
  make_setup_instructions_3: Hws,
  make_setup_instructions_4: Yws,
  make_setup_instructions_5: Kws,
  make_setup_instructions_6: Zws,
  install_zapier_app: Xws,
  install_make_app: Jws,
  app_installation: Qws,
  app_not_installed: eks,
  visit_our_app_store: tks,
  connect_apple_server: nks,
  calendar_url: oks,
  apple_server_generate_password: rks,
  unable_to_add_apple_calendar: iks,
  credentials_stored_encrypted: aks,
  it_stored_encrypted: sks,
  go_to_app_store: cks,
  calendar_error: lks,
  set_your_phone_number: uks,
  calendar_no_busy_slots: dks,
  display_location_label: _ks,
  display_location_info_badge: pks,
  add_gif: mks,
  search_giphy: fks,
  add_link_from_giphy: gks,
  add_gif_to_confirmation: hks,
  find_gif_spice_confirmation: vks,
  share_feedback: bks,
  resources: yks,
  support_documentation: $ks,
  developer_documentation: wks,
  get_in_touch: kks,
  contact_support: Sks,
  premium_support: Eks,
  community_support: xks,
  feedback: Cks,
  submitted_feedback: Tks,
  feedback_error: Aks,
  comments: Iks,
  booking_details: Oks,
  or_lowercase: Nks,
  nevermind: zks,
  go_to: Rks,
  zapier_invite_link: Pks,
  meeting_url_provided_after_confirmed: Dks,
  dynamically_display_attendee_or_organizer: Lks,
  event_location: Mks,
  reschedule_optional: Fks,
  reschedule_placeholder: qks,
  event_cancelled: jks,
  emailed_information_about_cancelled_event: Vks,
  this_input_will_shown_booking_this_event: Bks,
  meeting_url_in_confirmation_email: Uks,
  url_start_with_https: Gks,
  number_provided: Wks,
  before_event_trigger: Hks,
  event_cancelled_trigger: Yks,
  after_hosts_cal_video_no_show: Kks,
  after_guests_cal_video_no_show: Zks,
  join_video_call: Xks,
  sign_in_to_cal_com: Jks,
  log_in_to_cal_com: Qks,
  track_your_meetings: e0s,
  track_meetings_and_manage_schedule: t0s,
  failed_to_join_call: n0s,
  choose_how_you_d_like_to_join_call: o0s,
  choose_how_you_d_like_to_appear_on_the_call: r0s,
  new_event_trigger: i0s,
  email_host_action: a0s,
  email_attendee_action: s0s,
  sms_attendee_action: c0s,
  sms_number_action: l0s,
  send_reminder_sms: u0s,
  whatsapp_number_action: d0s,
  whatsapp_attendee_action: _0s,
  workflows: p0s,
  new_workflow_btn: m0s,
  how_would_you_like_to_start: f0s,
  add_new_workflow: g0s,
  reschedule_event_trigger: h0s,
  trigger: v0s,
  triggers: b0s,
  action: y0s,
  workflows_to_automate_notifications: $0s,
  workflow_name: w0s,
  custom_workflow: k0s,
  workflow_created_successfully: S0s,
  delete_workflow_description: E0s,
  delete_workflow: x0s,
  confirm_delete_workflow: C0s,
  workflow_deleted_successfully: T0s,
  how_long_before: A0s,
  day_timeUnit: I0s,
  hour_timeUnit: O0s,
  minute_timeUnit: N0s,
  minute_short: z0s,
  hour_short: R0s,
  new_workflow_heading: P0s,
  new_workflow_description: D0s,
  active_on: L0s,
  workflow_updated_successfully: M0s,
  premium_to_standard_username_description: F0s,
  premium_username: q0s,
  current: j0s,
  premium: V0s,
  standard: B0s,
  confirm_username_change_dialog_title: U0s,
  change_username_standard_to_premium: G0s,
  change_username_premium_to_standard: W0s,
  go_to_stripe_billing: H0s,
  stripe_description: Y0s,
  trial_expired: K0s,
  remove_app: Z0s,
  yes_remove_app: X0s,
  are_you_sure_you_want_to_remove_this_app: J0s,
  app_removed_successfully: Q0s,
  error_removing_app: e1s,
  web_conference: t1s,
  web_call: n1s,
  start_web_call: o1s,
  end_call: r1s,
  test_your_agent_with_web_call: i1s,
  phone_call: a1s,
  connecting_to_agent: s1s,
  call_active: c1s,
  call_ended: l1s,
  call_error: u1s,
  ready_to_start_call: d1s,
  failed_to_start_web_call_try_again: _1s,
  call_encountered_error_try_again: p1s,
  failed_initialize_web_call_microphone_permissions: m1s,
  start_call_to_see_conversation: f1s,
  waiting_for_conversation: g1s,
  ai_agent: h1s,
  live: v1s,
  connecting: b1s,
  requires_confirmation: y1s,
  requires_confirmation_threshold: $1s,
  may_require_confirmation: w1s,
  nr_event_type_one: k1s,
  nr_event_type_other: S1s,
  count_team_one: E1s,
  count_team_other: x1s,
  add_action: C1s,
  set_whereby_link: T1s,
  invalid_whereby_link: A1s,
  set_around_link: I1s,
  invalid_around_link: O1s,
  set_riverside_link: N1s,
  invalid_riverside_link: z1s,
  invalid_ping_link: R1s,
  add_exchange2013: P1s,
  add_exchange2016: D1s,
  custom_template: L1s,
  email_body: M1s,
  text_message: F1s,
  specific_issue: q1s,
  browse_our_docs: j1s,
  choose_template: V1s,
  custom: B1s,
  reminder: U1s,
  rescheduled: G1s,
  rescheduled_by: W1s,
  original_booking: H1s,
  completed: Y1s,
  rating: K1s,
  reminder_email: Z1s,
  not_triggering_existing_bookings: X1s,
  minute_one: J1s,
  minute_one_short: Q1s,
  minute_other: eSs,
  hour_one: tSs,
  hour_one_short: nSs,
  hour_other: oSs,
  invalid_input: rSs,
  broken_video_action: iSs,
  broken_calendar_action: aSs,
  attendee_name: sSs,
  scheduler_full_name: cSs,
  broken_integration: lSs,
  problem_adding_video_link: uSs,
  problem_updating_calendar: dSs,
  active_on_event_types_one: _Ss,
  active_on_event_types_other: pSs,
  active_on_teams_one: mSs,
  active_on_teams_other: fSs,
  active_on_all_event_types: gSs,
  active_on_all_teams: hSs,
  no_active_event_types: vSs,
  no_active_teams: bSs,
  new_seat_subject: ySs,
  new_seat_title: $Ss,
  variable: wSs,
  event_name_variable: kSs,
  attendee_name_variable: SSs,
  event_date_variable: ESs,
  event_time_variable: xSs,
  organizer_name_variable: CSs,
  app_upgrade_description: TSs,
  invalid_number: ASs,
  invalid_url_error_message: ISs,
  navigate: OSs,
  open: NSs,
  close: zSs,
  upgrade: RSs,
  buy_us_number_button: PSs,
  upgrade_to_access_recordings_title: DSs,
  upgrade_to_access_recordings_description: LSs,
  upgrade_to_cal_ai_phone_number_description: MSs,
  recordings_are_part_of_the_teams_plan: FSs,
  team_feature_teams: qSs,
  team_feature_workflows: jSs,
  show_eventtype_on_profile: VSs,
  embed: BSs,
  new_username: USs,
  current_username: GSs,
  example_1: WSs,
  example_2: HSs,
  booking_question_identifier: YSs,
  company_size: KSs,
  what_help_needed: ZSs,
  variable_format: XSs,
  webhook_subscriber_url_reserved: JSs,
  custom_input_as_variable_info: QSs,
  using_booking_questions_as_variables: eEs,
  download_desktop_app: tEs,
  set_ping_link: nEs,
  rate_limit_exceeded: oEs,
  when_something_happens: rEs,
  action_is_performed: iEs,
  test_action: aEs,
  notification_sent: sEs,
  no_input: cEs,
  test_workflow_action: lEs,
  send_sms: uEs,
  send_sms_to_number: dEs,
  missing_connected_calendar: _Es,
  connect_your_calendar_and_link: pEs,
  default_calendar_selected: mEs,
  hide_from_profile: fEs,
  basics: gEs,
  availability_not_found_in_schedule_error: hEs,
  event_limit_tab_title: vEs,
  event_limit_tab_description: bEs,
  event_advanced_tab_description: yEs,
  event_advanced_tab_title: $Es,
  event_payments_tab_description: wEs,
  event_setup_multiple_duration_error: kEs,
  event_setup_multiple_duration_default_error: SEs,
  event_setup_booking_limits_error: EEs,
  event_setup_duration_limits_error: xEs,
  select_which_cal: CEs,
  custom_event_name: TEs,
  custom_event_name_description: AEs,
  "2fa_required": "Requer autenticação de dois fatores",
  incorrect_2fa: IEs,
  which_event_type_apply: OEs,
  apply_to_all_event_types: NEs,
  apply_to_all_teams: zEs,
  which_team_apply: REs,
  no_workflows_description: PEs,
  timeformat_profile_hint: DEs,
  create_workflow: LEs,
  do_this: MEs,
  turn_off: FEs,
  turn_on: qEs,
  cancelled_bookings_cannot_be_rescheduled: jEs,
  settings_updated_successfully: VEs,
  error_updating_settings: BEs,
  personal_cal_url: UEs,
  bio_hint: GEs,
  finish_and_start: WEs,
  user_has_no_bio: HEs,
  bio: YEs,
  delete_account_modal_title: KEs,
  confirm_delete_account_modal: ZEs,
  delete_my_account: XEs,
  start_of_week: JEs,
  recordings_title: QEs,
  recording: exs,
  happy_scheduling: txs,
  select_calendars: nxs,
  check_for_conflicts: oxs,
  view_recordings: rxs,
  check_for_recordings: ixs,
  adding_events_to: axs,
  follow_system_preferences: sxs,
  custom_brand_colors: cxs,
  customize_your_brand_colors: lxs,
  pro: uxs,
  removes_cal_branding: dxs,
  instant_meeting_with_title: _xs,
  profile_picture: pxs,
  upload: mxs,
  add_profile_photo: fxs,
  token_address: gxs,
  blockchain: hxs,
  old_password: vxs,
  secure_password: bxs,
  error_updating_password: yxs,
  two_factor_auth: $xs,
  recurring_event_tab_description: wxs,
  today: kxs,
  appearance: Sxs,
  my_account: Exs,
  general: xxs,
  calendars: Cxs,
  "2fa_auth": "Autenticação de dois fatores",
  invoices: Txs,
  embeds: Axs,
  impersonation: Ixs,
  impersonation_description: Oxs,
  recent_impersonations: Nxs,
  quick_impersonate: zxs,
  no_recent_impersonations: Rxs,
  users: Pxs,
  user: Dxs,
  profile_description: Lxs,
  users_description: Mxs,
  users_listing: Fxs,
  general_description: qxs,
  calendars_description: jxs,
  appearance_description: Vxs,
  conferencing_description: Bxs,
  add_conferencing_app: Uxs,
  password_description: Gxs,
  set_up_two_factor_authentication: Wxs,
  we_just_need_basic_info: Hxs,
  skip: Yxs,
  do_this_later: Kxs,
  set_availability_getting_started_subtitle_1: Zxs,
  set_availability_getting_started_subtitle_2: Xxs,
  connect_calendar_first: Jxs,
  complete_profile: Qxs,
  connect_calendars_from_app_store: eCs,
  connect_conference_apps: tCs,
  connect_calendar_apps: nCs,
  connect_payment_apps: oCs,
  connect_automation_apps: rCs,
  connect_analytics_apps: iCs,
  connect_other_apps: aCs,
  connect_messaging_apps: sCs,
  connect_crm_apps: cCs,
  current_step_of_total: lCs,
  add_variable: uCs,
  custom_phone_number: dCs,
  message_template: _Cs,
  email_subject: pCs,
  add_dynamic_variables: mCs,
  event_name_info: fCs,
  event_date_info: gCs,
  event_duration_info: hCs,
  event_time_info: vCs,
  event_type_not_found: bCs,
  number_to_call_variable: yCs,
  number_to_call_info: $Cs,
  location_variable: wCs,
  location_info: kCs,
  additional_notes_variable: SCs,
  additional_notes_info: ECs,
  attendee_name_info: xCs,
  organizer_name_info: CCs,
  to: TCs,
  workflow_turned_on_successfully: ACs,
  download_responses: ICs,
  download_responses_description: OCs,
  view_responses: NCs,
  download: zCs,
  downloading: RCs,
  download_recording: PCs,
  transcription_enabled: DCs,
  transcription_stopped: LCs,
  download_transcript: MCs,
  transcript: FCs,
  recording_from_your_recent_call: qCs,
  transcript_from_previous_call: jCs,
  you_can_download_transcript_from_attachments: VCs,
  link_valid_for_12_hrs: BCs,
  link_valid_for_12_hrs_description: UCs,
  create_your_first_form: GCs,
  create_your_first_form_description: WCs,
  create_your_first_webhook: HCs,
  create_your_first_webhook_description: YCs,
  for_a_maximum_of: KCs,
  event_one: ZCs,
  event_other: XCs,
  profile_team_description: JCs,
  profile_org_description: QCs,
  members_team_description: eTs,
  organization_description: tTs,
  team_url: nTs,
  team_members: oTs,
  more: rTs,
  cal_ai_workflows: iTs,
  and_count_more: aTs,
  more_page_footer: sTs,
  workflow_example_1: cTs,
  workflow_example_2: lTs,
  workflow_example_3: uTs,
  workflow_example_4: dTs,
  workflow_example_5: _Ts,
  workflow_example_6: pTs,
  send_sms_reminder: mTs,
  send_sms_reminder_description: fTs,
  follow_up_with_no_shows: gTs,
  follow_up_with_no_shows_description: hTs,
  remind_attendees_to_bring_id: vTs,
  remind_attendees_to_bring_id_description: bTs,
  email_to_remind_booking: yTs,
  email_to_remind_booking_description: $Ts,
  custom_sms_reminder: wTs,
  custom_sms_reminder_description: kTs,
  custom_email_reminder: STs,
  custom_email_reminder_description: ETs,
  count_managed_to_limit: xTs,
  welcome_to_cal_header: CTs,
  edit_form_later_subtitle: TTs,
  connect_calendar_later: ATs,
  problem_saving_user_profile: ITs,
  purchase_missing_seats: OTs,
  slot_length: NTs,
  booking_appearance: zTs,
  appearance_team_description: RTs,
  appearance_org_description: PTs,
  only_owner_change: DTs,
  team_disable_cal_branding_description: LTs,
  invited_by_team: MTs,
  token_invalid_expired: FTs,
  view_booking: qTs,
  exchange_add: jTs,
  exchange_authentication: VTs,
  exchange_authentication_standard: BTs,
  exchange_authentication_ntlm: UTs,
  exchange_compression: GTs,
  exchange_version: WTs,
  exchange_version_2007_SP1: HTs,
  exchange_version_2010: YTs,
  exchange_version_2010_SP1: KTs,
  exchange_version_2010_SP2: ZTs,
  exchange_version_2013: XTs,
  exchange_version_2013_SP1: JTs,
  exchange_version_2015: QTs,
  exchange_version_2016: eAs,
  routing: tAs,
  routing_forms_description: nAs,
  routing_forms_send_email_owner: oAs,
  routing_forms_send_email_owner_description: rAs,
  routing_forms_send_email_to: iAs,
  add_new_form: aAs,
  add_new_team_form: sAs,
  create_your_first_route: cAs,
  route_to_the_right_person: lAs,
  form: uAs,
  form_description: dAs,
  copy_link_to_form: _As,
  theme: pAs,
  theme_applies_note: mAs,
  app_theme: fAs,
  app_theme_applies_note: gAs,
  theme_system: hAs,
  add_a_team: vAs,
  add_webhook_description: bAs,
  triggers_when: yAs,
  test_webhook: $As,
  enable_webhook: wAs,
  add_webhook: kAs,
  webhook_edited_successfully: SAs,
  api_keys_description: EAs,
  new_api_key: xAs,
  active: CAs,
  api_key_updated: TAs,
  api_key_update_failed: AAs,
  embeds_title: IAs,
  embeds_description: OAs,
  create_first_api_key: NAs,
  create_first_api_key_description: zAs,
  back_to_signin: RAs,
  reset_link_sent: PAs,
  password_reset_email: DAs,
  password_reset_leading: LAs,
  password_updated: MAs,
  pending_payment: FAs,
  pending_invites: qAs,
  pending_organization_invites: jAs,
  not_on_cal: VAs,
  no_calendar_installed: BAs,
  no_calendar_installed_description: UAs,
  add_a_calendar: GAs,
  change_email_hint: WAs,
  confirm_password_change_email: HAs,
  seats: YAs,
  every_app_published: KAs,
  report_app: ZAs,
  limit_booking_frequency: XAs,
  limit_booking_frequency_description: JAs,
  only_show_first_available_slot: QAs,
  only_show_first_available_slot_description: e2s,
  limit_total_booking_duration: t2s,
  limit_total_booking_duration_description: n2s,
  booker_booking_limit: o2s,
  booker_booking_limit_description: r2s,
  recurring_event_doesnt_support_booker_booking_limit: i2s,
  add_limit: a2s,
  team_name_required: s2s,
  show_attendees: c2s,
  show_available_seats_count: l2s,
  how_booking_questions_as_variables: u2s,
  format: d2s,
  questions: _2s,
  all_info_your_booker_provide: p2s,
  uppercase_for_letters: m2s,
  replace_whitespaces_underscores: f2s,
  platform_members: g2s,
  platform_members_description: h2s,
  platform_billing: v2s,
  manage_billing: b2s,
  manage_billing_description: y2s,
  billing_freeplan_title: $2s,
  billing_freeplan_description: w2s,
  billing_freeplan_cta: k2s,
  billing_portal: S2s,
  billing_help_cta: E2s,
  ignore_special_characters_booking_questions: x2s,
  retry: C2s,
  fetching_calendars_error: T2s,
  calendar_connection_fail: A2s,
  booking_confirmation_success: I2s,
  booking_rejection_success: O2s,
  booking_tentative: N2s,
  booking_accept_intent: z2s,
  we_wont_show_again: R2s,
  couldnt_update_timezone: P2s,
  updated_timezone_to: D2s,
  update_timezone: L2s,
  update_timezone_question: M2s,
  update_timezone_description: F2s,
  dont_update: q2s,
  require_additional_notes: j2s,
  require_additional_notes_description: V2s,
  email_address_action: B2s,
  after_event_trigger: U2s,
  booking_rejected_trigger: G2s,
  booking_requested_trigger: W2s,
  booking_payment_initiated_trigger: H2s,
  booking_paid_trigger: Y2s,
  booking_no_show_updated_trigger: K2s,
  how_long_after: Z2s,
  how_long_after_hosts_no_show: X2s,
  how_long_after_guests_no_show: J2s,
  how_long_after_user_no_show_minutes: Q2s,
  no_available_slots: eIs,
  time_available: tIs,
  cant_find_the_right_conferencing_app_visit_our_app_store: nIs,
  install_new_calendar_app: oIs,
  make_phone_number_required: rIs,
  new_event_type_availability: iIs,
  error_editing_availability: aIs,
  dont_have_permission: sIs,
  saml_configuration_placeholder: cIs,
  saml_email_required: lIs,
  saml_sp_title: uIs,
  saml_sp_description: dIs,
  saml_sp_acs_url: _Is,
  saml_sp_entity_id: pIs,
  saml_sp_acs_url_copied: mIs,
  saml_sp_entity_id_copied: fIs,
  add_calendar: gIs,
  limit_future_bookings: hIs,
  limit_future_bookings_description: vIs,
  no_event_types: bIs,
  no_event_types_description: yIs,
  billing_frequency: $Is,
  monthly: wIs,
  yearly: kIs,
  checkout: SIs,
  your_team_disbanded_successfully: EIs,
  your_org_disbanded_successfully: xIs,
  error_creating_team: CIs,
  you: TIs,
  or_continue_with: AIs,
  resend_email: IIs,
  member_already_invited: OIs,
  already_in_use_error: NIs,
  enter_email_or_username: zIs,
  enter_email: RIs,
  enter_emails: PIs,
  too_many_invites: DIs,
  team_name_taken: LIs,
  must_enter_team_name: MIs,
  team_url_required: FIs,
  url_taken: qIs,
  problem_registering_domain: jIs,
  team_publish: VIs,
  number_text_notifications: BIs,
  number_sms_notifications: UIs,
  attendee_email_variable: GIs,
  attendee_email_info: WIs,
  booking_uid: HIs,
  kbar_search_placeholder: YIs,
  invalid_credential: KIs,
  invalid_credential_action: ZIs,
  reschedule_reason: XIs,
  choose_common_schedule_team_event: JIs,
  choose_common_schedule_team_event_description: QIs,
  reason: eOs,
  sender_id: tOs,
  sender_id_error_message: nOs,
  test_routing_form: oOs,
  test_preview: rOs,
  route_to: iOs,
  test_preview_description: aOs,
  test_routing: sOs,
  payment_app_disabled: cOs,
  edit_event_type: lOs,
  only_admin_can_see_members_of_org: uOs,
  only_admin_can_manage_sso_org: dOs,
  only_admin_can_manage_directory_sync: _Os,
  only_admin_can_manage_oauth_clients: pOs,
  collective_scheduling: mOs,
  make_it_easy_to_book: fOs,
  find_the_best_person: gOs,
  fixed_round_robin: hOs,
  add_one_fixed_attendee: vOs,
  calcom_is_better_with_team: bOs,
  the_calcom_team: yOs,
  add_your_team_members: $Os,
  booking_limit_reached: wOs,
  duration_limit_reached: kOs,
  admin_has_disabled: SOs,
  disable_attendees_emails_description: EOs,
  disabled_app_affects_event_type: xOs,
  event_replaced_notice: COs,
  email_subject_slug_replacement: TOs,
  email_body_slug_replacement_notice: AOs,
  email_body_slug_replacement_info: IOs,
  email_body_slug_replacement_suggestion: OOs,
  disable_payment_app: NOs,
  payment_disabled_still_able_to_book: zOs,
  app_disabled_with_event_type: ROs,
  app_disabled_video: POs,
  app_disabled_subject: DOs,
  navigate_installed_apps: LOs,
  disabled_calendar: MOs,
  enable_apps: FOs,
  enable_apps_description: qOs,
  purchase_license: jOs,
  already_have_account: VOs,
  already_have_key: BOs,
  already_have_key_suggestion: UOs,
  create_license_key: GOs,
  app_is_enabled: WOs,
  app_is_disabled: HOs,
  keys_have_been_saved: YOs,
  disable_app: KOs,
  disable_app_description: ZOs,
  edit_keys: XOs,
  admin_apps_description: JOs,
  admin_users_description: QOs,
  admin_users_add_description: eNs,
  admin_users_edit_description: tNs,
  admin_orgs_edit_description: nNs,
  admin_oAuth_description: oNs,
  admin_lockedSMS_description: rNs,
  no_available_apps: iNs,
  no_available_apps_description: aNs,
  no_apps: sNs,
  no_apps_configured: cNs,
  enable_in_settings: lNs,
  please_contact_admin: uNs,
  apps_settings: dNs,
  fill_this_field: _Ns,
  options: pNs,
  enter_option: mNs,
  add_an_option: fNs,
  location_already_exists: gNs,
  radio: hNs,
  google_meet_warning: vNs,
  individual: bNs,
  all_bookings_filter_label: yNs,
  all_users_filter_label: $Ns,
  all_event_types_filter_label: wNs,
  your_bookings_filter_label: kNs,
  meeting_url_variable: SNs,
  meeting_url_info: ENs,
  date_overrides: xNs,
  date_overrides_delete_on_date: CNs,
  date_overrides_subtitle: TNs,
  date_overrides_info: ANs,
  date_overrides_dialog_which_hours: INs,
  date_overrides_dialog_which_hours_unavailable: ONs,
  date_overrides_dialog_title: NNs,
  date_overrides_unavailable: zNs,
  date_overrides_mark_all_day_unavailable_one: RNs,
  date_overrides_mark_all_day_unavailable_other: PNs,
  date_overrides_update_btn: DNs,
  date_successfully_added: LNs,
  date_overrides_save_btn: MNs,
  event_type_duplicate_copy_text: FNs,
  set_as_default: qNs,
  hide_eventtype_details: jNs,
  show_navigation: VNs,
  hide_navigation: BNs,
  verification_code_sent: UNs,
  verified_successfully: GNs,
  wrong_code: WNs,
  not_verified: HNs,
  no_availability_in_month: YNs,
  no_availability_rolling: KNs,
  no_availability_range: ZNs,
  view_previous_month: XNs,
  view_next_month: JNs,
  send_code: QNs,
  number_verified: ezs,
  create_your_first_team_webhook_description: tzs,
  create_webhook_team_event_type: nzs,
  disable_success_page: ozs,
  invalid_admin_password: rzs,
  change_password_admin: izs,
  username_already_taken: azs,
  assignment: szs,
  fixed_hosts: czs,
  add_fixed_hosts: lzs,
  round_robin_hosts: uzs,
  minimum_round_robin_hosts_count: dzs,
  hosts: _zs,
  upgrade_to_enable_feature: pzs,
  orgs_upgrade_to_enable_feature: mzs,
  new_attendee: fzs,
  awaiting_approval: gzs,
  requires_google_calendar: hzs,
  event_type_requires_google_calendar: vzs,
  connected_google_calendar: bzs,
  using_meet_requires_calendar: yzs,
  continue_to_install_google_calendar: $zs,
  install_google_meet: wzs,
  install_google_calendar: kzs,
  sender_name: Szs,
  already_invited: Ezs,
  no_recordings_found: xzs,
  new_workflow_subtitle: Czs,
  reporting: Tzs,
  reporting_feature: Azs,
  teams_plan_required: Izs,
  routing_forms_are_a_great_way: Ozs,
  choose_a_license: Nzs,
  choose_license_description: zzs,
  license: Rzs,
  agplv3_license: Pzs,
  no_need_to_keep_your_code_open_source: Dzs,
  repackage_rebrand_resell: Lzs,
  a_vast_suite_of_enterprise_features: Mzs,
  free_license_fee: Fzs,
  forever_open_and_free: qzs,
  required_to_keep_your_code_open_source: jzs,
  cannot_repackage_and_resell: Vzs,
  no_enterprise_features: Bzs,
  step_enterprise_license: Uzs,
  step_enterprise_license_description: Gzs,
  setup: Wzs,
  setup_description: Hzs,
  configure: Yzs,
  sso_configuration: Kzs,
  sso_configuration_description: Zzs,
  sso_configuration_description_orgs: Xzs,
  sso_oidc_heading: Jzs,
  sso_oidc_description: Qzs,
  sso_oidc_configuration_title: eRs,
  sso_oidc_configuration_description: tRs,
  sso_oidc_callback_copied: nRs,
  sso_saml_heading: oRs,
  sso_saml_description: rRs,
  sso_saml_configuration_title: iRs,
  sso_saml_configuration_description: aRs,
  sso_saml_acsurl_copied: sRs,
  sso_saml_entityid_copied: cRs,
  sso_connection_created_successfully: lRs,
  sso_connection_deleted_successfully: uRs,
  delete_sso_configuration: dRs,
  delete_sso_configuration_confirmation: _Rs,
  delete_sso_configuration_confirmation_description: pRs,
  organizer_timezone: mRs,
  email_user_cta: fRs,
  accept_invite: gRs,
  join_now: hRs,
  successfully_joined: vRs,
  email_no_user_invite_heading_subteam: bRs,
  email_no_user_invite_heading_org: yRs,
  email_no_user_invite_subheading: $Rs,
  email_user_invite_subheading_subteam: wRs,
  email_user_invite_subheading_org: kRs,
  email_no_user_invite_steps_intro: SRs,
  email_no_user_step_one: ERs,
  email_no_user_step_two: xRs,
  email_no_user_step_three: CRs,
  email_no_user_step_four: TRs,
  email_no_user_signoff: ARs,
  impersonation_user_tip: IRs,
  available_variables: ORs,
  scheduler: NRs,
  no_workflows: zRs,
  change_filter: RRs,
  change_filter_common: PRs,
  no_results_for_filter: DRs,
  recommended_next_steps: LRs,
  create_a_managed_event: MRs,
  meetings_are_better_with_the_right: FRs,
  create_a_one_one_template: qRs,
  collective_or_roundrobin: jRs,
  book_your_team_members: VRs,
  event_no_longer_attending_subject: BRs,
  no_longer_attending: URs,
  attendee_no_longer_attending_subject: GRs,
  attendee_no_longer_attending: WRs,
  attendee_no_longer_attending_subtitle: HRs,
  create_event_on: YRs,
  create_routing_form_on: KRs,
  default_app_link_title: ZRs,
  default_app_link_description: XRs,
  organizer_default_conferencing_app: JRs,
  organizer_default_conferencing_app_not_found: QRs,
  under_maintenance: ePs,
  under_maintenance_description: tPs,
  event_type_seats: nPs,
  booking_questions_title: oPs,
  booking_questions_description: rPs,
  add_a_booking_question: iPs,
  identifier: aPs,
  duplicate_email: sPs,
  enter_redirect_url_on_exit_description: cPs,
  booking_with_payment_cancelled: lPs,
  booking_with_payment_cancelled_already_paid: uPs,
  booking_with_payment_cancelled_refunded: dPs,
  booking_with_payment_cancelled_no_refund: _Ps,
  booking_with_payment_cancelled_refund_window_expired: pPs,
  booking_confirmation_failed: mPs,
  not_enough_seats: fPs,
  form_builder_field_already_exists: gPs,
  guests_field_must_be_multiemail: hPs,
  show_on_booking_page: vPs,
  visit_cancelled_booking: bPs,
  get_started_zapier_templates: yPs,
  standard_templates: $Ps,
  cal_ai_templates: wPs,
  team_is_unpublished: kPs,
  org_is_unpublished_description: SPs,
  team_is_unpublished_description: EPs,
  team_member: xPs,
  a_routing_form: CPs,
  form_description_placeholder: TPs,
  keep_me_connected_with_form: APs,
  fields_in_form_duplicated: IPs,
  form_deleted: OPs,
  delete_form: NPs,
  delete_form_action: zPs,
  delete_form_confirmation: RPs,
  delete_form_confirmation_2: PPs,
  typeform_redirect_url_copied: DPs,
  modifications_in_fields_warning: LPs,
  connected_forms: MPs,
  form_modifications_warning: FPs,
  responses_collection_waiting_description: qPs,
  this_is_what_your_users_would_see: jPs,
  identifies_name_field: VPs,
  add_1_option_per_line: BPs,
  select_a_router: UPs,
  add_a_new_route: GPs,
  make_informed_decisions: WPs,
  make_informed_decisions_description: HPs,
  view_bookings_across: YPs,
  view_bookings_across_description: KPs,
  identify_booking_trends: ZPs,
  identify_booking_trends_description: XPs,
  spot_popular_event_types: JPs,
  spot_popular_event_types_description: QPs,
  no_responses_yet: eDs,
  no_routes_defined: tDs,
  this_will_be_the_placeholder: nDs,
  error_booking_event: oDs,
  timeslot_missing_title: rDs,
  timeslot_missing_description: iDs,
  timeslot_missing_cta: aDs,
  switch_monthly: sDs,
  switch_weekly: cDs,
  switch_multiday: lDs,
  switch_columnview: uDs,
  num_locations: dDs,
  select_on_next_step: _Ds,
  this_meeting_has_not_started_yet: pDs,
  this_app_requires_connected_account: mDs,
  connect_app: fDs,
  app_is_connected: gDs,
  requires_app: hDs,
  verification_code: vDs,
  can_you_try_again: bDs,
  verify: yDs,
  timezone_info: $Ds,
  timezone_variable: wDs,
  event_end_time_variable: kDs,
  event_end_time_info: SDs,
  cancel_url_variable: EDs,
  cancel_url_info: xDs,
  cancel_reason_variable: CDs,
  cancel_reason_info: TDs,
  reschedule_url_variable: ADs,
  reschedule_url_info: IDs,
  reschedule_reason_variable: ODs,
  reschedule_reason_info: NDs,
  invalid_event_name_variables: zDs,
  select_all: RDs,
  default_conferencing_bulk_title: PDs,
  members_default_schedule: DDs,
  set_by_admin: LDs,
  members_default_location: MDs,
  members_default_schedule_description: FDs,
  requires_at_least_one_schedule: qDs,
  default_conferencing_bulk_description: jDs,
  default_schedules_bulk_description: VDs,
  locked_for_members: BDs,
  unlocked_for_members: UDs,
  apps_locked_for_members_description: GDs,
  apps_unlocked_for_members_description: WDs,
  apps_locked_by_team_admins_description: HDs,
  apps_unlocked_by_team_admins_description: YDs,
  workflows_locked_for_members_description: KDs,
  workflows_unlocked_for_members_description: ZDs,
  workflows_locked_by_team_admins_description: XDs,
  workflows_unlocked_by_team_admins_description: JDs,
  webhooks_locked_for_members_description: QDs,
  webhooks_unlocked_for_members_description: e3s,
  webhooks_locked_by_team_admins_description: t3s,
  webhooks_unlocked_by_team_admins_description: n3s,
  locked_by_team_admin: o3s,
  app_not_connected: r3s,
  connect_now: i3s,
  managed_event_dialog_confirm_button_one: a3s,
  managed_event_dialog_confirm_button_other: s3s,
  managed_event_dialog_title_one: c3s,
  managed_event_dialog_title_other: l3s,
  managed_event_dialog_information_one: u3s,
  managed_event_dialog_information_other: d3s,
  managed_event_dialog_clarification: _3s,
  review_event_type: p3s,
  looking_for_more_analytics: m3s,
  looking_for_more_insights: f3s,
  filters: g3s,
  filter: h3s,
  add_a_member: v3s,
  add_filter: b3s,
  add_rule: y3s,
  add_rule_group: $3s,
  remove_filters: w3s,
  email_verified: k3s,
  select_user: S3s,
  select_event_type: E3s,
  select_date_range: x3s,
  popular_events: C3s,
  no_event_types_found: T3s,
  average_event_duration: A3s,
  bookings_by_hour: I3s,
  most_booked_members: O3s,
  least_booked_members: N3s,
  most_bookings_scheduled: z3s,
  least_bookings_scheduled: R3s,
  most_bookings_completed: P3s,
  least_bookings_completed: D3s,
  events_created: L3s,
  events_completed: M3s,
  events_cancelled: F3s,
  events_rescheduled: q3s,
  events: j3s,
  performance: V3s,
  from_last_period: B3s,
  from_to_date_period: U3s,
  redirect_url_warning: G3s,
  event_trends: W3s,
  clear_filters: H3s,
  clear: Y3s,
  hold: K3s,
  on_booking_option: Z3s,
  hold_option: X3s,
  card_held: J3s,
  charge_card: Q3s,
  card_charged: eLs,
  no_show_fee_amount: tLs,
  no_show_fee: nLs,
  submit_card: oLs,
  submit_payment_information: rLs,
  meeting_awaiting_payment_method: iLs,
  no_show_fee_charged_email_subject: aLs,
  no_show_fee_charged_text_body: sLs,
  no_show_fee_charged_subtitle: cLs,
  error_charging_card: lLs,
  collect_no_show_fee: uLs,
  no_show_fee_charged: dLs,
  your_card_was_declined: _Ls,
  your_card_does_not_support_this_type_of_purchase: pLs,
  amount_must_convert_to_at_least: mLs,
  could_not_charge_card: fLs,
  insights: gLs,
  routing_forms: hLs,
  insights_no_data_found_for_filter: vLs,
  acknowledge_booking_no_show_fee: bLs,
  days: yLs,
  card_details: $Ls,
  something_went_wrong_on_our_end: wLs,
  please_provide_following_text_to_suppport: kLs,
  seats_and_no_show_fee_error: SLs,
  complete_your_booking: ELs,
  complete_your_booking_subject: xLs,
  confirm_your_details: CLs,
  copy_invite_link: TLs,
  edit_invite_link: ALs,
  invite_link_copied: ILs,
  invite_link_deleted: OLs,
  api_key_deleted: NLs,
  delete_api_key_warning: zLs,
  invite_link_updated: RLs,
  link_expires_after: PLs,
  one_day: DLs,
  seven_days: LLs,
  thirty_days: MLs,
  three_months: FLs,
  one_year: qLs,
  team_invite_received: jLs,
  currency_string: VLs,
  charge_card_dialog_body: BLs,
  charge_attendee: ULs,
  payment_app_commission: GLs,
  email_invite_team: WLs,
  email_invite_team_bulk: HLs,
  error_collecting_card: YLs,
  image_size_limit_exceed: KLs,
  unauthorized_workflow_error_message: ZLs,
  inline_embed: XLs,
  load_inline_content: JLs,
  floating_pop_up_button: QLs,
  floating_button_trigger_modal: eMs,
  pop_up_element_click: tMs,
  open_dialog_with_element_click: nMs,
  use_my_own_form: oMs,
  use_our_headless_routing_api: rMs,
  need_help_embedding: iMs,
  book_my_cal: aMs,
  first_name: sMs,
  last_name: cMs,
  first_last_name: lMs,
  invite_as: uMs,
  form_updated_successfully: dMs,
  disable_attendees_confirmation_emails: _Ms,
  disable_attendees_confirmation_emails_description: pMs,
  disable_host_confirmation_emails: mMs,
  disable_host_confirmation_emails_description: fMs,
  add_an_override: gMs,
  import_from_google_workspace: hMs,
  connect_google_workspace: vMs,
  google_workspace_admin_tooltip: bMs,
  first_event_type_webhook_description: yMs,
  create_instant_meeting_webhook_description: $Ms,
  install_app_on: wMs,
  create_for: kMs,
  currency: SMs,
  organization_banner_description: EMs,
  organization_banner_title: xMs,
  set_up_your_organization: CMs,
  set_up_your_platform_organization: TMs,
  organizations_description: AMs,
  plans: IMs,
  platform: OMs,
  platform_description: NMs,
  platform_organization_description: zMs,
  must_enter_organization_name: RMs,
  must_enter_organization_admin_email: PMs,
  admin_email: DMs,
  platform_admin_email: LMs,
  admin_username: MMs,
  organization_name: FMs,
  platform_name: qMs,
  organization_url: jMs,
  organization_verify_header: VMs,
  organization_verify_email_body: BMs,
  additional_url_parameters: UMs,
  about_your_organization: GMs,
  about_your_organization_description: WMs,
  create_your_teams: HMs,
  create_your_teams_description: YMs,
  invite_organization_admins: KMs,
  invite_organization_admins_description: ZMs,
  set_a_password: XMs,
  set_a_password_description: JMs,
  organization_logo: QMs,
  organization_about_description: e4s,
  ill_do_this_later: t4s,
  verify_your_email: n4s,
  enter_digit_code: o4s,
  verify_email_organization: r4s,
  code_provided_invalid: i4s,
  email_already_used: a4s,
  organization_admin_invited_heading: s4s,
  organization_admin_invited_body: c4s,
  duplicated_slugs_warning: l4s,
  team_names_empty: u4s,
  team_names_repeated: d4s,
  user_belongs_organization: _4s,
  org_no_teams_yet: p4s,
  org_no_teams_yet_description: m4s,
  set_up: f4s,
  my_profile: g4s,
  my_settings: h4s,
  crm: v4s,
  messaging: b4s,
  sender_id_info: y4s,
  org_admins_can_create_new_teams: $4s,
  google_new_spam_policy: w4s,
  resolve: k4s,
  no_organization_slug: S4s,
  copy_link_org: E4s,
  "404_the_org": "A organização",
  "404_the_team": "A equipe",
  "404_claim_entity_org": "Solicite o subdomínio para a sua organização",
  "404_claim_entity_team": "Solicite esta equipe e comece a gerenciar agendamentos coletivamente",
  insights_team_filter: x4s,
  insights_user_filter: C4s,
  insights_subtitle: T4s,
  call_history: A4s,
  call_history_subtitle: I4s,
  location_options: O4s,
  channel_type: N4s,
  end_reason: z4s,
  session_status: R4s,
  user_sentiment: P4s,
  time_header: D4s,
  from_header: L4s,
  custom_plan: M4s,
  email_embed: F4s,
  add_times_to_your_email: q4s,
  select_time: j4s,
  select_date: V4s,
  only_show_if_parameter_set: B4s,
  add_parameter: U4s,
  connecting_you_to_someone: G4s,
  please_do_not_close_this_tab: W4s,
  see_all_available_times: H4s,
  org_team_names_example_1: Y4s,
  org_team_names_example_2: K4s,
  org_team_names_example_3: Z4s,
  org_team_names_example_4: X4s,
  org_team_names_example_5: J4s,
  org_max_team_warnings: Q4s,
  what_is_this_meeting_about: e5s,
  add_to_team: t5s,
  remove_users_from_org: n5s,
  delegation_credential: o5s,
  delegation_credential_description: r5s,
  add_client_id_in_google_workspace_with_below_scope: i5s,
  delegation_credential_enabled: a5s,
  add_delegation_credential: s5s,
  edit_delegation_credential: c5s,
  domain: l5s,
  no_workspace_platforms: u5s,
  workspace_platform: d5s,
  workspace_platforms: _5s,
  workspace_platforms_description: p5s,
  edit_workspace_platform: m5s,
  edit_service_account: f5s,
  add_workspace_platform: g5s,
  slug: h5s,
  service_account_key: v5s,
  edit_service_account_key: b5s,
  delegation_credential_restricts_adding_more_than_one_installation: y5s,
  app_successfully_installed_and_is_using_delegated_credentials: $5s,
  remove_users_from_org_confirm: w5s,
  remove_users_from_team: k5s,
  remove_users_from_team_confirm: S5s,
  user_has_no_schedules: E5s,
  user_isnt_in_any_teams: x5s,
  user_has_no_app_installed: C5s,
  requires_booker_email_verification: T5s,
  description_requires_booker_email_verification: A5s,
  requires_confirmation_mandatory: I5s,
  organizations: O5s,
  upload_cal_video_logo: N5s,
  update_cal_video_logo: z5s,
  upload_banner: R5s,
  cal_video_logo_upload_instruction: P5s,
  org_admin_other_teams: D5s,
  org_admin_other_teams_description: L5s,
  not_part_of_org: M5s,
  no_other_teams_found: F5s,
  no_other_teams_found_description: q5s,
  attendee_first_name_variable: j5s,
  attendee_last_name_variable: V5s,
  attendee_first_name_info: B5s,
  attendee_last_name_info: U5s,
  your_monthly_digest: G5s,
  member_name: W5s,
  most_popular_events: H5s,
  summary_of_events_for_your_team_for_the_last_30_days: Y5s,
  me: K5s,
  meeting_unavailable: Z5s,
  monthly_digest_email: X5s,
  monthly_digest_email_for_teams: J5s,
  verify_team_tooltip: Q5s,
  member_removed: e6s,
  my_availability: t6s,
  team_availability: n6s,
  instant_meeting_availability: o6s,
  backup_code: r6s,
  backup_codes: i6s,
  backup_code_instructions: a6s,
  backup_codes_copied: s6s,
  incorrect_backup_code: c6s,
  lost_access: l6s,
  missing_backup_codes: u6s,
  admin_org_notification_email_subject: d6s,
  hi_admin: _6s,
  admin_org_notification_email_title: p6s,
  admin_org_notification_email_body_part1: m6s,
  admin_org_notification_email_body_part2: f6s,
  admin_org_notification_email_body_part3: g6s,
  admin_org_notification_email_cta: h6s,
  org_has_been_processed: v6s,
  org_error_processing: b6s,
  orgs_page_description: y6s,
  unverified: $6s,
  verified: w6s,
  dns_missing: k6s,
  dns_configured: S6s,
  mark_dns_configured: E6s,
  value: x6s,
  your_organization_updated_sucessfully: C6s,
  team_no_event_types: T6s,
  seat_options_doesnt_multiple_durations: A6s,
  include_calendar_event: I6s,
  oAuth: O6s,
  oAuth_client_creation_form: N6s,
  oAuth_client_creation_form_description: z6s,
  oAuth_client_updation_form: R6s,
  oAuth_client_updation_form_description: P6s,
  recently_added: D6s,
  connect_all_calendars: L6s,
  connect_all_calendars_description: M6s,
  workflow_automation_description: F6s,
  scheduling_for_your_team: q6s,
  scheduling_for_your_team_description: j6s,
  no_members_found: V6s,
  directory_sync: B6s,
  directory_name: U6s,
  directory_provider: G6s,
  directory_scim_url: W6s,
  directory_scim_token: H6s,
  directory_scim_url_copied: Y6s,
  directory_scim_token_copied: K6s,
  directory_sync_info_description: Z6s,
  directory_sync_configure: X6s,
  directory_sync_configure_description: J6s,
  directory_sync_title: Q6s,
  directory_sync_created: eFs,
  directory_sync_description: tFs,
  directory_sync_deleted: nFs,
  directory_sync_delete_connection: oFs,
  directory_sync_delete_title: rFs,
  directory_sync_delete_description: iFs,
  directory_sync_delete_confirmation: aFs,
  event_setup_length_error: sFs,
  availability_schedules: cFs,
  unauthorized: lFs,
  access_cal_account: uFs,
  select_account_team: dFs,
  allow_client_to: _Fs,
  associate_with_cal_account: pFs,
  see_personal_info: mFs,
  see_primary_email_address: fFs,
  connect_installed_apps: gFs,
  access_event_type: hFs,
  access_availability: vFs,
  access_bookings: bFs,
  allow_client_to_do: yFs,
  oauth_access_information: $Fs,
  allow: wFs,
  view_only_edit_availability_not_onboarded: kFs,
  view_only_edit_availability: SFs,
  you_can_override_calendar_in_advanced_tab: EFs,
  edit_users_availability: xFs,
  resend_invitation: CFs,
  invitation_resent: TFs,
  saml_sso: AFs,
  add_client: IFs,
  copy_client_secret_info: OFs,
  add_new_client: NFs,
  add_new_user: zFs,
  this_app_is_not_setup_already: RFs,
  as_csv: PFs,
  overlay_my_calendar: DFs,
  overlay_my_calendar_toc: LFs,
  view_overlay_calendar_events: MFs,
  join_event_location: FFs,
  troubleshooting: qFs,
  calendars_were_checking_for_conflicts: jFs,
  availabilty_schedules: VFs,
  manage_calendars: BFs,
  manage_availability_schedules: UFs,
  locked: GFs,
  unlocked: WFs,
  lock_timezone_toggle_on_booking_page: HFs,
  description_lock_timezone_toggle_on_booking_page: YFs,
  event_setup_multiple_payment_apps_error: KFs,
  number_in_international_format: ZFs,
  install_calendar: XFs,
  branded_subdomain: JFs,
  branded_subdomain_description: QFs,
  org_insights: eqs,
  org_insights_description: tqs,
  extensive_whitelabeling: nqs,
  extensive_whitelabeling_description: oqs,
  unlimited_teams: rqs,
  verify_email: iqs,
  proceed_with_cancellation_description: aqs,
  proceed_with_cancellation_error: sqs,
  unlimited_teams_description: cqs,
  unified_billing: lqs,
  advanced_managed_events: uqs,
  advanced_managed_events_description: dqs,
  enterprise: _qs,
  enterprise_description: pqs,
  create_your_org: mqs,
  create_org: fqs,
  create_your_org_description: gqs,
  create_your_enterprise_description: hqs,
  other_payment_app_enabled: vqs,
  admin_delete_organization_description_1: bqs,
  admin_delete_organization_description_2: yqs,
  admin_delete_organization_description_3: $qs,
  admin_delete_organization_description_4: wqs,
  admin_delete_organization_title: kqs,
  published: Sqs,
  unpublished: Eqs,
  publish: xqs,
  troubleshooter_tooltip: Cqs,
  need_help: Tqs,
  troubleshooter: Aqs,
  number_to_call: Iqs,
  guest_name: Oqs,
  guest_email: Nqs,
  guest_company: zqs,
  please_install_a_calendar: Rqs,
  instant_tab_title: Pqs,
  instant_event_tab_description: Dqs,
  uprade_to_create_instant_bookings: Lqs,
  dont_want_to_wait: Mqs,
  meeting_started: Fqs,
  pay_and_book: qqs,
  cal_ai_event_tab_description: jqs,
  booking_not_found_error: Vqs,
  booking_seats_full_error: Bqs,
  missing_payment_credential_error: Uqs,
  missing_payment_app_id_error: Gqs,
  not_enough_available_seats_error: Wqs,
  user_redirect_title: Hqs,
  user_redirect_description: Yqs,
  out_of_office: Kqs,
  out_of_office_description: Zqs,
  send_request: Xqs,
  start_date_and_end_date_required: Jqs,
  start_date_must_be_before_end_date: Qqs,
  start_date_must_be_in_the_future: ejs,
  user_not_found: tjs,
  cannot_redirect_to_self: njs,
  out_of_office_entry_already_exists: ojs,
  out_of_office_id_required: rjs,
  booking_redirect_infinite_not_allowed: ijs,
  success_entry_created: ajs,
  booking_redirect_email_subject: sjs,
  booking_redirect_email_title: cjs,
  booking_redirect_email_description: ljs,
  booking_redirect_updated_email_subject: ujs,
  booking_redirect_updated_email_title: djs,
  booking_redirect_updated_email_description: _js,
  booking_redirect_cancelled_email_subject: pjs,
  booking_redirect_cancelled_email_title: mjs,
  booking_redirect_cancelled_email_description: fjs,
  success_accept_booking_redirect: gjs,
  success_reject_booking_redirect: hjs,
  copy_link_booking_redirect_request: vjs,
  booking_redirect_request_title: bjs,
  select_team_member: yjs,
  going_away_title: $js,
  redirect_team_enabled: wjs,
  redirect_team_disabled: kjs,
  out_of_office_unavailable_list: Sjs,
  success_deleted_entry_out_of_office: Ejs,
  success_edited_entry_out_of_office: xjs,
  temporarily_out_of_office: Cjs,
  add_a_redirect: Tjs,
  create_entry: Ajs,
  time_range: Ijs,
  automatically_add_all_team_members: Ojs,
  redirect_to: Njs,
  having_trouble_finding_time: zjs,
  show_more: Rjs,
  forward_params_redirect: Pjs,
  assignment_description: Djs,
  lowest: Ljs,
  low: Mjs,
  medium: Fjs,
  high: qjs,
  Highest: jjs,
  send_booker_to: Vjs,
  set_priority: Bjs,
  set_weight: Ujs,
  enable_weights: Gjs,
  priority_for_user: Wjs,
  weights_description: Hjs,
  weight_for_user: Yjs,
  change_priority: Kjs,
  field_identifiers_as_variables: Zjs,
  field_identifiers_as_variables_with_example: Xjs,
  account_already_linked: Jjs,
  send_email: Qjs,
  cal_ai_phone_call_action: eVs,
  call_to_confirm_booking: tVs,
  cal_ai_phone_call_action_description: nVs,
  cal_ai_agent_configuration: oVs,
  choose_at_least_one_event_type_test_call: rVs,
  mark_as_no_show: iVs,
  unmark_as_no_show: aVs,
  account_unlinked_success: sVs,
  account_unlinked_error: cVs,
  travel_schedule: lVs,
  travel_schedule_description: uVs,
  schedule_timezone_change: dVs,
  date: _Vs,
  enter_the_general_prompt_for_the_agent: pVs,
  overlaps_with_existing_schedule: mVs,
  "org_admin_no_slots|heading": "Nenhuma disponibilidade encontrada para {{name}}",
  "org_admin_no_slots|content": "Olá Administradores da Organização,<br /><br />Observação: Foi trazido à nossa atenção que {{username}} não teve disponibilidade quando um usuário visitou {{username}}/{{slug}}<br /><br />Existem alguns motivos pelos quais isso pode estar acontecendo<br />O usuário não tem calendários conectados<br />Seus horários vinculados a este evento não estão habilitados<br /> <br />Recomendamos verificar a disponibilidade para resolver isso.",
  "org_admin_no_slots|cta": "Abrir a disponibilidade dos usuários",
  organization_no_slots_notification_switch_title: fVs,
  organization_no_slots_notification_switch_description: gVs,
  organization_disable_phone_only_sms_notifications_switch_title: hVs,
  organization_disable_phone_only_sms_notifications_switch_description: vVs,
  "email_team_invite|subject|added_to_org": "{{user}} adicionou você à organização {{team}} no {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} convidou você para se juntar à organização {{team}} no {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} adicionou você à equipe {{team}} da organização {{parentTeamName}} no {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} convidou você para se juntar à equipe {{team}} em {{appName}}",
  "email_team_invite|heading|added_to_org": "Você foi adicionado a uma organização do {{appName}}",
  "email_team_invite|heading|invited_to_org": "Você foi convidado para uma organização do {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Você foi adicionado a uma equipe da organização {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Você foi convidado para uma equipe da organização {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Você foi convidado para participar de uma equipe do {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} adicionou você à organização <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} convidou você para se juntar à organização {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} convidou você para se juntar à equipe {{team}} da organização {{parentTeamName}} no {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} adicionou você à equipe <strong>{{teamName}}</strong> na organização {{parentTeamName}}. {{appName}} é o agendador para gerenciador de múltiplos eventos que permite que você e sua equipe agendem reuniões sem o vai-e-vem de e-mails.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} convidou você para a equipe <strong>{{teamName}}</strong> na organização {{parentTeamName}}. {{appName}} é o gerenciador de múltiplos eventos que permite que você e sua equipe agendem reuniões sem o vai-e-vem de e-mails.",
  "email_team_invite|content|invited_to_regular_team": 'Você recebeu um convite de {{invitedBy}} para ingressar na equipe "{{teamName}}" em {{appName}}. {{appName}} é um agendador que concilia eventos e permite que sua equipe agende reuniões sem precisar trocar e-mails.',
  "email|existing_user_added_link_will_change": "Ao aceitar o convite, seu link mudará para o domínio da sua organização, mas não se preocupe, todos os links anteriores ainda funcionarão e redirecionarão adequadamente.<br /><br />Observe: Todos os seus tipos de eventos pessoais serão movidos para a organização <strong>{{teamName}}</strong>, o que também pode incluir potencial link pessoal. <br /><br />Para eventos pessoais, recomendamos criar uma nova conta com um endereço de e-mail pessoal.",
  "email|existing_user_added_link_changed": "Seu link foi alterado de {{a0}} para {{a1}}, mas não se preocupe, todos os links anteriores ainda funcionam e redirecionam adequadamente. <br /><br />Observe: Todos os seus tipos de eventos pessoais foram movidos para a organização <strong>{{teamName}}</strong>, o que também pode incluir potencial link pessoal.<br /><br />Faça login e verifique se não há eventos privados em sua nova conta organizacional.<br /><br />Para eventos pessoais, recomendamos criar uma nova conta com um endereço de e-mail pessoal.<br /><br />Aproveite seu novo link limpo: {{a2}}",
  "email_organization_created|subject": "Sua organização foi criada",
  your_current_plan: bVs,
  organization_price_per_user_month: yVs,
  privacy_organization_description: $Vs,
  privacy: wVs,
  team_will_be_under_org: kVs,
  add_group_name: SVs,
  group_name: EVs,
  routers: xVs,
  primary: CVs,
  make_primary: TVs,
  add_email: AVs,
  add_emails: IVs,
  add_email_description: OVs,
  confirm_email: NVs,
  confirming_your_booking_sms: zVs,
  scheduler_first_name: RVs,
  scheduler_last_name: PVs,
  scheduler_name: DVs,
  organizer_first_name: LVs,
  confirm_email_description: MVs,
  send_event_details_to: FVs,
  schedule_tz_without_end_date: qVs,
  select_members: jVs,
  lock_event_types_modal_header: VVs,
  org_delete_event_types_org_admin: BVs,
  org_hide_event_types_org_admin: UVs,
  hide_org_eventtypes: GVs,
  delete_org_eventtypes: WVs,
  lock_org_users_eventtypes: HVs,
  lock_org_users_eventtypes_description: YVs,
  add_to_event_type: KVs,
  create_account_password: ZVs,
  create_account_with_saml: XVs,
  error_creating_account_password: JVs,
  cannot_create_account_password_cal_provider: QVs,
  cannot_create_account_password_already_existing: eBs,
  create_account_password_hint: tBs,
  disconnect_account: nBs,
  disconnect_account_hint: oBs,
  cookie_consent_checkbox: rBs,
  make_a_call: iBs,
  skip_rr_assignment_label: aBs,
  skip_rr_description: sBs,
  select_account_header: cBs,
  select_account_description: lBs,
  select_event_types_header: uBs,
  select_event_types_description: dBs,
  configure_app_header: _Bs,
  configure_app_description: pBs,
  already_installed: mBs,
  ooo_reasons_unspecified: fBs,
  ooo_reasons_vacation: gBs,
  ooo_reasons_travel: hBs,
  ooo_reasons_sick_leave: vBs,
  ooo_reasons_public_holiday: bBs,
  ooo_forwarding_to: yBs,
  ooo_not_forwarding: $Bs,
  ooo_empty_title: wBs,
  ooo_empty_description: kBs,
  ooo_user_is_ooo: SBs,
  ooo_slots_returning: EBs,
  ooo_slots_book_with: xBs,
  ooo_select_reason: CBs,
  create_an_out_of_office: TBs,
  edit_an_out_of_office: ABs,
  submit_feedback: IBs,
  host_no_show: OBs,
  no_show_description: NBs,
  how_can_we_improve: zBs,
  most_liked: RBs,
  review: PBs,
  reviewed: DBs,
  unreviewed: LBs,
  rating_url_variable: MBs,
  rating_url_info: FBs,
  no_show_url_variable: qBs,
  no_show_url_info: jBs,
  no_support_needed: VBs,
  hide_support: BBs,
  event_ratings: UBs,
  event_no_show: GBs,
  event_no_show_guest: WBs,
  recent_ratings: HBs,
  no_ratings: YBs,
  no_ratings_description: KBs,
  most_no_show_host: ZBs,
  highest_rated: XBs,
  lowest_rated: JBs,
  highest_rated_members: QBs,
  lowest_rated_members: e9s,
  csat_score: t9s,
  lockedSMS: n9s,
  leave_without_assigning_anyone: o9s,
  leave_without_adding_attendees: r9s,
  no_availability_shown_to_bookers: i9s,
  go_back_and_assign: a9s,
  leave_without_assigning: s9s,
  signing_up_terms: c9s,
  proceeding_agreement: l9s,
  terms: u9s,
  always_show_x_days: d9s,
  always_show_x_days_description: _9s,
  team_subscription_cancelled_successfully: p9s,
  team_subscription_cancellation_error: m9s,
  unable_to_subscribe_to_the_platform: f9s,
  updating_oauth_client_error: g9s,
  creating_oauth_client_error: h9s,
  event_type_color: v9s,
  event_type_color_description: b9s,
  mark_as_no_show_title: y9s,
  x_marked_as_no_show: $9s,
  x_unmarked_as_no_show: w9s,
  team_select_info: k9s,
  team_settings_description: S9s,
  no_show_updated: E9s,
  email_copied: x9s,
  phone_number_copied: C9s,
  USER_PENDING_MEMBER_OF_THE_ORG: T9s,
  USER_ALREADY_INVITED_OR_MEMBER: A9s,
  USER_MEMBER_OF_OTHER_ORGANIZATION: I9s,
  booking_reassigned: O9s,
  reassign: N9s,
  reassign_to_another_rr_host: z9s,
  assign_team_member: R9s,
  override_team_member_to_assign: P9s,
  no_available_hosts: D9s,
  reassign_round_robin_host: L9s,
  skip_writing_to_calendar: M9s,
  rescheduling_not_possible: F9s,
  event_expired: q9s,
  skip_contact_creation: j9s,
  skip_writing_to_calendar_note: V9s,
  attributes: B9s,
  new_attribute: U9s,
  add_attributes: G9s,
  add_attributes_description: W9s,
  new_option: H9s,
  update_profile: Y9s,
  attribute: K9s,
  create_attribute_description: Z9s,
  edit_attribute_description: X9s,
  attribute_updated_successfully: J9s,
  attribute_deleted_successfully: Q9s,
  attributes_edited_successfully: eUs,
  attribute_meta_description: tUs,
  attributes_edit_description: nUs,
  back_to_attributes: oUs,
  delete_attribute: rUs,
  delete_attribute_description: iUs,
  disable_all_emails_to_attendees: aUs,
  disable_all_emails_description: sUs,
  disable_all_emails_to_hosts: cUs,
  type_confirm_to_continue: lUs,
  disable_email: uUs,
  grant_admin_api: dUs,
  revoke_admin_api: _Us,
  add_calendar_label: pUs,
  apple_connect_atom_label: mUs,
  apple_connect_atom_already_connected_label: fUs,
  apple_connect_atom_loading_label: gUs,
  google_connect_atom_label: hUs,
  google_connect_atom_already_connected_label: vUs,
  google_connect_atom_loading_label: bUs,
  outlook_connect_atom_label: yUs,
  outlook_connect_atom_already_connected_label: $Us,
  outlook_connect_atom_loading_label: wUs,
  stripe_connect_atom_label: kUs,
  stripe_connect_atom_already_connected_label: SUs,
  stripe_connect_atom_loading_label: EUs,
  booking_question_response_variables: xUs,
  managed_by_teamAdmins: CUs,
  number_of_options: TUs,
  reschedule_with_same_round_robin_host_title: AUs,
  reschedule_with_same_round_robin_host_description: IUs,
  disable_input_if_prefilled: OUs,
  booking_limits: NUs,
  booking_limits_team_description: zUs,
  limit_team_booking_frequency_description: RUs,
  booking_limits_updated_successfully: PUs,
  you_are_unauthorized_to_make_this_change_to_the_booking: DUs,
  delegation_credential_disabled: LUs,
  matching_members: MUs,
  x_matching_members: FUs,
  matching_members_queue_using_attribute_weights: qUs,
  matching_members_queue_using_event_assignee_weights: jUs,
  no_matching_members: VUs,
  no_matching_members_will_fallback_to_all_assigned_members: BUs,
  hide_calendar_event_details: UUs,
  description_hide_calendar_event_details: GUs,
  last_number_of_days: WUs,
  month_to_date: HUs,
  year_to_date: YUs,
  custom_range: KUs,
  refund_policy: ZUs,
  always: XUs,
  never: JUs,
  payment_option: QUs,
  if_cancelled: eGs,
  before: tGs,
  show_all_columns: nGs,
  toggle_columns: oGs,
  no_columns_found: rGs,
  salesforce_create_record_as: iGs,
  salesforce_lead: aGs,
  salesforce_contact_under_account: sGs,
  salesforce_skip_entry_creation: cGs,
  salesforce_if_account_does_not_exist: lGs,
  salesforce_create_new_contact_under_account: uGs,
  salesforce_change_record_owner_on_booking: dGs,
  mass_assign_attributes: _Gs,
  reroute_preview_custom_message: pGs,
  reroute_preview_external_redirect: mGs,
  reroute_preview_possible_host: fGs,
  current_routing_status: gGs,
  reroute_booking: hGs,
  reroute_booking_description: vGs,
  verify_new_route: bGs,
  reroute: yGs,
  new_routing_status: $Gs,
  salesforce_book_directly_with_attendee_owner: wGs,
  salesforce_check_owner_of: kGs,
  account: SGs,
  choose_hosts_schedule: EGs,
  hosts_schedule_description: xGs,
  no_hosts_description: CGs,
  team_member_round_robin_reassign: TGs,
  team_member_round_robin_reassign_description: AGs,
  round_robin_reassign_description: IGs,
  invalid_round_robin_host: OGs,
  user_is_round_robin_fixed: NGs,
  reschedule_with_same_timeslot: zGs,
  reschedule_with_same_timeslot_of_new_event: RGs,
  reschedule_to_the_new_event_with_different_timeslot: PGs,
  reschedule_with_different_timeslot: DGs,
  we_dont_have_id_for_the_new_event: LGs,
  rerouted_booking_successfully_redirecting_to_booking_page: MGs,
  on_booking_write_to_event_object: FGs,
  field_name: qGs,
  add_new_field: jGs,
  you_dont_have_access_to_reroute_this_booking: VGs,
  form_response_not_found: BGs,
  contact_owner: UGs,
  contact_owner_not_found: GGs,
  using_fallback_members: WGs,
  chosen_route: HGs,
  attribute_logic_matched: YGs,
  attribute_logic_fallback_matched: KGs,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: ZGs,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: XGs,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: JGs,
  warning: QGs,
  fallback_attribute_logic_description: eWs,
  fallback_attribute_logic_warning: tWs,
  fallback_not_needed: nWs,
  confirm_reassign_unavailable: oWs,
  confirm_reassign_available: rWs,
  reassign_unavailable_team_member_description: iWs,
  reassign_available_team_member_description: aWs,
  yes_reassign: sWs,
  filter_by_attributes: cWs,
  reassign_reason: lWs,
  field_type_change_suggestion: uWs,
  reassigned_by: dWs,
  row: _Ws,
  rows: pWs,
  attendee_timezone_variable: mWs,
  event_start_time_in_attendee_timezone_variable: fWs,
  event_start_time_in_attendee_timezone_info: gWs,
  event_end_time_in_attendee_timezone_info: hWs,
  event_end_time_in_attendee_timezone_variable: vWs,
  salesforce_create_event_on_contact: bWs,
  salesforce_owner_name_to_change: yWs,
  no_filter_set: $Ws,
  booking_dry_run_successful: wWs,
  booking_dry_run_successful_description: kWs,
  dont_have_access_this_page: SWs,
  you_need_admin_or_owner_privileges_to_access: EWs,
  field_type: xWs,
  when_to_write: CWs,
  salesforce_on_booking_write_to_record: TWs,
  on_every_booking: AWs,
  only_if_field_is_empty: IWs,
  booking_start_date: OWs,
  booking_created_date: NWs,
  booking_reassigned_to_host: zWs,
  no_contact_owner: RWs,
  routing_forms_created: PWs,
  routing_forms_total_responses: DWs,
  routing_forms_total_responses_without_booking: LWs,
  routing_forms_total_responses_with_booking: MWs,
  routing_form_insights: FWs,
  routing_form_insights_form_name_header: qWs,
  routing_form_insights_booking_status_header: jWs,
  routing_form_insights_response_no_booking: VWs,
  routing_form_insights_booked_by: BWs,
  routing_form_insights_created_at: UWs,
  routing_form_insights_booking_status: GWs,
  routing_form_insights_booking_at: WWs,
  routing_form_insights_submitted_at: HWs,
  copy_redirect_url: YWs,
  redirect_url_on_exit: KWs,
  total_bookings_per_period: ZWs,
  routed_to_per_period: XWs,
  per_day: JWs,
  per_week: QWs,
  per_month: e8s,
  routing_form_insights_assignment_reason: t8s,
  access_denied: n8s,
  salesforce_route_to_owner: o8s,
  salesforce_add_attendees_as: r8s,
  salesforce_do_not_route_to_owner: i8s,
  salesforce_route_to_custom_lookup_field: a8s,
  salesforce_option: s8s,
  lookup_field_name: c8s,
  salesforce_if_free_email_domain_skip_owner_check: l8s,
  filter_operator_is: u8s,
  filter_operator_is_not: d8s,
  filter_operator_contains: _8s,
  filter_operator_does_not_contain: p8s,
  filter_operator_starts_with: m8s,
  filter_operator_ends_with: f8s,
  filter_operator_is_empty: g8s,
  filter_operator_not_empty: h8s,
  translate_description_button: v8s,
  translate_description_button_description: b8s,
  rr_distribution_method: y8s,
  rr_distribution_method_description: $8s,
  rr_distribution_method_availability_title: w8s,
  rr_distribution_method_availability_description: k8s,
  rr_distribution_method_balanced_title: S8s,
  rr_distribution_method_balanced_description: E8s,
  edit_team_member_weights: x8s,
  weights_updated_successfully: C8s,
  require_confirmation_for_free_email: T8s,
  exclude_emails_that_contain: A8s,
  require_emails_that_contain: I8s,
  exclude_emails_match_found_error_message: O8s,
  require_emails_no_match_found_error_message: N8s,
  search_columns: z8s,
  search_options: R8s,
  disable_org_url_label: P8s,
  disable_org_url_description: D8s,
  single_select: L8s,
  multi_select: M8s,
  calendar_conflict_settings: F8s,
  select_calendars_conflict_check: q8s,
  group_meeting: j8s,
  are_you_sure_you_want_to_remove_this_app_from: V8s,
  disconnect_app_from: B8s,
  salesforce_ignore_guests: U8s,
  google_meet: G8s,
  zoom: W8s,
  office_365_video: H8s,
  lock_attribute_for_assignment: Y8s,
  lock_attribute_for_assignment_description: K8s,
  attribute_edited_successfully: Z8s,
  new_group_option: X8s,
  attribute_weight_enabled: J8s,
  attribute_weight_enabled_description: Q8s,
  routed: e7s,
  reassigned: t7s,
  allow_rescheduling_past_events: n7s,
  allow_rescheduling_past_events_description: o7s,
  rerouted: r7s,
  salesforce_assigned: i7s,
  router_position: a7s,
  show_matching_hosts: s7s,
  no_active_queues: c7s,
  weight: l7s,
  calibration: u7s,
  shortfall: d7s,
  routing_form: _7s,
  go_back_and_save: p7s,
  save_changes: m7s,
  leave_without_saving: f7s,
  leave_without_saving_description: g7s,
  something_unexpected_occurred: h7s,
  "500_error_message": "Não é você, somos nós.",
  dry_run_mode_active: v7s,
  icon_showcase: b7s,
  icons_showcase: y7s,
  migrating_from_team: $7s,
  feature_currently_disabled: w7s,
  choose_an_option: k7s,
  enter_option_value: S7s,
  remove_option: E7s,
  use_attribute_weights: x7s,
  if_enabled_ignore_event_type_weights: C7s,
  attribute_for_weights: T7s,
  managed_users: A7s,
  managed_users_description: I7s,
  can_you_tell_me_about: O7s,
  use_ai_to_answer_your_questions: N7s,
  error_fetching_answer: z7s,
  k_bar_ai_error: R7s,
  select_oAuth_client: P7s,
  on_every_instance: D7s,
  delegation_credential_feature_not_enabled: L7s,
  internal_booking_note: M7s,
  internal_note_cancellation_reason: F7s,
  internal_booking_note_description: q7s,
  internal_note_presets: j7s,
  internal_note_presets_description: V7s,
  internal_note_presets_updated_successfully: B7s,
  add_preset: U7s,
  authorize: G7s,
  next: W7s,
  hide: H7s,
  show: Y7s,
  utm_params: K7s,
  no_utm_params: Z7s,
  asc: X7s,
  desc: J7s,
  verify_email_change: Q7s,
  buy_credits: eHs,
  credits: tHs,
  credits_used: nHs,
  total_credits_remaining: oHs,
  credits_per_tip_org: rHs,
  credits_per_tip_teams: iHs,
  view_and_manage_credits: aHs,
  view_and_manage_credits_description: sHs,
  credit_worth_description: cHs,
  buy_additional_credits: lHs,
  view_additional_credits_expense_tip: uHs,
  overview: dHs,
  organization_slug_taken: _Hs,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: pHs,
  you_need_to_complete_user_onboarding_before_creating_an_organization: mHs,
  use_company_email_to_create_an_organization: fHs,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: gHs,
  you_need_to_have_minimum_published_teams: hHs,
  you_are_part_of_this_organization_already: vHs,
  you_are_part_of_another_organization_cannot_create_organization: bHs,
  you_are_part_of_another_platform_organization_cannot_create_organization: yHs,
  organization_payment_success: $Hs,
  organization_payment_success_description: wHs,
  this_may_take_a_few_seconds: kHs,
  organization_onboarding_status: SHs,
  organization_onboarding_status_description: EHs,
  payment_failed: xHs,
  payment_failed_description: CHs,
  creating_your_organization: THs,
  organization_onboarding_already_completed: AHs,
  organization_onboarding_already_exists: IHs,
  organization_onboarding_not_found: OHs,
  payment_successful: NHs,
  handover_onboarding_page_title: zHs,
  handover_onboarding_page_description: RHs,
  organization_already_exists_with_this_slug: PHs,
  you_do_not_have_permission_to_create_an_organization_for_this_email: DHs,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: LHs,
  organization_has_subscription_already: MHs,
  reset_interval_weighted_rr: FHs,
  interval: qHs,
  rr_reset_interval_description: jHs,
  daily: VHs,
  end_date_not_selected: BHs,
  my_ooo: UHs,
  team_ooo: GHs,
  out_of_office_team_description: WHs,
  create_ooo_dialog_team_title: HHs,
  create_ooo_dialog_team_subtitle: YHs,
  edit_ooo_dialog_team_subtitle: KHs,
  ooo_team_empty_title: ZHs,
  ooo_team_empty_description: XHs,
  forward_to_team_member_only: JHs,
  ooo_team_redirect_infinite_not_allowed: QHs,
  previous_ooo_empty_title: eYs,
  previous: tYs,
  rr_interval_successfully_updated: nYs,
  trial_mode: oYs,
  inactive_team_plan: rYs,
  inactive_team_plan_description: iYs,
  limited_access_trial_mode: aYs,
  referral_program: sYs,
  referral_text: cYs,
  dub_disabled_error_message: lYs,
  uid: uYs,
  link: dYs,
  rows_per_page: _Ys,
  pagination_status: pYs,
  tip_username_plus: mYs,
  user_has_no_team_yet: fYs,
  no_team_members: gYs,
  recurring_event_doesnt_support_seats: hYs,
  booking_limit_per_booker_doesnt_support_recurring: vYs,
  seats_doesnt_support_recurring: bYs,
  recurring_event_seats_error: yYs,
  segment: $Ys,
  saved_filters: wYs,
  rename: kYs,
  rename_segment: SYs,
  delete_segment: EYs,
  duplicate_segment: xYs,
  delete_segment_confirmation: CYs,
  filter_segment_updated: TYs,
  error_updating_filter_segment: AYs,
  filter_segment_duplicated: IYs,
  error_duplicating_filter_segment: OYs,
  filter_segment_deleted: NYs,
  error_deleting_filter_segment: zYs,
  save_segment: RYs,
  segment_not_found: PYs,
  filter_segment_saved: DYs,
  no_segments: LYs,
  error_saving_filter_segment: MYs,
  override_segment: FYs,
  create_new_segment: qYs,
  save_for_team: jYs,
  select_team: VYs,
  please_select_team: BYs,
  personal: UYs,
  hide_team_profile_link: GYs,
  hide_team_profile_link_description: WYs,
  display: HYs,
  could_not_find_slug_to_publish_org: YYs,
  picklist: KYs,
  most_cancelled_bookings: ZYs,
  interface_language: XYs,
  interface_language_description: JYs,
  visitors_browser_language: QYs,
  name_or_email: eKs,
  salesforce_round_robin_skip_fallback_to_lead_owner: tKs,
  credit_purchase_failed: nKs,
  minimum_of_credits_required: oKs,
  enable_delegation_credential: rKs,
  enable_delegation_credential_description: iKs,
  disable_delegation_credential: aKs,
  disable_delegation_credential_description: sKs,
  last_active: cKs,
  member_since: lKs,
  last_updated: uKs,
  salesforce_on_cancel_write_to_event: dKs,
  salesforce_on_every_cancellation: _Ks,
  report_issue: pKs,
  report_issue_description: mKs,
  open_issue: fKs,
  this_is_your_current_plan: gKs,
  schedule_a_time: hKs,
  this_includes: vKs,
  oauth_client_updated_successfully: bKs,
  oauth_client_not_found: yKs,
  subscribe_to_platform: $Ks,
  error_accessing_webhooks: wKs,
  webhook_update_failed: kKs,
  webhook_create_failed: SKs,
  invalid_link: EKs,
  currently_subscribed_to_plan: xKs,
  user_team: CKs,
  client_id_copied: TKs,
  client_secret_copied: AKs,
  maintenance_message: IKs,
  your_payment_failed: OKs,
  check_your_inbox: NKs,
  account_created_premium_not_reserved: zKs,
  email_sent_with_activation_link: RKs,
  activate_account_to_purchase_username: PKs,
  open_in_gmail: DKs,
  dont_see_email: LKs,
  resend_in_seconds: MKs,
  resend: FKs,
  verification_email_sent: qKs,
  select_all_members: jKs,
  select_all_members_tooltip: VKs,
  form_settings: BKs,
  remove_whitelist_status: UKs,
  whitelist_user_workflows: GKs,
  user_workflows_whitelisted: WKs,
  user_workflows_unwhitelisted: HKs,
  date_and_time: YKs,
  email_reminder_upcoming_event_notice: KKs,
  email_reminder_triggered_by_workflow: ZKs,
  event_upper_case: XKs,
  scheduling_by: JKs,
  experience_review_prompt: QKs,
  improve_customer_experience_message: eZs,
  meeting_satisfaction_question: tZs,
  meeting_not_joined_question: nZs,
  reschedule_cta_short: oZs,
  hide_organizer_email: rZs,
  platform_customer_cant_create_organization: iZs,
  organization_customer_cant_create_platform: aZs,
  hide_organizer_email_description: sZs,
  you_and_conjunction: cZs,
  select_verified_email: lZs,
  add_verified_email: uZs,
  add_verified_emails: dZs,
  custom_reply_to_email_title: _Zs,
  custom_reply_to_email_description: pZs,
  email_survey_triggered_by_workflow: mZs,
  skip_trial: fZs,
  team_trials_skipped_successfully: gZs,
  sms_workflow_consent: hZs,
  routing_preview_more_info_found_insights: vZs,
  results: bZs,
  view_form: yZs,
  sms_opt_out_message: $Zs,
  team_credits_low_warning: wZs,
  user_credits_low_warning: kZs,
  action_required_out_of_credits: SZs,
  action_required_user_out_of_credits: EZs,
  low_credits_warning_message: xZs,
  low_credits_warning_message_user: CZs,
  credit_limit_reached_message: TZs,
  credit_limit_reached_message_user: AZs,
  current_credit_balance: IZs,
  current_balance: OZs,
  notification_about_your_booking: NZs,
  monthly_credits: zZs,
  total_credits: RZs,
  remaining_credits: PZs,
  remaining: DZs,
  total: LZs,
  additional_credits: MZs,
  routing_form_next_in_queue: FZs,
  routing_form_select_members_to_email: qZs,
  routing_incomplete_booking_tab: jZs,
  include_no_show_in_rr_calculation: VZs,
  recent_no_show_guests: BZs,
  recent_no_show_guests_tooltip: UZs,
  matching: GZs,
  event_redirect: WZs,
  reset_form: HZs,
  rr_settings_successfully_updated: YZs,
  distribution_basis_weighted_rr: KZs,
  timestamp_basis_description: ZZs,
  requires_credits: XZs,
  requires_credits_tooltip: JZs,
  available_credits: QZs,
  create_role: eXs,
  roles_and_permissions: tXs,
  roles_and_permissions_description: nXs,
  learn_more_permissions: oXs,
  role_name: rXs,
  role_name_required: iXs,
  role_name_placeholder: aXs,
  role_description: sXs,
  role_description_placeholder: cXs,
  default_role: lXs,
  custom_role: uXs,
  advanced: dXs,
  search_permissions: _Xs,
  all_permissions: pXs,
  none: mXs,
  read_only: fXs,
  pbac_desc_all_actions_all_resources: gXs,
  pbac_resource_all: hXs,
  pbac_resource_event_type: vXs,
  pbac_resource_team: bXs,
  pbac_resource_organization: yXs,
  pbac_resource_booking: $Xs,
  pbac_resource_insights: wXs,
  pbac_resource_role: kXs,
  pbac_resource_routing_form: SXs,
  pbac_resource_workflow: EXs,
  pbac_action_all: xXs,
  pbac_action_create: CXs,
  pbac_action_read: TXs,
  pbac_action_update: AXs,
  pbac_action_delete: IXs,
  pbac_action_manage: OXs,
  pbac_action_invite: NXs,
  pbac_action_remove: zXs,
  pbac_action_change_member_role: RXs,
  pbac_action_list_members: PXs,
  pbac_action_manage_billing: DXs,
  pbac_action_read_team_bookings: LXs,
  pbac_action_read_org_bookings: MXs,
  pbac_action_read_recordings: FXs,
  pbac_action_impersonate: qXs,
  role_created_successfully: jXs,
  role_updated_successfully: VXs,
  delete_role: BXs,
  confirm_delete_role: UXs,
  role_deleted_successfully: GXs,
  error_creating_role: WXs,
  error_updating_role: HXs,
  pbac_desc_create_roles: YXs,
  pbac_resource_attributes: KXs,
  pbac_desc_view_organization_attributes: ZXs,
  pbac_desc_update_organization_attributes: XXs,
  pbac_desc_delete_organization_attributes: JXs,
  pbac_desc_create_organization_attributes: QXs,
  pbac_desc_view_roles: eJs,
  pbac_desc_update_roles: tJs,
  pbac_desc_delete_roles: nJs,
  pbac_desc_create_workflows: oJs,
  set_up_required: rJs,
  pbac_desc_view_workflows: iJs,
  pbac_desc_update_workflows: aJs,
  pbac_desc_delete_workflows: sJs,
  pbac_resource_webhook: cJs,
  pbac_resource_availability: lJs,
  pbac_resource_out_of_office: uJs,
  pbac_desc_create_webhooks: dJs,
  pbac_desc_view_webhooks: _Js,
  pbac_desc_update_webhooks: pJs,
  pbac_desc_delete_webhooks: mJs,
  pbac_desc_create_availability: fJs,
  pbac_desc_view_availability: gJs,
  pbac_desc_update_availability: hJs,
  pbac_desc_delete_availability: vJs,
  pbac_desc_create_out_of_office: bJs,
  pbac_desc_view_out_of_office: yJs,
  pbac_desc_update_out_of_office: $Js,
  pbac_desc_delete_out_of_office: wJs,
  pbac_desc_manage_workflows: kJs,
  pbac_desc_create_event_types: SJs,
  pbac_desc_view_event_types: EJs,
  pbac_desc_update_event_types: xJs,
  pbac_desc_delete_event_types: CJs,
  pbac_desc_manage_event_types: TJs,
  pbac_desc_create_teams: AJs,
  pbac_desc_view_team_details: IJs,
  pbac_desc_update_team_settings: OJs,
  pbac_desc_delete_team: NJs,
  pbac_desc_invite_team_members: zJs,
  pbac_desc_remove_team_members: RJs,
  pbac_desc_change_team_member_role: PJs,
  pbac_desc_impersonate_team_members: DJs,
  pbac_desc_manage_teams: LJs,
  pbac_desc_create_organization: MJs,
  pbac_desc_view_organization_details: FJs,
  pbac_desc_list_organization_members: qJs,
  pbac_desc_invite_organization_members: jJs,
  pbac_desc_remove_organization_members: VJs,
  pbac_desc_manage_organization_billing: BJs,
  pbac_desc_change_organization_member_role: UJs,
  pbac_desc_impersonate_organization_members: GJs,
  pbac_desc_edit_organization_settings: WJs,
  pbac_desc_manage_organizations: HJs,
  pbac_desc_view_bookings: YJs,
  pbac_desc_view_team_bookings: KJs,
  pbac_desc_view_organization_bookings: ZJs,
  pbac_desc_view_booking_recordings: XJs,
  pbac_desc_update_bookings: JJs,
  pbac_desc_manage_bookings: QJs,
  pbac_desc_view_team_insights: eQs,
  pbac_desc_manage_team_insights: tQs,
  pbac_desc_create_routing_forms: nQs,
  pbac_desc_view_routing_forms: oQs,
  pbac_desc_update_routing_forms: rQs,
  pbac_desc_delete_routing_forms: iQs,
  read_permission_auto_enabled_tooltip: aQs,
  choose_restriction_schedule: sQs,
  restriction_schedule_description: cQs,
  use_booker_timezone: lQs,
  use_booker_timezone_info: uQs,
  load_balancing_warning: dQs,
  rr_load_balancing_disabled: _Qs,
  rr_load_balancing_disabled_with_groups: pQs,
  round_robin_settings_description: mQs,
  round_robin_settings_updated_successfully: fQs,
  booking_creation_time: gQs,
  meeting_start_time: hQs,
  members_affected_by_disabling_delegation_credential: vQs,
  no_members_affected_by_disabling_delegation_credential: bQs,
  download_expense_log: yQs,
  error_downloading_expense_log: $Qs,
  offer_to_reschedule_last_booking: wQs,
  booker_limit_exceeded_error: kQs,
  booker_limit_exceeded_error_reschedule: SQs,
  duration_min_error: EQs,
  duration_max_error: xQs,
  booking_not_allowed_by_restriction_schedule_error: CQs,
  restriction_schedule_not_found_error: TQs,
  converted_image_size_limit_exceed: AQs,
  add_group: IQs,
  routing_funnel: OQs,
  routing_funnel_total_submissions: NQs,
  routing_funnel_successful_routings: zQs,
  routing_funnel_accepted_bookings: RQs,
  license_key: PQs,
  license_selection_title: DQs,
  license_selection_description: LQs,
  agplv3_license_description: MQs,
  enter_license_key: FQs,
  enter_your_license_key: qQs,
  enter_existing_license: jQs,
  enter_license_key_description: VQs,
  license_key_placeholder: BQs,
  save_license_key: UQs,
  signature_token_optional: GQs,
  signature_token_description: WQs,
  need_a_license: HQs,
  license_key_required: YQs,
  invalid_license_key: KQs,
  license_validation_failed: ZQs,
  attachments_optional: XQs,
  send_message: JQs,
  describe_the_issue: QQs,
  file_size_limit_exceed: eec,
  invalid_file_type: tec,
  invalid_file_type_extension: nec,
  max_files_exceeded: oec,
  files_uploaded_successfully: rec,
  file_upload_instructions: iec,
  license_key_saved: aec,
  timezone_mismatch_tooltip: sec,
  show_optimized_slots: cec,
  show_optimized_slots_description: lec,
  failed_bookings_by_field: uec,
  failed_bookings: dec,
  event_type_no_hosts: _ec,
  cache_status: pec,
  cache_last_updated: mec,
  delete_cached_data: fec,
  cache_deleted_successfully: gec,
  error_deleting_cache: hec,
  confirm_delete_cache: vec,
  yes_delete_cache: bec,
  remainder_of_maximum_uses_left_plural: yec,
  remainder_of_maximum_use_left_singular: $ec,
  expires_on_date: wec,
  single_use: kec,
  time_based_expiration: Sec,
  usage_based_expiration: Eec,
  number_of_uses: xec,
  expires_on: Cec,
  max_usage_count: Tec,
  link_settings: Aec,
  link_expired_on_date: Iec,
  usage_limit_reached: Oec,
  usage_count_error: Nec,
  private_link_expired: zec,
  time_based_expiration_description: Rec,
  time_based_generic_expiration_description: Pec,
  usage_based_expiration_description: Dec,
  usage_based_generic_expiration_description: Lec,
  usage_based_expiration_description_plural: Mec,
  webhook_trigger_event: Fec,
  webhook_created_at: qec,
  webhook_type: jec,
  set_up_agent: Vec,
  webhook_title: Bec,
  webhook_start_time: Uec,
  webhook_end_time: Gec,
  webhook_description: Wec,
  webhook_location: Hec,
  webhook_uid: Yec,
  webhook_reschedule_uid: Kec,
  webhook_cancellation_reason: Zec,
  webhook_rejection_reason: Xec,
  webhook_organizer_name: Jec,
  webhook_organizer_email: Qec,
  webhook_organizer_timezone: etc,
  webhook_organizer_locale: ttc,
  webhook_organizer_username: ntc,
  webhook_organizer_username_in_org: otc,
  webhook_attendee_name: rtc,
  webhook_attendee_email: itc,
  webhook_attendee_timezone: atc,
  webhook_attendee_locale: stc,
  webhook_team_name: ctc,
  webhook_team_members: ltc,
  webhook_video_call_url: utc,
  webhook_hide_variables: dtc,
  webhook_show_variable: _tc,
  webhook_event_and_booking: ptc,
  webhook_people: mtc,
  webhook_teams: ftc,
  webhook_metadata: gtc,
  stats: htc,
  booking_status: vtc,
  visit: btc,
  location_custom_label_input_label: ytc,
  meeting_link: $tc,
  session_outcome: wtc,
  call_created: ktc,
  voicemail: Stc,
  my_bookings: Etc,
  phone: xtc,
  free: Ctc,
  user_email: Ttc,
  user_name: Atc,
  expand_panel: Itc,
  collapse_panel: Otc,
  email_verification_required: Ntc,
  invalid_verification_code: ztc,
  you_have_one_team: Rtc,
  consider_consolidating_one_team_org: Ptc,
  consider_consolidating_multi_team_org: Dtc,
  message_sent: Ltc,
  support_message_sent_description: Mtc,
  search_variables: Ftc,
  support_message_placeholder: qtc,
  send_another_message: jtc,
  sending: Vtc,
  no_variables_found: Btc,
  credits_required: Utc,
  web_call_credits_info: Gtc,
  web_call_no_credits: Wtc,
  purchase_credits: Htc,
  credits_required_tooltip: Ytc,
  api_key_name_too_long: Ktc,
  auto_charge_for_last_minute_cancellation: Ztc,
  before_scheduled_start_time: Xtc,
  cancel_booking_acknowledge_no_show_fee: Jtc,
  contact_organizer: Qtc,
  booking_time_option: enc,
  booking_time_option_description: tnc,
  created_at_option: nnc,
  created_at_option_description: onc,
  call_details: rnc,
  call_id: inc,
  call_information: anc,
  sentiment: snc,
  disconnect_reason: cnc,
  call_summary: lnc,
  transcription: unc,
  event_details: dnc,
  agent: _nc,
  no_transcript_available: pnc,
  testing_sms_workflow_info_message: mnc,
  start_from_scratch_title: fnc,
  start_from_scratch_description: gnc,
  cal_ai_template_title: hnc,
  cal_ai_template_description: vnc,
  voice: bnc,
  select_voice: ync,
  select_voice_for_agent: $nc,
  choose_a_voice_for_your_agent: wnc,
  trait: knc,
  voice_id: Snc,
  use_voice: Enc,
  current_voice: xnc,
  setup_incoming_agent: Cnc,
  setup_incoming_agent_description: Tnc,
  connect_a_phone_number_first: Anc,
  setup_agent_for_incoming_calls: Inc,
  configure_agent_to_handle_incoming_calls: Onc,
  incoming_calls: Nnc,
  outgoing_calls: znc,
  inbound_agent_setup_success: Rnc,
  inbound_agent_configured: Pnc,
  setup_inbound_agent: Dnc,
  please_select_event_type_first: Lnc,
  edit_configuration: Mnc,
  select_event_type_for_inbound_calls: Fnc,
  setup_inbound_agent_for_incoming_calls: qnc,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: jnc
}, hM = Cr({
  clientId: "",
  accessToken: "",
  organizationId: 0,
  options: { refreshUrl: "", apiUrl: "" },
  error: "",
  getClient: () => {
  },
  isEmbed: !1
}), cr = () => bo(hM), Bnc = "get-me", Ev = (e = !1) => {
  const t = `/${rs.me}`;
  return mr({
    queryKey: [Bnc],
    queryFn: () => At == null ? void 0 : At.get(t).then((o) => {
      if (o.data.status === Nn)
        return o.data;
      throw new Error(o.data.error.message);
    }),
    enabled: !!At.getAuthorizationHeader() && !e
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var zp = function() {
  return zp = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, zp.apply(this, arguments);
};
function jie(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function Unc(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Gnc(e) {
  var t = xt();
  return yt(function() {
    t.current = e;
  }), t.current;
}
const Wnc = ({
  isEmbed: e,
  clientId: t,
  apiUrl: n,
  refreshUrl: o,
  onError: r,
  onSuccess: i
}) => {
  const a = Gnc(t), [s, c] = it(!1);
  return yt(() => {
    n && (At.setUrl(n), c(!0)), o && At.setRefreshUrl(o);
  }, [n, o]), yt(() => {
    if (!e && t && At.getUrl() && a !== t)
      try {
        At.get(`/provider/${t}`).then((l) => {
          l.data.status === Nn && i(l.data.data), At.setClientIdHeader(t);
        }).catch((l) => {
          var u;
          ((u = l.response) == null ? void 0 : u.status) === 401 && r("Invalid oAuth Client.");
        });
      } catch (l) {
        console.error(l);
      }
  }, [e, t, r, a, i, At.getUrl()]), { isInit: s };
};
var Ax = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ax.exports;
(function(e, t) {
  (function() {
    var n, o = "4.17.21", r = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", l = 500, u = "__lodash_placeholder__", d = 1, _ = 2, p = 4, g = 1, f = 2, h = 1, $ = 2, v = 4, b = 8, y = 16, w = 32, N = 64, M = 128, q = 256, L = 512, R = 30, T = "...", D = 800, A = 16, S = 1, E = 2, x = 3, k = 1 / 0, I = 9007199254740991, z = 17976931348623157e292, F = NaN, P = 4294967295, O = P - 1, V = P >>> 1, U = [
      ["ary", M],
      ["bind", h],
      ["bindKey", $],
      ["curry", b],
      ["curryRight", y],
      ["flip", L],
      ["partial", w],
      ["partialRight", N],
      ["rearg", q]
    ], H = "[object Arguments]", J = "[object Array]", le = "[object AsyncFunction]", ae = "[object Boolean]", Y = "[object Date]", re = "[object DOMException]", ie = "[object Error]", _e = "[object Function]", he = "[object GeneratorFunction]", be = "[object Map]", Q = "[object Number]", me = "[object Null]", ne = "[object Object]", pe = "[object Promise]", ge = "[object Proxy]", ve = "[object RegExp]", Te = "[object Set]", Re = "[object String]", Me = "[object Symbol]", et = "[object Undefined]", st = "[object WeakMap]", De = "[object WeakSet]", ze = "[object ArrayBuffer]", Pe = "[object DataView]", je = "[object Float32Array]", He = "[object Float64Array]", Xe = "[object Int8Array]", at = "[object Int16Array]", wt = "[object Int32Array]", Je = "[object Uint8Array]", vt = "[object Uint8ClampedArray]", Ot = "[object Uint16Array]", Ft = "[object Uint32Array]", wn = /\b__p \+= '';/g, un = /\b(__p \+=) '' \+/g, pn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Dn = /&(?:amp|lt|gt|quot|#39);/g, Rn = /[&<>"']/g, Ln = RegExp(Dn.source), Yn = RegExp(Rn.source), Qt = /<%-([\s\S]+?)%>/g, fn = /<%([\s\S]+?)%>/g, qn = /<%=([\s\S]+?)%>/g, Xn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Qn = /^\w*$/, In = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $n = /[\\^$.*+?()[\]{}|]/g, uo = RegExp($n.source), go = /^\s+/, Rr = /\s/, qo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ho = /\{\n\/\* \[wrapped with (.+)\] \*/, Ut = /,? & /, Kt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, an = /[()=,{}\[\]\/\s]/, Gn = /\\(\\)?/g, An = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, hn = /\w*$/, zn = /^[-+]0x[0-9a-f]+$/i, gn = /^0b[01]+$/i, kn = /^\[object .+?Constructor\]$/, dt = /^0o[0-7]+$/i, Pt = /^(?:0|[1-9]\d*)$/, cn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, sn = /($^)/, ao = /['\n\r\u2028\u2029\\]/g, Ze = "\\ud800-\\udfff", bt = "\\u0300-\\u036f", Wt = "\\ufe20-\\ufe2f", xn = "\\u20d0-\\u20ff", It = bt + Wt + xn, Jn = "\\u2700-\\u27bf", ur = "a-z\\xdf-\\xf6\\xf8-\\xff", er = "\\xac\\xb1\\xd7\\xf7", ya = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ai = "\\u2000-\\u206f", Ka = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Wc = "A-Z\\xc0-\\xd6\\xd8-\\xde", Q_ = "\\ufe0e\\ufe0f", cm = er + ya + Ai + Ka, Pr = "['’]", ji = "[" + Ze + "]", Ks = "[" + cm + "]", Or = "[" + It + "]", Xr = "\\d+", mi = "[" + Jn + "]", Gd = "[" + ur + "]", Hc = "[^" + Ze + cm + Xr + Jn + ur + Wc + "]", iu = "\\ud83c[\\udffb-\\udfff]", Wd = "(?:" + Or + "|" + iu + ")", ep = "[^" + Ze + "]", ss = "(?:\\ud83c[\\udde6-\\uddff]){2}", _c = "[\\ud800-\\udbff][\\udc00-\\udfff]", Co = "[" + Wc + "]", Hd = "\\u200d", xs = "(?:" + Gd + "|" + Hc + ")", ea = "(?:" + Co + "|" + Hc + ")", Zs = "(?:" + Pr + "(?:d|ll|m|re|s|t|ve))?", cs = "(?:" + Pr + "(?:D|LL|M|RE|S|T|VE))?", Ju = Wd + "?", Sl = "[" + Q_ + "]?", Qu = "(?:" + Hd + "(?:" + [ep, ss, _c].join("|") + ")" + Sl + Ju + ")*", au = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", tp = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Yd = Sl + Ju + Qu, su = "(?:" + [mi, ss, _c].join("|") + ")" + Yd, Kd = "(?:" + [ep + Or + "?", Or, ss, _c, ji].join("|") + ")", Cs = RegExp(Pr, "g"), Zd = RegExp(Or, "g"), Yc = RegExp(iu + "(?=" + iu + ")|" + Kd + Yd, "g"), fi = RegExp([
      Co + "?" + Gd + "+" + Zs + "(?=" + [Ks, Co, "$"].join("|") + ")",
      ea + "+" + cs + "(?=" + [Ks, Co + xs, "$"].join("|") + ")",
      Co + "?" + xs + "+" + Zs,
      Co + "+" + cs,
      tp,
      au,
      Xr,
      su
    ].join("|"), "g"), pc = RegExp("[" + Hd + Ze + It + Q_ + "]"), Xd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ed = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Jd = -1, Dr = {};
    Dr[je] = Dr[He] = Dr[Xe] = Dr[at] = Dr[wt] = Dr[Je] = Dr[vt] = Dr[Ot] = Dr[Ft] = !0, Dr[H] = Dr[J] = Dr[ze] = Dr[ae] = Dr[Pe] = Dr[Y] = Dr[ie] = Dr[_e] = Dr[be] = Dr[Q] = Dr[ne] = Dr[ve] = Dr[Te] = Dr[Re] = Dr[st] = !1;
    var Po = {};
    Po[H] = Po[J] = Po[ze] = Po[Pe] = Po[ae] = Po[Y] = Po[je] = Po[He] = Po[Xe] = Po[at] = Po[wt] = Po[be] = Po[Q] = Po[ne] = Po[ve] = Po[Te] = Po[Re] = Po[Me] = Po[Je] = Po[vt] = Po[Ot] = Po[Ft] = !0, Po[ie] = Po[_e] = Po[st] = !1;
    var mc = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, El = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, xl = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, td = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, nd = parseFloat, np = parseInt, Qd = typeof Dt == "object" && Dt && Dt.Object === Object && Dt, lm = typeof self == "object" && self && self.Object === Object && self, ma = Qd || lm || Function("return this")(), e_ = t && !t.nodeType && t, cu = e_ && !0 && e && !e.nodeType && e, op = cu && cu.exports === e_, um = op && Qd.process, ls = function() {
      try {
        var Be = cu && cu.require && cu.require("util").types;
        return Be || um && um.binding && um.binding("util");
      } catch {
      }
    }(), Rf = ls && ls.isArrayBuffer, Pf = ls && ls.isDate, Kc = ls && ls.isMap, t_ = ls && ls.isRegExp, od = ls && ls.isSet, rd = ls && ls.isTypedArray;
    function _o(Be, We, mt) {
      switch (mt.length) {
        case 0:
          return Be.call(We);
        case 1:
          return Be.call(We, mt[0]);
        case 2:
          return Be.call(We, mt[0], mt[1]);
        case 3:
          return Be.call(We, mt[0], mt[1], mt[2]);
      }
      return Be.apply(We, mt);
    }
    function dm(Be, We, mt, Gt) {
      for (var on = -1, no = Be == null ? 0 : Be.length; ++on < no; ) {
        var gr = Be[on];
        We(Gt, gr, mt(gr), Be);
      }
      return Gt;
    }
    function $a(Be, We) {
      for (var mt = -1, Gt = Be == null ? 0 : Be.length; ++mt < Gt && We(Be[mt], mt, Be) !== !1; )
        ;
      return Be;
    }
    function Cl(Be, We) {
      for (var mt = Be == null ? 0 : Be.length; mt-- && We(Be[mt], mt, Be) !== !1; )
        ;
      return Be;
    }
    function wa(Be, We) {
      for (var mt = -1, Gt = Be == null ? 0 : Be.length; ++mt < Gt; )
        if (!We(Be[mt], mt, Be))
          return !1;
      return !0;
    }
    function ta(Be, We) {
      for (var mt = -1, Gt = Be == null ? 0 : Be.length, on = 0, no = []; ++mt < Gt; ) {
        var gr = Be[mt];
        We(gr, mt, Be) && (no[on++] = gr);
      }
      return no;
    }
    function Tl(Be, We) {
      var mt = Be == null ? 0 : Be.length;
      return !!mt && As(Be, We, 0) > -1;
    }
    function lu(Be, We, mt) {
      for (var Gt = -1, on = Be == null ? 0 : Be.length; ++Gt < on; )
        if (mt(We, Be[Gt]))
          return !0;
      return !1;
    }
    function Zo(Be, We) {
      for (var mt = -1, Gt = Be == null ? 0 : Be.length, on = Array(Gt); ++mt < Gt; )
        on[mt] = We(Be[mt], mt, Be);
      return on;
    }
    function nn(Be, We) {
      for (var mt = -1, Gt = We.length, on = Be.length; ++mt < Gt; )
        Be[on + mt] = We[mt];
      return Be;
    }
    function Ts(Be, We, mt, Gt) {
      var on = -1, no = Be == null ? 0 : Be.length;
      for (Gt && no && (mt = Be[++on]); ++on < no; )
        mt = We(mt, Be[on], on, Be);
      return mt;
    }
    function po(Be, We, mt, Gt) {
      var on = Be == null ? 0 : Be.length;
      for (Gt && on && (mt = Be[--on]); on--; )
        mt = We(mt, Be[on], on, Be);
      return mt;
    }
    function Zc(Be, We) {
      for (var mt = -1, Gt = Be == null ? 0 : Be.length; ++mt < Gt; )
        if (We(Be[mt], mt, Be))
          return !0;
      return !1;
    }
    var _m = Za("length");
    function Er(Be) {
      return Be.split("");
    }
    function uu(Be) {
      return Be.match(Kt) || [];
    }
    function du(Be, We, mt) {
      var Gt;
      return mt(Be, function(on, no, gr) {
        if (We(on, no, gr))
          return Gt = no, !1;
      }), Gt;
    }
    function na(Be, We, mt, Gt) {
      for (var on = Be.length, no = mt + (Gt ? 1 : -1); Gt ? no-- : ++no < on; )
        if (We(Be[no], no, Be))
          return no;
      return -1;
    }
    function As(Be, We, mt) {
      return We === We ? fm(Be, We, mt) : na(Be, n_, mt);
    }
    function pm(Be, We, mt, Gt) {
      for (var on = mt - 1, no = Be.length; ++on < no; )
        if (Gt(Be[on], We))
          return on;
      return -1;
    }
    function n_(Be) {
      return Be !== Be;
    }
    function Ma(Be, We) {
      var mt = Be == null ? 0 : Be.length;
      return mt ? id(Be, We) / mt : F;
    }
    function Za(Be) {
      return function(We) {
        return We == null ? n : We[Be];
      };
    }
    function Al(Be) {
      return function(We) {
        return Be == null ? n : Be[We];
      };
    }
    function Il(Be, We, mt, Gt, on) {
      return on(Be, function(no, gr, Xo) {
        mt = Gt ? (Gt = !1, no) : We(mt, no, gr, Xo);
      }), mt;
    }
    function rp(Be, We) {
      var mt = Be.length;
      for (Be.sort(We); mt--; )
        Be[mt] = Be[mt].value;
      return Be;
    }
    function id(Be, We) {
      for (var mt, Gt = -1, on = Be.length; ++Gt < on; ) {
        var no = We(Be[Gt]);
        no !== n && (mt = mt === n ? no : mt + no);
      }
      return mt;
    }
    function Ol(Be, We) {
      for (var mt = -1, Gt = Array(Be); ++mt < Be; )
        Gt[mt] = We(mt);
      return Gt;
    }
    function To(Be, We) {
      return Zo(We, function(mt) {
        return [mt, Be[mt]];
      });
    }
    function Na(Be) {
      return Be && Be.slice(0, Ie(Be) + 1).replace(go, "");
    }
    function fa(Be) {
      return function(We) {
        return Be(We);
      };
    }
    function Is(Be, We) {
      return Zo(We, function(mt) {
        return Be[mt];
      });
    }
    function Xc(Be, We) {
      return Be.has(We);
    }
    function ad(Be, We) {
      for (var mt = -1, Gt = Be.length; ++mt < Gt && As(We, Be[mt], 0) > -1; )
        ;
      return mt;
    }
    function sd(Be, We) {
      for (var mt = Be.length; mt-- && As(We, Be[mt], 0) > -1; )
        ;
      return mt;
    }
    function Xs(Be, We) {
      for (var mt = Be.length, Gt = 0; mt--; )
        Be[mt] === We && ++Gt;
      return Gt;
    }
    var fr = Al(mc), Ii = Al(El);
    function Fa(Be) {
      return "\\" + td[Be];
    }
    function ip(Be, We) {
      return Be == null ? n : Be[We];
    }
    function Xa(Be) {
      return pc.test(Be);
    }
    function Vi(Be) {
      return Xd.test(Be);
    }
    function Bi(Be) {
      for (var We, mt = []; !(We = Be.next()).done; )
        mt.push(We.value);
      return mt;
    }
    function Jr(Be) {
      var We = -1, mt = Array(Be.size);
      return Be.forEach(function(Gt, on) {
        mt[++We] = [on, Gt];
      }), mt;
    }
    function oa(Be, We) {
      return function(mt) {
        return Be(We(mt));
      };
    }
    function Do(Be, We) {
      for (var mt = -1, Gt = Be.length, on = 0, no = []; ++mt < Gt; ) {
        var gr = Be[mt];
        (gr === We || gr === u) && (Be[mt] = u, no[on++] = mt);
      }
      return no;
    }
    function Jc(Be) {
      var We = -1, mt = Array(Be.size);
      return Be.forEach(function(Gt) {
        mt[++We] = Gt;
      }), mt;
    }
    function mm(Be) {
      var We = -1, mt = Array(Be.size);
      return Be.forEach(function(Gt) {
        mt[++We] = [Gt, Gt];
      }), mt;
    }
    function fm(Be, We, mt) {
      for (var Gt = mt - 1, on = Be.length; ++Gt < on; )
        if (Be[Gt] === We)
          return Gt;
      return -1;
    }
    function G(Be, We, mt) {
      for (var Gt = mt + 1; Gt--; )
        if (Be[Gt] === We)
          return Gt;
      return Gt;
    }
    function ce(Be) {
      return Xa(Be) ? Ge(Be) : _m(Be);
    }
    function Se(Be) {
      return Xa(Be) ? Qe(Be) : Er(Be);
    }
    function Ie(Be) {
      for (var We = Be.length; We-- && Rr.test(Be.charAt(We)); )
        ;
      return We;
    }
    var Ae = Al(xl);
    function Ge(Be) {
      for (var We = Yc.lastIndex = 0; Yc.test(Be); )
        ++We;
      return We;
    }
    function Qe(Be) {
      return Be.match(Yc) || [];
    }
    function gt(Be) {
      return Be.match(fi) || [];
    }
    var Nt = function Be(We) {
      We = We == null ? ma : Ct.defaults(ma.Object(), We, Ct.pick(ma, ed));
      var mt = We.Array, Gt = We.Date, on = We.Error, no = We.Function, gr = We.Math, Xo = We.Object, fc = We.RegExp, o_ = We.String, gc = We.TypeError, hc = mt.prototype, gm = no.prototype, vc = Xo.prototype, r_ = We["__core-js_shared__"], ap = gm.toString, yr = vc.hasOwnProperty, Df = 0, i_ = function() {
        var C = /[^.]+$/.exec(r_ && r_.keys && r_.keys.IE_PROTO || "");
        return C ? "Symbol(src)_1." + C : "";
      }(), Lf = vc.toString, Gg = ap.call(Xo), _u = ma._, Wg = fc(
        "^" + ap.call(yr).replace($n, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), sp = op ? We.Buffer : n, ka = We.Symbol, ra = We.Uint8Array, Vn = sp ? sp.allocUnsafe : n, Os = oa(Xo.getPrototypeOf, Xo), cp = Xo.create, Nl = vc.propertyIsEnumerable, a_ = hc.splice, lp = ka ? ka.isConcatSpreadable : n, pu = ka ? ka.iterator : n, zl = ka ? ka.toStringTag : n, Ns = function() {
        try {
          var C = ah(Xo, "defineProperty");
          return C({}, "", {}), C;
        } catch {
        }
      }(), Hg = We.clearTimeout !== ma.clearTimeout && We.clearTimeout, Mf = Gt && Gt.now !== ma.Date.now && Gt.now, qv = We.setTimeout !== ma.setTimeout && We.setTimeout, cd = gr.ceil, Z = gr.floor, B = Xo.getOwnPropertySymbols, K = sp ? sp.isBuffer : n, ue = We.isFinite, fe = hc.join, ke = oa(Xo.keys, Xo), Ee = gr.max, qe = gr.min, ot = Gt.now, $t = We.parseInt, Vt = gr.random, Mt = hc.reverse, zt = ah(We, "DataView"), Rt = ah(We, "Map"), Sn = ah(We, "Promise"), Cn = ah(We, "Set"), ro = ah(We, "WeakMap"), Uo = ah(Xo, "create"), Oi = ro && new ro(), ga = {}, bc = sh(zt), ld = sh(Rt), jv = sh(Sn), Js = sh(Cn), Yg = sh(ro), s_ = ka ? ka.prototype : n, us = s_ ? s_.valueOf : n, Qs = s_ ? s_.toString : n;
      function Le(C) {
        if (za(C) && !tr(C) && !(C instanceof jo)) {
          if (C instanceof ds)
            return C;
          if (yr.call(C, "__wrapped__"))
            return pB(C);
        }
        return new ds(C);
      }
      var so = /* @__PURE__ */ function() {
        function C() {
        }
        return function(j) {
          if (!xa(j))
            return {};
          if (cp)
            return cp(j);
          C.prototype = j;
          var ee = new C();
          return C.prototype = n, ee;
        };
      }();
      function c_() {
      }
      function ds(C, j) {
        this.__wrapped__ = C, this.__actions__ = [], this.__chain__ = !!j, this.__index__ = 0, this.__values__ = n;
      }
      Le.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Qt,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: fn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: qn,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Le
        }
      }, Le.prototype = c_.prototype, Le.prototype.constructor = Le, ds.prototype = so(c_.prototype), ds.prototype.constructor = ds;
      function jo(C) {
        this.__wrapped__ = C, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = P, this.__views__ = [];
      }
      function ud() {
        var C = new jo(this.__wrapped__);
        return C.__actions__ = to(this.__actions__), C.__dir__ = this.__dir__, C.__filtered__ = this.__filtered__, C.__iteratees__ = to(this.__iteratees__), C.__takeCount__ = this.__takeCount__, C.__views__ = to(this.__views__), C;
      }
      function Kg() {
        if (this.__filtered__) {
          var C = new jo(this);
          C.__dir__ = -1, C.__filtered__ = !0;
        } else
          C = this.clone(), C.__dir__ *= -1;
        return C;
      }
      function up() {
        var C = this.__wrapped__.value(), j = this.__dir__, ee = tr(C), $e = j < 0, Ne = ee ? C.length : 0, Ve = J$e(0, Ne, this.__views__), tt = Ve.start, ft = Ve.end, Et = ft - tt, Zt = $e ? ft : tt - 1, Xt = this.__iteratees__, rn = Xt.length, Mn = 0, oo = qe(Et, this.__takeCount__);
        if (!ee || !$e && Ne == Et && oo == Et)
          return ye(C, this.__actions__);
        var Ao = [];
        e:
          for (; Et-- && Mn < oo; ) {
            Zt += j;
            for (var dr = -1, Io = C[Zt]; ++dr < rn; ) {
              var $r = Xt[dr], Ar = $r.iteratee, hu = $r.type, il = Ar(Io);
              if (hu == E)
                Io = il;
              else if (!il) {
                if (hu == S)
                  continue e;
                break e;
              }
            }
            Ao[Mn++] = Io;
          }
        return Ao;
      }
      jo.prototype = so(c_.prototype), jo.prototype.constructor = jo;
      function mu(C) {
        var j = -1, ee = C == null ? 0 : C.length;
        for (this.clear(); ++j < ee; ) {
          var $e = C[j];
          this.set($e[0], $e[1]);
        }
      }
      function Vv() {
        this.__data__ = Uo ? Uo(null) : {}, this.size = 0;
      }
      function hm(C) {
        var j = this.has(C) && delete this.__data__[C];
        return this.size -= j ? 1 : 0, j;
      }
      function vm(C) {
        var j = this.__data__;
        if (Uo) {
          var ee = j[C];
          return ee === c ? n : ee;
        }
        return yr.call(j, C) ? j[C] : n;
      }
      function Zg(C) {
        var j = this.__data__;
        return Uo ? j[C] !== n : yr.call(j, C);
      }
      function Bv(C, j) {
        var ee = this.__data__;
        return this.size += this.has(C) ? 0 : 1, ee[C] = Uo && j === n ? c : j, this;
      }
      mu.prototype.clear = Vv, mu.prototype.delete = hm, mu.prototype.get = vm, mu.prototype.has = Zg, mu.prototype.set = Bv;
      function yc(C) {
        var j = -1, ee = C == null ? 0 : C.length;
        for (this.clear(); ++j < ee; ) {
          var $e = C[j];
          this.set($e[0], $e[1]);
        }
      }
      function Ff() {
        this.__data__ = [], this.size = 0;
      }
      function bm(C) {
        var j = this.__data__, ee = Qg(j, C);
        if (ee < 0)
          return !1;
        var $e = j.length - 1;
        return ee == $e ? j.pop() : a_.call(j, ee, 1), --this.size, !0;
      }
      function ym(C) {
        var j = this.__data__, ee = Qg(j, C);
        return ee < 0 ? n : j[ee][1];
      }
      function fu(C) {
        return Qg(this.__data__, C) > -1;
      }
      function $$(C, j) {
        var ee = this.__data__, $e = Qg(ee, C);
        return $e < 0 ? (++this.size, ee.push([C, j])) : ee[$e][1] = j, this;
      }
      yc.prototype.clear = Ff, yc.prototype.delete = bm, yc.prototype.get = ym, yc.prototype.has = fu, yc.prototype.set = $$;
      function ec(C) {
        var j = -1, ee = C == null ? 0 : C.length;
        for (this.clear(); ++j < ee; ) {
          var $e = C[j];
          this.set($e[0], $e[1]);
        }
      }
      function w$() {
        this.size = 0, this.__data__ = {
          hash: new mu(),
          map: new (Rt || yc)(),
          string: new mu()
        };
      }
      function Uv(C) {
        var j = V1(this, C).delete(C);
        return this.size -= j ? 1 : 0, j;
      }
      function Xg(C) {
        return V1(this, C).get(C);
      }
      function yo(C) {
        return V1(this, C).has(C);
      }
      function Sa(C, j) {
        var ee = V1(this, C), $e = ee.size;
        return ee.set(C, j), this.size += ee.size == $e ? 0 : 1, this;
      }
      ec.prototype.clear = w$, ec.prototype.delete = Uv, ec.prototype.get = Xg, ec.prototype.has = yo, ec.prototype.set = Sa;
      function Ni(C) {
        var j = -1, ee = C == null ? 0 : C.length;
        for (this.__data__ = new ec(); ++j < ee; )
          this.add(C[j]);
      }
      function Qc(C) {
        return this.__data__.set(C, c), this;
      }
      function $m(C) {
        return this.__data__.has(C);
      }
      Ni.prototype.add = Ni.prototype.push = Qc, Ni.prototype.has = $m;
      function gi(C) {
        var j = this.__data__ = new yc(C);
        this.size = j.size;
      }
      function el() {
        this.__data__ = new yc(), this.size = 0;
      }
      function Rl(C) {
        var j = this.__data__, ee = j.delete(C);
        return this.size = j.size, ee;
      }
      function dd(C) {
        return this.__data__.get(C);
      }
      function l_(C) {
        return this.__data__.has(C);
      }
      function tl(C, j) {
        var ee = this.__data__;
        if (ee instanceof yc) {
          var $e = ee.__data__;
          if (!Rt || $e.length < r - 1)
            return $e.push([C, j]), this.size = ++ee.size, this;
          ee = this.__data__ = new ec($e);
        }
        return ee.set(C, j), this.size = ee.size, this;
      }
      gi.prototype.clear = el, gi.prototype.delete = Rl, gi.prototype.get = dd, gi.prototype.has = l_, gi.prototype.set = tl;
      function _d(C, j) {
        var ee = tr(C), $e = !ee && ch(C), Ne = !ee && !$e && Bf(C), Ve = !ee && !$e && !Ne && Jv(C), tt = ee || $e || Ne || Ve, ft = tt ? Ol(C.length, o_) : [], Et = ft.length;
        for (var Zt in C)
          (j || yr.call(C, Zt)) && !(tt && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Zt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          Ne && (Zt == "offset" || Zt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Ve && (Zt == "buffer" || Zt == "byteLength" || Zt == "byteOffset") || // Skip index properties.
          Im(Zt, Et))) && ft.push(Zt);
        return ft;
      }
      function Hi(C) {
        var j = C.length;
        return j ? C[u_(0, j - 1)] : n;
      }
      function Ea(C, j) {
        return B1(to(C), wm(j, 0, C.length));
      }
      function $c(C) {
        return B1(to(C));
      }
      function Jg(C, j, ee) {
        (ee !== n && !d_(C[j], ee) || ee === n && !(j in C)) && Ja(C, j, ee);
      }
      function dp(C, j, ee) {
        var $e = C[j];
        (!(yr.call(C, j) && d_($e, ee)) || ee === n && !(j in C)) && Ja(C, j, ee);
      }
      function Qg(C, j) {
        for (var ee = C.length; ee--; )
          if (d_(C[ee][0], j))
            return ee;
        return -1;
      }
      function qf(C, j, ee, $e) {
        return pd(C, function(Ne, Ve, tt) {
          j($e, Ne, ee(Ne), tt);
        }), $e;
      }
      function _s(C, j) {
        return C && Go(j, Rs(j), C);
      }
      function k1(C, j) {
        return C && Go(j, Ml(j), C);
      }
      function Ja(C, j, ee) {
        j == "__proto__" && Ns ? Ns(C, j, {
          configurable: !0,
          enumerable: !0,
          value: ee,
          writable: !0
        }) : C[j] = ee;
      }
      function Yi(C, j) {
        for (var ee = -1, $e = j.length, Ne = mt($e), Ve = C == null; ++ee < $e; )
          Ne[ee] = Ve ? n : nI(C, j[ee]);
        return Ne;
      }
      function wm(C, j, ee) {
        return C === C && (ee !== n && (C = C <= ee ? C : ee), j !== n && (C = C >= j ? C : j)), C;
      }
      function nl(C, j, ee, $e, Ne, Ve) {
        var tt, ft = j & d, Et = j & _, Zt = j & p;
        if (ee && (tt = Ne ? ee(C, $e, Ne, Ve) : ee(C)), tt !== n)
          return tt;
        if (!xa(C))
          return C;
        var Xt = tr(C);
        if (Xt) {
          if (tt = ewe(C), !ft)
            return to(C, tt);
        } else {
          var rn = Sc(C), Mn = rn == _e || rn == he;
          if (Bf(C))
            return ct(C, ft);
          if (rn == ne || rn == H || Mn && !Ne) {
            if (tt = Et || Mn ? {} : rB(C), !ft)
              return Et ? kc(C, k1(tt, C)) : zs(C, _s(tt, C));
          } else {
            if (!Po[rn])
              return Ne ? C : {};
            tt = twe(C, rn, ft);
          }
        }
        Ve || (Ve = new gi());
        var oo = Ve.get(C);
        if (oo)
          return oo;
        Ve.set(C, tt), zB(C) ? C.forEach(function(Io) {
          tt.add(nl(Io, j, ee, Io, C, Ve));
        }) : OB(C) && C.forEach(function(Io, $r) {
          tt.set($r, nl(Io, j, ee, $r, C, Ve));
        });
        var Ao = Zt ? Et ? V2 : j2 : Et ? Ml : Rs, dr = Xt ? n : Ao(C);
        return $a(dr || C, function(Io, $r) {
          dr && ($r = Io, Io = C[$r]), dp(tt, $r, nl(Io, j, ee, $r, C, Ve));
        }), tt;
      }
      function S1(C) {
        var j = Rs(C);
        return function(ee) {
          return E1(ee, C, j);
        };
      }
      function E1(C, j, ee) {
        var $e = ee.length;
        if (C == null)
          return !$e;
        for (C = Xo(C); $e--; ) {
          var Ne = ee[$e], Ve = j[Ne], tt = C[Ne];
          if (tt === n && !(Ne in C) || !Ve(tt))
            return !1;
        }
        return !0;
      }
      function x1(C, j, ee) {
        if (typeof C != "function")
          throw new gc(a);
        return L$(function() {
          C.apply(n, ee);
        }, j);
      }
      function eh(C, j, ee, $e) {
        var Ne = -1, Ve = Tl, tt = !0, ft = C.length, Et = [], Zt = j.length;
        if (!ft)
          return Et;
        ee && (j = Zo(j, fa(ee))), $e ? (Ve = lu, tt = !1) : j.length >= r && (Ve = Xc, tt = !1, j = new Ni(j));
        e:
          for (; ++Ne < ft; ) {
            var Xt = C[Ne], rn = ee == null ? Xt : ee(Xt);
            if (Xt = $e || Xt !== 0 ? Xt : 0, tt && rn === rn) {
              for (var Mn = Zt; Mn--; )
                if (j[Mn] === rn)
                  continue e;
              Et.push(Xt);
            } else
              Ve(j, rn, $e) || Et.push(Xt);
          }
        return Et;
      }
      var pd = Dl(md), C1 = Dl(S$, !0);
      function T1(C, j) {
        var ee = !0;
        return pd(C, function($e, Ne, Ve) {
          return ee = !!j($e, Ne, Ve), ee;
        }), ee;
      }
      function th(C, j, ee) {
        for (var $e = -1, Ne = C.length; ++$e < Ne; ) {
          var Ve = C[$e], tt = j(Ve);
          if (tt != null && (ft === n ? tt === tt && !gu(tt) : ee(tt, ft)))
            var ft = tt, Et = Ve;
        }
        return Et;
      }
      function km(C, j, ee, $e) {
        var Ne = C.length;
        for (ee = ir(ee), ee < 0 && (ee = -ee > Ne ? 0 : Ne + ee), $e = $e === n || $e > Ne ? Ne : ir($e), $e < 0 && ($e += Ne), $e = ee > $e ? 0 : PB($e); ee < $e; )
          C[ee++] = j;
        return C;
      }
      function A1(C, j) {
        var ee = [];
        return pd(C, function($e, Ne, Ve) {
          j($e, Ne, Ve) && ee.push($e);
        }), ee;
      }
      function ps(C, j, ee, $e, Ne) {
        var Ve = -1, tt = C.length;
        for (ee || (ee = owe), Ne || (Ne = []); ++Ve < tt; ) {
          var ft = C[Ve];
          j > 0 && ee(ft) ? j > 1 ? ps(ft, j - 1, ee, $e, Ne) : nn(Ne, ft) : $e || (Ne[Ne.length] = ft);
        }
        return Ne;
      }
      var Sm = fd(), k$ = fd(!0);
      function md(C, j) {
        return C && Sm(C, j, Rs);
      }
      function S$(C, j) {
        return C && k$(C, j, Rs);
      }
      function nh(C, j) {
        return ta(j, function(ee) {
          return Om(C[ee]);
        });
      }
      function _p(C, j) {
        j = Ke(j, C);
        for (var ee = 0, $e = j.length; C != null && ee < $e; )
          C = C[gp(j[ee++])];
        return ee && ee == $e ? C : n;
      }
      function wc(C, j, ee) {
        var $e = j(C);
        return tr(C) ? $e : nn($e, ee(C));
      }
      function ms(C) {
        return C == null ? C === n ? et : me : zl && zl in Xo(C) ? X$e(C) : uwe(C);
      }
      function hi(C, j) {
        return C > j;
      }
      function Em(C, j) {
        return C != null && yr.call(C, j);
      }
      function dn(C, j) {
        return C != null && j in Xo(C);
      }
      function I1(C, j, ee) {
        return C >= qe(j, ee) && C < Ee(j, ee);
      }
      function pp(C, j, ee) {
        for (var $e = ee ? lu : Tl, Ne = C[0].length, Ve = C.length, tt = Ve, ft = mt(Ve), Et = 1 / 0, Zt = []; tt--; ) {
          var Xt = C[tt];
          tt && j && (Xt = Zo(Xt, fa(j))), Et = qe(Xt.length, Et), ft[tt] = !ee && (j || Ne >= 120 && Xt.length >= 120) ? new Ni(tt && Xt) : n;
        }
        Xt = C[0];
        var rn = -1, Mn = ft[0];
        e:
          for (; ++rn < Ne && Zt.length < Et; ) {
            var oo = Xt[rn], Ao = j ? j(oo) : oo;
            if (oo = ee || oo !== 0 ? oo : 0, !(Mn ? Xc(Mn, Ao) : $e(Zt, Ao, ee))) {
              for (tt = Ve; --tt; ) {
                var dr = ft[tt];
                if (!(dr ? Xc(dr, Ao) : $e(C[tt], Ao, ee)))
                  continue e;
              }
              Mn && Mn.push(Ao), Zt.push(oo);
            }
          }
        return Zt;
      }
      function O2(C, j, ee, $e) {
        return md(C, function(Ne, Ve, tt) {
          j($e, ee(Ne), Ve, tt);
        }), $e;
      }
      function Qa(C, j, ee) {
        j = Ke(j, C), C = cB(C, j);
        var $e = C == null ? C : C[gp(gd(j))];
        return $e == null ? n : _o($e, C, ee);
      }
      function O1(C) {
        return za(C) && ms(C) == H;
      }
      function N2(C) {
        return za(C) && ms(C) == ze;
      }
      function E$(C) {
        return za(C) && ms(C) == Y;
      }
      function jf(C, j, ee, $e, Ne) {
        return C === j ? !0 : C == null || j == null || !za(C) && !za(j) ? C !== C && j !== j : Gv(C, j, ee, $e, jf, Ne);
      }
      function Gv(C, j, ee, $e, Ne, Ve) {
        var tt = tr(C), ft = tr(j), Et = tt ? J : Sc(C), Zt = ft ? J : Sc(j);
        Et = Et == H ? ne : Et, Zt = Zt == H ? ne : Zt;
        var Xt = Et == ne, rn = Zt == ne, Mn = Et == Zt;
        if (Mn && Bf(C)) {
          if (!Bf(j))
            return !1;
          tt = !0, Xt = !1;
        }
        if (Mn && !Xt)
          return Ve || (Ve = new gi()), tt || Jv(C) ? tB(C, j, ee, $e, Ne, Ve) : K$e(C, j, Et, ee, $e, Ne, Ve);
        if (!(ee & g)) {
          var oo = Xt && yr.call(C, "__wrapped__"), Ao = rn && yr.call(j, "__wrapped__");
          if (oo || Ao) {
            var dr = oo ? C.value() : C, Io = Ao ? j.value() : j;
            return Ve || (Ve = new gi()), Ne(dr, Io, ee, $e, Ve);
          }
        }
        return Mn ? (Ve || (Ve = new gi()), Z$e(C, j, ee, $e, Ne, Ve)) : !1;
      }
      function Vf(C) {
        return za(C) && Sc(C) == be;
      }
      function x$(C, j, ee, $e) {
        var Ne = ee.length, Ve = Ne, tt = !$e;
        if (C == null)
          return !Ve;
        for (C = Xo(C); Ne--; ) {
          var ft = ee[Ne];
          if (tt && ft[2] ? ft[1] !== C[ft[0]] : !(ft[0] in C))
            return !1;
        }
        for (; ++Ne < Ve; ) {
          ft = ee[Ne];
          var Et = ft[0], Zt = C[Et], Xt = ft[1];
          if (tt && ft[2]) {
            if (Zt === n && !(Et in C))
              return !1;
          } else {
            var rn = new gi();
            if ($e)
              var Mn = $e(Zt, Xt, Et, C, j, rn);
            if (!(Mn === n ? jf(Xt, Zt, g | f, $e, rn) : Mn))
              return !1;
          }
        }
        return !0;
      }
      function xm(C) {
        if (!xa(C) || iwe(C))
          return !1;
        var j = Om(C) ? Wg : kn;
        return j.test(sh(C));
      }
      function oh(C) {
        return za(C) && ms(C) == ve;
      }
      function C$(C) {
        return za(C) && Sc(C) == Te;
      }
      function T$(C) {
        return za(C) && K1(C.length) && !!Dr[ms(C)];
      }
      function A$(C) {
        return typeof C == "function" ? C : C == null ? Fl : typeof C == "object" ? tr(C) ? z1(C[0], C[1]) : Cm(C) : WB(C);
      }
      function I$(C) {
        if (!D$(C))
          return ke(C);
        var j = [];
        for (var ee in Xo(C))
          yr.call(C, ee) && ee != "constructor" && j.push(ee);
        return j;
      }
      function N1(C) {
        if (!xa(C))
          return lwe(C);
        var j = D$(C), ee = [];
        for (var $e in C)
          $e == "constructor" && (j || !yr.call(C, $e)) || ee.push($e);
        return ee;
      }
      function Wv(C, j) {
        return C < j;
      }
      function rh(C, j) {
        var ee = -1, $e = Ll(C) ? mt(C.length) : [];
        return pd(C, function(Ne, Ve, tt) {
          $e[++ee] = j(Ne, Ve, tt);
        }), $e;
      }
      function Cm(C) {
        var j = U2(C);
        return j.length == 1 && j[0][2] ? aB(j[0][0], j[0][1]) : function(ee) {
          return ee === C || x$(ee, C, j);
        };
      }
      function z1(C, j) {
        return W2(C) && iB(j) ? aB(gp(C), j) : function(ee) {
          var $e = nI(ee, C);
          return $e === n && $e === j ? oI(ee, C) : jf(j, $e, g | f);
        };
      }
      function Hv(C, j, ee, $e, Ne) {
        C !== j && Sm(j, function(Ve, tt) {
          if (Ne || (Ne = new gi()), xa(Ve))
            z2(C, j, tt, ee, Hv, $e, Ne);
          else {
            var ft = $e ? $e(Y2(C, tt), Ve, tt + "", C, j, Ne) : n;
            ft === n && (ft = Ve), Jg(C, tt, ft);
          }
        }, Ml);
      }
      function z2(C, j, ee, $e, Ne, Ve, tt) {
        var ft = Y2(C, ee), Et = Y2(j, ee), Zt = tt.get(Et);
        if (Zt) {
          Jg(C, ee, Zt);
          return;
        }
        var Xt = Ve ? Ve(ft, Et, ee + "", C, j, tt) : n, rn = Xt === n;
        if (rn) {
          var Mn = tr(Et), oo = !Mn && Bf(Et), Ao = !Mn && !oo && Jv(Et);
          Xt = Et, Mn || oo || Ao ? tr(ft) ? Xt = ft : qa(ft) ? Xt = to(ft) : oo ? (rn = !1, Xt = ct(Et, !0)) : Ao ? (rn = !1, Xt = Ht(Et, !0)) : Xt = [] : M$(Et) || ch(Et) ? (Xt = ft, ch(ft) ? Xt = DB(ft) : (!xa(ft) || Om(ft)) && (Xt = rB(Et))) : rn = !1;
        }
        rn && (tt.set(Et, Xt), Ne(Xt, Et, $e, Ve, tt), tt.delete(Et)), Jg(C, ee, Xt);
      }
      function R1(C, j) {
        var ee = C.length;
        if (ee)
          return j += j < 0 ? ee : 0, Im(j, ee) ? C[j] : n;
      }
      function P1(C, j, ee) {
        j.length ? j = Zo(j, function(Ve) {
          return tr(Ve) ? function(tt) {
            return _p(tt, Ve.length === 1 ? Ve[0] : Ve);
          } : Ve;
        }) : j = [Fl];
        var $e = -1;
        j = Zo(j, fa(wo()));
        var Ne = rh(C, function(Ve, tt, ft) {
          var Et = Zo(j, function(Zt) {
            return Zt(Ve);
          });
          return { criteria: Et, index: ++$e, value: Ve };
        });
        return rp(Ne, function(Ve, tt) {
          return $o(Ve, tt, ee);
        });
      }
      function mp(C, j) {
        return es(C, j, function(ee, $e) {
          return oI(C, $e);
        });
      }
      function es(C, j, ee) {
        for (var $e = -1, Ne = j.length, Ve = {}; ++$e < Ne; ) {
          var tt = j[$e], ft = _p(C, tt);
          ee(ft, tt) && ih(Ve, Ke(tt, C), ft);
        }
        return Ve;
      }
      function Wn(C) {
        return function(j) {
          return _p(j, C);
        };
      }
      function fp(C, j, ee, $e) {
        var Ne = $e ? pm : As, Ve = -1, tt = j.length, ft = C;
        for (C === j && (j = to(j)), ee && (ft = Zo(C, fa(ee))); ++Ve < tt; )
          for (var Et = 0, Zt = j[Ve], Xt = ee ? ee(Zt) : Zt; (Et = Ne(ft, Xt, Et, $e)) > -1; )
            ft !== C && a_.call(ft, Et, 1), a_.call(C, Et, 1);
        return C;
      }
      function D1(C, j) {
        for (var ee = C ? j.length : 0, $e = ee - 1; ee--; ) {
          var Ne = j[ee];
          if (ee == $e || Ne !== Ve) {
            var Ve = Ne;
            Im(Ne) ? a_.call(C, Ne, 1) : W(C, Ne);
          }
        }
        return C;
      }
      function u_(C, j) {
        return C + Z(Vt() * (j - C + 1));
      }
      function R2(C, j, ee, $e) {
        for (var Ne = -1, Ve = Ee(cd((j - C) / (ee || 1)), 0), tt = mt(Ve); Ve--; )
          tt[$e ? Ve : ++Ne] = C, C += ee;
        return tt;
      }
      function O$(C, j) {
        var ee = "";
        if (!C || j < 1 || j > I)
          return ee;
        do
          j % 2 && (ee += C), j = Z(j / 2), j && (C += C);
        while (j);
        return ee;
      }
      function rr(C, j) {
        return K2(sB(C, j, Fl), C + "");
      }
      function P2(C) {
        return Hi(Qv(C));
      }
      function D2(C, j) {
        var ee = Qv(C);
        return B1(ee, wm(j, 0, ee.length));
      }
      function ih(C, j, ee, $e) {
        if (!xa(C))
          return C;
        j = Ke(j, C);
        for (var Ne = -1, Ve = j.length, tt = Ve - 1, ft = C; ft != null && ++Ne < Ve; ) {
          var Et = gp(j[Ne]), Zt = ee;
          if (Et === "__proto__" || Et === "constructor" || Et === "prototype")
            return C;
          if (Ne != tt) {
            var Xt = ft[Et];
            Zt = $e ? $e(Xt, Et, ft) : n, Zt === n && (Zt = xa(Xt) ? Xt : Im(j[Ne + 1]) ? [] : {});
          }
          dp(ft, Et, Zt), ft = ft[Et];
        }
        return C;
      }
      var N$ = Oi ? function(C, j) {
        return Oi.set(C, j), C;
      } : Fl, L2 = Ns ? function(C, j) {
        return Ns(C, "toString", {
          configurable: !0,
          enumerable: !1,
          value: iI(j),
          writable: !0
        });
      } : Fl;
      function M2(C) {
        return B1(Qv(C));
      }
      function Pl(C, j, ee) {
        var $e = -1, Ne = C.length;
        j < 0 && (j = -j > Ne ? 0 : Ne + j), ee = ee > Ne ? Ne : ee, ee < 0 && (ee += Ne), Ne = j > ee ? 0 : ee - j >>> 0, j >>>= 0;
        for (var Ve = mt(Ne); ++$e < Ne; )
          Ve[$e] = C[$e + j];
        return Ve;
      }
      function z$(C, j) {
        var ee;
        return pd(C, function($e, Ne, Ve) {
          return ee = j($e, Ne, Ve), !ee;
        }), !!ee;
      }
      function ol(C, j, ee) {
        var $e = 0, Ne = C == null ? $e : C.length;
        if (typeof j == "number" && j === j && Ne <= V) {
          for (; $e < Ne; ) {
            var Ve = $e + Ne >>> 1, tt = C[Ve];
            tt !== null && !gu(tt) && (ee ? tt <= j : tt < j) ? $e = Ve + 1 : Ne = Ve;
          }
          return Ne;
        }
        return Yv(C, j, Fl, ee);
      }
      function Yv(C, j, ee, $e) {
        var Ne = 0, Ve = C == null ? 0 : C.length;
        if (Ve === 0)
          return 0;
        j = ee(j);
        for (var tt = j !== j, ft = j === null, Et = gu(j), Zt = j === n; Ne < Ve; ) {
          var Xt = Z((Ne + Ve) / 2), rn = ee(C[Xt]), Mn = rn !== n, oo = rn === null, Ao = rn === rn, dr = gu(rn);
          if (tt)
            var Io = $e || Ao;
          else
            Zt ? Io = Ao && ($e || Mn) : ft ? Io = Ao && Mn && ($e || !oo) : Et ? Io = Ao && Mn && !oo && ($e || !dr) : oo || dr ? Io = !1 : Io = $e ? rn <= j : rn < j;
          Io ? Ne = Xt + 1 : Ve = Xt;
        }
        return qe(Ve, O);
      }
      function Kv(C, j) {
        for (var ee = -1, $e = C.length, Ne = 0, Ve = []; ++ee < $e; ) {
          var tt = C[ee], ft = j ? j(tt) : tt;
          if (!ee || !d_(ft, Et)) {
            var Et = ft;
            Ve[Ne++] = tt === 0 ? 0 : tt;
          }
        }
        return Ve;
      }
      function R$(C) {
        return typeof C == "number" ? C : gu(C) ? F : +C;
      }
      function fs(C) {
        if (typeof C == "string")
          return C;
        if (tr(C))
          return Zo(C, fs) + "";
        if (gu(C))
          return Qs ? Qs.call(C) : "";
        var j = C + "";
        return j == "0" && 1 / C == -k ? "-0" : j;
      }
      function te(C, j, ee) {
        var $e = -1, Ne = Tl, Ve = C.length, tt = !0, ft = [], Et = ft;
        if (ee)
          tt = !1, Ne = lu;
        else if (Ve >= r) {
          var Zt = j ? null : H$e(C);
          if (Zt)
            return Jc(Zt);
          tt = !1, Ne = Xc, Et = new Ni();
        } else
          Et = j ? [] : ft;
        e:
          for (; ++$e < Ve; ) {
            var Xt = C[$e], rn = j ? j(Xt) : Xt;
            if (Xt = ee || Xt !== 0 ? Xt : 0, tt && rn === rn) {
              for (var Mn = Et.length; Mn--; )
                if (Et[Mn] === rn)
                  continue e;
              j && Et.push(rn), ft.push(Xt);
            } else
              Ne(Et, rn, ee) || (Et !== ft && Et.push(rn), ft.push(Xt));
          }
        return ft;
      }
      function W(C, j) {
        return j = Ke(j, C), C = cB(C, j), C == null || delete C[gp(gd(j))];
      }
      function X(C, j, ee, $e) {
        return ih(C, j, ee(_p(C, j)), $e);
      }
      function se(C, j, ee, $e) {
        for (var Ne = C.length, Ve = $e ? Ne : -1; ($e ? Ve-- : ++Ve < Ne) && j(C[Ve], Ve, C); )
          ;
        return ee ? Pl(C, $e ? 0 : Ve, $e ? Ve + 1 : Ne) : Pl(C, $e ? Ve + 1 : 0, $e ? Ne : Ve);
      }
      function ye(C, j) {
        var ee = C;
        return ee instanceof jo && (ee = ee.value()), Ts(j, function($e, Ne) {
          return Ne.func.apply(Ne.thisArg, nn([$e], Ne.args));
        }, ee);
      }
      function we(C, j, ee) {
        var $e = C.length;
        if ($e < 2)
          return $e ? te(C[0]) : [];
        for (var Ne = -1, Ve = mt($e); ++Ne < $e; )
          for (var tt = C[Ne], ft = -1; ++ft < $e; )
            ft != Ne && (Ve[Ne] = eh(Ve[Ne] || tt, C[ft], j, ee));
        return te(ps(Ve, 1), j, ee);
      }
      function Ce(C, j, ee) {
        for (var $e = -1, Ne = C.length, Ve = j.length, tt = {}; ++$e < Ne; ) {
          var ft = $e < Ve ? j[$e] : n;
          ee(tt, C[$e], ft);
        }
        return tt;
      }
      function Oe(C) {
        return qa(C) ? C : [];
      }
      function Ye(C) {
        return typeof C == "function" ? C : Fl;
      }
      function Ke(C, j) {
        return tr(C) ? C : W2(C, j) ? [C] : _B(ii(C));
      }
      var rt = rr;
      function ut(C, j, ee) {
        var $e = C.length;
        return ee = ee === n ? $e : ee, !j && ee >= $e ? C : Pl(C, j, ee);
      }
      var _t = Hg || function(C) {
        return ma.clearTimeout(C);
      };
      function ct(C, j) {
        if (j)
          return C.slice();
        var ee = C.length, $e = Vn ? Vn(ee) : new C.constructor(ee);
        return C.copy($e), $e;
      }
      function Lt(C) {
        var j = new C.constructor(C.byteLength);
        return new ra(j).set(new ra(C)), j;
      }
      function St(C, j) {
        var ee = j ? Lt(C.buffer) : C.buffer;
        return new C.constructor(ee, C.byteOffset, C.byteLength);
      }
      function jt(C) {
        var j = new C.constructor(C.source, hn.exec(C));
        return j.lastIndex = C.lastIndex, j;
      }
      function bn(C) {
        return us ? Xo(us.call(C)) : {};
      }
      function Ht(C, j) {
        var ee = j ? Lt(C.buffer) : C.buffer;
        return new C.constructor(ee, C.byteOffset, C.length);
      }
      function ln(C, j) {
        if (C !== j) {
          var ee = C !== n, $e = C === null, Ne = C === C, Ve = gu(C), tt = j !== n, ft = j === null, Et = j === j, Zt = gu(j);
          if (!ft && !Zt && !Ve && C > j || Ve && tt && Et && !ft && !Zt || $e && tt && Et || !ee && Et || !Ne)
            return 1;
          if (!$e && !Ve && !Zt && C < j || Zt && ee && Ne && !$e && !Ve || ft && ee && Ne || !tt && Ne || !Et)
            return -1;
        }
        return 0;
      }
      function $o(C, j, ee) {
        for (var $e = -1, Ne = C.criteria, Ve = j.criteria, tt = Ne.length, ft = ee.length; ++$e < tt; ) {
          var Et = ln(Ne[$e], Ve[$e]);
          if (Et) {
            if ($e >= ft)
              return Et;
            var Zt = ee[$e];
            return Et * (Zt == "desc" ? -1 : 1);
          }
        }
        return C.index - j.index;
      }
      function eo(C, j, ee, $e) {
        for (var Ne = -1, Ve = C.length, tt = ee.length, ft = -1, Et = j.length, Zt = Ee(Ve - tt, 0), Xt = mt(Et + Zt), rn = !$e; ++ft < Et; )
          Xt[ft] = j[ft];
        for (; ++Ne < tt; )
          (rn || Ne < Ve) && (Xt[ee[Ne]] = C[Ne]);
        for (; Zt--; )
          Xt[ft++] = C[Ne++];
        return Xt;
      }
      function mo(C, j, ee, $e) {
        for (var Ne = -1, Ve = C.length, tt = -1, ft = ee.length, Et = -1, Zt = j.length, Xt = Ee(Ve - ft, 0), rn = mt(Xt + Zt), Mn = !$e; ++Ne < Xt; )
          rn[Ne] = C[Ne];
        for (var oo = Ne; ++Et < Zt; )
          rn[oo + Et] = j[Et];
        for (; ++tt < ft; )
          (Mn || Ne < Ve) && (rn[oo + ee[tt]] = C[Ne++]);
        return rn;
      }
      function to(C, j) {
        var ee = -1, $e = C.length;
        for (j || (j = mt($e)); ++ee < $e; )
          j[ee] = C[ee];
        return j;
      }
      function Go(C, j, ee, $e) {
        var Ne = !ee;
        ee || (ee = {});
        for (var Ve = -1, tt = j.length; ++Ve < tt; ) {
          var ft = j[Ve], Et = $e ? $e(ee[ft], C[ft], ft, ee, C) : n;
          Et === n && (Et = C[ft]), Ne ? Ja(ee, ft, Et) : dp(ee, ft, Et);
        }
        return ee;
      }
      function zs(C, j) {
        return Go(C, G2(C), j);
      }
      function kc(C, j) {
        return Go(C, nB(C), j);
      }
      function Tr(C, j) {
        return function(ee, $e) {
          var Ne = tr(ee) ? dm : qf, Ve = j ? j() : {};
          return Ne(ee, C, wo($e, 2), Ve);
        };
      }
      function ia(C) {
        return rr(function(j, ee) {
          var $e = -1, Ne = ee.length, Ve = Ne > 1 ? ee[Ne - 1] : n, tt = Ne > 2 ? ee[2] : n;
          for (Ve = C.length > 3 && typeof Ve == "function" ? (Ne--, Ve) : n, tt && rl(ee[0], ee[1], tt) && (Ve = Ne < 3 ? n : Ve, Ne = 1), j = Xo(j); ++$e < Ne; ) {
            var ft = ee[$e];
            ft && C(j, ft, $e, Ve);
          }
          return j;
        });
      }
      function Dl(C, j) {
        return function(ee, $e) {
          if (ee == null)
            return ee;
          if (!Ll(ee))
            return C(ee, $e);
          for (var Ne = ee.length, Ve = j ? Ne : -1, tt = Xo(ee); (j ? Ve-- : ++Ve < Ne) && $e(tt[Ve], Ve, tt) !== !1; )
            ;
          return ee;
        };
      }
      function fd(C) {
        return function(j, ee, $e) {
          for (var Ne = -1, Ve = Xo(j), tt = $e(j), ft = tt.length; ft--; ) {
            var Et = tt[C ? ft : ++Ne];
            if (ee(Ve[Et], Et, Ve) === !1)
              break;
          }
          return j;
        };
      }
      function U$e(C, j, ee) {
        var $e = j & h, Ne = P$(C);
        function Ve() {
          var tt = this && this !== ma && this instanceof Ve ? Ne : C;
          return tt.apply($e ? ee : this, arguments);
        }
        return Ve;
      }
      function WV(C) {
        return function(j) {
          j = ii(j);
          var ee = Xa(j) ? Se(j) : n, $e = ee ? ee[0] : j.charAt(0), Ne = ee ? ut(ee, 1).join("") : j.slice(1);
          return $e[C]() + Ne;
        };
      }
      function Zv(C) {
        return function(j) {
          return Ts(UB(BB(j).replace(Cs, "")), C, "");
        };
      }
      function P$(C) {
        return function() {
          var j = arguments;
          switch (j.length) {
            case 0:
              return new C();
            case 1:
              return new C(j[0]);
            case 2:
              return new C(j[0], j[1]);
            case 3:
              return new C(j[0], j[1], j[2]);
            case 4:
              return new C(j[0], j[1], j[2], j[3]);
            case 5:
              return new C(j[0], j[1], j[2], j[3], j[4]);
            case 6:
              return new C(j[0], j[1], j[2], j[3], j[4], j[5]);
            case 7:
              return new C(j[0], j[1], j[2], j[3], j[4], j[5], j[6]);
          }
          var ee = so(C.prototype), $e = C.apply(ee, j);
          return xa($e) ? $e : ee;
        };
      }
      function G$e(C, j, ee) {
        var $e = P$(C);
        function Ne() {
          for (var Ve = arguments.length, tt = mt(Ve), ft = Ve, Et = Xv(Ne); ft--; )
            tt[ft] = arguments[ft];
          var Zt = Ve < 3 && tt[0] !== Et && tt[Ve - 1] !== Et ? [] : Do(tt, Et);
          if (Ve -= Zt.length, Ve < ee)
            return XV(
              C,
              j,
              L1,
              Ne.placeholder,
              n,
              tt,
              Zt,
              n,
              n,
              ee - Ve
            );
          var Xt = this && this !== ma && this instanceof Ne ? $e : C;
          return _o(Xt, this, tt);
        }
        return Ne;
      }
      function HV(C) {
        return function(j, ee, $e) {
          var Ne = Xo(j);
          if (!Ll(j)) {
            var Ve = wo(ee, 3);
            j = Rs(j), ee = function(ft) {
              return Ve(Ne[ft], ft, Ne);
            };
          }
          var tt = C(j, ee, $e);
          return tt > -1 ? Ne[Ve ? j[tt] : tt] : n;
        };
      }
      function YV(C) {
        return Am(function(j) {
          var ee = j.length, $e = ee, Ne = ds.prototype.thru;
          for (C && j.reverse(); $e--; ) {
            var Ve = j[$e];
            if (typeof Ve != "function")
              throw new gc(a);
            if (Ne && !tt && j1(Ve) == "wrapper")
              var tt = new ds([], !0);
          }
          for ($e = tt ? $e : ee; ++$e < ee; ) {
            Ve = j[$e];
            var ft = j1(Ve), Et = ft == "wrapper" ? B2(Ve) : n;
            Et && H2(Et[0]) && Et[1] == (M | b | w | q) && !Et[4].length && Et[9] == 1 ? tt = tt[j1(Et[0])].apply(tt, Et[3]) : tt = Ve.length == 1 && H2(Ve) ? tt[ft]() : tt.thru(Ve);
          }
          return function() {
            var Zt = arguments, Xt = Zt[0];
            if (tt && Zt.length == 1 && tr(Xt))
              return tt.plant(Xt).value();
            for (var rn = 0, Mn = ee ? j[rn].apply(this, Zt) : Xt; ++rn < ee; )
              Mn = j[rn].call(this, Mn);
            return Mn;
          };
        });
      }
      function L1(C, j, ee, $e, Ne, Ve, tt, ft, Et, Zt) {
        var Xt = j & M, rn = j & h, Mn = j & $, oo = j & (b | y), Ao = j & L, dr = Mn ? n : P$(C);
        function Io() {
          for (var $r = arguments.length, Ar = mt($r), hu = $r; hu--; )
            Ar[hu] = arguments[hu];
          if (oo)
            var il = Xv(Io), vu = Xs(Ar, il);
          if ($e && (Ar = eo(Ar, $e, Ne, oo)), Ve && (Ar = mo(Ar, Ve, tt, oo)), $r -= vu, oo && $r < Zt) {
            var ja = Do(Ar, il);
            return XV(
              C,
              j,
              L1,
              Io.placeholder,
              ee,
              Ar,
              ja,
              ft,
              Et,
              Zt - $r
            );
          }
          var __ = rn ? ee : this, zm = Mn ? __[C] : C;
          return $r = Ar.length, ft ? Ar = dwe(Ar, ft) : Ao && $r > 1 && Ar.reverse(), Xt && Et < $r && (Ar.length = Et), this && this !== ma && this instanceof Io && (zm = dr || P$(zm)), zm.apply(__, Ar);
        }
        return Io;
      }
      function KV(C, j) {
        return function(ee, $e) {
          return O2(ee, C, j($e), {});
        };
      }
      function M1(C, j) {
        return function(ee, $e) {
          var Ne;
          if (ee === n && $e === n)
            return j;
          if (ee !== n && (Ne = ee), $e !== n) {
            if (Ne === n)
              return $e;
            typeof ee == "string" || typeof $e == "string" ? (ee = fs(ee), $e = fs($e)) : (ee = R$(ee), $e = R$($e)), Ne = C(ee, $e);
          }
          return Ne;
        };
      }
      function F2(C) {
        return Am(function(j) {
          return j = Zo(j, fa(wo())), rr(function(ee) {
            var $e = this;
            return C(j, function(Ne) {
              return _o(Ne, $e, ee);
            });
          });
        });
      }
      function F1(C, j) {
        j = j === n ? " " : fs(j);
        var ee = j.length;
        if (ee < 2)
          return ee ? O$(j, C) : j;
        var $e = O$(j, cd(C / ce(j)));
        return Xa(j) ? ut(Se($e), 0, C).join("") : $e.slice(0, C);
      }
      function W$e(C, j, ee, $e) {
        var Ne = j & h, Ve = P$(C);
        function tt() {
          for (var ft = -1, Et = arguments.length, Zt = -1, Xt = $e.length, rn = mt(Xt + Et), Mn = this && this !== ma && this instanceof tt ? Ve : C; ++Zt < Xt; )
            rn[Zt] = $e[Zt];
          for (; Et--; )
            rn[Zt++] = arguments[++ft];
          return _o(Mn, Ne ? ee : this, rn);
        }
        return tt;
      }
      function ZV(C) {
        return function(j, ee, $e) {
          return $e && typeof $e != "number" && rl(j, ee, $e) && (ee = $e = n), j = Nm(j), ee === n ? (ee = j, j = 0) : ee = Nm(ee), $e = $e === n ? j < ee ? 1 : -1 : Nm($e), R2(j, ee, $e, C);
        };
      }
      function q1(C) {
        return function(j, ee) {
          return typeof j == "string" && typeof ee == "string" || (j = hd(j), ee = hd(ee)), C(j, ee);
        };
      }
      function XV(C, j, ee, $e, Ne, Ve, tt, ft, Et, Zt) {
        var Xt = j & b, rn = Xt ? tt : n, Mn = Xt ? n : tt, oo = Xt ? Ve : n, Ao = Xt ? n : Ve;
        j |= Xt ? w : N, j &= ~(Xt ? N : w), j & v || (j &= ~(h | $));
        var dr = [
          C,
          j,
          Ne,
          oo,
          rn,
          Ao,
          Mn,
          ft,
          Et,
          Zt
        ], Io = ee.apply(n, dr);
        return H2(C) && lB(Io, dr), Io.placeholder = $e, uB(Io, C, j);
      }
      function q2(C) {
        var j = gr[C];
        return function(ee, $e) {
          if (ee = hd(ee), $e = $e == null ? 0 : qe(ir($e), 292), $e && ue(ee)) {
            var Ne = (ii(ee) + "e").split("e"), Ve = j(Ne[0] + "e" + (+Ne[1] + $e));
            return Ne = (ii(Ve) + "e").split("e"), +(Ne[0] + "e" + (+Ne[1] - $e));
          }
          return j(ee);
        };
      }
      var H$e = Cn && 1 / Jc(new Cn([, -0]))[1] == k ? function(C) {
        return new Cn(C);
      } : cI;
      function JV(C) {
        return function(j) {
          var ee = Sc(j);
          return ee == be ? Jr(j) : ee == Te ? mm(j) : To(j, C(j));
        };
      }
      function Tm(C, j, ee, $e, Ne, Ve, tt, ft) {
        var Et = j & $;
        if (!Et && typeof C != "function")
          throw new gc(a);
        var Zt = $e ? $e.length : 0;
        if (Zt || (j &= ~(w | N), $e = Ne = n), tt = tt === n ? tt : Ee(ir(tt), 0), ft = ft === n ? ft : ir(ft), Zt -= Ne ? Ne.length : 0, j & N) {
          var Xt = $e, rn = Ne;
          $e = Ne = n;
        }
        var Mn = Et ? n : B2(C), oo = [
          C,
          j,
          ee,
          $e,
          Ne,
          Xt,
          rn,
          Ve,
          tt,
          ft
        ];
        if (Mn && cwe(oo, Mn), C = oo[0], j = oo[1], ee = oo[2], $e = oo[3], Ne = oo[4], ft = oo[9] = oo[9] === n ? Et ? 0 : C.length : Ee(oo[9] - Zt, 0), !ft && j & (b | y) && (j &= ~(b | y)), !j || j == h)
          var Ao = U$e(C, j, ee);
        else
          j == b || j == y ? Ao = G$e(C, j, ft) : (j == w || j == (h | w)) && !Ne.length ? Ao = W$e(C, j, ee, $e) : Ao = L1.apply(n, oo);
        var dr = Mn ? N$ : lB;
        return uB(dr(Ao, oo), C, j);
      }
      function QV(C, j, ee, $e) {
        return C === n || d_(C, vc[ee]) && !yr.call($e, ee) ? j : C;
      }
      function eB(C, j, ee, $e, Ne, Ve) {
        return xa(C) && xa(j) && (Ve.set(j, C), Hv(C, j, n, eB, Ve), Ve.delete(j)), C;
      }
      function Y$e(C) {
        return M$(C) ? n : C;
      }
      function tB(C, j, ee, $e, Ne, Ve) {
        var tt = ee & g, ft = C.length, Et = j.length;
        if (ft != Et && !(tt && Et > ft))
          return !1;
        var Zt = Ve.get(C), Xt = Ve.get(j);
        if (Zt && Xt)
          return Zt == j && Xt == C;
        var rn = -1, Mn = !0, oo = ee & f ? new Ni() : n;
        for (Ve.set(C, j), Ve.set(j, C); ++rn < ft; ) {
          var Ao = C[rn], dr = j[rn];
          if ($e)
            var Io = tt ? $e(dr, Ao, rn, j, C, Ve) : $e(Ao, dr, rn, C, j, Ve);
          if (Io !== n) {
            if (Io)
              continue;
            Mn = !1;
            break;
          }
          if (oo) {
            if (!Zc(j, function($r, Ar) {
              if (!Xc(oo, Ar) && (Ao === $r || Ne(Ao, $r, ee, $e, Ve)))
                return oo.push(Ar);
            })) {
              Mn = !1;
              break;
            }
          } else if (!(Ao === dr || Ne(Ao, dr, ee, $e, Ve))) {
            Mn = !1;
            break;
          }
        }
        return Ve.delete(C), Ve.delete(j), Mn;
      }
      function K$e(C, j, ee, $e, Ne, Ve, tt) {
        switch (ee) {
          case Pe:
            if (C.byteLength != j.byteLength || C.byteOffset != j.byteOffset)
              return !1;
            C = C.buffer, j = j.buffer;
          case ze:
            return !(C.byteLength != j.byteLength || !Ve(new ra(C), new ra(j)));
          case ae:
          case Y:
          case Q:
            return d_(+C, +j);
          case ie:
            return C.name == j.name && C.message == j.message;
          case ve:
          case Re:
            return C == j + "";
          case be:
            var ft = Jr;
          case Te:
            var Et = $e & g;
            if (ft || (ft = Jc), C.size != j.size && !Et)
              return !1;
            var Zt = tt.get(C);
            if (Zt)
              return Zt == j;
            $e |= f, tt.set(C, j);
            var Xt = tB(ft(C), ft(j), $e, Ne, Ve, tt);
            return tt.delete(C), Xt;
          case Me:
            if (us)
              return us.call(C) == us.call(j);
        }
        return !1;
      }
      function Z$e(C, j, ee, $e, Ne, Ve) {
        var tt = ee & g, ft = j2(C), Et = ft.length, Zt = j2(j), Xt = Zt.length;
        if (Et != Xt && !tt)
          return !1;
        for (var rn = Et; rn--; ) {
          var Mn = ft[rn];
          if (!(tt ? Mn in j : yr.call(j, Mn)))
            return !1;
        }
        var oo = Ve.get(C), Ao = Ve.get(j);
        if (oo && Ao)
          return oo == j && Ao == C;
        var dr = !0;
        Ve.set(C, j), Ve.set(j, C);
        for (var Io = tt; ++rn < Et; ) {
          Mn = ft[rn];
          var $r = C[Mn], Ar = j[Mn];
          if ($e)
            var hu = tt ? $e(Ar, $r, Mn, j, C, Ve) : $e($r, Ar, Mn, C, j, Ve);
          if (!(hu === n ? $r === Ar || Ne($r, Ar, ee, $e, Ve) : hu)) {
            dr = !1;
            break;
          }
          Io || (Io = Mn == "constructor");
        }
        if (dr && !Io) {
          var il = C.constructor, vu = j.constructor;
          il != vu && "constructor" in C && "constructor" in j && !(typeof il == "function" && il instanceof il && typeof vu == "function" && vu instanceof vu) && (dr = !1);
        }
        return Ve.delete(C), Ve.delete(j), dr;
      }
      function Am(C) {
        return K2(sB(C, n, gB), C + "");
      }
      function j2(C) {
        return wc(C, Rs, G2);
      }
      function V2(C) {
        return wc(C, Ml, nB);
      }
      var B2 = Oi ? function(C) {
        return Oi.get(C);
      } : cI;
      function j1(C) {
        for (var j = C.name + "", ee = ga[j], $e = yr.call(ga, j) ? ee.length : 0; $e--; ) {
          var Ne = ee[$e], Ve = Ne.func;
          if (Ve == null || Ve == C)
            return Ne.name;
        }
        return j;
      }
      function Xv(C) {
        var j = yr.call(Le, "placeholder") ? Le : C;
        return j.placeholder;
      }
      function wo() {
        var C = Le.iteratee || aI;
        return C = C === aI ? A$ : C, arguments.length ? C(arguments[0], arguments[1]) : C;
      }
      function V1(C, j) {
        var ee = C.__data__;
        return rwe(j) ? ee[typeof j == "string" ? "string" : "hash"] : ee.map;
      }
      function U2(C) {
        for (var j = Rs(C), ee = j.length; ee--; ) {
          var $e = j[ee], Ne = C[$e];
          j[ee] = [$e, Ne, iB(Ne)];
        }
        return j;
      }
      function ah(C, j) {
        var ee = ip(C, j);
        return xm(ee) ? ee : n;
      }
      function X$e(C) {
        var j = yr.call(C, zl), ee = C[zl];
        try {
          C[zl] = n;
          var $e = !0;
        } catch {
        }
        var Ne = Lf.call(C);
        return $e && (j ? C[zl] = ee : delete C[zl]), Ne;
      }
      var G2 = B ? function(C) {
        return C == null ? [] : (C = Xo(C), ta(B(C), function(j) {
          return Nl.call(C, j);
        }));
      } : lI, nB = B ? function(C) {
        for (var j = []; C; )
          nn(j, G2(C)), C = Os(C);
        return j;
      } : lI, Sc = ms;
      (zt && Sc(new zt(new ArrayBuffer(1))) != Pe || Rt && Sc(new Rt()) != be || Sn && Sc(Sn.resolve()) != pe || Cn && Sc(new Cn()) != Te || ro && Sc(new ro()) != st) && (Sc = function(C) {
        var j = ms(C), ee = j == ne ? C.constructor : n, $e = ee ? sh(ee) : "";
        if ($e)
          switch ($e) {
            case bc:
              return Pe;
            case ld:
              return be;
            case jv:
              return pe;
            case Js:
              return Te;
            case Yg:
              return st;
          }
        return j;
      });
      function J$e(C, j, ee) {
        for (var $e = -1, Ne = ee.length; ++$e < Ne; ) {
          var Ve = ee[$e], tt = Ve.size;
          switch (Ve.type) {
            case "drop":
              C += tt;
              break;
            case "dropRight":
              j -= tt;
              break;
            case "take":
              j = qe(j, C + tt);
              break;
            case "takeRight":
              C = Ee(C, j - tt);
              break;
          }
        }
        return { start: C, end: j };
      }
      function Q$e(C) {
        var j = C.match(ho);
        return j ? j[1].split(Ut) : [];
      }
      function oB(C, j, ee) {
        j = Ke(j, C);
        for (var $e = -1, Ne = j.length, Ve = !1; ++$e < Ne; ) {
          var tt = gp(j[$e]);
          if (!(Ve = C != null && ee(C, tt)))
            break;
          C = C[tt];
        }
        return Ve || ++$e != Ne ? Ve : (Ne = C == null ? 0 : C.length, !!Ne && K1(Ne) && Im(tt, Ne) && (tr(C) || ch(C)));
      }
      function ewe(C) {
        var j = C.length, ee = new C.constructor(j);
        return j && typeof C[0] == "string" && yr.call(C, "index") && (ee.index = C.index, ee.input = C.input), ee;
      }
      function rB(C) {
        return typeof C.constructor == "function" && !D$(C) ? so(Os(C)) : {};
      }
      function twe(C, j, ee) {
        var $e = C.constructor;
        switch (j) {
          case ze:
            return Lt(C);
          case ae:
          case Y:
            return new $e(+C);
          case Pe:
            return St(C, ee);
          case je:
          case He:
          case Xe:
          case at:
          case wt:
          case Je:
          case vt:
          case Ot:
          case Ft:
            return Ht(C, ee);
          case be:
            return new $e();
          case Q:
          case Re:
            return new $e(C);
          case ve:
            return jt(C);
          case Te:
            return new $e();
          case Me:
            return bn(C);
        }
      }
      function nwe(C, j) {
        var ee = j.length;
        if (!ee)
          return C;
        var $e = ee - 1;
        return j[$e] = (ee > 1 ? "& " : "") + j[$e], j = j.join(ee > 2 ? ", " : " "), C.replace(qo, `{
/* [wrapped with ` + j + `] */
`);
      }
      function owe(C) {
        return tr(C) || ch(C) || !!(lp && C && C[lp]);
      }
      function Im(C, j) {
        var ee = typeof C;
        return j = j ?? I, !!j && (ee == "number" || ee != "symbol" && Pt.test(C)) && C > -1 && C % 1 == 0 && C < j;
      }
      function rl(C, j, ee) {
        if (!xa(ee))
          return !1;
        var $e = typeof j;
        return ($e == "number" ? Ll(ee) && Im(j, ee.length) : $e == "string" && j in ee) ? d_(ee[j], C) : !1;
      }
      function W2(C, j) {
        if (tr(C))
          return !1;
        var ee = typeof C;
        return ee == "number" || ee == "symbol" || ee == "boolean" || C == null || gu(C) ? !0 : Qn.test(C) || !Xn.test(C) || j != null && C in Xo(j);
      }
      function rwe(C) {
        var j = typeof C;
        return j == "string" || j == "number" || j == "symbol" || j == "boolean" ? C !== "__proto__" : C === null;
      }
      function H2(C) {
        var j = j1(C), ee = Le[j];
        if (typeof ee != "function" || !(j in jo.prototype))
          return !1;
        if (C === ee)
          return !0;
        var $e = B2(ee);
        return !!$e && C === $e[0];
      }
      function iwe(C) {
        return !!i_ && i_ in C;
      }
      var awe = r_ ? Om : uI;
      function D$(C) {
        var j = C && C.constructor, ee = typeof j == "function" && j.prototype || vc;
        return C === ee;
      }
      function iB(C) {
        return C === C && !xa(C);
      }
      function aB(C, j) {
        return function(ee) {
          return ee == null ? !1 : ee[C] === j && (j !== n || C in Xo(ee));
        };
      }
      function swe(C) {
        var j = H1(C, function($e) {
          return ee.size === l && ee.clear(), $e;
        }), ee = j.cache;
        return j;
      }
      function cwe(C, j) {
        var ee = C[1], $e = j[1], Ne = ee | $e, Ve = Ne < (h | $ | M), tt = $e == M && ee == b || $e == M && ee == q && C[7].length <= j[8] || $e == (M | q) && j[7].length <= j[8] && ee == b;
        if (!(Ve || tt))
          return C;
        $e & h && (C[2] = j[2], Ne |= ee & h ? 0 : v);
        var ft = j[3];
        if (ft) {
          var Et = C[3];
          C[3] = Et ? eo(Et, ft, j[4]) : ft, C[4] = Et ? Do(C[3], u) : j[4];
        }
        return ft = j[5], ft && (Et = C[5], C[5] = Et ? mo(Et, ft, j[6]) : ft, C[6] = Et ? Do(C[5], u) : j[6]), ft = j[7], ft && (C[7] = ft), $e & M && (C[8] = C[8] == null ? j[8] : qe(C[8], j[8])), C[9] == null && (C[9] = j[9]), C[0] = j[0], C[1] = Ne, C;
      }
      function lwe(C) {
        var j = [];
        if (C != null)
          for (var ee in Xo(C))
            j.push(ee);
        return j;
      }
      function uwe(C) {
        return Lf.call(C);
      }
      function sB(C, j, ee) {
        return j = Ee(j === n ? C.length - 1 : j, 0), function() {
          for (var $e = arguments, Ne = -1, Ve = Ee($e.length - j, 0), tt = mt(Ve); ++Ne < Ve; )
            tt[Ne] = $e[j + Ne];
          Ne = -1;
          for (var ft = mt(j + 1); ++Ne < j; )
            ft[Ne] = $e[Ne];
          return ft[j] = ee(tt), _o(C, this, ft);
        };
      }
      function cB(C, j) {
        return j.length < 2 ? C : _p(C, Pl(j, 0, -1));
      }
      function dwe(C, j) {
        for (var ee = C.length, $e = qe(j.length, ee), Ne = to(C); $e--; ) {
          var Ve = j[$e];
          C[$e] = Im(Ve, ee) ? Ne[Ve] : n;
        }
        return C;
      }
      function Y2(C, j) {
        if (!(j === "constructor" && typeof C[j] == "function") && j != "__proto__")
          return C[j];
      }
      var lB = dB(N$), L$ = qv || function(C, j) {
        return ma.setTimeout(C, j);
      }, K2 = dB(L2);
      function uB(C, j, ee) {
        var $e = j + "";
        return K2(C, nwe($e, _we(Q$e($e), ee)));
      }
      function dB(C) {
        var j = 0, ee = 0;
        return function() {
          var $e = ot(), Ne = A - ($e - ee);
          if (ee = $e, Ne > 0) {
            if (++j >= D)
              return arguments[0];
          } else
            j = 0;
          return C.apply(n, arguments);
        };
      }
      function B1(C, j) {
        var ee = -1, $e = C.length, Ne = $e - 1;
        for (j = j === n ? $e : j; ++ee < j; ) {
          var Ve = u_(ee, Ne), tt = C[Ve];
          C[Ve] = C[ee], C[ee] = tt;
        }
        return C.length = j, C;
      }
      var _B = swe(function(C) {
        var j = [];
        return C.charCodeAt(0) === 46 && j.push(""), C.replace(In, function(ee, $e, Ne, Ve) {
          j.push(Ne ? Ve.replace(Gn, "$1") : $e || ee);
        }), j;
      });
      function gp(C) {
        if (typeof C == "string" || gu(C))
          return C;
        var j = C + "";
        return j == "0" && 1 / C == -k ? "-0" : j;
      }
      function sh(C) {
        if (C != null) {
          try {
            return ap.call(C);
          } catch {
          }
          try {
            return C + "";
          } catch {
          }
        }
        return "";
      }
      function _we(C, j) {
        return $a(U, function(ee) {
          var $e = "_." + ee[0];
          j & ee[1] && !Tl(C, $e) && C.push($e);
        }), C.sort();
      }
      function pB(C) {
        if (C instanceof jo)
          return C.clone();
        var j = new ds(C.__wrapped__, C.__chain__);
        return j.__actions__ = to(C.__actions__), j.__index__ = C.__index__, j.__values__ = C.__values__, j;
      }
      function pwe(C, j, ee) {
        (ee ? rl(C, j, ee) : j === n) ? j = 1 : j = Ee(ir(j), 0);
        var $e = C == null ? 0 : C.length;
        if (!$e || j < 1)
          return [];
        for (var Ne = 0, Ve = 0, tt = mt(cd($e / j)); Ne < $e; )
          tt[Ve++] = Pl(C, Ne, Ne += j);
        return tt;
      }
      function mwe(C) {
        for (var j = -1, ee = C == null ? 0 : C.length, $e = 0, Ne = []; ++j < ee; ) {
          var Ve = C[j];
          Ve && (Ne[$e++] = Ve);
        }
        return Ne;
      }
      function fwe() {
        var C = arguments.length;
        if (!C)
          return [];
        for (var j = mt(C - 1), ee = arguments[0], $e = C; $e--; )
          j[$e - 1] = arguments[$e];
        return nn(tr(ee) ? to(ee) : [ee], ps(j, 1));
      }
      var gwe = rr(function(C, j) {
        return qa(C) ? eh(C, ps(j, 1, qa, !0)) : [];
      }), hwe = rr(function(C, j) {
        var ee = gd(j);
        return qa(ee) && (ee = n), qa(C) ? eh(C, ps(j, 1, qa, !0), wo(ee, 2)) : [];
      }), vwe = rr(function(C, j) {
        var ee = gd(j);
        return qa(ee) && (ee = n), qa(C) ? eh(C, ps(j, 1, qa, !0), n, ee) : [];
      });
      function bwe(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        return $e ? (j = ee || j === n ? 1 : ir(j), Pl(C, j < 0 ? 0 : j, $e)) : [];
      }
      function ywe(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        return $e ? (j = ee || j === n ? 1 : ir(j), j = $e - j, Pl(C, 0, j < 0 ? 0 : j)) : [];
      }
      function $we(C, j) {
        return C && C.length ? se(C, wo(j, 3), !0, !0) : [];
      }
      function wwe(C, j) {
        return C && C.length ? se(C, wo(j, 3), !0) : [];
      }
      function kwe(C, j, ee, $e) {
        var Ne = C == null ? 0 : C.length;
        return Ne ? (ee && typeof ee != "number" && rl(C, j, ee) && (ee = 0, $e = Ne), km(C, j, ee, $e)) : [];
      }
      function mB(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        if (!$e)
          return -1;
        var Ne = ee == null ? 0 : ir(ee);
        return Ne < 0 && (Ne = Ee($e + Ne, 0)), na(C, wo(j, 3), Ne);
      }
      function fB(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        if (!$e)
          return -1;
        var Ne = $e - 1;
        return ee !== n && (Ne = ir(ee), Ne = ee < 0 ? Ee($e + Ne, 0) : qe(Ne, $e - 1)), na(C, wo(j, 3), Ne, !0);
      }
      function gB(C) {
        var j = C == null ? 0 : C.length;
        return j ? ps(C, 1) : [];
      }
      function Swe(C) {
        var j = C == null ? 0 : C.length;
        return j ? ps(C, k) : [];
      }
      function Ewe(C, j) {
        var ee = C == null ? 0 : C.length;
        return ee ? (j = j === n ? 1 : ir(j), ps(C, j)) : [];
      }
      function xwe(C) {
        for (var j = -1, ee = C == null ? 0 : C.length, $e = {}; ++j < ee; ) {
          var Ne = C[j];
          $e[Ne[0]] = Ne[1];
        }
        return $e;
      }
      function hB(C) {
        return C && C.length ? C[0] : n;
      }
      function Cwe(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        if (!$e)
          return -1;
        var Ne = ee == null ? 0 : ir(ee);
        return Ne < 0 && (Ne = Ee($e + Ne, 0)), As(C, j, Ne);
      }
      function Twe(C) {
        var j = C == null ? 0 : C.length;
        return j ? Pl(C, 0, -1) : [];
      }
      var Awe = rr(function(C) {
        var j = Zo(C, Oe);
        return j.length && j[0] === C[0] ? pp(j) : [];
      }), Iwe = rr(function(C) {
        var j = gd(C), ee = Zo(C, Oe);
        return j === gd(ee) ? j = n : ee.pop(), ee.length && ee[0] === C[0] ? pp(ee, wo(j, 2)) : [];
      }), Owe = rr(function(C) {
        var j = gd(C), ee = Zo(C, Oe);
        return j = typeof j == "function" ? j : n, j && ee.pop(), ee.length && ee[0] === C[0] ? pp(ee, n, j) : [];
      });
      function Nwe(C, j) {
        return C == null ? "" : fe.call(C, j);
      }
      function gd(C) {
        var j = C == null ? 0 : C.length;
        return j ? C[j - 1] : n;
      }
      function zwe(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        if (!$e)
          return -1;
        var Ne = $e;
        return ee !== n && (Ne = ir(ee), Ne = Ne < 0 ? Ee($e + Ne, 0) : qe(Ne, $e - 1)), j === j ? G(C, j, Ne) : na(C, n_, Ne, !0);
      }
      function Rwe(C, j) {
        return C && C.length ? R1(C, ir(j)) : n;
      }
      var Pwe = rr(vB);
      function vB(C, j) {
        return C && C.length && j && j.length ? fp(C, j) : C;
      }
      function Dwe(C, j, ee) {
        return C && C.length && j && j.length ? fp(C, j, wo(ee, 2)) : C;
      }
      function Lwe(C, j, ee) {
        return C && C.length && j && j.length ? fp(C, j, n, ee) : C;
      }
      var Mwe = Am(function(C, j) {
        var ee = C == null ? 0 : C.length, $e = Yi(C, j);
        return D1(C, Zo(j, function(Ne) {
          return Im(Ne, ee) ? +Ne : Ne;
        }).sort(ln)), $e;
      });
      function Fwe(C, j) {
        var ee = [];
        if (!(C && C.length))
          return ee;
        var $e = -1, Ne = [], Ve = C.length;
        for (j = wo(j, 3); ++$e < Ve; ) {
          var tt = C[$e];
          j(tt, $e, C) && (ee.push(tt), Ne.push($e));
        }
        return D1(C, Ne), ee;
      }
      function Z2(C) {
        return C == null ? C : Mt.call(C);
      }
      function qwe(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        return $e ? (ee && typeof ee != "number" && rl(C, j, ee) ? (j = 0, ee = $e) : (j = j == null ? 0 : ir(j), ee = ee === n ? $e : ir(ee)), Pl(C, j, ee)) : [];
      }
      function jwe(C, j) {
        return ol(C, j);
      }
      function Vwe(C, j, ee) {
        return Yv(C, j, wo(ee, 2));
      }
      function Bwe(C, j) {
        var ee = C == null ? 0 : C.length;
        if (ee) {
          var $e = ol(C, j);
          if ($e < ee && d_(C[$e], j))
            return $e;
        }
        return -1;
      }
      function Uwe(C, j) {
        return ol(C, j, !0);
      }
      function Gwe(C, j, ee) {
        return Yv(C, j, wo(ee, 2), !0);
      }
      function Wwe(C, j) {
        var ee = C == null ? 0 : C.length;
        if (ee) {
          var $e = ol(C, j, !0) - 1;
          if (d_(C[$e], j))
            return $e;
        }
        return -1;
      }
      function Hwe(C) {
        return C && C.length ? Kv(C) : [];
      }
      function Ywe(C, j) {
        return C && C.length ? Kv(C, wo(j, 2)) : [];
      }
      function Kwe(C) {
        var j = C == null ? 0 : C.length;
        return j ? Pl(C, 1, j) : [];
      }
      function Zwe(C, j, ee) {
        return C && C.length ? (j = ee || j === n ? 1 : ir(j), Pl(C, 0, j < 0 ? 0 : j)) : [];
      }
      function Xwe(C, j, ee) {
        var $e = C == null ? 0 : C.length;
        return $e ? (j = ee || j === n ? 1 : ir(j), j = $e - j, Pl(C, j < 0 ? 0 : j, $e)) : [];
      }
      function Jwe(C, j) {
        return C && C.length ? se(C, wo(j, 3), !1, !0) : [];
      }
      function Qwe(C, j) {
        return C && C.length ? se(C, wo(j, 3)) : [];
      }
      var eke = rr(function(C) {
        return te(ps(C, 1, qa, !0));
      }), tke = rr(function(C) {
        var j = gd(C);
        return qa(j) && (j = n), te(ps(C, 1, qa, !0), wo(j, 2));
      }), nke = rr(function(C) {
        var j = gd(C);
        return j = typeof j == "function" ? j : n, te(ps(C, 1, qa, !0), n, j);
      });
      function oke(C) {
        return C && C.length ? te(C) : [];
      }
      function rke(C, j) {
        return C && C.length ? te(C, wo(j, 2)) : [];
      }
      function ike(C, j) {
        return j = typeof j == "function" ? j : n, C && C.length ? te(C, n, j) : [];
      }
      function X2(C) {
        if (!(C && C.length))
          return [];
        var j = 0;
        return C = ta(C, function(ee) {
          if (qa(ee))
            return j = Ee(ee.length, j), !0;
        }), Ol(j, function(ee) {
          return Zo(C, Za(ee));
        });
      }
      function bB(C, j) {
        if (!(C && C.length))
          return [];
        var ee = X2(C);
        return j == null ? ee : Zo(ee, function($e) {
          return _o(j, n, $e);
        });
      }
      var ake = rr(function(C, j) {
        return qa(C) ? eh(C, j) : [];
      }), ske = rr(function(C) {
        return we(ta(C, qa));
      }), cke = rr(function(C) {
        var j = gd(C);
        return qa(j) && (j = n), we(ta(C, qa), wo(j, 2));
      }), lke = rr(function(C) {
        var j = gd(C);
        return j = typeof j == "function" ? j : n, we(ta(C, qa), n, j);
      }), uke = rr(X2);
      function dke(C, j) {
        return Ce(C || [], j || [], dp);
      }
      function _ke(C, j) {
        return Ce(C || [], j || [], ih);
      }
      var pke = rr(function(C) {
        var j = C.length, ee = j > 1 ? C[j - 1] : n;
        return ee = typeof ee == "function" ? (C.pop(), ee) : n, bB(C, ee);
      });
      function yB(C) {
        var j = Le(C);
        return j.__chain__ = !0, j;
      }
      function mke(C, j) {
        return j(C), C;
      }
      function U1(C, j) {
        return j(C);
      }
      var fke = Am(function(C) {
        var j = C.length, ee = j ? C[0] : 0, $e = this.__wrapped__, Ne = function(Ve) {
          return Yi(Ve, C);
        };
        return j > 1 || this.__actions__.length || !($e instanceof jo) || !Im(ee) ? this.thru(Ne) : ($e = $e.slice(ee, +ee + (j ? 1 : 0)), $e.__actions__.push({
          func: U1,
          args: [Ne],
          thisArg: n
        }), new ds($e, this.__chain__).thru(function(Ve) {
          return j && !Ve.length && Ve.push(n), Ve;
        }));
      });
      function gke() {
        return yB(this);
      }
      function hke() {
        return new ds(this.value(), this.__chain__);
      }
      function vke() {
        this.__values__ === n && (this.__values__ = RB(this.value()));
        var C = this.__index__ >= this.__values__.length, j = C ? n : this.__values__[this.__index__++];
        return { done: C, value: j };
      }
      function bke() {
        return this;
      }
      function yke(C) {
        for (var j, ee = this; ee instanceof c_; ) {
          var $e = pB(ee);
          $e.__index__ = 0, $e.__values__ = n, j ? Ne.__wrapped__ = $e : j = $e;
          var Ne = $e;
          ee = ee.__wrapped__;
        }
        return Ne.__wrapped__ = C, j;
      }
      function $ke() {
        var C = this.__wrapped__;
        if (C instanceof jo) {
          var j = C;
          return this.__actions__.length && (j = new jo(this)), j = j.reverse(), j.__actions__.push({
            func: U1,
            args: [Z2],
            thisArg: n
          }), new ds(j, this.__chain__);
        }
        return this.thru(Z2);
      }
      function wke() {
        return ye(this.__wrapped__, this.__actions__);
      }
      var kke = Tr(function(C, j, ee) {
        yr.call(C, ee) ? ++C[ee] : Ja(C, ee, 1);
      });
      function Ske(C, j, ee) {
        var $e = tr(C) ? wa : T1;
        return ee && rl(C, j, ee) && (j = n), $e(C, wo(j, 3));
      }
      function Eke(C, j) {
        var ee = tr(C) ? ta : A1;
        return ee(C, wo(j, 3));
      }
      var xke = HV(mB), Cke = HV(fB);
      function Tke(C, j) {
        return ps(G1(C, j), 1);
      }
      function Ake(C, j) {
        return ps(G1(C, j), k);
      }
      function Ike(C, j, ee) {
        return ee = ee === n ? 1 : ir(ee), ps(G1(C, j), ee);
      }
      function $B(C, j) {
        var ee = tr(C) ? $a : pd;
        return ee(C, wo(j, 3));
      }
      function wB(C, j) {
        var ee = tr(C) ? Cl : C1;
        return ee(C, wo(j, 3));
      }
      var Oke = Tr(function(C, j, ee) {
        yr.call(C, ee) ? C[ee].push(j) : Ja(C, ee, [j]);
      });
      function Nke(C, j, ee, $e) {
        C = Ll(C) ? C : Qv(C), ee = ee && !$e ? ir(ee) : 0;
        var Ne = C.length;
        return ee < 0 && (ee = Ee(Ne + ee, 0)), Z1(C) ? ee <= Ne && C.indexOf(j, ee) > -1 : !!Ne && As(C, j, ee) > -1;
      }
      var zke = rr(function(C, j, ee) {
        var $e = -1, Ne = typeof j == "function", Ve = Ll(C) ? mt(C.length) : [];
        return pd(C, function(tt) {
          Ve[++$e] = Ne ? _o(j, tt, ee) : Qa(tt, j, ee);
        }), Ve;
      }), Rke = Tr(function(C, j, ee) {
        Ja(C, ee, j);
      });
      function G1(C, j) {
        var ee = tr(C) ? Zo : rh;
        return ee(C, wo(j, 3));
      }
      function Pke(C, j, ee, $e) {
        return C == null ? [] : (tr(j) || (j = j == null ? [] : [j]), ee = $e ? n : ee, tr(ee) || (ee = ee == null ? [] : [ee]), P1(C, j, ee));
      }
      var Dke = Tr(function(C, j, ee) {
        C[ee ? 0 : 1].push(j);
      }, function() {
        return [[], []];
      });
      function Lke(C, j, ee) {
        var $e = tr(C) ? Ts : Il, Ne = arguments.length < 3;
        return $e(C, wo(j, 4), ee, Ne, pd);
      }
      function Mke(C, j, ee) {
        var $e = tr(C) ? po : Il, Ne = arguments.length < 3;
        return $e(C, wo(j, 4), ee, Ne, C1);
      }
      function Fke(C, j) {
        var ee = tr(C) ? ta : A1;
        return ee(C, Y1(wo(j, 3)));
      }
      function qke(C) {
        var j = tr(C) ? Hi : P2;
        return j(C);
      }
      function jke(C, j, ee) {
        (ee ? rl(C, j, ee) : j === n) ? j = 1 : j = ir(j);
        var $e = tr(C) ? Ea : D2;
        return $e(C, j);
      }
      function Vke(C) {
        var j = tr(C) ? $c : M2;
        return j(C);
      }
      function Bke(C) {
        if (C == null)
          return 0;
        if (Ll(C))
          return Z1(C) ? ce(C) : C.length;
        var j = Sc(C);
        return j == be || j == Te ? C.size : I$(C).length;
      }
      function Uke(C, j, ee) {
        var $e = tr(C) ? Zc : z$;
        return ee && rl(C, j, ee) && (j = n), $e(C, wo(j, 3));
      }
      var Gke = rr(function(C, j) {
        if (C == null)
          return [];
        var ee = j.length;
        return ee > 1 && rl(C, j[0], j[1]) ? j = [] : ee > 2 && rl(j[0], j[1], j[2]) && (j = [j[0]]), P1(C, ps(j, 1), []);
      }), W1 = Mf || function() {
        return ma.Date.now();
      };
      function Wke(C, j) {
        if (typeof j != "function")
          throw new gc(a);
        return C = ir(C), function() {
          if (--C < 1)
            return j.apply(this, arguments);
        };
      }
      function kB(C, j, ee) {
        return j = ee ? n : j, j = C && j == null ? C.length : j, Tm(C, M, n, n, n, n, j);
      }
      function SB(C, j) {
        var ee;
        if (typeof j != "function")
          throw new gc(a);
        return C = ir(C), function() {
          return --C > 0 && (ee = j.apply(this, arguments)), C <= 1 && (j = n), ee;
        };
      }
      var J2 = rr(function(C, j, ee) {
        var $e = h;
        if (ee.length) {
          var Ne = Do(ee, Xv(J2));
          $e |= w;
        }
        return Tm(C, $e, j, ee, Ne);
      }), EB = rr(function(C, j, ee) {
        var $e = h | $;
        if (ee.length) {
          var Ne = Do(ee, Xv(EB));
          $e |= w;
        }
        return Tm(j, $e, C, ee, Ne);
      });
      function xB(C, j, ee) {
        j = ee ? n : j;
        var $e = Tm(C, b, n, n, n, n, n, j);
        return $e.placeholder = xB.placeholder, $e;
      }
      function CB(C, j, ee) {
        j = ee ? n : j;
        var $e = Tm(C, y, n, n, n, n, n, j);
        return $e.placeholder = CB.placeholder, $e;
      }
      function TB(C, j, ee) {
        var $e, Ne, Ve, tt, ft, Et, Zt = 0, Xt = !1, rn = !1, Mn = !0;
        if (typeof C != "function")
          throw new gc(a);
        j = hd(j) || 0, xa(ee) && (Xt = !!ee.leading, rn = "maxWait" in ee, Ve = rn ? Ee(hd(ee.maxWait) || 0, j) : Ve, Mn = "trailing" in ee ? !!ee.trailing : Mn);
        function oo(ja) {
          var __ = $e, zm = Ne;
          return $e = Ne = n, Zt = ja, tt = C.apply(zm, __), tt;
        }
        function Ao(ja) {
          return Zt = ja, ft = L$($r, j), Xt ? oo(ja) : tt;
        }
        function dr(ja) {
          var __ = ja - Et, zm = ja - Zt, HB = j - __;
          return rn ? qe(HB, Ve - zm) : HB;
        }
        function Io(ja) {
          var __ = ja - Et, zm = ja - Zt;
          return Et === n || __ >= j || __ < 0 || rn && zm >= Ve;
        }
        function $r() {
          var ja = W1();
          if (Io(ja))
            return Ar(ja);
          ft = L$($r, dr(ja));
        }
        function Ar(ja) {
          return ft = n, Mn && $e ? oo(ja) : ($e = Ne = n, tt);
        }
        function hu() {
          ft !== n && _t(ft), Zt = 0, $e = Et = Ne = ft = n;
        }
        function il() {
          return ft === n ? tt : Ar(W1());
        }
        function vu() {
          var ja = W1(), __ = Io(ja);
          if ($e = arguments, Ne = this, Et = ja, __) {
            if (ft === n)
              return Ao(Et);
            if (rn)
              return _t(ft), ft = L$($r, j), oo(Et);
          }
          return ft === n && (ft = L$($r, j)), tt;
        }
        return vu.cancel = hu, vu.flush = il, vu;
      }
      var Hke = rr(function(C, j) {
        return x1(C, 1, j);
      }), Yke = rr(function(C, j, ee) {
        return x1(C, hd(j) || 0, ee);
      });
      function Kke(C) {
        return Tm(C, L);
      }
      function H1(C, j) {
        if (typeof C != "function" || j != null && typeof j != "function")
          throw new gc(a);
        var ee = function() {
          var $e = arguments, Ne = j ? j.apply(this, $e) : $e[0], Ve = ee.cache;
          if (Ve.has(Ne))
            return Ve.get(Ne);
          var tt = C.apply(this, $e);
          return ee.cache = Ve.set(Ne, tt) || Ve, tt;
        };
        return ee.cache = new (H1.Cache || ec)(), ee;
      }
      H1.Cache = ec;
      function Y1(C) {
        if (typeof C != "function")
          throw new gc(a);
        return function() {
          var j = arguments;
          switch (j.length) {
            case 0:
              return !C.call(this);
            case 1:
              return !C.call(this, j[0]);
            case 2:
              return !C.call(this, j[0], j[1]);
            case 3:
              return !C.call(this, j[0], j[1], j[2]);
          }
          return !C.apply(this, j);
        };
      }
      function Zke(C) {
        return SB(2, C);
      }
      var Xke = rt(function(C, j) {
        j = j.length == 1 && tr(j[0]) ? Zo(j[0], fa(wo())) : Zo(ps(j, 1), fa(wo()));
        var ee = j.length;
        return rr(function($e) {
          for (var Ne = -1, Ve = qe($e.length, ee); ++Ne < Ve; )
            $e[Ne] = j[Ne].call(this, $e[Ne]);
          return _o(C, this, $e);
        });
      }), Q2 = rr(function(C, j) {
        var ee = Do(j, Xv(Q2));
        return Tm(C, w, n, j, ee);
      }), AB = rr(function(C, j) {
        var ee = Do(j, Xv(AB));
        return Tm(C, N, n, j, ee);
      }), Jke = Am(function(C, j) {
        return Tm(C, q, n, n, n, j);
      });
      function Qke(C, j) {
        if (typeof C != "function")
          throw new gc(a);
        return j = j === n ? j : ir(j), rr(C, j);
      }
      function e0e(C, j) {
        if (typeof C != "function")
          throw new gc(a);
        return j = j == null ? 0 : Ee(ir(j), 0), rr(function(ee) {
          var $e = ee[j], Ne = ut(ee, 0, j);
          return $e && nn(Ne, $e), _o(C, this, Ne);
        });
      }
      function t0e(C, j, ee) {
        var $e = !0, Ne = !0;
        if (typeof C != "function")
          throw new gc(a);
        return xa(ee) && ($e = "leading" in ee ? !!ee.leading : $e, Ne = "trailing" in ee ? !!ee.trailing : Ne), TB(C, j, {
          leading: $e,
          maxWait: j,
          trailing: Ne
        });
      }
      function n0e(C) {
        return kB(C, 1);
      }
      function o0e(C, j) {
        return Q2(Ye(j), C);
      }
      function r0e() {
        if (!arguments.length)
          return [];
        var C = arguments[0];
        return tr(C) ? C : [C];
      }
      function i0e(C) {
        return nl(C, p);
      }
      function a0e(C, j) {
        return j = typeof j == "function" ? j : n, nl(C, p, j);
      }
      function s0e(C) {
        return nl(C, d | p);
      }
      function c0e(C, j) {
        return j = typeof j == "function" ? j : n, nl(C, d | p, j);
      }
      function l0e(C, j) {
        return j == null || E1(C, j, Rs(j));
      }
      function d_(C, j) {
        return C === j || C !== C && j !== j;
      }
      var u0e = q1(hi), d0e = q1(function(C, j) {
        return C >= j;
      }), ch = O1(/* @__PURE__ */ function() {
        return arguments;
      }()) ? O1 : function(C) {
        return za(C) && yr.call(C, "callee") && !Nl.call(C, "callee");
      }, tr = mt.isArray, _0e = Rf ? fa(Rf) : N2;
      function Ll(C) {
        return C != null && K1(C.length) && !Om(C);
      }
      function qa(C) {
        return za(C) && Ll(C);
      }
      function p0e(C) {
        return C === !0 || C === !1 || za(C) && ms(C) == ae;
      }
      var Bf = K || uI, m0e = Pf ? fa(Pf) : E$;
      function f0e(C) {
        return za(C) && C.nodeType === 1 && !M$(C);
      }
      function g0e(C) {
        if (C == null)
          return !0;
        if (Ll(C) && (tr(C) || typeof C == "string" || typeof C.splice == "function" || Bf(C) || Jv(C) || ch(C)))
          return !C.length;
        var j = Sc(C);
        if (j == be || j == Te)
          return !C.size;
        if (D$(C))
          return !I$(C).length;
        for (var ee in C)
          if (yr.call(C, ee))
            return !1;
        return !0;
      }
      function h0e(C, j) {
        return jf(C, j);
      }
      function v0e(C, j, ee) {
        ee = typeof ee == "function" ? ee : n;
        var $e = ee ? ee(C, j) : n;
        return $e === n ? jf(C, j, n, ee) : !!$e;
      }
      function eI(C) {
        if (!za(C))
          return !1;
        var j = ms(C);
        return j == ie || j == re || typeof C.message == "string" && typeof C.name == "string" && !M$(C);
      }
      function b0e(C) {
        return typeof C == "number" && ue(C);
      }
      function Om(C) {
        if (!xa(C))
          return !1;
        var j = ms(C);
        return j == _e || j == he || j == le || j == ge;
      }
      function IB(C) {
        return typeof C == "number" && C == ir(C);
      }
      function K1(C) {
        return typeof C == "number" && C > -1 && C % 1 == 0 && C <= I;
      }
      function xa(C) {
        var j = typeof C;
        return C != null && (j == "object" || j == "function");
      }
      function za(C) {
        return C != null && typeof C == "object";
      }
      var OB = Kc ? fa(Kc) : Vf;
      function y0e(C, j) {
        return C === j || x$(C, j, U2(j));
      }
      function $0e(C, j, ee) {
        return ee = typeof ee == "function" ? ee : n, x$(C, j, U2(j), ee);
      }
      function w0e(C) {
        return NB(C) && C != +C;
      }
      function k0e(C) {
        if (awe(C))
          throw new on(i);
        return xm(C);
      }
      function S0e(C) {
        return C === null;
      }
      function E0e(C) {
        return C == null;
      }
      function NB(C) {
        return typeof C == "number" || za(C) && ms(C) == Q;
      }
      function M$(C) {
        if (!za(C) || ms(C) != ne)
          return !1;
        var j = Os(C);
        if (j === null)
          return !0;
        var ee = yr.call(j, "constructor") && j.constructor;
        return typeof ee == "function" && ee instanceof ee && ap.call(ee) == Gg;
      }
      var tI = t_ ? fa(t_) : oh;
      function x0e(C) {
        return IB(C) && C >= -I && C <= I;
      }
      var zB = od ? fa(od) : C$;
      function Z1(C) {
        return typeof C == "string" || !tr(C) && za(C) && ms(C) == Re;
      }
      function gu(C) {
        return typeof C == "symbol" || za(C) && ms(C) == Me;
      }
      var Jv = rd ? fa(rd) : T$;
      function C0e(C) {
        return C === n;
      }
      function T0e(C) {
        return za(C) && Sc(C) == st;
      }
      function A0e(C) {
        return za(C) && ms(C) == De;
      }
      var I0e = q1(Wv), O0e = q1(function(C, j) {
        return C <= j;
      });
      function RB(C) {
        if (!C)
          return [];
        if (Ll(C))
          return Z1(C) ? Se(C) : to(C);
        if (pu && C[pu])
          return Bi(C[pu]());
        var j = Sc(C), ee = j == be ? Jr : j == Te ? Jc : Qv;
        return ee(C);
      }
      function Nm(C) {
        if (!C)
          return C === 0 ? C : 0;
        if (C = hd(C), C === k || C === -k) {
          var j = C < 0 ? -1 : 1;
          return j * z;
        }
        return C === C ? C : 0;
      }
      function ir(C) {
        var j = Nm(C), ee = j % 1;
        return j === j ? ee ? j - ee : j : 0;
      }
      function PB(C) {
        return C ? wm(ir(C), 0, P) : 0;
      }
      function hd(C) {
        if (typeof C == "number")
          return C;
        if (gu(C))
          return F;
        if (xa(C)) {
          var j = typeof C.valueOf == "function" ? C.valueOf() : C;
          C = xa(j) ? j + "" : j;
        }
        if (typeof C != "string")
          return C === 0 ? C : +C;
        C = Na(C);
        var ee = gn.test(C);
        return ee || dt.test(C) ? np(C.slice(2), ee ? 2 : 8) : zn.test(C) ? F : +C;
      }
      function DB(C) {
        return Go(C, Ml(C));
      }
      function N0e(C) {
        return C ? wm(ir(C), -I, I) : C === 0 ? C : 0;
      }
      function ii(C) {
        return C == null ? "" : fs(C);
      }
      var z0e = ia(function(C, j) {
        if (D$(j) || Ll(j)) {
          Go(j, Rs(j), C);
          return;
        }
        for (var ee in j)
          yr.call(j, ee) && dp(C, ee, j[ee]);
      }), LB = ia(function(C, j) {
        Go(j, Ml(j), C);
      }), X1 = ia(function(C, j, ee, $e) {
        Go(j, Ml(j), C, $e);
      }), R0e = ia(function(C, j, ee, $e) {
        Go(j, Rs(j), C, $e);
      }), P0e = Am(Yi);
      function D0e(C, j) {
        var ee = so(C);
        return j == null ? ee : _s(ee, j);
      }
      var L0e = rr(function(C, j) {
        C = Xo(C);
        var ee = -1, $e = j.length, Ne = $e > 2 ? j[2] : n;
        for (Ne && rl(j[0], j[1], Ne) && ($e = 1); ++ee < $e; )
          for (var Ve = j[ee], tt = Ml(Ve), ft = -1, Et = tt.length; ++ft < Et; ) {
            var Zt = tt[ft], Xt = C[Zt];
            (Xt === n || d_(Xt, vc[Zt]) && !yr.call(C, Zt)) && (C[Zt] = Ve[Zt]);
          }
        return C;
      }), M0e = rr(function(C) {
        return C.push(n, eB), _o(MB, n, C);
      });
      function F0e(C, j) {
        return du(C, wo(j, 3), md);
      }
      function q0e(C, j) {
        return du(C, wo(j, 3), S$);
      }
      function j0e(C, j) {
        return C == null ? C : Sm(C, wo(j, 3), Ml);
      }
      function V0e(C, j) {
        return C == null ? C : k$(C, wo(j, 3), Ml);
      }
      function B0e(C, j) {
        return C && md(C, wo(j, 3));
      }
      function U0e(C, j) {
        return C && S$(C, wo(j, 3));
      }
      function G0e(C) {
        return C == null ? [] : nh(C, Rs(C));
      }
      function W0e(C) {
        return C == null ? [] : nh(C, Ml(C));
      }
      function nI(C, j, ee) {
        var $e = C == null ? n : _p(C, j);
        return $e === n ? ee : $e;
      }
      function H0e(C, j) {
        return C != null && oB(C, j, Em);
      }
      function oI(C, j) {
        return C != null && oB(C, j, dn);
      }
      var Y0e = KV(function(C, j, ee) {
        j != null && typeof j.toString != "function" && (j = Lf.call(j)), C[j] = ee;
      }, iI(Fl)), K0e = KV(function(C, j, ee) {
        j != null && typeof j.toString != "function" && (j = Lf.call(j)), yr.call(C, j) ? C[j].push(ee) : C[j] = [ee];
      }, wo), Z0e = rr(Qa);
      function Rs(C) {
        return Ll(C) ? _d(C) : I$(C);
      }
      function Ml(C) {
        return Ll(C) ? _d(C, !0) : N1(C);
      }
      function X0e(C, j) {
        var ee = {};
        return j = wo(j, 3), md(C, function($e, Ne, Ve) {
          Ja(ee, j($e, Ne, Ve), $e);
        }), ee;
      }
      function J0e(C, j) {
        var ee = {};
        return j = wo(j, 3), md(C, function($e, Ne, Ve) {
          Ja(ee, Ne, j($e, Ne, Ve));
        }), ee;
      }
      var Q0e = ia(function(C, j, ee) {
        Hv(C, j, ee);
      }), MB = ia(function(C, j, ee, $e) {
        Hv(C, j, ee, $e);
      }), e1e = Am(function(C, j) {
        var ee = {};
        if (C == null)
          return ee;
        var $e = !1;
        j = Zo(j, function(Ve) {
          return Ve = Ke(Ve, C), $e || ($e = Ve.length > 1), Ve;
        }), Go(C, V2(C), ee), $e && (ee = nl(ee, d | _ | p, Y$e));
        for (var Ne = j.length; Ne--; )
          W(ee, j[Ne]);
        return ee;
      });
      function t1e(C, j) {
        return FB(C, Y1(wo(j)));
      }
      var n1e = Am(function(C, j) {
        return C == null ? {} : mp(C, j);
      });
      function FB(C, j) {
        if (C == null)
          return {};
        var ee = Zo(V2(C), function($e) {
          return [$e];
        });
        return j = wo(j), es(C, ee, function($e, Ne) {
          return j($e, Ne[0]);
        });
      }
      function o1e(C, j, ee) {
        j = Ke(j, C);
        var $e = -1, Ne = j.length;
        for (Ne || (Ne = 1, C = n); ++$e < Ne; ) {
          var Ve = C == null ? n : C[gp(j[$e])];
          Ve === n && ($e = Ne, Ve = ee), C = Om(Ve) ? Ve.call(C) : Ve;
        }
        return C;
      }
      function r1e(C, j, ee) {
        return C == null ? C : ih(C, j, ee);
      }
      function i1e(C, j, ee, $e) {
        return $e = typeof $e == "function" ? $e : n, C == null ? C : ih(C, j, ee, $e);
      }
      var qB = JV(Rs), jB = JV(Ml);
      function a1e(C, j, ee) {
        var $e = tr(C), Ne = $e || Bf(C) || Jv(C);
        if (j = wo(j, 4), ee == null) {
          var Ve = C && C.constructor;
          Ne ? ee = $e ? new Ve() : [] : xa(C) ? ee = Om(Ve) ? so(Os(C)) : {} : ee = {};
        }
        return (Ne ? $a : md)(C, function(tt, ft, Et) {
          return j(ee, tt, ft, Et);
        }), ee;
      }
      function s1e(C, j) {
        return C == null ? !0 : W(C, j);
      }
      function c1e(C, j, ee) {
        return C == null ? C : X(C, j, Ye(ee));
      }
      function l1e(C, j, ee, $e) {
        return $e = typeof $e == "function" ? $e : n, C == null ? C : X(C, j, Ye(ee), $e);
      }
      function Qv(C) {
        return C == null ? [] : Is(C, Rs(C));
      }
      function u1e(C) {
        return C == null ? [] : Is(C, Ml(C));
      }
      function d1e(C, j, ee) {
        return ee === n && (ee = j, j = n), ee !== n && (ee = hd(ee), ee = ee === ee ? ee : 0), j !== n && (j = hd(j), j = j === j ? j : 0), wm(hd(C), j, ee);
      }
      function _1e(C, j, ee) {
        return j = Nm(j), ee === n ? (ee = j, j = 0) : ee = Nm(ee), C = hd(C), I1(C, j, ee);
      }
      function p1e(C, j, ee) {
        if (ee && typeof ee != "boolean" && rl(C, j, ee) && (j = ee = n), ee === n && (typeof j == "boolean" ? (ee = j, j = n) : typeof C == "boolean" && (ee = C, C = n)), C === n && j === n ? (C = 0, j = 1) : (C = Nm(C), j === n ? (j = C, C = 0) : j = Nm(j)), C > j) {
          var $e = C;
          C = j, j = $e;
        }
        if (ee || C % 1 || j % 1) {
          var Ne = Vt();
          return qe(C + Ne * (j - C + nd("1e-" + ((Ne + "").length - 1))), j);
        }
        return u_(C, j);
      }
      var m1e = Zv(function(C, j, ee) {
        return j = j.toLowerCase(), C + (ee ? VB(j) : j);
      });
      function VB(C) {
        return rI(ii(C).toLowerCase());
      }
      function BB(C) {
        return C = ii(C), C && C.replace(cn, fr).replace(Zd, "");
      }
      function f1e(C, j, ee) {
        C = ii(C), j = fs(j);
        var $e = C.length;
        ee = ee === n ? $e : wm(ir(ee), 0, $e);
        var Ne = ee;
        return ee -= j.length, ee >= 0 && C.slice(ee, Ne) == j;
      }
      function g1e(C) {
        return C = ii(C), C && Yn.test(C) ? C.replace(Rn, Ii) : C;
      }
      function h1e(C) {
        return C = ii(C), C && uo.test(C) ? C.replace($n, "\\$&") : C;
      }
      var v1e = Zv(function(C, j, ee) {
        return C + (ee ? "-" : "") + j.toLowerCase();
      }), b1e = Zv(function(C, j, ee) {
        return C + (ee ? " " : "") + j.toLowerCase();
      }), y1e = WV("toLowerCase");
      function $1e(C, j, ee) {
        C = ii(C), j = ir(j);
        var $e = j ? ce(C) : 0;
        if (!j || $e >= j)
          return C;
        var Ne = (j - $e) / 2;
        return F1(Z(Ne), ee) + C + F1(cd(Ne), ee);
      }
      function w1e(C, j, ee) {
        C = ii(C), j = ir(j);
        var $e = j ? ce(C) : 0;
        return j && $e < j ? C + F1(j - $e, ee) : C;
      }
      function k1e(C, j, ee) {
        C = ii(C), j = ir(j);
        var $e = j ? ce(C) : 0;
        return j && $e < j ? F1(j - $e, ee) + C : C;
      }
      function S1e(C, j, ee) {
        return ee || j == null ? j = 0 : j && (j = +j), $t(ii(C).replace(go, ""), j || 0);
      }
      function E1e(C, j, ee) {
        return (ee ? rl(C, j, ee) : j === n) ? j = 1 : j = ir(j), O$(ii(C), j);
      }
      function x1e() {
        var C = arguments, j = ii(C[0]);
        return C.length < 3 ? j : j.replace(C[1], C[2]);
      }
      var C1e = Zv(function(C, j, ee) {
        return C + (ee ? "_" : "") + j.toLowerCase();
      });
      function T1e(C, j, ee) {
        return ee && typeof ee != "number" && rl(C, j, ee) && (j = ee = n), ee = ee === n ? P : ee >>> 0, ee ? (C = ii(C), C && (typeof j == "string" || j != null && !tI(j)) && (j = fs(j), !j && Xa(C)) ? ut(Se(C), 0, ee) : C.split(j, ee)) : [];
      }
      var A1e = Zv(function(C, j, ee) {
        return C + (ee ? " " : "") + rI(j);
      });
      function I1e(C, j, ee) {
        return C = ii(C), ee = ee == null ? 0 : wm(ir(ee), 0, C.length), j = fs(j), C.slice(ee, ee + j.length) == j;
      }
      function O1e(C, j, ee) {
        var $e = Le.templateSettings;
        ee && rl(C, j, ee) && (j = n), C = ii(C), j = X1({}, j, $e, QV);
        var Ne = X1({}, j.imports, $e.imports, QV), Ve = Rs(Ne), tt = Is(Ne, Ve), ft, Et, Zt = 0, Xt = j.interpolate || sn, rn = "__p += '", Mn = fc(
          (j.escape || sn).source + "|" + Xt.source + "|" + (Xt === qn ? An : sn).source + "|" + (j.evaluate || sn).source + "|$",
          "g"
        ), oo = "//# sourceURL=" + (yr.call(j, "sourceURL") ? (j.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Jd + "]") + `
`;
        C.replace(Mn, function(Io, $r, Ar, hu, il, vu) {
          return Ar || (Ar = hu), rn += C.slice(Zt, vu).replace(ao, Fa), $r && (ft = !0, rn += `' +
__e(` + $r + `) +
'`), il && (Et = !0, rn += `';
` + il + `;
__p += '`), Ar && (rn += `' +
((__t = (` + Ar + `)) == null ? '' : __t) +
'`), Zt = vu + Io.length, Io;
        }), rn += `';
`;
        var Ao = yr.call(j, "variable") && j.variable;
        if (!Ao)
          rn = `with (obj) {
` + rn + `
}
`;
        else if (an.test(Ao))
          throw new on(s);
        rn = (Et ? rn.replace(wn, "") : rn).replace(un, "$1").replace(pn, "$1;"), rn = "function(" + (Ao || "obj") + `) {
` + (Ao ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ft ? ", __e = _.escape" : "") + (Et ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + rn + `return __p
}`;
        var dr = GB(function() {
          return no(Ve, oo + "return " + rn).apply(n, tt);
        });
        if (dr.source = rn, eI(dr))
          throw dr;
        return dr;
      }
      function N1e(C) {
        return ii(C).toLowerCase();
      }
      function z1e(C) {
        return ii(C).toUpperCase();
      }
      function R1e(C, j, ee) {
        if (C = ii(C), C && (ee || j === n))
          return Na(C);
        if (!C || !(j = fs(j)))
          return C;
        var $e = Se(C), Ne = Se(j), Ve = ad($e, Ne), tt = sd($e, Ne) + 1;
        return ut($e, Ve, tt).join("");
      }
      function P1e(C, j, ee) {
        if (C = ii(C), C && (ee || j === n))
          return C.slice(0, Ie(C) + 1);
        if (!C || !(j = fs(j)))
          return C;
        var $e = Se(C), Ne = sd($e, Se(j)) + 1;
        return ut($e, 0, Ne).join("");
      }
      function D1e(C, j, ee) {
        if (C = ii(C), C && (ee || j === n))
          return C.replace(go, "");
        if (!C || !(j = fs(j)))
          return C;
        var $e = Se(C), Ne = ad($e, Se(j));
        return ut($e, Ne).join("");
      }
      function L1e(C, j) {
        var ee = R, $e = T;
        if (xa(j)) {
          var Ne = "separator" in j ? j.separator : Ne;
          ee = "length" in j ? ir(j.length) : ee, $e = "omission" in j ? fs(j.omission) : $e;
        }
        C = ii(C);
        var Ve = C.length;
        if (Xa(C)) {
          var tt = Se(C);
          Ve = tt.length;
        }
        if (ee >= Ve)
          return C;
        var ft = ee - ce($e);
        if (ft < 1)
          return $e;
        var Et = tt ? ut(tt, 0, ft).join("") : C.slice(0, ft);
        if (Ne === n)
          return Et + $e;
        if (tt && (ft += Et.length - ft), tI(Ne)) {
          if (C.slice(ft).search(Ne)) {
            var Zt, Xt = Et;
            for (Ne.global || (Ne = fc(Ne.source, ii(hn.exec(Ne)) + "g")), Ne.lastIndex = 0; Zt = Ne.exec(Xt); )
              var rn = Zt.index;
            Et = Et.slice(0, rn === n ? ft : rn);
          }
        } else if (C.indexOf(fs(Ne), ft) != ft) {
          var Mn = Et.lastIndexOf(Ne);
          Mn > -1 && (Et = Et.slice(0, Mn));
        }
        return Et + $e;
      }
      function M1e(C) {
        return C = ii(C), C && Ln.test(C) ? C.replace(Dn, Ae) : C;
      }
      var F1e = Zv(function(C, j, ee) {
        return C + (ee ? " " : "") + j.toUpperCase();
      }), rI = WV("toUpperCase");
      function UB(C, j, ee) {
        return C = ii(C), j = ee ? n : j, j === n ? Vi(C) ? gt(C) : uu(C) : C.match(j) || [];
      }
      var GB = rr(function(C, j) {
        try {
          return _o(C, n, j);
        } catch (ee) {
          return eI(ee) ? ee : new on(ee);
        }
      }), q1e = Am(function(C, j) {
        return $a(j, function(ee) {
          ee = gp(ee), Ja(C, ee, J2(C[ee], C));
        }), C;
      });
      function j1e(C) {
        var j = C == null ? 0 : C.length, ee = wo();
        return C = j ? Zo(C, function($e) {
          if (typeof $e[1] != "function")
            throw new gc(a);
          return [ee($e[0]), $e[1]];
        }) : [], rr(function($e) {
          for (var Ne = -1; ++Ne < j; ) {
            var Ve = C[Ne];
            if (_o(Ve[0], this, $e))
              return _o(Ve[1], this, $e);
          }
        });
      }
      function V1e(C) {
        return S1(nl(C, d));
      }
      function iI(C) {
        return function() {
          return C;
        };
      }
      function B1e(C, j) {
        return C == null || C !== C ? j : C;
      }
      var U1e = YV(), G1e = YV(!0);
      function Fl(C) {
        return C;
      }
      function aI(C) {
        return A$(typeof C == "function" ? C : nl(C, d));
      }
      function W1e(C) {
        return Cm(nl(C, d));
      }
      function H1e(C, j) {
        return z1(C, nl(j, d));
      }
      var Y1e = rr(function(C, j) {
        return function(ee) {
          return Qa(ee, C, j);
        };
      }), K1e = rr(function(C, j) {
        return function(ee) {
          return Qa(C, ee, j);
        };
      });
      function sI(C, j, ee) {
        var $e = Rs(j), Ne = nh(j, $e);
        ee == null && !(xa(j) && (Ne.length || !$e.length)) && (ee = j, j = C, C = this, Ne = nh(j, Rs(j)));
        var Ve = !(xa(ee) && "chain" in ee) || !!ee.chain, tt = Om(C);
        return $a(Ne, function(ft) {
          var Et = j[ft];
          C[ft] = Et, tt && (C.prototype[ft] = function() {
            var Zt = this.__chain__;
            if (Ve || Zt) {
              var Xt = C(this.__wrapped__), rn = Xt.__actions__ = to(this.__actions__);
              return rn.push({ func: Et, args: arguments, thisArg: C }), Xt.__chain__ = Zt, Xt;
            }
            return Et.apply(C, nn([this.value()], arguments));
          });
        }), C;
      }
      function Z1e() {
        return ma._ === this && (ma._ = _u), this;
      }
      function cI() {
      }
      function X1e(C) {
        return C = ir(C), rr(function(j) {
          return R1(j, C);
        });
      }
      var J1e = F2(Zo), Q1e = F2(wa), eSe = F2(Zc);
      function WB(C) {
        return W2(C) ? Za(gp(C)) : Wn(C);
      }
      function tSe(C) {
        return function(j) {
          return C == null ? n : _p(C, j);
        };
      }
      var nSe = ZV(), oSe = ZV(!0);
      function lI() {
        return [];
      }
      function uI() {
        return !1;
      }
      function rSe() {
        return {};
      }
      function iSe() {
        return "";
      }
      function aSe() {
        return !0;
      }
      function sSe(C, j) {
        if (C = ir(C), C < 1 || C > I)
          return [];
        var ee = P, $e = qe(C, P);
        j = wo(j), C -= P;
        for (var Ne = Ol($e, j); ++ee < C; )
          j(ee);
        return Ne;
      }
      function cSe(C) {
        return tr(C) ? Zo(C, gp) : gu(C) ? [C] : to(_B(ii(C)));
      }
      function lSe(C) {
        var j = ++Df;
        return ii(C) + j;
      }
      var uSe = M1(function(C, j) {
        return C + j;
      }, 0), dSe = q2("ceil"), _Se = M1(function(C, j) {
        return C / j;
      }, 1), pSe = q2("floor");
      function mSe(C) {
        return C && C.length ? th(C, Fl, hi) : n;
      }
      function fSe(C, j) {
        return C && C.length ? th(C, wo(j, 2), hi) : n;
      }
      function gSe(C) {
        return Ma(C, Fl);
      }
      function hSe(C, j) {
        return Ma(C, wo(j, 2));
      }
      function vSe(C) {
        return C && C.length ? th(C, Fl, Wv) : n;
      }
      function bSe(C, j) {
        return C && C.length ? th(C, wo(j, 2), Wv) : n;
      }
      var ySe = M1(function(C, j) {
        return C * j;
      }, 1), $Se = q2("round"), wSe = M1(function(C, j) {
        return C - j;
      }, 0);
      function kSe(C) {
        return C && C.length ? id(C, Fl) : 0;
      }
      function SSe(C, j) {
        return C && C.length ? id(C, wo(j, 2)) : 0;
      }
      return Le.after = Wke, Le.ary = kB, Le.assign = z0e, Le.assignIn = LB, Le.assignInWith = X1, Le.assignWith = R0e, Le.at = P0e, Le.before = SB, Le.bind = J2, Le.bindAll = q1e, Le.bindKey = EB, Le.castArray = r0e, Le.chain = yB, Le.chunk = pwe, Le.compact = mwe, Le.concat = fwe, Le.cond = j1e, Le.conforms = V1e, Le.constant = iI, Le.countBy = kke, Le.create = D0e, Le.curry = xB, Le.curryRight = CB, Le.debounce = TB, Le.defaults = L0e, Le.defaultsDeep = M0e, Le.defer = Hke, Le.delay = Yke, Le.difference = gwe, Le.differenceBy = hwe, Le.differenceWith = vwe, Le.drop = bwe, Le.dropRight = ywe, Le.dropRightWhile = $we, Le.dropWhile = wwe, Le.fill = kwe, Le.filter = Eke, Le.flatMap = Tke, Le.flatMapDeep = Ake, Le.flatMapDepth = Ike, Le.flatten = gB, Le.flattenDeep = Swe, Le.flattenDepth = Ewe, Le.flip = Kke, Le.flow = U1e, Le.flowRight = G1e, Le.fromPairs = xwe, Le.functions = G0e, Le.functionsIn = W0e, Le.groupBy = Oke, Le.initial = Twe, Le.intersection = Awe, Le.intersectionBy = Iwe, Le.intersectionWith = Owe, Le.invert = Y0e, Le.invertBy = K0e, Le.invokeMap = zke, Le.iteratee = aI, Le.keyBy = Rke, Le.keys = Rs, Le.keysIn = Ml, Le.map = G1, Le.mapKeys = X0e, Le.mapValues = J0e, Le.matches = W1e, Le.matchesProperty = H1e, Le.memoize = H1, Le.merge = Q0e, Le.mergeWith = MB, Le.method = Y1e, Le.methodOf = K1e, Le.mixin = sI, Le.negate = Y1, Le.nthArg = X1e, Le.omit = e1e, Le.omitBy = t1e, Le.once = Zke, Le.orderBy = Pke, Le.over = J1e, Le.overArgs = Xke, Le.overEvery = Q1e, Le.overSome = eSe, Le.partial = Q2, Le.partialRight = AB, Le.partition = Dke, Le.pick = n1e, Le.pickBy = FB, Le.property = WB, Le.propertyOf = tSe, Le.pull = Pwe, Le.pullAll = vB, Le.pullAllBy = Dwe, Le.pullAllWith = Lwe, Le.pullAt = Mwe, Le.range = nSe, Le.rangeRight = oSe, Le.rearg = Jke, Le.reject = Fke, Le.remove = Fwe, Le.rest = Qke, Le.reverse = Z2, Le.sampleSize = jke, Le.set = r1e, Le.setWith = i1e, Le.shuffle = Vke, Le.slice = qwe, Le.sortBy = Gke, Le.sortedUniq = Hwe, Le.sortedUniqBy = Ywe, Le.split = T1e, Le.spread = e0e, Le.tail = Kwe, Le.take = Zwe, Le.takeRight = Xwe, Le.takeRightWhile = Jwe, Le.takeWhile = Qwe, Le.tap = mke, Le.throttle = t0e, Le.thru = U1, Le.toArray = RB, Le.toPairs = qB, Le.toPairsIn = jB, Le.toPath = cSe, Le.toPlainObject = DB, Le.transform = a1e, Le.unary = n0e, Le.union = eke, Le.unionBy = tke, Le.unionWith = nke, Le.uniq = oke, Le.uniqBy = rke, Le.uniqWith = ike, Le.unset = s1e, Le.unzip = X2, Le.unzipWith = bB, Le.update = c1e, Le.updateWith = l1e, Le.values = Qv, Le.valuesIn = u1e, Le.without = ake, Le.words = UB, Le.wrap = o0e, Le.xor = ske, Le.xorBy = cke, Le.xorWith = lke, Le.zip = uke, Le.zipObject = dke, Le.zipObjectDeep = _ke, Le.zipWith = pke, Le.entries = qB, Le.entriesIn = jB, Le.extend = LB, Le.extendWith = X1, sI(Le, Le), Le.add = uSe, Le.attempt = GB, Le.camelCase = m1e, Le.capitalize = VB, Le.ceil = dSe, Le.clamp = d1e, Le.clone = i0e, Le.cloneDeep = s0e, Le.cloneDeepWith = c0e, Le.cloneWith = a0e, Le.conformsTo = l0e, Le.deburr = BB, Le.defaultTo = B1e, Le.divide = _Se, Le.endsWith = f1e, Le.eq = d_, Le.escape = g1e, Le.escapeRegExp = h1e, Le.every = Ske, Le.find = xke, Le.findIndex = mB, Le.findKey = F0e, Le.findLast = Cke, Le.findLastIndex = fB, Le.findLastKey = q0e, Le.floor = pSe, Le.forEach = $B, Le.forEachRight = wB, Le.forIn = j0e, Le.forInRight = V0e, Le.forOwn = B0e, Le.forOwnRight = U0e, Le.get = nI, Le.gt = u0e, Le.gte = d0e, Le.has = H0e, Le.hasIn = oI, Le.head = hB, Le.identity = Fl, Le.includes = Nke, Le.indexOf = Cwe, Le.inRange = _1e, Le.invoke = Z0e, Le.isArguments = ch, Le.isArray = tr, Le.isArrayBuffer = _0e, Le.isArrayLike = Ll, Le.isArrayLikeObject = qa, Le.isBoolean = p0e, Le.isBuffer = Bf, Le.isDate = m0e, Le.isElement = f0e, Le.isEmpty = g0e, Le.isEqual = h0e, Le.isEqualWith = v0e, Le.isError = eI, Le.isFinite = b0e, Le.isFunction = Om, Le.isInteger = IB, Le.isLength = K1, Le.isMap = OB, Le.isMatch = y0e, Le.isMatchWith = $0e, Le.isNaN = w0e, Le.isNative = k0e, Le.isNil = E0e, Le.isNull = S0e, Le.isNumber = NB, Le.isObject = xa, Le.isObjectLike = za, Le.isPlainObject = M$, Le.isRegExp = tI, Le.isSafeInteger = x0e, Le.isSet = zB, Le.isString = Z1, Le.isSymbol = gu, Le.isTypedArray = Jv, Le.isUndefined = C0e, Le.isWeakMap = T0e, Le.isWeakSet = A0e, Le.join = Nwe, Le.kebabCase = v1e, Le.last = gd, Le.lastIndexOf = zwe, Le.lowerCase = b1e, Le.lowerFirst = y1e, Le.lt = I0e, Le.lte = O0e, Le.max = mSe, Le.maxBy = fSe, Le.mean = gSe, Le.meanBy = hSe, Le.min = vSe, Le.minBy = bSe, Le.stubArray = lI, Le.stubFalse = uI, Le.stubObject = rSe, Le.stubString = iSe, Le.stubTrue = aSe, Le.multiply = ySe, Le.nth = Rwe, Le.noConflict = Z1e, Le.noop = cI, Le.now = W1, Le.pad = $1e, Le.padEnd = w1e, Le.padStart = k1e, Le.parseInt = S1e, Le.random = p1e, Le.reduce = Lke, Le.reduceRight = Mke, Le.repeat = E1e, Le.replace = x1e, Le.result = o1e, Le.round = $Se, Le.runInContext = Be, Le.sample = qke, Le.size = Bke, Le.snakeCase = C1e, Le.some = Uke, Le.sortedIndex = jwe, Le.sortedIndexBy = Vwe, Le.sortedIndexOf = Bwe, Le.sortedLastIndex = Uwe, Le.sortedLastIndexBy = Gwe, Le.sortedLastIndexOf = Wwe, Le.startCase = A1e, Le.startsWith = I1e, Le.subtract = wSe, Le.sum = kSe, Le.sumBy = SSe, Le.template = O1e, Le.times = sSe, Le.toFinite = Nm, Le.toInteger = ir, Le.toLength = PB, Le.toLower = N1e, Le.toNumber = hd, Le.toSafeInteger = N0e, Le.toString = ii, Le.toUpper = z1e, Le.trim = R1e, Le.trimEnd = P1e, Le.trimStart = D1e, Le.truncate = L1e, Le.unescape = M1e, Le.uniqueId = lSe, Le.upperCase = F1e, Le.upperFirst = rI, Le.each = $B, Le.eachRight = wB, Le.first = hB, sI(Le, function() {
        var C = {};
        return md(Le, function(j, ee) {
          yr.call(Le.prototype, ee) || (C[ee] = j);
        }), C;
      }(), { chain: !1 }), Le.VERSION = o, $a(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(C) {
        Le[C].placeholder = Le;
      }), $a(["drop", "take"], function(C, j) {
        jo.prototype[C] = function(ee) {
          ee = ee === n ? 1 : Ee(ir(ee), 0);
          var $e = this.__filtered__ && !j ? new jo(this) : this.clone();
          return $e.__filtered__ ? $e.__takeCount__ = qe(ee, $e.__takeCount__) : $e.__views__.push({
            size: qe(ee, P),
            type: C + ($e.__dir__ < 0 ? "Right" : "")
          }), $e;
        }, jo.prototype[C + "Right"] = function(ee) {
          return this.reverse()[C](ee).reverse();
        };
      }), $a(["filter", "map", "takeWhile"], function(C, j) {
        var ee = j + 1, $e = ee == S || ee == x;
        jo.prototype[C] = function(Ne) {
          var Ve = this.clone();
          return Ve.__iteratees__.push({
            iteratee: wo(Ne, 3),
            type: ee
          }), Ve.__filtered__ = Ve.__filtered__ || $e, Ve;
        };
      }), $a(["head", "last"], function(C, j) {
        var ee = "take" + (j ? "Right" : "");
        jo.prototype[C] = function() {
          return this[ee](1).value()[0];
        };
      }), $a(["initial", "tail"], function(C, j) {
        var ee = "drop" + (j ? "" : "Right");
        jo.prototype[C] = function() {
          return this.__filtered__ ? new jo(this) : this[ee](1);
        };
      }), jo.prototype.compact = function() {
        return this.filter(Fl);
      }, jo.prototype.find = function(C) {
        return this.filter(C).head();
      }, jo.prototype.findLast = function(C) {
        return this.reverse().find(C);
      }, jo.prototype.invokeMap = rr(function(C, j) {
        return typeof C == "function" ? new jo(this) : this.map(function(ee) {
          return Qa(ee, C, j);
        });
      }), jo.prototype.reject = function(C) {
        return this.filter(Y1(wo(C)));
      }, jo.prototype.slice = function(C, j) {
        C = ir(C);
        var ee = this;
        return ee.__filtered__ && (C > 0 || j < 0) ? new jo(ee) : (C < 0 ? ee = ee.takeRight(-C) : C && (ee = ee.drop(C)), j !== n && (j = ir(j), ee = j < 0 ? ee.dropRight(-j) : ee.take(j - C)), ee);
      }, jo.prototype.takeRightWhile = function(C) {
        return this.reverse().takeWhile(C).reverse();
      }, jo.prototype.toArray = function() {
        return this.take(P);
      }, md(jo.prototype, function(C, j) {
        var ee = /^(?:filter|find|map|reject)|While$/.test(j), $e = /^(?:head|last)$/.test(j), Ne = Le[$e ? "take" + (j == "last" ? "Right" : "") : j], Ve = $e || /^find/.test(j);
        Ne && (Le.prototype[j] = function() {
          var tt = this.__wrapped__, ft = $e ? [1] : arguments, Et = tt instanceof jo, Zt = ft[0], Xt = Et || tr(tt), rn = function($r) {
            var Ar = Ne.apply(Le, nn([$r], ft));
            return $e && Mn ? Ar[0] : Ar;
          };
          Xt && ee && typeof Zt == "function" && Zt.length != 1 && (Et = Xt = !1);
          var Mn = this.__chain__, oo = !!this.__actions__.length, Ao = Ve && !Mn, dr = Et && !oo;
          if (!Ve && Xt) {
            tt = dr ? tt : new jo(this);
            var Io = C.apply(tt, ft);
            return Io.__actions__.push({ func: U1, args: [rn], thisArg: n }), new ds(Io, Mn);
          }
          return Ao && dr ? C.apply(this, ft) : (Io = this.thru(rn), Ao ? $e ? Io.value()[0] : Io.value() : Io);
        });
      }), $a(["pop", "push", "shift", "sort", "splice", "unshift"], function(C) {
        var j = hc[C], ee = /^(?:push|sort|unshift)$/.test(C) ? "tap" : "thru", $e = /^(?:pop|shift)$/.test(C);
        Le.prototype[C] = function() {
          var Ne = arguments;
          if ($e && !this.__chain__) {
            var Ve = this.value();
            return j.apply(tr(Ve) ? Ve : [], Ne);
          }
          return this[ee](function(tt) {
            return j.apply(tr(tt) ? tt : [], Ne);
          });
        };
      }), md(jo.prototype, function(C, j) {
        var ee = Le[j];
        if (ee) {
          var $e = ee.name + "";
          yr.call(ga, $e) || (ga[$e] = []), ga[$e].push({ name: j, func: ee });
        }
      }), ga[L1(n, $).name] = [{
        name: "wrapper",
        func: n
      }], jo.prototype.clone = ud, jo.prototype.reverse = Kg, jo.prototype.value = up, Le.prototype.at = fke, Le.prototype.chain = gke, Le.prototype.commit = hke, Le.prototype.next = vke, Le.prototype.plant = yke, Le.prototype.reverse = $ke, Le.prototype.toJSON = Le.prototype.valueOf = Le.prototype.value = wke, Le.prototype.first = Le.prototype.head, pu && (Le.prototype[pu] = bke), Le;
    }, Ct = Nt();
    cu ? ((cu.exports = Ct)._ = Ct, e_._ = Ct) : ma._ = Ct;
  }).call(Dt);
})(Ax, Ax.exports);
var Hnc = Ax.exports, Vie = {};
Object.defineProperty(Vie, "__esModule", { value: !0 });
var tU = Fe;
function Ync(e) {
  var t = tU.useRef();
  return tU.useEffect(function() {
    t.current = e;
  }), t.current;
}
var Knc = Vie.default = Ync;
const Znc = Hnc.debounce(At.refreshTokens, 1e4, { leading: !0, trailing: !1 }), Xnc = ({ accessToken: e, refreshUrl: t, clientId: n, onError: o, onSuccess: r }) => {
  const [i, a] = it(!1), [s, c] = it(""), l = Knc(e);
  return yt(() => {
    const u = s && At.getAuthorizationHeader() ? At.responseInterceptor.use(void 0, async (d) => {
      var p;
      const _ = d.config;
      if (t && ((p = d.response) == null ? void 0 : p.status) === 498 && !i) {
        a(!0);
        const g = await Znc(t);
        if (g)
          return c(g), r == null || r(), At.instance({
            ..._,
            headers: { ..._.headers, Authorization: `Bearer ${g}` }
          });
        o == null || o("Invalid Refresh Token."), a(!1);
      }
      return Promise.reject(d);
    }) : "";
    return () => {
      u && At.responseInterceptor.eject(u);
    };
  }, [s, i, t, o, r]), yt(() => {
    if (e && At.getUrl() && l !== e) {
      At.setAuthorizationHeader(e);
      try {
        At.get(`/provider/${n}/access-token`).catch(async (u) => {
          var d, _;
          if ((((d = u.response) == null ? void 0 : d.status) === 498 || ((_ = u.response) == null ? void 0 : _.status) === 401) && t) {
            a(!0);
            const p = await At.refreshTokens(t);
            p ? (c(p), r == null || r()) : o == null || o("Invalid Refresh Token."), a(!1);
          }
        }).finally(() => {
          c(e);
        });
      } catch {
      }
    }
  }, [e, n, t, l, o, r]), { isRefreshing: i, currentAccessToken: s };
};
var Bie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n = 1e3, o = 6e4, r = 36e5, i = "millisecond", a = "second", s = "minute", c = "hour", l = "day", u = "week", d = "month", _ = "quarter", p = "year", g = "date", f = "Invalid Date", h = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, $ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, b = function(A, S, E) {
      var x = String(A);
      return !x || x.length >= S ? A : "" + Array(S + 1 - x.length).join(E) + A;
    }, y = { s: b, z: function(A) {
      var S = -A.utcOffset(), E = Math.abs(S), x = Math.floor(E / 60), k = E % 60;
      return (S <= 0 ? "+" : "-") + b(x, 2, "0") + ":" + b(k, 2, "0");
    }, m: function A(S, E) {
      if (S.date() < E.date())
        return -A(E, S);
      var x = 12 * (E.year() - S.year()) + (E.month() - S.month()), k = S.clone().add(x, d), I = E - k < 0, z = S.clone().add(x + (I ? -1 : 1), d);
      return +(-(x + (E - k) / (I ? k - z : z - k)) || 0);
    }, a: function(A) {
      return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
    }, p: function(A) {
      return { M: d, y: p, w: u, d: l, D: g, h: c, m: s, s: a, ms: i, Q: _ }[A] || String(A || "").toLowerCase().replace(/s$/, "");
    }, u: function(A) {
      return A === void 0;
    } }, w = "en", N = {};
    N[w] = v;
    var M = function(A) {
      return A instanceof T;
    }, q = function A(S, E, x) {
      var k;
      if (!S)
        return w;
      if (typeof S == "string") {
        var I = S.toLowerCase();
        N[I] && (k = I), E && (N[I] = E, k = I);
        var z = S.split("-");
        if (!k && z.length > 1)
          return A(z[0]);
      } else {
        var F = S.name;
        N[F] = S, k = F;
      }
      return !x && k && (w = k), k || !x && w;
    }, L = function(A, S) {
      if (M(A))
        return A.clone();
      var E = typeof S == "object" ? S : {};
      return E.date = A, E.args = arguments, new T(E);
    }, R = y;
    R.l = q, R.i = M, R.w = function(A, S) {
      return L(A, { locale: S.$L, utc: S.$u, x: S.$x, $offset: S.$offset });
    };
    var T = function() {
      function A(E) {
        this.$L = q(E.locale, null, !0), this.parse(E);
      }
      var S = A.prototype;
      return S.parse = function(E) {
        this.$d = function(x) {
          var k = x.date, I = x.utc;
          if (k === null)
            return /* @__PURE__ */ new Date(NaN);
          if (R.u(k))
            return /* @__PURE__ */ new Date();
          if (k instanceof Date)
            return new Date(k);
          if (typeof k == "string" && !/Z$/i.test(k)) {
            var z = k.match(h);
            if (z) {
              var F = z[2] - 1 || 0, P = (z[7] || "0").substring(0, 3);
              return I ? new Date(Date.UTC(z[1], F, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, P)) : new Date(z[1], F, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, P);
            }
          }
          return new Date(k);
        }(E), this.$x = E.x || {}, this.init();
      }, S.init = function() {
        var E = this.$d;
        this.$y = E.getFullYear(), this.$M = E.getMonth(), this.$D = E.getDate(), this.$W = E.getDay(), this.$H = E.getHours(), this.$m = E.getMinutes(), this.$s = E.getSeconds(), this.$ms = E.getMilliseconds();
      }, S.$utils = function() {
        return R;
      }, S.isValid = function() {
        return this.$d.toString() !== f;
      }, S.isSame = function(E, x) {
        var k = L(E);
        return this.startOf(x) <= k && k <= this.endOf(x);
      }, S.isAfter = function(E, x) {
        return L(E) < this.startOf(x);
      }, S.isBefore = function(E, x) {
        return this.endOf(x) < L(E);
      }, S.$g = function(E, x, k) {
        return R.u(E) ? this[x] : this.set(k, E);
      }, S.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, S.valueOf = function() {
        return this.$d.getTime();
      }, S.startOf = function(E, x) {
        var k = this, I = !!R.u(x) || x, z = R.p(E), F = function(ae, Y) {
          var re = R.w(k.$u ? Date.UTC(k.$y, Y, ae) : new Date(k.$y, Y, ae), k);
          return I ? re : re.endOf(l);
        }, P = function(ae, Y) {
          return R.w(k.toDate()[ae].apply(k.toDate("s"), (I ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Y)), k);
        }, O = this.$W, V = this.$M, U = this.$D, H = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case p:
            return I ? F(1, 0) : F(31, 11);
          case d:
            return I ? F(1, V) : F(0, V + 1);
          case u:
            var J = this.$locale().weekStart || 0, le = (O < J ? O + 7 : O) - J;
            return F(I ? U - le : U + (6 - le), V);
          case l:
          case g:
            return P(H + "Hours", 0);
          case c:
            return P(H + "Minutes", 1);
          case s:
            return P(H + "Seconds", 2);
          case a:
            return P(H + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, S.endOf = function(E) {
        return this.startOf(E, !1);
      }, S.$set = function(E, x) {
        var k, I = R.p(E), z = "set" + (this.$u ? "UTC" : ""), F = (k = {}, k[l] = z + "Date", k[g] = z + "Date", k[d] = z + "Month", k[p] = z + "FullYear", k[c] = z + "Hours", k[s] = z + "Minutes", k[a] = z + "Seconds", k[i] = z + "Milliseconds", k)[I], P = I === l ? this.$D + (x - this.$W) : x;
        if (I === d || I === p) {
          var O = this.clone().set(g, 1);
          O.$d[F](P), O.init(), this.$d = O.set(g, Math.min(this.$D, O.daysInMonth())).$d;
        } else
          F && this.$d[F](P);
        return this.init(), this;
      }, S.set = function(E, x) {
        return this.clone().$set(E, x);
      }, S.get = function(E) {
        return this[R.p(E)]();
      }, S.add = function(E, x) {
        var k, I = this;
        E = Number(E);
        var z = R.p(x), F = function(V) {
          var U = L(I);
          return R.w(U.date(U.date() + Math.round(V * E)), I);
        };
        if (z === d)
          return this.set(d, this.$M + E);
        if (z === p)
          return this.set(p, this.$y + E);
        if (z === l)
          return F(1);
        if (z === u)
          return F(7);
        var P = (k = {}, k[s] = o, k[c] = r, k[a] = n, k)[z] || 1, O = this.$d.getTime() + E * P;
        return R.w(O, this);
      }, S.subtract = function(E, x) {
        return this.add(-1 * E, x);
      }, S.format = function(E) {
        var x = this, k = this.$locale();
        if (!this.isValid())
          return k.invalidDate || f;
        var I = E || "YYYY-MM-DDTHH:mm:ssZ", z = R.z(this), F = this.$H, P = this.$m, O = this.$M, V = k.weekdays, U = k.months, H = function(Y, re, ie, _e) {
          return Y && (Y[re] || Y(x, I)) || ie[re].slice(0, _e);
        }, J = function(Y) {
          return R.s(F % 12 || 12, Y, "0");
        }, le = k.meridiem || function(Y, re, ie) {
          var _e = Y < 12 ? "AM" : "PM";
          return ie ? _e.toLowerCase() : _e;
        }, ae = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: O + 1, MM: R.s(O + 1, 2, "0"), MMM: H(k.monthsShort, O, U, 3), MMMM: H(U, O), D: this.$D, DD: R.s(this.$D, 2, "0"), d: String(this.$W), dd: H(k.weekdaysMin, this.$W, V, 2), ddd: H(k.weekdaysShort, this.$W, V, 3), dddd: V[this.$W], H: String(F), HH: R.s(F, 2, "0"), h: J(1), hh: J(2), a: le(F, P, !0), A: le(F, P, !1), m: String(P), mm: R.s(P, 2, "0"), s: String(this.$s), ss: R.s(this.$s, 2, "0"), SSS: R.s(this.$ms, 3, "0"), Z: z };
        return I.replace($, function(Y, re) {
          return re || ae[Y] || z.replace(":", "");
        });
      }, S.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, S.diff = function(E, x, k) {
        var I, z = R.p(x), F = L(E), P = (F.utcOffset() - this.utcOffset()) * o, O = this - F, V = R.m(this, F);
        return V = (I = {}, I[p] = V / 12, I[d] = V, I[_] = V / 3, I[u] = (O - P) / 6048e5, I[l] = (O - P) / 864e5, I[c] = O / r, I[s] = O / o, I[a] = O / n, I)[z] || O, k ? V : R.a(V);
      }, S.daysInMonth = function() {
        return this.endOf(d).$D;
      }, S.$locale = function() {
        return N[this.$L];
      }, S.locale = function(E, x) {
        if (!E)
          return this.$L;
        var k = this.clone(), I = q(E, x, !0);
        return I && (k.$L = I), k;
      }, S.clone = function() {
        return R.w(this.$d, this);
      }, S.toDate = function() {
        return new Date(this.valueOf());
      }, S.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, S.toISOString = function() {
        return this.$d.toISOString();
      }, S.toString = function() {
        return this.$d.toUTCString();
      }, A;
    }(), D = T.prototype;
    return L.prototype = D, [["$ms", i], ["$s", a], ["$m", s], ["$H", c], ["$W", l], ["$M", d], ["$y", p], ["$D", g]].forEach(function(A) {
      D[A[1]] = function(S) {
        return this.$g(S, A[0], A[1]);
      };
    }), L.extend = function(A, S) {
      return A.$i || (A(S, T, L), A.$i = !0), L;
    }, L.locale = q, L.isDayjs = M, L.unix = function(A) {
      return L(1e3 * A);
    }, L.en = N[w], L.Ls = N, L.p = {}, L;
  });
})(Bie);
var Jnc = Bie.exports;
const ht = /* @__PURE__ */ Mi(Jnc);
var Uie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, o = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, i = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, s = {}, c = function(f) {
      return (f = +f) + (f > 68 ? 1900 : 2e3);
    }, l = function(f) {
      return function(h) {
        this[f] = +h;
      };
    }, u = [/[+-]\d\d:?(\d\d)?|Z/, function(f) {
      (this.zone || (this.zone = {})).offset = function(h) {
        if (!h || h === "Z")
          return 0;
        var $ = h.match(/([+-]|\d\d)/g), v = 60 * $[1] + (+$[2] || 0);
        return v === 0 ? 0 : $[0] === "+" ? -v : v;
      }(f);
    }], d = function(f) {
      var h = s[f];
      return h && (h.indexOf ? h : h.s.concat(h.f));
    }, _ = function(f, h) {
      var $, v = s.meridiem;
      if (v) {
        for (var b = 1; b <= 24; b += 1)
          if (f.indexOf(v(b, 0, h)) > -1) {
            $ = b > 12;
            break;
          }
      } else
        $ = f === (h ? "pm" : "PM");
      return $;
    }, p = { A: [a, function(f) {
      this.afternoon = _(f, !1);
    }], a: [a, function(f) {
      this.afternoon = _(f, !0);
    }], S: [/\d/, function(f) {
      this.milliseconds = 100 * +f;
    }], SS: [r, function(f) {
      this.milliseconds = 10 * +f;
    }], SSS: [/\d{3}/, function(f) {
      this.milliseconds = +f;
    }], s: [i, l("seconds")], ss: [i, l("seconds")], m: [i, l("minutes")], mm: [i, l("minutes")], H: [i, l("hours")], h: [i, l("hours")], HH: [i, l("hours")], hh: [i, l("hours")], D: [i, l("day")], DD: [r, l("day")], Do: [a, function(f) {
      var h = s.ordinal, $ = f.match(/\d+/);
      if (this.day = $[0], h)
        for (var v = 1; v <= 31; v += 1)
          h(v).replace(/\[|\]/g, "") === f && (this.day = v);
    }], M: [i, l("month")], MM: [r, l("month")], MMM: [a, function(f) {
      var h = d("months"), $ = (d("monthsShort") || h.map(function(v) {
        return v.slice(0, 3);
      })).indexOf(f) + 1;
      if ($ < 1)
        throw new Error();
      this.month = $ % 12 || $;
    }], MMMM: [a, function(f) {
      var h = d("months").indexOf(f) + 1;
      if (h < 1)
        throw new Error();
      this.month = h % 12 || h;
    }], Y: [/[+-]?\d+/, l("year")], YY: [r, function(f) {
      this.year = c(f);
    }], YYYY: [/\d{4}/, l("year")], Z: u, ZZ: u };
    function g(f) {
      var h, $;
      h = f, $ = s && s.formats;
      for (var v = (f = h.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(L, R, T) {
        var D = T && T.toUpperCase();
        return R || $[T] || n[T] || $[D].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(A, S, E) {
          return S || E.slice(1);
        });
      })).match(o), b = v.length, y = 0; y < b; y += 1) {
        var w = v[y], N = p[w], M = N && N[0], q = N && N[1];
        v[y] = q ? { regex: M, parser: q } : w.replace(/^\[|\]$/g, "");
      }
      return function(L) {
        for (var R = {}, T = 0, D = 0; T < b; T += 1) {
          var A = v[T];
          if (typeof A == "string")
            D += A.length;
          else {
            var S = A.regex, E = A.parser, x = L.slice(D), k = S.exec(x)[0];
            E.call(R, k), L = L.replace(k, "");
          }
        }
        return function(I) {
          var z = I.afternoon;
          if (z !== void 0) {
            var F = I.hours;
            z ? F < 12 && (I.hours += 12) : F === 12 && (I.hours = 0), delete I.afternoon;
          }
        }(R), R;
      };
    }
    return function(f, h, $) {
      $.p.customParseFormat = !0, f && f.parseTwoDigitYear && (c = f.parseTwoDigitYear);
      var v = h.prototype, b = v.parse;
      v.parse = function(y) {
        var w = y.date, N = y.utc, M = y.args;
        this.$u = N;
        var q = M[1];
        if (typeof q == "string") {
          var L = M[2] === !0, R = M[3] === !0, T = L || R, D = M[2];
          R && (D = M[2]), s = this.$locale(), !L && D && (s = $.Ls[D]), this.$d = function(x, k, I) {
            try {
              if (["x", "X"].indexOf(k) > -1)
                return new Date((k === "X" ? 1e3 : 1) * x);
              var z = g(k)(x), F = z.year, P = z.month, O = z.day, V = z.hours, U = z.minutes, H = z.seconds, J = z.milliseconds, le = z.zone, ae = /* @__PURE__ */ new Date(), Y = O || (F || P ? 1 : ae.getDate()), re = F || ae.getFullYear(), ie = 0;
              F && !P || (ie = P > 0 ? P - 1 : ae.getMonth());
              var _e = V || 0, he = U || 0, be = H || 0, Q = J || 0;
              return le ? new Date(Date.UTC(re, ie, Y, _e, he, be, Q + 60 * le.offset * 1e3)) : I ? new Date(Date.UTC(re, ie, Y, _e, he, be, Q)) : new Date(re, ie, Y, _e, he, be, Q);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(w, q, N), this.init(), D && D !== !0 && (this.$L = this.locale(D).$L), T && w != this.format(q) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (q instanceof Array)
          for (var A = q.length, S = 1; S <= A; S += 1) {
            M[1] = q[S - 1];
            var E = $.apply(this, M);
            if (E.isValid()) {
              this.$d = E.$d, this.$L = E.$L, this.init();
              break;
            }
            S === A && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          b.call(this, y);
      };
    };
  });
})(Uie);
var Qnc = Uie.exports;
const eoc = /* @__PURE__ */ Mi(Qnc);
var Gie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n, o, r = 1e3, i = 6e4, a = 36e5, s = 864e5, c = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, l = 31536e6, u = 2592e6, d = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, _ = { years: l, months: u, days: s, hours: a, minutes: i, seconds: r, milliseconds: 1, weeks: 6048e5 }, p = function(w) {
      return w instanceof y;
    }, g = function(w, N, M) {
      return new y(w, M, N.$l);
    }, f = function(w) {
      return o.p(w) + "s";
    }, h = function(w) {
      return w < 0;
    }, $ = function(w) {
      return h(w) ? Math.ceil(w) : Math.floor(w);
    }, v = function(w) {
      return Math.abs(w);
    }, b = function(w, N) {
      return w ? h(w) ? { negative: !0, format: "" + v(w) + N } : { negative: !1, format: "" + w + N } : { negative: !1, format: "" };
    }, y = function() {
      function w(M, q, L) {
        var R = this;
        if (this.$d = {}, this.$l = L, M === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), q)
          return g(M * _[f(q)], this);
        if (typeof M == "number")
          return this.$ms = M, this.parseFromMilliseconds(), this;
        if (typeof M == "object")
          return Object.keys(M).forEach(function(A) {
            R.$d[f(A)] = M[A];
          }), this.calMilliseconds(), this;
        if (typeof M == "string") {
          var T = M.match(d);
          if (T) {
            var D = T.slice(2).map(function(A) {
              return A != null ? Number(A) : 0;
            });
            return this.$d.years = D[0], this.$d.months = D[1], this.$d.weeks = D[2], this.$d.days = D[3], this.$d.hours = D[4], this.$d.minutes = D[5], this.$d.seconds = D[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var N = w.prototype;
      return N.calMilliseconds = function() {
        var M = this;
        this.$ms = Object.keys(this.$d).reduce(function(q, L) {
          return q + (M.$d[L] || 0) * _[L];
        }, 0);
      }, N.parseFromMilliseconds = function() {
        var M = this.$ms;
        this.$d.years = $(M / l), M %= l, this.$d.months = $(M / u), M %= u, this.$d.days = $(M / s), M %= s, this.$d.hours = $(M / a), M %= a, this.$d.minutes = $(M / i), M %= i, this.$d.seconds = $(M / r), M %= r, this.$d.milliseconds = M;
      }, N.toISOString = function() {
        var M = b(this.$d.years, "Y"), q = b(this.$d.months, "M"), L = +this.$d.days || 0;
        this.$d.weeks && (L += 7 * this.$d.weeks);
        var R = b(L, "D"), T = b(this.$d.hours, "H"), D = b(this.$d.minutes, "M"), A = this.$d.seconds || 0;
        this.$d.milliseconds && (A += this.$d.milliseconds / 1e3);
        var S = b(A, "S"), E = M.negative || q.negative || R.negative || T.negative || D.negative || S.negative, x = T.format || D.format || S.format ? "T" : "", k = (E ? "-" : "") + "P" + M.format + q.format + R.format + x + T.format + D.format + S.format;
        return k === "P" || k === "-P" ? "P0D" : k;
      }, N.toJSON = function() {
        return this.toISOString();
      }, N.format = function(M) {
        var q = M || "YYYY-MM-DDTHH:mm:ss", L = { Y: this.$d.years, YY: o.s(this.$d.years, 2, "0"), YYYY: o.s(this.$d.years, 4, "0"), M: this.$d.months, MM: o.s(this.$d.months, 2, "0"), D: this.$d.days, DD: o.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: o.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: o.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: o.s(this.$d.seconds, 2, "0"), SSS: o.s(this.$d.milliseconds, 3, "0") };
        return q.replace(c, function(R, T) {
          return T || String(L[R]);
        });
      }, N.as = function(M) {
        return this.$ms / _[f(M)];
      }, N.get = function(M) {
        var q = this.$ms, L = f(M);
        return L === "milliseconds" ? q %= 1e3 : q = L === "weeks" ? $(q / _[L]) : this.$d[L], q === 0 ? 0 : q;
      }, N.add = function(M, q, L) {
        var R;
        return R = q ? M * _[f(q)] : p(M) ? M.$ms : g(M, this).$ms, g(this.$ms + R * (L ? -1 : 1), this);
      }, N.subtract = function(M, q) {
        return this.add(M, q, !0);
      }, N.locale = function(M) {
        var q = this.clone();
        return q.$l = M, q;
      }, N.clone = function() {
        return g(this.$ms, this);
      }, N.humanize = function(M) {
        return n().add(this.$ms, "ms").locale(this.$l).fromNow(!M);
      }, N.milliseconds = function() {
        return this.get("milliseconds");
      }, N.asMilliseconds = function() {
        return this.as("milliseconds");
      }, N.seconds = function() {
        return this.get("seconds");
      }, N.asSeconds = function() {
        return this.as("seconds");
      }, N.minutes = function() {
        return this.get("minutes");
      }, N.asMinutes = function() {
        return this.as("minutes");
      }, N.hours = function() {
        return this.get("hours");
      }, N.asHours = function() {
        return this.as("hours");
      }, N.days = function() {
        return this.get("days");
      }, N.asDays = function() {
        return this.as("days");
      }, N.weeks = function() {
        return this.get("weeks");
      }, N.asWeeks = function() {
        return this.as("weeks");
      }, N.months = function() {
        return this.get("months");
      }, N.asMonths = function() {
        return this.as("months");
      }, N.years = function() {
        return this.get("years");
      }, N.asYears = function() {
        return this.as("years");
      }, w;
    }();
    return function(w, N, M) {
      n = M, o = M().$utils(), M.duration = function(R, T) {
        var D = M.locale();
        return g(R, { $l: D }, T);
      }, M.isDuration = p;
      var q = N.prototype.add, L = N.prototype.subtract;
      N.prototype.add = function(R, T) {
        return p(R) && (R = R.asMilliseconds()), q.bind(this)(R, T);
      }, N.prototype.subtract = function(R, T) {
        return p(R) && (R = R.asMilliseconds()), L.bind(this)(R, T);
      };
    };
  });
})(Gie);
var toc = Gie.exports;
const noc = /* @__PURE__ */ Mi(toc);
var Wie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    return function(n, o, r) {
      o.prototype.isBetween = function(i, a, s, c) {
        var l = r(i), u = r(a), d = (c = c || "()")[0] === "(", _ = c[1] === ")";
        return (d ? this.isAfter(l, s) : !this.isBefore(l, s)) && (_ ? this.isBefore(u, s) : !this.isAfter(u, s)) || (d ? this.isBefore(l, s) : !this.isAfter(l, s)) && (_ ? this.isAfter(u, s) : !this.isBefore(u, s));
      };
    };
  });
})(Wie);
var ooc = Wie.exports;
const roc = /* @__PURE__ */ Mi(ooc);
var Hie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    return function(n, o, r) {
      o.prototype.isToday = function() {
        var i = "YYYY-MM-DD", a = r();
        return this.format(i) === a.format(i);
      };
    };
  });
})(Hie);
var ioc = Hie.exports;
const aoc = /* @__PURE__ */ Mi(ioc);
var Yie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(o, r, i) {
      var a = r.prototype, s = a.format;
      i.en.formats = n, a.format = function(c) {
        c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
        var l = this.$locale().formats, u = function(d, _) {
          return d.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(p, g, f) {
            var h = f && f.toUpperCase();
            return g || _[f] || n[f] || _[h].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function($, v, b) {
              return v || b.slice(1);
            });
          });
        }(c, l === void 0 ? {} : l);
        return s.call(this, u);
      };
    };
  });
})(Yie);
var soc = Yie.exports;
const coc = /* @__PURE__ */ Mi(soc);
var Kie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    return function(n, o, r) {
      var i = function(a, s) {
        if (!s || !s.length || !s[0] || s.length === 1 && !s[0].length)
          return null;
        var c;
        s.length === 1 && s[0].length > 0 && (s = s[0]), c = s[0];
        for (var l = 1; l < s.length; l += 1)
          s[l].isValid() && !s[l][a](c) || (c = s[l]);
        return c;
      };
      r.max = function() {
        var a = [].slice.call(arguments, 0);
        return i("isAfter", a);
      }, r.min = function() {
        var a = [].slice.call(arguments, 0);
        return i("isBefore", a);
      };
    };
  });
})(Kie);
var loc = Kie.exports;
const uoc = /* @__PURE__ */ Mi(loc);
var Zie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    return function(n, o, r) {
      n = n || {};
      var i = o.prototype, a = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(l, u, d, _) {
        return i.fromToBase(l, u, d, _);
      }
      r.en.relativeTime = a, i.fromToBase = function(l, u, d, _, p) {
        for (var g, f, h, $ = d.$locale().relativeTime || a, v = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], b = v.length, y = 0; y < b; y += 1) {
          var w = v[y];
          w.d && (g = _ ? r(l).diff(d, w.d, !0) : d.diff(l, w.d, !0));
          var N = (n.rounding || Math.round)(Math.abs(g));
          if (h = g > 0, N <= w.r || !w.r) {
            N <= 1 && y > 0 && (w = v[y - 1]);
            var M = $[w.l];
            p && (N = p("" + N)), f = typeof M == "string" ? M.replace("%d", N) : M(N, u, w.l, h);
            break;
          }
        }
        if (u)
          return f;
        var q = h ? $.future : $.past;
        return typeof q == "function" ? q(f) : q.replace("%s", f);
      }, i.to = function(l, u) {
        return s(l, u, this, !0);
      }, i.from = function(l, u) {
        return s(l, u, this);
      };
      var c = function(l) {
        return l.$u ? r.utc() : r();
      };
      i.toNow = function(l) {
        return this.to(c(this), l);
      }, i.fromNow = function(l) {
        return this.from(c(this), l);
      };
    };
  });
})(Zie);
var doc = Zie.exports;
const _oc = /* @__PURE__ */ Mi(doc);
var Xie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    function n() {
      return n = Object.assign ? Object.assign.bind() : function(s) {
        for (var c = 1; c < arguments.length; c++) {
          var l = arguments[c];
          for (var u in l)
            Object.prototype.hasOwnProperty.call(l, u) && (s[u] = l[u]);
        }
        return s;
      }, n.apply(this, arguments);
    }
    var o = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }, i = {}, a = {};
    return function(s, c, l) {
      var u, d = function(f, h, $) {
        $ === void 0 && ($ = {});
        var v = new Date(f), b = function(y, w) {
          w === void 0 && (w = {});
          var N = w.timeZoneName || "short", M = y + "|" + N, q = i[M];
          return q || (q = new Intl.DateTimeFormat("en-US", n({}, r, { hour12: !1, timeZone: y, timeZoneName: N })), i[M] = q), q;
        }(h, $);
        return b.formatToParts(v);
      }, _ = function(f, h) {
        for (var $ = d(f, h), v = [], b = 0; b < $.length; b += 1) {
          var y = $[b], w = y.type, N = y.value, M = o[w];
          M >= 0 && (v[M] = parseInt(N, 10));
        }
        var q = v[3], L = q === 24 ? 0 : q, R = v[0] + "-" + v[1] + "-" + v[2] + " " + L + ":" + v[4] + ":" + v[5] + ":000", T = +f;
        return (l.utc(R).valueOf() - (T -= T % 1e3)) / 6e4;
      }, p = c.prototype;
      p.tz = function(f, h) {
        f === void 0 && (f = u);
        var $ = this.utcOffset(), v = this.toDate(), b = function(M) {
          var q = a[M];
          return q || (q = new Intl.DateTimeFormat("en-US", n({}, r, { timeZone: M })), a[M] = q), q;
        }(f).format(v), y = Math.round((v - new Date(b)) / 1e3 / 60), w = l(b, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(v.getTimezoneOffset() / 15) - y, !0);
        if (h) {
          var N = w.utcOffset();
          w = w.add($ - N, "minute");
        }
        return w.$x.$timezone = f, w;
      }, p.offsetName = function(f) {
        var h = this.$x.$timezone || l.tz.guess(), $ = d(this.valueOf(), h, { timeZoneName: f }).find(function(v) {
          return v.type.toLowerCase() === "timezonename";
        });
        return $ && $.value;
      };
      var g = p.startOf;
      p.startOf = function(f, h) {
        if (!this.$x || !this.$x.$timezone)
          return g.call(this, f, h);
        var $ = l(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return g.call($, f, h).tz(this.$x.$timezone, !0);
      }, l.tz = function(f, h, $) {
        var v = $ && h, b = $ || h || u, y = _(+l(), b);
        if (typeof f != "string")
          return l(f).tz(b);
        var w = function(L, R, T) {
          var D = L - 60 * R * 1e3, A = _(D, T);
          if (R === A)
            return [D, R];
          var S = _(D -= 60 * (A - R) * 1e3, T);
          return A === S ? [D, A] : [L - 60 * Math.min(A, S) * 1e3, Math.max(A, S)];
        }(l.utc(f, v).valueOf(), y, b), N = w[0], M = w[1], q = l(N).utcOffset(M);
        return q.$x.$timezone = b, q;
      }, l.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, l.tz.setDefault = function(f) {
        u = f;
      };
    };
  });
})(Xie);
var poc = Xie.exports;
const moc = /* @__PURE__ */ Mi(poc);
var Jie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    return function(n, o) {
      o.prototype.toArray = function() {
        return [this.$y, this.$M, this.$D, this.$H, this.$m, this.$s, this.$ms];
      };
    };
  });
})(Jie);
var foc = Jie.exports;
const goc = /* @__PURE__ */ Mi(foc);
var Qie = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(i, a, s) {
      var c = a.prototype;
      s.utc = function(f) {
        var h = { date: f, utc: !0, args: arguments };
        return new a(h);
      }, c.utc = function(f) {
        var h = s(this.toDate(), { locale: this.$L, utc: !0 });
        return f ? h.add(this.utcOffset(), n) : h;
      }, c.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var l = c.parse;
      c.parse = function(f) {
        f.utc && (this.$u = !0), this.$utils().u(f.$offset) || (this.$offset = f.$offset), l.call(this, f);
      };
      var u = c.init;
      c.init = function() {
        if (this.$u) {
          var f = this.$d;
          this.$y = f.getUTCFullYear(), this.$M = f.getUTCMonth(), this.$D = f.getUTCDate(), this.$W = f.getUTCDay(), this.$H = f.getUTCHours(), this.$m = f.getUTCMinutes(), this.$s = f.getUTCSeconds(), this.$ms = f.getUTCMilliseconds();
        } else
          u.call(this);
      };
      var d = c.utcOffset;
      c.utcOffset = function(f, h) {
        var $ = this.$utils().u;
        if ($(f))
          return this.$u ? 0 : $(this.$offset) ? d.call(this) : this.$offset;
        if (typeof f == "string" && (f = function(w) {
          w === void 0 && (w = "");
          var N = w.match(o);
          if (!N)
            return null;
          var M = ("" + N[0]).match(r) || ["-", 0, 0], q = M[0], L = 60 * +M[1] + +M[2];
          return L === 0 ? 0 : q === "+" ? L : -L;
        }(f), f === null))
          return this;
        var v = Math.abs(f) <= 16 ? 60 * f : f, b = this;
        if (h)
          return b.$offset = v, b.$u = f === 0, b;
        if (f !== 0) {
          var y = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (b = this.local().add(v + y, n)).$offset = v, b.$x.$localOffset = y;
        } else
          b = this.utc();
        return b;
      };
      var _ = c.format;
      c.format = function(f) {
        var h = f || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return _.call(this, h);
      }, c.valueOf = function() {
        var f = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * f;
      }, c.isUTC = function() {
        return !!this.$u;
      }, c.toISOString = function() {
        return this.toDate().toISOString();
      }, c.toString = function() {
        return this.toDate().toUTCString();
      };
      var p = c.toDate;
      c.toDate = function(f) {
        return f === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
      };
      var g = c.diff;
      c.diff = function(f, h, $) {
        if (f && this.$u === f.$u)
          return g.call(this, f, h, $);
        var v = this.local(), b = s(f).local();
        return g.call(v, b, h, $);
      };
    };
  });
})(Qie);
var hoc = Qie.exports;
const voc = /* @__PURE__ */ Mi(hoc), boc = (e = {}, t, n) => {
  const o = [1, 2, 3, 4, 5];
  n.getWorkingWeekdays = function() {
    return e.workingWeekdays || o;
  }, n.setWorkingWeekdays = function(r) {
    e.workingWeekdays = r;
  }, n.getHolidays = function() {
    return e.holidays || [];
  }, n.setHolidays = function(r) {
    e.holidays = r;
  }, n.getHolidayFormat = function() {
    return e.holidayFormat;
  }, n.setHolidayFormat = function(r) {
    e.holidayFormat = r;
  }, n.getAdditionalWorkingDays = function() {
    return e.additionalWorkingDays || [];
  }, n.setAdditionalWorkingDays = function(r) {
    e.additionalWorkingDays = r;
  }, n.getAdditionalWorkingDayFormat = function() {
    return e.additionalWorkingDayFormat;
  }, n.setAdditionalWorkingDayFormat = function(r) {
    e.additionalWorkingDayFormat = r;
  }, t.prototype.isHoliday = function() {
    return e.holidays ? !!e.holidays.includes(this.format(e.holidayFormat)) : !1;
  }, t.prototype.isBusinessDay = function() {
    const r = e.workingWeekdays || o;
    return this.isHoliday() ? !1 : !!(this.isAdditionalWorkingDay() || r.includes(this.day()));
  }, t.prototype.isAdditionalWorkingDay = function() {
    return e.additionalWorkingDays ? !!e.additionalWorkingDays.includes(this.format(e.additionalWorkingDayFormat)) : !1;
  }, t.prototype.businessDaysAdd = function(r) {
    const i = r < 0 ? -1 : 1;
    let a = this.clone(), s = Math.abs(r);
    for (; s > 0; )
      a = a.add(i, "d"), a.isBusinessDay() && (s -= 1);
    return a;
  }, t.prototype.businessDaysSubtract = function(r) {
    let i = this.clone();
    return i = i.businessDaysAdd(r * -1), i;
  }, t.prototype.businessDiff = function(r) {
    const i = this.clone(), a = r.clone(), s = i >= a;
    let c = s ? a : i;
    const l = s ? i : a;
    let u = 0;
    if (c.isSame(l))
      return u;
    for (; c < l; )
      c.isBusinessDay() && (u += 1), c = c.add(1, "d");
    return s ? u : -u;
  }, t.prototype.nextBusinessDay = function() {
    let i = this.clone(), a = 1;
    for (; a < 7 && (i = i.add(1, "day"), !i.isBusinessDay()); )
      a += 1;
    return i;
  }, t.prototype.prevBusinessDay = function() {
    let i = this.clone(), a = 1;
    for (; a < 7 && (i = i.subtract(1, "day"), !i.isBusinessDay()); )
      a += 1;
    return i;
  }, t.prototype.businessDaysInMonth = function() {
    if (!this.isValid())
      return [];
    let r = this.clone().startOf("month");
    const i = this.clone().endOf("month"), a = [];
    let s = !1;
    for (; !s; )
      r.isBusinessDay() && a.push(r.clone()), r = r.add(1, "day"), r.isAfter(i) && (s = !0);
    return a;
  }, t.prototype.lastBusinessDayOfMonth = function() {
    const r = this.businessDaysInMonth();
    return r[r.length - 1];
  }, t.prototype.businessWeeksInMonth = function() {
    if (!this.isValid())
      return [];
    let r = this.clone().startOf("month");
    const i = this.clone().endOf("month"), a = [];
    let s = [], c = !1;
    for (; !c; )
      r.isBusinessDay() && s.push(r.clone()), (r.day() === 5 || r.isSame(i, "day")) && (a.push(s), s = []), r = r.add(1, "day"), r.isAfter(i) && (c = !0);
    return a;
  };
};
ht.extend(eoc);
ht.extend(boc);
ht.extend(roc);
ht.extend(aoc);
ht.extend(coc);
ht.extend(_oc);
ht.extend(moc);
ht.extend(goc);
ht.extend(voc);
ht.extend(uoc);
ht.extend(noc);
const yoc = (e, t = ht.tz.guess()) => {
  var i;
  const { data: n, isLoading: o } = Ev(), r = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.timeZone) ?? t;
  yt(() => {
    !o && r && e && r !== t && e(t);
  }, [t, r, e, o]);
}, $oc = () => {
  const e = `/${rs.me}`;
  return Hr({
    mutationFn: (n) => {
      const { timeZone: o } = n;
      return At == null ? void 0 : At.patch(e, { timeZone: o }).then((r) => {
        if (r.data.status === Nn)
          return r.data;
        throw new Error(r.data.error.message);
      });
    }
  });
}, woc = "calcom-atoms", is = ({
  children: e,
  customClassName: t
}) => {
  const { options: n } = cr();
  return /* @__PURE__ */ m(
    "div",
    {
      dir: (n == null ? void 0 : n.readingDirection) ?? "ltr",
      className: xe(`${woc} m-0 w-auto bg-transparent p-0`, t),
      children: e
    }
  );
};
function V6(e) {
  const t = e + "CollectionProvider", [n, o] = jc(t), [r, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (p) => {
    const { scope: g, children: f } = p, h = Fe.useRef(null), $ = Fe.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Fe.createElement(r, {
      scope: g,
      itemMap: $,
      collectionRef: h
    }, f);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ Fe.forwardRef((p, g) => {
    const { scope: f, children: h } = p, $ = i(s, f), v = ni(g, $.collectionRef);
    return /* @__PURE__ */ Fe.createElement(av, {
      ref: v
    }, h);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ Fe.forwardRef((p, g) => {
    const { scope: f, children: h, ...$ } = p, v = Fe.useRef(null), b = ni(g, v), y = i(l, f);
    return Fe.useEffect(() => (y.itemMap.set(v, {
      ref: v,
      ...$
    }), () => void y.itemMap.delete(v))), /* @__PURE__ */ Fe.createElement(av, {
      [u]: "",
      ref: b
    }, h);
  });
  function _(p) {
    const g = i(e + "CollectionConsumer", p);
    return Fe.useCallback(() => {
      const h = g.collectionRef.current;
      if (!h)
        return [];
      const $ = Array.from(h.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (y, w) => $.indexOf(y.ref.current) - $.indexOf(w.ref.current)
      );
    }, [
      g.collectionRef,
      g.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: c,
      ItemSlot: d
    },
    _,
    o
  ];
}
const vM = "dismissableLayer.update", koc = "dismissableLayer.pointerDownOutside", Soc = "dismissableLayer.focusOutside";
let nU;
const eae = /* @__PURE__ */ Cr({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Eoc = /* @__PURE__ */ Bt((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, u = bo(eae), [d, _] = it(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = it({}), f = ni(
    t,
    (q) => _(q)
  ), h = Array.from(u.layers), [$] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = h.indexOf($), b = d ? h.indexOf(d) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, w = b >= v, N = Coc((q) => {
    const L = q.target, R = [
      ...u.branches
    ].some(
      (T) => T.contains(L)
    );
    !w || R || (i == null || i(q), s == null || s(q), q.defaultPrevented || c == null || c());
  }, p), M = Toc((q) => {
    const L = q.target;
    [
      ...u.branches
    ].some(
      (T) => T.contains(L)
    ) || (a == null || a(q), s == null || s(q), q.defaultPrevented || c == null || c());
  }, p);
  return I6((q) => {
    b === u.layers.size - 1 && (r == null || r(q), !q.defaultPrevented && c && (q.preventDefault(), c()));
  }, p), yt(() => {
    if (d)
      return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (nU = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), oU(), () => {
        o && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = nU);
      };
  }, [
    d,
    p,
    o,
    u
  ]), yt(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), oU());
  }, [
    d,
    u
  ]), yt(() => {
    const q = () => g({});
    return document.addEventListener(vM, q), () => document.removeEventListener(vM, q);
  }, []), /* @__PURE__ */ pt(nr.div, Tt({}, l, {
    ref: f,
    style: {
      pointerEvents: y ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: jn(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: jn(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: jn(e.onPointerDownCapture, N.onPointerDownCapture)
  }));
}), xoc = /* @__PURE__ */ Bt((e, t) => {
  const n = bo(eae), o = xt(null), r = ni(t, o);
  return yt(() => {
    const i = o.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [
    n.branches
  ]), /* @__PURE__ */ pt(nr.div, Tt({}, e, {
    ref: r
  }));
});
function Coc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e), o = xt(!1), r = xt(() => {
  });
  return yt(() => {
    const i = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          tae(koc, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Toc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e), o = xt(!1);
  return yt(() => {
    const r = (i) => {
      i.target && !o.current && tae(Soc, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function oU() {
  const e = new CustomEvent(vM);
  document.dispatchEvent(e);
}
function tae(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? z0(r, i) : r.dispatchEvent(i);
}
const Aoc = Eoc, Ioc = xoc, Ooc = /* @__PURE__ */ Bt((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ $v.createPortal(/* @__PURE__ */ pt(nr.div, Tt({}, r, {
    ref: t
  })), o) : null;
}), Noc = globalThis != null && globalThis.document ? lc : () => {
}, nae = "ToastProvider", [B6, zoc, Roc] = V6("Toast"), [oae, Qau] = jc("Toast", [
  Roc
]), [Poc, IT] = oae(nae), rae = (e) => {
  const { __scopeToast: t, label: n = "Notification", duration: o = 5e3, swipeDirection: r = "right", swipeThreshold: i = 50, children: a } = e, [s, c] = it(null), [l, u] = it(0), d = xt(!1), _ = xt(!1);
  return /* @__PURE__ */ pt(B6.Provider, {
    scope: t
  }, /* @__PURE__ */ pt(Poc, {
    scope: t,
    label: n,
    duration: o,
    swipeDirection: r,
    swipeThreshold: i,
    toastCount: l,
    viewport: s,
    onViewportChange: c,
    onToastAdd: Yt(
      () => u(
        (p) => p + 1
      ),
      []
    ),
    onToastRemove: Yt(
      () => u(
        (p) => p - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef: d,
    isClosePausedRef: _
  }, a));
};
rae.propTypes = {
  label(e) {
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      const t = `Invalid prop \`label\` supplied to \`${nae}\`. Expected non-empty \`string\`.`;
      return new Error(t);
    }
    return null;
  }
};
const Doc = "ToastViewport", Loc = [
  "F8"
], bM = "toast.viewportPause", yM = "toast.viewportResume", Moc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, hotkey: o = Loc, label: r = "Notifications ({hotkey})", ...i } = e, a = IT(Doc, n), s = zoc(n), c = xt(null), l = xt(null), u = xt(null), d = xt(null), _ = ni(t, d, a.onViewportChange), p = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = a.toastCount > 0;
  yt(() => {
    const h = ($) => {
      var v;
      o.every(
        (y) => $[y] || $.code === y
      ) && ((v = d.current) === null || v === void 0 || v.focus());
    };
    return document.addEventListener("keydown", h), () => document.removeEventListener("keydown", h);
  }, [
    o
  ]), yt(() => {
    const h = c.current, $ = d.current;
    if (g && h && $) {
      const v = () => {
        if (!a.isClosePausedRef.current) {
          const N = new CustomEvent(bM);
          $.dispatchEvent(N), a.isClosePausedRef.current = !0;
        }
      }, b = () => {
        if (a.isClosePausedRef.current) {
          const N = new CustomEvent(yM);
          $.dispatchEvent(N), a.isClosePausedRef.current = !1;
        }
      }, y = (N) => {
        !h.contains(N.relatedTarget) && b();
      }, w = () => {
        h.contains(document.activeElement) || b();
      };
      return h.addEventListener("focusin", v), h.addEventListener("focusout", y), h.addEventListener("pointermove", v), h.addEventListener("pointerleave", w), window.addEventListener("blur", v), window.addEventListener("focus", b), () => {
        h.removeEventListener("focusin", v), h.removeEventListener("focusout", y), h.removeEventListener("pointermove", v), h.removeEventListener("pointerleave", w), window.removeEventListener("blur", v), window.removeEventListener("focus", b);
      };
    }
  }, [
    g,
    a.isClosePausedRef
  ]);
  const f = Yt(({ tabbingDirection: h }) => {
    const v = s().map((b) => {
      const y = b.ref.current, w = [
        y,
        ...erc(y)
      ];
      return h === "forwards" ? w : w.reverse();
    });
    return (h === "forwards" ? v.reverse() : v).flat();
  }, [
    s
  ]);
  return yt(() => {
    const h = d.current;
    if (h) {
      const $ = (v) => {
        const b = v.altKey || v.ctrlKey || v.metaKey;
        if (v.key === "Tab" && !b) {
          const q = document.activeElement, L = v.shiftKey;
          if (v.target === h && L) {
            var w;
            (w = l.current) === null || w === void 0 || w.focus();
            return;
          }
          const D = f({
            tabbingDirection: L ? "backwards" : "forwards"
          }), A = D.findIndex(
            (S) => S === q
          );
          if (NI(D.slice(A + 1)))
            v.preventDefault();
          else {
            var N, M;
            L ? (N = l.current) === null || N === void 0 || N.focus() : (M = u.current) === null || M === void 0 || M.focus();
          }
        }
      };
      return h.addEventListener("keydown", $), () => h.removeEventListener("keydown", $);
    }
  }, [
    s,
    f
  ]), /* @__PURE__ */ pt(Ioc, {
    ref: c,
    role: "region",
    "aria-label": r.replace("{hotkey}", p),
    tabIndex: -1,
    style: {
      pointerEvents: g ? void 0 : "none"
    }
  }, g && /* @__PURE__ */ pt(rU, {
    ref: l,
    onFocusFromOutsideViewport: () => {
      const h = f({
        tabbingDirection: "forwards"
      });
      NI(h);
    }
  }), /* @__PURE__ */ pt(B6.Slot, {
    scope: n
  }, /* @__PURE__ */ pt(nr.ol, Tt({
    tabIndex: -1
  }, i, {
    ref: _
  }))), g && /* @__PURE__ */ pt(rU, {
    ref: u,
    onFocusFromOutsideViewport: () => {
      const h = f({
        tabbingDirection: "backwards"
      });
      NI(h);
    }
  }));
}), Foc = "ToastFocusProxy", rU = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, onFocusFromOutsideViewport: o, ...r } = e, i = IT(Foc, n);
  return /* @__PURE__ */ pt(L6, Tt({
    "aria-hidden": !0,
    tabIndex: 0
  }, r, {
    ref: t,
    style: {
      position: "fixed"
    },
    onFocus: (a) => {
      var s;
      const c = a.relatedTarget;
      !((s = i.viewport) !== null && s !== void 0 && s.contains(c)) && o();
    }
  }));
}), OT = "Toast", qoc = "toast.swipeStart", joc = "toast.swipeMove", Voc = "toast.swipeCancel", Boc = "toast.swipeEnd", Uoc = /* @__PURE__ */ Bt((e, t) => {
  const { forceMount: n, open: o, defaultOpen: r, onOpenChange: i, ...a } = e, [s = !0, c] = Uu({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ pt(Vc, {
    present: n || s
  }, /* @__PURE__ */ pt(iae, Tt({
    open: s
  }, a, {
    ref: t,
    onClose: () => c(!1),
    onPause: ws(e.onPause),
    onResume: ws(e.onResume),
    onSwipeStart: jn(e.onSwipeStart, (l) => {
      l.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: jn(e.onSwipeMove, (l) => {
      const { x: u, y: d } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
    }),
    onSwipeCancel: jn(e.onSwipeCancel, (l) => {
      l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: jn(e.onSwipeEnd, (l) => {
      const { x: u, y: d } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), c(!1);
    })
  })));
}), [Goc, Woc] = oae(OT, {
  onClose() {
  }
}), iae = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, type: o = "foreground", duration: r, open: i, onClose: a, onEscapeKeyDown: s, onPause: c, onResume: l, onSwipeStart: u, onSwipeMove: d, onSwipeCancel: _, onSwipeEnd: p, ...g } = e, f = IT(OT, n), [h, $] = it(null), v = ni(
    t,
    (S) => $(S)
  ), b = xt(null), y = xt(null), w = r || f.duration, N = xt(0), M = xt(w), q = xt(0), { onToastAdd: L, onToastRemove: R } = f, T = ws(() => {
    var S;
    (h == null ? void 0 : h.contains(document.activeElement)) && ((S = f.viewport) === null || S === void 0 || S.focus()), a();
  }), D = Yt((S) => {
    !S || S === 1 / 0 || (window.clearTimeout(q.current), N.current = (/* @__PURE__ */ new Date()).getTime(), q.current = window.setTimeout(T, S));
  }, [
    T
  ]);
  yt(() => {
    const S = f.viewport;
    if (S) {
      const E = () => {
        D(M.current), l == null || l();
      }, x = () => {
        const k = (/* @__PURE__ */ new Date()).getTime() - N.current;
        M.current = M.current - k, window.clearTimeout(q.current), c == null || c();
      };
      return S.addEventListener(bM, x), S.addEventListener(yM, E), () => {
        S.removeEventListener(bM, x), S.removeEventListener(yM, E);
      };
    }
  }, [
    f.viewport,
    w,
    c,
    l,
    D
  ]), yt(() => {
    i && !f.isClosePausedRef.current && D(w);
  }, [
    i,
    w,
    f.isClosePausedRef,
    D
  ]), yt(() => (L(), () => R()), [
    L,
    R
  ]);
  const A = vn(() => h ? lae(h) : null, [
    h
  ]);
  return f.viewport ? /* @__PURE__ */ pt(Ha, null, A && /* @__PURE__ */ pt(Hoc, {
    __scopeToast: n,
    role: "status",
    "aria-live": o === "foreground" ? "assertive" : "polite",
    "aria-atomic": !0
  }, A), /* @__PURE__ */ pt(Goc, {
    scope: n,
    onClose: T
  }, /* @__PURE__ */ My(/* @__PURE__ */ pt(B6.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ pt(Aoc, {
    asChild: !0,
    onEscapeKeyDown: jn(s, () => {
      f.isFocusedToastEscapeKeyDownRef.current || T(), f.isFocusedToastEscapeKeyDownRef.current = !1;
    })
  }, /* @__PURE__ */ pt(nr.li, Tt({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": !0,
    tabIndex: 0,
    "data-state": i ? "open" : "closed",
    "data-swipe-direction": f.swipeDirection
  }, g, {
    ref: v,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...e.style
    },
    onKeyDown: jn(e.onKeyDown, (S) => {
      S.key === "Escape" && (s == null || s(S.nativeEvent), S.nativeEvent.defaultPrevented || (f.isFocusedToastEscapeKeyDownRef.current = !0, T()));
    }),
    onPointerDown: jn(e.onPointerDown, (S) => {
      S.button === 0 && (b.current = {
        x: S.clientX,
        y: S.clientY
      });
    }),
    onPointerMove: jn(e.onPointerMove, (S) => {
      if (!b.current)
        return;
      const E = S.clientX - b.current.x, x = S.clientY - b.current.y, k = !!y.current, I = [
        "left",
        "right"
      ].includes(f.swipeDirection), z = [
        "left",
        "up"
      ].includes(f.swipeDirection) ? Math.min : Math.max, F = I ? z(0, E) : 0, P = I ? 0 : z(0, x), O = S.pointerType === "touch" ? 10 : 2, V = {
        x: F,
        y: P
      }, U = {
        originalEvent: S,
        delta: V
      };
      k ? (y.current = V, nS(joc, d, U, {
        discrete: !1
      })) : iU(V, f.swipeDirection, O) ? (y.current = V, nS(qoc, u, U, {
        discrete: !1
      }), S.target.setPointerCapture(S.pointerId)) : (Math.abs(E) > O || Math.abs(x) > O) && (b.current = null);
    }),
    onPointerUp: jn(e.onPointerUp, (S) => {
      const E = y.current, x = S.target;
      if (x.hasPointerCapture(S.pointerId) && x.releasePointerCapture(S.pointerId), y.current = null, b.current = null, E) {
        const k = S.currentTarget, I = {
          originalEvent: S,
          delta: E
        };
        iU(E, f.swipeDirection, f.swipeThreshold) ? nS(Boc, p, I, {
          discrete: !0
        }) : nS(Voc, _, I, {
          discrete: !0
        }), k.addEventListener(
          "click",
          (z) => z.preventDefault(),
          {
            once: !0
          }
        );
      }
    })
  })))), f.viewport))) : null;
});
iae.propTypes = {
  type(e) {
    if (e.type && ![
      "foreground",
      "background"
    ].includes(e.type)) {
      const t = `Invalid prop \`type\` supplied to \`${OT}\`. Expected \`foreground | background\`.`;
      return new Error(t);
    }
    return null;
  }
};
const Hoc = (e) => {
  const { __scopeToast: t, children: n, ...o } = e, r = IT(OT, t), [i, a] = it(!1), [s, c] = it(!1);
  return Joc(
    () => a(!0)
  ), yt(() => {
    const l = window.setTimeout(
      () => c(!0),
      1e3
    );
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ pt(Ooc, {
    asChild: !0
  }, /* @__PURE__ */ pt(L6, o, i && /* @__PURE__ */ pt(Ha, null, r.label, " ", n)));
}, Yoc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, ...o } = e;
  return /* @__PURE__ */ pt(nr.div, Tt({}, o, {
    ref: t
  }));
}), Koc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, ...o } = e;
  return /* @__PURE__ */ pt(nr.div, Tt({}, o, {
    ref: t
  }));
}), Zoc = "ToastAction", aae = /* @__PURE__ */ Bt((e, t) => {
  const { altText: n, ...o } = e;
  return n ? /* @__PURE__ */ pt(cae, {
    altText: n,
    asChild: !0
  }, /* @__PURE__ */ pt(sae, Tt({}, o, {
    ref: t
  }))) : null;
});
aae.propTypes = {
  altText(e) {
    return e.altText ? null : new Error(`Missing prop \`altText\` expected on \`${Zoc}\``);
  }
};
const Xoc = "ToastClose", sae = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, ...o } = e, r = Woc(Xoc, n);
  return /* @__PURE__ */ pt(cae, {
    asChild: !0
  }, /* @__PURE__ */ pt(nr.button, Tt({
    type: "button"
  }, o, {
    ref: t,
    onClick: jn(e.onClick, r.onClose)
  })));
}), cae = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeToast: n, altText: o, ...r } = e;
  return /* @__PURE__ */ pt(nr.div, Tt({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": o || void 0
  }, r, {
    ref: t
  }));
});
function lae(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((o) => {
    if (o.nodeType === o.TEXT_NODE && o.textContent && t.push(o.textContent), Qoc(o)) {
      const r = o.ariaHidden || o.hidden || o.style.display === "none", i = o.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (i) {
          const a = o.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...lae(o));
    }
  }), t;
}
function nS(e, t, n, { discrete: o }) {
  const r = n.originalEvent.currentTarget, i = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? z0(r, i) : r.dispatchEvent(i);
}
const iU = (e, t, n = 0) => {
  const o = Math.abs(e.x), r = Math.abs(e.y), i = o > r;
  return t === "left" || t === "right" ? i && o > n : !i && r > n;
};
function Joc(e = () => {
}) {
  const t = ws(e);
  Noc(() => {
    let n = 0, o = 0;
    return n = window.requestAnimationFrame(
      () => o = window.requestAnimationFrame(t)
    ), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(o);
    };
  }, [
    t
  ]);
}
function Qoc(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function erc(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function NI(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
const trc = rae, uae = Moc, dae = Uoc, _ae = Yoc, pae = Koc, mae = aae, fae = sae, aU = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, sU = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.flat(1 / 0).filter(Boolean).join(" ");
}, nrc = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null)
    return sU(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((l) => {
    const u = n == null ? void 0 : n[l], d = i == null ? void 0 : i[l];
    if (u === null)
      return null;
    const _ = aU(u) || aU(d);
    return r[l][_];
  }), s = n && Object.entries(n).reduce((l, u) => {
    let [d, _] = u;
    return _ === void 0 || (l[d] = _), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, u) => {
    let { class: d, className: _, ...p } = u;
    return Object.entries(p).every((g) => {
      let [f, h] = g;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...s
      }[f]) : {
        ...i,
        ...s
      }[f] === h;
    }) ? [
      ...l,
      d,
      _
    ] : l;
  }, []);
  return sU(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function gae(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (t = 0; t < r; t++)
        e[t] && (n = gae(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function orc() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++)
    (e = arguments[n]) && (t = gae(e)) && (o && (o += " "), o += t);
  return o;
}
function ar(...e) {
  return Lie(orc(e));
}
const rrc = trc, hae = Bt(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  uae,
  {
    ref: n,
    className: ar(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
hae.displayName = uae.displayName;
const irc = nrc(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), vae = Bt(({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ m(dae, { ref: o, className: ar(irc({ variant: t }), e), ...n }));
vae.displayName = dae.displayName;
const arc = Bt(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  mae,
  {
    ref: n,
    className: ar(
      "ring-offset-background hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
arc.displayName = mae.displayName;
const bae = Bt(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  fae,
  {
    ref: n,
    className: ar(
      "text-foreground/50 hover:text-foreground absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ m(qt, { name: "x", className: "h-4 w-4" })
  }
));
bae.displayName = fae.displayName;
const yae = Bt(({ className: e, ...t }, n) => /* @__PURE__ */ m(_ae, { ref: n, className: ar("text-sm font-semibold", e), ...t }));
yae.displayName = _ae.displayName;
const $ae = Bt(({ className: e, ...t }, n) => /* @__PURE__ */ m(pae, { ref: n, className: ar("text-sm opacity-90", e), ...t }));
$ae.displayName = pae.displayName;
const src = 1, crc = 1e6;
let zI = 0;
function lrc() {
  return zI = (zI + 1) % Number.MAX_SAFE_INTEGER, zI.toString();
}
const RI = /* @__PURE__ */ new Map(), cU = (e) => {
  if (RI.has(e))
    return;
  const t = setTimeout(() => {
    RI.delete(e), jw({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, crc);
  RI.set(e, t);
}, urc = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, src)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? cU(n) : e.toasts.forEach((o) => {
        cU(o.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (o) => o.id === n || n === void 0 ? {
            ...o,
            open: !1
          } : o
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, PE = [];
let DE = { toasts: [] };
function jw(e) {
  DE = urc(DE, e), PE.forEach((t) => {
    t(DE);
  });
}
function drc({ ...e }) {
  const t = lrc(), n = (r) => jw({
    type: "UPDATE_TOAST",
    toast: { ...r, id: t }
  }), o = () => jw({ type: "DISMISS_TOAST", toastId: t });
  return jw({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (r) => {
        r || o();
      }
    }
  }), {
    id: t,
    dismiss: o,
    update: n
  };
}
function wf() {
  const [e, t] = Ue.useState(DE);
  return Ue.useEffect(() => (PE.push(t), () => {
    const n = PE.indexOf(t);
    n > -1 && PE.splice(n, 1);
  }), [e]), {
    ...e,
    toast: drc,
    dismiss: (n) => jw({ type: "DISMISS_TOAST", toastId: n })
  };
}
function lU() {
  const { toasts: e } = wf();
  return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ de(rrc, { children: [
    e.map(function({ id: t, title: n, description: o, action: r, ...i }) {
      return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ de(vae, { ...i, children: [
        /* @__PURE__ */ de("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ m(yae, { children: n }),
          o && /* @__PURE__ */ m($ae, { children: o })
        ] }),
        r,
        /* @__PURE__ */ m(bae, {})
      ] }) }, t);
    }),
    /* @__PURE__ */ m(hae, {})
  ] }) });
}
const _rc = "en";
function prc({
  clientId: e,
  accessToken: t,
  options: n,
  children: o,
  labels: r,
  autoUpdateTimezone: i,
  language: a = _rc,
  organizationId: s,
  onTimezoneChange: c,
  isEmbed: l
}) {
  const [u, d] = it(""), [_, p] = it(0), { data: g } = Ev(l), { mutateAsync: f } = $oc(), h = Yt(
    async (M) => {
      await f({ timeZone: M });
    },
    [f]
  ), $ = Yt(() => {
    if (c)
      return c;
    if (!c && i)
      return h;
  }, [c, i, h]);
  yoc($());
  const { isInit: v } = Wnc({
    isEmbed: l,
    clientId: e,
    apiUrl: n.apiUrl,
    refreshUrl: n.refreshUrl,
    onError: d,
    onSuccess: (M) => {
      d(""), p(M.organizationId);
    }
  }), { isRefreshing: b, currentAccessToken: y } = Xnc({
    accessToken: t,
    refreshUrl: n.refreshUrl,
    onError: d,
    onSuccess: () => {
      d("");
    },
    clientId: e
  }), w = Yt(
    (M, q) => {
      if ((q == null ? void 0 : q.count) === void 0 || (q == null ? void 0 : q.count) === null)
        return M;
      const { count: L } = q;
      if (((r == null ? void 0 : r[M]) ?? String(uU(M, a) ?? "")).includes("{{count}}"))
        return M;
      const D = Number(L) === 1 ? "one" : "other";
      return `${M}_${D}`;
    },
    []
  ), N = {
    t: (M, q) => {
      const L = w(M, q);
      let R = (r == null ? void 0 : r[L]) ?? String(uU(L, a) ?? "");
      if (!R)
        return M;
      if (q) {
        const T = Object.keys(q);
        T.length && T.forEach((D) => {
          var A;
          R && (R = R.replace(
            `{{${String(D)}}}`,
            ((A = q[D]) == null ? void 0 : A.toString()) ?? `{{${String(D)}}}`
          ));
        });
      }
      return mrc(R, Tx) ?? "";
    },
    i18n: {
      language: a,
      defaultLocale: a,
      locales: [a],
      exists: (M) => !!Tx[M]
    }
  };
  return v ? /* @__PURE__ */ de(
    hM.Provider,
    {
      value: {
        clientId: e,
        accessToken: y,
        options: n,
        error: u,
        getClient: () => At,
        isRefreshing: b,
        isInit: v,
        isValidClient: !!(!u && e && v),
        isAuth: !!(v && !u && e && y && At.getAuthorizationHeader()),
        organizationId: s || _ || (g == null ? void 0 : g.data.organizationId) || 0,
        userId: g == null ? void 0 : g.data.id,
        isEmbed: l,
        ...N
      },
      children: [
        /* @__PURE__ */ m(U9, { children: o }),
        /* @__PURE__ */ m(lU, {}),
        /* @__PURE__ */ m(eU, {})
      ]
    }
  ) : /* @__PURE__ */ m(
    hM.Provider,
    {
      value: {
        clientId: e,
        options: n,
        error: u,
        getClient: () => At,
        isAuth: !1,
        isValidClient: !!(!u && e),
        isInit: !1,
        isRefreshing: !1,
        ...N,
        organizationId: 0,
        isEmbed: !1
      },
      children: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(U9, { children: o }),
        /* @__PURE__ */ m(lU, {}),
        /* @__PURE__ */ m(eU, {})
      ] })
    }
  );
}
function mrc(e, t) {
  const n = /\$t\((.*?)\)/g;
  return e.replace(n, (o, r) => r in t ? t[r] : o);
}
function uU(e, t) {
  switch (t) {
    case "en":
      return Tx[e];
    case "fr":
      return F9r[e];
    case "pt-BR":
      return Vnc[e];
    case "de":
      return hNt[e];
    case "es":
      return DFo[e];
    case "it":
      return q7i[e];
    case "nl":
      return jXa[e];
    default:
      return Tx[e];
  }
}
const dU = new xre();
function _U({
  clientId: e,
  accessToken: t,
  options: n,
  children: o,
  autoUpdateTimezone: r = !0,
  labels: i,
  language: a = "en",
  onTimezoneChange: s,
  version: c = k6,
  organizationId: l,
  isEmbed: u = !1
}) {
  return yt(() => {
    At.setVersionHeader(c);
  }, [c]), yt(() => {
    t && dU.resetQueries();
  }, [t]), yt(() => {
    At.setPlatformEmbedHeader(u);
  }, [u]), /* @__PURE__ */ m(Ire, { client: dU, children: /* @__PURE__ */ m(
    prc,
    {
      isEmbed: u,
      autoUpdateTimezone: r,
      onTimezoneChange: s,
      clientId: e,
      accessToken: t,
      options: n,
      version: c,
      labels: i,
      language: a,
      organizationId: l,
      children: o
    }
  ) });
}
var PI = { exports: {} }, DI = { exports: {} }, wae = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(wae);
var xo = wae.exports;
const frc = /* @__PURE__ */ Mi(xo);
var LI = { exports: {} }, pU;
function grc() {
  return pU || (pU = 1, function(e) {
    var t = xo.default;
    function n(o, r) {
      if (t(o) !== "object" || o === null)
        return o;
      var i = o[Symbol.toPrimitive];
      if (i !== void 0) {
        var a = i.call(o, r || "default");
        if (t(a) !== "object")
          return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (r === "string" ? String : Number)(o);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(LI)), LI.exports;
}
var mU;
function hrc() {
  return mU || (mU = 1, function(e) {
    var t = xo.default, n = grc();
    function o(r) {
      var i = n(r, "string");
      return t(i) === "symbol" ? i : String(i);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(DI)), DI.exports;
}
var fU;
function Yr() {
  return fU || (fU = 1, function(e) {
    var t = hrc();
    function n(o, r, i) {
      return r = t(r), r in o ? Object.defineProperty(o, r, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : o[r] = i, o;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(PI)), PI.exports;
}
var vrc = Yr();
const brc = /* @__PURE__ */ Mi(vrc);
function gk(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), r, i;
  for (i = 0; i < o.length; i++)
    r = o[i], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
function xv(e, t) {
  if (e == null)
    return {};
  var n = gk(e, t), o, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      o = i[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
const yrc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xv
}, Symbol.toStringTag, { value: "Module" }));
function $rc() {
  if (console && console.warn) {
    for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
  }
}
var gU = {};
function $M() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && gU[t[0]] || (typeof t[0] == "string" && (gU[t[0]] = /* @__PURE__ */ new Date()), $rc.apply(void 0, t));
}
var kae = function(t, n) {
  return function() {
    if (t.isInitialized)
      n();
    else {
      var o = function r() {
        setTimeout(function() {
          t.off("initialized", r);
        }, 0), n();
      };
      t.on("initialized", o);
    }
  };
};
function hU(e, t, n) {
  e.loadNamespaces(t, kae(e, n));
}
function vU(e, t, n, o) {
  typeof n == "string" && (n = [n]), n.forEach(function(r) {
    e.options.ns.indexOf(r) < 0 && e.options.ns.push(r);
  }), e.loadLanguages(t, kae(e, o));
}
function wrc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = t.languages[0], r = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (o.toLowerCase() === "cimode")
    return !0;
  var a = function(c, l) {
    var u = t.services.backendConnector.state["".concat(c, "|").concat(l)];
    return u === -1 || u === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(o, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(o, e) && (!r || a(i, e)));
}
function krc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return $M("i18n.languages were undefined or empty", t.languages), !0;
  var o = t.options.ignoreJSONStructure !== void 0;
  return o ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: function(i, a) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && i.services.backendConnector.backend && i.isLanguageChangingTo && !a(i.isLanguageChangingTo, e))
        return !1;
    }
  }) : wrc(e, t, n);
}
var Src = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Erc = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, xrc = function(t) {
  return Erc[t];
}, Crc = function(t) {
  return t.replace(Src, xrc);
}, Trc = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Crc
};
function Arc() {
  return Trc;
}
var Irc;
function Orc() {
  return Irc;
}
function U6(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
const Nrc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U6
}, Symbol.toStringTag, { value: "Module" }));
function cv(e) {
  "@babel/helpers - typeof";
  return cv = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cv(e);
}
function zrc(e, t) {
  if (cv(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t || "default");
    if (cv(o) !== "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Sae(e) {
  var t = zrc(e, "string");
  return cv(t) === "symbol" ? t : String(t);
}
function bU(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Sae(o.key), o);
  }
}
function G6(e, t, n) {
  return t && bU(e.prototype, t), n && bU(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
const Rrc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G6
}, Symbol.toStringTag, { value: "Module" }));
var Prc = Cr(), Drc = function() {
  function e() {
    U6(this, e), this.usedNamespaces = {};
  }
  return G6(e, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var o = this;
      n.forEach(function(r) {
        o.usedNamespaces[r] || (o.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}(), MI = { exports: {} }, FI = { exports: {} }, yU;
function Eae() {
  return yU || (yU = 1, function(e) {
    function t(n) {
      if (Array.isArray(n))
        return n;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(FI)), FI.exports;
}
var qI = { exports: {} }, $U;
function Lrc() {
  return $U || ($U = 1, function(e) {
    function t(n, o) {
      var r = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
      if (r != null) {
        var i, a, s, c, l = [], u = !0, d = !1;
        try {
          if (s = (r = r.call(n)).next, o === 0) {
            if (Object(r) !== r)
              return;
            u = !1;
          } else
            for (; !(u = (i = s.call(r)).done) && (l.push(i.value), l.length !== o); u = !0)
              ;
        } catch (_) {
          d = !0, a = _;
        } finally {
          try {
            if (!u && r.return != null && (c = r.return(), Object(c) !== c))
              return;
          } finally {
            if (d)
              throw a;
          }
        }
        return l;
      }
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(qI)), qI.exports;
}
var jI = { exports: {} }, VI = { exports: {} }, wU;
function Mrc() {
  return wU || (wU = 1, function(e) {
    function t(n, o) {
      (o == null || o > n.length) && (o = n.length);
      for (var r = 0, i = new Array(o); r < o; r++)
        i[r] = n[r];
      return i;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(VI)), VI.exports;
}
var kU;
function xae() {
  return kU || (kU = 1, function(e) {
    var t = Mrc();
    function n(o, r) {
      if (o) {
        if (typeof o == "string")
          return t(o, r);
        var i = Object.prototype.toString.call(o).slice(8, -1);
        if (i === "Object" && o.constructor && (i = o.constructor.name), i === "Map" || i === "Set")
          return Array.from(o);
        if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
          return t(o, r);
      }
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(jI)), jI.exports;
}
var BI = { exports: {} }, SU;
function Cae() {
  return SU || (SU = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(BI)), BI.exports;
}
var EU;
function Gu() {
  return EU || (EU = 1, function(e) {
    var t = Eae(), n = Lrc(), o = xae(), r = Cae();
    function i(a, s) {
      return t(a) || n(a, s) || o(a, s) || r();
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(MI)), MI.exports;
}
var Frc = Gu();
const qrc = /* @__PURE__ */ Mi(Frc);
function xU(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function UI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xU(Object(n), !0).forEach(function(o) {
      brc(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xU(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
var jrc = function(t, n) {
  var o = xt();
  return yt(function() {
    o.current = n ? o.current : t;
  }, [t, n]), o.current;
};
function Vrc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.i18n, o = bo(Prc) || {}, r = o.i18n, i = o.defaultNS, a = n || r || Orc();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new Drc()), !a) {
    $M("You will need to pass in an i18next instance by using initReactI18next");
    var s = function(L, R) {
      return typeof R == "string" ? R : R && frc(R) === "object" && typeof R.defaultValue == "string" ? R.defaultValue : Array.isArray(L) ? L[L.length - 1] : L;
    }, c = [s, {}, !1];
    return c.t = s, c.i18n = {}, c.ready = !1, c;
  }
  a.options.react && a.options.react.wait !== void 0 && $M("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var l = UI(UI(UI({}, Arc()), a.options.react), t), u = l.useSuspense, d = l.keyPrefix, _ = e || i || a.options && a.options.defaultNS;
  _ = typeof _ == "string" ? [_] : _ || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(_);
  var p = (a.isInitialized || a.initializedStoreOnce) && _.every(function(q) {
    return krc(q, a, l);
  });
  function g() {
    return a.getFixedT(t.lng || null, l.nsMode === "fallback" ? _ : _[0], d);
  }
  var f = it(g), h = qrc(f, 2), $ = h[0], v = h[1], b = _.join();
  t.lng && (b = "".concat(t.lng).concat(b));
  var y = jrc(b), w = xt(!0);
  yt(function() {
    var q = l.bindI18n, L = l.bindI18nStore;
    w.current = !0, !p && !u && (t.lng ? vU(a, t.lng, _, function() {
      w.current && v(g);
    }) : hU(a, _, function() {
      w.current && v(g);
    })), p && y && y !== b && w.current && v(g);
    function R() {
      w.current && v(g);
    }
    return q && a && a.on(q, R), L && a && a.store.on(L, R), function() {
      w.current = !1, q && a && q.split(" ").forEach(function(T) {
        return a.off(T, R);
      }), L && a && L.split(" ").forEach(function(T) {
        return a.store.off(T, R);
      });
    };
  }, [a, b]);
  var N = xt(!0);
  yt(function() {
    w.current && !N.current && v(g), N.current = !1;
  }, [a, d]);
  var M = [$, a, p];
  if (M.t = $, M.i18n = a, M.ready = p, p || !p && !u)
    return M;
  throw new Promise(function(q) {
    t.lng ? vU(a, t.lng, _, function() {
      return q();
    }) : hU(a, _, function() {
      return q();
    });
  });
}
const kt = (e = "common") => {
  const t = cr(), { i18n: n, t: o } = Vrc(e), r = Object.keys(n).length > 0;
  return t != null && t.clientId ? { i18n: t.i18n, t: t.t, isLocaleReady: !0 } : {
    i18n: n,
    t: o,
    isLocaleReady: r
  };
}, CU = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, TU = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.flat(1 / 0).filter(Boolean).join(" ");
}, Vy = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null)
    return TU(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((l) => {
    const u = n == null ? void 0 : n[l], d = i == null ? void 0 : i[l];
    if (u === null)
      return null;
    const _ = CU(u) || CU(d);
    return r[l][_];
  }), s = n && Object.entries(n).reduce((l, u) => {
    let [d, _] = u;
    return _ === void 0 || (l[d] = _), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, u) => {
    let { class: d, className: _, ...p } = u;
    return Object.entries(p).every((g) => {
      let [f, h] = g;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...s
      }[f]) : {
        ...i,
        ...s
      }[f] === h;
    }) ? [
      ...l,
      d,
      _
    ] : l;
  }, []);
  return TU(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
var wM = { exports: {} }, R0 = {};
function Tae(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Tae = function(o) {
    return o ? n : t;
  })(e);
}
function Brc(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Tae(t);
  if (n && n.has(e))
    return n.get(e);
  var o = { __proto__: null }, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var a = r ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(o, i, a) : o[i] = e[i];
    }
  return o.default = e, n && n.set(e, o), o;
}
R0._ = Brc;
var oS = { exports: {} }, GI = {}, AU;
function Aae() {
  return AU || (AU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      assign: function() {
        return i;
      },
      searchParamsToUrlQuery: function() {
        return n;
      },
      urlQueryToSearchParams: function() {
        return r;
      }
    });
    function n(a) {
      const s = {};
      for (const [c, l] of a.entries()) {
        const u = s[c];
        typeof u > "u" ? s[c] = l : Array.isArray(u) ? u.push(l) : s[c] = [
          u,
          l
        ];
      }
      return s;
    }
    function o(a) {
      return typeof a == "string" ? a : typeof a == "number" && !isNaN(a) || typeof a == "boolean" ? String(a) : "";
    }
    function r(a) {
      const s = new URLSearchParams();
      for (const [c, l] of Object.entries(a))
        if (Array.isArray(l))
          for (const u of l)
            s.append(c, o(u));
        else
          s.set(c, o(l));
      return s;
    }
    function i(a) {
      for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
        c[l - 1] = arguments[l];
      for (const u of c) {
        for (const d of u.keys())
          a.delete(d);
        for (const [d, _] of u.entries())
          a.append(d, _);
      }
      return a;
    }
  }(GI)), GI;
}
var WI = {}, IU;
function Iae() {
  return IU || (IU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var u in l)
        Object.defineProperty(c, u, {
          enumerable: !0,
          get: l[u]
        });
    }
    t(e, {
      formatUrl: function() {
        return i;
      },
      formatWithValidation: function() {
        return s;
      },
      urlObjectKeys: function() {
        return a;
      }
    });
    const o = /* @__PURE__ */ R0._(Aae()), r = /https?|ftp|gopher|file/;
    function i(c) {
      let { auth: l, hostname: u } = c, d = c.protocol || "", _ = c.pathname || "", p = c.hash || "", g = c.query || "", f = !1;
      l = l ? encodeURIComponent(l).replace(/%3A/i, ":") + "@" : "", c.host ? f = l + c.host : u && (f = l + (~u.indexOf(":") ? "[" + u + "]" : u), c.port && (f += ":" + c.port)), g && typeof g == "object" && (g = String(o.urlQueryToSearchParams(g)));
      let h = c.search || g && "?" + g || "";
      return d && !d.endsWith(":") && (d += ":"), c.slashes || (!d || r.test(d)) && f !== !1 ? (f = "//" + (f || ""), _ && _[0] !== "/" && (_ = "/" + _)) : f || (f = ""), p && p[0] !== "#" && (p = "#" + p), h && h[0] !== "?" && (h = "?" + h), _ = _.replace(/[?#]/g, encodeURIComponent), h = h.replace("#", "%23"), "" + d + f + _ + h + p;
    }
    const a = [
      "auth",
      "hash",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "slashes"
    ];
    function s(c) {
      return process.env.NODE_ENV === "development" && c !== null && typeof c == "object" && Object.keys(c).forEach((l) => {
        a.includes(l) || console.warn("Unknown key passed via urlObject into url.format: " + l);
      }), i(c);
    }
  }(WI)), WI;
}
var HI = {}, OU;
function Urc() {
  return OU || (OU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "omit", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n, o) {
      const r = {};
      return Object.keys(n).forEach((i) => {
        o.includes(i) || (r[i] = n[i]);
      }), r;
    }
  }(HI)), HI;
}
var YI = {}, NU;
function NT() {
  return NU || (NU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(y, w) {
      for (var N in w)
        Object.defineProperty(y, N, {
          enumerable: !0,
          get: w[N]
        });
    }
    t(e, {
      DecodeError: function() {
        return g;
      },
      MiddlewareNotFoundError: function() {
        return v;
      },
      MissingStaticPage: function() {
        return $;
      },
      NormalizeError: function() {
        return f;
      },
      PageNotFoundError: function() {
        return h;
      },
      SP: function() {
        return _;
      },
      ST: function() {
        return p;
      },
      WEB_VITALS: function() {
        return n;
      },
      execOnce: function() {
        return o;
      },
      getDisplayName: function() {
        return c;
      },
      getLocationOrigin: function() {
        return a;
      },
      getURL: function() {
        return s;
      },
      isAbsoluteUrl: function() {
        return i;
      },
      isResSent: function() {
        return l;
      },
      loadGetInitialProps: function() {
        return d;
      },
      normalizeRepeatedSlashes: function() {
        return u;
      },
      stringifyError: function() {
        return b;
      }
    });
    const n = [
      "CLS",
      "FCP",
      "FID",
      "INP",
      "LCP",
      "TTFB"
    ];
    function o(y) {
      let w = !1, N;
      return function() {
        for (var M = arguments.length, q = new Array(M), L = 0; L < M; L++)
          q[L] = arguments[L];
        return w || (w = !0, N = y(...q)), N;
      };
    }
    const r = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, i = (y) => r.test(y);
    function a() {
      const { protocol: y, hostname: w, port: N } = window.location;
      return y + "//" + w + (N ? ":" + N : "");
    }
    function s() {
      const { href: y } = window.location, w = a();
      return y.substring(w.length);
    }
    function c(y) {
      return typeof y == "string" ? y : y.displayName || y.name || "Unknown";
    }
    function l(y) {
      return y.finished || y.headersSent;
    }
    function u(y) {
      const w = y.split("?");
      return w[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (w[1] ? "?" + w.slice(1).join("?") : "");
    }
    async function d(y, w) {
      if (process.env.NODE_ENV !== "production") {
        var N;
        if ((N = y.prototype) != null && N.getInitialProps) {
          const L = '"' + c(y) + '.getInitialProps()" is defined as an instance method - visit https://nextjs.org/docs/messages/get-initial-props-as-an-instance-method for more information.';
          throw Object.defineProperty(new Error(L), "__NEXT_ERROR_CODE", {
            value: "E394",
            enumerable: !1,
            configurable: !0
          });
        }
      }
      const M = w.res || w.ctx && w.ctx.res;
      if (!y.getInitialProps)
        return w.ctx && w.Component ? {
          pageProps: await d(w.Component, w.ctx)
        } : {};
      const q = await y.getInitialProps(w);
      if (M && l(M))
        return q;
      if (!q) {
        const L = '"' + c(y) + '.getInitialProps()" should resolve to an object. But found "' + q + '" instead.';
        throw Object.defineProperty(new Error(L), "__NEXT_ERROR_CODE", {
          value: "E394",
          enumerable: !1,
          configurable: !0
        });
      }
      return process.env.NODE_ENV !== "production" && Object.keys(q).length === 0 && !w.ctx && console.warn("" + c(y) + " returned an empty object from `getInitialProps`. This de-optimizes and prevents automatic static optimization. https://nextjs.org/docs/messages/empty-object-getInitialProps"), q;
    }
    const _ = typeof performance < "u", p = _ && [
      "mark",
      "measure",
      "getEntriesByName"
    ].every((y) => typeof performance[y] == "function");
    class g extends Error {
    }
    class f extends Error {
    }
    class h extends Error {
      constructor(w) {
        super(), this.code = "ENOENT", this.name = "PageNotFoundError", this.message = "Cannot find module for page: " + w;
      }
    }
    class $ extends Error {
      constructor(w, N) {
        super(), this.message = "Failed to load static file for page: " + w + " " + N;
      }
    }
    class v extends Error {
      constructor() {
        super(), this.code = "ENOENT", this.message = "Cannot find the middleware module";
      }
    }
    function b(y) {
      return JSON.stringify({
        message: y.message,
        stack: y.stack
      });
    }
  }(YI)), YI;
}
var rS = { exports: {} }, KI = {}, zU;
function Oae() {
  return zU || (zU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "removeTrailingSlash", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return n.replace(/\/$/, "") || "/";
    }
  }(KI)), KI;
}
var ZI = {}, RU;
function W6() {
  return RU || (RU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "parsePath", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      const o = n.indexOf("#"), r = n.indexOf("?"), i = r > -1 && (o < 0 || r < o);
      return i || o > -1 ? {
        pathname: n.substring(0, i ? r : o),
        query: i ? n.substring(r, o > -1 ? o : void 0) : "",
        hash: o > -1 ? n.slice(o) : ""
      } : {
        pathname: n,
        query: "",
        hash: ""
      };
    }
  }(ZI)), ZI;
}
var PU;
function zT() {
  return PU || (PU = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "normalizePathTrailingSlash", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = Oae(), o = W6(), r = (i) => {
      if (!i.startsWith("/") || process.env.__NEXT_MANUAL_TRAILING_SLASH)
        return i;
      const { pathname: a, query: s, hash: c } = (0, o.parsePath)(i);
      return process.env.__NEXT_TRAILING_SLASH ? /\.[^/]+\/?$/.test(a) ? "" + (0, n.removeTrailingSlash)(a) + s + c : a.endsWith("/") ? "" + a + s + c : a + "/" + s + c : "" + (0, n.removeTrailingSlash)(a) + s + c;
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(rS, rS.exports)), rS.exports;
}
var XI = {}, iS = { exports: {} }, JI = {}, DU;
function Nae() {
  return DU || (DU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "pathHasPrefix", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = W6();
    function n(o, r) {
      if (typeof o != "string")
        return !1;
      const { pathname: i } = (0, t.parsePath)(o);
      return i === r || i.startsWith(r + "/");
    }
  }(JI)), JI;
}
var LU;
function Grc() {
  return LU || (LU = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "hasBasePath", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = Nae(), o = process.env.__NEXT_ROUTER_BASEPATH || "";
    function r(i) {
      return (0, n.pathHasPrefix)(i, o);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(iS, iS.exports)), iS.exports;
}
var MU;
function zae() {
  return MU || (MU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isLocalURL", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = NT(), n = Grc();
    function o(r) {
      if (!(0, t.isAbsoluteUrl)(r))
        return !0;
      try {
        const i = (0, t.getLocationOrigin)(), a = new URL(r, i);
        return a.origin === i && (0, n.hasBasePath)(a.pathname);
      } catch {
        return !1;
      }
    }
  }(XI)), XI;
}
var QI = {}, eO = {}, FU;
function Wrc() {
  return FU || (FU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var s in a)
        Object.defineProperty(i, s, {
          enumerable: !0,
          get: a[s]
        });
    }
    t(e, {
      getSortedRouteObjects: function() {
        return r;
      },
      getSortedRoutes: function() {
        return o;
      }
    });
    class n {
      insert(a) {
        this._insert(a.split("/").filter(Boolean), [], !1);
      }
      smoosh() {
        return this._smoosh();
      }
      _smoosh(a) {
        a === void 0 && (a = "/");
        const s = [
          ...this.children.keys()
        ].sort();
        this.slugName !== null && s.splice(s.indexOf("[]"), 1), this.restSlugName !== null && s.splice(s.indexOf("[...]"), 1), this.optionalRestSlugName !== null && s.splice(s.indexOf("[[...]]"), 1);
        const c = s.map((l) => this.children.get(l)._smoosh("" + a + l + "/")).reduce((l, u) => [
          ...l,
          ...u
        ], []);
        if (this.slugName !== null && c.push(...this.children.get("[]")._smoosh(a + "[" + this.slugName + "]/")), !this.placeholder) {
          const l = a === "/" ? "/" : a.slice(0, -1);
          if (this.optionalRestSlugName != null)
            throw Object.defineProperty(new Error('You cannot define a route with the same specificity as a optional catch-all route ("' + l + '" and "' + l + "[[..." + this.optionalRestSlugName + ']]").'), "__NEXT_ERROR_CODE", {
              value: "E458",
              enumerable: !1,
              configurable: !0
            });
          c.unshift(l);
        }
        return this.restSlugName !== null && c.push(...this.children.get("[...]")._smoosh(a + "[..." + this.restSlugName + "]/")), this.optionalRestSlugName !== null && c.push(...this.children.get("[[...]]")._smoosh(a + "[[..." + this.optionalRestSlugName + "]]/")), c;
      }
      _insert(a, s, c) {
        if (a.length === 0) {
          this.placeholder = !1;
          return;
        }
        if (c)
          throw Object.defineProperty(new Error("Catch-all must be the last part of the URL."), "__NEXT_ERROR_CODE", {
            value: "E392",
            enumerable: !1,
            configurable: !0
          });
        let l = a[0];
        if (l.startsWith("[") && l.endsWith("]")) {
          let _ = function(p, g) {
            if (p !== null && p !== g)
              throw Object.defineProperty(new Error("You cannot use different slug names for the same dynamic path ('" + p + "' !== '" + g + "')."), "__NEXT_ERROR_CODE", {
                value: "E337",
                enumerable: !1,
                configurable: !0
              });
            s.forEach((f) => {
              if (f === g)
                throw Object.defineProperty(new Error('You cannot have the same slug name "' + g + '" repeat within a single dynamic path'), "__NEXT_ERROR_CODE", {
                  value: "E247",
                  enumerable: !1,
                  configurable: !0
                });
              if (f.replace(/\W/g, "") === l.replace(/\W/g, ""))
                throw Object.defineProperty(new Error('You cannot have the slug names "' + f + '" and "' + g + '" differ only by non-word symbols within a single dynamic path'), "__NEXT_ERROR_CODE", {
                  value: "E499",
                  enumerable: !1,
                  configurable: !0
                });
            }), s.push(g);
          }, u = l.slice(1, -1), d = !1;
          if (u.startsWith("[") && u.endsWith("]") && (u = u.slice(1, -1), d = !0), u.startsWith("…"))
            throw Object.defineProperty(new Error("Detected a three-dot character ('…') at ('" + u + "'). Did you mean ('...')?"), "__NEXT_ERROR_CODE", {
              value: "E147",
              enumerable: !1,
              configurable: !0
            });
          if (u.startsWith("...") && (u = u.substring(3), c = !0), u.startsWith("[") || u.endsWith("]"))
            throw Object.defineProperty(new Error("Segment names may not start or end with extra brackets ('" + u + "')."), "__NEXT_ERROR_CODE", {
              value: "E421",
              enumerable: !1,
              configurable: !0
            });
          if (u.startsWith("."))
            throw Object.defineProperty(new Error("Segment names may not start with erroneous periods ('" + u + "')."), "__NEXT_ERROR_CODE", {
              value: "E288",
              enumerable: !1,
              configurable: !0
            });
          if (c)
            if (d) {
              if (this.restSlugName != null)
                throw Object.defineProperty(new Error('You cannot use both an required and optional catch-all route at the same level ("[...' + this.restSlugName + ']" and "' + a[0] + '" ).'), "__NEXT_ERROR_CODE", {
                  value: "E299",
                  enumerable: !1,
                  configurable: !0
                });
              _(this.optionalRestSlugName, u), this.optionalRestSlugName = u, l = "[[...]]";
            } else {
              if (this.optionalRestSlugName != null)
                throw Object.defineProperty(new Error('You cannot use both an optional and required catch-all route at the same level ("[[...' + this.optionalRestSlugName + ']]" and "' + a[0] + '").'), "__NEXT_ERROR_CODE", {
                  value: "E300",
                  enumerable: !1,
                  configurable: !0
                });
              _(this.restSlugName, u), this.restSlugName = u, l = "[...]";
            }
          else {
            if (d)
              throw Object.defineProperty(new Error('Optional route parameters are not yet supported ("' + a[0] + '").'), "__NEXT_ERROR_CODE", {
                value: "E435",
                enumerable: !1,
                configurable: !0
              });
            _(this.slugName, u), this.slugName = u, l = "[]";
          }
        }
        this.children.has(l) || this.children.set(l, new n()), this.children.get(l)._insert(a.slice(1), s, c);
      }
      constructor() {
        this.placeholder = !0, this.children = /* @__PURE__ */ new Map(), this.slugName = null, this.restSlugName = null, this.optionalRestSlugName = null;
      }
    }
    function o(i) {
      const a = new n();
      return i.forEach((s) => a.insert(s)), a.smoosh();
    }
    function r(i, a) {
      const s = {}, c = [];
      for (let u = 0; u < i.length; u++) {
        const d = a(i[u]);
        s[d] = u, c[u] = d;
      }
      return o(c).map((u) => i[s[u]]);
    }
  }(eO)), eO;
}
var tO = {}, nO = {}, oO = {}, rO = {}, qU;
function Hrc() {
  return qU || (qU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ensureLeadingSlash", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return n.startsWith("/") ? n : "/" + n;
    }
  }(rO)), rO;
}
var H6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(s, c) {
    for (var l in c)
      Object.defineProperty(s, l, {
        enumerable: !0,
        get: c[l]
      });
  }
  t(e, {
    DEFAULT_SEGMENT_KEY: function() {
      return a;
    },
    PAGE_SEGMENT_KEY: function() {
      return i;
    },
    addSearchParamsIfPageSegment: function() {
      return r;
    },
    isGroupSegment: function() {
      return n;
    },
    isParallelRouteSegment: function() {
      return o;
    }
  });
  function n(s) {
    return s[0] === "(" && s.endsWith(")");
  }
  function o(s) {
    return s.startsWith("@") && s !== "@children";
  }
  function r(s, c) {
    if (s.includes(i)) {
      const u = JSON.stringify(c);
      return u !== "{}" ? i + "?" + u : i;
    }
    return s;
  }
  const i = "__PAGE__", a = "__DEFAULT__";
})(H6);
var jU;
function Yrc() {
  return jU || (jU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      normalizeAppPath: function() {
        return r;
      },
      normalizeRscURL: function() {
        return i;
      }
    });
    const n = Hrc(), o = H6;
    function r(a) {
      return (0, n.ensureLeadingSlash)(a.split("/").reduce((s, c, l, u) => !c || (0, o.isGroupSegment)(c) || c[0] === "@" || (c === "page" || c === "route") && l === u.length - 1 ? s : s + "/" + c, ""));
    }
    function i(a) {
      return a.replace(
        /\.rsc($|\?)/,
        // $1 ensures `?` is preserved
        "$1"
      );
    }
  }(oO)), oO;
}
var VU;
function Rae() {
  return VU || (VU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      INTERCEPTION_ROUTE_MARKERS: function() {
        return o;
      },
      extractInterceptionRouteInformation: function() {
        return i;
      },
      isInterceptionRouteAppPath: function() {
        return r;
      }
    });
    const n = Yrc(), o = [
      "(..)(..)",
      "(.)",
      "(..)",
      "(...)"
    ];
    function r(a) {
      return a.split("/").find((s) => o.find((c) => s.startsWith(c))) !== void 0;
    }
    function i(a) {
      let s, c, l;
      for (const u of a.split("/"))
        if (c = o.find((d) => u.startsWith(d)), c) {
          [s, l] = a.split(c, 2);
          break;
        }
      if (!s || !c || !l)
        throw Object.defineProperty(new Error("Invalid interception route: " + a + ". Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>"), "__NEXT_ERROR_CODE", {
          value: "E269",
          enumerable: !1,
          configurable: !0
        });
      switch (s = (0, n.normalizeAppPath)(s), c) {
        case "(.)":
          s === "/" ? l = "/" + l : l = s + "/" + l;
          break;
        case "(..)":
          if (s === "/")
            throw Object.defineProperty(new Error("Invalid interception route: " + a + ". Cannot use (..) marker at the root level, use (.) instead."), "__NEXT_ERROR_CODE", {
              value: "E207",
              enumerable: !1,
              configurable: !0
            });
          l = s.split("/").slice(0, -1).concat(l).join("/");
          break;
        case "(...)":
          l = "/" + l;
          break;
        case "(..)(..)":
          const u = s.split("/");
          if (u.length <= 2)
            throw Object.defineProperty(new Error("Invalid interception route: " + a + ". Cannot use (..)(..) marker at the root level or one level up."), "__NEXT_ERROR_CODE", {
              value: "E486",
              enumerable: !1,
              configurable: !0
            });
          l = u.slice(0, -2).concat(l).join("/");
          break;
        default:
          throw Object.defineProperty(new Error("Invariant: unexpected marker"), "__NEXT_ERROR_CODE", {
            value: "E112",
            enumerable: !1,
            configurable: !0
          });
      }
      return {
        interceptingRoute: s,
        interceptedRoute: l
      };
    }
  }(nO)), nO;
}
var BU;
function Krc() {
  return BU || (BU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isDynamicRoute", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const t = Rae(), n = /\/[^/]*\[[^/]+\][^/]*(?=\/|$)/, o = /\/\[[^/]+\](?=\/|$)/;
    function r(i, a) {
      return a === void 0 && (a = !0), (0, t.isInterceptionRouteAppPath)(i) && (i = (0, t.extractInterceptionRouteInformation)(i).interceptedRoute), a ? o.test(i) : n.test(i);
    }
  }(tO)), tO;
}
var UU;
function Zrc() {
  return UU || (UU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(r, i) {
      for (var a in i)
        Object.defineProperty(r, a, {
          enumerable: !0,
          get: i[a]
        });
    }
    t(e, {
      getSortedRouteObjects: function() {
        return n.getSortedRouteObjects;
      },
      getSortedRoutes: function() {
        return n.getSortedRoutes;
      },
      isDynamicRoute: function() {
        return o.isDynamicRoute;
      }
    });
    const n = Wrc(), o = Krc();
  }(QI)), QI;
}
var iO = {}, aO = {}, sO = {}, cO = { exports: {} }, GU;
function Xrc() {
  return GU || (GU = 1, (() => {
    typeof __nccwpck_require__ < "u" && (__nccwpck_require__.ab = __dirname + "/");
    var e = {};
    (() => {
      var t = e;
      Object.defineProperty(t, "__esModule", { value: !0 }), t.pathToRegexp = t.tokensToRegexp = t.regexpToFunction = t.match = t.tokensToFunction = t.compile = t.parse = void 0;
      function n(f) {
        for (var h = [], $ = 0; $ < f.length; ) {
          var v = f[$];
          if (v === "*" || v === "+" || v === "?") {
            h.push({ type: "MODIFIER", index: $, value: f[$++] });
            continue;
          }
          if (v === "\\") {
            h.push({ type: "ESCAPED_CHAR", index: $++, value: f[$++] });
            continue;
          }
          if (v === "{") {
            h.push({ type: "OPEN", index: $, value: f[$++] });
            continue;
          }
          if (v === "}") {
            h.push({ type: "CLOSE", index: $, value: f[$++] });
            continue;
          }
          if (v === ":") {
            for (var b = "", y = $ + 1; y < f.length; ) {
              var w = f.charCodeAt(y);
              if (w >= 48 && w <= 57 || w >= 65 && w <= 90 || w >= 97 && w <= 122 || w === 95) {
                b += f[y++];
                continue;
              }
              break;
            }
            if (!b)
              throw new TypeError("Missing parameter name at ".concat($));
            h.push({ type: "NAME", index: $, value: b }), $ = y;
            continue;
          }
          if (v === "(") {
            var N = 1, M = "", y = $ + 1;
            if (f[y] === "?")
              throw new TypeError('Pattern cannot start with "?" at '.concat(y));
            for (; y < f.length; ) {
              if (f[y] === "\\") {
                M += f[y++] + f[y++];
                continue;
              }
              if (f[y] === ")") {
                if (N--, N === 0) {
                  y++;
                  break;
                }
              } else if (f[y] === "(" && (N++, f[y + 1] !== "?"))
                throw new TypeError("Capturing groups are not allowed at ".concat(y));
              M += f[y++];
            }
            if (N)
              throw new TypeError("Unbalanced pattern at ".concat($));
            if (!M)
              throw new TypeError("Missing pattern at ".concat($));
            h.push({ type: "PATTERN", index: $, value: M }), $ = y;
            continue;
          }
          h.push({ type: "CHAR", index: $, value: f[$++] });
        }
        return h.push({ type: "END", index: $, value: "" }), h;
      }
      function o(f, h) {
        h === void 0 && (h = {});
        for (var $ = n(f), v = h.prefixes, b = v === void 0 ? "./" : v, y = h.delimiter, w = y === void 0 ? "/#?" : y, N = [], M = 0, q = 0, L = "", R = function(U) {
          if (q < $.length && $[q].type === U)
            return $[q++].value;
        }, T = function(U) {
          var H = R(U);
          if (H !== void 0)
            return H;
          var J = $[q], le = J.type, ae = J.index;
          throw new TypeError("Unexpected ".concat(le, " at ").concat(ae, ", expected ").concat(U));
        }, D = function() {
          for (var U = "", H; H = R("CHAR") || R("ESCAPED_CHAR"); )
            U += H;
          return U;
        }, A = function(U) {
          for (var H = 0, J = w; H < J.length; H++) {
            var le = J[H];
            if (U.indexOf(le) > -1)
              return !0;
          }
          return !1;
        }, S = function(U) {
          var H = N[N.length - 1], J = U || (H && typeof H == "string" ? H : "");
          if (H && !J)
            throw new TypeError('Must have text between two parameters, missing text after "'.concat(H.name, '"'));
          return !J || A(J) ? "[^".concat(c(w), "]+?") : "(?:(?!".concat(c(J), ")[^").concat(c(w), "])+?");
        }; q < $.length; ) {
          var E = R("CHAR"), x = R("NAME"), k = R("PATTERN");
          if (x || k) {
            var I = E || "";
            b.indexOf(I) === -1 && (L += I, I = ""), L && (N.push(L), L = ""), N.push({ name: x || M++, prefix: I, suffix: "", pattern: k || S(I), modifier: R("MODIFIER") || "" });
            continue;
          }
          var z = E || R("ESCAPED_CHAR");
          if (z) {
            L += z;
            continue;
          }
          L && (N.push(L), L = "");
          var F = R("OPEN");
          if (F) {
            var I = D(), P = R("NAME") || "", O = R("PATTERN") || "", V = D();
            T("CLOSE"), N.push({ name: P || (O ? M++ : ""), pattern: P && !O ? S(I) : O, prefix: I, suffix: V, modifier: R("MODIFIER") || "" });
            continue;
          }
          T("END");
        }
        return N;
      }
      t.parse = o;
      function r(f, h) {
        return i(o(f, h), h);
      }
      t.compile = r;
      function i(f, h) {
        h === void 0 && (h = {});
        var $ = l(h), v = h.encode, b = v === void 0 ? function(M) {
          return M;
        } : v, y = h.validate, w = y === void 0 ? !0 : y, N = f.map(function(M) {
          if (typeof M == "object")
            return new RegExp("^(?:".concat(M.pattern, ")$"), $);
        });
        return function(M) {
          for (var q = "", L = 0; L < f.length; L++) {
            var R = f[L];
            if (typeof R == "string") {
              q += R;
              continue;
            }
            var T = M ? M[R.name] : void 0, D = R.modifier === "?" || R.modifier === "*", A = R.modifier === "*" || R.modifier === "+";
            if (Array.isArray(T)) {
              if (!A)
                throw new TypeError('Expected "'.concat(R.name, '" to not repeat, but got an array'));
              if (T.length === 0) {
                if (D)
                  continue;
                throw new TypeError('Expected "'.concat(R.name, '" to not be empty'));
              }
              for (var S = 0; S < T.length; S++) {
                var E = b(T[S], R);
                if (w && !N[L].test(E))
                  throw new TypeError('Expected all "'.concat(R.name, '" to match "').concat(R.pattern, '", but got "').concat(E, '"'));
                q += R.prefix + E + R.suffix;
              }
              continue;
            }
            if (typeof T == "string" || typeof T == "number") {
              var E = b(String(T), R);
              if (w && !N[L].test(E))
                throw new TypeError('Expected "'.concat(R.name, '" to match "').concat(R.pattern, '", but got "').concat(E, '"'));
              q += R.prefix + E + R.suffix;
              continue;
            }
            if (!D) {
              var x = A ? "an array" : "a string";
              throw new TypeError('Expected "'.concat(R.name, '" to be ').concat(x));
            }
          }
          return q;
        };
      }
      t.tokensToFunction = i;
      function a(f, h) {
        var $ = [], v = g(f, $, h);
        return s(v, $, h);
      }
      t.match = a;
      function s(f, h, $) {
        $ === void 0 && ($ = {});
        var v = $.decode, b = v === void 0 ? function(y) {
          return y;
        } : v;
        return function(y) {
          var w = f.exec(y);
          if (!w)
            return !1;
          for (var N = w[0], M = w.index, q = /* @__PURE__ */ Object.create(null), L = function(T) {
            if (w[T] === void 0)
              return "continue";
            var D = h[T - 1];
            D.modifier === "*" || D.modifier === "+" ? q[D.name] = w[T].split(D.prefix + D.suffix).map(function(A) {
              return b(A, D);
            }) : q[D.name] = b(w[T], D);
          }, R = 1; R < w.length; R++)
            L(R);
          return { path: N, index: M, params: q };
        };
      }
      t.regexpToFunction = s;
      function c(f) {
        return f.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
      }
      function l(f) {
        return f && f.sensitive ? "" : "i";
      }
      function u(f, h) {
        if (!h)
          return f;
        for (var $ = /\((?:\?<(.*?)>)?(?!\?)/g, v = 0, b = $.exec(f.source); b; )
          h.push({ name: b[1] || v++, prefix: "", suffix: "", modifier: "", pattern: "" }), b = $.exec(f.source);
        return f;
      }
      function d(f, h, $) {
        var v = f.map(function(b) {
          return g(b, h, $).source;
        });
        return new RegExp("(?:".concat(v.join("|"), ")"), l($));
      }
      function _(f, h, $) {
        return p(o(f, $), h, $);
      }
      function p(f, h, $) {
        $ === void 0 && ($ = {});
        for (var v = $.strict, b = v === void 0 ? !1 : v, y = $.start, w = y === void 0 ? !0 : y, N = $.end, M = N === void 0 ? !0 : N, q = $.encode, L = q === void 0 ? function(H) {
          return H;
        } : q, R = $.delimiter, T = R === void 0 ? "/#?" : R, D = $.endsWith, A = D === void 0 ? "" : D, S = "[".concat(c(A), "]|$"), E = "[".concat(c(T), "]"), x = w ? "^" : "", k = 0, I = f; k < I.length; k++) {
          var z = I[k];
          if (typeof z == "string")
            x += c(L(z));
          else {
            var F = c(L(z.prefix)), P = c(L(z.suffix));
            if (z.pattern)
              if (h && h.push(z), F || P)
                if (z.modifier === "+" || z.modifier === "*") {
                  var O = z.modifier === "*" ? "?" : "";
                  x += "(?:".concat(F, "((?:").concat(z.pattern, ")(?:").concat(P).concat(F, "(?:").concat(z.pattern, "))*)").concat(P, ")").concat(O);
                } else
                  x += "(?:".concat(F, "(").concat(z.pattern, ")").concat(P, ")").concat(z.modifier);
              else {
                if (z.modifier === "+" || z.modifier === "*")
                  throw new TypeError('Can not repeat "'.concat(z.name, '" without a prefix and suffix'));
                x += "(".concat(z.pattern, ")").concat(z.modifier);
              }
            else
              x += "(?:".concat(F).concat(P, ")").concat(z.modifier);
          }
        }
        if (M)
          b || (x += "".concat(E, "?")), x += $.endsWith ? "(?=".concat(S, ")") : "$";
        else {
          var V = f[f.length - 1], U = typeof V == "string" ? E.indexOf(V[V.length - 1]) > -1 : V === void 0;
          b || (x += "(?:".concat(E, "(?=").concat(S, "))?")), U || (x += "(?=".concat(E, "|").concat(S, ")"));
        }
        return new RegExp(x, l($));
      }
      t.tokensToRegexp = p;
      function g(f, h, $) {
        return f instanceof RegExp ? u(f, h) : Array.isArray(f) ? d(f, h, $) : _(f, h, $);
      }
      t.pathToRegexp = g;
    })(), cO.exports = e;
  })()), cO.exports;
}
var lO = {}, WU;
function Jrc() {
  return WU || (WU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(s, c) {
      for (var l in c)
        Object.defineProperty(s, l, {
          enumerable: !0,
          get: c[l]
        });
    }
    t(e, {
      hasAdjacentParameterIssues: function() {
        return o;
      },
      normalizeAdjacentParameters: function() {
        return r;
      },
      normalizeTokensForRegexp: function() {
        return i;
      },
      stripParameterSeparators: function() {
        return a;
      }
    });
    const n = "_NEXTSEP_";
    function o(s) {
      return typeof s != "string" ? !1 : !!(/\/\(\.{1,3}\):[^/\s]+/.test(s) || /:[a-zA-Z_][a-zA-Z0-9_]*:[a-zA-Z_][a-zA-Z0-9_]*/.test(s));
    }
    function r(s) {
      let c = s;
      return c = c.replace(/(\([^)]*\)):([^/\s]+)/g, `$1${n}:$2`), c = c.replace(/:([^:/\s)]+)(?=:)/g, `:$1${n}`), c;
    }
    function i(s) {
      return s.map((c) => typeof c == "object" && c !== null && // Not all token objects have 'modifier' property (e.g., simple text tokens)
      "modifier" in c && // Only repeating modifiers (* or +) cause the validation error
      // Other modifiers like '?' (optional) are fine
      (c.modifier === "*" || c.modifier === "+") && // Token objects can have different shapes depending on route pattern
      "prefix" in c && "suffix" in c && // Both prefix and suffix must be empty strings
      // This is what causes the validation error in path-to-regexp
      c.prefix === "" && c.suffix === "" ? {
        ...c,
        prefix: "/"
      } : c);
    }
    function a(s) {
      const c = {};
      for (const [l, u] of Object.entries(s))
        typeof u == "string" ? c[l] = u.replace(new RegExp(`^${n}`), "") : Array.isArray(u) ? c[l] = u.map((d) => typeof d == "string" ? d.replace(new RegExp(`^${n}`), "") : d) : c[l] = u;
      return c;
    }
  }(lO)), lO;
}
var HU;
function Qrc() {
  return HU || (HU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var u in l)
        Object.defineProperty(c, u, {
          enumerable: !0,
          get: l[u]
        });
    }
    t(e, {
      safeCompile: function() {
        return i;
      },
      safePathToRegexp: function() {
        return r;
      },
      safeRegexpToFunction: function() {
        return a;
      },
      safeRouteMatcher: function() {
        return s;
      }
    });
    const n = Xrc(), o = Jrc();
    function r(c, l, u) {
      if (typeof c != "string")
        return (0, n.pathToRegexp)(c, l, u);
      const d = (0, o.hasAdjacentParameterIssues)(c), _ = d ? (0, o.normalizeAdjacentParameters)(c) : c;
      try {
        return (0, n.pathToRegexp)(_, l, u);
      } catch (p) {
        if (!d)
          try {
            const g = (0, o.normalizeAdjacentParameters)(c);
            return (0, n.pathToRegexp)(g, l, u);
          } catch {
            throw p;
          }
        throw p;
      }
    }
    function i(c, l) {
      const u = (0, o.hasAdjacentParameterIssues)(c), d = u ? (0, o.normalizeAdjacentParameters)(c) : c;
      try {
        return (0, n.compile)(d, l);
      } catch (_) {
        if (!u)
          try {
            const p = (0, o.normalizeAdjacentParameters)(c);
            return (0, n.compile)(p, l);
          } catch {
            throw _;
          }
        throw _;
      }
    }
    function a(c, l) {
      const u = (0, n.regexpToFunction)(c, l || []);
      return (d) => {
        const _ = u(d);
        return _ ? {
          ..._,
          params: (0, o.stripParameterSeparators)(_.params)
        } : !1;
      };
    }
    function s(c) {
      return (l) => {
        const u = c(l);
        return u ? (0, o.stripParameterSeparators)(u) : !1;
      };
    }
  }(sO)), sO;
}
var YU;
function Pae() {
  return YU || (YU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "getRouteMatcher", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = NT(), n = Qrc();
    function o(r) {
      let { re: i, groups: a } = r;
      const s = (c) => {
        const l = i.exec(c);
        if (!l)
          return !1;
        const u = (_) => {
          try {
            return decodeURIComponent(_);
          } catch {
            throw Object.defineProperty(new t.DecodeError("failed to decode param"), "__NEXT_ERROR_CODE", {
              value: "E528",
              enumerable: !1,
              configurable: !0
            });
          }
        }, d = {};
        for (const [_, p] of Object.entries(a)) {
          const g = l[p.pos];
          g !== void 0 && (p.repeat ? d[_] = g.split("/").map((f) => u(f)) : d[_] = u(g));
        }
        return d;
      };
      return (0, n.safeRouteMatcher)(s);
    }
  }(aO)), aO;
}
var uO = {}, dO = {}, KU;
function eic() {
  return KU || (KU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(Me, et) {
      for (var st in et)
        Object.defineProperty(Me, st, {
          enumerable: !0,
          get: et[st]
        });
    }
    t(e, {
      ACTION_SUFFIX: function() {
        return g;
      },
      APP_DIR_ALIAS: function() {
        return I;
      },
      CACHE_ONE_YEAR: function() {
        return R;
      },
      DOT_NEXT_ALIAS: function() {
        return x;
      },
      ESLINT_DEFAULT_DIRS: function() {
        return pe;
      },
      GSP_NO_RETURNED_VALUE: function() {
        return _e;
      },
      GSSP_COMPONENT_MEMBER_ERROR: function() {
        return Q;
      },
      GSSP_NO_RETURNED_VALUE: function() {
        return he;
      },
      HTML_CONTENT_TYPE_HEADER: function() {
        return o;
      },
      INFINITE_CACHE: function() {
        return T;
      },
      INSTRUMENTATION_HOOK_FILENAME: function() {
        return S;
      },
      JSON_CONTENT_TYPE_HEADER: function() {
        return r;
      },
      MATCHED_PATH_HEADER: function() {
        return s;
      },
      MIDDLEWARE_FILENAME: function() {
        return D;
      },
      MIDDLEWARE_LOCATION_REGEXP: function() {
        return A;
      },
      NEXT_BODY_SUFFIX: function() {
        return $;
      },
      NEXT_CACHE_IMPLICIT_TAG_ID: function() {
        return L;
      },
      NEXT_CACHE_REVALIDATED_TAGS_HEADER: function() {
        return b;
      },
      NEXT_CACHE_REVALIDATE_TAG_TOKEN_HEADER: function() {
        return y;
      },
      NEXT_CACHE_SOFT_TAG_MAX_LENGTH: function() {
        return q;
      },
      NEXT_CACHE_TAGS_HEADER: function() {
        return v;
      },
      NEXT_CACHE_TAG_MAX_ITEMS: function() {
        return N;
      },
      NEXT_CACHE_TAG_MAX_LENGTH: function() {
        return M;
      },
      NEXT_DATA_SUFFIX: function() {
        return f;
      },
      NEXT_INTERCEPTION_MARKER_PREFIX: function() {
        return a;
      },
      NEXT_META_SUFFIX: function() {
        return h;
      },
      NEXT_QUERY_PARAM_PREFIX: function() {
        return i;
      },
      NEXT_RESUME_HEADER: function() {
        return w;
      },
      NON_STANDARD_NODE_ENV: function() {
        return me;
      },
      PAGES_DIR_ALIAS: function() {
        return E;
      },
      PRERENDER_REVALIDATE_HEADER: function() {
        return c;
      },
      PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER: function() {
        return l;
      },
      PUBLIC_DIR_MIDDLEWARE_CONFLICT: function() {
        return J;
      },
      ROOT_DIR_ALIAS: function() {
        return k;
      },
      RSC_ACTION_CLIENT_WRAPPER_ALIAS: function() {
        return H;
      },
      RSC_ACTION_ENCRYPTION_ALIAS: function() {
        return U;
      },
      RSC_ACTION_PROXY_ALIAS: function() {
        return P;
      },
      RSC_ACTION_VALIDATE_ALIAS: function() {
        return F;
      },
      RSC_CACHE_WRAPPER_ALIAS: function() {
        return O;
      },
      RSC_DYNAMIC_IMPORT_WRAPPER_ALIAS: function() {
        return V;
      },
      RSC_MOD_REF_PROXY_ALIAS: function() {
        return z;
      },
      RSC_PREFETCH_SUFFIX: function() {
        return u;
      },
      RSC_SEGMENTS_DIR_SUFFIX: function() {
        return d;
      },
      RSC_SEGMENT_SUFFIX: function() {
        return _;
      },
      RSC_SUFFIX: function() {
        return p;
      },
      SERVER_PROPS_EXPORT_ERROR: function() {
        return ie;
      },
      SERVER_PROPS_GET_INIT_PROPS_CONFLICT: function() {
        return ae;
      },
      SERVER_PROPS_SSG_CONFLICT: function() {
        return Y;
      },
      SERVER_RUNTIME: function() {
        return ge;
      },
      SSG_FALLBACK_EXPORT_ERROR: function() {
        return ne;
      },
      SSG_GET_INITIAL_PROPS_CONFLICT: function() {
        return le;
      },
      STATIC_STATUS_PAGE_GET_INITIAL_PROPS_ERROR: function() {
        return re;
      },
      TEXT_PLAIN_CONTENT_TYPE_HEADER: function() {
        return n;
      },
      UNSTABLE_REVALIDATE_RENAME_ERROR: function() {
        return be;
      },
      WEBPACK_LAYERS: function() {
        return Te;
      },
      WEBPACK_RESOURCE_QUERIES: function() {
        return Re;
      }
    });
    const n = "text/plain", o = "text/html; charset=utf-8", r = "application/json; charset=utf-8", i = "nxtP", a = "nxtI", s = "x-matched-path", c = "x-prerender-revalidate", l = "x-prerender-revalidate-if-generated", u = ".prefetch.rsc", d = ".segments", _ = ".segment.rsc", p = ".rsc", g = ".action", f = ".json", h = ".meta", $ = ".body", v = "x-next-cache-tags", b = "x-next-revalidated-tags", y = "x-next-revalidate-tag-token", w = "next-resume", N = 128, M = 256, q = 1024, L = "_N_T_", R = 31536e3, T = 4294967294, D = "middleware", A = `(?:src/)?${D}`, S = "instrumentation", E = "private-next-pages", x = "private-dot-next", k = "private-next-root-dir", I = "private-next-app-dir", z = "private-next-rsc-mod-ref-proxy", F = "private-next-rsc-action-validate", P = "private-next-rsc-server-reference", O = "private-next-rsc-cache-wrapper", V = "private-next-rsc-track-dynamic-import", U = "private-next-rsc-action-encryption", H = "private-next-rsc-action-client-wrapper", J = "You can not have a '_next' folder inside of your public folder. This conflicts with the internal '/_next' route. https://nextjs.org/docs/messages/public-next-folder-conflict", le = "You can not use getInitialProps with getStaticProps. To use SSG, please remove your getInitialProps", ae = "You can not use getInitialProps with getServerSideProps. Please remove getInitialProps.", Y = "You can not use getStaticProps or getStaticPaths with getServerSideProps. To use SSG, please remove getServerSideProps", re = "can not have getInitialProps/getServerSideProps, https://nextjs.org/docs/messages/404-get-initial-props", ie = "pages with `getServerSideProps` can not be exported. See more info here: https://nextjs.org/docs/messages/gssp-export", _e = "Your `getStaticProps` function did not return an object. Did you forget to add a `return`?", he = "Your `getServerSideProps` function did not return an object. Did you forget to add a `return`?", be = "The `unstable_revalidate` property is available for general use.\nPlease use `revalidate` instead.", Q = "can not be attached to a page's component and must be exported from the page. See more info here: https://nextjs.org/docs/messages/gssp-component-member", me = 'You are using a non-standard "NODE_ENV" value in your environment. This creates inconsistencies in the project and is strongly advised against. Read more: https://nextjs.org/docs/messages/non-standard-node-env', ne = "Pages with `fallback` enabled in `getStaticPaths` can not be exported. See more info here: https://nextjs.org/docs/messages/ssg-fallback-true-export", pe = [
      "app",
      "pages",
      "components",
      "lib",
      "src"
    ], ge = {
      edge: "edge",
      experimentalEdge: "experimental-edge",
      nodejs: "nodejs"
    }, ve = {
      /**
      * The layer for the shared code between the client and server bundles.
      */
      shared: "shared",
      /**
      * The layer for server-only runtime and picking up `react-server` export conditions.
      * Including app router RSC pages and app router custom routes and metadata routes.
      */
      reactServerComponents: "rsc",
      /**
      * Server Side Rendering layer for app (ssr).
      */
      serverSideRendering: "ssr",
      /**
      * The browser client bundle layer for actions.
      */
      actionBrowser: "action-browser",
      /**
      * The Node.js bundle layer for the API routes.
      */
      apiNode: "api-node",
      /**
      * The Edge Lite bundle layer for the API routes.
      */
      apiEdge: "api-edge",
      /**
      * The layer for the middleware code.
      */
      middleware: "middleware",
      /**
      * The layer for the instrumentation hooks.
      */
      instrument: "instrument",
      /**
      * The layer for assets on the edge.
      */
      edgeAsset: "edge-asset",
      /**
      * The browser client bundle layer for App directory.
      */
      appPagesBrowser: "app-pages-browser",
      /**
      * The browser client bundle layer for Pages directory.
      */
      pagesDirBrowser: "pages-dir-browser",
      /**
      * The Edge Lite bundle layer for Pages directory.
      */
      pagesDirEdge: "pages-dir-edge",
      /**
      * The Node.js bundle layer for Pages directory.
      */
      pagesDirNode: "pages-dir-node"
    }, Te = {
      ...ve,
      GROUP: {
        builtinReact: [
          ve.reactServerComponents,
          ve.actionBrowser
        ],
        serverOnly: [
          ve.reactServerComponents,
          ve.actionBrowser,
          ve.instrument,
          ve.middleware
        ],
        neutralTarget: [
          // pages api
          ve.apiNode,
          ve.apiEdge
        ],
        clientOnly: [
          ve.serverSideRendering,
          ve.appPagesBrowser
        ],
        bundled: [
          ve.reactServerComponents,
          ve.actionBrowser,
          ve.serverSideRendering,
          ve.appPagesBrowser,
          ve.shared,
          ve.instrument,
          ve.middleware
        ],
        appPages: [
          // app router pages and layouts
          ve.reactServerComponents,
          ve.serverSideRendering,
          ve.appPagesBrowser,
          ve.actionBrowser
        ]
      }
    }, Re = {
      edgeSSREntry: "__next_edge_ssr_entry__",
      metadata: "__next_metadata__",
      metadataRoute: "__next_metadata_route__",
      metadataImageMeta: "__next_metadata_image_meta__"
    };
  }(dO)), dO;
}
var _O = {}, ZU;
function tic() {
  return ZU || (ZU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "escapeStringRegexp", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = /[|\\{}()[\]^$+*?.-]/, n = /[|\\{}()[\]^$+*?.-]/g;
    function o(r) {
      return t.test(r) ? r.replace(n, "\\$&") : r;
    }
  }(_O)), _O;
}
var pO = {}, XU;
function nic() {
  return XU || (XU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      PARAMETER_PATTERN: function() {
        return o;
      },
      getDynamicParam: function() {
        return n;
      },
      parseMatchedParameter: function() {
        return i;
      },
      parseParameter: function() {
        return r;
      }
    });
    function n(a, s, c, l, u) {
      let d = a[s];
      if (u && u.has(s) ? d = u.get(s) : Array.isArray(d) ? d = d.map((_) => encodeURIComponent(_)) : typeof d == "string" && (d = encodeURIComponent(d)), !d) {
        const _ = c === "c", p = c === "oc";
        if (_ || p)
          return p ? {
            param: s,
            value: null,
            type: c,
            treeSegment: [
              s,
              "",
              c
            ]
          } : (d = l.split("/").slice(1).flatMap((g) => {
            const f = r(g);
            var h;
            return (h = a[f.key]) != null ? h : f.key;
          }), {
            param: s,
            value: d,
            type: c,
            // This value always has to be a string.
            treeSegment: [
              s,
              d.join("/"),
              c
            ]
          });
      }
      return {
        param: s,
        // The value that is passed to user code.
        value: d,
        // The value that is rendered in the router tree.
        treeSegment: [
          s,
          Array.isArray(d) ? d.join("/") : d,
          c
        ],
        type: c
      };
    }
    const o = /^([^[]*)\[((?:\[[^\]]*\])|[^\]]+)\](.*)$/;
    function r(a) {
      const s = a.match(o);
      return i(s ? s[2] : a);
    }
    function i(a) {
      const s = a.startsWith("[") && a.endsWith("]");
      s && (a = a.slice(1, -1));
      const c = a.startsWith("...");
      return c && (a = a.slice(3)), {
        key: a,
        repeat: c,
        optional: s
      };
    }
  }(pO)), pO;
}
var JU;
function Dae() {
  return JU || (JU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(g, f) {
      for (var h in f)
        Object.defineProperty(g, h, {
          enumerable: !0,
          get: f[h]
        });
    }
    t(e, {
      getNamedMiddlewareRegex: function() {
        return p;
      },
      getNamedRouteRegex: function() {
        return _;
      },
      getRouteRegex: function() {
        return c;
      }
    });
    const n = eic(), o = Rae(), r = tic(), i = Oae(), a = nic();
    function s(g, f, h) {
      const $ = {};
      let v = 1;
      const b = [];
      for (const y of (0, i.removeTrailingSlash)(g).slice(1).split("/")) {
        const w = o.INTERCEPTION_ROUTE_MARKERS.find((M) => y.startsWith(M)), N = y.match(a.PARAMETER_PATTERN);
        if (w && N && N[2]) {
          const { key: M, optional: q, repeat: L } = (0, a.parseMatchedParameter)(N[2]);
          $[M] = {
            pos: v++,
            repeat: L,
            optional: q
          }, b.push("/" + (0, r.escapeStringRegexp)(w) + "([^/]+?)");
        } else if (N && N[2]) {
          const { key: M, repeat: q, optional: L } = (0, a.parseMatchedParameter)(N[2]);
          $[M] = {
            pos: v++,
            repeat: q,
            optional: L
          }, h && N[1] && b.push("/" + (0, r.escapeStringRegexp)(N[1]));
          let R = q ? L ? "(?:/(.+?))?" : "/(.+?)" : "/([^/]+?)";
          h && N[1] && (R = R.substring(1)), b.push(R);
        } else
          b.push("/" + (0, r.escapeStringRegexp)(y));
        f && N && N[3] && b.push((0, r.escapeStringRegexp)(N[3]));
      }
      return {
        parameterizedRoute: b.join(""),
        groups: $
      };
    }
    function c(g, f) {
      let { includeSuffix: h = !1, includePrefix: $ = !1, excludeOptionalTrailingSlash: v = !1 } = f === void 0 ? {} : f;
      const { parameterizedRoute: b, groups: y } = s(g, h, $);
      let w = b;
      return v || (w += "(?:/)?"), {
        re: new RegExp("^" + w + "$"),
        groups: y
      };
    }
    function l() {
      let g = 0;
      return () => {
        let f = "", h = ++g;
        for (; h > 0; )
          f += String.fromCharCode(97 + (h - 1) % 26), h = Math.floor((h - 1) / 26);
        return f;
      };
    }
    function u(g) {
      let { interceptionMarker: f, getSafeRouteKey: h, segment: $, routeKeys: v, keyPrefix: b, backreferenceDuplicateKeys: y } = g;
      const { key: w, optional: N, repeat: M } = (0, a.parseMatchedParameter)($);
      let q = w.replace(/\W/g, "");
      b && (q = "" + b + q);
      let L = !1;
      (q.length === 0 || q.length > 30) && (L = !0), isNaN(parseInt(q.slice(0, 1))) || (L = !0), L && (q = h());
      const R = q in v;
      b ? v[q] = "" + b + w : v[q] = w;
      const T = f ? (0, r.escapeStringRegexp)(f) : "";
      let D;
      return R && y ? D = "\\k<" + q + ">" : M ? D = "(?<" + q + ">.+?)" : D = "(?<" + q + ">[^/]+?)", N ? "(?:/" + T + D + ")?" : "/" + T + D;
    }
    function d(g, f, h, $, v) {
      const b = l(), y = {}, w = [];
      for (const N of (0, i.removeTrailingSlash)(g).slice(1).split("/")) {
        const M = o.INTERCEPTION_ROUTE_MARKERS.some((L) => N.startsWith(L)), q = N.match(a.PARAMETER_PATTERN);
        if (M && q && q[2])
          w.push(u({
            getSafeRouteKey: b,
            interceptionMarker: q[1],
            segment: q[2],
            routeKeys: y,
            keyPrefix: f ? n.NEXT_INTERCEPTION_MARKER_PREFIX : void 0,
            backreferenceDuplicateKeys: v
          }));
        else if (q && q[2]) {
          $ && q[1] && w.push("/" + (0, r.escapeStringRegexp)(q[1]));
          let L = u({
            getSafeRouteKey: b,
            segment: q[2],
            routeKeys: y,
            keyPrefix: f ? n.NEXT_QUERY_PARAM_PREFIX : void 0,
            backreferenceDuplicateKeys: v
          });
          $ && q[1] && (L = L.substring(1)), w.push(L);
        } else
          w.push("/" + (0, r.escapeStringRegexp)(N));
        h && q && q[3] && w.push((0, r.escapeStringRegexp)(q[3]));
      }
      return {
        namedParameterizedRoute: w.join(""),
        routeKeys: y
      };
    }
    function _(g, f) {
      var h, $, v;
      const b = d(g, f.prefixRouteKeys, (h = f.includeSuffix) != null ? h : !1, ($ = f.includePrefix) != null ? $ : !1, (v = f.backreferenceDuplicateKeys) != null ? v : !1);
      let y = b.namedParameterizedRoute;
      return f.excludeOptionalTrailingSlash || (y += "(?:/)?"), {
        ...c(g, f),
        namedRegex: "^" + y + "$",
        routeKeys: b.routeKeys
      };
    }
    function p(g, f) {
      const { parameterizedRoute: h } = s(g, !1, !1), { catchAll: $ = !0 } = f;
      if (h === "/")
        return {
          namedRegex: "^/" + ($ ? ".*" : "") + "$"
        };
      const { namedParameterizedRoute: v } = d(g, !1, !1, !1, !1);
      let b = $ ? "(?:(/.*)?)" : "";
      return {
        namedRegex: "^" + v + b + "$"
      };
    }
  }(uO)), uO;
}
var QU;
function oic() {
  return QU || (QU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "interpolateAs", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = Pae(), n = Dae();
    function o(r, i, a) {
      let s = "";
      const c = (0, n.getRouteRegex)(r), l = c.groups, u = (
        // Try to match the dynamic route against the asPath
        (i !== r ? (0, t.getRouteMatcher)(c)(i) : "") || // Fall back to reading the values from the href
        // TODO: should this take priority; also need to change in the router.
        a
      );
      s = r;
      const d = Object.keys(l);
      return d.every((_) => {
        let p = u[_] || "";
        const { repeat: g, optional: f } = l[_];
        let h = "[" + (g ? "..." : "") + _ + "]";
        return f && (h = (p ? "" : "/") + "[" + h + "]"), g && !Array.isArray(p) && (p = [
          p
        ]), (f || _ in u) && // Interpolate group into data URL if present
        (s = s.replace(h, g ? p.map(
          // these values should be fully encoded instead of just
          // path delimiter escaped since they are being inserted
          // into the URL and we expect URL encoded segments
          // when parsing dynamic route params
          ($) => encodeURIComponent($)
        ).join("/") : encodeURIComponent(p)) || "/");
      }) || (s = ""), {
        params: d,
        result: s
      };
    }
  }(iO)), iO;
}
var eG;
function ric() {
  return eG || (eG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "resolveHref", {
      enumerable: !0,
      get: function() {
        return _;
      }
    });
    const n = Aae(), o = Iae(), r = Urc(), i = NT(), a = zT(), s = zae(), c = Zrc(), l = oic(), u = Dae(), d = Pae();
    function _(p, g, f) {
      let h, $ = typeof g == "string" ? g : (0, o.formatWithValidation)(g);
      const v = $.match(/^[a-z][a-z0-9+.-]*:\/\//i), b = v ? $.slice(v[0].length) : $;
      if ((b.split("?", 1)[0] || "").match(/(\/\/|\\)/)) {
        console.error("Invalid href '" + $ + "' passed to next/router in page: '" + p.pathname + "'. Repeated forward-slashes (//) or backslashes \\ are not valid in the href.");
        const w = (0, i.normalizeRepeatedSlashes)(b);
        $ = (v ? v[0] : "") + w;
      }
      if (!(0, s.isLocalURL)($))
        return f ? [
          $
        ] : $;
      try {
        let w = $.startsWith("#") ? p.asPath : p.pathname;
        if ($.startsWith("?") && (w = p.asPath, (0, c.isDynamicRoute)(p.pathname))) {
          w = p.pathname;
          const N = (0, u.getRouteRegex)(p.pathname);
          (0, d.getRouteMatcher)(N)(p.asPath) || (w = p.asPath);
        }
        h = new URL(w, "http://n");
      } catch {
        h = new URL("/", "http://n");
      }
      try {
        const w = new URL($, h);
        w.pathname = (0, a.normalizePathTrailingSlash)(w.pathname);
        let N = "";
        if ((0, c.isDynamicRoute)(w.pathname) && w.searchParams && f) {
          const q = (0, n.searchParamsToUrlQuery)(w.searchParams), { result: L, params: R } = (0, l.interpolateAs)(w.pathname, w.pathname, q);
          L && (N = (0, o.formatWithValidation)({
            pathname: L,
            hash: w.hash,
            query: (0, r.omit)(q, R)
          }));
        }
        const M = w.origin === h.origin ? w.href.slice(w.origin.length) : w.href;
        return f ? [
          M,
          N || M
        ] : M;
      } catch {
        return f ? [
          $
        ] : $;
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(oS, oS.exports)), oS.exports;
}
var aS = { exports: {} }, mO = {}, fO = {}, tG;
function Lae() {
  return tG || (tG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addPathPrefix", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = W6();
    function n(o, r) {
      if (!o.startsWith("/") || !r)
        return o;
      const { pathname: i, query: a, hash: s } = (0, t.parsePath)(o);
      return "" + r + i + a + s;
    }
  }(fO)), fO;
}
var nG;
function iic() {
  return nG || (nG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addLocale", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = Lae(), n = Nae();
    function o(r, i, a, s) {
      if (!i || i === a)
        return r;
      const c = r.toLowerCase();
      return !s && ((0, n.pathHasPrefix)(c, "/api") || (0, n.pathHasPrefix)(c, "/" + i.toLowerCase())) ? r : (0, t.addPathPrefix)(r, "/" + i);
    }
  }(mO)), mO;
}
var oG;
function aic() {
  return oG || (oG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addLocale", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const n = zT(), o = function(r) {
      for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
        a[s - 1] = arguments[s];
      return process.env.__NEXT_I18N_SUPPORT ? (0, n.normalizePathTrailingSlash)(iic().addLocale(r, ...a)) : r;
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(aS, aS.exports)), aS.exports;
}
var gO = {}, qg = {};
function sic(e) {
  return e && e.__esModule ? e : { default: e };
}
qg._ = sic;
var rG;
function cic() {
  return rG || (rG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "RouterContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (/* @__PURE__ */ qg._(Fe)).default.createContext(null);
    process.env.NODE_ENV !== "production" && (o.displayName = "RouterContext");
  }(gO)), gO;
}
var sS = { exports: {} }, cS = { exports: {} }, iG;
function Mae() {
  return iG || (iG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, a) {
      for (var s in a)
        Object.defineProperty(i, s, {
          enumerable: !0,
          get: a[s]
        });
    }
    n(t, {
      cancelIdleCallback: function() {
        return r;
      },
      requestIdleCallback: function() {
        return o;
      }
    });
    const o = typeof self < "u" && self.requestIdleCallback && self.requestIdleCallback.bind(window) || function(i) {
      let a = Date.now();
      return self.setTimeout(function() {
        i({
          didTimeout: !1,
          timeRemaining: function() {
            return Math.max(0, 50 - (Date.now() - a));
          }
        });
      }, 1);
    }, r = typeof self < "u" && self.cancelIdleCallback && self.cancelIdleCallback.bind(window) || function(i) {
      return clearTimeout(i);
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(cS, cS.exports)), cS.exports;
}
var aG;
function lic() {
  return aG || (aG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "useIntersection", {
      enumerable: !0,
      get: function() {
        return l;
      }
    });
    const n = Fe, o = Mae(), r = typeof IntersectionObserver == "function", i = /* @__PURE__ */ new Map(), a = [];
    function s(u) {
      const d = {
        root: u.root || null,
        margin: u.rootMargin || ""
      }, _ = a.find((h) => h.root === d.root && h.margin === d.margin);
      let p;
      if (_ && (p = i.get(_), p))
        return p;
      const g = /* @__PURE__ */ new Map(), f = new IntersectionObserver((h) => {
        h.forEach(($) => {
          const v = g.get($.target), b = $.isIntersecting || $.intersectionRatio > 0;
          v && b && v(b);
        });
      }, u);
      return p = {
        id: d,
        observer: f,
        elements: g
      }, a.push(d), i.set(d, p), p;
    }
    function c(u, d, _) {
      const { id: p, observer: g, elements: f } = s(_);
      return f.set(u, d), g.observe(u), function() {
        if (f.delete(u), g.unobserve(u), f.size === 0) {
          g.disconnect(), i.delete(p);
          const $ = a.findIndex((v) => v.root === p.root && v.margin === p.margin);
          $ > -1 && a.splice($, 1);
        }
      };
    }
    function l(u) {
      let { rootRef: d, rootMargin: _, disabled: p } = u;
      const g = p || !r, [f, h] = (0, n.useState)(!1), $ = (0, n.useRef)(null), v = (0, n.useCallback)((y) => {
        $.current = y;
      }, []);
      (0, n.useEffect)(() => {
        if (r) {
          if (g || f)
            return;
          const y = $.current;
          if (y && y.tagName)
            return c(y, (N) => N && h(N), {
              root: d == null ? void 0 : d.current,
              rootMargin: _
            });
        } else if (!f) {
          const y = (0, o.requestIdleCallback)(() => h(!0));
          return () => (0, o.cancelIdleCallback)(y);
        }
      }, [
        g,
        _,
        d,
        f,
        $.current
      ]);
      const b = (0, n.useCallback)(() => {
        h(!1);
      }, []);
      return [
        v,
        f,
        b
      ];
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(sS, sS.exports)), sS.exports;
}
var lS = { exports: {} }, uS = { exports: {} }, hO = {}, sG;
function uic() {
  return sG || (sG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = /* @__PURE__ */ new WeakMap();
    function n(o, r) {
      if (!r)
        return {
          pathname: o
        };
      let i = t.get(r);
      i || (i = r.map((u) => u.toLowerCase()), t.set(r, i));
      let a;
      const s = o.split("/", 2);
      if (!s[1])
        return {
          pathname: o
        };
      const c = s[1].toLowerCase(), l = i.indexOf(c);
      return l < 0 ? {
        pathname: o
      } : (a = r[l], o = o.slice(a.length + 1) || "/", {
        pathname: o,
        detectedLocale: a
      });
    }
  }(hO)), hO;
}
var cG;
function dic() {
  return cG || (cG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (o, r) => process.env.__NEXT_I18N_SUPPORT ? uic().normalizeLocalePath(o, r) : {
      pathname: o,
      detectedLocale: void 0
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(uS, uS.exports)), uS.exports;
}
var dS = { exports: {} }, vO = {}, lG;
function _ic() {
  return lG || (lG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n, o, r) {
      if (n) {
        r && (r = r.toLowerCase());
        for (const s of n) {
          var i, a;
          const c = (i = s.domain) == null ? void 0 : i.split(":", 1)[0].toLowerCase();
          if (o === c || r === s.defaultLocale.toLowerCase() || (a = s.locales) != null && a.some((l) => l.toLowerCase() === r))
            return s;
        }
      }
    }
  }(vO)), vO;
}
var uG;
function pic() {
  return uG || (uG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = function() {
      for (var o = arguments.length, r = new Array(o), i = 0; i < o; i++)
        r[i] = arguments[i];
      if (process.env.__NEXT_I18N_SUPPORT)
        return _ic().detectDomainLocale(...r);
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(dS, dS.exports)), dS.exports;
}
var dG;
function mic() {
  return dG || (dG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "getDomainLocale", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = zT(), o = process.env.__NEXT_ROUTER_BASEPATH || "";
    function r(i, a, s, c) {
      if (process.env.__NEXT_I18N_SUPPORT) {
        const l = dic().normalizeLocalePath, u = pic().detectDomainLocale, d = a || l(i, s).detectedLocale, _ = u(c, void 0, d);
        if (_) {
          const p = "http" + (_.http ? "" : "s") + "://", g = d === _.defaultLocale ? "" : "/" + d;
          return "" + p + _.domain + (0, n.normalizePathTrailingSlash)("" + o + g + i);
        }
        return !1;
      } else
        return !1;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(lS, lS.exports)), lS.exports;
}
var _S = { exports: {} }, _G;
function fic() {
  return _G || (_G = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addBasePath", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const n = Lae(), o = zT(), r = process.env.__NEXT_ROUTER_BASEPATH || "";
    function i(a, s) {
      return (0, o.normalizePathTrailingSlash)(process.env.__NEXT_MANUAL_CLIENT_BASE_PATH && !s ? a : (0, n.addPathPrefix)(a, r));
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(_S, _S.exports)), _S.exports;
}
var pS = { exports: {} }, pG;
function gic() {
  return pG || (pG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "useMergedRef", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const n = Fe;
    function o(i, a) {
      const s = (0, n.useRef)(null), c = (0, n.useRef)(null);
      return (0, n.useCallback)((l) => {
        if (l === null) {
          const u = s.current;
          u && (s.current = null, u());
          const d = c.current;
          d && (c.current = null, d());
        } else
          i && (s.current = r(i, l)), a && (c.current = r(a, l));
      }, [
        i,
        a
      ]);
    }
    function r(i, a) {
      if (typeof i == "function") {
        const s = i(a);
        return typeof s == "function" ? s : () => i(null);
      } else
        return i.current = a, () => {
          i.current = null;
        };
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(pS, pS.exports)), pS.exports;
}
var bO = {}, mG;
function hic() {
  return mG || (mG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "errorOnce", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    let t = (n) => {
    };
    if (process.env.NODE_ENV !== "production") {
      const n = /* @__PURE__ */ new Set();
      t = (o) => {
        n.has(o) || console.error(o), n.add(o);
      };
    }
  }(bO)), bO;
}
(function(e, t) {
  "use client";
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(R, T) {
    for (var D in T)
      Object.defineProperty(R, D, {
        enumerable: !0,
        get: T[D]
      });
  }
  n(t, {
    default: function() {
      return L;
    },
    useLinkStatus: function() {
      return q;
    }
  });
  const o = R0, r = gT, i = /* @__PURE__ */ o._(Fe), a = ric(), s = zae(), c = Iae(), l = NT(), u = aic(), d = cic(), _ = lic(), p = mic(), g = fic(), f = gic(), h = hic(), $ = /* @__PURE__ */ new Set();
  function v(R, T, D, A) {
    if (!(typeof window > "u") && (0, s.isLocalURL)(T)) {
      if (!A.bypassPrefetchedCheck) {
        const S = (
          // Let the link's locale prop override the default router locale.
          typeof A.locale < "u" ? A.locale : "locale" in R ? R.locale : void 0
        ), E = T + "%" + D + "%" + S;
        if ($.has(E))
          return;
        $.add(E);
      }
      R.prefetch(T, D, A).catch((S) => {
        if (process.env.NODE_ENV !== "production")
          throw S;
      });
    }
  }
  function b(R) {
    const D = R.currentTarget.getAttribute("target");
    return D && D !== "_self" || R.metaKey || R.ctrlKey || R.shiftKey || R.altKey || // triggers resource download
    R.nativeEvent && R.nativeEvent.which === 2;
  }
  function y(R, T, D, A, S, E, x, k, I) {
    const { nodeName: z } = R.currentTarget;
    if (z.toUpperCase() === "A" && b(R) || R.currentTarget.hasAttribute("download"))
      return;
    if (!(0, s.isLocalURL)(D)) {
      S && (R.preventDefault(), location.replace(D));
      return;
    }
    R.preventDefault(), (() => {
      if (I) {
        let V = !1;
        if (I({
          preventDefault: () => {
            V = !0;
          }
        }), V)
          return;
      }
      const O = x ?? !0;
      "beforePopState" in T ? T[S ? "replace" : "push"](D, A, {
        shallow: E,
        locale: k,
        scroll: O
      }) : T[S ? "replace" : "push"](A || D, {
        scroll: O
      });
    })();
  }
  function w(R) {
    return typeof R == "string" ? R : (0, c.formatUrl)(R);
  }
  const N = /* @__PURE__ */ i.default.forwardRef(function(T, D) {
    let A;
    const { href: S, as: E, children: x, prefetch: k = null, passHref: I, replace: z, shallow: F, scroll: P, locale: O, onClick: V, onNavigate: U, onMouseEnter: H, onTouchStart: J, legacyBehavior: le = !1, ...ae } = T;
    A = x, le && (typeof A == "string" || typeof A == "number") && (A = /* @__PURE__ */ (0, r.jsx)("a", {
      children: A
    }));
    const Y = i.default.useContext(d.RouterContext), re = k !== !1;
    if (process.env.NODE_ENV !== "production") {
      let Me = function(Pe) {
        return Object.defineProperty(new Error("Failed prop type: The prop `" + Pe.key + "` expects a " + Pe.expected + " in `<Link>`, but got `" + Pe.actual + "` instead." + (typeof window < "u" ? `
Open your browser's console to view the Component stack trace.` : "")), "__NEXT_ERROR_CODE", {
          value: "E319",
          enumerable: !1,
          configurable: !0
        });
      };
      Object.keys({
        href: !0
      }).forEach((Pe) => {
        if (Pe === "href" && (T[Pe] == null || typeof T[Pe] != "string" && typeof T[Pe] != "object"))
          throw Me({
            key: Pe,
            expected: "`string` or `object`",
            actual: T[Pe] === null ? "null" : typeof T[Pe]
          });
      }), Object.keys({
        as: !0,
        replace: !0,
        scroll: !0,
        shallow: !0,
        passHref: !0,
        prefetch: !0,
        locale: !0,
        onClick: !0,
        onMouseEnter: !0,
        onTouchStart: !0,
        legacyBehavior: !0,
        onNavigate: !0
      }).forEach((Pe) => {
        const je = typeof T[Pe];
        if (Pe === "as") {
          if (T[Pe] && je !== "string" && je !== "object")
            throw Me({
              key: Pe,
              expected: "`string` or `object`",
              actual: je
            });
        } else if (Pe === "locale") {
          if (T[Pe] && je !== "string")
            throw Me({
              key: Pe,
              expected: "`string`",
              actual: je
            });
        } else if (Pe === "onClick" || Pe === "onMouseEnter" || Pe === "onTouchStart" || Pe === "onNavigate") {
          if (T[Pe] && je !== "function")
            throw Me({
              key: Pe,
              expected: "`function`",
              actual: je
            });
        } else if (Pe === "replace" || Pe === "scroll" || Pe === "shallow" || Pe === "passHref" || Pe === "legacyBehavior") {
          if (T[Pe] != null && je !== "boolean")
            throw Me({
              key: Pe,
              expected: "`boolean`",
              actual: je
            });
        } else if (Pe === "prefetch" && T[Pe] != null && je !== "boolean" && T[Pe] !== "auto")
          throw Me({
            key: Pe,
            expected: '`boolean | "auto"`',
            actual: je
          });
      });
    }
    const { href: ie, as: _e } = i.default.useMemo(() => {
      if (!Y) {
        const st = w(S);
        return {
          href: st,
          as: E ? w(E) : st
        };
      }
      const [Me, et] = (0, a.resolveHref)(Y, S, !0);
      return {
        href: Me,
        as: E ? (0, a.resolveHref)(Y, E) : et || Me
      };
    }, [
      Y,
      S,
      E
    ]), he = i.default.useRef(ie), be = i.default.useRef(_e);
    let Q;
    if (le)
      if (process.env.NODE_ENV === "development") {
        V && console.warn('"onClick" was passed to <Link> with `href` of `' + S + '` but "legacyBehavior" was set. The legacy behavior requires onClick be set on the child of next/link'), H && console.warn('"onMouseEnter" was passed to <Link> with `href` of `' + S + '` but "legacyBehavior" was set. The legacy behavior requires onMouseEnter be set on the child of next/link');
        try {
          Q = i.default.Children.only(A);
        } catch {
          throw A ? Object.defineProperty(new Error("Multiple children were passed to <Link> with `href` of `" + S + "` but only one child is supported https://nextjs.org/docs/messages/link-multiple-children" + (typeof window < "u" ? ` 
Open your browser's console to view the Component stack trace.` : "")), "__NEXT_ERROR_CODE", {
            value: "E266",
            enumerable: !1,
            configurable: !0
          }) : Object.defineProperty(new Error("No children were passed to <Link> with `href` of `" + S + "` but one child is required https://nextjs.org/docs/messages/link-no-children"), "__NEXT_ERROR_CODE", {
            value: "E320",
            enumerable: !1,
            configurable: !0
          });
        }
      } else
        Q = i.default.Children.only(A);
    else if (process.env.NODE_ENV === "development" && (A == null ? void 0 : A.type) === "a")
      throw Object.defineProperty(new Error(`Invalid <Link> with <a> child. Please remove <a> or use <Link legacyBehavior>.
Learn more: https://nextjs.org/docs/messages/invalid-new-link-with-extra-anchor`), "__NEXT_ERROR_CODE", {
        value: "E209",
        enumerable: !1,
        configurable: !0
      });
    const me = le ? Q && typeof Q == "object" && Q.ref : D, [ne, pe, ge] = (0, _.useIntersection)({
      rootMargin: "200px"
    }), ve = i.default.useCallback((Me) => {
      (be.current !== _e || he.current !== ie) && (ge(), be.current = _e, he.current = ie), ne(Me);
    }, [
      _e,
      ie,
      ge,
      ne
    ]), Te = (0, f.useMergedRef)(ve, me);
    i.default.useEffect(() => {
      process.env.NODE_ENV === "production" && Y && (!pe || !re || v(Y, ie, _e, {
        locale: O
      }));
    }, [
      _e,
      ie,
      pe,
      O,
      re,
      Y == null ? void 0 : Y.locale,
      Y
    ]);
    const Re = {
      ref: Te,
      onClick(Me) {
        if (process.env.NODE_ENV !== "production" && !Me)
          throw Object.defineProperty(new Error('Component rendered inside next/link has to pass click event to "onClick" prop.'), "__NEXT_ERROR_CODE", {
            value: "E312",
            enumerable: !1,
            configurable: !0
          });
        !le && typeof V == "function" && V(Me), le && Q.props && typeof Q.props.onClick == "function" && Q.props.onClick(Me), Y && (Me.defaultPrevented || y(Me, Y, ie, _e, z, F, P, O, U));
      },
      onMouseEnter(Me) {
        !le && typeof H == "function" && H(Me), le && Q.props && typeof Q.props.onMouseEnter == "function" && Q.props.onMouseEnter(Me), Y && v(Y, ie, _e, {
          locale: O,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        });
      },
      onTouchStart: process.env.__NEXT_LINK_NO_TOUCH_START ? void 0 : function(et) {
        !le && typeof J == "function" && J(et), le && Q.props && typeof Q.props.onTouchStart == "function" && Q.props.onTouchStart(et), Y && v(Y, ie, _e, {
          locale: O,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        });
      }
    };
    if ((0, l.isAbsoluteUrl)(_e))
      Re.href = _e;
    else if (!le || I || Q.type === "a" && !("href" in Q.props)) {
      const Me = typeof O < "u" ? O : Y == null ? void 0 : Y.locale, et = (Y == null ? void 0 : Y.isLocaleDomain) && (0, p.getDomainLocale)(_e, Me, Y == null ? void 0 : Y.locales, Y == null ? void 0 : Y.domainLocales);
      Re.href = et || (0, g.addBasePath)((0, u.addLocale)(_e, Me, Y == null ? void 0 : Y.defaultLocale));
    }
    return le ? (process.env.NODE_ENV === "development" && (0, h.errorOnce)(`\`legacyBehavior\` is deprecated and will be removed in a future release. A codemod is available to upgrade your components:

npx @next/codemod@latest new-link .

Learn more: https://nextjs.org/docs/app/building-your-application/upgrading/codemods#remove-a-tags-from-link-components`), /* @__PURE__ */ i.default.cloneElement(Q, Re)) : /* @__PURE__ */ (0, r.jsx)("a", {
      ...ae,
      ...Re,
      children: A
    });
  }), M = /* @__PURE__ */ (0, i.createContext)({
    // We do not support link status in the Pages Router, so we always return false
    pending: !1
  }), q = () => (0, i.useContext)(M), L = N;
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(wM, wM.exports);
var vic = wM.exports, bic = vic;
const Ir = /* @__PURE__ */ Mi(bic);
function Sr({
  children: e,
  content: t,
  open: n,
  defaultOpen: o,
  onOpenChange: r,
  delayDuration: i,
  side: a = "top",
  ...s
}) {
  const c = /* @__PURE__ */ m(
    hCe,
    {
      ...s,
      className: xe(
        "calcom-tooltip",
        a === "top" && "-mt-7",
        a === "right" && "ml-2",
        "bg-inverted text-inverted relative z-50 rounded-md px-2 py-1 text-xs font-semibold shadow-lg",
        s.className && `${s.className}`
      ),
      side: a,
      align: "center",
      children: t
    }
  );
  return /* @__PURE__ */ de(
    vCe,
    {
      delayDuration: i || 50,
      open: n,
      defaultOpen: o,
      onOpenChange: r,
      children: [
        /* @__PURE__ */ m(fCe, { asChild: !0, children: e }),
        /* @__PURE__ */ m(mCe, { children: c })
      ]
    }
  );
}
const Ix = Vy(
  "group whitespace-nowrap inline-flex items-center text-sm font-medium relative rounded-[10px] transition disabled:cursor-not-allowed gap-1",
  {
    variants: {
      variant: {
        button: "",
        icon: "flex justify-center",
        fab: "min-w-14 min-h-14 md:min-w-min md:min-h-min rounded-full justify-center md:rounded-[10px] radix-state-open:rotate-45 md:radix-state-open:rotate-0 radix-state-open:shadown-none radix-state-open:ring-0"
      },
      color: {
        primary: [
          // Base colors
          "bg-brand-default",
          "text-brand",
          // Hover state
          "enabled:hover:bg-brand-emphasis",
          // Focus state
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:shadow-button-solid-brand-focused",
          // Border
          "border border-brand-default",
          // Disabled
          "disabled:opacity-30",
          // Shadows and effects
          "shadow-button-solid-brand-default",
          "enabled:active:shadow-button-solid-brand-active",
          "enabled:hover:shadow-button-solid-brand-hover",
          "transition-shadow",
          "transition-transform",
          "duration-100"
        ],
        secondary: [
          // Base colors and border
          "bg-default",
          "text-default",
          "border",
          "border-default",
          // Hover state
          "enabled:hover:bg-muted",
          "enabled:hover:text-emphasis",
          // Disabled
          "disabled:opacity-30",
          // Focus state
          "focus-visible:bg-subtle",
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:shadow-outline-gray-focused",
          // Shadows and effects
          "shadow-outline-gray-rested",
          "enabled:hover:shadow-outline-gray-hover",
          "enabled:active:shadow-outline-gray-active",
          "transition-shadow",
          "duration-200"
        ],
        minimal: [
          // Base color
          "text-subtle",
          "border border-transparent",
          // Hover
          "enabled:hover:bg-subtle",
          "enabled:hover:text-emphasis",
          "enabled:hover:border-subtle hover:border",
          // Disabled
          "disabled:opacity-30",
          // Focus
          "focus-visible:bg-subtle",
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:border-subtle",
          "focus-visible:shadow-button-outline-gray-focused",
          // Shadows and effects
          "enabled:active:shadow-outline-gray-active",
          "transition-shadow",
          "duration-200"
        ],
        destructive: [
          // Base colors and border
          "border",
          "border-default",
          "text-error",
          // Hover state
          "dark:hover:text-red-100",
          "hover:border-semantic-error",
          "hover:bg-error",
          // Focus state
          "focus-visible:text-red-700",
          "focus-visible:bg-error",
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:shadow-button-outline-red-focused",
          // Disabled state
          "disabled:bg-red-100",
          "disabled:border-red-200",
          "disabled:text-red-700",
          "disabled:hover:border-red-200",
          "disabled:opacity-30",
          // Shadows and effects
          "shadow-outline-red-rested",
          "enabled:hover:shadow-outline-red-hover",
          "enabled:active:shadow-outline-red-active",
          "transition-shadow",
          "duration-200"
        ]
      },
      size: {
        xs: "h-6 p-2 leading-none text-xs rounded-md",
        sm: "h-7 px-2 py-1.5 leading-none text-sm",
        base: "px-2.5 py-2 text-sm leading-none",
        lg: "px-3 py-2.5 "
      },
      loading: {
        true: "cursor-wait"
      }
    },
    compoundVariants: [
      // Primary variants
      {
        loading: !0,
        color: "primary",
        className: "opacity-30"
      },
      // Secondary variants
      {
        loading: !0,
        color: "secondary",
        className: "bg-subtle text-emphasis/80"
      },
      // Minimal variants
      {
        loading: !0,
        color: "minimal",
        className: "bg-subtle text-emphasis/30"
      },
      // Destructive variants
      {
        loading: !0,
        color: "destructive",
        className: "text-red-700/30 dark:text-red-700/30 hover:text-red-700/30  border border-default text-emphasis"
      },
      {
        variant: "icon",
        size: "base",
        className: "min-h-[36px] min-w-[36px] !p-2 hover:border-default"
      },
      {
        variant: "icon",
        size: "xs",
        className: "h-5 w-5 !p-1 rounded-md"
      },
      {
        variant: "icon",
        size: "sm",
        className: "h-6 w-6 !p-1 rounded-md"
      },
      {
        variant: "icon",
        size: "lg",
        className: "h-10 w-10 !p-1"
      },
      {
        variant: "fab",
        size: "base",
        className: "md:px-4 md:py-2.5"
      }
    ],
    defaultVariants: {
      variant: "button",
      color: "primary",
      size: "base"
    }
  }
), Jt = Bt(function(t, n) {
  const {
    loading: o = !1,
    color: r = "primary",
    size: i,
    variant: a = "button",
    type: s = "button",
    tooltipSide: c = "top",
    tooltipOffset: l = 4,
    tooltipClassName: u,
    StartIcon: d,
    CustomStartIcon: _,
    EndIcon: p,
    shallow: g,
    // attributes propagated from `HTMLAnchorProps` or `HTMLButtonProps`
    ...f
  } = t, h = t.disabled || o, $ = typeof t.href < "u", v = $ ? "a" : "button", b = Fe.createElement(
    v,
    {
      ...f,
      disabled: h,
      type: $ ? void 0 : s,
      ref: n,
      className: xe(Ix({ color: r, size: i, loading: o, variant: a }), t.className),
      // if we click a disabled button, we prevent going through the click handler
      onClick: h ? (y) => {
        y.preventDefault();
      } : t.onClick
    },
    /* @__PURE__ */ de(nt, { children: [
      _ || d && /* @__PURE__ */ m(nt, { children: a === "fab" ? /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(qt, { name: d, className: "hidden h-4 w-4 stroke-[1.5px]  md:inline-flex" }),
        /* @__PURE__ */ m(qt, { name: "plus", "data-testid": "plus", className: "inline h-6 w-6 md:hidden" })
      ] }) : /* @__PURE__ */ m(
        qt,
        {
          "data-name": "start-icon",
          name: d,
          className: xe(
            o ? "invisible" : "visible",
            "button-icon group-active:translate-y-[0.5px]",
            a === "icon" && "h-4 w-4",
            a === "button" && "h-4 w-4 stroke-[1.5px] "
          )
        }
      ) }),
      /* @__PURE__ */ m(
        "div",
        {
          className: xe(
            "contents",
            // This makes the div behave like it doesn't exist in the layout
            o ? "invisible" : "visible",
            a === "fab" ? "hidden md:contents" : "",
            "group-active:translate-y-[0.5px]"
          ),
          children: t.children
        }
      ),
      o && /* @__PURE__ */ m("div", { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform", children: /* @__PURE__ */ de(
        "svg",
        {
          className: xe(
            "mx-4 h-5 w-5 animate-spin",
            r === "primary" ? "text-inverted" : "text-emphasis"
          ),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [
            /* @__PURE__ */ m("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            /* @__PURE__ */ m(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      ) }),
      p && /* @__PURE__ */ m(nt, { children: a === "fab" ? /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(qt, { name: p, className: "-mr-1 me-2 ms-2 hidden h-5 w-5 md:inline" }),
        /* @__PURE__ */ m(qt, { name: "plus", "data-testid": "plus", className: "inline h-6 w-6 md:hidden" })
      ] }) : /* @__PURE__ */ m(
        qt,
        {
          name: p,
          className: xe(
            o ? "invisible" : "visible",
            "group-active:translate-y-[0.5px]",
            a === "icon" && "h-4 w-4",
            a === "button" && "h-4 w-4 stroke-[1.5px] "
          )
        }
      ) })
    ] })
  );
  return t.href ? /* @__PURE__ */ m(Ir, { "data-testid": "link-component", passHref: !0, href: t.href, shallow: g && g, legacyBehavior: !0, children: b }) : /* @__PURE__ */ m(
    yic,
    {
      "data-testid": "wrapper",
      tooltip: t.tooltip,
      tooltipSide: c,
      tooltipOffset: l,
      tooltipClassName: u,
      children: b
    }
  );
}), yic = ({
  children: e,
  tooltip: t,
  tooltipSide: n,
  tooltipOffset: o,
  tooltipClassName: r
}) => t ? /* @__PURE__ */ m(
  Sr,
  {
    "data-testid": "tooltip",
    className: r,
    content: t,
    side: n,
    sideOffset: o,
    children: e
  }
) : /* @__PURE__ */ m(nt, { children: e });
Jt.displayName = "Button";
const $ic = /* @__PURE__ */ Cr(void 0);
function wic(e) {
  const t = bo($ic);
  return e || t || "ltr";
}
let yO = 0;
function Y6() {
  yt(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : fG()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : fG()), yO++, () => {
      yO === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (o) => o.remove()
      ), yO--;
    };
  }, []);
}
function fG() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const $O = "focusScope.autoFocusOnMount", wO = "focusScope.autoFocusOnUnmount", gG = {
  bubbles: !1,
  cancelable: !0
}, K6 = /* @__PURE__ */ Bt((e, t) => {
  const { loop: n = !1, trapped: o = !1, onMountAutoFocus: r, onUnmountAutoFocus: i, ...a } = e, [s, c] = it(null), l = ws(r), u = ws(i), d = xt(null), _ = ni(
    t,
    (f) => c(f)
  ), p = xt({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  yt(() => {
    if (o) {
      let f = function(b) {
        if (p.paused || !s)
          return;
        const y = b.target;
        s.contains(y) ? d.current = y : Kf(d.current, {
          select: !0
        });
      }, h = function(b) {
        if (p.paused || !s)
          return;
        const y = b.relatedTarget;
        y !== null && (s.contains(y) || Kf(d.current, {
          select: !0
        }));
      }, $ = function(b) {
        const y = document.activeElement;
        for (const w of b)
          w.removedNodes.length > 0 && (s != null && s.contains(y) || Kf(s));
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", h);
      const v = new MutationObserver($);
      return s && v.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", h), v.disconnect();
      };
    }
  }, [
    o,
    s,
    p.paused
  ]), yt(() => {
    if (s) {
      vG.add(p);
      const f = document.activeElement;
      if (!s.contains(f)) {
        const $ = new CustomEvent($O, gG);
        s.addEventListener($O, l), s.dispatchEvent($), $.defaultPrevented || (kic(Tic(Fae(s)), {
          select: !0
        }), document.activeElement === f && Kf(s));
      }
      return () => {
        s.removeEventListener($O, l), setTimeout(() => {
          const $ = new CustomEvent(wO, gG);
          s.addEventListener(wO, u), s.dispatchEvent($), $.defaultPrevented || Kf(f ?? document.body, {
            select: !0
          }), s.removeEventListener(wO, u), vG.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    l,
    u,
    p
  ]);
  const g = Yt((f) => {
    if (!n && !o || p.paused)
      return;
    const h = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, $ = document.activeElement;
    if (h && $) {
      const v = f.currentTarget, [b, y] = Sic(v);
      b && y ? !f.shiftKey && $ === y ? (f.preventDefault(), n && Kf(b, {
        select: !0
      })) : f.shiftKey && $ === b && (f.preventDefault(), n && Kf(y, {
        select: !0
      })) : $ === v && f.preventDefault();
    }
  }, [
    n,
    o,
    p.paused
  ]);
  return /* @__PURE__ */ pt(nr.div, Tt({
    tabIndex: -1
  }, a, {
    ref: _,
    onKeyDown: g
  }));
});
function kic(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Kf(o, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Sic(e) {
  const t = Fae(e), n = hG(t, e), o = hG(t.reverse(), e);
  return [
    n,
    o
  ];
}
function Fae(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function hG(e, t) {
  for (const n of e)
    if (!Eic(n, {
      upTo: t
    }))
      return n;
}
function Eic(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function xic(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Kf(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && xic(e) && t && e.select();
  }
}
const vG = Cic();
function Cic() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = bG(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = bG(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function bG(e, t) {
  const n = [
    ...e
  ], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Tic(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Aic = /* @__PURE__ */ Cr(void 0);
function Iic(e) {
  const t = bo(Aic);
  return e || t || "ltr";
}
const kO = "rovingFocusGroup.onEntryFocus", Oic = {
  bubbles: !1,
  cancelable: !0
}, Z6 = "RovingFocusGroup", [kM, qae, Nic] = V6(Z6), [zic, By] = jc(Z6, [
  Nic
]), [Ric, Pic] = zic(Z6), Dic = /* @__PURE__ */ Bt((e, t) => /* @__PURE__ */ pt(kM.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ pt(kM.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ pt(Lic, Tt({}, e, {
  ref: t
}))))), Lic = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: o, loop: r = !1, dir: i, currentTabStopId: a, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: l, ...u } = e, d = xt(null), _ = ni(t, d), p = Iic(i), [g = null, f] = Uu({
    prop: a,
    defaultProp: s,
    onChange: c
  }), [h, $] = it(!1), v = ws(l), b = qae(n), y = xt(!1), [w, N] = it(0);
  return yt(() => {
    const M = d.current;
    if (M)
      return M.addEventListener(kO, v), () => M.removeEventListener(kO, v);
  }, [
    v
  ]), /* @__PURE__ */ pt(Ric, {
    scope: n,
    orientation: o,
    dir: p,
    loop: r,
    currentTabStopId: g,
    onItemFocus: Yt(
      (M) => f(M),
      [
        f
      ]
    ),
    onItemShiftTab: Yt(
      () => $(!0),
      []
    ),
    onFocusableItemAdd: Yt(
      () => N(
        (M) => M + 1
      ),
      []
    ),
    onFocusableItemRemove: Yt(
      () => N(
        (M) => M - 1
      ),
      []
    )
  }, /* @__PURE__ */ pt(nr.div, Tt({
    tabIndex: h || w === 0 ? -1 : 0,
    "data-orientation": o
  }, u, {
    ref: _,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: jn(e.onMouseDown, () => {
      y.current = !0;
    }),
    onFocus: jn(e.onFocus, (M) => {
      const q = !y.current;
      if (M.target === M.currentTarget && q && !h) {
        const L = new CustomEvent(kO, Oic);
        if (M.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
          const R = b().filter(
            (E) => E.focusable
          ), T = R.find(
            (E) => E.active
          ), D = R.find(
            (E) => E.id === g
          ), S = [
            T,
            D,
            ...R
          ].filter(Boolean).map(
            (E) => E.ref.current
          );
          jae(S);
        }
      }
      y.current = !1;
    }),
    onBlur: jn(
      e.onBlur,
      () => $(!1)
    )
  })));
}), Mic = "RovingFocusGroupItem", Fic = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: o = !0, active: r = !1, tabStopId: i, ...a } = e, s = Pu(), c = i || s, l = Pic(Mic, n), u = l.currentTabStopId === c, d = qae(n), { onFocusableItemAdd: _, onFocusableItemRemove: p } = l;
  return yt(() => {
    if (o)
      return _(), () => p();
  }, [
    o,
    _,
    p
  ]), /* @__PURE__ */ pt(kM.ItemSlot, {
    scope: n,
    id: c,
    focusable: o,
    active: r
  }, /* @__PURE__ */ pt(nr.span, Tt({
    tabIndex: u ? 0 : -1,
    "data-orientation": l.orientation
  }, a, {
    ref: t,
    onMouseDown: jn(e.onMouseDown, (g) => {
      o ? l.onItemFocus(c) : g.preventDefault();
    }),
    onFocus: jn(
      e.onFocus,
      () => l.onItemFocus(c)
    ),
    onKeyDown: jn(e.onKeyDown, (g) => {
      if (g.key === "Tab" && g.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (g.target !== g.currentTarget)
        return;
      const f = Vic(g, l.orientation, l.dir);
      if (f !== void 0) {
        g.preventDefault();
        let $ = d().filter(
          (v) => v.focusable
        ).map(
          (v) => v.ref.current
        );
        if (f === "last")
          $.reverse();
        else if (f === "prev" || f === "next") {
          f === "prev" && $.reverse();
          const v = $.indexOf(g.currentTarget);
          $ = l.loop ? Bic($, v + 1) : $.slice(v + 1);
        }
        setTimeout(
          () => jae($)
        );
      }
    })
  })));
}), qic = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function jic(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Vic(e, t, n) {
  const o = jic(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(o)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(o)))
    return qic[o];
}
function jae(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Bic(e, t) {
  return e.map(
    (n, o) => e[(t + o) % e.length]
  );
}
const X6 = Dic, J6 = Fic;
var Uic = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, nb = /* @__PURE__ */ new WeakMap(), mS = /* @__PURE__ */ new WeakMap(), fS = {}, SO = 0, Q6 = function(e, t, n) {
  t === void 0 && (t = Uic(e)), n === void 0 && (n = "data-aria-hidden");
  var o = Array.isArray(e) ? e : [e];
  fS[n] || (fS[n] = /* @__PURE__ */ new WeakMap());
  var r = fS[n], i = [], a = /* @__PURE__ */ new Set(), s = function(l) {
    !l || a.has(l) || (a.add(l), s(l.parentNode));
  };
  o.forEach(s);
  var c = function(l) {
    !l || o.indexOf(l) >= 0 || Array.prototype.forEach.call(l.children, function(u) {
      if (a.has(u))
        c(u);
      else {
        var d = u.getAttribute("aria-hidden"), _ = d !== null && d !== "false", p = (nb.get(u) || 0) + 1, g = (r.get(u) || 0) + 1;
        nb.set(u, p), r.set(u, g), i.push(u), p === 1 && _ && mS.set(u, !0), g === 1 && u.setAttribute(n, "true"), _ || u.setAttribute("aria-hidden", "true");
      }
    });
  };
  return c(t), a.clear(), SO++, function() {
    i.forEach(function(l) {
      var u = nb.get(l) - 1, d = r.get(l) - 1;
      nb.set(l, u), r.set(l, d), u || (mS.has(l) || l.removeAttribute("aria-hidden"), mS.delete(l)), d || l.removeAttribute(n);
    }), SO--, SO || (nb = /* @__PURE__ */ new WeakMap(), nb = /* @__PURE__ */ new WeakMap(), mS = /* @__PURE__ */ new WeakMap(), fS = {});
  };
}, LE = "right-scroll-bar-position", ME = "width-before-scroll-bar", Gic = "with-scroll-bars-hidden", Wic = "--removed-body-scroll-bar-size";
function EO(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Hic(e, t) {
  var n = it(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var yG = /* @__PURE__ */ new WeakMap();
function Yic(e, t) {
  var n = Hic(t || null, function(o) {
    return e.forEach(function(r) {
      return EO(r, o);
    });
  });
  return Ue.useLayoutEffect(function() {
    var o = yG.get(n);
    if (o) {
      var r = new Set(o), i = new Set(e), a = n.current;
      r.forEach(function(s) {
        i.has(s) || EO(s, null);
      }), i.forEach(function(s) {
        r.has(s) || EO(s, a);
      });
    }
    yG.set(n, e);
  }, [e]), n;
}
function Kic(e) {
  return e;
}
function Zic(e, t) {
  t === void 0 && (t = Kic);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, o);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (o = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      o = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var c = function() {
        var u = a;
        a = [], u.forEach(i);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          a.push(u), l();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return r;
}
function Xic(e) {
  e === void 0 && (e = {});
  var t = Zic(null);
  return t.options = zp({ async: !0, ssr: !1 }, e), t;
}
var Vae = function(e) {
  var t = e.sideCar, n = jie(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return Ue.createElement(o, zp({}, n));
};
Vae.isSideCarExport = !0;
function Jic(e, t) {
  return e.useMedium(t), Vae;
}
var Bae = Xic(), xO = function() {
}, RT = Ue.forwardRef(function(e, t) {
  var n = Ue.useRef(null), o = Ue.useState({
    onScrollCapture: xO,
    onWheelCapture: xO,
    onTouchMoveCapture: xO
  }), r = o[0], i = o[1], a = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, _ = e.sideCar, p = e.noIsolation, g = e.inert, f = e.allowPinchZoom, h = e.as, $ = h === void 0 ? "div" : h, v = jie(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), b = _, y = Yic([n, t]), w = zp(zp({}, v), r);
  return Ue.createElement(
    Ue.Fragment,
    null,
    u && Ue.createElement(b, { sideCar: Bae, removeScrollBar: l, shards: d, noIsolation: p, inert: g, setCallbacks: i, allowPinchZoom: !!f, lockRef: n }),
    a ? Ue.cloneElement(Ue.Children.only(s), zp(zp({}, w), { ref: y })) : Ue.createElement($, zp({}, w, { className: c, ref: y }), s)
  );
});
RT.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
RT.classNames = {
  fullWidth: ME,
  zeroRight: LE
};
var $G, Qic = function() {
  if ($G)
    return $G;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function eac() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Qic();
  return t && e.setAttribute("nonce", t), e;
}
function tac(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function nac(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var oac = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = eac()) && (tac(t, n), nac(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, rac = function() {
  var e = oac();
  return function(t, n) {
    Ue.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Uae = function() {
  var e = rac(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, iac = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, CO = function(e) {
  return parseInt(e || "", 10) || 0;
}, aac = function(e) {
  var t = window.getComputedStyle(document.body);
  process.env.NODE_ENV !== "production" && t.overflowY === "hidden" && console.error("react-remove-scroll-bar: cannot calculate scrollbar size because it is removed (overflow:hidden on body");
  var n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [CO(n), CO(o), CO(r)];
}, sac = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return iac;
  var t = aac(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, cac = Uae(), lac = function(e, t, n, o) {
  var r = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Gic, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(LE, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ME, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(LE, " .").concat(LE, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ME, " .").concat(ME, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body {
    `).concat(Wic, ": ").concat(s, `px;
  }
`);
}, uac = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o, i = Ue.useMemo(function() {
    return sac(r);
  }, [r]);
  return Ue.createElement(cac, { styles: lac(i, !t, r, n ? "" : "!important") });
}, SM = !1;
if (typeof window < "u")
  try {
    var gS = Object.defineProperty({}, "passive", {
      get: function() {
        return SM = !0, !0;
      }
    });
    window.addEventListener("test", gS, gS), window.removeEventListener("test", gS, gS);
  } catch {
    SM = !1;
  }
var ob = SM ? { passive: !1 } : !1, dac = function(e) {
  return e.tagName === "TEXTAREA";
}, Gae = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !dac(e) && n[t] === "visible")
  );
}, _ac = function(e) {
  return Gae(e, "overflowY");
}, pac = function(e) {
  return Gae(e, "overflowX");
}, wG = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = Wae(e, n);
    if (o) {
      var r = Hae(e, n), i = r[1], a = r[2];
      if (i > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, mac = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, fac = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Wae = function(e, t) {
  return e === "v" ? _ac(t) : pac(t);
}, Hae = function(e, t) {
  return e === "v" ? mac(t) : fac(t);
}, gac = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, hac = function(e, t, n, o, r) {
  var i = gac(e, window.getComputedStyle(t).direction), a = i * o, s = n.target, c = t.contains(s), l = !1, u = a > 0, d = 0, _ = 0;
  do {
    var p = Hae(e, s), g = p[0], f = p[1], h = p[2], $ = f - h - i * g;
    (g || $) && Wae(e, s) && (d += $, _ += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && (r && d === 0 || !r && a > d) || !u && (r && _ === 0 || !r && -a > _)) && (l = !0), l;
}, hS = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, kG = function(e) {
  return [e.deltaX, e.deltaY];
}, SG = function(e) {
  return e && "current" in e ? e.current : e;
}, vac = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, bac = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, yac = 0, rb = [];
function $ac(e) {
  var t = Ue.useRef([]), n = Ue.useRef([0, 0]), o = Ue.useRef(), r = Ue.useState(yac++)[0], i = Ue.useState(function() {
    return Uae();
  })[0], a = Ue.useRef(e);
  Ue.useEffect(function() {
    a.current = e;
  }, [e]), Ue.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var f = Unc([e.lockRef.current], (e.shards || []).map(SG), !0).filter(Boolean);
      return f.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), f.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = Ue.useCallback(function(f, h) {
    if ("touches" in f && f.touches.length === 2)
      return !a.current.allowPinchZoom;
    var $ = hS(f), v = n.current, b = "deltaX" in f ? f.deltaX : v[0] - $[0], y = "deltaY" in f ? f.deltaY : v[1] - $[1], w, N = f.target, M = Math.abs(b) > Math.abs(y) ? "h" : "v";
    if ("touches" in f && M === "h" && N.type === "range")
      return !1;
    var q = wG(M, N);
    if (!q)
      return !0;
    if (q ? w = M : (w = M === "v" ? "h" : "v", q = wG(M, N)), !q)
      return !1;
    if (!o.current && "changedTouches" in f && (b || y) && (o.current = w), !w)
      return !0;
    var L = o.current || w;
    return hac(L, h, f, L === "h" ? b : y, !0);
  }, []), c = Ue.useCallback(function(f) {
    var h = f;
    if (!(!rb.length || rb[rb.length - 1] !== i)) {
      var $ = "deltaY" in h ? kG(h) : hS(h), v = t.current.filter(function(w) {
        return w.name === h.type && w.target === h.target && vac(w.delta, $);
      })[0];
      if (v && v.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!v) {
        var b = (a.current.shards || []).map(SG).filter(Boolean).filter(function(w) {
          return w.contains(h.target);
        }), y = b.length > 0 ? s(h, b[0]) : !a.current.noIsolation;
        y && h.cancelable && h.preventDefault();
      }
    }
  }, []), l = Ue.useCallback(function(f, h, $, v) {
    var b = { name: f, delta: h, target: $, should: v };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(y) {
        return y !== b;
      });
    }, 1);
  }, []), u = Ue.useCallback(function(f) {
    n.current = hS(f), o.current = void 0;
  }, []), d = Ue.useCallback(function(f) {
    l(f.type, kG(f), f.target, s(f, e.lockRef.current));
  }, []), _ = Ue.useCallback(function(f) {
    l(f.type, hS(f), f.target, s(f, e.lockRef.current));
  }, []);
  Ue.useEffect(function() {
    return rb.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: _
    }), document.addEventListener("wheel", c, ob), document.addEventListener("touchmove", c, ob), document.addEventListener("touchstart", u, ob), function() {
      rb = rb.filter(function(f) {
        return f !== i;
      }), document.removeEventListener("wheel", c, ob), document.removeEventListener("touchmove", c, ob), document.removeEventListener("touchstart", u, ob);
    };
  }, []);
  var p = e.removeScrollBar, g = e.inert;
  return Ue.createElement(
    Ue.Fragment,
    null,
    g ? Ue.createElement(i, { styles: bac(r) }) : null,
    p ? Ue.createElement(uac, { gapMode: "margin" }) : null
  );
}
const wac = Jic(Bae, $ac);
var Yae = Ue.forwardRef(function(e, t) {
  return Ue.createElement(RT, zp({}, e, { ref: t, sideCar: wac }));
});
Yae.classNames = RT.classNames;
const eF = Yae, kac = [
  "Enter",
  " "
], Sac = [
  "ArrowDown",
  "PageUp",
  "Home"
], Kae = [
  "ArrowUp",
  "PageDown",
  "End"
], Eac = [
  ...Sac,
  ...Kae
], PT = "Menu", [EM, xac, Cac] = V6(PT), [Cv, Zae] = jc(PT, [
  Cac,
  jy,
  By
]), tF = jy(), Xae = By(), [Tac, P0] = Cv(PT), [Aac, nF] = Cv(PT), Iac = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: i, modal: a = !0 } = e, s = tF(t), [c, l] = it(null), u = xt(!1), d = ws(i), _ = wic(r);
  return yt(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", g, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", g, {
        capture: !0,
        once: !0
      });
    }, g = () => u.current = !1;
    return document.addEventListener("keydown", p, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", p, {
        capture: !0
      }), document.removeEventListener("pointerdown", g, {
        capture: !0
      }), document.removeEventListener("pointermove", g, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ pt(z6, s, /* @__PURE__ */ pt(Tac, {
    scope: t,
    open: n,
    onOpenChange: d,
    content: c,
    onContentChange: l
  }, /* @__PURE__ */ pt(Aac, {
    scope: t,
    onClose: Yt(
      () => d(!1),
      [
        d
      ]
    ),
    isUsingKeyboardRef: u,
    dir: _,
    modal: a
  }, o)));
}, Oac = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeMenu: n, ...o } = e, r = tF(n);
  return /* @__PURE__ */ pt(R6, Tt({}, r, o, {
    ref: t
  }));
}), Jae = "MenuPortal", [Nac, zac] = Cv(Jae, {
  forceMount: void 0
}), Rac = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, i = P0(Jae, t);
  return /* @__PURE__ */ pt(Nac, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ pt(Vc, {
    present: n || i.open
  }, /* @__PURE__ */ pt(D6, {
    asChild: !0,
    container: r
  }, o)));
}, bg = "MenuContent", [Pac, Qae] = Cv(bg), Dac = /* @__PURE__ */ Bt((e, t) => {
  const n = zac(bg, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, i = P0(bg, e.__scopeMenu), a = nF(bg, e.__scopeMenu);
  return /* @__PURE__ */ pt(EM.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ pt(Vc, {
    present: o || i.open
  }, /* @__PURE__ */ pt(EM.Slot, {
    scope: e.__scopeMenu
  }, a.modal ? /* @__PURE__ */ pt(Lac, Tt({}, r, {
    ref: t
  })) : /* @__PURE__ */ pt(Mac, Tt({}, r, {
    ref: t
  })))));
}), Lac = /* @__PURE__ */ Bt((e, t) => {
  const n = P0(bg, e.__scopeMenu), o = xt(null), r = ni(t, o);
  return yt(() => {
    const i = o.current;
    if (i)
      return Q6(i);
  }, []), /* @__PURE__ */ pt(ese, Tt({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: jn(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), Mac = /* @__PURE__ */ Bt((e, t) => {
  const n = P0(bg, e.__scopeMenu);
  return /* @__PURE__ */ pt(ese, Tt({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), ese = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeMenu: n, loop: o = !1, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: l, onPointerDownOutside: u, onFocusOutside: d, onInteractOutside: _, onDismiss: p, disableOutsideScroll: g, ...f } = e, h = P0(bg, n), $ = nF(bg, n), v = tF(n), b = Xae(n), y = xac(n), [w, N] = it(null), M = xt(null), q = ni(t, M, h.onContentChange), L = xt(0), R = xt(""), T = xt(0), D = xt(null), A = xt("right"), S = xt(0), E = g ? eF : Ha, x = g ? {
    as: av,
    allowPinchZoom: !0
  } : void 0, k = (z) => {
    var F, P;
    const O = R.current + z, V = y().filter(
      (Y) => !Y.disabled
    ), U = document.activeElement, H = (F = V.find(
      (Y) => Y.ref.current === U
    )) === null || F === void 0 ? void 0 : F.textValue, J = V.map(
      (Y) => Y.textValue
    ), le = Jac(J, O, H), ae = (P = V.find(
      (Y) => Y.textValue === le
    )) === null || P === void 0 ? void 0 : P.ref.current;
    (function Y(re) {
      R.current = re, window.clearTimeout(L.current), re !== "" && (L.current = window.setTimeout(
        () => Y(""),
        1e3
      ));
    })(O), ae && setTimeout(
      () => ae.focus()
    );
  };
  yt(() => () => window.clearTimeout(L.current), []), Y6();
  const I = Yt((z) => {
    var F, P;
    return A.current === ((F = D.current) === null || F === void 0 ? void 0 : F.side) && esc(z, (P = D.current) === null || P === void 0 ? void 0 : P.area);
  }, []);
  return /* @__PURE__ */ pt(Pac, {
    scope: n,
    searchRef: R,
    onItemEnter: Yt((z) => {
      I(z) && z.preventDefault();
    }, [
      I
    ]),
    onItemLeave: Yt((z) => {
      var F;
      I(z) || ((F = M.current) === null || F === void 0 || F.focus(), N(null));
    }, [
      I
    ]),
    onTriggerLeave: Yt((z) => {
      I(z) && z.preventDefault();
    }, [
      I
    ]),
    pointerGraceTimerRef: T,
    onPointerGraceIntentChange: Yt((z) => {
      D.current = z;
    }, [])
  }, /* @__PURE__ */ pt(E, x, /* @__PURE__ */ pt(K6, {
    asChild: !0,
    trapped: r,
    onMountAutoFocus: jn(i, (z) => {
      var F;
      z.preventDefault(), (F = M.current) === null || F === void 0 || F.focus();
    }),
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ pt(ST, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: l,
    onPointerDownOutside: u,
    onFocusOutside: d,
    onInteractOutside: _,
    onDismiss: p
  }, /* @__PURE__ */ pt(X6, Tt({
    asChild: !0
  }, b, {
    dir: $.dir,
    orientation: "vertical",
    loop: o,
    currentTabStopId: w,
    onCurrentTabStopIdChange: N,
    onEntryFocus: jn(c, (z) => {
      $.isUsingKeyboardRef.current || z.preventDefault();
    })
  }), /* @__PURE__ */ pt(P6, Tt({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": Kac(h.open),
    "data-radix-menu-content": "",
    dir: $.dir
  }, v, f, {
    ref: q,
    style: {
      outline: "none",
      ...f.style
    },
    onKeyDown: jn(f.onKeyDown, (z) => {
      const P = z.target.closest("[data-radix-menu-content]") === z.currentTarget, O = z.ctrlKey || z.altKey || z.metaKey, V = z.key.length === 1;
      P && (z.key === "Tab" && z.preventDefault(), !O && V && k(z.key));
      const U = M.current;
      if (z.target !== U || !Eac.includes(z.key))
        return;
      z.preventDefault();
      const J = y().filter(
        (le) => !le.disabled
      ).map(
        (le) => le.ref.current
      );
      Kae.includes(z.key) && J.reverse(), Zac(J);
    }),
    onBlur: jn(e.onBlur, (z) => {
      z.currentTarget.contains(z.target) || (window.clearTimeout(L.current), R.current = "");
    }),
    onPointerMove: jn(e.onPointerMove, CM((z) => {
      const F = z.target, P = S.current !== z.clientX;
      if (z.currentTarget.contains(F) && P) {
        const O = z.clientX > S.current ? "right" : "left";
        A.current = O, S.current = z.clientX;
      }
    }))
  })))))));
}), xM = "MenuItem", EG = "menu.itemSelect", oF = /* @__PURE__ */ Bt((e, t) => {
  const { disabled: n = !1, onSelect: o, ...r } = e, i = xt(null), a = nF(xM, e.__scopeMenu), s = Qae(xM, e.__scopeMenu), c = ni(t, i), l = xt(!1), u = () => {
    const d = i.current;
    if (!n && d) {
      const _ = new CustomEvent(EG, {
        bubbles: !0,
        cancelable: !0
      });
      d.addEventListener(
        EG,
        (p) => o == null ? void 0 : o(p),
        {
          once: !0
        }
      ), z0(d, _), _.defaultPrevented ? l.current = !1 : a.onClose();
    }
  };
  return /* @__PURE__ */ pt(Fac, Tt({}, r, {
    ref: c,
    disabled: n,
    onClick: jn(e.onClick, u),
    onPointerDown: (d) => {
      var _;
      (_ = e.onPointerDown) === null || _ === void 0 || _.call(e, d), l.current = !0;
    },
    onPointerUp: jn(e.onPointerUp, (d) => {
      var _;
      l.current || (_ = d.currentTarget) === null || _ === void 0 || _.click();
    }),
    onKeyDown: jn(e.onKeyDown, (d) => {
      const _ = s.searchRef.current !== "";
      n || _ && d.key === " " || kac.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
    })
  }));
}), Fac = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeMenu: n, disabled: o = !1, textValue: r, ...i } = e, a = Qae(xM, n), s = Xae(n), c = xt(null), l = ni(t, c), [u, d] = it(!1), [_, p] = it("");
  return yt(() => {
    const g = c.current;
    if (g) {
      var f;
      p(((f = g.textContent) !== null && f !== void 0 ? f : "").trim());
    }
  }, [
    i.children
  ]), /* @__PURE__ */ pt(EM.ItemSlot, {
    scope: n,
    disabled: o,
    textValue: r ?? _
  }, /* @__PURE__ */ pt(J6, Tt({
    asChild: !0
  }, s, {
    focusable: !o
  }), /* @__PURE__ */ pt(nr.div, Tt({
    role: "menuitem",
    "data-highlighted": u ? "" : void 0,
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0
  }, i, {
    ref: l,
    onPointerMove: jn(e.onPointerMove, CM((g) => {
      o ? a.onItemLeave(g) : (a.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus());
    })),
    onPointerLeave: jn(e.onPointerLeave, CM(
      (g) => a.onItemLeave(g)
    )),
    onFocus: jn(
      e.onFocus,
      () => d(!0)
    ),
    onBlur: jn(
      e.onBlur,
      () => d(!1)
    )
  }))));
}), qac = /* @__PURE__ */ Bt((e, t) => {
  const { checked: n = !1, onCheckedChange: o, ...r } = e;
  return /* @__PURE__ */ pt(nse, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ pt(oF, Tt({
    role: "menuitemcheckbox",
    "aria-checked": Ox(n) ? "mixed" : n
  }, r, {
    ref: t,
    "data-state": rF(n),
    onSelect: jn(
      r.onSelect,
      () => o == null ? void 0 : o(Ox(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), jac = "MenuRadioGroup", [esu, Vac] = Cv(jac, {
  value: void 0,
  onValueChange: () => {
  }
}), Bac = "MenuRadioItem", Uac = /* @__PURE__ */ Bt((e, t) => {
  const { value: n, ...o } = e, r = Vac(Bac, e.__scopeMenu), i = n === r.value;
  return /* @__PURE__ */ pt(nse, {
    scope: e.__scopeMenu,
    checked: i
  }, /* @__PURE__ */ pt(oF, Tt({
    role: "menuitemradio",
    "aria-checked": i
  }, o, {
    ref: t,
    "data-state": rF(i),
    onSelect: jn(o.onSelect, () => {
      var a;
      return (a = r.onValueChange) === null || a === void 0 ? void 0 : a.call(r, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), tse = "MenuItemIndicator", [nse, Gac] = Cv(tse, {
  checked: !1
}), Wac = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeMenu: n, forceMount: o, ...r } = e, i = Gac(tse, n);
  return /* @__PURE__ */ pt(Vc, {
    present: o || Ox(i.checked) || i.checked === !0
  }, /* @__PURE__ */ pt(nr.span, Tt({}, r, {
    ref: t,
    "data-state": rF(i.checked)
  })));
}), Hac = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeMenu: n, ...o } = e;
  return /* @__PURE__ */ pt(nr.div, Tt({
    role: "separator",
    "aria-orientation": "horizontal"
  }, o, {
    ref: t
  }));
}), Yac = "MenuSub";
Cv(Yac);
function Kac(e) {
  return e ? "open" : "closed";
}
function Ox(e) {
  return e === "indeterminate";
}
function rF(e) {
  return Ox(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Zac(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Xac(e, t) {
  return e.map(
    (n, o) => e[(t + o) % e.length]
  );
}
function Jac(e, t, n) {
  const r = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = Xac(e, Math.max(i, 0));
  r.length === 1 && (a = a.filter(
    (l) => l !== n
  ));
  const c = a.find(
    (l) => l.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Qac(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, u = t[a].y;
    c > o != u > o && n < (l - s) * (o - c) / (u - c) + s && (r = !r);
  }
  return r;
}
function esc(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return Qac(n, t);
}
function CM(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const tsc = Iac, nsc = Oac, osc = Rac, rsc = Dac, isc = oF, asc = qac, ssc = Uac, csc = Wac, lsc = Hac, ose = "DropdownMenu", [usc, tsu] = jc(ose, [
  Zae
]), kf = Zae(), [dsc, rse] = usc(ose), _sc = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: o, open: r, defaultOpen: i, onOpenChange: a, modal: s = !0 } = e, c = kf(t), l = xt(null), [u = !1, d] = Uu({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ pt(dsc, {
    scope: t,
    triggerId: Pu(),
    triggerRef: l,
    contentId: Pu(),
    open: u,
    onOpenChange: d,
    onOpenToggle: Yt(
      () => d(
        (_) => !_
      ),
      [
        d
      ]
    ),
    modal: s
  }, /* @__PURE__ */ pt(tsc, Tt({}, c, {
    open: u,
    onOpenChange: d,
    dir: o,
    modal: s
  }), n));
}, psc = "DropdownMenuTrigger", msc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, i = rse(psc, n), a = kf(n);
  return /* @__PURE__ */ pt(nsc, Tt({
    asChild: !0
  }, a), /* @__PURE__ */ pt(nr.button, Tt({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": i.open,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": o ? "" : void 0,
    disabled: o
  }, r, {
    ref: A6(t, i.triggerRef),
    onPointerDown: jn(e.onPointerDown, (s) => {
      !o && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
    }),
    onKeyDown: jn(e.onKeyDown, (s) => {
      o || ([
        "Enter",
        " "
      ].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), fsc = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = kf(t);
  return /* @__PURE__ */ pt(osc, Tt({}, o, n));
}, gsc = "DropdownMenuContent", hsc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = rse(gsc, n), i = kf(n), a = xt(!1);
  return /* @__PURE__ */ pt(rsc, Tt({
    id: r.contentId,
    "aria-labelledby": r.triggerId
  }, i, o, {
    ref: t,
    onCloseAutoFocus: jn(e.onCloseAutoFocus, (s) => {
      var c;
      a.current || (c = r.triggerRef.current) === null || c === void 0 || c.focus(), a.current = !1, s.preventDefault();
    }),
    onInteractOutside: jn(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
      (!r.modal || u) && (a.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), vsc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = kf(n);
  return /* @__PURE__ */ pt(isc, Tt({}, r, o, {
    ref: t
  }));
}), bsc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = kf(n);
  return /* @__PURE__ */ pt(asc, Tt({}, r, o, {
    ref: t
  }));
}), ysc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = kf(n);
  return /* @__PURE__ */ pt(ssc, Tt({}, r, o, {
    ref: t
  }));
}), $sc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = kf(n);
  return /* @__PURE__ */ pt(csc, Tt({}, r, o, {
    ref: t
  }));
}), wsc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = kf(n);
  return /* @__PURE__ */ pt(lsc, Tt({}, r, o, {
    ref: t
  }));
}), ksc = _sc, Ssc = msc, Esc = fsc, xsc = hsc, Csc = vsc, Tsc = bsc, Asc = ysc, ise = $sc, Isc = wsc, xG = (e) => [`get-${e}-check`], ase = ({ onCheckError: e, calendar: t, initialData: n }) => {
  var c, l;
  const { isInit: o, accessToken: r } = cr(), i = qc(), { data: a, refetch: s } = mr({
    queryKey: xG(t),
    staleTime: 6e3,
    enabled: o && !!r,
    queryFn: () => At == null ? void 0 : At.get(`/calendars/${t}/check`).then(({ data: u }) => u.status === Nn ? { status: Nn, data: { allowConnect: !1, checked: !0 } } : (e == null || e(u), { status: Ig, data: { allowConnect: !0, checked: !0 } })).catch((u) => (e == null || e(u), { status: Ig, data: { allowConnect: !0, checked: !0 } })),
    initialData: n
  });
  return {
    allowConnect: ((c = a == null ? void 0 : a.data) == null ? void 0 : c.allowConnect) ?? !1,
    checked: ((l = a == null ? void 0 : a.data) == null ? void 0 : l.checked) ?? !1,
    refetch: () => {
      i.setQueryData(xG(t), {
        status: Nn,
        data: { allowConnect: !1, checked: !1 }
      }), s();
    }
  };
}, Osc = (e) => [`get-${e}-redirect-uri`], Nsc = (e, t, n) => {
  const o = t ? encodeURIComponent(t) : "";
  return mr({
    queryKey: Osc(e),
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => At == null ? void 0 : At.get(
      `/calendars/${e}/connect?redir=${o}&isDryRun=${n ?? ""}`
    ).then(({ data: i }) => {
      if (i.status === Nn)
        return i.data.authUrl;
      if (i.status === Ig)
        throw new Error(i.error.message);
      return "";
    })
  });
}, zsc = (e, t, n) => {
  const { refetch: o } = Nsc(e, t, n);
  return { connect: async () => {
    const i = await o();
    i.data && (window.location.href = i.data);
  } };
}, Rsc = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => {
    const { calendar: r, username: i, password: a } = o, s = {
      username: i,
      password: a
    };
    return At.post(`/calendars/${r}/credentials`, s).then((c) => c.data);
  },
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), iF = "get-connected-calendars", Uy = (e) => {
  const { isInit: t } = cr();
  return mr({
    queryKey: [iF],
    queryFn: () => At.get("/calendars").then((o) => {
      var r;
      if (o.data.status === Nn)
        return (r = o.data) == null ? void 0 : r.data;
      throw new Error(o.data.error.message);
    }),
    enabled: (e == null ? void 0 : e.enabled) !== void 0 ? e.enabled && t : t,
    staleTime: 5e3
  });
}, sse = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  onCheckError: r,
  calendar: i,
  redir: a,
  initialData: s,
  isMultiCalendar: c = !1,
  tooltip: l,
  tooltipSide: u = "bottom",
  isClickable: d,
  onSuccess: _,
  isDryRun: p
}) => {
  const { connect: g } = zsc(i, a, p), { allowConnect: f, checked: h } = ase({
    onCheckError: r,
    calendar: i,
    initialData: s
  }), $ = !h, v = $ || !f;
  let b = e;
  return $ ? b = n : f || (b = t), c ? /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m(
    Jt,
    {
      StartIcon: "calendar-days",
      color: "primary",
      disabled: d ? !1 : $,
      tooltip: l || /* @__PURE__ */ m(cse, { calendarInstance: i }),
      tooltipSide: u,
      tooltipOffset: 10,
      tooltipClassName: "p-0 text-inherit bg-inherit",
      className: ar("", !v && "cursor-pointer", "border-none md:rounded-md", o),
      onTouchEnd: () => {
        g(), _ == null || _();
      },
      onClick: () => {
        g(), _ == null || _();
      },
      children: b
    }
  ) }) : /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m(
    Jt,
    {
      StartIcon: "calendar-days",
      color: "primary",
      disabled: v,
      className: ar(
        "",
        v && "cursor-not-allowed",
        !v && "cursor-pointer",
        "border-none md:rounded-md",
        o
      ),
      onTouchEnd: () => {
        g(), _ == null || _();
      },
      onClick: () => g(),
      children: b
    }
  ) });
}, cse = ({
  calendarInstance: e
}) => {
  const { data: t, isLoading: n } = Uy({});
  return n ? /* @__PURE__ */ m("div", { className: "bg-subtle flex flex-col rounded-md border border-gray-300 px-4 py-2", children: "Loading..." }) : /* @__PURE__ */ m("div", { className: "bg-subtle flex flex-col rounded-md border border-gray-300", children: t == null ? void 0 : t.connectedCalendars.filter((o) => o.integration.slug === `${e}-calendar`).map((o, r, i) => {
    var a, s, c;
    return /* @__PURE__ */ de(nt, { children: [
      /* @__PURE__ */ de("div", { className: "bg-transparent px-4 py-2 text-black", children: [
        (a = o.primary) == null ? void 0 : a.name,
        " - ",
        (s = o.primary) == null ? void 0 : s.email
      ] }, (c = o.primary) == null ? void 0 : c.externalId),
      i.length - 1 !== r && /* @__PURE__ */ m("hr", { className: "w-[90%] self-center" })
    ] });
  }) });
}, lse = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  onCheckError: r,
  redir: i,
  initialData: a,
  isMultiCalendar: s = !1,
  tooltipSide: c,
  tooltip: l,
  isClickable: u,
  isDryRun: d
}) => {
  const { t: _ } = kt();
  return /* @__PURE__ */ m(
    sse,
    {
      label: e || _("google_connect_atom_label"),
      alreadyConnectedLabel: t || _("google_connect_atom_already_connected_label"),
      loadingLabel: n || _("google_connect_atom_loading_label"),
      calendar: _Ee,
      className: o,
      onCheckError: r,
      redir: i,
      initialData: a,
      isMultiCalendar: s,
      tooltipSide: c,
      tooltip: l,
      isClickable: u,
      isDryRun: d
    }
  );
}, D0 = "use-atom-schedule", use = (e, t) => {
  const n = "atoms/schedules", { isInit: o, accessToken: r } = cr(), { isLoading: i, error: a, data: s } = mr({
    queryKey: [D0, e, t],
    queryFn: () => At.get(n, {
      params: { scheduleId: e, isManagedEventType: t }
    }).then((c) => {
      var l;
      if (c.data.status === Nn)
        return c.data.data;
      throw new Error((l = c.data.error) == null ? void 0 : l.message);
    }),
    enabled: o && !!r
  });
  return { isLoading: i, error: a, data: s };
}, dse = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = qc();
  return Hr({
    mutationFn: async ({ scheduleId: o, body: r }) => {
      const i = `atoms/schedules/${o}`;
      return (await At.patch(i, r)).data;
    },
    onSuccess: (o) => {
      o.status === Nn ? (e == null || e(o), n.invalidateQueries({ queryKey: [D0] })) : t == null || t(o);
    },
    onError: (o) => {
      t == null || t(o);
    }
  });
}, Psc = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = qc();
  return Hr({
    mutationFn: (r) => {
      const { id: i } = r, a = `/${rs.availability}/${i}`;
      return At == null ? void 0 : At.delete(a).then((s) => s.data);
    },
    onSuccess: (r) => {
      r.status === Nn ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    },
    onSettled: () => {
      n.invalidateQueries({ queryKey: [D0] });
    }
  });
}, _se = Psc;
var L0 = (e) => e.type === "checkbox", Eb = (e) => e instanceof Date, dl = (e) => e == null;
const pse = (e) => typeof e == "object";
var ks = (e) => !dl(e) && !Array.isArray(e) && pse(e) && !Eb(e), mse = (e) => ks(e) && e.target ? L0(e.target) ? e.target.checked : e.target.value : e, Dsc = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, fse = (e, t) => e.has(Dsc(t)), Gy = (e) => Array.isArray(e) ? e.filter(Boolean) : [], va = (e) => e === void 0, Pn = (e, t, n) => {
  if (!t || !ks(e))
    return n;
  const o = Gy(t.split(/[,[\].]+?/)).reduce((r, i) => dl(r) ? r : r[i], e);
  return va(o) || o === e ? va(e[t]) ? n : e[t] : o;
};
const Nx = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ad = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Rm = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, gse = Fe.createContext(null), No = () => Fe.useContext(gse), hse = (e) => {
  const { children: t, ...n } = e;
  return Fe.createElement(gse.Provider, { value: n }, t);
};
var vse = (e, t, n, o = !0) => {
  const r = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(r, i, {
      get: () => {
        const a = i;
        return t._proxyFormState[a] !== Ad.all && (t._proxyFormState[a] = !o || Ad.all), n && (n[a] = !0), e[a];
      }
    });
  return r;
}, Tu = (e) => ks(e) && !Object.keys(e).length, bse = (e, t, n, o) => {
  n(e);
  const { name: r, ...i } = e;
  return Tu(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((a) => t[a] === (!o || Ad.all));
}, zu = (e) => Array.isArray(e) ? e : [e], yse = (e, t, n) => n && t ? e === t : !e || !t || e === t || zu(e).some((o) => o && (o.startsWith(t) || t.startsWith(o)));
function DT(e) {
  const t = Fe.useRef(e);
  t.current = e, Fe.useEffect(() => {
    const n = !e.disabled && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function Lsc(e) {
  const t = No(), { control: n = t.control, disabled: o, name: r, exact: i } = e || {}, [a, s] = Fe.useState(n._formState), c = Fe.useRef(!0), l = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), u = Fe.useRef(r);
  return u.current = r, DT({
    disabled: o,
    next: (d) => c.current && yse(u.current, d.name, i) && bse(d, l.current, n._updateFormState) && s({
      ...n._formState,
      ...d
    }),
    subject: n._subjects.state
  }), Fe.useEffect(() => {
    c.current = !0;
    const d = n._proxyFormState.isDirty && n._getDirty();
    return d !== n._formState.isDirty && n._subjects.state.next({
      isDirty: d
    }), l.current.isValid && n._updateValid(!0), () => {
      c.current = !1;
    };
  }, [n]), vse(a, n, l.current, !1);
}
var Fp = (e) => typeof e == "string", $se = (e, t, n, o, r) => Fp(e) ? (o && t.watch.add(e), Pn(n, e, r)) : Array.isArray(e) ? e.map((i) => (o && t.watch.add(i), Pn(n, i))) : (o && (t.watchAll = !0), n), Msc = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return ks(t) && t.hasOwnProperty("isPrototypeOf");
}, aF = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Au(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(aF && (e instanceof Blob || e instanceof FileList)) && (n || ks(e)))
    if (t = n ? [] : {}, !Array.isArray(e) && !Msc(e))
      t = e;
    else
      for (const o in e)
        t[o] = Au(e[o]);
  else
    return e;
  return t;
}
function cf(e) {
  const t = No(), { control: n = t.control, name: o, defaultValue: r, disabled: i, exact: a } = e || {}, s = Fe.useRef(o);
  s.current = o, DT({
    disabled: i,
    subject: n._subjects.values,
    next: (u) => {
      yse(s.current, u.name, a) && l(Au($se(s.current, n._names, u.values || n._formValues, !1, r)));
    }
  });
  const [c, l] = Fe.useState(n._getWatch(o, r));
  return Fe.useEffect(() => n._removeUnmounted()), c;
}
function Fsc(e) {
  const t = No(), { name: n, control: o = t.control, shouldUnregister: r } = e, i = fse(o._names.array, n), a = cf({
    control: o,
    name: n,
    defaultValue: Pn(o._formValues, n, Pn(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), s = Lsc({
    control: o,
    name: n
  }), c = Fe.useRef(o.register(n, {
    ...e.rules,
    value: a
  }));
  return Fe.useEffect(() => {
    const l = (u, d) => {
      const _ = Pn(o._fields, u);
      _ && (_._f.mount = d);
    };
    return l(n, !0), () => {
      const u = o._options.shouldUnregister || r;
      (i ? u && !o._stateFlags.action : u) ? o.unregister(n) : l(n, !1);
    };
  }, [n, o, i, r]), {
    field: {
      name: n,
      value: a,
      onChange: Fe.useCallback((l) => c.current.onChange({
        target: {
          value: mse(l),
          name: n
        },
        type: Nx.CHANGE
      }), [n]),
      onBlur: Fe.useCallback(() => c.current.onBlur({
        target: {
          value: Pn(o._formValues, n),
          name: n
        },
        type: Nx.BLUR
      }), [n, o]),
      ref: (l) => {
        const u = Pn(o._fields, n);
        u && l && (u._f.ref = {
          focus: () => l.focus(),
          select: () => l.select(),
          setCustomValidity: (d) => l.setCustomValidity(d),
          reportValidity: () => l.reportValidity()
        });
      }
    },
    formState: s,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!Pn(s.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!Pn(s.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!Pn(s.touchedFields, n)
      },
      error: {
        enumerable: !0,
        get: () => Pn(s.errors, n)
      }
    })
  };
}
const Bn = (e) => e.render(Fsc(e));
var wse = (e, t, n, o, r) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [o]: r || !0
  }
} : {}, sF = (e) => /^\w*$/.test(e), kse = (e) => Gy(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function Zi(e, t, n) {
  let o = -1;
  const r = sF(t) ? [t] : kse(t), i = r.length, a = i - 1;
  for (; ++o < i; ) {
    const s = r[o];
    let c = n;
    if (o !== a) {
      const l = e[s];
      c = ks(l) || Array.isArray(l) ? l : isNaN(+r[o + 1]) ? {} : [];
    }
    e[s] = c, e = e[s];
  }
  return e;
}
const zx = (e, t, n) => {
  for (const o of n || Object.keys(e)) {
    const r = Pn(e, o);
    if (r) {
      const { _f: i, ...a } = r;
      if (i && t(i.name)) {
        if (i.ref.focus) {
          i.ref.focus();
          break;
        } else if (i.refs && i.refs[0].focus) {
          i.refs[0].focus();
          break;
        }
      } else
        ks(a) && zx(a, t);
    }
  }
};
var Gf = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? n : n & 3 | 8).toString(16);
  });
}, TO = (e, t, n = {}) => n.shouldFocus || va(n.shouldFocus) ? n.focusName || `${e}.${va(n.focusIndex) ? t : n.focusIndex}.` : "", TM = (e) => ({
  isOnSubmit: !e || e === Ad.onSubmit,
  isOnBlur: e === Ad.onBlur,
  isOnChange: e === Ad.onChange,
  isOnAll: e === Ad.all,
  isOnTouch: e === Ad.onTouched
}), AM = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((o) => e.startsWith(o) && /^\.\w+/.test(e.slice(o.length)))), Sse = (e, t, n) => {
  const o = Gy(Pn(e, n));
  return Zi(o, "root", t[n]), Zi(e, n, o), e;
}, Db = (e) => typeof e == "boolean", cF = (e) => e.type === "file", Lb = (e) => typeof e == "function", Rx = (e) => {
  if (!aF)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, FE = (e) => Fp(e), lF = (e) => e.type === "radio", Px = (e) => e instanceof RegExp;
const CG = {
  value: !1,
  isValid: !1
}, TG = { value: !0, isValid: !0 };
var Ese = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !va(e[0].attributes.value) ? va(e[0].value) || e[0].value === "" ? TG : { value: e[0].value, isValid: !0 } : TG
    ) : CG;
  }
  return CG;
};
const AG = {
  isValid: !1,
  value: null
};
var xse = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, AG) : AG;
function IG(e, t, n = "validate") {
  if (FE(e) || Array.isArray(e) && e.every(FE) || Db(e) && !e)
    return {
      type: n,
      message: FE(e) ? e : "",
      ref: t
    };
}
var ib = (e) => ks(e) && !Px(e) ? e : {
  value: e,
  message: ""
}, IM = async (e, t, n, o, r) => {
  const { ref: i, refs: a, required: s, maxLength: c, minLength: l, min: u, max: d, pattern: _, validate: p, name: g, valueAsNumber: f, mount: h, disabled: $ } = e._f, v = Pn(t, g);
  if (!h || $)
    return {};
  const b = a ? a[0] : i, y = (D) => {
    o && b.reportValidity && (b.setCustomValidity(Db(D) ? "" : D || ""), b.reportValidity());
  }, w = {}, N = lF(i), M = L0(i), q = N || M, L = (f || cF(i)) && va(i.value) && va(v) || Rx(i) && i.value === "" || v === "" || Array.isArray(v) && !v.length, R = wse.bind(null, g, n, w), T = (D, A, S, E = Rm.maxLength, x = Rm.minLength) => {
    const k = D ? A : S;
    w[g] = {
      type: D ? E : x,
      message: k,
      ref: i,
      ...R(D ? E : x, k)
    };
  };
  if (r ? !Array.isArray(v) || !v.length : s && (!q && (L || dl(v)) || Db(v) && !v || M && !Ese(a).isValid || N && !xse(a).isValid)) {
    const { value: D, message: A } = FE(s) ? { value: !!s, message: s } : ib(s);
    if (D && (w[g] = {
      type: Rm.required,
      message: A,
      ref: b,
      ...R(Rm.required, A)
    }, !n))
      return y(A), w;
  }
  if (!L && (!dl(u) || !dl(d))) {
    let D, A;
    const S = ib(d), E = ib(u);
    if (!dl(v) && !isNaN(v)) {
      const x = i.valueAsNumber || v && +v;
      dl(S.value) || (D = x > S.value), dl(E.value) || (A = x < E.value);
    } else {
      const x = i.valueAsDate || new Date(v), k = (F) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + F), I = i.type == "time", z = i.type == "week";
      Fp(S.value) && v && (D = I ? k(v) > k(S.value) : z ? v > S.value : x > new Date(S.value)), Fp(E.value) && v && (A = I ? k(v) < k(E.value) : z ? v < E.value : x < new Date(E.value));
    }
    if ((D || A) && (T(!!D, S.message, E.message, Rm.max, Rm.min), !n))
      return y(w[g].message), w;
  }
  if ((c || l) && !L && (Fp(v) || r && Array.isArray(v))) {
    const D = ib(c), A = ib(l), S = !dl(D.value) && v.length > D.value, E = !dl(A.value) && v.length < A.value;
    if ((S || E) && (T(S, D.message, A.message), !n))
      return y(w[g].message), w;
  }
  if (_ && !L && Fp(v)) {
    const { value: D, message: A } = ib(_);
    if (Px(D) && !v.match(D) && (w[g] = {
      type: Rm.pattern,
      message: A,
      ref: i,
      ...R(Rm.pattern, A)
    }, !n))
      return y(A), w;
  }
  if (p) {
    if (Lb(p)) {
      const D = await p(v, t), A = IG(D, b);
      if (A && (w[g] = {
        ...A,
        ...R(Rm.validate, A.message)
      }, !n))
        return y(A.message), w;
    } else if (ks(p)) {
      let D = {};
      for (const A in p) {
        if (!Tu(D) && !n)
          break;
        const S = IG(await p[A](v, t), b, A);
        S && (D = {
          ...S,
          ...R(A, S.message)
        }, y(S.message), n && (w[g] = D));
      }
      if (!Tu(D) && (w[g] = {
        ref: b,
        ...D
      }, !n))
        return w;
    }
  }
  return y(!0), w;
};
function AO(e, t) {
  return [...e, ...zu(t)];
}
var IO = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function OO(e, t, n) {
  return [
    ...e.slice(0, t),
    ...zu(n),
    ...e.slice(t)
  ];
}
var NO = (e, t, n) => Array.isArray(e) ? (va(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [];
function zO(e, t) {
  return [...zu(t), ...zu(e)];
}
function qsc(e, t) {
  let n = 0;
  const o = [...e];
  for (const r of t)
    o.splice(r - n, 1), n++;
  return Gy(o).length ? o : [];
}
var RO = (e, t) => va(t) ? [] : qsc(e, zu(t).sort((n, o) => n - o)), PO = (e, t, n) => {
  e[t] = [e[n], e[n] = e[t]][0];
};
function jsc(e, t) {
  const n = t.slice(0, -1).length;
  let o = 0;
  for (; o < n; )
    e = va(e) ? o++ : e[t[o++]];
  return e;
}
function Vsc(e) {
  for (const t in e)
    if (!va(e[t]))
      return !1;
  return !0;
}
function Fs(e, t) {
  const n = Array.isArray(t) ? t : sF(t) ? [t] : kse(t), o = n.length === 1 ? e : jsc(e, n), r = n.length - 1, i = n[r];
  return o && delete o[i], r !== 0 && (ks(o) && Tu(o) || Array.isArray(o) && Vsc(o)) && Fs(e, n.slice(0, -1)), e;
}
var OG = (e, t, n) => (e[t] = n, e);
function M0(e) {
  const t = No(), { control: n = t.control, name: o, keyName: r = "id", shouldUnregister: i } = e, [a, s] = Fe.useState(n._getFieldArray(o)), c = Fe.useRef(n._getFieldArray(o).map(Gf)), l = Fe.useRef(a), u = Fe.useRef(o), d = Fe.useRef(!1);
  u.current = o, l.current = a, n._names.array.add(o), e.rules && n.register(o, e.rules), DT({
    next: ({ values: w, name: N }) => {
      if (N === u.current || !N) {
        const M = Pn(w, u.current);
        Array.isArray(M) && (s(M), c.current = M.map(Gf));
      }
    },
    subject: n._subjects.array
  });
  const _ = Fe.useCallback((w) => {
    d.current = !0, n._updateFieldArray(o, w);
  }, [n, o]), p = (w, N) => {
    const M = zu(Au(w)), q = AO(n._getFieldArray(o), M);
    n._names.focus = TO(o, q.length - 1, N), c.current = AO(c.current, M.map(Gf)), _(q), s(q), n._updateFieldArray(o, q, AO, {
      argA: IO(w)
    });
  }, g = (w, N) => {
    const M = zu(Au(w)), q = zO(n._getFieldArray(o), M);
    n._names.focus = TO(o, 0, N), c.current = zO(c.current, M.map(Gf)), _(q), s(q), n._updateFieldArray(o, q, zO, {
      argA: IO(w)
    });
  }, f = (w) => {
    const N = RO(n._getFieldArray(o), w);
    c.current = RO(c.current, w), _(N), s(N), n._updateFieldArray(o, N, RO, {
      argA: w
    });
  }, h = (w, N, M) => {
    const q = zu(Au(N)), L = OO(n._getFieldArray(o), w, q);
    n._names.focus = TO(o, w, M), c.current = OO(c.current, w, q.map(Gf)), _(L), s(L), n._updateFieldArray(o, L, OO, {
      argA: w,
      argB: IO(N)
    });
  }, $ = (w, N) => {
    const M = n._getFieldArray(o);
    PO(M, w, N), PO(c.current, w, N), _(M), s(M), n._updateFieldArray(o, M, PO, {
      argA: w,
      argB: N
    }, !1);
  }, v = (w, N) => {
    const M = n._getFieldArray(o);
    NO(M, w, N), NO(c.current, w, N), _(M), s(M), n._updateFieldArray(o, M, NO, {
      argA: w,
      argB: N
    }, !1);
  }, b = (w, N) => {
    const M = Au(N), q = OG(n._getFieldArray(o), w, M);
    c.current = [...q].map((L, R) => !L || R === w ? Gf() : c.current[R]), _(q), s([...q]), n._updateFieldArray(o, q, OG, {
      argA: w,
      argB: M
    }, !0, !1);
  }, y = (w) => {
    const N = zu(Au(w));
    c.current = N.map(Gf), _([...N]), s([...N]), n._updateFieldArray(o, [...N], (M) => M, {}, !0, !1);
  };
  return Fe.useEffect(() => {
    if (n._stateFlags.action = !1, AM(o, n._names) && n._subjects.state.next({
      ...n._formState
    }), d.current && (!TM(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([o]).then((w) => {
          const N = Pn(w.errors, o), M = Pn(n._formState.errors, o);
          (M ? !N && M.type : N && N.type) && (N ? Zi(n._formState.errors, o, N) : Fs(n._formState.errors, o), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const w = Pn(n._fields, o);
        w && w._f && IM(w, n._formValues, n._options.criteriaMode === Ad.all, n._options.shouldUseNativeValidation, !0).then((N) => !Tu(N) && n._subjects.state.next({
          errors: Sse(n._formState.errors, N, o)
        }));
      }
    n._subjects.values.next({
      name: o,
      values: n._formValues
    }), n._names.focus && zx(n._fields, (w) => !!w && w.startsWith(n._names.focus || "")), n._names.focus = "", n._updateValid();
  }, [a, o, n]), Fe.useEffect(() => (!Pn(n._formValues, o) && n._updateFieldArray(o), () => {
    (n._options.shouldUnregister || i) && n.unregister(o);
  }), [o, n, r, i]), {
    swap: Fe.useCallback($, [_, o, n]),
    move: Fe.useCallback(v, [_, o, n]),
    prepend: Fe.useCallback(g, [_, o, n]),
    append: Fe.useCallback(p, [_, o, n]),
    remove: Fe.useCallback(f, [_, o, n]),
    insert: Fe.useCallback(h, [_, o, n]),
    update: Fe.useCallback(b, [_, o, n]),
    replace: Fe.useCallback(y, [_, o, n]),
    fields: Fe.useMemo(() => a.map((w, N) => ({
      ...w,
      [r]: c.current[N] || Gf()
    })), [a, r])
  };
}
function DO() {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (r) => {
      let i = 0;
      const a = e.length;
      for (; i < a; )
        e[i].next(r), ++i;
    },
    subscribe: (r) => (e.push(r), {
      unsubscribe: () => {
        e = e.filter((i) => i !== r);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}
var Dx = (e) => dl(e) || !pse(e);
function Dh(e, t) {
  if (Dx(e) || Dx(t))
    return e === t;
  if (Eb(e) && Eb(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), o = Object.keys(t);
  if (n.length !== o.length)
    return !1;
  for (const r of n) {
    const i = e[r];
    if (!o.includes(r))
      return !1;
    if (r !== "ref") {
      const a = t[r];
      if (Eb(i) && Eb(a) || ks(i) && ks(a) || Array.isArray(i) && Array.isArray(a) ? !Dh(i, a) : i !== a)
        return !1;
    }
  }
  return !0;
}
var Cse = (e) => e.type === "select-multiple", Bsc = (e) => lF(e) || L0(e), LO = (e) => Rx(e) && e.isConnected, Tse = (e) => {
  for (const t in e)
    if (Lb(e[t]))
      return !0;
  return !1;
};
function Lx(e, t = {}) {
  const n = Array.isArray(e);
  if (ks(e) || n)
    for (const o in e)
      Array.isArray(e[o]) || ks(e[o]) && !Tse(e[o]) ? (t[o] = Array.isArray(e[o]) ? [] : {}, Lx(e[o], t[o])) : dl(e[o]) || (t[o] = !0);
  return t;
}
function Ase(e, t, n) {
  const o = Array.isArray(e);
  if (ks(e) || o)
    for (const r in e)
      Array.isArray(e[r]) || ks(e[r]) && !Tse(e[r]) ? va(t) || Dx(n[r]) ? n[r] = Array.isArray(e[r]) ? Lx(e[r], []) : { ...Lx(e[r]) } : Ase(e[r], dl(t) ? {} : t[r], n[r]) : n[r] = !Dh(e[r], t[r]);
  return n;
}
var MO = (e, t) => Ase(e, t, Lx(t)), Ise = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: o }) => va(e) ? e : t ? e === "" ? NaN : e && +e : n && Fp(e) ? new Date(e) : o ? o(e) : e;
function FO(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return cF(t) ? t.files : lF(t) ? xse(e.refs).value : Cse(t) ? [...t.selectedOptions].map(({ value: n }) => n) : L0(t) ? Ese(e.refs).value : Ise(va(t.value) ? e.ref.value : t.value, e);
}
var Usc = (e, t, n, o) => {
  const r = {};
  for (const i of e) {
    const a = Pn(t, i);
    a && Zi(r, i, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: r,
    shouldUseNativeValidation: o
  };
}, j$ = (e) => va(e) ? e : Px(e) ? e.source : ks(e) ? Px(e.value) ? e.value.source : e.value : e, Gsc = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function NG(e, t, n) {
  const o = Pn(e, n);
  if (o || sF(n))
    return {
      error: o,
      name: n
    };
  const r = n.split(".");
  for (; r.length; ) {
    const i = r.join("."), a = Pn(t, i), s = Pn(e, i);
    if (a && !Array.isArray(a) && n !== i)
      return { name: n };
    if (s && s.type)
      return {
        name: i,
        error: s
      };
    r.pop();
  }
  return {
    name: n
  };
}
var Wsc = (e, t, n, o, r) => r.isOnAll ? !1 : !n && r.isOnTouch ? !(t || e) : (n ? o.isOnBlur : r.isOnBlur) ? !e : (n ? o.isOnChange : r.isOnChange) ? e : !0, Hsc = (e, t) => !Gy(Pn(e, t)).length && Fs(e, t);
const Ysc = {
  mode: Ad.onSubmit,
  reValidateMode: Ad.onChange,
  shouldFocusError: !0
};
function Ksc(e = {}, t) {
  let n = {
    ...Ysc,
    ...e
  }, o = {
    submitCount: 0,
    isDirty: !1,
    isLoading: !0,
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, r = {}, i = ks(n.defaultValues) || ks(n.values) ? Au(n.defaultValues || n.values) || {} : {}, a = n.shouldUnregister ? {} : Au(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, c = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const d = e.resetOptions && e.resetOptions.keepDirtyValues, _ = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, p = {
    values: DO(),
    array: DO(),
    state: DO()
  }, g = TM(n.mode), f = TM(n.reValidateMode), h = n.criteriaMode === Ad.all, $ = (Q) => (me) => {
    clearTimeout(u), u = setTimeout(Q, me);
  }, v = async (Q) => {
    if (_.isValid || Q) {
      const me = n.resolver ? Tu((await L()).errors) : await T(r, !0);
      me !== o.isValid && p.state.next({
        isValid: me
      });
    }
  }, b = (Q) => _.isValidating && p.state.next({
    isValidating: Q
  }), y = (Q, me = [], ne, pe, ge = !0, ve = !0) => {
    if (pe && ne) {
      if (s.action = !0, ve && Array.isArray(Pn(r, Q))) {
        const Te = ne(Pn(r, Q), pe.argA, pe.argB);
        ge && Zi(r, Q, Te);
      }
      if (ve && Array.isArray(Pn(o.errors, Q))) {
        const Te = ne(Pn(o.errors, Q), pe.argA, pe.argB);
        ge && Zi(o.errors, Q, Te), Hsc(o.errors, Q);
      }
      if (_.touchedFields && ve && Array.isArray(Pn(o.touchedFields, Q))) {
        const Te = ne(Pn(o.touchedFields, Q), pe.argA, pe.argB);
        ge && Zi(o.touchedFields, Q, Te);
      }
      _.dirtyFields && (o.dirtyFields = MO(i, a)), p.state.next({
        name: Q,
        isDirty: A(Q, me),
        dirtyFields: o.dirtyFields,
        errors: o.errors,
        isValid: o.isValid
      });
    } else
      Zi(a, Q, me);
  }, w = (Q, me) => {
    Zi(o.errors, Q, me), p.state.next({
      errors: o.errors
    });
  }, N = (Q, me, ne, pe) => {
    const ge = Pn(r, Q);
    if (ge) {
      const ve = Pn(a, Q, va(ne) ? Pn(i, Q) : ne);
      va(ve) || pe && pe.defaultChecked || me ? Zi(a, Q, me ? ve : FO(ge._f)) : x(Q, ve), s.mount && v();
    }
  }, M = (Q, me, ne, pe, ge) => {
    let ve = !1, Te = !1;
    const Re = {
      name: Q
    };
    if (!ne || pe) {
      _.isDirty && (Te = o.isDirty, o.isDirty = Re.isDirty = A(), ve = Te !== Re.isDirty);
      const Me = Dh(Pn(i, Q), me);
      Te = Pn(o.dirtyFields, Q), Me ? Fs(o.dirtyFields, Q) : Zi(o.dirtyFields, Q, !0), Re.dirtyFields = o.dirtyFields, ve = ve || _.dirtyFields && Te !== !Me;
    }
    if (ne) {
      const Me = Pn(o.touchedFields, Q);
      Me || (Zi(o.touchedFields, Q, ne), Re.touchedFields = o.touchedFields, ve = ve || _.touchedFields && Me !== ne);
    }
    return ve && ge && p.state.next(Re), ve ? Re : {};
  }, q = (Q, me, ne, pe) => {
    const ge = Pn(o.errors, Q), ve = _.isValid && Db(me) && o.isValid !== me;
    if (e.delayError && ne ? (l = $(() => w(Q, ne)), l(e.delayError)) : (clearTimeout(u), l = null, ne ? Zi(o.errors, Q, ne) : Fs(o.errors, Q)), (ne ? !Dh(ge, ne) : ge) || !Tu(pe) || ve) {
      const Te = {
        ...pe,
        ...ve && Db(me) ? { isValid: me } : {},
        errors: o.errors,
        name: Q
      };
      o = {
        ...o,
        ...Te
      }, p.state.next(Te);
    }
    b(!1);
  }, L = async (Q) => await n.resolver(a, n.context, Usc(Q || c.mount, r, n.criteriaMode, n.shouldUseNativeValidation)), R = async (Q) => {
    const { errors: me } = await L();
    if (Q)
      for (const ne of Q) {
        const pe = Pn(me, ne);
        pe ? Zi(o.errors, ne, pe) : Fs(o.errors, ne);
      }
    else
      o.errors = me;
    return me;
  }, T = async (Q, me, ne = {
    valid: !0
  }) => {
    for (const pe in Q) {
      const ge = Q[pe];
      if (ge) {
        const { _f: ve, ...Te } = ge;
        if (ve) {
          const Re = c.array.has(ve.name), Me = await IM(ge, a, h, n.shouldUseNativeValidation, Re);
          if (Me[ve.name] && (ne.valid = !1, me))
            break;
          !me && (Pn(Me, ve.name) ? Re ? Sse(o.errors, Me, ve.name) : Zi(o.errors, ve.name, Me[ve.name]) : Fs(o.errors, ve.name));
        }
        Te && await T(Te, me, ne);
      }
    }
    return ne.valid;
  }, D = () => {
    for (const Q of c.unMount) {
      const me = Pn(r, Q);
      me && (me._f.refs ? me._f.refs.every((ne) => !LO(ne)) : !LO(me._f.ref)) && J(Q);
    }
    c.unMount = /* @__PURE__ */ new Set();
  }, A = (Q, me) => (Q && me && Zi(a, Q, me), !Dh(P(), i)), S = (Q, me, ne) => $se(Q, c, {
    ...s.mount ? a : va(me) ? i : Fp(Q) ? { [Q]: me } : me
  }, ne, me), E = (Q) => Gy(Pn(s.mount ? a : i, Q, e.shouldUnregister ? Pn(i, Q, []) : [])), x = (Q, me, ne = {}) => {
    const pe = Pn(r, Q);
    let ge = me;
    if (pe) {
      const ve = pe._f;
      ve && (!ve.disabled && Zi(a, Q, Ise(me, ve)), ge = Rx(ve.ref) && dl(me) ? "" : me, Cse(ve.ref) ? [...ve.ref.options].forEach((Te) => Te.selected = ge.includes(Te.value)) : ve.refs ? L0(ve.ref) ? ve.refs.length > 1 ? ve.refs.forEach((Te) => (!Te.defaultChecked || !Te.disabled) && (Te.checked = Array.isArray(ge) ? !!ge.find((Re) => Re === Te.value) : ge === Te.value)) : ve.refs[0] && (ve.refs[0].checked = !!ge) : ve.refs.forEach((Te) => Te.checked = Te.value === ge) : cF(ve.ref) ? ve.ref.value = "" : (ve.ref.value = ge, ve.ref.type || p.values.next({
        name: Q,
        values: { ...a }
      })));
    }
    (ne.shouldDirty || ne.shouldTouch) && M(Q, ge, ne.shouldTouch, ne.shouldDirty, !0), ne.shouldValidate && F(Q);
  }, k = (Q, me, ne) => {
    for (const pe in me) {
      const ge = me[pe], ve = `${Q}.${pe}`, Te = Pn(r, ve);
      (c.array.has(Q) || !Dx(ge) || Te && !Te._f) && !Eb(ge) ? k(ve, ge, ne) : x(ve, ge, ne);
    }
  }, I = (Q, me, ne = {}) => {
    const pe = Pn(r, Q), ge = c.array.has(Q), ve = Au(me);
    Zi(a, Q, ve), ge ? (p.array.next({
      name: Q,
      values: { ...a }
    }), (_.isDirty || _.dirtyFields) && ne.shouldDirty && p.state.next({
      name: Q,
      dirtyFields: MO(i, a),
      isDirty: A(Q, ve)
    })) : pe && !pe._f && !dl(ve) ? k(Q, ve, ne) : x(Q, ve, ne), AM(Q, c) && p.state.next({ ...o }), p.values.next({
      name: Q,
      values: { ...a }
    }), !s.mount && t();
  }, z = async (Q) => {
    const me = Q.target;
    let ne = me.name;
    const pe = Pn(r, ne), ge = () => me.type ? FO(pe._f) : mse(Q);
    if (pe) {
      let ve, Te;
      const Re = ge(), Me = Q.type === Nx.BLUR || Q.type === Nx.FOCUS_OUT, et = !Gsc(pe._f) && !n.resolver && !Pn(o.errors, ne) && !pe._f.deps || Wsc(Me, Pn(o.touchedFields, ne), o.isSubmitted, f, g), st = AM(ne, c, Me);
      Zi(a, ne, Re), Me ? (pe._f.onBlur && pe._f.onBlur(Q), l && l(0)) : pe._f.onChange && pe._f.onChange(Q);
      const De = M(ne, Re, Me, !1), ze = !Tu(De) || st;
      if (!Me && p.values.next({
        name: ne,
        type: Q.type,
        values: { ...a }
      }), et)
        return _.isValid && v(), ze && p.state.next({ name: ne, ...st ? {} : De });
      if (!Me && st && p.state.next({ ...o }), b(!0), n.resolver) {
        const { errors: Pe } = await L([ne]), je = NG(o.errors, r, ne), He = NG(Pe, r, je.name || ne);
        ve = He.error, ne = He.name, Te = Tu(Pe);
      } else
        ve = (await IM(pe, a, h, n.shouldUseNativeValidation))[ne], ve ? Te = !1 : _.isValid && (Te = await T(r, !0));
      pe._f.deps && F(pe._f.deps), q(ne, Te, ve, De);
    }
  }, F = async (Q, me = {}) => {
    let ne, pe;
    const ge = zu(Q);
    if (b(!0), n.resolver) {
      const ve = await R(va(Q) ? Q : ge);
      ne = Tu(ve), pe = Q ? !ge.some((Te) => Pn(ve, Te)) : ne;
    } else
      Q ? (pe = (await Promise.all(ge.map(async (ve) => {
        const Te = Pn(r, ve);
        return await T(Te && Te._f ? { [ve]: Te } : Te);
      }))).every(Boolean), !(!pe && !o.isValid) && v()) : pe = ne = await T(r);
    return p.state.next({
      ...!Fp(Q) || _.isValid && ne !== o.isValid ? {} : { name: Q },
      ...n.resolver || !Q ? { isValid: ne } : {},
      errors: o.errors,
      isValidating: !1
    }), me.shouldFocus && !pe && zx(r, (ve) => ve && Pn(o.errors, ve), Q ? ge : c.mount), pe;
  }, P = (Q) => {
    const me = {
      ...i,
      ...s.mount ? a : {}
    };
    return va(Q) ? me : Fp(Q) ? Pn(me, Q) : Q.map((ne) => Pn(me, ne));
  }, O = (Q, me) => ({
    invalid: !!Pn((me || o).errors, Q),
    isDirty: !!Pn((me || o).dirtyFields, Q),
    isTouched: !!Pn((me || o).touchedFields, Q),
    error: Pn((me || o).errors, Q)
  }), V = (Q) => {
    Q && zu(Q).forEach((me) => Fs(o.errors, me)), p.state.next({
      errors: Q ? o.errors : {}
    });
  }, U = (Q, me, ne) => {
    const pe = (Pn(r, Q, { _f: {} })._f || {}).ref;
    Zi(o.errors, Q, {
      ...me,
      ref: pe
    }), p.state.next({
      name: Q,
      errors: o.errors,
      isValid: !1
    }), ne && ne.shouldFocus && pe && pe.focus && pe.focus();
  }, H = (Q, me) => Lb(Q) ? p.values.subscribe({
    next: (ne) => Q(S(void 0, me), ne)
  }) : S(Q, me, !0), J = (Q, me = {}) => {
    for (const ne of Q ? zu(Q) : c.mount)
      c.mount.delete(ne), c.array.delete(ne), Pn(r, ne) && (me.keepValue || (Fs(r, ne), Fs(a, ne)), !me.keepError && Fs(o.errors, ne), !me.keepDirty && Fs(o.dirtyFields, ne), !me.keepTouched && Fs(o.touchedFields, ne), !n.shouldUnregister && !me.keepDefaultValue && Fs(i, ne));
    p.values.next({
      values: { ...a }
    }), p.state.next({
      ...o,
      ...me.keepDirty ? { isDirty: A() } : {}
    }), !me.keepIsValid && v();
  }, le = (Q, me = {}) => {
    let ne = Pn(r, Q);
    const pe = Db(me.disabled);
    return Zi(r, Q, {
      ...ne || {},
      _f: {
        ...ne && ne._f ? ne._f : { ref: { name: Q } },
        name: Q,
        mount: !0,
        ...me
      }
    }), c.mount.add(Q), ne ? pe && Zi(a, Q, me.disabled ? void 0 : Pn(a, Q, FO(ne._f))) : N(Q, !0, me.value), {
      ...pe ? { disabled: me.disabled } : {},
      ...n.shouldUseNativeValidation ? {
        required: !!me.required,
        min: j$(me.min),
        max: j$(me.max),
        minLength: j$(me.minLength),
        maxLength: j$(me.maxLength),
        pattern: j$(me.pattern)
      } : {},
      name: Q,
      onChange: z,
      onBlur: z,
      ref: (ge) => {
        if (ge) {
          le(Q, me), ne = Pn(r, Q);
          const ve = va(ge.value) && ge.querySelectorAll && ge.querySelectorAll("input,select,textarea")[0] || ge, Te = Bsc(ve), Re = ne._f.refs || [];
          if (Te ? Re.find((Me) => Me === ve) : ve === ne._f.ref)
            return;
          Zi(r, Q, {
            _f: {
              ...ne._f,
              ...Te ? {
                refs: [
                  ...Re.filter(LO),
                  ve,
                  ...Array.isArray(Pn(i, Q)) ? [{}] : []
                ],
                ref: { type: ve.type, name: Q }
              } : { ref: ve }
            }
          }), N(Q, !1, void 0, ve);
        } else
          ne = Pn(r, Q, {}), ne._f && (ne._f.mount = !1), (n.shouldUnregister || me.shouldUnregister) && !(fse(c.array, Q) && s.action) && c.unMount.add(Q);
      }
    };
  }, ae = () => n.shouldFocusError && zx(r, (Q) => Q && Pn(o.errors, Q), c.mount), Y = (Q, me) => async (ne) => {
    ne && (ne.preventDefault && ne.preventDefault(), ne.persist && ne.persist());
    let pe = Au(a);
    if (p.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: ge, values: ve } = await L();
      o.errors = ge, pe = ve;
    } else
      await T(r);
    Fs(o.errors, "root"), Tu(o.errors) ? (p.state.next({
      errors: {}
    }), await Q(pe, ne)) : (me && await me({ ...o.errors }, ne), ae(), setTimeout(ae)), p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Tu(o.errors),
      submitCount: o.submitCount + 1,
      errors: o.errors
    });
  }, re = (Q, me = {}) => {
    Pn(r, Q) && (va(me.defaultValue) ? I(Q, Pn(i, Q)) : (I(Q, me.defaultValue), Zi(i, Q, me.defaultValue)), me.keepTouched || Fs(o.touchedFields, Q), me.keepDirty || (Fs(o.dirtyFields, Q), o.isDirty = me.defaultValue ? A(Q, Pn(i, Q)) : A()), me.keepError || (Fs(o.errors, Q), _.isValid && v()), p.state.next({ ...o }));
  }, ie = (Q, me = {}) => {
    const ne = Q || i, pe = Au(ne), ge = Q && !Tu(Q) ? pe : i;
    if (me.keepDefaultValues || (i = ne), !me.keepValues) {
      if (me.keepDirtyValues || d)
        for (const ve of c.mount)
          Pn(o.dirtyFields, ve) ? Zi(ge, ve, Pn(a, ve)) : I(ve, Pn(ge, ve));
      else {
        if (aF && va(Q))
          for (const ve of c.mount) {
            const Te = Pn(r, ve);
            if (Te && Te._f) {
              const Re = Array.isArray(Te._f.refs) ? Te._f.refs[0] : Te._f.ref;
              if (Rx(Re)) {
                const Me = Re.closest("form");
                if (Me) {
                  Me.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      a = e.shouldUnregister ? me.keepDefaultValues ? Au(i) : {} : pe, p.array.next({
        values: ge
      }), p.values.next({
        values: ge
      });
    }
    c = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !s.mount && t(), s.mount = !_.isValid || !!me.keepIsValid, s.watch = !!e.shouldUnregister, p.state.next({
      submitCount: me.keepSubmitCount ? o.submitCount : 0,
      isDirty: me.keepDirty ? o.isDirty : !!(me.keepDefaultValues && !Dh(Q, i)),
      isSubmitted: me.keepIsSubmitted ? o.isSubmitted : !1,
      dirtyFields: me.keepDirtyValues ? o.dirtyFields : me.keepDefaultValues && Q ? MO(i, Q) : {},
      touchedFields: me.keepTouched ? o.touchedFields : {},
      errors: me.keepErrors ? o.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, _e = (Q, me) => ie(Lb(Q) ? Q(a) : Q, me), he = (Q, me = {}) => {
    const ne = Pn(r, Q), pe = ne && ne._f;
    if (pe) {
      const ge = pe.refs ? pe.refs[0] : pe.ref;
      ge.focus && (ge.focus(), me.shouldSelect && ge.select());
    }
  }, be = (Q) => {
    o = {
      ...o,
      ...Q
    };
  };
  return Lb(n.defaultValues) && n.defaultValues().then((Q) => {
    _e(Q, n.resetOptions), p.state.next({
      isLoading: !1
    });
  }), {
    control: {
      register: le,
      unregister: J,
      getFieldState: O,
      _executeSchema: L,
      _getWatch: S,
      _getDirty: A,
      _updateValid: v,
      _removeUnmounted: D,
      _updateFieldArray: y,
      _getFieldArray: E,
      _reset: ie,
      _updateFormState: be,
      _subjects: p,
      _proxyFormState: _,
      get _fields() {
        return r;
      },
      get _formValues() {
        return a;
      },
      get _stateFlags() {
        return s;
      },
      set _stateFlags(Q) {
        s = Q;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return c;
      },
      set _names(Q) {
        c = Q;
      },
      get _formState() {
        return o;
      },
      set _formState(Q) {
        o = Q;
      },
      get _options() {
        return n;
      },
      set _options(Q) {
        n = {
          ...n,
          ...Q
        };
      }
    },
    trigger: F,
    register: le,
    handleSubmit: Y,
    watch: H,
    setValue: I,
    getValues: P,
    reset: _e,
    resetField: re,
    clearErrors: V,
    unregister: J,
    setError: U,
    setFocus: he,
    getFieldState: O
  };
}
function W_(e = {}) {
  const t = Fe.useRef(), [n, o] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: !0,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: Lb(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...Ksc(e, () => o((i) => ({ ...i }))),
    formState: n
  });
  const r = t.current.control;
  return r._options = e, DT({
    subject: r._subjects.state,
    next: (i) => {
      bse(i, r._proxyFormState, r._updateFormState, !0) && o({ ...r._formState });
    }
  }), Fe.useEffect(() => {
    e.values && !Dh(e.values, r._defaultValues) && r._reset(e.values, r._options.resetOptions);
  }, [e.values, r]), Fe.useEffect(() => {
    r._stateFlags.mount || (r._updateValid(), r._stateFlags.mount = !0), r._stateFlags.watch && (r._stateFlags.watch = !1, r._subjects.state.next({ ...r._formState })), r._removeUnmounted();
  }), t.current.formState = vse(n, r), t.current;
}
var Zsc = { VITE_BOOKER_EMBED_API_URL: "https://api.cal.com/v2", VITE_BOOKER_EMBED_OAUTH_CLIENT_ID: "cm165l146000nqi1mrz8vscja", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const zG = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (u, d) => {
    const _ = typeof u == "function" ? u(t) : u;
    if (!Object.is(_, t)) {
      const p = t;
      t = d ?? (typeof _ != "object" || _ === null) ? _ : Object.assign({}, t, _), n.forEach((g) => g(t, p));
    }
  }, r = () => t, c = { setState: o, getState: r, getInitialState: () => l, subscribe: (u) => (n.add(u), () => n.delete(u)), destroy: () => {
    (Zsc ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, l = t = e(o, r, c);
  return c;
}, Ose = (e) => e ? zG(e) : zG;
var OM = { exports: {} }, qO = {}, vS = { exports: {} }, jO = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RG;
function Xsc() {
  return RG || (RG = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Fe, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(b) {
      {
        for (var y = arguments.length, w = new Array(y > 1 ? y - 1 : 0), N = 1; N < y; N++)
          w[N - 1] = arguments[N];
        o("error", b, w);
      }
    }
    function o(b, y, w) {
      {
        var N = t.ReactDebugCurrentFrame, M = N.getStackAddendum();
        M !== "" && (y += "%s", w = w.concat([M]));
        var q = w.map(function(L) {
          return String(L);
        });
        q.unshift("Warning: " + y), Function.prototype.apply.call(console[b], console, q);
      }
    }
    function r(b, y) {
      return b === y && (b !== 0 || 1 / b === 1 / y) || b !== b && y !== y;
    }
    var i = typeof Object.is == "function" ? Object.is : r, a = e.useState, s = e.useEffect, c = e.useLayoutEffect, l = e.useDebugValue, u = !1, d = !1;
    function _(b, y, w) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var N = y();
      if (!d) {
        var M = y();
        i(N, M) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var q = a({
        inst: {
          value: N,
          getSnapshot: y
        }
      }), L = q[0].inst, R = q[1];
      return c(function() {
        L.value = N, L.getSnapshot = y, p(L) && R({
          inst: L
        });
      }, [b, N, y]), s(function() {
        p(L) && R({
          inst: L
        });
        var T = function() {
          p(L) && R({
            inst: L
          });
        };
        return b(T);
      }, [b]), l(N), N;
    }
    function p(b) {
      var y = b.getSnapshot, w = b.value;
      try {
        var N = y();
        return !i(w, N);
      } catch {
        return !0;
      }
    }
    function g(b, y, w) {
      return y();
    }
    var f = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", h = !f, $ = h ? g : _, v = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : $;
    jO.useSyncExternalStore = v, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), jO;
}
var VO = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PG;
function Jsc() {
  if (PG)
    return VO;
  PG = 1;
  var e = Fe;
  function t(d, _) {
    return d === _ && (d !== 0 || 1 / d === 1 / _) || d !== d && _ !== _;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, r = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function s(d, _) {
    var p = _(), g = o({ inst: { value: p, getSnapshot: _ } }), f = g[0].inst, h = g[1];
    return i(function() {
      f.value = p, f.getSnapshot = _, c(f) && h({ inst: f });
    }, [d, p, _]), r(function() {
      return c(f) && h({ inst: f }), d(function() {
        c(f) && h({ inst: f });
      });
    }, [d]), a(p), p;
  }
  function c(d) {
    var _ = d.getSnapshot;
    d = d.value;
    try {
      var p = _();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function l(d, _) {
    return _();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : s;
  return VO.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, VO;
}
var DG;
function Nse() {
  return DG || (DG = 1, process.env.NODE_ENV === "production" ? vS.exports = Jsc() : vS.exports = Xsc()), vS.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LG;
function Qsc() {
  return LG || (LG = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Fe, t = Nse();
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var o = typeof Object.is == "function" ? Object.is : n, r = t.useSyncExternalStore, i = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
    function l(u, d, _, p, g) {
      var f = i(null), h;
      f.current === null ? (h = {
        hasValue: !1,
        value: null
      }, f.current = h) : h = f.current;
      var $ = s(function() {
        var w = !1, N, M, q = function(D) {
          if (!w) {
            w = !0, N = D;
            var A = p(D);
            if (g !== void 0 && h.hasValue) {
              var S = h.value;
              if (g(S, A))
                return M = S, S;
            }
            return M = A, A;
          }
          var E = N, x = M;
          if (o(E, D))
            return x;
          var k = p(D);
          return g !== void 0 && g(x, k) ? x : (N = D, M = k, k);
        }, L = _ === void 0 ? null : _, R = function() {
          return q(d());
        }, T = L === null ? void 0 : function() {
          return q(L());
        };
        return [R, T];
      }, [d, _, p, g]), v = $[0], b = $[1], y = r(u, v, b);
      return a(function() {
        h.hasValue = !0, h.value = y;
      }, [y]), c(y), y;
    }
    qO.useSyncExternalStoreWithSelector = l, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), qO;
}
var BO = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MG;
function ecc() {
  if (MG)
    return BO;
  MG = 1;
  var e = Fe, t = Nse();
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = t.useSyncExternalStore, i = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
  return BO.useSyncExternalStoreWithSelector = function(l, u, d, _, p) {
    var g = i(null);
    if (g.current === null) {
      var f = { hasValue: !1, value: null };
      g.current = f;
    } else
      f = g.current;
    g = s(function() {
      function $(N) {
        if (!v) {
          if (v = !0, b = N, N = _(N), p !== void 0 && f.hasValue) {
            var M = f.value;
            if (p(M, N))
              return y = M;
          }
          return y = N;
        }
        if (M = y, o(b, N))
          return M;
        var q = _(N);
        return p !== void 0 && p(M, q) ? M : (b = N, y = q);
      }
      var v = !1, b, y, w = d === void 0 ? null : d;
      return [function() {
        return $(u());
      }, w === null ? void 0 : function() {
        return $(w());
      }];
    }, [u, d, _, p]);
    var h = r(l, g[0], g[1]);
    return a(function() {
      f.hasValue = !0, f.value = h;
    }, [h]), c(h), h;
  }, BO;
}
process.env.NODE_ENV === "production" ? OM.exports = ecc() : OM.exports = Qsc();
var tcc = OM.exports;
const zse = /* @__PURE__ */ Mi(tcc);
var Rse = { VITE_BOOKER_EMBED_API_URL: "https://api.cal.com/v2", VITE_BOOKER_EMBED_OAUTH_CLIENT_ID: "cm165l146000nqi1mrz8vscja", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue: ncc } = Fe, { useSyncExternalStoreWithSelector: occ } = zse;
let FG = !1;
const rcc = (e) => e;
function uF(e, t = rcc, n) {
  (Rse ? "production" : void 0) !== "production" && n && !FG && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), FG = !0);
  const o = occ(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return ncc(o), o;
}
const qG = (e) => {
  (Rse ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? Ose(e) : e, n = (o, r) => uF(t, o, r);
  return Object.assign(n, t), n;
}, dF = (e) => e ? qG(e) : qG, { useDebugValue: icc } = Fe, { useSyncExternalStoreWithSelector: acc } = zse, scc = (e) => e;
function ccc(e, t = scc, n) {
  const o = acc(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return icc(o), o;
}
const jG = (e, t) => {
  const n = Ose(e), o = (r, i = t) => ccc(n, r, i);
  return Object.assign(o, n), o;
}, lcc = (e, t) => e ? jG(e, t) : jG;
process.env.NEXT_PUBLIC_VERCEL_URL && `${process.env.NEXT_PUBLIC_VERCEL_URL}`;
process.env.RAILWAY_STATIC_URL && `${process.env.RAILWAY_STATIC_URL}`;
process.env.HEROKU_APP_NAME && `${process.env.HEROKU_APP_NAME}`;
process.env.RENDER_EXTERNAL_URL && `${process.env.RENDER_EXTERNAL_URL}`;
const ucc = process.env.CALCOM_ENV || process.env.NODE_ENV, qE = ucc === "production";
process.env.NODE_ENV;
process.env.ORGANIZER_EMAIL_EXEMPT_DOMAINS;
process.env.NEXT_PUBLIC_SINGLE_ORG_SLUG;
const Wa = "https://app.cal.com", Vw = process.env.NEXT_PUBLIC_WEBSITE_URL || "https://cal.com", Kp = process.env.NEXT_PUBLIC_APP_NAME || "Cal.com";
process.env.NEXT_PUBLIC_SUPPORT_MAIL_ADDRESS;
const dcc = process.env.NEXT_PUBLIC_COMPANY_NAME || "Cal.com, Inc.";
process.env.NEXT_PUBLIC_SENDER_ID;
process.env.NEXT_PUBLIC_SENDGRID_SENDER_NAME;
process.env.EMAIL_FROM_NAME;
const VG = new URL(Wa).hostname.endsWith(".vercel.app") ? Wa : process.env.NEXT_PUBLIC_WEBSITE_URL || Wa, Pse = new URL(Wa).hostname.endsWith("cal.com") || new URL(Wa).hostname.endsWith("cal.dev") || new URL(Wa).hostname.endsWith("cal.qa") || new URL(Wa).hostname.endsWith("cal-staging.com") || new URL(Wa).hostname.endsWith("cal.eu");
new URL(Wa).hostname.endsWith(".cal.dev") || new URL(Wa).hostname.endsWith(".cal.qa") || new URL(Wa).hostname.endsWith(".cal-staging.com") || process.env.NODE_ENV;
const _cc = [".cal.com", ".cal.dev", ".cal.eu", ".cal.qa"], pcc = new URL(Wa).hostname, Sf = !_cc.some((e) => pcc.endsWith(e)), mcc = process.env.NEXT_PUBLIC_EMBED_LIB_URL || `${Wa}/embed/embed.js`, bS = 1e3, Mb = 1440, Fb = 1, fcc = process.env.NEXT_PUBLIC_HOSTED_CAL_FEATURES || !Sf;
parseInt(process.env.NEXT_PUBLIC_QUERY_RESERVATION_INTERVAL_SECONDS ?? "", 10);
parseInt(process.env.NEXT_PUBLIC_QUERY_RESERVATION_STALE_TIME_SECONDS ?? "", 10);
const gcc = parseInt(process.env.NEXT_PUBLIC_QUERY_AVAILABLE_SLOTS_INTERVAL_SECONDS ?? "", 10) || 5 * 60, Dse = process.env.NEXT_PUBLIC_INVALIDATE_AVAILABLE_SLOTS_ON_BOOKING_FORM === "1", hcc = parseInt(process.env.NEXT_PUBLIC_QUICK_AVAILABILITY_ROLLOUT ?? "", 10) || 0, Lse = "/avatar.svg", vcc = "https://cal.com/roadmap", bcc = "https://cal.com/download", ycc = "https://go.cal.com/booking", $cc = !!(process.env.STRIPE_CLIENT_ID && process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY && process.env.STRIPE_PRIVATE_KEY);
process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY;
const wcc = process.env.NEXT_PUBLIC_MINUTES_TO_BOOK || "5", Mse = process.env.NEXT_PUBLIC_ENABLE_PROFILE_SWITCHER === "1";
JSON.parse(`[${process.env.ALLOWED_HOSTNAMES || ""}]`);
JSON.parse(`[${process.env.RESERVED_SUBDOMAINS || ""}]`);
parseInt(
  process.env.NEXT_PUBLIC_ORGANIZATIONS_MIN_SELF_SERVE_SEATS || "5"
);
parseFloat(
  process.env.NEXT_PUBLIC_ORGANIZATIONS_SELF_SERVE_PRICE_NEW || "37"
);
process.env.E2E_TEST_MAILHOG_ENABLED;
const Fse = process.env.NEXT_PUBLIC_CALCOM_VERSION;
process.env.CALCOM_CREDENTIAL_SYNC_SECRET && process.env.CALCOM_APP_CREDENTIAL_ENCRYPTION_KEY;
process.env.CALCOM_CREDENTIAL_SYNC_SECRET;
process.env.CALCOM_CREDENTIAL_SYNC_HEADER_NAME;
process.env.CALCOM_CREDENTIAL_SYNC_ENDPOINT;
process.env.CALCOM_SERVICE_ACCOUNT_ENCRYPTION_KEY;
const _F = "#292929", pF = "#fafafa", qse = 40;
(Pse || process.env.NEXT_PUBLIC_IS_E2E && $cc) && process.env.NEXT_PUBLIC_STRIPE_PREMIUM_PLAN_PRICE_MONTHLY;
var ere, tre;
const kcc = !!((tre = (ere = globalThis.window) == null ? void 0 : ere.Meticulous) != null && tre.isRunningAsTest), NM = parseInt(
  process.env.NEXT_PUBLIC_BOOKER_NUMBER_OF_DAYS_TO_LOAD ?? "0",
  0
), zM = process.env.NEXT_PUBLIC_CLOUDFLARE_SITEKEY, Scc = process.env.NEXT_PUBLIC_CLOUDFLARE_USE_TURNSTILE_IN_BOOKER;
process.env.NEXT_PUBLIC_ORG_SELF_SERVE_ENABLED;
process.env.CALCOM_PRIVATE_API_ROUTE;
const BG = process.env.NEXT_PUBLIC_WEBSITE_PRIVACY_POLICY_URL || "https://cal.com/privacy", UG = process.env.NEXT_PUBLIC_WEBSITE_TERMS_URL || "https://cal.com/terms";
process.env.LINGO_DOT_DEV_API_KEY;
const RM = 61;
var nre;
(nre = process.env.DIRECTORY_IDS_TO_LOG) != null && nre.split(",");
!Sf && process.env.IFFY_API_KEY;
const Ecc = !!process.env.NEXT_PUBLIC_DUB_PROGRAM_ID && process.env.NEXT_PUBLIC_DUB_PROGRAM_ID !== "";
process.env.CAL_VIDEO_MEETING_LINK_FOR_TESTING;
process.env.NEXT_PUBLIC_STRIPE_CREDITS_PRICE_ID || process.env.NEXT_PUBLIC_IS_E2E;
parseInt(process.env.DATABASE_CHUNK_SIZE || "25", 10);
const Mx = "default_group_id", UO = process.env.NEXT_PUBLIC_CAL_AI_PHONE_NUMBER_MONTHLY_PRICE;
(() => {
  const e = UO && UO.trim() !== "" ? Number(UO) : NaN;
  return Number.isFinite(e) ? e : 5;
})();
process.env.RETELL_AI_TEST_MODE;
(() => {
  if (!process.env.RETELL_AI_TEST_EVENT_TYPE_MAP)
    return null;
  try {
    return JSON.parse(process.env.RETELL_AI_TEST_EVENT_TYPE_MAP);
  } catch (e) {
    return console.warn("Failed to parse RETELL_AI_TEST_EVENT_TYPE_MAP", e), null;
  }
})();
process.env._CAL_INTERNAL_PAST_BOOKING_RESCHEDULE_CHANGE_TEAM_IDS;
var Gr;
(function(e) {
  e.assertEqual = (r) => r;
  function t(r) {
  }
  e.assertIs = t;
  function n(r) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (r) => {
    const i = {};
    for (const a of r)
      i[a] = a;
    return i;
  }, e.getValidEnumValues = (r) => {
    const i = e.objectKeys(r).filter((s) => typeof r[r[s]] != "number"), a = {};
    for (const s of i)
      a[s] = r[s];
    return e.objectValues(a);
  }, e.objectValues = (r) => e.objectKeys(r).map(function(i) {
    return r[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const i = [];
    for (const a in r)
      Object.prototype.hasOwnProperty.call(r, a) && i.push(a);
    return i;
  }, e.find = (r, i) => {
    for (const a of r)
      if (i(a))
        return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function o(r, i = " | ") {
    return r.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  e.joinValues = o, e.jsonStringifyReplacer = (r, i) => typeof i == "bigint" ? i.toString() : i;
})(Gr || (Gr = {}));
var PM;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(PM || (PM = {}));
const Hn = Gr.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ng = (e) => {
  switch (typeof e) {
    case "undefined":
      return Hn.undefined;
    case "string":
      return Hn.string;
    case "number":
      return isNaN(e) ? Hn.nan : Hn.number;
    case "boolean":
      return Hn.boolean;
    case "function":
      return Hn.function;
    case "bigint":
      return Hn.bigint;
    case "symbol":
      return Hn.symbol;
    case "object":
      return Array.isArray(e) ? Hn.array : e === null ? Hn.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Hn.promise : typeof Map < "u" && e instanceof Map ? Hn.map : typeof Set < "u" && e instanceof Set ? Hn.set : typeof Date < "u" && e instanceof Date ? Hn.date : Hn.object;
    default:
      return Hn.unknown;
  }
}, yn = Gr.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), xcc = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class Du extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (o) => {
      this.issues = [...this.issues, o];
    }, this.addIssues = (o = []) => {
      this.issues = [...this.issues, ...o];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function(i) {
      return i.message;
    }, o = { _errors: [] }, r = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(r);
        else if (a.code === "invalid_return_type")
          r(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          r(a.argumentsError);
        else if (a.path.length === 0)
          o._errors.push(n(a));
        else {
          let s = o, c = 0;
          for (; c < a.path.length; ) {
            const l = a.path[c];
            c === a.path.length - 1 ? (s[l] = s[l] || { _errors: [] }, s[l]._errors.push(n(a))) : s[l] = s[l] || { _errors: [] }, s = s[l], c++;
          }
        }
    };
    return r(this), o;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Gr.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, o = [];
    for (const r of this.issues)
      r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(t(r))) : o.push(t(r));
    return { formErrors: o, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Du.create = (e) => new Du(e);
const hk = (e, t) => {
  let n;
  switch (e.code) {
    case yn.invalid_type:
      e.received === Hn.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case yn.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, Gr.jsonStringifyReplacer)}`;
      break;
    case yn.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${Gr.joinValues(e.keys, ", ")}`;
      break;
    case yn.invalid_union:
      n = "Invalid input";
      break;
    case yn.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${Gr.joinValues(e.options)}`;
      break;
    case yn.invalid_enum_value:
      n = `Invalid enum value. Expected ${Gr.joinValues(e.options)}, received '${e.received}'`;
      break;
    case yn.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case yn.invalid_return_type:
      n = "Invalid function return type";
      break;
    case yn.invalid_date:
      n = "Invalid date";
      break;
    case yn.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : Gr.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case yn.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case yn.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case yn.custom:
      n = "Invalid input";
      break;
    case yn.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case yn.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case yn.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, Gr.assertNever(e);
  }
  return { message: n };
};
let jse = hk;
function Ccc(e) {
  jse = e;
}
function Fx() {
  return jse;
}
const qx = (e) => {
  const { data: t, path: n, errorMaps: o, issueData: r } = e, i = [...n, ...r.path || []], a = {
    ...r,
    path: i
  };
  let s = "";
  const c = o.filter((l) => !!l).slice().reverse();
  for (const l of c)
    s = l(a, { data: t, defaultError: s }).message;
  return {
    ...r,
    path: i,
    message: r.message || s
  };
}, Tcc = [];
function Kn(e, t) {
  const n = qx({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      Fx(),
      hk
      // then global default map
    ].filter((o) => !!o)
  });
  e.common.issues.push(n);
}
class Mc {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const o = [];
    for (const r of n) {
      if (r.status === "aborted")
        return Qo;
      r.status === "dirty" && t.dirty(), o.push(r.value);
    }
    return { status: t.value, value: o };
  }
  static async mergeObjectAsync(t, n) {
    const o = [];
    for (const r of n)
      o.push({
        key: await r.key,
        value: await r.value
      });
    return Mc.mergeObjectSync(t, o);
  }
  static mergeObjectSync(t, n) {
    const o = {};
    for (const r of n) {
      const { key: i, value: a } = r;
      if (i.status === "aborted" || a.status === "aborted")
        return Qo;
      i.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || r.alwaysSet) && (o[i.value] = a.value);
    }
    return { status: t.value, value: o };
  }
}
const Qo = Object.freeze({
  status: "aborted"
}), Vse = (e) => ({ status: "dirty", value: e }), yl = (e) => ({ status: "valid", value: e }), DM = (e) => e.status === "aborted", LM = (e) => e.status === "dirty", vk = (e) => e.status === "valid", jx = (e) => typeof Promise < "u" && e instanceof Promise;
var vo;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(vo || (vo = {}));
class Zp {
  constructor(t, n, o, r) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = o, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const GG = (e, t) => {
  if (vk(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Du(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function or(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: o, description: r } = e;
  if (t && (n || o))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: r } : { errorMap: (a, s) => a.code !== "invalid_type" ? { message: s.defaultError } : typeof s.data > "u" ? { message: o ?? s.defaultError } : { message: n ?? s.defaultError }, description: r };
}
class pr {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ng(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: ng(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Mc(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ng(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (jx(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const o = this.safeParse(t, n);
    if (o.success)
      return o.data;
    throw o.error;
  }
  safeParse(t, n) {
    var o;
    const r = {
      common: {
        issues: [],
        async: (o = n == null ? void 0 : n.async) !== null && o !== void 0 ? o : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ng(t)
    }, i = this._parseSync({ data: t, path: r.path, parent: r });
    return GG(r, i);
  }
  async parseAsync(t, n) {
    const o = await this.safeParseAsync(t, n);
    if (o.success)
      return o.data;
    throw o.error;
  }
  async safeParseAsync(t, n) {
    const o = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ng(t)
    }, r = this._parse({ data: t, path: o.path, parent: o }), i = await (jx(r) ? r : Promise.resolve(r));
    return GG(o, i);
  }
  refine(t, n) {
    const o = (r) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, i) => {
      const a = t(r), s = () => i.addIssue({
        code: yn.custom,
        ...o(r)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (s(), !1)) : a ? !0 : (s(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((o, r) => t(o) ? !0 : (r.addIssue(typeof n == "function" ? n(o, r) : n), !1));
  }
  _refinement(t) {
    return new M_({
      schema: this,
      typeName: Ro.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return lf.create(this, this._def);
  }
  nullable() {
    return dv.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return D_.create(this, this._def);
  }
  promise() {
    return ky.create(this, this._def);
  }
  or(t) {
    return wk.create([this, t], this._def);
  }
  and(t) {
    return kk.create(this, t, this._def);
  }
  transform(t) {
    return new M_({
      ...or(this._def),
      schema: this,
      typeName: Ro.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Tk({
      ...or(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Ro.ZodDefault
    });
  }
  brand() {
    return new Use({
      typeName: Ro.ZodBranded,
      type: this,
      ...or(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Gx({
      ...or(this._def),
      innerType: this,
      catchValue: n,
      typeName: Ro.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return F0.create(this, t);
  }
  readonly() {
    return Hx.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Acc = /^c[^\s-]{8,}$/i, Icc = /^[a-z][a-z0-9]*$/, Occ = /^[0-9A-HJKMNP-TV-Z]{26}$/, Ncc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, zcc = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Rcc = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let GO;
const Pcc = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Dcc = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Lcc = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Mcc(e, t) {
  return !!((t === "v4" || !t) && Pcc.test(e) || (t === "v6" || !t) && Dcc.test(e));
}
class O_ extends pr {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Hn.string) {
      const i = this._getOrReturnCtx(t);
      return Kn(
        i,
        {
          code: yn.invalid_type,
          expected: Hn.string,
          received: i.parsedType
        }
        //
      ), Qo;
    }
    const o = new Mc();
    let r;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (r = this._getOrReturnCtx(t, r), Kn(r, {
          code: yn.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), o.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (r = this._getOrReturnCtx(t, r), Kn(r, {
          code: yn.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), o.dirty());
      else if (i.kind === "length") {
        const a = t.data.length > i.value, s = t.data.length < i.value;
        (a || s) && (r = this._getOrReturnCtx(t, r), a ? Kn(r, {
          code: yn.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && Kn(r, {
          code: yn.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), o.dirty());
      } else if (i.kind === "email")
        zcc.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "email",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "emoji")
        GO || (GO = new RegExp(Rcc, "u")), GO.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "emoji",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "uuid")
        Ncc.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "uuid",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "cuid")
        Acc.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "cuid",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "cuid2")
        Icc.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "cuid2",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "ulid")
        Occ.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "ulid",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          r = this._getOrReturnCtx(t, r), Kn(r, {
            validation: "url",
            code: yn.invalid_string,
            message: i.message
          }), o.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "regex",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          code: yn.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), o.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          code: yn.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), o.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          code: yn.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), o.dirty()) : i.kind === "datetime" ? Lcc(i).test(t.data) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          code: yn.invalid_string,
          validation: "datetime",
          message: i.message
        }), o.dirty()) : i.kind === "ip" ? Mcc(t.data, i.version) || (r = this._getOrReturnCtx(t, r), Kn(r, {
          validation: "ip",
          code: yn.invalid_string,
          message: i.message
        }), o.dirty()) : Gr.assertNever(i);
    return { status: o.value, value: t.data };
  }
  _regex(t, n, o) {
    return this.refinement((r) => t.test(r), {
      validation: n,
      code: yn.invalid_string,
      ...vo.errToObj(o)
    });
  }
  _addCheck(t) {
    return new O_({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...vo.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...vo.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...vo.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...vo.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...vo.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...vo.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...vo.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...vo.errToObj(t) });
  }
  datetime(t) {
    var n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      ...vo.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...vo.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...vo.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...vo.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...vo.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...vo.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...vo.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...vo.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, vo.errToObj(t));
  }
  trim() {
    return new O_({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new O_({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new O_({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
O_.create = (e) => {
  var t;
  return new O_({
    checks: [],
    typeName: Ro.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...or(e)
  });
};
function Fcc(e, t) {
  const n = (e.toString().split(".")[1] || "").length, o = (t.toString().split(".")[1] || "").length, r = n > o ? n : o, i = parseInt(e.toFixed(r).replace(".", "")), a = parseInt(t.toFixed(r).replace(".", ""));
  return i % a / Math.pow(10, r);
}
class Ng extends pr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Hn.number) {
      const i = this._getOrReturnCtx(t);
      return Kn(i, {
        code: yn.invalid_type,
        expected: Hn.number,
        received: i.parsedType
      }), Qo;
    }
    let o;
    const r = new Mc();
    for (const i of this._def.checks)
      i.kind === "int" ? Gr.isInteger(t.data) || (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), r.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? Fcc(t.data, i.value) !== 0 && (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.not_finite,
        message: i.message
      }), r.dirty()) : Gr.assertNever(i);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, vo.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, vo.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, vo.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, vo.toString(n));
  }
  setLimit(t, n, o, r) {
    return new Ng({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: o,
          message: vo.toString(r)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ng({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: vo.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: vo.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: vo.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: vo.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: vo.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: vo.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: vo.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: vo.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: vo.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Gr.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const o of this._def.checks) {
      if (o.kind === "finite" || o.kind === "int" || o.kind === "multipleOf")
        return !0;
      o.kind === "min" ? (n === null || o.value > n) && (n = o.value) : o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Ng.create = (e) => new Ng({
  checks: [],
  typeName: Ro.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...or(e)
});
class zg extends pr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== Hn.bigint) {
      const i = this._getOrReturnCtx(t);
      return Kn(i, {
        code: yn.invalid_type,
        expected: Hn.bigint,
        received: i.parsedType
      }), Qo;
    }
    let o;
    const r = new Mc();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (o = this._getOrReturnCtx(t, o), Kn(o, {
        code: yn.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : Gr.assertNever(i);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, vo.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, vo.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, vo.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, vo.toString(n));
  }
  setLimit(t, n, o, r) {
    return new zg({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: o,
          message: vo.toString(r)
        }
      ]
    });
  }
  _addCheck(t) {
    return new zg({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: vo.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: vo.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: vo.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: vo.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: vo.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
zg.create = (e) => {
  var t;
  return new zg({
    checks: [],
    typeName: Ro.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...or(e)
  });
};
class bk extends pr {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Hn.boolean) {
      const o = this._getOrReturnCtx(t);
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.boolean,
        received: o.parsedType
      }), Qo;
    }
    return yl(t.data);
  }
}
bk.create = (e) => new bk({
  typeName: Ro.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...or(e)
});
class lv extends pr {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Hn.date) {
      const i = this._getOrReturnCtx(t);
      return Kn(i, {
        code: yn.invalid_type,
        expected: Hn.date,
        received: i.parsedType
      }), Qo;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return Kn(i, {
        code: yn.invalid_date
      }), Qo;
    }
    const o = new Mc();
    let r;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (r = this._getOrReturnCtx(t, r), Kn(r, {
        code: yn.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), o.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (r = this._getOrReturnCtx(t, r), Kn(r, {
        code: yn.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), o.dirty()) : Gr.assertNever(i);
    return {
      status: o.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new lv({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: vo.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: vo.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
lv.create = (e) => new lv({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Ro.ZodDate,
  ...or(e)
});
class Vx extends pr {
  _parse(t) {
    if (this._getType(t) !== Hn.symbol) {
      const o = this._getOrReturnCtx(t);
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.symbol,
        received: o.parsedType
      }), Qo;
    }
    return yl(t.data);
  }
}
Vx.create = (e) => new Vx({
  typeName: Ro.ZodSymbol,
  ...or(e)
});
class yk extends pr {
  _parse(t) {
    if (this._getType(t) !== Hn.undefined) {
      const o = this._getOrReturnCtx(t);
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.undefined,
        received: o.parsedType
      }), Qo;
    }
    return yl(t.data);
  }
}
yk.create = (e) => new yk({
  typeName: Ro.ZodUndefined,
  ...or(e)
});
class $k extends pr {
  _parse(t) {
    if (this._getType(t) !== Hn.null) {
      const o = this._getOrReturnCtx(t);
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.null,
        received: o.parsedType
      }), Qo;
    }
    return yl(t.data);
  }
}
$k.create = (e) => new $k({
  typeName: Ro.ZodNull,
  ...or(e)
});
class wy extends pr {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return yl(t.data);
  }
}
wy.create = (e) => new wy({
  typeName: Ro.ZodAny,
  ...or(e)
});
class Qh extends pr {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return yl(t.data);
  }
}
Qh.create = (e) => new Qh({
  typeName: Ro.ZodUnknown,
  ...or(e)
});
class vf extends pr {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return Kn(n, {
      code: yn.invalid_type,
      expected: Hn.never,
      received: n.parsedType
    }), Qo;
  }
}
vf.create = (e) => new vf({
  typeName: Ro.ZodNever,
  ...or(e)
});
class Bx extends pr {
  _parse(t) {
    if (this._getType(t) !== Hn.undefined) {
      const o = this._getOrReturnCtx(t);
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.void,
        received: o.parsedType
      }), Qo;
    }
    return yl(t.data);
  }
}
Bx.create = (e) => new Bx({
  typeName: Ro.ZodVoid,
  ...or(e)
});
class D_ extends pr {
  _parse(t) {
    const { ctx: n, status: o } = this._processInputParams(t), r = this._def;
    if (n.parsedType !== Hn.array)
      return Kn(n, {
        code: yn.invalid_type,
        expected: Hn.array,
        received: n.parsedType
      }), Qo;
    if (r.exactLength !== null) {
      const a = n.data.length > r.exactLength.value, s = n.data.length < r.exactLength.value;
      (a || s) && (Kn(n, {
        code: a ? yn.too_big : yn.too_small,
        minimum: s ? r.exactLength.value : void 0,
        maximum: a ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), o.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (Kn(n, {
      code: yn.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), o.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (Kn(n, {
      code: yn.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), o.dirty()), n.common.async)
      return Promise.all([...n.data].map((a, s) => r.type._parseAsync(new Zp(n, a, n.path, s)))).then((a) => Mc.mergeArray(o, a));
    const i = [...n.data].map((a, s) => r.type._parseSync(new Zp(n, a, n.path, s)));
    return Mc.mergeArray(o, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new D_({
      ...this._def,
      minLength: { value: t, message: vo.toString(n) }
    });
  }
  max(t, n) {
    return new D_({
      ...this._def,
      maxLength: { value: t, message: vo.toString(n) }
    });
  }
  length(t, n) {
    return new D_({
      ...this._def,
      exactLength: { value: t, message: vo.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
D_.create = (e, t) => new D_({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ro.ZodArray,
  ...or(t)
});
function yb(e) {
  if (e instanceof Aa) {
    const t = {};
    for (const n in e.shape) {
      const o = e.shape[n];
      t[n] = lf.create(yb(o));
    }
    return new Aa({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof D_ ? new D_({
      ...e._def,
      type: yb(e.element)
    }) : e instanceof lf ? lf.create(yb(e.unwrap())) : e instanceof dv ? dv.create(yb(e.unwrap())) : e instanceof Xp ? Xp.create(e.items.map((t) => yb(t))) : e;
}
class Aa extends pr {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = Gr.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== Hn.object) {
      const l = this._getOrReturnCtx(t);
      return Kn(l, {
        code: yn.invalid_type,
        expected: Hn.object,
        received: l.parsedType
      }), Qo;
    }
    const { status: o, ctx: r } = this._processInputParams(t), { shape: i, keys: a } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof vf && this._def.unknownKeys === "strip"))
      for (const l in r.data)
        a.includes(l) || s.push(l);
    const c = [];
    for (const l of a) {
      const u = i[l], d = r.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: u._parse(new Zp(r, d, r.path, l)),
        alwaysSet: l in r.data
      });
    }
    if (this._def.catchall instanceof vf) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of s)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: r.data[u] }
          });
      else if (l === "strict")
        s.length > 0 && (Kn(r, {
          code: yn.unrecognized_keys,
          keys: s
        }), o.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of s) {
        const d = r.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new Zp(r, d, r.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of c) {
        const d = await u.key;
        l.push({
          key: d,
          value: await u.value,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => Mc.mergeObjectSync(o, l)) : Mc.mergeObjectSync(o, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return vo.errToObj, new Aa({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, o) => {
          var r, i, a, s;
          const c = (a = (i = (r = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(r, n, o).message) !== null && a !== void 0 ? a : o.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (s = vo.errToObj(t).message) !== null && s !== void 0 ? s : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new Aa({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Aa({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Aa({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Aa({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Ro.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Aa({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return Gr.objectKeys(t).forEach((o) => {
      t[o] && this.shape[o] && (n[o] = this.shape[o]);
    }), new Aa({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return Gr.objectKeys(this.shape).forEach((o) => {
      t[o] || (n[o] = this.shape[o]);
    }), new Aa({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return yb(this);
  }
  partial(t) {
    const n = {};
    return Gr.objectKeys(this.shape).forEach((o) => {
      const r = this.shape[o];
      t && !t[o] ? n[o] = r : n[o] = r.optional();
    }), new Aa({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return Gr.objectKeys(this.shape).forEach((o) => {
      if (t && !t[o])
        n[o] = this.shape[o];
      else {
        let i = this.shape[o];
        for (; i instanceof lf; )
          i = i._def.innerType;
        n[o] = i;
      }
    }), new Aa({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Bse(Gr.objectKeys(this.shape));
  }
}
Aa.create = (e, t) => new Aa({
  shape: () => e,
  unknownKeys: "strip",
  catchall: vf.create(),
  typeName: Ro.ZodObject,
  ...or(t)
});
Aa.strictCreate = (e, t) => new Aa({
  shape: () => e,
  unknownKeys: "strict",
  catchall: vf.create(),
  typeName: Ro.ZodObject,
  ...or(t)
});
Aa.lazycreate = (e, t) => new Aa({
  shape: e,
  unknownKeys: "strip",
  catchall: vf.create(),
  typeName: Ro.ZodObject,
  ...or(t)
});
class wk extends pr {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = this._def.options;
    function r(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const a = i.map((s) => new Du(s.ctx.common.issues));
      return Kn(n, {
        code: yn.invalid_union,
        unionErrors: a
      }), Qo;
    }
    if (n.common.async)
      return Promise.all(o.map(async (i) => {
        const a = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: n.data,
            path: n.path,
            parent: a
          }),
          ctx: a
        };
      })).then(r);
    {
      let i;
      const a = [];
      for (const c of o) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: l }), l.common.issues.length && a.push(l.common.issues);
      }
      if (i)
        return n.common.issues.push(...i.ctx.common.issues), i.result;
      const s = a.map((c) => new Du(c));
      return Kn(n, {
        code: yn.invalid_union,
        unionErrors: s
      }), Qo;
    }
  }
  get options() {
    return this._def.options;
  }
}
wk.create = (e, t) => new wk({
  options: e,
  typeName: Ro.ZodUnion,
  ...or(t)
});
const jE = (e) => e instanceof Ek ? jE(e.schema) : e instanceof M_ ? jE(e.innerType()) : e instanceof xk ? [e.value] : e instanceof Rg ? e.options : e instanceof Ck ? Object.keys(e.enum) : e instanceof Tk ? jE(e._def.innerType) : e instanceof yk ? [void 0] : e instanceof $k ? [null] : null;
class LT extends pr {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Hn.object)
      return Kn(n, {
        code: yn.invalid_type,
        expected: Hn.object,
        received: n.parsedType
      }), Qo;
    const o = this.discriminator, r = n.data[o], i = this.optionsMap.get(r);
    return i ? n.common.async ? i._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : i._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (Kn(n, {
      code: yn.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [o]
    }), Qo);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, o) {
    const r = /* @__PURE__ */ new Map();
    for (const i of n) {
      const a = jE(i.shape[t]);
      if (!a)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const s of a) {
        if (r.has(s))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(s)}`);
        r.set(s, i);
      }
    }
    return new LT({
      typeName: Ro.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: r,
      ...or(o)
    });
  }
}
function MM(e, t) {
  const n = ng(e), o = ng(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === Hn.object && o === Hn.object) {
    const r = Gr.objectKeys(t), i = Gr.objectKeys(e).filter((s) => r.indexOf(s) !== -1), a = { ...e, ...t };
    for (const s of i) {
      const c = MM(e[s], t[s]);
      if (!c.valid)
        return { valid: !1 };
      a[s] = c.data;
    }
    return { valid: !0, data: a };
  } else if (n === Hn.array && o === Hn.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const r = [];
    for (let i = 0; i < e.length; i++) {
      const a = e[i], s = t[i], c = MM(a, s);
      if (!c.valid)
        return { valid: !1 };
      r.push(c.data);
    }
    return { valid: !0, data: r };
  } else
    return n === Hn.date && o === Hn.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class kk extends pr {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t), r = (i, a) => {
      if (DM(i) || DM(a))
        return Qo;
      const s = MM(i.value, a.value);
      return s.valid ? ((LM(i) || LM(a)) && n.dirty(), { status: n.value, value: s.data }) : (Kn(o, {
        code: yn.invalid_intersection_types
      }), Qo);
    };
    return o.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      }),
      this._def.right._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      })
    ]).then(([i, a]) => r(i, a)) : r(this._def.left._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }), this._def.right._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }));
  }
}
kk.create = (e, t, n) => new kk({
  left: e,
  right: t,
  typeName: Ro.ZodIntersection,
  ...or(n)
});
class Xp extends pr {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Hn.array)
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.array,
        received: o.parsedType
      }), Qo;
    if (o.data.length < this._def.items.length)
      return Kn(o, {
        code: yn.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Qo;
    !this._def.rest && o.data.length > this._def.items.length && (Kn(o, {
      code: yn.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const i = [...o.data].map((a, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new Zp(o, a, o.path, s)) : null;
    }).filter((a) => !!a);
    return o.common.async ? Promise.all(i).then((a) => Mc.mergeArray(n, a)) : Mc.mergeArray(n, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Xp({
      ...this._def,
      rest: t
    });
  }
}
Xp.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Xp({
    items: e,
    typeName: Ro.ZodTuple,
    rest: null,
    ...or(t)
  });
};
class Sk extends pr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Hn.object)
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.object,
        received: o.parsedType
      }), Qo;
    const r = [], i = this._def.keyType, a = this._def.valueType;
    for (const s in o.data)
      r.push({
        key: i._parse(new Zp(o, s, o.path, s)),
        value: a._parse(new Zp(o, o.data[s], o.path, s))
      });
    return o.common.async ? Mc.mergeObjectAsync(n, r) : Mc.mergeObjectSync(n, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, o) {
    return n instanceof pr ? new Sk({
      keyType: t,
      valueType: n,
      typeName: Ro.ZodRecord,
      ...or(o)
    }) : new Sk({
      keyType: O_.create(),
      valueType: t,
      typeName: Ro.ZodRecord,
      ...or(n)
    });
  }
}
class Ux extends pr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Hn.map)
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.map,
        received: o.parsedType
      }), Qo;
    const r = this._def.keyType, i = this._def.valueType, a = [...o.data.entries()].map(([s, c], l) => ({
      key: r._parse(new Zp(o, s, o.path, [l, "key"])),
      value: i._parse(new Zp(o, c, o.path, [l, "value"]))
    }));
    if (o.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return Qo;
          (l.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(l.value, u.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of a) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return Qo;
        (l.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(l.value, u.value);
      }
      return { status: n.value, value: s };
    }
  }
}
Ux.create = (e, t, n) => new Ux({
  valueType: t,
  keyType: e,
  typeName: Ro.ZodMap,
  ...or(n)
});
class uv extends pr {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Hn.set)
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.set,
        received: o.parsedType
      }), Qo;
    const r = this._def;
    r.minSize !== null && o.data.size < r.minSize.value && (Kn(o, {
      code: yn.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), n.dirty()), r.maxSize !== null && o.data.size > r.maxSize.value && (Kn(o, {
      code: yn.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), n.dirty());
    const i = this._def.valueType;
    function a(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return Qo;
        u.status === "dirty" && n.dirty(), l.add(u.value);
      }
      return { status: n.value, value: l };
    }
    const s = [...o.data.values()].map((c, l) => i._parse(new Zp(o, c, o.path, l)));
    return o.common.async ? Promise.all(s).then((c) => a(c)) : a(s);
  }
  min(t, n) {
    return new uv({
      ...this._def,
      minSize: { value: t, message: vo.toString(n) }
    });
  }
  max(t, n) {
    return new uv({
      ...this._def,
      maxSize: { value: t, message: vo.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
uv.create = (e, t) => new uv({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Ro.ZodSet,
  ...or(t)
});
class qb extends pr {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Hn.function)
      return Kn(n, {
        code: yn.invalid_type,
        expected: Hn.function,
        received: n.parsedType
      }), Qo;
    function o(s, c) {
      return qx({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Fx(),
          hk
        ].filter((l) => !!l),
        issueData: {
          code: yn.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function r(s, c) {
      return qx({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Fx(),
          hk
        ].filter((l) => !!l),
        issueData: {
          code: yn.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const i = { errorMap: n.common.contextualErrorMap }, a = n.data;
    if (this._def.returns instanceof ky) {
      const s = this;
      return yl(async function(...c) {
        const l = new Du([]), u = await s._def.args.parseAsync(c, i).catch((p) => {
          throw l.addIssue(o(c, p)), l;
        }), d = await Reflect.apply(a, this, u);
        return await s._def.returns._def.type.parseAsync(d, i).catch((p) => {
          throw l.addIssue(r(d, p)), l;
        });
      });
    } else {
      const s = this;
      return yl(function(...c) {
        const l = s._def.args.safeParse(c, i);
        if (!l.success)
          throw new Du([o(c, l.error)]);
        const u = Reflect.apply(a, this, l.data), d = s._def.returns.safeParse(u, i);
        if (!d.success)
          throw new Du([r(u, d.error)]);
        return d.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new qb({
      ...this._def,
      args: Xp.create(t).rest(Qh.create())
    });
  }
  returns(t) {
    return new qb({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, o) {
    return new qb({
      args: t || Xp.create([]).rest(Qh.create()),
      returns: n || Qh.create(),
      typeName: Ro.ZodFunction,
      ...or(o)
    });
  }
}
class Ek extends pr {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Ek.create = (e, t) => new Ek({
  getter: e,
  typeName: Ro.ZodLazy,
  ...or(t)
});
class xk extends pr {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return Kn(n, {
        received: n.data,
        code: yn.invalid_literal,
        expected: this._def.value
      }), Qo;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
xk.create = (e, t) => new xk({
  value: e,
  typeName: Ro.ZodLiteral,
  ...or(t)
});
function Bse(e, t) {
  return new Rg({
    values: e,
    typeName: Ro.ZodEnum,
    ...or(t)
  });
}
class Rg extends pr {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), o = this._def.values;
      return Kn(n, {
        expected: Gr.joinValues(o),
        received: n.parsedType,
        code: yn.invalid_type
      }), Qo;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const n = this._getOrReturnCtx(t), o = this._def.values;
      return Kn(n, {
        received: n.data,
        code: yn.invalid_enum_value,
        options: o
      }), Qo;
    }
    return yl(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t) {
    return Rg.create(t);
  }
  exclude(t) {
    return Rg.create(this.options.filter((n) => !t.includes(n)));
  }
}
Rg.create = Bse;
class Ck extends pr {
  _parse(t) {
    const n = Gr.getValidEnumValues(this._def.values), o = this._getOrReturnCtx(t);
    if (o.parsedType !== Hn.string && o.parsedType !== Hn.number) {
      const r = Gr.objectValues(n);
      return Kn(o, {
        expected: Gr.joinValues(r),
        received: o.parsedType,
        code: yn.invalid_type
      }), Qo;
    }
    if (n.indexOf(t.data) === -1) {
      const r = Gr.objectValues(n);
      return Kn(o, {
        received: o.data,
        code: yn.invalid_enum_value,
        options: r
      }), Qo;
    }
    return yl(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ck.create = (e, t) => new Ck({
  values: e,
  typeName: Ro.ZodNativeEnum,
  ...or(t)
});
class ky extends pr {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Hn.promise && n.common.async === !1)
      return Kn(n, {
        code: yn.invalid_type,
        expected: Hn.promise,
        received: n.parsedType
      }), Qo;
    const o = n.parsedType === Hn.promise ? n.data : Promise.resolve(n.data);
    return yl(o.then((r) => this._def.type.parseAsync(r, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
ky.create = (e, t) => new ky({
  type: e,
  typeName: Ro.ZodPromise,
  ...or(t)
});
class M_ extends pr {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ro.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t), r = this._def.effect || null, i = {
      addIssue: (a) => {
        Kn(o, a), a.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return o.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
      const a = r.transform(o.data, i);
      return o.common.issues.length ? {
        status: "dirty",
        value: o.data
      } : o.common.async ? Promise.resolve(a).then((s) => this._def.schema._parseAsync({
        data: s,
        path: o.path,
        parent: o
      })) : this._def.schema._parseSync({
        data: a,
        path: o.path,
        parent: o
      });
    }
    if (r.type === "refinement") {
      const a = (s) => {
        const c = r.refinement(s, i);
        if (o.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (o.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return s.status === "aborted" ? Qo : (s.status === "dirty" && n.dirty(), a(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((s) => s.status === "aborted" ? Qo : (s.status === "dirty" && n.dirty(), a(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (r.type === "transform")
      if (o.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        if (!vk(a))
          return a;
        const s = r.transform(a.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((a) => vk(a) ? Promise.resolve(r.transform(a.value, i)).then((s) => ({ status: n.value, value: s })) : a);
    Gr.assertNever(r);
  }
}
M_.create = (e, t, n) => new M_({
  schema: e,
  typeName: Ro.ZodEffects,
  effect: t,
  ...or(n)
});
M_.createWithPreprocess = (e, t, n) => new M_({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Ro.ZodEffects,
  ...or(n)
});
class lf extends pr {
  _parse(t) {
    return this._getType(t) === Hn.undefined ? yl(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
lf.create = (e, t) => new lf({
  innerType: e,
  typeName: Ro.ZodOptional,
  ...or(t)
});
class dv extends pr {
  _parse(t) {
    return this._getType(t) === Hn.null ? yl(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
dv.create = (e, t) => new dv({
  innerType: e,
  typeName: Ro.ZodNullable,
  ...or(t)
});
class Tk extends pr {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let o = n.data;
    return n.parsedType === Hn.undefined && (o = this._def.defaultValue()), this._def.innerType._parse({
      data: o,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Tk.create = (e, t) => new Tk({
  innerType: e,
  typeName: Ro.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...or(t)
});
class Gx extends pr {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: o.data,
      path: o.path,
      parent: {
        ...o
      }
    });
    return jx(r) ? r.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Du(o.common.issues);
        },
        input: o.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new Du(o.common.issues);
        },
        input: o.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Gx.create = (e, t) => new Gx({
  innerType: e,
  typeName: Ro.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...or(t)
});
class Wx extends pr {
  _parse(t) {
    if (this._getType(t) !== Hn.nan) {
      const o = this._getOrReturnCtx(t);
      return Kn(o, {
        code: yn.invalid_type,
        expected: Hn.nan,
        received: o.parsedType
      }), Qo;
    }
    return { status: "valid", value: t.data };
  }
}
Wx.create = (e) => new Wx({
  typeName: Ro.ZodNaN,
  ...or(e)
});
const qcc = Symbol("zod_brand");
class Use extends pr {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = n.data;
    return this._def.type._parse({
      data: o,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class F0 extends pr {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return i.status === "aborted" ? Qo : i.status === "dirty" ? (n.dirty(), Vse(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: o.path,
          parent: o
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: o.data,
        path: o.path,
        parent: o
      });
      return r.status === "aborted" ? Qo : r.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: o.path,
        parent: o
      });
    }
  }
  static create(t, n) {
    return new F0({
      in: t,
      out: n,
      typeName: Ro.ZodPipeline
    });
  }
}
class Hx extends pr {
  _parse(t) {
    const n = this._def.innerType._parse(t);
    return vk(n) && (n.value = Object.freeze(n.value)), n;
  }
}
Hx.create = (e, t) => new Hx({
  innerType: e,
  typeName: Ro.ZodReadonly,
  ...or(t)
});
const Gse = (e, t = {}, n) => e ? wy.create().superRefine((o, r) => {
  var i, a;
  if (!e(o)) {
    const s = typeof t == "function" ? t(o) : typeof t == "string" ? { message: t } : t, c = (a = (i = s.fatal) !== null && i !== void 0 ? i : n) !== null && a !== void 0 ? a : !0, l = typeof s == "string" ? { message: s } : s;
    r.addIssue({ code: "custom", ...l, fatal: c });
  }
}) : wy.create(), jcc = {
  object: Aa.lazycreate
};
var Ro;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Ro || (Ro = {}));
const Vcc = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Gse((n) => n instanceof e, t), Wse = O_.create, Hse = Ng.create, Bcc = Wx.create, Ucc = zg.create, Yse = bk.create, Gcc = lv.create, Wcc = Vx.create, Hcc = yk.create, Ycc = $k.create, Kcc = wy.create, Zcc = Qh.create, Xcc = vf.create, Jcc = Bx.create, Qcc = D_.create, elc = Aa.create, tlc = Aa.strictCreate, nlc = wk.create, olc = LT.create, rlc = kk.create, ilc = Xp.create, alc = Sk.create, slc = Ux.create, clc = uv.create, llc = qb.create, ulc = Ek.create, dlc = xk.create, _lc = Rg.create, plc = Ck.create, mlc = ky.create, WG = M_.create, flc = lf.create, glc = dv.create, hlc = M_.createWithPreprocess, vlc = F0.create, blc = () => Wse().optional(), ylc = () => Hse().optional(), $lc = () => Yse().optional(), wlc = {
  string: (e) => O_.create({ ...e, coerce: !0 }),
  number: (e) => Ng.create({ ...e, coerce: !0 }),
  boolean: (e) => bk.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => zg.create({ ...e, coerce: !0 }),
  date: (e) => lv.create({ ...e, coerce: !0 })
}, klc = Qo;
var oe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: hk,
  setErrorMap: Ccc,
  getErrorMap: Fx,
  makeIssue: qx,
  EMPTY_PATH: Tcc,
  addIssueToContext: Kn,
  ParseStatus: Mc,
  INVALID: Qo,
  DIRTY: Vse,
  OK: yl,
  isAborted: DM,
  isDirty: LM,
  isValid: vk,
  isAsync: jx,
  get util() {
    return Gr;
  },
  get objectUtil() {
    return PM;
  },
  ZodParsedType: Hn,
  getParsedType: ng,
  ZodType: pr,
  ZodString: O_,
  ZodNumber: Ng,
  ZodBigInt: zg,
  ZodBoolean: bk,
  ZodDate: lv,
  ZodSymbol: Vx,
  ZodUndefined: yk,
  ZodNull: $k,
  ZodAny: wy,
  ZodUnknown: Qh,
  ZodNever: vf,
  ZodVoid: Bx,
  ZodArray: D_,
  ZodObject: Aa,
  ZodUnion: wk,
  ZodDiscriminatedUnion: LT,
  ZodIntersection: kk,
  ZodTuple: Xp,
  ZodRecord: Sk,
  ZodMap: Ux,
  ZodSet: uv,
  ZodFunction: qb,
  ZodLazy: Ek,
  ZodLiteral: xk,
  ZodEnum: Rg,
  ZodNativeEnum: Ck,
  ZodPromise: ky,
  ZodEffects: M_,
  ZodTransformer: M_,
  ZodOptional: lf,
  ZodNullable: dv,
  ZodDefault: Tk,
  ZodCatch: Gx,
  ZodNaN: Wx,
  BRAND: qcc,
  ZodBranded: Use,
  ZodPipeline: F0,
  ZodReadonly: Hx,
  custom: Gse,
  Schema: pr,
  ZodSchema: pr,
  late: jcc,
  get ZodFirstPartyTypeKind() {
    return Ro;
  },
  coerce: wlc,
  any: Kcc,
  array: Qcc,
  bigint: Ucc,
  boolean: Yse,
  date: Gcc,
  discriminatedUnion: olc,
  effect: WG,
  enum: _lc,
  function: llc,
  instanceof: Vcc,
  intersection: rlc,
  lazy: ulc,
  literal: dlc,
  map: slc,
  nan: Bcc,
  nativeEnum: plc,
  never: Xcc,
  null: Ycc,
  nullable: glc,
  number: Hse,
  object: elc,
  oboolean: $lc,
  onumber: ylc,
  optional: flc,
  ostring: blc,
  pipeline: vlc,
  preprocess: hlc,
  promise: mlc,
  record: alc,
  set: clc,
  strictObject: tlc,
  string: Wse,
  symbol: Wcc,
  transformer: WG,
  tuple: ilc,
  undefined: Hcc,
  union: nlc,
  unknown: Zcc,
  void: Jcc,
  NEVER: klc,
  ZodIssueCode: yn,
  quotelessJson: xcc,
  ZodError: Du
});
function Slc(e, t, n) {
  let o = !1, r = !1, i = !1, a = !1, s = !1;
  if (e.length >= 7 && (!n || e.length > 14) && (a = !0), n && e.length > 14 && (s = !0), e.match(/\d/) && (i = !0), e.match(/[a-z]/) && (r = !0), e.match(/[A-Z]/) && (o = !0), !t)
    return o && r && i && a && (n ? s : !0);
  let c = { caplow: o && r, num: i, min: a };
  return n && (c = { ...c, admin_min: s }), c;
}
const Kse = (
  /* eslint-disable-next-line no-useless-escape */
  /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.']*)[A-Z0-9_+'-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i
), Elc = 254, xlc = oe.string().max(Elc, { message: "Email address is too long" }).regex(Kse), Zse = (e) => e.replace(/[^a-zA-Z0-9-_]/g, "-"), Clc = oe.object({
  type: oe.string().optional(),
  properties: oe.object({
    field: oe.any().optional(),
    operator: oe.any().optional(),
    value: oe.any().optional(),
    valueSrc: oe.any().optional(),
    valueError: oe.array(oe.union([oe.string(), oe.null()])).optional(),
    valueType: oe.any().optional()
  }).optional()
  /*
   * TODO: (emrysal) This schema is good, but our DB contains invalid entries-
   *       instead of crashing on read we need to handle this on write first.
  type: z.union([z.literal("rule"), z.literal("rule_group")]),
  properties: z.object({
    // This is RAQB field that is used in the rules. The aluealue we provide here is used as a lookup key in RAQB_CONFIG.fields
    field: z.string(),
    // It could be any of the operators. There are many custom operators.
    operator: z.string(),
    // It is the value of the 'field' chosen for comparison in the rule
    // It might not be set if the operator needs nothing to compare with e.g. is_empty, is_not_empty\
    // It could be a 2D array for MultiSelect field
    value: z.array(z.union([z.string(), z.array(z.string()), z.null()])).optional(),
    // It is the source of the value. It might not be set if the value is coming from the field itself.
    valueSrc: z
      .union([z.literal("value"), z.literal("field"), z.literal("func"), z.literal("const")])
      .array()
      .optional(),
    // It is the error message that is shown when the value is not valid.
    valueError: z.array(z.union([z.string(), z.null()])).optional(),
    // Type of the value - can be text, number, boolean, date, time, datetime, select, multiselect, treeselect, treemultiselect and maybe more
    // We only use a few of them in our app
    valueType: z.array(z.string()).optional(),
  }),*/
}), HG = oe.record(Clc).superRefine((e, t) => {
  if (!e)
    return;
  const n = (o) => typeof o == "object" && o !== null;
  Object.entries(e).forEach(([, o]) => {
    const r = o;
    if (!n(r) || r.type !== "rule" || !n(r.properties))
      return;
    const i = r.properties.value || [], a = r.properties.valueSrc;
    if (!(i instanceof Array) || !(a instanceof Array) || !a.length)
      return;
    i.flat().filter((l) => l !== void 0).length || t.addIssue({
      code: oe.ZodIssueCode.custom,
      message: "Looks like you are trying to create a rule with no value"
    });
  });
}), VE = oe.union([
  oe.object({
    id: oe.string().optional(),
    type: oe.literal("group"),
    children1: HG.optional(),
    properties: oe.any()
  }),
  oe.object({
    id: oe.string().optional(),
    type: oe.literal("switch_group"),
    children1: HG.optional(),
    properties: oe.any()
  })
]), Tlc = VE, mF = (e, t) => {
  if (!e)
    return "";
  const n = e.toLowerCase().trim().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").replace(/[^.\p{L}\p{N}\p{Zs}\p{Emoji}]+/gu, "-").replace(/[\s_#]+/g, "-").replace(/^-+/, "").replace(/\.{2,}/g, ".").replace(/^\.+/, "").replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    ""
  ).replace(/\s+/g, " ").replace(/-+/g, "-");
  return t ? n : n.replace(/-+$/, "").replace(/\.*$/, "");
}, ev = mF, Bs = {
  ROUND_ROBIN: "ROUND_ROBIN",
  COLLECTIVE: "COLLECTIVE",
  MANAGED: "MANAGED"
}, ic = {
  UNLIMITED: "UNLIMITED",
  ROLLING: "ROLLING",
  ROLLING_WINDOW: "ROLLING_WINDOW",
  RANGE: "RANGE"
}, Alc = {
  USER: "USER",
  ADMIN: "ADMIN"
}, Ilc = {
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
  OWNER: "OWNER"
}, WO = {
  CANCELLED: "CANCELLED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  AWAITING_HOST: "AWAITING_HOST"
}, Olc = {
  TEXT: "TEXT",
  TEXTLONG: "TEXTLONG",
  NUMBER: "NUMBER",
  BOOL: "BOOL",
  RADIO: "RADIO",
  PHONE: "PHONE"
}, Xse = {
  BEFORE_EVENT: "BEFORE_EVENT",
  EVENT_CANCELLED: "EVENT_CANCELLED",
  NEW_EVENT: "NEW_EVENT",
  AFTER_EVENT: "AFTER_EVENT",
  RESCHEDULE_EVENT: "RESCHEDULE_EVENT",
  AFTER_HOSTS_CAL_VIDEO_NO_SHOW: "AFTER_HOSTS_CAL_VIDEO_NO_SHOW",
  AFTER_GUESTS_CAL_VIDEO_NO_SHOW: "AFTER_GUESTS_CAL_VIDEO_NO_SHOW",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  FORM_SUBMITTED_NO_EVENT: "FORM_SUBMITTED_NO_EVENT",
  BOOKING_REJECTED: "BOOKING_REJECTED",
  BOOKING_REQUESTED: "BOOKING_REQUESTED",
  BOOKING_PAYMENT_INITIATED: "BOOKING_PAYMENT_INITIATED",
  BOOKING_PAID: "BOOKING_PAID",
  BOOKING_NO_SHOW_UPDATED: "BOOKING_NO_SHOW_UPDATED"
}, FM = {
  EMAIL_HOST: "EMAIL_HOST",
  EMAIL_ATTENDEE: "EMAIL_ATTENDEE",
  SMS_ATTENDEE: "SMS_ATTENDEE",
  SMS_NUMBER: "SMS_NUMBER",
  EMAIL_ADDRESS: "EMAIL_ADDRESS",
  WHATSAPP_ATTENDEE: "WHATSAPP_ATTENDEE",
  WHATSAPP_NUMBER: "WHATSAPP_NUMBER",
  CAL_AI_PHONE_CALL: "CAL_AI_PHONE_CALL"
}, YG = {
  CREATED_AT: "CREATED_AT",
  START_TIME: "START_TIME"
}, yS = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  SINGLE_SELECT: "SINGLE_SELECT",
  MULTI_SELECT: "MULTI_SELECT"
}, KG = {
  DESCRIPTION: "DESCRIPTION",
  TITLE: "TITLE"
};
var jb = /* @__PURE__ */ ((e) => (e[e.YEARLY = 0] = "YEARLY", e[e.MONTHLY = 1] = "MONTHLY", e[e.WEEKLY = 2] = "WEEKLY", e[e.DAILY = 3] = "DAILY", e[e.HOURLY = 4] = "HOURLY", e[e.MINUTELY = 5] = "MINUTELY", e[e.SECONDLY = 6] = "SECONDLY", e))(jb || {}), io = /* @__PURE__ */ ((e) => (e.MONTH_VIEW = "month_view", e.WEEK_VIEW = "week_view", e.COLUMN_VIEW = "column_view", e))(io || {});
const Wp = [
  "month_view",
  "week_view",
  "column_view"
  /* COLUMN_VIEW */
], ZG = oe.union([
  oe.literal(Wp[0]),
  oe.literal(Wp[1]),
  oe.literal(Wp[2])
]), Jse = oe.object({
  enabledLayouts: oe.array(ZG),
  defaultLayout: ZG
}).nullable();
oe.array(
  oe.object({
    email: oe.string().email(),
    name: oe.string().optional(),
    teamId: oe.number().optional(),
    teamName: oe.string().optional(),
    role: oe.enum(["MEMBER", "ADMIN"]).optional().default("MEMBER")
  })
);
oe.array(
  oe.object({
    id: oe.number(),
    name: oe.string(),
    isBeingMigrated: oe.boolean(),
    // "slug" is null for new teams
    slug: oe.string().nullable()
  })
);
const Qse = {
  defaultLayout: "month_view",
  // if the user has no explicit layouts set (not in user profile and not in event settings), all layouts are enabled.
  enabledLayouts: Wp
}, Nlc = oe.enum(["hours", "minutes"]), ece = oe.object({
  smartContractAddress: oe.string().optional(),
  blockchainId: oe.number().optional(),
  multipleDuration: oe.number().array().optional(),
  giphyThankYouPage: oe.string().optional(),
  additionalNotesRequired: oe.boolean().optional(),
  disableSuccessPage: oe.boolean().optional(),
  disableStandardEmails: oe.object({
    all: oe.object({
      host: oe.boolean().optional(),
      attendee: oe.boolean().optional()
    }).optional(),
    confirmation: oe.object({
      host: oe.boolean().optional(),
      attendee: oe.boolean().optional()
    }).optional()
  }).optional(),
  managedEventConfig: oe.object({
    unlockedFields: oe.custom().optional()
  }).optional(),
  requiresConfirmationThreshold: oe.object({
    time: oe.number(),
    unit: Nlc
  }).optional(),
  config: oe.object({
    useHostSchedulesForTeamEvent: oe.boolean().optional()
  }).optional(),
  bookerLayouts: Jse.optional()
}), zlc = ece.merge(
  oe.object({
    apps: oe.record(oe.string(), oe.any()).optional()
  })
), tce = zlc.nullable(), nce = ece.nullable(), MT = oe.object({
  email: oe.string(),
  attendeePhoneNumber: oe.string().optional(),
  //TODO: Why don't we move name out of bookingResponses and let it be handled like user fields?
  name: oe.union([
    oe.string(),
    oe.object({
      firstName: oe.string(),
      lastName: oe.string().optional()
    })
  ]),
  guests: oe.array(oe.string()).optional(),
  notes: oe.string().optional(),
  location: oe.object({
    optionValue: oe.string(),
    value: oe.string()
  }).optional(),
  smsReminderNumber: oe.string().optional(),
  rescheduleReason: oe.string().optional()
}).nullable(), Rlc = oe.array(
  oe.object({
    // TODO: Couldn't find a way to make it a union of types from App Store locations
    // Creating a dynamic union by iterating over the object doesn't seem to make TS happy
    type: oe.string(),
    address: oe.string().optional(),
    link: oe.string().url().optional(),
    displayLocationPublicly: oe.boolean().optional(),
    hostPhoneNumber: oe.string().optional(),
    credentialId: oe.number().optional(),
    teamName: oe.string().optional(),
    customLabel: oe.string().optional()
  })
);
oe.object({
  dtstart: oe.date().optional(),
  interval: oe.number(),
  count: oe.number(),
  freq: oe.nativeEnum(jb),
  until: oe.date().optional(),
  tzid: oe.string().optional()
}).nullable();
oe.string().transform((e, t) => {
  const n = Date.parse(e);
  n || t.addIssue({
    code: oe.ZodIssueCode.custom,
    message: "Invalid ISO Date"
  });
  const o = /* @__PURE__ */ new Date();
  return o.setTime(n), o;
});
oe.object({
  lightEventTypeColor: oe.string(),
  darkEventTypeColor: oe.string()
}).nullable();
const Plc = oe.string().trim().transform((e) => mF(e)).refine((e) => e.length >= 1, {
  message: "Please enter at least one character"
});
oe.string().transform((e) => new Date(e));
oe.union([
  oe.string().transform((e, t) => {
    const n = parseInt(e);
    return isNaN(n) && t.addIssue({
      code: oe.ZodIssueCode.custom,
      message: "Not a number"
    }), n;
  }),
  oe.number().int()
]);
oe.union([
  // string must be given & nonempty
  oe.string().trim().min(1),
  // boolean must be true if set.
  oe.boolean().refine((e) => e === !0)
]);
const Dlc = oe.object({
  platformClientId: oe.string().optional(),
  platformRescheduleUrl: oe.string().nullable().optional(),
  platformCancelUrl: oe.string().nullable().optional(),
  platformBookingUrl: oe.string().nullable().optional(),
  platformBookingLocation: oe.string().optional(),
  areCalendarEventsEnabled: oe.boolean().optional()
});
oe.object({
  bookingId: oe.number(),
  confirmed: oe.boolean(),
  recurringEventId: oe.string().optional(),
  reason: oe.string().optional(),
  emailsEnabled: oe.boolean().default(!0),
  platformClientParams: Dlc.optional()
});
const oce = oe.object({
  id: oe.number().optional(),
  uid: oe.string().optional(),
  // note(Lauris): allRemainingBookings will cancel all bookings that have start time greater than this moment.
  allRemainingBookings: oe.boolean().optional(),
  // note(Lauris): cancelSubsequentBookings will cancel all bookings after one specified by id or uid.
  cancelSubsequentBookings: oe.boolean().optional(),
  cancellationReason: oe.string().optional(),
  skipCancellationReasonValidation: oe.boolean().optional(),
  seatReferenceUid: oe.string().optional(),
  cancelledBy: oe.string().email({ message: "Invalid email" }).optional(),
  internalNote: oe.object({
    id: oe.number(),
    name: oe.string(),
    cancellationReason: oe.string().optional().nullable()
  }).optional().nullable()
});
oe.object({
  seatReferenceUid: oe.string()
});
oce.refine(
  (e) => !!e.id || !!e.uid,
  "At least one of the following required: 'id', 'uid'."
);
oce.extend({
  csrfToken: oe.string().length(64, "Invalid CSRF token")
}).refine((e) => !!e.id || !!e.uid, "At least one of the following required: 'id', 'uid'.");
const Llc = oe.object({
  connected: oe.boolean().optional(),
  selectedParam: oe.string().optional(),
  sleepValue: oe.number().optional()
});
oe.object({
  id: oe.string(),
  thirdPartyRecurringEventId: oe.string(),
  password: oe.union([oe.string(), oe.undefined()]),
  onlineMeetingUrl: oe.string().nullable(),
  iCalUID: oe.string().optional()
}).passthrough();
const rce = oe.object({
  appSlug: oe.string().default("daily-video").optional(),
  appLink: oe.string().optional()
});
oe.object({
  proPaidForByTeamId: oe.number().optional(),
  stripeCustomerId: oe.string().optional(),
  vitalSettings: Llc.optional(),
  isPremium: oe.boolean().optional(),
  sessionTimeout: oe.number().optional(),
  // Minutes
  defaultConferencingApp: rce.optional(),
  defaultBookerLayouts: Jse.optional(),
  emailChangeWaitingForVerification: oe.string().transform((e) => e.toLowerCase()).optional(),
  migratedToOrgFrom: oe.object({
    username: oe.string().or(oe.null()).optional(),
    lastMigrationTime: oe.string().optional(),
    reverted: oe.boolean().optional(),
    revertTime: oe.string().optional()
  }).optional()
}).nullable();
oe.object({
  isOrganizationVerified: oe.boolean().optional(),
  isOrganizationConfigured: oe.boolean().optional(),
  isAdminReviewed: oe.boolean().optional(),
  orgAutoAcceptEmail: oe.string().optional(),
  isAdminAPIEnabled: oe.boolean().optional()
}).nullable();
var ice = /* @__PURE__ */ ((e) => (e.MONTHLY = "MONTHLY", e.ANNUALLY = "ANNUALLY", e))(ice || {});
const ace = oe.object({
  defaultConferencingApp: rce.optional(),
  requestedSlug: oe.string().or(oe.null()),
  paymentId: oe.string(),
  subscriptionId: oe.string().nullable(),
  subscriptionItemId: oe.string().nullable(),
  orgSeats: oe.number().nullable(),
  orgPricePerSeat: oe.number().nullable(),
  migratedToOrgFrom: oe.object({
    teamSlug: oe.string().or(oe.null()).optional(),
    lastMigrationTime: oe.string().optional(),
    reverted: oe.boolean().optional(),
    lastRevertTime: oe.string().optional()
  }).optional(),
  billingPeriod: oe.nativeEnum(ice).optional()
});
ace.partial().nullable();
ace.extend({
  subscriptionId: oe.string().refine((e) => e.startsWith("sub_"), {
    message: "subscriptionId must start with 'sub_'"
  }).nullable(),
  subscriptionItemId: oe.string().refine((e) => e.startsWith("si_"), {
    message: "subscriptionItemId must start with 'si_'"
  }).nullable()
}).partial().nullable();
oe.object({
  videoCallUrl: oe.string().optional()
}).and(oe.record(oe.string())).nullable().describe("BookingMetadata");
const Mlc = oe.array(
  oe.object({
    label: oe.string(),
    type: oe.string()
  })
);
oe.object({
  id: oe.number(),
  eventTypeId: oe.number(),
  label: oe.string(),
  type: oe.nativeEnum(Olc),
  options: Mlc.optional().nullable(),
  required: oe.boolean(),
  placeholder: oe.string(),
  hasToBeCreated: oe.boolean().optional()
});
const Flc = oe.object({
  id: oe.string(),
  room_name: oe.string(),
  start_ts: oe.number(),
  status: oe.string(),
  max_participants: oe.number().optional(),
  duration: oe.number(),
  share_token: oe.string()
}).passthrough(), qlc = oe.array(Flc);
oe.union([
  oe.object({
    total_count: oe.number(),
    data: qlc
  }),
  oe.object({})
]);
oe.union([
  oe.literal(""),
  oe.string().url().regex(/^http(s)?:\/\/.*/)
]).optional();
oe.object({
  // Applicable only for User Forms
  emailOwnerOnSubmission: oe.boolean(),
  // Applicable only for Team Forms
  sendUpdatesTo: oe.array(oe.number()).optional(),
  sendToAll: oe.boolean().optional()
}).nullable();
oe.object({
  brand: oe.string().default("#292929"),
  textBrand: oe.string().default("#ffffff"),
  darkBrand: oe.string().default("#fafafa"),
  textDarkBrand: oe.string().default("#292929"),
  bookingHighlight: oe.string().default("#10B981"),
  bookingLightest: oe.string().default("#E1E1E1"),
  bookingLighter: oe.string().default("#ACACAC"),
  bookingLight: oe.string().default("#888888"),
  bookingMedian: oe.string().default("#494949"),
  bookingDark: oe.string().default("#313131"),
  bookingDarker: oe.string().default("#292929"),
  fontName: oe.string().default("Cal Sans"),
  fontSrc: oe.string().default("https://cal.com/cal.ttf")
}).optional();
oe.object({
  download_link: oe.string().url()
});
oe.object({
  recordingId: oe.string(),
  bookingUID: oe.string()
});
oe.object({
  download_link: oe.string()
});
const HO = {
  title: !0,
  description: !0,
  interfaceLanguage: !0,
  isInstantEvent: !0,
  instantMeetingParameters: !0,
  instantMeetingExpiryTimeOffsetInSeconds: !0,
  aiPhoneCallConfig: !0,
  currency: !0,
  periodDays: !0,
  position: !0,
  price: !0,
  slug: !0,
  length: !0,
  offsetStart: !0,
  locations: !0,
  hidden: !0,
  availability: !0,
  recurringEvent: !0,
  customInputs: !0,
  disableGuests: !0,
  disableCancelling: !0,
  disableRescheduling: !0,
  allowReschedulingCancelledBookings: !0,
  requiresConfirmation: !0,
  canSendCalVideoTranscriptionEmails: !0,
  requiresConfirmationForFreeEmail: !0,
  requiresConfirmationWillBlockSlot: !0,
  eventName: !0,
  metadata: !0,
  children: !0,
  hideCalendarNotes: !0,
  hideCalendarEventDetails: !0,
  minimumBookingNotice: !0,
  beforeEventBuffer: !0,
  afterEventBuffer: !0,
  successRedirectUrl: !0,
  seatsPerTimeSlot: !0,
  seatsShowAttendees: !0,
  seatsShowAvailabilityCount: !0,
  forwardParamsSuccessRedirect: !0,
  periodType: !0,
  hashedLink: !0,
  webhooks: !0,
  periodStartDate: !0,
  periodEndDate: !0,
  destinationCalendar: !0,
  periodCountCalendarDays: !0,
  bookingLimits: !0,
  onlyShowFirstAvailableSlot: !0,
  slotInterval: !0,
  scheduleId: !0,
  workflows: !0,
  bookingFields: !0,
  durationLimits: !0,
  maxActiveBookingsPerBooker: !0,
  maxActiveBookingPerBookerOfferReschedule: !0,
  lockTimeZoneToggleOnBookingPage: !0,
  lockedTimeZone: !0,
  requiresBookerEmailVerification: !0,
  assignAllTeamMembers: !0,
  isRRWeightsEnabled: !0,
  eventTypeColor: !0,
  allowReschedulingPastBookings: !0,
  hideOrganizerEmail: !0,
  rescheduleWithSameRoundRobinHost: !0,
  maxLeadThreshold: !0,
  customReplyToEmail: !0,
  bookingRequiresAuthentication: !0
}, jlc = {
  locations: HO.locations,
  scheduleId: HO.scheduleId,
  destinationCalendar: HO.destinationCalendar
}, sce = xlc, Vlc = (e) => sce.safeParse(e).success;
oe.object({
  // Username is marked optional here because it's requirement depends on if it's the Organization invite or a team invite which isn't easily done in zod
  // It's better handled beyond zod in `validateAndGetCorrectedUsernameAndEmail`
  username: oe.string().optional(),
  email: oe.string().regex(Kse, { message: "Invalid email" }),
  password: oe.string().superRefine((e, t) => {
    const o = Slc(e, !0, !1);
    Object.keys(o).map((r) => {
      o[r] || t.addIssue({
        code: oe.ZodIssueCode.custom,
        path: [r],
        message: r
      });
    });
  }),
  language: oe.string().optional(),
  token: oe.string().optional()
});
oe.object({
  email: sce,
  code: oe.string()
});
oe.coerce.date();
oe.object({
  description: oe.string().optional(),
  responses: MT
});
oe.object({
  private_key: oe.string(),
  client_email: oe.string().optional(),
  client_id: oe.string(),
  tenant_id: oe.string().optional()
}).passthrough();
Tlc.nullish();
const cce = oe.enum([
  "name",
  "text",
  "textarea",
  "number",
  "email",
  "phone",
  "address",
  "multiemail",
  "select",
  "multiselect",
  "checkbox",
  "radio",
  "radioInput",
  "boolean",
  "url"
]), Yx = oe.string().superRefine((e, t) => {
  const n = e.split(",").map((i) => i.trim()), o = /^(?:@?[a-z0-9-]+(?:\.[a-z]{2,})?)?(?:@[a-z0-9-]+\.[a-z]{2,})?$/;
  !n.some((i) => !o.test(i)) || t.addIssue({
    code: oe.ZodIssueCode.custom,
    message: "Enter valid domain or email"
  });
}), Blc = oe.enum([
  "system",
  // Can't be deleted, can't be hidden, name can't be edited, can't be marked optional
  "system-but-optional",
  // Can't be deleted. Name can't be edited. But can be hidden or be marked optional
  "system-but-hidden",
  // Can't be deleted, name can't be edited, will be shown
  "user",
  // Fully editable
  "user-readonly"
  // All fields are readOnly.
]), lce = oe.object({
  name: oe.string().transform(Zse),
  type: cce,
  // TODO: We should make at least one of `defaultPlaceholder` and `placeholder` required. Do the same for label.
  label: oe.string().optional(),
  labelAsSafeHtml: oe.string().optional(),
  /**
   * It is the default label that will be used when a new field is created.
   * Note: It belongs in FieldsTypeConfig, so that changing defaultLabel in code can work for existing fields as well(for fields that are using the default label).
   * Supports translation
   */
  defaultLabel: oe.string().optional(),
  placeholder: oe.string().optional(),
  /**
   * It is the default placeholder that will be used when a new field is created.
   * Note: Same as defaultLabel, it belongs in FieldsTypeConfig
   * Supports translation
   */
  defaultPlaceholder: oe.string().optional(),
  required: oe.boolean().default(!1).optional(),
  /**
   * It is the list of options that is valid for a certain type of fields.
   *
   */
  options: oe.array(
    oe.object({
      label: oe.string(),
      value: oe.string(),
      price: oe.coerce.number().min(0).optional()
    })
  ).optional(),
  /**
   * This is an alternate way to specify options when the options are stored elsewhere. Form Builder expects options to be present at `dataStore[getOptionsAt]`
   * This allows keeping a single source of truth in DB.
   */
  getOptionsAt: oe.string().optional(),
  /**
   * For `radioInput` type of questions, it stores the input that is shown based on the user option selected.
   * e.g. If user is given a list of locations and he selects "Phone", then he will be shown a phone input
   */
  optionsInputs: oe.record(
    oe.object({
      // Support all types as needed
      // Must be a subset of `fieldTypeEnum`.TODO: Enforce it in TypeScript
      type: oe.enum(["address", "phone", "text"]),
      required: oe.boolean().optional(),
      placeholder: oe.string().optional()
    })
  ).optional(),
  /**
   * It is the minimum number of characters that can be entered in the field.
   * It is used for types with `supportsLengthCheck= true`.
   * @default 0
   * @requires supportsLengthCheck = true
   */
  minLength: oe.number().optional(),
  /**
   * It is the maximum number of characters that can be entered in the field.
   * It is used for types with `supportsLengthCheck= true`.
   * @requires supportsLengthCheck = true
   */
  maxLength: oe.number().optional(),
  // Emails that needs to be excluded
  excludeEmails: Yx.optional(),
  // Emails that need to be required
  requireEmails: Yx.optional(),
  // Price associated with the field which works like addons which users can add to the booking
  price: oe.coerce.number().min(0).optional()
}), uce = oe.object({
  variants: oe.record(
    oe.object({
      /**
       * Variant Fields schema for a variant of the main field.
       * It doesn't support non text fields as of now
       **/
      fields: lce.omit({
        defaultLabel: !0,
        defaultPlaceholder: !0,
        options: !0,
        getOptionsAt: !0,
        optionsInputs: !0
      }).array()
    })
  )
}), dce = lce.merge(
  oe.object({
    variant: oe.string().optional(),
    variantsConfig: uce.optional(),
    views: oe.object({
      label: oe.string(),
      id: oe.string(),
      description: oe.string().optional()
    }).array().optional(),
    /**
     * It is used to hide fields such as location when there are less than two options
     */
    hideWhenJustOneOption: oe.boolean().default(!1).optional(),
    hidden: oe.boolean().optional(),
    editable: Blc.default("user").optional(),
    sources: oe.array(
      oe.object({
        // Unique ID for the `type`. If type is workflow, it's the workflow ID
        id: oe.string(),
        type: oe.union([oe.literal("user"), oe.literal("system"), oe.string()]),
        label: oe.string(),
        editUrl: oe.string().optional(),
        // Mark if a field is required by this source or not. This allows us to set `field.required` based on all the sources' fieldRequired value
        fieldRequired: oe.boolean().optional()
      })
    ).optional(),
    disableOnPrefill: oe.boolean().default(!1).optional()
  })
), _ce = oe.array(dce);
_ce.element.shape.type.Enum;
const vd = (e, t, n = !0) => {
  if (typeof window > "u")
    return;
  const o = new URL(window.location.href);
  if (o.searchParams.get(e) !== t) {
    if (t === "" || t === "null") {
      BE(e, n);
      return;
    } else
      o.searchParams.set(e, `${t}`);
    n ? window.history.replaceState({ ...window.history.state, as: o.href }, "", o.href) : window.history.pushState({ ...window.history.state, as: o.href }, "", o.href);
  }
}, zc = (e) => {
  if (!(typeof window > "u"))
    return new URLSearchParams(window.location.search).get(e);
}, BE = (e, t = !0) => {
  if (typeof window > "u")
    return;
  const n = new URL(window.location.href);
  n.searchParams.get(e) && (n.searchParams.delete(e), t ? window.history.replaceState({ ...window.history.state, as: n.href }, "", n.href) : window.history.pushState({ ...window.history.state, as: n.href }, "", n.href));
}, pce = () => lcc((e, t) => ({
  state: "loading",
  setState: (n) => e({ state: n }),
  layout: io.MONTH_VIEW,
  setLayout: (n) => (["week_view", "column_view"].includes(n) && !t().selectedDate && e({ selectedDate: ht().format("YYYY-MM-DD") }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("layout", n), e({ layout: n })),
  selectedDate: zc("date") || null,
  setSelectedDate: ({ date: n, omitUpdatingParams: o = !1, preventMonthSwitching: r = !1 }) => {
    if (!n) {
      BE("date");
      return;
    }
    const i = ht(t().selectedDate), a = ht(n);
    e({ selectedDate: n }), !o && (!t().isPlatform || t().allowUpdatingUrlParams) && vd("date", n ?? ""), !r && a.month() !== i.month() && (e({ month: a.format("YYYY-MM") }), !o && (!t().isPlatform || t().allowUpdatingUrlParams) && vd("month", a.format("YYYY-MM")));
  },
  selectedDatesAndTimes: null,
  setSelectedDatesAndTimes: (n) => {
    e({ selectedDatesAndTimes: n });
  },
  addToSelectedDate: (n) => {
    const o = ht(t().selectedDate);
    let r = o.add(n, "day");
    r.isBefore(ht(), "day") && (r = ht());
    const i = r.format("YYYY-MM-DD");
    r.month() !== o.month() && (e({ month: r.format("YYYY-MM") }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("month", r.format("YYYY-MM"))), e({ selectedDate: i }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("date", i);
  },
  username: null,
  eventSlug: null,
  eventId: null,
  rescheduledBy: null,
  verifiedEmail: null,
  setVerifiedEmail: (n) => {
    e({ verifiedEmail: n });
  },
  verificationCode: null,
  setVerificationCode: (n) => {
    e({ verificationCode: n });
  },
  month: zc("month") || (zc("date") && ht(zc("date")).isValid() ? ht(zc("date")).format("YYYY-MM") : null) || ht().format("YYYY-MM"),
  setMonth: (n) => {
    if (!n) {
      BE("month");
      return;
    }
    e({ month: n, selectedTimeslot: null }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("month", n ?? ""), t().setSelectedDate({ date: null });
  },
  dayCount: NM > 0 ? NM : null,
  setDayCount: (n) => {
    e({ dayCount: n });
  },
  isTeamEvent: !1,
  seatedEventData: {
    seatsPerTimeSlot: void 0,
    attendees: void 0,
    bookingUid: void 0,
    showAvailableSeatsCount: !0
  },
  setSeatedEventData: (n) => {
    e({ seatedEventData: n }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("bookingUid", n.bookingUid ?? "null");
  },
  // This is different from timeZone in timePreferencesStore, because timeZone in timePreferencesStore is the preferred timezone of the booker,
  // it is the timezone configured through query param. So, this is in a way the preference of the person who shared the link.
  // it is the timezone configured through query param. So, this is in a way the preference of the person who shared the link.
  timezone: zc("cal.tz") ?? null,
  setTimezone: (n) => {
    e({ timezone: n });
  },
  initialize: ({
    username: n,
    eventSlug: o,
    month: r,
    eventId: i,
    rescheduleUid: a = null,
    rescheduledBy: s = null,
    bookingUid: c = null,
    bookingData: l = null,
    layout: u,
    isTeamEvent: d,
    durationConfig: _,
    org: p,
    isInstantMeeting: g,
    timezone: f = null,
    teamMemberEmail: h,
    crmOwnerRecordType: $,
    crmAppSlug: v,
    crmRecordId: b,
    isPlatform: y = !1,
    allowUpdatingUrlParams: w = !0
  }) => {
    var M;
    const N = t().selectedDate;
    if (!(t().username === n && t().eventSlug === o && t().month === r && t().eventId === i && t().rescheduleUid === a && t().bookingUid === c && ((M = t().bookingData) == null ? void 0 : M.responses.email) === (l == null ? void 0 : l.responses.email) && t().layout === u && t().timezone === f && t().rescheduledBy === s && t().teamMemberEmail === h && t().crmOwnerRecordType === $ && t().crmAppSlug === v && t().crmRecordId === b) && (e({
      username: n,
      eventSlug: o,
      eventId: i,
      org: p,
      rescheduleUid: a,
      rescheduledBy: s,
      bookingUid: c,
      bookingData: l,
      layout: u || io.MONTH_VIEW,
      isTeamEvent: d || !1,
      durationConfig: _,
      timezone: f,
      // Preselect today's date in week / column view, since they use this to show the week title.
      selectedDate: N || (["week_view", "column_view"].includes(u) ? ht().format("YYYY-MM-DD") : null),
      teamMemberEmail: h,
      crmOwnerRecordType: $,
      crmAppSlug: v,
      crmRecordId: b,
      isPlatform: y,
      allowUpdatingUrlParams: w
    }), _ != null && _.includes(Number(zc("duration"))) ? e({
      selectedDuration: Number(zc("duration"))
    }) : BE("duration"), a && l && e({ selectedTimeslot: null }), r && e({ month: r }), g)) {
      const q = ht().format("YYYY-MM"), L = ht().format("YYYY-MM-DD"), R = (/* @__PURE__ */ new Date()).toISOString();
      e({
        month: q,
        selectedDate: L,
        selectedTimeslot: R,
        isInstantMeeting: g
      }), (!y || w) && (vd("month", q), vd("date", L ?? ""), vd("slot", R ?? "", !1));
    }
  },
  durationConfig: null,
  selectedDuration: null,
  setSelectedDuration: (n) => {
    e({ selectedDuration: n }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("duration", n ?? "");
  },
  setBookingData: (n) => {
    e({ bookingData: n ?? null });
  },
  setRescheduleUid: (n) => {
    e({ rescheduleUid: n });
  },
  recurringEventCount: null,
  setRecurringEventCount: (n) => e({ recurringEventCount: n }),
  occurenceCount: null,
  setOccurenceCount: (n) => e({ occurenceCount: n }),
  rescheduleUid: null,
  bookingData: null,
  bookingUid: null,
  selectedTimeslot: zc("slot") || null,
  tentativeSelectedTimeslots: [],
  setTentativeSelectedTimeslots: (n) => {
    e({ tentativeSelectedTimeslots: n });
  },
  setSelectedTimeslot: (n) => {
    e({ selectedTimeslot: n }), (!t().isPlatform || t().allowUpdatingUrlParams) && vd("slot", n ?? "", !1);
  },
  formValues: {},
  setFormValues: (n) => {
    e({ formValues: n });
  },
  org: null,
  setOrg: (n) => {
    e({ org: n });
  },
  isPlatform: !1,
  allowUpdatingUrlParams: !0
})), Fu = pce(), mce = ({
  username: e,
  eventSlug: t,
  month: n,
  eventId: o,
  rescheduleUid: r = null,
  rescheduledBy: i = null,
  bookingData: a = null,
  verifiedEmail: s = null,
  layout: c,
  isTeamEvent: l,
  durationConfig: u,
  org: d,
  isInstantMeeting: _,
  timezone: p = null,
  teamMemberEmail: g,
  crmOwnerRecordType: f,
  crmAppSlug: h,
  crmRecordId: $,
  isPlatform: v = !1,
  allowUpdatingUrlParams: b = !0
}) => {
  const y = Fu((w) => w.initialize);
  yt(() => {
    y({
      username: e,
      eventSlug: t,
      month: n,
      eventId: o,
      rescheduleUid: r,
      rescheduledBy: i,
      bookingData: a,
      layout: c,
      isTeamEvent: l,
      org: d,
      verifiedEmail: s,
      durationConfig: u,
      isInstantMeeting: _,
      timezone: p,
      teamMemberEmail: g,
      crmOwnerRecordType: f,
      crmAppSlug: h,
      crmRecordId: $,
      isPlatform: v,
      allowUpdatingUrlParams: b
    });
  }, [
    y,
    d,
    e,
    t,
    n,
    o,
    r,
    i,
    a,
    c,
    l,
    s,
    u,
    _,
    p,
    g,
    f,
    h,
    $,
    v,
    b
  ]);
}, FT = Cr(null), Wy = ({ children: e }) => {
  const t = xt();
  return t.current || (t.current = pce()), /* @__PURE__ */ m(FT.Provider, { value: t.current, children: e });
}, _n = (e, t) => {
  const n = bo(FT);
  if (!n)
    throw new Error("useBookerStoreContext must be used within BookerStoreProvider");
  return uF(n, e, t);
}, fF = ({
  username: e,
  eventSlug: t,
  month: n,
  eventId: o,
  rescheduleUid: r = null,
  rescheduledBy: i = null,
  bookingData: a = null,
  verifiedEmail: s = null,
  layout: c,
  isTeamEvent: l,
  durationConfig: u,
  org: d,
  isInstantMeeting: _,
  timezone: p = null,
  teamMemberEmail: g,
  crmOwnerRecordType: f,
  crmAppSlug: h,
  crmRecordId: $,
  isPlatform: v = !1,
  allowUpdatingUrlParams: b = !0
}) => {
  const y = bo(FT);
  if (!y)
    throw new Error("useInitializeBookerStoreContext must be used within BookerStoreProvider");
  const w = uF(y, (N) => N.initialize);
  yt(() => {
    w({
      username: e,
      eventSlug: t,
      month: n,
      eventId: o,
      rescheduleUid: r,
      rescheduledBy: i,
      bookingData: a,
      layout: c,
      isTeamEvent: l,
      org: d,
      verifiedEmail: s,
      durationConfig: u,
      isInstantMeeting: _,
      timezone: p,
      teamMemberEmail: g,
      crmOwnerRecordType: f,
      crmAppSlug: h,
      crmRecordId: $,
      isPlatform: v,
      allowUpdatingUrlParams: b
    });
  }, [
    w,
    d,
    e,
    t,
    n,
    o,
    r,
    i,
    a,
    c,
    l,
    s,
    u,
    _,
    p,
    g,
    f,
    h,
    $,
    v,
    b
  ]);
}, fce = "Dialog", [gce, nsu] = jc(fce), [Ulc, H_] = gce(fce), Glc = (e) => {
  const { __scopeDialog: t, children: n, open: o, defaultOpen: r, onOpenChange: i, modal: a = !0 } = e, s = xt(null), c = xt(null), [l = !1, u] = Uu({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ pt(Ulc, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: Pu(),
    titleId: Pu(),
    descriptionId: Pu(),
    open: l,
    onOpenChange: u,
    onOpenToggle: Yt(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: a
  }, n);
}, Wlc = "DialogTrigger", Hlc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = H_(Wlc, n), i = ni(t, r.triggerRef);
  return /* @__PURE__ */ pt(nr.button, Tt({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": r.open,
    "aria-controls": r.contentId,
    "data-state": gF(r.open)
  }, o, {
    ref: i,
    onClick: jn(e.onClick, r.onOpenToggle)
  }));
}), hce = "DialogPortal", [Ylc, vce] = gce(hce, {
  forceMount: void 0
}), Klc = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, i = H_(hce, t);
  return /* @__PURE__ */ pt(Ylc, {
    scope: t,
    forceMount: n
  }, hg.map(
    o,
    (a) => /* @__PURE__ */ pt(Vc, {
      present: n || i.open
    }, /* @__PURE__ */ pt(D6, {
      asChild: !0,
      container: r
    }, a))
  ));
}, qM = "DialogOverlay", Zlc = /* @__PURE__ */ Bt((e, t) => {
  const n = vce(qM, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = H_(qM, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ pt(Vc, {
    present: o || i.open
  }, /* @__PURE__ */ pt(Xlc, Tt({}, r, {
    ref: t
  }))) : null;
}), Xlc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = H_(qM, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ pt(eF, {
      as: av,
      allowPinchZoom: !0,
      shards: [
        r.contentRef
      ]
    }, /* @__PURE__ */ pt(nr.div, Tt({
      "data-state": gF(r.open)
    }, o, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...o.style
      }
    })))
  );
}), Ak = "DialogContent", Jlc = /* @__PURE__ */ Bt((e, t) => {
  const n = vce(Ak, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = H_(Ak, e.__scopeDialog);
  return /* @__PURE__ */ pt(Vc, {
    present: o || i.open
  }, i.modal ? /* @__PURE__ */ pt(Qlc, Tt({}, r, {
    ref: t
  })) : /* @__PURE__ */ pt(euc, Tt({}, r, {
    ref: t
  })));
}), Qlc = /* @__PURE__ */ Bt((e, t) => {
  const n = H_(Ak, e.__scopeDialog), o = xt(null), r = ni(t, n.contentRef, o);
  return yt(() => {
    const i = o.current;
    if (i)
      return Q6(i);
  }, []), /* @__PURE__ */ pt(bce, Tt({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: jn(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: jn(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && i.preventDefault();
    }),
    onFocusOutside: jn(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), euc = /* @__PURE__ */ Bt((e, t) => {
  const n = H_(Ak, e.__scopeDialog), o = xt(!1), r = xt(!1);
  return /* @__PURE__ */ pt(bce, Tt({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      o.current = !1, r.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (o.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
    }
  }));
}), bce = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, ...a } = e, s = H_(Ak, n), c = xt(null), l = ni(t, c);
  return Y6(), /* @__PURE__ */ pt(Ha, null, /* @__PURE__ */ pt(K6, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ pt(ST, Tt({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": gF(s.open)
  }, a, {
    ref: l,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), tuc = "DialogTitle", nuc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = H_(tuc, n);
  return /* @__PURE__ */ pt(nr.h2, Tt({
    id: r.titleId
  }, o, {
    ref: t
  }));
}), ouc = "DialogDescription", ruc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = H_(ouc, n);
  return /* @__PURE__ */ pt(nr.p, Tt({
    id: r.descriptionId
  }, o, {
    ref: t
  }));
}), iuc = "DialogClose", auc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = H_(iuc, n);
  return /* @__PURE__ */ pt(nr.button, Tt({
    type: "button"
  }, o, {
    ref: t,
    onClick: jn(
      e.onClick,
      () => r.onOpenChange(!1)
    )
  }));
});
function gF(e) {
  return e ? "open" : "closed";
}
const yce = Glc, $ce = Hlc, wce = Klc, hF = Zlc, vF = Jlc, bF = nuc, yF = ruc, kce = auc, $F = yce, Sce = $ce, suc = wce, Ece = ({ children: e }) => /* @__PURE__ */ m(wce, { className: "calcom-atoms", children: /* @__PURE__ */ m("div", { className: "calcom-atoms", children: e }) }), xce = yce, Cce = $ce, Tce = hF, Ace = vF, Ice = bF, Oce = yF, wF = kce, Nce = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  hF,
  {
    ref: n,
    className: ar(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0  fixed inset-0 z-50 bg-black/80",
      e
    ),
    ...t
  }
));
Nce.displayName = hF.displayName;
const kF = Ue.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(suc, { children: /* @__PURE__ */ de("div", { className: "calcom-atoms", children: [
  /* @__PURE__ */ m(Nce, {}),
  /* @__PURE__ */ de(
    vF,
    {
      ref: o,
      className: ar(
        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ de(kce, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
          /* @__PURE__ */ m(qt, { name: "x", className: "h-4 w-4" }),
          /* @__PURE__ */ m("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }) }) }));
kF.displayName = vF.displayName;
const zce = ({ className: e, ...t }) => /* @__PURE__ */ m("div", { className: ar("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
zce.displayName = "DialogHeader";
const Rce = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  bF,
  {
    ref: n,
    className: ar("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Rce.displayName = bF.displayName;
const Pce = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  yF,
  {
    ref: n,
    className: ar("text-muted-foreground text-sm", e),
    ...t
  }
));
Pce.displayName = yF.displayName;
var jM = { exports: {} }, Dce = {};
(function(e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(l, u) {
    for (var d in u)
      Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
  }
  t(e, {
    AppRouterContext: function() {
      return r;
    },
    GlobalLayoutRouterContext: function() {
      return a;
    },
    LayoutRouterContext: function() {
      return i;
    },
    MissingSlotContext: function() {
      return c;
    },
    TemplateContext: function() {
      return s;
    }
  });
  const o = /* @__PURE__ */ qg._(Fe), r = o.default.createContext(null), i = o.default.createContext(null), a = o.default.createContext(null), s = o.default.createContext(null);
  process.env.NODE_ENV !== "production" && (r.displayName = "AppRouterContext", i.displayName = "LayoutRouterContext", a.displayName = "GlobalLayoutRouterContext", s.displayName = "TemplateContext");
  const c = o.default.createContext(/* @__PURE__ */ new Set());
})(Dce);
var Lce = {};
(function(e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(a, s) {
    for (var c in s)
      Object.defineProperty(a, c, {
        enumerable: !0,
        get: s[c]
      });
  }
  t(e, {
    PathParamsContext: function() {
      return i;
    },
    PathnameContext: function() {
      return r;
    },
    SearchParamsContext: function() {
      return o;
    }
  });
  const n = Fe, o = (0, n.createContext)(null), r = (0, n.createContext)(null), i = (0, n.createContext)(null);
  process.env.NODE_ENV !== "production" && (o.displayName = "SearchParamsContext", r.displayName = "PathnameContext", i.displayName = "PathParamsContext");
})(Lce);
var VM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "getSegmentValue", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function n(o) {
    return Array.isArray(o) ? o[1] : o;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(VM, VM.exports);
var cuc = VM.exports, BM = { exports: {} }, UM = { exports: {} }, GM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "RedirectStatusCode", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  var n = /* @__PURE__ */ function(o) {
    return o[o.SeeOther = 303] = "SeeOther", o[o.TemporaryRedirect = 307] = "TemporaryRedirect", o[o.PermanentRedirect = 308] = "PermanentRedirect", o;
  }({});
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(GM, GM.exports);
var Mce = GM.exports, WM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(s, c) {
    for (var l in c)
      Object.defineProperty(s, l, {
        enumerable: !0,
        get: c[l]
      });
  }
  n(t, {
    REDIRECT_ERROR_CODE: function() {
      return r;
    },
    RedirectType: function() {
      return i;
    },
    isRedirectError: function() {
      return a;
    }
  });
  const o = Mce, r = "NEXT_REDIRECT";
  var i = /* @__PURE__ */ function(s) {
    return s.push = "push", s.replace = "replace", s;
  }({});
  function a(s) {
    if (typeof s != "object" || s === null || !("digest" in s) || typeof s.digest != "string")
      return !1;
    const c = s.digest.split(";"), [l, u] = c, d = c.slice(2, -2).join(";"), _ = c.at(-2), p = Number(_);
    return l === r && (u === "replace" || u === "push") && typeof d == "string" && !isNaN(p) && p in o.RedirectStatusCode;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(WM, WM.exports);
var SF = WM.exports, YO = {}, KO = {}, ZO = {}, XG;
function EF() {
  return XG || (XG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var u in l)
        Object.defineProperty(c, u, {
          enumerable: !0,
          get: l[u]
        });
    }
    t(e, {
      bindSnapshot: function() {
        return a;
      },
      createAsyncLocalStorage: function() {
        return i;
      },
      createSnapshot: function() {
        return s;
      }
    });
    const n = Object.defineProperty(new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available"), "__NEXT_ERROR_CODE", {
      value: "E504",
      enumerable: !1,
      configurable: !0
    });
    class o {
      disable() {
        throw n;
      }
      getStore() {
      }
      run() {
        throw n;
      }
      exit() {
        throw n;
      }
      enterWith() {
        throw n;
      }
      static bind(l) {
        return l;
      }
    }
    const r = typeof globalThis < "u" && globalThis.AsyncLocalStorage;
    function i() {
      return r ? new r() : new o();
    }
    function a(c) {
      return r ? r.bind(c) : o.bind(c);
    }
    function s() {
      return r ? r.snapshot() : function(c, ...l) {
        return c(...l);
      };
    }
  }(ZO)), ZO;
}
var JG;
function luc() {
  return JG || (JG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "actionAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, EF().createAsyncLocalStorage)();
  }(KO)), KO;
}
var QG;
function uuc() {
  return QG || (QG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "actionAsyncStorage", {
      enumerable: !0,
      get: function() {
        return t.actionAsyncStorageInstance;
      }
    });
    const t = luc();
  }(YO)), YO;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(_, p) {
    for (var g in p)
      Object.defineProperty(_, g, {
        enumerable: !0,
        get: p[g]
      });
  }
  n(t, {
    getRedirectError: function() {
      return a;
    },
    getRedirectStatusCodeFromError: function() {
      return d;
    },
    getRedirectTypeFromError: function() {
      return u;
    },
    getURLFromRedirectError: function() {
      return l;
    },
    permanentRedirect: function() {
      return c;
    },
    redirect: function() {
      return s;
    }
  });
  const o = Mce, r = SF, i = typeof window > "u" ? uuc().actionAsyncStorage : void 0;
  function a(_, p, g) {
    g === void 0 && (g = o.RedirectStatusCode.TemporaryRedirect);
    const f = Object.defineProperty(new Error(r.REDIRECT_ERROR_CODE), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    return f.digest = r.REDIRECT_ERROR_CODE + ";" + p + ";" + _ + ";" + g + ";", f;
  }
  function s(_, p) {
    var g;
    throw p ?? (p = !(i == null || (g = i.getStore()) == null) && g.isAction ? r.RedirectType.push : r.RedirectType.replace), a(_, p, o.RedirectStatusCode.TemporaryRedirect);
  }
  function c(_, p) {
    throw p === void 0 && (p = r.RedirectType.replace), a(_, p, o.RedirectStatusCode.PermanentRedirect);
  }
  function l(_) {
    return (0, r.isRedirectError)(_) ? _.digest.split(";").slice(2, -2).join(";") : null;
  }
  function u(_) {
    if (!(0, r.isRedirectError)(_))
      throw Object.defineProperty(new Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
        value: "E260",
        enumerable: !1,
        configurable: !0
      });
    return _.digest.split(";", 2)[1];
  }
  function d(_) {
    if (!(0, r.isRedirectError)(_))
      throw Object.defineProperty(new Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
        value: "E260",
        enumerable: !1,
        configurable: !0
      });
    return Number(_.digest.split(";").at(-2));
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(UM, UM.exports);
var duc = UM.exports, HM = { exports: {} }, YM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(l, u) {
    for (var d in u)
      Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
  }
  n(t, {
    HTTPAccessErrorStatus: function() {
      return o;
    },
    HTTP_ERROR_FALLBACK_ERROR_CODE: function() {
      return i;
    },
    getAccessFallbackErrorTypeByStatus: function() {
      return c;
    },
    getAccessFallbackHTTPStatus: function() {
      return s;
    },
    isHTTPAccessFallbackError: function() {
      return a;
    }
  });
  const o = {
    NOT_FOUND: 404,
    FORBIDDEN: 403,
    UNAUTHORIZED: 401
  }, r = new Set(Object.values(o)), i = "NEXT_HTTP_ERROR_FALLBACK";
  function a(l) {
    if (typeof l != "object" || l === null || !("digest" in l) || typeof l.digest != "string")
      return !1;
    const [u, d] = l.digest.split(";");
    return u === i && r.has(Number(d));
  }
  function s(l) {
    const u = l.digest.split(";")[1];
    return Number(u);
  }
  function c(l) {
    switch (l) {
      case 401:
        return "unauthorized";
      case 403:
        return "forbidden";
      case 404:
        return "not-found";
      default:
        return;
    }
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(YM, YM.exports);
var qT = YM.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "notFound", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const o = "" + qT.HTTP_ERROR_FALLBACK_ERROR_CODE + ";404";
  function r() {
    const i = Object.defineProperty(new Error(o), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    throw i.digest = o, i;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(HM, HM.exports);
var _uc = HM.exports, KM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "forbidden", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const o = "" + qT.HTTP_ERROR_FALLBACK_ERROR_CODE + ";403";
  function r() {
    if (!process.env.__NEXT_EXPERIMENTAL_AUTH_INTERRUPTS)
      throw Object.defineProperty(new Error("`forbidden()` is experimental and only allowed to be enabled when `experimental.authInterrupts` is enabled."), "__NEXT_ERROR_CODE", {
        value: "E488",
        enumerable: !1,
        configurable: !0
      });
    const i = Object.defineProperty(new Error(o), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    throw i.digest = o, i;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(KM, KM.exports);
var puc = KM.exports, ZM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "unauthorized", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const o = "" + qT.HTTP_ERROR_FALLBACK_ERROR_CODE + ";401";
  function r() {
    if (!process.env.__NEXT_EXPERIMENTAL_AUTH_INTERRUPTS)
      throw Object.defineProperty(new Error("`unauthorized()` is experimental and only allowed to be used when `experimental.authInterrupts` is enabled."), "__NEXT_ERROR_CODE", {
        value: "E411",
        enumerable: !1,
        configurable: !0
      });
    const i = Object.defineProperty(new Error(o), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    throw i.digest = o, i;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(ZM, ZM.exports);
var muc = ZM.exports, XM = { exports: {} }, $S = { exports: {} }, XO = {}, eW;
function jT() {
  return eW || (eW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var s in a)
        Object.defineProperty(i, s, {
          enumerable: !0,
          get: a[s]
        });
    }
    t(e, {
      BailoutToCSRError: function() {
        return o;
      },
      isBailoutToCSRError: function() {
        return r;
      }
    });
    const n = "BAILOUT_TO_CLIENT_SIDE_RENDERING";
    class o extends Error {
      constructor(a) {
        super("Bail out to client-side rendering: " + a), this.reason = a, this.digest = n;
      }
    }
    function r(i) {
      return typeof i != "object" || i === null || !("digest" in i) ? !1 : i.digest === n;
    }
  }(XO)), XO;
}
var wS = { exports: {} }, tW;
function Fce() {
  return tW || (tW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isNextRouterError", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = qT, o = SF;
    function r(i) {
      return (0, o.isRedirectError)(i) || (0, n.isHTTPAccessFallbackError)(i);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(wS, wS.exports)), wS.exports;
}
var nW;
function fuc() {
  return nW || (nW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = jT(), o = Fce();
    function r(i) {
      if ((0, o.isNextRouterError)(i) || (0, n.isBailoutToCSRError)(i))
        throw i;
      i instanceof Error && "cause" in i && r(i.cause);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }($S, $S.exports)), $S.exports;
}
var kS = { exports: {} }, JO = {}, oW;
function qce() {
  return oW || (oW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, u) {
      for (var d in u)
        Object.defineProperty(l, d, {
          enumerable: !0,
          get: u[d]
        });
    }
    t(e, {
      isHangingPromiseRejectionError: function() {
        return n;
      },
      makeDevtoolsIOAwarePromise: function() {
        return c;
      },
      makeHangingPromise: function() {
        return a;
      }
    });
    function n(l) {
      return typeof l != "object" || l === null || !("digest" in l) ? !1 : l.digest === o;
    }
    const o = "HANGING_PROMISE_REJECTION";
    class r extends Error {
      constructor(u, d) {
        super(`During prerendering, ${d} rejects when the prerender is complete. Typically these errors are handled by React but if you move ${d} to a different context by using \`setTimeout\`, \`after\`, or similar functions you may observe this error and you should handle it in that context. This occurred at route "${u}".`), this.route = u, this.expression = d, this.digest = o;
      }
    }
    const i = /* @__PURE__ */ new WeakMap();
    function a(l, u, d) {
      if (l.aborted)
        return Promise.reject(new r(u, d));
      {
        const _ = new Promise((p, g) => {
          const f = g.bind(null, new r(u, d));
          let h = i.get(l);
          if (h)
            h.push(f);
          else {
            const $ = [
              f
            ];
            i.set(l, $), l.addEventListener("abort", () => {
              for (let v = 0; v < $.length; v++)
                $[v]();
            }, {
              once: !0
            });
          }
        });
        return _.catch(s), _;
      }
    }
    function s() {
    }
    function c(l) {
      return new Promise((u) => {
        setTimeout(() => {
          u(l);
        }, 0);
      });
    }
  }(JO)), JO;
}
var QO = {}, rW;
function guc() {
  return rW || (rW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isPostpone", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = Symbol.for("react.postpone");
    function n(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
  }(QO)), QO;
}
var eN = {}, SS = { exports: {} }, iW;
function jce() {
  return iW || (iW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    n(t, {
      DynamicServerError: function() {
        return r;
      },
      isDynamicServerError: function() {
        return i;
      }
    });
    const o = "DYNAMIC_SERVER_USAGE";
    class r extends Error {
      constructor(s) {
        super("Dynamic server usage: " + s), this.description = s, this.digest = o;
      }
    }
    function i(a) {
      return typeof a != "object" || a === null || !("digest" in a) || typeof a.digest != "string" ? !1 : a.digest === o;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(SS, SS.exports)), SS.exports;
}
var ES = { exports: {} }, aW;
function huc() {
  return aW || (aW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    n(t, {
      StaticGenBailoutError: function() {
        return r;
      },
      isStaticGenBailoutError: function() {
        return i;
      }
    });
    const o = "NEXT_STATIC_GEN_BAILOUT";
    class r extends Error {
      constructor(...s) {
        super(...s), this.code = o;
      }
    }
    function i(a) {
      return typeof a != "object" || a === null || !("code" in a) ? !1 : a.code === o;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(ES, ES.exports)), ES.exports;
}
var tN = {}, nN = {}, sW;
function vuc() {
  return sW || (sW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workUnitAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, EF().createAsyncLocalStorage)();
  }(nN)), nN;
}
var xS = { exports: {} }, cW;
function buc() {
  return cW || (cW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(y, w) {
      for (var N in w)
        Object.defineProperty(y, N, {
          enumerable: !0,
          get: w[N]
        });
    }
    n(t, {
      ACTION_HEADER: function() {
        return r;
      },
      FLIGHT_HEADERS: function() {
        return _;
      },
      NEXT_ACTION_NOT_FOUND_HEADER: function() {
        return b;
      },
      NEXT_DID_POSTPONE_HEADER: function() {
        return f;
      },
      NEXT_HMR_REFRESH_HASH_COOKIE: function() {
        return l;
      },
      NEXT_HMR_REFRESH_HEADER: function() {
        return c;
      },
      NEXT_IS_PRERENDER_HEADER: function() {
        return v;
      },
      NEXT_REWRITTEN_PATH_HEADER: function() {
        return h;
      },
      NEXT_REWRITTEN_QUERY_HEADER: function() {
        return $;
      },
      NEXT_ROUTER_PREFETCH_HEADER: function() {
        return a;
      },
      NEXT_ROUTER_SEGMENT_PREFETCH_HEADER: function() {
        return s;
      },
      NEXT_ROUTER_STALE_TIME_HEADER: function() {
        return g;
      },
      NEXT_ROUTER_STATE_TREE_HEADER: function() {
        return i;
      },
      NEXT_RSC_UNION_QUERY: function() {
        return p;
      },
      NEXT_URL: function() {
        return u;
      },
      RSC_CONTENT_TYPE_HEADER: function() {
        return d;
      },
      RSC_HEADER: function() {
        return o;
      }
    });
    const o = "rsc", r = "next-action", i = "next-router-state-tree", a = "next-router-prefetch", s = "next-router-segment-prefetch", c = "next-hmr-refresh", l = "__next_hmr_refresh_hash__", u = "next-url", d = "text/x-component", _ = [
      o,
      i,
      a,
      c,
      s
    ], p = "_rsc", g = "x-nextjs-stale-time", f = "x-nextjs-postponed", h = "x-nextjs-rewritten-path", $ = "x-nextjs-rewritten-query", v = "x-nextjs-prerender", b = "x-nextjs-action-not-found";
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(xS, xS.exports)), xS.exports;
}
var oN = {}, lW;
function Vce() {
  return lW || (lW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "InvariantError", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    class t extends Error {
      constructor(o, r) {
        super("Invariant: " + (o.endsWith(".") ? o : o + ".") + " This is a bug in Next.js.", r), this.name = "InvariantError";
      }
    }
  }(oN)), oN;
}
var uW;
function Bce() {
  return uW || (uW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(f, h) {
      for (var $ in h)
        Object.defineProperty(f, $, {
          enumerable: !0,
          get: h[$]
        });
    }
    t(e, {
      getCacheSignal: function() {
        return p;
      },
      getDraftModeProviderForCacheScope: function() {
        return _;
      },
      getHmrRefreshHash: function() {
        return l;
      },
      getPrerenderResumeDataCache: function() {
        return s;
      },
      getRenderResumeDataCache: function() {
        return c;
      },
      getRuntimeStagePromise: function() {
        return g;
      },
      getServerComponentsHmrCache: function() {
        return d;
      },
      isHmrRefresh: function() {
        return u;
      },
      throwForMissingRequestStore: function() {
        return i;
      },
      throwInvariantForMissingStore: function() {
        return a;
      },
      workUnitAsyncStorage: function() {
        return n.workUnitAsyncStorageInstance;
      }
    });
    const n = vuc(), o = buc(), r = Vce();
    function i(f) {
      throw Object.defineProperty(new Error(`\`${f}\` was called outside a request scope. Read more: https://nextjs.org/docs/messages/next-dynamic-api-wrong-context`), "__NEXT_ERROR_CODE", {
        value: "E251",
        enumerable: !1,
        configurable: !0
      });
    }
    function a() {
      throw Object.defineProperty(new r.InvariantError("Expected workUnitAsyncStorage to have a store."), "__NEXT_ERROR_CODE", {
        value: "E696",
        enumerable: !1,
        configurable: !0
      });
    }
    function s(f) {
      switch (f.type) {
        case "prerender":
        case "prerender-runtime":
        case "prerender-ppr":
          return f.prerenderResumeDataCache;
        case "prerender-client":
          return f.prerenderResumeDataCache;
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
          return null;
        default:
          return f;
      }
    }
    function c(f) {
      switch (f.type) {
        case "request":
          return f.renderResumeDataCache;
        case "prerender":
        case "prerender-runtime":
        case "prerender-client":
          if (f.renderResumeDataCache)
            return f.renderResumeDataCache;
        case "prerender-ppr":
          return f.prerenderResumeDataCache;
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "prerender-legacy":
          return null;
        default:
          return f;
      }
    }
    function l(f, h) {
      if (f.dev)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "prerender":
          case "prerender-runtime":
            return h.hmrRefreshHash;
          case "request":
            var $;
            return ($ = h.cookies.get(o.NEXT_HMR_REFRESH_HASH_COOKIE)) == null ? void 0 : $.value;
        }
    }
    function u(f, h) {
      if (f.dev)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "request":
            return h.isHmrRefresh ?? !1;
        }
      return !1;
    }
    function d(f, h) {
      if (f.dev)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "request":
            return h.serverComponentsHmrCache;
        }
    }
    function _(f, h) {
      if (f.isDraftMode)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "unstable-cache":
          case "prerender-runtime":
          case "request":
            return h.draftMode;
        }
    }
    function p(f) {
      switch (f.type) {
        case "prerender":
        case "prerender-client":
        case "prerender-runtime":
          return f.cacheSignal;
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
          return null;
        default:
          return f;
      }
    }
    function g(f) {
      switch (f.type) {
        case "prerender-runtime":
        case "private-cache":
          return f.runtimeStagePromise;
        case "prerender":
        case "prerender-client":
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "unstable-cache":
          return null;
        default:
          return f;
      }
    }
  }(tN)), tN;
}
var rN = {}, iN = {}, dW;
function yuc() {
  return dW || (dW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, EF().createAsyncLocalStorage)();
  }(iN)), iN;
}
var _W;
function Uce() {
  return _W || (_W = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workAsyncStorage", {
      enumerable: !0,
      get: function() {
        return t.workAsyncStorageInstance;
      }
    });
    const t = yuc();
  }(rN)), rN;
}
var aN = {}, pW;
function $uc() {
  return pW || (pW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      METADATA_BOUNDARY_NAME: function() {
        return n;
      },
      OUTLET_BOUNDARY_NAME: function() {
        return r;
      },
      ROOT_LAYOUT_BOUNDARY_NAME: function() {
        return i;
      },
      VIEWPORT_BOUNDARY_NAME: function() {
        return o;
      }
    });
    const n = "__next_metadata_boundary__", o = "__next_viewport_boundary__", r = "__next_outlet_boundary__", i = "__next_root_layout_boundary__";
  }(aN)), aN;
}
var sN = {}, mW;
function wuc() {
  return mW || (mW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      atLeastOneTask: function() {
        return r;
      },
      scheduleImmediate: function() {
        return o;
      },
      scheduleOnNextTick: function() {
        return n;
      },
      waitAtLeastOneReactRenderTask: function() {
        return i;
      }
    });
    const n = (a) => {
      Promise.resolve().then(() => {
        process.env.NEXT_RUNTIME === "edge" ? setTimeout(a, 0) : process.nextTick(a);
      });
    }, o = (a) => {
      process.env.NEXT_RUNTIME === "edge" ? setTimeout(a, 0) : setImmediate(a);
    };
    function r() {
      return new Promise((a) => o(a));
    }
    function i() {
      return process.env.NEXT_RUNTIME === "edge" ? new Promise((a) => setTimeout(a, 0)) : new Promise((a) => setImmediate(a));
    }
  }(sN)), sN;
}
var fW;
function Gce() {
  return fW || (fW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(pe, ge) {
      for (var ve in ge)
        Object.defineProperty(pe, ve, {
          enumerable: !0,
          get: ge[ve]
        });
    }
    t(e, {
      Postpone: function() {
        return R;
      },
      PreludeState: function() {
        return be;
      },
      abortAndThrowOnSynchronousRequestDataAccess: function() {
        return M;
      },
      abortOnSynchronousPlatformIOAccess: function() {
        return w;
      },
      accessedDynamicData: function() {
        return I;
      },
      annotateDynamicAccess: function() {
        return U;
      },
      consumeDynamicAccess: function() {
        return z;
      },
      createDynamicTrackingState: function() {
        return g;
      },
      createDynamicValidationState: function() {
        return f;
      },
      createHangingInputAbortSignal: function() {
        return V;
      },
      createRenderInBrowserAbortSignal: function() {
        return O;
      },
      delayUntilRuntimeStage: function() {
        return ne;
      },
      formatDynamicAPIAccesses: function() {
        return F;
      },
      getFirstDynamicReason: function() {
        return h;
      },
      isDynamicPostpone: function() {
        return A;
      },
      isPrerenderInterruptedError: function() {
        return k;
      },
      logDisallowedDynamicError: function() {
        return Q;
      },
      markCurrentScopeAsDynamic: function() {
        return $;
      },
      postponeWithTracking: function() {
        return T;
      },
      throwIfDisallowedDynamic: function() {
        return me;
      },
      throwToInterruptStaticGeneration: function() {
        return v;
      },
      trackAllowedDynamicAccess: function() {
        return _e;
      },
      trackDynamicDataInDynamicRender: function() {
        return b;
      },
      trackSynchronousPlatformIOAccessInDev: function() {
        return N;
      },
      trackSynchronousRequestDataAccessInDev: function() {
        return L;
      },
      useDynamicRouteParams: function() {
        return H;
      },
      warnOnSyncDynamicError: function() {
        return q;
      }
    });
    const n = /* @__PURE__ */ _(Fe), o = jce(), r = huc(), i = Bce(), a = Uce(), s = qce(), c = $uc(), l = wuc(), u = jT(), d = Vce();
    function _(pe) {
      return pe && pe.__esModule ? pe : {
        default: pe
      };
    }
    const p = typeof n.default.unstable_postpone == "function";
    function g(pe) {
      return {
        isDebugDynamicAccesses: pe,
        dynamicAccesses: [],
        syncDynamicErrorWithStack: null
      };
    }
    function f() {
      return {
        hasSuspenseAboveBody: !1,
        hasDynamicMetadata: !1,
        hasDynamicViewport: !1,
        hasAllowedDynamic: !1,
        dynamicErrors: []
      };
    }
    function h(pe) {
      var ge;
      return (ge = pe.dynamicAccesses[0]) == null ? void 0 : ge.expression;
    }
    function $(pe, ge, ve) {
      if (ge)
        switch (ge.type) {
          case "cache":
          case "unstable-cache":
            return;
          case "private-cache":
            return;
        }
      if (!(pe.forceDynamic || pe.forceStatic)) {
        if (pe.dynamicShouldError)
          throw Object.defineProperty(new r.StaticGenBailoutError(`Route ${pe.route} with \`dynamic = "error"\` couldn't be rendered statically because it used \`${ve}\`. See more info here: https://nextjs.org/docs/app/building-your-application/rendering/static-and-dynamic#dynamic-rendering`), "__NEXT_ERROR_CODE", {
            value: "E553",
            enumerable: !1,
            configurable: !0
          });
        if (ge)
          switch (ge.type) {
            case "prerender-ppr":
              return T(pe.route, ve, ge.dynamicTracking);
            case "prerender-legacy":
              ge.revalidate = 0;
              const Te = Object.defineProperty(new o.DynamicServerError(`Route ${pe.route} couldn't be rendered statically because it used ${ve}. See more info here: https://nextjs.org/docs/messages/dynamic-server-error`), "__NEXT_ERROR_CODE", {
                value: "E550",
                enumerable: !1,
                configurable: !0
              });
              throw pe.dynamicUsageDescription = ve, pe.dynamicUsageStack = Te.stack, Te;
            case "request":
              process.env.NODE_ENV !== "production" && (ge.usedDynamic = !0);
              break;
          }
      }
    }
    function v(pe, ge, ve) {
      const Te = Object.defineProperty(new o.DynamicServerError(`Route ${ge.route} couldn't be rendered statically because it used \`${pe}\`. See more info here: https://nextjs.org/docs/messages/dynamic-server-error`), "__NEXT_ERROR_CODE", {
        value: "E558",
        enumerable: !1,
        configurable: !0
      });
      throw ve.revalidate = 0, ge.dynamicUsageDescription = pe, ge.dynamicUsageStack = Te.stack, Te;
    }
    function b(pe) {
      switch (pe.type) {
        case "cache":
        case "unstable-cache":
          return;
        case "private-cache":
          return;
        case "prerender":
        case "prerender-runtime":
        case "prerender-legacy":
        case "prerender-ppr":
        case "prerender-client":
          break;
        case "request":
          process.env.NODE_ENV !== "production" && (pe.usedDynamic = !0);
          break;
      }
    }
    function y(pe, ge, ve) {
      const Te = `Route ${pe} needs to bail out of prerendering at this point because it used ${ge}.`, Re = x(Te);
      ve.controller.abort(Re);
      const Me = ve.dynamicTracking;
      Me && Me.dynamicAccesses.push({
        // When we aren't debugging, we don't need to create another error for the
        // stack trace.
        stack: Me.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: ge
      });
    }
    function w(pe, ge, ve, Te) {
      const Re = Te.dynamicTracking;
      y(pe, ge, Te), Re && Re.syncDynamicErrorWithStack === null && (Re.syncDynamicErrorWithStack = ve);
    }
    function N(pe) {
      pe.prerenderPhase = !1;
    }
    function M(pe, ge, ve, Te) {
      if (Te.controller.signal.aborted === !1) {
        y(pe, ge, Te);
        const Me = Te.dynamicTracking;
        Me && Me.syncDynamicErrorWithStack === null && (Me.syncDynamicErrorWithStack = ve);
      }
      throw x(`Route ${pe} needs to bail out of prerendering at this point because it used ${ge}.`);
    }
    function q(pe) {
      pe.syncDynamicErrorWithStack && console.error(pe.syncDynamicErrorWithStack);
    }
    const L = N;
    function R({ reason: pe, route: ge }) {
      const ve = i.workUnitAsyncStorage.getStore(), Te = ve && ve.type === "prerender-ppr" ? ve.dynamicTracking : null;
      T(ge, pe, Te);
    }
    function T(pe, ge, ve) {
      P(), ve && ve.dynamicAccesses.push({
        // When we aren't debugging, we don't need to create another error for the
        // stack trace.
        stack: ve.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: ge
      }), n.default.unstable_postpone(D(pe, ge));
    }
    function D(pe, ge) {
      return `Route ${pe} needs to bail out of prerendering at this point because it used ${ge}. React throws this special object to indicate where. It should not be caught by your own try/catch. Learn more: https://nextjs.org/docs/messages/ppr-caught-error`;
    }
    function A(pe) {
      return typeof pe == "object" && pe !== null && typeof pe.message == "string" ? S(pe.message) : !1;
    }
    function S(pe) {
      return pe.includes("needs to bail out of prerendering at this point because it used") && pe.includes("Learn more: https://nextjs.org/docs/messages/ppr-caught-error");
    }
    if (S(D("%%%", "^^^")) === !1)
      throw Object.defineProperty(new Error("Invariant: isDynamicPostpone misidentified a postpone reason. This is a bug in Next.js"), "__NEXT_ERROR_CODE", {
        value: "E296",
        enumerable: !1,
        configurable: !0
      });
    const E = "NEXT_PRERENDER_INTERRUPTED";
    function x(pe) {
      const ge = Object.defineProperty(new Error(pe), "__NEXT_ERROR_CODE", {
        value: "E394",
        enumerable: !1,
        configurable: !0
      });
      return ge.digest = E, ge;
    }
    function k(pe) {
      return typeof pe == "object" && pe !== null && pe.digest === E && "name" in pe && "message" in pe && pe instanceof Error;
    }
    function I(pe) {
      return pe.length > 0;
    }
    function z(pe, ge) {
      return pe.dynamicAccesses.push(...ge.dynamicAccesses), pe.dynamicAccesses;
    }
    function F(pe) {
      return pe.filter((ge) => typeof ge.stack == "string" && ge.stack.length > 0).map(({ expression: ge, stack: ve }) => (ve = ve.split(`
`).slice(4).filter((Te) => !(Te.includes("node_modules/next/") || Te.includes(" (<anonymous>)") || Te.includes(" (node:"))).join(`
`), `Dynamic API Usage Debug - ${ge}:
${ve}`));
    }
    function P() {
      if (!p)
        throw Object.defineProperty(new Error("Invariant: React.unstable_postpone is not defined. This suggests the wrong version of React was loaded. This is a bug in Next.js"), "__NEXT_ERROR_CODE", {
          value: "E224",
          enumerable: !1,
          configurable: !0
        });
    }
    function O() {
      const pe = new AbortController();
      return pe.abort(Object.defineProperty(new u.BailoutToCSRError("Render in Browser"), "__NEXT_ERROR_CODE", {
        value: "E721",
        enumerable: !1,
        configurable: !0
      })), pe.signal;
    }
    function V(pe) {
      switch (pe.type) {
        case "prerender":
        case "prerender-runtime":
          const ge = new AbortController();
          if (pe.cacheSignal)
            pe.cacheSignal.inputReady().then(() => {
              ge.abort();
            });
          else {
            const ve = (0, i.getRuntimeStagePromise)(pe);
            ve ? ve.then(() => (0, l.scheduleOnNextTick)(() => ge.abort())) : (0, l.scheduleOnNextTick)(() => ge.abort());
          }
          return ge.signal;
        case "prerender-client":
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
          return;
      }
    }
    function U(pe, ge) {
      const ve = ge.dynamicTracking;
      ve && ve.dynamicAccesses.push({
        stack: ve.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: pe
      });
    }
    function H(pe) {
      const ge = a.workAsyncStorage.getStore(), ve = i.workUnitAsyncStorage.getStore();
      if (ge && ve)
        switch (ve.type) {
          case "prerender-client":
          case "prerender": {
            const Te = ve.fallbackRouteParams;
            Te && Te.size > 0 && n.default.use((0, s.makeHangingPromise)(ve.renderSignal, ge.route, pe));
            break;
          }
          case "prerender-ppr": {
            const Te = ve.fallbackRouteParams;
            if (Te && Te.size > 0)
              return T(ge.route, pe, ve.dynamicTracking);
            break;
          }
          case "prerender-runtime":
            throw Object.defineProperty(new d.InvariantError(`\`${pe}\` was called during a runtime prerender. Next.js should be preventing ${pe} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E771",
              enumerable: !1,
              configurable: !0
            });
          case "cache":
          case "private-cache":
            throw Object.defineProperty(new d.InvariantError(`\`${pe}\` was called inside a cache scope. Next.js should be preventing ${pe} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E745",
              enumerable: !1,
              configurable: !0
            });
        }
    }
    const J = /\n\s+at Suspense \(<anonymous>\)/, le = "body|div|main|section|article|aside|header|footer|nav|form|p|span|h1|h2|h3|h4|h5|h6", ae = new RegExp(`\\n\\s+at Suspense \\(<anonymous>\\)(?:(?!\\n\\s+at (?:${le}) \\(<anonymous>\\))[\\s\\S])*?\\n\\s+at ${c.ROOT_LAYOUT_BOUNDARY_NAME} \\([^\\n]*\\)`), Y = new RegExp(`\\n\\s+at ${c.METADATA_BOUNDARY_NAME}[\\n\\s]`), re = new RegExp(`\\n\\s+at ${c.VIEWPORT_BOUNDARY_NAME}[\\n\\s]`), ie = new RegExp(`\\n\\s+at ${c.OUTLET_BOUNDARY_NAME}[\\n\\s]`);
    function _e(pe, ge, ve, Te) {
      if (!ie.test(ge))
        if (Y.test(ge)) {
          ve.hasDynamicMetadata = !0;
          return;
        } else if (re.test(ge)) {
          ve.hasDynamicViewport = !0;
          return;
        } else if (ae.test(ge)) {
          ve.hasAllowedDynamic = !0, ve.hasSuspenseAboveBody = !0;
          return;
        } else if (J.test(ge)) {
          ve.hasAllowedDynamic = !0;
          return;
        } else if (Te.syncDynamicErrorWithStack) {
          ve.dynamicErrors.push(Te.syncDynamicErrorWithStack);
          return;
        } else {
          const Re = `Route "${pe.route}": A component accessed data, headers, params, searchParams, or a short-lived cache without a Suspense boundary nor a "use cache" above it. See more info: https://nextjs.org/docs/messages/next-prerender-missing-suspense`, Me = he(Re, ge);
          ve.dynamicErrors.push(Me);
          return;
        }
    }
    function he(pe, ge) {
      const ve = process.env.NODE_ENV !== "production" && n.default.captureOwnerStack ? n.default.captureOwnerStack() : null, Te = Object.defineProperty(new Error(pe), "__NEXT_ERROR_CODE", {
        value: "E394",
        enumerable: !1,
        configurable: !0
      });
      return Te.stack = Te.name + ": " + pe + (ve ?? ge), Te;
    }
    var be = /* @__PURE__ */ function(pe) {
      return pe[pe.Full = 0] = "Full", pe[pe.Empty = 1] = "Empty", pe[pe.Errored = 2] = "Errored", pe;
    }({});
    function Q(pe, ge) {
      console.error(ge), pe.dev || (pe.hasReadableErrorStacks ? console.error(`To get a more detailed stack trace and pinpoint the issue, start the app in development mode by running \`next dev\`, then open "${pe.route}" in your browser to investigate the error.`) : console.error(`To get a more detailed stack trace and pinpoint the issue, try one of the following:
  - Start the app in development mode by running \`next dev\`, then open "${pe.route}" in your browser to investigate the error.
  - Rerun the production build with \`next build --debug-prerender\` to generate better stack traces.`));
    }
    function me(pe, ge, ve, Te) {
      if (ge !== 0) {
        if (ve.hasSuspenseAboveBody)
          return;
        if (Te.syncDynamicErrorWithStack)
          throw Q(pe, Te.syncDynamicErrorWithStack), new r.StaticGenBailoutError();
        const Re = ve.dynamicErrors;
        if (Re.length > 0) {
          for (let Me = 0; Me < Re.length; Me++)
            Q(pe, Re[Me]);
          throw new r.StaticGenBailoutError();
        }
        if (ve.hasDynamicViewport)
          throw console.error(`Route "${pe.route}" has a \`generateViewport\` that depends on Request data (\`cookies()\`, etc...) or uncached external data (\`fetch(...)\`, etc...) without explicitly allowing fully dynamic rendering. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-viewport`), new r.StaticGenBailoutError();
        if (ge === 1)
          throw console.error(`Route "${pe.route}" did not produce a static shell and Next.js was unable to determine a reason. This is a bug in Next.js.`), new r.StaticGenBailoutError();
      } else if (ve.hasAllowedDynamic === !1 && ve.hasDynamicMetadata)
        throw console.error(`Route "${pe.route}" has a \`generateMetadata\` that depends on Request data (\`cookies()\`, etc...) or uncached external data (\`fetch(...)\`, etc...) when the rest of the route does not. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-metadata`), new r.StaticGenBailoutError();
    }
    function ne(pe, ge) {
      return pe.runtimeStagePromise ? pe.runtimeStagePromise.then(() => ge) : ge;
    }
  }(eN)), eN;
}
var gW;
function kuc() {
  return gW || (gW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return c;
      }
    });
    const n = qce(), o = guc(), r = jT(), i = Fce(), a = Gce(), s = jce();
    function c(l) {
      if ((0, i.isNextRouterError)(l) || (0, r.isBailoutToCSRError)(l) || (0, s.isDynamicServerError)(l) || (0, a.isDynamicPostpone)(l) || (0, o.isPostpone)(l) || (0, n.isHangingPromiseRejectionError)(l))
        throw l;
      l instanceof Error && "cause" in l && c(l.cause);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(kS, kS.exports)), kS.exports;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "unstable_rethrow", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const n = typeof window > "u" ? kuc().unstable_rethrow : fuc().unstable_rethrow;
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(XM, XM.exports);
var Suc = XM.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(_, p) {
    for (var g in p)
      Object.defineProperty(_, g, {
        enumerable: !0,
        get: p[g]
      });
  }
  n(t, {
    ReadonlyURLSearchParams: function() {
      return u;
    },
    RedirectType: function() {
      return r.RedirectType;
    },
    forbidden: function() {
      return a.forbidden;
    },
    notFound: function() {
      return i.notFound;
    },
    permanentRedirect: function() {
      return o.permanentRedirect;
    },
    redirect: function() {
      return o.redirect;
    },
    unauthorized: function() {
      return s.unauthorized;
    },
    unstable_isUnrecognizedActionError: function() {
      return d;
    },
    unstable_rethrow: function() {
      return c.unstable_rethrow;
    }
  });
  const o = duc, r = SF, i = _uc, a = puc, s = muc, c = Suc;
  class l extends Error {
    constructor() {
      super("Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams");
    }
  }
  class u extends URLSearchParams {
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    append() {
      throw new l();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    delete() {
      throw new l();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    set() {
      throw new l();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    sort() {
      throw new l();
    }
  }
  function d() {
    throw Object.defineProperty(new Error("`unstable_isUnrecognizedActionError` can only be used on the client."), "__NEXT_ERROR_CODE", {
      value: "E776",
      enumerable: !1,
      configurable: !0
    });
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(BM, BM.exports);
var Euc = BM.exports, Wce = {};
(function(e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(a, s) {
    for (var c in s)
      Object.defineProperty(a, c, {
        enumerable: !0,
        get: s[c]
      });
  }
  t(e, {
    ServerInsertedHTMLContext: function() {
      return r;
    },
    useServerInsertedHTML: function() {
      return i;
    }
  });
  const o = /* @__PURE__ */ R0._(Fe), r = /* @__PURE__ */ o.default.createContext(null);
  function i(a) {
    const s = (0, o.useContext)(r);
    s && s(a);
  }
})(Wce);
var JM = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(i, a) {
    for (var s in a)
      Object.defineProperty(i, s, {
        enumerable: !0,
        get: a[s]
      });
  }
  n(t, {
    UnrecognizedActionError: function() {
      return o;
    },
    unstable_isUnrecognizedActionError: function() {
      return r;
    }
  });
  class o extends Error {
    constructor(...a) {
      super(...a), this.name = "UnrecognizedActionError";
    }
  }
  function r(i) {
    return !!(i && typeof i == "object" && i instanceof o);
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(JM, JM.exports);
var xuc = JM.exports, CS = { exports: {} }, hW;
function Cuc() {
  return hW || (hW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "bailoutToClientRendering", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const n = jT(), o = Uce(), r = Bce();
    function i(a) {
      const s = o.workAsyncStorage.getStore();
      if (s != null && s.forceStatic)
        return;
      const c = r.workUnitAsyncStorage.getStore();
      if (c)
        switch (c.type) {
          case "prerender":
          case "prerender-runtime":
          case "prerender-client":
          case "prerender-ppr":
          case "prerender-legacy":
            throw Object.defineProperty(new n.BailoutToCSRError(a), "__NEXT_ERROR_CODE", {
              value: "E394",
              enumerable: !1,
              configurable: !0
            });
        }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(CS, CS.exports)), CS.exports;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(b, y) {
    for (var w in y)
      Object.defineProperty(b, w, {
        enumerable: !0,
        get: y[w]
      });
  }
  n(t, {
    ReadonlyURLSearchParams: function() {
      return c.ReadonlyURLSearchParams;
    },
    RedirectType: function() {
      return c.RedirectType;
    },
    ServerInsertedHTMLContext: function() {
      return l.ServerInsertedHTMLContext;
    },
    forbidden: function() {
      return c.forbidden;
    },
    notFound: function() {
      return c.notFound;
    },
    permanentRedirect: function() {
      return c.permanentRedirect;
    },
    redirect: function() {
      return c.redirect;
    },
    unauthorized: function() {
      return c.unauthorized;
    },
    unstable_isUnrecognizedActionError: function() {
      return u.unstable_isUnrecognizedActionError;
    },
    unstable_rethrow: function() {
      return c.unstable_rethrow;
    },
    useParams: function() {
      return f;
    },
    usePathname: function() {
      return p;
    },
    useRouter: function() {
      return g;
    },
    useSearchParams: function() {
      return _;
    },
    useSelectedLayoutSegment: function() {
      return v;
    },
    useSelectedLayoutSegments: function() {
      return $;
    },
    useServerInsertedHTML: function() {
      return l.useServerInsertedHTML;
    }
  });
  const o = Fe, r = Dce, i = Lce, a = cuc, s = H6, c = Euc, l = Wce, u = xuc, d = typeof window > "u" ? Gce().useDynamicRouteParams : void 0;
  function _() {
    const b = (0, o.useContext)(i.SearchParamsContext), y = (0, o.useMemo)(() => b ? new c.ReadonlyURLSearchParams(b) : null, [
      b
    ]);
    if (typeof window > "u") {
      const { bailoutToClientRendering: w } = Cuc();
      w("useSearchParams()");
    }
    return y;
  }
  function p() {
    return d == null || d("usePathname()"), (0, o.useContext)(i.PathnameContext);
  }
  function g() {
    const b = (0, o.useContext)(r.AppRouterContext);
    if (b === null)
      throw Object.defineProperty(new Error("invariant expected app router to be mounted"), "__NEXT_ERROR_CODE", {
        value: "E238",
        enumerable: !1,
        configurable: !0
      });
    return b;
  }
  function f() {
    return d == null || d("useParams()"), (0, o.useContext)(i.PathParamsContext);
  }
  function h(b, y, w, N) {
    w === void 0 && (w = !0), N === void 0 && (N = []);
    let M;
    if (w)
      M = b[1][y];
    else {
      const T = b[1];
      var q;
      M = (q = T.children) != null ? q : Object.values(T)[0];
    }
    if (!M)
      return N;
    const L = M[0];
    let R = (0, a.getSegmentValue)(L);
    return !R || R.startsWith(s.PAGE_SEGMENT_KEY) ? N : (N.push(R), h(M, y, !1, N));
  }
  function $(b) {
    b === void 0 && (b = "children"), d == null || d("useSelectedLayoutSegments()");
    const y = (0, o.useContext)(r.LayoutRouterContext);
    return y ? h(y.parentTree, b) : null;
  }
  function v(b) {
    b === void 0 && (b = "children"), d == null || d("useSelectedLayoutSegment()");
    const y = $(b);
    if (!y || y.length === 0)
      return null;
    const w = b === "children" ? y[0] : y[y.length - 1];
    return w === s.DEFAULT_SEGMENT_KEY ? null : w;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(jM, jM.exports);
var Tuc = jM.exports, Nr = Tuc;
const Kr = () => {
  const e = cr();
  return !!(e != null && e.clientId);
}, Ef = () => {
  const e = Nr.useSearchParams() ?? new URLSearchParams(), t = Nr.useParams() ?? {}, n = new URLSearchParams(e.toString());
  return Object.getOwnPropertyNames(t).forEach((o) => {
    n.delete(o);
    const r = t[o] || "";
    (typeof r == "string" ? r.split("/") : r).forEach((a) => {
      n.append(o, a);
    });
  }), new Nr.ReadonlyURLSearchParams(n);
}, Auc = Vy(
  "fadeIn bg-default scroll-bar fixed left-1/2 top-1/2 z-50 w-[95vw] m-auto -translate-x-1/2 -translate-y-1/2 rounded-2xl text-left shadow-xl focus-visible:outline-none sm:align-middle",
  {
    variants: {
      size: {
        xl: "px-8 pt-8 sm:max-w-[90rem]",
        lg: "px-8 pt-8 sm:max-w-[70rem]",
        md: "px-8 pt-8 sm:max-w-[48rem]",
        default: "px-8 pt-8 sm:max-w-[35rem]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
function _v(e) {
  const { children: t, ...n } = e;
  return /* @__PURE__ */ m(xce, { ...n, children: t });
}
const Ya = Fe.forwardRef(
  ({
    children: e,
    title: t,
    Icon: n,
    enableOverflow: o,
    forceOverlayWhenNoModal: r,
    type: i = "creation",
    preventCloseOnOutsideClick: a,
    ...s
  }, c) => /* @__PURE__ */ de(Ece, { children: [
    r ? /* @__PURE__ */ m("div", { className: "fadeIn fixed inset-0 z-50  bg-neutral-800 bg-opacity-70 transition-opacity" }) : /* @__PURE__ */ m(Tce, { className: "fadeIn fixed inset-0 z-50 bg-neutral-800 bg-opacity-70 transition-opacity dark:bg-opacity-80" }),
    /* @__PURE__ */ de(
      Ace,
      {
        ...s,
        onPointerDownOutside: (l) => {
          a && l.preventDefault();
        },
        className: xe(
          Auc({ size: s.size }),
          "max-h-[95vh]",
          o ? "overflow-y-auto" : "overflow-visible",
          `${s.className || ""}`
        ),
        ref: c,
        children: [
          i === "creation" && /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ m(Sy, { title: t, subtitle: s.description }),
            /* @__PURE__ */ m("div", { "data-testid": "dialog-creation", className: "flex flex-col", children: e })
          ] }),
          i === "confirmation" && /* @__PURE__ */ de("div", { className: "flex", children: [
            n && /* @__PURE__ */ m("div", { className: "bg-emphasis flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full", children: /* @__PURE__ */ m(qt, { name: n, className: "text-emphasis h-4 w-4" }) }),
            /* @__PURE__ */ de("div", { className: "ml-4 flex-grow", children: [
              /* @__PURE__ */ m(Sy, { title: t, subtitle: s.description }),
              /* @__PURE__ */ m("div", { "data-testid": "dialog-confirmation", children: e })
            ] })
          ] }),
          !i && e
        ]
      }
    )
  ] })
);
function Sy(e) {
  return e.title ? /* @__PURE__ */ de("div", { className: "mb-4", children: [
    /* @__PURE__ */ m(
      "h2",
      {
        "data-testid": "dialog-title",
        className: "leading-20 text-semibold text-emphasis font-cal mb-1 text-xl",
        id: "modal-title",
        children: e.title
      }
    ),
    e.subtitle && /* @__PURE__ */ m("p", { className: "text-subtle text-sm", "data-testid": "dialog-subtitle", children: e.subtitle })
  ] }) : null;
}
function Wu(e) {
  return /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "bg-muted border-muted bottom-0 -mx-8 mt-10 rounded-b-2xl border",
        e != null && e.noSticky ? "" : "sticky",
        e.className
      ),
      children: [
        e.showDivider && /* @__PURE__ */ m("div", { "data-testid": "divider", className: "border-subtle border-t" }),
        /* @__PURE__ */ m("div", { className: xe("flex justify-end space-x-2 px-8 py-4 font-sans rtl:space-x-reverse"), children: e.children })
      ]
    }
  );
}
Ya.displayName = "DialogContent";
const q0 = Fe.forwardRef((e, t) => /* @__PURE__ */ m(Cce, { ...e, ref: t }));
q0.displayName = "DialogTrigger";
function Gs(e) {
  const { t } = kt(), { className: n, ...o } = e;
  return /* @__PURE__ */ m(wF, { asChild: !0, ...e.dialogCloseProps, children: /* @__PURE__ */ m(
    Jt,
    {
      "data-testid": e["data-testid"] || "dialog-rejection",
      color: e.color || "minimal",
      className: xe(e.color === "destructive" && "destructive", n),
      ...o,
      children: e.children ? e.children : t("close")
    }
  ) });
}
function pv(e) {
  return /* @__PURE__ */ m(Ya, { type: "creation", children: /* @__PURE__ */ m(Iuc, { ...e }) });
}
const Iuc = (e) => {
  const { t } = kt(), {
    title: n,
    variety: o,
    confirmBtn: r = null,
    confirmBtnText: i = t("confirm"),
    cancelBtnText: a = t("cancel"),
    loadingText: s = t("loading"),
    isPending: c = !1,
    onConfirm: l,
    children: u
  } = e;
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de("div", { className: "flex", children: [
      o && /* @__PURE__ */ de("div", { className: "mt-0.5 ltr:mr-3", children: [
        o === "danger" && /* @__PURE__ */ m("div", { className: "bg-error mx-auto rounded-full p-2 text-center", children: /* @__PURE__ */ m(qt, { name: "circle-alert", className: "h-5 w-5 text-red-600 dark:text-red-100" }) }),
        o === "warning" && /* @__PURE__ */ m("div", { className: "bg-attention mx-auto rounded-full p-2 text-center", children: /* @__PURE__ */ m(qt, { name: "circle-alert", className: "h-5 w-5 text-orange-600" }) }),
        o === "success" && /* @__PURE__ */ m("div", { className: "bg-success mx-auto rounded-full p-2 text-center", children: /* @__PURE__ */ m(qt, { name: "check", className: "h-5 w-5 text-green-600" }) })
      ] }),
      /* @__PURE__ */ de("div", { className: "w-full", children: [
        /* @__PURE__ */ m(Ice, { className: "font-cal text-emphasis mt-2 text-xl", children: n }),
        /* @__PURE__ */ m(Oce, { className: "text-subtle text-sm", children: u })
      ] })
    ] }),
    /* @__PURE__ */ de("div", { className: "my-5 flex flex-row-reverse gap-x-2 sm:my-8", children: [
      r || /* @__PURE__ */ m(
        Gs,
        {
          color: "primary",
          loading: c,
          onClick: (d) => l && l(d),
          "data-testid": "dialog-confirmation",
          children: c ? s : i
        }
      ),
      /* @__PURE__ */ m(Gs, { disabled: c, children: a })
    ] })
  ] });
};
function Ss(e) {
  return Kr() ? /* @__PURE__ */ m($F, { ...e }) : /* @__PURE__ */ m(Ouc, { ...e });
}
function Ouc(e) {
  const t = Nr.useRouter(), n = Nr.usePathname(), o = Ef(), r = new URLSearchParams(o.toString()), { children: i, name: a, ...s } = e, [c, l] = it(
    s.open ? "OPEN" : "CLOSED"
    /* CLOSED */
  ), u = r.get("dialog") === a;
  if (a) {
    const d = ["dialog", ...e.clearQueryParamsOnClose || []];
    s.onOpenChange = (_) => {
      e.onOpenChange && e.onOpenChange(_), _ ? r.set("dialog", a) : (d.forEach((p) => {
        r.delete(p);
      }), t.push(`${n}?${r.toString()}`)), l(
        _ ? "OPEN" : "CLOSING"
        /* CLOSING */
      );
    }, c === "CLOSED" && u && l(
      "OPEN"
      /* OPEN */
    ), c === "CLOSING" && !u && l(
      "CLOSED"
      /* CLOSED */
    ), "open" in s || (s.open = c === "OPEN");
  }
  return /* @__PURE__ */ m(_v, { ...s, children: i });
}
function Ew(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vW(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ho(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vW(Object(n), !0).forEach(function(o) {
      Ew(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vW(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function QM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Hce(e, t) {
  if (e) {
    if (typeof e == "string")
      return QM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? QM(e, t) : void 0;
  }
}
function uf(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, o) {
    var r = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (r != null) {
      var i, a, s = [], c = !0, l = !1;
      try {
        for (r = r.call(n); !(c = (i = r.next()).done) && (s.push(i.value), !o || s.length !== o); c = !0)
          ;
      } catch (u) {
        l = !0, a = u;
      } finally {
        try {
          c || r.return == null || r.return();
        } finally {
          if (l)
            throw a;
        }
      }
      return s;
    }
  }(e, t) || Hce(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ey(e, t) {
  if (e == null)
    return {};
  var n, o, r = function(a, s) {
    if (a == null)
      return {};
    var c, l, u = {}, d = Object.keys(a);
    for (l = 0; l < d.length; l++)
      c = d[l], s.indexOf(c) >= 0 || (u[c] = a[c]);
    return u;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
var Nuc = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Oo() {
  return Oo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Oo.apply(this, arguments);
}
function bW(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function e4(e, t) {
  return e4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, e4(e, t);
}
function Kx(e) {
  return Kx = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Kx(e);
}
function Zx(e) {
  return Zx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zx(e);
}
function zuc(e, t) {
  if (t && (Zx(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return function(n) {
    if (n === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }(e);
}
function Ruc(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, o = Kx(e);
    if (t) {
      var r = Kx(this).constructor;
      n = Reflect.construct(o, arguments, r);
    } else
      n = o.apply(this, arguments);
    return zuc(this, n);
  };
}
function Yce(e) {
  return function(t) {
    if (Array.isArray(t))
      return QM(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || Hce(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
var Puc = function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var i;
      i = o.tags.length === 0 ? o.insertionPoint ? o.insertionPoint.nextSibling : o.prepend ? o.container.firstChild : o.before : o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, i), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function(a) {
      var s = document.createElement("style");
      return s.setAttribute("data-emotion", a.key), a.nonce !== void 0 && s.setAttribute("nonce", a.nonce), s.appendChild(document.createTextNode("")), s.setAttribute("data-s", ""), s;
    }(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var r = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      r && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !r;
    }
    if (this.isSpeedy) {
      var i = function(a) {
        if (a.sheet)
          return a.sheet;
        for (var s = 0; s < document.styleSheets.length; s++)
          if (document.styleSheets[s].ownerNode === a)
            return document.styleSheets[s];
      }(o);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (a) {
        process.env.NODE_ENV === "production" || /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(n) || console.error('There was a problem inserting the following rule: "' + n + '"', a);
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), ql = "-ms-", yW = "-moz-", Ki = "-webkit-", Duc = Math.abs, VT = String.fromCharCode, Luc = Object.assign;
function Kce(e) {
  return e.trim();
}
function ui(e, t, n) {
  return e.replace(t, n);
}
function t4(e, t) {
  return e.indexOf(t);
}
function jl(e, t) {
  return 0 | e.charCodeAt(t);
}
function Ik(e, t, n) {
  return e.slice(t, n);
}
function Ip(e) {
  return e.length;
}
function xF(e) {
  return e.length;
}
function TS(e, t) {
  return t.push(e), e;
}
var BT = 1, xy = 1, Zce = 0, eu = 0, ns = 0, Hy = "";
function UT(e, t, n, o, r, i, a) {
  return { value: e, root: t, parent: n, type: o, props: r, children: i, line: BT, column: xy, length: a, return: "" };
}
function V$(e, t) {
  return Luc(UT("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Muc() {
  return ns = eu > 0 ? jl(Hy, --eu) : 0, xy--, ns === 10 && (xy = 1, BT--), ns;
}
function Lu() {
  return ns = eu < Zce ? jl(Hy, eu++) : 0, xy++, ns === 10 && (xy = 1, BT++), ns;
}
function Hp() {
  return jl(Hy, eu);
}
function UE() {
  return eu;
}
function j0(e, t) {
  return Ik(Hy, e, t);
}
function Ok(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Xce(e) {
  return BT = xy = 1, Zce = Ip(Hy = e), eu = 0, [];
}
function Jce(e) {
  return Hy = "", e;
}
function GE(e) {
  return Kce(j0(eu - 1, n4(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Fuc(e) {
  for (; (ns = Hp()) && ns < 33; )
    Lu();
  return Ok(e) > 2 || Ok(ns) > 3 ? "" : " ";
}
function quc(e, t) {
  for (; --t && Lu() && !(ns < 48 || ns > 102 || ns > 57 && ns < 65 || ns > 70 && ns < 97); )
    ;
  return j0(e, UE() + (t < 6 && Hp() == 32 && Lu() == 32));
}
function n4(e) {
  for (; Lu(); )
    switch (ns) {
      case e:
        return eu;
      case 34:
      case 39:
        e !== 34 && e !== 39 && n4(ns);
        break;
      case 40:
        e === 41 && n4(e);
        break;
      case 92:
        Lu();
    }
  return eu;
}
function juc(e, t) {
  for (; Lu() && e + ns !== 57 && (e + ns !== 84 || Hp() !== 47); )
    ;
  return "/*" + j0(t, eu - 1) + "*" + VT(e === 47 ? e : Lu());
}
function Vuc(e) {
  for (; !Ok(Hp()); )
    Lu();
  return j0(e, eu);
}
function $W(e) {
  return Jce(WE("", null, null, null, [""], e = Xce(e), 0, [0], e));
}
function WE(e, t, n, o, r, i, a, s, c) {
  for (var l = 0, u = 0, d = a, _ = 0, p = 0, g = 0, f = 1, h = 1, $ = 1, v = 0, b = "", y = r, w = i, N = o, M = b; h; )
    switch (g = v, v = Lu()) {
      case 40:
        if (g != 108 && M.charCodeAt(d - 1) == 58) {
          t4(M += ui(GE(v), "&", "&\f"), "&\f") != -1 && ($ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        M += GE(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        M += Fuc(g);
        break;
      case 92:
        M += quc(UE() - 1, 7);
        continue;
      case 47:
        switch (Hp()) {
          case 42:
          case 47:
            TS(Buc(juc(Lu(), UE()), t, n), c);
            break;
          default:
            M += "/";
        }
        break;
      case 123 * f:
        s[l++] = Ip(M) * $;
      case 125 * f:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            h = 0;
          case 59 + u:
            p > 0 && Ip(M) - d && TS(p > 32 ? kW(M + ";", o, n, d - 1) : kW(ui(M, " ", "") + ";", o, n, d - 2), c);
            break;
          case 59:
            M += ";";
          default:
            if (TS(N = wW(M, t, n, l, u, r, s, b, y = [], w = [], d), i), v === 123)
              if (u === 0)
                WE(M, t, N, N, y, i, d, s, w);
              else
                switch (_) {
                  case 100:
                  case 109:
                  case 115:
                    WE(e, N, N, o && TS(wW(e, N, N, 0, 0, r, s, b, r, y = [], d), w), r, w, d, s, o ? y : w);
                    break;
                  default:
                    WE(M, N, N, N, [""], w, 0, s, w);
                }
        }
        l = u = p = 0, f = $ = 1, b = M = "", d = a;
        break;
      case 58:
        d = 1 + Ip(M), p = g;
      default:
        if (f < 1) {
          if (v == 123)
            --f;
          else if (v == 125 && f++ == 0 && Muc() == 125)
            continue;
        }
        switch (M += VT(v), v * f) {
          case 38:
            $ = u > 0 ? 1 : (M += "\f", -1);
            break;
          case 44:
            s[l++] = (Ip(M) - 1) * $, $ = 1;
            break;
          case 64:
            Hp() === 45 && (M += GE(Lu())), _ = Hp(), u = d = Ip(b = M += Vuc(UE())), v++;
            break;
          case 45:
            g === 45 && Ip(M) == 2 && (f = 0);
        }
    }
  return i;
}
function wW(e, t, n, o, r, i, a, s, c, l, u) {
  for (var d = r - 1, _ = r === 0 ? i : [""], p = xF(_), g = 0, f = 0, h = 0; g < o; ++g)
    for (var $ = 0, v = Ik(e, d + 1, d = Duc(f = a[g])), b = e; $ < p; ++$)
      (b = Kce(f > 0 ? _[$] + " " + v : ui(v, /&\f/g, _[$]))) && (c[h++] = b);
  return UT(e, t, n, r === 0 ? "rule" : s, c, l, u);
}
function Buc(e, t, n) {
  return UT(e, t, n, "comm", VT(ns), Ik(e, 2, -2), 0);
}
function kW(e, t, n, o) {
  return UT(e, t, n, "decl", Ik(e, 0, o), Ik(e, o + 1, -1), o);
}
function Qce(e, t) {
  switch (function(n, o) {
    return (((o << 2 ^ jl(n, 0)) << 2 ^ jl(n, 1)) << 2 ^ jl(n, 2)) << 2 ^ jl(n, 3);
  }(e, t)) {
    case 5103:
      return Ki + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ki + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ki + e + yW + e + ql + e + e;
    case 6828:
    case 4268:
      return Ki + e + ql + e + e;
    case 6165:
      return Ki + e + ql + "flex-" + e + e;
    case 5187:
      return Ki + e + ui(e, /(\w+).+(:[^]+)/, "-webkit-box-$1$2-ms-flex-$1$2") + e;
    case 5443:
      return Ki + e + ql + "flex-item-" + ui(e, /flex-|-self/, "") + e;
    case 4675:
      return Ki + e + ql + "flex-line-pack" + ui(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Ki + e + ql + ui(e, "shrink", "negative") + e;
    case 5292:
      return Ki + e + ql + ui(e, "basis", "preferred-size") + e;
    case 6060:
      return Ki + "box-" + ui(e, "-grow", "") + Ki + e + ql + ui(e, "grow", "positive") + e;
    case 4554:
      return Ki + ui(e, /([^-])(transform)/g, "$1-webkit-$2") + e;
    case 6187:
      return ui(ui(ui(e, /(zoom-|grab)/, Ki + "$1"), /(image-set)/, Ki + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ui(e, /(image-set\([^]*)/, Ki + "$1$`$1");
    case 4968:
      return ui(ui(e, /(.+:)(flex-)?(.*)/, "-webkit-box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ki + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ui(e, /(.+)-inline(.+)/, Ki + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ip(e) - 1 - t > 6)
        switch (jl(e, t + 1)) {
          case 109:
            if (jl(e, t + 4) !== 45)
              break;
          case 102:
            return ui(e, /(.+:)(.+)-([^]+)/, "$1-webkit-$2-$3$1" + yW + (jl(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~t4(e, "stretch") ? Qce(ui(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (jl(e, t + 1) !== 115)
        break;
    case 6444:
      switch (jl(e, Ip(e) - 3 - (~t4(e, "!important") && 10))) {
        case 107:
          return ui(e, ":", ":" + Ki) + e;
        case 101:
          return ui(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ki + (jl(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ki + "$2$3$1" + ql + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (jl(e, t + 11)) {
        case 114:
          return Ki + e + ql + ui(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Ki + e + ql + ui(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Ki + e + ql + ui(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ki + e + ql + e + e;
  }
  return e;
}
function tv(e, t) {
  for (var n = "", o = xF(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function SW(e, t, n, o) {
  switch (e.type) {
    case "@import":
    case "decl":
      return e.return = e.return || e.value;
    case "comm":
      return "";
    case "@keyframes":
      return e.return = e.value + "{" + tv(e.children, o) + "}";
    case "rule":
      e.value = e.props.join(",");
  }
  return Ip(n = tv(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function EW(e) {
  var t = xF(e);
  return function(n, o, r, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, o, r, i) || "";
    return a;
  };
}
function ele(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var xW, AS, Uuc = function(e, t, n) {
  for (var o = 0, r = 0; o = r, r = Hp(), o === 38 && r === 12 && (t[n] = 1), !Ok(r); )
    Lu();
  return j0(e, eu);
}, Guc = function(e, t) {
  return Jce(function(n, o) {
    var r = -1, i = 44;
    do
      switch (Ok(i)) {
        case 0:
          i === 38 && Hp() === 12 && (o[r] = 1), n[r] += Uuc(eu - 1, o, r);
          break;
        case 2:
          n[r] += GE(i);
          break;
        case 4:
          if (i === 44) {
            n[++r] = Hp() === 58 ? "&\f" : "", o[r] = n[r].length;
            break;
          }
        default:
          n[r] += VT(i);
      }
    while (i = Lu());
    return n;
  }(Xce(e), t));
}, CW = /* @__PURE__ */ new WeakMap(), Wuc = function(e) {
  if (e.type === "rule" && e.parent && !(e.length < 1)) {
    for (var t = e.value, n = e.parent, o = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (!(n = n.parent))
        return;
    if ((e.props.length !== 1 || t.charCodeAt(0) === 58 || CW.get(n)) && !o) {
      CW.set(e, !0);
      for (var r = [], i = Guc(t, r), a = n.props, s = 0, c = 0; s < i.length; s++)
        for (var l = 0; l < a.length; l++, c++)
          e.props[c] = r[s] ? i[s].replace(/&\f/g, a[l]) : a[l] + " " + i[s];
    }
  }
}, Huc = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, TW = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, AW = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, Yuc = function(e, t, n) {
  TW(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), AW(e)) : function(o, r) {
    for (var i = o - 1; i >= 0; i--)
      if (!TW(r[i]))
        return !0;
    return !1;
  }(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), AW(e)));
}, HE = typeof document < "u", Kuc = HE ? void 0 : (xW = function() {
  return ele(function() {
    var e = {};
    return function(t) {
      return e[t];
    };
  });
}, AS = /* @__PURE__ */ new WeakMap(), function(e) {
  if (AS.has(e))
    return AS.get(e);
  var t = xW(e);
  return AS.set(e, t), t;
}), Zuc = [function(e, t, n, o) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case "decl":
        e.return = Qce(e.value, e.length);
        break;
      case "@keyframes":
        return tv([V$(e, { value: ui(e.value, "@", "@" + Ki) })], o);
      case "rule":
        if (e.length)
          return function(r, i) {
            return r.map(i).join("");
          }(e.props, function(r) {
            switch (function(i, a) {
              return (i = a.exec(i)) ? i[0] : i;
            }(r, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return tv([V$(e, { props: [ui(r, /:(read-\w+)/, ":-moz-$1")] })], o);
              case "::placeholder":
                return tv([V$(e, { props: [ui(r, /:(plac\w+)/, ":-webkit-input-$1")] }), V$(e, { props: [ui(r, /:(plac\w+)/, ":-moz-$1")] }), V$(e, { props: [ui(r, /:(plac\w+)/, ql + "input-$1")] })], o);
            }
            return "";
          });
    }
}], tle = function(e) {
  var t = e.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (HE && t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      v.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = e.stylisPlugins || Zuc;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var r, i, a = {}, s = [];
  HE && (r = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function(v) {
    for (var b = v.getAttribute("data-emotion").split(" "), y = 1; y < b.length; y++)
      a[b[y]] = !0;
    s.push(v);
  }));
  var c, l = [Wuc, Huc];
  if (process.env.NODE_ENV !== "production" && l.push(/* @__PURE__ */ function(v) {
    return function(b, y, w) {
      if (b.type === "rule") {
        var N, M = b.value.match(/(:first|:nth|:nth-last)-child/g);
        if (M && v.compat !== !0) {
          var q = y > 0 ? w[y - 1] : null;
          if (q && function(L) {
            return !!L && L.type === "comm" && L.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
          }((N = q.children).length ? N[N.length - 1] : null))
            return;
          M.forEach(function(L) {
            console.error('The pseudo class "' + L + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + L.split("-child")[0] + '-of-type".');
          });
        }
      }
    };
  }({ get compat() {
    return $.compat;
  } }), Yuc), HE) {
    var u, d = [SW, process.env.NODE_ENV !== "production" ? function(v) {
      v.root || (v.return ? u.insert(v.return) : v.value && v.type !== "comm" && u.insert(v.value + "{}"));
    } : (c = function(v) {
      u.insert(v);
    }, function(v) {
      v.root || (v = v.return) && c(v);
    })], _ = EW(l.concat(o, d));
    i = function(v, b, y, w) {
      u = y, process.env.NODE_ENV !== "production" && b.map !== void 0 && (u = { insert: function(N) {
        y.insert(N + b.map);
      } }), tv($W(v ? v + "{" + b.styles + "}" : b.styles), _), w && ($.inserted[b.name] = !0);
    };
  } else {
    var p = [SW], g = EW(l.concat(o, p)), f = Kuc(o)(t), h = function(v, b) {
      var y = b.name;
      return f[y] === void 0 && (f[y] = tv($W(v ? v + "{" + b.styles + "}" : b.styles), g)), f[y];
    };
    i = function(v, b, y, w) {
      var N = b.name, M = h(v, b);
      return $.compat === void 0 ? (w && ($.inserted[N] = !0), process.env.NODE_ENV === "development" && b.map !== void 0 ? M + b.map : M) : w ? void ($.inserted[N] = M) : M;
    };
  }
  var $ = { key: t, sheet: new Puc({ key: t, container: r, nonce: e.nonce, speedy: e.speedy, prepend: e.prepend, insertionPoint: e.insertionPoint }), nonce: e.nonce, inserted: a, registered: {}, insert: i };
  return $.sheet.hydrate(s), $;
}, o4 = { exports: {} }, yi = {}, Ws = typeof Symbol == "function" && Symbol.for, r4 = Ws ? Symbol.for("react.element") : 60103, i4 = Ws ? Symbol.for("react.portal") : 60106, YE = Ws ? Symbol.for("react.fragment") : 60107, KE = Ws ? Symbol.for("react.strict_mode") : 60108, ZE = Ws ? Symbol.for("react.profiler") : 60114, XE = Ws ? Symbol.for("react.provider") : 60109, JE = Ws ? Symbol.for("react.context") : 60110, a4 = Ws ? Symbol.for("react.async_mode") : 60111, Xx = Ws ? Symbol.for("react.concurrent_mode") : 60111, QE = Ws ? Symbol.for("react.forward_ref") : 60112, ex = Ws ? Symbol.for("react.suspense") : 60113, Xuc = Ws ? Symbol.for("react.suspense_list") : 60120, tx = Ws ? Symbol.for("react.memo") : 60115, nx = Ws ? Symbol.for("react.lazy") : 60116, Juc = Ws ? Symbol.for("react.block") : 60121, Quc = Ws ? Symbol.for("react.fundamental") : 60117, edc = Ws ? Symbol.for("react.responder") : 60118, tdc = Ws ? Symbol.for("react.scope") : 60119;
function ku(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case r4:
        switch (e = e.type) {
          case a4:
          case Xx:
          case YE:
          case ZE:
          case KE:
          case ex:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case JE:
              case QE:
              case nx:
              case tx:
              case XE:
                return e;
              default:
                return t;
            }
        }
      case i4:
        return t;
    }
  }
}
function IW(e) {
  return ku(e) === Xx;
}
yi.AsyncMode = a4, yi.ConcurrentMode = Xx, yi.ContextConsumer = JE, yi.ContextProvider = XE, yi.Element = r4, yi.ForwardRef = QE, yi.Fragment = YE, yi.Lazy = nx, yi.Memo = tx, yi.Portal = i4, yi.Profiler = ZE, yi.StrictMode = KE, yi.Suspense = ex, yi.isAsyncMode = function(e) {
  return IW(e) || ku(e) === a4;
}, yi.isConcurrentMode = IW, yi.isContextConsumer = function(e) {
  return ku(e) === JE;
}, yi.isContextProvider = function(e) {
  return ku(e) === XE;
}, yi.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === r4;
}, yi.isForwardRef = function(e) {
  return ku(e) === QE;
}, yi.isFragment = function(e) {
  return ku(e) === YE;
}, yi.isLazy = function(e) {
  return ku(e) === nx;
}, yi.isMemo = function(e) {
  return ku(e) === tx;
}, yi.isPortal = function(e) {
  return ku(e) === i4;
}, yi.isProfiler = function(e) {
  return ku(e) === ZE;
}, yi.isStrictMode = function(e) {
  return ku(e) === KE;
}, yi.isSuspense = function(e) {
  return ku(e) === ex;
}, yi.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === YE || e === Xx || e === ZE || e === KE || e === ex || e === Xuc || typeof e == "object" && e !== null && (e.$$typeof === nx || e.$$typeof === tx || e.$$typeof === XE || e.$$typeof === JE || e.$$typeof === QE || e.$$typeof === Quc || e.$$typeof === edc || e.$$typeof === tdc || e.$$typeof === Juc);
}, yi.typeOf = ku;
var bi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV !== "production" && function() {
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function b(z) {
    if (typeof z == "object" && z !== null) {
      var F = z.$$typeof;
      switch (F) {
        case t:
          var P = z.type;
          switch (P) {
            case c:
            case l:
            case o:
            case i:
            case r:
            case d:
              return P;
            default:
              var O = P && P.$$typeof;
              switch (O) {
                case s:
                case u:
                case g:
                case p:
                case a:
                  return O;
                default:
                  return F;
              }
          }
        case n:
          return F;
      }
    }
  }
  var y = c, w = l, N = s, M = a, q = t, L = u, R = o, T = g, D = p, A = n, S = i, E = r, x = d, k = !1;
  function I(z) {
    return b(z) === l;
  }
  bi.AsyncMode = y, bi.ConcurrentMode = w, bi.ContextConsumer = N, bi.ContextProvider = M, bi.Element = q, bi.ForwardRef = L, bi.Fragment = R, bi.Lazy = T, bi.Memo = D, bi.Portal = A, bi.Profiler = S, bi.StrictMode = E, bi.Suspense = x, bi.isAsyncMode = function(z) {
    return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(z) || b(z) === c;
  }, bi.isConcurrentMode = I, bi.isContextConsumer = function(z) {
    return b(z) === s;
  }, bi.isContextProvider = function(z) {
    return b(z) === a;
  }, bi.isElement = function(z) {
    return typeof z == "object" && z !== null && z.$$typeof === t;
  }, bi.isForwardRef = function(z) {
    return b(z) === u;
  }, bi.isFragment = function(z) {
    return b(z) === o;
  }, bi.isLazy = function(z) {
    return b(z) === g;
  }, bi.isMemo = function(z) {
    return b(z) === p;
  }, bi.isPortal = function(z) {
    return b(z) === n;
  }, bi.isProfiler = function(z) {
    return b(z) === i;
  }, bi.isStrictMode = function(z) {
    return b(z) === r;
  }, bi.isSuspense = function(z) {
    return b(z) === d;
  }, bi.isValidElementType = function(z) {
    return typeof z == "string" || typeof z == "function" || z === o || z === l || z === i || z === r || z === d || z === _ || typeof z == "object" && z !== null && (z.$$typeof === g || z.$$typeof === p || z.$$typeof === a || z.$$typeof === s || z.$$typeof === u || z.$$typeof === h || z.$$typeof === $ || z.$$typeof === v || z.$$typeof === f);
  }, bi.typeOf = b;
}(), process.env.NODE_ENV === "production" ? o4.exports = yi : o4.exports = bi;
var OW = o4.exports, NW = {};
NW[OW.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, NW[OW.Memo] = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 };
var s4 = typeof document < "u";
function nle(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : o += r + " ";
  }), o;
}
var CF = function(e, t, n) {
  var o = e.key + "-" + t.name;
  (n === !1 || s4 === !1 && e.compat !== void 0) && e.registered[o] === void 0 && (e.registered[o] = t.styles);
}, TF = function(e, t, n) {
  CF(e, t, n);
  var o = e.key + "-" + t.name;
  if (e.inserted[t.name] === void 0) {
    var r = "", i = t;
    do {
      var a = e.insert(t === i ? "." + o : "", i, e.sheet, !0);
      s4 || a === void 0 || (r += a), i = i.next;
    } while (i !== void 0);
    if (!s4 && r.length !== 0)
      return r;
  }
}, ndc = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, zW = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, odc = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", rdc = /[A-Z]|^ms/g, ole = /_EMO_([^_]+?)_([^]*?)_EMO_/g, AF = function(e) {
  return e.charCodeAt(1) === 45;
}, RW = function(e) {
  return e != null && typeof e != "boolean";
}, cN = ele(function(e) {
  return AF(e) ? e : e.replace(rdc, "-$&").toLowerCase();
}), Jx = function(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(ole, function(n, o, r) {
          return T_ = { name: o, styles: r, next: T_ }, o;
        });
  }
  return ndc[e] === 1 || AF(e) || typeof t != "number" || t === 0 ? t : t + "px";
};
if (process.env.NODE_ENV !== "production") {
  var idc = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, adc = ["normal", "none", "initial", "inherit", "unset"], sdc = Jx, cdc = /^-ms-/, ldc = /-(.)/g, PW = {};
  Jx = function(e, t) {
    if (e === "content" && (typeof t != "string" || adc.indexOf(t) === -1 && !idc.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = sdc(e, t);
    return n === "" || AF(e) || e.indexOf("-") === -1 || PW[e] !== void 0 || (PW[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(cdc, "ms-").replace(ldc, function(o, r) {
      return r.toUpperCase();
    }) + "?")), n;
  };
}
var DW = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Bw(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(DW);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object":
      if (n.anim === 1)
        return T_ = { name: n.name, styles: n.styles, next: T_ }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            T_ = { name: o.name, styles: o.styles, next: T_ }, o = o.next;
        var r = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (r += n.map), r;
      }
      return function(u, d, _) {
        var p = "";
        if (Array.isArray(_))
          for (var g = 0; g < _.length; g++)
            p += Bw(u, d, _[g]) + ";";
        else
          for (var f in _) {
            var h = _[f];
            if (typeof h != "object")
              d != null && d[h] !== void 0 ? p += f + "{" + d[h] + "}" : RW(h) && (p += cN(f) + ":" + Jx(f, h) + ";");
            else {
              if (f === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
                throw new Error(DW);
              if (!Array.isArray(h) || typeof h[0] != "string" || d != null && d[h[0]] !== void 0) {
                var $ = Bw(u, d, h);
                switch (f) {
                  case "animation":
                  case "animationName":
                    p += cN(f) + ":" + $ + ";";
                    break;
                  default:
                    process.env.NODE_ENV !== "production" && f === "undefined" && console.error(odc), p += f + "{" + $ + "}";
                }
              } else
                for (var v = 0; v < h.length; v++)
                  RW(h[v]) && (p += cN(f) + ":" + Jx(f, h[v]) + ";");
            }
          }
        return p;
      }(e, t, n);
    case "function":
      if (e !== void 0) {
        var i = T_, a = n(e);
        return T_ = i, Bw(e, t, a);
      }
      process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], c = n.replace(ole, function(u, d, _) {
          var p = "animation" + s.length;
          return s.push("const " + p + " = keyframes`" + _.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + p + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + c + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

css\`` + c + "`");
      }
  }
  if (t == null)
    return n;
  var l = t[n];
  return l !== void 0 ? l : n;
}
var rle, T_, LW = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
process.env.NODE_ENV !== "production" && (rle = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Nk = function(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, r = "";
  T_ = void 0;
  var i, a = e[0];
  a == null || a.raw === void 0 ? (o = !1, r += Bw(n, t, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(zW), r += a[0]);
  for (var s = 1; s < e.length; s++)
    r += Bw(n, t, e[s]), o && (process.env.NODE_ENV !== "production" && a[s] === void 0 && console.error(zW), r += a[s]);
  process.env.NODE_ENV !== "production" && (r = r.replace(rle, function(d) {
    return i = d, "";
  })), LW.lastIndex = 0;
  for (var c, l = ""; (c = LW.exec(r)) !== null; )
    l += "-" + c[1];
  var u = function(d) {
    for (var _, p = 0, g = 0, f = d.length; f >= 4; ++g, f -= 4)
      _ = 1540483477 * (65535 & (_ = 255 & d.charCodeAt(g) | (255 & d.charCodeAt(++g)) << 8 | (255 & d.charCodeAt(++g)) << 16 | (255 & d.charCodeAt(++g)) << 24)) + (59797 * (_ >>> 16) << 16), p = 1540483477 * (65535 & (_ ^= _ >>> 24)) + (59797 * (_ >>> 16) << 16) ^ 1540483477 * (65535 & p) + (59797 * (p >>> 16) << 16);
    switch (f) {
      case 3:
        p ^= (255 & d.charCodeAt(g + 2)) << 16;
      case 2:
        p ^= (255 & d.charCodeAt(g + 1)) << 8;
      case 1:
        p = 1540483477 * (65535 & (p ^= 255 & d.charCodeAt(g))) + (59797 * (p >>> 16) << 16);
    }
    return (((p = 1540483477 * (65535 & (p ^= p >>> 13)) + (59797 * (p >>> 16) << 16)) ^ p >>> 15) >>> 0).toString(36);
  }(r) + l;
  return process.env.NODE_ENV !== "production" ? { name: u, styles: r, map: i, next: T_, toString: function() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  } } : { name: u, styles: r, next: T_ };
}, Vb = typeof document < "u", IF = {}.hasOwnProperty, zk = Cr(typeof HTMLElement < "u" ? tle({ key: "css" }) : null);
process.env.NODE_ENV !== "production" && (zk.displayName = "EmotionCacheContext"), zk.Provider;
var GT = function(e) {
  return Bt(function(t, n) {
    var o = bo(zk);
    return e(t, o, n);
  });
};
Vb || (GT = function(e) {
  return function(t) {
    var n = bo(zk);
    return n === null ? (n = tle({ key: "css" }), pt(zk.Provider, { value: n }, e(t, n))) : e(t, n);
  };
});
var WT = Cr({});
process.env.NODE_ENV !== "production" && (WT.displayName = "EmotionThemeContext");
var udc = function(e) {
  var t = e.split(".");
  return t[t.length - 1];
}, ddc = function(e) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e);
  return t || (t = /^([A-Za-z0-9$.]+)@/.exec(e)) ? udc(t[1]) : void 0;
}, _dc = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), pdc = function(e) {
  return e.replace(/\$/g, "-");
}, mdc = typeof document < "u", fdc = Ue.useInsertionEffect ? Ue.useInsertionEffect : function(e) {
  e();
};
function ile(e) {
  if (!mdc)
    return e();
  fdc(e);
}
var c4 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", l4 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", gdc = function(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var n = {};
  for (var o in t)
    IF.call(t, o) && (n[o] = t[o]);
  if (n[c4] = e, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var r = function(i) {
      if (i)
        for (var a = i.split(`
`), s = 0; s < a.length; s++) {
          var c = ddc(a[s]);
          if (c) {
            if (_dc.has(c))
              break;
            if (/^[A-Z]/.test(c))
              return pdc(c);
          }
        }
    }(new Error().stack);
    r && (n[l4] = r);
  }
  return n;
}, hdc = function(e) {
  var t = e.cache, n = e.serialized, o = e.isStringTag;
  CF(t, n, o);
  var r = ile(function() {
    return TF(t, n, o);
  });
  if (!Vb && r !== void 0) {
    for (var i, a = n.name, s = n.next; s !== void 0; )
      a += " " + s.name, s = s.next;
    return pt("style", ((i = {})["data-emotion"] = t.key + " " + a, i.dangerouslySetInnerHTML = { __html: r }, i.nonce = t.sheet.nonce, i));
  }
  return null;
}, ale = GT(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[c4], i = [o], a = "";
  typeof e.className == "string" ? a = nle(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var s = Nk(i, void 0, bo(WT));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var c = e[l4];
    c && (s = Nk([s, "label:" + c + ";"]));
  }
  a += t.key + "-" + s.name;
  var l = {};
  for (var u in e)
    !IF.call(e, u) || u === "css" || u === c4 || process.env.NODE_ENV !== "production" && u === l4 || (l[u] = e[u]);
  return l.ref = n, l.className = a, pt(Ha, null, pt(hdc, { cache: t, serialized: s, isStringTag: typeof r == "string" }), pt(r, l));
});
process.env.NODE_ENV !== "production" && (ale.displayName = "EmotionCssPropInternal");
var So = function(e, t) {
  var n = arguments;
  if (t == null || !IF.call(t, "css"))
    return pt.apply(void 0, n);
  var o = n.length, r = new Array(o);
  r[0] = ale, r[1] = gdc(e, t);
  for (var i = 2; i < o; i++)
    r[i] = n[i];
  return pt.apply(null, r);
}, MW = Ue.useInsertionEffect ? Ue.useInsertionEffect : lc, FW = !1, vdc = GT(function(e, t) {
  process.env.NODE_ENV === "production" || FW || !e.className && !e.css || (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), FW = !0);
  var n = e.styles, o = Nk([n], void 0, bo(WT));
  if (!Vb) {
    for (var r, i = o.name, a = o.styles, s = o.next; s !== void 0; )
      i += " " + s.name, a += s.styles, s = s.next;
    var c = t.compat === !0, l = t.insert("", { name: i, styles: a }, t.sheet, c);
    return c ? null : pt("style", ((r = {})["data-emotion"] = t.key + "-global " + i, r.dangerouslySetInnerHTML = { __html: l }, r.nonce = t.sheet.nonce, r));
  }
  var u = xt();
  return MW(function() {
    var d = t.key + "-global", _ = new t.sheet.constructor({ key: d, nonce: t.sheet.nonce, container: t.sheet.container, speedy: t.sheet.isSpeedy }), p = !1, g = document.querySelector('style[data-emotion="' + d + " " + o.name + '"]');
    return t.sheet.tags.length && (_.before = t.sheet.tags[0]), g !== null && (p = !0, g.setAttribute("data-emotion", d), _.hydrate([g])), u.current = [_, p], function() {
      _.flush();
    };
  }, [t]), MW(function() {
    var d = u.current, _ = d[0];
    if (d[1])
      d[1] = !1;
    else {
      if (o.next !== void 0 && TF(t, o.next, !0), _.tags.length) {
        var p = _.tags[_.tags.length - 1].nextElementSibling;
        _.before = p, _.flush();
      }
      t.insert("", o, _, !1);
    }
  }, [t, o.name]), null;
});
function OF() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Nk(t);
}
process.env.NODE_ENV !== "production" && (vdc.displayName = "EmotionGlobal");
var bdc = function e(t) {
  for (var n = t.length, o = 0, r = ""; o < n; o++) {
    var i = t[o];
    if (i != null) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object":
          if (Array.isArray(i))
            a = e(i);
          else
            for (var s in process.env.NODE_ENV !== "production" && i.styles !== void 0 && i.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "", i)
              i[s] && s && (a && (a += " "), a += s);
          break;
        default:
          a = i;
      }
      a && (r && (r += " "), r += a);
    }
  }
  return r;
};
function ydc(e, t, n) {
  var o = [], r = nle(e, o, n);
  return o.length < 2 ? n : r + t(o);
}
var $dc = function(e) {
  var t, n = e.cache, o = e.serializedArr, r = ile(function() {
    for (var i = "", a = 0; a < o.length; a++) {
      var s = TF(n, o[a], !1);
      Vb || s === void 0 || (i += s);
    }
    if (!Vb)
      return i;
  });
  return Vb || r.length === 0 ? null : pt("style", ((t = {})["data-emotion"] = n.key + " " + o.map(function(i) {
    return i.name;
  }).join(" "), t.dangerouslySetInnerHTML = { __html: r }, t.nonce = n.sheet.nonce, t));
}, wdc = GT(function(e, t) {
  var n = !1, o = [], r = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var u = Nk(c, t.registered);
    return o.push(u), CF(t, u, !1), t.key + "-" + u.name;
  }, i = { css: r, cx: function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    return ydc(t.registered, r, bdc(c));
  }, theme: bo(WT) }, a = e.children(i);
  return n = !0, pt(Ha, null, pt($dc, { cache: t, serializedArr: o }), a);
});
if (process.env.NODE_ENV !== "production" && (wdc.displayName = "EmotionClassNames"), process.env.NODE_ENV !== "production") {
  var qW = typeof document < "u", kdc = typeof jest < "u";
  if (qW && !kdc) {
    var jW = typeof globalThis < "u" ? globalThis : qW ? window : global, VW = "__EMOTION_REACT_" + "11.9.3".split(".")[0] + "__";
    jW[VW] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), jW[VW] = !0;
  }
}
function qp(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function sle(e) {
  return qp(e).getComputedStyle(e);
}
const IS = Math.round;
function cle(e) {
  return ule(e) ? (e.nodeName || "").toLowerCase() : "";
}
let OS;
function lle(e) {
  return e instanceof qp(e).HTMLElement;
}
function Bb(e) {
  return e instanceof qp(e).Element;
}
function ule(e) {
  return e instanceof qp(e).Node;
}
function BW(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof qp(e).ShadowRoot || e instanceof ShadowRoot;
}
function dle(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = sle(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function Sdc() {
  return !/^((?!chrome|android).)*safari/i.test(function() {
    if (OS)
      return OS;
    const e = navigator.userAgentData;
    return e && Array.isArray(e.brands) ? (OS = e.brands.map((t) => t.brand + "/" + t.version).join(" "), OS) : navigator.userAgent;
  }());
}
function _le(e) {
  return Bb(e) ? e : e.contextElement;
}
const ple = { x: 1, y: 1 };
function lN(e) {
  const t = _le(e);
  if (!lle(t))
    return ple;
  const n = t.getBoundingClientRect(), { width: o, height: r, fallback: i } = function(c) {
    const l = sle(c);
    let u = parseFloat(l.width), d = parseFloat(l.height);
    const _ = c.offsetWidth, p = c.offsetHeight, g = IS(u) !== _ || IS(d) !== p;
    return g && (u = _, d = p), { width: u, height: d, fallback: g };
  }(t);
  let a = (i ? IS(n.width) : n.width) / o, s = (i ? IS(n.height) : n.height) / r;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
function UW(e, t, n, o) {
  var r, i;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), s = _le(e);
  let c = ple;
  t && (o ? Bb(o) && (c = lN(o)) : c = lN(e));
  const l = s ? qp(s) : window, u = !Sdc() && n;
  let d = (a.left + (u && ((r = l.visualViewport) == null ? void 0 : r.offsetLeft) || 0)) / c.x, _ = (a.top + (u && ((i = l.visualViewport) == null ? void 0 : i.offsetTop) || 0)) / c.y, p = a.width / c.x, g = a.height / c.y;
  if (s) {
    const f = qp(s), h = o && Bb(o) ? qp(o) : o;
    let $ = f.frameElement;
    for (; $ && o && h !== f; ) {
      const v = lN($), b = $.getBoundingClientRect(), y = getComputedStyle($);
      b.x += ($.clientLeft + parseFloat(y.paddingLeft)) * v.x, b.y += ($.clientTop + parseFloat(y.paddingTop)) * v.y, d *= v.x, _ *= v.y, p *= v.x, g *= v.y, d += b.x, _ += b.y, $ = qp($).frameElement;
    }
  }
  return { width: p, height: g, top: _, right: d + p, bottom: _ + g, left: d, x: d, y: _ };
}
function Edc(e) {
  if (cle(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || BW(e) && e.host || function(n) {
    return ((ule(n) ? n.ownerDocument : n.document) || window.document).documentElement;
  }(e);
  return BW(t) ? t.host : t;
}
function mle(e) {
  const t = Edc(e);
  return function(n) {
    return ["html", "body", "#document"].includes(cle(n));
  }(t) ? t.ownerDocument.body : lle(t) && dle(t) ? t : mle(t);
}
function ox(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = mle(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = qp(o);
  return r ? t.concat(i, i.visualViewport || [], dle(o) ? o : []) : t.concat(o, ox(o));
}
var u4 = typeof document < "u" ? lc : yt, xdc = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Qx = function() {
};
function Cdc(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function Tdc(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    o[r - 2] = arguments[r];
  var i = [].concat(o);
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && i.push("".concat(Cdc(e, a)));
  return i.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var GW = function(e) {
  return t = e, Array.isArray(t) ? e.filter(Boolean) : Zx(e) === "object" && e !== null ? [e] : [];
  var t;
}, WW = function(e) {
  return e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, Ho({}, Ey(e, xdc));
}, Ra = function(e, t, n) {
  var o = e.cx, r = e.getStyles, i = e.getClassNames, a = e.className;
  return { css: r(t, e), className: o(n ?? {}, i(t, e), a) };
};
function HT(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function fle(e) {
  return HT(e) ? window.pageYOffset : e.scrollTop;
}
function eC(e, t) {
  HT(e) ? window.scrollTo(0, t) : e.scrollTop = t;
}
function Adc(e, t, n, o) {
  return n * ((e = e / o - 1) * e * e + 1) + t;
}
function NS(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Qx, r = fle(e), i = t - r, a = 10, s = 0;
  function c() {
    var l = Adc(s += a, r, i, n);
    eC(e, l), s < n ? window.requestAnimationFrame(c) : o(e);
  }
  c();
}
function HW(e, t) {
  var n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = t.offsetHeight / 3;
  o.bottom + r > n.bottom ? eC(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : o.top - r < n.top && eC(e, Math.max(t.offsetTop - r, 0));
}
function YW() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
var gle = !1, Idc = { get passive() {
  return gle = !0;
} }, zS = typeof window < "u" ? window : {};
zS.addEventListener && zS.removeEventListener && (zS.addEventListener("p", Qx, Idc), zS.removeEventListener("p", Qx, !1));
var Odc = gle;
function Ndc(e) {
  return e != null;
}
function RS(e, t, n) {
  return e ? t : n;
}
function zdc(e) {
  var t = e.maxHeight, n = e.menuEl, o = e.minHeight, r = e.placement, i = e.shouldScroll, a = e.isFixedPosition, s = e.controlHeight, c = function(E) {
    var x = getComputedStyle(E), k = x.position === "absolute", I = /(auto|scroll)/;
    if (x.position === "fixed")
      return document.documentElement;
    for (var z = E; z = z.parentElement; )
      if (x = getComputedStyle(z), (!k || x.position !== "static") && I.test(x.overflow + x.overflowY + x.overflowX))
        return z;
    return document.documentElement;
  }(n), l = { placement: "bottom", maxHeight: t };
  if (!n || !n.offsetParent)
    return l;
  var u, d = c.getBoundingClientRect().height, _ = n.getBoundingClientRect(), p = _.bottom, g = _.height, f = _.top, h = n.offsetParent.getBoundingClientRect().top, $ = a || HT(u = c) ? window.innerHeight : u.clientHeight, v = fle(c), b = parseInt(getComputedStyle(n).marginBottom, 10), y = parseInt(getComputedStyle(n).marginTop, 10), w = h - y, N = $ - f, M = w + v, q = d - v - f, L = p - $ + v + b, R = v + f - y, T = 160;
  switch (r) {
    case "auto":
    case "bottom":
      if (N >= g)
        return { placement: "bottom", maxHeight: t };
      if (q >= g && !a)
        return i && NS(c, L, T), { placement: "bottom", maxHeight: t };
      if (!a && q >= o || a && N >= o)
        return i && NS(c, L, T), { placement: "bottom", maxHeight: a ? N - b : q - b };
      if (r === "auto" || a) {
        var D = t, A = a ? w : M;
        return A >= o && (D = Math.min(A - b - s, t)), { placement: "top", maxHeight: D };
      }
      if (r === "bottom")
        return i && eC(c, L), { placement: "bottom", maxHeight: t };
      break;
    case "top":
      if (w >= g)
        return { placement: "top", maxHeight: t };
      if (M >= g && !a)
        return i && NS(c, R, T), { placement: "top", maxHeight: t };
      if (!a && M >= o || a && w >= o) {
        var S = t;
        return (!a && M >= o || a && w >= o) && (S = a ? w - y : M - y), i && NS(c, R, T), { placement: "top", maxHeight: S };
      }
      return { placement: "bottom", maxHeight: t };
    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }
  return l;
}
var hle = function(e) {
  return e === "auto" ? "bottom" : e;
}, vle = Cr(null), Rdc = function(e) {
  var t = e.children, n = e.minMenuHeight, o = e.maxMenuHeight, r = e.menuPlacement, i = e.menuPosition, a = e.menuShouldScrollIntoView, s = e.theme, c = (bo(vle) || {}).setPortalPlacement, l = xt(null), u = uf(it(o), 2), d = u[0], _ = u[1], p = uf(it(null), 2), g = p[0], f = p[1], h = s.spacing.controlHeight;
  return u4(function() {
    var $ = l.current;
    if ($) {
      var v = i === "fixed", b = zdc({ maxHeight: o, menuEl: $, minHeight: n, placement: r, shouldScroll: a && !v, isFixedPosition: v, controlHeight: h });
      _(b.maxHeight), f(b.placement), c == null || c(b.placement);
    }
  }, [o, r, i, a, n, c, h]), t({ ref: l, placerProps: Ho(Ho({}, e), {}, { placement: g || hle(r), maxHeight: d }) });
}, ble = function(e, t) {
  var n = e.theme, o = n.spacing.baseUnit, r = n.colors;
  return Ho({ textAlign: "center" }, t ? {} : { color: r.neutral40, padding: "".concat(2 * o, "px ").concat(3 * o, "px") });
}, Pdc = ble, Ddc = ble, yle = function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({}, Ra(e, "noOptionsMessage", { "menu-notice": !0, "menu-notice--no-options": !0 }), n), t);
};
yle.defaultProps = { children: "No options" };
var $le = function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({}, Ra(e, "loadingMessage", { "menu-notice": !0, "menu-notice--loading": !0 }), n), t);
};
$le.defaultProps = { children: "Loading..." };
var KW, Ldc = ["size"], uN, dN, Mdc = process.env.NODE_ENV === "production" ? { name: "8mmkcg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0" } : { name: "tj5bde-Svg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} }, wle = function(e) {
  var t = e.size, n = Ey(e, Ldc);
  return So("svg", Oo({ height: t, width: t, viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", css: Mdc }, n));
}, _N = function(e) {
  return So(wle, Oo({ size: 20 }, e), So("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" }));
}, ZW = function(e) {
  return So(wle, Oo({ size: 20 }, e), So("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" }));
}, kle = function(e, t) {
  var n = e.isFocused, o = e.theme, r = o.spacing.baseUnit, i = o.colors;
  return Ho({ label: "indicatorContainer", display: "flex", transition: "color 150ms" }, t ? {} : { color: n ? i.neutral60 : i.neutral20, padding: 2 * r, ":hover": { color: n ? i.neutral80 : i.neutral40 } });
}, Fdc = kle, qdc = kle, jdc = function() {
  var e = OF.apply(void 0, arguments), t = "animation-" + e.name;
  return { name: t, styles: "@keyframes " + t + "{" + e.styles + "}", anim: 1, toString: function() {
    return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
  } };
}(KW || (uN = [`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`], dN || (dN = uN.slice(0)), KW = Object.freeze(Object.defineProperties(uN, { raw: { value: Object.freeze(dN) } })))), pN = function(e) {
  var t = e.delay, n = e.offset;
  return So("span", { css: OF({ animation: "".concat(jdc, " 1s ease-in-out ").concat(t, "ms infinite;"), backgroundColor: "currentColor", borderRadius: "1em", display: "inline-block", marginLeft: n ? "1em" : void 0, height: "1em", verticalAlign: "top", width: "1em" }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") });
}, Sle = function(e) {
  var t = e.innerProps, n = e.isRtl;
  return So("div", Oo({}, Ra(e, "loadingIndicator", { indicator: !0, "loading-indicator": !0 }), t), So(pN, { delay: 0, offset: n }), So(pN, { delay: 160, offset: !0 }), So(pN, { delay: 320, offset: !n }));
};
Sle.defaultProps = { size: 4 };
var Vdc = ["data"], Bdc = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Ele = { gridArea: "1 / 2", font: "inherit", minWidth: "2px", border: 0, margin: 0, outline: 0, padding: 0 }, Udc = { flex: "1 1 auto", display: "inline-grid", gridArea: "1 / 1 / 2 / 3", gridTemplateColumns: "0 min-content", "&:after": Ho({ content: 'attr(data-value) " "', visibility: "hidden", whiteSpace: "pre" }, Ele) }, Gdc = function(e) {
  return Ho({ label: "input", color: "inherit", background: 0, opacity: e ? 0 : 1, width: "100%" }, Ele);
}, XW = function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", n, t);
}, Wdc = { ClearIndicator: function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({}, Ra(e, "clearIndicator", { indicator: !0, "clear-indicator": !0 }), n), t || So(_N, null));
}, Control: function(e) {
  var t = e.children, n = e.isDisabled, o = e.isFocused, r = e.innerRef, i = e.innerProps, a = e.menuIsOpen;
  return So("div", Oo({ ref: r }, Ra(e, "control", { control: !0, "control--is-disabled": n, "control--is-focused": o, "control--menu-is-open": a }), i), t);
}, DropdownIndicator: function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({}, Ra(e, "dropdownIndicator", { indicator: !0, "dropdown-indicator": !0 }), n), t || So(ZW, null));
}, DownChevron: ZW, CrossIcon: _N, Group: function(e) {
  var t = e.children, n = e.cx, o = e.getStyles, r = e.getClassNames, i = e.Heading, a = e.headingProps, s = e.innerProps, c = e.label, l = e.theme, u = e.selectProps;
  return So("div", Oo({}, Ra(e, "group", { group: !0 }), s), So(i, Oo({}, a, { selectProps: u, theme: l, getStyles: o, getClassNames: r, cx: n }), c), So("div", null, t));
}, GroupHeading: function(e) {
  var t = WW(e);
  t.data;
  var n = Ey(t, Vdc);
  return So("div", Oo({}, Ra(e, "groupHeading", { "group-heading": !0 }), n));
}, IndicatorsContainer: function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({}, Ra(e, "indicatorsContainer", { indicators: !0 }), n), t);
}, IndicatorSeparator: function(e) {
  var t = e.innerProps;
  return So("span", Oo({}, t, Ra(e, "indicatorSeparator", { "indicator-separator": !0 })));
}, Input: function(e) {
  var t = e.cx, n = e.value, o = WW(e), r = o.innerRef, i = o.isDisabled, a = o.isHidden, s = o.inputClassName, c = Ey(o, Bdc);
  return So("div", Oo({}, Ra(e, "input", { "input-container": !0 }), { "data-value": n || "" }), So("input", Oo({ className: t({ input: !0 }, s), ref: r, style: Gdc(a), disabled: i }, c)));
}, LoadingIndicator: Sle, Menu: function(e) {
  var t = e.children, n = e.innerRef, o = e.innerProps;
  return So("div", Oo({}, Ra(e, "menu", { menu: !0 }), { ref: n }, o), t);
}, MenuList: function(e) {
  var t = e.children, n = e.innerProps, o = e.innerRef, r = e.isMulti;
  return So("div", Oo({}, Ra(e, "menuList", { "menu-list": !0, "menu-list--is-multi": r }), { ref: o }, n), t);
}, MenuPortal: function(e) {
  var t = e.appendTo, n = e.children, o = e.controlElement, r = e.innerProps, i = e.menuPlacement, a = e.menuPosition, s = xt(null), c = xt(null), l = uf(it(hle(i)), 2), u = l[0], d = l[1], _ = vn(function() {
    return { setPortalPlacement: d };
  }, []), p = uf(it(null), 2), g = p[0], f = p[1], h = Yt(function() {
    if (o) {
      var y = function(M) {
        var q = M.getBoundingClientRect();
        return { bottom: q.bottom, height: q.height, left: q.left, right: q.right, top: q.top, width: q.width };
      }(o), w = a === "fixed" ? 0 : window.pageYOffset, N = y[u] + w;
      N === (g == null ? void 0 : g.offset) && y.left === (g == null ? void 0 : g.rect.left) && y.width === (g == null ? void 0 : g.rect.width) || f({ offset: N, rect: y });
    }
  }, [o, a, u, g == null ? void 0 : g.offset, g == null ? void 0 : g.rect.left, g == null ? void 0 : g.rect.width]);
  u4(function() {
    h();
  }, [h]);
  var $ = Yt(function() {
    typeof c.current == "function" && (c.current(), c.current = null), o && s.current && (c.current = function(y, w, N, M) {
      M === void 0 && (M = {});
      const { ancestorScroll: q = !0, ancestorResize: L = !0, elementResize: R = !0, animationFrame: T = !1 } = M, D = q && !T, A = D || L ? [...Bb(y) ? ox(y) : y.contextElement ? ox(y.contextElement) : [], ...ox(w)] : [];
      A.forEach((k) => {
        D && k.addEventListener("scroll", N, { passive: !0 }), L && k.addEventListener("resize", N);
      });
      let S, E = null;
      if (R) {
        let k = !0;
        E = new ResizeObserver(() => {
          k || N(), k = !1;
        }), Bb(y) && !T && E.observe(y), Bb(y) || !y.contextElement || T || E.observe(y.contextElement), E.observe(w);
      }
      let x = T ? UW(y) : null;
      return T && function k() {
        const I = UW(y);
        !x || I.x === x.x && I.y === x.y && I.width === x.width && I.height === x.height || N(), x = I, S = requestAnimationFrame(k);
      }(), N(), () => {
        var k;
        A.forEach((I) => {
          D && I.removeEventListener("scroll", N), L && I.removeEventListener("resize", N);
        }), (k = E) == null || k.disconnect(), E = null, T && cancelAnimationFrame(S);
      };
    }(o, s.current, h, { elementResize: "ResizeObserver" in window }));
  }, [o, h]);
  u4(function() {
    $();
  }, [$]);
  var v = Yt(function(y) {
    s.current = y, $();
  }, [$]);
  if (!t && a !== "fixed" || !g)
    return null;
  var b = So("div", Oo({ ref: v }, Ra(Ho(Ho({}, e), {}, { offset: g.offset, position: a, rect: g.rect }), "menuPortal", { "menu-portal": !0 }), r), n);
  return So(vle.Provider, { value: _ }, t ? My(b, t) : b);
}, LoadingMessage: $le, NoOptionsMessage: yle, MultiValue: function(e) {
  var t = e.children, n = e.components, o = e.data, r = e.innerProps, i = e.isDisabled, a = e.removeProps, s = e.selectProps, c = n.Container, l = n.Label, u = n.Remove;
  return So(c, { data: o, innerProps: Ho(Ho({}, Ra(e, "multiValue", { "multi-value": !0, "multi-value--is-disabled": i })), r), selectProps: s }, So(l, { data: o, innerProps: Ho({}, Ra(e, "multiValueLabel", { "multi-value__label": !0 })), selectProps: s }, t), So(u, { data: o, innerProps: Ho(Ho({}, Ra(e, "multiValueRemove", { "multi-value__remove": !0 })), {}, { "aria-label": "Remove ".concat(t || "option") }, a), selectProps: s }));
}, MultiValueContainer: XW, MultiValueLabel: XW, MultiValueRemove: function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({ role: "button" }, n), t || So(_N, { size: 14 }));
}, Option: function(e) {
  var t = e.children, n = e.isDisabled, o = e.isFocused, r = e.isSelected, i = e.innerRef, a = e.innerProps;
  return So("div", Oo({}, Ra(e, "option", { option: !0, "option--is-disabled": n, "option--is-focused": o, "option--is-selected": r }), { ref: i, "aria-disabled": n }, a), t);
}, Placeholder: function(e) {
  var t = e.children, n = e.innerProps;
  return So("div", Oo({}, Ra(e, "placeholder", { placeholder: !0 }), n), t);
}, SelectContainer: function(e) {
  var t = e.children, n = e.innerProps, o = e.isDisabled, r = e.isRtl;
  return So("div", Oo({}, Ra(e, "container", { "--is-disabled": o, "--is-rtl": r }), n), t);
}, SingleValue: function(e) {
  var t = e.children, n = e.isDisabled, o = e.innerProps;
  return So("div", Oo({}, Ra(e, "singleValue", { "single-value": !0, "single-value--is-disabled": n }), o), t);
}, ValueContainer: function(e) {
  var t = e.children, n = e.innerProps, o = e.isMulti, r = e.hasValue;
  return So("div", Oo({}, Ra(e, "valueContainer", { "value-container": !0, "value-container--is-multi": o, "value-container--has-value": r }), n), t);
} }, JW = Number.isNaN || function(e) {
  return typeof e == "number" && e != e;
};
function Hdc(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (o = e[n], r = t[n], !(o === r || JW(o) && JW(r)))
      return !1;
  var o, r;
  return !0;
}
for (var Ydc = process.env.NODE_ENV === "production" ? { name: "7pg0cj-a11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap" } : { name: "1f43avz-a11yText-A11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} }, QW = function(e) {
  return So("span", Oo({ css: Ydc }, e));
}, Kdc = { guidance: function(e) {
  var t = e.isSearchable, n = e.isMulti, o = e.isDisabled, r = e.tabSelectsValue;
  switch (e.context) {
    case "menu":
      return "Use Up and Down to choose options".concat(o ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(r ? ", press Tab to select the option and exit the menu" : "", ".");
    case "input":
      return "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "");
    case "value":
      return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
    default:
      return "";
  }
}, onChange: function(e) {
  var t = e.action, n = e.label, o = n === void 0 ? "" : n, r = e.labels, i = e.isDisabled;
  switch (t) {
    case "deselect-option":
    case "pop-value":
    case "remove-value":
      return "option ".concat(o, ", deselected.");
    case "clear":
      return "All selected options have been cleared.";
    case "initial-input-focus":
      return "option".concat(r.length > 1 ? "s" : "", " ").concat(r.join(","), ", selected.");
    case "select-option":
      return "option ".concat(o, i ? " is disabled. Select another option." : ", selected.");
    default:
      return "";
  }
}, onFocus: function(e) {
  var t = e.context, n = e.focused, o = e.options, r = e.label, i = r === void 0 ? "" : r, a = e.selectValue, s = e.isDisabled, c = e.isSelected, l = function(_, p) {
    return _ && _.length ? "".concat(_.indexOf(p) + 1, " of ").concat(_.length) : "";
  };
  if (t === "value" && a)
    return "value ".concat(i, " focused, ").concat(l(a, n), ".");
  if (t === "menu") {
    var u = s ? " disabled" : "", d = "".concat(c ? "selected" : "focused").concat(u);
    return "option ".concat(i, " ").concat(d, ", ").concat(l(o, n), ".");
  }
  return "";
}, onFilter: function(e) {
  var t = e.inputValue, n = e.resultsMessage;
  return "".concat(n).concat(t ? " for search term " + t : "", ".");
} }, Zdc = function(e) {
  var t = e.ariaSelection, n = e.focusedOption, o = e.focusedValue, r = e.focusableOptions, i = e.isFocused, a = e.selectValue, s = e.selectProps, c = e.id, l = s.ariaLiveMessages, u = s.getOptionLabel, d = s.inputValue, _ = s.isMulti, p = s.isOptionDisabled, g = s.isSearchable, f = s.menuIsOpen, h = s.options, $ = s.screenReaderStatus, v = s.tabSelectsValue, b = s["aria-label"], y = s["aria-live"], w = vn(function() {
    return Ho(Ho({}, Kdc), l || {});
  }, [l]), N = vn(function() {
    var A, S = "";
    if (t && w.onChange) {
      var E = t.option, x = t.options, k = t.removedValue, I = t.removedValues, z = t.value, F = k || E || (A = z, Array.isArray(A) ? null : A), P = F ? u(F) : "", O = x || I || void 0, V = O ? O.map(u) : [], U = Ho({ isDisabled: F && p(F, a), label: P, labels: V }, t);
      S = w.onChange(U);
    }
    return S;
  }, [t, w, p, a, u]), M = vn(function() {
    var A = "", S = n || o, E = !!(n && a && a.includes(n));
    if (S && w.onFocus) {
      var x = { focused: S, label: u(S), isDisabled: p(S, a), isSelected: E, options: r, context: S === n ? "menu" : "value", selectValue: a };
      A = w.onFocus(x);
    }
    return A;
  }, [n, o, u, p, w, r, a]), q = vn(function() {
    var A = "";
    if (f && h.length && w.onFilter) {
      var S = $({ count: r.length });
      A = w.onFilter({ inputValue: d, resultsMessage: S });
    }
    return A;
  }, [r, d, f, w, h, $]), L = vn(function() {
    var A = "";
    if (w.guidance) {
      var S = o ? "value" : f ? "menu" : "input";
      A = w.guidance({ "aria-label": b, context: S, isDisabled: n && p(n, a), isMulti: _, isSearchable: g, tabSelectsValue: v });
    }
    return A;
  }, [b, n, o, _, p, g, f, w, a, v]), R = "".concat(M, " ").concat(q, " ").concat(L), T = So(Ha, null, So("span", { id: "aria-selection" }, N), So("span", { id: "aria-context" }, R)), D = (t == null ? void 0 : t.action) === "initial-input-focus";
  return So(Ha, null, So(QW, { id: c }, D && T), So(QW, { "aria-live": y, "aria-atomic": "false", "aria-relevant": "additions text" }, i && !D && T));
}, mN = [{ base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" }, { base: "AA", letters: "Ꜳ" }, { base: "AE", letters: "ÆǼǢ" }, { base: "AO", letters: "Ꜵ" }, { base: "AU", letters: "Ꜷ" }, { base: "AV", letters: "ꜸꜺ" }, { base: "AY", letters: "Ꜽ" }, { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" }, { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" }, { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ" }, { base: "DZ", letters: "ǱǄ" }, { base: "Dz", letters: "ǲǅ" }, { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" }, { base: "F", letters: "FⒻＦḞƑꝻ" }, { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" }, { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" }, { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" }, { base: "J", letters: "JⒿＪĴɈ" }, { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" }, { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" }, { base: "LJ", letters: "Ǉ" }, { base: "Lj", letters: "ǈ" }, { base: "M", letters: "MⓂＭḾṀṂⱮƜ" }, { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" }, { base: "NJ", letters: "Ǌ" }, { base: "Nj", letters: "ǋ" }, { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" }, { base: "OI", letters: "Ƣ" }, { base: "OO", letters: "Ꝏ" }, { base: "OU", letters: "Ȣ" }, { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" }, { base: "Q", letters: "QⓆＱꝖꝘɊ" }, { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" }, { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" }, { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" }, { base: "TZ", letters: "Ꜩ" }, { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" }, { base: "V", letters: "VⓋＶṼṾƲꝞɅ" }, { base: "VY", letters: "Ꝡ" }, { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" }, { base: "X", letters: "XⓍＸẊẌ" }, { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" }, { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" }, { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" }, { base: "aa", letters: "ꜳ" }, { base: "ae", letters: "æǽǣ" }, { base: "ao", letters: "ꜵ" }, { base: "au", letters: "ꜷ" }, { base: "av", letters: "ꜹꜻ" }, { base: "ay", letters: "ꜽ" }, { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" }, { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" }, { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" }, { base: "dz", letters: "ǳǆ" }, { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" }, { base: "f", letters: "fⓕｆḟƒꝼ" }, { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" }, { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" }, { base: "hv", letters: "ƕ" }, { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" }, { base: "j", letters: "jⓙｊĵǰɉ" }, { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" }, { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" }, { base: "lj", letters: "ǉ" }, { base: "m", letters: "mⓜｍḿṁṃɱɯ" }, { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" }, { base: "nj", letters: "ǌ" }, { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" }, { base: "oi", letters: "ƣ" }, { base: "ou", letters: "ȣ" }, { base: "oo", letters: "ꝏ" }, { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" }, { base: "q", letters: "qⓠｑɋꝗꝙ" }, { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" }, { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" }, { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" }, { base: "tz", letters: "ꜩ" }, { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" }, { base: "v", letters: "vⓥｖṽṿʋꝟʌ" }, { base: "vy", letters: "ꝡ" }, { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" }, { base: "x", letters: "xⓧｘẋẍ" }, { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" }, { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" }], Xdc = new RegExp("[" + mN.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), xle = {}, fN = 0; fN < mN.length; fN++)
  for (var gN = mN[fN], hN = 0; hN < gN.letters.length; hN++)
    xle[gN.letters[hN]] = gN.base;
var Cle = function(e) {
  return e.replace(Xdc, function(t) {
    return xle[t];
  });
}, Jdc = function(e, t) {
  t === void 0 && (t = Hdc);
  var n = null;
  function o() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (n && n.lastThis === this && t(r, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, r);
    return n = { lastResult: a, lastArgs: r, lastThis: this }, a;
  }
  return o.clear = function() {
    n = null;
  }, o;
}(Cle), e8 = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, Qdc = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, e_c = ["innerRef"];
function t_c(e) {
  var t = e.innerRef, n = function(o) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    var s = Object.entries(o).filter(function(c) {
      var l = uf(c, 1)[0];
      return !i.includes(l);
    });
    return s.reduce(function(c, l) {
      var u = uf(l, 2), d = u[0], _ = u[1];
      return c[d] = _, c;
    }, {});
  }(Ey(e, e_c), "onExited", "in", "enter", "exit", "appear");
  return So("input", Oo({ ref: t }, n, { css: OF({ label: "dummyInput", background: 0, border: 0, caretColor: "transparent", fontSize: "inherit", gridArea: "1 / 1 / 2 / 3", outline: 0, padding: 0, width: 1, color: "transparent", left: -100, opacity: 0, position: "relative", transform: "scale(.01)" }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */") }));
}
var t8 = ["boxSizing", "height", "overflow", "paddingRight", "position"], n8 = { boxSizing: "border-box", overflow: "hidden", position: "relative", height: "100%" };
function o8(e) {
  e.preventDefault();
}
function r8(e) {
  e.stopPropagation();
}
function i8() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function a8() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var s8 = !(typeof window > "u" || !window.document || !window.document.createElement), B$ = 0, ab = { capture: !1, passive: !1 }, n_c = function() {
  return document.activeElement && document.activeElement.blur();
}, o_c = process.env.NODE_ENV === "production" ? { name: "1kfdb0e", styles: "position:fixed;left:0;bottom:0;right:0;top:0" } : { name: "bp8cua-ScrollManager", styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} };
function r_c(e) {
  var t = e.children, n = e.lockEnabled, o = e.captureEnabled, r = function(a) {
    var s = a.isEnabled, c = a.onBottomArrive, l = a.onBottomLeave, u = a.onTopArrive, d = a.onTopLeave, _ = xt(!1), p = xt(!1), g = xt(0), f = xt(null), h = Yt(function(N, M) {
      if (f.current !== null) {
        var q = f.current, L = q.scrollTop, R = q.scrollHeight, T = q.clientHeight, D = f.current, A = M > 0, S = R - T - L, E = !1;
        S > M && _.current && (l && l(N), _.current = !1), A && p.current && (d && d(N), p.current = !1), A && M > S ? (c && !_.current && c(N), D.scrollTop = R, E = !0, _.current = !0) : !A && -M > L && (u && !p.current && u(N), D.scrollTop = 0, E = !0, p.current = !0), E && function(x) {
          x.preventDefault(), x.stopPropagation();
        }(N);
      }
    }, [c, l, u, d]), $ = Yt(function(N) {
      h(N, N.deltaY);
    }, [h]), v = Yt(function(N) {
      g.current = N.changedTouches[0].clientY;
    }, []), b = Yt(function(N) {
      var M = g.current - N.changedTouches[0].clientY;
      h(N, M);
    }, [h]), y = Yt(function(N) {
      if (N) {
        var M = !!Odc && { passive: !1 };
        N.addEventListener("wheel", $, M), N.addEventListener("touchstart", v, M), N.addEventListener("touchmove", b, M);
      }
    }, [b, v, $]), w = Yt(function(N) {
      N && (N.removeEventListener("wheel", $, !1), N.removeEventListener("touchstart", v, !1), N.removeEventListener("touchmove", b, !1));
    }, [b, v, $]);
    return yt(function() {
      if (s) {
        var N = f.current;
        return y(N), function() {
          w(N);
        };
      }
    }, [s, y, w]), function(N) {
      f.current = N;
    };
  }({ isEnabled: o === void 0 || o, onBottomArrive: e.onBottomArrive, onBottomLeave: e.onBottomLeave, onTopArrive: e.onTopArrive, onTopLeave: e.onTopLeave }), i = function(a) {
    var s = a.isEnabled, c = a.accountForScrollbars, l = c === void 0 || c, u = xt({}), d = xt(null), _ = Yt(function(g) {
      if (s8) {
        var f = document.body, h = f && f.style;
        if (l && t8.forEach(function(y) {
          var w = h && h[y];
          u.current[y] = w;
        }), l && B$ < 1) {
          var $ = parseInt(u.current.paddingRight, 10) || 0, v = document.body ? document.body.clientWidth : 0, b = window.innerWidth - v + $ || 0;
          Object.keys(n8).forEach(function(y) {
            var w = n8[y];
            h && (h[y] = w);
          }), h && (h.paddingRight = "".concat(b, "px"));
        }
        f && a8() && (f.addEventListener("touchmove", o8, ab), g && (g.addEventListener("touchstart", i8, ab), g.addEventListener("touchmove", r8, ab))), B$ += 1;
      }
    }, [l]), p = Yt(function(g) {
      if (s8) {
        var f = document.body, h = f && f.style;
        B$ = Math.max(B$ - 1, 0), l && B$ < 1 && t8.forEach(function($) {
          var v = u.current[$];
          h && (h[$] = v);
        }), f && a8() && (f.removeEventListener("touchmove", o8, ab), g && (g.removeEventListener("touchstart", i8, ab), g.removeEventListener("touchmove", r8, ab)));
      }
    }, [l]);
    return yt(function() {
      if (s) {
        var g = d.current;
        return _(g), function() {
          p(g);
        };
      }
    }, [s, _, p]), function(g) {
      d.current = g;
    };
  }({ isEnabled: n });
  return So(Ha, null, n && So("div", { onClick: n_c, css: o_c }), t(function(a) {
    r(a), i(a);
  }));
}
var i_c, a_c = process.env.NODE_ENV === "production" ? { name: "1a0ro4n-requiredInput", styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%" } : { name: "5kkxb2-requiredInput-RequiredInput", styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZTogc3RyaW5nO1xuICByZWFkb25seSBvbkZvY3VzOiBGb2N1c0V2ZW50SGFuZGxlcjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0+ID0gKHsgbmFtZSwgb25Gb2N1cyB9KSA9PiAoXG4gIDxpbnB1dFxuICAgIHJlcXVpcmVkXG4gICAgbmFtZT17bmFtZX1cbiAgICB0YWJJbmRleD17LTF9XG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} }, s_c = function(e) {
  var t = e.name, n = e.onFocus;
  return So("input", { required: !0, name: t, tabIndex: -1, onFocus: n, css: a_c, value: "", onChange: function() {
  } });
}, c_c = { clearIndicator: qdc, container: function(e) {
  var t = e.isDisabled;
  return { label: "container", direction: e.isRtl ? "rtl" : void 0, pointerEvents: t ? "none" : void 0, position: "relative" };
}, control: function(e, t) {
  var n = e.isDisabled, o = e.isFocused, r = e.theme, i = r.colors, a = r.borderRadius;
  return Ho({ label: "control", alignItems: "center", cursor: "default", display: "flex", flexWrap: "wrap", justifyContent: "space-between", minHeight: r.spacing.controlHeight, outline: "0 !important", position: "relative", transition: "all 100ms" }, t ? {} : { backgroundColor: n ? i.neutral5 : i.neutral0, borderColor: n ? i.neutral10 : o ? i.primary : i.neutral20, borderRadius: a, borderStyle: "solid", borderWidth: 1, boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0, "&:hover": { borderColor: o ? i.primary : i.neutral30 } });
}, dropdownIndicator: Fdc, group: function(e, t) {
  var n = e.theme.spacing;
  return t ? {} : { paddingBottom: 2 * n.baseUnit, paddingTop: 2 * n.baseUnit };
}, groupHeading: function(e, t) {
  var n = e.theme, o = n.colors, r = n.spacing;
  return Ho({ label: "group", cursor: "default", display: "block" }, t ? {} : { color: o.neutral40, fontSize: "75%", fontWeight: 500, marginBottom: "0.25em", paddingLeft: 3 * r.baseUnit, paddingRight: 3 * r.baseUnit, textTransform: "uppercase" });
}, indicatorsContainer: function() {
  return { alignItems: "center", alignSelf: "stretch", display: "flex", flexShrink: 0 };
}, indicatorSeparator: function(e, t) {
  var n = e.isDisabled, o = e.theme, r = o.spacing.baseUnit, i = o.colors;
  return Ho({ label: "indicatorSeparator", alignSelf: "stretch", width: 1 }, t ? {} : { backgroundColor: n ? i.neutral10 : i.neutral20, marginBottom: 2 * r, marginTop: 2 * r });
}, input: function(e, t) {
  var n = e.isDisabled, o = e.value, r = e.theme, i = r.spacing, a = r.colors;
  return Ho(Ho({ visibility: n ? "hidden" : "visible", transform: o ? "translateZ(0)" : "" }, Udc), t ? {} : { margin: i.baseUnit / 2, paddingBottom: i.baseUnit / 2, paddingTop: i.baseUnit / 2, color: a.neutral80 });
}, loadingIndicator: function(e, t) {
  var n = e.isFocused, o = e.size, r = e.theme, i = r.colors, a = r.spacing.baseUnit;
  return Ho({ label: "loadingIndicator", display: "flex", transition: "color 150ms", alignSelf: "center", fontSize: o, lineHeight: 1, marginRight: o, textAlign: "center", verticalAlign: "middle" }, t ? {} : { color: n ? i.neutral60 : i.neutral20, padding: 2 * a });
}, loadingMessage: Ddc, menu: function(e, t) {
  var n, o = e.placement, r = e.theme, i = r.borderRadius, a = r.spacing, s = r.colors;
  return Ho((Ew(n = { label: "menu" }, function(c) {
    return c ? { bottom: "top", top: "bottom" }[c] : "bottom";
  }(o), "100%"), Ew(n, "position", "absolute"), Ew(n, "width", "100%"), Ew(n, "zIndex", 1), n), t ? {} : { backgroundColor: s.neutral0, borderRadius: i, boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)", marginBottom: a.menuGutter, marginTop: a.menuGutter });
}, menuList: function(e, t) {
  var n = e.maxHeight, o = e.theme.spacing.baseUnit;
  return Ho({ maxHeight: n, overflowY: "auto", position: "relative", WebkitOverflowScrolling: "touch" }, t ? {} : { paddingBottom: o, paddingTop: o });
}, menuPortal: function(e) {
  var t = e.rect, n = e.offset, o = e.position;
  return { left: t.left, position: o, top: n, width: t.width, zIndex: 1 };
}, multiValue: function(e, t) {
  var n = e.theme, o = n.spacing, r = n.borderRadius, i = n.colors;
  return Ho({ label: "multiValue", display: "flex", minWidth: 0 }, t ? {} : { backgroundColor: i.neutral10, borderRadius: r / 2, margin: o.baseUnit / 2 });
}, multiValueLabel: function(e, t) {
  var n = e.theme, o = n.borderRadius, r = n.colors, i = e.cropWithEllipsis;
  return Ho({ overflow: "hidden", textOverflow: i || i === void 0 ? "ellipsis" : void 0, whiteSpace: "nowrap" }, t ? {} : { borderRadius: o / 2, color: r.neutral80, fontSize: "85%", padding: 3, paddingLeft: 6 });
}, multiValueRemove: function(e, t) {
  var n = e.theme, o = n.spacing, r = n.borderRadius, i = n.colors, a = e.isFocused;
  return Ho({ alignItems: "center", display: "flex" }, t ? {} : { borderRadius: r / 2, backgroundColor: a ? i.dangerLight : void 0, paddingLeft: o.baseUnit, paddingRight: o.baseUnit, ":hover": { backgroundColor: i.dangerLight, color: i.danger } });
}, noOptionsMessage: Pdc, option: function(e, t) {
  var n = e.isDisabled, o = e.isFocused, r = e.isSelected, i = e.theme, a = i.spacing, s = i.colors;
  return Ho({ label: "option", cursor: "default", display: "block", fontSize: "inherit", width: "100%", userSelect: "none", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }, t ? {} : { backgroundColor: r ? s.primary : o ? s.primary25 : "transparent", color: n ? s.neutral20 : r ? s.neutral0 : "inherit", padding: "".concat(2 * a.baseUnit, "px ").concat(3 * a.baseUnit, "px"), ":active": { backgroundColor: n ? void 0 : r ? s.primary : s.primary50 } });
}, placeholder: function(e, t) {
  var n = e.theme, o = n.spacing, r = n.colors;
  return Ho({ label: "placeholder", gridArea: "1 / 1 / 2 / 3" }, t ? {} : { color: r.neutral50, marginLeft: o.baseUnit / 2, marginRight: o.baseUnit / 2 });
}, singleValue: function(e, t) {
  var n = e.isDisabled, o = e.theme, r = o.spacing, i = o.colors;
  return Ho({ label: "singleValue", gridArea: "1 / 1 / 2 / 3", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, t ? {} : { color: n ? i.neutral40 : i.neutral80, marginLeft: r.baseUnit / 2, marginRight: r.baseUnit / 2 });
}, valueContainer: function(e, t) {
  var n = e.theme.spacing, o = e.isMulti, r = e.hasValue, i = e.selectProps.controlShouldRenderValue;
  return Ho({ alignItems: "center", display: o && r && i ? "flex" : "grid", flex: 1, flexWrap: "wrap", WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" }, t ? {} : { padding: "".concat(n.baseUnit / 2, "px ").concat(2 * n.baseUnit, "px") });
} }, vN = { borderRadius: 4, colors: { primary: "#2684FF", primary75: "#4C9AFF", primary50: "#B2D4FF", primary25: "#DEEBFF", danger: "#DE350B", dangerLight: "#FFBDAD", neutral0: "hsl(0, 0%, 100%)", neutral5: "hsl(0, 0%, 95%)", neutral10: "hsl(0, 0%, 90%)", neutral20: "hsl(0, 0%, 80%)", neutral30: "hsl(0, 0%, 70%)", neutral40: "hsl(0, 0%, 60%)", neutral50: "hsl(0, 0%, 50%)", neutral60: "hsl(0, 0%, 40%)", neutral70: "hsl(0, 0%, 30%)", neutral80: "hsl(0, 0%, 20%)", neutral90: "hsl(0, 0%, 10%)" }, spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 } }, l_c = { "aria-live": "polite", backspaceRemovesValue: !0, blurInputOnSelect: YW(), captureMenuScroll: !YW(), classNames: {}, closeMenuOnSelect: !0, closeMenuOnScroll: !1, components: {}, controlShouldRenderValue: !0, escapeClearsValue: !1, filterOption: function(e, t) {
  if (e.data.__isNew__)
    return !0;
  var n = Ho({ ignoreCase: !0, ignoreAccents: !0, stringify: Qdc, trim: !0, matchFrom: "any" }, i_c), o = n.ignoreCase, r = n.ignoreAccents, i = n.stringify, a = n.trim, s = n.matchFrom, c = a ? e8(t) : t, l = a ? e8(i(e)) : i(e);
  return o && (c = c.toLowerCase(), l = l.toLowerCase()), r && (c = Jdc(c), l = Cle(l)), s === "start" ? l.substr(0, c.length) === c : l.indexOf(c) > -1;
}, formatGroupLabel: function(e) {
  return e.label;
}, getOptionLabel: function(e) {
  return e.label;
}, getOptionValue: function(e) {
  return e.value;
}, isDisabled: !1, isLoading: !1, isMulti: !1, isRtl: !1, isSearchable: !0, isOptionDisabled: function(e) {
  return !!e.isDisabled;
}, loadingMessage: function() {
  return "Loading...";
}, maxMenuHeight: 300, minMenuHeight: 140, menuIsOpen: !1, menuPlacement: "bottom", menuPosition: "absolute", menuShouldBlockScroll: !1, menuShouldScrollIntoView: !function() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}(), noOptionsMessage: function() {
  return "No options";
}, openMenuOnFocus: !1, openMenuOnClick: !0, options: [], pageSize: 5, placeholder: "Select...", screenReaderStatus: function(e) {
  var t = e.count;
  return "".concat(t, " result").concat(t !== 1 ? "s" : "", " available");
}, styles: {}, tabIndex: 0, tabSelectsValue: !0, unstyled: !1 };
function c8(e, t, n, o) {
  return { type: "option", data: t, isDisabled: Ale(e, t, n), isSelected: Ile(e, t, n), label: Tle(e, t), value: tC(e, t), index: o };
}
function l8(e, t) {
  return e.options.map(function(n, o) {
    if ("options" in n) {
      var r = n.options.map(function(a, s) {
        return c8(e, a, t, s);
      }).filter(function(a) {
        return d8(e, a);
      });
      return r.length > 0 ? { type: "group", data: n, options: r, index: o } : void 0;
    }
    var i = c8(e, n, t, o);
    return d8(e, i) ? i : void 0;
  }).filter(Ndc);
}
function u8(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Yce(n.options.map(function(o) {
      return o.data;
    }))) : t.push(n.data), t;
  }, []);
}
function d8(e, t) {
  var n = e.inputValue, o = n === void 0 ? "" : n, r = t.data, i = t.isSelected, a = t.label, s = t.value;
  return (!Nle(e) || !i) && Ole(e, { label: a, value: s, data: r }, o);
}
var Tle = function(e, t) {
  return e.getOptionLabel(t);
}, tC = function(e, t) {
  return e.getOptionValue(t);
};
function Ale(e, t, n) {
  return typeof e.isOptionDisabled == "function" && e.isOptionDisabled(t, n);
}
function Ile(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var o = tC(e, t);
  return n.some(function(r) {
    return tC(e, r) === o;
  });
}
function Ole(e, t, n) {
  return !e.filterOption || e.filterOption(t, n);
}
var Nle = function(e) {
  var t = e.hideSelectedOptions, n = e.isMulti;
  return t === void 0 ? n : t;
}, u_c = 1, zle = function(e) {
  (function(a, s) {
    if (typeof s != "function" && s !== null)
      throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(s && s.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), s && e4(a, s);
  })(i, mre);
  var t, n, o, r = Ruc(i);
  function i(a) {
    var s;
    if (function(u, d) {
      if (!(u instanceof d))
        throw new TypeError("Cannot call a class as a function");
    }(this, i), (s = r.call(this, a)).state = { ariaSelection: null, focusedOption: null, focusedValue: null, inputIsHidden: !1, isFocused: !1, selectValue: [], clearFocusValueOnUpdate: !1, prevWasFocused: !1, inputIsHiddenAfterUpdate: void 0, prevProps: void 0 }, s.blockOptionHover = !1, s.isComposing = !1, s.commonProps = void 0, s.initialTouchX = 0, s.initialTouchY = 0, s.instancePrefix = "", s.openAfterFocus = !1, s.scrollToFocusedOptionOnUpdate = !1, s.userIsDragging = void 0, s.controlRef = null, s.getControlRef = function(u) {
      s.controlRef = u;
    }, s.focusedOptionRef = null, s.getFocusedOptionRef = function(u) {
      s.focusedOptionRef = u;
    }, s.menuListRef = null, s.getMenuListRef = function(u) {
      s.menuListRef = u;
    }, s.inputRef = null, s.getInputRef = function(u) {
      s.inputRef = u;
    }, s.focus = s.focusInput, s.blur = s.blurInput, s.onChange = function(u, d) {
      var _ = s.props, p = _.onChange, g = _.name;
      d.name = g, s.ariaOnChange(u, d), p(u, d);
    }, s.setValue = function(u, d, _) {
      var p = s.props, g = p.closeMenuOnSelect, f = p.isMulti, h = p.inputValue;
      s.onInputChange("", { action: "set-value", prevInputValue: h }), g && (s.setState({ inputIsHiddenAfterUpdate: !f }), s.onMenuClose()), s.setState({ clearFocusValueOnUpdate: !0 }), s.onChange(u, { action: d, option: _ });
    }, s.selectOption = function(u) {
      var d = s.props, _ = d.blurInputOnSelect, p = d.isMulti, g = d.name, f = s.state.selectValue, h = p && s.isOptionSelected(u, f), $ = s.isOptionDisabled(u, f);
      if (h) {
        var v = s.getOptionValue(u);
        s.setValue(f.filter(function(b) {
          return s.getOptionValue(b) !== v;
        }), "deselect-option", u);
      } else {
        if ($)
          return void s.ariaOnChange(u, { action: "select-option", option: u, name: g });
        p ? s.setValue([].concat(Yce(f), [u]), "select-option", u) : s.setValue(u, "select-option");
      }
      _ && s.blurInput();
    }, s.removeValue = function(u) {
      var d = s.props.isMulti, _ = s.state.selectValue, p = s.getOptionValue(u), g = _.filter(function(h) {
        return s.getOptionValue(h) !== p;
      }), f = RS(d, g, g[0] || null);
      s.onChange(f, { action: "remove-value", removedValue: u }), s.focusInput();
    }, s.clearValue = function() {
      var u = s.state.selectValue;
      s.onChange(RS(s.props.isMulti, [], null), { action: "clear", removedValues: u });
    }, s.popValue = function() {
      var u = s.props.isMulti, d = s.state.selectValue, _ = d[d.length - 1], p = d.slice(0, d.length - 1), g = RS(u, p, p[0] || null);
      s.onChange(g, { action: "pop-value", removedValue: _ });
    }, s.getValue = function() {
      return s.state.selectValue;
    }, s.cx = function() {
      for (var u = arguments.length, d = new Array(u), _ = 0; _ < u; _++)
        d[_] = arguments[_];
      return Tdc.apply(void 0, [s.props.classNamePrefix].concat(d));
    }, s.getOptionLabel = function(u) {
      return Tle(s.props, u);
    }, s.getOptionValue = function(u) {
      return tC(s.props, u);
    }, s.getStyles = function(u, d) {
      var _ = s.props.unstyled, p = c_c[u](d, _);
      p.boxSizing = "border-box";
      var g = s.props.styles[u];
      return g ? g(p, d) : p;
    }, s.getClassNames = function(u, d) {
      var _, p;
      return (_ = (p = s.props.classNames)[u]) === null || _ === void 0 ? void 0 : _.call(p, d);
    }, s.getElementId = function(u) {
      return "".concat(s.instancePrefix, "-").concat(u);
    }, s.getComponents = function() {
      return u = s.props, Ho(Ho({}, Wdc), u.components);
      var u;
    }, s.buildCategorizedOptions = function() {
      return l8(s.props, s.state.selectValue);
    }, s.getCategorizedOptions = function() {
      return s.props.menuIsOpen ? s.buildCategorizedOptions() : [];
    }, s.buildFocusableOptions = function() {
      return u8(s.buildCategorizedOptions());
    }, s.getFocusableOptions = function() {
      return s.props.menuIsOpen ? s.buildFocusableOptions() : [];
    }, s.ariaOnChange = function(u, d) {
      s.setState({ ariaSelection: Ho({ value: u }, d) });
    }, s.onMenuMouseDown = function(u) {
      u.button === 0 && (u.stopPropagation(), u.preventDefault(), s.focusInput());
    }, s.onMenuMouseMove = function(u) {
      s.blockOptionHover = !1;
    }, s.onControlMouseDown = function(u) {
      if (!u.defaultPrevented) {
        var d = s.props.openMenuOnClick;
        s.state.isFocused ? s.props.menuIsOpen ? u.target.tagName !== "INPUT" && u.target.tagName !== "TEXTAREA" && s.onMenuClose() : d && s.openMenu("first") : (d && (s.openAfterFocus = !0), s.focusInput()), u.target.tagName !== "INPUT" && u.target.tagName !== "TEXTAREA" && u.preventDefault();
      }
    }, s.onDropdownIndicatorMouseDown = function(u) {
      if (!(u && u.type === "mousedown" && u.button !== 0 || s.props.isDisabled)) {
        var d = s.props, _ = d.isMulti, p = d.menuIsOpen;
        s.focusInput(), p ? (s.setState({ inputIsHiddenAfterUpdate: !_ }), s.onMenuClose()) : s.openMenu("first"), u.preventDefault();
      }
    }, s.onClearIndicatorMouseDown = function(u) {
      u && u.type === "mousedown" && u.button !== 0 || (s.clearValue(), u.preventDefault(), s.openAfterFocus = !1, u.type === "touchend" ? s.focusInput() : setTimeout(function() {
        return s.focusInput();
      }));
    }, s.onScroll = function(u) {
      typeof s.props.closeMenuOnScroll == "boolean" ? u.target instanceof HTMLElement && HT(u.target) && s.props.onMenuClose() : typeof s.props.closeMenuOnScroll == "function" && s.props.closeMenuOnScroll(u) && s.props.onMenuClose();
    }, s.onCompositionStart = function() {
      s.isComposing = !0;
    }, s.onCompositionEnd = function() {
      s.isComposing = !1;
    }, s.onTouchStart = function(u) {
      var d = u.touches, _ = d && d.item(0);
      _ && (s.initialTouchX = _.clientX, s.initialTouchY = _.clientY, s.userIsDragging = !1);
    }, s.onTouchMove = function(u) {
      var d = u.touches, _ = d && d.item(0);
      if (_) {
        var p = Math.abs(_.clientX - s.initialTouchX), g = Math.abs(_.clientY - s.initialTouchY);
        s.userIsDragging = p > 5 || g > 5;
      }
    }, s.onTouchEnd = function(u) {
      s.userIsDragging || (s.controlRef && !s.controlRef.contains(u.target) && s.menuListRef && !s.menuListRef.contains(u.target) && s.blurInput(), s.initialTouchX = 0, s.initialTouchY = 0);
    }, s.onControlTouchEnd = function(u) {
      s.userIsDragging || s.onControlMouseDown(u);
    }, s.onClearIndicatorTouchEnd = function(u) {
      s.userIsDragging || s.onClearIndicatorMouseDown(u);
    }, s.onDropdownIndicatorTouchEnd = function(u) {
      s.userIsDragging || s.onDropdownIndicatorMouseDown(u);
    }, s.handleInputChange = function(u) {
      var d = s.props.inputValue, _ = u.currentTarget.value;
      s.setState({ inputIsHiddenAfterUpdate: !1 }), s.onInputChange(_, { action: "input-change", prevInputValue: d }), s.props.menuIsOpen || s.onMenuOpen();
    }, s.onInputFocus = function(u) {
      s.props.onFocus && s.props.onFocus(u), s.setState({ inputIsHiddenAfterUpdate: !1, isFocused: !0 }), (s.openAfterFocus || s.props.openMenuOnFocus) && s.openMenu("first"), s.openAfterFocus = !1;
    }, s.onInputBlur = function(u) {
      var d = s.props.inputValue;
      s.menuListRef && s.menuListRef.contains(document.activeElement) ? s.inputRef.focus() : (s.props.onBlur && s.props.onBlur(u), s.onInputChange("", { action: "input-blur", prevInputValue: d }), s.onMenuClose(), s.setState({ focusedValue: null, isFocused: !1 }));
    }, s.onOptionHover = function(u) {
      s.blockOptionHover || s.state.focusedOption === u || s.setState({ focusedOption: u });
    }, s.shouldHideSelectedOptions = function() {
      return Nle(s.props);
    }, s.onValueInputFocus = function(u) {
      u.preventDefault(), u.stopPropagation(), s.focus();
    }, s.onKeyDown = function(u) {
      var d = s.props, _ = d.isMulti, p = d.backspaceRemovesValue, g = d.escapeClearsValue, f = d.inputValue, h = d.isClearable, $ = d.isDisabled, v = d.menuIsOpen, b = d.onKeyDown, y = d.tabSelectsValue, w = d.openMenuOnFocus, N = s.state, M = N.focusedOption, q = N.focusedValue, L = N.selectValue;
      if (!($ || typeof b == "function" && (b(u), u.defaultPrevented))) {
        switch (s.blockOptionHover = !0, u.key) {
          case "ArrowLeft":
            if (!_ || f)
              return;
            s.focusValue("previous");
            break;
          case "ArrowRight":
            if (!_ || f)
              return;
            s.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (f)
              return;
            if (q)
              s.removeValue(q);
            else {
              if (!p)
                return;
              _ ? s.popValue() : h && s.clearValue();
            }
            break;
          case "Tab":
            if (s.isComposing || u.shiftKey || !v || !y || !M || w && s.isOptionSelected(M, L))
              return;
            s.selectOption(M);
            break;
          case "Enter":
            if (u.keyCode === 229)
              break;
            if (v) {
              if (!M || s.isComposing)
                return;
              s.selectOption(M);
              break;
            }
            return;
          case "Escape":
            v ? (s.setState({ inputIsHiddenAfterUpdate: !1 }), s.onInputChange("", { action: "menu-close", prevInputValue: f }), s.onMenuClose()) : h && g && s.clearValue();
            break;
          case " ":
            if (f)
              return;
            if (!v) {
              s.openMenu("first");
              break;
            }
            if (!M)
              return;
            s.selectOption(M);
            break;
          case "ArrowUp":
            v ? s.focusOption("up") : s.openMenu("last");
            break;
          case "ArrowDown":
            v ? s.focusOption("down") : s.openMenu("first");
            break;
          case "PageUp":
            if (!v)
              return;
            s.focusOption("pageup");
            break;
          case "PageDown":
            if (!v)
              return;
            s.focusOption("pagedown");
            break;
          case "Home":
            if (!v)
              return;
            s.focusOption("first");
            break;
          case "End":
            if (!v)
              return;
            s.focusOption("last");
            break;
          default:
            return;
        }
        u.preventDefault();
      }
    }, s.instancePrefix = "react-select-" + (s.props.instanceId || ++u_c), s.state.selectValue = GW(a.value), a.menuIsOpen && s.state.selectValue.length) {
      var c = s.buildFocusableOptions(), l = c.indexOf(s.state.selectValue[0]);
      s.state.focusedOption = c[l];
    }
    return s;
  }
  return t = i, n = [{ key: "componentDidMount", value: function() {
    this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && HW(this.menuListRef, this.focusedOptionRef);
  } }, { key: "componentDidUpdate", value: function(a) {
    var s = this.props, c = s.isDisabled, l = s.menuIsOpen, u = this.state.isFocused;
    (u && !c && a.isDisabled || u && l && !a.menuIsOpen) && this.focusInput(), u && c && !a.isDisabled ? this.setState({ isFocused: !1 }, this.onMenuClose) : u || c || !a.isDisabled || this.inputRef !== document.activeElement || this.setState({ isFocused: !0 }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (HW(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
  } }, { key: "componentWillUnmount", value: function() {
    this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "onMenuOpen", value: function() {
    this.props.onMenuOpen();
  } }, { key: "onMenuClose", value: function() {
    this.onInputChange("", { action: "menu-close", prevInputValue: this.props.inputValue }), this.props.onMenuClose();
  } }, { key: "onInputChange", value: function(a, s) {
    this.props.onInputChange(a, s);
  } }, { key: "focusInput", value: function() {
    this.inputRef && this.inputRef.focus();
  } }, { key: "blurInput", value: function() {
    this.inputRef && this.inputRef.blur();
  } }, { key: "openMenu", value: function(a) {
    var s = this, c = this.state, l = c.selectValue, u = c.isFocused, d = this.buildFocusableOptions(), _ = a === "first" ? 0 : d.length - 1;
    if (!this.props.isMulti) {
      var p = d.indexOf(l[0]);
      p > -1 && (_ = p);
    }
    this.scrollToFocusedOptionOnUpdate = !(u && this.menuListRef), this.setState({ inputIsHiddenAfterUpdate: !1, focusedValue: null, focusedOption: d[_] }, function() {
      return s.onMenuOpen();
    });
  } }, { key: "focusValue", value: function(a) {
    var s = this.state, c = s.selectValue, l = s.focusedValue;
    if (this.props.isMulti) {
      this.setState({ focusedOption: null });
      var u = c.indexOf(l);
      l || (u = -1);
      var d = c.length - 1, _ = -1;
      if (c.length) {
        switch (a) {
          case "previous":
            _ = u === 0 ? 0 : u === -1 ? d : u - 1;
            break;
          case "next":
            u > -1 && u < d && (_ = u + 1);
        }
        this.setState({ inputIsHidden: _ !== -1, focusedValue: c[_] });
      }
    }
  } }, { key: "focusOption", value: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", s = this.props.pageSize, c = this.state.focusedOption, l = this.getFocusableOptions();
    if (l.length) {
      var u = 0, d = l.indexOf(c);
      c || (d = -1), a === "up" ? u = d > 0 ? d - 1 : l.length - 1 : a === "down" ? u = (d + 1) % l.length : a === "pageup" ? (u = d - s) < 0 && (u = 0) : a === "pagedown" ? (u = d + s) > l.length - 1 && (u = l.length - 1) : a === "last" && (u = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({ focusedOption: l[u], focusedValue: null });
    }
  } }, { key: "getTheme", value: function() {
    return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(vN) : Ho(Ho({}, vN), this.props.theme) : vN;
  } }, { key: "getCommonProps", value: function() {
    var a = this.clearValue, s = this.cx, c = this.getStyles, l = this.getClassNames, u = this.getValue, d = this.selectOption, _ = this.setValue, p = this.props, g = p.isMulti, f = p.isRtl, h = p.options;
    return { clearValue: a, cx: s, getStyles: c, getClassNames: l, getValue: u, hasValue: this.hasValue(), isMulti: g, isRtl: f, options: h, selectOption: d, selectProps: p, setValue: _, theme: this.getTheme() };
  } }, { key: "hasValue", value: function() {
    return this.state.selectValue.length > 0;
  } }, { key: "hasOptions", value: function() {
    return !!this.getFocusableOptions().length;
  } }, { key: "isClearable", value: function() {
    var a = this.props, s = a.isClearable, c = a.isMulti;
    return s === void 0 ? c : s;
  } }, { key: "isOptionDisabled", value: function(a, s) {
    return Ale(this.props, a, s);
  } }, { key: "isOptionSelected", value: function(a, s) {
    return Ile(this.props, a, s);
  } }, { key: "filterOption", value: function(a, s) {
    return Ole(this.props, a, s);
  } }, { key: "formatOptionLabel", value: function(a, s) {
    if (typeof this.props.formatOptionLabel == "function") {
      var c = this.props.inputValue, l = this.state.selectValue;
      return this.props.formatOptionLabel(a, { context: s, inputValue: c, selectValue: l });
    }
    return this.getOptionLabel(a);
  } }, { key: "formatGroupLabel", value: function(a) {
    return this.props.formatGroupLabel(a);
  } }, { key: "startListeningComposition", value: function() {
    document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
  } }, { key: "stopListeningComposition", value: function() {
    document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
  } }, { key: "startListeningToTouch", value: function() {
    document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
  } }, { key: "stopListeningToTouch", value: function() {
    document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
  } }, { key: "renderInput", value: function() {
    var a = this.props, s = a.isDisabled, c = a.isSearchable, l = a.inputId, u = a.inputValue, d = a.tabIndex, _ = a.form, p = a.menuIsOpen, g = a.required, f = this.getComponents().Input, h = this.state, $ = h.inputIsHidden, v = h.ariaSelection, b = this.commonProps, y = l || this.getElementId("input"), w = Ho(Ho(Ho({ "aria-autocomplete": "list", "aria-expanded": p, "aria-haspopup": !0, "aria-errormessage": this.props["aria-errormessage"], "aria-invalid": this.props["aria-invalid"], "aria-label": this.props["aria-label"], "aria-labelledby": this.props["aria-labelledby"], "aria-required": g, role: "combobox" }, p && { "aria-controls": this.getElementId("listbox"), "aria-owns": this.getElementId("listbox") }), !c && { "aria-readonly": !0 }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && { "aria-describedby": this.getElementId("live-region") } : { "aria-describedby": this.getElementId("placeholder") });
    return c ? Ue.createElement(f, Oo({}, b, { autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", id: y, innerRef: this.getInputRef, isDisabled: s, isHidden: $, onBlur: this.onInputBlur, onChange: this.handleInputChange, onFocus: this.onInputFocus, spellCheck: "false", tabIndex: d, form: _, type: "text", value: u }, w)) : Ue.createElement(t_c, Oo({ id: y, innerRef: this.getInputRef, onBlur: this.onInputBlur, onChange: Qx, onFocus: this.onInputFocus, disabled: s, tabIndex: d, inputMode: "none", form: _, value: "" }, w));
  } }, { key: "renderPlaceholderOrValue", value: function() {
    var a = this, s = this.getComponents(), c = s.MultiValue, l = s.MultiValueContainer, u = s.MultiValueLabel, d = s.MultiValueRemove, _ = s.SingleValue, p = s.Placeholder, g = this.commonProps, f = this.props, h = f.controlShouldRenderValue, $ = f.isDisabled, v = f.isMulti, b = f.inputValue, y = f.placeholder, w = this.state, N = w.selectValue, M = w.focusedValue, q = w.isFocused;
    if (!this.hasValue() || !h)
      return b ? null : Ue.createElement(p, Oo({}, g, { key: "placeholder", isDisabled: $, isFocused: q, innerProps: { id: this.getElementId("placeholder") } }), y);
    if (v)
      return N.map(function(R, T) {
        var D = R === M, A = "".concat(a.getOptionLabel(R), "-").concat(a.getOptionValue(R));
        return Ue.createElement(c, Oo({}, g, { components: { Container: l, Label: u, Remove: d }, isFocused: D, isDisabled: $, key: A, index: T, removeProps: { onClick: function() {
          return a.removeValue(R);
        }, onTouchEnd: function() {
          return a.removeValue(R);
        }, onMouseDown: function(S) {
          S.preventDefault();
        } }, data: R }), a.formatOptionLabel(R, "value"));
      });
    if (b)
      return null;
    var L = N[0];
    return Ue.createElement(_, Oo({}, g, { data: L, isDisabled: $ }), this.formatOptionLabel(L, "value"));
  } }, { key: "renderClearIndicator", value: function() {
    var a = this.getComponents().ClearIndicator, s = this.commonProps, c = this.props, l = c.isDisabled, u = c.isLoading, d = this.state.isFocused;
    if (!this.isClearable() || !a || l || !this.hasValue() || u)
      return null;
    var _ = { onMouseDown: this.onClearIndicatorMouseDown, onTouchEnd: this.onClearIndicatorTouchEnd, "aria-hidden": "true" };
    return Ue.createElement(a, Oo({}, s, { innerProps: _, isFocused: d }));
  } }, { key: "renderLoadingIndicator", value: function() {
    var a = this.getComponents().LoadingIndicator, s = this.commonProps, c = this.props, l = c.isDisabled, u = c.isLoading, d = this.state.isFocused;
    return a && u ? Ue.createElement(a, Oo({}, s, { innerProps: { "aria-hidden": "true" }, isDisabled: l, isFocused: d })) : null;
  } }, { key: "renderIndicatorSeparator", value: function() {
    var a = this.getComponents(), s = a.DropdownIndicator, c = a.IndicatorSeparator;
    if (!s || !c)
      return null;
    var l = this.commonProps, u = this.props.isDisabled, d = this.state.isFocused;
    return Ue.createElement(c, Oo({}, l, { isDisabled: u, isFocused: d }));
  } }, { key: "renderDropdownIndicator", value: function() {
    var a = this.getComponents().DropdownIndicator;
    if (!a)
      return null;
    var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused, u = { onMouseDown: this.onDropdownIndicatorMouseDown, onTouchEnd: this.onDropdownIndicatorTouchEnd, "aria-hidden": "true" };
    return Ue.createElement(a, Oo({}, s, { innerProps: u, isDisabled: c, isFocused: l }));
  } }, { key: "renderMenu", value: function() {
    var a = this, s = this.getComponents(), c = s.Group, l = s.GroupHeading, u = s.Menu, d = s.MenuList, _ = s.MenuPortal, p = s.LoadingMessage, g = s.NoOptionsMessage, f = s.Option, h = this.commonProps, $ = this.state.focusedOption, v = this.props, b = v.captureMenuScroll, y = v.inputValue, w = v.isLoading, N = v.loadingMessage, M = v.minMenuHeight, q = v.maxMenuHeight, L = v.menuIsOpen, R = v.menuPlacement, T = v.menuPosition, D = v.menuPortalTarget, A = v.menuShouldBlockScroll, S = v.menuShouldScrollIntoView, E = v.noOptionsMessage, x = v.onMenuScrollToTop, k = v.onMenuScrollToBottom;
    if (!L)
      return null;
    var I, z = function(U, H) {
      var J = U.type, le = U.data, ae = U.isDisabled, Y = U.isSelected, re = U.label, ie = U.value, _e = $ === le, he = ae ? void 0 : function() {
        return a.onOptionHover(le);
      }, be = ae ? void 0 : function() {
        return a.selectOption(le);
      }, Q = "".concat(a.getElementId("option"), "-").concat(H), me = { id: Q, onClick: be, onMouseMove: he, onMouseOver: he, tabIndex: -1 };
      return Ue.createElement(f, Oo({}, h, { innerProps: me, data: le, isDisabled: ae, isSelected: Y, key: Q, label: re, type: J, value: ie, isFocused: _e, innerRef: _e ? a.getFocusedOptionRef : void 0 }), a.formatOptionLabel(U.data, "menu"));
    };
    if (this.hasOptions())
      I = this.getCategorizedOptions().map(function(U) {
        if (U.type === "group") {
          var H = U.data, J = U.options, le = U.index, ae = "".concat(a.getElementId("group"), "-").concat(le), Y = "".concat(ae, "-heading");
          return Ue.createElement(c, Oo({}, h, { key: ae, data: H, options: J, Heading: l, headingProps: { id: Y, data: U.data }, label: a.formatGroupLabel(U.data) }), U.options.map(function(re) {
            return z(re, "".concat(le, "-").concat(re.index));
          }));
        }
        if (U.type === "option")
          return z(U, "".concat(U.index));
      });
    else if (w) {
      var F = N({ inputValue: y });
      if (F === null)
        return null;
      I = Ue.createElement(p, h, F);
    } else {
      var P = E({ inputValue: y });
      if (P === null)
        return null;
      I = Ue.createElement(g, h, P);
    }
    var O = { minMenuHeight: M, maxMenuHeight: q, menuPlacement: R, menuPosition: T, menuShouldScrollIntoView: S }, V = Ue.createElement(Rdc, Oo({}, h, O), function(U) {
      var H = U.ref, J = U.placerProps, le = J.placement, ae = J.maxHeight;
      return Ue.createElement(u, Oo({}, h, O, { innerRef: H, innerProps: { onMouseDown: a.onMenuMouseDown, onMouseMove: a.onMenuMouseMove, id: a.getElementId("listbox") }, isLoading: w, placement: le }), Ue.createElement(r_c, { captureEnabled: b, onTopArrive: x, onBottomArrive: k, lockEnabled: A }, function(Y) {
        return Ue.createElement(d, Oo({}, h, { innerRef: function(re) {
          a.getMenuListRef(re), Y(re);
        }, isLoading: w, maxHeight: ae, focusedOption: $ }), I);
      }));
    });
    return D || T === "fixed" ? Ue.createElement(_, Oo({}, h, { appendTo: D, controlElement: this.controlRef, menuPlacement: R, menuPosition: T }), V) : V;
  } }, { key: "renderFormField", value: function() {
    var a = this, s = this.props, c = s.delimiter, l = s.isDisabled, u = s.isMulti, d = s.name, _ = s.required, p = this.state.selectValue;
    if (d && !l) {
      if (_ && !this.hasValue())
        return Ue.createElement(s_c, { name: d, onFocus: this.onValueInputFocus });
      if (u) {
        if (c) {
          var g = p.map(function($) {
            return a.getOptionValue($);
          }).join(c);
          return Ue.createElement("input", { name: d, type: "hidden", value: g });
        }
        var f = p.length > 0 ? p.map(function($, v) {
          return Ue.createElement("input", { key: "i-".concat(v), name: d, type: "hidden", value: a.getOptionValue($) });
        }) : Ue.createElement("input", { name: d, type: "hidden", value: "" });
        return Ue.createElement("div", null, f);
      }
      var h = p[0] ? this.getOptionValue(p[0]) : "";
      return Ue.createElement("input", { name: d, type: "hidden", value: h });
    }
  } }, { key: "renderLiveRegion", value: function() {
    var a = this.commonProps, s = this.state, c = s.ariaSelection, l = s.focusedOption, u = s.focusedValue, d = s.isFocused, _ = s.selectValue, p = this.getFocusableOptions();
    return Ue.createElement(Zdc, Oo({}, a, { id: this.getElementId("live-region"), ariaSelection: c, focusedOption: l, focusedValue: u, isFocused: d, selectValue: _, focusableOptions: p }));
  } }, { key: "render", value: function() {
    var a = this.getComponents(), s = a.Control, c = a.IndicatorsContainer, l = a.SelectContainer, u = a.ValueContainer, d = this.props, _ = d.className, p = d.id, g = d.isDisabled, f = d.menuIsOpen, h = this.state.isFocused, $ = this.commonProps = this.getCommonProps();
    return Ue.createElement(l, Oo({}, $, { className: _, innerProps: { id: p, onKeyDown: this.onKeyDown }, isDisabled: g, isFocused: h }), this.renderLiveRegion(), Ue.createElement(s, Oo({}, $, { innerRef: this.getControlRef, innerProps: { onMouseDown: this.onControlMouseDown, onTouchEnd: this.onControlTouchEnd }, isDisabled: g, isFocused: h, menuIsOpen: f }), Ue.createElement(u, Oo({}, $, { isDisabled: g }), this.renderPlaceholderOrValue(), this.renderInput()), Ue.createElement(c, Oo({}, $, { isDisabled: g }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
  } }], o = [{ key: "getDerivedStateFromProps", value: function(a, s) {
    var c = s.prevProps, l = s.clearFocusValueOnUpdate, u = s.inputIsHiddenAfterUpdate, d = s.ariaSelection, _ = s.isFocused, p = s.prevWasFocused, g = a.options, f = a.value, h = a.menuIsOpen, $ = a.inputValue, v = a.isMulti, b = GW(f), y = {};
    if (c && (f !== c.value || g !== c.options || h !== c.menuIsOpen || $ !== c.inputValue)) {
      var w = h ? function(T, D) {
        return u8(l8(T, D));
      }(a, b) : [], N = l ? function(T, D) {
        var A = T.focusedValue, S = T.selectValue.indexOf(A);
        if (S > -1) {
          if (D.indexOf(A) > -1)
            return A;
          if (S < D.length)
            return D[S];
        }
        return null;
      }(s, b) : null, M = function(T, D) {
        var A = T.focusedOption;
        return A && D.indexOf(A) > -1 ? A : D[0];
      }(s, w);
      y = { selectValue: b, focusedOption: M, focusedValue: N, clearFocusValueOnUpdate: !1 };
    }
    var q = u != null && a !== c ? { inputIsHidden: u, inputIsHiddenAfterUpdate: void 0 } : {}, L = d, R = _ && p;
    return _ && !R && (L = { value: RS(v, b, b[0] || null), options: b, action: "initial-input-focus" }, R = !p), (d == null ? void 0 : d.action) === "initial-input-focus" && (L = null), Ho(Ho(Ho({}, y), q), {}, { prevProps: a, ariaSelection: L, prevWasFocused: R });
  } }], n && bW(t.prototype, n), o && bW(t, o), Object.defineProperty(t, "prototype", { writable: !1 }), i;
}();
zle.defaultProps = l_c;
var d_c = Bt(function(e, t) {
  var n = function(o) {
    var r = o.defaultInputValue, i = r === void 0 ? "" : r, a = o.defaultMenuIsOpen, s = a !== void 0 && a, c = o.defaultValue, l = c === void 0 ? null : c, u = o.inputValue, d = o.menuIsOpen, _ = o.onChange, p = o.onInputChange, g = o.onMenuClose, f = o.onMenuOpen, h = o.value, $ = Ey(o, Nuc), v = uf(it(u !== void 0 ? u : i), 2), b = v[0], y = v[1], w = uf(it(d !== void 0 ? d : s), 2), N = w[0], M = w[1], q = uf(it(h !== void 0 ? h : l), 2), L = q[0], R = q[1], T = Yt(function(I, z) {
      typeof _ == "function" && _(I, z), R(I);
    }, [_]), D = Yt(function(I, z) {
      var F;
      typeof p == "function" && (F = p(I, z)), y(F !== void 0 ? F : I);
    }, [p]), A = Yt(function() {
      typeof f == "function" && f(), M(!0);
    }, [f]), S = Yt(function() {
      typeof g == "function" && g(), M(!1);
    }, [g]), E = u !== void 0 ? u : b, x = d !== void 0 ? d : N, k = h !== void 0 ? h : L;
    return Ho(Ho({}, $), {}, { inputValue: E, menuIsOpen: x, onChange: T, onInputChange: D, onMenuClose: S, onMenuOpen: A, value: k });
  }(e);
  return Ue.createElement(zle, Oo({ ref: t }, n));
}), __c = d_c;
const _8 = (e, t, n) => {
  const [o, r] = e.split("/"), [i, a] = r.split(":");
  return Date.UTC(n, o - 1, i, a) - 36e5 * t;
};
var Rle = (e, t, n, o, r) => {
  const i = new Date(e).getUTCFullYear(), a = _8(t, r, i), s = _8(n, o, i);
  return e >= a && e < s;
}, p_c = (e) => {
  let t = e.timezones[e.tz];
  if (t === void 0)
    return console.warn("Warning: couldn't find timezone " + e.tz), 0;
  if (t.dst === void 0)
    return t.offset;
  let n = t.offset, o = t.offset + 1;
  t.hem === "n" && (o = n - 1);
  let r = t.dst.split("->");
  return Rle(e.epoch, r[0], r[1], n, o) === !0 ? n : o;
}, p8 = { "9|s": "2/dili,2/jayapura", "9|n": "2/chita,2/khandyga,2/pyongyang,2/seoul,2/tokyo,11/palau,japan,rok", "9.5|s|04/03:03->10/02:02": "4/adelaide,4/broken_hill,4/south,4/yancowinna", "9.5|s": "4/darwin,4/north", "8|s|03/08:01->10/04:00": "12/casey", "8|s": "2/kuala_lumpur,2/makassar,2/singapore,4/perth,2/ujung_pandang,4/west,singapore", "8|n": "2/brunei,2/choibalsan,2/hong_kong,2/irkutsk,2/kuching,2/macau,2/manila,2/shanghai,2/taipei,2/ulaanbaatar,2/chongqing,2/chungking,2/harbin,2/macao,2/ulan_bator,hongkong,prc,roc", "8.75|s": "4/eucla", "7|s": "12/davis,2/jakarta,9/christmas", "7|n": "2/bangkok,2/barnaul,2/hovd,2/krasnoyarsk,2/novokuznetsk,2/novosibirsk,2/phnom_penh,2/pontianak,2/ho_chi_minh,2/tomsk,2/vientiane,2/saigon", "6|s": "12/vostok", "6|n": "2/almaty,2/bishkek,2/dhaka,2/omsk,2/qyzylorda,2/qostanay,2/thimphu,2/urumqi,9/chagos,2/dacca,2/kashgar,2/thimbu", "6.5|n": "2/yangon,9/cocos,2/rangoon", "5|s": "12/mawson,9/kerguelen", "5|n": "2/aqtau,2/aqtobe,2/ashgabat,2/atyrau,2/dushanbe,2/karachi,2/oral,2/samarkand,2/tashkent,2/yekaterinburg,9/maldives,2/ashkhabad", "5.75|n": "2/katmandu,2/kathmandu", "5.5|n": "2/kolkata,2/colombo,2/calcutta", "4|s": "9/reunion", "4|n": "2/baku,2/dubai,2/muscat,2/tbilisi,2/yerevan,8/astrakhan,8/samara,8/saratov,8/ulyanovsk,8/volgograd,2/volgograd,9/mahe,9/mauritius", "4.5|n|03/22:00->09/21:24": "2/tehran,iran", "4.5|n": "2/kabul", "3|s": "12/syowa,9/antananarivo", "3|n|03/27:03->10/30:04": "2/famagusta,2/nicosia,8/athens,8/bucharest,8/helsinki,8/kiev,8/mariehamn,8/riga,8/sofia,8/tallinn,8/uzhgorod,8/vilnius,8/zaporozhye,8/nicosia", "3|n|03/27:02->10/30:03": "8/chisinau,8/tiraspol", "3|n|03/27:00->10/29:24": "2/beirut", "3|n|03/27:00->10/28:01": "2/gaza,2/hebron", "3|n|03/25:02->10/30:02": "2/jerusalem,2/tel_aviv,israel", "3|n|03/25:00->10/27:24": "2/damascus", "3|n|02/25:00->10/28:01": "2/amman", "3|n": "0/addis_ababa,0/asmara,0/asmera,0/dar_es_salaam,0/djibouti,0/juba,0/kampala,0/mogadishu,0/nairobi,2/aden,2/baghdad,2/bahrain,2/kuwait,2/qatar,2/riyadh,8/istanbul,8/kirov,8/minsk,8/moscow,8/simferopol,9/comoro,9/mayotte,2/istanbul,turkey,w-su", "2|s|03/27:02->10/30:02": "12/troll", "2|s": "0/gaborone,0/harare,0/johannesburg,0/lubumbashi,0/lusaka,0/maputo,0/maseru,0/mbabane", "2|n|03/27:02->10/30:03": "0/ceuta,arctic/longyearbyen,8/amsterdam,8/andorra,8/belgrade,8/berlin,8/bratislava,8/brussels,8/budapest,8/busingen,8/copenhagen,8/gibraltar,8/ljubljana,8/luxembourg,8/madrid,8/malta,8/monaco,8/oslo,8/paris,8/podgorica,8/prague,8/rome,8/san_marino,8/sarajevo,8/skopje,8/stockholm,8/tirane,8/vaduz,8/vatican,8/vienna,8/warsaw,8/zagreb,8/zurich,3/jan_mayen,poland", "2|n": "0/blantyre,0/bujumbura,0/cairo,0/khartoum,0/kigali,0/tripoli,8/kaliningrad,egypt,libya", "1|s": "0/brazzaville,0/kinshasa,0/luanda,0/windhoek", "1|n|03/27:03->05/08:02": "0/casablanca,0/el_aaiun", "1|n|03/27:01->10/30:02": "3/canary,3/faroe,3/madeira,8/dublin,8/guernsey,8/isle_of_man,8/jersey,8/lisbon,8/london,3/faeroe,eire,8/belfast,gb-eire,gb,portugal", "1|n": "0/algiers,0/bangui,0/douala,0/lagos,0/libreville,0/malabo,0/ndjamena,0/niamey,0/porto-novo,0/tunis", "14|n": "11/kiritimati", "13|s|04/04:04->09/26:03": "11/apia", "13|s|01/15:02->11/05:03": "11/tongatapu", "13|n": "11/enderbury,11/fakaofo", "12|s|04/03:03->09/25:02": "12/mcmurdo,11/auckland,12/south_pole,nz", "12|s|01/17:03->11/14:02": "11/fiji", "12|n": "2/anadyr,2/kamchatka,2/srednekolymsk,11/funafuti,11/kwajalein,11/majuro,11/nauru,11/tarawa,11/wake,11/wallis,kwajalein", "12.75|s|04/03:03->04/03:02": "11/chatham,nz-chat", "11|s|04/03:03->10/02:02": "12/macquarie", "11|s": "11/bougainville", "11|n": "2/magadan,2/sakhalin,11/efate,11/guadalcanal,11/kosrae,11/noumea,11/pohnpei,11/ponape", "11.5|n|04/03:03->10/02:02": "11/norfolk", "10|s|04/03:03->10/02:02": "4/currie,4/hobart,4/melbourne,4/sydney,4/act,4/canberra,4/nsw,4/tasmania,4/victoria", "10|s": "12/dumontdurville,4/brisbane,4/lindeman,11/port_moresby,4/queensland", "10|n": "2/ust-nera,2/vladivostok,2/yakutsk,11/guam,11/saipan,11/chuuk,11/truk,11/yap", "10.5|s|04/03:01->10/02:02": "4/lord_howe,4/lhi", "0|n|03/27:00->10/30:01": "1/scoresbysund,3/azores", "0|n": "0/abidjan,0/accra,0/bamako,0/banjul,0/bissau,0/conakry,0/dakar,0/freetown,0/lome,0/monrovia,0/nouakchott,0/ouagadougou,0/sao_tome,1/danmarkshavn,3/reykjavik,3/st_helena,13/gmt,13/utc,0/timbuktu,13/greenwich,13/uct,13/universal,13/zulu,gmt-0,gmt+0,gmt0,greenwich,iceland,uct,universal,utc,zulu", "-9|n|03/13:02->11/06:02": "1/adak,1/atka,us/aleutian", "-9|n": "11/gambier", "-9.5|n": "11/marquesas", "-8|n|03/13:02->11/06:02": "1/anchorage,1/juneau,1/metlakatla,1/nome,1/sitka,1/yakutat,us/alaska", "-8|n": "11/pitcairn", "-7|n|03/13:02->11/06:02": "1/los_angeles,1/santa_isabel,1/tijuana,1/vancouver,1/ensenada,6/pacific,10/bajanorte,us/pacific-new,us/pacific", "-7|n|03/08:02->11/01:01": "1/dawson,1/whitehorse,6/yukon", "-7|n": "1/creston,1/dawson_creek,1/fort_nelson,1/hermosillo,1/phoenix,us/arizona", "-6|s|04/02:22->09/03:22": "11/easter,7/easterisland", "-6|n|04/03:02->10/30:02": "1/chihuahua,1/mazatlan,10/bajasur", "-6|n|03/13:02->11/06:02": "1/boise,1/cambridge_bay,1/denver,1/edmonton,1/inuvik,1/ojinaga,1/yellowknife,1/shiprock,6/mountain,navajo,us/mountain", "-6|n": "1/belize,1/costa_rica,1/el_salvador,1/guatemala,1/managua,1/regina,1/swift_current,1/tegucigalpa,11/galapagos,6/east-saskatchewan,6/saskatchewan", "-5|s": "1/lima,1/rio_branco,1/porto_acre,5/acre", "-5|n|04/03:02->10/30:02": "1/bahia_banderas,1/merida,1/mexico_city,1/monterrey,10/general", "-5|n|03/13:02->11/06:02": "1/chicago,1/matamoros,1/menominee,1/rainy_river,1/rankin_inlet,1/resolute,1/winnipeg,1/indiana/knox,1/indiana/tell_city,1/north_dakota/beulah,1/north_dakota/center,1/north_dakota/new_salem,1/knox_in,6/central,us/central,us/indiana-starke", "-5|n|03/12:03->11/05:01": "1/north_dakota", "-5|n": "1/bogota,1/cancun,1/cayman,1/coral_harbour,1/eirunepe,1/guayaquil,1/jamaica,1/panama,1/atikokan,jamaica", "-4|s|05/13:23->08/13:01": "12/palmer", "-4|s|04/02:24->09/04:00": "1/santiago,7/continental", "-4|s|03/26:24->10/02:00": "1/asuncion", "-4|s|02/16:24->11/03:00": "1/campo_grande,1/cuiaba", "-4|s": "1/la_paz,1/manaus,5/west", "-4|n|03/13:02->11/06:02": "1/detroit,1/grand_turk,1/indianapolis,1/iqaluit,1/louisville,1/montreal,1/nassau,1/new_york,1/nipigon,1/pangnirtung,1/port-au-prince,1/thunder_bay,1/toronto,1/indiana/marengo,1/indiana/petersburg,1/indiana/vevay,1/indiana/vincennes,1/indiana/winamac,1/kentucky/monticello,1/fort_wayne,1/indiana/indianapolis,1/kentucky/louisville,6/eastern,us/east-indiana,us/eastern,us/michigan", "-4|n|03/13:00->11/06:01": "1/havana,cuba", "-4|n|03/12:03->11/05:01": "1/indiana,1/kentucky", "-4|n": "1/anguilla,1/antigua,1/aruba,1/barbados,1/blanc-sablon,1/boa_vista,1/caracas,1/curacao,1/dominica,1/grenada,1/guadeloupe,1/guyana,1/kralendijk,1/lower_princes,1/marigot,1/martinique,1/montserrat,1/port_of_spain,1/porto_velho,1/puerto_rico,1/santo_domingo,1/st_barthelemy,1/st_kitts,1/st_lucia,1/st_thomas,1/st_vincent,1/tortola,1/virgin", "-3|s": "1/argentina,1/buenos_aires,1/catamarca,1/cordoba,1/fortaleza,1/jujuy,1/mendoza,1/montevideo,1/punta_arenas,1/sao_paulo,12/rothera,3/stanley,1/argentina/la_rioja,1/argentina/rio_gallegos,1/argentina/salta,1/argentina/san_juan,1/argentina/san_luis,1/argentina/tucuman,1/argentina/ushuaia,1/argentina/comodrivadavia,1/argentina/buenos_aires,1/argentina/catamarca,1/argentina/cordoba,1/argentina/jujuy,1/argentina/mendoza,1/argentina/rosario,1/rosario,5/east", "-3|n|03/13:02->11/06:02": "1/glace_bay,1/goose_bay,1/halifax,1/moncton,1/thule,3/bermuda,6/atlantic", "-3|n": "1/araguaina,1/bahia,1/belem,1/cayenne,1/maceio,1/paramaribo,1/recife,1/santarem", "-2|n|03/26:22->10/29:23": "1/nuuk,1/godthab", "-2|n|03/13:02->11/06:02": "1/miquelon", "-2|n": "1/noronha,3/south_georgia,5/denoronha", "-2.5|n|03/13:02->11/06:02": "1/st_johns,6/newfoundland", "-1|n": "3/cape_verde", "-11|n": "11/midway,11/niue,11/pago_pago,11/samoa,us/samoa", "-10|n": "11/honolulu,11/johnston,11/rarotonga,11/tahiti,us/hawaii" }, m_c = ["africa", "america", "asia", "atlantic", "australia", "brazil", "canada", "chile", "europe", "indian", "mexico", "pacific", "antarctica", "etc"];
let Rk = {};
Object.keys(p8).forEach((e) => {
  let t = e.split("|"), n = { offset: Number(t[0]), hem: t[1] };
  t[2] && (n.dst = t[2]), p8[e].split(",").forEach((o) => {
    o = o.replace(/(^[0-9]+)\//, (r, i) => (i = Number(i), m_c[i] + "/")), Rk[o] = n;
  });
}), Rk.utc = { offset: 0, hem: "n" };
for (let e = -14; e <= 14; e += 0.5) {
  let t = e;
  t > 0 && (t = "+" + t);
  let n = "etc/gmt" + t;
  Rk[n] = { offset: -1 * e, hem: "n" }, n = "utc/gmt" + t, Rk[n] = { offset: -1 * e, hem: "n" };
}
var Ple = Rk, f_c = () => {
  let e = (() => {
    if (typeof Intl > "u" || Intl.DateTimeFormat === void 0)
      return null;
    let t = Intl.DateTimeFormat();
    if (t === void 0 || t.resolvedOptions === void 0)
      return null;
    let n = t.resolvedOptions().timeZone;
    return n ? n.toLowerCase() : null;
  })();
  return e === null ? "utc" : e;
};
const g_c = /(\-?[0-9]+)h(rs)?/i, h_c = /(\-?[0-9]+)/, v_c = /utc([\-+]?[0-9]+)/i, b_c = /gmt([\-+]?[0-9]+)/i, PS = function(e) {
  return (e = Number(e)) >= -13 && e <= 13 ? "etc/gmt" + (e = ((e *= -1) > 0 ? "+" : "") + e) : null;
};
var y_c = function(e) {
  let t = e.match(g_c);
  if (t !== null || (t = e.match(v_c), t !== null))
    return PS(t[1]);
  if (t = e.match(b_c), t !== null) {
    let n = -1 * Number(t[1]);
    return PS(n);
  }
  return t = e.match(h_c), t !== null ? PS(t[1]) : null;
};
const $_c = f_c(), m8 = Object.keys(Ple).reduce((e, t) => {
  let n = t.split("/")[1] || "";
  return n = n.replace(/_/g, " "), e[n] = t, e;
}, {});
var nC = (e, t) => {
  if (!e)
    return $_c;
  typeof e != "string" && console.error("Timezone must be a string - recieved: '", e, `'
`);
  let n = e.trim();
  if (n = n.toLowerCase(), t.hasOwnProperty(n) === !0 || (n = ((o) => (o = (o = (o = (o = (o = o.replace(/ time/g, "")).replace(/ (standard|daylight|summer)/g, "")).replace(/\b(east|west|north|south)ern/g, "$1")).replace(/\b(africa|america|australia)n/g, "$1")).replace(/\beuropean/g, "europe")).replace(/\islands/g, "island"))(n), t.hasOwnProperty(n) === !0))
    return n;
  if (m8.hasOwnProperty(n) === !0)
    return m8[n];
  if (/[0-9]/.test(n) === !0) {
    let o = y_c(n);
    if (o)
      return o;
  }
  throw new Error("Spacetime: Cannot find timezone named: '" + e + "'. Please enter an IANA timezone id.");
};
function YT(e) {
  return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
}
function Dle(e) {
  return Object.prototype.toString.call(e) === "[object Date]" && !isNaN(e.valueOf());
}
function Ub(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Wo(e, t = 2) {
  return (e += "").length >= t ? e : new Array(t - e.length + 1).join("0") + e;
}
function Pm(e) {
  let t = e % 10, n = e % 100;
  return t === 1 && n !== 11 ? e + "st" : t === 2 && n !== 12 ? e + "nd" : t === 3 && n !== 13 ? e + "rd" : e + "th";
}
function Gb(e) {
  return e = (e = String(e)).replace(/([0-9])(st|nd|rd|th)$/i, "$1"), parseInt(e, 10);
}
function mv(e = "") {
  return (e = (e = (e = (e = e.toLowerCase().trim()).replace(/ies$/, "y")).replace(/s$/, "")).replace(/-/g, "")) === "day" || e === "days" ? "date" : e === "min" || e === "mins" ? "minute" : e;
}
function U$(e) {
  return typeof e == "number" ? e : Dle(e) ? e.getTime() : e.epoch ? e.epoch : null;
}
function Ah(e, t) {
  return Ub(e) === !1 ? t.clone().set(e) : e;
}
function xw(e, t = "") {
  const n = e > 0 ? "+" : "-", o = Math.abs(e);
  return `${n}${Wo(parseInt("" + o, 10))}${t}${Wo(o % 1 * 60)}`;
}
const bN = { year: (/* @__PURE__ */ new Date()).getFullYear(), month: 0, date: 1 };
var w_c = { parseArray: (e, t, n) => {
  if (t.length === 0)
    return e;
  let o = ["year", "month", "date", "hour", "minute", "second", "millisecond"];
  for (let r = 0; r < o.length; r++) {
    let i = t[r] || n[o[r]] || bN[o[r]] || 0;
    e = e[o[r]](i);
  }
  return e;
}, parseObject: (e, t, n) => {
  if (Object.keys(t).length === 0)
    return e;
  t = Object.assign({}, bN, n, t);
  let o = Object.keys(t);
  for (let r = 0; r < o.length; r++) {
    let i = o[r];
    if (e[i] === void 0 || typeof e[i] != "function" || t[i] === null || t[i] === void 0 || t[i] === "")
      continue;
    let a = t[i] || n[i] || bN[i] || 0;
    e = e[i](a);
  }
  return e;
}, parseNumber: function(e, t) {
  return t > 0 && t < 25e8 && e.silent === !1 && (console.warn("  - Warning: You are setting the date to January 1970."), console.warn("       -   did input seconds instead of milliseconds?")), e.epoch = t, e;
} };
const lh = function(e) {
  return e.epoch = Date.now(), Object.keys(e._today || {}).forEach((t) => {
    typeof e[t] == "function" && (e = e[t](e._today[t]));
  }), e;
}, d4 = { now: (e) => lh(e), today: (e) => lh(e), tonight: (e) => e = (e = lh(e)).hour(18), tomorrow: (e) => e = (e = (e = lh(e)).add(1, "day")).startOf("day"), yesterday: (e) => e = (e = (e = lh(e)).subtract(1, "day")).startOf("day"), christmas: (e) => {
  let t = lh(e).year();
  return e = e.set([t, 11, 25, 18, 0, 0]);
}, "new years": (e) => {
  let t = lh(e).year();
  return e = e.set([t, 11, 31, 18, 0, 0]);
} };
d4["new years eve"] = d4["new years"];
var f8 = d4, k_c = function(e) {
  return e = (e = (e = (e = e.replace(/\b(mon|tues?|wed|wednes|thur?s?|fri|sat|satur|sun)(day)?\b/i, "")).replace(/([0-9])(th|rd|st|nd)/, "$1")).replace(/,/g, "")).replace(/ +/g, " ").trim();
};
let Km = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5 };
Km.date = Km.day, Km.month = 25488e5, Km.week = 6048e5, Km.year = 3154e7, Object.keys(Km).forEach((e) => {
  Km[e + "s"] = Km[e];
});
var js = Km;
const DS = (e, t, n, o, r) => {
  let i = e.d[n]();
  if (i === t)
    return;
  let a = r === null ? null : e.d[r](), s = e.epoch, c = t - i;
  e.epoch += js[o] * c, o === "day" && Math.abs(c) > 28 && t < 28 && (e.epoch += js.hour), r !== null && a !== e.d[r]() && (e.epoch = s);
  const l = js[o] / 2;
  for (; e.d[n]() < t; )
    e.epoch += l;
  for (; e.d[n]() > t; )
    e.epoch -= l;
  r !== null && a !== e.d[r]() && (e.epoch = s);
}, yN = { year: { valid: (e) => e > -4e3 && e < 4e3, walkTo: (e, t) => DS(e, t, "getFullYear", "year", null) }, month: { valid: (e) => e >= 0 && e <= 11, walkTo: (e, t) => {
  let n = e.d, o = n.getMonth(), r = e.epoch, i = n.getFullYear();
  if (o === t)
    return;
  let a = t - o;
  for (e.epoch += js.day * (28 * a), i !== e.d.getFullYear() && (e.epoch = r); e.d.getMonth() < t; )
    e.epoch += js.day;
  for (; e.d.getMonth() > t; )
    e.epoch -= js.day;
} }, date: { valid: (e) => e > 0 && e <= 31, walkTo: (e, t) => DS(e, t, "getDate", "day", "getMonth") }, hour: { valid: (e) => e >= 0 && e < 24, walkTo: (e, t) => DS(e, t, "getHours", "hour", "getDate") }, minute: { valid: (e) => e >= 0 && e < 60, walkTo: (e, t) => DS(e, t, "getMinutes", "minute", "getHours") }, second: { valid: (e) => e >= 0 && e < 60, walkTo: (e, t) => {
  e.epoch = e.seconds(t).epoch;
} }, millisecond: { valid: (e) => e >= 0 && e < 1e3, walkTo: (e, t) => {
  e.epoch = e.milliseconds(t).epoch;
} } };
var _i = (e, t) => {
  let n = Object.keys(yN), o = e.clone();
  for (let r = 0; r < n.length; r++) {
    let i = n[r], a = t[i];
    if (a === void 0 && (a = o[i]()), typeof a == "string" && (a = parseInt(a, 10)), !yN[i].valid(a))
      return e.epoch = null, void (e.silent === !1 && console.warn("invalid " + i + ": " + a));
    yN[i].walkTo(e, a);
  }
}, fv = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
let Pk = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"], Dk = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function G$() {
  return Pk;
}
function Lle() {
  return function() {
    const e = { sep: 8 };
    for (let t = 0; t < Pk.length; t++)
      e[Pk[t]] = t;
    for (let t = 0; t < Dk.length; t++)
      e[Dk[t]] = t;
    return e;
  }();
}
var S_c = (e, t) => {
  if (!t)
    return e;
  let n = 0;
  if (/^[\+-]?[0-9]{2}:[0-9]{2}$/.test(t) && (/:00/.test(t) === !0 && (t = t.replace(/:00/, "")), /:30/.test(t) === !0 && (t = t.replace(/:30/, ".5"))), /^[\+-]?[0-9]{4}$/.test(t) && (t = t.replace(/30$/, ".5")), n = parseFloat(t), Math.abs(n) > 100 && (n /= 100), n === 0 || t === "Z" || t === "z")
    return e.tz = "etc/gmt", e;
  n *= -1, n >= 0 && (n = "+" + n);
  let o = "etc/gmt" + n;
  return e.timezones[o] && (e.tz = o), e;
}, fl = (e, t = "") => {
  let n = (t = t.replace(/^\s+/, "").toLowerCase()).match(/([0-9]{1,2}):([0-9]{1,2}):?([0-9]{1,2})?[:\.]?([0-9]{1,4})?/);
  if (n !== null) {
    let o = Number(n[1]);
    if (o < 0 || o > 24)
      return e.startOf("day");
    let r = Number(n[2]);
    if (n[2].length < 2 || r < 0 || r > 59)
      return e.startOf("day");
    e = e.hour(o), e = e.minute(r), e = (e = e.seconds(n[3] || 0)).millisecond(function(a = "") {
      return (a = String(a)).length > 3 ? a = a.substr(0, 3) : a.length === 1 ? a += "00" : a.length === 2 && (a += "0"), Number(a) || 0;
    }(n[4]));
    let i = t.match(/[\b0-9] ?(am|pm)\b/);
    return i !== null && i[1] && (e = e.ampm(i[1])), e;
  }
  if (n = t.match(/([0-9]+) ?(am|pm)/), n !== null && n[1]) {
    let o = Number(n[1]);
    return o > 12 || o < 1 ? e.startOf("day") : e = (e = (e = e.hour(n[1] || 0)).ampm(n[2])).startOf("hour");
  }
  return e = e.startOf("day");
};
let g8 = Lle();
const gl = (e) => {
  if (fv.hasOwnProperty(e.month) !== !0)
    return !1;
  if (e.month === 1)
    return !!(YT(e.year) && e.date <= 29) || e.date <= 28;
  let t = fv[e.month] || 0;
  return e.date <= t;
}, nf = (e = "", t) => {
  if (e = e.trim(), /^'[0-9][0-9]$/.test(e) === !0) {
    let o = Number(e.replace(/'/, ""));
    return o > 50 ? 1900 + o : 2e3 + o;
  }
  let n = parseInt(e, 10);
  return !n && t && (n = t.year), n = n || (/* @__PURE__ */ new Date()).getFullYear(), n;
}, yg = function(e) {
  return (e = e.toLowerCase().trim()) === "sept" ? g8.sep : g8[e];
};
var E_c = [{ reg: /^(\-?0?0?[0-9]{3,4})-([0-9]{1,2})-([0-9]{1,2})[T| ]([0-9.:]+)(Z|[0-9\-\+:]+)?$/i, parse: (e, t) => {
  let n = { year: t[1], month: parseInt(t[2], 10) - 1, date: t[3] };
  return gl(n) === !1 ? (e.epoch = null, e) : (S_c(e, t[5]), _i(e, n), e = fl(e, t[4]));
} }, { reg: /^([0-9]{4})[\-\/\. ]([0-9]{1,2})[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { year: t[1], month: parseInt(t[2], 10) - 1, date: parseInt(t[3], 10) };
  return n.month >= 12 && (n.date = parseInt(t[2], 10), n.month = parseInt(t[3], 10) - 1), gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }, { reg: /^([0-9]{4})[\-\/\. ]([a-z]+)[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { year: nf(t[1], e._today), month: yg(t[2]), date: Gb(t[3] || "") };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }], x_c = [{ reg: /^([0-9]{1,2})[\-\/.]([0-9]{1,2})[\-\/.]?([0-9]{4})?( [0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i, parse: (e, t) => {
  let n = parseInt(t[1], 10) - 1, o = parseInt(t[2], 10);
  (e.british || n >= 12) && (o = parseInt(t[1], 10), n = parseInt(t[2], 10) - 1);
  let r = { date: o, month: n, year: nf(t[3], e._today) || (/* @__PURE__ */ new Date()).getFullYear() };
  return gl(r) === !1 ? (e.epoch = null, e) : (_i(e, r), e = fl(e, t[4]));
} }, { reg: /^([a-z]+)[\-\/\. ]([0-9]{1,2})[\-\/\. ]?([0-9]{4}|'[0-9]{2})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { year: nf(t[3], e._today), month: yg(t[1]), date: Gb(t[2] || "") };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }, { reg: /^([a-z]+) ([0-9]{1,2})( [0-9]{4})?( ([0-9:]+( ?am| ?pm| ?gmt)?))?$/i, parse: (e, t) => {
  let n = { year: nf(t[3], e._today), month: yg(t[1]), date: Gb(t[2] || "") };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }, { reg: /^([a-z]+) ([0-9]{1,2})( [0-9:]+)?( \+[0-9]{4})?( [0-9]{4})?$/i, parse: (e, t) => {
  let n = { year: nf(t[5], e._today), month: yg(t[1]), date: Gb(t[2] || "") };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[3]));
} }], C_c = [{ reg: /^([0-9]{1,2})[\-\/]([a-z]+)[\-\/]?([0-9]{4})?$/i, parse: (e, t) => {
  let n = { year: nf(t[3], e._today), month: yg(t[2]), date: Gb(t[1] || "") };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }, { reg: /^([0-9]{1,2})( [a-z]+)( [0-9]{4}| '[0-9]{2})? ?([0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i, parse: (e, t) => {
  let n = { year: nf(t[3], e._today), month: yg(t[2]), date: Gb(t[1]) };
  return n.month && gl(n) !== !1 ? (_i(e, n), e = fl(e, t[4])) : (e.epoch = null, e);
} }, { reg: /^([0-9]{1,2})[\. -/]([a-z]+)[\. -/]([0-9]{4})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { date: Number(t[1]), month: yg(t[2]), year: Number(t[3]) };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = e.startOf("day"), e = fl(e, t[4]));
} }], T_c = [{ reg: /^([0-9]{4})[\-\/]([0-9]{2})$/i, parse: (e, t) => {
  let n = { year: t[1], month: parseInt(t[2], 10) - 1, date: 1 };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }, { reg: /^([a-z]+) ([0-9]{4})$/i, parse: (e, t) => {
  let n = { year: nf(t[2], e._today), month: yg(t[1]), date: e._today.date || 1 };
  return gl(n) === !1 ? (e.epoch = null, e) : (_i(e, n), e = fl(e, t[4]));
} }, { reg: /^(q[0-9])( of)?( [0-9]{4})?/i, parse: (e, t) => {
  let n = t[1] || "";
  e = e.quarter(n);
  let o = t[3] || "";
  return o && (o = o.trim(), e = e.year(o)), e;
} }, { reg: /^(spring|summer|winter|fall|autumn)( of)?( [0-9]{4})?/i, parse: (e, t) => {
  let n = t[1] || "";
  e = e.season(n);
  let o = t[3] || "";
  return o && (o = o.trim(), e = e.year(o)), e;
} }, { reg: /^[0-9,]+ ?b\.?c\.?$/i, parse: (e, t) => {
  let n = t[0] || "";
  n = n.replace(/^([0-9,]+) ?b\.?c\.?$/i, "-$1");
  let o = /* @__PURE__ */ new Date(), r = { year: parseInt(n.trim(), 10), month: o.getMonth(), date: o.getDate() };
  return gl(r) === !1 ? (e.epoch = null, e) : (_i(e, r), e = fl(e));
} }, { reg: /^[0-9,]+ ?(a\.?d\.?|c\.?e\.?)$/i, parse: (e, t) => {
  let n = t[0] || "";
  n = n.replace(/,/g, "");
  let o = /* @__PURE__ */ new Date(), r = { year: parseInt(n.trim(), 10), month: o.getMonth(), date: o.getDate() };
  return gl(r) === !1 ? (e.epoch = null, e) : (_i(e, r), e = fl(e));
} }, { reg: /^[0-9]{4}( ?a\.?d\.?)?$/i, parse: (e, t) => {
  let n = e._today;
  n.month && !n.date && (n.date = 1);
  let o = /* @__PURE__ */ new Date(), r = { year: nf(t[0], n), month: n.month || o.getMonth(), date: n.date || o.getDate() };
  return gl(r) === !1 ? (e.epoch = null, e) : (_i(e, r), e = fl(e));
} }], $N = [].concat(E_c, x_c, C_c, T_c), A_c = function(e, t, n) {
  for (let o = 0; o < $N.length; o++) {
    let r = t.match($N[o].reg);
    if (r) {
      let i = $N[o].parse(e, r, n);
      if (i !== null && i.isValid())
        return i;
    }
  }
  return e.silent === !1 && console.warn("Warning: couldn't parse date-string: '" + t + "'"), e.epoch = null, e;
};
const { parseArray: I_c, parseObject: h8, parseNumber: O_c } = w_c, v8 = { year: (/* @__PURE__ */ new Date()).getFullYear(), month: 0, date: 1 };
var Mle = (e, t) => {
  let n = e._today || v8;
  if (typeof t == "number")
    return O_c(e, t);
  if (e.epoch = Date.now(), e._today && Ub(e._today) && Object.keys(e._today).length > 0) {
    let o = h8(e, n, v8);
    o.isValid() && (e.epoch = o.epoch);
  }
  return t == null || t === "" ? e : Dle(t) === !0 ? (e.epoch = t.getTime(), e) : function(o) {
    return Object.prototype.toString.call(o) === "[object Array]";
  }(t) === !0 ? e = I_c(e, t, n) : Ub(t) === !0 ? t.epoch ? (e.epoch = t.epoch, e.tz = t.tz, e) : e = h8(e, t, n) : typeof t != "string" ? e : (t = k_c(t), f8.hasOwnProperty(t) === !0 ? e = f8[t](e) : A_c(e, t));
};
let _4 = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], p4 = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
function Lk() {
  return _4;
}
function oC() {
  return p4;
}
const b8 = { mo: 1, tu: 2, we: 3, th: 4, fr: 5, sa: 6, su: 7, tues: 2, weds: 3, wedn: 3, thur: 4, thurs: 4 };
let Fle = !0;
var y8 = (e) => {
  let t = e.timezone().current.offset;
  return t ? xw(t, ":") : "Z";
};
const Zm = (e) => Fle ? function(t) {
  return t ? t[0].toUpperCase() + t.substr(1) : "";
}(e) : e, xb = { day: (e) => Zm(e.dayName()), "day-short": (e) => Zm(Lk()[e.day()]), "day-number": (e) => e.day(), "day-ordinal": (e) => Pm(e.day()), "day-pad": (e) => Wo(e.day()), date: (e) => e.date(), "date-ordinal": (e) => Pm(e.date()), "date-pad": (e) => Wo(e.date()), month: (e) => Zm(e.monthName()), "month-short": (e) => Zm(G$()[e.month()]), "month-number": (e) => e.month(), "month-ordinal": (e) => Pm(e.month()), "month-pad": (e) => Wo(e.month()), "iso-month": (e) => Wo(e.month() + 1), year: (e) => {
  let t = e.year();
  return t > 0 ? t : (t = Math.abs(t), t + " BC");
}, "year-short": (e) => {
  let t = e.year();
  return t > 0 ? `'${String(e.year()).substr(2, 4)}` : (t = Math.abs(t), t + " BC");
}, "iso-year": (e) => {
  let t = e.year(), n = t < 0, o = Wo(Math.abs(t), 4);
  return n && (o = Wo(o, 6), o = "-" + o), o;
}, time: (e) => e.time(), "time-24": (e) => `${e.hour24()}:${Wo(e.minute())}`, hour: (e) => e.hour12(), "hour-pad": (e) => Wo(e.hour12()), "hour-24": (e) => e.hour24(), "hour-24-pad": (e) => Wo(e.hour24()), minute: (e) => e.minute(), "minute-pad": (e) => Wo(e.minute()), second: (e) => e.second(), "second-pad": (e) => Wo(e.second()), millisecond: (e) => e.millisecond(), "millisecond-pad": (e) => Wo(e.millisecond(), 3), ampm: (e) => e.ampm(), quarter: (e) => "Q" + e.quarter(), season: (e) => e.season(), era: (e) => e.era(), json: (e) => e.json(), timezone: (e) => e.timezone().name, offset: (e) => y8(e), numeric: (e) => `${e.year()}/${Wo(e.month() + 1)}/${Wo(e.date())}`, "numeric-us": (e) => `${Wo(e.month() + 1)}/${Wo(e.date())}/${e.year()}`, "numeric-uk": (e) => `${Wo(e.date())}/${Wo(e.month() + 1)}/${e.year()}`, "mm/dd": (e) => `${Wo(e.month() + 1)}/${Wo(e.date())}`, iso: (e) => `${e.format("iso-year")}-${Wo(e.month() + 1)}-${Wo(e.date())}T${Wo(e.h24())}:${Wo(e.minute())}:${Wo(e.second())}.${Wo(e.millisecond(), 3)}${y8(e)}`, "iso-short": (e) => {
  let t = Wo(e.month() + 1), n = Wo(e.date());
  var o;
  return `${(o = e.year()) >= 0 ? Wo(o, 4) : "-" + Wo(o = Math.abs(o), 4)}-${t}-${n}`;
}, "iso-utc": (e) => new Date(e.epoch).toISOString(), nice: (e) => `${G$()[e.month()]} ${Pm(e.date())}, ${e.time()}`, "nice-24": (e) => `${G$()[e.month()]} ${Pm(e.date())}, ${e.hour24()}:${Wo(e.minute())}`, "nice-year": (e) => `${G$()[e.month()]} ${Pm(e.date())}, ${e.year()}`, "nice-day": (e) => `${Lk()[e.day()]} ${Zm(G$()[e.month()])} ${Pm(e.date())}`, "nice-full": (e) => `${e.dayName()} ${Zm(e.monthName())} ${Pm(e.date())}, ${e.time()}`, "nice-full-24": (e) => `${e.dayName()} ${Zm(e.monthName())} ${Pm(e.date())}, ${e.hour24()}:${Wo(e.minute())}` }, $8 = { "day-name": "day", "month-name": "month", "iso 8601": "iso", "time-h24": "time-24", "time-12": "time", "time-h12": "time", tz: "timezone", "day-num": "day-number", "month-num": "month-number", "month-iso": "iso-month", "year-iso": "iso-year", "nice-short": "nice", "nice-short-24": "nice-24", mdy: "numeric-us", dmy: "numeric-uk", ymd: "numeric", "yyyy/mm/dd": "numeric", "mm/dd/yyyy": "numeric-us", "dd/mm/yyyy": "numeric-us", "little-endian": "numeric-uk", "big-endian": "numeric", "day-nice": "nice-day" };
Object.keys($8).forEach((e) => xb[e] = xb[$8[e]]);
var wN = (e, t = "") => {
  if (e.isValid() !== !0)
    return "";
  if (xb.hasOwnProperty(t)) {
    let n = xb[t](e) || "";
    return t !== "json" && (n = String(n), t !== "ampm" && (n = Zm(n))), n;
  }
  if (t.indexOf("{") !== -1) {
    let n = /\{(.+?)\}/g;
    return t = t.replace(n, (o, r) => {
      if (r = r.toLowerCase().trim(), xb.hasOwnProperty(r)) {
        let i = String(xb[r](e));
        return r !== "ampm" ? Zm(i) : i;
      }
      return "";
    }), t;
  }
  return e.format("iso-short");
};
const rC = { G: (e) => e.era(), GG: (e) => e.era(), GGG: (e) => e.era(), GGGG: (e) => e.era() === "AD" ? "Anno Domini" : "Before Christ", y: (e) => e.year(), yy: (e) => Wo(Number(String(e.year()).substr(2, 4))), yyy: (e) => e.year(), yyyy: (e) => e.year(), yyyyy: (e) => "0" + e.year(), Q: (e) => e.quarter(), QQ: (e) => e.quarter(), QQQ: (e) => e.quarter(), QQQQ: (e) => e.quarter(), M: (e) => e.month() + 1, MM: (e) => Wo(e.month() + 1), MMM: (e) => e.format("month-short"), MMMM: (e) => e.format("month"), w: (e) => e.week(), ww: (e) => Wo(e.week()), d: (e) => e.date(), dd: (e) => Wo(e.date()), D: (e) => e.dayOfYear(), DD: (e) => Wo(e.dayOfYear()), DDD: (e) => Wo(e.dayOfYear(), 3), E: (e) => e.format("day-short"), EE: (e) => e.format("day-short"), EEE: (e) => e.format("day-short"), EEEE: (e) => e.format("day"), EEEEE: (e) => e.format("day")[0], e: (e) => e.day(), ee: (e) => e.day(), eee: (e) => e.format("day-short"), eeee: (e) => e.format("day"), eeeee: (e) => e.format("day")[0], a: (e) => e.ampm().toUpperCase(), aa: (e) => e.ampm().toUpperCase(), aaa: (e) => e.ampm().toUpperCase(), aaaa: (e) => e.ampm().toUpperCase(), h: (e) => e.h12(), hh: (e) => Wo(e.h12()), H: (e) => e.hour(), HH: (e) => Wo(e.hour()), m: (e) => e.minute(), mm: (e) => Wo(e.minute()), s: (e) => e.second(), ss: (e) => Wo(e.second()), SSS: (e) => Wo(e.millisecond(), 3), A: (e) => e.epoch - e.startOf("day").epoch, z: (e) => e.timezone().name, zz: (e) => e.timezone().name, zzz: (e) => e.timezone().name, zzzz: (e) => e.timezone().name, Z: (e) => xw(e.timezone().current.offset), ZZ: (e) => xw(e.timezone().current.offset), ZZZ: (e) => xw(e.timezone().current.offset), ZZZZ: (e) => xw(e.timezone().current.offset, ":") }, Dm = (e, t, n) => {
  let o = e, r = t;
  for (let i = 0; i < n; i += 1)
    rC[o] = rC[r], o += e, r += t;
};
Dm("q", "Q", 4), Dm("L", "M", 4), Dm("Y", "y", 4), Dm("c", "e", 4), Dm("k", "H", 2), Dm("K", "h", 2), Dm("S", "s", 2), Dm("v", "z", 4), Dm("V", "Z", 4);
var N_c = (e, t) => {
  let n = t.split("");
  return n = function(o) {
    for (let r = 0; r < o.length; r += 1)
      if (o[r] === "'")
        for (let i = r + 1; i < o.length; i += 1) {
          if (o[i] && (o[r] += o[i]), o[i] === "'") {
            o[i] = null;
            break;
          }
          o[i] = null;
        }
    return o.filter((r) => r);
  }(n), n = function(o) {
    for (let r = 0; r < o.length; r += 1) {
      let i = o[r];
      for (let a = r + 1; a < o.length && o[a] === i; a += 1)
        o[r] += o[a], o[a] = null;
    }
    return (o = o.filter((r) => r)).map((r) => (r === "''" && (r = "'"), r));
  }(n), n.reduce((o, r) => (rC[r] !== void 0 ? o += rC[r](e) || "" : (/^'.{1,}'$/.test(r) && (r = r.replace(/'/g, "")), o += r), o), "");
};
const z_c = ["year", "season", "quarter", "month", "week", "day", "quarterHour", "hour", "minute"], w8 = function(e, t) {
  let n = e.clone().startOf(t), o = e.clone().endOf(t).epoch - n.epoch, r = (e.epoch - n.epoch) / o;
  return parseFloat(r.toFixed(2));
};
var R_c = (e, t) => {
  if (t)
    return t = mv(t), w8(e, t);
  let n = {};
  return z_c.forEach((o) => {
    n[o] = w8(e, o);
  }), n;
}, P_c = (e, t) => {
  let n = e.progress();
  return (t = mv(t)) === "quarterhour" && (t = "quarterHour"), n[t] !== void 0 ? (n[t] > 0.5 && (e = e.add(1, t)), e = e.startOf(t)) : e.silent === !1 && console.warn("no known unit '" + t + "'"), e;
};
const k8 = (e, t, n) => {
  let o = 0;
  for (e = e.clone(); e.isBefore(t); )
    e = e.add(1, n), o += 1;
  return e.isAfter(t, n) && (o -= 1), o;
};
var kN = (e, t, n) => e.isBefore(t) ? k8(e, t, n) : -1 * k8(t, e, n), D_c = function(e, t) {
  let n = t.epoch - e.epoch, o = { milliseconds: n, seconds: parseInt(n / 1e3, 10) };
  o.minutes = parseInt(o.seconds / 60, 10), o.hours = parseInt(o.minutes / 60, 10);
  let r = e.clone();
  return o.years = ((i, a) => {
    let s = a.year() - i.year();
    return (i = i.year(a.year())).isAfter(a) && (s -= 1), s;
  })(r, t), r = e.add(o.years, "year"), o.months = 12 * o.years, r = e.add(o.months, "month"), o.months += kN(r, t, "month"), o.weeks = 52 * o.years, r = e.add(o.weeks, "week"), o.weeks += kN(r, t, "week"), o.days = 7 * o.weeks, r = e.add(o.days, "day"), o.days += kN(r, t, "day"), o;
}, L_c = function(e, t, n) {
  t = Ah(t, e);
  let o = !1;
  if (e.isAfter(t)) {
    let i = e;
    e = t, t = i, o = !0;
  }
  let r = D_c(e, t);
  return o && (r = function(i) {
    return Object.keys(i).forEach((a) => {
      i[a] *= -1;
    }), i;
  }(r)), n ? (n = mv(n), /s$/.test(n) !== !0 && (n += "s"), n === "dates" && (n = "days"), r[n]) : r;
};
const sb = (e) => Math.abs(e) || 0;
var M_c = function(e) {
  let t = "P";
  return t += sb(e.years) + "Y", t += sb(e.months) + "M", t += sb(e.days) + "DT", t += sb(e.hours) + "H", t += sb(e.minutes) + "M", t += sb(e.seconds) + "S", t;
};
const S8 = { months: { almost: 10, over: 4 }, days: { almost: 25, over: 10 }, hours: { almost: 20, over: 8 }, minutes: { almost: 50, over: 20 }, seconds: { almost: 50, over: 20 } };
function E8(e, t) {
  return e === 1 && (t = t.slice(0, -1)), e + " " + t;
}
var F_c = function(e) {
  let t = null, n = null, o = [], r = [];
  return Object.keys(e).forEach((i, a, s) => {
    const c = Math.abs(e[i]);
    if (c === 0)
      return;
    o.push(c + i[0]);
    const l = E8(c, i);
    if (r.push(l), !t) {
      if (t = n = l, a > 4)
        return;
      const u = s[a + 1], d = Math.abs(e[u]);
      d > S8[u].almost ? (t = E8(c + 1, i), n = "almost " + t) : d > S8[u].over && (n = "over " + l);
    }
  }), { qualified: n, rounded: t, abbreviated: o, englishValues: r };
}, q_c = (e, t) => {
  const n = function(d, _) {
    const p = d.isBefore(_), g = p ? _ : d;
    let f = p ? d : _;
    f = f.clone();
    const h = { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    return Object.keys(h).forEach(($) => {
      if (f.isSame(g, $))
        return;
      let v = f.diff(g, $);
      f = f.add(v, $), h[$] = v;
    }), p && Object.keys(h).forEach(($) => {
      h[$] !== 0 && (h[$] *= -1);
    }), h;
  }(e, t = Ah(t, e));
  if (Object.keys(n).every((d) => !n[d]) === !0)
    return { diff: n, rounded: "now", qualified: "now", precise: "now", abbreviated: [], iso: "P0Y0M0DT0H0M0S", direction: "present" };
  let r, i = "future", { rounded: a, qualified: s, englishValues: c, abbreviated: l } = F_c(n);
  r = c.splice(0, 2).join(", "), e.isAfter(t) === !0 ? (a += " ago", s += " ago", r += " ago", i = "past") : (a = "in " + a, s = "in " + s, r = "in " + r);
  let u = M_c(n);
  return { diff: n, rounded: a, qualified: s, precise: r, abbreviated: l, iso: u, direction: i };
}, x_ = { north: [["spring", 2, 1], ["summer", 5, 1], ["fall", 8, 1], ["autumn", 8, 1], ["winter", 11, 1]], south: [["fall", 2, 1], ["autumn", 2, 1], ["winter", 5, 1], ["spring", 8, 1], ["summer", 11, 1]] }, Lh = [null, [0, 1], [3, 1], [6, 1], [9, 1]];
const Ih = { minute: (e) => (_i(e, { second: 0, millisecond: 0 }), e), quarterhour: (e) => {
  let t = e.minutes();
  return e = t >= 45 ? e.minutes(45) : t >= 30 ? e.minutes(30) : t >= 15 ? e.minutes(15) : e.minutes(0), _i(e, { second: 0, millisecond: 0 }), e;
}, hour: (e) => (_i(e, { minute: 0, second: 0, millisecond: 0 }), e), day: (e) => (_i(e, { hour: 0, minute: 0, second: 0, millisecond: 0 }), e), week: (e) => {
  let t = e.clone();
  return (e = e.day(e._weekStart)).isAfter(t) && (e = e.subtract(1, "week")), _i(e, { hour: 0, minute: 0, second: 0, millisecond: 0 }), e;
}, month: (e) => (_i(e, { date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }), e), quarter: (e) => {
  let t = e.quarter();
  return Lh[t] && _i(e, { month: Lh[t][0], date: Lh[t][1], hour: 0, minute: 0, second: 0, millisecond: 0 }), e;
}, season: (e) => {
  let t = e.season(), n = "north";
  e.hemisphere() === "South" && (n = "south");
  for (let o = 0; o < x_[n].length; o++)
    if (x_[n][o][0] === t) {
      let r = e.year();
      return t === "winter" && e.month() < 3 && (r -= 1), _i(e, { year: r, month: x_[n][o][1], date: x_[n][o][2], hour: 0, minute: 0, second: 0, millisecond: 0 }), e;
    }
  return e;
}, year: (e) => (_i(e, { month: 0, date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }), e), decade: (e) => {
  let t = (e = e.startOf("year")).year(), n = 10 * parseInt(t / 10, 10);
  return e = e.year(n);
}, century: (e) => {
  let t = (e = e.startOf("year")).year(), n = 100 * parseInt(t / 100, 10);
  return e = e.year(n);
} };
Ih.date = Ih.day;
var j_c = function(e, t, n) {
  if (!t || !n)
    return [];
  if (t = mv(t), n = e.clone().set(n), e.isAfter(n)) {
    let i = e;
    e = n, n = i;
  }
  let o = e.clone();
  (function(i) {
    return !!Lk().find((a) => a === i) || !!oC().find((a) => a === i);
  })(t) ? (o = o.next(t), t = "week") : o.startOf(t).isBefore(e) && (o = o.next(t));
  let r = [];
  for (; o.isBefore(n); )
    r.push(o), o = o.add(1, t);
  return r;
}, W$ = (e) => {
  let t = e.timezones, n = e.tz;
  if (t.hasOwnProperty(n) === !1 && (n = nC(e.tz, t)), n === null)
    return e.silent === !1 && console.warn("Warn: could not find given or local timezone - '" + e.tz + "'"), { current: { epochShift: 0 } };
  let o = t[n], r = { name: (i = n, i = (i = (i = i[0].toUpperCase() + i.substr(1)).replace(/\/gmt/, "/GMT")).replace(/[\/_]([a-z])/gi, (l) => l.toUpperCase()), i), hasDst: !!o.dst, default_offset: o.offset, hemisphere: o.hem === "s" ? "South" : "North", current: {} };
  var i, a;
  if (r.hasDst) {
    let l = (a = o.dst) ? a.split("->") : [];
    r.change = { start: l[0], back: l[1] };
  }
  let s = o.offset, c = s;
  return r.hasDst === !0 && (c = r.hemisphere === "North" ? s - 1 : o.offset + 1), r.hasDst === !1 ? (r.current.offset = s, r.current.isDST = !1) : Rle(e.epoch, r.change.start, r.change.back, s, c) === !0 ? (r.current.offset = s, r.current.isDST = r.hemisphere === "North") : (r.current.offset = c, r.current.isDST = r.hemisphere === "South"), r;
};
const V_c = ["century", "decade", "year", "month", "date", "day", "hour", "minute", "second", "millisecond"], Sh = { set: function(e, t) {
  let n = this.clone();
  return n = Mle(n, e), t && (this.tz = nC(t)), n;
}, timezone: function() {
  return W$(this);
}, isDST: function() {
  return W$(this).current.isDST;
}, hasDST: function() {
  return W$(this).hasDst;
}, offset: function() {
  return 60 * W$(this).current.offset;
}, hemisphere: function() {
  return W$(this).hemisphere;
}, format: function(e) {
  return wN(this, e);
}, unixFmt: function(e) {
  return N_c(this, e);
}, startOf: function(e) {
  return ((t, n) => {
    let o = t.clone();
    return n = mv(n), Ih[n] ? Ih[n](o) : n === "summer" || n === "winter" ? (o = o.season(n), Ih.season(o)) : o;
  })(this, e);
}, endOf: function(e) {
  return ((t, n) => {
    let o = t.clone();
    return n = mv(n), Ih[n] && (o = Ih[n](o), o = o.add(1, n), o = o.subtract(1, "millisecond")), o;
  })(this, e);
}, leapYear: function() {
  return YT(this.year());
}, progress: function(e) {
  return R_c(this, e);
}, nearest: function(e) {
  return P_c(this, e);
}, diff: function(e, t) {
  return L_c(this, e, t);
}, since: function(e) {
  return e || (e = this.clone().set()), q_c(this, e);
}, next: function(e) {
  return this.add(1, e).startOf(e);
}, last: function(e) {
  return this.subtract(1, e).startOf(e);
}, isValid: function() {
  return !(!this.epoch && this.epoch !== 0) && !isNaN(this.d.getTime());
}, goto: function(e) {
  let t = this.clone();
  return t.tz = nC(e, t.timezones), t;
}, every: function(e, t) {
  if (typeof e == "object" && typeof t == "string") {
    let n = t;
    t = e, e = n;
  }
  return j_c(this, e, t);
}, isAwake: function() {
  let e = this.hour();
  return !(e < 8 || e > 22);
}, isAsleep: function() {
  return !this.isAwake();
}, daysInMonth: function() {
  switch (this.month()) {
    case 0:
    case 2:
    case 4:
    case 6:
    case 7:
    case 9:
    case 11:
      return 31;
    case 1:
      return this.leapYear() ? 29 : 28;
    case 3:
    case 5:
    case 8:
    case 10:
      return 30;
    default:
      throw new Error("Invalid Month state.");
  }
}, log: function() {
  return console.log(""), console.log(wN(this, "nice-short")), this;
}, logYear: function() {
  return console.log(""), console.log(wN(this, "full-short")), this;
}, json: function() {
  return V_c.reduce((e, t) => (e[t] = this[t](), e), {});
}, debug: function() {
  let e = this.timezone(), t = this.format("MM") + " " + this.format("date-ordinal") + " " + this.year();
  return t += `
     - ` + this.format("time"), console.log(`

`, t + `
     - ` + e.name + " (" + e.current.offset + ")"), this;
}, from: function(e) {
  return (e = this.clone().set(e)).since(this);
}, fromNow: function() {
  return this.clone().set(Date.now()).since(this);
}, weekStart: function(e) {
  if (typeof e == "number")
    return this._weekStart = e, this;
  if (typeof e == "string") {
    e = e.toLowerCase().trim();
    let t = Lk().indexOf(e);
    t === -1 && (t = oC().indexOf(e)), t === -1 && (t = 1), this._weekStart = t;
  } else
    console.warn("Spacetime Error: Cannot understand .weekStart() input:", e);
  return this;
} };
Sh.inDST = Sh.isDST, Sh.round = Sh.nearest, Sh.each = Sh.every;
var x8 = Sh;
const df = (e) => (typeof e == "string" && (e = parseInt(e, 10)), e), SN = ["year", "month", "date", "hour", "minute", "second", "millisecond"], NF = (e, t, n) => {
  let o = SN.indexOf(n), r = SN.slice(o, SN.length);
  for (let i = 0; i < r.length; i++) {
    let a = t[r[i]]();
    e[r[i]](a);
  }
  return e;
}, $g = function(e, t, n, o) {
  return n === !0 && e.isBefore(t) ? e = e.add(1, o) : n === !1 && e.isAfter(t) && (e = e.minus(1, o)), e;
}, C8 = function(e, t, n) {
  t = df(t);
  let o = e.clone(), r = (e.minute() - t) * js.minute;
  return e.epoch -= r, NF(e, o, "second"), (e = $g(e, o, n, "hour")).epoch;
}, EN = function(e, t, n) {
  (t = df(t)) >= 24 ? t = 24 : t < 0 && (t = 0);
  let o = e.clone(), r = e.hour() - t, i = r * js.hour;
  return e.epoch -= i, e.date() !== o.date() && (e = o.clone(), r > 1 && (r -= 1), r < 1 && (r += 1), i = r * js.hour, e.epoch -= i), _i(e, { hour: t }), NF(e, o, "minute"), (e = $g(e, o, n, "day")).epoch;
}, xN = function(e, t) {
  return typeof t == "string" && /^'[0-9]{2}$/.test(t) && (t = t.replace(/'/, "").trim(), t = (t = Number(t)) > 30 ? 1900 + t : 2e3 + t), t = df(t), _i(e, { year: t }), e.epoch;
};
let m4 = "am", f4 = "pm";
const B_c = { millisecond: function(e) {
  if (e !== void 0) {
    let t = this.clone();
    return t.epoch = function(n, o) {
      o = df(o);
      let r = n.millisecond() - o;
      return n.epoch - r;
    }(t, e), t;
  }
  return this.d.getMilliseconds();
}, second: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n.epoch = function(o, r, i) {
      r = df(r);
      let a = o.clone(), s = (o.second() - r) * js.second;
      return o.epoch = o.epoch - s, (o = $g(o, a, i, "minute")).epoch;
    }(n, e, t), n;
  }
  return this.d.getSeconds();
}, minute: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n.epoch = C8(n, e, t), n;
  }
  return this.d.getMinutes();
}, hour: function(e, t) {
  let n = this.d;
  if (e !== void 0) {
    let o = this.clone();
    return o.epoch = EN(o, e, t), o;
  }
  return n.getHours();
}, hourFloat: function(e, t) {
  if (e !== void 0) {
    let i = this.clone(), a = e % 1;
    a *= 60;
    let s = parseInt(e, 10);
    return i.epoch = EN(i, s, t), i.epoch = C8(i, a, t), i;
  }
  let n = this.d, o = n.getHours(), r = n.getMinutes();
  return r /= 60, o + r;
}, hour12: function(e, t) {
  let n = this.d;
  if (e !== void 0) {
    let r = this.clone(), i = (e = "" + e).match(/^([0-9]+)(am|pm)$/);
    if (i) {
      let a = parseInt(i[1], 10);
      i[2] === "pm" && (a += 12), r.epoch = EN(r, a, t);
    }
    return r;
  }
  let o = n.getHours();
  return o > 12 && (o -= 12), o === 0 && (o = 12), o;
}, time: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return e = e.toLowerCase().trim(), n.epoch = function(o, r, i) {
      let a = r.match(/([0-9]{1,2})[:h]([0-9]{1,2})(:[0-9]{1,2})? ?(am|pm)?/);
      if (!a) {
        if (a = r.match(/([0-9]{1,2}) ?(am|pm)/), !a)
          return o.epoch;
        a.splice(2, 0, "0"), a.splice(3, 0, "");
      }
      let s = !1, c = parseInt(a[1], 10), l = parseInt(a[2], 10);
      l >= 60 && (l = 59), c > 12 && (s = !0), s === !1 && (a[4] === "am" && c === 12 && (c = 0), a[4] === "pm" && c < 12 && (c += 12)), a[3] = a[3] || "", a[3] = a[3].replace(/:/, "");
      let u = parseInt(a[3], 10) || 0, d = o.clone();
      return o = (o = (o = (o = o.hour(c)).minute(l)).second(u)).millisecond(0), (o = $g(o, d, i, "day")).epoch;
    }(n, e, t), n;
  }
  return `${this.h12()}:${Wo(this.minute())}${this.ampm()}`;
}, ampm: function(e, t) {
  let n = m4, o = this.hour();
  if (o >= 12 && (n = f4), typeof e != "string")
    return n;
  let r = this.clone();
  return e = e.toLowerCase().trim(), o >= 12 && e === "am" ? (o -= 12, r.hour(o, t)) : o < 12 && e === "pm" ? (o += 12, r.hour(o, t)) : r;
}, dayTime: function(e, t) {
  if (e !== void 0) {
    const o = { morning: "7:00am", breakfast: "7:00am", noon: "12:00am", lunch: "12:00pm", afternoon: "2:00pm", evening: "6:00pm", dinner: "6:00pm", night: "11:00pm", midnight: "23:59pm" };
    let r = this.clone();
    return e = (e = e || "").toLowerCase(), o.hasOwnProperty(e) === !0 && (r = r.time(o[e], t)), r;
  }
  let n = this.hour();
  return n < 6 ? "night" : n < 12 ? "morning" : n < 17 ? "afternoon" : n < 22 ? "evening" : "night";
}, iso: function(e) {
  return e !== void 0 ? this.set(e) : this.format("iso");
} };
var U_c = B_c;
const G_c = { date: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return (e = parseInt(e, 10)) && (n.epoch = function(o, r, i) {
      if ((r = df(r)) > 28) {
        let s = o.month(), c = fv[s];
        s === 1 && r === 29 && YT(o.year()) && (c = 29), r > c && (r = c);
      }
      r <= 0 && (r = 1);
      let a = o.clone();
      return _i(o, { date: r }), (o = $g(o, a, i, "month")).epoch;
    }(n, e, t)), n;
  }
  return this.d.getDate();
}, day: function(e, t) {
  if (e === void 0)
    return this.d.getDay();
  let n = this.clone(), o = e;
  typeof e == "string" && (e = e.toLowerCase(), b8.hasOwnProperty(e) ? o = b8[e] : (o = Lk().indexOf(e), o === -1 && (o = oC().indexOf(e))));
  let r = this.d.getDay() - o;
  t === !0 && r > 0 && (r -= 7), t === !1 && r < 0 && (r += 7);
  let i = this.subtract(r, "days");
  return _i(i, { hour: n.hour(), minute: n.minute(), second: n.second() }), i;
}, dayName: function(e, t) {
  if (e === void 0)
    return oC()[this.day()];
  let n = this.clone();
  return n = n.day(e, t), n;
} };
var W_c = G_c;
const T8 = (e) => e = (e = (e = e.minute(0)).second(0)).millisecond(1), H_c = { dayOfYear: function(e, t) {
  if (e !== void 0) {
    let i = this.clone();
    return i.epoch = function(a, s, c) {
      s = df(s);
      let l = a.clone();
      return (s -= 1) <= 0 ? s = 0 : s >= 365 && (s = 364), a = (a = a.startOf("year")).add(s, "day"), NF(a, l, "hour"), (a = $g(a, l, c, "year")).epoch;
    }(i, e, t), i;
  }
  let n, o = 0, r = this.d.getMonth();
  for (let i = 1; i <= r; i++)
    n = /* @__PURE__ */ new Date(), n.setDate(1), n.setFullYear(this.d.getFullYear()), n.setHours(1), n.setMinutes(1), n.setMonth(i), n.setHours(-2), o += n.getDate();
  return o + this.d.getDate();
}, week: function(e, t) {
  if (e !== void 0) {
    let s = this.clone();
    return s.epoch = function(c, l, u) {
      let d = c.clone();
      return l = df(l), (c = (c = (c = c.month(0)).date(1)).day("monday")).monthName() === "december" && c.date() >= 28 && (c = c.add(1, "week")), l -= 1, c = c.add(l, "weeks"), (c = $g(c, d, u, "year")).epoch;
    }(this, e, t), s = T8(s), s;
  }
  let n = this.clone();
  n = n.month(0), n = n.date(1), n = T8(n), n = n.day("monday"), n.monthName() === "december" && n.date() >= 28 && (n = n.add(1, "week"));
  let o = 1;
  n.date() === 1 && (o = 0), n = n.minus(1, "second");
  const r = this.epoch;
  if (n.epoch > r)
    return 1;
  let i = 0, a = 4 * this.month();
  for (n.epoch += js.week * a, i += a; i <= 52; i++) {
    if (n.epoch > r)
      return i + o;
    n = n.add(1, "week");
  }
  return 52;
}, month: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n.epoch = function(o, r, i) {
      typeof r == "string" && (r === "sept" && (r = "sep"), r = Lle()[r.toLowerCase()]), (r = df(r)) >= 12 && (r = 11), r <= 0 && (r = 0);
      let a = o.date();
      a > fv[r] && (a = fv[r]);
      let s = o.clone();
      return _i(o, { month: r, d: a }), (o = $g(o, s, i, "year")).epoch;
    }(n, e, t), n;
  }
  return this.d.getMonth();
}, monthName: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n = n.month(e, t), n;
  }
  return Dk[this.month()];
}, quarter: function(e, t) {
  if (e !== void 0 && (typeof e == "string" && (e = e.replace(/^q/i, ""), e = parseInt(e, 10)), Lh[e])) {
    let o = this.clone(), r = Lh[e][0];
    return o = o.month(r, t), o = o.date(1, t), o = o.startOf("day"), o;
  }
  let n = this.d.getMonth();
  for (let o = 1; o < Lh.length; o++)
    if (n < Lh[o][0])
      return o - 1;
  return 4;
}, season: function(e, t) {
  let n = "north";
  if (this.hemisphere() === "South" && (n = "south"), e !== void 0) {
    let r = this.clone();
    for (let i = 0; i < x_[n].length; i++)
      e === x_[n][i][0] && (r = r.month(x_[n][i][1], t), r = r.date(1), r = r.startOf("day"));
    return r;
  }
  let o = this.d.getMonth();
  for (let r = 0; r < x_[n].length - 1; r++)
    if (o >= x_[n][r][1] && o < x_[n][r + 1][1])
      return x_[n][r][0];
  return "winter";
}, year: function(e) {
  if (e !== void 0) {
    let t = this.clone();
    return t.epoch = xN(t, e), t;
  }
  return this.d.getFullYear();
}, era: function(e) {
  if (e !== void 0) {
    let t = this.clone();
    e = e.toLowerCase();
    let n = t.d.getFullYear();
    return e === "bc" && n > 0 && (t.epoch = xN(t, -1 * n)), e === "ad" && n < 0 && (t.epoch = xN(t, -1 * n)), t;
  }
  return this.d.getFullYear() < 0 ? "BC" : "AD";
}, decade: function(e) {
  if (e !== void 0) {
    if (!(e = (e = (e = String(e)).replace(/([0-9])'?s$/, "$1")).replace(/([0-9])(th|rd|st|nd)/, "$1")))
      return console.warn("Spacetime: Invalid decade input"), this;
    e.length === 2 && /[0-9][0-9]/.test(e) && (e = "19" + e);
    let t = Number(e);
    return isNaN(t) ? this : (t = 10 * Math.floor(t / 10), this.year(t));
  }
  return this.startOf("decade").year();
}, century: function(e) {
  if (e !== void 0) {
    typeof e == "string" && (e = (e = e.replace(/([0-9])(th|rd|st|nd)/, "$1")).replace(/([0-9]+) ?(b\.?c\.?|a\.?d\.?)/i, (o, r, i) => (i.match(/b\.?c\.?/i) && (r = "-" + r), r)), e = e.replace(/c$/, ""));
    let n = Number(e);
    return isNaN(e) ? (console.warn("Spacetime: Invalid century input"), this) : (n === 0 && (n = 1), n = n >= 0 ? 100 * (n - 1) : 100 * (n + 1), this.year(n));
  }
  let t = this.startOf("century").year();
  return t = Math.floor(t / 100), t < 0 ? t - 1 : t + 1;
}, millenium: function(e) {
  if (e !== void 0) {
    if (typeof e == "string" && (e = e.replace(/([0-9])(th|rd|st|nd)/, "$1"), e = Number(e), isNaN(e)))
      return console.warn("Spacetime: Invalid millenium input"), this;
    e > 0 && (e -= 1);
    let n = 1e3 * e;
    return n === 0 && (n = 1), this.year(n);
  }
  let t = Math.floor(this.year() / 1e3);
  return t >= 0 && (t += 1), t;
} };
var Y_c = H_c;
const Ls = Object.assign({}, U_c, W_c, Y_c);
Ls.milliseconds = Ls.millisecond, Ls.seconds = Ls.second, Ls.minutes = Ls.minute, Ls.hours = Ls.hour, Ls.hour24 = Ls.hour, Ls.h12 = Ls.hour12, Ls.h24 = Ls.hour24, Ls.days = Ls.day;
var K_c = (e) => {
  Object.keys(Ls).forEach((t) => {
    e.prototype[t] = Ls[t];
  });
};
const g4 = function(e, t) {
  return e === 1 && YT(t) ? 29 : fv[e];
}, Z_c = (e, t) => {
  if (e.month > 0) {
    let n = parseInt(e.month / 12, 10);
    e.year = t.year() + n, e.month = e.month % 12;
  } else if (e.month < 0) {
    let n = Math.abs(e.month), o = parseInt(n / 12, 10);
    n % 12 != 0 && (o += 1), e.year = t.year() - o, e.month = e.month % 12, e.month = e.month + 12, e.month === 12 && (e.month = 0);
  }
  return e;
}, X_c = (e, t, n) => {
  let o = t.year(), r = t.month(), i = g4(r, o);
  for (; n > i; )
    n -= i, r += 1, r >= 12 && (r -= 12, o += 1), i = g4(r, o);
  return e.month = r, e.date = n, e;
}, J_c = (e, t, n) => {
  e.year = t.year(), e.month = t.month();
  let o = t.date();
  for (e.date = o - Math.abs(n); e.date < 1; ) {
    e.month -= 1, e.month < 0 && (e.month = 11, e.year -= 1);
    let r = g4(e.month, e.year);
    e.date += r;
  }
  return e;
}, m_ = ["millisecond", "second", "minute", "hour", "date", "month"];
let Qf = { second: m_.slice(0, 1), minute: m_.slice(0, 2), quarterhour: m_.slice(0, 2), hour: m_.slice(0, 3), date: m_.slice(0, 4), month: m_.slice(0, 4), quarter: m_.slice(0, 4), season: m_.slice(0, 4), year: m_, decade: m_, century: m_ };
Qf.week = Qf.hour, Qf.season = Qf.date, Qf.quarter = Qf.date;
const Q_c = { year: !0, quarter: !0, season: !0, month: !0, week: !0, date: !0 }, epc = { month: !0, quarter: !0, season: !0, year: !0 };
var tpc = (e) => {
  e.prototype.add = function(t, n) {
    let o = this.clone();
    if (!n || t === 0)
      return o;
    let r = this.clone();
    if ((n = mv(n)) === "millisecond")
      return o.epoch += t, o;
    n === "fortnight" && (t *= 2, n = "week"), js[n] ? o.epoch += js[n] * t : n === "week" || n === "weekend" ? o.epoch += js.day * (7 * t) : n === "quarter" || n === "season" ? o.epoch += js.month * (3 * t) : n === "quarterhour" && (o.epoch += 15 * js.minute * t);
    let i = {};
    if (Qf[n] && Qf[n].forEach((a) => {
      i[a] = r[a]();
    }), Q_c[n]) {
      const a = r.timezone().current.offset - o.timezone().current.offset;
      o.epoch += 3600 * a * 1e3;
    }
    if (n === "month" && (i.month = r.month() + t, i = Z_c(i, r)), n === "week") {
      let a = r.date() + 7 * t;
      a <= 28 && a > 1 && (i.date = a);
    }
    if (n === "weekend" && o.dayName() !== "saturday")
      o = o.day("saturday", !0);
    else if (n === "date") {
      if (t < 0)
        i = J_c(i, r, t);
      else {
        let a = r.date() + t;
        i = X_c(i, r, a);
      }
      t !== 0 && r.isSame(o, "day") && (i.date = r.date() + t);
    } else if (n === "quarter") {
      if (i.month = r.month() + 3 * t, i.year = r.year(), i.month < 0) {
        let a = Math.floor(i.month / 12), s = i.month + 12 * Math.abs(a);
        i.month = s, i.year += a;
      } else if (i.month >= 12) {
        let a = Math.floor(i.month / 12);
        i.month = i.month % 12, i.year += a;
      }
      i.date = r.date();
    } else if (n === "year") {
      let a = r.year() + t, s = o.year();
      if (s < a) {
        let c = Math.floor(t / 4) || 1;
        o.epoch += Math.abs(js.day * c);
      } else if (s > a) {
        let c = Math.floor(t / 4) || 1;
        o.epoch += js.day * c;
      }
    } else
      n === "decade" ? i.year = o.year() + 10 : n === "century" && (i.year = o.year() + 100);
    if (epc[n]) {
      let a = fv[i.month];
      i.date = r.date(), i.date > a && (i.date = a);
    }
    return Object.keys(i).length > 1 && _i(o, i), o;
  }, e.prototype.subtract = function(t, n) {
    return this.clone().add(-1 * t, n);
  }, e.prototype.minus = e.prototype.subtract, e.prototype.plus = e.prototype.add;
};
const Uw = { millisecond: (e) => e.epoch, second: (e) => [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second()].join("-"), minute: (e) => [e.year(), e.month(), e.date(), e.hour(), e.minute()].join("-"), hour: (e) => [e.year(), e.month(), e.date(), e.hour()].join("-"), day: (e) => [e.year(), e.month(), e.date()].join("-"), week: (e) => [e.year(), e.week()].join("-"), month: (e) => [e.year(), e.month()].join("-"), quarter: (e) => [e.year(), e.quarter()].join("-"), year: (e) => e.year() };
Uw.date = Uw.day;
var npc = (e) => {
  e.prototype.isSame = function(t, n, o = !0) {
    let r = this;
    if (!n)
      return null;
    if (typeof t == "string" && typeof n == "object") {
      let i = t;
      t = n, n = i;
    }
    return typeof t != "string" && typeof t != "number" || (t = new e(t, this.timezone.name)), n = n.replace(/s$/, ""), o === !0 && r.tz !== t.tz && ((t = t.clone()).tz = r.tz), Uw[n] ? Uw[n](r) === Uw[n](t) : null;
  };
}, opc = (e) => {
  const t = { isAfter: function(n) {
    let o = U$(n = Ah(n, this));
    return o === null ? null : this.epoch > o;
  }, isBefore: function(n) {
    let o = U$(n = Ah(n, this));
    return o === null ? null : this.epoch < o;
  }, isEqual: function(n) {
    let o = U$(n = Ah(n, this));
    return o === null ? null : this.epoch === o;
  }, isBetween: function(n, o, r = !1) {
    n = Ah(n, this), o = Ah(o, this);
    let i = U$(n);
    if (i === null)
      return null;
    let a = U$(o);
    return a === null ? null : r ? this.isBetween(n, o) || this.isEqual(n) || this.isEqual(o) : i < this.epoch && this.epoch < a;
  } };
  Object.keys(t).forEach((n) => {
    e.prototype[n] = t[n];
  });
}, rpc = (e) => {
  const t = { i18n: (n) => {
    var o, r, i;
    Ub(n.days) && (o = n.days, _4 = o.short || _4, p4 = o.long || p4), Ub(n.months) && function(a) {
      Pk = a.short || Pk, Dk = a.long || Dk;
    }(n.months), i = n.useTitleCase, Object.prototype.toString.call(i) === "[object Boolean]" && (r = n.useTitleCase, Fle = r), Ub(n.ampm) && function(a) {
      m4 = a.am || m4, f4 = a.pm || f4;
    }(n.ampm);
  } };
  Object.keys(t).forEach((n) => {
    e.prototype[n] = t[n];
  });
};
let CN = Ple;
const k_ = function(e, t, n = {}) {
  this.epoch = null, this.tz = nC(t, CN), this.silent = n.silent === void 0 || n.silent, this.british = n.dmy || n.british, this._weekStart = 1, n.weekStart !== void 0 && (this._weekStart = n.weekStart), this._today = {}, n.today !== void 0 && (this._today = n.today), Object.defineProperty(this, "d", { get: function() {
    let r = p_c(this), i = (new Date(this.epoch).getTimezoneOffset() || 0) + 60 * r;
    i = 60 * i * 1e3;
    let a = this.epoch + i;
    return new Date(a);
  } }), Object.defineProperty(this, "timezones", { get: () => CN, set: (r) => (CN = r, r) });
  let o = Mle(this, e);
  this.epoch = o.epoch;
};
Object.keys(x8).forEach((e) => {
  k_.prototype[e] = x8[e];
}), k_.prototype.clone = function() {
  return new k_(this.epoch, this.tz, { silent: this.silent, weekStart: this._weekStart, today: this._today, parsers: this.parsers });
}, k_.prototype.toLocalDate = function() {
  return this.toNativeDate();
}, k_.prototype.toNativeDate = function() {
  return new Date(this.epoch);
}, K_c(k_), tpc(k_), npc(k_), opc(k_), rpc(k_);
var Sd = k_, ipc = (e, t) => {
  let n = new Sd(null), o = new Sd(null);
  n = n.time(e), o = t ? o.time(t) : n.add(59, "minutes");
  let r = n.hour(), i = o.hour();
  return Object.keys(n.timezones).filter((s) => {
    if (s.indexOf("/") === -1)
      return !1;
    let c = new Sd(null, s), l = c.hour();
    return l >= r && l <= i && !(l === r && c.minute() < n.minute()) && !(l === i && c.minute() > o.minute());
  });
};
const Su = (e, t, n) => new Sd(e, t, n), LS = function(e) {
  let t = e._today || {};
  return Object.keys(t).forEach((n) => {
    e = e[n](t[n]);
  }), e;
};
Su.now = (e, t) => {
  let n = new Sd((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = LS(n), n;
}, Su.today = (e, t) => {
  let n = new Sd((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = LS(n), n.startOf("day");
}, Su.tomorrow = (e, t) => {
  let n = new Sd((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = LS(n), n.add(1, "day").startOf("day");
}, Su.yesterday = (e, t) => {
  let n = new Sd((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = LS(n), n.subtract(1, "day").startOf("day");
}, Su.extend = function(e = {}) {
  return Object.keys(e).forEach((t) => {
    Sd.prototype[t] = e[t];
  }), this;
}, Su.timezones = function() {
  return new Sd().timezones;
}, Su.max = function(e, t) {
  let n = new Sd(null, e, t);
  return n.epoch = 864e13, n;
}, Su.min = function(e, t) {
  let n = new Sd(null, e, t);
  return n.epoch = -864e13, n;
}, Su.whereIts = ipc, Su.version = "7.1.4", Su.plugin = Su.extend;
var TN = Su, A8 = function(e, t) {
  let n = Math.min(e.length, t.length);
  for (; n > 0; ) {
    const o = e.slice(0, n);
    if (o === t.slice(0, n))
      return o;
    n -= 1;
  }
  return "";
};
const h4 = function() {
  this.counts = {};
}, I8 = { init: function(e) {
  this.counts[e] === void 0 && (this.counts[e] = 0);
}, add: function(e, t) {
  t === void 0 && (t = 1), this.init(e), this.counts[e] += t;
}, countOf: function(e) {
  return this.init(e), this.counts[e];
}, highest: function(e) {
  let t = [];
  const n = Object.keys(this.counts);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    t.push([r, this.counts[r]]);
  }
  return t.sort(function(o, r) {
    return r[1] - o[1];
  }), e && (t = t.slice(0, e)), t;
} };
Object.keys(I8).forEach(function(e) {
  h4.prototype[e] = I8[e];
});
const v4 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", O8 = v4.split("").reduce(function(e, t, n) {
  return e[t] = n, e;
}, {});
var Cb = function(e) {
  if (v4[e] !== void 0)
    return v4[e];
  let t = 1, n = 36, o = "";
  for (; e >= n; e -= n, t++, n *= 36)
    ;
  for (; t--; ) {
    const r = e % 36;
    o = String.fromCharCode((r < 10 ? 48 : 55) + r) + o, e = (e - r) / 36;
  }
  return o;
}, b4 = function(e) {
  if (O8[e] !== void 0)
    return O8[e];
  let t = 0, n = 1, o = 36, r = 1;
  for (; n < e.length; t += o, n++, o *= 36)
    ;
  for (let i = e.length - 1; i >= 0; i--, r *= 36) {
    let a = e.charCodeAt(i) - 48;
    a > 10 && (a -= 7), t += a * r;
  }
  return t;
};
const apc = function(e, t) {
  let n = "", o = "";
  e.isTerminal(t) && (n += "!");
  const r = e.nodeProps(t);
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (typeof t[a] == "number") {
      n += o + a, o = ",";
      continue;
    }
    if (e.syms[t[a]._n]) {
      n += o + a + e.syms[t[a]._n], o = "";
      continue;
    }
    let s = Cb(t._n - t[a]._n - 1 + e.symCount);
    t[a]._g && s.length >= t[a]._g.length && t[t[a]._g] === 1 ? (s = t[a]._g, n += o + a + s, o = ",") : (n += o + a + s, o = "");
  }
  return n;
}, qle = function(e, t) {
  if (e.visited(t))
    return;
  const n = e.nodeProps(t, !0);
  for (let o = 0; o < n.length; o++) {
    const r = n[o], i = t._n - t[r]._n - 1;
    i < 36 && e.histRel.add(i), e.histAbs.add(t[r]._n, Cb(i).length - 1), qle(e, t[r]);
  }
}, jle = function(e, t) {
  if (t._n !== void 0)
    return;
  const n = e.nodeProps(t, !0);
  for (let o = 0; o < n.length; o++)
    jle(e, t[n[o]]);
  t._n = e.pos++, e.nodes.unshift(t);
}, spc = new RegExp("[0-9A-Z,;!:|¦]"), cpc = { insertWords: function(e) {
  if (e !== void 0) {
    typeof e == "string" && (e = e.split(/[^a-zA-Z]+/));
    for (let t = 0; t < e.length; t++)
      e[t] = e[t].toLowerCase();
    (function(t) {
      t.sort();
      for (let n = 1; n < t.length; n++)
        t[n - 1] === t[n] && t.splice(n, 1);
    })(e);
    for (let t = 0; t < e.length; t++)
      e[t].match(spc) === null && this.insert(e[t]);
  }
}, insert: function(e) {
  this._insert(e, this.root);
  const t = this.lastWord;
  if (this.lastWord = e, A8(e, t) === t)
    return;
  const n = this.uniqueNode(t, e, this.root);
  n && this.combineSuffixNode(n);
}, _insert: function(e, t) {
  let n, o;
  if (e.length === 0)
    return;
  const r = Object.keys(t);
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (n = A8(e, a), n.length !== 0)
      return a === n && typeof t[a] == "object" ? void this._insert(e.slice(n.length), t[a]) : a === e && typeof t[a] == "number" ? void 0 : (o = {}, o[a.slice(n.length)] = t[a], this.addTerminal(o, e = e.slice(n.length)), delete t[a], t[n] = o, void this.wordCount++);
  }
  this.addTerminal(t, e), this.wordCount++;
}, addTerminal: function(e, t) {
  if (t.length <= 1)
    return void (e[t] = 1);
  const n = {};
  e[t[0]] = n, this.addTerminal(n, t.slice(1));
}, nodeProps: function(e, t) {
  const n = [];
  for (const o in e)
    o !== "" && o[0] !== "_" && (t && typeof e[o] != "object" || n.push(o));
  return n.sort(), n;
}, optimize: function() {
  this.combineSuffixNode(this.root), this.prepDFS(), this.countDegree(this.root), this.prepDFS(), this.collapseChains(this.root);
}, combineSuffixNode: function(e) {
  if (e._c)
    return e;
  let t = [];
  this.isTerminal(e) && t.push("!");
  const n = this.nodeProps(e);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    typeof e[r] == "object" ? (e[r] = this.combineSuffixNode(e[r]), t.push(r), t.push(e[r]._c)) : t.push(r);
  }
  return t = t.join("-"), this.suffixes[t] || (this.suffixes[t] = e, e._c = this.cNext++, e);
}, prepDFS: function() {
  this.vCur++;
}, visited: function(e) {
  return e._v === this.vCur || (e._v = this.vCur, !1);
}, countDegree: function(e) {
  if (e._d === void 0 && (e._d = 0), e._d++, this.visited(e))
    return;
  const t = this.nodeProps(e, !0);
  for (let n = 0; n < t.length; n++)
    this.countDegree(e[t[n]]);
}, collapseChains: function(e) {
  let t, n, o, r;
  if (!this.visited(e)) {
    for (n = this.nodeProps(e), r = 0; r < n.length; r++)
      t = n[r], o = e[t], typeof o == "object" && (this.collapseChains(o), o._g === void 0 || o._d !== 1 && o._g.length !== 1 || (delete e[t], t += o._g, e[t] = o[o._g]));
    n.length !== 1 || this.isTerminal(e) || (e._g = t);
  }
}, isTerminal: function(e) {
  return !!e[""];
}, uniqueNode: function(e, t, n) {
  const o = this.nodeProps(n, !0);
  for (let r = 0; r < o.length; r++) {
    const i = o[r];
    if (i === e.slice(0, i.length))
      return i !== t.slice(0, i.length) ? n[i] : this.uniqueNode(e.slice(i.length), t.slice(i.length), n[i]);
  }
}, pack: function() {
  return function(e) {
    e.nodes = [], e.nodeCount = 0, e.syms = {}, e.symCount = 0, e.pos = 0, e.optimize(), e.histAbs = new h4(), e.histRel = new h4(), jle(e, e.root), e.nodeCount = e.nodes.length, e.prepDFS(), qle(e, e.root), e.symCount = function(t) {
      t.histAbs = t.histAbs.highest(36);
      const n = [];
      n[-1] = 0;
      let o = 0, r = 0;
      const i = 3 + Cb(t.nodeCount).length;
      for (let a = 0; a < 36 && t.histAbs[a] !== void 0; a++)
        n[a] = t.histAbs[a][1] - i - t.histRel.countOf(36 - a - 1) + n[a - 1], n[a] >= o && (o = n[a], r = a + 1);
      return r;
    }(e);
    for (let t = 0; t < e.symCount; t++)
      e.syms[e.histAbs[t][0]] = Cb(t);
    for (let t = 0; t < e.nodeCount; t++)
      e.nodes[t] = apc(e, e.nodes[t]);
    for (let t = e.symCount - 1; t >= 0; t--)
      e.nodes.unshift(Cb(t) + ":" + Cb(e.nodeCount - e.histAbs[t][0] - 1));
    return e.nodes.join(";");
  }(this);
} };
Object.keys(cpc).forEach(function(e) {
});
const lpc = function(e, t, n) {
  const o = b4(t);
  return o < e.symCount ? e.syms[o] : n + o + 1 - e.symCount;
}, upc = /(\-?[0-9]+)h(rs)?/i, dpc = /(\-?[0-9]+)/, _pc = /utc([\-+]?[0-9]+)/i, ppc = /gmt([\-+]?[0-9]+)/i, MS = function(e) {
  return (e = Number(e)) > -13 && e < 13 ? "Etc/GMT" + (e = ((e *= -1) > 0 ? "+" : "") + e) : null;
};
let Ta = function(e) {
  const t = e.split("|").reduce((o, r) => {
    const i = r.split("¦");
    return o[i[0]] = i[1], o;
  }, {}), n = {};
  return Object.keys(t).forEach(function(o) {
    const r = function(i) {
      const a = { nodes: i.split(";"), syms: [], symCount: 0 };
      return i.match(":") && function(s) {
        const c = new RegExp("([0-9A-Z]+):([0-9A-Z]+)");
        for (let l = 0; l < s.nodes.length; l++) {
          const u = c.exec(s.nodes[l]);
          if (!u) {
            s.symCount = l;
            break;
          }
          s.syms[b4(u[1])] = b4(u[2]);
        }
        s.nodes = s.nodes.slice(s.symCount, s.nodes.length);
      }(a), function(s) {
        const c = [], l = (u, d) => {
          let _ = s.nodes[u];
          _[0] === "!" && (c.push(d), _ = _.slice(1));
          const p = _.split(/([A-Z0-9,]+)/g);
          for (let g = 0; g < p.length; g += 2) {
            const f = p[g], h = p[g + 1];
            if (!f)
              continue;
            const $ = d + f;
            if (h === "," || h === void 0) {
              c.push($);
              continue;
            }
            const v = lpc(s, h, u);
            l(v, $);
          }
        };
        return l(0, ""), c;
      }(a);
    }(t[o]);
    o === "true" && (o = !0);
    for (let i = 0; i < r.length; i++) {
      const a = r[i];
      n.hasOwnProperty(a) === !0 ? Array.isArray(n[a]) === !1 ? n[a] = [n[a], o] : n[a].push(o) : n[a] = o;
    }
  }), n;
}("Africa/Abidjan¦a2bouake,daloa,san ped1t0yamoussouk1;g,ogo;ro;b0frica/timbuktu;idjan,obo|Africa/Algiers¦a5b3c2dz,oran,s1t0;ebessa,iaret;etif,idi bel abbes;hlef,onstantine;a0iskra,lida,oumerdas;b ezzouar,tna;lg0nnaba;eria,iers|Africa/Cairo¦a4bani suwayf,c3damanhur,eg2giza,halw6i1kafr ad dawwar,luxor,new c3port said,qina,s0tanta,zagazig;hibin al kawm,ohag,uez;dku,smail6;!ypt;airo;l2s0;w0yut;an; 1exandr0;ia;fayyum,m0;a0inya;hallah al kubra,nsurah|Africa/El_Aaiun¦e0laayoune,western sahara;h,l aaiun|Africa/Ceuta¦ceuta0;!melilla|Africa/Accra¦a2gh1kumasi,ta0;koradi,male;!ana;ccra,tsiaman|Africa/Bissau¦b1g0;uinea b0w;issau|Africa/Nairobi¦africa7e2kisumu,m1na0thika,yt;irobi,kuru;ayotte,ombasa;. africa standard 3a0ldoret;st0t; africa0ern africa;! 0;time; eastern,/asmera|Africa/Monrovia¦l0monrov1;iber0r;ia|Africa/Tripoli¦a3benghazi,l1misrat4t0zawi2;arhuna,ripoli;ib0y;ya;l khums,z zawiy0;ah|Africa/Casablanca¦a9casablanca,f8kenit7m4oujda angad,rabat,sa2t0;angier,e0;ma5touan;fi,le0;! al jadida;a1ekn3o0;hammedia,rocco;!rrakesh;ra;es;gadir,l hoceima|Africa/Maputo¦beira,c4ma2na1quelimane,z0;imbabwe,w;ca1mpu1;puto,to0;la;entral africa time,himoio|Africa/Windhoek¦africa central,na0windhoek;!mibia0;! standard time|Africa/Lagos¦aYbWcVeUgTiPjOkaMlKmHnFoCport harcourt,sBuAw0zarG;. central africa6a5est0; 0ern1;africa1central0; africa;! 0;s2t3;rCst,t;! s0;tandard t0;ime;gep,muah5yo;a9hagamu,okoto;kFn1w0yo;er5o;do,itsha;g,iger0newi;ia;a0in5ubi;idugu0kurdi;ri;agos,ek0;ki;du0no,tsi0;na;imeEos;badan,jebu ode,k1l0seAwo;a orangun,esa,or6;eAi7ot ekp0;ene;ombe,usau;bute ikorodu,fon alaaye,nugu;alabar,hakwama;auchi,en0;in;b2do1frica western,ku0tani;re; ekiti;a,eoku1u0;ja;ta|Africa/Khartoum¦a6c5el 4k2ny3omdurm1port sud1s0wad medani;d,inga,ud0;an;ass0hartoum,osti;ala;dae2fasher,obeid;at,entral africa;d damaz0l qadarif;in|Africa/Juba¦juba,s0winejok;outh sudan,s|Africa/Sao_Tome¦s0;ao tome,t|Africa/Ndjamena¦chad,n0td;'d0d0;jamena|Africa/Tunis¦sfax,t0;n,unis0;!ia|Africa/Johannesburg¦africa southern,bEcAd9east londBjohannesHk7newcastDp6r5s2tembisa,uitenhage,v1w0za;elkom,itbank;anderbijlpark,ereeniging;ast,o0prings;uth africa0weto;! standard time;andBichards bay,oodepoort;aarl,ietermaritzAort elizabeth,retoria;lerk0ruger0;sdorp;iepsloot,urb5;a1enturi0;on;pe town,rletonvil0;le;enoni,loemfontein,o1rakp0;an;ks0tshabelo;burg|America/Argentina/Buenos_Aires¦argentina/buenos aires|America/Argentina/Cordoba¦a0;merica/0rgentina/c1;c0rosario;ordoba|America/Argentina/Salta¦argentina/salta|America/Argentina/Jujuy¦a0;meric0rgentin0;a/jujuy|America/Argentina/Tucuman¦argentina/tucuman|America/Argentina/Catamarca¦a0;merica/0rgentina/c1;argentina/comodrivadavia,c0;atamarca|America/Argentina/La_Rioja¦argentina/la rioja|America/Argentina/San_Juan¦argentina/san juan|America/Argentina/Mendoza¦a0;meric0rgentin0;a/mendoza|America/Argentina/San_Luis¦argentina/san luis|America/Argentina/Rio_Gallegos¦argentina/rio gallegos|America/Argentina/Ushuaia¦argentina/ushuaia|America/Barbados¦b0;arbados,b|America/La_Paz¦bo1cochabamba,la paz,oruro,s0;anta cruz de la sierra,ucre;!livia0t;! time|America/Noronha¦atlantic islands,brazil/den0fernando de noronha standard time,n0;oronha|America/Belem¦ananindeua,belem,macapa,par0;auapebas,á (east) amapá|America/Fortaleza¦ca2fortaleza,imperatriz,j1m0natal,sao luis,teresina;aracanau,ossoro;oao pessoa,uazeiro do norte;mpina grande,ucaia|America/Recife¦caruaru,jaboatao2olinda,p0recife;aulista,e0;rnambuco,trolina;! dos guararapes|America/Araguaina¦araguaina,palmas,tocantins|America/Maceio¦a0maceio;lagoassergipe,racaju|America/Bahia¦bahia,camacari,feira de santa0itabu0salvador,vitoria da conquista;na|America/Sao_Paulo¦a14b0Tc0Md0Je0Hf0Fg0Ahortol09i05j02l01mXnVosasco,pLriFs4ta3uber2v0;i0olta redon18;amao,la velha,tor14;a0Ml06;boao da ser00uba0Y;a2e1oroNu0;maLzano;rXte lago0L;nt4o 0;bernardo do campo,carl03jo0leopolLpaulo,vicE;ao de meriti,se0;! do0; rio p8s camp00;a 1o0; andDs;barbara d'oes0Nluz0Rmar0R;beirao 3o0;! 0;cla0de janei0g6ver7;ro;das nev07p0;reto;asso fun8e7iraci6lanalti0Mo4r0;aia g1esidente prud0;en0E;ran0;de;nta grossa,rto aleg0;re;caW;lotYtro0D;do;iteroi,ov0;aJo hamburgo;a1o0;gi das cruzSntes clarD;ri0ua;l05n6;imei2ondri06;acarei,oinville,u0;iz de fo0ndi9;ra;ndaia2patin1ta0;bor6pevi,quaquece1;ga;tuG;andW;o3ravat2uaru0;ja,lh0;os;ai;iQvernador valadarC;loria5oz do0ran2; iguacu;. south america Gast south ameri0mbu;ca;i0uque de caxi8;adema,vi0;noL;a1o0uriti2;ntagem,tI;choeiro de itapemirBmp1no3rapicui0scavel,xias do sul;ba;in1os dos goytacaz0;es;as;a9e5lumenau,r0;!a0st,t;silia1zil0;!/east;! 0;standard time;l1t0;im;ford roxo,o horizon0;te;rueri,uru;lvora4merica3na2parecida de goi0;an0;ia;polis;na;da|America/Campo_Grande¦campo grande,mato grosso do sul|America/Cuiaba¦cuiaba,mato grosso,varzea grande|America/Santarem¦pará (west),santarem|America/Porto_Velho¦porto velho,rondônia|America/Boa_Vista¦amazon1boa vista,central brazil0roraima;!ian0;! standard time|America/Manaus¦am0brazil/west,manaus;azonas (east),t|America/Eirunepe¦a0eirunepe;cre standard time,mazonas (west)|America/Rio_Branco¦a0brazil/a0rio branco;cre|America/Nassau¦b0nassau;ahamas,s|America/Belize¦b0;elize,z|America/St_Johns¦canada/newfoundland,n0st johns;d2ewfoundland0st,t;! 0;labrador (southeast),standard time;dt,t|America/Halifax¦a2canada/atlantic,halifax,n1p0;ei,rince edward island;ew brunswick,ova scotia;dt,st,tlantic0;! - ns (most areas) pe|America/Glace_Bay¦atlantic - ns (cape breton),glace bay|America/Moncton¦atlantic - new brunswick,moncton|America/Goose_Bay¦atlantic - labrador (most areas),goose bay|America/Blanc-Sablon¦ast - qc (lower north shore),blanc sablon|America/Toronto¦america/moBb9ca7eastern - onqc (most areas),gatineau,hamilAkitchener,l4m3nepe2o0quebec,richmond hill,toronto,vaugh2windsor;n5sh0tt0;awa;an;arkham,ississauga,o7;av7on0;don on0gueuil;tario;!nada0;!/eastern;arrie,ramp0;ton;ntre0;al|America/Nipigon¦nipigon|America/Thunder_Bay¦eastern - on (thunder bay),thunder bay|America/Iqaluit¦eastern - nu (most east areas),iqaluit|America/Pangnirtung¦eastern - nu (pangnirtung),pangnirtung|America/Atikokan¦atikokan,est - on (atikokan) nu (coral h)|America/Winnipeg¦c0m1winnipeg;anada/central,entral - on (west) m0;anitoba|America/Rainy_River¦central - on (rainy rft frances),rainy river|America/Resolute¦central - nu (resolute),resolute|America/Rankin_Inlet¦central - nu (central),rankin inlet|America/Regina¦c1regina,saskat0;c1oon;anada/saskatc0st - sk (most areas);hewan|America/Swift_Current¦cst - sk (midwest),swift current|America/Edmonton¦alberta,ca0edmonton,mountain - ab bc (e) sk (w);lgary,nada/mountain|America/Cambridge_Bay¦cambridge bay,mountain - nu (west)|America/Yellowknife¦mountain - nt (central),yellowknife|America/Inuvik¦inuvik,mountain - nt (west)|America/Creston¦creston,mst - bc (creston)|America/Dawson_Creek¦dawson creek,mst - bc (dawson crft st john)|America/Fort_Nelson¦fort nelson,mst - bc (ft nelson)|America/Whitehorse¦canada/yukon,pacific - yukon (south),whitehorse|America/Dawson¦dawson,pacific - yukon (north)|America/Vancouver¦b2canada/pacific,ladn1okanagan,pacific - bc (most areas),surrey,v0yukon;ancouv0ictor2;er;ritish columb0urnaby;ia|America/Santiago¦a7c4iquique,la pintana,puente alto,rancagua,san3t1v0;alparaiso,ina del mar;alca0emuco;!huano; bernardo,tiago;hile1l0oncepcion;!st,t;! (most areas),/continental;ntofagasta,rica|America/Punta_Arenas¦punta arenas,region of magallanes|America/Bogota¦armenGbBc7dosquebradas,floridablanca,i6m5neiva,p3s1v0;alledupar,illavicencio;anta marCincelejo,o0;acha,ledad;a0erei9opayan;lmi8sto;anizales,edellin,onterA;bague,taguei;a2o0ucu6;!lombia0st,t;! standard time;li,rtagena;arran3ello,ogo2u0;caramanga,enaventu0;ra;ta;cabermeja,quilla;ia|America/Costa_Rica¦c0;osta rica,r|America/Havana¦arroyo naranjo,b7c2diez de octubre,guantan9h1las tunas,pinar del rio,sant0;a clara,iago de cuba;avana,olguin;amaguey,i2u0;!ba0;! standard time;e0udad camilo cie0;nfueg1;ay1oyer0;os;amo|America/Curacao¦curacao,s0;t maarten,x|America/Santo_Domingo¦bella vista,do5la romana,san0; pedro de macoris,t0;iago de los caballeros,o domingo0;! 0;e0oe0;ste;!minican republic|America/Guayaquil¦cuenca,ec1guayaquil,ma0quito,santo domingo de los colorados;chala,nta;!uador0;! 0;(mainland),time|America/Cayenne¦cayenne,french guiana1gf0;!t;! time|America/Nuuk¦america/godthab,nuuk|America/Danmarkshavn¦danmarkshavn,national park (east coast)|America/Scoresbysund¦e1greenland eastern,scoresbysund0;!/ittoqqortoormiit;ast greenland1g0;st,t;! standard time|America/Thule¦thule0;!/pituffik|America/Guatemala¦g0mixco,villa nueva;t,uatemala|America/Guyana¦g0;eorgetown,uyana1y0;!t;! time|America/Tegucigalpa¦h0san pedro sula,tegucigalpa;n,onduras|America/Port-au-Prince¦c2p0;etionville,ort 0;au prince,de paix;arrefour,roix des bouquets|America/Jamaica¦j1k0new k0;ingston;amaica,m|America/Martinique¦m0;artinique,q|America/Mexico_City¦a0Gb0EcVduran09ecatepec de morel07guQhPiNjalis0Ileon de los alda03mInHoGpEqDs9t4uruap01v2x1yucat01za0;catec09pop00;alapa de enriqu0Ki0Gochimil0G;e0illahermosa;nustiano carranza,racruz;a3e7la1o0uxt00;luRnaZ;huac,l0quepaque,xcaY;nepantXpT;bas09maulip01pachuW;an0oledad de graciano sanch0C; luis potosi,t0;a maria chimal0iago de q1;huN;ueretaD;achuca de soFoza rica de6ue0;bPrto vallarZ;axaGjo de agua;aucalpan02icolas rome9uevo le01;agdalena contrerRexico3i1orel0x;ia,os;choFguel0; h3;! city,/general;rap5xtapalu9zta0;cSpalapa;idalJ;a1erre0stavo adolfo made0;ro;dalajara,naj0;ua0;to;eFhiCiudad Ao3u0;au1ernava0;ca;htemoc,titlan izcalli;a4l2yo0;ac0;an;i0onia del valle;ma;cChui0tzacoalc2;la;lopez mate0nezahualcoyotl;os;ap1lpancin0;go;as;laya,ntral 0;mexic0time;an,o;enito6uenavis0;ta;capulco3guascalientes,lvaro obreg2zcapotz0;al0;co;on; de0; juar0;ez|America/Cancun¦cancun,eastern standard time - quintana roo|America/Merida¦c0merida;ampeche,entral time - campecheyucatán|America/Monterrey¦c5g4mon3sa1t0victoria de durango;ampico,orreon;ltillo,n0; nicolas de los garza,ta catarina;clova,terrey;omez palacio,uadalupe;entral time - durango coahuilanuevo leóntamaulipas (most areas),iudad 0;apodaca,general escobedo,madero,victoria|America/Matamoros¦central time us - coahuilanuevo leóntamaulipas (us border),heroica m0m0nuevo laredo,reynosa;atamoros|America/Mazatlan¦culiac1los mochis,m0tepic;azatl0exico/bajasur,ountain time - baja california surnayaritsinaloa;an|America/Chihuahua¦chihuahua,m0;exic1ountain 0;mexico,standard time (mexico),time - chihuahua (most areas);an pacific standard time,o pacific|America/Ojinaga¦ciudad juarez,mountain time us - chihuahua (us border),ojinaga|America/Hermosillo¦ciudad obregon,hermosillo,mountain standard time - sonora,nogales|America/Tijuana¦america/e1e1mexic0pacific time us - baja california,tijuana;ali,o/bajanorte;nsenada|America/Bahia_Banderas¦bahia0central time - bahía de0; banderas|America/Managua¦man1ni0;!car0;agua|America/Panama¦pa0san miguelito;!nama|America/Lima¦arequiAc6huanc9i5juliaca,lima,p2sant1t0;acna,rujillo;a anita   los ficus,iago de sur5;e0iura,ucall7;!ru0t;! standard time;ca,quitos;allao,hi1us0;co;cl0mbote;ayo;pa|America/Miquelon¦m8p6s0;aint pierre1t0; pierre a3. pierre & miquelon s2;! 0;a1s0;tandard time;nd1;ierre0m; m0;iquelon|America/Puerto_Rico¦atlantic standard time,bayamon,p0;r,uerto rico|America/Asuncion¦asuncion,c3p0san lorenzo;araguay1y0;!st,t;! standard time;apiata,iudad del este|America/Paramaribo¦paramaribo,s0;r1uriname0;! time;!t|America/El_Salvador¦el1s0;an0oyapango,v; salvador|America/Grand_Turk¦grand turk,t0;c,urks and caicos|America/Port_of_Spain¦america/virg0port of spa0;in|America/New_York¦a0Pb0Mc0Fd0Ee0Af06g04hialeah,i01jZkYlexingtonXmTnMoKpIquHrDsAt7u5v3w0yonkers;ashington1est 0inston salem,orcD;raEvirgin03;! dc;ermont,irginia0;! beach;nited states,s0;!/0J;a0enne1he bronx,oleD;llaha0mpa;ssee;outh 1t0;. petersburg,aten3;bo0AcC;a2hode1ichmo04och0;ester; is01;lei2;eens,intana roo;ennsylvanMhiladelphMittsbur0rovidence;gh;hio,rlan0;do;ew3or1y0;!c;folk,th c0;aroliD; 0ark,port news;hampshiWje8york0;! staS;a1eads,i0;ami,chig1;ine,nhatt0ryLssachusetts;an;! fayetN;entucky,nox9;acks2e0;rsey;ndia1r0;on5;na;eorg0reensboro;ia;ayette1l0ort lauderda2;!orida;vil0;le;ast0dt,st; flatbush,ern0;! 0;(most areas),standard time;elawa9urham;ape coral,h3incinnati,leve1o0;lumbus,nnecticut;la0;nd;a0esapeake;rlot0ttanooga;te;altimo1o0rooklyn,uffalo;st3;re;kr1merica 0tlanta;eastern;on|America/Detroit¦detroit,eastern - mi (most areas),grand rapids,us/michigan|America/Kentucky/Louisville¦america0kentucky0;/louisville|America/Kentucky/Monticello¦kentucky/monticello|America/Indiana/Indianapolis¦americ0indian0us/east-indiana;a/indianapolis|America/Indiana/Vincennes¦indiana/vincennes|America/Indiana/Winamac¦indiana/winamac|America/Indiana/Marengo¦indiana/marengo|America/Indiana/Petersburg¦indiana/petersburg|America/Indiana/Vevay¦indiana/vevay|America/Chicago¦aVbScQdPfort worth,gOhNiLkZlImBn7o6plano,s3t1us/02wi0;chiFsconsV;ex0ulsa;!as;a0hreveport,ou4t 1;int 0n antonio;louGpaul;klahoWmaha,verland park;ashLe1or0;th dako7;braska,w 0;orleans,south me6;adisMe5i1o0;biHntgomery;lwaukee,nne1ss0;issippi,ouri;apol6so0;ta;mph4;aredo,i0ouisiana,ubb1;ncoln,ttle r0;ock;llino0owa,rving;is;oustAunts5;arland,rand prairie;allAes moines;dt,entral0hicago,orpus christi,st;! (most areas);aton rouge,rowns0;vil0;le;laba7m5r1ust0;in;k1lingt0;on;ans0;as;arillo,erica 0;central;ma|America/Indiana/Tell_City¦indiana/tell city|America/Indiana/Knox¦indiana/knox,us/indiana-starke|America/Menominee¦central - mi (wisconsin border),menominee|America/North_Dakota/Center¦north dakota/center|America/North_Dakota/New_Salem¦north dakota/new salem|America/North_Dakota/Beulah¦north dakota/beulah|America/Denver¦a1colorado springs,denver,el paso,m0navajo,salt lake,us/mountain;dt,ountain (most areas),st;lbuquerque,merica/shiprock,urora|America/Boise¦america mountain,boise,mountain0;! 0;- id (south) or (east),standard time|America/Phoenix¦a8c7g5idaho,m4n3phoenix,s2t1u0wyoming;s/a7tah;empe,ucson;cottsd3inaloa,onora;ayarit,ew mexico;aryv1esa,onta4st - arizona (except navajo);ilbert,lend0;ale;handler,olorado;rizo0;na|America/Los_Angeles¦aZbaXcVfRgarden grove,hOirviNlJmoGnFoCp8r7s0tacoma,us/00washington state;a1eattle,f,p0tocktPunrise manor;okaLringF;cramenFn0; 1ta 0;aPclariR;bernardiNdiego,fran0jo4;!cisco;ancho cucamonga,eLiver5;a0dt,ort5st;cific1radi0;se;! standard time;ak1cean0regDxnard;side;land;evada,orth las6;des1reno0; valley;to;a1o0;ng4s angeles;!s0; vegas;ne;enders1untington0; beach;on;onta2re0;mont,s0;no;na;a2hula vis0;ta;ja ca0kersfield;lifornia;merica 0naheim;pacific|America/Anchorage¦a0us/alaska;h4k4laska0nchorage;! 1n0;! s1;(most areas),s0;tandard time;dt,st|America/Juneau¦alaska - juneau area,juneau|America/Sitka¦alaska - sitka area,sitka|America/Metlakatla¦alaska - annette island,metlakatla|America/Yakutat¦alaska - y0y0;akutat|America/Nome¦alaska (west),nome|America/Adak¦a0hawaii standard time,us/aleutian;dak,leutian islands,merica/atka|America/Montevideo¦montevideo2u0;ruguay1y0;!st,t;! standard time|America/Caracas¦alto barinJbarIcCguaAm7p6san5turmeEv0;alencia,e0;!nezuela0t;! 0n;standard t0t0;ime; cristobal,ta teresa del tuy;eta4uerto la cruz;a0ucumpiz;raca0turin;ibo,y;ren8ti0;re;a4iudad 2o1u0;a,m2;ro;bolivar,guay0;ana;bim1rac1;in0quisimeto,uta;as|Asia/Dubai¦a4dubai,g2musaff1om0ras al khaim1sharj1;!an;ah;st,ulf0;! standard time;bu dhabi,jman|Asia/Kabul¦af1herat,jalalabad,ka0mazar e sharif;bul,ndahar;!ghanistan0t;! 0;standard t0t0;ime|Asia/Yerevan¦a0caucasus1yerevan;m,rmenia0;! standard time|Asia/Baku¦az0baku,ganja,lankaran,sumqayit;!erbaijan0t;! standard time|Asia/Dhaka¦asia/dacca,bDcBd9jess8khul7mymensingh,na4pa3ra2s1t0;angail,ungi;aid8hib4ylhet;jshahi,ng7;b3ltan,r naogaon;gar5r0t3;ayan0singdi;ganj;na;ore;haka,inaj0;pur;hattogram,o0;milla,x's bazar;a0d,ogra;gerhat,ngladesh0rishal;! standard time|Asia/Brunei¦b0;dt,n1runei0;! darussalam time;!t|Asia/Thimphu¦asia/thimbu,b0thimphu;hutan0t;! time|Asia/Shanghai¦0:3I;1:38;2:36;3:39;4:3C;a3Eb31c2Nd2He30f2Cg26h1Qji1Ek1Bl0Ym0Wn0Tordos,p0Pq0Lrizh10s08t01wSxLyEz5;aoCh6i5ouc3unyi;bo,go0;a7en6ouk2u5; c3h33maWzh2;g2Vj1Izh2;b1Ung5o3D;jiakou5zh2;! shi xuanhua qu;ya0z27;an9i7u5;ci,e18n5;c3fu;b4c9n5ya0;cZgk2;c3g5ji,t2S;j17qu1sh16zh2;i6uc5;ha0;a6n5uyi0;di,gt2Nh1Fi0pu,t2Nx13ya0;m17n5;!g5ni0t0Eya0;t1ya0;aBe9u5;h6so0w1Bx5zh2;i,ue;a5u;i,n;i0Hn5;sh1zh2;fang5nxi1;di1;a8i6ong5;chuans0XhDli02sh1;an5eli0;j4sh0Z;i6ng5;gu,sh1;an,hec1Wyu1zh2;anmi0hAi8u5;i5zh2;h5zh2;ua;c5pi0;hu1;a7en6i5uangya14;jiaz15qi,y1;gli,ya0zh0G;n6o5s0I;gu1xi0;g5t2;h1Rqiu,rKyu;i5uan1J;aFn5o14qih0N;g5huangdH;dGh1N;an0Ting7rc,u5;ti1yang5;! H;ding0QxZ;an5eijYingbo;ch5ji0ni0to0ya0;a0o0;entoug2ianRuda5;njU;aEi8u5;anc3o6qi5;ao;he,ya0;a7jPn5upansh01;fTxia 5yi;chengguanI;n0Do5;c3y5;a0u1;i0Wn5ohek2;g5zh2;fa0;ai6un5;mi0sh1;fe0yu1;'1aAe9l4n6u5xi;jCt0W;an,c3g5i0zh2;de5li0zh2;zhE;ya0;musi,n8o5xi0;j6z5;uo;ia0;g5shF;m7xi;aFeBkt,ohhot,u5;a6i0Dlan ergi,m5n1;en;i7ng5y4;ga0s5;hi;'1b8n1;bi,f7ga0ng5ze;sh5ya0;ui;ei;i7n5rb4;d1g5;u,zh2;c3k2l5;ar;a9u5;an6i5li;l4ya0zh2;g5k2;do0yu1zh2;nsu,opi0;en7o6u5;ji1shQx4zh2;sh1;d2g5;hua0;a6eNong5;gu1hT;d6lian5ndo0qi0to0;!g;o5uk2;nghP;angHh5n,t;aAen7i5oYuG;fe0na5;! standard K;g5zh2;d5zho0;e,u;ng6o5;ya0zh2;ch7de,sh6zh5;i,ou;a,u;un;zh2;aBe5;i6n5;gbu,xi;'1h7jing5;! 5;time;ai;i7o5yan nur;di0t2;ou;c3sh1y4;an;he0;nAsia/5;ch6harb4;in;o5ungki0;ng5;qi0;da,qi0sh5ya0;an,un;ng|Asia/Urumqi¦a6changji,huoche5k3shihezi,turp2urumqi,xin1zh0;anjia4ongsh1;jiang time,yu0;an;a0orla;ramay,s2;ng;ksu,ral,sia/kas0;hgar|Asia/Nicosia¦cy0nicosia;!prus0;! (most areas)|Asia/Famagusta¦famagusta,northern cyprus|Asia/Tbilisi¦ge1kuta0tbil0;isi;!orgia0t;! 1n0;! 0;standard time|Asia/Hong_Kong¦h0kowloon,tsuen wan;k2ong0; kong0kong;! standard time;!st|Asia/Jakarta¦bScQdepPiNjKkediri,lJmGpArengasdengklPs4t2w0yogyakM;est0ib; indonesia,ern indonesia time;a0egal;n4sikmal3;ema4itubondo,outh tan3u0;kabumi,medaRra0;b0kF;aya;ge0;raN;a4e1robolinggo,urw0;akAokerto;ka1ma0rcut;laJtangsiantar;long2nbaru;daHl3mulaHruH;a1ed0;an;diun,laE;embaD;a0ember;k0mbi,vasumatra;arta;d,ndonesia0;! western;ok;i0urug;ampea,bino5leungsir,mahi,putat,rebon;a1e0injai,ogor;kasi,ngkulu;nd0tam;a0u1; aceh,r lampu0;ng|Asia/Pontianak¦borneo (westcentral),pontianak,tanjung pinang|Asia/Makassar¦b6c4denpa3indonesia central,k2l1ma0palu,samarinda,wita;kas2nado,taram;abuan bajo,oa jan7;endari,upang;sar;entral indonesia0ity of bal3;! time;a0orneo (eastsouth) sulawesi/celebesbalinusa tengarra timor (west);l0njarmasin;ikpap0;an|Asia/Jayapura¦ambon,east0indonesia eastern,jayapura,new guinea (west papua / irian jaya) malukus/moluccas,wit; indonesia,ern indonesia time|Asia/Jerusalem¦ashdod,beersheba,haifa,i2j0petah tiqwa,rishon leziyyon,tel aviv,west je1;e0mt;rusalem;d1l,srael0;! standard time;dt,t|Asia/Kolkata¦0:3C;1:3K;2:2D;3:3L;4:3I;5:38;a36b2Ec25d1Xe1Vf1Tg1Gh1Di19j14k0Ql0Lm0Dn06odis3KpWquthbull5rOsGtAu9v6warang2Nyamun1Q;a7el1Vi6;jayawa2Wsakha0IzianagD;doda2Prana12;daip0jja24lhasn1ttar pradesh;a9eYh8iru6umk0;chirap0Nnelve2p6vottiy0;a39p0;ane,iruvananthapur0Ooothuku2Zriss0;mb6njo1Y;ar0M;aCecunder4hAi9lst,o8r1Gu6;jan37r6;at,endr1D;l5nip2O;k3liguLngrau2rK;ahj20i6ri2Pya0M;mo1Nvaji08;har1Ylem,mbh25ng2t05ug0Z;a7e0Foh6;iJtak;ebare2iAj8m6nc1Htl0Burke37;ag6g6p0;und09;a6kot;hmund27sth2B;ch0p0;aAimp9roddat0u6;ducher24n6rn18;a6e;sa;ri;li,n8rbha7t6;ia2Vna;ni;chku2Ti6;ha2Gp22;a8e7izam4o6;i1Wwrang5;l0Tw del0Z;di2Kg8i0Fjaf2Fn6re2Oshik,vi mumb16;ded,g6;i,loi j1W;ercoil,p0;a9eerut,irz5o8u6yso0Z;lugu,mb11rwa1Jzaffar6;n1p0;nghyr,rad4;chili8d7harasht1Gleg08n6thu1Gu;ga0Jip0;hya,ur0W;patnH;a8u6;cknow,dhia6;na;l bahadur6t0; n1;aEhaCo9u6;kat7lt6rno1P;a2i;pal2;l6rXta,zhikode;h5ka1Kl6;am;nd6ragp0;wa;kina14l9marPnp0r6shmir,tih3;i7na6ol ba19;l,tW;mn1;lakuric04y12;a7han6odOunagadh;si;b0Sip0l7m6;mu,n1shedp0;andh3gHna;chalkaranji,mph0Jn6st;!d6;ia6o01;! standard time,n;a7is3ospet,u6;b2g2;o0Ip0ridw3;aDhazi4oAreater noi0Nu7wali6y05;or;jar0PlbarRnt0rg7wa6;ha12;aon;rak7sa6;ba;hp0;juw9n6ya;dh7g6;an1;in1;aka;ar6iroz4;id4rukh4;l6taw0M;loG;aBe9h7indigul,ombPurg6;!ap0;anb0Uul6;ia;hra dun,l6was;hi;rbhan6vange9;ga;a09h9o6uttack;ch7imbato6;re;in;a7enn6;ai;nd6pM;a6i0C;!nn1;aOeLhCiAor8rahm5u6;landshahr,rh6;anp0;iv2;li;d3har sharif,j5kan07l6;asp0imoD;aBi8op7u6;baneshw3sav6;al;l7wan6;di,i;ai,wa7;g7ratp0tpa6vn1yand3;ra;alp0;l6ngaluru;gaum,la6;ry;hBli,r7thin6;da;a7ddham6eilly;an;n1s6;at;a7rai6;gh;ramp0;gQhmLizawl,jmKkoRlHmDnant5rrBs7urang4va6;di;ans8ia/ca6;lcut6;ta;ol;ah;ap0;arnath,batt0r6;ava6its3oA;ti;ur;appuz7i6lah4w3;garh;ha;er;adn1ed4;ab6;ad;ag3;ar;arta6ra;la|Asia/Baghdad¦a4ba3dihok,erbil,i2k1mosul,na0ramadi;jaf,sirB;arbala,irkuk,uwait;q,raq;ghdad,sr9;bu ghurayb,d diw6l 5rab0s sulaym6;! 3i0;a0c;!n0;! 0;standard time;amar2basrah al qadim2falluj2hill2kut,mawsil al jadid2;an0;iy0;ah|Asia/Tehran¦aRbNgorgXhamWiKkCmaBn8orumiy7pasragad branch,q4rasht,s2t1varam6yazd,za0;hedWnjW;abHehrV;a0hirSirjU;bzevar,nandEri,v3;a0om;rchak,zv0;in;eh;a0eyshabur;jaf0zar0;ab4;layer,shh3;a4erman3ho0;meyni sErram0wy;ab0sD;ad;!shah;h1r0;aj;riz;r0sfahC;!an0dt,st;! standard time;a2irjand,o0uk9;jnu0ruje0;rd;b3ndar abbas;b4hv3m2r1zads0;hahr;ak,dabil;ol;az;ad0;an|Asia/Amman¦amm1irbid,jo0russeifa,wadi as sir,zarqa;!rd0;an|Asia/Tokyo¦0:11;1:19;a17ch15fu0Ygifu13h0Ni0Hj0EkYmSnLoJsEt8u7waka04y2;a5o2;k2no;kaic1Ao2;ha0Xsu0;maJo;ji,tsun0E;aka6o2sukuba;k4makom04y2;a0So2;hNna0ta;oro02us0Pyo04;m0Irazu0sa1tsu1;a4endZhi3o0u2;i0Yzu0;monose1zuo0;ita0Lk2ppoKsebo;ai,u05;dawa04i0Uka2sa0t0D;ya0Iza1;a5eyaga0Oi2umazu;i3shi2; tokyo0Hnomiya ha0F;ga0P;g2ha,ra0F;a2oW;no,o0sa1;a4i2orio0;na2to,yaza1;mirinkan,to;chiCeb3tsu2;do,m7ya06;as0H;aAi8o6u2y5;mam4r3shi2;ro;ashi1e,uG;oto;be,c0Bfu,ri2shigaJ;yaY;shiwa2takyushu;da;gosUkogawacho honmJmirenjaku,na7s4wa2;g2sa1;oe,uc05;hiZu2;g2kabe;ai;zaW;apan2dt,oetIp,st;! standard ti2;me;bara1chi3ta2wa1zu2;mi;ha4n2;omi2;ya;ra;a7i2oncho;meAr3t2;acP;a3os2;a1hiB;kaLtsu0;chi4kodate,mam2;at2;su;nohe,o2;ji;ji7ku2;i5o0s2ya3;hi2;ma;ka; sB;!sa5;i2ofu;ba,g4;geoshimo,k5mag3njo,omori,sahika2tsugi;wa;asa1;ki;as3i2;ta;hi|Asia/Bishkek¦bishkek,k0osh;g2yrgy0;stan,zstan0;! time;!t|Asia/Pyongyang¦chongjin,h5k3n2pyongya8s0won6;ariw0inui8unch'0;on;amp'o,orth korea;a0p;eso3nggye;a1ungnam,ye0;san;e1mhu0;ng;ju|Asia/Seoul¦anPbuMchHdaeGgChwaseoQiBjeAk7m6pohaFrok,s2u1wonJy0;aCeosu;ijeongbuPlsL;e1outh korea,u0;nEwH;joAo0;ngnamLul;asGokpo;imhae,orea0r,st,wangmyo7;! 0n 0;standard time;ju,on8;cCksBn6;angneu2oyaDu1wa0;ng5;mi,ns8riC;ng;gu,je4;angw3eon2in1un0;che2;ju;an,gju6;on;c1s0;an;heon2;san1ya0;ng0; si|Asia/Almaty¦a8central asia6east kazakhstan7k2nur sultan,p1s0taraz,ust kamenogorsk;emey,hymkent;avlodar,etropavl;a0z;ragandy,zakhstan0;! 0;(most areas),eastern;! standard0; time;lm0stana;aty,t|Asia/Qyzylorda¦kyzyl1qyzylorda0;!/kyzylorda/kzyl-0;orda|Asia/Qostanay¦k0q0;ostanay|Asia/Aqtobe¦a0;k1qt0;o1öbe/ak0;to0;be|Asia/Aqtau¦a1kazakhstan western,mangghystaū/mankis2west asia0;! standard3;lma1q0;tau; ata,-ata0; time|Asia/Atyrau¦atyra0;u,ū/atirau/gur'yev|Asia/Oral¦oral,west kazakhstan|Asia/Beirut¦bei2e1l0ra's bay2;b,ebanon;astern european standard time,urope eastern;rut|Asia/Colombo¦colombo,dehiwala mount lavinia,lk,moratuwa,sri lanka|Asia/Yangon¦asia/rango3b2kyain seikgyi township,m0nay pyi taw,pathein,sittwe,yang3;a0eiktila,m,onywa,yanmar;ndalay,wlamyine;ago,urma;on|Asia/Ulaanbaatar¦m2ula0;anbaatar0n bator,t;! standard time;n,ongolia0;! (most areas)|Asia/Hovd¦bayan-ölgiigovi-altaihovduvszavkhan,hov3w0;. mongolia 4est0; 0ern 0;mongolia;d0t;! 0;standard time|Asia/Choibalsan¦choibalsan,dornodsükhbaatar|Asia/Macau¦asia/macao,m0;acau,o|Asia/Kuala_Lumpur¦alor setar,bukit mertajEgeorge town,ipoh,johor bahDk8m4petali3s0taipiC;e1hah alDu0;ba1ngai petani;pa9remb7;ng jaya;ala0y;cca,ysia0;! 0;(peninsula),time;ampung baru suba3la3ota bha4ua0;la 1nt0;an;lumpur,terengganu;ng;ru;am|Asia/Kuching¦k2miri,s0tawau;a0ibu;bahsarawak,ndakan;ota kinabalu,uching|Asia/Kathmandu¦asia/kat3biratnagar,kath3n1p0;atan,okhara;epal,p0;!t;mandu|Asia/Manila¦an04bWcRdaPgeneral santOiMlJmCnaBoAp4quezIsan1ta0zamboanga;clobZguig,rlac,ytE; 1t0;a ro2ol;fernando,jose del monte,pab01;a3h1uerto prince0;sa;!ilippine0t; standard time,s;gadiRnalanoy,s0;ay,ig;longapo,rmoc;ga,votQ;a0eycauayN;balacat,gugpo poblaci4kati,l3n0;da1ila,silingLtamp0;ay;luyong,ue;ingDol6;on;a1egaspi,i0ucena;bertad,pa;pu lapu,s p4;l0mus;igCoiH;os;smar0v5;inB;a0ebu,otabato;b1gayan de oro,in5l0;amba,ooc6;anatu5uy0;ao;a4inan2u0;d0tu2;ta;!gon0;an;co1guio,tang0;as;lod,or;geles,tipo0;lo|Asia/Karachi¦bKchiniJdera ghaziHfaisalGgujraFhyderGislamGjhang sadr,kDlaCm7nawabshah,okaAp4quetta,ra3s0;a1h0ialkIukkM;ahkHekhupu8;ddiqDhiwal,rgodha;him yarDwalpindi;akistan1eshawar,k0;!t;! standard time;a3i1u0;lt9zaffar7;ngo0rpur khas;ra;lir cantonment,rd6;hore,rkana;a0otli;moke,rachi,s8;n5t;abad; kh0;an;ot;a1himber,ure0;wala;hawalp0ttagram;ur|Asia/Gaza¦gaza1p0;alestine,s;! strip|Asia/Hebron¦east jerusalem,hebron,west bank|Asia/Qatar¦ar rayyan,doha,qa0;!tar|Asia/Yekaterinburg¦chelyabin7eka5k4magnitogor7nizhn3or2perm,s1tyumen,ufa,yek0zlatoust;a4t;terlitamak,urgut;enburg,sk;evartov3y tagil;amensk ural'skiy,urgan;terinburg0;! standard time;sk|Asia/Omsk¦oms0;k0t;! standard time|Asia/Novosibirsk¦n0siber4;. central asia 4o0;rth central as2v0;osibirsk0t;! 1;ia;standard time|Asia/Barnaul¦b0;arnaul,iysk|Asia/Tomsk¦tomsk|Asia/Novokuznetsk¦kemerovo,novokuznet0prokop'yev0;sk|Asia/Krasnoyarsk¦kra0north asia1;snoyarsk0t;! standard time|Asia/Irkutsk¦angar2brat2irk0north asia east1ulan ude;t,utsk0;! standard time;sk|Asia/Chita¦chita|Asia/Yakutsk¦blagoveshchensk,yak0;t,utsk0;! standard time|Asia/Khandyga¦khandyga|Asia/Vladivostok¦k2vla0;divostok0t;! standard time;habarovsk0omsomolsk on amur;! vtoroy|Asia/Ust-Nera¦ust nera|Asia/Magadan¦mag0;adan0t;! standard time|Asia/Sakhalin¦sak0yuzhno sakhalinsk;halin0t;! standard time|Asia/Srednekolymsk¦chokurdakh,sre0;dnekolymsk0t;! standard time|Asia/Kamchatka¦kamchatka,pet0;ropavlovsk0t; kamchatsky,-kamchatski standard time|Asia/Anadyr¦ana0;dyr0t;! standard time|Asia/Riyadh¦a6burayd5dammam,ha4jedd5khamis mushait,me3najran,riyadh,sultan5ta2y0;anbu,e0;!men;'if,buk;cca,dina;'il,far al batin;ah;bha,l 0;hufuf,jubayl,kharj,mubarraz|Asia/Singapore¦s0woodlands;g1ingapore0;! standard time;!t|Asia/Damascus¦a4d3h2latak1sy0;!r0;ia;am2oms;amascus,eir ez zor;leppo,r raqq0;ah|Asia/Bangkok¦bangkok,ch8h6indochina3mueang nontha9na2pak kret,s0udon thani;amut prakan,e asia0i racha,outh east asia;! standard t3;khon ratchasima,m dinh;! 0;(most areas),t0;ime;a0ue;iphong,noi,t y2;iang m1on 0;buri;ai|Asia/Dushanbe¦dushanbe,t0;ajikistan1j0;!t;! time|Asia/Dili¦dili,east timor1tl0;!t;! time|Asia/Ashgabat¦as4t0;m2urkmen0;a3istan0;! standard time;!st,t;hga0ia/ashkhabad;bat|Asia/Taipei¦banqiao,h7k5roc,t0;a0w;i0oyu2;ch3n1pei0w1;! standard time;an;aohsi0eel0;ung;sinchu,ualien|Asia/Samarkand¦bukhara,nukus,qarshi,samarkand,uzbekistan 0;(west),standard time|Asia/Tashkent¦andij2namangan,qo`q2tashkent,uz0;!bekistan0t;! (east);on|Asia/Ho_Chi_Minh¦asia/saig4bien hoa,can tho,da 2ho chi minh,nha tr3qui nh4rach gia,sa dec,thi xa phu my,v0;ietnam0n,ung tau;! (south);lat,n0;ang;on|Atlantic/Bermuda¦b0;ermuda,m|Atlantic/Cape_Verde¦c0;a1v0;!t;bo verde,pe verde0;! standard time|Atlantic/Canary¦canary0las palmas de gran canaria,santa cruz de tenerife;! islands|Atlantic/Stanley¦f0stanley;alkland1k0;!st;! island0;!s0;! summer time|Atlantic/Faroe¦atlantic/faeroe,f0;aroe0o;! islands|Atlantic/South_Georgia¦gs,south georgia0;! time|Atlantic/Reykjavik¦i0reykjavik;celand,s|Atlantic/Madeira¦madeira0;! islands|Atlantic/Azores¦azo0hmt;res0st,t;! standard time|Australia/Lord_Howe¦australia/lhi,l0;h2ord howe0;! 0;island,standard time;dt,st|Australia/Hobart¦australia/1hobart,tasmania0;! (most areas);currie,tasmania|Australia/Melbourne¦australia/victoria,geelong,melbourne|Australia/Sydney¦au0c4new south wales (most areas),sydney,wollongong;!s0; east3tralia0;! eastern,/0n eastern 4;act,c0nsw;anberra;!ern0;! 0;standard time|Australia/Broken_Hill¦australia/yancowinna,broken hill,new south wales (yancowinna)|Australia/Brisbane¦a1brisbane,gold co3logan,queensland0townsville;! (most areas);e2ustralia0;/queensland,n e0;ast;dt,st|Australia/Lindeman¦lindeman,queensland (whitsunday islands)|Australia/Adelaide¦a2cen0south1;. australia 4tral0; australia;c3delaide,ustralia0; central,/south,n central0;! 0;standard time;dt,st|Australia/Darwin¦australia/north,darwin,northern territory|Australia/Perth¦a3perth,w0;. australia6est0; australia,ern australia0;! (most areas);ustralia1w0;dt,st; western,/west,n west0;!ern0; standard time|Australia/Eucla¦a0cw5eucla,western australia (eucla);cw6us0; central w2tralia0; centralwestern,n central western0;! 2;. 1e0;st;standard time;dt,st|Indian/Cocos¦c0;c3ocos0;! island0;!s0;! time;!t|Indian/Christmas¦c0;hristmas1x0;!t;! island0;! time|Indian/Chagos¦british indian ocean territory,c4i0;ndian 1o0;!t;c1ocean0;! time;hagos|Indian/Mauritius¦m0port louis;auritius1u0;!t;! standard time|Indian/Maldives¦m0;aldives1v0;!t;! time|Indian/Reunion¦r0;e1éunion0; time,crozetscattered islands;t,union|Indian/Mahe¦mahe,s0;c,eychelles0;! time|Indian/Kerguelen¦french southern2kerguelen1tf0;!t;!st paul islandamsterdam island;! 0;& antarctic time,and antarctic0;! lands|Europe/Andorra¦a0;d,ndorra|Europe/Tirane¦al1tiran0;a,e;!bania|Europe/Vienna¦a0donaustadt,favoriten,graz,linz,vienna;t,ustria|Europe/Brussels¦antwerpen,b0charleroi,gent,liege;e0russels;!lgium|Europe/Sofia¦b0plovdiv,sof2varna;g,u0;lgar0rgas;ia|Europe/Minsk¦b2h1m0viteb3;ahilyow,in2;omyel,rodna;abruy0elarus,rest,y;sk|Europe/Zurich¦geneve,li0swiss time,zurich;!echtenstein|Europe/Prague¦brno,ostrava,prague,s0;k,lovakia|Europe/Berlin¦a00bScQdOeMfrLgeJhaEkClAm4n3oberhaus04rostoBs1w0;andsbek,iesbad03uppert8;a0tuttgaL;arbrueck01xony;eue neustadt,uernbeY;a3e2iddle european,oenchengladba1u0;enst9ni0;ch;st,t;gdeSinz,nnheim,rienth0;al;eipzJuebe0;ck;a0iKoeln,rL;rlsruhe,ssJ;gPlle (saale),m1nnov0rM;er;burg0m;! 0;mitte,nord;lsenkirJrmany0;! (most areas);ankfurt am maDeiF;imsbuettArfu0ssH;rt;e,ortmund,resdFu0;esseldorf,isB;e0hemnitz;ntral europe,st,t;avaria,erl6iel5o2r0;aunschwe0emA;ig;chum0nn;! hord0;el;efeld;in;a2ltona,ugs0;bu0;rg;ch0;en|Europe/Copenhagen¦arhus,copenhagen,d0;enmark,k|Europe/Tallinn¦e0tallinn;e,stonia|Europe/Madrid¦aMbJcHeGfuenDgCjerez de la frontera,lBm8ovieFp6s1terrassa,v0zaragoza;alladol9igo;a1evilla,pain0;! (mainland);badell,n0; sebastian,t0; marti,ander,s montjuic;a0uente de vallecas;lma,mpD;a0ostolGurcF;dr0laga;id;atiEeganD;asteiz / vitorBijon,ran1;carral el par1labr0;ada;do;ixample,lche,s;a0iudad lineal;rabanchel,stello de la pla7;a0ilbao,urgos;da0rce0sque;lo4; coru3l0;cala de henar1icante,mer0;ia;es;na|Europe/Helsinki¦espoo,fi1helsinki,t0vantaa;ampere,urku;!nland|Europe/Paris¦bordeaux,ceDeurope central,frBl9m8n6paris,r3s0toulouE;aint 1t0; 0rasbourg;etienne;e1omance0;! A;ims,nn1;ant0i5ormandy;es;arsei1ontpellier;e havre,i0yon;lle;!an0;ce;ntral european 1rgy pontoi0;se;standard time|Europe/London¦a0Hb05c02dZeXgUhSiPjeOkingston upon hull,lJmHnBoxTp9reading,s1w0yF;arwick05igan,olverha7;heffield,o3t2u1w0;an4iH;ffolk,nderland,sUttM;afOoke on tre05;meUuth0;a1end on 0;sea;mptH;ly0orts0restG;mouth;ew4o0;r0ttinghamO;th0wD; y0amptonM;orkQ;castle upon tyne,port;ancheLi0;dlan4lton keynes;ancaMdn,e2i1o0ut6;nd5;ncolnKverP;e0icesterE;ds;!rsQ;psw1slingt0;on;ich;ampDert0;fordC;b1l0mt standard time;asgow,oucesterA;!-eA;dinburgh,s0urope/belI;sex;erby1o0udlF;rset;!sh5;a1ity of westmin0oventry,rawlC;ster;mbridge1rdiff;e8ir7lack5r2st,uckingham0;sh0;ire;adford,e1i0;st2tish;nt;po0;ol;kenhead,mingham;l1xl0;ey;fast;berdeen,rchway|Europe/Gibraltar¦gi0;!braltar|Europe/Athens¦athens,gr0thessaloniki;!eece|Europe/Budapest¦budapest,debrecen,hu0;!ngary|Europe/Dublin¦cork,dublin,eire,i0;e,reland|Europe/Rome¦b9c8florence,genoa,m7naples,p4rome,sicily,t2v0;a0eroA;!tican city;aran2rieste,u0;rin,scany;a1ra0;to;dova,lermo;essi3ilan;atan1orsica;ari,olog1resc0;ia;na|Europe/Vilnius¦k1l0vilnius;ithuania,t;aunas,laipeda|Europe/Luxembourg¦lu0;!xembourg|Europe/Riga¦e1kalt,l0riga;atvia,v;ast europe,e0;st,t|Europe/Monaco¦m0;c,onaco|Europe/Chisinau¦chisinau,europe/tiraspol,m0;d,oldova|Europe/Malta¦m0;alta,t|Europe/Amsterdam¦a3eindhov2groning2n1rot4t0utrecht;he hague,ilburg;etherlands,l;en;lmere stad,ms0;terdam|Europe/Oslo¦berg1oslo,s0;j,valbard and jan may0;en|Europe/Warsaw¦bDczestochowa,g9k7l5mokot8p3radFs2torun,w0zabrze;ars0rocl0;aw;osnowiec,zczec3;l,o0raga poludnie;land,znan;odz,ubl0;in;ato2iel3rak0;ow;d2li0;wi0;ce;ansk,ynia;i2y0;dgoszcz,t0;om;alystok,elsko biala|Europe/Lisbon¦amadora,europe western,lisbon,p2we0;st0t;! europe,ern european standard time;ort0t;o,ugal0;! (mainland)|Europe/Bucharest¦b3c2gala1iasi,oradea,ploies1ro0timisoara;!mania;ti;luj napoca,onstanta,raiova;ra0ucharest;ila,sov|Europe/Belgrade¦belgrade,n1pristina,s0;i,lovenia;is,ovi sad|Europe/Kaliningrad¦kaliningrad|Europe/Moscow¦ar0Cb09c06dzerzh05fet,grozn04ivano03kXlipet0EmQnMorel,pJrFs8t6v2w-su,y0zelenograd;a0oshkar oV;roslavl,sene01;asyl'evsky ostrHelikiLladi2o0ykhino zhulebS;l0ronezh;gograOogda;kavkaz,m07;a0uPver;ganrog,mbC;a4ever3hakhty,molen05ochi,t0yktyvkQ; 4a0;ryy osk0vrop0;ol;nRodvS;int 0rW;petersburg;ostov na donu,u1y0;azKbO;!ssia0;!n9;e1odolUsk0;ov;nza,trozavodS;a2izhn0ovorossiyR;ekamQi0;y novM;berezhnyye chelny,l'chik;a3dst,oscow1s0urmJ;d,k;! standar0;d time;khachka1r'0;ino;la;a2himki,ostroma,rasno0urG;d0gvargeisky;ar;l1z0;an;ininsk5uga;vo;yy;in8;entraln1he0;boksary,repovets;iy;el1ry0;an3;gorod;khangel'1mav0;ir;sk|Europe/Simferopol¦simferopol|Europe/Kirov¦kirov|Europe/Volgograd¦vol0;gograd,t,zhskiy|Europe/Astrakhan¦astrakhan|Europe/Saratov¦balakovo,saratov|Europe/Ulyanovsk¦ulyanovsk|Europe/Samara¦izhevsk,s0togliatti on the volga;am0yzran;ara0t;! standard time|Europe/Stockholm¦goeteborg,malmoe,s0;e,tockholm,weden|Europe/Istanbul¦a00bUcSdQeNgMiKkImDosmCs6t1u0v07zeytinburnu;eskuedYmrB;arsus,r3urkey0;! 0;standard t0t0;ime;!abzon,t;a3i1ultan0;beyJgazi;sIv0;as,erek;msun,n0;cakt5liurfa;aniye;a1er0uratpaH;kezefendi,sin;l0niF;atOt0;epe;a0irikkale,onMutahM;hramanmaras,rabaglFyseP;stanbul,zmi0;r,t;aziantep,ebze;lazig,rzurum,s0;en0kiC;l8yurt;eniz0iyarbakB;li;ankaCor0;lu,um;a1ur0;sa;gcil2hcelievl1likes5sak4t0;ikent,m9;er;ar;d5n2rnavutkoey,ta0;seh0;ir;kara,ta0;k0l0;ya;a1iyam0;an;na,paza0;ri|Europe/Kiev¦bila tserkHcherEdChorlBivano frankivDk7l6m4odessa,poltaHrivne,sumy,ternopil,u2vinnyts1z0;aporizhzh0hytomyr;ya;a,kraine0;! (most areas);a0ykolayB;ki5riupol;ut6v9;amyanske,h1iev,r0y8;emenchuk,opyv1yvyy rih;ark6erson,mel0;nytskyy;ivka;nipro,onet0;sk;kasy,ni0;h0vtsi;iv;va|Europe/Uzhgorod¦ruthenia,uzhgorod|Europe/Zaporozhye¦luhansk,sevastopol,zaporozh0;'ye/zaporizhia lugansk/luhansk (east),ye|Antarctica/Casey¦casey0;! time|Antarctica/Davis¦a1davis0;! time;ntarctica,q|Antarctica/DumontDUrville¦dumont0;-d0d1;'0’urville time;urville|Antarctica/Mawson¦mawson0;! time|Antarctica/Palmer¦chile standard time,palmer|Antarctica/Rothera¦rothera|Antarctica/Syowa¦syowa0;! time|Antarctica/Troll¦troll0;! research station|Antarctica/Vostok¦vost0;!ok0;! time|Antarctica/Macquarie¦macquarie0;! island|Pacific/Pago_Pago¦pa0samoamidway,us1;cific0go pago;/samoa|Pacific/Rarotonga¦c0rarotonga;k2ook0;! islands0;! standard time;!t|Pacific/Easter¦chile/easterisland,e0;as0mt;st,t0;!er0;! island0;! standard time|Pacific/Galapagos¦gal0;apagos,t,ápagos islands|Pacific/Fiji¦f0;iji1j0;!st,t;! standard time|Pacific/Chuuk¦chuuk1pacific/0;truk,y1;!/truky0;ap|Pacific/Pohnpei¦f3micro4p0;acific/1f,ohnpei0;!/0;ponape;m,rench poly0;nesia|Pacific/Kosrae¦kosrae0;! time|Pacific/Guam¦ch1guam,mp,northern mariana islands,west0; pacific1ern pacific;amorro0st;! standard time|Pacific/Tarawa¦gilbert islands0tarawa;! time|Pacific/Enderbury¦enderbury,phoenix islands0;! time|Pacific/Kiritimati¦ki3line islands0;! 0;standard t0t0;ime;!ri0;bati,timati0;! island|Pacific/Majuro¦m0;a0h;juro,rshall islands0;! (most areas)|Pacific/Kwajalein¦kwajalein,marshall islands time|Pacific/Noumea¦n0;c,ew caledonia0oumea;! standard time|Pacific/Nauru¦n0;auru0r;! time|Pacific/Niue¦n0;iue1u0;!t;! time|Pacific/Auckland¦auckland,christchurch,manukau,n0wellington;ew zealand1orth shore,z0;!dt,mt,st;! 0;standard t0t0;ime|Pacific/Chatham¦cha0nz-chat;dt,st,tham0;! 0;islands0s1;! s0;tandard time|Pacific/Tahiti¦society islands,tahiti0;! time|Pacific/Marquesas¦marquesas0;! 0;islands,standard t0t0;ime|Pacific/Gambier¦gambier0;! 0;islands,time|Pacific/Port_Moresby¦p0;apua new guinea0g,ort moresby;! (most areas)|Pacific/Bougainville¦bougainville,guinea0papua new guinea time;!n|Pacific/Pitcairn¦p0;itcairn0n;! time|Pacific/Palau¦p0;alau0w;! time|Pacific/Guadalcanal¦guadalcanal,s0;b,olomon0;! islands0;! time|Pacific/Fakaofo¦fakaofo,t0;k1okelau0;! time;!t|Pacific/Tongatapu¦nuku'alofa,to0;!nga0;! standard time,tapu|Pacific/Funafuti¦funafuti,t0;uvalu0v;! time|Pacific/Wake¦u2wake0;! island0;! time;m,s minor outlying islands|Pacific/Honolulu¦aleutian2h0pacific/johnston,us/hawaii;awaii0onolulu,st;! aleutian,-aleutian 1;! 0;standard time|Pacific/Efate¦efate,v0;anuatu0u;! standard time|Pacific/Wallis¦w0;allis0f;! 0;& futuna time,and futuna|Pacific/Apia¦apia,s2w0;est0s; samoa time,ern s0;amoa|ETC/GMT¦gmt|Etc/GMT¦coordinated universal1greenwich0;! mean0; time|Etc/UTC¦etc/uct,u0zulu;ct,niversal,tc|America/Argentina¦arNbKcHformosa,jGla EmBneuquen,pAquilmJr9sa1t0;ierra del fuego (tLucumán (tm);lta6n0; 2t0;a 0iago del estero;cruz (sc),fe;juan1luis0miguel de tucuman,salvador de jujuy;! (sl);! (sj);! (salpnqrn);esistencia,osario;araDilar,osadas;ar del p3e0oron;ndoza0rlo;! (mz);p0rioja (lr);lata;ose c paz,ujuy (jy);atamarca (ct) chubut (ch),or0;doba,rient0;es;ahia blanca,uenos aires0;! (bac0;f);!genti0;na|Australia/Currie¦tasmania (king island)|America/Godthab¦g3w0;est greenland1g0;st,t;! s3;l,reenland0;! 0;(most areas),s0western;tandard time|America/Kentucky¦eastern - ky (0louisville;louisville area),wayne)|America/Indiana¦central 3eastern - in (0fort wayne,indianapolis;crawfor1dadukmn),most areas),p0switzerlan1;i3ulaski);d);- in (0standard time;perry),star0;ke)|America/North_Dakota¦central - nd (0;m0oliv1;erc0orton rural);er)|Africa/Kinshasa¦c3ki2m0;a0bandaka;sina,tadi;kwit,nshasa;d,ongo|Africa/Luanda¦huambo,l0n'dalatando;obito,uanda|Africa/Addis_Ababa¦addis ababa,dire dawa,mek'ele,nazret|Africa/Dar_es_Salaam¦arusha,d1m0tanga,zanzibar;beya,orogoro,wanza;ar es salaam,odoma|Africa/Mogadishu¦berbera,hargeysa,jamaame,kismayo,m0;arka,ogadishu|Africa/Dakar¦dakar,pikine,t0;hies0ouba;! nones|Asia/Aden¦a0ibb,mukalla,sanaa,taiz;den,l hudaydah|Africa/Conakry¦c0;amayenne,onakry|Asia/Phnom_Penh¦ict,phnom penh,takeo|Africa/Harare¦bulawayo,chitungwiza,har0mut0;are|Indian/Antananarivo¦ant0toamasina;ananarivo,sirabe|Africa/Lubumbashi¦b3k2l1m0tshikapa;buji mayi,wene ditu;ikasi,ubumbashi;ananga,isanga1olwezi;e0ukavu;ni|Africa/Kampala¦kampala|Africa/Douala¦b1douala,edea,gar2kousseri,loum,m0ngaoundere,yaounde;ar1okolo;a1ert0;oua;foussam,menda|Africa/Bamako¦bamako|Africa/Brazzaville¦brazzaville,pointe noire|Africa/Lusaka¦k0lusaka,ndola;ab0it0;we|Africa/Ouagadougou¦bobo dioulasso,ouagadougou|Africa/Freetown¦freetown|Asia/Muscat¦muscat,seeb|Africa/Porto-Novo¦abomey calavi,coton0djoug0porto novo;ou|Africa/Niamey¦niamey,zinder|Africa/Lome¦lome|Africa/Kigali¦kigali|Europe/Zagreb¦split,zagreb|Europe/Sarajevo¦banja luka,sarajevo|Africa/Nouakchott¦nouakchott|Africa/Blantyre¦blantyre,lilongwe,mzuzu|Asia/Kuwait¦al ahmadi|Africa/Djibouti¦djibouti|Africa/Libreville¦libreville|Africa/Asmara¦asmara|Africa/Bangui¦bangui|Europe/Skopje¦skopje|Europe/Bratislava¦bratislava,kosice|Africa/Banjul¦serekunda|Africa/Bujumbura¦bujumbura|Europe/Ljubljana¦ljubljana|Europe/Podgorica¦podgorica|Africa/Gaborone¦gaborone|Asia/Vientiane¦vientiane|Asia/Saigon¦ho chi minh city|America/Port_Of_Spain¦vi0;!rgin islands|America/Port-au-prince¦h0;aiti,t|Pacific/Norfolk¦n0;f,orfolk 0;island0s1;! s0;tandard time|America/Buenos_Aires¦ar0;gentina standard time,st,t|Pacific/Midway¦s0;amoa standard time,dt,st|Asia/Katmandu¦nepal 0;standard t0t0;ime|Asia/Rangoon¦myanmar 0;standard t0t0;ime|Pacific/Truk¦chuuk time,truk|Pacific/Ponape¦ponape0;! time|America/Santa_Isabel¦mexico northwest,northwest mexico standard time,pacific 0;mexico,standard time (mexico)|Brazil/Acre¦act|Asia/Thimbu¦btt");
Ta = Object.assign(Ta, { "gmt+0": "etc/Gmt", "gmt-0": "etc/Gmt", gmt0: "etc/Gmt", "etc/gmt+0": "Etc/Gmt", "etc/gmt-0": "Etc/Gmt", "etc/gmt0": "Etc/Gmt", "msk-01 - kaliningrad": "Europe/Kaliningrad", "msk+00 - moscow area": "Europe/Moscow", "msk+00 - crimea": "Europe/Simferopol", "msk+00 - volgograd": "Europe/Volgograd", "msk+00 - kirov": "Europe/Kirov", "msk+01 - astrakhan": "Europe/Astrakhan", "msk+01 - saratov": "Europe/Saratov", "msk+01 - ulyanovsk": "Europe/Ulyanovsk", "msk+01 - samaraudmurtia": "Europe/Samara", "msk+02 - urals": "Asia/Yekaterinburg", "msk+03 - omsk": "Asia/Omsk", "msk+04 - novosibirsk": "Asia/Novosibirsk", "msk+04 - altai": "Asia/Barnaul", "msk+04 - tomsk": "Asia/Tomsk", "msk+04 - kemerovo": "Asia/Novokuznetsk", "msk+04 - krasnoyarsk area": "Asia/Krasnoyarsk", "msk+05 - irkutskburyatia": "Asia/Irkutsk", "msk+06 - zabaykalsky": "Asia/Chita", "msk+06 - lena river": "Asia/Yakutsk", "msk+06 - tomponskyust-maysky": "Asia/Khandyga", "msk+07 - amur river": "Asia/Vladivostok", "msk+07 - oymyakonsky": "Asia/Ust-Nera", "msk+08 - magadan": "Asia/Magadan", "msk+08 - sakhalin island": "Asia/Sakhalin", "msk+08 - sakha (e) north kuril is": "Asia/Srednekolymsk", "msk+09 - kamchatka": "Asia/Kamchatka", "msk+09 - bering sea": "Asia/Anadyr", "antarctica/south_pole": "Pacific/Auckland", "america/buenos_aires": "America/Argentina/Buenos_Aires", "america/coral_harbour": "America/Atikokan", "america/fort_wayne": "America/Indiana/Indianapolis", "america/knox_in": "America/Indiana/Knox", "america/porto_acre": "America/Rio_Branco", "america/santa_isabel": "America/Tijuana", "asia/tel_aviv": "Asia/Jerusalem", "asia/ujung_pandang": "Asia/Makassar", "asia/ulan_bator": "Asia/Ulaanbaatar", "atlantic/jan_mayen": "Europe/Oslo" }), Object.keys(Ta).filter((e) => {
  let t = Ta[e];
  typeof t == "string" && (t = t.toLowerCase(), Ta[t] === void 0 && (Ta[t] = Ta[e]));
});
const mpc = function(e) {
  if (!e)
    return null;
  if (e = e.toLowerCase().trim(), Ta.hasOwnProperty(e))
    return Ta[e];
  if (/[0-9]/.test(e)) {
    let n = function(o) {
      let r = o.match(upc);
      if (r !== null || (r = o.match(_pc), r !== null))
        return MS(r[1]);
      if (r = o.match(ppc), r !== null) {
        let i = -1 * Number(r[1]);
        return MS(i);
      }
      return r = o.match(dpc), r !== null ? MS(r[1]) : null;
    }(e);
    if (n)
      return [n];
  }
  if (e = e.replace(/^in /g, "").replace(/ time/g, "").replace(/ (standard|daylight|summer)/g, "").replace(/ - .*/g, "").replace(/, .*/g, "").trim(), Ta.hasOwnProperty(e))
    return Ta[e];
  let t = e + " time";
  return Ta.hasOwnProperty(t) ? Ta[t] : (t = e + " standard time", Ta.hasOwnProperty(t) ? Ta[t] : (e = function(n) {
    return (n = (n = (n = (n = (n = n.replace(/\b(east|west|north|south)ern/g, "$1")).replace(/\b(africa|america|australia)n/g, "$1")).replace(/\beuropean/g, "europe")).replace(/\islands/g, "island")).replace(/.*\//g, "")).trim();
  }(e), Ta.hasOwnProperty(e) ? Ta[e] : (e = function(n) {
    return (n = n.replace(/\(.*\)/, "")).trim();
  }(e), Ta.hasOwnProperty(e) ? Ta[e] : (t = e + " time", Ta.hasOwnProperty(t) ? Ta[t] : (t = e + " standard time", Ta.hasOwnProperty(t) ? Ta[t] : null)))));
};
var fpc = [{ name: "India Time", abbr: null, aliases: ["india", "indian", "india standard time", "chennai", "kolkata", "mumbai", "new delhi"], ids: ["Asia/Kolkata", "Asia/Calcutta", "Asia/Colombo"], std: { name: "India Standard Time", abbr: "IST", offset: 5.5 }, dst: {}, long: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", hem: "n" }, { name: "China Time", abbr: null, aliases: ["china", "china standard time", "beijing", "chongqing", "hong kong", "urumqi"], ids: ["Asia/Shanghai", "Asia/Macau", "Asia/Urumqi"], std: { abbr: "CST", name: "China Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", hem: "n" }, { name: "Central European Time", abbr: null, aliases: ["europe central", "romance standard time", "brussels", "copenhagen", "madrid", "paris", "romance"], ids: ["Europe/Paris", "Africa/Ceuta", "Arctic/Longyearbyen", "Europe/Amsterdam", "Europe/Andorra", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Budapest", "Europe/Busingen", "Europe/Copenhagen", "Europe/Gibraltar", "Europe/Ljubljana", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Monaco", "Europe/Oslo", "Europe/Podgorica", "Europe/Prague", "Europe/Rome", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Skopje", "Europe/Stockholm", "Europe/Tirane", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zurich"], std: { abbr: "CET", name: "Central European Standard Time", offset: 1 }, dst: { abbr: "CEST", name: "Central European Summer Time", offset: 2 }, long: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris", hem: "n" }, { name: "", dupe: !0, ids: ["America/Puerto_Rico", "America/Montserrat", "America/Port_of_Spain", "America/Santo_Domingo", "America/St_Barthelemy", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Tortola", "America/Grenada", "America/Guadeloupe", "America/Kralendijk", "America/Lower_Princes", "America/Marigot", "America/Martinique", "America/Anguilla", "America/Antigua", "America/Aruba", "America/Barbados", "America/Blanc-Sablon", "America/Curacao", "America/Dominica"], std: { name: "Atlantic Standard Time", abbr: "AST", offset: -4 }, dst: {}, hem: "n" }, { name: "Greenwich Mean Time", abbr: null, aliases: ["gmt", "zulu", "utc", "coordinated universal time"], ids: ["Etc/GMT", "Africa/Abidjan", "Africa/Accra", "Africa/Bamako", "Africa/Banjul", "Africa/Bissau", "Africa/Conakry", "Africa/Dakar", "Africa/Freetown", "Africa/Lome", "Africa/Monrovia", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Sao_Tome", "America/Danmarkshavn", "Atlantic/Reykjavik", "Atlantic/St_Helena", "Etc/UTC"], std: { name: "Greenwich Mean Time", abbr: "GMT", offset: 0 }, dst: {}, long: "(UTC) Coordinated Universal Time", hem: "n" }, { name: "Eastern European Time", abbr: null, aliases: ["europe eastern"], ids: ["Asia/Beirut", "Asia/Famagusta", "Asia/Nicosia", "Europe/Athens", "Europe/Bucharest", "Europe/Chisinau", "Europe/Helsinki", "Europe/Kiev", "Europe/Mariehamn", "Europe/Riga", "Europe/Sofia", "Europe/Tallinn", "Europe/Uzhgorod", "Europe/Vilnius", "Europe/Zaporozhye"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, dst: { abbr: "EEST", name: "Eastern European Summer Time", offset: 3 }, hem: "n" }, { name: "", dupe: !0, ids: ["America/Indiana", "America/North_Dakota", "America/Belize", "America/Costa_Rica", "America/El_Salvador", "America/Guatemala", "America/Indiana/Knox", "America/Indiana/Tell_City", "America/Managua", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Regina", "America/Swift_Current", "America/Tegucigalpa"], std: { name: "Central Standard Time", abbr: "CST", offset: -6 }, hem: "n" }, { name: "Eastern Time", abbr: "ET", aliases: ["america eastern", "eastern standard time", "eastern"], ids: ["America/New_York", "America/Detroit", "America/Grand_Turk", "America/Indianapolis", "America/Iqaluit", "America/Louisville", "America/Nassau", "America/Nipigon", "America/Pangnirtung", "America/Port-au-Prince", "America/Thunder_Bay", "America/Toronto", "America/Montreal", "America/Kentucky"], std: { name: "Eastern Standard Time", abbr: "EST", offset: -5 }, dst: { name: "Eastern Daylight Time", abbr: "EDT", offset: -4 }, long: "(UTC-05:00) Eastern Time (US & Canada)", hem: "n" }, { name: "Argentina Time", abbr: "ART", aliases: ["argentina", "arst", "argentina standard time", "buenos aires"], ids: ["America/Buenos_Aires", "America/Argentina/La_Rioja", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Catamarca", "America/Cordoba", "America/Jujuy", "America/Mendoza", "Antarctica/Rothera", "America/Argentina"], std: { name: "Argentina Standard Time", abbr: "ART", offset: -3 }, dst: {}, long: "(UTC-03:00) City of Buenos Aires", hem: "s" }, { name: "", dupe: !0, ids: ["America/Coral_Harbour", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Kentucky/Monticello", "America/Cancun", "America/Cayman", "America/Jamaica", "America/Panama"], std: { name: "Eastern Standard Time", abbr: "EST", offset: -5 }, hem: "n" }, { name: "East Africa Time", abbr: null, aliases: ["africa eastern", "e. africa standard time", "nairobi", "east africa", "eastern africa"], ids: ["Africa/Nairobi", "Africa/Addis_Ababa", "Africa/Asmera", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Kampala", "Africa/Mogadishu", "Indian/Comoro", "Indian/Mayotte"], std: { name: "East Africa Time", abbr: "EAT", offset: 3 }, dst: {}, long: "(UTC+03:00) Nairobi", hem: "n" }, { name: "West Africa Time", abbr: "WAT", aliases: ["africa western", "wast", "western africa", "w. central africa standard time", "west central africa", "w. central africa"], ids: ["Africa/Lagos", "Africa/Bangui", "Africa/Douala", "Africa/Libreville", "Africa/Malabo", "Africa/Ndjamena", "Africa/Niamey", "Africa/Porto-Novo"], std: { name: "West Africa Standard Time", abbr: "WAT", offset: 1 }, long: "(UTC+01:00) West Central Africa", hem: "n" }, { name: "Moscow Time", abbr: null, aliases: ["moscow", "russian standard time", "st. petersburg", "russian", "volgograd time"], ids: ["Europe/Moscow", "Europe/Astrakhan", "Europe/Minsk", "Europe/Simferopol", "Europe/Ulyanovsk", "Europe/Kirov", "Europe/Volgograd", "Asia/Volgograd"], std: { abbr: "MSK", name: "Moscow Standard Time", offset: 3 }, dst: {}, long: "(UTC+03:00) Moscow, St. Petersburg", hem: "n" }, { name: "Brasilia Time", abbr: null, aliases: ["brasilia", "e. south america standard time", "east south america"], ids: ["America/Sao_Paulo", "America/Araguaina", "America/Bahia", "America/Belem", "America/Fortaleza", "America/Maceio", "America/Recife", "America/Santarem"], std: { abbr: "BRT", name: "Brasilia Standard Time", offset: -3 }, dst: {}, long: "(UTC-03:00) Brasilia", hem: "s" }, { name: "Mountain Time", abbr: "MT", aliases: ["america mountain", "mountain standard time", "mountain"], ids: ["America/Boise", "America/Cambridge_Bay", "America/Denver", "America/Edmonton", "America/Inuvik", "America/Ojinaga", "America/Yellowknife"], std: { name: "Mountain Standard Time", abbr: "MST", offset: -7 }, dst: { name: "Mountain Daylight Time", abbr: "MDT", offset: -6 }, long: "(UTC-07:00) Mountain Time (US & Canada)", hem: "n" }, { name: "Central Time", abbr: "CT", aliases: ["america central", "central standard time", "central"], ids: ["America/Chicago", "America/Matamoros", "America/Menominee", "America/Rainy_River", "America/Rankin_Inlet", "America/Resolute", "America/Winnipeg"], std: { name: "Central Standard Time", abbr: "CST", offset: -6 }, dst: { name: "Central Daylight Time", abbr: "CDT", offset: -5 }, long: "(UTC-06:00) Central Time (US & Canada)", hem: "n" }, { name: "Central Africa Time", abbr: null, aliases: ["africa central", "namibia standard time", "windhoek", "namibia"], ids: ["Africa/Windhoek", "Africa/Gaborone", "Africa/Harare", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Maputo"], std: { name: "Central Africa Time", abbr: "CAT", offset: 2 }, dst: {}, long: "(UTC+02:00) Windhoek", hem: "s" }, { name: "Arabian Time", abbr: null, aliases: ["arabian", "arab standard time", "kuwait", "riyadh", "arab", "arabia", "arabic"], ids: ["Asia/Baghdad", "Asia/Aden", "Asia/Bahrain", "Asia/Kuwait", "Asia/Qatar", "Asia/Riyadh"], std: { abbr: "AST", name: "Arabian Standard Time", offset: 3 }, dst: {}, long: "(UTC+03:00) Kuwait, Riyadh", hem: "n" }, { name: "Alaska Time", abbr: "AKT", aliases: ["alaska", "alaskan standard time", "alaskan"], ids: ["America/Anchorage", "America/Juneau", "America/Metlakatla", "America/Nome", "America/Sitka", "America/Yakutat"], std: { name: "Alaska Standard Time", abbr: "AKST", offset: -9 }, dst: { name: "Alaska Daylight Time", abbr: "AKDT", offset: -8 }, long: "(UTC-09:00) Alaska", hem: "n" }, { name: "Atlantic Time", abbr: "AT", aliases: ["atlantic", "atlantic standard time"], ids: ["America/Halifax", "America/Glace_Bay", "America/Goose_Bay", "America/Moncton", "America/Thule", "Atlantic/Bermuda"], std: { name: "Atlantic Standard Time", abbr: "AST", offset: -4 }, dst: { name: "Atlantic Daylight Time", abbr: "ADT", offset: -3 }, long: "(UTC-04:00) Atlantic Time (Canada)", hem: "n" }, { name: "British Time", abbr: null, aliases: ["gmt", "gmt standard time", "dublin", "edinburgh", "lisbon", "london"], ids: ["Europe/London", "Europe/Dublin", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Jersey"], std: { name: "Greenwich Mean Time", abbr: "GMT", offset: 0 }, dst: { name: "British Summer Time", abbr: "BST", offset: 1 }, long: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London", hem: "n" }, { name: "Central Africa Time", dupe: !0, ids: ["Africa/Blantyre", "Africa/Bujumbura", "Africa/Juba", "Africa/Khartoum", "Africa/Kigali"], std: { name: "Central Africa Time", abbr: "CAT", offset: 2 }, dst: {}, hem: "n" }, { name: "West Kazakhstan Time", abbr: null, aliases: ["kazakhstan western", "west asia standard time", "ashgabat", "tashkent", "west asia", "alma ata"], ids: ["Asia/Aqtau", "Asia/Aqtobe", "Asia/Atyrau", "Asia/Oral", "Asia/Qyzylorda"], std: { abbr: "ALMT", name: "Alma-Ata Time", offset: 5 }, dst: {}, long: "(UTC+05:00) Ashgabat, Tashkent", hem: "n" }, { name: "Eastern Australia Time", abbr: "AET", aliases: ["australia eastern", "aus eastern standard time", "canberra", "melbourne", "sydney", "aus eastern", "aus east"], ids: ["Australia/Sydney", "Antarctica/Macquarie", "Australia/Currie", "Australia/Hobart", "Australia/Melbourne"], std: { name: "Australian Eastern Standard Time", abbr: "AEST", offset: 10 }, dst: { name: "Australian Eastern Daylight Time", abbr: "AEDT", offset: 11 }, long: "(UTC+10:00) Canberra, Melbourne, Sydney", hem: "s" }, { name: "Western European Time", abbr: null, aliases: ["europe western"], ids: ["Europe/Lisbon", "Atlantic/Canary", "Atlantic/Faeroe", "Atlantic/Madeira"], std: { abbr: "WET", name: "Western European Standard Time", offset: 0 }, dst: { abbr: "WEST", name: "Western European Summer Time", offset: 1 }, hem: "n" }, { name: "Indochina Time", abbr: null, aliases: ["indochina", "se asia standard time", "bangkok", "hanoi", "jakarta", "se asia", "south east asia"], ids: ["Asia/Bangkok", "Asia/Phnom_Penh", "Asia/Saigon", "Asia/Vientiane"], std: { abbr: "ICT", name: "Indochina Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Bangkok, Hanoi, Jakarta", hem: "n" }, { name: "", dupe: !0, abbr: "MT", std: { name: "Mountain Standard Time", abbr: "MST", offset: -7 }, ids: ["America/Phoenix", "America/Creston", "America/Dawson_Creek", "America/Fort_Nelson"], hem: "n" }, { name: "Central Mexico Time", long: "(UTC-06:00) Guadalajara, Mexico City, Monterrey", aliases: ["guadalajara", "mexico city", "monterrey", "central mexico", "central mexican"], ids: ["America/Mexico_City", "America/Merida", "America/Monterrey", "America/Bahia_Banderas"], std: { name: "Central Standard Time", abbr: "CST", offset: -6 }, dst: { name: "Central Daylight Time", abbr: "CDT", offset: -5 }, hem: "n" }, { name: "West Africa Time", dupe: !0, ids: ["Africa/Luanda", "Africa/Kinshasa", "Africa/Brazzaville"], std: { name: "West Africa Standard Time", abbr: "WAT", offset: 1 }, hem: "s" }, { name: "", dupe: !0, ids: ["Africa/Cairo", "Africa/Tripoli", "Europe/Kaliningrad"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, hem: "n" }, { name: "South Africa Time", abbr: null, aliases: ["africa southern", "south africa standard time", "harare", "pretoria", "south africa"], ids: ["Africa/Johannesburg", "Africa/Maseru", "Africa/Mbabane"], std: { name: "South Africa Standard Time", abbr: "SAST", offset: 2 }, dst: {}, long: "(UTC+02:00) Harare, Pretoria", hem: "s" }, { name: "Krasnoyarsk Time", abbr: null, aliases: ["krasnoyarsk", "north asia standard time", "north asia"], ids: ["Asia/Krasnoyarsk", "Asia/Novokuznetsk", "Asia/Barnaul"], std: { abbr: "KRAT", name: "Krasnoyarsk Standard Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Krasnoyarsk", hem: "n" }, { name: "Yakutsk Time", abbr: null, aliases: ["yakutsk", "yakutsk standard time"], ids: ["Asia/Yakutsk", "Asia/Chita", "Asia/Khandyga"], std: { abbr: "YAKT", name: "Yakutsk Standard Time", offset: 9 }, dst: {}, long: "(UTC+09:00) Yakutsk", hem: "n" }, { name: "Pacific Time", abbr: "PT", aliases: ["america pacific", "pacific standard time", "pacific"], ids: ["America/Los_Angeles", "America/Tijuana", "America/Vancouver"], std: { name: "Pacific Standard Time", abbr: "PST", offset: -8 }, dst: { name: "Pacific Daylight Time", abbr: "PDT", offset: -7 }, long: "(UTC-08:00) Pacific Time (US & Canada)", hem: "n" }, { name: "Amazon Time", abbr: null, aliases: ["amazon", "central brazilian standard time", "cuiaba", "central brazilian", "central brazil"], ids: ["America/Boa_Vista", "America/Manaus", "America/Porto_Velho"], std: { abbr: "AMT", name: "Amazon Standard Time", offset: -4 }, dst: {}, long: "(UTC-04:00) Cuiaba", hem: "n" }, { name: "Morocco Standard Time", offset: 1, long: "(UTC+00:00) Casablanca", aliases: ["casablanca", "morocco"], ids: ["Africa/Casablanca", "Africa/El_Aaiun"], std: { abbr: "WET", name: "Western European Standard Time", offset: 1 }, dst: { abbr: "WEST", name: "Western European Summer Time", offset: 0 }, hem: "n" }, { name: "", dupe: !0, ids: ["Africa/Algiers", "Africa/Tunis"], std: { abbr: "CET", name: "Central European Standard Time", offset: 1 }, dst: { abbr: "CEST", name: "Central European Summer Time", offset: 2 }, hem: "n" }, { name: "", dupe: !0, ids: ["Asia/Gaza", "Asia/Hebron"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, hem: "n" }, { name: "", dupe: !0, ids: ["Asia/Damascus", "Asia/Amman"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, hem: "n" }, { name: "Gulf Time", abbr: null, aliases: ["gulf", "arabian standard time", "abu dhabi", "muscat", "arabian"], ids: ["Asia/Dubai", "Asia/Muscat"], std: { name: "Gulf Standard Time", abbr: "GST", offset: 4 }, dst: {}, long: "(UTC+04:00) Abu Dhabi, Muscat", hem: "n" }, { name: "Samara Time", abbr: null, aliases: ["samara", "russia time zone 3", "izhevsk"], ids: ["Europe/Samara", "Europe/Saratov"], std: { abbr: "SAMT", name: "Samara Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Izhevsk, Samara", hem: "n" }, { name: "Uzbekistan Time", abbr: null, aliases: ["uzbekistan"], ids: ["Asia/Samarkand", "Asia/Tashkent"], std: { abbr: "UZT", name: "Uzbekistan Standard Time", offset: 5 }, dst: {}, hem: "n" }, { name: "East Kazakhstan Time", abbr: null, aliases: ["kazakhstan eastern", "central asia standard time", "astana", "central asia"], ids: ["Asia/Almaty", "Asia/Qostanay"], std: { abbr: "ALMT", name: "East Kazakhstan Time", offset: 6 }, dst: {}, long: "(UTC+06:00) Astana", hem: "n" }, { name: "Omsk Time", abbr: null, aliases: ["omsk", "omsk standard time"], ids: ["Asia/Omsk", "Asia/Tomsk"], std: { abbr: "OMST", name: "Omsk Standard Time", offset: 6 }, dst: {}, long: "(UTC+06:00) Omsk", hem: "n" }, { name: "Western Indonesia Time", abbr: null, aliases: ["indonesia western"], ids: ["Asia/Jakarta", "Asia/Pontianak"], std: { name: "Western Indonesia Time", abbr: "WIB", offset: 7 }, dst: {}, hem: "s" }, { name: "Ulaanbaatar Time", abbr: null, aliases: ["mongolia", "ulaanbaatar standard time", "ulaanbaatar"], ids: ["Asia/Ulaanbaatar", "Asia/Choibalsan"], std: { abbr: "ULAT", name: "Ulaanbaatar Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Ulaanbaatar", hem: "n" }, { name: "Malaysia Time", abbr: null, aliases: ["malaysia"], ids: ["Asia/Kuala_Lumpur", "Asia/Kuching"], std: { name: "Malaysia Time", abbr: "MYT", offset: 8 }, dst: {}, hem: "s" }, { name: "Korean Time", abbr: null, aliases: ["korea", "korea standard time", "seoul"], ids: ["Asia/Seoul", "Asia/Pyongyang"], std: { abbr: "KST", name: "Korean Standard Time", offset: 9 }, dst: {}, long: "(UTC+09:00) Seoul", hem: "n" }, { name: "Central Australia Time", abbr: "ACT", aliases: ["australia central", "cen. australia standard time", "adelaide", "central australia"], ids: ["Australia/Adelaide", "Australia/Broken_Hill"], std: { name: "Australian Central Standard Time", abbr: "ACST", offset: 9.5 }, dst: { name: "Australian Central Daylight Time", abbr: "ACDT", offset: 10.5 }, long: "(UTC+09:30) Adelaide", hem: "s" }, { name: "Brisbane Time", dupe: !0, ids: ["Australia/Brisbane", "Australia/Lindeman"], std: { name: "Australian Eastern Standard Time", abbr: "AEST", offset: 10 }, hem: "s" }, { name: "Vladivostok Time", abbr: null, aliases: ["vladivostok", "vladivostok standard time"], ids: ["Asia/Vladivostok", "Asia/Ust-Nera"], std: { abbr: "VLAT", name: "Vladivostok Standard Time", offset: 10 }, dst: {}, long: "(UTC+10:00) Vladivostok", hem: "n" }, { name: "Chamorro Time", abbr: null, aliases: ["chamorro", "west pacific standard time", "guam", "port moresby", "west pacific", "western pacific"], ids: ["Pacific/Guam", "Pacific/Saipan"], std: { name: "Chamorro Standard Time", abbr: "ChST", offset: 10 }, dst: {}, long: "(UTC+10:00) Guam, Port Moresby", hem: "n" }, { name: "Papua New Guinea Time", abbr: null, aliases: ["papua new guinea", "guinea", "guinean"], ids: ["Pacific/Bougainville", "Pacific/Port_Moresby"], std: { abbr: "PGT", name: "Papua New Guinea Time", offset: 11 }, dst: {}, hem: "s" }, { name: "New Zealand Time", abbr: "NZT", aliases: ["new zealand", "new zealand standard time", "auckland", "wellington"], ids: ["Pacific/Auckland", "Antarctica/McMurdo"], std: { name: "New Zealand Standard Time", abbr: "NZST", offset: 12 }, dst: { name: "New Zealand Daylight Time", abbr: "NZDT", offset: 13 }, long: "(UTC+12:00) Auckland, Wellington", hem: "s" }, { name: "Marshall Islands Time", abbr: null, aliases: ["marshall islands"], ids: ["Pacific/Kwajalein", "Pacific/Majuro"], std: { abbr: "MHT", name: "Marshall Islands Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Samoa Time", abbr: "SST", aliases: ["samoa", "samoa standard time"], ids: ["Pacific/Midway", "Pacific/Pago_Pago"], std: { abbr: "SST", name: "Samoa Standard Time", offset: -11 }, dst: {}, long: "(UTC+13:00) Samoa", hem: "n" }, { name: "Hawaii-Aleutian Time", abbr: "HAT", aliases: ["hawaii aleutian", "aleutian standard time", "aleutian"], ids: ["Pacific/Honolulu", "Pacific/Johnston"], std: { name: "Hawaii-Aleutian Standard Time", abbr: "HAST", offset: -9 }, dst: { name: "Hawaii-Aleutian Daylight Time", abbr: "HADT", offset: -8 }, long: "(UTC-09:00) Aleutian Islands", hem: "n" }, { name: "", dupe: !0, std: { name: "Mountain Standard Time", abbr: "MST", offset: -7 }, ids: ["America/Dawson", "America/Whitehorse"], hem: "n" }, { name: "Mexican Pacific Time", abbr: "HPMX", aliases: ["mexico pacific", "mountain standard time (mexico)", "chihuahua", "la paz", "mazatlan", "mountain mexico"], ids: ["America/Chihuahua", "America/Mazatlan"], std: { name: "Mexican Pacific Standard Time", abbr: "HNPMX", offset: -7 }, dst: { name: "Mexican Pacific Daylight Time", abbr: "HEPMX", offset: -6 }, long: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", hem: "n" }, { name: "Colombia Time", abbr: "COT", aliases: ["colombia", "cost"], ids: ["America/Bogota", "Pacific/Galapagos"], std: { name: "Colombia Standard Time", abbr: "COT", offset: -5 }, dst: {}, hem: "n" }, { name: "Acre Time", abbr: null, aliases: ["acre"], ids: ["America/Eirunepe", "America/Rio_Branco"], std: { abbr: "ACT", name: "Acre Standard Time", offset: -5 }, dst: {}, hem: "n" }, { name: "", dupe: !0, ids: ["America/Campo_Grande", "America/Cuiaba"], std: { abbr: "AMT", name: "Amazon Standard Time", offset: -4 }, hem: "s" }, { name: "", dupe: !0, ids: ["Antarctica/Palmer", "America/Punta_Arenas"], std: { name: "Chile Standard Time", abbr: "CLT", offset: -3 }, hem: "s" }, { name: "Troll Time", dupe: !0, abbr: null, aliases: ["troll research station"], ids: ["Antarctica/Troll"], std: { name: "Greenwich Mean Time", abbr: "GMT", offset: 0 }, dst: {}, hem: "s" }, { name: "East Greenland Time", abbr: "HEG", aliases: ["greenland eastern"], ids: ["America/Scoresbysund"], std: { name: "East Greenland Standard Time", abbr: "HNEG", offset: 0 }, dst: { name: "East Greenland Summer Time", abbr: "HEEG", offset: 1 }, hem: "n" }, { name: "Israel Time", abbr: null, aliases: ["israel", "israel standard time", "jerusalem"], ids: ["Asia/Jerusalem"], std: { abbr: "IST", name: "Israel Standard Time", offset: 2 }, dst: { name: "Israel Daylight Time", offset: 3 }, long: "(UTC+02:00) Jerusalem", hem: "n" }, { name: "East Africa Time", dupe: !0, ids: ["Indian/Antananarivo"], std: { name: "East Africa Time", abbr: "EAT", offset: 3 }, dst: {}, hem: "s" }, { name: "Syowa Time", abbr: null, aliases: ["syowa"], ids: ["Antarctica/Syowa"], std: { abbr: "SYOT", name: "Syowa Time", offset: 3 }, dst: {}, hem: "s" }, { name: "Turkey Time", abbr: "TRT", aliases: ["turkey", "turkey standard time", "istanbul"], ids: ["Europe/Istanbul"], std: { name: "Turkey Time", abbr: "TRT", offset: 3 }, dst: {}, long: "(UTC+03:00) Istanbul", hem: "n" }, { name: "Iran Time", abbr: null, aliases: ["iran", "iran standard time", "tehran"], ids: ["Asia/Tehran"], std: { abbr: "IRST", name: "Iran Standard Time", offset: 3.5 }, dst: { abbr: "IRDT", name: "Iran Daylight Time", offset: 4.5 }, long: "(UTC+03:30) Tehran", hem: "n" }, { name: "Azerbaijan Time", abbr: null, aliases: ["azerbaijan", "azerbaijan standard time", "baku"], ids: ["Asia/Baku"], std: { abbr: "AZT", name: "Azerbaijan Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Baku", hem: "n" }, { name: "Georgia Time", abbr: "GET", aliases: ["georgia", "georgian standard time", "tbilisi", "georgian"], ids: ["Asia/Tbilisi"], std: { abbr: "GET", name: "Georgia Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Tbilisi", hem: "n" }, { name: "Armenia Time", abbr: "AMT", aliases: ["armenia", "caucasus standard time", "yerevan", "caucasus"], ids: ["Asia/Yerevan"], std: { abbr: "AMT", name: "Armenia Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Yerevan", hem: "n" }, { name: "Seychelles Time", abbr: null, aliases: ["seychelles"], ids: ["Indian/Mahe"], std: { abbr: "SCT", name: "Seychelles Time", offset: 4 }, dst: {}, hem: "n" }, { name: "Mauritius Time", abbr: null, aliases: ["mauritius", "mauritius standard time", "port louis"], ids: ["Indian/Mauritius"], std: { abbr: "MUT", name: "Mauritius Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Port Louis", hem: "n" }, { name: "Réunion Time", abbr: null, aliases: ["reunion"], ids: ["Indian/Reunion"], std: { abbr: "RET", name: "Réunion Time", offset: 4 }, dst: {}, hem: "s" }, { name: "Afghanistan Time", abbr: null, aliases: ["afghanistan", "afghanistan standard time", "kabul"], ids: ["Asia/Kabul"], std: { abbr: "AFT", name: "Afghanistan Time", offset: 4.5 }, dst: {}, long: "(UTC+04:30) Kabul", hem: "n" }, { name: "Mawson Time", abbr: null, aliases: ["mawson"], ids: ["Antarctica/Mawson"], std: { abbr: "MAWT", name: "Mawson Time", offset: 5 }, dst: {}, hem: "s" }, { name: "Turkmenistan Time", abbr: "TMT", aliases: ["turkmenistan", "tmst"], ids: ["Asia/Ashgabat"], std: { name: "Turkmenistan Standard Time", abbr: "TMT", offset: 5 }, dst: {}, hem: "n" }, { name: "Tajikistan Time", abbr: null, aliases: ["tajikistan"], ids: ["Asia/Dushanbe"], std: { abbr: "TJT", name: "Tajikistan Time", offset: 5 }, dst: {}, hem: "n" }, { name: "Pakistan Time", abbr: null, aliases: ["pakistan", "pakistan standard time", "islamabad", "karachi"], ids: ["Asia/Karachi"], std: { abbr: "PKT", name: "Pakistan Standard Time", offset: 5 }, dst: {}, long: "(UTC+05:00) Islamabad, Karachi", hem: "n" }, { name: "Yekaterinburg Time", abbr: "YEKT", aliases: ["yekaterinburg", "ekaterinburg standard time", "ekaterinburg"], ids: ["Asia/Yekaterinburg"], std: { abbr: "YEKT", name: "Yekaterinburg Standard Time", offset: 5 }, dst: {}, long: "(UTC+05:00) Ekaterinburg", hem: "n" }, { name: "French Southern & Antarctic Time", abbr: null, aliases: ["french southern"], ids: ["Indian/Kerguelen"], std: { abbr: "TFT", name: "French Southern & Antarctic Time", offset: 5 }, dst: {}, hem: "s" }, { name: "Maldives Time", abbr: null, aliases: ["maldives"], ids: ["Indian/Maldives"], std: { abbr: "MVT", name: "Maldives Time", offset: 5 }, dst: {}, hem: "n" }, { name: "Nepal Time", abbr: null, aliases: ["nepal", "nepal standard time", "kathmandu"], ids: ["Asia/Katmandu"], std: { abbr: "NPT", name: "Nepal Time", offset: 5.75 }, dst: {}, long: "(UTC+05:45) Kathmandu", hem: "n" }, { name: "Vostok Time", abbr: null, aliases: ["vostok"], ids: ["Antarctica/Vostok"], std: { abbr: "MSK+4", name: "Vostok Time", offset: 6 }, dst: {}, hem: "s" }, { name: "Kyrgyzstan Time", abbr: null, aliases: ["kyrgystan"], ids: ["Asia/Bishkek"], std: { abbr: "KGT", name: "Kyrgyzstan Time", offset: 6 }, dst: {}, hem: "n" }, { name: "Bangladesh Time", abbr: "BST", aliases: ["bangladesh", "bangladesh standard time", "dhaka"], ids: ["Asia/Dhaka"], std: { abbr: "BST", name: "Bangladesh Standard Time", offset: 6 }, dst: {}, long: "(UTC+06:00) Dhaka", hem: "n" }, { name: "Bhutan Time", abbr: null, aliases: ["bhutan"], ids: ["Asia/Thimphu"], std: { name: "Bhutan Time", abbr: "BT", offset: 6 }, dst: {}, hem: "n" }, { name: "Indian Ocean Time", abbr: null, aliases: ["indian ocean", "indian chagos"], ids: ["Indian/Chagos"], std: { abbr: "IOT", name: "Indian Ocean Time", offset: 6 }, dst: {}, hem: "n" }, { name: "Myanmar Time", abbr: null, aliases: ["myanmar", "myanmar standard time"], ids: ["Asia/Rangoon"], std: { abbr: "MMT", name: "Myanmar Time", offset: 6.5 }, dst: {}, long: "(UTC+06:30) Yangon (Rangoon)", hem: "n" }, { name: "Cocos Islands Time", abbr: null, aliases: ["cocos"], ids: ["Indian/Cocos"], std: { abbr: "CCT", name: "Cocos Islands Time", offset: 6.5 }, dst: {}, hem: "n" }, { name: "Davis Time", abbr: null, aliases: ["davis"], ids: ["Antarctica/Davis"], std: { abbr: "DAVT", name: "Davis Time", offset: 7 }, dst: {}, hem: "s" }, { name: "Hovd Time", abbr: null, aliases: ["hovd", "w. mongolia standard time", "west mongolia", "western mongolia"], ids: ["Asia/Hovd"], std: { abbr: "HOVT", name: "Hovd Standard Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Hovd", hem: "n" }, { name: "Novosibirsk Time", abbr: null, aliases: ["novosibirsk", "n. central asia standard time", "north central asia"], ids: ["Asia/Novosibirsk"], std: { abbr: "NOVT", name: "Novosibirsk Standard Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Novosibirsk", hem: "n" }, { name: "Christmas Island Time", abbr: null, aliases: ["christmas"], ids: ["Indian/Christmas"], std: { abbr: "CXT", name: "Christmas Island Time", offset: 7 }, dst: {}, hem: "s" }, { name: "Brunei Darussalam Time", abbr: null, aliases: ["brunei"], ids: ["Asia/Brunei"], std: { abbr: "BNT", name: "Brunei Darussalam Time", offset: 8 }, dst: {}, hem: "n" }, { name: "Hong Kong Time", abbr: "HKT", aliases: ["hong kong", "hkst"], ids: ["Asia/Hong_Kong"], std: { name: "Hong Kong Standard Time", abbr: "HKT", offset: 8 }, dst: {}, hem: "n" }, { name: "Irkutsk Time", abbr: null, aliases: ["irkutsk", "north asia east standard time", "north asia east"], ids: ["Asia/Irkutsk"], std: { abbr: "IRKT", name: "Irkutsk Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Irkutsk", hem: "n" }, { name: "Central Indonesia Time", abbr: null, aliases: ["indonesia central"], ids: ["Asia/Makassar"], std: { name: "Central Indonesia Time", abbr: "WITA", offset: 8 }, dst: {}, hem: "s" }, { name: "Philippine Time", abbr: null, aliases: ["philippines"], ids: ["Asia/Manila"], std: { abbr: "PHST", name: "Philippine Standard Time", offset: 8 }, dst: {}, hem: "n" }, { name: "Singapore Time", abbr: null, aliases: ["singapore", "singapore standard time", "kuala lumpur"], ids: ["Asia/Singapore"], std: { name: "Singapore Standard Time", abbr: "SGT", offset: 8 }, dst: {}, long: "(UTC+08:00) Kuala Lumpur, Singapore", hem: "s" }, { name: "Taipei Time", abbr: null, aliases: ["taipei", "taipei standard time"], ids: ["Asia/Taipei"], std: { abbr: "CST", name: "Taipei Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Taipei", hem: "n" }, { name: "Western Australia Time", abbr: "AWT", aliases: ["australia western", "awdt", "w. australia standard time", "perth", "western australia", "west australia"], ids: ["Australia/Perth"], std: { name: "Australian Western Standard Time", abbr: "AWST", offset: 8 }, dst: {}, long: "(UTC+08:00) Perth", hem: "s" }, { name: "Australian Central Western Time", abbr: "ACWT", aliases: ["australia centralwestern", "acwdt", "aus central w. standard time", "eucla", "aus central west"], ids: ["Australia/Eucla"], std: { name: "Australian Central Western Standard Time", abbr: "ACWST", offset: 8.75 }, dst: {}, long: "(UTC+08:45) Eucla", hem: "s" }, { name: "East Timor Time", abbr: "TLT", aliases: ["east timor"], ids: ["Asia/Dili"], std: { abbr: "TLT", name: "East Timor Time", offset: 9 }, dst: {}, hem: "s" }, { name: "Eastern Indonesia Time", abbr: null, aliases: ["indonesia eastern"], ids: ["Asia/Jayapura"], std: { name: "Eastern Indonesia Time", abbr: "WIT", offset: 9 }, dst: {}, hem: "s" }, { name: "Japan Time", abbr: null, aliases: ["japan", "jdt", "tokyo standard time", "osaka", "sapporo", "tokyo"], ids: ["Asia/Tokyo"], std: { name: "Japan Standard Time", abbr: "JST", offset: 9 }, dst: {}, long: "(UTC+09:00) Osaka, Sapporo, Tokyo", hem: "n" }, { name: "Palau Time", abbr: null, aliases: ["palau"], ids: ["Pacific/Palau"], std: { abbr: "PWT", name: "Palau Time", offset: 9 }, dst: {}, hem: "n" }, { name: "", dupe: !0, ids: ["Australia/Darwin"], std: { name: "Australian Central Standard Time", abbr: "ACST", offset: 9.5 }, hem: "s" }, { name: "Dumont-d’Urville Time", abbr: null, aliases: ["dumontdurville"], ids: ["Antarctica/DumontDUrville"], std: { abbr: "CLST", name: "Dumont-d’Urville Time", offset: 10 }, dst: {}, hem: "s" }, { name: "Chuuk Time", abbr: null, aliases: ["truk"], ids: ["Pacific/Truk"], std: { abbr: "CHUT", name: "Chuuk Time", offset: 10 }, dst: {}, hem: "n" }, { name: "Lord Howe Time", abbr: "LHT", aliases: ["lord howe", "lord howe standard time"], ids: ["Australia/Lord_Howe"], std: { name: "Lord Howe Standard Time", abbr: "LHST", offset: 10.5 }, dst: { name: "Lord Howe Daylight Time", abbr: "LHDT", offset: 11.5 }, long: "(UTC+10:30) Lord Howe Island", hem: "s" }, { name: "Casey Time", abbr: "CAST", aliases: ["casey"], ids: ["Antarctica/Casey"], std: { abbr: "CAST", name: "Casey Time", offset: 11 }, dst: { name: "Casey Summer Time", offset: 8 }, hem: "s" }, { name: "Magadan Time", abbr: null, aliases: ["magadan", "magadan standard time"], ids: ["Asia/Magadan"], std: { abbr: "MAGT", name: "Magadan Standard Time", offset: 11 }, dst: {}, long: "(UTC+11:00) Magadan", hem: "n" }, { name: "Sakhalin Time", abbr: null, aliases: ["sakhalin", "sakhalin standard time"], ids: ["Asia/Sakhalin"], std: { abbr: "SAKT", name: "Sakhalin Standard Time", offset: 11 }, dst: {}, long: "(UTC+11:00) Sakhalin", hem: "n" }, { name: "Srednekolymsk Time", abbr: "SRET", aliases: ["srednekolymsk", "russia time zone 10", "chokurdakh"], ids: ["Asia/Srednekolymsk"], std: { abbr: "SRET", name: "Srednekolymsk Standard Time", offset: 11 }, dst: {}, long: "(UTC+11:00) Chokurdakh", hem: "n" }, { name: "Vanuatu Time", abbr: null, aliases: ["vanuatu"], ids: ["Pacific/Efate"], std: { abbr: "VUT", name: "Vanuatu Standard Time", offset: 11 }, dst: {}, hem: "n" }, { name: "Solomon Islands Time", abbr: null, aliases: ["solomon"], ids: ["Pacific/Guadalcanal"], std: { abbr: "SBT", name: "Solomon Islands Time", offset: 11 }, dst: {}, hem: "n" }, { name: "Kosrae Time", abbr: null, aliases: ["kosrae"], ids: ["Pacific/Kosrae"], std: { abbr: "KOST", name: "Kosrae Time", offset: 11 }, dst: {}, hem: "n" }, { name: "New Caledonia Time", abbr: null, aliases: ["new caledonia"], ids: ["Pacific/Noumea"], std: { abbr: "NCT", name: "New Caledonia Standard Time", offset: 11 }, dst: { name: "New Caledonia Summer Time" }, hem: "n" }, { name: "Ponape Time", abbr: null, aliases: ["ponape"], ids: ["Pacific/Ponape"], std: { abbr: "PONT", name: "Ponape Time", offset: 11 }, dst: {}, hem: "n" }, { name: "Anadyr Time", abbr: null, aliases: ["anadyr", "russia time zone 11", "petropavlovsk kamchatsky"], ids: ["Asia/Anadyr"], std: { abbr: "ANAT", name: "Anadyr Standard Time", offset: 12 }, dst: {}, long: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", hem: "n" }, { name: "Petropavlovsk-Kamchatski Time", abbr: null, aliases: ["kamchatka", "russia time zone 11", "anadyr", "petropavlovsk kamchatsky"], ids: ["Asia/Kamchatka"], std: { abbr: "PETT", name: "Petropavlovsk-Kamchatski Standard Time", offset: 12 }, dst: {}, long: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", hem: "n" }, { name: "Fiji Time", abbr: "FJT", aliases: ["fiji", "fiji standard time"], ids: ["Pacific/Fiji"], std: { abbr: "FJT", name: "Fiji Standard Time", offset: 12 }, dst: { abbr: "FJT", name: "Fiji Summer Time", offset: 13 }, long: "(UTC+12:00) Fiji", hem: "s" }, { name: "Tuvalu Time", abbr: "TVT", aliases: ["tuvalu"], ids: ["Pacific/Funafuti"], std: { abbr: "TVT", name: "Tuvalu Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Nauru Time", abbr: null, aliases: ["nauru"], ids: ["Pacific/Nauru"], std: { abbr: "NRT", name: "Nauru Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Norfolk Island Time", abbr: null, aliases: ["norfolk", "norfolk standard time", "norfolk island"], ids: ["Pacific/Norfolk"], std: { abbr: "NFT", name: "Norfolk Island Standard Time", offset: 12 }, dst: { abbr: "NFDT", name: "Norfolk Island Daylight Time", offset: 11 }, long: "(UTC+11:00) Norfolk Island", hem: "n" }, { name: "Gilbert Islands Time", abbr: null, aliases: ["gilbert islands"], ids: ["Pacific/Tarawa"], std: { abbr: "GILT", name: "Gilbert Islands Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Wake Island Time", abbr: null, aliases: ["wake"], ids: ["Pacific/Wake"], std: { abbr: "WAKT", name: "Wake Island Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Wallis & Futuna Time", abbr: null, aliases: ["wallis"], ids: ["Pacific/Wallis"], std: { abbr: "WFT", name: "Wallis & Futuna Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Chatham Time", abbr: "CHAT", aliases: ["chatham", "chatham islands standard time", "chatham islands"], ids: ["Pacific/Chatham"], std: { name: "Chatham Standard Time", abbr: "CHAST", offset: 12.75 }, dst: { name: "Chatham Daylight Time", abbr: "CHADT", offset: 13.75 }, long: "(UTC+12:45) Chatham Islands", hem: "s" }, { name: "West Samoa Time", abbr: "WST", aliases: ["apia"], ids: ["Pacific/Apia"], std: { abbr: "WST", name: "West Samoa Time", offset: 13 }, dst: { abbr: "WST", name: "West Samoa Summer Time", offset: 14 }, hem: "s" }, { name: "Phoenix Islands Time", abbr: null, aliases: ["phoenix islands"], ids: ["Pacific/Enderbury"], std: { abbr: "PHOT", name: "Phoenix Islands Time", offset: 13 }, dst: {}, hem: "n" }, { name: "Tokelau Time", abbr: null, aliases: ["tokelau"], ids: ["Pacific/Fakaofo"], std: { abbr: "TKT", name: "Tokelau Time", offset: 13 }, dst: {}, hem: "n" }, { name: "Tonga Time", abbr: null, aliases: ["tonga", "tonga standard time", "nuku'alofa"], ids: ["Pacific/Tongatapu"], std: { abbr: "TOT", name: "Tonga Standard Time", offset: 13 }, dst: { name: "Tonga Summer Time", offset: 14 }, long: "(UTC+13:00) Nuku'alofa", hem: "s" }, { name: "Line Islands Time", abbr: null, aliases: ["line islands", "line islands standard time", "kiritimati island"], ids: ["Pacific/Kiritimati"], std: { abbr: "LINT", name: "Line Islands Time", offset: 14 }, dst: {}, long: "(UTC+14:00) Kiritimati Island", hem: "n" }, { name: "Niue Time", abbr: null, aliases: ["niue"], ids: ["Pacific/Niue"], std: { abbr: "NUT", name: "Niue Time", offset: -11 }, dst: {}, hem: "n" }, { name: "Cook Islands Time", abbr: "CKT", aliases: ["cook"], ids: ["Pacific/Rarotonga"], std: { abbr: "CKT", name: "Cook Islands Standard Time", offset: -10 }, dst: {}, hem: "n" }, { name: "Tahiti Time", abbr: null, aliases: ["tahiti"], ids: ["Pacific/Tahiti"], std: { abbr: "TAHT", name: "Tahiti Time", offset: -10 }, dst: {}, hem: "n" }, { name: "Marquesas Time", abbr: null, aliases: ["marquesas", "marquesas standard time"], ids: ["Pacific/Marquesas"], std: { abbr: "MART", name: "Marquesas Time", offset: -9.5 }, dst: {}, long: "(UTC-09:30) Marquesas Islands", hem: "n" }, { name: "Aleutian Standard Time", iso: "(UTC-10:00) Aleutian Islands", aliases: ["aleutian"], ids: ["America/Adak"], abbr: "HST", std: { name: "Hawaii Standard Time", abbr: "HST", offset: -10 }, dst: { name: "Hawaii Daylight Time", abbr: "HDT", offset: -9 }, hem: "n" }, { name: "Gambier Time", abbr: null, aliases: ["gambier", "utc-09", "coordinated universal time-09"], ids: ["Pacific/Gambier"], std: { abbr: "GAMT", name: "Gambier Time", offset: -9 }, dst: {}, long: "(UTC-09:00) Coordinated Universal Time-09", hem: "n" }, { name: "Pitcairn Time", abbr: null, aliases: ["pitcairn", "utc-08", "coordinated universal time-08"], ids: ["Pacific/Pitcairn"], std: { abbr: "PST", name: "Pitcairn Time", offset: -8 }, dst: {}, long: "(UTC-08:00) Coordinated Universal Time-08", hem: "n" }, { name: "", dupe: !0, ids: ["America/Hermosillo"], std: { name: "Mexican Pacific Standard Time", abbr: "HNPMX", offset: -7 }, hem: "n" }, { name: "Northwest Mexico Time", abbr: "HNOMX", aliases: ["mexico northwest", "pacific standard time (mexico)", "baja california", "pacific mexico"], ids: ["America/Santa_Isabel"], std: { name: "Northwest Mexico Standard Time", abbr: "HNNOMX", offset: -6 }, dst: { name: "Northwest Mexico Daylight Time", abbr: "HENOMX", offset: -5 }, long: "(UTC-08:00) Baja California", hem: "n" }, { name: "Easter Island Time", abbr: null, aliases: ["easter", "easter island standard time", "easter island"], ids: ["Pacific/Easter"], std: { name: "Easter Island Standard Time", abbr: "EAST", offset: -6 }, dst: { name: "Easter Island Summer Time", abbr: "EASST", offset: -5 }, long: "(UTC-06:00) Easter Island", hem: "s" }, { name: "Ecuador Time", abbr: null, aliases: ["ecuador"], ids: ["America/Guayaquil"], std: { name: "Ecuador Time", abbr: "ECT", offset: -5 }, dst: {}, hem: "n" }, { name: "Cuba Time", abbr: "HCU", aliases: ["cuba", "cuba standard time", "havana"], ids: ["America/Havana"], std: { name: "Cuba Standard Time", abbr: "HNCU", offset: -5 }, dst: { name: "Cuba Daylight Time", abbr: "HECU", offset: -4 }, long: "(UTC-05:00) Havana", hem: "n" }, { name: "Peru Time", abbr: null, aliases: ["peru"], ids: ["America/Lima"], std: { abbr: "PET", name: "Peru Standard Time", offset: -5 }, dst: {}, hem: "s" }, { name: "Paraguay Time", abbr: null, aliases: ["paraguay", "paraguay standard time", "asuncion"], ids: ["America/Asuncion"], std: { abbr: "PYT", name: "Paraguay Standard Time", offset: -4 }, dst: { name: "Paraguay Summer Time", offset: -3 }, long: "(UTC-04:00) Asuncion", hem: "s" }, { name: "Venezuela Time", abbr: null, aliases: ["venezuela", "venezuelan", "venezuela standard time", "caracas"], ids: ["America/Caracas"], std: { name: "Venezuela Time", abbr: "VET", offset: -4 }, dst: {}, long: "(UTC-04:00) Caracas", hem: "n" }, { name: "Guyana Time", abbr: null, aliases: ["guyana"], ids: ["America/Guyana"], std: { name: "Guyana Time", abbr: "GYT", offset: -4 }, dst: {}, hem: "n" }, { name: "Bolivia Time", abbr: null, aliases: ["bolivia"], ids: ["America/La_Paz"], std: { name: "Bolivia Time", abbr: "BOT", offset: -4 }, dst: {}, hem: "s" }, { name: "Newfoundland Time", abbr: "HTN", aliases: ["newfoundland", "newfoundland standard time"], ids: ["America/St_Johns"], std: { name: "Newfoundland Standard Time", abbr: "HNTN", offset: -3.5 }, dst: { name: "Newfoundland Daylight Time", abbr: "HETN", offset: -2.5 }, long: "(UTC-03:30) Newfoundland", hem: "n" }, { name: "French Guiana Time", abbr: null, aliases: ["french guiana"], ids: ["America/Cayenne"], std: { name: "French Guiana Time", abbr: "GFT", offset: -3 }, dst: {}, hem: "n" }, { name: "West Greenland Time", abbr: "HOG", aliases: ["greenland western", "greenland standard time", "greenland"], ids: ["America/Godthab"], std: { name: "West Greenland Standard Time", abbr: "HNOG", offset: -3 }, dst: { name: "West Greenland Summer Time", abbr: "HEOG", offset: -2 }, long: "(UTC-03:00) Greenland", hem: "n" }, { name: "St. Pierre & Miquelon Time", abbr: "HPM", aliases: ["pierre miquelon", "saint pierre standard time", "saint pierre and miquelon", "saint pierre"], ids: ["America/Miquelon"], std: { name: "St. Pierre & Miquelon Standard Time", abbr: "HNPM", offset: -3 }, dst: { name: "St. Pierre & Miquelon Daylight Time", abbr: "HEPM", offset: -2 }, long: "(UTC-03:00) Saint Pierre and Miquelon", hem: "n" }, { name: "Uruguay Time", abbr: "UYT", aliases: ["uruguay", "uyst", "montevideo standard time", "montevideo"], ids: ["America/Montevideo"], std: { name: "Uruguay Standard Time", abbr: "UYT", offset: -3 }, dst: {}, long: "(UTC-03:00) Montevideo", hem: "s" }, { name: "Suriname Time", abbr: null, aliases: ["suriname"], ids: ["America/Paramaribo"], std: { name: "Suriname Time", abbr: "SRT", offset: -3 }, dst: {}, hem: "n" }, { name: "Chile Time", abbr: "CLT", aliases: ["chile"], ids: ["America/Santiago"], std: { name: "Chile Standard Time", abbr: "CLT", offset: -3 }, dst: { name: "Chile Summer Time", abbr: "CLST", offset: -4 }, hem: "s" }, { name: "Falkland Islands Time", abbr: "FKT", aliases: ["falkland"], ids: ["Atlantic/Stanley"], std: { abbr: "FKST", name: "Falkland Islands Summer Time", offset: -3 }, dst: {}, hem: "s" }, { name: "Fernando de Noronha Time", abbr: null, aliases: ["noronha"], ids: ["America/Noronha"], std: { abbr: "FNT", name: "Fernando de Noronha Standard Time", offset: -2 }, dst: {}, hem: "n" }, { name: "South Georgia Time", abbr: null, aliases: ["south georgia"], ids: ["Atlantic/South_Georgia"], std: { abbr: "GST", name: "South Georgia Time", offset: -2 }, dst: {}, hem: "n" }, { name: "Azores Time", abbr: "AZOT", aliases: ["azores", "azores standard time"], ids: ["Atlantic/Azores"], std: { abbr: "AZOT", name: "Azores Standard Time", offset: -1 }, dst: { name: "Azores Summer Time", abbr: "AZOST", offset: 0 }, long: "(UTC-01:00) Azores", hem: "n" }, { name: "Cape Verde Time", abbr: null, aliases: ["cape verde", "cape verde standard time", "cabo verde"], ids: ["Atlantic/Cape_Verde"], std: { abbr: "CVT", name: "Cape Verde Standard Time", offset: -1 }, dst: {}, long: "(UTC-01:00) Cabo Verde Is.", hem: "n" }], gpc = { "asia/dili": "+9", "pacific/palau": "+9", "australia/west": "+8", "asia/ulan_bator": "+8/+7", "asia/choibalsan": "+8", "asia/chongqing": "+8", "asia/chungking": "+8", "asia/harbin": "+8", "asia/irkutsk": "+8", "asia/macao": "+8", "asia/ujung_pandang": "+8", "antarctica/davis": "+7", "indian/christmas": "+7", "asia/ho_chi_minh": "+7", "asia/hovd": "+7", "asia/novosibirsk": "+7", "asia/tomsk": "+7", "antarctica/vostok": "+6", "asia/dacca": "+6", "asia/dhaka": "+6", "asia/kashgar": "+6", "asia/omsk": "+6", "asia/thimbu": "+6", "asia/thimphu": "+6", "asia/urumqi": "+6", "indian/cocos": "+6.5", "antarctica/mawson": "+5", "indian/kerguelen": "+5", "asia/ashkhabad": "+5", "asia/dushanbe": "+5", "asia/yekaterinburg": "+5", "asia/kathmandu": "+5.75", "indian/reunion": "+4", "indian/mahe": "+4", "atlantic/jan_mayen": "+2/+1", "atlantic/faroe": "+1/0", "pacific/kiritimati": "+14", "pacific/apia": "+13/+12", "pacific/tongatapu": "+13/+12", "pacific/enderbury": "+13", "pacific/fakaofo": "+13", "antarctica/south_pole": "+12/+11", "pacific/norfolk": "+11.5/+10.5", "australia/lhi": "+10.5/+9.5", "etc/greenwich": "0", "etc/utc": "0", "etc/universal": "0", "etc/zulu": "0", "america/atka": "-9/-10", "pacific/gambier": "-9", "pacific/marquesas": "-9.5", "pacific/pitcairn": "-8", "america/ensenada": "-7/-8", "america/santa_isabel": "-7/-8", "mexico/bajanorte": "-7/-8", "canada/yukon": "-7/-8", "canada/east-saskatchewan": "-6", "antarctica/rothera": "-3", "atlantic/stanley": "-3", "america/nuuk": "-3/-4", "america/cayenne": "-3", "america/paramaribo": "-3", "america/rosario": "-3", "america/godthab": "-2/-3", "america/miquelon": "-2/-3", "america/noronha": "-2", "atlantic/south_georgia": "-2", "atlantic/cape_verde": "-1", "pacific/niue": "-11", "pacific/samoa": "-11", "pacific/rarotonga": "-10", "pacific/tahiti": "-10" };
const Vle = function(e) {
  let t = mpc(e) || [];
  return typeof t == "string" && (t = [t]), t = t.map((n) => function(o) {
    if (!o)
      return null;
    let r = fpc.find((i) => i.ids.find((a) => a === o));
    if (!r) {
      let i = gpc[o.toLowerCase()];
      if (i !== void 0) {
        let a = `UTC${i}`, s = o.split(/\//), c = s[s.length - 1].replace(/\w\S*/g, function(l) {
          return l.charAt(0).toUpperCase() + l.substr(1).toLowerCase();
        });
        c = c.replace(/_/g, " "), c += " Time", r = { std: { name: c, abbr: a }, offset: null };
      } else {
        let a = o.replace(/^etc\//i, "");
        r = { std: { name: o, abbr: a }, offset: null };
      }
    }
    return { iana: o, standard: r.std || null, daylight: r.dst || null };
  }(n)), t;
};
Vle.prototype.version = "1.1.0";
var hpc = Vle;
const vpc = { "Pacific/Midway": "Midway Island, Samoa", "Pacific/Honolulu": "Hawaii", "America/Juneau": "Alaska", "America/Boise": "Mountain Time", "America/Dawson": "Dawson, Yukon", "America/Chihuahua": "Chihuahua, La Paz, Mazatlan", "America/Phoenix": "Arizona", "America/Chicago": "Central Time", "America/Regina": "Saskatchewan", "America/Mexico_City": "Guadalajara, Mexico City, Monterrey", "America/Belize": "Central America", "America/Detroit": "Eastern Time", "America/Bogota": "Bogota, Lima, Quito", "America/Caracas": "Caracas, La Paz", "America/Santiago": "Santiago", "America/St_Johns": "Newfoundland and Labrador", "America/Sao_Paulo": "Brasilia", "America/Tijuana": "Tijuana", "America/Montevideo": "Montevideo", "America/Argentina/Buenos_Aires": "Buenos Aires, Georgetown", "America/Godthab": "Greenland", "America/Los_Angeles": "Pacific Time", "Atlantic/Azores": "Azores", "Atlantic/Cape_Verde": "Cape Verde Islands", GMT: "UTC", "Europe/London": "Edinburgh, London", "Europe/Dublin": "Dublin", "Europe/Lisbon": "Lisbon", "Africa/Casablanca": "Casablanca, Monrovia", "Atlantic/Canary": "Canary Islands", "Europe/Belgrade": "Belgrade, Bratislava, Budapest, Ljubljana, Prague", "Europe/Sarajevo": "Sarajevo, Skopje, Warsaw, Zagreb", "Europe/Brussels": "Brussels, Copenhagen, Madrid, Paris", "Europe/Amsterdam": "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", "Africa/Algiers": "West Central Africa", "Europe/Bucharest": "Bucharest", "Africa/Cairo": "Cairo", "Europe/Helsinki": "Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", "Europe/Athens": "Athens, Minsk", "Asia/Jerusalem": "Jerusalem", "Africa/Harare": "Harare, Pretoria", "Europe/Moscow": "Istanbul, Moscow, St. Petersburg, Volgograd", "Asia/Kuwait": "Kuwait, Riyadh", "Africa/Nairobi": "Nairobi", "Asia/Baghdad": "Baghdad", "Asia/Tehran": "Tehran", "Asia/Dubai": "Abu Dhabi, Muscat", "Asia/Baku": "Baku, Tbilisi, Yerevan", "Asia/Kabul": "Kabul", "Asia/Yekaterinburg": "Ekaterinburg", "Asia/Karachi": "Islamabad, Karachi, Tashkent", "Asia/Kolkata": "Chennai, Kolkata, Mumbai, New Delhi", "Asia/Kathmandu": "Kathmandu", "Asia/Dhaka": "Astana, Dhaka", "Asia/Colombo": "Sri Jayawardenepura", "Asia/Almaty": "Almaty, Novosibirsk", "Asia/Rangoon": "Yangon Rangoon", "Asia/Bangkok": "Bangkok, Hanoi, Jakarta", "Asia/Krasnoyarsk": "Krasnoyarsk", "Asia/Shanghai": "Beijing, Chongqing, Hong Kong SAR, Urumqi", "Asia/Kuala_Lumpur": "Kuala Lumpur, Singapore", "Asia/Taipei": "Taipei", "Australia/Perth": "Perth", "Asia/Irkutsk": "Irkutsk, Ulaanbaatar", "Asia/Seoul": "Seoul", "Asia/Tokyo": "Osaka, Sapporo, Tokyo", "Asia/Yakutsk": "Yakutsk", "Australia/Darwin": "Darwin", "Australia/Adelaide": "Adelaide", "Australia/Sydney": "Canberra, Melbourne, Sydney", "Australia/Brisbane": "Brisbane", "Australia/Hobart": "Hobart", "Asia/Vladivostok": "Vladivostok", "Pacific/Guam": "Guam, Port Moresby", "Asia/Magadan": "Magadan, Solomon Islands, New Caledonia", "Asia/Kamchatka": "Kamchatka, Marshall Islands", "Pacific/Fiji": "Fiji Islands", "Pacific/Auckland": "Auckland, Wellington", "Pacific/Tongatapu": "Nuku'alofa" }, bpc = ({ value: e, onBlur: t, onChange: n, labelStyle: o = "original", timezones: r, ...i }) => {
  r || (r = vpc);
  const a = Ue.useMemo(() => Object.entries(r).reduce((c, l) => {
    var b, y, w, N;
    const u = TN.now(l[0]), d = u.timezone(), _ = hpc(l[0]);
    let p = "", g = u.isDST() ? (b = _[0].daylight) == null ? void 0 : b.abbr : (y = _[0].standard) == null ? void 0 : y.abbr, f = u.isDST() ? (w = _[0].daylight) == null ? void 0 : w.name : (N = _[0].standard) == null ? void 0 : N.name;
    const h = 60 * d.current.offset, $ = (h / 60 ^ 0) + ":" + (h % 60 == 0 ? "00" : Math.abs(h % 60)), v = `(GMT${$.includes("-") ? $ : `+${$}`}) ${l[1]}`;
    switch (o) {
      case "original":
        p = v;
        break;
      case "altName":
        p = `${v} ${f != null && f.length ? `(${f})` : ""}`;
        break;
      case "abbrev":
        p = `${v} ${(g == null ? void 0 : g.length) < 5 ? `(${g})` : ""}`;
        break;
      default:
        p = `${v}`;
    }
    return c.push({ value: d.name, label: p, offset: d.current.offset, abbrev: g, altName: f }), c;
  }, []).sort((c, l) => c.offset - l.offset), [o, r]);
  return Ue.createElement(__c, { value: (s = e, typeof s == "object" && s.value && s.label ? s : typeof s == "string" ? a.find((c) => c.value === s) || s.indexOf("/") !== -1 && ((c) => {
    let l = TN.now("GMT");
    try {
      l = TN.now(c);
    } catch {
      return;
    }
    return a.filter((u) => u.offset === l.timezone().current.offset).map((u) => {
      let d = 0;
      return l.timezones[u.value.toLowerCase()] && !!l.timezones[u.value.toLowerCase()].dst === l.timezone().hasDst ? (u.value.toLowerCase().indexOf(l.tz.substring(l.tz.indexOf("/") + 1)) !== -1 && (d += 8), u.label.toLowerCase().indexOf(l.tz.substring(l.tz.indexOf("/") + 1)) !== -1 && (d += 4), u.value.toLowerCase().indexOf(l.tz.substring(0, l.tz.indexOf("/"))) && (d += 2), d += 1) : u.value === "GMT" && (d += 1), { tz: u, score: d };
    }).sort((u, d) => d.score - u.score).map(({ tz: u }) => u)[0];
  })(s) : s.value && !s.label ? a.find((c) => c.value === s.value) : void 0), onChange: (c) => {
    n && n(c);
  }, options: a, onBlur: t, ...i });
  var s;
};
function ypc(e) {
  return [
    "null",
    "Africa/Malabo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "America/Anguilla",
    "America/Antigua",
    "America/Aruba",
    "America/Bahia",
    "America/Cayman",
    "America/Dominica",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Kralendijk",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Marigot",
    "America/Montserrat",
    "America/Nassau",
    "America/St_Barthelemy",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Tortola",
    "Antarctica/McMurdo",
    "Arctic/Longyearbyen",
    "Asia/Bahrain",
    "Atlantic/St_Helena",
    "Europe/Busingen",
    "Europe/Guernsey",
    "Europe/Isle_of_Man",
    "Europe/Mariehamn",
    "Europe/San_Marino",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Indian/Comoro",
    "Pacific/Saipan",
    "Africa/Asmara"
  ].includes(e);
}
const $pc = (e, t) => t && e.label.toLowerCase().includes(t.toLowerCase()), wpc = (e, t) => t.filter((n) => $pc(n, e)), N8 = (e) => Object.fromEntries(
  e.filter(({ timezone: t }) => t !== null && !ypc(t)).map(({ label: t, timezone: n }) => [n, t])
), kpc = (e) => e.replace(/^([-+])(0)(\d):00$/, (t, n, o, r) => `${n}${r}:00`), Spc = (e, t) => {
  const n = e.label.split(/[-+]/)[0].substring(1), o = e.label.split(") ")[1], r = ` ${n} ${kpc(ht.tz(void 0, e.value).format("Z"))}`;
  return t.length > 0 ? `${o}${r}` : `${e.value.replace(/_/g, " ")}${r}`;
};
var Epc = (
  /** @class */
  function() {
    function e() {
      this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
    }
    return e.prototype.set = function(t, n) {
      this.keyToValue.set(t, n), this.valueToKey.set(n, t);
    }, e.prototype.getByKey = function(t) {
      return this.keyToValue.get(t);
    }, e.prototype.getByValue = function(t) {
      return this.valueToKey.get(t);
    }, e.prototype.clear = function() {
      this.keyToValue.clear(), this.valueToKey.clear();
    }, e;
  }()
), Ble = (
  /** @class */
  function() {
    function e(t) {
      this.generateIdentifier = t, this.kv = new Epc();
    }
    return e.prototype.register = function(t, n) {
      if (!this.kv.getByValue(t)) {
        if (n || (n = this.generateIdentifier(t)), process.env.NODE_ENV !== "production") {
          var o = this.kv.getByKey(n);
          o && o !== t && console.debug('Ambiguous class "' + n + '", provide a unique identifier.');
        }
        this.kv.set(n, t);
      }
    }, e.prototype.clear = function() {
      this.kv.clear();
    }, e.prototype.getIdentifier = function(t) {
      return this.kv.getByValue(t);
    }, e.prototype.getValue = function(t) {
      return this.kv.getByKey(t);
    }, e;
  }()
), xpc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, r) {
      o.__proto__ = r;
    } || function(o, r) {
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (o[i] = r[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), Cpc = (
  /** @class */
  function(e) {
    xpc(t, e);
    function t() {
      var n = e.call(this, function(o) {
        return o.name;
      }) || this;
      return n.classToAllowedProps = /* @__PURE__ */ new Map(), n;
    }
    return t.prototype.register = function(n, o) {
      typeof o == "object" ? (o.allowProps && this.classToAllowedProps.set(n, o.allowProps), e.prototype.register.call(this, n, o.identifier)) : e.prototype.register.call(this, n, o);
    }, t.prototype.getAllowedProps = function(n) {
      return this.classToAllowedProps.get(n);
    }, t;
  }(Ble)
), Gw = new Cpc(), rx = new Ble(function(e) {
  var t;
  return (t = e.description) !== null && t !== void 0 ? t : "";
}), Tpc = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
};
function Apc(e) {
  if ("values" in Object)
    return Object.values(e);
  var t = [];
  for (var n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function Ipc(e, t) {
  var n = Apc(e);
  if ("find" in n)
    return n.find(t);
  for (var o = n, r = 0; r < o.length; r++) {
    var i = o[r];
    if (t(i))
      return i;
  }
}
function Cy(e, t) {
  Object.entries(e).forEach(function(n) {
    var o = Tpc(n, 2), r = o[0], i = o[1];
    return t(i, r);
  });
}
function ix(e, t) {
  return e.indexOf(t) !== -1;
}
function z8(e, t) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    if (t(o))
      return o;
  }
}
var AN = {}, Cw = {
  register: function(e) {
    AN[e.name] = e;
  },
  findApplicable: function(e) {
    return Ipc(AN, function(t) {
      return t.isApplicable(e);
    });
  },
  findByName: function(e) {
    return AN[e];
  }
}, Opc = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, Npc = function(e, t) {
  for (var n = 0, o = t.length, r = e.length; n < o; n++, r++)
    e[r] = t[n];
  return e;
}, iC = [], zpc = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  iC.push.apply(iC, Npc([], Opc(e)));
}, Ule = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}, Gle = function(e) {
  return typeof e > "u";
}, Rpc = function(e) {
  return e === null;
}, Mk = function(e) {
  return Ule(e) !== "Object" ? !1 : Object.getPrototypeOf(e) === null ? !0 : e === Object.prototype ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}, y4 = function(e) {
  return Mk(e) && Object.keys(e).length === 0;
}, Pg = function(e) {
  return Array.isArray(e);
}, Ppc = function(e) {
  return typeof e == "string";
}, Dpc = function(e) {
  return typeof e == "number" && !isNaN(e);
}, Lpc = function(e) {
  return typeof e == "boolean";
}, Mpc = function(e) {
  return e instanceof RegExp;
}, aC = function(e) {
  return e instanceof Map;
}, sC = function(e) {
  return e instanceof Set;
}, Wle = function(e) {
  return Ule(e) === "Symbol";
}, Fpc = function(e) {
  return e instanceof Date && !isNaN(e.valueOf());
}, qpc = function(e) {
  return e instanceof Error;
}, R8 = function(e) {
  return typeof e == "number" && isNaN(e);
}, P8 = function(e) {
  return Lpc(e) || Rpc(e) || Gle(e) || Dpc(e) || Ppc(e) || Wle(e);
}, jpc = function(e) {
  return typeof e == "bigint";
}, Vpc = function(e) {
  return e === 1 / 0 || e === -1 / 0;
}, Bpc = function(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}, Hle = function(e) {
  return e.replace(/\./g, "\\.");
}, IN = function(e) {
  return e.map(String).map(Hle).join(".");
}, Ww = function(e) {
  for (var t = [], n = "", o = 0; o < e.length; o++) {
    var r = e.charAt(o), i = r === "\\" && e.charAt(o + 1) === ".";
    if (i) {
      n += ".", o++;
      continue;
    }
    var a = r === ".";
    if (a) {
      t.push(n), n = "";
      continue;
    }
    n += r;
  }
  var s = n;
  return t.push(s), t;
}, $4 = function() {
  return $4 = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, $4.apply(this, arguments);
}, w4 = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, k4 = function(e, t) {
  for (var n = 0, o = t.length, r = e.length; n < o; n++, r++)
    e[r] = t[n];
  return e;
};
function Lm(e, t, n, o) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: o
  };
}
var Yle = [
  Lm(Gle, "undefined", function() {
    return null;
  }, function() {
  }),
  Lm(jpc, "bigint", function(e) {
    return e.toString();
  }, function(e) {
    return typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e);
  }),
  Lm(Fpc, "Date", function(e) {
    return e.toISOString();
  }, function(e) {
    return new Date(e);
  }),
  Lm(qpc, "Error", function(e) {
    var t = {
      name: e.name,
      message: e.message
    };
    return iC.forEach(function(n) {
      t[n] = e[n];
    }), t;
  }, function(e) {
    var t = new Error(e.message);
    return t.name = e.name, t.stack = e.stack, iC.forEach(function(n) {
      t[n] = e[n];
    }), t;
  }),
  Lm(Mpc, "regexp", function(e) {
    return "" + e;
  }, function(e) {
    var t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  Lm(
    sC,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(e) {
      return k4([], w4(e.values()));
    },
    function(e) {
      return new Set(e);
    }
  ),
  Lm(aC, "map", function(e) {
    return k4([], w4(e.entries()));
  }, function(e) {
    return new Map(e);
  }),
  Lm(function(e) {
    return R8(e) || Vpc(e);
  }, "number", function(e) {
    return R8(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity";
  }, Number),
  Lm(function(e) {
    return e === 0 && 1 / e === -1 / 0;
  }, "number", function() {
    return "-0";
  }, Number)
];
function KT(e, t, n, o) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: o
  };
}
var Kle = KT(function(e) {
  if (Wle(e)) {
    var t = !!rx.getIdentifier(e);
    return t;
  }
  return !1;
}, function(e) {
  var t = rx.getIdentifier(e);
  return ["symbol", t];
}, function(e) {
  return e.description;
}, function(e, t) {
  var n = rx.getValue(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown symbol");
  return n;
}), Upc = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce(function(e, t) {
  return e[t.name] = t, e;
}, {}), Zle = KT(Bpc, function(e) {
  return ["typed-array", e.constructor.name];
}, function(e) {
  return k4([], w4(e));
}, function(e, t) {
  var n = Upc[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function Xle(e) {
  if (e != null && e.constructor) {
    var t = !!Gw.getIdentifier(e.constructor);
    return t;
  }
  return !1;
}
var Jle = KT(Xle, function(e) {
  var t = Gw.getIdentifier(e.constructor);
  return ["class", t];
}, function(e) {
  var t = Gw.getAllowedProps(e.constructor);
  if (!t)
    return $4({}, e);
  var n = {};
  return t.forEach(function(o) {
    n[o] = e[o];
  }), n;
}, function(e, t) {
  var n = Gw.getValue(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(n.prototype), e);
}), Qle = KT(function(e) {
  return !!Cw.findApplicable(e);
}, function(e) {
  var t = Cw.findApplicable(e);
  return ["custom", t.name];
}, function(e) {
  var t = Cw.findApplicable(e);
  return t.serialize(e);
}, function(e, t) {
  var n = Cw.findByName(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown custom value");
  return n.deserialize(e);
}), Gpc = [Jle, Kle, Qle, Zle], D8 = function(e) {
  var t = z8(Gpc, function(o) {
    return o.isApplicable(e);
  });
  if (t)
    return {
      value: t.transform(e),
      type: t.annotation(e)
    };
  var n = z8(Yle, function(o) {
    return o.isApplicable(e);
  });
  if (n)
    return {
      value: n.transform(e),
      type: n.annotation
    };
}, eue = {};
Yle.forEach(function(e) {
  eue[e.annotation] = e;
});
var Wpc = function(e, t) {
  if (Pg(t))
    switch (t[0]) {
      case "symbol":
        return Kle.untransform(e, t);
      case "class":
        return Jle.untransform(e, t);
      case "custom":
        return Qle.untransform(e, t);
      case "typed-array":
        return Zle.untransform(e, t);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    var n = eue[t];
    if (!n)
      throw new Error("Unknown transformation: " + t);
    return n.untransform(e);
  }
}, FS = function(e, t) {
  for (var n = e.keys(); t > 0; )
    n.next(), t--;
  return n.next().value;
};
function tue(e) {
  if (ix(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (ix(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (ix(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var Hpc = function(e, t) {
  return tue(t), t.forEach(function(n) {
    e = e[n];
  }), e;
}, S4 = function(e, t, n) {
  if (tue(t), t.length === 0)
    return n(e);
  for (var o = e, r = 0; r < t.length - 1; r++) {
    var i = t[r];
    if (Pg(o)) {
      var a = +i;
      o = o[a];
    } else if (Mk(o))
      o = o[i];
    else if (sC(o)) {
      var s = +i;
      o = FS(o, s);
    } else if (aC(o)) {
      var c = r === t.length - 2;
      if (c)
        break;
      var s = +i, l = +t[++r] == 0 ? "key" : "value", u = FS(o, s);
      switch (l) {
        case "key":
          o = u;
          break;
        case "value":
          o = o.get(u);
          break;
      }
    }
  }
  var d = t[t.length - 1];
  if ((Pg(o) || Mk(o)) && (o[d] = n(o[d])), sC(o)) {
    var _ = FS(o, +d), p = n(_);
    _ !== p && (o.delete(_), o.add(p));
  }
  if (aC(o)) {
    var s = +t[t.length - 2], g = FS(o, s), l = +d == 0 ? "key" : "value";
    switch (l) {
      case "key": {
        var f = n(g);
        o.set(f, o.get(g)), f !== g && o.delete(g);
        break;
      }
      case "value": {
        o.set(g, n(o.get(g)));
        break;
      }
    }
  }
  return e;
}, tf = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, dg = function(e, t) {
  for (var n = 0, o = t.length, r = e.length; n < o; n++, r++)
    e[r] = t[n];
  return e;
};
function E4(e, t, n) {
  if (n === void 0 && (n = []), !!e) {
    if (!Pg(e)) {
      Cy(e, function(a, s) {
        return E4(a, t, dg(dg([], tf(n)), tf(Ww(s))));
      });
      return;
    }
    var o = tf(e, 2), r = o[0], i = o[1];
    i && Cy(i, function(a, s) {
      E4(a, t, dg(dg([], tf(n)), tf(Ww(s))));
    }), t(r, n);
  }
}
function Ypc(e, t) {
  return E4(t, function(n, o) {
    e = S4(e, o, function(r) {
      return Wpc(r, n);
    });
  }), e;
}
function Kpc(e, t) {
  function n(a, s) {
    var c = Hpc(e, Ww(s));
    a.map(Ww).forEach(function(l) {
      e = S4(e, l, function() {
        return c;
      });
    });
  }
  if (Pg(t)) {
    var o = tf(t, 2), r = o[0], i = o[1];
    r.forEach(function(a) {
      e = S4(e, Ww(a), function() {
        return e;
      });
    }), i && Cy(i, n);
  } else
    Cy(t, n);
  return e;
}
var Zpc = function(e) {
  return Mk(e) || Pg(e) || aC(e) || sC(e) || Xle(e);
};
function Xpc(e, t, n) {
  var o = n.get(e);
  o ? o.push(t) : n.set(e, [t]);
}
function Jpc(e) {
  var t = {}, n = void 0;
  return e.forEach(function(o) {
    if (!(o.length <= 1)) {
      var r = tf(o.map(function(s) {
        return s.map(String);
      }).sort(function(s, c) {
        return s.length - c.length;
      })), i = r[0], a = r.slice(1);
      i.length === 0 ? n = a.map(IN) : t[IN(i)] = a.map(IN);
    }
  }), n ? y4(t) ? [n] : [n, t] : y4(t) ? void 0 : t;
}
var nue = function(e, t, n, o) {
  var r;
  if (n === void 0 && (n = []), o === void 0 && (o = []), P8(e) || Xpc(e, n, t), !Zpc(e)) {
    var i = D8(e);
    return i ? {
      transformedValue: i.value,
      annotations: [i.type]
    } : {
      transformedValue: e
    };
  }
  if (ix(o, e))
    return {
      transformedValue: null
    };
  var a = D8(e), s = (r = a == null ? void 0 : a.value) !== null && r !== void 0 ? r : e;
  P8(e) || (o = dg(dg([], tf(o)), [e]));
  var c = Pg(s) ? [] : {}, l = {};
  return Cy(s, function(u, d) {
    var _ = nue(u, t, dg(dg([], tf(n)), [d]), o);
    c[d] = _.transformedValue, Pg(_.annotations) ? l[d] = _.annotations : Mk(_.annotations) && Cy(_.annotations, function(p, g) {
      l[Hle(d) + "." + g] = p;
    });
  }), y4(l) ? {
    transformedValue: c,
    annotations: a ? [a.type] : void 0
  } : {
    transformedValue: c,
    annotations: a ? [a.type, l] : l
  };
};
function oue(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Qpc(e) {
  return oue(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function L8(e) {
  return oue(e) === "Array";
}
function emc(e, t, n, o, r) {
  const i = {}.propertyIsEnumerable.call(o, t) ? "enumerable" : "nonenumerable";
  i === "enumerable" && (e[t] = n), r && i === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function x4(e, t = {}) {
  if (L8(e))
    return e.map((r) => x4(r, t));
  if (!Qpc(e))
    return e;
  const n = Object.getOwnPropertyNames(e), o = Object.getOwnPropertySymbols(e);
  return [...n, ...o].reduce((r, i) => {
    if (L8(t.props) && !t.props.includes(i))
      return r;
    const a = e[i], s = x4(a, t);
    return emc(r, i, s, e, t.nonenumerable), r;
  }, {});
}
var Mh = function() {
  return Mh = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Mh.apply(this, arguments);
}, rue = function(e) {
  var t = /* @__PURE__ */ new Map(), n = nue(e, t), o = {
    json: n.transformedValue
  };
  n.annotations && (o.meta = Mh(Mh({}, o.meta), { values: n.annotations }));
  var r = Jpc(t);
  return r && (o.meta = Mh(Mh({}, o.meta), { referentialEqualities: r })), o;
}, iue = function(e) {
  var t = e.json, n = e.meta, o = x4(t);
  return n != null && n.values && (o = Ypc(o, n.values)), n != null && n.referentialEqualities && (o = Kpc(o, n.referentialEqualities)), o;
}, tmc = function(e) {
  return JSON.stringify(rue(e));
}, nmc = function(e) {
  return iue(JSON.parse(e));
}, omc = function(e, t) {
  return Gw.register(e, t);
}, rmc = function(e, t) {
  return rx.register(e, t);
}, imc = function(e, t) {
  return Cw.register(Mh({ name: t }, e));
};
const amc = {
  stringify: tmc,
  parse: nmc,
  serialize: rue,
  deserialize: iue,
  registerClass: omc,
  registerSymbol: rmc,
  registerCustom: imc,
  allowErrorProps: zpc
};
function smc(e) {
  return e;
}
function V0(e) {
  const t = {
    subscribe(n) {
      let o = null, r = !1, i = !1, a = !1;
      function s() {
        if (o === null) {
          a = !0;
          return;
        }
        i || (i = !0, typeof o == "function" ? o() : o && o.unsubscribe());
      }
      return o = e({
        next(c) {
          var l;
          r || (l = n.next) == null || l.call(n, c);
        },
        error(c) {
          var l;
          r || (r = !0, (l = n.error) == null || l.call(n, c), s());
        },
        complete() {
          var c;
          r || (r = !0, (c = n.complete) == null || c.call(n), s());
        }
      }), a && s(), {
        unsubscribe: s
      };
    },
    pipe(...n) {
      return cmc(n)(t);
    }
  };
  return t;
}
function cmc(e) {
  return e.length === 0 ? smc : e.length === 1 ? e[0] : function(n) {
    return e.reduce((o, r) => r(o), n);
  };
}
class zF extends Error {
  constructor(t) {
    super(t), this.name = "ObservableAbortError", Object.setPrototypeOf(this, zF.prototype);
  }
}
function lmc(e) {
  let t;
  return {
    promise: new Promise((o, r) => {
      let i = !1;
      function a() {
        i || (i = !0, r(new zF("This operation was aborted.")), s.unsubscribe());
      }
      const s = e.subscribe({
        next(c) {
          i = !0, o(c), a();
        },
        error(c) {
          i = !0, r(c), a();
        },
        complete() {
          i = !0, a();
        }
      });
      t = a;
    }),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    abort: t
  };
}
function umc(e) {
  return (t) => {
    let n = 0, o = null;
    const r = [];
    function i() {
      o || (o = t.subscribe({
        next(s) {
          var c;
          for (const l of r)
            (c = l.next) == null || c.call(l, s);
        },
        error(s) {
          var c;
          for (const l of r)
            (c = l.error) == null || c.call(l, s);
        },
        complete() {
          var s;
          for (const c of r)
            (s = c.complete) == null || s.call(c);
        }
      }));
    }
    function a() {
      if (n === 0 && o) {
        const s = o;
        o = null, s.unsubscribe();
      }
    }
    return {
      subscribe(s) {
        return n++, r.push(s), i(), {
          unsubscribe() {
            n--, a();
            const c = r.findIndex((l) => l === s);
            c > -1 && r.splice(c, 1);
          }
        };
      }
    };
  };
}
function dmc(e) {
  return (t) => ({
    subscribe(n) {
      return t.subscribe({
        next(o) {
          var r, i;
          (r = e.next) == null || r.call(e, o), (i = n.next) == null || i.call(n, o);
        },
        error(o) {
          var r, i;
          (r = e.error) == null || r.call(e, o), (i = n.error) == null || i.call(n, o);
        },
        complete() {
          var o, r;
          (o = e.complete) == null || o.call(e), (r = n.complete) == null || r.call(n);
        }
      });
    }
  });
}
function _mc(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in e) {
    const o = e[n];
    t[o] = n;
  }
  return t;
}
function Fk(e) {
  return !!e && !Array.isArray(e) && typeof e == "object";
}
class pmc extends Error {
}
function mmc(e) {
  if (e instanceof Error)
    return e;
  const t = typeof e;
  if (!(t === "undefined" || t === "function" || e === null)) {
    if (t !== "object")
      return new Error(String(e));
    if (Fk(e)) {
      const n = new pmc();
      for (const o in e)
        n[o] = e[o];
      return n;
    }
  }
}
const fmc = {
  /**
  * Invalid JSON was received by the server.
  * An error occurred on the server while parsing the JSON text.
  */
  PARSE_ERROR: -32700,
  /**
  * The JSON sent is not a valid Request object.
  */
  BAD_REQUEST: -32600,
  // Internal JSON-RPC error
  INTERNAL_SERVER_ERROR: -32603,
  NOT_IMPLEMENTED: -32603,
  // Implementation specific errors
  UNAUTHORIZED: -32001,
  FORBIDDEN: -32003,
  NOT_FOUND: -32004,
  METHOD_NOT_SUPPORTED: -32005,
  TIMEOUT: -32008,
  CONFLICT: -32009,
  PRECONDITION_FAILED: -32012,
  PAYLOAD_TOO_LARGE: -32013,
  UNPROCESSABLE_CONTENT: -32022,
  TOO_MANY_REQUESTS: -32029,
  CLIENT_CLOSED_REQUEST: -32099
};
_mc(fmc);
const aue = () => {
};
function sue(e, t) {
  return new Proxy(aue, {
    get(o, r) {
      if (!(typeof r != "string" || r === "then"))
        return sue(e, [
          ...t,
          r
        ]);
    },
    apply(o, r, i) {
      const a = t[t.length - 1] === "apply";
      return e({
        args: a ? i.length >= 2 ? i[1] : [] : i,
        path: a ? t.slice(0, -1) : t
      });
    }
  });
}
const ZT = (e) => sue(e, []), RF = (e) => new Proxy(aue, {
  get(t, n) {
    if (!(typeof n != "string" || n === "then"))
      return e(n);
  }
});
var ore, rre, ire, are, sre, cre;
typeof window > "u" || "Deno" in window || // eslint-disable-next-line @typescript-eslint/dot-notation
((rre = (ore = globalThis.process) == null ? void 0 : ore.env) == null ? void 0 : rre.NODE_ENV) === "test" || (are = (ire = globalThis.process) == null ? void 0 : ire.env) != null && are.JEST_WORKER_ID || (cre = (sre = globalThis.process) == null ? void 0 : sre.env) != null && cre.VITEST_WORKER_ID;
function gmc(e, t) {
  if ("error" in e) {
    const o = t.deserialize(e.error);
    return {
      ok: !1,
      error: {
        ...e,
        error: o
      }
    };
  }
  return {
    ok: !0,
    result: {
      ...e.result,
      ...(!e.result.type || e.result.type === "data") && {
        type: "data",
        data: t.deserialize(e.result.data)
      }
    }
  };
}
class ON extends Error {
  constructor() {
    super("Unable to transform response from server");
  }
}
function cue(e, t) {
  let n;
  try {
    n = gmc(e, t);
  } catch {
    throw new ON();
  }
  if (!n.ok && (!Fk(n.error.error) || typeof n.error.error.code != "number"))
    throw new ON();
  if (n.ok && !Fk(n.result))
    throw new ON();
  return n;
}
function lue(e) {
  return V0((t) => {
    function n(r = 0, i = e.op) {
      const a = e.links[r];
      if (!a)
        throw new Error("No more links to execute - did you forget to add an ending link?");
      return a({
        op: i,
        next(c) {
          return n(r + 1, c);
        }
      });
    }
    return n().subscribe(t);
  });
}
function hmc(e) {
  return e instanceof Id || /**
  * @deprecated
  * Delete in next major
  */
  e instanceof Error && e.name === "TRPCClientError";
}
function vmc(e) {
  return Fk(e) && Fk(e.error) && typeof e.error.code == "number" && typeof e.error.message == "string";
}
class Id extends Error {
  static from(t, n = {}) {
    const o = t;
    return hmc(o) ? (n.meta && (o.meta = {
      ...o.meta,
      ...n.meta
    }), o) : vmc(o) ? new Id(o.error.message, {
      ...n,
      result: o
    }) : o instanceof Error ? new Id(o.message, {
      ...n,
      cause: mmc(o)
    }) : new Id("Unknown error", {
      ...n,
      cause: o
    });
  }
  constructor(t, n) {
    var r, i;
    const o = n == null ? void 0 : n.cause;
    super(t, {
      cause: o
    }), this.meta = n == null ? void 0 : n.meta, this.cause = o, this.shape = (r = n == null ? void 0 : n.result) == null ? void 0 : r.error, this.data = (i = n == null ? void 0 : n.result) == null ? void 0 : i.error.data, this.name = "TRPCClientError", Object.setPrototypeOf(this, Id.prototype);
  }
}
class uue {
  $request({ type: t, input: n, path: o, context: r = {} }) {
    return lue({
      links: this.links,
      op: {
        id: ++this.requestId,
        type: t,
        path: o,
        input: n,
        context: r
      }
    }).pipe(umc());
  }
  requestAsPromise(t) {
    const n = this.$request(t), { promise: o, abort: r } = lmc(n);
    return new Promise((a, s) => {
      var c;
      (c = t.signal) == null || c.addEventListener("abort", r), o.then((l) => {
        a(l.result.data);
      }).catch((l) => {
        s(Id.from(l));
      });
    });
  }
  query(t, n, o) {
    return this.requestAsPromise({
      type: "query",
      path: t,
      input: n,
      context: o == null ? void 0 : o.context,
      signal: o == null ? void 0 : o.signal
    });
  }
  mutation(t, n, o) {
    return this.requestAsPromise({
      type: "mutation",
      path: t,
      input: n,
      context: o == null ? void 0 : o.context,
      signal: o == null ? void 0 : o.signal
    });
  }
  subscription(t, n, o) {
    return this.$request({
      type: "subscription",
      path: t,
      input: n,
      context: o == null ? void 0 : o.context
    }).subscribe({
      next(i) {
        var a, s, c;
        i.result.type === "started" ? (a = o.onStarted) == null || a.call(o) : i.result.type === "stopped" ? (s = o.onStopped) == null || s.call(o) : (c = o.onData) == null || c.call(o, i.result.data);
      },
      error(i) {
        var a;
        (a = o.onError) == null || a.call(o, i);
      },
      complete() {
        var i;
        (i = o.onComplete) == null || i.call(o);
      }
    });
  }
  constructor(t) {
    this.requestId = 0;
    const n = (() => {
      const o = t.transformer;
      return o ? "input" in o ? t.transformer : {
        input: o,
        output: o
      } : {
        input: {
          serialize: (r) => r,
          deserialize: (r) => r
        },
        output: {
          serialize: (r) => r,
          deserialize: (r) => r
        }
      };
    })();
    this.runtime = {
      transformer: {
        serialize: (o) => n.input.serialize(o),
        deserialize: (o) => n.output.deserialize(o)
      },
      combinedTransformer: n
    }, this.links = t.links.map((o) => o(this.runtime));
  }
}
function due(e) {
  return new uue(e);
}
const bmc = {
  query: "query",
  mutate: "mutation",
  subscribe: "subscription"
}, ymc = (e) => bmc[e];
function $mc(e) {
  return RF((t) => e.hasOwnProperty(t) ? e[t] : t === "__untypedClient" ? e : ZT(({ path: n, args: o }) => {
    const r = [
      t,
      ...n
    ], i = ymc(r.pop()), a = r.join(".");
    return e[i](a, ...o);
  }));
}
function wmc(e) {
  return e.__untypedClient;
}
const M8 = (e) => typeof e == "function";
function kmc(e) {
  if (e)
    return e;
  if (typeof window < "u" && M8(window.fetch))
    return window.fetch;
  if (typeof globalThis < "u" && M8(globalThis.fetch))
    return globalThis.fetch;
  throw new Error("No fetch implementation found");
}
const NN = () => {
  throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
function zN(e) {
  let t = null, n = null;
  const o = () => {
    clearTimeout(n), n = null, t = null;
  };
  function r(s) {
    var u, d;
    const c = [
      []
    ];
    let l = 0;
    for (; ; ) {
      const _ = s[l];
      if (!_)
        break;
      const p = c[c.length - 1];
      if (_.aborted) {
        (u = _.reject) == null || u.call(_, new Error("Aborted")), l++;
        continue;
      }
      if (e.validate(p.concat(_).map((f) => f.key))) {
        p.push(_), l++;
        continue;
      }
      if (p.length === 0) {
        (d = _.reject) == null || d.call(_, new Error("Input is too big for a single dispatch")), l++;
        continue;
      }
      c.push([]);
    }
    return c;
  }
  function i() {
    const s = r(t);
    o();
    for (const c of s) {
      if (!c.length)
        continue;
      const l = {
        items: c,
        cancel: NN
      };
      for (const p of c)
        p.batch = l;
      const u = (p, g) => {
        var h;
        const f = l.items[p];
        (h = f.resolve) == null || h.call(f, g), f.batch = null, f.reject = null, f.resolve = null;
      }, { promise: d, cancel: _ } = e.fetch(l.items.map((p) => p.key), u);
      l.cancel = _, d.then((p) => {
        var g;
        for (let f = 0; f < p.length; f++) {
          const h = p[f];
          u(f, h);
        }
        for (const f of l.items)
          (g = f.reject) == null || g.call(f, new Error("Missing result")), f.batch = null;
      }).catch((p) => {
        var g;
        for (const f of l.items)
          (g = f.reject) == null || g.call(f, p), f.batch = null;
      });
    }
  }
  function a(s) {
    const c = {
      aborted: !1,
      key: s,
      batch: null,
      resolve: NN,
      reject: NN
    }, l = new Promise((d, _) => {
      c.reject = _, c.resolve = d, t || (t = []), t.push(c);
    });
    return n || (n = setTimeout(i)), {
      promise: l,
      cancel: () => {
        var d;
        c.aborted = !0, (d = c.batch) != null && d.items.every((_) => _.aborted) && (c.batch.cancel(), c.batch = null);
      }
    };
  }
  return {
    load: a
  };
}
function Smc(e) {
  return e || (typeof window < "u" && window.AbortController ? window.AbortController : typeof globalThis < "u" && globalThis.AbortController ? globalThis.AbortController : null);
}
function _ue(e) {
  return {
    url: e.url.toString().replace(/\/$/, ""),
    fetch: e.fetch,
    AbortController: Smc(e.AbortController)
  };
}
function Emc(e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    t[n] = o;
  }
  return t;
}
const xmc = {
  query: "GET",
  mutation: "POST"
};
function pue(e) {
  return "input" in e ? e.runtime.transformer.serialize(e.input) : Emc(e.inputs.map((t) => e.runtime.transformer.serialize(t)));
}
const mue = (e) => {
  let t = e.url + "/" + e.path;
  const n = [];
  if ("inputs" in e && n.push("batch=1"), e.type === "query") {
    const o = pue(e);
    o !== void 0 && n.push(`input=${encodeURIComponent(JSON.stringify(o))}`);
  }
  return n.length && (t += "?" + n.join("&")), t;
}, Cmc = (e) => {
  if (e.type === "query")
    return;
  const t = pue(e);
  return t !== void 0 ? JSON.stringify(t) : void 0;
}, fue = (e) => Amc({
  ...e,
  contentTypeHeader: "application/json",
  getUrl: mue,
  getBody: Cmc
});
async function Tmc(e, t) {
  const n = e.getUrl(e), o = e.getBody(e), { type: r } = e, i = await (async () => {
    const s = await e.headers();
    return Symbol.iterator in s ? Object.fromEntries(s) : s;
  })();
  /* istanbul ignore if -- @preserve */
  if (r === "subscription")
    throw new Error("Subscriptions should use wsLink");
  const a = {
    ...e.contentTypeHeader ? {
      "content-type": e.contentTypeHeader
    } : {},
    ...e.batchModeHeader ? {
      "trpc-batch-mode": e.batchModeHeader
    } : {},
    ...i
  };
  return kmc(e.fetch)(n, {
    method: xmc[r],
    signal: t == null ? void 0 : t.signal,
    body: o,
    headers: a
  });
}
function Amc(e) {
  const t = e.AbortController ? new e.AbortController() : null, n = {};
  let o = !1;
  return {
    promise: new Promise((a, s) => {
      Tmc(e, t).then((c) => (n.response = c, o = !0, c.json())).then((c) => {
        n.responseJSON = c, a({
          json: c,
          meta: n
        });
      }).catch((c) => {
        o = !0, s(Id.from(c, {
          meta: n
        }));
      });
    }),
    cancel: () => {
      o || t == null || t.abort();
    }
  };
}
function Imc(e) {
  return function(n) {
    const o = _ue(n), r = n.maxURLLength ?? 1 / 0;
    return (i) => {
      const a = (d) => {
        const _ = (g) => {
          if (r === 1 / 0)
            return !0;
          const f = g.map((v) => v.path).join(","), h = g.map((v) => v.input);
          return mue({
            ...o,
            runtime: i,
            type: d,
            path: f,
            inputs: h
          }).length <= r;
        }, p = e({
          ...o,
          runtime: i,
          type: d,
          opts: n
        });
        return {
          validate: _,
          fetch: p
        };
      }, s = zN(a("query")), c = zN(a("mutation")), l = zN(a("subscription")), u = {
        query: s,
        subscription: l,
        mutation: c
      };
      return ({ op: d }) => V0((_) => {
        const p = u[d.type], { promise: g, cancel: f } = p.load(d);
        let h;
        return g.then(($) => {
          h = $;
          const v = cue($.json, i.transformer);
          if (!v.ok) {
            _.error(Id.from(v.error, {
              meta: $.meta
            }));
            return;
          }
          _.next({
            context: $.meta,
            result: v.result
          }), _.complete();
        }).catch(($) => {
          _.error(Id.from($, {
            meta: h == null ? void 0 : h.meta
          }));
        }), () => {
          f();
        };
      });
    };
  };
}
const Omc = (e) => (t) => {
  const n = t.map((a) => a.path).join(","), o = t.map((a) => a.input), { promise: r, cancel: i } = fue({
    ...e,
    path: n,
    inputs: o,
    headers() {
      return e.opts.headers ? typeof e.opts.headers == "function" ? e.opts.headers({
        opList: t
      }) : e.opts.headers : {};
    }
  });
  return {
    promise: r.then((a) => (Array.isArray(a.json) ? a.json : t.map(() => a.json)).map((l) => ({
      meta: a.meta,
      json: l
    }))),
    cancel: i
  };
}, Nmc = Imc(Omc);
function zmc(e) {
  return (t) => {
    const n = _ue(t);
    return (o) => ({ op: r }) => V0((i) => {
      const { path: a, input: s, type: c } = r, { promise: l, cancel: u } = e.requester({
        ...n,
        runtime: o,
        type: c,
        path: a,
        input: s,
        headers() {
          return t.headers ? typeof t.headers == "function" ? t.headers({
            op: r
          }) : t.headers : {};
        }
      });
      let d;
      return l.then((_) => {
        d = _.meta;
        const p = cue(_.json, o.transformer);
        if (!p.ok) {
          i.error(Id.from(p.error, {
            meta: d
          }));
          return;
        }
        i.next({
          context: _.meta,
          result: p.result
        }), i.complete();
      }).catch((_) => {
        i.error(Id.from(_, {
          meta: d
        }));
      }), () => {
        u();
      };
    });
  };
}
const Rmc = zmc({
  requester: fue
});
function Pmc(e) {
  return typeof FormData > "u" ? !1 : e instanceof FormData;
}
const RN = {
  css: {
    query: [
      "72e3ff",
      "3fb0d8"
    ],
    mutation: [
      "c5a3fc",
      "904dfc"
    ],
    subscription: [
      "ff49e1",
      "d83fbe"
    ]
  },
  ansi: {
    regular: {
      // Cyan background, black and white text respectively
      query: [
        "\x1B[30;46m",
        "\x1B[97;46m"
      ],
      // Magenta background, black and white text respectively
      mutation: [
        "\x1B[30;45m",
        "\x1B[97;45m"
      ],
      // Green background, black and white text respectively
      subscription: [
        "\x1B[30;42m",
        "\x1B[97;42m"
      ]
    },
    bold: {
      query: [
        "\x1B[1;30;46m",
        "\x1B[1;97;46m"
      ],
      mutation: [
        "\x1B[1;30;45m",
        "\x1B[1;97;45m"
      ],
      subscription: [
        "\x1B[1;30;42m",
        "\x1B[1;97;42m"
      ]
    }
  }
};
function Dmc(e) {
  const { direction: t, type: n, path: o, id: r, input: i } = e, a = [], s = [];
  if (e.colorMode === "ansi") {
    const [d, _] = RN.ansi.regular[n], [p, g] = RN.ansi.bold[n], f = "\x1B[0m";
    return a.push(t === "up" ? d : _, t === "up" ? ">>" : "<<", n, t === "up" ? p : g, `#${r}`, o, f), t === "up" ? s.push({
      input: e.input
    }) : s.push({
      input: e.input,
      // strip context from result cause it's too noisy in terminal wihtout collapse mode
      result: "result" in e.result ? e.result.result : e.result,
      elapsedMs: e.elapsedMs
    }), {
      parts: a,
      args: s
    };
  }
  const [c, l] = RN.css[n], u = `
    background-color: #${t === "up" ? c : l};
    color: ${t === "up" ? "black" : "white"};
    padding: 2px;
  `;
  return a.push("%c", t === "up" ? ">>" : "<<", n, `#${r}`, `%c${o}%c`, "%O"), s.push(u, `${u}; font-weight: bold;`, `${u}; font-weight: normal;`), t === "up" ? s.push({
    input: i,
    context: e.context
  }) : s.push({
    input: i,
    result: e.result,
    elapsedMs: e.elapsedMs,
    context: e.context
  }), {
    parts: a,
    args: s
  };
}
const Lmc = ({ c: e = console, colorMode: t = "css" }) => (n) => {
  const o = n.input, r = Pmc(o) ? Object.fromEntries(o) : o, { parts: i, args: a } = Dmc({
    ...n,
    colorMode: t,
    input: r
  }), s = n.direction === "down" && n.result && (n.result instanceof Error || "error" in n.result.result) ? "error" : "log";
  e[s].apply(null, [
    i.join(" ")
  ].concat(a));
};
function Mmc(e = {}) {
  const { enabled: t = () => !0 } = e, n = e.colorMode ?? (typeof window > "u" ? "ansi" : "css"), { logger: o = Lmc({
    c: e.console,
    colorMode: n
  }) } = e;
  return () => ({ op: r, next: i }) => V0((a) => {
    t({
      ...r,
      direction: "up"
    }) && o({
      ...r,
      direction: "up"
    });
    const s = Date.now();
    function c(l) {
      const u = Date.now() - s;
      t({
        ...r,
        direction: "down",
        result: l
      }) && o({
        ...r,
        direction: "down",
        elapsedMs: u,
        result: l
      });
    }
    return i(r).pipe(dmc({
      next(l) {
        c(l);
      },
      error(l) {
        c(l);
      }
    })).subscribe(a);
  });
}
function F8(e) {
  return Array.isArray(e) ? e : [
    e
  ];
}
function Fmc(e) {
  return (t) => {
    const n = F8(e.true).map((r) => r(t)), o = F8(e.false).map((r) => r(t));
    return (r) => V0((i) => {
      const a = e.condition(r.op) ? n : o;
      return lue({
        op: r.op,
        links: a
      }).subscribe(i);
    });
  };
}
function qmc(e, t) {
  return ZT(({ path: n, args: o }) => {
    const r = [
      e,
      ...n
    ], i = r.pop();
    if (i === "useMutation")
      return t[i](r, ...o);
    if (i === "_def")
      return {
        path: r
      };
    const [a, ...s] = o, c = s[0] || {};
    return t[i](r, a, c);
  });
}
const jmc = [
  "client",
  "ssrContext",
  "ssrState",
  "abortOnUnmount"
];
var lre;
const Vmc = (lre = Ue.createContext) == null ? void 0 : lre.call(Ue, null);
function Oh(e, t, n) {
  const o = e.flatMap((r) => r.split("."));
  if (!t && (!n || n === "any"))
    return o.length ? [
      o
    ] : [];
  if (n === "infinite" && t && typeof t == "object" && "cursor" in t) {
    const { cursor: r, ...i } = t;
    return [
      o,
      {
        input: i,
        type: "infinite"
      }
    ];
  }
  return [
    o,
    {
      ...typeof t < "u" && {
        input: t
      },
      ...n && n !== "any" && {
        type: n
      }
    }
  ];
}
const Bmc = (e) => {
  switch (e) {
    case "fetch":
    case "ensureData":
    case "prefetch":
    case "getData":
    case "setData":
      return "query";
    case "fetchInfinite":
    case "prefetchInfinite":
    case "getInfiniteData":
    case "setInfiniteData":
      return "infinite";
    case "cancel":
    case "invalidate":
    case "refetch":
    case "reset":
      return "any";
  }
};
function Umc(e, t) {
  return ZT((n) => {
    const o = [
      t,
      ...n.path
    ], r = o.pop(), i = [
      ...n.args
    ], a = i.shift(), s = Bmc(r), c = Oh(o, a, s);
    return {
      fetch: () => e.fetchQuery(c, ...i),
      fetchInfinite: () => e.fetchInfiniteQuery(c, i[0]),
      prefetch: () => e.prefetchQuery(c, ...i),
      prefetchInfinite: () => e.prefetchInfiniteQuery(c, i[0]),
      ensureData: () => e.ensureQueryData(c, ...i),
      invalidate: () => e.invalidateQueries(c, ...i),
      reset: () => e.resetQueries(c, ...i),
      refetch: () => e.refetchQueries(c, ...i),
      cancel: () => e.cancelQuery(c, ...i),
      setData: () => {
        e.setQueryData(c, i[0], i[1]);
      },
      setInfiniteData: () => {
        e.setInfiniteQueryData(c, i[0], i[1]);
      },
      getData: () => e.getQueryData(c),
      getInfiniteData: () => e.getInfiniteQueryData(c)
    }[r]();
  });
}
function Gmc(e) {
  return RF((t) => {
    const n = t;
    return n === "client" ? $mc(e.client) : jmc.includes(n) ? e[n] : Umc(e, t);
  });
}
function q8(e) {
  return ZT((t) => {
    const n = t.path, o = n.join("."), [r, i] = t.args;
    return {
      queryKey: Oh(n, r, "query"),
      queryFn: () => e.query(o, r, i == null ? void 0 : i.trpc),
      ...i
    };
  });
}
function Rp(e, t, n) {
  var i;
  const o = e[0], r = (i = e[1]) == null ? void 0 : i.input;
  return n && (r.cursor = n), [
    o.join("."),
    r,
    t == null ? void 0 : t.trpc
  ];
}
function H$(e) {
  const t = Ue.useRef(e);
  return t.current.path = e.path, t.current;
}
function Wmc(e) {
  const { client: t, queryClient: n } = e, o = t instanceof uue ? t : wmc(t);
  return {
    fetchQuery: (r, i) => n.fetchQuery({
      ...i,
      queryKey: r,
      queryFn: () => o.query(...Rp(r, i))
    }),
    fetchInfiniteQuery: (r, i) => n.fetchInfiniteQuery({
      ...i,
      queryKey: r,
      queryFn: ({ pageParam: a }) => o.query(...Rp(r, i, a)),
      initialPageParam: (i == null ? void 0 : i.initialCursor) ?? null
    }),
    prefetchQuery: (r, i) => n.prefetchQuery({
      ...i,
      queryKey: r,
      queryFn: () => o.query(...Rp(r, i))
    }),
    prefetchInfiniteQuery: (r, i) => n.prefetchInfiniteQuery({
      ...i,
      queryKey: r,
      queryFn: ({ pageParam: a }) => o.query(...Rp(r, i, a)),
      initialPageParam: (i == null ? void 0 : i.initialCursor) ?? null
    }),
    ensureQueryData: (r, i) => n.ensureQueryData({
      ...i,
      queryKey: r,
      queryFn: () => o.query(...Rp(r, i))
    }),
    invalidateQueries: (r, i, a) => n.invalidateQueries({
      ...i,
      queryKey: r
    }, a),
    resetQueries: (r, i, a) => n.resetQueries({
      ...i,
      queryKey: r
    }, a),
    refetchQueries: (r, i, a) => n.refetchQueries({
      ...i,
      queryKey: r
    }, a),
    cancelQuery: (r, i) => n.cancelQueries({
      queryKey: r
    }, i),
    setQueryData: (r, i, a) => n.setQueryData(r, i, a),
    getQueryData: (r) => n.getQueryData(r),
    setInfiniteQueryData: (r, i, a) => n.setQueryData(r, i, a),
    getInfiniteQueryData: (r) => n.getQueryData(r)
  };
}
function gue(e) {
  var h, $;
  const t = (($ = (h = e == null ? void 0 : e.overrides) == null ? void 0 : h.useMutation) == null ? void 0 : $.onSuccess) ?? ((v) => v.originalFn()), n = (e == null ? void 0 : e.context) ?? Vmc, o = (v) => due(v), r = (v) => {
    const { abortOnUnmount: b = !1, client: y, queryClient: w, ssrContext: N } = v, [M, q] = Ue.useState(v.ssrState ?? !1), L = Ue.useMemo(() => Wmc({
      client: y,
      queryClient: w
    }), [
      y,
      w
    ]), R = Ue.useMemo(() => ({
      abortOnUnmount: b,
      queryClient: w,
      client: y,
      ssrContext: N ?? null,
      ssrState: M,
      ...L
    }), [
      b,
      y,
      L,
      w,
      N,
      M
    ]);
    return Ue.useEffect(() => {
      q((T) => T ? "mounted" : !1);
    }, []), /* @__PURE__ */ Ue.createElement(n.Provider, {
      value: R
    }, v.children);
  };
  function i() {
    const v = Ue.useContext(n);
    if (!v)
      throw new Error("Unable to find tRPC Context. Did you forget to wrap your App inside `withTRPC` HoC?");
    return v;
  }
  function a(v, b) {
    var N;
    const { queryClient: y, ssrState: w } = i();
    return w && w !== "mounted" && ((N = y.getQueryCache().find({
      queryKey: v
    })) == null ? void 0 : N.state.status) === "error" ? {
      retryOnMount: !1,
      ...b
    } : b;
  }
  function s(v, b, y) {
    var x, k;
    const w = i(), { abortOnUnmount: N, client: M, ssrState: q, queryClient: L, prefetchQuery: R } = w, T = Oh(v, b, "query"), D = L.getQueryDefaults(T);
    typeof window > "u" && q === "prepass" && ((x = y == null ? void 0 : y.trpc) == null ? void 0 : x.ssr) !== !1 && ((y == null ? void 0 : y.enabled) ?? (D == null ? void 0 : D.enabled)) !== !1 && !L.getQueryCache().find({
      queryKey: T
    }) && R(T, y);
    const A = a(T, {
      ...D,
      ...y
    }), S = ((k = y == null ? void 0 : y.trpc) == null ? void 0 : k.abortOnUnmount) ?? (e == null ? void 0 : e.abortOnUnmount) ?? N, E = mr({
      ...A,
      queryKey: T,
      queryFn: (I) => {
        const z = {
          ...A,
          trpc: {
            ...A == null ? void 0 : A.trpc,
            ...S ? {
              signal: I.signal
            } : {}
          }
        };
        return M.query(...Rp(T, z));
      }
    }, L);
    return E.trpc = H$({
      path: v.join(".")
    }), E;
  }
  function c(v, b, y) {
    var L;
    const w = i(), N = Oh(v, b, "query"), M = ((L = y == null ? void 0 : y.trpc) == null ? void 0 : L.abortOnUnmount) ?? (e == null ? void 0 : e.abortOnUnmount) ?? w.abortOnUnmount, q = rEe({
      ...y,
      queryKey: N,
      queryFn: (R) => {
        const T = {
          trpc: {
            ...M ? {
              signal: R.signal
            } : {}
          }
        };
        return w.client.query(...Rp(N, T));
      }
    }, w.queryClient);
    return q.trpc = H$({
      path: v.join(".")
    }), [
      q.data,
      q
    ];
  }
  function l(v, b) {
    const { client: y } = i(), w = qc(), N = [
      v
    ], M = w.getMutationDefaults(N), q = Hr({
      ...b,
      mutationKey: N,
      mutationFn: (L) => y.mutation(...Rp([
        v,
        {
          input: L
        }
      ], b)),
      onSuccess(...L) {
        return t({
          originalFn: () => {
            var T, D;
            return ((T = b == null ? void 0 : b.onSuccess) == null ? void 0 : T.call(b, ...L)) ?? ((D = M == null ? void 0 : M.onSuccess) == null ? void 0 : D.call(M, ...L));
          },
          queryClient: w,
          meta: (b == null ? void 0 : b.meta) ?? (M == null ? void 0 : M.meta) ?? {}
        });
      }
    }, w);
    return q.trpc = H$({
      path: v.join(".")
    }), q;
  }
  /* istanbul ignore next -- @preserve */
  function u(v, b, y) {
    const w = (y == null ? void 0 : y.enabled) ?? !0, N = Ag(Oh(v, b, "any")), { client: M } = i(), q = Ue.useRef(y);
    q.current = y, Ue.useEffect(() => {
      if (!w)
        return;
      let L = !1;
      const R = M.subscription(v.join("."), b ?? void 0, {
        onStarted: () => {
          var T, D;
          L || (D = (T = q.current).onStarted) == null || D.call(T);
        },
        onData: (T) => {
          L || y.onData(T);
        },
        onError: (T) => {
          var D, A;
          L || (A = (D = q.current).onError) == null || A.call(D, T);
        }
      });
      return () => {
        L = !0, R.unsubscribe();
      };
    }, [
      N,
      w
    ]);
  }
  function d(v, b, y) {
    var E, x;
    const { client: w, ssrState: N, prefetchInfiniteQuery: M, queryClient: q, abortOnUnmount: L } = i(), R = Oh(v, b, "infinite"), T = q.getQueryDefaults(R);
    typeof window > "u" && N === "prepass" && ((E = y == null ? void 0 : y.trpc) == null ? void 0 : E.ssr) !== !1 && ((y == null ? void 0 : y.enabled) ?? (T == null ? void 0 : T.enabled)) !== !1 && !q.getQueryCache().find({
      queryKey: R
    }) && M(R, {
      ...T,
      ...y
    });
    const D = a(R, {
      ...T,
      ...y
    }), A = ((x = y == null ? void 0 : y.trpc) == null ? void 0 : x.abortOnUnmount) ?? L, S = lEe({
      ...D,
      initialPageParam: y.initialCursor ?? null,
      persister: y.persister,
      queryKey: R,
      queryFn: (k) => {
        const I = {
          ...D,
          trpc: {
            ...D == null ? void 0 : D.trpc,
            ...A ? {
              signal: k.signal
            } : {}
          }
        };
        return w.query(...Rp(R, I, k.pageParam ?? y.initialCursor));
      }
    }, q);
    return S.trpc = H$({
      path: v.join(".")
    }), S;
  }
  function _(v, b, y) {
    var T;
    const w = i(), N = Oh(v, b, "infinite"), M = w.queryClient.getQueryDefaults(N), q = a(N, {
      ...M,
      ...y
    }), L = ((T = y == null ? void 0 : y.trpc) == null ? void 0 : T.abortOnUnmount) ?? w.abortOnUnmount, R = iEe({
      ...y,
      initialPageParam: y.initialCursor ?? null,
      queryKey: N,
      queryFn: (D) => {
        const A = {
          ...q,
          trpc: {
            ...q == null ? void 0 : q.trpc,
            ...L ? {
              signal: D.signal
            } : {}
          }
        };
        return w.client.query(...Rp(N, A, D.pageParam ?? y.initialCursor));
      }
    }, w.queryClient);
    return R.trpc = H$({
      path: v.join(".")
    }), [
      R.data,
      R
    ];
  }
  return {
    Provider: r,
    createClient: o,
    useContext: i,
    useUtils: i,
    useQuery: s,
    useSuspenseQuery: c,
    useQueries: (v) => {
      var L;
      const { ssrState: b, queryClient: y, prefetchQuery: w, client: N } = i(), M = q8(N), q = v(M);
      if (typeof window > "u" && b === "prepass")
        for (const R of q) {
          const T = R;
          ((L = T.trpc) == null ? void 0 : L.ssr) !== !1 && !y.getQueryCache().find({
            queryKey: T.queryKey
          }) && w(T.queryKey, T);
        }
      return Fre({
        queries: q.map((R) => ({
          ...R,
          queryKey: R.queryKey
        }))
      }, y);
    },
    useSuspenseQueries: (v) => {
      const { queryClient: b, client: y } = i(), w = q8(y), N = v(w), M = aEe({
        queries: N.map((q) => ({
          ...q,
          queryKey: q.queryKey
        }))
      }, b);
      return [
        M.map((q) => q.data),
        M
      ];
    },
    useMutation: l,
    useSubscription: u,
    useDehydratedState: (v, b) => Ue.useMemo(() => b && v.runtime.transformer.deserialize(b), [
      b,
      v
    ]),
    useInfiniteQuery: d,
    useSuspenseInfiniteQuery: _
  };
}
const j8 = (e) => e.queryClient ?? new xre(e.queryClientConfig);
function V8(e) {
  const t = e.state.error;
  if (t instanceof Error && t.name === "TRPCClientError") {
    const n = {
      message: t.message,
      data: t.data,
      shape: t.shape
    };
    return {
      ...e,
      state: {
        ...e.state,
        error: n
      }
    };
  }
  return e;
}
function Hmc(e) {
  const { config: t } = e;
  return (n) => {
    const o = gue(e), r = (a) => {
      var p;
      const [s] = it(() => {
        if (a.trpc)
          return a.trpc;
        const g = t({}), f = j8(g), h = o.createClient(g);
        return {
          abortOnUnmount: g.abortOnUnmount,
          queryClient: f,
          trpcClient: h,
          ssrState: e.ssr ? "mounting" : !1,
          ssrContext: null
        };
      }), { queryClient: c, trpcClient: l, ssrState: u, ssrContext: d } = s, _ = o.useDehydratedState(l, (p = a.pageProps) == null ? void 0 : p.trpcState);
      return /* @__PURE__ */ Fe.createElement(o.Provider, {
        abortOnUnmount: s.abortOnUnmount ?? !1,
        client: l,
        queryClient: c,
        ssrState: u,
        ssrContext: d
      }, /* @__PURE__ */ Fe.createElement(Ire, {
        client: c
      }, /* @__PURE__ */ Fe.createElement(sEe, {
        state: _
      }, /* @__PURE__ */ Fe.createElement(n, Object.assign({}, a)))));
    };
    (n.getInitialProps ?? e.ssr) && (r.getInitialProps = async (a) => {
      var M, q;
      const c = await (async () => {
        if (typeof e.ssr == "function") {
          if (typeof window < "u")
            return !1;
          try {
            return await e.ssr({
              ctx: a.ctx
            });
          } catch {
            return !1;
          }
        }
        return e.ssr;
      })(), l = a.AppTree, u = !!a.Component, d = u ? a.ctx : a;
      let _ = {};
      if (n.getInitialProps) {
        const L = await n.getInitialProps(a);
        _ = {
          ...u ? L.pageProps ?? {} : L,
          ..._
        };
      }
      const p = (L) => u ? {
        pageProps: L
      } : L;
      if (typeof window < "u" || !c)
        return p(_);
      const g = t({
        ctx: d
      }), f = due(g), h = j8(g), v = {
        pageProps: _,
        trpc: {
          config: g,
          trpcClient: f,
          queryClient: h,
          ssrState: "prepass",
          ssrContext: d
        }
      }, b = await import("./server.browser-yA5s9iMO.js").then((L) => L.s);
      for (; b.renderToString(/* @__PURE__ */ pt(l, v)), !!h.isFetching(); )
        await new Promise((L) => {
          const R = h.getQueryCache().subscribe((T) => {
            (T == null ? void 0 : T.query.getObserversCount()) === 0 && (L(), R());
          });
        });
      const y = eEe(h, {
        shouldDehydrateQuery(L) {
          return !(L.state.fetchStatus === "idle" && L.state.status === "pending");
        }
      }), w = {
        ...y,
        queries: y.queries.map(V8),
        mutations: y.mutations.map(V8)
      };
      _.trpcState = f.runtime.combinedTransformer.output.serialize(w);
      const N = p(_);
      if ("responseMeta" in e) {
        const L = ((M = e.responseMeta) == null ? void 0 : M.call(e, {
          ctx: d,
          clientErrors: [
            ...y.queries,
            ...y.mutations
          ].map((R) => R.state.error).flatMap((R) => R instanceof Error && R.name === "TRPCClientError" ? [
            R
          ] : [])
        })) ?? {};
        for (const [R, T] of Object.entries(L.headers ?? {}))
          typeof T == "string" && ((q = d.res) == null || q.setHeader(R, T));
        L.status && d.res && (d.res.statusCode = L.status);
      }
      return N;
    });
    const i = n.displayName ?? n.name ?? "Component";
    return r.displayName = `withTRPC(${i})`, r;
  };
}
/* istanbul ignore file -- @preserve */
function Ymc(e) {
  const t = gue(e), n = Hmc(e);
  return RF((o) => o === "useContext" || o === "useUtils" ? () => {
    const r = t.useUtils();
    return vn(() => Gmc(r), [
      r
    ]);
  } : o === "useQueries" ? t.useQueries : o === "useSuspenseQueries" ? t.useSuspenseQueries : o === "withTRPC" ? n : qmc(o, t));
}
const B8 = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "appRoutingForms",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "dsync",
  "eventTypes",
  "eventTypes/heavy",
  "features",
  "i18n",
  "insights",
  "me",
  "ooo",
  "payments",
  "public",
  "timezones",
  "saml",
  "slots",
  "teams",
  "organizations",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "workflows",
  "googleWorkspace",
  "oAuth",
  "attributes",
  "delegationCredential",
  "routingForms",
  "credits",
  "filterSegments",
  "aiVoiceAgent",
  "phoneNumber",
  "pbac"
], U8 = (e) => (t) => {
  const n = t.op.path.split(".");
  let o, r = "";
  return n.length == 2 ? (o = n[0], r = n[1]) : n.length >= 3 && n[2] === "heavy" ? (o = n[1] + "/heavy", r = n[3]) : (o = n[1], r = n.splice(2, n.length - 2).join(".")), e[o]({ ...t, op: { ...t.op, path: r } });
}, hr = Ymc({
  config() {
    const e = typeof window < "u" ? "/api/trpc" : process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}/api/trpc` : "https://app.cal.com/api/trpc";
    return {
      /**
       * @link https://trpc.io/docs/links
       */
      links: [
        // adds pretty logs to your console in development and logs errors in production
        Mmc({
          enabled: (t) => typeof process.env.NEXT_PUBLIC_LOGGER_LEVEL == "number" && process.env.NEXT_PUBLIC_LOGGER_LEVEL >= 0 || t.direction === "down" && t.result instanceof Error
        }),
        Fmc({
          // check for context property `skipBatch`
          condition: (t) => !!t.context.skipBatch,
          // when condition is true, use normal request
          true: (t) => {
            const n = Object.fromEntries(
              B8.map((o) => [o, Rmc({ url: `${e}/${o}` })(t)])
            );
            return U8(n);
          },
          // when condition is false, use batch request
          false: (t) => {
            const n = Object.fromEntries(
              B8.map((o) => [o, Nmc({ url: `${e}/${o}` })(t)])
            );
            return U8(n);
          }
        })
      ],
      /**
       * @link https://react-query.tanstack.com/reference/QueryClient
       */
      queryClientConfig: {
        defaultOptions: {
          queries: {
            /**
             * 1s should be enough to just keep identical query waterfalls low
             * @example if one page components uses a query that is also used further down the tree
             */
            staleTime: 1e3,
            /**
             * Retry `useQuery()` calls depending on this function
             */
            retry(t, n) {
              var a;
              const o = n, r = (a = o == null ? void 0 : o.data) == null ? void 0 : a.code;
              return r === "BAD_REQUEST" || r === "FORBIDDEN" || r === "UNAUTHORIZED" ? !1 : t < 3;
            }
          }
        }
      },
      /**
       * @link https://trpc.io/docs/data-transformers
       */
      transformer: amc
    };
  },
  /**
   * @link https://trpc.io/docs/ssr
   */
  ssr: !1
});
function hue(e) {
  const t = xt({
    value: e,
    previous: e
  });
  return vn(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const vue = "Checkbox", [Kmc, osu] = jc(vue), [Zmc, Xmc] = Kmc(vue), Jmc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeCheckbox: n, name: o, checked: r, defaultChecked: i, required: a, disabled: s, value: c = "on", onCheckedChange: l, ...u } = e, [d, _] = it(null), p = ni(
    t,
    (b) => _(b)
  ), g = xt(!1), f = d ? !!d.closest("form") : !0, [h = !1, $] = Uu({
    prop: r,
    defaultProp: i,
    onChange: l
  }), v = xt(h);
  return yt(() => {
    const b = d == null ? void 0 : d.form;
    if (b) {
      const y = () => $(v.current);
      return b.addEventListener("reset", y), () => b.removeEventListener("reset", y);
    }
  }, [
    d,
    $
  ]), /* @__PURE__ */ pt(Zmc, {
    scope: n,
    state: h,
    disabled: s
  }, /* @__PURE__ */ pt(nr.button, Tt({
    type: "button",
    role: "checkbox",
    "aria-checked": nv(h) ? "mixed" : h,
    "aria-required": a,
    "data-state": bue(h),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: c
  }, u, {
    ref: p,
    onKeyDown: jn(e.onKeyDown, (b) => {
      b.key === "Enter" && b.preventDefault();
    }),
    onClick: jn(e.onClick, (b) => {
      $(
        (y) => nv(y) ? !0 : !y
      ), f && (g.current = b.isPropagationStopped(), g.current || b.stopPropagation());
    })
  })), f && /* @__PURE__ */ pt(tfc, {
    control: d,
    bubbles: !g.current,
    name: o,
    value: c,
    checked: h,
    required: a,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Qmc = "CheckboxIndicator", efc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeCheckbox: n, forceMount: o, ...r } = e, i = Xmc(Qmc, n);
  return /* @__PURE__ */ pt(Vc, {
    present: o || nv(i.state) || i.state === !0
  }, /* @__PURE__ */ pt(nr.span, Tt({
    "data-state": bue(i.state),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), tfc = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = xt(null), a = hue(n), s = CT(t);
  return yt(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && d) {
      const _ = new Event("click", {
        bubbles: o
      });
      c.indeterminate = nv(n), d.call(c, nv(n) ? !1 : n), c.dispatchEvent(_);
    }
  }, [
    a,
    n,
    o
  ]), /* @__PURE__ */ pt("input", Tt({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: nv(n) ? !1 : n
  }, r, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function nv(e) {
  return e === "indeterminate";
}
function bue(e) {
  return nv(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const yue = Jmc, nfc = efc;
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */
const {
  entries: $ue,
  setPrototypeOf: G8,
  isFrozen: ofc,
  getPrototypeOf: rfc,
  getOwnPropertyDescriptor: ifc
} = Object;
let {
  freeze: $l,
  seal: Pd,
  create: wue
} = Object, {
  apply: C4,
  construct: T4
} = typeof Reflect < "u" && Reflect;
$l || ($l = function(t) {
  return t;
});
Pd || (Pd = function(t) {
  return t;
});
C4 || (C4 = function(t, n, o) {
  return t.apply(n, o);
});
T4 || (T4 = function(t, n) {
  return new t(...n);
});
const qS = qu(Array.prototype.forEach), W8 = qu(Array.prototype.pop), Y$ = qu(Array.prototype.push), ax = qu(String.prototype.toLowerCase), PN = qu(String.prototype.toString), H8 = qu(String.prototype.match), K$ = qu(String.prototype.replace), afc = qu(String.prototype.indexOf), sfc = qu(String.prototype.trim), S_ = qu(Object.prototype.hasOwnProperty), al = qu(RegExp.prototype.test), Z$ = cfc(TypeError);
function qu(e) {
  return function(t) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
      o[r - 1] = arguments[r];
    return C4(e, t, o);
  };
}
function cfc(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return T4(e, n);
  };
}
function wr(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ax;
  G8 && G8(e, null);
  let o = t.length;
  for (; o--; ) {
    let r = t[o];
    if (typeof r == "string") {
      const i = n(r);
      i !== r && (ofc(t) || (t[o] = i), r = i);
    }
    e[r] = !0;
  }
  return e;
}
function lfc(e) {
  for (let t = 0; t < e.length; t++)
    S_(e, t) || (e[t] = null);
  return e;
}
function Eh(e) {
  const t = wue(null);
  for (const [n, o] of $ue(e))
    S_(e, n) && (Array.isArray(o) ? t[n] = lfc(o) : o && typeof o == "object" && o.constructor === Object ? t[n] = Eh(o) : t[n] = o);
  return t;
}
function X$(e, t) {
  for (; e !== null; ) {
    const o = ifc(e, t);
    if (o) {
      if (o.get)
        return qu(o.get);
      if (typeof o.value == "function")
        return qu(o.value);
    }
    e = rfc(e);
  }
  function n() {
    return null;
  }
  return n;
}
const Y8 = $l(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), DN = $l(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), LN = $l(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), ufc = $l(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), MN = $l(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), dfc = $l(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), K8 = $l(["#text"]), Z8 = $l(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), FN = $l(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), X8 = $l(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), jS = $l(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), _fc = Pd(/\{\{[\w\W]*|[\w\W]*\}\}/gm), pfc = Pd(/<%[\w\W]*|[\w\W]*%>/gm), mfc = Pd(/\$\{[\w\W]*}/gm), ffc = Pd(/^data-[\-\w.\u00B7-\uFFFF]+$/), gfc = Pd(/^aria-[\-\w]+$/), kue = Pd(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), hfc = Pd(/^(?:\w+script|data):/i), vfc = Pd(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Sue = Pd(/^html$/i), bfc = Pd(/^[a-z][.\w]*(-[.\w]+)+$/i);
var J8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: gfc,
  ATTR_WHITESPACE: vfc,
  CUSTOM_ELEMENT: bfc,
  DATA_ATTR: ffc,
  DOCTYPE_NAME: Sue,
  ERB_EXPR: pfc,
  IS_ALLOWED_URI: kue,
  IS_SCRIPT_OR_DATA: hfc,
  MUSTACHE_EXPR: _fc,
  TMPLIT_EXPR: mfc
});
const J$ = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, yfc = function() {
  return typeof window > "u" ? null : window;
}, $fc = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let o = null;
  const r = "data-tt-policy-suffix";
  n && n.hasAttribute(r) && (o = n.getAttribute(r));
  const i = "dompurify" + (o ? "#" + o : "");
  try {
    return t.createPolicy(i, {
      createHTML(a) {
        return a;
      },
      createScriptURL(a) {
        return a;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, Q8 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Eue() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : yfc();
  const t = (kn) => Eue(kn);
  if (t.version = "3.2.3", t.removed = [], !e || !e.document || e.document.nodeType !== J$.document)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const o = n, r = o.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: a,
    Node: s,
    Element: c,
    NodeFilter: l,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: _,
    trustedTypes: p
  } = e, g = c.prototype, f = X$(g, "cloneNode"), h = X$(g, "remove"), $ = X$(g, "nextSibling"), v = X$(g, "childNodes"), b = X$(g, "parentNode");
  if (typeof a == "function") {
    const kn = n.createElement("template");
    kn.content && kn.content.ownerDocument && (n = kn.content.ownerDocument);
  }
  let y, w = "";
  const {
    implementation: N,
    createNodeIterator: M,
    createDocumentFragment: q,
    getElementsByTagName: L
  } = n, {
    importNode: R
  } = o;
  let T = Q8();
  t.isSupported = typeof $ue == "function" && typeof b == "function" && N && N.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: D,
    ERB_EXPR: A,
    TMPLIT_EXPR: S,
    DATA_ATTR: E,
    ARIA_ATTR: x,
    IS_SCRIPT_OR_DATA: k,
    ATTR_WHITESPACE: I,
    CUSTOM_ELEMENT: z
  } = J8;
  let {
    IS_ALLOWED_URI: F
  } = J8, P = null;
  const O = wr({}, [...Y8, ...DN, ...LN, ...MN, ...K8]);
  let V = null;
  const U = wr({}, [...Z8, ...FN, ...X8, ...jS]);
  let H = Object.seal(wue(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), J = null, le = null, ae = !0, Y = !0, re = !1, ie = !0, _e = !1, he = !0, be = !1, Q = !1, me = !1, ne = !1, pe = !1, ge = !1, ve = !0, Te = !1;
  const Re = "user-content-";
  let Me = !0, et = !1, st = {}, De = null;
  const ze = wr({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Pe = null;
  const je = wr({}, ["audio", "video", "img", "source", "image", "track"]);
  let He = null;
  const Xe = wr({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), at = "http://www.w3.org/1998/Math/MathML", wt = "http://www.w3.org/2000/svg", Je = "http://www.w3.org/1999/xhtml";
  let vt = Je, Ot = !1, Ft = null;
  const wn = wr({}, [at, wt, Je], PN);
  let un = wr({}, ["mi", "mo", "mn", "ms", "mtext"]), pn = wr({}, ["annotation-xml"]);
  const Dn = wr({}, ["title", "style", "font", "a", "script"]);
  let Rn = null;
  const Ln = ["application/xhtml+xml", "text/html"], Yn = "text/html";
  let Qt = null, fn = null;
  const qn = n.createElement("form"), Xn = function(dt) {
    return dt instanceof RegExp || dt instanceof Function;
  }, Qn = function() {
    let dt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(fn && fn === dt)) {
      if ((!dt || typeof dt != "object") && (dt = {}), dt = Eh(dt), Rn = // eslint-disable-next-line unicorn/prefer-includes
      Ln.indexOf(dt.PARSER_MEDIA_TYPE) === -1 ? Yn : dt.PARSER_MEDIA_TYPE, Qt = Rn === "application/xhtml+xml" ? PN : ax, P = S_(dt, "ALLOWED_TAGS") ? wr({}, dt.ALLOWED_TAGS, Qt) : O, V = S_(dt, "ALLOWED_ATTR") ? wr({}, dt.ALLOWED_ATTR, Qt) : U, Ft = S_(dt, "ALLOWED_NAMESPACES") ? wr({}, dt.ALLOWED_NAMESPACES, PN) : wn, He = S_(dt, "ADD_URI_SAFE_ATTR") ? wr(Eh(Xe), dt.ADD_URI_SAFE_ATTR, Qt) : Xe, Pe = S_(dt, "ADD_DATA_URI_TAGS") ? wr(Eh(je), dt.ADD_DATA_URI_TAGS, Qt) : je, De = S_(dt, "FORBID_CONTENTS") ? wr({}, dt.FORBID_CONTENTS, Qt) : ze, J = S_(dt, "FORBID_TAGS") ? wr({}, dt.FORBID_TAGS, Qt) : {}, le = S_(dt, "FORBID_ATTR") ? wr({}, dt.FORBID_ATTR, Qt) : {}, st = S_(dt, "USE_PROFILES") ? dt.USE_PROFILES : !1, ae = dt.ALLOW_ARIA_ATTR !== !1, Y = dt.ALLOW_DATA_ATTR !== !1, re = dt.ALLOW_UNKNOWN_PROTOCOLS || !1, ie = dt.ALLOW_SELF_CLOSE_IN_ATTR !== !1, _e = dt.SAFE_FOR_TEMPLATES || !1, he = dt.SAFE_FOR_XML !== !1, be = dt.WHOLE_DOCUMENT || !1, ne = dt.RETURN_DOM || !1, pe = dt.RETURN_DOM_FRAGMENT || !1, ge = dt.RETURN_TRUSTED_TYPE || !1, me = dt.FORCE_BODY || !1, ve = dt.SANITIZE_DOM !== !1, Te = dt.SANITIZE_NAMED_PROPS || !1, Me = dt.KEEP_CONTENT !== !1, et = dt.IN_PLACE || !1, F = dt.ALLOWED_URI_REGEXP || kue, vt = dt.NAMESPACE || Je, un = dt.MATHML_TEXT_INTEGRATION_POINTS || un, pn = dt.HTML_INTEGRATION_POINTS || pn, H = dt.CUSTOM_ELEMENT_HANDLING || {}, dt.CUSTOM_ELEMENT_HANDLING && Xn(dt.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (H.tagNameCheck = dt.CUSTOM_ELEMENT_HANDLING.tagNameCheck), dt.CUSTOM_ELEMENT_HANDLING && Xn(dt.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (H.attributeNameCheck = dt.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), dt.CUSTOM_ELEMENT_HANDLING && typeof dt.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (H.allowCustomizedBuiltInElements = dt.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), _e && (Y = !1), pe && (ne = !0), st && (P = wr({}, K8), V = [], st.html === !0 && (wr(P, Y8), wr(V, Z8)), st.svg === !0 && (wr(P, DN), wr(V, FN), wr(V, jS)), st.svgFilters === !0 && (wr(P, LN), wr(V, FN), wr(V, jS)), st.mathMl === !0 && (wr(P, MN), wr(V, X8), wr(V, jS))), dt.ADD_TAGS && (P === O && (P = Eh(P)), wr(P, dt.ADD_TAGS, Qt)), dt.ADD_ATTR && (V === U && (V = Eh(V)), wr(V, dt.ADD_ATTR, Qt)), dt.ADD_URI_SAFE_ATTR && wr(He, dt.ADD_URI_SAFE_ATTR, Qt), dt.FORBID_CONTENTS && (De === ze && (De = Eh(De)), wr(De, dt.FORBID_CONTENTS, Qt)), Me && (P["#text"] = !0), be && wr(P, ["html", "head", "body"]), P.table && (wr(P, ["tbody"]), delete J.tbody), dt.TRUSTED_TYPES_POLICY) {
        if (typeof dt.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Z$('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof dt.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Z$('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        y = dt.TRUSTED_TYPES_POLICY, w = y.createHTML("");
      } else
        y === void 0 && (y = $fc(p, r)), y !== null && typeof w == "string" && (w = y.createHTML(""));
      $l && $l(dt), fn = dt;
    }
  }, In = wr({}, [...DN, ...LN, ...ufc]), $n = wr({}, [...MN, ...dfc]), uo = function(dt) {
    let Pt = b(dt);
    (!Pt || !Pt.tagName) && (Pt = {
      namespaceURI: vt,
      tagName: "template"
    });
    const cn = ax(dt.tagName), sn = ax(Pt.tagName);
    return Ft[dt.namespaceURI] ? dt.namespaceURI === wt ? Pt.namespaceURI === Je ? cn === "svg" : Pt.namespaceURI === at ? cn === "svg" && (sn === "annotation-xml" || un[sn]) : !!In[cn] : dt.namespaceURI === at ? Pt.namespaceURI === Je ? cn === "math" : Pt.namespaceURI === wt ? cn === "math" && pn[sn] : !!$n[cn] : dt.namespaceURI === Je ? Pt.namespaceURI === wt && !pn[sn] || Pt.namespaceURI === at && !un[sn] ? !1 : !$n[cn] && (Dn[cn] || !In[cn]) : !!(Rn === "application/xhtml+xml" && Ft[dt.namespaceURI]) : !1;
  }, go = function(dt) {
    Y$(t.removed, {
      element: dt
    });
    try {
      b(dt).removeChild(dt);
    } catch {
      h(dt);
    }
  }, Rr = function(dt, Pt) {
    try {
      Y$(t.removed, {
        attribute: Pt.getAttributeNode(dt),
        from: Pt
      });
    } catch {
      Y$(t.removed, {
        attribute: null,
        from: Pt
      });
    }
    if (Pt.removeAttribute(dt), dt === "is")
      if (ne || pe)
        try {
          go(Pt);
        } catch {
        }
      else
        try {
          Pt.setAttribute(dt, "");
        } catch {
        }
  }, qo = function(dt) {
    let Pt = null, cn = null;
    if (me)
      dt = "<remove></remove>" + dt;
    else {
      const Ze = H8(dt, /^[\r\n\t ]+/);
      cn = Ze && Ze[0];
    }
    Rn === "application/xhtml+xml" && vt === Je && (dt = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dt + "</body></html>");
    const sn = y ? y.createHTML(dt) : dt;
    if (vt === Je)
      try {
        Pt = new _().parseFromString(sn, Rn);
      } catch {
      }
    if (!Pt || !Pt.documentElement) {
      Pt = N.createDocument(vt, "template", null);
      try {
        Pt.documentElement.innerHTML = Ot ? w : sn;
      } catch {
      }
    }
    const ao = Pt.body || Pt.documentElement;
    return dt && cn && ao.insertBefore(n.createTextNode(cn), ao.childNodes[0] || null), vt === Je ? L.call(Pt, be ? "html" : "body")[0] : be ? Pt.documentElement : ao;
  }, ho = function(dt) {
    return M.call(
      dt.ownerDocument || dt,
      dt,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, Ut = function(dt) {
    return dt instanceof d && (typeof dt.nodeName != "string" || typeof dt.textContent != "string" || typeof dt.removeChild != "function" || !(dt.attributes instanceof u) || typeof dt.removeAttribute != "function" || typeof dt.setAttribute != "function" || typeof dt.namespaceURI != "string" || typeof dt.insertBefore != "function" || typeof dt.hasChildNodes != "function");
  }, Kt = function(dt) {
    return typeof s == "function" && dt instanceof s;
  };
  function an(kn, dt, Pt) {
    qS(kn, (cn) => {
      cn.call(t, dt, Pt, fn);
    });
  }
  const Gn = function(dt) {
    let Pt = null;
    if (an(T.beforeSanitizeElements, dt, null), Ut(dt))
      return go(dt), !0;
    const cn = Qt(dt.nodeName);
    if (an(T.uponSanitizeElement, dt, {
      tagName: cn,
      allowedTags: P
    }), dt.hasChildNodes() && !Kt(dt.firstElementChild) && al(/<[/\w]/g, dt.innerHTML) && al(/<[/\w]/g, dt.textContent) || dt.nodeType === J$.progressingInstruction || he && dt.nodeType === J$.comment && al(/<[/\w]/g, dt.data))
      return go(dt), !0;
    if (!P[cn] || J[cn]) {
      if (!J[cn] && hn(cn) && (H.tagNameCheck instanceof RegExp && al(H.tagNameCheck, cn) || H.tagNameCheck instanceof Function && H.tagNameCheck(cn)))
        return !1;
      if (Me && !De[cn]) {
        const sn = b(dt) || dt.parentNode, ao = v(dt) || dt.childNodes;
        if (ao && sn) {
          const Ze = ao.length;
          for (let bt = Ze - 1; bt >= 0; --bt) {
            const Wt = f(ao[bt], !0);
            Wt.__removalCount = (dt.__removalCount || 0) + 1, sn.insertBefore(Wt, $(dt));
          }
        }
      }
      return go(dt), !0;
    }
    return dt instanceof c && !uo(dt) || (cn === "noscript" || cn === "noembed" || cn === "noframes") && al(/<\/no(script|embed|frames)/i, dt.innerHTML) ? (go(dt), !0) : (_e && dt.nodeType === J$.text && (Pt = dt.textContent, qS([D, A, S], (sn) => {
      Pt = K$(Pt, sn, " ");
    }), dt.textContent !== Pt && (Y$(t.removed, {
      element: dt.cloneNode()
    }), dt.textContent = Pt)), an(T.afterSanitizeElements, dt, null), !1);
  }, An = function(dt, Pt, cn) {
    if (ve && (Pt === "id" || Pt === "name") && (cn in n || cn in qn))
      return !1;
    if (!(Y && !le[Pt] && al(E, Pt))) {
      if (!(ae && al(x, Pt))) {
        if (!V[Pt] || le[Pt]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(hn(dt) && (H.tagNameCheck instanceof RegExp && al(H.tagNameCheck, dt) || H.tagNameCheck instanceof Function && H.tagNameCheck(dt)) && (H.attributeNameCheck instanceof RegExp && al(H.attributeNameCheck, Pt) || H.attributeNameCheck instanceof Function && H.attributeNameCheck(Pt)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Pt === "is" && H.allowCustomizedBuiltInElements && (H.tagNameCheck instanceof RegExp && al(H.tagNameCheck, cn) || H.tagNameCheck instanceof Function && H.tagNameCheck(cn)))
          )
            return !1;
        } else if (!He[Pt]) {
          if (!al(F, K$(cn, I, ""))) {
            if (!((Pt === "src" || Pt === "xlink:href" || Pt === "href") && dt !== "script" && afc(cn, "data:") === 0 && Pe[dt])) {
              if (!(re && !al(k, K$(cn, I, "")))) {
                if (cn)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, hn = function(dt) {
    return dt !== "annotation-xml" && H8(dt, z);
  }, zn = function(dt) {
    an(T.beforeSanitizeAttributes, dt, null);
    const {
      attributes: Pt
    } = dt;
    if (!Pt || Ut(dt))
      return;
    const cn = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: V,
      forceKeepAttr: void 0
    };
    let sn = Pt.length;
    for (; sn--; ) {
      const ao = Pt[sn], {
        name: Ze,
        namespaceURI: bt,
        value: Wt
      } = ao, xn = Qt(Ze);
      let It = Ze === "value" ? Wt : sfc(Wt);
      if (cn.attrName = xn, cn.attrValue = It, cn.keepAttr = !0, cn.forceKeepAttr = void 0, an(T.uponSanitizeAttribute, dt, cn), It = cn.attrValue, Te && (xn === "id" || xn === "name") && (Rr(Ze, dt), It = Re + It), he && al(/((--!?|])>)|<\/(style|title)/i, It)) {
        Rr(Ze, dt);
        continue;
      }
      if (cn.forceKeepAttr || (Rr(Ze, dt), !cn.keepAttr))
        continue;
      if (!ie && al(/\/>/i, It)) {
        Rr(Ze, dt);
        continue;
      }
      _e && qS([D, A, S], (ur) => {
        It = K$(It, ur, " ");
      });
      const Jn = Qt(dt.nodeName);
      if (An(Jn, xn, It)) {
        if (y && typeof p == "object" && typeof p.getAttributeType == "function" && !bt)
          switch (p.getAttributeType(Jn, xn)) {
            case "TrustedHTML": {
              It = y.createHTML(It);
              break;
            }
            case "TrustedScriptURL": {
              It = y.createScriptURL(It);
              break;
            }
          }
        try {
          bt ? dt.setAttributeNS(bt, Ze, It) : dt.setAttribute(Ze, It), Ut(dt) ? go(dt) : W8(t.removed);
        } catch {
        }
      }
    }
    an(T.afterSanitizeAttributes, dt, null);
  }, gn = function kn(dt) {
    let Pt = null;
    const cn = ho(dt);
    for (an(T.beforeSanitizeShadowDOM, dt, null); Pt = cn.nextNode(); )
      an(T.uponSanitizeShadowNode, Pt, null), Gn(Pt), zn(Pt), Pt.content instanceof i && kn(Pt.content);
    an(T.afterSanitizeShadowDOM, dt, null);
  };
  return t.sanitize = function(kn) {
    let dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Pt = null, cn = null, sn = null, ao = null;
    if (Ot = !kn, Ot && (kn = "<!-->"), typeof kn != "string" && !Kt(kn))
      if (typeof kn.toString == "function") {
        if (kn = kn.toString(), typeof kn != "string")
          throw Z$("dirty is not a string, aborting");
      } else
        throw Z$("toString is not a function");
    if (!t.isSupported)
      return kn;
    if (Q || Qn(dt), t.removed = [], typeof kn == "string" && (et = !1), et) {
      if (kn.nodeName) {
        const Wt = Qt(kn.nodeName);
        if (!P[Wt] || J[Wt])
          throw Z$("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (kn instanceof s)
      Pt = qo("<!---->"), cn = Pt.ownerDocument.importNode(kn, !0), cn.nodeType === J$.element && cn.nodeName === "BODY" || cn.nodeName === "HTML" ? Pt = cn : Pt.appendChild(cn);
    else {
      if (!ne && !_e && !be && // eslint-disable-next-line unicorn/prefer-includes
      kn.indexOf("<") === -1)
        return y && ge ? y.createHTML(kn) : kn;
      if (Pt = qo(kn), !Pt)
        return ne ? null : ge ? w : "";
    }
    Pt && me && go(Pt.firstChild);
    const Ze = ho(et ? kn : Pt);
    for (; sn = Ze.nextNode(); )
      Gn(sn), zn(sn), sn.content instanceof i && gn(sn.content);
    if (et)
      return kn;
    if (ne) {
      if (pe)
        for (ao = q.call(Pt.ownerDocument); Pt.firstChild; )
          ao.appendChild(Pt.firstChild);
      else
        ao = Pt;
      return (V.shadowroot || V.shadowrootmode) && (ao = R.call(o, ao, !0)), ao;
    }
    let bt = be ? Pt.outerHTML : Pt.innerHTML;
    return be && P["!doctype"] && Pt.ownerDocument && Pt.ownerDocument.doctype && Pt.ownerDocument.doctype.name && al(Sue, Pt.ownerDocument.doctype.name) && (bt = "<!DOCTYPE " + Pt.ownerDocument.doctype.name + `>
` + bt), _e && qS([D, A, S], (Wt) => {
      bt = K$(bt, Wt, " ");
    }), y && ge ? y.createHTML(bt) : bt;
  }, t.setConfig = function() {
    let kn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Qn(kn), Q = !0;
  }, t.clearConfig = function() {
    fn = null, Q = !1;
  }, t.isValidAttribute = function(kn, dt, Pt) {
    fn || Qn({});
    const cn = Qt(kn), sn = Qt(dt);
    return An(cn, sn, Pt);
  }, t.addHook = function(kn, dt) {
    typeof dt == "function" && Y$(T[kn], dt);
  }, t.removeHook = function(kn) {
    return W8(T[kn]);
  }, t.removeHooks = function(kn) {
    T[kn] = [];
  }, t.removeAllHooks = function() {
    T = Q8();
  }, t;
}
var xue = Eue();
function PF() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let Tv = PF();
function Cue(e) {
  Tv = e;
}
const Hw = { exec: () => null };
function Li(e, t = "") {
  let n = typeof e == "string" ? e : e.source;
  const o = {
    replace: (r, i) => {
      let a = typeof i == "string" ? i : i.source;
      return a = a.replace(vl.caret, "$1"), n = n.replace(r, a), o;
    },
    getRegex: () => new RegExp(n, t)
  };
  return o;
}
const vl = {
  codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
  outputLinkReplace: /\\([\[\]])/g,
  indentCodeCompensation: /^(\s+)(?:```)/,
  beginningSpace: /^\s+/,
  endingHash: /#$/,
  startingSpaceChar: /^ /,
  endingSpaceChar: / $/,
  nonSpaceChar: /[^ ]/,
  newLineCharGlobal: /\n/g,
  tabCharGlobal: /\t/g,
  multipleSpaceGlobal: /\s+/g,
  blankLine: /^[ \t]*$/,
  doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
  blockquoteStart: /^ {0,3}>/,
  blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
  blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
  listReplaceTabs: /^\t+/,
  listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
  listIsTask: /^\[[ xX]\] /,
  listReplaceTask: /^\[[ xX]\] +/,
  anyLine: /\n.*\n/,
  hrefBrackets: /^<(.*)>$/,
  tableDelimiter: /[:|]/,
  tableAlignChars: /^\||\| *$/g,
  tableRowBlankLine: /\n[ \t]*$/,
  tableAlignRight: /^ *-+: *$/,
  tableAlignCenter: /^ *:-+: *$/,
  tableAlignLeft: /^ *:-+ *$/,
  startATag: /^<a /i,
  endATag: /^<\/a>/i,
  startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
  endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
  startAngleBracket: /^</,
  endAngleBracket: />$/,
  pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
  unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
  escapeTest: /[&<>"']/,
  escapeReplace: /[&<>"']/g,
  escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
  escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
  unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
  caret: /(^|[^\[])\^/g,
  percentDecode: /%25/g,
  findPipe: /\|/g,
  splitPipe: / \|/,
  slashPipe: /\\\|/g,
  carriageReturn: /\r\n|\r/g,
  spaceLine: /^ +$/gm,
  notSpaceStart: /^\S*/,
  endingNewline: /\n$/,
  listItemRegex: (e) => new RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
  nextBulletRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
  hrRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
  fencesBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
  headingBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
  htmlBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, "i")
}, wfc = /^(?:[ \t]*(?:\n|$))+/, kfc = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Sfc = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, B0 = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Efc = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, Tue = /(?:[*+-]|\d{1,9}[.)])/, Aue = Li(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, Tue).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), DF = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, xfc = /^[^\n]+/, LF = /(?!\s*\])(?:\\.|[^\[\]\\])+/, Cfc = Li(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", LF).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Tfc = Li(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Tue).getRegex(), XT = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", MF = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Afc = Li("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", MF).replace("tag", XT).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), Iue = Li(DF).replace("hr", B0).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", XT).getRegex(), Ifc = Li(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", Iue).getRegex(), FF = {
  blockquote: Ifc,
  code: kfc,
  def: Cfc,
  fences: Sfc,
  heading: Efc,
  hr: B0,
  html: Afc,
  lheading: Aue,
  list: Tfc,
  newline: wfc,
  paragraph: Iue,
  table: Hw,
  text: xfc
}, e7 = Li("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", B0).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", XT).getRegex(), Ofc = {
  ...FF,
  table: e7,
  paragraph: Li(DF).replace("hr", B0).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", e7).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", XT).getRegex()
}, Nfc = {
  ...FF,
  html: Li(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", MF).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: Hw,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: Li(DF).replace("hr", B0).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", Aue).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, Oue = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, zfc = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, Nue = /^( {2,}|\\)\n(?!\s*$)/, Rfc = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, JT = /[\p{P}\p{S}]/u, qF = /[\s\p{P}\p{S}]/u, zue = /[^\s\p{P}\p{S}]/u, Pfc = Li(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, qF).getRegex(), Dfc = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g, Lfc = Li(/^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, "u").replace(/punct/g, JT).getRegex(), Mfc = Li("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, zue).replace(/punctSpace/g, qF).replace(/punct/g, JT).getRegex(), Ffc = Li("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, zue).replace(/punctSpace/g, qF).replace(/punct/g, JT).getRegex(), qfc = Li(/\\(punct)/, "gu").replace(/punct/g, JT).getRegex(), jfc = Li(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), Vfc = Li(MF).replace("(?:-->|$)", "-->").getRegex(), Bfc = Li("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", Vfc).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), cC = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, Ufc = Li(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", cC).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), Rue = Li(/^!?\[(label)\]\[(ref)\]/).replace("label", cC).replace("ref", LF).getRegex(), Pue = Li(/^!?\[(ref)\](?:\[\])?/).replace("ref", LF).getRegex(), Gfc = Li("reflink|nolink(?!\\()", "g").replace("reflink", Rue).replace("nolink", Pue).getRegex(), jF = {
  _backpedal: Hw,
  // only used for GFM url
  anyPunctuation: qfc,
  autolink: jfc,
  blockSkip: Dfc,
  br: Nue,
  code: zfc,
  del: Hw,
  emStrongLDelim: Lfc,
  emStrongRDelimAst: Mfc,
  emStrongRDelimUnd: Ffc,
  escape: Oue,
  link: Ufc,
  nolink: Pue,
  punctuation: Pfc,
  reflink: Rue,
  reflinkSearch: Gfc,
  tag: Bfc,
  text: Rfc,
  url: Hw
}, Wfc = {
  ...jF,
  link: Li(/^!?\[(label)\]\((.*?)\)/).replace("label", cC).getRegex(),
  reflink: Li(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", cC).getRegex()
}, A4 = {
  ...jF,
  escape: Li(Oue).replace("])", "~|])").getRegex(),
  url: Li(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, Hfc = {
  ...A4,
  br: Li(Nue).replace("{2,}", "*").getRegex(),
  text: Li(A4.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, VS = {
  normal: FF,
  gfm: Ofc,
  pedantic: Nfc
}, Q$ = {
  normal: jF,
  gfm: A4,
  breaks: Hfc,
  pedantic: Wfc
}, Yfc = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, t7 = (e) => Yfc[e];
function kp(e, t) {
  if (t) {
    if (vl.escapeTest.test(e))
      return e.replace(vl.escapeReplace, t7);
  } else if (vl.escapeTestNoEncode.test(e))
    return e.replace(vl.escapeReplaceNoEncode, t7);
  return e;
}
function n7(e) {
  try {
    e = encodeURI(e).replace(vl.percentDecode, "%");
  } catch {
    return null;
  }
  return e;
}
function o7(e, t) {
  var i;
  const n = e.replace(vl.findPipe, (a, s, c) => {
    let l = !1, u = s;
    for (; --u >= 0 && c[u] === "\\"; )
      l = !l;
    return l ? "|" : " |";
  }), o = n.split(vl.splitPipe);
  let r = 0;
  if (o[0].trim() || o.shift(), o.length > 0 && !((i = o.at(-1)) != null && i.trim()) && o.pop(), t)
    if (o.length > t)
      o.splice(t);
    else
      for (; o.length < t; )
        o.push("");
  for (; r < o.length; r++)
    o[r] = o[r].trim().replace(vl.slashPipe, "|");
  return o;
}
function ew(e, t, n) {
  const o = e.length;
  if (o === 0)
    return "";
  let r = 0;
  for (; r < o; ) {
    const i = e.charAt(o - r - 1);
    if (i === t && !n)
      r++;
    else if (i !== t && n)
      r++;
    else
      break;
  }
  return e.slice(0, o - r);
}
function Kfc(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  let n = 0;
  for (let o = 0; o < e.length; o++)
    if (e[o] === "\\")
      o++;
    else if (e[o] === t[0])
      n++;
    else if (e[o] === t[1] && (n--, n < 0))
      return o;
  return -1;
}
function r7(e, t, n, o, r) {
  const i = t.href, a = t.title || null, s = e[1].replace(r.other.outputLinkReplace, "$1");
  if (e[0].charAt(0) !== "!") {
    o.state.inLink = !0;
    const c = {
      type: "link",
      raw: n,
      href: i,
      title: a,
      text: s,
      tokens: o.inlineTokens(s)
    };
    return o.state.inLink = !1, c;
  }
  return {
    type: "image",
    raw: n,
    href: i,
    title: a,
    text: s
  };
}
function Zfc(e, t, n) {
  const o = e.match(n.other.indentCodeCompensation);
  if (o === null)
    return t;
  const r = o[1];
  return t.split(`
`).map((i) => {
    const a = i.match(n.other.beginningSpace);
    if (a === null)
      return i;
    const [s] = a;
    return s.length >= r.length ? i.slice(r.length) : i;
  }).join(`
`);
}
class lC {
  // set by the lexer
  constructor(t) {
    vi(this, "options");
    vi(this, "rules");
    // set by the lexer
    vi(this, "lexer");
    this.options = t || Tv;
  }
  space(t) {
    const n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(t) {
    const n = this.rules.block.code.exec(t);
    if (n) {
      const o = n[0].replace(this.rules.other.codeRemoveIndent, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? o : ew(o, `
`)
      };
    }
  }
  fences(t) {
    const n = this.rules.block.fences.exec(t);
    if (n) {
      const o = n[0], r = Zfc(o, n[3] || "", this.rules);
      return {
        type: "code",
        raw: o,
        lang: n[2] ? n[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : n[2],
        text: r
      };
    }
  }
  heading(t) {
    const n = this.rules.block.heading.exec(t);
    if (n) {
      let o = n[2].trim();
      if (this.rules.other.endingHash.test(o)) {
        const r = ew(o, "#");
        (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (o = r.trim());
      }
      return {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: o,
        tokens: this.lexer.inline(o)
      };
    }
  }
  hr(t) {
    const n = this.rules.block.hr.exec(t);
    if (n)
      return {
        type: "hr",
        raw: ew(n[0], `
`)
      };
  }
  blockquote(t) {
    const n = this.rules.block.blockquote.exec(t);
    if (n) {
      let o = ew(n[0], `
`).split(`
`), r = "", i = "";
      const a = [];
      for (; o.length > 0; ) {
        let s = !1;
        const c = [];
        let l;
        for (l = 0; l < o.length; l++)
          if (this.rules.other.blockquoteStart.test(o[l]))
            c.push(o[l]), s = !0;
          else if (!s)
            c.push(o[l]);
          else
            break;
        o = o.slice(l);
        const u = c.join(`
`), d = u.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
        r = r ? `${r}
${u}` : u, i = i ? `${i}
${d}` : d;
        const _ = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(d, a, !0), this.lexer.state.top = _, o.length === 0)
          break;
        const p = a.at(-1);
        if ((p == null ? void 0 : p.type) === "code")
          break;
        if ((p == null ? void 0 : p.type) === "blockquote") {
          const g = p, f = g.raw + `
` + o.join(`
`), h = this.blockquote(f);
          a[a.length - 1] = h, r = r.substring(0, r.length - g.raw.length) + h.raw, i = i.substring(0, i.length - g.text.length) + h.text;
          break;
        } else if ((p == null ? void 0 : p.type) === "list") {
          const g = p, f = g.raw + `
` + o.join(`
`), h = this.list(f);
          a[a.length - 1] = h, r = r.substring(0, r.length - p.raw.length) + h.raw, i = i.substring(0, i.length - g.raw.length) + h.raw, o = f.substring(a.at(-1).raw.length).split(`
`);
          continue;
        }
      }
      return {
        type: "blockquote",
        raw: r,
        tokens: a,
        text: i
      };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let o = n[1].trim();
      const r = o.length > 1, i = {
        type: "list",
        raw: "",
        ordered: r,
        start: r ? +o.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      o = r ? `\\d{1,9}\\${o.slice(-1)}` : `\\${o}`, this.options.pedantic && (o = r ? o : "[*+-]");
      const a = this.rules.other.listItemRegex(o);
      let s = !1;
      for (; t; ) {
        let l = !1, u = "", d = "";
        if (!(n = a.exec(t)) || this.rules.block.hr.test(t))
          break;
        u = n[0], t = t.substring(u.length);
        let _ = n[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (v) => " ".repeat(3 * v.length)), p = t.split(`
`, 1)[0], g = !_.trim(), f = 0;
        if (this.options.pedantic ? (f = 2, d = _.trimStart()) : g ? f = n[1].length + 1 : (f = n[2].search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, d = _.slice(f), f += n[1].length), g && this.rules.other.blankLine.test(p) && (u += p + `
`, t = t.substring(p.length + 1), l = !0), !l) {
          const v = this.rules.other.nextBulletRegex(f), b = this.rules.other.hrRegex(f), y = this.rules.other.fencesBeginRegex(f), w = this.rules.other.headingBeginRegex(f), N = this.rules.other.htmlBeginRegex(f);
          for (; t; ) {
            const M = t.split(`
`, 1)[0];
            let q;
            if (p = M, this.options.pedantic ? (p = p.replace(this.rules.other.listReplaceNesting, "  "), q = p) : q = p.replace(this.rules.other.tabCharGlobal, "    "), y.test(p) || w.test(p) || N.test(p) || v.test(p) || b.test(p))
              break;
            if (q.search(this.rules.other.nonSpaceChar) >= f || !p.trim())
              d += `
` + q.slice(f);
            else {
              if (g || _.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || y.test(_) || w.test(_) || b.test(_))
                break;
              d += `
` + p;
            }
            !g && !p.trim() && (g = !0), u += M + `
`, t = t.substring(M.length + 1), _ = q.slice(f);
          }
        }
        i.loose || (s ? i.loose = !0 : this.rules.other.doubleBlankLine.test(u) && (s = !0));
        let h = null, $;
        this.options.gfm && (h = this.rules.other.listIsTask.exec(d), h && ($ = h[0] !== "[ ] ", d = d.replace(this.rules.other.listReplaceTask, ""))), i.items.push({
          type: "list_item",
          raw: u,
          task: !!h,
          checked: $,
          loose: !1,
          text: d,
          tokens: []
        }), i.raw += u;
      }
      const c = i.items.at(-1);
      c && (c.raw = c.raw.trimEnd(), c.text = c.text.trimEnd()), i.raw = i.raw.trimEnd();
      for (let l = 0; l < i.items.length; l++)
        if (this.lexer.state.top = !1, i.items[l].tokens = this.lexer.blockTokens(i.items[l].text, []), !i.loose) {
          const u = i.items[l].tokens.filter((_) => _.type === "space"), d = u.length > 0 && u.some((_) => this.rules.other.anyLine.test(_.raw));
          i.loose = d;
        }
      if (i.loose)
        for (let l = 0; l < i.items.length; l++)
          i.items[l].loose = !0;
      return i;
    }
  }
  html(t) {
    const n = this.rules.block.html.exec(t);
    if (n)
      return {
        type: "html",
        block: !0,
        raw: n[0],
        pre: n[1] === "pre" || n[1] === "script" || n[1] === "style",
        text: n[0]
      };
  }
  def(t) {
    const n = this.rules.block.def.exec(t);
    if (n) {
      const o = n[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = n[2] ? n[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : n[3];
      return {
        type: "def",
        tag: o,
        raw: n[0],
        href: r,
        title: i
      };
    }
  }
  table(t) {
    var s;
    const n = this.rules.block.table.exec(t);
    if (!n || !this.rules.other.tableDelimiter.test(n[2]))
      return;
    const o = o7(n[1]), r = n[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = (s = n[3]) != null && s.trim() ? n[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], a = {
      type: "table",
      raw: n[0],
      header: [],
      align: [],
      rows: []
    };
    if (o.length === r.length) {
      for (const c of r)
        this.rules.other.tableAlignRight.test(c) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(c) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(c) ? a.align.push("left") : a.align.push(null);
      for (let c = 0; c < o.length; c++)
        a.header.push({
          text: o[c],
          tokens: this.lexer.inline(o[c]),
          header: !0,
          align: a.align[c]
        });
      for (const c of i)
        a.rows.push(o7(c, a.header.length).map((l, u) => ({
          text: l,
          tokens: this.lexer.inline(l),
          header: !1,
          align: a.align[u]
        })));
      return a;
    }
  }
  lheading(t) {
    const n = this.rules.block.lheading.exec(t);
    if (n)
      return {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1])
      };
  }
  paragraph(t) {
    const n = this.rules.block.paragraph.exec(t);
    if (n) {
      const o = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return {
        type: "paragraph",
        raw: n[0],
        text: o,
        tokens: this.lexer.inline(o)
      };
    }
  }
  text(t) {
    const n = this.rules.block.text.exec(t);
    if (n)
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: this.lexer.inline(n[0])
      };
  }
  escape(t) {
    const n = this.rules.inline.escape.exec(t);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: n[1]
      };
  }
  tag(t) {
    const n = this.rules.inline.tag.exec(t);
    if (n)
      return !this.lexer.state.inLink && this.rules.other.startATag.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: n[0]
      };
  }
  link(t) {
    const n = this.rules.inline.link.exec(t);
    if (n) {
      const o = n[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(o)) {
        if (!this.rules.other.endAngleBracket.test(o))
          return;
        const a = ew(o.slice(0, -1), "\\");
        if ((o.length - a.length) % 2 === 0)
          return;
      } else {
        const a = Kfc(n[2], "()");
        if (a > -1) {
          const c = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + a;
          n[2] = n[2].substring(0, a), n[0] = n[0].substring(0, c).trim(), n[3] = "";
        }
      }
      let r = n[2], i = "";
      if (this.options.pedantic) {
        const a = this.rules.other.pedanticHrefTitle.exec(r);
        a && (r = a[1], i = a[3]);
      } else
        i = n[3] ? n[3].slice(1, -1) : "";
      return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(o) ? r = r.slice(1) : r = r.slice(1, -1)), r7(n, {
        href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
        title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
      }, n[0], this.lexer, this.rules);
    }
  }
  reflink(t, n) {
    let o;
    if ((o = this.rules.inline.reflink.exec(t)) || (o = this.rules.inline.nolink.exec(t))) {
      const r = (o[2] || o[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = n[r.toLowerCase()];
      if (!i) {
        const a = o[0].charAt(0);
        return {
          type: "text",
          raw: a,
          text: a
        };
      }
      return r7(o, i, o[0], this.lexer, this.rules);
    }
  }
  emStrong(t, n, o = "") {
    let r = this.rules.inline.emStrongLDelim.exec(t);
    if (!r || r[3] && o.match(this.rules.other.unicodeAlphaNumeric))
      return;
    if (!(r[1] || r[2] || "") || !o || this.rules.inline.punctuation.exec(o)) {
      const a = [...r[0]].length - 1;
      let s, c, l = a, u = 0;
      const d = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (d.lastIndex = 0, n = n.slice(-1 * t.length + a); (r = d.exec(n)) != null; ) {
        if (s = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !s)
          continue;
        if (c = [...s].length, r[3] || r[4]) {
          l += c;
          continue;
        } else if ((r[5] || r[6]) && a % 3 && !((a + c) % 3)) {
          u += c;
          continue;
        }
        if (l -= c, l > 0)
          continue;
        c = Math.min(c, c + l + u);
        const _ = [...r[0]][0].length, p = t.slice(0, a + r.index + _ + c);
        if (Math.min(a, c) % 2) {
          const f = p.slice(1, -1);
          return {
            type: "em",
            raw: p,
            text: f,
            tokens: this.lexer.inlineTokens(f)
          };
        }
        const g = p.slice(2, -2);
        return {
          type: "strong",
          raw: p,
          text: g,
          tokens: this.lexer.inlineTokens(g)
        };
      }
    }
  }
  codespan(t) {
    const n = this.rules.inline.code.exec(t);
    if (n) {
      let o = n[2].replace(this.rules.other.newLineCharGlobal, " ");
      const r = this.rules.other.nonSpaceChar.test(o), i = this.rules.other.startingSpaceChar.test(o) && this.rules.other.endingSpaceChar.test(o);
      return r && i && (o = o.substring(1, o.length - 1)), {
        type: "codespan",
        raw: n[0],
        text: o
      };
    }
  }
  br(t) {
    const n = this.rules.inline.br.exec(t);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(t) {
    const n = this.rules.inline.del.exec(t);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2])
      };
  }
  autolink(t) {
    const n = this.rules.inline.autolink.exec(t);
    if (n) {
      let o, r;
      return n[2] === "@" ? (o = n[1], r = "mailto:" + o) : (o = n[1], r = o), {
        type: "link",
        raw: n[0],
        text: o,
        href: r,
        tokens: [
          {
            type: "text",
            raw: o,
            text: o
          }
        ]
      };
    }
  }
  url(t) {
    var o;
    let n;
    if (n = this.rules.inline.url.exec(t)) {
      let r, i;
      if (n[2] === "@")
        r = n[0], i = "mailto:" + r;
      else {
        let a;
        do
          a = n[0], n[0] = ((o = this.rules.inline._backpedal.exec(n[0])) == null ? void 0 : o[0]) ?? "";
        while (a !== n[0]);
        r = n[0], n[1] === "www." ? i = "http://" + n[0] : i = n[0];
      }
      return {
        type: "link",
        raw: n[0],
        text: r,
        href: i,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  inlineText(t) {
    const n = this.rules.inline.text.exec(t);
    if (n) {
      const o = this.lexer.state.inRawBlock;
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        escaped: o
      };
    }
  }
}
class Od {
  constructor(t) {
    vi(this, "tokens");
    vi(this, "options");
    vi(this, "state");
    vi(this, "tokenizer");
    vi(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || Tv, this.options.tokenizer = this.options.tokenizer || new lC(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      other: vl,
      block: VS.normal,
      inline: Q$.normal
    };
    this.options.pedantic ? (n.block = VS.pedantic, n.inline = Q$.pedantic) : this.options.gfm && (n.block = VS.gfm, this.options.breaks ? n.inline = Q$.breaks : n.inline = Q$.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: VS,
      inline: Q$
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, n) {
    return new Od(n).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, n) {
    return new Od(n).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(vl.carriageReturn, `
`), this.blockTokens(t, this.tokens);
    for (let n = 0; n < this.inlineQueue.length; n++) {
      const o = this.inlineQueue[n];
      this.inlineTokens(o.src, o.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(t, n = [], o = !1) {
    var r, i, a;
    for (this.options.pedantic && (t = t.replace(vl.tabCharGlobal, "    ").replace(vl.spaceLine, "")); t; ) {
      let s;
      if ((i = (r = this.options.extensions) == null ? void 0 : r.block) != null && i.some((l) => (s = l.call({ lexer: this }, t, n)) ? (t = t.substring(s.raw.length), n.push(s), !0) : !1))
        continue;
      if (s = this.tokenizer.space(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        s.raw.length === 1 && l !== void 0 ? l.raw += `
` : n.push(s);
        continue;
      }
      if (s = this.tokenizer.code(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        (l == null ? void 0 : l.type) === "paragraph" || (l == null ? void 0 : l.type) === "text" ? (l.raw += `
` + s.raw, l.text += `
` + s.text, this.inlineQueue.at(-1).src = l.text) : n.push(s);
        continue;
      }
      if (s = this.tokenizer.fences(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.heading(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.hr(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.blockquote(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.list(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.html(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.def(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        (l == null ? void 0 : l.type) === "paragraph" || (l == null ? void 0 : l.type) === "text" ? (l.raw += `
` + s.raw, l.text += `
` + s.raw, this.inlineQueue.at(-1).src = l.text) : this.tokens.links[s.tag] || (this.tokens.links[s.tag] = {
          href: s.href,
          title: s.title
        });
        continue;
      }
      if (s = this.tokenizer.table(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.lheading(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      let c = t;
      if ((a = this.options.extensions) != null && a.startBlock) {
        let l = 1 / 0;
        const u = t.slice(1);
        let d;
        this.options.extensions.startBlock.forEach((_) => {
          d = _.call({ lexer: this }, u), typeof d == "number" && d >= 0 && (l = Math.min(l, d));
        }), l < 1 / 0 && l >= 0 && (c = t.substring(0, l + 1));
      }
      if (this.state.top && (s = this.tokenizer.paragraph(c))) {
        const l = n.at(-1);
        o && (l == null ? void 0 : l.type) === "paragraph" ? (l.raw += `
` + s.raw, l.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = l.text) : n.push(s), o = c.length !== t.length, t = t.substring(s.raw.length);
        continue;
      }
      if (s = this.tokenizer.text(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        (l == null ? void 0 : l.type) === "text" ? (l.raw += `
` + s.raw, l.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = l.text) : n.push(s);
        continue;
      }
      if (t) {
        const l = "Infinite loop on byte: " + t.charCodeAt(0);
        if (this.options.silent) {
          console.error(l);
          break;
        } else
          throw new Error(l);
      }
    }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, n = []) {
    var s, c, l;
    let o = t, r = null;
    if (this.tokens.links) {
      const u = Object.keys(this.tokens.links);
      if (u.length > 0)
        for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          u.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (r = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(o)) != null; )
      o = o.slice(0, r.index) + "++" + o.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    let i = !1, a = "";
    for (; t; ) {
      i || (a = ""), i = !1;
      let u;
      if ((c = (s = this.options.extensions) == null ? void 0 : s.inline) != null && c.some((_) => (u = _.call({ lexer: this }, t, n)) ? (t = t.substring(u.raw.length), n.push(u), !0) : !1))
        continue;
      if (u = this.tokenizer.escape(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.tag(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.link(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.reflink(t, this.tokens.links)) {
        t = t.substring(u.raw.length);
        const _ = n.at(-1);
        u.type === "text" && (_ == null ? void 0 : _.type) === "text" ? (_.raw += u.raw, _.text += u.text) : n.push(u);
        continue;
      }
      if (u = this.tokenizer.emStrong(t, o, a)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.codespan(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.br(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.del(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.autolink(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (!this.state.inLink && (u = this.tokenizer.url(t))) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      let d = t;
      if ((l = this.options.extensions) != null && l.startInline) {
        let _ = 1 / 0;
        const p = t.slice(1);
        let g;
        this.options.extensions.startInline.forEach((f) => {
          g = f.call({ lexer: this }, p), typeof g == "number" && g >= 0 && (_ = Math.min(_, g));
        }), _ < 1 / 0 && _ >= 0 && (d = t.substring(0, _ + 1));
      }
      if (u = this.tokenizer.inlineText(d)) {
        t = t.substring(u.raw.length), u.raw.slice(-1) !== "_" && (a = u.raw.slice(-1)), i = !0;
        const _ = n.at(-1);
        (_ == null ? void 0 : _.type) === "text" ? (_.raw += u.raw, _.text += u.text) : n.push(u);
        continue;
      }
      if (t) {
        const _ = "Infinite loop on byte: " + t.charCodeAt(0);
        if (this.options.silent) {
          console.error(_);
          break;
        } else
          throw new Error(_);
      }
    }
    return n;
  }
}
class uC {
  // set by the parser
  constructor(t) {
    vi(this, "options");
    vi(this, "parser");
    this.options = t || Tv;
  }
  space(t) {
    return "";
  }
  code({ text: t, lang: n, escaped: o }) {
    var a;
    const r = (a = (n || "").match(vl.notSpaceStart)) == null ? void 0 : a[0], i = t.replace(vl.endingNewline, "") + `
`;
    return r ? '<pre><code class="language-' + kp(r) + '">' + (o ? i : kp(i, !0)) + `</code></pre>
` : "<pre><code>" + (o ? i : kp(i, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: t }) {
    return `<blockquote>
${this.parser.parse(t)}</blockquote>
`;
  }
  html({ text: t }) {
    return t;
  }
  heading({ tokens: t, depth: n }) {
    return `<h${n}>${this.parser.parseInline(t)}</h${n}>
`;
  }
  hr(t) {
    return `<hr>
`;
  }
  list(t) {
    const n = t.ordered, o = t.start;
    let r = "";
    for (let s = 0; s < t.items.length; s++) {
      const c = t.items[s];
      r += this.listitem(c);
    }
    const i = n ? "ol" : "ul", a = n && o !== 1 ? ' start="' + o + '"' : "";
    return "<" + i + a + `>
` + r + "</" + i + `>
`;
  }
  listitem(t) {
    var o;
    let n = "";
    if (t.task) {
      const r = this.checkbox({ checked: !!t.checked });
      t.loose ? ((o = t.tokens[0]) == null ? void 0 : o.type) === "paragraph" ? (t.tokens[0].text = r + " " + t.tokens[0].text, t.tokens[0].tokens && t.tokens[0].tokens.length > 0 && t.tokens[0].tokens[0].type === "text" && (t.tokens[0].tokens[0].text = r + " " + kp(t.tokens[0].tokens[0].text), t.tokens[0].tokens[0].escaped = !0)) : t.tokens.unshift({
        type: "text",
        raw: r + " ",
        text: r + " ",
        escaped: !0
      }) : n += r + " ";
    }
    return n += this.parser.parse(t.tokens, !!t.loose), `<li>${n}</li>
`;
  }
  checkbox({ checked: t }) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: t }) {
    return `<p>${this.parser.parseInline(t)}</p>
`;
  }
  table(t) {
    let n = "", o = "";
    for (let i = 0; i < t.header.length; i++)
      o += this.tablecell(t.header[i]);
    n += this.tablerow({ text: o });
    let r = "";
    for (let i = 0; i < t.rows.length; i++) {
      const a = t.rows[i];
      o = "";
      for (let s = 0; s < a.length; s++)
        o += this.tablecell(a[s]);
      r += this.tablerow({ text: o });
    }
    return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + n + `</thead>
` + r + `</table>
`;
  }
  tablerow({ text: t }) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t) {
    const n = this.parser.parseInline(t.tokens), o = t.header ? "th" : "td";
    return (t.align ? `<${o} align="${t.align}">` : `<${o}>`) + n + `</${o}>
`;
  }
  /**
   * span level renderer
   */
  strong({ tokens: t }) {
    return `<strong>${this.parser.parseInline(t)}</strong>`;
  }
  em({ tokens: t }) {
    return `<em>${this.parser.parseInline(t)}</em>`;
  }
  codespan({ text: t }) {
    return `<code>${kp(t, !0)}</code>`;
  }
  br(t) {
    return "<br>";
  }
  del({ tokens: t }) {
    return `<del>${this.parser.parseInline(t)}</del>`;
  }
  link({ href: t, title: n, tokens: o }) {
    const r = this.parser.parseInline(o), i = n7(t);
    if (i === null)
      return r;
    t = i;
    let a = '<a href="' + t + '"';
    return n && (a += ' title="' + kp(n) + '"'), a += ">" + r + "</a>", a;
  }
  image({ href: t, title: n, text: o }) {
    const r = n7(t);
    if (r === null)
      return kp(o);
    t = r;
    let i = `<img src="${t}" alt="${o}"`;
    return n && (i += ` title="${kp(n)}"`), i += ">", i;
  }
  text(t) {
    return "tokens" in t && t.tokens ? this.parser.parseInline(t.tokens) : "escaped" in t && t.escaped ? t.text : kp(t.text);
  }
}
class VF {
  // no need for block level renderers
  strong({ text: t }) {
    return t;
  }
  em({ text: t }) {
    return t;
  }
  codespan({ text: t }) {
    return t;
  }
  del({ text: t }) {
    return t;
  }
  html({ text: t }) {
    return t;
  }
  text({ text: t }) {
    return t;
  }
  link({ text: t }) {
    return "" + t;
  }
  image({ text: t }) {
    return "" + t;
  }
  br() {
    return "";
  }
}
class Nd {
  constructor(t) {
    vi(this, "options");
    vi(this, "renderer");
    vi(this, "textRenderer");
    this.options = t || Tv, this.options.renderer = this.options.renderer || new uC(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new VF();
  }
  /**
   * Static Parse Method
   */
  static parse(t, n) {
    return new Nd(n).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, n) {
    return new Nd(n).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, n = !0) {
    var r, i;
    let o = "";
    for (let a = 0; a < t.length; a++) {
      const s = t[a];
      if ((i = (r = this.options.extensions) == null ? void 0 : r.renderers) != null && i[s.type]) {
        const l = s, u = this.options.extensions.renderers[l.type].call({ parser: this }, l);
        if (u !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(l.type)) {
          o += u || "";
          continue;
        }
      }
      const c = s;
      switch (c.type) {
        case "space": {
          o += this.renderer.space(c);
          continue;
        }
        case "hr": {
          o += this.renderer.hr(c);
          continue;
        }
        case "heading": {
          o += this.renderer.heading(c);
          continue;
        }
        case "code": {
          o += this.renderer.code(c);
          continue;
        }
        case "table": {
          o += this.renderer.table(c);
          continue;
        }
        case "blockquote": {
          o += this.renderer.blockquote(c);
          continue;
        }
        case "list": {
          o += this.renderer.list(c);
          continue;
        }
        case "html": {
          o += this.renderer.html(c);
          continue;
        }
        case "paragraph": {
          o += this.renderer.paragraph(c);
          continue;
        }
        case "text": {
          let l = c, u = this.renderer.text(l);
          for (; a + 1 < t.length && t[a + 1].type === "text"; )
            l = t[++a], u += `
` + this.renderer.text(l);
          n ? o += this.renderer.paragraph({
            type: "paragraph",
            raw: u,
            text: u,
            tokens: [{ type: "text", raw: u, text: u, escaped: !0 }]
          }) : o += u;
          continue;
        }
        default: {
          const l = 'Token with "' + c.type + '" type was not found.';
          if (this.options.silent)
            return console.error(l), "";
          throw new Error(l);
        }
      }
    }
    return o;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, n = this.renderer) {
    var r, i;
    let o = "";
    for (let a = 0; a < t.length; a++) {
      const s = t[a];
      if ((i = (r = this.options.extensions) == null ? void 0 : r.renderers) != null && i[s.type]) {
        const l = this.options.extensions.renderers[s.type].call({ parser: this }, s);
        if (l !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(s.type)) {
          o += l || "";
          continue;
        }
      }
      const c = s;
      switch (c.type) {
        case "escape": {
          o += n.text(c);
          break;
        }
        case "html": {
          o += n.html(c);
          break;
        }
        case "link": {
          o += n.link(c);
          break;
        }
        case "image": {
          o += n.image(c);
          break;
        }
        case "strong": {
          o += n.strong(c);
          break;
        }
        case "em": {
          o += n.em(c);
          break;
        }
        case "codespan": {
          o += n.codespan(c);
          break;
        }
        case "br": {
          o += n.br(c);
          break;
        }
        case "del": {
          o += n.del(c);
          break;
        }
        case "text": {
          o += n.text(c);
          break;
        }
        default: {
          const l = 'Token with "' + c.type + '" type was not found.';
          if (this.options.silent)
            return console.error(l), "";
          throw new Error(l);
        }
      }
    }
    return o;
  }
}
class Yw {
  constructor(t) {
    vi(this, "options");
    vi(this, "block");
    this.options = t || Tv;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(t) {
    return t;
  }
  /**
   * Provide function to tokenize markdown
   */
  provideLexer() {
    return this.block ? Od.lex : Od.lexInline;
  }
  /**
   * Provide function to parse tokens
   */
  provideParser() {
    return this.block ? Nd.parse : Nd.parseInline;
  }
}
vi(Yw, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
]));
class Xfc {
  constructor(...t) {
    vi(this, "defaults", PF());
    vi(this, "options", this.setOptions);
    vi(this, "parse", this.parseMarkdown(!0));
    vi(this, "parseInline", this.parseMarkdown(!1));
    vi(this, "Parser", Nd);
    vi(this, "Renderer", uC);
    vi(this, "TextRenderer", VF);
    vi(this, "Lexer", Od);
    vi(this, "Tokenizer", lC);
    vi(this, "Hooks", Yw);
    this.use(...t);
  }
  /**
   * Run callback for every token
   */
  walkTokens(t, n) {
    var r, i;
    let o = [];
    for (const a of t)
      switch (o = o.concat(n.call(this, a)), a.type) {
        case "table": {
          const s = a;
          for (const c of s.header)
            o = o.concat(this.walkTokens(c.tokens, n));
          for (const c of s.rows)
            for (const l of c)
              o = o.concat(this.walkTokens(l.tokens, n));
          break;
        }
        case "list": {
          const s = a;
          o = o.concat(this.walkTokens(s.items, n));
          break;
        }
        default: {
          const s = a;
          (i = (r = this.defaults.extensions) == null ? void 0 : r.childTokens) != null && i[s.type] ? this.defaults.extensions.childTokens[s.type].forEach((c) => {
            const l = s[c].flat(1 / 0);
            o = o.concat(this.walkTokens(l, n));
          }) : s.tokens && (o = o.concat(this.walkTokens(s.tokens, n)));
        }
      }
    return o;
  }
  use(...t) {
    const n = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((o) => {
      const r = { ...o };
      if (r.async = this.defaults.async || r.async || !1, o.extensions && (o.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if ("renderer" in i) {
          const a = n.renderers[i.name];
          a ? n.renderers[i.name] = function(...s) {
            let c = i.renderer.apply(this, s);
            return c === !1 && (c = a.apply(this, s)), c;
          } : n.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const a = n[i.level];
          a ? a.unshift(i.tokenizer) : n[i.level] = [i.tokenizer], i.start && (i.level === "block" ? n.startBlock ? n.startBlock.push(i.start) : n.startBlock = [i.start] : i.level === "inline" && (n.startInline ? n.startInline.push(i.start) : n.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (n.childTokens[i.name] = i.childTokens);
      }), r.extensions = n), o.renderer) {
        const i = this.defaults.renderer || new uC(this.defaults);
        for (const a in o.renderer) {
          if (!(a in i))
            throw new Error(`renderer '${a}' does not exist`);
          if (["options", "parser"].includes(a))
            continue;
          const s = a, c = o.renderer[s], l = i[s];
          i[s] = (...u) => {
            let d = c.apply(i, u);
            return d === !1 && (d = l.apply(i, u)), d || "";
          };
        }
        r.renderer = i;
      }
      if (o.tokenizer) {
        const i = this.defaults.tokenizer || new lC(this.defaults);
        for (const a in o.tokenizer) {
          if (!(a in i))
            throw new Error(`tokenizer '${a}' does not exist`);
          if (["options", "rules", "lexer"].includes(a))
            continue;
          const s = a, c = o.tokenizer[s], l = i[s];
          i[s] = (...u) => {
            let d = c.apply(i, u);
            return d === !1 && (d = l.apply(i, u)), d;
          };
        }
        r.tokenizer = i;
      }
      if (o.hooks) {
        const i = this.defaults.hooks || new Yw();
        for (const a in o.hooks) {
          if (!(a in i))
            throw new Error(`hook '${a}' does not exist`);
          if (["options", "block"].includes(a))
            continue;
          const s = a, c = o.hooks[s], l = i[s];
          Yw.passThroughHooks.has(a) ? i[s] = (u) => {
            if (this.defaults.async)
              return Promise.resolve(c.call(i, u)).then((_) => l.call(i, _));
            const d = c.call(i, u);
            return l.call(i, d);
          } : i[s] = (...u) => {
            let d = c.apply(i, u);
            return d === !1 && (d = l.apply(i, u)), d;
          };
        }
        r.hooks = i;
      }
      if (o.walkTokens) {
        const i = this.defaults.walkTokens, a = o.walkTokens;
        r.walkTokens = function(s) {
          let c = [];
          return c.push(a.call(this, s)), i && (c = c.concat(i.call(this, s))), c;
        };
      }
      this.defaults = { ...this.defaults, ...r };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
  lexer(t, n) {
    return Od.lex(t, n ?? this.defaults);
  }
  parser(t, n) {
    return Nd.parse(t, n ?? this.defaults);
  }
  parseMarkdown(t) {
    return (o, r) => {
      const i = { ...r }, a = { ...this.defaults, ...i }, s = this.onError(!!a.silent, !!a.async);
      if (this.defaults.async === !0 && i.async === !1)
        return s(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      if (typeof o > "u" || o === null)
        return s(new Error("marked(): input parameter is undefined or null"));
      if (typeof o != "string")
        return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(o) + ", string expected"));
      a.hooks && (a.hooks.options = a, a.hooks.block = t);
      const c = a.hooks ? a.hooks.provideLexer() : t ? Od.lex : Od.lexInline, l = a.hooks ? a.hooks.provideParser() : t ? Nd.parse : Nd.parseInline;
      if (a.async)
        return Promise.resolve(a.hooks ? a.hooks.preprocess(o) : o).then((u) => c(u, a)).then((u) => a.hooks ? a.hooks.processAllTokens(u) : u).then((u) => a.walkTokens ? Promise.all(this.walkTokens(u, a.walkTokens)).then(() => u) : u).then((u) => l(u, a)).then((u) => a.hooks ? a.hooks.postprocess(u) : u).catch(s);
      try {
        a.hooks && (o = a.hooks.preprocess(o));
        let u = c(o, a);
        a.hooks && (u = a.hooks.processAllTokens(u)), a.walkTokens && this.walkTokens(u, a.walkTokens);
        let d = l(u, a);
        return a.hooks && (d = a.hooks.postprocess(d)), d;
      } catch (u) {
        return s(u);
      }
    };
  }
  onError(t, n) {
    return (o) => {
      if (o.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
        const r = "<p>An error occurred:</p><pre>" + kp(o.message + "", !0) + "</pre>";
        return n ? Promise.resolve(r) : r;
      }
      if (n)
        return Promise.reject(o);
      throw o;
    };
  }
}
const gv = new Xfc();
function pi(e, t) {
  return gv.parse(e, t);
}
pi.options = pi.setOptions = function(e) {
  return gv.setOptions(e), pi.defaults = gv.defaults, Cue(pi.defaults), pi;
};
pi.getDefaults = PF;
pi.defaults = Tv;
pi.use = function(...e) {
  return gv.use(...e), pi.defaults = gv.defaults, Cue(pi.defaults), pi;
};
pi.walkTokens = function(e, t) {
  return gv.walkTokens(e, t);
};
pi.parseInline = gv.parseInline;
pi.Parser = Nd;
pi.parser = Nd.parse;
pi.Renderer = uC;
pi.TextRenderer = VF;
pi.Lexer = Od;
pi.lexer = Od.lex;
pi.Tokenizer = lC;
pi.Hooks = Yw;
pi.parse = pi;
pi.options;
pi.setOptions;
pi.use;
pi.walkTokens;
pi.parseInline;
Nd.parse;
Od.lex;
function QT(e) {
  if (!e)
    return "";
  pi.use({ async: !1 });
  const t = pi.parse(e);
  return xue.sanitize(t);
}
const Due = Fe.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  yue,
  {
    ref: n,
    className: xe(
      "border-default data-[state=checked]:bg-brand-default data-[state=checked]:text-brand peer h-4 w-4 shrink-0 rounded-[4px] border ring-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed",
      e
    ),
    ...t,
    children: /* @__PURE__ */ m(nfc, { className: xe("flex items-center justify-center text-current"), children: /* @__PURE__ */ m(qt, { name: "check", className: "h-4 w-4" }) })
  }
));
Due.displayName = yue.displayName;
const cc = Bt(
  ({ label: e, description: t, error: n, disabled: o, descriptionAsSafeHtml: r, ...i }, a) => {
    const s = !e || i.descriptionAsLabel, c = Pu();
    return /* @__PURE__ */ de("div", { className: "block items-center sm:flex", children: [
      e && /* @__PURE__ */ m("div", { className: "min-w-48 mb-4 sm:mb-0", children: Fe.createElement(
        s ? "div" : "label",
        {
          className: xe("flex text-sm font-medium text-emphasis"),
          ...s ? {} : {
            htmlFor: i.id ? i.id : c
          }
        },
        e
      ) }),
      /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m("div", { className: "hover:bg-subtle relative flex w-fit items-center rounded-md p-1", children: Fe.createElement(
        s ? "label" : "div",
        {
          className: xe(
            "relative flex items-start",
            "text-emphasis",
            n && "text-error"
          )
        },
        /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ m("div", { className: "flex h-5 items-center", children: /* @__PURE__ */ m(
            "input",
            {
              ...i,
              ref: a,
              type: "checkbox",
              disabled: o,
              id: i.id ? i.id : c,
              className: xe(
                "text-emphasis focus:ring-emphasis dark:text-muted border-default bg-default focus:bg-default active:bg-default h-4 w-4 rounded transition checked:hover:bg-gray-600 focus:outline-none focus:ring-0 ltr:mr-2 rtl:ml-2",
                !n && o ? "cursor-not-allowed bg-gray-300 checked:bg-gray-300 hover:bg-gray-300 hover:checked:bg-gray-300" : "hover:bg-subtle hover:border-emphasis checked:bg-gray-800",
                n && "border-error hover:bg-error hover:border-error checked:bg-darkerror checked:hover:border-error checked:hover:bg-darkerror",
                i.className
              )
            }
          ) }),
          r ? /* @__PURE__ */ m(
            "span",
            {
              className: xe(
                "text-default ml-2 text-sm",
                !e && "font-medium",
                i.descriptionClassName
              ),
              dangerouslySetInnerHTML: {
                __html: QT(r)
              }
            }
          ) : /* @__PURE__ */ m(
            "span",
            {
              className: xe(
                "text-default ml-2 text-sm",
                !e && "font-medium",
                i.descriptionClassName
              ),
              children: t
            }
          )
        ] })
      ) }) })
    ] });
  }
);
cc.displayName = "CheckboxField";
function Tw(e, t, n) {
  return t = Sae(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function i7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Fo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? i7(Object(n), !0).forEach(function(o) {
      Tw(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i7(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Jfc(e) {
  if (Array.isArray(e))
    return e;
}
function Qfc(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, r, i, a, s = [], c = !0, l = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (o = i.call(n)).done) && (s.push(o.value), s.length !== t); c = !0)
          ;
    } catch (u) {
      l = !0, r = u;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (l)
          throw r;
      }
    }
    return s;
  }
}
function I4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Lue(e, t) {
  if (e) {
    if (typeof e == "string")
      return I4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return I4(e, t);
  }
}
function egc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _f(e, t) {
  return Jfc(e) || Qfc(e, t) || Lue(e, t) || egc();
}
var tgc = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function ngc(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, o = e.defaultMenuIsOpen, r = o === void 0 ? !1 : o, i = e.defaultValue, a = i === void 0 ? null : i, s = e.inputValue, c = e.menuIsOpen, l = e.onChange, u = e.onInputChange, d = e.onMenuClose, _ = e.onMenuOpen, p = e.value, g = xv(e, tgc), f = it(s !== void 0 ? s : n), h = _f(f, 2), $ = h[0], v = h[1], b = it(c !== void 0 ? c : r), y = _f(b, 2), w = y[0], N = y[1], M = it(p !== void 0 ? p : a), q = _f(M, 2), L = q[0], R = q[1], T = Yt(function(I, z) {
    typeof l == "function" && l(I, z), R(I);
  }, [l]), D = Yt(function(I, z) {
    var F;
    typeof u == "function" && (F = u(I, z)), v(F !== void 0 ? F : I);
  }, [u]), A = Yt(function() {
    typeof _ == "function" && _(), N(!0);
  }, [_]), S = Yt(function() {
    typeof d == "function" && d(), N(!1);
  }, [d]), E = s !== void 0 ? s : $, x = c !== void 0 ? c : w, k = p !== void 0 ? p : L;
  return Fo(Fo({}, g), {}, {
    inputValue: E,
    menuIsOpen: x,
    onChange: T,
    onInputChange: D,
    onMenuClose: S,
    onMenuOpen: A,
    value: k
  });
}
function O4(e, t) {
  return O4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, r) {
    return o.__proto__ = r, o;
  }, O4(e, t);
}
function Mue(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && O4(e, t);
}
const ogc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mue
}, Symbol.toStringTag, { value: "Module" }));
function dC(e) {
  return dC = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, dC(e);
}
function rgc() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function igc(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function agc(e, t) {
  if (t && (cv(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return igc(e);
}
function sgc(e) {
  var t = rgc();
  return function() {
    var o = dC(e), r;
    if (t) {
      var i = dC(this).constructor;
      r = Reflect.construct(o, arguments, i);
    } else
      r = o.apply(this, arguments);
    return agc(this, r);
  };
}
function cgc(e) {
  if (Array.isArray(e))
    return I4(e);
}
function lgc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ugc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BF(e) {
  return cgc(e) || lgc(e) || Lue(e) || ugc();
}
const dgc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: BF
}, Symbol.toStringTag, { value: "Module" }));
function _gc(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function pgc(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var mgc = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, i), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(pgc(this));
    var r = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var a = _gc(r);
      try {
        a.insertRule(o, a.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(o) && console.error('There was a problem inserting the following rule: "' + o + '"', s);
      }
    } else
      r.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Oc = "-ms-", _C = "-moz-", ei = "-webkit-", UF = "comm", GF = "rule", WF = "decl", fgc = "@import", Fue = "@keyframes", ggc = Math.abs, eA = String.fromCharCode, hgc = Object.assign;
function vgc(e, t) {
  return (((t << 2 ^ Wl(e, 0)) << 2 ^ Wl(e, 1)) << 2 ^ Wl(e, 2)) << 2 ^ Wl(e, 3);
}
function que(e) {
  return e.trim();
}
function bgc(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function di(e, t, n) {
  return e.replace(t, n);
}
function N4(e, t) {
  return e.indexOf(t);
}
function Wl(e, t) {
  return e.charCodeAt(t) | 0;
}
function qk(e, t, n) {
  return e.slice(t, n);
}
function Op(e) {
  return e.length;
}
function HF(e) {
  return e.length;
}
function BS(e, t) {
  return t.push(e), e;
}
function ygc(e, t) {
  return e.map(t).join("");
}
var tA = 1, Ty = 1, jue = 0, tu = 0, os = 0, Yy = "";
function nA(e, t, n, o, r, i, a) {
  return { value: e, root: t, parent: n, type: o, props: r, children: i, line: tA, column: Ty, length: a, return: "" };
}
function tw(e, t) {
  return hgc(nA("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function $gc() {
  return os;
}
function wgc() {
  return os = tu > 0 ? Wl(Yy, --tu) : 0, Ty--, os === 10 && (Ty = 1, tA--), os;
}
function Mu() {
  return os = tu < jue ? Wl(Yy, tu++) : 0, Ty++, os === 10 && (Ty = 1, tA++), os;
}
function Yp() {
  return Wl(Yy, tu);
}
function sx() {
  return tu;
}
function U0(e, t) {
  return qk(Yy, e, t);
}
function jk(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Vue(e) {
  return tA = Ty = 1, jue = Op(Yy = e), tu = 0, [];
}
function Bue(e) {
  return Yy = "", e;
}
function cx(e) {
  return que(U0(tu - 1, z4(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function kgc(e) {
  for (; (os = Yp()) && os < 33; )
    Mu();
  return jk(e) > 2 || jk(os) > 3 ? "" : " ";
}
function Sgc(e, t) {
  for (; --t && Mu() && !(os < 48 || os > 102 || os > 57 && os < 65 || os > 70 && os < 97); )
    ;
  return U0(e, sx() + (t < 6 && Yp() == 32 && Mu() == 32));
}
function z4(e) {
  for (; Mu(); )
    switch (os) {
      case e:
        return tu;
      case 34:
      case 39:
        e !== 34 && e !== 39 && z4(os);
        break;
      case 40:
        e === 41 && z4(e);
        break;
      case 92:
        Mu();
        break;
    }
  return tu;
}
function Egc(e, t) {
  for (; Mu() && e + os !== 57; )
    if (e + os === 84 && Yp() === 47)
      break;
  return "/*" + U0(t, tu - 1) + "*" + eA(e === 47 ? e : Mu());
}
function xgc(e) {
  for (; !jk(Yp()); )
    Mu();
  return U0(e, tu);
}
function Cgc(e) {
  return Bue(lx("", null, null, null, [""], e = Vue(e), 0, [0], e));
}
function lx(e, t, n, o, r, i, a, s, c) {
  for (var l = 0, u = 0, d = a, _ = 0, p = 0, g = 0, f = 1, h = 1, $ = 1, v = 0, b = "", y = r, w = i, N = o, M = b; h; )
    switch (g = v, v = Mu()) {
      case 40:
        if (g != 108 && M.charCodeAt(d - 1) == 58) {
          N4(M += di(cx(v), "&", "&\f"), "&\f") != -1 && ($ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        M += cx(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        M += kgc(g);
        break;
      case 92:
        M += Sgc(sx() - 1, 7);
        continue;
      case 47:
        switch (Yp()) {
          case 42:
          case 47:
            BS(Tgc(Egc(Mu(), sx()), t, n), c);
            break;
          default:
            M += "/";
        }
        break;
      case 123 * f:
        s[l++] = Op(M) * $;
      case 125 * f:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            h = 0;
          case 59 + u:
            p > 0 && Op(M) - d && BS(p > 32 ? s7(M + ";", o, n, d - 1) : s7(di(M, " ", "") + ";", o, n, d - 2), c);
            break;
          case 59:
            M += ";";
          default:
            if (BS(N = a7(M, t, n, l, u, r, s, b, y = [], w = [], d), i), v === 123)
              if (u === 0)
                lx(M, t, N, N, y, i, d, s, w);
              else
                switch (_) {
                  case 100:
                  case 109:
                  case 115:
                    lx(e, N, N, o && BS(a7(e, N, N, 0, 0, r, s, b, r, y = [], d), w), r, w, d, s, o ? y : w);
                    break;
                  default:
                    lx(M, N, N, N, [""], w, 0, s, w);
                }
        }
        l = u = p = 0, f = $ = 1, b = M = "", d = a;
        break;
      case 58:
        d = 1 + Op(M), p = g;
      default:
        if (f < 1) {
          if (v == 123)
            --f;
          else if (v == 125 && f++ == 0 && wgc() == 125)
            continue;
        }
        switch (M += eA(v), v * f) {
          case 38:
            $ = u > 0 ? 1 : (M += "\f", -1);
            break;
          case 44:
            s[l++] = (Op(M) - 1) * $, $ = 1;
            break;
          case 64:
            Yp() === 45 && (M += cx(Mu())), _ = Yp(), u = d = Op(b = M += xgc(sx())), v++;
            break;
          case 45:
            g === 45 && Op(M) == 2 && (f = 0);
        }
    }
  return i;
}
function a7(e, t, n, o, r, i, a, s, c, l, u) {
  for (var d = r - 1, _ = r === 0 ? i : [""], p = HF(_), g = 0, f = 0, h = 0; g < o; ++g)
    for (var $ = 0, v = qk(e, d + 1, d = ggc(f = a[g])), b = e; $ < p; ++$)
      (b = que(f > 0 ? _[$] + " " + v : di(v, /&\f/g, _[$]))) && (c[h++] = b);
  return nA(e, t, n, r === 0 ? GF : s, c, l, u);
}
function Tgc(e, t, n) {
  return nA(e, t, n, UF, eA($gc()), qk(e, 2, -2), 0);
}
function s7(e, t, n, o) {
  return nA(e, t, n, WF, qk(e, 0, o), qk(e, o + 1, -1), o);
}
function Uue(e, t) {
  switch (vgc(e, t)) {
    case 5103:
      return ei + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ei + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ei + e + _C + e + Oc + e + e;
    case 6828:
    case 4268:
      return ei + e + Oc + e + e;
    case 6165:
      return ei + e + Oc + "flex-" + e + e;
    case 5187:
      return ei + e + di(e, /(\w+).+(:[^]+)/, ei + "box-$1$2" + Oc + "flex-$1$2") + e;
    case 5443:
      return ei + e + Oc + "flex-item-" + di(e, /flex-|-self/, "") + e;
    case 4675:
      return ei + e + Oc + "flex-line-pack" + di(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return ei + e + Oc + di(e, "shrink", "negative") + e;
    case 5292:
      return ei + e + Oc + di(e, "basis", "preferred-size") + e;
    case 6060:
      return ei + "box-" + di(e, "-grow", "") + ei + e + Oc + di(e, "grow", "positive") + e;
    case 4554:
      return ei + di(e, /([^-])(transform)/g, "$1" + ei + "$2") + e;
    case 6187:
      return di(di(di(e, /(zoom-|grab)/, ei + "$1"), /(image-set)/, ei + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return di(e, /(image-set\([^]*)/, ei + "$1$`$1");
    case 4968:
      return di(di(e, /(.+:)(flex-)?(.*)/, ei + "box-pack:$3" + Oc + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ei + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return di(e, /(.+)-inline(.+)/, ei + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Op(e) - 1 - t > 6)
        switch (Wl(e, t + 1)) {
          case 109:
            if (Wl(e, t + 4) !== 45)
              break;
          case 102:
            return di(e, /(.+:)(.+)-([^]+)/, "$1" + ei + "$2-$3$1" + _C + (Wl(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~N4(e, "stretch") ? Uue(di(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Wl(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Wl(e, Op(e) - 3 - (~N4(e, "!important") && 10))) {
        case 107:
          return di(e, ":", ":" + ei) + e;
        case 101:
          return di(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ei + (Wl(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ei + "$2$3$1" + Oc + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Wl(e, t + 11)) {
        case 114:
          return ei + e + Oc + di(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ei + e + Oc + di(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ei + e + Oc + di(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return ei + e + Oc + e + e;
  }
  return e;
}
function Wb(e, t) {
  for (var n = "", o = HF(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function Agc(e, t, n, o) {
  switch (e.type) {
    case fgc:
    case WF:
      return e.return = e.return || e.value;
    case UF:
      return "";
    case Fue:
      return e.return = e.value + "{" + Wb(e.children, o) + "}";
    case GF:
      e.value = e.props.join(",");
  }
  return Op(n = Wb(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function Igc(e) {
  var t = HF(e);
  return function(n, o, r, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, o, r, i) || "";
    return a;
  };
}
function Ogc(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Ngc(e, t, n, o) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case WF:
        e.return = Uue(e.value, e.length);
        break;
      case Fue:
        return Wb([tw(e, { value: di(e.value, "@", "@" + ei) })], o);
      case GF:
        if (e.length)
          return ygc(e.props, function(r) {
            switch (bgc(r, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Wb([tw(e, { props: [di(r, /:(read-\w+)/, ":" + _C + "$1")] })], o);
              case "::placeholder":
                return Wb([
                  tw(e, { props: [di(r, /:(plac\w+)/, ":" + ei + "input-$1")] }),
                  tw(e, { props: [di(r, /:(plac\w+)/, ":" + _C + "$1")] }),
                  tw(e, { props: [di(r, /:(plac\w+)/, Oc + "input-$1")] })
                ], o);
            }
            return "";
          });
    }
}
function zgc(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Rgc = function(t) {
  return t.length ? t[t.length - 1] : null;
}, Pgc = function(t, n, o) {
  for (var r = 0, i = 0; r = i, i = Yp(), r === 38 && i === 12 && (n[o] = 1), !jk(i); )
    Mu();
  return U0(t, tu);
}, Dgc = function(t, n) {
  var o = -1, r = 44;
  do
    switch (jk(r)) {
      case 0:
        r === 38 && Yp() === 12 && (n[o] = 1), t[o] += Pgc(tu - 1, n, o);
        break;
      case 2:
        t[o] += cx(r);
        break;
      case 4:
        if (r === 44) {
          t[++o] = Yp() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      default:
        t[o] += eA(r);
    }
  while (r = Mu());
  return t;
}, Lgc = function(t, n) {
  return Bue(Dgc(Vue(t), n));
}, c7 = /* @__PURE__ */ new WeakMap(), Mgc = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, r = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !c7.get(o)) && !r) {
      c7.set(t, !0);
      for (var i = [], a = Lgc(n, i), s = o.props, c = 0, l = 0; c < a.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = i[c] ? a[c].replace(/&\f/g, s[u]) : s[u] + " " + a[c];
    }
  }
}, Fgc = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, qgc = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", jgc = function(t) {
  return !!t && t.type === "comm" && t.children.indexOf(qgc) > -1;
}, Vgc = function(t) {
  return function(n, o, r) {
    if (n.type === "rule") {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i && t.compat !== !0) {
        var a = o > 0 ? r[o - 1] : null;
        if (a && jgc(Rgc(a.children)))
          return;
        i.forEach(function(s) {
          console.error('The pseudo class "' + s + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + s.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Gue = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, Bgc = function(t, n) {
  for (var o = t - 1; o >= 0; o--)
    if (!Gue(n[o]))
      return !0;
  return !1;
}, l7 = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, Ugc = function(t, n, o) {
  Gue(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), l7(t)) : Bgc(n, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), l7(t)));
}, Ggc = [Ngc], Wgc = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(f) {
      var h = f.getAttribute("data-emotion");
      h.indexOf(" ") !== -1 && (document.head.appendChild(f), f.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || Ggc;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, a, s = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(f) {
      for (var h = f.getAttribute("data-emotion").split(" "), $ = 1; $ < h.length; $++)
        i[h[$]] = !0;
      s.push(f);
    }
  );
  var c, l = [Mgc, Fgc];
  process.env.NODE_ENV !== "production" && l.push(Vgc({
    get compat() {
      return g.compat;
    }
  }), Ugc);
  {
    var u, d = [Agc, process.env.NODE_ENV !== "production" ? function(f) {
      f.root || (f.return ? u.insert(f.return) : f.value && f.type !== UF && u.insert(f.value + "{}"));
    } : Ogc(function(f) {
      u.insert(f);
    })], _ = Igc(l.concat(r, d)), p = function(h) {
      return Wb(Cgc(h), _);
    };
    c = function(h, $, v, b) {
      u = v, process.env.NODE_ENV !== "production" && $.map !== void 0 && (u = {
        insert: function(w) {
          v.insert(w + $.map);
        }
      }), p(h ? h + "{" + $.styles + "}" : $.styles), b && (g.inserted[$.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new mgc({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return g.sheet.hydrate(s), g;
}, R4 = { exports: {} }, ai = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u7;
function Hgc() {
  return u7 || (u7 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function b(_e) {
      return typeof _e == "string" || typeof _e == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _e === o || _e === l || _e === i || _e === r || _e === d || _e === _ || typeof _e == "object" && _e !== null && (_e.$$typeof === g || _e.$$typeof === p || _e.$$typeof === a || _e.$$typeof === s || _e.$$typeof === u || _e.$$typeof === h || _e.$$typeof === $ || _e.$$typeof === v || _e.$$typeof === f);
    }
    function y(_e) {
      if (typeof _e == "object" && _e !== null) {
        var he = _e.$$typeof;
        switch (he) {
          case t:
            var be = _e.type;
            switch (be) {
              case c:
              case l:
              case o:
              case i:
              case r:
              case d:
                return be;
              default:
                var Q = be && be.$$typeof;
                switch (Q) {
                  case s:
                  case u:
                  case g:
                  case p:
                  case a:
                    return Q;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var w = c, N = l, M = s, q = a, L = t, R = u, T = o, D = g, A = p, S = n, E = i, x = r, k = d, I = !1;
    function z(_e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(_e) || y(_e) === c;
    }
    function F(_e) {
      return y(_e) === l;
    }
    function P(_e) {
      return y(_e) === s;
    }
    function O(_e) {
      return y(_e) === a;
    }
    function V(_e) {
      return typeof _e == "object" && _e !== null && _e.$$typeof === t;
    }
    function U(_e) {
      return y(_e) === u;
    }
    function H(_e) {
      return y(_e) === o;
    }
    function J(_e) {
      return y(_e) === g;
    }
    function le(_e) {
      return y(_e) === p;
    }
    function ae(_e) {
      return y(_e) === n;
    }
    function Y(_e) {
      return y(_e) === i;
    }
    function re(_e) {
      return y(_e) === r;
    }
    function ie(_e) {
      return y(_e) === d;
    }
    ai.AsyncMode = w, ai.ConcurrentMode = N, ai.ContextConsumer = M, ai.ContextProvider = q, ai.Element = L, ai.ForwardRef = R, ai.Fragment = T, ai.Lazy = D, ai.Memo = A, ai.Portal = S, ai.Profiler = E, ai.StrictMode = x, ai.Suspense = k, ai.isAsyncMode = z, ai.isConcurrentMode = F, ai.isContextConsumer = P, ai.isContextProvider = O, ai.isElement = V, ai.isForwardRef = U, ai.isFragment = H, ai.isLazy = J, ai.isMemo = le, ai.isPortal = ae, ai.isProfiler = Y, ai.isStrictMode = re, ai.isSuspense = ie, ai.isValidElementType = b, ai.typeOf = y;
  }()), ai;
}
var si = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d7;
function Ygc() {
  if (d7)
    return si;
  d7 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var N = w.$$typeof;
      switch (N) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case o:
            case i:
            case r:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case g:
                case p:
                case a:
                  return w;
                default:
                  return N;
              }
          }
        case n:
          return N;
      }
    }
  }
  function y(w) {
    return b(w) === l;
  }
  return si.AsyncMode = c, si.ConcurrentMode = l, si.ContextConsumer = s, si.ContextProvider = a, si.Element = t, si.ForwardRef = u, si.Fragment = o, si.Lazy = g, si.Memo = p, si.Portal = n, si.Profiler = i, si.StrictMode = r, si.Suspense = d, si.isAsyncMode = function(w) {
    return y(w) || b(w) === c;
  }, si.isConcurrentMode = y, si.isContextConsumer = function(w) {
    return b(w) === s;
  }, si.isContextProvider = function(w) {
    return b(w) === a;
  }, si.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, si.isForwardRef = function(w) {
    return b(w) === u;
  }, si.isFragment = function(w) {
    return b(w) === o;
  }, si.isLazy = function(w) {
    return b(w) === g;
  }, si.isMemo = function(w) {
    return b(w) === p;
  }, si.isPortal = function(w) {
    return b(w) === n;
  }, si.isProfiler = function(w) {
    return b(w) === i;
  }, si.isStrictMode = function(w) {
    return b(w) === r;
  }, si.isSuspense = function(w) {
    return b(w) === d;
  }, si.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === o || w === l || w === i || w === r || w === d || w === _ || typeof w == "object" && w !== null && (w.$$typeof === g || w.$$typeof === p || w.$$typeof === a || w.$$typeof === s || w.$$typeof === u || w.$$typeof === h || w.$$typeof === $ || w.$$typeof === v || w.$$typeof === f);
  }, si.typeOf = b, si;
}
process.env.NODE_ENV === "production" ? R4.exports = Ygc() : R4.exports = Hgc();
var Kgc = R4.exports, YF = Kgc, Zgc = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Xgc = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Jgc = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Wue = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, KF = {};
KF[YF.ForwardRef] = Jgc;
KF[YF.Memo] = Wue;
function _7(e) {
  return YF.isMemo(e) ? Wue : KF[e.$$typeof] || Zgc;
}
var Qgc = Object.defineProperty, ehc = Object.getOwnPropertyNames, p7 = Object.getOwnPropertySymbols, thc = Object.getOwnPropertyDescriptor, nhc = Object.getPrototypeOf, m7 = Object.prototype;
function Hue(e, t, n) {
  if (typeof t != "string") {
    if (m7) {
      var o = nhc(t);
      o && o !== m7 && Hue(e, o, n);
    }
    var r = ehc(t);
    p7 && (r = r.concat(p7(t)));
    for (var i = _7(e), a = _7(t), s = 0; s < r.length; ++s) {
      var c = r[s];
      if (!Xgc[c] && !(n && n[c]) && !(a && a[c]) && !(i && i[c])) {
        var l = thc(t, c);
        try {
          Qgc(e, c, l);
        } catch {
        }
      }
    }
  }
  return e;
}
var ohc = Hue;
const f7 = /* @__PURE__ */ Mi(ohc);
var rhc = !0;
function Yue(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : o += r + " ";
  }), o;
}
var ZF = function(t, n, o) {
  var r = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  rhc === !1) && t.registered[r] === void 0 && (t.registered[r] = n.styles);
}, XF = function(t, n, o) {
  ZF(t, n, o);
  var r = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + r : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function ihc(e) {
  for (var t = 0, n, o = 0, r = e.length; r >= 4; ++o, r -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var ahc = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, g7 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, shc = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", chc = /[A-Z]|^ms/g, Kue = /_EMO_([^_]+?)_([^]*?)_EMO_/g, JF = function(t) {
  return t.charCodeAt(1) === 45;
}, h7 = function(t) {
  return t != null && typeof t != "boolean";
}, qN = /* @__PURE__ */ zgc(function(e) {
  return JF(e) ? e : e.replace(chc, "-$&").toLowerCase();
}), pC = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Kue, function(o, r, i) {
          return A_ = {
            name: r,
            styles: i,
            next: A_
          }, r;
        });
  }
  return ahc[t] !== 1 && !JF(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var lhc = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, uhc = ["normal", "none", "initial", "inherit", "unset"], dhc = pC, _hc = /^-ms-/, phc = /-(.)/g, v7 = {};
  pC = function(t, n) {
    if (t === "content" && (typeof n != "string" || uhc.indexOf(n) === -1 && !lhc.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var o = dhc(t, n);
    return o !== "" && !JF(t) && t.indexOf("-") !== -1 && v7[t] === void 0 && (v7[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(_hc, "ms-").replace(phc, function(r, i) {
      return i.toUpperCase();
    }) + "?")), o;
  };
}
function Vk(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return A_ = {
          name: n.name,
          styles: n.styles,
          next: A_
        }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            A_ = {
              name: o.name,
              styles: o.styles,
              next: A_
            }, o = o.next;
        var r = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (r += n.map), r;
      }
      return mhc(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = A_, a = n(e);
        return A_ = i, Vk(e, t, a);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], c = n.replace(Kue, function(u, d, _) {
          var p = "animation" + s.length;
          return s.push("const " + p + " = keyframes`" + _.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + p + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + c + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + c + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var l = t[n];
  return l !== void 0 ? l : n;
}
function mhc(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      o += Vk(e, t, n[r]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object")
        t != null && t[a] !== void 0 ? o += i + "{" + t[a] + "}" : h7(a) && (o += qN(i) + ":" + pC(i, a) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
        if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
          for (var s = 0; s < a.length; s++)
            h7(a[s]) && (o += qN(i) + ":" + pC(i, a[s]) + ";");
        else {
          var c = Vk(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              o += qN(i) + ":" + c + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(shc), o += i + "{" + c + "}";
          }
        }
      }
    }
  return o;
}
var b7 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Zue;
process.env.NODE_ENV !== "production" && (Zue = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var A_, Bk = function(t, n, o) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var r = !0, i = "";
  A_ = void 0;
  var a = t[0];
  a == null || a.raw === void 0 ? (r = !1, i += Vk(o, n, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(g7), i += a[0]);
  for (var s = 1; s < t.length; s++)
    i += Vk(o, n, t[s]), r && (process.env.NODE_ENV !== "production" && a[s] === void 0 && console.error(g7), i += a[s]);
  var c;
  process.env.NODE_ENV !== "production" && (i = i.replace(Zue, function(_) {
    return c = _, "";
  })), b7.lastIndex = 0;
  for (var l = "", u; (u = b7.exec(i)) !== null; )
    l += "-" + // $FlowFixMe we know it's not null
    u[1];
  var d = ihc(i) + l;
  return process.env.NODE_ENV !== "production" ? {
    name: d,
    styles: i,
    map: c,
    next: A_,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: d,
    styles: i,
    next: A_
  };
}, QF = {}.hasOwnProperty, eq = /* @__PURE__ */ Cr(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Wgc({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (eq.displayName = "EmotionCacheContext");
eq.Provider;
var tq = function(t) {
  return /* @__PURE__ */ Bt(function(n, o) {
    var r = bo(eq);
    return t(n, r, o);
  });
}, oA = /* @__PURE__ */ Cr({});
process.env.NODE_ENV !== "production" && (oA.displayName = "EmotionThemeContext");
var y7 = function(t) {
  var n = t.split(".");
  return n[n.length - 1];
}, fhc = function(t) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(t);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(t), n))
    return y7(n[1]);
}, ghc = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), hhc = function(t) {
  return t.replace(/\$/g, "-");
}, vhc = function(t) {
  if (t)
    for (var n = t.split(`
`), o = 0; o < n.length; o++) {
      var r = fhc(n[o]);
      if (r) {
        if (ghc.has(r))
          break;
        if (/^[A-Z]/.test(r))
          return hhc(r);
      }
    }
}, bhc = Ue.useInsertionEffect ? Ue.useInsertionEffect : function(t) {
  t();
};
function Xue(e) {
  bhc(e);
}
var P4 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", D4 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", yhc = function(t, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var o = {};
  for (var r in n)
    QF.call(n, r) && (o[r] = n[r]);
  if (o[P4] = t, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = vhc(new Error().stack);
    i && (o[D4] = i);
  }
  return o;
}, $hc = function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return ZF(n, o, r), Xue(function() {
    return XF(n, o, r);
  }), null;
}, Jue = /* @__PURE__ */ tq(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[P4], i = [o], a = "";
  typeof e.className == "string" ? a = Yue(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var s = Bk(i, void 0, bo(oA));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var c = e[D4];
    c && (s = Bk([s, "label:" + c + ";"]));
  }
  a += t.key + "-" + s.name;
  var l = {};
  for (var u in e)
    QF.call(e, u) && u !== "css" && u !== P4 && (process.env.NODE_ENV === "production" || u !== D4) && (l[u] = e[u]);
  return l.ref = n, l.className = a, /* @__PURE__ */ pt(Ha, null, /* @__PURE__ */ pt($hc, {
    cache: t,
    serialized: s,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ pt(r, l));
});
process.env.NODE_ENV !== "production" && (Jue.displayName = "EmotionCssPropInternal");
var whc = {
  name: "@emotion/react",
  version: "11.9.0",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.13.10",
    "@emotion/babel-plugin": "^11.7.1",
    "@emotion/cache": "^11.7.1",
    "@emotion/serialize": "^1.0.3",
    "@emotion/utils": "^1.1.0",
    "@emotion/weak-memoize": "^0.2.5",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: !0
    },
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@babel/core": "^7.13.10",
    "@emotion/css": "11.9.0",
    "@emotion/css-prettifier": "1.0.1",
    "@emotion/server": "11.4.0",
    "@emotion/styled": "11.8.1",
    "@types/react": "^16.9.11",
    dtslint: "^4.2.1",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact"
  }
}, Eo = function(t, n) {
  var o = arguments;
  if (n == null || !QF.call(n, "css"))
    return pt.apply(void 0, o);
  var r = o.length, i = new Array(r);
  i[0] = Jue, i[1] = yhc(t, n);
  for (var a = 2; a < r; a++)
    i[a] = o[a];
  return pt.apply(null, i);
}, $7 = Ue.useInsertionEffect ? Ue.useInsertionEffect : lc, w7 = !1, khc = /* @__PURE__ */ tq(function(e, t) {
  process.env.NODE_ENV !== "production" && !w7 && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), w7 = !0);
  var n = e.styles, o = Bk([n], void 0, bo(oA)), r = xt();
  return $7(function() {
    var i = t.key + "-global", a = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), s = !1, c = document.querySelector('style[data-emotion="' + i + " " + o.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), c !== null && (s = !0, c.setAttribute("data-emotion", i), a.hydrate([c])), r.current = [a, s], function() {
      a.flush();
    };
  }, [t]), $7(function() {
    var i = r.current, a = i[0], s = i[1];
    if (s) {
      i[1] = !1;
      return;
    }
    if (o.next !== void 0 && XF(t, o.next, !0), a.tags.length) {
      var c = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = c, a.flush();
    }
    t.insert("", o, a, !1);
  }, [t, o.name]), null;
});
process.env.NODE_ENV !== "production" && (khc.displayName = "EmotionGlobal");
function nq() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Bk(t);
}
var Shc = function() {
  var t = nq.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Ehc = function e(t) {
  for (var n = t.length, o = 0, r = ""; o < n; o++) {
    var i = t[o];
    if (i != null) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            a = e(i);
          else {
            process.env.NODE_ENV !== "production" && i.styles !== void 0 && i.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "";
            for (var s in i)
              i[s] && s && (a && (a += " "), a += s);
          }
          break;
        }
        default:
          a = i;
      }
      a && (r && (r += " "), r += a);
    }
  }
  return r;
};
function xhc(e, t, n) {
  var o = [], r = Yue(e, o, n);
  return o.length < 2 ? n : r + t(o);
}
var Chc = function(t) {
  var n = t.cache, o = t.serializedArr;
  return Xue(function() {
    for (var r = 0; r < o.length; r++)
      XF(n, o[r], !1);
  }), null;
}, Thc = /* @__PURE__ */ tq(function(e, t) {
  var n = !1, o = [], r = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
      u[d] = arguments[d];
    var _ = Bk(u, t.registered);
    return o.push(_), ZF(t, _, !1), t.key + "-" + _.name;
  }, i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
      u[d] = arguments[d];
    return xhc(t.registered, r, Ehc(u));
  }, a = {
    css: r,
    cx: i,
    theme: bo(oA)
  }, s = e.children(a);
  return n = !0, /* @__PURE__ */ pt(Ha, null, /* @__PURE__ */ pt(Chc, {
    cache: t,
    serializedArr: o
  }), s);
});
process.env.NODE_ENV !== "production" && (Thc.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var k7 = !0, Ahc = typeof jest < "u";
  if (k7 && !Ahc) {
    var S7 = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : k7 ? window : global
    ), E7 = "__EMOTION_REACT_" + whc.version.split(".")[0] + "__";
    S7[E7] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), S7[E7] = !0;
  }
}
function Ihc(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function Ohc(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
const Nhc = ["top", "right", "bottom", "left"];
Nhc.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
function jp(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Que(e) {
  return jp(e).getComputedStyle(e);
}
function ede(e) {
  return e instanceof jp(e).Node;
}
function tde(e) {
  return ede(e) ? (e.nodeName || "").toLowerCase() : "";
}
let US;
function zhc() {
  if (US)
    return US;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (US = e.brands.map((t) => t.brand + "/" + t.version).join(" "), US) : navigator.userAgent;
}
function oq(e) {
  return e instanceof jp(e).HTMLElement;
}
function Hb(e) {
  return e instanceof jp(e).Element;
}
function x7(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof jp(e).ShadowRoot || e instanceof ShadowRoot;
}
function nde(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = Que(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function Rhc() {
  return /^((?!chrome|android).)*safari/i.test(zhc());
}
function Phc(e) {
  return ["html", "body", "#document"].includes(tde(e));
}
const mC = Math.round;
function Dhc(e) {
  const t = Que(e);
  let n = parseFloat(t.width), o = parseFloat(t.height);
  const r = oq(e), i = r ? e.offsetWidth : n, a = r ? e.offsetHeight : o, s = mC(n) !== i || mC(o) !== a;
  return s && (n = i, o = a), { width: n, height: o, fallback: s };
}
function ode(e) {
  return Hb(e) ? e : e.contextElement;
}
const rde = { x: 1, y: 1 };
function jN(e) {
  const t = ode(e);
  if (!oq(t))
    return rde;
  const n = t.getBoundingClientRect(), { width: o, height: r, fallback: i } = Dhc(t);
  let a = (i ? mC(n.width) : n.width) / o, s = (i ? mC(n.height) : n.height) / r;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
function C7(e, t, n, o) {
  var r, i;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), s = ode(e);
  let c = rde;
  t && (o ? Hb(o) && (c = jN(o)) : c = jN(e));
  const l = s ? jp(s) : window, u = Rhc() && n;
  let d = (a.left + (u && ((r = l.visualViewport) == null ? void 0 : r.offsetLeft) || 0)) / c.x, _ = (a.top + (u && ((i = l.visualViewport) == null ? void 0 : i.offsetTop) || 0)) / c.y, p = a.width / c.x, g = a.height / c.y;
  if (s) {
    const f = jp(s), h = o && Hb(o) ? jp(o) : o;
    let $ = f.frameElement;
    for (; $ && o && h !== f; ) {
      const v = jN($), b = $.getBoundingClientRect(), y = getComputedStyle($);
      b.x += ($.clientLeft + parseFloat(y.paddingLeft)) * v.x, b.y += ($.clientTop + parseFloat(y.paddingTop)) * v.y, d *= v.x, _ *= v.y, p *= v.x, g *= v.y, d += b.x, _ += b.y, $ = jp($).frameElement;
    }
  }
  return Ohc({ width: p, height: g, x: d, y: _ });
}
function Lhc(e) {
  return ((ede(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Mhc(e) {
  if (tde(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || x7(e) && e.host || Lhc(e);
  return x7(t) ? t.host : t;
}
function ide(e) {
  const t = Mhc(e);
  return Phc(t) ? t.ownerDocument.body : oq(t) && nde(t) ? t : ide(t);
}
function ux(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = ide(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = jp(o);
  return r ? t.concat(i, i.visualViewport || [], nde(o) ? o : []) : t.concat(o, ux(o));
}
function Fhc(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: a = !0, animationFrame: s = !1 } = o, c = r && !s, l = c || i ? [...Hb(e) ? ux(e) : e.contextElement ? ux(e.contextElement) : [], ...ux(t)] : [];
  l.forEach((p) => {
    c && p.addEventListener("scroll", n, { passive: !0 }), i && p.addEventListener("resize", n);
  });
  let u, d = null;
  a && (d = new ResizeObserver(() => {
    n();
  }), Hb(e) && !s && d.observe(e), Hb(e) || !e.contextElement || s || d.observe(e.contextElement), d.observe(t));
  let _ = s ? C7(e) : null;
  return s && function p() {
    const g = C7(e);
    !_ || g.x === _.x && g.y === _.y && g.width === _.width && g.height === _.height || n(), _ = g, u = requestAnimationFrame(p);
  }(), n(), () => {
    var p;
    l.forEach((g) => {
      c && g.removeEventListener("scroll", n), i && g.removeEventListener("resize", n);
    }), (p = d) == null || p.disconnect(), d = null, s && cancelAnimationFrame(u);
  };
}
var L4 = lc, qhc = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], fC = function() {
};
function jhc(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function Vhc(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    o[r - 2] = arguments[r];
  var i = [].concat(o);
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && i.push("".concat(jhc(e, a)));
  return i.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var T7 = function(t) {
  return Xhc(t) ? t.filter(Boolean) : cv(t) === "object" && t !== null ? [t] : [];
}, ade = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = xv(t, qhc);
  return Fo({}, n);
}, La = function(t, n, o) {
  var r = t.cx, i = t.getStyles, a = t.getClassNames, s = t.className;
  return {
    css: i(n, t),
    className: r(o ?? {}, a(n, t), s)
  };
};
function rA(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function Bhc(e) {
  return rA(e) ? window.innerHeight : e.clientHeight;
}
function sde(e) {
  return rA(e) ? window.pageYOffset : e.scrollTop;
}
function gC(e, t) {
  if (rA(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function Uhc(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", o = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var r = e; r = r.parentElement; )
    if (t = getComputedStyle(r), !(n && t.position === "static") && o.test(t.overflow + t.overflowY + t.overflowX))
      return r;
  return document.documentElement;
}
function Ghc(e, t, n, o) {
  return n * ((e = e / o - 1) * e * e + 1) + t;
}
function GS(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : fC, r = sde(e), i = t - r, a = 10, s = 0;
  function c() {
    s += a;
    var l = Ghc(s, r, i, n);
    gC(e, l), s < n ? window.requestAnimationFrame(c) : o(e);
  }
  c();
}
function A7(e, t) {
  var n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = t.offsetHeight / 3;
  o.bottom + r > n.bottom ? gC(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : o.top - r < n.top && gC(e, Math.max(t.offsetTop - r, 0));
}
function Whc(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function I7() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function Hhc() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var cde = !1, Yhc = {
  get passive() {
    return cde = !0;
  }
}, WS = typeof window < "u" ? window : {};
WS.addEventListener && WS.removeEventListener && (WS.addEventListener("p", fC, Yhc), WS.removeEventListener("p", fC, !1));
var Khc = cde;
function Zhc(e) {
  return e != null;
}
function Xhc(e) {
  return Array.isArray(e);
}
function HS(e, t, n) {
  return e ? t : n;
}
var Jhc = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    o[r - 1] = arguments[r];
  var i = Object.entries(t).filter(function(a) {
    var s = _f(a, 1), c = s[0];
    return !o.includes(c);
  });
  return i.reduce(function(a, s) {
    var c = _f(s, 2), l = c[0], u = c[1];
    return a[l] = u, a;
  }, {});
};
function Qhc(e) {
  var t = e.maxHeight, n = e.menuEl, o = e.minHeight, r = e.placement, i = e.shouldScroll, a = e.isFixedPosition, s = e.controlHeight, c = Uhc(n), l = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return l;
  var u = c.getBoundingClientRect(), d = u.height, _ = n.getBoundingClientRect(), p = _.bottom, g = _.height, f = _.top, h = n.offsetParent.getBoundingClientRect(), $ = h.top, v = a ? window.innerHeight : Bhc(c), b = sde(c), y = parseInt(getComputedStyle(n).marginBottom, 10), w = parseInt(getComputedStyle(n).marginTop, 10), N = $ - w, M = v - f, q = N + b, L = d - b - f, R = p - v + b + y, T = b + f - w, D = 160;
  switch (r) {
    case "auto":
    case "bottom":
      if (M >= g)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (L >= g && !a)
        return i && GS(c, R, D), {
          placement: "bottom",
          maxHeight: t
        };
      if (!a && L >= o || a && M >= o) {
        i && GS(c, R, D);
        var A = a ? M - y : L - y;
        return {
          placement: "bottom",
          maxHeight: A
        };
      }
      if (r === "auto" || a) {
        var S = t, E = a ? N : q;
        return E >= o && (S = Math.min(E - y - s, t)), {
          placement: "top",
          maxHeight: S
        };
      }
      if (r === "bottom")
        return i && gC(c, R), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (N >= g)
        return {
          placement: "top",
          maxHeight: t
        };
      if (q >= g && !a)
        return i && GS(c, T, D), {
          placement: "top",
          maxHeight: t
        };
      if (!a && q >= o || a && N >= o) {
        var x = t;
        return (!a && q >= o || a && N >= o) && (x = a ? N - w : q - w), i && GS(c, T, D), {
          placement: "top",
          maxHeight: x
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }
  return l;
}
function evc(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var lde = function(t) {
  return t === "auto" ? "bottom" : t;
}, tvc = function(t, n) {
  var o, r = t.placement, i = t.theme, a = i.borderRadius, s = i.spacing, c = i.colors;
  return Fo((o = {
    label: "menu"
  }, Tw(o, evc(r), "100%"), Tw(o, "position", "absolute"), Tw(o, "width", "100%"), Tw(o, "zIndex", 1), o), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: a,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, ude = /* @__PURE__ */ Cr(null), nvc = function(t) {
  var n = t.children, o = t.minMenuHeight, r = t.maxMenuHeight, i = t.menuPlacement, a = t.menuPosition, s = t.menuShouldScrollIntoView, c = t.theme, l = bo(ude) || {}, u = l.setPortalPlacement, d = xt(null), _ = it(r), p = _f(_, 2), g = p[0], f = p[1], h = it(null), $ = _f(h, 2), v = $[0], b = $[1], y = c.spacing.controlHeight;
  return L4(function() {
    var w = d.current;
    if (w) {
      var N = a === "fixed", M = s && !N, q = Qhc({
        maxHeight: r,
        menuEl: w,
        minHeight: o,
        placement: i,
        shouldScroll: M,
        isFixedPosition: N,
        controlHeight: y
      });
      f(q.maxHeight), b(q.placement), u == null || u(q.placement);
    }
  }, [r, i, a, s, o, u, y]), n({
    ref: d,
    placerProps: Fo(Fo({}, t), {}, {
      placement: v || lde(i),
      maxHeight: g
    })
  });
}, ovc = function(t) {
  var n = t.children, o = t.innerRef, r = t.innerProps;
  return Eo("div", Tt({}, La(t, "menu", {
    menu: !0
  }), {
    ref: o
  }, r), n);
}, rvc = function(t, n) {
  var o = t.maxHeight, r = t.theme.spacing.baseUnit;
  return Fo({
    maxHeight: o,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: r,
    paddingTop: r
  });
}, ivc = function(t) {
  var n = t.children, o = t.innerProps, r = t.innerRef, i = t.isMulti;
  return Eo("div", Tt({}, La(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: r
  }, o), n);
}, dde = function(t, n) {
  var o = t.theme, r = o.spacing.baseUnit, i = o.colors;
  return Fo({
    textAlign: "center"
  }, n ? {} : {
    color: i.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px")
  });
}, avc = dde, svc = dde, _de = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", Tt({}, La(t, "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), n);
};
_de.defaultProps = {
  children: "No options"
};
var pde = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", Tt({}, La(t, "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), n);
};
pde.defaultProps = {
  children: "Loading..."
};
var cvc = function(t) {
  var n = t.rect, o = t.offset, r = t.position;
  return {
    left: n.left,
    position: r,
    top: o,
    width: n.width,
    zIndex: 1
  };
}, lvc = function(t) {
  var n = t.appendTo, o = t.children, r = t.controlElement, i = t.innerProps, a = t.menuPlacement, s = t.menuPosition, c = xt(null), l = xt(null), u = it(lde(a)), d = _f(u, 2), _ = d[0], p = d[1], g = vn(function() {
    return {
      setPortalPlacement: p
    };
  }, []), f = it(null), h = _f(f, 2), $ = h[0], v = h[1], b = Yt(function() {
    if (r) {
      var M = Whc(r), q = s === "fixed" ? 0 : window.pageYOffset, L = M[_] + q;
      (L !== ($ == null ? void 0 : $.offset) || M.left !== ($ == null ? void 0 : $.rect.left) || M.width !== ($ == null ? void 0 : $.rect.width)) && v({
        offset: L,
        rect: M
      });
    }
  }, [r, s, _, $ == null ? void 0 : $.offset, $ == null ? void 0 : $.rect.left, $ == null ? void 0 : $.rect.width]);
  L4(function() {
    b();
  }, [b]);
  var y = Yt(function() {
    typeof l.current == "function" && (l.current(), l.current = null), r && c.current && (l.current = Fhc(r, c.current, b, {
      elementResize: "ResizeObserver" in window
    }));
  }, [r, b]);
  L4(function() {
    y();
  }, [y]);
  var w = Yt(function(M) {
    c.current = M, y();
  }, [y]);
  if (!n && s !== "fixed" || !$)
    return null;
  var N = Eo("div", Tt({
    ref: w
  }, La(Fo(Fo({}, t), {}, {
    offset: $.offset,
    position: s,
    rect: $.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), o);
  return Eo(ude.Provider, {
    value: g
  }, n ? /* @__PURE__ */ My(N, n) : N);
}, uvc = function(t) {
  var n = t.isDisabled, o = t.isRtl;
  return {
    label: "container",
    direction: o ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, dvc = function(t) {
  var n = t.children, o = t.innerProps, r = t.isDisabled, i = t.isRtl;
  return Eo("div", Tt({}, La(t, "container", {
    "--is-disabled": r,
    "--is-rtl": i
  }), o), n);
}, _vc = function(t, n) {
  var o = t.theme.spacing, r = t.isMulti, i = t.hasValue, a = t.selectProps.controlShouldRenderValue;
  return Fo({
    alignItems: "center",
    display: r && i && a ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(o.baseUnit / 2, "px ").concat(o.baseUnit * 2, "px")
  });
}, pvc = function(t) {
  var n = t.children, o = t.innerProps, r = t.isMulti, i = t.hasValue;
  return Eo("div", Tt({}, La(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": r,
    "value-container--has-value": i
  }), o), n);
}, mvc = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, fvc = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", Tt({}, La(t, "indicatorsContainer", {
    indicators: !0
  }), o), n);
}, O7, gvc = ["size"];
function hvc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var vvc = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hvc
}, mde = function(t) {
  var n = t.size, o = xv(t, gvc);
  return Eo("svg", Tt({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: vvc
  }, o));
}, rq = function(t) {
  return Eo(mde, Tt({
    size: 20
  }, t), Eo("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, fde = function(t) {
  return Eo(mde, Tt({
    size: 20
  }, t), Eo("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, gde = function(t, n) {
  var o = t.isFocused, r = t.theme, i = r.spacing.baseUnit, a = r.colors;
  return Fo({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: o ? a.neutral60 : a.neutral20,
    padding: i * 2,
    ":hover": {
      color: o ? a.neutral80 : a.neutral40
    }
  });
}, bvc = gde, yvc = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", Tt({}, La(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), o), n || Eo(fde, null));
}, $vc = gde, wvc = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", Tt({}, La(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), o), n || Eo(rq, null));
}, kvc = function(t, n) {
  var o = t.isDisabled, r = t.theme, i = r.spacing.baseUnit, a = r.colors;
  return Fo({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: o ? a.neutral10 : a.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, Svc = function(t) {
  var n = t.innerProps;
  return Eo("span", Tt({}, n, La(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Evc = Shc(O7 || (O7 = Ihc([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), xvc = function(t, n) {
  var o = t.isFocused, r = t.size, i = t.theme, a = i.colors, s = i.spacing.baseUnit;
  return Fo({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: o ? a.neutral60 : a.neutral20,
    padding: s * 2
  });
}, VN = function(t) {
  var n = t.delay, o = t.offset;
  return Eo("span", {
    css: /* @__PURE__ */ nq({
      animation: "".concat(Evc, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: o ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, hde = function(t) {
  var n = t.innerProps, o = t.isRtl;
  return Eo("div", Tt({}, La(t, "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), Eo(VN, {
    delay: 0,
    offset: o
  }), Eo(VN, {
    delay: 160,
    offset: !0
  }), Eo(VN, {
    delay: 320,
    offset: !o
  }));
};
hde.defaultProps = {
  size: 4
};
var Cvc = function(t, n) {
  var o = t.isDisabled, r = t.isFocused, i = t.theme, a = i.colors, s = i.borderRadius, c = i.spacing;
  return Fo({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: o ? a.neutral5 : a.neutral0,
    borderColor: o ? a.neutral10 : r ? a.primary : a.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(a.primary) : void 0,
    "&:hover": {
      borderColor: r ? a.primary : a.neutral30
    }
  });
}, Tvc = function(t) {
  var n = t.children, o = t.isDisabled, r = t.isFocused, i = t.innerRef, a = t.innerProps, s = t.menuIsOpen;
  return Eo("div", Tt({
    ref: i
  }, La(t, "control", {
    control: !0,
    "control--is-disabled": o,
    "control--is-focused": r,
    "control--menu-is-open": s
  }), a), n);
}, Avc = ["data"], Ivc = function(t, n) {
  var o = t.theme.spacing;
  return n ? {} : {
    paddingBottom: o.baseUnit * 2,
    paddingTop: o.baseUnit * 2
  };
}, Ovc = function(t) {
  var n = t.children, o = t.cx, r = t.getStyles, i = t.getClassNames, a = t.Heading, s = t.headingProps, c = t.innerProps, l = t.label, u = t.theme, d = t.selectProps;
  return Eo("div", Tt({}, La(t, "group", {
    group: !0
  }), c), Eo(a, Tt({}, s, {
    selectProps: d,
    theme: u,
    getStyles: r,
    getClassNames: i,
    cx: o
  }), l), Eo("div", null, n));
}, Nvc = function(t, n) {
  var o = t.theme, r = o.colors, i = o.spacing;
  return Fo({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: r.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, zvc = function(t) {
  var n = ade(t);
  n.data;
  var o = xv(n, Avc);
  return Eo("div", Tt({}, La(t, "groupHeading", {
    "group-heading": !0
  }), o));
}, Rvc = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Pvc = function(t, n) {
  var o = t.isDisabled, r = t.value, i = t.theme, a = i.spacing, s = i.colors;
  return Fo(Fo({
    visibility: o ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: r ? "translateZ(0)" : ""
  }, Dvc), n ? {} : {
    margin: a.baseUnit / 2,
    paddingBottom: a.baseUnit / 2,
    paddingTop: a.baseUnit / 2,
    color: s.neutral80
  });
}, vde = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Dvc = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Fo({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, vde)
}, Lvc = function(t) {
  return Fo({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, vde);
}, Mvc = function(t) {
  var n = t.cx, o = t.value, r = ade(t), i = r.innerRef, a = r.isDisabled, s = r.isHidden, c = r.inputClassName, l = xv(r, Rvc);
  return Eo("div", Tt({}, La(t, "input", {
    "input-container": !0
  }), {
    "data-value": o || ""
  }), Eo("input", Tt({
    className: n({
      input: !0
    }, c),
    ref: i,
    style: Lvc(s),
    disabled: a
  }, l)));
}, Fvc = function(t, n) {
  var o = t.theme, r = o.spacing, i = o.borderRadius, a = o.colors;
  return Fo({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: a.neutral10,
    borderRadius: i / 2,
    margin: r.baseUnit / 2
  });
}, qvc = function(t, n) {
  var o = t.theme, r = o.borderRadius, i = o.colors, a = t.cropWithEllipsis;
  return Fo({
    overflow: "hidden",
    textOverflow: a || a === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: r / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, jvc = function(t, n) {
  var o = t.theme, r = o.spacing, i = o.borderRadius, a = o.colors, s = t.isFocused;
  return Fo({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: i / 2,
    backgroundColor: s ? a.dangerLight : void 0,
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: a.dangerLight,
      color: a.danger
    }
  });
}, bde = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", o, n);
}, Vvc = bde, Bvc = bde;
function Uvc(e) {
  var t = e.children, n = e.innerProps;
  return Eo("div", Tt({
    role: "button"
  }, n), t || Eo(rq, {
    size: 14
  }));
}
var Gvc = function(t) {
  var n = t.children, o = t.components, r = t.data, i = t.innerProps, a = t.isDisabled, s = t.removeProps, c = t.selectProps, l = o.Container, u = o.Label, d = o.Remove;
  return Eo(l, {
    data: r,
    innerProps: Fo(Fo({}, La(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": a
    })), i),
    selectProps: c
  }, Eo(u, {
    data: r,
    innerProps: Fo({}, La(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), Eo(d, {
    data: r,
    innerProps: Fo(Fo({}, La(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: c
  }));
}, Wvc = function(t, n) {
  var o = t.isDisabled, r = t.isFocused, i = t.isSelected, a = t.theme, s = a.spacing, c = a.colors;
  return Fo({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: i ? c.primary : r ? c.primary25 : "transparent",
    color: o ? c.neutral20 : i ? c.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: o ? void 0 : i ? c.primary : c.primary50
    }
  });
}, Hvc = function(t) {
  var n = t.children, o = t.isDisabled, r = t.isFocused, i = t.isSelected, a = t.innerRef, s = t.innerProps;
  return Eo("div", Tt({}, La(t, "option", {
    option: !0,
    "option--is-disabled": o,
    "option--is-focused": r,
    "option--is-selected": i
  }), {
    ref: a,
    "aria-disabled": o
  }, s), n);
}, Yvc = function(t, n) {
  var o = t.theme, r = o.spacing, i = o.colors;
  return Fo({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: i.neutral50,
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  });
}, Kvc = function(t) {
  var n = t.children, o = t.innerProps;
  return Eo("div", Tt({}, La(t, "placeholder", {
    placeholder: !0
  }), o), n);
}, Zvc = function(t, n) {
  var o = t.isDisabled, r = t.theme, i = r.spacing, a = r.colors;
  return Fo({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: o ? a.neutral40 : a.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, Xvc = function(t) {
  var n = t.children, o = t.isDisabled, r = t.innerProps;
  return Eo("div", Tt({}, La(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": o
  }), r), n);
}, F_ = {
  ClearIndicator: wvc,
  Control: Tvc,
  DropdownIndicator: yvc,
  DownChevron: fde,
  CrossIcon: rq,
  Group: Ovc,
  GroupHeading: zvc,
  IndicatorsContainer: fvc,
  IndicatorSeparator: Svc,
  Input: Mvc,
  LoadingIndicator: hde,
  Menu: ovc,
  MenuList: ivc,
  MenuPortal: lvc,
  LoadingMessage: pde,
  NoOptionsMessage: _de,
  MultiValue: Gvc,
  MultiValueContainer: Vvc,
  MultiValueLabel: Bvc,
  MultiValueRemove: Uvc,
  Option: Hvc,
  Placeholder: Kvc,
  SelectContainer: dvc,
  SingleValue: Xvc,
  ValueContainer: pvc
}, Jvc = function(t) {
  return Fo(Fo({}, F_), t.components);
}, N7 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Qvc(e, t) {
  return !!(e === t || N7(e) && N7(t));
}
function ebc(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Qvc(e[n], t[n]))
      return !1;
  return !0;
}
function tbc(e, t) {
  t === void 0 && (t = ebc);
  var n = null;
  function o() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (n && n.lastThis === this && t(r, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, r);
    return n = {
      lastResult: a,
      lastArgs: r,
      lastThis: this
    }, a;
  }
  return o.clear = function() {
    n = null;
  }, o;
}
function nbc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var obc = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: nbc
}, z7 = function(t) {
  return Eo("span", Tt({
    css: obc
  }, t));
}, rbc = {
  guidance: function(t) {
    var n = t.isSearchable, o = t.isMulti, r = t.isDisabled, i = t.tabSelectsValue, a = t.context;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options".concat(r ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(o ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, o = t.label, r = o === void 0 ? "" : o, i = t.labels, a = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(r, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return a ? "option ".concat(r, " is disabled. Select another option.") : "option ".concat(r, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, o = t.focused, r = t.options, i = t.label, a = i === void 0 ? "" : i, s = t.selectValue, c = t.isDisabled, l = t.isSelected, u = function(g, f) {
      return g && g.length ? "".concat(g.indexOf(f) + 1, " of ").concat(g.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(a, " focused, ").concat(u(s, o), ".");
    if (n === "menu") {
      var d = c ? " disabled" : "", _ = "".concat(l ? "selected" : "focused").concat(d);
      return "option ".concat(a, " ").concat(_, ", ").concat(u(r, o), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, o = t.resultsMessage;
    return "".concat(o).concat(n ? " for search term " + n : "", ".");
  }
}, ibc = function(t) {
  var n = t.ariaSelection, o = t.focusedOption, r = t.focusedValue, i = t.focusableOptions, a = t.isFocused, s = t.selectValue, c = t.selectProps, l = t.id, u = c.ariaLiveMessages, d = c.getOptionLabel, _ = c.inputValue, p = c.isMulti, g = c.isOptionDisabled, f = c.isSearchable, h = c.menuIsOpen, $ = c.options, v = c.screenReaderStatus, b = c.tabSelectsValue, y = c["aria-label"], w = c["aria-live"], N = vn(function() {
    return Fo(Fo({}, rbc), u || {});
  }, [u]), M = vn(function() {
    var S = "";
    if (n && N.onChange) {
      var E = n.option, x = n.options, k = n.removedValue, I = n.removedValues, z = n.value, F = function(le) {
        return Array.isArray(le) ? null : le;
      }, P = k || E || F(z), O = P ? d(P) : "", V = x || I || void 0, U = V ? V.map(d) : [], H = Fo({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: P && g(P, s),
        label: O,
        labels: U
      }, n);
      S = N.onChange(H);
    }
    return S;
  }, [n, N, g, s, d]), q = vn(function() {
    var S = "", E = o || r, x = !!(o && s && s.includes(o));
    if (E && N.onFocus) {
      var k = {
        focused: E,
        label: d(E),
        isDisabled: g(E, s),
        isSelected: x,
        options: i,
        context: E === o ? "menu" : "value",
        selectValue: s
      };
      S = N.onFocus(k);
    }
    return S;
  }, [o, r, d, g, N, i, s]), L = vn(function() {
    var S = "";
    if (h && $.length && N.onFilter) {
      var E = v({
        count: i.length
      });
      S = N.onFilter({
        inputValue: _,
        resultsMessage: E
      });
    }
    return S;
  }, [i, _, h, N, $, v]), R = vn(function() {
    var S = "";
    if (N.guidance) {
      var E = r ? "value" : h ? "menu" : "input";
      S = N.guidance({
        "aria-label": y,
        context: E,
        isDisabled: o && g(o, s),
        isMulti: p,
        isSearchable: f,
        tabSelectsValue: b
      });
    }
    return S;
  }, [y, o, r, p, g, f, h, N, s, b]), T = "".concat(q, " ").concat(L, " ").concat(R), D = Eo(Ha, null, Eo("span", {
    id: "aria-selection"
  }, M), Eo("span", {
    id: "aria-context"
  }, T)), A = (n == null ? void 0 : n.action) === "initial-input-focus";
  return Eo(Ha, null, Eo(z7, {
    id: l
  }, A && D), Eo(z7, {
    "aria-live": w,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, a && !A && D));
}, M4 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], abc = new RegExp("[" + M4.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), yde = {};
for (var BN = 0; BN < M4.length; BN++)
  for (var UN = M4[BN], GN = 0; GN < UN.letters.length; GN++)
    yde[UN.letters[GN]] = UN.base;
var $de = function(t) {
  return t.replace(abc, function(n) {
    return yde[n];
  });
}, sbc = tbc($de), R7 = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, cbc = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, wde = function(t) {
  return function(n, o) {
    if (n.data.__isNew__)
      return !0;
    var r = Fo({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: cbc,
      trim: !0,
      matchFrom: "any"
    }, t), i = r.ignoreCase, a = r.ignoreAccents, s = r.stringify, c = r.trim, l = r.matchFrom, u = c ? R7(o) : o, d = c ? R7(s(n)) : s(n);
    return i && (u = u.toLowerCase(), d = d.toLowerCase()), a && (u = sbc(u), d = $de(d)), l === "start" ? d.substr(0, u.length) === u : d.indexOf(u) > -1;
  };
}, lbc = ["innerRef"];
function ubc(e) {
  var t = e.innerRef, n = xv(e, lbc), o = Jhc(n, "onExited", "in", "enter", "exit", "appear");
  return Eo("input", Tt({
    ref: t
  }, o, {
    css: /* @__PURE__ */ nq({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var dbc = function(t) {
  t.preventDefault(), t.stopPropagation();
};
function _bc(e) {
  var t = e.isEnabled, n = e.onBottomArrive, o = e.onBottomLeave, r = e.onTopArrive, i = e.onTopLeave, a = xt(!1), s = xt(!1), c = xt(0), l = xt(null), u = Yt(function(h, $) {
    if (l.current !== null) {
      var v = l.current, b = v.scrollTop, y = v.scrollHeight, w = v.clientHeight, N = l.current, M = $ > 0, q = y - w - b, L = !1;
      q > $ && a.current && (o && o(h), a.current = !1), M && s.current && (i && i(h), s.current = !1), M && $ > q ? (n && !a.current && n(h), N.scrollTop = y, L = !0, a.current = !0) : !M && -$ > b && (r && !s.current && r(h), N.scrollTop = 0, L = !0, s.current = !0), L && dbc(h);
    }
  }, [n, o, r, i]), d = Yt(function(h) {
    u(h, h.deltaY);
  }, [u]), _ = Yt(function(h) {
    c.current = h.changedTouches[0].clientY;
  }, []), p = Yt(function(h) {
    var $ = c.current - h.changedTouches[0].clientY;
    u(h, $);
  }, [u]), g = Yt(function(h) {
    if (h) {
      var $ = Khc ? {
        passive: !1
      } : !1;
      h.addEventListener("wheel", d, $), h.addEventListener("touchstart", _, $), h.addEventListener("touchmove", p, $);
    }
  }, [p, _, d]), f = Yt(function(h) {
    h && (h.removeEventListener("wheel", d, !1), h.removeEventListener("touchstart", _, !1), h.removeEventListener("touchmove", p, !1));
  }, [p, _, d]);
  return yt(function() {
    if (t) {
      var h = l.current;
      return g(h), function() {
        f(h);
      };
    }
  }, [t, g, f]), function(h) {
    l.current = h;
  };
}
var P7 = ["boxSizing", "height", "overflow", "paddingRight", "position"], D7 = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function L7(e) {
  e.preventDefault();
}
function M7(e) {
  e.stopPropagation();
}
function F7() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function q7() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var j7 = !!(typeof window < "u" && window.document && window.document.createElement), nw = 0, cb = {
  capture: !1,
  passive: !1
};
function pbc(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, o = n === void 0 ? !0 : n, r = xt({}), i = xt(null), a = Yt(function(c) {
    if (j7) {
      var l = document.body, u = l && l.style;
      if (o && P7.forEach(function(g) {
        var f = u && u[g];
        r.current[g] = f;
      }), o && nw < 1) {
        var d = parseInt(r.current.paddingRight, 10) || 0, _ = document.body ? document.body.clientWidth : 0, p = window.innerWidth - _ + d || 0;
        Object.keys(D7).forEach(function(g) {
          var f = D7[g];
          u && (u[g] = f);
        }), u && (u.paddingRight = "".concat(p, "px"));
      }
      l && q7() && (l.addEventListener("touchmove", L7, cb), c && (c.addEventListener("touchstart", F7, cb), c.addEventListener("touchmove", M7, cb))), nw += 1;
    }
  }, [o]), s = Yt(function(c) {
    if (j7) {
      var l = document.body, u = l && l.style;
      nw = Math.max(nw - 1, 0), o && nw < 1 && P7.forEach(function(d) {
        var _ = r.current[d];
        u && (u[d] = _);
      }), l && q7() && (l.removeEventListener("touchmove", L7, cb), c && (c.removeEventListener("touchstart", F7, cb), c.removeEventListener("touchmove", M7, cb)));
    }
  }, [o]);
  return yt(function() {
    if (t) {
      var c = i.current;
      return a(c), function() {
        s(c);
      };
    }
  }, [t, a, s]), function(c) {
    i.current = c;
  };
}
function mbc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var fbc = function() {
  return document.activeElement && document.activeElement.blur();
}, gbc = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: mbc
};
function hbc(e) {
  var t = e.children, n = e.lockEnabled, o = e.captureEnabled, r = o === void 0 ? !0 : o, i = e.onBottomArrive, a = e.onBottomLeave, s = e.onTopArrive, c = e.onTopLeave, l = _bc({
    isEnabled: r,
    onBottomArrive: i,
    onBottomLeave: a,
    onTopArrive: s,
    onTopLeave: c
  }), u = pbc({
    isEnabled: n
  }), d = function(p) {
    l(p), u(p);
  };
  return Eo(Ha, null, n && Eo("div", {
    onClick: fbc,
    css: gbc
  }), t(d));
}
function vbc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var bbc = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: vbc
}, ybc = function(t) {
  var n = t.name, o = t.onFocus;
  return Eo("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: o,
    css: bbc,
    value: "",
    onChange: function() {
    }
  });
}, $bc = function(t) {
  return t.label;
}, wbc = function(t) {
  return t.label;
}, kbc = function(t) {
  return t.value;
}, Sbc = function(t) {
  return !!t.isDisabled;
}, Ebc = {
  clearIndicator: $vc,
  container: uvc,
  control: Cvc,
  dropdownIndicator: bvc,
  group: Ivc,
  groupHeading: Nvc,
  indicatorsContainer: mvc,
  indicatorSeparator: kvc,
  input: Pvc,
  loadingIndicator: xvc,
  loadingMessage: svc,
  menu: tvc,
  menuList: rvc,
  menuPortal: cvc,
  multiValue: Fvc,
  multiValueLabel: qvc,
  multiValueRemove: jvc,
  noOptionsMessage: avc,
  option: Wvc,
  placeholder: Yvc,
  singleValue: Zvc,
  valueContainer: _vc
}, xbc = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, Cbc = 4, kde = 4, Tbc = 38, Abc = kde * 2, Ibc = {
  baseUnit: kde,
  controlHeight: Tbc,
  menuGutter: Abc
}, WN = {
  borderRadius: Cbc,
  colors: xbc,
  spacing: Ibc
}, Obc = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: I7(),
  captureMenuScroll: !I7(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: wde(),
  formatGroupLabel: $bc,
  getOptionLabel: wbc,
  getOptionValue: kbc,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Sbc,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Hhc(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function V7(e, t, n, o) {
  var r = Cde(e, t, n), i = Tde(e, t, n), a = xde(e, t), s = hC(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: r,
    isSelected: i,
    label: a,
    value: s,
    index: o
  };
}
function Sde(e, t) {
  return e.options.map(function(n, o) {
    if ("options" in n) {
      var r = n.options.map(function(a, s) {
        return V7(e, a, t, s);
      }).filter(function(a) {
        return B7(e, a);
      });
      return r.length > 0 ? {
        type: "group",
        data: n,
        options: r,
        index: o
      } : void 0;
    }
    var i = V7(e, n, t, o);
    return B7(e, i) ? i : void 0;
  }).filter(Zhc);
}
function Ede(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, BF(n.options.map(function(o) {
      return o.data;
    }))) : t.push(n.data), t;
  }, []);
}
function Nbc(e, t) {
  return Ede(Sde(e, t));
}
function B7(e, t) {
  var n = e.inputValue, o = n === void 0 ? "" : n, r = t.data, i = t.isSelected, a = t.label, s = t.value;
  return (!Ide(e) || !i) && Ade(e, {
    label: a,
    value: s,
    data: r
  }, o);
}
function zbc(e, t) {
  var n = e.focusedValue, o = e.selectValue, r = o.indexOf(n);
  if (r > -1) {
    var i = t.indexOf(n);
    if (i > -1)
      return n;
    if (r < t.length)
      return t[r];
  }
  return null;
}
function Rbc(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var xde = function(t, n) {
  return t.getOptionLabel(n);
}, hC = function(t, n) {
  return t.getOptionValue(n);
};
function Cde(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Tde(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var o = hC(e, t);
  return n.some(function(r) {
    return hC(e, r) === o;
  });
}
function Ade(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var Ide = function(t) {
  var n = t.hideSelectedOptions, o = t.isMulti;
  return n === void 0 ? o : n;
}, Pbc = 1, Ode = /* @__PURE__ */ function(e) {
  Mue(n, e);
  var t = sgc(n);
  function n(o) {
    var r;
    if (U6(this, n), r = t.call(this, o), r.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, r.blockOptionHover = !1, r.isComposing = !1, r.commonProps = void 0, r.initialTouchX = 0, r.initialTouchY = 0, r.instancePrefix = "", r.openAfterFocus = !1, r.scrollToFocusedOptionOnUpdate = !1, r.userIsDragging = void 0, r.controlRef = null, r.getControlRef = function(s) {
      r.controlRef = s;
    }, r.focusedOptionRef = null, r.getFocusedOptionRef = function(s) {
      r.focusedOptionRef = s;
    }, r.menuListRef = null, r.getMenuListRef = function(s) {
      r.menuListRef = s;
    }, r.inputRef = null, r.getInputRef = function(s) {
      r.inputRef = s;
    }, r.focus = r.focusInput, r.blur = r.blurInput, r.onChange = function(s, c) {
      var l = r.props, u = l.onChange, d = l.name;
      c.name = d, r.ariaOnChange(s, c), u(s, c);
    }, r.setValue = function(s, c, l) {
      var u = r.props, d = u.closeMenuOnSelect, _ = u.isMulti, p = u.inputValue;
      r.onInputChange("", {
        action: "set-value",
        prevInputValue: p
      }), d && (r.setState({
        inputIsHiddenAfterUpdate: !_
      }), r.onMenuClose()), r.setState({
        clearFocusValueOnUpdate: !0
      }), r.onChange(s, {
        action: c,
        option: l
      });
    }, r.selectOption = function(s) {
      var c = r.props, l = c.blurInputOnSelect, u = c.isMulti, d = c.name, _ = r.state.selectValue, p = u && r.isOptionSelected(s, _), g = r.isOptionDisabled(s, _);
      if (p) {
        var f = r.getOptionValue(s);
        r.setValue(_.filter(function(h) {
          return r.getOptionValue(h) !== f;
        }), "deselect-option", s);
      } else if (!g)
        u ? r.setValue([].concat(BF(_), [s]), "select-option", s) : r.setValue(s, "select-option");
      else {
        r.ariaOnChange(s, {
          action: "select-option",
          option: s,
          name: d
        });
        return;
      }
      l && r.blurInput();
    }, r.removeValue = function(s) {
      var c = r.props.isMulti, l = r.state.selectValue, u = r.getOptionValue(s), d = l.filter(function(p) {
        return r.getOptionValue(p) !== u;
      }), _ = HS(c, d, d[0] || null);
      r.onChange(_, {
        action: "remove-value",
        removedValue: s
      }), r.focusInput();
    }, r.clearValue = function() {
      var s = r.state.selectValue;
      r.onChange(HS(r.props.isMulti, [], null), {
        action: "clear",
        removedValues: s
      });
    }, r.popValue = function() {
      var s = r.props.isMulti, c = r.state.selectValue, l = c[c.length - 1], u = c.slice(0, c.length - 1), d = HS(s, u, u[0] || null);
      r.onChange(d, {
        action: "pop-value",
        removedValue: l
      });
    }, r.getValue = function() {
      return r.state.selectValue;
    }, r.cx = function() {
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      return Vhc.apply(void 0, [r.props.classNamePrefix].concat(c));
    }, r.getOptionLabel = function(s) {
      return xde(r.props, s);
    }, r.getOptionValue = function(s) {
      return hC(r.props, s);
    }, r.getStyles = function(s, c) {
      var l = r.props.unstyled, u = Ebc[s](c, l);
      u.boxSizing = "border-box";
      var d = r.props.styles[s];
      return d ? d(u, c) : u;
    }, r.getClassNames = function(s, c) {
      var l, u;
      return (l = (u = r.props.classNames)[s]) === null || l === void 0 ? void 0 : l.call(u, c);
    }, r.getElementId = function(s) {
      return "".concat(r.instancePrefix, "-").concat(s);
    }, r.getComponents = function() {
      return Jvc(r.props);
    }, r.buildCategorizedOptions = function() {
      return Sde(r.props, r.state.selectValue);
    }, r.getCategorizedOptions = function() {
      return r.props.menuIsOpen ? r.buildCategorizedOptions() : [];
    }, r.buildFocusableOptions = function() {
      return Ede(r.buildCategorizedOptions());
    }, r.getFocusableOptions = function() {
      return r.props.menuIsOpen ? r.buildFocusableOptions() : [];
    }, r.ariaOnChange = function(s, c) {
      r.setState({
        ariaSelection: Fo({
          value: s
        }, c)
      });
    }, r.onMenuMouseDown = function(s) {
      s.button === 0 && (s.stopPropagation(), s.preventDefault(), r.focusInput());
    }, r.onMenuMouseMove = function(s) {
      r.blockOptionHover = !1;
    }, r.onControlMouseDown = function(s) {
      if (!s.defaultPrevented) {
        var c = r.props.openMenuOnClick;
        r.state.isFocused ? r.props.menuIsOpen ? s.target.tagName !== "INPUT" && s.target.tagName !== "TEXTAREA" && r.onMenuClose() : c && r.openMenu("first") : (c && (r.openAfterFocus = !0), r.focusInput()), s.target.tagName !== "INPUT" && s.target.tagName !== "TEXTAREA" && s.preventDefault();
      }
    }, r.onDropdownIndicatorMouseDown = function(s) {
      if (!(s && s.type === "mousedown" && s.button !== 0) && !r.props.isDisabled) {
        var c = r.props, l = c.isMulti, u = c.menuIsOpen;
        r.focusInput(), u ? (r.setState({
          inputIsHiddenAfterUpdate: !l
        }), r.onMenuClose()) : r.openMenu("first"), s.preventDefault();
      }
    }, r.onClearIndicatorMouseDown = function(s) {
      s && s.type === "mousedown" && s.button !== 0 || (r.clearValue(), s.preventDefault(), r.openAfterFocus = !1, s.type === "touchend" ? r.focusInput() : setTimeout(function() {
        return r.focusInput();
      }));
    }, r.onScroll = function(s) {
      typeof r.props.closeMenuOnScroll == "boolean" ? s.target instanceof HTMLElement && rA(s.target) && r.props.onMenuClose() : typeof r.props.closeMenuOnScroll == "function" && r.props.closeMenuOnScroll(s) && r.props.onMenuClose();
    }, r.onCompositionStart = function() {
      r.isComposing = !0;
    }, r.onCompositionEnd = function() {
      r.isComposing = !1;
    }, r.onTouchStart = function(s) {
      var c = s.touches, l = c && c.item(0);
      l && (r.initialTouchX = l.clientX, r.initialTouchY = l.clientY, r.userIsDragging = !1);
    }, r.onTouchMove = function(s) {
      var c = s.touches, l = c && c.item(0);
      if (l) {
        var u = Math.abs(l.clientX - r.initialTouchX), d = Math.abs(l.clientY - r.initialTouchY), _ = 5;
        r.userIsDragging = u > _ || d > _;
      }
    }, r.onTouchEnd = function(s) {
      r.userIsDragging || (r.controlRef && !r.controlRef.contains(s.target) && r.menuListRef && !r.menuListRef.contains(s.target) && r.blurInput(), r.initialTouchX = 0, r.initialTouchY = 0);
    }, r.onControlTouchEnd = function(s) {
      r.userIsDragging || r.onControlMouseDown(s);
    }, r.onClearIndicatorTouchEnd = function(s) {
      r.userIsDragging || r.onClearIndicatorMouseDown(s);
    }, r.onDropdownIndicatorTouchEnd = function(s) {
      r.userIsDragging || r.onDropdownIndicatorMouseDown(s);
    }, r.handleInputChange = function(s) {
      var c = r.props.inputValue, l = s.currentTarget.value;
      r.setState({
        inputIsHiddenAfterUpdate: !1
      }), r.onInputChange(l, {
        action: "input-change",
        prevInputValue: c
      }), r.props.menuIsOpen || r.onMenuOpen();
    }, r.onInputFocus = function(s) {
      r.props.onFocus && r.props.onFocus(s), r.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (r.openAfterFocus || r.props.openMenuOnFocus) && r.openMenu("first"), r.openAfterFocus = !1;
    }, r.onInputBlur = function(s) {
      var c = r.props.inputValue;
      if (r.menuListRef && r.menuListRef.contains(document.activeElement)) {
        r.inputRef.focus();
        return;
      }
      r.props.onBlur && r.props.onBlur(s), r.onInputChange("", {
        action: "input-blur",
        prevInputValue: c
      }), r.onMenuClose(), r.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, r.onOptionHover = function(s) {
      r.blockOptionHover || r.state.focusedOption === s || r.setState({
        focusedOption: s
      });
    }, r.shouldHideSelectedOptions = function() {
      return Ide(r.props);
    }, r.onValueInputFocus = function(s) {
      s.preventDefault(), s.stopPropagation(), r.focus();
    }, r.onKeyDown = function(s) {
      var c = r.props, l = c.isMulti, u = c.backspaceRemovesValue, d = c.escapeClearsValue, _ = c.inputValue, p = c.isClearable, g = c.isDisabled, f = c.menuIsOpen, h = c.onKeyDown, $ = c.tabSelectsValue, v = c.openMenuOnFocus, b = r.state, y = b.focusedOption, w = b.focusedValue, N = b.selectValue;
      if (!g && !(typeof h == "function" && (h(s), s.defaultPrevented))) {
        switch (r.blockOptionHover = !0, s.key) {
          case "ArrowLeft":
            if (!l || _)
              return;
            r.focusValue("previous");
            break;
          case "ArrowRight":
            if (!l || _)
              return;
            r.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (_)
              return;
            if (w)
              r.removeValue(w);
            else {
              if (!u)
                return;
              l ? r.popValue() : p && r.clearValue();
            }
            break;
          case "Tab":
            if (r.isComposing || s.shiftKey || !f || !$ || !y || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            v && r.isOptionSelected(y, N))
              return;
            r.selectOption(y);
            break;
          case "Enter":
            if (s.keyCode === 229)
              break;
            if (f) {
              if (!y || r.isComposing)
                return;
              r.selectOption(y);
              break;
            }
            return;
          case "Escape":
            f ? (r.setState({
              inputIsHiddenAfterUpdate: !1
            }), r.onInputChange("", {
              action: "menu-close",
              prevInputValue: _
            }), r.onMenuClose()) : p && d && r.clearValue();
            break;
          case " ":
            if (_)
              return;
            if (!f) {
              r.openMenu("first");
              break;
            }
            if (!y)
              return;
            r.selectOption(y);
            break;
          case "ArrowUp":
            f ? r.focusOption("up") : r.openMenu("last");
            break;
          case "ArrowDown":
            f ? r.focusOption("down") : r.openMenu("first");
            break;
          case "PageUp":
            if (!f)
              return;
            r.focusOption("pageup");
            break;
          case "PageDown":
            if (!f)
              return;
            r.focusOption("pagedown");
            break;
          case "Home":
            if (!f)
              return;
            r.focusOption("first");
            break;
          case "End":
            if (!f)
              return;
            r.focusOption("last");
            break;
          default:
            return;
        }
        s.preventDefault();
      }
    }, r.instancePrefix = "react-select-" + (r.props.instanceId || ++Pbc), r.state.selectValue = T7(o.value), o.menuIsOpen && r.state.selectValue.length) {
      var i = r.buildFocusableOptions(), a = i.indexOf(r.state.selectValue[0]);
      r.state.focusedOption = i[a];
    }
    return r;
  }
  return G6(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && A7(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var i = this.props, a = i.isDisabled, s = i.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !a && r.isDisabled || // ensure focus is on the Input when the menu opens
      c && s && !r.menuIsOpen) && this.focusInput(), c && a && !r.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !a && r.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (A7(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(r, i) {
      this.props.onInputChange(r, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(r) {
      var i = this, a = this.state, s = a.selectValue, c = a.isFocused, l = this.buildFocusableOptions(), u = r === "first" ? 0 : l.length - 1;
      if (!this.props.isMulti) {
        var d = l.indexOf(s[0]);
        d > -1 && (u = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: l[u]
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(r) {
      var i = this.state, a = i.selectValue, s = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = a.indexOf(s);
        s || (c = -1);
        var l = a.length - 1, u = -1;
        if (a.length) {
          switch (r) {
            case "previous":
              c === 0 ? u = 0 : c === -1 ? u = l : u = c - 1;
              break;
            case "next":
              c > -1 && c < l && (u = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: u !== -1,
            focusedValue: a[u]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, a = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var c = 0, l = s.indexOf(a);
        a || (l = -1), r === "up" ? c = l > 0 ? l - 1 : s.length - 1 : r === "down" ? c = (l + 1) % s.length : r === "pageup" ? (c = l - i, c < 0 && (c = 0)) : r === "pagedown" ? (c = l + i, c > s.length - 1 && (c = s.length - 1)) : r === "last" && (c = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[c],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(WN) : Fo(Fo({}, WN), this.props.theme) : WN;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var r = this.clearValue, i = this.cx, a = this.getStyles, s = this.getClassNames, c = this.getValue, l = this.selectOption, u = this.setValue, d = this.props, _ = d.isMulti, p = d.isRtl, g = d.options, f = this.hasValue();
      return {
        clearValue: r,
        cx: i,
        getStyles: a,
        getClassNames: s,
        getValue: c,
        hasValue: f,
        isMulti: _,
        isRtl: p,
        options: g,
        selectOption: l,
        selectProps: d,
        setValue: u,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var r = this.state.selectValue;
      return r.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var r = this.props, i = r.isClearable, a = r.isMulti;
      return i === void 0 ? a : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(r, i) {
      return Cde(this.props, r, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(r, i) {
      return Tde(this.props, r, i);
    }
  }, {
    key: "filterOption",
    value: function(r, i) {
      return Ade(this.props, r, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(r, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var a = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(r, {
          context: i,
          inputValue: a,
          selectValue: s
        });
      } else
        return this.getOptionLabel(r);
    }
  }, {
    key: "formatGroupLabel",
    value: function(r) {
      return this.props.formatGroupLabel(r);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var r = this.props, i = r.isDisabled, a = r.isSearchable, s = r.inputId, c = r.inputValue, l = r.tabIndex, u = r.form, d = r.menuIsOpen, _ = r.required, p = this.getComponents(), g = p.Input, f = this.state, h = f.inputIsHidden, $ = f.ariaSelection, v = this.commonProps, b = s || this.getElementId("input"), y = Fo(Fo(Fo({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": _,
          role: "combobox"
        }, d && {
          "aria-controls": this.getElementId("listbox"),
          "aria-owns": this.getElementId("listbox")
        }), !a && {
          "aria-readonly": !0
        }), this.hasValue() ? ($ == null ? void 0 : $.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return a ? /* @__PURE__ */ Ue.createElement(g, Tt({}, v, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: b,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: h,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: l,
          form: u,
          type: "text",
          value: c
        }, y)) : /* @__PURE__ */ Ue.createElement(ubc, Tt({
          id: b,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: fC,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: l,
          inputMode: "none",
          form: u,
          value: ""
        }, y));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var r = this, i = this.getComponents(), a = i.MultiValue, s = i.MultiValueContainer, c = i.MultiValueLabel, l = i.MultiValueRemove, u = i.SingleValue, d = i.Placeholder, _ = this.commonProps, p = this.props, g = p.controlShouldRenderValue, f = p.isDisabled, h = p.isMulti, $ = p.inputValue, v = p.placeholder, b = this.state, y = b.selectValue, w = b.focusedValue, N = b.isFocused;
      if (!this.hasValue() || !g)
        return $ ? null : /* @__PURE__ */ Ue.createElement(d, Tt({}, _, {
          key: "placeholder",
          isDisabled: f,
          isFocused: N,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), v);
      if (h)
        return y.map(function(q, L) {
          var R = q === w, T = "".concat(r.getOptionLabel(q), "-").concat(r.getOptionValue(q));
          return /* @__PURE__ */ Ue.createElement(a, Tt({}, _, {
            components: {
              Container: s,
              Label: c,
              Remove: l
            },
            isFocused: R,
            isDisabled: f,
            key: T,
            index: L,
            removeProps: {
              onClick: function() {
                return r.removeValue(q);
              },
              onTouchEnd: function() {
                return r.removeValue(q);
              },
              onMouseDown: function(A) {
                A.preventDefault();
              }
            },
            data: q
          }), r.formatOptionLabel(q, "value"));
        });
      if ($)
        return null;
      var M = y[0];
      return /* @__PURE__ */ Ue.createElement(u, Tt({}, _, {
        data: M,
        isDisabled: f
      }), this.formatOptionLabel(M, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var r = this.getComponents(), i = r.ClearIndicator, a = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, u = this.state.isFocused;
      if (!this.isClearable() || !i || c || !this.hasValue() || l)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Ue.createElement(i, Tt({}, a, {
        innerProps: d,
        isFocused: u
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var r = this.getComponents(), i = r.LoadingIndicator, a = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, u = this.state.isFocused;
      if (!i || !l)
        return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Ue.createElement(i, Tt({}, a, {
        innerProps: d,
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var r = this.getComponents(), i = r.DropdownIndicator, a = r.IndicatorSeparator;
      if (!i || !a)
        return null;
      var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused;
      return /* @__PURE__ */ Ue.createElement(a, Tt({}, s, {
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var r = this.getComponents(), i = r.DropdownIndicator;
      if (!i)
        return null;
      var a = this.commonProps, s = this.props.isDisabled, c = this.state.isFocused, l = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Ue.createElement(i, Tt({}, a, {
        innerProps: l,
        isDisabled: s,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var r = this, i = this.getComponents(), a = i.Group, s = i.GroupHeading, c = i.Menu, l = i.MenuList, u = i.MenuPortal, d = i.LoadingMessage, _ = i.NoOptionsMessage, p = i.Option, g = this.commonProps, f = this.state.focusedOption, h = this.props, $ = h.captureMenuScroll, v = h.inputValue, b = h.isLoading, y = h.loadingMessage, w = h.minMenuHeight, N = h.maxMenuHeight, M = h.menuIsOpen, q = h.menuPlacement, L = h.menuPosition, R = h.menuPortalTarget, T = h.menuShouldBlockScroll, D = h.menuShouldScrollIntoView, A = h.noOptionsMessage, S = h.onMenuScrollToTop, E = h.onMenuScrollToBottom;
      if (!M)
        return null;
      var x = function(V, U) {
        var H = V.type, J = V.data, le = V.isDisabled, ae = V.isSelected, Y = V.label, re = V.value, ie = f === J, _e = le ? void 0 : function() {
          return r.onOptionHover(J);
        }, he = le ? void 0 : function() {
          return r.selectOption(J);
        }, be = "".concat(r.getElementId("option"), "-").concat(U), Q = {
          id: be,
          onClick: he,
          onMouseMove: _e,
          onMouseOver: _e,
          tabIndex: -1
        };
        return /* @__PURE__ */ Ue.createElement(p, Tt({}, g, {
          innerProps: Q,
          data: J,
          isDisabled: le,
          isSelected: ae,
          key: be,
          label: Y,
          type: H,
          value: re,
          isFocused: ie,
          innerRef: ie ? r.getFocusedOptionRef : void 0
        }), r.formatOptionLabel(V.data, "menu"));
      }, k;
      if (this.hasOptions())
        k = this.getCategorizedOptions().map(function(O) {
          if (O.type === "group") {
            var V = O.data, U = O.options, H = O.index, J = "".concat(r.getElementId("group"), "-").concat(H), le = "".concat(J, "-heading");
            return /* @__PURE__ */ Ue.createElement(a, Tt({}, g, {
              key: J,
              data: V,
              options: U,
              Heading: s,
              headingProps: {
                id: le,
                data: O.data
              },
              label: r.formatGroupLabel(O.data)
            }), O.options.map(function(ae) {
              return x(ae, "".concat(H, "-").concat(ae.index));
            }));
          } else if (O.type === "option")
            return x(O, "".concat(O.index));
        });
      else if (b) {
        var I = y({
          inputValue: v
        });
        if (I === null)
          return null;
        k = /* @__PURE__ */ Ue.createElement(d, g, I);
      } else {
        var z = A({
          inputValue: v
        });
        if (z === null)
          return null;
        k = /* @__PURE__ */ Ue.createElement(_, g, z);
      }
      var F = {
        minMenuHeight: w,
        maxMenuHeight: N,
        menuPlacement: q,
        menuPosition: L,
        menuShouldScrollIntoView: D
      }, P = /* @__PURE__ */ Ue.createElement(nvc, Tt({}, g, F), function(O) {
        var V = O.ref, U = O.placerProps, H = U.placement, J = U.maxHeight;
        return /* @__PURE__ */ Ue.createElement(c, Tt({}, g, F, {
          innerRef: V,
          innerProps: {
            onMouseDown: r.onMenuMouseDown,
            onMouseMove: r.onMenuMouseMove,
            id: r.getElementId("listbox")
          },
          isLoading: b,
          placement: H
        }), /* @__PURE__ */ Ue.createElement(hbc, {
          captureEnabled: $,
          onTopArrive: S,
          onBottomArrive: E,
          lockEnabled: T
        }, function(le) {
          return /* @__PURE__ */ Ue.createElement(l, Tt({}, g, {
            innerRef: function(Y) {
              r.getMenuListRef(Y), le(Y);
            },
            isLoading: b,
            maxHeight: J,
            focusedOption: f
          }), k);
        }));
      });
      return R || L === "fixed" ? /* @__PURE__ */ Ue.createElement(u, Tt({}, g, {
        appendTo: R,
        controlElement: this.controlRef,
        menuPlacement: q,
        menuPosition: L
      }), P) : P;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var r = this, i = this.props, a = i.delimiter, s = i.isDisabled, c = i.isMulti, l = i.name, u = i.required, d = this.state.selectValue;
      if (u && !this.hasValue() && !s)
        return /* @__PURE__ */ Ue.createElement(ybc, {
          name: l,
          onFocus: this.onValueInputFocus
        });
      if (!(!l || s))
        if (c)
          if (a) {
            var _ = d.map(function(f) {
              return r.getOptionValue(f);
            }).join(a);
            return /* @__PURE__ */ Ue.createElement("input", {
              name: l,
              type: "hidden",
              value: _
            });
          } else {
            var p = d.length > 0 ? d.map(function(f, h) {
              return /* @__PURE__ */ Ue.createElement("input", {
                key: "i-".concat(h),
                name: l,
                type: "hidden",
                value: r.getOptionValue(f)
              });
            }) : /* @__PURE__ */ Ue.createElement("input", {
              name: l,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ Ue.createElement("div", null, p);
          }
        else {
          var g = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ Ue.createElement("input", {
            name: l,
            type: "hidden",
            value: g
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var r = this.commonProps, i = this.state, a = i.ariaSelection, s = i.focusedOption, c = i.focusedValue, l = i.isFocused, u = i.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ Ue.createElement(ibc, Tt({}, r, {
        id: this.getElementId("live-region"),
        ariaSelection: a,
        focusedOption: s,
        focusedValue: c,
        isFocused: l,
        selectValue: u,
        focusableOptions: d
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.getComponents(), i = r.Control, a = r.IndicatorsContainer, s = r.SelectContainer, c = r.ValueContainer, l = this.props, u = l.className, d = l.id, _ = l.isDisabled, p = l.menuIsOpen, g = this.state.isFocused, f = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ Ue.createElement(s, Tt({}, f, {
        className: u,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: _,
        isFocused: g
      }), this.renderLiveRegion(), /* @__PURE__ */ Ue.createElement(i, Tt({}, f, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: _,
        isFocused: g,
        menuIsOpen: p
      }), /* @__PURE__ */ Ue.createElement(c, Tt({}, f, {
        isDisabled: _
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ Ue.createElement(a, Tt({}, f, {
        isDisabled: _
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var a = i.prevProps, s = i.clearFocusValueOnUpdate, c = i.inputIsHiddenAfterUpdate, l = i.ariaSelection, u = i.isFocused, d = i.prevWasFocused, _ = r.options, p = r.value, g = r.menuIsOpen, f = r.inputValue, h = r.isMulti, $ = T7(p), v = {};
      if (a && (p !== a.value || _ !== a.options || g !== a.menuIsOpen || f !== a.inputValue)) {
        var b = g ? Nbc(r, $) : [], y = s ? zbc(i, $) : null, w = Rbc(i, b);
        v = {
          selectValue: $,
          focusedOption: w,
          focusedValue: y,
          clearFocusValueOnUpdate: !1
        };
      }
      var N = c != null && r !== a ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, M = l, q = u && d;
      return u && !q && (M = {
        value: HS(h, $, $[0] || null),
        options: $,
        action: "initial-input-focus"
      }, q = !d), (l == null ? void 0 : l.action) === "initial-input-focus" && (M = null), Fo(Fo(Fo({}, v), N), {}, {
        prevProps: r,
        ariaSelection: M,
        prevWasFocused: q
      });
    }
  }]), n;
}(mre);
Ode.defaultProps = Obc;
var Dbc = /* @__PURE__ */ Bt(function(e, t) {
  var n = ngc(e);
  return /* @__PURE__ */ Ue.createElement(Ode, Tt({
    ref: t
  }, n));
});
const Lbc = Dbc;
function Ko(e) {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ m(
    "label",
    {
      className: xe(
        "text-default text-emphasis mb-2 block text-sm font-medium leading-none",
        t
      ),
      ...n,
      children: e.children
    }
  );
}
const Mbc = ({ message: e }) => /* @__PURE__ */ de("div", { "data-testid": "field-error", className: "text-error mt-2 flex items-center gap-x-2 text-sm", children: [
  /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(qt, { name: "info", className: "h-3 w-3" }) }),
  /* @__PURE__ */ m("p", { children: e })
] });
function Fbc({
  hintErrors: e,
  fieldName: t,
  t: n
}) {
  const o = No();
  if (!o)
    return null;
  const { formState: r } = o, i = r.errors[t];
  return !e && i && !i.message ? /* @__PURE__ */ m("div", { className: "text-gray text-default mt-2 flex items-center text-sm", children: /* @__PURE__ */ m("ul", { className: "ml-2", children: Object.keys(i).map((a) => /* @__PURE__ */ m("li", { className: "text-blue-700", children: n(`${t}_hint_${a}`) }, a)) }) }) : e && i ? /* @__PURE__ */ m("div", { className: "text-gray text-default mt-2 flex items-center text-sm", children: /* @__PURE__ */ m("ul", { className: "ml-2", children: e.map((a) => {
    const s = r.isSubmitted, c = i[a] || i.message;
    return /* @__PURE__ */ de(
      "li",
      {
        "data-testid": "hint-error",
        className: c !== void 0 ? s ? "text-error" : "" : "text-green-600",
        children: [
          c !== void 0 ? s ? /* @__PURE__ */ m(
            qt,
            {
              name: "x",
              size: "12",
              strokeWidth: "3",
              className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
            }
          ) : /* @__PURE__ */ m(
            qt,
            {
              name: "circle",
              fill: "currentColor",
              size: "5",
              className: "inline-block ltr:mr-2 rtl:ml-2"
            }
          ) : /* @__PURE__ */ m(
            qt,
            {
              name: "check",
              size: "12",
              strokeWidth: "3",
              className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
            }
          ),
          n(`${t}_hint_${a}`)
        ]
      },
      a
    );
  }) }) }) : i ? /* @__PURE__ */ m(Mbc, { message: i.message }) : e ? /* @__PURE__ */ m("div", { className: "text-gray text-default mt-2 flex items-center text-sm", children: /* @__PURE__ */ m("ul", { className: "ml-2", children: e.map((a) => {
    const s = r.dirtyFields[t];
    return /* @__PURE__ */ de("li", { className: s ? "text-green-600" : "", children: [
      s ? /* @__PURE__ */ m(
        qt,
        {
          name: "check",
          size: "12",
          strokeWidth: "3",
          className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
        }
      ) : /* @__PURE__ */ m(qt, { name: "circle", fill: "currentColor", size: "5", className: "inline-block ltr:mr-2 rtl:ml-2" }),
      n(`${t}_hint_${a}`)
    ] }, a);
  }) }) }) : null;
}
const G0 = Vy(
  [
    // Base styles
    "rounded-[10px] border",
    "leading-none font-normal",
    // Colors
    "bg-default",
    "border-default",
    "text-default",
    "placeholder:text-muted",
    // States
    "hover:border-emphasis",
    "focus:ring-0",
    "focus:shadow-outline-gray-focused",
    // Disabled state
    "disabled:bg-subtle",
    "disabled:hover:border-default",
    "disabled:cursor-not-allowed",
    // Shadow
    "shadow-outline-gray-rested",
    // Transitions
    "transition"
  ],
  {
    variants: {
      size: {
        sm: "h-7 px-2 py-1 text-xs",
        md: "h-8 px-3 py-2 text-sm"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), Iu = Bt(function({ isFullWidth: t = !0, size: n = "md", className: o, ...r }, i) {
  return /* @__PURE__ */ m(
    "input",
    {
      ...r,
      ref: i,
      className: xe(G0({ size: n }), t && "w-full", o)
    }
  );
}), U7 = ({
  children: e,
  className: t,
  error: n,
  onClickAddon: o,
  size: r = "md",
  position: i = "start"
}) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o && o,
    className: xe(
      "flex flex-shrink-0 items-center justify-center whitespace-nowrap",
      o && "pointer-events-auto cursor-pointer disabled:hover:cursor-not-allowed",
      t
    ),
    children: /* @__PURE__ */ m(
      "span",
      {
        className: xe(
          "text-sm font-medium leading-none",
          n ? "text-error" : "text-muted peer-disabled:opacity-50"
        ),
        children: e
      }
    )
  }
), Da = Bt(function(t, n) {
  const o = I0(), { t: r, isLocaleReady: i, i18n: a } = kt(), s = t.t || r, c = t.name || "", {
    label: l = s(c),
    labelProps: u,
    labelClassName: d,
    disabled: _,
    LockedIcon: p,
    placeholder: g = i && a.exists(`${c}_placeholder`) ? s(`${c}_placeholder`) : "",
    className: f,
    addOnLeading: h,
    addOnSuffix: $,
    addOnClassname: v,
    inputIsFullWidth: b,
    hint: y,
    type: w,
    hintErrors: N,
    labelSrOnly: M,
    noLabel: q,
    containerClassName: L,
    readOnly: R,
    showAsteriskIndicator: T,
    onClickAddon: D,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    t: A,
    dataTestid: S,
    size: E,
    ...x
  } = t, [k, I] = it("");
  return /* @__PURE__ */ de("div", { className: xe(L), children: [
    !!c && !q && /* @__PURE__ */ de(
      Ko,
      {
        htmlFor: o,
        ...u,
        className: xe(d, M && "sr-only", t.error && "text-error"),
        children: [
          l,
          T && !R && x.required ? /* @__PURE__ */ m("span", { className: "text-default ml-1 font-medium", children: "*" }) : null,
          p
        ]
      }
    ),
    h || $ ? /* @__PURE__ */ de(
      "div",
      {
        dir: "ltr",
        className: xe(
          G0({ size: E }),
          "group relative mb-1 flex min-w-0 items-center gap-1",
          "[&:focus-within]:border-subtle [&:focus-within]:ring-brand-default [&:focus-within]:ring-2",
          "[&:has(:disabled)]:bg-subtle [&:has(:disabled)]:hover:border-default [&:has(:disabled)]:cursor-not-allowed",
          b && "w-full"
        ),
        children: [
          h && /* @__PURE__ */ m(U7, { size: E ?? "md", position: "start", className: xe(v), children: h }),
          /* @__PURE__ */ m(
            "input",
            {
              "data-testid": S ? `${S}-input` : "input-field",
              id: o,
              type: w,
              placeholder: g,
              className: xe(
                "w-full min-w-0 truncate border-0 bg-transparent focus:outline-none focus:ring-0",
                "text-default rounded-lg text-sm font-medium leading-none",
                "placeholder:text-muted disabled:cursor-not-allowed disabled:bg-transparent",
                h && "rounded-none pl-0.5 pr-0",
                $ && "pl-0",
                f
              ),
              ...x,
              ...w == "search" && {
                onChange: (z) => {
                  I(z.target.value), t.onChange && t.onChange(z);
                },
                value: k
              },
              disabled: R || _,
              ref: n
            }
          ),
          $ && /* @__PURE__ */ m(
            U7,
            {
              size: E ?? "md",
              position: "end",
              onClickAddon: D,
              className: xe(v),
              children: $
            }
          ),
          w === "search" && (k == null ? void 0 : k.toString().length) > 0 && /* @__PURE__ */ m(
            qt,
            {
              name: "x",
              className: "text-subtle absolute top-2.5 h-4 w-4 cursor-pointer ltr:right-2 rtl:left-2",
              onClick: (z) => {
                I(""), t.onChange && t.onChange(z);
              }
            }
          )
        ]
      }
    ) : /* @__PURE__ */ m(
      Iu,
      {
        id: o,
        type: w,
        placeholder: g,
        size: E,
        className: xe(
          f,
          w === "email" && "focus:border-subtle focus:ring-brand-default focus:ring-2",
          "disabled:bg-subtle disabled:hover:border-subtle disabled:cursor-not-allowed"
        ),
        ...x,
        readOnly: R,
        ref: n,
        isFullWidth: b,
        disabled: R || _
      }
    ),
    /* @__PURE__ */ m(Fbc, { hintErrors: N, fieldName: c, t: s }),
    y && /* @__PURE__ */ m("div", { className: "text-default mt-2 flex items-center text-sm", children: y })
  ] });
}), xr = Bt(function(t, n) {
  return /* @__PURE__ */ m(Da, { ref: n, ...t });
}), qbc = Vy("font-medium inline-flex items-center justify-center rounded gap-x-1", {
  variants: {
    variant: {
      default: "bg-attention text-attention",
      warning: "bg-attention text-attention",
      orange: "bg-attention text-attention",
      success: "bg-success text-success",
      green: "bg-success text-success",
      gray: "bg-emphasis text-emphasis",
      blue: "bg-info text-info",
      red: "bg-error text-error",
      error: "bg-error text-error",
      grayWithoutHover: "bg-gray-100 text-gray-800 dark:bg-darkgray-200 dark:text-darkgray-800",
      purple: "bg-purple-50 text-purple-800"
    },
    size: {
      sm: "px-1 py-1 text-[10px] leading-none",
      md: "py-1 px-1.5 text-xs leading-none",
      lg: "py-1 px-1.5 text-sm leading-none rounded-lg"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
}), Wi = function(t) {
  const {
    customStartIcon: n,
    variant: o,
    className: r,
    size: i,
    startIcon: a,
    withDot: s,
    children: c,
    rounded: l,
    customDot: u,
    ...d
  } = t, _ = "onClick" in d && d.onClick !== void 0, p = a, g = xe(
    qbc({ variant: o, size: i }),
    l && "h-5 w-5 rounded-full p-0",
    r
  ), f = () => /* @__PURE__ */ de(nt, { children: [
    s ? /* @__PURE__ */ m("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "currentColor", "data-testid": "go-primitive-dot", children: /* @__PURE__ */ m("circle", { cx: "4", cy: "4", r: "4" }) }) : null,
    n || (p ? /* @__PURE__ */ m(
      qt,
      {
        name: p,
        "data-testid": "start-icon",
        className: "stroke-[3px]",
        style: { width: 12, height: 12 }
      }
    ) : null),
    c
  ] }), h = _ ? "button" : "div";
  return Fe.createElement(h, { ...d, className: g }, /* @__PURE__ */ m(f, {}));
};
function jbc(e) {
  return typeof e == "object" && !Array.isArray(e);
}
const Vbc = (e, t) => jbc(e == null ? void 0 : e.metadata) && !!(e != null && e.metadata) && t in e.metadata, Bbc = Vbc;
function Ubc() {
  if (Sf)
    return { isPending: !1, hasPaidPlan: !0 };
  const { data: e, isPending: t } = hr.viewer.teams.hasTeamPlan.useQuery(), { data: n, isPending: o } = hr.viewer.me.get.useQuery(), r = t || o, i = n && Bbc(n, "isPremium") ? !!n.metadata.isPremium : !1, a = (e == null ? void 0 : e.hasTeamPlan) || i;
  return { isPending: r, hasPaidPlan: a, plan: e == null ? void 0 : e.plan };
}
function Gbc() {
  const e = hr.viewer.teams.listInvites.useQuery();
  return { isPending: e.isPending, listInvites: e.data };
}
function rsu() {
  const { data: e, isPending: t } = hr.viewer.teams.hasTeamPlan.useQuery();
  return { isPending: t, hasTeamPlan: e == null ? void 0 : e.hasTeamPlan };
}
function Wbc() {
  if (Sf)
    return { isPending: !1, hasActiveTeamPlan: !0, isTrial: !1 };
  const { data: e, isPending: t } = hr.viewer.teams.hasActiveTeamPlan.useQuery();
  return { isPending: t, hasActiveTeamPlan: !!(e != null && e.isActive), isTrial: !!(e != null && e.isTrial) };
}
function Hbc() {
  if (Sf)
    return { isPending: !1, hasActiveTeamPlan: !0, isTrial: !1 };
  const { data: e, isPending: t } = hr.viewer.teams.hasActiveTeamPlan.useQuery({ ownerOnly: !0 });
  return { isPending: t, hasActiveTeamPlan: !!(e != null && e.isActive), isTrial: !!(e != null && e.isTrial) };
}
const xh = function({
  checkForActiveStatus: t
}) {
  const { t: n } = kt(), { hasPaidPlan: o } = Ubc(), { hasActiveTeamPlan: r, isTrial: i } = Wbc();
  if (o && (!t || r))
    return null;
  const a = n(i ? "trial_mode" : o ? "inactive_team_plan" : "upgrade"), s = n(i ? "limited_access_trial_mode" : o ? "inactive_team_plan_description" : "upgrade_to_enable_feature");
  return /* @__PURE__ */ m(Sr, { content: s, children: /* @__PURE__ */ m(Ir, { href: o ? "" : "/teams", children: /* @__PURE__ */ m(Wi, { variant: "gray", children: a }) }) });
}, Ybc = function({
  teamId: t,
  isOrganization: n = !1
}) {
  const { t: o } = kt(), r = () => t ? n ? "/settings/organizations/billing" : `/settings/teams/${t}/billing` : "/settings/billing";
  return /* @__PURE__ */ m(Sr, { content: o("requires_credits_tooltip"), children: /* @__PURE__ */ m(Ir, { href: r(), children: /* @__PURE__ */ m(Wi, { variant: "gray", className: "whitespace-nowrap", children: o("requires_credits") }) }) });
};
function vC({ content: e }) {
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(Sr, { side: "top", content: e, children: /* @__PURE__ */ m("span", { title: e, children: /* @__PURE__ */ m(qt, { name: "info", className: "text-subtle relative left-1 right-1 top-px mt-px h-4 w-4" }) }) }) });
}
const Kbc = ({
  inputClassName: e,
  ...t
}) => /* @__PURE__ */ m(
  F_.Input,
  {
    inputClassName: xe(
      "focus:ring-0 focus:ring-offset-0 !text-default dark:!text-white",
      e
    ),
    ...t
  }
), Zbc = ({
  ...e
}) => (
  // This gets styled in the select classNames prop now - handles overrides with styles vs className here doesn't
  /* @__PURE__ */ m(F_.Option, { ...e, children: /* @__PURE__ */ de("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ de("span", { className: "w-full", "data-testid": `select-option-${e.value}`, children: [
      e.data.isCalAi ? /* @__PURE__ */ m(Wi, { startIcon: "sparkles", variant: "purple", className: "mr-1 hidden md:inline-flex", children: "Cal.ai" }) : /* @__PURE__ */ m(nt, {}),
      e.label || /* @__PURE__ */ m(nt, { children: " " })
    ] }),
    e.data.needsTeamsUpgrade ? /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 }) : e.data.needsCredits ? /* @__PURE__ */ m(
      Ybc,
      {
        teamId: e.data.creditsTeamId,
        isOrganization: e.data.isOrganization
      }
    ) : /* @__PURE__ */ m(nt, {}),
    e.isSelected && /* @__PURE__ */ m(qt, { name: "check", className: "ml-2 h-4 w-4" })
  ] }) })
), Xbc = (e) => {
  const t = e.selectProps["data-testid"] ?? "select-control";
  return /* @__PURE__ */ m("span", { "data-testid": t, children: /* @__PURE__ */ m(F_.Control, { ...e }) });
}, Nde = ({
  components: e,
  menuPlacement: t = "auto"
}) => ({
  menuPlacement: t,
  components: {
    Input: Kbc,
    Option: Zbc,
    Control: Xbc,
    ...e
  },
  unstyled: !0
}), Di = ({
  components: e,
  variant: t = "default",
  size: n = "md",
  grow: o = !0,
  ...r
}) => {
  const { classNames: i, innerClassNames: a, menuPlacement: s = "auto", ...c } = r, l = Ue.useMemo(() => Nde({
    components: e || {},
    menuPlacement: s
  }), [e, s]), u = r.isMulti || r.isLoading || r.isClearable;
  return /* @__PURE__ */ m(
    Lbc,
    {
      ...l,
      menuPlacement: s,
      styles: {
        control: (d) => ({
          ...d,
          minHeight: n === "sm" ? "28px" : "32px",
          height: o ? "auto" : n === "sm" ? "28px" : "32px"
        })
      },
      classNames: {
        input: () => xe("text-emphasis", a == null ? void 0 : a.input),
        option: (d) => xe(
          "bg-default flex cursor-pointer justify-between py-1.5 px-2 rounded-md text-default items-center",
          d.isFocused && "bg-subtle",
          d.isDisabled && "bg-muted",
          d.isSelected && "bg-emphasis text-default",
          a == null ? void 0 : a.option
        ),
        placeholder: (d) => xe("text-muted", d.isFocused && t !== "checkbox" && "hidden"),
        dropdownIndicator: () => xe("text-default", "w-4 h-4", "flex items-center justify-center "),
        control: (d) => xe(
          G0({ size: n }),
          d.isMulti ? t === "checkbox" ? "px-3 h-fit" : d.hasValue ? "p-1 h-fit" : "px-3 h-fit" : n === "sm" ? "h-7 px-2 py-1" : "h-8 px-3 py-2",
          r.isDisabled && "bg-subtle",
          "rounded-[10px]",
          "[&:focus-within]:border-emphasis [&:focus-within]:shadow-outline-gray-focused [&:focus-within]:ring-0 !flex",
          a == null ? void 0 : a.control
        ),
        singleValue: () => xe("text-default placeholder:text-muted", a == null ? void 0 : a.singleValue),
        valueContainer: () => xe("text-default placeholder:text-muted flex gap-1", a == null ? void 0 : a.valueContainer),
        multiValue: () => xe(
          "font-medium inline-flex items-center justify-center rounded bg-emphasis text-emphasis leading-none text-xs",
          n == "sm" ? "px-1.5 py-[1px] rounded-md" : "py-1 px-1.5 leading-none rounded-lg"
        ),
        menu: () => xe(
          "rounded-lg bg-default text-sm leading-4 text-default mt-1 border border-subtle shadow-dropdown p-1",
          a == null ? void 0 : a.menu
        ),
        groupHeading: () => "leading-none text-xs text-muted p-2 font-medium ml-1",
        menuList: () => xe(
          "scroll-bar scrollbar-track-w-20 rounded-md flex flex-col space-y-[1px]",
          a == null ? void 0 : a.menuList
        ),
        indicatorsContainer: (d) => xe(
          "flex !items-start justify-center mt-0.5 h-full",
          d.selectProps.menuIsOpen ? u ? "[&>*:last-child]:rotate-180 [&>*:last-child]:transition-transform [&>*:last-child]:w-4 [&>*:last-child]:h-4" : "rotate-180 transition-transform w-4 h-4" : u ? "[&>*:last-child]:w-4 [&>*:last-child]:h-4 text-default" : "w-4 h-4 text-default"
        ),
        multiValueRemove: () => "text-default py-auto",
        ...i
      },
      ...c
    }
  );
}, iq = function(t) {
  var l;
  const { t: n } = kt(), { label: o = n(t.name || ""), containerClassName: r, labelProps: i, className: a, ...s } = t, c = Pu();
  return /* @__PURE__ */ de("div", { className: xe(r), children: [
    /* @__PURE__ */ m("div", { className: xe(a), children: !!o && /* @__PURE__ */ m(
      Ko,
      {
        htmlFor: c,
        ...i,
        className: xe(t.error && "text-error", (l = t.labelProps) == null ? void 0 : l.className),
        children: o
      }
    ) }),
    /* @__PURE__ */ m(Di, { ...s })
  ] });
};
function isu({
  required: e = !1,
  onChange: t,
  value: n,
  ...o
}) {
  const [r, i] = Ue.useState(() => n instanceof Array || !n ? "" : n.value || ""), a = Ue.useCallback((s) => {
    let c = "";
    s instanceof Array ? c = s.map((l) => l.value).join(",") : c = (s == null ? void 0 : s.value) || "", i(c);
  }, []);
  return Ue.useEffect(() => {
    n && a(n);
  }, [n, a]), /* @__PURE__ */ de("div", { className: xe("relative", o.className), children: [
    /* @__PURE__ */ m(
      Di,
      {
        value: n,
        ...o,
        onChange: (s, ...c) => {
          a(s), t && t(s, ...c);
        }
      }
    ),
    e && /* @__PURE__ */ m(
      "input",
      {
        tabIndex: -1,
        autoComplete: "off",
        style: {
          opacity: 0,
          width: "100%",
          height: 1,
          position: "absolute"
        },
        value: r,
        onChange: () => {
        },
        required: e
      }
    )
  ] });
}
var zde = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];
        if (i) {
          var a = typeof i;
          if (a === "string" || a === "number")
            o.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var s = n.apply(null, i);
              s && o.push(s);
            }
          } else if (a === "object")
            if (i.toString === Object.prototype.toString)
              for (var c in i)
                t.call(i, c) && i[c] && o.push(c);
            else
              o.push(i.toString());
        }
      }
      return o.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(zde);
var jg = zde.exports;
const Ia = /* @__PURE__ */ Mi(jg), Jbc = Vy("rounded-[10px] p-3", {
  variants: {
    severity: {
      neutral: "bg-default border-subtle border-[1px] text-default",
      info: "bg-semantic-info-subtle text-semantic-info",
      warning: "bg-semantic-attention-subtle text-semantic-attention",
      error: "bg-semantic-error-subtle text-semantic-error"
    }
  },
  defaultVariants: {
    severity: "neutral"
  }
}), Us = Bt((e, t) => {
  const { severity: n, iconClassName: o, CustomIcon: r, customIconColor: i } = e;
  return /* @__PURE__ */ m("div", { "data-testid": "alert", ref: t, className: Jbc({ severity: n, className: e.className }), children: /* @__PURE__ */ de("div", { className: "relative flex md:flex-row", children: [
    r ? /* @__PURE__ */ m("div", { className: "flex-shrink-0", children: /* @__PURE__ */ m(
      qt,
      {
        name: r,
        "data-testid": "custom-icon",
        "aria-hidden": "true",
        className: Ia("h4 mr-2 w-4", o, i ?? "text-default")
      }
    ) }) : /* @__PURE__ */ de("div", { className: Ia("mr-2 flex-shrink-0", e.title ? "" : "mt-0.5"), children: [
      n === "error" && /* @__PURE__ */ m(
        qt,
        {
          name: "circle-x",
          "data-testid": "circle-x",
          className: Ia("h4 w-4", o),
          "aria-hidden": "true"
        }
      ),
      n === "warning" && /* @__PURE__ */ m(
        qt,
        {
          name: "triangle-alert",
          "data-testid": "alert-triangle",
          className: Ia("h4 w-4", o),
          "aria-hidden": "true"
        }
      ),
      n === "info" && /* @__PURE__ */ m(
        qt,
        {
          name: "info",
          "data-testid": "info",
          className: Ia("h4 w-4", o),
          "aria-hidden": "true"
        }
      ),
      n === "neutral" && /* @__PURE__ */ m(
        qt,
        {
          name: "info",
          "data-testid": "neutral",
          className: Ia("text-default h4 w-4 fill-transparent", o),
          "aria-hidden": "true"
        }
      )
    ] }),
    /* @__PURE__ */ de("div", { className: "flex flex-grow flex-col sm:flex-row", children: [
      /* @__PURE__ */ de("div", { className: "space-y-1 ltr:ml-3 rtl:mr-3", children: [
        e.title && /* @__PURE__ */ m("h3", { className: "text-sm font-medium leading-none", children: e.title }),
        e.message && /* @__PURE__ */ m("div", { className: "text-sm leading-5", children: e.message })
      ] }),
      e.actions && /* @__PURE__ */ m("div", { className: "ml-auto mt-auto text-sm sm:mt-0 md:relative", children: e.actions })
    ] })
  ] }) });
});
Us.displayName = "Alert";
const Qbc = Bt(function(t, n) {
  const { t: o } = kt(), [r, i] = it(!1), a = Yt(
    () => i(!r),
    [r, i]
  ), s = o(r ? "hide_password" : "show_password");
  return /* @__PURE__ */ m(
    Da,
    {
      type: r ? "text" : "password",
      placeholder: t.placeholder || "•••••••••••••",
      ref: n,
      ...t,
      className: xe(
        "addon-wrapper mb-0 ltr:border-r-0 ltr:pr-10 rtl:border-l-0 rtl:pl-10",
        t.className
      ),
      addOnSuffix: /* @__PURE__ */ m(Sr, { content: s, children: /* @__PURE__ */ de(
        "button",
        {
          className: "text-emphasis h-9",
          tabIndex: -1,
          type: "button",
          onClick: () => a(),
          children: [
            r ? /* @__PURE__ */ m(qt, { name: "eye-off", className: "h-4 w-4 stroke-[2.5px]" }) : /* @__PURE__ */ m(qt, { name: "eye", className: "h-4 w-4 stroke-[2.5px]" }),
            /* @__PURE__ */ m("span", { className: "sr-only", children: s })
          ]
        }
      ) })
    }
  );
});
Bt(function(t, n) {
  return /* @__PURE__ */ m(
    Iu,
    {
      ref: n,
      type: "email",
      autoCapitalize: "none",
      autoComplete: "email",
      autoCorrect: "off",
      inputMode: "email",
      ...t
    }
  );
});
const Rde = Bt(function(t, n) {
  return /* @__PURE__ */ m(
    Da,
    {
      ref: n,
      type: "email",
      autoCapitalize: "none",
      autoComplete: "email",
      autoCorrect: "off",
      inputMode: "email",
      ...t
    }
  );
}), Kw = Bt(function(t, n) {
  return /* @__PURE__ */ m(
    "textarea",
    {
      ...t,
      ref: n,
      className: xe(G0(), "min-h-[80px] w-full", t.className)
    }
  );
}), Pde = Bt(function(t, n) {
  var d, _, p;
  const o = I0(), { t: r } = kt(), i = t.t || r, a = No(), {
    label: s = i(t.name),
    labelProps: c,
    /** Prevents displaying untranslated placeholder keys */
    placeholder: l = i(`${t.name}_placeholder`) !== `${t.name}_placeholder` ? `${t.name}_placeholder` : "",
    ...u
  } = t;
  return /* @__PURE__ */ de("div", { children: [
    !!t.name && /* @__PURE__ */ m(Ko, { htmlFor: o, ...c, children: s }),
    /* @__PURE__ */ m(Kw, { ref: n, placeholder: l, ...u }),
    ((_ = (d = a == null ? void 0 : a.formState) == null ? void 0 : d.errors[t.name]) == null ? void 0 : _.message) && /* @__PURE__ */ m(
      Us,
      {
        className: "mt-1",
        severity: "error",
        message: /* @__PURE__ */ m(nt, { children: (p = a.formState.errors[t.name]) == null ? void 0 : p.message })
      }
    )
  ] });
}), eyc = Bt(function(t, n) {
  return /* @__PURE__ */ m(
    Iu,
    {
      ref: n,
      type: "number",
      autoCapitalize: "none",
      autoComplete: "numeric",
      autoCorrect: "off",
      inputMode: "numeric",
      ...t
    }
  );
});
Bt(function(t, n) {
  return /* @__PURE__ */ m(
    Da,
    {
      ref: n,
      addOnLeading: /* @__PURE__ */ m(qt, { name: "search", className: "h-4 w-4 stroke-[2.5px]", "data-testid": "search-icon" }),
      placeholder: "Search",
      containerClassName: "mx-3 mt-2",
      ...t
    }
  );
});
const Dde = /* @__PURE__ */ new Set(), Jl = /* @__PURE__ */ new WeakMap(), Yb = /* @__PURE__ */ new WeakMap(), hv = /* @__PURE__ */ new WeakMap(), F4 = /* @__PURE__ */ new WeakMap(), tyc = /* @__PURE__ */ new WeakMap(), Ay = /* @__PURE__ */ new WeakMap(), bC = /* @__PURE__ */ new WeakMap(), Aw = /* @__PURE__ */ new WeakSet();
let Dg;
const of = "__aa_tgt", q4 = "__aa_del", nyc = (e) => {
  const t = syc(e);
  t && t.forEach((n) => cyc(n));
}, oyc = (e) => {
  e.forEach((t) => {
    t.target === Dg && iyc(), Jl.has(t.target) && Av(t.target);
  });
};
function ryc(e) {
  const t = F4.get(e);
  t == null || t.disconnect();
  let n = Jl.get(e), o = 0;
  const r = 5;
  n || (n = Iy(e), Jl.set(e, n));
  const { offsetWidth: i, offsetHeight: a } = Dg, c = [
    n.top - r,
    i - (n.left + r + n.width),
    a - (n.top + r + n.height),
    n.left - r
  ].map((u) => `${-1 * Math.floor(u)}px`).join(" "), l = new IntersectionObserver(() => {
    ++o > 1 && Av(e);
  }, {
    root: Dg,
    threshold: 1,
    rootMargin: c
  });
  l.observe(e), F4.set(e, l);
}
function Av(e) {
  clearTimeout(bC.get(e));
  const t = iA(e), n = typeof t == "function" ? 500 : t.duration;
  bC.set(e, setTimeout(async () => {
    const o = hv.get(e);
    (!o || await o.finished) && (Jl.set(e, Iy(e)), ryc(e));
  }, n));
}
function iyc() {
  clearTimeout(bC.get(Dg)), bC.set(Dg, setTimeout(() => {
    Dde.forEach((e) => qde(e, (t) => Lde(() => Av(t))));
  }, 100));
}
function ayc(e) {
  setTimeout(() => {
    tyc.set(e, setInterval(() => Lde(Av.bind(null, e)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function Lde(e) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => e()) : requestAnimationFrame(() => e());
}
let j4, Tb;
typeof window < "u" && (Dg = document.documentElement, j4 = new MutationObserver(nyc), Tb = new ResizeObserver(oyc), Tb.observe(Dg));
function syc(e) {
  return e.reduce((o, r) => [
    ...o,
    ...Array.from(r.addedNodes),
    ...Array.from(r.removedNodes)
  ], []).every((o) => o.nodeName === "#comment") ? !1 : e.reduce((o, r) => {
    if (o === !1)
      return !1;
    if (r.target instanceof Element) {
      if (HN(r.target), !o.has(r.target)) {
        o.add(r.target);
        for (let i = 0; i < r.target.children.length; i++) {
          const a = r.target.children.item(i);
          if (a) {
            if (q4 in a)
              return !1;
            HN(r.target, a), o.add(a);
          }
        }
      }
      if (r.removedNodes.length)
        for (let i = 0; i < r.removedNodes.length; i++) {
          const a = r.removedNodes[i];
          if (q4 in a)
            return !1;
          a instanceof Element && (o.add(a), HN(r.target, a), Yb.set(a, [
            r.previousSibling,
            r.nextSibling
          ]));
        }
    }
    return o;
  }, /* @__PURE__ */ new Set());
}
function HN(e, t) {
  !t && !(of in e) ? Object.defineProperty(e, of, { value: e }) : t && !(of in t) && Object.defineProperty(t, of, { value: e });
}
function cyc(e) {
  var t;
  const n = Dg.contains(e), o = Jl.has(e);
  n && Yb.has(e) && Yb.delete(e), hv.has(e) && ((t = hv.get(e)) === null || t === void 0 || t.cancel()), o && n ? lyc(e) : o && !n ? dyc(e) : uyc(e);
}
function Sp(e) {
  return Number(e.replace(/[^0-9.\-]/g, ""));
}
function Iy(e) {
  const t = e.getBoundingClientRect();
  return {
    top: t.top + window.scrollY,
    left: t.left + window.scrollX,
    width: t.width,
    height: t.height
  };
}
function Mde(e, t, n) {
  let o = t.width, r = t.height, i = n.width, a = n.height;
  const s = getComputedStyle(e);
  if (s.getPropertyValue("box-sizing") === "content-box") {
    const l = Sp(s.paddingTop) + Sp(s.paddingBottom) + Sp(s.borderTopWidth) + Sp(s.borderBottomWidth), u = Sp(s.paddingLeft) + Sp(s.paddingRight) + Sp(s.borderRightWidth) + Sp(s.borderLeftWidth);
    o -= u, i -= u, r -= l, a -= l;
  }
  return [o, i, r, a].map(Math.round);
}
function iA(e) {
  return of in e && Ay.has(e[of]) ? Ay.get(e[of]) : { duration: 250, easing: "ease-in-out" };
}
function Fde(e) {
  if (of in e)
    return e[of];
}
function aq(e) {
  const t = Fde(e);
  return t ? Aw.has(t) : !1;
}
function qde(e, ...t) {
  t.forEach((n) => n(e, Ay.has(e)));
  for (let n = 0; n < e.children.length; n++) {
    const o = e.children.item(n);
    o && t.forEach((r) => r(o, Ay.has(o)));
  }
}
function lyc(e) {
  const t = Jl.get(e), n = Iy(e);
  if (!aq(e))
    return Jl.set(e, n);
  let o;
  if (!t)
    return;
  const r = iA(e);
  if (typeof r != "function") {
    const i = t.left - n.left, a = t.top - n.top, [s, c, l, u] = Mde(e, t, n), d = {
      transform: `translate(${i}px, ${a}px)`
    }, _ = {
      transform: "translate(0, 0)"
    };
    s !== c && (d.width = `${s}px`, _.width = `${c}px`), l !== u && (d.height = `${l}px`, _.height = `${u}px`), o = e.animate([d, _], {
      duration: r.duration,
      easing: r.easing
    });
  } else
    o = new Animation(r(e, "remain", t, n)), o.play();
  hv.set(e, o), Jl.set(e, n), o.addEventListener("finish", Av.bind(null, e));
}
function uyc(e) {
  const t = Iy(e);
  Jl.set(e, t);
  const n = iA(e);
  if (!aq(e))
    return;
  let o;
  typeof n != "function" ? o = e.animate([
    { transform: "scale(.98)", opacity: 0 },
    { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
    { transform: "scale(1)", opacity: 1 }
  ], {
    duration: n.duration * 1.5,
    easing: "ease-in"
  }) : (o = new Animation(n(e, "add", t)), o.play()), hv.set(e, o), o.addEventListener("finish", Av.bind(null, e));
}
function dyc(e) {
  var t;
  if (!Yb.has(e) || !Jl.has(e))
    return;
  const [n, o] = Yb.get(e);
  Object.defineProperty(e, q4, { value: !0 }), o && o.parentNode && o.parentNode instanceof Element ? o.parentNode.insertBefore(e, o) : n && n.parentNode ? n.parentNode.appendChild(e) : (t = Fde(e)) === null || t === void 0 || t.appendChild(e);
  function r() {
    var _;
    e.remove(), Jl.delete(e), Yb.delete(e), hv.delete(e), (_ = F4.get(e)) === null || _ === void 0 || _.disconnect();
  }
  if (!aq(e))
    return r();
  const [i, a, s, c] = _yc(e), l = iA(e), u = Jl.get(e);
  let d;
  Object.assign(e.style, {
    position: "absolute",
    top: `${i}px`,
    left: `${a}px`,
    width: `${s}px`,
    height: `${c}px`,
    margin: 0,
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: 100
  }), typeof l != "function" ? d = e.animate([
    {
      transform: "scale(1)",
      opacity: 1
    },
    {
      transform: "scale(.98)",
      opacity: 0
    }
  ], { duration: l.duration, easing: "ease-out" }) : (d = new Animation(l(e, "remove", u)), d.play()), hv.set(e, d), d.addEventListener("finish", r);
}
function _yc(e) {
  const t = Jl.get(e), [n, , o] = Mde(e, t, Iy(e));
  let r = e.parentElement;
  for (; r && (getComputedStyle(r).position === "static" || r instanceof HTMLBodyElement); )
    r = r.parentElement;
  r || (r = document.body);
  const i = getComputedStyle(r), a = Jl.get(r) || Iy(r), s = Math.round(t.top - a.top) - Sp(i.borderTopWidth), c = Math.round(t.left - a.left) - Sp(i.borderLeftWidth);
  return [s, c, n, o];
}
function pyc(e, t = {}) {
  return j4 && Tb && (window.matchMedia("(prefers-reduced-motion: reduce)").matches && typeof t != "function" && !t.disrespectUserMotionPreference || (Aw.add(e), getComputedStyle(e).position === "static" && Object.assign(e.style, { position: "relative" }), qde(e, Av, ayc, (r) => Tb == null ? void 0 : Tb.observe(r)), typeof t == "function" ? Ay.set(e, t) : Ay.set(e, { duration: 250, easing: "ease-in-out", ...t }), j4.observe(e, { childList: !0 }), Dde.add(e))), Object.freeze({
    parent: e,
    enable: () => {
      Aw.add(e);
    },
    disable: () => {
      Aw.delete(e);
    },
    isEnabled: () => Aw.has(e)
  });
}
function qd(e) {
  const t = xt(null), [n, o] = it(), r = (i) => {
    n && (i ? n.enable() : n.disable());
  };
  return yt(() => {
    t.current instanceof HTMLElement && o(pyc(t.current, e || {}));
  }, []), [t, r];
}
var jde = /* @__PURE__ */ ((e) => (e.PaymentCreationFailure = "payment_not_created_error", e.NoAvailableUsersFound = "no_available_users_found_error", e.ChargeCardFailure = "couldnt_charge_card_error", e.RequestBodyWithouEnd = "request_body_end_time_internal_error", e.AlreadySignedUpForBooking = "already_signed_up_for_this_booking_error", e.FixedHostsUnavailableForBooking = "fixed_hosts_unavailable_for_booking", e.RoundRobinHostsUnavailableForBooking = "round_robin_host_unavailable_for_booking", e.EventTypeNotFound = "event_type_not_found_error", e.BookingNotFound = "booking_not_found_error", e.BookingSeatsFull = "booking_seats_full_error", e.MissingPaymentCredential = "missing_payment_credential_error", e.MissingPaymentAppId = "missing_payment_app_id_error", e.NotEnoughAvailableSeats = "not_enough_available_seats_error", e.AvailabilityNotFoundInSchedule = "availability_not_found_in_schedule_error", e.CancelledBookingsCannotBeRescheduled = "cancelled_bookings_cannot_be_rescheduled", e.UnableToSubscribeToThePlatform = "unable_to_subscribe_to_the_platform", e.UpdatingOauthClientError = "updating_oauth_client_error", e.CreatingOauthClientError = "creating_oauth_client_error", e.BookingTimeOutOfBounds = "booking_time_out_of_bounds_error", e.BookingConflict = "booking_conflict_error", e.BookerLimitExceeded = "booker_limit_exceeded_error", e.BookerLimitExceededReschedule = "booker_limit_exceeded_error_reschedule", e.BookingNotAllowedByRestrictionSchedule = "booking_not_allowed_by_restriction_schedule_error", e.RestrictionScheduleNotFound = "restriction_schedule_not_found_error", e.EventTypeNoHosts = "event_type_no_hosts", e.RequestBodyInvalid = "request_body_invalid_error", e.PrivateLinkExpired = "private_link_expired", e.BookerEmailBlocked = "booker_email_blocked", e.BookerEmailRequiresLogin = "booker_email_requires_login", e.InvalidVerificationCode = "invalid_verification_code", e.UnableToValidateVerificationCode = "unable_to_validate_verification_code", e))(jde || {});
function myc(e) {
  return e instanceof Error ? e : typeof e == "string" ? new Error(e, { cause: e }) : new Error(`Unhandled error of type '${typeof e}''`);
}
var fyc = (e) => {
  switch (e) {
    case "success":
      return vyc;
    case "info":
      return yyc;
    case "warning":
      return byc;
    case "error":
      return $yc;
    default:
      return null;
  }
}, gyc = Array(12).fill(0), hyc = ({ visible: e, className: t }) => Fe.createElement("div", { className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "), "data-visible": e }, Fe.createElement("div", { className: "sonner-spinner" }, gyc.map((n, o) => Fe.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${o}` })))), vyc = Fe.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, Fe.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), byc = Fe.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, Fe.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), yyc = Fe.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, Fe.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), $yc = Fe.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, Fe.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), wyc = Fe.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, Fe.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), Fe.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), kyc = () => {
  let [e, t] = Fe.useState(document.hidden);
  return Fe.useEffect(() => {
    let n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
}, V4 = 1, Syc = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: n, ...o } = e, r = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : V4++, i = this.toasts.find((s) => s.id === r), a = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(r) && this.dismissedToasts.delete(r), i ? this.toasts = this.toasts.map((s) => s.id === r ? (this.publish({ ...s, ...e, id: r, title: n }), { ...s, ...e, id: r, dismissible: a, title: n }) : s) : this.addToast({ title: n, ...o, dismissible: a, id: r }), r;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((t) => {
      this.subscribers.forEach((n) => n({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t)
        return;
      let n;
      t.loading !== void 0 && (n = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let o = e instanceof Promise ? e : e(), r = n !== void 0, i, a = o.then(async (c) => {
        if (i = ["resolve", c], Fe.isValidElement(c))
          r = !1, this.create({ id: n, type: "default", message: c });
        else if (xyc(c) && !c.ok) {
          r = !1;
          let l = typeof t.error == "function" ? await t.error(`HTTP error! status: ${c.status}`) : t.error, u = typeof t.description == "function" ? await t.description(`HTTP error! status: ${c.status}`) : t.description;
          this.create({ id: n, type: "error", message: l, description: u });
        } else if (t.success !== void 0) {
          r = !1;
          let l = typeof t.success == "function" ? await t.success(c) : t.success, u = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: n, type: "success", message: l, description: u });
        }
      }).catch(async (c) => {
        if (i = ["reject", c], t.error !== void 0) {
          r = !1;
          let l = typeof t.error == "function" ? await t.error(c) : t.error, u = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: n, type: "error", message: l, description: u });
        }
      }).finally(() => {
        var c;
        r && (this.dismiss(n), n = void 0), (c = t.finally) == null || c.call(t);
      }), s = () => new Promise((c, l) => a.then(() => i[0] === "reject" ? l(i[1]) : c(i[1])).catch(l));
      return typeof n != "string" && typeof n != "number" ? { unwrap: s } : Object.assign(n, { unwrap: s });
    }, this.custom = (e, t) => {
      let n = (t == null ? void 0 : t.id) || V4++;
      return this.create({ jsx: e(n), id: n, ...t }), n;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, Ul = new Syc(), Eyc = (e, t) => {
  let n = (t == null ? void 0 : t.id) || V4++;
  return Ul.addToast({ title: e, ...t, id: n }), n;
}, xyc = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", Cyc = Eyc, Tyc = () => Ul.toasts, Ayc = () => Ul.getActiveToasts(), G7 = Object.assign(Cyc, { success: Ul.success, info: Ul.info, warning: Ul.warning, error: Ul.error, custom: Ul.custom, message: Ul.message, promise: Ul.promise, dismiss: Ul.dismiss, loading: Ul.loading }, { getHistory: Tyc, getToasts: Ayc });
function Iyc(e, { insertAt: t } = {}) {
  if (!e || typeof document > "u")
    return;
  let n = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
  o.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(o, n.firstChild) : n.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
}
Iyc(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function YS(e) {
  return e.label !== void 0;
}
var Oyc = 3, Nyc = "32px", zyc = "16px", W7 = 4e3, Ryc = 356, Pyc = 14, Dyc = 20, Lyc = 200;
function f_(...e) {
  return e.filter(Boolean).join(" ");
}
function Myc(e) {
  let [t, n] = e.split("-"), o = [];
  return t && o.push(t), n && o.push(n), o;
}
var Fyc = (e) => {
  var t, n, o, r, i, a, s, c, l, u, d;
  let { invert: _, toast: p, unstyled: g, interacting: f, setHeights: h, visibleToasts: $, heights: v, index: b, toasts: y, expanded: w, removeToast: N, defaultRichColors: M, closeButton: q, style: L, cancelButtonStyle: R, actionButtonStyle: T, className: D = "", descriptionClassName: A = "", duration: S, position: E, gap: x, loadingIcon: k, expandByDefault: I, classNames: z, icons: F, closeButtonAriaLabel: P = "Close toast", pauseWhenPageIsHidden: O } = e, [V, U] = Fe.useState(null), [H, J] = Fe.useState(null), [le, ae] = Fe.useState(!1), [Y, re] = Fe.useState(!1), [ie, _e] = Fe.useState(!1), [he, be] = Fe.useState(!1), [Q, me] = Fe.useState(!1), [ne, pe] = Fe.useState(0), [ge, ve] = Fe.useState(0), Te = Fe.useRef(p.duration || S || W7), Re = Fe.useRef(null), Me = Fe.useRef(null), et = b === 0, st = b + 1 <= $, De = p.type, ze = p.dismissible !== !1, Pe = p.className || "", je = p.descriptionClassName || "", He = Fe.useMemo(() => v.findIndex((Qt) => Qt.toastId === p.id) || 0, [v, p.id]), Xe = Fe.useMemo(() => {
    var Qt;
    return (Qt = p.closeButton) != null ? Qt : q;
  }, [p.closeButton, q]), at = Fe.useMemo(() => p.duration || S || W7, [p.duration, S]), wt = Fe.useRef(0), Je = Fe.useRef(0), vt = Fe.useRef(0), Ot = Fe.useRef(null), [Ft, wn] = E.split("-"), un = Fe.useMemo(() => v.reduce((Qt, fn, qn) => qn >= He ? Qt : Qt + fn.height, 0), [v, He]), pn = kyc(), Dn = p.invert || _, Rn = De === "loading";
  Je.current = Fe.useMemo(() => He * x + un, [He, un]), Fe.useEffect(() => {
    Te.current = at;
  }, [at]), Fe.useEffect(() => {
    ae(!0);
  }, []), Fe.useEffect(() => {
    let Qt = Me.current;
    if (Qt) {
      let fn = Qt.getBoundingClientRect().height;
      return ve(fn), h((qn) => [{ toastId: p.id, height: fn, position: p.position }, ...qn]), () => h((qn) => qn.filter((Xn) => Xn.toastId !== p.id));
    }
  }, [h, p.id]), Fe.useLayoutEffect(() => {
    if (!le)
      return;
    let Qt = Me.current, fn = Qt.style.height;
    Qt.style.height = "auto";
    let qn = Qt.getBoundingClientRect().height;
    Qt.style.height = fn, ve(qn), h((Xn) => Xn.find((Qn) => Qn.toastId === p.id) ? Xn.map((Qn) => Qn.toastId === p.id ? { ...Qn, height: qn } : Qn) : [{ toastId: p.id, height: qn, position: p.position }, ...Xn]);
  }, [le, p.title, p.description, h, p.id]);
  let Ln = Fe.useCallback(() => {
    re(!0), pe(Je.current), h((Qt) => Qt.filter((fn) => fn.toastId !== p.id)), setTimeout(() => {
      N(p);
    }, Lyc);
  }, [p, N, h, Je]);
  Fe.useEffect(() => {
    if (p.promise && De === "loading" || p.duration === 1 / 0 || p.type === "loading")
      return;
    let Qt;
    return w || f || O && pn ? (() => {
      if (vt.current < wt.current) {
        let fn = (/* @__PURE__ */ new Date()).getTime() - wt.current;
        Te.current = Te.current - fn;
      }
      vt.current = (/* @__PURE__ */ new Date()).getTime();
    })() : Te.current !== 1 / 0 && (wt.current = (/* @__PURE__ */ new Date()).getTime(), Qt = setTimeout(() => {
      var fn;
      (fn = p.onAutoClose) == null || fn.call(p, p), Ln();
    }, Te.current)), () => clearTimeout(Qt);
  }, [w, f, p, De, O, pn, Ln]), Fe.useEffect(() => {
    p.delete && Ln();
  }, [Ln, p.delete]);
  function Yn() {
    var Qt, fn, qn;
    return F != null && F.loading ? Fe.createElement("div", { className: f_(z == null ? void 0 : z.loader, (Qt = p == null ? void 0 : p.classNames) == null ? void 0 : Qt.loader, "sonner-loader"), "data-visible": De === "loading" }, F.loading) : k ? Fe.createElement("div", { className: f_(z == null ? void 0 : z.loader, (fn = p == null ? void 0 : p.classNames) == null ? void 0 : fn.loader, "sonner-loader"), "data-visible": De === "loading" }, k) : Fe.createElement(hyc, { className: f_(z == null ? void 0 : z.loader, (qn = p == null ? void 0 : p.classNames) == null ? void 0 : qn.loader), visible: De === "loading" });
  }
  return Fe.createElement("li", { tabIndex: 0, ref: Me, className: f_(D, Pe, z == null ? void 0 : z.toast, (t = p == null ? void 0 : p.classNames) == null ? void 0 : t.toast, z == null ? void 0 : z.default, z == null ? void 0 : z[De], (n = p == null ? void 0 : p.classNames) == null ? void 0 : n[De]), "data-sonner-toast": "", "data-rich-colors": (o = p.richColors) != null ? o : M, "data-styled": !(p.jsx || p.unstyled || g), "data-mounted": le, "data-promise": !!p.promise, "data-swiped": Q, "data-removed": Y, "data-visible": st, "data-y-position": Ft, "data-x-position": wn, "data-index": b, "data-front": et, "data-swiping": ie, "data-dismissible": ze, "data-type": De, "data-invert": Dn, "data-swipe-out": he, "data-swipe-direction": H, "data-expanded": !!(w || I && le), style: { "--index": b, "--toasts-before": b, "--z-index": y.length - b, "--offset": `${Y ? ne : Je.current}px`, "--initial-height": I ? "auto" : `${ge}px`, ...L, ...p.style }, onDragEnd: () => {
    _e(!1), U(null), Ot.current = null;
  }, onPointerDown: (Qt) => {
    Rn || !ze || (Re.current = /* @__PURE__ */ new Date(), pe(Je.current), Qt.target.setPointerCapture(Qt.pointerId), Qt.target.tagName !== "BUTTON" && (_e(!0), Ot.current = { x: Qt.clientX, y: Qt.clientY }));
  }, onPointerUp: () => {
    var Qt, fn, qn, Xn;
    if (he || !ze)
      return;
    Ot.current = null;
    let Qn = Number(((Qt = Me.current) == null ? void 0 : Qt.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), In = Number(((fn = Me.current) == null ? void 0 : fn.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), $n = (/* @__PURE__ */ new Date()).getTime() - ((qn = Re.current) == null ? void 0 : qn.getTime()), uo = V === "x" ? Qn : In, go = Math.abs(uo) / $n;
    if (Math.abs(uo) >= Dyc || go > 0.11) {
      pe(Je.current), (Xn = p.onDismiss) == null || Xn.call(p, p), J(V === "x" ? Qn > 0 ? "right" : "left" : In > 0 ? "down" : "up"), Ln(), be(!0), me(!1);
      return;
    }
    _e(!1), U(null);
  }, onPointerMove: (Qt) => {
    var fn, qn, Xn, Qn;
    if (!Ot.current || !ze || ((fn = window.getSelection()) == null ? void 0 : fn.toString().length) > 0)
      return;
    let In = Qt.clientY - Ot.current.y, $n = Qt.clientX - Ot.current.x, uo = (qn = e.swipeDirections) != null ? qn : Myc(E);
    !V && (Math.abs($n) > 1 || Math.abs(In) > 1) && U(Math.abs($n) > Math.abs(In) ? "x" : "y");
    let go = { x: 0, y: 0 };
    V === "y" ? (uo.includes("top") || uo.includes("bottom")) && (uo.includes("top") && In < 0 || uo.includes("bottom") && In > 0) && (go.y = In) : V === "x" && (uo.includes("left") || uo.includes("right")) && (uo.includes("left") && $n < 0 || uo.includes("right") && $n > 0) && (go.x = $n), (Math.abs(go.x) > 0 || Math.abs(go.y) > 0) && me(!0), (Xn = Me.current) == null || Xn.style.setProperty("--swipe-amount-x", `${go.x}px`), (Qn = Me.current) == null || Qn.style.setProperty("--swipe-amount-y", `${go.y}px`);
  } }, Xe && !p.jsx ? Fe.createElement("button", { "aria-label": P, "data-disabled": Rn, "data-close-button": !0, onClick: Rn || !ze ? () => {
  } : () => {
    var Qt;
    Ln(), (Qt = p.onDismiss) == null || Qt.call(p, p);
  }, className: f_(z == null ? void 0 : z.closeButton, (r = p == null ? void 0 : p.classNames) == null ? void 0 : r.closeButton) }, (i = F == null ? void 0 : F.close) != null ? i : wyc) : null, p.jsx || zd(p.title) ? p.jsx ? p.jsx : typeof p.title == "function" ? p.title() : p.title : Fe.createElement(Fe.Fragment, null, De || p.icon || p.promise ? Fe.createElement("div", { "data-icon": "", className: f_(z == null ? void 0 : z.icon, (a = p == null ? void 0 : p.classNames) == null ? void 0 : a.icon) }, p.promise || p.type === "loading" && !p.icon ? p.icon || Yn() : null, p.type !== "loading" ? p.icon || (F == null ? void 0 : F[De]) || fyc(De) : null) : null, Fe.createElement("div", { "data-content": "", className: f_(z == null ? void 0 : z.content, (s = p == null ? void 0 : p.classNames) == null ? void 0 : s.content) }, Fe.createElement("div", { "data-title": "", className: f_(z == null ? void 0 : z.title, (c = p == null ? void 0 : p.classNames) == null ? void 0 : c.title) }, typeof p.title == "function" ? p.title() : p.title), p.description ? Fe.createElement("div", { "data-description": "", className: f_(A, je, z == null ? void 0 : z.description, (l = p == null ? void 0 : p.classNames) == null ? void 0 : l.description) }, typeof p.description == "function" ? p.description() : p.description) : null), zd(p.cancel) ? p.cancel : p.cancel && YS(p.cancel) ? Fe.createElement("button", { "data-button": !0, "data-cancel": !0, style: p.cancelButtonStyle || R, onClick: (Qt) => {
    var fn, qn;
    YS(p.cancel) && ze && ((qn = (fn = p.cancel).onClick) == null || qn.call(fn, Qt), Ln());
  }, className: f_(z == null ? void 0 : z.cancelButton, (u = p == null ? void 0 : p.classNames) == null ? void 0 : u.cancelButton) }, p.cancel.label) : null, zd(p.action) ? p.action : p.action && YS(p.action) ? Fe.createElement("button", { "data-button": !0, "data-action": !0, style: p.actionButtonStyle || T, onClick: (Qt) => {
    var fn, qn;
    YS(p.action) && ((qn = (fn = p.action).onClick) == null || qn.call(fn, Qt), !Qt.defaultPrevented && Ln());
  }, className: f_(z == null ? void 0 : z.actionButton, (d = p == null ? void 0 : p.classNames) == null ? void 0 : d.actionButton) }, p.action.label) : null));
};
function H7() {
  if (typeof window > "u" || typeof document > "u")
    return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function qyc(e, t) {
  let n = {};
  return [e, t].forEach((o, r) => {
    let i = r === 1, a = i ? "--mobile-offset" : "--offset", s = i ? zyc : Nyc;
    function c(l) {
      ["top", "right", "bottom", "left"].forEach((u) => {
        n[`${a}-${u}`] = typeof l == "number" ? `${l}px` : l;
      });
    }
    typeof o == "number" || typeof o == "string" ? c(o) : typeof o == "object" ? ["top", "right", "bottom", "left"].forEach((l) => {
      o[l] === void 0 ? n[`${a}-${l}`] = s : n[`${a}-${l}`] = typeof o[l] == "number" ? `${o[l]}px` : o[l];
    }) : c(s);
  }), n;
}
var Vde = Bt(function(e, t) {
  let { invert: n, position: o = "bottom-right", hotkey: r = ["altKey", "KeyT"], expand: i, closeButton: a, className: s, offset: c, mobileOffset: l, theme: u = "light", richColors: d, duration: _, style: p, visibleToasts: g = Oyc, toastOptions: f, dir: h = H7(), gap: $ = Pyc, loadingIcon: v, icons: b, containerAriaLabel: y = "Notifications", pauseWhenPageIsHidden: w } = e, [N, M] = Fe.useState([]), q = Fe.useMemo(() => Array.from(new Set([o].concat(N.filter((O) => O.position).map((O) => O.position)))), [N, o]), [L, R] = Fe.useState([]), [T, D] = Fe.useState(!1), [A, S] = Fe.useState(!1), [E, x] = Fe.useState(u !== "system" ? u : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), k = Fe.useRef(null), I = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), z = Fe.useRef(null), F = Fe.useRef(!1), P = Fe.useCallback((O) => {
    M((V) => {
      var U;
      return (U = V.find((H) => H.id === O.id)) != null && U.delete || Ul.dismiss(O.id), V.filter(({ id: H }) => H !== O.id);
    });
  }, []);
  return Fe.useEffect(() => Ul.subscribe((O) => {
    if (O.dismiss) {
      M((V) => V.map((U) => U.id === O.id ? { ...U, delete: !0 } : U));
      return;
    }
    setTimeout(() => {
      $v.flushSync(() => {
        M((V) => {
          let U = V.findIndex((H) => H.id === O.id);
          return U !== -1 ? [...V.slice(0, U), { ...V[U], ...O }, ...V.slice(U + 1)] : [O, ...V];
        });
      });
    });
  }), []), Fe.useEffect(() => {
    if (u !== "system") {
      x(u);
      return;
    }
    if (u === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? x("dark") : x("light")), typeof window > "u")
      return;
    let O = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      O.addEventListener("change", ({ matches: V }) => {
        x(V ? "dark" : "light");
      });
    } catch {
      O.addListener(({ matches: U }) => {
        try {
          x(U ? "dark" : "light");
        } catch (H) {
          console.error(H);
        }
      });
    }
  }, [u]), Fe.useEffect(() => {
    N.length <= 1 && D(!1);
  }, [N]), Fe.useEffect(() => {
    let O = (V) => {
      var U, H;
      r.every((J) => V[J] || V.code === J) && (D(!0), (U = k.current) == null || U.focus()), V.code === "Escape" && (document.activeElement === k.current || (H = k.current) != null && H.contains(document.activeElement)) && D(!1);
    };
    return document.addEventListener("keydown", O), () => document.removeEventListener("keydown", O);
  }, [r]), Fe.useEffect(() => {
    if (k.current)
      return () => {
        z.current && (z.current.focus({ preventScroll: !0 }), z.current = null, F.current = !1);
      };
  }, [k.current]), Fe.createElement("section", { ref: t, "aria-label": `${y} ${I}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, q.map((O, V) => {
    var U;
    let [H, J] = O.split("-");
    return N.length ? Fe.createElement("ol", { key: O, dir: h === "auto" ? H7() : h, tabIndex: -1, ref: k, className: s, "data-sonner-toaster": !0, "data-theme": E, "data-y-position": H, "data-lifted": T && N.length > 1 && !i, "data-x-position": J, style: { "--front-toast-height": `${((U = L[0]) == null ? void 0 : U.height) || 0}px`, "--width": `${Ryc}px`, "--gap": `${$}px`, ...p, ...qyc(c, l) }, onBlur: (le) => {
      F.current && !le.currentTarget.contains(le.relatedTarget) && (F.current = !1, z.current && (z.current.focus({ preventScroll: !0 }), z.current = null));
    }, onFocus: (le) => {
      le.target instanceof HTMLElement && le.target.dataset.dismissible === "false" || F.current || (F.current = !0, z.current = le.relatedTarget);
    }, onMouseEnter: () => D(!0), onMouseMove: () => D(!0), onMouseLeave: () => {
      A || D(!1);
    }, onDragEnd: () => D(!1), onPointerDown: (le) => {
      le.target instanceof HTMLElement && le.target.dataset.dismissible === "false" || S(!0);
    }, onPointerUp: () => S(!1) }, N.filter((le) => !le.position && V === 0 || le.position === O).map((le, ae) => {
      var Y, re;
      return Fe.createElement(Fyc, { key: le.id, icons: b, index: ae, toast: le, defaultRichColors: d, duration: (Y = f == null ? void 0 : f.duration) != null ? Y : _, className: f == null ? void 0 : f.className, descriptionClassName: f == null ? void 0 : f.descriptionClassName, invert: n, visibleToasts: g, closeButton: (re = f == null ? void 0 : f.closeButton) != null ? re : a, interacting: A, position: O, style: f == null ? void 0 : f.style, unstyled: f == null ? void 0 : f.unstyled, classNames: f == null ? void 0 : f.classNames, cancelButtonStyle: f == null ? void 0 : f.cancelButtonStyle, actionButtonStyle: f == null ? void 0 : f.actionButtonStyle, removeToast: P, toasts: N.filter((ie) => ie.position == le.position), heights: L.filter((ie) => ie.position == le.position), setHeights: R, expandByDefault: i, gap: $, loadingIcon: v, expanded: T, pauseWhenPageIsHidden: w, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
const Y7 = ({ message: e, onClose: t, toastId: n }) => /* @__PURE__ */ de(
  "button",
  {
    className: Ia(
      "data-testid-toast-success bg-default dark:bg-inverted text-emphasis dark:text-inverted shadow-elevation-low border-subtle mb-2 flex h-auto items-center justify-between space-x-2 rounded-lg border px-3 py-2.5 text-sm font-semibold rtl:space-x-reverse md:max-w-sm"
    ),
    onClick: () => t(n),
    children: [
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(qt, { name: "check", className: "size-4" }) }),
      /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m("p", { "data-testid": "toast-success", className: "m-0 w-full text-left", children: e }) }),
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(qt, { name: "x", className: "size-4 hover:cursor-pointer" }) })
    ]
  }
), jyc = ({ message: e, onClose: t, toastId: n }) => /* @__PURE__ */ de(
  "button",
  {
    className: Ia(
      "animate-fade-in-up bg-semantic-error-subtle text-semantic-error shadow-elevation-low border-semantic-error-subtle mb-2 flex h-auto items-center justify-between space-x-2 rounded-md border px-3 py-2.5 text-sm font-semibold rtl:space-x-reverse md:max-w-sm"
    ),
    onClick: () => t(n),
    children: [
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(qt, { name: "info", className: "text-semantic-error  size-4" }) }),
      /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m("p", { "data-testid": "toast-error", className: "m-0 w-full text-left", children: e }) }),
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(qt, { name: "x", className: "text-semantic-error size-4 hover:cursor-pointer" }) })
    ]
  }
), Vyc = ({ message: e, onClose: t, toastId: n }) => /* @__PURE__ */ de(
  "button",
  {
    className: Ia(
      "animate-fade-in-up bg-semantic-attention-subtle text-semantic-attention shadow-elevation-low border-semantic-attention-subtle mb-2 flex h-auto items-center justify-between space-x-2 rounded-md border px-3 py-2.5 text-sm font-semibold rtl:space-x-reverse md:max-w-sm"
    ),
    onClick: () => t(n),
    children: [
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(qt, { name: "info", className: "text-semantic-attention size-4" }) }),
      /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m("p", { "data-testid": "toast-warning", className: "m-0 w-full text-left", children: e }) }),
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(qt, { name: "x", className: "text-semantic-attention size-4 hover:cursor-pointer" }) })
    ]
  }
), K7 = 6e3;
function ti(e, t, n = K7) {
  const o = typeof n == "number" ? { duration: n } : n;
  o.duration || (o.duration = K7), o.position || (o.position = "bottom-center");
  const r = (a) => {
    G7.dismiss(a);
  }, i = {
    success: (a) => /* @__PURE__ */ m(Y7, { message: e, onClose: r, toastId: a }),
    error: (a) => /* @__PURE__ */ m(jyc, { message: e, onClose: r, toastId: a }),
    warning: (a) => /* @__PURE__ */ m(Vyc, { message: e, onClose: r, toastId: a })
  };
  return G7.custom(
    i[t] || ((a) => /* @__PURE__ */ m(Y7, { message: e, onClose: r, toastId: a })),
    o
  );
}
const Byc = (e, t) => {
  const { form: n, handleSubmit: o, ...r } = e;
  return /* @__PURE__ */ m(hse, { ...n, children: /* @__PURE__ */ m(
    "form",
    {
      ref: t,
      onSubmit: (i) => {
        i.preventDefault(), i.stopPropagation(), n.handleSubmit(o)(i).catch((a) => {
          ti(`${myc(a).message}`, "error");
        });
      },
      ...r,
      children: e.children
    }
  ) });
}, Y_ = Bt(Byc);
var B4 = { exports: {} };
function Uyc(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var YN = {}, KN = {}, Z7;
function Gyc() {
  return Z7 || (Z7 = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "LoadableContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (/* @__PURE__ */ qg._(Fe)).default.createContext(null);
    process.env.NODE_ENV !== "production" && (o.displayName = "LoadableContext");
  }(KN)), KN;
}
var X7;
function Wyc() {
  return X7 || (X7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return p;
      }
    });
    const n = /* @__PURE__ */ qg._(Fe), o = Gyc();
    function r(g) {
      return g && g.default ? g.default : g;
    }
    const i = [], a = [];
    let s = !1;
    function c(g) {
      let f = g(), h = {
        loading: !0,
        loaded: null,
        error: null
      };
      return h.promise = f.then(($) => (h.loading = !1, h.loaded = $, $)).catch(($) => {
        throw h.loading = !1, h.error = $, $;
      }), h;
    }
    function l(g, f) {
      let h = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null
      }, f), $ = null;
      function v() {
        if (!$) {
          const w = new u(g, h);
          $ = {
            getCurrentValue: w.getCurrentValue.bind(w),
            subscribe: w.subscribe.bind(w),
            retry: w.retry.bind(w),
            promise: w.promise.bind(w)
          };
        }
        return $.promise();
      }
      if (typeof window > "u" && i.push(v), !s && typeof window < "u") {
        const w = h.webpack && typeof Uyc.resolveWeak == "function" ? h.webpack() : h.modules;
        w && a.push((N) => {
          for (const M of w)
            if (N.includes(M))
              return v();
        });
      }
      function b() {
        v();
        const w = n.default.useContext(o.LoadableContext);
        w && Array.isArray(h.modules) && h.modules.forEach((N) => {
          w(N);
        });
      }
      function y(w, N) {
        b();
        const M = n.default.useSyncExternalStore($.subscribe, $.getCurrentValue, $.getCurrentValue);
        return n.default.useImperativeHandle(N, () => ({
          retry: $.retry
        }), []), n.default.useMemo(() => M.loading || M.error ? /* @__PURE__ */ n.default.createElement(h.loading, {
          isLoading: M.loading,
          pastDelay: M.pastDelay,
          timedOut: M.timedOut,
          error: M.error,
          retry: $.retry
        }) : M.loaded ? /* @__PURE__ */ n.default.createElement(r(M.loaded), w) : null, [
          w,
          M
        ]);
      }
      return y.preload = () => v(), y.displayName = "LoadableComponent", /* @__PURE__ */ n.default.forwardRef(y);
    }
    class u {
      promise() {
        return this._res.promise;
      }
      retry() {
        this._clearTimeouts(), this._res = this._loadFn(this._opts.loader), this._state = {
          pastDelay: !1,
          timedOut: !1
        };
        const { _res: f, _opts: h } = this;
        f.loading && (typeof h.delay == "number" && (h.delay === 0 ? this._state.pastDelay = !0 : this._delay = setTimeout(() => {
          this._update({
            pastDelay: !0
          });
        }, h.delay)), typeof h.timeout == "number" && (this._timeout = setTimeout(() => {
          this._update({
            timedOut: !0
          });
        }, h.timeout))), this._res.promise.then(() => {
          this._update({}), this._clearTimeouts();
        }).catch(($) => {
          this._update({}), this._clearTimeouts();
        }), this._update({});
      }
      _update(f) {
        this._state = {
          ...this._state,
          error: this._res.error,
          loaded: this._res.loaded,
          loading: this._res.loading,
          ...f
        }, this._callbacks.forEach((h) => h());
      }
      _clearTimeouts() {
        clearTimeout(this._delay), clearTimeout(this._timeout);
      }
      getCurrentValue() {
        return this._state;
      }
      subscribe(f) {
        return this._callbacks.add(f), () => {
          this._callbacks.delete(f);
        };
      }
      constructor(f, h) {
        this._loadFn = f, this._opts = h, this._callbacks = /* @__PURE__ */ new Set(), this._delay = null, this._timeout = null, this.retry();
      }
    }
    function d(g) {
      return l(c, g);
    }
    function _(g, f) {
      let h = [];
      for (; g.length; ) {
        let $ = g.pop();
        h.push($(f));
      }
      return Promise.all(h).then(() => {
        if (g.length)
          return _(g, f);
      });
    }
    d.preloadAll = () => new Promise((g, f) => {
      _(i).then(g, f);
    }), d.preloadReady = (g) => (g === void 0 && (g = []), new Promise((f) => {
      const h = () => (s = !0, f());
      _(a, g).then(h, h);
    })), typeof window < "u" && (window.__NEXT_PRELOADREADY = d.preloadReady);
    const p = d;
  }(YN)), YN;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(u, d) {
    for (var _ in d)
      Object.defineProperty(u, _, {
        enumerable: !0,
        get: d[_]
      });
  }
  n(t, {
    /**
    * This function lets you dynamically import a component.
    * It uses [React.lazy()](https://react.dev/reference/react/lazy) with [Suspense](https://react.dev/reference/react/Suspense) under the hood.
    *
    * Read more: [Next.js Docs: `next/dynamic`](https://nextjs.org/docs/app/building-your-application/optimizing/lazy-loading#nextdynamic)
    */
    default: function() {
      return l;
    },
    noSSR: function() {
      return c;
    }
  });
  const o = qg, r = gT, i = /* @__PURE__ */ o._(Wyc()), a = typeof window > "u";
  function s(u) {
    return {
      default: (u == null ? void 0 : u.default) || u
    };
  }
  function c(u, d) {
    if (delete d.webpack, delete d.modules, !a)
      return u(d);
    const _ = d.loading;
    return () => /* @__PURE__ */ (0, r.jsx)(_, {
      error: null,
      isLoading: !0,
      pastDelay: !1,
      timedOut: !1
    });
  }
  function l(u, d) {
    let _ = i.default, p = {
      // A loading component is not required, so we default it
      loading: (h) => {
        let { error: $, isLoading: v, pastDelay: b } = h;
        if (!b)
          return null;
        if (process.env.NODE_ENV !== "production") {
          if (v)
            return null;
          if ($)
            return /* @__PURE__ */ (0, r.jsxs)("p", {
              children: [
                $.message,
                /* @__PURE__ */ (0, r.jsx)("br", {}),
                $.stack
              ]
            });
        }
        return null;
      }
    };
    u instanceof Promise ? p.loader = () => u : typeof u == "function" ? p.loader = u : typeof u == "object" && (p = {
      ...p,
      ...u
    }), p = {
      ...p,
      ...d
    };
    const g = p.loader, f = () => g != null ? g().then(s) : Promise.resolve(s(() => null));
    return p.loadableGenerated && (p = {
      ...p,
      ...p.loadableGenerated
    }, delete p.loadableGenerated), typeof p.ssr == "boolean" && !p.ssr ? (delete p.webpack, delete p.modules, c(_, p)) : _({
      ...p,
      loader: f
    });
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(B4, B4.exports);
var Hyc = B4.exports, Yyc = Hyc;
const co = /* @__PURE__ */ Mi(Yyc), Kyc = co(
  () => import("./DateRangePicker-wDv3QJSa.js").then((e) => e.DatePickerWithRange)
);
var sq = globalThis != null && globalThis.document ? Ue.useLayoutEffect : () => {
};
const Bde = "Popover", [Ude, asu] = jc(Bde, [
  jy
]), cq = jy(), [Zyc, Ky] = Ude(Bde), Xyc = (e) => {
  const { __scopePopover: t, children: n, open: o, defaultOpen: r, onOpenChange: i, modal: a = !1 } = e, s = cq(t), c = xt(null), [l, u] = it(!1), [d = !1, _] = Uu({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ pt(z6, s, /* @__PURE__ */ pt(Zyc, {
    scope: t,
    contentId: Pu(),
    triggerRef: c,
    open: d,
    onOpenChange: _,
    onOpenToggle: Yt(
      () => _(
        (p) => !p
      ),
      [
        _
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: Yt(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: Yt(
      () => u(!1),
      []
    ),
    modal: a
  }, n));
}, Jyc = "PopoverTrigger", Qyc = /* @__PURE__ */ Bt((e, t) => {
  const { __scopePopover: n, ...o } = e, r = Ky(Jyc, n), i = cq(n), a = ni(t, r.triggerRef), s = /* @__PURE__ */ pt(nr.button, Tt({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": r.open,
    "aria-controls": r.contentId,
    "data-state": Hde(r.open)
  }, o, {
    ref: a,
    onClick: jn(e.onClick, r.onOpenToggle)
  }));
  return r.hasCustomAnchor ? s : /* @__PURE__ */ pt(R6, Tt({
    asChild: !0
  }, i), s);
}), Gde = "PopoverPortal", [e$c, t$c] = Ude(Gde, {
  forceMount: void 0
}), n$c = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, i = Ky(Gde, t);
  return /* @__PURE__ */ pt(e$c, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ pt(Vc, {
    present: n || i.open
  }, /* @__PURE__ */ pt(D6, {
    asChild: !0,
    container: r
  }, o)));
}, Uk = "PopoverContent", o$c = /* @__PURE__ */ Bt((e, t) => {
  const n = t$c(Uk, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, i = Ky(Uk, e.__scopePopover);
  return /* @__PURE__ */ pt(Vc, {
    present: o || i.open
  }, i.modal ? /* @__PURE__ */ pt(r$c, Tt({}, r, {
    ref: t
  })) : /* @__PURE__ */ pt(i$c, Tt({}, r, {
    ref: t
  })));
}), r$c = /* @__PURE__ */ Bt((e, t) => {
  const n = Ky(Uk, e.__scopePopover), o = xt(null), r = ni(t, o), i = xt(!1);
  return yt(() => {
    const a = o.current;
    if (a)
      return Q6(a);
  }, []), /* @__PURE__ */ pt(eF, {
    as: av,
    allowPinchZoom: !0
  }, /* @__PURE__ */ pt(Wde, Tt({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: jn(e.onCloseAutoFocus, (a) => {
      var s;
      a.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: jn(e.onPointerDownOutside, (a) => {
      const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      i.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: jn(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), i$c = /* @__PURE__ */ Bt((e, t) => {
  const n = Ky(Uk, e.__scopePopover), o = xt(!1), r = xt(!1);
  return /* @__PURE__ */ pt(Wde, Tt({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      o.current = !1, r.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (o.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
    }
  }));
}), Wde = /* @__PURE__ */ Bt((e, t) => {
  const { __scopePopover: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, disableOutsidePointerEvents: a, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, _ = Ky(Uk, n), p = cq(n);
  return Y6(), /* @__PURE__ */ pt(K6, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ pt(ST, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onInteractOutside: u,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => _.onOpenChange(!1)
  }, /* @__PURE__ */ pt(P6, Tt({
    "data-state": Hde(_.open),
    role: "dialog",
    id: _.contentId
  }, p, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function Hde(e) {
  return e ? "open" : "closed";
}
const Yde = Xyc, Kde = Qyc, a$c = n$c, Zde = o$c, s$c = /* @__PURE__ */ Bt((e, t) => {
  const { pressed: n, defaultPressed: o = !1, onPressedChange: r, ...i } = e, [a = !1, s] = Uu({
    prop: n,
    onChange: r,
    defaultProp: o
  });
  return /* @__PURE__ */ pt(nr.button, Tt({
    type: "button",
    "aria-pressed": a,
    "data-state": a ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, i, {
    ref: t,
    onClick: jn(e.onClick, () => {
      e.disabled || s(!a);
    })
  }));
}), c$c = /* @__PURE__ */ Cr(void 0);
function l$c(e) {
  const t = bo(c$c);
  return e || t || "ltr";
}
const aA = "ToggleGroup", [Xde, ssu] = jc(aA, [
  By
]), Jde = By(), u$c = /* @__PURE__ */ Fe.forwardRef((e, t) => {
  const { type: n, ...o } = e;
  if (n === "single") {
    const r = o;
    return /* @__PURE__ */ Fe.createElement(d$c, Tt({}, r, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const r = o;
    return /* @__PURE__ */ Fe.createElement(_$c, Tt({}, r, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${aA}\``);
}), [Qde, e_e] = Xde(aA), d$c = /* @__PURE__ */ Fe.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: r = () => {
  }, ...i } = e, [a, s] = Uu({
    prop: n,
    defaultProp: o,
    onChange: r
  });
  return /* @__PURE__ */ Fe.createElement(Qde, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: a ? [
      a
    ] : [],
    onItemActivate: s,
    onItemDeactivate: Fe.useCallback(
      () => s(""),
      [
        s
      ]
    )
  }, /* @__PURE__ */ Fe.createElement(t_e, Tt({}, i, {
    ref: t
  })));
}), _$c = /* @__PURE__ */ Fe.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: r = () => {
  }, ...i } = e, [a = [], s] = Uu({
    prop: n,
    defaultProp: o,
    onChange: r
  }), c = Fe.useCallback(
    (u) => s(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      s
    ]
  ), l = Fe.useCallback(
    (u) => s(
      (d = []) => d.filter(
        (_) => _ !== u
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ Fe.createElement(Qde, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: a,
    onItemActivate: c,
    onItemDeactivate: l
  }, /* @__PURE__ */ Fe.createElement(t_e, Tt({}, i, {
    ref: t
  })));
}), [p$c, m$c] = Xde(aA), t_e = /* @__PURE__ */ Fe.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: o = !1, rovingFocus: r = !0, orientation: i, dir: a, loop: s = !0, ...c } = e, l = Jde(n), u = l$c(a), d = {
    role: "group",
    dir: u,
    ...c
  };
  return /* @__PURE__ */ Fe.createElement(p$c, {
    scope: n,
    rovingFocus: r,
    disabled: o
  }, r ? /* @__PURE__ */ Fe.createElement(X6, Tt({
    asChild: !0
  }, l, {
    orientation: i,
    dir: u,
    loop: s
  }), /* @__PURE__ */ Fe.createElement(nr.div, Tt({}, d, {
    ref: t
  }))) : /* @__PURE__ */ Fe.createElement(nr.div, Tt({}, d, {
    ref: t
  })));
}), U4 = "ToggleGroupItem", f$c = /* @__PURE__ */ Fe.forwardRef((e, t) => {
  const n = e_e(U4, e.__scopeToggleGroup), o = m$c(U4, e.__scopeToggleGroup), r = Jde(e.__scopeToggleGroup), i = n.value.includes(e.value), a = o.disabled || e.disabled, s = {
    ...e,
    pressed: i,
    disabled: a
  }, c = Fe.useRef(null);
  return o.rovingFocus ? /* @__PURE__ */ Fe.createElement(J6, Tt({
    asChild: !0
  }, r, {
    focusable: !a,
    active: i,
    ref: c
  }), /* @__PURE__ */ Fe.createElement(J7, Tt({}, s, {
    ref: t
  }))) : /* @__PURE__ */ Fe.createElement(J7, Tt({}, s, {
    ref: t
  }));
}), J7 = /* @__PURE__ */ Fe.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: o, ...r } = e, i = e_e(U4, n), a = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, s = i.type === "single" ? a : void 0;
  return /* @__PURE__ */ Fe.createElement(s$c, Tt({}, s, r, {
    ref: t,
    onPressedChange: (c) => {
      c ? i.onItemActivate(o) : i.onItemDeactivate(o);
    }
  }));
}), g$c = u$c, h$c = f$c, v$c = ({
  children: e,
  tooltipText: t
}) => t ? /* @__PURE__ */ m(Sr, { delayDuration: 150, sideOffset: 12, side: "bottom", content: t, children: e }) : /* @__PURE__ */ m(nt, { children: e }), lq = ({
  options: e,
  onValueChange: t,
  isFullWidth: n,
  orientation: o = "horizontal",
  customClassNames: r,
  ...i
}) => /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
  g$c,
  {
    type: "single",
    ...i,
    orientation: o,
    onValueChange: t,
    style: {
      // @ts-expect-error --toggle-group-shadow is not a valid CSS property but can be a variable
      "--toggle-group-shadow": "0px 2px 3px 0px rgba(0, 0, 0, 0.03), 0px 2px 2px -1px rgba(0, 0, 0, 0.03)"
    },
    className: xe(
      "bg-subtle border-subtle rounded-[10px] border p-0.5",
      o === "horizontal" && "inline-flex gap-0.5 rtl:flex-row-reverse",
      o === "vertical" && "flex w-fit flex-col gap-0.5",
      i.className,
      n && "w-full",
      r
    ),
    children: e.map((a) => /* @__PURE__ */ m(v$c, { tooltipText: a.tooltip, children: /* @__PURE__ */ m(
      h$c,
      {
        disabled: a.disabled,
        value: a.value,
        "data-testid": a.dataTestId ?? `toggle-group-item-${a.value}`,
        className: xe(
          "aria-checked:bg-default aria-checked:border-subtle rounded-lg border border-transparent p-1.5 text-sm leading-none transition aria-checked:shadow-[0px_2px_3px_0px_rgba(0,0,0,0.03),0px_2px_2px_-1px_rgba(0,0,0,0.03)]",
          a.disabled ? "text-gray-400 hover:cursor-not-allowed" : "text-default [&[aria-checked='false']]:hover:text-emphasis",
          n && "w-full"
        ),
        children: /* @__PURE__ */ de(
          "div",
          {
            className: xe(
              "flex items-center gap-1",
              o === "horizontal" && "justify-center",
              o === "vertical" && "justify-start"
            ),
            children: [
              a.iconLeft && /* @__PURE__ */ m("span", { className: "flex h-4 w-4 items-center", children: a.iconLeft }),
              a.label
            ]
          }
        )
      }
    ) }, a.value))
  }
) });
function Fr(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function ju(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function _l(e, t) {
  const n = Fr(e);
  return isNaN(t) ? ju(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function q_(e, t) {
  const n = Fr(e);
  if (isNaN(t))
    return ju(e, NaN);
  if (!t)
    return n;
  const o = n.getDate(), r = ju(e, n.getTime());
  r.setMonth(n.getMonth() + t + 1, 0);
  const i = r.getDate();
  return o >= i ? r : (n.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    o
  ), n);
}
const uq = 6048e5, b$c = 864e5;
let y$c = {};
function Zy() {
  return y$c;
}
function Jp(e, t) {
  var s, c, l, u;
  const n = Zy(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = Fr(e), i = r.getDay(), a = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - a), r.setHours(0, 0, 0, 0), r;
}
function vv(e) {
  return Jp(e, { weekStartsOn: 1 });
}
function n_e(e) {
  const t = Fr(e), n = t.getFullYear(), o = ju(e, 0);
  o.setFullYear(n + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const r = vv(o), i = ju(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const a = vv(i);
  return t.getTime() >= r.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function Oy(e) {
  const t = Fr(e);
  return t.setHours(0, 0, 0, 0), t;
}
function yC(e) {
  const t = Fr(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Vp(e, t) {
  const n = Oy(e), o = Oy(t), r = +n - yC(n), i = +o - yC(o);
  return Math.round((r - i) / b$c);
}
function $$c(e) {
  const t = n_e(e), n = ju(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), vv(n);
}
function G4(e, t) {
  const n = t * 7;
  return _l(e, n);
}
function w$c(e, t) {
  return q_(e, t * 12);
}
function k$c(e) {
  let t;
  return e.forEach(function(n) {
    const o = Fr(n);
    (t === void 0 || t < o || isNaN(Number(o))) && (t = o);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function S$c(e) {
  let t;
  return e.forEach((n) => {
    const o = Fr(n);
    (!t || t > o || isNaN(+o)) && (t = o);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Kl(e, t) {
  const n = Oy(e), o = Oy(t);
  return +n == +o;
}
function dq(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function E$c(e) {
  if (!dq(e) && typeof e != "number")
    return !1;
  const t = Fr(e);
  return !isNaN(Number(t));
}
function Gk(e, t) {
  const n = Fr(e), o = Fr(t), r = n.getFullYear() - o.getFullYear(), i = n.getMonth() - o.getMonth();
  return r * 12 + i;
}
function x$c(e, t, n) {
  const o = Jp(e, n), r = Jp(t, n), i = +o - yC(o), a = +r - yC(r);
  return Math.round((i - a) / uq);
}
function _q(e) {
  const t = Fr(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Ql(e) {
  const t = Fr(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function o_e(e) {
  const t = Fr(e), n = ju(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function pq(e, t) {
  var s, c, l, u;
  const n = Zy(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = Fr(e), i = r.getDay(), a = (i < o ? -7 : 0) + 6 - (i - o);
  return r.setDate(r.getDate() + a), r.setHours(23, 59, 59, 999), r;
}
function r_e(e) {
  return pq(e, { weekStartsOn: 1 });
}
const C$c = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, T$c = (e, t, n) => {
  let o;
  const r = C$c[e];
  return typeof r == "string" ? o = r : t === 1 ? o = r.one : o = r.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function ZN(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const A$c = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, I$c = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, O$c = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, N$c = {
  date: ZN({
    formats: A$c,
    defaultWidth: "full"
  }),
  time: ZN({
    formats: I$c,
    defaultWidth: "full"
  }),
  dateTime: ZN({
    formats: O$c,
    defaultWidth: "full"
  })
}, z$c = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, R$c = (e, t, n, o) => z$c[e];
function ow(e) {
  return (t, n) => {
    const o = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      r = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      r = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[i];
  };
}
const P$c = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, D$c = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, L$c = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, M$c = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, F$c = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, q$c = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, j$c = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, V$c = {
  ordinalNumber: j$c,
  era: ow({
    values: P$c,
    defaultWidth: "wide"
  }),
  quarter: ow({
    values: D$c,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ow({
    values: L$c,
    defaultWidth: "wide"
  }),
  day: ow({
    values: M$c,
    defaultWidth: "wide"
  }),
  dayPeriod: ow({
    values: F$c,
    defaultWidth: "wide",
    formattingValues: q$c,
    defaultFormattingWidth: "wide"
  })
};
function rw(e) {
  return (t, n = {}) => {
    const o = n.width, r = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], i = t.match(r);
    if (!i)
      return null;
    const a = i[0], s = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? U$c(s, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      B$c(s, (d) => d.test(a))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(l)
    ) : l;
    const u = t.slice(a.length);
    return { value: l, rest: u };
  };
}
function B$c(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function U$c(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function G$c(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o)
      return null;
    const r = o[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(r.length);
    return { value: a, rest: s };
  };
}
const W$c = /^(\d+)(th|st|nd|rd)?/i, H$c = /\d+/i, Y$c = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, K$c = {
  any: [/^b/i, /^(a|c)/i]
}, Z$c = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, X$c = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, J$c = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Q$c = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ewc = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, twc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, nwc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, owc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, rwc = {
  ordinalNumber: G$c({
    matchPattern: W$c,
    parsePattern: H$c,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: rw({
    matchPatterns: Y$c,
    defaultMatchWidth: "wide",
    parsePatterns: K$c,
    defaultParseWidth: "any"
  }),
  quarter: rw({
    matchPatterns: Z$c,
    defaultMatchWidth: "wide",
    parsePatterns: X$c,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: rw({
    matchPatterns: J$c,
    defaultMatchWidth: "wide",
    parsePatterns: Q$c,
    defaultParseWidth: "any"
  }),
  day: rw({
    matchPatterns: ewc,
    defaultMatchWidth: "wide",
    parsePatterns: twc,
    defaultParseWidth: "any"
  }),
  dayPeriod: rw({
    matchPatterns: nwc,
    defaultMatchWidth: "any",
    parsePatterns: owc,
    defaultParseWidth: "any"
  })
}, i_e = {
  code: "en-US",
  formatDistance: T$c,
  formatLong: N$c,
  formatRelative: R$c,
  localize: V$c,
  match: rwc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function iwc(e) {
  const t = Fr(e);
  return Vp(t, o_e(t)) + 1;
}
function a_e(e) {
  const t = Fr(e), n = +vv(t) - +$$c(t);
  return Math.round(n / uq) + 1;
}
function s_e(e, t) {
  var u, d, _, p;
  const n = Fr(e), o = n.getFullYear(), r = Zy(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (_ = r.locale) == null ? void 0 : _.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = ju(e, 0);
  a.setFullYear(o + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Jp(a, t), c = ju(e, 0);
  c.setFullYear(o, 0, i), c.setHours(0, 0, 0, 0);
  const l = Jp(c, t);
  return n.getTime() >= s.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function awc(e, t) {
  var s, c, l, u;
  const n = Zy(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, r = s_e(e, t), i = ju(e, 0);
  return i.setFullYear(r, 0, o), i.setHours(0, 0, 0, 0), Jp(i, t);
}
function c_e(e, t) {
  const n = Fr(e), o = +Jp(n, t) - +awc(n, t);
  return Math.round(o / uq) + 1;
}
function $i(e, t) {
  const n = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return n + o;
}
const Wf = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
    return $i(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : $i(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return $i(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return $i(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return $i(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return $i(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return $i(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, o = e.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return $i(r, t.length);
  }
}, lb = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Q7 = {
  // Era
  G: function(e, t, n) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const o = e.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Wf.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, o) {
    const r = s_e(e, o), i = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const a = i % 100;
      return $i(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : $i(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = n_e(e);
    return $i(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return $i(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(o);
      case "QQ":
        return $i(o, 2);
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(o);
      case "qq":
        return $i(o, 2);
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Wf.M(e, t);
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "L":
        return String(o + 1);
      case "LL":
        return $i(o + 1, 2);
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, o) {
    const r = c_e(e, o);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : $i(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const o = a_e(e);
    return t === "Io" ? n.ordinalNumber(o, { unit: "week" }) : $i(o, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Wf.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const o = iwc(e);
    return t === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : $i(o, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const o = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, o) {
    const r = e.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return $i(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, o) {
    const r = e.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return $i(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const o = e.getDay(), r = o === 0 ? 7 : o;
    switch (t) {
      case "i":
        return String(r);
      case "ii":
        return $i(r, t.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const o = e.getHours();
    let r;
    switch (o === 12 ? r = lb.noon : o === 0 ? r = lb.midnight : r = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const o = e.getHours();
    let r;
    switch (o >= 17 ? r = lb.evening : o >= 12 ? r = lb.afternoon : o >= 4 ? r = lb.morning : r = lb.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return Wf.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Wf.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const o = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : $i(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : $i(o, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Wf.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Wf.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Wf.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return tH(o);
      case "XXXX":
      case "XX":
        return Ch(o);
      case "XXXXX":
      case "XXX":
      default:
        return Ch(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return tH(o);
      case "xxxx":
      case "xx":
        return Ch(o);
      case "xxxxx":
      case "xxx":
      default:
        return Ch(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + eH(o, ":");
      case "OOOO":
      default:
        return "GMT" + Ch(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + eH(o, ":");
      case "zzzz":
      default:
        return "GMT" + Ch(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const o = Math.trunc(e.getTime() / 1e3);
    return $i(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const o = e.getTime();
    return $i(o, t.length);
  }
};
function eH(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + t + $i(i, 2);
}
function tH(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + $i(Math.abs(e) / 60, 2) : Ch(e, t);
}
function Ch(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = $i(Math.trunc(o / 60), 2), i = $i(o % 60, 2);
  return n + r + t + i;
}
const nH = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, l_e = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, swc = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return nH(e, t);
  let i;
  switch (o) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", nH(o, t)).replace("{{time}}", l_e(r, t));
}, cwc = {
  p: l_e,
  P: swc
}, lwc = /^D+$/, uwc = /^Y+$/, dwc = ["D", "DD", "YY", "YYYY"];
function _wc(e) {
  return lwc.test(e);
}
function pwc(e) {
  return uwc.test(e);
}
function mwc(e, t, n) {
  const o = fwc(e, t, n);
  if (console.warn(o), dwc.includes(e))
    throw new RangeError(o);
}
function fwc(e, t, n) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const gwc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, hwc = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vwc = /^'([^]*?)'?$/, bwc = /''/g, ywc = /[a-zA-Z]/;
function xf(e, t, n) {
  var u, d, _, p, g, f, h, $;
  const o = Zy(), r = (n == null ? void 0 : n.locale) ?? o.locale ?? i_e, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (_ = o.locale) == null ? void 0 : _.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : f.weekStartsOn) ?? o.weekStartsOn ?? (($ = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : $.weekStartsOn) ?? 0, s = Fr(e);
  if (!E$c(s))
    throw new RangeError("Invalid time value");
  let c = t.match(hwc).map((v) => {
    const b = v[0];
    if (b === "p" || b === "P") {
      const y = cwc[b];
      return y(v, r.formatLong);
    }
    return v;
  }).join("").match(gwc).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const b = v[0];
    if (b === "'")
      return { isToken: !1, value: $wc(v) };
    if (Q7[b])
      return { isToken: !0, value: v };
    if (b.match(ywc))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: v };
  });
  r.localize.preprocessor && (c = r.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: r
  };
  return c.map((v) => {
    if (!v.isToken)
      return v.value;
    const b = v.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && pwc(b) || !(n != null && n.useAdditionalDayOfYearTokens) && _wc(b)) && mwc(b, t, String(e));
    const y = Q7[b[0]];
    return y(s, b, r.localize, l);
  }).join("");
}
function $wc(e) {
  const t = e.match(vwc);
  return t ? t[1].replace(bwc, "'") : e;
}
function wwc(e) {
  const t = Fr(e), n = t.getFullYear(), o = t.getMonth(), r = ju(e, 0);
  return r.setFullYear(n, o + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function kwc() {
  return Object.assign({}, Zy());
}
function Swc(e) {
  return Math.trunc(+Fr(e) / 1e3);
}
function Ewc(e) {
  const t = Fr(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function xwc(e, t) {
  return x$c(
    Ewc(e),
    Ql(e),
    t
  ) + 1;
}
function W4(e, t) {
  const n = Fr(e), o = Fr(t);
  return n.getTime() > o.getTime();
}
function u_e(e, t) {
  const n = Fr(e), o = Fr(t);
  return +n < +o;
}
function mq(e, t) {
  const n = Fr(e), o = Fr(t);
  return n.getFullYear() === o.getFullYear() && n.getMonth() === o.getMonth();
}
function Cwc(e, t) {
  const n = Fr(e), o = Fr(t);
  return n.getFullYear() === o.getFullYear();
}
function XN(e, t) {
  return _l(e, -t);
}
function JN(e, t) {
  const n = Fr(e), o = n.getFullYear(), r = n.getDate(), i = ju(e, 0);
  i.setFullYear(o, t, 15), i.setHours(0, 0, 0, 0);
  const a = wwc(i);
  return n.setMonth(t, Math.min(r, a)), n;
}
function oH(e, t) {
  const n = Fr(e);
  return isNaN(+n) ? ju(e, NaN) : (n.setFullYear(t), n);
}
var Mo = function() {
  return Mo = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Mo.apply(this, arguments);
};
function Twc(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function d_e(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function W0(e) {
  return e.mode === "multiple";
}
function H0(e) {
  return e.mode === "range";
}
function sA(e) {
  return e.mode === "single";
}
var Awc = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Iwc(e, t) {
  return xf(e, "LLLL y", t);
}
function Owc(e, t) {
  return xf(e, "d", t);
}
function Nwc(e, t) {
  return xf(e, "LLLL", t);
}
function zwc(e) {
  return "".concat(e);
}
function Rwc(e, t) {
  return xf(e, "cccccc", t);
}
function Pwc(e, t) {
  return xf(e, "yyyy", t);
}
var Dwc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: Iwc,
  formatDay: Owc,
  formatMonthCaption: Nwc,
  formatWeekNumber: zwc,
  formatWeekdayName: Rwc,
  formatYearCaption: Pwc
}), Lwc = function(e, t, n) {
  return xf(e, "do MMMM (EEEE)", n);
}, Mwc = function() {
  return "Month: ";
}, Fwc = function() {
  return "Go to next month";
}, qwc = function() {
  return "Go to previous month";
}, jwc = function(e, t) {
  return xf(e, "cccc", t);
}, Vwc = function(e) {
  return "Week n. ".concat(e);
}, Bwc = function() {
  return "Year: ";
}, Uwc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: Lwc,
  labelMonthDropdown: Mwc,
  labelNext: Fwc,
  labelPrevious: qwc,
  labelWeekNumber: Vwc,
  labelWeekday: jwc,
  labelYearDropdown: Bwc
});
function Gwc() {
  var e = "buttons", t = Awc, n = i_e, o = {}, r = {}, i = 1, a = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: Dwc,
    labels: Uwc,
    locale: n,
    modifiersClassNames: o,
    modifiers: r,
    numberOfMonths: i,
    styles: a,
    today: s,
    mode: "default"
  };
}
function Wwc(e) {
  var t = e.fromYear, n = e.toYear, o = e.fromMonth, r = e.toMonth, i = e.fromDate, a = e.toDate;
  return o ? i = Ql(o) : t && (i = new Date(t, 0, 1)), r ? a = _q(r) : n && (a = new Date(n, 11, 31)), {
    fromDate: i ? Oy(i) : void 0,
    toDate: a ? Oy(a) : void 0
  };
}
var __e = Cr(void 0);
function Hwc(e) {
  var t, n = e.initialProps, o = Gwc(), r = Wwc(n), i = r.fromDate, a = r.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : o.captionLayout;
  s !== "buttons" && (!i || !a) && (s = "buttons");
  var c;
  (sA(n) || W0(n) || H0(n)) && (c = n.onSelect);
  var l = Mo(Mo(Mo({}, o), n), { captionLayout: s, classNames: Mo(Mo({}, o.classNames), n.classNames), components: Mo({}, n.components), formatters: Mo(Mo({}, o.formatters), n.formatters), fromDate: i, labels: Mo(Mo({}, o.labels), n.labels), mode: n.mode || o.mode, modifiers: Mo(Mo({}, o.modifiers), n.modifiers), modifiersClassNames: Mo(Mo({}, o.modifiersClassNames), n.modifiersClassNames), onSelect: c, styles: Mo(Mo({}, o.styles), n.styles), toDate: a });
  return m(__e.Provider, { value: l, children: e.children });
}
function Ji() {
  var e = bo(__e);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function p_e(e) {
  var t = Ji(), n = t.locale, o = t.classNames, r = t.styles, i = t.formatters.formatCaption;
  return m("div", { className: o.caption_label, style: r.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: n }) });
}
function Ywc(e) {
  return m("svg", Mo({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: m("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function m_e(e) {
  var t, n, o = e.onChange, r = e.value, i = e.children, a = e.caption, s = e.className, c = e.style, l = Ji(), u = (n = (t = l.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : Ywc;
  return de("div", { className: s, style: c, children: [m("span", { className: l.classNames.vhidden, children: e["aria-label"] }), m("select", { name: e.name, "aria-label": e["aria-label"], className: l.classNames.dropdown, style: l.styles.dropdown, value: r, onChange: o, children: i }), de("div", { className: l.classNames.caption_label, style: l.styles.caption_label, "aria-hidden": "true", children: [a, m(u, { className: l.classNames.dropdown_icon, style: l.styles.dropdown_icon })] })] });
}
function Kwc(e) {
  var t, n = Ji(), o = n.fromDate, r = n.toDate, i = n.styles, a = n.locale, s = n.formatters.formatMonthCaption, c = n.classNames, l = n.components, u = n.labels.labelMonthDropdown;
  if (!o)
    return m(nt, {});
  if (!r)
    return m(nt, {});
  var d = [];
  if (Cwc(o, r))
    for (var _ = Ql(o), p = o.getMonth(); p <= r.getMonth(); p++)
      d.push(JN(_, p));
  else
    for (var _ = Ql(/* @__PURE__ */ new Date()), p = 0; p <= 11; p++)
      d.push(JN(_, p));
  var g = function(h) {
    var $ = Number(h.target.value), v = JN(Ql(e.displayMonth), $);
    e.onChange(v);
  }, f = (t = l == null ? void 0 : l.Dropdown) !== null && t !== void 0 ? t : m_e;
  return m(f, { name: "months", "aria-label": u(), className: c.dropdown_month, style: i.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: a }), children: d.map(function(h) {
    return m("option", { value: h.getMonth(), children: s(h, { locale: a }) }, h.getMonth());
  }) });
}
function Zwc(e) {
  var t, n = e.displayMonth, o = Ji(), r = o.fromDate, i = o.toDate, a = o.locale, s = o.styles, c = o.classNames, l = o.components, u = o.formatters.formatYearCaption, d = o.labels.labelYearDropdown, _ = [];
  if (!r)
    return m(nt, {});
  if (!i)
    return m(nt, {});
  for (var p = r.getFullYear(), g = i.getFullYear(), f = p; f <= g; f++)
    _.push(oH(o_e(/* @__PURE__ */ new Date()), f));
  var h = function(v) {
    var b = oH(Ql(n), Number(v.target.value));
    e.onChange(b);
  }, $ = (t = l == null ? void 0 : l.Dropdown) !== null && t !== void 0 ? t : m_e;
  return m($, { name: "years", "aria-label": d(), className: c.dropdown_year, style: s.dropdown_year, onChange: h, value: n.getFullYear(), caption: u(n, { locale: a }), children: _.map(function(v) {
    return m("option", { value: v.getFullYear(), children: u(v, { locale: a }) }, v.getFullYear());
  }) });
}
function Xwc(e, t) {
  var n = it(e), o = n[0], r = n[1], i = t === void 0 ? o : t;
  return [i, r];
}
function Jwc(e) {
  var t = e.month, n = e.defaultMonth, o = e.today, r = t || n || o || /* @__PURE__ */ new Date(), i = e.toDate, a = e.fromDate, s = e.numberOfMonths, c = s === void 0 ? 1 : s;
  if (i && Gk(i, r) < 0) {
    var l = -1 * (c - 1);
    r = q_(i, l);
  }
  return a && Gk(r, a) < 0 && (r = a), Ql(r);
}
function Qwc() {
  var e = Ji(), t = Jwc(e), n = Xwc(t, e.month), o = n[0], r = n[1], i = function(a) {
    var s;
    if (!e.disableNavigation) {
      var c = Ql(a);
      r(c), (s = e.onMonthChange) === null || s === void 0 || s.call(e, c);
    }
  };
  return [o, i];
}
function ekc(e, t) {
  for (var n = t.reverseMonths, o = t.numberOfMonths, r = Ql(e), i = Ql(q_(r, o)), a = Gk(i, r), s = [], c = 0; c < a; c++) {
    var l = q_(r, c);
    s.push(l);
  }
  return n && (s = s.reverse()), s;
}
function tkc(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, o = t.pagedNavigation, r = t.numberOfMonths, i = r === void 0 ? 1 : r, a = o ? i : 1, s = Ql(e);
    if (!n)
      return q_(s, a);
    var c = Gk(n, e);
    if (!(c < i))
      return q_(s, a);
  }
}
function nkc(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, o = t.pagedNavigation, r = t.numberOfMonths, i = r === void 0 ? 1 : r, a = o ? i : 1, s = Ql(e);
    if (!n)
      return q_(s, -a);
    var c = Gk(s, n);
    if (!(c <= 0))
      return q_(s, -a);
  }
}
var f_e = Cr(void 0);
function okc(e) {
  var t = Ji(), n = Qwc(), o = n[0], r = n[1], i = ekc(o, t), a = tkc(o, t), s = nkc(o, t), c = function(d) {
    return i.some(function(_) {
      return mq(d, _);
    });
  }, l = function(d, _) {
    c(d) || (_ && u_e(d, _) ? r(q_(d, 1 + t.numberOfMonths * -1)) : r(d));
  }, u = {
    currentMonth: o,
    displayMonths: i,
    goToMonth: r,
    goToDate: l,
    previousMonth: s,
    nextMonth: a,
    isDateDisplayed: c
  };
  return m(f_e.Provider, { value: u, children: e.children });
}
function Y0() {
  var e = bo(f_e);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function rH(e) {
  var t, n = Ji(), o = n.classNames, r = n.styles, i = n.components, a = Y0().goToMonth, s = function(u) {
    a(q_(u, e.displayIndex ? -e.displayIndex : 0));
  }, c = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : p_e, l = m(c, { id: e.id, displayMonth: e.displayMonth });
  return de("div", { className: o.caption_dropdowns, style: r.caption_dropdowns, children: [m("div", { className: o.vhidden, children: l }), m(Kwc, { onChange: s, displayMonth: e.displayMonth }), m(Zwc, { onChange: s, displayMonth: e.displayMonth })] });
}
function rkc(e) {
  return m("svg", Mo({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: m("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function ikc(e) {
  return m("svg", Mo({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: m("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var $C = Bt(function(e, t) {
  var n = Ji(), o = n.classNames, r = n.styles, i = [o.button_reset, o.button];
  e.className && i.push(e.className);
  var a = i.join(" "), s = Mo(Mo({}, r.button_reset), r.button);
  return e.style && Object.assign(s, e.style), m("button", Mo({}, e, { ref: t, type: "button", className: a, style: s }));
});
function akc(e) {
  var t, n, o = Ji(), r = o.dir, i = o.locale, a = o.classNames, s = o.styles, c = o.labels, l = c.labelPrevious, u = c.labelNext, d = o.components;
  if (!e.nextMonth && !e.previousMonth)
    return m(nt, {});
  var _ = l(e.previousMonth, { locale: i }), p = [
    a.nav_button,
    a.nav_button_previous
  ].join(" "), g = u(e.nextMonth, { locale: i }), f = [
    a.nav_button,
    a.nav_button_next
  ].join(" "), h = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : ikc, $ = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : rkc;
  return de("div", { className: a.nav, style: s.nav, children: [!e.hidePrevious && m($C, { name: "previous-month", "aria-label": _, className: p, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: r === "rtl" ? m(h, { className: a.nav_icon, style: s.nav_icon }) : m($, { className: a.nav_icon, style: s.nav_icon }) }), !e.hideNext && m($C, { name: "next-month", "aria-label": g, className: f, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: r === "rtl" ? m($, { className: a.nav_icon, style: s.nav_icon }) : m(h, { className: a.nav_icon, style: s.nav_icon }) })] });
}
function iH(e) {
  var t = Ji().numberOfMonths, n = Y0(), o = n.previousMonth, r = n.nextMonth, i = n.goToMonth, a = n.displayMonths, s = a.findIndex(function(g) {
    return mq(e.displayMonth, g);
  }), c = s === 0, l = s === a.length - 1, u = t > 1 && (c || !l), d = t > 1 && (l || !c), _ = function() {
    o && i(o);
  }, p = function() {
    r && i(r);
  };
  return m(akc, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: r, previousMonth: o, onPreviousClick: _, onNextClick: p });
}
function skc(e) {
  var t, n = Ji(), o = n.classNames, r = n.disableNavigation, i = n.styles, a = n.captionLayout, s = n.components, c = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : p_e, l;
  return r ? l = m(c, { id: e.id, displayMonth: e.displayMonth }) : a === "dropdown" ? l = m(rH, { displayMonth: e.displayMonth, id: e.id }) : a === "dropdown-buttons" ? l = de(nt, { children: [m(rH, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), m(iH, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : l = de(nt, { children: [m(c, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), m(iH, { displayMonth: e.displayMonth, id: e.id })] }), m("div", { className: o.caption, style: i.caption, children: l });
}
function ckc(e) {
  var t = Ji(), n = t.footer, o = t.styles, r = t.classNames.tfoot;
  return n ? m("tfoot", { className: r, style: o.tfoot, children: m("tr", { children: m("td", { colSpan: 8, children: n }) }) }) : m(nt, {});
}
function lkc(e, t, n) {
  for (var o = n ? vv(/* @__PURE__ */ new Date()) : Jp(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), r = [], i = 0; i < 7; i++) {
    var a = _l(o, i);
    r.push(a);
  }
  return r;
}
function ukc() {
  var e = Ji(), t = e.classNames, n = e.styles, o = e.showWeekNumber, r = e.locale, i = e.weekStartsOn, a = e.ISOWeek, s = e.formatters.formatWeekdayName, c = e.labels.labelWeekday, l = lkc(r, i, a);
  return de("tr", { style: n.head_row, className: t.head_row, children: [o && m("td", { style: n.head_cell, className: t.head_cell }), l.map(function(u, d) {
    return m("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": c(u, { locale: r }), children: s(u, { locale: r }) }, d);
  })] });
}
function dkc() {
  var e, t = Ji(), n = t.classNames, o = t.styles, r = t.components, i = (e = r == null ? void 0 : r.HeadRow) !== null && e !== void 0 ? e : ukc;
  return m("thead", { style: o.head, className: n.head, children: m(i, {}) });
}
function _kc(e) {
  var t = Ji(), n = t.locale, o = t.formatters.formatDay;
  return m(nt, { children: o(e.date, { locale: n }) });
}
var fq = Cr(void 0);
function pkc(e) {
  if (!W0(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return m(fq.Provider, { value: t, children: e.children });
  }
  return m(mkc, { initialProps: e.initialProps, children: e.children });
}
function mkc(e) {
  var t = e.initialProps, n = e.children, o = t.selected, r = t.min, i = t.max, a = function(l, u, d) {
    var _, p;
    (_ = t.onDayClick) === null || _ === void 0 || _.call(t, l, u, d);
    var g = !!(u.selected && r && (o == null ? void 0 : o.length) === r);
    if (!g) {
      var f = !!(!u.selected && i && (o == null ? void 0 : o.length) === i);
      if (!f) {
        var h = o ? d_e([], o, !0) : [];
        if (u.selected) {
          var $ = h.findIndex(function(v) {
            return Kl(l, v);
          });
          h.splice($, 1);
        } else
          h.push(l);
        (p = t.onSelect) === null || p === void 0 || p.call(t, h, l, u, d);
      }
    }
  }, s = {
    disabled: []
  };
  o && s.disabled.push(function(l) {
    var u = i && o.length > i - 1, d = o.some(function(_) {
      return Kl(_, l);
    });
    return !!(u && !d);
  });
  var c = {
    selected: o,
    onDayClick: a,
    modifiers: s
  };
  return m(fq.Provider, { value: c, children: n });
}
function gq() {
  var e = bo(fq);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function fkc(e, t) {
  var n = t || {}, o = n.from, r = n.to;
  return o && r ? Kl(r, e) && Kl(o, e) ? void 0 : Kl(r, e) ? { from: r, to: void 0 } : Kl(o, e) ? void 0 : W4(o, e) ? { from: e, to: r } : { from: o, to: e } : r ? W4(e, r) ? { from: r, to: e } : { from: e, to: r } : o ? u_e(e, o) ? { from: e, to: o } : { from: o, to: e } : { from: e, to: void 0 };
}
var hq = Cr(void 0);
function gkc(e) {
  if (!H0(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return m(hq.Provider, { value: t, children: e.children });
  }
  return m(hkc, { initialProps: e.initialProps, children: e.children });
}
function hkc(e) {
  var t = e.initialProps, n = e.children, o = t.selected, r = o || {}, i = r.from, a = r.to, s = t.min, c = t.max, l = function(p, g, f) {
    var h, $;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, p, g, f);
    var v = fkc(p, o);
    ($ = t.onSelect) === null || $ === void 0 || $.call(t, v, p, g, f);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (u.range_start = [i], a ? (u.range_end = [a], Kl(i, a) || (u.range_middle = [
    {
      after: i,
      before: a
    }
  ])) : u.range_end = [i]) : a && (u.range_start = [a], u.range_end = [a]), s && (i && !a && u.disabled.push({
    after: XN(i, s - 1),
    before: _l(i, s - 1)
  }), i && a && u.disabled.push({
    after: i,
    before: _l(i, s - 1)
  }), !i && a && u.disabled.push({
    after: XN(a, s - 1),
    before: _l(a, s - 1)
  })), c) {
    if (i && !a && (u.disabled.push({
      before: _l(i, -c + 1)
    }), u.disabled.push({
      after: _l(i, c - 1)
    })), i && a) {
      var d = Vp(a, i) + 1, _ = c - d;
      u.disabled.push({
        before: XN(i, _)
      }), u.disabled.push({
        after: _l(a, _)
      });
    }
    !i && a && (u.disabled.push({
      before: _l(a, -c + 1)
    }), u.disabled.push({
      after: _l(a, c - 1)
    }));
  }
  return m(hq.Provider, { value: { selected: o, onDayClick: l, modifiers: u }, children: n });
}
function vq() {
  var e = bo(hq);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function dx(e) {
  return Array.isArray(e) ? d_e([], e, !0) : e !== void 0 ? [e] : [];
}
function vkc(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var o = n[0], r = n[1];
    t[o] = dx(r);
  }), t;
}
var j_;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(j_ || (j_ = {}));
var bkc = j_.Selected, Mm = j_.Disabled, ykc = j_.Hidden, $kc = j_.Today, QN = j_.RangeEnd, ez = j_.RangeMiddle, tz = j_.RangeStart, wkc = j_.Outside;
function kkc(e, t, n) {
  var o, r = (o = {}, o[bkc] = dx(e.selected), o[Mm] = dx(e.disabled), o[ykc] = dx(e.hidden), o[$kc] = [e.today], o[QN] = [], o[ez] = [], o[tz] = [], o[wkc] = [], o);
  return e.fromDate && r[Mm].push({ before: e.fromDate }), e.toDate && r[Mm].push({ after: e.toDate }), W0(e) ? r[Mm] = r[Mm].concat(t.modifiers[Mm]) : H0(e) && (r[Mm] = r[Mm].concat(n.modifiers[Mm]), r[tz] = n.modifiers[tz], r[ez] = n.modifiers[ez], r[QN] = n.modifiers[QN]), r;
}
var g_e = Cr(void 0);
function Skc(e) {
  var t = Ji(), n = gq(), o = vq(), r = kkc(t, n, o), i = vkc(t.modifiers), a = Mo(Mo({}, r), i);
  return m(g_e.Provider, { value: a, children: e.children });
}
function h_e() {
  var e = bo(g_e);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function Ekc(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function xkc(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function Ckc(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Tkc(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Akc(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Ikc(e, t) {
  var n, o = t.from, r = t.to;
  if (o && r) {
    var i = Vp(r, o) < 0;
    i && (n = [r, o], o = n[0], r = n[1]);
    var a = Vp(e, o) >= 0 && Vp(r, e) >= 0;
    return a;
  }
  return r ? Kl(r, e) : o ? Kl(o, e) : !1;
}
function Okc(e) {
  return dq(e);
}
function Nkc(e) {
  return Array.isArray(e) && e.every(dq);
}
function zkc(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (Okc(n))
      return Kl(e, n);
    if (Nkc(n))
      return n.includes(e);
    if (xkc(n))
      return Ikc(e, n);
    if (Akc(n))
      return n.dayOfWeek.includes(e.getDay());
    if (Ekc(n)) {
      var o = Vp(n.before, e), r = Vp(n.after, e), i = o > 0, a = r < 0, s = W4(n.before, n.after);
      return s ? a && i : i || a;
    }
    return Ckc(n) ? Vp(e, n.after) > 0 : Tkc(n) ? Vp(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function bq(e, t, n) {
  var o = Object.keys(t).reduce(function(i, a) {
    var s = t[a];
    return zkc(e, s) && i.push(a), i;
  }, []), r = {};
  return o.forEach(function(i) {
    return r[i] = !0;
  }), n && !mq(e, n) && (r.outside = !0), r;
}
function Rkc(e, t) {
  for (var n = Ql(e[0]), o = _q(e[e.length - 1]), r, i, a = n; a <= o; ) {
    var s = bq(a, t), c = !s.disabled && !s.hidden;
    if (!c) {
      a = _l(a, 1);
      continue;
    }
    if (s.selected)
      return a;
    s.today && !i && (i = a), r || (r = a), a = _l(a, 1);
  }
  return i || r;
}
var Pkc = 365;
function v_e(e, t) {
  var n = t.moveBy, o = t.direction, r = t.context, i = t.modifiers, a = t.retry, s = a === void 0 ? { count: 0, lastFocused: e } : a, c = r.weekStartsOn, l = r.fromDate, u = r.toDate, d = r.locale, _ = {
    day: _l,
    week: G4,
    month: q_,
    year: w$c,
    startOfWeek: function(h) {
      return r.ISOWeek ? vv(h) : Jp(h, { locale: d, weekStartsOn: c });
    },
    endOfWeek: function(h) {
      return r.ISOWeek ? r_e(h) : pq(h, { locale: d, weekStartsOn: c });
    }
  }, p = _[n](e, o === "after" ? 1 : -1);
  o === "before" && l ? p = k$c([l, p]) : o === "after" && u && (p = S$c([u, p]));
  var g = !0;
  if (i) {
    var f = bq(p, i);
    g = !f.disabled && !f.hidden;
  }
  return g ? p : s.count > Pkc ? s.lastFocused : v_e(p, {
    moveBy: n,
    direction: o,
    context: r,
    modifiers: i,
    retry: Mo(Mo({}, s), { count: s.count + 1 })
  });
}
var b_e = Cr(void 0);
function Dkc(e) {
  var t = Y0(), n = h_e(), o = it(), r = o[0], i = o[1], a = it(), s = a[0], c = a[1], l = Rkc(t.displayMonths, n), u = r ?? (s && t.isDateDisplayed(s)) ? s : l, d = function() {
    c(r), i(void 0);
  }, _ = function(h) {
    i(h);
  }, p = Ji(), g = function(h, $) {
    if (r) {
      var v = v_e(r, {
        moveBy: h,
        direction: $,
        context: p,
        modifiers: n
      });
      Kl(r, v) || (t.goToDate(v, r), _(v));
    }
  }, f = {
    focusedDay: r,
    focusTarget: u,
    blur: d,
    focus: _,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return m(b_e.Provider, { value: f, children: e.children });
}
function yq() {
  var e = bo(b_e);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function Lkc(e, t) {
  var n = h_e(), o = bq(e, n, t);
  return o;
}
var $q = Cr(void 0);
function Mkc(e) {
  if (!sA(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return m($q.Provider, { value: t, children: e.children });
  }
  return m(Fkc, { initialProps: e.initialProps, children: e.children });
}
function Fkc(e) {
  var t = e.initialProps, n = e.children, o = function(i, a, s) {
    var c, l, u;
    if ((c = t.onDayClick) === null || c === void 0 || c.call(t, i, a, s), a.selected && !t.required) {
      (l = t.onSelect) === null || l === void 0 || l.call(t, void 0, i, a, s);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, i, i, a, s);
  }, r = {
    selected: t.selected,
    onDayClick: o
  };
  return m($q.Provider, { value: r, children: n });
}
function y_e() {
  var e = bo($q);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function qkc(e, t) {
  var n = Ji(), o = y_e(), r = gq(), i = vq(), a = yq(), s = a.focusDayAfter, c = a.focusDayBefore, l = a.focusWeekAfter, u = a.focusWeekBefore, d = a.blur, _ = a.focus, p = a.focusMonthBefore, g = a.focusMonthAfter, f = a.focusYearBefore, h = a.focusYearAfter, $ = a.focusStartOfWeek, v = a.focusEndOfWeek, b = function(k) {
    var I, z, F, P;
    sA(n) ? (I = o.onDayClick) === null || I === void 0 || I.call(o, e, t, k) : W0(n) ? (z = r.onDayClick) === null || z === void 0 || z.call(r, e, t, k) : H0(n) ? (F = i.onDayClick) === null || F === void 0 || F.call(i, e, t, k) : (P = n.onDayClick) === null || P === void 0 || P.call(n, e, t, k);
  }, y = function(k) {
    var I;
    _(e), (I = n.onDayFocus) === null || I === void 0 || I.call(n, e, t, k);
  }, w = function(k) {
    var I;
    d(), (I = n.onDayBlur) === null || I === void 0 || I.call(n, e, t, k);
  }, N = function(k) {
    var I;
    (I = n.onDayMouseEnter) === null || I === void 0 || I.call(n, e, t, k);
  }, M = function(k) {
    var I;
    (I = n.onDayMouseLeave) === null || I === void 0 || I.call(n, e, t, k);
  }, q = function(k) {
    var I;
    (I = n.onDayPointerEnter) === null || I === void 0 || I.call(n, e, t, k);
  }, L = function(k) {
    var I;
    (I = n.onDayPointerLeave) === null || I === void 0 || I.call(n, e, t, k);
  }, R = function(k) {
    var I;
    (I = n.onDayTouchCancel) === null || I === void 0 || I.call(n, e, t, k);
  }, T = function(k) {
    var I;
    (I = n.onDayTouchEnd) === null || I === void 0 || I.call(n, e, t, k);
  }, D = function(k) {
    var I;
    (I = n.onDayTouchMove) === null || I === void 0 || I.call(n, e, t, k);
  }, A = function(k) {
    var I;
    (I = n.onDayTouchStart) === null || I === void 0 || I.call(n, e, t, k);
  }, S = function(k) {
    var I;
    (I = n.onDayKeyUp) === null || I === void 0 || I.call(n, e, t, k);
  }, E = function(k) {
    var I;
    switch (k.key) {
      case "ArrowLeft":
        k.preventDefault(), k.stopPropagation(), n.dir === "rtl" ? s() : c();
        break;
      case "ArrowRight":
        k.preventDefault(), k.stopPropagation(), n.dir === "rtl" ? c() : s();
        break;
      case "ArrowDown":
        k.preventDefault(), k.stopPropagation(), l();
        break;
      case "ArrowUp":
        k.preventDefault(), k.stopPropagation(), u();
        break;
      case "PageUp":
        k.preventDefault(), k.stopPropagation(), k.shiftKey ? f() : p();
        break;
      case "PageDown":
        k.preventDefault(), k.stopPropagation(), k.shiftKey ? h() : g();
        break;
      case "Home":
        k.preventDefault(), k.stopPropagation(), $();
        break;
      case "End":
        k.preventDefault(), k.stopPropagation(), v();
        break;
    }
    (I = n.onDayKeyDown) === null || I === void 0 || I.call(n, e, t, k);
  }, x = {
    onClick: b,
    onFocus: y,
    onBlur: w,
    onKeyDown: E,
    onKeyUp: S,
    onMouseEnter: N,
    onMouseLeave: M,
    onPointerEnter: q,
    onPointerLeave: L,
    onTouchCancel: R,
    onTouchEnd: T,
    onTouchMove: D,
    onTouchStart: A
  };
  return x;
}
function jkc() {
  var e = Ji(), t = y_e(), n = gq(), o = vq(), r = sA(e) ? t.selected : W0(e) ? n.selected : H0(e) ? o.selected : void 0;
  return r;
}
function Vkc(e) {
  return Object.values(j_).includes(e);
}
function Bkc(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(o) {
    var r = e.modifiersClassNames[o];
    if (r)
      n.push(r);
    else if (Vkc(o)) {
      var i = e.classNames["day_".concat(o)];
      i && n.push(i);
    }
  }), n;
}
function Ukc(e, t) {
  var n = Mo({}, e.styles.day);
  return Object.keys(t).forEach(function(o) {
    var r;
    n = Mo(Mo({}, n), (r = e.modifiersStyles) === null || r === void 0 ? void 0 : r[o]);
  }), n;
}
function Gkc(e, t, n) {
  var o, r, i, a = Ji(), s = yq(), c = Lkc(e, t), l = qkc(e, c), u = jkc(), d = !!(a.onDayClick || a.mode !== "default");
  yt(function() {
    var N;
    c.outside || s.focusedDay && d && Kl(s.focusedDay, e) && ((N = n.current) === null || N === void 0 || N.focus());
  }, [
    s.focusedDay,
    e,
    n,
    d,
    c.outside
  ]);
  var _ = Bkc(a, c).join(" "), p = Ukc(a, c), g = !!(c.outside && !a.showOutsideDays || c.hidden), f = (i = (r = a.components) === null || r === void 0 ? void 0 : r.DayContent) !== null && i !== void 0 ? i : _kc, h = m(f, { date: e, displayMonth: t, activeModifiers: c }), $ = {
    style: p,
    className: _,
    children: h,
    role: "gridcell"
  }, v = s.focusTarget && Kl(s.focusTarget, e) && !c.outside, b = s.focusedDay && Kl(s.focusedDay, e), y = Mo(Mo(Mo({}, $), (o = { disabled: c.disabled, role: "gridcell" }, o["aria-selected"] = c.selected, o.tabIndex = b || v ? 0 : -1, o)), l), w = {
    isButton: d,
    isHidden: g,
    activeModifiers: c,
    selectedDays: u,
    buttonProps: y,
    divProps: $
  };
  return w;
}
function Wkc(e) {
  var t = xt(null), n = Gkc(e.date, e.displayMonth, t);
  return n.isHidden ? m("div", { role: "gridcell" }) : n.isButton ? m($C, Mo({ name: "day", ref: t }, n.buttonProps)) : m("div", Mo({}, n.divProps));
}
function Hkc(e) {
  var t = e.number, n = e.dates, o = Ji(), r = o.onWeekNumberClick, i = o.styles, a = o.classNames, s = o.locale, c = o.labels.labelWeekNumber, l = o.formatters.formatWeekNumber, u = l(Number(t), { locale: s });
  if (!r)
    return m("span", { className: a.weeknumber, style: i.weeknumber, children: u });
  var d = c(Number(t), { locale: s }), _ = function(p) {
    r(t, n, p);
  };
  return m($C, { name: "week-number", "aria-label": d, className: a.weeknumber, style: i.weeknumber, onClick: _, children: u });
}
function Ykc(e) {
  var t, n, o = Ji(), r = o.styles, i = o.classNames, a = o.showWeekNumber, s = o.components, c = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : Wkc, l = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : Hkc, u;
  return a && (u = m("td", { className: i.cell, style: r.cell, children: m(l, { number: e.weekNumber, dates: e.dates }) })), de("tr", { className: i.row, style: r.row, children: [u, e.dates.map(function(d) {
    return m("td", { className: i.cell, style: r.cell, role: "presentation", children: m(c, { displayMonth: e.displayMonth, date: d }) }, Swc(d));
  })] });
}
function aH(e, t, n) {
  for (var o = n != null && n.ISOWeek ? r_e(t) : pq(t, n), r = n != null && n.ISOWeek ? vv(e) : Jp(e, n), i = Vp(o, r), a = [], s = 0; s <= i; s++)
    a.push(_l(r, s));
  var c = a.reduce(function(l, u) {
    var d = n != null && n.ISOWeek ? a_e(u) : c_e(u, n), _ = l.find(function(p) {
      return p.weekNumber === d;
    });
    return _ ? (_.dates.push(u), l) : (l.push({
      weekNumber: d,
      dates: [u]
    }), l);
  }, []);
  return c;
}
function Kkc(e, t) {
  var n = aH(Ql(e), _q(e), t);
  if (t != null && t.useFixedWeeks) {
    var o = xwc(e, t);
    if (o < 6) {
      var r = n[n.length - 1], i = r.dates[r.dates.length - 1], a = G4(i, 6 - o), s = aH(G4(i, 1), a, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function Zkc(e) {
  var t, n, o, r = Ji(), i = r.locale, a = r.classNames, s = r.styles, c = r.hideHead, l = r.fixedWeeks, u = r.components, d = r.weekStartsOn, _ = r.firstWeekContainsDate, p = r.ISOWeek, g = Kkc(e.displayMonth, {
    useFixedWeeks: !!l,
    ISOWeek: p,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: _
  }), f = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : dkc, h = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : Ykc, $ = (o = u == null ? void 0 : u.Footer) !== null && o !== void 0 ? o : ckc;
  return de("table", { id: e.id, className: a.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!c && m(f, {}), m("tbody", { className: a.tbody, style: s.tbody, children: g.map(function(v) {
    return m(h, { displayMonth: e.displayMonth, dates: v.dates, weekNumber: v.weekNumber }, v.weekNumber);
  }) }), m($, { displayMonth: e.displayMonth })] });
}
function Xkc() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Jkc = Xkc() ? lc : yt, nz = !1, Qkc = 0;
function sH() {
  return "react-day-picker-".concat(++Qkc);
}
function e0c(e) {
  var t, n = e ?? (nz ? sH() : null), o = it(n), r = o[0], i = o[1];
  return Jkc(function() {
    r === null && i(sH());
  }, []), yt(function() {
    nz === !1 && (nz = !0);
  }, []), (t = e ?? r) !== null && t !== void 0 ? t : void 0;
}
function t0c(e) {
  var t, n, o = Ji(), r = o.dir, i = o.classNames, a = o.styles, s = o.components, c = Y0().displayMonths, l = e0c(o.id ? "".concat(o.id, "-").concat(e.displayIndex) : void 0), u = o.id ? "".concat(o.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], _ = a.month, p = e.displayIndex === 0, g = e.displayIndex === c.length - 1, f = !p && !g;
  r === "rtl" && (t = [p, g], g = t[0], p = t[1]), p && (d.push(i.caption_start), _ = Mo(Mo({}, _), a.caption_start)), g && (d.push(i.caption_end), _ = Mo(Mo({}, _), a.caption_end)), f && (d.push(i.caption_between), _ = Mo(Mo({}, _), a.caption_between));
  var h = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : skc;
  return de("div", { className: d.join(" "), style: _, children: [m(h, { id: l, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), m(Zkc, { id: u, "aria-labelledby": l, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function n0c(e) {
  var t = Ji(), n = t.classNames, o = t.styles;
  return m("div", { className: n.months, style: o.months, children: e.children });
}
function o0c(e) {
  var t, n, o = e.initialProps, r = Ji(), i = yq(), a = Y0(), s = it(!1), c = s[0], l = s[1];
  yt(function() {
    r.initialFocus && i.focusTarget && (c || (i.focus(i.focusTarget), l(!0)));
  }, [
    r.initialFocus,
    c,
    i.focus,
    i.focusTarget,
    i
  ]);
  var u = [r.classNames.root, r.className];
  r.numberOfMonths > 1 && u.push(r.classNames.multiple_months), r.showWeekNumber && u.push(r.classNames.with_weeknumber);
  var d = Mo(Mo({}, r.styles.root), r.style), _ = Object.keys(o).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, f) {
    var h;
    return Mo(Mo({}, g), (h = {}, h[f] = o[f], h));
  }, {}), p = (n = (t = o.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : n0c;
  return m("div", Mo({ className: u.join(" "), style: d, dir: r.dir, id: r.id, nonce: o.nonce, title: o.title, lang: o.lang }, _, { children: m(p, { children: a.displayMonths.map(function(g, f) {
    return m(t0c, { displayIndex: f, displayMonth: g }, f);
  }) }) }));
}
function r0c(e) {
  var t = e.children, n = Twc(e, ["children"]);
  return m(Hwc, { initialProps: n, children: m(okc, { children: m(Mkc, { initialProps: n, children: m(pkc, { initialProps: n, children: m(gkc, { initialProps: n, children: m(Skc, { children: m(Dkc, { children: t }) }) }) }) }) }) });
}
function i0c(e) {
  return m(r0c, Mo({}, e, { children: m(o0c, { initialProps: e }) }));
}
function $_e({
  className: e,
  classNames: t,
  fromDate: n,
  toDate: o,
  showOutsideDays: r = !0,
  ...i
}) {
  return /* @__PURE__ */ m(
    i0c,
    {
      fromDate: n,
      toDate: o || void 0,
      showOutsideDays: r,
      className: xe("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex pt-1 relative items-center justify-between",
        caption_label: "text-sm font-medium",
        nav: "flex items-center",
        head: "",
        head_row: "flex w-full items-center justify-between",
        head_cell: "w-8 md:w-11 h-8 text-sm font-medium text-default text-center",
        nav_button: xe(Ix({ color: "minimal", variant: "icon" })),
        table: "w-full border-collapse space-y-1",
        row: "flex w-full mt-0.5 gap-0.5",
        cell: "w-8 h-8 md:h-11 md:w-11 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: xe(
          Ix({ color: "minimal" }),
          "w-8 h-8 md:h-11 md:w-11 p-0 text-sm font-medium aria-selected:opacity-100 inline-flex items-center justify-center"
        ),
        day_range_end: "hover:!bg-inverted hover:!text-inverted",
        day_range_start: "hover:!bg-inverted hover:!text-inverted",
        day_selected: "bg-inverted text-inverted",
        day_today: "",
        day_outside: "",
        day_disabled: "text-muted opacity-50",
        day_range_middle: "aria-selected:bg-emphasis aria-selected:text-emphasis",
        day_hidden: "invisible",
        ...t
      },
      components: {
        CaptionLabel: (a) => /* @__PURE__ */ de("div", { className: "px-2", children: [
          /* @__PURE__ */ de("span", { className: "text-emphasis font-semibold leading-none", children: [
            ht(a.displayMonth).format("MMMM"),
            " "
          ] }),
          /* @__PURE__ */ m("span", { className: "text-subtle font-medium leading-none", children: ht(a.displayMonth).format("YYYY") })
        ] }),
        IconLeft: () => /* @__PURE__ */ m(qt, { name: "chevron-left", className: "h-4 w-4 stroke-2" }),
        IconRight: () => /* @__PURE__ */ m(qt, { name: "chevron-right", className: "h-4 w-4 stroke-2" })
      },
      ...i
    }
  );
}
$_e.displayName = "Calendar";
const a0c = ({ minDate: e, disabled: t, date: n, onDatesChange: o, className: r }) => {
  function i(c) {
    o == null || o(c ?? /* @__PURE__ */ new Date());
  }
  const s = /* @__PURE__ */ m(
    $_e,
    {
      initialFocus: !0,
      fromDate: e === null ? void 0 : e ?? /* @__PURE__ */ new Date(),
      mode: "single",
      defaultMonth: n,
      selected: n,
      onDayClick: (c) => i(c),
      numberOfMonths: 1,
      disabled: t
    }
  );
  return /* @__PURE__ */ m("div", { className: xe("grid gap-2", r), children: /* @__PURE__ */ de(Yde, { children: [
    /* @__PURE__ */ m(Kde, { asChild: !0, children: /* @__PURE__ */ m(
      Jt,
      {
        "data-testid": "pick-date",
        color: "secondary",
        EndIcon: "calendar",
        className: xe("justify-between text-left font-normal", !n && "text-subtle"),
        children: n ? /* @__PURE__ */ m(nt, { children: xf(n, "LLL dd, y") }) : /* @__PURE__ */ m("span", { children: "Pick a date" })
      }
    ) }),
    /* @__PURE__ */ m(
      Zde,
      {
        className: "bg-default text-emphasis z-50 w-auto rounded-md border p-0 outline-none",
        align: "start",
        sideOffset: 4,
        children: s
      }
    )
  ] }) });
}, s0c = a0c;
function Xy() {
  return (Xy = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }).apply(this, arguments);
}
function cA(e, t) {
  if (e == null)
    return {};
  var n, o, r = {}, i = Object.keys(e);
  for (o = 0; o < i.length; o++)
    t.indexOf(n = i[o]) >= 0 || (r[n] = e[n]);
  return r;
}
function Wk(e) {
  var t = xt(e), n = xt(function(o) {
    t.current && t.current(o);
  });
  return t.current = e, n.current;
}
var Hk = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, Zw = function(e) {
  return "touches" in e;
}, H4 = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, cH = function(e, t, n) {
  var o = e.getBoundingClientRect(), r = Zw(t) ? function(i, a) {
    for (var s = 0; s < i.length; s++)
      if (i[s].identifier === a)
        return i[s];
    return i[0];
  }(t.touches, n) : t;
  return { left: Hk((r.pageX - (o.left + H4(e).pageXOffset)) / o.width), top: Hk((r.pageY - (o.top + H4(e).pageYOffset)) / o.height) };
}, lH = function(e) {
  !Zw(e) && e.preventDefault();
}, w_e = Fe.memo(function(e) {
  var t = e.onMove, n = e.onKey, o = cA(e, ["onMove", "onKey"]), r = xt(null), i = Wk(t), a = Wk(n), s = xt(null), c = xt(!1), l = vn(function() {
    var p = function(h) {
      lH(h), (Zw(h) ? h.touches.length > 0 : h.buttons > 0) && r.current ? i(cH(r.current, h, s.current)) : f(!1);
    }, g = function() {
      return f(!1);
    };
    function f(h) {
      var $ = c.current, v = H4(r.current), b = h ? v.addEventListener : v.removeEventListener;
      b($ ? "touchmove" : "mousemove", p), b($ ? "touchend" : "mouseup", g);
    }
    return [function(h) {
      var $ = h.nativeEvent, v = r.current;
      if (v && (lH($), !function(y, w) {
        return w && !Zw(y);
      }($, c.current) && v)) {
        if (Zw($)) {
          c.current = !0;
          var b = $.changedTouches || [];
          b.length && (s.current = b[0].identifier);
        }
        v.focus(), i(cH(v, $, s.current)), f(!0);
      }
    }, function(h) {
      var $ = h.which || h.keyCode;
      $ < 37 || $ > 40 || (h.preventDefault(), a({ left: $ === 39 ? 0.05 : $ === 37 ? -0.05 : 0, top: $ === 40 ? 0.05 : $ === 38 ? -0.05 : 0 }));
    }, f];
  }, [a, i]), u = l[0], d = l[1], _ = l[2];
  return yt(function() {
    return _;
  }, [_]), Fe.createElement("div", Xy({}, o, { onTouchStart: u, onMouseDown: u, className: "react-colorful__interactive", ref: r, onKeyDown: d, tabIndex: 0, role: "slider" }));
}), wq = function(e) {
  return e.filter(Boolean).join(" ");
}, k_e = function(e) {
  var t = e.color, n = e.left, o = e.top, r = o === void 0 ? 0.5 : o, i = wq(["react-colorful__pointer", e.className]);
  return Fe.createElement("div", { className: i, style: { top: 100 * r + "%", left: 100 * n + "%" } }, Fe.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, ac = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, c0c = function(e) {
  return p0c(Y4(e));
}, Y4 = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? ac(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? ac(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, l0c = function(e) {
  return _0c(d0c(e));
}, u0c = function(e) {
  var t = e.s, n = e.v, o = e.a, r = (200 - t) * n / 100;
  return { h: ac(e.h), s: ac(r > 0 && r < 200 ? t * n / 100 / (r <= 100 ? r : 200 - r) * 100 : 0), l: ac(r / 2), a: ac(o, 2) };
}, K4 = function(e) {
  var t = u0c(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, d0c = function(e) {
  var t = e.h, n = e.s, o = e.v, r = e.a;
  t = t / 360 * 6, n /= 100, o /= 100;
  var i = Math.floor(t), a = o * (1 - n), s = o * (1 - (t - i) * n), c = o * (1 - (1 - t + i) * n), l = i % 6;
  return { r: ac(255 * [o, s, a, a, c, o][l]), g: ac(255 * [c, o, o, s, a, a][l]), b: ac(255 * [a, a, c, o, o, s][l]), a: ac(r, 2) };
}, KS = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, _0c = function(e) {
  var t = e.r, n = e.g, o = e.b, r = e.a, i = r < 1 ? KS(ac(255 * r)) : "";
  return "#" + KS(t) + KS(n) + KS(o) + i;
}, p0c = function(e) {
  var t = e.r, n = e.g, o = e.b, r = e.a, i = Math.max(t, n, o), a = i - Math.min(t, n, o), s = a ? i === t ? (n - o) / a : i === n ? 2 + (o - t) / a : 4 + (t - n) / a : 0;
  return { h: ac(60 * (s < 0 ? s + 6 : s)), s: ac(i ? a / i * 100 : 0), v: ac(i / 255 * 100), a: r };
}, m0c = Fe.memo(function(e) {
  var t = e.hue, n = e.onChange, o = wq(["react-colorful__hue", e.className]);
  return Fe.createElement("div", { className: o }, Fe.createElement(w_e, { onMove: function(r) {
    n({ h: 360 * r.left });
  }, onKey: function(r) {
    n({ h: Hk(t + 360 * r.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": ac(t), "aria-valuemax": "360", "aria-valuemin": "0" }, Fe.createElement(k_e, { className: "react-colorful__hue-pointer", left: t / 360, color: K4({ h: t, s: 100, v: 100, a: 1 }) })));
}), f0c = Fe.memo(function(e) {
  var t = e.hsva, n = e.onChange, o = { backgroundColor: K4({ h: t.h, s: 100, v: 100, a: 1 }) };
  return Fe.createElement("div", { className: "react-colorful__saturation", style: o }, Fe.createElement(w_e, { onMove: function(r) {
    n({ s: 100 * r.left, v: 100 - 100 * r.top });
  }, onKey: function(r) {
    n({ s: Hk(t.s + 100 * r.left, 0, 100), v: Hk(t.v - 100 * r.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + ac(t.s) + "%, Brightness " + ac(t.v) + "%" }, Fe.createElement(k_e, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: K4(t) })));
}), S_e = function(e, t) {
  if (e === t)
    return !0;
  for (var n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, g0c = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || S_e(Y4(e), Y4(t));
};
function h0c(e, t, n) {
  var o = Wk(n), r = it(function() {
    return e.toHsva(t);
  }), i = r[0], a = r[1], s = xt({ color: t, hsva: i });
  yt(function() {
    if (!e.equal(t, s.current.color)) {
      var l = e.toHsva(t);
      s.current = { hsva: l, color: t }, a(l);
    }
  }, [t, e]), yt(function() {
    var l;
    S_e(i, s.current.hsva) || e.equal(l = e.fromHsva(i), s.current.color) || (s.current = { hsva: i, color: l }, o(l));
  }, [i, e, o]);
  var c = Yt(function(l) {
    a(function(u) {
      return Object.assign({}, u, l);
    });
  }, []);
  return [i, c];
}
var v0c = typeof window < "u" ? lc : yt, b0c = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, uH = /* @__PURE__ */ new Map(), y0c = function(e) {
  v0c(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !uH.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, uH.set(t, n);
      var o = b0c();
      o && n.setAttribute("nonce", o), t.head.appendChild(n);
    }
  }, []);
}, $0c = function(e) {
  var t = e.className, n = e.colorModel, o = e.color, r = o === void 0 ? n.defaultColor : o, i = e.onChange, a = cA(e, ["className", "colorModel", "color", "onChange"]), s = xt(null);
  y0c(s);
  var c = h0c(n, r, i), l = c[0], u = c[1], d = wq(["react-colorful", t]);
  return Fe.createElement("div", Xy({}, a, { ref: s, className: d }), Fe.createElement(f0c, { hsva: l, onChange: u }), Fe.createElement(m0c, { hue: l.h, onChange: u, className: "react-colorful__last-control" }));
}, w0c = { defaultColor: "000", toHsva: c0c, fromHsva: function(e) {
  return l0c({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: g0c }, k0c = function(e) {
  return Fe.createElement($0c, Xy({}, e, { colorModel: w0c }));
}, S0c = /^#?([0-9A-F]{3,8})$/i, E0c = function(e) {
  var t = e.color, n = t === void 0 ? "" : t, o = e.onChange, r = e.onBlur, i = e.escape, a = e.validate, s = e.format, c = e.process, l = cA(e, ["color", "onChange", "onBlur", "escape", "validate", "format", "process"]), u = it(function() {
    return i(n);
  }), d = u[0], _ = u[1], p = Wk(o), g = Wk(r), f = Yt(function($) {
    var v = i($.target.value);
    _(v), a(v) && p(c ? c(v) : v);
  }, [i, c, a, p]), h = Yt(function($) {
    a($.target.value) || _(i(n)), g($);
  }, [n, i, a, g]);
  return yt(function() {
    _(i(n));
  }, [n, i]), Fe.createElement("input", Xy({}, l, { value: s ? s(d) : d, spellCheck: "false", onChange: f, onBlur: h }));
}, dH = function(e) {
  return "#" + e;
}, x0c = function(e) {
  var t = e.prefixed, n = e.alpha, o = cA(e, ["prefixed", "alpha"]), r = Yt(function(a) {
    return a.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
  }, [n]), i = Yt(function(a) {
    return function(s, c) {
      var l = S0c.exec(s), u = l ? l[1].length : 0;
      return u === 3 || u === 6 || !!c && u === 4 || !!c && u === 8;
    }(a, n);
  }, [n]);
  return Fe.createElement(E0c, Xy({}, o, { escape: r, format: t ? dH : void 0, process: dH, validate: i }));
};
function C0c(e) {
  const t = {};
  if (e === null)
    return t;
  for (const [n, o] of e)
    if (t.hasOwnProperty(n)) {
      let r = t[n];
      Array.isArray(r) || (r = [r]), r.push(o), t[n] = r;
    } else
      t[n] = o;
  return t;
}
function T0c({
  param: e,
  value: t,
  container: n
}) {
  const o = C0c(n.entries());
  if (!n.has(e))
    return !1;
  const r = o[e], i = Array.isArray(t) ? t : [t];
  return i.length !== r.length ? !1 : i.every((a) => r.includes(a));
}
function A0c() {
  if (typeof window > "u" || window.isEmbed)
    return;
  const e = new URL(document.URL), t = e.searchParams.get("embed"), n = e.pathname.endsWith("/embed"), o = "", r = typeof t == "string" ? t : window.name.includes("cal-embed=") ? window.name.replace(/cal-embed=(.*)/, "$1").trim() : n ? o : null;
  window.isEmbed = () => typeof r == "string", window.getEmbedTheme = () => window.CalEmbed.embedStore.theme ? window.CalEmbed.embedStore.theme : new URL(document.URL).searchParams.get("theme"), window.getEmbedNamespace = () => r, window.CalEmbed = window.CalEmbed || {}, window.CalEmbed.applyCssVars = (i) => {
    const a = [];
    if (i)
      for (const [l, u] of Object.entries(i)) {
        a.push(`.${l} {`);
        for (const [d, _] of Object.entries(u))
          a.push(`--${d}: ${_} !important;`);
        a.push("}");
      }
    const s = document.head.querySelector("#embed-css-vars");
    if (s) {
      console.warn("Existing embed CSS Vars are being reset"), s.innerText = a.join(`
`);
      return;
    }
    const c = document.createElement("style");
    c.id = "embed-css-vars", c.innerText = a.join(`
`), document.head.appendChild(c);
  };
}
function _H(e, t) {
  const n = new window.CustomEvent(e, {
    detail: t
  });
  window.dispatchEvent(n);
}
class I0c {
  constructor(t) {
    vi(this, "namespace");
    t = t || "", this.namespace = t;
  }
  static parseAction(t) {
    if (!t)
      return null;
    const [n, o, r] = t.split(":");
    return n !== "CAL" ? null : {
      ns: o,
      type: r
    };
  }
  getFullActionName(t) {
    return this.namespace ? `CAL:${this.namespace}:${t}` : `CAL::${t}`;
  }
  fire(t, n) {
    const o = this.getFullActionName(t), r = {
      type: t,
      namespace: this.namespace,
      fullType: o,
      data: n
    };
    _H(o, r), _H(this.getFullActionName("*"), r);
  }
  on(t, n) {
    const o = this.getFullActionName(t);
    window.addEventListener(o, n);
  }
  off(t, n) {
    const o = this.getFullActionName(t);
    window.removeEventListener(o, n);
  }
}
let _r = null;
typeof window < "u" && (A0c(), _r = new I0c(window.getEmbedNamespace()));
function N_(e) {
  return setTimeout(e, 50);
}
function O0c() {
  return !!window._embedBookerState;
}
function E_e() {
  return window._embedBookerState === "slotsDone";
}
function N0c() {
  return !!new URL(document.URL).searchParams.get("cal.embed.pageType");
}
function x_e({ embedStore: e }) {
  return e.providedCorrectHeightToParent ? O0c() && N0c() ? E_e() : !0 : !1;
}
function z0c({ embedStore: e }) {
  let t = null, n = null, o = !0, r = !1;
  N_(function i() {
    if (document.readyState !== "complete") {
      N_(i);
      return;
    }
    if (!r) {
      setTimeout(() => {
        r = !0, i();
      }, 100);
      return;
    }
    e.windowLoadEventFired || _r == null || _r.fire("__windowLoadComplete", {}), e.windowLoadEventFired = !0;
    const a = document.getElementsByClassName("main")[0] || document.getElementsByTagName("main")[0] || document.documentElement, s = document.documentElement.scrollHeight, c = document.documentElement.scrollWidth;
    if (!(a instanceof HTMLElement))
      throw new Error("Main element should be an HTMLElement");
    const l = getComputedStyle(a), u = Math.ceil(
      parseFloat(l.height) + parseFloat(l.marginTop) + parseFloat(l.marginBottom)
    ), d = Math.ceil(
      parseFloat(l.width) + parseFloat(l.marginLeft) + parseFloat(l.marginRight)
    ), _ = o ? s : u, p = o ? c : d;
    if (!_ || !p) {
      N_(i);
      return;
    }
    (t !== _ || n !== p || !e.providedCorrectHeightToParent) && (t = _, n = p, _r == null || _r.fire("__dimensionChanged", {
      iframeHeight: _,
      iframeWidth: p,
      isFirstTime: o
    })), o || (e.providedCorrectHeightToParent = !0), o = !1, N_(i);
  });
}
const R0c = async (e) => {
  const t = new URL(document.URL);
  let n = null;
  const r = t.searchParams.get("cal.queuedFormResponseId");
  if (!r)
    return null;
  if (r === "00000000-0000-0000-0000-000000000000")
    return 0;
  const { form: i, ...a } = e, s = await fetch("/api/routing-forms/queued-response", {
    method: "POST",
    body: JSON.stringify({ queuedFormResponseId: r, params: a })
  });
  if (!s.ok)
    return null;
  const l = (await s.json()).data.formResponseId;
  return l && (n = l), n;
};
var Z4 = /* @__PURE__ */ ((e) => (e[e.NOT_INITIALIZED = 0] = "NOT_INITIALIZED", e[e.INITIALIZED = 1] = "INITIALIZED", e))(Z4 || {});
const zo = {
  connectVersion: 0,
  /**
   * Tracks whether the iframe is fully rendered or in progress of rendering.
   * In case of prerendering as well as non-prerendering, it would be "completed" after the iframe is fully rendered.
   */
  renderState: null,
  // Handles the commands of routing received from parent even when React hasn't initialized and nextRouter isn't available
  router: {
    /**
     * When we do the history push, it is possible that
     * - React might revert that change depending on in what state React is in while initializing
     * - So, we use a declarative approach to ensure that our requirement is continuously met
     */
    ensureQueryParamsInUrl({
      toBeThereParams: e,
      toRemoveParams: t
    }) {
      let n = !1;
      function o() {
        if (n)
          return { hasChanged: !1 };
        const s = new URL(document.URL);
        let c = !1;
        for (const [l, u] of Object.entries(e))
          c = !T0c({
            param: l,
            value: u,
            container: s.searchParams
          }), c && a({ key: l, value: u, url: s });
        return i({ keys: t, url: s }), c = c || t.length > 0, c && window.history.replaceState({}, "", s.toString()), N_(o), {
          hasChanged: c
        };
      }
      const { hasChanged: r } = o();
      return {
        stopEnsuringQueryParamsInUrl: () => {
          n = !0;
        },
        hasChanged: r
      };
      function i({ keys: s, url: c }) {
        for (const l of s)
          c.searchParams.delete(l);
      }
      function a({ key: s, value: c, url: l }) {
        l.searchParams.delete(s), (Array.isArray(c) ? c : [c]).forEach((d) => {
          l.searchParams.append(s, d);
        });
      }
    }
  },
  state: 0,
  // Store all embed styles here so that as and when new elements are mounted, styles can be applied to it.
  styles: {},
  nonStyles: {},
  namespace: null,
  embedType: void 0,
  // Store all React State setters here.
  reactStylesStateSetters: {},
  reactNonStylesStateSetters: {},
  // Embed can show itself only after this is set to true
  providedCorrectHeightToParent: !1,
  windowLoadEventFired: !1,
  setTheme: void 0,
  theme: void 0,
  uiConfig: void 0,
  /**
   * We maintain a list of all setUiConfig setters that are in use at the moment so that we can update all those components.
   */
  setUiConfig: []
}, P0c = () => {
  const e = Nr.useSearchParams() ?? new URLSearchParams(), t = Nr.useParams() ?? {}, n = new URLSearchParams(e.toString());
  return Object.getOwnPropertyNames(t).forEach((o) => {
    n.delete(o);
    const r = t[o], i = typeof r == "string" ? r.split("/") : r;
    i == null || i.forEach((a) => {
      n.append(o, a);
    });
  }), new Nr.ReadonlyURLSearchParams(n);
}, D0c = [
  // so that Postmessage communication starts
  "__iframeReady",
  // so that iframe height is adjusted according to the content, and iframe is ready to be shown when needed
  "__dimensionChanged",
  // When this event is fired, the iframe is still in prerender state but is going to be moved out of prerender state
  "__connectInitiated"
  // For other events, we should consider introducing prerender specific events and not reuse existing events
];
let pH = !1;
const Jy = typeof window < "u";
if (Jy) {
  window.CalEmbed = (window == null ? void 0 : window.CalEmbed) || {}, window.CalEmbed.embedStore = zo;
  const e = navigator.userAgent.toLowerCase();
  pH = e.includes("safari") && !e.includes("chrome"), pH && ml("Safari Detected: Using setTimeout instead of rAF");
}
function ml(...e) {
  if (Jy) {
    const t = A_e(), n = new URL(document.URL).searchParams, o = window.CalEmbed.__logQueue = window.CalEmbed.__logQueue || [];
    e.push({
      ns: t,
      url: document.URL
    }), e.unshift("CAL:"), o.push(e), n.get("debug") && console.log("Child:", ...e);
  }
}
const L0c = (e) => {
  zo.styles = e;
  for (const [, t] of Object.entries(zo.reactStylesStateSetters))
    t((n) => ({
      ...n,
      ...e
    }));
}, M0c = (e) => {
  zo.nonStyles = e;
  for (const [, t] of Object.entries(zo.reactStylesStateSetters))
    t((n) => ({
      ...n,
      ...e
    }));
}, C_e = (e) => e.styles ? (zo.reactStylesStateSetters[e.elementName] = e.setState, e.setState(zo.styles || {}), () => {
  delete zo.reactStylesStateSetters[e.elementName];
}) : (zo.reactNonStylesStateSetters[e.elementName] = e.setState, e.setState(zo.nonStyles || {}), () => {
  delete zo.reactNonStylesStateSetters[e.elementName];
});
function T_e(e) {
  return typeof e < "u" && e !== null;
}
const F0c = (e) => {
  const t = Jy ? new URL(document.URL) : null, n = (t == null ? void 0 : t.pathname) ?? "", o = (t == null ? void 0 : t.searchParams) ?? null, r = xt(`${n}?${o}`);
  yt(() => {
    const i = `${n}?${o}`;
    r.current !== i && (r.current = i, e(i));
  }, [n, o, e]);
}, q0c = () => {
  const e = P0c(), [t, n] = it(
    zo.theme || (e == null ? void 0 : e.get("theme"))
  ), o = Yt(() => {
    _r == null || _r.fire("__routeChanged", {});
  }, []);
  return F0c(o), zo.setTheme = n, t;
}, kq = () => {
  const [e, t] = it(zo.uiConfig || {});
  return zo.setUiConfig.push(t), yt(() => () => {
    const n = zo.setUiConfig.findIndex((o) => o === t);
    zo.setUiConfig.splice(n, 1);
  }), e;
}, mH = (e) => {
  const [, t] = it({});
  return yt(() => C_e({ elementName: e, setState: t, styles: !0 }), []), (zo.styles || {})[e] || {};
}, j0c = (e) => {
  const [, t] = it({});
  return yt(() => C_e({ elementName: e, setState: t, styles: !1 }), []), (zo.nonStyles || {})[e] || {};
}, V0c = () => j0c("branding") || {};
function A_e() {
  var e;
  if (T_e(zo.namespace))
    return zo.namespace;
  if (Jy) {
    const t = ((e = window == null ? void 0 : window.getEmbedNamespace) == null ? void 0 : e.call(window)) ?? null;
    return zo.namespace = t, t;
  }
}
function B0c() {
  if (zo.embedType)
    return zo.embedType;
  if (Jy) {
    const e = new URL(document.URL);
    return zo.embedType = e.searchParams.get("embedType");
  }
}
const tm = (e) => {
  const [t, n] = it(e);
  return yt(() => {
    var i;
    const o = A_e(), r = T_e(o);
    parent !== window && !r && ml(
      "Looks like you have iframed cal.com but not using Embed Snippet. Directly using an iframe isn't recommended."
    ), n(((i = window == null ? void 0 : window.isEmbed) == null ? void 0 : i.call(window)) || !1);
  }, []), t;
}, U0c = () => {
  const [e, t] = it(null);
  return yt(() => {
    t(B0c());
  }, []), e;
};
function Sq() {
  document.body.style.visibility !== "visible" && (document.body.style.visibility = "visible"), N_(() => {
    Sq();
  });
}
function G0c() {
  Sq(), e();
  function e() {
    document.body.style.background === "transparent" && (document.body.style.background = "");
  }
}
async function W0c({
  newlyRecordedResponseId: e,
  toBeThereParams: t,
  toRemoveParams: n
}) {
  const { stopEnsuringQueryParamsInUrl: o } = zo.router.ensureQueryParamsInUrl({
    toBeThereParams: {
      ...t,
      "cal.routingFormResponseId": e.toString()
    },
    toRemoveParams: n
  });
  o();
}
async function H0c() {
  return new Promise((e) => {
    (function t() {
      if (zo.renderState !== "completed") {
        N_(t);
        return;
      }
      e();
    })();
  });
}
const Y0c = {
  ui: function(t) {
    var o;
    ml("Method: ui called", t);
    const n = t.styles;
    n && console.warn(
      "Cal.com Embed: `styles` prop is deprecated. Use `cssVarsPerTheme` instead to achieve the same effect. Here is a list of CSS variables that are supported. https://github.com/calcom/cal.com/blob/main/packages/config/tailwind-preset.js#L19"
    ), (o = n == null ? void 0 : n.body) != null && o.background && (document.body.style.background = n.body.background), t.theme && (zo.theme = t.theme, zo.setTheme && zo.setTheme(t.theme)), t = {
      ...zo.uiConfig,
      ...t
    }, t.cssVarsPerTheme && window.CalEmbed.applyCssVars(t.cssVarsPerTheme), t.colorScheme && I_e(t.colorScheme), zo.setUiConfig && J0c(t), L0c(n || {}), M0c(n || {});
  },
  parentKnowsIframeReady: (e) => {
    ml("Method: `parentKnowsIframeReady` called"), N_(function t() {
      if (!x_e({ embedStore: zo })) {
        N_(t);
        return;
      }
      Sq(), ml("renderState is 'completed'"), zo.renderState = "completed", _r == null || _r.fire("linkReady", {});
    });
  },
  /**
   * Connects new config to prerendered page
   */
  connect: async function({
    config: t,
    params: n
  }) {
    _r == null || _r.fire("__connectInitiated", {}), ml("Method: connect, requested with params", { config: t, params: n });
    const {
      iframeAttrs: o,
      "cal.embed.noSlotsFetchOnConnect": r,
      ...i
    } = t;
    zo.providedCorrectHeightToParent = !1, r !== "true" && (ml("Method: connect, noSlotsFetchOnConnect is false. Requesting slots re-fetch"), zo.connectVersion = zo.connectVersion + 1);
    const a = zo.connectVersion, s = {
      ...n,
      // Query params from config takes precedence over query params in url
      ...i,
      "cal.embed.connectVersion": a.toString()
    }, c = ["preload", "prerender", "cal.skipSlotsFetch"];
    await H0c(), ml("Method: connect, renderState is completed. Connecting"), await Q0c({
      // We know after removing iframeAttrs, that it is of this type
      toBeThereParams: s,
      toRemoveParams: c
    });
    const l = await R0c(n);
    typeof l == "number" && await W0c({
      newlyRecordedResponseId: l,
      toBeThereParams: s,
      toRemoveParams: c
    });
  }
}, oz = Y0c, K0c = (e) => {
  parent.postMessage(
    {
      originator: "CAL",
      ...e
    },
    "*"
  );
};
function Z0c() {
  var r, i, a;
  if (!Jy)
    return;
  ml("Embed SDK loaded", { isEmbed: ((r = window == null ? void 0 : window.isEmbed) == null ? void 0 : r.call(window)) || !1 });
  const e = new URL(document.URL);
  zo.theme = (i = window == null ? void 0 : window.getEmbedTheme) == null ? void 0 : i.call(window);
  const n = e.searchParams.get("ui.autoscroll") === "false";
  if (zo.uiConfig = {
    // TODO: Add theme as well here
    colorScheme: e.searchParams.get("ui.color-scheme"),
    layout: e.searchParams.get("layout"),
    disableAutoScroll: n
  }, I_e(zo.uiConfig.colorScheme), top === window) {
    G0c(), ml("Embed SDK Skipped as we are in top");
    return;
  }
  const o = e.searchParams.get("cal.skipSlotsFetch") !== "true";
  ml(`Slots will ${o ? "" : "NOT "}be fetched`), window.addEventListener("message", (s) => {
    var u;
    const c = s.data;
    if (!c)
      return;
    const l = c.method;
    c.originator === "CAL" && typeof l == "string" && ((u = oz[l]) == null || u.call(oz, c.arg));
  }), document.addEventListener("click", (s) => {
    if (!s.target || !(s.target instanceof Node))
      return;
    const c = document.getElementsByClassName("main")[0] || document.getElementsByTagName("main")[0] || document.documentElement;
    s.target.contains(c) && (_r == null || _r.fire("__closeIframe", {}));
  }), _r == null || _r.on("*", (s) => {
    if (O_e() && !D0c.includes(s.detail.type))
      return;
    const c = s.detail;
    ml(c), K0c(c);
  }), e.searchParams.get("preload") !== "true" && ((a = window == null ? void 0 : window.isEmbed) != null && a.call(window)) ? X0c() : ml("Preloaded scenario - Skipping initialization and setup as only assets need to be loaded");
}
function X0c() {
  if (_r == null || _r.fire("__iframeReady", {
    isPrerendering: O_e()
  }), zo.renderState = "inProgress", zo.state !== Z4.NOT_INITIALIZED) {
    ml("Embed Iframe already initialized");
    return;
  }
  zo.state = Z4.INITIALIZED, ml("Initializing embed-iframe");
  const e = window.CalComPageStatus;
  !e || e == "200" ? z0c({ embedStore: zo }) : _r == null || _r.fire("linkFailed", {
    code: e,
    msg: "Problem loading the link",
    data: {
      url: document.URL
    }
  });
}
function J0c(e) {
  zo.uiConfig = e, zo.setUiConfig.forEach((t) => t(e));
}
function I_e(e) {
  e && (document.documentElement.style.colorScheme = e);
}
async function Q0c({
  toBeThereParams: e,
  toRemoveParams: t
}) {
  const { hasChanged: n, stopEnsuringQueryParamsInUrl: o } = zo.router.ensureQueryParamsInUrl({
    toBeThereParams: e,
    toRemoveParams: t
  });
  let r = 0;
  return E_e() && n && (r = 2), await new Promise((i) => {
    N_(function a() {
      if (!x_e({ embedStore: zo }) || r > 0) {
        r--, N_(a);
        return;
      }
      o(), _r == null || _r.fire("__connectCompleted", {}), _r == null || _r.fire("linkReady", {}), i();
    });
  }), {
    stopEnsuringQueryParamsInUrl: o
  };
}
const O_e = () => new URL(document.URL).searchParams.get("prerender") === "true";
function e1c({
  bookerState: e,
  slotsQuery: t
}) {
  return e === "loading" ? "initializing" : t.isLoading ? "slotsLoading" : t.isPending || t.isSuccess ? "slotsDone" : t.isError ? "slotsLoadingError" : "slotsPending";
}
function X4({
  bookerState: e,
  slotsQuery: t
}) {
  if (typeof window > "u")
    return;
  const n = window, o = e1c({ bookerState: e, slotsQuery: t });
  n._embedBookerState = o;
}
Z0c();
const wC = _F, kC = pF;
function rz(e, t) {
  return e && J4(e) ? e : t ? kC : wC;
}
function J4(e) {
  return /^#([0-9A-Fa-f]{3}){1,2}$/.test(e);
}
const fH = (e, t) => /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(e.replace("##", "#")) ? e : t;
function Yk(e) {
  const t = e.replace("##", "#"), n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  if (!n)
    throw new Error("Invalid Hex colour");
  const [, o, r, i] = n;
  return {
    r: parseInt(o, 16),
    g: parseInt(r, 16),
    b: parseInt(i, 16)
  };
}
function N_e(e, t, n) {
  const o = (r) => `0${r.toString(16)}`.slice(-2);
  return `#${o(e)}${o(t)}${o(n)}`;
}
function t1c(e, t) {
  const n = Yk(`#${e}`);
  if (!n)
    return "";
  const o = Math.round(n.r + (255 - n.r) * t), r = Math.round(n.g + (255 - n.g) * t), i = Math.round(n.b + (255 - n.b) * t);
  return N_e(o, r, i);
}
function n1c(e, t) {
  const n = Yk(e);
  if (!n)
    return "";
  const o = Math.round(n.r * t), r = Math.round(n.g * t), i = Math.round(n.b * t);
  return N_e(o, r, i);
}
function gH(e, t) {
  return e ? (e = e.replace("#", ""), e.length === 3 && (e = e.split("").map(function(n) {
    return n + n;
  }).join("")), e) : t ? kC : wC;
}
const hH = (e) => {
  const t = {
    500: `#${e}`.replace("##", "#")
  }, n = {
    50: 0.95,
    100: 0.9,
    200: 0.75,
    300: 0.6,
    400: 0.3,
    600: 0.9,
    700: 0.75,
    800: 0.6,
    900: 0.49
  };
  return [50, 100, 200, 300, 400].forEach((o) => {
    t[o] = t1c(e, n[o]);
  }), [600, 700, 800, 900].forEach((o) => {
    t[o] = n1c(e, n[o]);
  }), t;
};
function ZS(e) {
  const { r: t, g: n, b: o } = Yk(e);
  return (0.2126 * t + 0.7152 * n + 0.0722 * o) / 255 < 0.5 ? "#FFFFFF" : "#000000";
}
function vH(e, t) {
  const n = Yk(e), o = Yk(t), r = (0.2126 * n.r + 0.7152 * n.g + 0.0722 * n.b) / 255, i = (0.2126 * o.r + 0.7152 * o.g + 0.0722 * o.b) / 255;
  return (Math.max(r, i) + 0.05) / (Math.min(i, r) + 0.05) >= 4.5;
}
const o1c = ({
  lightVal: e = wC,
  darkVal: t = kC
}) => {
  e = V0c().brandColor || e, e = gH(e, !1), t = gH(t, !0);
  const o = hH(fH(e, wC)), r = hH(fH(t, kC));
  return {
    light: {
      "cal-brand": o[500],
      "cal-brand-emphasis": o[400],
      "cal-brand-subtle": o[200],
      "cal-brand-text": ZS(o[500]),
      "cal-brand-accent": ZS(o[500])
    },
    dark: {
      "cal-brand": r[500],
      "cal-brand-emphasis": r[600],
      "cal-brand-subtle": r[800],
      "cal-brand-text": ZS(r[500]),
      "cal-brand-accent": ZS(r[500])
    }
  };
}, r1c = o1c, i1c = (e) => {
  const t = J4(e.defaultValue) ? e.defaultValue : rz(e.defaultValue, !1), n = e.resetDefaultValue && (J4(e.resetDefaultValue) ? e.resetDefaultValue : rz(e.resetDefaultValue, !1)), [o, r] = it(t);
  return /* @__PURE__ */ de("div", { className: "mt-1 flex h-[38px] items-center justify-center", children: [
    /* @__PURE__ */ de(Yde, { children: [
      /* @__PURE__ */ m("div", { className: "border-default min-w-9 flex h-full items-center justify-center border ltr:rounded-l-md ltr:border-r-0 rtl:rounded-r-md rtl:border-l-0", children: /* @__PURE__ */ m(Kde, { asChild: !0, children: /* @__PURE__ */ m(
        "button",
        {
          className: "h-5 w-5 rounded-sm",
          "aria-label": "pick colors",
          style: { backgroundColor: o }
        }
      ) }) }),
      /* @__PURE__ */ m(a$c, { container: e.container, children: /* @__PURE__ */ m(Zde, { align: e.popoverAlign ?? "center", sideOffset: 10, children: /* @__PURE__ */ m(
        k0c,
        {
          color: o,
          className: "!h-32 !w-32",
          onChange: (i) => {
            r(i), e.onChange(i);
          }
        }
      ) }) })
    ] }),
    /* @__PURE__ */ m(
      x0c,
      {
        className: xe(
          "border-default text-default bg-default block h-full w-full border px-3 py-2 ltr:rounded-r-md rtl:rounded-l-md sm:text-sm",
          e.className
        ),
        color: o,
        onChange: (i) => {
          r(i), e.onChange(i);
        },
        type: "text"
      }
    ),
    n && o != n && /* @__PURE__ */ m("div", { className: "px-1", children: /* @__PURE__ */ m(
      Jt,
      {
        color: "secondary",
        target: "_blank",
        variant: "icon",
        rel: "noreferrer",
        "aria-label": "Reset to default",
        StartIcon: "rotate-ccw",
        tooltip: "Reset to default",
        onClick: () => {
          r(rz(n, !1)), e.onChange(n);
        }
      }
    ) })
  ] });
}, Xw = i1c, a1c = globalThis != null && globalThis.document ? Ue.useLayoutEffect : () => {
}, s1c = Ue.useId || (() => {
});
let c1c = 0;
function l1c(e) {
  const [t, n] = Ue.useState(s1c());
  return a1c(() => {
    e || n((o) => o ?? String(c1c++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function z_e(...e) {
  return (t) => e.forEach((n) => function(o, r) {
    typeof o == "function" ? o(r) : o != null && (o.current = r);
  }(n, t));
}
function u1c(...e) {
  return Ue.useCallback(z_e(...e), e);
}
const R_e = /* @__PURE__ */ Ue.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  return Ue.Children.toArray(n).some(bH) ? /* @__PURE__ */ Ue.createElement(Ue.Fragment, null, Ue.Children.map(n, (r) => bH(r) ? /* @__PURE__ */ Ue.createElement(Q4, Tt({}, o, { ref: t }), r.props.children) : r)) : /* @__PURE__ */ Ue.createElement(Q4, Tt({}, o, { ref: t }), n);
});
R_e.displayName = "Slot";
const Q4 = /* @__PURE__ */ Ue.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  return Ue.isValidElement(n) ? /* @__PURE__ */ Ue.cloneElement(n, { ..._1c(o, n.props), ref: z_e(t, n.ref) }) : Ue.Children.count(n) > 1 ? Ue.Children.only(null) : null;
});
Q4.displayName = "SlotClone";
const d1c = ({ children: e }) => /* @__PURE__ */ Ue.createElement(Ue.Fragment, null, e);
function bH(e) {
  return Ue.isValidElement(e) && e.type === d1c;
}
function _1c(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? n[o] = (...a) => {
      i == null || i(...a), r == null || r(...a);
    } : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
const p1c = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((e, t) => ({ ...e, [t]: /* @__PURE__ */ Ue.forwardRef((n, o) => {
  const { asChild: r, ...i } = n, a = r ? R_e : t;
  return Ue.useEffect(() => {
    window[Symbol.for("radix-ui")] = !0;
  }, []), /* @__PURE__ */ Ue.createElement(a, Tt({}, i, { ref: o }));
}) }), {});
function m1c(e, t) {
  const n = /* @__PURE__ */ Ue.createContext(t);
  function o(r) {
    const { children: i, ...a } = r, s = Ue.useMemo(() => a, Object.values(a));
    return Ue.createElement(n.Provider, { value: s }, i);
  }
  return o.displayName = e + "Provider", [o, function(r) {
    const i = Ue.useContext(n);
    if (i)
      return i;
    if (t !== void 0)
      return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }];
}
const [f1c, csu] = m1c("Label", { id: void 0, controlRef: { current: null } }), g1c = /* @__PURE__ */ Ue.forwardRef((e, t) => {
  const { htmlFor: n, id: o, ...r } = e, i = Ue.useRef(null), a = Ue.useRef(null), s = u1c(t, a), c = l1c(o);
  return Ue.useEffect(() => {
    if (n) {
      const l = document.getElementById(n);
      if (a.current && l) {
        const u = () => l.getAttribute("aria-labelledby"), d = [c, u()].filter(Boolean).join(" ");
        return l.setAttribute("aria-labelledby", d), i.current = l, () => {
          var _;
          const p = (_ = u()) === null || _ === void 0 ? void 0 : _.replace(c, "");
          p === "" ? l.removeAttribute("aria-labelledby") : p && l.setAttribute("aria-labelledby", p);
        };
      }
    }
  }, [c, n]), /* @__PURE__ */ Ue.createElement(f1c, { id: c, controlRef: i }, /* @__PURE__ */ Ue.createElement(p1c.span, Tt({ role: "label", id: c }, r, { ref: s, onMouseDown: (l) => {
    var u;
    (u = e.onMouseDown) === null || u === void 0 || u.call(e, l), !l.defaultPrevented && l.detail > 1 && l.preventDefault();
  }, onClick: (l) => {
    var u;
    if ((u = e.onClick) === null || u === void 0 || u.call(e, l), !i.current || l.defaultPrevented)
      return;
    const d = i.current.contains(l.target), _ = l.isTrusted === !0;
    !d && _ && (i.current.click(), i.current.focus());
  } })));
}), h1c = g1c;
function v1c(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function b1c(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function P_e(...e) {
  return (t) => e.forEach((n) => b1c(n, t));
}
function y1c(...e) {
  return Ue.useCallback(P_e(...e), e);
}
function $1c(e, t = []) {
  let n = [];
  function o(i, a) {
    const s = Ue.createContext(a), c = n.length;
    n = [...n, a];
    function l(d) {
      const { scope: _, children: p, ...g } = d, f = (_ == null ? void 0 : _[e][c]) || s, h = Ue.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ m(f.Provider, { value: h, children: p });
    }
    function u(d, _) {
      const p = (_ == null ? void 0 : _[e][c]) || s, g = Ue.useContext(p);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [l, u];
  }
  const r = () => {
    const i = n.map((a) => Ue.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return Ue.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return r.scopeName = e, [o, w1c(r, ...t)];
}
function w1c(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(i) {
      const a = o.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return { ...s, ...d };
      }, {});
      return Ue.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function D_e(e) {
  const t = Ue.useRef(e);
  return Ue.useEffect(() => {
    t.current = e;
  }), Ue.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function k1c({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, r] = S1c({ defaultProp: t, onChange: n }), i = e !== void 0, a = i ? e : o, s = D_e(n), c = Ue.useCallback(
    (l) => {
      if (i) {
        const d = typeof l == "function" ? l(e) : l;
        d !== e && s(d);
      } else
        r(l);
    },
    [i, e, r, s]
  );
  return [a, c];
}
function S1c({
  defaultProp: e,
  onChange: t
}) {
  const n = Ue.useState(e), [o] = n, r = Ue.useRef(o), i = D_e(t);
  return Ue.useEffect(() => {
    r.current !== o && (i(o), r.current = o);
  }, [o, r, i]), n;
}
function E1c(e) {
  const t = Ue.useRef({ value: e, previous: e });
  return Ue.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function x1c(e) {
  const [t, n] = Ue.useState(void 0);
  return sq(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var L_e = Ue.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = Ue.Children.toArray(n), i = r.find(T1c);
  if (i) {
    const a = i.props.children, s = r.map((c) => c === i ? Ue.Children.count(a) > 1 ? Ue.Children.only(null) : Ue.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ m(e5, { ...o, ref: t, children: Ue.isValidElement(a) ? Ue.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ m(e5, { ...o, ref: t, children: n });
});
L_e.displayName = "Slot";
var e5 = Ue.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (Ue.isValidElement(n)) {
    const r = I1c(n);
    return Ue.cloneElement(n, {
      ...A1c(o, n.props),
      // @ts-ignore
      ref: t ? P_e(t, r) : r
    });
  }
  return Ue.Children.count(n) > 1 ? Ue.Children.only(null) : null;
});
e5.displayName = "SlotClone";
var C1c = ({ children: e }) => /* @__PURE__ */ m(nt, { children: e });
function T1c(e) {
  return Ue.isValidElement(e) && e.type === C1c;
}
function A1c(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      i(...s), r(...s);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function I1c(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var O1c = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], M_e = O1c.reduce((e, t) => {
  const n = Ue.forwardRef((o, r) => {
    const { asChild: i, ...a } = o, s = i ? L_e : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(s, { ...a, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Eq = "Switch", [N1c, lsu] = $1c(Eq), [z1c, R1c] = N1c(Eq), F_e = Ue.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      ...u
    } = e, [d, _] = Ue.useState(null), p = y1c(t, (v) => _(v)), g = Ue.useRef(!1), f = d ? !!d.closest("form") : !0, [h = !1, $] = k1c({
      prop: r,
      defaultProp: i,
      onChange: l
    });
    return /* @__PURE__ */ de(z1c, { scope: n, checked: h, disabled: s, children: [
      /* @__PURE__ */ m(
        M_e.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": h,
          "aria-required": a,
          "data-state": V_e(h),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...u,
          ref: p,
          onClick: v1c(e.onClick, (v) => {
            $((b) => !b), f && (g.current = v.isPropagationStopped(), g.current || v.stopPropagation());
          })
        }
      ),
      f && /* @__PURE__ */ m(
        P1c,
        {
          control: d,
          bubbles: !g.current,
          name: o,
          value: c,
          checked: h,
          required: a,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
F_e.displayName = Eq;
var q_e = "SwitchThumb", j_e = Ue.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = R1c(q_e, n);
    return /* @__PURE__ */ m(
      M_e.span,
      {
        "data-state": V_e(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
j_e.displayName = q_e;
var P1c = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = Ue.useRef(null), a = E1c(n), s = x1c(t);
  return Ue.useEffect(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && d) {
      const _ = new Event("click", { bubbles: o });
      d.call(c, n), c.dispatchEvent(_);
    }
  }, [a, n, o]), /* @__PURE__ */ m(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...r,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function V_e(e) {
  return e ? "checked" : "unchecked";
}
var D1c = F_e, L1c = j_e;
const M1c = ({ children: e, tooltip: t }) => t ? /* @__PURE__ */ m(Sr, { content: t, children: e }) : /* @__PURE__ */ m(nt, { children: e }), as = (e) => {
  const {
    label: t,
    fitToHeight: n,
    classNames: o,
    labelOnLeading: r,
    LockedIcon: i,
    padding: a,
    size: s = "base",
    ...c
  } = e, l = Pu();
  return /* @__PURE__ */ m(M1c, { tooltip: e.tooltip, children: /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "flex h-auto w-fit flex-row items-center",
        n && "h-fit",
        r && "flex-row-reverse",
        a && "hover:bg-subtle rounded-md p-1.5",
        o == null ? void 0 : o.container
      ),
      children: [
        i && /* @__PURE__ */ m("div", { className: "mr-2", children: i }),
        /* @__PURE__ */ m(
          D1c,
          {
            ...c,
            id: l,
            className: xe(
              s === "sm" ? "h-3 w-[20px]" : "h-4 w-[28px]",
              "focus:ring-brand-default data-[state=checked]:bg-brand-default dark:data-[state=checked]:bg-brand-emphasis data-[state=unchecked]:bg-emphasis peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-inner transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
              s === "sm" ? "h-4 w-7" : "h-6 w-11",
              o == null ? void 0 : o.container
            ),
            children: /* @__PURE__ */ m(
              L1c,
              {
                className: xe(
                  "bg-default data-[state=checked]:bg-brand-accent shadow-switch-thumb pointer-events-none block rounded-full shadow-lg ring-0 transition-transform",
                  s === "sm" ? "h-3 w-3 data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0 rtl:data-[state=checked]:-translate-x-3" : "h-5 w-5 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 rtl:data-[state=checked]:-translate-x-5",
                  o == null ? void 0 : o.thumb
                )
              }
            )
          }
        ),
        t && /* @__PURE__ */ m(
          h1c,
          {
            htmlFor: l,
            className: xe(
              "text-emphasis font-medium",
              s === "sm" ? "m-1 text-xs" : "ml-2 mt-1 text-sm",
              c.disabled ? "cursor-not-allowed opacity-25" : "cursor-pointer",
              r && "flex-1"
            ),
            children: t
          }
        )
      ]
    }
  ) });
};
function Jo({
  checked: e,
  onCheckedChange: t,
  description: n,
  LockedIcon: o,
  Badge: r,
  title: i,
  children: a,
  disabled: s,
  tooltip: c,
  toggleSwitchAtTheEnd: l = !1,
  childrenClassName: u,
  switchContainerClassName: d,
  labelClassName: _,
  descriptionClassName: p,
  noIndentation: g = !1,
  hideSwitch: f,
  ...h
}) {
  const [$] = qd();
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m("div", { className: "flex w-full flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: /* @__PURE__ */ de("fieldset", { className: "block w-full flex-col sm:flex", children: [
    l ? /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "border-subtle flex justify-between space-x-3 rounded-lg border px-4 py-6 sm:px-6",
          e && a && "rounded-b-none",
          d
        ),
        children: [
          /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ de("div", { className: "flex items-center gap-x-2", "data-testid": `${h["data-testid"]}-title`, children: [
              /* @__PURE__ */ de(
                Ko,
                {
                  className: xe("mt-0.5 text-base font-semibold leading-none", _),
                  htmlFor: "",
                  children: [
                    i,
                    o
                  ]
                }
              ),
              r && /* @__PURE__ */ m("div", { className: "mb-2", children: r })
            ] }),
            n && /* @__PURE__ */ m(
              "p",
              {
                className: xe(
                  "text-default -mt-1.5 text-sm leading-normal",
                  p
                ),
                "data-testid": `${h["data-testid"]}-description`,
                children: n
              }
            )
          ] }),
          !f && /* @__PURE__ */ m("div", { className: "my-auto h-full", children: /* @__PURE__ */ m(
            as,
            {
              "data-testid": h["data-testid"],
              fitToHeight: !0,
              checked: e,
              onCheckedChange: t,
              disabled: s,
              tooltip: c
            }
          ) })
        ]
      }
    ) : /* @__PURE__ */ de("div", { className: "flex space-x-3", children: [
      /* @__PURE__ */ m(
        as,
        {
          "data-testid": h["data-testid"],
          fitToHeight: !0,
          checked: e,
          onCheckedChange: t,
          disabled: s,
          tooltip: c
        }
      ),
      /* @__PURE__ */ de("div", { children: [
        /* @__PURE__ */ de(
          Ko,
          {
            className: xe("text-emphasis text-sm font-semibold leading-none", _),
            children: [
              i,
              " ",
              r || null,
              o
            ]
          }
        ),
        n && /* @__PURE__ */ m("p", { className: "text-default -mt-1.5 text-sm leading-normal", children: n })
      ] })
    ] }),
    a && /* @__PURE__ */ m("div", { className: xe(g ? "" : "lg:ml-14", u), ref: $, children: e && /* @__PURE__ */ m("div", { className: xe(!l && "mt-4"), children: a }) })
  ] }) }) });
}
const F1c = [
  { label: "San Francisco", timezone: "America/Los_Angeles" },
  { label: "Sao Francisco do Sul", timezone: "America/Sao_Paulo" },
  { label: "San Francisco de Macoris", timezone: "America/Santo_Domingo" },
  { label: "San Francisco Gotera", timezone: "America/El_Salvador" },
  { label: "Eastern Time - US & Canada", timezone: "America/New_York" },
  { label: "Pacific Time - US & Canada", timezone: "America/Los_Angeles" },
  { label: "Central Time - US & Canada", timezone: "America/Chicago" },
  { label: "Mountain Time - US & Canada", timezone: "America/Denver" },
  { label: "Atlantic Time - Canada", timezone: "America/Halifax" },
  { label: "Eastern European Time", timezone: "Europe/Bucharest" },
  { label: "Central European Time", timezone: "Europe/Berlin" },
  { label: "Western European Time", timezone: "Europe/London" },
  { label: "Australian Eastern Time", timezone: "Australia/Sydney" },
  { label: "Japan Standard Time", timezone: "Asia/Tokyo" },
  { label: "India Standard Time", timezone: "Asia/Kolkata" },
  { label: "Gulf Standard Time", timezone: "Asia/Dubai" },
  { label: "South Africa Standard Time", timezone: "Africa/Johannesburg" },
  { label: "Brazil Time", timezone: "America/Sao_Paulo" },
  { label: "Hawaii-Aleutian Standard Time", timezone: "Pacific/Honolulu" }
];
function xq(e) {
  const { data: t = [], isPending: n } = hr.viewer.timezones.cityTimezones.useQuery(
    {
      CalComVersion: Fse
    },
    {
      trpc: { context: { skipBatch: !0 } }
    }
  ), o = t.map(({ city: r, timezone: i }) => ({ label: r, timezone: i }));
  return /* @__PURE__ */ m(
    B_e,
    {
      data: [...o, ...F1c],
      isPending: n,
      ...e
    }
  );
}
function B_e({
  className: e,
  classNames: t,
  timezoneSelectCustomClassname: n,
  components: o,
  variant: r = "default",
  isPending: i,
  value: a,
  size: s = "md",
  grow: c = !1,
  isWebTimezoneSelect: l = !0,
  ...u
}) {
  const d = [...u.data || []], [_, p] = it([]), g = (h) => {
    d && p(wpc(h, d));
  }, f = vn(() => Nde({
    components: o || {}
  }), [o]);
  return /* @__PURE__ */ m(
    bpc,
    {
      value: a,
      className: `${e} ${n}`,
      "aria-label": "Timezone Select",
      isLoading: i,
      "data-testid": "timezone-select",
      isDisabled: i,
      ...f,
      timezones: {
        ...u.data ? N8(d) : {},
        ...l ? N8(_) : {}
      },
      styles: {
        control: (h) => ({
          ...h,
          minHeight: s === "sm" ? "28px" : "36px",
          height: c ? "h-auto " : s === "sm" ? "28px" : "36px"
        }),
        menuList: (h) => ({
          ...h,
          height: c ? "h-auto " : s === "sm" ? "200px" : "180px"
        })
      },
      onInputChange: g,
      ...u,
      onChange: (h) => {
        if (!u.onChange)
          return;
        if (!h) {
          u.onChange(h);
          return;
        }
        const v = {
          "America/Port_Of_Spain": "America/Port_of_Spain",
          "Africa/Porto-novo": "Africa/Porto-Novo",
          "Africa/Dar_Es_Salaam": "Africa/Dar_es_Salaam"
        }[h.value] || h.value;
        u.onChange({ ...h, value: v });
      },
      formatOptionLabel: (h) => /* @__PURE__ */ m("p", { className: "truncate", children: h.value.replace(/_/g, " ") }),
      getOptionLabel: (h) => Spc(h, _),
      classNames: {
        ...t,
        input: (h) => xe(
          "text-emphasis h-6 md:max-w-[145px] max-w-[250px]",
          (t == null ? void 0 : t.input) && t.input(h)
        ),
        option: (h) => xe(
          "bg-default py-2.5 px-3 rounded-md text-default ",
          h.isFocused && "bg-subtle",
          h.isDisabled && "bg-muted",
          h.isSelected && "bg-emphasis text-default",
          (t == null ? void 0 : t.option) && t.option(h)
        ),
        placeholder: (h) => xe("text-muted", h.isFocused && "hidden"),
        dropdownIndicator: () => "text-default",
        control: (h) => xe(
          G0({ size: s }),
          h.isMulti ? h.hasValue ? "p-1 h-fit" : "px-3 h-fit" : s === "sm" ? "h-7 px-2" : "h-9 py-0 px-3",
          u.isDisabled && "bg-subtle",
          "rounded-[10px]",
          (t == null ? void 0 : t.control) && t.control(h)
        ),
        singleValue: (h) => xe(
          "text-emphasis placeholder:text-muted",
          (t == null ? void 0 : t.singleValue) && t.singleValue(h)
        ),
        valueContainer: (h) => xe(
          "text-emphasis placeholder:text-muted flex gap-1",
          (t == null ? void 0 : t.valueContainer) && t.valueContainer(h)
        ),
        multiValue: (h) => xe(
          "bg-subtle text-default rounded-md py-1.5 px-2 flex items-center text-sm leading-none",
          (t == null ? void 0 : t.multiValue) && t.multiValue(h)
        ),
        menu: (h) => xe(
          "rounded-md bg-default text-sm leading-4 text-default mt-1 border border-subtle",
          h.selectProps.menuIsOpen && "shadow-dropdown",
          // Add box-shadow when menu is open
          (t == null ? void 0 : t.menu) && t.menu(h)
        ),
        groupHeading: () => "leading-none text-xs uppercase text-default pl-2.5 pt-4 pb-2",
        menuList: (h) => xe(
          "scroll-bar scrollbar-track-w-20 rounded-md",
          (t == null ? void 0 : t.menuList) && t.menuList(h)
        ),
        indicatorsContainer: (h) => xe(
          h.selectProps.menuIsOpen ? h.isMulti ? "[&>*:last-child]:rotate-180 [&>*:last-child]:transition-transform" : "rotate-180 transition-transform" : "text-default",
          // Woo it adds another SVG here on multi for some reason
          (t == null ? void 0 : t.indicatorsContainer) && t.indicatorsContainer(h)
        ),
        multiValueRemove: () => "text-default py-auto ml-2",
        noOptionsMessage: () => "h-12 py-2 flex items-center justify-center"
      }
    }
  );
}
var yH = function(e, t, n) {
  if (e && "reportValidity" in e) {
    var o = Pn(n, t);
    e.setCustomValidity(o && o.message || ""), e.reportValidity();
  }
}, U_e = function(e, t) {
  var n = function(r) {
    var i = t.fields[r];
    i && i.ref && "reportValidity" in i.ref ? yH(i.ref, r, e) : i.refs && i.refs.forEach(function(a) {
      return yH(a, r, e);
    });
  };
  for (var o in t.fields)
    n(o);
}, q1c = function(e, t) {
  t.shouldUseNativeValidation && U_e(e, t);
  var n = {};
  for (var o in e) {
    var r = Pn(t.fields, o);
    Zi(n, o, Object.assign(e[o], { ref: r && r.ref }));
  }
  return n;
}, j1c = function(e, t) {
  for (var n = {}; e.length; ) {
    var o = e[0], r = o.code, i = o.message, a = o.path.join(".");
    if (!n[a])
      if ("unionErrors" in o) {
        var s = o.unionErrors[0].errors[0];
        n[a] = { message: s.message, type: s.code };
      } else
        n[a] = { message: i, type: r };
    if ("unionErrors" in o && o.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(d) {
        return e.push(d);
      });
    }), t) {
      var c = n[a].types, l = c && c[o.code];
      n[a] = wse(a, t, n, r, l ? [].concat(l, o.message) : o.message);
    }
    e.shift();
  }
  return n;
}, K0 = function(e, t, n) {
  return n === void 0 && (n = {}), function(o, r, i) {
    try {
      return Promise.resolve(function(a, s) {
        try {
          var c = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](o, t)).then(function(l) {
            return i.shouldUseNativeValidation && U_e({}, i), { errors: {}, values: n.rawValues ? o : l };
          });
        } catch (l) {
          return s(l);
        }
        return c && c.then ? c.then(void 0, s) : c;
      }(0, function(a) {
        return { values: {}, errors: a.isEmpty ? {} : q1c(j1c(a.errors, !i.shouldUseNativeValidation && i.criteriaMode === "all"), i) };
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
};
const V1c = oe.object({
  eventTypeIds: oe.array(oe.number())
});
function G_e({
  eventTypes: e,
  isEventTypesFetching: t,
  ...n
}) {
  const { t: o } = kt(), r = W_({
    resolver: K0(V1c),
    defaultValues: {
      eventTypeIds: (e == null ? void 0 : e.map((s) => s.id)) ?? []
    }
  }), i = r.watch("eventTypeIds"), a = i.length === 0;
  return t || !open || !e ? null : /* @__PURE__ */ m(Ss, { name: "Bulk Default Location Update", open: n.open, onOpenChange: n.setOpen, children: /* @__PURE__ */ m(
    Ya,
    {
      type: "creation",
      title: o("default_conferencing_bulk_title"),
      description: n.description,
      enableOverflow: !0,
      children: /* @__PURE__ */ de(
        Y_,
        {
          form: r,
          handleSubmit: (s) => {
            n.bulkUpdateFunction({
              eventTypeIds: s.eventTypeIds,
              callback: () => n.setOpen(!1)
            });
          },
          children: [
            /* @__PURE__ */ de("div", { className: "flex flex-col space-y-2", children: [
              e.length > 0 && /* @__PURE__ */ m("div", { className: "flex items-center space-x-2 rounded-md px-3 pb-2.5 pt-1", children: /* @__PURE__ */ m(
                cc,
                {
                  description: o("select_all"),
                  descriptionAsLabel: !0,
                  onChange: (s) => {
                    r.setValue("eventTypeIds", s.target.checked ? e.map((c) => c.id) : []);
                  },
                  checked: i.length === e.length
                }
              ) }),
              e.map((s) => /* @__PURE__ */ m("div", { className: "bg-muted flex items-center space-x-2 rounded-md px-3 py-2.5", children: /* @__PURE__ */ m(
                cc,
                {
                  description: s.title,
                  descriptionAsLabel: !0,
                  checked: i.includes(s.id),
                  onChange: (c) => {
                    r.setValue(
                      "eventTypeIds",
                      c.target.checked ? [...i, s.id] : i.filter((l) => l !== s.id)
                    );
                  }
                }
              ) }, s.id))
            ] }),
            /* @__PURE__ */ de(Wu, { showDivider: !0, className: "mt-10", children: [
              /* @__PURE__ */ m(
                Gs,
                {
                  onClick: () => {
                    n.handleBulkEditDialogToggle();
                  }
                }
              ),
              /* @__PURE__ */ m(Jt, { type: "submit", color: "primary", loading: n.isPending, disabled: a, children: o("update") })
            ] })
          ]
        }
      )
    }
  ) });
}
const ll = (e) => e instanceof Date ? ht(e).format("YYYY-MM-DD") : e.format("YYYY-MM-DD"), W_e = (e) => {
  const [t, n] = e instanceof Date ? [e.getFullYear(), e.getMonth()] : [e.year(), e.month()];
  return new Date(t, n + 1, 0).getDate();
}, B1c = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], H_e = (e) => typeof e > "u" ? 0 : typeof e == "number" ? e >= 0 && e >= 6 ? e : 0 : B1c.indexOf(e) || 0, U1c = (e) => {
  const t = e.match(/([+-]\d{2}:\d{2})$/), n = t ? t[1] : "+00:00";
  return ht(e).utcOffset(n);
};
oe.string().transform(U1c);
function Xi(e, t) {
  if (Object.is(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size)
      return !1;
    for (const [o, r] of e)
      if (!Object.is(r, t.get(o)))
        return !1;
    return !0;
  }
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size)
      return !1;
    for (const o of e)
      if (!t.has(o))
        return !1;
    return !0;
  }
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !1;
  for (const o of n)
    if (!Object.prototype.hasOwnProperty.call(t, o) || !Object.is(e[o], t[o]))
      return !1;
  return !0;
}
function G1c({
  browsingDate: e,
  minDate: t = /* @__PURE__ */ new Date(),
  includedDates: n
}) {
  const o = [], r = new Date(
    e.getFullYear(),
    e.getMonth(),
    W_e(e)
  );
  for (
    let i = e > t ? e : t;
    // Check if date is before the last date of the month
    // or is the same day, in the same month, in the same year.
    i < r || ht(i).isSame(r, "day");
    i = new Date(i.getFullYear(), i.getMonth(), i.getDate() + 1)
  )
    n && !n.includes(ll(i)) || o.push(ll(i));
  return o;
}
function Qy(e, t = 0, n = "long") {
  return Array(7).fill(null).map((o, r) => Cq(e, r + t, n));
}
function Cq(e, t, n = "long") {
  return new Intl.DateTimeFormat(e, { weekday: n }).format(new Date(1970, 0, t + 4));
}
const Gl = ({
  as: e,
  className: t = "",
  children: n,
  loading: o = !1,
  /**
   * Assumes that the text needs translation by default and wait for it.
   */
  waitForTranslation: r = !0,
  /**
   * Classes that you need only in loading state
   */
  loadingClassName: i = "",
  ...a
}) => {
  const { isLocaleReady: s } = kt();
  return o = (r ? !s : !1) || o, /* @__PURE__ */ m(
    e,
    {
      className: xe(
        o ? xe("font-size-0 bg-emphasis animate-pulse rounded-md text-transparent", i) : "",
        t
      ),
      ...a,
      children: n
    }
  );
}, Yo = ({
  className: e = "",
  invisible: t = !1,
  style: n
}) => /* @__PURE__ */ m(
  "span",
  {
    style: n,
    className: xe(
      "font-size-0 bg-emphasis inline-block animate-pulse rounded-md empty:before:inline-block empty:before:content-['']",
      e,
      t ? "invisible" : ""
    )
  }
), Tq = ({ children: e, as: t, className: n }) => /* @__PURE__ */ m(t || "div", { className: xe("animate-pulse", n), children: e }), $H = ({ className: e }) => /* @__PURE__ */ m(
  "li",
  {
    className: xe(
      "border-subtle group flex w-full items-center justify-between rounded-sm border px-[10px] py-3",
      e
    ),
    children: /* @__PURE__ */ m("div", { className: "flex-grow truncate text-sm", children: /* @__PURE__ */ de("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ m(Yo, { className: "h-4 w-32" }),
      /* @__PURE__ */ m(Yo, { className: "h-4 w-4" })
    ] }) })
  }
);
function W1c() {
  return /* @__PURE__ */ m("div", { className: "loader border-brand-default dark:border-darkmodebrand", children: /* @__PURE__ */ m("span", { className: "loader-inner bg-brand dark:bg-darkmodebrand" }) });
}
const t5 = {
  reset: [0, 0],
  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  overline: [53, 55],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
};
function n5(e, t, n, o = !1) {
  const r = String(t), i = (c, l) => `\x1B[${l[0]}m${c}\x1B[${l[1]}m`, a = (c, l) => l != null && typeof l == "string" ? i(c, t5[l]) : l != null && Array.isArray(l) ? l.reduce((u, d) => a(u, d), c) : l != null && l[c.trim()] != null ? a(c, l[c.trim()]) : l != null && l["*"] != null ? a(c, l["*"]) : c, s = null;
  return r.replace(/{{(.+?)}}/g, (c, l) => {
    var d;
    const u = n[l] != null ? String(n[l]) : o ? "" : c;
    return e.stylePrettyLogs ? a(u, ((d = e == null ? void 0 : e.prettyLogStyles) == null ? void 0 : d[l]) ?? s) + i("", t5.reset) : u;
  });
}
function bd(e, t = 2, n = 0) {
  return e != null && isNaN(e) ? "" : (e = e != null ? e + n : e, t === 2 ? e == null ? "--" : e < 10 ? "0" + e : e.toString() : e == null ? "---" : e < 10 ? "00" + e : e < 100 ? "0" + e : e.toString());
}
function H1c(e) {
  return {
    href: e.href,
    protocol: e.protocol,
    username: e.username,
    password: e.password,
    host: e.host,
    hostname: e.hostname,
    port: e.port,
    pathname: e.pathname,
    search: e.search,
    searchParams: [...e.searchParams].map(([t, n]) => ({ key: t, value: n })),
    hash: e.hash,
    origin: e.origin
  };
}
function Y_e(e) {
  const t = /* @__PURE__ */ new Set();
  return JSON.stringify(e, (n, o) => {
    if (typeof o == "object" && o !== null) {
      if (t.has(o))
        return "[Circular]";
      t.add(o);
    }
    return o;
  });
}
function Rc(e, t) {
  const n = {
    seen: [],
    stylize: K_e
  };
  return t != null && Q_e(n, t), Ab(n.showHidden) && (n.showHidden = !1), Ab(n.depth) && (n.depth = 2), Ab(n.colors) && (n.colors = !0), Ab(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = K1c), SC(n, e, n.depth);
}
Rc.colors = t5;
Rc.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  regexp: "red"
};
function Y1c(e) {
  return typeof e == "boolean";
}
function Ab(e) {
  return e === void 0;
}
function K_e(e) {
  return e;
}
function K1c(e, t) {
  var o, r, i, a;
  const n = Rc.styles[t];
  return n != null && ((r = (o = Rc == null ? void 0 : Rc.colors) == null ? void 0 : o[n]) == null ? void 0 : r[0]) != null && ((a = (i = Rc == null ? void 0 : Rc.colors) == null ? void 0 : i[n]) == null ? void 0 : a[1]) != null ? "\x1B[" + Rc.colors[n][0] + "m" + e + "\x1B[" + Rc.colors[n][1] + "m" : e;
}
function XS(e) {
  return typeof e == "function";
}
function Z_e(e) {
  return typeof e == "string";
}
function Z1c(e) {
  return typeof e == "number";
}
function X_e(e) {
  return e === null;
}
function J_e(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function iz(e) {
  return lA(e) && Aq(e) === "[object RegExp]";
}
function lA(e) {
  return typeof e == "object" && e !== null;
}
function az(e) {
  return lA(e) && (Aq(e) === "[object Error]" || e instanceof Error);
}
function wH(e) {
  return lA(e) && Aq(e) === "[object Date]";
}
function Aq(e) {
  return Object.prototype.toString.call(e);
}
function X1c(e) {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}
function J1c(e, t, n, o, r) {
  const i = [];
  for (let a = 0, s = t.length; a < s; ++a)
    J_e(t, String(a)) ? i.push(o5(e, t, n, o, String(a), !0)) : i.push("");
  return r.forEach((a) => {
    a.match(/^\d+$/) || i.push(o5(e, t, n, o, a, !0));
  }), i;
}
function sz(e) {
  return "[" + Error.prototype.toString.call(e) + "]";
}
function SC(e, t, n = 0) {
  if (e.customInspect && t != null && XS(t) && (t == null ? void 0 : t.inspect) !== Rc && !(t != null && t.constructor && (t == null ? void 0 : t.constructor.prototype) === t)) {
    if (typeof t.inspect != "function" && t.toString != null)
      return t.toString();
    let u = t == null ? void 0 : t.inspect(n, e);
    return Z_e(u) || (u = SC(e, u, n)), u;
  }
  const o = Zf(e, t);
  if (o)
    return o;
  let r = Object.keys(t);
  const i = X1c(r);
  try {
    e.showHidden && Object.getOwnPropertyNames && (r = Object.getOwnPropertyNames(t));
  } catch {
  }
  if (az(t) && (r.indexOf("message") >= 0 || r.indexOf("description") >= 0))
    return sz(t);
  if (r.length === 0)
    if (XS(e.stylize)) {
      if (XS(t)) {
        const u = t.name ? ": " + t.name : "";
        return e.stylize("[Function" + u + "]", "special");
      }
      if (iz(t))
        return e.stylize(RegExp.prototype.toString.call(t), "regexp");
      if (wH(t))
        return e.stylize(Date.prototype.toISOString.call(t), "date");
      if (az(t))
        return sz(t);
    } else
      return t;
  let a = "", s = !1, c = [`{
`, `
}`];
  if (Array.isArray(t) && (s = !0, c = [`[
`, `
]`]), XS(t) && (a = " [Function" + (t.name ? ": " + t.name : "") + "]"), iz(t) && (a = " " + RegExp.prototype.toString.call(t)), wH(t) && (a = " " + Date.prototype.toUTCString.call(t)), az(t) && (a = " " + sz(t)), r.length === 0 && (!s || t.length == 0))
    return c[0] + a + c[1];
  if (n < 0)
    return iz(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
  e.seen.push(t);
  let l;
  return s ? l = J1c(e, t, n, i, r) : l = r.map((u) => o5(e, t, n, i, u, s)), e.seen.pop(), Q1c(l, a, c);
}
function o5(e, t, n, o, r, i) {
  let a, s, c = { value: void 0 };
  try {
    c.value = t[r];
  } catch {
  }
  try {
    Object.getOwnPropertyDescriptor && (c = Object.getOwnPropertyDescriptor(t, r) || c);
  } catch {
  }
  if (c.get ? c.set ? s = e.stylize("[Getter/Setter]", "special") : s = e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), J_e(o, r) || (a = "[" + r + "]"), s || (e.seen.indexOf(c.value) < 0 ? (X_e(n) ? s = SC(e, c.value, void 0) : s = SC(e, c.value, n - 1), s.indexOf(`
`) > -1 && (i ? s = s.split(`
`).map((l) => "  " + l).join(`
`).substr(2) : s = `
` + s.split(`
`).map((l) => "   " + l).join(`
`))) : s = e.stylize("[Circular]", "special")), Ab(a)) {
    if (i && r.match(/^\d+$/))
      return s;
    a = JSON.stringify("" + r), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, "\\'").replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
  }
  return a + ": " + s;
}
function Zf(e, t) {
  if (Ab(t))
    return e.stylize("undefined", "undefined");
  if (Z_e(t)) {
    const n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\\'") + "'";
    return e.stylize(n, "string");
  }
  if (Z1c(t))
    return e.stylize("" + t, "number");
  if (Y1c(t))
    return e.stylize("" + t, "boolean");
  if (X_e(t))
    return e.stylize("null", "null");
}
function Q1c(e, t, n) {
  return n[0] + (t === "" ? "" : t + `
`) + "  " + e.join(`,
  `) + " " + n[1];
}
function Q_e(e, t) {
  if (!t || !lA(t))
    return e;
  const n = { ...e }, o = { ...t }, r = Object.keys(t);
  let i = r.length;
  for (; i--; )
    n[r[i]] = o[r[i]];
  return e;
}
function eSc(e, ...t) {
  const n = {
    seen: [],
    stylize: K_e
  };
  e != null && Q_e(n, e);
  const o = t[0];
  let r = 0, i = "", a = "";
  if (typeof o == "string") {
    if (t.length === 1)
      return o;
    let s, c = 0;
    for (let l = 0; l < o.length - 1; l++)
      if (o.charCodeAt(l) === 37) {
        const u = o.charCodeAt(++l);
        if (r + 1 !== t.length) {
          switch (u) {
            case 115: {
              const d = t[++r];
              typeof d == "number" || typeof d == "bigint" ? s = Zf(n, d) : typeof d != "object" || d === null ? s = String(d) : s = Rc(d, {
                ...e,
                compact: 3,
                colors: !1,
                depth: 0
              });
              break;
            }
            case 106:
              s = Y_e(t[++r]);
              break;
            case 100: {
              const d = t[++r];
              typeof d == "bigint" ? s = Zf(n, d) : typeof d == "symbol" ? s = "NaN" : s = Zf(n, d);
              break;
            }
            case 79:
              s = Rc(t[++r], e);
              break;
            case 111:
              s = Rc(t[++r], {
                ...e,
                showHidden: !0,
                showProxy: !0,
                depth: 4
              });
              break;
            case 105: {
              const d = t[++r];
              typeof d == "bigint" ? s = Zf(n, d) : typeof d == "symbol" ? s = "NaN" : s = Zf(n, parseInt(s));
              break;
            }
            case 102: {
              const d = t[++r];
              typeof d == "symbol" ? s = "NaN" : s = Zf(n, parseInt(d));
              break;
            }
            case 99:
              r += 1, s = "";
              break;
            case 37:
              i += o.slice(c, l), c = l + 1;
              continue;
            default:
              continue;
          }
          c !== l - 1 && (i += o.slice(c, l - 1)), i += s, c = l + 1;
        } else
          u === 37 && (i += o.slice(c, l), c = l + 1);
      }
    c !== 0 && (r++, a = " ", c < o.length && (i += o.slice(c)));
  }
  for (; r < t.length; ) {
    const s = t[r];
    i += a, i += typeof s != "string" ? Rc(s, e) : s, a = " ", r++;
  }
  return i;
}
const tSc = {
  getCallerStackFrame: epe,
  getErrorTrace: tpe,
  getMeta: rSc,
  transportJSON: sSc,
  transportFormatted: aSc,
  isBuffer: cSc,
  isError: ope,
  prettyFormatLogObj: iSc,
  prettyFormatErrorObj: rpe
};
var ure;
const nSc = {
  runtime: [typeof window, typeof document].includes("undefined") ? "Generic" : "Browser",
  browser: (ure = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : ure.userAgent
}, oSc = /(?:(?:file|https?|global code|[^@]+)@)?(?:file:)?((?:\/[^:/]+){2,})(?::(\d+))?(?::(\d+))?/;
function rSc(e, t, n, o, r, i) {
  return Object.assign({}, nSc, {
    name: r,
    parentNames: i,
    date: /* @__PURE__ */ new Date(),
    logLevelId: e,
    logLevelName: t,
    path: o ? void 0 : epe(n)
  });
}
function epe(e, t = Error()) {
  var n, o, r;
  return npe((r = (o = (n = t == null ? void 0 : t.stack) == null ? void 0 : n.split(`
`)) == null ? void 0 : o.filter((i) => !i.includes("Error: "))) == null ? void 0 : r[e]);
}
function tpe(e) {
  var t, n, o;
  return (o = (n = (t = e == null ? void 0 : e.stack) == null ? void 0 : t.split(`
`)) == null ? void 0 : n.filter((r) => !r.includes("Error: "))) == null ? void 0 : o.reduce((r, i) => (r.push(npe(i)), r), []);
}
function npe(e) {
  var o;
  const t = (o = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : o.origin, n = {
    fullFilePath: void 0,
    fileName: void 0,
    fileNameWithLine: void 0,
    fileColumn: void 0,
    fileLine: void 0,
    filePath: void 0,
    filePathWithLine: void 0,
    method: void 0
  };
  if (e != null) {
    const r = e.match(oSc);
    if (r) {
      n.filePath = r[1].replace(/\?.*$/, ""), n.fullFilePath = `${t}${n.filePath}`;
      const i = n.filePath.split("/");
      n.fileName = i[i.length - 1], n.fileLine = r[2], n.fileColumn = r[3], n.filePathWithLine = `${n.filePath}:${n.fileLine}`, n.fileNameWithLine = `${n.fileName}:${n.fileLine}`;
    }
  }
  return n;
}
function ope(e) {
  return e instanceof Error;
}
function iSc(e, t) {
  return e.reduce((n, o) => (ope(o) ? n.errors.push(rpe(o, t)) : n.args.push(o), n), { args: [], errors: [] });
}
function rpe(e, t) {
  const n = tpe(e).map((r) => n5(t, t.prettyErrorStackTemplate, { ...r }, !0)), o = {
    errorName: ` ${e.name} `,
    errorMessage: Object.getOwnPropertyNames(e).reduce((r, i) => (i !== "stack" && r.push(e[i]), r), []).join(", "),
    errorStack: n.join(`
`)
  };
  return n5(t, t.prettyErrorTemplate, o);
}
function aSc(e, t, n, o) {
  const r = (n.length > 0 && t.length > 0 ? `
` : "") + n.join(`
`);
  o.prettyInspectOptions.colors = o.stylePrettyLogs, console.log(e + eSc(o.prettyInspectOptions, ...t) + r);
}
function sSc(e) {
  console.log(Y_e(e));
}
function cSc(e) {
  return !1;
}
class lSc {
  constructor(t, n, o = 4) {
    var r, i, a, s, c, l, u, d;
    this.logObj = n, this.stackDepthLevel = o, this.runtime = tSc, this.settings = {
      type: (t == null ? void 0 : t.type) ?? "pretty",
      name: t == null ? void 0 : t.name,
      parentNames: t == null ? void 0 : t.parentNames,
      minLevel: (t == null ? void 0 : t.minLevel) ?? 0,
      argumentsArrayName: t == null ? void 0 : t.argumentsArrayName,
      hideLogPositionForProduction: (t == null ? void 0 : t.hideLogPositionForProduction) ?? !1,
      prettyLogTemplate: (t == null ? void 0 : t.prettyLogTemplate) ?? "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	{{filePathWithLine}}{{nameWithDelimiterPrefix}}	",
      prettyErrorTemplate: (t == null ? void 0 : t.prettyErrorTemplate) ?? `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
      prettyErrorStackTemplate: (t == null ? void 0 : t.prettyErrorStackTemplate) ?? `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
      prettyErrorParentNamesSeparator: (t == null ? void 0 : t.prettyErrorParentNamesSeparator) ?? ":",
      prettyErrorLoggerNameDelimiter: (t == null ? void 0 : t.prettyErrorLoggerNameDelimiter) ?? "	",
      stylePrettyLogs: (t == null ? void 0 : t.stylePrettyLogs) ?? !0,
      prettyLogTimeZone: (t == null ? void 0 : t.prettyLogTimeZone) ?? "UTC",
      prettyLogStyles: (t == null ? void 0 : t.prettyLogStyles) ?? {
        logLevelName: {
          "*": ["bold", "black", "bgWhiteBright", "dim"],
          SILLY: ["bold", "white"],
          TRACE: ["bold", "whiteBright"],
          DEBUG: ["bold", "green"],
          INFO: ["bold", "blue"],
          WARN: ["bold", "yellow"],
          ERROR: ["bold", "red"],
          FATAL: ["bold", "redBright"]
        },
        dateIsoStr: "white",
        filePathWithLine: "white",
        name: ["white", "bold"],
        nameWithDelimiterPrefix: ["white", "bold"],
        nameWithDelimiterSuffix: ["white", "bold"],
        errorName: ["bold", "bgRedBright", "whiteBright"],
        fileName: ["yellow"],
        fileNameWithLine: "white"
      },
      prettyInspectOptions: (t == null ? void 0 : t.prettyInspectOptions) ?? {
        colors: !0,
        compact: !1,
        depth: 1 / 0
      },
      metaProperty: (t == null ? void 0 : t.metaProperty) ?? "_meta",
      maskPlaceholder: (t == null ? void 0 : t.maskPlaceholder) ?? "[***]",
      maskValuesOfKeys: (t == null ? void 0 : t.maskValuesOfKeys) ?? ["password"],
      maskValuesOfKeysCaseInsensitive: (t == null ? void 0 : t.maskValuesOfKeysCaseInsensitive) ?? !1,
      maskValuesRegEx: t == null ? void 0 : t.maskValuesRegEx,
      prefix: [...(t == null ? void 0 : t.prefix) ?? []],
      attachedTransports: [...(t == null ? void 0 : t.attachedTransports) ?? []],
      overwrite: {
        mask: (r = t == null ? void 0 : t.overwrite) == null ? void 0 : r.mask,
        toLogObj: (i = t == null ? void 0 : t.overwrite) == null ? void 0 : i.toLogObj,
        addMeta: (a = t == null ? void 0 : t.overwrite) == null ? void 0 : a.addMeta,
        addPlaceholders: (s = t == null ? void 0 : t.overwrite) == null ? void 0 : s.addPlaceholders,
        formatMeta: (c = t == null ? void 0 : t.overwrite) == null ? void 0 : c.formatMeta,
        formatLogObj: (l = t == null ? void 0 : t.overwrite) == null ? void 0 : l.formatLogObj,
        transportFormatted: (u = t == null ? void 0 : t.overwrite) == null ? void 0 : u.transportFormatted,
        transportJSON: (d = t == null ? void 0 : t.overwrite) == null ? void 0 : d.transportJSON
      }
    };
  }
  log(t, n, ...o) {
    var d, _, p, g, f, h, $, v, b, y, w, N, M, q;
    if (t < this.settings.minLevel)
      return;
    const r = [...this.settings.prefix, ...o], i = ((d = this.settings.overwrite) == null ? void 0 : d.mask) != null ? (_ = this.settings.overwrite) == null ? void 0 : _.mask(r) : this.settings.maskValuesOfKeys != null && this.settings.maskValuesOfKeys.length > 0 ? this._mask(r) : r, a = this.logObj != null ? this._recursiveCloneAndExecuteFunctions(this.logObj) : void 0, s = ((p = this.settings.overwrite) == null ? void 0 : p.toLogObj) != null ? (g = this.settings.overwrite) == null ? void 0 : g.toLogObj(i, a) : this._toLogObj(i, a), c = ((f = this.settings.overwrite) == null ? void 0 : f.addMeta) != null ? (h = this.settings.overwrite) == null ? void 0 : h.addMeta(s, t, n) : this._addMetaToLogObj(s, t, n);
    let l, u;
    return (($ = this.settings.overwrite) == null ? void 0 : $.formatMeta) != null && (l = (v = this.settings.overwrite) == null ? void 0 : v.formatMeta(c == null ? void 0 : c[this.settings.metaProperty])), ((b = this.settings.overwrite) == null ? void 0 : b.formatLogObj) != null && (u = (y = this.settings.overwrite) == null ? void 0 : y.formatLogObj(i, this.settings)), this.settings.type === "pretty" && (l = l ?? this._prettyFormatLogObjMeta(c == null ? void 0 : c[this.settings.metaProperty]), u = u ?? this.runtime.prettyFormatLogObj(i, this.settings)), l != null && u != null ? ((w = this.settings.overwrite) == null ? void 0 : w.transportFormatted) != null ? (N = this.settings.overwrite) == null || N.transportFormatted(l, u.args, u.errors, this.settings) : this.runtime.transportFormatted(l, u.args, u.errors, this.settings) : ((M = this.settings.overwrite) == null ? void 0 : M.transportJSON) != null ? (q = this.settings.overwrite) == null || q.transportJSON(c) : this.settings.type !== "hidden" && this.runtime.transportJSON(c), this.settings.attachedTransports != null && this.settings.attachedTransports.length > 0 && this.settings.attachedTransports.forEach((L) => {
      L(c);
    }), c;
  }
  attachTransport(t) {
    this.settings.attachedTransports.push(t);
  }
  getSubLogger(t, n) {
    var i, a, s;
    const o = {
      ...this.settings,
      ...t,
      parentNames: ((i = this.settings) == null ? void 0 : i.parentNames) != null && ((a = this.settings) == null ? void 0 : a.name) != null ? [...this.settings.parentNames, this.settings.name] : ((s = this.settings) == null ? void 0 : s.name) != null ? [this.settings.name] : void 0,
      prefix: [...this.settings.prefix, ...(t == null ? void 0 : t.prefix) ?? []]
    };
    return new this.constructor(o, n ?? this.logObj, this.stackDepthLevel);
  }
  _mask(t) {
    const n = this.settings.maskValuesOfKeysCaseInsensitive !== !0 ? this.settings.maskValuesOfKeys : this.settings.maskValuesOfKeys.map((o) => o.toLowerCase());
    return t == null ? void 0 : t.map((o) => this._recursiveCloneAndMaskValuesOfKeys(o, n));
  }
  _recursiveCloneAndMaskValuesOfKeys(t, n, o = []) {
    var r, i;
    if (o.includes(t))
      return { ...t };
    if (typeof t == "object" && t !== null && o.push(t), this.runtime.isError(t) || this.runtime.isBuffer(t))
      return t;
    if (t instanceof Map)
      return new Map(t);
    if (t instanceof Set)
      return new Set(t);
    if (Array.isArray(t))
      return t.map((a) => this._recursiveCloneAndMaskValuesOfKeys(a, n, o));
    if (t instanceof Date)
      return new Date(t.getTime());
    if (t instanceof URL)
      return H1c(t);
    if (t !== null && typeof t == "object") {
      const a = this.runtime.isError(t) ? this._cloneError(t) : Object.create(Object.getPrototypeOf(t));
      return Object.getOwnPropertyNames(t).reduce((s, c) => {
        var l;
        return s[c] = n.includes(((l = this.settings) == null ? void 0 : l.maskValuesOfKeysCaseInsensitive) !== !0 ? c : c.toLowerCase()) ? this.settings.maskPlaceholder : this._recursiveCloneAndMaskValuesOfKeys(t[c], n, o), s;
      }, a);
    } else {
      if (typeof t == "string") {
        let a = t;
        for (const s of ((r = this.settings) == null ? void 0 : r.maskValuesRegEx) || [])
          a = a.replace(s, ((i = this.settings) == null ? void 0 : i.maskPlaceholder) || "");
        return a;
      }
      return t;
    }
  }
  _recursiveCloneAndExecuteFunctions(t, n = []) {
    return this.isObjectOrArray(t) && n.includes(t) ? this.shallowCopy(t) : (this.isObjectOrArray(t) && n.push(t), Array.isArray(t) ? t.map((o) => this._recursiveCloneAndExecuteFunctions(o, n)) : t instanceof Date ? new Date(t.getTime()) : this.isObject(t) ? Object.getOwnPropertyNames(t).reduce((o, r) => {
      const i = Object.getOwnPropertyDescriptor(t, r);
      if (i) {
        Object.defineProperty(o, r, i);
        const a = t[r];
        o[r] = typeof a == "function" ? a() : this._recursiveCloneAndExecuteFunctions(a, n);
      }
      return o;
    }, Object.create(Object.getPrototypeOf(t))) : t);
  }
  isObjectOrArray(t) {
    return typeof t == "object" && t !== null;
  }
  isObject(t) {
    return typeof t == "object" && !Array.isArray(t) && t !== null;
  }
  shallowCopy(t) {
    return Array.isArray(t) ? [...t] : { ...t };
  }
  _toLogObj(t, n = {}) {
    return t = t == null ? void 0 : t.map((o) => this.runtime.isError(o) ? this._toErrorObject(o) : o), this.settings.argumentsArrayName == null ? t.length === 1 && !Array.isArray(t[0]) && this.runtime.isBuffer(t[0]) !== !0 && !(t[0] instanceof Date) ? n = typeof t[0] == "object" && t[0] != null ? { ...t[0], ...n } : { 0: t[0], ...n } : n = { ...n, ...t } : n = {
      ...n,
      [this.settings.argumentsArrayName]: t
    }, n;
  }
  _cloneError(t) {
    const n = new t.constructor();
    return Object.getOwnPropertyNames(t).forEach((o) => {
      n[o] = t[o];
    }), n;
  }
  _toErrorObject(t) {
    return {
      nativeError: t,
      name: t.name ?? "Error",
      message: t.message,
      stack: this.runtime.getErrorTrace(t)
    };
  }
  _addMetaToLogObj(t, n, o) {
    return {
      ...t,
      [this.settings.metaProperty]: this.runtime.getMeta(n, o, this.stackDepthLevel, this.settings.hideLogPositionForProduction, this.settings.name, this.settings.parentNames)
    };
  }
  _prettyFormatLogObjMeta(t) {
    var a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w, N, M, q, L, R, T;
    if (t == null)
      return "";
    let n = this.settings.prettyLogTemplate;
    const o = {};
    n.includes("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}") ? n = n.replace("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}", "{{dateIsoStr}}") : this.settings.prettyLogTimeZone === "UTC" ? (o.yyyy = ((a = t == null ? void 0 : t.date) == null ? void 0 : a.getUTCFullYear()) ?? "----", o.mm = bd((s = t == null ? void 0 : t.date) == null ? void 0 : s.getUTCMonth(), 2, 1), o.dd = bd((c = t == null ? void 0 : t.date) == null ? void 0 : c.getUTCDate(), 2), o.hh = bd((l = t == null ? void 0 : t.date) == null ? void 0 : l.getUTCHours(), 2), o.MM = bd((u = t == null ? void 0 : t.date) == null ? void 0 : u.getUTCMinutes(), 2), o.ss = bd((d = t == null ? void 0 : t.date) == null ? void 0 : d.getUTCSeconds(), 2), o.ms = bd((_ = t == null ? void 0 : t.date) == null ? void 0 : _.getUTCMilliseconds(), 3)) : (o.yyyy = ((p = t == null ? void 0 : t.date) == null ? void 0 : p.getFullYear()) ?? "----", o.mm = bd((g = t == null ? void 0 : t.date) == null ? void 0 : g.getMonth(), 2, 1), o.dd = bd((f = t == null ? void 0 : t.date) == null ? void 0 : f.getDate(), 2), o.hh = bd((h = t == null ? void 0 : t.date) == null ? void 0 : h.getHours(), 2), o.MM = bd(($ = t == null ? void 0 : t.date) == null ? void 0 : $.getMinutes(), 2), o.ss = bd((v = t == null ? void 0 : t.date) == null ? void 0 : v.getSeconds(), 2), o.ms = bd((b = t == null ? void 0 : t.date) == null ? void 0 : b.getMilliseconds(), 3));
    const r = this.settings.prettyLogTimeZone === "UTC" ? t == null ? void 0 : t.date : new Date(((y = t == null ? void 0 : t.date) == null ? void 0 : y.getTime()) - ((w = t == null ? void 0 : t.date) == null ? void 0 : w.getTimezoneOffset()) * 6e4);
    o.rawIsoStr = r == null ? void 0 : r.toISOString(), o.dateIsoStr = r == null ? void 0 : r.toISOString().replace("T", " ").replace("Z", ""), o.logLevelName = t == null ? void 0 : t.logLevelName, o.fileNameWithLine = ((N = t == null ? void 0 : t.path) == null ? void 0 : N.fileNameWithLine) ?? "", o.filePathWithLine = ((M = t == null ? void 0 : t.path) == null ? void 0 : M.filePathWithLine) ?? "", o.fullFilePath = ((q = t == null ? void 0 : t.path) == null ? void 0 : q.fullFilePath) ?? "";
    let i = (L = this.settings.parentNames) == null ? void 0 : L.join(this.settings.prettyErrorParentNamesSeparator);
    return i = i != null && (t == null ? void 0 : t.name) != null ? i + this.settings.prettyErrorParentNamesSeparator : void 0, o.name = (t == null ? void 0 : t.name) != null || i != null ? (i ?? "") + (t == null ? void 0 : t.name) : "", o.nameWithDelimiterPrefix = o.name.length > 0 ? this.settings.prettyErrorLoggerNameDelimiter + o.name : "", o.nameWithDelimiterSuffix = o.name.length > 0 ? o.name + this.settings.prettyErrorLoggerNameDelimiter : "", ((R = this.settings.overwrite) == null ? void 0 : R.addPlaceholders) != null && ((T = this.settings.overwrite) == null || T.addPlaceholders(t, o)), n5(this.settings, n, o);
  }
}
class uSc extends lSc {
  constructor(t, n) {
    const o = typeof window < "u" && typeof document < "u", r = o ? window.chrome !== void 0 && window.CSS !== void 0 && window.CSS.supports("color", "green") : !1, i = o ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
    t = t || {}, t.stylePrettyLogs = t.stylePrettyLogs && o && !r ? !1 : t.stylePrettyLogs, super(t, n, i ? 4 : 5);
  }
  log(t, n, ...o) {
    return super.log(t, n, ...o);
  }
  silly(...t) {
    return super.log(0, "SILLY", ...t);
  }
  trace(...t) {
    return super.log(1, "TRACE", ...t);
  }
  debug(...t) {
    return super.log(2, "DEBUG", ...t);
  }
  info(...t) {
    return super.log(3, "INFO", ...t);
  }
  warn(...t) {
    return super.log(4, "WARN", ...t);
  }
  error(...t) {
    return super.log(5, "ERROR", ...t);
  }
  fatal(...t) {
    return super.log(6, "FATAL", ...t);
  }
  getSubLogger(t, n) {
    return super.getSubLogger(t, n);
  }
}
const dSc = new uSc({
  minLevel: parseInt(process.env.NEXT_PUBLIC_LOGGER_LEVEL || "4"),
  maskValuesOfKeys: ["password", "passwordConfirmation", "credentials", "credential"],
  prettyLogTimeZone: qE ? "UTC" : "local",
  prettyErrorStackTemplate: `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
  // default
  prettyErrorTemplate: `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
  // default
  prettyLogTemplate: "{{hh}}:{{MM}}:{{ss}}:{{ms}} [{{logLevelName}}] ",
  // default with exclusion of `{{filePathWithLine}}`
  stylePrettyLogs: !qE,
  prettyLogStyles: {
    name: "yellow",
    dateIsoStr: "blue"
  },
  type: qE ? "json" : "pretty"
}), uA = dSc;
function Kk(e) {
  try {
    return e instanceof Error ? JSON.stringify(e.stack ?? e.message) : JSON.stringify(e);
  } catch {
    return e;
  }
}
function _Sc({
  periodType: e,
  periodDays: t,
  periodCountCalendarDays: n,
  periodStartDate: o,
  periodEndDate: r,
  /**
   * These dates will be considered in the same utfcOffset as provided
   */
  allDatesWithBookabilityStatusInBookerTz: i,
  eventUtcOffset: a,
  bookerUtcOffset: s,
  /**
   * This is temporary till we find a way to provide allDatesWithBookabilityStatus in handleNewBooking without re-computing availability.
   * It is okay for handleNewBooking to pass it as true as the frontend won't allow selecting a timeslot that is out of bounds of ROLLING_WINDOW
   * But for the booking that happen through API, we absolutely need to check the ROLLING_WINDOW limits.
   */
  _skipRollingWindowCheck: c
}) {
  const l = ht(), u = l.utcOffset(a), d = l.utcOffset(s);
  switch (t = t || 0, uA.getSubLogger({ prefix: ["calculatePeriodLimits"] }).debug(
    Kk({
      periodType: e,
      periodDays: t,
      periodCountCalendarDays: n,
      periodStartDate: o,
      periodEndDate: r,
      currentTime: u.format()
    })
  ), e) {
    case ic.ROLLING:
      return {
        endOfRollingPeriodEndDayInBookerTz: (n ? d.add(t, "days") : d.businessDaysAdd(t)).endOf("day"),
        startOfRangeStartDayInEventTz: null,
        endOfRangeEndDayInEventTz: null
      };
    case ic.ROLLING_WINDOW: {
      if (c)
        return {
          endOfRollingPeriodEndDayInBookerTz: null,
          startOfRangeStartDayInEventTz: null,
          endOfRangeEndDayInEventTz: null
        };
      if (!i)
        throw new Error("`allDatesWithBookabilityStatus` is required");
      return {
        endOfRollingPeriodEndDayInBookerTz: pSc({
          startDateInBookerTz: d,
          daysNeeded: t,
          allDatesWithBookabilityStatusInBookerTz: i,
          countNonBusinessDays: n
        }),
        startOfRangeStartDayInEventTz: null,
        endOfRangeEndDayInEventTz: null
      };
    }
    case ic.RANGE: {
      const p = ht(o).utcOffset(a).startOf("day"), g = ht(r).utcOffset(a).endOf("day");
      return {
        endOfRollingPeriodEndDayInBookerTz: null,
        startOfRangeStartDayInEventTz: p,
        endOfRangeEndDayInEventTz: g
      };
    }
  }
  return {
    endOfRollingPeriodEndDayInBookerTz: null,
    startOfRangeStartDayInEventTz: null,
    endOfRangeEndDayInEventTz: null
  };
}
function pSc({
  startDateInBookerTz: e,
  daysNeeded: t,
  allDatesWithBookabilityStatusInBookerTz: n,
  countNonBusinessDays: o
}) {
  var _;
  const r = uA.getSubLogger({ prefix: ["getRollingWindowEndDate"] });
  r.debug("called:", Kk({ startDay: e.format(), daysNeeded: t }));
  let i = 1, a;
  const s = e.startOf("day"), c = RM;
  let l = 0, u = s;
  for (; l < t && !(i > c); ) {
    const p = u.format("YYYY-MM-DD"), g = !!((_ = n[p]) != null && _.isBookable);
    g && (l++, a = u), r.silly(
      `Loop Iteration: ${i}`,
      Kk({
        iterationDayBeginning: u.format(),
        isBookable: g,
        bookableDaysCount: l,
        rollingEndDay: a == null ? void 0 : a.format(),
        allDatesWithBookabilityStatusInBookerTz: n
      })
    ), u = o ? u.add(1, "days") : u.businessDaysAdd(1), i++;
  }
  const d = (a ?? u).endOf("day");
  return r.debug("Returning rollingEndDay", d.format()), d;
}
function mSc({
  time: e,
  periodLimits: t
}) {
  const n = uA.getSubLogger({ prefix: ["isTimeViolatingFutureLimit"] }), o = new Date(e);
  if (t.endOfRollingPeriodEndDayInBookerTz) {
    const r = o.valueOf() > t.endOfRollingPeriodEndDayInBookerTz.valueOf();
    return r && n.warn(
      "Booking is out of bounds due to rolling period end day.",
      Kk({
        formattedDate: o.toISOString(),
        isAfterRollingEndDay: r,
        endOfRollingPeriodEndDayTs: t.endOfRollingPeriodEndDayInBookerTz.valueOf()
      })
    ), r;
  }
  if (t.startOfRangeStartDayInEventTz && t.endOfRangeEndDayInEventTz) {
    const r = o.valueOf() < t.startOfRangeStartDayInEventTz.valueOf(), i = o.valueOf() > t.endOfRangeEndDayInEventTz.valueOf();
    return (r || i) && n.warn(
      "Booking is out of bounds due to range start and end.",
      Kk({
        formattedDate: o.toISOString(),
        isBeforeRangeStart: r,
        isAfterRangeEnd: i,
        startOfRangeStartDayInEventTz: t.startOfRangeStartDayInEventTz.toDate().toISOString(),
        endOfRangeEndDayInEventTz: t.endOfRangeEndDayInEventTz.toDate().toISOString()
      })
    ), r || i;
  }
  return !1;
}
const fSc = (e, t) => {
  const { periodDays: n, periodType: o, periodCountCalendarDays: r, periodEndDate: i, periodStartDate: a } = t, s = _Sc({
    periodType: o,
    periodDays: n,
    periodCountCalendarDays: r,
    periodStartDate: a,
    periodEndDate: i,
    allDatesWithBookabilityStatusInBookerTz: null,
    // Temporary workaround
    _skipRollingWindowCheck: !0,
    eventUtcOffset: 0,
    bookerUtcOffset: 0
  });
  return mSc({
    time: e.add(1, "month").startOf("month").toDate(),
    periodLimits: s
  });
}, gSc = (e, t) => {
  const { t: n } = kt();
  if (!e)
    return "";
  if (t.periodType === "ROLLING") {
    const o = t.periodCountCalendarDays ? n("calendar_days") : n("business_days");
    return n("no_availability_rolling", { days: `${t.periodDays} ${o}` });
  }
  return t.periodType === "RANGE" ? n("no_availability_range", { date: ht(t.periodEndDate).format("MMMM D YYYY") }) : "";
}, hSc = ({
  month: e,
  nextMonthButton: t,
  browsingDate: n,
  periodData: o
}) => {
  const { t: r } = kt(), [i, a] = it(!0), s = fSc(n, o), c = gSc(s, o), l = () => {
    a(!1);
  };
  return /* @__PURE__ */ m(
    _v,
    {
      open: i,
      onOpenChange: (u) => {
        a(u);
      },
      children: /* @__PURE__ */ m(
        Ya,
        {
          title: r("no_availability_in_month", { month: e }),
          type: "creation",
          description: c,
          preventCloseOnOutsideClick: !1,
          children: /* @__PURE__ */ de(Wu, { children: [
            /* @__PURE__ */ m(
              Gs,
              {
                color: s ? "primary" : "secondary",
                onClick: l,
                "data-testid": "close_dialog_button",
                children: r("close")
              }
            ),
            !s && /* @__PURE__ */ m(
              Jt,
              {
                color: "primary",
                onClick: t,
                "data-testid": "view_next_month",
                EndIcon: "arrow-right",
                children: r("view_next_month")
              }
            )
          ] })
        }
      )
    }
  );
}, vSc = hSc, bSc = ({
  date: e,
  active: t,
  disabled: n,
  away: o,
  emoji: r,
  customClassName: i,
  showMonthTooltip: a,
  isFirstDayOfNextMonth: s,
  ...c
}) => {
  const { t: l } = kt(), u = mH("enabledDateButton"), d = mH("disabledDateButton"), _ = /* @__PURE__ */ de(
    "button",
    {
      type: "button",
      style: n ? { ...d } : { ...u },
      className: xe(
        "disabled:text-bookinglighter absolute bottom-0 left-0 right-0 top-0 mx-auto w-full rounded-md border-2 border-transparent text-center text-sm font-medium transition disabled:cursor-default disabled:border-transparent disabled:font-light ",
        t ? "bg-brand-default text-brand" : n ? `${i ? "" : " text-mute"}` : `${i != null && i.dayActive ? `hover:border-brand-default ${i.dayActive}` : "hover:border-brand-default text-emphasis bg-emphasis"}`
      ),
      "data-testid": "day",
      "data-disabled": n,
      disabled: n,
      ...c,
      children: [
        o && /* @__PURE__ */ m("span", { "data-testid": "away-emoji", children: r }),
        !o && e.date(),
        e.isToday() && /* @__PURE__ */ m(
          "span",
          {
            className: xe(
              "bg-brand-default absolute left-1/2 top-1/2 flex h-[5px] w-[5px] -translate-x-1/2 translate-y-[8px] items-center justify-center rounded-full align-middle sm:translate-y-[12px]",
              t && "bg-brand-accent"
            ),
            children: /* @__PURE__ */ m("span", { className: "sr-only", children: l("today") })
          }
        )
      ]
    }
  ), p = a ? /* @__PURE__ */ m(Sr, { content: e.format("MMMM"), children: _ }) : _;
  return /* @__PURE__ */ de(nt, { children: [
    s && /* @__PURE__ */ m(
      "div",
      {
        className: xe(
          "absolute top-0 z-10 mx-auto w-fit rounded-full font-semibold uppercase tracking-wide",
          t ? "text-white" : "text-default",
          n && "bg-emphasis"
        ),
        style: {
          fontSize: "10px",
          lineHeight: "13px",
          padding: n ? "0 3px" : "3px 3px 3px 4px"
        },
        children: e.format("MMM")
      }
    ),
    p
  ] });
}, ySc = ({
  minDate: e,
  excludedDates: t = [],
  browsingDate: n,
  weekStart: o,
  DayComponent: r = bSc,
  selected: i,
  month: a,
  nextMonthButton: s,
  eventSlug: c,
  slots: l,
  customClassName: u,
  isBookingInPast: d,
  periodData: _,
  isCompact: p,
  showNoAvailabilityDialog: g = !0,
  ...f
}) => {
  const h = G1c({
    browsingDate: n.toDate(),
    minDate: e,
    includedDates: f.includedDates
  }), $ = ht(), v = n.startOf("month"), b = $.isAfter(v.add(2, "week"));
  let y = [];
  const w = (D) => (n.set("date", D).day() - o + 7) % 7, N = W_e(n), M = b && !p;
  if (M) {
    const A = w(8);
    y = Array(A).fill(null);
    for (let k = 8; k <= N; k++)
      y.push(n.set("date", k));
    const S = y.length % 7, E = (S > 0 ? 7 - S : 0) + 7, x = n.add(1, "month");
    for (let k = 0; k < E; k++)
      y.push(x.set("date", 1 + k));
  } else {
    const D = w(1);
    y = Array(D).fill(null);
    for (let A = 1; A <= N; A++)
      y.push(n.set("date", A));
  }
  const [q] = _n((D) => [D.selectedDatesAndTimes], Xi), L = (D) => Array.isArray(i) ? Array.isArray(i) && (i == null ? void 0 : i.some((A) => ll(A) === ll(D))) : i && ll(i) === ll(D) ? !0 : c && q && q[c] && Object.keys(q[c]).length > 0 ? Object.keys(q[c]).some((A) => ll(ht(A)) === ll(D)) : !1, R = y.map((D) => {
    if (!D)
      return { day: null, disabled: !0 };
    const A = ll(D), S = (l == null ? void 0 : l[A]) || [], E = S.find((U) => U.away) || null, x = D.month() !== n.month(), k = b && !p && x && D.date() === 1, I = h == null ? void 0 : h.includes(A), z = t.includes(A), F = S.some((U) => !U.away), O = S.length > 0 && S.every((U) => U.away), V = O ? !(E != null && E.toUser) : x ? !F : !I || z;
    return {
      day: D,
      disabled: V,
      away: O,
      emoji: E == null ? void 0 : E.emoji,
      isFirstDayOfNextMonth: k
    };
  });
  return yt(() => {
    var S;
    if (i instanceof Array)
      return;
    const D = (S = R.find((E) => !E.disabled)) == null ? void 0 : S.day, A = i ? R.some(({ day: E, disabled: x }) => {
      if (E && ll(E) === ll(i) && !x)
        return !0;
    }) : !1;
    if (!A && D) {
      const E = !(i != null && i.isValid());
      f.onChange(D, E);
    }
    A && f.onChange(ht(i), !0), D || f.onChange(null);
  }), /* @__PURE__ */ de(nt, { children: [
    R.map(({ day: D, disabled: A, away: S, emoji: E, isFirstDayOfNextMonth: x }, k) => /* @__PURE__ */ m("div", { className: "relative w-full pt-[100%]", children: D === null ? /* @__PURE__ */ m("div", {}, `e-${k}`) : f.isLoading ? /* @__PURE__ */ m(
      "button",
      {
        className: "bg-muted text-muted absolute bottom-0 left-0 right-0 top-0 mx-auto flex w-full items-center justify-center rounded-sm border-transparent text-center font-medium opacity-90 transition",
        disabled: !0,
        children: /* @__PURE__ */ m(Yo, { className: "h-8 w-9" })
      },
      `e-${k}`
    ) : /* @__PURE__ */ m(
      r,
      {
        customClassName: {
          dayContainer: u == null ? void 0 : u.datePickerDate,
          dayActive: u == null ? void 0 : u.datePickerDateActive
        },
        date: D,
        onClick: () => {
          var I;
          f.onChange(D), (I = f == null ? void 0 : f.scrollToTimeSlots) == null || I.call(f);
        },
        disabled: A,
        active: L(D),
        away: S,
        emoji: E,
        showMonthTooltip: M && !A && D.month() !== n.month(),
        isFirstDayOfNextMonth: x
      }
    ) }, D === null ? `e-${k}` : `day-${D.format()}`)),
    !f.isLoading && !d && h && (h == null ? void 0 : h.length) === 0 && g && /* @__PURE__ */ m(
      vSc,
      {
        month: a,
        nextMonthButton: s,
        browsingDate: n,
        periodData: _
      }
    )
  ] });
}, ipe = ({
  weekStart: e = 0,
  className: t,
  locale: n,
  selected: o,
  onMonthChange: r,
  slots: i,
  customClassNames: a,
  includedDates: s,
  periodData: c = {
    periodStartDate: null,
    periodEndDate: null,
    periodCountCalendarDays: null,
    periodDays: null,
    periodType: "UNLIMITED"
  },
  isCompact: l,
  showNoAvailabilityDialog: u,
  ...d
}) => {
  const _ = d.minDate, p = d.browsingDate || ht().startOf("month"), g = _ && p.valueOf() < _.valueOf() ? ht(_) : p, { i18n: f, t: h } = kt(), $ = _n((w) => w.bookingData), v = $ ? new Date($.endTime) < /* @__PURE__ */ new Date() : !1, b = (w) => {
    r && r(g.add(w, "month"));
  }, y = g ? new Intl.DateTimeFormat(f.language, { month: "long" }).format(
    new Date(g.year(), g.month())
  ) : null;
  return /* @__PURE__ */ de("div", { className: t, children: [
    /* @__PURE__ */ de("div", { className: "mb-1 flex items-center justify-between text-xl", children: [
      /* @__PURE__ */ m("span", { className: "text-default w-1/2 text-base", children: g ? /* @__PURE__ */ de("time", { dateTime: g.format("YYYY-MM"), "data-testid": "selected-month-label", children: [
        /* @__PURE__ */ m(
          "strong",
          {
            className: xe("text-emphasis font-semibold", a == null ? void 0 : a.datePickerTitle),
            children: y
          }
        ),
        " ",
        /* @__PURE__ */ m("span", { className: xe("text-subtle font-medium", a == null ? void 0 : a.datePickerTitle), children: g.format("YYYY") })
      ] }) : /* @__PURE__ */ m(Yo, { className: "h-8 w-24" }) }),
      /* @__PURE__ */ m("div", { className: "text-emphasis", children: /* @__PURE__ */ de("div", { className: "flex", children: [
        /* @__PURE__ */ m(
          Jt,
          {
            className: xe(
              "group p-1 opacity-70 transition hover:opacity-100 rtl:rotate-180",
              !g.isAfter(ht()) && "disabled:text-bookinglighter hover:bg-background hover:opacity-70",
              a == null ? void 0 : a.datePickerToggle
            ),
            onClick: () => b(-1),
            disabled: !g.isAfter(ht()),
            "data-testid": "decrementMonth",
            color: "minimal",
            variant: "icon",
            StartIcon: "chevron-left",
            "aria-label": h("view_previous_month")
          }
        ),
        /* @__PURE__ */ m(
          Jt,
          {
            className: xe(
              "group p-1 opacity-70 transition hover:opacity-100 rtl:rotate-180",
              `${a == null ? void 0 : a.datePickerToggle}`
            ),
            onClick: () => b(1),
            "data-testid": "incrementMonth",
            color: "minimal",
            variant: "icon",
            StartIcon: "chevron-right",
            "aria-label": h("view_next_month")
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ m("div", { className: "border-subtle mb-2 grid grid-cols-7 gap-4 border-b border-t text-center md:mb-0 md:border-0", children: Qy(n, e, "short").map((w) => /* @__PURE__ */ m(
      "div",
      {
        className: xe(
          "text-emphasis my-4 text-xs font-medium uppercase tracking-widest",
          a == null ? void 0 : a.datePickerDays
        ),
        children: w
      },
      w
    )) }),
    /* @__PURE__ */ m("div", { className: "relative grid grid-cols-7 grid-rows-6 gap-1 text-center", children: /* @__PURE__ */ m(
      ySc,
      {
        customClassName: {
          datePickerDate: a == null ? void 0 : a.datePickersDates,
          datePickerDateActive: a == null ? void 0 : a.datePickerDatesActive
        },
        weekStart: e,
        selected: o,
        ...d,
        browsingDate: g,
        month: y,
        nextMonthButton: () => b(1),
        slots: i,
        includedDates: s,
        isBookingInPast: v,
        periodData: c,
        isCompact: l,
        showNoAvailabilityDialog: u
      }
    ) })
  ] });
}, ape = ipe, $Sc = {
  start: new Date((/* @__PURE__ */ new Date()).setUTCHours(9, 0, 0, 0)),
  end: new Date((/* @__PURE__ */ new Date()).setUTCHours(17, 0, 0, 0))
};
function spe(e, { locale: t, hour12: n }) {
  const o = (i) => i.days.slice(1).reduce(
    (s, c) => (s[s.length - 1].length === 1 && s[s.length - 1][0] === c - 1 ? s[s.length - 1].push(c) : s[s.length - 1][s[s.length - 1].length - 1] === c - 1 ? s[s.length - 1] = [s[s.length - 1][0], c] : s.push([c]), s),
    [[i.days[0]]]
  ).map((s) => s.map((c) => Cq(t, c, "short")).join(" - ")).join(", "), r = (i) => `${new Intl.DateTimeFormat(t, { hour: "numeric", minute: "numeric", hour12: n }).format(
    new Date(i.startTime.toISOString().slice(0, -1))
  )} - ${new Intl.DateTimeFormat(t, { hour: "numeric", minute: "numeric", hour12: n }).format(
    new Date(i.endTime.toISOString().slice(0, -1))
  )}`;
  return `${o(e)}, ${r(e)}`;
}
function Z0() {
  return hr.viewer.me.get.useQuery(void 0, {
    retry(t) {
      return t > 3;
    }
  });
}
const jd = ksc, Hu = Bt(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ m(
    Ssc,
    {
      ...t,
      className: xe(
        !t.asChild && `focus:bg-subtle hover:bg-muted text-default group-hover:text-emphasis inline-flex items-center rounded-md bg-transparent px-3 py-2 text-sm font-medium ring-0 transition ${e}`
      ),
      ref: n
    }
  )
);
Hu.displayName = "DropdownMenuTrigger";
const cpe = Esc, Yu = Bt(
  ({ children: e, sideOffset: t = 2, align: n = "end", ...o }, r) => /* @__PURE__ */ m(
    xsc,
    {
      align: n,
      ...o,
      sideOffset: t,
      className: xe(
        "shadow-dropdown bg-default border-subtle relative z-10 origin-top-right space-y-[1px] rounded-xl border p-1 text-sm",
        "w-[220px]",
        o.className
      ),
      ref: r,
      children: e
    }
  )
);
Yu.displayName = "DropdownMenuContent";
const Pi = Bt(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ m(
    Csc,
    {
      className: `focus:ring-brand-default hover:bg-subtle hover:text-emphasis text-default text-sm ring-inset first-of-type:rounded-t-[inherit] last-of-type:rounded-b-[inherit] hover:ring-0 focus:outline-none focus:ring-1 ${e}`,
      ...t,
      ref: n
    }
  )
);
Pi.displayName = "DropdownMenuItem";
const wSc = Bt(
  ({ children: e, checked: t, onCheckedChange: n, ...o }, r) => /* @__PURE__ */ de(
    Tsc,
    {
      ...o,
      checked: t,
      onCheckedChange: n,
      ref: r,
      className: "hover:text-emphasis text-default hover:bg-subtle flex flex-1 items-center space-x-2 px-3 py-2 hover:outline-none hover:ring-0 disabled:cursor-not-allowed",
      children: [
        /* @__PURE__ */ m("div", { className: "w-full", children: e }),
        !t && /* @__PURE__ */ m(
          "input",
          {
            "aria-disabled": !0,
            "aria-label": typeof e == "string" ? `Not active ${e}` : void 0,
            "aria-readonly": !0,
            checked: !1,
            type: "checkbox",
            className: "text-emphasis dark:text-muted focus:ring-emphasis border-default bg-default ml-auto h-4 w-4 rounded transition hover:cursor-pointer"
          }
        ),
        /* @__PURE__ */ m(ise, { asChild: !0, children: /* @__PURE__ */ m(
          "input",
          {
            "aria-disabled": !0,
            "aria-readonly": !0,
            "aria-label": typeof e == "string" ? `Active ${e}` : void 0,
            checked: !0,
            type: "checkbox",
            className: "text-emphasis dark:text-muted focus:ring-emphasis border-default bg-default h-4 w-4 rounded transition hover:cursor-pointer"
          }
        ) })
      ]
    }
  )
);
wSc.displayName = "DropdownMenuCheckboxItem";
const kSc = Bt(
  ({ children: e, ...t }, n) => /* @__PURE__ */ de(Asc, { ...t, ref: n, children: [
    e,
    /* @__PURE__ */ m(ise, { children: /* @__PURE__ */ m(qt, { name: "circle-check" }) })
  ] })
);
kSc.displayName = "DropdownMenuRadioItem";
function lpe({ href: e, ...t }) {
  const n = typeof e < "u", r = /* @__PURE__ */ m(n ? "a" : "button", { ...t });
  return n ? /* @__PURE__ */ m(Ir, { href: e, legacyBehavior: !0, children: r }) : r;
}
const ba = (e) => {
  const { CustomStartIcon: t, StartIcon: n, EndIcon: o, children: r, color: i, childrenClassName: a, ...s } = e;
  return /* @__PURE__ */ m(
    lpe,
    {
      ...s,
      className: xe(
        "hover:text-emphasis text-default inline-flex w-full items-center space-x-1 rounded-lg  p-2 disabled:cursor-not-allowed",
        i === "destructive" ? "hover:bg-error hover:text-error text-error" : "hover:bg-subtle",
        e.className
      ),
      children: /* @__PURE__ */ de(nt, { children: [
        t || n && /* @__PURE__ */ m(qt, { name: n, className: "mr-1 h-4 w-4" }),
        /* @__PURE__ */ m("div", { className: xe("w-full text-left text-sm font-medium leading-none", a), children: r }),
        o && /* @__PURE__ */ m(qt, { name: o, className: "h-4 w-4" })
      ] })
    }
  );
}, EC = Bt(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ m(
    Isc,
    {
      className: xe("bg-emphasis -mx-1 my-1 h-px", e),
      ...t,
      ref: n
    }
  )
);
EC.displayName = "DropdownMenuSeparator";
const SSc = ({
  name: e,
  weekday: t,
  control: n,
  CopyButton: o,
  disabled: r,
  labels: i,
  userTimeFormat: a,
  classNames: s
}) => {
  const { watch: c, setValue: l } = No(), u = c(e);
  return /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "flex w-full flex-col gap-4 last:mb-0 sm:flex-row sm:gap-6 sm:px-0",
        s == null ? void 0 : s.scheduleDay
      ),
      "data-testid": t,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: xe(
              "flex h-[36px] items-center justify-between sm:w-32",
              s == null ? void 0 : s.labelAndSwitchContainer
            ),
            children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ de("label", { className: "text-default flex flex-row items-center space-x-2 rtl:space-x-reverse", children: [
              /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
                as,
                {
                  disabled: !u || r,
                  defaultChecked: u && u.length > 0,
                  checked: u && !!u.length,
                  "data-testid": `${t}-switch`,
                  onCheckedChange: (d) => {
                    l(e, d ? [$Sc] : []);
                  }
                }
              ) }),
              /* @__PURE__ */ m("span", { className: "inline-block min-w-[88px] text-sm capitalize", children: t })
            ] }) })
          }
        ),
        /* @__PURE__ */ de(nt, { children: [
          !u && /* @__PURE__ */ m(Yo, { className: "ml-1 mt-2.5 h-6 w-48" }),
          u.length > 0 && /* @__PURE__ */ de("div", { className: "flex sm:gap-2", children: [
            /* @__PURE__ */ m(
              dpe,
              {
                userTimeFormat: a,
                labels: i,
                control: n,
                name: e,
                disabled: r,
                classNames: {
                  dayRanges: s == null ? void 0 : s.dayRanges,
                  timeRangeField: s == null ? void 0 : s.timeRangeField,
                  timePicker: s == null ? void 0 : s.timePicker
                }
              }
            ),
            !r && /* @__PURE__ */ m("div", { className: "block", children: o })
          ] })
        ] })
      ]
    }
  );
}, ESc = ({
  getValuesFromDayRange: e,
  weekStart: t,
  labels: n
}) => {
  const { t: o } = kt(), [r, i] = it(!1), a = e.substring(0, e.lastIndexOf(".")), { setValue: s, getValues: c } = No();
  return /* @__PURE__ */ de(jd, { open: r, onOpenChange: i, children: [
    /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(
      Jt,
      {
        className: xe(
          "text-default",
          r && "ring-brand-500 !bg-subtle outline-none ring-2 ring-offset-1"
        ),
        "data-testid": "copy-button",
        type: "button",
        tooltip: (n == null ? void 0 : n.copyTime) ?? o("copy_times_to_tooltip"),
        color: "minimal",
        variant: "icon",
        StartIcon: "copy"
      }
    ) }),
    /* @__PURE__ */ m(Yu, { align: "end", children: /* @__PURE__ */ m(
      OSc,
      {
        weekStart: t,
        disabled: parseInt(e.replace(`${a}.`, ""), 10),
        onClick: (l) => {
          l.forEach((u) => s(`${a}.${u}`, c(e))), i(!1);
        },
        onCancel: () => i(!1)
      }
    ) })
  ] });
}, xSc = (e) => {
  const t = Z0(), { timeFormat: n } = t.data || { timeFormat: null };
  return /* @__PURE__ */ m(upe, { userTimeFormat: n, ...e });
}, upe = ({
  name: e,
  control: t,
  disabled: n,
  weekStart: o = 0,
  labels: r,
  userTimeFormat: i,
  classNames: a
}) => {
  const { i18n: s } = kt();
  return /* @__PURE__ */ m("div", { className: xe("flex flex-col gap-4 p-2 sm:p-4", a == null ? void 0 : a.schedule), children: Qy(s.language, o, "long").map((c, l) => {
    const u = (l + o) % 7, d = `${e}.${u}`;
    return /* @__PURE__ */ m(
      SSc,
      {
        classNames: a,
        userTimeFormat: i,
        labels: r,
        disabled: n,
        name: d,
        weekday: c,
        control: t,
        CopyButton: /* @__PURE__ */ m(ESc, { weekStart: o, labels: r, getValuesFromDayRange: d })
      },
      c
    );
  }) });
}, dpe = ({
  name: e,
  disabled: t,
  control: n,
  labels: o,
  userTimeFormat: r,
  classNames: i
}) => {
  const { t: a } = kt(), { getValues: s } = No(), { remove: c, fields: l, prepend: u, append: d } = M0({
    control: n,
    name: e
  });
  return l.length ? /* @__PURE__ */ m("div", { className: xe("flex flex-col gap-2", i == null ? void 0 : i.dayRanges), children: l.map((_, p) => /* @__PURE__ */ m(Ha, { children: /* @__PURE__ */ de("div", { className: "flex gap-1 last:mb-0 sm:gap-2", children: [
    /* @__PURE__ */ m(
      Bn,
      {
        name: `${e}.${p}`,
        render: ({ field: g }) => /* @__PURE__ */ m(
          TSc,
          {
            className: i == null ? void 0 : i.timeRangeField,
            userTimeFormat: r,
            timePickerClassNames: i == null ? void 0 : i.timePicker,
            ...g
          }
        )
      }
    ),
    p === 0 && /* @__PURE__ */ m(
      Jt,
      {
        disabled: t,
        "data-testid": "add-time-availability",
        tooltip: (o == null ? void 0 : o.addTime) ?? a("add_time_availability"),
        className: "text-default",
        type: "button",
        color: "minimal",
        variant: "icon",
        StartIcon: "plus",
        onClick: () => {
          const g = ISc(
            s(`${e}.${l.length - 1}`),
            s(`${e}.0`)
          );
          g != null && g.append && d(g.append), g != null && g.prepend && u(g.prepend);
        }
      }
    ),
    p !== 0 && /* @__PURE__ */ m(CSc, { index: p, remove: c, className: "text-default border-none" })
  ] }) }, _.id)) }) : null;
}, CSc = ({
  index: e,
  remove: t,
  disabled: n,
  className: o,
  labels: r
}) => {
  const { t: i } = kt();
  return /* @__PURE__ */ m(
    Jt,
    {
      disabled: n,
      type: "button",
      variant: "icon",
      color: "destructive",
      StartIcon: "trash",
      onClick: () => t(e),
      className: o,
      tooltip: (r == null ? void 0 : r.deleteTime) ?? i("delete")
    }
  );
}, TSc = ({
  className: e,
  value: t,
  onChange: n,
  disabled: o,
  userTimeFormat: r,
  timePickerClassNames: i
}) => {
  const a = {
    control: i == null ? void 0 : i.container,
    singleValue: i == null ? void 0 : i.value,
    valueContainer: i == null ? void 0 : i.valueContainer,
    input: i == null ? void 0 : i.input,
    menu: i == null ? void 0 : i.dropdown
  };
  return /* @__PURE__ */ de("div", { className: xe("flex flex-row gap-2 sm:gap-3", e), children: [
    /* @__PURE__ */ m(
      kH,
      {
        userTimeFormat: r,
        className: "block w-[90px] sm:w-[100px]",
        isDisabled: o,
        value: t.start,
        menuPlacement: "bottom",
        innerClassNames: a,
        onChange: (s) => {
          const c = new Date(s == null ? void 0 : s.value);
          if (c >= new Date(t.end)) {
            const l = new Date(s == null ? void 0 : s.value);
            l.setMinutes(l.getMinutes() + r5), n({ ...t, start: c, end: l });
          } else
            n({ ...t, start: c });
        }
      }
    ),
    /* @__PURE__ */ m("span", { className: "text-default w-2 self-center", children: " - " }),
    /* @__PURE__ */ m(
      kH,
      {
        userTimeFormat: r,
        className: "block w-[90px] rounded-md sm:w-[100px]",
        isDisabled: o,
        value: t.end,
        min: t.start,
        innerClassNames: a,
        menuPlacement: "bottom",
        onChange: (s) => {
          n({ ...t, end: new Date(s == null ? void 0 : s.value) });
        }
      }
    )
  ] });
}, kH = ({
  value: e,
  min: t,
  max: n,
  userTimeFormat: o,
  menuPlacement: r,
  ...i
}) => {
  const { options: a, filter: s } = ASc(o);
  yt(() => {
    s({ current: e });
  }, [s, e]);
  const [c, l] = Fe.useState(""), u = Fe.useMemo(() => wde(), []), d = Fe.useMemo(() => {
    var b;
    const _ = /^(\d{1,2})(a|p|am|pm)$/i, p = c.replaceAll(" ", "").match(_);
    if (!p)
      return a.filter(
        (y) => u({ ...y, data: y.label, value: y.label }, c)
      );
    const [, g, f] = p, h = f.toLowerCase(), $ = a.filter((y) => y.label && y.label.toLowerCase().includes(h)).map((y) => {
      const w = y.label.toLowerCase(), N = w.indexOf(g);
      return { score: N >= 0 ? N + w.length : 1 / 0, option: y };
    }).sort((y, w) => y.score - w.score), v = (b = $[0]) == null ? void 0 : b.score;
    return $.filter((y) => y.score === v).map((y) => y.option);
  }, [c, a, u]);
  return /* @__PURE__ */ m(
    Di,
    {
      options: d,
      onMenuOpen: () => {
        t && s({ offset: t }), n && s({ limit: n }), !t && !n && s({ offset: 0, limit: 0 });
      },
      menuPlacement: r,
      value: a.find((_) => _.value === ht(e).toDate().valueOf()),
      onMenuClose: () => s({ current: e }),
      components: { DropdownIndicator: () => null, IndicatorSeparator: () => null },
      onInputChange: l,
      filterOption: () => !0,
      ...i
    }
  );
}, r5 = Number(process.env.NEXT_PUBLIC_AVAILABILITY_SCHEDULE_INTERVAL) || 15, ASc = (e) => {
  const [t, n] = it([]), o = vn(() => {
    const i = ht().utc().endOf("day"), a = [];
    for (let s = ht().utc().startOf("day"); s.isBefore(i); s = s.add(r5 + (s.add(r5).isSame(s, "day") ? 0 : -1), "minutes"))
      a.push({
        value: s.toDate().valueOf(),
        label: ht(s).utc().format(e === 12 ? "h:mma" : "HH:mm")
      });
    return a.push({
      value: i.toDate().valueOf(),
      label: ht(i).utc().format(e === 12 ? "h:mma" : "HH:mm")
    }), a;
  }, [e]), r = Yt(
    ({ offset: i, limit: a, current: s }) => {
      if (s) {
        const c = o.find((l) => l.value === ht(s).toDate().valueOf());
        c && n([c]);
      } else
        n(
          o.filter((c) => {
            const l = ht(c.value);
            return (!a || l.isBefore(a)) && (!i || l.isAfter(i));
          })
        );
    },
    [o]
  );
  return { options: t, filter: r };
}, ISc = (e, t) => {
  const n = ht(t.start).utc(), o = ht(e.end).utc(), r = o.hour() === 23 ? ht(o).add(59, "minutes").add(59, "seconds").add(999, "milliseconds") : ht(o).add(1, "hour"), i = o.endOf("day");
  if (!o.isSame(i))
    return {
      append: {
        start: o.toDate(),
        end: r.isAfter(i) ? i.toDate() : r.toDate()
      }
    };
  const a = ht(t.start).subtract(1, "hour"), s = n.startOf("day");
  if (!n.isSame(s))
    return {
      prepend: {
        start: a.isBefore(s) ? s.toDate() : a.toDate(),
        end: n.toDate()
      }
    };
}, OSc = ({
  disabled: e,
  onClick: t,
  onCancel: n,
  weekStart: o
}) => {
  const [r, i] = it([]), { i18n: a, t: s } = kt(), c = xt([]);
  yt(() => (document.addEventListener("keydown", l), () => {
    document.removeEventListener("keydown", l);
  }), []);
  const l = (u) => {
    const d = c.current;
    if (!(u.key === "Tab" || u.key === "ArrowUp" || u.key === "ArrowDown" || u.key === "Enter") || !d.length)
      return;
    u.preventDefault();
    const p = document.activeElement;
    let g = d.findIndex((f) => f === p);
    if (u.key === "Enter") {
      if (g === -1)
        return;
      p.click();
      return;
    }
    g === -1 ? d[0].focus() : (u.key === "ArrowUp" ? g = (g - 1 + d.length) % d.length : (u.key === "ArrowDown" || u.key === "Tab") && (g = (g + 1) % d.length), d[g].focus());
  };
  return /* @__PURE__ */ de("div", { className: "space-y-2 py-2", children: [
    /* @__PURE__ */ de("div", { className: "p-2", children: [
      /* @__PURE__ */ m("p", { className: "h6 text-emphasis pb-3 pl-1 text-xs font-medium uppercase", children: s("copy_times_to") }),
      /* @__PURE__ */ de("ol", { className: "space-y-2", children: [
        /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
          cc,
          {
            description: s("select_all"),
            descriptionAsLabel: !0,
            value: s("select_all"),
            checked: r.length === 7,
            onChange: (u) => {
              u.target.checked ? i([0, 1, 2, 3, 4, 5, 6]) : u.target.checked || i([]);
            },
            ref: (u) => {
              u && c.current.push(u);
            }
          }
        ) }, "select all"),
        Qy(a.language, o).map((u, d) => {
          const _ = (d + o) % 7;
          return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
            cc,
            {
              description: u,
              descriptionAsLabel: !0,
              value: _,
              checked: r.includes(_) || e === _,
              disabled: e === _,
              onChange: (p) => {
                p.target.checked && !r.includes(_) ? i(r.concat([_])) : !p.target.checked && r.includes(_) && i(r.filter((g) => g !== _));
              },
              ref: (p) => {
                p && e !== _ && c.current.push(p);
              }
            }
          ) }, u);
        })
      ] })
    ] }),
    /* @__PURE__ */ m("hr", { className: "border-subtle" }),
    /* @__PURE__ */ de("div", { className: "flex justify-end space-x-2 px-2 rtl:space-x-reverse", children: [
      /* @__PURE__ */ m(
        Jt,
        {
          color: "minimal",
          onClick: () => n(),
          ref: (u) => {
            u && c.current.push(u);
          },
          children: s("cancel")
        }
      ),
      /* @__PURE__ */ m(
        Jt,
        {
          color: "primary",
          onClick: () => t(r),
          ref: (u) => {
            u && c.current.push(u);
          },
          children: s("apply")
        }
      )
    ] })
  ] });
}, NSc = xSc, zSc = ({
  value: e,
  workingHours: t,
  excludedDates: n,
  onChange: o,
  userTimeFormat: r,
  weekStart: i,
  isDryRun: a = !1
}) => {
  const [s, c] = it(), { t: l, i18n: u, isLocaleReady: d } = kt(), [_, p] = it(
    e && e[0].start.getUTCHours() === 0 && e[0].start.getUTCMinutes() === 0 && e[0].end.getUTCHours() === 0 && e[0].end.getUTCMinutes() === 0
  ), [g, f] = it(e ? [ht.utc(e[0].start)] : []), h = (b) => {
    if (g.some((y) => ll(y) === ll(b))) {
      f(g.filter((y) => ll(y) !== ll(b)));
      return;
    }
    if (!e) {
      f((y) => [...y, b]);
      return;
    }
    f([b]);
  }, $ = (t || []).reduce((b, y) => (g[0] && y.days.includes(g[0].day()) && b.push({
    start: ht.utc().startOf("day").add(y.startTime, "minute").toDate(),
    end: ht.utc().startOf("day").add(y.endTime, "minute").toDate()
  }), b), []);
  $.length || $.push({
    start: ht.utc().startOf("day").add(540, "minute").toDate(),
    end: ht.utc().startOf("day").add(1020, "minute").toDate()
  });
  const v = W_({
    values: {
      range: e && e[0].start.valueOf() !== e[0].end.valueOf() ? e.map((b) => ({
        start: new Date(
          ht.utc().hour(b.start.getUTCHours()).minute(b.start.getUTCMinutes()).second(0).format()
        ),
        end: new Date(
          ht.utc().hour(b.end.getUTCHours()).minute(b.end.getUTCMinutes()).second(0).format()
        )
      })) : $
    }
  });
  return /* @__PURE__ */ de(
    Y_,
    {
      form: v,
      handleSubmit: (b) => {
        const y = [];
        if (g.length !== 0) {
          if (a) {
            f([]);
            return;
          }
          _ ? (g.map((w) => {
            y.push({
              start: w.utc(!0).startOf("day").toDate(),
              end: w.utc(!0).startOf("day").toDate()
            });
          }), o(y)) : (g.map((w) => {
            b.range.map((N) => {
              y.push({
                start: w.hour(N.start.getUTCHours()).minute(N.start.getUTCMinutes()).utc(!0).toDate(),
                end: w.hour(N.end.getUTCHours()).minute(N.end.getUTCMinutes()).utc(!0).toDate()
              });
            });
          }), o(y)), f([]);
        }
      },
      className: "p-6 sm:flex sm:p-0 xl:flex-row",
      children: [
        /* @__PURE__ */ de("div", { className: "sm:border-subtle w-full sm:border-r sm:p-4 sm:pr-6 md:p-8", children: [
          /* @__PURE__ */ m(Sy, { title: l("date_overrides_dialog_title") }),
          /* @__PURE__ */ m(Wy, { children: /* @__PURE__ */ m(
            ape,
            {
              excludedDates: n,
              weekStart: i,
              selected: g,
              onChange: (b) => {
                b && h(b);
              },
              onMonthChange: (b) => {
                c(b);
              },
              browsingDate: s,
              locale: d ? u.language : "en"
            }
          ) })
        ] }),
        /* @__PURE__ */ m("div", { className: "relative mt-8 flex w-full flex-col sm:mt-0 sm:p-4 md:p-8", children: g[0] ? /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ de("div", { className: "mb-4 flex-grow space-y-4", children: [
            /* @__PURE__ */ m("p", { className: "text-medium text-emphasis text-sm", children: l("date_overrides_dialog_which_hours") }),
            /* @__PURE__ */ m("div", { children: _ ? /* @__PURE__ */ m("p", { className: "text-subtle border-default rounded border p-2 text-sm", children: l("date_overrides_unavailable") }) : /* @__PURE__ */ m(dpe, { name: "range", userTimeFormat: r }) }),
            /* @__PURE__ */ m(
              as,
              {
                label: l("date_overrides_mark_all_day_unavailable_one"),
                checked: _,
                onCheckedChange: p,
                "data-testid": "date-override-mark-unavailable"
              }
            )
          ] }),
          /* @__PURE__ */ de("div", { className: "mt-4 flex flex-row-reverse sm:mt-0", children: [
            /* @__PURE__ */ m(
              Jt,
              {
                className: "ml-2",
                color: "primary",
                type: "submit",
                onClick: () => {
                  ti(l("date_successfully_added"), "success", 500);
                },
                disabled: g.length === 0,
                "data-testid": "add-override-submit-btn",
                children: l(e ? "date_overrides_update_btn" : "date_overrides_save_btn")
              }
            ),
            /* @__PURE__ */ m(Gs, {})
          ] })
        ] }) : /* @__PURE__ */ m("div", { className: "bottom-7 right-8 flex flex-row-reverse sm:absolute", children: /* @__PURE__ */ m(Gs, {}) }) })
      ]
    }
  );
}, RSc = ({
  Trigger: e,
  excludedDates: t = [],
  userTimeFormat: n,
  weekStart: o = 0,
  className: r,
  ...i
}) => {
  const [a, s] = it(!1);
  return /* @__PURE__ */ de(Ss, { open: a, onOpenChange: s, children: [
    /* @__PURE__ */ m(q0, { asChild: !0, children: e }),
    /* @__PURE__ */ m(Ya, { enableOverflow: !0, size: "md", className: xe("p-0", r), children: /* @__PURE__ */ m(
      zSc,
      {
        excludedDates: t,
        weekStart: o,
        ...i,
        onClose: () => s(!1),
        userTimeFormat: n
      }
    ) })
  ] });
}, _pe = RSc;
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function PSc() {
}
function SH(e, t, n) {
  const o = kwc(), r = MSc(e, n.timeZone, n.locale ?? o.locale);
  return "formatToParts" in r ? DSc(r, t) : LSc(r, t);
}
function DSc(e, t) {
  const n = e.formatToParts(t);
  for (let o = n.length - 1; o >= 0; --o)
    if (n[o].type === "timeZoneName")
      return n[o].value;
}
function LSc(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), o = / [\w-+ ]+$/.exec(n);
  return o ? o[0].substr(1) : "";
}
function MSc(e, t, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function FSc(e, t) {
  const n = USc(t);
  return "formatToParts" in n ? jSc(n, e) : VSc(n, e);
}
const qSc = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function jSc(e, t) {
  try {
    const n = e.formatToParts(t), o = [];
    for (let r = 0; r < n.length; r++) {
      const i = qSc[n[r].type];
      i !== void 0 && (o[i] = parseInt(n[r].value, 10));
    }
    return o;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function VSc(e, t) {
  const n = e.format(t), o = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(o[3], 10),
    parseInt(o[1], 10),
    parseInt(o[2], 10),
    parseInt(o[4], 10),
    parseInt(o[5], 10),
    parseInt(o[6], 10)
  ];
}
const cz = {}, EH = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), BSc = EH === "06/25/2014, 00:00:00" || EH === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function USc(e) {
  return cz[e] || (cz[e] = BSc ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), cz[e];
}
function ppe(e, t, n, o, r, i, a) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, n), s.setUTCHours(o, r, i, a), s;
}
const xH = 36e5, GSc = 6e4, lz = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Iq(e, t, n) {
  if (!e)
    return 0;
  let o = lz.timezoneZ.exec(e);
  if (o)
    return 0;
  let r, i;
  if (o = lz.timezoneHH.exec(e), o)
    return r = parseInt(o[1], 10), CH(r) ? -(r * xH) : NaN;
  if (o = lz.timezoneHHMM.exec(e), o) {
    r = parseInt(o[2], 10);
    const a = parseInt(o[3], 10);
    return CH(r, a) ? (i = Math.abs(r) * xH + a * GSc, o[1] === "+" ? -i : i) : NaN;
  }
  if (YSc(e)) {
    t = new Date(t || Date.now());
    const a = n ? t : WSc(t), s = i5(a, e);
    return -(n ? s : HSc(t, s, e));
  }
  return NaN;
}
function WSc(e) {
  return ppe(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function i5(e, t) {
  const n = FSc(e, t), o = ppe(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let r = e.getTime();
  const i = r % 1e3;
  return r -= i >= 0 ? i : 1e3 + i, o - r;
}
function HSc(e, t, n) {
  let r = e.getTime() - t;
  const i = i5(new Date(r), n);
  if (t === i)
    return t;
  r -= i - t;
  const a = i5(new Date(r), n);
  return i === a ? i : Math.max(i, a);
}
function CH(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const TH = {};
function YSc(e) {
  if (TH[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), TH[e] = !0, !0;
  } catch {
    return !1;
  }
}
const KSc = 60 * 1e3, ZSc = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = uz(n.timeZone, e);
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return AH(o);
      case "XXXX":
      case "XX":
        return $b(o);
      case "XXXXX":
      case "XXX":
      default:
        return $b(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = uz(n.timeZone, e);
    switch (t) {
      case "x":
        return AH(o);
      case "xxxx":
      case "xx":
        return $b(o);
      case "xxxxx":
      case "xxx":
      default:
        return $b(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = uz(n.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + XSc(o, ":");
      case "OOOO":
      default:
        return "GMT" + $b(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return SH("short", e, n);
      case "zzzz":
      default:
        return SH("long", e, n);
    }
  }
};
function uz(e, t) {
  const n = e ? Iq(e, t, !0) / KSc : (t == null ? void 0 : t.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function xC(e, t) {
  const n = e < 0 ? "-" : "";
  let o = Math.abs(e).toString();
  for (; o.length < t; )
    o = "0" + o;
  return n + o;
}
function $b(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = xC(Math.floor(o / 60), 2), i = xC(Math.floor(o % 60), 2);
  return n + r + t + i;
}
function AH(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + xC(Math.abs(e) / 60, 2) : $b(e, t);
}
function XSc(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = Math.floor(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + t + xC(i, 2);
}
function IH(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const JSc = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, dz = 36e5, OH = 6e4, QSc = 2, hl = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: JSc
};
function mpe(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = t.additionalDigits == null ? QSc : Number(t.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const o = eEc(e), { year: r, restDateString: i } = tEc(o.date, n), a = nEc(i, r);
  if (a === null || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (a) {
    const s = a.getTime();
    let c = 0, l;
    if (o.time && (c = oEc(o.time), c === null || isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timeZone || t.timeZone) {
      if (l = Iq(o.timeZone || t.timeZone, new Date(s + c)), isNaN(l))
        return /* @__PURE__ */ new Date(NaN);
    } else
      l = IH(new Date(s + c)), l = IH(new Date(s + c + l));
    return new Date(s + c + l);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function eEc(e) {
  const t = {};
  let n = hl.dateTimePattern.exec(e), o;
  if (n ? (t.date = n[1], o = n[3]) : (n = hl.datePattern.exec(e), n ? (t.date = n[1], o = n[2]) : (t.date = null, o = e)), o) {
    const r = hl.timeZone.exec(o);
    r ? (t.time = o.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = o;
  }
  return t;
}
function tEc(e, t) {
  if (e) {
    const n = hl.YYY[t], o = hl.YYYYY[t];
    let r = hl.YYYY.exec(e) || o.exec(e);
    if (r) {
      const i = r[1];
      return {
        year: parseInt(i, 10),
        restDateString: e.slice(i.length)
      };
    }
    if (r = hl.YY.exec(e) || n.exec(e), r) {
      const i = r[1];
      return {
        year: parseInt(i, 10) * 100,
        restDateString: e.slice(i.length)
      };
    }
  }
  return {
    year: null
  };
}
function nEc(e, t) {
  if (t === null)
    return null;
  let n, o, r;
  if (!e || !e.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  let i = hl.MM.exec(e);
  if (i)
    return n = /* @__PURE__ */ new Date(0), o = parseInt(i[1], 10) - 1, zH(t, o) ? (n.setUTCFullYear(t, o), n) : /* @__PURE__ */ new Date(NaN);
  if (i = hl.DDD.exec(e), i) {
    n = /* @__PURE__ */ new Date(0);
    const a = parseInt(i[1], 10);
    return aEc(t, a) ? (n.setUTCFullYear(t, 0, a), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (i = hl.MMDD.exec(e), i) {
    n = /* @__PURE__ */ new Date(0), o = parseInt(i[1], 10) - 1;
    const a = parseInt(i[2], 10);
    return zH(t, o, a) ? (n.setUTCFullYear(t, o, a), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (i = hl.Www.exec(e), i)
    return r = parseInt(i[1], 10) - 1, RH(r) ? NH(t, r) : /* @__PURE__ */ new Date(NaN);
  if (i = hl.WwwD.exec(e), i) {
    r = parseInt(i[1], 10) - 1;
    const a = parseInt(i[2], 10) - 1;
    return RH(r, a) ? NH(t, r, a) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function oEc(e) {
  let t, n, o = hl.HH.exec(e);
  if (o)
    return t = parseFloat(o[1].replace(",", ".")), _z(t) ? t % 24 * dz : NaN;
  if (o = hl.HHMM.exec(e), o)
    return t = parseInt(o[1], 10), n = parseFloat(o[2].replace(",", ".")), _z(t, n) ? t % 24 * dz + n * OH : NaN;
  if (o = hl.HHMMSS.exec(e), o) {
    t = parseInt(o[1], 10), n = parseInt(o[2], 10);
    const r = parseFloat(o[3].replace(",", "."));
    return _z(t, n, r) ? t % 24 * dz + n * OH + r * 1e3 : NaN;
  }
  return null;
}
function NH(e, t, n) {
  t = t || 0, n = n || 0;
  const o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(e, 0, 4);
  const r = o.getUTCDay() || 7, i = t * 7 + n + 1 - r;
  return o.setUTCDate(o.getUTCDate() + i), o;
}
const rEc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], iEc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function fpe(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function zH(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const o = fpe(e);
    if (o && n > iEc[t] || !o && n > rEc[t])
      return !1;
  }
  return !0;
}
function aEc(e, t) {
  if (t < 1)
    return !1;
  const n = fpe(e);
  return !(n && t > 366 || !n && t > 365);
}
function RH(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function _z(e, t, n) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
const sEc = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function cEc(e, t, n = {}) {
  t = String(t);
  const o = t.match(sEc);
  if (o) {
    const r = mpe(n.originalDate || e, n);
    t = o.reduce(function(i, a) {
      if (a[0] === "'")
        return i;
      const s = i.indexOf(a), c = i[s - 1] === "'", l = i.replace(a, "'" + ZSc[a[0]](r, a, n) + "'");
      return c ? l.substring(0, s - 1) + l.substring(s + 1) : l;
    }, t);
  }
  return xf(e, t, n);
}
function lEc(e, t, n) {
  e = mpe(e, n);
  const o = Iq(t, e, !0), r = new Date(e.getTime() - o), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), i.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), i;
}
function JS(e, t, n, o) {
  return o = {
    ...o,
    timeZone: t,
    originalDate: e
  }, cEc(lEc(e, t, { timeZone: o.timeZone }), n, o);
}
const uEc = (e, t) => e.ranges[0].start > t.ranges[0].start ? 1 : -1, dEc = ({
  workingHours: e,
  excludedDates: t = [],
  travelSchedules: n = [],
  userTimeFormat: o,
  hour12: r,
  replace: i,
  fields: a,
  weekStart: s = 0,
  handleAvailabilityUpdate: c = PSc,
  isDryRun: l = !1
}) => {
  const { t: u, i18n: d } = kt(), _ = Kr(), p = a.reduce(
    (f, { id: h }, $) => ({ ...f, [h]: $ }),
    {}
  );
  if (!a.length)
    return /* @__PURE__ */ m(nt, {});
  const g = ({ start: f, end: h }) => _ ? `${JS(f, "UTC", "h a")} - ${JS(h, "UTC", "h a")}` : `${new Intl.DateTimeFormat(d.language, { hour: "numeric", minute: "numeric", hour12: r }).format(
    new Date(f.toISOString().slice(0, -1))
  )} - ${new Intl.DateTimeFormat(d.language, { hour: "numeric", minute: "numeric", hour12: r }).format(
    new Date(h.toISOString().slice(0, -1))
  )}`;
  return /* @__PURE__ */ m("ul", { className: "border-subtle rounded border", "data-testid": "date-overrides-list", children: a.sort(uEc).map((f) => /* @__PURE__ */ de("li", { className: "border-subtle flex justify-between border-b px-5 py-4 last:border-b-0", children: [
    /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ de("h3", { className: "text-emphasis text-sm", children: [
        !_ && new Intl.DateTimeFormat(d.language, {
          weekday: "long",
          month: "long",
          day: "numeric",
          timeZone: "UTC"
        }).format(f.ranges[0].start),
        _ && JS(new Date(f.ranges[0].start), "UTC", "EEE MMM dd")
      ] }),
      f.ranges[0].start.valueOf() - f.ranges[0].end.valueOf() === 0 ? /* @__PURE__ */ m("p", { className: "text-subtle text-xs", children: u("unavailable") }) : f.ranges.map((h, $) => {
        var v;
        return /* @__PURE__ */ de("p", { className: "text-subtle text-xs", children: [
          `${g(h)} ${((v = n.find(
            (b) => !ht(f.ranges[0].start).isBefore(b.startDate) && (!ht(f.ranges[0].end).isAfter(b.endDate) || !b.endDate)
          )) == null ? void 0 : v.timeZone.replace(/_/g, " ")) || ""}`,
          /* @__PURE__ */ m(nt, {})
        ] }, $);
      })
    ] }),
    /* @__PURE__ */ de("div", { className: "flex flex-row-reverse gap-5 space-x-2 rtl:space-x-reverse", children: [
      /* @__PURE__ */ m(
        _pe,
        {
          userTimeFormat: o,
          excludedDates: t,
          workingHours: e,
          value: f.ranges.map((h) => ({
            start: new Date(h.start),
            end: new Date(h.end)
          })),
          weekStart: s,
          onChange: (h) => {
            l || (i([...a.filter(($) => $.id !== f.id), { ranges: h }]), delete p[f.id], c());
          },
          Trigger: /* @__PURE__ */ m(q0, { asChild: !0, children: /* @__PURE__ */ m(
            Jt,
            {
              tooltip: u("edit"),
              className: "text-default h-5",
              color: "minimal",
              variant: "icon",
              StartIcon: "pencil"
            }
          ) })
        }
      ),
      /* @__PURE__ */ m(Sr, { content: "Delete", children: /* @__PURE__ */ m(
        Jt,
        {
          className: "text-default h-5",
          "data-testid": "delete-button",
          title: u("date_overrides_delete_on_date", {
            date: _ ? JS(new Date(f.ranges[0].start), "UTC", "h a") : new Intl.DateTimeFormat(d.language, {
              weekday: "long",
              month: "long",
              day: "numeric",
              timeZone: "UTC"
            }).format(f.ranges[0].start)
          }),
          color: "destructive",
          variant: "icon",
          StartIcon: "trash-2",
          onClick: () => {
            i([...a.filter((h) => h.id !== f.id)]), l || c();
          }
        }
      ) })
    ] })
  ] }, f.id)) });
}, _Ec = dEc;
var ru = {}, gpe = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(gpe);
var Tn = gpe.exports, pz = { exports: {} }, PH;
function pEc() {
  return PH || (PH = 1, function(e) {
    var t = xo.default;
    function n() {
      e.exports = n = function() {
        return r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var o, r = {}, i = Object.prototype, a = i.hasOwnProperty, s = Object.defineProperty || function(z, F, P) {
        z[F] = P.value;
      }, c = typeof Symbol == "function" ? Symbol : {}, l = c.iterator || "@@iterator", u = c.asyncIterator || "@@asyncIterator", d = c.toStringTag || "@@toStringTag";
      function _(z, F, P) {
        return Object.defineProperty(z, F, {
          value: P,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), z[F];
      }
      try {
        _({}, "");
      } catch {
        _ = function(P, O, V) {
          return P[O] = V;
        };
      }
      function p(z, F, P, O) {
        var V = F && F.prototype instanceof y ? F : y, U = Object.create(V.prototype), H = new k(O || []);
        return s(U, "_invoke", {
          value: A(z, P, H)
        }), U;
      }
      function g(z, F, P) {
        try {
          return {
            type: "normal",
            arg: z.call(F, P)
          };
        } catch (O) {
          return {
            type: "throw",
            arg: O
          };
        }
      }
      r.wrap = p;
      var f = "suspendedStart", h = "suspendedYield", $ = "executing", v = "completed", b = {};
      function y() {
      }
      function w() {
      }
      function N() {
      }
      var M = {};
      _(M, l, function() {
        return this;
      });
      var q = Object.getPrototypeOf, L = q && q(q(I([])));
      L && L !== i && a.call(L, l) && (M = L);
      var R = N.prototype = y.prototype = Object.create(M);
      function T(z) {
        ["next", "throw", "return"].forEach(function(F) {
          _(z, F, function(P) {
            return this._invoke(F, P);
          });
        });
      }
      function D(z, F) {
        function P(V, U, H, J) {
          var le = g(z[V], z, U);
          if (le.type !== "throw") {
            var ae = le.arg, Y = ae.value;
            return Y && t(Y) == "object" && a.call(Y, "__await") ? F.resolve(Y.__await).then(function(re) {
              P("next", re, H, J);
            }, function(re) {
              P("throw", re, H, J);
            }) : F.resolve(Y).then(function(re) {
              ae.value = re, H(ae);
            }, function(re) {
              return P("throw", re, H, J);
            });
          }
          J(le.arg);
        }
        var O;
        s(this, "_invoke", {
          value: function(U, H) {
            function J() {
              return new F(function(le, ae) {
                P(U, H, le, ae);
              });
            }
            return O = O ? O.then(J, J) : J();
          }
        });
      }
      function A(z, F, P) {
        var O = f;
        return function(V, U) {
          if (O === $)
            throw new Error("Generator is already running");
          if (O === v) {
            if (V === "throw")
              throw U;
            return {
              value: o,
              done: !0
            };
          }
          for (P.method = V, P.arg = U; ; ) {
            var H = P.delegate;
            if (H) {
              var J = S(H, P);
              if (J) {
                if (J === b)
                  continue;
                return J;
              }
            }
            if (P.method === "next")
              P.sent = P._sent = P.arg;
            else if (P.method === "throw") {
              if (O === f)
                throw O = v, P.arg;
              P.dispatchException(P.arg);
            } else
              P.method === "return" && P.abrupt("return", P.arg);
            O = $;
            var le = g(z, F, P);
            if (le.type === "normal") {
              if (O = P.done ? v : h, le.arg === b)
                continue;
              return {
                value: le.arg,
                done: P.done
              };
            }
            le.type === "throw" && (O = v, P.method = "throw", P.arg = le.arg);
          }
        };
      }
      function S(z, F) {
        var P = F.method, O = z.iterator[P];
        if (O === o)
          return F.delegate = null, P === "throw" && z.iterator.return && (F.method = "return", F.arg = o, S(z, F), F.method === "throw") || P !== "return" && (F.method = "throw", F.arg = new TypeError("The iterator does not provide a '" + P + "' method")), b;
        var V = g(O, z.iterator, F.arg);
        if (V.type === "throw")
          return F.method = "throw", F.arg = V.arg, F.delegate = null, b;
        var U = V.arg;
        return U ? U.done ? (F[z.resultName] = U.value, F.next = z.nextLoc, F.method !== "return" && (F.method = "next", F.arg = o), F.delegate = null, b) : U : (F.method = "throw", F.arg = new TypeError("iterator result is not an object"), F.delegate = null, b);
      }
      function E(z) {
        var F = {
          tryLoc: z[0]
        };
        1 in z && (F.catchLoc = z[1]), 2 in z && (F.finallyLoc = z[2], F.afterLoc = z[3]), this.tryEntries.push(F);
      }
      function x(z) {
        var F = z.completion || {};
        F.type = "normal", delete F.arg, z.completion = F;
      }
      function k(z) {
        this.tryEntries = [{
          tryLoc: "root"
        }], z.forEach(E, this), this.reset(!0);
      }
      function I(z) {
        if (z || z === "") {
          var F = z[l];
          if (F)
            return F.call(z);
          if (typeof z.next == "function")
            return z;
          if (!isNaN(z.length)) {
            var P = -1, O = function V() {
              for (; ++P < z.length; )
                if (a.call(z, P))
                  return V.value = z[P], V.done = !1, V;
              return V.value = o, V.done = !0, V;
            };
            return O.next = O;
          }
        }
        throw new TypeError(t(z) + " is not iterable");
      }
      return w.prototype = N, s(R, "constructor", {
        value: N,
        configurable: !0
      }), s(N, "constructor", {
        value: w,
        configurable: !0
      }), w.displayName = _(N, d, "GeneratorFunction"), r.isGeneratorFunction = function(z) {
        var F = typeof z == "function" && z.constructor;
        return !!F && (F === w || (F.displayName || F.name) === "GeneratorFunction");
      }, r.mark = function(z) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(z, N) : (z.__proto__ = N, _(z, d, "GeneratorFunction")), z.prototype = Object.create(R), z;
      }, r.awrap = function(z) {
        return {
          __await: z
        };
      }, T(D.prototype), _(D.prototype, u, function() {
        return this;
      }), r.AsyncIterator = D, r.async = function(z, F, P, O, V) {
        V === void 0 && (V = Promise);
        var U = new D(p(z, F, P, O), V);
        return r.isGeneratorFunction(F) ? U : U.next().then(function(H) {
          return H.done ? H.value : U.next();
        });
      }, T(R), _(R, d, "Generator"), _(R, l, function() {
        return this;
      }), _(R, "toString", function() {
        return "[object Generator]";
      }), r.keys = function(z) {
        var F = Object(z), P = [];
        for (var O in F)
          P.push(O);
        return P.reverse(), function V() {
          for (; P.length; ) {
            var U = P.pop();
            if (U in F)
              return V.value = U, V.done = !1, V;
          }
          return V.done = !0, V;
        };
      }, r.values = I, k.prototype = {
        constructor: k,
        reset: function(F) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = o, this.done = !1, this.delegate = null, this.method = "next", this.arg = o, this.tryEntries.forEach(x), !F)
            for (var P in this)
              P.charAt(0) === "t" && a.call(this, P) && !isNaN(+P.slice(1)) && (this[P] = o);
        },
        stop: function() {
          this.done = !0;
          var F = this.tryEntries[0].completion;
          if (F.type === "throw")
            throw F.arg;
          return this.rval;
        },
        dispatchException: function(F) {
          if (this.done)
            throw F;
          var P = this;
          function O(ae, Y) {
            return H.type = "throw", H.arg = F, P.next = ae, Y && (P.method = "next", P.arg = o), !!Y;
          }
          for (var V = this.tryEntries.length - 1; V >= 0; --V) {
            var U = this.tryEntries[V], H = U.completion;
            if (U.tryLoc === "root")
              return O("end");
            if (U.tryLoc <= this.prev) {
              var J = a.call(U, "catchLoc"), le = a.call(U, "finallyLoc");
              if (J && le) {
                if (this.prev < U.catchLoc)
                  return O(U.catchLoc, !0);
                if (this.prev < U.finallyLoc)
                  return O(U.finallyLoc);
              } else if (J) {
                if (this.prev < U.catchLoc)
                  return O(U.catchLoc, !0);
              } else {
                if (!le)
                  throw new Error("try statement without catch or finally");
                if (this.prev < U.finallyLoc)
                  return O(U.finallyLoc);
              }
            }
          }
        },
        abrupt: function(F, P) {
          for (var O = this.tryEntries.length - 1; O >= 0; --O) {
            var V = this.tryEntries[O];
            if (V.tryLoc <= this.prev && a.call(V, "finallyLoc") && this.prev < V.finallyLoc) {
              var U = V;
              break;
            }
          }
          U && (F === "break" || F === "continue") && U.tryLoc <= P && P <= U.finallyLoc && (U = null);
          var H = U ? U.completion : {};
          return H.type = F, H.arg = P, U ? (this.method = "next", this.next = U.finallyLoc, b) : this.complete(H);
        },
        complete: function(F, P) {
          if (F.type === "throw")
            throw F.arg;
          return F.type === "break" || F.type === "continue" ? this.next = F.arg : F.type === "return" ? (this.rval = this.arg = F.arg, this.method = "return", this.next = "end") : F.type === "normal" && P && (this.next = P), b;
        },
        finish: function(F) {
          for (var P = this.tryEntries.length - 1; P >= 0; --P) {
            var O = this.tryEntries[P];
            if (O.finallyLoc === F)
              return this.complete(O.completion, O.afterLoc), x(O), b;
          }
        },
        catch: function(F) {
          for (var P = this.tryEntries.length - 1; P >= 0; --P) {
            var O = this.tryEntries[P];
            if (O.tryLoc === F) {
              var V = O.completion;
              if (V.type === "throw") {
                var U = V.arg;
                x(O);
              }
              return U;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(F, P, O) {
          return this.delegate = {
            iterator: I(F),
            resultName: P,
            nextLoc: O
          }, this.method === "next" && (this.arg = o), b;
        }
      }, r;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(pz)), pz.exports;
}
var mz, DH;
function dA() {
  if (DH)
    return mz;
  DH = 1;
  var e = pEc()();
  mz = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return mz;
}
var fz = { exports: {} }, LH;
function _A() {
  return LH || (LH = 1, function(e) {
    function t(o, r, i, a, s, c, l) {
      try {
        var u = o[c](l), d = u.value;
      } catch (_) {
        i(_);
        return;
      }
      u.done ? r(d) : Promise.resolve(d).then(a, s);
    }
    function n(o) {
      return function() {
        var r = this, i = arguments;
        return new Promise(function(a, s) {
          var c = o.apply(r, i);
          function l(d) {
            t(c, a, s, l, u, "next", d);
          }
          function u(d) {
            t(c, a, s, l, u, "throw", d);
          }
          l(void 0);
        });
      };
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(fz)), fz.exports;
}
var uh = {}, Ui = {}, gz = { exports: {} }, MH;
function Hs() {
  return MH || (MH = 1, function(e) {
    function t(n) {
      if (n === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(gz)), gz.exports;
}
const ki = /* @__PURE__ */ nu(Nrc), Si = /* @__PURE__ */ nu(Rrc), Ei = /* @__PURE__ */ nu(ogc);
var hz = { exports: {} }, FH;
function xi() {
  return FH || (FH = 1, function(e) {
    var t = xo.default, n = Hs();
    function o(r, i) {
      if (i && (t(i) === "object" || typeof i == "function"))
        return i;
      if (i !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return n(r);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(hz)), hz.exports;
}
var vz = { exports: {} }, qH;
function oi() {
  return qH || (qH = 1, function(e) {
    function t(n) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
        return r.__proto__ || Object.getPrototypeOf(r);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(vz)), vz.exports;
}
var bz = { exports: {} }, yz = { exports: {} }, jH;
function hpe() {
  return jH || (jH = 1, function(e) {
    function t(n, o) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, a) {
        return i.__proto__ = a, i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n, o);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(yz)), yz.exports;
}
var $z = { exports: {} }, VH;
function mEc() {
  return VH || (VH = 1, function(e) {
    function t(n) {
      return Function.toString.call(n).indexOf("[native code]") !== -1;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }($z)), $z.exports;
}
var wz = { exports: {} }, kz = { exports: {} }, BH;
function fEc() {
  return BH || (BH = 1, function(e) {
    function t() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(kz)), kz.exports;
}
var UH;
function gEc() {
  return UH || (UH = 1, function(e) {
    var t = hpe(), n = fEc();
    function o(r, i, a) {
      return n() ? (e.exports = o = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = o = function(c, l, u) {
        var d = [null];
        d.push.apply(d, l);
        var _ = Function.bind.apply(c, d), p = new _();
        return u && t(p, u.prototype), p;
      }, e.exports.__esModule = !0, e.exports.default = e.exports), o.apply(null, arguments);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(wz)), wz.exports;
}
var GH;
function hEc() {
  return GH || (GH = 1, function(e) {
    var t = oi(), n = hpe(), o = mEc(), r = gEc();
    function i(a) {
      var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return e.exports = i = function(l) {
        if (l === null || !o(l))
          return l;
        if (typeof l != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (typeof s < "u") {
          if (s.has(l))
            return s.get(l);
          s.set(l, u);
        }
        function u() {
          return r(l, arguments, t(this).constructor);
        }
        return u.prototype = Object.create(l.prototype, {
          constructor: {
            value: u,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), n(u, l);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, i(a);
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(bz)), bz.exports;
}
var WH;
function vEc() {
  if (WH)
    return Ui;
  WH = 1;
  var e = Tn;
  Object.defineProperty(Ui, "__esModule", {
    value: !0
  }), Ui.UnsupportedStrategy = Ui.UnknownError = Ui.OAuthCallbackError = Ui.MissingSecret = Ui.MissingAuthorize = Ui.MissingAdapterMethods = Ui.MissingAdapter = Ui.MissingAPIRoute = Ui.InvalidCallbackUrl = Ui.AccountNotLinkedError = void 0, Ui.adapterErrorHandler = R, Ui.capitalize = q, Ui.eventsErrorHandler = L, Ui.upperSnake = M;
  var t = e(dA()), n = e(_A()), o = e(Hs()), r = e(Yr()), i = e(ki), a = e(Si), s = e(Ei), c = e(xi()), l = e(oi()), u = e(hEc());
  function d(T) {
    var D = _();
    return function() {
      var S = (0, l.default)(T), E;
      if (D) {
        var x = (0, l.default)(this).constructor;
        E = Reflect.construct(S, arguments, x);
      } else
        E = S.apply(this, arguments);
      return (0, c.default)(this, E);
    };
  }
  function _() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var p = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A(S) {
      var E, x;
      return (0, i.default)(this, A), x = D.call(this, (E = S == null ? void 0 : S.message) !== null && E !== void 0 ? E : S), x.name = "UnknownError", x.code = S.code, S instanceof Error && (x.stack = S.stack), x;
    }
    return (0, a.default)(A, [{
      key: "toJSON",
      value: function() {
        return {
          name: this.name,
          message: this.message,
          stack: this.stack
        };
      }
    }]), A;
  }((0, u.default)(Error));
  Ui.UnknownError = p;
  var g = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "OAuthCallbackError"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.OAuthCallbackError = g;
  var f = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "AccountNotLinkedError"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.AccountNotLinkedError = f;
  var h = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "MissingAPIRouteError"), (0, r.default)((0, o.default)(S), "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.MissingAPIRoute = h;
  var $ = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "MissingSecretError"), (0, r.default)((0, o.default)(S), "code", "NO_SECRET"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.MissingSecret = $;
  var v = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "MissingAuthorizeError"), (0, r.default)((0, o.default)(S), "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.MissingAuthorize = v;
  var b = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "MissingAdapterError"), (0, r.default)((0, o.default)(S), "code", "EMAIL_REQUIRES_ADAPTER_ERROR"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.MissingAdapter = b;
  var y = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "MissingAdapterMethodsError"), (0, r.default)((0, o.default)(S), "code", "MISSING_ADAPTER_METHODS_ERROR"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.MissingAdapterMethods = y;
  var w = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "UnsupportedStrategyError"), (0, r.default)((0, o.default)(S), "code", "CALLBACK_CREDENTIALS_JWT_ERROR"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.UnsupportedStrategy = w;
  var N = function(T) {
    (0, s.default)(A, T);
    var D = d(A);
    function A() {
      var S;
      (0, i.default)(this, A);
      for (var E = arguments.length, x = new Array(E), k = 0; k < E; k++)
        x[k] = arguments[k];
      return S = D.call.apply(D, [this].concat(x)), (0, r.default)((0, o.default)(S), "name", "InvalidCallbackUrl"), (0, r.default)((0, o.default)(S), "code", "INVALID_CALLBACK_URL_ERROR"), S;
    }
    return (0, a.default)(A);
  }(p);
  Ui.InvalidCallbackUrl = N;
  function M(T) {
    return T.replace(/([A-Z])/g, "_$1").toUpperCase();
  }
  function q(T) {
    return "".concat(T[0].toUpperCase()).concat(T.slice(1));
  }
  function L(T, D) {
    return Object.keys(T).reduce(function(A, S) {
      return A[S] = (0, n.default)(t.default.mark(function E() {
        var x, k = arguments;
        return t.default.wrap(function(z) {
          for (; ; )
            switch (z.prev = z.next) {
              case 0:
                return z.prev = 0, x = T[S], z.next = 4, x.apply(void 0, k);
              case 4:
                return z.abrupt("return", z.sent);
              case 7:
                z.prev = 7, z.t0 = z.catch(0), D.error("".concat(M(S), "_EVENT_ERROR"), z.t0);
              case 10:
              case "end":
                return z.stop();
            }
        }, E, null, [[0, 7]]);
      })), A;
    }, {});
  }
  function R(T, D) {
    if (T)
      return Object.keys(T).reduce(function(A, S) {
        return A[S] = (0, n.default)(t.default.mark(function E() {
          var x, k, I, z, F, P = arguments;
          return t.default.wrap(function(V) {
            for (; ; )
              switch (V.prev = V.next) {
                case 0:
                  for (V.prev = 0, x = P.length, k = new Array(x), I = 0; I < x; I++)
                    k[I] = P[I];
                  return D.debug("adapter_".concat(S), {
                    args: k
                  }), z = T[S], V.next = 6, z.apply(void 0, k);
                case 6:
                  return V.abrupt("return", V.sent);
                case 9:
                  throw V.prev = 9, V.t0 = V.catch(0), D.error("adapter_error_".concat(S), V.t0), F = new p(V.t0), F.name = "".concat(q(S), "Error"), F;
                case 15:
                case "end":
                  return V.stop();
              }
          }, E, null, [[0, 9]]);
        })), A;
      }, {});
  }
  return Ui;
}
var HH;
function bEc() {
  if (HH)
    return uh;
  HH = 1;
  var e = Tn;
  Object.defineProperty(uh, "__esModule", {
    value: !0
  }), uh.default = void 0, uh.proxyLogger = u, uh.setLogger = c;
  var t = e(Yr()), n = vEc();
  function o(d, _) {
    var p = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(d);
      _ && (g = g.filter(function(f) {
        return Object.getOwnPropertyDescriptor(d, f).enumerable;
      })), p.push.apply(p, g);
    }
    return p;
  }
  function r(d) {
    for (var _ = 1; _ < arguments.length; _++) {
      var p = arguments[_] != null ? arguments[_] : {};
      _ % 2 ? o(Object(p), !0).forEach(function(g) {
        (0, t.default)(d, g, p[g]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(p)) : o(Object(p)).forEach(function(g) {
        Object.defineProperty(d, g, Object.getOwnPropertyDescriptor(p, g));
      });
    }
    return d;
  }
  function i(d) {
    if (d instanceof Error && !(d instanceof n.UnknownError))
      return {
        message: d.message,
        stack: d.stack,
        name: d.name
      };
    if (a(d)) {
      var _;
      d.error = i(d.error), d.message = (_ = d.message) !== null && _ !== void 0 ? _ : d.error.message;
    }
    return d;
  }
  function a(d) {
    return !!(d != null && d.error);
  }
  var s = {
    error: function(_, p) {
      p = i(p), console.error("[next-auth][error][".concat(_, "]"), `
https://next-auth.js.org/errors#`.concat(_.toLowerCase()), p.message, p);
    },
    warn: function(_) {
      console.warn("[next-auth][warn][".concat(_, "]"), `
https://next-auth.js.org/warnings#`.concat(_.toLowerCase()));
    },
    debug: function(_, p) {
      console.log("[next-auth][debug][".concat(_, "]"), p);
    }
  };
  function c() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ = arguments.length > 1 ? arguments[1] : void 0;
    _ || (s.debug = function() {
    }), d.error && (s.error = d.error), d.warn && (s.warn = d.warn), d.debug && (s.debug = d.debug);
  }
  var l = s;
  uh.default = l;
  function u() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s, _ = arguments.length > 1 ? arguments[1] : void 0;
    try {
      if (typeof window > "u")
        return d;
      var p = {}, g = function($) {
        p[$] = function(v, b) {
          s[$](v, b), $ === "error" && (b = i(b)), b.client = !0;
          var y = "".concat(_, "/_log"), w = new URLSearchParams(r({
            level: $,
            code: v
          }, b));
          return navigator.sendBeacon ? navigator.sendBeacon(y, w) : fetch(y, {
            method: "POST",
            body: w,
            keepalive: !0
          });
        };
      };
      for (var f in d)
        g(f);
      return p;
    } catch {
      return s;
    }
  }
  return uh;
}
var QS = {}, YH;
function yEc() {
  if (YH)
    return QS;
  YH = 1, Object.defineProperty(QS, "__esModule", {
    value: !0
  }), QS.default = e;
  function e(t) {
    var n;
    const o = new URL("http://localhost:3000/api/auth");
    t && !t.startsWith("http") && (t = `https://${t}`);
    const r = new URL((n = t) !== null && n !== void 0 ? n : o), i = (r.pathname === "/" ? o.pathname : r.pathname).replace(/\/$/, ""), a = `${r.origin}${i}`;
    return {
      origin: r.origin,
      host: r.host,
      path: i,
      base: a,
      toString: () => a
    };
  }
  return QS;
}
var dh = {}, KH;
function $Ec() {
  if (KH)
    return dh;
  KH = 1;
  var e = Tn;
  Object.defineProperty(dh, "__esModule", {
    value: !0
  }), dh.BroadcastChannel = u, dh.apiBaseUrl = c, dh.fetchData = a, dh.now = l;
  var t = e(dA()), n = e(Yr()), o = e(_A());
  function r(d, _) {
    var p = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(d);
      _ && (g = g.filter(function(f) {
        return Object.getOwnPropertyDescriptor(d, f).enumerable;
      })), p.push.apply(p, g);
    }
    return p;
  }
  function i(d) {
    for (var _ = 1; _ < arguments.length; _++) {
      var p = arguments[_] != null ? arguments[_] : {};
      _ % 2 ? r(Object(p), !0).forEach(function(g) {
        (0, n.default)(d, g, p[g]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(p)) : r(Object(p)).forEach(function(g) {
        Object.defineProperty(d, g, Object.getOwnPropertyDescriptor(p, g));
      });
    }
    return d;
  }
  function a(d, _, p) {
    return s.apply(this, arguments);
  }
  function s() {
    return s = (0, o.default)(t.default.mark(function d(_, p, g) {
      var f, h, $, v, b, y, w, N, M, q = arguments;
      return t.default.wrap(function(R) {
        for (; ; )
          switch (R.prev = R.next) {
            case 0:
              return f = q.length > 3 && q[3] !== void 0 ? q[3] : {}, h = f.ctx, $ = f.req, v = $ === void 0 ? h == null ? void 0 : h.req : $, b = "".concat(c(p), "/").concat(_), R.prev = 2, w = {
                headers: i({
                  "Content-Type": "application/json"
                }, v != null && (y = v.headers) !== null && y !== void 0 && y.cookie ? {
                  cookie: v.headers.cookie
                } : {})
              }, v != null && v.body && (w.body = JSON.stringify(v.body), w.method = "POST"), R.next = 7, fetch(b, w);
            case 7:
              return N = R.sent, R.next = 10, N.json();
            case 10:
              if (M = R.sent, N.ok) {
                R.next = 13;
                break;
              }
              throw M;
            case 13:
              return R.abrupt("return", Object.keys(M).length > 0 ? M : null);
            case 16:
              return R.prev = 16, R.t0 = R.catch(2), g.error("CLIENT_FETCH_ERROR", {
                error: R.t0,
                url: b
              }), R.abrupt("return", null);
            case 20:
            case "end":
              return R.stop();
          }
      }, d, null, [[2, 16]]);
    })), s.apply(this, arguments);
  }
  function c(d) {
    return typeof window > "u" ? "".concat(d.baseUrlServer).concat(d.basePathServer) : d.basePath;
  }
  function l() {
    return Math.floor(Date.now() / 1e3);
  }
  function u() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "nextauth.message";
    return {
      receive: function(p) {
        var g = function(h) {
          var $;
          if (h.key === d) {
            var v = JSON.parse(($ = h.newValue) !== null && $ !== void 0 ? $ : "{}");
            (v == null ? void 0 : v.event) !== "session" || !(v != null && v.data) || p(v);
          }
        };
        return window.addEventListener("storage", g), function() {
          return window.removeEventListener("storage", g);
        };
      },
      post: function(p) {
        if (!(typeof window > "u"))
          try {
            localStorage.setItem(d, JSON.stringify(i(i({}, p), {}, {
              timestamp: l()
            })));
          } catch {
          }
      }
    };
  }
  return dh;
}
var Sz = {}, ZH;
function wEc() {
  return ZH || (ZH = 1, Object.defineProperty(Sz, "__esModule", {
    value: !0
  })), Sz;
}
(function(e) {
  var t = Tn, n = xo;
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var o = {
    SessionContext: !0,
    useSession: !0,
    getSession: !0,
    getCsrfToken: !0,
    getProviders: !0,
    signIn: !0,
    signOut: !0,
    SessionProvider: !0
  };
  e.SessionContext = void 0, e.SessionProvider = V, e.getCsrfToken = E, e.getProviders = k, e.getSession = A, e.signIn = z, e.signOut = P, e.useSession = D;
  var r = t(dA()), i = t(Yr()), a = t(_A()), s = t(Gu()), c = y(Fe), l = y(bEc()), u = t(yEc()), d = $Ec(), _ = gT, p = wEc();
  Object.keys(p).forEach(function(U) {
    U === "default" || U === "__esModule" || Object.prototype.hasOwnProperty.call(o, U) || U in e && e[U] === p[U] || Object.defineProperty(e, U, {
      enumerable: !0,
      get: function() {
        return p[U];
      }
    });
  });
  var g, f, h, $, v;
  function b(U) {
    if (typeof WeakMap != "function")
      return null;
    var H = /* @__PURE__ */ new WeakMap(), J = /* @__PURE__ */ new WeakMap();
    return (b = function(ae) {
      return ae ? J : H;
    })(U);
  }
  function y(U, H) {
    if (!H && U && U.__esModule)
      return U;
    if (U === null || n(U) !== "object" && typeof U != "function")
      return { default: U };
    var J = b(H);
    if (J && J.has(U))
      return J.get(U);
    var le = {}, ae = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Y in U)
      if (Y !== "default" && Object.prototype.hasOwnProperty.call(U, Y)) {
        var re = ae ? Object.getOwnPropertyDescriptor(U, Y) : null;
        re && (re.get || re.set) ? Object.defineProperty(le, Y, re) : le[Y] = U[Y];
      }
    return le.default = U, J && J.set(U, le), le;
  }
  function w(U, H) {
    var J = Object.keys(U);
    if (Object.getOwnPropertySymbols) {
      var le = Object.getOwnPropertySymbols(U);
      H && (le = le.filter(function(ae) {
        return Object.getOwnPropertyDescriptor(U, ae).enumerable;
      })), J.push.apply(J, le);
    }
    return J;
  }
  function N(U) {
    for (var H = 1; H < arguments.length; H++) {
      var J = arguments[H] != null ? arguments[H] : {};
      H % 2 ? w(Object(J), !0).forEach(function(le) {
        (0, i.default)(U, le, J[le]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(U, Object.getOwnPropertyDescriptors(J)) : w(Object(J)).forEach(function(le) {
        Object.defineProperty(U, le, Object.getOwnPropertyDescriptor(J, le));
      });
    }
    return U;
  }
  var M = {
    baseUrl: (0, u.default)((g = process.env.NEXTAUTH_URL) !== null && g !== void 0 ? g : process.env.VERCEL_URL).origin,
    basePath: (0, u.default)(process.env.NEXTAUTH_URL).path,
    baseUrlServer: (0, u.default)((f = (h = process.env.NEXTAUTH_URL_INTERNAL) !== null && h !== void 0 ? h : process.env.NEXTAUTH_URL) !== null && f !== void 0 ? f : process.env.VERCEL_URL).origin,
    basePathServer: (0, u.default)(($ = process.env.NEXTAUTH_URL_INTERNAL) !== null && $ !== void 0 ? $ : process.env.NEXTAUTH_URL).path,
    _lastSync: 0,
    _session: void 0,
    _getSession: function() {
    }
  }, q = (0, d.BroadcastChannel)(), L = (0, l.proxyLogger)(l.default, M.basePath);
  function R() {
    var U = c.useState(typeof navigator < "u" ? navigator.onLine : !1), H = (0, s.default)(U, 2), J = H[0], le = H[1], ae = function() {
      return le(!0);
    }, Y = function() {
      return le(!1);
    };
    return c.useEffect(function() {
      return window.addEventListener("online", ae), window.addEventListener("offline", Y), function() {
        window.removeEventListener("online", ae), window.removeEventListener("offline", Y);
      };
    }, []), J;
  }
  var T = (v = c.createContext) === null || v === void 0 ? void 0 : v.call(c, void 0);
  e.SessionContext = T;
  function D(U) {
    if (!T)
      throw new Error("React Context is unavailable in Server Components");
    var H = c.useContext(T);
    if (!H && process.env.NODE_ENV !== "production")
      throw new Error("[next-auth]: `useSession` must be wrapped in a <SessionProvider />");
    var J = U ?? {}, le = J.required, ae = J.onUnauthenticated, Y = le && H.status === "unauthenticated";
    return c.useEffect(function() {
      if (Y) {
        var re = "/api/auth/signin?".concat(new URLSearchParams({
          error: "SessionRequired",
          callbackUrl: window.location.href
        }));
        ae ? ae() : window.location.href = re;
      }
    }, [Y, ae]), Y ? {
      data: H.data,
      update: H.update,
      status: "loading"
    } : H;
  }
  function A(U) {
    return S.apply(this, arguments);
  }
  function S() {
    return S = (0, a.default)(r.default.mark(function U(H) {
      var J, le;
      return r.default.wrap(function(Y) {
        for (; ; )
          switch (Y.prev = Y.next) {
            case 0:
              return Y.next = 2, (0, d.fetchData)("session", M, L, H);
            case 2:
              return le = Y.sent, (!((J = H == null ? void 0 : H.broadcast) !== null && J !== void 0) || J) && q.post({
                event: "session",
                data: {
                  trigger: "getSession"
                }
              }), Y.abrupt("return", le);
            case 5:
            case "end":
              return Y.stop();
          }
      }, U);
    })), S.apply(this, arguments);
  }
  function E(U) {
    return x.apply(this, arguments);
  }
  function x() {
    return x = (0, a.default)(r.default.mark(function U(H) {
      var J;
      return r.default.wrap(function(ae) {
        for (; ; )
          switch (ae.prev = ae.next) {
            case 0:
              return ae.next = 2, (0, d.fetchData)("csrf", M, L, H);
            case 2:
              return J = ae.sent, ae.abrupt("return", J == null ? void 0 : J.csrfToken);
            case 4:
            case "end":
              return ae.stop();
          }
      }, U);
    })), x.apply(this, arguments);
  }
  function k() {
    return I.apply(this, arguments);
  }
  function I() {
    return I = (0, a.default)(r.default.mark(function U() {
      return r.default.wrap(function(J) {
        for (; ; )
          switch (J.prev = J.next) {
            case 0:
              return J.next = 2, (0, d.fetchData)("providers", M, L);
            case 2:
              return J.abrupt("return", J.sent);
            case 3:
            case "end":
              return J.stop();
          }
      }, U);
    })), I.apply(this, arguments);
  }
  function z(U, H, J) {
    return F.apply(this, arguments);
  }
  function F() {
    return F = (0, a.default)(r.default.mark(function U(H, J, le) {
      var ae, Y, re, ie, _e, he, be, Q, me, ne, pe, ge, ve, Te, Re, Me, et;
      return r.default.wrap(function(De) {
        for (; ; )
          switch (De.prev = De.next) {
            case 0:
              return ae = J ?? {}, Y = ae.callbackUrl, re = Y === void 0 ? window.location.href : Y, ie = ae.redirect, _e = ie === void 0 ? !0 : ie, he = (0, d.apiBaseUrl)(M), De.next = 4, k();
            case 4:
              if (be = De.sent, be) {
                De.next = 8;
                break;
              }
              return window.location.href = "".concat(he, "/error"), De.abrupt("return");
            case 8:
              if (!(!H || !(H in be))) {
                De.next = 11;
                break;
              }
              return window.location.href = "".concat(he, "/signin?").concat(new URLSearchParams({
                callbackUrl: re
              })), De.abrupt("return");
            case 11:
              return Q = be[H].type === "credentials", me = be[H].type === "email", ne = Q || me, pe = "".concat(he, "/").concat(Q ? "callback" : "signin", "/").concat(H), ge = "".concat(pe, "?").concat(new URLSearchParams(le)), De.t0 = fetch, De.t1 = ge, De.t2 = {
                "Content-Type": "application/x-www-form-urlencoded"
              }, De.t3 = URLSearchParams, De.t4 = N, De.t5 = N({}, J), De.t6 = {}, De.next = 25, E();
            case 25:
              return De.t7 = De.sent, De.t8 = re, De.t9 = {
                csrfToken: De.t7,
                callbackUrl: De.t8,
                json: !0
              }, De.t10 = (0, De.t4)(De.t5, De.t6, De.t9), De.t11 = new De.t3(De.t10), De.t12 = {
                method: "post",
                headers: De.t2,
                body: De.t11
              }, De.next = 33, (0, De.t0)(De.t1, De.t12);
            case 33:
              return ve = De.sent, De.next = 36, ve.json();
            case 36:
              if (Te = De.sent, !(_e || !ne)) {
                De.next = 42;
                break;
              }
              return Me = (Re = Te.url) !== null && Re !== void 0 ? Re : re, window.location.href = Me, Me.includes("#") && window.location.reload(), De.abrupt("return");
            case 42:
              if (et = new URL(Te.url).searchParams.get("error"), !ve.ok) {
                De.next = 46;
                break;
              }
              return De.next = 46, M._getSession({
                event: "storage"
              });
            case 46:
              return De.abrupt("return", {
                error: et,
                status: ve.status,
                ok: ve.ok,
                url: et ? null : Te.url
              });
            case 47:
            case "end":
              return De.stop();
          }
      }, U);
    })), F.apply(this, arguments);
  }
  function P(U) {
    return O.apply(this, arguments);
  }
  function O() {
    return O = (0, a.default)(r.default.mark(function U(H) {
      var J, le, ae, Y, re, ie, _e, he, be, Q;
      return r.default.wrap(function(ne) {
        for (; ; )
          switch (ne.prev = ne.next) {
            case 0:
              return le = H ?? {}, ae = le.callbackUrl, Y = ae === void 0 ? window.location.href : ae, re = (0, d.apiBaseUrl)(M), ne.t0 = {
                "Content-Type": "application/x-www-form-urlencoded"
              }, ne.t1 = URLSearchParams, ne.next = 6, E();
            case 6:
              return ne.t2 = ne.sent, ne.t3 = Y, ne.t4 = {
                csrfToken: ne.t2,
                callbackUrl: ne.t3,
                json: !0
              }, ne.t5 = new ne.t1(ne.t4), ie = {
                method: "post",
                headers: ne.t0,
                body: ne.t5
              }, ne.next = 13, fetch("".concat(re, "/signout"), ie);
            case 13:
              return _e = ne.sent, ne.next = 16, _e.json();
            case 16:
              if (he = ne.sent, q.post({
                event: "session",
                data: {
                  trigger: "signout"
                }
              }), !(!((J = H == null ? void 0 : H.redirect) !== null && J !== void 0) || J)) {
                ne.next = 23;
                break;
              }
              return Q = (be = he.url) !== null && be !== void 0 ? be : Y, window.location.href = Q, Q.includes("#") && window.location.reload(), ne.abrupt("return");
            case 23:
              return ne.next = 25, M._getSession({
                event: "storage"
              });
            case 25:
              return ne.abrupt("return", he);
            case 26:
            case "end":
              return ne.stop();
          }
      }, U);
    })), O.apply(this, arguments);
  }
  function V(U) {
    if (!T)
      throw new Error("React Context is unavailable in Server Components");
    var H = U.children, J = U.basePath, le = U.refetchInterval, ae = U.refetchWhenOffline;
    J && (M.basePath = J);
    var Y = U.session !== void 0;
    M._lastSync = Y ? (0, d.now)() : 0;
    var re = c.useState(function() {
      return Y && (M._session = U.session), U.session;
    }), ie = (0, s.default)(re, 2), _e = ie[0], he = ie[1], be = c.useState(!Y), Q = (0, s.default)(be, 2), me = Q[0], ne = Q[1];
    c.useEffect(function() {
      return M._getSession = (0, a.default)(r.default.mark(function Te() {
        var Re, Me, et, st = arguments;
        return r.default.wrap(function(ze) {
          for (; ; )
            switch (ze.prev = ze.next) {
              case 0:
                if (Re = st.length > 0 && st[0] !== void 0 ? st[0] : {}, Me = Re.event, ze.prev = 1, et = Me === "storage", !(et || M._session === void 0)) {
                  ze.next = 10;
                  break;
                }
                return M._lastSync = (0, d.now)(), ze.next = 7, A({
                  broadcast: !et
                });
              case 7:
                return M._session = ze.sent, he(M._session), ze.abrupt("return");
              case 10:
                if (!(!Me || M._session === null || (0, d.now)() < M._lastSync)) {
                  ze.next = 12;
                  break;
                }
                return ze.abrupt("return");
              case 12:
                return M._lastSync = (0, d.now)(), ze.next = 15, A();
              case 15:
                M._session = ze.sent, he(M._session), ze.next = 22;
                break;
              case 19:
                ze.prev = 19, ze.t0 = ze.catch(1), L.error("CLIENT_SESSION_ERROR", ze.t0);
              case 22:
                return ze.prev = 22, ne(!1), ze.finish(22);
              case 25:
              case "end":
                return ze.stop();
            }
        }, Te, null, [[1, 19, 22, 25]]);
      })), M._getSession(), function() {
        M._lastSync = 0, M._session = void 0, M._getSession = function() {
        };
      };
    }, []), c.useEffect(function() {
      var Te = q.receive(function() {
        return M._getSession({
          event: "storage"
        });
      });
      return function() {
        return Te();
      };
    }, []), c.useEffect(function() {
      var Te = U.refetchOnWindowFocus, Re = Te === void 0 ? !0 : Te, Me = function() {
        Re && document.visibilityState === "visible" && M._getSession({
          event: "visibilitychange"
        });
      };
      return document.addEventListener("visibilitychange", Me, !1), function() {
        return document.removeEventListener("visibilitychange", Me, !1);
      };
    }, [U.refetchOnWindowFocus]);
    var pe = R(), ge = ae !== !1 || pe;
    c.useEffect(function() {
      if (le && ge) {
        var Te = setInterval(function() {
          M._session && M._getSession({
            event: "poll"
          });
        }, le * 1e3);
        return function() {
          return clearInterval(Te);
        };
      }
    }, [le, ge]);
    var ve = c.useMemo(function() {
      return {
        data: _e,
        status: me ? "loading" : _e ? "authenticated" : "unauthenticated",
        update: function(Re) {
          return (0, a.default)(r.default.mark(function Me() {
            var et;
            return r.default.wrap(function(De) {
              for (; ; )
                switch (De.prev = De.next) {
                  case 0:
                    if (!(me || !_e)) {
                      De.next = 2;
                      break;
                    }
                    return De.abrupt("return");
                  case 2:
                    return ne(!0), De.t0 = d.fetchData, De.t1 = M, De.t2 = L, De.next = 8, E();
                  case 8:
                    return De.t3 = De.sent, De.t4 = Re, De.t5 = {
                      csrfToken: De.t3,
                      data: De.t4
                    }, De.t6 = {
                      body: De.t5
                    }, De.t7 = {
                      req: De.t6
                    }, De.next = 15, (0, De.t0)("session", De.t1, De.t2, De.t7);
                  case 15:
                    return et = De.sent, ne(!1), et && (he(et), q.post({
                      event: "session",
                      data: {
                        trigger: "getSession"
                      }
                    })), De.abrupt("return", et);
                  case 19:
                  case "end":
                    return De.stop();
                }
            }, Me);
          }))();
        }
      };
    }, [_e, me]);
    return (0, _.jsx)(T.Provider, {
      value: ve,
      children: H
    });
  }
})(ru);
function kEc(e = !1) {
  const { data: t, status: n } = ru.useSession(), o = n === "loading", r = Nr.useRouter();
  return yt(() => {
    if (!e && !o && !t) {
      const i = new URLSearchParams();
      i.set("callbackUrl", `${Wa}${location.pathname}${location.search}`), r.replace(`/auth/login?${i.toString()}`);
    }
  }, [o, t, e]), {
    loading: o && !t,
    session: t
  };
}
const SEc = Cr(null);
function Oq() {
  const e = bo(SEc);
  if (e === null)
    throw new Error("Error: useFlagMap was used outside of FeatureProvider.");
  return e;
}
const EEc = (e) => !e.completedOnboarding && !e.organizationId && ht(e.createdDate).isAfter(xEc), xEc = ht("September 1 2021").toISOString();
function CEc() {
  const e = Nr.useRouter(), { data: t, isLoading: n } = Z0(), o = Oq(), r = !(t != null && t.emailVerified) && (t == null ? void 0 : t.identityProvider) === "CAL" && o["email-verification"], i = t && EEc(t), a = !n && i && !r;
  return yt(() => {
    a && e.replace("/getting-started");
  }, [a, e]), {
    isLoading: n,
    shouldRedirectToOnboarding: i
  };
}
var Bp = {}, Br = {}, a5 = Dt && Dt.__assign || function() {
  return a5 = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, a5.apply(this, arguments);
}, TEc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), AEc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), IEc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && TEc(t, e, n);
  return AEc(t, e), t;
}, OEc = Dt && Dt.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
};
Object.defineProperty(Br, "__esModule", { value: !0 });
Br.Priority = Br.isModKey = Br.shouldRejectKeystrokes = Br.useThrottledValue = Br.getScrollbarWidth = Br.useIsomorphicLayout = Br.noop = Br.createAction = Br.randomId = Br.usePointerMovedSinceMount = Br.useOuterClick = Br.swallowEvent = void 0;
var wg = IEc(Fe);
function NEc(e) {
  e.stopPropagation(), e.preventDefault();
}
Br.swallowEvent = NEc;
function zEc(e, t) {
  var n = wg.useRef(t);
  n.current = t, wg.useEffect(function() {
    function o(r) {
      var i, a;
      !((i = e.current) === null || i === void 0) && i.contains(r.target) || // Add support for ReactShadowRoot
      // @ts-expect-error wrong types, the `host` property exists https://stackoverflow.com/a/25340456
      r.target === ((a = e.current) === null || a === void 0 ? void 0 : a.getRootNode().host) || (r.preventDefault(), r.stopPropagation(), n.current());
    }
    return window.addEventListener("pointerdown", o, !0), function() {
      return window.removeEventListener("pointerdown", o, !0);
    };
  }, [e]);
}
Br.useOuterClick = zEc;
function REc() {
  var e = wg.useState(!1), t = e[0], n = e[1];
  return wg.useEffect(function() {
    function o() {
      n(!0);
    }
    if (!t)
      return window.addEventListener("pointermove", o), function() {
        return window.removeEventListener("pointermove", o);
      };
  }, [t]), t;
}
Br.usePointerMovedSinceMount = REc;
function vpe() {
  return Math.random().toString(36).substring(2, 9);
}
Br.randomId = vpe;
function PEc(e) {
  return a5({ id: vpe() }, e);
}
Br.createAction = PEc;
function bpe() {
}
Br.noop = bpe;
Br.useIsomorphicLayout = typeof window > "u" ? bpe : wg.useLayoutEffect;
function DEc() {
  var e = document.createElement("div");
  e.style.visibility = "hidden", e.style.overflow = "scroll", document.body.appendChild(e);
  var t = document.createElement("div");
  e.appendChild(t);
  var n = e.offsetWidth - t.offsetWidth;
  return e.parentNode.removeChild(e), n;
}
Br.getScrollbarWidth = DEc;
function LEc(e, t) {
  t === void 0 && (t = 100);
  var n = wg.useState(e), o = n[0], r = n[1], i = wg.useRef(Date.now());
  return wg.useEffect(function() {
    if (t !== 0) {
      var a = setTimeout(function() {
        r(e), i.current = Date.now();
      }, i.current - (Date.now() - t));
      return function() {
        clearTimeout(a);
      };
    }
  }, [t, e]), t === 0 ? e : o;
}
Br.useThrottledValue = LEc;
function MEc(e) {
  var t, n, o = e === void 0 ? { ignoreWhenFocused: [] } : e, r = o.ignoreWhenFocused, i = OEc(["input", "textarea"], r, !0).map(function(c) {
    return c.toLowerCase();
  }), a = document.activeElement, s = a && (i.indexOf(a.tagName.toLowerCase()) !== -1 || ((t = a.attributes.getNamedItem("role")) === null || t === void 0 ? void 0 : t.value) === "textbox" || ((n = a.attributes.getNamedItem("contenteditable")) === null || n === void 0 ? void 0 : n.value) === "true");
  return s;
}
Br.shouldRejectKeystrokes = MEc;
var FEc = typeof window > "u", qEc = !FEc && window.navigator.platform === "MacIntel";
function jEc(e) {
  return qEc ? e.metaKey : e.ctrlKey;
}
Br.isModKey = jEc;
Br.Priority = {
  HIGH: 1,
  NORMAL: 0,
  LOW: -1
};
var ype = {}, iw = {}, Ez = {}, pA = {}, s5 = { exports: {} };
(function(e, t) {
  (function(n, o) {
    o(t);
  })(Dt, function(n) {
    var o = typeof WeakSet == "function", r = Object.keys;
    function i(R, T) {
      return R === T || R !== R && T !== T;
    }
    function a(R) {
      return R.constructor === Object || R.constructor == null;
    }
    function s(R) {
      return !!R && typeof R.then == "function";
    }
    function c(R) {
      return !!(R && R.$$typeof);
    }
    function l() {
      var R = [];
      return {
        add: function(T) {
          R.push(T);
        },
        has: function(T) {
          return R.indexOf(T) !== -1;
        }
      };
    }
    var u = /* @__PURE__ */ function(R) {
      return R ? function() {
        return /* @__PURE__ */ new WeakSet();
      } : l;
    }(o);
    function d(R) {
      return function(D) {
        var A = R || D;
        return function(E, x, k) {
          k === void 0 && (k = u());
          var I = !!E && typeof E == "object", z = !!x && typeof x == "object";
          if (I || z) {
            var F = I && k.has(E), P = z && k.has(x);
            if (F || P)
              return F && P;
            I && k.add(E), z && k.add(x);
          }
          return A(E, x, k);
        };
      };
    }
    function _(R, T, D, A) {
      var S = R.length;
      if (T.length !== S)
        return !1;
      for (; S-- > 0; )
        if (!D(R[S], T[S], A))
          return !1;
      return !0;
    }
    function p(R, T, D, A) {
      var S = R.size === T.size;
      if (S && R.size) {
        var E = {};
        R.forEach(function(x, k) {
          if (S) {
            var I = !1, z = 0;
            T.forEach(function(F, P) {
              !I && !E[z] && (I = D(k, P, A) && D(x, F, A), I && (E[z] = !0)), z++;
            }), S = I;
          }
        });
      }
      return S;
    }
    var g = "_owner", f = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
    function h(R, T, D, A) {
      var S = r(R), E = S.length;
      if (r(T).length !== E)
        return !1;
      if (E)
        for (var x = void 0; E-- > 0; ) {
          if (x = S[E], x === g) {
            var k = c(R), I = c(T);
            if ((k || I) && k !== I)
              return !1;
          }
          if (!f(T, x) || !D(R[x], T[x], A))
            return !1;
        }
      return !0;
    }
    function $(R, T) {
      return R.source === T.source && R.global === T.global && R.ignoreCase === T.ignoreCase && R.multiline === T.multiline && R.unicode === T.unicode && R.sticky === T.sticky && R.lastIndex === T.lastIndex;
    }
    function v(R, T, D, A) {
      var S = R.size === T.size;
      if (S && R.size) {
        var E = {};
        R.forEach(function(x) {
          if (S) {
            var k = !1, I = 0;
            T.forEach(function(z) {
              !k && !E[I] && (k = D(x, z, A), k && (E[I] = !0)), I++;
            }), S = k;
          }
        });
      }
      return S;
    }
    var b = typeof Map == "function", y = typeof Set == "function";
    function w(R) {
      var T = (
        /* eslint-disable no-use-before-define */
        typeof R == "function" ? R(D) : D
      );
      function D(A, S, E) {
        if (A === S)
          return !0;
        if (A && S && typeof A == "object" && typeof S == "object") {
          if (a(A) && a(S))
            return h(A, S, T, E);
          var x = Array.isArray(A), k = Array.isArray(S);
          return x || k ? x === k && _(A, S, T, E) : (x = A instanceof Date, k = S instanceof Date, x || k ? x === k && i(A.getTime(), S.getTime()) : (x = A instanceof RegExp, k = S instanceof RegExp, x || k ? x === k && $(A, S) : s(A) || s(S) ? A === S : b && (x = A instanceof Map, k = S instanceof Map, x || k) ? x === k && p(A, S, T, E) : y && (x = A instanceof Set, k = S instanceof Set, x || k) ? x === k && v(A, S, T, E) : h(A, S, T, E)));
        }
        return A !== A && S !== S;
      }
      return D;
    }
    var N = w(), M = w(function() {
      return i;
    }), q = w(d()), L = w(d(i));
    n.circularDeepEqual = q, n.circularShallowEqual = L, n.createCustomEqual = w, n.deepEqual = N, n.sameValueZeroEqual = i, n.shallowEqual = M, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(s5, s5.exports);
var VEc = s5.exports, X0 = {}, BEc = process.env.NODE_ENV === "production", xz = "Invariant failed";
function UEc(e, t) {
  if (!e) {
    if (BEc)
      throw new Error(xz);
    var n = typeof t == "function" ? t() : t, o = n ? xz + ": " + n : xz;
    throw new Error(o);
  }
}
const GEc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: UEc
}, Symbol.toStringTag, { value: "Module" })), $pe = /* @__PURE__ */ nu(GEc);
var J0 = {}, mA = {};
Object.defineProperty(mA, "__esModule", { value: !0 });
mA.Command = void 0;
var WEc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var o = this;
      n === void 0 && (n = {}), this.perform = function() {
        var r = t.perform();
        if (typeof r == "function") {
          var i = n.history;
          i && (o.historyItem && i.remove(o.historyItem), o.historyItem = i.add({
            perform: t.perform,
            negate: r
          }), o.history = {
            undo: function() {
              return i.undo(o.historyItem);
            },
            redo: function() {
              return i.redo(o.historyItem);
            }
          });
        }
      };
    }
    return e;
  }()
);
mA.Command = WEc;
var HEc = Dt && Dt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(J0, "__esModule", { value: !0 });
J0.ActionImpl = void 0;
var YEc = HEc($pe), KEc = mA, ZEc = Br, XEc = function(e) {
  var t = e.keywords, n = t === void 0 ? "" : t, o = e.section, r = o === void 0 ? "" : o;
  return (n + " " + (typeof r == "string" ? r : r.name)).trim();
}, JEc = (
  /** @class */
  function() {
    function e(t, n) {
      var o = this, r;
      this.priority = ZEc.Priority.NORMAL, this.ancestors = [], this.children = [], Object.assign(this, t), this.id = t.id, this.name = t.name, this.keywords = XEc(t);
      var i = t.perform;
      if (this.command = i && new KEc.Command({
        perform: function() {
          return i(o);
        }
      }, {
        history: n.history
      }), this.perform = (r = this.command) === null || r === void 0 ? void 0 : r.perform, t.parent) {
        var a = n.store[t.parent];
        (0, YEc.default)(a, "attempted to create an action whos parent: " + t.parent + " does not exist in the store."), a.addChild(this);
      }
    }
    return e.prototype.addChild = function(t) {
      t.ancestors.unshift(this);
      for (var n = this.parentActionImpl; n; )
        t.ancestors.unshift(n), n = n.parentActionImpl;
      this.children.push(t);
    }, e.prototype.removeChild = function(t) {
      var n = this, o = this.children.indexOf(t);
      o !== -1 && this.children.splice(o, 1), t.children && t.children.forEach(function(r) {
        n.removeChild(r);
      });
    }, Object.defineProperty(e.prototype, "parentActionImpl", {
      // easily access parentActionImpl after creation
      get: function() {
        return this.ancestors[this.ancestors.length - 1];
      },
      enumerable: !1,
      configurable: !0
    }), e.create = function(t, n) {
      return new e(t, n);
    }, e;
  }()
);
J0.ActionImpl = JEc;
var CC = Dt && Dt.__assign || function() {
  return CC = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, CC.apply(this, arguments);
}, QEc = Dt && Dt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(X0, "__esModule", { value: !0 });
X0.ActionInterface = void 0;
var exc = QEc($pe), txc = J0, nxc = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = []), n === void 0 && (n = {}), this.actions = {}, this.options = n, this.add(t);
    }
    return e.prototype.add = function(t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.parent && (0, exc.default)(this.actions[o.parent], 'Attempted to create action "' + o.name + '" without registering its parent "' + o.parent + '" first.'), this.actions[o.id] = txc.ActionImpl.create(o, {
          history: this.options.historyManager,
          store: this.actions
        });
      }
      return CC({}, this.actions);
    }, e.prototype.remove = function(t) {
      var n = this;
      return t.forEach(function(o) {
        var r = n.actions[o.id];
        if (r) {
          for (var i = r.children; i.length; ) {
            var a = i.pop();
            if (!a)
              return;
            delete n.actions[a.id], a.parentActionImpl && a.parentActionImpl.removeChild(a), a.children && i.push.apply(i, a.children);
          }
          r.parentActionImpl && r.parentActionImpl.removeChild(r), delete n.actions[o.id];
        }
      }), CC({}, this.actions);
    }, e;
  }()
);
X0.ActionInterface = nxc;
var Ny = {};
Object.defineProperty(Ny, "__esModule", { value: !0 });
Ny.history = Ny.HistoryItemImpl = void 0;
var oxc = Br, wpe = (
  /** @class */
  function() {
    function e(t) {
      this.perform = t.perform, this.negate = t.negate;
    }
    return e.create = function(t) {
      return new e(t);
    }, e;
  }()
);
Ny.HistoryItemImpl = wpe;
var rxc = (
  /** @class */
  function() {
    function e() {
      return this.undoStack = [], this.redoStack = [], e.instance || (e.instance = this, this.init()), e.instance;
    }
    return e.prototype.init = function() {
      var t = this;
      typeof window > "u" || window.addEventListener("keydown", function(n) {
        var o;
        if (!(!t.redoStack.length && !t.undoStack.length || (0, oxc.shouldRejectKeystrokes)())) {
          var r = (o = n.key) === null || o === void 0 ? void 0 : o.toLowerCase();
          n.metaKey && r === "z" && n.shiftKey ? t.redo() : n.metaKey && r === "z" && t.undo();
        }
      });
    }, e.prototype.add = function(t) {
      var n = wpe.create(t);
      return this.undoStack.push(n), n;
    }, e.prototype.remove = function(t) {
      var n = this.undoStack.findIndex(function(r) {
        return r === t;
      });
      if (n !== -1) {
        this.undoStack.splice(n, 1);
        return;
      }
      var o = this.redoStack.findIndex(function(r) {
        return r === t;
      });
      o !== -1 && this.redoStack.splice(o, 1);
    }, e.prototype.undo = function(t) {
      if (!t) {
        var n = this.undoStack.pop();
        return n ? (n == null || n.negate(), this.redoStack.push(n), n) : void 0;
      }
      var o = this.undoStack.findIndex(function(r) {
        return r === t;
      });
      if (o !== -1)
        return this.undoStack.splice(o, 1), t.negate(), this.redoStack.push(t), t;
    }, e.prototype.redo = function(t) {
      if (!t) {
        var n = this.redoStack.pop();
        return n ? (n == null || n.perform(), this.undoStack.push(n), n) : void 0;
      }
      var o = this.redoStack.findIndex(function(r) {
        return r === t;
      });
      if (o !== -1)
        return this.redoStack.splice(o, 1), t.perform(), this.undoStack.push(t), t;
    }, e.prototype.reset = function() {
      this.undoStack.splice(0), this.redoStack.splice(0);
    }, e;
  }()
), kpe = new rxc();
Ny.history = kpe;
Object.freeze(kpe);
var Iv = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VisualState = void 0, function(t) {
    t.animatingIn = "animating-in", t.showing = "showing", t.animatingOut = "animating-out", t.hidden = "hidden";
  }(e.VisualState || (e.VisualState = {}));
})(Iv);
var Ms = Dt && Dt.__assign || function() {
  return Ms = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Ms.apply(this, arguments);
}, ixc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), axc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), sxc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && ixc(t, e, n);
  return axc(t, e), t;
};
Object.defineProperty(pA, "__esModule", { value: !0 });
pA.useStore = void 0;
var cxc = VEc, Fm = sxc(Fe), lxc = X0, uxc = Ny, aw = Iv;
function dxc(e) {
  var t = Fm.useRef(Ms({ animations: {
    enterMs: 200,
    exitMs: 100
  } }, e.options)), n = Fm.useMemo(
    function() {
      return new lxc.ActionInterface(e.actions || [], {
        historyManager: t.current.enableHistory ? uxc.history : void 0
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), o = Fm.useState({
    searchQuery: "",
    currentRootActionId: null,
    visualState: aw.VisualState.hidden,
    actions: Ms({}, n.actions),
    activeIndex: 0
  }), r = o[0], i = o[1], a = Fm.useRef(r);
  a.current = r;
  var s = Fm.useCallback(function() {
    return a.current;
  }, []), c = Fm.useMemo(function() {
    return new _xc(s);
  }, [s]);
  Fm.useEffect(function() {
    a.current = r, c.notify();
  }, [r, c]);
  var l = Fm.useCallback(function(u) {
    return i(function(d) {
      return Ms(Ms({}, d), { actions: n.add(u) });
    }), function() {
      i(function(_) {
        return Ms(Ms({}, _), { actions: n.remove(u) });
      });
    };
  }, [n]);
  return Fm.useMemo(function() {
    return {
      getState: s,
      query: {
        setCurrentRootAction: function(u) {
          i(function(d) {
            return Ms(Ms({}, d), { currentRootActionId: u });
          });
        },
        setVisualState: function(u) {
          i(function(d) {
            return Ms(Ms({}, d), { visualState: typeof u == "function" ? u(d.visualState) : u });
          });
        },
        setSearch: function(u) {
          return i(function(d) {
            return Ms(Ms({}, d), { searchQuery: u });
          });
        },
        registerActions: l,
        toggle: function() {
          return i(function(u) {
            return Ms(Ms({}, u), { visualState: [
              aw.VisualState.animatingOut,
              aw.VisualState.hidden
            ].includes(u.visualState) ? aw.VisualState.animatingIn : aw.VisualState.animatingOut });
          });
        },
        setActiveIndex: function(u) {
          return i(function(d) {
            return Ms(Ms({}, d), { activeIndex: typeof u == "number" ? u : u(d.activeIndex) });
          });
        }
      },
      options: t.current,
      subscribe: function(u, d) {
        return c.subscribe(u, d);
      }
    };
  }, [s, c, l]);
}
pA.useStore = dxc;
var _xc = (
  /** @class */
  function() {
    function e(t) {
      this.subscribers = [], this.getState = t;
    }
    return e.prototype.subscribe = function(t, n) {
      var o = this, r = new pxc(function() {
        return t(o.getState());
      }, n);
      return this.subscribers.push(r), this.unsubscribe.bind(this, r);
    }, e.prototype.unsubscribe = function(t) {
      if (this.subscribers.length) {
        var n = this.subscribers.indexOf(t);
        if (n > -1)
          return this.subscribers.splice(n, 1);
      }
    }, e.prototype.notify = function() {
      this.subscribers.forEach(function(t) {
        return t.collect();
      });
    }, e;
  }()
), pxc = (
  /** @class */
  function() {
    function e(t, n) {
      this.collector = t, this.onChange = n;
    }
    return e.prototype.collect = function() {
      try {
        var t = this.collector();
        (0, cxc.deepEqual)(t, this.collected) || (this.collected = t, this.onChange && this.onChange(this.collected));
      } catch (n) {
        console.warn(n);
      }
    }, e;
  }()
), sw = {}, Nq = {};
Object.defineProperty(Nq, "__esModule", { value: !0 });
var mxc = ["Shift", "Meta", "Alt", "Control"], fxc = 1e3, gxc = "keydown", hxc = typeof navigator == "object" && /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "Meta" : "Control";
function c5(e, t) {
  return typeof e.getModifierState == "function" ? e.getModifierState(t) : !1;
}
function vxc(e) {
  return e.trim().split(" ").map(function(t) {
    var n = t.split(/\b\+/), o = n.pop();
    return n = n.map(function(r) {
      return r === "$mod" ? hxc : r;
    }), [n, o];
  });
}
function bxc(e, t) {
  return /^[^A-Za-z0-9]$/.test(e.key) && t[1] === e.key ? !0 : !// Allow either the `event.key` or the `event.code`
  // MDN event.key: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
  // MDN event.code: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code
  (t[1].toUpperCase() !== e.key.toUpperCase() && t[1] !== e.code || // Ensure all the modifiers in the keybinding are pressed.
  t[0].find(function(n) {
    return !c5(e, n);
  }) || // KEYBINDING_MODIFIER_KEYS (Shift/Control/etc) change the meaning of a
  // keybinding. So if they are pressed but aren't part of the current
  // keybinding press, then we don't have a match.
  mxc.find(function(n) {
    return !t[0].includes(n) && t[1] !== n && c5(e, n);
  }));
}
function yxc(e, t, n) {
  var o, r;
  n === void 0 && (n = {});
  var i = (o = n.timeout) !== null && o !== void 0 ? o : fxc, a = (r = n.event) !== null && r !== void 0 ? r : gxc, s = Object.keys(t).map(function(d) {
    return [vxc(d), t[d]];
  }), c = /* @__PURE__ */ new Map(), l = null, u = function(d) {
    d instanceof KeyboardEvent && (s.forEach(function(_) {
      var p = _[0], g = _[1], f = c.get(p), h = f || p, $ = h[0], v = bxc(d, $);
      v ? h.length > 1 ? c.set(p, h.slice(1)) : (c.delete(p), g(d)) : c5(d, d.key) || c.delete(p);
    }), l && clearTimeout(l), l = setTimeout(c.clear.bind(c), i));
  };
  return e.addEventListener(a, u), function() {
    e.removeEventListener(a, u);
  };
}
Nq.default = yxc;
var XH;
function $xc() {
  if (XH)
    return sw;
  XH = 1;
  var e = Dt && Dt.__createBinding || (Object.create ? function(h, $, v, b) {
    b === void 0 && (b = v), Object.defineProperty(h, b, { enumerable: !0, get: function() {
      return $[v];
    } });
  } : function(h, $, v, b) {
    b === void 0 && (b = v), h[b] = $[v];
  }), t = Dt && Dt.__setModuleDefault || (Object.create ? function(h, $) {
    Object.defineProperty(h, "default", { enumerable: !0, value: $ });
  } : function(h, $) {
    h.default = $;
  }), n = Dt && Dt.__importStar || function(h) {
    if (h && h.__esModule)
      return h;
    var $ = {};
    if (h != null)
      for (var v in h)
        v !== "default" && Object.prototype.hasOwnProperty.call(h, v) && e($, h, v);
    return t($, h), $;
  }, o = Dt && Dt.__importDefault || function(h) {
    return h && h.__esModule ? h : { default: h };
  };
  Object.defineProperty(sw, "__esModule", { value: !0 }), sw.InternalEvents = void 0;
  var r = n(Fe), i = o(Nq), a = Iv, s = Vg(), c = Br;
  function l() {
    return u(), d(), g(), f(), null;
  }
  sw.InternalEvents = l;
  function u() {
    var h, $, v = (0, s.useKBar)(function(L) {
      return {
        visualState: L.visualState,
        showing: L.visualState !== a.VisualState.hidden
      };
    }), b = v.query, y = v.options, w = v.visualState, N = v.showing;
    r.useEffect(function() {
      var L, R = y.toggleShortcut || "$mod+k", T = (0, i.default)(window, (L = {}, L[R] = function(D) {
        var A, S, E, x;
        D.defaultPrevented || (D.preventDefault(), b.toggle(), N ? (S = (A = y.callbacks) === null || A === void 0 ? void 0 : A.onClose) === null || S === void 0 || S.call(A) : (x = (E = y.callbacks) === null || E === void 0 ? void 0 : E.onOpen) === null || x === void 0 || x.call(E));
      }, L.Escape = function(D) {
        var A, S;
        N && (D.stopPropagation(), (S = (A = y.callbacks) === null || A === void 0 ? void 0 : A.onClose) === null || S === void 0 || S.call(A)), b.setVisualState(function(E) {
          return E === a.VisualState.hidden || E === a.VisualState.animatingOut ? E : a.VisualState.animatingOut;
        });
      }, L));
      return function() {
        T();
      };
    }, [y.callbacks, y.toggleShortcut, b, N]);
    var M = r.useRef(), q = r.useCallback(function(L) {
      var R, T, D = 0;
      L === a.VisualState.animatingIn && (D = ((R = y.animations) === null || R === void 0 ? void 0 : R.enterMs) || 0), L === a.VisualState.animatingOut && (D = ((T = y.animations) === null || T === void 0 ? void 0 : T.exitMs) || 0), clearTimeout(M.current), M.current = setTimeout(function() {
        var A = !1;
        b.setVisualState(function() {
          var S = L === a.VisualState.animatingIn ? a.VisualState.showing : a.VisualState.hidden;
          return S === a.VisualState.hidden && (A = !0), S;
        }), A && b.setCurrentRootAction(null);
      }, D);
    }, [(h = y.animations) === null || h === void 0 ? void 0 : h.enterMs, ($ = y.animations) === null || $ === void 0 ? void 0 : $.exitMs, b]);
    r.useEffect(function() {
      switch (w) {
        case a.VisualState.animatingIn:
        case a.VisualState.animatingOut:
          q(w);
          break;
      }
    }, [q, w]);
  }
  function d() {
    var h = (0, s.useKBar)(function(b) {
      return {
        visualState: b.visualState
      };
    }), $ = h.visualState, v = h.options;
    r.useEffect(function() {
      if (!v.disableDocumentLock)
        if ($ === a.VisualState.animatingIn) {
          if (document.body.style.overflow = "hidden", !v.disableScrollbarManagement) {
            var b = (0, c.getScrollbarWidth)(), y = getComputedStyle(document.body)["margin-right"];
            y && (b += Number(y.replace(/\D/g, ""))), document.body.style.marginRight = b + "px";
          }
        } else
          $ === a.VisualState.hidden && (document.body.style.removeProperty("overflow"), v.disableScrollbarManagement || document.body.style.removeProperty("margin-right"));
    }, [
      v.disableDocumentLock,
      v.disableScrollbarManagement,
      $
    ]);
  }
  var _ = /* @__PURE__ */ new WeakSet();
  function p(h) {
    return function($) {
      _.has($) || (h($), _.add($));
    };
  }
  function g() {
    var h = (0, s.useKBar)(function(y) {
      return {
        actions: y.actions
      };
    }), $ = h.actions, v = h.query, b = h.options;
    r.useEffect(function() {
      for (var y, w = Object.keys($).map(function(E) {
        return $[E];
      }), N = [], M = 0, q = w; M < q.length; M++) {
        var L = q[M];
        !((y = L.shortcut) === null || y === void 0) && y.length && N.push(L);
      }
      N = N.sort(function(E, x) {
        return x.shortcut.join(" ").length - E.shortcut.join(" ").length;
      });
      for (var R = {}, T = function(E) {
        var x = E.shortcut.join(" ");
        R[x] = p(function(k) {
          var I, z, F, P, O, V;
          (0, c.shouldRejectKeystrokes)() || (k.preventDefault(), !((I = E.children) === null || I === void 0) && I.length ? (v.setCurrentRootAction(E.id), v.toggle(), (F = (z = b.callbacks) === null || z === void 0 ? void 0 : z.onOpen) === null || F === void 0 || F.call(z)) : ((P = E.command) === null || P === void 0 || P.perform(), (V = (O = b.callbacks) === null || O === void 0 ? void 0 : O.onSelectAction) === null || V === void 0 || V.call(O, E)));
        });
      }, D = 0, A = N; D < A.length; D++) {
        var L = A[D];
        T(L);
      }
      var S = (0, i.default)(window, R, {
        timeout: 400
      });
      return function() {
        S();
      };
    }, [$, b.callbacks, v]);
  }
  function f() {
    var h = (0, s.useKBar)(function(v) {
      return {
        isShowing: v.visualState === a.VisualState.showing || v.visualState === a.VisualState.animatingIn
      };
    }).isShowing, $ = r.useRef(null);
    r.useEffect(function() {
      if (h) {
        $.current = document.activeElement;
        return;
      }
      var v = document.activeElement;
      (v == null ? void 0 : v.tagName.toLowerCase()) === "input" && v.blur();
      var b = $.current;
      b && b.focus();
    }, [h]);
  }
  return sw;
}
var JH;
function Spe() {
  return JH || (JH = 1, function(e) {
    var t = Dt && Dt.__createBinding || (Object.create ? function(c, l, u, d) {
      d === void 0 && (d = u), Object.defineProperty(c, d, { enumerable: !0, get: function() {
        return l[u];
      } });
    } : function(c, l, u, d) {
      d === void 0 && (d = u), c[d] = l[u];
    }), n = Dt && Dt.__setModuleDefault || (Object.create ? function(c, l) {
      Object.defineProperty(c, "default", { enumerable: !0, value: l });
    } : function(c, l) {
      c.default = l;
    }), o = Dt && Dt.__importStar || function(c) {
      if (c && c.__esModule)
        return c;
      var l = {};
      if (c != null)
        for (var u in c)
          u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
      return n(l, c), l;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.KBarProvider = e.KBarContext = void 0;
    var r = pA, i = o(Fe), a = $xc();
    e.KBarContext = i.createContext({});
    var s = function(c) {
      var l = (0, r.useStore)(c);
      return i.createElement(
        e.KBarContext.Provider,
        { value: l },
        i.createElement(a.InternalEvents, null),
        c.children
      );
    };
    e.KBarProvider = s;
  }(Ez)), Ez;
}
var QH;
function Vg() {
  if (QH)
    return iw;
  QH = 1;
  var e = Dt && Dt.__assign || function() {
    return e = Object.assign || function(s) {
      for (var c, l = 1, u = arguments.length; l < u; l++) {
        c = arguments[l];
        for (var d in c)
          Object.prototype.hasOwnProperty.call(c, d) && (s[d] = c[d]);
      }
      return s;
    }, e.apply(this, arguments);
  }, t = Dt && Dt.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l), Object.defineProperty(s, u, { enumerable: !0, get: function() {
      return c[l];
    } });
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = Dt && Dt.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), o = Dt && Dt.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(iw, "__esModule", { value: !0 }), iw.useKBar = void 0;
  var r = o(Fe), i = Spe();
  function a(s) {
    var c = r.useContext(i.KBarContext), l = c.query, u = c.getState, d = c.subscribe, _ = c.options, p = r.useRef(s == null ? void 0 : s(u())), g = r.useRef(s), f = r.useCallback(function(b) {
      return e(e({}, b), { query: l, options: _ });
    }, [l, _]), h = r.useState(f(p.current)), $ = h[0], v = h[1];
    return r.useEffect(function() {
      var b;
      return g.current && (b = d(function(y) {
        return g.current(y);
      }, function(y) {
        return v(f(y));
      })), function() {
        b && b();
      };
    }, [f, d]), $;
  }
  return iw.useKBar = a, iw;
}
var eY = 1, wxc = 0.9, kxc = 0.3, Cz = 0.1, Sxc = 0, Tz = 0.999, Exc = 0.9999, xxc = 0.99, tY = /[\\\/\-_+.# \t"@\[\(\{&]/, Cxc = /[\\\/\-_+.# \t"@\[\(\{&]/g;
function l5(e, t, n, o, r, i) {
  if (i === t.length)
    return r === e.length ? eY : xxc;
  for (var a = o.charAt(i), s = n.indexOf(a, r), c = 0, l, u, d; s >= 0; )
    l = l5(e, t, n, o, s + 1, i + 1), l > c && (s === r ? l *= eY : tY.test(e.charAt(s - 1)) ? (l *= wxc, d = e.slice(r, s - 1).match(Cxc), d && r > 0 && (l *= Math.pow(Tz, d.length))) : tY.test(e.slice(r, s - 1)) ? (l *= Sxc, r > 0 && (l *= Math.pow(Tz, s - r))) : (l *= kxc, r > 0 && (l *= Math.pow(Tz, s - r))), e.charAt(s) !== t.charAt(i) && (l *= Exc)), l < Cz && n.charAt(s - 1) === o.charAt(i + 1) && n.charAt(s - 1) !== o.charAt(i) && (u = l5(e, t, n, o, s + 1, i + 2), u * Cz > l && (l = u * Cz)), l > c && (c = l), s = n.indexOf(a, s + 1);
  return c;
}
function Txc(e, t) {
  return l5(e, t, e.toLowerCase(), t.toLowerCase(), 0, 0);
}
var Axc = Txc;
(function(e) {
  var t = Dt && Dt.__createBinding || (Object.create ? function(_, p, g, f) {
    f === void 0 && (f = g), Object.defineProperty(_, f, { enumerable: !0, get: function() {
      return p[g];
    } });
  } : function(_, p, g, f) {
    f === void 0 && (f = g), _[f] = p[g];
  }), n = Dt && Dt.__setModuleDefault || (Object.create ? function(_, p) {
    Object.defineProperty(_, "default", { enumerable: !0, value: p });
  } : function(_, p) {
    _.default = p;
  }), o = Dt && Dt.__importStar || function(_) {
    if (_ && _.__esModule)
      return _;
    var p = {};
    if (_ != null)
      for (var g in _)
        g !== "default" && Object.prototype.hasOwnProperty.call(_, g) && t(p, _, g);
    return n(p, _), p;
  }, r = Dt && Dt.__importDefault || function(_) {
    return _ && _.__esModule ? _ : { default: _ };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.useDeepMatches = e.useMatches = e.NO_GROUP = void 0;
  var i = o(Fe), a = Vg(), s = Br, c = r(Axc);
  e.NO_GROUP = {
    name: "none",
    priority: s.Priority.NORMAL
  };
  function l(_, p) {
    return p.priority - _.priority;
  }
  function u() {
    var _ = (0, a.useKBar)(function(M) {
      return {
        search: M.searchQuery,
        actions: M.actions,
        rootActionId: M.currentRootActionId
      };
    }), p = _.search, g = _.actions, f = _.rootActionId, h = i.useMemo(function() {
      return Object.keys(g).reduce(function(M, q) {
        var L = g[q];
        if (!L.parent && !f && M.push(L), L.id === f)
          for (var R = 0; R < L.children.length; R++)
            M.push(L.children[R]);
        return M;
      }, []).sort(l);
    }, [g, f]), $ = i.useCallback(function(M) {
      for (var q = [], L = 0; L < M.length; L++)
        q.push(M[L]);
      return function R(T, D) {
        D === void 0 && (D = q);
        for (var A = 0; A < T.length; A++)
          if (T[A].children.length > 0) {
            for (var S = T[A].children, E = 0; E < S.length; E++)
              D.push(S[E]);
            R(T[A].children, D);
          }
        return D;
      }(M);
    }, []), v = !p, b = i.useMemo(function() {
      return v ? h : $(h);
    }, [$, h, v]), y = d(b, p), w = i.useMemo(function() {
      for (var M, q, L = {}, R = [], T = [], D = 0; D < y.length; D++) {
        var A = y[D], S = A.action, E = A.score || s.Priority.NORMAL, x = {
          name: typeof S.section == "string" ? S.section : ((M = S.section) === null || M === void 0 ? void 0 : M.name) || e.NO_GROUP.name,
          priority: typeof S.section == "string" ? E : ((q = S.section) === null || q === void 0 ? void 0 : q.priority) || 0 + E
        };
        L[x.name] || (L[x.name] = [], R.push(x)), L[x.name].push({
          priority: S.priority + E,
          action: S
        });
      }
      T = R.sort(l).map(function(F) {
        return {
          name: F.name,
          actions: L[F.name].sort(l).map(function(P) {
            return P.action;
          })
        };
      });
      for (var k = [], D = 0; D < T.length; D++) {
        var I = T[D];
        I.name !== e.NO_GROUP.name && k.push(I.name);
        for (var z = 0; z < I.actions.length; z++)
          k.push(I.actions[z]);
      }
      return k;
    }, [y]), N = i.useMemo(function() {
      return f;
    }, [w]);
    return i.useMemo(function() {
      return {
        results: w,
        rootActionId: N
      };
    }, [N, w]);
  }
  e.useMatches = u;
  function d(_, p) {
    var g = i.useMemo(function() {
      return {
        filtered: _,
        search: p
      };
    }, [_, p]), f = (0, s.useThrottledValue)(g), h = f.filtered, $ = f.search;
    return i.useMemo(function() {
      if ($.trim() === "")
        return h.map(function(N) {
          return { score: 0, action: N };
        });
      for (var v = [], b = 0; b < h.length; b++) {
        var y = h[b], w = (0, c.default)([y.name, y.keywords, y.subtitle].join(" "), $);
        w > 0 && v.push({ score: w, action: y });
      }
      return v;
    }, [h, $]);
  }
  e.useDeepMatches = u;
})(ype);
var fA = {};
function Ixc() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Oxc = /* @__PURE__ */ Ixc() ? lc : yt;
function Nxc() {
  var e = it(/* @__PURE__ */ Object.create(null)), t = e[1];
  return Yt(function() {
    t(/* @__PURE__ */ Object.create(null));
  }, []);
}
var zxc = process.env.NODE_ENV === "production";
function nY(e, t) {
  if (!zxc) {
    if (e)
      return;
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var u5 = function(t) {
  var n = t.children, o = t.type, r = o === void 0 ? "reach-portal" : o, i = t.containerRef, a = xt(null), s = xt(null), c = Nxc();
  return process.env.NODE_ENV !== "production" && yt(function() {
    i != null && (process.env.NODE_ENV !== "production" && nY(typeof i == "object" && "current" in i, "@reach/portal: Invalid value passed to the `containerRef` of a `Portal`. The portal will be appended to the document body, but if you want to attach it to another DOM node you must pass a valid React ref object to `containerRef`."), process.env.NODE_ENV !== "production" && nY(i ? i.current != null : !0, "@reach/portal: A ref was passed to the `containerRef` prop of a `Portal`, but no DOM node was attached to it. Be sure to pass the ref to a DOM component.\n\nIf you are forwarding the ref from another component, be sure to use the React.forwardRef API. See https://reactjs.org/docs/forwarding-refs.html."));
  }, [i]), Oxc(function() {
    if (a.current) {
      var l = a.current.ownerDocument, u = (i == null ? void 0 : i.current) || l.body;
      return s.current = l == null ? void 0 : l.createElement(r), u.appendChild(s.current), c(), function() {
        s.current && u && u.removeChild(s.current);
      };
    }
  }, [r, c, i]), s.current ? /* @__PURE__ */ My(n, s.current) : /* @__PURE__ */ pt("span", {
    ref: a
  });
};
process.env.NODE_ENV !== "production" && (u5.displayName = "Portal");
const Rxc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Portal: u5,
  default: u5
}, Symbol.toStringTag, { value: "Module" })), Pxc = /* @__PURE__ */ nu(Rxc);
var Dxc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), Lxc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Mxc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Dxc(t, e, n);
  return Lxc(t, e), t;
}, Fxc = Dt && Dt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fA, "__esModule", { value: !0 });
fA.KBarPortal = void 0;
var qxc = Fxc(Pxc), jxc = Mxc(Fe), Vxc = Iv, Bxc = Vg();
function Uxc(e) {
  var t = (0, Bxc.useKBar)(function(n) {
    return {
      showing: n.visualState !== Vxc.VisualState.hidden
    };
  }).showing;
  return t ? jxc.createElement(qxc.default, null, e.children) : null;
}
fA.KBarPortal = Uxc;
var gA = {}, Zk = Dt && Dt.__assign || function() {
  return Zk = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Zk.apply(this, arguments);
}, Gxc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), Wxc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Hxc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Gxc(t, e, n);
  return Wxc(t, e), t;
}, Yxc = Dt && Dt.__rest || function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
};
Object.defineProperty(gA, "__esModule", { value: !0 });
gA.KBarPositioner = void 0;
var oY = Hxc(Fe), rY = {
  position: "fixed",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  inset: "0px",
  padding: "14vh 16px 16px"
};
function Kxc(e) {
  return e ? Zk(Zk({}, rY), e) : rY;
}
gA.KBarPositioner = oY.forwardRef(function(e, t) {
  var n = e.style, o = e.children, r = Yxc(e, ["style", "children"]);
  return oY.createElement("div", Zk({ ref: t, style: Kxc(n) }, r), o);
});
var zq = {};
(function(e) {
  var t = Dt && Dt.__assign || function() {
    return t = Object.assign || function(d) {
      for (var _, p = 1, g = arguments.length; p < g; p++) {
        _ = arguments[p];
        for (var f in _)
          Object.prototype.hasOwnProperty.call(_, f) && (d[f] = _[f]);
      }
      return d;
    }, t.apply(this, arguments);
  }, n = Dt && Dt.__createBinding || (Object.create ? function(d, _, p, g) {
    g === void 0 && (g = p), Object.defineProperty(d, g, { enumerable: !0, get: function() {
      return _[p];
    } });
  } : function(d, _, p, g) {
    g === void 0 && (g = p), d[g] = _[p];
  }), o = Dt && Dt.__setModuleDefault || (Object.create ? function(d, _) {
    Object.defineProperty(d, "default", { enumerable: !0, value: _ });
  } : function(d, _) {
    d.default = _;
  }), r = Dt && Dt.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var _ = {};
    if (d != null)
      for (var p in d)
        p !== "default" && Object.prototype.hasOwnProperty.call(d, p) && n(_, d, p);
    return o(_, d), _;
  }, i = Dt && Dt.__rest || function(d, _) {
    var p = {};
    for (var g in d)
      Object.prototype.hasOwnProperty.call(d, g) && _.indexOf(g) < 0 && (p[g] = d[g]);
    if (d != null && typeof Object.getOwnPropertySymbols == "function")
      for (var f = 0, g = Object.getOwnPropertySymbols(d); f < g.length; f++)
        _.indexOf(g[f]) < 0 && Object.prototype.propertyIsEnumerable.call(d, g[f]) && (p[g[f]] = d[g[f]]);
    return p;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.KBarSearch = e.getListboxItemId = e.KBAR_LISTBOX = void 0;
  var a = r(Fe), s = Iv, c = Vg();
  e.KBAR_LISTBOX = "kbar-listbox";
  var l = function(d) {
    return "kbar-listbox-item-" + d;
  };
  e.getListboxItemId = l;
  function u(d) {
    var _ = (0, c.useKBar)(function(q) {
      return {
        search: q.searchQuery,
        currentRootActionId: q.currentRootActionId,
        actions: q.actions,
        activeIndex: q.activeIndex,
        showing: q.visualState === s.VisualState.showing
      };
    }), p = _.query, g = _.search, f = _.actions, h = _.currentRootActionId, $ = _.activeIndex, v = _.showing, b = _.options, y = a.useRef(null), w = d.defaultPlaceholder, N = i(d, ["defaultPlaceholder"]);
    a.useEffect(function() {
      return p.setSearch(""), y.current.focus(), function() {
        return p.setSearch("");
      };
    }, [h, p]);
    var M = a.useMemo(function() {
      var q = w ?? "Type a command or search…";
      return h && f[h] ? f[h].name : q;
    }, [f, h, w]);
    return a.createElement("input", t({}, N, { ref: y, autoFocus: !0, autoComplete: "off", role: "combobox", spellCheck: "false", "aria-expanded": v, "aria-controls": e.KBAR_LISTBOX, "aria-activedescendant": (0, e.getListboxItemId)($), value: g, placeholder: M, onChange: function(q) {
      var L, R, T;
      (L = d.onChange) === null || L === void 0 || L.call(d, q), p.setSearch(q.target.value), (T = (R = b == null ? void 0 : b.callbacks) === null || R === void 0 ? void 0 : R.onQueryChange) === null || T === void 0 || T.call(R, q.target.value);
    }, onKeyDown: function(q) {
      var L;
      if ((L = d.onKeyDown) === null || L === void 0 || L.call(d, q), h && !g && q.key === "Backspace") {
        var R = f[h].parent;
        p.setCurrentRootAction(R);
      }
    } }));
  }
  e.KBarSearch = u;
})(zq);
var hA = {};
function Nh() {
  return Nh = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Nh.apply(this, arguments);
}
function Zxc(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), r, i;
  for (i = 0; i < o.length; i++)
    r = o[i], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
var Xxc = ["bottom", "height", "left", "right", "top", "width"], Jxc = function(t, n) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), Xxc.some(function(o) {
    return t[o] !== n[o];
  });
}, Xf = /* @__PURE__ */ new Map(), Epe, Qxc = function e() {
  var t = [];
  Xf.forEach(function(n, o) {
    var r = o.getBoundingClientRect();
    Jxc(r, n.rect) && (n.rect = r, t.push(n));
  }), t.forEach(function(n) {
    n.callbacks.forEach(function(o) {
      return o(n.rect);
    });
  }), Epe = window.requestAnimationFrame(e);
};
function eCc(e, t) {
  return {
    observe: function() {
      var o = Xf.size === 0;
      Xf.has(e) ? Xf.get(e).callbacks.push(t) : Xf.set(e, {
        rect: void 0,
        hasRectChanged: !1,
        callbacks: [t]
      }), o && Qxc();
    },
    unobserve: function() {
      var o = Xf.get(e);
      if (o) {
        var r = o.callbacks.indexOf(t);
        r >= 0 && o.callbacks.splice(r, 1), o.callbacks.length || Xf.delete(e), Xf.size || cancelAnimationFrame(Epe);
      }
    }
  };
}
var TC = typeof window < "u" ? Fe.useLayoutEffect : Fe.useEffect;
function tCc(e, t) {
  t === void 0 && (t = {
    width: 0,
    height: 0
  });
  var n = Fe.useState(e.current), o = n[0], r = n[1], i = Fe.useReducer(nCc, t), a = i[0], s = i[1], c = Fe.useRef(!1);
  return TC(function() {
    e.current !== o && r(e.current);
  }), TC(function() {
    if (o && !c.current) {
      c.current = !0;
      var l = o.getBoundingClientRect();
      s({
        rect: l
      });
    }
  }, [o]), Fe.useEffect(function() {
    if (o) {
      var l = eCc(o, function(u) {
        s({
          rect: u
        });
      });
      return l.observe(), function() {
        l.unobserve();
      };
    }
  }, [o]), a;
}
function nCc(e, t) {
  var n = t.rect;
  return e.height !== n.height || e.width !== n.width ? n : e;
}
var oCc = function() {
  return 50;
}, rCc = function(t) {
  return t;
}, iCc = function(t, n) {
  var o = n ? "offsetWidth" : "offsetHeight";
  return t[o];
}, xpe = function(t) {
  for (var n = Math.max(t.start - t.overscan, 0), o = Math.min(t.end + t.overscan, t.size - 1), r = [], i = n; i <= o; i++)
    r.push(i);
  return r;
};
function aCc(e) {
  var t, n = e.size, o = n === void 0 ? 0 : n, r = e.estimateSize, i = r === void 0 ? oCc : r, a = e.overscan, s = a === void 0 ? 1 : a, c = e.paddingStart, l = c === void 0 ? 0 : c, u = e.paddingEnd, d = u === void 0 ? 0 : u, _ = e.parentRef, p = e.horizontal, g = e.scrollToFn, f = e.useObserver, h = e.initialRect, $ = e.onScrollElement, v = e.scrollOffsetFn, b = e.keyExtractor, y = b === void 0 ? rCc : b, w = e.measureSize, N = w === void 0 ? iCc : w, M = e.rangeExtractor, q = M === void 0 ? xpe : M, L = p ? "width" : "height", R = p ? "scrollLeft" : "scrollTop", T = Fe.useRef({
    scrollOffset: 0,
    measurements: []
  }), D = Fe.useState(0), A = D[0], S = D[1];
  T.current.scrollOffset = A;
  var E = f || tCc, x = E(_, h), k = x[L];
  T.current.outerSize = k;
  var I = Fe.useCallback(function(ge) {
    _.current && (_.current[R] = ge);
  }, [_, R]), z = g || I;
  g = Fe.useCallback(function(ge) {
    z(ge, I);
  }, [I, z]);
  var F = Fe.useState({}), P = F[0], O = F[1], V = Fe.useCallback(function() {
    return O({});
  }, []), U = Fe.useRef([]), H = Fe.useMemo(function() {
    var ge = U.current.length > 0 ? Math.min.apply(Math, U.current) : 0;
    U.current = [];
    for (var ve = T.current.measurements.slice(0, ge), Te = ge; Te < o; Te++) {
      var Re = y(Te), Me = P[Re], et = ve[Te - 1] ? ve[Te - 1].end : l, st = typeof Me == "number" ? Me : i(Te), De = et + st;
      ve[Te] = {
        index: Te,
        start: et,
        size: st,
        end: De,
        key: Re
      };
    }
    return ve;
  }, [i, P, l, o, y]), J = (((t = H[o - 1]) == null ? void 0 : t.end) || l) + d;
  T.current.measurements = H, T.current.totalSize = J;
  var le = $ ? $.current : _.current, ae = Fe.useRef(v);
  ae.current = v, TC(function() {
    if (!le) {
      S(0);
      return;
    }
    var ge = function(Te) {
      var Re = ae.current ? ae.current(Te) : le[R];
      S(Re);
    };
    return ge(), le.addEventListener("scroll", ge, {
      capture: !1,
      passive: !0
    }), function() {
      le.removeEventListener("scroll", ge);
    };
  }, [le, R]);
  var Y = cCc(T.current), re = Y.start, ie = Y.end, _e = Fe.useMemo(function() {
    return q({
      start: re,
      end: ie,
      overscan: s,
      size: H.length
    });
  }, [re, ie, s, H.length, q]), he = Fe.useRef(N);
  he.current = N;
  var be = Fe.useMemo(function() {
    for (var ge = [], ve = function(et, st) {
      var De = _e[et], ze = H[De], Pe = Nh(Nh({}, ze), {}, {
        measureRef: function(He) {
          if (He) {
            var Xe = he.current(He, p);
            if (Xe !== Pe.size) {
              var at = T.current.scrollOffset;
              Pe.start < at && I(at + (Xe - Pe.size)), U.current.push(De), O(function(wt) {
                var Je;
                return Nh(Nh({}, wt), {}, (Je = {}, Je[Pe.key] = Xe, Je));
              });
            }
          }
        }
      });
      ge.push(Pe);
    }, Te = 0, Re = _e.length; Te < Re; Te++)
      ve(Te);
    return ge;
  }, [_e, I, p, H]), Q = Fe.useRef(!1);
  TC(function() {
    Q.current && O({}), Q.current = !0;
  }, [i]);
  var me = Fe.useCallback(function(ge, ve) {
    var Te = ve === void 0 ? {} : ve, Re = Te.align, Me = Re === void 0 ? "start" : Re, et = T.current, st = et.scrollOffset, De = et.outerSize;
    Me === "auto" && (ge <= st ? Me = "start" : ge >= st + De ? Me = "end" : Me = "start"), Me === "start" ? g(ge) : Me === "end" ? g(ge - De) : Me === "center" && g(ge - De / 2);
  }, [g]), ne = Fe.useCallback(function(ge, ve) {
    var Te = ve === void 0 ? {} : ve, Re = Te.align, Me = Re === void 0 ? "auto" : Re, et = Zxc(Te, ["align"]), st = T.current, De = st.measurements, ze = st.scrollOffset, Pe = st.outerSize, je = De[Math.max(0, Math.min(ge, o - 1))];
    if (je) {
      if (Me === "auto")
        if (je.end >= ze + Pe)
          Me = "end";
        else if (je.start <= ze)
          Me = "start";
        else
          return;
      var He = Me === "center" ? je.start + je.size / 2 : Me === "end" ? je.end : je.start;
      me(He, Nh({
        align: Me
      }, et));
    }
  }, [me, o]), pe = Fe.useCallback(function() {
    for (var ge = arguments.length, ve = new Array(ge), Te = 0; Te < ge; Te++)
      ve[Te] = arguments[Te];
    ne.apply(void 0, ve), requestAnimationFrame(function() {
      ne.apply(void 0, ve);
    });
  }, [ne]);
  return {
    virtualItems: be,
    totalSize: J,
    scrollToOffset: me,
    scrollToIndex: pe,
    measure: V
  };
}
var sCc = function(t, n, o, r) {
  for (; t <= n; ) {
    var i = (t + n) / 2 | 0, a = o(i);
    if (a < r)
      t = i + 1;
    else if (a > r)
      n = i - 1;
    else
      return i;
  }
  return t > 0 ? t - 1 : 0;
};
function cCc(e) {
  for (var t = e.measurements, n = e.outerSize, o = e.scrollOffset, r = t.length - 1, i = function(l) {
    return t[l].start;
  }, a = sCc(0, r, i, o), s = a; s < r && t[s].end < o + n; )
    s++;
  return {
    start: a,
    end: s
  };
}
const lCc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultRangeExtractor: xpe,
  useVirtual: aCc
}, Symbol.toStringTag, { value: "Module" })), uCc = /* @__PURE__ */ nu(lCc);
var d5 = Dt && Dt.__assign || function() {
  return d5 = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, d5.apply(this, arguments);
}, dCc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), _Cc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), pCc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && dCc(t, e, n);
  return _Cc(t, e), t;
};
Object.defineProperty(hA, "__esModule", { value: !0 });
hA.KBarResults = void 0;
var g_ = pCc(Fe), mCc = uCc, iY = zq, fCc = Vg(), gCc = Br, eE = 0, hCc = function(e) {
  var t = g_.useRef(null), n = g_.useRef(null), o = g_.useRef(e.items);
  o.current = e.items;
  var r = (0, mCc.useVirtual)({
    size: o.current.length,
    parentRef: n
  }), i = (0, fCc.useKBar)(function(g) {
    return {
      search: g.searchQuery,
      currentRootActionId: g.currentRootActionId,
      activeIndex: g.activeIndex
    };
  }), a = i.query, s = i.search, c = i.currentRootActionId, l = i.activeIndex, u = i.options;
  g_.useEffect(function() {
    var g = function(f) {
      var h;
      f.key === "ArrowUp" || f.ctrlKey && f.key === "p" ? (f.preventDefault(), a.setActiveIndex(function($) {
        var v = $ > eE ? $ - 1 : $;
        if (typeof o.current[v] == "string") {
          if (v === 0)
            return $;
          v -= 1;
        }
        return v;
      })) : f.key === "ArrowDown" || f.ctrlKey && f.key === "n" ? (f.preventDefault(), a.setActiveIndex(function($) {
        var v = $ < o.current.length - 1 ? $ + 1 : $;
        if (typeof o.current[v] == "string") {
          if (v === o.current.length - 1)
            return $;
          v += 1;
        }
        return v;
      })) : f.key === "Enter" && (f.preventDefault(), (h = t.current) === null || h === void 0 || h.click());
    };
    return window.addEventListener("keydown", g), function() {
      return window.removeEventListener("keydown", g);
    };
  }, [a]);
  var d = r.scrollToIndex;
  g_.useEffect(function() {
    d(l, {
      // ensure that if the first item in the list is a group
      // name and we are focused on the second item, to not
      // scroll past that group, hiding it.
      align: l <= 1 ? "end" : "auto"
    });
  }, [l, d]), g_.useEffect(function() {
    a.setActiveIndex(
      // avoid setting active index on a group
      typeof e.items[eE] == "string" ? eE + 1 : eE
    );
  }, [s, c, e.items, a]);
  var _ = g_.useCallback(function(g) {
    var f, h;
    typeof g != "string" && (g.command ? (g.command.perform(g), a.toggle()) : (a.setSearch(""), a.setCurrentRootAction(g.id)), (h = (f = u.callbacks) === null || f === void 0 ? void 0 : f.onSelectAction) === null || h === void 0 || h.call(f, g));
  }, [a, u]), p = (0, gCc.usePointerMovedSinceMount)();
  return g_.createElement(
    "div",
    { ref: n, style: {
      maxHeight: e.maxHeight || 400,
      position: "relative",
      overflow: "auto"
    } },
    g_.createElement("div", { role: "listbox", id: iY.KBAR_LISTBOX, style: {
      height: r.totalSize + "px",
      width: "100%"
    } }, r.virtualItems.map(function(g) {
      var f = o.current[g.index], h = typeof f != "string" && {
        onPointerMove: function() {
          return p && l !== g.index && a.setActiveIndex(g.index);
        },
        onPointerDown: function() {
          return a.setActiveIndex(g.index);
        },
        onClick: function() {
          return _(f);
        }
      }, $ = g.index === l;
      return g_.createElement("div", d5({ ref: $ ? t : null, id: (0, iY.getListboxItemId)(g.index), role: "option", "aria-selected": $, key: g.index, style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        transform: "translateY(" + g.start + "px)"
      } }, h), g_.cloneElement(e.onRender({
        item: f,
        active: $
      }), {
        ref: g.measureRef
      }));
    }))
  );
};
hA.KBarResults = hCc;
var vA = {}, vCc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), bCc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), yCc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && vCc(t, e, n);
  return bCc(t, e), t;
};
Object.defineProperty(vA, "__esModule", { value: !0 });
vA.useRegisterActions = void 0;
var aY = yCc(Fe), $Cc = Vg();
function wCc(e, t) {
  t === void 0 && (t = []);
  var n = (0, $Cc.useKBar)().query, o = aY.useMemo(function() {
    return e;
  }, t);
  aY.useEffect(function() {
    if (o.length) {
      var r = n.registerActions(o);
      return function() {
        r();
      };
    }
  }, [n, o]);
}
vA.useRegisterActions = wCc;
var bA = {}, Jw = Dt && Dt.__assign || function() {
  return Jw = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Jw.apply(this, arguments);
}, kCc = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), SCc = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), ECc = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && kCc(t, e, n);
  return SCc(t, e), t;
};
Object.defineProperty(bA, "__esModule", { value: !0 });
bA.KBarAnimator = void 0;
var qm = ECc(Fe), ub = Iv, xCc = Vg(), CCc = Br, sY = [
  {
    opacity: 0,
    transform: "scale(.99)"
  },
  { opacity: 1, transform: "scale(1.01)" },
  { opacity: 1, transform: "scale(1)" }
], TCc = [
  {
    transform: "scale(1)"
  },
  {
    transform: "scale(.98)"
  },
  {
    transform: "scale(1)"
  }
], ACc = function(e) {
  var t, n, o = e.children, r = e.style, i = e.className, a = (0, xCc.useKBar)(function($) {
    return {
      visualState: $.visualState,
      currentRootActionId: $.currentRootActionId
    };
  }), s = a.visualState, c = a.currentRootActionId, l = a.query, u = a.options, d = qm.useRef(null), _ = qm.useRef(null), p = ((t = u == null ? void 0 : u.animations) === null || t === void 0 ? void 0 : t.enterMs) || 0, g = ((n = u == null ? void 0 : u.animations) === null || n === void 0 ? void 0 : n.exitMs) || 0;
  qm.useEffect(function() {
    if (s !== ub.VisualState.showing) {
      var $ = s === ub.VisualState.animatingIn ? p : g, v = d.current;
      v == null || v.animate(sY, {
        duration: $,
        easing: (
          // TODO: expose easing in options
          s === ub.VisualState.animatingOut ? "ease-in" : "ease-out"
        ),
        direction: s === ub.VisualState.animatingOut ? "reverse" : "normal",
        fill: "forwards"
      });
    }
  }, [u, s, p, g]);
  var f = qm.useRef();
  qm.useEffect(function() {
    if (s === ub.VisualState.showing) {
      var $ = d.current, v = _.current;
      if (!$ || !v)
        return;
      var b = new ResizeObserver(function(y) {
        for (var w = 0, N = y; w < N.length; w++) {
          var M = N[w], q = M.contentRect;
          f.current || (f.current = q.height), $.animate([
            {
              height: f.current + "px"
            },
            {
              height: q.height + "px"
            }
          ], {
            duration: p / 2,
            // TODO: expose configs here
            easing: "ease-out",
            fill: "forwards"
          }), f.current = q.height;
        }
      });
      return b.observe(v), function() {
        b.unobserve(v);
      };
    }
  }, [s, u, p, g]);
  var h = qm.useRef(!0);
  return qm.useEffect(function() {
    if (h.current) {
      h.current = !1;
      return;
    }
    var $ = d.current;
    $ && $.animate(TCc, {
      duration: p,
      easing: "ease-out"
    });
  }, [c, p]), (0, CCc.useOuterClick)(d, function() {
    var $, v;
    l.setVisualState(ub.VisualState.animatingOut), (v = ($ = u.callbacks) === null || $ === void 0 ? void 0 : $.onClose) === null || v === void 0 || v.call($);
  }), qm.createElement(
    "div",
    { ref: d, style: Jw(Jw(Jw({}, sY[0]), r), { pointerEvents: "auto" }), className: i },
    qm.createElement("div", { ref: _ }, o)
  );
};
bA.KBarAnimator = ACc;
var Cpe = {};
(function(e) {
  var t = Dt && Dt.__createBinding || (Object.create ? function(o, r, i, a) {
    a === void 0 && (a = i), Object.defineProperty(o, a, { enumerable: !0, get: function() {
      return r[i];
    } });
  } : function(o, r, i, a) {
    a === void 0 && (a = i), o[a] = r[i];
  }), n = Dt && Dt.__exportStar || function(o, r) {
    for (var i in o)
      i !== "default" && !Object.prototype.hasOwnProperty.call(r, i) && t(r, o, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(X0, e), n(J0, e);
})(Cpe);
(function(e) {
  var t = Dt && Dt.__createBinding || (Object.create ? function(r, i, a, s) {
    s === void 0 && (s = a), Object.defineProperty(r, s, { enumerable: !0, get: function() {
      return i[a];
    } });
  } : function(r, i, a, s) {
    s === void 0 && (s = a), r[s] = i[a];
  }), n = Dt && Dt.__exportStar || function(r, i) {
    for (var a in r)
      a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, r, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Priority = e.createAction = void 0;
  var o = Br;
  Object.defineProperty(e, "createAction", { enumerable: !0, get: function() {
    return o.createAction;
  } }), Object.defineProperty(e, "Priority", { enumerable: !0, get: function() {
    return o.Priority;
  } }), n(ype, e), n(fA, e), n(gA, e), n(zq, e), n(hA, e), n(Vg(), e), n(vA, e), n(Spe(), e), n(bA, e), n(Iv, e), n(Cpe, e);
})(Bp);
const ICc = "Alby", OCc = "alby", NCc = "alby_payment", zCc = "icon.svg", RCc = "https://getalby.com", PCc = "payment", DCc = [
  "payment"
], LCc = "Alby", MCc = "support@getalby.com", FCc = "Your Bitcoin & Nostr companion for the web. Use Alby to charge Satoshi for your [Cal.com](https://cal.com) meetings.\r", qCc = "EventType", jCc = !1, VCc = !0, BCc = "event-type-app-card", UCc = "alby", GCc = !1, WCc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: ICc,
  slug: OCc,
  type: NCc,
  logo: zCc,
  url: RCc,
  variant: PCc,
  categories: DCc,
  publisher: LCc,
  email: MCc,
  description: FCc,
  extendsFeature: qCc,
  isTemplate: jCc,
  __createdUsingCli: VCc,
  __template: BCc,
  dirName: UCc,
  isOAuth: GCc
}, HCc = "Amie", YCc = "amie", KCc = "amie_other", ZCc = "icon.svg", XCc = "https://cal.com", JCc = "other", QCc = [
  "calendar"
], eTc = "Cal.com, Inc.", tTc = "support@cal.com", nTc = "The joyful productivity app\r\r", oTc = !0, rTc = [
  "google-calendar"
], iTc = "amie", aTc = !1, sTc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: HCc,
  slug: YCc,
  type: KCc,
  logo: ZCc,
  url: XCc,
  variant: JCc,
  categories: QCc,
  publisher: eTc,
  email: tTc,
  description: nTc,
  __createdUsingCli: oTc,
  dependencies: rTc,
  dirName: iTc,
  isOAuth: aTc
}, cTc = "https://json.schemastore.org/package.json", lTc = "@calcom/applecalendar", uTc = "0.0.0", dTc = "./index.ts", _Tc = "Apple calendar runs both the macOS and iOS mobile operating systems. Offering online cloud backup of calendars using Apple’s iCloud service, it can sync with Google Calendar and Microsoft Exchange Server. Users can schedule events in their day that include time, location, duration, and extra notes.", pTc = {
  "@calcom/prisma": "workspace:*",
  "react-hook-form": "^7.43.3"
}, mTc = {
  "@calcom/types": "workspace:*"
}, fTc = {
  $schema: cTc,
  private: !0,
  name: lTc,
  version: uTc,
  main: dTc,
  description: _Tc,
  dependencies: pTc,
  devDependencies: mTc
}, gTc = {
  name: "Apple Calendar",
  description: fTc.description,
  installed: !0,
  type: "apple_calendar",
  title: "Apple Calendar",
  variant: "calendar",
  categories: ["calendar"],
  category: "calendar",
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "apple-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "applecalendar",
  isOAuth: !1
}, hTc = "Attio", vTc = "attio", bTc = "attio_crm", yTc = "icon-dark.svg", $Tc = "/apps/installed/crm", wTc = "crm", kTc = [
  "crm"
], STc = "Cal.com, Inc.", ETc = "support@cal.com", xTc = "Attio is the AI-native CRM that builds, scales and grows your company to the next level.", CTc = !1, TTc = !0, ATc = "link-as-an-app", ITc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: hTc,
  slug: vTc,
  type: bTc,
  logo: yTc,
  url: $Tc,
  variant: wTc,
  categories: kTc,
  publisher: STc,
  email: ETc,
  description: xTc,
  isTemplate: CTc,
  __createdUsingCli: TTc,
  __template: ATc
}, OTc = "Autocheckin", NTc = "autocheckin", zTc = "autocheckin_automation", RTc = "icon.svg", PTc = "https://autocheckin.app", DTc = "automation", LTc = [
  "automation"
], MTc = "Patrick Goeler von Ravensburg", FTc = "patrickvongoeler@gmail.com", qTc = "You simply paste a [Cal.com](https://cal.com) link of someone, select a frequency and we will take care of the scheduling for you.\r\r", jTc = !1, VTc = !0, BTc = "link-as-an-app", UTc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: OTc,
  slug: NTc,
  type: zTc,
  logo: RTc,
  url: PTc,
  variant: DTc,
  categories: LTc,
  publisher: MTc,
  email: FTc,
  description: qTc,
  isTemplate: jTc,
  __createdUsingCli: VTc,
  __template: BTc
}, GTc = "BAA for HIPAA", WTc = "baa-for-hipaa", HTc = "baa-for-hipaa_other", YTc = "icon.svg", KTc = "https://cal.com/BAA", ZTc = "other", XTc = [
  "other"
], JTc = "Cal.com, Inc.", QTc = "support@cal.com", eAc = "Request a signed Business Associate Agreement for your HIPAA compliance records", tAc = !1, nAc = !0, oAc = "link-as-an-app", rAc = {
  priceInUsd: 300,
  mode: "subscription"
}, iAc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: GTc,
  slug: WTc,
  type: HTc,
  logo: YTc,
  url: KTc,
  variant: ZTc,
  categories: XTc,
  publisher: JTc,
  email: QTc,
  description: eAc,
  isTemplate: tAc,
  __createdUsingCli: nAc,
  __template: oAc,
  paid: rAc
}, aAc = "Basecamp3", sAc = "basecamp3", cAc = "basecamp3_other_calendar", lAc = "icon-dark.svg", uAc = "https://basecamp.com/", dAc = "other", _Ac = [
  "other"
], pAc = "Jonathan D'mello", mAc = "support@cal.com", fAc = "Basecamp puts everything you need to get work done in one place. It’s the calm, organized way to manage projects, work with clients, and communicate company-wide.", gAc = "EventType", hAc = !1, vAc = !0, bAc = "event-type-app-card", yAc = "basecamp3", $Ac = !0, wAc = {
  name: aAc,
  slug: sAc,
  type: cAc,
  logo: lAc,
  url: uAc,
  variant: dAc,
  categories: _Ac,
  publisher: pAc,
  email: mAc,
  description: fAc,
  extendsFeature: gAc,
  isTemplate: hAc,
  __createdUsingCli: vAc,
  __template: bAc,
  dirName: yAc,
  isOAuth: $Ac
}, kAc = "Bolna", SAc = "bolna", EAc = "bolna_automation", xAc = "icon-primary.svg", CAc = "https://playground.bolna.dev/auth/calcom", TAc = "automation", AAc = [
  "automation"
], IAc = "Bolna", OAc = "founders@bolna.dev", NAc = "24x7 AI receptionists to answer all inbound calls", zAc = !1, RAc = !0, PAc = "link-as-an-app", DAc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: kAc,
  slug: SAc,
  type: EAc,
  logo: xAc,
  url: CAc,
  variant: TAc,
  categories: AAc,
  publisher: IAc,
  email: OAc,
  description: NAc,
  isTemplate: zAc,
  __createdUsingCli: RAc,
  __template: PAc
}, LAc = "BTCPayServer", MAc = "btcpayserver", FAc = "btcpayserver_payment", qAc = "icon.svg", jAc = "https://btcpayserver.org", VAc = "payment", BAc = [
  "payment"
], UAc = "BTCPay Server Team", GAc = "chat.btcpayserver.org", WAc = "BTCPay Server is a self-hosted open source Bitcoin payment processor. Start receiving bitcoin payments for your events and bookings.", HAc = "EventType", YAc = !1, KAc = !0, ZAc = "event-type-app-card", XAc = {
  name: LAc,
  slug: MAc,
  type: FAc,
  logo: qAc,
  url: jAc,
  variant: VAc,
  categories: BAc,
  publisher: UAc,
  email: GAc,
  description: WAc,
  extendsFeature: HAc,
  isTemplate: YAc,
  __createdUsingCli: KAc,
  __template: ZAc
}, JAc = "https://json.schemastore.org/package.json", QAc = "@calcom/caldavcalendar", e2c = "0.0.0", t2c = "./index.ts", n2c = "Caldav is a protocol that allows different clients/servers to access scheduling information on remote servers as well as schedule meetings with other users on the same server or other servers. It extends WebDAV specification and uses iCalendar format for the data.", o2c = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/ui": "workspace:*",
  "react-hook-form": "^7.43.3"
}, r2c = {
  "@calcom/types": "workspace:*"
}, i2c = {
  $schema: JAc,
  private: !0,
  name: QAc,
  version: e2c,
  main: t2c,
  description: n2c,
  dependencies: o2c,
  devDependencies: r2c
}, a2c = {
  name: "CalDav (Beta)",
  description: i2c.description,
  installed: !0,
  type: "caldav_calendar",
  title: "CalDav (Beta)",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "caldav-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "caldavcalendar",
  isOAuth: !1
}, s2c = "Campfire", c2c = "campfire", l2c = "campfire_video", u2c = "icon.svg", d2c = "https://cal.com/", _2c = "conferencing", p2c = [
  "conferencing"
], m2c = "Cal.com, Inc.", f2c = "help@cal.com", g2c = "Feel connected with your remote team. Team events, new hire onboardings, coffee chats, all on Campfire. No more awkward Zoom calls.\r\r", h2c = !0, v2c = {
  location: {
    type: "integrations:campfire_video",
    label: "Campfire",
    linkType: "static",
    organizerInputPlaceholder: "https://party.campfire.to/your-team",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?party.campfire.to\\/[a-zA-Z0-9]*"
  }
}, b2c = !1, Tpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: s2c,
  slug: c2c,
  type: l2c,
  logo: u2c,
  url: d2c,
  variant: _2c,
  categories: p2c,
  publisher: m2c,
  email: f2c,
  description: g2c,
  __createdUsingCli: h2c,
  appData: v2c,
  isOAuth: b2c
}, y2c = "Chatbase", $2c = "chatbase", w2c = "chatbase_other", k2c = "icon-dark.svg", S2c = "https://www.chatbase.co/guide/cal", E2c = "other", x2c = [
  "other"
], C2c = "Chatbase", T2c = "sandra@chatbase.co", A2c = "Add [Cal.com](https://cal.com/) to your Chatbase AI Chatbot and accept bookings right inside chat.", I2c = !1, O2c = !0, N2c = "link-as-an-app", z2c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: y2c,
  slug: $2c,
  type: w2c,
  logo: k2c,
  url: S2c,
  variant: E2c,
  categories: x2c,
  publisher: C2c,
  email: T2c,
  description: A2c,
  isTemplate: I2c,
  __createdUsingCli: O2c,
  __template: N2c
}, R2c = "Clic", P2c = "clic", D2c = "check_in_automation", L2c = "icon.svg", M2c = "https://clicis.vercel.app", F2c = "automation", q2c = [
  "automation"
], j2c = "Chris Pacheco", V2c = "chrispacheco430@gmail.com", B2c = "Create, List and Interact with Your Cal.com links and connections easily.\r\r", U2c = !1, G2c = !0, W2c = "link-as-an-app", H2c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: R2c,
  slug: P2c,
  type: D2c,
  logo: L2c,
  url: M2c,
  variant: F2c,
  categories: q2c,
  publisher: j2c,
  email: V2c,
  description: B2c,
  isTemplate: U2c,
  __createdUsingCli: G2c,
  __template: W2c
}, Y2c = "Close.com", K2c = "Close.com", Z2c = "closecom", X2c = "closecom_crm", J2c = "icon.svg", Q2c = "https://cal.com/", eIc = "crm", tIc = [
  "crm"
], nIc = "Cal.com, Inc.", oIc = "EventType", rIc = "help@cal.com", iIc = "Close is the inside sales CRM of choice for startups and SMBs. Make more calls, send more emails and close more deals starting today.", aIc = !0, sIc = !0, cIc = "closecom", lIc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Y2c,
  title: K2c,
  slug: Z2c,
  type: X2c,
  logo: J2c,
  url: Q2c,
  variant: eIc,
  categories: tIc,
  publisher: nIc,
  extendsFeature: oIc,
  email: rIc,
  description: iIc,
  __createdUsingCli: aIc,
  isOAuth: sIc,
  dirName: cIc
}, uIc = "Notion Calendar", dIc = "cron", _Ic = "cron_calendar", pIc = "logo.png", mIc = "https://github.com/miguelnietoa", fIc = "calendar", gIc = [
  "calendar"
], hIc = "Miguel Nieto", vIc = "support@cal.com", bIc = "All of your commitments, now in one place.", yIc = !1, $Ic = !0, wIc = "link-as-an-app", kIc = [
  "google-calendar"
], SIc = !1, EIc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: uIc,
  slug: dIc,
  type: _Ic,
  logo: pIc,
  url: mIc,
  variant: fIc,
  categories: gIc,
  publisher: hIc,
  email: vIc,
  description: bIc,
  isTemplate: yIc,
  __createdUsingCli: $Ic,
  __template: wIc,
  dependencies: kIc,
  isOAuth: SIc
}, xIc = "@calcom/dailyvideo", CIc = "0.0.0", TIc = "./index.ts", AIc = "Cal Video is the in-house web-based video conferencing platform powered by Daily.co, which is minimalistic and lightweight, but has most of the features you need.", IIc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, OIc = {
  "@calcom/types": "workspace:*"
}, NIc = {
  private: !0,
  name: xIc,
  version: CIc,
  main: TIc,
  description: AIc,
  dependencies: IIc,
  devDependencies: OIc
}, Ape = {
  name: "Cal Video",
  description: NIc.description,
  installed: !!process.env.DAILY_API_KEY,
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Cal.com",
  category: "conferencing",
  slug: "daily-video",
  title: "Cal Video",
  isGlobal: !0,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Cal Video"
    }
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: !1
}, zIc = "Deel", RIc = "deel", PIc = "deel_other", DIc = "icon.svg", LIc = "https://go.cal.com/deel", MIc = "other", FIc = [
  "other"
], qIc = "Deel.com", jIc = "support@deel.com", VIc = "Integrate Deel with your Calendar and get automatic updates on key employee dates like PTO, start days, public holidays, and birthdays. No manual entry. No errors. Just a calendar that's always in sync with your team.", BIc = !1, UIc = !0, GIc = "link-as-an-app", WIc = "deel", HIc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: zIc,
  slug: RIc,
  type: PIc,
  logo: DIc,
  url: LIc,
  variant: MIc,
  categories: FIc,
  publisher: qIc,
  email: jIc,
  description: VIc,
  isTemplate: BIc,
  __createdUsingCli: UIc,
  __template: GIc,
  dirName: WIc
}, YIc = "Demodesk", KIc = "demodesk", ZIc = "demodesk_conferencing", XIc = "icon.svg", JIc = "https://demodesk.com", QIc = "conferencing", eOc = [
  "conferencing"
], tOc = "Cal.com, Inc.", nOc = "support@cal.com", oOc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://demodesk.com/meet/mylink",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?demodesk.com\\/[a-zA-Z0-9]*"
  }
}, rOc = "Run Professional Video Meetings, Coach Sales Teams in Real-Time with AI, And Schedule Meetings on Auto-Pilot. 100% GDPR Compliant, Enterprise Ready.", iOc = !1, aOc = !0, sOc = "event-type-location-video-static", Ipe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: YIc,
  slug: KIc,
  type: ZIc,
  logo: XIc,
  url: JIc,
  variant: QIc,
  categories: eOc,
  publisher: tOc,
  email: nOc,
  appData: oOc,
  description: rOc,
  isTemplate: iOc,
  __createdUsingCli: aOc,
  __template: sOc
}, cOc = "dialpad", lOc = "dialpad", uOc = "dialpad_conferencing", dOc = "icon.svg", _Oc = "https://meetings.dialpad.com/", pOc = "conferencing", mOc = [
  "conferencing"
], fOc = "Cal.com", gOc = "help@cal.com", hOc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://meetings.dialpad.com/adb2002",
    urlRegExp: "^https:\\/\\/meetings\\.dialpad\\.com\\/[a-zA-Z0-9]+$"
  }
}, vOc = "A new way to meet, with built-in Ai", bOc = !1, yOc = !0, $Oc = "event-type-location-video-static", Ope = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: cOc,
  slug: lOc,
  type: uOc,
  logo: dOc,
  url: _Oc,
  variant: pOc,
  categories: mOc,
  publisher: fOc,
  email: gOc,
  appData: hOc,
  description: vOc,
  isTemplate: bOc,
  __createdUsingCli: yOc,
  __template: $Oc
}, wOc = "Discord", kOc = "discord", SOc = "discord_video", EOc = "icon.svg", xOc = "https://discord.com/", COc = "conferencing", TOc = [
  "conferencing"
], AOc = "Cal.com, Inc.", IOc = "support@cal.com", OOc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://discord.gg/420gg69",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?discord\\.(gg|com)\\/[a-zA-Z0-9]+"
  }
}, NOc = "Copy your server invite link and start scheduling calls in Discord! Discord is a VoIP and instant messaging social platform. Users have the ability to communicate with voice calls, video calls, text messaging, media and files in private chats or as part of communities.", zOc = !1, ROc = !0, POc = "event-type-location-video-static", DOc = !1, Npe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: wOc,
  slug: kOc,
  type: SOc,
  logo: EOc,
  url: xOc,
  variant: COc,
  categories: TOc,
  publisher: AOc,
  email: IOc,
  appData: OOc,
  description: NOc,
  isTemplate: zOc,
  __createdUsingCli: ROc,
  __template: POc,
  isOAuth: DOc
}, LOc = "Dub", MOc = "dub", FOc = "dub_analytics", qOc = "icon-dark.svg", jOc = "https://dub.co", VOc = "analytics", BOc = [
  "analytics"
], UOc = "Cal.com", GOc = "help@cal.com", WOc = "Dub is the modern link attribution platform for you to create short links, track conversion analytics, and run affiliate programs.", HOc = !1, YOc = !0, KOc = "basic", ZOc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: LOc,
  slug: MOc,
  type: FOc,
  logo: qOc,
  url: jOc,
  variant: VOc,
  categories: BOc,
  publisher: UOc,
  email: GOc,
  description: WOc,
  isTemplate: HOc,
  __createdUsingCli: YOc,
  __template: KOc
}, XOc = "8x8", JOc = "eightxeight", QOc = "eightxeight_video", eNc = "icon.svg", tNc = "https://github.com/shivamklr", nNc = "conferencing", oNc = [
  "conferencing"
], rNc = "Shivam Kalra", iNc = "shivamkalra98@gmail.com", aNc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://8x8.vc/company",
    urlRegExp: "^(http|https)://(www\\.)?8x8.vc/[a-zA-Z0-9]*"
  }
}, sNc = "The best video conferencing solution for businesses of any size. Fully secure, reliable, packed with features and ridiculously simple to use.\r\r", cNc = !1, lNc = !0, uNc = "event-type-location-video-static", dNc = "eightxeight", _Nc = !1, zpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: XOc,
  slug: JOc,
  type: QOc,
  logo: eNc,
  url: tNc,
  variant: nNc,
  categories: oNc,
  publisher: rNc,
  email: iNc,
  appData: aNc,
  description: sNc,
  isTemplate: cNc,
  __createdUsingCli: lNc,
  __template: uNc,
  dirName: dNc,
  isOAuth: _Nc
}, pNc = "Element Call", mNc = "element-call", fNc = "element-call_conferencing", gNc = "icon.svg", hNc = "https://github.com/suyash5053/", vNc = "conferencing", bNc = [
  "conferencing"
], yNc = "Suyash Srivastava", $Nc = "suyashsrivastava5053@gmail.com", wNc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://call.element.io/",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?call.element.io/[a-zA-Z0-9]*"
  }
}, kNc = 'Element is an open-source communication platform that provides messaging, voice calling, and video conferencing capabilities. It is based on the Matrix protocol, which is a decentralized and federated messaging protocol designed to enable secure and interoperable communication across different platforms and services."', SNc = !1, ENc = !0, xNc = "event-type-location-video-static", CNc = "element-call", TNc = !1, Rpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: pNc,
  slug: mNc,
  type: fNc,
  logo: gNc,
  url: hNc,
  variant: vNc,
  categories: bNc,
  publisher: yNc,
  email: $Nc,
  appData: wNc,
  description: kNc,
  isTemplate: SNc,
  __createdUsingCli: ENc,
  __template: xNc,
  dirName: CNc,
  isOAuth: TNc
}, ANc = "ElevenLabs", INc = "elevenlabs", ONc = "elevenlabs_automation", NNc = "icon-dark.svg", zNc = "https://elevenlabs.io/docs/conversational-ai/guides/integrations/cal-com", RNc = "automation", PNc = [
  "automation"
], DNc = "ElevenLabs", LNc = "support@elevenlabs.io", MNc = "Create the most realistic speech with our AI audio platform", FNc = !1, qNc = !0, jNc = "link-as-an-app", VNc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: ANc,
  slug: INc,
  type: ONc,
  logo: NNc,
  url: zNc,
  variant: RNc,
  categories: PNc,
  publisher: DNc,
  email: LNc,
  description: MNc,
  isTemplate: FNc,
  __createdUsingCli: qNc,
  __template: jNc
}, BNc = "@calcom/exchange2013calendar", UNc = "0.0.0", GNc = "./index.ts", WNc = "For calendars hosted on on-premises Microsoft Exchange 2013 servers", HNc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/ui": "workspace:*",
  "ews-javascript-api": "^0.11.0",
  "react-hook-form": "^7.43.3"
}, YNc = {
  "@calcom/types": "workspace:*"
}, KNc = {
  private: !0,
  name: BNc,
  version: UNc,
  main: GNc,
  description: WNc,
  dependencies: HNc,
  devDependencies: YNc
}, ZNc = {
  name: "Microsoft Exchange 2013 Calendar",
  description: KNc.description,
  installed: !0,
  type: "exchange2013_calendar",
  title: "Microsoft Exchange 2013 Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  label: "Exchange Calendar",
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "exchange2013-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "exchange2013calendar",
  isOAuth: !1
}, XNc = "@calcom/exchange2016calendar", JNc = "0.0.0", QNc = "./index.ts", ezc = "For calendars hosted on on-premises Microsoft Exchange 2016 servers", tzc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/ui": "workspace:*",
  "ews-javascript-api": "^0.11.0",
  "react-hook-form": "^7.43.3"
}, nzc = {
  "@calcom/types": "workspace:*"
}, ozc = {
  private: !0,
  name: XNc,
  version: JNc,
  main: QNc,
  description: ezc,
  dependencies: tzc,
  devDependencies: nzc
}, rzc = {
  name: "Microsoft Exchange 2016 Calendar",
  description: ozc.description,
  installed: !0,
  type: "exchange2016_calendar",
  title: "Microsoft Exchange 2016 Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  label: "Exchange Calendar",
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "exchange2016-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "exchange2016calendar",
  isOAuth: !1
}, izc = "Microsoft Exchange", azc = "Microsoft Exchange", szc = "exchange", czc = "exchangecalendar", lzc = "exchange_calendar", uzc = "icon.svg", dzc = "https://cal.com", _zc = "calendar", pzc = [
  "calendar"
], mzc = "Cal.com", fzc = "help@cal.com", gzc = "Fetch Microsoft Exchange calendars and availabilities using Exchange Web Services (EWS).", hzc = !0, vzc = !1, bzc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  title: izc,
  name: azc,
  slug: szc,
  dirName: czc,
  type: lzc,
  logo: uzc,
  url: dzc,
  variant: _zc,
  categories: pzc,
  publisher: mzc,
  email: fzc,
  description: gzc,
  __createdUsingCli: hzc,
  isOAuth: vzc
}, yzc = "Facetime", $zc = "Facetime", wzc = "facetime", kzc = "facetime_video", Szc = "icon.svg", Ezc = "https://github.com/Mythie", xzc = "conferencing", Czc = [
  "conferencing"
], Tzc = "Lucas Smith", Azc = "help@cal.com", Izc = "Facetime makes it super simple for collaborating teams to jump on a video call.", Ozc = !0, Nzc = {
  location: {
    linkType: "static",
    type: "integrations:facetime_video",
    label: "Facetime",
    organizerInputPlaceholder: "https://facetime.apple.com/join... link copied from the FaceTime app",
    urlRegExp: "^https?:\\/\\/facetime\\.apple\\.com\\/join.+$"
  }
}, zzc = !1, Rzc = !1, Ppe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: yzc,
  title: $zc,
  slug: wzc,
  type: kzc,
  logo: Szc,
  url: Ezc,
  variant: xzc,
  categories: Czc,
  publisher: Tzc,
  email: Azc,
  description: Izc,
  __createdUsingCli: Ozc,
  appData: Nzc,
  isTemplate: zzc,
  isOAuth: Rzc
}, Pzc = "Fathom", Dzc = "fathom", Lzc = "fathom_analytics", Mzc = "icon.svg", Fzc = "https://cal.com", qzc = "analytics", jzc = [
  "analytics"
], Vzc = "Cal.com, Inc.", Bzc = "help@cal.com", Uzc = "EventType", Gzc = {
  tag: {
    scripts: [
      {
        src: "https://cdn.usefathom.com/script.js",
        attrs: {
          "data-site": "{TRACKING_ID}"
        }
      }
    ]
  }
}, Wzc = "Fathom Analytics provides simple, privacy-focused website analytics. We're a GDPR-compliant, Google Analytics alternative.", Hzc = !0, Yzc = !1, Dpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Pzc,
  slug: Dzc,
  type: Lzc,
  logo: Mzc,
  url: Fzc,
  variant: qzc,
  categories: jzc,
  publisher: Vzc,
  email: Bzc,
  extendsFeature: Uzc,
  appData: Gzc,
  description: Wzc,
  __createdUsingCli: Hzc,
  isOAuth: Yzc
}, Kzc = "https://json.schemastore.org/package.json", Zzc = "@calcom/feishucalendar", Xzc = "0.0.0", Jzc = "./index.ts", Qzc = "Feishu Calendar is a time management and scheduling service developed by Feishu. Allows users to create and edit events, with options available for type and time. Available to anyone that has a Feishu account on both mobile and web versions.", eRc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, tRc = {
  "@calcom/types": "workspace:*"
}, nRc = {
  $schema: Kzc,
  private: !0,
  name: Zzc,
  version: Xzc,
  main: Jzc,
  description: Qzc,
  dependencies: eRc,
  devDependencies: tRc
}, oRc = {
  name: "Feishu Calendar",
  description: nRc.description,
  installed: !0,
  type: "feishu_calendar",
  title: "Feishu Calendar",
  variant: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Feishu",
  slug: "feishu-calendar",
  url: "https://feishu.cn/",
  email: "alan@larksuite.com",
  dirName: "feishucalendar"
}, rRc = "fonio.ai", iRc = "fonio-ai", aRc = "fonio-ai_automation", sRc = "icon.png", cRc = "https://docs.fonio.ai/Tools/Terminbuchung", lRc = "automation", uRc = [
  "automation"
], dRc = "fonio GmbH", _Rc = "info@fonio.ai", pRc = "Der KI-Telefonassistent auf Deutsch\r", mRc = !1, fRc = !0, gRc = "link-as-an-app", hRc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: rRc,
  slug: iRc,
  type: aRc,
  logo: sRc,
  url: cRc,
  variant: lRc,
  categories: uRc,
  publisher: dRc,
  email: _Rc,
  description: pRc,
  isTemplate: mRc,
  __createdUsingCli: fRc,
  __template: gRc
}, vRc = "Framer", bRc = "framer", yRc = "framer_other", $Rc = "icon-dark.svg", wRc = "https://www.framer.com/updates/cal-com", kRc = "other", SRc = [
  "other"
], ERc = "Framer B.V.", xRc = "benjamin@framer.com", CRc = "Add Cal.com to Framer, the design tool for websites. Design freely, publish fast, and scale with CMS, SEO, analytics, and more.", TRc = !1, ARc = !0, IRc = "link-as-an-app", ORc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: vRc,
  slug: bRc,
  type: yRc,
  logo: $Rc,
  url: wRc,
  variant: kRc,
  categories: SRc,
  publisher: ERc,
  email: xRc,
  description: CRc,
  isTemplate: TRc,
  __createdUsingCli: ARc,
  __template: IRc
}, NRc = "Google Analytics", zRc = "ga4", RRc = "ga4_analytics", PRc = "icon.svg", DRc = "https://marketingplatform.google.com", LRc = "analytics", MRc = [
  "analytics"
], FRc = "Cal.com, Inc.", qRc = "support@cal.com", jRc = "Google Analytics is a web analytics service offered by Google that tracks and reports website traffic, currently as a platform inside the Google Marketing Platform brand.", VRc = "EventType", BRc = {
  tag: {
    scripts: [
      {
        src: "https://www.googletagmanager.com/gtag/js?id={TRACKING_ID}",
        attrs: {}
      },
      {
        content: `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '{TRACKING_ID}', {'cookie_flags': 'SameSite=None;Secure'});`
      }
    ]
  }
}, URc = !0, GRc = !1, Lpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: NRc,
  slug: zRc,
  type: RRc,
  logo: PRc,
  url: DRc,
  variant: LRc,
  categories: MRc,
  publisher: FRc,
  email: qRc,
  description: jRc,
  extendsFeature: VRc,
  appData: BRc,
  __createdUsingCli: URc,
  isOAuth: GRc
}, WRc = "https://json.schemastore.org/package.json", HRc = "@calcom/giphy", YRc = "0.0.0", KRc = "./index.ts", ZRc = "GIPHY is your top source for the best & newest GIFs & Animated Stickers online. Find everything from funny GIFs, reaction GIFs, unique GIFs and more.", XRc = {
  "@calcom/prisma": "workspace:*"
}, JRc = {
  "@calcom/types": "workspace:*"
}, QRc = {
  $schema: WRc,
  private: !0,
  name: HRc,
  version: YRc,
  main: KRc,
  description: ZRc,
  dependencies: XRc,
  devDependencies: JRc
}, ePc = {
  name: "Giphy",
  description: QRc.description,
  installed: !0,
  categories: ["other"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "giphy",
  title: "Giphy",
  type: "giphy_other",
  url: "https://cal.com/apps/giphy",
  variant: "other",
  extendsFeature: "EventType",
  email: "help@cal.com",
  dirName: "giphy",
  isOAuth: !1
}, Mpe = (e) => {
  try {
    const t = JSON.parse(e);
    if (t && typeof t == "object")
      return t;
  } catch (t) {
    console.log("Invalid JSON:", t);
  }
  return !1;
}, tPc = "https://json.schemastore.org/package.json", nPc = "@calcom/googlecalendar", oPc = "0.0.0", rPc = "./index.ts", iPc = "Google Calendar is a time management and scheduling service developed by Google. Allows users to create and edit events, with options available for type and time. Available to anyone that has a Gmail account on both mobile and web versions.", aPc = {
  "@calcom/prisma": "workspace:*",
  "@googleapis/calendar": "^9.7.9"
}, sPc = {
  "@calcom/types": "workspace:*"
}, cPc = {
  $schema: tPc,
  private: !0,
  name: nPc,
  version: oPc,
  main: rPc,
  description: iPc,
  dependencies: aPc,
  devDependencies: sPc
}, lPc = {
  name: "Google Calendar",
  description: cPc.description,
  installed: !!(process.env.GOOGLE_API_CREDENTIALS && Mpe(process.env.GOOGLE_API_CREDENTIALS)),
  type: "google_calendar",
  title: "Google Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "google-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "googlecalendar",
  isOAuth: !0,
  delegationCredential: {
    // This is unused at the moment but should be used in future
    // For now, we have hardcoded imports in the codebase that are supported with Google Workspace(i.e. Google Calendar and Google Meet)
    workspacePlatformSlug: "google"
  }
}, uPc = "https://json.schemastore.org/package.json", dPc = "@calcom/googlevideo", _Pc = "0.0.0", pPc = "./index.ts", mPc = "Google Meet is Google's web-based video conferencing platform, designed to compete with major conferencing platforms.", fPc = {
  "@calcom/prisma": "workspace:*"
}, gPc = {
  "@calcom/types": "workspace:*"
}, hPc = {
  $schema: uPc,
  private: !0,
  name: dPc,
  version: _Pc,
  main: pPc,
  description: mPc,
  dependencies: fPc,
  devDependencies: gPc
}, Fpe = {
  name: "Google Meet",
  description: hPc.description,
  installed: !!(process.env.GOOGLE_API_CREDENTIALS && Mpe(process.env.GOOGLE_API_CREDENTIALS)),
  slug: "google-meet",
  category: "conferencing",
  categories: ["conferencing"],
  type: "google_video",
  title: "Google Meet",
  variant: "conferencing",
  logo: "logo.webp",
  publisher: "Cal.com",
  url: "https://cal.com/",
  isGlobal: !1,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:google:meet",
      label: "Google Meet"
    }
  },
  dirName: "googlevideo",
  dependencies: ["google-calendar"],
  isOAuth: !1
}, vPc = "Granola", bPc = "granola", yPc = "granola_other", $Pc = "icon.svg", wPc = "https://go.cal.com/granola", kPc = "other", SPc = [
  "other"
], EPc = "Granola inc", xPc = "hey@granola.so", CPc = "The AI notepad for people in back-to-back meetings for MacOS", TPc = !1, APc = !0, IPc = "link-as-an-app", OPc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: vPc,
  slug: bPc,
  type: yPc,
  logo: $Pc,
  url: wPc,
  variant: kPc,
  categories: SPc,
  publisher: EPc,
  email: xPc,
  description: CPc,
  isTemplate: TPc,
  __createdUsingCli: APc,
  __template: IPc
}, NPc = "Greetmate.ai", zPc = "greetmate-ai", RPc = "greetmate-ai_automation", PPc = "icon-dark.svg", DPc = "https://www.greetmate.ai", LPc = "automation", MPc = [
  "automation"
], FPc = "Greetmate Inc.", qPc = "support@greetmate.ai", jPc = "Connect [Cal.com](https://cal.com/) to [Greetmate.ai](https://www.greetmate.ai/) and enable appointment scheduling for your AI agents.", VPc = !1, BPc = !0, UPc = "link-as-an-app", GPc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: NPc,
  slug: zPc,
  type: RPc,
  logo: PPc,
  url: DPc,
  variant: LPc,
  categories: MPc,
  publisher: FPc,
  email: qPc,
  description: jPc,
  isTemplate: VPc,
  __createdUsingCli: BPc,
  __template: UPc
}, WPc = "Google Tag Manager", HPc = "gtm", YPc = "gtm_analytics", KPc = "icon.svg", ZPc = "https://tagmanager.google.com", XPc = "analytics", JPc = [
  "analytics"
], QPc = "Black Lemon", eDc = "support@blacklemon.dk", tDc = "App to install Google Tag Manager", nDc = "EventType", oDc = {
  tag: {
    scripts: [
      {
        content: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','{TRACKING_ID}');"
      }
    ],
    pushEventScript: {
      content: "function $pushEvent(event) {window.dataLayer.push({ event: event.name, ...event.data })}"
    }
  }
}, rDc = !1, iDc = !0, aDc = "booking-pages-tag", sDc = !1, qpe = {
  name: WPc,
  slug: HPc,
  type: YPc,
  logo: KPc,
  url: ZPc,
  variant: XPc,
  categories: JPc,
  publisher: QPc,
  email: eDc,
  description: tDc,
  extendsFeature: nDc,
  appData: oDc,
  isTemplate: rDc,
  __createdUsingCli: iDc,
  __template: aDc,
  isOAuth: sDc
}, cDc = "HitPay", lDc = "hitpay", uDc = "hitpay_payment", dDc = "icon.svg", _Dc = "https://hitpayapp.com", pDc = "payment", mDc = [
  "payment"
], fDc = "HitPay", gDc = "support@hit-pay.com", hDc = "HitPay's Cal.com payment integration combines powerful scheduling with seamless local payment acceptance. Our online scheduling software integration is built for customers in APAC, supporting their favorite e-wallets and banking apps.", vDc = "EventType", bDc = !1, yDc = !0, $Dc = "event-type-app-card", wDc = "hitpay", kDc = !0, SDc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: cDc,
  slug: lDc,
  type: uDc,
  logo: dDc,
  url: _Dc,
  variant: pDc,
  categories: mDc,
  publisher: fDc,
  email: gDc,
  description: hDc,
  extendsFeature: vDc,
  isTemplate: bDc,
  __createdUsingCli: yDc,
  __template: $Dc,
  dirName: wDc,
  isOAuth: kDc
}, EDc = "Horizon Workrooms", xDc = "horizon-workrooms", CDc = "horizon-workrooms_conferencing", TDc = "icon.svg", ADc = "https://forwork.meta.com/de/en/horizon-workrooms/", IDc = "conferencing", ODc = [
  "conferencing"
], NDc = "Cal.com, Inc", zDc = "support@cal.com", RDc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://workrooms.workplace.com/groupcall/LINK:uALeBBTZbdBowT",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?workrooms.workplace.com\\/[a-zA-Z0-9]*"
  }
}, PDc = "Workrooms is an immersive virtual space, where you and your team can work better together, from anywhere", DDc = !1, LDc = !0, MDc = "event-type-location-video-static", jpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: EDc,
  slug: xDc,
  type: CDc,
  logo: TDc,
  url: ADc,
  variant: IDc,
  categories: ODc,
  publisher: NDc,
  email: zDc,
  appData: RDc,
  description: PDc,
  isTemplate: DDc,
  __createdUsingCli: LDc,
  __template: MDc
}, FDc = "@calcom/hubspot", qDc = "0.0.0", jDc = "./index.ts", VDc = "HubSpot is a cloud-based CRM designed to help align sales and marketing teams, foster sales enablement, boost ROI and optimize your inbound marketing strategy to generate more, qualified leads.", BDc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@hubspot/api-client": "^6.0.1"
}, UDc = {
  "@calcom/types": "workspace:*"
}, GDc = {
  private: !0,
  name: FDc,
  version: qDc,
  main: jDc,
  description: VDc,
  dependencies: BDc,
  devDependencies: UDc
}, WDc = {
  name: "HubSpot CRM",
  installed: !!process.env.HUBSPOT_CLIENT_ID,
  description: GDc.description,
  type: "hubspot_crm",
  variant: "crm",
  logo: "icon.svg",
  publisher: "Cal.com",
  url: "https://hubspot.com/",
  categories: ["crm"],
  label: "HubSpot CRM",
  slug: "hubspot",
  extendsFeature: "EventType",
  title: "HubSpot CRM",
  email: "help@cal.com",
  dirName: "hubspot",
  isOAuth: !0
}, HDc = "@calcom/huddle01video", YDc = "0.0.0", KDc = "./index.ts", ZDc = "Huddle01 is a new video conferencing software native to Web3 and is comparable to a decentralized version of Zoom. It supports conversations for NFT communities, DAOs, Builders and also has features such as token gating, NFTs as avatars, Web3 Login + ENS and recording over IPFS.", XDc = {
  "@calcom/lib": "workspace:*"
}, JDc = {
  "@calcom/types": "workspace:*"
}, QDc = {
  private: !0,
  name: HDc,
  version: YDc,
  main: KDc,
  description: ZDc,
  dependencies: XDc,
  devDependencies: JDc
}, Vpe = {
  name: "Huddle01",
  description: QDc.description,
  installed: !0,
  type: "huddle01_video",
  variant: "conferencing",
  categories: ["video", "conferencing"],
  logo: "icon.svg",
  publisher: "huddle01.com",
  url: "https://huddle01.com",
  category: "conferencing",
  slug: "huddle01",
  title: "Huddle01",
  isGlobal: !1,
  email: "support@huddle01.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:huddle01_video",
      label: "Huddle01 Video"
    }
  },
  dirName: "huddle01video",
  concurrentMeetings: !0,
  isOAuth: !1
}, e3c = "ICS Feed", t3c = "ICS Feed", n3c = "ics-feed", o3c = "ics-feedcalendar", r3c = "ics-feed_calendar", i3c = "icon.svg", a3c = "calendar", s3c = [
  "calendar"
], c3c = "Cal.com, Inc.", l3c = "help@cal.com", u3c = "Import events from an ICS Feed into [Cal.com](https://cal.com).", d3c = !1, _3c = !0, p3c = {
  name: e3c,
  title: t3c,
  slug: n3c,
  dirName: o3c,
  type: r3c,
  logo: i3c,
  variant: a3c,
  categories: s3c,
  publisher: c3c,
  email: l3c,
  description: u3c,
  isTemplate: d3c,
  __createdUsingCli: _3c
}, m3c = "Insihts", f3c = "insihts", g3c = "insihts_analytics", h3c = "icon.svg", v3c = "https://cal.com/", b3c = "analytics", y3c = [
  "analytics"
], $3c = "Cal.com, Inc.", w3c = "help@cal.com", k3c = "Insihts is an all-in-one platform for businesses looking to track user behavior, optimize workflows, and make data-driven decisions. Whether you are a marketer, product manager, or part of a customer success team, Insihts provides the tools you need to succeed.", S3c = "EventType", E3c = {
  tag: {
    scripts: [
      {
        src: "https://collector.insihts.com/script.js",
        attrs: {
          "data-website-id": "{SITE_ID}"
        }
      }
    ]
  }
}, x3c = !1, C3c = !0, T3c = "booking-pages-tag", Bpe = {
  name: m3c,
  slug: f3c,
  type: g3c,
  logo: h3c,
  url: v3c,
  variant: b3c,
  categories: y3c,
  publisher: $3c,
  email: w3c,
  description: k3c,
  extendsFeature: S3c,
  appData: E3c,
  isTemplate: x3c,
  __createdUsingCli: C3c,
  __template: T3c
}, A3c = "Intercom", I3c = "intercom", O3c = "intercom_automation", N3c = "icon.svg", z3c = "https://github.com/vachmara", R3c = "automation", P3c = [
  "automation"
], D3c = "Valentin Chmara", L3c = "valentinchmara@gmail.com", M3c = "Enhance your scheduling and appointment management experience with the Intercom Integration for [Cal.com](https://cal.com).", F3c = !1, q3c = !0, j3c = "basic", V3c = "intercom", B3c = !0, U3c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: A3c,
  slug: I3c,
  type: O3c,
  logo: N3c,
  url: z3c,
  variant: R3c,
  categories: P3c,
  publisher: D3c,
  email: L3c,
  description: M3c,
  isTemplate: F3c,
  __createdUsingCli: q3c,
  __template: j3c,
  dirName: V3c,
  isOAuth: B3c
}, G3c = "Jelly", W3c = "jelly", H3c = "jelly_conferencing", Y3c = "icon.svg", K3c = "https://jellyjelly.com", Z3c = "conferencing", X3c = [
  "conferencing"
], J3c = "Jelly", Q3c = "support@jellyjelly.com", eLc = {
  location: {
    type: "integrations:{SLUG}_conferencing",
    label: "{TITLE}",
    linkType: "dynamic"
  }
}, tLc = "JellyPhone is a video calling tool with a stacked rolodex. You can cut short podcasts for Tik Tok and Instagram and publish in seconds. Connect with amazing people.", nLc = !1, oLc = !0, rLc = "event-type-location-video-static", Upe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: G3c,
  slug: W3c,
  type: H3c,
  logo: Y3c,
  url: K3c,
  variant: Z3c,
  categories: X3c,
  publisher: J3c,
  email: Q3c,
  appData: eLc,
  description: tLc,
  isTemplate: nLc,
  __createdUsingCli: oLc,
  __template: rLc
}, iLc = "@calcom/jitsivideo", aLc = "0.0.0", sLc = "./index.ts", cLc = "Jitsi is a free open-source video conferencing software for web and mobile. Make a call, launch on your own servers, integrate into your app, and more.", lLc = {
  "@calcom/lib": "workspace:*"
}, uLc = {
  "@calcom/types": "workspace:*"
}, dLc = {
  private: !0,
  name: iLc,
  version: aLc,
  main: sLc,
  description: cLc,
  dependencies: lLc,
  devDependencies: uLc
}, Gpe = {
  name: "Jitsi Video",
  description: dLc.description,
  installed: !0,
  type: "jitsi_video",
  variant: "conferencing",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Cal.com",
  url: "https://jitsi.org/",
  slug: "jitsi",
  title: "Jitsi Meet",
  isGlobal: !1,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:jitsi",
      label: "Jitsi Video"
    }
  },
  dirName: "jitsivideo",
  concurrentMeetings: !0,
  isOAuth: !1
}, _Lc = "https://json.schemastore.org/package.json", pLc = "@calcom/larkcalendar", mLc = "0.0.0", fLc = "./index.ts", gLc = "Lark Calendar is a time management and scheduling service developed by Lark. Allows users to create and edit events, with options available for type and time. Available to anyone that has a Lark account on both mobile and web versions.", hLc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, vLc = {
  "@calcom/types": "workspace:*"
}, bLc = {
  $schema: _Lc,
  private: !0,
  name: pLc,
  version: mLc,
  main: fLc,
  description: gLc,
  dependencies: hLc,
  devDependencies: vLc
}, yLc = {
  name: "Lark Calendar",
  description: bLc.description,
  installed: !0,
  type: "lark_calendar",
  title: "Lark Calendar",
  variant: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Lark",
  slug: "lark-calendar",
  url: "https://larksuite.com/",
  email: "alan@larksuite.com",
  dirName: "larkcalendar",
  isOAuth: !0
}, $Lc = "Lindy", wLc = "lindy", kLc = "lindy_automation", SLc = "icon-dark.svg", ELc = "https://www.lindy.ai/integrations/cal-com", xLc = "automation", CLc = [
  "automation"
], TLc = "Lindy", ALc = "flo@lindy.ai", ILc = "Build AI agents in minutes to automate workflows, save time and grow your business", OLc = !1, NLc = !0, zLc = "link-as-an-app", RLc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: $Lc,
  slug: wLc,
  type: kLc,
  logo: SLc,
  url: ELc,
  variant: xLc,
  categories: CLc,
  publisher: TLc,
  email: ALc,
  description: ILc,
  isTemplate: OLc,
  __createdUsingCli: NLc,
  __template: zLc
}, PLc = "Linear", DLc = "linear", LLc = "linear_other", MLc = "icon.svg", FLc = "https://linear.app", qLc = "other", jLc = [
  "other"
], VLc = "Linear", BLc = "support@linear.app", ULc = "Linear is a better way to build products. Connect your calendar to automate your status", GLc = !1, WLc = !0, HLc = [
  "google-calendar"
], YLc = "link-as-an-app", KLc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: PLc,
  slug: DLc,
  type: LLc,
  logo: MLc,
  url: FLc,
  variant: qLc,
  categories: jLc,
  publisher: VLc,
  email: BLc,
  description: ULc,
  isTemplate: GLc,
  __createdUsingCli: WLc,
  dependencies: HLc,
  __template: YLc
}, ZLc = "Make", XLc = "make", JLc = "make_automation", QLc = "icon.svg", eMc = "https://github.com/aar2dee2", tMc = "automation", nMc = [
  "automation"
], oMc = "aar2dee2", rMc = "support@cal.com", iMc = "From tasks and workflows to apps and systems, build and automate anything in one powerful visual platform.", aMc = !1, sMc = !0, cMc = "basic", lMc = "icon.svg", uMc = "make", dMc = !1, _Mc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: ZLc,
  slug: XLc,
  type: JLc,
  logo: QLc,
  url: eMc,
  variant: tMc,
  categories: nMc,
  publisher: oMc,
  email: rMc,
  description: iMc,
  isTemplate: aMc,
  __createdUsingCli: sMc,
  __template: cMc,
  imageSrc: lMc,
  dirName: uMc,
  isOAuth: dMc
}, pMc = "Matomo", mMc = "matomo", fMc = "matomo_analytics", gMc = "icon.svg", hMc = "https://cal.com/", vMc = "analytics", bMc = [
  "analytics"
], yMc = "Cal.com, Inc.", $Mc = "help@cal.com", wMc = "Google Analytics alternative that protects your data and your customers' privacy", kMc = "EventType", SMc = {
  tag: {
    scripts: [
      {
        src: "{MATOMO_URL}/matomo.js",
        attrs: {}
      },
      {
        content: `var _paq = window._paq || [];
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u='{MATOMO_URL}/';  
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '{SITE_ID}']);  
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
      })();`
      }
    ]
  }
}, EMc = !1, xMc = !0, CMc = "booking-pages-tag", Wpe = {
  name: pMc,
  slug: mMc,
  type: fMc,
  logo: gMc,
  url: hMc,
  variant: vMc,
  categories: bMc,
  publisher: yMc,
  email: $Mc,
  description: wMc,
  extendsFeature: kMc,
  appData: SMc,
  isTemplate: EMc,
  __createdUsingCli: xMc,
  __template: CMc
}, TMc = "Meta Pixel", AMc = "metapixel", IMc = "metapixel_analytics", OMc = "icon.svg", NMc = "https://github.com/regexyl", zMc = "analytics", RMc = [
  "analytics"
], PMc = "Regina Liu", DMc = "info@regexyl.com", LMc = "Add Meta Pixel to your bookings page to measure, optimize and build audiences for your ad campaigns.", MMc = "EventType", FMc = !1, qMc = !0, jMc = "event-type-app-card", VMc = {
  tag: {
    scripts: [
      {
        content: "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','{TRACKING_ID}');fbq('trackCustom','CalcomView');"
      }
    ]
  }
}, BMc = !1, Hpe = {
  name: TMc,
  slug: AMc,
  type: IMc,
  logo: OMc,
  url: NMc,
  variant: zMc,
  categories: RMc,
  publisher: PMc,
  email: DMc,
  description: LMc,
  extendsFeature: MMc,
  isTemplate: FMc,
  __createdUsingCli: qMc,
  __template: jMc,
  appData: VMc,
  isOAuth: BMc
}, UMc = "Millis AI", GMc = "millis-ai", WMc = "millis-ai_automation", HMc = "icon.png", YMc = "https://docs.millis.ai/tutorials/create-voice-agent-for-appointment-scheduling", KMc = "automation", ZMc = [
  "automation"
], XMc = "Millis AI", JMc = "thach@millis.ai", QMc = "Build next-gen voice agents with 500ms latency\r", e4c = !1, t4c = !0, n4c = "link-as-an-app", o4c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: UMc,
  slug: GMc,
  type: WMc,
  logo: HMc,
  url: YMc,
  variant: KMc,
  categories: ZMc,
  publisher: XMc,
  email: JMc,
  description: QMc,
  isTemplate: e4c,
  __createdUsingCli: t4c,
  __template: n4c
}, r4c = "Mirotalk", i4c = "mirotalk", a4c = "mirotalk_video", s4c = "icon.svg", c4c = "https://cal.com/", l4c = "conferencing", u4c = [
  "conferencing"
], d4c = "Cal.com, Inc.", _4c = "support@cal.com", p4c = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://p2p.mirotalk.com/join/80085ShinyPhone",
    urlRegExp: "^(http|https):\\/\\/(p2p|sfu)\\.mirotalk\\.com\\/join\\/[a-zA-Z0-9._-]+$"
  }
}, m4c = "Peer to peer real-time video conferences, optimized for small groups. Unlimited time, unlimited rooms each having 5-8 participants.", f4c = !1, g4c = !0, h4c = "event-type-location-video-static", v4c = "mirotalk", b4c = !1, Ype = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: r4c,
  slug: i4c,
  type: a4c,
  logo: s4c,
  url: c4c,
  variant: l4c,
  categories: u4c,
  publisher: d4c,
  email: _4c,
  appData: p4c,
  description: m4c,
  isTemplate: f4c,
  __createdUsingCli: g4c,
  __template: h4c,
  dirName: v4c,
  isOAuth: b4c
}, y4c = "Mock Payment App", $4c = "mock-payment-app", w4c = "mock-payment-app_payment", k4c = "icon.svg", S4c = "https://example.com/link", E4c = "payment", x4c = [
  "payment"
], C4c = "Intuita", T4c = "greg@intuita.io", A4c = "The mock payment app for tests", I4c = !1, O4c = !0, N4c = "basic", z4c = "mock-payment-app", R4c = "EventType", P4c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: y4c,
  slug: $4c,
  type: w4c,
  logo: k4c,
  url: S4c,
  variant: E4c,
  categories: x4c,
  publisher: C4c,
  email: T4c,
  description: A4c,
  isTemplate: I4c,
  __createdUsingCli: O4c,
  __template: N4c,
  dirName: z4c,
  extendsFeature: R4c
}, D4c = "Monobot CX", L4c = "monobot", M4c = "monobot_automation", F4c = "icon.svg", q4c = "https://monobot.ai/?ref=cal.com", j4c = "automation", V4c = [
  "automation"
], B4c = "Monobot CX", U4c = "contact@monobot.ai", G4c = "Crafting your personalized AI-driven assistant is easy and fast.", W4c = !1, H4c = !0, Y4c = "link-as-an-app", K4c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: D4c,
  slug: L4c,
  type: M4c,
  logo: F4c,
  url: q4c,
  variant: j4c,
  categories: V4c,
  publisher: B4c,
  email: U4c,
  description: G4c,
  isTemplate: W4c,
  __createdUsingCli: H4c,
  __template: Y4c
}, Z4c = "n8n", X4c = "n8n", J4c = "n8n_automation", Q4c = "icon.svg", e5c = "https://cal.com/", t5c = "automation", n5c = [
  "automation"
], o5c = "Cal.com, Inc.", r5c = "help@cal.com", i5c = "Automate without limits. The workflow automation platform that doesn't box you in, that you never outgrow", a5c = !0, s5c = !1, c5c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Z4c,
  slug: X4c,
  type: J4c,
  logo: Q4c,
  url: e5c,
  variant: t5c,
  categories: n5c,
  publisher: o5c,
  email: r5c,
  description: i5c,
  __createdUsingCli: a5c,
  isOAuth: s5c
}, l5c = "Nextcloud Talk", u5c = "nextcloudtalk", d5c = "nextcloudtalk_video", _5c = "icon.svg", p5c = "https://nextcloud.com/talk", m5c = "conferencing", f5c = [
  "conferencing"
], g5c = "Cal.com", h5c = "help@cal.com", v5c = {
  location: {
    type: "integrations:{SLUG}_conferencing",
    label: "{TITLE}",
    linkType: "dynamic"
  }
}, b5c = "Nextcloud Talk is a fully self hosted, on-premises audio/video and chat communication service. It features web and mobile apps and is designed to offer the highest degree of security while being easy to use.", y5c = !1, $5c = !0, Kpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: l5c,
  slug: u5c,
  type: d5c,
  logo: _5c,
  url: p5c,
  variant: m5c,
  categories: f5c,
  publisher: g5c,
  email: h5c,
  appData: v5c,
  description: b5c,
  isTemplate: y5c,
  __createdUsingCli: $5c
}, w5c = "https://json.schemastore.org/package.json", k5c = "@calcom/office365calendar", S5c = "0.0.0", E5c = "./index.ts", x5c = "Microsoft Office 365 is a suite of apps that helps you stay connected with others and get things done. It includes but is not limited to Microsoft Word, PowerPoint, Excel, Teams, OneNote and OneDrive. Office 365 allows you to work remotely with others on a team and collaborate in an online environment. Both web versions and desktop/mobile applications are available.", C5c = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  msw: "^2.7.0"
}, T5c = {
  "@calcom/types": "workspace:*"
}, A5c = {
  $schema: w5c,
  private: !0,
  name: k5c,
  version: S5c,
  main: E5c,
  description: x5c,
  dependencies: C5c,
  devDependencies: T5c
}, I5c = {
  name: "Outlook Calendar",
  description: A5c.description,
  type: "office365_calendar",
  title: "Outlook Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "office365-calendar",
  dirName: "office365calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  isOAuth: !0
}, O5c = "Microsoft 365/Teams (Requires work/school account)", N5c = "Microsoft Teams is a business communication platform and collaborative workspace included in Microsoft 365. It offers workspace chat and video conferencing, file storage, and application integration. Both web versions and desktop/mobile applications are available. NOTE: MUST HAVE A WORK / SCHOOL ACCOUNT", z5c = "office365_video", R5c = "conferencing", P5c = "icon.svg", D5c = "Cal.com", L5c = "https://www.microsoft.com/en-ca/microsoft-teams/group-chat-software", M5c = !0, F5c = 4.3, q5c = 69, j5c = [
  "conferencing"
], V5c = "msteams", B5c = "MS Teams (Requires work/school account)", U5c = !0, G5c = "help@cal.com", W5c = {
  location: {
    linkType: "dynamic",
    type: "integrations:office365_video",
    label: "MS Teams"
  }
}, H5c = "office365video", Y5c = [
  "office365-calendar"
], K5c = !0, Z5c = !0, Zpe = {
  name: O5c,
  description: N5c,
  type: z5c,
  variant: R5c,
  logo: P5c,
  publisher: D5c,
  url: L5c,
  verified: M5c,
  rating: F5c,
  reviews: q5c,
  categories: j5c,
  slug: V5c,
  title: B5c,
  trending: U5c,
  email: G5c,
  appData: W5c,
  dirName: H5c,
  dependencies: Y5c,
  concurrentMeetings: K5c,
  isOAuth: Z5c
}, X5c = "Paypal", J5c = "paypal", Q5c = "paypal_payment", e6c = "icon.svg", t6c = "https://paypal.com", n6c = "payment", o6c = [
  "payment"
], r6c = "Cal.com", i6c = "support@cal.com", a6c = "Paypal payment app by [Cal.com](https://cal.com)", s6c = "EventType", c6c = !1, l6c = !0, u6c = "icon.svg", d6c = "event-type-app-card", _6c = "paypal", p6c = !0, m6c = {
  name: X5c,
  slug: J5c,
  type: Q5c,
  logo: e6c,
  url: t6c,
  variant: n6c,
  categories: o6c,
  publisher: r6c,
  email: i6c,
  description: a6c,
  extendsFeature: s6c,
  isTemplate: c6c,
  __createdUsingCli: l6c,
  imageSrc: u6c,
  __template: d6c,
  dirName: _6c,
  isOAuth: p6c
}, f6c = "Ping.gg", g6c = "Ping.gg", h6c = "ping", v6c = "ping_video", b6c = "icon.svg", y6c = "https://ping.gg", $6c = "conferencing", w6c = [
  "conferencing"
], k6c = "Ping.gg", S6c = "support@ping.gg", E6c = "Ping.gg makes high quality video collaborations easier than ever. Think 'Zoom for streamers and creators'. Join a call in 3 clicks, manage audio and video like a pro, and copy-paste your guests straight into OBS", x6c = !0, C6c = {
  location: {
    linkType: "static",
    type: "integrations:ping_video",
    label: "Ping.gg",
    organizerInputPlaceholder: "https://www.ping.gg/call/theo",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?ping.gg\\/call\\/[a-zA-Z0-9]*"
  }
}, T6c = !1, Xpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: f6c,
  title: g6c,
  slug: h6c,
  type: v6c,
  logo: b6c,
  url: y6c,
  variant: $6c,
  categories: w6c,
  publisher: k6c,
  email: S6c,
  description: E6c,
  __createdUsingCli: x6c,
  appData: C6c,
  isOAuth: T6c
}, A6c = "Pipedream", I6c = "pipedream", O6c = "pipedream_automation", N6c = "icon.svg", z6c = "https://pipedream.com/apps/cal-com", R6c = "automation", P6c = [
  "automation"
], D6c = "Pipedream, Inc.", L6c = "support@pipedream.com", M6c = "Connect APIs, remarkably fast. Stop writing boilerplate code, struggling with authentication and managing infrastructure. Start connecting APIs with code-level control when you need it — and no code when you don't", F6c = !0, q6c = !1, j6c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: A6c,
  slug: I6c,
  type: O6c,
  logo: N6c,
  url: z6c,
  variant: R6c,
  categories: P6c,
  publisher: D6c,
  email: L6c,
  description: M6c,
  __createdUsingCli: F6c,
  isOAuth: q6c
}, V6c = "Pipedrive CRM", B6c = "pipedrive-crm", U6c = "pipedrive-crm_crm", G6c = "icon.svg", W6c = "https://revert.dev", H6c = "crm", Y6c = [
  "crm"
], K6c = "EventType", Z6c = "Revert.dev ", X6c = "jatin@revert.dev", J6c = "Founded in 2010, Pipedrive is an easy and effective sales CRM that drives small business growth.\r\rToday, Pipedrive is used by revenue teams at more than 100,000 companies worldwide. Pipedrive is headquartered in New York and has offices across Europe and the US.\r\rThe company is backed by majority holder Vista Equity Partners, Bessemer Venture Partners, Insight Partners, Atomico, and DTCP.\r\rLearn more at www.pipedrive.com.", Q6c = !1, eFc = !0, tFc = "basic", nFc = "pipedrive-crm", oFc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: V6c,
  slug: B6c,
  type: U6c,
  logo: G6c,
  url: W6c,
  variant: H6c,
  categories: Y6c,
  extendsFeature: K6c,
  publisher: Z6c,
  email: X6c,
  description: J6c,
  isTemplate: Q6c,
  __createdUsingCli: eFc,
  __template: tFc,
  dirName: nFc
}, rFc = "Plausible", iFc = "plausible", aFc = "plausible_analytics", sFc = "icon.svg", cFc = "https://cal.com/", lFc = "analytics", uFc = [
  "analytics"
], dFc = "Cal.com, Inc.", _Fc = "help@cal.com", pFc = "EventType", mFc = {
  tag: {
    scripts: [
      {
        src: "{PLAUSIBLE_URL}",
        attrs: {
          "data-domain": "{TRACKING_ID}"
        }
      }
    ]
  }
}, fFc = "Simple, privacy-friendly Google Analytics alternative.", gFc = !0, hFc = !1, Jpe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: rFc,
  slug: iFc,
  type: aFc,
  logo: sFc,
  url: cFc,
  variant: lFc,
  categories: uFc,
  publisher: dFc,
  email: _Fc,
  extendsFeature: pFc,
  appData: mFc,
  description: fFc,
  __createdUsingCli: gFc,
  isOAuth: hFc
}, vFc = "Posthog", bFc = "posthog", yFc = "posthog_analytics", $Fc = "icon.svg", wFc = "https://posthog.com", kFc = "analytics", SFc = [
  "analytics"
], EFc = "Cal.com, Inc.", xFc = "help@cal.com", CFc = "PostHog is the all-in-one platform for building better products - with product analytics, feature flags, session recordings, a/b testing, heatmaps, and more.", TFc = "EventType", AFc = {
  tag: {
    scripts: [
      {
        content: "!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split('.');2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement('script')).type='text/javascript',p.async=!0,p.src=s.api_host.replace('.i.posthog.com','-assets.i.posthog.com')+'/static/array.js',(r=t.getElementsByTagName('script')[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a='posthog',u.people=u.people||[],u.toString=function(t){var e='posthog';return'posthog'!==a&&(e+='.'+a),t||(e+=' (stub)'),e},u.people.toString=function(){return u.toString(1)+'.people (stub)'},o='capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId'.split(' '),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);posthog.init('{TRACKING_ID}',{api_host:'{API_HOST}'})"
      }
    ]
  }
}, IFc = !1, OFc = !0, NFc = "booking-pages-tag", Qpe = {
  name: vFc,
  slug: bFc,
  type: yFc,
  logo: $Fc,
  url: wFc,
  variant: kFc,
  categories: SFc,
  publisher: EFc,
  email: xFc,
  description: CFc,
  extendsFeature: TFc,
  appData: AFc,
  isTemplate: IFc,
  __createdUsingCli: OFc,
  __template: NFc
}, zFc = "QR Code", RFc = "qr_code", PFc = "qr_code_other", DFc = "icon.svg", LFc = "https://cal.com/", MFc = "other", FFc = [
  "other"
], qFc = "EventType", jFc = "Cal.com, Inc.", VFc = "support@cal.com", BFc = "Easily generate a QR code for your links to print, share, or embed.", UFc = !0, GFc = !1, WFc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: zFc,
  slug: RFc,
  type: PFc,
  logo: DFc,
  url: LFc,
  variant: MFc,
  categories: FFc,
  extendsFeature: qFc,
  publisher: jFc,
  email: VFc,
  description: BFc,
  __createdUsingCli: UFc,
  isOAuth: GFc
}, HFc = "Raycast", YFc = "raycast", KFc = "raycast_other", ZFc = "icon.svg", XFc = "https://github.com/eluce2", JFc = "other", QFc = [
  "automation"
], eqc = "Eric Luce", tqc = "info@restlessmindstech.com", nqc = "Quickly share your [Cal.com](https://cal.com) meeting links with Raycast", oqc = !0, rqc = !1, iqc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: HFc,
  slug: YFc,
  type: KFc,
  logo: ZFc,
  url: XFc,
  variant: JFc,
  categories: QFc,
  publisher: eqc,
  email: tqc,
  description: nqc,
  __createdUsingCli: oqc,
  isOAuth: rqc
}, aqc = "Retell AI", sqc = "retell-ai", cqc = "retell-ai_automation", lqc = "icon-dark.svg", uqc = "https://go.cal.com/retellai", dqc = "automation", _qc = [
  "automation"
], pqc = "Retell AI", mqc = "founders@retellai.com", fqc = "Supercharge your Call Operations with AI \r", gqc = !1, hqc = !0, vqc = "link-as-an-app", bqc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: aqc,
  slug: sqc,
  type: cqc,
  logo: lqc,
  url: uqc,
  variant: dqc,
  categories: _qc,
  publisher: pqc,
  email: mqc,
  description: fqc,
  isTemplate: gqc,
  __createdUsingCli: hqc,
  __template: vqc
}, yqc = "Riverside", $qc = "riverside", wqc = "riverside_video", kqc = "icon-dark.svg", Sqc = "https://cal.com/", Eqc = "conferencing", xqc = [
  "conferencing"
], Cqc = "Cal.com, Inc.", Tqc = "help@cal.com", Aqc = "Your online recording studio. The easiest way to record podcasts and videos in studio quality from anywhere. All from the browser.", Iqc = !0, Oqc = {
  location: {
    label: "Riverside Video",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?riverside.fm\\/studio\\/[a-zA-Z0-9]*",
    type: "integrations:riverside_video",
    linkType: "static"
  }
}, Nqc = !1, eme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: yqc,
  slug: $qc,
  type: wqc,
  logo: kqc,
  url: Sqc,
  variant: Eqc,
  categories: xqc,
  publisher: Cqc,
  email: Tqc,
  description: Aqc,
  __createdUsingCli: Iqc,
  appData: Oqc,
  isOAuth: Nqc
}, zqc = "Roam", Rqc = "roam", Pqc = "roam_conferencing", Dqc = "icon.png", Lqc = "https://ro.am", Mqc = "conferencing", Fqc = [
  "conferencing"
], qqc = "Roam HQ, Inc.", jqc = "support@ro.am", Vqc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://ro.am/r/#/p/yHwFBQrRTMuptqKYo_wu8A/huzRiHnR-np4RGYKV-c0pQ",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?ro.am\\/[a-zA-Z0-9]*"
  }
}, Bqc = "Roam is Your Whole Company in one HQ\r", Uqc = !1, Gqc = !0, Wqc = "event-type-location-video-static", tme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: zqc,
  slug: Rqc,
  type: Pqc,
  logo: Dqc,
  url: Lqc,
  variant: Mqc,
  categories: Fqc,
  publisher: qqc,
  email: jqc,
  appData: Vqc,
  description: Bqc,
  isTemplate: Uqc,
  __createdUsingCli: Gqc,
  __template: Wqc
}, Hqc = "Routing", Yqc = "Routing", Kqc = !0, Zqc = "routing-forms", Xqc = "routing-forms_other", Jqc = "icon-dark.svg", Qqc = "https://cal.com/resources/feature/routing-forms", ejc = "other", tjc = [
  "automation"
], njc = "Cal.com, Inc.", ojc = "/routing", rjc = "help@cal.com", ijc = !0, ajc = {
  upgradeUrl: "/routing"
}, sjc = "It would allow a booker to connect with the right person or choose the right event, faster. It would work by taking inputs from the booker and using that data to route to the correct booker/event as configured by Cal user", cjc = !0, ljc = !1, ujc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Hqc,
  title: Yqc,
  isGlobal: Kqc,
  slug: Zqc,
  type: Xqc,
  logo: Jqc,
  url: Qqc,
  variant: ejc,
  categories: tjc,
  publisher: njc,
  simplePath: ojc,
  email: rjc,
  licenseRequired: ijc,
  teamsPlanRequired: ajc,
  description: sjc,
  __createdUsingCli: cjc,
  isOAuth: ljc
}, djc = "Salesforce", _jc = "salesforce", pjc = "salesforce_crm", mjc = "icon.png", fjc = "https://cal.com/", gjc = "crm", hjc = [
  "crm"
], vjc = "EventType", bjc = "Cal.com, Inc.", yjc = "help@cal.com", $jc = "Salesforce (Sales Cloud) is a cloud-based application designed to help your salespeople sell smarter and faster by centralizing customer information, logging their interactions with your company, and automating many of the tasks salespeople do every day.", wjc = !0, kjc = !0, Sjc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: djc,
  slug: _jc,
  type: pjc,
  logo: mjc,
  url: fjc,
  variant: gjc,
  categories: hjc,
  extendsFeature: vjc,
  publisher: bjc,
  email: yjc,
  description: $jc,
  __createdUsingCli: wjc,
  isOAuth: kjc
}, Ejc = "Salesroom", xjc = "salesroom", Cjc = "salesroom_conferencing", Tjc = "icon.svg", Ajc = "https://salesroom.com/", Ijc = "conferencing", Ojc = [
  "conferencing"
], Njc = "Cal.com, Inc.", zjc = "support@cal.com", Rjc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://user.sr.chat",
    urlRegExp: "^https:\\/\\/.+\\.sr\\.chat"
  }
}, Pjc = "Unlock real-time AI and take your sales game to the next level", Djc = !1, Ljc = !0, Mjc = "event-type-location-video-static", nme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Ejc,
  slug: xjc,
  type: Cjc,
  logo: Tjc,
  url: Ajc,
  variant: Ijc,
  categories: Ojc,
  publisher: Njc,
  email: zjc,
  appData: Rjc,
  description: Pjc,
  isTemplate: Djc,
  __createdUsingCli: Ljc,
  __template: Mjc
}, Fjc = "Sendgrid", qjc = "sendgrid", jjc = "sendgrid_other_calendar", Vjc = "logo.png", Bjc = "https://cal.com/", Ujc = "other_calendar", Gjc = [
  "other"
], Wjc = "Cal.com, Inc.", Hjc = "help@cal.com", Yjc = "SendGrid delivers your transactional and marketing emails through the world's largest cloud-based email delivery platform.", Kjc = !0, Zjc = !1, Xjc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Fjc,
  slug: qjc,
  type: jjc,
  logo: Vjc,
  url: Bjc,
  variant: Ujc,
  categories: Gjc,
  publisher: Wjc,
  email: Hjc,
  description: Yjc,
  __createdUsingCli: Kjc,
  isOAuth: Zjc
}, Jjc = "Shimmer Video", Qjc = "shimmervideo", eVc = "shimmer_video", tVc = "icon.png", nVc = "https://shimmer.care", oVc = "conferencing", rVc = [
  "conferencing"
], iVc = "Shimmer.care", aVc = "support@shimmer.care", sVc = "The #1 Expert ADHD Coach. Weekly calls and in-app support so that you can reach your full potential", cVc = !1, lVc = !0, uVc = "basic", dVc = {
  location: {
    linkType: "dynamic",
    type: "integrations:shimmer_video",
    label: "Shimmer Video"
  }
}, ome = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Jjc,
  slug: Qjc,
  type: eVc,
  logo: tVc,
  url: nVc,
  variant: oVc,
  categories: rVc,
  publisher: iVc,
  email: aVc,
  description: sVc,
  isTemplate: cVc,
  __createdUsingCli: lVc,
  __template: uVc,
  appData: dVc
}, _Vc = "Signal", pVc = "signal", mVc = "signal_video", fVc = "icon.svg", gVc = "https://cal.com/", hVc = "messaging", vVc = [
  "messaging"
], bVc = "Cal.com, Inc.", yVc = "support@cal.com", $Vc = "Schedule a chat with your guests or have a Signal Video call.", wVc = !0, kVc = {
  location: {
    type: "integrations:signal_video",
    label: "Signal",
    linkType: "static",
    organizerInputPlaceholder: "https://signal.me/#p/+11234567890",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?signal.me\\/[a-zA-Z0-9]*"
  }
}, SVc = !1, rme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: _Vc,
  slug: pVc,
  type: mVc,
  logo: fVc,
  url: gVc,
  variant: hVc,
  categories: vVc,
  publisher: bVc,
  email: yVc,
  description: $Vc,
  __createdUsingCli: wVc,
  appData: kVc,
  isOAuth: SVc
}, EVc = "Sirius Video", xVc = "sirius_video", CVc = "sirius_video_video", TVc = "icon-dark.svg", AVc = "https://cal.com/", IVc = "conferencing", OVc = [
  "conferencing"
], NVc = "Cal.com, Inc.", zVc = "support@cal.com", RVc = "Video meetings made for music.\rCreate your own virtual music classroom, easily.", PVc = !0, DVc = {
  location: {
    type: "integrations:sirius_video_video",
    label: "Sirius Video",
    linkType: "static",
    organizerInputPlaceholder: "https://sirius.video/sebastian",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?sirius.video\\/[a-zA-Z0-9]*"
  }
}, LVc = !1, ime = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: EVc,
  slug: xVc,
  type: CVc,
  logo: TVc,
  url: AVc,
  variant: IVc,
  categories: OVc,
  publisher: NVc,
  email: zVc,
  description: RVc,
  __createdUsingCli: PVc,
  appData: DVc,
  isOAuth: LVc
}, MVc = "Skype", FVc = "skype", qVc = "skype_conferencing", jVc = "icon.svg", VVc = "https://github.com/anikdhabal/", BVc = "conferencing", UVc = [
  "conferencing"
], GVc = "Anik Dhabal Babu", WVc = "adhabl2002@gmail.com", HVc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://join.skype.com/",
    urlRegExp: "https://join\\.skype\\.com/[a-zA-Z0-9]*"
  }
}, YVc = "Skype is for connecting with the people that matter most in your life and work. It's built for both one-on-one and group conversations and works wherever you are – via mobile, PC and Alexa. Skype messaging and HD voice and video calling will help you share experiences and get things done with others.", KVc = !1, ZVc = !0, XVc = "event-type-location-video-static", ame = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: MVc,
  slug: FVc,
  type: qVc,
  logo: jVc,
  url: VVc,
  variant: BVc,
  categories: UVc,
  publisher: GVc,
  email: WVc,
  appData: HVc,
  description: YVc,
  isTemplate: KVc,
  __createdUsingCli: ZVc,
  __template: XVc
}, JVc = "https://json.schemastore.org/package.json", QVc = "AGPLv3 (see LICENSE file)", eBc = "@calcom/stripepayment", tBc = "0.0.0", nBc = "./index.ts", oBc = "A Saas company a payment processing software, and application programming interfaces for e-commerce websites and mobile applications.", rBc = {
  downgrade: "ts-node ./downgrade.ts"
}, iBc = {
  "@calcom/app-store": "workspace:*",
  "@calcom/dayjs": "workspace:*",
  "@calcom/emails": "workspace:*",
  "@calcom/features": "workspace:*",
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/types": "workspace:*",
  "@stripe/react-stripe-js": "^1.10.0",
  "@stripe/stripe-js": "^1.35.0",
  stripe: "^9.16.0",
  uuid: "^8.3.2",
  zod: "^3.22.4"
}, aBc = {
  "@calcom/types": "workspace:*",
  "ts-node": "^10.9.1"
}, sBc = {
  $schema: JVc,
  private: !0,
  license: QVc,
  name: eBc,
  version: tBc,
  main: nBc,
  description: oBc,
  scripts: rBc,
  dependencies: iBc,
  devDependencies: aBc
}, cBc = {
  name: "Stripe",
  description: sBc.description,
  installed: !!(process.env.STRIPE_CLIENT_ID && process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY && process.env.STRIPE_PRIVATE_KEY),
  slug: "stripe",
  category: "payment",
  categories: ["payment"],
  logo: "icon.svg",
  publisher: "Cal.com",
  title: "Stripe",
  type: "stripe_payment",
  url: "https://cal.com/",
  docsUrl: "https://stripe.com/docs",
  variant: "payment",
  extendsFeature: "EventType",
  email: "help@cal.com",
  dirName: "stripepayment",
  isOAuth: !0
}, lBc = "Sylaps", uBc = "Sylaps", dBc = "sylapsvideo", _Bc = "sylaps_video", pBc = "icon.svg", mBc = "https://sylaps.com", fBc = "conferencing", gBc = [
  "conferencing"
], hBc = "Sylaps Inc", vBc = "support@sylaps.com", bBc = "Free Audio and Video Conferencing, Online Collaboration, Screen Sharing on web browser, mobile and desktop.", yBc = !0, $Bc = {
  location: {
    linkType: "dynamic",
    type: "integrations:sylaps_video",
    label: "Sylaps"
  }
}, wBc = !1, sme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: lBc,
  title: uBc,
  slug: dBc,
  type: _Bc,
  logo: pBc,
  url: mBc,
  variant: fBc,
  categories: gBc,
  publisher: hBc,
  email: vBc,
  description: bBc,
  __createdUsingCli: yBc,
  appData: $Bc,
  isOAuth: wBc
}, kBc = "Synthflow", SBc = "synthflow", EBc = "synthflow_automation", xBc = "icon.svg", CBc = "https://synthflow.ai/integrations/calcom", TBc = "automation", ABc = [
  "automation"
], IBc = "Synthflow.ai", OBc = "albert@synthflow.ai", NBc = "Effortless Human-Like AI Phone Calls and Scheduling", zBc = !1, RBc = !0, PBc = "link-as-an-app", DBc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: kBc,
  slug: SBc,
  type: EBc,
  logo: xBc,
  url: CBc,
  variant: TBc,
  categories: ABc,
  publisher: IBc,
  email: OBc,
  description: NBc,
  isTemplate: zBc,
  __createdUsingCli: RBc,
  __template: PBc
}, LBc = "@calcom/tandemvideo", MBc = "0.0.0", FBc = "./index.ts", qBc = "Tandem is a new virtual office space that allows teams to effortlessly connect as though they are in a physical office, online. Through co-working rooms, available statuses, live real-time video call, and chat options, you can see who’s around, talk and collaborate in one click. It works cross-platform with both desktop and mobile versions.", jBc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, VBc = {
  "@calcom/types": "workspace:*"
}, BBc = {
  private: !0,
  name: LBc,
  version: MBc,
  main: FBc,
  description: qBc,
  dependencies: jBc,
  devDependencies: VBc
}, cme = {
  name: "Tandem Video",
  description: BBc.description,
  type: "tandem_video",
  title: "Tandem Video",
  variant: "conferencing",
  categories: ["conferencing"],
  slug: "tandem",
  category: "conferencing",
  logo: "icon.svg",
  publisher: "",
  url: "",
  isGlobal: !1,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:tandem",
      label: "Tandem Video"
    }
  },
  dirName: "tandemvideo",
  isOAuth: !0
}, UBc = "Telegram", GBc = "telegram", WBc = "telegram_video", HBc = "icon.svg", YBc = "https://cal.com/", KBc = "messaging", ZBc = [
  "messaging"
], XBc = "Cal.com, Inc.", JBc = "support@cal.com", QBc = "Schedule a chat with your guests or have a Telegram Video call.", e9c = !0, t9c = {
  location: {
    type: "integrations:telegram_video",
    label: "Telegram",
    linkType: "static",
    organizerInputPlaceholder: "https://t.me/MyUsername",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?t.me\\/[a-zA-Z0-9]*"
  }
}, lme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: UBc,
  slug: GBc,
  type: WBc,
  logo: HBc,
  url: YBc,
  variant: KBc,
  categories: ZBc,
  publisher: XBc,
  email: JBc,
  description: QBc,
  __createdUsingCli: e9c,
  appData: t9c
}, n9c = "telli", o9c = "telli", r9c = "telli_automation", i9c = "icon-dark.svg", a9c = "https://www.telli.com/en/caldotcom", s9c = "automation", c9c = [
  "automation"
], l9c = "telli technologies GmbH", u9c = "founders@telli.so", d9c = "telli AI agents reach your customers, make calls independently & enhance your customer experience - fully integrated into [Cal.com](https://cal.com).", _9c = !1, p9c = !0, m9c = "link-as-an-app", f9c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: n9c,
  slug: o9c,
  type: r9c,
  logo: i9c,
  url: a9c,
  variant: s9c,
  categories: c9c,
  publisher: l9c,
  email: u9c,
  description: d9c,
  isTemplate: _9c,
  __createdUsingCli: p9c,
  __template: m9c
}, g9c = "Basic", h9c = "basic", v9c = "basic_other", b9c = "icon.svg", y9c = "https://example.com/link", $9c = "other", w9c = [
  "other"
], k9c = "Cal.com, Inc.", S9c = "support@cal.com", E9c = "It is a template for an app that can be installed and provides no other feature.", x9c = !0, C9c = !0, T9c = "link-as-an-app", A9c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: g9c,
  slug: h9c,
  type: v9c,
  logo: b9c,
  url: y9c,
  variant: $9c,
  categories: w9c,
  publisher: k9c,
  email: S9c,
  description: E9c,
  isTemplate: x9c,
  __createdUsingCli: C9c,
  __template: T9c
}, I9c = "Booking Pages Tag", O9c = "booking-pages-tag", N9c = "booking-pages-tag_analytics", z9c = "icon.svg", R9c = "https://example.com/link", P9c = "analytics", D9c = [
  "analytics"
], L9c = "Cal.com, Inc.", M9c = "support@cal.com", F9c = "It is a template demoing a Booking Pages tracking app like GA4, Fathom and Plausible.", q9c = "EventType", j9c = {
  tag: {
    scripts: [
      {
        src: "https://cdn.example.com/script.js",
        attrs: {
          "data-site": "{TRACKING_ID}"
        }
      }
    ]
  }
}, V9c = !0, B9c = !0, ume = {
  name: I9c,
  slug: O9c,
  type: N9c,
  logo: z9c,
  url: R9c,
  variant: P9c,
  categories: D9c,
  publisher: L9c,
  email: M9c,
  description: F9c,
  extendsFeature: q9c,
  appData: j9c,
  isTemplate: V9c,
  __createdUsingCli: B9c
}, U9c = "EventType AppCard", G9c = "event-type-app-card", W9c = "event-type-app-card_other", H9c = "icon.svg", Y9c = "https://example.com/link", K9c = "other", Z9c = [
  "other"
], X9c = "Cal.com, Inc.", J9c = "support@cal.com", Q9c = "A template showcasing how an app with EventType AppCard can be built e.g. Giphy, QR Code", eUc = "EventType", tUc = !0, nUc = !0, oUc = {
  name: U9c,
  slug: G9c,
  type: W9c,
  logo: H9c,
  url: Y9c,
  variant: K9c,
  categories: Z9c,
  publisher: X9c,
  email: J9c,
  description: Q9c,
  extendsFeature: eUc,
  isTemplate: tUc,
  __createdUsingCli: nUc
}, rUc = "EventType Location Video - Static", iUc = "event-type-location-video-static", aUc = "event-type-location-video-static_video", sUc = "icon.svg", cUc = "https://example.com/link", lUc = "conferencing", uUc = [
  "conferencing"
], dUc = "Cal.com Inc", _Uc = "support@cal.com", pUc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://video.app/mylink",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?video.app\\/[a-zA-Z0-9]*"
  }
}, mUc = "It is a template showing how to add a static URL EventType location e.g. Around, Whereby", fUc = !0, gUc = !0, dme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: rUc,
  slug: iUc,
  type: aUc,
  logo: sUc,
  url: cUc,
  variant: lUc,
  categories: uUc,
  publisher: dUc,
  email: _Uc,
  appData: pUc,
  description: mUc,
  isTemplate: fUc,
  __createdUsingCli: gUc
}, hUc = "General App Settings", vUc = "general-app-settings", bUc = "general-app-settings_other", yUc = "icon.svg", $Uc = "https://example.com/link", wUc = "other", kUc = [
  "other"
], SUc = "Cal.com Inc", EUc = "support@cal.com", xUc = "It is a template showing how an App can have settings in installed section that configures the app globally e.g. Weather in your Calendar", CUc = !0, TUc = !0, AUc = {
  name: hUc,
  slug: vUc,
  type: bUc,
  logo: yUc,
  url: $Uc,
  variant: wUc,
  categories: kUc,
  publisher: SUc,
  email: EUc,
  description: xUc,
  isTemplate: CUc,
  __createdUsingCli: TUc
}, IUc = "Link as An App", OUc = "link-as-an-app", NUc = "link-as-an-app_other", zUc = "icon.svg", RUc = "https://example.com/link", PUc = "other", DUc = [
  "other"
], LUc = "Cal.com, Inc.", MUc = "support@cal.com", FUc = "It's a template showing how an app, that is just a link to some webpage, can be made e.g. Pipedream, Amie, Vimcal.", qUc = !0, jUc = !0, VUc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: IUc,
  slug: OUc,
  type: NUc,
  logo: zUc,
  url: RUc,
  variant: PUc,
  categories: DUc,
  publisher: LUc,
  email: MUc,
  description: FUc,
  isTemplate: qUc,
  __createdUsingCli: jUc
}, BUc = "Twipla", UUc = "twipla", GUc = "twipla_analytics", WUc = "icon.svg", HUc = "https://cal.com/", YUc = "analytics", KUc = [
  "analytics"
], ZUc = "Cal.com, Inc.", XUc = "help@cal.com", JUc = "Twipla.com, formerly known as Visitor Analytics, is a website intelligence platform that helps you understand how visitors interact with your website.", QUc = "EventType", eGc = {
  tag: {
    scripts: [
      {
        content: `(function(v, i, s, a, t) {
  v[t] = v[t] || function() {
    (v[t].v = v[t].v || []).push(arguments);
  };
  if (!v._visaSettings) {
    v._visaSettings = {};
  }
  v._visaSettings[a] = {
    v: '1.0',
    s: a,
    a: '1',
    t: t
  };
  var b = i.getElementsByTagName('body')[0];
  var p = i.createElement('script');
  p.defer = 1;
  p.async = 1;
  p.src = s + '?s=' + a;
  b.appendChild(p);
})(window, document, '//app-worker.visitor-analytics.io/main.js', '{SITE_ID}', 'va');`
      }
    ]
  }
}, tGc = !1, nGc = !0, oGc = "booking-pages-tag", _me = {
  name: BUc,
  slug: UUc,
  type: GUc,
  logo: WUc,
  url: HUc,
  variant: YUc,
  categories: KUc,
  publisher: ZUc,
  email: XUc,
  description: JUc,
  extendsFeature: QUc,
  appData: eGc,
  isTemplate: tGc,
  __createdUsingCli: nGc,
  __template: oGc
}, rGc = "Umami", iGc = "umami", aGc = "umami_analytics", sGc = "icon.svg", cGc = "https://cal.com/", lGc = "analytics", uGc = [
  "analytics"
], dGc = "Cal.com, Inc.", _Gc = "help@cal.com", pGc = "Umami makes it easy to collect, analyze, and understand your web data — while maintaining visitor privacy and data ownership.", mGc = "EventType", fGc = {
  tag: {
    scripts: [
      {
        src: "{SCRIPT_URL}",
        attrs: {
          "data-website-id": "{SITE_ID}"
        }
      }
    ]
  }
}, gGc = !1, hGc = !0, vGc = "booking-pages-tag", pme = {
  name: rGc,
  slug: iGc,
  type: aGc,
  logo: sGc,
  url: cGc,
  variant: lGc,
  categories: uGc,
  publisher: dGc,
  email: _Gc,
  description: pGc,
  extendsFeature: mGc,
  appData: fGc,
  isTemplate: gGc,
  __createdUsingCli: hGc,
  __template: vGc
}, bGc = "Vimcal", yGc = "vimcal", $Gc = "vimcal_other", wGc = "icon.svg", kGc = "https://cal.com/", SGc = "other", EGc = [
  "calendar"
], xGc = "Cal.com, Inc.", CGc = "support@cal.com", TGc = "The world's fastest calendar, beautifully designed for a remote world\r", AGc = !0, IGc = [
  "google-calendar"
], OGc = !1, NGc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: bGc,
  slug: yGc,
  type: $Gc,
  logo: wGc,
  url: kGc,
  variant: SGc,
  categories: EGc,
  publisher: xGc,
  email: CGc,
  description: TGc,
  __createdUsingCli: AGc,
  dependencies: IGc,
  isOAuth: OGc
}, zGc = "https://json.schemastore.org/package.json", RGc = "@calcom/vital", PGc = "0.1.0", DGc = "./index.ts", LGc = "Connect your health data or wearables to trigger actions on your calendar.", MGc = {
  "@calcom/prisma": "workspace:*",
  "@tryvital/vital-node": "^1.4.6",
  queue: "^6.0.2"
}, FGc = {
  "@calcom/types": "workspace:*"
}, qGc = {
  $schema: zGc,
  private: !0,
  name: RGc,
  version: PGc,
  main: DGc,
  description: LGc,
  dependencies: MGc,
  devDependencies: FGc
}, jGc = {
  name: "Vital",
  description: qGc.description,
  installed: !0,
  category: "automation",
  categories: ["automation"],
  logo: "icon-dark.svg",
  label: "Vital",
  publisher: "Vital",
  slug: "vital-automation",
  title: "Vital",
  type: "vital_other",
  url: "https://tryvital.io",
  variant: "other",
  email: "support@tryvital.io",
  dirName: "vital",
  isOAuth: !0
}, VGc = "Weather in your Calendar", BGc = "weather_in_your_calendar", UGc = "weather_in_your_calendar_other", GGc = "icon.svg", WGc = "https://github.com/vejnoe", HGc = "other", YGc = [
  "other"
], KGc = "Andreas Vejnø Andersen", ZGc = "info@vejnoe.dk", XGc = "Get the local weather forecast with icons in your calendar\r\r", JGc = !0, QGc = !1, eWc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: VGc,
  slug: BGc,
  type: UGc,
  logo: GGc,
  url: WGc,
  variant: HGc,
  categories: YGc,
  publisher: KGc,
  email: ZGc,
  description: XGc,
  __createdUsingCli: JGc,
  isOAuth: QGc
}, tWc = "Webex", nWc = "Webex", oWc = "webex", rWc = "webex_video", iWc = "/icon.ico", aWc = "/icon.ico", sWc = "https://github.com/aar2dee2", cWc = "conferencing", lWc = [
  "conferencing"
], uWc = "aar2dee2", dWc = "support@cal.com", _Wc = "Create meetings with Cisco Webex", pWc = {
  location: {
    linkType: "dynamic",
    type: "integrations:webex_video",
    label: "Webex"
  }
}, mWc = !1, fWc = !0, gWc = "basic", hWc = !0, vWc = !0, mme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: tWc,
  title: nWc,
  slug: oWc,
  type: rWc,
  imageSrc: iWc,
  logo: aWc,
  url: sWc,
  variant: cWc,
  categories: lWc,
  publisher: uWc,
  email: dWc,
  description: _Wc,
  appData: pWc,
  isTemplate: mWc,
  __createdUsingCli: fWc,
  __template: gWc,
  concurrentMeetings: hWc,
  isAuth: vWc
}, bWc = "WhatsApp", yWc = "whatsapp", $Wc = "whatsapp_video", wWc = "icon.svg", kWc = "https://cal.com/", SWc = "messaging", EWc = [
  "messaging"
], xWc = "Cal.com, Inc.", CWc = "support@cal.com", TWc = "Schedule a chat with your guests or have a WhatsApp Video call.", AWc = !0, IWc = {
  location: {
    type: "integrations:whatsapp_video",
    label: "WhatsApp",
    linkType: "static",
    organizerInputPlaceholder: "https://wa.me/send?phone=1234567890",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?wa.me\\/[a-zA-Z0-9]*"
  }
}, OWc = !1, fme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: bWc,
  slug: yWc,
  type: $Wc,
  logo: wWc,
  url: kWc,
  variant: SWc,
  categories: EWc,
  publisher: xWc,
  email: CWc,
  description: TWc,
  __createdUsingCli: AWc,
  appData: IWc,
  isAuth: OWc
}, NWc = "Whereby", zWc = "Whereby", RWc = "whereby", PWc = "whereby_video", DWc = "icon-dark.svg", LWc = "https://cal.com/", MWc = "conferencing", FWc = [
  "conferencing"
], qWc = "Cal.com, Inc.", jWc = "help@cal.com", VWc = "Whereby makes it super simple for collaborating teams to jump on a video call.", BWc = !0, UWc = {
  location: {
    linkType: "static",
    type: "integrations:whereby_video",
    label: "Whereby Video",
    organizerInputPlaceholder: "https://www.whereby.com/cal",
    urlRegExp: "^(?:https?://)?(?:(?!.*-\\.)(?:\\w+(-\\w+)*\\.))*whereby\\.com(/[\\w\\-._~:?#\\[\\]@!$&'()*+,;%=]+)*$"
  }
}, GWc = !1, gme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: NWc,
  title: zWc,
  slug: RWc,
  type: PWc,
  logo: DWc,
  url: LWc,
  variant: MWc,
  categories: FWc,
  publisher: qWc,
  email: jWc,
  description: VWc,
  __createdUsingCli: BWc,
  appData: UWc,
  isAuth: GWc
}, WWc = "https://json.schemastore.org/package.json", HWc = "WipeMyCal", YWc = "0.1.0", KWc = "./index.ts", ZWc = "Wipe My Cal is a Cal.com exclusive app that redefines what it looks like to reschedule multiple meetings at the same time. Simply install the app, and select ‘Wipe’ for whatever date you need to mass reschedule. Handle emergencies, unexpected sick days and last minute events with the simple click of a button.", XWc = {
  "@calcom/prisma": "workspace:*",
  queue: "^6.0.2"
}, JWc = {
  "@calcom/types": "workspace:*"
}, cY = {
  $schema: WWc,
  private: !0,
  name: HWc,
  version: YWc,
  main: KWc,
  description: ZWc,
  dependencies: XWc,
  devDependencies: JWc
}, QWc = {
  name: cY.name,
  description: cY.description,
  installed: !0,
  category: "automation",
  categories: ["automation"],
  // If using static next public folder, can then be referenced from the base URL (/).
  logo: "icon-dark.svg",
  publisher: "Cal.com",
  slug: "wipe-my-cal",
  title: "Wipe my cal",
  type: "wipemycal_other",
  url: "https://cal.com/apps/wipe-my-cal",
  variant: "other",
  email: "help@cal.com",
  dirName: "wipemycalother",
  isOAuth: !1
}, e8c = "Wordpress", t8c = "wordpress", n8c = "wordpress_other", o8c = "icon-dark.svg", r8c = "https://github.com/calcom/wp-plugin", i8c = "other", a8c = [
  "other"
], s8c = "Cal.com, Inc.", c8c = "support@cal.com", l8c = "Embedded booking pages right into your wordpress page", u8c = !0, d8c = !1, _8c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: e8c,
  slug: t8c,
  type: n8c,
  logo: o8c,
  url: r8c,
  variant: i8c,
  categories: a8c,
  publisher: s8c,
  email: c8c,
  description: l8c,
  __createdUsingCli: u8c,
  isAuth: d8c
}, p8c = "https://json.schemastore.org/package.json", m8c = "@calcom/zapier", f8c = "0.0.0", g8c = "./index.ts", h8c = "Workflow automation for everyone. Use the Cal.com Zapier app to trigger your workflows when a booking is created, rescheduled, or cancelled, or after a meeting ends.", v8c = {
  "@calcom/lib": "workspace:*",
  "node-schedule": "2.1.0"
}, b8c = {
  "@calcom/types": "workspace:*",
  "@types/node-schedule": "^2.1.0"
}, y8c = {
  $schema: p8c,
  private: !0,
  name: m8c,
  version: f8c,
  main: g8c,
  description: h8c,
  dependencies: v8c,
  devDependencies: b8c
}, $8c = {
  name: "Zapier",
  description: y8c.description,
  installed: !0,
  category: "automation",
  categories: ["automation"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "zapier",
  title: "Zapier",
  type: "zapier_automation",
  url: "https://cal.com/apps/zapier",
  variant: "automation",
  email: "help@cal.com",
  dirName: "zapier",
  isOAuth: !1
}, w8c = "Zoho Bigin", k8c = "zoho-bigin", S8c = "zoho-bigin_crm", E8c = "zohobigin.svg", x8c = "https://github.com/ShaneMaglangit", C8c = "crm", T8c = [
  "crm"
], A8c = "EventType", I8c = "Shane Maglangit", O8c = "help@cal.com", N8c = "Bigin easily transforms your day-to-day customer processes into actionable pipelines. From qualifying leads to closing deals to managing important after-sales operations—Bigin connects your different teams to work together so that you can offer the best possible experience to your customers. Say goodbye to missing follow-ups, manual data entry, lack of team communication, and information silos.", z8c = !1, R8c = !0, P8c = "basic", D8c = "ZohoBigin.modules.events.ALL,ZohoBigin.modules.contacts.ALL", L8c = !0, M8c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: w8c,
  slug: k8c,
  type: S8c,
  logo: E8c,
  url: x8c,
  variant: C8c,
  categories: T8c,
  extendsFeature: A8c,
  publisher: I8c,
  email: O8c,
  description: N8c,
  isTemplate: z8c,
  __createdUsingCli: R8c,
  __template: P8c,
  scope: D8c,
  isOAuth: L8c
}, F8c = "Zoho Calendar", q8c = "Zoho Calendar is an online business calendar that makes scheduling easy for you. You can use it to stay on top of your schedule and also share calendars with your team to keep everyone on the same page.", j8c = "zohocalendar", V8c = "zoho_calendar", B8c = "Zoho Calendar", U8c = "calendar", G8c = "calendar", W8c = [
  "calendar"
], H8c = "icon.svg", Y8c = "Cal.com", K8c = "https://cal.com/", Z8c = "help@cal.com", X8c = !0, J8c = {
  name: F8c,
  description: q8c,
  slug: j8c,
  type: V8c,
  title: B8c,
  variant: U8c,
  category: G8c,
  categories: W8c,
  logo: H8c,
  publisher: Y8c,
  url: K8c,
  email: Z8c,
  isAuth: X8c
}, Q8c = "ZohoCRM", e7c = "zohocrm", t7c = "zohocrm_crm", n7c = "icon.svg", o7c = "https://github.com/jatinsandilya", r7c = "crm", i7c = [
  "crm"
], a7c = "EventType", s7c = "Jatin Sandilya", c7c = "help@cal.com", l7c = "Zoho CRM is a cloud-based application designed to help your salespeople sell smarter and faster by centralizing customer information, logging their interactions with your company, and automating many of the tasks salespeople do every day", u7c = !1, d7c = !0, _7c = "basic", p7c = !0, m7c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Q8c,
  slug: e7c,
  type: t7c,
  logo: n7c,
  url: o7c,
  variant: r7c,
  categories: i7c,
  extendsFeature: a7c,
  publisher: s7c,
  email: c7c,
  description: l7c,
  isTemplate: u7c,
  __createdUsingCli: d7c,
  __template: _7c,
  isOAuth: p7c
}, f7c = "@calcom/zoomvideo", g7c = "0.0.0", h7c = "./index.ts", v7c = "Zoom is a secure and reliable video platform that supports all of your online communication needs. It can provide everything from one on one meetings, chat, phone, webinars, and large-scale online events. Available with both desktop, web, and mobile versions.", b7c = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, y7c = {
  "@calcom/types": "workspace:*"
}, $7c = {
  private: !0,
  name: f7c,
  version: g7c,
  main: h7c,
  description: v7c,
  dependencies: b7c,
  devDependencies: y7c
}, hme = {
  linkType: "dynamic",
  name: "Zoom Video",
  description: $7c.description,
  type: "zoom_video",
  categories: ["conferencing"],
  variant: "conferencing",
  logo: "icon.svg",
  publisher: "Cal.com",
  url: "https://zoom.us/",
  category: "conferencing",
  slug: "zoom",
  title: "Zoom Video",
  email: "help@cal.com",
  appData: {
    location: {
      default: !1,
      linkType: "dynamic",
      type: "integrations:zoom",
      label: "Zoom Video"
    }
  },
  dirName: "zoomvideo",
  isOAuth: !0
}, w7c = {
  alby: WCc,
  amie: sTc,
  applecalendar: gTc,
  attio: ITc,
  autocheckin: UTc,
  "baa-for-hipaa": iAc,
  basecamp3: wAc,
  bolna: DAc,
  btcpayserver: XAc,
  caldavcalendar: a2c,
  campfire: Tpe,
  chatbase: z2c,
  clic: H2c,
  closecom: lIc,
  cron: EIc,
  dailyvideo: Ape,
  deel: HIc,
  demodesk: Ipe,
  dialpad: Ope,
  discord: Npe,
  dub: ZOc,
  eightxeight: zpe,
  "element-call": Rpe,
  elevenlabs: VNc,
  exchange2013calendar: ZNc,
  exchange2016calendar: rzc,
  exchangecalendar: bzc,
  facetime: Ppe,
  fathom: Dpe,
  feishucalendar: oRc,
  "fonio-ai": hRc,
  framer: ORc,
  ga4: Lpe,
  giphy: ePc,
  googlecalendar: lPc,
  googlevideo: Fpe,
  granola: OPc,
  "greetmate-ai": GPc,
  gtm: qpe,
  hitpay: SDc,
  "horizon-workrooms": jpe,
  hubspot: WDc,
  huddle01video: Vpe,
  "ics-feedcalendar": p3c,
  insihts: Bpe,
  intercom: U3c,
  jelly: Upe,
  jitsivideo: Gpe,
  larkcalendar: yLc,
  lindy: RLc,
  linear: KLc,
  make: _Mc,
  matomo: Wpe,
  metapixel: Hpe,
  "millis-ai": o4c,
  mirotalk: Ype,
  "mock-payment-app": P4c,
  monobot: K4c,
  n8n: c5c,
  nextcloudtalk: Kpe,
  office365calendar: I5c,
  office365video: Zpe,
  paypal: m6c,
  ping: Xpe,
  pipedream: j6c,
  "pipedrive-crm": oFc,
  plausible: Jpe,
  posthog: Qpe,
  qr_code: WFc,
  raycast: iqc,
  "retell-ai": bqc,
  riverside: eme,
  roam: tme,
  "routing-forms": ujc,
  salesforce: Sjc,
  salesroom: nme,
  sendgrid: Xjc,
  shimmervideo: ome,
  signal: rme,
  sirius_video: ime,
  skype: ame,
  stripepayment: cBc,
  sylapsvideo: sme,
  synthflow: DBc,
  tandemvideo: cme,
  telegram: lme,
  telli: f9c,
  basic: A9c,
  "booking-pages-tag": ume,
  "event-type-app-card": oUc,
  "event-type-location-video-static": dme,
  "general-app-settings": AUc,
  "link-as-an-app": VUc,
  twipla: _me,
  umami: pme,
  vimcal: NGc,
  vital: jGc,
  weather_in_your_calendar: eWc,
  webex: mme,
  whatsapp: fme,
  whereby: gme,
  wipemycalother: QWc,
  wordpress: _8c,
  zapier: $8c,
  "zoho-bigin": M8c,
  zohocalendar: J8c,
  zohocrm: m7c,
  zoomvideo: hme
};
function k7c(e, t) {
  const n = `${t.isTemplate ? "templates/" : ""}${t.dirName}`;
  let o = e;
  return !e.startsWith("/app-store/") && !/^https?/.test(e) && (o = `/app-store/${n}/${e}`), o;
}
const vme = (e) => {
  const t = "dirName" in e ? e.dirName : e.slug;
  if (!t)
    throw new Error(`Couldn't derive dirName for app ${e.name}`);
  const n = {
    appData: null,
    dirName: t,
    __template: "",
    ...e
  };
  return n.logo = k7c(n.logo, {
    dirName: t,
    isTemplate: n.isTemplate
  }), n;
}, bme = {};
for (const [e, t] of Object.entries(w7c))
  bme[e] = vme(t);
const yme = typeof window < "u" ? navigator.userAgent.indexOf("Mac") != -1 : !1, AC = process.env.NEXT_PUBLIC_MINTLIFY_CHAT_API_KEY, IC = process.env.NEXT_PUBLIC_CHAT_API_URL, S7c = async () => {
  if (!AC || !IC)
    return;
  const e = await fetch(`${IC}/topic`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${AC}`
    }
  });
  if (!e.ok)
    return;
  const t = await e.json();
  if (t && typeof t == "object" && "topicId" in t && typeof t.topicId == "string")
    return t.topicId;
}, E7c = async ({
  topicId: e,
  userQuery: t,
  onChunkReceived: n
}) => {
  if (!AC || !IC)
    return;
  const o = await fetch(
    `
${IC}/message`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${AC}`
      },
      body: JSON.stringify({ message: t, topicId: e })
    }
  );
  if (!o.ok || !o.body)
    throw Error(o.statusText);
  const r = o.body.getReader();
  for (; ; ) {
    const { done: i, value: a } = await r.read();
    if (i) {
      const c = new TextDecoder().decode(a);
      n(c, o.headers.get("X-Mintlify-Base-Url") ?? "", !0);
      return;
    }
    const s = new TextDecoder().decode(a);
    n(s);
  }
}, x7c = async (e, t, n) => {
  let o = null, r = "";
  try {
    if (n || (o = await S7c()), !o)
      return {
        id: o,
        error: "Error creating topic. Please try again later"
      };
    await E7c({
      topicId: o,
      onChunkReceived: e,
      userQuery: t
    });
  } catch (i) {
    i instanceof Error ? r = i.message : r = "k_bar_ai_error";
  }
  return {
    id: o,
    error: r
  };
}, C7c = (e) => {
  if (!("metadata" in e && e.metadata && "title" in e.metadata && "link" in e && typeof e.link == "string"))
    return "";
  const t = e.metadata.title, n = $me(e.link);
  if (t && typeof t == "string") {
    const o = t.toLowerCase().replaceAll(" ", "-").replaceAll(/[^a-zA-Z0-9-_#]/g, "");
    return `${n}#${o}`;
  }
  return n;
};
function T7c(e) {
  try {
    const t = JSON.parse(e ?? "[]"), n = new Map(
      t.map((o, r) => {
        const i = o.metadata.title ?? "", a = {
          citationNumber: r,
          title: o.metadata.title ?? "",
          url: C7c(o)
        };
        return [i, a];
      })
    );
    return Array.from(n.values());
  } catch {
    return [];
  }
}
function $me(e) {
  return e.startsWith("/") ? e : `/${e}`;
}
function A7c(e, t) {
  if (t.startsWith("https://"))
    return t;
  const n = $me(t);
  return `${e}${n}`;
}
const I7c = ({ searchText: e, aiResponse: t, setAiResponse: n }) => {
  const { t: o } = kt(), [r, i] = it(""), [a, s] = it(process.env.NEXT_PUBLIC_DOCS_URL ?? ""), [c, l] = it(!1), [u, d] = it(""), _ = (f, h, $) => {
    n((v) => v + f), h && s(h), $ && l(!1);
  }, p = T7c(t.split("||")[1]) ?? [], g = t.split("||")[0] ?? "";
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de(
      "div",
      {
        onClick: async () => {
          if (c)
            return;
          l(!0), n(""), d("");
          const { id: f, error: h } = await x7c(_, e, r);
          f ? i(f) : h && (l(!1), d(h));
        },
        className: xe(
          "hover:bg-subtle flex items-center gap-3 px-4 py-2 transition",
          c ? "cursor-not-allowed" : "cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(qt, { name: "star" }) }),
          /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ de("div", { children: [
              o("can_you_tell_me_about"),
              " ",
              /* @__PURE__ */ m("span", { className: "font-bold", children: e })
            ] }),
            /* @__PURE__ */ m("div", { className: "text-subtle text-sm", children: o("use_ai_to_answer_your_questions") })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ de("div", { className: "px-2 px-4 text-sm", children: [
      u && /* @__PURE__ */ m("p", { className: "mt-1 text-xs text-red-500", children: u }),
      c && t === "" ? /* @__PURE__ */ m(Tq, { children: /* @__PURE__ */ m(Yo, { className: "h-12 w-full" }) }) : /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("div", { dangerouslySetInnerHTML: { __html: QT(g) } }),
        /* @__PURE__ */ m("div", { className: "my-1 flex flex-wrap gap-2", children: a && p.map((f) => {
          if (f.title) {
            const h = A7c(a, f.url);
            return /* @__PURE__ */ m("a", { href: h, target: "_blank", children: /* @__PURE__ */ m("div", { className: "flex h-6 items-center gap-1 rounded-md bg-gray-100 px-1.5 text-xs text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700", children: f.title }) }, h);
          }
          return null;
        }) })
      ] })
    ] })
  ] });
}, O7c = Object.values(bme).map(({ name: e, slug: t }) => ({
  id: t,
  name: e,
  section: "Installable Apps",
  keywords: `app ${e}`
})), N7c = () => {
  var r;
  const e = Nr.useRouter(), { data: t } = hr.viewer.eventTypes.getEventTypesFromGroup.useInfiniteQuery(
    {
      limit: 10,
      group: { teamId: null, parentId: null }
    },
    {
      refetchOnWindowFocus: !1,
      staleTime: 1 * 60 * 60 * 1e3,
      getNextPageParam: (i) => i.nextCursor
    }
  ), n = ((r = t == null ? void 0 : t.pages) == null ? void 0 : r.flatMap((i) => {
    var a;
    return ((a = i == null ? void 0 : i.eventTypes) == null ? void 0 : a.map((s) => ({
      id: `event-type-${s.id}`,
      name: s.title,
      section: "event_types_page_title",
      keywords: "event types",
      perform: () => e.push(`/event-types/${s.id}`)
    }))) ?? [];
  })) ?? [], o = n != null && n.length ? n : [];
  return Bp.useRegisterActions(o);
}, z7c = ({ children: e }) => {
  const t = Nr.useRouter(), n = vn(() => {
    const o = O7c.map((r) => ({
      ...r,
      perform: () => t.push(`/apps/${r.id}`)
    }));
    return [
      {
        id: "workflows",
        name: "workflows",
        section: "workflows",
        shortcut: ["w", "f"],
        keywords: "workflows automation",
        perform: () => t.push("/workflows")
      },
      {
        id: "event-types",
        name: "event_types_page_title",
        section: "event_types_page_title",
        shortcut: ["e", "t"],
        keywords: "event types",
        perform: () => t.push("/event-types")
      },
      {
        id: "app-store",
        name: "app_store",
        section: "apps",
        shortcut: ["a", "s"],
        keywords: "app store",
        perform: () => t.push("/apps")
      },
      {
        id: "upcoming-bookings",
        name: "upcoming",
        section: "bookings",
        shortcut: ["u", "b"],
        keywords: "upcoming bookings",
        perform: () => t.push("/bookings/upcoming")
      },
      {
        id: "recurring-bookings",
        name: "recurring",
        section: "bookings",
        shortcut: ["r", "b"],
        keywords: "recurring bookings",
        perform: () => t.push("/bookings/recurring")
      },
      {
        id: "past-bookings",
        name: "past",
        section: "bookings",
        shortcut: ["p", "b"],
        keywords: "past bookings",
        perform: () => t.push("/bookings/past")
      },
      {
        id: "cancelled-bookings",
        name: "cancelled",
        section: "bookings",
        shortcut: ["c", "b"],
        keywords: "cancelled bookings",
        perform: () => t.push("/bookings/cancelled")
      },
      {
        id: "schedule",
        name: "availability",
        section: "availability",
        shortcut: ["s", "a"],
        keywords: "schedule availability",
        perform: () => t.push("/availability")
      },
      {
        id: "profile",
        name: "profile",
        section: "profile",
        shortcut: ["p", "s"],
        keywords: "setting profile",
        perform: () => t.push("/settings/my-account/profile")
      },
      {
        id: "avatar",
        name: "change_avatar",
        section: "profile",
        shortcut: ["c", "a"],
        keywords: "remove change modify avatar",
        perform: () => t.push("/settings/my-account/profile")
      },
      {
        id: "timezone",
        name: "timezone",
        section: "profile",
        shortcut: ["c", "t"],
        keywords: "change modify timezone",
        perform: () => t.push("/settings/my-account/general")
      },
      {
        id: "brand-color",
        name: "brand_color",
        section: "profile",
        shortcut: ["b", "c"],
        keywords: "change modify brand color",
        perform: () => t.push("/settings/my-account/appearance")
      },
      {
        id: "teams",
        name: "teams",
        shortcut: ["t", "s"],
        keywords: "add manage modify team",
        perform: () => t.push("/settings/teams")
      },
      {
        id: "password",
        name: "change_password",
        section: "security",
        shortcut: ["c", "p"],
        keywords: "change modify password",
        perform: () => t.push("/settings/security/password")
      },
      {
        id: "two-factor",
        name: "two_factor_auth",
        section: "security",
        shortcut: ["t", "f", "a"],
        keywords: "two factor authentication",
        perform: () => t.push("/settings/security/two-factor-auth")
      },
      {
        id: "impersonation",
        name: "user_impersonation_heading",
        section: "security",
        shortcut: ["u", "i"],
        keywords: "user impersonation",
        perform: () => t.push("/settings/security/impersonation")
      },
      {
        id: "license",
        name: "choose_a_license",
        section: "admin",
        shortcut: ["u", "l"],
        keywords: "license",
        perform: () => t.push("/auth/setup?step=1")
      },
      {
        id: "webhooks",
        name: "Webhooks",
        section: "developer",
        shortcut: ["w", "h"],
        keywords: "webhook automation",
        perform: () => t.push("/settings/developer/webhooks")
      },
      {
        id: "api-keys",
        name: "api_keys",
        section: "developer",
        shortcut: ["a", "p", "i"],
        keywords: "api keys",
        perform: () => t.push("/settings/developer/api-keys")
      },
      {
        id: "billing",
        name: "manage_billing",
        section: "billing",
        shortcut: ["m", "b"],
        keywords: "billing view manage",
        perform: () => t.push("/settings/billing")
      },
      ...o
    ];
  }, []);
  return /* @__PURE__ */ m(Bp.KBarProvider, { actions: n, children: e });
}, R7c = () => {
  const { t: e } = kt();
  N7c();
  const [t, n] = it(""), [o, r] = it(""), i = process.env.NEXT_PUBLIC_MINTLIFY_CHAT_API_KEY && process.env.NEXT_PUBLIC_CHAT_API_URL;
  return /* @__PURE__ */ m(Bp.KBarPortal, { children: /* @__PURE__ */ de(Bp.KBarPositioner, { className: "overflow-scroll", children: [
    /* @__PURE__ */ de(Bp.KBarAnimator, { className: "bg-default z-10 w-full max-w-screen-sm overflow-hidden rounded-md shadow-lg", children: [
      /* @__PURE__ */ de("div", { className: "border-subtle flex items-center justify-center border-b", children: [
        /* @__PURE__ */ m(qt, { name: "search", className: "text-default mx-3 h-4 w-4" }),
        /* @__PURE__ */ m(
          Bp.KBarSearch,
          {
            defaultPlaceholder: e("kbar_search_placeholder"),
            className: "bg-default placeholder:text-subtle text-default w-full rounded-sm py-2.5 focus-visible:outline-none",
            value: t,
            onChange: (a) => {
              n(a.currentTarget.value.trim()), o && r("");
            }
          }
        )
      ] }),
      i && t && /* @__PURE__ */ m(I7c, { aiResponse: o, setAiResponse: r, searchText: t }),
      /* @__PURE__ */ m(D7c, {}),
      /* @__PURE__ */ de("div", { className: "text-subtle border-subtle hidden items-center space-x-1 border-t px-2 py-1.5 text-xs sm:flex", children: [
        /* @__PURE__ */ m(qt, { name: "arrow-up", className: "h-4 w-4" }),
        /* @__PURE__ */ m(qt, { name: "arrow-down", className: "h-4 w-4" }),
        " ",
        /* @__PURE__ */ m("span", { className: "pr-2", children: e("navigate") }),
        /* @__PURE__ */ m(qt, { name: "corner-down-left", className: "h-4 w-4" }),
        /* @__PURE__ */ m("span", { className: "pr-2", children: e("open") }),
        yme ? /* @__PURE__ */ m(qt, { name: "command", className: "h-3 w-3" }) : "CTRL",
        /* @__PURE__ */ m("span", { className: "pr-1", children: "+ K " }),
        /* @__PURE__ */ m("span", { className: "pr-2", children: e("close") })
      ] })
    ] }),
    /* @__PURE__ */ m("div", { className: "z-1 fixed inset-0 bg-neutral-800 bg-opacity-70" })
  ] }) });
}, Rq = () => {
  const { query: e } = Bp.useKBar();
  return e ? /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(Sr, { side: "right", content: yme ? "⌘ + K" : "CTRL + K", children: /* @__PURE__ */ m(
    "button",
    {
      color: "minimal",
      onClick: e.toggle,
      className: "text-default hover:bg-subtle todesktop:hover:!bg-transparent lg:hover:bg-emphasis lg:hover:text-emphasis group flex rounded-md px-3 py-2 text-sm font-medium transition lg:px-2",
      children: /* @__PURE__ */ m(qt, { name: "search", className: "h-4 w-4 flex-shrink-0 text-inherit" })
    }
  ) }) }) : null;
}, P7c = (e) => {
  const t = e.shortcuts;
  return /* @__PURE__ */ m("span", { className: "space-x-1", children: t == null ? void 0 : t.map((n) => /* @__PURE__ */ m(
    "kbd",
    {
      className: "bg-default hover:bg-subtle text-emphasis rounded-sm border px-2 py-1 transition",
      children: n
    },
    n
  )) });
};
function D7c() {
  const { results: e } = Bp.useMatches(), { t } = kt();
  return /* @__PURE__ */ m(
    Bp.KBarResults,
    {
      items: e,
      onRender: ({ item: n, active: o }) => typeof n == "string" ? /* @__PURE__ */ m("div", { className: "bg-default text-emphasis p-4 text-xs font-bold uppercase", children: t(n) }) : /* @__PURE__ */ de(
        "div",
        {
          style: {
            background: o ? "var(--cal-bg-subtle)" : "var(--cal-bg-default)",
            borderLeft: o ? "2px solid var(--cal-border)" : "2px solid transparent",
            color: "var(--cal-text)"
          },
          className: "flex items-center justify-between px-4 py-2.5 text-sm transition hover:cursor-pointer",
          children: [
            /* @__PURE__ */ m("span", { children: t(n.name) }),
            /* @__PURE__ */ m(P7c, { shortcuts: n.shortcut })
          ]
        }
      )
    }
  );
}
var dre;
(dre = ht.tz.guess()) == null || dre.indexOf("Europe");
const zy = ht.tz.guess() !== "Etc/Unknown" ? ht.tz.guess() : "Europe/London";
function wme(e, t) {
  document.cookie = `calcom-timezone-dialog=1;max-age=${ht().add(e[0], e[1]).unix() - ht().unix()}`, t && ti(t, "success");
}
const L7c = () => {
  const { t: e, isLocaleReady: t } = kt();
  if (!t)
    return null;
  const n = hr.useUtils(), o = zy.replace("_", " "), r = async () => {
    ti(
      e("updated_timezone_to", { formattedCurrentTz: o, interpolation: { escapeValue: !1 } }),
      "success"
    ), await n.viewer.me.invalidate();
  }, i = () => {
    ti(e("couldnt_update_timezone"), "error");
  }, a = hr.viewer.me.updateProfile.useMutation({
    onSuccess: r,
    onError: i
  }), s = () => {
    a.mutate({
      timeZone: zy
    });
  };
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Sy,
      {
        title: e("update_timezone_question"),
        subtitle: e("update_timezone_description", {
          formattedCurrentTz: o,
          interpolation: { escapeValue: !1 }
        })
      }
    ),
    /* @__PURE__ */ m("div", { className: "mb-8" }),
    /* @__PURE__ */ de(Wu, { showDivider: !0, children: [
      /* @__PURE__ */ m(Gs, { onClick: () => wme([3, "months"], e("we_wont_show_again")), color: "secondary", children: e("dont_update") }),
      /* @__PURE__ */ m(Gs, { onClick: () => s(), color: "primary", children: e("update_timezone") })
    ] })
  ] });
};
function M7c() {
  var i;
  const { data: e } = hr.viewer.me.get.useQuery(), [t, n] = it(!1), { data: o, status: r } = ru.useSession();
  return yt(() => {
    var a;
    !(e != null && e.timeZone) || r !== "authenticated" || (a = o == null ? void 0 : o.user) != null && a.impersonatedBy || ht.tz(void 0, zy).utcOffset() !== ht.tz(void 0, e.timeZone).utcOffset() && n(!0);
  }, [e == null ? void 0 : e.timeZone, r, (i = o == null ? void 0 : o.user) == null ? void 0 : i.impersonatedBy]), { open: t, setOpen: n };
}
function F7c() {
  const { open: e, setOpen: t } = M7c(), { t: n } = kt();
  return /* @__PURE__ */ m(Ss, { open: e, onOpenChange: t, children: /* @__PURE__ */ m(Ya, { type: "creation", onInteractOutside: () => {
    wme([1, "day"], n("we_wont_show_again"));
  }, children: /* @__PURE__ */ m(L7c, {}) }) });
}
function q7c() {
  const [e, t] = it(!1);
  return yt(() => {
    typeof window < "u" && document && (document.cookie.split(";").find((o) => o.trim().startsWith("calcom-timezone-dialog")) || t(!0));
  }, []), e ? /* @__PURE__ */ m(F7c, {}) : null;
}
var j7c = Object.defineProperty, V7c = (e, t, n) => t in e ? j7c(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, db = (e, t, n) => (V7c(e, typeof t != "symbol" ? t + "" : t, n), n);
const B7c = (e) => async (...t) => {
  try {
    return {
      ok: !0,
      data: await e(...t)
    };
  } catch (n) {
    return {
      ok: !1,
      error: n
    };
  }
};
class U7c {
  constructor() {
    db(this, "queue", []), db(this, "isExecuting", !1), db(this, "add", (t) => {
      this.queue.push(t), this.run();
    }), db(this, "runNext", async () => {
      if (this.isExecuting)
        return;
      const t = this.queue.shift();
      if (t) {
        this.isExecuting = !0;
        try {
          await t();
        } finally {
          this.isExecuting = !1, this.queue.length > 0 && this.runNext();
        }
      }
    }), db(this, "run", async () => {
      !this.isExecuting && this.queue.length > 0 && await this.runNext();
    }), db(this, "clear", () => {
      this.queue = [];
    });
  }
}
let cw = !1, lY = !1;
const Az = new U7c(), G7c = async (e, t) => {
  if (!window.formbricks) {
    const n = await fetch(`${e}/api/packages/${t}`);
    if (!n.ok)
      return { ok: !1, error: new Error(`Failed to load Formbricks ${t} SDK`) };
    const o = await n.text(), r = document.createElement("script");
    r.innerHTML = o, document.head.appendChild(r);
    const i = async () => new Promise((a, s) => {
      const c = setInterval(() => {
        window.formbricks && (clearInterval(c), a());
      }, 100);
      setTimeout(() => {
        clearInterval(c), s(new Error(`Formbricks ${t} SDK loading timed out`));
      }, 1e4);
    });
    try {
      return await i(), { ok: !0, data: void 0 };
    } catch (a) {
      return {
        ok: !1,
        error: new Error(a.message ?? `Failed to load Formbricks ${t} SDK`)
      };
    }
  }
  return { ok: !0, data: void 0 };
}, W7c = async (e, t, ...n) => {
  const o = async () => {
    try {
      return await window.formbricks[e](...n);
    } catch (r) {
      throw console.error(`🧱 Formbricks - Global error: ${r}`), r;
    }
  };
  if (lY) {
    if (window.formbricks && typeof window.formbricks[e] != "function") {
      console.error(
        `🧱 Formbricks - Global error: Formbricks ${t} SDK does not support method ${String(e)}`
      );
      return;
    }
    Az.add(o);
    return;
  } else if (cw)
    Az.add(o);
  else if (e === "init") {
    cw = !0;
    const r = async () => {
      const { apiHost: i } = n[0], a = await B7c(G7c)(i, t);
      if (!a.ok) {
        cw = !1, console.error(`🧱 Formbricks - Global error: ${a.error.message}`);
        return;
      }
      try {
        const s = await window.formbricks[e](...n);
        return lY = !0, cw = !1, s;
      } catch (s) {
        throw cw = !1, console.error(`🧱 Formbricks - Global error: ${s}`), s;
      }
    };
    Az.add(r);
  } else {
    console.error(
      "🧱 Formbricks - Global error: You need to call formbricks.init before calling any other method"
    );
    return;
  }
}, H7c = {
  get(e, t, n) {
    return (...o) => W7c(t, "app", ...o);
  }
}, Y7c = new Proxy({}, H7c), K7c = ({
  userId: e,
  attributes: t
}) => {
  const n = {};
  Object.entries(t).forEach(([o, r]) => {
    r != null && (n[o] = r);
  }), process.env.NEXT_PUBLIC_FORMBRICKS_HOST_URL && process.env.NEXT_PUBLIC_FORMBRICKS_ENVIRONMENT_ID && Y7c.init({
    environmentId: process.env.NEXT_PUBLIC_FORMBRICKS_ENVIRONMENT_ID,
    apiHost: process.env.NEXT_PUBLIC_FORMBRICKS_HOST_URL,
    debug: process.env.NODE_ENV === "development",
    userId: e,
    attributes: n
  });
}, Z7c = () => {
  const { data: e, isLoading: t } = Z0(), { data: n, status: o } = ru.useSession();
  yt(() => {
    var r, i, a;
    !t && e && n && K7c({
      userId: e.id.toString(),
      attributes: {
        name: e == null ? void 0 : e.name,
        email: e.email,
        username: e == null ? void 0 : e.username,
        belongsToActiveTeam: (r = n.user.belongsToActiveTeam) == null ? void 0 : r.toString(),
        isOrganizationAdmin: (a = (i = e.organization) == null ? void 0 : i.isOrgAdmin) == null ? void 0 : a.toString()
      }
    });
  }, [t, e, o, n]);
};
class X7c extends Fe.Component {
  constructor(t) {
    super(t), this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(t, n) {
    this.setState({ error: t, errorInfo: n });
  }
  render() {
    return this.state.error !== null && "digest" in this.state.error && this.state.error.digest === "NEXT_NOT_FOUND" ? this.props.children : this.state.errorInfo ? /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("h2", { children: this.props.message || "Something went wrong." }),
      /* @__PURE__ */ m("details", { style: { whiteSpace: "pre-wrap" }, children: this.state.error && this.state.error.toString() })
    ] }) : this.props.children;
  }
}
const kme = X7c, vr = {
  getItem(e) {
    try {
      return window.localStorage.getItem(e);
    } catch {
      return null;
    }
  },
  setItem(e, t) {
    try {
      window.localStorage.setItem(e, t);
    } catch {
      return;
    }
  },
  removeItem: (e) => {
    try {
      window.localStorage.removeItem(e);
    } catch {
      return;
    }
  }
};
function J7c() {
  const { t: e } = kt(), t = Nr.usePathname(), [n, o] = it(() => typeof window > "u" ? !0 : !vr.getItem("calai-banner-dismissed")), r = () => {
    vr.setItem("calai-banner-dismissed", "true"), o(!1);
  }, i = () => {
    window.open("/workflow/new?action=calAi&templateWorkflowId=wf-11", "_blank");
  };
  return !n || !(t === "/workflows" || t === "/event-types" || t === "/bookings/upcoming") ? null : /* @__PURE__ */ de("div", { className: "bg-launch-dark relative mb-6 w-full overflow-hidden rounded-lg text-white", children: [
    /* @__PURE__ */ m(
      "button",
      {
        onClick: r,
        className: "absolute right-2 top-2 z-10 rounded-[10px] p-2",
        "aria-label": "Close banner",
        children: /* @__PURE__ */ m(qt, { name: "x", className: "h-4 w-4 text-white" })
      }
    ),
    /* @__PURE__ */ de("div", { className: "flex flex-col md:flex-row", children: [
      /* @__PURE__ */ de("div", { className: "flex-1 p-6 pr-6 lg:p-8", children: [
        /* @__PURE__ */ m("h2", { className: "font-cal font-subtle text-lg", children: e("supercharge_your_workflows_with_cal_ai") }),
        /* @__PURE__ */ m("p", { className: "text-subtle mb-4 text-sm", children: e("supercharge_your_workflows_with_cal_ai_description") }),
        /* @__PURE__ */ m(
          "button",
          {
            onClick: i,
            className: "rounded-[10px] bg-gradient-to-b from-[#6349EA] to-[#875FE0] px-5 py-2 text-sm font-medium text-white hover:from-[#5A42D1] hover:to-[#7B6FD7]",
            children: e("try_now")
          }
        )
      ] }),
      /* @__PURE__ */ m("img", { src: "/cal-ai-banner.svg", alt: "Cal.ai Banner", className: "mt-auto hidden h-40 md:block" })
    ] })
  ] });
}
function yA(e, t) {
  return e || `https://eu.ui-avatars.com/api/?background=fff&color=f9f9f9&bold=true&background=000000&name=${encodeURIComponent(
    t || ""
  )}`;
}
uA.getSubLogger({
  prefix: ["orgDomains.ts"]
});
function Q7c() {
  var t;
  if (!qE && process.env.LOCAL_TESTING_DOMAIN_VERCEL)
    return process.env.LOCAL_TESTING_DOMAIN_VERCEL;
  const e = (t = Wa.replace("https://", "")) == null ? void 0 : t.replace("http://", "").split(".");
  return e.length === 3 ? e.slice(1).join(".") : e.join(".");
}
function eHc(e, t = { protocol: !0 }) {
  return e ? `${t.protocol ? `${new URL(Vw).protocol}//` : ""}${e}.${Q7c()}` : t.protocol ? Vw : Vw.replace("https://", "").replace("http://", "");
}
const Ry = (e, t) => eHc(e ?? "", t);
function tHc(e, t = []) {
  let n = [];
  function o(i, a) {
    const s = Ue.createContext(a), c = n.length;
    n = [...n, a];
    const l = (d) => {
      var $;
      const { scope: _, children: p, ...g } = d, f = (($ = _ == null ? void 0 : _[e]) == null ? void 0 : $[c]) || s, h = Ue.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ m(f.Provider, { value: h, children: p });
    };
    l.displayName = i + "Provider";
    function u(d, _) {
      var f;
      const p = ((f = _ == null ? void 0 : _[e]) == null ? void 0 : f[c]) || s, g = Ue.useContext(p);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [l, u];
  }
  const r = () => {
    const i = n.map((a) => Ue.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return Ue.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return r.scopeName = e, [o, nHc(r, ...t)];
}
function nHc(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(i) {
      const a = o.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return { ...s, ...d };
      }, {});
      return Ue.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function oHc(e) {
  const t = Ue.useRef(e);
  return Ue.useEffect(() => {
    t.current = e;
  }), Ue.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function uY(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function rHc(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const i = uY(r, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const i = o[r];
          typeof i == "function" ? i() : uY(e[r], null);
        }
      };
  };
}
var Sme = Ue.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = Ue.Children.toArray(n), i = r.find(aHc);
  if (i) {
    const a = i.props.children, s = r.map((c) => c === i ? Ue.Children.count(a) > 1 ? Ue.Children.only(null) : Ue.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ m(_5, { ...o, ref: t, children: Ue.isValidElement(a) ? Ue.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ m(_5, { ...o, ref: t, children: n });
});
Sme.displayName = "Slot";
var _5 = Ue.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (Ue.isValidElement(n)) {
    const r = cHc(n), i = sHc(o, n.props);
    return n.type !== Ue.Fragment && (i.ref = t ? rHc(t, r) : r), Ue.cloneElement(n, i);
  }
  return Ue.Children.count(n) > 1 ? Ue.Children.only(null) : null;
});
_5.displayName = "SlotClone";
var iHc = ({ children: e }) => /* @__PURE__ */ m(nt, { children: e });
function aHc(e) {
  return Ue.isValidElement(e) && e.type === iHc;
}
function sHc(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      i(...s), r(...s);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function cHc(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var lHc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Pq = lHc.reduce((e, t) => {
  const n = Ue.forwardRef((o, r) => {
    const { asChild: i, ...a } = o, s = i ? Sme : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(s, { ...a, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Dq = "Avatar", [uHc, usu] = tHc(Dq), [dHc, Eme] = uHc(Dq), xme = Ue.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...o } = e, [r, i] = Ue.useState("idle");
    return /* @__PURE__ */ m(
      dHc,
      {
        scope: n,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ m(Pq.span, { ...o, ref: t })
      }
    );
  }
);
xme.displayName = Dq;
var Cme = "AvatarImage", Tme = Ue.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: o, onLoadingStatusChange: r = () => {
    }, ...i } = e, a = Eme(Cme, n), s = _Hc(o, i.referrerPolicy), c = oHc((l) => {
      r(l), a.onImageLoadingStatusChange(l);
    });
    return sq(() => {
      s !== "idle" && c(s);
    }, [s, c]), s === "loaded" ? /* @__PURE__ */ m(Pq.img, { ...i, ref: t, src: o }) : null;
  }
);
Tme.displayName = Cme;
var Ame = "AvatarFallback", Ime = Ue.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: o, ...r } = e, i = Eme(Ame, n), [a, s] = Ue.useState(o === void 0);
    return Ue.useEffect(() => {
      if (o !== void 0) {
        const c = window.setTimeout(() => s(!0), o);
        return () => window.clearTimeout(c);
      }
    }, [o]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ m(Pq.span, { ...r, ref: t }) : null;
  }
);
Ime.displayName = Ame;
function _Hc(e, t) {
  const [n, o] = Ue.useState("idle");
  return sq(() => {
    if (!e) {
      o("error");
      return;
    }
    let r = !0;
    const i = new window.Image(), a = (s) => () => {
      r && o(s);
    };
    return o("loading"), i.onload = a("loaded"), i.onerror = a("error"), i.src = e, t && (i.referrerPolicy = t), () => {
      r = !1;
    };
  }, [e, t]), n;
}
var pHc = xme, mHc = Tme, fHc = Ime;
const gHc = Vy(
  "bg-emphasis border-default relative inline-flex aspect-square items-center justify-center border align-top",
  {
    variants: {
      size: {
        xs: "w-4 h-4 min-w-4 min-h-4 max-h-4",
        // 16px
        xsm: "w-5 h-5 min-w-5 min-h-5",
        // 20px
        sm: "w-6 h-6 min-w-6 min-h-6",
        // 24px
        md: "w-8 h-8 min-w-8 min-h-8",
        // 32px
        mdLg: "w-10 h-10 min-w-10 min-h-10",
        // 40px
        lg: "w-16 h-16 min-w-16 min-h-16",
        // 64px
        xl: "w-24 h-24 min-w-24 min-h-24"
        // 96px
      },
      shape: {
        circle: "rounded-full",
        square: ""
      }
    },
    defaultVariants: {
      size: "md",
      shape: "circle"
    },
    compoundVariants: [
      {
        size: ["xs", "xsm", "sm"],
        shape: "square",
        className: "rounded"
      },
      {
        size: ["md"],
        shape: "square",
        className: "rounded-md"
      },
      {
        size: ["mdLg", "lg", "xl"],
        shape: "square",
        className: "rounded-[10px]"
      }
    ]
  }
);
function Dd(e) {
  const { imageSrc: t, size: n = "md", alt: o, title: r, href: i, indicator: a } = e, s = gHc({ size: n, shape: e.shape }), c = xe("aspect-square rounded-full", s);
  let l = /* @__PURE__ */ m(
    pHc,
    {
      "data-testid": e == null ? void 0 : e["data-testid"],
      className: xe(
        s,
        a ? "overflow-visible" : "overflow-hidden",
        e.className
      ),
      children: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(
          mHc,
          {
            src: t ?? void 0,
            alt: o,
            className: xe("aspect-square", s)
          }
        ),
        /* @__PURE__ */ m(
          fHc,
          {
            delayMs: 600,
            asChild: e.asChild,
            className: "flex h-full items-center justify-center",
            children: /* @__PURE__ */ m(nt, { children: e.fallback ? e.fallback : /* @__PURE__ */ m("img", { src: Lse, alt: o, className: c }) })
          }
        ),
        a
      ] })
    }
  );
  return i && (l = /* @__PURE__ */ m(Ir, { "data-testid": "avatar-href", href: i, children: l })), r ? /* @__PURE__ */ m(gCe, { children: /* @__PURE__ */ m(Sr, { content: r, children: l }) }) : /* @__PURE__ */ m(nt, { children: l });
}
const Ome = (e) => e != null && e.avatarUrl ? oe.string().url().safeParse(e.avatarUrl).success ? e.avatarUrl : VG + e.avatarUrl : VG + Lse, Nme = function(t) {
  const n = t.items.length, o = t.truncateAfter || 4, r = t.items.filter((a) => a.image).slice(0, o), i = n - r.length;
  return r.length ? /* @__PURE__ */ de("ul", { className: xe("flex items-center", t.className), children: [
    r.map((a, s) => /* @__PURE__ */ m("li", { className: "-mr-1 inline-block", children: /* @__PURE__ */ m(
      Dd,
      {
        "data-testid": "avatar",
        className: "border-subtle",
        imageSrc: a.image,
        title: a.title,
        alt: a.alt || "",
        size: t.size,
        href: a.href
      }
    ) }, s)),
    i > 0 && /* @__PURE__ */ m(
      "li",
      {
        className: xe(
          "bg-inverted relative -mr-1 inline-flex justify-center  overflow-hidden rounded-full",
          t.size === "sm" ? "min-w-6 h-6" : "min-w-16 h-16"
        ),
        children: /* @__PURE__ */ de(
          "span",
          {
            className: xe(
              " text-inverted m-auto flex h-full w-full items-center justify-center text-center",
              t.size === "sm" ? "text-[12px]" : "text-2xl"
            ),
            children: [
              "+",
              t.hideTruncatedAvatarsCount ? null : i
            ]
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ m(nt, {});
};
function hHc(e) {
  const { users: t, organization: n, disableHref: o = !1, ...r } = e, a = [
    {
      // We don't want booker to be able to see the list of other users or teams inside the embed
      href: tm() || o ? null : Ry(n.slug),
      image: yA(n.logoUrl, n.name),
      alt: n.name || void 0,
      title: n.name
    }
  ].concat(
    t.map((s) => ({
      href: o ? null : `${s.bookerUrl}/${s.username}?redirect=false`,
      image: Ome(s),
      alt: s.name || void 0,
      title: s.name || s.username || ""
    }))
  );
  return /* @__PURE__ */ m(Nme, { ...r, items: a });
}
const OC = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA, dY = OC ? `-${OC.slice(0, 7)}` : "", vHc = `v.${Fse}-${Sf ? "sh" : "h"}`;
function bHc() {
  const [e, t] = it(!1);
  return yt(() => {
    t(!0);
  }, []), /* @__PURE__ */ de("small", { className: "text-default mx-3 mb-2 mt-1 hidden text-[0.5rem] opacity-50 lg:block", children: [
    "© ",
    (/* @__PURE__ */ new Date()).getFullYear(),
    " ",
    /* @__PURE__ */ m(Ir, { href: "https://go.cal.com/credits", target: "_blank", className: "hover:underline", children: dcc }),
    " ",
    e && /* @__PURE__ */ de(nt, { children: [
      /* @__PURE__ */ m(Ir, { href: "https://go.cal.com/releases", target: "_blank", className: "hover:underline", children: vHc }),
      OC && Pse ? /* @__PURE__ */ m(
        Ir,
        {
          href: `https://github.com/calcom/cal.com/commit/${OC}`,
          target: "_blank",
          className: "hover:underline",
          children: dY
        }
      ) : dY
    ] })
  ] });
}
function zme({
  small: e,
  icon: t,
  inline: n = !0,
  className: o,
  src: r = "/api/logo"
}) {
  return /* @__PURE__ */ m("h3", { className: xe("logo", n && "inline", o), children: /* @__PURE__ */ m("strong", { children: t ? /* @__PURE__ */ m("img", { className: "mx-auto w-9 dark:invert", alt: "Cal", title: "Cal", src: `${r}?type=icon` }) : /* @__PURE__ */ m(
    "img",
    {
      className: xe(e ? "h-4 w-auto" : "h-5 w-auto", "dark:invert"),
      alt: "Cal",
      title: "Cal",
      src: r
    }
  ) }) });
}
function yHc() {
  const { t: e } = kt(), { data: t } = hr.viewer.me.bookingUnconfirmedCount.useQuery();
  return t ? /* @__PURE__ */ m(Ir, { href: "/bookings/unconfirmed", children: /* @__PURE__ */ m(
    Wi,
    {
      rounded: !0,
      title: e("unconfirmed_bookings_tooltip"),
      variant: "orange",
      className: "cursor-pointer hover:bg-orange-800 hover:text-orange-100",
      children: t
    }
  ) }) : null;
}
const $Hc = Cr(null);
function Rme() {
  const e = bo($Hc);
  if (!e)
    throw new Error("Error: useOrgBranding was used outside of OrgBrandingProvider.");
  return e.orgBrand;
}
function wHc() {
  const { isPending: e, listInvites: t } = Gbc(), { t: n } = kt();
  return e || !t || t.length === 0 ? null : /* @__PURE__ */ m(Wi, { variant: "default", children: n("invite_team_notifcation_badge") });
}
const kHc = (e) => {
  const [t, n] = it(!1);
  return yt(() => {
    const o = window.matchMedia(e);
    o.matches !== t && n(o.matches);
    const r = () => n(o.matches);
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [t, e]), t;
}, NC = kHc, SHc = (e, t) => e in t;
function Pme(e) {
  const t = Oq();
  return SHc(e.name, t) ? t[e.name] : !0;
}
const EHc = (e) => {
  const [t, n] = it(!1);
  return yt(() => {
    try {
      const r = sessionStorage.getItem(`nav-expansion-${e}`);
      r !== null && n(JSON.parse(r));
    } catch {
    }
  }, [e]), [t, (r) => {
    n(r);
    try {
      sessionStorage.setItem(`nav-expansion-${e}`, JSON.stringify(r));
    } catch {
    }
  }];
}, p5 = ({ isChild: e, item: t, pathname: n }) => e ? t.href === n : t.href ? (n == null ? void 0 : n.startsWith(t.href)) ?? !1 : !1, Dme = (e) => {
  var b, y;
  const { item: t, isChild: n } = e, { t: o, isLocaleReady: r } = kt(), i = Nr.usePathname(), a = t.isCurrent || p5, s = a({ isChild: !!n, item: t, pathname: i }), c = Pme(e.item), [l, u] = EHc(t.name), d = NC("(max-width: 1024px)"), [_, p] = it(!1);
  if (!c)
    return null;
  const g = t.child && t.child.length > 0, f = g && ((b = t.child) == null ? void 0 : b.some((w) => a({ isChild: !0, item: w, pathname: i }))), h = l || f || a({ pathname: i, isChild: n, item: t }), $ = g && !f;
  return /* @__PURE__ */ de(Ha, { children: [
    g && !n ? /* @__PURE__ */ m(
      Sr,
      {
        side: "right",
        open: _,
        content: g ? /* @__PURE__ */ de("div", { className: "pointer-events-auto flex flex-col space-y-1 p-1", children: [
          /* @__PURE__ */ m("span", { className: "text-subtle px-2 text-xs font-semibold uppercase tracking-wide", children: o(t.name) }),
          /* @__PURE__ */ m("div", { className: "flex flex-col", children: (y = t.child) == null ? void 0 : y.map((w) => {
            const N = typeof w.isCurrent == "function" ? w.isCurrent({ isChild: !0, item: w, pathname: i }) : p5({ isChild: !0, item: w, pathname: i });
            return /* @__PURE__ */ m(
              Ir,
              {
                href: w.href,
                "aria-current": N ? "page" : void 0,
                onClick: () => p(!1),
                className: xe(
                  "group relative block rounded-md px-3 py-1 text-sm font-medium",
                  N ? "bg-emphasis text-white" : "hover:bg-emphasis text-mute hover:text-emphasis"
                ),
                children: o(w.name)
              },
              w.name
            );
          }) })
        ] }) : o(t.name),
        className: "lg:hidden",
        children: /* @__PURE__ */ de(
          "button",
          {
            "data-test-id": t.name,
            "aria-label": o(t.name),
            "aria-expanded": l,
            "aria-current": s ? "page" : void 0,
            onClick: () => {
              u(!l), d && g && p(!_);
            },
            className: xe(
              "todesktop:py-[7px] text-default group flex w-full items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
              "[&[aria-current='page']]:!bg-transparent",
              "[&[aria-current='page']]:text-emphasis mt-0.5 text-sm",
              r ? "hover:bg-subtle todesktop:[&[aria-current='page']]:bg-emphasis todesktop:hover:bg-transparent hover:text-emphasis" : ""
            ),
            children: [
              t.icon && /* @__PURE__ */ m(
                qt,
                {
                  name: t.isLoading ? "rotate-cw" : t.icon,
                  className: xe(
                    "todesktop:!text-blue-500 mr-2 h-4 w-4 flex-shrink-0 rtl:ml-2 md:ltr:mx-auto lg:ltr:mr-2",
                    t.isLoading && "animate-spin"
                  ),
                  "aria-hidden": "true"
                }
              ),
              r ? /* @__PURE__ */ de("span", { className: "hidden w-full justify-between truncate text-ellipsis lg:flex", children: [
                o(t.name),
                t.badge && t.badge
              ] }) : /* @__PURE__ */ m(Yo, { className: "h-[20px] w-full" }),
              $ && /* @__PURE__ */ m(qt, { name: l ? "chevron-up" : "chevron-down", className: "ml-auto h-4 w-4" })
            ]
          }
        )
      }
    ) : /* @__PURE__ */ m(Sr, { side: "right", content: o(t.name), className: "lg:hidden", children: /* @__PURE__ */ de(
      Ir,
      {
        "data-test-id": t.name,
        href: t.href,
        "aria-label": o(t.name),
        target: t.target,
        className: xe(
          "todesktop:py-[7px] text-default group flex items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
          t.child ? "[&[aria-current='page']]:!bg-transparent" : "[&[aria-current='page']]:bg-emphasis",
          n ? `[&[aria-current='page']]:text-emphasis [&[aria-current='page']]:bg-emphasis hidden h-8 pl-16 lg:flex lg:pl-11 ${e.index === 0 ? "mt-0" : "mt-px"}` : "[&[aria-current='page']]:text-emphasis mt-0.5 text-sm",
          r ? "hover:bg-subtle todesktop:[&[aria-current='page']]:bg-emphasis todesktop:hover:bg-transparent hover:text-emphasis" : ""
        ),
        "aria-current": s ? "page" : void 0,
        children: [
          t.icon && /* @__PURE__ */ m(
            qt,
            {
              name: t.isLoading ? "rotate-cw" : t.icon,
              className: xe(
                "todesktop:!text-blue-500 mr-2 h-4 w-4 flex-shrink-0 rtl:ml-2 md:ltr:mx-auto lg:ltr:mr-2 [&[aria-current='page']]:text-inherit",
                t.isLoading && "animate-spin"
              ),
              "aria-hidden": "true",
              "aria-current": s ? "page" : void 0
            }
          ),
          r ? /* @__PURE__ */ de(
            "span",
            {
              className: "hidden w-full justify-between truncate text-ellipsis lg:flex",
              "data-testid": `${t.name}-test`,
              children: [
                o(t.name),
                t.badge && t.badge
              ]
            }
          ) : /* @__PURE__ */ m(Yo, { className: "h-[20px] w-full" }),
          t.name === "workflows" && /* @__PURE__ */ m(Wi, { startIcon: "sparkles", variant: "purple", children: "Cal.ai" })
        ]
      }
    ) }),
    t.child && h && t.child.map((w, N) => /* @__PURE__ */ m(Dme, { index: N, item: w, isChild: !0 }, w.name))
  ] });
}, xHc = (e) => {
  const { item: t, isChild: n } = e, o = Nr.usePathname(), { t: r, isLocaleReady: i } = kt(), s = (t.isCurrent || p5)({ isChild: !!n, item: t, pathname: o });
  return Pme(e.item) ? /* @__PURE__ */ de(
    Ir,
    {
      href: t.href,
      target: t.target,
      className: "[&[aria-current='page']]:text-emphasis hover:text-default text-muted relative my-2 min-w-0 flex-1 overflow-hidden rounded-md !bg-transparent p-1 text-center text-xs font-medium focus:z-10 sm:text-sm",
      "aria-current": s ? "page" : void 0,
      children: [
        t.badge && /* @__PURE__ */ m("div", { className: "absolute right-1 top-1", children: t.badge }),
        t.icon && /* @__PURE__ */ m(
          qt,
          {
            name: t.icon,
            className: "[&[aria-current='page']]:text-emphasis  mx-auto mb-1 block h-5 w-5 flex-shrink-0 text-center text-inherit",
            "aria-hidden": "true",
            "aria-current": s ? "page" : void 0
          }
        ),
        i ? /* @__PURE__ */ m("span", { className: "block truncate", children: r(t.name) }) : /* @__PURE__ */ m(Yo, {})
      ]
    },
    t.name
  ) : null;
}, Qw = "more", CHc = (e) => [
  {
    name: "event_types_page_title",
    href: "/event-types",
    icon: "link"
  },
  {
    name: "bookings",
    href: "/bookings/upcoming",
    icon: "calendar",
    badge: /* @__PURE__ */ m(yHc, {}),
    isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/bookings")) ?? !1
  },
  {
    name: "availability",
    href: "/availability",
    icon: "clock"
  },
  ...e ? [
    {
      name: "members",
      href: `/settings/organizations/${e.slug}/members`,
      icon: "building",
      moreOnMobile: !0
    }
  ] : [],
  {
    name: "teams",
    href: "/teams",
    icon: "users",
    badge: /* @__PURE__ */ m(wHc, {}),
    moreOnMobile: !0
  },
  {
    name: "apps",
    href: "/apps",
    icon: "grid-3x3",
    moreOnMobile: !0,
    isCurrent: ({ pathname: t, item: n }) => ((t == null ? void 0 : t.startsWith(n.href)) ?? !1) && !((t == null ? void 0 : t.includes("routing-forms/")) ?? !1),
    child: [
      {
        name: "app_store",
        href: "/apps",
        isCurrent: ({ pathname: t, item: n }) => ((t == null ? void 0 : t.startsWith(n.href)) ?? !1) && !((t == null ? void 0 : t.includes("routing-forms/")) ?? !1) && !((t == null ? void 0 : t.includes("/installed")) ?? !1)
      },
      {
        name: "installed_apps",
        href: "/apps/installed/calendar",
        isCurrent: ({ pathname: t }) => ((t == null ? void 0 : t.startsWith("/apps/installed/")) ?? !1) || ((t == null ? void 0 : t.startsWith("/v2/apps/installed/")) ?? !1)
      }
    ]
  },
  {
    name: Qw,
    href: "/more",
    icon: "ellipsis"
  },
  {
    name: "routing",
    href: "/routing",
    icon: "split",
    isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/routing")) ?? !1,
    moreOnMobile: !0
  },
  {
    name: "workflows",
    href: "/workflows",
    icon: "zap",
    moreOnMobile: !0
  },
  {
    name: "insights",
    href: "/insights",
    icon: "chart-bar",
    isCurrent: ({ pathname: t, item: n }) => (t == null ? void 0 : t.startsWith(n.href)) ?? !1,
    moreOnMobile: !0,
    child: [
      {
        name: "bookings",
        href: "/insights",
        isCurrent: ({ pathname: t }) => t === "/insights"
      },
      {
        name: "routing",
        href: "/insights/routing",
        isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/insights/routing")) ?? !1
      },
      {
        name: "router_position",
        href: "/insights/router-position",
        isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/insights/router-position")) ?? !1
      },
      {
        name: "call_history",
        href: "/insights/call-history",
        // icon: "phone",
        isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/insights/call-history")) ?? !1
      }
    ]
  }
], THc = [
  {
    name: "Dashboard",
    href: "/settings/platform/",
    icon: "layout-dashboard"
  },
  {
    name: "Documentation",
    href: "https://docs.cal.com/docs/platform",
    icon: "chart-bar",
    target: "_blank"
  },
  {
    name: "API reference",
    href: "https://api.cal.com/v2/docs#/",
    icon: "terminal",
    target: "_blank"
  },
  {
    name: "Atoms",
    href: "https://docs.cal.com/docs/platform#atoms",
    icon: "atom",
    target: "_blank"
  },
  {
    name: Qw,
    href: "https://docs.cal.com/docs/platform/faq",
    icon: "ellipsis",
    target: "_blank"
  },
  {
    name: "Billing",
    href: "/settings/platform/billing",
    icon: "credit-card",
    moreOnMobile: !0
  },
  {
    name: "Members",
    href: "/settings/platform/members",
    icon: "users",
    moreOnMobile: !0
  },
  {
    name: "Managed Users",
    href: "/settings/platform/managed-users",
    icon: "users",
    moreOnMobile: !0
  }
], Lme = (e = !1) => {
  const t = Rme();
  return vn(() => {
    const n = e ? THc : CHc(t), o = n.filter((a) => a.name !== Qw), r = n.filter(
      (a) => !a.moreOnMobile && !a.onlyDesktop || a.name === Qw
    ), i = n.filter(
      (a) => a.moreOnMobile && !a.onlyDesktop && a.name !== Qw
    );
    return { desktopNavigationItems: o, mobileNavigationBottomItems: r, mobileNavigationMoreItems: i };
  }, [e, t]);
}, AHc = ({ isPlatformNavigation: e = !1 }) => {
  const { desktopNavigationItems: t } = Lme(e);
  return /* @__PURE__ */ de("nav", { className: "mt-2 flex-1 md:px-2 lg:mt-4 lg:px-0", children: [
    t.map((n) => /* @__PURE__ */ m(Dme, { item: n }, n.name)),
    /* @__PURE__ */ m("div", { className: "text-subtle mt-0.5 lg:hidden", children: /* @__PURE__ */ m(Rq, {}) })
  ] });
};
function IHc({
  isPlatformNavigation: e = !1
}) {
  const { status: t } = ru.useSession();
  return t !== "authenticated" ? null : /* @__PURE__ */ m(OHc, { isPlatformNavigation: e });
}
const OHc = ({ isPlatformNavigation: e = !1 }) => {
  const t = tm(), { mobileNavigationBottomItems: n } = Lme(e);
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      "nav",
      {
        className: xe(
          "pwa:pb-[max(0.25rem,env(safe-area-inset-bottom))] pwa:-mx-2 bg-muted border-subtle fixed bottom-0 left-0 z-30 flex w-full border-t bg-opacity-40 px-1 shadow backdrop-blur-md md:hidden",
          t && "hidden"
        ),
        children: n.map((o) => /* @__PURE__ */ m(xHc, { item: o }, o.name))
      }
    ),
    /* @__PURE__ */ m("div", { className: "block pt-12 md:hidden" })
  ] });
};
function NHc({
  publicPageUrl: e,
  isAdmin: t,
  user: n
}) {
  const { t: o } = kt(), { isTrial: r } = Hbc(), i = hr.useUtils(), a = hr.viewer.teams.skipTeamTrials.useMutation({
    onSuccess: () => {
      i.viewer.teams.hasActiveTeamPlan.invalidate(), ti(o("team_trials_skipped_successfully"), "success");
    },
    onError: () => {
      ti(o("something_went_wrong"), "error");
    }
  });
  return [
    // Render above to prevent layout shift as much as possible
    r ? {
      name: "skip_trial",
      href: "",
      isLoading: a.isPending,
      icon: "clock",
      onClick: (s) => {
        s.preventDefault(), a.mutate({});
      }
    } : null,
    {
      name: "view_public_page",
      href: e,
      icon: "external-link",
      target: "__blank"
    },
    {
      name: "copy_public_page_link",
      href: "",
      onClick: (s) => {
        s.preventDefault(), navigator.clipboard.writeText(e), ti(o("link_copied"), "success");
      },
      icon: "copy"
    },
    Ecc ? {
      name: "referral_text",
      href: "/refer",
      icon: "gift"
    } : null,
    t ? {
      name: "impersonation",
      href: "/settings/admin/impersonation",
      icon: "lock"
    } : null,
    {
      name: "settings",
      href: n != null && n.org ? "/settings/organizations/profile" : "/settings/my-account/profile",
      icon: "settings"
    }
  ].filter(Boolean);
}
function zHc() {
  const e = Nr.usePathname(), t = Nr.useSearchParams();
  return vn(
    () => `${e}${t ? `?${t.toString()}` : ""}`,
    [e, t]
  );
}
function RHc() {
  const e = Nr.useRouter(), t = zHc();
  return () => {
    "refresh" in e && e.refresh(), e.replace(t);
  };
}
function PHc() {
  const { update: e, data: t } = ru.useSession(), { data: n } = hr.viewer.me.get.useQuery(), [o, r] = it(!1), i = RHc();
  if (!n || !Mse || !t)
    return null;
  const a = n.profiles.map((c) => {
    let l;
    return c.organization ? l = c.organization.name : l = t.user.name, {
      label: l,
      value: c.upId
    };
  }), s = a.find((c) => c.value === t.upId) || a[0];
  return /* @__PURE__ */ de(jd, { open: o, children: [
    /* @__PURE__ */ m(Hu, { asChild: !0, onClick: () => r((c) => !c), children: /* @__PURE__ */ m(
      "button",
      {
        "data-testid": "user-dropdown-trigger-button",
        className: xe(
          "hover:bg-emphasis todesktop:!bg-transparent group mx-0 flex w-full cursor-pointer appearance-none items-center rounded-full px-2 py-1.5 text-left outline-none transition focus:outline-none focus:ring-0 md:rounded-none lg:rounded"
        ),
        children: /* @__PURE__ */ de("span", { className: "flex w-full flex-grow items-center justify-around gap-2 text-sm font-medium leading-none", children: [
          /* @__PURE__ */ m(Dd, { alt: s.label || "", size: "xsm" }),
          /* @__PURE__ */ m("span", { className: "block w-20 overflow-hidden overflow-ellipsis whitespace-nowrap", children: s.label }),
          /* @__PURE__ */ m(
            qt,
            {
              name: "chevron-down",
              className: "group-hover:text-subtle text-muted h-4 w-4 flex-shrink-0 transition rtl:mr-4",
              "aria-hidden": "true"
            }
          )
        ] })
      }
    ) }),
    /* @__PURE__ */ m(cpe, { children: /* @__PURE__ */ de(
      Yu,
      {
        align: "start",
        onInteractOutside: () => {
          r(!1);
        },
        className: "min-w-56 hariom group overflow-hidden rounded-md",
        children: [
          /* @__PURE__ */ m(Pi, { className: "p-3 uppercase", children: /* @__PURE__ */ m("span", { children: "Switch to" }) }),
          a.map((c) => {
            const l = s.value === c.value;
            return /* @__PURE__ */ m(
              Pi,
              {
                onClick: () => {
                  r(!1), !l && e({
                    upId: c.value
                  }).then(() => {
                    i();
                  });
                },
                className: xe("flex w-full", l ? "bg-subtle text-emphasis" : ""),
                children: /* @__PURE__ */ de(
                  ba,
                  {
                    type: "button",
                    childrenClassName: xe("flex w-full justify-between items-center"),
                    children: [
                      /* @__PURE__ */ de("span", { children: [
                        /* @__PURE__ */ m(Dd, { alt: c.label || "", size: "xsm" }),
                        /* @__PURE__ */ m("span", { className: "ml-2", children: c.label })
                      ] }),
                      l ? /* @__PURE__ */ m(qt, { name: "check", className: "ml-2 inline h-4 w-4", "aria-hidden": "true" }) : null
                    ]
                  }
                )
              },
              c.value
            );
          })
        ]
      }
    ) })
  ] });
}
const DHc = (e, t) => mr({
  queryKey: ["check-team-billing", e],
  queryFn: async () => (await (await fetch(`/api/v2/billing/${e}/check`, {
    method: "get",
    headers: { "Content-type": "application/json" }
  })).json()).data,
  enabled: !!e && !!t,
  staleTime: 5e3
});
function LHc() {
  return hr.viewer.me.platformMe.useQuery(void 0, {
    retry(t) {
      return t > 3;
    },
    // 5 minutes
    staleTime: 3e5
  });
}
const MHc = () => {
  var l, u;
  const {
    data: e,
    isLoading: t,
    refetch: n
  } = LHc(), {
    data: o,
    isFetching: r,
    refetch: i
  } = DHc(e == null ? void 0 : e.organizationId, ((l = e == null ? void 0 : e.organization) == null ? void 0 : l.isPlatform) ?? !1), a = ((u = e == null ? void 0 : e.organization) == null ? void 0 : u.isPlatform) ?? !1, s = o == null ? void 0 : o.valid, c = e == null ? void 0 : e.organizationId;
  return {
    isUserLoading: t,
    isUserBillingDataLoading: r,
    isPlatformUser: a,
    isPaidUser: s,
    userBillingData: o,
    userOrgId: c,
    refetchTeamBilling: i,
    refetchPlatformUser: n
  };
};
var m5 = { exports: {} }, Iz = {}, _Y;
function FHc() {
  return _Y || (_Y = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "HeadManagerContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (/* @__PURE__ */ qg._(Fe)).default.createContext({});
    process.env.NODE_ENV !== "production" && (o.displayName = "HeadManagerContext");
  }(Iz)), Iz;
}
var tE = { exports: {} }, pY;
function qHc() {
  return pY || (pY = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "setAttributesFromProps", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const n = {
      acceptCharset: "accept-charset",
      className: "class",
      htmlFor: "for",
      httpEquiv: "http-equiv",
      noModule: "noModule"
    }, o = [
      "onLoad",
      "onReady",
      "dangerouslySetInnerHTML",
      "children",
      "onError",
      "strategy",
      "stylesheets"
    ];
    function r(a) {
      return [
        "async",
        "defer",
        "noModule"
      ].includes(a);
    }
    function i(a, s) {
      for (const [c, l] of Object.entries(s)) {
        if (!s.hasOwnProperty(c) || o.includes(c) || l === void 0)
          continue;
        const u = n[c] || c.toLowerCase();
        a.tagName === "SCRIPT" && r(u) ? a[u] = !!l : a.setAttribute(u, String(l)), (l === !1 || a.tagName === "SCRIPT" && r(u) && (!l || l === "false")) && (a.setAttribute(u, ""), a.removeAttribute(u));
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(tE, tE.exports)), tE.exports;
}
(function(e, t) {
  "use client";
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(w, N) {
    for (var M in N)
      Object.defineProperty(w, M, {
        enumerable: !0,
        get: N[M]
      });
  }
  n(t, {
    default: function() {
      return y;
    },
    handleClientScriptLoad: function() {
      return f;
    },
    initScriptLoader: function() {
      return v;
    }
  });
  const o = qg, r = R0, i = gT, a = /* @__PURE__ */ o._($v), s = /* @__PURE__ */ r._(Fe), c = FHc(), l = qHc(), u = Mae(), d = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Set(), p = (w) => {
    if (a.default.preinit) {
      w.forEach((N) => {
        a.default.preinit(N, {
          as: "style"
        });
      });
      return;
    }
    if (typeof window < "u") {
      let N = document.head;
      w.forEach((M) => {
        let q = document.createElement("link");
        q.type = "text/css", q.rel = "stylesheet", q.href = M, N.appendChild(q);
      });
    }
  }, g = (w) => {
    const { src: N, id: M, onLoad: q = () => {
    }, onReady: L = null, dangerouslySetInnerHTML: R, children: T = "", strategy: D = "afterInteractive", onError: A, stylesheets: S } = w, E = M || N;
    if (E && _.has(E))
      return;
    if (d.has(N)) {
      _.add(E), d.get(N).then(q, A);
      return;
    }
    const x = () => {
      L && L(), _.add(E);
    }, k = document.createElement("script"), I = new Promise((z, F) => {
      k.addEventListener("load", function(P) {
        z(), q && q.call(this, P), x();
      }), k.addEventListener("error", function(P) {
        F(P);
      });
    }).catch(function(z) {
      A && A(z);
    });
    R ? (k.innerHTML = R.__html || "", x()) : T ? (k.textContent = typeof T == "string" ? T : Array.isArray(T) ? T.join("") : "", x()) : N && (k.src = N, d.set(N, I)), (0, l.setAttributesFromProps)(k, w), D === "worker" && k.setAttribute("type", "text/partytown"), k.setAttribute("data-nscript", D), S && p(S), document.body.appendChild(k);
  };
  function f(w) {
    const { strategy: N = "afterInteractive" } = w;
    N === "lazyOnload" ? window.addEventListener("load", () => {
      (0, u.requestIdleCallback)(() => g(w));
    }) : g(w);
  }
  function h(w) {
    document.readyState === "complete" ? (0, u.requestIdleCallback)(() => g(w)) : window.addEventListener("load", () => {
      (0, u.requestIdleCallback)(() => g(w));
    });
  }
  function $() {
    [
      ...document.querySelectorAll('[data-nscript="beforeInteractive"]'),
      ...document.querySelectorAll('[data-nscript="beforePageRender"]')
    ].forEach((N) => {
      const M = N.id || N.getAttribute("src");
      _.add(M);
    });
  }
  function v(w) {
    w.forEach(f), $();
  }
  function b(w) {
    const { id: N, src: M = "", onLoad: q = () => {
    }, onReady: L = null, strategy: R = "afterInteractive", onError: T, stylesheets: D, ...A } = w;
    let { updateScripts: S, scripts: E, getIsSsr: x, appDir: k, nonce: I } = (0, s.useContext)(c.HeadManagerContext);
    I = A.nonce || I;
    const z = (0, s.useRef)(!1);
    (0, s.useEffect)(() => {
      const P = N || M;
      z.current || (L && P && _.has(P) && L(), z.current = !0);
    }, [
      L,
      N,
      M
    ]);
    const F = (0, s.useRef)(!1);
    if ((0, s.useEffect)(() => {
      F.current || (R === "afterInteractive" ? g(w) : R === "lazyOnload" && h(w), F.current = !0);
    }, [
      w,
      R
    ]), (R === "beforeInteractive" || R === "worker") && (S ? (E[R] = (E[R] || []).concat([
      {
        id: N,
        src: M,
        onLoad: q,
        onReady: L,
        onError: T,
        ...A,
        nonce: I
      }
    ]), S(E)) : x && x() ? _.add(N || M) : x && !x() && g({
      ...w,
      nonce: I
    })), k) {
      if (D && D.forEach((P) => {
        a.default.preinit(P, {
          as: "style"
        });
      }), R === "beforeInteractive")
        return M ? (a.default.preload(M, A.integrity ? {
          as: "script",
          integrity: A.integrity,
          nonce: I,
          crossOrigin: A.crossOrigin
        } : {
          as: "script",
          nonce: I,
          crossOrigin: A.crossOrigin
        }), /* @__PURE__ */ (0, i.jsx)("script", {
          nonce: I,
          dangerouslySetInnerHTML: {
            __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
              M,
              {
                ...A,
                id: N
              }
            ]) + ")"
          }
        })) : (A.dangerouslySetInnerHTML && (A.children = A.dangerouslySetInnerHTML.__html, delete A.dangerouslySetInnerHTML), /* @__PURE__ */ (0, i.jsx)("script", {
          nonce: I,
          dangerouslySetInnerHTML: {
            __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
              0,
              {
                ...A,
                id: N
              }
            ]) + ")"
          }
        }));
      R === "afterInteractive" && M && a.default.preload(M, A.integrity ? {
        as: "script",
        integrity: A.integrity,
        nonce: I,
        crossOrigin: A.crossOrigin
      } : {
        as: "script",
        nonce: I,
        crossOrigin: A.crossOrigin
      });
    }
    return null;
  }
  Object.defineProperty(b, "__nextScript", {
    value: !0
  });
  const y = b;
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(m5, m5.exports);
var jHc = m5.exports, VHc = jHc;
const Mme = /* @__PURE__ */ Mi(VHc), mY = oe.string().min(1), Fme = process.env.NEXT_PUBLIC_FRESHCHAT_HOST, qme = process.env.NEXT_PUBLIC_FRESHCHAT_TOKEN;
mY.safeParse(Fme).success && mY.safeParse(qme).success;
function BHc() {
  const { data: e } = hr.viewer.me.get.useQuery();
  return /* @__PURE__ */ m(
    Mme,
    {
      id: "fresh-chat-sdk",
      src: "https://wchat.freshchat.com/js/widget.js",
      onLoad: () => {
        window.fcWidget.init({
          token: qme,
          host: Fme,
          externalId: e == null ? void 0 : e.id,
          lastName: e == null ? void 0 : e.name,
          email: e == null ? void 0 : e.email,
          meta: {
            username: e == null ? void 0 : e.username
          },
          open: !0
        });
      }
    }
  );
}
const UHc = Cr({ active: !1, setActive: () => {
} });
function GHc(e) {
  const [t, n] = it(!1);
  return /* @__PURE__ */ de(UHc.Provider, { value: { active: t, setActive: n }, children: [
    e.children,
    t && /* @__PURE__ */ m(BHc, {})
  ] });
}
function _x({ small: e }) {
  const { isPlatformUser: t } = MHc(), { t: n } = kt(), { data: o, isPending: r } = Z0(), i = Nr.usePathname(), a = i == null ? void 0 : i.startsWith("/settings/platform");
  yt(() => {
    const _ = window.Beacon;
    _ && _("session-data", {
      username: (o == null ? void 0 : o.username) || "Unknown",
      screenResolution: `${screen.width}x${screen.height}`
    });
  });
  const [s, c] = it(!1), [l, u] = it(!1), d = (_) => {
    _ == null || _.preventDefault(), _ == null || _.stopPropagation(), u(!0), c(!1);
  };
  return yt(() => {
    !s && l && (setTimeout(() => {
      var _;
      (_ = window.Support) == null || _.open();
    }, 0), u(!1));
  }, [s, l]), !o && !r ? null : /* @__PURE__ */ de(jd, { open: s, children: [
    /* @__PURE__ */ m(Hu, { asChild: !0, onClick: () => c((_) => !_), disabled: r, children: /* @__PURE__ */ de(
      "button",
      {
        "data-testid": "user-dropdown-trigger-button",
        className: xe(
          "hover:bg-emphasis todesktop:!bg-transparent group mx-0 flex w-full cursor-pointer appearance-none items-center rounded-full text-left outline-none transition focus:outline-none focus:ring-0 md:rounded-none lg:rounded",
          e ? "p-2" : "px-2 py-1.5"
        ),
        children: [
          /* @__PURE__ */ de(
            "span",
            {
              className: xe(
                e ? "h-4 w-4" : "h-5 w-5 ltr:mr-2 rtl:ml-2",
                "relative flex-shrink-0 rounded-full"
              ),
              children: [
                /* @__PURE__ */ m(
                  Dd,
                  {
                    size: e ? "xs" : "xsm",
                    imageSrc: (o == null ? void 0 : o.avatarUrl) ?? (o == null ? void 0 : o.avatar),
                    alt: o != null && o.username ? `${o.username} Avatar` : "Nameless User Avatar",
                    className: "overflow-hidden"
                  }
                ),
                /* @__PURE__ */ m(
                  "span",
                  {
                    className: xe(
                      "border-muted absolute -bottom-1 -right-1 rounded-full border bg-green-500",
                      e ? "-bottom-0.5 -right-0.5 h-2.5 w-2.5" : "-bottom-0.5 -right-0 h-2 w-2"
                    )
                  }
                )
              ]
            }
          ),
          !e && /* @__PURE__ */ de("span", { className: "flex flex-grow items-center gap-2", children: [
            /* @__PURE__ */ m("span", { className: "w-24 flex-shrink-0 text-sm leading-none", children: /* @__PURE__ */ m("span", { className: "text-emphasis block truncate py-0.5 font-medium leading-normal", children: r ? "Loading..." : (o == null ? void 0 : o.name) ?? "Nameless User" }) }),
            /* @__PURE__ */ m(
              qt,
              {
                name: "chevron-down",
                className: "group-hover:text-subtle text-muted h-4 w-4 flex-shrink-0 transition rtl:mr-4",
                "aria-hidden": "true"
              }
            )
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ m(cpe, { children: /* @__PURE__ */ m(GHc, { children: /* @__PURE__ */ m(
      Yu,
      {
        align: "start",
        onInteractOutside: () => {
          c(!1);
        },
        className: "group overflow-hidden rounded-md",
        children: /* @__PURE__ */ de(nt, { children: [
          !a && /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
              ba,
              {
                type: "button",
                CustomStartIcon: /* @__PURE__ */ m(qt, { name: "user", className: "text-default h-4 w-4", "aria-hidden": "true" }),
                href: "/settings/my-account/profile",
                children: n("my_profile")
              }
            ) }),
            /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
              ba,
              {
                type: "button",
                CustomStartIcon: /* @__PURE__ */ m(qt, { name: "settings", className: "text-default h-4 w-4", "aria-hidden": "true" }),
                href: "/settings/my-account/general",
                children: n("my_settings")
              }
            ) }),
            /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
              ba,
              {
                type: "button",
                CustomStartIcon: /* @__PURE__ */ m(qt, { name: "moon", className: "text-default h-4 w-4", "aria-hidden": "true" }),
                href: "/settings/my-account/out-of-office",
                children: n("out_of_office")
              }
            ) }),
            /* @__PURE__ */ m(EC, {})
          ] }),
          /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(ba, { StartIcon: "map", target: "_blank", href: vcc, children: n("visit_roadmap") }) }),
          /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
            ba,
            {
              type: "button",
              StartIcon: "circle-help",
              "aria-hidden": "true",
              onClick: d,
              children: n("help")
            }
          ) }),
          !a && /* @__PURE__ */ m(Pi, { className: "todesktop:hidden hidden lg:flex", children: /* @__PURE__ */ m(ba, { StartIcon: "download", target: "_blank", rel: "noreferrer", href: bcc, children: n("download_desktop_app") }) }),
          !a && t && /* @__PURE__ */ m(Pi, { className: "todesktop:hidden hidden lg:flex", children: /* @__PURE__ */ m(ba, { StartIcon: "blocks", target: "_blank", rel: "noreferrer", href: "/settings/platform", children: "Platform" }) }),
          /* @__PURE__ */ m(EC, {}),
          /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
            ba,
            {
              type: "button",
              StartIcon: "log-out",
              "aria-hidden": "true",
              onClick: () => {
                ru.signOut({ callbackUrl: "/auth/logout" });
              },
              children: n("sign_out")
            }
          ) })
        ] })
      }
    ) }) })
  ] });
}
const WHc = co(() => import("./index-8F8F8ovZ.js").then((e) => e.Tips), {
  ssr: !1
});
function HHc({ bannersHeight: e, isPlatformUser: t = !1 }) {
  const { status: n, data: o } = ru.useSession();
  return n !== "loading" && n !== "authenticated" ? null : /* @__PURE__ */ m(YHc, { isPlatformUser: t, bannersHeight: e, user: o == null ? void 0 : o.user });
}
function YHc({ bannersHeight: e, user: t }) {
  var d, _;
  const n = ru.useSession(), { t: o, isLocaleReady: r } = kt(), i = Nr.usePathname(), a = i == null ? void 0 : i.startsWith("/settings/platform"), s = ((d = n.data) == null ? void 0 : d.user.role) === Alc.ADMIN, c = `${Ry(((_ = t == null ? void 0 : t.org) == null ? void 0 : _.slug) ?? null)}/${t == null ? void 0 : t.orgAwareUsername}`, l = NHc({
    publicPageUrl: c,
    isAdmin: s,
    user: t
  }), u = {
    maxHeight: `calc(100vh - ${e}px)`,
    top: `${e}px`
  };
  return /* @__PURE__ */ m("div", { className: "relative", children: /* @__PURE__ */ de(
    "aside",
    {
      style: a ? {} : u,
      className: xe(
        "bg-muted border-muted fixed left-0 hidden h-full w-14 flex-col overflow-y-auto overflow-x-hidden border-r md:sticky md:flex lg:w-56 lg:px-3",
        !a && "max-h-screen"
      ),
      children: [
        /* @__PURE__ */ de("div", { className: "flex h-full flex-col justify-between py-3 lg:pt-4", children: [
          /* @__PURE__ */ de("header", { className: "todesktop:-mt-3 todesktop:flex-col-reverse todesktop:[-webkit-app-region:drag] items-center justify-between md:hidden lg:flex", children: [
            t != null && t.org ? Mse ? /* @__PURE__ */ m(PHc, {}) : /* @__PURE__ */ m(Ir, { href: "/settings/organizations/profile", className: "w-full px-1.5", children: /* @__PURE__ */ de("div", { className: "flex items-center gap-2 font-medium", children: [
              /* @__PURE__ */ m(
                Dd,
                {
                  alt: `${t.org.name} logo`,
                  imageSrc: yA(t.org.logoUrl, t.org.name),
                  size: "xsm"
                }
              ),
              /* @__PURE__ */ m("p", { className: "text line-clamp-1 text-sm", children: /* @__PURE__ */ m("span", { children: t.org.name }) })
            ] }) }) : /* @__PURE__ */ de("div", { "data-testid": "user-dropdown-trigger", className: "todesktop:mt-4 w-full", children: [
              /* @__PURE__ */ m("span", { className: "hidden lg:inline", children: /* @__PURE__ */ m(_x, {}) }),
              /* @__PURE__ */ m("span", { className: "hidden md:inline lg:hidden", children: /* @__PURE__ */ m(_x, { small: !0 }) })
            ] }),
            /* @__PURE__ */ de("div", { className: "flex w-full justify-end rtl:space-x-reverse", children: [
              /* @__PURE__ */ m(
                "button",
                {
                  color: "minimal",
                  onClick: () => window.history.back(),
                  className: "todesktop:block hover:text-emphasis text-subtle group hidden text-sm font-medium",
                  children: /* @__PURE__ */ m(
                    qt,
                    {
                      name: "arrow-left",
                      className: "group-hover:text-emphasis text-subtle h-4 w-4 flex-shrink-0"
                    }
                  )
                }
              ),
              /* @__PURE__ */ m(
                "button",
                {
                  color: "minimal",
                  onClick: () => window.history.forward(),
                  className: "todesktop:block hover:text-emphasis text-subtle group hidden text-sm font-medium",
                  children: /* @__PURE__ */ m(
                    qt,
                    {
                      name: "arrow-right",
                      className: "group-hover:text-emphasis text-subtle h-4 w-4 flex-shrink-0"
                    }
                  )
                }
              ),
              !!(t != null && t.org) && /* @__PURE__ */ m("div", { "data-testid": "user-dropdown-trigger", className: "flex items-center", children: /* @__PURE__ */ m(_x, { small: !0 }) }),
              /* @__PURE__ */ m(Rq, {})
            ] })
          ] }),
          /* @__PURE__ */ m(Ir, { href: "/event-types", className: "text-center md:inline lg:hidden", children: /* @__PURE__ */ m(zme, { small: !0, icon: !0 }) }),
          /* @__PURE__ */ m(AHc, { isPlatformNavigation: a })
        ] }),
        !a && /* @__PURE__ */ de("div", { children: [
          /* @__PURE__ */ m("div", { className: "overflow-hidden", children: /* @__PURE__ */ m(WHc, {}) }),
          l.map((p, g) => /* @__PURE__ */ m(Sr, { side: "right", content: o(p.name), className: "lg:hidden", children: /* @__PURE__ */ de(
            lpe,
            {
              id: p.name,
              href: p.href || void 0,
              "aria-label": o(p.name),
              target: p.target,
              className: xe(
                "text-left",
                "[&[aria-current='page']]:bg-emphasis text-default justify-right group flex items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
                "[&[aria-current='page']]:text-emphasis mt-0.5 w-full text-sm",
                r ? "hover:bg-emphasis hover:text-emphasis" : "",
                g === 0 && "mt-3"
              ),
              onClick: p.onClick,
              children: [
                !!p.icon && /* @__PURE__ */ m(
                  qt,
                  {
                    name: p.isLoading ? "rotate-cw" : p.icon,
                    className: xe(
                      "h-4 w-4 flex-shrink-0 [&[aria-current='page']]:text-inherit",
                      "me-3 md:mx-auto lg:ltr:mr-2 lg:rtl:ml-2",
                      p.isLoading && "animate-spin"
                    ),
                    "aria-hidden": "true"
                  }
                ),
                r ? /* @__PURE__ */ m("span", { className: "hidden w-full justify-between lg:flex", children: /* @__PURE__ */ m("div", { className: "flex", children: o(p.name) }) }) : /* @__PURE__ */ m(Yo, { className: "h-[20px] w-full" })
              ]
            }
          ) }, p.name)),
          !kcc && /* @__PURE__ */ m(bHc, {})
        ] })
      ]
    }
  ) });
}
function KHc() {
  const { status: e } = ru.useSession();
  return e !== "authenticated" ? null : /* @__PURE__ */ m(ZHc, {});
}
function ZHc() {
  const e = tm(), { t } = kt();
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(
    "nav",
    {
      style: e ? { display: "none" } : {},
      className: "bg-muted border-subtle sticky top-0 z-40 flex w-full items-center justify-between border-b bg-opacity-50 px-4 py-1.5 backdrop-blur-lg sm:p-4 md:hidden",
      children: [
        /* @__PURE__ */ m(Ir, { href: "/event-types", children: /* @__PURE__ */ m(zme, {}) }),
        /* @__PURE__ */ de("div", { className: "flex items-center gap-2 self-center", children: [
          /* @__PURE__ */ m("span", { className: "hover:bg-muted hover:text-emphasis text-default group flex items-center rounded-full text-sm font-medium transition lg:hidden", children: /* @__PURE__ */ m(Rq, {}) }),
          /* @__PURE__ */ de("button", { className: "hover:bg-muted hover:text-subtle text-muted rounded-full p-1 transition focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2", children: [
            /* @__PURE__ */ m("span", { className: "sr-only", children: t("settings") }),
            /* @__PURE__ */ m(Ir, { href: "/settings/my-account/profile", children: /* @__PURE__ */ m(qt, { name: "settings", className: "text-default h-4 w-4", "aria-hidden": "true" }) })
          ] }),
          /* @__PURE__ */ m(_x, { small: !0 })
        ] })
      ]
    }
  ) });
}
const XHc = {
  default: "bg-gradient-primary",
  warning: "bg-orange-400",
  error: "bg-red-400"
}, Oz = {
  className: "text-emphasis h-4 w-4 stroke-[2.5px]"
};
function Ov(e) {
  const { icon: t, variant: n = "default", text: o, actions: r } = e, a = (() => {
    switch (n) {
      case "error":
        return /* @__PURE__ */ m(qt, { ...Oz, name: "triangle-alert", "data-testid": "variant-error" });
      case "warning":
        return /* @__PURE__ */ m(qt, { ...Oz, name: "info", "data-testid": "variant-warning" });
      default:
        return null;
    }
  })();
  return /* @__PURE__ */ m(
    "div",
    {
      "data-testid": "banner",
      style: { minHeight: qse },
      className: Ia(
        "flex w-full items-start justify-between gap-8 px-4 py-2 text-center lg:items-center",
        XHc[n]
      ),
      children: /* @__PURE__ */ de("div", { className: "flex flex-1 flex-col items-start justify-center gap-2 px-1 py-0.5 lg:flex-row lg:items-center", children: [
        /* @__PURE__ */ de("p", { className: "text-emphasis flex flex-col items-start justify-center gap-2 text-left font-sans text-sm font-medium leading-4 lg:flex-row lg:items-center", children: [
          t ? /* @__PURE__ */ m(qt, { ...Oz, name: t, "data-testid": "variant-default" }) : a,
          o
        ] }),
        r && /* @__PURE__ */ m("div", { className: "text-sm font-medium", children: r })
      ] })
    }
  );
}
function JHc({ data: e }) {
  var r, i;
  const { t } = kt();
  if (!(e != null && e.user.impersonatedBy))
    return null;
  const n = e.user.impersonatedBy.id, o = e.user.impersonatedBy.role == "ADMIN" || ((i = (r = e.user) == null ? void 0 : r.org) == null ? void 0 : i.id);
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
    Ov,
    {
      text: t("impersonating_user_warning", { user: e.user.orgAwareUsername || e.user.username }),
      variant: "warning",
      actions: o ? /* @__PURE__ */ m(
        "form",
        {
          onSubmit: (a) => {
            a.preventDefault(), ru.signIn("impersonation-auth", { returnToId: n });
          },
          children: /* @__PURE__ */ m("button", { className: "text-emphasis hover:underline", "data-testid": "stop-impersonating-button", children: t("impersonating_stop_instructions") })
        }
      ) : /* @__PURE__ */ m("a", { className: "border-b border-b-black", href: "/auth/logout", children: t("impersonating_stop_instructions") })
    }
  ) });
}
function QHc({ data: e }) {
  const { t } = kt(), n = Nr.useRouter(), o = Kr(), r = hr.viewer.organizations.publish.useMutation({
    onSuccess(a) {
      n.push(a.url);
    },
    onError: (a) => {
      ti(a.message, "error");
    }
  });
  if (!e)
    return null;
  const [i] = e;
  return !i || o ? null : /* @__PURE__ */ m(
    Ov,
    {
      text: t("org_upgrade_banner_description", { teamName: i.team.name }),
      variant: "warning",
      actions: /* @__PURE__ */ m(
        "button",
        {
          "data-testid": "upgrade_org_banner_button",
          className: "border-b border-b-black",
          onClick: () => {
            r.mutate();
          },
          children: t("upgrade_banner_action")
        }
      )
    }
  );
}
const eYc = {
  lg: "12px",
  base: "8px",
  sm: "10px",
  xs: "8px"
};
function $A({ children: e, combined: t = !1, containerProps: n }) {
  var s;
  const o = Fe.Children.toArray(e)[0], r = ((s = o == null ? void 0 : o.props) == null ? void 0 : s.size) || "base", i = eYc[r];
  return /* @__PURE__ */ m(
    "div",
    {
      ...n,
      style: t ? { "--btn-group-radius": i } : void 0,
      className: xe(
        "flex",
        t ? "[&>*:first-child]:rounded-l-[var(--btn-group-radius)] rtl:[&>*:first-child]:rounded-l-none rtl:[&>*:first-child]:rounded-r-[var(--btn-group-radius)] [&>*:last-child]:rounded-r-[var(--btn-group-radius)] rtl:[&>*:last-child]:rounded-l-[var(--btn-group-radius)] rtl:[&>*:last-child]:rounded-r-none [&>*:not(:first-child)]:-ml-[1px] [&>*]:rounded-none [&>*]:border hover:[&>*]:z-[1]" : "space-x-2 rtl:space-x-reverse",
        n == null ? void 0 : n.className
      ),
      children: e
    }
  );
}
function e$({
  Icon: e,
  customIcon: t,
  avatar: n,
  headline: o,
  description: r,
  buttonText: i,
  buttonOnClick: a,
  buttonRaw: s,
  border: c = !0,
  dashedBorder: l = !0,
  className: u,
  iconClassName: d,
  iconWrapperClassName: _,
  limitWidth: p = !0
}) {
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(
    "div",
    {
      "data-testid": "empty-screen",
      className: xe(
        "flex w-full select-none flex-col items-center justify-center rounded-lg p-7 lg:p-20",
        c && "border-subtle border",
        l && "border-dashed",
        u
      ),
      children: [
        n ? /* @__PURE__ */ m("div", { className: "flex h-[72px] w-[72px] items-center justify-center rounded-full", children: n }) : null,
        e ? /* @__PURE__ */ m(
          "div",
          {
            className: xe(
              "bg-emphasis flex h-[72px] w-[72px] items-center justify-center rounded-full ",
              _
            ),
            children: /* @__PURE__ */ m(
              qt,
              {
                name: e,
                className: xe("text-default inline-block h-10 w-10 stroke-[1.3px]", d)
              }
            )
          }
        ) : null,
        t ? /* @__PURE__ */ m(nt, { children: t }) : null,
        /* @__PURE__ */ de("div", { className: `flex ${p ? "max-w-[420px]" : ""}  flex-col items-center`, children: [
          /* @__PURE__ */ m(
            "h2",
            {
              className: xe(
                "text-semibold font-cal text-emphasis text-center text-xl normal-nums",
                e && "mt-6",
                !r && "mb-8"
              ),
              children: o
            }
          ),
          r && /* @__PURE__ */ m("div", { className: "text-default mb-8 mt-3 text-center text-sm font-normal leading-6", children: r }),
          a && i && /* @__PURE__ */ m(Jt, { onClick: (g) => a(g), children: i }),
          s
        ] })
      ]
    }
  ) });
}
function tYc(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var jme = tYc;
function nYc(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, r = Array(o); ++n < o; )
    r[n] = t(e[n], n, e);
  return r;
}
var Lq = nYc;
function oYc(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var rYc = oYc, iYc = typeof Dt == "object" && Dt && Dt.Object === Object && Dt, Vme = iYc, aYc = Vme, sYc = typeof self == "object" && self && self.Object === Object && self, cYc = aYc || sYc || Function("return this")(), K_ = cYc, lYc = K_, uYc = lYc.Symbol, t$ = uYc, fY = t$, Bme = Object.prototype, dYc = Bme.hasOwnProperty, _Yc = Bme.toString, lw = fY ? fY.toStringTag : void 0;
function pYc(e) {
  var t = dYc.call(e, lw), n = e[lw];
  try {
    e[lw] = void 0;
    var o = !0;
  } catch {
  }
  var r = _Yc.call(e);
  return o && (t ? e[lw] = n : delete e[lw]), r;
}
var mYc = pYc, fYc = Object.prototype, gYc = fYc.toString;
function hYc(e) {
  return gYc.call(e);
}
var vYc = hYc, gY = t$, bYc = mYc, yYc = vYc, $Yc = "[object Null]", wYc = "[object Undefined]", hY = gY ? gY.toStringTag : void 0;
function kYc(e) {
  return e == null ? e === void 0 ? wYc : $Yc : hY && hY in Object(e) ? bYc(e) : yYc(e);
}
var n$ = kYc;
function SYc(e) {
  return e != null && typeof e == "object";
}
var Cf = SYc, EYc = n$, xYc = Cf, CYc = "[object Arguments]";
function TYc(e) {
  return xYc(e) && EYc(e) == CYc;
}
var AYc = TYc, vY = AYc, IYc = Cf, Ume = Object.prototype, OYc = Ume.hasOwnProperty, NYc = Ume.propertyIsEnumerable, zYc = vY(/* @__PURE__ */ function() {
  return arguments;
}()) ? vY : function(e) {
  return IYc(e) && OYc.call(e, "callee") && !NYc.call(e, "callee");
}, wA = zYc, RYc = Array.isArray, Z_ = RYc, zC = { exports: {} };
function PYc() {
  return !1;
}
var DYc = PYc;
zC.exports;
(function(e, t) {
  var n = K_, o = DYc, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, a = i && i.exports === r, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || o;
  e.exports = l;
})(zC, zC.exports);
var kA = zC.exports, LYc = 9007199254740991, MYc = /^(?:0|[1-9]\d*)$/;
function FYc(e, t) {
  var n = typeof e;
  return t = t ?? LYc, !!t && (n == "number" || n != "symbol" && MYc.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var SA = FYc, qYc = 9007199254740991;
function jYc(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= qYc;
}
var Mq = jYc, VYc = n$, BYc = Mq, UYc = Cf, GYc = "[object Arguments]", WYc = "[object Array]", HYc = "[object Boolean]", YYc = "[object Date]", KYc = "[object Error]", ZYc = "[object Function]", XYc = "[object Map]", JYc = "[object Number]", QYc = "[object Object]", eKc = "[object RegExp]", tKc = "[object Set]", nKc = "[object String]", oKc = "[object WeakMap]", rKc = "[object ArrayBuffer]", iKc = "[object DataView]", aKc = "[object Float32Array]", sKc = "[object Float64Array]", cKc = "[object Int8Array]", lKc = "[object Int16Array]", uKc = "[object Int32Array]", dKc = "[object Uint8Array]", _Kc = "[object Uint8ClampedArray]", pKc = "[object Uint16Array]", mKc = "[object Uint32Array]", ua = {};
ua[aKc] = ua[sKc] = ua[cKc] = ua[lKc] = ua[uKc] = ua[dKc] = ua[_Kc] = ua[pKc] = ua[mKc] = !0;
ua[GYc] = ua[WYc] = ua[rKc] = ua[HYc] = ua[iKc] = ua[YYc] = ua[KYc] = ua[ZYc] = ua[XYc] = ua[JYc] = ua[QYc] = ua[eKc] = ua[tKc] = ua[nKc] = ua[oKc] = !1;
function fKc(e) {
  return UYc(e) && BYc(e.length) && !!ua[VYc(e)];
}
var gKc = fKc;
function hKc(e) {
  return function(t) {
    return e(t);
  };
}
var Fq = hKc, RC = { exports: {} };
RC.exports;
(function(e, t) {
  var n = Vme, o = t && !t.nodeType && t, r = o && !0 && e && !e.nodeType && e, i = r && r.exports === o, a = i && n.process, s = function() {
    try {
      var c = r && r.require && r.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(RC, RC.exports);
var qq = RC.exports, vKc = gKc, bKc = Fq, bY = qq, yY = bY && bY.isTypedArray, yKc = yY ? bKc(yY) : vKc, jq = yKc, $Kc = rYc, wKc = wA, kKc = Z_, SKc = kA, EKc = SA, xKc = jq, CKc = Object.prototype, TKc = CKc.hasOwnProperty;
function AKc(e, t) {
  var n = kKc(e), o = !n && wKc(e), r = !n && !o && SKc(e), i = !n && !o && !r && xKc(e), a = n || o || r || i, s = a ? $Kc(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || TKc.call(e, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    EKc(l, c))) && s.push(l);
  return s;
}
var Gme = AKc, IKc = Object.prototype;
function OKc(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || IKc;
  return e === n;
}
var Vq = OKc;
function NKc(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Wme = NKc, zKc = Wme, RKc = zKc(Object.keys, Object), PKc = RKc, DKc = Vq, LKc = PKc, MKc = Object.prototype, FKc = MKc.hasOwnProperty;
function qKc(e) {
  if (!DKc(e))
    return LKc(e);
  var t = [];
  for (var n in Object(e))
    FKc.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var jKc = qKc;
function VKc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Vd = VKc, BKc = n$, UKc = Vd, GKc = "[object AsyncFunction]", WKc = "[object Function]", HKc = "[object GeneratorFunction]", YKc = "[object Proxy]";
function KKc(e) {
  if (!UKc(e))
    return !1;
  var t = BKc(e);
  return t == WKc || t == HKc || t == GKc || t == YKc;
}
var Bq = KKc, ZKc = Bq, XKc = Mq;
function JKc(e) {
  return e != null && XKc(e.length) && !ZKc(e);
}
var EA = JKc, QKc = Gme, eZc = jKc, tZc = EA;
function nZc(e) {
  return tZc(e) ? QKc(e) : eZc(e);
}
var Tf = nZc;
const oZc = /* @__PURE__ */ Cr(void 0), rZc = { setTheme: (e) => {
}, themes: [] }, iZc = () => {
  var e;
  return (e = bo(oZc)) !== null && e !== void 0 ? e : rZc;
};
function Hme(e, t = !1) {
  if (typeof window < "u") {
    const s = vr.getItem("app-theme");
    e = e ?? s ?? "system";
  }
  const { resolvedTheme: n, setTheme: o, forcedTheme: r, theme: i } = iZc(), a = q0c();
  if (yt(() => {
    if (t || e === void 0)
      return;
    const s = a ? a === "auto" ? "system" : a : e;
    !s || s === i || o(s);
  }, [e, o, a]), t)
    return {
      resolvedTheme: n,
      forcedTheme: r,
      activeTheme: i
    };
}
function dsu() {
  const e = Hme(null, !0);
  if (!e)
    throw new Error("useTheme must have a return value here");
  return e;
}
const aZc = ({
  i18nKey: e,
  components: t = [],
  t: n,
  values: o = {},
  children: r,
  parent: i
}) => {
  const a = { ...o }, s = n(e, a);
  if (!s && r)
    return /* @__PURE__ */ m(nt, { children: r });
  if (!s)
    return /* @__PURE__ */ m(nt, {});
  let c;
  return Array.isArray(t) && t.length > 0 ? c = cZc(s, t) : sZc(t) && Object.keys(t).length > 0 ? c = lZc(s, t) : c = Pp(s), i ? /* @__PURE__ */ m(i, { children: c }) : /* @__PURE__ */ m(nt, { children: c });
}, sZc = (e) => e !== null && typeof e == "object" && !Array.isArray(e), cZc = (e, t) => {
  const n = [];
  let o = "";
  const r = (a) => {
    for (let s = 0; s < a.length; s++) {
      if (a[s] === "<" && /\d/.test(a[s + 1])) {
        let c = "", l = s + 1;
        for (; l < a.length && /\d/.test(a[l]); )
          c += a[l], l++;
        if (l < a.length && a[l] === ">") {
          o && (n.push(...Pp(o)), o = "");
          const u = `</${c}>`, d = i(a.substring(l + 1), c);
          if (d !== null) {
            const _ = parseInt(c, 10);
            if (_ < t.length) {
              const p = t[_];
              zd(p) ? n.push(
                gf(
                  p,
                  {
                    ...p.props || {},
                    key: p.key || `comp-${_}`
                  },
                  ...Pp(d)
                )
              ) : n.push(...Pp(d));
            } else
              n.push(...Pp(d));
            s = l + d.length + u.length;
            continue;
          }
        }
      }
      o += a[s];
    }
    o && n.push(...Pp(o));
  }, i = (a, s) => {
    let c = 1, l = "";
    for (let u = 0; u < a.length; u++) {
      if (a[u] === "<" && a.substring(u + 1, u + 1 + s.length) === s && a[u + 1 + s.length] === ">") {
        c++, l += a.substring(u, u + 2 + s.length), u += 1 + s.length;
        continue;
      }
      if (a[u] === "<" && a.substring(u + 1, u + 2 + s.length) === `/${s}` && a[u + 2 + s.length] === ">") {
        if (c--, c === 0)
          return l;
        l += a.substring(u, u + 3 + s.length), u += 2 + s.length;
        continue;
      }
      l += a[u];
    }
    return null;
  };
  return r(e), n.length > 0 ? n : [e];
}, lZc = (e, t) => {
  let n = e;
  const o = {};
  Object.keys(t).forEach((c) => {
    const l = new RegExp(`{{\\s*${c}\\s*}}`, "g");
    n = n.replace(l, (u) => {
      const d = `__INTERP_${c}_${Math.random().toString(36).substring(2)}__`;
      return zd(t[c]) && (o[d] = gf(t[c], {
        ...t[c].props || {},
        key: t[c].key || `interp-${c}`
      })), d;
    });
  }), Object.keys(t).forEach((c) => {
    const l = new RegExp(`<${c}>(.*?)<\\/${c}>`, "gs");
    n = n.replace(l, (u, d) => {
      const _ = `__TAG_${c}_${Math.random().toString(36).substring(2)}__`;
      if (zd(t[c])) {
        const p = Pp(d);
        o[_] = gf(
          t[c],
          {
            ...t[c].props || {},
            key: t[c].key || `tag-${c}`
          },
          ...p.length > 1 ? p : [d]
        );
      }
      return _;
    });
  });
  const r = [];
  let i = 0;
  const a = /__(?:INTERP|TAG)_[^_]+_[a-z0-9]+__/g;
  let s;
  for (; (s = a.exec(n)) !== null; ) {
    const [c] = s, l = s.index;
    if (l > i) {
      const u = n.substring(i, l);
      r.push(...Pp(u));
    }
    o[c] && r.push(o[c]), i = l + c.length;
  }
  if (i < n.length) {
    const c = n.substring(i);
    r.push(...Pp(c));
  }
  return r.length > 0 ? r : [n];
}, Pp = (e) => {
  if (!e || typeof e != "string")
    return [e].filter(Boolean);
  if (!/<[a-z][\s\S]*>/i.test(e))
    return [e];
  const t = [
    { tag: "strong", component: "strong" },
    { tag: "b", component: "b" },
    { tag: "i", component: "i" },
    { tag: "em", component: "em" },
    { tag: "p", component: "p" },
    { tag: "br", component: "br", selfClosing: !0 },
    { tag: "div", component: "div" },
    { tag: "span", component: "span" },
    { tag: "ul", component: "ul" },
    { tag: "ol", component: "ol" },
    { tag: "li", component: "li" }
  ];
  let n = e;
  const o = {};
  if (t.forEach(({ tag: c, component: l, selfClosing: u }) => {
    if (u) {
      const d = new RegExp(`<${c}\\s*\\/>`, "g");
      n = n.replace(d, (_) => {
        const p = `__HTML_${c}_${Math.random().toString(36).substring(2)}__`;
        return o[p] = pt(l, { key: p }), p;
      });
    } else {
      const d = new RegExp(`<${c}>(.*?)<\\/${c}>`, "gs");
      n = n.replace(d, (_, p) => {
        const g = `__HTML_${c}_${Math.random().toString(36).substring(2)}__`, f = Pp(p);
        return o[g] = pt(
          l,
          { key: g },
          ...f.length > 1 ? f : [p]
        ), g;
      });
    }
  }), Object.keys(o).length === 0)
    return [n];
  const r = [];
  let i = 0;
  const a = /__HTML_[^_]+_[a-z0-9]+__/g;
  let s;
  for (; (s = a.exec(n)) !== null; ) {
    const [c] = s, l = s.index;
    l > i && r.push(n.substring(i, l)), o[c] && r.push(o[c]), i = l + c.length;
  }
  return i < n.length && r.push(n.substring(i)), r.length > 0 ? r : [n];
}, Ld = aZc, uZc = ({
  orgSlug: e,
  teamSlug: t
}, n) => {
  const o = Ry(e, n);
  return t = t || "", e ? `${o}/${t}` : `${o}/team/${t}`;
};
function dZc({ data: e }) {
  const { t } = kt(), n = Nr.useRouter(), o = hr.viewer.teams.publish.useMutation({
    onSuccess(i) {
      n.push(i.url);
    },
    onError: (i) => {
      ti(i.message, "error");
    }
  });
  if (!e)
    return null;
  const [r] = e;
  return r ? /* @__PURE__ */ m(
    Ov,
    {
      text: t("team_upgrade_banner_description", { teamName: r.team.name }),
      variant: "warning",
      actions: /* @__PURE__ */ m(
        "button",
        {
          className: "border-b border-b-black",
          onClick: () => {
            o.mutate({ teamId: r.team.id });
          },
          children: t("upgrade_banner_action")
        }
      )
    }
  ) : null;
}
function _Zc({ data: e }) {
  const { t } = kt();
  return (e == null ? void 0 : e.user.role) !== "INACTIVE_ADMIN" ? null : /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
    Ov,
    {
      text: t("invalid_admin_password", { user: e.user.username }),
      variant: "warning",
      actions: /* @__PURE__ */ m(Ir, { href: "/settings/security/password", className: "border-b border-b-black", children: t("change_password_admin") })
    }
  ) });
}
function pZc({ data: e }) {
  const { t } = kt();
  return e ? /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
    Ov,
    {
      text: `${t("something_went_wrong")} ${t("calendar_error")}`,
      variant: "error",
      actions: /* @__PURE__ */ m(Ir, { href: "/apps/installed/calendar", className: "border-b border-b-black", children: t("check_here") })
    }
  ) }) : null;
}
function mZc({ data: e }) {
  return e.length === 0 ? null : /* @__PURE__ */ m("div", { children: e.map((t) => /* @__PURE__ */ m(fZc, { name: t.name, slug: t.slug }, t.slug)) });
}
function fZc({ name: e, slug: t }) {
  const { t: n } = kt(), o = Nr.useRouter(), r = () => {
    o.push(`/apps/${t}`);
  };
  return /* @__PURE__ */ m(
    Ov,
    {
      text: ` ${n("invalid_credential", { appName: e })} `,
      variant: "warning",
      actions: /* @__PURE__ */ m("button", { className: "border-b border-b-black", onClick: r, children: n("invalid_credential_action") })
    }
  );
}
function gZc({ data: e }) {
  const t = Oq(), { t: n } = kt(), o = hr.viewer.auth.resendVerifyEmail.useMutation();
  return !e || !t["email-verification"] ? null : /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
    Ov,
    {
      icon: "mail",
      text: n("verify_email_banner_body", { appName: Kp }),
      variant: "warning",
      actions: /* @__PURE__ */ m(
        "a",
        {
          className: "underline hover:cursor-pointer",
          onClick: () => {
            o.mutate(), ti(n("email_sent"), "success");
          },
          children: n("resend_email")
        }
      )
    }
  ) });
}
const _h = {
  teamUpgradeBanner: (e) => /* @__PURE__ */ m(dZc, { ...e }),
  orgUpgradeBanner: (e) => /* @__PURE__ */ m(QHc, { ...e }),
  verifyEmailBanner: (e) => /* @__PURE__ */ m(gZc, { ...e }),
  adminPasswordBanner: (e) => /* @__PURE__ */ m(_Zc, { ...e }),
  impersonationBanner: (e) => /* @__PURE__ */ m(JHc, { ...e }),
  calendarCredentialBanner: (e) => /* @__PURE__ */ m(pZc, { ...e }),
  invalidAppCredentialBanners: (e) => /* @__PURE__ */ m(mZc, { ...e })
}, hZc = ({ banners: e }) => /* @__PURE__ */ m("div", { className: "sticky top-0 z-10 w-full divide-y divide-black", children: Object.keys(e).map((t) => {
  if (t === "teamUpgradeBanner") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "orgUpgradeBanner") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "verifyEmailBanner") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "adminPasswordBanner") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "impersonationBanner") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "calendarCredentialBanner") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "invalidAppCredentialBanners") {
    const n = _h[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  }
}) }), vZc = () => {
  var s;
  const { data: e, isPending: t } = hr.viewer.me.getUserTopBanners.useQuery(), { data: n } = ru.useSession();
  if (t || !n)
    return null;
  const o = (n == null ? void 0 : n.user.role) === "INACTIVE_ADMIN", r = (s = n == null ? void 0 : n.user.impersonatedBy) == null ? void 0 : s.id;
  return Object.assign({}, e, {
    adminPasswordBanner: o ? n : null,
    impersonationBanner: r ? n : null
  });
}, bZc = (e) => vn(() => {
  const n = e && Object.entries(e).filter(([o, r]) => r && (!Array.isArray(r) || r.length > 0));
  return ((n == null ? void 0 : n.length) ?? 0) * qse;
}, [e]), yZc = () => {
  const e = vZc(), t = bZc(e);
  return { banners: e, bannersHeight: t };
}, $Zc = (e) => {
  yt(() => {
    Object.entries(e).forEach(([t, n]) => {
      if (!n)
        return;
      if (t === "root") {
        const i = document.documentElement;
        Object.entries(n).forEach(([a, s]) => {
          i.style.setProperty(`--${a}`, s);
        });
        return;
      }
      const o = document.querySelectorAll(`.${t}`);
      Object.entries(n).forEach(([i, a]) => {
        o.forEach((s) => {
          s.style.setProperty(`--${i}`, a);
        });
      });
    });
  }, [e]);
}, wZc = () => {
  const { data: e } = Z0(), t = r1c({
    lightVal: e == null ? void 0 : e.brandColor,
    darkVal: e == null ? void 0 : e.darkBrandColor
  });
  $Zc(t), Hme(e == null ? void 0 : e.appTheme);
}, Yme = (e) => {
  const { banners: t, bannersHeight: n } = yZc();
  return Nr.usePathname(), Z7c(), /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(Vde, { position: "bottom-right" }) }),
    /* @__PURE__ */ m(q7c, {}),
    /* @__PURE__ */ de("div", { className: "flex min-h-screen flex-col", children: [
      t && !e.isPlatformUser && /* @__PURE__ */ m(hZc, { banners: t }),
      /* @__PURE__ */ de("div", { className: "flex flex-1", "data-testid": "dashboard-shell", children: [
        e.SidebarContainer ? gf(e.SidebarContainer, { bannersHeight: n }) : /* @__PURE__ */ m(HHc, { isPlatformUser: e.isPlatformUser, bannersHeight: n }),
        /* @__PURE__ */ m("div", { className: "flex w-0 flex-1 flex-col", children: /* @__PURE__ */ m(EZc, { ...e }) })
      ] })
    ] })
  ] });
}, Kme = ({ children: e, withKBar: t = !1 }) => t ? /* @__PURE__ */ de(z7c, { children: [
  e,
  /* @__PURE__ */ m(R7c, {})
] }) : /* @__PURE__ */ m(nt, { children: e }), kZc = (e) => {
  const { status: t } = ru.useSession();
  return /* @__PURE__ */ m(Kme, { withKBar: t === "authenticated", children: /* @__PURE__ */ m(Yme, { ...e }) });
};
function Zme(e) {
  return kEc(e.isPublic), CEc(), wZc(), e.isPublic ? /* @__PURE__ */ m(kZc, { ...e }) : /* @__PURE__ */ m(Kme, { withKBar: !0, children: /* @__PURE__ */ m(Yme, { ...e }) });
}
function SZc(e) {
  const t = Nr.useRouter(), { isLocaleReady: n } = kt();
  return /* @__PURE__ */ de(nt, { children: [
    (e.heading || !!e.backPath) && /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "bg-default sticky top-0 z-10 mb-0 flex items-center py-2 md:mb-6 md:mt-0",
          e.smallHeading ? "lg:mb-7" : "lg:mb-8"
        ),
        children: [
          !!e.backPath && /* @__PURE__ */ m(
            Jt,
            {
              variant: "icon",
              size: "sm",
              color: "minimal",
              onClick: () => typeof e.backPath == "string" ? t.push(e.backPath) : t.back(),
              StartIcon: "arrow-left",
              "aria-label": "Go Back",
              className: "rounded-md ltr:mr-2 rtl:ml-2",
              "data-testid": "go-back-button"
            }
          ),
          e.heading && /* @__PURE__ */ de(
            "header",
            {
              className: xe(e.large && "py-8", "flex w-full max-w-full items-center truncate"),
              children: [
                e.HeadingLeftIcon && /* @__PURE__ */ m("div", { className: "ltr:mr-4", children: e.HeadingLeftIcon }),
                /* @__PURE__ */ de(
                  "div",
                  {
                    className: xe("w-full truncate ltr:mr-4 rtl:ml-4 md:block", e.headerClassName),
                    children: [
                      e.heading && /* @__PURE__ */ m(
                        "h3",
                        {
                          className: xe(
                            "font-cal text-emphasis max-w-28 sm:max-w-72 md:max-w-80 hidden truncate text-lg font-semibold tracking-wide sm:text-xl md:block xl:max-w-full",
                            e.smallHeading ? "text-base" : "text-xl"
                          ),
                          children: n ? e.heading : /* @__PURE__ */ m(Yo, { invisible: !0 })
                        }
                      ),
                      e.subtitle && /* @__PURE__ */ m("p", { className: "text-default hidden text-sm md:block", "data-testid": "subtitle", children: n ? e.subtitle : /* @__PURE__ */ m(Yo, { invisible: !0 }) })
                    ]
                  }
                ),
                e.beforeCTAactions,
                e.CTA && /* @__PURE__ */ m(
                  "div",
                  {
                    className: xe(
                      e.backPath ? "relative" : "pwa:bottom-[max(7rem,_calc(5rem_+_env(safe-area-inset-bottom)))] fixed bottom-20 z-40 ltr:right-4 rtl:left-4 md:z-auto md:ltr:right-0 md:rtl:left-0",
                      "flex-shrink-0 [-webkit-app-region:no-drag] md:relative md:bottom-auto md:right-auto"
                    ),
                    children: n && e.CTA
                  }
                ),
                e.actions && e.actions
              ]
            }
          )
        ]
      }
    ),
    e.afterHeading && /* @__PURE__ */ m(nt, { children: e.afterHeading }),
    /* @__PURE__ */ m("div", { className: xe(e.flexChildrenContainer && "flex flex-1 flex-col"), children: e.children })
  ] });
}
function EZc({
  isPlatformUser: e,
  MobileNavigationContainer: t = /* @__PURE__ */ m(IHc, { isPlatformNavigation: e }),
  TopNavContainer: n = /* @__PURE__ */ m(KHc, {}),
  ...o
}) {
  return /* @__PURE__ */ de("main", { className: "bg-default relative z-0 flex-1 pb-8 focus:outline-none", children: [
    n,
    /* @__PURE__ */ de("div", { className: "max-w-full p-2 sm:py-4 lg:px-6", children: [
      /* @__PURE__ */ m(J7c, {}),
      /* @__PURE__ */ m(kme, { children: o.withoutMain ? o.children : /* @__PURE__ */ m(SZc, { ...o, children: o.children }) }),
      o.backPath ? null : t
    ] })
  ] });
}
function Uq(e = "Sunday") {
  const n = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(e);
  return n !== -1 ? n : 0;
}
function Xme(e, t = "Sunday") {
  return (n, o) => {
    const r = Qy(e, Uq(t), "short"), i = (a) => {
      for (let s = 0; s < r.length; s++)
        if (a.includes(r[s]))
          return s;
      return -1;
    };
    return i(n) - i(o);
  };
}
function PC({ className: e, ...t }) {
  return e = xe("mx-3 text-muted", e), /* @__PURE__ */ m(
    "svg",
    {
      className: e,
      ...t,
      width: "2",
      height: "16",
      viewBox: "0 0 2 16",
      ry: "6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ m("rect", { width: "2", height: "16", rx: "1", fill: "currentColor" })
    }
  );
}
const xZc = function({
  value: t,
  onChange: n,
  isReady: o,
  disabled: r = !1,
  ...i
}) {
  const [a, s] = it(!1);
  return /* @__PURE__ */ m("div", { className: "group pointer-events-auto relative truncate", onClick: () => s(!r), children: /* @__PURE__ */ m("div", { className: Ia(!r && "cursor-pointer", "flex items-center"), children: /* @__PURE__ */ de("label", { className: "min-w-8 relative inline-block", children: [
    /* @__PURE__ */ de("span", { className: "whitespace-pre text-xl tracking-normal text-transparent", children: [
      t,
      " "
    ] }),
    /* @__PURE__ */ m(
      "input",
      {
        ...i,
        disabled: r,
        type: "text",
        value: t,
        required: !0,
        className: Ia(
          !r && "hover:text-default focus:text-emphasis cursor-pointer focus:outline-none focus:ring-0",
          "text-emphasis absolute left-0 top-0 w-full truncate border-none bg-transparent p-0 align-top text-xl ",
          i.className
        ),
        onFocus: (l) => {
          s(!r), i.onFocus && i.onFocus(l);
        },
        onBlur: (l) => {
          s(!1), i.onBlur && i.onBlur(l);
        },
        onChange: (l) => n && n(l.target.value)
      }
    ),
    !a && o && !r && /* @__PURE__ */ m(qt, { name: "pencil", className: "text-subtle group-hover:text-subtle -mt-px ml-1 inline  h-3 w-3" })
  ] }) }) });
}, Jme = (e) => /* @__PURE__ */ de("div", { className: ar(e.headerClassName, "flex flex-col px-10 py-4"), children: [
  /* @__PURE__ */ de("div", { className: "mb-6 flex items-center justify-between md:mb-6 md:mt-0 lg:mb-8", children: [
    /* @__PURE__ */ de("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ m("div", { children: e.heading }),
      /* @__PURE__ */ m("div", { className: "text-default text-sm", children: e.subtitle })
    ] }),
    /* @__PURE__ */ m("div", { children: e.CTA })
  ] }),
  /* @__PURE__ */ m("div", { children: e.children })
] }), CZc = () => {
  const e = "/timezones", { isLoading: t, data: n } = mr({
    queryKey: ["city-timezones"],
    queryFn: () => At == null ? void 0 : At.get(e).then((o) => {
      if (o.data.status === Nn)
        return o.data.data;
      throw new Error(o.data.error.message);
    })
  });
  return { isLoading: t, data: n };
}, TZc = CZc, $Y = (e) => e.map(({ city: t, timezone: n }) => ({
  label: t,
  timezone: n
})), AZc = (e, t) => t.filter(
  (n) => e.includes(n.timezone)
);
function Gq(e) {
  const { isLoading: t, data: n } = TZc(), o = vn(() => {
    if (e.timeZones) {
      const r = AZc(e.timeZones, n ?? []);
      return $Y(r);
    } else if (n && !t)
      return $Y(n);
    return [];
  }, [n, e.timeZones, t]);
  return /* @__PURE__ */ m(
    B_e,
    {
      ...e,
      data: o,
      isPending: t,
      isWebTimezoneSelect: !1
    }
  );
}
const wY = ({
  disabled: e,
  buttonClassName: t,
  isPending: n,
  onDeleteConfirmed: o,
  handleDelete: r
}) => {
  const { t: i } = kt();
  return /* @__PURE__ */ de(Ss, { children: [
    /* @__PURE__ */ m(q0, { asChild: !0, children: /* @__PURE__ */ m(
      Jt,
      {
        StartIcon: "trash",
        variant: "icon",
        color: "destructive",
        "aria-label": i("delete"),
        className: t,
        disabled: e,
        tooltip: i(e ? "requires_at_least_one_schedule" : "delete"),
        tooltipSide: "bottom"
      }
    ) }),
    /* @__PURE__ */ m(
      pv,
      {
        isPending: n,
        variety: "danger",
        title: i("delete_schedule"),
        confirmBtnText: i("delete"),
        loadingText: i("delete"),
        onConfirm: () => {
          r(), o == null || o();
        },
        children: i("delete_schedule_description")
      }
    )
  ] });
}, IZc = () => {
  const e = cf({ name: "dateOverrides" });
  return vn(() => e == null ? void 0 : e.map((t) => ht(t.ranges[0].start).utc().format("YYYY-MM-DD")), [e]);
}, OZc = ({
  workingHours: e,
  userTimeFormat: t,
  travelSchedules: n,
  weekStart: o,
  overridesModalClassNames: r,
  classNames: i,
  handleSubmit: a,
  isDryRun: s = !1
}) => {
  const { append: c, replace: l, fields: u } = M0({
    name: "dateOverrides"
  }), { getValues: d } = No(), _ = IZc(), { t: p } = kt(), g = () => {
    const f = d();
    s || a(f);
  };
  return /* @__PURE__ */ de("div", { className: ar("p-6", i == null ? void 0 : i.container), children: [
    /* @__PURE__ */ de("h3", { className: ar("text-emphasis font-medium leading-6", i == null ? void 0 : i.title), children: [
      p("date_overrides"),
      " ",
      /* @__PURE__ */ m(Sr, { content: p("date_overrides_info"), children: /* @__PURE__ */ m("span", { className: "inline-block align-middle", children: /* @__PURE__ */ m(qt, { name: "info", className: "h-4 w-4" }) }) })
    ] }),
    /* @__PURE__ */ m("p", { className: ar("text-subtle mb-4 text-sm", i == null ? void 0 : i.description), children: p("date_overrides_subtitle") }),
    /* @__PURE__ */ de("div", { className: "space-y-2", children: [
      /* @__PURE__ */ m(
        _Ec,
        {
          excludedDates: _,
          replace: l,
          fields: u,
          weekStart: o,
          workingHours: e,
          userTimeFormat: t,
          hour12: t === 12,
          travelSchedules: n,
          handleAvailabilityUpdate: g,
          isDryRun: s
        }
      ),
      /* @__PURE__ */ m(
        _pe,
        {
          className: r,
          workingHours: e,
          excludedDates: _,
          onChange: (f) => {
            f.forEach((h) => c({ ranges: [h] })), g();
          },
          userTimeFormat: t,
          weekStart: o,
          isDryRun: s,
          Trigger: /* @__PURE__ */ m(
            Jt,
            {
              className: i == null ? void 0 : i.button,
              color: "secondary",
              StartIcon: "plus",
              "data-testid": "add-override",
              children: p("add_an_override")
            }
          )
        }
      )
    ] })
  ] });
}, NZc = ({ open: e, children: t }) => /* @__PURE__ */ m(
  "div",
  {
    className: xe(
      e ? "fadeIn fixed inset-0 z-50 bg-neutral-800 bg-opacity-70 transition-opacity dark:bg-opacity-70 sm:hidden" : ""
    ),
    children: /* @__PURE__ */ m(
      "div",
      {
        className: xe(
          "bg-default fixed right-0 z-20 flex h-screen w-80 flex-col space-y-2 overflow-x-hidden rounded-md px-2 pb-3 transition-transform",
          e ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        ),
        children: e ? t : null
      }
    )
  }
), zZc = Bt(
  function(t, n) {
    var z;
    const {
      schedule: o,
      travelSchedules: r,
      handleDelete: i,
      isDeleting: a,
      isLoading: s,
      isSaving: c,
      timeFormat: l,
      weekStart: u,
      backPath: d,
      handleSubmit: _,
      isPlatform: p = !1,
      customClassNames: g,
      disableEditableHeading: f = !1,
      enableOverrides: h = !1,
      onFormStateChange: $,
      bulkUpdateModalProps: v,
      allowSetToDefault: b = !0,
      allowDelete: y = !0,
      callbacksRef: w,
      isDryRun: N
    } = t, [M, q] = it(!1), { t: L, i18n: R } = kt(), T = W_({
      defaultValues: {
        ...o,
        schedule: o.availability || []
      }
    }), D = cf({
      control: T.control
    });
    yt(() => {
      $ && D && $(D);
    }, [D, $]);
    const [A, S, E] = vn(() => p ? [Jme, upe, Gq] : [Zme, NSc, xq], [p]), x = xt(null), k = Yt(
      (F) => {
        w && F && (w.current = F), x.current ? x.current.click() : T.handleSubmit(async (P) => {
          var O, V, U, H;
          try {
            await _(P), (V = (O = w == null ? void 0 : w.current) == null ? void 0 : O.onSuccess) == null || V.call(O);
          } catch (J) {
            (H = (U = w == null ? void 0 : w.current) == null ? void 0 : U.onError) == null || H.call(U, J);
          }
        })();
      },
      [T, _, w]
    ), I = Yt(async () => ({
      isValid: await T.trigger(),
      errors: T.formState.errors
    }), [T]);
    return fre(
      n,
      () => ({
        validateForm: I,
        handleFormSubmit: k
      }),
      [I, k]
    ), /* @__PURE__ */ m(
      A,
      {
        headerClassName: ar(g == null ? void 0 : g.containerClassName),
        backPath: d,
        title: o.name ? `${o.name} | ${L("availability")}` : L("availability"),
        heading: /* @__PURE__ */ m(
          Bn,
          {
            control: T.control,
            name: "name",
            render: ({ field: F }) => /* @__PURE__ */ m(
              xZc,
              {
                className: ar(g == null ? void 0 : g.editableHeadingClassName),
                isReady: !s,
                disabled: f,
                ...F,
                "data-testid": "availablity-title"
              }
            )
          }
        ),
        subtitle: o ? o.schedule.filter((F) => !!F.days.length).map(
          (F) => spe(F, {
            locale: R.language,
            hour12: l === 12
          })
        ).sort(Xme(R.language, u)).map((F, P) => /* @__PURE__ */ de("span", { className: ar(g == null ? void 0 : g.subtitlesClassName), children: [
          F,
          /* @__PURE__ */ m("br", {})
        ] }, P)) : /* @__PURE__ */ m(Yo, { className: "h-4 w-48" }),
        CTA: /* @__PURE__ */ de("div", { className: ar(g == null ? void 0 : g.ctaClassName, "flex items-center justify-end"), children: [
          /* @__PURE__ */ m("div", { className: "sm:hover:bg-muted hidden items-center rounded-md px-2 transition sm:flex", children: !M && b ? /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(
              Gl,
              {
                as: Ko,
                htmlFor: "hiddenSwitch",
                className: "mt-2 cursor-pointer self-center pe-2",
                loadingClassName: "me-4",
                waitForTranslation: !p,
                children: L("set_to_default")
              }
            ),
            /* @__PURE__ */ m(
              Bn,
              {
                control: T.control,
                name: "isDefault",
                render: ({ field: { value: F, onChange: P } }) => {
                  var O, V;
                  return /* @__PURE__ */ m(
                    as,
                    {
                      id: "hiddenSwitch",
                      classNames: {
                        container: ar((O = g == null ? void 0 : g.hiddenSwitchClassname) == null ? void 0 : O.container),
                        thumb: ar((V = g == null ? void 0 : g.hiddenSwitchClassname) == null ? void 0 : V.thumb)
                      },
                      disabled: c || o.isDefault,
                      checked: F,
                      onCheckedChange: (U) => {
                        P(U), v == null || v.setIsOpen(U);
                      }
                    }
                  );
                }
              }
            ),
            /* @__PURE__ */ m(PC, { className: "hidden sm:inline" })
          ] }) : null }),
          v && (v == null ? void 0 : v.isOpen) && /* @__PURE__ */ m(
            G_e,
            {
              isPending: v == null ? void 0 : v.isSaving,
              open: v == null ? void 0 : v.isOpen,
              setOpen: v.setIsOpen,
              bulkUpdateFunction: v == null ? void 0 : v.save,
              description: L("default_schedules_bulk_description"),
              eventTypes: v == null ? void 0 : v.eventTypes,
              isEventTypesFetching: v == null ? void 0 : v.isEventTypesFetching,
              handleBulkEditDialogToggle: v.handleBulkEditDialogToggle
            }
          ),
          y && /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(
              wY,
              {
                buttonClassName: ar("hidden me-2 sm:inline", g == null ? void 0 : g.deleteButtonClassname),
                disabled: o.isLastSchedule,
                isPending: a,
                handleDelete: i
              }
            ),
            /* @__PURE__ */ m(PC, { className: "hidden sm:inline" })
          ] }),
          /* @__PURE__ */ m(NZc, { open: M, children: /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
            "div",
            {
              className: xe(
                M ? "fadeIn fixed inset-0 z-50 bg-neutral-800 bg-opacity-70 transition-opacity dark:bg-opacity-70 sm:hidden" : ""
              ),
              children: /* @__PURE__ */ de(
                "div",
                {
                  className: xe(
                    "bg-default fixed right-0 z-20 flex h-screen w-80 flex-col space-y-2 overflow-x-hidden rounded-md px-2 pb-3 transition-transform",
                    M ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
                  ),
                  children: [
                    /* @__PURE__ */ de("div", { className: "flex flex-row items-center pt-16", children: [
                      /* @__PURE__ */ m(Jt, { StartIcon: "arrow-left", color: "minimal", onClick: () => q(!1) }),
                      /* @__PURE__ */ m("p", { className: "-ml-2", children: L("availability_settings") }),
                      y && /* @__PURE__ */ m(
                        wY,
                        {
                          buttonClassName: ar("ml-16 inline", g == null ? void 0 : g.deleteButtonClassname),
                          disabled: o.isLastSchedule,
                          isPending: a,
                          handleDelete: i,
                          onDeleteConfirmed: () => {
                            q(!1);
                          }
                        }
                      )
                    ] }),
                    /* @__PURE__ */ de("div", { className: "flex flex-col px-2 py-2", children: [
                      /* @__PURE__ */ m(Gl, { as: Ko, waitForTranslation: !p, children: L("name") }),
                      /* @__PURE__ */ m(
                        Bn,
                        {
                          control: T.control,
                          name: "name",
                          render: ({ field: F }) => /* @__PURE__ */ m(
                            "input",
                            {
                              className: "hover:border-emphasis dark:focus:border-emphasis border-default bg-default placeholder:text-muted text-emphasis focus:ring-brand-default disabled:bg-subtle disabled:hover:border-subtle focus:border-subtle mb-2 block h-9 w-full rounded-md border px-3 py-2 text-sm leading-4 focus:outline-none focus:ring-2 disabled:cursor-not-allowed",
                              ...F
                            }
                          )
                        }
                      )
                    ] }),
                    /* @__PURE__ */ m("div", { className: "flex h-9 flex-row-reverse items-center justify-end gap-3 px-2", children: b && /* @__PURE__ */ de(nt, { children: [
                      /* @__PURE__ */ m(
                        Gl,
                        {
                          as: Ko,
                          htmlFor: "hiddenSwitch",
                          className: "mt-2 cursor-pointer self-center pr-2 sm:inline",
                          waitForTranslation: !p,
                          children: L("set_to_default")
                        }
                      ),
                      /* @__PURE__ */ m(
                        Bn,
                        {
                          control: T.control,
                          name: "isDefault",
                          render: ({ field: { value: F, onChange: P } }) => {
                            var O, V;
                            return /* @__PURE__ */ m(
                              as,
                              {
                                classNames: {
                                  container: ar((O = g == null ? void 0 : g.hiddenSwitchClassname) == null ? void 0 : O.container),
                                  thumb: ar((V = g == null ? void 0 : g.hiddenSwitchClassname) == null ? void 0 : V.thumb)
                                },
                                id: "hiddenSwitch",
                                disabled: c || F,
                                checked: F,
                                onCheckedChange: P
                              }
                            );
                          }
                        }
                      )
                    ] }) }),
                    /* @__PURE__ */ m("div", { className: "min-w-40 col-span-3 space-y-2 px-2 py-4 lg:col-span-1", children: /* @__PURE__ */ de("div", { className: "xl:max-w-80 w-full pr-4 sm:ml-0 sm:mr-36 sm:p-0", children: [
                      /* @__PURE__ */ de("div", { children: [
                        /* @__PURE__ */ m(
                          Gl,
                          {
                            as: Ko,
                            htmlFor: "timeZone-sm-viewport",
                            className: "mb-0 inline-block leading-none",
                            waitForTranslation: !p,
                            children: L("timezone")
                          }
                        ),
                        /* @__PURE__ */ m(
                          Bn,
                          {
                            control: T.control,
                            name: "timeZone",
                            render: ({ field: { onChange: F, value: P } }) => P ? /* @__PURE__ */ m(
                              E,
                              {
                                inputId: "timeZone-sm-viewport",
                                value: P,
                                className: ar(
                                  "focus:border-brand-default border-default mt-1 block w-72 rounded-md text-sm",
                                  g == null ? void 0 : g.timezoneSelectClassName
                                ),
                                onChange: (O) => F(O.value)
                              }
                            ) : /* @__PURE__ */ m($H, { className: "mt-1 w-72" })
                          }
                        )
                      ] }),
                      !p && /* @__PURE__ */ de(nt, { children: [
                        /* @__PURE__ */ m("hr", { className: "border-subtle my-7" }),
                        /* @__PURE__ */ de("div", { className: "rounded-md md:block", children: [
                          /* @__PURE__ */ m(
                            Gl,
                            {
                              as: "h3",
                              className: "mb-0 inline-block text-sm font-medium",
                              waitForTranslation: !p,
                              children: L("something_doesnt_look_right")
                            }
                          ),
                          /* @__PURE__ */ m("div", { className: "mt-3 flex", children: /* @__PURE__ */ m(
                            Gl,
                            {
                              as: Jt,
                              href: "/availability/troubleshoot",
                              color: "secondary",
                              waitForTranslation: !p,
                              children: L("launch_troubleshooter")
                            }
                          ) })
                        ] })
                      ] })
                    ] }) })
                  ]
                }
              )
            }
          ) }) }),
          /* @__PURE__ */ m("div", { className: "border-default border-l-2" }),
          /* @__PURE__ */ m(
            Jt,
            {
              ref: x,
              className: "ml-4 lg:ml-0",
              type: "submit",
              form: "availability-form",
              loading: c,
              children: L("save")
            }
          ),
          /* @__PURE__ */ m(
            Jt,
            {
              className: "ml-3 sm:hidden",
              StartIcon: "ellipsis-vertical",
              variant: "icon",
              color: "secondary",
              onClick: () => q(!0)
            }
          )
        ] }),
        children: /* @__PURE__ */ m("div", { className: "mt-4 w-full md:mt-0", children: /* @__PURE__ */ de(
          Y_,
          {
            form: T,
            id: "availability-form",
            handleSubmit: async (F) => {
              _(F);
            },
            className: ar(g == null ? void 0 : g.formClassName, "flex flex-col sm:mx-0 xl:flex-row xl:space-x-6"),
            children: [
              /* @__PURE__ */ de("div", { className: "flex-1 flex-row xl:mr-0", children: [
                /* @__PURE__ */ m(
                  "div",
                  {
                    className: ar(
                      "border-subtle mb-6 rounded-md border",
                      (z = g == null ? void 0 : g.scheduleClassNames) == null ? void 0 : z.scheduleContainer
                    ),
                    children: /* @__PURE__ */ m("div", { children: typeof u == "string" && /* @__PURE__ */ m(
                      S,
                      {
                        labels: {
                          addTime: L("add_time_availability"),
                          copyTime: L("copy_times_to"),
                          deleteTime: L("delete")
                        },
                        classNames: g != null && g.scheduleClassNames ? { ...g.scheduleClassNames } : {},
                        control: T.control,
                        name: "schedule",
                        userTimeFormat: l,
                        weekStart: [
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday"
                        ].indexOf(u)
                      }
                    ) })
                  }
                ),
                h && /* @__PURE__ */ m(Wy, { children: /* @__PURE__ */ m(
                  OZc,
                  {
                    isDryRun: N,
                    workingHours: o.workingHours,
                    userTimeFormat: l,
                    handleSubmit: _,
                    travelSchedules: r,
                    weekStart: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(
                      u
                    ),
                    overridesModalClassNames: g == null ? void 0 : g.overridesModalClassNames,
                    classNames: g == null ? void 0 : g.dateOverrideClassNames
                  }
                ) })
              ] }),
              /* @__PURE__ */ m("div", { className: "min-w-40 col-span-3 hidden space-y-2 md:block lg:col-span-1", children: /* @__PURE__ */ de("div", { className: "xl:max-w-80 w-full pr-4 sm:ml-0 sm:mr-36 sm:p-0", children: [
                /* @__PURE__ */ de("div", { children: [
                  /* @__PURE__ */ m(
                    Gl,
                    {
                      as: Ko,
                      htmlFor: "timeZone-lg-viewport",
                      className: "mb-0 inline-block leading-none",
                      waitForTranslation: !p,
                      children: L("timezone")
                    }
                  ),
                  /* @__PURE__ */ m(
                    Bn,
                    {
                      name: "timeZone",
                      render: ({ field: { onChange: F, value: P } }) => P ? /* @__PURE__ */ m(
                        E,
                        {
                          inputId: "timeZone-lg-viewport",
                          value: P,
                          className: "focus:border-brand-default border-default mt-1 block w-72 rounded-md text-sm",
                          onChange: (O) => F(O.value)
                        }
                      ) : /* @__PURE__ */ m($H, { className: "mt-1 w-72" })
                    }
                  )
                ] }),
                p ? /* @__PURE__ */ m(nt, {}) : /* @__PURE__ */ de(nt, { children: [
                  /* @__PURE__ */ m("hr", { className: "border-subtle my-6 mr-8" }),
                  /* @__PURE__ */ de("div", { className: "rounded-md", children: [
                    /* @__PURE__ */ m(
                      Gl,
                      {
                        as: "h3",
                        className: "mb-0 inline-block text-sm font-medium",
                        waitForTranslation: !p,
                        children: L("something_doesnt_look_right")
                      }
                    ),
                    /* @__PURE__ */ m("div", { className: "mt-3 flex", children: /* @__PURE__ */ m(
                      Gl,
                      {
                        as: Jt,
                        href: "/availability/troubleshoot",
                        color: "secondary",
                        waitForTranslation: !p,
                        children: L("launch_troubleshooter")
                      }
                    ) })
                  ] })
                ] })
              ] }) })
            ]
          }
        ) })
      }
    );
  }
), _su = Bt(function(t, n) {
  var E;
  const {
    id: o,
    customClassNames: r,
    onDeleteError: i,
    onDeleteSuccess: a,
    onUpdateError: s,
    onUpdateSuccess: c,
    disableEditableHeading: l = !1,
    enableOverrides: u = !1,
    onBeforeUpdate: d,
    onFormStateChange: _,
    allowDelete: p,
    allowSetToDefault: g,
    disableToasts: f,
    isDryRun: h = !1,
    noScheduleChildren: $,
    loadingStateChildren: v
  } = t, { isLoading: b, data: y } = use(o), { data: w } = Ev(), { timeFormat: N } = (w == null ? void 0 : w.data) || { timeFormat: null }, { toast: M } = wf(), { mutate: q, isPending: L } = _se({
    onSuccess: (x) => {
      a == null || a(x), f || M({
        description: "Schedule deleted successfully"
      });
    },
    onError: (x) => {
      i == null || i(x), f || M({
        description: "Could not delete schedule"
      });
    }
  }), R = xt({}), { mutate: T, isPending: D } = dse({
    onSuccess: (x) => {
      var k, I;
      c == null || c(x), f || M({
        description: "Schedule updated successfully"
      }), (I = (k = R.current) == null ? void 0 : k.onSuccess) == null || I.call(k);
    },
    onError: (x) => {
      var k, I;
      s == null || s(x), f || M({
        description: "Could not update schedule"
      }), (I = (k = R.current) == null ? void 0 : k.onError) == null || I.call(k, x);
    }
  }), A = async (x) => {
    await q({ id: x });
  }, S = async (x, k) => {
    let I = !0;
    d && (I = await d(k)), I && T({
      scheduleId: x,
      body: {
        ...k,
        dateOverrides: k.dateOverrides.flatMap((z) => z.ranges)
      }
    });
  };
  return b ? /* @__PURE__ */ m(nt, { children: v || /* @__PURE__ */ m("div", { className: "px-10 py-4 text-xl", children: "Loading..." }) }) : y ? /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m(
    zZc,
    {
      ref: n,
      disableEditableHeading: l,
      handleDelete: () => {
        h && M({
          description: "Schedule deleted successfully"
        }), !h && y.id && A(y.id);
      },
      handleSubmit: async (x) => {
        h && M({
          description: "Schedule updated successfully"
        }), !h && y.id && S(y.id, x);
      },
      weekStart: ((E = w == null ? void 0 : w.data) == null ? void 0 : E.weekStart) || "Sunday",
      timeFormat: N,
      enableOverrides: u,
      isLoading: b,
      schedule: {
        name: y.name,
        id: y.id,
        isLastSchedule: y.isLastSchedule,
        isDefault: y.isDefault,
        workingHours: y.workingHours,
        dateOverrides: y.dateOverrides,
        timeZone: y.timeZone,
        availability: y.availability,
        schedule: y.schedule.reduce(
          (x, k) => [
            ...x,
            { days: k.days, startTime: new Date(k.startTime), endTime: new Date(k.endTime) }
          ],
          []
        ) || []
      },
      isDeleting: L,
      isSaving: D,
      backPath: "",
      isPlatform: !0,
      customClassNames: r,
      allowDelete: p,
      allowSetToDefault: g,
      onFormStateChange: _,
      callbacksRef: R,
      isDryRun: h
    }
  ) }) : $ ? /* @__PURE__ */ m(nt, { children: $ }) : /* @__PURE__ */ m("div", { className: "px-10 py-4 text-xl", children: "No user schedule present" });
});
var RZc = K_, PZc = function() {
  return RZc.Date.now();
}, DZc = PZc, LZc = /\s/;
function MZc(e) {
  for (var t = e.length; t-- && LZc.test(e.charAt(t)); )
    ;
  return t;
}
var FZc = MZc, qZc = FZc, jZc = /^\s+/;
function VZc(e) {
  return e && e.slice(0, qZc(e) + 1).replace(jZc, "");
}
var BZc = VZc, UZc = n$, GZc = Cf, WZc = "[object Symbol]";
function HZc(e) {
  return typeof e == "symbol" || GZc(e) && UZc(e) == WZc;
}
var xA = HZc, YZc = BZc, kY = Vd, KZc = xA, SY = NaN, ZZc = /^[-+]0x[0-9a-f]+$/i, XZc = /^0b[01]+$/i, JZc = /^0o[0-7]+$/i, QZc = parseInt;
function eXc(e) {
  if (typeof e == "number")
    return e;
  if (KZc(e))
    return SY;
  if (kY(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = kY(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = YZc(e);
  var n = XZc.test(e);
  return n || JZc.test(e) ? QZc(e.slice(2), n ? 2 : 8) : ZZc.test(e) ? SY : +e;
}
var Qme = eXc, tXc = Vd, Nz = DZc, EY = Qme, nXc = "Expected a function", oXc = Math.max, rXc = Math.min;
function iXc(e, t, n) {
  var o, r, i, a, s, c, l = 0, u = !1, d = !1, _ = !0;
  if (typeof e != "function")
    throw new TypeError(nXc);
  t = EY(t) || 0, tXc(n) && (u = !!n.leading, d = "maxWait" in n, i = d ? oXc(EY(n.maxWait) || 0, t) : i, _ = "trailing" in n ? !!n.trailing : _);
  function p(N) {
    var M = o, q = r;
    return o = r = void 0, l = N, a = e.apply(q, M), a;
  }
  function g(N) {
    return l = N, s = setTimeout($, t), u ? p(N) : a;
  }
  function f(N) {
    var M = N - c, q = N - l, L = t - M;
    return d ? rXc(L, i - q) : L;
  }
  function h(N) {
    var M = N - c, q = N - l;
    return c === void 0 || M >= t || M < 0 || d && q >= i;
  }
  function $() {
    var N = Nz();
    if (h(N))
      return v(N);
    s = setTimeout($, f(N));
  }
  function v(N) {
    return s = void 0, _ && o ? p(N) : (o = r = void 0, a);
  }
  function b() {
    s !== void 0 && clearTimeout(s), l = 0, o = c = r = s = void 0;
  }
  function y() {
    return s === void 0 ? a : v(Nz());
  }
  function w() {
    var N = Nz(), M = h(N);
    if (o = arguments, r = this, c = N, M) {
      if (s === void 0)
        return g(c);
      if (d)
        return clearTimeout(s), s = setTimeout($, t), p(c);
    }
    return s === void 0 && (s = setTimeout($, t)), a;
  }
  return w.cancel = b, w.flush = y, w;
}
var aXc = iXc;
const sXc = /* @__PURE__ */ Mi(aXc), efe = Cr({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), CA = Cr({}), Wq = Cr(null), TA = typeof document < "u", DC = TA ? lc : yt, Hq = Cr({ strict: !1 });
function cXc(e, t, n, o) {
  const { visualElement: r } = bo(CA), i = bo(Hq), a = bo(Wq), s = bo(efe).reducedMotion, c = xt();
  o = o || i.renderer, !c.current && o && (c.current = o(e, {
    visualState: t,
    parent: r,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: s
  }));
  const l = c.current;
  return gre(() => {
    l && l.update(n, a);
  }), DC(() => {
    l && l.render();
  }), yt(() => {
    l && l.updateFeatures();
  }), (window.HandoffAppearAnimations ? DC : yt)(() => {
    l && l.animationState && l.animationState.animateChanges();
  }), l;
}
function tfe(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function lXc(e, t, n) {
  return Yt(
    (o) => {
      o && e.mount && e.mount(o), t && (o ? t.mount(o) : t.unmount()), n && (typeof n == "function" ? n(o) : tfe(n) && (n.current = o));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function Xk(e) {
  return typeof e == "string" || Array.isArray(e);
}
function AA(e) {
  return typeof e == "object" && typeof e.start == "function";
}
const Yq = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Kq = ["initial", ...Yq];
function IA(e) {
  return AA(e.animate) || Kq.some((t) => Xk(e[t]));
}
function nfe(e) {
  return !!(IA(e) || e.variants);
}
function uXc(e, t) {
  if (IA(e)) {
    const { initial: n, animate: o } = e;
    return {
      initial: n === !1 || Xk(n) ? n : void 0,
      animate: Xk(o) ? o : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function dXc(e) {
  const { initial: t, animate: n } = uXc(e, bo(CA));
  return vn(() => ({ initial: t, animate: n }), [xY(t), xY(n)]);
}
function xY(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const CY = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Jk = {};
for (const e in CY)
  Jk[e] = {
    isEnabled: (t) => CY[e].some((n) => !!t[n])
  };
function f5(e) {
  for (const t in e)
    Jk[t] = {
      ...Jk[t],
      ...e[t]
    };
}
const ofe = Cr({}), _Xc = Cr({}), pXc = Symbol.for("motionComponentSymbol");
function mXc({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: o, Component: r }) {
  e && f5(e);
  function i(s, c) {
    let l;
    const u = {
      ...bo(efe),
      ...s,
      layoutId: fXc(s)
    }, { isStatic: d } = u, _ = dXc(s), p = o(s, d);
    if (!d && TA) {
      _.visualElement = cXc(r, p, u, t);
      const g = bo(_Xc), f = bo(Hq).strict;
      _.visualElement && (l = _.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        u,
        f,
        e,
        g
      ));
    }
    return Ue.createElement(
      CA.Provider,
      { value: _ },
      l && _.visualElement ? Ue.createElement(l, { visualElement: _.visualElement, ...u }) : null,
      n(r, s, lXc(p, _.visualElement, c), p, d, _.visualElement)
    );
  }
  const a = Bt(i);
  return a[pXc] = r, a;
}
function fXc({ layoutId: e }) {
  const t = bo(ofe).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function gXc(e) {
  function t(o, r = {}) {
    return mXc(e(o, r));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, r) => (n.has(r) || n.set(r, t(r)), n.get(r))
  });
}
const hXc = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Zq(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(hXc.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const vXc = {}, Q0 = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Nv = new Set(Q0);
function rfe(e, { layout: t, layoutId: n }) {
  return Nv.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!vXc[e] || e === "opacity");
}
const Fc = (e) => !!(e && e.getVelocity), bXc = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, yXc = Q0.length;
function $Xc(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, o, r) {
  let i = "";
  for (let a = 0; a < yXc; a++) {
    const s = Q0[a];
    if (e[s] !== void 0) {
      const c = bXc[s] || s;
      i += `${c}(${e[s]}) `;
    }
  }
  return t && !e.z && (i += "translateZ(0)"), i = i.trim(), r ? i = r(e, o ? "" : i) : n && o && (i = "none"), i;
}
const ife = (e) => (t) => typeof t == "string" && t.startsWith(e), afe = ife("--"), g5 = ife("var(--"), wXc = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, kXc = (e, t) => t && typeof e == "number" ? t.transform(e) : e, Py = (e, t, n) => Math.min(Math.max(n, e), t), zv = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ek = {
  ...zv,
  transform: (e) => Py(0, 1, e)
}, nE = {
  ...zv,
  default: 1
}, tk = (e) => Math.round(e * 1e5) / 1e5, OA = /(-)?([\d]*\.?[\d])+/g, sfe = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, SXc = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function e1(e) {
  return typeof e == "string";
}
const t1 = (e) => ({
  test: (t) => e1(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Jf = t1("deg"), Kb = t1("%"), Bo = t1("px"), EXc = t1("vh"), xXc = t1("vw"), TY = {
  ...Kb,
  parse: (e) => Kb.parse(e) / 100,
  transform: (e) => Kb.transform(e * 100)
}, AY = {
  ...zv,
  transform: Math.round
}, cfe = {
  // Border props
  borderWidth: Bo,
  borderTopWidth: Bo,
  borderRightWidth: Bo,
  borderBottomWidth: Bo,
  borderLeftWidth: Bo,
  borderRadius: Bo,
  radius: Bo,
  borderTopLeftRadius: Bo,
  borderTopRightRadius: Bo,
  borderBottomRightRadius: Bo,
  borderBottomLeftRadius: Bo,
  // Positioning props
  width: Bo,
  maxWidth: Bo,
  height: Bo,
  maxHeight: Bo,
  size: Bo,
  top: Bo,
  right: Bo,
  bottom: Bo,
  left: Bo,
  // Spacing props
  padding: Bo,
  paddingTop: Bo,
  paddingRight: Bo,
  paddingBottom: Bo,
  paddingLeft: Bo,
  margin: Bo,
  marginTop: Bo,
  marginRight: Bo,
  marginBottom: Bo,
  marginLeft: Bo,
  // Transform props
  rotate: Jf,
  rotateX: Jf,
  rotateY: Jf,
  rotateZ: Jf,
  scale: nE,
  scaleX: nE,
  scaleY: nE,
  scaleZ: nE,
  skew: Jf,
  skewX: Jf,
  skewY: Jf,
  distance: Bo,
  translateX: Bo,
  translateY: Bo,
  translateZ: Bo,
  x: Bo,
  y: Bo,
  z: Bo,
  perspective: Bo,
  transformPerspective: Bo,
  opacity: ek,
  originX: TY,
  originY: TY,
  originZ: Bo,
  // Misc
  zIndex: AY,
  // SVG
  fillOpacity: ek,
  strokeOpacity: ek,
  numOctaves: AY
};
function Xq(e, t, n, o) {
  const { style: r, vars: i, transform: a, transformOrigin: s } = e;
  let c = !1, l = !1, u = !0;
  for (const d in t) {
    const _ = t[d];
    if (afe(d)) {
      i[d] = _;
      continue;
    }
    const p = cfe[d], g = kXc(_, p);
    if (Nv.has(d)) {
      if (c = !0, a[d] = g, !u)
        continue;
      _ !== (p.default || 0) && (u = !1);
    } else
      d.startsWith("origin") ? (l = !0, s[d] = g) : r[d] = g;
  }
  if (t.transform || (c || o ? r.transform = $Xc(e.transform, n, u, o) : r.transform && (r.transform = "none")), l) {
    const { originX: d = "50%", originY: _ = "50%", originZ: p = 0 } = s;
    r.transformOrigin = `${d} ${_} ${p}`;
  }
}
const Jq = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function lfe(e, t, n) {
  for (const o in t)
    !Fc(t[o]) && !rfe(o, n) && (e[o] = t[o]);
}
function CXc({ transformTemplate: e }, t, n) {
  return vn(() => {
    const o = Jq();
    return Xq(o, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, o.vars, o.style);
  }, [t]);
}
function TXc(e, t, n) {
  const o = e.style || {}, r = {};
  return lfe(r, o, e), Object.assign(r, CXc(e, t, n)), e.transformValues ? e.transformValues(r) : r;
}
function AXc(e, t, n) {
  const o = {}, r = TXc(e, t, n);
  return e.drag && e.dragListener !== !1 && (o.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (o.tabIndex = 0), o.style = r, o;
}
const IXc = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "ignoreStrict",
  "viewport"
]);
function LC(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || IXc.has(e);
}
let ufe = (e) => !LC(e);
function OXc(e) {
  e && (ufe = (t) => t.startsWith("on") ? !LC(t) : e(t));
}
try {
  OXc(require("@emotion/is-prop-valid").default);
} catch {
}
function NXc(e, t, n) {
  const o = {};
  for (const r in e)
    r === "values" && typeof e.values == "object" || (ufe(r) || n === !0 && LC(r) || !t && !LC(r) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && r.startsWith("onDrag")) && (o[r] = e[r]);
  return o;
}
function IY(e, t, n) {
  return typeof e == "string" ? e : Bo.transform(t + n * e);
}
function zXc(e, t, n) {
  const o = IY(t, e.x, e.width), r = IY(n, e.y, e.height);
  return `${o} ${r}`;
}
const RXc = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, PXc = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function DXc(e, t, n = 1, o = 0, r = !0) {
  e.pathLength = 1;
  const i = r ? RXc : PXc;
  e[i.offset] = Bo.transform(-o);
  const a = Bo.transform(t), s = Bo.transform(n);
  e[i.array] = `${a} ${s}`;
}
function Qq(e, {
  attrX: t,
  attrY: n,
  attrScale: o,
  originX: r,
  originY: i,
  pathLength: a,
  pathSpacing: s = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, u, d, _) {
  if (Xq(e, l, u, _), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: g, dimensions: f } = e;
  p.transform && (f && (g.transform = p.transform), delete p.transform), f && (r !== void 0 || i !== void 0 || g.transform) && (g.transformOrigin = zXc(f, r !== void 0 ? r : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), o !== void 0 && (p.scale = o), a !== void 0 && DXc(p, a, s, c, !1);
}
const dfe = () => ({
  ...Jq(),
  attrs: {}
}), ej = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function LXc(e, t, n, o) {
  const r = vn(() => {
    const i = dfe();
    return Qq(i, t, { enableHardwareAcceleration: !1 }, ej(o), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    lfe(i, e.style, e), r.style = { ...i, ...r.style };
  }
  return r;
}
function MXc(e = !1) {
  return (n, o, r, { latestValues: i }, a) => {
    const c = (Zq(n) ? LXc : AXc)(o, i, a, n), u = {
      ...NXc(o, typeof n == "string", e),
      ...c,
      ref: r
    }, { children: d } = o, _ = vn(() => Fc(d) ? d.get() : d, [d]);
    return pt(n, {
      ...u,
      children: _
    });
  };
}
const tj = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function _fe(e, { style: t, vars: n }, o, r) {
  Object.assign(e.style, t, r && r.getProjectionStyles(o));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const pfe = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function mfe(e, t, n, o) {
  _fe(e, t, void 0, o);
  for (const r in t.attrs)
    e.setAttribute(pfe.has(r) ? r : tj(r), t.attrs[r]);
}
function nj(e, t) {
  const { style: n } = e, o = {};
  for (const r in n)
    (Fc(n[r]) || t.style && Fc(t.style[r]) || rfe(r, e)) && (o[r] = n[r]);
  return o;
}
function ffe(e, t) {
  const n = nj(e, t);
  for (const o in e)
    if (Fc(e[o]) || Fc(t[o])) {
      const r = Q0.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      n[r] = e[o];
    }
  return n;
}
function oj(e, t, n, o = {}, r = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, o, r)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, o, r)), t;
}
function MC(e) {
  const t = xt(null);
  return t.current === null && (t.current = e()), t.current;
}
const FC = (e) => Array.isArray(e), FXc = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), qXc = (e) => FC(e) ? e[e.length - 1] || 0 : e;
function jXc(e) {
  const t = Fc(e) ? e.get() : e;
  return FXc(t) ? t.toValue() : t;
}
function VXc({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, o, r, i) {
  const a = {
    latestValues: BXc(o, r, i, e),
    renderState: t()
  };
  return n && (a.mount = (s) => n(o, s, a)), a;
}
const gfe = (e) => (t, n) => {
  const o = bo(CA), r = bo(Wq), i = () => VXc(e, t, o, r);
  return n ? i() : MC(i);
};
function BXc(e, t, n, o) {
  const r = {}, i = o(e, {});
  for (const _ in i)
    r[_] = jXc(i[_]);
  let { initial: a, animate: s } = e;
  const c = IA(e), l = nfe(e);
  t && l && !c && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || a === !1;
  const d = u ? s : a;
  return d && typeof d != "boolean" && !AA(d) && (Array.isArray(d) ? d : [d]).forEach((p) => {
    const g = oj(e, p);
    if (!g)
      return;
    const { transitionEnd: f, transition: h, ...$ } = g;
    for (const v in $) {
      let b = $[v];
      if (Array.isArray(b)) {
        const y = u ? b.length - 1 : 0;
        b = b[y];
      }
      b !== null && (r[v] = b);
    }
    for (const v in f)
      r[v] = f[v];
  }), r;
}
const UXc = {
  useVisualState: gfe({
    scrapeMotionValuesFromProps: ffe,
    createRenderState: dfe,
    onMount: (e, t, { renderState: n, latestValues: o }) => {
      try {
        n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Qq(n, o, { enableHardwareAcceleration: !1 }, ej(t.tagName), e.transformTemplate), mfe(t, n);
    }
  })
}, GXc = {
  useVisualState: gfe({
    scrapeMotionValuesFromProps: nj,
    createRenderState: Jq
  })
};
function WXc(e, { forwardMotionProps: t = !1 }, n, o) {
  return {
    ...Zq(e) ? UXc : GXc,
    preloadedFeatures: n,
    useRender: MXc(t),
    createVisualElement: o,
    Component: e
  };
}
function Fh(e, t, n, o = { passive: !0 }) {
  return e.addEventListener(t, n, o), () => e.removeEventListener(t, n);
}
const HXc = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function hfe(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const YXc = (e) => (t) => HXc(t) && e(t, hfe(t));
function px(e, t, n, o) {
  return Fh(e, t, YXc(n), o);
}
const KXc = (e, t) => (n) => t(e(n)), ov = (...e) => e.reduce(KXc);
function vfe(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const OY = vfe("dragHorizontal"), NY = vfe("dragVertical");
function ZXc(e) {
  let t = !1;
  if (e === "y")
    t = NY();
  else if (e === "x")
    t = OY();
  else {
    const n = OY(), o = NY();
    n && o ? t = () => {
      n(), o();
    } : (n && n(), o && o());
  }
  return t;
}
function bfe() {
  const e = ZXc(!0);
  return e ? (e(), !1) : !0;
}
class o$ {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function XXc(e) {
  let t = [], n = [], o = 0, r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, l = !1, u = !1) => {
      const d = u && r, _ = d ? t : n;
      return l && a.add(c), _.indexOf(c) === -1 && (_.push(c), d && r && (o = t.length)), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      const l = n.indexOf(c);
      l !== -1 && n.splice(l, 1), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (r) {
        i = !0;
        return;
      }
      if (r = !0, [t, n] = [n, t], n.length = 0, o = t.length, o)
        for (let l = 0; l < o; l++) {
          const u = t[l];
          u(c), a.has(u) && (s.schedule(u), e());
        }
      r = !1, i && (i = !1, s.process(c));
    }
  };
  return s;
}
const Dp = {
  delta: 0,
  timestamp: 0,
  isProcessing: !1
}, JXc = 40;
let h5 = !0, Qk = !1;
const NA = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], rj = NA.reduce((e, t) => (e[t] = XXc(() => Qk = !0), e), {}), QXc = (e) => rj[e].process(Dp), yfe = (e) => {
  Qk = !1, Dp.delta = h5 ? 1e3 / 60 : Math.max(Math.min(e - Dp.timestamp, JXc), 1), Dp.timestamp = e, Dp.isProcessing = !0, NA.forEach(QXc), Dp.isProcessing = !1, Qk && (h5 = !1, requestAnimationFrame(yfe));
}, eJc = () => {
  Qk = !0, h5 = !0, Dp.isProcessing || requestAnimationFrame(yfe);
}, Zl = NA.reduce((e, t) => {
  const n = rj[t];
  return e[t] = (o, r = !1, i = !1) => (Qk || eJc(), n.schedule(o, r, i)), e;
}, {});
function qC(e) {
  NA.forEach((t) => rj[t].cancel(e));
}
function zY(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), o = "onHover" + (t ? "Start" : "End"), r = (i, a) => {
    if (i.type === "touch" || bfe())
      return;
    const s = e.getProps();
    e.animationState && s.whileHover && e.animationState.setActive("whileHover", t), s[o] && Zl.update(() => s[o](i, a));
  };
  return px(e.current, n, r, {
    passive: !e.getProps()[o]
  });
}
class tJc extends o$ {
  mount() {
    this.unmount = ov(zY(this.node, !0), zY(this.node, !1));
  }
  unmount() {
  }
}
class nJc extends o$ {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ov(Fh(this.node.current, "focus", () => this.onFocus()), Fh(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const $fe = (e, t) => t ? e === t ? !0 : $fe(e, t.parentElement) : !1, Yl = (e) => e;
function zz(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, hfe(n));
}
class oJc extends o$ {
  constructor() {
    super(...arguments), this.removeStartListeners = Yl, this.removeEndListeners = Yl, this.removeAccessibleListeners = Yl, this.startPointerPress = (t, n) => {
      if (this.removeEndListeners(), this.isPressing)
        return;
      const o = this.node.getProps(), i = px(window, "pointerup", (s, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: u } = this.node.getProps();
        Zl.update(() => {
          $fe(this.node.current, s.target) ? l && l(s, c) : u && u(s, c);
        });
      }, { passive: !(o.onTap || o.onPointerUp) }), a = px(window, "pointercancel", (s, c) => this.cancelPress(s, c), { passive: !(o.onTapCancel || o.onPointerCancel) });
      this.removeEndListeners = ov(i, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const a = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || zz("up", (c, l) => {
            const { onTap: u } = this.node.getProps();
            u && Zl.update(() => u(c, l));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Fh(this.node.current, "keyup", a), zz("down", (s, c) => {
          this.startPress(s, c);
        });
      }, n = Fh(this.node.current, "keydown", t), o = () => {
        this.isPressing && zz("cancel", (i, a) => this.cancelPress(i, a));
      }, r = Fh(this.node.current, "blur", o);
      this.removeAccessibleListeners = ov(n, r);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: o, whileTap: r } = this.node.getProps();
    r && this.node.animationState && this.node.animationState.setActive("whileTap", !0), o && Zl.update(() => o(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !bfe();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: o } = this.node.getProps();
    o && Zl.update(() => o(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = px(this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), o = Fh(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = ov(n, o);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const v5 = /* @__PURE__ */ new WeakMap(), Rz = /* @__PURE__ */ new WeakMap(), rJc = (e) => {
  const t = v5.get(e.target);
  t && t(e);
}, iJc = (e) => {
  e.forEach(rJc);
};
function aJc({ root: e, ...t }) {
  const n = e || document;
  Rz.has(n) || Rz.set(n, {});
  const o = Rz.get(n), r = JSON.stringify(t);
  return o[r] || (o[r] = new IntersectionObserver(iJc, { root: e, ...t })), o[r];
}
function sJc(e, t, n) {
  const o = aJc(t);
  return v5.set(e, n), o.observe(e), () => {
    v5.delete(e), o.unobserve(e);
  };
}
const cJc = {
  some: 0,
  all: 1
};
class lJc extends o$ {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: o, amount: r = "some", once: i } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: o,
      threshold: typeof r == "number" ? r : cJc[r]
    }, s = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, i && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), _ = l ? u : d;
      _ && _(c);
    };
    return sJc(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(uJc(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function uJc({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const dJc = {
  inView: {
    Feature: lJc
  },
  tap: {
    Feature: oJc
  },
  focus: {
    Feature: nJc
  },
  hover: {
    Feature: tJc
  }
};
function wfe(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let o = 0; o < n; o++)
    if (t[o] !== e[o])
      return !1;
  return !0;
}
function _Jc(e) {
  const t = {};
  return e.values.forEach((n, o) => t[o] = n.get()), t;
}
function pJc(e) {
  const t = {};
  return e.values.forEach((n, o) => t[o] = n.getVelocity()), t;
}
function zA(e, t, n) {
  const o = e.getProps();
  return oj(o, t, n !== void 0 ? n : o.custom, _Jc(e), pJc(e));
}
const mJc = "framerAppearId", fJc = "data-" + tj(mJc);
let n1 = Yl, Md = Yl;
process.env.NODE_ENV !== "production" && (n1 = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Md = (e, t) => {
  if (!e)
    throw new Error(t);
});
const kg = (e) => e * 1e3, pf = (e) => e / 1e3, gJc = {
  current: !1
}, kfe = (e) => Array.isArray(e) && typeof e[0] == "number";
function Sfe(e) {
  return !!(!e || typeof e == "string" && Efe[e] || kfe(e) || Array.isArray(e) && e.every(Sfe));
}
const Iw = ([e, t, n, o]) => `cubic-bezier(${e}, ${t}, ${n}, ${o})`, Efe = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: Iw([0, 0.65, 0.55, 1]),
  circOut: Iw([0.55, 0, 1, 0.45]),
  backIn: Iw([0.31, 0.01, 0.66, -0.59]),
  backOut: Iw([0.33, 1.53, 0.69, 0.99])
};
function xfe(e) {
  if (e)
    return kfe(e) ? Iw(e) : Array.isArray(e) ? e.map(xfe) : Efe[e];
}
function hJc(e, t, n, { delay: o = 0, duration: r, repeat: i = 0, repeatType: a = "loop", ease: s, times: c } = {}) {
  const l = { [t]: n };
  c && (l.offset = c);
  const u = xfe(s);
  return Array.isArray(u) && (l.easing = u), e.animate(l, {
    delay: o,
    duration: r,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
const RY = {
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
}, Pz = {}, Cfe = {};
for (const e in RY)
  Cfe[e] = () => (Pz[e] === void 0 && (Pz[e] = RY[e]()), Pz[e]);
function vJc(e, { repeat: t, repeatType: n = "loop" }) {
  const o = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[o];
}
const Tfe = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, bJc = 1e-7, yJc = 12;
function $Jc(e, t, n, o, r) {
  let i, a, s = 0;
  do
    a = t + (n - t) / 2, i = Tfe(a, o, r) - e, i > 0 ? n = a : t = a;
  while (Math.abs(i) > bJc && ++s < yJc);
  return a;
}
function r$(e, t, n, o) {
  if (e === t && n === o)
    return Yl;
  const r = (i) => $Jc(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : Tfe(r(i), t, o);
}
const wJc = r$(0.42, 0, 1, 1), kJc = r$(0, 0, 0.58, 1), Afe = r$(0.42, 0, 0.58, 1), Ife = (e) => Array.isArray(e) && typeof e[0] != "number", Ofe = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Nfe = (e) => (t) => 1 - e(1 - t), zfe = (e) => 1 - Math.sin(Math.acos(e)), Rfe = Nfe(zfe), SJc = Ofe(Rfe), Pfe = r$(0.33, 1.53, 0.69, 0.99), ij = Nfe(Pfe), EJc = Ofe(ij), xJc = (e) => (e *= 2) < 1 ? 0.5 * ij(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), PY = {
  linear: Yl,
  easeIn: wJc,
  easeInOut: Afe,
  easeOut: kJc,
  circIn: zfe,
  circInOut: SJc,
  circOut: Rfe,
  backIn: ij,
  backInOut: EJc,
  backOut: Pfe,
  anticipate: xJc
}, DY = (e) => {
  if (Array.isArray(e)) {
    Md(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, o, r] = e;
    return r$(t, n, o, r);
  } else if (typeof e == "string")
    return Md(PY[e] !== void 0, `Invalid easing type '${e}'`), PY[e];
  return e;
}, aj = (e, t) => (n) => !!(e1(n) && SXc.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), Dfe = (e, t, n) => (o) => {
  if (!e1(o))
    return o;
  const [r, i, a, s] = o.match(OA);
  return {
    [e]: parseFloat(r),
    [t]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, CJc = (e) => Py(0, 255, e), Dz = {
  ...zv,
  transform: (e) => Math.round(CJc(e))
}, qh = {
  test: aj("rgb", "red"),
  parse: Dfe("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: o = 1 }) => "rgba(" + Dz.transform(e) + ", " + Dz.transform(t) + ", " + Dz.transform(n) + ", " + tk(ek.transform(o)) + ")"
};
function TJc(e) {
  let t = "", n = "", o = "", r = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), o = e.substring(5, 7), r = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), o = e.substring(3, 4), r = e.substring(4, 5), t += t, n += n, o += o, r += r), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(o, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const b5 = {
  test: aj("#"),
  parse: TJc,
  transform: qh.transform
}, Ib = {
  test: aj("hsl", "hue"),
  parse: Dfe("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: o = 1 }) => "hsla(" + Math.round(e) + ", " + Kb.transform(tk(t)) + ", " + Kb.transform(tk(n)) + ", " + tk(ek.transform(o)) + ")"
}, cl = {
  test: (e) => qh.test(e) || b5.test(e) || Ib.test(e),
  parse: (e) => qh.test(e) ? qh.parse(e) : Ib.test(e) ? Ib.parse(e) : b5.parse(e),
  transform: (e) => e1(e) ? e : e.hasOwnProperty("red") ? qh.transform(e) : Ib.transform(e)
}, o1 = (e, t, n) => -n * e + n * t + e;
function Lz(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function AJc({ hue: e, saturation: t, lightness: n, alpha: o }) {
  e /= 360, t /= 100, n /= 100;
  let r = 0, i = 0, a = 0;
  if (!t)
    r = i = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - s;
    r = Lz(c, s, e + 1 / 3), i = Lz(c, s, e), a = Lz(c, s, e - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: o
  };
}
const Mz = (e, t, n) => {
  const o = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - o) + o));
}, IJc = [b5, qh, Ib], OJc = (e) => IJc.find((t) => t.test(e));
function LY(e) {
  const t = OJc(e);
  Md(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let n = t.parse(e);
  return t === Ib && (n = AJc(n)), n;
}
const Lfe = (e, t) => {
  const n = LY(e), o = LY(t), r = { ...n };
  return (i) => (r.red = Mz(n.red, o.red, i), r.green = Mz(n.green, o.green, i), r.blue = Mz(n.blue, o.blue, i), r.alpha = o1(n.alpha, o.alpha, i), qh.transform(r));
};
function NJc(e) {
  var t, n;
  return isNaN(e) && e1(e) && (((t = e.match(OA)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(sfe)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const Mfe = {
  regex: wXc,
  countKey: "Vars",
  token: "${v}",
  parse: Yl
}, Ffe = {
  regex: sfe,
  countKey: "Colors",
  token: "${c}",
  parse: cl.parse
}, qfe = {
  regex: OA,
  countKey: "Numbers",
  token: "${n}",
  parse: zv.parse
};
function Fz(e, { regex: t, countKey: n, token: o, parse: r }) {
  const i = e.tokenised.match(t);
  i && (e["num" + n] = i.length, e.tokenised = e.tokenised.replace(t, o), e.values.push(...i.map(r)));
}
function jC(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && Fz(n, Mfe), Fz(n, Ffe), Fz(n, qfe), n;
}
function jfe(e) {
  return jC(e).values;
}
function Vfe(e) {
  const { values: t, numColors: n, numVars: o, tokenised: r } = jC(e), i = t.length;
  return (a) => {
    let s = r;
    for (let c = 0; c < i; c++)
      c < o ? s = s.replace(Mfe.token, a[c]) : c < o + n ? s = s.replace(Ffe.token, cl.transform(a[c])) : s = s.replace(qfe.token, tk(a[c]));
    return s;
  };
}
const zJc = (e) => typeof e == "number" ? 0 : e;
function RJc(e) {
  const t = jfe(e);
  return Vfe(e)(t.map(zJc));
}
const i$ = {
  test: NJc,
  parse: jfe,
  createTransformer: Vfe,
  getAnimatableNone: RJc
}, Bfe = (e, t) => (n) => `${n > 0 ? t : e}`;
function Ufe(e, t) {
  return typeof e == "number" ? (n) => o1(e, t, n) : cl.test(e) ? Lfe(e, t) : e.startsWith("var(") ? Bfe(e, t) : Wfe(e, t);
}
const Gfe = (e, t) => {
  const n = [...e], o = n.length, r = e.map((i, a) => Ufe(i, t[a]));
  return (i) => {
    for (let a = 0; a < o; a++)
      n[a] = r[a](i);
    return n;
  };
}, PJc = (e, t) => {
  const n = { ...e, ...t }, o = {};
  for (const r in n)
    e[r] !== void 0 && t[r] !== void 0 && (o[r] = Ufe(e[r], t[r]));
  return (r) => {
    for (const i in o)
      n[i] = o[i](r);
    return n;
  };
}, Wfe = (e, t) => {
  const n = i$.createTransformer(t), o = jC(e), r = jC(t);
  return o.numVars === r.numVars && o.numColors === r.numColors && o.numNumbers >= r.numNumbers ? ov(Gfe(o.values, r.values), n) : (n1(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Bfe(e, t));
}, sj = (e, t, n) => {
  const o = t - e;
  return o === 0 ? 1 : (n - e) / o;
}, MY = (e, t) => (n) => o1(e, t, n);
function DJc(e) {
  return typeof e == "number" ? MY : typeof e == "string" ? cl.test(e) ? Lfe : Wfe : Array.isArray(e) ? Gfe : typeof e == "object" ? PJc : MY;
}
function LJc(e, t, n) {
  const o = [], r = n || DJc(e[0]), i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let s = r(e[a], e[a + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[a] || Yl : t;
      s = ov(c, s);
    }
    o.push(s);
  }
  return o;
}
function Hfe(e, t, { clamp: n = !0, ease: o, mixer: r } = {}) {
  const i = e.length;
  if (Md(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = LJc(t, o, r), s = a.length, c = (l) => {
    let u = 0;
    if (s > 1)
      for (; u < e.length - 2 && !(l < e[u + 1]); u++)
        ;
    const d = sj(e[u], e[u + 1], l);
    return a[u](d);
  };
  return n ? (l) => c(Py(e[0], e[i - 1], l)) : c;
}
function Yfe(e, t) {
  const n = e[e.length - 1];
  for (let o = 1; o <= t; o++) {
    const r = sj(0, t, o);
    e.push(o1(n, 1, r));
  }
}
function Kfe(e) {
  const t = [0];
  return Yfe(t, e.length - 1), t;
}
function MJc(e, t) {
  return e.map((n) => n * t);
}
function FJc(e, t) {
  return e.map(() => t || Afe).splice(0, e.length - 1);
}
function VC({ duration: e = 300, keyframes: t, times: n, ease: o = "easeInOut" }) {
  const r = Ife(o) ? o.map(DY) : DY(o), i = {
    done: !1,
    value: t[0]
  }, a = MJc(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Kfe(t),
    e
  ), s = Hfe(a, t, {
    ease: Array.isArray(r) ? r : FJc(t, r)
  });
  return {
    calculatedDuration: e,
    next: (c) => (i.value = s(c), i.done = c >= e, i)
  };
}
function Zfe(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const qJc = 5;
function Xfe(e, t, n) {
  const o = Math.max(t - qJc, 0);
  return Zfe(n - e(o), t - o);
}
const qz = 1e-3, jJc = 0.01, FY = 10, VJc = 0.05, BJc = 1;
function UJc({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: o = 1 }) {
  let r, i;
  n1(e <= kg(FY), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = Py(VJc, BJc, a), e = Py(jJc, FY, pf(e)), a < 1 ? (r = (l) => {
    const u = l * a, d = u * e, _ = u - n, p = y5(l, a), g = Math.exp(-d);
    return qz - _ / p * g;
  }, i = (l) => {
    const d = l * a * e, _ = d * n + n, p = Math.pow(a, 2) * Math.pow(l, 2) * e, g = Math.exp(-d), f = y5(Math.pow(l, 2), a);
    return (-r(l) + qz > 0 ? -1 : 1) * ((_ - p) * g) / f;
  }) : (r = (l) => {
    const u = Math.exp(-l * e), d = (l - n) * e + 1;
    return -qz + u * d;
  }, i = (l) => {
    const u = Math.exp(-l * e), d = (n - l) * (e * e);
    return u * d;
  });
  const s = 5 / e, c = WJc(r, i, s);
  if (e = kg(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * o;
    return {
      stiffness: l,
      damping: a * 2 * Math.sqrt(o * l),
      duration: e
    };
  }
}
const GJc = 12;
function WJc(e, t, n) {
  let o = n;
  for (let r = 1; r < GJc; r++)
    o = o - e(o) / t(o);
  return o;
}
function y5(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const HJc = ["duration", "bounce"], YJc = ["stiffness", "damping", "mass"];
function qY(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function KJc(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!qY(e, YJc) && qY(e, HJc)) {
    const n = UJc(e);
    t = {
      ...t,
      ...n,
      velocity: 0,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function cj({ keyframes: e, restDelta: t, restSpeed: n, ...o }) {
  const r = e[0], i = e[e.length - 1], a = { done: !1, value: r }, { stiffness: s, damping: c, mass: l, velocity: u, duration: d, isResolvedFromDuration: _ } = KJc(o), p = u ? -pf(u) : 0, g = c / (2 * Math.sqrt(s * l)), f = i - r, h = pf(Math.sqrt(s / l)), $ = Math.abs(f) < 5;
  n || (n = $ ? 0.01 : 2), t || (t = $ ? 5e-3 : 0.5);
  let v;
  if (g < 1) {
    const b = y5(h, g);
    v = (y) => {
      const w = Math.exp(-g * h * y);
      return i - w * ((p + g * h * f) / b * Math.sin(b * y) + f * Math.cos(b * y));
    };
  } else if (g === 1)
    v = (b) => i - Math.exp(-h * b) * (f + (p + h * f) * b);
  else {
    const b = h * Math.sqrt(g * g - 1);
    v = (y) => {
      const w = Math.exp(-g * h * y), N = Math.min(b * y, 300);
      return i - w * ((p + g * h * f) * Math.sinh(N) + b * f * Math.cosh(N)) / b;
    };
  }
  return {
    calculatedDuration: _ && d || null,
    next: (b) => {
      const y = v(b);
      if (_)
        a.done = b >= d;
      else {
        let w = p;
        b !== 0 && (g < 1 ? w = Xfe(v, b, y) : w = 0);
        const N = Math.abs(w) <= n, M = Math.abs(i - y) <= t;
        a.done = N && M;
      }
      return a.value = a.done ? i : y, a;
    }
  };
}
function jY({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: o = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: a, min: s, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const d = e[0], _ = {
    done: !1,
    value: d
  }, p = (q) => s !== void 0 && q < s || c !== void 0 && q > c, g = (q) => s === void 0 ? c : c === void 0 || Math.abs(s - q) < Math.abs(c - q) ? s : c;
  let f = n * t;
  const h = d + f, $ = a === void 0 ? h : a(h);
  $ !== h && (f = $ - d);
  const v = (q) => -f * Math.exp(-q / o), b = (q) => $ + v(q), y = (q) => {
    const L = v(q), R = b(q);
    _.done = Math.abs(L) <= l, _.value = _.done ? $ : R;
  };
  let w, N;
  const M = (q) => {
    p(_.value) && (w = q, N = cj({
      keyframes: [_.value, g(_.value)],
      velocity: Xfe(b, q, _.value),
      damping: r,
      stiffness: i,
      restDelta: l,
      restSpeed: u
    }));
  };
  return M(0), {
    calculatedDuration: null,
    next: (q) => {
      let L = !1;
      return !N && w === void 0 && (L = !0, y(q), M(q)), w !== void 0 && q > w ? N.next(q - w) : (!L && y(q), _);
    }
  };
}
const ZJc = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Zl.update(t, !0),
    stop: () => qC(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Dp.isProcessing ? Dp.timestamp : performance.now()
  };
}, $5 = 2e4;
function w5(e) {
  let t = 0;
  const n = 50;
  let o = e.next(t);
  for (; !o.done && t < $5; )
    t += n, o = e.next(t);
  return t >= $5 ? 1 / 0 : t;
}
const XJc = {
  decay: jY,
  inertia: jY,
  tween: VC,
  keyframes: VC,
  spring: cj
};
function BC({ autoplay: e = !0, delay: t = 0, driver: n = ZJc, keyframes: o, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: s = "loop", onPlay: c, onStop: l, onComplete: u, onUpdate: d, ..._ }) {
  let p = 1, g = !1, f, h;
  const $ = () => {
    f && f(), h = new Promise((P) => {
      f = P;
    });
  };
  $();
  let v;
  const b = XJc[r] || VC;
  let y;
  b !== VC && typeof o[0] != "number" && (y = Hfe([0, 100], o, {
    clamp: !1
  }), o = [0, 100]);
  const w = b({ ..._, keyframes: o });
  let N;
  s === "mirror" && (N = b({
    ..._,
    keyframes: [...o].reverse(),
    velocity: -(_.velocity || 0)
  }));
  let M = "idle", q = null, L = null, R = null;
  w.calculatedDuration === null && i && (w.calculatedDuration = w5(w));
  const { calculatedDuration: T } = w;
  let D = 1 / 0, A = 1 / 0;
  T !== null && (D = T + a, A = D * (i + 1) - a);
  let S = 0;
  const E = (P) => {
    if (L === null)
      return;
    p > 0 && (L = Math.min(L, P)), q !== null ? S = q : S = (P - L) * p;
    const O = S - t, V = O < 0;
    S = Math.max(O, 0), M === "finished" && q === null && (S = A);
    let U = S, H = w;
    if (i) {
      const Y = S / D;
      let re = Math.floor(Y), ie = Y % 1;
      !ie && Y >= 1 && (ie = 1), ie === 1 && re--, re = Math.min(re, i + 1);
      const _e = !!(re % 2);
      _e && (s === "reverse" ? (ie = 1 - ie, a && (ie -= a / D)) : s === "mirror" && (H = N));
      let he = Py(0, 1, ie);
      S > A && (he = s === "reverse" && _e ? 1 : 0), U = he * D;
    }
    const J = V ? { done: !1, value: o[0] } : H.next(U);
    y && (J.value = y(J.value));
    let { done: le } = J;
    !V && T !== null && (le = S >= A);
    const ae = q === null && (M === "finished" || M === "running" && le || p < 0 && S <= 0);
    return d && d(J.value), ae && I(), J;
  }, x = () => {
    v && v.stop(), v = void 0;
  }, k = () => {
    M = "idle", x(), $(), L = R = null;
  }, I = () => {
    M = "finished", u && u(), x(), $();
  }, z = () => {
    if (g)
      return;
    v || (v = n(E));
    const P = v.now();
    c && c(), q !== null ? L = P - q : (!L || M === "finished") && (L = P), R = L, q = null, M = "running", v.start();
  };
  e && z();
  const F = {
    then(P, O) {
      return h.then(P, O);
    },
    get time() {
      return pf(S);
    },
    set time(P) {
      P = kg(P), S = P, q !== null || !v || p === 0 ? q = P : L = v.now() - P / p;
    },
    get duration() {
      const P = w.calculatedDuration === null ? w5(w) : w.calculatedDuration;
      return pf(P);
    },
    get speed() {
      return p;
    },
    set speed(P) {
      P === p || !v || (p = P, F.time = pf(S));
    },
    get state() {
      return M;
    },
    play: z,
    pause: () => {
      M = "paused", q = S;
    },
    stop: () => {
      g = !0, M !== "idle" && (M = "idle", l && l(), k());
    },
    cancel: () => {
      R !== null && E(R), k();
    },
    complete: () => {
      M = "finished";
    },
    sample: (P) => (L = 0, E(P))
  };
  return F;
}
const JJc = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), oE = 10, QJc = 2e4, eQc = (e, t) => t.type === "spring" || e === "backgroundColor" || !Sfe(t.ease);
function tQc(e, t, { onUpdate: n, onComplete: o, ...r }) {
  if (!(Cfe.waapi() && JJc.has(t) && !r.repeatDelay && r.repeatType !== "mirror" && r.damping !== 0 && r.type !== "inertia"))
    return !1;
  let a = !1, s, c;
  const l = () => {
    c = new Promise(($) => {
      s = $;
    });
  };
  l();
  let { keyframes: u, duration: d = 300, ease: _, times: p } = r;
  if (eQc(t, r)) {
    const $ = BC({
      ...r,
      repeat: 0,
      delay: 0
    });
    let v = { done: !1, value: u[0] };
    const b = [];
    let y = 0;
    for (; !v.done && y < QJc; )
      v = $.sample(y), b.push(v.value), y += oE;
    p = void 0, u = b, d = y - oE, _ = "linear";
  }
  const g = hJc(e.owner.current, t, u, {
    ...r,
    duration: d,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: _,
    times: p
  }), f = () => g.cancel(), h = () => {
    Zl.update(f), s(), l();
  };
  return g.onfinish = () => {
    e.set(vJc(u, r)), o && o(), h();
  }, {
    then($, v) {
      return c.then($, v);
    },
    get time() {
      return pf(g.currentTime || 0);
    },
    set time($) {
      g.currentTime = kg($);
    },
    get speed() {
      return g.playbackRate;
    },
    set speed($) {
      g.playbackRate = $;
    },
    get duration() {
      return pf(d);
    },
    play: () => {
      a || (g.play(), qC(f));
    },
    pause: () => g.pause(),
    stop: () => {
      if (a = !0, g.playState === "idle")
        return;
      const { currentTime: $ } = g;
      if ($) {
        const v = BC({
          ...r,
          autoplay: !1
        });
        e.setWithVelocity(v.sample($ - oE).value, v.sample($).value, oE);
      }
      h();
    },
    complete: () => g.finish(),
    cancel: h
  };
}
function nQc({ keyframes: e, delay: t, onUpdate: n, onComplete: o }) {
  const r = () => (n && n(e[e.length - 1]), o && o(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: Yl,
    pause: Yl,
    stop: Yl,
    then: (i) => (i(), Promise.resolve()),
    cancel: Yl,
    complete: Yl
  });
  return t ? BC({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: r
  }) : r();
}
const oQc = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, rQc = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), iQc = {
  type: "keyframes",
  duration: 0.8
}, aQc = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, sQc = (e, { keyframes: t }) => t.length > 2 ? iQc : Nv.has(e) ? e.startsWith("scale") ? rQc(t[1]) : oQc : aQc, k5 = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(i$.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), cQc = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function lQc(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [o] = n.match(OA) || [];
  if (!o)
    return e;
  const r = n.replace(o, "");
  let i = cQc.has(t) ? 1 : 0;
  return o !== n && (i *= 100), t + "(" + i + r + ")";
}
const uQc = /([a-z-]*)\(.*?\)/g, S5 = {
  ...i$,
  getAnimatableNone: (e) => {
    const t = e.match(uQc);
    return t ? t.map(lQc).join(" ") : e;
  }
}, dQc = {
  ...cfe,
  // Color props
  color: cl,
  backgroundColor: cl,
  outlineColor: cl,
  fill: cl,
  stroke: cl,
  // Border props
  borderColor: cl,
  borderTopColor: cl,
  borderRightColor: cl,
  borderBottomColor: cl,
  borderLeftColor: cl,
  filter: S5,
  WebkitFilter: S5
}, lj = (e) => dQc[e];
function Jfe(e, t) {
  let n = lj(e);
  return n !== S5 && (n = i$), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const Qfe = (e) => /^0[^.\s]+$/.test(e);
function _Qc(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || Qfe(e);
}
function pQc(e, t, n, o) {
  const r = k5(t, n);
  let i;
  Array.isArray(n) ? i = [...n] : i = [null, n];
  const a = o.from !== void 0 ? o.from : e.get();
  let s;
  const c = [];
  for (let l = 0; l < i.length; l++)
    i[l] === null && (i[l] = l === 0 ? a : i[l - 1]), _Qc(i[l]) ? c.push(l) : typeof i[l] == "string" && (s = i[l]);
  if (r && c.length && s)
    for (let l = 0; l < c.length; l++) {
      const u = c[l];
      i[u] = Jfe(t, s);
    }
  return i;
}
function mQc({ when: e, delay: t, delayChildren: n, staggerChildren: o, staggerDirection: r, repeat: i, repeatType: a, repeatDelay: s, from: c, elapsed: l, ...u }) {
  return !!Object.keys(u).length;
}
function fQc(e, t) {
  return e[t] || e.default || e;
}
const ege = (e, t, n, o = {}) => (r) => {
  const i = fQc(o, e) || {}, a = i.delay || o.delay || 0;
  let { elapsed: s = 0 } = o;
  s = s - kg(a);
  const c = pQc(t, e, n, i), l = c[0], u = c[c.length - 1], d = k5(e, l), _ = k5(e, u);
  n1(d === _, `You are trying to animate ${e} from "${l}" to "${u}". ${l} is not an animatable value - to enable this animation set ${l} to a value animatable to ${u} via the \`style\` property.`);
  let p = {
    keyframes: c,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...i,
    delay: -s,
    onUpdate: (g) => {
      t.set(g), i.onUpdate && i.onUpdate(g);
    },
    onComplete: () => {
      r(), i.onComplete && i.onComplete();
    }
  };
  if (mQc(i) || (p = {
    ...p,
    ...sQc(e, p)
  }), p.duration && (p.duration = kg(p.duration)), p.repeatDelay && (p.repeatDelay = kg(p.repeatDelay)), !d || !_ || gJc.current || i.type === !1)
    return nQc(p);
  if (t.owner && t.owner.current instanceof HTMLElement && !t.owner.getProps().onUpdate) {
    const g = tQc(t, e, p);
    if (g)
      return g;
  }
  return BC(p);
};
function UC(e) {
  return !!(Fc(e) && e.add);
}
const gQc = (e) => /^\-?\d*\.?\d+$/.test(e);
function hQc(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function tge(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class nge {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return hQc(this.subscriptions, t), () => tge(this.subscriptions, t);
  }
  notify(t, n, o) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](t, n, o);
      else
        for (let i = 0; i < r; i++) {
          const a = this.subscriptions[i];
          a && a(t, n, o);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const VY = /* @__PURE__ */ new Set();
function RA(e, t, n) {
  e || VY.has(t) || (console.warn(t), n && console.warn(n), VY.add(t));
}
const vQc = (e) => !isNaN(parseFloat(e));
class bQc {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.12.8", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (o, r = !0) => {
      this.prev = this.current, this.current = o;
      const { delta: i, timestamp: a } = Dp;
      this.lastUpdated !== a && (this.timeDelta = i, this.lastUpdated = a, Zl.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), r && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => Zl.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: o }) => {
      o !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = vQc(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && RA(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new nge());
    const o = this.events[t].add(n);
    return t === "change" ? () => {
      o(), Zl.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : o;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, o) {
    this.set(n), this.prev = t, this.timeDelta = o;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      Zfe(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Dy(e, t) {
  return new bQc(e, t);
}
const oge = (e) => (t) => t.test(e), yQc = {
  test: (e) => e === "auto",
  parse: (e) => e
}, rge = [zv, Bo, Kb, Jf, xXc, EXc, yQc], uw = (e) => rge.find(oge(e)), $Qc = [...rge, cl, i$], wQc = (e) => $Qc.find(oge(e));
function kQc(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Dy(n));
}
function SQc(e, t) {
  const n = zA(e, t);
  let { transitionEnd: o = {}, transition: r = {}, ...i } = n ? e.makeTargetAnimatable(n, !1) : {};
  i = { ...i, ...o };
  for (const a in i) {
    const s = qXc(i[a]);
    kQc(e, a, s);
  }
}
function EQc(e, t, n) {
  var o, r;
  const i = Object.keys(t).filter((s) => !e.hasValue(s)), a = i.length;
  if (a)
    for (let s = 0; s < a; s++) {
      const c = i[s], l = t[c];
      let u = null;
      Array.isArray(l) && (u = l[0]), u === null && (u = (r = (o = n[c]) !== null && o !== void 0 ? o : e.readValue(c)) !== null && r !== void 0 ? r : t[c]), u != null && (typeof u == "string" && (gQc(u) || Qfe(u)) ? u = parseFloat(u) : !wQc(u) && i$.test(l) && (u = Jfe(c, l)), e.addValue(c, Dy(u, { owner: e })), n[c] === void 0 && (n[c] = u), u !== null && e.setBaseTarget(c, u));
    }
}
function xQc(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function CQc(e, t, n) {
  const o = {};
  for (const r in e) {
    const i = xQc(r, t);
    if (i !== void 0)
      o[r] = i;
    else {
      const a = n.getValue(r);
      a && (o[r] = a.get());
    }
  }
  return o;
}
function TQc({ protectedKeys: e, needsAnimating: t }, n) {
  const o = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, o;
}
function uj(e, t, { delay: n = 0, transitionOverride: o, type: r } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: a, ...s } = e.makeTargetAnimatable(t);
  const c = e.getValue("willChange");
  o && (i = o);
  const l = [], u = r && e.animationState && e.animationState.getState()[r];
  for (const d in s) {
    const _ = e.getValue(d), p = s[d];
    if (!_ || p === void 0 || u && TQc(u, d))
      continue;
    const g = { delay: n, elapsed: 0, ...i };
    if (window.HandoffAppearAnimations && !_.hasAnimated) {
      const h = e.getProps()[fJc];
      h && (g.elapsed = window.HandoffAppearAnimations(h, d, _, Zl));
    }
    _.start(ege(d, _, p, e.shouldReduceMotion && Nv.has(d) ? { type: !1 } : g));
    const f = _.animation;
    UC(c) && (c.add(d), f.then(() => c.remove(d))), l.push(f);
  }
  return a && Promise.all(l).then(() => {
    a && SQc(e, a);
  }), l;
}
function E5(e, t, n = {}) {
  const o = zA(e, t, n.custom);
  let { transition: r = e.getDefaultTransition() || {} } = o || {};
  n.transitionOverride && (r = n.transitionOverride);
  const i = o ? () => Promise.all(uj(e, o, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: l = 0, staggerChildren: u, staggerDirection: d } = r;
    return AQc(e, t, l + c, u, d, n);
  } : () => Promise.resolve(), { when: s } = r;
  if (s) {
    const [c, l] = s === "beforeChildren" ? [i, a] : [a, i];
    return c().then(() => l());
  } else
    return Promise.all([i(), a(n.delay)]);
}
function AQc(e, t, n = 0, o = 0, r = 1, i) {
  const a = [], s = (e.variantChildren.size - 1) * o, c = r === 1 ? (l = 0) => l * o : (l = 0) => s - l * o;
  return Array.from(e.variantChildren).sort(IQc).forEach((l, u) => {
    l.notify("AnimationStart", t), a.push(E5(l, t, {
      ...i,
      delay: n + c(u)
    }).then(() => l.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function IQc(e, t) {
  return e.sortNodePosition(t);
}
function OQc(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let o;
  if (Array.isArray(t)) {
    const r = t.map((i) => E5(e, i, n));
    o = Promise.all(r);
  } else if (typeof t == "string")
    o = E5(e, t, n);
  else {
    const r = typeof t == "function" ? zA(e, t, n.custom) : t;
    o = Promise.all(uj(e, r, n));
  }
  return o.then(() => e.notify("AnimationComplete", t));
}
const NQc = [...Yq].reverse(), zQc = Yq.length;
function RQc(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: o }) => OQc(e, n, o)));
}
function PQc(e) {
  let t = RQc(e);
  const n = LQc();
  let o = !0;
  const r = (c, l) => {
    const u = zA(e, l);
    if (u) {
      const { transition: d, transitionEnd: _, ...p } = u;
      c = { ...c, ...p, ..._ };
    }
    return c;
  };
  function i(c) {
    t = c(e);
  }
  function a(c, l) {
    const u = e.getProps(), d = e.getVariantContext(!0) || {}, _ = [], p = /* @__PURE__ */ new Set();
    let g = {}, f = 1 / 0;
    for (let $ = 0; $ < zQc; $++) {
      const v = NQc[$], b = n[v], y = u[v] !== void 0 ? u[v] : d[v], w = Xk(y), N = v === l ? b.isActive : null;
      N === !1 && (f = $);
      let M = y === d[v] && y !== u[v] && w;
      if (M && o && e.manuallyAnimateOnMount && (M = !1), b.protectedKeys = { ...g }, // If it isn't active and hasn't *just* been set as inactive
      !b.isActive && N === null || // If we didn't and don't have any defined prop for this animation type
      !y && !b.prevProp || // Or if the prop doesn't define an animation
      AA(y) || typeof y == "boolean")
        continue;
      const q = DQc(b.prevProp, y);
      let L = q || // If we're making this variant active, we want to always make it active
      v === l && b.isActive && !M && w || // If we removed a higher-priority variant (i is in reverse order)
      $ > f && w;
      const R = Array.isArray(y) ? y : [y];
      let T = R.reduce(r, {});
      N === !1 && (T = {});
      const { prevResolvedValues: D = {} } = b, A = {
        ...D,
        ...T
      }, S = (E) => {
        L = !0, p.delete(E), b.needsAnimating[E] = !0;
      };
      for (const E in A) {
        const x = T[E], k = D[E];
        g.hasOwnProperty(E) || (x !== k ? FC(x) && FC(k) ? !wfe(x, k) || q ? S(E) : b.protectedKeys[E] = !0 : x !== void 0 ? S(E) : p.add(E) : x !== void 0 && p.has(E) ? S(E) : b.protectedKeys[E] = !0);
      }
      b.prevProp = y, b.prevResolvedValues = T, b.isActive && (g = { ...g, ...T }), o && e.blockInitialAnimation && (L = !1), L && !M && _.push(...R.map((E) => ({
        animation: E,
        options: { type: v, ...c }
      })));
    }
    if (p.size) {
      const $ = {};
      p.forEach((v) => {
        const b = e.getBaseTarget(v);
        b !== void 0 && ($[v] = b);
      }), _.push({ animation: $ });
    }
    let h = !!_.length;
    return o && u.initial === !1 && !e.manuallyAnimateOnMount && (h = !1), o = !1, h ? t(_) : Promise.resolve();
  }
  function s(c, l, u) {
    var d;
    if (n[c].isActive === l)
      return Promise.resolve();
    (d = e.variantChildren) === null || d === void 0 || d.forEach((p) => {
      var g;
      return (g = p.animationState) === null || g === void 0 ? void 0 : g.setActive(c, l);
    }), n[c].isActive = l;
    const _ = a(u, c);
    for (const p in n)
      n[p].protectedKeys = {};
    return _;
  }
  return {
    animateChanges: a,
    setActive: s,
    setAnimateFunction: i,
    getState: () => n
  };
}
function DQc(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !wfe(t, e) : !1;
}
function ph(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function LQc() {
  return {
    animate: ph(!0),
    whileInView: ph(),
    whileHover: ph(),
    whileTap: ph(),
    whileDrag: ph(),
    whileFocus: ph(),
    exit: ph()
  };
}
class MQc extends o$ {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = PQc(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), AA(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let FQc = 0;
class qQc extends o$ {
  constructor() {
    super(...arguments), this.id = FQc++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: o } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t, { custom: o ?? this.node.getProps().custom });
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const jQc = {
  animation: {
    Feature: MQc
  },
  exit: {
    Feature: qQc
  }
}, BY = () => ({ min: 0, max: 0 }), ige = () => ({
  x: BY(),
  y: BY()
});
function VQc({ top: e, left: t, right: n, bottom: o }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: o }
  };
}
function BQc(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), o = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: o.y,
    right: o.x
  };
}
function UQc(e, t) {
  return VQc(BQc(e.getBoundingClientRect(), t));
}
function GQc(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function age(e, t, n) {
  const o = Fc(e) ? e : Dy(e);
  return o.start(ege("", o, t, n)), o.animation;
}
const WQc = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function HQc(e) {
  const t = WQc.exec(e);
  if (!t)
    return [,];
  const [, n, o] = t;
  return [n, o];
}
const YQc = 4;
function x5(e, t, n = 1) {
  Md(n <= YQc, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [o, r] = HQc(e);
  if (!o)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(o);
  return i ? i.trim() : g5(r) ? x5(r, t, n + 1) : r;
}
function KQc(e, { ...t }, n) {
  const o = e.current;
  if (!(o instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((r) => {
    const i = r.get();
    if (!g5(i))
      return;
    const a = x5(i, o);
    a && r.set(a);
  });
  for (const r in t) {
    const i = t[r];
    if (!g5(i))
      continue;
    const a = x5(i, o);
    a && (t[r] = a, n || (n = {}), n[r] === void 0 && (n[r] = i));
  }
  return { target: t, transitionEnd: n };
}
const ZQc = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), sge = (e) => ZQc.has(e), XQc = (e) => Object.keys(e).some(sge), rE = (e) => e === zv || e === Bo, UY = (e, t) => parseFloat(e.split(", ")[t]), GY = (e, t) => (n, { transform: o }) => {
  if (o === "none" || !o)
    return 0;
  const r = o.match(/^matrix3d\((.+)\)$/);
  if (r)
    return UY(r[1], t);
  {
    const i = o.match(/^matrix\((.+)\)$/);
    return i ? UY(i[1], e) : 0;
  }
}, JQc = /* @__PURE__ */ new Set(["x", "y", "z"]), QQc = Q0.filter((e) => !JQc.has(e));
function eel(e) {
  const t = [];
  return QQc.forEach((n) => {
    const o = e.getValue(n);
    o !== void 0 && (t.push([n, o.get()]), o.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const WY = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: GY(4, 13),
  y: GY(5, 14)
}, tel = (e, t, n) => {
  const o = t.measureViewportBox(), r = t.current, i = getComputedStyle(r), { display: a } = i, s = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((l) => {
    s[l] = WY[l](o, i);
  }), t.render();
  const c = t.measureViewportBox();
  return n.forEach((l) => {
    const u = t.getValue(l);
    u && u.jump(s[l]), e[l] = WY[l](c, i);
  }), e;
}, nel = (e, t, n = {}, o = {}) => {
  t = { ...t }, o = { ...o };
  const r = Object.keys(t).filter(sge);
  let i = [], a = !1;
  const s = [];
  if (r.forEach((c) => {
    const l = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let u = n[c], d = uw(u);
    const _ = t[c];
    let p;
    if (FC(_)) {
      const g = _.length, f = _[0] === null ? 1 : 0;
      u = _[f], d = uw(u);
      for (let h = f; h < g && _[h] !== null; h++)
        p ? Md(uw(_[h]) === p, "All keyframes must be of the same type") : (p = uw(_[h]), Md(p === d || rE(d) && rE(p), "Keyframes must be of the same dimension as the current value"));
    } else
      p = uw(_);
    if (d !== p)
      if (rE(d) && rE(p)) {
        const g = l.get();
        typeof g == "string" && l.set(parseFloat(g)), typeof _ == "string" ? t[c] = parseFloat(_) : Array.isArray(_) && p === Bo && (t[c] = _.map(parseFloat));
      } else
        d != null && d.transform && (p != null && p.transform) && (u === 0 || _ === 0) ? u === 0 ? l.set(p.transform(u)) : t[c] = d.transform(_) : (a || (i = eel(e), a = !0), s.push(c), o[c] = o[c] !== void 0 ? o[c] : t[c], l.jump(_));
  }), s.length) {
    const c = s.indexOf("height") >= 0 ? window.pageYOffset : null, l = tel(t, e, s);
    return i.length && i.forEach(([u, d]) => {
      e.getValue(u).set(d);
    }), e.render(), TA && c !== null && window.scrollTo({ top: c }), { target: l, transitionEnd: o };
  } else
    return { target: t, transitionEnd: o };
};
function oel(e, t, n, o) {
  return XQc(t) ? nel(e, t, n, o) : { target: t, transitionEnd: o };
}
const rel = (e, t, n, o) => {
  const r = KQc(e, t, o);
  return t = r.target, o = r.transitionEnd, oel(e, t, n, o);
}, GC = { current: null }, dj = { current: !1 };
function cge() {
  if (dj.current = !0, !!TA)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => GC.current = e.matches;
      e.addListener(t), t();
    } else
      GC.current = !1;
}
function iel(e, t, n) {
  const { willChange: o } = t;
  for (const r in t) {
    const i = t[r], a = n[r];
    if (Fc(i))
      e.addValue(r, i), UC(o) && o.add(r), process.env.NODE_ENV === "development" && RA(i.version === "10.12.8", `Attempting to mix Framer Motion versions ${i.version} with 10.12.8 may not work as expected.`);
    else if (Fc(a))
      e.addValue(r, Dy(i, { owner: e })), UC(o) && o.remove(r);
    else if (a !== i)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        !s.hasAnimated && s.set(i);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Dy(s !== void 0 ? s : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const e0 = /* @__PURE__ */ new WeakMap(), lge = Object.keys(Jk), ael = lge.length, HY = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], sel = Kq.length;
class cel {
  constructor({ parent: t, props: n, presenceContext: o, reducedMotionConfig: r, visualState: i }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Zl.render(this.render, !1, !0);
    const { latestValues: s, renderState: c } = i;
    this.latestValues = s, this.baseTarget = { ...s }, this.initialValues = n.initial ? { ...s } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = o, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = r, this.options = a, this.isControllingVariants = IA(n), this.isVariantNode = nfe(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: l, ...u } = this.scrapeMotionValuesFromProps(n, {});
    for (const d in u) {
      const _ = u[d];
      s[d] !== void 0 && Fc(_) && (_.set(s[d], !1), UC(l) && l.add(d));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, e0.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, o) => this.bindToMotionValue(o, n)), dj.current || cge(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : GC.current, process.env.NODE_ENV !== "production" && RA(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    e0.delete(this.current), this.projection && this.projection.unmount(), qC(this.notifyUpdate), qC(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const o = Nv.has(t), r = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && Zl.update(this.notifyUpdate, !1, !0), o && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      r(), i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, o, r, i) {
    let a, s;
    if (process.env.NODE_ENV !== "production" && r && o) {
      const c = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? n1(!1, c) : Md(!1, c);
    }
    for (let c = 0; c < ael; c++) {
      const l = lge[c], { isEnabled: u, Feature: d, ProjectionNode: _, MeasureLayout: p } = Jk[l];
      _ && (a = _), u(n) && (!this.features[l] && d && (this.features[l] = new d(this)), p && (s = p));
    }
    if (!this.projection && a) {
      this.projection = new a(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: l, drag: u, dragConstraints: d, layoutScroll: _, layoutRoot: p } = n;
      this.projection.setOptions({
        layoutId: c,
        layout: l,
        alwaysMeasureLayout: !!u || d && tfe(d),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof l == "string" ? l : "both",
        initialPromotionConfig: i,
        layoutScroll: _,
        layoutRoot: p
      });
    }
    return s;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update(this.props, this.prevProps) : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ige();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let o = 0; o < HY.length; o++) {
      const r = HY[o];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const i = t["on" + r];
      i && (this.propEventSubscriptions[r] = this.on(r, i));
    }
    this.prevMotionValues = iel(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const o = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (o.initial = this.props.initial), o;
    }
    const n = {};
    for (let o = 0; o < sel; o++) {
      const r = Kq[o], i = this.props[r];
      (Xk(i) || i === !1) && (n[r] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let o = this.values.get(t);
    return o === void 0 && n !== void 0 && (o = Dy(n, { owner: this }), this.addValue(t, o)), o;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: o } = this.props, r = typeof o == "string" || typeof o == "object" ? (n = oj(this.props, o)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (o && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Fc(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new nge()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class uge extends cel {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: o }) {
    delete n[t], delete o[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...o }, { transformValues: r }, i) {
    let a = CQc(o, t || {}, this);
    if (r && (n && (n = r(n)), o && (o = r(o)), a && (a = r(a))), i) {
      EQc(this, o, a);
      const s = rel(this, o, a, n);
      n = s.transitionEnd, o = s.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...o
    };
  }
}
function lel(e) {
  return window.getComputedStyle(e);
}
class dge extends uge {
  readValueFromInstance(t, n) {
    if (Nv.has(n)) {
      const o = lj(n);
      return o && o.default || 0;
    } else {
      const o = lel(t), r = (afe(n) ? o.getPropertyValue(n) : o[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return UQc(t, n);
  }
  build(t, n, o, r) {
    Xq(t, n, o, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return nj(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Fc(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, o, r) {
    _fe(t, n, o, r);
  }
}
class _ge extends uge {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Nv.has(n)) {
      const o = lj(n);
      return o && o.default || 0;
    }
    return n = pfe.has(n) ? n : tj(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return ige();
  }
  scrapeMotionValuesFromProps(t, n) {
    return ffe(t, n);
  }
  build(t, n, o, r) {
    Qq(t, n, o, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, o, r) {
    mfe(t, n, o, r);
  }
  mount(t) {
    this.isSVGTag = ej(t.tagName), super.mount(t);
  }
}
const uel = (e, t) => Zq(e) ? new _ge(t, { enableHardwareAcceleration: !1 }) : new dge(t, { enableHardwareAcceleration: !0 }), t0 = gXc(WXc);
function pge() {
  const e = xt(!1);
  return DC(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function del() {
  const e = pge(), [t, n] = it(0), o = Yt(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Yt(() => Zl.postRender(o), [o]), t];
}
class _el extends Ue.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const o = this.props.sizeRef.current;
      o.height = n.offsetHeight || 0, o.width = n.offsetWidth || 0, o.top = n.offsetTop, o.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function pel({ children: e, isPresent: t }) {
  const n = I0(), o = xt(null), r = xt({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return gre(() => {
    const { width: i, height: a, top: s, left: c } = r.current;
    if (t || !o.current || !i || !a)
      return;
    o.current.dataset.motionPopId = n;
    const l = document.createElement("style");
    return document.head.appendChild(l), l.sheet && l.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${i}px !important;
            height: ${a}px !important;
            top: ${s}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(l);
    };
  }, [t]), Ue.createElement(_el, { isPresent: t, childRef: o, sizeRef: r }, Ue.cloneElement(e, { ref: o }));
}
const jz = ({ children: e, initial: t, isPresent: n, onExitComplete: o, custom: r, presenceAffectsLayout: i, mode: a }) => {
  const s = MC(mel), c = I0(), l = vn(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: r,
      onExitComplete: (u) => {
        s.set(u, !0);
        for (const d of s.values())
          if (!d)
            return;
        o && o();
      },
      register: (u) => (s.set(u, !1), () => s.delete(u))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? void 0 : [n]
  );
  return vn(() => {
    s.forEach((u, d) => s.set(d, !1));
  }, [n]), Ue.useEffect(() => {
    !n && !s.size && o && o();
  }, [n]), a === "popLayout" && (e = Ue.createElement(pel, { isPresent: n }, e)), Ue.createElement(Wq.Provider, { value: l }, e);
};
function mel() {
  return /* @__PURE__ */ new Map();
}
function mge(e) {
  return yt(() => () => e(), []);
}
const wb = (e) => e.key || "";
function fel(e, t) {
  e.forEach((n) => {
    const o = wb(n);
    t.set(o, n);
  });
}
function gel(e) {
  const t = [];
  return hg.forEach(e, (n) => {
    zd(n) && t.push(n);
  }), t;
}
const fge = ({ children: e, custom: t, initial: n = !0, onExitComplete: o, exitBeforeEnter: r, presenceAffectsLayout: i = !0, mode: a = "sync" }) => {
  Md(!r, "Replace exitBeforeEnter with mode='wait'");
  let [s] = del();
  const c = bo(ofe).forceRender;
  c && (s = c);
  const l = pge(), u = gel(e);
  let d = u;
  const _ = /* @__PURE__ */ new Set(), p = xt(d), g = xt(/* @__PURE__ */ new Map()).current, f = xt(!0);
  if (DC(() => {
    f.current = !1, fel(u, g), p.current = d;
  }), mge(() => {
    f.current = !0, g.clear(), _.clear();
  }), f.current)
    return Ue.createElement(Ue.Fragment, null, d.map((b) => Ue.createElement(jz, { key: wb(b), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: i, mode: a }, b)));
  d = [...d];
  const h = p.current.map(wb), $ = u.map(wb), v = h.length;
  for (let b = 0; b < v; b++) {
    const y = h[b];
    $.indexOf(y) === -1 && _.add(y);
  }
  return a === "wait" && _.size && (d = []), _.forEach((b) => {
    if ($.indexOf(b) !== -1)
      return;
    const y = g.get(b);
    if (!y)
      return;
    const w = h.indexOf(b), N = () => {
      g.delete(b), _.delete(b);
      const M = p.current.findIndex((q) => q.key === b);
      if (p.current.splice(M, 1), !_.size) {
        if (p.current = u, l.current === !1)
          return;
        s(), o && o();
      }
    };
    d.splice(w, 0, Ue.createElement(jz, { key: wb(y), isPresent: !1, onExitComplete: N, custom: t, presenceAffectsLayout: i, mode: a }, y));
  }), d = d.map((b) => {
    const y = b.key;
    return _.has(y) ? b : Ue.createElement(jz, { key: wb(b), isPresent: !0, presenceAffectsLayout: i, mode: a }, b);
  }), process.env.NODE_ENV !== "production" && a === "wait" && d.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), Ue.createElement(Ue.Fragment, null, _.size ? d : d.map((b) => gf(b)));
};
function hel({ children: e, features: t, strict: n = !1 }) {
  const [, o] = it(!Vz(t)), r = xt(void 0);
  if (!Vz(t)) {
    const { renderer: i, ...a } = t;
    r.current = i, f5(a);
  }
  return yt(() => {
    Vz(t) && t().then(({ renderer: i, ...a }) => {
      f5(a), r.current = i, o(!0);
    });
  }, []), Ue.createElement(Hq.Provider, { value: { renderer: r.current, strict: n } }, e);
}
function Vz(e) {
  return typeof e == "function";
}
const vel = {
  renderer: uel,
  ...jQc,
  ...dJc
};
function gge(e, t, n) {
  var o;
  if (typeof e == "string") {
    let r = document;
    t && (Md(!!t.current, "Scope provided, but no element detected."), r = t.current), n ? ((o = n[e]) !== null && o !== void 0 || (n[e] = r.querySelectorAll(e)), e = n[e]) : e = r.querySelectorAll(e);
  } else
    e instanceof Element && (e = [e]);
  return Array.from(e || []);
}
function bel() {
  !dj.current && cge();
  const [e] = it(GC.current);
  return process.env.NODE_ENV !== "production" && RA(e !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), e;
}
class hge {
  constructor(t) {
    this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let o = 0; o < this.animations.length; o++)
      this.animations[o][t] = n;
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  stop() {
    this.runAll("stop");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function yel(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function $el(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = GQc(e) ? new _ge(t, {
    enableHardwareAcceleration: !1
  }) : new dge(t, {
    enableHardwareAcceleration: !0
  });
  n.mount(e), e0.set(e, n);
}
function wel(e, t = 100) {
  const n = cj({ keyframes: [0, t], ...e }), o = Math.min(w5(n), $5);
  return {
    type: "keyframes",
    ease: (r) => n.next(o * r).value / t,
    duration: pf(o)
  };
}
function YY(e, t, n, o) {
  var r;
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : (r = o.get(t)) !== null && r !== void 0 ? r : e;
}
const kel = (e, t, n) => {
  const o = t - e;
  return ((n - e) % o + o) % o + e;
};
function Sel(e, t) {
  return Ife(e) ? e[kel(0, e.length, t)] : e;
}
function Eel(e, t, n) {
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    r.at > t && r.at < n && (tge(e, r), o--);
  }
}
function xel(e, t, n, o, r, i) {
  Eel(e, r, i);
  for (let a = 0; a < t.length; a++)
    e.push({
      value: t[a],
      at: o1(r, i, o[a]),
      easing: Sel(n, a)
    });
}
function Cel(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const Tel = "easeInOut";
function Ael(e, { defaultTransition: t = {}, ...n } = {}, o) {
  const r = t.duration || 0.3, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = {}, c = /* @__PURE__ */ new Map();
  let l = 0, u = 0, d = 0;
  for (let _ = 0; _ < e.length; _++) {
    const p = e[_];
    if (typeof p == "string") {
      c.set(p, u);
      continue;
    } else if (!Array.isArray(p)) {
      c.set(p.name, YY(u, p.at, l, c));
      continue;
    }
    let [g, f, h = {}] = p;
    h.at !== void 0 && (u = YY(u, h.at, l, c));
    let $ = 0;
    const v = (b, y, w, N = 0, M = 0) => {
      const q = Iel(b), { delay: L = 0, times: R = Kfe(q), type: T = "keyframes", ...D } = y;
      let { ease: A = t.ease || "easeOut", duration: S } = y;
      const E = typeof L == "function" ? L(N, M) : L, x = q.length;
      if (x <= 2 && T === "spring") {
        let F = 100;
        if (x === 2 && zel(q)) {
          const V = q[1] - q[0];
          F = Math.abs(V);
        }
        const P = { ...D };
        S !== void 0 && (P.duration = kg(S));
        const O = wel(P, F);
        A = O.ease, S = O.duration;
      }
      S ?? (S = r);
      const k = u + E, I = k + S;
      R.length === 1 && R[0] === 0 && (R[1] = 1);
      const z = R.length - q.length;
      z > 0 && Yfe(R, z), q.length === 1 && q.unshift(null), xel(w, q, A, R, k, I), $ = Math.max(E + S, $), d = Math.max(I, d);
    };
    if (Fc(g)) {
      const b = KY(g, a);
      v(f, h, ZY("default", b));
    } else {
      const b = gge(g, o, s), y = b.length;
      for (let w = 0; w < y; w++) {
        f = f, h = h;
        const N = b[w], M = KY(N, a);
        for (const q in f)
          v(f[q], Oel(h, q), ZY(q, M), w, y);
      }
      l = u, u += $;
    }
  }
  return a.forEach((_, p) => {
    for (const g in _) {
      const f = _[g];
      f.sort(Cel);
      const h = [], $ = [], v = [];
      for (let y = 0; y < f.length; y++) {
        const { at: w, value: N, easing: M } = f[y];
        h.push(N), $.push(sj(0, d, w)), v.push(M || "easeOut");
      }
      $[0] !== 0 && ($.unshift(0), h.unshift(h[0]), v.unshift(Tel)), $[$.length - 1] !== 1 && ($.push(1), h.push(null)), i.has(p) || i.set(p, {
        keyframes: {},
        transition: {}
      });
      const b = i.get(p);
      b.keyframes[g] = h, b.transition[g] = {
        ...t,
        duration: d,
        ease: v,
        times: $,
        ...n
      };
    }
  }), i;
}
function KY(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function ZY(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function Iel(e) {
  return Array.isArray(e) ? e : [e];
}
function Oel(e, t) {
  return e[t] ? { ...e, ...e[t] } : { ...e };
}
const Nel = (e) => typeof e == "number", zel = (e) => e.every(Nel);
function vge(e, t, n, o) {
  const r = gge(e, o), i = r.length;
  Md(!!i, "No valid element provided.");
  const a = [];
  for (let s = 0; s < i; s++) {
    const c = r[s];
    e0.has(c) || $el(c);
    const l = e0.get(c), u = { ...n };
    typeof u.delay == "function" && (u.delay = u.delay(s, i)), a.push(...uj(l, { ...t, transition: u }, {}));
  }
  return new hge(a);
}
const Rel = (e) => Array.isArray(e) && Array.isArray(e[0]);
function Pel(e, t, n) {
  const o = [];
  return Ael(e, t, n).forEach(({ keyframes: i, transition: a }, s) => {
    let c;
    Fc(s) ? c = age(s, i.default, a.default) : c = vge(s, i, a), o.push(c);
  }), new hge(o);
}
const Del = (e) => {
  function t(n, o, r) {
    let i;
    return Rel(n) ? i = Pel(n, o, e) : yel(o) ? i = vge(n, o, r, e) : i = age(n, o, r), e && e.animations.push(i), i;
  }
  return t;
};
function Lel() {
  const e = MC(() => ({
    current: null,
    animations: []
  })), t = MC(() => Del(e));
  return mge(() => {
    e.animations.forEach((n) => n.stop());
  }), [e, t];
}
var Mel = (e) => {
  let t = e;
  for (; t = t.parentElement; ) {
    const n = getComputedStyle(t, null).getPropertyValue("overflow-y");
    if (t === document.body)
      return window;
    if (n === "auto" || n === "scroll" || n === "overlay")
      return t;
  }
  return window;
}, bge = (e) => e.firstChild ? e.firstChild.offsetParent === e : !0, Fel = (e, t) => {
  let n = e, o = 0;
  bge(t) || (o += e.offsetTop - t.offsetTop, t = e.offsetParent, o += -e.offsetTop);
  do
    o += n.offsetTop, n = n.offsetParent;
  while (n && n !== t);
  return o;
}, qel = (e) => {
  let t = e.parentElement;
  for (; t && getComputedStyle(t, null).getPropertyValue("display") === "contents"; )
    t = t.parentElement;
  return t || window;
}, n0 = null;
typeof CSS < "u" && CSS.supports && (CSS.supports("position", "sticky") ? n0 = "sticky" : CSS.supports("position", "-webkit-sticky") && (n0 = "-webkit-sticky"));
var WC = !1;
try {
  const e = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get() {
      WC = { passive: !0 };
    }
  }), t = () => {
  };
  window.addEventListener("testPassive", t, e), window.removeEventListener("testPassive", t, e);
} catch {
}
var Bz = (e) => {
  const { el: t, onChange: n, unsubs: o, measure: r } = e;
  if (t === window) {
    const i = () => ({ top: 0, left: 0, height: window.innerHeight, width: window.innerWidth }), a = r(i()), s = () => {
      Object.assign(a, r(i())), n();
    };
    return window.addEventListener("resize", s, WC), o.push(() => window.removeEventListener("resize", s)), a;
  } else {
    const i = r(t.getBoundingClientRect()), a = () => {
      Object.assign(i, r(t.getBoundingClientRect())), n();
    }, s = new ResizeObserver(a);
    return s.observe(t), o.push(() => s.disconnect()), i;
  }
}, jel = (e) => {
  const t = getComputedStyle(e, null), n = parseInt(t.getPropertyValue("padding-top"), 10), o = parseInt(t.getPropertyValue("padding-bottom"), 10);
  return { top: n, bottom: o };
}, Vel = (e, t, n) => {
  const { bottom: o, offsetBottom: r, offsetTop: i } = n, a = Mel(e);
  let s = !1;
  const c = () => {
    s || requestAnimationFrame(() => {
      const M = d();
      M !== b && y(M), s = !1;
    }), s = !0;
  };
  let l = a === window ? window.scrollY : a.scrollTop;
  const u = (M) => {
    const { offsetTop: q, height: L } = p, { naturalTop: R } = h, { height: T } = $;
    return M + q + L >= R + T + v + r;
  }, d = () => {
    const { height: M } = p, { height: q } = $;
    return q + i + r <= M ? 3 : u(l) ? 1 : 2;
  }, _ = a !== window && bge(a), p = Bz({
    el: a,
    onChange: c,
    unsubs: t,
    measure: ({ height: M, top: q }) => ({
      height: M,
      offsetTop: _ ? q : 0
    })
  }), g = qel(e), f = g === window ? { top: 0, bottom: 0 } : jel(g), h = Bz({
    el: g,
    onChange: c,
    unsubs: t,
    measure: ({ height: M }) => ({
      height: M - f.top - f.bottom,
      naturalTop: g === window ? 0 : Fel(g, a) + f.top + p.offsetTop
    })
  }), $ = Bz({
    el: e,
    onChange: c,
    unsubs: t,
    measure: ({ height: M }) => ({ height: M })
  });
  let v = 0, b = d();
  const y = (M) => {
    const q = b;
    if (b = M, q === 2 && (v = -1), M === 3) {
      e.style.position = n0, o ? e.style.bottom = `${r}px` : e.style.top = `${i}px`;
      return;
    }
    const { height: L, offsetTop: R } = p, { height: T, naturalTop: D } = h, { height: A } = $;
    if (M === 2)
      if (e.style.position = "relative", v = q === 0 ? Math.max(0, R + l - D + i) : Math.max(
        0,
        R + l + L - (D + A + r)
      ), o) {
        const S = Math.max(0, T - A - v);
        e.style.bottom = `${S}px`;
      } else
        e.style.top = `${v}px`;
    else
      e.style.position = n0, M === 1 ? o ? e.style.bottom = `${r}px` : e.style.top = `${L - A - r}px` : o ? e.style.bottom = `${L - A - r}px` : e.style.top = `${i}px`;
  };
  y(b);
  const w = (M) => {
    if (M === l)
      return;
    const q = M - l;
    if (l = M, b === 3)
      return;
    const { offsetTop: L, height: R } = p, { naturalTop: T, height: D } = h, { height: A } = $;
    if (q > 0)
      if (b === 0) {
        if (M + L + i > T) {
          const S = Math.max(0, L + l - T + i);
          M + L + R <= T + A + S + r ? y(
            2
            /* relative */
          ) : y(
            1
            /* stickyBottom */
          );
        }
      } else
        b === 2 && u(M) && y(
          1
          /* stickyBottom */
        );
    else if (b === 1) {
      if (L + M + R < T + D + r) {
        const S = Math.max(
          0,
          L + l + R - (T + A + r)
        );
        L + M + i >= T + S ? y(
          2
          /* relative */
        ) : y(
          0
          /* stickyTop */
        );
      }
    } else
      b === 2 && L + M + i < T + v && y(
        0
        /* stickyTop */
      );
  }, N = a === window ? () => w(window.scrollY) : () => w(a.scrollTop);
  a.addEventListener("scroll", N, WC), a.addEventListener("mousewheel", N, WC), t.push(
    () => a.removeEventListener("scroll", N),
    () => a.removeEventListener("mousewheel", N)
  );
}, Bel = ({
  offsetTop: e = 0,
  offsetBottom: t = 0,
  bottom: n = !1
} = {}) => {
  const [o, r] = it(null);
  return yt(() => {
    if (!o || !n0)
      return;
    const i = [];
    return Vel(o, i, { offsetBottom: t, offsetTop: e, bottom: n }), () => {
      i.forEach((a) => a());
    };
  }, [o, t, e, n]), r;
}, Uel = (e) => {
  const { offsetTop: t, offsetBottom: n, bottom: o, children: r, className: i, style: a } = e, s = Bel({ offsetTop: t, offsetBottom: n, bottom: o });
  return /* @__PURE__ */ m("div", { className: i, style: a, ref: s, children: r });
}, Gel = Uel;
const yge = (e, t, n) => {
  var c, l;
  const o = e.metadata, r = (o == null ? void 0 : o.apps) && o.apps[t];
  if (r)
    return (n ? !0 : r.enabled) ? {
      ...r,
      // We should favor eventType's price and currency over appMetadata's price and currency
      price: e.price || r.price || null,
      currency: e.currency || r.currency || null,
      // trackingId is legacy way to store value for TRACKING_ID. So, we need to support both.
      TRACKING_ID: r.TRACKING_ID || r.trackingId || null
    } : null;
  const a = {
    stripe: {
      enabled: !!e.price,
      // Price default is 0 in DB. So, it would always be non nullish.
      price: e.price,
      // Currency default is "usd" in DB.So, it would also be available always
      currency: e.currency,
      paymentOption: "ON_BOOKING"
    },
    giphy: {
      enabled: !!((c = e.metadata) != null && c.giphyThankYouPage),
      thankYouPage: ((l = e.metadata) == null ? void 0 : l.giphyThankYouPage) || ""
    }
  }[t];
  return (n ? !0 : a == null ? void 0 : a.enabled) ? a : null;
}, Wel = {
  campfire: Tpe,
  dailyvideo: Ape,
  demodesk: Ipe,
  dialpad: Ope,
  discord: Npe,
  eightxeight: zpe,
  "element-call": Rpe,
  facetime: Ppe,
  fathom: Dpe,
  ga4: Lpe,
  googlevideo: Fpe,
  gtm: qpe,
  "horizon-workrooms": jpe,
  huddle01video: Vpe,
  insihts: Bpe,
  jelly: Upe,
  jitsivideo: Gpe,
  matomo: Wpe,
  metapixel: Hpe,
  mirotalk: Ype,
  nextcloudtalk: Kpe,
  office365video: Zpe,
  ping: Xpe,
  plausible: Jpe,
  posthog: Qpe,
  riverside: eme,
  roam: tme,
  salesroom: nme,
  shimmervideo: ome,
  signal: rme,
  sirius_video: ime,
  skype: ame,
  sylapsvideo: sme,
  tandemvideo: cme,
  telegram: lme,
  "booking-pages-tag": ume,
  "event-type-location-video-static": dme,
  twipla: _me,
  umami: pme,
  webex: mme,
  whatsapp: fme,
  whereby: gme,
  zoomvideo: hme
}, _j = {};
for (const [e, t] of Object.entries(Wel))
  _j[e] = vme(t);
const $ge = "cal_analytics_app_", Hel = ({ tag: e, appId: t }) => {
  var n, o;
  return e.pushEventScript ? {
    ...e.pushEventScript,
    // In case of complex pushEvent implementations, we could think about exporting a pushEvent function from the analytics app maybe but for now this should suffice
    content: (o = (n = e.pushEventScript) == null ? void 0 : n.content) == null ? void 0 : o.replace("$pushEvent", `${$ge}_${t}`)
  } : e.pushEventScript;
};
function Yel(e) {
  return Object.entries(_j).reduce(
    (t, n) => {
      var a;
      const [o, r] = n, i = yge(e, o);
      return !i || !((a = r.appData) != null && a.tag) || (t[o] = {
        meta: r,
        eventTypeAppData: i
      }), t;
    },
    {}
  );
}
function Kel(e) {
  const { type: t, ...n } = e.detail;
  return t.startsWith("__") ? !1 : (Object.entries(window).forEach(([o, r]) => {
    if (!o.startsWith($ge) || typeof r != "function")
      return;
    const i = window[o];
    i({
      name: t,
      data: n
    });
  }), window.opener && window.opener.postMessage(
    {
      type: `CAL:${t}`,
      ...n
    },
    "*"
  ), !0);
}
function Zel({
  eventType: e
}) {
  const t = Yel(e);
  return /* @__PURE__ */ m(nt, { children: Object.entries(t).map(([n, { meta: o, eventTypeAppData: r }]) => {
    const i = o.appData.tag, a = (c) => {
      if (!c)
        return c;
      const l = /\{([A-Z_\d]+)\}/g;
      let u;
      for (; u = l.exec(c); ) {
        const d = u[1];
        r[d] && (c = c.replace(
          new RegExp(`{${d}}`, "g"),
          r[d]
        ));
      }
      return c;
    }, s = Hel({ tag: i, appId: n });
    return i.scripts.concat(s ? [s] : []).map((c, l) => {
      const u = {}, d = c.attrs || {};
      return Object.entries(d).forEach(([_, p]) => {
        typeof p == "string" && (p = a(p)), u[_] = p;
      }), /* @__PURE__ */ m(
        Mme,
        {
          "data-testid": `cal-analytics-app-${n}`,
          src: a(c.src),
          id: `${n}-${l}`,
          dangerouslySetInnerHTML: {
            __html: a(c.content) || ""
          },
          ...u,
          defer: !0
        },
        `${n}-${l}`
      );
    });
  }) });
}
typeof window < "u" && (_r == null || _r.on("*", Kel));
const wge = () => {
  const e = cr();
  return !!(e != null && e.clientId && (e != null && e.isEmbed));
}, Xel = ({
  logoOnly: e,
  hasValidLicense: t
}) => {
  const { t: n } = kt(), o = tm();
  return /* @__PURE__ */ m("div", { className: `p-2 text-center text-xs sm:text-right${o ? " max-w-3xl" : ""}`, children: /* @__PURE__ */ de(Ir, { href: ycc, target: "_blank", className: "text-subtle", children: [
    !e && /* @__PURE__ */ de(nt, { children: [
      n("powered_by"),
      " "
    ] }),
    Kp === "Cal.com" || !t ? /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
      "img",
      {
        className: "-mt-px inline h-[10px] w-auto dark:invert",
        src: "https://app.cal.com/api/logo",
        alt: "Cal.com Logo"
      }
    ) }) : /* @__PURE__ */ m("span", { className: "text-emphasis font-semibold opacity-50 hover:opacity-100", children: Kp })
  ] }) });
};
var PA = {}, Jel = Dt && Dt.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n);
  var r = Object.getOwnPropertyDescriptor(t, n);
  (!r || ("get" in r ? !t.__esModule : r.writable || r.configurable)) && (r = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, o, r);
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), Qel = Dt && Dt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), etl = Dt && Dt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Jel(t, e, n);
  return Qel(t, e), t;
};
Object.defineProperty(PA, "__esModule", { value: !0 });
PA.useTurnstile = void 0;
const zh = etl(Fe), nk = typeof globalThis < "u" ? globalThis : window;
let Sg = typeof nk.turnstile < "u" ? "ready" : "unloaded", kge, C5;
const Sge = new Promise((e, t) => {
  C5 = { resolve: e, reject: t }, Sg === "ready" && e(void 0);
});
{
  const e = "cf__reactTurnstileOnLoad", t = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  kge = () => {
    if (Sg === "unloaded") {
      Sg = "loading", nk[e] = () => {
        C5.resolve(), Sg = "ready", delete nk[e];
      };
      const n = `${t}?onload=${e}&render=explicit`, o = document.createElement("script");
      o.src = n, o.async = !0, o.addEventListener("error", () => {
        C5.reject("Failed to load Turnstile."), delete nk[e];
      }), document.head.appendChild(o);
    }
    return Sge;
  };
}
function ttl({ id: e, className: t, style: n, sitekey: o, action: r, cData: i, theme: a, language: s, tabIndex: c, responseField: l, responseFieldName: u, size: d, fixedSize: _, retry: p, retryInterval: g, refreshExpired: f, appearance: h, execution: $, userRef: v, onVerify: b, onLoad: y, onError: w, onExpire: N, onTimeout: M, onAfterInteractive: q, onBeforeInteractive: L, onUnsupported: R }) {
  const T = (0, zh.useRef)(null), D = (0, zh.useState)({
    onVerify: b,
    onLoad: y,
    onError: w,
    onExpire: N,
    onTimeout: M,
    onAfterInteractive: q,
    onBeforeInteractive: L,
    onUnsupported: R
  })[0], A = v ?? T;
  return (0, zh.useEffect)(() => {
    if (!A.current)
      return;
    let S = !1, E = "";
    return (async () => {
      var x, k;
      if (Sg !== "ready")
        try {
          await kge();
        } catch (F) {
          (x = D.onError) === null || x === void 0 || x.call(D, F);
          return;
        }
      if (S || !A.current)
        return;
      let I;
      const z = {
        sitekey: o,
        action: r,
        cData: i,
        theme: a,
        language: s,
        tabindex: c,
        "response-field": l,
        "response-field-name": u,
        size: d,
        retry: p,
        "retry-interval": g,
        "refresh-expired": f,
        appearance: h,
        execution: $,
        callback: (F) => {
          var P;
          return (P = D.onVerify) === null || P === void 0 ? void 0 : P.call(D, F, I);
        },
        "error-callback": (F) => {
          var P;
          return (P = D.onError) === null || P === void 0 ? void 0 : P.call(D, F, I);
        },
        "expired-callback": (F) => {
          var P;
          return (P = D.onExpire) === null || P === void 0 ? void 0 : P.call(D, F, I);
        },
        "timeout-callback": () => {
          var F;
          return (F = D.onTimeout) === null || F === void 0 ? void 0 : F.call(D, I);
        },
        "after-interactive-callback": () => {
          var F;
          return (F = D.onAfterInteractive) === null || F === void 0 ? void 0 : F.call(D, I);
        },
        "before-interactive-callback": () => {
          var F;
          return (F = D.onBeforeInteractive) === null || F === void 0 ? void 0 : F.call(D, I);
        },
        "unsupported-callback": () => {
          var F;
          return (F = D.onUnsupported) === null || F === void 0 ? void 0 : F.call(D, I);
        }
      };
      E = window.turnstile.render(A.current, z), I = otl(E), (k = D.onLoad) === null || k === void 0 || k.call(D, E, I);
    })(), () => {
      S = !0, E && window.turnstile.remove(E);
    };
  }, [
    o,
    r,
    i,
    a,
    s,
    c,
    l,
    u,
    d,
    p,
    g,
    f,
    h,
    $
  ]), (0, zh.useEffect)(() => {
    D.onVerify = b, D.onLoad = y, D.onError = w, D.onExpire = N, D.onTimeout = M, D.onAfterInteractive = q, D.onBeforeInteractive = L, D.onUnsupported = R;
  }, [
    b,
    y,
    w,
    N,
    M,
    q,
    L,
    R
  ]), zh.default.createElement("div", { ref: A, id: e, className: t, style: _ ? {
    ...n ?? {},
    width: d === "compact" ? "130px" : "300px",
    height: d === "compact" ? "120px" : "65px"
  } : n });
}
var ntl = PA.default = ttl;
function otl(e) {
  return {
    execute: (t) => window.turnstile.execute(e, t),
    reset: () => window.turnstile.reset(e),
    getResponse: () => window.turnstile.getResponse(e),
    isExpired: () => window.turnstile.isExpired(e)
  };
}
function rtl() {
  const [e, t] = (0, zh.useState)(Sg);
  return (0, zh.useEffect)(() => {
    Sg !== "ready" && Sge.then(() => t(Sg));
  }, []), nk.turnstile;
}
PA.useTurnstile = rtl;
function itl(e) {
  return !zM || process.env.NEXT_PUBLIC_IS_E2E ? null : /* @__PURE__ */ m(ntl, { ...e, sitekey: zM, theme: "auto" });
}
const atl = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function stl(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(atl), e.apply(this, n);
}
function T5(e) {
  "@babel/helpers - typeof";
  return T5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, T5(e);
}
function XY(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function ctl(e, t, n) {
  return t && XY(e.prototype, t), n && XY(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ltl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function utl(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && o0(e, t);
}
function dtl(e) {
  var t = xge();
  return function() {
    var o = r0(e), r;
    if (t) {
      var i = r0(this).constructor;
      r = Reflect.construct(o, arguments, i);
    } else
      r = o.apply(this, arguments);
    return _tl(this, r);
  };
}
function _tl(e, t) {
  if (t && (T5(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ege(e);
}
function Ege(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function A5(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return A5 = function(o) {
    if (o === null || !ptl(o))
      return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(o))
        return t.get(o);
      t.set(o, r);
    }
    function r() {
      return mx(o, arguments, r0(this).constructor);
    }
    return r.prototype = Object.create(o.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), o0(r, o);
  }, A5(e);
}
function mx(e, t, n) {
  return xge() ? mx = Reflect.construct : mx = function(r, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var c = Function.bind.apply(r, s), l = new c();
    return a && o0(l, a.prototype), l;
  }, mx.apply(null, arguments);
}
function xge() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ptl(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function o0(e, t) {
  return o0 = Object.setPrototypeOf || function(o, r) {
    return o.__proto__ = r, o;
  }, o0(e, t);
}
function r0(e) {
  return r0 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, r0(e);
}
var Jm = /* @__PURE__ */ function(e) {
  utl(n, e);
  var t = dtl(n);
  function n(o) {
    var r;
    return ltl(this, n), r = t.call(this, o), Object.setPrototypeOf(Ege(r), n.prototype), r.name = r.constructor.name, r;
  }
  return ctl(n);
}(/* @__PURE__ */ A5(Error)), pj = 2, mtl = 17, ftl = 3, V_ = "0-9０-９٠-٩۰-۹", gtl = "-‐-―−ー－", htl = "／/", vtl = "．.", btl = "  ­​⁠　", ytl = "()（）［］\\[\\]", $tl = "~⁓∼～", HC = "".concat(gtl).concat(htl).concat(vtl).concat(btl).concat(ytl).concat($tl), mj = "+＋";
function JY(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), o = t[0].split("."), r = 0; r < 3; r++) {
    var i = Number(n[r]), a = Number(o[r]);
    if (i > a)
      return 1;
    if (a > i)
      return -1;
    if (!isNaN(i) && isNaN(a))
      return 1;
    if (isNaN(i) && !isNaN(a))
      return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var wtl = {}.constructor;
function fx(e) {
  return e != null && e.constructor === wtl;
}
function I5(e) {
  "@babel/helpers - typeof";
  return I5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, I5(e);
}
function DA(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function QY(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function LA(e, t, n) {
  return t && QY(e.prototype, t), n && QY(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ktl = "1.2.0", Stl = "1.7.35", eK = " ext. ", Etl = /^\d+$/, wl = /* @__PURE__ */ function() {
  function e(t) {
    DA(this, e), Atl(t), this.metadata = t, Cge.call(this, t);
  }
  return LA(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, o) {
      if (n && Etl.test(n) && (o = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new tK(this.getCountryMetadata(n), this);
      } else if (o) {
        if (!this.hasCallingCode(o))
          throw new Error("Unknown calling code: ".concat(o));
        this.numberingPlan = new tK(this.getNumberingPlanMetadata(o), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var o = this.countryCallingCodes()[n];
      if (o)
        return o.length === 1 && o[0].length === 3 ? void 0 : o;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var o = this.getCountryCodesForCallingCode(n);
      if (o)
        return o[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var o = this.getCountryCodeForCallingCode(n);
      if (o)
        return this.getCountryMetadata(o);
      if (this.nonGeographic()) {
        var r = this.nonGeographic()[n];
        if (r)
          return r;
      } else {
        var i = this.countryCallingCodes()[n];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), tK = /* @__PURE__ */ function() {
  function e(t, n) {
    DA(this, e), this.globalMetadataObject = n, this.metadata = t, Cge.call(this, n.metadata);
  }
  return LA(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, o = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return o.map(function(r) {
        return new xtl(r, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && nK(this.types(), n))
        return new Ttl(nK(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? eK : this.metadata[13] || eK;
    }
  }]), e;
}(), xtl = /* @__PURE__ */ function() {
  function e(t, n) {
    DA(this, e), this._format = t, this.metadata = n;
  }
  return LA(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Ctl.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Ctl = /^\(?\$1\)?$/, Ttl = /* @__PURE__ */ function() {
  function e(t, n) {
    DA(this, e), this.type = t, this.metadata = n;
  }
  return LA(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function nK(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Atl(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!fx(e) || !fx(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(fx(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Itl(e) + ": " + e, "."));
}
var Itl = function(t) {
  return I5(t);
};
function fj(e, t) {
  if (t = new wl(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Otl(e, t) {
  return t.countries.hasOwnProperty(e);
}
function Cge(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? JY(t, ktl) === -1 ? this.v2 = !0 : JY(t, Stl) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Ntl = ";ext=", _b = function(t) {
  return "([".concat(V_, "]{1,").concat(t, "})");
};
function Tge(e) {
  var t = "20", n = "15", o = "9", r = "6", i = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", l = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", d = "[  \\t]*", _ = "(?:,{2}|;)", p = Ntl + _b(t), g = i + c + a + _b(t) + s, f = i + l + a + _b(o) + s, h = u + _b(r) + "#", $ = d + _ + a + _b(n) + s, v = d + "(?:,)+" + a + _b(o) + s;
  return p + "|" + g + "|" + f + "|" + h + "|" + $ + "|" + v;
}
var ztl = "[" + V_ + "]{" + pj + "}", Rtl = "[" + mj + "]{0,1}(?:[" + HC + "]*[" + V_ + "]){3,}[" + HC + V_ + "]*", Ptl = new RegExp("^[" + mj + "]{0,1}(?:[" + HC + "]*[" + V_ + "]){1,2}$", "i"), Dtl = Rtl + // Phone number extensions
"(?:" + Tge() + ")?", Ltl = new RegExp(
  // Either a short two-digit-only phone number
  "^" + ztl + "$|^" + Dtl + "$",
  "i"
);
function Mtl(e) {
  return e.length >= pj && Ltl.test(e);
}
function Ftl(e) {
  return Ptl.test(e);
}
var oK = new RegExp("(?:" + Tge() + ")$", "i");
function qtl(e) {
  var t = e.search(oK);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), o = e.match(oK), r = 1; r < o.length; ) {
    if (o[r])
      return {
        number: n,
        ext: o[r]
      };
    r++;
  }
}
var jtl = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Vtl(e) {
  return jtl[e];
}
function Btl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Utl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Utl(e, t) {
  if (e) {
    if (typeof e == "string")
      return rK(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rK(e, t);
  }
}
function rK(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function iK(e) {
  for (var t = "", n = Btl(e.split("")), o; !(o = n()).done; ) {
    var r = o.value;
    t += Gtl(r, t) || "";
  }
  return t;
}
function Gtl(e, t, n) {
  if (e === "+") {
    if (t) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return Vtl(e);
}
function Wtl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Htl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Htl(e, t) {
  if (e) {
    if (typeof e == "string")
      return aK(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return aK(e, t);
  }
}
function aK(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Ytl(e, t) {
  for (var n = e.slice(), o = Wtl(t), r; !(r = o()).done; ) {
    var i = r.value;
    e.indexOf(i) < 0 && n.push(i);
  }
  return n.sort(function(a, s) {
    return a - s;
  });
}
function gj(e, t) {
  return Age(e, void 0, t);
}
function Age(e, t, n) {
  var o = n.type(t), r = o && o.possibleLengths() || n.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return Age(e, "MOBILE", n);
    var i = n.type("MOBILE");
    i && (r = Ytl(r, i.possibleLengths()));
  } else if (t && !o)
    return "INVALID_LENGTH";
  var a = e.length, s = r[0];
  return s === a ? "IS_POSSIBLE" : s > a ? "TOO_SHORT" : r[r.length - 1] < a ? "TOO_LONG" : r.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Ktl(e, t, n) {
  if (t === void 0 && (t = {}), n = new wl(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Ige(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Ige(e, t) {
  switch (gj(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function bf(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Ztl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Xtl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xtl(e, t) {
  if (e) {
    if (typeof e == "string")
      return sK(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return sK(e, t);
  }
}
function sK(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
var Jtl = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function hj(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new wl(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var o = t.v2 ? e.nationalNumber : e.phone;
    if (bf(o, n.nationalNumberPattern())) {
      if (Uz(o, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Uz(o, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var r = Ztl(Jtl), i; !(i = r()).done; ) {
        var a = i.value;
        if (Uz(o, a, n))
          return a;
      }
    }
  }
}
function Uz(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : bf(e, t.pattern());
}
function Qtl(e, t, n) {
  if (t = t || {}, n = new wl(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return hj(e, t, n.metadata) !== void 0;
  var o = t.v2 ? e.nationalNumber : e.phone;
  return bf(o, n.nationalNumberPattern());
}
function enl(e, t, n) {
  var o = new wl(n), r = o.getCountryCodesForCallingCode(e);
  return r ? r.filter(function(i) {
    return tnl(t, i, n);
  }) : [];
}
function tnl(e, t, n) {
  var o = new wl(n);
  return o.selectNumberingPlan(t), o.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function nnl(e) {
  return e.replace(new RegExp("[".concat(HC, "]+"), "g"), " ").trim();
}
var onl = /(\$\d)/;
function rnl(e, t, n) {
  var o = n.useInternationalFormat, r = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var i = e.replace(new RegExp(t.pattern()), o ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    r && t.nationalPrefixFormattingRule() ? t.format().replace(onl, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return o ? nnl(i) : i;
}
var inl = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function anl(e, t, n) {
  var o = new wl(n);
  if (o.selectNumberingPlan(e, t), o.defaultIDDPrefix())
    return o.defaultIDDPrefix();
  if (inl.test(o.IDDPrefix()))
    return o.IDDPrefix();
}
function snl(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function cnl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = lnl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lnl(e, t) {
  if (e) {
    if (typeof e == "string")
      return cK(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return cK(e, t);
  }
}
function cK(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function lK(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function uK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lK(Object(n), !0).forEach(function(o) {
      unl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lK(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function unl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var dK = {
  formatExtension: function(t, n, o) {
    return "".concat(t).concat(o.ext()).concat(n);
  }
};
function dnl(e, t, n, o) {
  if (n ? n = uK(uK({}, dK), n) : n = dK, o = new wl(o), e.country && e.country !== "001") {
    if (!o.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    o.country(e.country);
  } else if (e.countryCallingCode)
    o.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var r = o.countryCallingCode(), i = n.v2 ? e.nationalNumber : e.phone, a;
  switch (t) {
    case "NATIONAL":
      return i ? (a = YC(i, e.carrierCode, "NATIONAL", o, n), Gz(a, e.ext, o, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (a = YC(i, null, "INTERNATIONAL", o, n), a = "+".concat(r, " ").concat(a), Gz(a, e.ext, o, n.formatExtension)) : "+".concat(r);
    case "E.164":
      return "+".concat(r).concat(i);
    case "RFC3966":
      return snl({
        number: "+".concat(r).concat(i),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = pnl(i, e.carrierCode, r, n.fromCountry, o);
      return Gz(s, e.ext, o, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function YC(e, t, n, o, r) {
  var i = _nl(o.formats(), e);
  return i ? rnl(e, i, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && r && r.nationalPrefix === !1),
    carrierCode: t,
    metadata: o
  }) : e;
}
function _nl(e, t) {
  for (var n = cnl(e), o; !(o = n()).done; ) {
    var r = o.value;
    if (r.leadingDigitsPatterns().length > 0) {
      var i = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (bf(t, r.pattern()))
      return r;
  }
}
function Gz(e, t, n, o) {
  return t ? o(e, t, n) : e;
}
function pnl(e, t, n, o, r) {
  var i = fj(o, r.metadata);
  if (i === n) {
    var a = YC(e, t, "NATIONAL", r);
    return n === "1" ? n + " " + a : a;
  }
  var s = anl(o, void 0, r.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(YC(e, null, "INTERNATIONAL", r));
}
function _K(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function pK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _K(Object(n), !0).forEach(function(o) {
      mnl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _K(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function mnl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fnl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mK(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function gnl(e, t, n) {
  return t && mK(e.prototype, t), n && mK(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var hnl = /* @__PURE__ */ function() {
  function e(t, n, o) {
    if (fnl(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!o)
      throw new TypeError("`metadata` not passed");
    var r = bnl(t, o), i = r.country, a = r.countryCallingCode;
    this.country = i, this.countryCallingCode = a, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return o;
    };
  }
  return gnl(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : enl(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Ktl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return Qtl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new wl(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return hj(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, o) {
      return dnl(this, n, o ? pK(pK({}, o), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), vnl = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function bnl(e, t) {
  var n, o, r = new wl(t);
  return vnl(e) ? (n = e, r.selectNumberingPlan(n), o = r.countryCallingCode()) : o = e, {
    country: n,
    countryCallingCode: o
  };
}
var ynl = new RegExp("([" + V_ + "])");
function $nl(e, t, n, o) {
  if (t) {
    var r = new wl(o);
    r.selectNumberingPlan(t, n);
    var i = new RegExp(r.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var a = e.match(ynl);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return e;
    }
  }
}
function wnl(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), o = n.exec(e);
    if (o) {
      var r, i, a = o.length - 1, s = a > 0 && o[a];
      if (t.nationalPrefixTransformRule() && s)
        r = e.replace(n, t.nationalPrefixTransformRule()), a > 1 && (i = o[1]);
      else {
        var c = o[0];
        r = e.slice(c.length), s && (i = o[1]);
      }
      var l;
      if (s) {
        var u = e.indexOf(o[1]), d = e.slice(0, u);
        d === t.numberingPlan.nationalPrefix() && (l = t.numberingPlan.nationalPrefix());
      } else
        l = o[0];
      return {
        nationalNumber: r,
        nationalPrefix: l,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function O5(e, t) {
  var n = wnl(e, t), o = n.carrierCode, r = n.nationalNumber;
  if (r !== e) {
    if (!knl(e, r, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !Snl(r, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: o
  };
}
function knl(e, t, n) {
  return !(bf(e, n.nationalNumberPattern()) && !bf(t, n.nationalNumberPattern()));
}
function Snl(e, t) {
  switch (gj(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Enl(e, t, n, o) {
  var r = t ? fj(t, o) : n;
  if (e.indexOf(r) === 0) {
    o = new wl(o), o.selectNumberingPlan(t, n);
    var i = e.slice(r.length), a = O5(i, o), s = a.nationalNumber, c = O5(e, o), l = c.nationalNumber;
    if (!bf(l, o.nationalNumberPattern()) && bf(s, o.nationalNumberPattern()) || gj(l, o) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: i
      };
  }
  return {
    number: e
  };
}
function xnl(e, t, n, o) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var i = $nl(e, t, n, o);
    if (i && i !== e)
      r = !0, e = "+" + i;
    else {
      if (t || n) {
        var a = Enl(e, t, n, o), s = a.countryCallingCode, c = a.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  o = new wl(o);
  for (var l = 2; l - 1 <= ftl && l <= e.length; ) {
    var u = e.slice(1, l);
    if (o.hasCallingCode(u))
      return o.selectNumberingPlan(u), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(l)
      };
    l++;
  }
  return {};
}
function Cnl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Tnl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tnl(e, t) {
  if (e) {
    if (typeof e == "string")
      return fK(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return fK(e, t);
  }
}
function fK(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Anl(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var o = t.metadata;
  o = new wl(o);
  for (var r = Cnl(n), i; !(i = r()).done; ) {
    var a = i.value;
    if (o.country(a), o.leadingDigits()) {
      if (e && e.search(o.leadingDigits()) === 0)
        return a;
    } else if (hj({
      phone: e,
      country: a
    }, void 0, o.metadata))
      return a;
  }
}
var Inl = !1;
function Onl(e, t) {
  var n = t.nationalNumber, o = t.defaultCountry, r = t.metadata;
  if (Inl && r.isNonGeographicCallingCode(e))
    return "001";
  var i = r.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : Anl(n, {
      countries: i,
      defaultCountry: o,
      metadata: r.metadata
    });
}
var Oge = "+", Nnl = "[\\-\\.\\(\\)]?", gK = "([" + V_ + "]|" + Nnl + ")", znl = "^\\" + Oge + gK + "*[" + V_ + "]" + gK + "*$", Rnl = new RegExp(znl, "g"), N5 = V_, Pnl = "[" + N5 + "]+((\\-)*[" + N5 + "])*", Dnl = "a-zA-Z", Lnl = "[" + Dnl + "]+((\\-)*[" + N5 + "])*", Mnl = "^(" + Pnl + "\\.)*" + Lnl + "\\.?$", Fnl = new RegExp(Mnl, "g"), hK = "tel:", z5 = ";phone-context=", qnl = ";isub=";
function jnl(e) {
  var t = e.indexOf(z5);
  if (t < 0)
    return null;
  var n = t + z5.length;
  if (n >= e.length)
    return "";
  var o = e.indexOf(";", n);
  return o >= 0 ? e.substring(n, o) : e.substring(n);
}
function Vnl(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Rnl.test(e) || Fnl.test(e);
}
function Bnl(e, t) {
  var n = t.extractFormattedPhoneNumber, o = jnl(e);
  if (!Vnl(o))
    throw new Jm("NOT_A_NUMBER");
  var r;
  if (o === null)
    r = n(e) || "";
  else {
    r = "", o.charAt(0) === Oge && (r += o);
    var i = e.indexOf(hK), a;
    i >= 0 ? a = i + hK.length : a = 0;
    var s = e.indexOf(z5);
    r += e.substring(a, s);
  }
  var c = r.indexOf(qnl);
  if (c > 0 && (r = r.substring(0, c)), r !== "")
    return r;
}
var Unl = 250, Gnl = new RegExp("[" + mj + V_ + "]"), Wnl = new RegExp("[^" + V_ + "#]+$");
function Hnl(e, t, n) {
  if (t = t || {}, n = new wl(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new Jm("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var o = Knl(e, t.v2, t.extract), r = o.number, i = o.ext, a = o.error;
  if (!r) {
    if (t.v2)
      throw a === "TOO_SHORT" ? new Jm("TOO_SHORT") : new Jm("NOT_A_NUMBER");
    return {};
  }
  var s = Xnl(r, t.defaultCountry, t.defaultCallingCode, n), c = s.country, l = s.nationalNumber, u = s.countryCallingCode, d = s.countryCallingCodeSource, _ = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Jm("INVALID_COUNTRY");
    return {};
  }
  if (!l || l.length < pj) {
    if (t.v2)
      throw new Jm("TOO_SHORT");
    return {};
  }
  if (l.length > mtl) {
    if (t.v2)
      throw new Jm("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new hnl(u, l, n.metadata);
    return c && (p.country = c), _ && (p.carrierCode = _), i && (p.ext = i), p.__countryCallingCodeSource = d, p;
  }
  var g = (t.extended ? n.hasSelectedNumberingPlan() : c) ? bf(l, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: c,
    countryCallingCode: u,
    carrierCode: _,
    valid: g,
    possible: g ? !0 : !!(t.extended === !0 && n.possibleLengths() && Ige(l, n)),
    phone: l,
    ext: i
  } : g ? Znl(c, l, i) : {};
}
function Ynl(e, t, n) {
  if (e) {
    if (e.length > Unl) {
      if (n)
        throw new Jm("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var o = e.search(Gnl);
    if (!(o < 0))
      return e.slice(o).replace(Wnl, "");
  }
}
function Knl(e, t, n) {
  var o = Bnl(e, {
    extractFormattedPhoneNumber: function(a) {
      return Ynl(a, n, t);
    }
  });
  if (!o)
    return {};
  if (!Mtl(o))
    return Ftl(o) ? {
      error: "TOO_SHORT"
    } : {};
  var r = qtl(o);
  return r.ext ? r : {
    number: o
  };
}
function Znl(e, t, n) {
  var o = {
    country: e,
    phone: t
  };
  return n && (o.ext = n), o;
}
function Xnl(e, t, n, o) {
  var r = xnl(iK(e), t, n, o.metadata), i = r.countryCallingCodeSource, a = r.countryCallingCode, s = r.number, c;
  if (a)
    o.selectNumberingPlan(a);
  else if (s && (t || n))
    o.selectNumberingPlan(t, n), t && (c = t), a = n || fj(t, o.metadata);
  else
    return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: a
    };
  var l = O5(iK(s), o), u = l.nationalNumber, d = l.carrierCode, _ = Onl(a, {
    nationalNumber: u,
    defaultCountry: t,
    metadata: o
  });
  return _ && (c = _, _ === "001" || o.country(c)), {
    country: c,
    countryCallingCode: a,
    countryCallingCodeSource: i,
    nationalNumber: u,
    carrierCode: d
  };
}
function vK(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function bK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vK(Object(n), !0).forEach(function(o) {
      Jnl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vK(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Jnl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qnl(e, t, n) {
  return Hnl(e, bK(bK({}, t), {}, {
    v2: !0
  }), n);
}
function yK(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function eol(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yK(Object(n), !0).forEach(function(o) {
      tol(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yK(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function tol(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nol(e, t) {
  return aol(e) || iol(e, t) || rol(e, t) || ool();
}
function ool() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rol(e, t) {
  if (e) {
    if (typeof e == "string")
      return $K(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return $K(e, t);
  }
}
function $K(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function iol(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o = [], r = !0, i = !1, a, s;
    try {
      for (n = n.call(e); !(r = (a = n.next()).done) && (o.push(a.value), !(t && o.length === t)); r = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !r && n.return != null && n.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return o;
  }
}
function aol(e) {
  if (Array.isArray(e))
    return e;
}
function sol(e) {
  var t = Array.prototype.slice.call(e), n = nol(t, 4), o = n[0], r = n[1], i = n[2], a = n[3], s, c, l;
  if (typeof o == "string")
    s = o;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!r || typeof r == "string")
    a ? (c = i, l = a) : (c = void 0, l = i), r && (c = eol({
      defaultCountry: r
    }, c));
  else if (fx(r))
    i ? (c = r, l = i) : l = r;
  else
    throw new Error("Invalid second argument: ".concat(r));
  return {
    text: s,
    options: c,
    metadata: l
  };
}
function wK(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function kK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wK(Object(n), !0).forEach(function(o) {
      col(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wK(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function col(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function lol(e, t, n) {
  t && t.defaultCountry && !Otl(t.defaultCountry, n) && (t = kK(kK({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return Qnl(e, t, n);
  } catch (o) {
    if (!(o instanceof Jm))
      throw o;
  }
}
function SK(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function EK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? SK(Object(n), !0).forEach(function(o) {
      uol(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : SK(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function uol(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dol() {
  var e = sol(arguments), t = e.text, n = e.options, o = e.metadata;
  n = EK(EK({}, n), {}, {
    extract: !1
  });
  var r = lol(t, n, o);
  return r && r.isValid() || !1;
}
function i0() {
  return stl(dol, arguments);
}
const Nc = {
  name: "variants",
  email: "text",
  phone: "text",
  address: "text",
  text: "text",
  number: "text",
  textarea: "text",
  select: "select",
  multiselect: "multiselect",
  multiemail: "textList",
  radioInput: "objectiveWithInput",
  checkbox: "multiselect",
  radio: "select",
  boolean: "boolean",
  url: "text"
}, _ol = {
  // This won't be stored in DB. It allows UI to be configured from the codebase for all existing booking fields stored in DB as well
  // Candidates for this are:
  // - Anything that you want to show in App UI only.
  // - Default values that are shown in UI that are supposed to be changed for existing bookingFields as well if user is using default values
  name: {
    label: "Name",
    value: "name",
    isTextType: !0,
    systemOnly: !0,
    variantsConfig: {
      toggleLabel: 'Split "Full name" into "First name" and "Last name"',
      defaultVariant: "fullName",
      variants: {
        firstAndLastName: {
          label: "first_last_name",
          fieldsMap: {
            firstName: {
              defaultLabel: "first_name",
              canChangeRequirability: !1
            },
            lastName: {
              defaultLabel: "last_name",
              canChangeRequirability: !0
            }
          }
        },
        fullName: {
          label: "your_name",
          fieldsMap: {
            fullName: {
              defaultLabel: "your_name",
              defaultPlaceholder: "example_name",
              canChangeRequirability: !1
            }
          }
        }
      },
      defaultValue: {
        variants: {
          firstAndLastName: {
            // Configures variant fields
            // This array form(in comparison to a generic component form) has the benefit that we can allow configuring placeholder, label, required etc. for each variant
            // Doing this in a generic component form would require a lot of work in terms of supporting variables maybe that would be read by the component.
            fields: [
              {
                // This name won't be configurable by user. User can always configure the main field name
                name: "firstName",
                type: "text",
                required: !0
              },
              {
                name: "lastName",
                type: "text",
                required: !1
              }
            ]
          },
          fullName: {
            fields: [
              {
                name: "fullName",
                type: "text",
                label: "your_name",
                required: !0
              }
            ]
          }
        }
      }
    }
  },
  email: {
    label: "Email",
    value: "email",
    isTextType: !0
  },
  phone: {
    label: "Phone",
    value: "phone",
    isTextType: !0
  },
  address: {
    label: "Address",
    value: "address",
    isTextType: !0
  },
  text: {
    label: "Short Text",
    value: "text",
    isTextType: !0
  },
  number: {
    label: "Number",
    value: "number",
    isTextType: !0,
    supportsPricing: !0
  },
  textarea: {
    label: "Long Text",
    value: "textarea",
    isTextType: !0,
    supportsLengthCheck: {
      // Keep it as small as possible. It is easier to change to a higher value but coming back to a lower value(due to any reason) would be problematic for users who have saved higher value.
      maxLength: 1e3
    }
  },
  select: {
    label: "Select",
    value: "select",
    needsOptions: !0,
    isTextType: !0,
    optionsSupportPricing: !0
  },
  multiselect: {
    label: "MultiSelect",
    value: "multiselect",
    needsOptions: !0,
    isTextType: !1,
    optionsSupportPricing: !0
  },
  multiemail: {
    label: "Multiple Emails",
    value: "multiemail",
    isTextType: !0
  },
  radioInput: {
    label: "Radio Input",
    value: "radioInput",
    isTextType: !1,
    systemOnly: !0
    // This is false currently because we don't want to show the options for Location field right now. It is the only field with type radioInput.
    // needsOptions: true,
  },
  checkbox: {
    label: "Checkbox Group",
    value: "checkbox",
    needsOptions: !0,
    isTextType: !1,
    optionsSupportPricing: !0
  },
  radio: {
    label: "Radio Group",
    value: "radio",
    needsOptions: !0,
    isTextType: !1,
    optionsSupportPricing: !0
  },
  boolean: {
    label: "Checkbox",
    value: "boolean",
    isTextType: !1,
    supportsPricing: !0
  },
  url: {
    label: "URL",
    value: "url",
    isTextType: !0
  }
}, sc = _ol;
Object.entries(sc).forEach(([e, t]) => {
  t.propsType = Nc[e];
});
const Nge = (e, t) => e === "firstAndLastName" ? mol(t) : pol(t), pol = (e) => {
  if (!e)
    return "";
  let t = "";
  return typeof e == "string" ? t = e : (t = e.firstName, e.lastName && (t = `${t} ${e.lastName}`)), t;
};
function mol(e) {
  let t;
  if (e = e || "", typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      const o = e.split(" ").map((a) => a.trim()), r = o[0], i = o.slice(1).join(" ");
      t = { firstName: r, lastName: i };
    }
  else
    t = e;
  return t;
}
function fol(e, t) {
  return Object.entries(e).reduce((n, [o, r]) => {
    const i = r.fields.map((a) => {
      const s = a.label ?? "", c = a.placeholder ?? "";
      return {
        ...a,
        label: t(s),
        placeholder: t(c)
      };
    });
    return n[o] = {
      ...r,
      fields: i
    }, n;
  }, {});
}
const vj = (e) => {
  var i;
  const t = e.variantsConfig, n = sc[e.type];
  if (!n)
    throw new Error(`Invalid field.type ${e.type}}`);
  const o = (i = n == null ? void 0 : n.variantsConfig) == null ? void 0 : i.defaultValue, r = t || o;
  if (n.propsType === "variants" && !r)
    throw new Error("propsType variants must have variantsConfig");
  return r;
}, gol = (e, t) => {
  const n = vj(e);
  if (!n)
    return n;
  const o = fol(n.variants, t);
  return {
    ...n,
    variants: o
  };
}, xK = () => oe.string().refine((e) => e.trim().length > 0);
oe.object({
  label: oe.string(),
  value: cce,
  isTextType: oe.boolean().default(!1).optional(),
  systemOnly: oe.boolean().default(!1).optional(),
  needsOptions: oe.boolean().default(!1).optional(),
  supportsLengthCheck: oe.object({
    maxLength: oe.number()
  }).optional(),
  supportsPricing: oe.boolean().default(!1).optional(),
  optionsSupportPricing: oe.boolean().default(!1).optional(),
  propsType: oe.enum([
    "text",
    "textList",
    "select",
    "multiselect",
    "boolean",
    "objectiveWithInput",
    "variants"
  ]),
  // It is the config that can tweak what an existing or a new field shows in the App UI or booker UI.
  variantsConfig: oe.object({
    /**
     * This is the default variant that will be used when a new field is created.
     */
    defaultVariant: oe.string(),
    /**
     *  Used only when there are 2 variants, so that UI can be simplified by showing a switch(with this label) instead of a Select
     */
    toggleLabel: oe.string().optional(),
    variants: oe.record(
      oe.object({
        /**
         * That's how the variant would be labelled in App UI. This label represents the field in booking questions' list
         * Supports translation
         */
        label: oe.string(),
        fieldsMap: oe.record(
          oe.object({
            /**
             * Supports translation
             */
            defaultLabel: oe.string().optional(),
            /**
             * Supports translation
             */
            defaultPlaceholder: oe.string().optional(),
            /**
             * Decides if a variant field's required property can be changed or not
             */
            canChangeRequirability: oe.boolean().default(!0).optional()
          })
        )
      })
    ),
    /**
     * This is the default configuration for the field.
     */
    defaultValue: uce.optional()
  }).optional()
}).refine((e) => {
  if (!e.variantsConfig)
    return;
  const t = e.variantsConfig;
  if (!t.variants[t.defaultVariant])
    throw new Error(`defaultVariant: ${t.defaultVariant} is not in variants`);
  return !0;
});
oe.array(dce);
const CK = {
  name: {
    preprocess: ({ response: e, field: t }) => {
      var i;
      const n = sc[t.type], o = t.variant || ((i = n == null ? void 0 : n.variantsConfig) == null ? void 0 : i.defaultVariant);
      let r;
      if (!o)
        throw new Error("`variant` must be there for the field with `variantsConfig`");
      return o !== "firstAndLastName" && o !== "fullName" ? r = "fullName" : r = o, Nge(r, e);
    },
    superRefine: ({ field: e, response: t, isPartialSchema: n, ctx: o, m: r }) => {
      var d;
      const i = oe.string(), a = sc[e.type], s = e.variant || ((d = a == null ? void 0 : a.variantsConfig) == null ? void 0 : d.defaultVariant);
      if (!s)
        throw new Error("`variant` must be there for the field with `variantsConfig`");
      const c = vj(e);
      if (!c)
        throw new Error("variantsConfig must be there for `name` field");
      const l = c.variants[s].fields, u = ["text"];
      if (l.length === 1) {
        const _ = l[0];
        if (u.includes(_.type)) {
          (_.required && !n ? xK() : i).safeParse(t).success || o.addIssue({ code: oe.ZodIssueCode.custom, message: r("Invalid string") });
          return;
        } else
          throw new Error(`Unsupported field.type with variants: ${_.type}`);
      }
      l.forEach((_) => {
        const p = _.required && !n ? xK() : i;
        if (!u.includes(_.type))
          throw new Error(`Unsupported field.type with variants: ${_.type}`);
        const g = t;
        if (_.required && (!n && !g[_.name] && o.addIssue({ code: oe.ZodIssueCode.custom, message: r("error_required_field") }), !p.safeParse(g[_.name]).success)) {
          o.addIssue({ code: oe.ZodIssueCode.custom, message: r("Invalid string") });
          return;
        }
      });
    }
  },
  textarea: {
    preprocess: ({ response: e }) => e.trim(),
    superRefine: ({ field: e, response: t, ctx: n, m: o }) => {
      var u;
      const r = sc[e.type], i = t ?? "", a = e.maxLength ?? ((u = r.supportsLengthCheck) == null ? void 0 : u.maxLength), s = e.minLength ?? 0;
      if (!a)
        throw new Error("maxLength must be there for textarea field");
      const c = i.length > a, l = i.length < s;
      if (c) {
        n.addIssue({
          code: oe.ZodIssueCode.custom,
          message: o(`Max. ${a} characters allowed`)
        });
        return;
      }
      if (l) {
        n.addIssue({
          code: oe.ZodIssueCode.custom,
          message: o(`Min. ${s} characters required`)
        });
        return;
      }
    }
  },
  url: {
    preprocess: ({ response: e }) => e.trim(),
    superRefine: ({ response: e, ctx: t, m: n }) => {
      const o = e ?? "", r = oe.string().url();
      if (o.match(/^https?:\/[^\/]/)) {
        t.addIssue({
          code: oe.ZodIssueCode.custom,
          message: n("url_validation_error")
        });
        return;
      }
      if (r.safeParse(o).success)
        return;
      if (/^[a-z0-9.-]+\.[a-z]{2,}(\/.*)?$/i.test(o)) {
        const a = `https://${o}`;
        if (r.safeParse(a).success)
          return;
      }
      t.addIssue({
        code: oe.ZodIssueCode.custom,
        message: n("url_validation_error")
      });
    }
  }
}, hol = oe.union([
  oe.string(),
  oe.boolean(),
  oe.string().array(),
  oe.object({
    optionValue: oe.string(),
    value: oe.string()
  }),
  // For variantsConfig case
  oe.record(oe.string())
]), vol = oe.record(hol), bol = vol, TK = (e) => e ? e.replace(/^ +/, "+") : "", yol = ({ bookingFields: e, view: t }) => {
  const n = MT.unwrap().partial().and(bol);
  return bj({ schema: n, bookingFields: e, isPartialSchema: !0, view: t });
};
function $ol({ bookingFields: e, view: t }) {
  const n = MT.and(oe.record(oe.any()));
  return bj({ schema: n, bookingFields: e, isPartialSchema: !1, view: t });
}
function wol({ bookingFields: e, view: t }) {
  const n = MT.and(oe.record(oe.any()));
  return bj({ schema: n, bookingFields: e, isPartialSchema: !1, view: t, checkOptional: !0 });
}
function bj({
  schema: e,
  bookingFields: t,
  isPartialSchema: n,
  view: o,
  checkOptional: r = !1
}) {
  const i = oe.preprocess(
    (a) => {
      const s = oe.record(oe.any()).nullable().parse(a) || {}, c = {};
      return t ? (t.forEach((l) => {
        const u = s[l.name];
        if (u === void 0)
          return;
        const d = l.views;
        if (!(o === "ALL_VIEWS" ? !0 : d ? d.find((g) => g.id === o) : !0))
          return;
        const p = CK[l.type];
        if (p) {
          c[l.name] = p.preprocess({
            response: u,
            isPartialSchema: n,
            field: l
          });
          return;
        }
        if (l.type === "boolean")
          c[l.name] = u === "true" || u === !0;
        else if (l.type === "multiemail" || l.type === "checkbox" || l.type === "multiselect")
          c[l.name] = u instanceof Array ? u : [u];
        else if (l.type === "radioInput" && typeof u == "string") {
          let g = {
            optionValue: "",
            value: ""
          };
          try {
            g = JSON.parse(u);
          } catch {
          }
          const f = l.optionsInputs, h = f == null ? void 0 : f[g.value];
          h && h.type === "phone" && (g.optionValue = TK(g.optionValue)), c[l.name] = g;
        } else
          l.type === "phone" ? c[l.name] = TK(u) : c[l.name] = u;
      }), {
        ...s,
        ...c
      }) : s;
    },
    e.superRefine(async (a, s) => {
      var _, p, g;
      if (!t)
        return;
      const c = t.find((f) => f.name === "attendeePhoneNumber"), l = c == null ? void 0 : c.hidden, u = t.find((f) => f.name === "email");
      !!(u != null && u.hidden) && !l && (a.email = "");
      for (const f of t) {
        const h = a[f.name], $ = oe.string(), v = n ? oe.string() : oe.string().refine(Vlc), b = n ? oe.string() : oe.string().refine(async (T) => i0(T)), y = (T) => `{${f.name}}${T}`, w = f.views, N = o === "ALL_VIEWS" ? !0 : w ? w.find((T) => T.id === o) : !0;
        let M = f.hidden;
        const q = ((_ = f.options) == null ? void 0 : _.length) ?? 0;
        f.hideWhenJustOneOption && (M = M || q <= 1);
        let L = !1;
        if (!M && N && (L = r || !!f.required), (n || !L) && h === void 0)
          continue;
        if (L && !n && !h) {
          s.addIssue({ code: oe.ZodIssueCode.custom, message: y("error_required_field") });
          return;
        }
        if (f.type === "email") {
          if (!f.hidden && (r || f.required)) {
            v.safeParse(h).success || s.addIssue({
              code: oe.ZodIssueCode.custom,
              message: y("email_validation_error")
            });
            const T = h;
            (((p = f.excludeEmails) == null ? void 0 : p.split(",").map((x) => x.trim())) || []).find((x) => T.includes(x)) && s.addIssue({
              code: oe.ZodIssueCode.custom,
              message: y("exclude_emails_match_found_error_message")
            });
            const S = ((g = f.requireEmails) == null ? void 0 : g.split(",").map((x) => x.trim()).filter(Boolean)) || [], E = S.find((x) => T.includes(x));
            S.length > 0 && !E && s.addIssue({
              code: oe.ZodIssueCode.custom,
              message: y("require_emails_no_match_found_error_message")
            });
          }
          continue;
        }
        const R = CK[f.type];
        if (R) {
          R.superRefine({
            response: h,
            ctx: s,
            m: y,
            field: f,
            isPartialSchema: n
          });
          continue;
        }
        if (f.type === "multiemail") {
          const T = v.array().safeParse(h);
          if (L && (!h || h.length === 0)) {
            s.addIssue({ code: oe.ZodIssueCode.custom, message: y("error_required_field") });
            continue;
          }
          if (!T.success) {
            if (f.name === "guests" && h.every((A) => A === "")) {
              a[f.name] = [];
              continue;
            }
            s.addIssue({
              code: oe.ZodIssueCode.custom,
              message: y("email_validation_error")
            });
            continue;
          }
          const D = T.data;
          D.sort().some((A, S) => {
            if (A === D[S + 1])
              return s.addIssue({ code: oe.ZodIssueCode.custom, message: y("duplicate_email") }), !0;
          });
          continue;
        }
        if (f.type === "multiselect") {
          if (L && (!h || h.length === 0)) {
            s.addIssue({ code: oe.ZodIssueCode.custom, message: y("error_required_field") });
            continue;
          }
          $.array().safeParse(h).success || s.addIssue({ code: oe.ZodIssueCode.custom, message: y("Invalid array of strings") });
          continue;
        }
        if (f.type === "checkbox") {
          $.array().safeParse(h).success || s.addIssue({ code: oe.ZodIssueCode.custom, message: y("Invalid array of strings") });
          continue;
        }
        if (f.type === "phone") {
          const T = L || h && h.trim() !== "";
          !f.hidden && T && ((await b.safeParseAsync(h)).success || s.addIssue({ code: oe.ZodIssueCode.custom, message: y("invalid_number") }));
          continue;
        }
        if (f.type === "boolean") {
          oe.boolean().safeParse(h).success || s.addIssue({ code: oe.ZodIssueCode.custom, message: y("Invalid Boolean") });
          continue;
        }
        if (f.type === "radioInput") {
          if (f.optionsInputs) {
            const T = h == null ? void 0 : h.optionValue, D = f.optionsInputs[h == null ? void 0 : h.value], A = D == null ? void 0 : D.type;
            if (
              // Either the field is required or there is a radio selected, we need to check if the optionInput is required or not.
              (L || h != null && h.value) && r || D != null && D.required && !T
            ) {
              s.addIssue({ code: oe.ZodIssueCode.custom, message: y("error_required_field") });
              return;
            }
            T && A === "phone" && ((await b.safeParseAsync(T)).success || s.addIssue({ code: oe.ZodIssueCode.custom, message: y("invalid_number") }));
          }
          continue;
        }
        if (["address", "text", "select", "number", "radio", "textarea"].includes(f.type)) {
          $.safeParse(h).success || s.addIssue({ code: oe.ZodIssueCode.custom, message: y("Invalid string") });
          continue;
        }
        s.addIssue({
          code: oe.ZodIssueCode.custom,
          message: `Can't parse unknown booking field type: ${f.type}`
        });
      }
    })
  );
  return n ? i.catch(function(a) {
    return console.error("Failed to preprocess query params, prefilling will be skipped", a == null ? void 0 : a.error), {};
  }) : i;
}
const kol = (e, t, n, o, r, i) => {
  const a = e.getValues(), [s, c] = it(!1), l = Fu((u) => u.rescheduleUid);
  return yt(() => {
    t === "selecting_time" && (!n && !o) && (async () => {
      if (!r || i && i.length > 1) {
        c(!1);
        return;
      }
      try {
        const p = await wol({
          bookingFields: r,
          view: l ? "reschedule" : "booking"
        }).safeParseAsync(a.responses);
        c(p.success);
      } catch {
        c(!1);
      }
    })();
  }, [a, r, l, t, o, n]), s;
}, Sol = kol, Eol = (e) => {
  if (typeof e > "u")
    return [];
  const t = [];
  return Object.keys(e).forEach((n) => {
    e[n].some((o) => !(o != null && o.away && !o.toUser) && e[n].length > 0) && t.push(n);
  }), t;
}, MA = (e) => vn(() => Eol(e), [e]), xol = () => {
  if (typeof window > "u")
    return !1;
  const e = navigator.userAgent.toLowerCase();
  return e.includes("safari") && !e.includes("chrome");
}, Col = (e) => {
  const n = e.getBoundingClientRect().top;
  _r == null || _r.fire("__scrollByDistance", {
    distance: n
  });
}, zge = (e, t) => {
  requestAnimationFrame(() => {
    if (e === 1) {
      t();
      return;
    }
    requestAnimationFrame(() => zge(e - 1, t));
  });
}, Tol = (e, t = !1) => {
  const n = e.getBoundingClientRect().top;
  if (e.scrollIntoView({ behavior: "smooth" }), !t)
    return;
  const o = xol();
  zge(2, () => {
    const r = e.getBoundingClientRect().top;
    o && !(n !== r) && Col(e);
  });
};
function Aol(e) {
  const { t } = kt(), n = e.orgSlug || e.teamSlug;
  return /* @__PURE__ */ m("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ m(
    e$,
    {
      avatar: /* @__PURE__ */ m(Dd, { alt: n ?? "", imageSrc: yA(e.logoUrl, n), size: "lg" }),
      headline: t("team_is_unpublished", {
        team: e.name,
        interpolation: {
          // This is needed because React automatically escapes special characters like apostrophes
          // for security (XSS prevention), but we want to display the actual apostrophe in the UI
          escapeValue: !1
        }
      }),
      description: t(`${e.orgSlug ? "org" : "team"}_is_unpublished_description`)
    }
  ) });
}
var Rge = {};
(function(e) {
  e.__esModule = !0;
  var t = Fe;
  function n(r) {
    for (var i = r.acceptedCharacters, a = r.length, s = r.value, c = r.onChange, l = o(s, a), u = t.useRef(Array.from({ length: a })), d = t.useRef(Array.from({ length: a })), _ = [], p = function(f) {
      var h = d.current[f] = d.current[f] || function(v) {
        u.current[f] = v || void 0;
      }, $ = l[f] === " " ? "" : l[f];
      _.push({
        ref: h,
        value: $,
        onClick: function(v) {
          var b = v.currentTarget;
          window.requestAnimationFrame(function() {
            b.setSelectionRange(0, 1);
          });
        },
        onFocus: function(v) {
          var b = v.currentTarget;
          b.setSelectionRange(0, 1);
        },
        onKeyDown: function(v) {
          switch (v.key) {
            case "Backspace":
              if (v.preventDefault(), $)
                c(l.substring(0, f) + " " + l.substring(f + 1));
              else if (f > 0) {
                c(l.substring(0, f - 1) + " " + l.substring(f));
                var b = u.current[f - 1];
                b && b.focus();
              }
              break;
            case "ArrowUp":
            case "ArrowLeft":
              if (v.preventDefault(), f > 0) {
                var y = u.current[f - 1];
                y && (y.focus(), window.requestAnimationFrame(function() {
                  y.setSelectionRange(0, 1);
                }));
              }
              break;
            case "ArrowDown":
            case "ArrowRight":
              if (v.preventDefault(), f + 1 < a) {
                var w = u.current[f + 1];
                w && (w.focus(), window.requestAnimationFrame(function() {
                  w.setSelectionRange(0, 1);
                }));
              }
              break;
            default:
              if (v.key.length === 1 && !(v.metaKey || v.altKey || v.ctrlKey) && (v.preventDefault(), i.test(v.key)))
                if (c(l.substring(0, f) + v.key + l.substring(f + 1)), f + 1 < a) {
                  var N = u.current[f + 1];
                  N && (N.focus(), window.requestAnimationFrame(function() {
                    N.setSelectionRange(0, 1);
                  }));
                } else {
                  var M = v.currentTarget;
                  window.requestAnimationFrame(function() {
                    M.setSelectionRange(0, 1);
                  });
                }
          }
        },
        onChange: function(v) {
          var b = v.target.value.split("").filter(function(w) {
            return i.test(w);
          }).join("");
          if (c((l.substring(0, f) + b + l.substring(f + b.length)).substr(0, a)), f < a - 1) {
            var y = u.current[f + b.length < a ? f + b.length : a - 1];
            y && (y.focus(), window.requestAnimationFrame(function() {
              y.setSelectionRange(0, 1);
            }));
          }
        }
      });
    }, g = 0; g < a; g++)
      p(g);
    return _;
  }
  e.default = n;
  function o(r, i) {
    for (; r.length < i; )
      r += " ";
    return r.substr(0, i);
  }
})(Rge);
const Iol = /* @__PURE__ */ Mi(Rge), Pge = ({
  isOpenDialog: e,
  setIsOpenDialog: t,
  email: n,
  isUserSessionRequiredToVerify: o = !0,
  verifyCodeWithSessionNotRequired: r,
  verifyCodeWithSessionRequired: i,
  resetErrors: a,
  setIsPending: s,
  isPending: c,
  error: l
}) => {
  const { t: u } = kt(), [d, _] = it(""), [p, g] = it(!1), f = _n((b) => b.setVerificationCode), h = Iol({
    acceptedCharacters: /^[0-9]$/,
    length: 6,
    value: d,
    onChange: Yt((b) => {
      a(), _(b);
    }, [])
  }), $ = Yt(() => {
    a(), s(!0), o ? i(d, n) : r(d, n), f(d), g(!0);
  }, [
    a,
    s,
    o,
    i,
    d,
    n,
    r
  ]);
  yt(() => {
    p || l || c || !/^\d{6}$/.test(d.trim()) || $();
  }, [l, c, d, $, p]), yt(() => _(""), [e]);
  const v = "h-12 w-12 !text-xl text-center";
  return /* @__PURE__ */ m(
    Ss,
    {
      open: e,
      onOpenChange: () => {
        _(""), a();
      },
      children: /* @__PURE__ */ m(Ya, { className: "sm:max-w-md", children: /* @__PURE__ */ m("div", { className: "flex flex-row", children: /* @__PURE__ */ de("div", { className: "w-full", children: [
        /* @__PURE__ */ m(Sy, { title: u("verify_your_email"), subtitle: u("enter_digit_code", { email: n }) }),
        /* @__PURE__ */ m(Ko, { htmlFor: "code", children: u("code") }),
        /* @__PURE__ */ de("div", { className: "flex flex-row justify-between", children: [
          /* @__PURE__ */ m(
            Iu,
            {
              className: v,
              name: "2fa1",
              inputMode: "decimal",
              ...h[0],
              autoFocus: !0,
              autoComplete: "one-time-code"
            }
          ),
          /* @__PURE__ */ m(Iu, { className: v, name: "2fa2", inputMode: "decimal", ...h[1] }),
          /* @__PURE__ */ m(Iu, { className: v, name: "2fa3", inputMode: "decimal", ...h[2] }),
          /* @__PURE__ */ m(Iu, { className: v, name: "2fa4", inputMode: "decimal", ...h[3] }),
          /* @__PURE__ */ m(Iu, { className: v, name: "2fa5", inputMode: "decimal", ...h[4] }),
          /* @__PURE__ */ m(Iu, { className: v, name: "2fa6", inputMode: "decimal", ...h[5] })
        ] }),
        l && /* @__PURE__ */ de("div", { className: "mt-2 flex items-center gap-x-2 text-sm text-red-700", children: [
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(qt, { name: "info", className: "h-3 w-3" }) }),
          /* @__PURE__ */ m("p", { children: l })
        ] }),
        /* @__PURE__ */ de(Wu, { noSticky: !0, children: [
          /* @__PURE__ */ m(Gs, { onClick: () => t(!1) }),
          /* @__PURE__ */ m(Jt, { type: "submit", onClick: $, loading: c, children: u("submit") })
        ] })
      ] }) }) })
    }
  );
}, Fi = oe.object({
  enabled: oe.boolean().optional(),
  credentialId: oe.number().optional(),
  appCategories: oe.array(oe.string()).optional()
});
oe.object({});
const Ool = oe.object({
  label: oe.string(),
  value: oe.string()
});
oe.array(Ool);
const AK = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], Nol = [
  AK[0].value,
  ...AK.slice(1).map((e) => e.value)
];
oe.enum(Nol);
const zol = Fi.merge(
  oe.object({
    price: oe.number(),
    currency: oe.string(),
    paymentOption: oe.string().optional(),
    enabled: oe.boolean().optional(),
    credentialId: oe.number().optional()
  })
);
oe.object({
  client_id: oe.string(),
  client_secret: oe.string()
});
const Rol = Fi.merge(oe.object({}));
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1),
  user_agent: oe.string().min(1)
});
const Pol = oe.object({
  label: oe.string(),
  value: oe.string()
});
oe.array(Pol);
const IK = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], Dol = [
  IK[0].value,
  ...IK.slice(1).map((e) => e.value)
];
oe.enum(Dol);
const Lol = Fi.merge(
  oe.object({
    price: oe.number(),
    currency: oe.string(),
    paymentOption: oe.string().optional(),
    enabled: oe.boolean().optional(),
    credentialId: oe.number().optional()
  })
);
oe.object({});
const Mol = Fi;
oe.object({
  client_id: oe.string(),
  client_secret: oe.string()
});
oe.object({
  api_key: oe.string().min(1),
  scale_plan: oe.string().default("false")
});
const Fol = oe.object({});
oe.object({
  id: oe.string()
});
oe.object({
  id: oe.string(),
  preset: oe.string(),
  status: oe.string(),
  transcription: oe.array(
    oe.object({
      format: oe.string(),
      link: oe.string().url()
    })
  )
});
oe.object({
  redirect_uris: oe.string(),
  client_id: oe.string(),
  client_secret: oe.string()
});
const qol = oe.object({}), jol = Fi.merge(
  oe.object({
    trackingId: oe.string().default("").optional()
  })
);
oe.object({});
const Vol = oe.object({});
oe.object({
  app_id: oe.string().min(1),
  app_secret: oe.string().min(1),
  open_verfication_token: oe.string().min(1)
});
const Bol = Fi.merge(
  oe.object({
    trackingId: oe.string().default("").optional()
  })
);
oe.object({});
const Uol = Fi.merge(
  oe.object({
    thankYouPage: oe.string().optional()
  })
);
oe.object({
  app_key: oe.string().min(1)
});
const Gol = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1),
  redirect_uris: oe.union([
    oe.string().url().array(),
    oe.string().url().transform((e) => [e])
  ])
});
const Wol = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1),
  redirect_uris: oe.union([
    oe.string().url().array(),
    oe.string().url().transform((e) => [e])
  ])
});
const Hol = Fi.merge(
  oe.object({
    trackingId: oe.string().transform((e) => {
      let t = e.trim();
      return t = t.startsWith("GTM-") ? t : `GTM-${t}`, t;
    })
  })
);
oe.object({});
const OK = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], Yol = [
  OK[0].value,
  ...OK.slice(1).map((e) => e.value)
];
oe.enum(Yol);
const Kol = Fi.merge(
  oe.object({
    price: oe.number(),
    currency: oe.string(),
    paymentOption: oe.string().optional(),
    enabled: oe.boolean().optional()
  })
);
oe.object({});
const Zol = Fi;
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const Xol = Fi.merge(
  oe.object({
    SITE_ID: oe.string().optional(),
    SCRIPT_URL: oe.string().optional()
  })
);
oe.object({});
const Jol = oe.object({});
oe.object({
  client_id: oe.string(),
  client_secret: oe.string()
});
const Qol = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
oe.object({
  jitsiHost: oe.string().optional(),
  jitsiPathPattern: oe.string().optional()
});
const erl = oe.object({}), trl = oe.object({});
oe.object({
  app_id: oe.string().min(1),
  app_secret: oe.string().min(1),
  open_verfication_token: oe.string().min(1)
});
const nrl = oe.object({});
oe.object({
  invite_link: oe.string().min(1)
});
const orl = Fi.merge(
  oe.object({
    MATOMO_URL: oe.string().optional(),
    SITE_ID: oe.string().optional()
  })
);
oe.object({});
const rrl = Fi.merge(
  oe.object({
    trackingId: oe.string().default("").optional()
  })
);
oe.object({});
const irl = oe.object({
  label: oe.string(),
  value: oe.string()
});
oe.array(irl);
const NK = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], arl = [
  NK[0].value,
  ...NK.slice(1).map((e) => e.value)
];
oe.enum(arl);
const srl = Fi.merge(
  oe.object({
    price: oe.number(),
    currency: oe.string(),
    paymentOption: oe.string().optional(),
    enabled: oe.boolean().optional()
  })
);
oe.object({});
oe.object({
  nextcloudTalkHost: oe.string(),
  nextcloudTalkPattern: oe.string().optional(),
  nextcloudTalkClientId: oe.string(),
  nextcloudTalkClientSecret: oe.string()
});
const crl = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const lrl = oe.object({
  client_id: oe.string(),
  client_secret: oe.string()
});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const url = oe.object({
  client_id: oe.string(),
  client_secret: oe.string()
}), drl = oe.object({
  label: oe.string(),
  value: oe.string()
});
oe.array(drl);
const zK = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
  // @TODO: not required right now
  // {
  //   label: "hold_option",
  //   value: "HOLD",
  // },
], _rl = [
  zK[0].value,
  ...zK.slice(1).map((e) => e.value)
];
oe.enum(_rl);
const prl = Fi.merge(
  oe.object({
    price: oe.number(),
    currency: oe.string(),
    paymentOption: oe.string().optional(),
    enabled: oe.boolean().optional()
  })
);
oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const mrl = Fi, frl = Fi.merge(
  oe.object({
    PLAUSIBLE_URL: oe.string().optional().default("https://plausible.io/js/script.js").or(oe.undefined()),
    trackingId: oe.string().default("").optional()
  })
);
oe.object({});
const grl = Fi.merge(
  oe.object({
    TRACKING_ID: oe.string().optional(),
    API_HOST: oe.string().optional()
  })
);
oe.object({});
const hrl = Fi;
oe.object({});
var Ow = /* @__PURE__ */ ((e) => (e.CONTACT = "Contact", e.LEAD = "Lead", e.ACCOUNT = "Account", e.EVENT = "Event", e))(Ow || {}), yj = /* @__PURE__ */ ((e) => (e.EVERY_BOOKING = "every_booking", e.FIELD_EMPTY = "field_empty", e))(yj || {}), $j = /* @__PURE__ */ ((e) => (e.DATE = "date", e.TEXT = "string", e.PHONE = "phone", e.CUSTOM = "custom", e.PICKLIST = "picklist", e.CHECKBOX = "boolean", e.DATETIME = "datetime", e.TEXTAREA = "textarea", e))($j || {}), vrl = /* @__PURE__ */ ((e) => (e.BOOKING_START_DATE = "booking_start_date", e.BOOKING_CREATED_DATE = "booking_created_date", e.BOOKING_CANCEL_DATE = "booking_cancel_date", e))(vrl || {});
const R5 = oe.object({
  value: oe.union([oe.string(), oe.boolean()]),
  fieldType: oe.nativeEnum($j),
  whenToWrite: oe.nativeEnum(yj)
});
oe.object({
  field: oe.string(),
  fieldType: oe.nativeEnum($j),
  value: oe.union([oe.string(), oe.boolean()]),
  whenToWrite: oe.nativeEnum(yj)
});
const brl = oe.record(oe.string(), R5), yrl = oe.object({
  rrSkipToAccountLookupField: oe.boolean().optional(),
  rrSKipToAccountLookupFieldName: oe.string().optional()
}).optional();
oe.object({
  writeToRecordObject: brl.optional()
});
oe.any().refine((e) => typeof e == "boolean" || e === void 0).optional();
const $rl = Fi.extend({
  roundRobinLeadSkip: oe.boolean().optional(),
  roundRobinSkipCheckRecordOn: oe.nativeEnum(Ow).default(Ow.CONTACT).optional(),
  ifFreeEmailDomainSkipOwnerCheck: oe.boolean().optional(),
  roundRobinSkipFallbackToLeadOwner: oe.boolean().optional(),
  skipContactCreation: oe.boolean().optional(),
  createEventOn: oe.nativeEnum(Ow).default(Ow.CONTACT).optional(),
  createNewContactUnderAccount: oe.boolean().optional(),
  createLeadIfAccountNull: oe.boolean().optional(),
  onBookingWriteToEventObject: oe.boolean().optional(),
  onBookingWriteToEventObjectMap: oe.record(oe.any()).optional(),
  createEventOnLeadCheckForContact: oe.boolean().optional(),
  onBookingChangeRecordOwner: oe.boolean().optional(),
  onBookingChangeRecordOwnerName: oe.string().optional(),
  sendNoShowAttendeeData: oe.boolean().optional(),
  sendNoShowAttendeeDataField: oe.string().optional(),
  onBookingWriteToRecord: oe.boolean().optional(),
  onBookingWriteToRecordFields: oe.record(oe.string(), R5).optional(),
  ignoreGuests: oe.boolean().optional(),
  onCancelWriteToEventRecord: oe.boolean().optional(),
  onCancelWriteToEventRecordFields: oe.record(oe.string(), R5).optional()
});
oe.object({
  consumer_key: oe.string().min(1),
  consumer_secret: oe.string().min(1)
});
const wrl = {
  salesforce: yrl
}, wj = oe.object({
  id: oe.string(),
  label: oe.string(),
  identifier: oe.string().optional(),
  placeholder: oe.string().optional(),
  type: oe.string(),
  /**
   * @deprecated in favour of `options`
   */
  selectText: oe.string().optional(),
  required: oe.boolean().optional(),
  deleted: oe.boolean().optional(),
  options: oe.array(
    oe.object({
      label: oe.string(),
      // To keep backwards compatibility with the options generated from legacy selectText, we allow saving null as id
      // It helps in differentiating whether the routing logic should consider the option.label as value or option.id as value.
      // This is important for legacy routes which has option.label saved in conditions and it must keep matching with the value of the option
      id: oe.string().or(oe.null())
    })
  ).optional()
}), Dge = wj.extend({
  routerId: oe.string()
}), krl = oe.union([Dge, wj]);
oe.array(krl).optional();
const Lge = wj, Srl = Dge.extend({
  routerField: Lge,
  router: oe.object({
    name: oe.string(),
    description: oe.string(),
    id: oe.string()
  })
}), Erl = oe.union([Lge, Srl]);
oe.array(Erl).optional();
var Mge = /* @__PURE__ */ ((e) => (e.CustomPageMessage = "customPageMessage", e.ExternalRedirectUrl = "externalRedirectUrl", e.EventTypeRedirectUrl = "eventTypeRedirectUrl", e))(Mge || {});
const xrl = oe.nativeEnum(Mge), Crl = oe.object({
  skipContactOwner: oe.boolean().optional(),
  salesforce: wrl.salesforce
}).nullish(), Fge = oe.object({
  id: oe.string(),
  name: oe.string().optional(),
  attributeIdForWeights: oe.string().optional(),
  attributeRoutingConfig: Crl,
  // TODO: It should be renamed to formFieldsQueryValue but it would take some effort
  /**
   * RAQB query value for form fields
   * BRANDED to ensure we don't give it Attributes
   */
  queryValue: VE.brand(),
  /**
   * RAQB query value for attributes. It is only applicable for Team Events as it is used to find matching team members
   * BRANDED to ensure we don't give it Form Fields
   */
  attributesQueryValue: VE.optional(),
  /**
   * RAQB query value for fallback of `attributesQueryValue`
   * BRANDED to ensure we don't give it Form Fields, It needs Attributes
   */
  fallbackAttributesQueryValue: VE.optional(),
  /**
   * Whether the route is a fallback if no other routes match
   */
  isFallback: oe.boolean().optional(),
  action: oe.object({
    type: xrl,
    eventTypeId: oe.number().optional(),
    value: oe.string()
  })
}), Trl = Fge, qge = oe.object({
  // This is the id of the Form being used as router
  id: oe.string(),
  name: oe.string().optional(),
  isRouter: oe.literal(!0)
}), jge = oe.union([Fge, qge]), Arl = qge.extend({
  //TODO: Extend it from form
  name: oe.string(),
  description: oe.string().nullable(),
  routes: oe.array(oe.union([jge, oe.null()]))
});
oe.union([oe.array(jge), oe.null()]).optional();
const Irl = oe.union([Trl, Arl]);
oe.union([oe.array(Irl), oe.null()]).optional();
const Orl = oe.any();
oe.object({});
oe.record(
  oe.object({
    label: oe.string().optional(),
    value: oe.union([oe.string(), oe.number(), oe.array(oe.string())])
  })
);
oe.object({
  api_key: oe.string(),
  api_route: oe.string()
});
const Nrl = oe.object({});
var Vge = /* @__PURE__ */ ((e) => (e.NEVER = "never", e.ALWAYS = "always", e.DAYS = "days", e))(Vge || {});
process.env.NEXT_PUBLIC_STRIPE_PREMIUM_PLAN_PRICE_MONTHLY;
process.env.NEXT_PUBLIC_STRIPE_PREMIUM_PLAN_PRODUCT_ID;
process.env.NEXT_PUBLIC_STRIPE_TEAM_MONTHLY_PRICE_ID;
process.env.STRIPE_PHONE_NUMBER_MONTHLY_PRICE_ID;
const RK = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  },
  {
    label: "hold_option",
    value: "HOLD"
  }
], zrl = [
  RK[0].value,
  ...RK.slice(1).map((e) => e.value)
], Rrl = oe.enum(zrl), Prl = oe.enum(["minutes", "hours", "days"]), Drl = Fi.merge(
  oe.object({
    price: oe.number(),
    currency: oe.string(),
    paymentOption: Rrl.optional(),
    enabled: oe.boolean().optional(),
    refundPolicy: oe.nativeEnum(Vge).optional(),
    refundDaysCount: oe.number().optional(),
    refundCountCalendarDays: oe.boolean().optional(),
    autoChargeNoShowFeeIfCancelled: oe.boolean().optional(),
    autoChargeNoShowFeeTimeValue: oe.number().optional(),
    autoChargeNoShowFeeTimeUnit: Prl.optional()
  })
);
oe.object({
  client_id: oe.string().startsWith("ca_").min(1),
  client_secret: oe.string().startsWith("sk_").min(1),
  public_key: oe.string().startsWith("pk_").min(1),
  webhook_secret: oe.string().startsWith("whsec_").min(1)
});
const Lrl = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1),
  base_url: oe.string().min(1)
});
const Mrl = Fi.merge(
  oe.object({
    trackingId: oe.string()
  })
);
oe.object({});
const Frl = Fi.merge(
  oe.object({
    isSunrise: oe.boolean()
  })
);
oe.object({});
const qrl = Fi.merge(
  oe.object({
    SITE_ID: oe.string().optional()
  })
);
oe.object({});
const jrl = Fi.merge(
  oe.object({
    SITE_ID: oe.string().optional(),
    SCRIPT_URL: oe.string().optional()
  })
);
oe.object({});
const Vrl = oe.object({});
oe.object({
  mode: oe.string().min(1),
  region: oe.string().min(1),
  api_key: oe.string().min(1),
  webhook_secret: oe.string().min(1)
});
const Brl = oe.object({});
oe.object({
  client_id: oe.string().min(64),
  client_secret: oe.string().min(64)
});
const Url = Fi.merge(
  oe.object({
    isSunrise: oe.boolean()
  })
);
oe.object({});
const Grl = oe.object({});
oe.object({
  invite_link: oe.string().min(1)
});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const Wrl = Fi, Hrl = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const Yrl = Fi, Krl = oe.object({});
oe.object({
  client_id: oe.string().min(1),
  client_secret: oe.string().min(1)
});
const Zrl = {
  alby: zol,
  basecamp3: Rol,
  btcpayserver: Lol,
  closecom: Mol,
  dailyvideo: Fol,
  dub: qol,
  fathom: jol,
  feishucalendar: Vol,
  ga4: Bol,
  giphy: Uol,
  googlecalendar: Gol,
  googlevideo: Wol,
  gtm: Hol,
  hitpay: Kol,
  hubspot: Zol,
  insihts: Xol,
  intercom: Jol,
  jelly: Qol,
  jitsivideo: erl,
  larkcalendar: trl,
  make: nrl,
  matomo: orl,
  metapixel: rrl,
  "mock-payment-app": srl,
  nextcloudtalk: crl,
  office365calendar: lrl,
  office365video: url,
  paypal: prl,
  "pipedrive-crm": mrl,
  plausible: frl,
  posthog: grl,
  qr_code: hrl,
  "routing-forms": Orl,
  salesforce: $rl,
  shimmervideo: Nrl,
  stripe: Drl,
  tandemvideo: Lrl,
  "booking-pages-tag": Mrl,
  "event-type-app-card": Frl,
  twipla: qrl,
  umami: jrl,
  vital: Vrl,
  webex: Brl,
  wordpress: Url,
  zapier: Grl,
  "zoho-bigin": Wrl,
  zohocalendar: Hrl,
  zohocrm: Yrl,
  zoomvideo: Krl
}, Xrl = oe.object(Zrl).partial(), Jrl = Xrl.optional(), kj = nce.unwrap().merge(
  oe.object({
    apps: Jrl
  })
).nullable();
function Lg(e, t) {
  var a;
  const n = {
    ...e,
    metadata: kj.parse(e.metadata)
  }, o = (a = n.metadata) == null ? void 0 : a.apps;
  if (!o)
    return { enabled: !1, price: 0, currency: "usd", appId: null };
  const r = Object.keys(o).filter(
    (s) => {
      var c, l;
      return ((c = o[s]) == null ? void 0 : c.price) && ((l = o[s]) == null ? void 0 : l.enabled);
    }
  );
  let i = null;
  for (const s of r) {
    const c = yge(n, s, t);
    c && i === null && (i = {
      ...c,
      appId: s
    });
  }
  return i || {
    enabled: !1,
    price: 0,
    currency: "usd",
    appId: null,
    paymentOption: "ON_BOOKING",
    credentialId: void 0,
    refundPolicy: void 0,
    refundDaysCount: void 0,
    refundCountCalendarDays: void 0
  };
}
function Qrl(e) {
  const { className: t, currency: n } = e;
  return n !== "BTC" ? /* @__PURE__ */ m(qt, { name: "credit-card", className: t }) : /* @__PURE__ */ m(mTe, { className: t });
}
var I_ = /* @__PURE__ */ ((e) => (e[e.DURATION = 0] = "DURATION", e[e.LOCATION = 1] = "LOCATION", e[e.REQUIRES_CONFIRMATION = 2] = "REQUIRES_CONFIRMATION", e[e.OCCURENCES = 3] = "OCCURENCES", e[e.PRICE = 4] = "PRICE", e))(I_ || {});
const eil = "integrations:google:meet", til = "integrations:daily", nil = eil;
var Bge = /* @__PURE__ */ ((e) => (e.AttendeeInPerson = "attendeeInPerson", e.InPerson = "inPerson", e.Phone = "phone", e.UserPhone = "userPhone", e.Link = "link", e.Conferencing = "conferencing", e.SomewhereElse = "somewhereElse", e))(Bge || {});
const oil = [
  {
    default: !0,
    type: "attendeeInPerson",
    label: "in_person_attendee_address",
    variable: "address",
    organizerInputType: null,
    messageForOrganizer: "Cal will ask your invitee to enter an address before scheduling.",
    attendeeInputType: "attendeeAddress",
    attendeeInputPlaceholder: "enter_address",
    defaultValueVariable: "attendeeAddress",
    iconUrl: "/map-pin-dark.svg",
    category: "in person",
    linkType: "static"
  },
  {
    default: !0,
    type: "somewhereElse",
    label: "custom_attendee_location",
    variable: "address",
    organizerInputType: null,
    messageForOrganizer: "Cal will ask your invitee to enter any location before scheduling.",
    attendeeInputType: "somewhereElse",
    attendeeInputPlaceholder: "any_location",
    defaultValueVariable: "somewhereElse",
    iconUrl: "/message-pin.svg",
    category: "other",
    linkType: "static"
  },
  {
    default: !0,
    type: "inPerson",
    label: "in_person",
    organizerInputType: "text",
    messageForOrganizer: "Provide an Address or Place",
    // HACK:
    variable: "locationAddress",
    defaultValueVariable: "address",
    iconUrl: "/map-pin-dark.svg",
    category: "in person",
    linkType: "static"
  },
  {
    default: !0,
    type: "conferencing",
    iconUrl: "/link.svg",
    organizerInputType: null,
    label: "organizer_default_conferencing_app",
    variable: "hostDefault",
    defaultValueVariable: "hostDefault",
    category: "conferencing",
    messageForOrganizer: "",
    linkType: "static",
    supportsCustomLabel: !0
  },
  {
    default: !0,
    type: "link",
    label: "link_meeting",
    organizerInputType: "text",
    organizerInputLabel: "meeting_link",
    variable: "locationLink",
    messageForOrganizer: "Provide a Meeting Link",
    defaultValueVariable: "link",
    iconUrl: "/link.svg",
    category: "other",
    linkType: "static",
    supportsCustomLabel: !0
  },
  {
    default: !0,
    type: "phone",
    label: "attendee_phone_number",
    variable: "phone",
    organizerInputType: null,
    attendeeInputType: "phone",
    attendeeInputPlaceholder: "enter_phone_number",
    defaultValueVariable: "phone",
    messageForOrganizer: "Cal will ask your invitee to enter a phone number before scheduling.",
    // This isn't inputType phone because organizer doesn't need to provide it.
    // inputType: "phone"
    iconUrl: "/phone.svg",
    category: "phone",
    linkType: "static"
  },
  {
    default: !0,
    type: "userPhone",
    label: "organizer_phone_number",
    messageForOrganizer: "Provide your phone number",
    organizerInputType: "phone",
    organizerInputLabel: "phone_number",
    variable: "locationPhoneNumber",
    defaultValueVariable: "hostPhoneNumber",
    iconUrl: "/phone.svg",
    category: "phone",
    linkType: "static"
  }
], ril = [
  "in_person_attendee_address",
  "in_person",
  "attendee_phone_number",
  "link_meeting",
  "organizer_phone_number",
  "organizer_default_conferencing_app",
  "somewhere_else",
  "custom_attendee_location"
], Uge = {}, Sj = [];
var _re, pre;
for (const [e, t] of Object.entries(_j)) {
  const n = (_re = t.appData) == null ? void 0 : _re.location;
  if (n) {
    for (const [r, i] of Object.entries(n))
      typeof i == "string" && (n[r] = i.replace(/{SLUG}/g, t.slug).replace(/{TITLE}/g, t.name));
    const o = {
      ...n,
      messageForOrganizer: n.messageForOrganizer || `Set ${n.label} link`,
      iconUrl: t.logo,
      // For All event location apps, locationLink is where we store the input
      // TODO: locationLink and link seems redundant. We can modify the code to keep just one of them.
      variable: n.variable || "locationLink",
      defaultValueVariable: n.defaultValueVariable || "link"
    };
    o.linkType === "static" ? (o.organizerInputType = n.organizerInputType || "text", (pre = o.organizerInputPlaceholder) != null && pre.match(/https?:\/\//) && (o.organizerInputPlaceholder = ` ${o.organizerInputPlaceholder}`)) : o.organizerInputType = null, Uge[e] = o.type, Sj.push({
      ...o
    });
  }
}
const Ej = [...oil, ...Sj], iil = (e) => Sj.find((t) => t.type === e), Xl = (e) => Ej.find((t) => t.type === e), ail = (e) => e ? Ej.find((t) => {
  if (!(t.default || t.linkType == "dynamic" || !t.urlRegExp))
    return new RegExp(t.urlRegExp).test(e);
}) : null, PK = (e) => Xl(e) || ail(e);
({ ...Bge, ...Uge });
const sil = (e, t) => {
  if (!e)
    return t("no_location");
  const n = Xl(e), o = n == null ? void 0 : n.default;
  return n ? o ? t(n.label) : `${n.label}` : e || "";
}, Gge = (e) => {
  const t = Xl(e.type);
  if (!t)
    return null;
  const n = t.defaultValueVariable;
  return n ? e[n] || t.label : (console.error(`defaultValueVariable not set for ${e.type}`), "");
};
function cil(e, t, n) {
  const o = Xl(e);
  let r = e;
  if (o && !o.default && o.linkType === "dynamic") {
    const i = n === WO.ACCEPTED;
    n === WO.CANCELLED || n === WO.REJECTED ? r == t("web_conference") : i ? r = `${sil(e, t)}: ${t(
      "meeting_url_in_confirmation_email"
    )}` : r = t("web_conferencing_details_to_follow");
  }
  return r;
}
const xj = (e, t, n) => {
  if (!t)
    return null;
  const o = oe.string().default("").parse(Gge(e));
  return e.type.startsWith("integrations:") ? t.label : ril.includes(o) ? n(o) : o;
}, lil = () => {
  const e = [], t = Ej.filter((n) => !!n.organizerInputType);
  return t == null || t.forEach((n) => e.push(n.type)), e;
}, uil = (e) => oe.array(
  oe.object({
    type: oe.string(),
    address: oe.string().optional(),
    link: oe.string().url().optional(),
    phone: oe.string().refine((t) => i0(t)).optional(),
    hostPhoneNumber: oe.string().refine((t) => i0(t)).optional(),
    displayLocationPublicly: oe.boolean().optional(),
    credentialId: oe.number().optional(),
    teamName: oe.string().optional()
  }).passthrough().superRefine((t, n) => {
    if (t != null && t.link) {
      const o = t.link, r = Xl(t.type);
      if (r && !r.default && r.linkType === "static" && r.urlRegExp) {
        if (!oe.string().regex(new RegExp(r.urlRegExp)).safeParse(o).success) {
          const s = r.organizerInputPlaceholder;
          n.addIssue({
            code: oe.ZodIssueCode.custom,
            path: [(r == null ? void 0 : r.defaultValueVariable) ?? "link"],
            message: e("invalid_url_error_message", {
              label: r.label,
              sampleUrl: s ?? "https://cal.com"
            })
          });
        }
        return;
      }
      oe.string().url().optional().safeParse(o).success || n.addIssue({
        code: oe.ZodIssueCode.custom,
        path: [(r == null ? void 0 : r.defaultValueVariable) ?? "link"],
        message: "Invalid URL"
      });
    }
  })
).optional();
function Wge(e, t) {
  return e != null && e.includes("-dark") || !(e != null && e.startsWith("/app-store")) ? t ? "invert dark:invert-0" : "dark:invert" : "";
}
const dil = (e) => !!e;
function Hge({
  eventLocationType: e,
  isTooltip: t
}) {
  const n = Kr();
  return /* @__PURE__ */ m(
    "img",
    {
      src: `${n ? "https://app.cal.com" : ""}${e.iconUrl}`,
      className: xe(Wge(e == null ? void 0 : e.iconUrl, t), "me-[10px] h-4 w-4"),
      alt: `${e.label} icon`
    }
  );
}
function _il({ locations: e }) {
  const { t } = kt();
  return /* @__PURE__ */ de("div", { className: "my-2 me-2 flex w-full flex-col space-y-3 break-words", children: [
    /* @__PURE__ */ m("p", { children: t("select_on_next_step") }),
    e.map(
      (n, o) => {
        const r = Xl(n.type);
        if (!r)
          return null;
        const i = n.customLabel || xj(n, r, t);
        return /* @__PURE__ */ de("div", { className: "font-sm flex flex-row items-center", children: [
          /* @__PURE__ */ m(Hge, { eventLocationType: r, isTooltip: !0 }),
          /* @__PURE__ */ m("p", { className: "line-clamp-1", children: i })
        ] }, `${n.type}-${o}`);
      }
    )
  ] });
}
function pil({ locations: e }) {
  const { t } = kt(), n = Kr(), r = e.map(
    (i, a) => {
      const s = Xl(i.type);
      if (!s)
        return null;
      const c = (i == null ? void 0 : i.customLabel) || xj(i, s, t);
      return /* @__PURE__ */ de("div", { className: "flex flex-row items-center text-sm font-medium", children: [
        s.iconUrl === "/link.svg" ? /* @__PURE__ */ m(qt, { name: "link", className: "text-default h-4 w-4 ltr:mr-[10px] rtl:ml-[10px]" }) : /* @__PURE__ */ m(Hge, { eventLocationType: s, isTooltip: !1 }),
        /* @__PURE__ */ m(Sr, { content: c, children: /* @__PURE__ */ m("p", { className: "line-clamp-1", children: c }) })
      ] }, `${i.type}-${a}`);
    }
  ).filter(dil);
  return r.length > 1 ? /* @__PURE__ */ de("div", { className: "flex flex-row items-center text-sm font-medium", children: [
    n ? /* @__PURE__ */ m(qt, { name: "map-pin", className: xe("me-[10px] h-4 w-4 opacity-70 dark:invert") }) : /* @__PURE__ */ m(
      "img",
      {
        src: "/map-pin-dark.svg",
        className: xe("me-[10px] h-4 w-4 opacity-70 dark:invert"),
        alt: "map-pin"
      }
    ),
    /* @__PURE__ */ m(Sr, { content: /* @__PURE__ */ m(_il, { locations: e }), children: /* @__PURE__ */ m("p", { className: "line-clamp-1", children: t("location_options", {
      locationCount: r.length
    }) }) })
  ] }) : r.length === 1 ? /* @__PURE__ */ m("div", { className: "text-default mr-6 flex w-full flex-col space-y-4 break-words text-sm rtl:mr-2", children: r }) : null;
}
function Wz(e, t) {
  if (t) {
    window.open(e, "_blank");
    return;
  }
  window.location.href = e;
}
function mil(e, t) {
  const n = Nr.usePathname(), o = `${Wa}${n}`;
  return Hr({
    ...t,
    mutationFn: async (i) => {
      var h, $, v;
      let a;
      const s = i && i.teamId ? i.teamId : void 0, c = i && i.defaultInstall ? i.defaultInstall : void 0, l = t != null && t.returnTo ? t.returnTo : i && i.returnTo ? i.returnTo : void 0;
      if (i === "" ? a = e : a = i.type, a != null && a.endsWith("_other_calendar") && (a = a.split("_other_calendar")[0]), t != null && t.installGoogleVideo && a !== "google_calendar")
        throw new Error("Could not install Google Meet");
      const u = {
        onErrorReturnTo: o,
        fromApp: !0,
        ...s && { teamId: s },
        ...a === "google_calendar" && { installGoogleVideo: t == null ? void 0 : t.installGoogleVideo },
        ...l && { returnTo: l },
        ...c && { defaultInstall: c }
      }, d = JSON.stringify(u), _ = fil({
        stateStr: d,
        teamId: s,
        returnTo: l
      }), p = await fetch(`/api/integrations/${a}/add${_}`);
      if (!p.ok) {
        const b = await p.json();
        throw new Error(b.message || "Something went wrong");
      }
      const g = await p.json();
      return /https?:\/\//.test(g == null ? void 0 : g.url) && !((h = g == null ? void 0 : g.url) != null && h.startsWith(window.location.origin)) ? (Wz(g.url, g.newTab), { setupPending: !g.newTab, message: g.message }) : g.url ? (Wz(g.url, g.newTab), {
        setupPending: (($ = g == null ? void 0 : g.url) == null ? void 0 : $.endsWith("/setup")) || ((v = g == null ? void 0 : g.url) == null ? void 0 : v.includes("/apps/installation/event-types")),
        message: g.message
      }) : l ? (Wz(l, !1), { setupPending: !0, message: g.message }) : { setupPending: !1, message: g.message };
    }
  });
}
const fil = ({
  stateStr: e,
  teamId: t,
  returnTo: n
}) => {
  const o = new URL("https://example.com");
  return o.searchParams.append("state", e), t !== void 0 && o.searchParams.append("teamId", t.toString()), n && o.searchParams.append("returnTo", n), o.search;
};
function gil(e, t) {
  let n = t[e];
  if (n)
    return e;
  const o = e.substring(0, e.lastIndexOf("_"));
  if (n = t[o], n)
    return o;
  const r = e.substring(0, e.lastIndexOf("_")) + e.substring(e.lastIndexOf("_") + 1);
  if (n = t[r], n)
    return r;
  const i = e.replace(/_/g, "");
  return n = t[i], n ? i : e;
}
const DK = {
  exchange2013calendar: co(() => import("./InstallAppButton-jzgMgjiO.js")),
  exchange2016calendar: co(() => import("./InstallAppButton-wnOge6-d.js")),
  office365video: co(() => import("./InstallAppButton-kyiW9rge.js")),
  vital: co(() => import("./InstallAppButton-JXhBVaYJ.js"))
}, hil = {
  "general-app-settings": co(
    () => import("./AppSettingsInterface-hU-ZJWt8.js")
  ),
  weather_in_your_calendar: co(
    () => import("./AppSettingsInterface-_qb_QvFR.js")
  ),
  zapier: co(() => import("./AppSettingsInterface-4jU328CN.js"))
}, vil = {
  alby: co(() => import("./EventTypeAppCardInterface-D0Tk5N2s.js")),
  basecamp3: co(() => import("./EventTypeAppCardInterface-uKYQLG0k.js")),
  btcpayserver: co(() => import("./EventTypeAppCardInterface-XgrGXD91.js")),
  closecom: co(() => import("./EventTypeAppCardInterface-g13_N3l3.js")),
  fathom: co(() => import("./EventTypeAppCardInterface-FRAbji-6.js")),
  ga4: co(() => import("./EventTypeAppCardInterface-0t4a0XXB.js")),
  giphy: co(() => import("./EventTypeAppCardInterface-EE3Plo-p.js")),
  gtm: co(() => import("./EventTypeAppCardInterface-nn3b6GNv.js")),
  hitpay: co(() => import("./EventTypeAppCardInterface-0k8p3HBE.js")),
  hubspot: co(() => import("./EventTypeAppCardInterface-AwfBtypH.js")),
  insihts: co(() => import("./EventTypeAppCardInterface-PDKuhoIF.js")),
  matomo: co(() => import("./EventTypeAppCardInterface-8uQdGaBQ.js")),
  metapixel: co(() => import("./EventTypeAppCardInterface-5CFb_x5t.js")),
  "mock-payment-app": co(() => import("./EventTypeAppCardInterface-BvssguDR.js")),
  paypal: co(() => import("./EventTypeAppCardInterface-Pcm1KBZm.js")),
  "pipedrive-crm": co(() => import("./EventTypeAppCardInterface-OAwlWWPN.js")),
  plausible: co(() => import("./EventTypeAppCardInterface-1_VDsz_0.js")),
  posthog: co(() => import("./EventTypeAppCardInterface-tivPI7Ng.js")),
  qr_code: co(() => import("./EventTypeAppCardInterface-o5mBa0ZW.js")),
  salesforce: co(() => import("./EventTypeAppCardInterface-LsjRe5rc.js")),
  stripepayment: co(() => import("./EventTypeAppCardInterface--SqJ0-cs.js")),
  "booking-pages-tag": co(
    () => import("./EventTypeAppCardInterface-cYkIhiKV.js")
  ),
  "event-type-app-card": co(
    () => import("./EventTypeAppCardInterface-KvPM2bQj.js")
  ),
  twipla: co(() => import("./EventTypeAppCardInterface-pSNF92jK.js")),
  umami: co(() => import("./EventTypeAppCardInterface-RHB5OccZ.js")),
  "zoho-bigin": co(() => import("./EventTypeAppCardInterface-dpugsezy.js")),
  zohocrm: co(() => import("./EventTypeAppCardInterface-i_bbo2v-.js"))
};
co(() => import("./EventTypeAppSettingsInterface-qc1T0gom.js")), co(() => import("./EventTypeAppSettingsInterface-Fk84Ea7p.js")), co(() => import("./EventTypeAppSettingsInterface-EPNjGsgH.js")), co(() => import("./EventTypeAppSettingsInterface-bGkJ_lyk.js")), co(() => import("./EventTypeAppSettingsInterface-cexDdNNi.js")), co(() => import("./EventTypeAppSettingsInterface-jaf6DsiA.js")), co(() => import("./EventTypeAppSettingsInterface-GL5mv58q.js")), co(() => import("./EventTypeAppSettingsInterface-r7OCJduA.js")), co(() => import("./EventTypeAppSettingsInterface-BWO6zNgo.js")), co(() => import("./EventTypeAppSettingsInterface-Gw8L0HiJ.js")), co(() => import("./EventTypeAppSettingsInterface-5NV7Y9Dn.js")), co(() => import("./EventTypeAppSettingsInterface-zTt0CtoK.js")), co(() => import("./EventTypeAppSettingsInterface-N7rys0Kc.js"));
const bil = (e) => {
  var r;
  const t = mil(null, e.options), n = gil(e.type, DK), o = DK[n];
  return o ? /* @__PURE__ */ m(
    o,
    {
      render: e.render,
      onChanged: e.onChanged,
      disableInstall: e.disableInstall
    }
  ) : /* @__PURE__ */ m(nt, { children: e.render({
    useDefaultComponent: !0,
    disabled: e.disableInstall,
    onClick: () => {
      t.mutate({ type: e.type });
    },
    loading: (r = t.data) == null ? void 0 : r.setupPending
  }) });
}, Yge = (e) => /* @__PURE__ */ m("div", { className: e.wrapperClassName, children: /* @__PURE__ */ m(bil, { ...e }) });
function yil() {
  var r, i;
  const e = xt(null), [t, n] = it({
    left: !1,
    right: !1
  });
  return yt(() => {
    const a = e.current;
    if (a) {
      const s = a.scrollLeft <= 0, c = a.scrollWidth <= a.clientWidth + a.scrollLeft;
      n({
        left: !s,
        right: !c
      });
    }
  }, [(r = e.current) == null ? void 0 : r.scrollWidth, (i = e.current) == null ? void 0 : i.clientWidth]), { ref: e, calculateScroll: (a) => {
    const s = a.currentTarget, c = s.scrollWidth <= s.clientWidth + s.scrollLeft + 1;
    n({
      left: s.scrollLeft > 0,
      right: !c
    });
  }, leftVisible: t.left, rightVisible: t.right };
}
const P5 = (e, t) => {
  if (!e)
    return null;
  const n = Math.floor(e / 60);
  e %= 60;
  let o = "";
  e > 0 && (o = e === 1 ? t("minute_one_short", { count: 1 }) : t("multiple_duration_timeUnit_short", { count: e, unit: "minute" }));
  let r = "";
  return n > 0 && (r = n === 1 ? t("hour_one_short", { count: 1 }) : t("multiple_duration_timeUnit_short", { count: n, unit: "hour" })), r && o ? `${r} ${o}` : r || o;
}, $il = ({
  event: e
}) => {
  var f, h, $;
  const { t } = kt(), n = xt([]);
  Kr();
  const [o, r, i] = _n((v) => [
    v.selectedDuration,
    v.setSelectedDuration,
    v.state
  ]), { ref: a, calculateScroll: s, leftVisible: c, rightVisible: l } = yil(), u = () => {
    a.current && (a.current.scrollLeft -= 100);
  }, d = () => {
    a.current && (a.current.scrollLeft += 100);
  }, _ = "isDynamic" in e && e.isDynamic, p = tm();
  if (yt(() => {
    var v;
    !o && ((v = e.metadata) != null && v.multipleDuration || _) && r(e.length);
  }, [o, r, (f = e.metadata) == null ? void 0 : f.multipleDuration, e.length, _]), yt(() => {
    const v = setTimeout(() => {
      var b;
      p || o && n.current[o] && ((b = n.current[o]) == null || b.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      }));
    }, 100);
    return () => clearTimeout(v);
  }, [o, p]), !((h = e == null ? void 0 : e.metadata) != null && h.multipleDuration) && !_)
    return /* @__PURE__ */ m(nt, { children: P5(e.length, t) });
  const g = (($ = e == null ? void 0 : e.metadata) == null ? void 0 : $.multipleDuration) || [15, 30, 60, 90];
  return o ? /* @__PURE__ */ de("div", { className: "border-default relative mr-5 flex flex-row items-center justify-between rounded-md border", children: [
    c && /* @__PURE__ */ de("button", { onClick: u, className: "absolute bottom-0 left-0 flex", children: [
      /* @__PURE__ */ m("div", { className: "bg-default flex h-9 w-5 items-center justify-end rounded-md", children: /* @__PURE__ */ m(qt, { name: "chevron-left", className: "text-subtle h-4 w-4" }) }),
      /* @__PURE__ */ m("div", { className: "to-default flex h-9 w-5 bg-gradient-to-l from-transparent" })
    ] }),
    /* @__PURE__ */ m(
      "ul",
      {
        className: "bg-default no-scrollbar flex max-w-full items-center gap-0.5 overflow-x-auto rounded-md p-1",
        onScroll: (v) => s(v),
        ref: a,
        children: g.filter((v) => i !== "booking" || v === o).map((v, b) => /* @__PURE__ */ m(
          "li",
          {
            "data-testId": `multiple-choice-${v}mins`,
            "data-active": o === v ? "true" : "false",
            onClick: () => r(v),
            ref: (y) => n.current[v] = y,
            className: xe(
              o === v ? "bg-emphasis" : "hover:text-emphasis",
              "text-default cursor-pointer rounded-[4px] px-3 py-1.5 text-sm leading-tight transition"
            ),
            children: /* @__PURE__ */ m("div", { className: "w-max", children: P5(v, t) })
          },
          b
        ))
      }
    ),
    l && /* @__PURE__ */ de("button", { onClick: d, className: "absolute bottom-0 right-0 flex", children: [
      /* @__PURE__ */ m("div", { className: "to-default flex h-9 w-5 bg-gradient-to-r from-transparent" }),
      /* @__PURE__ */ m("div", { className: "bg-default flex h-9 w-5 items-center justify-end rounded-md", children: /* @__PURE__ */ m(qt, { name: "chevron-right", className: "text-subtle h-4 w-4" }) })
    ] })
  ] }) : null;
};
var D5 = [
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU"
], pl = (
  /** @class */
  function() {
    function e(t, n) {
      if (n === 0)
        throw new Error("Can't create weekday with n == 0");
      this.weekday = t, this.n = n;
    }
    return e.fromStr = function(t) {
      return new e(D5.indexOf(t));
    }, e.prototype.nth = function(t) {
      return this.n === t ? this : new e(this.weekday, t);
    }, e.prototype.equals = function(t) {
      return this.weekday === t.weekday && this.n === t.n;
    }, e.prototype.toString = function() {
      var t = D5[this.weekday];
      return this.n && (t = (this.n > 0 ? "+" : "") + String(this.n) + t), t;
    }, e.prototype.getJsWeekday = function() {
      return this.weekday === 6 ? 0 : this.weekday + 1;
    }, e;
  }()
), ts = function(e) {
  return e != null;
}, Ep = function(e) {
  return typeof e == "number";
}, LK = function(e) {
  return typeof e == "string" && D5.includes(e);
}, Ru = Array.isArray, nm = function(e, t) {
  t === void 0 && (t = e), arguments.length === 1 && (t = e, e = 0);
  for (var n = [], o = e; o < t; o++)
    n.push(o);
  return n;
}, Vr = function(e, t) {
  var n = 0, o = [];
  if (Ru(e))
    for (; n < t; n++)
      o[n] = [].concat(e);
  else
    for (; n < t; n++)
      o[n] = e;
  return o;
}, wil = function(e) {
  return Ru(e) ? e : [e];
};
function pb(e, t, n) {
  n === void 0 && (n = " ");
  var o = String(e);
  return t = t >> 0, o.length > t ? String(o) : (t = t - o.length, t > n.length && (n += Vr(n, t / n.length)), n.slice(0, t) + String(o));
}
var kil = function(e, t, n) {
  var o = e.split(t);
  return n ? o.slice(0, n).concat([o.slice(n).join(t)]) : o;
}, Cd = function(e, t) {
  var n = e % t;
  return n * t < 0 ? n + t : n;
}, Hz = function(e, t) {
  return { div: Math.floor(e / t), mod: Cd(e, t) };
}, Np = function(e) {
  return !ts(e) || e.length === 0;
}, Vs = function(e) {
  return !Np(e);
}, Gi = function(e, t) {
  return Vs(e) && e.indexOf(t) !== -1;
}, jh;
(function(e) {
  e.MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], e.ONE_DAY = 1e3 * 60 * 60 * 24, e.MAXYEAR = 9999, e.ORDINAL_BASE = new Date(Date.UTC(1970, 0, 1)), e.PY_WEEKDAYS = [6, 0, 1, 2, 3, 4, 5], e.getYearDay = function(t) {
    var n = new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate());
    return Math.ceil((n.valueOf() - new Date(t.getUTCFullYear(), 0, 1).valueOf()) / e.ONE_DAY) + 1;
  }, e.isLeapYear = function(t) {
    return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
  }, e.isDate = function(t) {
    return t instanceof Date;
  }, e.isValidDate = function(t) {
    return e.isDate(t) && !isNaN(t.getTime());
  }, e.tzOffset = function(t) {
    return t.getTimezoneOffset() * 60 * 1e3;
  }, e.daysBetween = function(t, n) {
    var o = t.getTime() - e.tzOffset(t), r = n.getTime() - e.tzOffset(n), i = o - r;
    return Math.round(i / e.ONE_DAY);
  }, e.toOrdinal = function(t) {
    return e.daysBetween(t, e.ORDINAL_BASE);
  }, e.fromOrdinal = function(t) {
    return new Date(e.ORDINAL_BASE.getTime() + t * e.ONE_DAY);
  }, e.getMonthDays = function(t) {
    var n = t.getUTCMonth();
    return n === 1 && e.isLeapYear(t.getUTCFullYear()) ? 29 : e.MONTH_DAYS[n];
  }, e.getWeekday = function(t) {
    return e.PY_WEEKDAYS[t.getUTCDay()];
  }, e.monthRange = function(t, n) {
    var o = new Date(Date.UTC(t, n, 1));
    return [e.getWeekday(o), e.getMonthDays(o)];
  }, e.combine = function(t, n) {
    return n = n || t, new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
  }, e.clone = function(t) {
    var n = new Date(t.getTime());
    return n;
  }, e.cloneDates = function(t) {
    for (var n = [], o = 0; o < t.length; o++)
      n.push(e.clone(t[o]));
    return n;
  }, e.sort = function(t) {
    t.sort(function(n, o) {
      return n.getTime() - o.getTime();
    });
  }, e.timeToUntilString = function(t, n) {
    n === void 0 && (n = !0);
    var o = new Date(t);
    return [
      pb(o.getUTCFullYear().toString(), 4, "0"),
      pb(o.getUTCMonth() + 1, 2, "0"),
      pb(o.getUTCDate(), 2, "0"),
      "T",
      pb(o.getUTCHours(), 2, "0"),
      pb(o.getUTCMinutes(), 2, "0"),
      pb(o.getUTCSeconds(), 2, "0"),
      n ? "Z" : ""
    ].join("");
  }, e.untilStringToDate = function(t) {
    var n = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/, o = n.exec(t);
    if (!o)
      throw new Error("Invalid UNTIL value: ".concat(t));
    return new Date(Date.UTC(parseInt(o[1], 10), parseInt(o[2], 10) - 1, parseInt(o[3], 10), parseInt(o[5], 10) || 0, parseInt(o[6], 10) || 0, parseInt(o[7], 10) || 0));
  };
})(jh || (jh = {}));
const kr = jh;
var Ob = (
  /** @class */
  function() {
    function e(t, n) {
      this.minDate = null, this.maxDate = null, this._result = [], this.total = 0, this.method = t, this.args = n, t === "between" ? (this.maxDate = n.inc ? n.before : new Date(n.before.getTime() - 1), this.minDate = n.inc ? n.after : new Date(n.after.getTime() + 1)) : t === "before" ? this.maxDate = n.inc ? n.dt : new Date(n.dt.getTime() - 1) : t === "after" && (this.minDate = n.inc ? n.dt : new Date(n.dt.getTime() + 1));
    }
    return e.prototype.accept = function(t) {
      ++this.total;
      var n = this.minDate && t < this.minDate, o = this.maxDate && t > this.maxDate;
      if (this.method === "between") {
        if (n)
          return !0;
        if (o)
          return !1;
      } else if (this.method === "before") {
        if (o)
          return !1;
      } else if (this.method === "after")
        return n ? !0 : (this.add(t), !1);
      return this.add(t);
    }, e.prototype.add = function(t) {
      return this._result.push(t), !0;
    }, e.prototype.getValue = function() {
      var t = this._result;
      switch (this.method) {
        case "all":
        case "between":
          return t;
        case "before":
        case "after":
        default:
          return t.length ? t[t.length - 1] : null;
      }
    }, e.prototype.clone = function() {
      return new e(this.method, this.args);
    }, e;
  }()
), L5 = function(e, t) {
  return L5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
    n.__proto__ = o;
  } || function(n, o) {
    for (var r in o)
      Object.prototype.hasOwnProperty.call(o, r) && (n[r] = o[r]);
  }, L5(e, t);
};
function Cj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  L5(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Vu = function() {
  return Vu = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Vu.apply(this, arguments);
};
function On(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var MK = (
  /** @class */
  function(e) {
    Cj(t, e);
    function t(n, o, r) {
      var i = e.call(this, n, o) || this;
      return i.iterator = r, i;
    }
    return t.prototype.add = function(n) {
      return this.iterator(n, this._result.length) ? (this._result.push(n), !0) : !1;
    }, t;
  }(Ob)
), KC = {
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  tokens: {
    SKIP: /^[ \r\n\t]+|^\.$/,
    number: /^[1-9][0-9]*/,
    numberAsText: /^(one|two|three)/i,
    every: /^every/i,
    "day(s)": /^days?/i,
    "weekday(s)": /^weekdays?/i,
    "week(s)": /^weeks?/i,
    "hour(s)": /^hours?/i,
    "minute(s)": /^minutes?/i,
    "month(s)": /^months?/i,
    "year(s)": /^years?/i,
    on: /^(on|in)/i,
    at: /^(at)/i,
    the: /^the/i,
    first: /^first/i,
    second: /^second/i,
    third: /^third/i,
    nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
    last: /^last/i,
    for: /^for/i,
    "time(s)": /^times?/i,
    until: /^(un)?til/i,
    monday: /^mo(n(day)?)?/i,
    tuesday: /^tu(e(s(day)?)?)?/i,
    wednesday: /^we(d(n(esday)?)?)?/i,
    thursday: /^th(u(r(sday)?)?)?/i,
    friday: /^fr(i(day)?)?/i,
    saturday: /^sa(t(urday)?)?/i,
    sunday: /^su(n(day)?)?/i,
    january: /^jan(uary)?/i,
    february: /^feb(ruary)?/i,
    march: /^mar(ch)?/i,
    april: /^apr(il)?/i,
    may: /^may/i,
    june: /^june?/i,
    july: /^july?/i,
    august: /^aug(ust)?/i,
    september: /^sep(t(ember)?)?/i,
    october: /^oct(ober)?/i,
    november: /^nov(ember)?/i,
    december: /^dec(ember)?/i,
    comma: /^(,\s*|(and|or)\s*)+/i
  }
}, FK = function(e, t) {
  return e.indexOf(t) !== -1;
}, Sil = function(e) {
  return e.toString();
}, Eil = function(e, t, n) {
  return "".concat(t, " ").concat(n, ", ").concat(e);
}, Af = (
  /** @class */
  function() {
    function e(t, n, o, r) {
      if (n === void 0 && (n = Sil), o === void 0 && (o = KC), r === void 0 && (r = Eil), this.text = [], this.language = o || KC, this.gettext = n, this.dateFormatter = r, this.rrule = t, this.options = t.options, this.origOptions = t.origOptions, this.origOptions.bymonthday) {
        var i = [].concat(this.options.bymonthday), a = [].concat(this.options.bynmonthday);
        i.sort(function(u, d) {
          return u - d;
        }), a.sort(function(u, d) {
          return d - u;
        }), this.bymonthday = i.concat(a), this.bymonthday.length || (this.bymonthday = null);
      }
      if (ts(this.origOptions.byweekday)) {
        var s = Ru(this.origOptions.byweekday) ? this.origOptions.byweekday : [this.origOptions.byweekday], c = String(s);
        this.byweekday = {
          allWeeks: s.filter(function(u) {
            return !u.n;
          }),
          someWeeks: s.filter(function(u) {
            return !!u.n;
          }),
          isWeekdays: c.indexOf("MO") !== -1 && c.indexOf("TU") !== -1 && c.indexOf("WE") !== -1 && c.indexOf("TH") !== -1 && c.indexOf("FR") !== -1 && c.indexOf("SA") === -1 && c.indexOf("SU") === -1,
          isEveryDay: c.indexOf("MO") !== -1 && c.indexOf("TU") !== -1 && c.indexOf("WE") !== -1 && c.indexOf("TH") !== -1 && c.indexOf("FR") !== -1 && c.indexOf("SA") !== -1 && c.indexOf("SU") !== -1
        };
        var l = function(u, d) {
          return u.weekday - d.weekday;
        };
        this.byweekday.allWeeks.sort(l), this.byweekday.someWeeks.sort(l), this.byweekday.allWeeks.length || (this.byweekday.allWeeks = null), this.byweekday.someWeeks.length || (this.byweekday.someWeeks = null);
      } else
        this.byweekday = null;
    }
    return e.isFullyConvertible = function(t) {
      var n = !0;
      if (!(t.options.freq in e.IMPLEMENTED) || t.origOptions.until && t.origOptions.count)
        return !1;
      for (var o in t.origOptions) {
        if (FK(["dtstart", "wkst", "freq"], o))
          return !0;
        if (!FK(e.IMPLEMENTED[t.options.freq], o))
          return !1;
      }
      return n;
    }, e.prototype.isFullyConvertible = function() {
      return e.isFullyConvertible(this.rrule);
    }, e.prototype.toString = function() {
      var t = this.gettext;
      if (!(this.options.freq in e.IMPLEMENTED))
        return t("RRule error: Unable to fully convert this rrule to text");
      if (this.text = [t("every")], this[Lo.FREQUENCIES[this.options.freq]](), this.options.until) {
        this.add(t("until"));
        var n = this.options.until;
        this.add(this.dateFormatter(n.getUTCFullYear(), this.language.monthNames[n.getUTCMonth()], n.getUTCDate()));
      } else
        this.options.count && this.add(t("for")).add(this.options.count.toString()).add(this.plural(this.options.count) ? t("times") : t("time"));
      return this.isFullyConvertible() || this.add(t("(~ approximate)")), this.text.join("");
    }, e.prototype.HOURLY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("hours") : t("hour"));
    }, e.prototype.MINUTELY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("minutes") : t("minute"));
    }, e.prototype.DAILY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.byweekday && this.byweekday.isWeekdays ? this.add(this.plural(this.options.interval) ? t("weekdays") : t("weekday")) : this.add(this.plural(this.options.interval) ? t("days") : t("day")), this.origOptions.bymonth && (this.add(t("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday ? this._byweekday() : this.origOptions.byhour && this._byhour();
    }, e.prototype.WEEKLY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? t("weeks") : t("week")), this.byweekday && this.byweekday.isWeekdays ? this.options.interval === 1 ? this.add(this.plural(this.options.interval) ? t("weekdays") : t("weekday")) : this.add(t("on")).add(t("weekdays")) : this.byweekday && this.byweekday.isEveryDay ? this.add(this.plural(this.options.interval) ? t("days") : t("day")) : (this.options.interval === 1 && this.add(t("week")), this.origOptions.bymonth && (this.add(t("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday());
    }, e.prototype.MONTHLY = function() {
      var t = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()).add(t("months")), this.plural(this.options.interval) && this.add(t("in"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("months") : t("month"))), this.bymonthday ? this._bymonthday() : this.byweekday && this.byweekday.isWeekdays ? this.add(t("on")).add(t("weekdays")) : this.byweekday && this._byweekday();
    }, e.prototype.YEARLY = function() {
      var t = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()), this.add(t("years"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("years") : t("year"))), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.options.byyearday && this.add(t("on the")).add(this.list(this.options.byyearday, this.nth, t("and"))).add(t("day")), this.options.byweekno && this.add(t("in")).add(this.plural(this.options.byweekno.length) ? t("weeks") : t("week")).add(this.list(this.options.byweekno, void 0, t("and")));
    }, e.prototype._bymonthday = function() {
      var t = this.gettext;
      this.byweekday && this.byweekday.allWeeks ? this.add(t("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext, t("or"))).add(t("the")).add(this.list(this.bymonthday, this.nth, t("or"))) : this.add(t("on the")).add(this.list(this.bymonthday, this.nth, t("and")));
    }, e.prototype._byweekday = function() {
      var t = this.gettext;
      this.byweekday.allWeeks && !this.byweekday.isWeekdays && this.add(t("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext)), this.byweekday.someWeeks && (this.byweekday.allWeeks && this.add(t("and")), this.add(t("on the")).add(this.list(this.byweekday.someWeeks, this.weekdaytext, t("and"))));
    }, e.prototype._byhour = function() {
      var t = this.gettext;
      this.add(t("at")).add(this.list(this.origOptions.byhour, void 0, t("and")));
    }, e.prototype._bymonth = function() {
      this.add(this.list(this.options.bymonth, this.monthtext, this.gettext("and")));
    }, e.prototype.nth = function(t) {
      t = parseInt(t.toString(), 10);
      var n, o = this.gettext;
      if (t === -1)
        return o("last");
      var r = Math.abs(t);
      switch (r) {
        case 1:
        case 21:
        case 31:
          n = r + o("st");
          break;
        case 2:
        case 22:
          n = r + o("nd");
          break;
        case 3:
        case 23:
          n = r + o("rd");
          break;
        default:
          n = r + o("th");
      }
      return t < 0 ? n + " " + o("last") : n;
    }, e.prototype.monthtext = function(t) {
      return this.language.monthNames[t - 1];
    }, e.prototype.weekdaytext = function(t) {
      var n = Ep(t) ? (t + 1) % 7 : t.getJsWeekday();
      return (t.n ? this.nth(t.n) + " " : "") + this.language.dayNames[n];
    }, e.prototype.plural = function(t) {
      return t % 100 !== 1;
    }, e.prototype.add = function(t) {
      return this.text.push(" "), this.text.push(t), this;
    }, e.prototype.list = function(t, n, o, r) {
      var i = this;
      r === void 0 && (r = ","), Ru(t) || (t = [t]);
      var a = function(c, l, u) {
        for (var d = "", _ = 0; _ < c.length; _++)
          _ !== 0 && (_ === c.length - 1 ? d += " " + u + " " : d += l + " "), d += c[_];
        return d;
      };
      n = n || function(c) {
        return c.toString();
      };
      var s = function(c) {
        return n && n.call(i, c);
      };
      return o ? a(t.map(s), r, o) : t.map(s).join(r + " ");
    }, e;
  }()
), xil = (
  /** @class */
  function() {
    function e(t) {
      this.done = !0, this.rules = t;
    }
    return e.prototype.start = function(t) {
      return this.text = t, this.done = !1, this.nextSymbol();
    }, e.prototype.isDone = function() {
      return this.done && this.symbol === null;
    }, e.prototype.nextSymbol = function() {
      var t, n;
      this.symbol = null, this.value = null;
      do {
        if (this.done)
          return !1;
        var o = void 0;
        t = null;
        for (var r in this.rules) {
          o = this.rules[r];
          var i = o.exec(this.text);
          i && (t === null || i[0].length > t[0].length) && (t = i, n = r);
        }
        if (t != null && (this.text = this.text.substr(t[0].length), this.text === "" && (this.done = !0)), t == null) {
          this.done = !0, this.symbol = null, this.value = null;
          return;
        }
      } while (n === "SKIP");
      return this.symbol = n, this.value = t, !0;
    }, e.prototype.accept = function(t) {
      if (this.symbol === t) {
        if (this.value) {
          var n = this.value;
          return this.nextSymbol(), n;
        }
        return this.nextSymbol(), !0;
      }
      return !1;
    }, e.prototype.acceptNumber = function() {
      return this.accept("number");
    }, e.prototype.expect = function(t) {
      if (this.accept(t))
        return !0;
      throw new Error("expected " + t + " but found " + this.symbol);
    }, e;
  }()
);
function Kge(e, t) {
  t === void 0 && (t = KC);
  var n = {}, o = new xil(t.tokens);
  if (!o.start(e))
    return null;
  return r(), n;
  function r() {
    o.expect("every");
    var _ = o.acceptNumber();
    if (_ && (n.interval = parseInt(_[0], 10)), o.isDone())
      throw new Error("Unexpected end");
    switch (o.symbol) {
      case "day(s)":
        n.freq = Lo.DAILY, o.nextSymbol() && (a(), d());
        break;
      case "weekday(s)":
        n.freq = Lo.WEEKLY, n.byweekday = [Lo.MO, Lo.TU, Lo.WE, Lo.TH, Lo.FR], o.nextSymbol(), d();
        break;
      case "week(s)":
        n.freq = Lo.WEEKLY, o.nextSymbol() && (i(), d());
        break;
      case "hour(s)":
        n.freq = Lo.HOURLY, o.nextSymbol() && (i(), d());
        break;
      case "minute(s)":
        n.freq = Lo.MINUTELY, o.nextSymbol() && (i(), d());
        break;
      case "month(s)":
        n.freq = Lo.MONTHLY, o.nextSymbol() && (i(), d());
        break;
      case "year(s)":
        n.freq = Lo.YEARLY, o.nextSymbol() && (i(), d());
        break;
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        n.freq = Lo.WEEKLY;
        var p = o.symbol.substr(0, 2).toUpperCase();
        if (n.byweekday = [Lo[p]], !o.nextSymbol())
          return;
        for (; o.accept("comma"); ) {
          if (o.isDone())
            throw new Error("Unexpected end");
          var g = c();
          if (!g)
            throw new Error("Unexpected symbol " + o.symbol + ", expected weekday");
          n.byweekday.push(Lo[g]), o.nextSymbol();
        }
        u(), d();
        break;
      case "january":
      case "february":
      case "march":
      case "april":
      case "may":
      case "june":
      case "july":
      case "august":
      case "september":
      case "october":
      case "november":
      case "december":
        if (n.freq = Lo.YEARLY, n.bymonth = [s()], !o.nextSymbol())
          return;
        for (; o.accept("comma"); ) {
          if (o.isDone())
            throw new Error("Unexpected end");
          var f = s();
          if (!f)
            throw new Error("Unexpected symbol " + o.symbol + ", expected month");
          n.bymonth.push(f), o.nextSymbol();
        }
        i(), d();
        break;
      default:
        throw new Error("Unknown symbol");
    }
  }
  function i() {
    var _ = o.accept("on"), p = o.accept("the");
    if (_ || p)
      do {
        var g = l(), f = c(), h = s();
        if (g)
          f ? (o.nextSymbol(), n.byweekday || (n.byweekday = []), n.byweekday.push(Lo[f].nth(g))) : (n.bymonthday || (n.bymonthday = []), n.bymonthday.push(g), o.accept("day(s)"));
        else if (f)
          o.nextSymbol(), n.byweekday || (n.byweekday = []), n.byweekday.push(Lo[f]);
        else if (o.symbol === "weekday(s)")
          o.nextSymbol(), n.byweekday || (n.byweekday = [Lo.MO, Lo.TU, Lo.WE, Lo.TH, Lo.FR]);
        else if (o.symbol === "week(s)") {
          o.nextSymbol();
          var $ = o.acceptNumber();
          if (!$)
            throw new Error("Unexpected symbol " + o.symbol + ", expected week number");
          for (n.byweekno = [parseInt($[0], 10)]; o.accept("comma"); ) {
            if ($ = o.acceptNumber(), !$)
              throw new Error("Unexpected symbol " + o.symbol + "; expected monthday");
            n.byweekno.push(parseInt($[0], 10));
          }
        } else if (h)
          o.nextSymbol(), n.bymonth || (n.bymonth = []), n.bymonth.push(h);
        else
          return;
      } while (o.accept("comma") || o.accept("the") || o.accept("on"));
  }
  function a() {
    var _ = o.accept("at");
    if (_)
      do {
        var p = o.acceptNumber();
        if (!p)
          throw new Error("Unexpected symbol " + o.symbol + ", expected hour");
        for (n.byhour = [parseInt(p[0], 10)]; o.accept("comma"); ) {
          if (p = o.acceptNumber(), !p)
            throw new Error("Unexpected symbol " + o.symbol + "; expected hour");
          n.byhour.push(parseInt(p[0], 10));
        }
      } while (o.accept("comma") || o.accept("at"));
  }
  function s() {
    switch (o.symbol) {
      case "january":
        return 1;
      case "february":
        return 2;
      case "march":
        return 3;
      case "april":
        return 4;
      case "may":
        return 5;
      case "june":
        return 6;
      case "july":
        return 7;
      case "august":
        return 8;
      case "september":
        return 9;
      case "october":
        return 10;
      case "november":
        return 11;
      case "december":
        return 12;
      default:
        return !1;
    }
  }
  function c() {
    switch (o.symbol) {
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        return o.symbol.substr(0, 2).toUpperCase();
      default:
        return !1;
    }
  }
  function l() {
    switch (o.symbol) {
      case "last":
        return o.nextSymbol(), -1;
      case "first":
        return o.nextSymbol(), 1;
      case "second":
        return o.nextSymbol(), o.accept("last") ? -2 : 2;
      case "third":
        return o.nextSymbol(), o.accept("last") ? -3 : 3;
      case "nth":
        var _ = parseInt(o.value[1], 10);
        if (_ < -366 || _ > 366)
          throw new Error("Nth out of range: " + _);
        return o.nextSymbol(), o.accept("last") ? -_ : _;
      default:
        return !1;
    }
  }
  function u() {
    o.accept("on"), o.accept("the");
    var _ = l();
    if (_)
      for (n.bymonthday = [_], o.nextSymbol(); o.accept("comma"); ) {
        if (_ = l(), !_)
          throw new Error("Unexpected symbol " + o.symbol + "; expected monthday");
        n.bymonthday.push(_), o.nextSymbol();
      }
  }
  function d() {
    if (o.symbol === "until") {
      var _ = Date.parse(o.text);
      if (!_)
        throw new Error("Cannot parse until date:" + o.text);
      n.until = new Date(_);
    } else
      o.accept("for") && (n.count = parseInt(o.value[0], 10), o.expect("number"));
  }
}
var Ur;
(function(e) {
  e[e.YEARLY = 0] = "YEARLY", e[e.MONTHLY = 1] = "MONTHLY", e[e.WEEKLY = 2] = "WEEKLY", e[e.DAILY = 3] = "DAILY", e[e.HOURLY = 4] = "HOURLY", e[e.MINUTELY = 5] = "MINUTELY", e[e.SECONDLY = 6] = "SECONDLY";
})(Ur || (Ur = {}));
function Tj(e) {
  return e < Ur.HOURLY;
}
var Cil = function(e, t) {
  return t === void 0 && (t = KC), new Lo(Kge(e, t) || void 0);
}, a$ = [
  "count",
  "until",
  "interval",
  "byweekday",
  "bymonthday",
  "bymonth"
];
Af.IMPLEMENTED = [];
Af.IMPLEMENTED[Ur.HOURLY] = a$;
Af.IMPLEMENTED[Ur.MINUTELY] = a$;
Af.IMPLEMENTED[Ur.DAILY] = ["byhour"].concat(a$);
Af.IMPLEMENTED[Ur.WEEKLY] = a$;
Af.IMPLEMENTED[Ur.MONTHLY] = a$;
Af.IMPLEMENTED[Ur.YEARLY] = ["byweekno", "byyearday"].concat(a$);
var Til = function(e, t, n, o) {
  return new Af(e, t, n, o).toString();
}, Ail = Af.isFullyConvertible, ZC = (
  /** @class */
  function() {
    function e(t, n, o, r) {
      this.hour = t, this.minute = n, this.second = o, this.millisecond = r || 0;
    }
    return e.prototype.getHours = function() {
      return this.hour;
    }, e.prototype.getMinutes = function() {
      return this.minute;
    }, e.prototype.getSeconds = function() {
      return this.second;
    }, e.prototype.getMilliseconds = function() {
      return this.millisecond;
    }, e.prototype.getTime = function() {
      return (this.hour * 60 * 60 + this.minute * 60 + this.second) * 1e3 + this.millisecond;
    }, e;
  }()
), Iil = (
  /** @class */
  function(e) {
    Cj(t, e);
    function t(n, o, r, i, a, s, c) {
      var l = e.call(this, i, a, s, c) || this;
      return l.year = n, l.month = o, l.day = r, l;
    }
    return t.fromDate = function(n) {
      return new this(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate(), n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.valueOf() % 1e3);
    }, t.prototype.getWeekday = function() {
      return jh.getWeekday(new Date(this.getTime()));
    }, t.prototype.getTime = function() {
      return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    }, t.prototype.getDay = function() {
      return this.day;
    }, t.prototype.getMonth = function() {
      return this.month;
    }, t.prototype.getYear = function() {
      return this.year;
    }, t.prototype.addYears = function(n) {
      this.year += n;
    }, t.prototype.addMonths = function(n) {
      if (this.month += n, this.month > 12) {
        var o = Math.floor(this.month / 12), r = Cd(this.month, 12);
        this.month = r, this.year += o, this.month === 0 && (this.month = 12, --this.year);
      }
    }, t.prototype.addWeekly = function(n, o) {
      o > this.getWeekday() ? this.day += -(this.getWeekday() + 1 + (6 - o)) + n * 7 : this.day += -(this.getWeekday() - o) + n * 7, this.fixDay();
    }, t.prototype.addDaily = function(n) {
      this.day += n, this.fixDay();
    }, t.prototype.addHours = function(n, o, r) {
      for (o && (this.hour += Math.floor((23 - this.hour) / n) * n); ; ) {
        this.hour += n;
        var i = Hz(this.hour, 24), a = i.div, s = i.mod;
        if (a && (this.hour = s, this.addDaily(a)), Np(r) || Gi(r, this.hour))
          break;
      }
    }, t.prototype.addMinutes = function(n, o, r, i) {
      for (o && (this.minute += Math.floor((1439 - (this.hour * 60 + this.minute)) / n) * n); ; ) {
        this.minute += n;
        var a = Hz(this.minute, 60), s = a.div, c = a.mod;
        if (s && (this.minute = c, this.addHours(s, !1, r)), (Np(r) || Gi(r, this.hour)) && (Np(i) || Gi(i, this.minute)))
          break;
      }
    }, t.prototype.addSeconds = function(n, o, r, i, a) {
      for (o && (this.second += Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / n) * n); ; ) {
        this.second += n;
        var s = Hz(this.second, 60), c = s.div, l = s.mod;
        if (c && (this.second = l, this.addMinutes(c, !1, r, i)), (Np(r) || Gi(r, this.hour)) && (Np(i) || Gi(i, this.minute)) && (Np(a) || Gi(a, this.second)))
          break;
      }
    }, t.prototype.fixDay = function() {
      if (!(this.day <= 28)) {
        var n = jh.monthRange(this.year, this.month - 1)[1];
        if (!(this.day <= n))
          for (; this.day > n; ) {
            if (this.day -= n, ++this.month, this.month === 13 && (this.month = 1, ++this.year, this.year > jh.MAXYEAR))
              return;
            n = jh.monthRange(this.year, this.month - 1)[1];
          }
      }
    }, t.prototype.add = function(n, o) {
      var r = n.freq, i = n.interval, a = n.wkst, s = n.byhour, c = n.byminute, l = n.bysecond;
      switch (r) {
        case Ur.YEARLY:
          return this.addYears(i);
        case Ur.MONTHLY:
          return this.addMonths(i);
        case Ur.WEEKLY:
          return this.addWeekly(i, a);
        case Ur.DAILY:
          return this.addDaily(i);
        case Ur.HOURLY:
          return this.addHours(i, o, s);
        case Ur.MINUTELY:
          return this.addMinutes(i, o, s, c);
        case Ur.SECONDLY:
          return this.addSeconds(i, o, s, c, l);
      }
    }, t;
  }(ZC)
);
function Zge(e) {
  for (var t = [], n = Object.keys(e), o = 0, r = n; o < r.length; o++) {
    var i = r[o];
    Gi(aal, i) || t.push(i), kr.isDate(e[i]) && !kr.isValidDate(e[i]) && t.push(i);
  }
  if (t.length)
    throw new Error("Invalid options: " + t.join(", "));
  return Vu({}, e);
}
function Oil(e) {
  var t = Vu(Vu({}, Aj), Zge(e));
  if (ts(t.byeaster) && (t.freq = Lo.YEARLY), !(ts(t.freq) && Lo.FREQUENCIES[t.freq]))
    throw new Error("Invalid frequency: ".concat(t.freq, " ").concat(e.freq));
  if (t.dtstart || (t.dtstart = new Date((/* @__PURE__ */ new Date()).setMilliseconds(0))), ts(t.wkst) ? Ep(t.wkst) || (t.wkst = t.wkst.weekday) : t.wkst = Lo.MO.weekday, ts(t.bysetpos)) {
    Ep(t.bysetpos) && (t.bysetpos = [t.bysetpos]);
    for (var n = 0; n < t.bysetpos.length; n++) {
      var o = t.bysetpos[n];
      if (o === 0 || !(o >= -366 && o <= 366))
        throw new Error("bysetpos must be between 1 and 366, or between -366 and -1");
    }
  }
  if (!(t.byweekno || Vs(t.byweekno) || Vs(t.byyearday) || t.bymonthday || Vs(t.bymonthday) || ts(t.byweekday) || ts(t.byeaster)))
    switch (t.freq) {
      case Lo.YEARLY:
        t.bymonth || (t.bymonth = t.dtstart.getUTCMonth() + 1), t.bymonthday = t.dtstart.getUTCDate();
        break;
      case Lo.MONTHLY:
        t.bymonthday = t.dtstart.getUTCDate();
        break;
      case Lo.WEEKLY:
        t.byweekday = [kr.getWeekday(t.dtstart)];
        break;
    }
  if (ts(t.bymonth) && !Ru(t.bymonth) && (t.bymonth = [t.bymonth]), ts(t.byyearday) && !Ru(t.byyearday) && Ep(t.byyearday) && (t.byyearday = [t.byyearday]), !ts(t.bymonthday))
    t.bymonthday = [], t.bynmonthday = [];
  else if (Ru(t.bymonthday)) {
    for (var r = [], i = [], n = 0; n < t.bymonthday.length; n++) {
      var o = t.bymonthday[n];
      o > 0 ? r.push(o) : o < 0 && i.push(o);
    }
    t.bymonthday = r, t.bynmonthday = i;
  } else
    t.bymonthday < 0 ? (t.bynmonthday = [t.bymonthday], t.bymonthday = []) : (t.bynmonthday = [], t.bymonthday = [t.bymonthday]);
  if (ts(t.byweekno) && !Ru(t.byweekno) && (t.byweekno = [t.byweekno]), !ts(t.byweekday))
    t.bynweekday = null;
  else if (Ep(t.byweekday))
    t.byweekday = [t.byweekday], t.bynweekday = null;
  else if (LK(t.byweekday))
    t.byweekday = [pl.fromStr(t.byweekday).weekday], t.bynweekday = null;
  else if (t.byweekday instanceof pl)
    !t.byweekday.n || t.freq > Lo.MONTHLY ? (t.byweekday = [t.byweekday.weekday], t.bynweekday = null) : (t.bynweekday = [[t.byweekday.weekday, t.byweekday.n]], t.byweekday = null);
  else {
    for (var a = [], s = [], n = 0; n < t.byweekday.length; n++) {
      var c = t.byweekday[n];
      if (Ep(c)) {
        a.push(c);
        continue;
      } else if (LK(c)) {
        a.push(pl.fromStr(c).weekday);
        continue;
      }
      !c.n || t.freq > Lo.MONTHLY ? a.push(c.weekday) : s.push([c.weekday, c.n]);
    }
    t.byweekday = Vs(a) ? a : null, t.bynweekday = Vs(s) ? s : null;
  }
  return ts(t.byhour) ? Ep(t.byhour) && (t.byhour = [t.byhour]) : t.byhour = t.freq < Lo.HOURLY ? [t.dtstart.getUTCHours()] : null, ts(t.byminute) ? Ep(t.byminute) && (t.byminute = [t.byminute]) : t.byminute = t.freq < Lo.MINUTELY ? [t.dtstart.getUTCMinutes()] : null, ts(t.bysecond) ? Ep(t.bysecond) && (t.bysecond = [t.bysecond]) : t.bysecond = t.freq < Lo.SECONDLY ? [t.dtstart.getUTCSeconds()] : null, { parsedOptions: t };
}
function Nil(e) {
  var t = e.dtstart.getTime() % 1e3;
  if (!Tj(e.freq))
    return [];
  var n = [];
  return e.byhour.forEach(function(o) {
    e.byminute.forEach(function(r) {
      e.bysecond.forEach(function(i) {
        n.push(new ZC(o, r, i, t));
      });
    });
  }), n;
}
function M5(e) {
  var t = e.split(`
`).map(zil).filter(function(n) {
    return n !== null;
  });
  return Vu(Vu({}, t[0]), t[1]);
}
function XC(e) {
  var t = {}, n = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(e);
  if (!n)
    return t;
  var o = n[1], r = n[2];
  return o && (t.tzid = o), t.dtstart = kr.untilStringToDate(r), t;
}
function zil(e) {
  if (e = e.replace(/^\s+|\s+$/, ""), !e.length)
    return null;
  var t = /^([A-Z]+?)[:;]/.exec(e.toUpperCase());
  if (!t)
    return qK(e);
  var n = t[1];
  switch (n.toUpperCase()) {
    case "RRULE":
    case "EXRULE":
      return qK(e);
    case "DTSTART":
      return XC(e);
    default:
      throw new Error("Unsupported RFC prop ".concat(n, " in ").concat(e));
  }
}
function qK(e) {
  var t = e.replace(/^RRULE:/i, ""), n = XC(t), o = e.replace(/^(?:RRULE|EXRULE):/i, "").split(";");
  return o.forEach(function(r) {
    var i = r.split("="), a = i[0], s = i[1];
    switch (a.toUpperCase()) {
      case "FREQ":
        n.freq = Ur[s.toUpperCase()];
        break;
      case "WKST":
        n.wkst = C_[s.toUpperCase()];
        break;
      case "COUNT":
      case "INTERVAL":
      case "BYSETPOS":
      case "BYMONTH":
      case "BYMONTHDAY":
      case "BYYEARDAY":
      case "BYWEEKNO":
      case "BYHOUR":
      case "BYMINUTE":
      case "BYSECOND":
        var c = Ril(s), l = a.toLowerCase();
        n[l] = c;
        break;
      case "BYWEEKDAY":
      case "BYDAY":
        n.byweekday = Pil(s);
        break;
      case "DTSTART":
      case "TZID":
        var u = XC(e);
        n.tzid = u.tzid, n.dtstart = u.dtstart;
        break;
      case "UNTIL":
        n.until = kr.untilStringToDate(s);
        break;
      case "BYEASTER":
        n.byeaster = Number(s);
        break;
      default:
        throw new Error("Unknown RRULE property '" + a + "'");
    }
  }), n;
}
function Ril(e) {
  if (e.indexOf(",") !== -1) {
    var t = e.split(",");
    return t.map(jK);
  }
  return jK(e);
}
function jK(e) {
  return /^[+-]?\d+$/.test(e) ? Number(e) : e;
}
function Pil(e) {
  var t = e.split(",");
  return t.map(function(n) {
    if (n.length === 2)
      return C_[n];
    var o = n.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
    if (!o || o.length < 3)
      throw new SyntaxError("Invalid weekday string: ".concat(n));
    var r = Number(o[1]), i = o[2], a = C_[i].weekday;
    return new pl(a, r);
  });
}
var JC = (
  /** @class */
  function() {
    function e(t, n) {
      if (isNaN(t.getTime()))
        throw new RangeError("Invalid date passed to DateWithZone");
      this.date = t, this.tzid = n;
    }
    return Object.defineProperty(e.prototype, "isUTC", {
      get: function() {
        return !this.tzid || this.tzid.toUpperCase() === "UTC";
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toString = function() {
      var t = kr.timeToUntilString(this.date.getTime(), this.isUTC);
      return this.isUTC ? ":".concat(t) : ";TZID=".concat(this.tzid, ":").concat(t);
    }, e.prototype.getTime = function() {
      return this.date.getTime();
    }, e.prototype.rezonedDate = function() {
      var t;
      if (this.isUTC)
        return this.date;
      var n = Intl.DateTimeFormat().resolvedOptions().timeZone, o = new Date(this.date.toLocaleString(void 0, { timeZone: n })), r = new Date(this.date.toLocaleString(void 0, { timeZone: (t = this.tzid) !== null && t !== void 0 ? t : "UTC" })), i = r.getTime() - o.getTime();
      return new Date(this.date.getTime() - i);
    }, e;
  }()
);
function F5(e) {
  for (var t = [], n = "", o = Object.keys(e), r = Object.keys(Aj), i = 0; i < o.length; i++)
    if (o[i] !== "tzid" && Gi(r, o[i])) {
      var a = o[i].toUpperCase(), s = e[o[i]], c = "";
      if (!(!ts(s) || Ru(s) && !s.length)) {
        switch (a) {
          case "FREQ":
            c = Lo.FREQUENCIES[e.freq];
            break;
          case "WKST":
            Ep(s) ? c = new pl(s).toString() : c = s.toString();
            break;
          case "BYWEEKDAY":
            a = "BYDAY", c = wil(s).map(function(p) {
              return p instanceof pl ? p : Ru(p) ? new pl(p[0], p[1]) : new pl(p);
            }).toString();
            break;
          case "DTSTART":
            n = Dil(s, e.tzid);
            break;
          case "UNTIL":
            c = kr.timeToUntilString(s, !e.tzid);
            break;
          default:
            if (Ru(s)) {
              for (var l = [], u = 0; u < s.length; u++)
                l[u] = String(s[u]);
              c = l.toString();
            } else
              c = String(s);
        }
        c && t.push([a, c]);
      }
    }
  var d = t.map(function(p) {
    var g = p[0], f = p[1];
    return "".concat(g, "=").concat(f.toString());
  }).join(";"), _ = "";
  return d !== "" && (_ = "RRULE:".concat(d)), [n, _].filter(function(p) {
    return !!p;
  }).join(`
`);
}
function Dil(e, t) {
  return e ? "DTSTART" + new JC(new Date(e), t).toString() : "";
}
function Lil(e, t) {
  return Array.isArray(e) ? !Array.isArray(t) || e.length !== t.length ? !1 : e.every(function(n, o) {
    return n.getTime() === t[o].getTime();
  }) : e instanceof Date ? t instanceof Date && e.getTime() === t.getTime() : e === t;
}
var Mil = (
  /** @class */
  function() {
    function e() {
      this.all = !1, this.before = [], this.after = [], this.between = [];
    }
    return e.prototype._cacheAdd = function(t, n, o) {
      n && (n = n instanceof Date ? kr.clone(n) : kr.cloneDates(n)), t === "all" ? this.all = n : (o._value = n, this[t].push(o));
    }, e.prototype._cacheGet = function(t, n) {
      var o = !1, r = n ? Object.keys(n) : [], i = function(u) {
        for (var d = 0; d < r.length; d++) {
          var _ = r[d];
          if (!Lil(n[_], u[_]))
            return !0;
        }
        return !1;
      }, a = this[t];
      if (t === "all")
        o = this.all;
      else if (Ru(a))
        for (var s = 0; s < a.length; s++) {
          var c = a[s];
          if (!(r.length && i(c))) {
            o = c._value;
            break;
          }
        }
      if (!o && this.all) {
        for (var l = new Ob(t, n), s = 0; s < this.all.length && l.accept(this.all[s]); s++)
          ;
        o = l.getValue(), this._cacheAdd(t, o, n);
      }
      return Ru(o) ? kr.cloneDates(o) : o instanceof Date ? kr.clone(o) : o;
    }, e;
  }()
), Fil = On(On(On(On(On(On(On(On(On(On(On(On(On([], Vr(1, 31), !0), Vr(2, 28), !0), Vr(3, 31), !0), Vr(4, 30), !0), Vr(5, 31), !0), Vr(6, 30), !0), Vr(7, 31), !0), Vr(8, 31), !0), Vr(9, 30), !0), Vr(10, 31), !0), Vr(11, 30), !0), Vr(12, 31), !0), Vr(1, 7), !0), qil = On(On(On(On(On(On(On(On(On(On(On(On(On([], Vr(1, 31), !0), Vr(2, 29), !0), Vr(3, 31), !0), Vr(4, 30), !0), Vr(5, 31), !0), Vr(6, 30), !0), Vr(7, 31), !0), Vr(8, 31), !0), Vr(9, 30), !0), Vr(10, 31), !0), Vr(11, 30), !0), Vr(12, 31), !0), Vr(1, 7), !0), jil = nm(1, 29), Vil = nm(1, 30), _g = nm(1, 31), Pc = nm(1, 32), Bil = On(On(On(On(On(On(On(On(On(On(On(On(On([], Pc, !0), Vil, !0), Pc, !0), _g, !0), Pc, !0), _g, !0), Pc, !0), Pc, !0), _g, !0), Pc, !0), _g, !0), Pc, !0), Pc.slice(0, 7), !0), Uil = On(On(On(On(On(On(On(On(On(On(On(On(On([], Pc, !0), jil, !0), Pc, !0), _g, !0), Pc, !0), _g, !0), Pc, !0), Pc, !0), _g, !0), Pc, !0), _g, !0), Pc, !0), Pc.slice(0, 7), !0), Gil = nm(-28, 0), Wil = nm(-29, 0), pg = nm(-30, 0), Dc = nm(-31, 0), Hil = On(On(On(On(On(On(On(On(On(On(On(On(On([], Dc, !0), Wil, !0), Dc, !0), pg, !0), Dc, !0), pg, !0), Dc, !0), Dc, !0), pg, !0), Dc, !0), pg, !0), Dc, !0), Dc.slice(0, 7), !0), Yil = On(On(On(On(On(On(On(On(On(On(On(On(On([], Dc, !0), Gil, !0), Dc, !0), pg, !0), Dc, !0), pg, !0), Dc, !0), Dc, !0), pg, !0), Dc, !0), pg, !0), Dc, !0), Dc.slice(0, 7), !0), Kil = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366], Zil = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365], VK = function() {
  for (var e = [], t = 0; t < 55; t++)
    e = e.concat(nm(7));
  return e;
}();
function Xil(e, t) {
  var n = new Date(Date.UTC(e, 0, 1)), o = kr.isLeapYear(e) ? 366 : 365, r = kr.isLeapYear(e + 1) ? 366 : 365, i = kr.toOrdinal(n), a = kr.getWeekday(n), s = Vu(Vu({ yearlen: o, nextyearlen: r, yearordinal: i, yearweekday: a }, Jil(e)), { wnomask: null });
  if (Np(t.byweekno))
    return s;
  s.wnomask = Vr(0, o + 7);
  var c, l, u = c = Cd(7 - a + t.wkst, 7);
  u >= 4 ? (u = 0, l = s.yearlen + Cd(a - t.wkst, 7)) : l = o - u;
  for (var d = Math.floor(l / 7), _ = Cd(l, 7), p = Math.floor(d + _ / 4), g = 0; g < t.byweekno.length; g++) {
    var f = t.byweekno[g];
    if (f < 0 && (f += p + 1), f > 0 && f <= p) {
      var h = void 0;
      f > 1 ? (h = u + (f - 1) * 7, u !== c && (h -= 7 - c)) : h = u;
      for (var $ = 0; $ < 7 && (s.wnomask[h] = 1, h++, s.wdaymask[h] !== t.wkst); $++)
        ;
    }
  }
  if (Gi(t.byweekno, 1)) {
    var h = u + p * 7;
    if (u !== c && (h -= 7 - c), h < o)
      for (var g = 0; g < 7 && (s.wnomask[h] = 1, h += 1, s.wdaymask[h] !== t.wkst); g++)
        ;
  }
  if (u) {
    var v = void 0;
    if (Gi(t.byweekno, -1))
      v = -1;
    else {
      var b = kr.getWeekday(new Date(Date.UTC(e - 1, 0, 1))), y = Cd(7 - b.valueOf() + t.wkst, 7), w = kr.isLeapYear(e - 1) ? 366 : 365, N = void 0;
      y >= 4 ? (y = 0, N = w + Cd(b - t.wkst, 7)) : N = o - u, v = Math.floor(52 + Cd(N, 7) / 4);
    }
    if (Gi(t.byweekno, v))
      for (var h = 0; h < u; h++)
        s.wnomask[h] = 1;
  }
  return s;
}
function Jil(e) {
  var t = kr.isLeapYear(e) ? 366 : 365, n = new Date(Date.UTC(e, 0, 1)), o = kr.getWeekday(n);
  return t === 365 ? {
    mmask: Fil,
    mdaymask: Uil,
    nmdaymask: Yil,
    wdaymask: VK.slice(o),
    mrange: Zil
  } : {
    mmask: qil,
    mdaymask: Bil,
    nmdaymask: Hil,
    wdaymask: VK.slice(o),
    mrange: Kil
  };
}
function Qil(e, t, n, o, r, i) {
  var a = {
    lastyear: e,
    lastmonth: t,
    nwdaymask: []
  }, s = [];
  if (i.freq === Lo.YEARLY)
    if (Np(i.bymonth))
      s = [[0, n]];
    else
      for (var c = 0; c < i.bymonth.length; c++)
        t = i.bymonth[c], s.push(o.slice(t - 1, t + 1));
  else
    i.freq === Lo.MONTHLY && (s = [o.slice(t - 1, t + 1)]);
  if (Np(s))
    return a;
  a.nwdaymask = Vr(0, n);
  for (var c = 0; c < s.length; c++)
    for (var l = s[c], u = l[0], d = l[1] - 1, _ = 0; _ < i.bynweekday.length; _++) {
      var p = void 0, g = i.bynweekday[_], f = g[0], h = g[1];
      h < 0 ? (p = d + (h + 1) * 7, p -= Cd(r[p] - f, 7)) : (p = u + (h - 1) * 7, p += Cd(7 - r[p] + f, 7)), u <= p && p <= d && (a.nwdaymask[p] = 1);
    }
  return a;
}
function eal(e, t) {
  t === void 0 && (t = 0);
  var n = e % 19, o = Math.floor(e / 100), r = e % 100, i = Math.floor(o / 4), a = o % 4, s = Math.floor((o + 8) / 25), c = Math.floor((o - s + 1) / 3), l = Math.floor(19 * n + o - i - c + 15) % 30, u = Math.floor(r / 4), d = r % 4, _ = Math.floor(32 + 2 * a + 2 * u - l - d) % 7, p = Math.floor((n + 11 * l + 22 * _) / 451), g = Math.floor((l + _ - 7 * p + 114) / 31), f = (l + _ - 7 * p + 114) % 31 + 1, h = Date.UTC(e, g - 1, f + t), $ = Date.UTC(e, 0, 1);
  return [Math.ceil((h - $) / (1e3 * 60 * 60 * 24))];
}
var tal = (
  /** @class */
  function() {
    function e(t) {
      this.options = t;
    }
    return e.prototype.rebuild = function(t, n) {
      var o = this.options;
      if (t !== this.lastyear && (this.yearinfo = Xil(t, o)), Vs(o.bynweekday) && (n !== this.lastmonth || t !== this.lastyear)) {
        var r = this.yearinfo, i = r.yearlen, a = r.mrange, s = r.wdaymask;
        this.monthinfo = Qil(t, n, i, a, s, o);
      }
      ts(o.byeaster) && (this.eastermask = eal(t, o.byeaster));
    }, Object.defineProperty(e.prototype, "lastyear", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastyear : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastmonth", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastmonth : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "yearlen", {
      get: function() {
        return this.yearinfo.yearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "yearordinal", {
      get: function() {
        return this.yearinfo.yearordinal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "mrange", {
      get: function() {
        return this.yearinfo.mrange;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "wdaymask", {
      get: function() {
        return this.yearinfo.wdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "mmask", {
      get: function() {
        return this.yearinfo.mmask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "wnomask", {
      get: function() {
        return this.yearinfo.wnomask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nwdaymask", {
      get: function() {
        return this.monthinfo ? this.monthinfo.nwdaymask : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextyearlen", {
      get: function() {
        return this.yearinfo.nextyearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "mdaymask", {
      get: function() {
        return this.yearinfo.mdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nmdaymask", {
      get: function() {
        return this.yearinfo.nmdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.ydayset = function() {
      return [nm(this.yearlen), 0, this.yearlen];
    }, e.prototype.mdayset = function(t, n) {
      for (var o = this.mrange[n - 1], r = this.mrange[n], i = Vr(null, this.yearlen), a = o; a < r; a++)
        i[a] = a;
      return [i, o, r];
    }, e.prototype.wdayset = function(t, n, o) {
      for (var r = Vr(null, this.yearlen + 7), i = kr.toOrdinal(new Date(Date.UTC(t, n - 1, o))) - this.yearordinal, a = i, s = 0; s < 7 && (r[i] = i, ++i, this.wdaymask[i] !== this.options.wkst); s++)
        ;
      return [r, a, i];
    }, e.prototype.ddayset = function(t, n, o) {
      var r = Vr(null, this.yearlen), i = kr.toOrdinal(new Date(Date.UTC(t, n - 1, o))) - this.yearordinal;
      return r[i] = i, [r, i, i + 1];
    }, e.prototype.htimeset = function(t, n, o, r) {
      var i = this, a = [];
      return this.options.byminute.forEach(function(s) {
        a = a.concat(i.mtimeset(t, s, o, r));
      }), kr.sort(a), a;
    }, e.prototype.mtimeset = function(t, n, o, r) {
      var i = this.options.bysecond.map(function(a) {
        return new ZC(t, n, a, r);
      });
      return kr.sort(i), i;
    }, e.prototype.stimeset = function(t, n, o, r) {
      return [new ZC(t, n, o, r)];
    }, e.prototype.getdayset = function(t) {
      switch (t) {
        case Ur.YEARLY:
          return this.ydayset.bind(this);
        case Ur.MONTHLY:
          return this.mdayset.bind(this);
        case Ur.WEEKLY:
          return this.wdayset.bind(this);
        case Ur.DAILY:
          return this.ddayset.bind(this);
        default:
          return this.ddayset.bind(this);
      }
    }, e.prototype.gettimeset = function(t) {
      switch (t) {
        case Ur.HOURLY:
          return this.htimeset.bind(this);
        case Ur.MINUTELY:
          return this.mtimeset.bind(this);
        case Ur.SECONDLY:
          return this.stimeset.bind(this);
      }
    }, e;
  }()
);
function nal(e, t, n, o, r, i) {
  for (var a = [], s = 0; s < e.length; s++) {
    var c = void 0, l = void 0, u = e[s];
    u < 0 ? (c = Math.floor(u / t.length), l = Cd(u, t.length)) : (c = Math.floor((u - 1) / t.length), l = Cd(u - 1, t.length));
    for (var d = [], _ = n; _ < o; _++) {
      var p = i[_];
      ts(p) && d.push(p);
    }
    var g = void 0;
    c < 0 ? g = d.slice(c)[0] : g = d[c];
    var f = t[l], h = kr.fromOrdinal(r.yearordinal + g), $ = kr.combine(h, f);
    Gi(a, $) || a.push($);
  }
  return kr.sort(a), a;
}
function Xge(e, t) {
  var n = t.dtstart, o = t.freq, r = t.interval, i = t.until, a = t.bysetpos, s = t.count;
  if (s === 0 || r === 0)
    return jm(e);
  var c = Iil.fromDate(n), l = new tal(t);
  l.rebuild(c.year, c.month);
  for (var u = ial(l, c, t); ; ) {
    var d = l.getdayset(o)(c.year, c.month, c.day), _ = d[0], p = d[1], g = d[2], f = ral(_, p, g, l, t);
    if (Vs(a))
      for (var h = nal(a, u, p, g, l, _), $ = 0; $ < h.length; $++) {
        var v = h[$];
        if (i && v > i)
          return jm(e);
        if (v >= n) {
          var b = BK(v, t);
          if (!e.accept(b) || s && (--s, !s))
            return jm(e);
        }
      }
    else
      for (var $ = p; $ < g; $++) {
        var y = _[$];
        if (ts(y))
          for (var w = kr.fromOrdinal(l.yearordinal + y), N = 0; N < u.length; N++) {
            var M = u[N], v = kr.combine(w, M);
            if (i && v > i)
              return jm(e);
            if (v >= n) {
              var b = BK(v, t);
              if (!e.accept(b) || s && (--s, !s))
                return jm(e);
            }
          }
      }
    if (t.interval === 0 || (c.add(t, f), c.year > kr.MAXYEAR))
      return jm(e);
    Tj(o) || (u = l.gettimeset(o)(c.hour, c.minute, c.second, 0)), l.rebuild(c.year, c.month);
  }
}
function oal(e, t, n) {
  var o = n.bymonth, r = n.byweekno, i = n.byweekday, a = n.byeaster, s = n.bymonthday, c = n.bynmonthday, l = n.byyearday;
  return Vs(o) && !Gi(o, e.mmask[t]) || Vs(r) && !e.wnomask[t] || Vs(i) && !Gi(i, e.wdaymask[t]) || Vs(e.nwdaymask) && !e.nwdaymask[t] || a !== null && !Gi(e.eastermask, t) || (Vs(s) || Vs(c)) && !Gi(s, e.mdaymask[t]) && !Gi(c, e.nmdaymask[t]) || Vs(l) && (t < e.yearlen && !Gi(l, t + 1) && !Gi(l, -e.yearlen + t) || t >= e.yearlen && !Gi(l, t + 1 - e.yearlen) && !Gi(l, -e.nextyearlen + t - e.yearlen));
}
function BK(e, t) {
  return new JC(e, t.tzid).rezonedDate();
}
function jm(e) {
  return e.getValue();
}
function ral(e, t, n, o, r) {
  for (var i = !1, a = t; a < n; a++) {
    var s = e[a];
    i = oal(o, s, r), i && (e[s] = null);
  }
  return i;
}
function ial(e, t, n) {
  var o = n.freq, r = n.byhour, i = n.byminute, a = n.bysecond;
  return Tj(o) ? Nil(n) : o >= Lo.HOURLY && Vs(r) && !Gi(r, t.hour) || o >= Lo.MINUTELY && Vs(i) && !Gi(i, t.minute) || o >= Lo.SECONDLY && Vs(a) && !Gi(a, t.second) ? [] : e.gettimeset(o)(t.hour, t.minute, t.second, t.millisecond);
}
var C_ = {
  MO: new pl(0),
  TU: new pl(1),
  WE: new pl(2),
  TH: new pl(3),
  FR: new pl(4),
  SA: new pl(5),
  SU: new pl(6)
}, Aj = {
  freq: Ur.YEARLY,
  dtstart: null,
  interval: 1,
  wkst: C_.MO,
  count: null,
  until: null,
  tzid: null,
  bysetpos: null,
  bymonth: null,
  bymonthday: null,
  bynmonthday: null,
  byyearday: null,
  byweekno: null,
  byweekday: null,
  bynweekday: null,
  byhour: null,
  byminute: null,
  bysecond: null,
  byeaster: null
}, aal = Object.keys(Aj), Lo = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = {}), n === void 0 && (n = !1), this._cache = n ? null : new Mil(), this.origOptions = Zge(t);
      var o = Oil(t).parsedOptions;
      this.options = o;
    }
    return e.parseText = function(t, n) {
      return Kge(t, n);
    }, e.fromText = function(t, n) {
      return Cil(t, n);
    }, e.fromString = function(t) {
      return new e(e.parseString(t) || void 0);
    }, e.prototype._iter = function(t) {
      return Xge(t, this.options);
    }, e.prototype._cacheGet = function(t, n) {
      return this._cache ? this._cache._cacheGet(t, n) : !1;
    }, e.prototype._cacheAdd = function(t, n, o) {
      if (this._cache)
        return this._cache._cacheAdd(t, n, o);
    }, e.prototype.all = function(t) {
      if (t)
        return this._iter(new MK("all", {}, t));
      var n = this._cacheGet("all");
      return n === !1 && (n = this._iter(new Ob("all", {})), this._cacheAdd("all", n)), n;
    }, e.prototype.between = function(t, n, o, r) {
      if (o === void 0 && (o = !1), !kr.isValidDate(t) || !kr.isValidDate(n))
        throw new Error("Invalid date passed in to RRule.between");
      var i = {
        before: n,
        after: t,
        inc: o
      };
      if (r)
        return this._iter(new MK("between", i, r));
      var a = this._cacheGet("between", i);
      return a === !1 && (a = this._iter(new Ob("between", i)), this._cacheAdd("between", a, i)), a;
    }, e.prototype.before = function(t, n) {
      if (n === void 0 && (n = !1), !kr.isValidDate(t))
        throw new Error("Invalid date passed in to RRule.before");
      var o = { dt: t, inc: n }, r = this._cacheGet("before", o);
      return r === !1 && (r = this._iter(new Ob("before", o)), this._cacheAdd("before", r, o)), r;
    }, e.prototype.after = function(t, n) {
      if (n === void 0 && (n = !1), !kr.isValidDate(t))
        throw new Error("Invalid date passed in to RRule.after");
      var o = { dt: t, inc: n }, r = this._cacheGet("after", o);
      return r === !1 && (r = this._iter(new Ob("after", o)), this._cacheAdd("after", r, o)), r;
    }, e.prototype.count = function() {
      return this.all().length;
    }, e.prototype.toString = function() {
      return F5(this.origOptions);
    }, e.prototype.toText = function(t, n, o) {
      return Til(this, t, n, o);
    }, e.prototype.isFullyConvertibleToText = function() {
      return Ail(this);
    }, e.prototype.clone = function() {
      return new e(this.origOptions);
    }, e.FREQUENCIES = [
      "YEARLY",
      "MONTHLY",
      "WEEKLY",
      "DAILY",
      "HOURLY",
      "MINUTELY",
      "SECONDLY"
    ], e.YEARLY = Ur.YEARLY, e.MONTHLY = Ur.MONTHLY, e.WEEKLY = Ur.WEEKLY, e.DAILY = Ur.DAILY, e.HOURLY = Ur.HOURLY, e.MINUTELY = Ur.MINUTELY, e.SECONDLY = Ur.SECONDLY, e.MO = C_.MO, e.TU = C_.TU, e.WE = C_.WE, e.TH = C_.TH, e.FR = C_.FR, e.SA = C_.SA, e.SU = C_.SU, e.parseString = M5, e.optionsToString = F5, e;
  }()
);
function sal(e, t, n, o, r, i) {
  var a = {}, s = e.accept;
  function c(_, p) {
    n.forEach(function(g) {
      g.between(_, p, !0).forEach(function(f) {
        a[Number(f)] = !0;
      });
    });
  }
  r.forEach(function(_) {
    var p = new JC(_, i).rezonedDate();
    a[Number(p)] = !0;
  }), e.accept = function(_) {
    var p = Number(_);
    return isNaN(p) ? s.call(this, _) : !a[p] && (c(new Date(p - 1), new Date(p + 1)), !a[p]) ? (a[p] = !0, s.call(this, _)) : !0;
  }, e.method === "between" && (c(e.args.after, e.args.before), e.accept = function(_) {
    var p = Number(_);
    return a[p] ? !0 : (a[p] = !0, s.call(this, _));
  });
  for (var l = 0; l < o.length; l++) {
    var u = new JC(o[l], i).rezonedDate();
    if (!e.accept(new Date(u.getTime())))
      break;
  }
  t.forEach(function(_) {
    Xge(e, _.options);
  });
  var d = e._result;
  switch (kr.sort(d), e.method) {
    case "all":
    case "between":
      return d;
    case "before":
      return d.length && d[d.length - 1] || null;
    case "after":
    default:
      return d.length && d[0] || null;
  }
}
var UK = {
  dtstart: null,
  cache: !1,
  unfold: !1,
  forceset: !1,
  compatible: !1,
  tzid: null
};
function cal(e, t) {
  var n = [], o = [], r = [], i = [], a = XC(e), s = a.dtstart, c = a.tzid, l = pal(e, t.unfold);
  return l.forEach(function(u) {
    var d;
    if (u) {
      var _ = _al(u), p = _.name, g = _.parms, f = _.value;
      switch (p.toUpperCase()) {
        case "RRULE":
          if (g.length)
            throw new Error("unsupported RRULE parm: ".concat(g.join(",")));
          n.push(M5(u));
          break;
        case "RDATE":
          var h = (d = /RDATE(?:;TZID=([^:=]+))?/i.exec(u)) !== null && d !== void 0 ? d : [], $ = h[1];
          $ && !c && (c = $), o = o.concat(WK(f, g));
          break;
        case "EXRULE":
          if (g.length)
            throw new Error("unsupported EXRULE parm: ".concat(g.join(",")));
          r.push(M5(f));
          break;
        case "EXDATE":
          i = i.concat(WK(f, g));
          break;
        case "DTSTART":
          break;
        default:
          throw new Error("unsupported property: " + p);
      }
    }
  }), {
    dtstart: s,
    tzid: c,
    rrulevals: n,
    rdatevals: o,
    exrulevals: r,
    exdatevals: i
  };
}
function lal(e, t) {
  var n = cal(e, t), o = n.rrulevals, r = n.rdatevals, i = n.exrulevals, a = n.exdatevals, s = n.dtstart, c = n.tzid, l = t.cache === !1;
  if (t.compatible && (t.forceset = !0, t.unfold = !0), t.forceset || o.length > 1 || r.length || i.length || a.length) {
    var u = new fal(l);
    return u.dtstart(s), u.tzid(c || void 0), o.forEach(function(_) {
      u.rrule(new Lo(Yz(_, s, c), l));
    }), r.forEach(function(_) {
      u.rdate(_);
    }), i.forEach(function(_) {
      u.exrule(new Lo(Yz(_, s, c), l));
    }), a.forEach(function(_) {
      u.exdate(_);
    }), t.compatible && t.dtstart && u.rdate(s), u;
  }
  var d = o[0] || {};
  return new Lo(Yz(d, d.dtstart || t.dtstart || s, d.tzid || t.tzid || c), l);
}
function GK(e, t) {
  return t === void 0 && (t = {}), lal(e, ual(t));
}
function Yz(e, t, n) {
  return Vu(Vu({}, e), { dtstart: t, tzid: n });
}
function ual(e) {
  var t = [], n = Object.keys(e), o = Object.keys(UK);
  if (n.forEach(function(r) {
    Gi(o, r) || t.push(r);
  }), t.length)
    throw new Error("Invalid options: " + t.join(", "));
  return Vu(Vu({}, UK), e);
}
function dal(e) {
  if (e.indexOf(":") === -1)
    return {
      name: "RRULE",
      value: e
    };
  var t = kil(e, ":", 1), n = t[0], o = t[1];
  return {
    name: n,
    value: o
  };
}
function _al(e) {
  var t = dal(e), n = t.name, o = t.value, r = n.split(";");
  if (!r)
    throw new Error("empty property name");
  return {
    name: r[0].toUpperCase(),
    parms: r.slice(1),
    value: o
  };
}
function pal(e, t) {
  if (t === void 0 && (t = !1), e = e && e.trim(), !e)
    throw new Error("Invalid empty string");
  if (!t)
    return e.split(/\s/);
  for (var n = e.split(`
`), o = 0; o < n.length; ) {
    var r = n[o] = n[o].replace(/\s+$/g, "");
    r ? o > 0 && r[0] === " " ? (n[o - 1] += r.slice(1), n.splice(o, 1)) : o += 1 : n.splice(o, 1);
  }
  return n;
}
function mal(e) {
  e.forEach(function(t) {
    if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(t))
      throw new Error("unsupported RDATE/EXDATE parm: " + t);
  });
}
function WK(e, t) {
  return mal(t), e.split(",").map(function(n) {
    return kr.untilStringToDate(n);
  });
}
function HK(e) {
  var t = this;
  return function(n) {
    if (n !== void 0 && (t["_".concat(e)] = n), t["_".concat(e)] !== void 0)
      return t["_".concat(e)];
    for (var o = 0; o < t._rrule.length; o++) {
      var r = t._rrule[o].origOptions[e];
      if (r)
        return r;
    }
  };
}
var fal = (
  /** @class */
  function(e) {
    Cj(t, e);
    function t(n) {
      n === void 0 && (n = !1);
      var o = e.call(this, {}, n) || this;
      return o.dtstart = HK.apply(o, ["dtstart"]), o.tzid = HK.apply(o, ["tzid"]), o._rrule = [], o._rdate = [], o._exrule = [], o._exdate = [], o;
    }
    return t.prototype._iter = function(n) {
      return sal(n, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    }, t.prototype.rrule = function(n) {
      YK(n, this._rrule);
    }, t.prototype.exrule = function(n) {
      YK(n, this._exrule);
    }, t.prototype.rdate = function(n) {
      KK(n, this._rdate);
    }, t.prototype.exdate = function(n) {
      KK(n, this._exdate);
    }, t.prototype.rrules = function() {
      return this._rrule.map(function(n) {
        return GK(n.toString());
      });
    }, t.prototype.exrules = function() {
      return this._exrule.map(function(n) {
        return GK(n.toString());
      });
    }, t.prototype.rdates = function() {
      return this._rdate.map(function(n) {
        return new Date(n.getTime());
      });
    }, t.prototype.exdates = function() {
      return this._exdate.map(function(n) {
        return new Date(n.getTime());
      });
    }, t.prototype.valueOf = function() {
      var n = [];
      return !this._rrule.length && this._dtstart && (n = n.concat(F5({ dtstart: this._dtstart }))), this._rrule.forEach(function(o) {
        n = n.concat(o.toString().split(`
`));
      }), this._exrule.forEach(function(o) {
        n = n.concat(o.toString().split(`
`).map(function(r) {
          return r.replace(/^RRULE:/, "EXRULE:");
        }).filter(function(r) {
          return !/^DTSTART/.test(r);
        }));
      }), this._rdate.length && n.push(ZK("RDATE", this._rdate, this.tzid())), this._exdate.length && n.push(ZK("EXDATE", this._exdate, this.tzid())), n;
    }, t.prototype.toString = function() {
      return this.valueOf().join(`
`);
    }, t.prototype.clone = function() {
      var n = new t(!!this._cache);
      return this._rrule.forEach(function(o) {
        return n.rrule(o.clone());
      }), this._exrule.forEach(function(o) {
        return n.exrule(o.clone());
      }), this._rdate.forEach(function(o) {
        return n.rdate(new Date(o.getTime()));
      }), this._exdate.forEach(function(o) {
        return n.exdate(new Date(o.getTime()));
      }), n;
    }, t;
  }(Lo)
);
function YK(e, t) {
  if (!(e instanceof Lo))
    throw new TypeError(String(e) + " is not RRule instance");
  Gi(t.map(String), String(e)) || t.push(e);
}
function KK(e, t) {
  if (!(e instanceof Date))
    throw new TypeError(String(e) + " is not Date instance");
  Gi(t.map(Number), Number(e)) || (t.push(e), kr.sort(t));
}
function ZK(e, t, n) {
  var o = !n || n.toUpperCase() === "UTC", r = o ? "".concat(e, ":") : "".concat(e, ";TZID=").concat(n, ":"), i = t.map(function(a) {
    return kr.timeToUntilString(a.valueOf(), o);
  }).join(",");
  return "".concat(r).concat(i);
}
const Jge = "timeOption.is24hClock";
var bv = /* @__PURE__ */ ((e) => (e.TWELVE_HOUR = "h:mma", e.TWENTY_FOUR_HOUR = "HH:mm", e))(bv || {});
const q5 = (e) => vr.setItem(Jge, e.toString()), gal = () => {
  const e = vr.getItem(Jge);
  return e === null ? null : e === "true";
}, Qge = () => {
  const e = gal();
  return e === !0 ? !0 : e === !1 ? !1 : new Intl.DateTimeFormat(void 0, { hour: "numeric" }).format(0).match(/M/i) ? (q5(!1), !1) : (q5(!0), !0);
}, ehe = Qge() ? "HH:mm" : "h:mma", hal = /^(.*)([+-])(\d{2}):(\d{2})|(Z)$/;
function val(e, t, n, o) {
  if (typeof e != "string")
    return ht(e, t, n, o);
  const r = e.match(hal);
  if (r === null)
    return;
  if (r[0] === "Z")
    return ht(
      e,
      {
        utc: !0,
        ...typeof t == "string" ? { format: t } : { ...t }
      },
      n,
      o
    );
  const [, i, a, s, c] = r, l = parseInt(s) * 60 + parseInt(c, 10), u = a === "+" ? l : -l;
  return ht(
    i,
    {
      $offset: u,
      ...typeof t == "string" ? { format: t } : { ...t }
    },
    n,
    o
  );
}
const bal = (e, t, n, o) => {
  const r = val(e);
  return r != null && r.isValid() ? `${r == null ? void 0 : r.format(
    o != null && o.withDefaultTimeFormat ? bv.TWELVE_HOUR : (o == null ? void 0 : o.selectedTimeFormat) || ehe
  )}, ${ht(e).toDate().toLocaleString(t, { dateStyle: "full", timeZone: n })}` : "Invalid date";
}, the = ({
  startDate: e,
  timeZone: t,
  recurringEvent: n,
  recurringCount: o,
  selectedTimeFormat: r,
  withDefaultTimeFormat: i
}, a) => {
  const { count: s, ...c } = n || {}, l = new Lo({
    ...c,
    count: o,
    dtstart: new Date(ht(e).valueOf())
  }), u = ht(e).utcOffset(), d = l.all().map((p) => ht.utc(p).add(u - ht(p).utcOffset(), "minute"));
  return [d.map((p) => bal(p.tz(t), a, t, { selectedTimeFormat: r, withDefaultTimeFormat: i })), d.map((p) => p.toDate())];
}, yal = ({
  t: e,
  recurringEvent: t
}) => t.interval && t.freq >= 0 ? e("every_for_freq", {
  freq: `${t.interval > 1 ? t.interval : ""} ${e(
    jb[t.freq].toString().toLowerCase(),
    {
      count: t.interval
    }
  )}`
}) : "", XK = "timeOption.preferredTimeZone", $al = dF((e) => ({
  timeFormat: ehe,
  setTimeFormat: (t) => {
    q5(t === bv.TWENTY_FOUR_HOUR), e({ timeFormat: t });
  },
  timezone: vr.getItem(XK) || zy,
  setTimezone: (t) => {
    vr.setItem(XK, t), e({ timezone: t });
  }
})), Mg = $al, wal = ({
  storeTimezone: e,
  bookerUserPreferredTimezone: t
}) => e ?? t, Ku = () => {
  const [e] = _n((r) => [r.timezone], Xi), { timezone: t, timeFormat: n } = Mg();
  return {
    timezone: wal({
      storeTimezone: e,
      bookerUserPreferredTimezone: t
    }),
    timeFormat: n,
    timezoneFromBookerStore: e,
    timezoneFromTimePreferences: t
  };
}, kal = ({ event: e }) => {
  var g;
  const t = ((g = e.recurringEvent) == null ? void 0 : g.count) || null, { t: n, i18n: o } = kt(), [r, i, a, s] = _n((f) => [
    f.setRecurringEventCount,
    f.recurringEventCount,
    f.setOccurenceCount,
    f.occurenceCount
  ]), c = _n((f) => f.selectedTimeslot), l = _n((f) => f.state), { timezone: u, timeFormat: d } = Ku(), [_, p] = it(!1);
  if (yt(() => {
    var f;
    (f = e.recurringEvent) != null && f.count && (a(s || e.recurringEvent.count), r(i || e.recurringEvent.count), s && (s > e.recurringEvent.count || s < 1) && p(!0));
  }, [r, e.recurringEvent, i, a, s]), !e.recurringEvent)
    return null;
  if (l === "booking" && i && c) {
    const [f] = the(
      {
        startDate: c,
        timeZone: u,
        recurringEvent: e.recurringEvent,
        recurringCount: i,
        selectedTimeFormat: d
      },
      o.language
    );
    return /* @__PURE__ */ de("div", { "data-testid": "recurring-dates", children: [
      f.slice(0, 5).map((h, $) => /* @__PURE__ */ m("p", { children: h }, $)),
      f.length > 5 && /* @__PURE__ */ m(
        Sr,
        {
          content: f.slice(5).map((h, $) => /* @__PURE__ */ m("p", { children: h }, $)),
          children: /* @__PURE__ */ de("p", { className: " text-sm", children: [
            "+ ",
            n("plus_more", { count: f.length - 5 })
          ] })
        }
      )
    ] });
  }
  return /* @__PURE__ */ de(nt, { children: [
    yal({ t: n, recurringEvent: e.recurringEvent }),
    /* @__PURE__ */ m("br", {}),
    /* @__PURE__ */ m(
      Iu,
      {
        className: "my-1 mr-3 inline-flex h-[26px] w-[46px] px-1 py-0",
        type: "number",
        min: "1",
        max: e.recurringEvent.count,
        defaultValue: s || e.recurringEvent.count,
        "data-testid": "occurrence-input",
        onChange: (f) => {
          const h = /^(?=.*[0-9])\S+$/, $ = parseInt(f.target.value);
          a($), !h.test(f.target.value) || $ < 1 || t && $ > t ? (p(!0), r(t)) : (p(!1), r($));
        }
      }
    ),
    n("occurrence", {
      count: i || e.recurringEvent.count
    }),
    _ && /* @__PURE__ */ m("div", { className: "-ml-4 mr-4 mt-2 flex", children: /* @__PURE__ */ m(Us, { severity: "warning", title: n("enter_number_between_range", { maxOccurences: t }) }) })
  ] });
}, nhe = [
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "JPY",
  "KMF",
  "KRW",
  "MGA",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF"
], psu = (e, t) => nhe.includes(t.toUpperCase()) ? e : Math.round(e * 100), Sal = (e, t) => nhe.includes(t.toUpperCase()) ? e : e / 100, ohe = (e) => {
  try {
    const o = Intl.NumberFormat("en", { style: "currency", currency: e }).formatToParts(1).find((r) => r.type === "currency");
    return (o == null ? void 0 : o.value) || "$";
  } catch {
    return console.warn(`Failed to get currency symbol for ${e}, falling back to $`), "$";
  }
}, Eal = (e, t, n = "en") => {
  switch (t) {
    case "BTC":
      return `${e} sats`;
    default:
      return t = (t == null ? void 0 : t.toUpperCase()) || "USD", `${Intl.NumberFormat(n, {
        style: "currency",
        currency: t
      }).format(Sal(e, t))}`;
  }
}, xal = co(
  () => import("./AlbyPriceComponent-QeW9E7Mu.js").then((e) => e.AlbyPriceComponent),
  {
    ssr: !1
  }
), rhe = ({ price: e, currency: t, displayAlternateSymbol: n = !0 }) => {
  if (e === 0)
    return null;
  const o = Eal(e, t);
  return t !== "BTC" ? /* @__PURE__ */ m(nt, { children: o }) : /* @__PURE__ */ m(
    xal,
    {
      displaySymbol: n,
      price: e,
      formattedPrice: o
    }
  );
}, Cal = [
  I_.REQUIRES_CONFIRMATION,
  I_.DURATION,
  I_.OCCURENCES,
  I_.LOCATION,
  I_.PRICE
], Lp = ({
  customIcon: e,
  icon: t,
  iconUrl: n,
  children: o,
  highlight: r,
  contentClassName: i,
  className: a,
  isDark: s,
  ...c
}) => Fe.Children.count(o) ? /* @__PURE__ */ de(
  "div",
  {
    className: xe(
      "flex items-start justify-start text-sm",
      r ? "text-emphasis" : "text-text",
      a
    ),
    ...c,
    children: [
      n ? /* @__PURE__ */ m(
        "img",
        {
          src: n,
          alt: "",
          className: xe(
            "mr-2 mt-[2px] h-4 w-4 flex-shrink-0",
            s === void 0 && "[filter:invert(0.5)_brightness(0.5)]",
            (s === void 0 || s) && "dark:[filter:invert(0.65)_brightness(0.9)]"
          )
        }
      ) : /* @__PURE__ */ m(nt, { children: e || !!t && /* @__PURE__ */ m(qt, { name: t, className: "relative z-20 mr-2 mt-[2px] h-4 w-4 flex-shrink-0 rtl:ml-2" }) }),
      /* @__PURE__ */ m("div", { className: xe("relative z-10 max-w-full break-words", i), children: o })
    ]
  }
) : null, Tal = ({ event: e, blocks: t = Cal }) => {
  const { t: n } = kt(), o = Fu((i) => i.rescheduleUid), r = Fu((i) => i.isInstantMeeting);
  return /* @__PURE__ */ m(nt, { children: t.map((i) => {
    var a;
    if (typeof i == "function")
      return /* @__PURE__ */ m(Ha, { children: i(e) }, i.name);
    switch (i) {
      case I_.DURATION:
        return /* @__PURE__ */ m(Lp, { icon: "clock", className: "items-center", children: /* @__PURE__ */ m($il, { event: e }) }, i);
      case I_.LOCATION:
        return !((a = e == null ? void 0 : e.locations) != null && a.length) || r ? null : /* @__PURE__ */ m(Lp, { children: /* @__PURE__ */ m(pil, { locations: e.locations }) }, i);
      case I_.REQUIRES_CONFIRMATION:
        return e.requiresConfirmation ? /* @__PURE__ */ m(Lp, { icon: "square-check", children: n("requires_confirmation") }, i) : null;
      case I_.OCCURENCES:
        return !e.recurringEvent || o ? null : /* @__PURE__ */ m(Lp, { icon: "refresh-ccw", children: /* @__PURE__ */ m(kal, { event: e }) }, i);
      case I_.PRICE:
        const s = Lg(e);
        return e.price <= 0 || s.price <= 0 ? null : /* @__PURE__ */ m(
          Lp,
          {
            customIcon: /* @__PURE__ */ m(
              Qrl,
              {
                className: "relative z-20 mr-2 mt-[2px] h-4 w-4 flex-shrink-0 rtl:ml-2",
                currency: e.currency
              }
            ),
            children: /* @__PURE__ */ m(
              rhe,
              {
                price: s.price,
                currency: e.currency,
                displayAlternateSymbol: !1
              }
            )
          },
          i
        );
    }
  }) });
}, Aal = ({ children: e, as: t, className: n }) => /* @__PURE__ */ m(t || "h1", { "data-testid": "event-title", className: xe("text-text text-xl font-semibold", n), children: e }), Ial = () => /* @__PURE__ */ de("div", { className: "flex flex-col", children: [
  /* @__PURE__ */ m(Yo, { className: "h-6 w-6 rounded-full" }),
  /* @__PURE__ */ m(Yo, { className: "mt-2 h-5 w-32" }),
  /* @__PURE__ */ m(Yo, { className: "mt-2 h-8 w-48" }),
  /* @__PURE__ */ m("div", { className: "mt-8", children: Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ de("div", { className: "mb-2 flex flex-row items-center", children: [
    /* @__PURE__ */ m(Yo, { className: "mr-3 h-5 w-5 rounded-full" }),
    /* @__PURE__ */ m(Yo, { className: xe("h-6", t > 1 ? "w-24" : "w-32") })
  ] }, t)) })
] }), Oal = ({
  schedulingType: e,
  users: t,
  profile: n,
  entity: o,
  isPrivateLink: r,
  roundRobinHideOrgAndTeam: i
}) => {
  const a = Fu((g) => g.username), s = !!(a && a.indexOf("+") > -1), c = tm(), l = Kr(), d = e !== Bs.ROUND_ROBIN ? t : [], _ = n.name && e === Bs.ROUND_ROBIN || !t.length || n.name !== t[0].name && e === Bs.COLLECTIVE;
  if (e === Bs.ROUND_ROBIN && i)
    return /* @__PURE__ */ m("div", { className: "h-6" });
  const p = s || !n.image && !o.logoUrl || !o.teamSlug ? [] : [
    {
      // We don't want booker to be able to see the list of other users or teams inside the embed
      href: c || l || r || o.hideProfileLink ? null : o.teamSlug ? uZc({ orgSlug: o.orgSlug, teamSlug: o.teamSlug }) : Ry(o.orgSlug),
      image: o.logoUrl ?? n.image ?? "",
      alt: o.name ?? n.name ?? "",
      title: o.name ?? n.name ?? ""
    }
  ];
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Nme,
      {
        size: "sm",
        className: "border-muted",
        items: [
          ...p,
          ...d.map((g) => {
            var f, h, $;
            return {
              href: l || r || o.hideProfileLink ? null : `${Ry(((h = (f = g.profile) == null ? void 0 : f.organization) == null ? void 0 : h.slug) ?? null)}/${($ = g.profile) == null ? void 0 : $.username}?redirect=false`,
              alt: g.name || "",
              title: g.name || "",
              image: Ome(g)
            };
          })
        ]
      }
    ),
    /* @__PURE__ */ m("p", { className: "text-subtle mt-2 text-sm font-semibold", children: _ ? n.name : d.map((g) => g.name).filter((g) => g).join(", ") })
  ] });
};
function Nal(e) {
  const { className: t, currency: n } = e;
  return /* @__PURE__ */ m(qt, { name: n !== "BTC" ? "credit-card" : "zap", className: t });
}
const JK = globalThis != null && globalThis.document ? lc : () => {
}, ihe = "Popper", [ahe, she] = jc(ihe), [zal, che] = ahe(ihe), Ral = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = it(null);
  return /* @__PURE__ */ pt(zal, {
    scope: t,
    anchor: o,
    onAnchorChange: r
  }, n);
}, Pal = "PopperAnchor", Dal = /* @__PURE__ */ Bt((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = che(Pal, n), a = xt(null), s = ni(t, a);
  return yt(() => {
    i.onAnchorChange((o == null ? void 0 : o.current) || a.current);
  }), o ? null : /* @__PURE__ */ pt(nr.div, Tt({}, r, {
    ref: s
  }));
}), lhe = "PopperContent", [Lal, msu] = ahe(lhe), Mal = /* @__PURE__ */ Bt((e, t) => {
  var n, o, r, i, a, s, c, l;
  const { __scopePopper: u, side: d = "bottom", sideOffset: _ = 0, align: p = "center", alignOffset: g = 0, arrowPadding: f = 0, avoidCollisions: h = !0, collisionBoundary: $ = [], collisionPadding: v = 0, sticky: b = "partial", hideWhenDetached: y = !1, updatePositionStrategy: w = "optimized", onPlaced: N, ...M } = e, q = che(lhe, u), [L, R] = it(null), T = ni(
    t,
    (Q) => R(Q)
  ), [D, A] = it(null), S = CT(D), E = (n = S == null ? void 0 : S.width) !== null && n !== void 0 ? n : 0, x = (o = S == null ? void 0 : S.height) !== null && o !== void 0 ? o : 0, k = d + (p !== "center" ? "-" + p : ""), I = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, z = Array.isArray($) ? $ : [
    $
  ], F = z.length > 0, P = {
    padding: I,
    boundary: z.filter(Fal),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: F
  }, { refs: O, floatingStyles: V, placement: U, isPositioned: H, middlewareData: J } = Sie({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: k,
    whileElementsMounted: (...Q) => $ie(...Q, {
      animationFrame: w === "always"
    }),
    elements: {
      reference: q.anchor
    },
    middleware: [
      cie({
        mainAxis: _ + x,
        alignmentAxis: g
      }),
      h && uie({
        mainAxis: !0,
        crossAxis: !1,
        limiter: b === "partial" ? die() : void 0,
        ...P
      }),
      h && aie({
        ...P
      }),
      _ie({
        ...P,
        apply: ({ elements: Q, rects: me, availableWidth: ne, availableHeight: pe }) => {
          const { width: ge, height: ve } = me.reference, Te = Q.floating.style;
          Te.setProperty("--radix-popper-available-width", `${ne}px`), Te.setProperty("--radix-popper-available-height", `${pe}px`), Te.setProperty("--radix-popper-anchor-width", `${ge}px`), Te.setProperty("--radix-popper-anchor-height", `${ve}px`);
        }
      }),
      D && wie({
        element: D,
        padding: f
      }),
      qal({
        arrowWidth: E,
        arrowHeight: x
      }),
      y && sie({
        strategy: "referenceHidden",
        ...P
      })
    ]
  }), [le, ae] = uhe(U), Y = ws(N);
  JK(() => {
    H && (Y == null || Y());
  }, [
    H,
    Y
  ]);
  const re = (r = J.arrow) === null || r === void 0 ? void 0 : r.x, ie = (i = J.arrow) === null || i === void 0 ? void 0 : i.y, _e = ((a = J.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [he, be] = it();
  return JK(() => {
    L && be(window.getComputedStyle(L).zIndex);
  }, [
    L
  ]), /* @__PURE__ */ pt("div", {
    ref: O.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...V,
      transform: H ? V.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: he,
      "--radix-popper-transform-origin": [
        (s = J.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = J.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ pt(Lal, {
    scope: u,
    placedSide: le,
    onArrowChange: A,
    arrowX: re,
    arrowY: ie,
    shouldHideArrow: _e
  }, /* @__PURE__ */ pt(nr.div, Tt({
    "data-side": le,
    "data-align": ae
  }, M, {
    ref: T,
    style: {
      ...M.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: H ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = J.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function Fal(e) {
  return e !== null;
}
const qal = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, o, r, i, a;
    const { placement: s, rects: c, middlewareData: l } = t, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, _ = d ? 0 : e.arrowWidth, p = d ? 0 : e.arrowHeight, [g, f] = uhe(s), h = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[f], $ = ((o = (r = l.arrow) === null || r === void 0 ? void 0 : r.x) !== null && o !== void 0 ? o : 0) + _ / 2, v = ((i = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let b = "", y = "";
    return g === "bottom" ? (b = d ? h : `${$}px`, y = `${-p}px`) : g === "top" ? (b = d ? h : `${$}px`, y = `${c.floating.height + p}px`) : g === "right" ? (b = `${-p}px`, y = d ? h : `${v}px`) : g === "left" && (b = `${c.floating.width + p}px`, y = d ? h : `${v}px`), {
      data: {
        x: b,
        y
      }
    };
  }
});
function uhe(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const jal = Ral, Val = Dal, Bal = Mal, Ual = /* @__PURE__ */ Bt((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ $v.createPortal(/* @__PURE__ */ pt(nr.div, Tt({}, r, {
    ref: t
  })), o) : null;
}), j5 = "dismissableLayer.update", Gal = "dismissableLayer.pointerDownOutside", Wal = "dismissableLayer.focusOutside";
let QK;
const Hal = /* @__PURE__ */ Cr({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Yal = /* @__PURE__ */ Bt((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, u = bo(Hal), [d, _] = it(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = it({}), f = ni(
    t,
    (q) => _(q)
  ), h = Array.from(u.layers), [$] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = h.indexOf($), b = d ? h.indexOf(d) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, w = b >= v, N = Kal((q) => {
    const L = q.target, R = [
      ...u.branches
    ].some(
      (T) => T.contains(L)
    );
    !w || R || (i == null || i(q), s == null || s(q), q.defaultPrevented || c == null || c());
  }, p), M = Zal((q) => {
    const L = q.target;
    [
      ...u.branches
    ].some(
      (T) => T.contains(L)
    ) || (a == null || a(q), s == null || s(q), q.defaultPrevented || c == null || c());
  }, p);
  return I6((q) => {
    b === u.layers.size - 1 && (r == null || r(q), !q.defaultPrevented && c && (q.preventDefault(), c()));
  }, p), yt(() => {
    if (d)
      return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (QK = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), eZ(), () => {
        o && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = QK);
      };
  }, [
    d,
    p,
    o,
    u
  ]), yt(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), eZ());
  }, [
    d,
    u
  ]), yt(() => {
    const q = () => g({});
    return document.addEventListener(j5, q), () => document.removeEventListener(j5, q);
  }, []), /* @__PURE__ */ pt(nr.div, Tt({}, l, {
    ref: f,
    style: {
      pointerEvents: y ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: jn(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: jn(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: jn(e.onPointerDownCapture, N.onPointerDownCapture)
  }));
});
function Kal(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e), o = xt(!1), r = xt(() => {
  });
  return yt(() => {
    const i = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          dhe(Gal, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Zal(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ws(e), o = xt(!1);
  return yt(() => {
    const r = (i) => {
      i.target && !o.current && dhe(Wal, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function eZ() {
  const e = new CustomEvent(j5);
  document.dispatchEvent(e);
}
function dhe(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? z0(r, i) : r.dispatchEvent(i);
}
let Kz;
const _he = "HoverCard", [phe, fsu] = jc(_he, [
  she
]), Ij = she(), [Xal, FA] = phe(_he), Jal = (e) => {
  const { __scopeHoverCard: t, children: n, open: o, defaultOpen: r, onOpenChange: i, openDelay: a = 700, closeDelay: s = 300 } = e, c = Ij(t), l = xt(0), u = xt(0), d = xt(!1), _ = xt(!1), [p = !1, g] = Uu({
    prop: o,
    defaultProp: r,
    onChange: i
  }), f = Yt(() => {
    clearTimeout(u.current), l.current = window.setTimeout(
      () => g(!0),
      a
    );
  }, [
    a,
    g
  ]), h = Yt(() => {
    clearTimeout(l.current), !d.current && !_.current && (u.current = window.setTimeout(
      () => g(!1),
      s
    ));
  }, [
    s,
    g
  ]), $ = Yt(
    () => g(!1),
    [
      g
    ]
  );
  return yt(() => () => {
    clearTimeout(l.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ pt(Xal, {
    scope: t,
    open: p,
    onOpenChange: g,
    onOpen: f,
    onClose: h,
    onDismiss: $,
    hasSelectionRef: d,
    isPointerDownOnContentRef: _
  }, /* @__PURE__ */ pt(jal, c, n));
}, Qal = "HoverCardTrigger", esl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeHoverCard: n, ...o } = e, r = FA(Qal, n), i = Ij(n);
  return /* @__PURE__ */ pt(Val, Tt({
    asChild: !0
  }, i), /* @__PURE__ */ pt(nr.a, Tt({
    "data-state": r.open ? "open" : "closed"
  }, o, {
    ref: t,
    onPointerEnter: jn(e.onPointerEnter, QC(r.onOpen)),
    onPointerLeave: jn(e.onPointerLeave, QC(r.onClose)),
    onFocus: jn(e.onFocus, r.onOpen),
    onBlur: jn(e.onBlur, r.onClose),
    onTouchStart: jn(
      e.onTouchStart,
      (a) => a.preventDefault()
    )
  })));
}), mhe = "HoverCardPortal", [tsl, nsl] = phe(mhe, {
  forceMount: void 0
}), osl = (e) => {
  const { __scopeHoverCard: t, forceMount: n, children: o, container: r } = e, i = FA(mhe, t);
  return /* @__PURE__ */ pt(tsl, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ pt(Vc, {
    present: n || i.open
  }, /* @__PURE__ */ pt(Ual, {
    asChild: !0,
    container: r
  }, o)));
}, V5 = "HoverCardContent", rsl = /* @__PURE__ */ Bt((e, t) => {
  const n = nsl(V5, e.__scopeHoverCard), { forceMount: o = n.forceMount, ...r } = e, i = FA(V5, e.__scopeHoverCard);
  return /* @__PURE__ */ pt(Vc, {
    present: o || i.open
  }, /* @__PURE__ */ pt(isl, Tt({
    "data-state": i.open ? "open" : "closed"
  }, r, {
    onPointerEnter: jn(e.onPointerEnter, QC(i.onOpen)),
    onPointerLeave: jn(e.onPointerLeave, QC(i.onClose)),
    ref: t
  })));
}), isl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeHoverCard: n, onEscapeKeyDown: o, onPointerDownOutside: r, onFocusOutside: i, onInteractOutside: a, ...s } = e, c = FA(V5, n), l = Ij(n), u = xt(null), d = ni(t, u), [_, p] = it(!1);
  return yt(() => {
    if (_) {
      const g = document.body;
      return Kz = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = Kz, g.style.webkitUserSelect = Kz;
      };
    }
  }, [
    _
  ]), yt(() => {
    if (u.current) {
      const g = () => {
        p(!1), c.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var f;
          ((f = document.getSelection()) === null || f === void 0 ? void 0 : f.toString()) !== "" && (c.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [
    c.isPointerDownOnContentRef,
    c.hasSelectionRef
  ]), yt(() => {
    u.current && asl(u.current).forEach(
      (f) => f.setAttribute("tabindex", "-1")
    );
  }), /* @__PURE__ */ pt(Yal, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onInteractOutside: a,
    onEscapeKeyDown: o,
    onPointerDownOutside: r,
    onFocusOutside: jn(i, (g) => {
      g.preventDefault();
    }),
    onDismiss: c.onDismiss
  }, /* @__PURE__ */ pt(Bal, Tt({}, l, s, {
    onPointerDown: jn(s.onPointerDown, (g) => {
      g.currentTarget.contains(g.target) && p(!0), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !0;
    }),
    ref: d,
    style: {
      ...s.style,
      userSelect: _ ? "text" : void 0,
      // Safari requires prefix
      WebkitUserSelect: _ ? "text" : void 0,
      "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
      "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
      "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
    }
  })));
});
function QC(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function asl(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
const ssl = Jal, csl = esl, lsl = osl, usl = rsl, fhe = (e) => {
  const { t } = kt(), { fromUser: n, toUser: o, emoji: r = "🏝️", borderDashed: i = !0, date: a, className: s } = e, c = Ef(), l = Nr.useRouter();
  return !n || !o ? null : /* @__PURE__ */ m("div", { className: xe("relative h-full pb-5", s), children: /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "flex h-full flex-col items-center justify-start rounded-md border bg-white px-4 py-4 font-normal dark:bg-transparent",
        i && "border-dashed"
      ),
      children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis flex h-14 w-14 flex-col items-center justify-center rounded-full", children: /* @__PURE__ */ m("span", { className: "m-auto text-center text-lg", children: r }) }),
        /* @__PURE__ */ de("div", { className: "space-y-2 text-center", children: [
          /* @__PURE__ */ m("p", { className: "mt-2 text-base font-bold", children: t("ooo_user_is_ooo", { displayName: n.displayName }) }),
          (n == null ? void 0 : n.displayName) && (o == null ? void 0 : o.displayName) && /* @__PURE__ */ m("p", { className: "text-center text-sm", children: /* @__PURE__ */ m(
            Ld,
            {
              t,
              i18nKey: "ooo_slots_returning",
              values: { displayName: o.displayName },
              components: [/* @__PURE__ */ m("strong", { children: "username" }, "username")]
            }
          ) })
        ] }),
        (o == null ? void 0 : o.id) && /* @__PURE__ */ m(
          Jt,
          {
            className: "mt-8 max-w-[90%]",
            variant: "button",
            color: "secondary",
            onClick: () => {
              const u = c.get("month"), d = c.get("layout"), _ = c.get("date") || a;
              l.push(
                `/${o.username}?${u ? `month=${u}&` : ""}date=${_}${d ? `&layout=${d}` : ""}`
              );
            },
            children: /* @__PURE__ */ m("span", { className: "block overflow-hidden text-ellipsis whitespace-nowrap", children: t("ooo_slots_book_with", { displayName: o.displayName }) })
          }
        )
      ]
    }
  ) });
}, rv = dF((e) => ({
  overlayBusyDates: void 0,
  setOverlayBusyDates: (t) => {
    e({ overlayBusyDates: t });
  },
  calendarSettingsOverlayModal: !1,
  setCalendarSettingsOverlayModal: (t) => {
    e({ calendarSettingsOverlayModal: t });
  },
  continueWithProviderModal: !1,
  setContinueWithProviderModal: (t) => {
    e({ continueWithProviderModal: t });
  }
}));
function tZ(e) {
  const t = e.getHours().toString().padStart(2, "0"), n = e.getMinutes().toString().padStart(2, "0");
  return `${t}:${n}`;
}
function dsl({
  start: e,
  selectedDuration: t,
  offset: n
}) {
  const o = rv((s) => s.overlayBusyDates);
  let r = null, i = null;
  return { isOverlapping: o && o.some((s) => {
    const c = ht(s.start), l = ht(s.end), u = ht(e.add(n, "hours")).add(t ?? 0, "minute"), d = (u.isSame(c) || u.isAfter(c)) && e.add(n, "hours") < l && u > c;
    return r = d ? tZ(c.toDate()) : null, i = d ? tZ(l.toDate()) : null, d;
  }), overlappingTimeStart: r, overlappingTimeEnd: i };
}
const ghe = ({
  showExact: e = !0,
  bookedSeats: t,
  totalSeats: n,
  variant: o = "whole"
}) => {
  const { t: r } = kt(), i = n - t, a = t / n >= 0.5, s = t / n >= 0.83;
  return /* @__PURE__ */ m("span", { className: "truncate", children: e ? `${i}${o === "fraction" ? ` / ${n}` : ""} ${r("seats_available", {
    count: i
  })}` : s ? r("seats_nearly_full") : a ? r("seats_half_full") : r("seats_available", {
    count: i
  }) });
}, _sl = ({
  slot: e,
  seatsPerTimeSlot: t,
  selectedSlots: n,
  onTimeSelect: o,
  showAvailableSeatsCount: r,
  event: i,
  customClassNames: a,
  loadingStates: s,
  renderConfirmNotVerifyEmailButtonCond: c,
  isVerificationCodeSending: l,
  skipConfirmStep: u,
  shouldRenderCaptcha: d,
  watchedCfToken: _,
  handleSlotClick: p,
  onTentativeTimeSelect: g,
  unavailableTimeSlots: f = [],
  confirmButtonDisabled: h,
  confirmStepClassNames: $
}) => {
  const { t: v } = kt(), { data: b } = i, y = vn(() => {
    if (!(b != null && b.price))
      return !1;
    const H = Lg(b);
    return (b == null ? void 0 : b.price) > 0 && !Number.isNaN(H.price) && H.price > 0;
  }, [b]), w = zc("overlayCalendar") === "true" || vr.getItem("overlayCalendarSwitchDefault"), { timeFormat: N, timezone: M } = Ku(), q = _n((H) => H.bookingData), L = _n((H) => H.layout), R = !!t, T = ht.utc(e.time).tz(M), D = !!(R && e.attendees && e.attendees >= t), A = e.attendees && t && e.attendees / t >= 0.5, E = e.attendees && t && e.attendees / t >= 0.83 ? "bg-rose-600" : A ? "bg-yellow-500" : "bg-emerald-400", x = ht(), I = (x.tz(M).utcOffset() - x.utcOffset()) / 60, z = _n((H) => H.selectedTimeslot), { isOverlapping: F, overlappingTimeEnd: P, overlappingTimeStart: O } = dsl({
    start: T,
    selectedDuration: (b == null ? void 0 : b.length) ?? 0,
    offset: I
  }), V = () => {
    p && p(e, F), g && g({
      time: e.time,
      attendees: e.attendees || 0,
      seatsPerTimeSlot: t
    });
  }, U = f.includes(e.time);
  return /* @__PURE__ */ m(fge, { children: /* @__PURE__ */ de("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ de(
      Jt,
      {
        disabled: D || !!(e.bookingUid && e.bookingUid === (q == null ? void 0 : q.uid)) || (s == null ? void 0 : s.creatingBooking) || (s == null ? void 0 : s.creatingRecurringBooking) || l || (s == null ? void 0 : s.creatingInstantBooking) || u && !!d && !_ || U,
        "data-testid": "time",
        "data-disabled": D,
        "data-time": e.time,
        onClick: V,
        className: xe(
          "hover:border-brand-default min-h-9 mb-2 flex h-auto w-full flex-grow flex-col justify-center py-2",
          (n == null ? void 0 : n.includes(e.time)) && "border-brand-default",
          `${a}`
        ),
        color: "secondary",
        children: [
          /* @__PURE__ */ de("div", { className: "flex items-center gap-2", children: [
            !R && w && /* @__PURE__ */ m(
              "span",
              {
                className: xe(
                  "inline-block h-2 w-2 rounded-full",
                  F ? "bg-rose-600" : "bg-emerald-400"
                )
              }
            ),
            T.format(N)
          ] }),
          D && /* @__PURE__ */ m("p", { className: "text-sm", children: v("booking_full") }),
          R && !D && /* @__PURE__ */ de("p", { className: "flex items-center text-sm", children: [
            /* @__PURE__ */ m(
              "span",
              {
                className: xe(E, "mr-1 inline-block h-2 w-2 rounded-full"),
                "aria-hidden": !0
              }
            ),
            /* @__PURE__ */ m(
              ghe,
              {
                showExact: !!r,
                totalSeats: t,
                bookedSeats: e.attendees || 0
              }
            )
          ] })
        ]
      },
      e.time
    ),
    !!e.showConfirmButton && /* @__PURE__ */ de(ssl, { children: [
      /* @__PURE__ */ m(csl, { asChild: !0, children: /* @__PURE__ */ m(t0.div, { initial: { width: 0 }, animate: { width: "auto" }, exit: { width: 0 }, children: /* @__PURE__ */ m(
        Jt,
        {
          variant: L === "column_view" ? "icon" : "button",
          StartIcon: L === "column_view" ? "chevron-right" : void 0,
          type: "button",
          className: $ == null ? void 0 : $.confirmButton,
          onClick: () => o && o(e.time, (e == null ? void 0 : e.attendees) || 0, t, e.bookingUid),
          "data-testid": "skip-confirm-book-button",
          disabled: U || !!d && !_ || (s == null ? void 0 : s.creatingBooking) || (s == null ? void 0 : s.creatingRecurringBooking) || l || (s == null ? void 0 : s.creatingInstantBooking) || h,
          color: "primary",
          loading: z === e.time && (s == null ? void 0 : s.creatingBooking) || (s == null ? void 0 : s.creatingRecurringBooking) || l || (s == null ? void 0 : s.creatingInstantBooking),
          children: L === "column_view" ? "" : v(U ? "timeslot_unavailable_short" : c ? y ? "pay_and_book" : "confirm" : "verify_email_button")
        }
      ) }, e.time) }),
      F && /* @__PURE__ */ m(lsl, { children: /* @__PURE__ */ m(usl, { side: "top", align: "end", sideOffset: 2, children: /* @__PURE__ */ de("div", { className: "text-emphasis bg-inverted w-[var(--booker-timeslots-width)] rounded-md p-3", children: [
        /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ m("p", { children: "Busy" }) }),
        /* @__PURE__ */ de("p", { className: "text-muted", children: [
          O,
          " - ",
          P
        ] })
      ] }) }) })
    ] })
  ] }) });
}, hhe = ({
  slots: e,
  showTimeFormatToggle: t = !0,
  className: n,
  ...o
}) => {
  const { t: r } = kt();
  if (e.every((c) => c.away))
    return /* @__PURE__ */ m(Zz, { ...e[0] });
  const a = e[0] && e[0].away, s = e[e.length - 1] && e[e.length - 1].away;
  return /* @__PURE__ */ m("div", { className: xe("text-default flex flex-col", n), children: /* @__PURE__ */ de("div", { className: "h-full pb-4", children: [
    !e.length && /* @__PURE__ */ de(
      "div",
      {
        "data-testId": "no-slots-available",
        className: "bg-subtle border-subtle flex h-full flex-col items-center rounded-md border p-6 dark:bg-transparent",
        children: [
          /* @__PURE__ */ m(qt, { name: "calendar-x-2", className: "text-muted mb-2 h-4 w-4" }),
          /* @__PURE__ */ m("p", { className: xe("text-muted", t ? "-mt-1 text-lg" : "text-sm"), children: r("all_booked_today") })
        ]
      }
    ),
    a && !s && /* @__PURE__ */ m(Zz, { ...e[0] }),
    e.map((c) => c.away ? null : /* @__PURE__ */ m(_sl, { slot: c, ...o }, c.time)),
    s && !a && /* @__PURE__ */ m(Zz, { ...e[e.length - 1], className: "pb-0" })
  ] }) });
}, Zz = (e) => {
  const t = Kr(), { fromUser: n, toUser: o, reason: r, emoji: i, time: a, className: s = "" } = e;
  return t ? /* @__PURE__ */ m(nt, {}) : /* @__PURE__ */ m(
    fhe,
    {
      fromUser: n,
      toUser: o,
      date: ht(a).format("YYYY-MM-DD"),
      reason: r,
      emoji: i,
      borderDashed: !0,
      className: s
    }
  );
}, psl = () => /* @__PURE__ */ m("div", { className: "flex w-[20%] flex-col only:w-full", children: Array.from({ length: Math.floor(Math.random() * 6) + 1 }).map((e, t) => /* @__PURE__ */ m(Yo, { className: "mb-4 h-6 w-full" }, t)) });
var iE, msl = new Uint8Array(16);
function vhe() {
  if (!iE && (iE = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !iE))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return iE(msl);
}
const fsl = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function qA(e) {
  return typeof e == "string" && fsl.test(e);
}
var nc = [];
for (var Xz = 0; Xz < 256; ++Xz)
  nc.push((Xz + 256).toString(16).substr(1));
function jA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (nc[e[t + 0]] + nc[e[t + 1]] + nc[e[t + 2]] + nc[e[t + 3]] + "-" + nc[e[t + 4]] + nc[e[t + 5]] + "-" + nc[e[t + 6]] + nc[e[t + 7]] + "-" + nc[e[t + 8]] + nc[e[t + 9]] + "-" + nc[e[t + 10]] + nc[e[t + 11]] + nc[e[t + 12]] + nc[e[t + 13]] + nc[e[t + 14]] + nc[e[t + 15]]).toLowerCase();
  if (!qA(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var nZ, Jz, Qz = 0, eR = 0;
function gsl(e, t, n) {
  var o = t && n || 0, r = t || new Array(16);
  e = e || {};
  var i = e.node || nZ, a = e.clockseq !== void 0 ? e.clockseq : Jz;
  if (i == null || a == null) {
    var s = e.random || (e.rng || vhe)();
    i == null && (i = nZ = [s[0] | 1, s[1], s[2], s[3], s[4], s[5]]), a == null && (a = Jz = (s[6] << 8 | s[7]) & 16383);
  }
  var c = e.msecs !== void 0 ? e.msecs : Date.now(), l = e.nsecs !== void 0 ? e.nsecs : eR + 1, u = c - Qz + (l - eR) / 1e4;
  if (u < 0 && e.clockseq === void 0 && (a = a + 1 & 16383), (u < 0 || c > Qz) && e.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Qz = c, eR = l, Jz = a, c += 122192928e5;
  var d = ((c & 268435455) * 1e4 + l) % 4294967296;
  r[o++] = d >>> 24 & 255, r[o++] = d >>> 16 & 255, r[o++] = d >>> 8 & 255, r[o++] = d & 255;
  var _ = c / 4294967296 * 1e4 & 268435455;
  r[o++] = _ >>> 8 & 255, r[o++] = _ & 255, r[o++] = _ >>> 24 & 15 | 16, r[o++] = _ >>> 16 & 255, r[o++] = a >>> 8 | 128, r[o++] = a & 255;
  for (var p = 0; p < 6; ++p)
    r[o + p] = i[p];
  return t || jA(r);
}
function bhe(e) {
  if (!qA(e))
    throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = t & 255, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = t & 255, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = t & 255, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = t & 255, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = t & 255, n;
}
function hsl(e) {
  e = unescape(encodeURIComponent(e));
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n));
  return t;
}
var vsl = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", bsl = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function yhe(e, t, n) {
  function o(r, i, a, s) {
    if (typeof r == "string" && (r = hsl(r)), typeof i == "string" && (i = bhe(i)), i.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + r.length);
    if (c.set(i), c.set(r, i.length), c = n(c), c[6] = c[6] & 15 | t, c[8] = c[8] & 63 | 128, a) {
      s = s || 0;
      for (var l = 0; l < 16; ++l)
        a[s + l] = c[l];
      return a;
    }
    return jA(c);
  }
  try {
    o.name = e;
  } catch {
  }
  return o.DNS = vsl, o.URL = bsl, o;
}
function ysl(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n)
      e[n] = t.charCodeAt(n);
  }
  return $sl(wsl(ksl(e), e.length * 8));
}
function $sl(e) {
  for (var t = [], n = e.length * 32, o = "0123456789abcdef", r = 0; r < n; r += 8) {
    var i = e[r >> 5] >>> r % 32 & 255, a = parseInt(o.charAt(i >>> 4 & 15) + o.charAt(i & 15), 16);
    t.push(a);
  }
  return t;
}
function $he(e) {
  return (e + 64 >>> 9 << 4) + 14 + 1;
}
function wsl(e, t) {
  e[t >> 5] |= 128 << t % 32, e[$he(t) - 1] = t;
  for (var n = 1732584193, o = -271733879, r = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
    var s = n, c = o, l = r, u = i;
    n = Ec(n, o, r, i, e[a], 7, -680876936), i = Ec(i, n, o, r, e[a + 1], 12, -389564586), r = Ec(r, i, n, o, e[a + 2], 17, 606105819), o = Ec(o, r, i, n, e[a + 3], 22, -1044525330), n = Ec(n, o, r, i, e[a + 4], 7, -176418897), i = Ec(i, n, o, r, e[a + 5], 12, 1200080426), r = Ec(r, i, n, o, e[a + 6], 17, -1473231341), o = Ec(o, r, i, n, e[a + 7], 22, -45705983), n = Ec(n, o, r, i, e[a + 8], 7, 1770035416), i = Ec(i, n, o, r, e[a + 9], 12, -1958414417), r = Ec(r, i, n, o, e[a + 10], 17, -42063), o = Ec(o, r, i, n, e[a + 11], 22, -1990404162), n = Ec(n, o, r, i, e[a + 12], 7, 1804603682), i = Ec(i, n, o, r, e[a + 13], 12, -40341101), r = Ec(r, i, n, o, e[a + 14], 17, -1502002290), o = Ec(o, r, i, n, e[a + 15], 22, 1236535329), n = xc(n, o, r, i, e[a + 1], 5, -165796510), i = xc(i, n, o, r, e[a + 6], 9, -1069501632), r = xc(r, i, n, o, e[a + 11], 14, 643717713), o = xc(o, r, i, n, e[a], 20, -373897302), n = xc(n, o, r, i, e[a + 5], 5, -701558691), i = xc(i, n, o, r, e[a + 10], 9, 38016083), r = xc(r, i, n, o, e[a + 15], 14, -660478335), o = xc(o, r, i, n, e[a + 4], 20, -405537848), n = xc(n, o, r, i, e[a + 9], 5, 568446438), i = xc(i, n, o, r, e[a + 14], 9, -1019803690), r = xc(r, i, n, o, e[a + 3], 14, -187363961), o = xc(o, r, i, n, e[a + 8], 20, 1163531501), n = xc(n, o, r, i, e[a + 13], 5, -1444681467), i = xc(i, n, o, r, e[a + 2], 9, -51403784), r = xc(r, i, n, o, e[a + 7], 14, 1735328473), o = xc(o, r, i, n, e[a + 12], 20, -1926607734), n = Cc(n, o, r, i, e[a + 5], 4, -378558), i = Cc(i, n, o, r, e[a + 8], 11, -2022574463), r = Cc(r, i, n, o, e[a + 11], 16, 1839030562), o = Cc(o, r, i, n, e[a + 14], 23, -35309556), n = Cc(n, o, r, i, e[a + 1], 4, -1530992060), i = Cc(i, n, o, r, e[a + 4], 11, 1272893353), r = Cc(r, i, n, o, e[a + 7], 16, -155497632), o = Cc(o, r, i, n, e[a + 10], 23, -1094730640), n = Cc(n, o, r, i, e[a + 13], 4, 681279174), i = Cc(i, n, o, r, e[a], 11, -358537222), r = Cc(r, i, n, o, e[a + 3], 16, -722521979), o = Cc(o, r, i, n, e[a + 6], 23, 76029189), n = Cc(n, o, r, i, e[a + 9], 4, -640364487), i = Cc(i, n, o, r, e[a + 12], 11, -421815835), r = Cc(r, i, n, o, e[a + 15], 16, 530742520), o = Cc(o, r, i, n, e[a + 2], 23, -995338651), n = Tc(n, o, r, i, e[a], 6, -198630844), i = Tc(i, n, o, r, e[a + 7], 10, 1126891415), r = Tc(r, i, n, o, e[a + 14], 15, -1416354905), o = Tc(o, r, i, n, e[a + 5], 21, -57434055), n = Tc(n, o, r, i, e[a + 12], 6, 1700485571), i = Tc(i, n, o, r, e[a + 3], 10, -1894986606), r = Tc(r, i, n, o, e[a + 10], 15, -1051523), o = Tc(o, r, i, n, e[a + 1], 21, -2054922799), n = Tc(n, o, r, i, e[a + 8], 6, 1873313359), i = Tc(i, n, o, r, e[a + 15], 10, -30611744), r = Tc(r, i, n, o, e[a + 6], 15, -1560198380), o = Tc(o, r, i, n, e[a + 13], 21, 1309151649), n = Tc(n, o, r, i, e[a + 4], 6, -145523070), i = Tc(i, n, o, r, e[a + 11], 10, -1120210379), r = Tc(r, i, n, o, e[a + 2], 15, 718787259), o = Tc(o, r, i, n, e[a + 9], 21, -343485551), n = mg(n, s), o = mg(o, c), r = mg(r, l), i = mg(i, u);
  }
  return [n, o, r, i];
}
function ksl(e) {
  if (e.length === 0)
    return [];
  for (var t = e.length * 8, n = new Uint32Array($he(t)), o = 0; o < t; o += 8)
    n[o >> 5] |= (e[o / 8] & 255) << o % 32;
  return n;
}
function mg(e, t) {
  var n = (e & 65535) + (t & 65535), o = (e >> 16) + (t >> 16) + (n >> 16);
  return o << 16 | n & 65535;
}
function Ssl(e, t) {
  return e << t | e >>> 32 - t;
}
function VA(e, t, n, o, r, i) {
  return mg(Ssl(mg(mg(t, e), mg(o, i)), r), n);
}
function Ec(e, t, n, o, r, i, a) {
  return VA(t & n | ~t & o, e, t, r, i, a);
}
function xc(e, t, n, o, r, i, a) {
  return VA(t & o | n & ~o, e, t, r, i, a);
}
function Cc(e, t, n, o, r, i, a) {
  return VA(t ^ n ^ o, e, t, r, i, a);
}
function Tc(e, t, n, o, r, i, a) {
  return VA(n ^ (t | ~o), e, t, r, i, a);
}
var Esl = yhe("v3", 48, ysl);
const xsl = Esl;
function ok(e, t, n) {
  e = e || {};
  var o = e.random || (e.rng || vhe)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, t) {
    n = n || 0;
    for (var r = 0; r < 16; ++r)
      t[n + r] = o[r];
    return t;
  }
  return jA(o);
}
function Csl(e, t, n, o) {
  switch (e) {
    case 0:
      return t & n ^ ~t & o;
    case 1:
      return t ^ n ^ o;
    case 2:
      return t & n ^ t & o ^ n & o;
    case 3:
      return t ^ n ^ o;
  }
}
function tR(e, t) {
  return e << t | e >>> 32 - t;
}
function Tsl(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var o = unescape(encodeURIComponent(e));
    e = [];
    for (var r = 0; r < o.length; ++r)
      e.push(o.charCodeAt(r));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c) {
    for (var l = new Uint32Array(16), u = 0; u < 16; ++u)
      l[u] = e[c * 64 + u * 4] << 24 | e[c * 64 + u * 4 + 1] << 16 | e[c * 64 + u * 4 + 2] << 8 | e[c * 64 + u * 4 + 3];
    s[c] = l;
  }
  s[a - 1][14] = (e.length - 1) * 8 / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = (e.length - 1) * 8 & 4294967295;
  for (var d = 0; d < a; ++d) {
    for (var _ = new Uint32Array(80), p = 0; p < 16; ++p)
      _[p] = s[d][p];
    for (var g = 16; g < 80; ++g)
      _[g] = tR(_[g - 3] ^ _[g - 8] ^ _[g - 14] ^ _[g - 16], 1);
    for (var f = n[0], h = n[1], $ = n[2], v = n[3], b = n[4], y = 0; y < 80; ++y) {
      var w = Math.floor(y / 20), N = tR(f, 5) + Csl(w, h, $, v) + b + t[w] + _[y] >>> 0;
      b = v, v = $, $ = tR(h, 30) >>> 0, h = f, f = N;
    }
    n[0] = n[0] + f >>> 0, n[1] = n[1] + h >>> 0, n[2] = n[2] + $ >>> 0, n[3] = n[3] + v >>> 0, n[4] = n[4] + b >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var Asl = yhe("v5", 80, Tsl);
const B5 = Asl, Isl = "00000000-0000-0000-0000-000000000000";
function Osl(e) {
  if (!qA(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}
const Nsl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: Isl,
  parse: bhe,
  stringify: jA,
  v1: gsl,
  v3: xsl,
  v4: ok,
  v5: B5,
  validate: qA,
  version: Osl
}, Symbol.toStringTag, { value: "Module" })), Oj = (e) => e.get("cal.isBookingDryRun") === "true", Nj = (e) => {
  const t = e.get("cal.routedTeamMemberIds");
  return typeof t == "string" ? t.split(",").filter(Boolean).map((o) => parseInt(o, 10)) : null;
}, U5 = ({
  values: e,
  event: t,
  date: n,
  duration: o,
  timeZone: r,
  language: i,
  rescheduleUid: a,
  rescheduledBy: s,
  username: c,
  metadata: l,
  bookingUid: u,
  seatReferenceUid: d,
  hashedLink: _,
  teamMemberEmail: p,
  crmOwnerRecordType: g,
  crmAppSlug: f,
  crmRecordId: h,
  orgSlug: $,
  routingFormSearchParams: v,
  isDryRunProp: b,
  verificationCode: y
}) => {
  const w = new URLSearchParams(v ?? window.location.search), N = Nj(w), M = w.get("cal.routingFormResponseId"), q = M ? Number(M) : void 0, L = w.get("cal.skipContactOwner") === "true", R = w.get("cal.reroutingFormResponses"), T = b !== void 0 ? b : Oj(w), D = w == null ? void 0 : w.get("cal.cache"), A = D ? D === "true" : void 0, S = w == null ? void 0 : w.get("dub_id");
  return {
    ...e,
    user: c,
    start: ht(n).format(),
    end: ht(n).add(o || t.length, "minute").format(),
    eventTypeId: t.id,
    eventTypeSlug: t.slug,
    timeZone: r,
    language: i,
    rescheduleUid: a,
    rescheduledBy: s,
    metadata: l || {},
    hasHashedBookingLink: !!_,
    bookingUid: u,
    seatReferenceUid: d,
    hashedLink: _,
    teamMemberEmail: p,
    crmOwnerRecordType: g,
    crmAppSlug: f,
    crmRecordId: h,
    orgSlug: $,
    routedTeamMemberIds: N,
    routingFormResponseId: q,
    skipContactOwner: L,
    // In case of rerouting, the form responses are actually the responses that we need to update.
    reroutingFormResponses: R ? JSON.parse(R) : void 0,
    _isDryRun: T,
    _shouldServeCache: A,
    dub_id: S,
    verificationCode: y
  };
}, zsl = (e, t, n) => {
  const o = ok(), [, r] = the(
    {
      startDate: e.date,
      timeZone: e.timeZone,
      recurringEvent: e.event.recurringEvent,
      recurringCount: t,
      withDefaultTimeFormat: !0
    },
    e.language
  ), i = U5({ ...e, bookingUid: void 0 });
  return r.map((a) => ({
    ...i,
    start: ht(a).format(),
    end: ht(a).add(e.duration || e.event.length, "minute").format(),
    recurringEventId: o,
    schedulingType: e.event.schedulingType || void 0,
    recurringCount: r.length,
    tracking: n
  }));
}, whe = ({ customClassName: e }) => {
  const t = Mg((r) => r.timeFormat), n = Mg((r) => r.setTimeFormat), { t: o } = kt();
  return /* @__PURE__ */ m(
    lq,
    {
      customClassNames: e,
      onValueChange: (r) => {
        r && r !== t && n(r);
      },
      defaultValue: t,
      value: t,
      options: [
        { value: bv.TWELVE_HOUR, label: o("12_hour_short") },
        { value: bv.TWENTY_FOUR_HOUR, label: o("24_hour_short") }
      ]
    }
  );
}, khe = ({
  date: e,
  showTimeFormatToggle: t = !0,
  availableMonth: n,
  customClassNames: o
}) => {
  const { t: r, i18n: i } = kt(), [a] = _n((u) => [u.layout], Xi), s = a === io.COLUMN_VIEW, c = a === io.MONTH_VIEW, l = ht().isSame(e, "day");
  return /* @__PURE__ */ de(
    "header",
    {
      className: xe(
        "dark:bg-muted dark:before:bg-muted mb-3 flex w-full flex-row items-center font-medium",
        "bg-default before:bg-default",
        o == null ? void 0 : o.availableTimeSlotsHeaderContainer
      ),
      children: [
        /* @__PURE__ */ de(
          "span",
          {
            className: xe(
              s && "w-full text-center",
              s ? "text-subtle text-xs uppercase" : "text-emphasis font-semibold"
            ),
            children: [
              /* @__PURE__ */ m(
                "span",
                {
                  className: xe(
                    l && !(o != null && o.availableTimeSlotsTitle) && "!text-default",
                    o == null ? void 0 : o.availableTimeSlotsTitle
                  ),
                  children: Cq(i.language, Number(e.format("d")), "short")
                }
              ),
              /* @__PURE__ */ de(
                "span",
                {
                  className: xe(
                    s && l && "bg-brand-default text-brand ml-2",
                    "inline-flex items-center justify-center rounded-3xl px-1 pt-0.5 font-medium",
                    c ? `text-default text-sm ${o == null ? void 0 : o.availableTimeSlotsTitle}` : `text-xs ${o == null ? void 0 : o.availableTimeSlotsTitle}`
                  ),
                  children: [
                    e.format("DD"),
                    n && `, ${n}`
                  ]
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ m("div", { className: "ml-auto rtl:mr-auto", children: /* @__PURE__ */ m(whe, { customClassName: o == null ? void 0 : o.availableTimeSlotsTimeFormatToggle }) })
      ]
    }
  );
}, Rsl = (e, t) => vn(() => !e || typeof t > "u" ? [] : t[e] || [], [e, t]), Psl = (e, t) => {
  const [n, o] = it([]), r = Yt((i) => {
    o(
      (a) => a.map(({ date: s, slots: c }) => ({
        date: s,
        slots: c.map((l) => ({
          ...l,
          showConfirmButton: l.time === i.time ? !(i != null && i.showConfirmButton) : !1
        }))
      }))
    );
  }, []);
  return yt(() => {
    if (t === void 0) {
      o([]);
      return;
    }
    const i = e.filter((a) => a !== null).map((a) => ({
      slots: t[`${a}`] || [],
      date: a
    }));
    o(i);
  }, [JSON.stringify(e), JSON.stringify(t)]), { slotsPerDay: n, setSlotsPerDay: o, toggleConfirmButton: r };
}, Dsl = ({
  extraDays: e,
  limitHeight: t,
  showAvailableSeatsCount: n,
  schedule: o,
  isLoading: r,
  customClassNames: i,
  skipConfirmStep: a,
  seatsPerTimeSlot: s,
  onSubmit: c,
  unavailableTimeSlots: l,
  confirmButtonDisabled: u,
  confirmStepClassNames: d,
  onAvailableTimeSlotSelect: _,
  ...p
}) => {
  const g = _n((x) => x.selectedDate), f = _n((x) => x.setSeatedEventData), h = g || ht().format("YYYY-MM-DD"), [$] = _n((x) => [x.layout]), v = $ === io.COLUMN_VIEW, b = xt(null), { setTentativeSelectedTimeslots: y, tentativeSelectedTimeslots: w } = _n((x) => ({
    setTentativeSelectedTimeslots: x.setTentativeSelectedTimeslots,
    tentativeSelectedTimeslots: x.tentativeSelectedTimeslots
  })), N = ({
    time: x,
    attendees: k,
    seatsPerTimeSlot: I,
    bookingUid: z
  }) => {
    y([x]);
  }, M = o == null ? void 0 : o.data, L = MA(M == null ? void 0 : M.slots).filter(
    (x) => ht(g).diff(x, "day") <= 0
  ), R = vn(() => e ? L.length > 0 ? L.slice(0, e) : [] : [h], [h, e, L]), { slotsPerDay: T, toggleConfirmButton: D } = Psl(R, M == null ? void 0 : M.slots), A = zc("overlayCalendar") === "true" || vr.getItem("overlayCalendarSwitchDefault"), S = Yt(
    (x, k, I, z) => {
      Dse && (o == null || o.invalidate()), y([]), I && f({
        seatsPerTimeSlot: I,
        attendees: k,
        bookingUid: z,
        showAvailableSeatsCount: n
      }), _(x);
      const F = !l.includes(x);
      a && F && c(x);
    },
    [
      c,
      f,
      a,
      n,
      l,
      o,
      y,
      _
    ]
  ), E = Yt(
    (x, k) => {
      A && k || a ? D(x) : S(
        x.time,
        (x == null ? void 0 : x.attendees) || 0,
        s,
        x.bookingUid
      );
    },
    [A, S, s, a, D]
  );
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m("div", { className: xe("flex", `${i == null ? void 0 : i.availableTimeSlotsContainer}`), children: r ? /* @__PURE__ */ m("div", { className: "mb-3 h-8" }) : T.length > 0 && T.map((x) => /* @__PURE__ */ m(
      khe,
      {
        customClassNames: {
          availableTimeSlotsHeaderContainer: i == null ? void 0 : i.availableTimeSlotsHeaderContainer,
          availableTimeSlotsTitle: i == null ? void 0 : i.availableTimeSlotsTitle,
          availableTimeSlotsTimeFormatToggle: i == null ? void 0 : i.availableTimeSlotsTimeFormatToggle
        },
        date: ht(x.date),
        showTimeFormatToggle: !v,
        availableMonth: ht(g).format("MM") !== ht(x.date).format("MM") ? ht(x.date).format("MMM") : void 0
      },
      x.date
    )) }),
    /* @__PURE__ */ de(
      "div",
      {
        ref: b,
        className: xe(
          t && "scroll-bar flex-grow overflow-auto md:h-[400px]",
          !t && "flex h-full w-full flex-row gap-4",
          `${i == null ? void 0 : i.availableTimeSlotsContainer}`
        ),
        children: [
          r && // Shows exact amount of days as skeleton.
          Array.from({ length: 1 + (e ?? 0) }).map((x, k) => /* @__PURE__ */ m(psl, {}, k)),
          !r && T.length > 0 && T.map((x) => /* @__PURE__ */ m("div", { className: "scroll-bar h-full w-full overflow-y-auto overflow-x-hidden", children: /* @__PURE__ */ m(
            hhe,
            {
              className: i == null ? void 0 : i.availableTimeSlotsContainer,
              customClassNames: i == null ? void 0 : i.availableTimes,
              showTimeFormatToggle: !v,
              onTimeSelect: S,
              onTentativeTimeSelect: N,
              unavailableTimeSlots: l,
              slots: x.slots,
              showAvailableSeatsCount: n,
              skipConfirmStep: a,
              seatsPerTimeSlot: s,
              handleSlotClick: E,
              confirmButtonDisabled: u,
              confirmStepClassNames: d,
              ...p
            }
          ) }, x.date))
        ]
      }
    )
  ] });
}, She = ({ date: e, timeFormat: t, timeZone: n, language: o }) => {
  const r = new Date(e), i = new Intl.DateTimeFormat(o, {
    timeZone: n,
    dateStyle: "full"
  }).format(r), a = new Intl.DateTimeFormat(o, {
    timeZone: n,
    timeStyle: "short",
    hour12: t === bv.TWELVE_HOUR
  }).format(r).toLowerCase();
  return { date: i, time: a };
}, Lsl = ({
  date: e,
  duration: t,
  timeFormat: n,
  timeZone: o,
  language: r
}) => {
  const i = new Date(e), a = t ? new Date(new Date(e).setMinutes(i.getMinutes() + t)) : i, s = new Intl.DateTimeFormat(r, {
    timeZone: o,
    dateStyle: "full"
  }).formatRange(i, a), c = new Intl.DateTimeFormat(r, {
    timeZone: o,
    timeStyle: "short",
    hour12: n === bv.TWELVE_HOUR
  }).formatRange(i, a).toLowerCase();
  return { date: s, time: c };
}, oZ = (e) => {
  const t = Lsl(e);
  return /* @__PURE__ */ de(nt, { children: [
    t.date,
    /* @__PURE__ */ m("br", {}),
    t.time
  ] });
}, Msl = (e) => {
  const t = She(e);
  return /* @__PURE__ */ de(nt, { children: [
    t.date,
    ", ",
    t.time
  ] });
}, Fsl = (e) => !!e, qsl = Fsl;
function Ehe(e, t) {
  return e.map((n) => {
    const o = Xl(n.type), r = Gge(n);
    if (typeof r != "string" || !o)
      return null;
    const i = o.type;
    return {
      // XYZ: is considered a namespace in i18next https://www.i18next.com/principles/namespaces and thus it gets cleaned up.
      label: n.customLabel || xj(n, o, t) || r,
      value: i,
      inputPlaceholder: t((o == null ? void 0 : o.attendeeInputPlaceholder) || "")
    };
  }).filter(qsl);
}
var BA = function(e) {
  var t = e.as, n = e.errors, o = e.name, r = e.message, i = e.render, a = function(_, p) {
    if (_ == null)
      return {};
    var g, f, h = {}, $ = Object.keys(_);
    for (f = 0; f < $.length; f++)
      p.indexOf(g = $[f]) >= 0 || (h[g] = _[g]);
    return h;
  }(e, ["as", "errors", "name", "message", "render"]), s = No(), c = Pn(n || s.formState.errors, o);
  if (!c)
    return null;
  var l = c.message, u = c.types, d = Object.assign({}, a, { children: l || r });
  return Ue.isValidElement(t) ? Ue.cloneElement(t, d) : i ? i({ message: l || r, messages: u }) : Ue.createElement(t || Ue.Fragment, d);
};
const UA = co(
  async () => (await import("./index-QUmEmUDE.js")).SelectWithValidation
), jsl = (e) => {
  const { value: t, setValue: n, readOnly: o, placeholder: r, maxLength: i, customProps: a, ...s } = e;
  return /* @__PURE__ */ m(
    Kw,
    {
      value: t || "",
      placeholder: r,
      className: "mb-2",
      disabled: o,
      onChange: (u) => {
        const d = u.target.value;
        n(d);
      },
      maxLength: i,
      ...a,
      ...s
    }
  );
}, Vsl = (e) => {
  const {
    value: t,
    noLabel: n,
    setValue: o,
    readOnly: r,
    placeholder: i,
    customProps: a,
    type: s = "text",
    ...c
  } = e;
  return /* @__PURE__ */ m(
    xr,
    {
      size: "sm",
      containerClassName: "w-full mb-2",
      type: s,
      value: t || "",
      noLabel: n,
      placeholder: i,
      disabled: r,
      onChange: (d) => {
        const _ = d.target.value;
        o(_);
      },
      ...c,
      ...a
    }
  );
};
function Bsl({ value: e, setValue: t, ...n }) {
  return /* @__PURE__ */ m(
    xr,
    {
      size: "sm",
      type: "number",
      labelSrOnly: n.noLabel,
      containerClassName: "w-full",
      className: "mb-2",
      value: e,
      onChange: (o) => {
        t(o.target.value);
      },
      ...n
    }
  );
}
const Usl = ({
  listValues: e,
  setValue: t,
  value: n,
  ...o
}) => {
  if (!e)
    return null;
  const r = e.map((a) => ({
    label: a.title,
    value: a.value
  })), i = r.filter((a) => n == null ? void 0 : n.includes(a.value));
  return i.length === 0 && (n != null && n.length) && t([]), /* @__PURE__ */ m(
    UA,
    {
      size: "sm",
      "aria-label": "multi-select-dropdown",
      className: "mb-2",
      onChange: (a) => {
        t(a == null ? void 0 : a.map((s) => s.value));
      },
      value: i,
      isMulti: !0,
      isDisabled: o.readOnly,
      options: r,
      ...o
    }
  );
};
function Gsl({ listValues: e, setValue: t, value: n, ...o }) {
  if (!e)
    return null;
  const r = e.map((a) => ({
    label: a.title,
    value: a.value
  })), i = r.find((a) => a.value === n);
  return !i && n && t(""), /* @__PURE__ */ m(
    UA,
    {
      size: "sm",
      "aria-label": "select-dropdown",
      className: "data-testid-select mb-2",
      onChange: (a) => {
        a && t(a.value);
      },
      isDisabled: o.readOnly,
      value: i,
      options: r,
      ...o
    }
  );
}
function Wsl({ config: e, type: t, label: n, onClick: o, readonly: r }) {
  const { t: i } = kt();
  if (t === "delRule" || t == "delGroup")
    return /* @__PURE__ */ m("button", { className: "ml-5", children: /* @__PURE__ */ m(qt, { name: "trash", className: "text-subtle m-0 h-4 w-4", onClick: o }) });
  let a = "";
  return t === "addRule" ? (n = e != null && e.operators.__calReporting ? i("add_filter") : i("add_rule"), a = "add-rule") : t == "addGroup" && (n = i("add_rule_group"), a = "add-rule-group"), /* @__PURE__ */ m(
    Jt,
    {
      size: "sm",
      StartIcon: "plus",
      "data-testid": a,
      type: "button",
      color: "minimal",
      disabled: r,
      onClick: o,
      children: n
    }
  );
}
function Hsl({ children: e }) {
  return e instanceof Array ? /* @__PURE__ */ m(nt, { children: e.map((t, n) => t ? /* @__PURE__ */ m("div", { children: t }, n) : null) }) : null;
}
function Ysl({ not: e, setNot: t, config: n, conjunctionOptions: o, setConjunction: r, disabled: i }) {
  if (!n || !o)
    return null;
  const a = Object.keys(o).length, s = i, { forceShowConj: c } = n.settings, l = c || a > 1 && !s, u = [
    { label: "All", value: "all" },
    { label: "Any", value: "any" },
    { label: "None", value: "none" }
  ];
  return l ? (() => {
    const { checked: _ } = o.AND, { checked: p } = o.OR, g = e;
    let f = _ ? "all" : p ? "any" : "all";
    g && (f = f == "any" ? "none" : "all");
    const h = u.find((v) => v.value === f), $ = n.operators.__calReporting ? "Query where" : "If booker selects";
    return /* @__PURE__ */ de("div", { className: "mb-[1px] flex items-center text-sm", children: [
      /* @__PURE__ */ m("span", { children: $ }),
      /* @__PURE__ */ m(
        UA,
        {
          className: "flex px-2",
          size: "sm",
          defaultValue: h,
          options: u,
          onChange: (v) => {
            v && (v.value === "all" ? (r("AND"), t(!1)) : v.value === "any" ? (r("OR"), t(!1)) : v.value === "none" && (r("OR"), t(!0)));
          }
        }
      )
    ] });
  })() : null;
}
const Ksl = function(t) {
  const { items: n, setField: o, selectedKey: r } = t, i = n.map((s) => ({
    ...s,
    value: s.key
  })), a = i.find((s) => s.value === r);
  return /* @__PURE__ */ m(
    UA,
    {
      size: "sm",
      className: "data-testid-field-select  mb-2",
      menuPosition: "fixed",
      onChange: (s) => {
        s && o(s.value);
      },
      defaultValue: a,
      options: i
    }
  );
}, Zsl = ({ children: e }) => e, Th = {
  TextWidget: Vsl,
  TextAreaWidget: jsl,
  SelectWidget: Gsl,
  NumberWidget: Bsl,
  MultiSelectWidget: Usl,
  FieldSelect: Ksl,
  Button: Wsl,
  ButtonGroup: Hsl,
  Conjs: Ysl,
  Provider: Zsl
}, Xsl = co(
  () => import("./PhoneInput-OHj2mRNd.js")
), xhe = Xsl, Jsl = co(
  () => import("./AddressInput-d5fg8Fqj.js")
), Qsl = Jsl, ecl = /* @__PURE__ */ Cr(void 0);
function tcl(e) {
  const t = bo(ecl);
  return e || t || "ltr";
}
const Che = "Radio", [ncl, The] = jc(Che), [ocl, rcl] = ncl(Che), icl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRadio: n, name: o, checked: r = !1, required: i, disabled: a, value: s = "on", onCheck: c, ...l } = e, [u, d] = it(null), _ = ni(
    t,
    (f) => d(f)
  ), p = xt(!1), g = u ? !!u.closest("form") : !0;
  return /* @__PURE__ */ pt(ocl, {
    scope: n,
    checked: r,
    disabled: a
  }, /* @__PURE__ */ pt(nr.button, Tt({
    type: "button",
    role: "radio",
    "aria-checked": r,
    "data-state": Ahe(r),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: s
  }, l, {
    ref: _,
    onClick: jn(e.onClick, (f) => {
      r || c == null || c(), g && (p.current = f.isPropagationStopped(), p.current || f.stopPropagation());
    })
  })), g && /* @__PURE__ */ pt(ccl, {
    control: u,
    bubbles: !p.current,
    name: o,
    value: s,
    checked: r,
    required: i,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), acl = "RadioIndicator", scl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRadio: n, forceMount: o, ...r } = e, i = rcl(acl, n);
  return /* @__PURE__ */ pt(Vc, {
    present: o || i.checked
  }, /* @__PURE__ */ pt(nr.span, Tt({
    "data-state": Ahe(i.checked),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t
  })));
}), ccl = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = xt(null), a = hue(n), s = CT(t);
  return yt(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && d) {
      const _ = new Event("click", {
        bubbles: o
      });
      d.call(c, n), c.dispatchEvent(_);
    }
  }, [
    a,
    n,
    o
  ]), /* @__PURE__ */ pt("input", Tt({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, r, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Ahe(e) {
  return e ? "checked" : "unchecked";
}
const lcl = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], Ihe = "RadioGroup", [ucl, gsu] = jc(Ihe, [
  By,
  The
]), Ohe = By(), Nhe = The(), [dcl, _cl] = ucl(Ihe), pcl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRadioGroup: n, name: o, defaultValue: r, value: i, required: a = !1, disabled: s = !1, orientation: c, dir: l, loop: u = !0, onValueChange: d, ..._ } = e, p = Ohe(n), g = tcl(l), [f, h] = Uu({
    prop: i,
    defaultProp: r,
    onChange: d
  });
  return /* @__PURE__ */ pt(dcl, {
    scope: n,
    name: o,
    required: a,
    disabled: s,
    value: f,
    onValueChange: h
  }, /* @__PURE__ */ pt(X6, Tt({
    asChild: !0
  }, p, {
    orientation: c,
    dir: g,
    loop: u
  }), /* @__PURE__ */ pt(nr.div, Tt({
    role: "radiogroup",
    "aria-required": a,
    "aria-orientation": c,
    "data-disabled": s ? "" : void 0,
    dir: g
  }, _, {
    ref: t
  }))));
}), mcl = "RadioGroupItem", fcl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRadioGroup: n, disabled: o, ...r } = e, i = _cl(mcl, n), a = i.disabled || o, s = Ohe(n), c = Nhe(n), l = xt(null), u = ni(t, l), d = i.value === r.value, _ = xt(!1);
  return yt(() => {
    const p = (f) => {
      lcl.includes(f.key) && (_.current = !0);
    }, g = () => _.current = !1;
    return document.addEventListener("keydown", p), document.addEventListener("keyup", g), () => {
      document.removeEventListener("keydown", p), document.removeEventListener("keyup", g);
    };
  }, []), /* @__PURE__ */ pt(J6, Tt({
    asChild: !0
  }, s, {
    focusable: !a,
    active: d
  }), /* @__PURE__ */ pt(icl, Tt({
    disabled: a,
    required: i.required,
    checked: d
  }, c, r, {
    name: i.name,
    ref: u,
    onCheck: () => i.onValueChange(r.value),
    onKeyDown: jn((p) => {
      p.key === "Enter" && p.preventDefault();
    }),
    onFocus: jn(r.onFocus, () => {
      var p;
      _.current && ((p = l.current) === null || p === void 0 || p.click());
    })
  })));
}), gcl = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeRadioGroup: n, ...o } = e, r = Nhe(n);
  return /* @__PURE__ */ pt(scl, Tt({}, r, o, {
    ref: t
  }));
}), r1 = pcl, i1 = fcl, a1 = gcl, hcl = ({ children: e, className: t, classNames: n, ...o }) => {
  const r = Pu(), i = o.id ?? r;
  return /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "border-subtle [&:has(input:checked)]:border-emphasis relative flex items-start rounded-[10px] border ",
        t
      ),
      children: [
        /* @__PURE__ */ m(
          i1,
          {
            id: i,
            ...o,
            className: xe(
              "hover:bg-subtle disabled:hover:bg-default border-default focus:ring-emphasis absolute left-3 top-[0.9rem] mt-0.5 h-4 w-4 flex-shrink-0 rounded-full border transition focus:ring-2 disabled:cursor-not-allowed",
              o.disabled && "opacity-60"
            ),
            children: /* @__PURE__ */ m(
              a1,
              {
                className: xe(
                  "after:bg-default dark:after:bg-inverted relative flex h-full w-full items-center justify-center rounded-full bg-black after:h-[6px] after:w-[6px] after:rounded-full after:content-['']",
                  o.disabled ? "after:bg-muted" : "bg-black"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ m("label", { htmlFor: i, className: xe("text-default p-4 pl-10 pt-3", n == null ? void 0 : n.container), children: e })
      ]
    }
  );
}, vcl = ({
  children: e,
  className: t,
  onValueChange: n,
  ...o
}) => /* @__PURE__ */ m(r1, { className: t, onValueChange: n, ...o, children: e }), Eg = hcl, zj = vcl, bcl = (e) => /* @__PURE__ */ m(r1, { ...e, children: e.children }), ycl = (e) => /* @__PURE__ */ m(
  i1,
  {
    ...e,
    className: xe(
      "hover:bg-subtle border-default dark:checked:bg-brand-default dark:hover:bg-subtle dark:checked:hover:bg-brand-default focus:ring-brand-default hover:border-emphasis me-1.5 mt-0.5 h-4 w-4 flex-shrink-0 rounded-full border text-[--cal-brand] transition focus:border-0 focus:ring-1",
      e.disabled && "opacity-60"
    ),
    children: e.children
  }
), $cl = ({ disabled: e }) => /* @__PURE__ */ m(
  a1,
  {
    className: xe(
      "after:bg-default dark:after:bg-brand-accent relative flex h-full w-full items-center justify-center rounded-full bg-black after:h-[6px] after:w-[6px] after:rounded-full after:content-['']",
      e ? "after:bg-muted" : "bg-brand-default"
    )
  }
), wcl = (e) => /* @__PURE__ */ m(
  "label",
  {
    ...e,
    className: xe(
      "text-emphasis ms-2 w-full text-sm font-medium leading-5",
      e.disabled && "text-subtle"
    )
  }
), G5 = ({
  label: e,
  disabled: t,
  id: n,
  value: o,
  className: r,
  withPadding: i
}) => /* @__PURE__ */ de(
  "div",
  {
    className: xe(
      "flex items-start",
      i && "hover:bg-subtle cursor-pointer rounded-lg p-1.5",
      r
    ),
    children: [
      /* @__PURE__ */ m(ycl, { value: o, disabled: t, id: n, children: /* @__PURE__ */ m($cl, { disabled: t }) }),
      /* @__PURE__ */ m(wcl, { htmlFor: n, disabled: t, children: e })
    ]
  }
), kcl = {
  boolean: (e) => typeof e == "boolean",
  multiselect: (e) => e instanceof Array && e.every((t) => typeof t == "string"),
  objectiveWithInput: (e) => typeof e == "object" && e !== null ? "value" in e : !1,
  select: (e) => typeof e == "string",
  text: (e) => typeof e == "string",
  textList: (e) => e instanceof Array && e.every((t) => typeof t == "string"),
  variants: (e) => typeof e == "object" && e !== null || typeof e == "string"
}, Scl = {
  text: {
    propsType: Nc.text,
    factory: (e) => /* @__PURE__ */ m(Th.TextWidget, { id: e.name, noLabel: !0, ...e })
  },
  textarea: {
    propsType: Nc.textarea,
    // TODO: Make rows configurable in the form builder
    factory: (e) => /* @__PURE__ */ m(Th.TextAreaWidget, { id: e.name, rows: 3, ...e })
  },
  number: {
    propsType: Nc.number,
    factory: (e) => /* @__PURE__ */ m(Th.NumberWidget, { id: e.name, noLabel: !0, ...e })
  },
  name: {
    propsType: Nc.name,
    // Keep special "name" type field and later build split(FirstName and LastName) variant of it.
    factory: (e) => {
      const { variant: t = "fullName" } = e, n = (i, a) => {
        let s = e.value;
        typeof s != "object" && (s = {}), e.setValue({
          ...s,
          [i]: a
        });
      };
      if (!e.variants)
        throw new Error("'variants' is required for 'name' type of field");
      if (t !== "firstAndLastName" && t !== "fullName")
        throw new Error(`Invalid variant name '${t}' for 'name' type of field`);
      const o = Nge(t, e.value);
      if (t === "fullName") {
        if (typeof o != "string")
          throw new Error("Invalid value for 'fullName' variant");
        const a = e.variants[t].fields[0];
        return /* @__PURE__ */ m(
          Da,
          {
            name: "name",
            showAsteriskIndicator: !0,
            placeholder: a.placeholder,
            label: a.label,
            containerClassName: "w-full",
            readOnly: e.readOnly,
            value: o,
            required: a.required,
            type: "text",
            onChange: (s) => {
              e.setValue(s.target.value);
            }
          }
        );
      }
      const r = e.variants[t];
      if (typeof o != "object")
        throw new Error("Invalid value for 'fullName' variant");
      return /* @__PURE__ */ m("div", { className: "flex space-x-4", children: r.fields.map((i) => /* @__PURE__ */ m(
        Da,
        {
          className: "!mb-0",
          showAsteriskIndicator: !0,
          name: i.name,
          readOnly: e.readOnly,
          placeholder: i.placeholder,
          label: i.label,
          containerClassName: `w-full testid-${i.name}`,
          value: o[i.name],
          required: i.required,
          type: "text",
          onChange: (a) => n(i.name, a.target.value)
        },
        i.name
      )) });
    }
  },
  phone: {
    propsType: Nc.phone,
    factory: ({ setValue: e, readOnly: t, ...n }) => n ? /* @__PURE__ */ m(
      xhe,
      {
        disabled: t,
        onChange: (o) => {
          e(o);
        },
        ...n
      }
    ) : /* @__PURE__ */ m("div", {})
  },
  email: {
    propsType: Nc.email,
    factory: (e) => e ? /* @__PURE__ */ m(
      Da,
      {
        type: "email",
        id: e.name,
        noLabel: !0,
        ...e,
        onChange: (t) => e.setValue(t.target.value)
      }
    ) : /* @__PURE__ */ m("div", {})
  },
  address: {
    propsType: Nc.address,
    factory: (e) => /* @__PURE__ */ m(
      Qsl,
      {
        id: e.name,
        onChange: (t) => {
          e.setValue(t);
        },
        ...e,
        disabled: e.readOnly
      }
    )
  },
  multiemail: {
    propsType: Nc.multiemail,
    //TODO: Make it a ui component
    factory: function({ value: t, readOnly: n, label: o, setValue: r, ...i }) {
      const a = i.placeholder, { t: s } = kt();
      return t = t || [], /* @__PURE__ */ de(nt, { children: [
        t.length ? /* @__PURE__ */ de("div", { children: [
          /* @__PURE__ */ m("label", { htmlFor: "guests", className: "text-default  mb-1 block text-sm font-medium", children: o }),
          /* @__PURE__ */ m("ul", { children: t.map((c, l) => /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
            Rde,
            {
              id: `${i.name}.${l}`,
              disabled: n,
              value: t[l],
              onChange: (u) => {
                t[l] = u.target.value.toLowerCase(), r(t);
              },
              placeholder: a,
              label: /* @__PURE__ */ m(nt, {}),
              required: !0,
              onClickAddon: () => {
                t.splice(l, 1), r(t);
              },
              addOnSuffix: n ? null : /* @__PURE__ */ m(Sr, { content: "Remove email", children: /* @__PURE__ */ m("button", { className: "m-1", type: "button", children: /* @__PURE__ */ m(qt, { name: "x", width: 12, className: "text-default" }) }) })
            }
          ) }, l)) }),
          !n && /* @__PURE__ */ m(
            Jt,
            {
              "data-testid": "add-another-guest",
              type: "button",
              color: "minimal",
              StartIcon: "user-plus",
              className: "my-2.5",
              onClick: () => {
                t.push(""), r(t);
              },
              children: s("add_another")
            }
          )
        ] }) : /* @__PURE__ */ m(nt, {}),
        !t.length && !n && /* @__PURE__ */ m(
          Jt,
          {
            "data-testid": "add-guests",
            color: "minimal",
            variant: "button",
            StartIcon: "user-plus",
            onClick: () => {
              t.push(""), r(t);
            },
            className: "mr-auto h-fit whitespace-normal text-left",
            children: /* @__PURE__ */ m("span", { className: "flex-1", children: o })
          }
        )
      ] });
    }
  },
  multiselect: {
    propsType: Nc.multiselect,
    factory: (e) => {
      const t = {
        ...e,
        listValues: e.options.map((n) => ({ title: n.label, value: n.value }))
      };
      return /* @__PURE__ */ m(Th.MultiSelectWidget, { id: e.name, ...t });
    }
  },
  select: {
    propsType: Nc.select,
    factory: (e) => {
      const t = {
        ...e,
        listValues: e.options.map((n) => ({ title: n.label, value: n.value }))
      };
      return /* @__PURE__ */ m(Th.SelectWidget, { id: e.name, ...t });
    }
  },
  checkbox: {
    propsType: Nc.checkbox,
    factory: ({ options: e, readOnly: t, setValue: n, value: o }) => (o = o || [], /* @__PURE__ */ m("div", { children: e.map((r, i) => /* @__PURE__ */ de("label", { className: "block", children: [
      /* @__PURE__ */ m(
        Due,
        {
          disabled: t,
          onCheckedChange: (a) => {
            const s = o.filter((c) => c !== r.value);
            a && s.push(r.value), n(s);
          },
          value: r.value,
          checked: o.includes(r.value)
        }
      ),
      /* @__PURE__ */ m("span", { className: "text-emphasis me-2 ms-2 text-sm", children: r.label ?? "" })
    ] }, i)) }))
  },
  radio: {
    propsType: Nc.radio,
    factory: ({ setValue: e, name: t, value: n, options: o, readOnly: r }) => /* @__PURE__ */ m(
      bcl,
      {
        disabled: r,
        value: n,
        onValueChange: (i) => {
          e(i);
        },
        children: /* @__PURE__ */ m(nt, { children: o.map((i, a) => /* @__PURE__ */ m(
          G5,
          {
            label: i.label,
            value: i.label,
            id: `${t}.option.${a}.radio`
          },
          `option.${a}.radio`
        )) })
      }
    )
  },
  radioInput: {
    propsType: Nc.radioInput,
    factory: function({
      name: t,
      label: n,
      options: o,
      optionsInputs: r,
      value: i,
      setValue: a,
      readOnly: s,
      translatedDefaultLabel: c
    }) {
      var _;
      yt(() => {
        var p;
        i || a({
          value: (p = o[0]) == null ? void 0 : p.value,
          optionValue: ""
        });
      }, [o, a, i]);
      const { t: l } = kt(), u = (p, g) => p && g ? g !== p : !1, d = (p) => p ? p.search(/^https?:\/\//) !== -1 ? /* @__PURE__ */ m("a", { href: p, target: "_blank", children: /* @__PURE__ */ m("span", { className: "underline", children: p }) }) : p : "";
      return /* @__PURE__ */ de("div", { children: [
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "mb-2", children: o.length > 1 ? o.map((p, g) => /* @__PURE__ */ de("label", { className: "mb-1 flex items-center", children: [
          /* @__PURE__ */ m(
            "input",
            {
              type: "radio",
              disabled: s,
              name: t,
              className: "bg-default after:bg-default border-emphasis focus:ring-brand-default hover:bg-subtle hover:after:bg-subtle dark:checked:after:bg-brand-accent flex h-4 w-4 cursor-pointer items-center justify-center text-[--cal-brand] transition after:h-[6px] after:w-[6px] after:rounded-full after:content-[''] after:hover:block focus:ring-2 focus:ring-offset-0 ltr:mr-2 rtl:ml-2 dark:checked:hover:text-[--cal-brand]",
              value: p.value,
              onChange: (f) => {
                a({
                  value: f.target.value,
                  optionValue: ""
                });
              },
              checked: (i == null ? void 0 : i.value) === p.value
            }
          ),
          /* @__PURE__ */ m("span", { className: "text-emphasis me-2 ms-2 text-sm", children: p.value === "somewhereElse" ? l("somewhere_else") : d(p.label) ?? "" }),
          /* @__PURE__ */ m("span", { children: p.value === "phone" && /* @__PURE__ */ m(vC, { content: l("number_in_international_format") }) })
        ] }, g)) : (
          // Use the only option itself to determine if the field is required or not.
          /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(Ko, { className: "flex items-center", children: [
            o[0].value === "somewhereElse" ? c : d(
              u(n, c) ? n : o[0].label
            ),
            !s && ((_ = r[o[0].value]) != null && _.required) ? /* @__PURE__ */ m("span", { className: "text-default -mb-2 ml-1 text-sm font-medium", children: "*" }) : null,
            o[0].value === "phone" && /* @__PURE__ */ m(vC, { content: l("number_in_international_format") })
          ] }) })
        ) }) }),
        (() => {
          const p = r[i == null ? void 0 : i.value];
          return p ? /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
            Rhe,
            {
              readOnly: !!s,
              field: {
                ...p,
                name: "optionField"
              },
              value: i == null ? void 0 : i.optionValue,
              setValue: (g) => {
                a({
                  value: i == null ? void 0 : i.value,
                  optionValue: g || ""
                });
              }
            }
          ) }) : null;
        })()
      ] });
    }
  },
  boolean: {
    propsType: Nc.boolean,
    factory: ({ readOnly: e, name: t, label: n, value: o, setValue: r }) => /* @__PURE__ */ m("div", { className: "flex", children: /* @__PURE__ */ m(
      cc,
      {
        name: t,
        onChange: (i) => {
          i.target.checked ? r(!0) : r(!1);
        },
        placeholder: "",
        checked: o,
        disabled: e,
        description: "",
        descriptionAsSafeHtml: n ?? ""
      }
    ) })
  },
  url: {
    propsType: Nc.url,
    factory: (e) => /* @__PURE__ */ m(Th.TextWidget, { type: "url", noLabel: !0, ...e })
  }
}, GA = ["boolean", "radio"];
function Ecl(e) {
  const t = {};
  if (e === null)
    return t;
  for (const [n, o] of e)
    if (t.hasOwnProperty(n)) {
      let r = t[n];
      Array.isArray(r) || (r = [r]), r.push(o), t[n] = r;
    } else
      t[n] = o;
  return t;
}
const xcl = () => {
  const e = Ef();
  return Ecl((e == null ? void 0 : e.entries()) ?? null);
}, zhe = (e) => e == null ? void 0 : e.replace(/\{([^}]+)\}.*/, "$1");
function rZ(e) {
  return Array.isArray(e) ? e : [e];
}
function Ccl(e, t) {
  return !!e.find((n) => t.find((o) => (o == null ? void 0 : o.toString()) == (n == null ? void 0 : n.toString())));
}
function Tcl(e, t) {
  if (typeof t == "string")
    return (e == null ? void 0 : e.toString()) == (t == null ? void 0 : t.toString());
  const n = rZ(t), o = rZ(e);
  return Ccl(n, o);
}
const Acl = (e) => {
  var _, p, g, f, h;
  const { getValues: t, formState: n } = No(), o = xcl();
  if (!e.disableOnPrefill || (p = (_ = n.dirtyFields) == null ? void 0 : _.responses) != null && p[e.name])
    return !1;
  const r = ((g = t()) == null ? void 0 : g.responses) || {}, i = e.type !== "radioInput" && !e.variantsConfig, a = ((h = (f = n == null ? void 0 : n.errors) == null ? void 0 : f.responses) == null ? void 0 : h.message) || "";
  if (zhe(a) === e.name)
    return !1;
  const c = o[e.name], l = r[e.name];
  if (!i && u(c) && u(l))
    return e.type === "radioInput" ? d({ value: l, optionsInputs: e.optionsInputs }) : !0;
  if (!u(l) || !o)
    return !1;
  if (c == (l == null ? void 0 : l.toString()))
    return !0;
  return Tcl(c, l);
  function u($) {
    return $ != null && $ !== "";
  }
  function d({
    value: $,
    optionsInputs: v
  }) {
    return (v == null ? void 0 : v[$.value]) ? !!$.value && !!$.optionValue : !!$.value;
  }
}, Icl = (e) => e.labelAsSafeHtml ? /* @__PURE__ */ m(
  "span",
  {
    dangerouslySetInnerHTML: { __html: QT(e.labelAsSafeHtml) }
  }
) : /* @__PURE__ */ m("span", { children: e.label }), Ocl = ({
  field: e,
  readOnly: t,
  className: n
}) => {
  const { t: o } = kt(), { control: r, formState: i } = No(), { hidden: a, placeholder: s, label: c, noLabel: l, translatedDefaultLabel: u } = zcl(
    e,
    o
  ), d = Acl(e);
  return /* @__PURE__ */ m("div", { "data-fob-field-name": e.name, className: xe(n, a ? "hidden" : ""), children: /* @__PURE__ */ m(
    Bn,
    {
      control: r,
      name: `responses.${e.name}`,
      render: ({ field: { value: _, onChange: p }, fieldState: { error: g } }) => /* @__PURE__ */ de("div", { children: [
        /* @__PURE__ */ m(
          Rhe,
          {
            field: { ...e, label: c, placeholder: s, hidden: a },
            value: _,
            readOnly: t || d,
            setValue: (f) => {
              p(f);
            },
            noLabel: l,
            translatedDefaultLabel: u
          }
        ),
        /* @__PURE__ */ m(
          BA,
          {
            name: "responses",
            errors: i.errors,
            render: ({ message: f }) => (f = f || "", !(zhe(f) === e.name) && !g ? null : (f = f.replace(/\{[^}]+\}(.*)/, "$1").trim(), a && console.error(`Error message for hidden field:${e.name} => ${f}`), /* @__PURE__ */ de(
              "div",
              {
                "data-testid": `error-message-${e.name}`,
                className: "mt-2 flex items-center text-sm text-red-700 ",
                children: [
                  /* @__PURE__ */ m(qt, { name: "info", className: "h-3 w-3 ltr:mr-2 rtl:ml-2" }),
                  /* @__PURE__ */ m("p", { children: o(f || "invalid_input") })
                ]
              }
            )))
          }
        )
      ] })
    }
  ) });
};
function Ncl(e) {
  throw new Error(`Don't know how to handle ${JSON.stringify(e)}`);
}
const mb = ({
  field: e,
  children: t,
  readOnly: n,
  htmlFor: o,
  noLabel: r = !1
}) => {
  const { t: i } = kt();
  return /* @__PURE__ */ de("div", { children: [
    r ? null : e.type !== "boolean" && e.type !== "multiemail" && e.label && /* @__PURE__ */ m("div", { className: "mb-2 flex items-center", children: /* @__PURE__ */ de(Ko, { className: "!mb-0 flex items-center", htmlFor: o, children: [
      Icl(e),
      /* @__PURE__ */ m("span", { className: "text-emphasis -mb-1 ml-1 text-sm font-medium leading-none", children: !n && e.required ? "*" : "" }),
      e.type === "phone" && /* @__PURE__ */ m(vC, { content: i("number_in_international_format") })
    ] }) }),
    t,
    e.name === "smsReminderNumber" && /* @__PURE__ */ m("div", { className: "text-sm text-gray-500", children: i("sms_workflow_consent") })
  ] });
};
function zcl(e, t) {
  var s;
  let n = !1, o = !!e.hidden;
  if (e.type === "radioInput") {
    const c = e.options;
    if ((c == null ? void 0 : c.length) === 1) {
      if (!e.optionsInputs)
        throw new Error("radioInput must have optionsInputs");
      e.optionsInputs[c[0].value] ? n = !0 : o = !0;
    }
  }
  if (GA.includes(e.type) && e.labelAsSafeHtml === void 0)
    throw new Error(`${e.name}:${e.type} type must have labelAsSafeHtml set`);
  const r = t(e.defaultLabel || ""), i = e.labelAsSafeHtml || e.label || r, a = e.placeholder || t(e.defaultPlaceholder || "");
  return (s = e.variantsConfig) != null && s.variants && Object.entries(e.variantsConfig.variants).forEach(([c, l]) => {
    l.fields.forEach((u) => {
      var p, g, f, h;
      const d = (p = sc[e.type]) == null ? void 0 : p.variantsConfig, _ = (h = (f = (g = d == null ? void 0 : d.variants) == null ? void 0 : g[c]) == null ? void 0 : f.fieldsMap[u.name]) == null ? void 0 : h.defaultLabel;
      u.label = u.label || t(_ || "");
    });
  }), { hidden: o, placeholder: a, label: i, noLabel: n, translatedDefaultLabel: r };
}
const Rhe = ({
  field: e,
  value: t,
  setValue: n,
  readOnly: o,
  noLabel: r,
  translatedDefaultLabel: i
}) => {
  const a = e.type || "text", s = Scl[a], { t: c } = kt();
  if (t !== void 0 && !((u, d) => kcl[d](u))(t, s.propsType))
    throw new Error(
      `Value ${t} is not valid for type ${s.propsType} for field ${e.name}`
    );
  if (s.propsType === "text")
    return /* @__PURE__ */ m(mb, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        minLength: e.minLength,
        maxLength: e.maxLength,
        name: e.name,
        label: e.label,
        readOnly: o,
        value: t,
        setValue: n
      }
    ) });
  if (s.propsType === "boolean")
    return /* @__PURE__ */ m(mb, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        name: e.name,
        label: e.label,
        readOnly: o,
        value: t,
        setValue: n,
        placeholder: e.placeholder
      }
    ) });
  if (s.propsType === "textList")
    return /* @__PURE__ */ m(mb, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        name: e.name,
        label: e.label,
        readOnly: o,
        value: t,
        setValue: n
      }
    ) });
  if (s.propsType === "select") {
    if (!e.options)
      throw new Error("Field options is not defined");
    return /* @__PURE__ */ m(mb, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        readOnly: o,
        value: t,
        name: e.name,
        placeholder: e.placeholder,
        setValue: n,
        options: e.options.map((u) => ({ ...u, title: u.label }))
      }
    ) });
  }
  if (s.propsType === "multiselect") {
    if (!e.options)
      throw new Error("Field options is not defined");
    return /* @__PURE__ */ m(mb, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        name: e.name,
        readOnly: o,
        value: t,
        setValue: n,
        options: e.options.map((u) => ({ ...u, title: u.label }))
      }
    ) });
  }
  if (s.propsType === "objectiveWithInput") {
    if (!e.options)
      throw new Error("Field options is not defined");
    if (!e.optionsInputs)
      throw new Error("Field optionsInputs is not defined");
    const u = e.options;
    return e.options.length ? /* @__PURE__ */ m(mb, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        readOnly: o,
        name: e.name,
        label: e.label,
        value: t,
        setValue: n,
        optionsInputs: e.optionsInputs,
        options: u,
        required: e.required,
        translatedDefaultLabel: i
      }
    ) }) : null;
  }
  if (s.propsType === "variants") {
    const u = gol(e, c);
    return u ? /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        readOnly: o,
        name: e.name,
        variant: e.variant,
        value: t,
        setValue: n,
        variants: u.variants
      }
    ) : null;
  }
  return Ncl(s), null;
}, mh = oe.enum([
  "name",
  "email",
  "location",
  "title",
  "notes",
  "guests",
  "rescheduleReason",
  "smsReminderNumber",
  "attendeePhoneNumber",
  "aiAgentCallPhoneNumber"
]), Rcl = ({
  fields: e,
  locations: t,
  rescheduleUid: n,
  isDynamicGroupBooking: o,
  bookingData: r,
  isPaidEvent: i,
  paymentCurrency: a = "USD"
}) => {
  const { t: s, i18n: c } = kt(), { watch: l, setValue: u } = No(), d = l("responses.location"), _ = n ? "reschedule" : "", p = Fu(($) => $.isInstantMeeting), g = ($, v) => `${$} (${Intl.NumberFormat(c.language, {
    style: "currency",
    currency: a
  }).format(v)})`, f = ($) => {
    var y;
    if (!((y = sc[$.type]) != null && y.supportsPricing) || !$.label || !$.price)
      return $;
    const v = typeof $.price == "string" ? parseFloat($.price) : $.price, b = g($.label, v);
    return {
      ...$,
      label: b,
      ...GA.includes($.type) && $.labelAsSafeHtml ? { labelAsSafeHtml: QT(b) } : { labelAsSafeHtml: void 0 }
    };
  }, h = ($) => {
    var v;
    return !((v = sc[$.type]) != null && v.optionsSupportPricing) || !$.options ? $ : {
      ...$,
      options: $.options.map((b) => {
        const y = b, w = y.price;
        return w ? {
          ...y,
          label: g(y.label, w)
        } : y;
      })
    };
  };
  return (
    // TODO: It might make sense to extract this logic into BookingFields config, that would allow to quickly configure system fields and their editability in fresh booking and reschedule booking view
    // The logic here intends to make modifications to booking fields based on the way we want to specifically show Booking Form
    /* @__PURE__ */ m("div", { children: e.map(($, v) => {
      var L, R;
      if (p && $.name === "location")
        return null;
      const b = ($.editable === "system" || $.editable === "system-but-optional") && !!n && r !== null;
      let w = $.editable === "user-readonly" || b, N = !!$.hidden;
      const M = $.views;
      if (M && !M.find((T) => T.id === _))
        return null;
      if ($.name === mh.Enum.rescheduleReason) {
        if (r === null)
          return null;
        w = !1;
      }
      if ($.name === mh.Enum.smsReminderNumber) {
        if ((d == null ? void 0 : d.value) === "phone")
          return u(`responses.${mh.Enum.smsReminderNumber}`, d == null ? void 0 : d.optionValue), null;
        w = !1;
      }
      if ($.name === mh.Enum.guests && (w = !1, N = o ? !0 : !!$.hidden), $.name === mh.Enum.notes && r !== null)
        return null;
      if ($.name === mh.Enum.location && (w = !1), $.name === mh.Enum.location && $.type === "radioInput") {
        if (!$.optionsInputs)
          throw new Error("radioInput must have optionsInputs");
        const T = $.optionsInputs, D = Ehe(t, s);
        D.forEach((A) => {
          const S = T[A.value];
          S && (S.placeholder = A.inputPlaceholder);
        }), $.options = D.filter(
          (A) => !!A
        );
      }
      if ($ != null && $.options) {
        const T = lil(), D = {};
        $.options.forEach((A) => {
          A.value in D ? D[A.value]++ : D[A.value] = 1;
        }), $.options = $.options.map((A) => ({
          ...A,
          value: T.includes(A.value) && D[A.value] > 1 ? A.label : A.value
        }));
      }
      let q = $;
      return i && ((L = sc[$.type]) != null && L.supportsPricing && (q = f($)), (R = sc[$.type]) != null && R.optionsSupportPricing && (q = h(q))), /* @__PURE__ */ m(
        Ocl,
        {
          className: "mb-4",
          field: { ...q, hidden: N },
          readOnly: w
        },
        v
      );
    }) })
  );
}, Pcl = () => /* @__PURE__ */ de("div", { className: "flex flex-col", children: [
  /* @__PURE__ */ m(Yo, { className: "h-7 w-32" }),
  /* @__PURE__ */ m(Yo, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ m(Yo, { className: "mt-4 h-7 w-28" }),
  /* @__PURE__ */ m(Yo, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ de("div", { className: "mt-12 flex h-7 w-full flex-row items-center gap-4", children: [
    /* @__PURE__ */ m(Yo, { className: "inline h-4 w-4 rounded-full" }),
    /* @__PURE__ */ m(Yo, { className: "inline h-7 w-32" })
  ] }),
  /* @__PURE__ */ de("div", { className: "mt-2 flex h-7 w-full flex-row items-center gap-4", children: [
    /* @__PURE__ */ m(Yo, { className: "inline h-4 w-4 rounded-full" }),
    /* @__PURE__ */ m(Yo, { className: "inline h-7 w-28" })
  ] }),
  /* @__PURE__ */ m(Yo, { className: "mt-8 h-7 w-32" }),
  /* @__PURE__ */ m(Yo, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ m(Yo, { className: "mt-4 h-7 w-28" }),
  /* @__PURE__ */ m(Yo, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ de("div", { className: "mt-6 flex flex-row gap-3", children: [
    /* @__PURE__ */ m(Yo, { className: "ml-auto h-8 w-20" }),
    /* @__PURE__ */ m(Yo, { className: "h-8 w-20" })
  ] })
] }), Dcl = ({
  onCancel: e,
  eventQuery: t,
  onSubmit: n,
  errorRef: o,
  errors: r,
  loadingStates: i,
  renderConfirmNotVerifyEmailButtonCond: a,
  bookingForm: s,
  children: c,
  extraOptions: l,
  isVerificationCodeSending: u,
  isPlatform: d = !1,
  isTimeslotUnavailable: _,
  shouldRenderCaptcha: p,
  confirmButtonDisabled: g,
  classNames: f,
  timeslot: h
}) => {
  const $ = t.data, v = _n((x) => x.setFormValues), b = _n((x) => x.bookingData), y = _n((x) => x.rescheduleUid), w = _n((x) => x.username), N = _n((x) => x.isInstantMeeting), M = wge(), { timeFormat: q, timezone: L } = Ku(), [R] = it(null), { t: T, i18n: D } = kt(), A = vn(() => {
    if (!($ != null && $.price))
      return !1;
    const x = Lg($);
    return ($ == null ? void 0 : $.price) > 0 && !Number.isNaN(x.price) && x.price > 0;
  }, [$]), S = vn(() => {
    var x;
    return $ && ((x = Lg($)) == null ? void 0 : x.currency) || "USD";
  }, [$]);
  if (t.isError)
    return /* @__PURE__ */ m(Us, { severity: "warning", message: T("error_booking_event") });
  if (t.isPending || !t.data)
    return /* @__PURE__ */ m(Pcl, {});
  if (!h)
    return /* @__PURE__ */ m(
      e$,
      {
        headline: T("timeslot_missing_title"),
        description: T("timeslot_missing_description"),
        Icon: "calendar",
        buttonText: T("timeslot_missing_cta"),
        buttonOnClick: e
      }
    );
  if (!$)
    return console.warn("No event type found for event", l), /* @__PURE__ */ m(Us, { severity: "warning", message: T("error_booking_event") });
  const E = s.watch("cfToken");
  return /* @__PURE__ */ de("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ de(
      Y_,
      {
        className: "flex h-full flex-col",
        onChange: () => {
          const x = s.getValues();
          v(x);
        },
        form: s,
        handleSubmit: n,
        noValidate: !0,
        children: [
          /* @__PURE__ */ m(
            Rcl,
            {
              isDynamicGroupBooking: !!(w && w.indexOf("+") > -1),
              fields: $.bookingFields,
              locations: $.locations,
              rescheduleUid: y || void 0,
              bookingData: b,
              isPaidEvent: A,
              paymentCurrency: S
            }
          ),
          r.hasFormErrors || r.hasDataErrors ? /* @__PURE__ */ m("div", { "data-testid": "booking-fail", children: /* @__PURE__ */ m(
            Us,
            {
              ref: o,
              className: "my-2",
              severity: "info",
              title: T(y ? "reschedule_fail" : "booking_fail"),
              message: Lcl({
                globalError: r.formErrors,
                dataError: r.dataErrors,
                t: T,
                responseVercelIdHeader: R,
                timeFormat: q,
                timezone: L,
                language: D.language
              })
            }
          ) }) : _ ? /* @__PURE__ */ m("div", { "data-testid": "slot-not-allowed-to-book", children: /* @__PURE__ */ m(
            Us,
            {
              severity: "info",
              title: T("unavailable_timeslot_title"),
              message: /* @__PURE__ */ m(
                Ld,
                {
                  t: T,
                  i18nKey: "timeslot_unavailable_book_a_new_time",
                  components: [
                    /* @__PURE__ */ m(
                      "button",
                      {
                        type: "button",
                        className: "underline",
                        onClick: e,
                        children: "Please select a new time"
                      },
                      "please-select-a-new-time-button"
                    )
                  ]
                }
              )
            }
          ) }) : null,
          !d && /* @__PURE__ */ m("div", { className: "text-subtle my-3 w-full text-xs", children: /* @__PURE__ */ m(
            Ld,
            {
              t: T,
              i18nKey: "signing_up_terms",
              components: [
                /* @__PURE__ */ m(
                  Ir,
                  {
                    className: "text-emphasis hover:underline",
                    href: `${UG}`,
                    target: "_blank",
                    children: "Terms"
                  },
                  "terms"
                ),
                /* @__PURE__ */ m(
                  Ir,
                  {
                    className: "text-emphasis hover:underline",
                    href: `${BG}`,
                    target: "_blank",
                    children: "Privacy Policy."
                  },
                  "privacy"
                )
              ]
            }
          ) }),
          M && /* @__PURE__ */ de("div", { className: "text-subtle my-3 w-full text-xs", children: [
            T("proceeding_agreement"),
            " ",
            /* @__PURE__ */ m(
              Ir,
              {
                className: "text-emphasis hover:underline",
                href: `${UG}`,
                target: "_blank",
                children: T("terms")
              },
              "terms"
            ),
            " ",
            T("and"),
            " ",
            /* @__PURE__ */ m(
              Ir,
              {
                className: "text-emphasis hover:underline",
                href: `${BG}`,
                target: "_blank",
                children: T("privacy_policy")
              },
              "privacy"
            ),
            "."
          ] }),
          /* @__PURE__ */ m("div", { className: "modalsticky mt-auto flex justify-end space-x-2 rtl:space-x-reverse", children: N ? /* @__PURE__ */ m(Jt, { type: "submit", color: "primary", loading: i.creatingInstantBooking, children: T(A ? "pay_and_book" : "confirm") }) : /* @__PURE__ */ de(nt, { children: [
            !!e && /* @__PURE__ */ m(
              Jt,
              {
                color: "minimal",
                type: "button",
                onClick: e,
                "data-testid": "back",
                className: f == null ? void 0 : f.backButton,
                children: T("back")
              }
            ),
            /* @__PURE__ */ m(
              Jt,
              {
                type: "submit",
                color: "primary",
                disabled: !!p && !E || _ || g,
                loading: i.creatingBooking || i.creatingRecurringBooking || u,
                className: f == null ? void 0 : f.confirmButton,
                "data-testid": y && b ? "confirm-reschedule-button" : "confirm-book-button",
                children: T(y && b ? "reschedule" : a ? A ? "pay_and_book" : "confirm" : "verify_email_button")
              }
            )
          ] }) })
        ]
      }
    ),
    c
  ] });
}, Lcl = ({
  globalError: e,
  dataError: t,
  t: n,
  responseVercelIdHeader: o,
  timeFormat: r,
  timezone: i,
  language: a
}) => {
  if (e)
    return e == null ? void 0 : e.message;
  const s = t;
  let c = "";
  if (s.message === jde.BookerLimitExceededReschedule) {
    const l = She({
      date: s.data.startTime,
      timeFormat: r,
      timeZone: i,
      language: a
    });
    c = `${l.date} ${l.time}`;
  }
  return s != null && s.message ? /* @__PURE__ */ de(nt, { children: [
    o ?? "",
    " ",
    n(s.message, { date: c })
  ] }) : /* @__PURE__ */ m(nt, { children: n("can_you_try_again") });
}, Mcl = "use-event-by-id", Fcl = (e) => {
  const t = `/${rs.eventTypes}/${e}`;
  return mr({
    queryKey: [Mcl, e],
    queryFn: () => At == null ? void 0 : At.get(t).then((n) => {
      if (n.data.status === Nn)
        return n.data.data;
      throw new Error(n.data.error.message);
    })
  });
}, Rj = ({
  month: e,
  monthCount: t,
  selectedDate: n,
  dayCount: o,
  prefetchNextMonth: r
}) => {
  const i = ht(), a = e ? ht(e) : i, s = a.add(t || 1, "month");
  let c, l;
  return o && o > 0 ? n ? (c = ht(n).toISOString(), l = ht(n).add(o, "day").toISOString()) : a.month() === i.month() ? (c = i.startOf("day").toISOString(), l = i.startOf("day").add(o, "day").toISOString()) : (c = a.startOf("month").toISOString(), l = a.startOf("month").add(o, "day").toISOString()) : (c = a.startOf("month").toISOString(), l = (r ? s : a).endOf("month").toISOString()), [c, l];
}, qcl = {
  metadata: null,
  theme: null,
  credentials: [],
  username: "john.doe",
  timeZone: "",
  bufferTime: 0,
  availability: [],
  id: 0,
  startTime: 0,
  endTime: 0,
  allSelectedCalendars: [],
  userLevelSelectedCalendars: [],
  schedules: [],
  defaultScheduleId: null,
  locale: "en",
  email: "john.doe@example.com",
  name: "John doe",
  destinationCalendar: null,
  hideBranding: !0,
  brandColor: "#797979",
  darkBrandColor: "#efefef",
  allowDynamicBooking: !0,
  timeFormat: 12,
  travelSchedules: [],
  locked: !1,
  isPlatformManaged: !1
}, jcl = [], Vcl = {
  isDynamic: !0,
  periodCountCalendarDays: !0,
  periodStartDate: null,
  periodEndDate: null,
  beforeEventBuffer: 0,
  afterEventBuffer: 0,
  periodType: ic.UNLIMITED,
  periodDays: null,
  slotInterval: null,
  offsetStart: 0,
  locations: [{ type: til }],
  customInputs: jcl,
  disableGuests: !0,
  minimumBookingNotice: 120,
  schedule: null,
  timeZone: null,
  successRedirectUrl: "",
  forwardParamsSuccessRedirect: !0,
  teamId: null,
  scheduleId: null,
  availability: [],
  price: 0,
  currency: "usd",
  schedulingType: Bs.COLLECTIVE,
  seatsPerTimeSlot: null,
  seatsShowAttendees: null,
  seatsShowAvailabilityCount: null,
  disableCancelling: !1,
  disableRescheduling: !1,
  onlyShowFirstAvailableSlot: !1,
  allowReschedulingPastBookings: !1,
  allowReschedulingCancelledBookings: !1,
  hideOrganizerEmail: !1,
  showOptimizedSlots: !1,
  id: 0,
  hideCalendarNotes: !1,
  hideCalendarEventDetails: !1,
  recurringEvent: null,
  destinationCalendar: null,
  team: null,
  lockTimeZoneToggleOnBookingPage: !1,
  lockedTimeZone: null,
  requiresConfirmation: !1,
  requiresConfirmationForFreeEmail: !1,
  requiresBookerEmailVerification: !1,
  bookingLimits: null,
  maxActiveBookingsPerBooker: null,
  maxActiveBookingPerBookerOfferReschedule: !1,
  durationLimits: null,
  hidden: !1,
  userId: 0,
  parentId: null,
  parent: null,
  owner: null,
  workflows: [],
  users: [qcl],
  hosts: [],
  subsetOfHosts: [],
  metadata: tce.parse({}),
  bookingFields: [],
  assignAllTeamMembers: !1,
  assignRRMembersUsingSegment: !1,
  rrSegmentQueryValue: null,
  isRRWeightsEnabled: !1,
  rescheduleWithSameRoundRobinHost: !1,
  useEventTypeDestinationCalendarEmail: !1,
  secondaryEmailId: null,
  secondaryEmail: null,
  autoTranslateDescriptionEnabled: !1,
  fieldTranslations: [],
  maxLeadThreshold: null,
  includeNoShowInRRCalculation: !1,
  useEventLevelSelectedCalendars: !1,
  rrResetInterval: null,
  rrTimestampBasis: null,
  interfaceLanguage: null,
  customReplyToEmail: null,
  restrictionScheduleId: null,
  useBookerTimezone: !1,
  profileId: null,
  profile: null,
  requiresConfirmationWillBlockSlot: !1,
  canSendCalVideoTranscriptionEmails: !1,
  instantMeetingExpiryTimeOffsetInSeconds: 0,
  instantMeetingScheduleId: null,
  instantMeetingParameters: [],
  eventTypeColor: null,
  hostGroups: [],
  bookingRequiresAuthentication: !1,
  createdAt: null,
  updatedAt: null
};
({
  ...Vcl,
  metadata: kj.parse({ multipleDuration: [15, 30, 45, 60, 90] })
});
const Bcl = (e) => Array.isArray(e) ? e : e ? [e] : [], yf = (e) => {
  e = Bcl(e);
  const t = e.map((n) => n.replace(/( |%20|%2b)/gi, "+").split("+")).flat().filter(Boolean);
  return Array.prototype.concat(...t.map((n) => ev(n)));
}, Ucl = "get-available-slots", Gcl = ({
  enabled: e,
  ...t
}) => mr({
  queryKey: [
    Ucl,
    t.startTime,
    t.endTime,
    t.eventTypeId,
    t.eventTypeSlug,
    t.isTeamEvent ?? !1,
    t.teamId ?? !1,
    t.usernameList,
    t.routedTeamMemberIds,
    t.skipContactOwner,
    t._shouldServeCache,
    t.teamMemberEmail,
    t.embedConnectVersion ?? !1
  ],
  queryFn: () => tie.get("/api/v2/slots/available", {
    params: t
  }).then((o) => {
    if (o.data.status === "success")
      return o.data.data;
    throw new Error(o.data.error.message);
  }),
  enabled: e
}), Wcl = ({
  month: e,
  timezone: t,
  username: n,
  eventSlug: o,
  eventId: r,
  selectedDate: i,
  prefetchNextMonth: a,
  duration: s,
  monthCount: c,
  dayCount: l,
  rescheduleUid: u,
  isTeamEvent: d,
  orgSlug: _,
  teamMemberEmail: p,
  useApiV2: g = !1,
  enabled: f = !0
}) => {
  const h = Fu((F) => F.state), [$, v] = Rj({
    month: e,
    monthCount: c,
    dayCount: l,
    prefetchNextMonth: a,
    selectedDate: i
  }), b = Nr.useSearchParams(), y = b ? Nj(new URLSearchParams(b.toString())) : null, w = b ? b.get("cal.skipContactOwner") === "true" : !1, N = b == null ? void 0 : b.get("cal.cache"), M = N ? N === "true" : void 0, q = hr.useUtils(), L = b == null ? void 0 : b.get("cal.routingFormResponseId"), R = b == null ? void 0 : b.get("cal.queuedFormResponseId"), T = b == null ? void 0 : b.get("email"), D = (b == null ? void 0 : b.get("cal.skipSlotsFetch")) === "true", A = L ? parseInt(L, 10) : void 0, S = (b == null ? void 0 : b.get("cal.embed.connectVersion")) || "0", E = {
    isTeamEvent: d,
    usernameList: yf(n ?? ""),
    // Prioritize slug over id, since slug is the first value we get available.
    // If we have a slug, we don't need to fetch the id.
    // TODO: are queries using eventTypeId faster? Even tho we lost time fetching the id with the slug.
    ...o ? { eventTypeSlug: o } : { eventTypeId: r ?? 0 },
    // @TODO: Old code fetched 2 days ago if we were fetching the current month.
    // Do we want / need to keep that behavior?
    startTime: $,
    // if `prefetchNextMonth` is true, two months are fetched at once.
    endTime: v,
    timeZone: t,
    duration: s ? `${s}` : void 0,
    rescheduleUid: u,
    orgSlug: _,
    teamMemberEmail: p,
    routedTeamMemberIds: y,
    skipContactOwner: w,
    _shouldServeCache: M,
    ...R ? { queuedFormResponseId: R } : { routingFormResponseId: A },
    email: T,
    // Ensures that connectVersion causes a refresh of the data
    ...S ? { embedConnectVersion: S } : {},
    _isDryRun: b ? Oj(b) : !1
  }, x = {
    trpc: {
      context: {
        skipBatch: !0
      }
    },
    // It allows people who might not have the tab in focus earlier, to get latest available slots
    // It might not work correctly in iframes, so we have refetchInterval to take care of that.
    // But where it works, it should give user latest availability even if they come back to tab before refetchInterval.
    refetchOnWindowFocus: !0,
    // It allows long sitting users to get latest available slots
    refetchInterval: gcc * 1e3,
    enabled: !D && !!n && !!e && !!t && // Should only wait for one or the other, not both.
    (!!o || !!r || r === 0) && f
  }, k = g && !!d && x.enabled, I = Gcl({
    ...E,
    enabled: k,
    duration: E.duration ? Number(E.duration) : void 0,
    routedTeamMemberIds: E.routedTeamMemberIds ?? void 0,
    teamMemberEmail: E.teamMemberEmail ?? void 0,
    eventTypeId: r ?? void 0
  }), z = hr.viewer.slots.getSchedule.useQuery(E, {
    ...x,
    // Only enable if we're not using API V2
    enabled: x.enabled && !k
  });
  return k && !I.failureReason ? (X4({
    bookerState: h,
    slotsQuery: I
  }), {
    ...I,
    /**
     * Invalidates the request and resends it regardless of any other configuration including staleTime
     */
    invalidate: () => I.refetch()
  }) : (X4({
    bookerState: h,
    slotsQuery: z
  }), {
    ...z,
    /**
     * Invalidates the request and resends it regardless of any other configuration including staleTime
     */
    invalidate: () => q.viewer.slots.getSchedule.invalidate(E)
  });
}, Phe = (e) => {
  const [t, n, o, r] = _n(
    (a) => [a.username, a.eventSlug, a.isTeamEvent, a.org],
    Xi
  ), i = hr.viewer.public.event.useQuery(
    {
      username: t ?? "",
      eventSlug: n ?? "",
      isTeamEvent: o,
      org: r ?? null,
      fromRedirectOfNonOrgLink: e == null ? void 0 : e.fromRedirectOfNonOrgLink
    },
    {
      refetchOnWindowFocus: !1,
      enabled: !(e != null && e.disabled) && !!t && !!n
    }
  );
  return {
    data: i == null ? void 0 : i.data,
    isSuccess: i == null ? void 0 : i.isSuccess,
    isError: i == null ? void 0 : i.isError,
    isPending: i == null ? void 0 : i.isPending
  };
}, Hcl = ({
  prefetchNextMonth: e,
  username: t,
  eventSlug: n,
  eventId: o,
  month: r,
  duration: i,
  monthCount: a,
  dayCount: s,
  selectedDate: c,
  orgSlug: l,
  teamMemberEmail: u,
  isTeamEvent: d,
  useApiV2: _ = !0
} = {}) => {
  const { timezone: p } = Ku(), [g, f, h, $] = _n(
    (w) => [w.username, w.eventSlug, w.month, w.selectedDuration],
    Xi
  ), v = Ef(), b = v == null ? void 0 : v.get("rescheduleUid"), y = Wcl({
    username: g ?? t,
    eventSlug: f ?? n,
    eventId: o,
    timezone: p,
    selectedDate: c,
    prefetchNextMonth: e,
    monthCount: a,
    dayCount: s,
    rescheduleUid: b,
    month: h ?? r,
    duration: $ ?? i,
    isTeamEvent: d,
    orgSlug: l,
    teamMemberEmail: u,
    useApiV2: _
  });
  return {
    data: y == null ? void 0 : y.data,
    isPending: y == null ? void 0 : y.isPending,
    isError: y == null ? void 0 : y.isError,
    isSuccess: y == null ? void 0 : y.isSuccess,
    isLoading: y == null ? void 0 : y.isLoading,
    invalidate: y == null ? void 0 : y.invalidate
  };
}, Ycl = ({ children: e, onCancel: t }) => {
  const { data: n } = Phe();
  return /* @__PURE__ */ m(Dhe, { child: e, eventLength: n == null ? void 0 : n.length, onCancel: t });
}, Kcl = ({
  children: e,
  onCancel: t
}) => {
  const n = _n((r) => r.eventId), { data: o } = Fcl(n);
  return /* @__PURE__ */ m(Dhe, { child: e, eventLength: o == null ? void 0 : o.lengthInMinutes, onCancel: t });
}, Dhe = ({
  child: e,
  eventLength: t
}) => {
  const { i18n: n, t: o } = kt(), r = _n((c) => c.selectedTimeslot), i = _n((c) => c.selectedDuration), { timeFormat: a, timezone: s } = Ku();
  return r ? /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de("h1", { className: "font-cal text-emphasis text-xl leading-5", children: [
      o("confirm_your_details"),
      " "
    ] }),
    /* @__PURE__ */ de("div", { className: "my-4 flex flex-wrap gap-2 rounded-md leading-none", children: [
      /* @__PURE__ */ m(Wi, { variant: "grayWithoutHover", startIcon: "calendar", size: "lg", children: /* @__PURE__ */ m(
        Msl,
        {
          date: r,
          timeFormat: a,
          timeZone: s,
          language: n.language
        }
      ) }),
      (i || t) && /* @__PURE__ */ m(Wi, { variant: "grayWithoutHover", startIcon: "clock", size: "lg", children: /* @__PURE__ */ m("span", { children: P5(i || t, o) }) })
    ] }),
    e
  ] }) : null;
}, Zcl = ({
  visible: e,
  onCancel: t,
  children: n
}) => {
  const o = Kr();
  return /* @__PURE__ */ m(Ss, { open: e, onOpenChange: t, children: /* @__PURE__ */ m(
    Ya,
    {
      type: void 0,
      enableOverflow: !0,
      className: "[&_.modalsticky]:border-t-subtle [&_.modalsticky]:bg-default max-h-[80vh] pb-0 [&_.modalsticky]:sticky [&_.modalsticky]:bottom-0 [&_.modalsticky]:left-0 [&_.modalsticky]:right-0 [&_.modalsticky]:-mx-8 [&_.modalsticky]:border-t [&_.modalsticky]:px-8 [&_.modalsticky]:py-4",
      children: o ? /* @__PURE__ */ m(Kcl, { onCancel: t, children: n }) : /* @__PURE__ */ m(Ycl, { onCancel: t, children: n })
    }
  ) });
}, Xcl = ({
  browsingDate: e,
  nonEmptyScheduleDays: t,
  onMonthChange: n,
  isLoading: o
}) => {
  if (o)
    return {
      moveToNextMonthOnNoAvailability: () => {
      }
    };
  const r = t.filter(
    (a) => ht(a).isSame(e, "month")
  );
  return {
    moveToNextMonthOnNoAvailability: () => {
      const a = ht().startOf("month").format("YYYY-MM"), s = e.format("YYYY-MM");
      a != s || r.length || n(e.add(1, "month"));
    }
  };
}, iZ = ({
  event: e,
  slots: t = {},
  isLoading: n,
  classNames: o,
  scrollToTimeSlots: r,
  showNoAvailabilityDialog: i
}) => {
  var b, y, w;
  const { i18n: a } = kt(), [s, c, l] = _n(
    (N) => [N.month, N.selectedDate, N.layout],
    Xi
  ), [u, d, _] = _n(
    (N) => [N.setSelectedDate, N.setMonth, N.setDayCount],
    Xi
  ), p = (N) => {
    d(N.format("YYYY-MM")), u({ date: N.format("YYYY-MM-DD") }), _(null);
  }, g = MA(t), f = s ? ht(s) : ht().startOf("month"), { moveToNextMonthOnNoAvailability: h } = Xcl({
    browsingDate: f,
    nonEmptyScheduleDays: g,
    onMonthChange: p,
    isLoading: n ?? !0
  });
  h();
  const $ = l !== "month_view" && l !== "mobile", v = {
    periodType: "UNLIMITED",
    periodStartDate: null,
    periodEndDate: null,
    periodDays: null,
    periodCountCalendarDays: !1,
    ...(e == null ? void 0 : e.data) && {
      periodType: e.data.periodType,
      periodStartDate: e.data.periodStartDate,
      periodEndDate: e.data.periodEndDate,
      periodDays: e.data.periodDays,
      periodCountCalendarDays: e.data.periodCountCalendarDays
    }
  };
  return /* @__PURE__ */ m(
    ipe,
    {
      customClassNames: {
        datePickerTitle: o == null ? void 0 : o.datePickerTitle,
        datePickerDays: o == null ? void 0 : o.datePickerDays,
        datePickersDates: o == null ? void 0 : o.datePickerDate,
        datePickerDatesActive: o == null ? void 0 : o.datePickerDatesActive,
        datePickerToggle: o == null ? void 0 : o.datePickerToggle
      },
      className: o == null ? void 0 : o.datePickerContainer,
      isLoading: n,
      onChange: (N, M) => {
        u({
          date: N === null ? N : N.format("YYYY-MM-DD"),
          omitUpdatingParams: M,
          preventMonthSwitching: !$
          // Prevent month switching when in monthly view
        });
      },
      onMonthChange: p,
      includedDates: g,
      locale: a.language,
      browsingDate: s ? ht(s) : void 0,
      selected: ht(c),
      weekStart: H_e((w = (y = (b = e == null ? void 0 : e.data) == null ? void 0 : b.subsetOfUsers) == null ? void 0 : y[0]) == null ? void 0 : w.weekStart),
      slots: t,
      scrollToTimeSlots: r,
      periodData: v,
      isCompact: $,
      showNoAvailabilityDialog: i
    }
  );
}, Jcl = ({ isEmbed: e }) => {
  const { t } = kt(), [n, o] = it(!0);
  return n ? /* @__PURE__ */ m(
    "div",
    {
      onClick: () => o(!1),
      className: `bg-default border-subtle fixed left-1/2 ${e ? "top-0" : "top-4"} z-50 -translate-x-1/2 transform cursor-pointer items-center gap-3 rounded-xl border p-3 text-sm shadow-md`,
      children: /* @__PURE__ */ de("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ m("div", { className: "relative", children: /* @__PURE__ */ m(qt, { name: "info", className: "h-5 w-5 text-orange-500" }) }),
        /* @__PURE__ */ m("div", { className: "text-emphasis font-medium", "data-testid": "dry-run-msg", children: t("dry_run_mode_active") })
      ] })
    }
  ) : null;
};
var ri = {};
const Qcl = "Á", ell = "á", tll = "Ă", nll = "ă", oll = "∾", rll = "∿", ill = "∾̳", all = "Â", sll = "â", cll = "´", lll = "А", ull = "а", dll = "Æ", _ll = "æ", pll = "⁡", mll = "𝔄", fll = "𝔞", gll = "À", hll = "à", vll = "ℵ", bll = "ℵ", yll = "Α", $ll = "α", wll = "Ā", kll = "ā", Sll = "⨿", Ell = "&", xll = "&", Cll = "⩕", Tll = "⩓", All = "∧", Ill = "⩜", Oll = "⩘", Nll = "⩚", zll = "∠", Rll = "⦤", Pll = "∠", Dll = "⦨", Lll = "⦩", Mll = "⦪", Fll = "⦫", qll = "⦬", jll = "⦭", Vll = "⦮", Bll = "⦯", Ull = "∡", Gll = "∟", Wll = "⊾", Hll = "⦝", Yll = "∢", Kll = "Å", Zll = "⍼", Xll = "Ą", Jll = "ą", Qll = "𝔸", eul = "𝕒", tul = "⩯", nul = "≈", oul = "⩰", rul = "≊", iul = "≋", aul = "'", sul = "⁡", cul = "≈", lul = "≊", uul = "Å", dul = "å", _ul = "𝒜", pul = "𝒶", mul = "≔", ful = "*", gul = "≈", hul = "≍", vul = "Ã", bul = "ã", yul = "Ä", $ul = "ä", wul = "∳", kul = "⨑", Sul = "≌", Eul = "϶", xul = "‵", Cul = "∽", Tul = "⋍", Aul = "∖", Iul = "⫧", Oul = "⊽", Nul = "⌅", zul = "⌆", Rul = "⌅", Pul = "⎵", Dul = "⎶", Lul = "≌", Mul = "Б", Ful = "б", qul = "„", jul = "∵", Vul = "∵", Bul = "∵", Uul = "⦰", Gul = "϶", Wul = "ℬ", Hul = "ℬ", Yul = "Β", Kul = "β", Zul = "ℶ", Xul = "≬", Jul = "𝔅", Qul = "𝔟", edl = "⋂", tdl = "◯", ndl = "⋃", odl = "⨀", rdl = "⨁", idl = "⨂", adl = "⨆", sdl = "★", cdl = "▽", ldl = "△", udl = "⨄", ddl = "⋁", _dl = "⋀", pdl = "⤍", mdl = "⧫", fdl = "▪", gdl = "▴", hdl = "▾", vdl = "◂", bdl = "▸", ydl = "␣", $dl = "▒", wdl = "░", kdl = "▓", Sdl = "█", Edl = "=⃥", xdl = "≡⃥", Cdl = "⫭", Tdl = "⌐", Adl = "𝔹", Idl = "𝕓", Odl = "⊥", Ndl = "⊥", zdl = "⋈", Rdl = "⧉", Pdl = "┐", Ddl = "╕", Ldl = "╖", Mdl = "╗", Fdl = "┌", qdl = "╒", jdl = "╓", Vdl = "╔", Bdl = "─", Udl = "═", Gdl = "┬", Wdl = "╤", Hdl = "╥", Ydl = "╦", Kdl = "┴", Zdl = "╧", Xdl = "╨", Jdl = "╩", Qdl = "⊟", e_l = "⊞", t_l = "⊠", n_l = "┘", o_l = "╛", r_l = "╜", i_l = "╝", a_l = "└", s_l = "╘", c_l = "╙", l_l = "╚", u_l = "│", d_l = "║", __l = "┼", p_l = "╪", m_l = "╫", f_l = "╬", g_l = "┤", h_l = "╡", v_l = "╢", b_l = "╣", y_l = "├", $_l = "╞", w_l = "╟", k_l = "╠", S_l = "‵", E_l = "˘", x_l = "˘", C_l = "¦", T_l = "𝒷", A_l = "ℬ", I_l = "⁏", O_l = "∽", N_l = "⋍", z_l = "⧅", R_l = "\\", P_l = "⟈", D_l = "•", L_l = "•", M_l = "≎", F_l = "⪮", q_l = "≏", j_l = "≎", V_l = "≏", B_l = "Ć", U_l = "ć", G_l = "⩄", W_l = "⩉", H_l = "⩋", Y_l = "∩", K_l = "⋒", Z_l = "⩇", X_l = "⩀", J_l = "ⅅ", Q_l = "∩︀", epl = "⁁", tpl = "ˇ", npl = "ℭ", opl = "⩍", rpl = "Č", ipl = "č", apl = "Ç", spl = "ç", cpl = "Ĉ", lpl = "ĉ", upl = "∰", dpl = "⩌", _pl = "⩐", ppl = "Ċ", mpl = "ċ", fpl = "¸", gpl = "¸", hpl = "⦲", vpl = "¢", bpl = "·", ypl = "·", $pl = "𝔠", wpl = "ℭ", kpl = "Ч", Spl = "ч", Epl = "✓", xpl = "✓", Cpl = "Χ", Tpl = "χ", Apl = "ˆ", Ipl = "≗", Opl = "↺", Npl = "↻", zpl = "⊛", Rpl = "⊚", Ppl = "⊝", Dpl = "⊙", Lpl = "®", Mpl = "Ⓢ", Fpl = "⊖", qpl = "⊕", jpl = "⊗", Vpl = "○", Bpl = "⧃", Upl = "≗", Gpl = "⨐", Wpl = "⫯", Hpl = "⧂", Ypl = "∲", Kpl = "”", Zpl = "’", Xpl = "♣", Jpl = "♣", Qpl = ":", eml = "∷", tml = "⩴", nml = "≔", oml = "≔", rml = ",", iml = "@", aml = "∁", sml = "∘", cml = "∁", lml = "ℂ", uml = "≅", dml = "⩭", _ml = "≡", pml = "∮", mml = "∯", fml = "∮", gml = "𝕔", hml = "ℂ", vml = "∐", bml = "∐", yml = "©", $ml = "©", wml = "℗", kml = "∳", Sml = "↵", Eml = "✗", xml = "⨯", Cml = "𝒞", Tml = "𝒸", Aml = "⫏", Iml = "⫑", Oml = "⫐", Nml = "⫒", zml = "⋯", Rml = "⤸", Pml = "⤵", Dml = "⋞", Lml = "⋟", Mml = "↶", Fml = "⤽", qml = "⩈", jml = "⩆", Vml = "≍", Bml = "∪", Uml = "⋓", Gml = "⩊", Wml = "⊍", Hml = "⩅", Yml = "∪︀", Kml = "↷", Zml = "⤼", Xml = "⋞", Jml = "⋟", Qml = "⋎", efl = "⋏", tfl = "¤", nfl = "↶", ofl = "↷", rfl = "⋎", ifl = "⋏", afl = "∲", sfl = "∱", cfl = "⌭", lfl = "†", ufl = "‡", dfl = "ℸ", _fl = "↓", pfl = "↡", mfl = "⇓", ffl = "‐", gfl = "⫤", hfl = "⊣", vfl = "⤏", bfl = "˝", yfl = "Ď", $fl = "ď", wfl = "Д", kfl = "д", Sfl = "‡", Efl = "⇊", xfl = "ⅅ", Cfl = "ⅆ", Tfl = "⤑", Afl = "⩷", Ifl = "°", Ofl = "∇", Nfl = "Δ", zfl = "δ", Rfl = "⦱", Pfl = "⥿", Dfl = "𝔇", Lfl = "𝔡", Mfl = "⥥", Ffl = "⇃", qfl = "⇂", jfl = "´", Vfl = "˙", Bfl = "˝", Ufl = "`", Gfl = "˜", Wfl = "⋄", Hfl = "⋄", Yfl = "⋄", Kfl = "♦", Zfl = "♦", Xfl = "¨", Jfl = "ⅆ", Qfl = "ϝ", egl = "⋲", tgl = "÷", ngl = "÷", ogl = "⋇", rgl = "⋇", igl = "Ђ", agl = "ђ", sgl = "⌞", cgl = "⌍", lgl = "$", ugl = "𝔻", dgl = "𝕕", _gl = "¨", pgl = "˙", mgl = "⃜", fgl = "≐", ggl = "≑", hgl = "≐", vgl = "∸", bgl = "∔", ygl = "⊡", $gl = "⌆", wgl = "∯", kgl = "¨", Sgl = "⇓", Egl = "⇐", xgl = "⇔", Cgl = "⫤", Tgl = "⟸", Agl = "⟺", Igl = "⟹", Ogl = "⇒", Ngl = "⊨", zgl = "⇑", Rgl = "⇕", Pgl = "∥", Dgl = "⤓", Lgl = "↓", Mgl = "↓", Fgl = "⇓", qgl = "⇵", jgl = "̑", Vgl = "⇊", Bgl = "⇃", Ugl = "⇂", Ggl = "⥐", Wgl = "⥞", Hgl = "⥖", Ygl = "↽", Kgl = "⥟", Zgl = "⥗", Xgl = "⇁", Jgl = "↧", Qgl = "⊤", ehl = "⤐", thl = "⌟", nhl = "⌌", ohl = "𝒟", rhl = "𝒹", ihl = "Ѕ", ahl = "ѕ", shl = "⧶", chl = "Đ", lhl = "đ", uhl = "⋱", dhl = "▿", _hl = "▾", phl = "⇵", mhl = "⥯", fhl = "⦦", ghl = "Џ", hhl = "џ", vhl = "⟿", bhl = "É", yhl = "é", $hl = "⩮", whl = "Ě", khl = "ě", Shl = "Ê", Ehl = "ê", xhl = "≖", Chl = "≕", Thl = "Э", Ahl = "э", Ihl = "⩷", Ohl = "Ė", Nhl = "ė", zhl = "≑", Rhl = "ⅇ", Phl = "≒", Dhl = "𝔈", Lhl = "𝔢", Mhl = "⪚", Fhl = "È", qhl = "è", jhl = "⪖", Vhl = "⪘", Bhl = "⪙", Uhl = "∈", Ghl = "⏧", Whl = "ℓ", Hhl = "⪕", Yhl = "⪗", Khl = "Ē", Zhl = "ē", Xhl = "∅", Jhl = "∅", Qhl = "◻", evl = "∅", tvl = "▫", nvl = " ", ovl = " ", rvl = " ", ivl = "Ŋ", avl = "ŋ", svl = " ", cvl = "Ę", lvl = "ę", uvl = "𝔼", dvl = "𝕖", _vl = "⋕", pvl = "⧣", mvl = "⩱", fvl = "ε", gvl = "Ε", hvl = "ε", vvl = "ϵ", bvl = "≖", yvl = "≕", $vl = "≂", wvl = "⪖", kvl = "⪕", Svl = "⩵", Evl = "=", xvl = "≂", Cvl = "≟", Tvl = "⇌", Avl = "≡", Ivl = "⩸", Ovl = "⧥", Nvl = "⥱", zvl = "≓", Rvl = "ℯ", Pvl = "ℰ", Dvl = "≐", Lvl = "⩳", Mvl = "≂", Fvl = "Η", qvl = "η", jvl = "Ð", Vvl = "ð", Bvl = "Ë", Uvl = "ë", Gvl = "€", Wvl = "!", Hvl = "∃", Yvl = "∃", Kvl = "ℰ", Zvl = "ⅇ", Xvl = "ⅇ", Jvl = "≒", Qvl = "Ф", ebl = "ф", tbl = "♀", nbl = "ﬃ", obl = "ﬀ", rbl = "ﬄ", ibl = "𝔉", abl = "𝔣", sbl = "ﬁ", cbl = "◼", lbl = "▪", ubl = "fj", dbl = "♭", _bl = "ﬂ", pbl = "▱", mbl = "ƒ", fbl = "𝔽", gbl = "𝕗", hbl = "∀", vbl = "∀", bbl = "⋔", ybl = "⫙", $bl = "ℱ", wbl = "⨍", kbl = "½", Sbl = "⅓", Ebl = "¼", xbl = "⅕", Cbl = "⅙", Tbl = "⅛", Abl = "⅔", Ibl = "⅖", Obl = "¾", Nbl = "⅗", zbl = "⅜", Rbl = "⅘", Pbl = "⅚", Dbl = "⅝", Lbl = "⅞", Mbl = "⁄", Fbl = "⌢", qbl = "𝒻", jbl = "ℱ", Vbl = "ǵ", Bbl = "Γ", Ubl = "γ", Gbl = "Ϝ", Wbl = "ϝ", Hbl = "⪆", Ybl = "Ğ", Kbl = "ğ", Zbl = "Ģ", Xbl = "Ĝ", Jbl = "ĝ", Qbl = "Г", eyl = "г", tyl = "Ġ", nyl = "ġ", oyl = "≥", ryl = "≧", iyl = "⪌", ayl = "⋛", syl = "≥", cyl = "≧", lyl = "⩾", uyl = "⪩", dyl = "⩾", _yl = "⪀", pyl = "⪂", myl = "⪄", fyl = "⋛︀", gyl = "⪔", hyl = "𝔊", vyl = "𝔤", byl = "≫", yyl = "⋙", $yl = "⋙", wyl = "ℷ", kyl = "Ѓ", Syl = "ѓ", Eyl = "⪥", xyl = "≷", Cyl = "⪒", Tyl = "⪤", Ayl = "⪊", Iyl = "⪊", Oyl = "⪈", Nyl = "≩", zyl = "⪈", Ryl = "≩", Pyl = "⋧", Dyl = "𝔾", Lyl = "𝕘", Myl = "`", Fyl = "≥", qyl = "⋛", jyl = "≧", Vyl = "⪢", Byl = "≷", Uyl = "⩾", Gyl = "≳", Wyl = "𝒢", Hyl = "ℊ", Yyl = "≳", Kyl = "⪎", Zyl = "⪐", Xyl = "⪧", Jyl = "⩺", Qyl = ">", e$l = ">", t$l = "≫", n$l = "⋗", o$l = "⦕", r$l = "⩼", i$l = "⪆", a$l = "⥸", s$l = "⋗", c$l = "⋛", l$l = "⪌", u$l = "≷", d$l = "≳", _$l = "≩︀", p$l = "≩︀", m$l = "ˇ", f$l = " ", g$l = "½", h$l = "ℋ", v$l = "Ъ", b$l = "ъ", y$l = "⥈", $$l = "↔", w$l = "⇔", k$l = "↭", S$l = "^", E$l = "ℏ", x$l = "Ĥ", C$l = "ĥ", T$l = "♥", A$l = "♥", I$l = "…", O$l = "⊹", N$l = "𝔥", z$l = "ℌ", R$l = "ℋ", P$l = "⤥", D$l = "⤦", L$l = "⇿", M$l = "∻", F$l = "↩", q$l = "↪", j$l = "𝕙", V$l = "ℍ", B$l = "―", U$l = "─", G$l = "𝒽", W$l = "ℋ", H$l = "ℏ", Y$l = "Ħ", K$l = "ħ", Z$l = "≎", X$l = "≏", J$l = "⁃", Q$l = "‐", ewl = "Í", twl = "í", nwl = "⁣", owl = "Î", rwl = "î", iwl = "И", awl = "и", swl = "İ", cwl = "Е", lwl = "е", uwl = "¡", dwl = "⇔", _wl = "𝔦", pwl = "ℑ", mwl = "Ì", fwl = "ì", gwl = "ⅈ", hwl = "⨌", vwl = "∭", bwl = "⧜", ywl = "℩", $wl = "Ĳ", wwl = "ĳ", kwl = "Ī", Swl = "ī", Ewl = "ℑ", xwl = "ⅈ", Cwl = "ℐ", Twl = "ℑ", Awl = "ı", Iwl = "ℑ", Owl = "⊷", Nwl = "Ƶ", zwl = "⇒", Rwl = "℅", Pwl = "∞", Dwl = "⧝", Lwl = "ı", Mwl = "⊺", Fwl = "∫", qwl = "∬", jwl = "ℤ", Vwl = "∫", Bwl = "⊺", Uwl = "⋂", Gwl = "⨗", Wwl = "⨼", Hwl = "⁣", Ywl = "⁢", Kwl = "Ё", Zwl = "ё", Xwl = "Į", Jwl = "į", Qwl = "𝕀", ekl = "𝕚", tkl = "Ι", nkl = "ι", okl = "⨼", rkl = "¿", ikl = "𝒾", akl = "ℐ", skl = "∈", ckl = "⋵", lkl = "⋹", ukl = "⋴", dkl = "⋳", _kl = "∈", pkl = "⁢", mkl = "Ĩ", fkl = "ĩ", gkl = "І", hkl = "і", vkl = "Ï", bkl = "ï", ykl = "Ĵ", $kl = "ĵ", wkl = "Й", kkl = "й", Skl = "𝔍", Ekl = "𝔧", xkl = "ȷ", Ckl = "𝕁", Tkl = "𝕛", Akl = "𝒥", Ikl = "𝒿", Okl = "Ј", Nkl = "ј", zkl = "Є", Rkl = "є", Pkl = "Κ", Dkl = "κ", Lkl = "ϰ", Mkl = "Ķ", Fkl = "ķ", qkl = "К", jkl = "к", Vkl = "𝔎", Bkl = "𝔨", Ukl = "ĸ", Gkl = "Х", Wkl = "х", Hkl = "Ќ", Ykl = "ќ", Kkl = "𝕂", Zkl = "𝕜", Xkl = "𝒦", Jkl = "𝓀", Qkl = "⇚", e0l = "Ĺ", t0l = "ĺ", n0l = "⦴", o0l = "ℒ", r0l = "Λ", i0l = "λ", a0l = "⟨", s0l = "⟪", c0l = "⦑", l0l = "⟨", u0l = "⪅", d0l = "ℒ", _0l = "«", p0l = "⇤", m0l = "⤟", f0l = "←", g0l = "↞", h0l = "⇐", v0l = "⤝", b0l = "↩", y0l = "↫", $0l = "⤹", w0l = "⥳", k0l = "↢", S0l = "⤙", E0l = "⤛", x0l = "⪫", C0l = "⪭", T0l = "⪭︀", A0l = "⤌", I0l = "⤎", O0l = "❲", N0l = "{", z0l = "[", R0l = "⦋", P0l = "⦏", D0l = "⦍", L0l = "Ľ", M0l = "ľ", F0l = "Ļ", q0l = "ļ", j0l = "⌈", V0l = "{", B0l = "Л", U0l = "л", G0l = "⤶", W0l = "“", H0l = "„", Y0l = "⥧", K0l = "⥋", Z0l = "↲", X0l = "≤", J0l = "≦", Q0l = "⟨", e1l = "⇤", t1l = "←", n1l = "←", o1l = "⇐", r1l = "⇆", i1l = "↢", a1l = "⌈", s1l = "⟦", c1l = "⥡", l1l = "⥙", u1l = "⇃", d1l = "⌊", _1l = "↽", p1l = "↼", m1l = "⇇", f1l = "↔", g1l = "↔", h1l = "⇔", v1l = "⇆", b1l = "⇋", y1l = "↭", $1l = "⥎", w1l = "↤", k1l = "⊣", S1l = "⥚", E1l = "⋋", x1l = "⧏", C1l = "⊲", T1l = "⊴", A1l = "⥑", I1l = "⥠", O1l = "⥘", N1l = "↿", z1l = "⥒", R1l = "↼", P1l = "⪋", D1l = "⋚", L1l = "≤", M1l = "≦", F1l = "⩽", q1l = "⪨", j1l = "⩽", V1l = "⩿", B1l = "⪁", U1l = "⪃", G1l = "⋚︀", W1l = "⪓", H1l = "⪅", Y1l = "⋖", K1l = "⋚", Z1l = "⪋", X1l = "⋚", J1l = "≦", Q1l = "≶", eSl = "≶", tSl = "⪡", nSl = "≲", oSl = "⩽", rSl = "≲", iSl = "⥼", aSl = "⌊", sSl = "𝔏", cSl = "𝔩", lSl = "≶", uSl = "⪑", dSl = "⥢", _Sl = "↽", pSl = "↼", mSl = "⥪", fSl = "▄", gSl = "Љ", hSl = "љ", vSl = "⇇", bSl = "≪", ySl = "⋘", $Sl = "⌞", wSl = "⇚", kSl = "⥫", SSl = "◺", ESl = "Ŀ", xSl = "ŀ", CSl = "⎰", TSl = "⎰", ASl = "⪉", ISl = "⪉", OSl = "⪇", NSl = "≨", zSl = "⪇", RSl = "≨", PSl = "⋦", DSl = "⟬", LSl = "⇽", MSl = "⟦", FSl = "⟵", qSl = "⟵", jSl = "⟸", VSl = "⟷", BSl = "⟷", USl = "⟺", GSl = "⟼", WSl = "⟶", HSl = "⟶", YSl = "⟹", KSl = "↫", ZSl = "↬", XSl = "⦅", JSl = "𝕃", QSl = "𝕝", eEl = "⨭", tEl = "⨴", nEl = "∗", oEl = "_", rEl = "↙", iEl = "↘", aEl = "◊", sEl = "◊", cEl = "⧫", lEl = "(", uEl = "⦓", dEl = "⇆", _El = "⌟", pEl = "⇋", mEl = "⥭", fEl = "‎", gEl = "⊿", hEl = "‹", vEl = "𝓁", bEl = "ℒ", yEl = "↰", $El = "↰", wEl = "≲", kEl = "⪍", SEl = "⪏", EEl = "[", xEl = "‘", CEl = "‚", TEl = "Ł", AEl = "ł", IEl = "⪦", OEl = "⩹", NEl = "<", zEl = "<", REl = "≪", PEl = "⋖", DEl = "⋋", LEl = "⋉", MEl = "⥶", FEl = "⩻", qEl = "◃", jEl = "⊴", VEl = "◂", BEl = "⦖", UEl = "⥊", GEl = "⥦", WEl = "≨︀", HEl = "≨︀", YEl = "¯", KEl = "♂", ZEl = "✠", XEl = "✠", JEl = "↦", QEl = "↦", exl = "↧", txl = "↤", nxl = "↥", oxl = "▮", rxl = "⨩", ixl = "М", axl = "м", sxl = "—", cxl = "∺", lxl = "∡", uxl = " ", dxl = "ℳ", _xl = "𝔐", pxl = "𝔪", mxl = "℧", fxl = "µ", gxl = "*", hxl = "⫰", vxl = "∣", bxl = "·", yxl = "⊟", $xl = "−", wxl = "∸", kxl = "⨪", Sxl = "∓", Exl = "⫛", xxl = "…", Cxl = "∓", Txl = "⊧", Axl = "𝕄", Ixl = "𝕞", Oxl = "∓", Nxl = "𝓂", zxl = "ℳ", Rxl = "∾", Pxl = "Μ", Dxl = "μ", Lxl = "⊸", Mxl = "⊸", Fxl = "∇", qxl = "Ń", jxl = "ń", Vxl = "∠⃒", Bxl = "≉", Uxl = "⩰̸", Gxl = "≋̸", Wxl = "ŉ", Hxl = "≉", Yxl = "♮", Kxl = "ℕ", Zxl = "♮", Xxl = " ", Jxl = "≎̸", Qxl = "≏̸", eCl = "⩃", tCl = "Ň", nCl = "ň", oCl = "Ņ", rCl = "ņ", iCl = "≇", aCl = "⩭̸", sCl = "⩂", cCl = "Н", lCl = "н", uCl = "–", dCl = "⤤", _Cl = "↗", pCl = "⇗", mCl = "↗", fCl = "≠", gCl = "≐̸", hCl = "​", vCl = "​", bCl = "​", yCl = "​", $Cl = "≢", wCl = "⤨", kCl = "≂̸", SCl = "≫", ECl = "≪", xCl = `
`, CCl = "∄", TCl = "∄", ACl = "𝔑", ICl = "𝔫", OCl = "≧̸", NCl = "≱", zCl = "≱", RCl = "≧̸", PCl = "⩾̸", DCl = "⩾̸", LCl = "⋙̸", MCl = "≵", FCl = "≫⃒", qCl = "≯", jCl = "≯", VCl = "≫̸", BCl = "↮", UCl = "⇎", GCl = "⫲", WCl = "∋", HCl = "⋼", YCl = "⋺", KCl = "∋", ZCl = "Њ", XCl = "њ", JCl = "↚", QCl = "⇍", eTl = "‥", tTl = "≦̸", nTl = "≰", oTl = "↚", rTl = "⇍", iTl = "↮", aTl = "⇎", sTl = "≰", cTl = "≦̸", lTl = "⩽̸", uTl = "⩽̸", dTl = "≮", _Tl = "⋘̸", pTl = "≴", mTl = "≪⃒", fTl = "≮", gTl = "⋪", hTl = "⋬", vTl = "≪̸", bTl = "∤", yTl = "⁠", $Tl = " ", wTl = "𝕟", kTl = "ℕ", STl = "⫬", ETl = "¬", xTl = "≢", CTl = "≭", TTl = "∦", ATl = "∉", ITl = "≠", OTl = "≂̸", NTl = "∄", zTl = "≯", RTl = "≱", PTl = "≧̸", DTl = "≫̸", LTl = "≹", MTl = "⩾̸", FTl = "≵", qTl = "≎̸", jTl = "≏̸", VTl = "∉", BTl = "⋵̸", UTl = "⋹̸", GTl = "∉", WTl = "⋷", HTl = "⋶", YTl = "⧏̸", KTl = "⋪", ZTl = "⋬", XTl = "≮", JTl = "≰", QTl = "≸", eAl = "≪̸", tAl = "⩽̸", nAl = "≴", oAl = "⪢̸", rAl = "⪡̸", iAl = "∌", aAl = "∌", sAl = "⋾", cAl = "⋽", lAl = "⊀", uAl = "⪯̸", dAl = "⋠", _Al = "∌", pAl = "⧐̸", mAl = "⋫", fAl = "⋭", gAl = "⊏̸", hAl = "⋢", vAl = "⊐̸", bAl = "⋣", yAl = "⊂⃒", $Al = "⊈", wAl = "⊁", kAl = "⪰̸", SAl = "⋡", EAl = "≿̸", xAl = "⊃⃒", CAl = "⊉", TAl = "≁", AAl = "≄", IAl = "≇", OAl = "≉", NAl = "∤", zAl = "∦", RAl = "∦", PAl = "⫽⃥", DAl = "∂̸", LAl = "⨔", MAl = "⊀", FAl = "⋠", qAl = "⊀", jAl = "⪯̸", VAl = "⪯̸", BAl = "⤳̸", UAl = "↛", GAl = "⇏", WAl = "↝̸", HAl = "↛", YAl = "⇏", KAl = "⋫", ZAl = "⋭", XAl = "⊁", JAl = "⋡", QAl = "⪰̸", e2l = "𝒩", t2l = "𝓃", n2l = "∤", o2l = "∦", r2l = "≁", i2l = "≄", a2l = "≄", s2l = "∤", c2l = "∦", l2l = "⋢", u2l = "⋣", d2l = "⊄", _2l = "⫅̸", p2l = "⊈", m2l = "⊂⃒", f2l = "⊈", g2l = "⫅̸", h2l = "⊁", v2l = "⪰̸", b2l = "⊅", y2l = "⫆̸", $2l = "⊉", w2l = "⊃⃒", k2l = "⊉", S2l = "⫆̸", E2l = "≹", x2l = "Ñ", C2l = "ñ", T2l = "≸", A2l = "⋪", I2l = "⋬", O2l = "⋫", N2l = "⋭", z2l = "Ν", R2l = "ν", P2l = "#", D2l = "№", L2l = " ", M2l = "≍⃒", F2l = "⊬", q2l = "⊭", j2l = "⊮", V2l = "⊯", B2l = "≥⃒", U2l = ">⃒", G2l = "⤄", W2l = "⧞", H2l = "⤂", Y2l = "≤⃒", K2l = "<⃒", Z2l = "⊴⃒", X2l = "⤃", J2l = "⊵⃒", Q2l = "∼⃒", eIl = "⤣", tIl = "↖", nIl = "⇖", oIl = "↖", rIl = "⤧", iIl = "Ó", aIl = "ó", sIl = "⊛", cIl = "Ô", lIl = "ô", uIl = "⊚", dIl = "О", _Il = "о", pIl = "⊝", mIl = "Ő", fIl = "ő", gIl = "⨸", hIl = "⊙", vIl = "⦼", bIl = "Œ", yIl = "œ", $Il = "⦿", wIl = "𝔒", kIl = "𝔬", SIl = "˛", EIl = "Ò", xIl = "ò", CIl = "⧁", TIl = "⦵", AIl = "Ω", IIl = "∮", OIl = "↺", NIl = "⦾", zIl = "⦻", RIl = "‾", PIl = "⧀", DIl = "Ō", LIl = "ō", MIl = "Ω", FIl = "ω", qIl = "Ο", jIl = "ο", VIl = "⦶", BIl = "⊖", UIl = "𝕆", GIl = "𝕠", WIl = "⦷", HIl = "“", YIl = "‘", KIl = "⦹", ZIl = "⊕", XIl = "↻", JIl = "⩔", QIl = "∨", eOl = "⩝", tOl = "ℴ", nOl = "ℴ", oOl = "ª", rOl = "º", iOl = "⊶", aOl = "⩖", sOl = "⩗", cOl = "⩛", lOl = "Ⓢ", uOl = "𝒪", dOl = "ℴ", _Ol = "Ø", pOl = "ø", mOl = "⊘", fOl = "Õ", gOl = "õ", hOl = "⨶", vOl = "⨷", bOl = "⊗", yOl = "Ö", $Ol = "ö", wOl = "⌽", kOl = "‾", SOl = "⏞", EOl = "⎴", xOl = "⏜", COl = "¶", TOl = "∥", AOl = "∥", IOl = "⫳", OOl = "⫽", NOl = "∂", zOl = "∂", ROl = "П", POl = "п", DOl = "%", LOl = ".", MOl = "‰", FOl = "⊥", qOl = "‱", jOl = "𝔓", VOl = "𝔭", BOl = "Φ", UOl = "φ", GOl = "ϕ", WOl = "ℳ", HOl = "☎", YOl = "Π", KOl = "π", ZOl = "⋔", XOl = "ϖ", JOl = "ℏ", QOl = "ℎ", eNl = "ℏ", tNl = "⨣", nNl = "⊞", oNl = "⨢", rNl = "+", iNl = "∔", aNl = "⨥", sNl = "⩲", cNl = "±", lNl = "±", uNl = "⨦", dNl = "⨧", _Nl = "±", pNl = "ℌ", mNl = "⨕", fNl = "𝕡", gNl = "ℙ", hNl = "£", vNl = "⪷", bNl = "⪻", yNl = "≺", $Nl = "≼", wNl = "⪷", kNl = "≺", SNl = "≼", ENl = "≺", xNl = "⪯", CNl = "≼", TNl = "≾", ANl = "⪯", INl = "⪹", ONl = "⪵", NNl = "⋨", zNl = "⪯", RNl = "⪳", PNl = "≾", DNl = "′", LNl = "″", MNl = "ℙ", FNl = "⪹", qNl = "⪵", jNl = "⋨", VNl = "∏", BNl = "∏", UNl = "⌮", GNl = "⌒", WNl = "⌓", HNl = "∝", YNl = "∝", KNl = "∷", ZNl = "∝", XNl = "≾", JNl = "⊰", QNl = "𝒫", ezl = "𝓅", tzl = "Ψ", nzl = "ψ", ozl = " ", rzl = "𝔔", izl = "𝔮", azl = "⨌", szl = "𝕢", czl = "ℚ", lzl = "⁗", uzl = "𝒬", dzl = "𝓆", _zl = "ℍ", pzl = "⨖", mzl = "?", fzl = "≟", gzl = '"', hzl = '"', vzl = "⇛", bzl = "∽̱", yzl = "Ŕ", $zl = "ŕ", wzl = "√", kzl = "⦳", Szl = "⟩", Ezl = "⟫", xzl = "⦒", Czl = "⦥", Tzl = "⟩", Azl = "»", Izl = "⥵", Ozl = "⇥", Nzl = "⤠", zzl = "⤳", Rzl = "→", Pzl = "↠", Dzl = "⇒", Lzl = "⤞", Mzl = "↪", Fzl = "↬", qzl = "⥅", jzl = "⥴", Vzl = "⤖", Bzl = "↣", Uzl = "↝", Gzl = "⤚", Wzl = "⤜", Hzl = "∶", Yzl = "ℚ", Kzl = "⤍", Zzl = "⤏", Xzl = "⤐", Jzl = "❳", Qzl = "}", eRl = "]", tRl = "⦌", nRl = "⦎", oRl = "⦐", rRl = "Ř", iRl = "ř", aRl = "Ŗ", sRl = "ŗ", cRl = "⌉", lRl = "}", uRl = "Р", dRl = "р", _Rl = "⤷", pRl = "⥩", mRl = "”", fRl = "”", gRl = "↳", hRl = "ℜ", vRl = "ℛ", bRl = "ℜ", yRl = "ℝ", $Rl = "ℜ", wRl = "▭", kRl = "®", SRl = "®", ERl = "∋", xRl = "⇋", CRl = "⥯", TRl = "⥽", ARl = "⌋", IRl = "𝔯", ORl = "ℜ", NRl = "⥤", zRl = "⇁", RRl = "⇀", PRl = "⥬", DRl = "Ρ", LRl = "ρ", MRl = "ϱ", FRl = "⟩", qRl = "⇥", jRl = "→", VRl = "→", BRl = "⇒", URl = "⇄", GRl = "↣", WRl = "⌉", HRl = "⟧", YRl = "⥝", KRl = "⥕", ZRl = "⇂", XRl = "⌋", JRl = "⇁", QRl = "⇀", ePl = "⇄", tPl = "⇌", nPl = "⇉", oPl = "↝", rPl = "↦", iPl = "⊢", aPl = "⥛", sPl = "⋌", cPl = "⧐", lPl = "⊳", uPl = "⊵", dPl = "⥏", _Pl = "⥜", pPl = "⥔", mPl = "↾", fPl = "⥓", gPl = "⇀", hPl = "˚", vPl = "≓", bPl = "⇄", yPl = "⇌", $Pl = "‏", wPl = "⎱", kPl = "⎱", SPl = "⫮", EPl = "⟭", xPl = "⇾", CPl = "⟧", TPl = "⦆", APl = "𝕣", IPl = "ℝ", OPl = "⨮", NPl = "⨵", zPl = "⥰", RPl = ")", PPl = "⦔", DPl = "⨒", LPl = "⇉", MPl = "⇛", FPl = "›", qPl = "𝓇", jPl = "ℛ", VPl = "↱", BPl = "↱", UPl = "]", GPl = "’", WPl = "’", HPl = "⋌", YPl = "⋊", KPl = "▹", ZPl = "⊵", XPl = "▸", JPl = "⧎", QPl = "⧴", eDl = "⥨", tDl = "℞", nDl = "Ś", oDl = "ś", rDl = "‚", iDl = "⪸", aDl = "Š", sDl = "š", cDl = "⪼", lDl = "≻", uDl = "≽", dDl = "⪰", _Dl = "⪴", pDl = "Ş", mDl = "ş", fDl = "Ŝ", gDl = "ŝ", hDl = "⪺", vDl = "⪶", bDl = "⋩", yDl = "⨓", $Dl = "≿", wDl = "С", kDl = "с", SDl = "⊡", EDl = "⋅", xDl = "⩦", CDl = "⤥", TDl = "↘", ADl = "⇘", IDl = "↘", ODl = "§", NDl = ";", zDl = "⤩", RDl = "∖", PDl = "∖", DDl = "✶", LDl = "𝔖", MDl = "𝔰", FDl = "⌢", qDl = "♯", jDl = "Щ", VDl = "щ", BDl = "Ш", UDl = "ш", GDl = "↓", WDl = "←", HDl = "∣", YDl = "∥", KDl = "→", ZDl = "↑", XDl = "­", JDl = "Σ", QDl = "σ", e3l = "ς", t3l = "ς", n3l = "∼", o3l = "⩪", r3l = "≃", i3l = "≃", a3l = "⪞", s3l = "⪠", c3l = "⪝", l3l = "⪟", u3l = "≆", d3l = "⨤", _3l = "⥲", p3l = "←", m3l = "∘", f3l = "∖", g3l = "⨳", h3l = "⧤", v3l = "∣", b3l = "⌣", y3l = "⪪", $3l = "⪬", w3l = "⪬︀", k3l = "Ь", S3l = "ь", E3l = "⌿", x3l = "⧄", C3l = "/", T3l = "𝕊", A3l = "𝕤", I3l = "♠", O3l = "♠", N3l = "∥", z3l = "⊓", R3l = "⊓︀", P3l = "⊔", D3l = "⊔︀", L3l = "√", M3l = "⊏", F3l = "⊑", q3l = "⊏", j3l = "⊑", V3l = "⊐", B3l = "⊒", U3l = "⊐", G3l = "⊒", W3l = "□", H3l = "□", Y3l = "⊓", K3l = "⊏", Z3l = "⊑", X3l = "⊐", J3l = "⊒", Q3l = "⊔", eLl = "▪", tLl = "□", nLl = "▪", oLl = "→", rLl = "𝒮", iLl = "𝓈", aLl = "∖", sLl = "⌣", cLl = "⋆", lLl = "⋆", uLl = "☆", dLl = "★", _Ll = "ϵ", pLl = "ϕ", mLl = "¯", fLl = "⊂", gLl = "⋐", hLl = "⪽", vLl = "⫅", bLl = "⊆", yLl = "⫃", $Ll = "⫁", wLl = "⫋", kLl = "⊊", SLl = "⪿", ELl = "⥹", xLl = "⊂", CLl = "⋐", TLl = "⊆", ALl = "⫅", ILl = "⊆", OLl = "⊊", NLl = "⫋", zLl = "⫇", RLl = "⫕", PLl = "⫓", DLl = "⪸", LLl = "≻", MLl = "≽", FLl = "≻", qLl = "⪰", jLl = "≽", VLl = "≿", BLl = "⪰", ULl = "⪺", GLl = "⪶", WLl = "⋩", HLl = "≿", YLl = "∋", KLl = "∑", ZLl = "∑", XLl = "♪", JLl = "¹", QLl = "²", eMl = "³", tMl = "⊃", nMl = "⋑", oMl = "⪾", rMl = "⫘", iMl = "⫆", aMl = "⊇", sMl = "⫄", cMl = "⊃", lMl = "⊇", uMl = "⟉", dMl = "⫗", _Ml = "⥻", pMl = "⫂", mMl = "⫌", fMl = "⊋", gMl = "⫀", hMl = "⊃", vMl = "⋑", bMl = "⊇", yMl = "⫆", $Ml = "⊋", wMl = "⫌", kMl = "⫈", SMl = "⫔", EMl = "⫖", xMl = "⤦", CMl = "↙", TMl = "⇙", AMl = "↙", IMl = "⤪", OMl = "ß", NMl = "	", zMl = "⌖", RMl = "Τ", PMl = "τ", DMl = "⎴", LMl = "Ť", MMl = "ť", FMl = "Ţ", qMl = "ţ", jMl = "Т", VMl = "т", BMl = "⃛", UMl = "⌕", GMl = "𝔗", WMl = "𝔱", HMl = "∴", YMl = "∴", KMl = "∴", ZMl = "Θ", XMl = "θ", JMl = "ϑ", QMl = "ϑ", e4l = "≈", t4l = "∼", n4l = "  ", o4l = " ", r4l = " ", i4l = "≈", a4l = "∼", s4l = "Þ", c4l = "þ", l4l = "˜", u4l = "∼", d4l = "≃", _4l = "≅", p4l = "≈", m4l = "⨱", f4l = "⊠", g4l = "×", h4l = "⨰", v4l = "∭", b4l = "⤨", y4l = "⌶", $4l = "⫱", w4l = "⊤", k4l = "𝕋", S4l = "𝕥", E4l = "⫚", x4l = "⤩", C4l = "‴", T4l = "™", A4l = "™", I4l = "▵", O4l = "▿", N4l = "◃", z4l = "⊴", R4l = "≜", P4l = "▹", D4l = "⊵", L4l = "◬", M4l = "≜", F4l = "⨺", q4l = "⃛", j4l = "⨹", V4l = "⧍", B4l = "⨻", U4l = "⏢", G4l = "𝒯", W4l = "𝓉", H4l = "Ц", Y4l = "ц", K4l = "Ћ", Z4l = "ћ", X4l = "Ŧ", J4l = "ŧ", Q4l = "≬", e5l = "↞", t5l = "↠", n5l = "Ú", o5l = "ú", r5l = "↑", i5l = "↟", a5l = "⇑", s5l = "⥉", c5l = "Ў", l5l = "ў", u5l = "Ŭ", d5l = "ŭ", _5l = "Û", p5l = "û", m5l = "У", f5l = "у", g5l = "⇅", h5l = "Ű", v5l = "ű", b5l = "⥮", y5l = "⥾", $5l = "𝔘", w5l = "𝔲", k5l = "Ù", S5l = "ù", E5l = "⥣", x5l = "↿", C5l = "↾", T5l = "▀", A5l = "⌜", I5l = "⌜", O5l = "⌏", N5l = "◸", z5l = "Ū", R5l = "ū", P5l = "¨", D5l = "_", L5l = "⏟", M5l = "⎵", F5l = "⏝", q5l = "⋃", j5l = "⊎", V5l = "Ų", B5l = "ų", U5l = "𝕌", G5l = "𝕦", W5l = "⤒", H5l = "↑", Y5l = "↑", K5l = "⇑", Z5l = "⇅", X5l = "↕", J5l = "↕", Q5l = "⇕", e6l = "⥮", t6l = "↿", n6l = "↾", o6l = "⊎", r6l = "↖", i6l = "↗", a6l = "υ", s6l = "ϒ", c6l = "ϒ", l6l = "Υ", u6l = "υ", d6l = "↥", _6l = "⊥", p6l = "⇈", m6l = "⌝", f6l = "⌝", g6l = "⌎", h6l = "Ů", v6l = "ů", b6l = "◹", y6l = "𝒰", $6l = "𝓊", w6l = "⋰", k6l = "Ũ", S6l = "ũ", E6l = "▵", x6l = "▴", C6l = "⇈", T6l = "Ü", A6l = "ü", I6l = "⦧", O6l = "⦜", N6l = "ϵ", z6l = "ϰ", R6l = "∅", P6l = "ϕ", D6l = "ϖ", L6l = "∝", M6l = "↕", F6l = "⇕", q6l = "ϱ", j6l = "ς", V6l = "⊊︀", B6l = "⫋︀", U6l = "⊋︀", G6l = "⫌︀", W6l = "ϑ", H6l = "⊲", Y6l = "⊳", K6l = "⫨", Z6l = "⫫", X6l = "⫩", J6l = "В", Q6l = "в", eFl = "⊢", tFl = "⊨", nFl = "⊩", oFl = "⊫", rFl = "⫦", iFl = "⊻", aFl = "∨", sFl = "⋁", cFl = "≚", lFl = "⋮", uFl = "|", dFl = "‖", _Fl = "|", pFl = "‖", mFl = "∣", fFl = "|", gFl = "❘", hFl = "≀", vFl = " ", bFl = "𝔙", yFl = "𝔳", $Fl = "⊲", wFl = "⊂⃒", kFl = "⊃⃒", SFl = "𝕍", EFl = "𝕧", xFl = "∝", CFl = "⊳", TFl = "𝒱", AFl = "𝓋", IFl = "⫋︀", OFl = "⊊︀", NFl = "⫌︀", zFl = "⊋︀", RFl = "⊪", PFl = "⦚", DFl = "Ŵ", LFl = "ŵ", MFl = "⩟", FFl = "∧", qFl = "⋀", jFl = "≙", VFl = "℘", BFl = "𝔚", UFl = "𝔴", GFl = "𝕎", WFl = "𝕨", HFl = "℘", YFl = "≀", KFl = "≀", ZFl = "𝒲", XFl = "𝓌", JFl = "⋂", QFl = "◯", eql = "⋃", tql = "▽", nql = "𝔛", oql = "𝔵", rql = "⟷", iql = "⟺", aql = "Ξ", sql = "ξ", cql = "⟵", lql = "⟸", uql = "⟼", dql = "⋻", _ql = "⨀", pql = "𝕏", mql = "𝕩", fql = "⨁", gql = "⨂", hql = "⟶", vql = "⟹", bql = "𝒳", yql = "𝓍", $ql = "⨆", wql = "⨄", kql = "△", Sql = "⋁", Eql = "⋀", xql = "Ý", Cql = "ý", Tql = "Я", Aql = "я", Iql = "Ŷ", Oql = "ŷ", Nql = "Ы", zql = "ы", Rql = "¥", Pql = "𝔜", Dql = "𝔶", Lql = "Ї", Mql = "ї", Fql = "𝕐", qql = "𝕪", jql = "𝒴", Vql = "𝓎", Bql = "Ю", Uql = "ю", Gql = "ÿ", Wql = "Ÿ", Hql = "Ź", Yql = "ź", Kql = "Ž", Zql = "ž", Xql = "З", Jql = "з", Qql = "Ż", ejl = "ż", tjl = "ℨ", njl = "​", ojl = "Ζ", rjl = "ζ", ijl = "𝔷", ajl = "ℨ", sjl = "Ж", cjl = "ж", ljl = "⇝", ujl = "𝕫", djl = "ℤ", _jl = "𝒵", pjl = "𝓏", mjl = "‍", fjl = "‌", gjl = {
  Aacute: Qcl,
  aacute: ell,
  Abreve: tll,
  abreve: nll,
  ac: oll,
  acd: rll,
  acE: ill,
  Acirc: all,
  acirc: sll,
  acute: cll,
  Acy: lll,
  acy: ull,
  AElig: dll,
  aelig: _ll,
  af: pll,
  Afr: mll,
  afr: fll,
  Agrave: gll,
  agrave: hll,
  alefsym: vll,
  aleph: bll,
  Alpha: yll,
  alpha: $ll,
  Amacr: wll,
  amacr: kll,
  amalg: Sll,
  amp: Ell,
  AMP: xll,
  andand: Cll,
  And: Tll,
  and: All,
  andd: Ill,
  andslope: Oll,
  andv: Nll,
  ang: zll,
  ange: Rll,
  angle: Pll,
  angmsdaa: Dll,
  angmsdab: Lll,
  angmsdac: Mll,
  angmsdad: Fll,
  angmsdae: qll,
  angmsdaf: jll,
  angmsdag: Vll,
  angmsdah: Bll,
  angmsd: Ull,
  angrt: Gll,
  angrtvb: Wll,
  angrtvbd: Hll,
  angsph: Yll,
  angst: Kll,
  angzarr: Zll,
  Aogon: Xll,
  aogon: Jll,
  Aopf: Qll,
  aopf: eul,
  apacir: tul,
  ap: nul,
  apE: oul,
  ape: rul,
  apid: iul,
  apos: aul,
  ApplyFunction: sul,
  approx: cul,
  approxeq: lul,
  Aring: uul,
  aring: dul,
  Ascr: _ul,
  ascr: pul,
  Assign: mul,
  ast: ful,
  asymp: gul,
  asympeq: hul,
  Atilde: vul,
  atilde: bul,
  Auml: yul,
  auml: $ul,
  awconint: wul,
  awint: kul,
  backcong: Sul,
  backepsilon: Eul,
  backprime: xul,
  backsim: Cul,
  backsimeq: Tul,
  Backslash: Aul,
  Barv: Iul,
  barvee: Oul,
  barwed: Nul,
  Barwed: zul,
  barwedge: Rul,
  bbrk: Pul,
  bbrktbrk: Dul,
  bcong: Lul,
  Bcy: Mul,
  bcy: Ful,
  bdquo: qul,
  becaus: jul,
  because: Vul,
  Because: Bul,
  bemptyv: Uul,
  bepsi: Gul,
  bernou: Wul,
  Bernoullis: Hul,
  Beta: Yul,
  beta: Kul,
  beth: Zul,
  between: Xul,
  Bfr: Jul,
  bfr: Qul,
  bigcap: edl,
  bigcirc: tdl,
  bigcup: ndl,
  bigodot: odl,
  bigoplus: rdl,
  bigotimes: idl,
  bigsqcup: adl,
  bigstar: sdl,
  bigtriangledown: cdl,
  bigtriangleup: ldl,
  biguplus: udl,
  bigvee: ddl,
  bigwedge: _dl,
  bkarow: pdl,
  blacklozenge: mdl,
  blacksquare: fdl,
  blacktriangle: gdl,
  blacktriangledown: hdl,
  blacktriangleleft: vdl,
  blacktriangleright: bdl,
  blank: ydl,
  blk12: $dl,
  blk14: wdl,
  blk34: kdl,
  block: Sdl,
  bne: Edl,
  bnequiv: xdl,
  bNot: Cdl,
  bnot: Tdl,
  Bopf: Adl,
  bopf: Idl,
  bot: Odl,
  bottom: Ndl,
  bowtie: zdl,
  boxbox: Rdl,
  boxdl: Pdl,
  boxdL: Ddl,
  boxDl: Ldl,
  boxDL: Mdl,
  boxdr: Fdl,
  boxdR: qdl,
  boxDr: jdl,
  boxDR: Vdl,
  boxh: Bdl,
  boxH: Udl,
  boxhd: Gdl,
  boxHd: Wdl,
  boxhD: Hdl,
  boxHD: Ydl,
  boxhu: Kdl,
  boxHu: Zdl,
  boxhU: Xdl,
  boxHU: Jdl,
  boxminus: Qdl,
  boxplus: e_l,
  boxtimes: t_l,
  boxul: n_l,
  boxuL: o_l,
  boxUl: r_l,
  boxUL: i_l,
  boxur: a_l,
  boxuR: s_l,
  boxUr: c_l,
  boxUR: l_l,
  boxv: u_l,
  boxV: d_l,
  boxvh: __l,
  boxvH: p_l,
  boxVh: m_l,
  boxVH: f_l,
  boxvl: g_l,
  boxvL: h_l,
  boxVl: v_l,
  boxVL: b_l,
  boxvr: y_l,
  boxvR: $_l,
  boxVr: w_l,
  boxVR: k_l,
  bprime: S_l,
  breve: E_l,
  Breve: x_l,
  brvbar: C_l,
  bscr: T_l,
  Bscr: A_l,
  bsemi: I_l,
  bsim: O_l,
  bsime: N_l,
  bsolb: z_l,
  bsol: R_l,
  bsolhsub: P_l,
  bull: D_l,
  bullet: L_l,
  bump: M_l,
  bumpE: F_l,
  bumpe: q_l,
  Bumpeq: j_l,
  bumpeq: V_l,
  Cacute: B_l,
  cacute: U_l,
  capand: G_l,
  capbrcup: W_l,
  capcap: H_l,
  cap: Y_l,
  Cap: K_l,
  capcup: Z_l,
  capdot: X_l,
  CapitalDifferentialD: J_l,
  caps: Q_l,
  caret: epl,
  caron: tpl,
  Cayleys: npl,
  ccaps: opl,
  Ccaron: rpl,
  ccaron: ipl,
  Ccedil: apl,
  ccedil: spl,
  Ccirc: cpl,
  ccirc: lpl,
  Cconint: upl,
  ccups: dpl,
  ccupssm: _pl,
  Cdot: ppl,
  cdot: mpl,
  cedil: fpl,
  Cedilla: gpl,
  cemptyv: hpl,
  cent: vpl,
  centerdot: bpl,
  CenterDot: ypl,
  cfr: $pl,
  Cfr: wpl,
  CHcy: kpl,
  chcy: Spl,
  check: Epl,
  checkmark: xpl,
  Chi: Cpl,
  chi: Tpl,
  circ: Apl,
  circeq: Ipl,
  circlearrowleft: Opl,
  circlearrowright: Npl,
  circledast: zpl,
  circledcirc: Rpl,
  circleddash: Ppl,
  CircleDot: Dpl,
  circledR: Lpl,
  circledS: Mpl,
  CircleMinus: Fpl,
  CirclePlus: qpl,
  CircleTimes: jpl,
  cir: Vpl,
  cirE: Bpl,
  cire: Upl,
  cirfnint: Gpl,
  cirmid: Wpl,
  cirscir: Hpl,
  ClockwiseContourIntegral: Ypl,
  CloseCurlyDoubleQuote: Kpl,
  CloseCurlyQuote: Zpl,
  clubs: Xpl,
  clubsuit: Jpl,
  colon: Qpl,
  Colon: eml,
  Colone: tml,
  colone: nml,
  coloneq: oml,
  comma: rml,
  commat: iml,
  comp: aml,
  compfn: sml,
  complement: cml,
  complexes: lml,
  cong: uml,
  congdot: dml,
  Congruent: _ml,
  conint: pml,
  Conint: mml,
  ContourIntegral: fml,
  copf: gml,
  Copf: hml,
  coprod: vml,
  Coproduct: bml,
  copy: yml,
  COPY: $ml,
  copysr: wml,
  CounterClockwiseContourIntegral: kml,
  crarr: Sml,
  cross: Eml,
  Cross: xml,
  Cscr: Cml,
  cscr: Tml,
  csub: Aml,
  csube: Iml,
  csup: Oml,
  csupe: Nml,
  ctdot: zml,
  cudarrl: Rml,
  cudarrr: Pml,
  cuepr: Dml,
  cuesc: Lml,
  cularr: Mml,
  cularrp: Fml,
  cupbrcap: qml,
  cupcap: jml,
  CupCap: Vml,
  cup: Bml,
  Cup: Uml,
  cupcup: Gml,
  cupdot: Wml,
  cupor: Hml,
  cups: Yml,
  curarr: Kml,
  curarrm: Zml,
  curlyeqprec: Xml,
  curlyeqsucc: Jml,
  curlyvee: Qml,
  curlywedge: efl,
  curren: tfl,
  curvearrowleft: nfl,
  curvearrowright: ofl,
  cuvee: rfl,
  cuwed: ifl,
  cwconint: afl,
  cwint: sfl,
  cylcty: cfl,
  dagger: lfl,
  Dagger: ufl,
  daleth: dfl,
  darr: _fl,
  Darr: pfl,
  dArr: mfl,
  dash: ffl,
  Dashv: gfl,
  dashv: hfl,
  dbkarow: vfl,
  dblac: bfl,
  Dcaron: yfl,
  dcaron: $fl,
  Dcy: wfl,
  dcy: kfl,
  ddagger: Sfl,
  ddarr: Efl,
  DD: xfl,
  dd: Cfl,
  DDotrahd: Tfl,
  ddotseq: Afl,
  deg: Ifl,
  Del: Ofl,
  Delta: Nfl,
  delta: zfl,
  demptyv: Rfl,
  dfisht: Pfl,
  Dfr: Dfl,
  dfr: Lfl,
  dHar: Mfl,
  dharl: Ffl,
  dharr: qfl,
  DiacriticalAcute: jfl,
  DiacriticalDot: Vfl,
  DiacriticalDoubleAcute: Bfl,
  DiacriticalGrave: Ufl,
  DiacriticalTilde: Gfl,
  diam: Wfl,
  diamond: Hfl,
  Diamond: Yfl,
  diamondsuit: Kfl,
  diams: Zfl,
  die: Xfl,
  DifferentialD: Jfl,
  digamma: Qfl,
  disin: egl,
  div: tgl,
  divide: ngl,
  divideontimes: ogl,
  divonx: rgl,
  DJcy: igl,
  djcy: agl,
  dlcorn: sgl,
  dlcrop: cgl,
  dollar: lgl,
  Dopf: ugl,
  dopf: dgl,
  Dot: _gl,
  dot: pgl,
  DotDot: mgl,
  doteq: fgl,
  doteqdot: ggl,
  DotEqual: hgl,
  dotminus: vgl,
  dotplus: bgl,
  dotsquare: ygl,
  doublebarwedge: $gl,
  DoubleContourIntegral: wgl,
  DoubleDot: kgl,
  DoubleDownArrow: Sgl,
  DoubleLeftArrow: Egl,
  DoubleLeftRightArrow: xgl,
  DoubleLeftTee: Cgl,
  DoubleLongLeftArrow: Tgl,
  DoubleLongLeftRightArrow: Agl,
  DoubleLongRightArrow: Igl,
  DoubleRightArrow: Ogl,
  DoubleRightTee: Ngl,
  DoubleUpArrow: zgl,
  DoubleUpDownArrow: Rgl,
  DoubleVerticalBar: Pgl,
  DownArrowBar: Dgl,
  downarrow: Lgl,
  DownArrow: Mgl,
  Downarrow: Fgl,
  DownArrowUpArrow: qgl,
  DownBreve: jgl,
  downdownarrows: Vgl,
  downharpoonleft: Bgl,
  downharpoonright: Ugl,
  DownLeftRightVector: Ggl,
  DownLeftTeeVector: Wgl,
  DownLeftVectorBar: Hgl,
  DownLeftVector: Ygl,
  DownRightTeeVector: Kgl,
  DownRightVectorBar: Zgl,
  DownRightVector: Xgl,
  DownTeeArrow: Jgl,
  DownTee: Qgl,
  drbkarow: ehl,
  drcorn: thl,
  drcrop: nhl,
  Dscr: ohl,
  dscr: rhl,
  DScy: ihl,
  dscy: ahl,
  dsol: shl,
  Dstrok: chl,
  dstrok: lhl,
  dtdot: uhl,
  dtri: dhl,
  dtrif: _hl,
  duarr: phl,
  duhar: mhl,
  dwangle: fhl,
  DZcy: ghl,
  dzcy: hhl,
  dzigrarr: vhl,
  Eacute: bhl,
  eacute: yhl,
  easter: $hl,
  Ecaron: whl,
  ecaron: khl,
  Ecirc: Shl,
  ecirc: Ehl,
  ecir: xhl,
  ecolon: Chl,
  Ecy: Thl,
  ecy: Ahl,
  eDDot: Ihl,
  Edot: Ohl,
  edot: Nhl,
  eDot: zhl,
  ee: Rhl,
  efDot: Phl,
  Efr: Dhl,
  efr: Lhl,
  eg: Mhl,
  Egrave: Fhl,
  egrave: qhl,
  egs: jhl,
  egsdot: Vhl,
  el: Bhl,
  Element: Uhl,
  elinters: Ghl,
  ell: Whl,
  els: Hhl,
  elsdot: Yhl,
  Emacr: Khl,
  emacr: Zhl,
  empty: Xhl,
  emptyset: Jhl,
  EmptySmallSquare: Qhl,
  emptyv: evl,
  EmptyVerySmallSquare: tvl,
  emsp13: nvl,
  emsp14: ovl,
  emsp: rvl,
  ENG: ivl,
  eng: avl,
  ensp: svl,
  Eogon: cvl,
  eogon: lvl,
  Eopf: uvl,
  eopf: dvl,
  epar: _vl,
  eparsl: pvl,
  eplus: mvl,
  epsi: fvl,
  Epsilon: gvl,
  epsilon: hvl,
  epsiv: vvl,
  eqcirc: bvl,
  eqcolon: yvl,
  eqsim: $vl,
  eqslantgtr: wvl,
  eqslantless: kvl,
  Equal: Svl,
  equals: Evl,
  EqualTilde: xvl,
  equest: Cvl,
  Equilibrium: Tvl,
  equiv: Avl,
  equivDD: Ivl,
  eqvparsl: Ovl,
  erarr: Nvl,
  erDot: zvl,
  escr: Rvl,
  Escr: Pvl,
  esdot: Dvl,
  Esim: Lvl,
  esim: Mvl,
  Eta: Fvl,
  eta: qvl,
  ETH: jvl,
  eth: Vvl,
  Euml: Bvl,
  euml: Uvl,
  euro: Gvl,
  excl: Wvl,
  exist: Hvl,
  Exists: Yvl,
  expectation: Kvl,
  exponentiale: Zvl,
  ExponentialE: Xvl,
  fallingdotseq: Jvl,
  Fcy: Qvl,
  fcy: ebl,
  female: tbl,
  ffilig: nbl,
  fflig: obl,
  ffllig: rbl,
  Ffr: ibl,
  ffr: abl,
  filig: sbl,
  FilledSmallSquare: cbl,
  FilledVerySmallSquare: lbl,
  fjlig: ubl,
  flat: dbl,
  fllig: _bl,
  fltns: pbl,
  fnof: mbl,
  Fopf: fbl,
  fopf: gbl,
  forall: hbl,
  ForAll: vbl,
  fork: bbl,
  forkv: ybl,
  Fouriertrf: $bl,
  fpartint: wbl,
  frac12: kbl,
  frac13: Sbl,
  frac14: Ebl,
  frac15: xbl,
  frac16: Cbl,
  frac18: Tbl,
  frac23: Abl,
  frac25: Ibl,
  frac34: Obl,
  frac35: Nbl,
  frac38: zbl,
  frac45: Rbl,
  frac56: Pbl,
  frac58: Dbl,
  frac78: Lbl,
  frasl: Mbl,
  frown: Fbl,
  fscr: qbl,
  Fscr: jbl,
  gacute: Vbl,
  Gamma: Bbl,
  gamma: Ubl,
  Gammad: Gbl,
  gammad: Wbl,
  gap: Hbl,
  Gbreve: Ybl,
  gbreve: Kbl,
  Gcedil: Zbl,
  Gcirc: Xbl,
  gcirc: Jbl,
  Gcy: Qbl,
  gcy: eyl,
  Gdot: tyl,
  gdot: nyl,
  ge: oyl,
  gE: ryl,
  gEl: iyl,
  gel: ayl,
  geq: syl,
  geqq: cyl,
  geqslant: lyl,
  gescc: uyl,
  ges: dyl,
  gesdot: _yl,
  gesdoto: pyl,
  gesdotol: myl,
  gesl: fyl,
  gesles: gyl,
  Gfr: hyl,
  gfr: vyl,
  gg: byl,
  Gg: yyl,
  ggg: $yl,
  gimel: wyl,
  GJcy: kyl,
  gjcy: Syl,
  gla: Eyl,
  gl: xyl,
  glE: Cyl,
  glj: Tyl,
  gnap: Ayl,
  gnapprox: Iyl,
  gne: Oyl,
  gnE: Nyl,
  gneq: zyl,
  gneqq: Ryl,
  gnsim: Pyl,
  Gopf: Dyl,
  gopf: Lyl,
  grave: Myl,
  GreaterEqual: Fyl,
  GreaterEqualLess: qyl,
  GreaterFullEqual: jyl,
  GreaterGreater: Vyl,
  GreaterLess: Byl,
  GreaterSlantEqual: Uyl,
  GreaterTilde: Gyl,
  Gscr: Wyl,
  gscr: Hyl,
  gsim: Yyl,
  gsime: Kyl,
  gsiml: Zyl,
  gtcc: Xyl,
  gtcir: Jyl,
  gt: Qyl,
  GT: e$l,
  Gt: t$l,
  gtdot: n$l,
  gtlPar: o$l,
  gtquest: r$l,
  gtrapprox: i$l,
  gtrarr: a$l,
  gtrdot: s$l,
  gtreqless: c$l,
  gtreqqless: l$l,
  gtrless: u$l,
  gtrsim: d$l,
  gvertneqq: _$l,
  gvnE: p$l,
  Hacek: m$l,
  hairsp: f$l,
  half: g$l,
  hamilt: h$l,
  HARDcy: v$l,
  hardcy: b$l,
  harrcir: y$l,
  harr: $$l,
  hArr: w$l,
  harrw: k$l,
  Hat: S$l,
  hbar: E$l,
  Hcirc: x$l,
  hcirc: C$l,
  hearts: T$l,
  heartsuit: A$l,
  hellip: I$l,
  hercon: O$l,
  hfr: N$l,
  Hfr: z$l,
  HilbertSpace: R$l,
  hksearow: P$l,
  hkswarow: D$l,
  hoarr: L$l,
  homtht: M$l,
  hookleftarrow: F$l,
  hookrightarrow: q$l,
  hopf: j$l,
  Hopf: V$l,
  horbar: B$l,
  HorizontalLine: U$l,
  hscr: G$l,
  Hscr: W$l,
  hslash: H$l,
  Hstrok: Y$l,
  hstrok: K$l,
  HumpDownHump: Z$l,
  HumpEqual: X$l,
  hybull: J$l,
  hyphen: Q$l,
  Iacute: ewl,
  iacute: twl,
  ic: nwl,
  Icirc: owl,
  icirc: rwl,
  Icy: iwl,
  icy: awl,
  Idot: swl,
  IEcy: cwl,
  iecy: lwl,
  iexcl: uwl,
  iff: dwl,
  ifr: _wl,
  Ifr: pwl,
  Igrave: mwl,
  igrave: fwl,
  ii: gwl,
  iiiint: hwl,
  iiint: vwl,
  iinfin: bwl,
  iiota: ywl,
  IJlig: $wl,
  ijlig: wwl,
  Imacr: kwl,
  imacr: Swl,
  image: Ewl,
  ImaginaryI: xwl,
  imagline: Cwl,
  imagpart: Twl,
  imath: Awl,
  Im: Iwl,
  imof: Owl,
  imped: Nwl,
  Implies: zwl,
  incare: Rwl,
  in: "∈",
  infin: Pwl,
  infintie: Dwl,
  inodot: Lwl,
  intcal: Mwl,
  int: Fwl,
  Int: qwl,
  integers: jwl,
  Integral: Vwl,
  intercal: Bwl,
  Intersection: Uwl,
  intlarhk: Gwl,
  intprod: Wwl,
  InvisibleComma: Hwl,
  InvisibleTimes: Ywl,
  IOcy: Kwl,
  iocy: Zwl,
  Iogon: Xwl,
  iogon: Jwl,
  Iopf: Qwl,
  iopf: ekl,
  Iota: tkl,
  iota: nkl,
  iprod: okl,
  iquest: rkl,
  iscr: ikl,
  Iscr: akl,
  isin: skl,
  isindot: ckl,
  isinE: lkl,
  isins: ukl,
  isinsv: dkl,
  isinv: _kl,
  it: pkl,
  Itilde: mkl,
  itilde: fkl,
  Iukcy: gkl,
  iukcy: hkl,
  Iuml: vkl,
  iuml: bkl,
  Jcirc: ykl,
  jcirc: $kl,
  Jcy: wkl,
  jcy: kkl,
  Jfr: Skl,
  jfr: Ekl,
  jmath: xkl,
  Jopf: Ckl,
  jopf: Tkl,
  Jscr: Akl,
  jscr: Ikl,
  Jsercy: Okl,
  jsercy: Nkl,
  Jukcy: zkl,
  jukcy: Rkl,
  Kappa: Pkl,
  kappa: Dkl,
  kappav: Lkl,
  Kcedil: Mkl,
  kcedil: Fkl,
  Kcy: qkl,
  kcy: jkl,
  Kfr: Vkl,
  kfr: Bkl,
  kgreen: Ukl,
  KHcy: Gkl,
  khcy: Wkl,
  KJcy: Hkl,
  kjcy: Ykl,
  Kopf: Kkl,
  kopf: Zkl,
  Kscr: Xkl,
  kscr: Jkl,
  lAarr: Qkl,
  Lacute: e0l,
  lacute: t0l,
  laemptyv: n0l,
  lagran: o0l,
  Lambda: r0l,
  lambda: i0l,
  lang: a0l,
  Lang: s0l,
  langd: c0l,
  langle: l0l,
  lap: u0l,
  Laplacetrf: d0l,
  laquo: _0l,
  larrb: p0l,
  larrbfs: m0l,
  larr: f0l,
  Larr: g0l,
  lArr: h0l,
  larrfs: v0l,
  larrhk: b0l,
  larrlp: y0l,
  larrpl: $0l,
  larrsim: w0l,
  larrtl: k0l,
  latail: S0l,
  lAtail: E0l,
  lat: x0l,
  late: C0l,
  lates: T0l,
  lbarr: A0l,
  lBarr: I0l,
  lbbrk: O0l,
  lbrace: N0l,
  lbrack: z0l,
  lbrke: R0l,
  lbrksld: P0l,
  lbrkslu: D0l,
  Lcaron: L0l,
  lcaron: M0l,
  Lcedil: F0l,
  lcedil: q0l,
  lceil: j0l,
  lcub: V0l,
  Lcy: B0l,
  lcy: U0l,
  ldca: G0l,
  ldquo: W0l,
  ldquor: H0l,
  ldrdhar: Y0l,
  ldrushar: K0l,
  ldsh: Z0l,
  le: X0l,
  lE: J0l,
  LeftAngleBracket: Q0l,
  LeftArrowBar: e1l,
  leftarrow: t1l,
  LeftArrow: n1l,
  Leftarrow: o1l,
  LeftArrowRightArrow: r1l,
  leftarrowtail: i1l,
  LeftCeiling: a1l,
  LeftDoubleBracket: s1l,
  LeftDownTeeVector: c1l,
  LeftDownVectorBar: l1l,
  LeftDownVector: u1l,
  LeftFloor: d1l,
  leftharpoondown: _1l,
  leftharpoonup: p1l,
  leftleftarrows: m1l,
  leftrightarrow: f1l,
  LeftRightArrow: g1l,
  Leftrightarrow: h1l,
  leftrightarrows: v1l,
  leftrightharpoons: b1l,
  leftrightsquigarrow: y1l,
  LeftRightVector: $1l,
  LeftTeeArrow: w1l,
  LeftTee: k1l,
  LeftTeeVector: S1l,
  leftthreetimes: E1l,
  LeftTriangleBar: x1l,
  LeftTriangle: C1l,
  LeftTriangleEqual: T1l,
  LeftUpDownVector: A1l,
  LeftUpTeeVector: I1l,
  LeftUpVectorBar: O1l,
  LeftUpVector: N1l,
  LeftVectorBar: z1l,
  LeftVector: R1l,
  lEg: P1l,
  leg: D1l,
  leq: L1l,
  leqq: M1l,
  leqslant: F1l,
  lescc: q1l,
  les: j1l,
  lesdot: V1l,
  lesdoto: B1l,
  lesdotor: U1l,
  lesg: G1l,
  lesges: W1l,
  lessapprox: H1l,
  lessdot: Y1l,
  lesseqgtr: K1l,
  lesseqqgtr: Z1l,
  LessEqualGreater: X1l,
  LessFullEqual: J1l,
  LessGreater: Q1l,
  lessgtr: eSl,
  LessLess: tSl,
  lesssim: nSl,
  LessSlantEqual: oSl,
  LessTilde: rSl,
  lfisht: iSl,
  lfloor: aSl,
  Lfr: sSl,
  lfr: cSl,
  lg: lSl,
  lgE: uSl,
  lHar: dSl,
  lhard: _Sl,
  lharu: pSl,
  lharul: mSl,
  lhblk: fSl,
  LJcy: gSl,
  ljcy: hSl,
  llarr: vSl,
  ll: bSl,
  Ll: ySl,
  llcorner: $Sl,
  Lleftarrow: wSl,
  llhard: kSl,
  lltri: SSl,
  Lmidot: ESl,
  lmidot: xSl,
  lmoustache: CSl,
  lmoust: TSl,
  lnap: ASl,
  lnapprox: ISl,
  lne: OSl,
  lnE: NSl,
  lneq: zSl,
  lneqq: RSl,
  lnsim: PSl,
  loang: DSl,
  loarr: LSl,
  lobrk: MSl,
  longleftarrow: FSl,
  LongLeftArrow: qSl,
  Longleftarrow: jSl,
  longleftrightarrow: VSl,
  LongLeftRightArrow: BSl,
  Longleftrightarrow: USl,
  longmapsto: GSl,
  longrightarrow: WSl,
  LongRightArrow: HSl,
  Longrightarrow: YSl,
  looparrowleft: KSl,
  looparrowright: ZSl,
  lopar: XSl,
  Lopf: JSl,
  lopf: QSl,
  loplus: eEl,
  lotimes: tEl,
  lowast: nEl,
  lowbar: oEl,
  LowerLeftArrow: rEl,
  LowerRightArrow: iEl,
  loz: aEl,
  lozenge: sEl,
  lozf: cEl,
  lpar: lEl,
  lparlt: uEl,
  lrarr: dEl,
  lrcorner: _El,
  lrhar: pEl,
  lrhard: mEl,
  lrm: fEl,
  lrtri: gEl,
  lsaquo: hEl,
  lscr: vEl,
  Lscr: bEl,
  lsh: yEl,
  Lsh: $El,
  lsim: wEl,
  lsime: kEl,
  lsimg: SEl,
  lsqb: EEl,
  lsquo: xEl,
  lsquor: CEl,
  Lstrok: TEl,
  lstrok: AEl,
  ltcc: IEl,
  ltcir: OEl,
  lt: NEl,
  LT: zEl,
  Lt: REl,
  ltdot: PEl,
  lthree: DEl,
  ltimes: LEl,
  ltlarr: MEl,
  ltquest: FEl,
  ltri: qEl,
  ltrie: jEl,
  ltrif: VEl,
  ltrPar: BEl,
  lurdshar: UEl,
  luruhar: GEl,
  lvertneqq: WEl,
  lvnE: HEl,
  macr: YEl,
  male: KEl,
  malt: ZEl,
  maltese: XEl,
  Map: "⤅",
  map: JEl,
  mapsto: QEl,
  mapstodown: exl,
  mapstoleft: txl,
  mapstoup: nxl,
  marker: oxl,
  mcomma: rxl,
  Mcy: ixl,
  mcy: axl,
  mdash: sxl,
  mDDot: cxl,
  measuredangle: lxl,
  MediumSpace: uxl,
  Mellintrf: dxl,
  Mfr: _xl,
  mfr: pxl,
  mho: mxl,
  micro: fxl,
  midast: gxl,
  midcir: hxl,
  mid: vxl,
  middot: bxl,
  minusb: yxl,
  minus: $xl,
  minusd: wxl,
  minusdu: kxl,
  MinusPlus: Sxl,
  mlcp: Exl,
  mldr: xxl,
  mnplus: Cxl,
  models: Txl,
  Mopf: Axl,
  mopf: Ixl,
  mp: Oxl,
  mscr: Nxl,
  Mscr: zxl,
  mstpos: Rxl,
  Mu: Pxl,
  mu: Dxl,
  multimap: Lxl,
  mumap: Mxl,
  nabla: Fxl,
  Nacute: qxl,
  nacute: jxl,
  nang: Vxl,
  nap: Bxl,
  napE: Uxl,
  napid: Gxl,
  napos: Wxl,
  napprox: Hxl,
  natural: Yxl,
  naturals: Kxl,
  natur: Zxl,
  nbsp: Xxl,
  nbump: Jxl,
  nbumpe: Qxl,
  ncap: eCl,
  Ncaron: tCl,
  ncaron: nCl,
  Ncedil: oCl,
  ncedil: rCl,
  ncong: iCl,
  ncongdot: aCl,
  ncup: sCl,
  Ncy: cCl,
  ncy: lCl,
  ndash: uCl,
  nearhk: dCl,
  nearr: _Cl,
  neArr: pCl,
  nearrow: mCl,
  ne: fCl,
  nedot: gCl,
  NegativeMediumSpace: hCl,
  NegativeThickSpace: vCl,
  NegativeThinSpace: bCl,
  NegativeVeryThinSpace: yCl,
  nequiv: $Cl,
  nesear: wCl,
  nesim: kCl,
  NestedGreaterGreater: SCl,
  NestedLessLess: ECl,
  NewLine: xCl,
  nexist: CCl,
  nexists: TCl,
  Nfr: ACl,
  nfr: ICl,
  ngE: OCl,
  nge: NCl,
  ngeq: zCl,
  ngeqq: RCl,
  ngeqslant: PCl,
  nges: DCl,
  nGg: LCl,
  ngsim: MCl,
  nGt: FCl,
  ngt: qCl,
  ngtr: jCl,
  nGtv: VCl,
  nharr: BCl,
  nhArr: UCl,
  nhpar: GCl,
  ni: WCl,
  nis: HCl,
  nisd: YCl,
  niv: KCl,
  NJcy: ZCl,
  njcy: XCl,
  nlarr: JCl,
  nlArr: QCl,
  nldr: eTl,
  nlE: tTl,
  nle: nTl,
  nleftarrow: oTl,
  nLeftarrow: rTl,
  nleftrightarrow: iTl,
  nLeftrightarrow: aTl,
  nleq: sTl,
  nleqq: cTl,
  nleqslant: lTl,
  nles: uTl,
  nless: dTl,
  nLl: _Tl,
  nlsim: pTl,
  nLt: mTl,
  nlt: fTl,
  nltri: gTl,
  nltrie: hTl,
  nLtv: vTl,
  nmid: bTl,
  NoBreak: yTl,
  NonBreakingSpace: $Tl,
  nopf: wTl,
  Nopf: kTl,
  Not: STl,
  not: ETl,
  NotCongruent: xTl,
  NotCupCap: CTl,
  NotDoubleVerticalBar: TTl,
  NotElement: ATl,
  NotEqual: ITl,
  NotEqualTilde: OTl,
  NotExists: NTl,
  NotGreater: zTl,
  NotGreaterEqual: RTl,
  NotGreaterFullEqual: PTl,
  NotGreaterGreater: DTl,
  NotGreaterLess: LTl,
  NotGreaterSlantEqual: MTl,
  NotGreaterTilde: FTl,
  NotHumpDownHump: qTl,
  NotHumpEqual: jTl,
  notin: VTl,
  notindot: BTl,
  notinE: UTl,
  notinva: GTl,
  notinvb: WTl,
  notinvc: HTl,
  NotLeftTriangleBar: YTl,
  NotLeftTriangle: KTl,
  NotLeftTriangleEqual: ZTl,
  NotLess: XTl,
  NotLessEqual: JTl,
  NotLessGreater: QTl,
  NotLessLess: eAl,
  NotLessSlantEqual: tAl,
  NotLessTilde: nAl,
  NotNestedGreaterGreater: oAl,
  NotNestedLessLess: rAl,
  notni: iAl,
  notniva: aAl,
  notnivb: sAl,
  notnivc: cAl,
  NotPrecedes: lAl,
  NotPrecedesEqual: uAl,
  NotPrecedesSlantEqual: dAl,
  NotReverseElement: _Al,
  NotRightTriangleBar: pAl,
  NotRightTriangle: mAl,
  NotRightTriangleEqual: fAl,
  NotSquareSubset: gAl,
  NotSquareSubsetEqual: hAl,
  NotSquareSuperset: vAl,
  NotSquareSupersetEqual: bAl,
  NotSubset: yAl,
  NotSubsetEqual: $Al,
  NotSucceeds: wAl,
  NotSucceedsEqual: kAl,
  NotSucceedsSlantEqual: SAl,
  NotSucceedsTilde: EAl,
  NotSuperset: xAl,
  NotSupersetEqual: CAl,
  NotTilde: TAl,
  NotTildeEqual: AAl,
  NotTildeFullEqual: IAl,
  NotTildeTilde: OAl,
  NotVerticalBar: NAl,
  nparallel: zAl,
  npar: RAl,
  nparsl: PAl,
  npart: DAl,
  npolint: LAl,
  npr: MAl,
  nprcue: FAl,
  nprec: qAl,
  npreceq: jAl,
  npre: VAl,
  nrarrc: BAl,
  nrarr: UAl,
  nrArr: GAl,
  nrarrw: WAl,
  nrightarrow: HAl,
  nRightarrow: YAl,
  nrtri: KAl,
  nrtrie: ZAl,
  nsc: XAl,
  nsccue: JAl,
  nsce: QAl,
  Nscr: e2l,
  nscr: t2l,
  nshortmid: n2l,
  nshortparallel: o2l,
  nsim: r2l,
  nsime: i2l,
  nsimeq: a2l,
  nsmid: s2l,
  nspar: c2l,
  nsqsube: l2l,
  nsqsupe: u2l,
  nsub: d2l,
  nsubE: _2l,
  nsube: p2l,
  nsubset: m2l,
  nsubseteq: f2l,
  nsubseteqq: g2l,
  nsucc: h2l,
  nsucceq: v2l,
  nsup: b2l,
  nsupE: y2l,
  nsupe: $2l,
  nsupset: w2l,
  nsupseteq: k2l,
  nsupseteqq: S2l,
  ntgl: E2l,
  Ntilde: x2l,
  ntilde: C2l,
  ntlg: T2l,
  ntriangleleft: A2l,
  ntrianglelefteq: I2l,
  ntriangleright: O2l,
  ntrianglerighteq: N2l,
  Nu: z2l,
  nu: R2l,
  num: P2l,
  numero: D2l,
  numsp: L2l,
  nvap: M2l,
  nvdash: F2l,
  nvDash: q2l,
  nVdash: j2l,
  nVDash: V2l,
  nvge: B2l,
  nvgt: U2l,
  nvHarr: G2l,
  nvinfin: W2l,
  nvlArr: H2l,
  nvle: Y2l,
  nvlt: K2l,
  nvltrie: Z2l,
  nvrArr: X2l,
  nvrtrie: J2l,
  nvsim: Q2l,
  nwarhk: eIl,
  nwarr: tIl,
  nwArr: nIl,
  nwarrow: oIl,
  nwnear: rIl,
  Oacute: iIl,
  oacute: aIl,
  oast: sIl,
  Ocirc: cIl,
  ocirc: lIl,
  ocir: uIl,
  Ocy: dIl,
  ocy: _Il,
  odash: pIl,
  Odblac: mIl,
  odblac: fIl,
  odiv: gIl,
  odot: hIl,
  odsold: vIl,
  OElig: bIl,
  oelig: yIl,
  ofcir: $Il,
  Ofr: wIl,
  ofr: kIl,
  ogon: SIl,
  Ograve: EIl,
  ograve: xIl,
  ogt: CIl,
  ohbar: TIl,
  ohm: AIl,
  oint: IIl,
  olarr: OIl,
  olcir: NIl,
  olcross: zIl,
  oline: RIl,
  olt: PIl,
  Omacr: DIl,
  omacr: LIl,
  Omega: MIl,
  omega: FIl,
  Omicron: qIl,
  omicron: jIl,
  omid: VIl,
  ominus: BIl,
  Oopf: UIl,
  oopf: GIl,
  opar: WIl,
  OpenCurlyDoubleQuote: HIl,
  OpenCurlyQuote: YIl,
  operp: KIl,
  oplus: ZIl,
  orarr: XIl,
  Or: JIl,
  or: QIl,
  ord: eOl,
  order: tOl,
  orderof: nOl,
  ordf: oOl,
  ordm: rOl,
  origof: iOl,
  oror: aOl,
  orslope: sOl,
  orv: cOl,
  oS: lOl,
  Oscr: uOl,
  oscr: dOl,
  Oslash: _Ol,
  oslash: pOl,
  osol: mOl,
  Otilde: fOl,
  otilde: gOl,
  otimesas: hOl,
  Otimes: vOl,
  otimes: bOl,
  Ouml: yOl,
  ouml: $Ol,
  ovbar: wOl,
  OverBar: kOl,
  OverBrace: SOl,
  OverBracket: EOl,
  OverParenthesis: xOl,
  para: COl,
  parallel: TOl,
  par: AOl,
  parsim: IOl,
  parsl: OOl,
  part: NOl,
  PartialD: zOl,
  Pcy: ROl,
  pcy: POl,
  percnt: DOl,
  period: LOl,
  permil: MOl,
  perp: FOl,
  pertenk: qOl,
  Pfr: jOl,
  pfr: VOl,
  Phi: BOl,
  phi: UOl,
  phiv: GOl,
  phmmat: WOl,
  phone: HOl,
  Pi: YOl,
  pi: KOl,
  pitchfork: ZOl,
  piv: XOl,
  planck: JOl,
  planckh: QOl,
  plankv: eNl,
  plusacir: tNl,
  plusb: nNl,
  pluscir: oNl,
  plus: rNl,
  plusdo: iNl,
  plusdu: aNl,
  pluse: sNl,
  PlusMinus: cNl,
  plusmn: lNl,
  plussim: uNl,
  plustwo: dNl,
  pm: _Nl,
  Poincareplane: pNl,
  pointint: mNl,
  popf: fNl,
  Popf: gNl,
  pound: hNl,
  prap: vNl,
  Pr: bNl,
  pr: yNl,
  prcue: $Nl,
  precapprox: wNl,
  prec: kNl,
  preccurlyeq: SNl,
  Precedes: ENl,
  PrecedesEqual: xNl,
  PrecedesSlantEqual: CNl,
  PrecedesTilde: TNl,
  preceq: ANl,
  precnapprox: INl,
  precneqq: ONl,
  precnsim: NNl,
  pre: zNl,
  prE: RNl,
  precsim: PNl,
  prime: DNl,
  Prime: LNl,
  primes: MNl,
  prnap: FNl,
  prnE: qNl,
  prnsim: jNl,
  prod: VNl,
  Product: BNl,
  profalar: UNl,
  profline: GNl,
  profsurf: WNl,
  prop: HNl,
  Proportional: YNl,
  Proportion: KNl,
  propto: ZNl,
  prsim: XNl,
  prurel: JNl,
  Pscr: QNl,
  pscr: ezl,
  Psi: tzl,
  psi: nzl,
  puncsp: ozl,
  Qfr: rzl,
  qfr: izl,
  qint: azl,
  qopf: szl,
  Qopf: czl,
  qprime: lzl,
  Qscr: uzl,
  qscr: dzl,
  quaternions: _zl,
  quatint: pzl,
  quest: mzl,
  questeq: fzl,
  quot: gzl,
  QUOT: hzl,
  rAarr: vzl,
  race: bzl,
  Racute: yzl,
  racute: $zl,
  radic: wzl,
  raemptyv: kzl,
  rang: Szl,
  Rang: Ezl,
  rangd: xzl,
  range: Czl,
  rangle: Tzl,
  raquo: Azl,
  rarrap: Izl,
  rarrb: Ozl,
  rarrbfs: Nzl,
  rarrc: zzl,
  rarr: Rzl,
  Rarr: Pzl,
  rArr: Dzl,
  rarrfs: Lzl,
  rarrhk: Mzl,
  rarrlp: Fzl,
  rarrpl: qzl,
  rarrsim: jzl,
  Rarrtl: Vzl,
  rarrtl: Bzl,
  rarrw: Uzl,
  ratail: Gzl,
  rAtail: Wzl,
  ratio: Hzl,
  rationals: Yzl,
  rbarr: Kzl,
  rBarr: Zzl,
  RBarr: Xzl,
  rbbrk: Jzl,
  rbrace: Qzl,
  rbrack: eRl,
  rbrke: tRl,
  rbrksld: nRl,
  rbrkslu: oRl,
  Rcaron: rRl,
  rcaron: iRl,
  Rcedil: aRl,
  rcedil: sRl,
  rceil: cRl,
  rcub: lRl,
  Rcy: uRl,
  rcy: dRl,
  rdca: _Rl,
  rdldhar: pRl,
  rdquo: mRl,
  rdquor: fRl,
  rdsh: gRl,
  real: hRl,
  realine: vRl,
  realpart: bRl,
  reals: yRl,
  Re: $Rl,
  rect: wRl,
  reg: kRl,
  REG: SRl,
  ReverseElement: ERl,
  ReverseEquilibrium: xRl,
  ReverseUpEquilibrium: CRl,
  rfisht: TRl,
  rfloor: ARl,
  rfr: IRl,
  Rfr: ORl,
  rHar: NRl,
  rhard: zRl,
  rharu: RRl,
  rharul: PRl,
  Rho: DRl,
  rho: LRl,
  rhov: MRl,
  RightAngleBracket: FRl,
  RightArrowBar: qRl,
  rightarrow: jRl,
  RightArrow: VRl,
  Rightarrow: BRl,
  RightArrowLeftArrow: URl,
  rightarrowtail: GRl,
  RightCeiling: WRl,
  RightDoubleBracket: HRl,
  RightDownTeeVector: YRl,
  RightDownVectorBar: KRl,
  RightDownVector: ZRl,
  RightFloor: XRl,
  rightharpoondown: JRl,
  rightharpoonup: QRl,
  rightleftarrows: ePl,
  rightleftharpoons: tPl,
  rightrightarrows: nPl,
  rightsquigarrow: oPl,
  RightTeeArrow: rPl,
  RightTee: iPl,
  RightTeeVector: aPl,
  rightthreetimes: sPl,
  RightTriangleBar: cPl,
  RightTriangle: lPl,
  RightTriangleEqual: uPl,
  RightUpDownVector: dPl,
  RightUpTeeVector: _Pl,
  RightUpVectorBar: pPl,
  RightUpVector: mPl,
  RightVectorBar: fPl,
  RightVector: gPl,
  ring: hPl,
  risingdotseq: vPl,
  rlarr: bPl,
  rlhar: yPl,
  rlm: $Pl,
  rmoustache: wPl,
  rmoust: kPl,
  rnmid: SPl,
  roang: EPl,
  roarr: xPl,
  robrk: CPl,
  ropar: TPl,
  ropf: APl,
  Ropf: IPl,
  roplus: OPl,
  rotimes: NPl,
  RoundImplies: zPl,
  rpar: RPl,
  rpargt: PPl,
  rppolint: DPl,
  rrarr: LPl,
  Rrightarrow: MPl,
  rsaquo: FPl,
  rscr: qPl,
  Rscr: jPl,
  rsh: VPl,
  Rsh: BPl,
  rsqb: UPl,
  rsquo: GPl,
  rsquor: WPl,
  rthree: HPl,
  rtimes: YPl,
  rtri: KPl,
  rtrie: ZPl,
  rtrif: XPl,
  rtriltri: JPl,
  RuleDelayed: QPl,
  ruluhar: eDl,
  rx: tDl,
  Sacute: nDl,
  sacute: oDl,
  sbquo: rDl,
  scap: iDl,
  Scaron: aDl,
  scaron: sDl,
  Sc: cDl,
  sc: lDl,
  sccue: uDl,
  sce: dDl,
  scE: _Dl,
  Scedil: pDl,
  scedil: mDl,
  Scirc: fDl,
  scirc: gDl,
  scnap: hDl,
  scnE: vDl,
  scnsim: bDl,
  scpolint: yDl,
  scsim: $Dl,
  Scy: wDl,
  scy: kDl,
  sdotb: SDl,
  sdot: EDl,
  sdote: xDl,
  searhk: CDl,
  searr: TDl,
  seArr: ADl,
  searrow: IDl,
  sect: ODl,
  semi: NDl,
  seswar: zDl,
  setminus: RDl,
  setmn: PDl,
  sext: DDl,
  Sfr: LDl,
  sfr: MDl,
  sfrown: FDl,
  sharp: qDl,
  SHCHcy: jDl,
  shchcy: VDl,
  SHcy: BDl,
  shcy: UDl,
  ShortDownArrow: GDl,
  ShortLeftArrow: WDl,
  shortmid: HDl,
  shortparallel: YDl,
  ShortRightArrow: KDl,
  ShortUpArrow: ZDl,
  shy: XDl,
  Sigma: JDl,
  sigma: QDl,
  sigmaf: e3l,
  sigmav: t3l,
  sim: n3l,
  simdot: o3l,
  sime: r3l,
  simeq: i3l,
  simg: a3l,
  simgE: s3l,
  siml: c3l,
  simlE: l3l,
  simne: u3l,
  simplus: d3l,
  simrarr: _3l,
  slarr: p3l,
  SmallCircle: m3l,
  smallsetminus: f3l,
  smashp: g3l,
  smeparsl: h3l,
  smid: v3l,
  smile: b3l,
  smt: y3l,
  smte: $3l,
  smtes: w3l,
  SOFTcy: k3l,
  softcy: S3l,
  solbar: E3l,
  solb: x3l,
  sol: C3l,
  Sopf: T3l,
  sopf: A3l,
  spades: I3l,
  spadesuit: O3l,
  spar: N3l,
  sqcap: z3l,
  sqcaps: R3l,
  sqcup: P3l,
  sqcups: D3l,
  Sqrt: L3l,
  sqsub: M3l,
  sqsube: F3l,
  sqsubset: q3l,
  sqsubseteq: j3l,
  sqsup: V3l,
  sqsupe: B3l,
  sqsupset: U3l,
  sqsupseteq: G3l,
  square: W3l,
  Square: H3l,
  SquareIntersection: Y3l,
  SquareSubset: K3l,
  SquareSubsetEqual: Z3l,
  SquareSuperset: X3l,
  SquareSupersetEqual: J3l,
  SquareUnion: Q3l,
  squarf: eLl,
  squ: tLl,
  squf: nLl,
  srarr: oLl,
  Sscr: rLl,
  sscr: iLl,
  ssetmn: aLl,
  ssmile: sLl,
  sstarf: cLl,
  Star: lLl,
  star: uLl,
  starf: dLl,
  straightepsilon: _Ll,
  straightphi: pLl,
  strns: mLl,
  sub: fLl,
  Sub: gLl,
  subdot: hLl,
  subE: vLl,
  sube: bLl,
  subedot: yLl,
  submult: $Ll,
  subnE: wLl,
  subne: kLl,
  subplus: SLl,
  subrarr: ELl,
  subset: xLl,
  Subset: CLl,
  subseteq: TLl,
  subseteqq: ALl,
  SubsetEqual: ILl,
  subsetneq: OLl,
  subsetneqq: NLl,
  subsim: zLl,
  subsub: RLl,
  subsup: PLl,
  succapprox: DLl,
  succ: LLl,
  succcurlyeq: MLl,
  Succeeds: FLl,
  SucceedsEqual: qLl,
  SucceedsSlantEqual: jLl,
  SucceedsTilde: VLl,
  succeq: BLl,
  succnapprox: ULl,
  succneqq: GLl,
  succnsim: WLl,
  succsim: HLl,
  SuchThat: YLl,
  sum: KLl,
  Sum: ZLl,
  sung: XLl,
  sup1: JLl,
  sup2: QLl,
  sup3: eMl,
  sup: tMl,
  Sup: nMl,
  supdot: oMl,
  supdsub: rMl,
  supE: iMl,
  supe: aMl,
  supedot: sMl,
  Superset: cMl,
  SupersetEqual: lMl,
  suphsol: uMl,
  suphsub: dMl,
  suplarr: _Ml,
  supmult: pMl,
  supnE: mMl,
  supne: fMl,
  supplus: gMl,
  supset: hMl,
  Supset: vMl,
  supseteq: bMl,
  supseteqq: yMl,
  supsetneq: $Ml,
  supsetneqq: wMl,
  supsim: kMl,
  supsub: SMl,
  supsup: EMl,
  swarhk: xMl,
  swarr: CMl,
  swArr: TMl,
  swarrow: AMl,
  swnwar: IMl,
  szlig: OMl,
  Tab: NMl,
  target: zMl,
  Tau: RMl,
  tau: PMl,
  tbrk: DMl,
  Tcaron: LMl,
  tcaron: MMl,
  Tcedil: FMl,
  tcedil: qMl,
  Tcy: jMl,
  tcy: VMl,
  tdot: BMl,
  telrec: UMl,
  Tfr: GMl,
  tfr: WMl,
  there4: HMl,
  therefore: YMl,
  Therefore: KMl,
  Theta: ZMl,
  theta: XMl,
  thetasym: JMl,
  thetav: QMl,
  thickapprox: e4l,
  thicksim: t4l,
  ThickSpace: n4l,
  ThinSpace: o4l,
  thinsp: r4l,
  thkap: i4l,
  thksim: a4l,
  THORN: s4l,
  thorn: c4l,
  tilde: l4l,
  Tilde: u4l,
  TildeEqual: d4l,
  TildeFullEqual: _4l,
  TildeTilde: p4l,
  timesbar: m4l,
  timesb: f4l,
  times: g4l,
  timesd: h4l,
  tint: v4l,
  toea: b4l,
  topbot: y4l,
  topcir: $4l,
  top: w4l,
  Topf: k4l,
  topf: S4l,
  topfork: E4l,
  tosa: x4l,
  tprime: C4l,
  trade: T4l,
  TRADE: A4l,
  triangle: I4l,
  triangledown: O4l,
  triangleleft: N4l,
  trianglelefteq: z4l,
  triangleq: R4l,
  triangleright: P4l,
  trianglerighteq: D4l,
  tridot: L4l,
  trie: M4l,
  triminus: F4l,
  TripleDot: q4l,
  triplus: j4l,
  trisb: V4l,
  tritime: B4l,
  trpezium: U4l,
  Tscr: G4l,
  tscr: W4l,
  TScy: H4l,
  tscy: Y4l,
  TSHcy: K4l,
  tshcy: Z4l,
  Tstrok: X4l,
  tstrok: J4l,
  twixt: Q4l,
  twoheadleftarrow: e5l,
  twoheadrightarrow: t5l,
  Uacute: n5l,
  uacute: o5l,
  uarr: r5l,
  Uarr: i5l,
  uArr: a5l,
  Uarrocir: s5l,
  Ubrcy: c5l,
  ubrcy: l5l,
  Ubreve: u5l,
  ubreve: d5l,
  Ucirc: _5l,
  ucirc: p5l,
  Ucy: m5l,
  ucy: f5l,
  udarr: g5l,
  Udblac: h5l,
  udblac: v5l,
  udhar: b5l,
  ufisht: y5l,
  Ufr: $5l,
  ufr: w5l,
  Ugrave: k5l,
  ugrave: S5l,
  uHar: E5l,
  uharl: x5l,
  uharr: C5l,
  uhblk: T5l,
  ulcorn: A5l,
  ulcorner: I5l,
  ulcrop: O5l,
  ultri: N5l,
  Umacr: z5l,
  umacr: R5l,
  uml: P5l,
  UnderBar: D5l,
  UnderBrace: L5l,
  UnderBracket: M5l,
  UnderParenthesis: F5l,
  Union: q5l,
  UnionPlus: j5l,
  Uogon: V5l,
  uogon: B5l,
  Uopf: U5l,
  uopf: G5l,
  UpArrowBar: W5l,
  uparrow: H5l,
  UpArrow: Y5l,
  Uparrow: K5l,
  UpArrowDownArrow: Z5l,
  updownarrow: X5l,
  UpDownArrow: J5l,
  Updownarrow: Q5l,
  UpEquilibrium: e6l,
  upharpoonleft: t6l,
  upharpoonright: n6l,
  uplus: o6l,
  UpperLeftArrow: r6l,
  UpperRightArrow: i6l,
  upsi: a6l,
  Upsi: s6l,
  upsih: c6l,
  Upsilon: l6l,
  upsilon: u6l,
  UpTeeArrow: d6l,
  UpTee: _6l,
  upuparrows: p6l,
  urcorn: m6l,
  urcorner: f6l,
  urcrop: g6l,
  Uring: h6l,
  uring: v6l,
  urtri: b6l,
  Uscr: y6l,
  uscr: $6l,
  utdot: w6l,
  Utilde: k6l,
  utilde: S6l,
  utri: E6l,
  utrif: x6l,
  uuarr: C6l,
  Uuml: T6l,
  uuml: A6l,
  uwangle: I6l,
  vangrt: O6l,
  varepsilon: N6l,
  varkappa: z6l,
  varnothing: R6l,
  varphi: P6l,
  varpi: D6l,
  varpropto: L6l,
  varr: M6l,
  vArr: F6l,
  varrho: q6l,
  varsigma: j6l,
  varsubsetneq: V6l,
  varsubsetneqq: B6l,
  varsupsetneq: U6l,
  varsupsetneqq: G6l,
  vartheta: W6l,
  vartriangleleft: H6l,
  vartriangleright: Y6l,
  vBar: K6l,
  Vbar: Z6l,
  vBarv: X6l,
  Vcy: J6l,
  vcy: Q6l,
  vdash: eFl,
  vDash: tFl,
  Vdash: nFl,
  VDash: oFl,
  Vdashl: rFl,
  veebar: iFl,
  vee: aFl,
  Vee: sFl,
  veeeq: cFl,
  vellip: lFl,
  verbar: uFl,
  Verbar: dFl,
  vert: _Fl,
  Vert: pFl,
  VerticalBar: mFl,
  VerticalLine: fFl,
  VerticalSeparator: gFl,
  VerticalTilde: hFl,
  VeryThinSpace: vFl,
  Vfr: bFl,
  vfr: yFl,
  vltri: $Fl,
  vnsub: wFl,
  vnsup: kFl,
  Vopf: SFl,
  vopf: EFl,
  vprop: xFl,
  vrtri: CFl,
  Vscr: TFl,
  vscr: AFl,
  vsubnE: IFl,
  vsubne: OFl,
  vsupnE: NFl,
  vsupne: zFl,
  Vvdash: RFl,
  vzigzag: PFl,
  Wcirc: DFl,
  wcirc: LFl,
  wedbar: MFl,
  wedge: FFl,
  Wedge: qFl,
  wedgeq: jFl,
  weierp: VFl,
  Wfr: BFl,
  wfr: UFl,
  Wopf: GFl,
  wopf: WFl,
  wp: HFl,
  wr: YFl,
  wreath: KFl,
  Wscr: ZFl,
  wscr: XFl,
  xcap: JFl,
  xcirc: QFl,
  xcup: eql,
  xdtri: tql,
  Xfr: nql,
  xfr: oql,
  xharr: rql,
  xhArr: iql,
  Xi: aql,
  xi: sql,
  xlarr: cql,
  xlArr: lql,
  xmap: uql,
  xnis: dql,
  xodot: _ql,
  Xopf: pql,
  xopf: mql,
  xoplus: fql,
  xotime: gql,
  xrarr: hql,
  xrArr: vql,
  Xscr: bql,
  xscr: yql,
  xsqcup: $ql,
  xuplus: wql,
  xutri: kql,
  xvee: Sql,
  xwedge: Eql,
  Yacute: xql,
  yacute: Cql,
  YAcy: Tql,
  yacy: Aql,
  Ycirc: Iql,
  ycirc: Oql,
  Ycy: Nql,
  ycy: zql,
  yen: Rql,
  Yfr: Pql,
  yfr: Dql,
  YIcy: Lql,
  yicy: Mql,
  Yopf: Fql,
  yopf: qql,
  Yscr: jql,
  yscr: Vql,
  YUcy: Bql,
  yucy: Uql,
  yuml: Gql,
  Yuml: Wql,
  Zacute: Hql,
  zacute: Yql,
  Zcaron: Kql,
  zcaron: Zql,
  Zcy: Xql,
  zcy: Jql,
  Zdot: Qql,
  zdot: ejl,
  zeetrf: tjl,
  ZeroWidthSpace: njl,
  Zeta: ojl,
  zeta: rjl,
  zfr: ijl,
  Zfr: ajl,
  ZHcy: sjl,
  zhcy: cjl,
  zigrarr: ljl,
  zopf: ujl,
  Zopf: djl,
  Zscr: _jl,
  zscr: pjl,
  zwj: mjl,
  zwnj: fjl
};
var Lhe = gjl, Pj = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, s$ = {}, aZ = {};
function hjl(e) {
  var t, n, o = aZ[e];
  if (o)
    return o;
  for (o = aZ[e] = [], t = 0; t < 128; t++)
    n = String.fromCharCode(t), /^[0-9a-z]$/i.test(n) ? o.push(n) : o.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
  for (t = 0; t < e.length; t++)
    o[e.charCodeAt(t)] = e[t];
  return o;
}
function WA(e, t, n) {
  var o, r, i, a, s, c = "";
  for (typeof t != "string" && (n = t, t = WA.defaultChars), typeof n > "u" && (n = !0), s = hjl(t), o = 0, r = e.length; o < r; o++) {
    if (i = e.charCodeAt(o), n && i === 37 && o + 2 < r && /^[0-9a-f]{2}$/i.test(e.slice(o + 1, o + 3))) {
      c += e.slice(o, o + 3), o += 2;
      continue;
    }
    if (i < 128) {
      c += s[i];
      continue;
    }
    if (i >= 55296 && i <= 57343) {
      if (i >= 55296 && i <= 56319 && o + 1 < r && (a = e.charCodeAt(o + 1), a >= 56320 && a <= 57343)) {
        c += encodeURIComponent(e[o] + e[o + 1]), o++;
        continue;
      }
      c += "%EF%BF%BD";
      continue;
    }
    c += encodeURIComponent(e[o]);
  }
  return c;
}
WA.defaultChars = ";/?:@&=+$,-_.!~*'()#";
WA.componentChars = "-_.!~*'()";
var vjl = WA, sZ = {};
function bjl(e) {
  var t, n, o = sZ[e];
  if (o)
    return o;
  for (o = sZ[e] = [], t = 0; t < 128; t++)
    n = String.fromCharCode(t), o.push(n);
  for (t = 0; t < e.length; t++)
    n = e.charCodeAt(t), o[n] = "%" + ("0" + n.toString(16).toUpperCase()).slice(-2);
  return o;
}
function HA(e, t) {
  var n;
  return typeof t != "string" && (t = HA.defaultChars), n = bjl(t), e.replace(/(%[a-f0-9]{2})+/gi, function(o) {
    var r, i, a, s, c, l, u, d = "";
    for (r = 0, i = o.length; r < i; r += 3) {
      if (a = parseInt(o.slice(r + 1, r + 3), 16), a < 128) {
        d += n[a];
        continue;
      }
      if ((a & 224) === 192 && r + 3 < i && (s = parseInt(o.slice(r + 4, r + 6), 16), (s & 192) === 128)) {
        u = a << 6 & 1984 | s & 63, u < 128 ? d += "��" : d += String.fromCharCode(u), r += 3;
        continue;
      }
      if ((a & 240) === 224 && r + 6 < i && (s = parseInt(o.slice(r + 4, r + 6), 16), c = parseInt(o.slice(r + 7, r + 9), 16), (s & 192) === 128 && (c & 192) === 128)) {
        u = a << 12 & 61440 | s << 6 & 4032 | c & 63, u < 2048 || u >= 55296 && u <= 57343 ? d += "���" : d += String.fromCharCode(u), r += 6;
        continue;
      }
      if ((a & 248) === 240 && r + 9 < i && (s = parseInt(o.slice(r + 4, r + 6), 16), c = parseInt(o.slice(r + 7, r + 9), 16), l = parseInt(o.slice(r + 10, r + 12), 16), (s & 192) === 128 && (c & 192) === 128 && (l & 192) === 128)) {
        u = a << 18 & 1835008 | s << 12 & 258048 | c << 6 & 4032 | l & 63, u < 65536 || u > 1114111 ? d += "����" : (u -= 65536, d += String.fromCharCode(55296 + (u >> 10), 56320 + (u & 1023))), r += 9;
        continue;
      }
      d += "�";
    }
    return d;
  });
}
HA.defaultChars = ";/?:@&=+$,#";
HA.componentChars = "";
var yjl = HA, $jl = function(t) {
  var n = "";
  return n += t.protocol || "", n += t.slashes ? "//" : "", n += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? n += "[" + t.hostname + "]" : n += t.hostname || "", n += t.port ? ":" + t.port : "", n += t.pathname || "", n += t.search || "", n += t.hash || "", n;
};
function eT() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
var wjl = /^([a-z0-9.+-]+:)/i, kjl = /:[0-9]*$/, Sjl = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, Ejl = ["<", ">", '"', "`", " ", "\r", `
`, "	"], xjl = ["{", "}", "|", "\\", "^", "`"].concat(Ejl), Cjl = ["'"].concat(xjl), cZ = ["%", "/", "?", ";", "#"].concat(Cjl), lZ = ["/", "?", "#"], Tjl = 255, uZ = /^[+a-z0-9A-Z_-]{0,63}$/, Ajl = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, dZ = {
  javascript: !0,
  "javascript:": !0
}, _Z = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function Ijl(e, t) {
  if (e && e instanceof eT)
    return e;
  var n = new eT();
  return n.parse(e, t), n;
}
eT.prototype.parse = function(e, t) {
  var n, o, r, i, a, s = e;
  if (s = s.trim(), !t && e.split("#").length === 1) {
    var c = Sjl.exec(s);
    if (c)
      return this.pathname = c[1], c[2] && (this.search = c[2]), this;
  }
  var l = wjl.exec(s);
  if (l && (l = l[0], r = l.toLowerCase(), this.protocol = l, s = s.substr(l.length)), (t || l || s.match(/^\/\/[^@\/]+@[^@\/]+/)) && (a = s.substr(0, 2) === "//", a && !(l && dZ[l]) && (s = s.substr(2), this.slashes = !0)), !dZ[l] && (a || l && !_Z[l])) {
    var u = -1;
    for (n = 0; n < lZ.length; n++)
      i = s.indexOf(lZ[n]), i !== -1 && (u === -1 || i < u) && (u = i);
    var d, _;
    for (u === -1 ? _ = s.lastIndexOf("@") : _ = s.lastIndexOf("@", u), _ !== -1 && (d = s.slice(0, _), s = s.slice(_ + 1), this.auth = d), u = -1, n = 0; n < cZ.length; n++)
      i = s.indexOf(cZ[n]), i !== -1 && (u === -1 || i < u) && (u = i);
    u === -1 && (u = s.length), s[u - 1] === ":" && u--;
    var p = s.slice(0, u);
    s = s.slice(u), this.parseHost(p), this.hostname = this.hostname || "";
    var g = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!g) {
      var f = this.hostname.split(/\./);
      for (n = 0, o = f.length; n < o; n++) {
        var h = f[n];
        if (h && !h.match(uZ)) {
          for (var $ = "", v = 0, b = h.length; v < b; v++)
            h.charCodeAt(v) > 127 ? $ += "x" : $ += h[v];
          if (!$.match(uZ)) {
            var y = f.slice(0, n), w = f.slice(n + 1), N = h.match(Ajl);
            N && (y.push(N[1]), w.unshift(N[2])), w.length && (s = w.join(".") + s), this.hostname = y.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > Tjl && (this.hostname = ""), g && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  var M = s.indexOf("#");
  M !== -1 && (this.hash = s.substr(M), s = s.slice(0, M));
  var q = s.indexOf("?");
  return q !== -1 && (this.search = s.substr(q), s = s.slice(0, q)), s && (this.pathname = s), _Z[r] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
eT.prototype.parseHost = function(e) {
  var t = kjl.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
var Ojl = Ijl;
s$.encode = vjl;
s$.decode = yjl;
s$.format = $jl;
s$.parse = Ojl;
var fh = {}, nR, pZ;
function Mhe() {
  return pZ || (pZ = 1, nR = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), nR;
}
var oR, mZ;
function Fhe() {
  return mZ || (mZ = 1, oR = /[\0-\x1F\x7F-\x9F]/), oR;
}
var rR, fZ;
function Njl() {
  return fZ || (fZ = 1, rR = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), rR;
}
var iR, gZ;
function qhe() {
  return gZ || (gZ = 1, iR = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), iR;
}
var hZ;
function zjl() {
  return hZ || (hZ = 1, fh.Any = Mhe(), fh.Cc = Fhe(), fh.Cf = Njl(), fh.P = Pj, fh.Z = qhe()), fh;
}
(function(e) {
  function t(S) {
    return Object.prototype.toString.call(S);
  }
  function n(S) {
    return t(S) === "[object String]";
  }
  var o = Object.prototype.hasOwnProperty;
  function r(S, E) {
    return o.call(S, E);
  }
  function i(S) {
    var E = Array.prototype.slice.call(arguments, 1);
    return E.forEach(function(x) {
      if (x) {
        if (typeof x != "object")
          throw new TypeError(x + "must be object");
        Object.keys(x).forEach(function(k) {
          S[k] = x[k];
        });
      }
    }), S;
  }
  function a(S, E, x) {
    return [].concat(S.slice(0, E), x, S.slice(E + 1));
  }
  function s(S) {
    return !(S >= 55296 && S <= 57343 || S >= 64976 && S <= 65007 || (S & 65535) === 65535 || (S & 65535) === 65534 || S >= 0 && S <= 8 || S === 11 || S >= 14 && S <= 31 || S >= 127 && S <= 159 || S > 1114111);
  }
  function c(S) {
    if (S > 65535) {
      S -= 65536;
      var E = 55296 + (S >> 10), x = 56320 + (S & 1023);
      return String.fromCharCode(E, x);
    }
    return String.fromCharCode(S);
  }
  var l = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g, u = /&([a-z#][a-z0-9]{1,31});/gi, d = new RegExp(l.source + "|" + u.source, "gi"), _ = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i, p = Lhe;
  function g(S, E) {
    var x = 0;
    return r(p, E) ? p[E] : E.charCodeAt(0) === 35 && _.test(E) && (x = E[1].toLowerCase() === "x" ? parseInt(E.slice(2), 16) : parseInt(E.slice(1), 10), s(x)) ? c(x) : S;
  }
  function f(S) {
    return S.indexOf("\\") < 0 ? S : S.replace(l, "$1");
  }
  function h(S) {
    return S.indexOf("\\") < 0 && S.indexOf("&") < 0 ? S : S.replace(d, function(E, x, k) {
      return x || g(E, k);
    });
  }
  var $ = /[&<>"]/, v = /[&<>"]/g, b = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
  };
  function y(S) {
    return b[S];
  }
  function w(S) {
    return $.test(S) ? S.replace(v, y) : S;
  }
  var N = /[.?*+^$[\]\\(){}|-]/g;
  function M(S) {
    return S.replace(N, "\\$&");
  }
  function q(S) {
    switch (S) {
      case 9:
      case 32:
        return !0;
    }
    return !1;
  }
  function L(S) {
    if (S >= 8192 && S <= 8202)
      return !0;
    switch (S) {
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 32:
      case 160:
      case 5760:
      case 8239:
      case 8287:
      case 12288:
        return !0;
    }
    return !1;
  }
  var R = Pj;
  function T(S) {
    return R.test(S);
  }
  function D(S) {
    switch (S) {
      case 33:
      case 34:
      case 35:
      case 36:
      case 37:
      case 38:
      case 39:
      case 40:
      case 41:
      case 42:
      case 43:
      case 44:
      case 45:
      case 46:
      case 47:
      case 58:
      case 59:
      case 60:
      case 61:
      case 62:
      case 63:
      case 64:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 123:
      case 124:
      case 125:
      case 126:
        return !0;
      default:
        return !1;
    }
  }
  function A(S) {
    return S = S.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (S = S.replace(/ẞ/g, "ß")), S.toLowerCase().toUpperCase();
  }
  e.lib = {}, e.lib.mdurl = s$, e.lib.ucmicro = zjl(), e.assign = i, e.isString = n, e.has = r, e.unescapeMd = f, e.unescapeAll = h, e.isValidEntityCode = s, e.fromCodePoint = c, e.escapeHtml = w, e.arrayReplaceAt = a, e.isSpace = q, e.isWhiteSpace = L, e.isMdAsciiPunct = D, e.isPunctChar = T, e.escapeRE = M, e.normalizeReference = A;
})(ri);
var YA = {}, Rjl = function(t, n, o) {
  var r, i, a, s, c = -1, l = t.posMax, u = t.pos;
  for (t.pos = n + 1, r = 1; t.pos < l; ) {
    if (a = t.src.charCodeAt(t.pos), a === 93 && (r--, r === 0)) {
      i = !0;
      break;
    }
    if (s = t.pos, t.md.inline.skipToken(t), a === 91) {
      if (s === t.pos - 1)
        r++;
      else if (o)
        return t.pos = u, -1;
    }
  }
  return i && (c = t.pos), t.pos = u, c;
}, vZ = ri.unescapeAll, Pjl = function(t, n, o) {
  var r, i, a = 0, s = n, c = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (t.charCodeAt(n) === 60) {
    for (n++; n < o; ) {
      if (r = t.charCodeAt(n), r === 10 || r === 60)
        return c;
      if (r === 62)
        return c.pos = n + 1, c.str = vZ(t.slice(s + 1, n)), c.ok = !0, c;
      if (r === 92 && n + 1 < o) {
        n += 2;
        continue;
      }
      n++;
    }
    return c;
  }
  for (i = 0; n < o && (r = t.charCodeAt(n), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && n + 1 < o) {
      if (t.charCodeAt(n + 1) === 32)
        break;
      n += 2;
      continue;
    }
    if (r === 40 && (i++, i > 32))
      return c;
    if (r === 41) {
      if (i === 0)
        break;
      i--;
    }
    n++;
  }
  return s === n || i !== 0 || (c.str = vZ(t.slice(s, n)), c.lines = a, c.pos = n, c.ok = !0), c;
}, Djl = ri.unescapeAll, Ljl = function(t, n, o) {
  var r, i, a = 0, s = n, c = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (n >= o || (i = t.charCodeAt(n), i !== 34 && i !== 39 && i !== 40))
    return c;
  for (n++, i === 40 && (i = 41); n < o; ) {
    if (r = t.charCodeAt(n), r === i)
      return c.pos = n + 1, c.lines = a, c.str = Djl(t.slice(s + 1, n)), c.ok = !0, c;
    if (r === 40 && i === 41)
      return c;
    r === 10 ? a++ : r === 92 && n + 1 < o && (n++, t.charCodeAt(n) === 10 && a++), n++;
  }
  return c;
};
YA.parseLinkLabel = Rjl;
YA.parseLinkDestination = Pjl;
YA.parseLinkTitle = Ljl;
var Mjl = ri.assign, Fjl = ri.unescapeAll, yv = ri.escapeHtml, om = {};
om.code_inline = function(e, t, n, o, r) {
  var i = e[t];
  return "<code" + r.renderAttrs(i) + ">" + yv(e[t].content) + "</code>";
};
om.code_block = function(e, t, n, o, r) {
  var i = e[t];
  return "<pre" + r.renderAttrs(i) + "><code>" + yv(e[t].content) + `</code></pre>
`;
};
om.fence = function(e, t, n, o, r) {
  var i = e[t], a = i.info ? Fjl(i.info).trim() : "", s = "", c = "", l, u, d, _, p;
  return a && (d = a.split(/(\s+)/g), s = d[0], c = d.slice(2).join("")), n.highlight ? l = n.highlight(i.content, s, c) || yv(i.content) : l = yv(i.content), l.indexOf("<pre") === 0 ? l + `
` : a ? (u = i.attrIndex("class"), _ = i.attrs ? i.attrs.slice() : [], u < 0 ? _.push(["class", n.langPrefix + s]) : (_[u] = _[u].slice(), _[u][1] += " " + n.langPrefix + s), p = {
    attrs: _
  }, "<pre><code" + r.renderAttrs(p) + ">" + l + `</code></pre>
`) : "<pre><code" + r.renderAttrs(i) + ">" + l + `</code></pre>
`;
};
om.image = function(e, t, n, o, r) {
  var i = e[t];
  return i.attrs[i.attrIndex("alt")][1] = r.renderInlineAsText(i.children, n, o), r.renderToken(e, t, n);
};
om.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
om.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
om.text = function(e, t) {
  return yv(e[t].content);
};
om.html_block = function(e, t) {
  return e[t].content;
};
om.html_inline = function(e, t) {
  return e[t].content;
};
function c$() {
  this.rules = Mjl({}, om);
}
c$.prototype.renderAttrs = function(t) {
  var n, o, r;
  if (!t.attrs)
    return "";
  for (r = "", n = 0, o = t.attrs.length; n < o; n++)
    r += " " + yv(t.attrs[n][0]) + '="' + yv(t.attrs[n][1]) + '"';
  return r;
};
c$.prototype.renderToken = function(t, n, o) {
  var r, i = "", a = !1, s = t[n];
  return s.hidden ? "" : (s.block && s.nesting !== -1 && n && t[n - 1].hidden && (i += `
`), i += (s.nesting === -1 ? "</" : "<") + s.tag, i += this.renderAttrs(s), s.nesting === 0 && o.xhtmlOut && (i += " /"), s.block && (a = !0, s.nesting === 1 && n + 1 < t.length && (r = t[n + 1], (r.type === "inline" || r.hidden || r.nesting === -1 && r.tag === s.tag) && (a = !1))), i += a ? `>
` : ">", i);
};
c$.prototype.renderInline = function(e, t, n) {
  for (var o, r = "", i = this.rules, a = 0, s = e.length; a < s; a++)
    o = e[a].type, typeof i[o] < "u" ? r += i[o](e, a, t, n, this) : r += this.renderToken(e, a, t);
  return r;
};
c$.prototype.renderInlineAsText = function(e, t, n) {
  for (var o = "", r = 0, i = e.length; r < i; r++)
    e[r].type === "text" ? o += e[r].content : e[r].type === "image" ? o += this.renderInlineAsText(e[r].children, t, n) : e[r].type === "softbreak" && (o += `
`);
  return o;
};
c$.prototype.render = function(e, t, n) {
  var o, r, i, a = "", s = this.rules;
  for (o = 0, r = e.length; o < r; o++)
    i = e[o].type, i === "inline" ? a += this.renderInline(e[o].children, t, n) : typeof s[i] < "u" ? a += s[e[o].type](e, o, t, n, this) : a += this.renderToken(e, o, t, n);
  return a;
};
var qjl = c$;
function X_() {
  this.__rules__ = [], this.__cache__ = null;
}
X_.prototype.__find__ = function(e) {
  for (var t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
X_.prototype.__compile__ = function() {
  var e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(o) {
      t.indexOf(o) < 0 && t.push(o);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(o) {
      o.enabled && (n && o.alt.indexOf(n) < 0 || e.__cache__[n].push(o.fn));
    });
  });
};
X_.prototype.at = function(e, t, n) {
  var o = this.__find__(e), r = n || {};
  if (o === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[o].fn = t, this.__rules__[o].alt = r.alt || [], this.__cache__ = null;
};
X_.prototype.before = function(e, t, n, o) {
  var r = this.__find__(e), i = o || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(r, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
X_.prototype.after = function(e, t, n, o) {
  var r = this.__find__(e), i = o || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(r + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
X_.prototype.push = function(e, t, n) {
  var o = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: o.alt || []
  }), this.__cache__ = null;
};
X_.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  var n = [];
  return e.forEach(function(o) {
    var r = this.__find__(o);
    if (r < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + o);
    }
    this.__rules__[r].enabled = !0, n.push(o);
  }, this), this.__cache__ = null, n;
};
X_.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(e, t);
};
X_.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  var n = [];
  return e.forEach(function(o) {
    var r = this.__find__(o);
    if (r < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + o);
    }
    this.__rules__[r].enabled = !1, n.push(o);
  }, this), this.__cache__ = null, n;
};
X_.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
var Dj = X_, jjl = /\r\n?|\n/g, Vjl = /\0/g, Bjl = function(t) {
  var n;
  n = t.src.replace(jjl, `
`), n = n.replace(Vjl, "�"), t.src = n;
}, Ujl = function(t) {
  var n;
  t.inlineMode ? (n = new t.Token("inline", "", 0), n.content = t.src, n.map = [0, 1], n.children = [], t.tokens.push(n)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
}, Gjl = function(t) {
  var n = t.tokens, o, r, i;
  for (r = 0, i = n.length; r < i; r++)
    o = n[r], o.type === "inline" && t.md.inline.parse(o.content, t.md, t.env, o.children);
}, Wjl = ri.arrayReplaceAt;
function Hjl(e) {
  return /^<a[>\s]/i.test(e);
}
function Yjl(e) {
  return /^<\/a\s*>/i.test(e);
}
var Kjl = function(t) {
  var n, o, r, i, a, s, c, l, u, d, _, p, g, f, h, $, v = t.tokens, b;
  if (t.md.options.linkify) {
    for (o = 0, r = v.length; o < r; o++)
      if (!(v[o].type !== "inline" || !t.md.linkify.pretest(v[o].content)))
        for (i = v[o].children, g = 0, n = i.length - 1; n >= 0; n--) {
          if (s = i[n], s.type === "link_close") {
            for (n--; i[n].level !== s.level && i[n].type !== "link_open"; )
              n--;
            continue;
          }
          if (s.type === "html_inline" && (Hjl(s.content) && g > 0 && g--, Yjl(s.content) && g++), !(g > 0) && s.type === "text" && t.md.linkify.test(s.content)) {
            for (u = s.content, b = t.md.linkify.match(u), c = [], p = s.level, _ = 0, b.length > 0 && b[0].index === 0 && n > 0 && i[n - 1].type === "text_special" && (b = b.slice(1)), l = 0; l < b.length; l++)
              f = b[l].url, h = t.md.normalizeLink(f), t.md.validateLink(h) && ($ = b[l].text, b[l].schema ? b[l].schema === "mailto:" && !/^mailto:/i.test($) ? $ = t.md.normalizeLinkText("mailto:" + $).replace(/^mailto:/, "") : $ = t.md.normalizeLinkText($) : $ = t.md.normalizeLinkText("http://" + $).replace(/^http:\/\//, ""), d = b[l].index, d > _ && (a = new t.Token("text", "", 0), a.content = u.slice(_, d), a.level = p, c.push(a)), a = new t.Token("link_open", "a", 1), a.attrs = [["href", h]], a.level = p++, a.markup = "linkify", a.info = "auto", c.push(a), a = new t.Token("text", "", 0), a.content = $, a.level = p, c.push(a), a = new t.Token("link_close", "a", -1), a.level = --p, a.markup = "linkify", a.info = "auto", c.push(a), _ = b[l].lastIndex);
            _ < u.length && (a = new t.Token("text", "", 0), a.content = u.slice(_), a.level = p, c.push(a)), v[o].children = i = Wjl(i, n, c);
          }
        }
  }
}, jhe = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, Zjl = /\((c|tm|r)\)/i, Xjl = /\((c|tm|r)\)/ig, Jjl = {
  c: "©",
  r: "®",
  tm: "™"
};
function Qjl(e, t) {
  return Jjl[t.toLowerCase()];
}
function eVl(e) {
  var t, n, o = 0;
  for (t = e.length - 1; t >= 0; t--)
    n = e[t], n.type === "text" && !o && (n.content = n.content.replace(Xjl, Qjl)), n.type === "link_open" && n.info === "auto" && o--, n.type === "link_close" && n.info === "auto" && o++;
}
function tVl(e) {
  var t, n, o = 0;
  for (t = e.length - 1; t >= 0; t--)
    n = e[t], n.type === "text" && !o && jhe.test(n.content) && (n.content = n.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), n.type === "link_open" && n.info === "auto" && o--, n.type === "link_close" && n.info === "auto" && o++;
}
var nVl = function(t) {
  var n;
  if (t.md.options.typographer)
    for (n = t.tokens.length - 1; n >= 0; n--)
      t.tokens[n].type === "inline" && (Zjl.test(t.tokens[n].content) && eVl(t.tokens[n].children), jhe.test(t.tokens[n].content) && tVl(t.tokens[n].children));
}, bZ = ri.isWhiteSpace, yZ = ri.isPunctChar, $Z = ri.isMdAsciiPunct, oVl = /['"]/, wZ = /['"]/g, kZ = "’";
function aE(e, t, n) {
  return e.slice(0, t) + n + e.slice(t + 1);
}
function rVl(e, t) {
  var n, o, r, i, a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w, N;
  for (y = [], n = 0; n < e.length; n++) {
    for (o = e[n], c = e[n].level, v = y.length - 1; v >= 0 && !(y[v].level <= c); v--)
      ;
    if (y.length = v + 1, o.type === "text") {
      r = o.content, a = 0, s = r.length;
      e:
        for (; a < s && (wZ.lastIndex = a, i = wZ.exec(r), !!i); ) {
          if (h = $ = !0, a = i.index + 1, b = i[0] === "'", u = 32, i.index - 1 >= 0)
            u = r.charCodeAt(i.index - 1);
          else
            for (v = n - 1; v >= 0 && !(e[v].type === "softbreak" || e[v].type === "hardbreak"); v--)
              if (e[v].content) {
                u = e[v].content.charCodeAt(e[v].content.length - 1);
                break;
              }
          if (d = 32, a < s)
            d = r.charCodeAt(a);
          else
            for (v = n + 1; v < e.length && !(e[v].type === "softbreak" || e[v].type === "hardbreak"); v++)
              if (e[v].content) {
                d = e[v].content.charCodeAt(0);
                break;
              }
          if (_ = $Z(u) || yZ(String.fromCharCode(u)), p = $Z(d) || yZ(String.fromCharCode(d)), g = bZ(u), f = bZ(d), f ? h = !1 : p && (g || _ || (h = !1)), g ? $ = !1 : _ && (f || p || ($ = !1)), d === 34 && i[0] === '"' && u >= 48 && u <= 57 && ($ = h = !1), h && $ && (h = _, $ = p), !h && !$) {
            b && (o.content = aE(o.content, i.index, kZ));
            continue;
          }
          if ($) {
            for (v = y.length - 1; v >= 0 && (l = y[v], !(y[v].level < c)); v--)
              if (l.single === b && y[v].level === c) {
                l = y[v], b ? (w = t.md.options.quotes[2], N = t.md.options.quotes[3]) : (w = t.md.options.quotes[0], N = t.md.options.quotes[1]), o.content = aE(o.content, i.index, N), e[l.token].content = aE(
                  e[l.token].content,
                  l.pos,
                  w
                ), a += N.length - 1, l.token === n && (a += w.length - 1), r = o.content, s = r.length, y.length = v;
                continue e;
              }
          }
          h ? y.push({
            token: n,
            pos: i.index,
            single: b,
            level: c
          }) : $ && b && (o.content = aE(o.content, i.index, kZ));
        }
    }
  }
}
var iVl = function(t) {
  var n;
  if (t.md.options.typographer)
    for (n = t.tokens.length - 1; n >= 0; n--)
      t.tokens[n].type !== "inline" || !oVl.test(t.tokens[n].content) || rVl(t.tokens[n].children, t);
}, aVl = function(t) {
  var n, o, r, i, a, s, c = t.tokens;
  for (n = 0, o = c.length; n < o; n++)
    if (c[n].type === "inline") {
      for (r = c[n].children, a = r.length, i = 0; i < a; i++)
        r[i].type === "text_special" && (r[i].type = "text");
      for (i = s = 0; i < a; i++)
        r[i].type === "text" && i + 1 < a && r[i + 1].type === "text" ? r[i + 1].content = r[i].content + r[i + 1].content : (i !== s && (r[s] = r[i]), s++);
      i !== s && (r.length = s);
    }
};
function l$(e, t, n) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
l$.prototype.attrIndex = function(t) {
  var n, o, r;
  if (!this.attrs)
    return -1;
  for (n = this.attrs, o = 0, r = n.length; o < r; o++)
    if (n[o][0] === t)
      return o;
  return -1;
};
l$.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
l$.prototype.attrSet = function(t, n) {
  var o = this.attrIndex(t), r = [t, n];
  o < 0 ? this.attrPush(r) : this.attrs[o] = r;
};
l$.prototype.attrGet = function(t) {
  var n = this.attrIndex(t), o = null;
  return n >= 0 && (o = this.attrs[n][1]), o;
};
l$.prototype.attrJoin = function(t, n) {
  var o = this.attrIndex(t);
  o < 0 ? this.attrPush([t, n]) : this.attrs[o][1] = this.attrs[o][1] + " " + n;
};
var Lj = l$, sVl = Lj;
function Vhe(e, t, n) {
  this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
}
Vhe.prototype.Token = sVl;
var cVl = Vhe, lVl = Dj, aR = [
  ["normalize", Bjl],
  ["block", Ujl],
  ["inline", Gjl],
  ["linkify", Kjl],
  ["replacements", nVl],
  ["smartquotes", iVl],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", aVl]
];
function Mj() {
  this.ruler = new lVl();
  for (var e = 0; e < aR.length; e++)
    this.ruler.push(aR[e][0], aR[e][1]);
}
Mj.prototype.process = function(e) {
  var t, n, o;
  for (o = this.ruler.getRules(""), t = 0, n = o.length; t < n; t++)
    o[t](e);
};
Mj.prototype.State = cVl;
var uVl = Mj, sR = ri.isSpace;
function cR(e, t) {
  var n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  return e.src.slice(n, o);
}
function SZ(e) {
  var t = [], n = 0, o = e.length, r, i = !1, a = 0, s = "";
  for (r = e.charCodeAt(n); n < o; )
    r === 124 && (i ? (s += e.substring(a, n - 1), a = n) : (t.push(s + e.substring(a, n)), s = "", a = n + 1)), i = r === 92, n++, r = e.charCodeAt(n);
  return t.push(s + e.substring(a)), t;
}
var dVl = function(t, n, o, r) {
  var i, a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w, N;
  if (n + 2 > o || (u = n + 1, t.sCount[u] < t.blkIndent) || t.sCount[u] - t.blkIndent >= 4 || (s = t.bMarks[u] + t.tShift[u], s >= t.eMarks[u]) || (w = t.src.charCodeAt(s++), w !== 124 && w !== 45 && w !== 58) || s >= t.eMarks[u] || (N = t.src.charCodeAt(s++), N !== 124 && N !== 45 && N !== 58 && !sR(N)) || w === 45 && sR(N))
    return !1;
  for (; s < t.eMarks[u]; ) {
    if (i = t.src.charCodeAt(s), i !== 124 && i !== 45 && i !== 58 && !sR(i))
      return !1;
    s++;
  }
  for (a = cR(t, n + 1), d = a.split("|"), g = [], c = 0; c < d.length; c++) {
    if (f = d[c].trim(), !f) {
      if (c === 0 || c === d.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(f))
      return !1;
    f.charCodeAt(f.length - 1) === 58 ? g.push(f.charCodeAt(0) === 58 ? "center" : "right") : f.charCodeAt(0) === 58 ? g.push("left") : g.push("");
  }
  if (a = cR(t, n).trim(), a.indexOf("|") === -1 || t.sCount[n] - t.blkIndent >= 4 || (d = SZ(a), d.length && d[0] === "" && d.shift(), d.length && d[d.length - 1] === "" && d.pop(), _ = d.length, _ === 0 || _ !== g.length))
    return !1;
  if (r)
    return !0;
  for (v = t.parentType, t.parentType = "table", y = t.md.block.ruler.getRules("blockquote"), p = t.push("table_open", "table", 1), p.map = h = [n, 0], p = t.push("thead_open", "thead", 1), p.map = [n, n + 1], p = t.push("tr_open", "tr", 1), p.map = [n, n + 1], c = 0; c < d.length; c++)
    p = t.push("th_open", "th", 1), g[c] && (p.attrs = [["style", "text-align:" + g[c]]]), p = t.push("inline", "", 0), p.content = d[c].trim(), p.children = [], p = t.push("th_close", "th", -1);
  for (p = t.push("tr_close", "tr", -1), p = t.push("thead_close", "thead", -1), u = n + 2; u < o && !(t.sCount[u] < t.blkIndent); u++) {
    for (b = !1, c = 0, l = y.length; c < l; c++)
      if (y[c](t, u, o, !0)) {
        b = !0;
        break;
      }
    if (b || (a = cR(t, u).trim(), !a) || t.sCount[u] - t.blkIndent >= 4)
      break;
    for (d = SZ(a), d.length && d[0] === "" && d.shift(), d.length && d[d.length - 1] === "" && d.pop(), u === n + 2 && (p = t.push("tbody_open", "tbody", 1), p.map = $ = [n + 2, 0]), p = t.push("tr_open", "tr", 1), p.map = [u, u + 1], c = 0; c < _; c++)
      p = t.push("td_open", "td", 1), g[c] && (p.attrs = [["style", "text-align:" + g[c]]]), p = t.push("inline", "", 0), p.content = d[c] ? d[c].trim() : "", p.children = [], p = t.push("td_close", "td", -1);
    p = t.push("tr_close", "tr", -1);
  }
  return $ && (p = t.push("tbody_close", "tbody", -1), $[1] = u), p = t.push("table_close", "table", -1), h[1] = u, t.parentType = v, t.line = u, !0;
}, _Vl = function(t, n, o) {
  var r, i, a;
  if (t.sCount[n] - t.blkIndent < 4)
    return !1;
  for (i = r = n + 1; r < o; ) {
    if (t.isEmpty(r)) {
      r++;
      continue;
    }
    if (t.sCount[r] - t.blkIndent >= 4) {
      r++, i = r;
      continue;
    }
    break;
  }
  return t.line = i, a = t.push("code_block", "code", 0), a.content = t.getLines(n, i, 4 + t.blkIndent, !1) + `
`, a.map = [n, t.line], !0;
}, pVl = function(t, n, o, r) {
  var i, a, s, c, l, u, d, _ = !1, p = t.bMarks[n] + t.tShift[n], g = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || p + 3 > g || (i = t.src.charCodeAt(p), i !== 126 && i !== 96) || (l = p, p = t.skipChars(p, i), a = p - l, a < 3) || (d = t.src.slice(l, p), s = t.src.slice(p, g), i === 96 && s.indexOf(String.fromCharCode(i)) >= 0))
    return !1;
  if (r)
    return !0;
  for (c = n; c++, !(c >= o || (p = l = t.bMarks[c] + t.tShift[c], g = t.eMarks[c], p < g && t.sCount[c] < t.blkIndent)); )
    if (t.src.charCodeAt(p) === i && !(t.sCount[c] - t.blkIndent >= 4) && (p = t.skipChars(p, i), !(p - l < a) && (p = t.skipSpaces(p), !(p < g)))) {
      _ = !0;
      break;
    }
  return a = t.sCount[n], t.line = c + (_ ? 1 : 0), u = t.push("fence", "code", 0), u.info = s, u.content = t.getLines(n + 1, c, a, !0), u.markup = d, u.map = [n, t.line], !0;
}, EZ = ri.isSpace, mVl = function(t, n, o, r) {
  var i, a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w, N, M, q, L = t.lineMax, R = t.bMarks[n] + t.tShift[n], T = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || t.src.charCodeAt(R++) !== 62)
    return !1;
  if (r)
    return !0;
  for (c = p = t.sCount[n] + 1, t.src.charCodeAt(R) === 32 ? (R++, c++, p++, i = !1, y = !0) : t.src.charCodeAt(R) === 9 ? (y = !0, (t.bsCount[n] + p) % 4 === 3 ? (R++, c++, p++, i = !1) : i = !0) : y = !1, g = [t.bMarks[n]], t.bMarks[n] = R; R < T && (a = t.src.charCodeAt(R), EZ(a)); ) {
    a === 9 ? p += 4 - (p + t.bsCount[n] + (i ? 1 : 0)) % 4 : p++;
    R++;
  }
  for (f = [t.bsCount[n]], t.bsCount[n] = t.sCount[n] + 1 + (y ? 1 : 0), u = R >= T, v = [t.sCount[n]], t.sCount[n] = p - c, b = [t.tShift[n]], t.tShift[n] = R - t.bMarks[n], N = t.md.block.ruler.getRules("blockquote"), $ = t.parentType, t.parentType = "blockquote", _ = n + 1; _ < o && (q = t.sCount[_] < t.blkIndent, R = t.bMarks[_] + t.tShift[_], T = t.eMarks[_], !(R >= T)); _++) {
    if (t.src.charCodeAt(R++) === 62 && !q) {
      for (c = p = t.sCount[_] + 1, t.src.charCodeAt(R) === 32 ? (R++, c++, p++, i = !1, y = !0) : t.src.charCodeAt(R) === 9 ? (y = !0, (t.bsCount[_] + p) % 4 === 3 ? (R++, c++, p++, i = !1) : i = !0) : y = !1, g.push(t.bMarks[_]), t.bMarks[_] = R; R < T && (a = t.src.charCodeAt(R), EZ(a)); ) {
        a === 9 ? p += 4 - (p + t.bsCount[_] + (i ? 1 : 0)) % 4 : p++;
        R++;
      }
      u = R >= T, f.push(t.bsCount[_]), t.bsCount[_] = t.sCount[_] + 1 + (y ? 1 : 0), v.push(t.sCount[_]), t.sCount[_] = p - c, b.push(t.tShift[_]), t.tShift[_] = R - t.bMarks[_];
      continue;
    }
    if (u)
      break;
    for (w = !1, s = 0, l = N.length; s < l; s++)
      if (N[s](t, _, o, !0)) {
        w = !0;
        break;
      }
    if (w) {
      t.lineMax = _, t.blkIndent !== 0 && (g.push(t.bMarks[_]), f.push(t.bsCount[_]), b.push(t.tShift[_]), v.push(t.sCount[_]), t.sCount[_] -= t.blkIndent);
      break;
    }
    g.push(t.bMarks[_]), f.push(t.bsCount[_]), b.push(t.tShift[_]), v.push(t.sCount[_]), t.sCount[_] = -1;
  }
  for (h = t.blkIndent, t.blkIndent = 0, M = t.push("blockquote_open", "blockquote", 1), M.markup = ">", M.map = d = [n, 0], t.md.block.tokenize(t, n, _), M = t.push("blockquote_close", "blockquote", -1), M.markup = ">", t.lineMax = L, t.parentType = $, d[1] = t.line, s = 0; s < b.length; s++)
    t.bMarks[s + n] = g[s], t.tShift[s + n] = b[s], t.sCount[s + n] = v[s], t.bsCount[s + n] = f[s];
  return t.blkIndent = h, !0;
}, fVl = ri.isSpace, gVl = function(t, n, o, r) {
  var i, a, s, c, l = t.bMarks[n] + t.tShift[n], u = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || (i = t.src.charCodeAt(l++), i !== 42 && i !== 45 && i !== 95))
    return !1;
  for (a = 1; l < u; ) {
    if (s = t.src.charCodeAt(l++), s !== i && !fVl(s))
      return !1;
    s === i && a++;
  }
  return a < 3 ? !1 : (r || (t.line = n + 1, c = t.push("hr", "hr", 0), c.map = [n, t.line], c.markup = Array(a + 1).join(String.fromCharCode(i))), !0);
}, Bhe = ri.isSpace;
function xZ(e, t) {
  var n, o, r, i;
  return o = e.bMarks[t] + e.tShift[t], r = e.eMarks[t], n = e.src.charCodeAt(o++), n !== 42 && n !== 45 && n !== 43 || o < r && (i = e.src.charCodeAt(o), !Bhe(i)) ? -1 : o;
}
function CZ(e, t) {
  var n, o = e.bMarks[t] + e.tShift[t], r = o, i = e.eMarks[t];
  if (r + 1 >= i || (n = e.src.charCodeAt(r++), n < 48 || n > 57))
    return -1;
  for (; ; ) {
    if (r >= i)
      return -1;
    if (n = e.src.charCodeAt(r++), n >= 48 && n <= 57) {
      if (r - o >= 10)
        return -1;
      continue;
    }
    if (n === 41 || n === 46)
      break;
    return -1;
  }
  return r < i && (n = e.src.charCodeAt(r), !Bhe(n)) ? -1 : r;
}
function hVl(e, t) {
  var n, o, r = e.level + 2;
  for (n = t + 2, o = e.tokens.length - 2; n < o; n++)
    e.tokens[n].level === r && e.tokens[n].type === "paragraph_open" && (e.tokens[n + 2].hidden = !0, e.tokens[n].hidden = !0, n += 2);
}
var vVl = function(t, n, o, r) {
  var i, a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w, N, M, q, L, R, T, D, A, S, E, x, k = !1, I = !0;
  if (t.sCount[n] - t.blkIndent >= 4 || t.listIndent >= 0 && t.sCount[n] - t.listIndent >= 4 && t.sCount[n] < t.blkIndent)
    return !1;
  if (r && t.parentType === "paragraph" && t.sCount[n] >= t.blkIndent && (k = !0), (T = CZ(t, n)) >= 0) {
    if (d = !0, A = t.bMarks[n] + t.tShift[n], $ = Number(t.src.slice(A, T - 1)), k && $ !== 1)
      return !1;
  } else if ((T = xZ(t, n)) >= 0)
    d = !1;
  else
    return !1;
  if (k && t.skipSpaces(T) >= t.eMarks[n])
    return !1;
  if (h = t.src.charCodeAt(T - 1), r)
    return !0;
  for (f = t.tokens.length, d ? (x = t.push("ordered_list_open", "ol", 1), $ !== 1 && (x.attrs = [["start", $]])) : x = t.push("bullet_list_open", "ul", 1), x.map = g = [n, 0], x.markup = String.fromCharCode(h), b = n, D = !1, E = t.md.block.ruler.getRules("list"), N = t.parentType, t.parentType = "list"; b < o; ) {
    for (R = T, v = t.eMarks[b], u = y = t.sCount[b] + T - (t.bMarks[n] + t.tShift[n]); R < v; ) {
      if (i = t.src.charCodeAt(R), i === 9)
        y += 4 - (y + t.bsCount[b]) % 4;
      else if (i === 32)
        y++;
      else
        break;
      R++;
    }
    if (a = R, a >= v ? l = 1 : l = y - u, l > 4 && (l = 1), c = u + l, x = t.push("list_item_open", "li", 1), x.markup = String.fromCharCode(h), x.map = _ = [n, 0], d && (x.info = t.src.slice(A, T - 1)), L = t.tight, q = t.tShift[n], M = t.sCount[n], w = t.listIndent, t.listIndent = t.blkIndent, t.blkIndent = c, t.tight = !0, t.tShift[n] = a - t.bMarks[n], t.sCount[n] = y, a >= v && t.isEmpty(n + 1) ? t.line = Math.min(t.line + 2, o) : t.md.block.tokenize(t, n, o, !0), (!t.tight || D) && (I = !1), D = t.line - n > 1 && t.isEmpty(t.line - 1), t.blkIndent = t.listIndent, t.listIndent = w, t.tShift[n] = q, t.sCount[n] = M, t.tight = L, x = t.push("list_item_close", "li", -1), x.markup = String.fromCharCode(h), b = n = t.line, _[1] = b, a = t.bMarks[n], b >= o || t.sCount[b] < t.blkIndent || t.sCount[n] - t.blkIndent >= 4)
      break;
    for (S = !1, s = 0, p = E.length; s < p; s++)
      if (E[s](t, b, o, !0)) {
        S = !0;
        break;
      }
    if (S)
      break;
    if (d) {
      if (T = CZ(t, b), T < 0)
        break;
      A = t.bMarks[b] + t.tShift[b];
    } else if (T = xZ(t, b), T < 0)
      break;
    if (h !== t.src.charCodeAt(T - 1))
      break;
  }
  return d ? x = t.push("ordered_list_close", "ol", -1) : x = t.push("bullet_list_close", "ul", -1), x.markup = String.fromCharCode(h), g[1] = b, t.line = b, t.parentType = N, I && hVl(t, f), !0;
}, bVl = ri.normalizeReference, sE = ri.isSpace, yVl = function(t, n, o, r) {
  var i, a, s, c, l, u, d, _, p, g, f, h, $, v, b, y, w = 0, N = t.bMarks[n] + t.tShift[n], M = t.eMarks[n], q = n + 1;
  if (t.sCount[n] - t.blkIndent >= 4 || t.src.charCodeAt(N) !== 91)
    return !1;
  for (; ++N < M; )
    if (t.src.charCodeAt(N) === 93 && t.src.charCodeAt(N - 1) !== 92) {
      if (N + 1 === M || t.src.charCodeAt(N + 1) !== 58)
        return !1;
      break;
    }
  for (c = t.lineMax, b = t.md.block.ruler.getRules("reference"), g = t.parentType, t.parentType = "reference"; q < c && !t.isEmpty(q); q++)
    if (!(t.sCount[q] - t.blkIndent > 3) && !(t.sCount[q] < 0)) {
      for (v = !1, u = 0, d = b.length; u < d; u++)
        if (b[u](t, q, c, !0)) {
          v = !0;
          break;
        }
      if (v)
        break;
    }
  for ($ = t.getLines(n, q, t.blkIndent, !1).trim(), M = $.length, N = 1; N < M; N++) {
    if (i = $.charCodeAt(N), i === 91)
      return !1;
    if (i === 93) {
      p = N;
      break;
    } else
      i === 10 ? w++ : i === 92 && (N++, N < M && $.charCodeAt(N) === 10 && w++);
  }
  if (p < 0 || $.charCodeAt(p + 1) !== 58)
    return !1;
  for (N = p + 2; N < M; N++)
    if (i = $.charCodeAt(N), i === 10)
      w++;
    else if (!sE(i))
      break;
  if (f = t.md.helpers.parseLinkDestination($, N, M), !f.ok || (l = t.md.normalizeLink(f.str), !t.md.validateLink(l)))
    return !1;
  for (N = f.pos, w += f.lines, a = N, s = w, h = N; N < M; N++)
    if (i = $.charCodeAt(N), i === 10)
      w++;
    else if (!sE(i))
      break;
  for (f = t.md.helpers.parseLinkTitle($, N, M), N < M && h !== N && f.ok ? (y = f.str, N = f.pos, w += f.lines) : (y = "", N = a, w = s); N < M && (i = $.charCodeAt(N), !!sE(i)); )
    N++;
  if (N < M && $.charCodeAt(N) !== 10 && y)
    for (y = "", N = a, w = s; N < M && (i = $.charCodeAt(N), !!sE(i)); )
      N++;
  return N < M && $.charCodeAt(N) !== 10 || (_ = bVl($.slice(1, p)), !_) ? !1 : (r || (typeof t.env.references > "u" && (t.env.references = {}), typeof t.env.references[_] > "u" && (t.env.references[_] = { title: y, href: l }), t.parentType = g, t.line = n + w + 1), !0);
}, $Vl = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "source",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], KA = {}, wVl = "[a-zA-Z_:][a-zA-Z0-9:._-]*", kVl = "[^\"'=<>`\\x00-\\x20]+", SVl = "'[^']*'", EVl = '"[^"]*"', xVl = "(?:" + kVl + "|" + SVl + "|" + EVl + ")", CVl = "(?:\\s+" + wVl + "(?:\\s*=\\s*" + xVl + ")?)", Uhe = "<[A-Za-z][A-Za-z0-9\\-]*" + CVl + "*\\s*\\/?>", Ghe = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", TVl = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", AVl = "<[?][\\s\\S]*?[?]>", IVl = "<![A-Z]+\\s+[^>]*>", OVl = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", NVl = new RegExp("^(?:" + Uhe + "|" + Ghe + "|" + TVl + "|" + AVl + "|" + IVl + "|" + OVl + ")"), zVl = new RegExp("^(?:" + Uhe + "|" + Ghe + ")");
KA.HTML_TAG_RE = NVl;
KA.HTML_OPEN_CLOSE_TAG_RE = zVl;
var RVl = $Vl, PVl = KA.HTML_OPEN_CLOSE_TAG_RE, fb = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + RVl.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(PVl.source + "\\s*$"), /^$/, !1]
], DVl = function(t, n, o, r) {
  var i, a, s, c, l = t.bMarks[n] + t.tShift[n], u = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || !t.md.options.html || t.src.charCodeAt(l) !== 60)
    return !1;
  for (c = t.src.slice(l, u), i = 0; i < fb.length && !fb[i][0].test(c); i++)
    ;
  if (i === fb.length)
    return !1;
  if (r)
    return fb[i][2];
  if (a = n + 1, !fb[i][1].test(c)) {
    for (; a < o && !(t.sCount[a] < t.blkIndent); a++)
      if (l = t.bMarks[a] + t.tShift[a], u = t.eMarks[a], c = t.src.slice(l, u), fb[i][1].test(c)) {
        c.length !== 0 && a++;
        break;
      }
  }
  return t.line = a, s = t.push("html_block", "", 0), s.map = [n, a], s.content = t.getLines(n, a, t.blkIndent, !0), !0;
}, TZ = ri.isSpace, LVl = function(t, n, o, r) {
  var i, a, s, c, l = t.bMarks[n] + t.tShift[n], u = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || (i = t.src.charCodeAt(l), i !== 35 || l >= u))
    return !1;
  for (a = 1, i = t.src.charCodeAt(++l); i === 35 && l < u && a <= 6; )
    a++, i = t.src.charCodeAt(++l);
  return a > 6 || l < u && !TZ(i) ? !1 : (r || (u = t.skipSpacesBack(u, l), s = t.skipCharsBack(u, 35, l), s > l && TZ(t.src.charCodeAt(s - 1)) && (u = s), t.line = n + 1, c = t.push("heading_open", "h" + String(a), 1), c.markup = "########".slice(0, a), c.map = [n, t.line], c = t.push("inline", "", 0), c.content = t.src.slice(l, u).trim(), c.map = [n, t.line], c.children = [], c = t.push("heading_close", "h" + String(a), -1), c.markup = "########".slice(0, a)), !0);
}, MVl = function(t, n, o) {
  var r, i, a, s, c, l, u, d, _, p = n + 1, g, f = t.md.block.ruler.getRules("paragraph");
  if (t.sCount[n] - t.blkIndent >= 4)
    return !1;
  for (g = t.parentType, t.parentType = "paragraph"; p < o && !t.isEmpty(p); p++)
    if (!(t.sCount[p] - t.blkIndent > 3)) {
      if (t.sCount[p] >= t.blkIndent && (l = t.bMarks[p] + t.tShift[p], u = t.eMarks[p], l < u && (_ = t.src.charCodeAt(l), (_ === 45 || _ === 61) && (l = t.skipChars(l, _), l = t.skipSpaces(l), l >= u)))) {
        d = _ === 61 ? 1 : 2;
        break;
      }
      if (!(t.sCount[p] < 0)) {
        for (i = !1, a = 0, s = f.length; a < s; a++)
          if (f[a](t, p, o, !0)) {
            i = !0;
            break;
          }
        if (i)
          break;
      }
    }
  return d ? (r = t.getLines(n, p, t.blkIndent, !1).trim(), t.line = p + 1, c = t.push("heading_open", "h" + String(d), 1), c.markup = String.fromCharCode(_), c.map = [n, t.line], c = t.push("inline", "", 0), c.content = r, c.map = [n, t.line - 1], c.children = [], c = t.push("heading_close", "h" + String(d), -1), c.markup = String.fromCharCode(_), t.parentType = g, !0) : !1;
}, FVl = function(t, n) {
  var o, r, i, a, s, c, l = n + 1, u = t.md.block.ruler.getRules("paragraph"), d = t.lineMax;
  for (c = t.parentType, t.parentType = "paragraph"; l < d && !t.isEmpty(l); l++)
    if (!(t.sCount[l] - t.blkIndent > 3) && !(t.sCount[l] < 0)) {
      for (r = !1, i = 0, a = u.length; i < a; i++)
        if (u[i](t, l, d, !0)) {
          r = !0;
          break;
        }
      if (r)
        break;
    }
  return o = t.getLines(n, l, t.blkIndent, !1).trim(), t.line = l, s = t.push("paragraph_open", "p", 1), s.map = [n, t.line], s = t.push("inline", "", 0), s.content = o, s.map = [n, t.line], s.children = [], s = t.push("paragraph_close", "p", -1), t.parentType = c, !0;
}, Whe = Lj, ZA = ri.isSpace;
function rm(e, t, n, o) {
  var r, i, a, s, c, l, u, d;
  for (this.src = e, this.md = t, this.env = n, this.tokens = o, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", i = this.src, d = !1, a = s = l = u = 0, c = i.length; s < c; s++) {
    if (r = i.charCodeAt(s), !d)
      if (ZA(r)) {
        l++, r === 9 ? u += 4 - u % 4 : u++;
        continue;
      } else
        d = !0;
    (r === 10 || s === c - 1) && (r !== 10 && s++, this.bMarks.push(a), this.eMarks.push(s), this.tShift.push(l), this.sCount.push(u), this.bsCount.push(0), d = !1, l = 0, u = 0, a = s + 1);
  }
  this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
rm.prototype.push = function(e, t, n) {
  var o = new Whe(e, t, n);
  return o.block = !0, n < 0 && this.level--, o.level = this.level, n > 0 && this.level++, this.tokens.push(o), o;
};
rm.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
rm.prototype.skipEmptyLines = function(t) {
  for (var n = this.lineMax; t < n && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
rm.prototype.skipSpaces = function(t) {
  for (var n, o = this.src.length; t < o && (n = this.src.charCodeAt(t), !!ZA(n)); t++)
    ;
  return t;
};
rm.prototype.skipSpacesBack = function(t, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (!ZA(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
rm.prototype.skipChars = function(t, n) {
  for (var o = this.src.length; t < o && this.src.charCodeAt(t) === n; t++)
    ;
  return t;
};
rm.prototype.skipCharsBack = function(t, n, o) {
  if (t <= o)
    return t;
  for (; t > o; )
    if (n !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
rm.prototype.getLines = function(t, n, o, r) {
  var i, a, s, c, l, u, d, _ = t;
  if (t >= n)
    return "";
  for (u = new Array(n - t), i = 0; _ < n; _++, i++) {
    for (a = 0, d = c = this.bMarks[_], _ + 1 < n || r ? l = this.eMarks[_] + 1 : l = this.eMarks[_]; c < l && a < o; ) {
      if (s = this.src.charCodeAt(c), ZA(s))
        s === 9 ? a += 4 - (a + this.bsCount[_]) % 4 : a++;
      else if (c - d < this.tShift[_])
        a++;
      else
        break;
      c++;
    }
    a > o ? u[i] = new Array(a - o + 1).join(" ") + this.src.slice(c, l) : u[i] = this.src.slice(c, l);
  }
  return u.join("");
};
rm.prototype.Token = Whe;
var qVl = rm, jVl = Dj, cE = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", dVl, ["paragraph", "reference"]],
  ["code", _Vl],
  ["fence", pVl, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", mVl, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", gVl, ["paragraph", "reference", "blockquote", "list"]],
  ["list", vVl, ["paragraph", "reference", "blockquote"]],
  ["reference", yVl],
  ["html_block", DVl, ["paragraph", "reference", "blockquote"]],
  ["heading", LVl, ["paragraph", "reference", "blockquote"]],
  ["lheading", MVl],
  ["paragraph", FVl]
];
function XA() {
  this.ruler = new jVl();
  for (var e = 0; e < cE.length; e++)
    this.ruler.push(cE[e][0], cE[e][1], { alt: (cE[e][2] || []).slice() });
}
XA.prototype.tokenize = function(e, t, n) {
  for (var o, r, i = this.ruler.getRules(""), a = i.length, s = t, c = !1, l = e.md.options.maxNesting; s < n && (e.line = s = e.skipEmptyLines(s), !(s >= n || e.sCount[s] < e.blkIndent)); ) {
    if (e.level >= l) {
      e.line = n;
      break;
    }
    for (r = 0; r < a && (o = i[r](e, s, n, !1), !o); r++)
      ;
    e.tight = !c, e.isEmpty(e.line - 1) && (c = !0), s = e.line, s < n && e.isEmpty(s) && (c = !0, s++, e.line = s);
  }
};
XA.prototype.parse = function(e, t, n, o) {
  var r;
  e && (r = new this.State(e, t, n, o), this.tokenize(r, r.line, r.lineMax));
};
XA.prototype.State = qVl;
var VVl = XA;
function BVl(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
var UVl = function(t, n) {
  for (var o = t.pos; o < t.posMax && !BVl(t.src.charCodeAt(o)); )
    o++;
  return o === t.pos ? !1 : (n || (t.pending += t.src.slice(t.pos, o)), t.pos = o, !0);
}, GVl = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i, WVl = function(t, n) {
  var o, r, i, a, s, c, l, u;
  return !t.md.options.linkify || t.linkLevel > 0 || (o = t.pos, r = t.posMax, o + 3 > r) || t.src.charCodeAt(o) !== 58 || t.src.charCodeAt(o + 1) !== 47 || t.src.charCodeAt(o + 2) !== 47 || (i = t.pending.match(GVl), !i) || (a = i[1], s = t.md.linkify.matchAtStart(t.src.slice(o - a.length)), !s) || (c = s.url, c = c.replace(/\*+$/, ""), l = t.md.normalizeLink(c), !t.md.validateLink(l)) ? !1 : (n || (t.pending = t.pending.slice(0, -a.length), u = t.push("link_open", "a", 1), u.attrs = [["href", l]], u.markup = "linkify", u.info = "auto", u = t.push("text", "", 0), u.content = t.md.normalizeLinkText(c), u = t.push("link_close", "a", -1), u.markup = "linkify", u.info = "auto"), t.pos += c.length - a.length, !0);
}, HVl = ri.isSpace, YVl = function(t, n) {
  var o, r, i, a = t.pos;
  if (t.src.charCodeAt(a) !== 10)
    return !1;
  if (o = t.pending.length - 1, r = t.posMax, !n)
    if (o >= 0 && t.pending.charCodeAt(o) === 32)
      if (o >= 1 && t.pending.charCodeAt(o - 1) === 32) {
        for (i = o - 1; i >= 1 && t.pending.charCodeAt(i - 1) === 32; )
          i--;
        t.pending = t.pending.slice(0, i), t.push("hardbreak", "br", 0);
      } else
        t.pending = t.pending.slice(0, -1), t.push("softbreak", "br", 0);
    else
      t.push("softbreak", "br", 0);
  for (a++; a < r && HVl(t.src.charCodeAt(a)); )
    a++;
  return t.pos = a, !0;
}, KVl = ri.isSpace, Fj = [];
for (var AZ = 0; AZ < 256; AZ++)
  Fj.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  Fj[e.charCodeAt(0)] = 1;
});
var ZVl = function(t, n) {
  var o, r, i, a, s, c = t.pos, l = t.posMax;
  if (t.src.charCodeAt(c) !== 92 || (c++, c >= l))
    return !1;
  if (o = t.src.charCodeAt(c), o === 10) {
    for (n || t.push("hardbreak", "br", 0), c++; c < l && (o = t.src.charCodeAt(c), !!KVl(o)); )
      c++;
    return t.pos = c, !0;
  }
  return a = t.src[c], o >= 55296 && o <= 56319 && c + 1 < l && (r = t.src.charCodeAt(c + 1), r >= 56320 && r <= 57343 && (a += t.src[c + 1], c++)), i = "\\" + a, n || (s = t.push("text_special", "", 0), o < 256 && Fj[o] !== 0 ? s.content = a : s.content = i, s.markup = i, s.info = "escape"), t.pos = c + 1, !0;
}, XVl = function(t, n) {
  var o, r, i, a, s, c, l, u, d = t.pos, _ = t.src.charCodeAt(d);
  if (_ !== 96)
    return !1;
  for (o = d, d++, r = t.posMax; d < r && t.src.charCodeAt(d) === 96; )
    d++;
  if (i = t.src.slice(o, d), l = i.length, t.backticksScanned && (t.backticks[l] || 0) <= o)
    return n || (t.pending += i), t.pos += l, !0;
  for (s = c = d; (s = t.src.indexOf("`", c)) !== -1; ) {
    for (c = s + 1; c < r && t.src.charCodeAt(c) === 96; )
      c++;
    if (u = c - s, u === l)
      return n || (a = t.push("code_inline", "code", 0), a.markup = i, a.content = t.src.slice(d, s).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), t.pos = c, !0;
    t.backticks[u] = s;
  }
  return t.backticksScanned = !0, n || (t.pending += i), t.pos += l, !0;
}, JA = {};
JA.tokenize = function(t, n) {
  var o, r, i, a, s, c = t.pos, l = t.src.charCodeAt(c);
  if (n || l !== 126 || (r = t.scanDelims(t.pos, !0), a = r.length, s = String.fromCharCode(l), a < 2))
    return !1;
  for (a % 2 && (i = t.push("text", "", 0), i.content = s, a--), o = 0; o < a; o += 2)
    i = t.push("text", "", 0), i.content = s + s, t.delimiters.push({
      marker: l,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: t.tokens.length - 1,
      end: -1,
      open: r.can_open,
      close: r.can_close
    });
  return t.pos += r.length, !0;
};
function IZ(e, t) {
  var n, o, r, i, a, s = [], c = t.length;
  for (n = 0; n < c; n++)
    r = t[n], r.marker === 126 && r.end !== -1 && (i = t[r.end], a = e.tokens[r.token], a.type = "s_open", a.tag = "s", a.nesting = 1, a.markup = "~~", a.content = "", a = e.tokens[i.token], a.type = "s_close", a.tag = "s", a.nesting = -1, a.markup = "~~", a.content = "", e.tokens[i.token - 1].type === "text" && e.tokens[i.token - 1].content === "~" && s.push(i.token - 1));
  for (; s.length; ) {
    for (n = s.pop(), o = n + 1; o < e.tokens.length && e.tokens[o].type === "s_close"; )
      o++;
    o--, n !== o && (a = e.tokens[o], e.tokens[o] = e.tokens[n], e.tokens[n] = a);
  }
}
JA.postProcess = function(t) {
  var n, o = t.tokens_meta, r = t.tokens_meta.length;
  for (IZ(t, t.delimiters), n = 0; n < r; n++)
    o[n] && o[n].delimiters && IZ(t, o[n].delimiters);
};
var QA = {};
QA.tokenize = function(t, n) {
  var o, r, i, a = t.pos, s = t.src.charCodeAt(a);
  if (n || s !== 95 && s !== 42)
    return !1;
  for (r = t.scanDelims(t.pos, s === 42), o = 0; o < r.length; o++)
    i = t.push("text", "", 0), i.content = String.fromCharCode(s), t.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: s,
      // Total length of these series of delimiters.
      //
      length: r.length,
      // A position of the token this delimiter corresponds to.
      //
      token: t.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: r.can_open,
      close: r.can_close
    });
  return t.pos += r.length, !0;
};
function OZ(e, t) {
  var n, o, r, i, a, s, c = t.length;
  for (n = c - 1; n >= 0; n--)
    o = t[n], !(o.marker !== 95 && o.marker !== 42) && o.end !== -1 && (r = t[o.end], s = n > 0 && t[n - 1].end === o.end + 1 && // check that first two markers match and adjacent
    t[n - 1].marker === o.marker && t[n - 1].token === o.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[o.end + 1].token === r.token + 1, a = String.fromCharCode(o.marker), i = e.tokens[o.token], i.type = s ? "strong_open" : "em_open", i.tag = s ? "strong" : "em", i.nesting = 1, i.markup = s ? a + a : a, i.content = "", i = e.tokens[r.token], i.type = s ? "strong_close" : "em_close", i.tag = s ? "strong" : "em", i.nesting = -1, i.markup = s ? a + a : a, i.content = "", s && (e.tokens[t[n - 1].token].content = "", e.tokens[t[o.end + 1].token].content = "", n--));
}
QA.postProcess = function(t) {
  var n, o = t.tokens_meta, r = t.tokens_meta.length;
  for (OZ(t, t.delimiters), n = 0; n < r; n++)
    o[n] && o[n].delimiters && OZ(t, o[n].delimiters);
};
var JVl = ri.normalizeReference, lR = ri.isSpace, QVl = function(t, n) {
  var o, r, i, a, s, c, l, u, d, _ = "", p = "", g = t.pos, f = t.posMax, h = t.pos, $ = !0;
  if (t.src.charCodeAt(t.pos) !== 91 || (s = t.pos + 1, a = t.md.helpers.parseLinkLabel(t, t.pos, !0), a < 0))
    return !1;
  if (c = a + 1, c < f && t.src.charCodeAt(c) === 40) {
    for ($ = !1, c++; c < f && (r = t.src.charCodeAt(c), !(!lR(r) && r !== 10)); c++)
      ;
    if (c >= f)
      return !1;
    if (h = c, l = t.md.helpers.parseLinkDestination(t.src, c, t.posMax), l.ok) {
      for (_ = t.md.normalizeLink(l.str), t.md.validateLink(_) ? c = l.pos : _ = "", h = c; c < f && (r = t.src.charCodeAt(c), !(!lR(r) && r !== 10)); c++)
        ;
      if (l = t.md.helpers.parseLinkTitle(t.src, c, t.posMax), c < f && h !== c && l.ok)
        for (p = l.str, c = l.pos; c < f && (r = t.src.charCodeAt(c), !(!lR(r) && r !== 10)); c++)
          ;
    }
    (c >= f || t.src.charCodeAt(c) !== 41) && ($ = !0), c++;
  }
  if ($) {
    if (typeof t.env.references > "u")
      return !1;
    if (c < f && t.src.charCodeAt(c) === 91 ? (h = c + 1, c = t.md.helpers.parseLinkLabel(t, c), c >= 0 ? i = t.src.slice(h, c++) : c = a + 1) : c = a + 1, i || (i = t.src.slice(s, a)), u = t.env.references[JVl(i)], !u)
      return t.pos = g, !1;
    _ = u.href, p = u.title;
  }
  return n || (t.pos = s, t.posMax = a, d = t.push("link_open", "a", 1), d.attrs = o = [["href", _]], p && o.push(["title", p]), t.linkLevel++, t.md.inline.tokenize(t), t.linkLevel--, d = t.push("link_close", "a", -1)), t.pos = c, t.posMax = f, !0;
}, eBl = ri.normalizeReference, uR = ri.isSpace, tBl = function(t, n) {
  var o, r, i, a, s, c, l, u, d, _, p, g, f, h = "", $ = t.pos, v = t.posMax;
  if (t.src.charCodeAt(t.pos) !== 33 || t.src.charCodeAt(t.pos + 1) !== 91 || (c = t.pos + 2, s = t.md.helpers.parseLinkLabel(t, t.pos + 1, !1), s < 0))
    return !1;
  if (l = s + 1, l < v && t.src.charCodeAt(l) === 40) {
    for (l++; l < v && (r = t.src.charCodeAt(l), !(!uR(r) && r !== 10)); l++)
      ;
    if (l >= v)
      return !1;
    for (f = l, d = t.md.helpers.parseLinkDestination(t.src, l, t.posMax), d.ok && (h = t.md.normalizeLink(d.str), t.md.validateLink(h) ? l = d.pos : h = ""), f = l; l < v && (r = t.src.charCodeAt(l), !(!uR(r) && r !== 10)); l++)
      ;
    if (d = t.md.helpers.parseLinkTitle(t.src, l, t.posMax), l < v && f !== l && d.ok)
      for (_ = d.str, l = d.pos; l < v && (r = t.src.charCodeAt(l), !(!uR(r) && r !== 10)); l++)
        ;
    else
      _ = "";
    if (l >= v || t.src.charCodeAt(l) !== 41)
      return t.pos = $, !1;
    l++;
  } else {
    if (typeof t.env.references > "u")
      return !1;
    if (l < v && t.src.charCodeAt(l) === 91 ? (f = l + 1, l = t.md.helpers.parseLinkLabel(t, l), l >= 0 ? a = t.src.slice(f, l++) : l = s + 1) : l = s + 1, a || (a = t.src.slice(c, s)), u = t.env.references[eBl(a)], !u)
      return t.pos = $, !1;
    h = u.href, _ = u.title;
  }
  return n || (i = t.src.slice(c, s), t.md.inline.parse(
    i,
    t.md,
    t.env,
    g = []
  ), p = t.push("image", "img", 0), p.attrs = o = [["src", h], ["alt", ""]], p.children = g, p.content = i, _ && o.push(["title", _])), t.pos = l, t.posMax = v, !0;
}, nBl = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, oBl = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/, rBl = function(t, n) {
  var o, r, i, a, s, c, l = t.pos;
  if (t.src.charCodeAt(l) !== 60)
    return !1;
  for (s = t.pos, c = t.posMax; ; ) {
    if (++l >= c || (a = t.src.charCodeAt(l), a === 60))
      return !1;
    if (a === 62)
      break;
  }
  return o = t.src.slice(s + 1, l), oBl.test(o) ? (r = t.md.normalizeLink(o), t.md.validateLink(r) ? (n || (i = t.push("link_open", "a", 1), i.attrs = [["href", r]], i.markup = "autolink", i.info = "auto", i = t.push("text", "", 0), i.content = t.md.normalizeLinkText(o), i = t.push("link_close", "a", -1), i.markup = "autolink", i.info = "auto"), t.pos += o.length + 2, !0) : !1) : nBl.test(o) ? (r = t.md.normalizeLink("mailto:" + o), t.md.validateLink(r) ? (n || (i = t.push("link_open", "a", 1), i.attrs = [["href", r]], i.markup = "autolink", i.info = "auto", i = t.push("text", "", 0), i.content = t.md.normalizeLinkText(o), i = t.push("link_close", "a", -1), i.markup = "autolink", i.info = "auto"), t.pos += o.length + 2, !0) : !1) : !1;
}, iBl = KA.HTML_TAG_RE;
function aBl(e) {
  return /^<a[>\s]/i.test(e);
}
function sBl(e) {
  return /^<\/a\s*>/i.test(e);
}
function cBl(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
var lBl = function(t, n) {
  var o, r, i, a, s = t.pos;
  return !t.md.options.html || (i = t.posMax, t.src.charCodeAt(s) !== 60 || s + 2 >= i) || (o = t.src.charCodeAt(s + 1), o !== 33 && o !== 63 && o !== 47 && !cBl(o)) || (r = t.src.slice(s).match(iBl), !r) ? !1 : (n || (a = t.push("html_inline", "", 0), a.content = t.src.slice(s, s + r[0].length), aBl(a.content) && t.linkLevel++, sBl(a.content) && t.linkLevel--), t.pos += r[0].length, !0);
}, NZ = Lhe, uBl = ri.has, dBl = ri.isValidEntityCode, zZ = ri.fromCodePoint, _Bl = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, pBl = /^&([a-z][a-z0-9]{1,31});/i, mBl = function(t, n) {
  var o, r, i, a, s = t.pos, c = t.posMax;
  if (t.src.charCodeAt(s) !== 38 || s + 1 >= c)
    return !1;
  if (o = t.src.charCodeAt(s + 1), o === 35) {
    if (i = t.src.slice(s).match(_Bl), i)
      return n || (r = i[1][0].toLowerCase() === "x" ? parseInt(i[1].slice(1), 16) : parseInt(i[1], 10), a = t.push("text_special", "", 0), a.content = dBl(r) ? zZ(r) : zZ(65533), a.markup = i[0], a.info = "entity"), t.pos += i[0].length, !0;
  } else if (i = t.src.slice(s).match(pBl), i && uBl(NZ, i[1]))
    return n || (a = t.push("text_special", "", 0), a.content = NZ[i[1]], a.markup = i[0], a.info = "entity"), t.pos += i[0].length, !0;
  return !1;
};
function RZ(e, t) {
  var n, o, r, i, a, s, c, l, u = {}, d = t.length;
  if (d) {
    var _ = 0, p = -2, g = [];
    for (n = 0; n < d; n++)
      if (r = t[n], g.push(0), (t[_].marker !== r.marker || p !== r.token - 1) && (_ = n), p = r.token, r.length = r.length || 0, !!r.close) {
        for (u.hasOwnProperty(r.marker) || (u[r.marker] = [-1, -1, -1, -1, -1, -1]), a = u[r.marker][(r.open ? 3 : 0) + r.length % 3], o = _ - g[_] - 1, s = o; o > a; o -= g[o] + 1)
          if (i = t[o], i.marker === r.marker && i.open && i.end < 0 && (c = !1, (i.close || r.open) && (i.length + r.length) % 3 === 0 && (i.length % 3 !== 0 || r.length % 3 !== 0) && (c = !0), !c)) {
            l = o > 0 && !t[o - 1].open ? g[o - 1] + 1 : 0, g[n] = n - o + l, g[o] = l, r.open = !1, i.end = n, i.close = !1, s = -1, p = -2;
            break;
          }
        s !== -1 && (u[r.marker][(r.open ? 3 : 0) + (r.length || 0) % 3] = s);
      }
  }
}
var fBl = function(t) {
  var n, o = t.tokens_meta, r = t.tokens_meta.length;
  for (RZ(t, t.delimiters), n = 0; n < r; n++)
    o[n] && o[n].delimiters && RZ(t, o[n].delimiters);
}, gBl = function(t) {
  var n, o, r = 0, i = t.tokens, a = t.tokens.length;
  for (n = o = 0; n < a; n++)
    i[n].nesting < 0 && r--, i[n].level = r, i[n].nesting > 0 && r++, i[n].type === "text" && n + 1 < a && i[n + 1].type === "text" ? i[n + 1].content = i[n].content + i[n + 1].content : (n !== o && (i[o] = i[n]), o++);
  n !== o && (i.length = o);
}, qj = Lj, PZ = ri.isWhiteSpace, DZ = ri.isPunctChar, LZ = ri.isMdAsciiPunct;
function s1(e, t, n, o) {
  this.src = e, this.env = n, this.md = t, this.tokens = o, this.tokens_meta = Array(o.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
s1.prototype.pushPending = function() {
  var e = new qj("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
s1.prototype.push = function(e, t, n) {
  this.pending && this.pushPending();
  var o = new qj(e, t, n), r = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), o.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], r = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(o), this.tokens_meta.push(r), o;
};
s1.prototype.scanDelims = function(e, t) {
  var n = e, o, r, i, a, s, c, l, u, d, _ = !0, p = !0, g = this.posMax, f = this.src.charCodeAt(e);
  for (o = e > 0 ? this.src.charCodeAt(e - 1) : 32; n < g && this.src.charCodeAt(n) === f; )
    n++;
  return i = n - e, r = n < g ? this.src.charCodeAt(n) : 32, l = LZ(o) || DZ(String.fromCharCode(o)), d = LZ(r) || DZ(String.fromCharCode(r)), c = PZ(o), u = PZ(r), u ? _ = !1 : d && (c || l || (_ = !1)), c ? p = !1 : l && (u || d || (p = !1)), t ? (a = _, s = p) : (a = _ && (!p || l), s = p && (!_ || d)), {
    can_open: a,
    can_close: s,
    length: i
  };
};
s1.prototype.Token = qj;
var hBl = s1, MZ = Dj, dR = [
  ["text", UVl],
  ["linkify", WVl],
  ["newline", YVl],
  ["escape", ZVl],
  ["backticks", XVl],
  ["strikethrough", JA.tokenize],
  ["emphasis", QA.tokenize],
  ["link", QVl],
  ["image", tBl],
  ["autolink", rBl],
  ["html_inline", lBl],
  ["entity", mBl]
], _R = [
  ["balance_pairs", fBl],
  ["strikethrough", JA.postProcess],
  ["emphasis", QA.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", gBl]
];
function c1() {
  var e;
  for (this.ruler = new MZ(), e = 0; e < dR.length; e++)
    this.ruler.push(dR[e][0], dR[e][1]);
  for (this.ruler2 = new MZ(), e = 0; e < _R.length; e++)
    this.ruler2.push(_R[e][0], _R[e][1]);
}
c1.prototype.skipToken = function(e) {
  var t, n, o = e.pos, r = this.ruler.getRules(""), i = r.length, a = e.md.options.maxNesting, s = e.cache;
  if (typeof s[o] < "u") {
    e.pos = s[o];
    return;
  }
  if (e.level < a)
    for (n = 0; n < i && (e.level++, t = r[n](e, !0), e.level--, !t); n++)
      ;
  else
    e.pos = e.posMax;
  t || e.pos++, s[o] = e.pos;
};
c1.prototype.tokenize = function(e) {
  for (var t, n, o = this.ruler.getRules(""), r = o.length, i = e.posMax, a = e.md.options.maxNesting; e.pos < i; ) {
    if (e.level < a)
      for (n = 0; n < r && (t = o[n](e, !1), !t); n++)
        ;
    if (t) {
      if (e.pos >= i)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
c1.prototype.parse = function(e, t, n, o) {
  var r, i, a, s = new this.State(e, t, n, o);
  for (this.tokenize(s), i = this.ruler2.getRules(""), a = i.length, r = 0; r < a; r++)
    i[r](s);
};
c1.prototype.State = hBl;
var vBl = c1, pR, FZ;
function bBl() {
  return FZ || (FZ = 1, pR = function(e) {
    var t = {};
    e = e || {}, t.src_Any = Mhe().source, t.src_Cc = Fhe().source, t.src_Z = qhe().source, t.src_P = Pj.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
    var n = "[><｜]";
    return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
  }), pR;
}
function W5(e) {
  var t = Array.prototype.slice.call(arguments, 1);
  return t.forEach(function(n) {
    n && Object.keys(n).forEach(function(o) {
      e[o] = n[o];
    });
  }), e;
}
function e2(e) {
  return Object.prototype.toString.call(e);
}
function yBl(e) {
  return e2(e) === "[object String]";
}
function $Bl(e) {
  return e2(e) === "[object Object]";
}
function wBl(e) {
  return e2(e) === "[object RegExp]";
}
function qZ(e) {
  return e2(e) === "[object Function]";
}
function kBl(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
var Hhe = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function SBl(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t || Hhe.hasOwnProperty(n);
  }, !1);
}
var EBl = {
  "http:": {
    validate: function(e, t, n) {
      var o = e.slice(t);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(o) ? o.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, n) {
      var o = e.slice(t);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(o) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : o.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, n) {
      var o = e.slice(t);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(o) ? o.match(n.re.mailto)[0].length : 0;
    }
  }
}, xBl = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", CBl = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function TBl(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function ABl(e) {
  return function(t, n) {
    var o = t.slice(n);
    return e.test(o) ? o.match(e)[0].length : 0;
  };
}
function jZ() {
  return function(e, t) {
    t.normalize(e);
  };
}
function tT(e) {
  var t = e.re = bBl()(e.__opts__), n = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || n.push(xBl), n.push(t.src_xn), t.src_tlds = n.join("|");
  function o(s) {
    return s.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(o(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(o(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(o(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(o(t.tpl_host_fuzzy_test), "i");
  var r = [];
  e.__compiled__ = {};
  function i(s, c) {
    throw new Error('(LinkifyIt) Invalid schema "' + s + '": ' + c);
  }
  Object.keys(e.__schemas__).forEach(function(s) {
    var c = e.__schemas__[s];
    if (c !== null) {
      var l = { validate: null, link: null };
      if (e.__compiled__[s] = l, $Bl(c)) {
        wBl(c.validate) ? l.validate = ABl(c.validate) : qZ(c.validate) ? l.validate = c.validate : i(s, c), qZ(c.normalize) ? l.normalize = c.normalize : c.normalize ? i(s, c) : l.normalize = jZ();
        return;
      }
      if (yBl(c)) {
        r.push(s);
        return;
      }
      i(s, c);
    }
  }), r.forEach(function(s) {
    e.__compiled__[e.__schemas__[s]] && (e.__compiled__[s].validate = e.__compiled__[e.__schemas__[s]].validate, e.__compiled__[s].normalize = e.__compiled__[e.__schemas__[s]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: jZ() };
  var a = Object.keys(e.__compiled__).filter(function(s) {
    return s.length > 0 && e.__compiled__[s];
  }).map(kBl).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), TBl(e);
}
function IBl(e, t) {
  var n = e.__index__, o = e.__last_index__, r = e.__text_cache__.slice(n, o);
  this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = o + t, this.raw = r, this.text = r, this.url = r;
}
function H5(e, t) {
  var n = new IBl(e, t);
  return e.__compiled__[n.schema].normalize(n, e), n;
}
function Bu(e, t) {
  if (!(this instanceof Bu))
    return new Bu(e, t);
  t || SBl(e) && (t = e, e = {}), this.__opts__ = W5({}, Hhe, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = W5({}, EBl, e), this.__compiled__ = {}, this.__tlds__ = CBl, this.__tlds_replaced__ = !1, this.re = {}, tT(this);
}
Bu.prototype.add = function(t, n) {
  return this.__schemas__[t] = n, tT(this), this;
};
Bu.prototype.set = function(t) {
  return this.__opts__ = W5(this.__opts__, t), this;
};
Bu.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  var n, o, r, i, a, s, c, l, u;
  if (this.re.schema_test.test(t)) {
    for (c = this.re.schema_search, c.lastIndex = 0; (n = c.exec(t)) !== null; )
      if (i = this.testSchemaAt(t, n[2], c.lastIndex), i) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + i;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = t.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && (o = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (a = o.index + o[1].length, (this.__index__ < 0 || a < this.__index__) && (this.__schema__ = "", this.__index__ = a, this.__last_index__ = o.index + o[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (u = t.indexOf("@"), u >= 0 && (r = t.match(this.re.email_fuzzy)) !== null && (a = r.index + r[1].length, s = r.index + r[0].length, (this.__index__ < 0 || a < this.__index__ || a === this.__index__ && s > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = a, this.__last_index__ = s))), this.__index__ >= 0;
};
Bu.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
Bu.prototype.testSchemaAt = function(t, n, o) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(t, o, this) : 0;
};
Bu.prototype.match = function(t) {
  var n = 0, o = [];
  this.__index__ >= 0 && this.__text_cache__ === t && (o.push(H5(this, n)), n = this.__last_index__);
  for (var r = n ? t.slice(n) : t; this.test(r); )
    o.push(H5(this, n)), r = r.slice(this.__last_index__), n += this.__last_index__;
  return o.length ? o : null;
};
Bu.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return null;
  var n = this.re.schema_at_start.exec(t);
  if (!n)
    return null;
  var o = this.testSchemaAt(t, n[2], n[0].length);
  return o ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + o, H5(this, 0)) : null;
};
Bu.prototype.tlds = function(t, n) {
  return t = Array.isArray(t) ? t : [t], n ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(o, r, i) {
    return o !== i[r - 1];
  }).reverse(), tT(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, tT(this), this);
};
Bu.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
Bu.prototype.onCompile = function() {
};
var OBl = Bu;
const Zb = 2147483647, Up = 36, jj = 1, a0 = 26, NBl = 38, zBl = 700, Yhe = 72, Khe = 128, Zhe = "-", RBl = /^xn--/, PBl = /[^\0-\x7E]/, DBl = /[\x2E\u3002\uFF0E\uFF61]/g, LBl = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, mR = Up - jj, Gp = Math.floor, fR = String.fromCharCode;
function Rh(e) {
  throw new RangeError(LBl[e]);
}
function MBl(e, t) {
  const n = [];
  let o = e.length;
  for (; o--; )
    n[o] = t(e[o]);
  return n;
}
function Xhe(e, t) {
  const n = e.split("@");
  let o = "";
  n.length > 1 && (o = n[0] + "@", e = n[1]), e = e.replace(DBl, ".");
  const r = e.split("."), i = MBl(r, t).join(".");
  return o + i;
}
function Vj(e) {
  const t = [];
  let n = 0;
  const o = e.length;
  for (; n < o; ) {
    const r = e.charCodeAt(n++);
    if (r >= 55296 && r <= 56319 && n < o) {
      const i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((r & 1023) << 10) + (i & 1023) + 65536) : (t.push(r), n--);
    } else
      t.push(r);
  }
  return t;
}
const Jhe = (e) => String.fromCodePoint(...e), FBl = function(e) {
  return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : Up;
}, VZ = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, Qhe = function(e, t, n) {
  let o = 0;
  for (e = n ? Gp(e / zBl) : e >> 1, e += Gp(e / t); e > mR * a0 >> 1; o += Up)
    e = Gp(e / mR);
  return Gp(o + (mR + 1) * e / (e + NBl));
}, Bj = function(e) {
  const t = [], n = e.length;
  let o = 0, r = Khe, i = Yhe, a = e.lastIndexOf(Zhe);
  a < 0 && (a = 0);
  for (let s = 0; s < a; ++s)
    e.charCodeAt(s) >= 128 && Rh("not-basic"), t.push(e.charCodeAt(s));
  for (let s = a > 0 ? a + 1 : 0; s < n; ) {
    let c = o;
    for (let u = 1, d = Up; ; d += Up) {
      s >= n && Rh("invalid-input");
      const _ = FBl(e.charCodeAt(s++));
      (_ >= Up || _ > Gp((Zb - o) / u)) && Rh("overflow"), o += _ * u;
      const p = d <= i ? jj : d >= i + a0 ? a0 : d - i;
      if (_ < p)
        break;
      const g = Up - p;
      u > Gp(Zb / g) && Rh("overflow"), u *= g;
    }
    const l = t.length + 1;
    i = Qhe(o - c, l, c == 0), Gp(o / l) > Zb - r && Rh("overflow"), r += Gp(o / l), o %= l, t.splice(o++, 0, r);
  }
  return String.fromCodePoint(...t);
}, Uj = function(e) {
  const t = [];
  e = Vj(e);
  let n = e.length, o = Khe, r = 0, i = Yhe;
  for (const c of e)
    c < 128 && t.push(fR(c));
  let a = t.length, s = a;
  for (a && t.push(Zhe); s < n; ) {
    let c = Zb;
    for (const u of e)
      u >= o && u < c && (c = u);
    const l = s + 1;
    c - o > Gp((Zb - r) / l) && Rh("overflow"), r += (c - o) * l, o = c;
    for (const u of e)
      if (u < o && ++r > Zb && Rh("overflow"), u == o) {
        let d = r;
        for (let _ = Up; ; _ += Up) {
          const p = _ <= i ? jj : _ >= i + a0 ? a0 : _ - i;
          if (d < p)
            break;
          const g = d - p, f = Up - p;
          t.push(
            fR(VZ(p + g % f, 0))
          ), d = Gp(g / f);
        }
        t.push(fR(VZ(d, 0))), i = Qhe(r, l, s == a), r = 0, ++s;
      }
    ++r, ++o;
  }
  return t.join("");
}, eve = function(e) {
  return Xhe(e, function(t) {
    return RBl.test(t) ? Bj(t.slice(4).toLowerCase()) : t;
  });
}, tve = function(e) {
  return Xhe(e, function(t) {
    return PBl.test(t) ? "xn--" + Uj(t) : t;
  });
}, qBl = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.1.0",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: Vj,
    encode: Jhe
  },
  decode: Bj,
  encode: Uj,
  toASCII: tve,
  toUnicode: eve
}, jBl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Bj,
  default: qBl,
  encode: Uj,
  toASCII: tve,
  toUnicode: eve,
  ucs2decode: Vj,
  ucs2encode: Jhe
}, Symbol.toStringTag, { value: "Module" })), VBl = /* @__PURE__ */ nu(jBl);
var BBl = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 100
    // Internal protection, recursion limit
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, UBl = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, GBl = {
  options: {
    html: !0,
    // Enable HTML tags in source
    xhtmlOut: !0,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, rk = ri, WBl = YA, HBl = qjl, YBl = uVl, KBl = VVl, ZBl = vBl, XBl = OBl, Vh = s$, nve = VBl, JBl = {
  default: BBl,
  zero: UBl,
  commonmark: GBl
}, QBl = /^(vbscript|javascript|file|data):/, e9l = /^data:image\/(gif|png|jpeg|webp);/;
function t9l(e) {
  var t = e.trim().toLowerCase();
  return QBl.test(t) ? !!e9l.test(t) : !0;
}
var ove = ["http:", "https:", "mailto:"];
function n9l(e) {
  var t = Vh.parse(e, !0);
  if (t.hostname && (!t.protocol || ove.indexOf(t.protocol) >= 0))
    try {
      t.hostname = nve.toASCII(t.hostname);
    } catch {
    }
  return Vh.encode(Vh.format(t));
}
function o9l(e) {
  var t = Vh.parse(e, !0);
  if (t.hostname && (!t.protocol || ove.indexOf(t.protocol) >= 0))
    try {
      t.hostname = nve.toUnicode(t.hostname);
    } catch {
    }
  return Vh.decode(Vh.format(t), Vh.decode.defaultChars + "%");
}
function Fd(e, t) {
  if (!(this instanceof Fd))
    return new Fd(e, t);
  t || rk.isString(e) || (t = e || {}, e = "default"), this.inline = new ZBl(), this.block = new KBl(), this.core = new YBl(), this.renderer = new HBl(), this.linkify = new XBl(), this.validateLink = t9l, this.normalizeLink = n9l, this.normalizeLinkText = o9l, this.utils = rk, this.helpers = rk.assign({}, WBl), this.options = {}, this.configure(e), t && this.set(t);
}
Fd.prototype.set = function(e) {
  return rk.assign(this.options, e), this;
};
Fd.prototype.configure = function(e) {
  var t = this, n;
  if (rk.isString(e) && (n = e, e = JBl[n], !e))
    throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(o) {
    e.components[o].rules && t[o].ruler.enableOnly(e.components[o].rules), e.components[o].rules2 && t[o].ruler2.enableOnly(e.components[o].rules2);
  }), this;
};
Fd.prototype.enable = function(e, t) {
  var n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(r) {
    n = n.concat(this[r].ruler.enable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
  var o = e.filter(function(r) {
    return n.indexOf(r) < 0;
  });
  if (o.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + o);
  return this;
};
Fd.prototype.disable = function(e, t) {
  var n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(r) {
    n = n.concat(this[r].ruler.disable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
  var o = e.filter(function(r) {
    return n.indexOf(r) < 0;
  });
  if (o.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + o);
  return this;
};
Fd.prototype.use = function(e) {
  var t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
Fd.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  var n = new this.core.State(e, this, t);
  return this.core.process(n), n.tokens;
};
Fd.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
Fd.prototype.parseInline = function(e, t) {
  var n = new this.core.State(e, this, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
Fd.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
var r9l = Fd, i9l = r9l;
const a9l = /* @__PURE__ */ Mi(i9l), t2 = new a9l("default", { html: !0, breaks: !0, linkify: !0 });
typeof window > "u" && console.warn(
  "`markdownToSafeHTMLClient` should not be used on the server side. use markdownToSafeHTML instead"
);
function Gj(e) {
  if (!e)
    return "";
  const t = t2.render(e);
  let o = xue.sanitize(t).replace(
    /<ul>/g,
    "<ul style='list-style-type: disc; list-style-position: inside; margin-left: 12px; margin-bottom: 4px'>"
  ).replace(
    /<ol>/g,
    "<ol style='list-style-type: decimal; list-style-position: inside; margin-left: 12px; margin-bottom: 4px'>"
  ).replace(/<a\s+href=/g, "<a target='_blank' class='text-blue-500 hover:text-blue-600' href=");
  return o = o.replace(
    /<li>([^<]+|<strong>.*?<\/strong>)<\/li>\s*<li>\s*<ul([^>]*)>([\s\S]*?)<\/ul>\s*<\/li>/g,
    "<li>$1<ul$2>$3</ul></li>"
  ), o;
}
const s9l = 1.2, c9l = {
  source: "en",
  targets: [
    "ar",
    "az",
    "bg",
    "bn",
    "ca",
    "cs",
    "da",
    "de",
    "el",
    "es",
    "es-419",
    "eu",
    "et",
    "fi",
    "fr",
    "he",
    "hu",
    "it",
    "ja",
    "km",
    "ko",
    "nl",
    "no",
    "pl",
    "pt-BR",
    "pt",
    "ro",
    "ru",
    "sk-SK",
    "sr",
    "sv",
    "tr",
    "uk",
    "vi",
    "zh-CN",
    "zh-TW"
  ]
}, l9l = {
  json: {
    include: [
      "apps/web/public/static/locales/[locale]/common.json"
    ]
  }
}, u9l = "https://lingo.dev/schema/i18n.json", BZ = {
  version: s9l,
  locale: c9l,
  buckets: l9l,
  $schema: u9l
}, lE = {
  variants: {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: 20 }
  },
  initial: "hidden",
  exit: "hidden",
  animate: "visible",
  transition: { ease: "easeInOut", delay: 0.1 }
}, gR = {
  variants: {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 20 }
  },
  initial: "hidden",
  exit: "hidden",
  animate: "visible",
  transition: { ease: "easeInOut", delay: 0.1 }
}, UZ = {
  mobile: {
    default: {
      width: "100%",
      minHeight: "0px",
      gridTemplateAreas: `
          "meta"
          "header"
          "main"
          "timeslots"
        `,
      gridTemplateColumns: "100%",
      gridTemplateRows: "minmax(min-content,max-content) 1fr"
    }
  },
  month_view: {
    default: {
      width: "calc(var(--booker-meta-width) + var(--booker-main-width))",
      minHeight: "450px",
      height: "auto",
      gridTemplateAreas: `
      "meta main main"
      "meta main main"
      `,
      gridTemplateColumns: "var(--booker-meta-width) var(--booker-main-width)",
      gridTemplateRows: "1fr 0fr"
    },
    selecting_time: {
      width: "calc(var(--booker-meta-width) + var(--booker-main-width) + var(--booker-timeslots-width))",
      minHeight: "450px",
      height: "auto",
      gridTemplateAreas: `
      "meta main timeslots"
      "meta main timeslots"
      `,
      gridTemplateColumns: "var(--booker-meta-width) 1fr var(--booker-timeslots-width)",
      gridTemplateRows: "1fr 0fr"
    }
  },
  week_view: {
    default: {
      width: "100vw",
      minHeight: "100vh",
      height: "auto",
      gridTemplateAreas: `
      "meta header header"
      "meta main main"
      `,
      gridTemplateColumns: "var(--booker-meta-width) 1fr",
      gridTemplateRows: "70px auto"
    }
  },
  column_view: {
    default: {
      width: "100vw",
      minHeight: "100vh",
      height: "auto",
      gridTemplateAreas: `
      "meta header header"
      "meta main main"
      `,
      gridTemplateColumns: "var(--booker-meta-width) 1fr",
      gridTemplateRows: "70px auto"
    }
  }
}, d9l = (e, t, n = !1) => {
  const o = (r) => n ? "" : r;
  return [
    // Size settings are abstracted on their own lines purely for readability.
    // General sizes, used always
    "[--booker-timeslots-width:240px] lg:[--booker-timeslots-width:280px]",
    // Small calendar defaults
    e === io.MONTH_VIEW && o("[--booker-meta-width:240px]"),
    // Meta column gets wider in booking view to fit the full date on a single row in case
    // of a multi occurrence event. Also makes form less wide, which also looks better.
    e === io.MONTH_VIEW && t === "booking" && `[--booker-main-width:420px] ${o("lg:[--booker-meta-width:340px]")}`,
    // Smaller meta when not in booking view.
    e === io.MONTH_VIEW && t !== "booking" && `[--booker-main-width:480px] ${o("lg:[--booker-meta-width:280px]")}`,
    // Fullscreen view settings.
    e !== io.MONTH_VIEW && `[--booker-main-width:480px] [--booker-meta-width:340px] ${o(
      "lg:[--booker-meta-width:424px]"
    )}`
  ];
}, _9l = (e, t) => {
  var a;
  const n = bel(), [o, r] = Lel(), i = typeof window < "u" && ((a = window == null ? void 0 : window.isEmbed) == null ? void 0 : a.call(window));
  return yt(() => {
    const s = UZ[e][t] || UZ[e].default;
    if (!o.current)
      return;
    const c = {
      height: (s == null ? void 0 : s.height) || "auto"
    }, l = {
      // Width is animated by the css class instead of via framer motion,
      // because css is better at animating the calcs, framer motion might
      // make some mistakes in that.
      gridTemplateAreas: s == null ? void 0 : s.gridTemplateAreas,
      width: (s == null ? void 0 : s.width) || "auto",
      gridTemplateColumns: s == null ? void 0 : s.gridTemplateColumns,
      gridTemplateRows: s == null ? void 0 : s.gridTemplateRows,
      minHeight: s == null ? void 0 : s.minHeight
    };
    if (n || e === "mobile" || i) {
      const u = { ...l, ...c };
      Object.keys(u).forEach((d) => {
        d === "height" ? o.current.style.height = c.height === "100vh" && i ? "100%" : c.height : o.current.style[d] = u[d];
      });
    } else
      Object.keys(l).forEach((u) => {
        o.current.style[u] = l[u];
      }), r(o.current, c, {
        duration: 0.5,
        ease: r$(0.4, 0, 0.2, 1)
      });
  }, [r, i, o, e, n, t]), o;
}, uE = {
  mobile: {
    // Desktop tablet feels weird on mobile layout,
    // but this is simply here to make the types a lot easier..
    desktop: 0,
    tablet: 0
  },
  [io.MONTH_VIEW]: {
    desktop: 0,
    tablet: 0
  },
  [io.WEEK_VIEW]: {
    desktop: 7,
    tablet: 4
  },
  [io.COLUMN_VIEW]: {
    desktop: 6,
    tablet: 2
  }
}, p9l = co(
  () => import("./index-B1E-OBOk.js").then((e) => e.TimezoneSelect),
  {
    ssr: !1
  }
), GZ = (e, t, n) => {
  var r;
  const o = BZ.locale.targets.concat([BZ.locale.source]);
  return (r = e == null ? void 0 : e.find(
    (i) => i.field === t && o.includes(i.targetLocale) && (n === i.targetLocale || n.split("-")[0] === i.targetLocale)
  )) == null ? void 0 : r.translatedText;
}, m9l = ({
  event: e,
  isPending: t,
  isPlatform: n = !0,
  isPrivateLink: o,
  classNames: r,
  locale: i,
  timeZones: a,
  children: s,
  selectedTimeslot: c,
  roundRobinHideOrgAndTeam: l
}) => {
  const { timeFormat: u, timezone: d } = Ku(), [_] = Mg((I) => [I.setTimezone]), [p] = _n((I) => [I.setTimezone], Xi), g = _n((I) => I.selectedDuration), f = _n((I) => I.state), h = _n((I) => I.bookingData), $ = _n((I) => I.rescheduleUid), [v, b] = _n(
    (I) => [I.seatedEventData, I.setSeatedEventData],
    Xi
  ), { i18n: y, t: w } = kt(), N = kq(), q = tm() ? N.hideEventTypeDetails : !1, [L] = vn(
    () => n ? [Gq] : [p9l],
    [n]
  );
  if (yt(() => {
    var I;
    if (e != null && e.lockTimeZoneToggleOnBookingPage) {
      const z = e.lockedTimeZone || ((I = e.schedule) == null ? void 0 : I.timeZone);
      z && _(z);
    }
  }, [e, _]), q)
    return null;
  const R = (v == null ? void 0 : v.attendees) || (h == null ? void 0 : h.attendees.length), T = (v == null ? void 0 : v.seatsPerTimeSlot) || (e == null ? void 0 : e.seatsPerTimeSlot), D = R && T && R / T >= 0.5, S = R && T && R / T >= 0.83 ? "text-rose-600" : D ? "text-yellow-500" : "text-bookinghighlight", E = i ?? navigator.language, x = GZ(
    (e == null ? void 0 : e.fieldTranslations) ?? [],
    KG.DESCRIPTION,
    E
  ), k = GZ(
    (e == null ? void 0 : e.fieldTranslations) ?? [],
    KG.TITLE,
    E
  );
  return /* @__PURE__ */ de("div", { className: `${(r == null ? void 0 : r.eventMetaContainer) || ""} relative z-10 p-6`, "data-testid": "event-meta", children: [
    t && /* @__PURE__ */ m(t0.div, { ...gR, initial: "visible", layout: !0, children: /* @__PURE__ */ m(Ial, {}) }),
    !t && !!e && /* @__PURE__ */ de(t0.div, { ...gR, layout: !0, transition: { ...gR.transition, delay: 0.3 }, children: [
      /* @__PURE__ */ m(
        Oal,
        {
          schedulingType: e.schedulingType,
          users: e.subsetOfUsers,
          profile: e.profile,
          entity: e.entity,
          isPrivateLink: o,
          roundRobinHideOrgAndTeam: l
        }
      ),
      /* @__PURE__ */ m(Aal, { className: `${r == null ? void 0 : r.eventMetaTitle} my-2`, children: k ?? (e == null ? void 0 : e.title) }),
      (e.description || x) && /* @__PURE__ */ m(
        Lp,
        {
          "data-testid": "event-meta-description",
          contentClassName: "mb-8 break-words max-w-full max-h-[180px] scroll-bar pr-4",
          children: /* @__PURE__ */ m(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: Gj(x ?? e.description)
              }
            }
          )
        }
      ),
      /* @__PURE__ */ de("div", { className: "space-y-4 font-medium rtl:-mr-2", children: [
        $ && h && /* @__PURE__ */ de(Lp, { icon: "calendar", children: [
          w("former_time"),
          /* @__PURE__ */ m("br", {}),
          /* @__PURE__ */ m("span", { className: "line-through", "data-testid": "former_time_p", children: /* @__PURE__ */ m(
            oZ,
            {
              date: h.startTime.toString(),
              duration: null,
              timeFormat: u,
              timeZone: d,
              language: y.language
            }
          ) })
        ] }),
        c && /* @__PURE__ */ m(Lp, { icon: "calendar", children: /* @__PURE__ */ m(
          oZ,
          {
            date: c,
            duration: g || e.length,
            timeFormat: u,
            timeZone: d,
            language: y.language
          }
        ) }),
        /* @__PURE__ */ m(Tal, { event: e }),
        /* @__PURE__ */ m(
          Lp,
          {
            className: "cursor-pointer [&_.current-timezone:before]:focus-within:opacity-100 [&_.current-timezone:before]:hover:opacity-100",
            contentClassName: "relative max-w-[90%]",
            icon: "globe",
            children: f === "booking" ? /* @__PURE__ */ m(nt, { children: d }) : /* @__PURE__ */ m(
              "span",
              {
                className: `current-timezone before:bg-subtle min-w-32 -mt-[2px] flex h-6 max-w-full items-center justify-start before:absolute before:inset-0 before:bottom-[-3px] before:left-[-30px] before:top-[-3px] before:w-[calc(100%_+_35px)] before:rounded-md before:py-3 before:opacity-0 before:transition-opacity ${e.lockTimeZoneToggleOnBookingPage ? "cursor-not-allowed" : ""}`,
                "data-testid": "event-meta-current-timezone",
                children: /* @__PURE__ */ m(
                  L,
                  {
                    timeZones: a,
                    menuPosition: "absolute",
                    timezoneSelectCustomClassname: r == null ? void 0 : r.eventMetaTimezoneSelect,
                    classNames: {
                      control: () => "!min-h-0 p-0 w-full border-0 bg-transparent focus-within:ring-0 shadow-none!",
                      menu: () => "!w-64 max-w-[90vw] mb-1 ",
                      singleValue: () => "text-text py-1",
                      indicatorsContainer: () => "ml-auto",
                      container: () => "max-w-full"
                    },
                    value: e.lockTimeZoneToggleOnBookingPage ? e.lockedTimeZone || zy : d,
                    onChange: ({ value: I }) => {
                      _(I), p(I);
                    },
                    isDisabled: e.lockTimeZoneToggleOnBookingPage
                  }
                )
              }
            )
          }
        ),
        f === "booking" && T && R ? /* @__PURE__ */ m(Lp, { icon: "user", className: `${S}`, children: /* @__PURE__ */ m("div", { className: "text-bookinghighlight flex items-start text-sm", children: /* @__PURE__ */ m("p", { children: /* @__PURE__ */ m(
          ghe,
          {
            showExact: !!v.showAvailableSeatsCount,
            totalSeats: T,
            bookedSeats: R || 0,
            variant: "fraction"
          }
        ) }) }) }) : null
      ] }),
      s && /* @__PURE__ */ m("div", { className: r == null ? void 0 : r.eventMetaChildren, children: s })
    ] })
  ] });
};
function f9l(e) {
  const { t } = kt(), [n, o] = it(!1);
  return !e.visible || process.env.NEXT_PUBLIC_BOOKER_NUMBER_OF_DAYS_TO_LOAD == "0" && NM == 0 || !process.env.NEXT_PUBLIC_BOOKER_NUMBER_OF_DAYS_TO_LOAD || n && !e.isScheduleLoading || e.isScheduleLoading || !e.dayCount ? null : /* @__PURE__ */ de("div", { className: "bg-default border-subtle mt-6 flex w-1/2 min-w-0 items-center justify-between rounded-[32px] border p-3 text-sm leading-none shadow-sm lg:w-1/3", children: [
    /* @__PURE__ */ de("div", { className: "flex items-center gap-2 overflow-x-hidden", children: [
      /* @__PURE__ */ m(qt, { name: "info", className: "text-default h-4 w-4" }),
      /* @__PURE__ */ m("p", { className: "w-full  leading-none", children: t("having_trouble_finding_time") })
    ] }),
    /* @__PURE__ */ de(
      "button",
      {
        className: "inline-flex items-center gap-2 font-medium",
        onClick: (r) => {
          r.preventDefault(), e.onButtonClick(), o(!0);
        },
        children: [
          t("show_more"),
          " ",
          /* @__PURE__ */ m(qt, { name: "arrow-right", className: "h-4 w-4" })
        ]
      }
    )
  ] });
}
const g9l = (e, t) => {
  const o = ht().startOf("week").format("YYYY-MM-DD"), r = _n((i) => i.setSelectedDate);
  yt(() => {
    e && t && r({ date: o, omitUpdatingParams: !0 });
  }, []);
};
function rve({
  extraDays: e,
  isMobile: t,
  enabledLayouts: n,
  nextSlots: o,
  eventSlug: r,
  isMyLink: i,
  renderOverlay: a,
  isCalendarView: s
}) {
  const { t: c, i18n: l } = kt(), u = tm(), d = Kr(), [_, p] = _n((T) => [T.layout, T.setLayout], Xi), g = _n((T) => T.selectedDate), f = _n((T) => T.setSelectedDate), h = _n((T) => T.addToSelectedDate), $ = s !== void 0 ? !s : _ === io.MONTH_VIEW, v = ht(), b = g ? ht(g) : v, y = vn(() => {
    const T = v.diff(b, "days");
    return T > 3 || T < -3;
  }, [v, b]);
  g9l(d, s ?? !1);
  const w = Yt(
    (T) => {
      _ === T || !T || p(T);
    },
    [p, _]
  );
  if (t || !n)
    return null;
  if ($)
    return /* @__PURE__ */ de("div", { className: "flex gap-2", children: [
      i && !u ? /* @__PURE__ */ m(Sr, { content: c("troubleshooter_tooltip"), side: "bottom", children: /* @__PURE__ */ m(
        Jt,
        {
          color: "primary",
          target: "_blank",
          href: `${Wa}/availability/troubleshoot?eventType=${r}`,
          children: c("need_help")
        }
      ) }) : a == null ? void 0 : a(),
      /* @__PURE__ */ m(
        hR,
        {
          layout: _,
          enabledLayouts: n,
          onLayoutToggle: w
        }
      )
    ] });
  const N = b.add(_ === io.COLUMN_VIEW ? e : e - 1, "days"), M = () => b.format("MMM") === N.format("MMM"), q = () => b.format("YYYY") === N.format("YYYY"), L = new Intl.DateTimeFormat(l.language ?? "en", { month: "short" });
  return /* @__PURE__ */ de("div", { className: "border-default relative z-10 flex border-b px-5 py-4 ltr:border-l rtl:border-r", children: [
    /* @__PURE__ */ de("div", { className: "flex items-center gap-5 rtl:flex-grow", children: [
      /* @__PURE__ */ m(() => /* @__PURE__ */ de("h3", { className: "min-w-[150px] text-base font-semibold leading-4", children: [
        L.format(b.toDate()),
        " ",
        b.format("D"),
        !q() && /* @__PURE__ */ de("span", { className: "text-subtle", children: [
          ", ",
          b.format("YYYY"),
          " "
        ] }),
        "-",
        " ",
        !M() && L.format(N.toDate()),
        " ",
        N.format("D"),
        ",",
        " ",
        /* @__PURE__ */ m("span", { className: "text-subtle", children: q() ? b.format("YYYY") : N.format("YYYY") })
      ] }), {}),
      /* @__PURE__ */ de($A, { children: [
        /* @__PURE__ */ m(
          Jt,
          {
            className: "group rtl:ml-1 rtl:rotate-180",
            variant: "icon",
            color: "minimal",
            StartIcon: "chevron-left",
            "aria-label": "Previous Day",
            onClick: () => h(_ === io.COLUMN_VIEW ? -o : -e)
          }
        ),
        /* @__PURE__ */ m(
          Jt,
          {
            className: "group rtl:mr-1 rtl:rotate-180",
            variant: "icon",
            color: "minimal",
            StartIcon: "chevron-right",
            "aria-label": "Next Day",
            onClick: () => h(_ === io.COLUMN_VIEW ? o : e)
          }
        ),
        y && /* @__PURE__ */ m(
          Jt,
          {
            className: "capitalize ltr:ml-2 rtl:mr-2",
            color: "secondary",
            onClick: () => {
              const T = (s ? v.startOf("week") : v).format("YYYY-MM-DD");
              f({ date: T });
            },
            children: c("today")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ de("div", { className: "ml-auto flex gap-2", children: [
      a == null ? void 0 : a(),
      /* @__PURE__ */ m(whe, {}),
      /* @__PURE__ */ m("div", { className: "fixed top-4 ltr:right-4 rtl:left-4", children: /* @__PURE__ */ m(
        hR,
        {
          layout: _,
          enabledLayouts: n,
          onLayoutToggle: w
        }
      ) }),
      /* @__PURE__ */ m("div", { className: "pointer-events-none opacity-0", "aria-hidden": !0, children: /* @__PURE__ */ m(
        hR,
        {
          layout: _,
          enabledLayouts: n,
          onLayoutToggle: w
        }
      ) })
    ] })
  ] });
}
const h9l = ({
  onLayoutToggle: e,
  layout: t,
  enabledLayouts: n
}) => {
  const o = tm(), r = Kr(), { t: i } = kt(), a = vn(() => [
    {
      value: io.MONTH_VIEW,
      label: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(qt, { name: "calendar", width: "16", height: "16" }),
        /* @__PURE__ */ de("span", { className: "sr-only", children: [
          "$",
          i("switch_monthly")
        ] })
      ] }),
      tooltip: i("switch_monthly")
    },
    {
      value: io.WEEK_VIEW,
      label: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(qt, { name: "grid-3x3", width: "16", height: "16" }),
        /* @__PURE__ */ de("span", { className: "sr-only", children: [
          "$",
          i("switch_weekly")
        ] })
      ] }),
      tooltip: i("switch_weekly")
    },
    {
      value: io.COLUMN_VIEW,
      label: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(qt, { name: "columns-3", width: "16", height: "16" }),
        /* @__PURE__ */ de("span", { className: "sr-only", children: [
          "$",
          i("switch_columnview")
        ] })
      ] }),
      tooltip: i("switch_columnview")
    }
  ].filter((s) => n == null ? void 0 : n.includes(s.value)), [i, n]);
  return o || r ? null : /* @__PURE__ */ m(lq, { onValueChange: e, defaultValue: t, options: a });
}, hR = ({
  enabledLayouts: e,
  onLayoutToggle: t,
  layout: n
}) => e.length <= 1 ? null : /* @__PURE__ */ m(h9l, { onLayoutToggle: t, layout: n, enabledLayouts: e }), v9l = ({ onConnectNow: e, event: t, cooldownMs: n = 0 }) => {
  const { t: o } = kt(), r = n > 0;
  return /* @__PURE__ */ de("div", { className: " bg-default border-subtle mx-2 block items-center gap-3 rounded-xl border p-[6px] text-sm shadow-sm delay-1000 sm:flex", children: [
    /* @__PURE__ */ de("div", { className: "flex items-center gap-3 ps-1", children: [
      /* @__PURE__ */ de("div", { className: "relative", children: [
        /* @__PURE__ */ m(
          hHc,
          {
            size: "sm",
            className: "border-muted",
            organization: {
              slug: t.entity.orgSlug,
              name: t.entity.name || "",
              logoUrl: t.entity.logoUrl ?? null
            },
            users: t.subsetOfUsers.slice(0, 2),
            disableHref: !0
          }
        ),
        /* @__PURE__ */ m("div", { className: "border-muted absolute -bottom-0.5 -right-1 h-2 w-2 rounded-full border bg-green-500" })
      ] }),
      /* @__PURE__ */ m("div", { children: o("dont_want_to_wait") })
    ] }),
    /* @__PURE__ */ m("div", { className: "mt-2 sm:mt-0 flex items-center gap-3", children: r ? /* @__PURE__ */ m(Sr, { content: o("just_connected_description"), children: /* @__PURE__ */ m("span", { className: "inline-flex", children: /* @__PURE__ */ m(
      Jt,
      {
        disabled: r,
        color: "primary",
        onClick: () => {
          e();
        },
        size: "sm",
        className: "w-full justify-center rounded-lg sm:w-auto",
        children: o("connect_now")
      }
    ) }) }) : /* @__PURE__ */ m(
      Jt,
      {
        color: "primary",
        onClick: () => {
          e();
        },
        size: "sm",
        className: "w-full justify-center rounded-lg sm:w-auto",
        children: o("connect_now")
      }
    ) })
  ] });
}, ive = ({ schedule: e, eventDuration: t }) => vn(() => {
  const n = {};
  if (!e || !e.slots)
    return n;
  for (const o in e.slots)
    n[o] = e.slots[o].map((r) => {
      const { time: i, ...a } = r;
      return {
        start: ht(i).toDate(),
        end: ht(i).add(t, "minutes").toDate(),
        ...a
      };
    });
  return n;
}, [e, t]);
function WZ(e = 0, t, n = 6) {
  const o = t;
  for (; o.getDay() !== e; )
    o.setDate(o.getDate() - 1);
  return {
    startDate: o,
    endDate: new Date(o.getTime() + n * 24 * 60 * 60 * 1e3)
  };
}
function b9l({
  day: e,
  gridCellIdx: t,
  totalGridCells: n,
  selectionLength: o,
  startHour: r,
  timezone: i
}) {
  const c = (o + 1) * 60 / n * t;
  return ht(e).tz(i).startOf("day").add(c, "minutes").add(r, "hours");
}
function y9l(e, t) {
  const n = [];
  let o = ht(e).hour(0).minute(0).second(0).millisecond(0);
  n.push(o);
  const r = ht(t).hour(0).minute(0).second(0).millisecond(0);
  for (; o.isBefore(r); )
    n.push(o.add(1, "day")), o = o.add(1, "day");
  return n.slice(0, 7);
}
function $9l(e, t, n) {
  const o = [];
  let r = ht("1970-01-01").tz(n).hour(e);
  o.push(r);
  const i = ht("1970-01-01").tz(n).hour(t);
  for (; r.isBefore(i); )
    o.push(r.add(1, "hour")), r = r.add(1, "hour");
  return o;
}
function w9l(e) {
  e.sort((n, o) => n.start.getTime() - o.start.getTime());
  const t = [];
  for (let n = 0; n < e.length; n++)
    if (t.length === 0)
      t.push(e[n]);
    else {
      const o = t[t.length - 1], r = e[n];
      o.end.getTime() >= r.start.getTime() ? o.end = r.end : t.push(r);
    }
  return t;
}
const k9l = {
  view: "week",
  startDate: WZ(0, /* @__PURE__ */ new Date()).startDate,
  endDate: WZ(0, /* @__PURE__ */ new Date()).endDate,
  events: [],
  startHour: 0,
  endHour: 23,
  gridCellsPerHour: 4
}, Ed = dF((e) => ({
  ...k9l,
  setView: (t) => e({ view: t }),
  setStartDate: (t) => e({ startDate: t }),
  setEndDate: (t) => e({ endDate: t }),
  setEvents: (t) => e({ events: t }),
  // This looks a bit odd but init state only overrides the public props + actions as we don't want to override our internal state
  initState: (t) => {
    let n = t.events;
    t.sortEvents && (n = t.events.sort((r, i) => ht(r.start).valueOf() - ht(i.start).valueOf()));
    const o = w9l(t.blockingDates || []);
    e({
      ...t,
      blockingDates: o,
      events: n
    });
  },
  setSelectedEvent: (t) => e({ selectedEvent: t }),
  handleDateChange: (t) => e((n) => {
    const { startDate: o, endDate: r } = n;
    if (t === "INCREMENT") {
      const s = ht(o).add(1, n.view).toDate(), c = ht(r).add(1, n.view).toDate();
      return n.minDate && s < n.minDate || n.maxDate && c > n.maxDate ? {
        startDate: o,
        endDate: r
      } : (n.onDateChange && n.onDateChange(s, c), {
        startDate: s,
        endDate: c
      });
    }
    const i = ht(o).subtract(1, n.view).toDate(), a = ht(r).subtract(1, n.view).toDate();
    return n.onDateChange && n.onDateChange(i, a), {
      startDate: i,
      endDate: a
    };
  })
}));
function S9l({ days: e, containerNavRef: t }) {
  const { i18n: n } = kt(), o = (r) => new Intl.DateTimeFormat(n.language, { weekday: "short" }).format(r.toDate());
  return /* @__PURE__ */ de(
    "div",
    {
      ref: t,
      className: "bg-default dark:bg-muted border-b-subtle rtl:border-r-default sticky top-[var(--calendar-dates-sticky-offset,0px)] z-[80] flex-none border-b border-r sm:pr-8",
      children: [
        /* @__PURE__ */ m("div", { className: "text-subtle flex text-sm leading-6 sm:hidden", "data-dayslength": e.length, children: e.map((r) => {
          const i = ht().isSame(r, "day");
          return /* @__PURE__ */ de(
            "button",
            {
              type: "button",
              className: "flex flex-1 flex-col items-center pb-3 pt-2",
              children: [
                r.format("dd"),
                " ",
                /* @__PURE__ */ m(
                  "span",
                  {
                    className: xe(
                      "text-emphasis mt-1 flex h-8 w-8 items-center justify-center font-semibold",
                      i && "bg-inverted text-inverted rounded-full"
                    ),
                    children: r.format("D")
                  }
                )
              ]
            },
            r.toString()
          );
        }) }),
        /* @__PURE__ */ de("div", { className: "text-subtle -mr-px hidden  auto-cols-fr text-sm leading-6 sm:flex ", children: [
          /* @__PURE__ */ m("div", { className: "border-default col-end-1 w-14 ltr:border-l" }),
          e.map((r) => {
            const i = ht().isSame(r, "day");
            return /* @__PURE__ */ m(
              "div",
              {
                className: xe(
                  "flex flex-1 items-center justify-center py-3 text-xs font-medium uppercase",
                  i && "font-bold"
                ),
                children: /* @__PURE__ */ de("span", { children: [
                  o(r),
                  " ",
                  /* @__PURE__ */ m(
                    "span",
                    {
                      className: xe(
                        "items-center justify-center p-1",
                        i && "bg-brand-default text-brand rounded-full"
                      ),
                      children: r.format("DD")
                    }
                  )
                ] })
              },
              r.toString()
            );
          })
        ] })
      ]
    }
  );
}
function E9l(e, t, n) {
  const o = e * 60;
  return t * 60 + n - o;
}
function x9l() {
  const e = xt(null), [t, n] = it(!1), [o, r] = it(null), { startHour: i, endHour: a } = Ed((l) => ({
    startHour: l.startHour || 0,
    endHour: l.endHour || 23
  })), { timeFormat: s, timezone: c } = Ku();
  return yt(() => {
    const l = ht().tz(c), u = l.hour(), d = l.minute();
    (u > a || u < i) && r(null);
    const _ = E9l(i, u, d);
    r(_), !(!e.current || t) && setTimeout(() => {
      var p;
      (p = e == null ? void 0 : e.current) == null || p.scrollIntoView({ block: "center" }), n(!0);
    }, 100);
  }, [i, a, t, c]), /* @__PURE__ */ de(
    "div",
    {
      ref: e,
      className: "absolute top-0 z-40 flex h-px items-center justify-center text-xs",
      "aria-hidden": "true",
      style: {
        top: `calc(${o}*var(--one-minute-height) + var(--calendar-offset-top))`,
        zIndex: 70
      },
      children: [
        /* @__PURE__ */ m("div", { className: "w-14 pr-2 text-right", children: ht().tz(c).format(s) }),
        /* @__PURE__ */ m("div", { className: "bg-inverted h-3 w-px" }),
        /* @__PURE__ */ m("div", { className: "bg-inverted h-px w-screen" })
      ]
    }
  );
}
function C9l(e) {
  const t = b9l({
    day: e.day,
    gridCellIdx: e.gridCellIdx,
    totalGridCells: e.totalGridCells,
    selectionLength: e.selectionLength,
    startHour: e.startHour,
    timezone: e.timezone
  }), n = (t.hour() - e.startHour) * 60 + t.minute();
  return /* @__PURE__ */ m(ave, { topOffsetMinutes: n, timeSlot: ht(t).tz(e.timezone) });
}
function T9l({ availableSlots: e, day: t, startHour: n }) {
  var c;
  const { timezone: o } = Ku(), i = ht(t).format("YYYY-MM-DD"), a = e && e[i], s = vn(() => {
    const l = [];
    let u = -1, d = -1, _ = !0, p = 0;
    if (a == null || a.forEach((g, f) => {
      const h = ht(g.start).tz(o), $ = (h.hour() - n) * 60 + h.minute();
      l.push({ slot: g, topOffsetMinutes: $ }), g.away ? (u === -1 && (u = f), d = f) : _ = !1;
    }), _ && u !== -1) {
      const g = a[u], f = a[d];
      return p = ht(f.end).diff(ht(g.start), "minutes"), g.toUser == null ? null : {
        slots: l,
        startEndTimeDuration: p,
        firstSlot: g,
        timezone: o
      };
    }
    return { slots: l, startEndTimeDuration: p };
  }, [a, n, o]);
  if (s === null)
    return null;
  if (s.startEndTimeDuration) {
    const { firstSlot: l, startEndTimeDuration: u } = s;
    return /* @__PURE__ */ m(
      A9l,
      {
        timeSlot: ht(l == null ? void 0 : l.start).tz(s.timezone),
        topOffsetMinutes: (c = s.slots[0]) == null ? void 0 : c.topOffsetMinutes,
        startEndTimeDuration: u,
        children: /* @__PURE__ */ m(
          fhe,
          {
            fromUser: l == null ? void 0 : l.fromUser,
            toUser: l == null ? void 0 : l.toUser,
            reason: l == null ? void 0 : l.reason,
            emoji: l == null ? void 0 : l.emoji,
            borderDashed: !1,
            date: i,
            className: "pb-0"
          }
        )
      }
    );
  }
  return /* @__PURE__ */ m(nt, { children: s.slots.map((l, u) => /* @__PURE__ */ m(
    ave,
    {
      timeSlot: ht(l.slot.start).tz(o),
      topOffsetMinutes: l.topOffsetMinutes
    },
    u
  )) });
}
function ave({ isDisabled: e, topOffsetMinutes: t, timeSlot: n }) {
  const { timeFormat: o } = Ku(), { onEmptyCellClick: r, hoverEventDuration: i } = Ed(
    (a) => ({
      onEmptyCellClick: a.onEmptyCellClick,
      hoverEventDuration: a.hoverEventDuration
    }),
    Xi
  );
  return /* @__PURE__ */ m(
    "div",
    {
      className: xe(
        "group flex w-[calc(100%-1px)] items-center justify-center",
        e && "pointer-events-none",
        !e && "bg-default dark:bg-muted",
        t && "absolute"
      ),
      "data-disabled": e,
      "data-slot": n.toISOString(),
      "data-testid": "calendar-empty-cell",
      style: {
        height: `calc(${i}*var(--one-minute-height))`,
        overflow: "visible",
        top: t ? `calc(${t}*var(--one-minute-height))` : void 0
      },
      onClick: () => {
        r && r(n.toDate());
      },
      children: !e && i !== 0 && /* @__PURE__ */ m(
        "div",
        {
          className: xe(
            "opacity-4 bg-brand-default hover:bg-brand-default text-brand dark:border-emphasis absolute hidden rounded-[4px] p-[6px] text-xs font-semibold leading-5 group-hover:flex group-hover:cursor-pointer",
            i && i > 15 && "items-start pt-3",
            i && i < 15 && "items-center"
          ),
          style: {
            height: `calc(${i}*var(--one-minute-height) - 2px)`,
            zIndex: 80,
            // @TODO: This used to be 90% as per Sean's work. I think this was needed when
            // multiple events are stacked next to each other. We might need to add this back later.
            width: "calc(100% - 2px)"
          },
          children: /* @__PURE__ */ m("div", { className: "overflow-ellipsis leading-[0]", children: n.format(o) })
        }
      )
    }
  );
}
function A9l({
  timeSlot: e,
  children: t,
  topOffsetMinutes: n,
  startEndTimeDuration: o
}) {
  return /* @__PURE__ */ m(
    "div",
    {
      className: xe(
        "bg-default dark:bg-muted group absolute z-[65] flex w-[calc(100%-1px)] items-center justify-center"
      ),
      "data-slot": e.toISOString(),
      style: {
        top: n ? `calc(${n}*var(--one-minute-height))` : void 0,
        overflow: "visible"
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          className: xe(
            "dark:border-emphasis bg-default dark:bg-muted cursor-pointer rounded-[4px] p-[6px] text-xs font-semibold dark:text-white"
          ),
          style: {
            height: `calc(${o}*var(--one-minute-height) - 2px)`,
            width: "calc(100% - 2px)"
          },
          children: t
        }
      )
    }
  );
}
function sve(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (t = 0; t < r; t++)
        e[t] && (n = sve(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function I9l() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++)
    (e = arguments[n]) && (t = sve(e)) && (o && (o += " "), o += t);
  return o;
}
const HZ = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, YZ = I9l, O9l = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null)
    return YZ(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((l) => {
    const u = n == null ? void 0 : n[l], d = i == null ? void 0 : i[l];
    if (u === null)
      return null;
    const _ = HZ(u) || HZ(d);
    return r[l][_];
  }), s = n && Object.entries(n).reduce((l, u) => {
    let [d, _] = u;
    return _ === void 0 || (l[d] = _), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, u) => {
    let { class: d, className: _, ...p } = u;
    return Object.entries(p).every((g) => {
      let [f, h] = g;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...s
      }[f]) : {
        ...i,
        ...s
      }[f] === h;
    }) ? [
      ...l,
      d,
      _
    ] : l;
  }, []);
  return YZ(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, N9l = O9l(
  "group flex h-full w-full overflow-y-auto rounded-[6px] px-[6px] text-xs font-semibold leading-5 opacity-80",
  {
    variants: {
      status: {
        ACCEPTED: "bg-subtle hover:bg-emphasis text-emphasis border-[1px] border-gray-900",
        PENDING: "bg-default text-emphasis border-[1px] border-dashed border-gray-900",
        REJECTED: "",
        CANCELLED: "",
        AWAITING_HOST: ""
      },
      disabled: {
        true: "hover:cursor-default",
        false: "hover:cursor-pointer"
      },
      selected: {
        true: "bg-inverted text-inverted border-[1px] border-transparent",
        false: ""
      },
      borderColor: {
        ACCEPTED: "border-gray-900",
        PENDING: "border-gray-900",
        REJECTED: "border-gray-900",
        CANCELLED: "border-gray-900",
        AWAITING_HOST: "",
        custom: ""
      }
    }
  }
);
function z9l({
  event: e,
  currentlySelectedEventId: t,
  eventDuration: n,
  disabled: o,
  onEventClick: r
}) {
  var u, d;
  const i = t === e.id, { options: a } = e, s = a != null && a.borderColor ? "custom" : a == null ? void 0 : a.status, c = a != null && a.borderColor ? {
    borderColor: a == null ? void 0 : a.borderColor
  } : {}, l = r ? "button" : "div";
  return /* @__PURE__ */ m(Sr, { content: e.title, children: /* @__PURE__ */ de(
    l,
    {
      onClick: () => r == null ? void 0 : r(e),
      className: xe(
        N9l({
          status: a == null ? void 0 : a.status,
          disabled: o,
          selected: i,
          borderColor: s
        }),
        n > 30 && "flex-col py-1",
        a == null ? void 0 : a.className
      ),
      style: c,
      children: [
        /* @__PURE__ */ de(
          "div",
          {
            className: xe(
              "flex w-full gap-2 overflow-hidden overflow-ellipsis whitespace-nowrap text-left leading-4",
              n <= 30 && "items-center"
            ),
            children: [
              /* @__PURE__ */ m("span", { children: e.title }),
              n <= 30 && !((u = e.options) != null && u.hideTime) && /* @__PURE__ */ de("p", { className: "text-subtle w-full whitespace-nowrap text-left text-[10px] leading-none", children: [
                ht(e.start).format("HH:mm"),
                " - ",
                ht(e.end).format("HH:mm")
              ] })
            ]
          }
        ),
        n > 30 && !((d = e.options) != null && d.hideTime) && /* @__PURE__ */ de("p", { className: "text-subtle text-left text-[10px] leading-none", children: [
          ht(e.start).format("HH:mm"),
          " - ",
          ht(e.end).format("HH:mm")
        ] }),
        n > 45 && e.description && /* @__PURE__ */ m("p", { className: "text-subtle text-left text-[10px] leading-none", children: e.description })
      ]
    }
  ) });
}
function R9l({ day: e }) {
  const { startHour: t, events: n, eventOnClick: o } = Ed(
    (i) => ({
      startHour: i.startHour,
      events: i.events,
      eventOnClick: i.onEventClick
    }),
    Xi
  ), r = xt(null);
  return /* @__PURE__ */ m(nt, { children: n.filter((i) => {
    var a;
    return ht(i.start).isSame(e, "day") && !((a = i.options) != null && a.allDay);
  }).map((i, a, s) => {
    var b;
    let c = 90, l = 0, u = 0, d = 61;
    const _ = ht(i.start), p = ht(i.end), g = p.diff(_, "minutes"), h = (_.hour() - (t || 0)) * 60 + _.minute(), $ = s[a + 1], v = s[a - 1];
    if (r.current ? g > r.current.duration && _.isBetween(r.current.start, r.current.end) && (r.current = {
      idx: a,
      start: _.toDate(),
      end: p.toDate(),
      duration: g
    }) : r.current = {
      idx: a,
      start: _.toDate(),
      end: p.toDate(),
      duration: g
    }, r.current.idx !== a) {
      if ($) {
        const y = ht($.start);
        (y.isBetween(r.current.start, r.current.end) || y.isBetween(_.add(-5, "minutes"), _.add(5, "minutes"))) && (d = 65, l = "auto", u = 4, c = c / 2);
      } else if (v) {
        const y = ht(v.start);
        y.isBetween(r.current.start, r.current.end) ? (d = 65, l = "auto", u = 4) : _.isBetween(y.add(5, "minutes"), y.add(-5, "minutes")) && (d = 65, u = 4, c = c / 2);
      }
    }
    return /* @__PURE__ */ m(
      "div",
      {
        className: "absolute inset-x-1 ",
        "data-testid": (b = i.options) == null ? void 0 : b["data-test-id"],
        style: {
          marginLeft: l,
          zIndex: d,
          right: `calc(${u}% - 1px)`,
          width: `${c}%`,
          top: `calc(${h}*var(--one-minute-height))`,
          height: `calc(${g}*var(--one-minute-height))`
        },
        children: /* @__PURE__ */ m(z9l, { event: i, eventDuration: g, onEventClick: o })
      },
      `${i.id}-${_.toISOString()}`
    );
  }) });
}
const KZ = Fe.forwardRef(function({ offsetHeight: t, gridStopsPerDay: n, children: o, zIndex: r }, i) {
  return /* @__PURE__ */ m(
    "ol",
    {
      ref: i,
      className: "scheduler-grid-row-template col-start-1 col-end-2 row-start-1 grid auto-cols-auto text-[0px] sm:pr-8",
      style: { marginTop: t || "var(--gridDefaultSize)", zIndex: r },
      "data-gridstopsperday": n,
      children: o
    }
  );
});
function P9l() {
  const { startDate: e, endDate: t, handleDateChange: n } = Ed((o) => ({
    startDate: ht(o.startDate),
    endDate: ht(o.endDate),
    handleDateChange: o.handleDateChange
  }));
  return /* @__PURE__ */ de("header", { className: "flex flex-none flex-col justify-between py-4 sm:flex-row sm:items-center", children: [
    /* @__PURE__ */ de("h1", { className: "text-emphasis text-xl font-semibold", children: [
      e.format("MMM DD"),
      "-",
      t.format("DD"),
      /* @__PURE__ */ de("span", { className: "text-subtle", children: [
        ",",
        e.format("YYYY")
      ] })
    ] }),
    /* @__PURE__ */ m("div", { className: "flex items-center space-x-2 rtl:space-x-reverse", children: /* @__PURE__ */ de($A, { combined: !0, children: [
      /* @__PURE__ */ m(
        Jt,
        {
          StartIcon: "chevron-left",
          variant: "icon",
          color: "secondary",
          "aria-label": "Previous Week",
          onClick: () => {
            n("DECREMENT");
          }
        }
      ),
      /* @__PURE__ */ m(
        Jt,
        {
          StartIcon: "chevron-right",
          variant: "icon",
          color: "secondary",
          "aria-label": "Next Week",
          onClick: () => {
            n("INCREMENT");
          }
        }
      )
    ] }) })
  ] });
}
const D9l = ({
  hours: e,
  numberOfGridStopsPerCell: t,
  containerOffsetRef: n
}) => {
  const { timeFormat: o } = Mg(), r = e[e.length - 1].add(1, "hour").minute(0).format(o), i = I0();
  return /* @__PURE__ */ de(
    "div",
    {
      className: " divide-default pointer-events-none relative z-[60] col-start-1 col-end-2 row-start-1 grid divide-y",
      style: {
        gridTemplateRows: `repeat(${e.length}, minmax(var(--gridDefaultSize),1fr)`
      },
      children: [
        /* @__PURE__ */ m("div", { className: "row-end-1 h-[--calendar-offset-top] ", ref: n }),
        e.map((a) => /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "text-muted sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 rtl:-mr-14", children: a.minute(0).format(o) }) }, `${i}-${a.get("hour")}`)),
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "text-muted sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 rtl:-mr-14", children: r }) }, `${i}-${r}`)
      ]
    }
  );
}, L9l = ({ className: e }) => /* @__PURE__ */ m(
  "div",
  {
    className: xe(
      "fixed left-[calc(50%+calc(var(--booker-meta-width,0px)/2))] top-1/2 z-[80] h-10 w-10 -translate-x-1/2 -translate-y-1/2",
      e
    ),
    children: /* @__PURE__ */ de("svg", { className: "h-10 w-10", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ m(
        "path",
        {
          className: "fill-default",
          d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
          opacity: ".25"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          className: "animate-spinning fill-emphasis origin-center",
          d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        }
      )
    ] })
  }
), M9l = ({ days: e }) => {
  const t = () => {
    let o = "en";
    if (typeof window < "u" && typeof navigator < "u") {
      const r = navigator.language;
      o = new Intl.Locale(r).language;
    }
    return ["ar", "he", "fa", "ur"].includes(o);
  }, n = t() ? "rtl" : "ltr";
  return /* @__PURE__ */ m(
    "div",
    {
      className: `divide-default pointer-events-none relative z-[60] col-start-1 col-end-2 row-start-1 grid
       auto-cols-auto grid-rows-1 divide-x sm:pr-8`,
      dir: n,
      style: {
        direction: n
      },
      children: e.map((o, r) => /* @__PURE__ */ m(
        "div",
        {
          className: "row-span-full",
          style: {
            gridColumnStart: t() ? e.length - r : r + 1
          }
        },
        `Key_vertical_${r}`
      ))
    }
  );
};
function cve(e) {
  var v, b;
  const t = xt(null), n = xt(null), o = xt(null), r = xt(null), i = Ed((y) => y.initState), { timezone: a } = Ku(), s = Ed((y) => y.startDate), c = Ed((y) => y.endDate), l = Ed((y) => y.startHour || 0), u = Ed((y) => y.endHour || 23), d = Ed((y) => y.gridCellsPerHour || 4), _ = Ed((y) => y.availableTimeslots), p = Ed((y) => y.hideHeader), g = vn(() => y9l(s, c), [s, c]), f = vn(
    () => $9l(l || 0, u || 23, a),
    [l, u, a]
  ), h = f.length * d, $ = 58;
  return yt(() => {
    i(e);
  }, [e, i]), /* @__PURE__ */ m(F9l, { children: /* @__PURE__ */ de(
    "div",
    {
      className: xe("scheduler-wrapper flex h-full w-full flex-col"),
      style: {
        "--one-minute-height": `calc(${$}px/60)`,
        "--gridDefaultSize": `${$}px`
      },
      children: [
        p !== !0 && /* @__PURE__ */ m(P9l, {}),
        e.isPending && /* @__PURE__ */ m(L9l, {}),
        /* @__PURE__ */ m(
          "div",
          {
            ref: t,
            className: "bg-default dark:bg-muted relative isolate flex h-full flex-auto flex-col",
            children: /* @__PURE__ */ de(
              "div",
              {
                style: { width: "165%" },
                className: "flex h-full max-w-full flex-none flex-col sm:max-w-none md:max-w-full",
                children: [
                  /* @__PURE__ */ m(S9l, { containerNavRef: n, days: g }),
                  /* @__PURE__ */ de("div", { className: "relative flex flex-auto", children: [
                    /* @__PURE__ */ m(x9l, {}),
                    /* @__PURE__ */ m("div", { className: "bg-default dark:bg-muted ring-muted border-default sticky left-0 z-10 w-14 flex-none border-l border-r ring-1" }),
                    /* @__PURE__ */ de(
                      "div",
                      {
                        className: "grid flex-auto grid-cols-1 grid-rows-1 [--disabled-gradient-background:#F8F9FB] [--disabled-gradient-foreground:#E6E7EB] dark:[--disabled-gradient-background:#262626] dark:[--disabled-gradient-foreground:#393939]",
                        style: {
                          backgroundColor: "var(--disabled-gradient-background)",
                          background: "repeating-linear-gradient(-45deg, var(--disabled-gradient-background), var(--disabled-gradient-background) 2.5px, var(--disabled-gradient-foreground) 2.5px, var(--disabled-gradient-foreground) 5px)"
                        },
                        children: [
                          /* @__PURE__ */ m(
                            D9l,
                            {
                              hours: f,
                              numberOfGridStopsPerCell: d,
                              containerOffsetRef: o
                            }
                          ),
                          /* @__PURE__ */ m(M9l, { days: g }),
                          /* @__PURE__ */ m(
                            KZ,
                            {
                              offsetHeight: (v = o.current) == null ? void 0 : v.offsetHeight,
                              gridStopsPerDay: h,
                              children: g.map((y, w) => /* @__PURE__ */ m("li", { className: "relative", style: { gridColumnStart: w + 1 }, children: /* @__PURE__ */ m(R9l, { day: y }) }, y.toISOString()))
                            }
                          ),
                          /* @__PURE__ */ m(
                            KZ,
                            {
                              ref: r,
                              offsetHeight: (b = o.current) == null ? void 0 : b.offsetHeight,
                              gridStopsPerDay: h,
                              children: /* @__PURE__ */ m(nt, { children: [...Array(g.length)].map((y, w) => /* @__PURE__ */ m(
                                "li",
                                {
                                  className: "relative",
                                  style: {
                                    gridRow: `1 / span ${h}`
                                  },
                                  children: _ ? /* @__PURE__ */ m(
                                    T9l,
                                    {
                                      day: g[w],
                                      startHour: l,
                                      availableSlots: _
                                    },
                                    g[w].toISOString()
                                  ) : /* @__PURE__ */ m(nt, { children: [...Array(h)].map((N, M) => {
                                    const q = `${w}-${M}`;
                                    return /* @__PURE__ */ m(
                                      C9l,
                                      {
                                        day: g[w],
                                        gridCellIdx: M,
                                        totalGridCells: h,
                                        selectionLength: u - l,
                                        startHour: l,
                                        timezone: a
                                      },
                                      q
                                    );
                                  }) })
                                },
                                w
                              )) })
                            }
                          )
                        ]
                      }
                    )
                  ] })
                ]
              }
            )
          }
        )
      ]
    }
  ) });
}
const F9l = ({ children: e }) => /* @__PURE__ */ de(nt, { children: [
  /* @__PURE__ */ de("div", { className: "flex h-full flex-col items-center justify-center sm:hidden", children: [
    /* @__PURE__ */ m("h1", { className: "text-2xl font-bold", children: "Mobile not supported yet " }),
    /* @__PURE__ */ m("p", { className: "text-subtle", children: "Please use a desktop browser to view this page" })
  ] }),
  /* @__PURE__ */ m("div", { className: "hidden h-full sm:block", children: e })
] }), q9l = ({
  extraDays: e,
  schedule: t,
  isLoading: n,
  event: o
}) => {
  var g;
  const r = _n((f) => f.selectedDate), i = _n((f) => f.setSelectedTimeslot), a = _n((f) => f.selectedDuration), s = rv((f) => f.overlayBusyDates), c = zc("overlayCalendar") === "true" || (vr == null ? void 0 : vr.getItem("overlayCalendarSwitchDefault")), l = a || ((g = o == null ? void 0 : o.data) == null ? void 0 : g.length) || 30, u = ive({ schedule: t, eventDuration: l }), d = r ? ht(r).toDate() : ht().toDate(), _ = ht(d).add(e - 1, "day").toDate();
  yt(() => {
  }, [c]);
  const p = vn(() => !s || !c ? [] : s.map((f, h) => ({
    id: h,
    start: ht(f.start).toDate(),
    end: ht(f.end).toDate(),
    title: "Busy",
    options: {
      status: "ACCEPTED"
    }
  })), [s, c]);
  return /* @__PURE__ */ m("div", { className: "h-full [--calendar-dates-sticky-offset:66px]", children: /* @__PURE__ */ m(
    cve,
    {
      isPending: n,
      availableTimeslots: u,
      startHour: 0,
      endHour: 23,
      events: p,
      startDate: d,
      endDate: _,
      onEmptyCellClick: (f) => i(f.toISOString()),
      gridCellsPerHour: 60 / l,
      hoverEventDuration: l,
      hideHeader: !0
    }
  ) });
};
function lve(e, t) {
  const [n, o] = it(() => {
    const l = vr.getItem(e);
    return l ? new Set(JSON.parse(l)) : new Set(t);
  });
  return yt(() => {
    vr.setItem(e, JSON.stringify(Array.from(n)));
  }, [e, n]), { set: n, addValue: (l) => {
    o((u) => new Set(u).add(l));
  }, removeById: (l) => {
    o((u) => {
      const d = new Set(u);
      return d.forEach((_) => {
        _.externalId === l && d.delete(_);
      }), d;
    });
  }, toggleValue: (l) => {
    let u = /* @__PURE__ */ new Set();
    return o((d) => {
      const _ = new Set(d);
      let p = !1;
      return _.forEach((g) => {
        g.externalId === l.externalId && (p = !0, _.delete(g));
      }), p || _.add(l), u = _, _;
    }), u;
  }, hasItem: (l) => Array.from(n).some((u) => u.externalId === l.externalId), clearSet: () => {
    o(() => /* @__PURE__ */ new Set()), vr.removeItem(e);
  } };
}
const j9l = ({
  connectedCalendars: e,
  overlayBusyDates: t,
  onToggleCalendar: n
}) => {
  const { set: o, toggleValue: r, hasItem: i } = lve("toggledConnectedCalendars", []), [a, s] = it(!1), [c, l] = rv(
    (f) => [f.continueWithProviderModal, f.setContinueWithProviderModal],
    Xi
  ), [u, d] = rv(
    (f) => [f.calendarSettingsOverlayModal, f.setCalendarSettingsOverlayModal],
    Xi
  ), _ = rv((f) => f.setOverlayBusyDates), { timezone: p } = Mg();
  return yt(() => {
    if (t) {
      const f = ht(), $ = (f.tz(p).utcOffset() - f.utcOffset()) / 60, v = t.map((b) => ({
        ...b,
        start: ht(b.start).add($, "hours").toDate(),
        end: ht(b.end).add($, "hours").toDate()
      }));
      _(v);
    }
  }, [t]), yt(() => {
    e && o.size === 0 && !a && (e.forEach((f) => {
      var h;
      (h = f.calendars) == null || h.forEach(($) => {
        const v = { credentialId: f.credentialId, externalId: $.externalId };
        $.primary && r(v);
      });
    }), s(!0));
  }, [i, o, a]), {
    isOpenOverlayContinueModal: c,
    isOpenOverlaySettingsModal: u,
    handleCloseContinueModal: (f) => l(f),
    handleCloseSettingsModal: (f) => d(f),
    handleToggleConnectedCalendar: (f, h) => {
      const $ = r({
        credentialId: h,
        externalId: f
      });
      _([]), n($);
    },
    checkIsCalendarToggled: (f, h) => i({
      credentialId: h,
      externalId: f
    })
  };
};
function V9l(e) {
  const { t } = kt();
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(Ss, { open: e.open, onOpenChange: e.onClose, children: /* @__PURE__ */ de(
    Ya,
    {
      type: "creation",
      title: t("overlay_my_calendar"),
      description: t("overlay_my_calendar_toc"),
      children: [
        /* @__PURE__ */ m("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ m(
          Jt,
          {
            "data-testid": "overlay-calendar-continue-button",
            onClick: () => {
              e.onContinue();
            },
            className: "gap w-full items-center justify-center font-semibold",
            StartIcon: "calendar-search",
            children: t("continue_with", { appName: Kp })
          }
        ) }),
        /* @__PURE__ */ m(Wu, { children: /* @__PURE__ */ m(nt, {}) })
      ]
    }
  ) }) });
}
function Wj(e) {
  return /* @__PURE__ */ m(
    "ul",
    {
      "data-testid": "list",
      ...e,
      className: xe(
        "mx-0 rounded-sm sm:overflow-hidden ",
        // Add rounded top and bottom if roundContainer is true
        e.roundContainer && "[&>*:first-child]:rounded-t-md [&>*:last-child]:rounded-b-md ",
        !e.noBorderTreatment && "border-subtle divide-subtle divide-y rounded-md border border-l border-r ",
        e.className
      ),
      children: e.children
    }
  );
}
function B9l(e) {
  const { href: t, expanded: n, rounded: o = !0, ...r } = e, a = pt(
    t ? "a" : "li",
    {
      ...r,
      className: xe(
        "items-center bg-default min-w-0 flex-1 flex border-neutral-200 p-4 sm:mx-0 md:border md:p-4 xl:mt-0 border-subtle",
        n ? "my-2 border" : "border -mb-px last:mb-0",
        // Pass rounded false to not round the corners -> Useful when used in list we can use roundedContainer to create the right design
        o ? "rounded-md" : "rounded-none",
        e.className,
        (e.onClick || t) && "hover:bg-muted"
      ),
      "data-testid": "list-item"
    },
    e.children
  );
  return t ? /* @__PURE__ */ m(Ir, { passHref: !0, href: t, legacyBehavior: !0, children: a }) : a;
}
function U9l(e) {
  const { component: t = "span", ...n } = e;
  return pt(
    t,
    {
      ...n,
      className: xe("text-sm font-medium text-emphasis truncate", e.className),
      "data-testid": "list-item-title"
    },
    e.children
  );
}
function Y5(e) {
  const { component: t = "span", ...n } = e;
  return pt(
    t,
    {
      ...n,
      className: xe("text-sm text-subtle truncate prose", e.className),
      "data-testid": "list-item-text"
    },
    e.children
  );
}
const G9l = () => /* @__PURE__ */ m(Tq, { children: /* @__PURE__ */ de("div", { className: "border-subtle mt-3 space-y-4 rounded-xl border px-4 py-4 ", children: [
  /* @__PURE__ */ m(Yo, { className: "h-4 w-full" }),
  /* @__PURE__ */ m(Yo, { className: "h-4 w-full" }),
  /* @__PURE__ */ m(Yo, { className: "h-4 w-full" }),
  /* @__PURE__ */ m(Yo, { className: "h-4 w-full" })
] }) });
function W9l({
  connectedCalendars: e,
  isLoading: t,
  open: n,
  onClose: o,
  onClickNoCalendar: r,
  onToggleConnectedCalendar: i,
  checkIsCalendarToggled: a
}) {
  const { t: s } = kt(), c = Kr();
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(Ss, { open: n, onOpenChange: o, children: /* @__PURE__ */ de(
    Ya,
    {
      enableOverflow: !0,
      type: "creation",
      title: "Calendar Settings",
      className: "pb-4",
      description: s("view_overlay_calendar_events"),
      children: [
        /* @__PURE__ */ m("div", { className: "no-scrollbar max-h-full overflow-y-scroll ", children: t ? /* @__PURE__ */ m(G9l, {}) : /* @__PURE__ */ m(nt, { children: e.length === 0 ? /* @__PURE__ */ m(
          e$,
          {
            Icon: "calendar",
            headline: s("no_calendar_installed"),
            description: s("no_calendar_installed_description"),
            buttonText: s("add_a_calendar"),
            buttonOnClick: r
          }
        ) : /* @__PURE__ */ m(nt, { children: e.map((l) => /* @__PURE__ */ de(Ha, { children: [
          l.error && !l.calendars && /* @__PURE__ */ m(Us, { severity: "error", title: l.error.message }),
          (l == null ? void 0 : l.error) === void 0 && l.calendars && /* @__PURE__ */ de(B9l, { className: "flex-col rounded-md", children: [
            /* @__PURE__ */ de("div", {
              className: "flex w-full flex-1 items-center space-x-3 pb-4 rtl:space-x-reverse",
              // eslint-disable-next-line @next/next/no-img-element
              children: [
                l.integration.logo && /* @__PURE__ */ m(
                  "img",
                  {
                    className: xe(
                      "h-10 w-10",
                      l.integration.logo.includes("-dark") && "dark:invert"
                    ),
                    src: c ? `https://app.cal.com${l.integration.logo}` : l.integration.logo,
                    alt: `${l.integration.title} logo`
                  }
                ),
                /* @__PURE__ */ de("div", { className: "flex-grow truncate pl-2", children: [
                  /* @__PURE__ */ m(U9l, { component: "h3", className: "space-x-2 rtl:space-x-reverse", children: /* @__PURE__ */ m(Ir, { href: `/apps/${l.integration.slug}`, children: l.integration.name || l.integration.title }) }),
                  /* @__PURE__ */ m(Y5, { component: "p", children: l.primary.email })
                ] })
              ]
            }),
            /* @__PURE__ */ m("div", { className: "border-subtle w-full border-t pt-4", children: /* @__PURE__ */ m("ul", { className: "space-y-4", children: l.calendars.map((u, d) => {
              const _ = u.integrationTitle ?? `calendar-switch-${d}`;
              return /* @__PURE__ */ de("li", { className: "flex gap-3", children: [
                /* @__PURE__ */ m(
                  as,
                  {
                    id: _,
                    checked: a(u.externalId, l.credentialId),
                    onCheckedChange: () => {
                      i(u.externalId, l.credentialId);
                    }
                  }
                ),
                /* @__PURE__ */ m("label", { htmlFor: _, children: u.name })
              ] }, _);
            }) }) })
          ] })
        ] }, l.credentialId)) }) }) }),
        /* @__PURE__ */ m("div", { className: "mt-4 flex gap-2 self-end", children: /* @__PURE__ */ m(Gs, { children: s("done") }) })
      ]
    }
  ) }) });
}
function H9l({ enabled: e, hasSession: t, onStateChange: n }) {
  const { t: o } = kt(), r = rv((c) => c.setContinueWithProviderModal), i = rv(
    (c) => c.setCalendarSettingsOverlayModal
  ), a = _n((c) => c.layout), s = e;
  return yt(() => {
    !t && s && (n(!1), r(!0));
  }, [t, s, r, n]), /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "hidden gap-2",
        a === "week_view" || a === "column_view" ? "xl:flex" : "md:flex"
      ),
      children: [
        /* @__PURE__ */ de("div", { className: "flex items-center gap-2 pr-2", children: [
          /* @__PURE__ */ m(
            as,
            {
              "data-testid": "overlay-calendar-switch",
              checked: s,
              id: "overlayCalendar",
              onCheckedChange: (c) => {
                t ? n(c) : r(c);
              }
            }
          ),
          /* @__PURE__ */ m(
            "label",
            {
              htmlFor: "overlayCalendar",
              className: "text-emphasis text-sm font-medium leading-none hover:cursor-pointer",
              children: o("overlay_my_calendar")
            }
          )
        ] }),
        t && /* @__PURE__ */ m(
          Jt,
          {
            size: "base",
            "data-testid": "overlay-calendar-settings-button",
            variant: "icon",
            color: "secondary",
            StartIcon: "settings",
            onClick: () => {
              i(!0);
            }
          }
        )
      ]
    }
  );
}
const Y9l = ({
  connectedCalendars: e,
  overlayBusyDates: t,
  onToggleCalendar: n,
  isOverlayCalendarEnabled: o,
  loadingConnectedCalendar: r,
  handleClickNoCalendar: i,
  handleSwitchStateChange: a,
  handleClickContinue: s,
  hasSession: c
}) => {
  const l = Kr(), {
    handleCloseContinueModal: u,
    handleCloseSettingsModal: d,
    isOpenOverlayContinueModal: _,
    isOpenOverlaySettingsModal: p,
    handleToggleConnectedCalendar: g,
    checkIsCalendarToggled: f
  } = j9l({ connectedCalendars: e, overlayBusyDates: t, onToggleCalendar: n });
  return yt(() => {
    o && u(!1);
  }, [o, u]), l && (e == null ? void 0 : e.length) === 0 ? null : /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      H9l,
      {
        enabled: o,
        hasSession: c,
        onStateChange: a
      }
    ),
    !l && /* @__PURE__ */ m(
      V9l,
      {
        open: _ && !o,
        onClose: u,
        onContinue: s
      }
    ),
    /* @__PURE__ */ m(
      W9l,
      {
        connectedCalendars: e,
        open: p,
        onClose: d,
        isLoading: r,
        onToggleConnectedCalendar: g,
        onClickNoCalendar: () => {
          i();
        },
        checkIsCalendarToggled: f
      }
    )
  ] });
}, dE = (e) => {
  const t = "/o";
  return e.returnValue = t, t;
}, K9l = ({
  bookingId: e,
  onGoBack: t,
  expiryTime: n,
  instantVideoMeetingUrl: o,
  orgName: r
}) => {
  const { t: i } = kt(), [a, s] = it(d()), [c, l] = it(!1), u = Nr.useRouter();
  function d() {
    const p = ht(), f = ht(n).diff(p);
    return Math.max(f, 0);
  }
  yt(() => {
    if (!n)
      return;
    const p = setInterval(() => {
      s(d()), l(n && new Date(n) < /* @__PURE__ */ new Date());
    }, 1e3);
    return () => {
      clearInterval(p);
    };
  }, [n]);
  const _ = (p) => {
    const g = ht.duration(p), f = g.seconds();
    return `${g.minutes()}m ${f}s`;
  };
  return yt(() => {
    if (!n || c || o) {
      window.removeEventListener("beforeunload", dE);
      return;
    }
    return window.addEventListener("beforeunload", dE), () => {
      window.removeEventListener("beforeunload", dE);
    };
  }, [n, c, o]), yt(() => {
    o && (window.removeEventListener("beforeunload", dE), u.push(o));
  }, [o]), /* @__PURE__ */ m(Ss, { open: !!e && !!n, children: /* @__PURE__ */ m(Ya, { enableOverflow: !0, className: "py-8", children: /* @__PURE__ */ m("div", { children: c ? /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ m("p", { className: "font-medium", children: i("please_book_a_time_sometime_later") }),
    /* @__PURE__ */ m(
      Jt,
      {
        className: "mt-4",
        onClick: () => {
          t();
        },
        color: "primary",
        children: i("schedule_instead")
      }
    )
  ] }) : /* @__PURE__ */ de("div", { className: "text-center", children: [
    /* @__PURE__ */ m("p", { className: "font-medium", children: i("connecting_you_to_someone", { orgName: r }) }),
    /* @__PURE__ */ m("p", { className: "font-bold", children: i("please_do_not_close_this_tab") }),
    /* @__PURE__ */ m("p", { className: "mt-2 font-medium", children: i("please_schedule_future_call", {
      seconds: _(a)
    }) }),
    /* @__PURE__ */ m("div", { className: "mt-4 h-[414px]", children: /* @__PURE__ */ m("iframe", { className: "mx-auto h-full w-[276px] rounded-lg", src: "https://cal.games/" }) })
  ] }) }) }) });
}, ZZ = {
  calendar: "[grid-area:calendar]",
  main: "[grid-area:main]",
  meta: "[grid-area:meta]",
  timeslots: "[grid-area:timeslots]",
  header: "[grid-area:header]"
}, eg = Bt(function({ children: t, area: n, visible: o, className: r, ...i }, a) {
  const s = _n((l) => l.layout);
  let c;
  return typeof n == "string" ? c = ZZ[n] : c = ZZ[n[s] || n.default], !o && typeof o < "u" ? null : /* @__PURE__ */ m(t0.div, { ref: a, className: xe(c, r), layout: !0, ...i, children: t });
}), Z9l = ({ children: e, title: t }) => /* @__PURE__ */ m("div", { className: "mx-auto w-full max-w-2xl", children: /* @__PURE__ */ de("div", { className: "border-subtle bg-default dark:bg-muted overflow-hidden rounded-lg border p-10", children: [
  /* @__PURE__ */ m("h2", { className: "font-cal mb-4 text-3xl", children: t }),
  e
] }) }), X9l = () => {
  const { t: e } = kt();
  return /* @__PURE__ */ m(Z9l, { title: e("404_page_not_found"), children: /* @__PURE__ */ m("p", { className: "max-w-[50ch]", children: e("booker_event_not_found") }) });
}, J9l = (e) => {
  var t;
  return typeof document > "u" ? null : (t = document.cookie.split(";").find((n) => n.trim().startsWith(`${e}=`))) == null ? void 0 : t.split("=")[1];
}, Q9l = ({ percentage: e }) => {
  if (process.env.NEXT_PUBLIC_IS_E2E || e >= 100)
    return !0;
  const t = J9l("uid");
  if (!t)
    return !1;
  const n = t.slice(-4);
  return parseInt(n, 16) % 100 < e;
}, eUl = () => {
  const e = xt(
    Q9l({ percentage: hcc })
  );
  return yt(() => {
    console.log("QuickAvailabilityCheck feature enabled:", e.current);
  }, []), e.current;
}, K5 = (e) => e.length < 16 ? !1 : e[4] === "-" && e[7] === "-" && e[10] === "T" && e[13] === ":", tUl = ({
  slotTimeInIso: e,
  slotToCheckInIso: t
}) => {
  if (e === t)
    return !0;
  if (!K5(e) || !K5(t))
    return console.log("Invalid ISO string format detected", { slotTimeInIso: e, slotToCheckInIso: t }), !0;
  const n = e.slice(0, 16), o = t.slice(0, 16);
  return n === o;
};
function vR(e, t) {
  return e ? e.some((n) => tUl({ slotTimeInIso: n.time, slotToCheckInIso: t })) : !1;
}
function nUl({
  scheduleData: e,
  dateInGMT: t,
  slotToCheckInIso: n
}) {
  const o = ht(t).subtract(1, "day").format("YYYY-MM-DD"), r = ht(t).add(1, "day").format("YYYY-MM-DD"), i = e.slots[t], a = e.slots[o], s = e.slots[r];
  return !!(vR(i, n) || vR(a, n) || vR(s, n));
}
const oUl = ({
  scheduleData: e,
  slotToCheckInIso: t,
  quickAvailabilityChecks: n
}) => {
  if (n && n.some(
    (i) => i.utcStartIso === t && i.status !== "available"
  ))
    return !1;
  if (!e)
    return !0;
  const r = K5(t) ? t.split("T")[0] : null;
  return r ? nUl({
    scheduleData: e,
    dateInGMT: r,
    slotToCheckInIso: t
  }) : !0;
}, rUl = ({
  username: e,
  eventSlug: t,
  hideBranding: n = !1,
  entity: o,
  isInstantMeeting: r = !1,
  onGoBackInstantMeeting: i,
  onConnectNowInstantMeeting: a,
  onOverlayClickNoCalendar: s,
  onClickOverlayContinue: c,
  onOverlaySwitchStateChange: l,
  sessionUsername: u,
  rescheduleUid: d,
  hasSession: _,
  extraOptions: p,
  bookings: g,
  verifyEmail: f,
  slots: h,
  calendars: $,
  bookerForm: v,
  event: b,
  bookerLayout: y,
  schedule: w,
  verifyCode: N,
  isPlatform: M,
  orgBannerUrl: q,
  customClassNames: L,
  areInstantMeetingParametersSet: R = !1,
  userLocale: T,
  hasValidLicense: D,
  isBookingDryRun: A,
  renderCaptcha: S,
  hashedLink: E,
  confirmButtonDisabled: x,
  timeZones: k,
  eventMetaChildren: I,
  roundRobinHideOrgAndTeam: z,
  showNoAvailabilityDialog: F
}) => {
  var gn, kn, dt, Pt, cn, sn, ao, Ze, bt, Wt, xn;
  const P = Ef(), O = wge(), [V, U] = _n(
    (It) => [It.state, It.setState],
    Xi
  ), H = _n((It) => It.selectedDate), {
    shouldShowFormInDialog: J,
    hasDarkBackground: le,
    extraDays: ae,
    columnViewExtraDays: Y,
    isMobile: re,
    layout: ie,
    hideEventTypeDetails: _e,
    isEmbed: he,
    bookerLayouts: be
  } = y, [Q, me] = _n(
    (It) => [It.seatedEventData, It.setSeatedEventData],
    Xi
  ), { selectedTimeslot: ne, setSelectedTimeslot: pe, allSelectedTimeslots: ge } = h, [ve, Te] = _n(
    (It) => [It.dayCount, It.setDayCount],
    Xi
  ), Re = MA((gn = w == null ? void 0 : w.data) == null ? void 0 : gn.slots).filter(
    (It) => ht(H).diff(It, "day") <= 0
  ), Me = 7, et = Re.length < ae ? (ae - Re.length + 1) * Me : Re.length === ae ? Me : 0, st = Re.slice(0, ae + 1);
  Re.length !== 0 && (Y.current = Math.abs(ht(H).diff(st[st.length - 2], "day")) + et);
  const De = Math.abs(ht(H).diff(st[st.length - 1], "day")) + et, ze = _9l(ie, V), Pe = xt(null), je = eUl(), He = re ? "div" : Gel, { bookerFormErrorRef: Xe, key: at, formEmail: wt, bookingForm: Je, errors: vt } = v, {
    handleBookEvent: Ot,
    errors: Ft,
    loadingStates: wn,
    expiryTime: un,
    instantVideoMeetingUrl: pn,
    instantConnectCooldownMs: Dn
  } = g, Rn = Je.watch("cfToken"), {
    isEmailVerificationModalVisible: Ln,
    setEmailVerificationModalVisible: Yn,
    handleVerifyEmail: Qt,
    renderConfirmNotVerifyEmailButtonCond: fn,
    isVerificationCodeSending: qn
  } = f, {
    overlayBusyDates: Xn,
    isOverlayCalendarEnabled: Qn,
    connectedCalendars: In,
    loadingConnectedCalendar: $n,
    onToggleCalendar: uo
  } = $, go = xt(!1), Rr = kq(), qo = () => {
    re && !go.current && Pe.current && !Rr.disableAutoScroll && (Tol(Pe.current, he), go.current = !0);
  }, ho = Sol(
    Je,
    V,
    r,
    ie == io.WEEK_VIEW,
    (kn = b == null ? void 0 : b.data) == null ? void 0 : kn.bookingFields,
    (dt = b == null ? void 0 : b.data) == null ? void 0 : dt.locations
  ), Ut = !!(!process.env.NEXT_PUBLIC_IS_E2E && S && zM && Scc === "1" && (V === "booking" || V === "selecting_time" && ho)), Kt = (It) => {
    pe(It);
  };
  X4({ bookerState: V, slotsQuery: w }), yt(() => {
    if (b.isPending)
      return U("loading");
    if (!H)
      return U("selecting_date");
    if (!ne)
      return U("selecting_time");
    const It = !r && ie !== io.WEEK_VIEW;
    return U(ne && ho && It ? "selecting_time" : "booking");
  }, [b, H, ne, U, ho, ie, r]);
  const an = je ? ge.filter((It) => !oUl({
    scheduleData: (w == null ? void 0 : w.data) ?? null,
    slotToCheckInIso: It,
    quickAvailabilityChecks: h.quickAvailabilityChecks
  })) : [], Gn = zc("slot");
  yt(() => {
    pe(Gn || null);
  }, [Gn, pe]);
  const An = (It) => fn ? Ot(It) : Qt(), hn = vn(() => {
    var It, Jn, ur, er;
    return V === "booking" ? /* @__PURE__ */ m(
      Dcl,
      {
        timeslot: ne,
        shouldRenderCaptcha: Ut,
        onCancel: () => {
          pe(null), Dse && (w == null || w.invalidate()), Q.bookingUid && me({ ...Q, bookingUid: void 0, attendees: void 0 });
        },
        onSubmit: () => fn ? Ot() : Qt(),
        errorRef: Xe,
        errors: { ...vt, ...Ft },
        isTimeslotUnavailable: !r && an.includes(ne || ""),
        loadingStates: wn,
        renderConfirmNotVerifyEmailButtonCond: fn,
        bookingForm: Je,
        eventQuery: b,
        extraOptions: p,
        isVerificationCodeSending: qn,
        confirmButtonDisabled: x,
        classNames: {
          confirmButton: (It = L == null ? void 0 : L.confirmStep) == null ? void 0 : It.confirmButton,
          backButton: (Jn = L == null ? void 0 : L.confirmStep) == null ? void 0 : Jn.backButton
        },
        isPlatform: M,
        children: /* @__PURE__ */ m(nt, { children: !M && /* @__PURE__ */ m(
          K9l,
          {
            expiryTime: un,
            bookingId: parseInt(zc("bookingId") || "0"),
            instantVideoMeetingUrl: pn,
            onGoBack: () => {
              i();
            },
            orgName: (er = (ur = b.data) == null ? void 0 : ur.entity) == null ? void 0 : er.name
          }
        ) })
      },
      at
    ) : /* @__PURE__ */ m(nt, {});
  }, [
    Xe,
    pn,
    V,
    Je,
    Ft,
    b,
    un,
    p,
    vt,
    Ot,
    Qt,
    at,
    wn,
    i,
    fn,
    Q,
    me,
    pe,
    M,
    Ut,
    qn,
    an
  ]);
  return o.considerUnpublished && !d ? /* @__PURE__ */ m(Aol, { ...o }) : b.isSuccess && !b.data ? /* @__PURE__ */ m(X9l, {}) : V === "loading" ? null : /* @__PURE__ */ de(nt, { children: [
    b.data && !M ? /* @__PURE__ */ m(Zel, { eventType: b.data }) : /* @__PURE__ */ m(nt, {}),
    (A || Oj(P)) && /* @__PURE__ */ m(Jcl, { isEmbed: he }),
    /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          // In a popup embed, if someone clicks outside the main(having main class or main tag), it closes the embed
          "main",
          "text-default flex min-h-full w-full flex-col items-center",
          ie === io.MONTH_VIEW && !he && "my-20 ",
          ie === io.MONTH_VIEW ? "overflow-visible" : "overflow-clip",
          `${L == null ? void 0 : L.bookerWrapper}`
        ),
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              ref: ze,
              "data-testid": "booker-container",
              className: xe(
                ...d9l(ie, V, _e),
                "bg-default dark:bg-muted grid max-w-full items-start dark:[color-scheme:dark] sm:transition-[width] sm:duration-300 sm:motion-reduce:transition-none md:flex-row",
                // We remove border only when the content covers entire viewport. Because in embed, it can almost never be the case that it covers entire viewport, we show the border there
                (ie === io.MONTH_VIEW || he) && "border-subtle rounded-md",
                !he && "sm:transition-[width] sm:duration-300",
                he && ie === io.MONTH_VIEW && "border-booker sm:border-booker-width",
                !he && ie === io.MONTH_VIEW && "border-subtle border",
                `${L == null ? void 0 : L.bookerContainer}`
              ),
              children: /* @__PURE__ */ de(fge, { children: [
                !r && /* @__PURE__ */ m(
                  eg,
                  {
                    area: "header",
                    className: xe(
                      ie === io.MONTH_VIEW && "fixed top-4 z-10 ltr:right-4 rtl:left-4",
                      (ie === io.COLUMN_VIEW || ie === io.WEEK_VIEW) && "bg-default dark:bg-muted sticky top-0 z-10"
                    ),
                    children: M && ie === io.MONTH_VIEW ? /* @__PURE__ */ m(nt, {}) : /* @__PURE__ */ m(
                      rve,
                      {
                        isMyLink: e === u,
                        eventSlug: t,
                        enabledLayouts: be.enabledLayouts,
                        extraDays: ie === io.COLUMN_VIEW ? Y.current : ae,
                        isMobile: re,
                        nextSlots: De,
                        renderOverlay: () => he ? /* @__PURE__ */ m(nt, {}) : /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
                          Y9l,
                          {
                            isOverlayCalendarEnabled: Qn,
                            connectedCalendars: In,
                            loadingConnectedCalendar: $n,
                            overlayBusyDates: Xn,
                            onToggleCalendar: uo,
                            hasSession: _,
                            handleClickContinue: c,
                            handleSwitchStateChange: l,
                            handleClickNoCalendar: () => {
                              s();
                            }
                          }
                        ) })
                      }
                    )
                  }
                ),
                /* @__PURE__ */ m(He, { className: xe("relative z-10 flex [grid-area:meta]"), children: /* @__PURE__ */ de(
                  eg,
                  {
                    area: "meta",
                    className: "max-w-screen flex w-full flex-col md:w-[var(--booker-meta-width)]",
                    children: [
                      !_e && q && /* @__PURE__ */ m(
                        "img",
                        {
                          loading: "eager",
                          className: "-mb-9 h-16 object-cover object-top ltr:rounded-tl-md rtl:rounded-tr-md sm:h-auto",
                          alt: "org banner",
                          src: q
                        }
                      ),
                      !_e && /* @__PURE__ */ m(
                        m9l,
                        {
                          selectedTimeslot: ne,
                          classNames: {
                            eventMetaContainer: (Pt = L == null ? void 0 : L.eventMetaCustomClassNames) == null ? void 0 : Pt.eventMetaContainer,
                            eventMetaTitle: (cn = L == null ? void 0 : L.eventMetaCustomClassNames) == null ? void 0 : cn.eventMetaTitle,
                            eventMetaTimezoneSelect: (sn = L == null ? void 0 : L.eventMetaCustomClassNames) == null ? void 0 : sn.eventMetaTimezoneSelect
                          },
                          event: b.data,
                          isPending: b.isPending,
                          isPlatform: M,
                          isPrivateLink: !!E,
                          locale: T,
                          timeZones: k,
                          roundRobinHideOrgAndTeam: z,
                          children: I
                        }
                      ),
                      ie !== io.MONTH_VIEW && !(ie === "mobile" && V === "booking") && /* @__PURE__ */ m("div", { className: "mt-auto px-5 py-3", children: /* @__PURE__ */ m(
                        iZ,
                        {
                          classNames: L == null ? void 0 : L.datePickerCustomClassNames,
                          event: b,
                          slots: (ao = w == null ? void 0 : w.data) == null ? void 0 : ao.slots,
                          isLoading: w.isPending,
                          scrollToTimeSlots: qo,
                          showNoAvailabilityDialog: F
                        }
                      ) })
                    ]
                  }
                ) }, "meta"),
                /* @__PURE__ */ m(
                  eg,
                  {
                    area: "main",
                    className: "sticky top-0 ml-[-1px] h-full p-6 md:w-[var(--booker-main-width)] md:border-l",
                    ...lE,
                    visible: V === "booking" && !J,
                    children: hn
                  },
                  "book-event-form"
                ),
                /* @__PURE__ */ m(
                  eg,
                  {
                    area: "main",
                    visible: V !== "booking" && ie === io.MONTH_VIEW,
                    ...lE,
                    initial: "visible",
                    className: "md:border-subtle ml-[-1px] h-full flex-shrink px-5 py-3 md:border-l lg:w-[var(--booker-main-width)]",
                    children: /* @__PURE__ */ m(
                      iZ,
                      {
                        classNames: L == null ? void 0 : L.datePickerCustomClassNames,
                        event: b,
                        slots: (Ze = w == null ? void 0 : w.data) == null ? void 0 : Ze.slots,
                        isLoading: w.isPending,
                        scrollToTimeSlots: qo,
                        showNoAvailabilityDialog: F
                      }
                    )
                  },
                  "datepicker"
                ),
                /* @__PURE__ */ m(
                  eg,
                  {
                    area: "main",
                    visible: ie === io.WEEK_VIEW,
                    className: "border-subtle sticky top-0 ml-[-1px] h-full md:border-l",
                    ...lE,
                    children: /* @__PURE__ */ m(
                      q9l,
                      {
                        extraDays: ae,
                        schedule: w.data,
                        isLoading: w.isPending,
                        event: b
                      }
                    )
                  },
                  "large-calendar"
                ),
                /* @__PURE__ */ m(
                  eg,
                  {
                    area: { default: "main", month_view: "timeslots" },
                    visible: ie !== io.WEEK_VIEW && V === "selecting_time" || ie === io.COLUMN_VIEW,
                    className: xe(
                      "border-subtle rtl:border-default flex h-full w-full flex-col overflow-x-auto px-5 py-3 pb-0 rtl:border-r ltr:md:border-l",
                      ie === io.MONTH_VIEW && "h-full overflow-hidden md:w-[var(--booker-timeslots-width)]",
                      ie !== io.MONTH_VIEW && "sticky top-0"
                    ),
                    ref: Pe,
                    ...lE,
                    children: /* @__PURE__ */ m(
                      Dsl,
                      {
                        onAvailableTimeSlotSelect: Kt,
                        customClassNames: L == null ? void 0 : L.availableTimeSlotsCustomClassNames,
                        extraDays: ae,
                        limitHeight: ie === io.MONTH_VIEW,
                        schedule: w,
                        isLoading: w.isPending,
                        seatsPerTimeSlot: (bt = b.data) == null ? void 0 : bt.seatsPerTimeSlot,
                        unavailableTimeSlots: an,
                        showAvailableSeatsCount: (Wt = b.data) == null ? void 0 : Wt.seatsShowAvailabilityCount,
                        event: b,
                        loadingStates: wn,
                        renderConfirmNotVerifyEmailButtonCond: fn,
                        isVerificationCodeSending: qn,
                        onSubmit: An,
                        skipConfirmStep: ho,
                        shouldRenderCaptcha: Ut,
                        watchedCfToken: Rn,
                        confirmButtonDisabled: x,
                        confirmStepClassNames: L == null ? void 0 : L.confirmStep
                      }
                    )
                  },
                  "timeslots"
                )
              ] })
            }
          ),
          /* @__PURE__ */ m(
            f9l,
            {
              visible: V !== "booking" && ie === io.MONTH_VIEW && !re,
              dayCount: ve,
              isScheduleLoading: w.isLoading,
              onButtonClick: () => {
                Te(null);
              }
            }
          ),
          V !== "booking" && ((xn = b.data) == null ? void 0 : xn.showInstantEventConnectNowModal) && R && /* @__PURE__ */ m(
            "div",
            {
              className: xe(
                "animate-fade-in-up  z-40 my-2 opacity-0",
                ie === io.MONTH_VIEW && he ? "" : "fixed bottom-2"
              ),
              style: { animationDelay: "1s" },
              children: /* @__PURE__ */ m(
                v9l,
                {
                  event: b.data,
                  cooldownMs: Dn,
                  onConnectNow: () => {
                    a();
                  }
                }
              )
            }
          ),
          Ut && /* @__PURE__ */ m("div", { className: "mb-6 mt-auto pt-6", children: /* @__PURE__ */ m(
            itl,
            {
              appearance: "interaction-only",
              onVerify: (It) => {
                Je.setValue("cfToken", It);
              }
            }
          ) }),
          !n && (!M || O) && !Ut && /* @__PURE__ */ m(
            t0.span,
            {
              className: xe(
                "mb-6 mt-auto pt-6 [&_img]:h-[15px]",
                le ? "dark" : "",
                ie === io.MONTH_VIEW ? "block" : "hidden"
              ),
              children: /* @__PURE__ */ m(Xel, { logoOnly: !0, hasValidLicense: D })
            },
            "logo"
          )
        ]
      }
    ),
    /* @__PURE__ */ m(nt, { children: N && wt ? /* @__PURE__ */ m(
      Pge,
      {
        isOpenDialog: Ln,
        setIsOpenDialog: Yn,
        email: wt,
        isUserSessionRequiredToVerify: !1,
        verifyCodeWithSessionNotRequired: N.verifyCodeWithSessionNotRequired,
        verifyCodeWithSessionRequired: N.verifyCodeWithSessionRequired,
        error: N.error,
        resetErrors: N.resetErrors,
        isPending: N.isPending,
        setIsPending: N.setIsPending
      }
    ) : /* @__PURE__ */ m(nt, {}) }),
    /* @__PURE__ */ m(
      Zcl,
      {
        onCancel: () => pe(null),
        visible: V === "booking" && J,
        children: hn
      }
    ),
    /* @__PURE__ */ m(Vde, { position: "bottom-right" })
  ] });
}, iUl = (e) => /* @__PURE__ */ m(hel, { strict: !0, features: vel, children: /* @__PURE__ */ m(rUl, { ...e }) }), bR = (e) => Wp.find((t) => t === e), uve = (e) => {
  const [t, n] = _n(($) => [$.layout, $.setLayout], Xi), o = tm(), r = NC("(max-width: 768px)"), i = NC("(max-width: 1024px)"), a = kq(), s = o ? r ? "mobile" : bR(a.layout) || t : t, c = i ? uE[s].tablet : uE[s].desktop, l = U0c(), u = o && l !== "inline", d = xt(
    i ? uE[s].tablet : uE[s].desktop
  ), _ = e || Qse, p = o && bR(a.layout) || _.defaultLayout;
  yt(() => {
    r && s !== "mobile" ? n("mobile") : !r && s === "mobile" && n(p);
  }, [r, n, s, p]), yt(() => {
    var v;
    const $ = zc("layout");
    if (!r && !o && bR($) && ((v = _ == null ? void 0 : _.enabledLayouts) != null && v.length) && $ !== t) {
      const b = _.enabledLayouts.find((y) => y === $);
      b && n(b);
    }
  }, [_, n, t, o, r]);
  const f = {
    // mobile supports showing the Form without Dialog
    mobile: !o,
    // We don't show Dialog in month_view currently. Can be easily toggled though as it supports no-dialog Form
    month_view: !1,
    // week_view doesn't support no-dialog Form
    // When it's supported, disable it for embed
    week_view: !0,
    // column_view doesn't support no-dialog Form
    // When it's supported, disable it for embed
    column_view: !0
  }[s], h = o ? a.hideEventTypeDetails : !1;
  return {
    shouldShowFormInDialog: f,
    hasDarkBackground: u,
    extraDays: c,
    columnViewExtraDays: d,
    isMobile: r,
    isEmbed: o,
    isTablet: i,
    layout: s,
    defaultLayout: p,
    hideEventTypeDetails: h,
    bookerLayouts: _
  };
};
function aUl(e) {
  return Object.entries(e).sort(([t], [n]) => t.localeCompare(n)).map(([t, n]) => Array.isArray(n) ? `${t}:${n.sort().join(",")}` : `${t}:${n}`).join("|");
}
const yR = ({
  values: e,
  hasSession: t,
  stableHashExtraOptions: n
}) => `${Object.keys(e).length}_${t ? 1 : 0}_${e.bookingId ?? 0}_${n}`;
function sUl({
  eventType: e,
  rescheduleUid: t,
  isRescheduling: n,
  email: o,
  name: r,
  username: i,
  hasSession: a,
  extraOptions: s,
  prefillFormParams: c,
  clientId: l
}) {
  const u = aUl(s), [d, _] = it({
    values: {},
    key: ""
  }), p = Fu((f) => f.bookingData), g = Fu((f) => f.formValues);
  return yt(() => {
    (async function() {
      if (Object.keys(g).length) {
        _({
          values: g,
          key: yR({ values: g, hasSession: a, stableHashExtraOptions: u })
        });
        return;
      }
      if (!(e != null && e.bookingFields))
        return {};
      const h = await yol({
        bookingFields: e.bookingFields,
        view: t ? "reschedule" : "booking"
      }).parseAsync({
        ...s,
        name: c.name,
        // `guest` because we need to support legacy URL with `guest` query param support
        // `guests` because the `name` of the corresponding bookingField is `guests`
        guests: c.guests
      }), $ = {
        email: t && p && p.attendees.length > 0 ? p == null ? void 0 : p.attendees[0].email : h.email ? h.email : o ?? "",
        name: t && p && p.attendees.length > 0 ? p == null ? void 0 : p.attendees[0].name : h.name ? h.name : r ?? i ?? ""
      };
      if (l && ($.email = $.email.replace(`+${l}`, "")), !n) {
        const y = {
          responses: {}
        }, w = e.bookingFields.reduce((N, M) => ({
          ...N,
          [M.name]: h[M.name] || void 0
        }), {});
        y.responses = {
          ...w,
          name: $.name,
          email: $.email ?? ""
        }, _({
          values: y,
          key: yR({ values: y, hasSession: a, stableHashExtraOptions: u })
        });
      }
      if (!t && !p)
        return {};
      const v = {
        responses: {},
        bookingId: p == null ? void 0 : p.id
      }, b = e.bookingFields.reduce((y, w) => ({
        ...y,
        [w.name]: p == null ? void 0 : p.responses[w.name]
      }), {});
      v.responses = {
        ...b,
        name: $.name,
        email: $.email ?? ""
      }, _({
        values: v,
        key: yR({ values: v, hasSession: a, stableHashExtraOptions: u })
      });
    })();
  }, [
    e == null ? void 0 : e.bookingFields,
    g,
    n,
    p,
    p == null ? void 0 : p.id,
    t,
    o,
    r,
    i,
    c,
    // We need to have extraOptions as a dep so that any change in query params can update the form values, but extraOptions itself isn't stable and changes reference on every render
    u
  ]), d;
}
const cUl = ({
  event: e,
  sessionEmail: t,
  sessionName: n,
  sessionUsername: o,
  hasSession: r,
  extraOptions: i,
  prefillFormParams: a,
  clientId: s
}) => {
  const c = Fu((w) => w.rescheduleUid), l = Fu((w) => w.bookingData), { t: u } = kt(), d = xt(null), _ = oe.object({
    responses: e ? $ol({
      bookingFields: e.bookingFields,
      view: c ? "reschedule" : "booking"
    }) : (
      // Fallback until event is loaded.
      oe.object({})
    )
  }).passthrough(), p = !!c && !!l, { values: g, key: f } = sUl({
    eventType: e,
    rescheduleUid: c,
    isRescheduling: p,
    email: t,
    name: n,
    username: o,
    hasSession: r,
    extraOptions: i,
    prefillFormParams: a,
    clientId: s
  }), h = W_({
    defaultValues: g,
    resolver: K0(
      // Since this isn't set to strict we only validate the fields in the schema
      _,
      {},
      {
        // bookingFormSchema is an async schema, so inform RHF to do async validation.
        mode: "async"
      }
    )
  });
  yt(() => {
    h.reset(g);
  }, [f]);
  const $ = h.watch("responses.email"), v = h.watch("responses.name"), b = () => {
    if (h.clearErrors(), !e) {
      h.setError("globalError", { message: u("error_booking_event") });
      return;
    }
  }, y = {
    hasFormErrors: !!h.formState.errors.globalError,
    formErrors: h.formState.errors.globalError
  };
  return {
    bookingForm: h,
    bookerFormErrorRef: d,
    key: f,
    formEmail: $,
    formName: v,
    beforeVerifyEmail: b,
    formErrors: y,
    errors: y
  };
}, lUl = (e, t) => {
  const n = Number.isFinite(e), o = Number.isFinite(t);
  return !(!n || !o || e === t);
}, uUl = (e, t, n, o, r) => {
  const i = lUl(n, o), a = e === io.WEEK_VIEW, s = e === io.COLUMN_VIEW, c = t === "selecting_time";
  if (i && (s || !a && c && !r))
    return 2;
}, XZ = (e, t) => !(isNaN(e) || isNaN(t) || e === t), dUl = (e, t) => {
  const n = ht(e).isValid(), o = ht(t).startOf("month").add(2, "week"), r = ht().isSame(ht(t), "month");
  return !!(ht().isAfter(o) && (!n || r));
}, _Ul = (e, t, n, o, r, i, a) => e === io.WEEK_VIEW ? !!a && XZ(n, o) : e === io.COLUMN_VIEW ? XZ(n, r) : e === io.MONTH_VIEW || e === "mobile" ? dUl(t, i) : !1, dve = ({ date: e, month: t, bookerLayout: n, bookerState: o }) => {
  const r = ht(e).month(), i = ht(e).add(1, "month").month(), a = ht(e).add(n.extraDays, "day").month(), s = ht(e).add(n.columnViewExtraDays.current, "day").month(), c = _Ul(
    n.layout,
    e,
    r,
    a,
    s,
    t,
    n.extraDays
  ), l = uUl(
    n.layout,
    o,
    i,
    s,
    c
  );
  return {
    prefetchNextMonth: c,
    monthCount: l
  };
}, pUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => At.post("/bookings", o).then((r) => {
    if (r.data.status === Nn)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), mUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => At.post("/bookings/instant", o).then((r) => {
    if (r.data.status === Nn)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), fUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => At.post("/bookings/recurring", o).then((r) => r.data),
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), _ve = "user-booking", gUl = (e = {
  onSuccess: () => {
  },
  onError: () => {
  },
  uid: ""
}) => {
  const { isInit: t } = cr(), n = `/${rs.bookings}/${e.uid}/reschedule`;
  return mr({
    queryKey: [_ve, e.uid],
    queryFn: () => At.get(n).then((r) => {
      var a, s;
      if (r.data.status === Nn)
        return (a = e.onSuccess) == null || a.call(
          e,
          r.data.data
        ), r.data.data;
      const i = new Error(r.data.error.message);
      throw (s = e.onError) == null || s.call(e, i), i;
    }).catch((r) => {
      var i;
      (i = e.onError) == null || i.call(e, r);
    }),
    enabled: t && !!(e != null && e.uid)
  });
};
function hUl(e) {
  if (!e)
    return;
  const n = Object.fromEntries(
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].map((o) => [o, e.get(o) ?? void 0])
  );
  return Object.values(n).every((o) => o === void 0) ? void 0 : n;
}
const vUl = ({
  bookingForm: e,
  event: t,
  metadata: n,
  hashedLink: o,
  handleBooking: r,
  handleInstantBooking: i,
  handleRecBooking: a,
  locationUrl: s,
  routingFormSearchParams: c,
  isBookingDryRun: l
}) => {
  const u = Kr(), d = _n((k) => k.setFormValues), _ = _n((k) => k.selectedTimeslot), p = _n((k) => k.selectedDuration), { timezone: g } = Ku(), f = _n((k) => k.rescheduleUid), h = _n((k) => k.rescheduledBy), { t: $, i18n: v } = kt(), b = _n((k) => k.username), y = _n((k) => k.recurringEventCount), w = _n((k) => k.bookingData), N = _n((k) => k.seatedEventData), M = _n((k) => k.isInstantMeeting), q = _n((k) => k.org), L = _n((k) => k.teamMemberEmail), R = _n((k) => k.crmOwnerRecordType), T = _n((k) => k.crmAppSlug), D = _n((k) => k.crmRecordId), A = _n((k) => k.verificationCode), S = (k) => {
    const I = k != null && k.message ? $(k.message) : $("can_you_try_again");
    ti(I, "error");
  }, E = Nr.useSearchParams();
  return (k) => {
    var P, O, V, U;
    const I = e.getValues(), z = k ?? _, F = k && !u ? { onError: S } : void 0;
    if (z) {
      if (d({}), e.clearErrors(), !(t != null && t.data)) {
        e.setError("globalError", { message: $("error_booking_event") });
        return;
      }
      const H = t.data.isDynamic ? p || t.data.length : p && ((O = (P = t.data.metadata) == null ? void 0 : P.multipleDuration) != null && O.includes(p)) ? p : t.data.length, J = {
        values: I,
        duration: H,
        event: t.data,
        date: z,
        timeZone: g,
        language: v.language,
        rescheduleUid: f || void 0,
        rescheduledBy: h || void 0,
        bookingUid: w && w.uid || (N == null ? void 0 : N.bookingUid) || void 0,
        username: b || "",
        metadata: n,
        hashedLink: o,
        teamMemberEmail: L,
        crmOwnerRecordType: R,
        crmAppSlug: T,
        crmRecordId: D,
        orgSlug: q || void 0,
        routingFormSearchParams: c,
        isDryRunProp: l,
        verificationCode: A || void 0
      }, le = hUl(E);
      M ? i(U5(J), F) : (U = (V = t.data) == null ? void 0 : V.recurringEvent) != null && U.freq && y && !f ? a(
        zsl(J, y, le),
        F
      ) : r({ ...U5(J), locationUrl: s, tracking: le }, F), d({}), e.clearErrors();
    }
  };
}, bUl = "get-public-event", pve = ({ username: e, eventSlug: t, isTeamEvent: n, teamId: o, selectedDuration: r }) => {
  const { organizationId: i } = cr(), a = vn(() => yf(e ?? "").length > 1, [e]), s = `/atoms/${rs.eventTypes}/${t}/public`;
  return mr({
    queryKey: [bUl, e, t, n, o, i],
    queryFn: () => {
      const l = {
        isTeamEvent: n,
        teamId: o,
        username: yf(e ?? "").join("+")
      };
      return i !== 0 && (l.orgId = i), At == null ? void 0 : At.get(s, {
        params: l
      }).then((u) => {
        if (u.data.status === Nn)
          return a && r && u.data.data && (u.data.data.length = r), u.data.data;
        throw new Error(u.data.error.message);
      });
    }
  });
}, yUl = "get-available-slots", mve = ({
  enabled: e,
  ...t
}) => mr({
  queryKey: [
    yUl,
    t.startTime,
    t.endTime,
    t.eventTypeId,
    t.eventTypeSlug,
    t.isTeamEvent ?? !1,
    t.teamId ?? !1,
    t.usernameList,
    t.routedTeamMemberIds,
    t.skipContactOwner,
    t._shouldServeCache,
    t.teamMemberEmail
  ],
  queryFn: () => At.get("/slots/available", {
    params: t
  }).then((o) => {
    if (o.data.status === Nn)
      return o.data.data;
    throw new Error(o.data.error.message);
  }),
  enabled: e
}), $Ul = "get-calendars-busy-times", wUl = ({ onError: e, enabled: t, ...n }) => {
  var r;
  return mr({
    queryKey: [
      $Ul,
      ((r = n == null ? void 0 : n.calendarsToLoad) == null ? void 0 : r.length) ?? 0,
      n.dateFrom ?? "",
      n.dateTo ?? "",
      n.loggedInUsersTz
    ],
    queryFn: () => At.get("/calendars/busy-times", {
      params: n
    }).then((i) => {
      if (i.data.status === Nn)
        return i.data;
      throw e == null || e(), new Error(i.data.error.message);
    }),
    enabled: t && !!n.dateFrom && !!n.dateTo
  });
};
let JZ = null;
const kUl = () => {
  function e(n) {
    JZ = n;
  }
  function t() {
    return JZ;
  }
  return [t(), e];
}, SUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => At.delete("/slots/selected-slot", {
    params: o
  }).then((r) => {
    if (r.data.status === Nn)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), EUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => At.post("/slots/reserve", o).then((r) => {
    if (r.data.status === Nn)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), xUl = (e, {
  onReserveSlotSuccess: t,
  onReserveSlotError: n,
  onDeleteSlotSuccess: o,
  onDeleteSlotError: r,
  isBookingDryRun: i,
  handleSlotReservation: a
} = {}) => {
  var v;
  const s = _n((b) => b.selectedDuration), [c, l] = _n(
    (b) => [b.selectedTimeslot, b.setSelectedTimeslot],
    Xi
  ), [u, d] = kUl(), _ = EUl({
    onSuccess: (b) => {
      d(b.data), t == null || t(b);
    },
    onError: n
  }), p = _n((b) => b.seatedEventData), g = SUl({
    onSuccess: o,
    onError: r
  }), f = () => {
    e != null && e.data && g.mutate({ uid: u ?? void 0 });
  }, h = () => {
    var b, y;
    if ((b = e == null ? void 0 : e.data) != null && b.id && c && (s || (y = e == null ? void 0 : e.data) != null && y.length)) {
      if (a) {
        a(c);
        return;
      }
      _.mutate({
        slotUtcStartDate: ht(c).utc().format(),
        eventTypeId: e.data.id,
        slotUtcEndDate: ht(c).utc().add(s || e.data.length, "minutes").format(),
        _isDryRun: i,
        bookingUid: p.bookingUid || void 0
      });
    }
  }, $ = _n((b) => b.selectedTimeslot);
  return yt(() => {
    h();
    const b = setInterval(() => {
      h();
    }, parseInt(wcc) * 60 * 1e3 - 2e3);
    return () => {
      f(), clearInterval(b);
    };
  }, [(v = e == null ? void 0 : e.data) == null ? void 0 : v.id, $]), {
    selectedTimeslot: c,
    setSelectedTimeslot: l,
    setSlotReservationId: d,
    slotReservationId: u,
    handleReserveSlot: h,
    handleRemoveSlot: f,
    // TODO: implement slot no longer available feature
    allSelectedTimeslots: []
  };
}, fve = ({ onSuccess: e }) => {
  const [t, n] = it(!1), [o, r] = it(""), [i, a] = it(""), [s, c] = it(!1), l = Hr({
    mutationFn: (p) => At.post(
      "/atoms/verification/email/verify-code-authenticated",
      p
    ).then((g) => {
      var f;
      if (g.data.status === Nn)
        return g.data;
      throw new Error(((f = g.data.error) == null ? void 0 : f.message) || "Invalid verification code");
    }),
    onSuccess: (p) => {
      n(!1), c(p.data.verified), e(p.data.verified);
    },
    onError: (p) => {
      var g, f, h, $, v;
      n(!1), c(!1), (f = (g = p.error) == null ? void 0 : g.message) != null && f.includes("invalid") || ($ = (h = p.error) == null ? void 0 : h.message) != null && $.includes("Invalid") ? r("Code provided is invalid") : r(((v = p.error) == null ? void 0 : v.message) || "Verification failed");
    }
  }), u = Hr({
    mutationFn: (p) => At.post("/atoms/verification/email/verify-code", p).then((g) => {
      var f;
      if (g.data.status === Nn)
        return g.data;
      throw new Error(((f = g.data.error) == null ? void 0 : f.message) || "Invalid verification code");
    }),
    onSuccess: (p) => {
      n(!1), c(p.data.verified), e(p.data.verified);
    },
    onError: (p) => {
      var g, f, h, $, v;
      n(!1), c(!1), (f = (g = p.error) == null ? void 0 : g.message) != null && f.includes("invalid") || ($ = (h = p.error) == null ? void 0 : h.message) != null && $.includes("Invalid") ? r("Code provided is invalid") : r(((v = p.error) == null ? void 0 : v.message) || "Verification failed");
    }
  });
  return {
    verifyCodeWithSessionRequired: (p, g) => {
      l.mutate({ code: p, email: g });
    },
    verifyCodeWithSessionNotRequired: (p, g) => {
      u.mutate({ code: p, email: g });
    },
    isPending: t,
    setIsPending: n,
    error: o,
    value: i,
    hasVerified: s,
    setValue: a,
    setHasVerified: c,
    resetErrors: () => r("")
  };
};
function CUl(e, t) {
  const [n, o] = it(e);
  return yt(() => {
    const r = setTimeout(() => {
      o(e);
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [e, t]), n;
}
const gve = ({
  email: e,
  name: t,
  requiresBookerEmailVerification: n,
  onVerifyEmail: o
}) => {
  const [r, i] = it(!1), a = Fu((f) => f.verifiedEmail), s = Fu((f) => f.setVerifiedEmail), c = CUl(e, 600), { data: l } = Ev(), { data: u } = mr({
    queryKey: ["isEmailVerificationRequired", c],
    queryFn: () => {
      var f;
      return At == null ? void 0 : At.get("/atoms/verification/email/check", {
        params: {
          email: c,
          userSessionEmail: ((f = l == null ? void 0 : l.data) == null ? void 0 : f.email) || ""
        }
      }).then((h) => {
        if (h.data.status === Nn)
          return h.data.data;
        throw new Error(h.data.error.message);
      });
    },
    enabled: !!c
  }), d = Hr({
    mutationFn: (f) => At.post("/atoms/verification/email/send-code", f).then((h) => {
      var $;
      if (h.data.status === Nn)
        return h.data;
      throw new Error((($ = h.data.error) == null ? void 0 : $.message) || "Failed to send verification email");
    }),
    onSuccess: () => {
      i(!0);
    },
    onError: (f) => {
      console.error("Failed to send verification email:", f);
    }
  }), _ = () => {
    o == null || o(), d.mutate({
      email: e,
      username: typeof t == "string" ? t : t == null ? void 0 : t.firstName
    });
  }, p = d.isPending;
  return {
    handleVerifyEmail: _,
    isEmailVerificationModalVisible: r,
    setEmailVerificationModalVisible: i,
    setVerifiedEmail: s,
    renderConfirmNotVerifyEmailButtonCond: !!(!n && !u || e && a && a === e),
    isVerificationCodeSending: p
  };
}, TUl = (e) => {
  var ho, Ut, Kt, an, Gn, An, hn, zn, gn, kn, dt, Pt, cn, sn, ao, Ze, bt, Wt, xn;
  const {
    view: t = "MONTH_VIEW",
    bannerUrl: n,
    routingFormSearchParams: o,
    teamMemberEmail: r,
    crmAppSlug: i,
    crmOwnerRecordType: a,
    preventEventTypeRedirect: s,
    onBookerStateChange: c,
    allowUpdatingUrlParams: l = !1,
    confirmButtonDisabled: u,
    isBookingDryRun: d,
    handleSlotReservation: _,
    onTimeslotsLoaded: p,
    startTime: g,
    showNoAvailabilityDialog: f,
    silentlyHandleCalendarFailures: h = !1,
    hideEventMetadata: $ = !1
  } = e, v = io[t], { clientId: b } = cr(), y = e.isTeamEvent ? e.teamId : void 0, [w, N] = _n(
    (It) => [It.state, It.setState],
    Xi
  ), M = _n((It) => It.setSelectedDate), q = _n((It) => It.setSelectedDuration), L = _n((It) => It.setBookingData), R = _n((It) => It.setOrg), T = _n((It) => It.bookingData), D = _n((It) => It.setSelectedTimeslot), A = _n((It) => It.setMonth), S = _n((It) => It.selectedDuration), [E, x] = it(
    !!((ho = vr == null ? void 0 : vr.getItem) != null && ho.call(vr, "overlayCalendarSwitchDefault"))
  ), k = xt(null), I = bo(FT), z = Yt((It) => Object.fromEntries(
    Object.entries(It).filter(([Jn, ur]) => typeof ur != "function")
  ), []), F = vn(() => sXc(
    (It, Jn) => {
      const ur = k.current;
      (!ur || JSON.stringify(ur) !== JSON.stringify(It)) && (Jn(It), k.current = It);
    },
    50
  ), []);
  yt(() => {
    if (!c || !I)
      return;
    const It = I.subscribe((ur) => {
      const er = z(ur);
      F(er, c);
    }), Jn = z(I.getState());
    return c(Jn), k.current = Jn, () => {
      It(), F.cancel();
    };
  }, [c, z, F, I]), gUl({
    uid: e.rescheduleUid ?? e.bookingUid ?? "",
    onSuccess: (It) => {
      L(It);
    }
  });
  const P = qc(), O = vn(() => e.username ? hve(e.username) : "", [e.username]);
  yt(() => {
    q(e.duration ?? null);
  }, [e.duration]), yt(() => {
    var It;
    R(((It = e.entity) == null ? void 0 : It.orgSlug) ?? null);
  }, [(Ut = e.entity) == null ? void 0 : Ut.orgSlug]);
  const V = vn(() => yf(O ?? "").length > 1, [O]), U = pve({
    username: O,
    eventSlug: e.eventSlug,
    isTeamEvent: e.isTeamEvent,
    teamId: y,
    selectedDuration: S
  }), H = uve((an = (Kt = U.data) == null ? void 0 : Kt.profile) == null ? void 0 : an.bookerLayouts);
  mce({
    ...e,
    teamMemberEmail: r,
    crmAppSlug: i,
    crmOwnerRecordType: a,
    crmRecordId: e.crmRecordId,
    eventId: (Gn = U == null ? void 0 : U.data) == null ? void 0 : Gn.id,
    rescheduleUid: e.rescheduleUid ?? null,
    bookingUid: e.bookingUid ?? null,
    layout: v,
    org: (An = e.entity) == null ? void 0 : An.orgSlug,
    username: O,
    bookingData: T,
    isPlatform: !0,
    allowUpdatingUrlParams: l
  }), fF({
    ...e,
    teamMemberEmail: r,
    crmAppSlug: i,
    crmOwnerRecordType: a,
    crmRecordId: e.crmRecordId,
    eventId: (hn = U == null ? void 0 : U.data) == null ? void 0 : hn.id,
    rescheduleUid: e.rescheduleUid ?? null,
    bookingUid: e.bookingUid ?? null,
    layout: v,
    org: (zn = e.entity) == null ? void 0 : zn.orgSlug,
    username: O,
    bookingData: T,
    isPlatform: !0,
    allowUpdatingUrlParams: l
  });
  const [J] = _n((It) => [It.dayCount, It.setDayCount], Xi), le = _n((It) => It.selectedDate), ae = _n((It) => It.month), Y = _n((It) => It.eventSlug), { data: re } = Ev(), ie = !!re, { name: _e, guests: he, ...be } = e.defaultFormValues ?? {}, Q = vn(() => _e || (be.firstName ? `${be.firstName} ${be.lastName}` : null), [_e, be]), me = vn(() => ({
    name: Q,
    guests: he ?? []
  }), [_e, he]), ne = vn(() => be, [be]), pe = ht(le).format("YYYY-MM-DD"), { prefetchNextMonth: ge, monthCount: ve } = dve({
    date: pe,
    month: ae,
    bookerLayout: H,
    bookerState: w
  }), { timezone: Te } = Mg(), [Re, Me] = Rj({
    month: ae,
    monthCount: ve,
    dayCount: J,
    prefetchNextMonth: ge,
    selectedDate: le
  }), et = g && ht(g).isAfter(ht(Re)) ? ht(g).toISOString() : Re, st = Me, [De, ze] = it({});
  yt(() => {
    var Ka, Wc;
    const It = o ? new URLSearchParams(o) : new URLSearchParams(window.location.search), Jn = Nj(It), ur = It.get("cal.skipContactOwner") === "true", er = It == null ? void 0 : It.get("cal.cache"), ya = er ? er === "true" : void 0, Ai = ((Ka = It == null ? void 0 : It.get("cal.isBookingDryRun")) == null ? void 0 : Ka.toLowerCase()) === "true" || ((Wc = It == null ? void 0 : It.get("cal.sandbox")) == null ? void 0 : Wc.toLowerCase()) === "true";
    ze({
      ...ur ? { skipContactOwner: ur } : {},
      ...Jn ? { routedTeamMemberIds: Jn } : {},
      ...ya ? { _shouldServeCache: ya } : {},
      ...Ai ? { isBookingDryRun: Ai } : {}
    });
  }, [o]);
  const Pe = mve({
    usernameList: yf(O),
    eventTypeId: ((gn = U == null ? void 0 : U.data) == null ? void 0 : gn.id) ?? 0,
    startTime: et,
    endTime: st,
    timeZone: Te,
    duration: S ?? void 0,
    rescheduleUid: e.rescheduleUid,
    teamMemberEmail: r ?? void 0,
    ...e.isTeamEvent ? {
      isTeamEvent: e.isTeamEvent,
      teamId: y
    } : {},
    enabled: !!(y || O) && !!ae && !!Te && !(U != null && U.isPending) && !!((kn = U == null ? void 0 : U.data) != null && kn.id),
    orgSlug: ((dt = e.entity) == null ? void 0 : dt.orgSlug) ?? void 0,
    eventTypeSlug: V ? "dynamic" : Y || "",
    _silentCalendarFailures: h,
    ...De
  });
  yt(() => {
    Pe.data && !Pe.isPending && !Pe.error && p && p(Pe.data.slots);
  }, [Pe.data, Pe.isPending, Pe.error, p]);
  const je = cUl({
    event: U == null ? void 0 : U.data,
    sessionEmail: (Pt = re == null ? void 0 : re.data) != null && Pt.email && b ? re.data.email.replace(`+${b}`, "") : (cn = re == null ? void 0 : re.data) == null ? void 0 : cn.email,
    sessionUsername: (sn = re == null ? void 0 : re.data) == null ? void 0 : sn.username,
    sessionName: (ao = re == null ? void 0 : re.data) == null ? void 0 : ao.username,
    hasSession: ie,
    extraOptions: ne ?? {},
    prefillFormParams: me,
    clientId: b
  }), {
    mutate: He,
    isPending: Xe,
    error: at,
    isError: wt
  } = pUl({
    onSuccess: (It) => {
      var Jn, ur, er, ya, Ai;
      (Jn = It == null ? void 0 : It.data) != null && Jn.isDryRun && ((ur = e == null ? void 0 : e.onDryRunSuccess) == null || ur.call(e)), Pe.refetch(), (er = e.onCreateBookingSuccess) == null || er.call(e, It), !s && ((ya = U == null ? void 0 : U.data) != null && ya.successRedirectUrl) && (window.location.href = (Ai = U == null ? void 0 : U.data) == null ? void 0 : Ai.successRedirectUrl);
    },
    onError: e.onCreateBookingError
  }), {
    mutate: Je,
    isPending: vt,
    error: Ot,
    isError: Ft
  } = fUl({
    onSuccess: (It) => {
      var Jn, ur, er, ya, Ai, Ka;
      (ur = (Jn = It == null ? void 0 : It.data) == null ? void 0 : Jn[0]) != null && ur.isDryRun && ((er = e == null ? void 0 : e.onDryRunSuccess) == null || er.call(e)), Pe.refetch(), (ya = e.onCreateRecurringBookingSuccess) == null || ya.call(e, It), (Ai = U == null ? void 0 : U.data) != null && Ai.successRedirectUrl && (window.location.href = (Ka = U == null ? void 0 : U.data) == null ? void 0 : Ka.successRedirectUrl);
    },
    onError: e.onCreateRecurringBookingError
  }), {
    mutate: wn,
    isPending: un,
    error: pn,
    isError: Dn
  } = mUl({
    onSuccess: (It) => {
      var Jn;
      Pe.refetch(), (Jn = e.onCreateInstantBookingSuccess) == null || Jn.call(e, It);
    },
    onError: e.onCreateInstantBookingError
  }), Rn = xUl(U, {
    onReserveSlotSuccess: e.onReserveSlotSuccess,
    onReserveSlotError: e.onReserveSlotError,
    onDeleteSlotSuccess: e.onDeleteSlotSuccess,
    onDeleteSlotError: e.onDeleteSlotError,
    isBookingDryRun: e.isBookingDryRun ? e.isBookingDryRun : De == null ? void 0 : De.isBookingDryRun,
    handleSlotReservation: _
  }), Ln = gve({
    email: je.formEmail,
    name: je.formName,
    requiresBookerEmailVerification: (Ze = U == null ? void 0 : U.data) == null ? void 0 : Ze.requiresBookerEmailVerification,
    onVerifyEmail: je.beforeVerifyEmail
  }), Yn = fve({
    onSuccess: () => {
      je.formEmail && (Ln.setVerifiedEmail(je.formEmail), Ln.setEmailVerificationModalVisible(!1), go());
    }
  }), { data: Qt, isPending: fn } = Uy({
    enabled: ie
  }), qn = Qt, { set: Xn, clearSet: Qn } = lve("toggledConnectedCalendars", []), [In, $n] = it(
    Array.from(Xn).map((It) => ({
      credentialId: It.credentialId,
      externalId: It.externalId
    }))
  ), { data: uo } = wUl({
    loggedInUsersTz: Te,
    dateFrom: le,
    dateTo: le,
    calendarsToLoad: In,
    onError: () => {
      Qn();
    },
    enabled: !!(ie && E && (In == null ? void 0 : In.length) > 0)
  }), go = vUl({
    event: U,
    bookingForm: je.bookingForm,
    hashedLink: e.hashedLink,
    metadata: e.metadata ?? {},
    handleBooking: (e == null ? void 0 : e.handleCreateBooking) ?? He,
    handleInstantBooking: wn,
    handleRecBooking: Je,
    locationUrl: e.locationUrl,
    routingFormSearchParams: o,
    isBookingDryRun: d ?? (De == null ? void 0 : De.isBookingDryRun)
  }), Rr = Yt(
    (It) => {
      x(It), It ? vr == null || vr.setItem("overlayCalendarSwitchDefault", "true") : vr == null || vr.removeItem("overlayCalendarSwitchDefault");
    },
    [x]
  ), qo = vn(
    () => ht(e.selectedDate).format("YYYY-MM-DD"),
    [e.selectedDate]
  );
  return yt(() => {
    M({ date: qo, omitUpdatingParams: !0 });
  }, [qo]), yt(() => () => {
    Rn.handleRemoveSlot(), N("loading"), M({ date: null }), D(null), q(null), R(null), A(null), e.rescheduleUid && (P.removeQueries({
      queryKey: [_ve, e.rescheduleUid],
      exact: !0
    }), L(null));
  }, []), yt(() => {
    var It;
    E && t === "MONTH_VIEW" && (vr == null || vr.removeItem("overlayCalendarSwitchDefault")), x(!!((It = vr == null ? void 0 : vr.getItem) != null && It.call(vr, "overlayCalendarSwitchDefault")));
  }, [t, E]), /* @__PURE__ */ m(is, { customClassName: (bt = e == null ? void 0 : e.customClassNames) == null ? void 0 : bt.atomsWrapper, children: /* @__PURE__ */ m(
    iUl,
    {
      timeZones: e.timeZones,
      teamMemberEmail: r,
      crmAppSlug: i,
      crmOwnerRecordType: a,
      customClassNames: e.customClassNames,
      eventSlug: e.eventSlug,
      username: O,
      showNoAvailabilityDialog: f,
      entity: ((Wt = U == null ? void 0 : U.data) == null ? void 0 : Wt.entity) ?? {
        considerUnpublished: !1,
        orgSlug: void 0,
        teamSlug: void 0,
        name: void 0
      },
      rescheduleUid: e.rescheduleUid ?? null,
      rescheduledBy: e.rescheduledBy ?? null,
      bookingUid: e.bookingUid ?? null,
      isRedirect: !1,
      confirmButtonDisabled: u,
      fromUserNameRedirected: "",
      hasSession: ie,
      onGoBackInstantMeeting: function() {
        throw new Error("Function not implemented.");
      },
      onConnectNowInstantMeeting: function() {
        throw new Error("Function not implemented.");
      },
      onOverlayClickNoCalendar: function() {
        throw new Error("Function not implemented.");
      },
      onClickOverlayContinue: function() {
        throw new Error("Function not implemented.");
      },
      onOverlaySwitchStateChange: Rr,
      extraOptions: ne ?? {},
      bookings: {
        handleBookEvent: (It) => {
          go(It);
        },
        expiryTime: void 0,
        bookingForm: je.bookingForm,
        bookerFormErrorRef: je.bookerFormErrorRef,
        errors: {
          hasDataErrors: wt || Ft || Dn,
          dataErrors: at || Ot || pn
        },
        loadingStates: {
          creatingBooking: Xe,
          creatingRecurringBooking: vt,
          creatingInstantBooking: un
        },
        instantVideoMeetingUrl: void 0
      },
      slots: Rn,
      calendars: {
        overlayBusyDates: uo == null ? void 0 : uo.data,
        isOverlayCalendarEnabled: E,
        connectedCalendars: (qn == null ? void 0 : qn.connectedCalendars) || [],
        loadingConnectedCalendar: fn,
        onToggleCalendar: (It) => {
          const Jn = Array.from(It ?? []);
          $n(Jn);
        }
      },
      verifyEmail: Ln,
      bookerForm: je,
      event: U,
      schedule: Pe,
      orgBannerUrl: n ?? ((xn = U.data) == null ? void 0 : xn.bannerUrl),
      bookerLayout: { ...H, hideEventTypeDetails: $ },
      verifyCode: Yn,
      isPlatform: !0,
      hasValidLicense: !0,
      isBookingDryRun: d ?? (De == null ? void 0 : De.isBookingDryRun),
      eventMetaChildren: e.eventMetaChildren,
      roundRobinHideOrgAndTeam: e.roundRobinHideOrgAndTeam
    }
  ) });
}, QZ = (e) => /* @__PURE__ */ m(Wy, { children: /* @__PURE__ */ m(TUl, { ...e }) });
function hve(e) {
  return typeof e == "string" ? e : e.join("+");
}
const AUl = "use-event-types", hsu = (e) => {
  const t = `/${rs.eventTypes}?username=${e}`;
  return mr({
    queryKey: [AUl, e],
    queryFn: () => At == null ? void 0 : At.get(t).then((n) => {
      if (n.data.status === Nn)
        return n.data.data;
      throw new Error(n.data.error.message);
    })
  });
}, IUl = "use-team-event-types", vsu = (e) => {
  const { organizationId: t } = cr(), n = `/organizations/${t}/teams/${e}/event-types`;
  return mr({
    queryKey: [IUl, t, e],
    queryFn: () => At == null ? void 0 : At.get(n).then((o) => {
      if (o.data.status === Nn)
        return o.data.data;
      throw new Error(o.data.error.message);
    }),
    enabled: !!t && !!e
  });
}, OUl = "use-event-type", NUl = (e, t, n) => {
  const o = e, r = t, i = vn(() => yf(o ?? "").length > 1, [o]);
  return mr({
    queryKey: [OUl, e, t],
    queryFn: async () => {
      if (!n)
        return i ? At.get(
          `/${rs.eventTypes}?usernames=${encodeURIComponent(yf(e).join(","))}`
        ).then((s) => {
          if (s.data.status === Nn)
            return s.data.data;
          throw new Error(s.data.error.message);
        }) : At.get(
          `/${rs.eventTypes}?username=${o}&eventSlug=${r}`
        ).then((s) => {
          if (s.data.status === Nn)
            return s.data.data;
          throw new Error(s.data.error.message);
        });
    }
  });
}, bsu = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => At.post(`/bookings/${o.uid}/cancel`, o).then((r) => {
    if (r.data.status === Nn)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === Nn ? e == null || e() : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), ysu = (e) => {
  const t = `/${rs.bookings}/${e}`, n = {
    [Fy]: qre
  };
  return mr({
    queryKey: ["use-booking", e],
    queryFn: async () => At.get(t, { headers: n }).then((r) => {
      var i, a;
      if (r.data.status === Nn)
        return r.data.data;
      throw new Error((a = (i = r.data) == null ? void 0 : i.error) == null ? void 0 : a.message);
    }),
    enabled: !!e
  });
}, zUl = "use-bookings", RUl = (e) => {
  const t = `/${rs.bookings}`, n = {
    [Fy]: qre
  };
  return mr({
    queryKey: [zUl, ...Hj(e)],
    queryFn: async () => At.get(t, {
      params: e,
      headers: n
    }).then((r) => {
      var i, a;
      if (r.data.status === Nn)
        return r.data.data;
      throw new Error((a = (i = r.data) == null ? void 0 : i.error) == null ? void 0 : a.message);
    })
  });
};
function Hj(e) {
  return [
    e.status,
    e.attendeeEmail,
    e.attendeeName,
    e.eventTypeIds,
    e.eventTypeId,
    e.teamsIds,
    e.teamId,
    e.afterStart,
    e.beforeEnd,
    e.afterCreatedAt,
    e.beforeCreatedAt,
    e.afterUpdatedAt,
    e.beforeUpdatedAt,
    e.sortStart,
    e.sortEnd,
    e.sortCreated,
    e.sortUpdatedAt,
    e.take,
    e.skip
  ];
}
const vve = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  onCheckError: r,
  redir: i,
  initialData: a,
  isMultiCalendar: s = !1,
  tooltipSide: c,
  tooltip: l,
  isClickable: u,
  isDryRun: d
}) => {
  const { t: _ } = kt();
  return /* @__PURE__ */ m(
    sse,
    {
      label: e || _("outlook_connect_atom_label"),
      alreadyConnectedLabel: t || _("outlook_connect_atom_already_connected_label"),
      loadingLabel: n || _("outlook_connect_atom_loading_label"),
      calendar: pEe,
      className: o,
      onCheckError: r,
      redir: i,
      initialData: a,
      isMultiCalendar: s,
      tooltipSide: c,
      tooltip: l,
      isClickable: u,
      isDryRun: d
    }
  );
}, bve = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  initialData: r,
  isMultiCalendar: i = !1,
  tooltip: a,
  tooltipSide: s = "bottom",
  isClickable: c,
  onSuccess: l,
  isDryRun: u = !1
}) => {
  const { t: d } = kt(), _ = W_({
    defaultValues: {
      username: "",
      password: ""
    }
  }), { toast: p } = wf(), { allowConnect: g, checked: f, refetch: h } = ase({
    calendar: "apple",
    initialData: r
  }), [$, v] = it(!1);
  let b = e || d("apple_connect_atom_label");
  const { mutate: y, isPending: w } = Rsc({
    onSuccess: (q) => {
      q.status === Nn && (_.reset(), v(!1), h(), p({
        description: "Calendar credentials added successfully"
      }), l == null || l());
    },
    onError: (q) => {
      p({
        description: `Error: ${q}`
      });
    }
  }), N = !f, M = N || !g;
  return N ? b = n || d("apple_connect_atom_loading_label") : g || (b = t || d("apple_connect_atom_already_connected_label")), /* @__PURE__ */ m(is, { children: /* @__PURE__ */ de($F, { open: $, children: [
    /* @__PURE__ */ m(Sce, { asChild: !0, children: /* @__PURE__ */ de(nt, { children: [
      i && /* @__PURE__ */ m(
        Jt,
        {
          StartIcon: "calendar-days",
          color: "primary",
          disabled: c ? !1 : N,
          tooltip: a || /* @__PURE__ */ m(cse, { calendarInstance: "apple" }),
          tooltipSide: s,
          tooltipOffset: 10,
          tooltipClassName: "p-0 text-inherit bg-inherit",
          className: ar("", !M && "cursor-pointer", "border-none md:rounded-md", o),
          onClick: () => v(!0),
          children: b
        }
      ),
      !i && /* @__PURE__ */ m(
        Jt,
        {
          StartIcon: "calendar-days",
          color: "primary",
          disabled: M,
          className: ar(
            "",
            M && "cursor-not-allowed",
            !M && "cursor-pointer",
            "border-none md:rounded-md",
            o
          ),
          onClick: () => v(!0),
          children: b
        }
      )
    ] }) }),
    /* @__PURE__ */ de(kF, { className: "bg-default text-default", children: [
      /* @__PURE__ */ de(zce, { children: [
        /* @__PURE__ */ m(Rce, { children: "Connect to Apple Server" }),
        /* @__PURE__ */ de(Pce, { children: [
          "Generate an app specific password to use with Cal.com at",
          " ",
          /* @__PURE__ */ m("span", { className: "font-bold", children: "https://appleid.apple.com/account/manage" }),
          ". Your credentials will be stored and encrypted."
        ] })
      ] }),
      /* @__PURE__ */ de(
        Y_,
        {
          form: _,
          handleSubmit: async (q) => {
            const { username: L, password: R } = q;
            u ? (_.reset(), v(!1), p({
              description: "Calendar credentials added successfully"
            }), l == null || l()) : await y({ calendar: "apple", username: L, password: R });
          },
          children: [
            /* @__PURE__ */ de(
              "fieldset",
              {
                className: "space-y-4",
                disabled: _.formState.isSubmitting,
                "data-testid": "apple-calendar-form",
                children: [
                  /* @__PURE__ */ m(
                    xr,
                    {
                      required: !0,
                      type: "text",
                      ..._.register("username"),
                      label: "Apple ID",
                      placeholder: "appleid@domain.com",
                      "data-testid": "apple-calendar-email"
                    }
                  ),
                  /* @__PURE__ */ m(
                    Qbc,
                    {
                      required: !0,
                      ..._.register("password"),
                      label: "Password",
                      placeholder: "•••••••••••••",
                      autoComplete: "password",
                      "data-testid": "apple-calendar-password"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ de("div", { className: "mt-5 justify-end space-x-2 rtl:space-x-reverse sm:mt-4 sm:flex", children: [
              /* @__PURE__ */ m(
                Jt,
                {
                  disabled: w,
                  type: "button",
                  color: "secondary",
                  className: "md:rounded-md",
                  onClick: () => v(!1),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ m(
                Jt,
                {
                  disabled: w,
                  type: "submit",
                  className: "border-none md:rounded-md",
                  loading: _.formState.isSubmitting,
                  "data-testid": "apple-calendar-login-button",
                  children: "Save"
                }
              )
            ] })
          ]
        }
      )
    ] })
  ] }) });
}, $su = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppleCalendar: bve,
  GoogleCalendar: lse,
  OutlookCalendar: vve
}, Symbol.toStringTag, { value: "Module" })), PUl = ({ routingFormUrl: e }) => vn(() => {
  if (e) {
    const n = new URL(e), o = n.pathname.split("/");
    if (o.length < 2)
      throw new Error("Invalid routing form url.");
    const r = o[o.length - 1], i = o[1] === "team", a = i ? void 0 : o[1], s = n.searchParams;
    if (!r)
      throw new Error("Event type slug is not defined within the routing form url");
    if (!i && !a)
      throw new Error("username not defined within the routing form url");
    const c = {
      ...s.get("firstName") && {
        firstName: s.get("firstName") ?? void 0
      },
      ...s.get("lastName") && {
        lastName: s.get("lastName") ?? void 0
      },
      ...s.get("name") && {
        name: s.get("name") ?? void 0
      },
      ...s.get("email") && {
        email: s.get("email") ?? void 0
      },
      ...s.get("notes") && {
        notes: s.get("notes") ?? void 0
      },
      ...s.get("rescheduleReason") && {
        rescheduleReason: s.get("rescheduleReason") ?? void 0
      },
      ...s.get("guests") && {
        guests: s.getAll("guests") ?? void 0
      }
    };
    return { ...{
      organizationId: s.get("cal.orgId") ? Number(s.get("cal.orgId")) : void 0,
      teamId: s.get("cal.teamId") ? Number(s.get("cal.teamId")) : void 0,
      username: a,
      eventTypeSlug: r,
      ...s.get("cal.routedTeamMemberIds") && {
        "cal.routedTeamMemberIds": s.get("cal.routedTeamMemberIds") ?? void 0
      },
      ...s.get("cal.reroutingFormResponses") && {
        "cal.reroutingFormResponses": s.get("cal.reroutingFormResponses") ?? void 0
      },
      ...s.get("cal.skipContactOwner") && {
        "cal.skipContactOwner": s.get("cal.skipContactOwner") ?? void 0
      },
      ...s.get("cal.isBookingDryRun") && {
        "cal.isBookingDryRun": s.get("cal.isBookingDryRun") ?? void 0
      },
      ...s.get("cal.cache") && {
        "cal.cache": s.get("cal.cache") ?? void 0
      },
      ...s.get("cal.routingFormResponseId") && {
        "cal.routingFormResponseId": s.get("cal.routingFormResponseId") ?? void 0
      },
      ...s.get("cal.salesforce.rrSkipToAccountLookupField") && {
        "cal.salesforce.rrSkipToAccountLookupField": s.get("cal.salesforce.rrSkipToAccountLookupField") ?? void 0
      },
      ...s.get("cal.teamMemberEmail") && {
        teamMemberEmail: s.get("cal.teamMemberEmail") ?? void 0
      },
      ...s.get("cal.crmOwnerRecordType") && {
        crmOwnerRecordType: s.get("cal.crmOwnerRecordType") ?? void 0
      },
      ...s.get("cal.crmAppSlug") && {
        crmAppSlug: s.get("cal.crmAppSlug") ?? void 0
      }
    }, defaultFormValues: c };
  }
}, [e]), DUl = (e) => {
  const t = PUl(e);
  if (e != null && e.routingFormUrl && t) {
    const {
      organizationId: n,
      teamId: o,
      eventTypeSlug: r,
      username: i,
      defaultFormValues: a,
      teamMemberEmail: s,
      crmOwnerRecordType: c,
      crmAppSlug: l,
      ...u
    } = t, { onDryRunSuccess: d, ..._ } = e;
    return /* @__PURE__ */ m(
      _U,
      {
        clientId: "cm165l146000nqi1mrz8vscja",
        isEmbed: !0,
        organizationId: n,
        options: {
          apiUrl: "https://api.cal.com/v2"
        },
        children: /* @__PURE__ */ m(
          QZ,
          {
            ...o ? {
              eventSlug: r,
              isTeamEvent: !0,
              teamId: o || 0,
              username: ""
            } : {
              eventSlug: r,
              username: i ?? "",
              isTeamEvent: !1
            },
            routingFormSearchParams: u,
            defaultFormValues: a,
            teamMemberEmail: s,
            crmOwnerRecordType: c,
            crmAppSlug: l,
            onDryRunSuccess: () => {
              d ? d() : window.location.href = "https://app.cal.com/booking/dry-run-successful";
            },
            ..._
          }
        )
      }
    );
  }
  return (e == null ? void 0 : e.routingFormUrl) === void 0 ? /* @__PURE__ */ m(
    _U,
    {
      clientId: "cm165l146000nqi1mrz8vscja",
      isEmbed: !0,
      organizationId: e == null ? void 0 : e.organizationId,
      options: {
        apiUrl: "https://api.cal.com/v2"
      },
      children: /* @__PURE__ */ m(QZ, { ...e })
    }
  ) : /* @__PURE__ */ m(nt, {});
}, LUl = Fe.memo(
  ({
    formId: e,
    formResponsesURLParams: t,
    onExternalRedirect: n,
    onDisplayBookerEmbed: o,
    renderMessage: r,
    onSubmitFormStart: i,
    onSubmitFormEnd: a,
    renderLoader: s,
    bookerProps: c
  }) => {
    const [l, u] = it(), [d, _] = it(), [p, g] = it(), [f, h] = it();
    Fe.useEffect(() => {
      if (!l) {
        u(!0), h(!1), g(void 0), _("");
        const v = "https://api.cal.com/v2";
        i == null || i(), fetch(`${v}/router/forms/${e}/submit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: t ? JSON.stringify(Object.fromEntries(t)) : void 0
        }).then(async (b) => {
          var w;
          const y = await b.json();
          y.redirect ? _(y.data) : g({ message: ((w = y.data) == null ? void 0 : w.message) ?? "" });
        }).catch((b) => {
          console.error(b), h(!0);
        }).finally(() => {
          u(!1), a == null || a();
        });
      }
    }, []);
    const $ = !!d;
    if (l && s)
      return /* @__PURE__ */ m(nt, { children: s == null ? void 0 : s(l) });
    if (l || f)
      return /* @__PURE__ */ m(nt, {});
    if (!l && $ && d) {
      const v = new URLSearchParams(d);
      if (v.get("cal.action") === "eventTypeRedirectUrl")
        return o == null || o(), /* @__PURE__ */ m(DUl, { routingFormUrl: d, ...c });
      if (v.get("cal.action") === "externalRedirectUrl")
        return n == null || n(), window.location.href = d, /* @__PURE__ */ m(nt, {});
    }
    return !$ && (p != null && p.message) ? r ? /* @__PURE__ */ m(nt, { children: r(p == null ? void 0 : p.message) }) : /* @__PURE__ */ m("div", { className: "mx-auto my-0 max-w-3xl md:my-24", children: /* @__PURE__ */ m("div", { className: "w-full max-w-4xl ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m("div", { className: "text-default bg-default -mx-4 rounded-sm border border-neutral-200 p-4 py-6 sm:mx-0 sm:px-8", children: /* @__PURE__ */ m("div", { children: p == null ? void 0 : p.message }) }) }) }) : /* @__PURE__ */ m(nt, {});
  }
);
LUl.displayName = "RouterAtom";
const MUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = qc();
  return Hr({
    mutationFn: (r) => {
      const { id: i, calendar: a } = r, s = {
        id: i
      };
      return At.post(`/calendars/${a}/disconnect`, s).then((c) => c.data);
    },
    onSuccess: (r) => {
      r.status === Nn ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    },
    onSettled: () => {
      n.invalidateQueries({ queryKey: [iF] });
    }
  });
}, FUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => {
    const { delegationCredentialId: r, ...i } = o;
    return At.post("/selected-calendars", {
      ...i,
      ...r ? { delegationCredentialId: r } : {}
    }).then((a) => a.data);
  },
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), qUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Hr({
  mutationFn: (o) => {
    const { credentialId: r, externalId: i, integration: a, delegationCredentialId: s } = o;
    return At.delete(
      `/selected-calendars?credentialId=${r}&integration=${a}&externalId=${encodeURIComponent(
        i
      )}${s ? `&delegationCredentialId=${s}` : ""}`
    ).then((c) => c.data);
  },
  onSuccess: (o) => {
    o.status === Nn ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), jUl = "use-teams", VUl = () => {
  const { organizationId: e } = cr(), t = `/organizations/${e}/teams/me`;
  return mr({
    queryKey: [jUl, e],
    queryFn: async () => At == null ? void 0 : At.get(t).then((o) => {
      if (o.data.status === Nn)
        return o.data.data;
      throw new Error(o.data.error.message);
    }),
    enabled: !!e
  });
};
function yve(e) {
  var r, i, a;
  const { query: t } = e, { isLocaleReady: n } = kt(), o = e.customLoader || /* @__PURE__ */ m(W1c, {});
  return n ? t.status === "pending" ? ((i = e.loading) == null ? void 0 : i.call(e, t)) ?? o : t.status === "success" ? "empty" in e && (t.data == null || Array.isArray(t.data) && t.data.length === 0) ? e.empty(t) : e.success(t) : t.status === "error" ? ((a = e.error) == null ? void 0 : a.call(e, t)) ?? /* @__PURE__ */ m(Us, { severity: "error", title: "Something went wrong", message: t.error.message }) : null : ((r = e.loading) == null ? void 0 : r.call(e, t.status === "pending" ? t : null)) ?? o;
}
const BUl = (e) => {
  const { t } = kt(), {
    logo: n,
    title: o,
    description: r,
    actions: i,
    isDefault: a,
    isTemplate: s,
    invalidCredential: c,
    children: l,
    credentialOwner: u,
    className: d,
    classNameObject: _,
    highlight: p
  } = e;
  return /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        p && "dark:bg-muted bg-yellow-100",
        d || (_ == null ? void 0 : _.container)
      ),
      children: [
        /* @__PURE__ */ de("div", { className: "flex items-start gap-x-3 px-4 py-4 sm:px-6", children: [
          n ? /* @__PURE__ */ m(
            "img",
            {
              className: xe(n.includes("-dark") && "dark:invert", "h-10 w-10 flex-shrink-0"),
              src: n,
              alt: `${o} logo`
            }
          ) : null,
          /* @__PURE__ */ de("div", { className: "flex min-w-0 grow flex-col gap-y-1", children: [
            /* @__PURE__ */ de("div", { className: "flex items-center gap-x-2", children: [
              /* @__PURE__ */ m(
                "h3",
                {
                  className: xe("text-emphasis truncate text-sm font-semibold", _ == null ? void 0 : _.title),
                  children: o
                }
              ),
              /* @__PURE__ */ de("div", { className: "flex flex-shrink-0 items-center gap-x-2", children: [
                a && /* @__PURE__ */ m(Wi, { variant: "green", children: t("default") }),
                s && /* @__PURE__ */ m(Wi, { variant: "red", children: "Template" })
              ] })
            ] }),
            /* @__PURE__ */ m(
              Y5,
              {
                component: "p",
                className: xe("whitespace-normal break-words", _ == null ? void 0 : _.description),
                children: r
              }
            ),
            c && /* @__PURE__ */ de("div", { className: "flex gap-x-2 pt-2", children: [
              /* @__PURE__ */ m(qt, { name: "circle-alert", className: "h-8 w-8 flex-shrink-0 text-red-500 sm:h-4 sm:w-4" }),
              /* @__PURE__ */ m(Y5, { component: "p", className: "whitespace-pre-wrap break-words text-red-500", children: t("invalid_credential", { appName: o }) })
            ] })
          ] }),
          u && /* @__PURE__ */ m("div", { className: "flex-shrink-0", children: /* @__PURE__ */ m(Wi, { variant: "gray", children: /* @__PURE__ */ de("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              Dd,
              {
                className: "mr-2",
                alt: u.name || "Nameless",
                size: "xs",
                imageSrc: yA(u.avatar, u == null ? void 0 : u.name)
              }
            ),
            u.name
          ] }) }) }),
          i && /* @__PURE__ */ m("div", { className: "flex-shrink-0", children: i })
        ] }),
        /* @__PURE__ */ m("div", { className: "w-full", children: l })
      ]
    }
  );
};
function UUl(e) {
  const {
    externalId: t,
    name: n,
    isLoading: o,
    translations: r = {
      spanText: "Adding events to"
    },
    children: i
  } = e;
  return /* @__PURE__ */ de("div", { className: xe("my-2 flex flex-row items-center"), children: [
    /* @__PURE__ */ m("div", { className: "flex pl-2", children: i }),
    /* @__PURE__ */ m("label", { className: "ml-3 text-sm font-medium leading-5", htmlFor: t, children: n }),
    !!e.destination && /* @__PURE__ */ de("span", { className: "bg-subtle text-default ml-8 inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-normal sm:ml-4", children: [
      /* @__PURE__ */ m(qt, { name: "arrow-left", className: "h-4 w-4" }),
      r.spanText
    ] }),
    o && /* @__PURE__ */ m(qt, { name: "rotate-cw", className: "text-muted h-4 w-4 animate-spin ltr:ml-1 rtl:mr-1" })
  ] });
}
const GUl = ({
  label: e,
  trashIcon: t,
  isGlobal: n,
  isModalOpen: o = !1,
  onModalOpen: r,
  onDeletionConfirmation: i,
  buttonProps: a,
  disabled: s
}) => {
  const { t: c } = kt();
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(_v, { open: o, onOpenChange: r, children: [
    /* @__PURE__ */ m(q0, { asChild: !0, children: /* @__PURE__ */ m(
      Jt,
      {
        color: (a == null ? void 0 : a.color) || "destructive",
        StartIcon: t ? "trash" : void 0,
        size: "base",
        variant: t && !e ? "icon" : "button",
        disabled: n || s,
        ...a,
        children: e
      }
    ) }),
    /* @__PURE__ */ m(
      pv,
      {
        variety: "danger",
        title: c("remove_app"),
        confirmBtnText: c("yes_remove_app"),
        onConfirm: i,
        children: /* @__PURE__ */ m("p", { className: "mt-5", children: c("are_you_sure_you_want_to_remove_this_app") })
      }
    )
  ] }) });
}, Z5 = (e) => /* @__PURE__ */ m("div", { className: ar("border-subtle mt-6 rounded-lg border", e.classNames), children: e.children }), WUl = ({
  classNames: e = "mx-5 mb-6",
  calendarRedirectUrls: t,
  allowDelete: n,
  isDryRun: o,
  classNamesObject: r
}) => {
  const { t: i } = kt(), a = Uy({});
  return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
    yve,
    {
      query: a,
      success: ({ data: s }) => {
        var l;
        const c = s.destinationCalendar.externalId;
        return s.connectedCalendars.length ? /* @__PURE__ */ de(Z5, { classNames: (r == null ? void 0 : r.container) || e, children: [
          /* @__PURE__ */ m(
            eX,
            {
              classNames: r == null ? void 0 : r.header,
              calendarRedirectUrls: t,
              isDryRun: o
            }
          ),
          /* @__PURE__ */ m(
            Wj,
            {
              noBorderTreatment: !0,
              className: ((l = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : l.container) || "p-6 pt-2",
              children: s.connectedCalendars.map((u) => {
                var d, _, p, g, f, h, $, v, b, y, w, N, M, q, L, R, T;
                return u.calendars && u.calendars.length > 0 ? /* @__PURE__ */ m(
                  BUl,
                  {
                    shouldHighlight: !0,
                    slug: u.integration.slug,
                    title: u.integration.name,
                    logo: `https://app.cal.com${u.integration.logo}`,
                    description: ((d = u.primary) == null ? void 0 : d.email) ?? u.integration.description,
                    classNameObject: {
                      container: xe(
                        "border-subtle mt-4 rounded-lg border",
                        (p = (_ = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : _.selectedCalendar) == null ? void 0 : p.container
                      ),
                      title: (h = (f = (g = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : g.selectedCalendar) == null ? void 0 : f.header) == null ? void 0 : h.title,
                      description: (b = (v = ($ = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : $.selectedCalendar) == null ? void 0 : v.header) == null ? void 0 : b.description
                    },
                    actions: /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: n && !u.delegationCredentialId && /* @__PURE__ */ m(
                      tX,
                      {
                        credentialId: u.credentialId,
                        trashIcon: !0,
                        buttonProps: { className: "border border-default" },
                        slug: u.integration.slug,
                        isDryRun: o
                      }
                    ) }),
                    children: /* @__PURE__ */ de(
                      "div",
                      {
                        className: xe(
                          "border-subtle border-t",
                          (N = (w = (y = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : y.selectedCalendar) == null ? void 0 : w.body) == null ? void 0 : N.container
                        ),
                        children: [
                          /* @__PURE__ */ m(
                            "p",
                            {
                              className: xe(
                                "text-subtle px-5 pt-4 text-sm",
                                (L = (q = (M = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : M.selectedCalendar) == null ? void 0 : q.body) == null ? void 0 : L.description
                              ),
                              children: i("toggle_calendars_conflict")
                            }
                          ),
                          /* @__PURE__ */ m("ul", { className: "space-y-4 px-5 py-4", children: (R = u.calendars) == null ? void 0 : R.map((D) => /* @__PURE__ */ m(
                            HUl,
                            {
                              externalId: D.externalId,
                              title: D.name || "Nameless calendar",
                              name: D.name || "Nameless calendar",
                              type: u.integration.type,
                              isChecked: D.isSelected,
                              destination: D.externalId === c,
                              credentialId: D.credentialId,
                              delegationCredentialId: u.delegationCredentialId,
                              eventTypeId: null,
                              isDryRun: o
                            },
                            D.externalId
                          )) })
                        ]
                      }
                    )
                  },
                  `list-${u.credentialId}-${u.integration.slug}`
                ) : /* @__PURE__ */ m(
                  Us,
                  {
                    severity: "warning",
                    title: i("something_went_wrong"),
                    message: /* @__PURE__ */ m("span", { children: ((T = u.error) == null ? void 0 : T.message) || i("calendar_error") }),
                    iconClassName: "h-10 w-10 ml-2 mr-1 mt-0.5",
                    actions: !u.delegationCredentialId && /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: /* @__PURE__ */ m(
                      tX,
                      {
                        credentialId: u.credentialId,
                        trashIcon: !0,
                        buttonProps: { className: "border border-default" },
                        slug: u.integration.slug,
                        isDryRun: o
                      }
                    ) })
                  },
                  `alert-${u.credentialId}`
                );
              })
            }
          )
        ] }) : /* @__PURE__ */ de(Z5, { classNames: (r == null ? void 0 : r.container) || e, children: [
          /* @__PURE__ */ m(
            eX,
            {
              classNames: r == null ? void 0 : r.header,
              calendarRedirectUrls: t,
              isDryRun: o
            }
          ),
          /* @__PURE__ */ m(
            "h1",
            {
              className: xe(
                "px-6 py-4 text-base leading-5",
                r == null ? void 0 : r.noSelectedCalendarsMessage
              ),
              children: "No connected calendars found."
            }
          )
        ] });
      }
    }
  ) }) });
}, eX = ({
  calendarRedirectUrls: e,
  isDryRun: t,
  classNames: n
}) => {
  const { t: o } = kt();
  return /* @__PURE__ */ m("div", { className: xe("border-subtle border-b p-6", n == null ? void 0 : n.container), children: /* @__PURE__ */ de("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("h4", { className: xe("text-emphasis text-base font-semibold leading-5", n == null ? void 0 : n.title), children: o("check_for_conflicts") }),
      /* @__PURE__ */ m("p", { className: xe("text-default text-sm leading-tight", n == null ? void 0 : n.description), children: o("select_calendars") })
    ] }),
    /* @__PURE__ */ m("div", { className: "flex flex-col xl:flex-row xl:space-x-5", children: /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m(
      YUl,
      {
        calendarRedirectUrls: e,
        isDryRun: t
      }
    ) }) })
  ] }) });
}, tX = (e) => {
  const { t } = kt(), { onSuccess: n, credentialId: o, slug: r } = e, [i, a] = it(!1), { toast: s } = wf(), { mutate: c } = MUl({
    onSuccess: () => {
      s({
        description: t("app_removed_successfully")
      }), a(!1), n && n();
    },
    onError: () => {
      s({
        description: t("error_removing_app")
      }), a(!1);
    }
  });
  return /* @__PURE__ */ m(
    GUl,
    {
      onDeletionConfirmation: async () => {
        !e.isDryRun && a(!1), e.isDryRun && s({
          description: t("app_removed_successfully")
        }), !e.isDryRun && r && await c({
          calendar: r.split("-")[0],
          id: o
        });
      },
      ...e,
      isModalOpen: i,
      onModalOpen: () => a((l) => !l)
    }
  );
}, HUl = (e) => {
  const { isChecked: t, title: n, credentialId: o, type: r, externalId: i, delegationCredentialId: a } = e, [s, c] = it(t), { toast: l } = wf(), { mutate: u, isPending: d } = FUl({
    onError: (f) => {
      l({
        description: `Something went wrong while adding calendar - ${n}. ${f}`
      });
    }
  }), { mutate: _, isPending: p } = qUl(
    {
      onError: (f) => {
        l({
          description: `Something went wrong while removing calendar - ${n}. ${f}`
        });
      }
    }
  ), g = async ({
    isOn: f,
    credentialId: h,
    integration: $,
    externalId: v
  }) => {
    f ? await u({ credentialId: h, integration: $, externalId: v, delegationCredentialId: a }) : await _({
      credentialId: h,
      integration: $,
      externalId: v,
      delegationCredentialId: a
    });
  };
  return /* @__PURE__ */ m(
    UUl,
    {
      destination: e.destination,
      ...e,
      isChecked: s,
      isLoading: d || p,
      children: /* @__PURE__ */ m(
        as,
        {
          checked: s,
          id: i,
          onCheckedChange: async () => {
            c((f) => !f), e.isDryRun || await g({
              isOn: !s,
              credentialId: o,
              externalId: i,
              integration: r
            });
          }
        }
      )
    }
  );
}, YUl = ({
  calendarRedirectUrls: e,
  isDryRun: t
}) => {
  const { t: n } = kt(), { refetch: o } = Uy({});
  return /* @__PURE__ */ de(jd, { modal: !1, children: [
    /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(Jt, { StartIcon: "plus", color: "secondary", className: "md:rounded-md", children: n("add") }) }),
    /* @__PURE__ */ m(Yu, { className: "w-auto", children: /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
        lse,
        {
          isDryRun: t,
          isMultiCalendar: !0,
          isClickable: !0,
          tooltip: /* @__PURE__ */ m(nt, {}),
          redir: (e == null ? void 0 : e.google) ?? window.location.href,
          label: n("add_calendar_label", { calendar: "Google" }),
          loadingLabel: n("add_calendar_label", { calendar: "Google" }),
          alreadyConnectedLabel: n("add_calendar_label", { calendar: "Google" }),
          className: "hover:bg-subtle hover:text-default cursor-pointer border-none bg-inherit text-inherit md:rounded-md"
        }
      ) }),
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
        vve,
        {
          isDryRun: t,
          isMultiCalendar: !0,
          isClickable: !0,
          tooltip: /* @__PURE__ */ m(nt, {}),
          redir: (e == null ? void 0 : e.outlook) ?? window.location.href,
          label: n("add_calendar_label", { calendar: "Outlook" }),
          loadingLabel: n("add_calendar_label", { calendar: "Outlook" }),
          alreadyConnectedLabel: n("add_calendar_label", { calendar: "Outlook" }),
          className: "hover:bg-subtle hover:text-default cursor-pointer border-none bg-inherit text-inherit md:rounded-md"
        }
      ) }),
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
        bve,
        {
          isDryRun: t,
          onSuccess: o,
          isClickable: !0,
          isMultiCalendar: !0,
          tooltip: /* @__PURE__ */ m(nt, {}),
          label: n("add_calendar_label", { calendar: "Apple" }),
          loadingLabel: n("add_calendar_label", { calendar: "Apple" }),
          alreadyConnectedLabel: n("add_calendar_label", { calendar: "Apple" }),
          className: "hover:bg-subtle hover:text-default cursor-pointer border-none bg-inherit text-inherit md:rounded-md"
        }
      ) })
    ] }) })
  ] });
}, KUl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = qc();
  return Hr({
    mutationFn: (r) => At.put("/destination-calendars", r).then((i) => i.data),
    onSuccess: (r) => {
      r.status === Nn ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    },
    onSettled: () => {
      n.invalidateQueries({ queryKey: [iF] });
    }
  });
}, $ve = ({ ...e }) => {
  const { label: t, subtitle: n } = e.data;
  return /* @__PURE__ */ de(F_.SingleValue, { ...e, className: "flex space-x-1", children: [
    /* @__PURE__ */ m("p", { children: t }),
    " ",
    /* @__PURE__ */ m("p", { className: " text-subtle", children: n })
  ] });
}, wve = ({ ...e }) => {
  const { label: t } = e.data;
  return /* @__PURE__ */ m(F_.Option, { ...e, children: /* @__PURE__ */ de("div", { className: "flex", children: [
    /* @__PURE__ */ m("span", { className: "mr-auto", children: t }),
    e.isSelected && /* @__PURE__ */ m(qt, { name: "check", className: "ml-2 h-4 w-4" })
  ] }) });
}, ZUl = ({
  onChange: e,
  isPending: t,
  value: n,
  hidePlaceholder: o,
  hideAdvancedText: r,
  maxWidth: i,
  calendarsQueryData: a,
  customClassNames: s
}) => {
  const { t: c } = kt(), l = a == null ? void 0 : a.connectedCalendars, u = a == null ? void 0 : a.destinationCalendar, [d, _] = it(null), p = (f = !1) => f ? {} : {
    alignItems: "center",
    width: "100%",
    display: "flex",
    ":before": {
      content: `'${c("create_events_on")}:'`,
      display: "block",
      marginRight: 8
    }
  };
  if (yt(() => {
    var h, $;
    const f = l == null ? void 0 : l.map((v) => v.calendars ?? []).flat().find((v) => v.externalId === n);
    if (f) {
      const v = l == null ? void 0 : l.find(
        (b) => {
          var y;
          return (y = b.calendars) == null ? void 0 : y.some((w) => w.externalId === f.externalId);
        }
      );
      _({
        value: `${f.integration}:${f.externalId}`,
        label: `${f.name} ` || "",
        subtitle: `(${(h = v == null ? void 0 : v.integration.title) == null ? void 0 : h.replace(/calendar/i, "")} - ${($ = v == null ? void 0 : v.primary) == null ? void 0 : $.name})`
      });
    }
  }, [l]), !(l != null && l.length))
    return null;
  const g = (l == null ? void 0 : l.map((f) => {
    var h, $, v, b;
    return {
      key: f.credentialId,
      label: `${(h = f.integration.title) == null ? void 0 : h.replace(/calendar/i, "")} (${(($ = f.primary) == null ? void 0 : $.integration) === "office365_calendar" ? (v = f.primary) == null ? void 0 : v.email : (b = f.primary) == null ? void 0 : b.name})`,
      options: (f.calendars ?? []).filter((y) => y.readOnly === !1).map((y) => {
        var w, N;
        return {
          label: ` ${y.name} `,
          subtitle: `(${(w = f == null ? void 0 : f.integration.title) == null ? void 0 : w.replace(/calendar/i, "")} - ${(N = f == null ? void 0 : f.primary) == null ? void 0 : N.name})`,
          value: `${y.integration}:${y.externalId}`
        };
      })
    };
  })) ?? [];
  return /* @__PURE__ */ de(
    "div",
    {
      className: "relative table w-full table-fixed",
      title: `${c("create_events_on")}: ${(d == null ? void 0 : d.label) || ""}`,
      children: [
        /* @__PURE__ */ m(
          Di,
          {
            name: "primarySelectedCalendar",
            placeholder: o ? /* @__PURE__ */ de("span", { className: "text-default min-w-0 overflow-hidden truncate whitespace-nowrap", children: [
              /* @__PURE__ */ m(Wi, { variant: "blue", children: "Default" }),
              " ",
              (u == null ? void 0 : u.name) && `${u.name} (${u == null ? void 0 : u.integrationTitle} - ${u.primaryEmail})`
            ] }) : `${c("create_events_on")}`,
            options: g,
            styles: {
              placeholder: (f) => ({ ...f, ...p(o) }),
              singleValue: (f) => ({ ...f, ...p(o) }),
              control: (f) => ({
                ...f,
                "@media only screen and (min-width: 640px)": {
                  ...f["@media only screen and (min-width: 640px)"],
                  maxWidth: i
                }
              })
            },
            isSearchable: !1,
            className: Ia(
              "border-default my-2 block w-full min-w-0 flex-1 rounded-none rounded-r-sm text-sm",
              s == null ? void 0 : s.select
            ),
            innerClassNames: s == null ? void 0 : s.innerClassNames,
            onChange: (f) => {
              if (_(f), !f)
                return;
              const [h, $] = f.value.split(/:(.+)/);
              e({
                integration: h,
                externalId: $
              });
            },
            isLoading: t,
            value: d,
            components: { SingleValue: $ve, Option: wve },
            isMulti: !1
          }
        ),
        r ? null : /* @__PURE__ */ m("p", { className: "text-sm leading-tight", children: c("you_can_override_calendar_in_advanced_tab") })
      ]
    }
  );
}, nX = (e = !1, t = "Create events on") => e ? {} : {
  alignItems: "center",
  width: "100%",
  display: "flex",
  ":before": {
    content: t,
    display: "block",
    marginRight: 8
  }
}, XUl = ({
  connectedCalendars: e,
  destinationCalendar: t,
  onChange: n,
  isPending: o,
  value: r,
  hidePlaceholder: i,
  hideAdvancedText: a,
  maxWidth: s
}) => {
  const { t: c } = kt(), [l, u] = it(null);
  yt(() => {
    var p, g;
    const _ = e.map((f) => f.calendars ?? []).flat().find((f) => f.externalId === r);
    if (_) {
      const f = e.find(
        (h) => {
          var $;
          return ($ = h.calendars) == null ? void 0 : $.some((v) => v.externalId === _.externalId);
        }
      );
      u({
        value: `${_.integration}:${_.externalId}`,
        label: `${_.name} ` || "",
        subtitle: `(${(p = f == null ? void 0 : f.integration.title) == null ? void 0 : p.replace(/calendar/i, "")} - ${(g = f == null ? void 0 : f.primary) == null ? void 0 : g.name})`
      });
    }
  }, [e]);
  const d = vn(() => e.map((_) => {
    var p, g, f, h;
    return {
      key: _.credentialId,
      label: `${(p = _.integration.title) == null ? void 0 : p.replace(/calendar/i, "")} (${((g = _.primary) == null ? void 0 : g.integration) === "office365_calendar" ? (f = _.primary) == null ? void 0 : f.email : (h = _.primary) == null ? void 0 : h.name})`,
      options: (_.calendars ?? []).filter(($) => $.readOnly === !1).map(($) => {
        var v, b;
        return {
          label: ` ${$.name} `,
          subtitle: `(${(v = _ == null ? void 0 : _.integration.title) == null ? void 0 : v.replace(/calendar/i, "")} - ${(b = _ == null ? void 0 : _.primary) == null ? void 0 : b.name})`,
          value: `${$.integration}:${$.externalId}`,
          delegationCredentialId: $.delegationCredentialId || void 0
        };
      })
    };
  }) ?? [], [e]);
  return /* @__PURE__ */ de(
    "div",
    {
      className: "relative table w-full table-fixed",
      title: `${c("create_events_on")}: ${(l == null ? void 0 : l.label) || ""}`,
      children: [
        /* @__PURE__ */ m(
          Di,
          {
            name: "primarySelectedCalendar",
            placeholder: i ? /* @__PURE__ */ de("span", { className: "text-default min-w-0 overflow-hidden truncate whitespace-nowrap", children: [
              /* @__PURE__ */ m(Wi, { variant: "blue", children: "Default" }),
              " ",
              (t == null ? void 0 : t.primaryEmail) && `${t.name} (${t == null ? void 0 : t.integrationTitle} - ${t.primaryEmail})`
            ] }) : `${c("create_events_on")}`,
            options: d,
            styles: {
              placeholder: (_) => ({
                ..._,
                ...nX(i, `'${c("create_events_on")}:'`)
              }),
              singleValue: (_) => ({
                ..._,
                ...nX(i, `'${c("create_events_on")}:'`)
              }),
              control: (_) => ({
                ..._,
                "@media only screen and (min-width: 640px)": {
                  ..._["@media only screen and (min-width: 640px)"],
                  maxWidth: s
                }
              })
            },
            isSearchable: !1,
            className: xe(
              "border-default my-2 block w-full min-w-0 flex-1 rounded-none rounded-r-sm text-sm"
            ),
            onChange: (_) => {
              if (u(_), !_)
                return;
              const [p, g] = _.value.split(/:(.+)/);
              n({
                integration: p,
                externalId: g,
                delegationCredentialId: _.delegationCredentialId
              });
            },
            isLoading: o,
            value: l,
            components: { SingleValue: $ve, Option: wve },
            isMulti: !1
          }
        ),
        a ? null : /* @__PURE__ */ m("p", { className: "text-sm leading-tight", children: c("you_can_override_calendar_in_advanced_tab") })
      ]
    }
  );
}, JUl = (e) => {
  var n, o;
  const { t } = kt();
  return /* @__PURE__ */ de(
    "div",
    {
      className: ar(
        "border-subtle mb-6 mt-8 rounded-lg border",
        (e == null ? void 0 : e.classNames) || ((n = e == null ? void 0 : e.classNamesObject) == null ? void 0 : n.container)
      ),
      children: [
        /* @__PURE__ */ m(QUl, { classNames: (o = e.classNamesObject) == null ? void 0 : o.header }),
        /* @__PURE__ */ m("div", { className: "border-t", children: /* @__PURE__ */ m("div", { className: "border-subtle flex w-full flex-col space-y-3 border-y-0 p-6", children: /* @__PURE__ */ de("div", { children: [
          /* @__PURE__ */ m(Ko, { className: "text-default mb-0 font-medium", children: t("add_events_to") }),
          /* @__PURE__ */ m(XUl, { ...e })
        ] }) }) })
      ]
    }
  );
}, QUl = ({ classNames: e }) => {
  const { t } = kt();
  return /* @__PURE__ */ de("div", { className: ar("p-6", e == null ? void 0 : e.container), children: [
    /* @__PURE__ */ m("h2", { className: ar("text-emphasis mb-1 text-base font-bold leading-5 tracking-wide", e == null ? void 0 : e.title), children: t("add_to_calendar") }),
    /* @__PURE__ */ m("p", { className: ar("text-subtle text-sm leading-tight", e == null ? void 0 : e.description), children: t("add_to_calendar_description") })
  ] });
}, eGl = ({
  statusLoader: e,
  classNames: t = "mx-5",
  classNamesObject: n,
  isDryRun: o = !1
}) => {
  var s;
  const r = Uy({}), { mutate: i, isPending: a } = KUl();
  return r.isLoading ? /* @__PURE__ */ m(is, { children: /* @__PURE__ */ de(nt, { children: [
    e,
    !e && /* @__PURE__ */ m("h1", { className: "m-5 text-xl font-semibold", children: "Loading..." })
  ] }) }) : !((s = r.data) != null && s.connectedCalendars) || r.data.connectedCalendars.length < 1 ? null : /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m(
    JUl,
    {
      classNames: t,
      classNamesObject: n,
      connectedCalendars: r.data.connectedCalendars,
      destinationCalendar: r.data.destinationCalendar,
      value: r.data.destinationCalendar.externalId,
      hidePlaceholder: !0,
      hideAdvancedText: !0,
      onChange: async ({ externalId: c, integration: l, delegationCredentialId: u }) => {
        o || await i({
          integration: l,
          externalId: c,
          delegationCredentialId: u
        });
      },
      isPending: a
    }
  ) });
}, wsu = ({
  classNames: e,
  calendarRedirectUrls: t,
  allowDelete: n = !0,
  isDryRun: o
}) => /* @__PURE__ */ de("div", { className: e == null ? void 0 : e.calendarSettingsCustomClassnames, children: [
  /* @__PURE__ */ m(
    eGl,
    {
      statusLoader: /* @__PURE__ */ m(nt, {}),
      classNames: e == null ? void 0 : e.destinationCalendarSettingsCustomClassnames,
      classNamesObject: e == null ? void 0 : e.destinationCalendarSettingsClassNames,
      isDryRun: o
    }
  ),
  /* @__PURE__ */ m(
    WUl,
    {
      classNames: e == null ? void 0 : e.selectedCalendarSettingsCustomClassnames,
      calendarRedirectUrls: t,
      allowDelete: n,
      isDryRun: o,
      classNamesObject: e == null ? void 0 : e.selectedCalendarSettingsClassNames
    }
  )
] });
var tGl = Z_, nGl = xA, oGl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, rGl = /^\w*$/;
function iGl(e, t) {
  if (tGl(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || nGl(e) ? !0 : rGl.test(e) || !oGl.test(e) || t != null && e in Object(t);
}
var Yj = iGl, aGl = K_, sGl = aGl["__core-js_shared__"], cGl = sGl, $R = cGl, oX = function() {
  var e = /[^.]+$/.exec($R && $R.keys && $R.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function lGl(e) {
  return !!oX && oX in e;
}
var uGl = lGl, wR, rX;
function kve() {
  if (rX)
    return wR;
  rX = 1;
  var e = Function.prototype, t = e.toString;
  function n(o) {
    if (o != null) {
      try {
        return t.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  return wR = n, wR;
}
var dGl = Bq, _Gl = uGl, pGl = Vd, mGl = kve(), fGl = /[\\^$.*+?()[\]{}|]/g, gGl = /^\[object .+?Constructor\]$/, hGl = Function.prototype, vGl = Object.prototype, bGl = hGl.toString, yGl = vGl.hasOwnProperty, $Gl = RegExp(
  "^" + bGl.call(yGl).replace(fGl, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function wGl(e) {
  if (!pGl(e) || _Gl(e))
    return !1;
  var t = dGl(e) ? $Gl : gGl;
  return t.test(mGl(e));
}
var kGl = wGl;
function SGl(e, t) {
  return e == null ? void 0 : e[t];
}
var EGl = SGl, xGl = kGl, CGl = EGl;
function TGl(e, t) {
  var n = CGl(e, t);
  return xGl(n) ? n : void 0;
}
var Rv = TGl, AGl = Rv, IGl = AGl(Object, "create"), n2 = IGl, iX = n2;
function OGl() {
  this.__data__ = iX ? iX(null) : {}, this.size = 0;
}
var NGl = OGl;
function zGl(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var RGl = zGl, PGl = n2, DGl = "__lodash_hash_undefined__", LGl = Object.prototype, MGl = LGl.hasOwnProperty;
function FGl(e) {
  var t = this.__data__;
  if (PGl) {
    var n = t[e];
    return n === DGl ? void 0 : n;
  }
  return MGl.call(t, e) ? t[e] : void 0;
}
var qGl = FGl, jGl = n2, VGl = Object.prototype, BGl = VGl.hasOwnProperty;
function UGl(e) {
  var t = this.__data__;
  return jGl ? t[e] !== void 0 : BGl.call(t, e);
}
var GGl = UGl, WGl = n2, HGl = "__lodash_hash_undefined__";
function YGl(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = WGl && t === void 0 ? HGl : t, this;
}
var KGl = YGl, ZGl = NGl, XGl = RGl, JGl = qGl, QGl = GGl, eWl = KGl;
function u$(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
u$.prototype.clear = ZGl;
u$.prototype.delete = XGl;
u$.prototype.get = JGl;
u$.prototype.has = QGl;
u$.prototype.set = eWl;
var tWl = u$;
function nWl() {
  this.__data__ = [], this.size = 0;
}
var oWl = nWl, kR, aX;
function l1() {
  if (aX)
    return kR;
  aX = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return kR = e, kR;
}
var rWl = l1();
function iWl(e, t) {
  for (var n = e.length; n--; )
    if (rWl(e[n][0], t))
      return n;
  return -1;
}
var o2 = iWl, aWl = o2, sWl = Array.prototype, cWl = sWl.splice;
function lWl(e) {
  var t = this.__data__, n = aWl(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : cWl.call(t, n, 1), --this.size, !0;
}
var uWl = lWl, dWl = o2;
function _Wl(e) {
  var t = this.__data__, n = dWl(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var pWl = _Wl, mWl = o2;
function fWl(e) {
  return mWl(this.__data__, e) > -1;
}
var gWl = fWl, hWl = o2;
function vWl(e, t) {
  var n = this.__data__, o = hWl(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var bWl = vWl, yWl = oWl, $Wl = uWl, wWl = pWl, kWl = gWl, SWl = bWl;
function d$(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
d$.prototype.clear = yWl;
d$.prototype.delete = $Wl;
d$.prototype.get = wWl;
d$.prototype.has = kWl;
d$.prototype.set = SWl;
var r2 = d$, EWl = Rv, xWl = K_, CWl = EWl(xWl, "Map"), Kj = CWl, sX = tWl, TWl = r2, AWl = Kj;
function IWl() {
  this.size = 0, this.__data__ = {
    hash: new sX(),
    map: new (AWl || TWl)(),
    string: new sX()
  };
}
var OWl = IWl;
function NWl(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var zWl = NWl, RWl = zWl;
function PWl(e, t) {
  var n = e.__data__;
  return RWl(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var i2 = PWl, DWl = i2;
function LWl(e) {
  var t = DWl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var MWl = LWl, FWl = i2;
function qWl(e) {
  return FWl(this, e).get(e);
}
var jWl = qWl, VWl = i2;
function BWl(e) {
  return VWl(this, e).has(e);
}
var UWl = BWl, GWl = i2;
function WWl(e, t) {
  var n = GWl(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var HWl = WWl, YWl = OWl, KWl = MWl, ZWl = jWl, XWl = UWl, JWl = HWl;
function _$(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
_$.prototype.clear = YWl;
_$.prototype.delete = KWl;
_$.prototype.get = ZWl;
_$.prototype.has = XWl;
_$.prototype.set = JWl;
var Zj = _$, Sve = Zj, QWl = "Expected a function";
function Xj(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(QWl);
  var n = function() {
    var o = arguments, r = t ? t.apply(this, o) : o[0], i = n.cache;
    if (i.has(r))
      return i.get(r);
    var a = e.apply(this, o);
    return n.cache = i.set(r, a) || i, a;
  };
  return n.cache = new (Xj.Cache || Sve)(), n;
}
Xj.Cache = Sve;
var e8l = Xj, t8l = e8l, n8l = 500;
function o8l(e) {
  var t = t8l(e, function(o) {
    return n.size === n8l && n.clear(), o;
  }), n = t.cache;
  return t;
}
var r8l = o8l, i8l = r8l, a8l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, s8l = /\\(\\)?/g, c8l = i8l(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(a8l, function(n, o, r, i) {
    t.push(r ? i.replace(s8l, "$1") : o || n);
  }), t;
}), l8l = c8l, cX = t$, u8l = Lq, d8l = Z_, _8l = xA, p8l = 1 / 0, lX = cX ? cX.prototype : void 0, uX = lX ? lX.toString : void 0;
function Eve(e) {
  if (typeof e == "string")
    return e;
  if (d8l(e))
    return u8l(e, Eve) + "";
  if (_8l(e))
    return uX ? uX.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -p8l ? "-0" : t;
}
var xve = Eve, m8l = xve;
function f8l(e) {
  return e == null ? "" : m8l(e);
}
var Cve = f8l, g8l = Z_, h8l = Yj, v8l = l8l, b8l = Cve;
function y8l(e, t) {
  return g8l(e) ? e : h8l(e, t) ? [e] : v8l(b8l(e));
}
var p$ = y8l, $8l = xA, w8l = 1 / 0;
function k8l(e) {
  if (typeof e == "string" || $8l(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -w8l ? "-0" : t;
}
var m$ = k8l, S8l = p$, E8l = m$;
function x8l(e, t) {
  t = S8l(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[E8l(t[n++])];
  return n && n == o ? e : void 0;
}
var a2 = x8l, C8l = a2;
function T8l(e, t, n) {
  var o = e == null ? void 0 : C8l(e, t);
  return o === void 0 ? n : o;
}
var Tve = T8l;
const A8l = /* @__PURE__ */ Mi(Tve), I8l = (e, [t, n], o, r, i = { simple: !1 }) => e ? /* @__PURE__ */ m(
  as,
  {
    "data-testid": `locked-indicator-${o}`,
    onCheckedChange: (a) => {
      n({
        ...t,
        [o]: a
      }), r(o, !a || void 0);
    },
    checked: t[o],
    size: "sm"
  }
) : null, O8l = (e, t, [n, o], r, i, a, s = { simple: !1 }) => {
  const c = n[i], l = r(c ? "locked" : "unlocked"), u = r(
    `${c ? "locked" : "unlocked"}_fields_${t ? "admin" : "member"}_description`
  );
  return (t || e) && /* @__PURE__ */ m(Sr, { content: /* @__PURE__ */ m(nt, { children: u }), children: /* @__PURE__ */ m("div", { className: "inline", children: /* @__PURE__ */ de(
    Wi,
    {
      variant: c ? "gray" : "green",
      className: xe(
        "ml-2 transform justify-between p-1",
        t && !s.simple && "w-28"
      ),
      children: [
        !s.simple && /* @__PURE__ */ de("span", { className: "inline-flex", children: [
          /* @__PURE__ */ m(qt, { name: c ? "lock" : "lock-open", className: "text-subtle h-3 w-3" }),
          /* @__PURE__ */ m("span", { className: "ml-1 font-medium", children: l })
        ] }),
        t && /* @__PURE__ */ m(
          as,
          {
            "data-testid": `locked-indicator-${i}`,
            onCheckedChange: (d) => {
              o({
                ...n,
                [i]: d
              }), a(i, !d || void 0);
            },
            checked: c,
            size: "sm"
          }
        )
      ]
    }
  ) }) });
}, N8l = ({
  eventType: e,
  translate: t,
  formMethods: n
}) => {
  var $, v;
  const { setValue: o, getValues: r } = n, [i, a] = it({}), s = nce.parse(e.metadata), c = (($ = s == null ? void 0 : s.managedEventConfig) == null ? void 0 : $.unlockedFields) !== void 0 && ((v = s == null ? void 0 : s.managedEventConfig) == null ? void 0 : v.unlockedFields) || {}, l = e.schedulingType === Bs.MANAGED, u = (s == null ? void 0 : s.managedEventConfig) !== void 0 && e.schedulingType !== Bs.MANAGED, d = (b, y) => {
    const w = "metadata.managedEventConfig.unlockedFields", N = r(w);
    N && (y === void 0 ? (delete N[b], o(w, { ...N }, { shouldDirty: !0 })) : o(
      w,
      {
        ...N,
        [b]: y
      },
      { shouldDirty: !0 }
    ));
  }, _ = (b) => {
    var w, N;
    let y = l || u;
    if (b.includes("."))
      y = y && A8l(c, b) === void 0;
    else {
      const M = (N = (w = r("metadata")) == null ? void 0 : w.managedEventConfig) == null ? void 0 : N.unlockedFields, q = !!(M != null && M[b]);
      y = y && !q;
    }
    return y;
  }, p = (b, y) => (typeof i[b] > "u" && a({
    ...i,
    [b]: _(b)
  }), O8l(
    u,
    l,
    [i, a],
    t,
    b,
    d,
    y
  ));
  return {
    shouldLockIndicator: p,
    shouldLockDisableProps: (b, y) => (typeof i[b] > "u" && a({
      ...i,
      [b]: _(b)
    }), {
      disabled: !l && (s == null ? void 0 : s.managedEventConfig) !== void 0 && c[b] === void 0,
      LockedIcon: p(b, y),
      isLocked: i[b]
    }),
    useLockedLabel: (b, y) => {
      typeof i[b] > "u" && a({
        ...i,
        [b]: _(b)
      });
      const w = i[b];
      return {
        disabled: !l && (s == null ? void 0 : s.managedEventConfig) !== void 0 && c[b] === void 0,
        LockedIcon: p(b, y),
        isLocked: w
      };
    },
    useLockedSwitch: (b, y = { simple: !1 }) => (typeof i[b] > "u" && a({
      ...i,
      [b]: _(b)
    }), () => I8l(l, [i, a], b, d, y)),
    isManagedEventType: l,
    isChildrenManagedEventType: u
  };
}, Bg = N8l, z8l = globalThis != null && globalThis.document ? lc : () => {
}, Ave = "Collapsible", [R8l, ksu] = jc(Ave), [P8l, Ive] = R8l(Ave), ik = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeCollapsible: n, open: o, defaultOpen: r, disabled: i, onOpenChange: a, ...s } = e, [c = !1, l] = Uu({
    prop: o,
    defaultProp: r,
    onChange: a
  });
  return /* @__PURE__ */ pt(P8l, {
    scope: n,
    disabled: i,
    contentId: Pu(),
    open: c,
    onOpenToggle: Yt(
      () => l(
        (u) => !u
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ pt(nr.div, Tt({
    "data-state": Nve(c),
    "data-disabled": i ? "" : void 0
  }, s, {
    ref: t
  })));
}), Ove = "CollapsibleContent", ak = /* @__PURE__ */ Bt((e, t) => {
  const { forceMount: n, ...o } = e, r = Ive(Ove, e.__scopeCollapsible);
  return /* @__PURE__ */ pt(
    Vc,
    {
      present: n || r.open
    },
    ({ present: i }) => /* @__PURE__ */ pt(D8l, Tt({}, o, {
      ref: t,
      present: i
    }))
  );
}), D8l = /* @__PURE__ */ Bt((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...i } = e, a = Ive(Ove, n), [s, c] = it(o), l = xt(null), u = ni(t, l), d = xt(0), _ = d.current, p = xt(0), g = p.current, f = a.open || s, h = xt(f), $ = xt();
  return yt(() => {
    const v = requestAnimationFrame(
      () => h.current = !1
    );
    return () => cancelAnimationFrame(v);
  }, []), z8l(() => {
    const v = l.current;
    if (v) {
      $.current = $.current || {
        transitionDuration: v.style.transitionDuration,
        animationName: v.style.animationName
      }, v.style.transitionDuration = "0s", v.style.animationName = "none";
      const b = v.getBoundingClientRect();
      d.current = b.height, p.current = b.width, h.current || (v.style.transitionDuration = $.current.transitionDuration, v.style.animationName = $.current.animationName), c(o);
    }
  }, [
    a.open,
    o
  ]), /* @__PURE__ */ pt(nr.div, Tt({
    "data-state": Nve(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    id: a.contentId,
    hidden: !f
  }, i, {
    ref: u,
    style: {
      "--radix-collapsible-content-height": _ ? `${_}px` : void 0,
      "--radix-collapsible-content-width": g ? `${g}px` : void 0,
      ...e.style
    }
  }), f && r);
});
function Nve(e) {
  return e ? "open" : "closed";
}
const zve = (e, t) => {
  const n = Nr.usePathname(), o = Ef(), r = o == null ? void 0 : o.toString();
  let i;
  return r ? i = `${n}?${r}` : i = n, t ? i ? i === e : !1 : i ? i.includes(e) : !1;
}, L8l = function({
  name: e,
  href: t,
  linkShallow: n,
  linkScroll: o,
  avatar: r,
  matchFullPath: i,
  ...a
}) {
  const s = zve(t, i) || (a == null ? void 0 : a.isActive), { t: c } = kt();
  return /* @__PURE__ */ de(
    Ir,
    {
      onClick: (l) => {
        a.onClick && (l.preventDefault(), a.onClick(e));
      },
      href: t,
      shallow: n,
      scroll: o,
      "aria-disabled": a.disabled ? "true" : void 0,
      className: xe(
        s ? "bg-subtle text-emphasis" : "hover:bg-muted hover:text-default text-subtle",
        "inline-flex h-fit items-center justify-center whitespace-nowrap rounded-md p-2 text-sm font-medium leading-none transition md:mb-0",
        a.disabled && "pointer-events-none !opacity-30",
        a.className
      ),
      target: a.target ? a.target : void 0,
      "data-testid": `horizontal-tab-${a["data-testid"]}`,
      "aria-current": s ? "page" : void 0,
      children: [
        a.icon && /* @__PURE__ */ m(
          qt,
          {
            name: a.icon,
            className: xe("-ml-0.5 me-2 hidden h-4 w-4 text-inherit sm:inline-block"),
            "aria-hidden": "true"
          }
        ),
        r && /* @__PURE__ */ m(Dd, { size: "xs", imageSrc: r, alt: "avatar", className: "-ml-0.5 me-1" }),
        " ",
        c(e)
      ]
    },
    e
  );
}, M8l = L8l, F8l = function({ tabs: e, linkShallow: t, linkScroll: n, actions: o, ...r }) {
  return /* @__PURE__ */ de("div", { className: "mb-4 max-w-full lg:mb-5", children: [
    /* @__PURE__ */ m(
      "nav",
      {
        className: "no-scrollbar flex space-x-0.5 overflow-x-scroll rounded-md",
        "aria-label": "Tabs",
        ...r,
        children: e.map((i, a) => /* @__PURE__ */ pt(M8l, { ...i, key: a, linkShallow: t, linkScroll: n }))
      }
    ),
    o && o
  ] });
}, Rve = F8l, Pve = ({
  name: e,
  href: t,
  info: n,
  isChild: o,
  disableChevron: r,
  linkShallow: i,
  linkScroll: a,
  ...s
}) => {
  var u;
  const c = zve(t) || (s == null ? void 0 : s.isActive), { t: l } = kt();
  return /* @__PURE__ */ m(Ha, { children: !s.hidden && /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de(
      Ir,
      {
        onClick: (d) => {
          s.onClick && (d.preventDefault(), s.onClick(e));
        },
        href: t,
        shallow: i,
        scroll: a,
        "aria-disabled": s.disabled ? "true" : void 0,
        target: s.isExternalLink ? "_blank" : "_self",
        className: xe(
          s.textClassNames || "text-default text-sm font-medium leading-none",
          "hover:bg-subtle [&[aria-current='page']]:bg-subtle [&[aria-current='page']]:text-emphasis group-hover:text-default group flex w-full flex-row items-center rounded-md p-2 transition ",
          s.disabled && "pointer-events-none !opacity-30",
          (o || !s.icon) && "ml-7",
          s.className
        ),
        "data-testid": `vertical-tab-${s["data-testid"]}`,
        "aria-current": c ? "page" : void 0,
        children: [
          s.icon && /* @__PURE__ */ m(
            qt,
            {
              name: s.icon,
              className: xe("me-2 h-4 w-4", s.iconClassName),
              "data-testid": "icon-component"
            }
          ),
          /* @__PURE__ */ de("div", { className: "h-fit min-w-0 flex-1", children: [
            /* @__PURE__ */ de("span", { className: "flex items-center gap-2", children: [
              l(e),
              s.isExternalLink ? /* @__PURE__ */ m(qt, { name: "external-link", "data-testid": "external-link" }) : null
            ] }),
            n && // TODO: I don't think having apps-info as a data-test-id is right here as this is meant to be dumb component.
            /* @__PURE__ */ m("p", { "data-testid": "apps-info", className: "mt-1 text-xs font-normal", children: n })
          ] }),
          !r && c && /* @__PURE__ */ m("div", { className: "ml-auto self-center", children: /* @__PURE__ */ m(
            qt,
            {
              name: "chevron-right",
              width: 20,
              height: 20,
              className: "text-default h-auto w-[20px] stroke-[1.5px]",
              "data-testid": "chevron-right"
            }
          ) })
        ]
      },
      e
    ),
    (u = s.children) == null ? void 0 : u.map((d) => /* @__PURE__ */ m(Pve, { ...d, isChild: !0 }, d.name))
  ] }) }, e);
}, q8l = Pve, j8l = function({
  tabs: e,
  className: t = "",
  sticky: n,
  linkShallow: o,
  linkScroll: r,
  itemClassname: i,
  iconClassName: a,
  ...s
}) {
  return /* @__PURE__ */ de(
    "nav",
    {
      className: xe(
        `no-scrollbar flex flex-col space-y-0.5 overflow-scroll ${t}`,
        n && "sticky top-0 -mt-7"
      ),
      style: {
        maxWidth: "256px"
      },
      "aria-label": "Tabs",
      ...s,
      children: [
        n && /* @__PURE__ */ m("div", { className: "pt-6" }),
        s.children,
        e.map((c, l) => /* @__PURE__ */ pt(
          q8l,
          {
            ...c,
            key: l,
            linkShallow: o,
            linkScroll: r,
            className: i,
            iconClassName: a
          }
        ))
      ]
    }
  );
}, V8l = j8l, Jj = () => {
  const e = Rme();
  return (e == null ? void 0 : e.fullDomain) ?? Wa;
}, s2 = mcc, B8l = `${Wa}/embed/preview.html`;
var Nw = /* @__PURE__ */ ((e) => (e.auto = "auto", e.light = "light", e.dark = "dark", e))(Nw || {});
function U8l({
  namespace: e,
  mainApiName: t
}) {
  return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(e) ? `${t}.ns.${e}` : `${t}.ns["${e}"]`;
}
function G8l({ mainApiName: e }) {
  return e;
}
function Dve({ mainApiName: e }) {
  return G8l({ mainApiName: e });
}
function X5({
  namespace: e,
  mainApiName: t
}) {
  return U8l({ mainApiName: t, namespace: e });
}
const Ly = (e) => (e.match(/^\d+$/) && (e = `${e}%`), e), SR = (e) => Sf || e !== Wa && e !== Vw, W8l = {
  react: {
    inline: ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = Ly(n.width), a = Ly(n.height), s = `${r ? `namespace="${r}"` : ""}`, c = ER(r);
      return Vm`
import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi(${c ? JSON.stringify(c) : ""});
      ${t}
    })();
  }, [])
  return <Cal ${s}
    calLink="${e}"
    style={{width:"${i}",height:"${a}",overflow:"scroll"}}
    config={${JSON.stringify(n.config)}}
    ${SR(o) ? `calOrigin="${o}"` : ""}
    ${Sf ? `embedJsUrl="${s2}"` : ""}
  />;
};`;
    },
    "floating-popup": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = ER(r), a = JSON.stringify({
        calLink: e,
        ...SR(o) ? { calOrigin: o } : null,
        ...n
      });
      return Vm`
import { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi(${i ? JSON.stringify(i) : ""});
      ${Dve({ mainApiName: "cal" })}("floatingButton", ${a});
      ${t}
    })();
  }, [])
};`;
    },
    "element-click": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = ER(r);
      return Vm`
import { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi(${i ? JSON.stringify(i) : ""});
      ${t}
    })();
  }, [])
  return <button data-cal-namespace="${r}"
    data-cal-link="${e}"
    ${SR(o) ? `data-cal-origin="${o}"` : ""}
    ${`data-cal-config='${JSON.stringify(n.config)}'`}
  >Click me</button>;
};`;
    },
    headless: () => null
  },
  "react-atom": {
    inline: ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      var i;
      return Vm`
import { BookerEmbed } from "@calcom/atoms";

// You might need to define or import BookerProps depending on your setup
// For example: type BookerProps = { eventTypeSlug: string; calUsername: string; /* other props */ };
export default function Booker( props : BookerProps ) {
  return (
    <>
      <BookerEmbed
        // Use the parsed username and event slug from calLink
        eventSlug={eventSlug}
        // layout can be of three types: COLUMN_VIEW, MONTH_VIEW or WEEK_VIEW, 
        // you can choose whichever you prefer
        view="${((i = n.config) == null ? void 0 : i.layout) || "MONTH_VIEW"}"
        username={calUsername}
        customClassNames={{
          bookerContainer: "border-subtle border",
        }}
        onCreateBookingSuccess={() => {
          console.log("booking created successfully");
        }}
      />
    </>
  );
};`;
    },
    "floating-popup": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      var i;
      return Vm`
import { BookerEmbed } from "@calcom/atoms";

// You might need to define or import BookerProps depending on your setup
export default function Booker( props : BookerProps ) {
  return (
    <>
      <BookerEmbed
        // Use the parsed username and event slug from calLink
        eventSlug={eventSlug}
        // layout can be of three types: COLUMN_VIEW, MONTH_VIEW or WEEK_VIEW, 
        // you can choose whichever you prefer
        view="${((i = n.config) == null ? void 0 : i.layout) || "MONTH_VIEW"}"
        username={calUsername}
        customClassNames={{
          bookerContainer: "border-subtle border",
        }}
        onCreateBookingSuccess={() => {
          console.log("booking created successfully");
        }}
      />
    </>
  );
};`;
    },
    "element-click": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      var i;
      return Vm`
import { BookerEmbed } from "@calcom/atoms";

// You might need to define or import BookerProps depending on your setup
export default function Booker( props : BookerProps ) {
  return (
    <>
      <BookerEmbed
        // Use the parsed username and event slug from calLink
        eventSlug={eventSlug}
        // layout can be of three types: COLUMN_VIEW, MONTH_VIEW or WEEK_VIEW, 
        // you can choose whichever you prefer
        view="${((i = n.config) == null ? void 0 : i.layout) || "MONTH_VIEW"}"
        username={calUsername}
        customClassNames={{
          bookerContainer: "border-subtle border",
        }}
        onCreateBookingSuccess={() => {
          console.log("booking created successfully");
        }}
      />
    </>
  );
};`;
    },
    headless: () => null
  },
  HTML: {
    inline: ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => Vm`${X5({ namespace: r, mainApiName: "Cal" })}("inline", {
    elementOrSelector:"#my-cal-inline-${r}",
    config: ${JSON.stringify(n.config)},
    calLink: "${e}",
  });

  ${t}`,
    "floating-popup": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = JSON.stringify({
        calLink: e,
        ...n
      });
      return Vm`${X5({
        namespace: r,
        mainApiName: "Cal"
      })}("floatingButton", ${i}); 
  ${t}`;
    },
    "element-click": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => Vm`
  // Important: Please add the following attributes to the element that should trigger the calendar to open upon clicking.
  // \`data-cal-link="${e}"\`
  // data-cal-namespace="${r}"
  // \`data-cal-config='${JSON.stringify(n.config)}'\`

  ${t}`,
    headless: () => null
  }
}, Vm = (e, ...t) => {
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (o >= t.length) {
      n.push(r);
      continue;
    }
    const i = t[o], a = [];
    let s = "";
    i.split(`
`).forEach((l) => {
      a.push(l);
    });
    const c = r.split(`
`).at(-1).match(/(^[\t ]*).*$/);
    c && (s = c[1]), n.push(r + a.join(`
${s}`));
  }
  return n.join("");
};
function ER(e) {
  const t = Sf ? s2 : void 0;
  return e ? { namespace: e, embedLibUrl: t } : { embedLibUrl: t };
}
function H8l({
  light: e,
  dark: t
}) {
  const o = Object.entries({ light: e, dark: t }).reduce((r, [i, a]) => {
    if (!Object.values(a).some(Boolean))
      return r;
    const s = Object.fromEntries(
      Object.entries(a).filter(([c, l]) => !!l)
    );
    return {
      ...r,
      [i]: s
    };
  }, {});
  if (Object.keys(o).length !== 0)
    return o;
}
function Lve({
  brandColor: e,
  darkBrandColor: t
}) {
  return H8l({
    light: { "cal-brand": e },
    dark: { "cal-brand": t }
  });
}
const Y8l = () => {
  const { t: e } = kt();
  return [
    {
      title: e("inline_embed"),
      subtitle: e("load_inline_content"),
      type: "inline",
      illustration: /* @__PURE__ */ de(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m(
              "path",
              {
                d: "M0 1.99999C0 0.895423 0.895431 0 2 0H306C307.105 0 308 0.895431 308 2V263C308 264.105 307.105 265 306 265H2C0.895431 265 0 264.105 0 263V1.99999Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "24", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24.5", y: "51", width: "139", height: "163", rx: "1.5", fill: "#F8F8F8" }),
            /* @__PURE__ */ m("rect", { opacity: "0.8", x: "48", y: "74.5", width: "80", height: "8", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "48", y: "86.5", width: "48", height: "4", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "99.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "125.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m(
              "path",
              {
                d: "M61 124.5H67V122.5H61V124.5ZM68 125.5V131.5H70V125.5H68ZM67 132.5H61V134.5H67V132.5ZM60 131.5V125.5H58V131.5H60ZM61 132.5C60.4477 132.5 60 132.052 60 131.5H58C58 133.157 59.3431 134.5 61 134.5V132.5ZM68 131.5C68 132.052 67.5523 132.5 67 132.5V134.5C68.6569 134.5 70 133.157 70 131.5H68ZM67 124.5C67.5523 124.5 68 124.948 68 125.5H70C70 123.843 68.6569 122.5 67 122.5V124.5ZM61 122.5C59.3431 122.5 58 123.843 58 125.5H60C60 124.948 60.4477 124.5 61 124.5V122.5Z",
                fill: "#3E3E3E"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "73", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "137.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "137.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "149.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "149.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "161.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "24.5", y: "51", width: "139", height: "163", rx: "6", stroke: "#292929" }),
            /* @__PURE__ */ m("rect", { x: "176", y: "50.5", width: "108", height: "164", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "226.5", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" })
          ]
        }
      )
    },
    {
      title: e("floating_pop_up_button"),
      subtitle: e("floating_button_trigger_modal"),
      type: "floating-popup",
      illustration: /* @__PURE__ */ de(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m(
              "path",
              {
                d: "M0 1.99999C0 0.895423 0.895431 0 2 0H306C307.105 0 308 0.895431 308 2V263C308 264.105 307.105 265 306 265H2C0.895431 265 0 264.105 0 263V1.99999Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "24", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "50.5", width: "120", height: "76", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "138.5", width: "120", height: "76", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "156", y: "50.5", width: "128", height: "164", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "226.5", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "226", y: "223.5", width: "66", height: "26", rx: "6", fill: "#292929" }),
            /* @__PURE__ */ m("rect", { x: "242", y: "235.5", width: "34", height: "2", rx: "1", fill: "white" })
          ]
        }
      )
    },
    {
      title: e("pop_up_element_click"),
      subtitle: e("open_dialog_with_element_click"),
      type: "element-click",
      illustration: /* @__PURE__ */ de(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m(
              "path",
              {
                d: "M0 1.99999C0 0.895423 0.895431 0 2 0H306C307.105 0 308 0.895431 308 2V263C308 264.105 307.105 265 306 265H2C0.895431 265 0 264.105 0 263V1.99999Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "24", y: "0.50293", width: "260", height: "24", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "35", width: "259", height: "192", rx: "5.5", fill: "#F9FAFB" }),
            /* @__PURE__ */ de("g", { filter: "url(#filter0_i_3223_14162)", children: [
              /* @__PURE__ */ m("rect", { opacity: "0.8", x: "40", y: "99", width: "24", height: "24", rx: "2", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "127", width: "48", height: "8", rx: "1", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "139", width: "82", height: "8", rx: "1", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "151", width: "34", height: "4", rx: "1", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "159", width: "34", height: "4", rx: "1", fill: "#E5E7EB" })
            ] }),
            /* @__PURE__ */ m("rect", { x: "152", y: "48", width: "2", height: "169", rx: "2", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { opacity: "0.8", x: "176", y: "84", width: "80", height: "8", rx: "2", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "176", y: "96", width: "48", height: "4", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "109", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "135", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "187.3", y: "133.4", width: "9", height: "9", rx: "1.5", stroke: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "147", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "147", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "159", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "159", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "171", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "35", width: "259", height: "192", rx: "5.5", stroke: "#101010" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "241.503", width: "260", height: "24", rx: "6", fill: "#F3F4F6" })
          ]
        }
      )
    },
    {
      title: e("email_embed"),
      subtitle: e("add_times_to_your_email"),
      type: "email",
      illustration: /* @__PURE__ */ de(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ de("g", { "clip-path": "url(#clip0_457_1339)", children: [
              /* @__PURE__ */ m("rect", { width: "308", height: "265", rx: "8", fill: "white" }),
              /* @__PURE__ */ m("rect", { width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "19", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "38", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "57", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "76", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "95", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "114", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "133", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "152", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "171", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "190", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "209", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "228", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "247", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ de("g", { "clip-path": "url(#clip1_457_1339)", children: [
                /* @__PURE__ */ m("rect", { x: "107", y: "64", width: "189", height: "189", rx: "6", fill: "white" }),
                /* @__PURE__ */ m("g", { "clip-path": "url(#clip2_457_1339)", children: /* @__PURE__ */ m(
                  "path",
                  {
                    d: "M124.671 75.5243C124.671 75.1018 124.325 74.756 123.902 74.756H117.756C117.334 74.756 116.988 75.1018 116.988 75.5243M124.671 75.5243V80.1341C124.671 80.5567 124.325 80.9024 123.902 80.9024H117.756C117.334 80.9024 116.988 80.5567 116.988 80.1341V75.5243M124.671 75.5243L120.829 78.2134L116.988 75.5243",
                    stroke: "#9CA3AF",
                    "stroke-width": "1.15244",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                ) }),
                /* @__PURE__ */ m("rect", { x: "130.049", y: "75.5244", width: "92.1951", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "130.049", y: "84.7439", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#E5E7EB" }),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "107",
                    y: "98.5732",
                    width: "189",
                    height: "1.15244",
                    rx: "0.576219",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "113.555", width: "92.1951", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "122.774", width: "42.6402", height: "4.60976", rx: "2.30488", fill: "#E5E7EB" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "136.604", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.719", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "142.073", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "167.427", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "192.781", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "218.134", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "160.805", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.719", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "142.073", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "167.427", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "192.781", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "218.134", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "185.006", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.719", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "142.073", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "167.427", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "192.781", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "218.134", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "107",
                    y: "223.037",
                    width: "189",
                    height: "1.15244",
                    rx: "0.576219",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m("rect", { width: "189", height: "28.811", transform: "translate(107 224.189)", fill: "#F9FAFB" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "233.985", width: "23.0488", height: "9.21951", rx: "2.30488", fill: "#9CA3AF" }),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "141.573",
                    y: "233.985",
                    width: "9.21951",
                    height: "9.21951",
                    rx: "2.30488",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "153.098",
                    y: "233.985",
                    width: "9.21951",
                    height: "9.21951",
                    rx: "2.30488",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "164.622",
                    y: "233.985",
                    width: "9.21951",
                    height: "9.21951",
                    rx: "2.30488",
                    fill: "#E5E7EB"
                  }
                )
              ] }),
              /* @__PURE__ */ m(
                "rect",
                {
                  x: "106.424",
                  y: "63.4238",
                  width: "190.152",
                  height: "190.152",
                  rx: "6.57622",
                  stroke: "#101010",
                  "stroke-width": "1.15244"
                }
              )
            ] }),
            /* @__PURE__ */ m("rect", { x: "0.5", y: "0.5", width: "307", height: "264", rx: "7.5", stroke: "#E5E7EB" }),
            /* @__PURE__ */ de("defs", { children: [
              /* @__PURE__ */ m("clipPath", { id: "clip0_457_1339", children: /* @__PURE__ */ m("rect", { width: "308", height: "265", rx: "8", fill: "white" }) }),
              /* @__PURE__ */ m("clipPath", { id: "clip1_457_1339", children: /* @__PURE__ */ m("rect", { x: "107", y: "64", width: "189", height: "189", rx: "6", fill: "white" }) }),
              /* @__PURE__ */ m("clipPath", { id: "clip2_457_1339", children: /* @__PURE__ */ m("rect", { width: "9.21951", height: "9.21951", fill: "white", transform: "translate(116.219 73.2195)" }) })
            ] })
          ]
        }
      )
    }
  ];
}, xR = () => Jj();
var zw = /* @__PURE__ */ ((e) => (e.HTML = "embed-code", e.IFRAME_REACT = "embed-react", e.ATOM_REACT = "embed-atom-react", e))(zw || {});
const K8l = [
  {
    name: "HTML (iframe)",
    href: "embedTabName=embed-code",
    icon: "code",
    type: "code",
    "data-testid": "HTML",
    Component: Bt(function({ embedType: t, calLink: n, previewState: o, namespace: r }, i) {
      const { t: a } = kt(), s = J8l(r), c = xR();
      return i instanceof Function || !i || i.current && !(i.current instanceof HTMLTextAreaElement) ? null : /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("small", { className: "text-subtle flex py-2", children: a("place_where_cal_widget_appear", { appName: Kp }) }) }),
        /* @__PURE__ */ m(
          Kw,
          {
            "data-testid": "embed-code",
            ref: i,
            name: "embed-code",
            className: "text-default bg-default h-[calc(100%-50px)] font-mono",
            style: { resize: "none", overflow: "auto" },
            readOnly: !0,
            value: `<!-- Cal ${t} embed code begins -->
${t === "inline" ? `<div style="width:${Ly(o.inline.width)};height:${Ly(
              o.inline.height
            )};overflow:scroll" id="my-cal-inline-${r}"></div>
` : ""}<script type="text/javascript">
  ${s}
  ${CR({
              embedFramework: "HTML",
              embedType: t,
              calLink: n,
              previewState: o,
              embedCalOrigin: c,
              namespace: r
            })}
  <\/script>
  <!-- Cal ${t} embed code ends -->`
          }
        ),
        /* @__PURE__ */ m("p", { className: "text-subtle hidden text-sm", children: a("need_help_embedding") })
      ] });
    })
  },
  {
    name: "React (iframe)",
    href: "embedTabName=embed-react",
    "data-testid": "react",
    icon: "code",
    type: "code",
    Component: Bt(function({ embedType: t, calLink: n, previewState: o, namespace: r }, i) {
      const { t: a } = kt(), s = xR();
      return i instanceof Function || !i || i.current && !(i.current instanceof HTMLTextAreaElement) ? null : /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("small", { className: "text-subtle flex py-2", children: a("create_update_react_component") }),
        /* @__PURE__ */ m(
          Kw,
          {
            "data-testid": "embed-react",
            ref: i,
            name: "embed-react",
            className: "text-default bg-default h-[calc(100%-50px)] font-mono",
            readOnly: !0,
            style: { resize: "none", overflow: "auto" },
            value: `/* First make sure that you have installed the package */

/* If you are using yarn */
// yarn add @calcom/embed-react

/* If you are using npm */
// npm install @calcom/embed-react
  ${CR({
              embedFramework: "react",
              embedType: t,
              calLink: n,
              previewState: o,
              embedCalOrigin: s,
              namespace: r
            })}
  `
          }
        )
      ] });
    })
  },
  {
    name: "React (Atom)",
    href: "embedTabName=embed-atom-react",
    "data-testid": "react-atom",
    icon: "code",
    type: "code",
    Component: Bt(function({ embedType: t, calLink: n, previewState: o, namespace: r }, i) {
      const { t: a } = kt(), s = xR();
      return i instanceof Function || !i || i.current && !(i.current instanceof HTMLTextAreaElement) ? null : /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("small", { className: "text-subtle flex py-2", children: a("create_update_react_component") }),
        /* @__PURE__ */ m(
          Kw,
          {
            "data-testid": "embed-atom-react",
            ref: i,
            name: "embed-atom-react",
            className: "text-default bg-default h-[calc(100%-50px)] font-mono",
            readOnly: !0,
            style: { resize: "none", overflow: "auto" },
            value: `/* First make sure that you have installed the package */

/* If you are using yarn */
// yarn add @calcom/atoms

/* If you are using npm */
// npm install @calcom/atoms
${CR({
              embedFramework: "react-atom",
              embedType: t,
              calLink: n,
              previewState: o,
              embedCalOrigin: s,
              namespace: r
            })}`
          }
        )
      ] });
    })
  },
  {
    name: "Preview",
    href: "embedTabName=embed-preview",
    icon: "trello",
    type: "iframe",
    "data-testid": "Preview",
    Component: Bt(function({ calLink: t, embedType: n }, o) {
      const r = Jj(), i = `${B8l}?embedType=${n}&calLink=${t}&embedLibUrl=${s2}&bookerUrl=${r}`;
      return o instanceof Function || !o || o.current && !(o.current instanceof HTMLIFrameElement) ? null : /* @__PURE__ */ m(
        "iframe",
        {
          ref: o,
          "data-testid": "embed-preview",
          className: "rounded-md border",
          width: "100%",
          height: "100%",
          src: i
        },
        i
      );
    })
  }
], CR = ({
  embedFramework: e,
  embedType: t,
  calLink: n,
  embedCalOrigin: o,
  previewState: r,
  namespace: i
}) => {
  const a = W8l[e];
  if (!a)
    throw new Error(`No code available for the framework:${e}`);
  if (t === "email")
    return "";
  let s;
  const c = {
    theme: r.theme,
    brandColor: r.palette.brandColor,
    darkBrandColor: r.palette.darkBrandColor,
    hideEventTypeDetails: r.hideEventTypeDetails,
    layout: r.layout
  };
  if (e === "react" ? s = {
    ...c,
    apiName: Dve({ mainApiName: "cal" })
  } : s = {
    ...c,
    apiName: X5({ namespace: i, mainApiName: "Cal" })
  }, !a[t])
    throw new Error(`Code not available for framework:${e} and embedType:${t}`);
  const l = {
    calLink: n,
    uiInstructionCode: Z8l(s),
    embedCalOrigin: o,
    namespace: i
  };
  return t === "inline" ? a[t]({
    ...l,
    previewState: r.inline
  }) : t === "floating-popup" ? a[t]({
    ...l,
    previewState: r.floatingPopup
  }) : t === "element-click" ? a[t]({
    ...l,
    previewState: r.elementClick
  }) : t === "headless" ? a[t]() : "";
}, Z8l = ({
  apiName: e,
  theme: t,
  brandColor: n,
  darkBrandColor: o,
  hideEventTypeDetails: r,
  layout: i
}) => (t = t !== "auto" ? t : void 0, X8l({
  apiName: e,
  instructionName: "ui",
  instructionArg: {
    theme: t,
    cssVarsPerTheme: Lve({ brandColor: n, darkBrandColor: o }),
    hideEventTypeDetails: r,
    layout: i
  }
})), X8l = ({
  apiName: e,
  instructionName: t,
  instructionArg: n
}) => `${e}("${t}", ${JSON.stringify(n)});`;
function J8l(e) {
  const t = Jj();
  return `(function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "${s2}", "init");
Cal("init", ${e ? `"${e}",` : ""} {origin:"${t}"});
`;
}
const Q8l = Cr(null);
function Qj(e) {
  const t = bo(Q8l);
  if (e) {
    if (!t)
      throw new Error("useEmbedDialogCtx must be used within an EmbedDialogProvider");
    return t;
  } else
    return {
      embedState: null,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setEmbedState: (n) => {
      }
    };
}
function Mve(e = !1) {
  const t = Ef(), { embedState: n } = Qj(e);
  return e ? {
    embedType: (n == null ? void 0 : n.embedType) ?? null,
    embedUrl: (n == null ? void 0 : n.embedUrl) ?? "",
    namespace: (n == null ? void 0 : n.namespace) ?? "",
    embedTabName: (n == null ? void 0 : n.embedTabName) ?? null,
    eventId: (n == null ? void 0 : n.eventId) ?? null,
    date: (n == null ? void 0 : n.date) ?? null,
    month: (n == null ? void 0 : n.month) ?? null
  } : {
    embedType: (t == null ? void 0 : t.get("embedType")) ?? null,
    embedUrl: (t == null ? void 0 : t.get("embedUrl")) || "",
    namespace: (t == null ? void 0 : t.get("namespace")) || "",
    embedTabName: (t == null ? void 0 : t.get("embedTabName")) || "",
    eventId: (t == null ? void 0 : t.get("eventId")) || "",
    date: (t == null ? void 0 : t.get("date")) || "",
    month: (t == null ? void 0 : t.get("month")) || ""
  };
}
const Fve = [
  "embedType",
  "embedTabName",
  "embedUrl",
  "eventId",
  "namespace",
  "date",
  "month"
];
function qve({
  timezoneFromBookerStore: e,
  timezoneFromTimePreferences: t,
  userSettingsTimezone: n
}) {
  return e ?? n ?? t;
}
function e7l() {
  const e = Nr.useRouter(), t = Ef(), n = Nr.usePathname();
  return { goto: (i) => {
    const a = new URLSearchParams(t.toString());
    a.delete("slug"), a.delete("pages"), Object.keys(i).forEach((s) => {
      a.set(s, i[s]);
    }), e.push(`${n}?${a.toString()}`);
  }, removeQueryParams: (i) => {
    const a = new URLSearchParams(t.toString());
    i.forEach((s) => {
      a.delete(s);
    }), e.push(`${n}?${a.toString()}`);
  } };
}
function eV(e = !1) {
  const { goto: t, removeQueryParams: n } = e7l(), { setEmbedState: o } = Qj(e);
  return { gotoState: (s) => {
    if (e)
      o((c) => ({
        ...c,
        embedType: s.embedType ?? (c == null ? void 0 : c.embedType) ?? null,
        embedTabName: s.embedTabName ?? (c == null ? void 0 : c.embedTabName) ?? null,
        embedUrl: s.embedUrl ?? (c == null ? void 0 : c.embedUrl) ?? null,
        eventId: s.eventId ?? (c == null ? void 0 : c.eventId) ?? null,
        namespace: s.namespace ?? (c == null ? void 0 : c.namespace) ?? null,
        date: s.date ?? (c == null ? void 0 : c.date) ?? null,
        month: s.month ?? (c == null ? void 0 : c.month) ?? null
      }));
    else {
      const c = Object.fromEntries(
        Object.entries(s).filter(([l, u]) => u !== null)
      );
      t(c);
    }
  }, resetState: () => {
    e ? o(null) : n(["dialog", ...Fve]);
  }, gotoEmbedTypeSelectionState: () => {
    e ? o((s) => ({
      ...s,
      embedType: null,
      embedTabName: null,
      embedUrl: (s == null ? void 0 : s.embedUrl) ?? null,
      eventId: (s == null ? void 0 : s.eventId) ?? null,
      namespace: (s == null ? void 0 : s.namespace) ?? null,
      date: (s == null ? void 0 : s.date) ?? null,
      month: (s == null ? void 0 : s.month) ?? null
    })) : n(["embedType", "embedTabName"]);
  } };
}
const t7l = ({
  children: e,
  ...t
}) => /* @__PURE__ */ de(F_.Control, { ...t, children: [
  /* @__PURE__ */ m(qt, { name: "sun", className: "text-subtle mr-2 h-4 w-4" }),
  e
] }), n7l = ({
  types: e,
  noQueryParamMode: t
}) => {
  const { t: n } = kt(), { gotoState: o } = eV(t);
  return /* @__PURE__ */ de(Ya, { className: "rounded-lg p-10", type: "creation", size: "lg", children: [
    /* @__PURE__ */ de("div", { className: "mb-2", children: [
      /* @__PURE__ */ m("h3", { className: "font-cal text-emphasis mb-2 text-2xl font-semibold leading-none", id: "modal-title", children: n("how_you_want_add_cal_site", { appName: Kp }) }),
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("p", { className: "text-subtle text-sm", children: n("choose_ways_put_cal_site", { appName: Kp }) }) })
    ] }),
    /* @__PURE__ */ m("div", { className: "items-start space-y-2 md:flex md:space-y-0", children: e.map((r, i) => /* @__PURE__ */ de(
      "button",
      {
        className: "hover:bg-subtle bg-muted	w-full self-stretch rounded-md border border-transparent p-6 text-left transition hover:rounded-md ltr:mr-4 ltr:last:mr-0 rtl:ml-4 rtl:last:ml-0 lg:w-1/3",
        "data-testid": r.type,
        onClick: () => {
          r.type === "headless" ? window.open("https://cal.com/help/routing/headless-routing", "_blank") : o({
            embedType: r.type
          });
        },
        children: [
          /* @__PURE__ */ m("div", { className: "bg-default order-none box-border flex-none rounded-md border border-solid transition dark:bg-transparent dark:invert", children: r.illustration }),
          /* @__PURE__ */ m("div", { className: "text-emphasis mt-4 font-semibold", children: r.title }),
          /* @__PURE__ */ m("p", { className: "text-subtle mt-2 text-sm", children: r.subtitle })
        ]
      },
      i
    )) })
  ] });
}, o7l = ({
  eventType: e,
  username: t,
  orgSlug: n,
  isTeamEvent: o,
  selectedDuration: r,
  setSelectedDuration: i,
  userSettingsTimezone: a
}) => {
  var T, D, A, S, E, x;
  const { t: s, i18n: c } = kt(), { timezoneFromBookerStore: l, timezoneFromTimePreferences: u } = Ku(), d = qve({
    timezoneFromBookerStore: l,
    timezoneFromTimePreferences: u,
    userSettingsTimezone: a
  });
  mce({
    username: t,
    eventSlug: (e == null ? void 0 : e.slug) ?? "",
    eventId: e == null ? void 0 : e.id,
    layout: io.MONTH_VIEW,
    org: n,
    isTeamEvent: o
  }), fF({
    username: t,
    eventSlug: (e == null ? void 0 : e.slug) ?? "",
    eventId: e == null ? void 0 : e.id,
    layout: io.MONTH_VIEW,
    org: n,
    isTeamEvent: o
  });
  const [_, p, g] = _n(
    (k) => [k.month, k.selectedDate, k.selectedDatesAndTimes],
    Xi
  ), [f, h, $, v, b] = _n(
    (k) => [
      k.setSelectedDate,
      k.setMonth,
      k.setSelectedDatesAndTimes,
      k.setSelectedTimeslot,
      k.setTimezone
    ],
    Xi
  ), y = Phe(), w = Hcl({
    orgSlug: n,
    eventId: e == null ? void 0 : e.id,
    isTeamEvent: o,
    duration: r,
    useApiV2: !1
  }), N = MA((T = w == null ? void 0 : w.data) == null ? void 0 : T.slots), M = (k) => {
    const { time: I } = k;
    if (!e)
      return null;
    if (g && g[e.slug]) {
      const z = g[e.slug], F = z[p] ?? [];
      if (F != null && F.includes(I)) {
        if ((F == null ? void 0 : F.length) > 1) {
          const O = {
            ...g,
            [e.slug]: {
              ...z,
              [p]: F == null ? void 0 : F.filter((V) => V !== I)
            }
          };
          $(O);
        } else {
          const O = { ...z };
          delete O[p], v(null), $({
            ...g,
            [e.slug]: O
          });
        }
        return;
      }
      const P = {
        ...g,
        [e.slug]: {
          ...z,
          [p]: [...F, I]
        }
      };
      $(P);
    } else
      $(g ? {
        ...g,
        [e.slug]: { [p]: [I] }
      } : { [e.slug]: { [p]: [I] } });
    v(I);
  }, q = Rsl(p, (D = w == null ? void 0 : w.data) == null ? void 0 : D.slots);
  if (!e)
    return null;
  r || i(e.length);
  const R = (((A = e == null ? void 0 : e.metadata) == null ? void 0 : A.multipleDuration) ?? []).map((k) => ({
    label: `${k} ${s("minutes")}`,
    value: k
  }));
  return /* @__PURE__ */ de("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ m("div", { className: "mb-[9px] font-medium", children: /* @__PURE__ */ m(ik, { open: !0, children: /* @__PURE__ */ de(ak, { children: [
      /* @__PURE__ */ m("div", { className: "text-default text-sm", children: s("select_date") }),
      /* @__PURE__ */ m(
        ape,
        {
          isLoading: w.isPending,
          onChange: (k) => {
            f({ date: k === null ? k : k.format("YYYY-MM-DD") });
          },
          onMonthChange: (k) => {
            h(k.format("YYYY-MM")), f({ date: k.format("YYYY-MM-DD") });
          },
          includedDates: N,
          locale: c.language,
          browsingDate: _ ? ht(_) : void 0,
          selected: ht(p),
          weekStart: H_e((x = (E = (S = y == null ? void 0 : y.data) == null ? void 0 : S.subsetOfUsers) == null ? void 0 : E[0]) == null ? void 0 : x.weekStart),
          eventSlug: e == null ? void 0 : e.slug
        }
      )
    ] }) }) }),
    p ? /* @__PURE__ */ m("div", { className: "mt-[9px] font-medium ", children: p ? /* @__PURE__ */ de("div", { className: "flex h-full w-full flex-col gap-4", children: [
      /* @__PURE__ */ m(khe, { date: ht(p) }),
      /* @__PURE__ */ m(
        hhe,
        {
          className: "w-full",
          selectedSlots: e.slug && g && g[e.slug] && g[e.slug][p] ? g[e.slug][p] : void 0,
          handleSlotClick: M,
          slots: q,
          showAvailableSeatsCount: e.seatsShowAvailabilityCount,
          event: y
        }
      )
    ] }) : null }) : null,
    /* @__PURE__ */ m("div", { className: "mb-[9px] font-medium ", children: /* @__PURE__ */ m(ik, { open: !0, children: /* @__PURE__ */ de(ak, { children: [
      /* @__PURE__ */ m("div", { className: "text-default mb-[9px] text-sm", children: s("duration") }),
      R.length > 0 ? /* @__PURE__ */ m(
        Di,
        {
          value: R.find((k) => k.value === r),
          options: R,
          onChange: (k) => {
            i(k == null ? void 0 : k.value), $({});
          }
        }
      ) : /* @__PURE__ */ m(
        xr,
        {
          disabled: !0,
          label: s("duration"),
          defaultValue: (e == null ? void 0 : e.length) ?? 15,
          addOnSuffix: /* @__PURE__ */ m(nt, { children: s("minutes") })
        }
      )
    ] }) }) }),
    /* @__PURE__ */ m("div", { className: "mb-[9px] font-medium ", children: /* @__PURE__ */ m(ik, { open: !0, children: /* @__PURE__ */ de(ak, { children: [
      /* @__PURE__ */ m("div", { className: "text-default mb-[9px] text-sm", children: s("timezone") }),
      /* @__PURE__ */ m(xq, { id: "timezone", value: d, onChange: ({ value: k }) => b(k) })
    ] }) }) })
  ] });
}, r7l = ({
  eventType: e,
  emailContentRef: t,
  username: n,
  month: o,
  selectedDateAndTime: r,
  calLink: i,
  selectedDuration: a,
  userSettingsTimezone: s
}) => {
  const { t: c } = kt(), { timeFormat: l, timezoneFromBookerStore: u, timezoneFromTimePreferences: d } = Ku(), _ = qve({
    timezoneFromBookerStore: u,
    timezoneFromTimePreferences: d,
    userSettingsTimezone: s
  });
  return e ? /* @__PURE__ */ m("div", { className: "flex h-full items-center justify-center border p-5 last:font-medium", children: /* @__PURE__ */ de("div", { className: "border bg-white p-4", children: [
    /* @__PURE__ */ de(
      "div",
      {
        style: {
          paddingBottom: "3px",
          fontSize: "13px",
          color: "black",
          lineHeight: "1.4",
          minWidth: "30vw",
          maxHeight: "50vh",
          overflowY: "auto",
          backgroundColor: "white"
        },
        ref: t,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              style: {
                fontStyle: "normal",
                fontSize: "20px",
                fontWeight: "bold",
                lineHeight: "19px",
                marginTop: "15px",
                marginBottom: "15px"
              },
              children: /* @__PURE__ */ de("b", { style: { color: "black" }, children: [
                " ",
                e.title
              ] })
            }
          ),
          /* @__PURE__ */ de(
            "div",
            {
              style: {
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#333333"
              },
              children: [
                c("duration"),
                ": ",
                /* @__PURE__ */ de("b", { style: { color: "black" }, children: [
                  a,
                  " mins"
                ] })
              ]
            }
          ),
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("b", { style: { color: "black" }, children: /* @__PURE__ */ de(
            "span",
            {
              style: {
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#333333"
              },
              children: [
                c("timezone"),
                ": ",
                /* @__PURE__ */ m("b", { style: { color: "black" }, children: _ })
              ]
            }
          ) }) }),
          /* @__PURE__ */ m("b", { style: { color: "black" }, children: /* @__PURE__ */ de(nt, { children: [
            r && Object.keys(r).sort().map((p) => {
              var h;
              const g = r[p][0], f = ht(g).tz(_).format("dddd, MMMM D, YYYY");
              return /* @__PURE__ */ m(
                "table",
                {
                  style: {
                    marginTop: "16px",
                    textAlign: "left",
                    borderCollapse: "collapse",
                    borderSpacing: "0px"
                  },
                  children: /* @__PURE__ */ de("tbody", { children: [
                    /* @__PURE__ */ m("tr", { children: /* @__PURE__ */ m("td", { style: { textAlign: "left", marginTop: "16px" }, children: /* @__PURE__ */ de(
                      "span",
                      {
                        style: {
                          fontSize: "14px",
                          lineHeight: "16px",
                          paddingBottom: "8px",
                          color: "rgb(26, 26, 26)",
                          fontWeight: "bold"
                        },
                        children: [
                          f,
                          " "
                        ]
                      }
                    ) }) }),
                    /* @__PURE__ */ m("tr", { children: /* @__PURE__ */ m("td", { children: /* @__PURE__ */ m("table", { style: { borderCollapse: "separate", borderSpacing: "0px 4px" }, children: /* @__PURE__ */ m("tbody", { children: /* @__PURE__ */ m("tr", { style: { height: "25px" }, children: ((h = r[p]) == null ? void 0 : h.length) > 0 && r[p].map(($) => {
                      const v = `${e.bookerUrl}/${e.teamId !== null ? "team/" : ""}${n}/${e.slug}?duration=${a}&date=${p}&month=${o}&slot=${$}&cal.tz=${_}`;
                      return /* @__PURE__ */ m(
                        "td",
                        {
                          style: {
                            padding: "0px",
                            width: "64px",
                            display: "inline-block",
                            marginRight: "4px",
                            marginBottom: "4px",
                            height: "24px",
                            border: "1px solid #111827",
                            borderRadius: "3px"
                          },
                          children: /* @__PURE__ */ m("table", { style: { height: "21px" }, children: /* @__PURE__ */ m("tbody", { children: /* @__PURE__ */ de("tr", { style: { height: "21px" }, children: [
                            /* @__PURE__ */ m("td", { style: { width: "7px" } }),
                            /* @__PURE__ */ m(
                              "td",
                              {
                                style: {
                                  width: "50px",
                                  textAlign: "center",
                                  marginRight: "1px"
                                },
                                children: /* @__PURE__ */ m(
                                  "a",
                                  {
                                    href: v,
                                    className: "spot",
                                    style: {
                                      fontFamily: '"Proxima Nova", sans-serif',
                                      textDecoration: "none",
                                      textAlign: "center",
                                      color: "#111827",
                                      fontSize: "12px",
                                      lineHeight: "16px"
                                    },
                                    children: /* @__PURE__ */ de(
                                      "b",
                                      {
                                        style: {
                                          fontWeight: "normal",
                                          textDecoration: "none"
                                        },
                                        children: [
                                          ht.utc($).tz(_).format(l),
                                          " "
                                        ]
                                      }
                                    )
                                  }
                                )
                              }
                            )
                          ] }) }) })
                        },
                        $
                      );
                    }) }) }) }) }) })
                  ] })
                },
                p
              );
            }),
            /* @__PURE__ */ m("div", { style: { marginTop: "13px" }, children: /* @__PURE__ */ m(
              "a",
              {
                className: "more",
                "data-testid": "see_all_available_times",
                href: `${e.bookerUrl}/${i}?cal.tz=${_}`,
                style: {
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "black"
                },
                children: c("see_all_available_times")
              }
            ) })
          ] }) }),
          /* @__PURE__ */ de(
            "div",
            {
              className: "w-full text-right",
              style: {
                borderTop: "1px solid #CCCCCC",
                marginTop: "8px",
                paddingTop: "8px"
              },
              children: [
                /* @__PURE__ */ m("span", { children: c("powered_by") }),
                " ",
                /* @__PURE__ */ m("b", { style: { color: "black" }, children: /* @__PURE__ */ m("span", { children: " Cal.com" }) })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ m("b", { style: { color: "black" } })
  ] }) }) : null;
}, i7l = ({
  embedType: e,
  embedUrl: t,
  tabs: n,
  namespace: o,
  eventTypeHideOptionDisabled: r,
  types: i,
  defaultBrandColor: a,
  noQueryParamMode: s
}) => {
  var Q, me;
  const { t: c } = kt(), l = Ef(), u = Nr.usePathname(), { resetState: d, gotoState: _, gotoEmbedTypeSelectionState: p } = eV(s), g = xt(null), f = xt(null), h = xt(null), { data: $ } = ru.useSession(), [v, b] = _n(
    (ne) => [ne.month, ne.selectedDatesAndTimes],
    Xi
  ), y = Mve(s), w = y.eventId, N = parseInt(w ?? "", 10), M = decodeURIComponent(t), { data: q } = hr.viewer.eventTypes.get.useQuery(
    { id: N },
    { enabled: !Number.isNaN(N) && e === "email", refetchOnWindowFocus: !1 }
  ), { data: L } = hr.viewer.me.get.useQuery(), R = q != null && q.team ? q.team.slug : null, T = (ne) => {
    const pe = new URLSearchParams(l.toString()), [ge, ve] = ne.split("=");
    return pe.set(ge, ve), `${(u == null ? void 0 : u.split("?")[0]) ?? ""}?${pe.toString()}`;
  }, D = n.map((ne) => {
    const { href: pe, ...ge } = ne, ve = pe.split("=")[1];
    return {
      ...ge,
      isActive: ve === y.embedTabName,
      ...s ? {
        onClick: () => {
          _({ embedTabName: ve });
        },
        // We still pass the href(which is unique) so that all the tabs aren't marked as active
        href: ne.href
      } : {
        href: T(ne.href)
      }
    };
  }), A = {};
  n.filter((ne) => ne.type === "code").forEach((ne) => {
    A[ne.name] = CSe();
  });
  const S = xt(A), E = i.find((ne) => ne.type === e), [x, k] = it(q == null ? void 0 : q.eventType.length), [I, z] = it(!0), [F, P] = it(!0), O = {
    layout: io.MONTH_VIEW
  }, V = (ne) => ne === "brandColor" ? (a == null ? void 0 : a.brandColor) ?? _F : ne === "darkBrandColor" ? (a == null ? void 0 : a.darkBrandColor) ?? pF : "#000000", [U, H] = it({
    inline: {
      width: "100%",
      height: "100%",
      config: O
    },
    theme: Nw.auto,
    layout: O.layout,
    floatingPopup: {
      config: O
    },
    elementClick: {
      config: O
    },
    hideEventTypeDetails: !1,
    palette: {
      brandColor: (a == null ? void 0 : a.brandColor) ?? null,
      darkBrandColor: (a == null ? void 0 : a.darkBrandColor) ?? null
    }
  }), J = () => {
    d();
  };
  if (y.embedTabName || _({
    embedTabName: "embed-code"
  }), !E || !t)
    return J(), null;
  const le = (ne) => {
    H((pe) => ({
      ...pe,
      palette: {
        ...pe.palette,
        ...ne
      }
    }));
  }, ae = (ne) => {
    var pe, ge;
    (ge = (pe = g.current) == null ? void 0 : pe.contentWindow) == null || ge.postMessage(
      {
        mode: "cal:preview",
        type: "instruction",
        instruction: ne
      },
      "*"
    );
  }, Y = ({ width: ne, height: pe }) => {
    var ge, ve;
    (ve = (ge = g.current) == null ? void 0 : ge.contentWindow) == null || ve.postMessage(
      {
        mode: "cal:preview",
        type: "inlineEmbedDimensionUpdate",
        data: {
          width: Ly(ne),
          height: Ly(pe)
        }
      },
      "*"
    );
  };
  ae({
    name: "ui",
    arg: {
      theme: U.theme,
      layout: U.layout,
      hideEventTypeDetails: U.hideEventTypeDetails,
      cssVarsPerTheme: Lve({
        brandColor: U.palette.brandColor,
        darkBrandColor: U.palette.darkBrandColor
      })
    }
  });
  const re = () => {
    const ne = h.current;
    if (ne !== null) {
      const pe = document.createRange();
      pe.selectNode(ne);
      const ge = window.getSelection();
      ge && (ge.removeAllRanges(), ge.addRange(pe), document.execCommand("copy"), ge.removeAllRanges()), ti(c("code_copied"), "success");
    }
  };
  e === "floating-popup" && ae({
    name: "floatingButton",
    arg: {
      attributes: {
        id: "my-floating-button"
      },
      ...U.floatingPopup
    }
  }), e === "inline" && Y({
    width: U.inline.width,
    height: U.inline.height
  });
  const ie = [
    { value: Nw.auto, label: "Auto" },
    { value: Nw.dark, label: "Dark Theme" },
    { value: Nw.light, label: "Light Theme" }
  ], _e = [
    { value: io.MONTH_VIEW, label: c("bookerlayout_month_view") },
    { value: io.WEEK_VIEW, label: c("bookerlayout_week_view") },
    { value: io.COLUMN_VIEW, label: c("bookerlayout_column_view") }
  ], he = [
    {
      value: "bottom-right",
      label: "Bottom right"
    },
    {
      value: "bottom-left",
      label: "Bottom left"
    }
  ], be = n.find((ne) => ne.name === "Preview");
  return /* @__PURE__ */ m(
    Ya,
    {
      enableOverflow: !0,
      ref: f,
      className: "rounded-lg p-0.5 sm:max-w-[80rem]",
      type: "creation",
      children: /* @__PURE__ */ de("div", { className: "flex", children: [
        /* @__PURE__ */ de("div", { className: "bg-muted flex h-[95vh] w-1/3 flex-col overflow-y-auto p-8", children: [
          /* @__PURE__ */ de(
            "h3",
            {
              className: "text-emphasis mb-2.5 flex items-center text-xl font-semibold leading-5",
              id: "modal-title",
              children: [
                /* @__PURE__ */ m("button", { className: "h-6 w-6", onClick: p, children: /* @__PURE__ */ m(qt, { name: "arrow-left", className: "mr-4 w-4" }) }),
                E.title
              ]
            }
          ),
          /* @__PURE__ */ m("h4", { className: "text-subtle mb-6 text-sm font-normal", children: E.subtitle }),
          q != null && q.eventType && e === "email" ? /* @__PURE__ */ m(
            o7l,
            {
              eventType: q == null ? void 0 : q.eventType,
              username: R ?? ($ == null ? void 0 : $.user.username),
              userSettingsTimezone: L == null ? void 0 : L.timeZone,
              orgSlug: (me = (Q = $ == null ? void 0 : $.user) == null ? void 0 : Q.org) == null ? void 0 : me.slug,
              isTeamEvent: !!R,
              selectedDuration: x,
              setSelectedDuration: k
            }
          ) : /* @__PURE__ */ de("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ m("div", { className: Ia("font-medium", e === "element-click" ? "hidden" : ""), children: /* @__PURE__ */ m(
              ik,
              {
                open: I,
                onOpenChange: () => z((ne) => !ne),
                children: /* @__PURE__ */ de(ak, { className: "text-sm", children: [
                  e === "inline" && y.embedTabName !== zw.ATOM_REACT && /* @__PURE__ */ de("div", { children: [
                    /* @__PURE__ */ m("div", { className: "text-default mb-[9px] text-sm", children: "Window sizing" }),
                    /* @__PURE__ */ de("div", { className: "justify-left mb-6 flex items-center !font-normal ", children: [
                      /* @__PURE__ */ m("div", { className: "mr-[9px]", children: /* @__PURE__ */ m(
                        xr,
                        {
                          labelProps: { className: "hidden" },
                          className: "focus:ring-offset-0",
                          required: !0,
                          value: U.inline.width,
                          onChange: (ne) => {
                            H((pe) => {
                              const ge = ne.target.value || "100%";
                              return {
                                ...pe,
                                inline: {
                                  ...pe.inline,
                                  width: ge
                                }
                              };
                            });
                          },
                          addOnLeading: /* @__PURE__ */ m(nt, { children: "W" })
                        }
                      ) }),
                      /* @__PURE__ */ m(
                        xr,
                        {
                          labelProps: { className: "hidden" },
                          className: "focus:ring-offset-0",
                          value: U.inline.height,
                          required: !0,
                          onChange: (ne) => {
                            const pe = ne.target.value || "100%";
                            H((ge) => ({
                              ...ge,
                              inline: {
                                ...ge.inline,
                                height: pe
                              }
                            }));
                          },
                          addOnLeading: /* @__PURE__ */ m(nt, { children: "H" })
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ de(
                    "div",
                    {
                      className: Ia(
                        "items-center justify-between",
                        e === "floating-popup" ? "text-emphasis" : "hidden"
                      ),
                      children: [
                        /* @__PURE__ */ m("div", { className: "mb-2 text-sm", children: "Button text" }),
                        /* @__PURE__ */ m(
                          xr,
                          {
                            labelProps: { className: "hidden" },
                            onChange: (ne) => {
                              H((pe) => ({
                                ...pe,
                                floatingPopup: {
                                  ...pe.floatingPopup,
                                  buttonText: ne.target.value
                                }
                              }));
                            },
                            defaultValue: c("book_my_cal"),
                            required: !0
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ de(
                    "div",
                    {
                      className: Ia(
                        "mt-4 flex items-center justify-start",
                        e === "floating-popup" ? "text-emphasis space-x-2 rtl:space-x-reverse" : "hidden"
                      ),
                      children: [
                        /* @__PURE__ */ m(
                          as,
                          {
                            defaultChecked: !0,
                            onCheckedChange: (ne) => {
                              H((pe) => ({
                                ...pe,
                                floatingPopup: {
                                  ...pe.floatingPopup,
                                  hideButtonIcon: !ne
                                }
                              }));
                            }
                          }
                        ),
                        /* @__PURE__ */ m("div", { className: "text-default my-2 text-sm", children: "Display calendar icon" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ de(
                    "div",
                    {
                      className: Ia(
                        "mt-4 items-center justify-between",
                        e === "floating-popup" ? "text-emphasis" : "hidden"
                      ),
                      children: [
                        /* @__PURE__ */ m("div", { className: "mb-2", children: "Position of button" }),
                        /* @__PURE__ */ m(
                          Di,
                          {
                            onChange: (ne) => {
                              H((pe) => ({
                                ...pe,
                                floatingPopup: {
                                  ...pe.floatingPopup,
                                  buttonPosition: ne == null ? void 0 : ne.value
                                }
                              }));
                            },
                            defaultValue: he[0],
                            options: he
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ de("div", { className: "mt-3 flex flex-col xl:flex-row xl:justify-between", children: [
                    /* @__PURE__ */ de("div", { className: Ia("mt-4", e === "floating-popup" ? "" : "hidden"), children: [
                      /* @__PURE__ */ m("div", { className: "whitespace-nowrap", children: "Button color" }),
                      /* @__PURE__ */ m("div", { className: "mt-2 w-40 xl:mt-0 xl:w-full", children: /* @__PURE__ */ m(
                        Xw,
                        {
                          className: "w-[130px]",
                          popoverAlign: "start",
                          container: (f == null ? void 0 : f.current) ?? void 0,
                          defaultValue: "#000000",
                          onChange: (ne) => {
                            H((pe) => ({
                              ...pe,
                              floatingPopup: {
                                ...pe.floatingPopup,
                                buttonColor: ne
                              }
                            }));
                          }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ de("div", { className: Ia("mt-4", e === "floating-popup" ? "" : "hidden"), children: [
                      /* @__PURE__ */ m("div", { className: "whitespace-nowrap", children: "Text color" }),
                      /* @__PURE__ */ m("div", { className: "mb-6 mt-2 w-40 xl:mt-0 xl:w-full", children: /* @__PURE__ */ m(
                        Xw,
                        {
                          className: "w-[130px]",
                          popoverAlign: "start",
                          container: (f == null ? void 0 : f.current) ?? void 0,
                          defaultValue: "#000000",
                          onChange: (ne) => {
                            H((pe) => ({
                              ...pe,
                              floatingPopup: {
                                ...pe.floatingPopup,
                                buttonTextColor: ne
                              }
                            }));
                          }
                        }
                      ) })
                    ] })
                  ] })
                ] })
              }
            ) }),
            /* @__PURE__ */ m("div", { className: "font-medium", children: /* @__PURE__ */ m(
              ik,
              {
                open: F,
                onOpenChange: () => P((ne) => !ne),
                children: /* @__PURE__ */ m(ak, { children: /* @__PURE__ */ de("div", { className: "text-sm", children: [
                  y.embedTabName !== zw.ATOM_REACT && /* @__PURE__ */ de(Ko, { className: "mb-6", children: [
                    /* @__PURE__ */ m("div", { className: "mb-2", children: "EmbedTheme" }),
                    /* @__PURE__ */ m(
                      Di,
                      {
                        className: "w-full",
                        defaultValue: ie[0],
                        components: {
                          Control: t7l,
                          IndicatorSeparator: () => null
                        },
                        onChange: (ne) => {
                          ne && H((pe) => {
                            const ge = (ve) => ({
                              ...ve ?? {},
                              theme: ne.value
                            });
                            return {
                              ...pe,
                              inline: {
                                ...pe.inline,
                                config: ge(pe.inline.config)
                              },
                              floatingPopup: {
                                ...pe.floatingPopup,
                                config: ge(pe.floatingPopup.config)
                              },
                              elementClick: {
                                ...pe.elementClick,
                                config: ge(pe.elementClick.config)
                              },
                              // Keep updating top-level theme for preview iframe
                              theme: ne.value
                            };
                          });
                        },
                        options: ie
                      }
                    )
                  ] }),
                  !r && y.embedTabName !== zw.ATOM_REACT ? /* @__PURE__ */ de("div", { className: "mb-6 flex items-center justify-start space-x-2 rtl:space-x-reverse", children: [
                    /* @__PURE__ */ m(
                      as,
                      {
                        checked: U.hideEventTypeDetails,
                        onCheckedChange: (ne) => {
                          H((pe) => ({
                            ...pe,
                            hideEventTypeDetails: ne
                          }));
                        }
                      }
                    ),
                    /* @__PURE__ */ m("div", { className: "text-default text-sm", children: c("hide_eventtype_details") })
                  ] }) : null,
                  y.embedTabName !== zw.ATOM_REACT && [
                    { name: "brandColor", title: "light_brand_color" },
                    { name: "darkBrandColor", title: "dark_brand_color" }
                    // { name: "lightColor", title: "Light Color" },
                    // { name: "lighterColor", title: "Lighter Color" },
                    // { name: "lightestColor", title: "Lightest Color" },
                    // { name: "highlightColor", title: "Highlight Color" },
                    // { name: "medianColor", title: "Median Color" },
                  ].map((ne) => /* @__PURE__ */ de(Ko, { className: "mb-6", children: [
                    /* @__PURE__ */ m("div", { className: "mb-2", children: c(ne.title) }),
                    /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m(
                      Xw,
                      {
                        popoverAlign: "start",
                        container: (f == null ? void 0 : f.current) ?? void 0,
                        defaultValue: V(ne.name),
                        onChange: (pe) => {
                          le({
                            [ne.name]: pe
                          });
                        }
                      }
                    ) })
                  ] }, ne.name)),
                  /* @__PURE__ */ de(Ko, { className: "mb-6", children: [
                    /* @__PURE__ */ m("div", { className: "mb-2", children: c("layout") }),
                    /* @__PURE__ */ m(
                      Di,
                      {
                        className: "w-full",
                        defaultValue: _e[0],
                        onChange: (ne) => {
                          ne && H((pe) => {
                            const ge = (ve) => ({
                              ...ve ?? {},
                              layout: ne.value
                            });
                            return {
                              ...pe,
                              inline: {
                                ...pe.inline,
                                config: ge(pe.inline.config)
                              },
                              floatingPopup: {
                                ...pe.floatingPopup,
                                config: ge(pe.floatingPopup.config)
                              },
                              elementClick: {
                                ...pe.elementClick,
                                config: ge(pe.elementClick.config)
                              },
                              // Keep updating top-level layout for preview iframe
                              layout: ne.value
                            };
                          });
                        },
                        options: _e
                      }
                    )
                  ] })
                ] }) })
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ de("div", { className: "flex h-[95vh] w-2/3 flex-col px-8 pt-8", children: [
          /* @__PURE__ */ m(
            Rve,
            {
              "data-testid": "embed-tabs",
              tabs: e === "email" ? D.filter((ne) => ne.name === "Preview") : D.filter((ne) => ne.name !== "Preview"),
              linkShallow: !0
            }
          ),
          /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ de("div", { className: "flex h-full flex-col", children: [
              n.map((ne) => {
                if (e !== "email")
                  return ne.name === "Preview" ? null : /* @__PURE__ */ de(
                    "div",
                    {
                      className: Ia(
                        y.embedTabName === ne.href.split("=")[1] ? "flex-1" : "hidden"
                      ),
                      children: [
                        ne.type === "code" && /* @__PURE__ */ m(
                          ne.Component,
                          {
                            namespace: o,
                            embedType: e,
                            calLink: M,
                            previewState: U,
                            ref: S.current[ne.name]
                          }
                        ),
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: y.embedTabName === "embed-preview" ? "mt-2 block" : "hidden"
                          }
                        )
                      ]
                    },
                    ne.href
                  );
                if (!(e === "email" && (ne.name !== "Preview" || !(q != null && q.eventType))))
                  return /* @__PURE__ */ de("div", { className: Ia("flex flex-grow flex-col"), children: [
                    /* @__PURE__ */ m("div", { className: "flex h-[55vh] flex-grow flex-col", children: /* @__PURE__ */ m(
                      r7l,
                      {
                        selectedDuration: x,
                        calLink: M,
                        eventType: q == null ? void 0 : q.eventType,
                        emailContentRef: h,
                        username: R ?? ($ == null ? void 0 : $.user.username),
                        userSettingsTimezone: L == null ? void 0 : L.timeZone,
                        month: v,
                        selectedDateAndTime: b ? b[q == null ? void 0 : q.eventType.slug] : {}
                      }
                    ) }),
                    /* @__PURE__ */ m("div", { className: y.embedTabName === "embed-preview" ? "mt-2 block" : "hidden" })
                  ] }, ne.href);
              }),
              e !== "email" && be && /* @__PURE__ */ m("div", { className: "flex-1", children: /* @__PURE__ */ m(
                be.Component,
                {
                  namespace: o,
                  embedType: e,
                  calLink: M,
                  previewState: U,
                  ref: g
                }
              ) })
            ] }),
            /* @__PURE__ */ de(Wu, { className: "mt-10 flex-row-reverse gap-x-2", showDivider: !0, children: [
              /* @__PURE__ */ m(Gs, {}),
              /* @__PURE__ */ m(
                Jt,
                {
                  type: "submit",
                  onClick: () => {
                    var ne;
                    if (e === "email")
                      re();
                    else {
                      const pe = y.embedTabName, ge = (ne = n.find(
                        (Te) => Te.href === `embedTabName=${pe}`
                      )) == null ? void 0 : ne.name;
                      if (!ge)
                        return;
                      const ve = S.current[ge].current;
                      if (!ve)
                        return;
                      navigator.clipboard.writeText(ve.value), ti(c("code_copied"), "success");
                    }
                  },
                  children: c(e === "email" ? "copy" : "copy_code")
                }
              )
            ] })
          ] })
        ] })
      ] })
    }
  );
}, a7l = ({
  types: e,
  tabs: t,
  eventTypeHideOptionDisabled: n,
  defaultBrandColor: o,
  noQueryParamMode: r = !1
}) => {
  const { embedState: i, setEmbedState: a } = Qj(r), s = Mve(r), c = () => {
    r && a(null);
  };
  return /* @__PURE__ */ m(Wy, { children: /* @__PURE__ */ m(
    Ss,
    {
      ...r ? {
        open: i !== null,
        onOpenChange: (l) => !l && c()
      } : {
        // Must not set name when noQueryParam mode as required by Dialog component
        name: "embed",
        clearQueryParamsOnClose: Fve
      },
      children: s.embedType ? /* @__PURE__ */ m(
        i7l,
        {
          embedType: s.embedType,
          embedUrl: s.embedUrl,
          namespace: s.namespace,
          tabs: t,
          types: e,
          eventTypeHideOptionDisabled: n,
          defaultBrandColor: o,
          noQueryParamMode: r
        }
      ) : /* @__PURE__ */ m(n7l, { types: e, noQueryParamMode: r })
    }
  ) });
}, s7l = ({
  embedUrl: e,
  children: t,
  className: n = "",
  as: o,
  eventId: r,
  namespace: i,
  noQueryParamMode: a,
  ...s
}) => {
  const { gotoState: c } = eV(a);
  return n = Ia("hidden lg:inline-flex", n), /* @__PURE__ */ m(
    o ?? Jt,
    {
      ...s,
      className: n,
      "data-test-embed-url": e,
      "data-testid": "embed",
      type: "button",
      onClick: () => {
        c({
          dialog: "embed",
          eventId: r ? r.toString() : "",
          namespace: i,
          embedUrl: e
        });
      },
      children: t
    }
  );
}, c7l = () => {
  const e = Y8l(), { data: t } = hr.viewer.me.get.useQuery();
  return /* @__PURE__ */ m(
    a7l,
    {
      types: e,
      tabs: K8l,
      eventTypeHideOptionDisabled: !1,
      defaultBrandColor: t ? { brandColor: t.brandColor, darkBrandColor: t.darkBrandColor } : null
    }
  );
}, l7l = (e) => /* @__PURE__ */ m(s7l, { ...e });
function u7l({
  isManagedEvent: e,
  eventTypeId: t,
  open: n,
  onOpenChange: o,
  onDelete: r,
  isDeleting: i
}) {
  const { t: a } = kt();
  return /* @__PURE__ */ m(Ss, { open: n, onOpenChange: o, children: /* @__PURE__ */ m(
    pv,
    {
      isPending: i,
      variety: "danger",
      title: a(`delete${e}_event_type`),
      confirmBtnText: a("confirm_delete_event_type"),
      loadingText: a("confirm_delete_event_type"),
      onConfirm: (s) => {
        s.preventDefault(), r(t);
      },
      children: /* @__PURE__ */ m("p", { className: "mt-5", children: e ? /* @__PURE__ */ de("ul", { className: "ml-4 list-disc", children: [
        /* @__PURE__ */ m("li", { children: a("delete_managed_event_type_description_1") }),
        /* @__PURE__ */ m("li", { children: a("delete_managed_event_type_description_2") })
      ] }) : a("delete_event_type_description") })
    }
  ) });
}
function d7l({
  children: e,
  eventType: t,
  currentUserMembership: n,
  team: o,
  disableBorder: r,
  isUpdateMutationLoading: i,
  formMethods: a,
  isUserOrganizationAdmin: s,
  bookerUrl: c,
  onDelete: l,
  isDeleting: u,
  isPlatform: d,
  tabsNavigation: _,
  allowDelete: p = !0,
  saveButtonRef: g
}) {
  var D, A, S, E, x;
  const { t: f } = kt(), h = (S = (A = (D = t.team) == null ? void 0 : D.parent) == null ? void 0 : A.organizationSettings) == null ? void 0 : S.lockEventTypeCreationForUsers, [$, v] = it(!1), b = (n == null ? void 0 : n.role) !== "MEMBER" || !n || a.getValues("schedulingType") === Bs.MANAGED || s, { isManagedEventType: y, isChildrenManagedEventType: w } = Bg({
    eventType: t,
    translate: f,
    formMethods: a
  }), N = _, M = `${c}/${o ? `${o.parentId ? "" : "team/"}${o.slug}` : a.getValues("users")[0].username}/${t.slug}`, q = `${o ? `team/${o.slug}` : a.getValues("users")[0].username}/${a.getValues("slug")}`, L = a.getValues("schedulingType") === Bs.MANAGED ? "_managed" : "", [R] = vn(() => d ? [Jme] : [Zme], [d]), T = (E = t.team) == null ? void 0 : E.id;
  return /* @__PURE__ */ de(
    R,
    {
      backPath: T ? `/event-types?teamId=${T}` : "/event-types",
      title: `${t.title} | ${f("event_type")}`,
      heading: t.title,
      CTA: /* @__PURE__ */ de("div", { className: "flex items-center justify-end", children: [
        !((x = a.getValues("metadata")) != null && x.managedEventConfig) && /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ de(
            "div",
            {
              className: xe(
                "sm:hover:bg-muted hidden cursor-pointer items-center rounded-md transition",
                a.watch("hidden") ? "pl-2" : "",
                "lg:flex"
              ),
              children: [
                a.watch("hidden") && /* @__PURE__ */ m(
                  Gl,
                  {
                    as: Ko,
                    htmlFor: "hiddenSwitch",
                    className: "mt-2 hidden cursor-pointer self-center whitespace-nowrap pr-2 sm:inline",
                    children: f("hidden")
                  }
                ),
                /* @__PURE__ */ m(
                  Sr,
                  {
                    sideOffset: 4,
                    content: a.watch("hidden") ? f("show_eventtype_on_profile") : f("hide_from_profile"),
                    side: "bottom",
                    children: /* @__PURE__ */ m("div", { className: "self-center rounded-md p-2", children: /* @__PURE__ */ m(
                      as,
                      {
                        id: "hiddenSwitch",
                        disabled: h,
                        checked: !a.watch("hidden"),
                        onCheckedChange: (k) => {
                          a.setValue("hidden", !k, { shouldDirty: !0 });
                        }
                      }
                    ) })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ m(PC, { className: "hidden lg:block" })
        ] }),
        /* @__PURE__ */ de($A, { combined: !0, containerProps: { className: "border-default hidden lg:flex" }, children: [
          !y && /* @__PURE__ */ de(nt, { children: [
            !d && /* @__PURE__ */ m(Sr, { content: f("preview"), side: "bottom", sideOffset: 4, children: /* @__PURE__ */ m(
              Jt,
              {
                color: "secondary",
                "data-testid": "preview-button",
                target: "_blank",
                variant: "icon",
                href: M,
                rel: "noreferrer",
                StartIcon: "external-link"
              }
            ) }),
            !d && /* @__PURE__ */ m(
              Jt,
              {
                color: "secondary",
                variant: "icon",
                StartIcon: "link",
                tooltip: f("copy_link"),
                tooltipSide: "bottom",
                tooltipOffset: 4,
                onClick: () => {
                  navigator.clipboard.writeText(M), ti("Link copied!", "success");
                }
              }
            ),
            !d && /* @__PURE__ */ m(
              l7l,
              {
                embedUrl: encodeURIComponent(q),
                StartIcon: "code",
                color: "secondary",
                variant: "icon",
                namespace: t.slug,
                tooltip: f("embed"),
                tooltipSide: "bottom",
                tooltipOffset: 4,
                eventId: a.getValues("id")
              }
            )
          ] }),
          !w && p && /* @__PURE__ */ m(
            Jt,
            {
              color: "destructive",
              variant: "icon",
              StartIcon: "trash",
              tooltip: f("delete"),
              tooltipSide: "bottom",
              tooltipOffset: 4,
              disabled: !b,
              onClick: () => v(!0)
            }
          )
        ] }),
        (!d || d && p) && /* @__PURE__ */ m(PC, { className: "hidden lg:block" }),
        /* @__PURE__ */ de(jd, { children: [
          /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(Jt, { className: "lg:hidden", StartIcon: "ellipsis", variant: "icon", color: "secondary" }) }),
          /* @__PURE__ */ de(Yu, { style: { minWidth: "200px" }, children: [
            /* @__PURE__ */ m(Pi, { className: "focus:ring-muted", children: /* @__PURE__ */ m(
              ba,
              {
                target: "_blank",
                type: "button",
                StartIcon: "external-link",
                href: M,
                rel: "noreferrer",
                children: f("preview")
              }
            ) }),
            /* @__PURE__ */ m(Pi, { className: "focus:ring-muted", children: /* @__PURE__ */ m(
              ba,
              {
                type: "button",
                StartIcon: "link",
                onClick: () => {
                  navigator.clipboard.writeText(M), ti("Link copied!", "success");
                },
                children: f("copy_link")
              }
            ) }),
            p && /* @__PURE__ */ m(Pi, { className: "focus:ring-muted", children: /* @__PURE__ */ m(
              ba,
              {
                type: "button",
                color: "destructive",
                StartIcon: "trash",
                disabled: !b,
                onClick: () => v(!0),
                children: f("delete")
              }
            ) }),
            /* @__PURE__ */ m(EC, {}),
            /* @__PURE__ */ de("div", { className: "hover:bg-subtle flex h-9 cursor-pointer flex-row items-center justify-between px-4 py-2 transition", children: [
              /* @__PURE__ */ m(
                Gl,
                {
                  as: Ko,
                  htmlFor: "hiddenSwitch",
                  className: "mt-2 inline cursor-pointer self-center pr-2 ",
                  children: a.watch("hidden") ? f("show_eventtype_on_profile") : f("hide_from_profile")
                }
              ),
              /* @__PURE__ */ m(
                as,
                {
                  id: "hiddenSwitch",
                  checked: !a.watch("hidden"),
                  onCheckedChange: (k) => {
                    a.setValue("hidden", !k, { shouldDirty: !0 });
                  }
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ m("div", { className: "border-default border-l-2" }),
        /* @__PURE__ */ m(
          Jt,
          {
            ref: g,
            className: "ml-4 lg:ml-0",
            type: "submit",
            loading: i,
            disabled: !a.formState.isDirty,
            "data-testid": "update-eventtype",
            form: "event-type-form",
            children: f("save")
          }
        )
      ] }),
      children: [
        /* @__PURE__ */ m(hT, { fallback: /* @__PURE__ */ m("div", { className: "flex h-64 items-center justify-center", children: /* @__PURE__ */ m(qt, { name: "loader", className: "h-5 w-5 animate-spin" }) }), children: /* @__PURE__ */ de("div", { className: "flex flex-col xl:flex-row xl:space-x-6", children: [
          /* @__PURE__ */ m("div", { className: "hidden xl:block", children: /* @__PURE__ */ m(
            V8l,
            {
              className: "primary-navigation w-64",
              tabs: N,
              sticky: !0,
              linkShallow: !0,
              itemClassname: "items-start"
            }
          ) }),
          /* @__PURE__ */ m("div", { className: "p-2 md:mx-0 md:p-0 xl:hidden", children: /* @__PURE__ */ m(Rve, { tabs: N, linkShallow: !0 }) }),
          /* @__PURE__ */ m("div", { className: "w-full ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m(
            "div",
            {
              className: xe(
                "bg-default border-subtle  mt-4 rounded-md sm:mx-0 xl:mt-0",
                r ? "border-0 " : "p-2 md:border md:p-6"
              ),
              children: e
            }
          ) })
        ] }) }),
        /* @__PURE__ */ m(
          u7l,
          {
            eventTypeId: t.id,
            isManagedEvent: L,
            open: $,
            onOpenChange: v,
            onDelete: l,
            isDeleting: u
          }
        ),
        !d && /* @__PURE__ */ m(c7l, {})
      ]
    }
  );
}
const _7l = ({
  formMethods: e,
  isPlatform: t,
  tabName: n,
  eventType: o,
  team: r,
  currentUserMembership: i,
  tabMap: a,
  isUpdating: s,
  isUserOrganizationAdmin: c,
  onDelete: l,
  isDeleting: u,
  tabsNavigation: d,
  handleSubmit: _,
  children: p,
  allowDelete: g = !0,
  saveButtonRef: f
}) => {
  const [h] = qd();
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      d7l,
      {
        eventType: o,
        team: r,
        isUpdateMutationLoading: s,
        formMethods: e,
        disableBorder: !0,
        currentUserMembership: i,
        bookerUrl: o.bookerUrl,
        isUserOrganizationAdmin: c,
        onDelete: l,
        isDeleting: u,
        isPlatform: t,
        allowDelete: g,
        tabsNavigation: d,
        saveButtonRef: f,
        children: /* @__PURE__ */ m(Y_, { form: e, id: "event-type-form", handleSubmit: _, children: /* @__PURE__ */ m("div", { ref: h, children: a[n] }) })
      }
    ),
    p
  ] });
};
function p7l(e) {
  const { t } = kt(), { slugExistsChildrenDialogOpen: n, slug: o, onOpenChange: r, isPending: i, onConfirm: a } = e;
  return /* @__PURE__ */ m(_v, { open: n.length > 0, onOpenChange: r, children: /* @__PURE__ */ de(
    pv,
    {
      isPending: i,
      variety: "warning",
      title: t("managed_event_dialog_title", {
        slug: o,
        count: n.length
      }),
      confirmBtnText: t("managed_event_dialog_confirm_button", {
        count: n.length
      }),
      cancelBtnText: t("go_back"),
      onConfirm: a,
      children: [
        /* @__PURE__ */ m("p", { className: "mt-5", children: /* @__PURE__ */ m(
          Ld,
          {
            t,
            i18nKey: n.length > 1 ? "managed_event_dialog_information_other" : "managed_event_dialog_information_one",
            values: {
              names: `${n.map((s) => s.owner.name).slice(0, -1).join(", ")} ${n.length > 1 ? t("and") : ""} ${n.map((s) => s.owner.name).slice(-1)}`,
              slug: o
            }
          }
        ) }),
        " ",
        /* @__PURE__ */ m("p", { className: "mt-5", children: t("managed_event_dialog_clarification") })
      ]
    }
  ) });
}
const m7l = ({ onSuccess: e, onError: t, onSettled: n }) => Hr({
  onSuccess: e,
  onError: t,
  onSettled: n,
  mutationFn: (o) => {
    if (!o)
      throw new Error("Event type id is required");
    const r = `/${rs.eventTypes}/${o}`;
    return At == null ? void 0 : At.delete(r).then((i) => {
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error(i.data.error.message);
    });
  }
}), f7l = ({
  onSuccess: e,
  onError: t,
  onSettled: n
}) => {
  const { organizationId: o } = cr();
  return Hr({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: ({ eventTypeId: r, teamId: i }) => {
      if (!r)
        throw new Error("Event type id is required");
      if (!i)
        throw new Error("team id is required");
      if (!o)
        throw new Error("organization id is required");
      const a = `/organizations/${o}/teams/${i}/${rs.eventTypes}/${r}`;
      return At == null ? void 0 : At.delete(a).then((s) => {
        if (s.data.status === Nn)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, J5 = "use-event-by-id", g7l = (e) => {
  const t = `/atoms/${rs.eventTypes}/${e}`, { isInit: n, accessToken: o } = cr();
  return mr({
    queryKey: [J5, e],
    queryFn: () => At == null ? void 0 : At.get(t).then((r) => {
      if (r.data.status === Nn)
        return r.data.data;
      throw new Error(r.data.error.message);
    }),
    enabled: !!e && n && !!o
  });
}, h7l = ({
  onSuccess: e = () => {
  },
  onError: t = () => {
  },
  onSettled: n = () => {
  },
  teamId: o
}) => {
  const { organizationId: r } = cr();
  return Hr({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i.id)
        throw new Error("Event type id is required");
      let a = `/atoms/${rs.eventTypes}/${i.id}`;
      return o && (a = `/atoms/organizations/${r}/teams/${o}/${rs.eventTypes}/${i.id}`), At == null ? void 0 : At.patch(a, i).then((s) => {
        if (s.data.status === Nn)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, v7l = (e, t = !1) => {
  let n = 0;
  for (const o in e == null ? void 0 : e.apps) {
    const r = e == null ? void 0 : e.apps[o];
    "appCategories" in r ? r.appCategories.includes("payment") && r.enabled && n++ : "price" in r && r.enabled && n++;
  }
  return t ? n >= 1 : n > 1;
}, b7l = v7l, jve = oe.enum(["CHECK_IN_APPOINTMENT", "CUSTOM_TEMPLATE"]), Vve = oe.object({
  yourPhoneNumber: oe.string().refine((e) => i0(e)),
  numberToCall: oe.string().refine((e) => i0(e)),
  calApiKey: oe.string().trim().min(1, {
    message: "Please enter CAL API Key"
  }),
  eventTypeId: oe.number(),
  enabled: oe.boolean().default(!1),
  templateType: jve
}), y7l = Vve.merge(
  oe.object({
    schedulerName: oe.string().min(1).optional().nullable(),
    guestName: oe.string().optional().transform((e) => e || void 0),
    guestEmail: oe.string().optional().transform((e) => e || void 0),
    guestCompany: oe.string().optional().transform((e) => e || void 0),
    beginMessage: oe.string().optional(),
    generalPrompt: oe.string().optional()
  })
);
oe.object({
  phone_number: oe.string(),
  agent_id: oe.string().optional(),
  nickname: oe.string(),
  inbound_agent_id: oe.string(),
  outbound_agent_id: oe.string(),
  error_message: oe.string().optional()
}).passthrough();
oe.object({
  call_id: oe.string(),
  agent_id: oe.string().optional()
}).passthrough();
Vve.merge(
  oe.object({
    schedulerName: oe.string().min(1)
  })
), y7l.omit({ generalPrompt: !0 }).merge(
  oe.object({
    generalPrompt: oe.string()
  })
);
const $7l = oe.enum([
  "name",
  "text",
  "textarea",
  "number",
  "email",
  "phone",
  "address",
  "multiemail",
  "select",
  "multiselect",
  "checkbox",
  "radio",
  "radioInput",
  "boolean"
]), w7l = oe.enum([
  "schedulerName",
  "generalPrompt",
  "guestName",
  "guestEmail",
  "guestCompany",
  "beginMessage"
]), k7l = oe.object({
  type: $7l,
  name: w7l,
  required: oe.boolean(),
  defaultLabel: oe.string(),
  placeholder: oe.string(),
  variableName: oe.string().optional()
});
oe.array(k7l);
oe.object({
  llm_id: oe.string(),
  llm_websocket_url: oe.string().optional(),
  inbound_dynamic_variables_webhook_url: oe.string().optional()
}).passthrough();
oe.object({
  general_prompt: oe.string(),
  begin_message: oe.string().nullable().optional(),
  llm_id: oe.string(),
  llm_websocket_url: oe.string().optional(),
  inbound_dynamic_variables_webhook_url: oe.string().optional(),
  general_tools: oe.array(
    oe.object({
      name: oe.string(),
      type: oe.string(),
      cal_api_key: oe.string().optional(),
      event_type_id: oe.number().optional(),
      timezone: oe.string().optional()
    }).passthrough()
  ),
  states: oe.array(
    oe.object({
      name: oe.string(),
      tools: oe.array(
        oe.object({
          name: oe.string(),
          type: oe.string(),
          cal_api_key: oe.string().optional(),
          event_type_id: oe.number().optional(),
          timezone: oe.string().optional()
        }).passthrough()
      )
    }).passthrough()
  ).nullable().optional()
}).passthrough();
oe.object({
  phone_number: oe.string(),
  phone_number_type: oe.string(),
  phone_number_pretty: oe.string(),
  inbound_agent_id: oe.string().optional().nullable(),
  outbound_agent_id: oe.string().optional().nullable(),
  inbound_agent_version: oe.number().optional().nullable(),
  outbound_agent_version: oe.number().optional().nullable(),
  area_code: oe.number().optional().nullable(),
  nickname: oe.string(),
  inbound_webhook_url: oe.string().url().optional().nullable(),
  last_modification_timestamp: oe.number()
});
oe.object({
  agent_id: oe.string(),
  agent_name: oe.string()
});
jve.enum.CHECK_IN_APPOINTMENT + "";
const S7l = `## You are helping user set up a call with the support team. The appointment is 15 min long. You are a pleasant and friendly.

  ## Style Guardrails
  Be Concise: Respond succinctly, addressing one topic at most.
  Embrace Variety: Use diverse language and rephrasing to enhance clarity without repeating content.
  Be Conversational: Use everyday language, making the chat feel like talking to a friend.
  Be Proactive: Lead the conversation, often wrapping up with a question or next-step suggestion.
  Avoid multiple questions in a single response.
  Get clarity: If the user only partially answers a question, or if the answer is unclear, keep asking to get clarity.
  Use a colloquial way of referring to the date (like Friday, Jan 14th, or Tuesday, Jan 12th, 2024 at 8am).
  If you are saying a time like 8:00 AM, just say 8 AM and omit the trailing zeros.

  ## Response Guideline
  Adapt and Guess: Try to understand transcripts that may contain transcription errors. Avoid mentioning "transcription error" in the response.
  Stay in Character: Keep conversations within your role'''s scope, guiding them back creatively without repeating.
  Ensure Fluid Dialogue: Respond in a role-appropriate, direct manner to maintain a smooth conversation flow.

  ## Schedule Rule
  Current time is {{current_time}}. You only schedule time in current calendar year, you cannot schedule time that'''s in the past.

  ## Task Steps
  1. I am here to learn more about your issue and help schedule an appointment with our support team.
  2. If {{ATTENDEE_EMAIL}} is not unknown then Use name {{ATTENDEE_NAME}} and email {{ATTENDEE_EMAIL}} for creating booking else Ask for user name and email and Confirm the name and email with user by reading it back to user.
  3. Ask user for "When would you want to meet with one of our representatives".
  4. Call function check_availability_{{eventTypeId}} to check for availability in the user provided time range.
    - if availability exists, inform user about the availability range (do not repeat the detailed available slot) and ask user to choose from it. Make sure user chose a slot within detailed available slot.
    - if availability does not exist, ask user to select another time range for the appointment, repeat this step 3.
  5. Confirm the date and time selected by user: "Just to confirm, you want to book the appointment at ...".
  6. Once confirmed, you can use {{user_number}} if it is not unknown else ask user for phone number in international format and use it for creating booking if it is a required field and call function book_appointment_{{eventTypeId}} to book the appointment.
    - if booking returned booking detail, it means booking is successful, proceed to step 7.
    - if booking returned error message, let user know why the booking was not successful, and maybe start over with step 3.
  7. Inform the user booking is successful, and ask if user have any questions. Answer them if there are any.
  8. After all questions answered, call function end_call to hang up.`, E7l = "Hi. How are you doing?";
function Bve({
  hosts: e,
  hostGroups: t
}) {
  const n = {}, o = t && t.length > 0;
  return o ? t.forEach((r) => {
    n[r.id] = [];
  }) : n[Mx] = [], e.forEach((r) => {
    const i = o && r.groupId ? r.groupId : Mx;
    n[i] && n[i].push(r);
  }), n;
}
function tV(e, t) {
  return e.filter(
    (n) => t && (!n.groupId || n.groupId !== t) || !t && n.groupId
  );
}
function Uve({ t: e }) {
  return /* @__PURE__ */ m(
    Ld,
    {
      t: e,
      i18nKey: "weights_description",
      components: [
        /* @__PURE__ */ m(
          Ir,
          {
            className: "underline underline-offset-2",
            target: "_blank",
            href: "https://cal.com/docs/enterprise-features/teams/round-robin-scheduling#weights",
            children: "Learn more"
          },
          "weights_description"
        )
      ]
    }
  );
}
const x7l = (e) => {
  const { t } = kt(), { isOpenDialog: n, setIsOpenDialog: o, option: r, options: i, onChange: a, customClassNames: s } = e, { getValues: c } = No(), l = [
    { label: t("lowest"), value: 0 },
    { label: t("low"), value: 1 },
    { label: t("medium"), value: 2 },
    { label: t("high"), value: 3 },
    { label: t("highest"), value: 4 }
  ], [u, d] = it(), _ = () => {
    if (u) {
      const p = c("hosts"), g = c("isRRWeightsEnabled"), f = c("hostGroups"), h = p.filter((M) => !M.isFixed), $ = Bve({ hosts: h, hostGroups: f });
      let v = [];
      const b = $[r.groupId ?? Mx];
      b && (v = b.map((M) => ({
        ...r,
        value: M.userId.toString(),
        priority: M.userId === parseInt(r.value, 10) ? u.value : M.priority,
        isFixed: !1,
        weight: M.weight,
        groupId: M.groupId,
        userId: M.userId
      })).sort((M, q) => s0(M, q, g)));
      const N = [...tV(h, r.groupId).map((M) => ({
        ...r,
        value: M.userId.toString(),
        priority: M.priority,
        weight: M.weight,
        isFixed: M.isFixed,
        groupId: M.groupId,
        userId: M.userId
      })), ...v];
      a(N);
    }
    o(!1);
  };
  return /* @__PURE__ */ m(Ss, { open: n, onOpenChange: o, children: /* @__PURE__ */ de(Ya, { title: t("set_priority"), children: [
    /* @__PURE__ */ de("div", { className: xe("mb-4", s == null ? void 0 : s.container), children: [
      /* @__PURE__ */ m(Ko, { className: s == null ? void 0 : s.label, children: t("priority_for_user", { userName: r.label }) }),
      /* @__PURE__ */ m(
        Di,
        {
          defaultValue: l[r.priority ?? 2],
          className: s == null ? void 0 : s.select,
          innerClassNames: s == null ? void 0 : s.innerClassNames,
          value: u,
          onChange: (p) => d(p ?? l[2]),
          options: l
        }
      )
    ] }),
    /* @__PURE__ */ de(Wu, { children: [
      /* @__PURE__ */ m(Gs, { onClick: () => d(void 0) }),
      /* @__PURE__ */ m(Jt, { onClick: _, className: s == null ? void 0 : s.confirmButton, children: t("confirm") })
    ] })
  ] }) });
};
function s0(e, t, n) {
  const o = e.weight ?? 100, r = e.priority ?? 2, i = t.weight ?? 100, a = t.priority ?? 2;
  return n ? o === i ? a - r : i - o : a - r;
}
const C7l = (e) => {
  var _, p, g, f;
  const { t } = kt(), { isOpenDialog: n, setIsOpenDialog: o, option: r, options: i, onChange: a, customClassNames: s } = e, { getValues: c } = No(), [l, u] = it(), d = () => {
    if (l) {
      const h = c("hosts"), $ = c("isRRWeightsEnabled"), v = c("hostGroups"), b = h.filter((D) => !D.isFixed), y = Bve({ hosts: b, hostGroups: v }), w = (D) => D.userId === parseInt(r.value, 10) ? { ...D, weight: l } : D;
      let N = [];
      const M = y[r.groupId ?? Mx];
      M && (N = M.map((D) => {
        const A = i.find((E) => E.value === D.userId.toString());
        return {
          ...w(D),
          avatar: (A == null ? void 0 : A.avatar) ?? "",
          label: (A == null ? void 0 : A.label) ?? D.userId.toString()
        };
      }).sort((D, A) => s0(D, A, $)));
      const q = N.map((D) => ({
        avatar: D.avatar,
        label: D.label,
        value: D.userId.toString(),
        priority: D.priority,
        weight: D.weight,
        isFixed: D.isFixed,
        groupId: D.groupId
      })), T = [...tV(b, r.groupId).map((D) => {
        const A = i.find((S) => S.value === D.userId.toString());
        return {
          avatar: (A == null ? void 0 : A.avatar) ?? "",
          label: (A == null ? void 0 : A.label) ?? D.userId.toString(),
          value: D.userId.toString(),
          priority: D.priority,
          weight: D.weight,
          isFixed: D.isFixed,
          groupId: D.groupId
        };
      }), ...q];
      a(T);
    }
    o(!1);
  };
  return /* @__PURE__ */ m(Ss, { open: n, onOpenChange: o, children: /* @__PURE__ */ de(Ya, { title: t("set_weight"), description: /* @__PURE__ */ m(Uve, { t }), children: [
    /* @__PURE__ */ de("div", { className: xe("mb-4 mt-2", s == null ? void 0 : s.container), children: [
      /* @__PURE__ */ m(Ko, { className: s == null ? void 0 : s.label, children: t("weight_for_user", { userName: r.label }) }),
      /* @__PURE__ */ m("div", { className: xe("w-36", (_ = s == null ? void 0 : s.weightInput) == null ? void 0 : _.container), children: /* @__PURE__ */ m(
        xr,
        {
          required: !0,
          min: 0,
          className: (p = s == null ? void 0 : s.weightInput) == null ? void 0 : p.input,
          labelClassName: (g = s == null ? void 0 : s.weightInput) == null ? void 0 : g.label,
          addOnClassname: (f = s == null ? void 0 : s.weightInput) == null ? void 0 : f.addOn,
          label: t("Weight"),
          value: l,
          defaultValue: r.weight ?? 100,
          type: "number",
          onChange: (h) => u(parseInt(h.target.value)),
          addOnSuffix: /* @__PURE__ */ m(nt, { children: "%" })
        }
      ) })
    ] }),
    /* @__PURE__ */ de(Wu, { children: [
      /* @__PURE__ */ m(Gs, { onClick: () => u(void 0) }),
      /* @__PURE__ */ m(Jt, { onClick: d, className: s == null ? void 0 : s.confirmButton, children: t("confirm") })
    ] })
  ] }) });
}, T7l = oe.object({
  firstName: oe.string(),
  lastName: oe.string().optional()
});
function A7l(e) {
  return typeof e == "string" ? e : typeof e == "object" && T7l.parse(e) ? `${e.firstName} ${e.lastName}`.trim() : "Nameless";
}
function Gve(e, t = !1) {
  var l;
  const n = A7l(e.attendeeName);
  if (!e.eventName)
    return e.t("event_between_users", {
      eventName: e.eventType,
      host: e.teamName || e.host,
      attendeeName: n,
      interpolation: {
        escapeValue: !1
      }
    });
  let o = e.eventName, r = e.location || "";
  if (e.eventName.includes("{Location}") || e.eventName.includes("{LOCATION}")) {
    const u = PK(e.location);
    u && (r = u.label), o = o.replace("{Location}", r), o = o.replace("{LOCATION}", r);
  }
  let i = o.replaceAll("{Event type title}", e.eventType).replaceAll("{Scheduler}", n).replaceAll("{Organiser}", e.host).replaceAll("{Organiser first name}", e.host.split(" ")[0]).replaceAll("{USER}", n).replaceAll("{ATTENDEE}", n).replaceAll("{HOST}", e.host).replaceAll("{HOST/ATTENDEE}", t ? e.host : n).replaceAll("{Event duration}", `${String(e.eventDuration)} mins`).replaceAll(
    "{Scheduler first name}",
    n === e.t("scheduler") ? "{Scheduler first name}" : n.split(" ")[0]
  );
  const { bookingFields: a } = e || {}, { name: s } = a || {};
  s && typeof s == "object" && !Array.isArray(s) && typeof s.lastName == "string" && (i = i.replaceAll("{Scheduler last name}", s.lastName.toString()));
  const c = (l = i.match(/\{(.+?)}/g)) == null ? void 0 : l.map((u) => u.replace("{", "").replace("}", ""));
  return c == null || c.forEach((u) => {
    var _, p;
    if (!e.bookingFields)
      return;
    const d = e.bookingFields[u];
    if (d) {
      let g;
      if (typeof d == "object") {
        if ("value" in d) {
          const f = (_ = d.value) == null ? void 0 : _.toString();
          g = u === "location" && ((p = PK(f)) == null ? void 0 : p.label) || f;
        } else if (u === "name" && "firstName" in d) {
          const f = "lastName" in d ? d.lastName : "";
          g = `${d.firstName} ${f}`.trim();
        }
      } else
        g = d.toString();
      i = i.replace(`{${u}}`, g || "");
    } else
      i = i.replace(`{${u}}`, "");
  }), i;
}
const Wve = (e, t) => {
  let n = [];
  t && (n = Object.keys(t).map((i) => `{${i}}`));
  const o = n.concat([
    "{Event type title}",
    "{Organiser}",
    "{Scheduler}",
    "{Location}",
    "{Organiser first name}",
    "{Scheduler first name}",
    "{Scheduler last name}",
    "{Event duration}",
    //allowed for fallback reasons
    "{LOCATION}",
    "{HOST/ATTENDEE}",
    "{HOST}",
    "{ATTENDEE}",
    "{USER}"
  ]), r = e.match(/\{([^}]+)\}/g);
  if (r != null && r.length) {
    for (const i of r)
      if (!o.includes(i))
        return i;
  }
  return !0;
}, nT = ["PER_DAY", "PER_WEEK", "PER_MONTH", "PER_YEAR"];
function I7l(e) {
  return ["day", "week", "month", "year"].includes(e);
}
function O7l(e) {
  const t = e.split("_")[1].toLowerCase();
  if (I7l(t))
    return t;
  throw new Error(`Invalid interval limit key: ${e}`);
}
const dX = (e) => {
  const t = Object.entries(e).sort(([, o], [, r]) => o - r).map(([o]) => o), n = nT.filter((o) => t.includes(o));
  return t.every((o, r) => n[r] === o);
}, N7l = (e) => {
  if (e === null)
    return;
  if (!((e == null ? void 0 : e.enabledLayouts.length) > 0))
    return "bookerlayout_error_min_one_enabled";
  if (!(e == null ? void 0 : e.enabledLayouts.find(
    (i) => i === e.defaultLayout
  )))
    return "bookerlayout_error_default_not_enabled";
  const o = e == null ? void 0 : e.enabledLayouts.every(
    (i) => Wp.includes(i)
  ), r = Wp.includes(e.defaultLayout);
  if (!o || !r)
    return "bookerlayout_error_unknown_layout";
}, z7l = ({
  eventType: e,
  onSubmit: t,
  onFormStateChange: n
}) => {
  const { t: o } = kt(), [r] = it({
    startDate: new Date(e.periodStartDate || Date.now()),
    endDate: new Date(e.periodEndDate || Date.now())
  }), i = vn(() => {
    var f, h, $, v, b, y, w, N, M, q;
    return {
      title: e.title,
      id: e.id,
      slug: e.slug,
      afterEventBuffer: e.afterEventBuffer,
      beforeEventBuffer: e.beforeEventBuffer,
      eventName: e.eventName || "",
      scheduleName: e.scheduleName,
      periodDays: e.periodDays,
      requiresBookerEmailVerification: e.requiresBookerEmailVerification,
      seatsPerTimeSlot: e.seatsPerTimeSlot,
      seatsShowAttendees: e.seatsShowAttendees,
      seatsShowAvailabilityCount: e.seatsShowAvailabilityCount,
      lockTimeZoneToggleOnBookingPage: e.lockTimeZoneToggleOnBookingPage,
      lockedTimeZone: e.lockedTimeZone || null,
      locations: e.locations || [],
      destinationCalendar: e.destinationCalendar,
      recurringEvent: e.recurringEvent || null,
      isInstantEvent: e.isInstantEvent,
      instantMeetingParameters: e.instantMeetingParameters || [],
      instantMeetingExpiryTimeOffsetInSeconds: e.instantMeetingExpiryTimeOffsetInSeconds,
      description: e.description ?? void 0,
      schedule: e.schedule || void 0,
      instantMeetingSchedule: e.instantMeetingSchedule || void 0,
      bookingLimits: e.bookingLimits || void 0,
      onlyShowFirstAvailableSlot: e.onlyShowFirstAvailableSlot || void 0,
      durationLimits: e.durationLimits || void 0,
      length: e.length,
      hidden: e.hidden,
      multiplePrivateLinks: e.hashedLink.map((L) => ({
        link: L.link,
        expiresAt: L.expiresAt,
        maxUsageCount: L.maxUsageCount
      })),
      eventTypeColor: e.eventTypeColor || null,
      periodDates: {
        startDate: r.startDate,
        endDate: r.endDate
      },
      hideCalendarNotes: e.hideCalendarNotes,
      hideCalendarEventDetails: e.hideCalendarEventDetails,
      offsetStart: e.offsetStart,
      bookingFields: e.bookingFields,
      periodType: e.periodType,
      periodCountCalendarDays: !!e.periodCountCalendarDays,
      schedulingType: e.schedulingType,
      requiresConfirmation: e.requiresConfirmation,
      canSendCalVideoTranscriptionEmails: e.canSendCalVideoTranscriptionEmails,
      requiresConfirmationWillBlockSlot: e.requiresConfirmationWillBlockSlot,
      requiresConfirmationForFreeEmail: e.requiresConfirmationForFreeEmail,
      slotInterval: e.slotInterval,
      minimumBookingNotice: e.minimumBookingNotice,
      allowReschedulingPastBookings: e.allowReschedulingPastBookings,
      hideOrganizerEmail: e.hideOrganizerEmail,
      metadata: e.metadata,
      hosts: e.hosts.sort((L, R) => s0(L, R, e.isRRWeightsEnabled)),
      hostGroups: e.hostGroups || [],
      successRedirectUrl: e.successRedirectUrl || "",
      forwardParamsSuccessRedirect: e.forwardParamsSuccessRedirect,
      users: e.users,
      useEventTypeDestinationCalendarEmail: e.useEventTypeDestinationCalendarEmail,
      secondaryEmailId: (e == null ? void 0 : e.secondaryEmailId) || -1,
      children: e.children.map((L) => {
        var R, T;
        return {
          ...L,
          created: !0,
          owner: {
            ...L.owner,
            eventTypeSlugs: ((T = (R = e.team) == null ? void 0 : R.members.find((D) => D.user.id === L.owner.id)) == null ? void 0 : T.user.eventTypes.map((D) => D.slug).filter((D) => D !== e.slug)) ?? []
          }
        };
      }),
      seatsPerTimeSlotEnabled: e.seatsPerTimeSlot,
      autoTranslateDescriptionEnabled: e.autoTranslateDescriptionEnabled,
      rescheduleWithSameRoundRobinHost: e.rescheduleWithSameRoundRobinHost,
      assignAllTeamMembers: e.assignAllTeamMembers,
      assignRRMembersUsingSegment: e.assignRRMembersUsingSegment,
      rrSegmentQueryValue: e.rrSegmentQueryValue,
      aiPhoneCallConfig: {
        generalPrompt: ((f = e.aiPhoneCallConfig) == null ? void 0 : f.generalPrompt) ?? S7l,
        enabled: (h = e.aiPhoneCallConfig) == null ? void 0 : h.enabled,
        beginMessage: (($ = e.aiPhoneCallConfig) == null ? void 0 : $.beginMessage) ?? E7l,
        guestName: (v = e.aiPhoneCallConfig) == null ? void 0 : v.guestName,
        guestEmail: (b = e.aiPhoneCallConfig) == null ? void 0 : b.guestEmail,
        guestCompany: (y = e.aiPhoneCallConfig) == null ? void 0 : y.guestCompany,
        yourPhoneNumber: (w = e.aiPhoneCallConfig) == null ? void 0 : w.yourPhoneNumber,
        numberToCall: (N = e.aiPhoneCallConfig) == null ? void 0 : N.numberToCall,
        templateType: ((M = e.aiPhoneCallConfig) == null ? void 0 : M.templateType) ?? "CUSTOM_TEMPLATE",
        schedulerName: (q = e.aiPhoneCallConfig) == null ? void 0 : q.schedulerName
      },
      isRRWeightsEnabled: e.isRRWeightsEnabled,
      maxLeadThreshold: e.maxLeadThreshold,
      includeNoShowInRRCalculation: e.includeNoShowInRRCalculation,
      useEventLevelSelectedCalendars: e.useEventLevelSelectedCalendars,
      customReplyToEmail: e.customReplyToEmail || null,
      calVideoSettings: e.calVideoSettings,
      maxActiveBookingsPerBooker: e.maxActiveBookingsPerBooker || null,
      maxActiveBookingPerBookerOfferReschedule: e.maxActiveBookingPerBookerOfferReschedule,
      showOptimizedSlots: e.showOptimizedSlots ?? !1
    };
  }, [e, r]), a = W_({
    defaultValues: i,
    resolver: K0(
      oe.object({
        // Length if string, is converted to a number or it can be a number
        // Make it optional because it's not submitted from all tabs of the page
        eventName: oe.string().superRefine((f, h) => {
          const $ = {};
          a.getValues("bookingFields").forEach(({ name: y }) => {
            $[y] = y;
          });
          const b = Wve(f, $);
          b !== !0 && h.addIssue({
            code: oe.ZodIssueCode.custom,
            message: o("invalid_event_name_variables", { item: b })
          });
        }).optional(),
        length: oe.union([oe.string().transform((f) => +f), oe.number()]).optional(),
        offsetStart: oe.union([oe.string().transform((f) => +f), oe.number()]).optional(),
        bookingFields: _ce,
        locations: uil(o),
        calVideoSettings: oe.object({
          redirectUrlOnExit: oe.string().url().nullish(),
          disableRecordingForOrganizer: oe.boolean().nullable(),
          disableRecordingForGuests: oe.boolean().nullable(),
          enableAutomaticTranscription: oe.boolean().nullable(),
          enableAutomaticRecordingForOrganizer: oe.boolean().nullable(),
          disableTranscriptionForGuests: oe.boolean().nullable(),
          disableTranscriptionForOrganizer: oe.boolean().nullable()
        }).optional().nullable()
      }).passthrough()
    )
  }), {
    formState: { isDirty: s, dirtyFields: c }
  } = a, l = a.watch(), u = (f) => f !== null && typeof f == "object" && !Array.isArray(f), d = (f) => Array.isArray(f), _ = (f, h) => {
    const $ = h.split(".");
    let v = f;
    for (let b = 0; b < $.length; b++) {
      const y = v[$[b]];
      if (y === void 0)
        return;
      v = y;
    }
    return v;
  }, p = (f) => {
    if (!s)
      return {};
    const h = (v) => {
      if (c[v] === !0)
        return !0;
      const b = _(c, v);
      if (u(b))
        for (const y in b) {
          if (b[y] === !0)
            return !0;
          if (u(b[y]) || d(b[y])) {
            const w = `${v}.${y}`;
            if (h(w))
              return !0;
          }
        }
      if (d(b)) {
        for (const y of b)
          if (u(y))
            for (const w in y) {
              if (y[w] === !0)
                return !0;
              if (u(y[w]) || d(y[w])) {
                const N = `${v}.${w}`;
                if (h(N))
                  return !0;
              }
            }
          else if (y === !0)
            return !0;
      }
      return !1;
    }, $ = {};
    return Object.keys(c).forEach((v) => {
      const b = v;
      $[b] = void 0, h(b) && ($[b] = f[b]);
    }), $;
  }, g = async (f) => {
    var Q, me, ne;
    const { children: h } = f, $ = p(f), v = Object.keys($).length !== 0, {
      periodDates: b,
      periodCountCalendarDays: y,
      beforeEventBuffer: w,
      afterEventBuffer: N,
      seatsPerTimeSlot: M,
      seatsShowAttendees: q,
      seatsShowAvailabilityCount: L,
      bookingLimits: R,
      onlyShowFirstAvailableSlot: T,
      durationLimits: D,
      recurringEvent: A,
      eventTypeColor: S,
      customReplyToEmail: E,
      locations: x,
      metadata: k,
      customInputs: I,
      assignAllTeamMembers: z,
      // We don't need to send send these values to the backend
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      seatsPerTimeSlotEnabled: F,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      minimumBookingNoticeInDurationType: P,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      bookerLayouts: O,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      multipleDurationEnabled: V,
      length: U,
      ...H
    } = $;
    if (U && !Number(U))
      throw new Error(o("event_setup_length_error"));
    const J = M === void 0 ? e.seatsPerTimeSlot : M, le = A === void 0 ? e.recurringEvent : A;
    if (J && le)
      throw new Error(o("recurring_event_seats_error"));
    if (R && !dX(R))
      throw new Error(o("event_setup_booking_limits_error"));
    if (D && !dX(D))
      throw new Error(o("event_setup_duration_limits_error"));
    const ae = N7l((k == null ? void 0 : k.bookerLayouts) || null);
    if (ae)
      throw new Error(o(ae));
    if ((k == null ? void 0 : k.multipleDuration) !== void 0) {
      if ((k == null ? void 0 : k.multipleDuration.length) < 1)
        throw new Error(o("event_setup_multiple_duration_error"));
      if (U !== void 0 && !U && !((Q = k == null ? void 0 : k.multipleDuration) != null && Q.includes(U)))
        throw new Error(o("event_setup_multiple_duration_default_error"));
    }
    if (b7l(k))
      throw new Error(o("event_setup_multiple_payment_apps_error"));
    if (((ne = (me = k == null ? void 0 : k.apps) == null ? void 0 : me.stripe) == null ? void 0 : ne.paymentOption) === "HOLD" && M)
      throw new Error(o("seats_and_no_show_fee_error"));
    const { availability: Y, users: re, scheduleName: ie, ..._e } = H, he = {
      ..._e,
      length: U,
      locations: x,
      recurringEvent: A,
      periodStartDate: b == null ? void 0 : b.startDate,
      periodEndDate: b == null ? void 0 : b.endDate,
      periodCountCalendarDays: y,
      id: e.id,
      beforeEventBuffer: w,
      afterEventBuffer: N,
      bookingLimits: R,
      onlyShowFirstAvailableSlot: T,
      durationLimits: D,
      eventTypeColor: S,
      customReplyToEmail: E,
      seatsPerTimeSlot: M,
      seatsShowAttendees: q,
      seatsShowAvailabilityCount: L,
      metadata: k,
      customInputs: I,
      children: h,
      assignAllTeamMembers: z,
      multiplePrivateLinks: f.multiplePrivateLinks,
      aiPhoneCallConfig: _e.aiPhoneCallConfig ? { ..._e.aiPhoneCallConfig, templateType: _e.aiPhoneCallConfig.templateType } : void 0
    }, be = Object.entries(he).reduce((pe, [ge, ve]) => (ve !== void 0 && (pe[ge] = ve), pe), {});
    v && t({ ...be, id: e.id });
  };
  return yt(() => {
    n && n({
      isDirty: s,
      dirtyFields: c,
      values: l
    });
  }, [s, c, l, n]), { form: a, handleSubmit: g };
};
function R7l({
  assignedUsers: e,
  hosts: t,
  isManagedEventType: n,
  assignAllTeamMembers: o
}) {
  return o ? !1 : n ? e.length === 0 : t.length === 0;
}
const P7l = ({
  isTeamEventTypeDeleted: e,
  isleavingWithoutAssigningHosts: t,
  isTeamEventType: n,
  assignedUsers: o,
  hosts: r,
  assignAllTeamMembers: i,
  isManagedEventType: a,
  onError: s,
  onStart: c,
  onEnd: l,
  watchTrigger: u
}) => {
  yt(() => {
    const d = (_) => {
      const p = _.split("/");
      e || n && !t && (_ === "/event-types" || p[1] !== "event-types") && R7l({
        assignedUsers: o,
        hosts: r,
        assignAllTeamMembers: i,
        isManagedEventType: a
      }) && (s == null || s(_));
    };
    return c == null || c(d), () => {
      l == null || l(d);
    };
  }, [u, r, o, i, s, c, l]);
}, D7l = ({ formMethods: e, eventType: t, team: n, tabs: o }) => {
  var b;
  const [r, i] = it(""), [a, s] = it(o[0]);
  yt(() => {
    const y = window.location.href;
    i(y);
  }, []);
  const { t: c } = kt(), l = e.watch("length"), u = (b = e.watch("metadata")) == null ? void 0 : b.multipleDuration, d = e.watch("schedulingType"), _ = e.watch("children").length, p = e.watch("availability"), { isManagedEventType: g, isChildrenManagedEventType: f } = Bg({
    eventType: t,
    translate: c,
    formMethods: e
  }), $ = Lg(t).price > 0;
  return { tabsNavigation: vn(() => {
    const y = L7l({
      t: c,
      length: l,
      multipleDuration: u,
      id: e.getValues("id"),
      tabs: o,
      url: r,
      onClick: (w) => {
        s(w);
      },
      currentTab: a
    });
    return !$ && o.includes("recurring") && y.splice(3, 0, {
      name: c("recurring"),
      onClick: () => s("recurring"),
      isActive: a === "recurring",
      href: `${r}?tabName=recurring`,
      icon: "repeat",
      info: c("recurring_event_tab_description"),
      "data-testid": "recurring"
    }), o.includes("availability") && y.splice(1, 0, {
      name: c("availability"),
      onClick: () => s("availability"),
      isActive: a === "availability",
      href: `${r}?tabName=availability`,
      icon: "calendar",
      info: g || f ? e.getValues("schedule") === null ? c("members_default_schedule") : f ? `${e.getValues("scheduleName") ? `${e.getValues("scheduleName")} - ${c("managed")}` : c("default_schedule_name")}` : e.getValues("scheduleName") ?? c("default_schedule_name") : e.getValues("scheduleName") ?? c("default_schedule_name"),
      "data-testid": "availability"
    }), n && o.includes("team") && y.splice(2, 0, {
      name: c("assignment"),
      onClick: () => s("team"),
      isActive: a === "team",
      href: `${r}?tabName=team`,
      icon: "users",
      info: `${c((d == null ? void 0 : d.toLowerCase()) ?? "")}${g ? ` - ${c("number_member", { count: _ || 0 })}` : ""}`,
      "data-testid": "assignment"
    }), y;
  }, [
    c,
    p,
    g,
    f,
    n,
    l,
    $,
    u,
    e.getValues("id"),
    d,
    _,
    r,
    o,
    a
  ]), currentTab: a };
};
function L7l({ length: e, multipleDuration: t, t: n, tabs: o, url: r, onClick: i, currentTab: a }) {
  const s = (t == null ? void 0 : t.map((l) => ` ${l}`)) || e, c = [];
  return o.includes("setup") && c.push({
    name: n("basics"),
    onClick: () => i("setup"),
    isActive: a === "setup",
    href: `${r}?tabName=setup`,
    icon: "link",
    info: `${s} ${n("minute_timeUnit")}`,
    // TODO: Get this from props
    "data-testid": "basics"
  }), o.includes("limits") && c.push({
    name: n("event_limit_tab_title"),
    onClick: () => i("limits"),
    isActive: a === "limits",
    href: `${r}?tabName=limits`,
    icon: "clock",
    info: n("event_limit_tab_description"),
    "data-testid": "event_limit_tab_title"
  }), o.includes("advanced") && c.push({
    name: n("event_advanced_tab_title"),
    onClick: () => i("advanced"),
    isActive: a === "advanced",
    href: `${r}?tabName=advanced`,
    icon: "sliders-vertical",
    info: n("event_advanced_tab_description"),
    "data-testid": "event_advanced_tab_title"
  }), o.includes("payments") && c.push({
    name: n("payments"),
    onClick: () => i("payments"),
    isActive: a === "payments",
    href: `${r}?tabName=payments`,
    icon: "credit-card",
    info: n("event_payments_tab_description"),
    "data-testid": "payments"
  }), c;
}
function Hve(e) {
  const t = Kr(), n = vn(
    () => co(
      () => t ? import("./AppListCardPlatformWrapper-C46cEjGL.js") : import("./AppListCardWebWrapper-LU3yqCaJ.js"),
      {
        ssr: !1
        // Prevents SSR issues if needed
      }
    ),
    [t]
  );
  return /* @__PURE__ */ m(n, { ...e });
}
function _X({
  credentialId: e,
  integrationType: t,
  cacheUpdatedAt: n,
  onSuccess: o,
  delegationCredentialId: r,
  disableConnectionModification: i
}) {
  const { t: a } = kt(), [s, c] = it(!1), [l, u] = it(!1), [d, _] = it(!1), p = hr.viewer.calendars.deleteCache.useMutation({
    onSuccess: () => {
      ti(a("cache_deleted_successfully"), "success"), o == null || o();
    },
    onError: () => {
      ti(a("error_deleting_cache"), "error");
    }
  }), g = hr.useUtils(), f = hr.viewer.credentials.delete.useMutation({
    onSuccess: () => {
      ti(a("app_removed_successfully"), "success"), o == null || o();
    },
    onError: () => {
      ti(a("error_removing_app"), "error");
    },
    async onSettled() {
      await g.viewer.calendars.connectedCalendars.invalidate(), await g.viewer.apps.integrations.invalidate();
    }
  }), h = t === dEe, $ = !r && !i, v = h && n;
  return !$ && !v ? null : /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de(jd, { open: s, onOpenChange: c, children: [
      /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(Jt, { type: "button", variant: "icon", color: "secondary", StartIcon: "ellipsis" }) }),
      /* @__PURE__ */ de(Yu, { children: [
        v && /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ m(Pi, { className: "focus:ring-muted", children: /* @__PURE__ */ de("div", { className: "px-2 py-1", children: [
            /* @__PURE__ */ m("div", { className: "text-sm font-medium text-gray-900 dark:text-white", children: a("cache_status") }),
            /* @__PURE__ */ m("div", { className: "text-xs text-gray-500 dark:text-white", children: a("cache_last_updated", {
              timestamp: new Intl.DateTimeFormat("en-US", {
                dateStyle: "short",
                timeStyle: "short"
              }).format(new Date(n)),
              interpolation: { escapeValue: !1 }
            }) })
          ] }) }),
          /* @__PURE__ */ m(Pi, { className: "outline-none", children: /* @__PURE__ */ m(
            ba,
            {
              type: "button",
              color: "destructive",
              StartIcon: "trash",
              onClick: () => {
                u(!0), c(!1);
              },
              children: a("delete_cached_data")
            }
          ) })
        ] }),
        $ && v && /* @__PURE__ */ m("hr", { className: "my-1" }),
        $ && /* @__PURE__ */ m(Pi, { className: "outline-none", children: /* @__PURE__ */ m(
          ba,
          {
            type: "button",
            color: "destructive",
            StartIcon: "trash",
            onClick: () => {
              _(!0), c(!1);
            },
            children: a("remove_app")
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ m(_v, { open: l, onOpenChange: u, children: /* @__PURE__ */ m(
      pv,
      {
        variety: "danger",
        title: a("delete_cached_data"),
        confirmBtnText: a("yes_delete_cache"),
        onConfirm: () => {
          p.mutate({ credentialId: e }), u(!1);
        },
        children: a("confirm_delete_cache")
      }
    ) }),
    /* @__PURE__ */ m(_v, { open: d, onOpenChange: _, children: /* @__PURE__ */ m(
      pv,
      {
        variety: "danger",
        title: a("remove_app"),
        confirmBtnText: a("yes_remove_app"),
        onConfirm: () => {
          f.mutate({ id: e }), _(!1);
        },
        children: a("are_you_sure_you_want_to_remove_this_app")
      }
    ) })
  ] });
}
const M7l = ({ isPending: e }) => {
  const { t } = kt(), [n] = hr.viewer.apps.integrations.useSuspenseQuery({ variant: "calendar", onlyInstalled: !0 }), o = n.items.map((r) => ({
    label: r.name,
    slug: r.slug,
    image: r.logo,
    type: r.type
  }));
  return o.push({
    label: "Add new calendars",
    slug: "add-new",
    image: "",
    type: "new_other"
  }), /* @__PURE__ */ de(jd, { modal: !1, children: [
    /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(Jt, { StartIcon: "plus", color: "secondary", ...e && { loading: e }, children: t("add") }) }),
    /* @__PURE__ */ m(Yu, { children: o.map((r) => /* @__PURE__ */ m(Pi, { className: "focus:outline-none", children: r.slug === "add-new" ? /* @__PURE__ */ m(ba, { StartIcon: "plus", color: "minimal", href: "/apps/categories/calendar", children: t("install_new_calendar_app") }) : /* @__PURE__ */ m(
      Yge,
      {
        type: r.type,
        render: (i) => {
          const a = { ...i };
          return /* @__PURE__ */ m(ba, { ...a, color: "minimal", type: "button", children: /* @__PURE__ */ de("span", { className: "flex items-center gap-x-2", children: [
            r.image && /* @__PURE__ */ m("img", { className: "h-5 w-5", src: r.image, alt: r.label }),
            `${t("add")} ${r.label}`
          ] }) });
        }
      }
    ) }, r.slug)) })
  ] });
}, F7l = M7l, q7l = (e) => {
  const {
    title: t,
    externalId: n,
    type: o,
    isChecked: r,
    name: i,
    credentialId: a,
    delegationCredentialId: s,
    eventTypeId: c,
    disabled: l
  } = e, [u, d] = it(r), _ = hr.useUtils(), { t: p } = kt(), g = Hr({
    mutationFn: async ({ isOn: f }) => {
      const h = {
        integration: o,
        externalId: n,
        ...s && { delegationCredentialId: s },
        // new URLSearchParams does not accept numbers
        credentialId: String(a),
        ...c ? { eventTypeId: String(c) } : {}
      };
      if (f) {
        if (!(await fetch("/api/availability/calendar", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(h)
        })).ok)
          throw new Error("Something went wrong");
      } else if (!(await fetch(`/api/availability/calendar?${new URLSearchParams(h)}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json"
        }
      })).ok)
        throw new Error("Something went wrong");
    },
    async onSettled() {
      await _.viewer.apps.integrations.invalidate(), await _.viewer.calendars.connectedCalendars.invalidate();
    },
    onError() {
      d(!1), ti(`Something went wrong when toggling "${t}"`, "error");
    }
  });
  return /* @__PURE__ */ de("div", { className: xe("my-2 flex flex-row items-center"), children: [
    /* @__PURE__ */ m("div", { className: "flex pl-2", children: /* @__PURE__ */ m(
      as,
      {
        id: n,
        checked: u,
        disabled: l || g.isPending,
        onCheckedChange: async (f) => {
          d(f), await g.mutate({ isOn: f });
        }
      }
    ) }),
    /* @__PURE__ */ m(
      "label",
      {
        className: xe(
          "ml-3 break-all text-sm font-medium leading-5",
          l ? "cursor-not-allowed opacity-25" : "cursor-pointer"
        ),
        htmlFor: n,
        children: i
      }
    ),
    !!e.destination && /* @__PURE__ */ de("span", { className: "bg-subtle text-default ml-8 inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-normal sm:ml-4", children: [
      /* @__PURE__ */ m(qt, { name: "arrow-left", className: "h-4 w-4" }),
      p("adding_events_to")
    ] }),
    g.isPending && /* @__PURE__ */ m(qt, { name: "rotate-cw", className: "text-muted h-4 w-4 animate-spin ltr:ml-1 rtl:mr-1" })
  ] });
};
var Rw = /* @__PURE__ */ ((e) => (e.User = "user", e.EventType = "eventType", e))(Rw || {});
const j7l = ({
  fromOnboarding: e = !1,
  scope: t,
  items: n,
  disableConnectionModification: o,
  eventTypeId: r,
  onChanged: i,
  destinationCalendarId: a,
  isDisabled: s
}) => {
  const { t: c } = kt(), l = t === "eventType";
  return /* @__PURE__ */ m(Wj, { noBorderTreatment: !0, className: "p-6 pt-2", children: n.map((u) => {
    var d, _;
    return u.calendars && u.calendars.length > 0 ? /* @__PURE__ */ m(
      Hve,
      {
        shouldHighlight: !0,
        slug: u.integration.slug,
        title: u.integration.name,
        logo: u.integration.logo,
        description: ((d = u.primary) == null ? void 0 : d.email) ?? u.integration.description,
        className: "border-subtle mt-4 rounded-lg border",
        actions: /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: /* @__PURE__ */ m(
          _X,
          {
            credentialId: u.credentialId,
            integrationType: u.integration.type,
            cacheUpdatedAt: u.cacheUpdatedAt,
            onSuccess: i,
            delegationCredentialId: u.delegationCredentialId,
            disableConnectionModification: o
          }
        ) }),
        children: /* @__PURE__ */ m("div", { className: "border-subtle border-t", children: !e && /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ m("p", { className: "text-subtle px-5 pt-4 text-sm", children: c("toggle_calendars_conflict") }),
          /* @__PURE__ */ m("ul", { className: "space-y-4 px-5 py-4", children: (_ = u.calendars) == null ? void 0 : _.map((p) => /* @__PURE__ */ m(
            q7l,
            {
              disabled: s,
              externalId: p.externalId,
              title: p.name || "Nameless calendar",
              name: p.name || "Nameless calendar",
              type: u.integration.type,
              isChecked: p.isSelected,
              destination: p.externalId === a,
              credentialId: p.credentialId,
              eventTypeId: l ? r : null,
              delegationCredentialId: u.delegationCredentialId || null
            },
            p.externalId
          )) })
        ] }) })
      },
      `list-${u.credentialId}-${t}`
    ) : /* @__PURE__ */ m(
      Us,
      {
        severity: "warning",
        title: c("something_went_wrong"),
        message: /* @__PURE__ */ de("span", { children: [
          /* @__PURE__ */ m(Ir, { href: `/apps/${u.integration.slug}`, children: u.integration.name }),
          ": ",
          c("calendar_error")
        ] }),
        iconClassName: "h-10 w-10 ml-2 mr-1 mt-0.5",
        actions: /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: /* @__PURE__ */ m(
          _X,
          {
            credentialId: u.credentialId,
            integrationType: u.integration.type,
            cacheUpdatedAt: u.cacheUpdatedAt,
            onSuccess: i,
            delegationCredentialId: u.delegationCredentialId,
            disableConnectionModification: o
          }
        ) })
      },
      `alert-${u.credentialId}`
    );
  }) });
}, V7l = (e) => {
  var d, _, p;
  const {
    scope: t = "user",
    setScope: n = () => {
    },
    disabledScope: o,
    disableConnectionModification: r,
    eventTypeId: i = null
  } = e, a = hr.viewer.calendars.connectedCalendars.useQuery(
    {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      eventTypeId: t === "eventType" ? i : null
    },
    {
      suspense: !0,
      refetchOnWindowFocus: !1
    }
  ), { isPending: s } = e, c = !!e.eventTypeId, l = o ? o === t : !1, u = l || r;
  return /* @__PURE__ */ m("div", { children: /* @__PURE__ */ de(Z5, { classNames: e.classNames, children: [
    /* @__PURE__ */ m(
      B7l,
      {
        isConnectedCalendarsPresent: !!((d = a.data) != null && d.connectedCalendars.length),
        isPending: s,
        showScopeSelector: c,
        setScope: n,
        scope: t,
        shouldDisableConnectionModification: u
      }
    ),
    (_ = a.data) != null && _.connectedCalendars && ((p = a.data) == null ? void 0 : p.connectedCalendars.length) > 0 ? /* @__PURE__ */ m(
      j7l,
      {
        fromOnboarding: e.fromOnboarding,
        scope: t,
        disableConnectionModification: r,
        onChanged: e.onChanged,
        eventTypeId: i,
        items: a.data.connectedCalendars,
        isDisabled: l
      }
    ) : null
  ] }) });
}, pX = () => /* @__PURE__ */ de("div", { className: "border-subtle mt-6 rounded-lg border", children: [
  /* @__PURE__ */ m("div", { className: "border-subtle border-b p-6", children: /* @__PURE__ */ de("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
      /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-4 w-48 animate-pulse rounded-md" })
    ] }),
    /* @__PURE__ */ m("div", { className: "bg-emphasis h-8 w-32 animate-pulse rounded-md" })
  ] }) }),
  /* @__PURE__ */ m("div", { className: "p-6 pt-2", children: /* @__PURE__ */ de("div", { className: "border-subtle mt-4 rounded-lg border p-4", children: [
    /* @__PURE__ */ de("div", { className: "flex items-center", children: [
      /* @__PURE__ */ m("div", { className: "bg-emphasis h-10 w-10 animate-pulse rounded-md" }),
      /* @__PURE__ */ de("div", { className: "ml-4 space-y-2", children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-48 animate-pulse rounded-md" })
      ] })
    ] }),
    /* @__PURE__ */ de("div", { className: "border-subtle mt-4 space-y-4 border-t pt-4", children: [
      /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-64 animate-pulse rounded-md" }),
      /* @__PURE__ */ m("div", { className: "space-y-2", children: [1, 2, 3].map((e) => /* @__PURE__ */ de("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-48 animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-6 w-10 animate-pulse rounded-md" })
      ] }, e)) })
    ] })
  ] }) })
] }), B7l = (e) => {
  const { t } = kt(), n = [
    {
      label: "User",
      value: "user"
      /* User */
    },
    {
      label: "Event Type",
      value: "eventType"
      /* EventType */
    }
  ], o = n.find((r) => r.value === e.scope);
  return /* @__PURE__ */ de("div", { className: "border-subtle border-b p-6", children: [
    /* @__PURE__ */ de("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ de("div", { children: [
        /* @__PURE__ */ m("h4", { className: "text-emphasis text-base font-semibold leading-5", children: t("check_for_conflicts") }),
        /* @__PURE__ */ m("p", { className: "text-default text-sm leading-tight", children: t("select_calendars") })
      ] }),
      !e.shouldDisableConnectionModification && /* @__PURE__ */ m("div", { className: "flex flex-col xl:flex-row xl:space-x-5", children: e.isConnectedCalendarsPresent && /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m(F7l, { isPending: e.isPending }) }) })
    ] }),
    e.showScopeSelector && /* @__PURE__ */ de("div", { className: "mt-2 flex flex-row items-center space-x-2", children: [
      /* @__PURE__ */ m("span", { className: "text-default text-sm", children: "Using" }),
      /* @__PURE__ */ m(
        Di,
        {
          onChange: (r) => {
            r && e.setScope(r.value);
          },
          value: o,
          options: n
        }
      ),
      /* @__PURE__ */ m("span", { className: "text-default text-sm", children: "settings" })
    ] })
  ] });
};
function U7l(e) {
  return !!e.find(
    (t) => t.trigger === Xse.NEW_EVENT && !!t.steps.find((n) => n.action === FM.EMAIL_HOST)
  );
}
function G7l(e) {
  return !!e.find(
    (t) => t.trigger === Xse.NEW_EVENT && !!t.steps.find(
      (n) => n.action === FM.EMAIL_ATTENDEE || n.action === FM.SMS_ATTENDEE
    )
  );
}
const W7l = ({
  options: e = [],
  value: t = [],
  isRRWeightsEnabled: n,
  customClassNames: o,
  groupId: r,
  ...i
}) => {
  var $, v, b;
  const a = Kr(), [s, c] = it(!1), [l, u] = it(!1), [d, _] = it(t[0] ?? null), { t: p } = kt(), [g] = qd(), f = r ? t.filter((y) => y.groupId === r) : t, h = (y) => {
    const N = [...tV(t, r), ...y.map((M) => ({ ...M, groupId: r }))];
    i.onChange(N);
  };
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Di,
      {
        ...i,
        name: i.name,
        placeholder: i.placeholder || p("select"),
        isSearchable: !0,
        options: e,
        value: f,
        onChange: h,
        isMulti: !0,
        className: ($ = o == null ? void 0 : o.hostsSelect) == null ? void 0 : $.select,
        innerClassNames: {
          ...(v = o == null ? void 0 : o.hostsSelect) == null ? void 0 : v.innerClassNames,
          control: "rounded-md"
        }
      }
    ),
    /* @__PURE__ */ m(
      "ul",
      {
        className: xe(
          "mb-4 mt-3 rounded-md",
          f.length >= 1 && "border-subtle border",
          (b = o == null ? void 0 : o.selectedHostList) == null ? void 0 : b.container
        ),
        ref: g,
        children: f.map((y, w) => {
          var N, M, q, L, R, T, D, A, S, E, x, k;
          return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(
            "li",
            {
              className: xe(
                `flex px-3 py-2 ${w === f.length - 1 ? "" : "border-subtle border-b"}`,
                (M = (N = o == null ? void 0 : o.selectedHostList) == null ? void 0 : N.listItem) == null ? void 0 : M.container
              ),
              children: [
                !a && /* @__PURE__ */ m(Dd, { size: "sm", imageSrc: y.avatar, alt: y.label }),
                a && /* @__PURE__ */ m(
                  qt,
                  {
                    name: "user",
                    className: xe(
                      "mt-0.5 h-4 w-4",
                      (L = (q = o == null ? void 0 : o.selectedHostList) == null ? void 0 : q.listItem) == null ? void 0 : L.avatar
                    )
                  }
                ),
                /* @__PURE__ */ m(
                  "p",
                  {
                    className: xe(
                      "text-emphasis my-auto ms-3 text-sm",
                      (T = (R = o == null ? void 0 : o.selectedHostList) == null ? void 0 : R.listItem) == null ? void 0 : T.name
                    ),
                    children: y.label
                  }
                ),
                /* @__PURE__ */ de("div", { className: "ml-auto flex items-center", children: [
                  y && !y.isFixed ? /* @__PURE__ */ de(nt, { children: [
                    /* @__PURE__ */ m(Sr, { content: p("change_priority"), children: /* @__PURE__ */ m(
                      Jt,
                      {
                        color: "minimal",
                        onClick: () => {
                          c(!0), _(y);
                        },
                        className: xe(
                          "mr-6 h-2 p-0 text-sm hover:bg-transparent",
                          mX(y.priority).color,
                          (A = (D = o == null ? void 0 : o.selectedHostList) == null ? void 0 : D.listItem) == null ? void 0 : A.changePriorityButton
                        ),
                        children: p(mX(y.priority).text)
                      }
                    ) }),
                    n ? /* @__PURE__ */ de(
                      Jt,
                      {
                        color: "minimal",
                        className: xe(
                          "mr-6 h-2 w-4 p-0 text-sm hover:bg-transparent",
                          (E = (S = o == null ? void 0 : o.selectedHostList) == null ? void 0 : S.listItem) == null ? void 0 : E.changeWeightButton
                        ),
                        onClick: () => {
                          u(!0), _(y);
                        },
                        children: [
                          y.weight ?? 100,
                          "%"
                        ]
                      }
                    ) : /* @__PURE__ */ m(nt, {})
                  ] }) : /* @__PURE__ */ m(nt, {}),
                  /* @__PURE__ */ m(
                    qt,
                    {
                      name: "x",
                      onClick: () => i.onChange(t.filter((I) => I.value !== y.value)),
                      className: xe(
                        "my-auto ml-2 h-4 w-4",
                        (k = (x = o == null ? void 0 : o.selectedHostList) == null ? void 0 : x.listItem) == null ? void 0 : k.removeButton
                      )
                    }
                  )
                ] })
              ]
            },
            y.value
          ) });
        })
      }
    ),
    d && !d.isFixed ? /* @__PURE__ */ de(nt, { children: [
      /* @__PURE__ */ m(
        x7l,
        {
          isOpenDialog: s,
          setIsOpenDialog: c,
          option: d,
          options: e,
          onChange: i.onChange,
          customClassNames: o == null ? void 0 : o.priorityDialog
        }
      ),
      /* @__PURE__ */ m(
        C7l,
        {
          isOpenDialog: l,
          setIsOpenDialog: u,
          option: d,
          options: e,
          onChange: i.onChange,
          customClassNames: o == null ? void 0 : o.weightDialog
        }
      )
    ] }) : /* @__PURE__ */ m(nt, {})
  ] });
}, mX = (e) => {
  switch (e) {
    case 0:
      return { text: "lowest", color: "text-gray-300" };
    case 1:
      return { text: "low", color: "text-gray-400" };
    case 2:
      return { text: "medium", color: "text-gray-500" };
    case 3:
      return { text: "high", color: "text-gray-600" };
    case 4:
      return { text: "highest", color: "text-gray-700" };
    default:
      return { text: "medium", color: "text-gray-500" };
  }
}, H7l = W7l, Y7l = ({
  permissions: e,
  teamSlug: t,
  teamId: n,
  form: o,
  urlPrefix: r,
  isPending: i,
  handleSubmit: a,
  isManagedEventType: s,
  SubmitButton: c
}) => {
  const l = Kr(), { t: u } = kt(), { register: d, setValue: _, formState: p } = o, { canCreateEventType: g } = e;
  return /* @__PURE__ */ de(Y_, { form: o, handleSubmit: a, children: [
    /* @__PURE__ */ de("div", { className: "mt-1 space-y-6", children: [
      /* @__PURE__ */ m(
        xr,
        {
          type: "hidden",
          labelProps: { style: { display: "none" } },
          ...d("teamId", { valueAsNumber: !0 }),
          value: n
        }
      ),
      /* @__PURE__ */ m(
        xr,
        {
          label: u("title"),
          placeholder: u("quick_chat"),
          "data-testid": "event-type-quick-chat",
          ...d("title"),
          onChange: (f) => {
            o.setValue("title", f == null ? void 0 : f.target.value), p.touchedFields.slug === void 0 && o.setValue("slug", ev(f == null ? void 0 : f.target.value));
          }
        }
      ),
      r && r.length >= 21 ? /* @__PURE__ */ de("div", { children: [
        /* @__PURE__ */ m(
          xr,
          {
            label: l ? "Slug" : `${u("url")}: ${r}`,
            required: !0,
            addOnLeading: l ? void 0 : /* @__PURE__ */ m(Sr, { content: s ? u("username_placeholder") : `team/${t}`, children: /* @__PURE__ */ de("span", { className: "max-w-24 md:max-w-56", children: [
              "/",
              s ? u("username_placeholder") : `team/${t}`,
              "/"
            ] }) }),
            ...d("slug"),
            onChange: (f) => {
              o.setValue("slug", ev(f == null ? void 0 : f.target.value), { shouldTouch: !0 });
            }
          }
        ),
        s && !l && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: u("managed_event_url_clarification") })
      ] }) : /* @__PURE__ */ de("div", { children: [
        /* @__PURE__ */ m(
          xr,
          {
            label: l ? "Slug" : u("url"),
            required: !0,
            addOnLeading: l ? void 0 : /* @__PURE__ */ m(
              Sr,
              {
                content: `${r}/${s ? u("username_placeholder") : `team/${t}`}/`,
                children: /* @__PURE__ */ de("span", { className: "max-w-24 md:max-w-56", children: [
                  r,
                  "/",
                  s ? u("username_placeholder") : `team/${t}`,
                  "/"
                ] })
              }
            ),
            ...d("slug"),
            onChange: (f) => {
              o.setValue("slug", ev(f == null ? void 0 : f.target.value), { shouldTouch: !0 });
            }
          }
        ),
        s && !l && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: u("managed_event_url_clarification") })
      ] }),
      /* @__PURE__ */ de("div", { className: "mb-4", children: [
        /* @__PURE__ */ m("label", { htmlFor: "schedulingType", className: "text-default block text-sm font-bold", children: u("assignment") }),
        p.errors.schedulingType && /* @__PURE__ */ m(Us, { className: "mt-1", severity: "error", message: p.errors.schedulingType.message }),
        /* @__PURE__ */ de(
          zj,
          {
            onValueChange: (f) => {
              _("schedulingType", f);
            },
            className: xe("mt-1 flex gap-4", g && "flex-col"),
            children: [
              /* @__PURE__ */ de(
                Eg,
                {
                  ...d("schedulingType"),
                  value: Bs.COLLECTIVE,
                  className: xe("w-full text-sm", !g && "w-1/2"),
                  classNames: { container: xe(g && "w-full") },
                  children: [
                    /* @__PURE__ */ m("strong", { className: "mb-1 block", children: u("collective") }),
                    /* @__PURE__ */ m("p", { children: u("collective_description") })
                  ]
                }
              ),
              /* @__PURE__ */ de(
                Eg,
                {
                  ...d("schedulingType"),
                  value: Bs.ROUND_ROBIN,
                  className: xe("text-sm", !g && "w-1/2"),
                  classNames: { container: xe(g && "w-full") },
                  children: [
                    /* @__PURE__ */ m("strong", { className: "mb-1 block", children: u("round_robin") }),
                    /* @__PURE__ */ m("p", { children: u("round_robin_description") })
                  ]
                }
              ),
              g && /* @__PURE__ */ de(
                Eg,
                {
                  ...d("schedulingType"),
                  value: Bs.MANAGED,
                  className: xe("text-sm", !g && "w-1/2"),
                  classNames: { container: xe(g && "w-full") },
                  "data-testid": "managed-event-type",
                  children: [
                    /* @__PURE__ */ m("strong", { className: "mb-1 block", children: u("managed_event") }),
                    /* @__PURE__ */ m("p", { children: u("managed_event_description") })
                  ]
                }
              )
            ]
          }
        )
      ] })
    ] }),
    c(i)
  ] });
};
oe.object({
  id: oe.number(),
  slug: oe.string(),
  title: oe.string().min(1),
  description: oe.string(),
  length: oe.number(),
  teamId: oe.number().nullish()
}).strict();
const K7l = oe.object({
  disableRecordingForGuests: oe.boolean().nullish(),
  disableRecordingForOrganizer: oe.boolean().nullish(),
  enableAutomaticTranscription: oe.boolean().nullish(),
  enableAutomaticRecordingForOrganizer: oe.boolean().nullish(),
  disableTranscriptionForGuests: oe.boolean().nullish(),
  disableTranscriptionForOrganizer: oe.boolean().nullish(),
  redirectUrlOnExit: oe.string().url().nullish()
}).optional().nullable(), Z7l = oe.object({
  title: oe.string().min(1),
  slug: Plc,
  description: oe.string().nullish(),
  length: oe.number().int(),
  hidden: oe.boolean(),
  teamId: oe.number().int().nullish(),
  schedulingType: oe.nativeEnum(Bs).nullish(),
  locations: Rlc,
  metadata: tce.optional(),
  disableGuests: oe.boolean().optional(),
  slotInterval: oe.number().min(0).nullish(),
  minimumBookingNotice: oe.number().int().min(0).optional(),
  beforeEventBuffer: oe.number().int().min(0).optional(),
  afterEventBuffer: oe.number().int().min(0).optional(),
  scheduleId: oe.number().int().optional(),
  calVideoSettings: K7l
}).partial({ hidden: !0, locations: !0 }).refine((e) => e.teamId ? e.teamId && e.schedulingType : !0, {
  path: ["schedulingType"],
  message: "You must select a scheduling type for team events"
}), X7l = () => {
  const e = W_({
    defaultValues: {
      length: 15
    },
    resolver: K0(Z7l)
  }), t = e.watch("schedulingType"), n = t === Bs.MANAGED;
  return yt(() => {
    n ? e.setValue("metadata.managedEventConfig.unlockedFields", jlc) : e.setValue("metadata", null);
  }, [t]), { form: e, isManagedEventType: n };
};
function J7l(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      n.hasOwnProperty(o) && (e[o] = n[o]);
  }
  return e;
}
function Q5(e, t) {
  return Array(t + 1).join(e);
}
function Q7l(e) {
  return e.replace(/^\n*/, "");
}
function eHl(e) {
  for (var t = e.length; t > 0 && e[t - 1] === `
`; )
    t--;
  return e.substring(0, t);
}
var tHl = [
  "ADDRESS",
  "ARTICLE",
  "ASIDE",
  "AUDIO",
  "BLOCKQUOTE",
  "BODY",
  "CANVAS",
  "CENTER",
  "DD",
  "DIR",
  "DIV",
  "DL",
  "DT",
  "FIELDSET",
  "FIGCAPTION",
  "FIGURE",
  "FOOTER",
  "FORM",
  "FRAMESET",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HEADER",
  "HGROUP",
  "HR",
  "HTML",
  "ISINDEX",
  "LI",
  "MAIN",
  "MENU",
  "NAV",
  "NOFRAMES",
  "NOSCRIPT",
  "OL",
  "OUTPUT",
  "P",
  "PRE",
  "SECTION",
  "TABLE",
  "TBODY",
  "TD",
  "TFOOT",
  "TH",
  "THEAD",
  "TR",
  "UL"
];
function nV(e) {
  return oV(e, tHl);
}
var Yve = [
  "AREA",
  "BASE",
  "BR",
  "COL",
  "COMMAND",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "KEYGEN",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
];
function Kve(e) {
  return oV(e, Yve);
}
function nHl(e) {
  return Xve(e, Yve);
}
var Zve = [
  "A",
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TH",
  "TD",
  "IFRAME",
  "SCRIPT",
  "AUDIO",
  "VIDEO"
];
function oHl(e) {
  return oV(e, Zve);
}
function rHl(e) {
  return Xve(e, Zve);
}
function oV(e, t) {
  return t.indexOf(e.nodeName) >= 0;
}
function Xve(e, t) {
  return e.getElementsByTagName && t.some(function(n) {
    return e.getElementsByTagName(n).length;
  });
}
var Bc = {};
Bc.paragraph = {
  filter: "p",
  replacement: function(e) {
    return `

` + e + `

`;
  }
};
Bc.lineBreak = {
  filter: "br",
  replacement: function(e, t, n) {
    return n.br + `
`;
  }
};
Bc.heading = {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement: function(e, t, n) {
    var o = Number(t.nodeName.charAt(1));
    if (n.headingStyle === "setext" && o < 3) {
      var r = Q5(o === 1 ? "=" : "-", e.length);
      return `

` + e + `
` + r + `

`;
    } else
      return `

` + Q5("#", o) + " " + e + `

`;
  }
};
Bc.blockquote = {
  filter: "blockquote",
  replacement: function(e) {
    return e = e.replace(/^\n+|\n+$/g, ""), e = e.replace(/^/gm, "> "), `

` + e + `

`;
  }
};
Bc.list = {
  filter: ["ul", "ol"],
  replacement: function(e, t) {
    var n = t.parentNode;
    return n.nodeName === "LI" && n.lastElementChild === t ? `
` + e : `

` + e + `

`;
  }
};
Bc.listItem = {
  filter: "li",
  replacement: function(e, t, n) {
    e = e.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
    `);
    var o = n.bulletListMarker + "   ", r = t.parentNode;
    if (r.nodeName === "OL") {
      var i = r.getAttribute("start"), a = Array.prototype.indexOf.call(r.children, t);
      o = (i ? Number(i) + a : a + 1) + ".  ";
    }
    return o + e + (t.nextSibling && !/\n$/.test(e) ? `
` : "");
  }
};
Bc.indentedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "indented" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    return `

    ` + t.firstChild.textContent.replace(/\n/g, `
    `) + `

`;
  }
};
Bc.fencedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "fenced" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    for (var o = t.firstChild.getAttribute("class") || "", r = (o.match(/language-(\S+)/) || [null, ""])[1], i = t.firstChild.textContent, a = n.fence.charAt(0), s = 3, c = new RegExp("^" + a + "{3,}", "gm"), l; l = c.exec(i); )
      l[0].length >= s && (s = l[0].length + 1);
    var u = Q5(a, s);
    return `

` + u + r + `
` + i.replace(/\n$/, "") + `
` + u + `

`;
  }
};
Bc.horizontalRule = {
  filter: "hr",
  replacement: function(e, t, n) {
    return `

` + n.hr + `

`;
  }
};
Bc.inlineLink = {
  filter: function(e, t) {
    return t.linkStyle === "inlined" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t) {
    var n = t.getAttribute("href");
    n && (n = n.replace(/([()])/g, "\\$1"));
    var o = oT(t.getAttribute("title"));
    return o && (o = ' "' + o.replace(/"/g, '\\"') + '"'), "[" + e + "](" + n + o + ")";
  }
};
Bc.referenceLink = {
  filter: function(e, t) {
    return t.linkStyle === "referenced" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t, n) {
    var o = t.getAttribute("href"), r = oT(t.getAttribute("title"));
    r && (r = ' "' + r + '"');
    var i, a;
    switch (n.linkReferenceStyle) {
      case "collapsed":
        i = "[" + e + "][]", a = "[" + e + "]: " + o + r;
        break;
      case "shortcut":
        i = "[" + e + "]", a = "[" + e + "]: " + o + r;
        break;
      default:
        var s = this.references.length + 1;
        i = "[" + e + "][" + s + "]", a = "[" + s + "]: " + o + r;
    }
    return this.references.push(a), i;
  },
  references: [],
  append: function(e) {
    var t = "";
    return this.references.length && (t = `

` + this.references.join(`
`) + `

`, this.references = []), t;
  }
};
Bc.emphasis = {
  filter: ["em", "i"],
  replacement: function(e, t, n) {
    return e.trim() ? n.emDelimiter + e + n.emDelimiter : "";
  }
};
Bc.strong = {
  filter: ["strong", "b"],
  replacement: function(e, t, n) {
    return e.trim() ? n.strongDelimiter + e + n.strongDelimiter : "";
  }
};
Bc.code = {
  filter: function(e) {
    var t = e.previousSibling || e.nextSibling, n = e.parentNode.nodeName === "PRE" && !t;
    return e.nodeName === "CODE" && !n;
  },
  replacement: function(e) {
    if (!e)
      return "";
    e = e.replace(/\r?\n|\r/g, " ");
    for (var t = /^`|^ .*?[^ ].* $|`$/.test(e) ? " " : "", n = "`", o = e.match(/`+/gm) || []; o.indexOf(n) !== -1; )
      n = n + "`";
    return n + t + e + t + n;
  }
};
Bc.image = {
  filter: "img",
  replacement: function(e, t) {
    var n = oT(t.getAttribute("alt")), o = t.getAttribute("src") || "", r = oT(t.getAttribute("title")), i = r ? ' "' + r + '"' : "";
    return o ? "![" + n + "](" + o + i + ")" : "";
  }
};
function oT(e) {
  return e ? e.replace(/(\n+\s*)+/g, `
`) : "";
}
function Jve(e) {
  this.options = e, this._keep = [], this._remove = [], this.blankRule = {
    replacement: e.blankReplacement
  }, this.keepReplacement = e.keepReplacement, this.defaultRule = {
    replacement: e.defaultReplacement
  }, this.array = [];
  for (var t in e.rules)
    this.array.push(e.rules[t]);
}
Jve.prototype = {
  add: function(e, t) {
    this.array.unshift(t);
  },
  keep: function(e) {
    this._keep.unshift({
      filter: e,
      replacement: this.keepReplacement
    });
  },
  remove: function(e) {
    this._remove.unshift({
      filter: e,
      replacement: function() {
        return "";
      }
    });
  },
  forNode: function(e) {
    if (e.isBlank)
      return this.blankRule;
    var t;
    return (t = TR(this.array, e, this.options)) || (t = TR(this._keep, e, this.options)) || (t = TR(this._remove, e, this.options)) ? t : this.defaultRule;
  },
  forEach: function(e) {
    for (var t = 0; t < this.array.length; t++)
      e(this.array[t], t);
  }
};
function TR(e, t, n) {
  for (var o = 0; o < e.length; o++) {
    var r = e[o];
    if (iHl(r, t, n))
      return r;
  }
}
function iHl(e, t, n) {
  var o = e.filter;
  if (typeof o == "string") {
    if (o === t.nodeName.toLowerCase())
      return !0;
  } else if (Array.isArray(o)) {
    if (o.indexOf(t.nodeName.toLowerCase()) > -1)
      return !0;
  } else if (typeof o == "function") {
    if (o.call(e, t, n))
      return !0;
  } else
    throw new TypeError("`filter` needs to be a string, array, or function");
}
function aHl(e) {
  var t = e.element, n = e.isBlock, o = e.isVoid, r = e.isPre || function(d) {
    return d.nodeName === "PRE";
  };
  if (!(!t.firstChild || r(t))) {
    for (var i = null, a = !1, s = null, c = fX(s, t, r); c !== t; ) {
      if (c.nodeType === 3 || c.nodeType === 4) {
        var l = c.data.replace(/[ \r\n\t]+/g, " ");
        if ((!i || / $/.test(i.data)) && !a && l[0] === " " && (l = l.substr(1)), !l) {
          c = AR(c);
          continue;
        }
        c.data = l, i = c;
      } else if (c.nodeType === 1)
        n(c) || c.nodeName === "BR" ? (i && (i.data = i.data.replace(/ $/, "")), i = null, a = !1) : o(c) || r(c) ? (i = null, a = !0) : i && (a = !1);
      else {
        c = AR(c);
        continue;
      }
      var u = fX(s, c, r);
      s = c, c = u;
    }
    i && (i.data = i.data.replace(/ $/, ""), i.data || AR(i));
  }
}
function AR(e) {
  var t = e.nextSibling || e.parentNode;
  return e.parentNode.removeChild(e), t;
}
function fX(e, t, n) {
  return e && e.parentNode === t || n(t) ? t.nextSibling || t.parentNode : t.firstChild || t.nextSibling || t.parentNode;
}
var rV = typeof window < "u" ? window : {};
function sHl() {
  var e = rV.DOMParser, t = !1;
  try {
    new e().parseFromString("", "text/html") && (t = !0);
  } catch {
  }
  return t;
}
function cHl() {
  var e = function() {
  };
  return lHl() ? e.prototype.parseFromString = function(t) {
    var n = new window.ActiveXObject("htmlfile");
    return n.designMode = "on", n.open(), n.write(t), n.close(), n;
  } : e.prototype.parseFromString = function(t) {
    var n = document.implementation.createHTMLDocument("");
    return n.open(), n.write(t), n.close(), n;
  }, e;
}
function lHl() {
  var e = !1;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch {
    rV.ActiveXObject && (e = !0);
  }
  return e;
}
var uHl = sHl() ? rV.DOMParser : cHl();
function dHl(e, t) {
  var n;
  if (typeof e == "string") {
    var o = _Hl().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + e + "</x-turndown>",
      "text/html"
    );
    n = o.getElementById("turndown-root");
  } else
    n = e.cloneNode(!0);
  return aHl({
    element: n,
    isBlock: nV,
    isVoid: Kve,
    isPre: t.preformattedCode ? pHl : null
  }), n;
}
var IR;
function _Hl() {
  return IR = IR || new uHl(), IR;
}
function pHl(e) {
  return e.nodeName === "PRE" || e.nodeName === "CODE";
}
function mHl(e, t) {
  return e.isBlock = nV(e), e.isCode = e.nodeName === "CODE" || e.parentNode.isCode, e.isBlank = fHl(e), e.flankingWhitespace = gHl(e, t), e;
}
function fHl(e) {
  return !Kve(e) && !oHl(e) && /^\s*$/i.test(e.textContent) && !nHl(e) && !rHl(e);
}
function gHl(e, t) {
  if (e.isBlock || t.preformattedCode && e.isCode)
    return { leading: "", trailing: "" };
  var n = hHl(e.textContent);
  return n.leadingAscii && gX("left", e, t) && (n.leading = n.leadingNonAscii), n.trailingAscii && gX("right", e, t) && (n.trailing = n.trailingNonAscii), { leading: n.leading, trailing: n.trailing };
}
function hHl(e) {
  var t = e.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: t[1],
    // whole string for whitespace-only strings
    leadingAscii: t[2],
    leadingNonAscii: t[3],
    trailing: t[4],
    // empty for whitespace-only strings
    trailingNonAscii: t[5],
    trailingAscii: t[6]
  };
}
function gX(e, t, n) {
  var o, r, i;
  return e === "left" ? (o = t.previousSibling, r = / $/) : (o = t.nextSibling, r = /^ /), o && (o.nodeType === 3 ? i = r.test(o.nodeValue) : n.preformattedCode && o.nodeName === "CODE" ? i = !1 : o.nodeType === 1 && !nV(o) && (i = r.test(o.textContent))), i;
}
var vHl = Array.prototype.reduce, bHl = [
  [/\\/g, "\\\\"],
  [/\*/g, "\\*"],
  [/^-/g, "\\-"],
  [/^\+ /g, "\\+ "],
  [/^(=+)/g, "\\$1"],
  [/^(#{1,6}) /g, "\\$1 "],
  [/`/g, "\\`"],
  [/^~~~/g, "\\~~~"],
  [/\[/g, "\\["],
  [/\]/g, "\\]"],
  [/^>/g, "\\>"],
  [/_/g, "\\_"],
  [/^(\d+)\. /g, "$1\\. "]
];
function rT(e) {
  if (!(this instanceof rT))
    return new rT(e);
  var t = {
    rules: Bc,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: !1,
    blankReplacement: function(n, o) {
      return o.isBlock ? `

` : "";
    },
    keepReplacement: function(n, o) {
      return o.isBlock ? `

` + o.outerHTML + `

` : o.outerHTML;
    },
    defaultReplacement: function(n, o) {
      return o.isBlock ? `

` + n + `

` : n;
    }
  };
  this.options = J7l({}, t, e), this.rules = new Jve(this.options);
}
rT.prototype = {
  /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */
  turndown: function(e) {
    if (!wHl(e))
      throw new TypeError(
        e + " is not a string, or an element/document/fragment node."
      );
    if (e === "")
      return "";
    var t = Qve.call(this, new dHl(e, this.options));
    return yHl.call(this, t);
  },
  /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */
  use: function(e) {
    if (Array.isArray(e))
      for (var t = 0; t < e.length; t++)
        this.use(e[t]);
    else if (typeof e == "function")
      e(this);
    else
      throw new TypeError("plugin must be a Function or an Array of Functions");
    return this;
  },
  /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  addRule: function(e, t) {
    return this.rules.add(e, t), this;
  },
  /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  keep: function(e) {
    return this.rules.keep(e), this;
  },
  /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  remove: function(e) {
    return this.rules.remove(e), this;
  },
  /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */
  escape: function(e) {
    return bHl.reduce(function(t, n) {
      return t.replace(n[0], n[1]);
    }, e);
  }
};
function Qve(e) {
  var t = this;
  return vHl.call(e.childNodes, function(n, o) {
    o = new mHl(o, t.options);
    var r = "";
    return o.nodeType === 3 ? r = o.isCode ? o.nodeValue : t.escape(o.nodeValue) : o.nodeType === 1 && (r = $Hl.call(t, o)), ebe(n, r);
  }, "");
}
function yHl(e) {
  var t = this;
  return this.rules.forEach(function(n) {
    typeof n.append == "function" && (e = ebe(e, n.append(t.options)));
  }), e.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function $Hl(e) {
  var t = this.rules.forNode(e), n = Qve.call(this, e), o = e.flankingWhitespace;
  return (o.leading || o.trailing) && (n = n.trim()), o.leading + t.replacement(n, e, this.options) + o.trailing;
}
function ebe(e, t) {
  var n = eHl(e), o = Q7l(t), r = Math.max(e.length - n.length, t.length - o.length), i = `

`.substring(0, r);
  return n + i + o;
}
function wHl(e) {
  return e != null && (typeof e == "string" || e.nodeType && (e.nodeType === 1 || e.nodeType === 9 || e.nodeType === 11));
}
const c2 = new rT();
function iV(e) {
  let t = c2.turndown(e);
  return t = t.replaceAll("[<p><br></p>]", ""), t === "<p><br></p>" && (t = ""), t;
}
c2.addRule("shiftEnter", {
  filter: function(e) {
    return e.nodeName === "BR" && !!tbe(e);
  },
  replacement: function() {
    return "<br>";
  }
});
c2.addRule("enter", {
  filter: function(e) {
    return e.nodeName === "BR" && !tbe(e);
  },
  replacement: function() {
    return "<p><br></p>";
  }
});
c2.addRule("ignoreEmphasized", {
  filter: "em",
  replacement: function(e) {
    return e;
  }
});
function tbe(e) {
  let t = e;
  for (; t != null && t.nodeType !== 1; )
    t = t.parentElement || t.parentNode;
  return t && t.nodeType === 1 && t.parentElement && t.parentElement.childNodes.length !== 1;
}
var Ba = {}, OR = { exports: {} }, hX;
function nbe() {
  return hX || (hX = 1, function(e) {
    var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
    /**
     * Prism: Lightweight, robust, elegant syntax highlighting
     *
     * @license MIT <https://opensource.org/licenses/MIT>
     * @author Lea Verou <https://lea.verou.me>
     * @namespace
     * @public
     */
    var n = function(o) {
      var r = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, i = 0, a = {}, s = {
        /**
         * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
         * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
         * additional languages or plugins yourself.
         *
         * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
         *
         * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.manual = true;
         * // add a new <script> to load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        manual: o.Prism && o.Prism.manual,
        /**
         * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
         * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
         * own worker, you don't want it to do this.
         *
         * By setting this value to `true`, Prism will not add its own listeners to the worker.
         *
         * You obviously have to change this value before Prism executes. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.disableWorkerMessageHandler = true;
         * // Load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        disableWorkerMessageHandler: o.Prism && o.Prism.disableWorkerMessageHandler,
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function v(b) {
            return b instanceof c ? new c(b.type, v(b.content), b.alias) : Array.isArray(b) ? b.map(v) : b.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(v) {
            return Object.prototype.toString.call(v).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(v) {
            return v.__id || Object.defineProperty(v, "__id", { value: ++i }), v.__id;
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function v(b, y) {
            y = y || {};
            var w, N;
            switch (s.util.type(b)) {
              case "Object":
                if (N = s.util.objId(b), y[N])
                  return y[N];
                w = /** @type {Record<string, any>} */
                {}, y[N] = w;
                for (var M in b)
                  b.hasOwnProperty(M) && (w[M] = v(b[M], y));
                return (
                  /** @type {any} */
                  w
                );
              case "Array":
                return N = s.util.objId(b), y[N] ? y[N] : (w = [], y[N] = w, /** @type {Array} */
                /** @type {any} */
                b.forEach(function(q, L) {
                  w[L] = v(q, y);
                }), /** @type {any} */
                w);
              default:
                return b;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(v) {
            for (; v; ) {
              var b = r.exec(v.className);
              if (b)
                return b[1].toLowerCase();
              v = v.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(v, b) {
            v.className = v.className.replace(RegExp(r, "gi"), ""), v.classList.add("language-" + b);
          },
          /**
           * Returns the script element that is currently executing.
           *
           * This does __not__ work for line script element.
           *
           * @returns {HTMLScriptElement | null}
           */
          currentScript: function() {
            if (typeof document > "u")
              return null;
            if ("currentScript" in document && 1 < 2)
              return (
                /** @type {any} */
                document.currentScript
              );
            try {
              throw new Error();
            } catch (w) {
              var v = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(w.stack) || [])[1];
              if (v) {
                var b = document.getElementsByTagName("script");
                for (var y in b)
                  if (b[y].src == v)
                    return b[y];
              }
              return null;
            }
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(v, b, y) {
            for (var w = "no-" + b; v; ) {
              var N = v.classList;
              if (N.contains(b))
                return !0;
              if (N.contains(w))
                return !1;
              v = v.parentElement;
            }
            return !!y;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: a,
          plaintext: a,
          text: a,
          txt: a,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(v, b) {
            var y = s.util.clone(s.languages[v]);
            for (var w in b)
              y[w] = b[w];
            return y;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(v, b, y, w) {
            w = w || /** @type {any} */
            s.languages;
            var N = w[v], M = {};
            for (var q in N)
              if (N.hasOwnProperty(q)) {
                if (q == b)
                  for (var L in y)
                    y.hasOwnProperty(L) && (M[L] = y[L]);
                y.hasOwnProperty(q) || (M[q] = N[q]);
              }
            var R = w[v];
            return w[v] = M, s.languages.DFS(s.languages, function(T, D) {
              D === R && T != v && (this[T] = M);
            }), M;
          },
          // Traverse a language definition with Depth First Search
          DFS: function v(b, y, w, N) {
            N = N || {};
            var M = s.util.objId;
            for (var q in b)
              if (b.hasOwnProperty(q)) {
                y.call(b, q, b[q], w || q);
                var L = b[q], R = s.util.type(L);
                R === "Object" && !N[M(L)] ? (N[M(L)] = !0, v(L, y, null, N)) : R === "Array" && !N[M(L)] && (N[M(L)] = !0, v(L, y, q, N));
              }
          }
        },
        plugins: {},
        /**
         * This is the most high-level function in Prism’s API.
         * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
         * each one of them.
         *
         * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
         *
         * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
         * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
         * @memberof Prism
         * @public
         */
        highlightAll: function(v, b) {
          s.highlightAllUnder(document, v, b);
        },
        /**
         * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
         * {@link Prism.highlightElement} on each one of them.
         *
         * The following hooks will be run:
         * 1. `before-highlightall`
         * 2. `before-all-elements-highlight`
         * 3. All hooks of {@link Prism.highlightElement} for each element.
         *
         * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
         * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
         * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
         * @memberof Prism
         * @public
         */
        highlightAllUnder: function(v, b, y) {
          var w = {
            callback: y,
            container: v,
            selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
          };
          s.hooks.run("before-highlightall", w), w.elements = Array.prototype.slice.apply(w.container.querySelectorAll(w.selector)), s.hooks.run("before-all-elements-highlight", w);
          for (var N = 0, M; M = w.elements[N++]; )
            s.highlightElement(M, b === !0, w.callback);
        },
        /**
         * Highlights the code inside a single element.
         *
         * The following hooks will be run:
         * 1. `before-sanity-check`
         * 2. `before-highlight`
         * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
         * 4. `before-insert`
         * 5. `after-highlight`
         * 6. `complete`
         *
         * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
         * the element's language.
         *
         * @param {Element} element The element containing the code.
         * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
         * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
         * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
         * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
         *
         * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
         * asynchronous highlighting to work. You can build your own bundle on the
         * [Download page](https://prismjs.com/download.html).
         * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
         * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
         * @memberof Prism
         * @public
         */
        highlightElement: function(v, b, y) {
          var w = s.util.getLanguage(v), N = s.languages[w];
          s.util.setLanguage(v, w);
          var M = v.parentElement;
          M && M.nodeName.toLowerCase() === "pre" && s.util.setLanguage(M, w);
          var q = v.textContent, L = {
            element: v,
            language: w,
            grammar: N,
            code: q
          };
          function R(D) {
            L.highlightedCode = D, s.hooks.run("before-insert", L), L.element.innerHTML = L.highlightedCode, s.hooks.run("after-highlight", L), s.hooks.run("complete", L), y && y.call(L.element);
          }
          if (s.hooks.run("before-sanity-check", L), M = L.element.parentElement, M && M.nodeName.toLowerCase() === "pre" && !M.hasAttribute("tabindex") && M.setAttribute("tabindex", "0"), !L.code) {
            s.hooks.run("complete", L), y && y.call(L.element);
            return;
          }
          if (s.hooks.run("before-highlight", L), !L.grammar) {
            R(s.util.encode(L.code));
            return;
          }
          if (b && o.Worker) {
            var T = new Worker(s.filename);
            T.onmessage = function(D) {
              R(D.data);
            }, T.postMessage(JSON.stringify({
              language: L.language,
              code: L.code,
              immediateClose: !0
            }));
          } else
            R(s.highlight(L.code, L.grammar, L.language));
        },
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(v, b, y) {
          var w = {
            code: v,
            grammar: b,
            language: y
          };
          if (s.hooks.run("before-tokenize", w), !w.grammar)
            throw new Error('The language "' + w.language + '" has no grammar.');
          return w.tokens = s.tokenize(w.code, w.grammar), s.hooks.run("after-tokenize", w), c.stringify(s.util.encode(w.tokens), w.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(v, b) {
          var y = b.rest;
          if (y) {
            for (var w in y)
              b[w] = y[w];
            delete b.rest;
          }
          var N = new d();
          return _(N, N.head, v), u(v, N, b, N.head, 0), g(N);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(v, b) {
            var y = s.hooks.all;
            y[v] = y[v] || [], y[v].push(b);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(v, b) {
            var y = s.hooks.all[v];
            if (!(!y || !y.length))
              for (var w = 0, N; N = y[w++]; )
                N(b);
          }
        },
        Token: c
      };
      o.Prism = s;
      function c(v, b, y, w) {
        this.type = v, this.content = b, this.alias = y, this.length = (w || "").length | 0;
      }
      c.stringify = function v(b, y) {
        if (typeof b == "string")
          return b;
        if (Array.isArray(b)) {
          var w = "";
          return b.forEach(function(R) {
            w += v(R, y);
          }), w;
        }
        var N = {
          type: b.type,
          content: v(b.content, y),
          tag: "span",
          classes: ["token", b.type],
          attributes: {},
          language: y
        }, M = b.alias;
        M && (Array.isArray(M) ? Array.prototype.push.apply(N.classes, M) : N.classes.push(M)), s.hooks.run("wrap", N);
        var q = "";
        for (var L in N.attributes)
          q += " " + L + '="' + (N.attributes[L] || "").replace(/"/g, "&quot;") + '"';
        return "<" + N.tag + ' class="' + N.classes.join(" ") + '"' + q + ">" + N.content + "</" + N.tag + ">";
      };
      function l(v, b, y, w) {
        v.lastIndex = b;
        var N = v.exec(y);
        if (N && w && N[1]) {
          var M = N[1].length;
          N.index += M, N[0] = N[0].slice(M);
        }
        return N;
      }
      function u(v, b, y, w, N, M) {
        for (var q in y)
          if (!(!y.hasOwnProperty(q) || !y[q])) {
            var L = y[q];
            L = Array.isArray(L) ? L : [L];
            for (var R = 0; R < L.length; ++R) {
              if (M && M.cause == q + "," + R)
                return;
              var T = L[R], D = T.inside, A = !!T.lookbehind, S = !!T.greedy, E = T.alias;
              if (S && !T.pattern.global) {
                var x = T.pattern.toString().match(/[imsuy]*$/)[0];
                T.pattern = RegExp(T.pattern.source, x + "g");
              }
              for (var k = T.pattern || T, I = w.next, z = N; I !== b.tail && !(M && z >= M.reach); z += I.value.length, I = I.next) {
                var F = I.value;
                if (b.length > v.length)
                  return;
                if (!(F instanceof c)) {
                  var P = 1, O;
                  if (S) {
                    if (O = l(k, z, v, A), !O || O.index >= v.length)
                      break;
                    var J = O.index, V = O.index + O[0].length, U = z;
                    for (U += I.value.length; J >= U; )
                      I = I.next, U += I.value.length;
                    if (U -= I.value.length, z = U, I.value instanceof c)
                      continue;
                    for (var H = I; H !== b.tail && (U < V || typeof H.value == "string"); H = H.next)
                      P++, U += H.value.length;
                    P--, F = v.slice(z, U), O.index -= z;
                  } else if (O = l(k, 0, F, A), !O)
                    continue;
                  var J = O.index, le = O[0], ae = F.slice(0, J), Y = F.slice(J + le.length), re = z + F.length;
                  M && re > M.reach && (M.reach = re);
                  var ie = I.prev;
                  ae && (ie = _(b, ie, ae), z += ae.length), p(b, ie, P);
                  var _e = new c(q, D ? s.tokenize(le, D) : le, E, le);
                  if (I = _(b, ie, _e), Y && _(b, I, Y), P > 1) {
                    var he = {
                      cause: q + "," + R,
                      reach: re
                    };
                    u(v, b, y, I.prev, z, he), M && he.reach > M.reach && (M.reach = he.reach);
                  }
                }
              }
            }
          }
      }
      function d() {
        var v = { value: null, prev: null, next: null }, b = { value: null, prev: v, next: null };
        v.next = b, this.head = v, this.tail = b, this.length = 0;
      }
      function _(v, b, y) {
        var w = b.next, N = { value: y, prev: b, next: w };
        return b.next = N, w.prev = N, v.length++, N;
      }
      function p(v, b, y) {
        for (var w = b.next, N = 0; N < y && w !== v.tail; N++)
          w = w.next;
        b.next = w, w.prev = b, v.length -= N;
      }
      function g(v) {
        for (var b = [], y = v.head.next; y !== v.tail; )
          b.push(y.value), y = y.next;
        return b;
      }
      if (!o.document)
        return o.addEventListener && (s.disableWorkerMessageHandler || o.addEventListener("message", function(v) {
          var b = JSON.parse(v.data), y = b.language, w = b.code, N = b.immediateClose;
          o.postMessage(s.highlight(w, s.languages[y], y)), N && o.close();
        }, !1)), s;
      var f = s.util.currentScript();
      f && (s.filename = f.src, f.hasAttribute("data-manual") && (s.manual = !0));
      function h() {
        s.manual || s.highlightAll();
      }
      if (!s.manual) {
        var $ = document.readyState;
        $ === "loading" || $ === "interactive" && f && f.defer ? document.addEventListener("DOMContentLoaded", h) : window.requestAnimationFrame ? window.requestAnimationFrame(h) : window.setTimeout(h, 16);
      }
      return s;
    }(t);
    e.exports && (e.exports = n), typeof Dt < "u" && (Dt.Prism = n), n.languages.markup = {
      comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
      },
      prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
      },
      doctype: {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
          "internal-subset": {
            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: !0
          },
          punctuation: /^<!|>$|[[\]]/,
          "doctype-tag": /^DOCTYPE/i,
          name: /[^\s<>'"]+/
        }
      },
      cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
      },
      tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
          tag: {
            pattern: /^<\/?[^\s>\/]+/,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          "special-attr": [],
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
            inside: {
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          },
          punctuation: /\/?>/,
          "attr-name": {
            pattern: /[^\s>\/]+/,
            inside: {
              namespace: /^[^\s>\/:]+:/
            }
          }
        }
      },
      entity: [
        {
          pattern: /&[\da-z]{1,8};/i,
          alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
      ]
    }, n.languages.markup.tag.inside["attr-value"].inside.entity = n.languages.markup.entity, n.languages.markup.doctype.inside["internal-subset"].inside = n.languages.markup, n.hooks.add("wrap", function(o) {
      o.type === "entity" && (o.attributes.title = o.content.replace(/&amp;/, "&"));
    }), Object.defineProperty(n.languages.markup.tag, "addInlined", {
      /**
       * Adds an inlined language to markup.
       *
       * An example of an inlined language is CSS with `<style>` tags.
       *
       * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addInlined('style', 'css');
       */
      value: function(r, i) {
        var a = {};
        a["language-" + i] = {
          pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
          lookbehind: !0,
          inside: n.languages[i]
        }, a.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var s = {
          "included-cdata": {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            inside: a
          }
        };
        s["language-" + i] = {
          pattern: /[\s\S]+/,
          inside: n.languages[i]
        };
        var c = {};
        c[r] = {
          pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
            return r;
          }), "i"),
          lookbehind: !0,
          greedy: !0,
          inside: s
        }, n.languages.insertBefore("markup", "cdata", c);
      }
    }), Object.defineProperty(n.languages.markup.tag, "addAttribute", {
      /**
       * Adds an pattern to highlight languages embedded in HTML attributes.
       *
       * An example of an inlined language is CSS with `style` attributes.
       *
       * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addAttribute('style', 'css');
       */
      value: function(o, r) {
        n.languages.markup.tag.inside["special-attr"].push({
          pattern: RegExp(
            /(^|["'\s])/.source + "(?:" + o + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
            "i"
          ),
          lookbehind: !0,
          inside: {
            "attr-name": /^[^\s=]+/,
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                value: {
                  pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                  lookbehind: !0,
                  alias: [r, "language-" + r],
                  inside: n.languages[r]
                },
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  /"|'/
                ]
              }
            }
          }
        });
      }
    }), n.languages.html = n.languages.markup, n.languages.mathml = n.languages.markup, n.languages.svg = n.languages.markup, n.languages.xml = n.languages.extend("markup", {}), n.languages.ssml = n.languages.xml, n.languages.atom = n.languages.xml, n.languages.rss = n.languages.xml, function(o) {
      var r = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      o.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
          inside: {
            rule: /^@[\w-]+/,
            "selector-function-argument": {
              pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
              lookbehind: !0,
              alias: "selector"
            },
            keyword: {
              pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        url: {
          // https://drafts.csswg.org/css-values-3/#urls
          pattern: RegExp("\\burl\\((?:" + r.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
          greedy: !0,
          inside: {
            function: /^url/i,
            punctuation: /^\(|\)$/,
            string: {
              pattern: RegExp("^" + r.source + "$"),
              alias: "url"
            }
          }
        },
        selector: {
          pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + r.source + ")*(?=\\s*\\{)"),
          lookbehind: !0
        },
        string: {
          pattern: r,
          greedy: !0
        },
        property: {
          pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
          lookbehind: !0
        },
        important: /!important\b/i,
        function: {
          pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
          lookbehind: !0
        },
        punctuation: /[(){};:,]/
      }, o.languages.css.atrule.inside.rest = o.languages.css;
      var i = o.languages.markup;
      i && (i.tag.addInlined("style", "css"), i.tag.addAttribute("style", "css"));
    }(n), n.languages.clike = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b\w+(?=\()/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
      punctuation: /[{}[\];(),.:]/
    }, n.languages.javascript = n.languages.extend("clike", {
      "class-name": [
        n.languages.clike["class-name"],
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /((?:^|\})\s*)catch\b/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
          lookbehind: !0
        }
      ],
      // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
      function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
      number: {
        pattern: RegExp(
          /(^|[^\w$])/.source + "(?:" + // constant
          (/NaN|Infinity/.source + "|" + // binary integer
          /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
          /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
          /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
          /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
          /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
        ),
        lookbehind: !0
      },
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    }), n.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, n.languages.insertBefore("javascript", "keyword", {
      regex: {
        pattern: RegExp(
          // lookbehind
          // eslint-disable-next-line regexp/no-dupe-characters-character-class
          /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
          // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
          // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
          // with the only syntax, so we have to define 2 different regex patterns.
          /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
          /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
          /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: n.languages.regex
          },
          "regex-delimiter": /^\/|\/$/,
          "regex-flags": /^[a-z]+$/
        }
      },
      // This must be declared before keyword because we use "function" inside the look-forward
      "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      },
      parameter: [
        {
          pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        {
          pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        {
          pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
          lookbehind: !0,
          inside: n.languages.javascript
        }
      ],
      constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    }), n.languages.insertBefore("javascript", "string", {
      hashbang: {
        pattern: /^#!.*/,
        greedy: !0,
        alias: "comment"
      },
      "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: n.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      },
      "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      }
    }), n.languages.insertBefore("javascript", "operator", {
      "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: !0,
        alias: "property"
      }
    }), n.languages.markup && (n.languages.markup.tag.addInlined("script", "javascript"), n.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
      "javascript"
    )), n.languages.js = n.languages.javascript, function() {
      if (typeof n > "u" || typeof document > "u")
        return;
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
      var o = "Loading…", r = function(f, h) {
        return "✖ Error " + f + " while fetching file: " + h;
      }, i = "✖ Error: File does not exist or is empty", a = {
        js: "javascript",
        py: "python",
        rb: "ruby",
        ps1: "powershell",
        psm1: "powershell",
        sh: "bash",
        bat: "batch",
        h: "c",
        tex: "latex"
      }, s = "data-src-status", c = "loading", l = "loaded", u = "failed", d = "pre[data-src]:not([" + s + '="' + l + '"]):not([' + s + '="' + c + '"])';
      function _(f, h, $) {
        var v = new XMLHttpRequest();
        v.open("GET", f, !0), v.onreadystatechange = function() {
          v.readyState == 4 && (v.status < 400 && v.responseText ? h(v.responseText) : v.status >= 400 ? $(r(v.status, v.statusText)) : $(i));
        }, v.send(null);
      }
      function p(f) {
        var h = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(f || "");
        if (h) {
          var $ = Number(h[1]), v = h[2], b = h[3];
          return v ? b ? [$, Number(b)] : [$, void 0] : [$, $];
        }
      }
      n.hooks.add("before-highlightall", function(f) {
        f.selector += ", " + d;
      }), n.hooks.add("before-sanity-check", function(f) {
        var h = (
          /** @type {HTMLPreElement} */
          f.element
        );
        if (h.matches(d)) {
          f.code = "", h.setAttribute(s, c);
          var $ = h.appendChild(document.createElement("CODE"));
          $.textContent = o;
          var v = h.getAttribute("data-src"), b = f.language;
          if (b === "none") {
            var y = (/\.(\w+)$/.exec(v) || [, "none"])[1];
            b = a[y] || y;
          }
          n.util.setLanguage($, b), n.util.setLanguage(h, b);
          var w = n.plugins.autoloader;
          w && w.loadLanguages(b), _(
            v,
            function(N) {
              h.setAttribute(s, l);
              var M = p(h.getAttribute("data-range"));
              if (M) {
                var q = N.split(/\r\n?|\n/g), L = M[0], R = M[1] == null ? q.length : M[1];
                L < 0 && (L += q.length), L = Math.max(0, Math.min(L - 1, q.length)), R < 0 && (R += q.length), R = Math.max(0, Math.min(R, q.length)), N = q.slice(L, R).join(`
`), h.hasAttribute("data-start") || h.setAttribute("data-start", String(L + 1));
              }
              $.textContent = N, n.highlightElement($);
            },
            function(N) {
              h.setAttribute(s, u), $.textContent = N;
            }
          );
        }
      }), n.plugins.fileHighlight = {
        /**
         * Executes the File Highlight plugin for all matching `pre` elements under the given container.
         *
         * Note: Elements which are already loaded or currently loading will not be touched by this method.
         *
         * @param {ParentNode} [container=document]
         */
        highlight: function(h) {
          for (var $ = (h || document).querySelectorAll(d), v = 0, b; b = $[v++]; )
            n.highlightElement(b);
        }
      };
      var g = !1;
      n.fileHighlight = function() {
        g || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), g = !0), n.plugins.fileHighlight.highlight.apply(this, arguments);
      };
    }();
  }(OR)), OR.exports;
}
var vX = {}, bX;
function obe() {
  return bX || (bX = 1, Prism.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  }), vX;
}
var yX = {}, $X;
function rbe() {
  return $X || ($X = 1, Prism.languages.javascript = Prism.languages.extend("clike", {
    "class-name": [
      Prism.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, Prism.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: RegExp(
        // lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: Prism.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: Prism.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: Prism.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: Prism.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: Prism.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), Prism.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: Prism.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), Prism.languages.js = Prism.languages.javascript), yX;
}
var wX = {}, kX;
function ibe() {
  return kX || (kX = 1, Prism.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity, Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup, Prism.hooks.add("wrap", function(e) {
    e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(t, n) {
      var o = {};
      o["language-" + n] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: Prism.languages[n]
      }, o.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var r = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: o
        }
      };
      r["language-" + n] = {
        pattern: /[\s\S]+/,
        inside: Prism.languages[n]
      };
      var i = {};
      i[t] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
          return t;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: r
      }, Prism.languages.insertBefore("markup", "cdata", i);
    }
  }), Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(e, t) {
      Prism.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [t, "language-" + t],
                inside: Prism.languages[t]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup, Prism.languages.xml = Prism.languages.extend("markup", {}), Prism.languages.ssml = Prism.languages.xml, Prism.languages.atom = Prism.languages.xml, Prism.languages.rss = Prism.languages.xml), wX;
}
var SX = {}, EX;
function abe() {
  return EX || (EX = 1, function(e) {
    var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function n(u) {
      return u = u.replace(/<inner>/g, function() {
        return t;
      }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + u + ")");
    }
    var o = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, r = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
      return o;
    }), i = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
    e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
      "front-matter-block": {
        pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          punctuation: /^---|---$/,
          "front-matter": {
            pattern: /\S+(?:\s+\S+)*/,
            alias: ["yaml", "language-yaml"],
            inside: e.languages.yaml
          }
        }
      },
      blockquote: {
        // > ...
        pattern: /^>(?:[\t ]*>)*/m,
        alias: "punctuation"
      },
      table: {
        pattern: RegExp("^" + r + i + "(?:" + r + ")*", "m"),
        inside: {
          "table-data-rows": {
            pattern: RegExp("^(" + r + i + ")(?:" + r + ")*$"),
            lookbehind: !0,
            inside: {
              "table-data": {
                pattern: RegExp(o),
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          },
          "table-line": {
            pattern: RegExp("^(" + r + ")" + i + "$"),
            lookbehind: !0,
            inside: {
              punctuation: /\||:?-{3,}:?/
            }
          },
          "table-header-row": {
            pattern: RegExp("^" + r + "$"),
            inside: {
              "table-header": {
                pattern: RegExp(o),
                alias: "important",
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          }
        }
      },
      code: [
        {
          // Prefixed by 4 spaces or 1 tab and preceded by an empty line
          pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
          lookbehind: !0,
          alias: "keyword"
        },
        {
          // ```optional language
          // code block
          // ```
          pattern: /^```[\s\S]*?^```$/m,
          greedy: !0,
          inside: {
            "code-block": {
              pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
              lookbehind: !0
            },
            "code-language": {
              pattern: /^(```).+/,
              lookbehind: !0
            },
            punctuation: /```/
          }
        }
      ],
      title: [
        {
          // title 1
          // =======
          // title 2
          // -------
          pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
          alias: "important",
          inside: {
            punctuation: /==+$|--+$/
          }
        },
        {
          // # title 1
          // ###### title 6
          pattern: /(^\s*)#.+/m,
          lookbehind: !0,
          alias: "important",
          inside: {
            punctuation: /^#+|#+$/
          }
        }
      ],
      hr: {
        // ***
        // ---
        // * * *
        // -----------
        pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      list: {
        // * item
        // + item
        // - item
        // 1. item
        pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      "url-reference": {
        // [id]: http://example.com "Optional title"
        // [id]: http://example.com 'Optional title'
        // [id]: http://example.com (Optional title)
        // [id]: <http://example.com> "Optional title"
        pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
        inside: {
          variable: {
            pattern: /^(!?\[)[^\]]+/,
            lookbehind: !0
          },
          string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
          punctuation: /^[\[\]!:]|[<>]/
        },
        alias: "url"
      },
      bold: {
        // **strong**
        // __strong__
        // allow one nested instance of italic text using the same delimiter
        pattern: n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^..)[\s\S]+(?=..$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /\*\*|__/
        }
      },
      italic: {
        // *em*
        // _em_
        // allow one nested instance of bold text using the same delimiter
        pattern: n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^.)[\s\S]+(?=.$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /[*_]/
        }
      },
      strike: {
        // ~~strike through~~
        // ~strike~
        // eslint-disable-next-line regexp/strict
        pattern: n(/(~~?)(?:(?!~)<inner>)+\2/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^~~?)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /~~?/
        }
      },
      "code-snippet": {
        // `code`
        // ``code``
        pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
        lookbehind: !0,
        greedy: !0,
        alias: ["code", "keyword"]
      },
      url: {
        // [example](http://example.com "Optional title")
        // [example][id]
        // [example] [id]
        pattern: n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          operator: /^!/,
          content: {
            pattern: /(^\[)[^\]]+(?=\])/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          variable: {
            pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
            lookbehind: !0
          },
          url: {
            pattern: /(^\]\()[^\s)]+/,
            lookbehind: !0
          },
          string: {
            pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
            lookbehind: !0
          }
        }
      }
    }), ["url", "bold", "italic", "strike"].forEach(function(u) {
      ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(d) {
        u !== d && (e.languages.markdown[u].inside.content.inside[d] = e.languages.markdown[d]);
      });
    }), e.hooks.add("after-tokenize", function(u) {
      if (u.language !== "markdown" && u.language !== "md")
        return;
      function d(_) {
        if (!(!_ || typeof _ == "string"))
          for (var p = 0, g = _.length; p < g; p++) {
            var f = _[p];
            if (f.type !== "code") {
              d(f.content);
              continue;
            }
            var h = f.content[1], $ = f.content[3];
            if (h && $ && h.type === "code-language" && $.type === "code-block" && typeof h.content == "string") {
              var v = h.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
              v = (/[a-z][\w-]*/i.exec(v) || [""])[0].toLowerCase();
              var b = "language-" + v;
              $.alias ? typeof $.alias == "string" ? $.alias = [$.alias, b] : $.alias.push(b) : $.alias = [b];
            }
          }
      }
      d(u.tokens);
    }), e.hooks.add("wrap", function(u) {
      if (u.type === "code-block") {
        for (var d = "", _ = 0, p = u.classes.length; _ < p; _++) {
          var g = u.classes[_], f = /language-(.+)/.exec(g);
          if (f) {
            d = f[1];
            break;
          }
        }
        var h = e.languages[d];
        if (h)
          u.content = e.highlight(l(u.content), h, d);
        else if (d && d !== "none" && e.plugins.autoloader) {
          var $ = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
          u.attributes.id = $, e.plugins.autoloader.loadLanguages(d, function() {
            var v = document.getElementById($);
            v && (v.innerHTML = e.highlight(v.textContent, e.languages[d], d));
          });
        }
      }
    });
    var a = RegExp(e.languages.markup.tag.pattern.source, "gi"), s = {
      amp: "&",
      lt: "<",
      gt: ">",
      quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    function l(u) {
      var d = u.replace(a, "");
      return d = d.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(_, p) {
        if (p = p.toLowerCase(), p[0] === "#") {
          var g;
          return p[1] === "x" ? g = parseInt(p.slice(2), 16) : g = Number(p.slice(1)), c(g);
        } else {
          var f = s[p];
          return f || _;
        }
      }), d;
    }
    e.languages.md = e.languages.markdown;
  }(Prism)), SX;
}
var xX = {}, CX;
function sbe() {
  return CX || (CX = 1, Prism.languages.c = Prism.languages.extend("clike", {
    comment: {
      pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    string: {
      // https://en.cppreference.com/w/c/language/string_literal
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
      lookbehind: !0
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
  }), Prism.languages.insertBefore("c", "string", {
    char: {
      // https://en.cppreference.com/w/c/language/character_constant
      pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
      greedy: !0
    }
  }), Prism.languages.insertBefore("c", "string", {
    macro: {
      // allow for multiline macro definitions
      // spaces after the # character compile fine with gcc
      pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: !0,
      greedy: !0,
      alias: "property",
      inside: {
        string: [
          {
            // highlight the path of the include statement as a string
            pattern: /^(#\s*include\s*)<[^>]+>/,
            lookbehind: !0
          },
          Prism.languages.c.string
        ],
        char: Prism.languages.c.char,
        comment: Prism.languages.c.comment,
        "macro-name": [
          {
            pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
            lookbehind: !0
          },
          {
            pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
            lookbehind: !0,
            alias: "function"
          }
        ],
        // highlight macro directives as keywords
        directive: {
          pattern: /^(#\s*)[a-z]+/,
          lookbehind: !0,
          alias: "keyword"
        },
        "directive-hash": /^#/,
        punctuation: /##|\\(?=[\r\n])/,
        expression: {
          pattern: /\S[\s\S]*/,
          inside: Prism.languages.c
        }
      }
    }
  }), Prism.languages.insertBefore("c", "function", {
    // highlight predefined macros as constants
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
  }), delete Prism.languages.c.boolean), xX;
}
var TX = {}, AX;
function cbe() {
  return AX || (AX = 1, function(e) {
    var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    e.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + t.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"),
        lookbehind: !0
      },
      string: {
        pattern: t,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css;
    var n = e.languages.markup;
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
  }(Prism)), TX;
}
var IX = {}, OX;
function lbe() {
  return OX || (OX = 1, Prism.languages.objectivec = Prism.languages.extend("c", {
    string: {
      pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
  }), delete Prism.languages.objectivec["class-name"], Prism.languages.objc = Prism.languages.objectivec), IX;
}
var NX = {}, zX;
function ube() {
  return zX || (zX = 1, Prism.languages.sql = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
      lookbehind: !0
    },
    variable: [
      {
        pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
        greedy: !0
      },
      /@[\w.$]+/
    ],
    string: {
      pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
      greedy: !0,
      lookbehind: !0
    },
    identifier: {
      pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
      greedy: !0,
      lookbehind: !0,
      inside: {
        punctuation: /^`|`$/
      }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    // Should we highlight user defined functions too?
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
  }), NX;
}
var RX = {}, PX;
function dbe() {
  return PX || (PX = 1, Prism.languages.python = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0,
      greedy: !0
    },
    "string-interpolation": {
      pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
      greedy: !0,
      inside: {
        interpolation: {
          // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
          pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
          lookbehind: !0,
          inside: {
            "format-spec": {
              pattern: /(:)[^:(){}]+(?=\}$)/,
              lookbehind: !0
            },
            "conversion-option": {
              pattern: /![sra](?=[:}]$)/,
              alias: "punctuation"
            },
            rest: null
          }
        },
        string: /[\s\S]+/
      }
    },
    "triple-quoted-string": {
      pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
      greedy: !0
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
      lookbehind: !0
    },
    "class-name": {
      pattern: /(\bclass\s+)\w+/i,
      lookbehind: !0
    },
    decorator: {
      pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
      lookbehind: !0,
      alias: ["annotation", "punctuation"],
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python, Prism.languages.py = Prism.languages.python), RX;
}
var DX = {}, LX;
function _be() {
  return LX || (LX = 1, function(e) {
    for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, n = 0; n < 2; n++)
      t = t.replace(/<self>/g, function() {
        return t;
      });
    t = t.replace(/<self>/g, function() {
      return /[^\s\S]/.source;
    }), e.languages.rust = {
      comment: [
        {
          pattern: RegExp(/(^|[^\\])/.source + t),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
        greedy: !0
      },
      char: {
        pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
        greedy: !0
      },
      attribute: {
        pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
        greedy: !0,
        alias: "attr-name",
        inside: {
          string: null
          // see below
        }
      },
      // Closure params should not be confused with bitwise OR |
      "closure-params": {
        pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "closure-punctuation": {
            pattern: /^\||\|$/,
            alias: "punctuation"
          },
          rest: null
          // see below
        }
      },
      "lifetime-annotation": {
        pattern: /'\w+/,
        alias: "symbol"
      },
      "fragment-specifier": {
        pattern: /(\$\w+:)[a-z]+/,
        lookbehind: !0,
        alias: "punctuation"
      },
      variable: /\$\w+/,
      "function-definition": {
        pattern: /(\bfn\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      "type-definition": {
        pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
        lookbehind: !0,
        alias: "class-name"
      },
      "module-declaration": [
        {
          pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
          lookbehind: !0,
          alias: "namespace"
        },
        {
          pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
          lookbehind: !0,
          alias: "namespace",
          inside: {
            punctuation: /::/
          }
        }
      ],
      keyword: [
        // https://github.com/rust-lang/reference/blob/master/src/keywords.md
        /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
        // primitives and str
        // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
        /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
      ],
      // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
      // and Rust's naming conventions recommend snake_case anyway.
      // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
      macro: {
        pattern: /\b\w+!/,
        alias: "property"
      },
      constant: /\b[A-Z_][A-Z_\d]+\b/,
      "class-name": /\b[A-Z]\w*\b/,
      namespace: {
        pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
        inside: {
          punctuation: /::/
        }
      },
      // Hex, oct, bin, dec numbers with visual separators and type suffix
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
      operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
  }(Prism)), DX;
}
var MX = {}, FX;
function pbe() {
  return FX || (FX = 1, Prism.languages.swift = {
    comment: {
      // Nested comments are supported up to 2 levels
      pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
      lookbehind: !0,
      greedy: !0
    },
    "string-literal": [
      // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
      {
        pattern: RegExp(
          /(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "interpolation-punctuation": {
            pattern: /^\)|\\\($/,
            alias: "punctuation"
          },
          punctuation: /\\(?=[\r\n])/,
          string: /[\s\S]+/
        }
      },
      {
        pattern: RegExp(
          /(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "interpolation-punctuation": {
            pattern: /^\)|\\#+\($/,
            alias: "punctuation"
          },
          string: /[\s\S]+/
        }
      }
    ],
    directive: {
      // directives with conditions
      pattern: RegExp(
        /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
      ),
      alias: "property",
      inside: {
        "directive-name": /^#\w+/,
        boolean: /\b(?:false|true)\b/,
        number: /\b\d+(?:\.\d+)*\b/,
        operator: /!|&&|\|\||[<>]=?/,
        punctuation: /[(),]/
      }
    },
    literal: {
      pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
      alias: "constant"
    },
    "other-directive": {
      pattern: /#\w+\b/,
      alias: "property"
    },
    attribute: {
      pattern: /@\w+/,
      alias: "atrule"
    },
    "function-definition": {
      pattern: /(\bfunc\s+)\w+/,
      lookbehind: !0,
      alias: "function"
    },
    label: {
      // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
      pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
      lookbehind: !0,
      alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
      pattern: /\bnil\b/,
      alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
      pattern: /\b_\b/,
      alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
    // This regex only supports ASCII operators.
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
  }, Prism.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = Prism.languages.swift;
  })), MX;
}
var qX = {}, jX;
function mbe() {
  return jX || (jX = 1, function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(
      /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
      // keywords that have to be followed by an identifier
      /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
      // This is for `import type *, {}`
      /\btype\b(?=\s*(?:[\{*]|$))/
    ), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var t = e.languages.extend("typescript", {});
    delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {
      decorator: {
        pattern: /@[$\w\xA0-\uFFFF]+/,
        inside: {
          at: {
            pattern: /^@/,
            alias: "operator"
          },
          function: /^[\s\S]+/
        }
      },
      "generic-function": {
        // e.g. foo<T extends "bar" | "baz">( ...
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
        greedy: !0,
        inside: {
          function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
          generic: {
            pattern: /<[\s\S]+/,
            // everything after the first <
            alias: "class-name",
            inside: t
          }
        }
      }
    }), e.languages.ts = e.languages.typescript;
  }(Prism)), qX;
}
var VX = {}, BX;
function fbe() {
  return BX || (BX = 1, function(e) {
    var t = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, n = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, o = {
      pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /\./
      }
    };
    e.languages.java = e.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        o,
        {
          // variables, parameters, and constructor references
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
          lookbehind: !0,
          inside: o.inside
        },
        {
          // class names based on keyword
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + n + /[A-Z]\w*\b/.source),
          lookbehind: !0,
          inside: o.inside
        }
      ],
      keyword: t,
      function: [
        e.languages.clike.function,
        {
          pattern: /(::\s*)[a-z_]\w*/,
          lookbehind: !0
        }
      ],
      number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
      operator: {
        pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
        lookbehind: !0
      }
    }), e.languages.insertBefore("java", "string", {
      "triple-quoted-string": {
        // http://openjdk.java.net/jeps/355#Description
        pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
        greedy: !0,
        alias: "string"
      },
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
        greedy: !0
      }
    }), e.languages.insertBefore("java", "class-name", {
      annotation: {
        pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
        lookbehind: !0,
        alias: "punctuation"
      },
      generics: {
        pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
        inside: {
          "class-name": o,
          keyword: t,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      },
      import: [
        {
          pattern: RegExp(/(\bimport\s+)/.source + n + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
          lookbehind: !0,
          inside: {
            namespace: o.inside.namespace,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        },
        {
          pattern: RegExp(/(\bimport\s+static\s+)/.source + n + /(?:\w+|\*)(?=\s*;)/.source),
          lookbehind: !0,
          alias: "static",
          inside: {
            namespace: o.inside.namespace,
            static: /\b\w+$/,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        }
      ],
      namespace: {
        pattern: RegExp(
          /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
            return t.source;
          })
        ),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    });
  }(Prism)), VX;
}
var UX = {}, GX;
function gbe() {
  return GX || (GX = 1, function(e) {
    var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, n = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
      return t.source;
    });
    e.languages.cpp = e.languages.extend("c", {
      "class-name": [
        {
          pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
            return t.source;
          })),
          lookbehind: !0
        },
        // This is intended to capture the class name of method implementations like:
        //   void foo::bar() const {}
        // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
        // it starts with an uppercase letter. This approximation should give decent results.
        /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
        // This will capture the class name before destructors like:
        //   Foo::~Foo() {}
        /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
        // This also intends to capture the class name of method implementations but here the class has template
        // parameters, so it can't be a namespace (until C++ adds generic namespaces).
        /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
      ],
      keyword: t,
      number: {
        pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
        greedy: !0
      },
      operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
      boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
      module: {
        // https://en.cppreference.com/w/cpp/language/modules
        pattern: RegExp(
          /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
          /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
          /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
            return n;
          }) + ")"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          string: /^[<"][\s\S]+/,
          operator: /:/,
          punctuation: /\./
        }
      },
      "raw-string": {
        pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
        alias: "string",
        greedy: !0
      }
    }), e.languages.insertBefore("cpp", "keyword", {
      "generic-function": {
        pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
        inside: {
          function: /^\w+/,
          generic: {
            pattern: /<[\s\S]+/,
            alias: "class-name",
            inside: e.languages.cpp
          }
        }
      }
    }), e.languages.insertBefore("cpp", "operator", {
      "double-colon": {
        pattern: /::/,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("cpp", "class-name", {
      // the base clause is an optional list of parent classes
      // https://en.cppreference.com/w/cpp/language/class
      "base-clause": {
        pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
        lookbehind: !0,
        greedy: !0,
        inside: e.languages.extend("cpp", {})
      }
    }), e.languages.insertBefore("inside", "double-colon", {
      // All untokenized words that are not namespaces should be class names
      "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
  }(Prism)), UX;
}
var Ps = {}, gs = {}, en = {}, WX;
function kHl() {
  if (WX)
    return en;
  WX = 1;
  let e = {}, t = {}, n = {}, o = {}, r = {}, i = {}, a = {}, s = {}, c = {}, l = {}, u = {}, d = {}, _ = {}, p = {}, g = {}, f = {}, h = {}, $ = {}, v = {}, b = {}, y = {}, w = {}, N = {}, M = {}, q = {}, L = {}, R = {}, T = {}, D = {}, A = {}, S = {}, E = {}, x = {}, k = {}, I = {};
  function z(Z) {
    throw Error(`Minified Lexical error #${Z}; visit https://lexical.dev/docs/error?code=${Z} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  let F = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", P = F && "documentMode" in document ? document.documentMode : null, O = F && /Mac|iPod|iPhone|iPad/.test(navigator.platform), V = F && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), U = F && "InputEvent" in window && !P ? "getTargetRanges" in new window.InputEvent("input") : !1, H = F && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), J = F && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, le = F && /^(?=.*Chrome).*/i.test(navigator.userAgent), ae = F && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !le, Y = H || J || ae ? " " : "​", re = V ? " " : Y, ie = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/, _e = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/, he = { bold: 1, code: 16, highlight: 128, italic: 2, strikethrough: 4, subscript: 32, superscript: 64, underline: 8 }, be = { directionless: 1, unmergeable: 2 }, Q = { center: 2, end: 6, justify: 4, left: 1, right: 3, start: 5 }, me = { 2: "center", 6: "end", 4: "justify", 1: "left", 3: "right", 5: "start" }, ne = { normal: 0, segmented: 2, token: 1 }, pe = { 0: "normal", 2: "segmented", 1: "token" }, ge = !1, ve = 0;
  function Te(Z) {
    ve = Z.timeStamp;
  }
  function Re(Z, B, K) {
    return B.__lexicalLineBreak === Z || Z[`__lexicalKey_${K._key}`] !== void 0;
  }
  function Me(Z) {
    return Z.getEditorState().read(() => {
      let B = To();
      return B !== null ? B.clone() : null;
    });
  }
  function et(Z, B, K) {
    ge = !0;
    let ue = 100 < performance.now() - ve;
    try {
      gt(Z, () => {
        let fe = To() || Me(Z);
        var ke = /* @__PURE__ */ new Map(), Ee = Z.getRootElement(), qe = Z._editorState, ot = Z._blockCursorElement;
        let $t = !1, Vt = "";
        for (var Mt = 0; Mt < B.length; Mt++) {
          var zt = B[Mt], Rt = zt.type, Sn = zt.target, Cn = Ln(Sn, qe);
          if (!(Cn === null && Sn !== Ee || Ct(Cn))) {
            if (Rt === "characterData") {
              if (zt = ue && Vn(Cn))
                e: {
                  zt = fe, Rt = Sn;
                  var ro = Cn;
                  if (po(zt)) {
                    var Uo = zt.anchor.getNode();
                    if (Uo.is(ro) && zt.format !== Uo.getFormat()) {
                      zt = !1;
                      break e;
                    }
                  }
                  zt = Rt.nodeType === 3 && ro.isAttached();
                }
              zt && (ro = xn(Z._window), Rt = zt = null, ro !== null && ro.anchorNode === Sn && (zt = ro.anchorOffset, Rt = ro.focusOffset), Sn = Sn.nodeValue, Sn !== null && Rr(Cn, Sn, zt, Rt, !1));
            } else if (Rt === "childList") {
              for ($t = !0, Rt = zt.addedNodes, ro = 0; ro < Rt.length; ro++) {
                Uo = Rt[ro];
                var Oi = Rn(Uo), ga = Uo.parentNode;
                ga == null || Uo === ot || Oi !== null || Uo.nodeName === "BR" && Re(Uo, ga, Z) || (V && (Oi = Uo.innerText || Uo.nodeValue) && (Vt += Oi), ga.removeChild(Uo));
              }
              if (zt = zt.removedNodes, Rt = zt.length, 0 < Rt) {
                for (ro = 0, Uo = 0; Uo < Rt; Uo++)
                  ga = zt[Uo], (ga.nodeName === "BR" && Re(ga, Sn, Z) || ot === ga) && (Sn.appendChild(ga), ro++);
                Rt !== ro && (Sn === Ee && (Cn = qe._nodeMap.get("root")), ke.set(Sn, Cn));
              }
            }
          }
        }
        if (0 < ke.size)
          for (let [bc, ld] of ke)
            if (We(ld))
              for (ke = ld.getChildrenKeys(), Ee = bc.firstChild, qe = 0; qe < ke.length; qe++)
                ot = Z.getElementByKey(ke[qe]), ot !== null && (Ee == null ? (bc.appendChild(ot), Ee = ot) : Ee !== ot && bc.replaceChild(ot, Ee), Ee = Ee.nextSibling);
            else
              Vn(ld) && ld.markDirty();
        if (ke = K.takeRecords(), 0 < ke.length) {
          for (Ee = 0; Ee < ke.length; Ee++)
            for (ot = ke[Ee], qe = ot.addedNodes, ot = ot.target, Mt = 0; Mt < qe.length; Mt++)
              Cn = qe[Mt], Sn = Cn.parentNode, Sn == null || Cn.nodeName !== "BR" || Re(Cn, ot, Z) || Sn.removeChild(Cn);
          K.takeRecords();
        }
        fe !== null && ($t && (fe.dirty = !0, Xn(fe)), V && Gn(Z) && fe.insertRawText(Vt));
      });
    } finally {
      ge = !1;
    }
  }
  function st(Z) {
    let B = Z._observer;
    if (B !== null) {
      let K = B.takeRecords();
      et(Z, K, B);
    }
  }
  function De(Z) {
    ve === 0 && dt(Z).addEventListener("textInput", Te, !0), Z._observer = new MutationObserver((B, K) => {
      et(Z, B, K);
    });
  }
  let ze = 1, Pe = typeof queueMicrotask == "function" ? queueMicrotask : (Z) => {
    Promise.resolve().then(Z);
  };
  function je(Z) {
    let B = document.activeElement;
    if (B === null)
      return !1;
    let K = B.nodeName;
    return Ct(Ln(Z)) && (K === "INPUT" || K === "TEXTAREA" || B.contentEditable === "true" && B.__lexicalEditor == null);
  }
  function He(Z, B, K) {
    let ue = Z.getRootElement();
    try {
      return ue !== null && ue.contains(B) && ue.contains(K) && B !== null && !je(B) && Xe(B) === Z;
    } catch {
      return !1;
    }
  }
  function Xe(Z) {
    for (; Z != null; ) {
      let B = Z.__lexicalEditor;
      if (B != null)
        return B;
      Z = zn(Z);
    }
    return null;
  }
  function at(Z) {
    return Z.isToken() || Z.isSegmented();
  }
  function wt(Z) {
    for (; Z != null; ) {
      if (Z.nodeType === 3)
        return Z;
      Z = Z.firstChild;
    }
    return null;
  }
  function Je(Z, B, K) {
    return B = he[B], Z & B && (K === null || !(K & B)) ? Z ^ B : K === null || K & B ? Z | B : Z;
  }
  function vt(Z) {
    return Vn(Z) || gm(Z) || Ct(Z);
  }
  function Ot(Z, B) {
    if (B != null)
      Z.__key = B;
    else {
      Jr(), 99 < Xa && z(14), B = Do();
      var K = oa(), ue = "" + ze++;
      K._nodeMap.set(ue, Z), We(Z) ? B._dirtyElements.set(ue, !0) : B._dirtyLeaves.add(ue), B._cloneNotNeeded.add(ue), B._dirtyType = 1, Z.__key = ue;
    }
  }
  function Ft(Z) {
    var B = Z.getParent();
    if (B !== null) {
      let fe = Z.getWritable();
      B = B.getWritable();
      var K = Z.getPreviousSibling();
      if (Z = Z.getNextSibling(), K === null)
        if (Z !== null) {
          var ue = Z.getWritable();
          B.__first = Z.__key, ue.__prev = null;
        } else
          B.__first = null;
      else {
        if (ue = K.getWritable(), Z !== null) {
          let ke = Z.getWritable();
          ke.__prev = ue.__key, ue.__next = ke.__key;
        } else
          ue.__next = null;
        fe.__prev = null;
      }
      Z === null ? K !== null ? (Z = K.getWritable(), B.__last = K.__key, Z.__next = null) : B.__last = null : (Z = Z.getWritable(), K !== null ? (K = K.getWritable(), K.__next = Z.__key, Z.__prev = K.__key) : Z.__prev = null, fe.__next = null), B.__size--, fe.__parent = null;
    }
  }
  function wn(Z) {
    99 < Xa && z(14);
    var B = Z.getLatest(), K = B.__parent, ue = oa();
    let fe = Do(), ke = ue._nodeMap;
    if (ue = fe._dirtyElements, K !== null)
      e:
        for (; K !== null; ) {
          if (ue.has(K))
            break e;
          let Ee = ke.get(K);
          if (Ee === void 0)
            break;
          ue.set(K, !1), K = Ee.__parent;
        }
    B = B.__key, fe._dirtyType = 1, We(Z) ? ue.set(B, !0) : fe._dirtyLeaves.add(B);
  }
  function un(Z) {
    Jr();
    var B = Do();
    let K = B._compositionKey;
    Z !== K && (B._compositionKey = Z, K !== null && (B = Dn(K), B !== null && B.getWritable()), Z !== null && (Z = Dn(Z), Z !== null && Z.getWritable()));
  }
  function pn() {
    return Bi() ? null : Do()._compositionKey;
  }
  function Dn(Z, B) {
    return Z = (B || oa())._nodeMap.get(Z), Z === void 0 ? null : Z;
  }
  function Rn(Z, B) {
    let K = Do();
    return Z = Z[`__lexicalKey_${K._key}`], Z !== void 0 ? Dn(Z, B) : null;
  }
  function Ln(Z, B) {
    for (; Z != null; ) {
      let K = Rn(Z, B);
      if (K !== null)
        return K;
      Z = zn(Z);
    }
    return null;
  }
  function Yn(Z) {
    let B = Object.assign({}, Z._decorators);
    return Z._pendingDecorators = B;
  }
  function Qt(Z) {
    return Z.read(() => qn().getTextContent());
  }
  function fn(Z, B) {
    gt(Z, () => {
      var K = oa();
      if (!K.isEmpty())
        if (B === "root")
          qn().markDirty();
        else {
          K = K._nodeMap;
          for (let [, ue] of K)
            ue.markDirty();
        }
    }, Z._pendingEditorState === null ? { tag: "history-merge" } : void 0);
  }
  function qn() {
    return oa()._nodeMap.get("root");
  }
  function Xn(Z) {
    Jr();
    let B = oa();
    Z !== null && (Z.dirty = !0, Z._cachedNodes = null), B._selection = Z;
  }
  function Qn(Z) {
    var B = Do(), K;
    e: {
      for (K = Z; K != null; ) {
        let ue = K[`__lexicalKey_${B._key}`];
        if (ue !== void 0) {
          K = ue;
          break e;
        }
        K = zn(K);
      }
      K = null;
    }
    return K === null ? (B = B.getRootElement(), Z === B ? Dn("root") : null) : Dn(K);
  }
  function In(Z) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(Z);
  }
  function $n(Z) {
    let B = [];
    for (; Z !== null; )
      B.push(Z), Z = Z._parentEditor;
    return B;
  }
  function uo() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
  }
  function go(Z, B, K) {
    if (B = xn(B._window), B !== null) {
      var ue = B.anchorNode, { anchorOffset: fe, focusOffset: ke } = B;
      if (ue !== null && (B = ue.nodeType === 3 ? ue.nodeValue : null, ue = Ln(ue), B !== null && Vn(ue))) {
        if (ue.canContainTabs()) {
          var Ee = B.includes("	");
          if (K && 0 < K.length && Ee) {
            Ee = K.length;
            let qe = fe + Ee - 1, ot = B.slice(0, qe);
            B = B.slice(qe, B.length), B = `${ot}${K}${B}`, fe += Ee, ke += Ee;
          }
        }
        B === Y && K && (Ee = K.length, B = K, ke = fe = Ee), B !== null && Rr(ue, B, fe, ke, Z);
      }
    }
  }
  function Rr(Z, B, K, ue, fe) {
    let ke = Z;
    if (ke.isAttached() && (fe || !ke.isDirty())) {
      var Ee = ke.isComposing();
      if (Z = B, (Ee || fe) && B[B.length - 1] === Y && (Z = B.slice(0, -1)), B = ke.getTextContent(), fe || Z !== B)
        if (Z === "")
          if (un(null), H || J || ae)
            ke.remove();
          else {
            let $t = Do();
            setTimeout(() => {
              $t.update(() => {
                ke.isAttached() && ke.remove();
              });
            }, 20);
          }
        else {
          fe = ke.getParent(), B = Na();
          var qe = pn(), ot = ke.getKey();
          ke.isToken() || qe !== null && ot === qe && !Ee || fe !== null && po(B) && !fe.canInsertTextBefore() && B.anchor.offset === 0 ? ke.markDirty() : (Ee = To(), po(Ee) && K !== null && ue !== null && (Ee.setTextNodeRange(
            ke,
            K,
            ke,
            ue
          ), ke.isSegmented() && (K = ke.getTextContent(), K = ra(K), ke.replace(K), ke = K)), ke.setTextContent(Z));
        }
    }
  }
  function qo(Z, B) {
    if (B.isSegmented())
      return !0;
    if (!Z.isCollapsed())
      return !1;
    Z = Z.anchor.offset;
    let K = B.getParentOrThrow(), ue = B.isToken();
    return Z === 0 ? ((Z = !B.canInsertTextBefore() || !K.canInsertTextBefore() || ue) || (B = B.getPreviousSibling(), Z = (Vn(B) || We(B) && B.isInline()) && !B.canInsertTextAfter()), Z) : Z === B.getTextContentSize() ? !B.canInsertTextAfter() || !K.canInsertTextAfter() || ue : !1;
  }
  function ho(Z, B) {
    var K = Z[B];
    return typeof K == "string" ? (K = K.split(" "), Z[B] = K) : K;
  }
  function Ut(Z, B, K, ue, fe) {
    K.size !== 0 && (K = ue.__key, B = B.get(ue.__type), B === void 0 && z(33), ue = B.klass, B = Z.get(ue), B === void 0 && (B = /* @__PURE__ */ new Map(), Z.set(ue, B)), Z = B.get(K), ue = Z === "destroyed" && fe === "created", (Z === void 0 || ue) && B.set(K, ue ? "updated" : fe));
  }
  function Kt(Z, B, K) {
    let ue = Z.getParent(), fe = K;
    return ue !== null && (B && K === 0 ? (fe = Z.getIndexWithinParent(), Z = ue) : B || K !== Z.getChildrenSize() || (fe = Z.getIndexWithinParent() + 1, Z = ue)), Z.getChildAtIndex(B ? fe - 1 : fe);
  }
  function an(Z, B) {
    var K = Z.offset;
    return Z.type === "element" ? (Z = Z.getNode(), Kt(Z, B, K)) : (Z = Z.getNode(), B && K === 0 || !B && K === Z.getTextContentSize() ? (K = B ? Z.getPreviousSibling() : Z.getNextSibling(), K === null ? Kt(Z.getParentOrThrow(), B, Z.getIndexWithinParent() + (B ? 0 : 1)) : K) : null);
  }
  function Gn(Z) {
    return Z = (Z = dt(Z).event) && Z.inputType, Z === "insertFromPaste" || Z === "insertFromPasteAsQuotation";
  }
  function An(Z) {
    return !on(Z) && !Z.isLastChild() && !Z.isInline();
  }
  function hn(Z, B) {
    return Z = Z._keyToDOMMap.get(B), Z === void 0 && z(75), Z;
  }
  function zn(Z) {
    return Z = Z.assignedSlot || Z.parentElement, Z !== null && Z.nodeType === 11 ? Z.host : Z;
  }
  function gn(Z, B = 0) {
    if (B !== 0 && z(1), B = To(), !po(B) || !We(Z))
      return B;
    let { anchor: K, focus: ue } = B, fe = K.getNode(), ke = ue.getNode();
    return kn(fe, Z) && K.set(Z.__key, 0, "element"), kn(ke, Z) && ue.set(Z.__key, 0, "element"), B;
  }
  function kn(Z, B) {
    for (Z = Z.getParent(); Z !== null; ) {
      if (Z.is(B))
        return !0;
      Z = Z.getParent();
    }
    return !1;
  }
  function dt(Z) {
    return Z = Z._window, Z === null && z(78), Z;
  }
  function Pt(Z) {
    for (Z = Z.getParentOrThrow(); Z !== null && !cn(Z); )
      Z = Z.getParentOrThrow();
    return Z;
  }
  function cn(Z) {
    return on(Z) || We(Z) && Z.isShadowRoot();
  }
  function sn(Z) {
    return Z = Z.constructor.clone(Z), Ot(Z, null), Z;
  }
  function ao(Z) {
    var B = Do();
    let K = Z.constructor.getType();
    return B = B._nodes.get(K), B === void 0 && z(97), B = B.replace, B !== null ? (B = B(Z), B instanceof Z.constructor || z(98), B) : Z;
  }
  function Ze(Z, B) {
    Z = Z.getParent(), !on(Z) || We(B) || Ct(B) || z(99);
  }
  function bt(Z) {
    return (Ct(Z) || We(Z) && !Z.canBeEmpty()) && !Z.isInline();
  }
  function Wt(Z, B, K) {
    K.style.removeProperty("caret-color"), B._blockCursorElement = null, B = Z.parentElement, B !== null && B.removeChild(Z);
  }
  function xn(Z) {
    return F ? (Z || window).getSelection() : null;
  }
  function It(Z, B) {
    let K = Z.getChildAtIndex(B);
    K == null && (K = Z), cn(Z) && z(102);
    let ue = (Ee) => {
      const qe = Ee.getParentOrThrow(), ot = cn(qe), $t = Ee !== K || ot ? sn(Ee) : Ee;
      if (ot)
        return Ee.insertAfter($t), [Ee, $t, $t];
      const [Vt, Mt, zt] = ue(qe);
      return Ee = Ee.getNextSiblings(), zt.append($t, ...Ee), [Vt, Mt, $t];
    }, [fe, ke] = ue(K);
    return [fe, ke];
  }
  function Jn(Z, B) {
    for (; Z !== qn() && Z != null; ) {
      if (B(Z))
        return Z;
      Z = Z.getParent();
    }
    return null;
  }
  function ur(Z) {
    let B = [], K = [Z];
    for (; 0 < K.length; ) {
      let ue = K.pop();
      ue === void 0 && z(112), We(ue) && K.unshift(...ue.getChildren()), ue !== Z && B.push(ue);
    }
    return B;
  }
  function er(Z, B, K, ue, fe) {
    for (Z = Z.getFirstChild(); Z !== null; ) {
      let ke = Z.__key;
      Z !== void 0 && Z.__parent === B && (We(Z) && er(Z, ke, K, ue, fe), K.has(ke) || fe.delete(ke), ue.delete(ke)), Z = Z.isAttached() ? Z.getNextSibling() : null;
    }
  }
  function ya(Z, B, K, ue) {
    Z = Z._nodeMap, B = B._nodeMap;
    for (let fe of K) {
      let ke = B.get(fe);
      ke === void 0 || ke.isAttached() || (Z.has(fe) || K.delete(fe), B.delete(fe));
    }
    for (let [fe] of ue)
      K = B.get(fe), K === void 0 || K.isAttached() || (We(K) && er(K, fe, Z, B, ue), Z.has(fe) || ue.delete(fe), B.delete(fe));
  }
  function Ai(Z, B) {
    let K = Z.__mode, ue = Z.__format;
    Z = Z.__style;
    let fe = B.__mode, ke = B.__format;
    return B = B.__style, (K === null || K === fe) && (ue === null || ue === ke) && (Z === null || Z === B);
  }
  function Ka(Z, B) {
    let K = Z.mergeWithSibling(B), ue = Do()._normalizedNodes;
    return ue.add(Z.__key), ue.add(B.__key), K;
  }
  function Wc(Z) {
    if (Z.__text === "" && Z.isSimpleText() && !Z.isUnmergeable())
      Z.remove();
    else {
      for (var B; (B = Z.getPreviousSibling()) !== null && Vn(B) && B.isSimpleText() && !B.isUnmergeable(); )
        if (B.__text === "")
          B.remove();
        else {
          Ai(B, Z) && (Z = Ka(B, Z));
          break;
        }
      for (var K; (K = Z.getNextSibling()) !== null && Vn(K) && K.isSimpleText() && !K.isUnmergeable(); )
        if (K.__text === "")
          K.remove();
        else {
          Ai(Z, K) && Ka(Z, K);
          break;
        }
    }
  }
  function Q_(Z) {
    return cm(Z.anchor), cm(Z.focus), Z;
  }
  function cm(Z) {
    for (; Z.type === "element"; ) {
      var B = Z.getNode(), K = Z.offset;
      if (K === B.getChildrenSize() ? (B = B.getChildAtIndex(K - 1), K = !0) : (B = B.getChildAtIndex(K), K = !1), Vn(B)) {
        Z.set(B.__key, K ? B.getTextContentSize() : 0, "text");
        break;
      } else if (!We(B))
        break;
      Z.set(B.__key, K ? B.getChildrenSize() : 0, "element");
    }
  }
  let Pr = "", ji = "", Ks = "", Or, Xr, mi, Gd = !1, Hc = !1, iu, Wd = null, ep, ss, _c, Co, Hd, xs;
  function ea(Z, B) {
    let K = _c.get(Z);
    if (B !== null) {
      let ue = fi(Z);
      ue.parentNode === B && B.removeChild(ue);
    }
    Co.has(Z) || Xr._keyToDOMMap.delete(Z), We(K) && (Z = Kd(K, _c), Zs(Z, 0, Z.length - 1, null)), K !== void 0 && Ut(xs, mi, iu, K, "destroyed");
  }
  function Zs(Z, B, K, ue) {
    for (; B <= K; ++B) {
      let fe = Z[B];
      fe !== void 0 && ea(fe, ue);
    }
  }
  function cs(Z, B) {
    Z.setProperty("text-align", B);
  }
  function Ju(Z, B) {
    var K = Or.theme.indent;
    if (typeof K == "string") {
      let ue = Z.classList.contains(K);
      0 < B && !ue ? Z.classList.add(K) : 1 > B && ue && Z.classList.remove(K);
    }
    K = getComputedStyle(Z).getPropertyValue("--lexical-indent-base-value") || "40px", Z.style.setProperty("padding-inline-start", B === 0 ? "" : `calc(${B} * ${K})`);
  }
  function Sl(Z, B) {
    Z = Z.style, B === 0 ? cs(Z, "") : B === 1 ? cs(Z, "left") : B === 2 ? cs(Z, "center") : B === 3 ? cs(Z, "right") : B === 4 ? cs(Z, "justify") : B === 5 ? cs(Z, "start") : B === 6 && cs(Z, "end");
  }
  function Qu(Z, B, K) {
    let ue = Co.get(Z);
    ue === void 0 && z(60);
    let fe = ue.createDOM(Or, Xr);
    var ke = Xr._keyToDOMMap;
    if (fe["__lexicalKey_" + Xr._key] = Z, ke.set(Z, fe), Vn(ue) ? fe.setAttribute("data-lexical-text", "true") : Ct(ue) && fe.setAttribute("data-lexical-decorator", "true"), We(ue)) {
      if (Z = ue.__indent, ke = ue.__size, Z !== 0 && Ju(fe, Z), ke !== 0) {
        --ke, Z = Kd(ue, Co);
        var Ee = ji;
        ji = "", au(Z, ue, 0, ke, fe, null), su(ue, fe), ji = Ee;
      }
      Z = ue.__format, Z !== 0 && Sl(fe, Z), ue.isInline() || Yd(null, ue, fe), An(ue) && (Pr += `

`, Ks += `

`);
    } else
      ke = ue.getTextContent(), Ct(ue) ? (Ee = ue.decorate(Xr, Or), Ee !== null && Zd(Z, Ee), fe.contentEditable = "false") : Vn(ue) && (ue.isDirectionless() || (ji += ke)), Pr += ke, Ks += ke;
    return B !== null && (K != null ? B.insertBefore(fe, K) : (K = B.__lexicalLineBreak, K != null ? B.insertBefore(fe, K) : B.appendChild(fe))), Ut(xs, mi, iu, ue, "created"), fe;
  }
  function au(Z, B, K, ue, fe, ke) {
    let Ee = Pr;
    for (Pr = ""; K <= ue; ++K)
      Qu(Z[K], fe, ke);
    An(B) && (Pr += `

`), fe.__lexicalTextContent = Pr, Pr = Ee + Pr;
  }
  function tp(Z, B) {
    return Z = B.get(Z), gm(Z) || Ct(Z) && Z.isInline();
  }
  function Yd(Z, B, K) {
    Z = Z !== null && (Z.__size === 0 || tp(Z.__last, _c)), B = B.__size === 0 || tp(B.__last, Co), Z ? B || (B = K.__lexicalLineBreak, B != null && K.removeChild(B), K.__lexicalLineBreak = null) : B && (B = document.createElement("br"), K.__lexicalLineBreak = B, K.appendChild(B));
  }
  function su(Z, B) {
    var K = B.__lexicalDir;
    if (B.__lexicalDirTextContent !== ji || K !== Wd) {
      let ke = ji === "";
      if (ke)
        var ue = Wd;
      else
        ue = ji, ue = ie.test(ue) ? "rtl" : _e.test(ue) ? "ltr" : null;
      if (ue !== K) {
        let Ee = B.classList, qe = Or.theme;
        var fe = K !== null ? qe[K] : void 0;
        let ot = ue !== null ? qe[ue] : void 0;
        fe !== void 0 && (typeof fe == "string" && (fe = fe.split(" "), fe = qe[K] = fe), Ee.remove(...fe)), ue === null || ke && ue === "ltr" ? B.removeAttribute("dir") : (ot !== void 0 && (typeof ot == "string" && (K = ot.split(" "), ot = qe[ue] = K), ot !== void 0 && Ee.add(...ot)), B.dir = ue), Hc || (Z.getWritable().__dir = ue);
      }
      Wd = ue, B.__lexicalDirTextContent = ji, B.__lexicalDir = ue;
    }
  }
  function Kd(Z, B) {
    let K = [];
    for (Z = Z.__first; Z !== null; ) {
      let ue = B.get(Z);
      ue === void 0 && z(101), K.push(Z), Z = ue.__next;
    }
    return K;
  }
  function Cs(Z, B) {
    var K = _c.get(Z), ue = Co.get(Z);
    K !== void 0 && ue !== void 0 || z(61);
    var fe = Gd || ss.has(Z) || ep.has(Z);
    let ke = hn(Xr, Z);
    if (K === ue && !fe)
      return We(K) ? (ue = ke.__lexicalTextContent, ue !== void 0 && (Pr += ue, Ks += ue), ue = ke.__lexicalDirTextContent, ue !== void 0 && (ji += ue)) : (ue = K.getTextContent(), Vn(K) && !K.isDirectionless() && (ji += ue), Ks += ue, Pr += ue), ke;
    if (K !== ue && fe && Ut(xs, mi, iu, ue, "updated"), ue.updateDOM(K, ke, Or))
      return ue = Qu(Z, null, null), B === null && z(62), B.replaceChild(ue, ke), ea(Z, null), ue;
    if (We(K) && We(ue)) {
      if (Z = ue.__indent, Z !== K.__indent && Ju(ke, Z), Z = ue.__format, Z !== K.__format && Sl(ke, Z), fe) {
        Z = ue, fe = ji, ji = "", B = Pr;
        var Ee = K.__size, qe = Z.__size;
        if (Pr = "", Ee === 1 && qe === 1) {
          var ot = K.__first, $t = Z.__first;
          if (ot === $t)
            Cs(ot, ke);
          else {
            var Vt = fi(ot);
            $t = Qu($t, null, null), ke.replaceChild($t, Vt), ea(ot, null);
          }
        } else {
          $t = Kd(K, _c);
          var Mt = Kd(Z, Co);
          if (Ee === 0)
            qe !== 0 && au(Mt, Z, 0, qe - 1, ke, null);
          else if (qe === 0)
            Ee !== 0 && (ot = ke.__lexicalLineBreak == null, Zs($t, 0, Ee - 1, ot ? null : ke), ot && (ke.textContent = ""));
          else {
            var zt = $t;
            $t = Mt, Mt = Ee - 1, Ee = qe - 1;
            let Sn = ke.firstChild, Cn = 0;
            for (qe = 0; Cn <= Mt && qe <= Ee; ) {
              var Rt = zt[Cn];
              let ro = $t[qe];
              if (Rt === ro)
                Sn = Yc(Cs(ro, ke)), Cn++, qe++;
              else {
                ot === void 0 && (ot = new Set(zt)), Vt === void 0 && (Vt = new Set($t));
                let Uo = Vt.has(Rt), Oi = ot.has(ro);
                Uo ? (Oi ? (Rt = hn(Xr, ro), Rt === Sn ? Sn = Yc(Cs(ro, ke)) : (Sn != null ? ke.insertBefore(Rt, Sn) : ke.appendChild(Rt), Cs(ro, ke)), Cn++) : Qu(ro, ke, Sn), qe++) : (Sn = Yc(fi(Rt)), ea(Rt, ke), Cn++);
              }
            }
            ot = Cn > Mt, Vt = qe > Ee, ot && !Vt ? (ot = $t[Ee + 1], ot = ot === void 0 ? null : Xr.getElementByKey(ot), au($t, Z, qe, Ee, ke, ot)) : Vt && !ot && Zs(zt, Cn, Mt, ke);
          }
        }
        An(Z) && (Pr += `

`), ke.__lexicalTextContent = Pr, Pr = B + Pr, su(Z, ke), ji = fe, on(ue) || ue.isInline() || Yd(K, ue, ke);
      }
      An(ue) && (Pr += `

`, Ks += `

`);
    } else
      K = ue.getTextContent(), Ct(ue) ? (fe = ue.decorate(Xr, Or), fe !== null && Zd(Z, fe)) : Vn(ue) && !ue.isDirectionless() && (ji += K), Pr += K, Ks += K;
    return !Hc && on(ue) && ue.__cachedText !== Ks && (ue = ue.getWritable(), ue.__cachedText = Ks), ke;
  }
  function Zd(Z, B) {
    let K = Xr._pendingDecorators, ue = Xr._decorators;
    if (K === null) {
      if (ue[Z] === B)
        return;
      K = Yn(Xr);
    }
    K[Z] = B;
  }
  function Yc(Z) {
    return Z = Z.nextSibling, Z !== null && Z === Xr._blockCursorElement && (Z = Z.nextSibling), Z;
  }
  function fi(Z) {
    return Z = Hd.get(Z), Z === void 0 && z(75), Z;
  }
  let pc = Object.freeze({}), Xd = [["keydown", od], ["pointerdown", cu], ["compositionstart", Pf], ["compositionend", t_], ["input", Rf], ["click", e_], ["cut", pc], ["copy", pc], ["dragstart", pc], ["dragover", pc], ["dragend", pc], ["paste", pc], ["focus", pc], ["blur", pc], ["drop", pc]];
  U && Xd.push(["beforeinput", (Z, B) => ls(Z, B)]);
  let ed = 0, Jd = 0, Dr = 0, Po = null, mc = 0, El = !1, xl = !1, td = !1, nd = !1, np = [0, "", 0, "root", 0];
  function Qd(Z, B, K, ue, fe) {
    let ke = Z.anchor, Ee = Z.focus, qe = ke.getNode();
    var ot = Do();
    let $t = xn(ot._window), Vt = $t !== null ? $t.anchorNode : null, Mt = ke.key;
    ot = ot.getElementByKey(Mt);
    let zt = K.length;
    return Mt !== Ee.key || !Vn(qe) || (!fe && (!U || Dr < ue + 50) || qe.isDirty() && 2 > zt || In(K)) && ke.offset !== Ee.offset && !qe.isComposing() || at(qe) || qe.isDirty() && 1 < zt || (fe || !U) && ot !== null && !qe.isComposing() && Vt !== wt(ot) || $t !== null && B !== null && (!B.collapsed || B.startContainer !== $t.anchorNode || B.startOffset !== $t.anchorOffset) || qe.getFormat() !== Z.format || qe.getStyle() !== Z.style || qo(Z, qe);
  }
  function lm(Z, B) {
    return Z !== null && Z.nodeValue !== null && Z.nodeType === 3 && B !== 0 && B !== Z.nodeValue.length;
  }
  function ma(Z, B, K) {
    let { anchorNode: ue, anchorOffset: fe, focusNode: ke, focusOffset: Ee } = Z;
    El && (El = !1, lm(ue, fe) && lm(ke, Ee)) || gt(B, () => {
      if (!K)
        Xn(null);
      else if (He(B, ue, ke)) {
        var qe = To();
        if (po(qe)) {
          var ot = qe.anchor, $t = ot.getNode();
          if (qe.isCollapsed()) {
            Z.type === "Range" && Z.anchorNode === Z.focusNode && (qe.dirty = !0);
            var Vt = dt(B).event;
            Vt = Vt ? Vt.timeStamp : performance.now();
            let [Mt, zt, Rt, Sn, Cn] = np;
            Vt < Cn + 200 && ot.offset === Rt && ot.key === Sn ? (qe.format = Mt, qe.style = zt) : ot.type === "text" ? (qe.format = $t.getFormat(), qe.style = $t.getStyle()) : ot.type === "element" && (qe.format = 0, qe.style = "");
          } else {
            ot = 255, $t = !1, Vt = qe.getNodes();
            let Mt = Vt.length;
            for (let zt = 0; zt < Mt; zt++) {
              let Rt = Vt[zt];
              if (Vn(Rt) && ($t = !0, ot &= Rt.getFormat(), ot === 0))
                break;
            }
            qe.format = $t ? ot : 0;
          }
        }
        Ae(B, e, void 0);
      }
    });
  }
  function e_(Z, B) {
    gt(B, () => {
      let K = To(), ue = xn(B._window), fe = Na();
      if (po(K)) {
        let ke = K.anchor, Ee = ke.getNode();
        ue && ke.type === "element" && ke.offset === 0 && K.isCollapsed() && !on(Ee) && qn().getChildrenSize() === 1 && Ee.getTopLevelElementOrThrow().isEmpty() && fe !== null && K.is(fe) && (ue.removeAllRanges(), K.dirty = !0);
      }
      Ae(B, t, Z);
    });
  }
  function cu(Z, B) {
    let K = Z.target;
    Z = Z.pointerType, K instanceof Node && Z !== "touch" && gt(B, () => {
      Ct(Ln(K)) || (xl = !0);
    });
  }
  function op(Z) {
    return Z.getTargetRanges ? (Z = Z.getTargetRanges(), Z.length === 0 ? null : Z[0]) : null;
  }
  function um(Z, B) {
    return Z !== B || We(Z) || We(B) || !Z.isToken() || !B.isToken();
  }
  function ls(Z, B) {
    let K = Z.inputType, ue = op(Z);
    K === "deleteCompositionText" || V && Gn(B) || K !== "insertCompositionText" && gt(B, () => {
      let fe = To();
      if (K === "deleteContentBackward") {
        if (fe === null) {
          var ke = Na();
          if (!po(ke))
            return;
          Xn(ke.clone());
        }
        if (po(fe)) {
          Jd === 229 && Z.timeStamp < ed + 30 && B.isComposing() && fe.anchor.key === fe.focus.key ? (un(null), ed = 0, setTimeout(() => {
            gt(B, () => {
              un(null);
            });
          }, 30), po(fe) && (ke = fe.anchor.getNode(), ke.markDirty(), fe.format = ke.getFormat(), fe.style = ke.getStyle())) : (Z.preventDefault(), Ae(B, n, !0));
          return;
        }
      }
      if (po(fe)) {
        ke = Z.data, Po !== null && go(!1, B, Po), fe.dirty && Po === null || !fe.isCollapsed() || on(fe.anchor.getNode()) || ue === null || fe.applyDOMRange(ue), Po = null;
        var Ee = fe.focus, qe = fe.anchor.getNode();
        if (Ee = Ee.getNode(), K === "insertText" || K === "insertTranspose")
          ke === `
` ? (Z.preventDefault(), Ae(B, o, !1)) : ke === `

` ? (Z.preventDefault(), Ae(B, r, void 0)) : ke == null && Z.dataTransfer ? (ke = Z.dataTransfer.getData("text/plain"), Z.preventDefault(), fe.insertRawText(ke)) : ke != null && Qd(fe, ue, ke, Z.timeStamp, !0) ? (Z.preventDefault(), Ae(B, i, ke)) : Po = ke, Dr = Z.timeStamp;
        else
          switch (Z.preventDefault(), K) {
            case "insertFromYank":
            case "insertFromDrop":
            case "insertReplacementText":
              Ae(B, i, Z);
              break;
            case "insertFromComposition":
              un(null), Ae(B, i, Z);
              break;
            case "insertLineBreak":
              un(null), Ae(B, o, !1);
              break;
            case "insertParagraph":
              un(null), td ? (td = !1, Ae(B, o, !1)) : Ae(B, r, void 0);
              break;
            case "insertFromPaste":
            case "insertFromPasteAsQuotation":
              Ae(B, a, Z);
              break;
            case "deleteByComposition":
              um(qe, Ee) && Ae(B, s, void 0);
              break;
            case "deleteByDrag":
            case "deleteByCut":
              Ae(B, s, void 0);
              break;
            case "deleteContent":
              Ae(B, n, !1);
              break;
            case "deleteWordBackward":
              Ae(
                B,
                c,
                !0
              );
              break;
            case "deleteWordForward":
              Ae(B, c, !1);
              break;
            case "deleteHardLineBackward":
            case "deleteSoftLineBackward":
              Ae(B, l, !0);
              break;
            case "deleteContentForward":
            case "deleteHardLineForward":
            case "deleteSoftLineForward":
              Ae(B, l, !1);
              break;
            case "formatStrikeThrough":
              Ae(B, u, "strikethrough");
              break;
            case "formatBold":
              Ae(B, u, "bold");
              break;
            case "formatItalic":
              Ae(B, u, "italic");
              break;
            case "formatUnderline":
              Ae(B, u, "underline");
              break;
            case "historyUndo":
              Ae(B, d, void 0);
              break;
            case "historyRedo":
              Ae(B, _, void 0);
          }
      }
    });
  }
  function Rf(Z, B) {
    Z.stopPropagation(), gt(B, () => {
      var K = To(), ue = Z.data, fe = op(Z);
      if (ue != null && po(K) && Qd(K, fe, ue, Z.timeStamp, !1)) {
        nd && (Kc(B, ue), nd = !1);
        var ke = K.anchor, Ee = ke.getNode();
        if (fe = xn(B._window), fe === null)
          return;
        let qe = ke.offset;
        (ke = U && !K.isCollapsed() && Vn(Ee) && fe.anchorNode !== null) && (Ee = Ee.getTextContent().slice(0, qe) + ue + Ee.getTextContent().slice(qe + K.focus.offset), fe = fe.anchorNode, ke = Ee === (fe.nodeType === 3 ? fe.nodeValue : null)), ke || Ae(B, i, ue), ue = ue.length, V && 1 < ue && Z.inputType === "insertCompositionText" && !B.isComposing() && (K.anchor.offset -= ue), H || J || ae || !B.isComposing() || (ed = 0, un(null));
      } else
        go(!1, B, ue !== null ? ue : void 0), nd && (Kc(B, ue || void 0), nd = !1);
      Jr(), K = Do(), st(K);
    }), Po = null;
  }
  function Pf(Z, B) {
    gt(B, () => {
      let K = To();
      if (po(K) && !B.isComposing()) {
        let ue = K.anchor, fe = K.anchor.getNode();
        un(ue.key), (Z.timeStamp < ed + 30 || ue.type === "element" || !K.isCollapsed() || fe.getFormat() !== K.format || fe.getStyle() !== K.style) && Ae(B, i, re);
      }
    });
  }
  function Kc(Z, B) {
    var K = Z._compositionKey;
    if (un(null), K !== null && B != null) {
      if (B === "") {
        B = Dn(K), Z = wt(Z.getElementByKey(K)), Z !== null && Z.nodeValue !== null && Vn(B) && Rr(B, Z.nodeValue, null, null, !0);
        return;
      }
      if (B[B.length - 1] === `
` && (K = To(), po(K))) {
        B = K.focus, K.anchor.set(B.key, B.offset, B.type), Ae(Z, y, null);
        return;
      }
    }
    go(!0, Z, B);
  }
  function t_(Z, B) {
    V ? nd = !0 : gt(B, () => {
      Kc(B, Z.data);
    });
  }
  function od(Z, B) {
    if (ed = Z.timeStamp, Jd = Z.keyCode, !B.isComposing()) {
      var { keyCode: K, shiftKey: ue, ctrlKey: fe, metaKey: ke, altKey: Ee } = Z;
      if (!Ae(B, p, Z)) {
        if (K !== 39 || fe || ke || Ee)
          if (K !== 39 || Ee || ue || !fe && !ke)
            if (K !== 37 || fe || ke || Ee)
              if (K !== 37 || Ee || ue || !fe && !ke)
                if (K !== 38 || fe || ke)
                  if (K !== 40 || fe || ke)
                    if (K === 13 && ue)
                      td = !0, Ae(B, y, Z);
                    else if (K === 32)
                      Ae(B, w, Z);
                    else if (O && fe && K === 79)
                      Z.preventDefault(), td = !0, Ae(B, o, !0);
                    else if (K !== 13 || ue) {
                      var qe = O ? Ee || ke ? !1 : K === 8 || K === 72 && fe : fe || Ee || ke ? !1 : K === 8;
                      qe ? K === 8 ? Ae(B, N, Z) : (Z.preventDefault(), Ae(B, n, !0)) : K === 27 ? Ae(
                        B,
                        M,
                        Z
                      ) : (qe = O ? ue || Ee || ke ? !1 : K === 46 || K === 68 && fe : fe || Ee || ke ? !1 : K === 46, qe ? K === 46 ? Ae(B, q, Z) : (Z.preventDefault(), Ae(B, n, !1)) : K === 8 && (O ? Ee : fe) ? (Z.preventDefault(), Ae(B, c, !0)) : K === 46 && (O ? Ee : fe) ? (Z.preventDefault(), Ae(B, c, !1)) : O && ke && K === 8 ? (Z.preventDefault(), Ae(B, l, !0)) : O && ke && K === 46 ? (Z.preventDefault(), Ae(B, l, !1)) : K === 66 && !Ee && (O ? ke : fe) ? (Z.preventDefault(), Ae(B, u, "bold")) : K === 85 && !Ee && (O ? ke : fe) ? (Z.preventDefault(), Ae(B, u, "underline")) : K === 73 && !Ee && (O ? ke : fe) ? (Z.preventDefault(), Ae(B, u, "italic")) : K !== 9 || Ee || fe || ke ? K === 90 && !ue && (O ? ke : fe) ? (Z.preventDefault(), Ae(B, d, void 0)) : (qe = O ? K === 90 && ke && ue : K === 89 && fe || K === 90 && fe && ue, qe ? (Z.preventDefault(), Ae(B, _, void 0)) : uu(B._editorState._selection) && (qe = ue ? !1 : K === 67 ? O ? ke : fe : !1, qe ? (Z.preventDefault(), Ae(B, S, Z)) : (qe = ue ? !1 : K === 88 ? O ? ke : fe : !1, qe && (Z.preventDefault(), Ae(B, E, Z))))) : Ae(B, L, Z));
                    } else
                      td = !1, Ae(B, y, Z);
                  else
                    Ae(B, b, Z);
                else
                  Ae(B, v, Z);
              else
                Ae(B, $, Z);
            else
              Ae(B, h, Z);
          else
            Ae(B, f, Z);
        else
          Ae(B, g, Z);
        (fe || ue || Ee || ke) && Ae(B, I, Z);
      }
    }
  }
  function rd(Z) {
    let B = Z.__lexicalEventHandles;
    return B === void 0 && (B = [], Z.__lexicalEventHandles = B), B;
  }
  let _o = /* @__PURE__ */ new Map();
  function dm(Z) {
    Z = Z.target;
    let B = xn(Z == null ? null : Z.nodeType === 9 ? Z.defaultView : Z.ownerDocument.defaultView);
    if (B !== null) {
      var K = Xe(B.anchorNode);
      if (K !== null) {
        xl && (xl = !1, gt(K, () => {
          var Ee = Na(), qe = B.anchorNode;
          qe !== null && (qe = qe.nodeType, qe === 1 || qe === 3) && (Ee = Ol(Ee, B, K), Xn(Ee));
        })), Z = $n(K), Z = Z[Z.length - 1];
        var ue = Z._key, fe = _o.get(ue), ke = fe || Z;
        ke !== K && ma(B, ke, !1), ma(B, K, !0), K !== Z ? _o.set(ue, K) : fe && _o.delete(ue);
      }
    }
  }
  function $a(Z, B) {
    mc === 0 && Z.ownerDocument.addEventListener("selectionchange", dm), mc++, Z.__lexicalEditor = B;
    let K = rd(Z);
    for (let ue = 0; ue < Xd.length; ue++) {
      let [fe, ke] = Xd[ue], Ee = typeof ke == "function" ? (qe) => {
        qe._lexicalHandled !== !0 && (qe._lexicalHandled = !0, B.isEditable() && ke(qe, B));
      } : (qe) => {
        if (qe._lexicalHandled !== !0 && (qe._lexicalHandled = !0, B.isEditable()))
          switch (fe) {
            case "cut":
              return Ae(B, E, qe);
            case "copy":
              return Ae(B, S, qe);
            case "paste":
              return Ae(B, a, qe);
            case "dragstart":
              return Ae(B, T, qe);
            case "dragover":
              return Ae(B, D, qe);
            case "dragend":
              return Ae(
                B,
                A,
                qe
              );
            case "focus":
              return Ae(B, x, qe);
            case "blur":
              return Ae(B, k, qe);
            case "drop":
              return Ae(B, R, qe);
          }
      };
      Z.addEventListener(fe, Ee), K.push(() => {
        Z.removeEventListener(fe, Ee);
      });
    }
  }
  function Cl(Z, B, K) {
    Jr();
    var ue = Z.__key;
    let fe = Z.getParent();
    if (fe !== null) {
      var ke = gn(Z), Ee = !1;
      if (po(ke) && B) {
        let qe = ke.anchor, ot = ke.focus;
        qe.key === ue && (ad(qe, Z, fe, Z.getPreviousSibling(), Z.getNextSibling()), Ee = !0), ot.key === ue && (ad(ot, Z, fe, Z.getPreviousSibling(), Z.getNextSibling()), Ee = !0);
      }
      po(ke) && B && !Ee ? (ue = Z.getIndexWithinParent(), Ft(Z), fa(ke, fe, ue, -1)) : Ft(Z), K || cn(fe) || fe.canBeEmpty() || !fe.isEmpty() || Cl(fe, B), B && on(fe) && fe.isEmpty() && fe.selectEnd();
    }
  }
  class wa {
    static getType() {
      z(64);
    }
    static clone() {
      z(65);
    }
    constructor(B) {
      this.__type = this.constructor.getType(), this.__next = this.__prev = this.__parent = null, Ot(this, B);
    }
    getType() {
      return this.__type;
    }
    isAttached() {
      for (var B = this.__key; B !== null; ) {
        if (B === "root")
          return !0;
        if (B = Dn(B), B === null)
          break;
        B = B.__parent;
      }
      return !1;
    }
    isSelected(B) {
      if (B = B || To(), B == null)
        return !1;
      let K = B.getNodes().some((ue) => ue.__key === this.__key);
      return Vn(this) ? K : po(B) && B.anchor.type === "element" && B.focus.type === "element" && B.anchor.key === B.focus.key && B.anchor.offset === B.focus.offset ? !1 : K;
    }
    getKey() {
      return this.__key;
    }
    getIndexWithinParent() {
      var B = this.getParent();
      if (B === null)
        return -1;
      B = B.getFirstChild();
      let K = 0;
      for (; B !== null; ) {
        if (this.is(B))
          return K;
        K++, B = B.getNextSibling();
      }
      return -1;
    }
    getParent() {
      let B = this.getLatest().__parent;
      return B === null ? null : Dn(B);
    }
    getParentOrThrow() {
      let B = this.getParent();
      return B === null && z(66), B;
    }
    getTopLevelElement() {
      let B = this;
      for (; B !== null; ) {
        let K = B.getParent();
        if (cn(K))
          return B;
        B = K;
      }
      return null;
    }
    getTopLevelElementOrThrow() {
      let B = this.getTopLevelElement();
      return B === null && z(67), B;
    }
    getParents() {
      let B = [], K = this.getParent();
      for (; K !== null; )
        B.push(K), K = K.getParent();
      return B;
    }
    getParentKeys() {
      let B = [], K = this.getParent();
      for (; K !== null; )
        B.push(K.__key), K = K.getParent();
      return B;
    }
    getPreviousSibling() {
      let B = this.getLatest().__prev;
      return B === null ? null : Dn(B);
    }
    getPreviousSiblings() {
      let B = [];
      var K = this.getParent();
      if (K === null)
        return B;
      for (K = K.getFirstChild(); K !== null && !K.is(this); )
        B.push(K), K = K.getNextSibling();
      return B;
    }
    getNextSibling() {
      let B = this.getLatest().__next;
      return B === null ? null : Dn(B);
    }
    getNextSiblings() {
      let B = [], K = this.getNextSibling();
      for (; K !== null; )
        B.push(K), K = K.getNextSibling();
      return B;
    }
    getCommonAncestor(B) {
      let K = this.getParents();
      var ue = B.getParents();
      We(this) && K.unshift(this), We(B) && ue.unshift(B), B = K.length;
      var fe = ue.length;
      if (B === 0 || fe === 0 || K[B - 1] !== ue[fe - 1])
        return null;
      for (ue = new Set(ue), fe = 0; fe < B; fe++) {
        let ke = K[fe];
        if (ue.has(ke))
          return ke;
      }
      return null;
    }
    is(B) {
      return B == null ? !1 : this.__key === B.__key;
    }
    isBefore(B) {
      if (this === B)
        return !1;
      if (B.isParentOf(this))
        return !0;
      if (this.isParentOf(B))
        return !1;
      var K = this.getCommonAncestor(B);
      let ue = this;
      for (; ; ) {
        var fe = ue.getParentOrThrow();
        if (fe === K) {
          fe = ue.getIndexWithinParent();
          break;
        }
        ue = fe;
      }
      for (ue = B; ; ) {
        if (B = ue.getParentOrThrow(), B === K) {
          K = ue.getIndexWithinParent();
          break;
        }
        ue = B;
      }
      return fe < K;
    }
    isParentOf(B) {
      let K = this.__key;
      if (K === B.__key)
        return !1;
      for (; B !== null; ) {
        if (B.__key === K)
          return !0;
        B = B.getParent();
      }
      return !1;
    }
    getNodesBetween(B) {
      let K = this.isBefore(B), ue = [], fe = /* @__PURE__ */ new Set();
      for (var ke = this; ; ) {
        var Ee = ke.__key;
        if (fe.has(Ee) || (fe.add(Ee), ue.push(ke)), ke === B)
          break;
        if (Ee = We(ke) ? K ? ke.getFirstChild() : ke.getLastChild() : null, Ee !== null)
          ke = Ee;
        else if (Ee = K ? ke.getNextSibling() : ke.getPreviousSibling(), Ee !== null)
          ke = Ee;
        else {
          if (ke = ke.getParentOrThrow(), fe.has(ke.__key) || ue.push(ke), ke === B)
            break;
          Ee = ke;
          do
            Ee === null && z(68), ke = K ? Ee.getNextSibling() : Ee.getPreviousSibling(), Ee = Ee.getParent(), Ee !== null && (ke !== null || fe.has(Ee.__key) || ue.push(Ee));
          while (ke === null);
        }
      }
      return K || ue.reverse(), ue;
    }
    isDirty() {
      let B = Do()._dirtyLeaves;
      return B !== null && B.has(this.__key);
    }
    getLatest() {
      let B = Dn(this.__key);
      return B === null && z(113), B;
    }
    getWritable() {
      Jr();
      var B = oa(), K = Do();
      B = B._nodeMap;
      let ue = this.__key, fe = this.getLatest(), ke = fe.__parent;
      K = K._cloneNotNeeded;
      var Ee = To();
      return Ee !== null && (Ee._cachedNodes = null), K.has(ue) ? (wn(fe), fe) : (Ee = fe.constructor.clone(fe), Ee.__parent = ke, Ee.__next = fe.__next, Ee.__prev = fe.__prev, We(fe) && We(Ee) ? (Ee.__first = fe.__first, Ee.__last = fe.__last, Ee.__size = fe.__size, Ee.__indent = fe.__indent, Ee.__format = fe.__format, Ee.__dir = fe.__dir) : Vn(fe) && Vn(Ee) && (Ee.__format = fe.__format, Ee.__style = fe.__style, Ee.__mode = fe.__mode, Ee.__detail = fe.__detail), K.add(ue), Ee.__key = ue, wn(Ee), B.set(ue, Ee), Ee);
    }
    getTextContent() {
      return "";
    }
    getTextContentSize() {
      return this.getTextContent().length;
    }
    createDOM() {
      z(70);
    }
    updateDOM() {
      z(71);
    }
    exportDOM(B) {
      return { element: this.createDOM(B._config, B) };
    }
    exportJSON() {
      z(72);
    }
    static importJSON() {
      z(18);
    }
    static transform() {
      return null;
    }
    remove(B) {
      Cl(this, !0, B);
    }
    replace(B, K) {
      Jr();
      var ue = To();
      ue !== null && (ue = ue.clone()), Ze(this, B);
      let fe = this.getLatest(), ke = this.__key, Ee = B.__key, qe = B.getWritable();
      B = this.getParentOrThrow().getWritable();
      let ot = B.__size;
      Ft(qe);
      let $t = fe.getPreviousSibling(), Vt = fe.getNextSibling(), Mt = fe.__prev, zt = fe.__next, Rt = fe.__parent;
      return Cl(fe, !1, !0), $t === null ? B.__first = Ee : $t.getWritable().__next = Ee, qe.__prev = Mt, Vt === null ? B.__last = Ee : Vt.getWritable().__prev = Ee, qe.__next = zt, qe.__parent = Rt, B.__size = ot, K && this.getChildren().forEach((Sn) => {
        qe.append(Sn);
      }), po(ue) && (Xn(ue), K = ue.anchor, ue = ue.focus, K.key === ke && lu(K, qe), ue.key === ke && lu(ue, qe)), pn() === ke && un(Ee), qe;
    }
    insertAfter(B, K = !0) {
      Jr(), Ze(this, B);
      var ue = this.getWritable();
      let fe = B.getWritable();
      var ke = fe.getParent();
      let Ee = To();
      var qe = !1, ot = !1;
      if (ke !== null) {
        var $t = B.getIndexWithinParent();
        Ft(fe), po(Ee) && (ot = ke.__key, qe = Ee.anchor, ke = Ee.focus, qe = qe.type === "element" && qe.key === ot && qe.offset === $t + 1, ot = ke.type === "element" && ke.key === ot && ke.offset === $t + 1);
      }
      ke = this.getNextSibling(), $t = this.getParentOrThrow().getWritable();
      let Vt = fe.__key, Mt = ue.__next;
      return ke === null ? $t.__last = Vt : ke.getWritable().__prev = Vt, $t.__size++, ue.__next = Vt, fe.__next = Mt, fe.__prev = ue.__key, fe.__parent = ue.__parent, K && po(Ee) && (K = this.getIndexWithinParent(), fa(Ee, $t, K + 1), ue = $t.__key, qe && Ee.anchor.set(ue, K + 2, "element"), ot && Ee.focus.set(ue, K + 2, "element")), B;
    }
    insertBefore(B, K = !0) {
      Jr(), Ze(this, B);
      var ue = this.getWritable();
      let fe = B.getWritable(), ke = fe.__key;
      Ft(fe);
      let Ee = this.getPreviousSibling(), qe = this.getParentOrThrow().getWritable(), ot = ue.__prev, $t = this.getIndexWithinParent();
      return Ee === null ? qe.__first = ke : Ee.getWritable().__next = ke, qe.__size++, ue.__prev = ke, fe.__prev = ot, fe.__next = ue.__key, fe.__parent = ue.__parent, ue = To(), K && po(ue) && (K = this.getParentOrThrow(), fa(ue, K, $t)), B;
    }
    isParentRequired() {
      return !1;
    }
    createParentElementNode() {
      return Nl();
    }
    selectPrevious(B, K) {
      Jr();
      let ue = this.getPreviousSibling(), fe = this.getParentOrThrow();
      return ue === null ? fe.select(0, 0) : We(ue) ? ue.select() : Vn(ue) ? ue.select(B, K) : (B = ue.getIndexWithinParent() + 1, fe.select(B, B));
    }
    selectNext(B, K) {
      Jr();
      let ue = this.getNextSibling(), fe = this.getParentOrThrow();
      return ue === null ? fe.select() : We(ue) ? ue.select(0, 0) : Vn(ue) ? ue.select(B, K) : (B = ue.getIndexWithinParent(), fe.select(B, B));
    }
    markDirty() {
      this.getWritable();
    }
  }
  class ta {
    constructor(B, K, ue) {
      this._selection = null, this.key = B, this.offset = K, this.type = ue;
    }
    is(B) {
      return this.key === B.key && this.offset === B.offset && this.type === B.type;
    }
    isBefore(B) {
      let K = this.getNode(), ue = B.getNode(), fe = this.offset;
      if (B = B.offset, We(K)) {
        var ke = K.getDescendantByIndex(fe);
        K = ke ?? K;
      }
      return We(ue) && (ke = ue.getDescendantByIndex(B), ue = ke ?? ue), K === ue ? fe < B : K.isBefore(ue);
    }
    getNode() {
      let B = Dn(this.key);
      return B === null && z(20), B;
    }
    set(B, K, ue) {
      let fe = this._selection, ke = this.key;
      this.key = B, this.offset = K, this.type = ue, Bi() || (pn() === ke && un(B), fe !== null && (fe._cachedNodes = null, fe.dirty = !0));
    }
  }
  function Tl(Z, B) {
    let K = B.__key, ue = Z.offset, fe = "element";
    if (Vn(B))
      fe = "text", B = B.getTextContentSize(), ue > B && (ue = B);
    else if (!We(B)) {
      var ke = B.getNextSibling();
      Vn(ke) ? (K = ke.__key, ue = 0, fe = "text") : (ke = B.getParent()) && (K = ke.__key, ue = B.getIndexWithinParent() + 1);
    }
    Z.set(K, ue, fe);
  }
  function lu(Z, B) {
    if (We(B)) {
      let K = B.getLastDescendant();
      We(K) || Vn(K) ? Tl(Z, K) : Tl(Z, B);
    } else
      Tl(Z, B);
  }
  function Zo(Z, B, K, ue) {
    let fe = Z.getNode(), ke = fe.getChildAtIndex(Z.offset), Ee = ra(), qe = on(fe) ? Nl().append(Ee) : Ee;
    Ee.setFormat(K), Ee.setStyle(ue), ke === null ? fe.append(qe) : ke.insertBefore(qe), Z.is(B) && B.set(Ee.__key, 0, "text"), Z.set(Ee.__key, 0, "text");
  }
  function nn(Z, B, K, ue) {
    Z.key = B, Z.offset = K, Z.type = ue;
  }
  class Ts {
    constructor(B) {
      this.dirty = !1, this._nodes = B, this._cachedNodes = null;
    }
    is(B) {
      if (!uu(B))
        return !1;
      let K = this._nodes, ue = B._nodes;
      return K.size === ue.size && Array.from(K).every((fe) => ue.has(fe));
    }
    add(B) {
      this.dirty = !0, this._nodes.add(B), this._cachedNodes = null;
    }
    delete(B) {
      this.dirty = !0, this._nodes.delete(B), this._cachedNodes = null;
    }
    clear() {
      this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
    }
    has(B) {
      return this._nodes.has(B);
    }
    clone() {
      return new Ts(new Set(this._nodes));
    }
    extract() {
      return this.getNodes();
    }
    insertRawText() {
    }
    insertText() {
    }
    insertNodes(B, K) {
      let ue = this.getNodes(), fe = ue.length;
      var ke = ue[fe - 1];
      if (Vn(ke))
        ke = ke.select();
      else {
        let Ee = ke.getIndexWithinParent() + 1;
        ke = ke.getParentOrThrow().select(Ee, Ee);
      }
      for (ke.insertNodes(B, K), B = 0; B < fe; B++)
        ue[B].remove();
      return !0;
    }
    getNodes() {
      var B = this._cachedNodes;
      if (B !== null)
        return B;
      var K = this._nodes;
      B = [];
      for (let ue of K)
        K = Dn(ue), K !== null && B.push(K);
      return Bi() || (this._cachedNodes = B), B;
    }
    getTextContent() {
      let B = this.getNodes(), K = "";
      for (let ue = 0; ue < B.length; ue++)
        K += B[ue].getTextContent();
      return K;
    }
  }
  function po(Z) {
    return Z instanceof Er;
  }
  class Zc {
    constructor(B, K, ue) {
      this.gridKey = B, this.anchor = K, this.focus = ue, this.dirty = !1, this._cachedNodes = null, K._selection = this, ue._selection = this;
    }
    is(B) {
      return _m(B) ? this.gridKey === B.gridKey && this.anchor.is(B.anchor) && this.focus.is(B.focus) : !1;
    }
    set(B, K, ue) {
      this.dirty = !0, this.gridKey = B, this.anchor.key = K, this.focus.key = ue, this._cachedNodes = null;
    }
    clone() {
      return new Zc(this.gridKey, this.anchor, this.focus);
    }
    isCollapsed() {
      return !1;
    }
    isBackward() {
      return this.focus.isBefore(this.anchor);
    }
    getCharacterOffsets() {
      return na(this);
    }
    extract() {
      return this.getNodes();
    }
    insertRawText() {
    }
    insertText() {
    }
    insertNodes(B, K) {
      let ue = this.focus.getNode();
      return Q_(ue.select(0, ue.getChildrenSize())).insertNodes(B, K);
    }
    getShape() {
      var B = Dn(this.anchor.key);
      B === null && z(21);
      var K = B.getIndexWithinParent();
      B = B.getParentOrThrow().getIndexWithinParent();
      var ue = Dn(this.focus.key);
      ue === null && z(22);
      var fe = ue.getIndexWithinParent();
      let ke = ue.getParentOrThrow().getIndexWithinParent();
      return ue = Math.min(K, fe), K = Math.max(K, fe), fe = Math.min(B, ke), B = Math.max(B, ke), { fromX: Math.min(ue, K), fromY: Math.min(fe, B), toX: Math.max(ue, K), toY: Math.max(fe, B) };
    }
    getNodes() {
      function B(ro) {
        let {
          cell: Uo,
          startColumn: Oi,
          startRow: ga
        } = ro;
        ot = Math.min(ot, Oi), $t = Math.min($t, ga), Vt = Math.max(Vt, Oi + Uo.__colSpan - 1), Mt = Math.max(Mt, ga + Uo.__rowSpan - 1);
      }
      var K = this._cachedNodes;
      if (K !== null)
        return K;
      var ue = this.anchor.getNode();
      K = this.focus.getNode(), ue = Jn(ue, Ns);
      var fe = Jn(K, Ns);
      Ns(ue) || z(103), Ns(fe) || z(104), K = ue.getParent(), cd(K) || z(105), K = K.getParent(), Mf(K) || z(106);
      let [ke, Ee, qe] = Xs(K, ue, fe), ot = Math.min(Ee.startColumn, qe.startColumn), $t = Math.min(Ee.startRow, qe.startRow), Vt = Math.max(Ee.startColumn + Ee.cell.__colSpan - 1, qe.startColumn + qe.cell.__colSpan - 1), Mt = Math.max(Ee.startRow + Ee.cell.__rowSpan - 1, qe.startRow + qe.cell.__rowSpan - 1);
      ue = ot, fe = $t;
      for (var zt = ot, Rt = $t; ot < ue || $t < fe || Vt > zt || Mt > Rt; ) {
        if (ot < ue) {
          var Sn = Rt - fe;
          --ue;
          for (var Cn = 0; Cn <= Sn; Cn++)
            B(ke[fe + Cn][ue]);
        }
        if ($t < fe)
          for (Sn = zt - ue, --fe, Cn = 0; Cn <= Sn; Cn++)
            B(ke[fe][ue + Cn]);
        if (Vt > zt)
          for (Sn = Rt - fe, zt += 1, Cn = 0; Cn <= Sn; Cn++)
            B(ke[fe + Cn][zt]);
        if (Mt > Rt)
          for (Sn = zt - ue, Rt += 1, Cn = 0; Cn <= Sn; Cn++)
            B(ke[Rt][ue + Cn]);
      }
      for (K = [K], ue = null, fe = $t; fe <= Mt; fe++)
        for (zt = ot; zt <= Vt; zt++)
          ({ cell: Rt } = ke[fe][zt]), Sn = Rt.getParent(), cd(Sn) || z(107), Sn !== ue && K.push(Sn), K.push(Rt, ...ur(Rt)), ue = Sn;
      return Bi() || (this._cachedNodes = K), K;
    }
    getTextContent() {
      let B = this.getNodes(), K = "";
      for (let ue = 0; ue < B.length; ue++)
        K += B[ue].getTextContent();
      return K;
    }
  }
  function _m(Z) {
    return Z instanceof Zc;
  }
  class Er {
    constructor(B, K, ue, fe) {
      this.anchor = B, this.focus = K, this.dirty = !1, this.format = ue, this.style = fe, this._cachedNodes = null, B._selection = this, K._selection = this;
    }
    is(B) {
      return po(B) ? this.anchor.is(B.anchor) && this.focus.is(B.focus) && this.format === B.format && this.style === B.style : !1;
    }
    isBackward() {
      return this.focus.isBefore(this.anchor);
    }
    isCollapsed() {
      return this.anchor.is(this.focus);
    }
    getNodes() {
      var B = this._cachedNodes;
      if (B !== null)
        return B;
      B = this.anchor;
      var K = this.focus, ue = B.isBefore(K), fe = ue ? B : K;
      ue = ue ? K : B, B = fe.getNode(), K = ue.getNode();
      let ke = fe.offset;
      return fe = ue.offset, We(B) && (ue = B.getDescendantByIndex(ke), B = ue ?? B), We(K) && (ue = K.getDescendantByIndex(fe), ue !== null && ue !== B && K.getChildAtIndex(fe) === ue && (ue = ue.getPreviousSibling()), K = ue ?? K), B = B.is(K) ? We(B) && 0 < B.getChildrenSize() ? [] : [B] : B.getNodesBetween(K), Bi() || (this._cachedNodes = B), B;
    }
    setTextNodeRange(B, K, ue, fe) {
      nn(this.anchor, B.__key, K, "text"), nn(this.focus, ue.__key, fe, "text"), this._cachedNodes = null, this.dirty = !0;
    }
    getTextContent() {
      let B = this.getNodes();
      if (B.length === 0)
        return "";
      let K = B[0], ue = B[B.length - 1], fe = this.anchor, ke = this.focus, Ee = fe.isBefore(ke), [qe, ot] = na(this), $t = "", Vt = !0;
      for (let Mt = 0; Mt < B.length; Mt++) {
        let zt = B[Mt];
        if (We(zt) && !zt.isInline())
          Vt || ($t += `
`), Vt = !zt.isEmpty();
        else if (Vt = !1, Vn(zt)) {
          let Rt = zt.getTextContent();
          zt === K ? zt === ue ? (fe.type !== "element" || ke.type !== "element" || ke.offset === fe.offset) && (Rt = qe < ot ? Rt.slice(qe, ot) : Rt.slice(ot, qe)) : Rt = Ee ? Rt.slice(qe) : Rt.slice(ot) : zt === ue && (Rt = Ee ? Rt.slice(0, ot) : Rt.slice(0, qe)), $t += Rt;
        } else
          !Ct(zt) && !gm(zt) || zt === ue && this.isCollapsed() || ($t += zt.getTextContent());
      }
      return $t;
    }
    applyDOMRange(B) {
      let K = Do(), ue = K.getEditorState()._selection;
      if (B = Za(B.startContainer, B.startOffset, B.endContainer, B.endOffset, K, ue), B !== null) {
        var [fe, ke] = B;
        nn(this.anchor, fe.key, fe.offset, fe.type), nn(this.focus, ke.key, ke.offset, ke.type), this._cachedNodes = null;
      }
    }
    clone() {
      let B = this.anchor, K = this.focus;
      return new Er(new ta(B.key, B.offset, B.type), new ta(K.key, K.offset, K.type), this.format, this.style);
    }
    toggleFormat(B) {
      this.format = Je(this.format, B, null), this.dirty = !0;
    }
    setStyle(B) {
      this.style = B, this.dirty = !0;
    }
    hasFormat(B) {
      return (this.format & he[B]) !== 0;
    }
    insertRawText(B) {
      let K = B.split(/\r?\n/);
      if (K.length === 1)
        this.insertText(B);
      else {
        B = [];
        let ue = K.length;
        for (let fe = 0; fe < ue; fe++) {
          let ke = K[fe];
          ke !== "" && B.push(ra(ke)), fe !== ue - 1 && B.push(hc());
        }
        this.insertNodes(B);
      }
    }
    insertText(B) {
      var K = this.anchor, ue = this.focus, fe = this.isCollapsed() || K.isBefore(ue), ke = this.format, Ee = this.style;
      fe && K.type === "element" ? Zo(K, ue, ke, Ee) : fe || ue.type !== "element" || Zo(ue, K, ke, Ee);
      var qe = this.getNodes(), ot = qe.length, $t = fe ? ue : K;
      ue = (fe ? K : ue).offset;
      var Vt = $t.offset;
      K = qe[0], Vn(K) || z(26), fe = K.getTextContent().length;
      var Mt = K.getParentOrThrow(), zt = qe[ot - 1];
      if (this.isCollapsed() && ue === fe && (K.isSegmented() || K.isToken() || !K.canInsertTextAfter() || !Mt.canInsertTextAfter() && K.getNextSibling() === null)) {
        var Rt = K.getNextSibling();
        if ((!Vn(Rt) || at(Rt)) && (Rt = ra(), Rt.setFormat(ke), Mt.canInsertTextAfter() ? K.insertAfter(Rt) : Mt.insertAfter(Rt)), Rt.select(0, 0), K = Rt, B !== "") {
          this.insertText(B);
          return;
        }
      } else if (this.isCollapsed() && ue === 0 && (K.isSegmented() || K.isToken() || !K.canInsertTextBefore() || !Mt.canInsertTextBefore() && K.getPreviousSibling() === null)) {
        if (Rt = K.getPreviousSibling(), (!Vn(Rt) || at(Rt)) && (Rt = ra(), Rt.setFormat(ke), Mt.canInsertTextBefore() ? K.insertBefore(Rt) : Mt.insertBefore(Rt)), Rt.select(), K = Rt, B !== "") {
          this.insertText(B);
          return;
        }
      } else if (K.isSegmented() && ue !== fe)
        Mt = ra(K.getTextContent()), Mt.setFormat(ke), K.replace(Mt), K = Mt;
      else if (!(this.isCollapsed() || B === "" || (Rt = zt.getParent(), Mt.canInsertTextBefore() && Mt.canInsertTextAfter() && (!We(Rt) || Rt.canInsertTextBefore() && Rt.canInsertTextAfter())))) {
        this.insertText(""), Ma(this.anchor, this.focus, null), this.insertText(B);
        return;
      }
      if (ot === 1)
        if (K.isToken())
          B = ra(B), B.select(), K.replace(B);
        else {
          if (qe = K.getFormat(), ot = K.getStyle(), ue === Vt && (qe !== ke || ot !== Ee))
            if (K.getTextContent() === "")
              K.setFormat(ke), K.setStyle(Ee);
            else {
              qe = ra(B), qe.setFormat(ke), qe.setStyle(Ee), qe.select(), ue === 0 ? K.insertBefore(qe, !1) : ([ot] = K.splitText(ue), ot.insertAfter(qe, !1)), qe.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= B.length);
              return;
            }
          K = K.spliceText(ue, Vt - ue, B, !0), K.getTextContent() === "" ? K.remove() : this.anchor.type === "text" && (K.isComposing() ? this.anchor.offset -= B.length : (this.format = qe, this.style = ot));
        }
      else {
        if (ke = /* @__PURE__ */ new Set([...K.getParentKeys(), ...zt.getParentKeys()]), Rt = We(K) ? K : K.getParentOrThrow(), Ee = We(zt) ? zt : zt.getParentOrThrow(), Mt = zt, !Rt.is(Ee) && Ee.isInline())
          do
            Mt = Ee, Ee = Ee.getParentOrThrow();
          while (Ee.isInline());
        $t.type === "text" && (Vt !== 0 || zt.getTextContent() === "") || $t.type === "element" && zt.getIndexWithinParent() < Vt ? Vn(zt) && !zt.isToken() && Vt !== zt.getTextContentSize() ? (zt.isSegmented() && ($t = ra(zt.getTextContent()), zt.replace($t), zt = $t), zt = zt.spliceText(0, Vt, ""), ke.add(zt.__key)) : ($t = zt.getParentOrThrow(), $t.canBeEmpty() || $t.getChildrenSize() !== 1 ? zt.remove() : $t.remove()) : ke.add(zt.__key), $t = Ee.getChildren(), Vt = new Set(qe), zt = Rt.is(Ee), Rt = Rt.isInline() && K.getNextSibling() === null ? Rt : K;
        for (let Sn = $t.length - 1; 0 <= Sn; Sn--) {
          let Cn = $t[Sn];
          if (Cn.is(K) || We(Cn) && Cn.isParentOf(K))
            break;
          Cn.isAttached() && (!Vt.has(Cn) || Cn.is(Mt) ? zt || Rt.insertAfter(Cn, !1) : Cn.remove());
        }
        if (!zt)
          for ($t = Ee, Vt = null; $t !== null; )
            Ee = $t.getChildren(), zt = Ee.length, (zt === 0 || Ee[zt - 1].is(Vt)) && (ke.delete($t.__key), Vt = $t), $t = $t.getParent();
        for (K.isToken() ? ue === fe ? K.select() : (B = ra(B), B.select(), K.replace(B)) : (K = K.spliceText(ue, fe - ue, B, !0), K.getTextContent() === "" ? K.remove() : K.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= B.length)), B = 1; B < ot; B++)
          K = qe[B], ke.has(K.__key) || K.remove();
      }
    }
    removeText() {
      this.insertText("");
    }
    formatText(B) {
      if (this.isCollapsed())
        this.toggleFormat(B), un(null);
      else {
        var K = this.getNodes(), ue = [];
        for (var fe of K)
          Vn(fe) && ue.push(fe);
        var ke = ue.length;
        if (ke === 0)
          this.toggleFormat(B), un(null);
        else {
          fe = this.anchor;
          var Ee = this.focus, qe = this.isBackward();
          K = qe ? Ee : fe, fe = qe ? fe : Ee;
          var ot = 0, $t = ue[0];
          if (Ee = K.type === "element" ? 0 : K.offset, K.type === "text" && Ee === $t.getTextContentSize() && (ot = 1, $t = ue[1], Ee = 0), $t != null) {
            qe = $t.getFormatFlags(B, null);
            var Vt = ke - 1, Mt = ue[Vt];
            if (ke = fe.type === "text" ? fe.offset : Mt.getTextContentSize(), $t.is(Mt))
              Ee !== ke && (Ee === 0 && ke === $t.getTextContentSize() ? $t.setFormat(qe) : (B = $t.splitText(Ee, ke), B = Ee === 0 ? B[0] : B[1], B.setFormat(qe), K.type === "text" && K.set(B.__key, 0, "text"), fe.type === "text" && fe.set(B.__key, ke - Ee, "text")), this.format = qe);
            else {
              Ee !== 0 && ([, $t] = $t.splitText(Ee), Ee = 0), $t.setFormat(qe);
              var zt = Mt.getFormatFlags(B, qe);
              for (0 < ke && (ke !== Mt.getTextContentSize() && ([Mt] = Mt.splitText(ke)), Mt.setFormat(zt)), ot += 1; ot < Vt; ot++) {
                let Rt = ue[ot];
                if (!Rt.isToken()) {
                  let Sn = Rt.getFormatFlags(B, zt);
                  Rt.setFormat(Sn);
                }
              }
              K.type === "text" && K.set($t.__key, Ee, "text"), fe.type === "text" && fe.set(Mt.__key, ke, "text"), this.format = qe | zt;
            }
          }
        }
      }
    }
    insertNodes(B, K) {
      if (!this.isCollapsed()) {
        var ue = this.isBackward() ? this.anchor : this.focus, fe = ue.getNode().getNextSibling();
        if (fe = fe ? fe.getKey() : null, ue = (ue = ue.getNode().getPreviousSibling()) ? ue.getKey() : null, this.removeText(), this.isCollapsed() && this.focus.type === "element") {
          if (this.focus.key === fe && this.focus.offset === 0) {
            var ke = ra();
            this.focus.getNode().insertBefore(ke);
          } else
            this.focus.key === ue && this.focus.offset === this.focus.getNode().getChildrenSize() && (ke = ra(), this.focus.getNode().insertAfter(ke));
          ke && (this.focus.set(ke.__key, 0, "text"), this.anchor.set(ke.__key, 0, "text"));
        }
      }
      ke = this.anchor, ue = ke.offset;
      var Ee = ke.getNode();
      fe = Ee, ke.type === "element" && (ke = ke.getNode(), fe = ke.getChildAtIndex(ue - 1), fe = fe === null ? ke : fe), ke = [];
      var qe = Ee.getNextSiblings(), ot = cn(Ee) ? null : Ee.getTopLevelElementOrThrow();
      if (Vn(Ee))
        if (fe = Ee.getTextContent().length, ue === 0 && fe !== 0)
          fe = Ee.getPreviousSibling(), fe = fe !== null ? fe : Ee.getParentOrThrow(), ke.push(Ee);
        else if (ue === fe)
          fe = Ee;
        else {
          if (Ee.isToken())
            return !1;
          [fe, Ee] = Ee.splitText(ue), ke.push(Ee);
        }
      Ee = fe, ke.push(...qe), qe = B[0];
      var $t = !1, Vt = null;
      for (let Sn = 0; Sn < B.length; Sn++) {
        var Mt = B[Sn];
        if (cn(fe) || Ct(fe) || !We(Mt) || Mt.isInline())
          $t && !We(Mt) && !Ct(Mt) && cn(fe.getParent()) && z(28);
        else {
          if (Mt.is(qe)) {
            if (We(fe) && fe.isEmpty() && fe.canReplaceWith(Mt)) {
              fe.replace(Mt), fe = Mt, $t = !0;
              continue;
            }
            if ($t = Mt.getFirstDescendant(), vt($t)) {
              for (var zt = $t.getParentOrThrow(); zt.isInline(); )
                zt = zt.getParentOrThrow();
              if (Vt = zt.getChildren(), $t = Vt.length, We(fe)) {
                var Rt = fe.getFirstChild();
                for (let Cn = 0; Cn < $t; Cn++) {
                  let ro = Vt[Cn];
                  Rt === null ? fe.append(ro) : Rt.insertAfter(ro), Rt = ro;
                }
              } else {
                for (Rt = $t - 1; 0 <= Rt; Rt--)
                  fe.insertAfter(Vt[Rt]);
                fe = fe.getParentOrThrow();
              }
              if (Vt = Vt[$t - 1], zt.remove(), $t = !0, zt.is(Mt))
                continue;
            }
          }
          Vn(fe) && (ot === null && z(27), fe = ot);
        }
        $t = !1, We(fe) && !fe.isInline() ? (Vt = Mt, Ct(Mt) && !Mt.isInline() ? fe = fe.insertAfter(Mt, !1) : We(Mt) ? (Mt.canBeEmpty() || !Mt.isEmpty()) && (on(fe) ? (zt = fe.getChildAtIndex(ue), zt !== null ? zt.insertBefore(Mt) : fe.append(Mt), fe = Mt) : Mt.isInline() ? (fe.append(Mt), fe = Mt) : fe = fe.insertAfter(Mt, !1)) : (zt = fe.getFirstChild(), zt !== null ? zt.insertBefore(Mt) : fe.append(Mt), fe = Mt)) : !We(Mt) || We(Mt) && Mt.isInline() || Ct(fe) && !fe.isInline() ? (Vt = Mt, po(this) && Ct(Mt) && (We(fe) || Vn(fe)) && !Mt.isInline() ? (Vn(fe) ? (zt = fe.getParentOrThrow(), [fe] = fe.splitText(ue), fe = fe.getIndexWithinParent() + 1) : (zt = fe, fe = ue), [, fe] = It(zt, fe), fe = fe.insertBefore(Mt)) : fe = fe.insertAfter(Mt, !1)) : (Mt = fe.getParentOrThrow(), gm(fe) && fe.remove(), fe = Mt, Sn--);
      }
      if (K && (Vn(Ee) ? Ee.select() : (B = fe.getPreviousSibling(), Vn(B) ? B.select() : (B = fe.getIndexWithinParent(), fe.getParentOrThrow().select(B, B)))), We(fe)) {
        if (B = Vn(Vt) ? Vt : We(Vt) && Vt.isInline() ? Vt.getLastDescendant() : fe.getLastDescendant(), K || (B === null ? fe.select() : Vn(B) ? B.getTextContent() === "" ? B.selectPrevious() : B.select() : B.selectNext()), ke.length !== 0)
          for (K = fe, B = ke.length - 1; 0 <= B; B--)
            ue = ke[B], ot = ue.getParentOrThrow(), !We(fe) || Al(ue) || Ct(ue) && (!ue.isInline() || ue.isIsolated()) ? We(fe) || Al(ue) ? We(ue) && !ue.canInsertAfter(fe) ? (Ee = ot.constructor.clone(ot), We(Ee) || z(29), Ee.append(ue), fe.insertAfter(Ee)) : fe.insertAfter(ue) : (fe.insertBefore(ue), fe = ue) : (K === fe ? fe.append(ue) : fe.insertBefore(ue), fe = ue), ot.isEmpty() && !ot.canBeEmpty() && ot.remove();
      } else
        K || (Vn(fe) ? fe.select() : (K = fe.getParentOrThrow(), B = fe.getIndexWithinParent() + 1, K.select(B, B)));
      return !0;
    }
    insertParagraph() {
      this.isCollapsed() || this.removeText();
      var B = this.anchor, K = B.offset, ue = [];
      if (B.type === "text") {
        var fe = B.getNode(), ke = fe.getNextSiblings().reverse(), Ee = fe.getParentOrThrow(), qe = Ee.isInline(), ot = qe ? Ee.getTextContentSize() : fe.getTextContentSize();
        K === 0 ? ke.push(fe) : (qe && (ue = Ee.getNextSiblings()), K === ot || qe && K === fe.getTextContentSize() || ([, fe] = fe.splitText(K), ke.push(fe)));
      } else {
        if (Ee = B.getNode(), cn(Ee)) {
          ke = Nl(), ue = Ee.getChildAtIndex(K), ke.select(), ue !== null ? ue.insertBefore(ke, !1) : Ee.append(ke);
          return;
        }
        ke = Ee.getChildren().slice(K).reverse();
      }
      if (fe = ke.length, K === 0 && 0 < fe && Ee.isInline()) {
        if (ue = Ee.getParentOrThrow(), ke = ue.insertNewAfter(this, !1), We(ke))
          for (ue = ue.getChildren(), Ee = 0; Ee < ue.length; Ee++)
            ke.append(ue[Ee]);
      } else if (qe = Ee.insertNewAfter(this, !1), qe === null)
        this.insertLineBreak();
      else if (We(qe))
        if (ot = Ee.getFirstChild(), K === 0 && (Ee.is(B.getNode()) || ot && ot.is(B.getNode())) && 0 < fe)
          Ee.insertBefore(qe);
        else {
          if (Ee = null, K = ue.length, B = qe.getParentOrThrow(), 0 < K)
            for (ot = 0; ot < K; ot++)
              B.append(ue[ot]);
          if (fe !== 0)
            for (ue = 0; ue < fe; ue++)
              K = ke[ue], Ee === null ? qe.append(K) : Ee.insertBefore(K), Ee = K;
          qe.canBeEmpty() || qe.getChildrenSize() !== 0 ? qe.selectStart() : (qe.selectPrevious(), qe.remove());
        }
    }
    insertLineBreak(B) {
      let K = hc();
      var ue = this.anchor;
      ue.type === "element" && (ue = ue.getNode(), on(ue) && this.insertParagraph()), B ? this.insertNodes([K], !0) : this.insertNodes([K]) && K.selectNext(0, 0);
    }
    getCharacterOffsets() {
      return na(this);
    }
    extract() {
      var B = this.getNodes(), K = B.length, ue = K - 1, fe = this.anchor;
      let ke = this.focus;
      var Ee = B[0];
      let qe = B[ue], [ot, $t] = na(this);
      return K === 0 ? [] : K === 1 ? Vn(Ee) && !this.isCollapsed() ? (B = ot > $t ? $t : ot, ue = Ee.splitText(B, ot > $t ? ot : $t), B = B === 0 ? ue[0] : ue[1], B != null ? [B] : []) : [Ee] : (K = fe.isBefore(ke), Vn(Ee) && (fe = K ? ot : $t, fe === Ee.getTextContentSize() ? B.shift() : fe !== 0 && ([, Ee] = Ee.splitText(fe), B[0] = Ee)), Vn(qe) && (Ee = qe.getTextContent().length, K = K ? $t : ot, K === 0 ? B.pop() : K !== Ee && ([qe] = qe.splitText(K), B[ue] = qe)), B);
    }
    modify(B, K, ue) {
      var fe = this.focus, ke = this.anchor, Ee = B === "move", qe = an(fe, K);
      if (Ct(qe) && !qe.isIsolated())
        Ee && qe.isKeyboardSelectable() ? (K = rp(), K.add(qe.__key), Xn(K)) : (B = K ? qe.getPreviousSibling() : qe.getNextSibling(), Vn(B) ? (qe = B.__key, K = K ? B.getTextContent().length : 0, fe.set(qe, K, "text"), Ee && ke.set(qe, K, "text")) : (ue = qe.getParentOrThrow(), We(B) ? (ue = B.__key, qe = K ? B.getChildrenSize() : 0) : (qe = qe.getIndexWithinParent(), ue = ue.__key, K || qe++), fe.set(ue, qe, "element"), Ee && ke.set(ue, qe, "element")));
      else if (ke = Do(), fe = xn(ke._window)) {
        var ot = ke._blockCursorElement, $t = ke._rootElement;
        if ($t === null || ot === null || !We(qe) || qe.isInline() || qe.canBeEmpty() || Wt(ot, ke, $t), fe.modify(B, K ? "backward" : "forward", ue), 0 < fe.rangeCount && (qe = fe.getRangeAt(0), ke = this.anchor.getNode(), ke = on(ke) ? ke : Pt(ke), this.applyDOMRange(qe), this.dirty = !0, !Ee)) {
          for (Ee = this.getNodes(), B = [], ue = !1, ot = 0; ot < Ee.length; ot++)
            $t = Ee[ot], kn($t, ke) ? B.push($t) : ue = !0;
          ue && 0 < B.length && (K ? (K = B[0], We(K) ? K.selectStart() : K.getParentOrThrow().selectStart()) : (K = B[B.length - 1], We(K) ? K.selectEnd() : K.getParentOrThrow().selectEnd())), (fe.anchorNode !== qe.startContainer || fe.anchorOffset !== qe.startOffset) && (K = this.focus, Ee = this.anchor, fe = Ee.key, qe = Ee.offset, ke = Ee.type, nn(Ee, K.key, K.offset, K.type), nn(
            K,
            fe,
            qe,
            ke
          ), this._cachedNodes = null);
        }
      }
    }
    deleteCharacter(B) {
      if (this.isCollapsed()) {
        var K = this.anchor, ue = this.focus, fe = K.getNode();
        if (!B && (K.type === "element" && We(fe) && K.offset === fe.getChildrenSize() || K.type === "text" && K.offset === fe.getTextContentSize())) {
          var ke = fe.getParent();
          if (ke = fe.getNextSibling() || (ke === null ? null : ke.getNextSibling()), We(ke) && !ke.canExtractContents())
            return;
        }
        if (ke = an(ue, B), Ct(ke) && !ke.isIsolated()) {
          ke.isKeyboardSelectable() && We(fe) && fe.getChildrenSize() === 0 ? (fe.remove(), B = rp(), B.add(ke.__key), Xn(B)) : ke.remove();
          return;
        }
        if (this.modify(
          "extend",
          B,
          "character"
        ), this.isCollapsed()) {
          if (B && K.offset === 0 && (K.type === "element" ? K.getNode() : K.getNode().getParentOrThrow()).collapseAtStart(this))
            return;
        } else {
          if (ke = ue.type === "text" ? ue.getNode() : null, fe = K.type === "text" ? K.getNode() : null, ke !== null && ke.isSegmented()) {
            if (K = ue.offset, ue = ke.getTextContentSize(), ke.is(fe) || B && K !== ue || !B && K !== 0) {
              As(ke, B, K);
              return;
            }
          } else if (fe !== null && fe.isSegmented() && (K = K.offset, ue = fe.getTextContentSize(), fe.is(ke) || B && K !== 0 || !B && K !== ue)) {
            As(fe, B, K);
            return;
          }
          if (fe = this.anchor, ke = this.focus, K = fe.getNode(), ue = ke.getNode(), K === ue && fe.type === "text" && ke.type === "text") {
            var Ee = fe.offset, qe = ke.offset;
            let ot = Ee < qe;
            ue = ot ? Ee : qe, qe = ot ? qe : Ee, Ee = qe - 1, ue !== Ee && (K = K.getTextContent().slice(ue, qe), In(K) || (B ? ke.offset = Ee : fe.offset = Ee));
          }
        }
      }
      fe = this.isCollapsed(), this.removeText(), B && !fe && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0 && (B = this.anchor.getNode(), B.isEmpty() && on(B.getParent()) && B.getIndexWithinParent() === 0 && B.collapseAtStart(this));
    }
    deleteLine(B) {
      this.isCollapsed() && (this.anchor.type === "text" && this.modify(
        "extend",
        B,
        "lineboundary"
      ), (B ? this.focus : this.anchor).offset === 0 && this.modify("extend", B, "character")), this.removeText();
    }
    deleteWord(B) {
      this.isCollapsed() && this.modify("extend", B, "word"), this.removeText();
    }
  }
  function uu(Z) {
    return Z instanceof Ts;
  }
  function du(Z) {
    let B = Z.offset;
    return Z.type === "text" ? B : (Z = Z.getNode(), B === Z.getChildrenSize() ? Z.getTextContent().length : 0);
  }
  function na(Z) {
    let B = Z.anchor;
    return Z = Z.focus, B.type === "element" && Z.type === "element" && B.key === Z.key && B.offset === Z.offset ? [0, 0] : [du(B), du(Z)];
  }
  function As(Z, B, K) {
    let ue = Z.getTextContent().split(/(?=\s)/g), fe = ue.length, ke = 0, Ee = 0;
    for (let qe = 0; qe < fe; qe++) {
      let ot = ue[qe], $t = qe === fe - 1;
      if (Ee = ke, ke += ot.length, B && ke === K || ke > K || $t) {
        ue.splice(qe, 1), $t && (Ee = void 0);
        break;
      }
    }
    B = ue.join("").trim(), B === "" ? Z.remove() : (Z.setTextContent(B), Z.select(Ee, Ee));
  }
  function pm(Z, B, K, ue) {
    var fe = B;
    if (Z.nodeType === 1) {
      let qe = !1;
      var ke = Z.childNodes, Ee = ke.length;
      fe === Ee && (qe = !0, fe = Ee - 1);
      let ot = ke[fe];
      if (Ee = !1, ot === ue._blockCursorElement ? (ot = ke[fe + 1], Ee = !0) : ue._blockCursorElement !== null && fe--, ue = Qn(ot), Vn(ue))
        fe = qe ? ue.getTextContentSize() : 0;
      else {
        if (ke = Qn(Z), ke === null)
          return null;
        if (We(ke) ? (Z = ke.getChildAtIndex(fe), (B = We(Z)) && (B = Z.getParent(), B = K === null || B === null || !B.canBeEmpty() || B !== K.getNode()), B && (K = qe ? Z.getLastDescendant() : Z.getFirstDescendant(), K === null ? (ke = Z, fe = 0) : (Z = K, ke = We(Z) ? Z : Z.getParentOrThrow())), Vn(Z) ? (ue = Z, ke = null, fe = qe ? Z.getTextContentSize() : 0) : Z !== ke && qe && !Ee && fe++) : (fe = ke.getIndexWithinParent(), fe = B === 0 && Ct(ke) && Qn(Z) === ke ? fe : fe + 1, ke = ke.getParentOrThrow()), We(ke))
          return new ta(ke.__key, fe, "element");
      }
    } else
      ue = Qn(Z);
    return Vn(ue) ? new ta(ue.__key, fe, "text") : null;
  }
  function n_(Z, B, K) {
    var ue = Z.offset, fe = Z.getNode();
    ue === 0 ? (ue = fe.getPreviousSibling(), fe = fe.getParent(), B ? (K || !B) && ue === null && We(fe) && fe.isInline() && (B = fe.getPreviousSibling(), Vn(B) && (Z.key = B.__key, Z.offset = B.getTextContent().length)) : We(ue) && !K && ue.isInline() ? (Z.key = ue.__key, Z.offset = ue.getChildrenSize(), Z.type = "element") : Vn(ue) && (Z.key = ue.__key, Z.offset = ue.getTextContent().length)) : ue === fe.getTextContent().length && (ue = fe.getNextSibling(), fe = fe.getParent(), B && We(ue) && ue.isInline() ? (Z.key = ue.__key, Z.offset = 0, Z.type = "element") : (K || B) && ue === null && We(fe) && fe.isInline() && !fe.canInsertTextAfter() && (B = fe.getNextSibling(), Vn(B) && (Z.key = B.__key, Z.offset = 0)));
  }
  function Ma(Z, B, K) {
    if (Z.type === "text" && B.type === "text") {
      var ue = Z.isBefore(B);
      let fe = Z.is(B);
      n_(Z, ue, fe), n_(B, !ue, fe), fe && (B.key = Z.key, B.offset = Z.offset, B.type = Z.type), ue = Do(), ue.isComposing() && ue._compositionKey !== Z.key && po(K) && (ue = K.anchor, K = K.focus, nn(Z, ue.key, ue.offset, ue.type), nn(B, K.key, K.offset, K.type));
    }
  }
  function Za(Z, B, K, ue, fe, ke) {
    return Z === null || K === null || !He(fe, Z, K) || (B = pm(Z, B, po(ke) ? ke.anchor : null, fe), B === null) || (ue = pm(K, ue, po(ke) ? ke.focus : null, fe), ue === null || B.type === "element" && ue.type === "element" && (Z = Qn(Z), K = Qn(K), Ct(Z) && Ct(K))) ? null : (Ma(B, ue, ke), [B, ue]);
  }
  function Al(Z) {
    return We(Z) && !Z.isInline();
  }
  function Il(Z, B, K, ue, fe, ke) {
    let Ee = oa();
    return Z = new Er(new ta(Z, B, fe), new ta(K, ue, ke), 0, ""), Z.dirty = !0, Ee._selection = Z;
  }
  function rp() {
    return new Ts(/* @__PURE__ */ new Set());
  }
  function id(Z) {
    let B = Z.getEditorState()._selection, K = xn(Z._window);
    return uu(B) || _m(B) ? B.clone() : Ol(B, K, Z);
  }
  function Ol(Z, B, K) {
    var ue = K._window;
    if (ue === null)
      return null;
    var fe = ue.event, ke = fe ? fe.type : void 0;
    ue = ke === "selectionchange", fe = !ge && (ue || ke === "beforeinput" || ke === "compositionstart" || ke === "compositionend" || ke === "click" && fe && fe.detail === 3 || ke === "drop" || ke === void 0);
    let Ee;
    if (!po(Z) || fe) {
      if (B === null)
        return null;
      if (fe = B.anchorNode, ke = B.focusNode, Ee = B.anchorOffset, B = B.focusOffset, ue && po(Z) && !He(K, fe, ke))
        return Z.clone();
    } else
      return Z.clone();
    if (K = Za(fe, Ee, ke, B, K, Z), K === null)
      return null;
    let [qe, ot] = K;
    return new Er(qe, ot, po(Z) ? Z.format : 0, po(Z) ? Z.style : "");
  }
  function To() {
    return oa()._selection;
  }
  function Na() {
    return Do()._editorState._selection;
  }
  function fa(Z, B, K, ue = 1) {
    var fe = Z.anchor, ke = Z.focus, Ee = fe.getNode(), qe = ke.getNode();
    if (B.is(Ee) || B.is(qe))
      if (Ee = B.__key, Z.isCollapsed())
        B = fe.offset, K <= B && (K = Math.max(0, B + ue), fe.set(Ee, K, "element"), ke.set(Ee, K, "element"), Is(Z));
      else {
        var ot = Z.isBackward();
        qe = ot ? ke : fe;
        var $t = qe.getNode();
        fe = ot ? fe : ke, ke = fe.getNode(), B.is($t) && ($t = qe.offset, K <= $t && qe.set(Ee, Math.max(0, $t + ue), "element")), B.is(ke) && (B = fe.offset, K <= B && fe.set(Ee, Math.max(0, B + ue), "element")), Is(Z);
      }
  }
  function Is(Z) {
    var B = Z.anchor, K = B.offset;
    let ue = Z.focus;
    var fe = ue.offset, ke = B.getNode(), Ee = ue.getNode();
    if (Z.isCollapsed())
      We(ke) && (Ee = ke.getChildrenSize(), Ee = (fe = K >= Ee) ? ke.getChildAtIndex(Ee - 1) : ke.getChildAtIndex(K), Vn(Ee) && (K = 0, fe && (K = Ee.getTextContentSize()), B.set(Ee.__key, K, "text"), ue.set(Ee.__key, K, "text")));
    else {
      if (We(ke)) {
        let qe = ke.getChildrenSize();
        K = (Z = K >= qe) ? ke.getChildAtIndex(qe - 1) : ke.getChildAtIndex(K), Vn(K) && (ke = 0, Z && (ke = K.getTextContentSize()), B.set(K.__key, ke, "text"));
      }
      We(Ee) && (K = Ee.getChildrenSize(), fe = (B = fe >= K) ? Ee.getChildAtIndex(K - 1) : Ee.getChildAtIndex(fe), Vn(fe) && (Ee = 0, B && (Ee = fe.getTextContentSize()), ue.set(fe.__key, Ee, "text")));
    }
  }
  function Xc(Z, B) {
    if (B = B.getEditorState()._selection, Z = Z._selection, po(Z)) {
      var K = Z.anchor;
      let ue = Z.focus, fe;
      K.type === "text" && (fe = K.getNode(), fe.selectionTransform(B, Z)), ue.type === "text" && (K = ue.getNode(), fe !== K && K.selectionTransform(B, Z));
    }
  }
  function ad(Z, B, K, ue, fe) {
    let ke = null, Ee = 0, qe = null;
    ue !== null ? (ke = ue.__key, Vn(ue) ? (Ee = ue.getTextContentSize(), qe = "text") : We(ue) && (Ee = ue.getChildrenSize(), qe = "element")) : fe !== null && (ke = fe.__key, Vn(fe) ? qe = "text" : We(fe) && (qe = "element")), ke !== null && qe !== null ? Z.set(ke, Ee, qe) : (Ee = B.getIndexWithinParent(), Ee === -1 && (Ee = K.getChildrenSize()), Z.set(K.__key, Ee, "element"));
  }
  function sd(Z, B, K, ue, fe) {
    Z.type === "text" ? (Z.key = K, B || (Z.offset += fe)) : Z.offset > ue.getIndexWithinParent() && --Z.offset;
  }
  function Xs(Z, B, K) {
    let ue = [], fe = null, ke = null;
    Z = Z.getChildren();
    for (let Vt = 0; Vt < Z.length; Vt++) {
      var Ee = Z[Vt];
      cd(Ee) || z(108);
      var qe = Ee.getChildren();
      Ee = 0;
      for (let Mt of qe) {
        for (Ns(Mt) || z(109); ue[Vt] !== void 0 && ue[Vt][Ee] !== void 0; )
          Ee++;
        qe = Vt;
        var ot = Ee, $t = Mt;
        let zt = { cell: $t, startColumn: ot, startRow: qe }, Rt = $t.__rowSpan, Sn = $t.__colSpan;
        for (let Cn = 0; Cn < Rt; Cn++) {
          ue[qe + Cn] === void 0 && (ue[qe + Cn] = []);
          for (let ro = 0; ro < Sn; ro++)
            ue[qe + Cn][ot + ro] = zt;
        }
        B.is($t) && (fe = zt), K.is($t) && (ke = zt), Ee += Mt.__colSpan;
      }
    }
    return fe === null && z(110), ke === null && z(111), [ue, fe, ke];
  }
  let fr = null, Ii = null, Fa = !1, ip = !1, Xa = 0, Vi = { characterData: !0, childList: !0, subtree: !0 };
  function Bi() {
    return Fa || fr !== null && fr._readOnly;
  }
  function Jr() {
    Fa && z(13);
  }
  function oa() {
    return fr === null && z(15), fr;
  }
  function Do() {
    return Ii === null && z(16), Ii;
  }
  function Jc(Z, B, K) {
    var ue = B.__type;
    let fe = Z._nodes.get(ue);
    for (fe === void 0 && z(30), Z = K.get(ue), Z === void 0 && (Z = Array.from(fe.transforms), K.set(ue, Z)), K = Z.length, ue = 0; ue < K && (Z[ue](B), B.isAttached()); ue++)
      ;
  }
  function mm(Z, B) {
    B = B._dirtyLeaves, Z = Z._nodeMap;
    for (let K of B)
      B = Z.get(K), Vn(B) && B.isAttached() && B.isSimpleText() && !B.isUnmergeable() && Wc(B);
  }
  function fm(Z, B) {
    let K = B._dirtyLeaves, ue = B._dirtyElements;
    Z = Z._nodeMap;
    let fe = pn(), ke = /* @__PURE__ */ new Map();
    var Ee = K;
    let qe = Ee.size;
    for (var ot = ue, $t = ot.size; 0 < qe || 0 < $t; ) {
      if (0 < qe) {
        B._dirtyLeaves = /* @__PURE__ */ new Set();
        for (let Vt of Ee)
          Ee = Z.get(Vt), Vn(Ee) && Ee.isAttached() && Ee.isSimpleText() && !Ee.isUnmergeable() && Wc(Ee), Ee !== void 0 && Ee !== void 0 && Ee.__key !== fe && Ee.isAttached() && Jc(B, Ee, ke), K.add(Vt);
        if (Ee = B._dirtyLeaves, qe = Ee.size, 0 < qe) {
          Xa++;
          continue;
        }
      }
      B._dirtyLeaves = /* @__PURE__ */ new Set(), B._dirtyElements = /* @__PURE__ */ new Map();
      for (let Vt of ot)
        ot = Vt[0], $t = Vt[1], (ot === "root" || $t) && (Ee = Z.get(ot), Ee !== void 0 && Ee !== void 0 && Ee.__key !== fe && Ee.isAttached() && Jc(B, Ee, ke), ue.set(ot, $t));
      Ee = B._dirtyLeaves, qe = Ee.size, ot = B._dirtyElements, $t = ot.size, Xa++;
    }
    B._dirtyLeaves = K, B._dirtyElements = ue;
  }
  function G(Z, B) {
    var K = B.get(Z.type);
    if (K === void 0 && z(17), K = K.klass, Z.type !== K.getType() && z(18), K = K.importJSON(Z), Z = Z.children, We(K) && Array.isArray(Z))
      for (let ue = 0; ue < Z.length; ue++) {
        let fe = G(Z[ue], B);
        K.append(fe);
      }
    return K;
  }
  function ce(Z, B) {
    let K = fr, ue = Fa, fe = Ii;
    fr = Z, Fa = !0, Ii = null;
    try {
      return B();
    } finally {
      fr = K, Fa = ue, Ii = fe;
    }
  }
  function Se(Z) {
    let B = Z._pendingEditorState, K = Z._rootElement, ue = Z._headless || K === null;
    if (B !== null) {
      var fe = Z._editorState, ke = fe._selection, Ee = B._selection, qe = Z._dirtyType !== 0, ot = fr, $t = Fa, Vt = Ii, Mt = Z._updating, zt = Z._observer, Rt = null;
      if (Z._pendingEditorState = null, Z._editorState = B, !ue && qe && zt !== null) {
        Ii = Z, fr = B, Fa = !1, Z._updating = !0;
        try {
          let yo = Z._dirtyType, Sa = Z._dirtyElements, Ni = Z._dirtyLeaves;
          zt.disconnect();
          var Sn = yo, Cn = Sa, ro = Ni;
          ji = Ks = Pr = "", Gd = Sn === 2, Wd = null, Xr = Z, Or = Z._config, mi = Z._nodes, iu = Xr._listeners.mutation, ep = Cn, ss = ro, _c = fe._nodeMap, Co = B._nodeMap, Hc = B._readOnly, Hd = new Map(Z._keyToDOMMap);
          let Qc = /* @__PURE__ */ new Map();
          xs = Qc, Cs("root", null), xs = Hd = Or = Co = _c = ss = ep = mi = Xr = void 0, Rt = Qc;
        } catch (yo) {
          if (yo instanceof Error && Z._onError(yo), ip)
            throw yo;
          a_(Z, null, K, B), De(Z), Z._dirtyType = 2, ip = !0, Se(Z), ip = !1;
          return;
        } finally {
          zt.observe(K, Vi), Z._updating = Mt, fr = ot, Fa = $t, Ii = Vt;
        }
      }
      B._readOnly || (B._readOnly = !0);
      var Uo = Z._dirtyLeaves, Oi = Z._dirtyElements, ga = Z._normalizedNodes, bc = Z._updateTags, ld = Z._deferred;
      qe && (Z._dirtyType = 0, Z._cloneNotNeeded.clear(), Z._dirtyLeaves = /* @__PURE__ */ new Set(), Z._dirtyElements = /* @__PURE__ */ new Map(), Z._normalizedNodes = /* @__PURE__ */ new Set(), Z._updateTags = /* @__PURE__ */ new Set());
      var jv = Z._decorators, Js = Z._pendingDecorators || jv, Yg = B._nodeMap, s_;
      for (s_ in Js)
        Yg.has(s_) || (Js === jv && (Js = Yn(Z)), delete Js[s_]);
      var us = ue ? null : xn(Z._window);
      if (Z._editable && us !== null && (qe || Ee === null || Ee.dirty)) {
        Ii = Z, fr = B;
        try {
          if (zt !== null && zt.disconnect(), qe || Ee === null || Ee.dirty) {
            let yo = Z._blockCursorElement;
            yo !== null && Wt(yo, Z, K);
            e: {
              let Sa = us.anchorNode, Ni = us.focusNode, Qc = us.anchorOffset, $m = us.focusOffset, gi = document.activeElement;
              if (!(bc.has("collaboration") && gi !== K || gi !== null && je(gi)))
                if (po(Ee)) {
                  var Qs = Ee.anchor, Le = Ee.focus, so = Qs.key, c_ = Le.key, ds = hn(Z, so), jo = hn(Z, c_), ud = Qs.offset, Kg = Le.offset, up = Ee.format, mu = Ee.style, Vv = Ee.isCollapsed(), hm = ds, vm = jo, Zg = !1;
                  if (Qs.type === "text") {
                    hm = wt(ds);
                    let el = Qs.getNode();
                    Zg = el.getFormat() !== up || el.getStyle() !== mu;
                  } else
                    po(ke) && ke.anchor.type === "text" && (Zg = !0);
                  if (Le.type === "text" && (vm = wt(jo)), hm !== null && vm !== null) {
                    if (Vv && (ke === null || Zg || po(ke) && (ke.format !== up || ke.style !== mu))) {
                      var Bv = performance.now();
                      np = [up, mu, ud, so, Bv];
                    }
                    if (Qc === ud && $m === Kg && Sa === hm && Ni === vm && (us.type !== "Range" || !Vv) && (gi !== null && K.contains(gi) || K.focus({ preventScroll: !0 }), Qs.type !== "element"))
                      break e;
                    try {
                      us.setBaseAndExtent(hm, ud, vm, Kg);
                    } catch {
                    }
                    if (!bc.has("skip-scroll-into-view") && Ee.isCollapsed() && K !== null && K === document.activeElement) {
                      let el = Ee instanceof Er && Ee.anchor.type === "element" ? hm.childNodes[ud] || null : 0 < us.rangeCount ? us.getRangeAt(0) : null;
                      if (el !== null) {
                        let Rl = el.getBoundingClientRect(), dd = K.ownerDocument, l_ = dd.defaultView;
                        if (l_ !== null)
                          for (var { top: yc, bottom: Ff } = Rl, bm, ym, fu = K; fu !== null; ) {
                            let tl = fu === dd.body;
                            if (tl)
                              bm = 0, ym = dt(Z).innerHeight;
                            else {
                              let Hi = fu.getBoundingClientRect();
                              bm = Hi.top, ym = Hi.bottom;
                            }
                            let _d = 0;
                            if (yc < bm ? _d = -(bm - yc) : Ff > ym && (_d = Ff - ym), _d !== 0)
                              if (tl)
                                l_.scrollBy(0, _d);
                              else {
                                let Hi = fu.scrollTop;
                                fu.scrollTop += _d;
                                let Ea = fu.scrollTop - Hi;
                                yc -= Ea, Ff -= Ea;
                              }
                            if (tl)
                              break;
                            fu = zn(fu);
                          }
                      }
                    }
                    El = !0;
                  }
                } else
                  ke !== null && He(Z, Sa, Ni) && us.removeAllRanges();
            }
          }
          e: {
            let yo = Z._blockCursorElement;
            if (po(Ee) && Ee.isCollapsed() && Ee.anchor.type === "element" && K.contains(document.activeElement)) {
              let Sa = Ee.anchor, Ni = Sa.getNode(), Qc = Sa.offset, $m = Ni.getChildrenSize(), gi = !1, el = null;
              if (Qc === $m) {
                let Rl = Ni.getChildAtIndex(Qc - 1);
                bt(Rl) && (gi = !0);
              } else {
                let Rl = Ni.getChildAtIndex(Qc);
                if (bt(Rl)) {
                  let dd = Rl.getPreviousSibling();
                  (dd === null || bt(dd)) && (gi = !0, el = Z.getElementByKey(Rl.__key));
                }
              }
              if (gi) {
                let Rl = Z.getElementByKey(Ni.__key);
                if (yo === null) {
                  let dd = Z._config.theme, l_ = document.createElement("div");
                  l_.contentEditable = "false", l_.setAttribute("data-lexical-cursor", "true");
                  let tl = dd.blockCursor;
                  if (tl !== void 0) {
                    if (typeof tl == "string") {
                      let _d = tl.split(" ");
                      tl = dd.blockCursor = _d;
                    }
                    tl !== void 0 && l_.classList.add(...tl);
                  }
                  Z._blockCursorElement = yo = l_;
                }
                K.style.caretColor = "transparent", el === null ? Rl.appendChild(yo) : Rl.insertBefore(yo, el);
                break e;
              }
            }
            yo !== null && Wt(yo, Z, K);
          }
          zt !== null && zt.observe(K, Vi);
        } finally {
          Ii = Vt, fr = ot;
        }
      }
      if (Rt !== null) {
        var $$ = Rt;
        let yo = Array.from(Z._listeners.mutation), Sa = yo.length;
        for (let Ni = 0; Ni < Sa; Ni++) {
          let [Qc, $m] = yo[Ni], gi = $$.get($m);
          gi !== void 0 && Qc(gi, { dirtyLeaves: Uo, updateTags: bc });
        }
      }
      po(Ee) || Ee === null || ke !== null && ke.is(Ee) || Z.dispatchCommand(e, void 0);
      var ec = Z._pendingDecorators;
      ec !== null && (Z._decorators = ec, Z._pendingDecorators = null, Ie("decorator", Z, !0, ec));
      var w$ = Qt(fe), Uv = Qt(B);
      if (w$ !== Uv && Ie("textcontent", Z, !0, Uv), Ie("update", Z, !0, { dirtyElements: Oi, dirtyLeaves: Uo, editorState: B, normalizedNodes: ga, prevEditorState: fe, tags: bc }), Z._deferred = [], ld.length !== 0) {
        let yo = Z._updating;
        Z._updating = !0;
        try {
          for (let Sa = 0; Sa < ld.length; Sa++)
            ld[Sa]();
        } finally {
          Z._updating = yo;
        }
      }
      var Xg = Z._updates;
      if (Xg.length !== 0) {
        let yo = Xg.shift();
        if (yo) {
          let [Sa, Ni] = yo;
          Qe(Z, Sa, Ni);
        }
      }
    }
  }
  function Ie(Z, B, K, ...ue) {
    let fe = B._updating;
    B._updating = K;
    try {
      let ke = Array.from(B._listeners[Z]);
      for (Z = 0; Z < ke.length; Z++)
        ke[Z].apply(null, ue);
    } finally {
      B._updating = fe;
    }
  }
  function Ae(Z, B, K) {
    if (Z._updating === !1 || Ii !== Z) {
      let ke = !1;
      return Z.update(() => {
        ke = Ae(Z, B, K);
      }), ke;
    }
    let ue = $n(Z);
    for (let ke = 4; 0 <= ke; ke--)
      for (let Ee = 0; Ee < ue.length; Ee++) {
        var fe = ue[Ee]._commands.get(B);
        if (fe !== void 0 && (fe = fe[ke], fe !== void 0)) {
          fe = Array.from(fe);
          let qe = fe.length;
          for (let ot = 0; ot < qe; ot++)
            if (fe[ot](K, Z) === !0)
              return !0;
        }
      }
    return !1;
  }
  function Ge(Z, B) {
    let K = Z._updates;
    for (B = B || !1; K.length !== 0; ) {
      var ue = K.shift();
      if (ue) {
        let [fe, ke] = ue, Ee;
        ke !== void 0 && (ue = ke.onUpdate, Ee = ke.tag, ke.skipTransforms && (B = !0), ue && Z._deferred.push(ue), Ee && Z._updateTags.add(Ee)), fe();
      }
    }
    return B;
  }
  function Qe(Z, B, K) {
    let ue = Z._updateTags;
    var fe, ke = fe = !1;
    if (K !== void 0) {
      var Ee = K.onUpdate;
      fe = K.tag, fe != null && ue.add(fe), fe = K.skipTransforms || !1, ke = K.discrete || !1;
    }
    Ee && Z._deferred.push(Ee), K = Z._editorState, Ee = Z._pendingEditorState;
    let qe = !1;
    (Ee === null || Ee._readOnly) && (Ee = Z._pendingEditorState = new fc(new Map((Ee || K)._nodeMap)), qe = !0), Ee._flushSync = ke, ke = fr;
    let ot = Fa, $t = Ii, Vt = Z._updating;
    fr = Ee, Fa = !1, Z._updating = !0, Ii = Z;
    try {
      qe && (Z._headless ? K._selection != null && (Ee._selection = K._selection.clone()) : Ee._selection = id(Z));
      let Mt = Z._compositionKey;
      B(), fe = Ge(Z, fe), Xc(Ee, Z), Z._dirtyType !== 0 && (fe ? mm(Ee, Z) : fm(Ee, Z), Ge(Z), ya(K, Ee, Z._dirtyLeaves, Z._dirtyElements)), Mt !== Z._compositionKey && (Ee._flushSync = !0);
      let zt = Ee._selection;
      if (po(zt)) {
        let Rt = Ee._nodeMap, Sn = zt.focus.key;
        Rt.get(zt.anchor.key) !== void 0 && Rt.get(Sn) !== void 0 || z(19);
      } else
        uu(zt) && zt._nodes.size === 0 && (Ee._selection = null);
    } catch (Mt) {
      Mt instanceof Error && Z._onError(Mt), Z._pendingEditorState = K, Z._dirtyType = 2, Z._cloneNotNeeded.clear(), Z._dirtyLeaves = /* @__PURE__ */ new Set(), Z._dirtyElements.clear(), Se(Z);
      return;
    } finally {
      fr = ke, Fa = ot, Ii = $t, Z._updating = Vt, Xa = 0;
    }
    Z._dirtyType !== 0 || no(Ee, Z) ? Ee._flushSync ? (Ee._flushSync = !1, Se(Z)) : qe && Pe(() => {
      Se(Z);
    }) : (Ee._flushSync = !1, qe && (ue.clear(), Z._deferred = [], Z._pendingEditorState = null));
  }
  function gt(Z, B, K) {
    Z._updating ? Z._updates.push([B, K]) : Qe(Z, B, K);
  }
  class Nt extends wa {
    constructor(B) {
      super(B);
    }
    decorate() {
      z(47);
    }
    isIsolated() {
      return !1;
    }
    isInline() {
      return !0;
    }
    isKeyboardSelectable() {
      return !0;
    }
  }
  function Ct(Z) {
    return Z instanceof Nt;
  }
  class Be extends wa {
    constructor(B) {
      super(B), this.__last = this.__first = null, this.__indent = this.__format = this.__size = 0, this.__dir = null;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getFormatType() {
      let B = this.getFormat();
      return me[B] || "";
    }
    getIndent() {
      return this.getLatest().__indent;
    }
    getChildren() {
      let B = [], K = this.getFirstChild();
      for (; K !== null; )
        B.push(K), K = K.getNextSibling();
      return B;
    }
    getChildrenKeys() {
      let B = [], K = this.getFirstChild();
      for (; K !== null; )
        B.push(K.__key), K = K.getNextSibling();
      return B;
    }
    getChildrenSize() {
      return this.getLatest().__size;
    }
    isEmpty() {
      return this.getChildrenSize() === 0;
    }
    isDirty() {
      let B = Do()._dirtyElements;
      return B !== null && B.has(this.__key);
    }
    isLastChild() {
      let B = this.getLatest(), K = this.getParentOrThrow().getLastChild();
      return K !== null && K.is(B);
    }
    getAllTextNodes() {
      let B = [], K = this.getFirstChild();
      for (; K !== null; ) {
        if (Vn(K) && B.push(K), We(K)) {
          let ue = K.getAllTextNodes();
          B.push(...ue);
        }
        K = K.getNextSibling();
      }
      return B;
    }
    getFirstDescendant() {
      let B = this.getFirstChild();
      for (; B !== null; ) {
        if (We(B)) {
          let K = B.getFirstChild();
          if (K !== null) {
            B = K;
            continue;
          }
        }
        break;
      }
      return B;
    }
    getLastDescendant() {
      let B = this.getLastChild();
      for (; B !== null; ) {
        if (We(B)) {
          let K = B.getLastChild();
          if (K !== null) {
            B = K;
            continue;
          }
        }
        break;
      }
      return B;
    }
    getDescendantByIndex(B) {
      let K = this.getChildren(), ue = K.length;
      return B >= ue ? (B = K[ue - 1], We(B) && B.getLastDescendant() || B || null) : (B = K[B], We(B) && B.getFirstDescendant() || B || null);
    }
    getFirstChild() {
      let B = this.getLatest().__first;
      return B === null ? null : Dn(B);
    }
    getFirstChildOrThrow() {
      let B = this.getFirstChild();
      return B === null && z(45), B;
    }
    getLastChild() {
      let B = this.getLatest().__last;
      return B === null ? null : Dn(B);
    }
    getLastChildOrThrow() {
      let B = this.getLastChild();
      return B === null && z(96), B;
    }
    getChildAtIndex(B) {
      var K = this.getChildrenSize();
      let ue;
      if (B < K / 2) {
        for (ue = this.getFirstChild(), K = 0; ue !== null && K <= B; ) {
          if (K === B)
            return ue;
          ue = ue.getNextSibling(), K++;
        }
        return null;
      }
      for (ue = this.getLastChild(), --K; ue !== null && K >= B; ) {
        if (K === B)
          return ue;
        ue = ue.getPreviousSibling(), K--;
      }
      return null;
    }
    getTextContent() {
      let B = "", K = this.getChildren(), ue = K.length;
      for (let fe = 0; fe < ue; fe++) {
        let ke = K[fe];
        B += ke.getTextContent(), We(ke) && fe !== ue - 1 && !ke.isInline() && (B += `

`);
      }
      return B;
    }
    getTextContentSize() {
      let B = 0, K = this.getChildren(), ue = K.length;
      for (let fe = 0; fe < ue; fe++) {
        let ke = K[fe];
        B += ke.getTextContentSize(), We(ke) && fe !== ue - 1 && !ke.isInline() && (B += 2);
      }
      return B;
    }
    getDirection() {
      return this.getLatest().__dir;
    }
    hasFormat(B) {
      return B !== "" ? (B = Q[B], (this.getFormat() & B) !== 0) : !1;
    }
    select(B, K) {
      Jr();
      let ue = To(), fe = B, ke = K;
      var Ee = this.getChildrenSize();
      if (!this.canBeEmpty()) {
        if (B === 0 && K === 0) {
          if (B = this.getFirstChild(), Vn(B) || We(B))
            return B.select(0, 0);
        } else if (!(B !== void 0 && B !== Ee || K !== void 0 && K !== Ee) && (B = this.getLastChild(), Vn(B) || We(B)))
          return B.select();
      }
      if (fe === void 0 && (fe = Ee), ke === void 0 && (ke = Ee), Ee = this.__key, po(ue))
        ue.anchor.set(Ee, fe, "element"), ue.focus.set(Ee, ke, "element"), ue.dirty = !0;
      else
        return Il(Ee, fe, Ee, ke, "element", "element");
      return ue;
    }
    selectStart() {
      let B = this.getFirstDescendant();
      return We(B) || Vn(B) ? B.select(0, 0) : B !== null ? B.selectPrevious() : this.select(0, 0);
    }
    selectEnd() {
      let B = this.getLastDescendant();
      return We(B) || Vn(B) ? B.select() : B !== null ? B.selectNext() : this.select();
    }
    clear() {
      let B = this.getWritable();
      return this.getChildren().forEach((K) => K.remove()), B;
    }
    append(...B) {
      return this.splice(
        this.getChildrenSize(),
        0,
        B
      );
    }
    setDirection(B) {
      let K = this.getWritable();
      return K.__dir = B, K;
    }
    setFormat(B) {
      return this.getWritable().__format = B !== "" ? Q[B] : 0, this;
    }
    setIndent(B) {
      return this.getWritable().__indent = B, this;
    }
    splice(B, K, ue) {
      let fe = ue.length, ke = this.getChildrenSize(), Ee = this.getWritable(), qe = Ee.__key;
      var ot = [], $t = [];
      let Vt = this.getChildAtIndex(B + K), Mt = null, zt = ke - K + fe;
      if (B !== 0)
        if (B === ke)
          Mt = this.getLastChild();
        else {
          var Rt = this.getChildAtIndex(B);
          Rt !== null && (Mt = Rt.getPreviousSibling());
        }
      if (0 < K) {
        var Sn = Mt === null ? this.getFirstChild() : Mt.getNextSibling();
        for (Rt = 0; Rt < K; Rt++) {
          Sn === null && z(100);
          var Cn = Sn.getNextSibling(), ro = Sn.__key;
          Sn = Sn.getWritable(), Ft(Sn), $t.push(ro), Sn = Cn;
        }
      }
      for (Rt = Mt, Cn = 0; Cn < fe; Cn++) {
        ro = ue[Cn], Rt !== null && ro.is(Rt) && (Mt = Rt = Rt.getPreviousSibling()), Sn = ro.getWritable(), Sn.__parent === qe && zt--, Ft(Sn);
        let Uo = ro.__key;
        Rt === null ? (Ee.__first = Uo, Sn.__prev = null) : (Rt = Rt.getWritable(), Rt.__next = Uo, Sn.__prev = Rt.__key), ro.__key === qe && z(76), Sn.__parent = qe, ot.push(Uo), Rt = ro;
      }
      if (B + K === ke ? Rt !== null && (Rt.getWritable().__next = null, Ee.__last = Rt.__key) : Vt !== null && (B = Vt.getWritable(), Rt !== null ? (K = Rt.getWritable(), B.__prev = Rt.__key, K.__next = Vt.__key) : B.__prev = null), Ee.__size = zt, $t.length && (B = To(), po(B))) {
        $t = new Set($t), ot = new Set(ot);
        let { anchor: Uo, focus: Oi } = B;
        mt(Uo, $t, ot) && ad(Uo, Uo.getNode(), this, Mt, Vt), mt(Oi, $t, ot) && ad(Oi, Oi.getNode(), this, Mt, Vt), zt !== 0 || this.canBeEmpty() || cn(this) || this.remove();
      }
      return Ee;
    }
    exportJSON() {
      return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
    }
    insertNewAfter() {
      return null;
    }
    canInsertTab() {
      return !1;
    }
    canIndent() {
      return !0;
    }
    collapseAtStart() {
      return !1;
    }
    excludeFromCopy() {
      return !1;
    }
    canExtractContents() {
      return !0;
    }
    canReplaceWith() {
      return !0;
    }
    canInsertAfter() {
      return !0;
    }
    canBeEmpty() {
      return !0;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    isInline() {
      return !1;
    }
    isShadowRoot() {
      return !1;
    }
    canMergeWith() {
      return !1;
    }
    extractWithChild() {
      return !1;
    }
  }
  function We(Z) {
    return Z instanceof Be;
  }
  function mt(Z, B, K) {
    for (Z = Z.getNode(); Z; ) {
      let ue = Z.__key;
      if (B.has(ue) && !K.has(ue))
        return !0;
      Z = Z.getParent();
    }
    return !1;
  }
  class Gt extends Be {
    static getType() {
      return "root";
    }
    static clone() {
      return new Gt();
    }
    constructor() {
      super("root"), this.__cachedText = null;
    }
    getTopLevelElementOrThrow() {
      z(51);
    }
    getTextContent() {
      let B = this.__cachedText;
      return !Bi() && Do()._dirtyType !== 0 || B === null ? super.getTextContent() : B;
    }
    remove() {
      z(52);
    }
    replace() {
      z(53);
    }
    insertBefore() {
      z(54);
    }
    insertAfter() {
      z(55);
    }
    updateDOM() {
      return !1;
    }
    append(...B) {
      for (let K = 0; K < B.length; K++) {
        let ue = B[K];
        We(ue) || Ct(ue) || z(56);
      }
      return super.append(...B);
    }
    static importJSON(B) {
      let K = qn();
      return K.setFormat(B.format), K.setIndent(B.indent), K.setDirection(B.direction), K;
    }
    exportJSON() {
      return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
    }
    collapseAtStart() {
      return !0;
    }
  }
  function on(Z) {
    return Z instanceof Gt;
  }
  function no(Z, B) {
    if (B = B.getEditorState()._selection, Z = Z._selection, Z !== null) {
      if (Z.dirty || !Z.is(B))
        return !0;
    } else if (B !== null)
      return !0;
    return !1;
  }
  function gr() {
    return new fc(/* @__PURE__ */ new Map([["root", new Gt()]]));
  }
  function Xo(Z) {
    let B = Z.exportJSON();
    B.type !== Z.constructor.getType() && z(58);
    let K = B.children;
    if (We(Z)) {
      Array.isArray(K) || z(59), Z = Z.getChildren();
      for (let ue = 0; ue < Z.length; ue++) {
        let fe = Xo(Z[ue]);
        K.push(fe);
      }
    }
    return B;
  }
  class fc {
    constructor(B, K) {
      this._nodeMap = B, this._selection = K || null, this._readOnly = this._flushSync = !1;
    }
    isEmpty() {
      return this._nodeMap.size === 1 && this._selection === null;
    }
    read(B) {
      return ce(this, B);
    }
    clone(B) {
      return B = new fc(this._nodeMap, B === void 0 ? this._selection : B), B._readOnly = !0, B;
    }
    toJSON() {
      return ce(this, () => ({ root: Xo(qn()) }));
    }
  }
  class o_ extends wa {
    static getType() {
      return "linebreak";
    }
    static clone(B) {
      return new o_(B.__key);
    }
    constructor(B) {
      super(B);
    }
    getTextContent() {
      return `
`;
    }
    createDOM() {
      return document.createElement("br");
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { br: (B) => {
        let K = B.parentElement;
        return K != null && K.firstChild === B && K.lastChild === B ? null : { conversion: gc, priority: 0 };
      } };
    }
    static importJSON() {
      return hc();
    }
    exportJSON() {
      return { type: "linebreak", version: 1 };
    }
  }
  function gc() {
    return { node: hc() };
  }
  function hc() {
    return ao(new o_());
  }
  function gm(Z) {
    return Z instanceof o_;
  }
  function vc(Z, B) {
    return B & 16 ? "code" : B & 128 ? "mark" : B & 32 ? "sub" : B & 64 ? "sup" : null;
  }
  function r_(Z, B) {
    return B & 1 ? "strong" : B & 2 ? "em" : "span";
  }
  function ap(Z, B, K, ue, fe) {
    Z = ue.classList, ue = ho(fe, "base"), ue !== void 0 && Z.add(...ue), ue = ho(fe, "underlineStrikethrough");
    let ke = !1, Ee = B & 8 && B & 4;
    var qe = K & 8 && K & 4;
    ue !== void 0 && (qe ? (ke = !0, Ee || Z.add(...ue)) : Ee && Z.remove(...ue));
    for (let ot in he)
      qe = he[ot], ue = ho(fe, ot), ue !== void 0 && (K & qe ? !ke || ot !== "underline" && ot !== "strikethrough" ? (!(B & qe) || Ee && ot === "underline" || ot === "strikethrough") && Z.add(...ue) : B & qe && Z.remove(...ue) : B & qe && Z.remove(...ue));
  }
  function yr(Z, B, K) {
    let ue = B.firstChild;
    if (K = K.isComposing(), Z += K ? Y : "", ue == null)
      B.textContent = Z;
    else if (B = ue.nodeValue, B !== Z)
      if (K || V) {
        K = B.length;
        let fe = Z.length, ke = 0, Ee = 0;
        for (; ke < K && ke < fe && B[ke] === Z[ke]; )
          ke++;
        for (; Ee + ke < K && Ee + ke < fe && B[K - Ee - 1] === Z[fe - Ee - 1]; )
          Ee++;
        Z = [ke, K - ke - Ee, Z.slice(ke, fe - Ee)];
        let [qe, ot, $t] = Z;
        ot !== 0 && ue.deleteData(qe, ot), ue.insertData(qe, $t);
      } else
        ue.nodeValue = Z;
  }
  function Df(Z, B) {
    return B = document.createElement(B), B.appendChild(Z), B;
  }
  class i_ extends wa {
    static getType() {
      return "text";
    }
    static clone(B) {
      return new i_(B.__text, B.__key);
    }
    constructor(B, K) {
      super(K), this.__text = B, this.__format = 0, this.__style = "", this.__detail = this.__mode = 0;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getDetail() {
      return this.getLatest().__detail;
    }
    getMode() {
      let B = this.getLatest();
      return pe[B.__mode];
    }
    getStyle() {
      return this.getLatest().__style;
    }
    isToken() {
      return this.getLatest().__mode === 1;
    }
    isComposing() {
      return this.__key === pn();
    }
    isSegmented() {
      return this.getLatest().__mode === 2;
    }
    isDirectionless() {
      return (this.getLatest().__detail & 1) !== 0;
    }
    isUnmergeable() {
      return (this.getLatest().__detail & 2) !== 0;
    }
    hasFormat(B) {
      return B = he[B], (this.getFormat() & B) !== 0;
    }
    isSimpleText() {
      return this.__type === "text" && this.__mode === 0;
    }
    getTextContent() {
      return this.getLatest().__text;
    }
    getFormatFlags(B, K) {
      let ue = this.getLatest().__format;
      return Je(ue, B, K);
    }
    createDOM(B) {
      var K = this.__format, ue = vc(this, K);
      let fe = r_(this, K), ke = document.createElement(ue === null ? fe : ue), Ee = ke;
      return ue !== null && (Ee = document.createElement(fe), ke.appendChild(Ee)), ue = Ee, yr(this.__text, ue, this), B = B.theme.text, B !== void 0 && ap(fe, 0, K, ue, B), K = this.__style, K !== "" && (ke.style.cssText = K), ke;
    }
    updateDOM(B, K, ue) {
      let fe = this.__text;
      var ke = B.__format, Ee = this.__format, qe = vc(this, ke);
      let ot = vc(this, Ee);
      var $t = r_(this, ke);
      let Vt = r_(this, Ee);
      return (qe === null ? $t : qe) !== (ot === null ? Vt : ot) ? !0 : qe === ot && $t !== Vt ? (ke = K.firstChild, ke == null && z(48), B = qe = document.createElement(Vt), yr(fe, B, this), ue = ue.theme.text, ue !== void 0 && ap(Vt, 0, Ee, B, ue), K.replaceChild(qe, ke), !1) : ($t = K, ot !== null && qe !== null && ($t = K.firstChild, $t == null && z(49)), yr(fe, $t, this), ue = ue.theme.text, ue !== void 0 && ke !== Ee && ap(Vt, ke, Ee, $t, ue), Ee = this.__style, B.__style !== Ee && (K.style.cssText = Ee), !1);
    }
    static importDOM() {
      return { "#text": () => ({ conversion: Wg, priority: 0 }), b: () => ({ conversion: _u, priority: 0 }), br: () => ({ conversion: Gg, priority: 0 }), code: () => ({ conversion: ka, priority: 0 }), em: () => ({ conversion: ka, priority: 0 }), i: () => ({ conversion: ka, priority: 0 }), s: () => ({ conversion: ka, priority: 0 }), span: () => ({ conversion: Lf, priority: 0 }), strong: () => ({ conversion: ka, priority: 0 }), sub: () => ({ conversion: ka, priority: 0 }), sup: () => ({
        conversion: ka,
        priority: 0
      }), u: () => ({ conversion: ka, priority: 0 }) };
    }
    static importJSON(B) {
      let K = ra(B.text);
      return K.setFormat(B.format), K.setDetail(B.detail), K.setMode(B.mode), K.setStyle(B.style), K;
    }
    exportDOM(B) {
      return { element: B } = super.exportDOM(B), B !== null && (this.hasFormat("bold") && (B = Df(B, "b")), this.hasFormat("italic") && (B = Df(B, "i")), this.hasFormat("strikethrough") && (B = Df(B, "s")), this.hasFormat("underline") && (B = Df(B, "u"))), { element: B };
    }
    exportJSON() {
      return {
        detail: this.getDetail(),
        format: this.getFormat(),
        mode: this.getMode(),
        style: this.getStyle(),
        text: this.getTextContent(),
        type: "text",
        version: 1
      };
    }
    selectionTransform() {
    }
    setFormat(B) {
      let K = this.getWritable();
      return K.__format = typeof B == "string" ? he[B] : B, K;
    }
    setDetail(B) {
      let K = this.getWritable();
      return K.__detail = typeof B == "string" ? be[B] : B, K;
    }
    setStyle(B) {
      let K = this.getWritable();
      return K.__style = B, K;
    }
    toggleFormat(B) {
      return B = he[B], this.setFormat(this.getFormat() ^ B);
    }
    toggleDirectionless() {
      let B = this.getWritable();
      return B.__detail ^= 1, B;
    }
    toggleUnmergeable() {
      let B = this.getWritable();
      return B.__detail ^= 2, B;
    }
    setMode(B) {
      if (B = ne[B], this.__mode === B)
        return this;
      let K = this.getWritable();
      return K.__mode = B, K;
    }
    setTextContent(B) {
      if (this.__text === B)
        return this;
      let K = this.getWritable();
      return K.__text = B, K;
    }
    select(B, K) {
      Jr();
      let ue = To();
      var fe = this.getTextContent();
      let ke = this.__key;
      if (typeof fe == "string" ? (fe = fe.length, B === void 0 && (B = fe), K === void 0 && (K = fe)) : K = B = 0, po(ue))
        fe = pn(), fe !== ue.anchor.key && fe !== ue.focus.key || un(ke), ue.setTextNodeRange(this, B, this, K);
      else
        return Il(ke, B, ke, K, "text", "text");
      return ue;
    }
    spliceText(B, K, ue, fe) {
      let ke = this.getWritable(), Ee = ke.__text, qe = ue.length, ot = B;
      0 > ot && (ot = qe + ot, 0 > ot && (ot = 0));
      let $t = To();
      return fe && po($t) && (B += qe, $t.setTextNodeRange(ke, B, ke, B)), K = Ee.slice(0, ot) + ue + Ee.slice(ot + K), ke.__text = K, ke;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    canContainTabs() {
      return !1;
    }
    splitText(...B) {
      Jr();
      var K = this.getLatest(), ue = K.getTextContent(), fe = K.__key, ke = pn(), Ee = new Set(B);
      B = [];
      for (var qe = ue.length, ot = "", $t = 0; $t < qe; $t++)
        ot !== "" && Ee.has($t) && (B.push(ot), ot = ""), ot += ue[$t];
      if (ot !== "" && B.push(ot), Ee = B.length, Ee === 0)
        return [];
      if (B[0] === ue)
        return [K];
      var Vt = B[0];
      ue = K.getParentOrThrow(), $t = K.getFormat();
      let Mt = K.getStyle(), zt = K.__detail;
      qe = !1, K.isSegmented() ? (ot = ra(Vt), ot.__format = $t, ot.__style = Mt, ot.__detail = zt, qe = !0) : (ot = K.getWritable(), ot.__text = Vt), K = To(), ot = [ot], Vt = Vt.length;
      for (let Cn = 1; Cn < Ee; Cn++) {
        var Rt = B[Cn], Sn = Rt.length;
        Rt = ra(Rt).getWritable(), Rt.__format = $t, Rt.__style = Mt, Rt.__detail = zt;
        let ro = Rt.__key;
        if (Sn = Vt + Sn, po(K)) {
          let Uo = K.anchor, Oi = K.focus;
          Uo.key === fe && Uo.type === "text" && Uo.offset > Vt && Uo.offset <= Sn && (Uo.key = ro, Uo.offset -= Vt, K.dirty = !0), Oi.key === fe && Oi.type === "text" && Oi.offset > Vt && Oi.offset <= Sn && (Oi.key = ro, Oi.offset -= Vt, K.dirty = !0);
        }
        ke === fe && un(ro), Vt = Sn, ot.push(Rt);
      }
      return fe = this.getPreviousSibling(), ke = this.getNextSibling(), fe !== null && wn(fe), ke !== null && wn(ke), fe = ue.getWritable(), ke = this.getIndexWithinParent(), qe ? (fe.splice(ke, 0, ot), this.remove()) : fe.splice(ke, 1, ot), po(K) && fa(K, ue, ke, Ee - 1), ot;
    }
    mergeWithSibling(B) {
      var K = B === this.getPreviousSibling();
      K || B === this.getNextSibling() || z(50);
      var ue = this.__key;
      let fe = B.__key, ke = this.__text, Ee = ke.length;
      pn() === fe && un(ue);
      let qe = To();
      if (po(qe)) {
        let ot = qe.anchor, $t = qe.focus;
        ot !== null && ot.key === fe && (sd(ot, K, ue, B, Ee), qe.dirty = !0), $t !== null && $t.key === fe && (sd($t, K, ue, B, Ee), qe.dirty = !0);
      }
      return ue = B.__text, this.setTextContent(K ? ue + ke : ke + ue), K = this.getWritable(), B.remove(), K;
    }
    isTextEntity() {
      return !1;
    }
  }
  function Lf(Z) {
    let B = Z.style.fontWeight === "700", K = Z.style.textDecoration === "line-through", ue = Z.style.fontStyle === "italic", fe = Z.style.textDecoration === "underline", ke = Z.style.verticalAlign;
    return { forChild: (Ee) => (Vn(Ee) && (B && Ee.toggleFormat("bold"), K && Ee.toggleFormat("strikethrough"), ue && Ee.toggleFormat("italic"), fe && Ee.toggleFormat("underline"), ke === "sub" && Ee.toggleFormat("subscript"), ke === "super" && Ee.toggleFormat("superscript")), Ee), node: null };
  }
  function Gg() {
    return { node: hc() };
  }
  function _u(Z) {
    let B = Z.style.fontWeight === "normal";
    return { forChild: (K) => (Vn(K) && !B && K.toggleFormat("bold"), K), node: null };
  }
  function Wg(Z, B, K) {
    return Z = Z.textContent || "", !K && /\n/.test(Z) && (Z = Z.replace(/\r?\n/gm, " "), Z.trim().length === 0) ? { node: null } : { node: ra(Z) };
  }
  let sp = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
  function ka(Z) {
    let B = sp[Z.nodeName.toLowerCase()];
    return B === void 0 ? { node: null } : { forChild: (K) => (Vn(K) && !K.hasFormat(B) && K.toggleFormat(B), K), node: null };
  }
  function ra(Z = "") {
    return ao(new i_(Z));
  }
  function Vn(Z) {
    return Z instanceof i_;
  }
  class Os extends Be {
    static getType() {
      return "paragraph";
    }
    static clone(B) {
      return new Os(B.__key);
    }
    createDOM(B) {
      let K = document.createElement("p");
      return B = ho(B.theme, "paragraph"), B !== void 0 && K.classList.add(...B), K;
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { p: () => ({ conversion: cp, priority: 0 }) };
    }
    exportDOM(B) {
      if ({ element: B } = super.exportDOM(B), B && this.isEmpty() && B.append(document.createElement("br")), B) {
        var K = this.getFormatType();
        B.style.textAlign = K, (K = this.getDirection()) && (B.dir = K), K = this.getIndent(), 0 < K && (B.style.textIndent = `${20 * K}px`);
      }
      return { element: B };
    }
    static importJSON(B) {
      let K = Nl();
      return K.setFormat(B.format), K.setIndent(B.indent), K.setDirection(B.direction), K;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "paragraph", version: 1 };
    }
    insertNewAfter(B, K) {
      B = Nl();
      let ue = this.getDirection();
      return B.setDirection(ue), this.insertAfter(B, K), B;
    }
    collapseAtStart() {
      let B = this.getChildren();
      if (B.length === 0 || Vn(B[0]) && B[0].getTextContent().trim() === "") {
        if (this.getNextSibling() !== null)
          return this.selectNext(), this.remove(), !0;
        if (this.getPreviousSibling() !== null)
          return this.selectPrevious(), this.remove(), !0;
      }
      return !1;
    }
  }
  function cp(Z) {
    let B = Nl();
    return Z.style && (B.setFormat(Z.style.textAlign), Z = parseInt(Z.style.textIndent, 10) / 20, 0 < Z && B.setIndent(Z)), { node: B };
  }
  function Nl() {
    return ao(new Os());
  }
  function a_(Z, B, K, ue) {
    let fe = Z._keyToDOMMap;
    fe.clear(), Z._editorState = gr(), Z._pendingEditorState = ue, Z._compositionKey = null, Z._dirtyType = 0, Z._cloneNotNeeded.clear(), Z._dirtyLeaves = /* @__PURE__ */ new Set(), Z._dirtyElements.clear(), Z._normalizedNodes = /* @__PURE__ */ new Set(), Z._updateTags = /* @__PURE__ */ new Set(), Z._updates = [], Z._blockCursorElement = null, ue = Z._observer, ue !== null && (ue.disconnect(), Z._observer = null), B !== null && (B.textContent = ""), K !== null && (K.textContent = "", fe.set("root", K));
  }
  function lp(Z) {
    let B = /* @__PURE__ */ new Map(), K = /* @__PURE__ */ new Set();
    return Z.forEach((ue) => {
      if (ue = ue.klass.importDOM != null ? ue.klass.importDOM.bind(ue.klass) : null, ue != null && !K.has(ue)) {
        K.add(ue);
        var fe = ue();
        fe !== null && Object.keys(fe).forEach((ke) => {
          let Ee = B.get(ke);
          Ee === void 0 && (Ee = [], B.set(ke, Ee)), Ee.push(fe[ke]);
        });
      }
    }), B;
  }
  class pu {
    constructor(B, K, ue, fe, ke, Ee) {
      this._parentEditor = K, this._rootElement = null, this._editorState = B, this._compositionKey = this._pendingEditorState = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = fe, this._nodes = ue, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = 0, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = uo(), this._onError = ke, this._htmlConversions = Ee, this._editable = !0, this._headless = K !== null && K._headless, this._blockCursorElement = this._window = null;
    }
    isComposing() {
      return this._compositionKey != null;
    }
    registerUpdateListener(B) {
      let K = this._listeners.update;
      return K.add(B), () => {
        K.delete(B);
      };
    }
    registerEditableListener(B) {
      let K = this._listeners.editable;
      return K.add(B), () => {
        K.delete(B);
      };
    }
    registerDecoratorListener(B) {
      let K = this._listeners.decorator;
      return K.add(B), () => {
        K.delete(B);
      };
    }
    registerTextContentListener(B) {
      let K = this._listeners.textcontent;
      return K.add(B), () => {
        K.delete(B);
      };
    }
    registerRootListener(B) {
      let K = this._listeners.root;
      return B(this._rootElement, null), K.add(B), () => {
        B(null, this._rootElement), K.delete(B);
      };
    }
    registerCommand(B, K, ue) {
      ue === void 0 && z(35);
      let fe = this._commands;
      fe.has(B) || fe.set(B, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
      let ke = fe.get(B);
      ke === void 0 && z(36);
      let Ee = ke[ue];
      return Ee.add(K), () => {
        Ee.delete(K), ke.every((qe) => qe.size === 0) && fe.delete(B);
      };
    }
    registerMutationListener(B, K) {
      this._nodes.get(B.getType()) === void 0 && z(37);
      let ue = this._listeners.mutation;
      return ue.set(K, B), () => {
        ue.delete(K);
      };
    }
    registerNodeTransformToKlass(B, K) {
      return B = B.getType(), B = this._nodes.get(B), B === void 0 && z(37), B.transforms.add(K), B;
    }
    registerNodeTransform(B, K) {
      var ue = this.registerNodeTransformToKlass(B, K);
      let fe = [ue];
      return ue = ue.replaceWithKlass, ue != null && (ue = this.registerNodeTransformToKlass(ue, K), fe.push(ue)), fn(this, B.getType()), () => {
        fe.forEach((ke) => ke.transforms.delete(K));
      };
    }
    hasNodes(B) {
      for (let K = 0; K < B.length; K++) {
        let ue = B[K].getType();
        if (!this._nodes.has(ue))
          return !1;
      }
      return !0;
    }
    dispatchCommand(B, K) {
      return Ae(this, B, K);
    }
    getDecorators() {
      return this._decorators;
    }
    getRootElement() {
      return this._rootElement;
    }
    getKey() {
      return this._key;
    }
    setRootElement(B) {
      let K = this._rootElement;
      if (B !== K) {
        let ke = ho(this._config.theme, "root");
        var ue = this._pendingEditorState || this._editorState;
        if (this._rootElement = B, a_(this, K, B, ue), K !== null) {
          if (!this._config.disableEvents) {
            if (mc !== 0 && (mc--, mc === 0 && K.ownerDocument.removeEventListener(
              "selectionchange",
              dm
            )), ue = K.__lexicalEditor, ue != null) {
              if (ue._parentEditor !== null) {
                var fe = $n(ue);
                fe = fe[fe.length - 1]._key, _o.get(fe) === ue && _o.delete(fe);
              } else
                _o.delete(ue._key);
              K.__lexicalEditor = null;
            }
            for (ue = rd(K), fe = 0; fe < ue.length; fe++)
              ue[fe]();
            K.__lexicalEventHandles = [];
          }
          ke != null && K.classList.remove(...ke);
        }
        B !== null ? (ue = (ue = B.ownerDocument) && ue.defaultView || null, fe = B.style, fe.userSelect = "text", fe.whiteSpace = "pre-wrap", fe.wordBreak = "break-word", B.setAttribute("data-lexical-editor", "true"), this._window = ue, this._dirtyType = 2, De(this), this._updateTags.add("history-merge"), Se(this), this._config.disableEvents || $a(B, this), ke != null && B.classList.add(...ke)) : this._window = null, Ie("root", this, !1, B, K);
      }
    }
    getElementByKey(B) {
      return this._keyToDOMMap.get(B) || null;
    }
    getEditorState() {
      return this._editorState;
    }
    setEditorState(B, K) {
      B.isEmpty() && z(38), st(this);
      let ue = this._pendingEditorState, fe = this._updateTags;
      K = K !== void 0 ? K.tag : null, ue === null || ue.isEmpty() || (K != null && fe.add(K), Se(this)), this._pendingEditorState = B, this._dirtyType = 2, this._dirtyElements.set(
        "root",
        !1
      ), this._compositionKey = null, K != null && fe.add(K), Se(this);
    }
    parseEditorState(B, K) {
      B = typeof B == "string" ? JSON.parse(B) : B;
      let ue = gr(), fe = fr, ke = Fa, Ee = Ii, qe = this._dirtyElements, ot = this._dirtyLeaves, $t = this._cloneNotNeeded, Vt = this._dirtyType;
      this._dirtyElements = /* @__PURE__ */ new Map(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyType = 0, fr = ue, Fa = !1, Ii = this;
      try {
        G(B.root, this._nodes), K && K(), ue._readOnly = !0;
      } catch (Mt) {
        Mt instanceof Error && this._onError(Mt);
      } finally {
        this._dirtyElements = qe, this._dirtyLeaves = ot, this._cloneNotNeeded = $t, this._dirtyType = Vt, fr = fe, Fa = ke, Ii = Ee;
      }
      return ue;
    }
    update(B, K) {
      gt(this, B, K);
    }
    focus(B, K = {}) {
      let ue = this._rootElement;
      ue !== null && (ue.setAttribute("autocapitalize", "off"), gt(this, () => {
        let fe = To(), ke = qn();
        fe !== null ? fe.dirty = !0 : ke.getChildrenSize() !== 0 && (K.defaultSelection === "rootStart" ? ke.selectStart() : ke.selectEnd());
      }, { onUpdate: () => {
        ue.removeAttribute("autocapitalize"), B && B();
      }, tag: "focus" }), this._pendingEditorState === null && ue.removeAttribute("autocapitalize"));
    }
    blur() {
      var B = this._rootElement;
      B !== null && B.blur(), B = xn(this._window), B !== null && B.removeAllRanges();
    }
    isEditable() {
      return this._editable;
    }
    setEditable(B) {
      this._editable !== B && (this._editable = B, Ie("editable", this, !0, B));
    }
    toJSON() {
      return { editorState: this._editorState.toJSON() };
    }
  }
  class zl extends Be {
    constructor(B, K) {
      super(K), this.__colSpan = B, this.__rowSpan = 1;
    }
    exportJSON() {
      return { ...super.exportJSON(), colSpan: this.__colSpan };
    }
    setColSpan(B) {
      return this.getWritable().__colSpan = B, this;
    }
    setRowSpan(B) {
      return this.getWritable().__rowSpan = B, this;
    }
  }
  function Ns(Z) {
    return Z instanceof zl;
  }
  class Hg extends Be {
  }
  function Mf(Z) {
    return Z instanceof Hg;
  }
  class qv extends Be {
  }
  function cd(Z) {
    return Z instanceof qv;
  }
  return en.$addUpdateTag = function(Z) {
    Jr(), Do()._updateTags.add(Z);
  }, en.$applyNodeReplacement = ao, en.$copyNode = sn, en.$createLineBreakNode = hc, en.$createNodeSelection = rp, en.$createParagraphNode = Nl, en.$createRangeSelection = function() {
    let Z = new ta("root", 0, "element"), B = new ta("root", 0, "element");
    return new Er(Z, B, 0, "");
  }, en.$createTextNode = ra, en.$getAdjacentNode = an, en.$getNearestNodeFromDOMNode = Ln, en.$getNearestRootOrShadowRoot = Pt, en.$getNodeByKey = Dn, en.$getPreviousSelection = Na, en.$getRoot = qn, en.$getSelection = To, en.$getTextContent = function() {
    let Z = To();
    return Z === null ? "" : Z.getTextContent();
  }, en.$hasAncestor = kn, en.$insertNodes = function(Z, B) {
    let K = To();
    return K === null && (K = qn().selectEnd()), K.insertNodes(Z, B);
  }, en.$isDecoratorNode = Ct, en.$isElementNode = We, en.$isInlineElementOrDecoratorNode = function(Z) {
    return We(Z) && Z.isInline() || Ct(Z) && Z.isInline();
  }, en.$isLeafNode = vt, en.$isLineBreakNode = gm, en.$isNodeSelection = uu, en.$isParagraphNode = function(Z) {
    return Z instanceof Os;
  }, en.$isRangeSelection = po, en.$isRootNode = on, en.$isRootOrShadowRoot = cn, en.$isTextNode = Vn, en.$nodesOfType = function(Z) {
    var B = oa();
    let K = B._readOnly, ue = Z.getType();
    B = B._nodeMap;
    let fe = [];
    for (let [, ke] of B)
      ke instanceof Z && ke.__type === ue && (K || ke.isAttached()) && fe.push(ke);
    return fe;
  }, en.$normalizeSelection__EXPERIMENTAL = Q_, en.$parseSerializedNode = function(Z) {
    return G(Z, Do()._nodes);
  }, en.$setCompositionKey = un, en.$setSelection = Xn, en.$splitNode = It, en.BLUR_COMMAND = k, en.CAN_REDO_COMMAND = {}, en.CAN_UNDO_COMMAND = {}, en.CLEAR_EDITOR_COMMAND = {}, en.CLEAR_HISTORY_COMMAND = {}, en.CLICK_COMMAND = t, en.COMMAND_PRIORITY_CRITICAL = 4, en.COMMAND_PRIORITY_EDITOR = 0, en.COMMAND_PRIORITY_HIGH = 3, en.COMMAND_PRIORITY_LOW = 1, en.COMMAND_PRIORITY_NORMAL = 2, en.CONTROLLED_TEXT_INSERTION_COMMAND = i, en.COPY_COMMAND = S, en.CUT_COMMAND = E, en.DELETE_CHARACTER_COMMAND = n, en.DELETE_LINE_COMMAND = l, en.DELETE_WORD_COMMAND = c, en.DEPRECATED_$computeGridMap = Xs, en.DEPRECATED_$createGridSelection = function() {
    let Z = new ta("root", 0, "element"), B = new ta("root", 0, "element");
    return new Zc("root", Z, B);
  }, en.DEPRECATED_$getNodeTriplet = function(Z) {
    if (!(Z instanceof zl)) {
      if (Z instanceof wa) {
        if (Z = Jn(Z, Ns), !Ns(Z))
          throw Error("Expected to find a parent GridCellNode");
      } else if (Z = Jn(Z.getNode(), Ns), !Ns(Z))
        throw Error("Expected to find a parent GridCellNode");
    }
    let B = Z.getParent();
    if (!cd(B))
      throw Error("Expected GridCellNode to have a parent GridRowNode");
    let K = B.getParent();
    if (!Mf(K))
      throw Error("Expected GridRowNode to have a parent GridNode");
    return [Z, B, K];
  }, en.DEPRECATED_$isGridCellNode = Ns, en.DEPRECATED_$isGridNode = Mf, en.DEPRECATED_$isGridRowNode = cd, en.DEPRECATED_$isGridSelection = _m, en.DEPRECATED_GridCellNode = zl, en.DEPRECATED_GridNode = Hg, en.DEPRECATED_GridRowNode = qv, en.DRAGEND_COMMAND = A, en.DRAGOVER_COMMAND = D, en.DRAGSTART_COMMAND = T, en.DROP_COMMAND = R, en.DecoratorNode = Nt, en.ElementNode = Be, en.FOCUS_COMMAND = x, en.FORMAT_ELEMENT_COMMAND = {}, en.FORMAT_TEXT_COMMAND = u, en.INDENT_CONTENT_COMMAND = {}, en.INSERT_LINE_BREAK_COMMAND = o, en.INSERT_PARAGRAPH_COMMAND = r, en.KEY_ARROW_DOWN_COMMAND = b, en.KEY_ARROW_LEFT_COMMAND = h, en.KEY_ARROW_RIGHT_COMMAND = g, en.KEY_ARROW_UP_COMMAND = v, en.KEY_BACKSPACE_COMMAND = N, en.KEY_DELETE_COMMAND = q, en.KEY_DOWN_COMMAND = p, en.KEY_ENTER_COMMAND = y, en.KEY_ESCAPE_COMMAND = M, en.KEY_MODIFIER_COMMAND = I, en.KEY_SPACE_COMMAND = w, en.KEY_TAB_COMMAND = L, en.LineBreakNode = o_, en.MOVE_TO_END = f, en.MOVE_TO_START = $, en.OUTDENT_CONTENT_COMMAND = {}, en.PASTE_COMMAND = a, en.ParagraphNode = Os, en.REDO_COMMAND = _, en.REMOVE_TEXT_COMMAND = s, en.RootNode = Gt, en.SELECTION_CHANGE_COMMAND = e, en.TextNode = i_, en.UNDO_COMMAND = d, en.createCommand = function() {
    return {};
  }, en.createEditor = function(Z) {
    var B = Z || {}, K = Ii, ue = B.theme || {};
    let fe = Z === void 0 ? K : B.parentEditor || null, ke = B.disableEvents || !1, Ee = gr(), qe = B.namespace || (fe !== null ? fe._config.namespace : uo()), ot = B.editorState, $t = [Gt, i_, o_, Os, ...B.nodes || []], Vt = B.onError;
    if (B = B.editable !== void 0 ? B.editable : !0, Z === void 0 && K !== null)
      Z = K._nodes;
    else
      for (Z = /* @__PURE__ */ new Map(), K = 0; K < $t.length; K++) {
        let zt = $t[K], Rt = null;
        var Mt = null;
        typeof zt != "function" && (Mt = zt, zt = Mt.replace, Rt = Mt.with, Mt = Mt.withKlass ? Mt.withKlass : null);
        let Sn = zt.getType(), Cn = zt.transform(), ro = /* @__PURE__ */ new Set();
        Cn !== null && ro.add(Cn), Z.set(Sn, { klass: zt, replace: Rt, replaceWithKlass: Mt, transforms: ro });
      }
    return ue = new pu(Ee, fe, Z, { disableEvents: ke, namespace: qe, theme: ue }, Vt || console.error, lp(Z), B), ot !== void 0 && (ue._pendingEditorState = ot, ue._dirtyType = 2), ue;
  }, en.getNearestEditorFromDOMNode = Xe, en.isSelectionWithinEditor = He, en;
}
var tn = {}, HX;
function SHl() {
  if (HX)
    return tn;
  HX = 1;
  function e(te) {
    return {
      type: te
    };
  }
  const t = e("SELECTION_CHANGE_COMMAND"), n = e("CLICK_COMMAND"), o = e("DELETE_CHARACTER_COMMAND"), r = e("INSERT_LINE_BREAK_COMMAND"), i = e("INSERT_PARAGRAPH_COMMAND"), a = e("CONTROLLED_TEXT_INSERTION_COMMAND"), s = e("PASTE_COMMAND"), c = e("REMOVE_TEXT_COMMAND"), l = e("DELETE_WORD_COMMAND"), u = e("DELETE_LINE_COMMAND"), d = e("FORMAT_TEXT_COMMAND"), _ = e("UNDO_COMMAND"), p = e("REDO_COMMAND"), g = e("KEYDOWN_COMMAND"), f = e("KEY_ARROW_RIGHT_COMMAND"), h = e("MOVE_TO_END"), $ = e("KEY_ARROW_LEFT_COMMAND"), v = e("MOVE_TO_START"), b = e("KEY_ARROW_UP_COMMAND"), y = e("KEY_ARROW_DOWN_COMMAND"), w = e("KEY_ENTER_COMMAND"), N = e("KEY_SPACE_COMMAND"), M = e("KEY_BACKSPACE_COMMAND"), q = e("KEY_ESCAPE_COMMAND"), L = e("KEY_DELETE_COMMAND"), R = e("KEY_TAB_COMMAND"), T = e("INDENT_CONTENT_COMMAND"), D = e("OUTDENT_CONTENT_COMMAND"), A = e("DROP_COMMAND"), S = e("FORMAT_ELEMENT_COMMAND"), E = e("DRAGSTART_COMMAND"), x = e("DRAGOVER_COMMAND"), k = e("DRAGEND_COMMAND"), I = e("COPY_COMMAND"), z = e("CUT_COMMAND"), F = e("CLEAR_EDITOR_COMMAND"), P = e("CLEAR_HISTORY_COMMAND"), O = e("CAN_REDO_COMMAND"), V = e("CAN_UNDO_COMMAND"), U = e("FOCUS_COMMAND"), H = e("BLUR_COMMAND"), J = e("KEY_MODIFIER_COMMAND"), le = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ae = le && "documentMode" in document ? document.documentMode : null, Y = le && /Mac|iPod|iPhone|iPad/.test(navigator.platform), re = le && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), ie = le && "InputEvent" in window && !ae ? "getTargetRanges" in new window.InputEvent("input") : !1, _e = le && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), he = le && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, be = le && /^(?=.*Chrome).*/i.test(navigator.userAgent), Q = le && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !be, me = 1, ne = 3, pe = 0, ge = 1, ve = 2, Te = 0, Re = 1, Me = 2, et = 1, st = 2, De = 4, ze = 8, Pe = 16, je = 32, He = 64, Xe = 128, at = et | st | De | ze | Pe | je | He | Xe, wt = 1, Je = 2, vt = 1, Ot = 2, Ft = 3, wn = 4, un = 5, pn = 6, Dn = " ", Ln = _e || he || Q ? Dn : "​", Yn = `

`, Qt = re ? Dn : Ln, fn = "֑-߿יִ-﷽ﹰ-ﻼ", qn = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", Xn = new RegExp("^[^" + qn + "]*[" + fn + "]"), Qn = new RegExp("^[^" + fn + "]*[" + qn + "]"), In = {
    bold: et,
    code: Pe,
    highlight: Xe,
    italic: st,
    strikethrough: De,
    subscript: je,
    superscript: He,
    underline: ze
  }, $n = {
    directionless: wt,
    unmergeable: Je
  }, uo = {
    center: Ot,
    end: pn,
    justify: wn,
    left: vt,
    right: Ft,
    start: un
  }, go = {
    [Ot]: "center",
    [pn]: "end",
    [wn]: "justify",
    [vt]: "left",
    [Ft]: "right",
    [un]: "start"
  }, Rr = {
    normal: Te,
    segmented: Me,
    token: Re
  }, qo = {
    [Te]: "normal",
    [Me]: "segmented",
    [Re]: "token"
  }, ho = 100;
  let Ut = !1, Kt = 0;
  function an() {
    return Ut;
  }
  function Gn(te) {
    Kt = te.timeStamp;
  }
  function An(te) {
    Kt === 0 && As(te).addEventListener("textInput", Gn, !0);
  }
  function hn(te, W, X) {
    return (
      // @ts-expect-error: internal field
      W.__lexicalLineBreak === te || // @ts-ignore We intentionally add this to the Node.
      te[`__lexicalKey_${X._key}`] !== void 0
    );
  }
  function zn(te) {
    return te.getEditorState().read(() => {
      const W = yo();
      return W !== null ? W.clone() : null;
    });
  }
  function gn(te, W, X) {
    const se = Na(X._window);
    let ye = null, we = null;
    se !== null && se.anchorNode === te && (ye = se.anchorOffset, we = se.focusOffset);
    const Ce = te.nodeValue;
    Ce !== null && tp(W, Ce, ye, we, !1);
  }
  function kn(te, W, X) {
    if (so(te)) {
      const se = te.anchor.getNode();
      if (se.is(X) && te.format !== se.getFormat())
        return !1;
    }
    return W.nodeType === ne && X.isAttached();
  }
  function dt(te, W, X) {
    Ut = !0;
    const se = performance.now() - Kt > ho;
    try {
      wc(te, () => {
        const ye = yo() || zn(te), we = /* @__PURE__ */ new Map(), Ce = te.getRootElement(), Oe = te._editorState, Ye = te._blockCursorElement;
        let Ke = !1, rt = "";
        for (let _t = 0; _t < W.length; _t++) {
          const ct = W[_t], Lt = ct.type, St = ct.target;
          let jt = Hc(St, Oe);
          if (!(jt === null && St !== Ce || hi(jt))) {
            if (Lt === "characterData")
              se && Wn(jt) && kn(ye, St, jt) && gn(
                // nodeType === DOM_TEXT_TYPE is a Text DOM node
                St,
                jt,
                te
              );
            else if (Lt === "childList") {
              Ke = !0;
              const bn = ct.addedNodes;
              for (let $o = 0; $o < bn.length; $o++) {
                const eo = bn[$o], mo = Gd(eo), to = eo.parentNode;
                if (to != null && eo !== Ye && mo === null && (eo.nodeName !== "BR" || !hn(eo, to, te))) {
                  if (re) {
                    const Go = eo.innerText || eo.nodeValue;
                    Go && (rt += Go);
                  }
                  to.removeChild(eo);
                }
              }
              const Ht = ct.removedNodes, ln = Ht.length;
              if (ln > 0) {
                let $o = 0;
                for (let eo = 0; eo < ln; eo++) {
                  const mo = Ht[eo];
                  (mo.nodeName === "BR" && hn(mo, St, te) || Ye === mo) && (St.appendChild(mo), $o++);
                }
                ln !== $o && (St === Ce && (jt = _c(Oe)), we.set(St, jt));
              }
            }
          }
        }
        if (we.size > 0)
          for (const [_t, ct] of we)
            if (dn(ct)) {
              const Lt = ct.getChildrenKeys();
              let St = _t.firstChild;
              for (let jt = 0; jt < Lt.length; jt++) {
                const bn = Lt[jt], Ht = te.getElementByKey(bn);
                Ht !== null && (St == null ? (_t.appendChild(Ht), St = Ht) : St !== Ht && _t.replaceChild(Ht, St), St = St.nextSibling);
              }
            } else
              Wn(ct) && ct.markDirty();
        const ut = X.takeRecords();
        if (ut.length > 0) {
          for (let _t = 0; _t < ut.length; _t++) {
            const ct = ut[_t], Lt = ct.addedNodes, St = ct.target;
            for (let jt = 0; jt < Lt.length; jt++) {
              const bn = Lt[jt], Ht = bn.parentNode;
              Ht != null && bn.nodeName === "BR" && !hn(bn, St, te) && Ht.removeChild(bn);
            }
          }
          X.takeRecords();
        }
        ye !== null && (Ke && (ye.dirty = !0, Co(ye)), re && Zo(te) && ye.insertRawText(rt));
      });
    } finally {
      Ut = !1;
    }
  }
  function Pt(te) {
    const W = te._observer;
    if (W !== null) {
      const X = W.takeRecords();
      dt(te, X, W);
    }
  }
  function cn(te) {
    An(te), te._observer = new MutationObserver((W, X) => {
      dt(te, W, X);
    });
  }
  let sn = 1;
  function ao() {
    return "" + sn++;
  }
  function Ze(te, W) {
    const X = te._nodes.get(W);
    if (X === void 0)
      throw Error(`registeredNode: Type ${W} not found`);
    return X;
  }
  const bt = typeof queueMicrotask == "function" ? queueMicrotask : (te) => {
    Promise.resolve().then(te);
  };
  function Wt(te) {
    return hi(Hc(te));
  }
  function xn(te) {
    const W = document.activeElement;
    if (W === null)
      return !1;
    const X = W.nodeName;
    return hi(Hc(te)) && (X === "INPUT" || X === "TEXTAREA" || W.contentEditable === "true" && // @ts-ignore iternal field
    W.__lexicalEditor == null);
  }
  function It(te, W, X) {
    const se = te.getRootElement();
    try {
      return se !== null && se.contains(W) && se.contains(X) && // Ignore if selection is within nested editor
      W !== null && !xn(W) && Jn(W) === te;
    } catch {
      return !1;
    }
  }
  function Jn(te) {
    let W = te;
    for (; W != null; ) {
      const X = W.__lexicalEditor;
      if (X != null)
        return X;
      W = Zc(W);
    }
    return null;
  }
  function ur(te) {
    return Xn.test(te) ? "rtl" : Qn.test(te) ? "ltr" : null;
  }
  function er(te) {
    return te.isToken() || te.isSegmented();
  }
  function ya(te) {
    return te.nodeType === ne;
  }
  function Ai(te) {
    let W = te;
    for (; W != null; ) {
      if (ya(W))
        return W;
      W = W.firstChild;
    }
    return null;
  }
  function Ka(te, W, X) {
    const se = In[W];
    return te & se && (X === null || !(X & se)) ? te ^ se : X === null || X & se ? te | se : te;
  }
  function Wc(te) {
    return Wn(te) || oh(te) || hi(te);
  }
  function Q_(te, W) {
    if (W != null) {
      te.__key = W;
      return;
    }
    _s(), k1();
    const X = Yi(), se = Ja(), ye = ao();
    se._nodeMap.set(ye, te), dn(te) ? X._dirtyElements.set(ye, !0) : X._dirtyLeaves.add(ye), X._cloneNotNeeded.add(ye), X._dirtyType = ge, te.__key = ye;
  }
  function cm(te, W, X) {
    let se = te;
    for (; se !== null; ) {
      if (X.has(se))
        return;
      const ye = W.get(se);
      if (ye === void 0)
        break;
      X.set(se, !1), se = ye.__parent;
    }
  }
  function Pr(te) {
    const W = te.getParent();
    if (W !== null) {
      const X = te.getWritable(), se = W.getWritable(), ye = te.getPreviousSibling(), we = te.getNextSibling();
      if (ye === null)
        if (we !== null) {
          const Ce = we.getWritable();
          se.__first = we.__key, Ce.__prev = null;
        } else
          se.__first = null;
      else {
        const Ce = ye.getWritable();
        if (we !== null) {
          const Oe = we.getWritable();
          Oe.__prev = Ce.__key, Ce.__next = Oe.__key;
        } else
          Ce.__next = null;
        X.__prev = null;
      }
      if (we === null)
        if (ye !== null) {
          const Ce = ye.getWritable();
          se.__last = ye.__key, Ce.__next = null;
        } else
          se.__last = null;
      else {
        const Ce = we.getWritable();
        if (ye !== null) {
          const Oe = ye.getWritable();
          Oe.__next = Ce.__key, Ce.__prev = Oe.__key;
        } else
          Ce.__prev = null;
        X.__next = null;
      }
      se.__size--, X.__parent = null;
    }
  }
  function ji(te) {
    k1();
    const W = te.getLatest(), X = W.__parent, se = Ja(), ye = Yi(), we = se._nodeMap, Ce = ye._dirtyElements;
    X !== null && cm(X, we, Ce);
    const Oe = W.__key;
    ye._dirtyType = ge, dn(te) ? Ce.set(Oe, !0) : ye._dirtyLeaves.add(Oe);
  }
  function Ks(te) {
    const W = te.getPreviousSibling(), X = te.getNextSibling();
    W !== null && ji(W), X !== null && ji(X);
  }
  function Or(te) {
    _s();
    const W = Yi(), X = W._compositionKey;
    if (te !== X) {
      if (W._compositionKey = te, X !== null) {
        const se = mi(X);
        se !== null && se.getWritable();
      }
      if (te !== null) {
        const se = mi(te);
        se !== null && se.getWritable();
      }
    }
  }
  function Xr() {
    return qf() ? null : Yi()._compositionKey;
  }
  function mi(te, W) {
    const se = (W || Ja())._nodeMap.get(te);
    return se === void 0 ? null : se;
  }
  function Gd(te, W) {
    const X = Yi(), se = te[`__lexicalKey_${X._key}`];
    return se !== void 0 ? mi(se, W) : null;
  }
  function Hc(te, W) {
    let X = te;
    for (; X != null; ) {
      const se = Gd(X, W);
      if (se !== null)
        return se;
      X = Zc(X);
    }
    return null;
  }
  function iu(te) {
    const W = te._decorators, X = Object.assign({}, W);
    return te._pendingDecorators = X, X;
  }
  function Wd(te) {
    return te.read(() => ss().getTextContent());
  }
  function ep(te, W) {
    wc(te, () => {
      const X = Ja();
      if (X.isEmpty())
        return;
      if (W === "root") {
        ss().markDirty();
        return;
      }
      const se = X._nodeMap;
      for (const [, ye] of se)
        ye.markDirty();
    }, te._pendingEditorState === null ? {
      tag: "history-merge"
    } : void 0);
  }
  function ss() {
    return _c(Ja());
  }
  function _c(te) {
    return te._nodeMap.get("root");
  }
  function Co(te) {
    _s();
    const W = Ja();
    if (te !== null) {
      if (Object.isFrozen(te))
        throw Error("$setSelection called on frozen selection object. Ensure selection is cloned before passing in.");
      te.dirty = !0, te._cachedNodes = null;
    }
    W._selection = te;
  }
  function Hd() {
    _s();
    const te = Yi();
    Pt(te);
  }
  function xs(te) {
    const W = Yi(), X = Zs(te, W);
    if (X === null) {
      const se = W.getRootElement();
      return te === se ? mi("root") : null;
    }
    return mi(X);
  }
  function ea(te, W) {
    return W ? te.getTextContentSize() : 0;
  }
  function Zs(te, W) {
    let X = te;
    for (; X != null; ) {
      const se = X[`__lexicalKey_${W._key}`];
      if (se !== void 0)
        return se;
      X = Zc(X);
    }
    return null;
  }
  function cs(te) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(te);
  }
  function Ju(te) {
    const W = [];
    let X = te;
    for (; X !== null; )
      W.push(X), X = X._parentEditor;
    return W;
  }
  function Sl() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
  }
  function Qu(te) {
    return te.nodeType === ne ? te.nodeValue : null;
  }
  function au(te, W, X) {
    const se = Na(W._window);
    if (se === null)
      return;
    const ye = se.anchorNode;
    let {
      anchorOffset: we,
      focusOffset: Ce
    } = se;
    if (ye !== null) {
      let Oe = Qu(ye);
      const Ye = Hc(ye);
      if (Oe !== null && Wn(Ye)) {
        if (Ye.canContainTabs()) {
          const Ke = Oe.includes("	");
          if (X && X.length > 0 && Ke) {
            const rt = X.length, ut = we + rt - 1, _t = Oe.slice(0, ut), ct = Oe.slice(ut, Oe.length);
            Oe = `${_t}${X}${ct}`, we += rt, Ce += rt;
          }
        }
        if (Oe === Ln && X) {
          const Ke = X.length;
          Oe = X, we = Ke, Ce = Ke;
        }
        Oe !== null && tp(Ye, Oe, we, Ce, te);
      }
    }
  }
  function tp(te, W, X, se, ye) {
    let we = te;
    if (we.isAttached() && (ye || !we.isDirty())) {
      const Ce = we.isComposing();
      let Oe = W;
      (Ce || ye) && W[W.length - 1] === Ln && (Oe = W.slice(0, -1));
      const Ye = we.getTextContent();
      if (ye || Oe !== Ye) {
        if (Oe === "") {
          if (Or(null), !_e && !he && !Q) {
            const Lt = Yi();
            setTimeout(() => {
              Lt.update(() => {
                we.isAttached() && we.remove();
              });
            }, 20);
          } else
            we.remove();
          return;
        }
        const Ke = we.getParent(), rt = Sa(), ut = Xr(), _t = we.getKey();
        if (we.isToken() || ut !== null && _t === ut && !Ce || // Check if character was added at the start, and we need
        // to clear this input from occurring as that action wasn't
        // permitted.
        Ke !== null && so(rt) && !Ke.canInsertTextBefore() && rt.anchor.offset === 0) {
          we.markDirty();
          return;
        }
        const ct = yo();
        if (!so(ct) || X === null || se === null) {
          we.setTextContent(Oe);
          return;
        }
        if (ct.setTextNodeRange(we, X, we, se), we.isSegmented()) {
          const Lt = we.getTextContent(), St = es(Lt);
          we.replace(St), we = St;
        }
        we.setTextContent(Oe);
      }
    }
  }
  function Yd(te) {
    const W = te.getPreviousSibling();
    return (Wn(W) || dn(W) && W.isInline()) && !W.canInsertTextAfter();
  }
  function su(te, W) {
    if (W.isSegmented())
      return !0;
    if (!te.isCollapsed())
      return !1;
    const X = te.anchor.offset, se = W.getParentOrThrow(), ye = W.isToken();
    return X === 0 ? !W.canInsertTextBefore() || !se.canInsertTextBefore() || ye || Yd(W) : X === W.getTextContentSize() ? !W.canInsertTextAfter() || !se.canInsertTextAfter() || ye : !1;
  }
  function Kd(te, W, X, se) {
    return te === 9 && !W && !X && !se;
  }
  function Cs(te, W, X, se) {
    return te === 66 && !W && od(X, se);
  }
  function Zd(te, W, X, se) {
    return te === 73 && !W && od(X, se);
  }
  function Yc(te, W, X, se) {
    return te === 85 && !W && od(X, se);
  }
  function fi(te, W) {
    return rd(te) && !W;
  }
  function pc(te, W) {
    return rd(te) && W;
  }
  function Xd(te, W) {
    return Y && W && te === 79;
  }
  function ed(te, W, X) {
    return _o(te) && (Y ? W : X);
  }
  function Jd(te, W, X) {
    return $a(te) && (Y ? W : X);
  }
  function Dr(te, W) {
    return Y && W && _o(te);
  }
  function Po(te, W) {
    return Y && W && $a(te);
  }
  function mc(te, W, X, se) {
    return Y ? W || X ? !1 : _o(te) || te === 72 && se : se || W || X ? !1 : _o(te);
  }
  function El(te, W, X, se, ye) {
    return Y ? X || se || ye ? !1 : $a(te) || te === 68 && W : W || se || ye ? !1 : $a(te);
  }
  function xl(te, W, X, se) {
    return te === 90 && !W && od(X, se);
  }
  function td(te, W, X, se) {
    return Y ? te === 90 && X && W : te === 89 && se || te === 90 && se && W;
  }
  function nd(te, W, X, se) {
    return W ? !1 : te === 67 ? Y ? X : se : !1;
  }
  function np(te, W, X, se) {
    return W ? !1 : te === 88 ? Y ? X : se : !1;
  }
  function Qd(te) {
    return te === 37;
  }
  function lm(te) {
    return te === 39;
  }
  function ma(te) {
    return te === 38;
  }
  function e_(te) {
    return te === 40;
  }
  function cu(te, W, X, se) {
    return Qd(te) && !W && !se && !X;
  }
  function op(te, W, X, se, ye) {
    return Qd(te) && !se && !X && (W || ye);
  }
  function um(te, W, X, se) {
    return lm(te) && !W && !se && !X;
  }
  function ls(te, W, X, se, ye) {
    return lm(te) && !se && !X && (W || ye);
  }
  function Rf(te, W, X) {
    return ma(te) && !W && !X;
  }
  function Pf(te, W, X) {
    return e_(te) && !W && !X;
  }
  function Kc(te, W, X, se) {
    return te || W || X || se;
  }
  function t_(te) {
    return te === 32;
  }
  function od(te, W) {
    return Y ? te : W;
  }
  function rd(te) {
    return te === 13;
  }
  function _o(te) {
    return te === 8;
  }
  function dm(te) {
    return te === 27;
  }
  function $a(te) {
    return te === 46;
  }
  function Cl(te, W) {
    const X = te[W];
    if (typeof X == "string") {
      const se = X.split(" ");
      return te[W] = se, se;
    }
    return X;
  }
  function wa(te, W, X, se, ye) {
    if (X.size === 0)
      return;
    const we = se.__type, Ce = se.__key, Oe = W.get(we);
    if (Oe === void 0)
      throw Error(`Type ${we} not in registeredNodes`);
    const Ye = Oe.klass;
    let Ke = te.get(Ye);
    Ke === void 0 && (Ke = /* @__PURE__ */ new Map(), te.set(Ye, Ke));
    const rt = Ke.get(Ce), ut = rt === "destroyed" && ye === "created";
    (rt === void 0 || ut) && Ke.set(Ce, ut ? "updated" : ye);
  }
  function ta(te) {
    const W = Ja(), X = W._readOnly, se = te.getType(), ye = W._nodeMap, we = [];
    for (const [, Ce] of ye)
      Ce instanceof te && Ce.__type === se && (X || Ce.isAttached()) && we.push(Ce);
    return we;
  }
  function Tl(te, W, X) {
    const se = te.getParent();
    let ye = X, we = te;
    return se !== null && (W && X === 0 ? (ye = we.getIndexWithinParent(), we = se) : !W && X === we.getChildrenSize() && (ye = we.getIndexWithinParent() + 1, we = se)), we.getChildAtIndex(W ? ye - 1 : ye);
  }
  function lu(te, W) {
    const X = te.offset;
    if (te.type === "element") {
      const se = te.getNode();
      return Tl(se, W, X);
    } else {
      const se = te.getNode();
      if (W && X === 0 || !W && X === se.getTextContentSize()) {
        const ye = W ? se.getPreviousSibling() : se.getNextSibling();
        return ye === null ? Tl(se.getParentOrThrow(), W, se.getIndexWithinParent() + (W ? 0 : 1)) : ye;
      }
    }
    return null;
  }
  function Zo(te) {
    const W = As(te).event, X = W && W.inputType;
    return X === "insertFromPaste" || X === "insertFromPasteAsQuotation";
  }
  function nn(te, W, X) {
    return k$(te, W, X);
  }
  function Ts(te) {
    return !Qa(te) && !te.isLastChild() && !te.isInline();
  }
  function po(te, W) {
    const X = te._keyToDOMMap.get(W);
    if (X === void 0)
      throw Error(`Reconciliation: could not find DOM element for node key ${W}`);
    return X;
  }
  function Zc(te) {
    const W = te.assignedSlot || te.parentElement;
    return W !== null && W.nodeType === 11 ? W.host : W;
  }
  function _m(te, W, X) {
    const se = X.ownerDocument, ye = se.defaultView;
    if (ye === null)
      return;
    let {
      top: we,
      bottom: Ce
    } = W, Oe = 0, Ye = 0, Ke = X;
    for (; Ke !== null; ) {
      const rt = Ke === se.body;
      if (rt)
        Oe = 0, Ye = As(te).innerHeight;
      else {
        const _t = Ke.getBoundingClientRect();
        Oe = _t.top, Ye = _t.bottom;
      }
      let ut = 0;
      if (we < Oe ? ut = -(Oe - we) : Ce > Ye && (ut = Ce - Ye), ut !== 0)
        if (rt)
          ye.scrollBy(0, ut);
        else {
          const _t = Ke.scrollTop;
          Ke.scrollTop += ut;
          const ct = Ke.scrollTop - _t;
          we -= ct, Ce -= ct;
        }
      if (rt)
        break;
      Ke = Zc(Ke);
    }
  }
  function Er(te) {
    _s(), Yi()._updateTags.add(te);
  }
  function uu(te, W = 0) {
    if (W !== 0)
      throw Error("TODO");
    const X = yo();
    if (!so(X) || !dn(te))
      return X;
    const {
      anchor: se,
      focus: ye
    } = X, we = se.getNode(), Ce = ye.getNode();
    return du(we, te) && se.set(te.__key, 0, "element"), du(Ce, te) && ye.set(te.__key, 0, "element"), X;
  }
  function du(te, W) {
    let X = te.getParent();
    for (; X !== null; ) {
      if (X.is(W))
        return !0;
      X = X.getParent();
    }
    return !1;
  }
  function na(te) {
    const W = te.ownerDocument;
    return W && W.defaultView || null;
  }
  function As(te) {
    const W = te._window;
    if (W === null)
      throw Error("window object not found");
    return W;
  }
  function pm(te) {
    return dn(te) && te.isInline() || hi(te) && te.isInline();
  }
  function n_(te) {
    let W = te.getParentOrThrow();
    for (; W !== null; ) {
      if (Ma(W))
        return W;
      W = W.getParentOrThrow();
    }
    return W;
  }
  function Ma(te) {
    return Qa(te) || dn(te) && te.isShadowRoot();
  }
  function Za(te) {
    const W = te.constructor.clone(te);
    return Q_(W, null), W;
  }
  function Al(te) {
    const W = Yi(), X = te.constructor.getType(), se = W._nodes.get(X);
    if (se === void 0)
      throw Error('$initializeNode failed. Ensure node has been registered to the editor. You can do this by passing the node class via the "nodes" array in the editor config.');
    const ye = se.replace;
    if (ye !== null) {
      const we = ye(te);
      if (!(we instanceof te.constructor))
        throw Error("$initializeNode failed. Ensure replacement node is a subclass of the original node.");
      return we;
    }
    return te;
  }
  function Il(te, W) {
    const X = te.getParent();
    if (Qa(X) && !dn(W) && !hi(W))
      throw Error("Only element or decorator nodes can be inserted in to the root node");
  }
  function rp(te) {
    const W = te.theme, X = document.createElement("div");
    X.contentEditable = "false", X.setAttribute("data-lexical-cursor", "true");
    let se = W.blockCursor;
    if (se !== void 0) {
      if (typeof se == "string") {
        const ye = se.split(" ");
        se = W.blockCursor = ye;
      }
      se !== void 0 && X.classList.add(...se);
    }
    return X;
  }
  function id(te) {
    return (hi(te) || dn(te) && !te.canBeEmpty()) && !te.isInline();
  }
  function Ol(te, W, X) {
    X.style.removeProperty("caret-color"), W._blockCursorElement = null;
    const se = te.parentElement;
    se !== null && se.removeChild(te);
  }
  function To(te, W, X) {
    let se = te._blockCursorElement;
    if (so(X) && X.isCollapsed() && X.anchor.type === "element" && W.contains(document.activeElement)) {
      const ye = X.anchor, we = ye.getNode(), Ce = ye.offset, Oe = we.getChildrenSize();
      let Ye = !1, Ke = null;
      if (Ce === Oe) {
        const rt = we.getChildAtIndex(Ce - 1);
        id(rt) && (Ye = !0);
      } else {
        const rt = we.getChildAtIndex(Ce);
        if (id(rt)) {
          const ut = rt.getPreviousSibling();
          (ut === null || id(ut)) && (Ye = !0, Ke = te.getElementByKey(rt.__key));
        }
      }
      if (Ye) {
        const rt = te.getElementByKey(we.__key);
        se === null && (te._blockCursorElement = se = rp(te._config)), W.style.caretColor = "transparent", Ke === null ? rt.appendChild(se) : rt.insertBefore(se, Ke);
        return;
      }
    }
    se !== null && Ol(se, te, W);
  }
  function Na(te) {
    return le ? (te || window).getSelection() : null;
  }
  function fa(te, W) {
    let X = te.getChildAtIndex(W);
    if (X == null && (X = te), Ma(te))
      throw Error("Can not call $splitNode() on root element");
    const se = (Ce) => {
      const Oe = Ce.getParentOrThrow(), Ye = Ma(Oe), Ke = Ce === X && !Ye ? Ce : Za(Ce);
      if (Ye)
        return Ce.insertAfter(Ke), [Ce, Ke, Ke];
      {
        const [rt, ut, _t] = se(Oe), ct = Ce.getNextSiblings();
        return _t.append(Ke, ...ct), [rt, ut, Ke];
      }
    }, [ye, we] = se(X);
    return [ye, we];
  }
  function Is(te, W) {
    let X = te;
    for (; X !== ss() && X != null; ) {
      if (W(X))
        return X;
      X = X.getParent();
    }
    return null;
  }
  function Xc(te) {
    const W = [], X = [te];
    for (; X.length > 0; ) {
      const se = X.pop();
      if (se === void 0)
        throw Error("Stack.length > 0; can't be undefined");
      dn(se) && X.unshift(...se.getChildren()), se !== te && W.push(se);
    }
    return W;
  }
  function ad(te, W) {
    const X = te._decorators;
    let ye = te._pendingDecorators || X;
    const we = W._nodeMap;
    let Ce;
    for (Ce in ye)
      we.has(Ce) || (ye === X && (ye = iu(te)), delete ye[Ce]);
  }
  function sd(te, W, X, se, ye) {
    let we = te.getFirstChild();
    for (; we !== null; ) {
      const Ce = we.__key;
      we !== void 0 && we.__parent === W && (dn(we) && sd(we, Ce, X, se, ye), X.has(Ce) || ye.delete(Ce), se.delete(Ce)), we = we.isAttached() ? we.getNextSibling() : null;
    }
  }
  function Xs(te, W, X, se) {
    const ye = te._nodeMap, we = W._nodeMap;
    for (const Ce of X) {
      const Oe = we.get(Ce);
      Oe !== void 0 && !Oe.isAttached() && (ye.has(Ce) || X.delete(Ce), we.delete(Ce));
    }
    for (const [Ce] of se) {
      const Oe = we.get(Ce);
      Oe !== void 0 && (Oe.isAttached() || (dn(Oe) && sd(Oe, Ce, ye, we, se), ye.has(Ce) || se.delete(Ce), we.delete(Ce)));
    }
  }
  function fr(te, W) {
    const X = te.__mode, se = te.__format, ye = te.__style, we = W.__mode, Ce = W.__format, Oe = W.__style;
    return (X === null || X === we) && (se === null || se === Ce) && (ye === null || ye === Oe);
  }
  function Ii(te, W) {
    const X = te.mergeWithSibling(W), se = Yi()._normalizedNodes;
    return se.add(te.__key), se.add(W.__key), X;
  }
  function Fa(te) {
    let W = te;
    if (W.__text === "" && W.isSimpleText() && !W.isUnmergeable()) {
      W.remove();
      return;
    }
    let X;
    for (; (X = W.getPreviousSibling()) !== null && Wn(X) && X.isSimpleText() && !X.isUnmergeable(); )
      if (X.__text === "")
        X.remove();
      else if (fr(X, W)) {
        W = Ii(X, W);
        break;
      } else
        break;
    let se;
    for (; (se = W.getNextSibling()) !== null && Wn(se) && se.isSimpleText() && !se.isUnmergeable(); )
      if (se.__text === "")
        se.remove();
      else if (fr(W, se)) {
        W = Ii(W, se);
        break;
      } else
        break;
  }
  function ip(te) {
    return Xa(te.anchor), Xa(te.focus), te;
  }
  function Xa(te) {
    for (; te.type === "element"; ) {
      const W = te.getNode(), X = te.offset;
      let se, ye;
      if (X === W.getChildrenSize() ? (se = W.getChildAtIndex(X - 1), ye = !0) : (se = W.getChildAtIndex(X), ye = !1), Wn(se)) {
        te.set(se.__key, ye ? se.getTextContentSize() : 0, "text");
        break;
      } else if (!dn(se))
        break;
      te.set(se.__key, ye ? se.getChildrenSize() : 0, "element");
    }
  }
  let Vi = "", Bi = "", Jr = "", oa, Do, Jc, mm = !1, fm = !1, G, ce = null, Se, Ie, Ae, Ge, Qe, gt;
  function Nt(te, W) {
    const X = Ae.get(te);
    if (W !== null) {
      const se = Gg(te);
      se.parentNode === W && W.removeChild(se);
    }
    if (Ge.has(te) || Do._keyToDOMMap.delete(te), dn(X)) {
      const se = hc(X, Ae);
      Ct(se, 0, se.length - 1, null);
    }
    X !== void 0 && wa(gt, Jc, G, X, "destroyed");
  }
  function Ct(te, W, X, se) {
    let ye = W;
    for (; ye <= X; ++ye) {
      const we = te[ye];
      we !== void 0 && Nt(we, se);
    }
  }
  function Be(te, W) {
    te.setProperty("text-align", W);
  }
  const We = "40px";
  function mt(te, W) {
    const X = oa.theme.indent;
    if (typeof X == "string") {
      const ye = te.classList.contains(X);
      W > 0 && !ye ? te.classList.add(X) : W < 1 && ye && te.classList.remove(X);
    }
    const se = getComputedStyle(te).getPropertyValue("--lexical-indent-base-value") || We;
    te.style.setProperty("padding-inline-start", W === 0 ? "" : `calc(${W} * ${se})`);
  }
  function Gt(te, W) {
    const X = te.style;
    W === 0 ? Be(X, "") : W === vt ? Be(X, "left") : W === Ot ? Be(X, "center") : W === Ft ? Be(X, "right") : W === wn ? Be(X, "justify") : W === un ? Be(X, "start") : W === pn && Be(X, "end");
  }
  function on(te, W, X) {
    const se = Ge.get(te);
    if (se === void 0)
      throw Error("createNode: node does not exist in nodeMap");
    const ye = se.createDOM(oa, Do);
    if (Lf(te, ye, Do), Wn(se) ? ye.setAttribute("data-lexical-text", "true") : hi(se) && ye.setAttribute("data-lexical-decorator", "true"), dn(se)) {
      const we = se.__indent, Ce = se.__size;
      if (we !== 0 && mt(ye, we), Ce !== 0) {
        const Ye = Ce - 1, Ke = hc(se, Ge);
        no(Ke, Ye, se, ye);
      }
      const Oe = se.__format;
      Oe !== 0 && Gt(ye, Oe), se.isInline() || fc(null, se, ye), Ts(se) && (Vi += Yn, Jr += Yn);
    } else {
      const we = se.getTextContent();
      if (hi(se)) {
        const Ce = se.decorate(Do, oa);
        Ce !== null && r_(te, Ce), ye.contentEditable = "false";
      } else
        Wn(se) && (se.isDirectionless() || (Bi += we));
      Vi += we, Jr += we;
    }
    if (W !== null)
      if (X != null)
        W.insertBefore(ye, X);
      else {
        const we = W.__lexicalLineBreak;
        we != null ? W.insertBefore(ye, we) : W.appendChild(ye);
      }
    return Object.freeze(se), wa(gt, Jc, G, se, "created"), ye;
  }
  function no(te, W, X, se) {
    const ye = Bi;
    Bi = "", gr(te, X, 0, W, se, null), o_(X, se), Bi = ye;
  }
  function gr(te, W, X, se, ye, we) {
    const Ce = Vi;
    Vi = "";
    let Oe = X;
    for (; Oe <= se; ++Oe)
      on(te[Oe], ye, we);
    Ts(W) && (Vi += Yn), ye.__lexicalTextContent = Vi, Vi = Ce + Vi;
  }
  function Xo(te, W) {
    const X = W.get(te);
    return oh(X) || hi(X) && X.isInline();
  }
  function fc(te, W, X) {
    const se = te !== null && (te.__size === 0 || Xo(te.__last, Ae)), ye = W.__size === 0 || Xo(W.__last, Ge);
    if (se) {
      if (!ye) {
        const we = X.__lexicalLineBreak;
        we != null && X.removeChild(we), X.__lexicalLineBreak = null;
      }
    } else if (ye) {
      const we = document.createElement("br");
      X.__lexicalLineBreak = we, X.appendChild(we);
    }
  }
  function o_(te, W) {
    const X = (
      // @ts-expect-error: internal field
      W.__lexicalDirTextContent
    ), se = W.__lexicalDir;
    if (X !== Bi || se !== ce) {
      const ye = Bi === "", we = ye ? ce : ur(Bi);
      if (we !== se) {
        const Ce = W.classList, Oe = oa.theme;
        let Ye = se !== null ? Oe[se] : void 0, Ke = we !== null ? Oe[we] : void 0;
        if (Ye !== void 0) {
          if (typeof Ye == "string") {
            const rt = Ye.split(" ");
            Ye = Oe[se] = rt;
          }
          Ce.remove(...Ye);
        }
        if (we === null || ye && we === "ltr")
          W.removeAttribute("dir");
        else {
          if (Ke !== void 0) {
            if (typeof Ke == "string") {
              const rt = Ke.split(" ");
              Ke = Oe[we] = rt;
            }
            Ke !== void 0 && Ce.add(...Ke);
          }
          W.dir = we;
        }
        if (!fm) {
          const rt = te.getWritable();
          rt.__dir = we;
        }
      }
      ce = we, W.__lexicalDirTextContent = Bi, W.__lexicalDir = we;
    }
  }
  function gc(te, W, X) {
    const se = Bi;
    Bi = "", gm(te, W, X), o_(W, X), Bi = se;
  }
  function hc(te, W) {
    const X = [];
    let se = te.__first;
    for (; se !== null; ) {
      const ye = W.get(se);
      if (ye === void 0)
        throw Error("createChildrenArray: node does not exist in nodeMap");
      X.push(se), se = ye.__next;
    }
    return X;
  }
  function gm(te, W, X) {
    const se = Vi, ye = te.__size, we = W.__size;
    if (Vi = "", ye === 1 && we === 1) {
      const Ce = te.__first, Oe = W.__first;
      if (Ce === Oe)
        vc(Ce, X);
      else {
        const Ye = Gg(Ce), Ke = on(Oe, null, null);
        X.replaceChild(Ke, Ye), Nt(Ce, null);
      }
    } else {
      const Ce = hc(te, Ae), Oe = hc(W, Ge);
      if (ye === 0)
        we !== 0 && gr(Oe, W, 0, we - 1, X, null);
      else if (we === 0) {
        if (ye !== 0) {
          const Ke = X.__lexicalLineBreak == null;
          Ct(Ce, 0, ye - 1, Ke ? null : X), Ke && (X.textContent = "");
        }
      } else
        Df(W, Ce, Oe, ye, we, X);
    }
    Ts(W) && (Vi += Yn), X.__lexicalTextContent = Vi, Vi = se + Vi;
  }
  function vc(te, W) {
    const X = Ae.get(te);
    let se = Ge.get(te);
    if (X === void 0 || se === void 0)
      throw Error("reconcileNode: prevNode or nextNode does not exist in nodeMap");
    const ye = mm || Ie.has(te) || Se.has(te), we = po(Do, te);
    if (X === se && !ye) {
      if (dn(X)) {
        const Ce = we.__lexicalTextContent;
        Ce !== void 0 && (Vi += Ce, Jr += Ce);
        const Oe = we.__lexicalDirTextContent;
        Oe !== void 0 && (Bi += Oe);
      } else {
        const Ce = X.getTextContent();
        Wn(X) && !X.isDirectionless() && (Bi += Ce), Jr += Ce, Vi += Ce;
      }
      return we;
    }
    if (X !== se && ye && wa(gt, Jc, G, se, "updated"), se.updateDOM(X, we, oa)) {
      const Ce = on(te, null, null);
      if (W === null)
        throw Error("reconcileNode: parentDOM is null");
      return W.replaceChild(Ce, we), Nt(te, null), Ce;
    }
    if (dn(X) && dn(se)) {
      const Ce = se.__indent;
      Ce !== X.__indent && mt(we, Ce);
      const Oe = se.__format;
      Oe !== X.__format && Gt(we, Oe), ye && (gc(X, se, we), !Qa(se) && !se.isInline() && fc(X, se, we)), Ts(se) && (Vi += Yn, Jr += Yn);
    } else {
      const Ce = se.getTextContent();
      if (hi(se)) {
        const Oe = se.decorate(Do, oa);
        Oe !== null && r_(te, Oe);
      } else
        Wn(se) && !se.isDirectionless() && (Bi += Ce);
      Vi += Ce, Jr += Ce;
    }
    return !fm && Qa(se) && se.__cachedText !== Jr && (se = se.getWritable(), se.__cachedText = Jr), Object.freeze(se), we;
  }
  function r_(te, W) {
    let X = Do._pendingDecorators;
    const se = Do._decorators;
    if (X === null) {
      if (se[te] === W)
        return;
      X = iu(Do);
    }
    X[te] = W;
  }
  function ap(te) {
    return te.firstChild;
  }
  function yr(te) {
    let W = te.nextSibling;
    return W !== null && W === Do._blockCursorElement && (W = W.nextSibling), W;
  }
  function Df(te, W, X, se, ye, we) {
    const Ce = se - 1, Oe = ye - 1;
    let Ye, Ke, rt = ap(we), ut = 0, _t = 0;
    for (; ut <= Ce && _t <= Oe; ) {
      const St = W[ut], jt = X[_t];
      if (St === jt)
        rt = yr(vc(jt, we)), ut++, _t++;
      else {
        Ye === void 0 && (Ye = new Set(W)), Ke === void 0 && (Ke = new Set(X));
        const bn = Ke.has(St), Ht = Ye.has(jt);
        if (!bn)
          rt = yr(Gg(St)), Nt(St, we), ut++;
        else if (!Ht)
          on(jt, we, rt), _t++;
        else {
          const ln = po(Do, jt);
          ln === rt ? rt = yr(vc(jt, we)) : (rt != null ? we.insertBefore(ln, rt) : we.appendChild(ln), vc(jt, we)), ut++, _t++;
        }
      }
    }
    const ct = ut > Ce, Lt = _t > Oe;
    if (ct && !Lt) {
      const St = X[Oe + 1], jt = St === void 0 ? null : Do.getElementByKey(St);
      gr(X, te, _t, Oe, we, jt);
    } else
      Lt && !ct && Ct(W, ut, Ce, we);
  }
  function i_(te, W, X, se, ye, we) {
    Vi = "", Jr = "", Bi = "", mm = se === ve, ce = null, Do = X, oa = X._config, Jc = X._nodes, G = Do._listeners.mutation, Se = ye, Ie = we, Ae = te._nodeMap, Ge = W._nodeMap, fm = W._readOnly, Qe = new Map(X._keyToDOMMap);
    const Ce = /* @__PURE__ */ new Map();
    return gt = Ce, vc("root", null), Do = void 0, Jc = void 0, Se = void 0, Ie = void 0, Ae = void 0, Ge = void 0, oa = void 0, Qe = void 0, gt = void 0, Ce;
  }
  function Lf(te, W, X) {
    const se = X._keyToDOMMap;
    W["__lexicalKey_" + X._key] = te, se.set(te, W);
  }
  function Gg(te) {
    const W = Qe.get(te);
    if (W === void 0)
      throw Error(`Reconciliation: could not find DOM element for node key ${te}`);
    return W;
  }
  const _u = Object.freeze({}), Wg = 30, sp = [["keydown", ot], ["pointerdown", cd], ["compositionstart", ke], ["compositionend", qe], ["input", fe], ["click", qv], ["cut", _u], ["copy", _u], ["dragstart", _u], ["dragover", _u], ["dragend", _u], ["paste", _u], ["focus", _u], ["blur", _u], ["drop", _u]];
  ie && sp.push(["beforeinput", (te, W) => ue(te, W)]);
  let ka = 0, ra = 0, Vn = 0, Os = null, cp = 0, Nl = !1, a_ = !1, lp = !1, pu = !1, zl = [0, "", 0, "root", 0];
  function Ns(te, W, X, se, ye) {
    const we = te.anchor, Ce = te.focus, Oe = we.getNode(), Ye = Yi(), Ke = Na(Ye._window), rt = Ke !== null ? Ke.anchorNode : null, ut = we.key, _t = Ye.getElementByKey(ut), ct = X.length;
    return ut !== Ce.key || // If we're working with a non-text node.
    !Wn(Oe) || // If we are replacing a range with a single character or grapheme, and not composing.
    (!ye && (!ie || // We check to see if there has been
    // a recent beforeinput event for "textInput". If there has been one in the last
    // 50ms then we proceed as normal. However, if there is not, then this is likely
    // a dangling `input` event caused by execCommand('insertText').
    Vn < se + 50) || Oe.isDirty() && ct < 2 || cs(X)) && we.offset !== Ce.offset && !Oe.isComposing() || // Any non standard text node.
    er(Oe) || // If the text length is more than a single character and we're either
    // dealing with this in "beforeinput" or where the node has already recently
    // been changed (thus is dirty).
    Oe.isDirty() && ct > 1 || // If the DOM selection element is not the same as the backing node during beforeinput.
    (ye || !ie) && _t !== null && !Oe.isComposing() && rt !== Ai(_t) || // If TargetRange is not the same as the DOM selection; browser trying to edit random parts
    // of the editor.
    Ke !== null && W !== null && (!W.collapsed || W.startContainer !== Ke.anchorNode || W.startOffset !== Ke.anchorOffset) || // Check if we're changing from bold to italics, or some other format.
    Oe.getFormat() !== te.format || Oe.getStyle() !== te.style || // One last set of heuristics to check against.
    su(te, Oe);
  }
  function Hg(te, W) {
    return te !== null && te.nodeValue !== null && te.nodeType === ne && W !== 0 && W !== te.nodeValue.length;
  }
  function Mf(te, W, X) {
    const {
      anchorNode: se,
      anchorOffset: ye,
      focusNode: we,
      focusOffset: Ce
    } = te;
    Nl && (Nl = !1, Hg(se, ye) && Hg(we, Ce)) || wc(W, () => {
      if (!X) {
        Co(null);
        return;
      }
      if (!It(W, se, we))
        return;
      const Oe = yo();
      if (so(Oe)) {
        const Ye = Oe.anchor, Ke = Ye.getNode();
        if (Oe.isCollapsed()) {
          te.type === "Range" && te.anchorNode === te.focusNode && (Oe.dirty = !0);
          const rt = As(W).event, ut = rt ? rt.timeStamp : performance.now(), [_t, ct, Lt, St, jt] = zl;
          ut < jt + 200 && Ye.offset === Lt && Ye.key === St ? (Oe.format = _t, Oe.style = ct) : Ye.type === "text" ? (Oe.format = Ke.getFormat(), Oe.style = Ke.getStyle()) : Ye.type === "element" && (Oe.format = 0, Oe.style = "");
        } else {
          let rt = at, ut = !1;
          const _t = Oe.getNodes(), ct = _t.length;
          for (let Lt = 0; Lt < ct; Lt++) {
            const St = _t[Lt];
            if (Wn(St) && (ut = !0, rt &= St.getFormat(), rt === 0))
              break;
          }
          Oe.format = ut ? rt : 0;
        }
      }
      nn(W, t, void 0);
    });
  }
  function qv(te, W) {
    wc(W, () => {
      const X = yo(), se = Na(W._window), ye = Sa();
      if (so(X)) {
        const we = X.anchor, Ce = we.getNode();
        se && we.type === "element" && we.offset === 0 && X.isCollapsed() && !Qa(Ce) && ss().getChildrenSize() === 1 && Ce.getTopLevelElementOrThrow().isEmpty() && ye !== null && X.is(ye) && (se.removeAllRanges(), X.dirty = !0);
      }
      nn(W, n, te);
    });
  }
  function cd(te, W) {
    const X = te.target, se = te.pointerType;
    X instanceof Node && se !== "touch" && wc(W, () => {
      Wt(X) || (a_ = !0);
    });
  }
  function Z(te) {
    if (!te.getTargetRanges)
      return null;
    const W = te.getTargetRanges();
    return W.length === 0 ? null : W[0];
  }
  function B(te, W) {
    return te !== W || dn(te) || dn(W) || !te.isToken() || !W.isToken();
  }
  function K(te) {
    return ra === 229 && te < ka + Wg;
  }
  function ue(te, W) {
    const X = te.inputType, se = Z(te);
    X === "deleteCompositionText" || // If we're pasting in FF, we shouldn't get this event
    // as the `paste` event should have triggered, unless the
    // user has dom.event.clipboardevents.enabled disabled in
    // about:config. In that case, we need to process the
    // pasted content in the DOM mutation phase.
    re && Zo(W) || X !== "insertCompositionText" && wc(W, () => {
      const ye = yo();
      if (X === "deleteContentBackward") {
        if (ye === null) {
          const rt = Sa();
          if (!so(rt))
            return;
          Co(rt.clone());
        }
        if (so(ye)) {
          if (K(te.timeStamp) && W.isComposing() && ye.anchor.key === ye.focus.key) {
            if (Or(null), ka = 0, setTimeout(() => {
              wc(W, () => {
                Or(null);
              });
            }, Wg), so(ye)) {
              const rt = ye.anchor.getNode();
              rt.markDirty(), ye.format = rt.getFormat(), ye.style = rt.getStyle();
            }
          } else
            te.preventDefault(), nn(W, o, !0);
          return;
        }
      }
      if (!so(ye))
        return;
      const we = te.data;
      Os !== null && au(!1, W, Os), (!ye.dirty || Os !== null) && ye.isCollapsed() && !Qa(ye.anchor.getNode()) && se !== null && ye.applyDOMRange(se), Os = null;
      const Ce = ye.anchor, Oe = ye.focus, Ye = Ce.getNode(), Ke = Oe.getNode();
      if (X === "insertText" || X === "insertTranspose") {
        if (we === `
`)
          te.preventDefault(), nn(W, r, !1);
        else if (we === Yn)
          te.preventDefault(), nn(W, i, void 0);
        else if (we == null && te.dataTransfer) {
          const rt = te.dataTransfer.getData("text/plain");
          te.preventDefault(), ye.insertRawText(rt);
        } else
          we != null && Ns(ye, se, we, te.timeStamp, !0) ? (te.preventDefault(), nn(W, a, we)) : Os = we;
        Vn = te.timeStamp;
        return;
      }
      switch (te.preventDefault(), X) {
        case "insertFromYank":
        case "insertFromDrop":
        case "insertReplacementText": {
          nn(W, a, te);
          break;
        }
        case "insertFromComposition": {
          Or(null), nn(W, a, te);
          break;
        }
        case "insertLineBreak": {
          Or(null), nn(W, r, !1);
          break;
        }
        case "insertParagraph": {
          Or(null), lp ? (lp = !1, nn(W, r, !1)) : nn(W, i, void 0);
          break;
        }
        case "insertFromPaste":
        case "insertFromPasteAsQuotation": {
          nn(W, s, te);
          break;
        }
        case "deleteByComposition": {
          B(Ye, Ke) && nn(W, c, void 0);
          break;
        }
        case "deleteByDrag":
        case "deleteByCut": {
          nn(W, c, void 0);
          break;
        }
        case "deleteContent": {
          nn(W, o, !1);
          break;
        }
        case "deleteWordBackward": {
          nn(W, l, !0);
          break;
        }
        case "deleteWordForward": {
          nn(W, l, !1);
          break;
        }
        case "deleteHardLineBackward":
        case "deleteSoftLineBackward": {
          nn(W, u, !0);
          break;
        }
        case "deleteContentForward":
        case "deleteHardLineForward":
        case "deleteSoftLineForward": {
          nn(W, u, !1);
          break;
        }
        case "formatStrikeThrough": {
          nn(W, d, "strikethrough");
          break;
        }
        case "formatBold": {
          nn(W, d, "bold");
          break;
        }
        case "formatItalic": {
          nn(W, d, "italic");
          break;
        }
        case "formatUnderline": {
          nn(W, d, "underline");
          break;
        }
        case "historyUndo": {
          nn(W, _, void 0);
          break;
        }
        case "historyRedo": {
          nn(W, p, void 0);
          break;
        }
      }
    });
  }
  function fe(te, W) {
    te.stopPropagation(), wc(W, () => {
      const X = yo(), se = te.data, ye = Z(te);
      if (se != null && so(X) && Ns(X, ye, se, te.timeStamp, !1)) {
        pu && (Ee(W, se), pu = !1);
        const we = X.anchor, Ce = we.getNode(), Oe = Na(W._window);
        if (Oe === null)
          return;
        const Ye = we.offset;
        (!ie || X.isCollapsed() || !Wn(Ce) || Oe.anchorNode === null || Ce.getTextContent().slice(0, Ye) + se + Ce.getTextContent().slice(Ye + X.focus.offset) !== Qu(Oe.anchorNode)) && nn(W, a, se);
        const Ke = se.length;
        re && Ke > 1 && te.inputType === "insertCompositionText" && !W.isComposing() && (X.anchor.offset -= Ke), !_e && !he && !Q && W.isComposing() && (ka = 0, Or(null));
      } else
        au(!1, W, se !== null ? se : void 0), pu && (Ee(W, se || void 0), pu = !1);
      Hd();
    }), Os = null;
  }
  function ke(te, W) {
    wc(W, () => {
      const X = yo();
      if (so(X) && !W.isComposing()) {
        const se = X.anchor, ye = X.anchor.getNode();
        Or(se.key), // If it has been 30ms since the last keydown, then we should
        // apply the empty space heuristic. We can't do this for Safari,
        // as the keydown fires after composition start.
        (te.timeStamp < ka + Wg || // FF has issues around composing multibyte characters, so we also
        // need to invoke the empty space heuristic below.
        se.type === "element" || !X.isCollapsed() || ye.getFormat() !== X.format || ye.getStyle() !== X.style) && nn(W, a, Qt);
      }
    });
  }
  function Ee(te, W) {
    const X = te._compositionKey;
    if (Or(null), X !== null && W != null) {
      if (W === "") {
        const se = mi(X), ye = Ai(te.getElementByKey(X));
        ye !== null && ye.nodeValue !== null && Wn(se) && tp(se, ye.nodeValue, null, null, !0);
        return;
      }
      if (W[W.length - 1] === `
`) {
        const se = yo();
        if (so(se)) {
          const ye = se.focus;
          se.anchor.set(ye.key, ye.offset, ye.type), nn(te, w, null);
          return;
        }
      }
    }
    au(!0, te, W);
  }
  function qe(te, W) {
    re ? pu = !0 : wc(W, () => {
      Ee(W, te.data);
    });
  }
  function ot(te, W) {
    if (ka = te.timeStamp, ra = te.keyCode, W.isComposing())
      return;
    const {
      keyCode: X,
      shiftKey: se,
      ctrlKey: ye,
      metaKey: we,
      altKey: Ce
    } = te;
    if (!nn(W, g, te)) {
      if (um(X, ye, Ce, we))
        nn(W, f, te);
      else if (ls(X, ye, se, Ce, we))
        nn(W, h, te);
      else if (cu(X, ye, Ce, we))
        nn(W, $, te);
      else if (op(X, ye, se, Ce, we))
        nn(W, v, te);
      else if (Rf(X, ye, we))
        nn(W, b, te);
      else if (Pf(X, ye, we))
        nn(W, y, te);
      else if (pc(X, se))
        lp = !0, nn(W, w, te);
      else if (t_(X))
        nn(W, N, te);
      else if (Xd(X, ye))
        te.preventDefault(), lp = !0, nn(W, r, !0);
      else if (fi(X, se))
        lp = !1, nn(W, w, te);
      else if (mc(X, Ce, we, ye))
        _o(X) ? nn(W, M, te) : (te.preventDefault(), nn(W, o, !0));
      else if (dm(X))
        nn(W, q, te);
      else if (El(X, ye, se, Ce, we))
        $a(X) ? nn(W, L, te) : (te.preventDefault(), nn(W, o, !1));
      else if (ed(X, Ce, ye))
        te.preventDefault(), nn(W, l, !0);
      else if (Jd(X, Ce, ye))
        te.preventDefault(), nn(W, l, !1);
      else if (Dr(X, we))
        te.preventDefault(), nn(W, u, !0);
      else if (Po(X, we))
        te.preventDefault(), nn(W, u, !1);
      else if (Cs(X, Ce, we, ye))
        te.preventDefault(), nn(W, d, "bold");
      else if (Yc(X, Ce, we, ye))
        te.preventDefault(), nn(W, d, "underline");
      else if (Zd(X, Ce, we, ye))
        te.preventDefault(), nn(W, d, "italic");
      else if (Kd(X, Ce, ye, we))
        nn(W, R, te);
      else if (xl(X, se, we, ye))
        te.preventDefault(), nn(W, _, void 0);
      else if (td(X, se, we, ye))
        te.preventDefault(), nn(W, p, void 0);
      else {
        const Oe = W._editorState._selection;
        ud(Oe) && (nd(X, se, we, ye) ? (te.preventDefault(), nn(W, I, te)) : np(X, se, we, ye) && (te.preventDefault(), nn(W, z, te)));
      }
      Kc(ye, se, Ce, we) && nn(W, J, te);
    }
  }
  function $t(te) {
    let W = te.__lexicalEventHandles;
    return W === void 0 && (W = [], te.__lexicalEventHandles = W), W;
  }
  const Vt = /* @__PURE__ */ new Map();
  function Mt(te) {
    const W = te.target, X = W == null ? null : W.nodeType === 9 ? W.defaultView : W.ownerDocument.defaultView, se = Na(X);
    if (se === null)
      return;
    const ye = Jn(se.anchorNode);
    if (ye === null)
      return;
    a_ && (a_ = !1, wc(ye, () => {
      const rt = Sa(), ut = se.anchorNode;
      if (ut === null)
        return;
      const _t = ut.nodeType;
      if (_t !== me && _t !== ne)
        return;
      const ct = Xg(rt, se, ye);
      Co(ct);
    }));
    const we = Ju(ye), Ce = we[we.length - 1], Oe = Ce._key, Ye = Vt.get(Oe), Ke = Ye || Ce;
    Ke !== ye && Mf(se, Ke, !1), Mf(se, ye, !0), ye !== Ce ? Vt.set(Oe, ye) : Ye && Vt.delete(Oe);
  }
  function zt(te) {
    te._lexicalHandled = !0;
  }
  function Rt(te) {
    return te._lexicalHandled === !0;
  }
  function Sn(te, W) {
    cp === 0 && te.ownerDocument.addEventListener("selectionchange", Mt), cp++, te.__lexicalEditor = W;
    const X = $t(te);
    for (let se = 0; se < sp.length; se++) {
      const [ye, we] = sp[se], Ce = typeof we == "function" ? (Oe) => {
        Rt(Oe) || (zt(Oe), W.isEditable() && we(Oe, W));
      } : (Oe) => {
        if (!Rt(Oe) && (zt(Oe), W.isEditable()))
          switch (ye) {
            case "cut":
              return nn(W, z, Oe);
            case "copy":
              return nn(W, I, Oe);
            case "paste":
              return nn(W, s, Oe);
            case "dragstart":
              return nn(W, E, Oe);
            case "dragover":
              return nn(W, x, Oe);
            case "dragend":
              return nn(W, k, Oe);
            case "focus":
              return nn(W, U, Oe);
            case "blur":
              return nn(W, H, Oe);
            case "drop":
              return nn(W, A, Oe);
          }
      };
      te.addEventListener(ye, Ce), X.push(() => {
        te.removeEventListener(ye, Ce);
      });
    }
  }
  function Cn(te) {
    cp !== 0 && (cp--, cp === 0 && te.ownerDocument.removeEventListener("selectionchange", Mt));
    const W = te.__lexicalEditor;
    W != null && (ro(W), te.__lexicalEditor = null);
    const X = $t(te);
    for (let se = 0; se < X.length; se++)
      X[se]();
    te.__lexicalEventHandles = [];
  }
  function ro(te) {
    if (te._parentEditor !== null) {
      const W = Ju(te), se = W[W.length - 1]._key;
      Vt.get(se) === te && Vt.delete(se);
    } else
      Vt.delete(te._key);
  }
  function Uo() {
    Nl = !0;
  }
  function Oi(te, W, X, se, ye) {
    zl = [te, W, X, se, ye];
  }
  function ga(te, W, X) {
    _s();
    const se = te.__key, ye = te.getParent();
    if (ye === null)
      return;
    const we = uu(te);
    let Ce = !1;
    if (so(we) && W) {
      const Oe = we.anchor, Ye = we.focus;
      Oe.key === se && (gi(Oe, te, ye, te.getPreviousSibling(), te.getNextSibling()), Ce = !0), Ye.key === se && (gi(Ye, te, ye, te.getPreviousSibling(), te.getNextSibling()), Ce = !0);
    }
    if (so(we) && W && !Ce) {
      const Oe = te.getIndexWithinParent();
      Pr(te), Ni(we, ye, Oe, -1);
    } else
      Pr(te);
    !X && !Ma(ye) && !ye.canBeEmpty() && ye.isEmpty() && ga(ye, W), W && Qa(ye) && ye.isEmpty() && ye.selectEnd();
  }
  class bc {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Flow doesn't support abstract classes unfortunately, so we can't _force_
    // subclasses of Node to implement statics. All subclasses of Node should have
    // a static getType and clone method though. We define getType and clone here so we can call it
    // on any  Node, and we throw this error by default since the subclass should provide
    // their own implementation.
    /**
     * Returns the string type of this node. Every node must
     * implement this and it MUST BE UNIQUE amongst nodes registered
     * on the editor.
     *
     */
    static getType() {
      throw Error(`LexicalNode: Node ${this.name} does not implement .getType().`);
    }
    /**
     * Clones this node, creating a new node with a different key
     * and adding it to the EditorState (but not attaching it anywhere!). All nodes must
     * implement this method.
     *
     */
    static clone(W) {
      throw Error(`LexicalNode: Node ${this.name} does not implement .clone().`);
    }
    constructor(W) {
      this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, Q_(this, W), this.__type !== "root" && (_s(), ld(
        this.__type,
        // @ts-expect-error
        this.constructor
      ));
    }
    // Getters and Traversers
    /**
     * Returns the string type of this node.
     */
    getType() {
      return this.__type;
    }
    /**
     * Returns true if there is a path between this node and the RootNode, false otherwise.
     * This is a way of determining if the node is "attached" EditorState. Unattached nodes
     * won't be reconciled and will ultimatelt be cleaned up by the Lexical GC.
     */
    isAttached() {
      let W = this.__key;
      for (; W !== null; ) {
        if (W === "root")
          return !0;
        const X = mi(W);
        if (X === null)
          break;
        W = X.__parent;
      }
      return !1;
    }
    /**
     * Returns true if this node is contained within the provided Selection., false otherwise.
     * Relies on the algorithms implemented in {@link BaseSelection.getNodes} to determine
     * what's included.
     *
     * @param selection - The selection that we want to determine if the node is in.
     */
    isSelected(W) {
      const X = W || yo();
      if (X == null)
        return !1;
      const se = X.getNodes().some((ye) => ye.__key === this.__key);
      return Wn(this) ? se : so(X) && X.anchor.type === "element" && X.focus.type === "element" && X.anchor.key === X.focus.key && X.anchor.offset === X.focus.offset ? !1 : se;
    }
    /**
     * Returns this nodes key.
     */
    getKey() {
      return this.__key;
    }
    /**
     * Returns the zero-based index of this node within the parent.
     */
    getIndexWithinParent() {
      const W = this.getParent();
      if (W === null)
        return -1;
      let X = W.getFirstChild(), se = 0;
      for (; X !== null; ) {
        if (this.is(X))
          return se;
        se++, X = X.getNextSibling();
      }
      return -1;
    }
    /**
     * Returns the parent of this node, or null if none is found.
     */
    getParent() {
      const W = this.getLatest().__parent;
      return W === null ? null : mi(W);
    }
    /**
     * Returns the parent of this node, or throws if none is found.
     */
    getParentOrThrow() {
      const W = this.getParent();
      if (W === null)
        throw Error(`Expected node ${this.__key} to have a parent.`);
      return W;
    }
    /**
     * Returns the highest (in the EditorState tree)
     * non-root ancestor of this node, or null if none is found. See {@link lexical!$isRootOrShadowRoot}
     * for more information on which Elements comprise "roots".
     */
    getTopLevelElement() {
      let W = this;
      for (; W !== null; ) {
        const X = W.getParent();
        if (Ma(X))
          return W;
        W = X;
      }
      return null;
    }
    /**
     * Returns the highest (in the EditorState tree)
     * non-root ancestor of this node, or throws if none is found. See {@link lexical!$isRootOrShadowRoot}
     * for more information on which Elements comprise "roots".
     */
    getTopLevelElementOrThrow() {
      const W = this.getTopLevelElement();
      if (W === null)
        throw Error(`Expected node ${this.__key} to have a top parent element.`);
      return W;
    }
    /**
     * Returns a list of the every ancestor of this node,
     * all the way up to the RootNode.
     *
     */
    getParents() {
      const W = [];
      let X = this.getParent();
      for (; X !== null; )
        W.push(X), X = X.getParent();
      return W;
    }
    /**
     * Returns a list of the keys of every ancestor of this node,
     * all the way up to the RootNode.
     *
     */
    getParentKeys() {
      const W = [];
      let X = this.getParent();
      for (; X !== null; )
        W.push(X.__key), X = X.getParent();
      return W;
    }
    /**
     * Returns the "previous" siblings - that is, the node that comes
     * before this one in the same parent.
     *
     */
    getPreviousSibling() {
      const X = this.getLatest().__prev;
      return X === null ? null : mi(X);
    }
    /**
     * Returns the "previous" siblings - that is, the nodes that come between
     * this one and the first child of it's parent, inclusive.
     *
     */
    getPreviousSiblings() {
      const W = [], X = this.getParent();
      if (X === null)
        return W;
      let se = X.getFirstChild();
      for (; se !== null && !se.is(this); )
        W.push(se), se = se.getNextSibling();
      return W;
    }
    /**
     * Returns the "next" siblings - that is, the node that comes
     * after this one in the same parent
     *
     */
    getNextSibling() {
      const X = this.getLatest().__next;
      return X === null ? null : mi(X);
    }
    /**
     * Returns all "next" siblings - that is, the nodes that come between this
     * one and the last child of it's parent, inclusive.
     *
     */
    getNextSiblings() {
      const W = [];
      let X = this.getNextSibling();
      for (; X !== null; )
        W.push(X), X = X.getNextSibling();
      return W;
    }
    /**
     * Returns the closest common ancestor of this node and the provided one or null
     * if one cannot be found.
     *
     * @param node - the other node to find the common ancestor of.
     */
    getCommonAncestor(W) {
      const X = this.getParents(), se = W.getParents();
      dn(this) && X.unshift(this), dn(W) && se.unshift(W);
      const ye = X.length, we = se.length;
      if (ye === 0 || we === 0 || X[ye - 1] !== se[we - 1])
        return null;
      const Ce = new Set(se);
      for (let Oe = 0; Oe < ye; Oe++) {
        const Ye = X[Oe];
        if (Ce.has(Ye))
          return Ye;
      }
      return null;
    }
    /**
     * Returns true if the provided node is the exact same one as this node, from Lexical's perspective.
     * Always use this instead of referential equality.
     *
     * @param object - the node to perform the equality comparison on.
     */
    is(W) {
      return W == null ? !1 : this.__key === W.__key;
    }
    /**
     * Returns true if this node logical precedes the target node in the editor state.
     *
     * @param targetNode - the node we're testing to see if it's after this one.
     */
    isBefore(W) {
      if (this === W)
        return !1;
      if (W.isParentOf(this))
        return !0;
      if (this.isParentOf(W))
        return !1;
      const X = this.getCommonAncestor(W);
      let se = 0, ye = 0, we = this;
      for (; ; ) {
        const Ce = we.getParentOrThrow();
        if (Ce === X) {
          se = we.getIndexWithinParent();
          break;
        }
        we = Ce;
      }
      for (we = W; ; ) {
        const Ce = we.getParentOrThrow();
        if (Ce === X) {
          ye = we.getIndexWithinParent();
          break;
        }
        we = Ce;
      }
      return se < ye;
    }
    /**
     * Returns true if this node is the parent of the target node, false otherwise.
     *
     * @param targetNode - the would-be child node.
     */
    isParentOf(W) {
      const X = this.__key;
      if (X === W.__key)
        return !1;
      let se = W;
      for (; se !== null; ) {
        if (se.__key === X)
          return !0;
        se = se.getParent();
      }
      return !1;
    }
    // TO-DO: this function can be simplified a lot
    /**
     * Returns a list of nodes that are between this node and
     * the target node in the EditorState.
     *
     * @param targetNode - the node that marks the other end of the range of nodes to be returned.
     */
    getNodesBetween(W) {
      const X = this.isBefore(W), se = [], ye = /* @__PURE__ */ new Set();
      let we = this;
      for (; ; ) {
        const Ce = we.__key;
        if (ye.has(Ce) || (ye.add(Ce), se.push(we)), we === W)
          break;
        const Oe = dn(we) ? X ? we.getFirstChild() : we.getLastChild() : null;
        if (Oe !== null) {
          we = Oe;
          continue;
        }
        const Ye = X ? we.getNextSibling() : we.getPreviousSibling();
        if (Ye !== null) {
          we = Ye;
          continue;
        }
        const Ke = we.getParentOrThrow();
        if (ye.has(Ke.__key) || se.push(Ke), Ke === W)
          break;
        let rt = null, ut = Ke;
        do {
          if (ut === null)
            throw Error("getNodesBetween: ancestor is null");
          rt = X ? ut.getNextSibling() : ut.getPreviousSibling(), ut = ut.getParent(), ut !== null && rt === null && !ye.has(ut.__key) && se.push(ut);
        } while (rt === null);
        we = rt;
      }
      return X || se.reverse(), se;
    }
    /**
     * Returns true if this node has been marked dirty during this update cycle.
     *
     */
    isDirty() {
      const X = Yi()._dirtyLeaves;
      return X !== null && X.has(this.__key);
    }
    /**
     * Returns the latest version of the node from the active EditorState.
     * This is used to avoid getting values from stale node references.
     *
     */
    getLatest() {
      const W = mi(this.__key);
      if (W === null)
        throw Error("Lexical node does not exist in active editor state. Avoid using the same node references between nested closures from editorState.read/editor.update.");
      return W;
    }
    /**
     * Returns a mutable version of the node. Will throw an error if
     * called outside of a Lexical Editor {@link LexicalEditor.update} callback.
     *
     */
    getWritable() {
      _s();
      const W = Ja(), X = Yi(), se = W._nodeMap, ye = this.__key, we = this.getLatest(), Ce = we.__parent, Oe = X._cloneNotNeeded, Ye = yo();
      if (Ye !== null && (Ye._cachedNodes = null), Oe.has(ye))
        return ji(we), we;
      const rt = we.constructor.clone(we);
      return rt.__parent = Ce, rt.__next = we.__next, rt.__prev = we.__prev, dn(we) && dn(rt) ? (rt.__first = we.__first, rt.__last = we.__last, rt.__size = we.__size, rt.__indent = we.__indent, rt.__format = we.__format, rt.__dir = we.__dir) : Wn(we) && Wn(rt) && (rt.__format = we.__format, rt.__style = we.__style, rt.__mode = we.__mode, rt.__detail = we.__detail), Oe.add(ye), rt.__key = ye, ji(rt), se.set(ye, rt), rt;
    }
    /**
     * Returns the text content of the node. Override this for
     * custom nodes that should have a representation in plain text
     * format (for copy + paste, for example)
     *
     */
    getTextContent() {
      return "";
    }
    /**
     * Returns the length of the string produced by calling getTextContent on this node.
     *
     */
    getTextContentSize() {
      return this.getTextContent().length;
    }
    // View
    /**
     * Called during the reconciliation process to determine which nodes
     * to insert into the DOM for this Lexical Node.
     *
     * This method must return exactly one HTMLElement. Nested elements are not supported.
     *
     * Do not attempt to update the Lexical EditorState during this phase of the update lifecyle.
     *
     * @param _config - allows access to things like the EditorTheme (to apply classes) during reconciliation.
     * @param _editor - allows access to the editor for context during reconciliation.
     *
     * */
    createDOM(W, X) {
      throw Error("createDOM: base method not extended");
    }
    /**
     * Called when a node changes and should update the DOM
     * in whatever way is necessary to make it align with any changes that might
     * have happened during the update.
     *
     * Returning "true" here will cause lexical to unmount and recreate the DOM node
     * (by calling createDOM). You would need to do this if the element tag changes,
     * for instance.
     *
     * */
    updateDOM(W, X, se) {
      throw Error("updateDOM: base method not extended");
    }
    /**
     * Controls how the this node is serialized to HTML. This is important for
     * copy and paste between Lexical and non-Lexical editors, or Lexical editors with different namespaces,
     * in which case the primary transfer format is HTML. It's also important if you're serializing
     * to HTML for any other reason via {@link @lexical/html!$generateHtmlFromNodes}. You could
     * also use this method to build your own HTML renderer.
     *
     * */
    exportDOM(W) {
      return {
        element: this.createDOM(W._config, W)
      };
    }
    /**
     * Controls how the this node is serialized to JSON. This is important for
     * copy and paste between Lexical editors sharing the same namespace. It's also important
     * if you're serializing to JSON for persistent storage somewhere.
     * See [Serialization & Deserialization](https://lexical.dev/docs/concepts/serialization#lexical---html).
     *
     * */
    exportJSON() {
      throw Error("exportJSON: base method not extended");
    }
    /**
     * Controls how the this node is deserialized from JSON. This is usually boilerplate,
     * but provides an abstraction betweent he node implementation and serialized interfaec that can
     * be important if you ever make breaking changes to a node schema (by adding or removing properties).
     * See [Serialization & Deserialization](https://lexical.dev/docs/concepts/serialization#lexical---html).
     *
     * */
    static importJSON(W) {
      throw Error(`LexicalNode: Node ${this.name} does not implement .importJSON().`);
    }
    /**
     * @experimental
     *
     * Registers the returned function as a transform on the node during
     * Editor initialization. Most such use cases should be addressed via
     * the {@link LexicalEditor.registerNodeTransform} API.
     *
     * Experimental - use at your own risk.
     */
    static transform() {
      return null;
    }
    // Setters and mutators
    /**
     * Removes this LexicalNode from the EditorState. If the node isn't re-inserted
     * somewhere, the Lexical garbage collector will eventually clean it up.
     *
     * @param preserveEmptyParent - If falsy, the node's parent will be removed if
     * it's empty after the removal operation. This is the default behavior, subject to
     * other node heuristics such as {@link ElementNode#canBeEmpty}
     * */
    remove(W) {
      ga(this, !0, W);
    }
    /**
     * Replaces this LexicalNode with the provided node, optionally transferring the children
     * of the replaced node to the replacing node.
     *
     * @param replaceWith - The node to replace this one with.
     * @param includeChildren - Whether or not to transfer the children of this node to the replacing node.
     * */
    replace(W, X) {
      _s();
      let se = yo();
      se !== null && (se = se.clone()), Il(this, W);
      const ye = this.getLatest(), we = this.__key, Ce = W.__key, Oe = W.getWritable(), Ye = this.getParentOrThrow().getWritable(), Ke = Ye.__size;
      Pr(Oe);
      const rt = ye.getPreviousSibling(), ut = ye.getNextSibling(), _t = ye.__prev, ct = ye.__next, Lt = ye.__parent;
      if (ga(ye, !1, !0), rt === null)
        Ye.__first = Ce;
      else {
        const St = rt.getWritable();
        St.__next = Ce;
      }
      if (Oe.__prev = _t, ut === null)
        Ye.__last = Ce;
      else {
        const St = ut.getWritable();
        St.__prev = Ce;
      }
      if (Oe.__next = ct, Oe.__parent = Lt, Ye.__size = Ke, X && this.getChildren().forEach((St) => {
        Oe.append(St);
      }), so(se)) {
        Co(se);
        const St = se.anchor, jt = se.focus;
        St.key === we && s_(St, Oe), jt.key === we && s_(jt, Oe);
      }
      return Xr() === we && Or(Ce), Oe;
    }
    /**
     * Inserts a node after this LexicalNode (as the next sibling).
     *
     * @param nodeToInsert - The node to insert after this one.
     * @param restoreSelection - Whether or not to attempt to resolve the
     * selection to the appropriate place after the operation is complete.
     * */
    insertAfter(W, X = !0) {
      _s(), Il(this, W);
      const se = this.getWritable(), ye = W.getWritable(), we = ye.getParent(), Ce = yo();
      let Oe = !1, Ye = !1;
      if (we !== null) {
        const ct = W.getIndexWithinParent();
        if (Pr(ye), so(Ce)) {
          const Lt = we.__key, St = Ce.anchor, jt = Ce.focus;
          Oe = St.type === "element" && St.key === Lt && St.offset === ct + 1, Ye = jt.type === "element" && jt.key === Lt && jt.offset === ct + 1;
        }
      }
      const Ke = this.getNextSibling(), rt = this.getParentOrThrow().getWritable(), ut = ye.__key, _t = se.__next;
      if (Ke === null)
        rt.__last = ut;
      else {
        const ct = Ke.getWritable();
        ct.__prev = ut;
      }
      if (rt.__size++, se.__next = ut, ye.__next = _t, ye.__prev = se.__key, ye.__parent = se.__parent, X && so(Ce)) {
        const ct = this.getIndexWithinParent();
        Ni(Ce, rt, ct + 1);
        const Lt = rt.__key;
        Oe && Ce.anchor.set(Lt, ct + 2, "element"), Ye && Ce.focus.set(Lt, ct + 2, "element");
      }
      return W;
    }
    /**
     * Inserts a node before this LexicalNode (as the previous sibling).
     *
     * @param nodeToInsert - The node to insert after this one.
     * @param restoreSelection - Whether or not to attempt to resolve the
     * selection to the appropriate place after the operation is complete.
     * */
    insertBefore(W, X = !0) {
      _s(), Il(this, W);
      const se = this.getWritable(), ye = W.getWritable(), we = ye.__key;
      Pr(ye);
      const Ce = this.getPreviousSibling(), Oe = this.getParentOrThrow().getWritable(), Ye = se.__prev, Ke = this.getIndexWithinParent();
      if (Ce === null)
        Oe.__first = we;
      else {
        const ut = Ce.getWritable();
        ut.__next = we;
      }
      Oe.__size++, se.__prev = we, ye.__prev = Ye, ye.__next = se.__key, ye.__parent = se.__parent;
      const rt = yo();
      if (X && so(rt)) {
        const ut = this.getParentOrThrow();
        Ni(rt, ut, Ke);
      }
      return W;
    }
    /**
     * Whether or not this node has a required parent. Used during copy + paste operations
     * to normalize nodes that would otherwise be orphaned. For example, ListItemNodes without
     * a ListNode parent or TextNodes with a ParagraphNode parent.
     *
     * */
    isParentRequired() {
      return !1;
    }
    /**
     * The creation logic for any required parent. Should be implemented if {@link isParentRequired} returns true.
     *
     * */
    createParentElementNode() {
      return u_();
    }
    /**
     * Moves selection to the previous sibling of this node, at the specified offsets.
     *
     * @param anchorOffset - The anchor offset for selection.
     * @param focusOffset -  The focus offset for selection
     * */
    selectPrevious(W, X) {
      _s();
      const se = this.getPreviousSibling(), ye = this.getParentOrThrow();
      if (se === null)
        return ye.select(0, 0);
      if (dn(se))
        return se.select();
      if (!Wn(se)) {
        const we = se.getIndexWithinParent() + 1;
        return ye.select(we, we);
      }
      return se.select(W, X);
    }
    /**
     * Moves selection to the next sibling of this node, at the specified offsets.
     *
     * @param anchorOffset - The anchor offset for selection.
     * @param focusOffset -  The focus offset for selection
     * */
    selectNext(W, X) {
      _s();
      const se = this.getNextSibling(), ye = this.getParentOrThrow();
      if (se === null)
        return ye.select();
      if (dn(se))
        return se.select(0, 0);
      if (!Wn(se)) {
        const we = se.getIndexWithinParent();
        return ye.select(we, we);
      }
      return se.select(W, X);
    }
    /**
     * Marks a node dirty, triggering transforms and
     * forcing it to be reconciled during the update cycle.
     *
     * */
    markDirty() {
      this.getWritable();
    }
  }
  function ld(te, W) {
    const X = Yi()._nodes.get(te);
    if (X === void 0)
      throw Error(`Create node: Attempted to create node ${W.name} that was not configured to be used on the editor.`);
    const se = X.klass;
    if (se !== W)
      throw Error(`Create node: Type ${te} in node ${W.name} does not match registered node ${se.name} with the same type`);
  }
  class jv {
    constructor(W, X, se) {
      this._selection = null, this.key = W, this.offset = X, this.type = se;
    }
    is(W) {
      return this.key === W.key && this.offset === W.offset && this.type === W.type;
    }
    isBefore(W) {
      let X = this.getNode(), se = W.getNode();
      const ye = this.offset, we = W.offset;
      if (dn(X)) {
        const Ce = X.getDescendantByIndex(ye);
        X = Ce ?? X;
      }
      if (dn(se)) {
        const Ce = se.getDescendantByIndex(we);
        se = Ce ?? se;
      }
      return X === se ? ye < we : X.isBefore(se);
    }
    getNode() {
      const W = this.key, X = mi(W);
      if (X === null)
        throw Error("Point.getNode: node not found");
      return X;
    }
    set(W, X, se) {
      const ye = this._selection, we = this.key;
      this.key = W, this.offset = X, this.type = se, qf() || (Xr() === we && Or(W), ye !== null && (ye._cachedNodes = null, ye.dirty = !0));
    }
  }
  function Js(te, W, X) {
    return new jv(te, W, X);
  }
  function Yg(te, W) {
    let X = W.__key, se = te.offset, ye = "element";
    if (Wn(W)) {
      ye = "text";
      const we = W.getTextContentSize();
      se > we && (se = we);
    } else if (!dn(W)) {
      const we = W.getNextSibling();
      if (Wn(we))
        X = we.__key, se = 0, ye = "text";
      else {
        const Ce = W.getParent();
        Ce && (X = Ce.__key, se = W.getIndexWithinParent() + 1);
      }
    }
    te.set(X, se, ye);
  }
  function s_(te, W) {
    if (dn(W)) {
      const X = W.getLastDescendant();
      dn(X) || Wn(X) ? Yg(te, X) : Yg(te, W);
    } else
      Yg(te, W);
  }
  function us(te, W, X, se) {
    const ye = te.getNode(), we = ye.getChildAtIndex(te.offset), Ce = es(), Oe = Qa(ye) ? u_().append(Ce) : Ce;
    Ce.setFormat(X), Ce.setStyle(se), we === null ? ye.append(Oe) : we.insertBefore(Oe), te.is(W) && W.set(Ce.__key, 0, "text"), te.set(Ce.__key, 0, "text");
  }
  function Qs(te, W, X, se) {
    te.key = W, te.offset = X, te.type = se;
  }
  class Le {
    constructor(W) {
      this.dirty = !1, this._nodes = W, this._cachedNodes = null;
    }
    is(W) {
      if (!ud(W))
        return !1;
      const X = this._nodes, se = W._nodes;
      return X.size === se.size && Array.from(X).every((ye) => se.has(ye));
    }
    add(W) {
      this.dirty = !0, this._nodes.add(W), this._cachedNodes = null;
    }
    delete(W) {
      this.dirty = !0, this._nodes.delete(W), this._cachedNodes = null;
    }
    clear() {
      this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
    }
    has(W) {
      return this._nodes.has(W);
    }
    clone() {
      return new Le(new Set(this._nodes));
    }
    extract() {
      return this.getNodes();
    }
    insertRawText(W) {
    }
    insertText() {
    }
    insertNodes(W, X) {
      const se = this.getNodes(), ye = se.length, we = se[ye - 1];
      let Ce;
      if (Wn(we))
        Ce = we.select();
      else {
        const Oe = we.getIndexWithinParent() + 1;
        Ce = we.getParentOrThrow().select(Oe, Oe);
      }
      Ce.insertNodes(W, X);
      for (let Oe = 0; Oe < ye; Oe++)
        se[Oe].remove();
      return !0;
    }
    getNodes() {
      const W = this._cachedNodes;
      if (W !== null)
        return W;
      const X = this._nodes, se = [];
      for (const ye of X) {
        const we = mi(ye);
        we !== null && se.push(we);
      }
      return qf() || (this._cachedNodes = se), se;
    }
    getTextContent() {
      const W = this.getNodes();
      let X = "";
      for (let se = 0; se < W.length; se++)
        X += W[se].getTextContent();
      return X;
    }
  }
  function so(te) {
    return te instanceof jo;
  }
  class c_ {
    constructor(W, X, se) {
      this.gridKey = W, this.anchor = X, this.focus = se, this.dirty = !1, this._cachedNodes = null, X._selection = this, se._selection = this;
    }
    is(W) {
      return ds(W) ? this.gridKey === W.gridKey && this.anchor.is(W.anchor) && this.focus.is(W.focus) : !1;
    }
    set(W, X, se) {
      this.dirty = !0, this.gridKey = W, this.anchor.key = X, this.focus.key = se, this._cachedNodes = null;
    }
    clone() {
      return new c_(this.gridKey, this.anchor, this.focus);
    }
    isCollapsed() {
      return !1;
    }
    isBackward() {
      return this.focus.isBefore(this.anchor);
    }
    getCharacterOffsets() {
      return up(this);
    }
    extract() {
      return this.getNodes();
    }
    insertRawText(W) {
    }
    insertText() {
    }
    insertNodes(W, X) {
      const se = this.focus.getNode();
      return ip(se.select(0, se.getChildrenSize())).insertNodes(W, X);
    }
    // TODO Deprecate this method. It's confusing when used with colspan|rowspan
    getShape() {
      const W = mi(this.anchor.key);
      if (W === null)
        throw Error("getNodes: expected to find AnchorNode");
      const X = W.getIndexWithinParent(), se = W.getParentOrThrow().getIndexWithinParent(), ye = mi(this.focus.key);
      if (ye === null)
        throw Error("getNodes: expected to find FocusNode");
      const we = ye.getIndexWithinParent(), Ce = ye.getParentOrThrow().getIndexWithinParent(), Oe = Math.min(X, we), Ye = Math.max(X, we), Ke = Math.min(se, Ce), rt = Math.max(se, Ce);
      return {
        fromX: Math.min(Oe, Ye),
        fromY: Math.min(Ke, rt),
        toX: Math.max(Oe, Ye),
        toY: Math.max(Ke, rt)
      };
    }
    getNodes() {
      const W = this._cachedNodes;
      if (W !== null)
        return W;
      const X = this.anchor.getNode(), se = this.focus.getNode(), ye = Is(X, ol), we = Is(se, ol);
      if (!ol(ye))
        throw Error("Expected GridSelection anchor to be (or a child of) GridCellNode");
      if (!ol(we))
        throw Error("Expected GridSelection focus to be (or a child of) GridCellNode");
      const Ce = ye.getParent();
      if (!fs(Ce))
        throw Error("Expected anchorCell to have a parent GridRowNode");
      const Oe = Ce.getParent();
      if (!Kv(Oe))
        throw Error("Expected tableNode to have a parent GridNode");
      const [Ye, Ke, rt] = tl(Oe, ye, we);
      let ut = Math.min(Ke.startColumn, rt.startColumn), _t = Math.min(Ke.startRow, rt.startRow), ct = Math.max(Ke.startColumn + Ke.cell.__colSpan - 1, rt.startColumn + rt.cell.__colSpan - 1), Lt = Math.max(Ke.startRow + Ke.cell.__rowSpan - 1, rt.startRow + rt.cell.__rowSpan - 1), St = ut, jt = _t, bn = ut, Ht = _t;
      function ln(mo) {
        const {
          cell: to,
          startColumn: Go,
          startRow: zs
        } = mo;
        ut = Math.min(ut, Go), _t = Math.min(_t, zs), ct = Math.max(ct, Go + to.__colSpan - 1), Lt = Math.max(Lt, zs + to.__rowSpan - 1);
      }
      for (; ut < St || _t < jt || ct > bn || Lt > Ht; ) {
        if (ut < St) {
          const mo = Ht - jt, to = St - 1;
          for (let Go = 0; Go <= mo; Go++)
            ln(Ye[jt + Go][to]);
          St = to;
        }
        if (_t < jt) {
          const mo = bn - St, to = jt - 1;
          for (let Go = 0; Go <= mo; Go++)
            ln(Ye[to][St + Go]);
          jt = to;
        }
        if (ct > bn) {
          const mo = Ht - jt, to = bn + 1;
          for (let Go = 0; Go <= mo; Go++)
            ln(Ye[jt + Go][to]);
          bn = to;
        }
        if (Lt > Ht) {
          const mo = bn - St, to = Ht + 1;
          for (let Go = 0; Go <= mo; Go++)
            ln(Ye[to][St + Go]);
          Ht = to;
        }
      }
      const $o = [Oe];
      let eo = null;
      for (let mo = _t; mo <= Lt; mo++)
        for (let to = ut; to <= ct; to++) {
          const {
            cell: Go
          } = Ye[mo][to], zs = Go.getParent();
          if (!fs(zs))
            throw Error("Expected GridCellNode parent to be a GridRowNode");
          zs !== eo && $o.push(zs), $o.push(Go, ...Xc(Go)), eo = zs;
        }
      return qf() || (this._cachedNodes = $o), $o;
    }
    getTextContent() {
      const W = this.getNodes();
      let X = "";
      for (let se = 0; se < W.length; se++)
        X += W[se].getTextContent();
      return X;
    }
  }
  function ds(te) {
    return te instanceof c_;
  }
  class jo {
    constructor(W, X, se, ye) {
      this.anchor = W, this.focus = X, this.dirty = !1, this.format = se, this.style = ye, this._cachedNodes = null, W._selection = this, X._selection = this;
    }
    is(W) {
      return so(W) ? this.anchor.is(W.anchor) && this.focus.is(W.focus) && this.format === W.format && this.style === W.style : !1;
    }
    isBackward() {
      return this.focus.isBefore(this.anchor);
    }
    isCollapsed() {
      return this.anchor.is(this.focus);
    }
    getNodes() {
      const W = this._cachedNodes;
      if (W !== null)
        return W;
      const X = this.anchor, se = this.focus, ye = X.isBefore(se), we = ye ? X : se, Ce = ye ? se : X;
      let Oe = we.getNode(), Ye = Ce.getNode();
      const Ke = we.offset, rt = Ce.offset;
      if (dn(Oe)) {
        const _t = Oe.getDescendantByIndex(Ke);
        Oe = _t ?? Oe;
      }
      if (dn(Ye)) {
        let _t = Ye.getDescendantByIndex(rt);
        _t !== null && _t !== Oe && Ye.getChildAtIndex(rt) === _t && (_t = _t.getPreviousSibling()), Ye = _t ?? Ye;
      }
      let ut;
      return Oe.is(Ye) ? dn(Oe) && Oe.getChildrenSize() > 0 ? ut = [] : ut = [Oe] : ut = Oe.getNodesBetween(Ye), qf() || (this._cachedNodes = ut), ut;
    }
    setTextNodeRange(W, X, se, ye) {
      Qs(this.anchor, W.__key, X, "text"), Qs(this.focus, se.__key, ye, "text"), this._cachedNodes = null, this.dirty = !0;
    }
    getTextContent() {
      const W = this.getNodes();
      if (W.length === 0)
        return "";
      const X = W[0], se = W[W.length - 1], ye = this.anchor, we = this.focus, Ce = ye.isBefore(we), [Oe, Ye] = up(this);
      let Ke = "", rt = !0;
      for (let ut = 0; ut < W.length; ut++) {
        const _t = W[ut];
        if (dn(_t) && !_t.isInline())
          rt || (Ke += `
`), _t.isEmpty() ? rt = !1 : rt = !0;
        else if (rt = !1, Wn(_t)) {
          let ct = _t.getTextContent();
          _t === X ? _t === se ? (ye.type !== "element" || we.type !== "element" || we.offset === ye.offset) && (ct = Oe < Ye ? ct.slice(Oe, Ye) : ct.slice(Ye, Oe)) : ct = Ce ? ct.slice(Oe) : ct.slice(Ye) : _t === se && (ct = Ce ? ct.slice(0, Ye) : ct.slice(0, Oe)), Ke += ct;
        } else
          (hi(_t) || oh(_t)) && (_t !== se || !this.isCollapsed()) && (Ke += _t.getTextContent());
      }
      return Ke;
    }
    applyDOMRange(W) {
      const X = Yi(), ye = X.getEditorState()._selection, we = bm(W.startContainer, W.startOffset, W.endContainer, W.endOffset, X, ye);
      if (we === null)
        return;
      const [Ce, Oe] = we;
      Qs(this.anchor, Ce.key, Ce.offset, Ce.type), Qs(this.focus, Oe.key, Oe.offset, Oe.type), this._cachedNodes = null;
    }
    clone() {
      const W = this.anchor, X = this.focus;
      return new jo(Js(W.key, W.offset, W.type), Js(X.key, X.offset, X.type), this.format, this.style);
    }
    toggleFormat(W) {
      this.format = Ka(this.format, W, null), this.dirty = !0;
    }
    setStyle(W) {
      this.style = W, this.dirty = !0;
    }
    hasFormat(W) {
      const X = In[W];
      return (this.format & X) !== 0;
    }
    insertRawText(W) {
      const X = W.split(/\r?\n/);
      if (X.length === 1)
        this.insertText(W);
      else {
        const se = [], ye = X.length;
        for (let we = 0; we < ye; we++) {
          const Ce = X[we];
          Ce !== "" && se.push(es(Ce)), we !== ye - 1 && se.push(xm());
        }
        this.insertNodes(se);
      }
    }
    insertText(W) {
      const X = this.anchor, se = this.focus, ye = this.isCollapsed() || X.isBefore(se), we = this.format, Ce = this.style;
      ye && X.type === "element" ? us(X, se, we, Ce) : !ye && se.type === "element" && us(se, X, we, Ce);
      const Oe = this.getNodes(), Ye = Oe.length, Ke = ye ? X : se, rt = ye ? se : X, ut = Ke.offset, _t = rt.offset;
      let ct = Oe[0];
      if (!Wn(ct))
        throw Error("insertText: first node is not a text node");
      const St = ct.getTextContent().length, jt = ct.getParentOrThrow(), bn = Ye - 1;
      let Ht = Oe[bn];
      if (this.isCollapsed() && ut === St && (ct.isSegmented() || ct.isToken() || !ct.canInsertTextAfter() || !jt.canInsertTextAfter() && ct.getNextSibling() === null)) {
        let ln = ct.getNextSibling();
        if ((!Wn(ln) || er(ln)) && (ln = es(), ln.setFormat(we), jt.canInsertTextAfter() ? ct.insertAfter(ln) : jt.insertAfter(ln)), ln.select(0, 0), ct = ln, W !== "") {
          this.insertText(W);
          return;
        }
      } else if (this.isCollapsed() && ut === 0 && (ct.isSegmented() || ct.isToken() || !ct.canInsertTextBefore() || !jt.canInsertTextBefore() && ct.getPreviousSibling() === null)) {
        let ln = ct.getPreviousSibling();
        if ((!Wn(ln) || er(ln)) && (ln = es(), ln.setFormat(we), jt.canInsertTextBefore() ? ct.insertBefore(ln) : jt.insertBefore(ln)), ln.select(), ct = ln, W !== "") {
          this.insertText(W);
          return;
        }
      } else if (ct.isSegmented() && ut !== St) {
        const ln = es(ct.getTextContent());
        ln.setFormat(we), ct.replace(ln), ct = ln;
      } else if (!this.isCollapsed() && W !== "") {
        const ln = Ht.getParent();
        if (!jt.canInsertTextBefore() || !jt.canInsertTextAfter() || dn(ln) && (!ln.canInsertTextBefore() || !ln.canInsertTextAfter())) {
          this.insertText(""), Ff(this.anchor, this.focus, null), this.insertText(W);
          return;
        }
      }
      if (Ye === 1) {
        if (ct.isToken()) {
          const mo = es(W);
          mo.select(), ct.replace(mo);
          return;
        }
        const ln = ct.getFormat(), $o = ct.getStyle();
        if (ut === _t && (ln !== we || $o !== Ce))
          if (ct.getTextContent() === "")
            ct.setFormat(we), ct.setStyle(Ce);
          else {
            const mo = es(W);
            if (mo.setFormat(we), mo.setStyle(Ce), mo.select(), ut === 0)
              ct.insertBefore(mo, !1);
            else {
              const [to] = ct.splitText(ut);
              to.insertAfter(mo, !1);
            }
            mo.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= W.length);
            return;
          }
        const eo = _t - ut;
        ct = ct.spliceText(ut, eo, W, !0), ct.getTextContent() === "" ? ct.remove() : this.anchor.type === "text" && (ct.isComposing() ? this.anchor.offset -= W.length : (this.format = ln, this.style = $o));
      } else {
        const ln = /* @__PURE__ */ new Set([...ct.getParentKeys(), ...Ht.getParentKeys()]), $o = dn(ct) ? ct : ct.getParentOrThrow();
        let eo = dn(Ht) ? Ht : Ht.getParentOrThrow(), mo = Ht;
        if (!$o.is(eo) && eo.isInline())
          do
            mo = eo, eo = eo.getParentOrThrow();
          while (eo.isInline());
        if (rt.type === "text" && (_t !== 0 || Ht.getTextContent() === "") || rt.type === "element" && Ht.getIndexWithinParent() < _t)
          if (Wn(Ht) && !Ht.isToken() && _t !== Ht.getTextContentSize()) {
            if (Ht.isSegmented()) {
              const Tr = es(Ht.getTextContent());
              Ht.replace(Tr), Ht = Tr;
            }
            Ht = Ht.spliceText(0, _t, ""), ln.add(Ht.__key);
          } else {
            const Tr = Ht.getParentOrThrow();
            !Tr.canBeEmpty() && Tr.getChildrenSize() === 1 ? Tr.remove() : Ht.remove();
          }
        else
          ln.add(Ht.__key);
        const to = eo.getChildren(), Go = new Set(Oe), zs = $o.is(eo), kc = $o.isInline() && ct.getNextSibling() === null ? $o : ct;
        for (let Tr = to.length - 1; Tr >= 0; Tr--) {
          const ia = to[Tr];
          if (ia.is(ct) || dn(ia) && ia.isParentOf(ct))
            break;
          ia.isAttached() && (!Go.has(ia) || ia.is(mo) ? zs || kc.insertAfter(ia, !1) : ia.remove());
        }
        if (!zs) {
          let Tr = eo, ia = null;
          for (; Tr !== null; ) {
            const Dl = Tr.getChildren(), fd = Dl.length;
            (fd === 0 || Dl[fd - 1].is(ia)) && (ln.delete(Tr.__key), ia = Tr), Tr = Tr.getParent();
          }
        }
        if (!ct.isToken())
          ct = ct.spliceText(ut, St - ut, W, !0), ct.getTextContent() === "" ? ct.remove() : ct.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= W.length);
        else if (ut === St)
          ct.select();
        else {
          const Tr = es(W);
          Tr.select(), ct.replace(Tr);
        }
        for (let Tr = 1; Tr < Ye; Tr++) {
          const ia = Oe[Tr], Dl = ia.__key;
          ln.has(Dl) || ia.remove();
        }
      }
    }
    removeText() {
      this.insertText("");
    }
    formatText(W) {
      if (this.isCollapsed()) {
        this.toggleFormat(W), Or(null);
        return;
      }
      const X = this.getNodes(), se = [];
      for (const Ht of X)
        Wn(Ht) && se.push(Ht);
      const ye = se.length;
      if (ye === 0) {
        this.toggleFormat(W), Or(null);
        return;
      }
      const we = this.anchor, Ce = this.focus, Oe = this.isBackward(), Ye = Oe ? Ce : we, Ke = Oe ? we : Ce;
      let rt = 0, ut = se[0], _t = Ye.type === "element" ? 0 : Ye.offset;
      if (Ye.type === "text" && _t === ut.getTextContentSize() && (rt = 1, ut = se[1], _t = 0), ut == null)
        return;
      const ct = ut.getFormatFlags(W, null), Lt = ye - 1;
      let St = se[Lt];
      const jt = Ke.type === "text" ? Ke.offset : St.getTextContentSize();
      if (ut.is(St)) {
        if (_t === jt)
          return;
        if (_t === 0 && jt === ut.getTextContentSize())
          ut.setFormat(ct);
        else {
          const Ht = ut.splitText(_t, jt), ln = _t === 0 ? Ht[0] : Ht[1];
          ln.setFormat(ct), Ye.type === "text" && Ye.set(ln.__key, 0, "text"), Ke.type === "text" && Ke.set(ln.__key, jt - _t, "text");
        }
        this.format = ct;
        return;
      }
      _t !== 0 && ([, ut] = ut.splitText(_t), _t = 0), ut.setFormat(ct);
      const bn = St.getFormatFlags(W, ct);
      jt > 0 && (jt !== St.getTextContentSize() && ([St] = St.splitText(jt)), St.setFormat(bn));
      for (let Ht = rt + 1; Ht < Lt; Ht++) {
        const ln = se[Ht];
        if (!ln.isToken()) {
          const $o = ln.getFormatFlags(W, bn);
          ln.setFormat($o);
        }
      }
      Ye.type === "text" && Ye.set(ut.__key, _t, "text"), Ke.type === "text" && Ke.set(St.__key, jt, "text"), this.format = ct | bn;
    }
    insertNodes(W, X) {
      if (!this.isCollapsed()) {
        const Lt = this.isBackward() ? this.anchor : this.focus, St = Lt.getNode().getNextSibling(), jt = St ? St.getKey() : null, bn = Lt.getNode().getPreviousSibling(), Ht = bn ? bn.getKey() : null;
        if (this.removeText(), this.isCollapsed() && this.focus.type === "element") {
          let ln;
          this.focus.key === jt && this.focus.offset === 0 ? (ln = es(), this.focus.getNode().insertBefore(ln)) : this.focus.key === Ht && this.focus.offset === this.focus.getNode().getChildrenSize() && (ln = es(), this.focus.getNode().insertAfter(ln)), ln && (this.focus.set(ln.__key, 0, "text"), this.anchor.set(ln.__key, 0, "text"));
        }
      }
      const se = this.anchor, ye = se.offset, we = se.getNode();
      let Ce = we;
      if (se.type === "element") {
        const Lt = se.getNode(), St = Lt.getChildAtIndex(ye - 1);
        St === null ? Ce = Lt : Ce = St;
      }
      const Oe = [], Ye = we.getNextSiblings(), Ke = Ma(we) ? null : we.getTopLevelElementOrThrow();
      if (Wn(we)) {
        const St = we.getTextContent().length;
        if (ye === 0 && St !== 0) {
          const jt = we.getPreviousSibling();
          jt !== null ? Ce = jt : Ce = we.getParentOrThrow(), Oe.push(we);
        } else if (ye === St)
          Ce = we;
        else {
          if (we.isToken())
            return !1;
          {
            let jt;
            [Ce, jt] = we.splitText(ye), Oe.push(jt);
          }
        }
      }
      const rt = Ce;
      Oe.push(...Ye);
      const ut = W[0];
      let _t = !1, ct = null;
      for (let Lt = 0; Lt < W.length; Lt++) {
        const St = W[Lt];
        if (!Ma(Ce) && !hi(Ce) && dn(St) && !St.isInline()) {
          if (St.is(ut)) {
            if (dn(Ce) && Ce.isEmpty() && Ce.canReplaceWith(St)) {
              Ce.replace(St), Ce = St, _t = !0;
              continue;
            }
            const jt = St.getFirstDescendant();
            if (Wc(jt)) {
              let bn = jt.getParentOrThrow();
              for (; bn.isInline(); )
                bn = bn.getParentOrThrow();
              const Ht = bn.getChildren(), ln = Ht.length;
              if (dn(Ce)) {
                let $o = Ce.getFirstChild();
                for (let eo = 0; eo < ln; eo++) {
                  const mo = Ht[eo];
                  $o === null ? Ce.append(mo) : $o.insertAfter(mo), $o = mo;
                }
              } else {
                for (let $o = ln - 1; $o >= 0; $o--)
                  Ce.insertAfter(Ht[$o]);
                Ce = Ce.getParentOrThrow();
              }
              if (ct = Ht[ln - 1], bn.remove(), _t = !0, bn.is(St))
                continue;
            }
          }
          if (Wn(Ce)) {
            if (Ke === null)
              throw Error("insertNode: topLevelElement is root node");
            Ce = Ke;
          }
        } else if (_t && !dn(St) && !hi(St) && Ma(Ce.getParent()))
          throw Error("insertNodes: cannot insert a non-element into a root node");
        if (_t = !1, dn(Ce) && !Ce.isInline())
          if (ct = St, hi(St) && !St.isInline())
            Ce = Ce.insertAfter(St, !1);
          else if (dn(St)) {
            if (!St.canBeEmpty() && St.isEmpty())
              continue;
            if (Qa(Ce)) {
              const jt = Ce.getChildAtIndex(ye);
              jt !== null ? jt.insertBefore(St) : Ce.append(St), Ce = St;
            } else
              St.isInline() ? (Ce.append(St), Ce = St) : Ce = Ce.insertAfter(St, !1);
          } else {
            const jt = Ce.getFirstChild();
            jt !== null ? jt.insertBefore(St) : Ce.append(St), Ce = St;
          }
        else if (!dn(St) || dn(St) && St.isInline() || hi(Ce) && !Ce.isInline())
          if (ct = St, so(this) && hi(St) && (dn(Ce) || Wn(Ce)) && !St.isInline()) {
            let jt, bn;
            if (Wn(Ce)) {
              jt = Ce.getParentOrThrow();
              const [ln] = Ce.splitText(ye);
              bn = ln.getIndexWithinParent() + 1;
            } else
              jt = Ce, bn = ye;
            const [, Ht] = fa(jt, bn);
            Ce = Ht.insertBefore(St);
          } else
            Ce = Ce.insertAfter(St, !1);
        else {
          const jt = Ce.getParentOrThrow();
          oh(Ce) && Ce.remove(), Ce = jt, Lt--;
          continue;
        }
      }
      if (X)
        if (Wn(rt))
          rt.select();
        else {
          const Lt = Ce.getPreviousSibling();
          if (Wn(Lt))
            Lt.select();
          else {
            const St = Ce.getIndexWithinParent();
            Ce.getParentOrThrow().select(St, St);
          }
        }
      if (dn(Ce)) {
        const Lt = Wn(ct) ? ct : dn(ct) && ct.isInline() ? ct.getLastDescendant() : Ce.getLastDescendant();
        if (X || (Lt === null ? Ce.select() : Wn(Lt) ? Lt.getTextContent() === "" ? Lt.selectPrevious() : Lt.select() : Lt.selectNext()), Oe.length !== 0) {
          const St = Ce;
          for (let jt = Oe.length - 1; jt >= 0; jt--) {
            const bn = Oe[jt], Ht = bn.getParentOrThrow();
            if (dn(Ce) && !ym(bn) && !(hi(bn) && // Note: We are only looking for decorators that are inline and not isolated.
            (!bn.isInline() || bn.isIsolated())))
              St === Ce ? Ce.append(bn) : Ce.insertBefore(bn), Ce = bn;
            else if (!dn(Ce) && !ym(bn))
              Ce.insertBefore(bn), Ce = bn;
            else if (dn(bn) && !bn.canInsertAfter(Ce)) {
              const ln = Ht.constructor.clone(Ht);
              if (!dn(ln))
                throw Error("insertNodes: cloned parent clone is not an element");
              ln.append(bn), Ce.insertAfter(ln);
            } else
              Ce.insertAfter(bn);
            Ht.isEmpty() && !Ht.canBeEmpty() && Ht.remove();
          }
        }
      } else if (!X)
        if (Wn(Ce))
          Ce.select();
        else {
          const Lt = Ce.getParentOrThrow(), St = Ce.getIndexWithinParent() + 1;
          Lt.select(St, St);
        }
      return !0;
    }
    insertParagraph() {
      this.isCollapsed() || this.removeText();
      const W = this.anchor, X = W.offset;
      let se, ye = [], we = [];
      if (W.type === "text") {
        const Ye = W.getNode();
        ye = Ye.getNextSiblings().reverse(), se = Ye.getParentOrThrow();
        const Ke = se.isInline(), rt = Ke ? se.getTextContentSize() : Ye.getTextContentSize();
        if (X === 0)
          ye.push(Ye);
        else if (Ke && (we = se.getNextSiblings()), X !== rt && (!Ke || X !== Ye.getTextContentSize())) {
          const [, ut] = Ye.splitText(X);
          ye.push(ut);
        }
      } else {
        if (se = W.getNode(), Ma(se)) {
          const Ye = u_(), Ke = se.getChildAtIndex(X);
          Ye.select(), Ke !== null ? Ke.insertBefore(Ye, !1) : se.append(Ye);
          return;
        }
        ye = se.getChildren().slice(X).reverse();
      }
      const Ce = ye.length;
      if (X === 0 && Ce > 0 && se.isInline()) {
        const Ye = se.getParentOrThrow(), Ke = Ye.insertNewAfter(this, !1);
        if (dn(Ke)) {
          const rt = Ye.getChildren();
          for (let ut = 0; ut < rt.length; ut++)
            Ke.append(rt[ut]);
        }
        return;
      }
      const Oe = se.insertNewAfter(this, !1);
      if (Oe === null)
        this.insertLineBreak();
      else if (dn(Oe)) {
        const Ye = se.getFirstChild();
        if (X === 0 && (se.is(W.getNode()) || Ye && Ye.is(W.getNode())) && Ce > 0) {
          se.insertBefore(Oe);
          return;
        }
        let rt = null;
        const ut = we.length, _t = Oe.getParentOrThrow();
        if (ut > 0)
          for (let ct = 0; ct < ut; ct++) {
            const Lt = we[ct];
            _t.append(Lt);
          }
        if (Ce !== 0)
          for (let ct = 0; ct < Ce; ct++) {
            const Lt = ye[ct];
            rt === null ? Oe.append(Lt) : rt.insertBefore(Lt), rt = Lt;
          }
        !Oe.canBeEmpty() && Oe.getChildrenSize() === 0 ? (Oe.selectPrevious(), Oe.remove()) : Oe.selectStart();
      }
    }
    insertLineBreak(W) {
      const X = xm(), se = this.anchor;
      if (se.type === "element") {
        const ye = se.getNode();
        Qa(ye) && this.insertParagraph();
      }
      W ? this.insertNodes([X], !0) : this.insertNodes([X]) && X.selectNext(0, 0);
    }
    getCharacterOffsets() {
      return up(this);
    }
    extract() {
      const W = this.getNodes(), X = W.length, se = X - 1, ye = this.anchor, we = this.focus;
      let Ce = W[0], Oe = W[se];
      const [Ye, Ke] = up(this);
      if (X === 0)
        return [];
      if (X === 1) {
        if (Wn(Ce) && !this.isCollapsed()) {
          const ut = Ye > Ke ? Ke : Ye, _t = Ye > Ke ? Ye : Ke, ct = Ce.splitText(ut, _t), Lt = ut === 0 ? ct[0] : ct[1];
          return Lt != null ? [Lt] : [];
        }
        return [Ce];
      }
      const rt = ye.isBefore(we);
      if (Wn(Ce)) {
        const ut = rt ? Ye : Ke;
        ut === Ce.getTextContentSize() ? W.shift() : ut !== 0 && ([, Ce] = Ce.splitText(ut), W[0] = Ce);
      }
      if (Wn(Oe)) {
        const _t = Oe.getTextContent().length, ct = rt ? Ke : Ye;
        ct === 0 ? W.pop() : ct !== _t && ([Oe] = Oe.splitText(ct), W[se] = Oe);
      }
      return W;
    }
    modify(W, X, se) {
      const ye = this.focus, we = this.anchor, Ce = W === "move", Oe = lu(ye, X);
      if (hi(Oe) && !Oe.isIsolated()) {
        if (Ce && Oe.isKeyboardSelectable()) {
          const ct = ec();
          ct.add(Oe.__key), Co(ct);
          return;
        }
        const _t = X ? Oe.getPreviousSibling() : Oe.getNextSibling();
        if (Wn(_t)) {
          const ct = _t.__key, Lt = X ? _t.getTextContent().length : 0;
          ye.set(ct, Lt, "text"), Ce && we.set(ct, Lt, "text");
          return;
        } else {
          const ct = Oe.getParentOrThrow();
          let Lt, St;
          dn(_t) ? (St = _t.__key, Lt = X ? _t.getChildrenSize() : 0) : (Lt = Oe.getIndexWithinParent(), St = ct.__key, X || Lt++), ye.set(St, Lt, "element"), Ce && we.set(St, Lt, "element");
          return;
        }
      }
      const Ye = Yi(), Ke = Na(Ye._window);
      if (!Ke)
        return;
      const rt = Ye._blockCursorElement, ut = Ye._rootElement;
      if (ut !== null && rt !== null && dn(Oe) && !Oe.isInline() && !Oe.canBeEmpty() && Ol(rt, Ye, ut), Vv(Ke, W, X ? "backward" : "forward", se), Ke.rangeCount > 0) {
        const _t = Ke.getRangeAt(0), ct = this.anchor.getNode(), Lt = Qa(ct) ? ct : n_(ct);
        if (this.applyDOMRange(_t), this.dirty = !0, !Ce) {
          const St = this.getNodes(), jt = [];
          let bn = !1;
          for (let Ht = 0; Ht < St.length; Ht++) {
            const ln = St[Ht];
            du(ln, Lt) ? jt.push(ln) : bn = !0;
          }
          if (bn && jt.length > 0)
            if (X) {
              const Ht = jt[0];
              dn(Ht) ? Ht.selectStart() : Ht.getParentOrThrow().selectStart();
            } else {
              const Ht = jt[jt.length - 1];
              dn(Ht) ? Ht.selectEnd() : Ht.getParentOrThrow().selectEnd();
            }
          (Ke.anchorNode !== _t.startContainer || Ke.anchorOffset !== _t.startOffset) && mu(this);
        }
      }
    }
    deleteCharacter(W) {
      if (this.isCollapsed()) {
        const se = this.anchor, ye = this.focus;
        let we = se.getNode();
        if (!W && // Delete forward handle case
        (se.type === "element" && dn(we) && se.offset === we.getChildrenSize() || se.type === "text" && se.offset === we.getTextContentSize())) {
          const Oe = we.getParent(), Ye = we.getNextSibling() || (Oe === null ? null : Oe.getNextSibling());
          if (dn(Ye) && !Ye.canExtractContents())
            return;
        }
        const Ce = lu(ye, W);
        if (hi(Ce) && !Ce.isIsolated()) {
          if (Ce.isKeyboardSelectable() && dn(we) && we.getChildrenSize() === 0) {
            we.remove();
            const Oe = ec();
            Oe.add(Ce.__key), Co(Oe);
          } else
            Ce.remove();
          return;
        }
        if (this.modify("extend", W, "character"), this.isCollapsed()) {
          if (W && se.offset === 0 && (se.type === "element" ? se.getNode() : se.getNode().getParentOrThrow()).collapseAtStart(this))
            return;
        } else {
          const Oe = ye.type === "text" ? ye.getNode() : null;
          if (we = se.type === "text" ? se.getNode() : null, Oe !== null && Oe.isSegmented()) {
            const Ye = ye.offset, Ke = Oe.getTextContentSize();
            if (Oe.is(we) || W && Ye !== Ke || !W && Ye !== 0) {
              vm(Oe, W, Ye);
              return;
            }
          } else if (we !== null && we.isSegmented()) {
            const Ye = se.offset, Ke = we.getTextContentSize();
            if (we.is(Oe) || W && Ye !== 0 || !W && Ye !== Ke) {
              vm(we, W, Ye);
              return;
            }
          }
          hm(this, W);
        }
      }
      const X = this.isCollapsed();
      if (this.removeText(), W && !X && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0) {
        const se = this.anchor.getNode();
        se.isEmpty() && Qa(se.getParent()) && se.getIndexWithinParent() === 0 && se.collapseAtStart(this);
      }
    }
    deleteLine(W) {
      this.isCollapsed() && (this.anchor.type === "text" && this.modify("extend", W, "lineboundary"), (W ? this.focus : this.anchor).offset === 0 && this.modify("extend", W, "character")), this.removeText();
    }
    deleteWord(W) {
      this.isCollapsed() && this.modify("extend", W, "word"), this.removeText();
    }
  }
  function ud(te) {
    return te instanceof Le;
  }
  function Kg(te) {
    const W = te.offset;
    if (te.type === "text")
      return W;
    const X = te.getNode();
    return W === X.getChildrenSize() ? X.getTextContent().length : 0;
  }
  function up(te) {
    const W = te.anchor, X = te.focus;
    return W.type === "element" && X.type === "element" && W.key === X.key && W.offset === X.offset ? [0, 0] : [Kg(W), Kg(X)];
  }
  function mu(te) {
    const W = te.focus, X = te.anchor, se = X.key, ye = X.offset, we = X.type;
    Qs(X, W.key, W.offset, W.type), Qs(W, se, ye, we), te._cachedNodes = null;
  }
  function Vv(te, W, X, se) {
    te.modify(W, X, se);
  }
  function hm(te, W) {
    const X = te.anchor, se = te.focus, ye = X.getNode(), we = se.getNode();
    if (ye === we && X.type === "text" && se.type === "text") {
      const Ce = X.offset, Oe = se.offset, Ye = Ce < Oe, Ke = Ye ? Ce : Oe, rt = Ye ? Oe : Ce, ut = rt - 1;
      if (Ke !== ut) {
        const _t = ye.getTextContent().slice(Ke, rt);
        cs(_t) || (W ? se.offset = ut : X.offset = ut);
      }
    }
  }
  function vm(te, W, X) {
    const se = te, we = se.getTextContent().split(/(?=\s)/g), Ce = we.length;
    let Oe = 0, Ye = 0;
    for (let rt = 0; rt < Ce; rt++) {
      const ut = we[rt], _t = rt === Ce - 1;
      if (Ye = Oe, Oe += ut.length, W && Oe === X || Oe > X || _t) {
        we.splice(rt, 1), _t && (Ye = void 0);
        break;
      }
    }
    const Ke = we.join("").trim();
    Ke === "" ? se.remove() : (se.setTextContent(Ke), se.select(Ye, Ye));
  }
  function Zg(te, W, X) {
    const se = te.getParent();
    return X === null || se === null || !se.canBeEmpty() || se !== X.getNode();
  }
  function Bv(te, W, X, se) {
    let ye = W, we;
    if (te.nodeType === me) {
      let Ce = !1;
      const Oe = te.childNodes, Ye = Oe.length;
      ye === Ye && (Ce = !0, ye = Ye - 1);
      let Ke = Oe[ye], rt = !1;
      if (Ke === se._blockCursorElement ? (Ke = Oe[ye + 1], rt = !0) : se._blockCursorElement !== null && ye--, we = xs(Ke), Wn(we))
        ye = ea(we, Ce);
      else {
        let ut = xs(te);
        if (ut === null)
          return null;
        if (dn(ut)) {
          let _t = ut.getChildAtIndex(ye);
          if (dn(_t) && Zg(_t, ye, X)) {
            const ct = Ce ? _t.getLastDescendant() : _t.getFirstDescendant();
            ct === null ? (ut = _t, ye = 0) : (_t = ct, ut = dn(_t) ? _t : _t.getParentOrThrow());
          }
          Wn(_t) ? (we = _t, ut = null, ye = ea(_t, Ce)) : _t !== ut && Ce && !rt && ye++;
        } else {
          const _t = ut.getIndexWithinParent();
          W === 0 && hi(ut) && xs(te) === ut ? ye = _t : ye = _t + 1, ut = ut.getParentOrThrow();
        }
        if (dn(ut))
          return Js(ut.__key, ye, "element");
      }
    } else
      we = xs(te);
    return Wn(we) ? Js(we.__key, ye, "text") : null;
  }
  function yc(te, W, X) {
    const se = te.offset, ye = te.getNode();
    if (se === 0) {
      const we = ye.getPreviousSibling(), Ce = ye.getParent();
      if (!W)
        dn(we) && !X && we.isInline() ? (te.key = we.__key, te.offset = we.getChildrenSize(), te.type = "element") : Wn(we) && (te.key = we.__key, te.offset = we.getTextContent().length);
      else if ((X || !W) && we === null && dn(Ce) && Ce.isInline()) {
        const Oe = Ce.getPreviousSibling();
        Wn(Oe) && (te.key = Oe.__key, te.offset = Oe.getTextContent().length);
      }
    } else if (se === ye.getTextContent().length) {
      const we = ye.getNextSibling(), Ce = ye.getParent();
      if (W && dn(we) && we.isInline())
        te.key = we.__key, te.offset = 0, te.type = "element";
      else if ((X || W) && we === null && dn(Ce) && Ce.isInline() && !Ce.canInsertTextAfter()) {
        const Oe = Ce.getNextSibling();
        Wn(Oe) && (te.key = Oe.__key, te.offset = 0);
      }
    }
  }
  function Ff(te, W, X) {
    if (te.type === "text" && W.type === "text") {
      const se = te.isBefore(W), ye = te.is(W);
      yc(te, se, ye), yc(W, !se, ye), ye && (W.key = te.key, W.offset = te.offset, W.type = te.type);
      const we = Yi();
      if (we.isComposing() && we._compositionKey !== te.key && so(X)) {
        const Ce = X.anchor, Oe = X.focus;
        Qs(te, Ce.key, Ce.offset, Ce.type), Qs(W, Oe.key, Oe.offset, Oe.type);
      }
    }
  }
  function bm(te, W, X, se, ye, we) {
    if (te === null || X === null || !It(ye, te, X))
      return null;
    const Ce = Bv(te, W, so(we) ? we.anchor : null, ye);
    if (Ce === null)
      return null;
    const Oe = Bv(X, se, so(we) ? we.focus : null, ye);
    if (Oe === null)
      return null;
    if (Ce.type === "element" && Oe.type === "element") {
      const Ye = xs(te), Ke = xs(X);
      if (hi(Ye) && hi(Ke))
        return null;
    }
    return Ff(Ce, Oe, we), [Ce, Oe];
  }
  function ym(te) {
    return dn(te) && !te.isInline();
  }
  function fu(te, W, X, se, ye, we) {
    const Ce = Ja(), Oe = new jo(Js(te, W, ye), Js(X, se, we), 0, "");
    return Oe.dirty = !0, Ce._selection = Oe, Oe;
  }
  function $$() {
    const te = Js("root", 0, "element"), W = Js("root", 0, "element");
    return new jo(te, W, 0, "");
  }
  function ec() {
    return new Le(/* @__PURE__ */ new Set());
  }
  function w$() {
    const te = Js("root", 0, "element"), W = Js("root", 0, "element");
    return new c_("root", te, W);
  }
  function Uv(te) {
    const X = te.getEditorState()._selection, se = Na(te._window);
    return ud(X) || ds(X) ? X.clone() : Xg(X, se, te);
  }
  function Xg(te, W, X) {
    const se = X._window;
    if (se === null)
      return null;
    const ye = se.event, we = ye ? ye.type : void 0, Ce = we === "selectionchange", Oe = !an() && (Ce || we === "beforeinput" || we === "compositionstart" || we === "compositionend" || we === "click" && ye && ye.detail === 3 || we === "drop" || we === void 0);
    let Ye, Ke, rt, ut;
    if (!so(te) || Oe) {
      if (W === null)
        return null;
      if (Ye = W.anchorNode, Ke = W.focusNode, rt = W.anchorOffset, ut = W.focusOffset, Ce && so(te) && !It(X, Ye, Ke))
        return te.clone();
    } else
      return te.clone();
    const _t = bm(Ye, rt, Ke, ut, X, te);
    if (_t === null)
      return null;
    const [ct, Lt] = _t;
    return new jo(ct, Lt, so(te) ? te.format : 0, so(te) ? te.style : "");
  }
  function yo() {
    return Ja()._selection;
  }
  function Sa() {
    return Yi()._editorState._selection;
  }
  function Ni(te, W, X, se = 1) {
    const ye = te.anchor, we = te.focus, Ce = ye.getNode(), Oe = we.getNode();
    if (!W.is(Ce) && !W.is(Oe))
      return;
    const Ye = W.__key;
    if (te.isCollapsed()) {
      const Lt = ye.offset;
      if (X <= Lt) {
        const St = Math.max(0, Lt + se);
        ye.set(Ye, St, "element"), we.set(Ye, St, "element"), Qc(te);
      }
      return;
    }
    const Ke = te.isBackward(), rt = Ke ? we : ye, ut = rt.getNode(), _t = Ke ? ye : we, ct = _t.getNode();
    if (W.is(ut)) {
      const Lt = rt.offset;
      X <= Lt && rt.set(Ye, Math.max(0, Lt + se), "element");
    }
    if (W.is(ct)) {
      const Lt = _t.offset;
      X <= Lt && _t.set(Ye, Math.max(0, Lt + se), "element");
    }
    Qc(te);
  }
  function Qc(te) {
    const W = te.anchor, X = W.offset, se = te.focus, ye = se.offset, we = W.getNode(), Ce = se.getNode();
    if (te.isCollapsed()) {
      if (!dn(we))
        return;
      const Oe = we.getChildrenSize(), Ye = X >= Oe, Ke = Ye ? we.getChildAtIndex(Oe - 1) : we.getChildAtIndex(X);
      if (Wn(Ke)) {
        let rt = 0;
        Ye && (rt = Ke.getTextContentSize()), W.set(Ke.__key, rt, "text"), se.set(Ke.__key, rt, "text");
      }
      return;
    }
    if (dn(we)) {
      const Oe = we.getChildrenSize(), Ye = X >= Oe, Ke = Ye ? we.getChildAtIndex(Oe - 1) : we.getChildAtIndex(X);
      if (Wn(Ke)) {
        let rt = 0;
        Ye && (rt = Ke.getTextContentSize()), W.set(Ke.__key, rt, "text");
      }
    }
    if (dn(Ce)) {
      const Oe = Ce.getChildrenSize(), Ye = ye >= Oe, Ke = Ye ? Ce.getChildAtIndex(Oe - 1) : Ce.getChildAtIndex(ye);
      if (Wn(Ke)) {
        let rt = 0;
        Ye && (rt = Ke.getTextContentSize()), se.set(Ke.__key, rt, "text");
      }
    }
  }
  function $m(te, W) {
    const se = W.getEditorState()._selection, ye = te._selection;
    if (so(ye)) {
      const we = ye.anchor, Ce = ye.focus;
      let Oe;
      if (we.type === "text" && (Oe = we.getNode(), Oe.selectionTransform(se, ye)), Ce.type === "text") {
        const Ye = Ce.getNode();
        Oe !== Ye && Ye.selectionTransform(se, ye);
      }
    }
  }
  function gi(te, W, X, se, ye) {
    let we = null, Ce = 0, Oe = null;
    se !== null ? (we = se.__key, Wn(se) ? (Ce = se.getTextContentSize(), Oe = "text") : dn(se) && (Ce = se.getChildrenSize(), Oe = "element")) : ye !== null && (we = ye.__key, Wn(ye) ? Oe = "text" : dn(ye) && (Oe = "element")), we !== null && Oe !== null ? te.set(we, Ce, Oe) : (Ce = W.getIndexWithinParent(), Ce === -1 && (Ce = X.getChildrenSize()), te.set(X.__key, Ce, "element"));
  }
  function el(te, W, X, se, ye) {
    te.type === "text" ? (te.key = X, W || (te.offset += ye)) : te.offset > se.getIndexWithinParent() && (te.offset -= 1);
  }
  function Rl(te, W, X, se, ye, we, Ce) {
    const Oe = se.anchorNode, Ye = se.focusNode, Ke = se.anchorOffset, rt = se.focusOffset, ut = document.activeElement;
    if (ye.has("collaboration") && ut !== we || ut !== null && xn(ut))
      return;
    if (!so(W)) {
      te !== null && It(X, Oe, Ye) && se.removeAllRanges();
      return;
    }
    const _t = W.anchor, ct = W.focus, Lt = _t.key, St = ct.key, jt = po(X, Lt), bn = po(X, St), Ht = _t.offset, ln = ct.offset, $o = W.format, eo = W.style, mo = W.isCollapsed();
    let to = jt, Go = bn, zs = !1;
    if (_t.type === "text") {
      to = Ai(jt);
      const kc = _t.getNode();
      zs = kc.getFormat() !== $o || kc.getStyle() !== eo;
    } else
      so(te) && te.anchor.type === "text" && (zs = !0);
    if (ct.type === "text" && (Go = Ai(bn)), !(to === null || Go === null) && (mo && (te === null || zs || so(te) && (te.format !== $o || te.style !== eo)) && Oi($o, eo, Ht, Lt, performance.now()), !(Ke === Ht && rt === ln && Oe === to && Ye === Go && // Badly interpreted range selection when collapsed - #1482
    !(se.type === "Range" && mo) && ((ut === null || !we.contains(ut)) && we.focus({
      preventScroll: !0
    }), _t.type !== "element")))) {
      try {
        se.setBaseAndExtent(to, Ht, Go, ln);
      } catch {
      }
      if (!ye.has("skip-scroll-into-view") && W.isCollapsed() && we !== null && we === document.activeElement) {
        const kc = W instanceof jo && W.anchor.type === "element" ? to.childNodes[Ht] || null : se.rangeCount > 0 ? se.getRangeAt(0) : null;
        if (kc !== null) {
          const Tr = kc.getBoundingClientRect();
          _m(X, Tr, we);
        }
      }
      Uo();
    }
  }
  function dd(te, W) {
    let X = yo();
    return X === null && (X = ss().selectEnd()), X.insertNodes(te, W);
  }
  function l_() {
    const te = yo();
    return te === null ? "" : te.getTextContent();
  }
  function tl(te, W, X) {
    const se = [];
    let ye = null, we = null;
    function Ce(Ke, rt, ut) {
      const _t = {
        cell: ut,
        startColumn: rt,
        startRow: Ke
      }, ct = ut.__rowSpan, Lt = ut.__colSpan;
      for (let St = 0; St < ct; St++) {
        se[Ke + St] === void 0 && (se[Ke + St] = []);
        for (let jt = 0; jt < Lt; jt++)
          se[Ke + St][rt + jt] = _t;
      }
      W.is(ut) && (ye = _t), X.is(ut) && (we = _t);
    }
    function Oe(Ke, rt) {
      return se[Ke] === void 0 || se[Ke][rt] === void 0;
    }
    const Ye = te.getChildren();
    for (let Ke = 0; Ke < Ye.length; Ke++) {
      const rt = Ye[Ke];
      if (!fs(rt))
        throw Error("Expected GridNode children to be GridRowNode");
      const ut = rt.getChildren();
      let _t = 0;
      for (const ct of ut) {
        if (!ol(ct))
          throw Error("Expected GridRowNode children to be GridCellNode");
        for (; !Oe(Ke, _t); )
          _t++;
        Ce(Ke, _t, ct), _t += ct.__colSpan;
      }
    }
    if (ye === null)
      throw Error("Anchor not found in Grid");
    if (we === null)
      throw Error("Focus not found in Grid");
    return [se, ye, we];
  }
  function _d(te) {
    let W;
    if (te instanceof z$)
      W = te;
    else if (te instanceof bc) {
      const ye = Is(te, ol);
      if (!ol(ye))
        throw Error("Expected to find a parent GridCellNode");
      W = ye;
    } else {
      const ye = Is(te.getNode(), ol);
      if (!ol(ye))
        throw Error("Expected to find a parent GridCellNode");
      W = ye;
    }
    const X = W.getParent();
    if (!fs(X))
      throw Error("Expected GridCellNode to have a parent GridRowNode");
    const se = X.getParent();
    if (!Kv(se))
      throw Error("Expected GridRowNode to have a parent GridNode");
    return [W, X, se];
  }
  let Hi = null, Ea = null, $c = !1, Jg = !1, dp = 0;
  const Qg = {
    characterData: !0,
    childList: !0,
    subtree: !0
  };
  function qf() {
    return $c || Hi !== null && Hi._readOnly;
  }
  function _s() {
    if ($c)
      throw Error("Cannot use method in read-only mode.");
  }
  function k1() {
    if (dp > 99)
      throw Error("One or more transforms are endlessly triggering additional transforms. May have encountered infinite recursion caused by transforms that have their preconditions too lose and/or conflict with each other.");
  }
  function Ja() {
    if (Hi === null)
      throw Error("Unable to find an active editor state. State helpers or node methods can only be used synchronously during the callback of editor.update() or editorState.read().");
    return Hi;
  }
  function Yi() {
    if (Ea === null)
      throw Error("Unable to find an active editor. This method can only be used synchronously during the callback of editor.update().");
    return Ea;
  }
  function wm() {
    return Ea;
  }
  function nl(te, W, X) {
    const se = W.__type, ye = Ze(te, se);
    let we = X.get(se);
    we === void 0 && (we = Array.from(ye.transforms), X.set(se, we));
    const Ce = we.length;
    for (let Oe = 0; Oe < Ce && (we[Oe](W), !!W.isAttached()); Oe++)
      ;
  }
  function S1(te, W) {
    return te !== void 0 && // We don't want to transform nodes being composed
    te.__key !== W && te.isAttached();
  }
  function E1(te, W) {
    const X = W._dirtyLeaves, se = te._nodeMap;
    for (const ye of X) {
      const we = se.get(ye);
      Wn(we) && we.isAttached() && we.isSimpleText() && !we.isUnmergeable() && Fa(we);
    }
  }
  function x1(te, W) {
    const X = W._dirtyLeaves, se = W._dirtyElements, ye = te._nodeMap, we = Xr(), Ce = /* @__PURE__ */ new Map();
    let Oe = X, Ye = Oe.size, Ke = se, rt = Ke.size;
    for (; Ye > 0 || rt > 0; ) {
      if (Ye > 0) {
        W._dirtyLeaves = /* @__PURE__ */ new Set();
        for (const ut of Oe) {
          const _t = ye.get(ut);
          Wn(_t) && _t.isAttached() && _t.isSimpleText() && !_t.isUnmergeable() && Fa(_t), _t !== void 0 && S1(_t, we) && nl(W, _t, Ce), X.add(ut);
        }
        if (Oe = W._dirtyLeaves, Ye = Oe.size, Ye > 0) {
          dp++;
          continue;
        }
      }
      W._dirtyLeaves = /* @__PURE__ */ new Set(), W._dirtyElements = /* @__PURE__ */ new Map();
      for (const ut of Ke) {
        const _t = ut[0], ct = ut[1];
        if (_t !== "root" && !ct)
          continue;
        const Lt = ye.get(_t);
        Lt !== void 0 && S1(Lt, we) && nl(W, Lt, Ce), se.set(_t, ct);
      }
      Oe = W._dirtyLeaves, Ye = Oe.size, Ke = W._dirtyElements, rt = Ke.size, dp++;
    }
    W._dirtyLeaves = X, W._dirtyElements = se;
  }
  function eh(te) {
    return pd(te, Yi()._nodes);
  }
  function pd(te, W) {
    const X = te.type, se = W.get(X);
    if (se === void 0)
      throw Error(`parseEditorState: type "${X}" + not found`);
    const ye = se.klass;
    if (te.type !== ye.getType())
      throw Error(`LexicalNode: Node ${ye.name} does not implement .importJSON().`);
    const we = ye.importJSON(te), Ce = te.children;
    if (dn(we) && Array.isArray(Ce))
      for (let Oe = 0; Oe < Ce.length; Oe++) {
        const Ye = Ce[Oe], Ke = pd(Ye, W);
        we.append(Ke);
      }
    return we;
  }
  function C1(te, W, X) {
    const se = E$(), ye = Hi, we = $c, Ce = Ea, Oe = W._dirtyElements, Ye = W._dirtyLeaves, Ke = W._cloneNotNeeded, rt = W._dirtyType;
    W._dirtyElements = /* @__PURE__ */ new Map(), W._dirtyLeaves = /* @__PURE__ */ new Set(), W._cloneNotNeeded = /* @__PURE__ */ new Set(), W._dirtyType = 0, Hi = se, $c = !1, Ea = W;
    try {
      const ut = W._nodes, _t = te.root;
      pd(_t, ut), X && X(), se._readOnly = !0, th(se);
    } catch (ut) {
      ut instanceof Error && W._onError(ut);
    } finally {
      W._dirtyElements = Oe, W._dirtyLeaves = Ye, W._cloneNotNeeded = Ke, W._dirtyType = rt, Hi = ye, $c = we, Ea = Ce;
    }
    return se;
  }
  function T1(te, W) {
    const X = Hi, se = $c, ye = Ea;
    Hi = te, $c = !0, Ea = null;
    try {
      return W();
    } finally {
      Hi = X, $c = se, Ea = ye;
    }
  }
  function th(te) {
    const W = te._nodeMap;
    W.set = () => {
      throw new Error("Cannot call set() on a frozen Lexical node map");
    }, W.clear = () => {
      throw new Error("Cannot call clear() on a frozen Lexical node map");
    }, W.delete = () => {
      throw new Error("Cannot call delete() on a frozen Lexical node map");
    };
  }
  function km(te) {
    const W = te._pendingEditorState, X = te._rootElement, se = te._headless || X === null;
    if (W === null)
      return;
    const ye = te._editorState, we = ye._selection, Ce = W._selection, Oe = te._dirtyType !== pe, Ye = Hi, Ke = $c, rt = Ea, ut = te._updating, _t = te._observer;
    let ct = null;
    if (te._pendingEditorState = null, te._editorState = W, !se && Oe && _t !== null) {
      Ea = te, Hi = W, $c = !1, te._updating = !0;
      try {
        const eo = te._dirtyType, mo = te._dirtyElements, to = te._dirtyLeaves;
        _t.disconnect(), ct = i_(ye, W, te, eo, mo, to);
      } catch (eo) {
        if (eo instanceof Error && te._onError(eo), !Jg)
          N$(te, null, X, W), cn(te), te._dirtyType = ve, Jg = !0, km(te), Jg = !1;
        else
          throw eo;
        return;
      } finally {
        _t.observe(X, Qg), te._updating = ut, Hi = Ye, $c = Ke, Ea = rt;
      }
    }
    W._readOnly || (W._readOnly = !0, th(W), so(Ce) && (Object.freeze(Ce.anchor), Object.freeze(Ce.focus)), Object.freeze(Ce));
    const Lt = te._dirtyLeaves, St = te._dirtyElements, jt = te._normalizedNodes, bn = te._updateTags, Ht = te._deferred;
    Oe && (te._dirtyType = pe, te._cloneNotNeeded.clear(), te._dirtyLeaves = /* @__PURE__ */ new Set(), te._dirtyElements = /* @__PURE__ */ new Map(), te._normalizedNodes = /* @__PURE__ */ new Set(), te._updateTags = /* @__PURE__ */ new Set()), ad(te, W);
    const ln = se ? null : Na(te._window);
    if (te._editable && // domSelection will be null in headless
    ln !== null && (Oe || Ce === null || Ce.dirty)) {
      Ea = te, Hi = W;
      try {
        if (_t !== null && _t.disconnect(), Oe || Ce === null || Ce.dirty) {
          const eo = te._blockCursorElement;
          eo !== null && Ol(eo, te, X), Rl(we, Ce, te, ln, bn, X);
        }
        To(te, X, Ce), _t !== null && _t.observe(X, Qg);
      } finally {
        Ea = rt, Hi = Ye;
      }
    }
    ct !== null && ps(te, ye, W, ct, bn, Lt), !so(Ce) && Ce !== null && (we === null || !we.is(Ce)) && te.dispatchCommand(t, void 0);
    const $o = te._pendingDecorators;
    $o !== null && (te._decorators = $o, te._pendingDecorators = null, Sm("decorator", te, !0, $o)), A1(te, ye, W), Sm("update", te, !0, {
      dirtyElements: St,
      dirtyLeaves: Lt,
      editorState: W,
      normalizedNodes: jt,
      prevEditorState: ye,
      tags: bn
    }), S$(te, Ht), md(te);
  }
  function A1(te, W, X) {
    const se = Wd(W), ye = Wd(X);
    se !== ye && Sm("textcontent", te, !0, ye);
  }
  function ps(te, W, X, se, ye, we) {
    const Ce = Array.from(te._listeners.mutation), Oe = Ce.length;
    for (let Ye = 0; Ye < Oe; Ye++) {
      const [Ke, rt] = Ce[Ye], ut = se.get(rt);
      ut !== void 0 && Ke(ut, {
        dirtyLeaves: we,
        updateTags: ye
      });
    }
  }
  function Sm(te, W, X, ...se) {
    const ye = W._updating;
    W._updating = X;
    try {
      const we = Array.from(W._listeners[te]);
      for (let Ce = 0; Ce < we.length; Ce++)
        we[Ce].apply(null, se);
    } finally {
      W._updating = ye;
    }
  }
  function k$(te, W, X) {
    if (te._updating === !1 || Ea !== te) {
      let ye = !1;
      return te.update(() => {
        ye = k$(te, W, X);
      }), ye;
    }
    const se = Ju(te);
    for (let ye = 4; ye >= 0; ye--)
      for (let we = 0; we < se.length; we++) {
        const Ye = se[we]._commands.get(W);
        if (Ye !== void 0) {
          const Ke = Ye[ye];
          if (Ke !== void 0) {
            const rt = Array.from(Ke), ut = rt.length;
            for (let _t = 0; _t < ut; _t++)
              if (rt[_t](X, te) === !0)
                return !0;
          }
        }
      }
    return !1;
  }
  function md(te) {
    const W = te._updates;
    if (W.length !== 0) {
      const X = W.shift();
      if (X) {
        const [se, ye] = X;
        _p(te, se, ye);
      }
    }
  }
  function S$(te, W) {
    if (te._deferred = [], W.length !== 0) {
      const X = te._updating;
      te._updating = !0;
      try {
        for (let se = 0; se < W.length; se++)
          W[se]();
      } finally {
        te._updating = X;
      }
    }
  }
  function nh(te, W) {
    const X = te._updates;
    let se = W || !1;
    for (; X.length !== 0; ) {
      const ye = X.shift();
      if (ye) {
        const [we, Ce] = ye;
        let Oe, Ye;
        Ce !== void 0 && (Oe = Ce.onUpdate, Ye = Ce.tag, Ce.skipTransforms && (se = !0), Oe && te._deferred.push(Oe), Ye && te._updateTags.add(Ye)), we();
      }
    }
    return se;
  }
  function _p(te, W, X) {
    const se = te._updateTags;
    let ye, we, Ce = !1, Oe = !1;
    X !== void 0 && (ye = X.onUpdate, we = X.tag, we != null && se.add(we), Ce = X.skipTransforms || !1, Oe = X.discrete || !1), ye && te._deferred.push(ye);
    const Ye = te._editorState;
    let Ke = te._pendingEditorState, rt = !1;
    (Ke === null || Ke._readOnly) && (Ke = te._pendingEditorState = N2(Ke || Ye), rt = !0), Ke._flushSync = Oe;
    const ut = Hi, _t = $c, ct = Ea, Lt = te._updating;
    Hi = Ke, $c = !1, te._updating = !0, Ea = te;
    try {
      rt && (te._headless ? Ye._selection != null && (Ke._selection = Ye._selection.clone()) : Ke._selection = Uv(te));
      const jt = te._compositionKey;
      W(), Ce = nh(te, Ce), $m(Ke, te), te._dirtyType !== pe && (Ce ? E1(Ke, te) : x1(Ke, te), nh(te), Xs(Ye, Ke, te._dirtyLeaves, te._dirtyElements));
      const bn = te._compositionKey;
      jt !== bn && (Ke._flushSync = !0);
      const Ht = Ke._selection;
      if (so(Ht)) {
        const ln = Ke._nodeMap, $o = Ht.anchor.key, eo = Ht.focus.key;
        if (ln.get($o) === void 0 || ln.get(eo) === void 0)
          throw Error("updateEditor: selection has been lost because the previously selected nodes have been removed and selection wasn't moved to another node. Ensure selection changes after removing/replacing a selected node.");
      } else
        ud(Ht) && Ht._nodes.size === 0 && (Ke._selection = null);
    } catch (jt) {
      jt instanceof Error && te._onError(jt), te._pendingEditorState = Ye, te._dirtyType = ve, te._cloneNotNeeded.clear(), te._dirtyLeaves = /* @__PURE__ */ new Set(), te._dirtyElements.clear(), km(te);
      return;
    } finally {
      Hi = ut, $c = _t, Ea = ct, te._updating = Lt, dp = 0;
    }
    te._dirtyType !== pe || O1(Ke, te) ? Ke._flushSync ? (Ke._flushSync = !1, km(te)) : rt && bt(() => {
      km(te);
    }) : (Ke._flushSync = !1, rt && (se.clear(), te._deferred = [], te._pendingEditorState = null));
  }
  function wc(te, W, X) {
    te._updating ? te._updates.push([W, X]) : _p(te, W, X);
  }
  class ms extends bc {
    constructor(W) {
      super(W);
    }
    decorate(W, X) {
      throw Error("decorate: base method not extended");
    }
    isIsolated() {
      return !1;
    }
    isInline() {
      return !0;
    }
    isKeyboardSelectable() {
      return !0;
    }
  }
  function hi(te) {
    return te instanceof ms;
  }
  class Em extends bc {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    constructor(W) {
      super(W), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__indent = 0, this.__dir = null;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getFormatType() {
      const W = this.getFormat();
      return go[W] || "";
    }
    getIndent() {
      return this.getLatest().__indent;
    }
    getChildren() {
      const W = [];
      let X = this.getFirstChild();
      for (; X !== null; )
        W.push(X), X = X.getNextSibling();
      return W;
    }
    getChildrenKeys() {
      const W = [];
      let X = this.getFirstChild();
      for (; X !== null; )
        W.push(X.__key), X = X.getNextSibling();
      return W;
    }
    getChildrenSize() {
      return this.getLatest().__size;
    }
    isEmpty() {
      return this.getChildrenSize() === 0;
    }
    isDirty() {
      const X = Yi()._dirtyElements;
      return X !== null && X.has(this.__key);
    }
    isLastChild() {
      const W = this.getLatest(), X = this.getParentOrThrow().getLastChild();
      return X !== null && X.is(W);
    }
    getAllTextNodes() {
      const W = [];
      let X = this.getFirstChild();
      for (; X !== null; ) {
        if (Wn(X) && W.push(X), dn(X)) {
          const se = X.getAllTextNodes();
          W.push(...se);
        }
        X = X.getNextSibling();
      }
      return W;
    }
    getFirstDescendant() {
      let W = this.getFirstChild();
      for (; W !== null; ) {
        if (dn(W)) {
          const X = W.getFirstChild();
          if (X !== null) {
            W = X;
            continue;
          }
        }
        break;
      }
      return W;
    }
    getLastDescendant() {
      let W = this.getLastChild();
      for (; W !== null; ) {
        if (dn(W)) {
          const X = W.getLastChild();
          if (X !== null) {
            W = X;
            continue;
          }
        }
        break;
      }
      return W;
    }
    getDescendantByIndex(W) {
      const X = this.getChildren(), se = X.length;
      if (W >= se) {
        const we = X[se - 1];
        return dn(we) && we.getLastDescendant() || we || null;
      }
      const ye = X[W];
      return dn(ye) && ye.getFirstDescendant() || ye || null;
    }
    getFirstChild() {
      const X = this.getLatest().__first;
      return X === null ? null : mi(X);
    }
    getFirstChildOrThrow() {
      const W = this.getFirstChild();
      if (W === null)
        throw Error(`Expected node ${this.__key} to have a first child.`);
      return W;
    }
    getLastChild() {
      const X = this.getLatest().__last;
      return X === null ? null : mi(X);
    }
    getLastChildOrThrow() {
      const W = this.getLastChild();
      if (W === null)
        throw Error(`Expected node ${this.__key} to have a last child.`);
      return W;
    }
    getChildAtIndex(W) {
      const X = this.getChildrenSize();
      let se, ye;
      if (W < X / 2) {
        for (se = this.getFirstChild(), ye = 0; se !== null && ye <= W; ) {
          if (ye === W)
            return se;
          se = se.getNextSibling(), ye++;
        }
        return null;
      }
      for (se = this.getLastChild(), ye = X - 1; se !== null && ye >= W; ) {
        if (ye === W)
          return se;
        se = se.getPreviousSibling(), ye--;
      }
      return null;
    }
    getTextContent() {
      let W = "";
      const X = this.getChildren(), se = X.length;
      for (let ye = 0; ye < se; ye++) {
        const we = X[ye];
        W += we.getTextContent(), dn(we) && ye !== se - 1 && !we.isInline() && (W += Yn);
      }
      return W;
    }
    getTextContentSize() {
      let W = 0;
      const X = this.getChildren(), se = X.length;
      for (let ye = 0; ye < se; ye++) {
        const we = X[ye];
        W += we.getTextContentSize(), dn(we) && ye !== se - 1 && !we.isInline() && (W += Yn.length);
      }
      return W;
    }
    getDirection() {
      return this.getLatest().__dir;
    }
    hasFormat(W) {
      if (W !== "") {
        const X = uo[W];
        return (this.getFormat() & X) !== 0;
      }
      return !1;
    }
    // Mutators
    select(W, X) {
      _s();
      const se = yo();
      let ye = W, we = X;
      const Ce = this.getChildrenSize();
      if (!this.canBeEmpty()) {
        if (W === 0 && X === 0) {
          const Ye = this.getFirstChild();
          if (Wn(Ye) || dn(Ye))
            return Ye.select(0, 0);
        } else if ((W === void 0 || W === Ce) && (X === void 0 || X === Ce)) {
          const Ye = this.getLastChild();
          if (Wn(Ye) || dn(Ye))
            return Ye.select();
        }
      }
      ye === void 0 && (ye = Ce), we === void 0 && (we = Ce);
      const Oe = this.__key;
      if (so(se))
        se.anchor.set(Oe, ye, "element"), se.focus.set(Oe, we, "element"), se.dirty = !0;
      else
        return fu(Oe, ye, Oe, we, "element", "element");
      return se;
    }
    selectStart() {
      const W = this.getFirstDescendant();
      return dn(W) || Wn(W) ? W.select(0, 0) : W !== null ? W.selectPrevious() : this.select(0, 0);
    }
    selectEnd() {
      const W = this.getLastDescendant();
      return dn(W) || Wn(W) ? W.select() : W !== null ? W.selectNext() : this.select();
    }
    clear() {
      const W = this.getWritable();
      return this.getChildren().forEach((se) => se.remove()), W;
    }
    append(...W) {
      return this.splice(this.getChildrenSize(), 0, W);
    }
    setDirection(W) {
      const X = this.getWritable();
      return X.__dir = W, X;
    }
    setFormat(W) {
      const X = this.getWritable();
      return X.__format = W !== "" ? uo[W] : 0, this;
    }
    setIndent(W) {
      const X = this.getWritable();
      return X.__indent = W, this;
    }
    splice(W, X, se) {
      const ye = se.length, we = this.getChildrenSize(), Ce = this.getWritable(), Oe = Ce.__key, Ye = [], Ke = [], rt = this.getChildAtIndex(W + X);
      let ut = null, _t = we - X + ye;
      if (W !== 0)
        if (W === we)
          ut = this.getLastChild();
        else {
          const Lt = this.getChildAtIndex(W);
          Lt !== null && (ut = Lt.getPreviousSibling());
        }
      if (X > 0) {
        let Lt = ut === null ? this.getFirstChild() : ut.getNextSibling();
        for (let St = 0; St < X; St++) {
          if (Lt === null)
            throw Error("splice: sibling not found");
          const jt = Lt.getNextSibling(), bn = Lt.__key, Ht = Lt.getWritable();
          Pr(Ht), Ke.push(bn), Lt = jt;
        }
      }
      let ct = ut;
      for (let Lt = 0; Lt < ye; Lt++) {
        const St = se[Lt];
        ct !== null && St.is(ct) && (ut = ct = ct.getPreviousSibling());
        const jt = St.getWritable();
        jt.__parent === Oe && _t--, Pr(jt);
        const bn = St.__key;
        if (ct === null)
          Ce.__first = bn, jt.__prev = null;
        else {
          const Ht = ct.getWritable();
          Ht.__next = bn, jt.__prev = Ht.__key;
        }
        if (St.__key === Oe)
          throw Error("append: attempting to append self");
        jt.__parent = Oe, Ye.push(bn), ct = St;
      }
      if (W + X === we) {
        if (ct !== null) {
          const Lt = ct.getWritable();
          Lt.__next = null, Ce.__last = ct.__key;
        }
      } else if (rt !== null) {
        const Lt = rt.getWritable();
        if (ct !== null) {
          const St = ct.getWritable();
          Lt.__prev = ct.__key, St.__next = rt.__key;
        } else
          Lt.__prev = null;
      }
      if (Ce.__size = _t, Ke.length) {
        const Lt = yo();
        if (so(Lt)) {
          const St = new Set(Ke), jt = new Set(Ye), {
            anchor: bn,
            focus: Ht
          } = Lt;
          I1(bn, St, jt) && gi(bn, bn.getNode(), this, ut, rt), I1(Ht, St, jt) && gi(Ht, Ht.getNode(), this, ut, rt), _t === 0 && !this.canBeEmpty() && !Ma(this) && this.remove();
        }
      }
      return Ce;
    }
    // JSON serialization
    exportJSON() {
      return {
        children: [],
        direction: this.getDirection(),
        format: this.getFormatType(),
        indent: this.getIndent(),
        type: "element",
        version: 1
      };
    }
    // These are intended to be extends for specific element heuristics.
    insertNewAfter(W, X) {
      return null;
    }
    canInsertTab() {
      return !1;
    }
    canIndent() {
      return !0;
    }
    /*
     * This method controls the behavior of a the node during backwards
     * deletion (i.e., backspace) when selection is at the beginning of
     * the node (offset 0)
     */
    collapseAtStart(W) {
      return !1;
    }
    excludeFromCopy(W) {
      return !1;
    }
    canExtractContents() {
      return !0;
    }
    canReplaceWith(W) {
      return !0;
    }
    canInsertAfter(W) {
      return !0;
    }
    canBeEmpty() {
      return !0;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    isInline() {
      return !1;
    }
    // A shadow root is a Node that behaves like RootNode. The shadow root (and RootNode) mark the
    // end of the hiercharchy, most implementations should treat it as there's nothing (upwards)
    // beyond this point. For example, node.getTopLevelElement(), when performed inside a TableCellNode
    // will return the immediate first child underneath TableCellNode instead of RootNode.
    isShadowRoot() {
      return !1;
    }
    canMergeWith(W) {
      return !1;
    }
    extractWithChild(W, X, se) {
      return !1;
    }
  }
  function dn(te) {
    return te instanceof Em;
  }
  function I1(te, W, X) {
    let se = te.getNode();
    for (; se; ) {
      const ye = se.__key;
      if (W.has(ye) && !X.has(ye))
        return !0;
      se = se.getParent();
    }
    return !1;
  }
  class pp extends Em {
    /** @internal */
    static getType() {
      return "root";
    }
    static clone() {
      return new pp();
    }
    constructor() {
      super("root"), this.__cachedText = null;
    }
    getTopLevelElementOrThrow() {
      throw Error("getTopLevelElementOrThrow: root nodes are not top level elements");
    }
    getTextContent() {
      const W = this.__cachedText;
      return (qf() || Yi()._dirtyType === pe) && W !== null ? W : super.getTextContent();
    }
    remove() {
      throw Error("remove: cannot be called on root nodes");
    }
    replace(W) {
      throw Error("replace: cannot be called on root nodes");
    }
    insertBefore(W) {
      throw Error("insertBefore: cannot be called on root nodes");
    }
    insertAfter(W) {
      throw Error("insertAfter: cannot be called on root nodes");
    }
    // View
    updateDOM(W, X) {
      return !1;
    }
    // Mutate
    append(...W) {
      for (let X = 0; X < W.length; X++) {
        const se = W[X];
        if (!dn(se) && !hi(se))
          throw Error("rootNode.append: Only element or decorator nodes can be appended to the root node");
      }
      return super.append(...W);
    }
    static importJSON(W) {
      const X = ss();
      return X.setFormat(W.format), X.setIndent(W.indent), X.setDirection(W.direction), X;
    }
    exportJSON() {
      return {
        children: [],
        direction: this.getDirection(),
        format: this.getFormatType(),
        indent: this.getIndent(),
        type: "root",
        version: 1
      };
    }
    collapseAtStart() {
      return !0;
    }
  }
  function O2() {
    return new pp();
  }
  function Qa(te) {
    return te instanceof pp;
  }
  function O1(te, W) {
    const X = W.getEditorState()._selection, se = te._selection;
    if (se !== null) {
      if (se.dirty || !se.is(X))
        return !0;
    } else if (X !== null)
      return !0;
    return !1;
  }
  function N2(te) {
    return new Gv(new Map(te._nodeMap));
  }
  function E$() {
    return new Gv(/* @__PURE__ */ new Map([["root", O2()]]));
  }
  function jf(te) {
    const W = te.exportJSON(), X = te.constructor;
    if (W.type !== X.getType())
      throw Error(`LexicalNode: Node ${X.name} does not implement .exportJSON().`);
    const se = W.children;
    if (dn(te)) {
      if (!Array.isArray(se))
        throw Error(`LexicalNode: Node ${X.name} is an element but .exportJSON() does not have a children array.`);
      const ye = te.getChildren();
      for (let we = 0; we < ye.length; we++) {
        const Ce = ye[we], Oe = jf(Ce);
        se.push(Oe);
      }
    }
    return W;
  }
  class Gv {
    constructor(W, X) {
      this._nodeMap = W, this._selection = X || null, this._flushSync = !1, this._readOnly = !1;
    }
    isEmpty() {
      return this._nodeMap.size === 1 && this._selection === null;
    }
    read(W) {
      return T1(this, W);
    }
    clone(W) {
      const X = new Gv(this._nodeMap, W === void 0 ? this._selection : W);
      return X._readOnly = !0, X;
    }
    toJSON() {
      return T1(this, () => ({
        root: jf(ss())
      }));
    }
  }
  class Vf extends bc {
    static getType() {
      return "linebreak";
    }
    static clone(W) {
      return new Vf(W.__key);
    }
    constructor(W) {
      super(W);
    }
    getTextContent() {
      return `
`;
    }
    createDOM() {
      return document.createElement("br");
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return {
        br: (W) => {
          const X = W.parentElement;
          return X != null && X.firstChild === W && X.lastChild === W ? null : {
            conversion: x$,
            priority: 0
          };
        }
      };
    }
    static importJSON(W) {
      return xm();
    }
    exportJSON() {
      return {
        type: "linebreak",
        version: 1
      };
    }
  }
  function x$(te) {
    return {
      node: xm()
    };
  }
  function xm() {
    return Al(new Vf());
  }
  function oh(te) {
    return te instanceof Vf;
  }
  function C$(te, W) {
    return W & Pe ? "code" : W & Xe ? "mark" : W & je ? "sub" : W & He ? "sup" : null;
  }
  function T$(te, W) {
    return W & et ? "strong" : W & st ? "em" : "span";
  }
  function A$(te, W, X, se, ye) {
    const we = se.classList;
    let Ce = Cl(ye, "base");
    Ce !== void 0 && we.add(...Ce), Ce = Cl(ye, "underlineStrikethrough");
    let Oe = !1;
    const Ye = W & ze && W & De, Ke = X & ze && X & De;
    Ce !== void 0 && (Ke ? (Oe = !0, Ye || we.add(...Ce)) : Ye && we.remove(...Ce));
    for (const rt in In) {
      const _t = In[rt];
      if (Ce = Cl(ye, rt), Ce !== void 0)
        if (X & _t) {
          if (Oe && (rt === "underline" || rt === "strikethrough")) {
            W & _t && we.remove(...Ce);
            continue;
          }
          (!(W & _t) || Ye && rt === "underline" || rt === "strikethrough") && we.add(...Ce);
        } else
          W & _t && we.remove(...Ce);
    }
  }
  function I$(te, W) {
    const X = te.length, se = W.length;
    let ye = 0, we = 0;
    for (; ye < X && ye < se && te[ye] === W[ye]; )
      ye++;
    for (; we + ye < X && we + ye < se && te[X - we - 1] === W[se - we - 1]; )
      we++;
    return [ye, X - ye - we, W.slice(ye, se - we)];
  }
  function N1(te, W, X) {
    const se = W.firstChild, ye = X.isComposing(), Ce = te + (ye ? Ln : "");
    if (se == null)
      W.textContent = Ce;
    else {
      const Oe = se.nodeValue;
      if (Oe !== Ce)
        if (ye || re) {
          const [Ye, Ke, rt] = I$(Oe, Ce);
          Ke !== 0 && se.deleteData(Ye, Ke), se.insertData(Ye, rt);
        } else
          se.nodeValue = Ce;
    }
  }
  function Wv(te, W, X, se, ye, we) {
    N1(ye, te, W);
    const Oe = we.theme.text;
    Oe !== void 0 && A$(X, 0, se, te, Oe);
  }
  function rh(te, W) {
    const X = document.createElement(W);
    return X.appendChild(te), X;
  }
  class Cm extends bc {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "text";
    }
    static clone(W) {
      return new Cm(W.__text, W.__key);
    }
    constructor(W, X) {
      super(X), this.__text = W, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
    }
    getFormat() {
      return this.getLatest().__format;
    }
    getDetail() {
      return this.getLatest().__detail;
    }
    getMode() {
      const W = this.getLatest();
      return qo[W.__mode];
    }
    getStyle() {
      return this.getLatest().__style;
    }
    isToken() {
      return this.getLatest().__mode === Re;
    }
    isComposing() {
      return this.__key === Xr();
    }
    isSegmented() {
      return this.getLatest().__mode === Me;
    }
    isDirectionless() {
      return (this.getLatest().__detail & wt) !== 0;
    }
    isUnmergeable() {
      return (this.getLatest().__detail & Je) !== 0;
    }
    hasFormat(W) {
      const X = In[W];
      return (this.getFormat() & X) !== 0;
    }
    isSimpleText() {
      return this.__type === "text" && this.__mode === 0;
    }
    getTextContent() {
      return this.getLatest().__text;
    }
    getFormatFlags(W, X) {
      const ye = this.getLatest().__format;
      return Ka(ye, W, X);
    }
    // View
    createDOM(W) {
      const X = this.__format, se = C$(this, X), ye = T$(this, X), we = se === null ? ye : se, Ce = document.createElement(we);
      let Oe = Ce;
      se !== null && (Oe = document.createElement(ye), Ce.appendChild(Oe));
      const Ye = this.__text;
      Wv(Oe, this, ye, X, Ye, W);
      const Ke = this.__style;
      return Ke !== "" && (Ce.style.cssText = Ke), Ce;
    }
    updateDOM(W, X, se) {
      const ye = this.__text, we = W.__format, Ce = this.__format, Oe = C$(this, we), Ye = C$(this, Ce), Ke = T$(this, we), rt = T$(this, Ce);
      if ((Oe === null ? Ke : Oe) !== (Ye === null ? rt : Ye))
        return !0;
      if (Oe === Ye && Ke !== rt) {
        const Ht = X.firstChild;
        if (Ht == null)
          throw Error("updateDOM: prevInnerDOM is null or undefined");
        const ln = document.createElement(rt);
        return Wv(ln, this, rt, Ce, ye, se), X.replaceChild(ln, Ht), !1;
      }
      let ct = X;
      if (Ye !== null && Oe !== null && (ct = X.firstChild, ct == null))
        throw Error("updateDOM: innerDOM is null or undefined");
      N1(ye, ct, this);
      const St = se.theme.text;
      St !== void 0 && we !== Ce && A$(rt, we, Ce, ct, St);
      const jt = W.__style, bn = this.__style;
      return jt !== bn && (X.style.cssText = bn), !1;
    }
    static importDOM() {
      return {
        "#text": () => ({
          conversion: R1,
          priority: 0
        }),
        b: () => ({
          conversion: z2,
          priority: 0
        }),
        br: () => ({
          conversion: Hv,
          priority: 0
        }),
        code: () => ({
          conversion: mp,
          priority: 0
        }),
        em: () => ({
          conversion: mp,
          priority: 0
        }),
        i: () => ({
          conversion: mp,
          priority: 0
        }),
        s: () => ({
          conversion: mp,
          priority: 0
        }),
        span: () => ({
          conversion: z1,
          priority: 0
        }),
        strong: () => ({
          conversion: mp,
          priority: 0
        }),
        sub: () => ({
          conversion: mp,
          priority: 0
        }),
        sup: () => ({
          conversion: mp,
          priority: 0
        }),
        u: () => ({
          conversion: mp,
          priority: 0
        })
      };
    }
    static importJSON(W) {
      const X = es(W.text);
      return X.setFormat(W.format), X.setDetail(W.detail), X.setMode(W.mode), X.setStyle(W.style), X;
    }
    // This improves Lexical's basic text output in copy+paste plus
    // for headless mode where people might use Lexical to generate
    // HTML content and not have the ability to use CSS classes.
    exportDOM(W) {
      let {
        element: X
      } = super.exportDOM(W);
      return X !== null && (this.hasFormat("bold") && (X = rh(X, "b")), this.hasFormat("italic") && (X = rh(X, "i")), this.hasFormat("strikethrough") && (X = rh(X, "s")), this.hasFormat("underline") && (X = rh(X, "u"))), {
        element: X
      };
    }
    exportJSON() {
      return {
        detail: this.getDetail(),
        format: this.getFormat(),
        mode: this.getMode(),
        style: this.getStyle(),
        text: this.getTextContent(),
        type: "text",
        version: 1
      };
    }
    // Mutators
    selectionTransform(W, X) {
    }
    // TODO 0.5 This should just be a `string`.
    setFormat(W) {
      const X = this.getWritable();
      return X.__format = typeof W == "string" ? In[W] : W, X;
    }
    // TODO 0.5 This should just be a `string`.
    setDetail(W) {
      const X = this.getWritable();
      return X.__detail = typeof W == "string" ? $n[W] : W, X;
    }
    setStyle(W) {
      const X = this.getWritable();
      return X.__style = W, X;
    }
    toggleFormat(W) {
      const X = In[W];
      return this.setFormat(this.getFormat() ^ X);
    }
    toggleDirectionless() {
      const W = this.getWritable();
      return W.__detail ^= wt, W;
    }
    toggleUnmergeable() {
      const W = this.getWritable();
      return W.__detail ^= Je, W;
    }
    setMode(W) {
      const X = Rr[W];
      if (this.__mode === X)
        return this;
      const se = this.getWritable();
      return se.__mode = X, se;
    }
    setTextContent(W) {
      if (this.__text === W)
        return this;
      const X = this.getWritable();
      return X.__text = W, X;
    }
    select(W, X) {
      _s();
      let se = W, ye = X;
      const we = yo(), Ce = this.getTextContent(), Oe = this.__key;
      if (typeof Ce == "string") {
        const Ye = Ce.length;
        se === void 0 && (se = Ye), ye === void 0 && (ye = Ye);
      } else
        se = 0, ye = 0;
      if (so(we)) {
        const Ye = Xr();
        (Ye === we.anchor.key || Ye === we.focus.key) && Or(Oe), we.setTextNodeRange(this, se, this, ye);
      } else
        return fu(Oe, se, Oe, ye, "text", "text");
      return we;
    }
    spliceText(W, X, se, ye) {
      const we = this.getWritable(), Ce = we.__text, Oe = se.length;
      let Ye = W;
      Ye < 0 && (Ye = Oe + Ye, Ye < 0 && (Ye = 0));
      const Ke = yo();
      if (ye && so(Ke)) {
        const ut = W + Oe;
        Ke.setTextNodeRange(we, ut, we, ut);
      }
      const rt = Ce.slice(0, Ye) + se + Ce.slice(Ye + X);
      return we.__text = rt, we;
    }
    canInsertTextBefore() {
      return !0;
    }
    canInsertTextAfter() {
      return !0;
    }
    canContainTabs() {
      return !1;
    }
    splitText(...W) {
      _s();
      const X = this.getLatest(), se = X.getTextContent(), ye = X.__key, we = Xr(), Ce = new Set(W), Oe = [], Ye = se.length;
      let Ke = "";
      for (let to = 0; to < Ye; to++)
        Ke !== "" && Ce.has(to) && (Oe.push(Ke), Ke = ""), Ke += se[to];
      Ke !== "" && Oe.push(Ke);
      const rt = Oe.length;
      if (rt === 0)
        return [];
      if (Oe[0] === se)
        return [X];
      const ut = Oe[0], _t = X.getParentOrThrow();
      let ct;
      const Lt = X.getFormat(), St = X.getStyle(), jt = X.__detail;
      let bn = !1;
      X.isSegmented() ? (ct = es(ut), ct.__format = Lt, ct.__style = St, ct.__detail = jt, bn = !0) : (ct = X.getWritable(), ct.__text = ut);
      const Ht = yo(), ln = [ct];
      let $o = ut.length;
      for (let to = 1; to < rt; to++) {
        const Go = Oe[to], zs = Go.length, kc = es(Go).getWritable();
        kc.__format = Lt, kc.__style = St, kc.__detail = jt;
        const Tr = kc.__key, ia = $o + zs;
        if (so(Ht)) {
          const Dl = Ht.anchor, fd = Ht.focus;
          Dl.key === ye && Dl.type === "text" && Dl.offset > $o && Dl.offset <= ia && (Dl.key = Tr, Dl.offset -= $o, Ht.dirty = !0), fd.key === ye && fd.type === "text" && fd.offset > $o && fd.offset <= ia && (fd.key = Tr, fd.offset -= $o, Ht.dirty = !0);
        }
        we === ye && Or(Tr), $o = ia, ln.push(kc);
      }
      Ks(this);
      const eo = _t.getWritable(), mo = this.getIndexWithinParent();
      return bn ? (eo.splice(mo, 0, ln), this.remove()) : eo.splice(mo, 1, ln), so(Ht) && Ni(Ht, _t, mo, rt - 1), ln;
    }
    mergeWithSibling(W) {
      const X = W === this.getPreviousSibling();
      if (!X && W !== this.getNextSibling())
        throw Error("mergeWithSibling: sibling must be a previous or next sibling");
      const se = this.__key, ye = W.__key, we = this.__text, Ce = we.length;
      Xr() === ye && Or(se);
      const Ye = yo();
      if (so(Ye)) {
        const _t = Ye.anchor, ct = Ye.focus;
        _t !== null && _t.key === ye && (el(_t, X, se, W, Ce), Ye.dirty = !0), ct !== null && ct.key === ye && (el(ct, X, se, W, Ce), Ye.dirty = !0);
      }
      const Ke = W.__text, rt = X ? Ke + we : we + Ke;
      this.setTextContent(rt);
      const ut = this.getWritable();
      return W.remove(), ut;
    }
    isTextEntity() {
      return !1;
    }
  }
  function z1(te) {
    const W = te, X = W.style.fontWeight === "700", se = W.style.textDecoration === "line-through", ye = W.style.fontStyle === "italic", we = W.style.textDecoration === "underline", Ce = W.style.verticalAlign;
    return {
      forChild: (Oe) => (Wn(Oe) && (X && Oe.toggleFormat("bold"), se && Oe.toggleFormat("strikethrough"), ye && Oe.toggleFormat("italic"), we && Oe.toggleFormat("underline"), Ce === "sub" && Oe.toggleFormat("subscript"), Ce === "super" && Oe.toggleFormat("superscript")), Oe),
      node: null
    };
  }
  function Hv() {
    return {
      node: xm()
    };
  }
  function z2(te) {
    const X = te.style.fontWeight === "normal";
    return {
      forChild: (se) => (Wn(se) && !X && se.toggleFormat("bold"), se),
      node: null
    };
  }
  function R1(te, W, X) {
    let se = te.textContent || "";
    return !X && /\n/.test(se) && (se = se.replace(/\r?\n/gm, " "), se.trim().length === 0) ? {
      node: null
    } : {
      node: es(se)
    };
  }
  const P1 = {
    code: "code",
    em: "italic",
    i: "italic",
    s: "strikethrough",
    strong: "bold",
    sub: "subscript",
    sup: "superscript",
    u: "underline"
  };
  function mp(te) {
    const W = P1[te.nodeName.toLowerCase()];
    return W === void 0 ? {
      node: null
    } : {
      forChild: (X) => (Wn(X) && !X.hasFormat(W) && X.toggleFormat(W), X),
      node: null
    };
  }
  function es(te = "") {
    return Al(new Cm(te));
  }
  function Wn(te) {
    return te instanceof Cm;
  }
  class fp extends Em {
    static getType() {
      return "paragraph";
    }
    static clone(W) {
      return new fp(W.__key);
    }
    // View
    createDOM(W) {
      const X = document.createElement("p"), se = Cl(W.theme, "paragraph");
      return se !== void 0 && X.classList.add(...se), X;
    }
    updateDOM(W, X, se) {
      return !1;
    }
    static importDOM() {
      return {
        p: (W) => ({
          conversion: D1,
          priority: 0
        })
      };
    }
    exportDOM(W) {
      const {
        element: X
      } = super.exportDOM(W);
      if (X && this.isEmpty() && X.append(document.createElement("br")), X) {
        const se = this.getFormatType();
        X.style.textAlign = se;
        const ye = this.getDirection();
        ye && (X.dir = ye);
        const we = this.getIndent();
        we > 0 && (X.style.textIndent = `${we * 20}px`);
      }
      return {
        element: X
      };
    }
    static importJSON(W) {
      const X = u_();
      return X.setFormat(W.format), X.setIndent(W.indent), X.setDirection(W.direction), X;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "paragraph",
        version: 1
      };
    }
    // Mutation
    insertNewAfter(W, X) {
      const se = u_(), ye = this.getDirection();
      return se.setDirection(ye), this.insertAfter(se, X), se;
    }
    collapseAtStart() {
      const W = this.getChildren();
      if (W.length === 0 || Wn(W[0]) && W[0].getTextContent().trim() === "") {
        if (this.getNextSibling() !== null)
          return this.selectNext(), this.remove(), !0;
        if (this.getPreviousSibling() !== null)
          return this.selectPrevious(), this.remove(), !0;
      }
      return !1;
    }
  }
  function D1(te) {
    const W = u_();
    if (te.style) {
      W.setFormat(te.style.textAlign);
      const X = parseInt(te.style.textIndent, 10) / 20;
      X > 0 && W.setIndent(X);
    }
    return {
      node: W
    };
  }
  function u_() {
    return Al(new fp());
  }
  function R2(te) {
    return te instanceof fp;
  }
  const O$ = 0, rr = 1, P2 = 2, D2 = 3, ih = 4;
  function N$(te, W, X, se) {
    const ye = te._keyToDOMMap;
    ye.clear(), te._editorState = E$(), te._pendingEditorState = se, te._compositionKey = null, te._dirtyType = pe, te._cloneNotNeeded.clear(), te._dirtyLeaves = /* @__PURE__ */ new Set(), te._dirtyElements.clear(), te._normalizedNodes = /* @__PURE__ */ new Set(), te._updateTags = /* @__PURE__ */ new Set(), te._updates = [], te._blockCursorElement = null;
    const we = te._observer;
    we !== null && (we.disconnect(), te._observer = null), W !== null && (W.textContent = ""), X !== null && (X.textContent = "", ye.set("root", X));
  }
  function L2(te) {
    const W = /* @__PURE__ */ new Map(), X = /* @__PURE__ */ new Set();
    return te.forEach((se) => {
      const ye = se.klass.importDOM != null ? se.klass.importDOM.bind(se.klass) : null;
      if (ye == null || X.has(ye))
        return;
      X.add(ye);
      const we = ye();
      we !== null && Object.keys(we).forEach((Ce) => {
        let Oe = W.get(Ce);
        Oe === void 0 && (Oe = [], W.set(Ce, Oe)), Oe.push(we[Ce]);
      });
    }), W;
  }
  function M2(te) {
    const W = te || {}, X = wm(), se = W.theme || {}, ye = te === void 0 ? X : W.parentEditor || null, we = W.disableEvents || !1, Ce = E$(), Oe = W.namespace || (ye !== null ? ye._config.namespace : Sl()), Ye = W.editorState, Ke = [pp, Cm, Vf, fp, ...W.nodes || []], rt = W.onError, ut = W.editable !== void 0 ? W.editable : !0;
    let _t;
    if (te === void 0 && X !== null)
      _t = X._nodes;
    else {
      _t = /* @__PURE__ */ new Map();
      for (let Lt = 0; Lt < Ke.length; Lt++) {
        let St = Ke[Lt], jt = null, bn = null;
        if (typeof St != "function") {
          const eo = St;
          St = eo.replace, jt = eo.with, bn = eo.withKlass ? eo.withKlass : null;
        }
        {
          const eo = St.name;
          if (eo !== "RootNode") {
            const mo = St.prototype;
            ["getType", "clone"].forEach((to) => {
              St.hasOwnProperty(to) || console.warn(`${eo} must implement static "${to}" method`);
            }), // eslint-disable-next-line no-prototype-builtins
            !St.hasOwnProperty("importDOM") && // eslint-disable-next-line no-prototype-builtins
            St.hasOwnProperty("exportDOM") && console.warn(`${eo} should implement "importDOM" if using a custom "exportDOM" method to ensure HTML serialization (important for copy & paste) works as expected`), mo instanceof ms && (mo.hasOwnProperty("decorate") || console.warn(`${mo.constructor.name} must implement "decorate" method`)), St.hasOwnProperty("importJSON") || console.warn(`${eo} should implement "importJSON" method to ensure JSON and default HTML serialization works as expected`), mo.hasOwnProperty("exportJSON") || console.warn(`${eo} should implement "exportJSON" method to ensure JSON and default HTML serialization works as expected`);
          }
        }
        const Ht = St.getType(), ln = St.transform(), $o = /* @__PURE__ */ new Set();
        ln !== null && $o.add(ln), _t.set(Ht, {
          klass: St,
          replace: jt,
          replaceWithKlass: bn,
          transforms: $o
        });
      }
    }
    const ct = new Pl(Ce, ye, _t, {
      disableEvents: we,
      namespace: Oe,
      theme: se
    }, rt || console.error, L2(_t), ut);
    return Ye !== void 0 && (ct._pendingEditorState = Ye, ct._dirtyType = ve), ct;
  }
  class Pl {
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    constructor(W, X, se, ye, we, Ce, Oe) {
      this._parentEditor = X, this._rootElement = null, this._editorState = W, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = {
        decorator: /* @__PURE__ */ new Set(),
        editable: /* @__PURE__ */ new Set(),
        mutation: /* @__PURE__ */ new Map(),
        root: /* @__PURE__ */ new Set(),
        textcontent: /* @__PURE__ */ new Set(),
        update: /* @__PURE__ */ new Set()
      }, this._commands = /* @__PURE__ */ new Map(), this._config = ye, this._nodes = se, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = pe, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = Sl(), this._onError = we, this._htmlConversions = Ce, this._editable = !0, this._headless = X !== null && X._headless, this._window = null, this._blockCursorElement = null;
    }
    /**
     *
     * @returns true if the editor is currently in "composition" mode due to receiving input
     * through an IME, or 3P extension, for example. Returns false otherwise.
     */
    isComposing() {
      return this._compositionKey != null;
    }
    /**
     * Registers a listener for Editor update event. Will trigger the provided callback
     * each time the editor goes through an update (via {@link LexicalEditor.update}) until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerUpdateListener(W) {
      const X = this._listeners.update;
      return X.add(W), () => {
        X.delete(W);
      };
    }
    /**
     * Registers a listener for for when the editor changes between editable and non-editable states.
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerEditableListener(W) {
      const X = this._listeners.editable;
      return X.add(W), () => {
        X.delete(W);
      };
    }
    /**
     * Registers a listener for when the editor's decorator object changes. The decorator object contains
     * all DecoratorNode keys -> their decorated value. This is primarily used with external UI frameworks.
     *
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerDecoratorListener(W) {
      const X = this._listeners.decorator;
      return X.add(W), () => {
        X.delete(W);
      };
    }
    /**
     * Registers a listener for when Lexical commits an update to the DOM and the text content of
     * the editor changes from the previous state of the editor. If the text content is the
     * same between updates, no notifications to the listeners will happen.
     *
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerTextContentListener(W) {
      const X = this._listeners.textcontent;
      return X.add(W), () => {
        X.delete(W);
      };
    }
    /**
     * Registers a listener for when the editor's root DOM element (the content editable
     * Lexical attaches to) changes. This is primarily used to attach event listeners to the root
     *  element. The root listener function is executed directly upon registration and then on
     * any subsequent update.
     *
     * Will trigger the provided callback each time the editor transitions between these states until the
     * teardown function is called.
     *
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerRootListener(W) {
      const X = this._listeners.root;
      return W(this._rootElement, null), X.add(W), () => {
        W(null, this._rootElement), X.delete(W);
      };
    }
    /**
     * Registers a listener that will trigger anytime the provided command
     * is dispatched, subject to priority. Listeners that run at a higher priority can "intercept"
     * commands and prevent them from propagating to other handlers by returning true.
     *
     * Listeners registered at the same priority level will run deterministically in the order of registration.
     *
     * @param command - the command that will trigger the callback.
     * @param listener - the function that will execute when the command is dispatched.
     * @param priority - the relative priority of the listener. 0 | 1 | 2 | 3 | 4
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerCommand(W, X, se) {
      if (se === void 0)
        throw Error('Listener for type "command" requires a "priority".');
      const ye = this._commands;
      ye.has(W) || ye.set(W, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
      const we = ye.get(W);
      if (we === void 0)
        throw Error(`registerCommand: Command ${String(W)} not found in command map`);
      const Ce = we[se];
      return Ce.add(X), () => {
        Ce.delete(X), we.every((Oe) => Oe.size === 0) && ye.delete(W);
      };
    }
    /**
     * Registers a listener that will run when a Lexical node of the provided class is
     * mutated. The listener will receive a list of nodes along with the type of mutation
     * that was performed on each: created, destroyed, or updated.
     *
     * One common use case for this is to attach DOM event listeners to the underlying DOM nodes as Lexical nodes are created.
     * {@link LexicalEditor.getElementByKey} can be used for this.
     *
     * @param klass - The class of the node that you want to listen to mutations on.
     * @param listener - The logic you want to run when the node is mutated.
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerMutationListener(W, X) {
      if (this._nodes.get(W.getType()) === void 0)
        throw Error(`Node ${W.name} has not been registered. Ensure node has been passed to createEditor.`);
      const ye = this._listeners.mutation;
      return ye.set(X, W), () => {
        ye.delete(X);
      };
    }
    /** @internal */
    registerNodeTransformToKlass(W, X) {
      const se = W.getType(), ye = this._nodes.get(se);
      if (ye === void 0)
        throw Error(`Node ${W.name} has not been registered. Ensure node has been passed to createEditor.`);
      return ye.transforms.add(X), ye;
    }
    /**
     * Registers a listener that will run when a Lexical node of the provided class is
     * marked dirty during an update. The listener will continue to run as long as the node
     * is marked dirty. There are no guarantees around the order of transform execution!
     *
     * Watch out for infinite loops. See [Node Transforms](https://lexical.dev/docs/concepts/transforms)
     * @param klass - The class of the node that you want to run transforms on.
     * @param listener - The logic you want to run when the node is updated.
     * @returns a teardown function that can be used to cleanup the listener.
     */
    registerNodeTransform(W, X) {
      const se = this.registerNodeTransformToKlass(W, X), ye = [se], we = se.replaceWithKlass;
      if (we != null) {
        const Ce = this.registerNodeTransformToKlass(we, X);
        ye.push(Ce);
      }
      return ep(this, W.getType()), () => {
        ye.forEach((Ce) => Ce.transforms.delete(X));
      };
    }
    /**
     * Used to assert that certain nodes are registered, usually by plugins to ensure nodes that they
     * depend on have been registered.
     * @returns True if the editor has registered all of the provided node types, false otherwise.
     */
    hasNodes(W) {
      for (let X = 0; X < W.length; X++) {
        const ye = W[X].getType();
        if (!this._nodes.has(ye))
          return !1;
      }
      return !0;
    }
    /**
     * Dispatches a command of the specified type with the specified payload.
     * This triggers all command listeners (set by {@link LexicalEditor.registerCommand})
     * for this type, passing them the provided payload.
     * @param type - the type of command listeners to trigger.
     * @param payload - the data to pass as an argument to the command listeners.
     */
    dispatchCommand(W, X) {
      return nn(this, W, X);
    }
    /**
     * Gets a map of all decorators in the editor.
     * @returns A mapping of call decorator keys to their decorated content
     */
    getDecorators() {
      return this._decorators;
    }
    /**
     *
     * @returns the current root element of the editor. If you want to register
     * an event listener, do it via {@link LexicalEditor.registerRootListener}, since
     * this reference may not be stable.
     */
    getRootElement() {
      return this._rootElement;
    }
    /**
     * Gets the key of the editor
     * @returns The editor key
     */
    getKey() {
      return this._key;
    }
    /**
     * Imperatively set the root contenteditable element that Lexical listens
     * for events on.
     */
    setRootElement(W) {
      const X = this._rootElement;
      if (W !== X) {
        const se = Cl(this._config.theme, "root"), ye = this._pendingEditorState || this._editorState;
        if (this._rootElement = W, N$(this, X, W, ye), X !== null && (this._config.disableEvents || Cn(X), se != null && X.classList.remove(...se)), W !== null) {
          const we = na(W), Ce = W.style;
          Ce.userSelect = "text", Ce.whiteSpace = "pre-wrap", Ce.wordBreak = "break-word", W.setAttribute("data-lexical-editor", "true"), this._window = we, this._dirtyType = ve, cn(this), this._updateTags.add("history-merge"), km(this), this._config.disableEvents || Sn(W, this), se != null && W.classList.add(...se);
        } else
          this._window = null;
        Sm("root", this, !1, W, X);
      }
    }
    /**
     * Gets the underlying HTMLElement associated with the LexicalNode for the given key.
     * @returns the HTMLElement rendered by the LexicalNode associated with the key.
     * @param key - the key of the LexicalNode.
     */
    getElementByKey(W) {
      return this._keyToDOMMap.get(W) || null;
    }
    /**
     * Gets the active editor state.
     * @returns The editor state
     */
    getEditorState() {
      return this._editorState;
    }
    /**
     * Imperatively set the EditorState. Triggers reconciliation like an update.
     * @param editorState - the state to set the editor
     * @param options - options for the update.
     */
    setEditorState(W, X) {
      if (W.isEmpty())
        throw Error("setEditorState: the editor state is empty. Ensure the editor state's root node never becomes empty.");
      Pt(this);
      const se = this._pendingEditorState, ye = this._updateTags, we = X !== void 0 ? X.tag : null;
      se !== null && !se.isEmpty() && (we != null && ye.add(we), km(this)), this._pendingEditorState = W, this._dirtyType = ve, this._dirtyElements.set("root", !1), this._compositionKey = null, we != null && ye.add(we), km(this);
    }
    /**
     * Parses a SerializedEditorState (usually produced by {@link EditorState.toJSON}) and returns
     * and EditorState object that can be, for example, passed to {@link LexicalEditor.setEditorState}. Typically,
     * deserliazation from JSON stored in a database uses this method.
     * @param maybeStringifiedEditorState
     * @param updateFn
     * @returns
     */
    parseEditorState(W, X) {
      const se = typeof W == "string" ? JSON.parse(W) : W;
      return C1(se, this, X);
    }
    /**
     * Executes an update to the editor state. The updateFn callback is the ONLY place
     * where Lexical editor state can be safely mutated.
     * @param updateFn - A function that has access to writable editor state.
     * @param options - A bag of options to control the behavior of the update.
     * @param options.onUpdate - A function to run once the update is complete.
     * Useful for synchronizing updates in some cases.
     * @param options.skipTransforms - Setting this to true will suppress all node
     * transforms for this update cycle.
     * @param options.tag - A tag to identify this update, in an update listener, for instance.
     * Some tags are reserved by the core and control update behavior in different ways.
     * @param options.discrete - If true, prevents this update from being batched, forcing it to
     * run synchronously.
     */
    update(W, X) {
      wc(this, W, X);
    }
    /**
     * Focuses the editor
     * @param callbackFn - A function to run after the editor is focused.
     * @param options - A bag of options
     * @param options.defaultSelection - Where to move selection when the editor is
     * focused. Can be rootStart, rootEnd, or undefined. Defaults to rootEnd.
     */
    focus(W, X = {}) {
      const se = this._rootElement;
      se !== null && (se.setAttribute("autocapitalize", "off"), wc(this, () => {
        const ye = yo(), we = ss();
        ye !== null ? ye.dirty = !0 : we.getChildrenSize() !== 0 && (X.defaultSelection === "rootStart" ? we.selectStart() : we.selectEnd());
      }, {
        onUpdate: () => {
          se.removeAttribute("autocapitalize"), W && W();
        },
        tag: "focus"
      }), this._pendingEditorState === null && se.removeAttribute("autocapitalize"));
    }
    /**
     * Removes focus from the editor.
     */
    blur() {
      const W = this._rootElement;
      W !== null && W.blur();
      const X = Na(this._window);
      X !== null && X.removeAllRanges();
    }
    /**
     * Returns true if the editor is editable, false otherwise.
     * @returns True if the editor is editable, false otherwise.
     */
    isEditable() {
      return this._editable;
    }
    /**
     * Sets the editable property of the editor. When false, the
     * editor will not listen for user events on the underling contenteditable.
     * @param editable - the value to set the editable mode to.
     */
    setEditable(W) {
      this._editable !== W && (this._editable = W, Sm("editable", this, !0, W));
    }
    /**
     * Returns a JSON-serializable javascript object NOT a JSON string.
     * You still must call JSON.stringify (or something else) to turn the
     * state into a string you can transfer over the wire and store in a database.
     *
     * See {@link LexicalNode.exportJSON}
     *
     * @returns A JSON-serializable javascript object
     */
    toJSON() {
      return {
        editorState: this._editorState.toJSON()
      };
    }
  }
  class z$ extends Em {
    /** @internal */
    constructor(W, X) {
      super(X), this.__colSpan = W, this.__rowSpan = 1;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        colSpan: this.__colSpan
      };
    }
    setColSpan(W) {
      return this.getWritable().__colSpan = W, this;
    }
    setRowSpan(W) {
      return this.getWritable().__rowSpan = W, this;
    }
  }
  function ol(te) {
    return te instanceof z$;
  }
  class Yv extends Em {
  }
  function Kv(te) {
    return te instanceof Yv;
  }
  class R$ extends Em {
  }
  function fs(te) {
    return te instanceof R$;
  }
  return tn.$addUpdateTag = Er, tn.$applyNodeReplacement = Al, tn.$copyNode = Za, tn.$createLineBreakNode = xm, tn.$createNodeSelection = ec, tn.$createParagraphNode = u_, tn.$createRangeSelection = $$, tn.$createTextNode = es, tn.$getAdjacentNode = lu, tn.$getNearestNodeFromDOMNode = Hc, tn.$getNearestRootOrShadowRoot = n_, tn.$getNodeByKey = mi, tn.$getPreviousSelection = Sa, tn.$getRoot = ss, tn.$getSelection = yo, tn.$getTextContent = l_, tn.$hasAncestor = du, tn.$insertNodes = dd, tn.$isDecoratorNode = hi, tn.$isElementNode = dn, tn.$isInlineElementOrDecoratorNode = pm, tn.$isLeafNode = Wc, tn.$isLineBreakNode = oh, tn.$isNodeSelection = ud, tn.$isParagraphNode = R2, tn.$isRangeSelection = so, tn.$isRootNode = Qa, tn.$isRootOrShadowRoot = Ma, tn.$isTextNode = Wn, tn.$nodesOfType = ta, tn.$normalizeSelection__EXPERIMENTAL = ip, tn.$parseSerializedNode = eh, tn.$setCompositionKey = Or, tn.$setSelection = Co, tn.$splitNode = fa, tn.BLUR_COMMAND = H, tn.CAN_REDO_COMMAND = O, tn.CAN_UNDO_COMMAND = V, tn.CLEAR_EDITOR_COMMAND = F, tn.CLEAR_HISTORY_COMMAND = P, tn.CLICK_COMMAND = n, tn.COMMAND_PRIORITY_CRITICAL = ih, tn.COMMAND_PRIORITY_EDITOR = O$, tn.COMMAND_PRIORITY_HIGH = D2, tn.COMMAND_PRIORITY_LOW = rr, tn.COMMAND_PRIORITY_NORMAL = P2, tn.CONTROLLED_TEXT_INSERTION_COMMAND = a, tn.COPY_COMMAND = I, tn.CUT_COMMAND = z, tn.DELETE_CHARACTER_COMMAND = o, tn.DELETE_LINE_COMMAND = u, tn.DELETE_WORD_COMMAND = l, tn.DEPRECATED_$computeGridMap = tl, tn.DEPRECATED_$createGridSelection = w$, tn.DEPRECATED_$getNodeTriplet = _d, tn.DEPRECATED_$isGridCellNode = ol, tn.DEPRECATED_$isGridNode = Kv, tn.DEPRECATED_$isGridRowNode = fs, tn.DEPRECATED_$isGridSelection = ds, tn.DEPRECATED_GridCellNode = z$, tn.DEPRECATED_GridNode = Yv, tn.DEPRECATED_GridRowNode = R$, tn.DRAGEND_COMMAND = k, tn.DRAGOVER_COMMAND = x, tn.DRAGSTART_COMMAND = E, tn.DROP_COMMAND = A, tn.DecoratorNode = ms, tn.ElementNode = Em, tn.FOCUS_COMMAND = U, tn.FORMAT_ELEMENT_COMMAND = S, tn.FORMAT_TEXT_COMMAND = d, tn.INDENT_CONTENT_COMMAND = T, tn.INSERT_LINE_BREAK_COMMAND = r, tn.INSERT_PARAGRAPH_COMMAND = i, tn.KEY_ARROW_DOWN_COMMAND = y, tn.KEY_ARROW_LEFT_COMMAND = $, tn.KEY_ARROW_RIGHT_COMMAND = f, tn.KEY_ARROW_UP_COMMAND = b, tn.KEY_BACKSPACE_COMMAND = M, tn.KEY_DELETE_COMMAND = L, tn.KEY_DOWN_COMMAND = g, tn.KEY_ENTER_COMMAND = w, tn.KEY_ESCAPE_COMMAND = q, tn.KEY_MODIFIER_COMMAND = J, tn.KEY_SPACE_COMMAND = N, tn.KEY_TAB_COMMAND = R, tn.LineBreakNode = Vf, tn.MOVE_TO_END = h, tn.MOVE_TO_START = v, tn.OUTDENT_CONTENT_COMMAND = D, tn.PASTE_COMMAND = s, tn.ParagraphNode = fp, tn.REDO_COMMAND = p, tn.REMOVE_TEXT_COMMAND = c, tn.RootNode = pp, tn.SELECTION_CHANGE_COMMAND = t, tn.TextNode = Cm, tn.UNDO_COMMAND = _, tn.createCommand = e, tn.createEditor = M2, tn.getNearestEditorFromDOMNode = Jn, tn.isSelectionWithinEditor = It, tn;
}
var NR, YX;
function lr() {
  return YX || (YX = 1, NR = process.env.NODE_ENV === "development" ? SHl() : kHl()), NR;
}
var KX;
function EHl() {
  if (KX)
    return gs;
  KX = 1;
  var e = lr();
  let t = /* @__PURE__ */ new Map();
  function n(_) {
    for (; _ != null; ) {
      if (_.nodeType === Node.TEXT_NODE)
        return _;
      _ = _.firstChild;
    }
    return null;
  }
  function o(_) {
    let p = _.parentNode;
    if (p == null)
      throw Error("Should never happen");
    return [p, Array.from(p.childNodes).indexOf(_)];
  }
  function r(_) {
    let p = {};
    _ = _.split(";");
    for (let g of _)
      if (g !== "") {
        let [f, h] = g.split(/:([^]+)/);
        p[f.trim()] = h.trim();
      }
    return p;
  }
  function i(_) {
    let p = t.get(_);
    return p === void 0 && (p = r(_), t.set(_, p)), p;
  }
  function a(_) {
    let p = "";
    for (let g in _)
      g && (p += `${g}: ${_[g]};`);
    return p;
  }
  function s(_, p) {
    var g = i("getStyle" in _ ? _.getStyle() : _.style);
    p = Object.entries(p).reduce((f, [h, $]) => ($ === null ? delete f[h] : f[h] = $, f), { ...g }), g = a(p), _.setStyle(g), t.set(g, p);
  }
  function c(_) {
    for (; _ !== null && !e.$isRootOrShadowRoot(_); ) {
      let p = _.getLatest(), g = _.getParent();
      p.getChildrenSize() === 0 && _.remove(!0), _ = g;
    }
  }
  function l(_, p, g, f, h = null) {
    if (p.length !== 0) {
      var $ = p[0], v = /* @__PURE__ */ new Map(), b = [];
      $ = e.$isElementNode($) ? $ : $.getParentOrThrow(), $.isInline() && ($ = $.getParentOrThrow());
      for (var y = !1; $ !== null; ) {
        var w = $.getPreviousSibling();
        if (w !== null) {
          $ = w, y = !0;
          break;
        }
        if ($ = $.getParentOrThrow(), e.$isRootOrShadowRoot($))
          break;
      }
      w = /* @__PURE__ */ new Set();
      for (var N = 0; N < g; N++) {
        var M = p[N];
        e.$isElementNode(M) && M.getChildrenSize() === 0 && w.add(M.getKey());
      }
      var q = /* @__PURE__ */ new Set();
      for (N = 0; N < g; N++) {
        M = p[N];
        var L = M.getParent();
        if (L !== null && L.isInline() && (L = L.getParent()), L !== null && e.$isLeafNode(M) && !q.has(M.getKey())) {
          if (M = L.getKey(), v.get(M) === void 0) {
            let R = f();
            R.setFormat(L.getFormatType()), R.setIndent(L.getIndent()), b.push(R), v.set(M, R), L.getChildren().forEach((T) => {
              R.append(T), q.add(T.getKey()), e.$isElementNode(T) && T.getChildrenKeys().forEach((D) => q.add(D));
            }), c(L);
          }
        } else
          w.has(M.getKey()) && (L = f(), L.setFormat(M.getFormatType()), L.setIndent(M.getIndent()), b.push(L), M.remove(!0));
      }
      if (h !== null)
        for (p = 0; p < b.length; p++)
          h.append(b[p]);
      if (p = null, e.$isRootOrShadowRoot($))
        if (y)
          if (h !== null)
            $.insertAfter(h);
          else
            for (h = b.length - 1; 0 <= h; h--)
              $.insertAfter(b[h]);
        else if (y = $.getFirstChild(), e.$isElementNode(y) && ($ = y), y === null)
          if (h)
            $.append(h);
          else
            for (h = 0; h < b.length; h++)
              y = b[h], $.append(y), p = y;
        else if (h !== null)
          y.insertBefore(h);
        else
          for ($ = 0; $ < b.length; $++)
            h = b[$], y.insertBefore(h), p = h;
      else if (h)
        $.insertAfter(h);
      else
        for (h = b.length - 1; 0 <= h; h--)
          y = b[h], $.insertAfter(y), p = y;
      b = e.$getPreviousSelection(), e.$isRangeSelection(b) && b.anchor.getNode().isAttached() && b.focus.getNode().isAttached() ? e.$setSelection(b.clone()) : p !== null ? p.selectEnd() : _.dirty = !0;
    }
  }
  function u(_, p, g, f) {
    _.modify(p ? "extend" : "move", g, f);
  }
  function d(_) {
    return _ = _.anchor.getNode(), (e.$isRootNode(_) ? _ : _.getParentOrThrow()).getDirection() === "rtl";
  }
  return gs.$addNodeStyle = function(_) {
    _ = _.getStyle();
    let p = r(_);
    t.set(_, p);
  }, gs.$cloneWithProperties = function(_) {
    _ = _.getLatest();
    let p = _.constructor.clone(_);
    return p.__parent = _.__parent, p.__next = _.__next, p.__prev = _.__prev, e.$isElementNode(_) && e.$isElementNode(p) ? (p.__first = _.__first, p.__last = _.__last, p.__size = _.__size, p.__format = _.__format, p.__indent = _.__indent, p.__dir = _.__dir, p) : (e.$isTextNode(_) && e.$isTextNode(p) && (p.__format = _.__format, p.__style = _.__style, p.__mode = _.__mode, p.__detail = _.__detail), p);
  }, gs.$getSelectionStyleValueForProperty = function(_, p, g = "") {
    let f = null, h = _.getNodes();
    var $ = _.anchor, v = _.focus, b = _.isBackward();
    let y = b ? v.offset : $.offset;
    if ($ = b ? v.getNode() : $.getNode(), _.style !== "" && (_ = i(_.style), _ !== null && p in _))
      return _[p];
    for (_ = 0; _ < h.length; _++) {
      var w = h[_];
      if ((_ === 0 || y !== 0 || !w.is($)) && e.$isTextNode(w)) {
        if (v = p, b = g, w = w.getStyle(), w = i(w), v = w !== null && w[v] || b, f === null)
          f = v;
        else if (f !== v) {
          f = "";
          break;
        }
      }
    }
    return f === null ? g : f;
  }, gs.$isAtNodeEnd = function(_) {
    return _.type === "text" ? _.offset === _.getNode().getTextContentSize() : _.offset === _.getNode().getChildrenSize();
  }, gs.$isParentElementRTL = d, gs.$moveCaretSelection = u, gs.$moveCharacter = function(_, p, g) {
    let f = d(_);
    u(_, p, g ? !f : f, "character");
  }, gs.$patchStyleText = function(_, p) {
    var g = _.getNodes();
    let f = g.length - 1, h = g[0], $ = g[f];
    if (_.isCollapsed())
      s(_, p);
    else {
      var v = _.anchor, b = _.focus, y = h.getTextContent().length, w = b.offset, N = v.offset, M = v.isBefore(b), q = M ? N : w;
      _ = M ? w : N;
      var L = M ? v.type : b.type, R = M ? b.type : v.type;
      if (v = M ? b.key : v.key, e.$isTextNode(h) && q === y && (b = h.getNextSibling(), e.$isTextNode(b) && (q = N = 0, h = b)), g.length === 1)
        e.$isTextNode(h) && (q = L === "element" ? 0 : N > w ? w : N, _ = R === "element" ? y : N > w ? N : w, q !== _ && (q === 0 && _ === y ? (s(h, p), h.select(q, _)) : (g = h.splitText(
          q,
          _
        ), g = q === 0 ? g[0] : g[1], s(g, p), g.select(0, _ - q))));
      else
        for (e.$isTextNode(h) && q < h.getTextContentSize() && (q !== 0 && (h = h.splitText(q)[1]), s(h, p)), e.$isTextNode($) && (q = $.getTextContent().length, $.__key !== v && _ !== 0 && (_ = q), _ !== q && ([$] = $.splitText(_)), _ !== 0 && s($, p)), _ = 1; _ < f; _++)
          q = g[_], y = q.getKey(), e.$isTextNode(q) && y !== h.getKey() && y !== $.getKey() && !q.isToken() && s(q, p);
    }
  }, gs.$selectAll = function(_) {
    let p = _.anchor;
    _ = _.focus;
    var g = p.getNode().getTopLevelElementOrThrow().getParentOrThrow();
    let f = g.getFirstDescendant();
    g = g.getLastDescendant();
    let h = "element", $ = "element", v = 0;
    e.$isTextNode(f) ? h = "text" : e.$isElementNode(f) || f === null || (f = f.getParentOrThrow()), e.$isTextNode(g) ? ($ = "text", v = g.getTextContentSize()) : e.$isElementNode(g) || g === null || (g = g.getParentOrThrow()), f && g && (p.set(f.getKey(), 0, h), _.set(g.getKey(), v, $));
  }, gs.$setBlocksType = function(_, p) {
    if (_.anchor.key === "root") {
      p = p();
      var g = e.$getRoot();
      (_ = g.getFirstChild()) ? _.replace(p, !0) : g.append(p);
    } else
      for (g = _.getNodes(), _ = _.anchor.getNode().getParentOrThrow(), g.indexOf(_) === -1 && g.push(_), _.isInline() && (_ = _.getParentOrThrow(), g.indexOf(_) === -1 && g.push(_)), _ = 0; _ < g.length; _++) {
        let $ = g[_];
        var f = $;
        if (!e.$isElementNode(f) || e.$isRootOrShadowRoot(f))
          f = !1;
        else {
          var h = f.getFirstChild();
          h = h === null || e.$isTextNode(h) || h.isInline(), f = !f.isInline() && f.canBeEmpty() !== !1 && h;
        }
        f && (f = p(), f.setFormat($.getFormatType()), f.setIndent($.getIndent()), $.replace(f, !0));
      }
  }, gs.$shouldOverrideDefaultCharacterSelection = function(_, p) {
    return _ = e.$getAdjacentNode(_.focus, p), e.$isDecoratorNode(_) && !_.isIsolated() || e.$isElementNode(_) && !_.isInline() && !_.canBeEmpty();
  }, gs.$sliceSelectedTextNodeContent = function(_, p) {
    if (p.isSelected() && !p.isSegmented() && !p.isToken() && (e.$isRangeSelection(_) || e.DEPRECATED_$isGridSelection(_))) {
      var g = _.anchor.getNode(), f = _.focus.getNode(), h = p.is(g), $ = p.is(f);
      if (h || $) {
        h = _.isBackward();
        let [v, b] = _.getCharacterOffsets();
        _ = g.is(f), $ = p.is(h ? f : g), f = p.is(h ? g : f), g = 0;
        let y;
        _ ? (g = v > b ? b : v, y = v > b ? v : b) : $ ? (g = h ? b : v, y = void 0) : f && (h = h ? v : b, g = 0, y = h), p.__text = p.__text.slice(g, y);
      }
    }
    return p;
  }, gs.$wrapNodes = function(_, p, g = null) {
    var f = _.getNodes();
    let h = f.length;
    var $ = _.anchor;
    if (h === 0 || h === 1 && $.type === "element" && $.getNode().getChildrenSize() === 0) {
      _ = $.type === "text" ? $.getNode().getParentOrThrow() : $.getNode(), f = _.getChildren();
      let b = p();
      b.setFormat(_.getFormatType()), b.setIndent(_.getIndent()), f.forEach((y) => b.append(y)), g && (b = g.append(b)), _.replace(b);
    } else {
      $ = null;
      var v = [];
      for (let b = 0; b < h; b++) {
        let y = f[b];
        e.$isRootOrShadowRoot(y) ? (l(_, v, v.length, p, g), v = [], $ = y) : $ === null || $ !== null && e.$hasAncestor(
          y,
          $
        ) ? v.push(y) : (l(_, v, v.length, p, g), v = [y]);
      }
      l(_, v, v.length, p, g);
    }
  }, gs.createDOMRange = function(_, p, g, f, h) {
    let $ = p.getKey(), v = f.getKey(), b = document.createRange(), y = _.getElementByKey($);
    if (_ = _.getElementByKey(v), e.$isTextNode(p) && (y = n(y)), e.$isTextNode(f) && (_ = n(_)), p === void 0 || f === void 0 || y === null || _ === null)
      return null;
    y.nodeName === "BR" && ([y, g] = o(y)), _.nodeName === "BR" && ([_, h] = o(_)), p = y.firstChild, y === _ && p != null && p.nodeName === "BR" && g === 0 && h === 0 && (h = 1);
    try {
      b.setStart(y, g), b.setEnd(_, h);
    } catch {
      return null;
    }
    return !b.collapsed || g === h && $ === v || (b.setStart(_, h), b.setEnd(
      y,
      g
    )), b;
  }, gs.createRectsFromDOMRange = function(_, p) {
    var g = _.getRootElement();
    if (g === null)
      return [];
    _ = g.getBoundingClientRect(), g = getComputedStyle(g), g = parseFloat(g.paddingLeft) + parseFloat(g.paddingRight), p = Array.from(p.getClientRects());
    let f = p.length, h;
    for (let $ = 0; $ < f; $++) {
      let v = p[$], b = v.width + g === _.width;
      h && h.top === v.top && h.left === v.left && h.width === v.width && h.height === v.height || b ? (p.splice($--, 1), f--) : h = v;
    }
    return p;
  }, gs.getStyleObjectFromCSS = i, gs.trimTextContentFromAnchor = function(_, p, g) {
    let f = p.getNode();
    if (e.$isElementNode(f)) {
      var h = f.getDescendantByIndex(p.offset);
      h !== null && (f = h);
    }
    for (; 0 < g && f !== null; ) {
      var $ = f.getPreviousSibling(), v = 0;
      if ($ === null) {
        h = f.getParentOrThrow();
        for (var b = h.getPreviousSibling(); b === null; ) {
          if (h = h.getParent(), h === null) {
            $ = null;
            break;
          }
          b = h.getPreviousSibling();
        }
        h !== null && (v = h.isInline() ? 0 : 2, $ = e.$isElementNode(b) ? b.getLastDescendant() : b);
      }
      if (b = f.getTextContent(), b === "" && e.$isElementNode(f) && !f.isInline() && (b = `

`), h = f.getTextContentSize(), !e.$isTextNode(f) || g >= h)
        b = f.getParent(), f.remove(), b == null || b.getChildrenSize() !== 0 || e.$isRootNode(b) || b.remove(), g -= h + v, f = $;
      else {
        let y = f.getKey();
        v = _.getEditorState().read(() => {
          const N = e.$getNodeByKey(y);
          return e.$isTextNode(N) && N.isSimpleText() ? N.getTextContent() : null;
        }), $ = h - g;
        let w = b.slice(0, $);
        v !== null && v !== b ? (g = e.$getPreviousSelection(), h = f, f.isSimpleText() ? f.setTextContent(v) : (h = e.$createTextNode(v), f.replace(h)), e.$isRangeSelection(g) && g.isCollapsed() && (g = g.anchor.offset, h.select(g, g))) : f.isSimpleText() ? (v = p.key === y, b = p.offset, b < g && (b = h), g = v ? b - g : 0, h = v ? b : $, v && g === 0 ? ([g] = f.splitText(g, h), g.remove()) : ([, g] = f.splitText(g, h), g.remove())) : (g = e.$createTextNode(w), f.replace(g)), g = 0;
      }
    }
  }, gs;
}
var hs = {}, ZX;
function xHl() {
  if (ZX)
    return hs;
  ZX = 1;
  var e = lr();
  const t = /* @__PURE__ */ new Map();
  function n(E) {
    let x = E;
    for (; x != null; ) {
      if (x.nodeType === Node.TEXT_NODE)
        return x;
      x = x.firstChild;
    }
    return null;
  }
  function o(E) {
    const x = E.parentNode;
    if (x == null)
      throw new Error("Should never happen");
    return [x, Array.from(x.childNodes).indexOf(E)];
  }
  function r(E, x, k, I, z) {
    const F = x.getKey(), P = I.getKey(), O = document.createRange();
    let V = E.getElementByKey(F), U = E.getElementByKey(P), H = k, J = z;
    if (e.$isTextNode(x) && (V = n(V)), e.$isTextNode(I) && (U = n(U)), x === void 0 || I === void 0 || V === null || U === null)
      return null;
    V.nodeName === "BR" && ([V, H] = o(V)), U.nodeName === "BR" && ([U, J] = o(U));
    const le = V.firstChild;
    V === U && le != null && le.nodeName === "BR" && H === 0 && J === 0 && (J = 1);
    try {
      O.setStart(V, H), O.setEnd(U, J);
    } catch {
      return null;
    }
    return O.collapsed && (H !== J || F !== P) && (O.setStart(U, J), O.setEnd(V, H)), O;
  }
  function i(E, x) {
    const k = E.getRootElement();
    if (k === null)
      return [];
    const I = k.getBoundingClientRect(), z = getComputedStyle(k), F = parseFloat(z.paddingLeft) + parseFloat(z.paddingRight), P = Array.from(x.getClientRects());
    let O = P.length, V;
    for (let U = 0; U < O; U++) {
      const H = P[U], J = V && V.top === H.top && V.left === H.left && V.width === H.width && V.height === H.height, le = H.width + F === I.width;
      if (J || le) {
        P.splice(U--, 1), O--;
        continue;
      }
      V = H;
    }
    return P;
  }
  function a(E) {
    const x = {}, k = E.split(";");
    for (const I of k)
      if (I !== "") {
        const [z, F] = I.split(/:([^]+)/);
        x[z.trim()] = F.trim();
      }
    return x;
  }
  function s(E) {
    let x = t.get(E);
    return x === void 0 && (x = a(E), t.set(E, x)), x;
  }
  function c(E) {
    let x = "";
    for (const k in E)
      k && (x += `${k}: ${E[k]};`);
    return x;
  }
  function l(E, x) {
    return E.__first = x.__first, E.__last = x.__last, E.__size = x.__size, E.__format = x.__format, E.__indent = x.__indent, E.__dir = x.__dir, E;
  }
  function u(E, x) {
    return E.__format = x.__format, E.__style = x.__style, E.__mode = x.__mode, E.__detail = x.__detail, E;
  }
  function d(E) {
    const x = E.getLatest(), I = x.constructor.clone(x);
    return I.__parent = x.__parent, I.__next = x.__next, I.__prev = x.__prev, e.$isElementNode(x) && e.$isElementNode(I) ? l(I, x) : e.$isTextNode(x) && e.$isTextNode(I) ? u(I, x) : I;
  }
  function _(E, x) {
    if (x.isSelected() && !x.isSegmented() && !x.isToken() && (e.$isRangeSelection(E) || e.DEPRECATED_$isGridSelection(E))) {
      const k = E.anchor.getNode(), I = E.focus.getNode(), z = x.is(k), F = x.is(I);
      if (z || F) {
        const P = E.isBackward(), [O, V] = E.getCharacterOffsets(), U = k.is(I), H = x.is(P ? I : k), J = x.is(P ? k : I);
        let le = 0, ae;
        if (U)
          le = O > V ? V : O, ae = O > V ? O : V;
        else if (H)
          le = P ? V : O, ae = void 0;
        else if (J) {
          const Y = P ? O : V;
          le = 0, ae = Y;
        }
        return x.__text = x.__text.slice(le, ae), x;
      }
    }
    return x;
  }
  function p(E) {
    return E.type === "text" ? E.offset === E.getNode().getTextContentSize() : E.offset === E.getNode().getChildrenSize();
  }
  function g(E, x, k) {
    let I = x.getNode(), z = k;
    if (e.$isElementNode(I)) {
      const F = I.getDescendantByIndex(x.offset);
      F !== null && (I = F);
    }
    for (; z > 0 && I !== null; ) {
      let F = I.getPreviousSibling(), P = 0;
      if (F === null) {
        let U = I.getParentOrThrow(), H = U.getPreviousSibling();
        for (; H === null; ) {
          if (U = U.getParent(), U === null) {
            F = null;
            break;
          }
          H = U.getPreviousSibling();
        }
        U !== null && (P = U.isInline() ? 0 : 2, e.$isElementNode(H) ? F = H.getLastDescendant() : F = H);
      }
      let O = I.getTextContent();
      O === "" && e.$isElementNode(I) && !I.isInline() && (O = `

`);
      const V = I.getTextContentSize();
      if (!e.$isTextNode(I) || z >= V) {
        const U = I.getParent();
        I.remove(), U != null && U.getChildrenSize() === 0 && !e.$isRootNode(U) && U.remove(), z -= V + P, I = F;
      } else {
        const U = I.getKey(), H = E.getEditorState().read(() => {
          const ae = e.$getNodeByKey(U);
          return e.$isTextNode(ae) && ae.isSimpleText() ? ae.getTextContent() : null;
        }), J = V - z, le = O.slice(0, J);
        if (H !== null && H !== O) {
          const ae = e.$getPreviousSelection();
          let Y = I;
          if (I.isSimpleText())
            I.setTextContent(H);
          else {
            const re = e.$createTextNode(H);
            I.replace(re), Y = re;
          }
          if (e.$isRangeSelection(ae) && ae.isCollapsed()) {
            const re = ae.anchor.offset;
            Y.select(re, re);
          }
        } else if (I.isSimpleText()) {
          const ae = x.key === U;
          let Y = x.offset;
          Y < z && (Y = V);
          const re = ae ? Y - z : 0, ie = ae ? Y : J;
          if (ae && re === 0) {
            const [_e] = I.splitText(re, ie);
            _e.remove();
          } else {
            const [, _e] = I.splitText(re, ie);
            _e.remove();
          }
        } else {
          const ae = e.$createTextNode(le);
          I.replace(ae);
        }
        z = 0;
      }
    }
  }
  function f(E) {
    const x = E.getStyle(), k = a(x);
    t.set(x, k);
  }
  function h(E, x) {
    const k = s("getStyle" in E ? E.getStyle() : E.style), I = Object.entries(x).reduce((F, [P, O]) => (O === null ? delete F[P] : F[P] = O, F), {
      ...k
    }), z = c(I);
    E.setStyle(z), t.set(z, I);
  }
  function $(E, x) {
    const k = E.getNodes(), z = k.length - 1;
    let F = k[0], P = k[z];
    if (E.isCollapsed()) {
      h(E, x);
      return;
    }
    const O = E.anchor, V = E.focus, H = F.getTextContent().length, J = V.offset;
    let le = O.offset;
    const ae = O.isBefore(V);
    let Y = ae ? le : J, re = ae ? J : le;
    const ie = ae ? O.type : V.type, _e = ae ? V.type : O.type, he = ae ? V.key : O.key;
    if (e.$isTextNode(F) && Y === H) {
      const be = F.getNextSibling();
      e.$isTextNode(be) && (le = 0, Y = 0, F = be);
    }
    if (k.length === 1) {
      if (e.$isTextNode(F)) {
        if (Y = ie === "element" ? 0 : le > J ? J : le, re = _e === "element" ? H : le > J ? le : J, Y === re)
          return;
        if (Y === 0 && re === H)
          h(F, x), F.select(Y, re);
        else {
          const be = F.splitText(Y, re), Q = Y === 0 ? be[0] : be[1];
          h(Q, x), Q.select(0, re - Y);
        }
      }
    } else {
      if (e.$isTextNode(F) && Y < F.getTextContentSize() && (Y !== 0 && (F = F.splitText(Y)[1], Y = 0), h(F, x)), e.$isTextNode(P)) {
        const Q = P.getTextContent().length;
        P.__key !== he && re !== 0 && (re = Q), re !== Q && ([P] = P.splitText(re)), re !== 0 && h(P, x);
      }
      for (let be = 1; be < z; be++) {
        const Q = k[be], me = Q.getKey();
        e.$isTextNode(Q) && me !== F.getKey() && me !== P.getKey() && !Q.isToken() && h(Q, x);
      }
    }
  }
  function v(E, x) {
    if (E.anchor.key === "root") {
      const z = x(), F = e.$getRoot(), P = F.getFirstChild();
      P ? P.replace(z, !0) : F.append(z);
      return;
    }
    const k = E.getNodes();
    let I = E.anchor.getNode().getParentOrThrow();
    k.indexOf(I) === -1 && k.push(I), I.isInline() && (I = I.getParentOrThrow(), k.indexOf(I) === -1 && k.push(I));
    for (let z = 0; z < k.length; z++) {
      const F = k[z];
      if (!b(F))
        continue;
      const P = x();
      P.setFormat(F.getFormatType()), P.setIndent(F.getIndent()), F.replace(P, !0);
    }
  }
  function b(E) {
    if (!e.$isElementNode(E) || e.$isRootOrShadowRoot(E))
      return !1;
    const x = E.getFirstChild(), k = x === null || e.$isTextNode(x) || x.isInline();
    return !E.isInline() && E.canBeEmpty() !== !1 && k;
  }
  function y(E) {
    return E.getNode().isAttached();
  }
  function w(E) {
    let x = E;
    for (; x !== null && !e.$isRootOrShadowRoot(x); ) {
      const k = x.getLatest(), I = x.getParent();
      k.getChildrenSize() === 0 && x.remove(!0), x = I;
    }
  }
  function N(E, x, k = null) {
    const I = E.getNodes(), z = I.length, F = E.anchor;
    if (z === 0 || z === 1 && F.type === "element" && F.getNode().getChildrenSize() === 0) {
      const V = F.type === "text" ? F.getNode().getParentOrThrow() : F.getNode(), U = V.getChildren();
      let H = x();
      H.setFormat(V.getFormatType()), H.setIndent(V.getIndent()), U.forEach((J) => H.append(J)), k && (H = k.append(H)), V.replace(H);
      return;
    }
    let P = null, O = [];
    for (let V = 0; V < z; V++) {
      const U = I[V];
      e.$isRootOrShadowRoot(U) ? (M(E, O, O.length, x, k), O = [], P = U) : P === null || P !== null && e.$hasAncestor(U, P) ? O.push(U) : (M(E, O, O.length, x, k), O = [U]);
    }
    M(E, O, O.length, x, k);
  }
  function M(E, x, k, I, z = null) {
    if (x.length === 0)
      return;
    const F = x[0], P = /* @__PURE__ */ new Map(), O = [];
    let V = e.$isElementNode(F) ? F : F.getParentOrThrow();
    V.isInline() && (V = V.getParentOrThrow());
    let U = !1;
    for (; V !== null; ) {
      const Y = V.getPreviousSibling();
      if (Y !== null) {
        V = Y, U = !0;
        break;
      }
      if (V = V.getParentOrThrow(), e.$isRootOrShadowRoot(V))
        break;
    }
    const H = /* @__PURE__ */ new Set();
    for (let Y = 0; Y < k; Y++) {
      const re = x[Y];
      e.$isElementNode(re) && re.getChildrenSize() === 0 && H.add(re.getKey());
    }
    const J = /* @__PURE__ */ new Set();
    for (let Y = 0; Y < k; Y++) {
      const re = x[Y];
      let ie = re.getParent();
      if (ie !== null && ie.isInline() && (ie = ie.getParent()), ie !== null && e.$isLeafNode(re) && !J.has(re.getKey())) {
        const _e = ie.getKey();
        if (P.get(_e) === void 0) {
          const he = I();
          he.setFormat(ie.getFormatType()), he.setIndent(ie.getIndent()), O.push(he), P.set(_e, he), ie.getChildren().forEach((be) => {
            he.append(be), J.add(be.getKey()), e.$isElementNode(be) && be.getChildrenKeys().forEach((Q) => J.add(Q));
          }), w(ie);
        }
      } else if (H.has(re.getKey())) {
        const _e = I();
        _e.setFormat(re.getFormatType()), _e.setIndent(re.getIndent()), O.push(_e), re.remove(!0);
      }
    }
    if (z !== null)
      for (let Y = 0; Y < O.length; Y++) {
        const re = O[Y];
        z.append(re);
      }
    let le = null;
    if (e.$isRootOrShadowRoot(V))
      if (U)
        if (z !== null)
          V.insertAfter(z);
        else
          for (let Y = O.length - 1; Y >= 0; Y--) {
            const re = O[Y];
            V.insertAfter(re);
          }
      else {
        const Y = V.getFirstChild();
        if (e.$isElementNode(Y) && (V = Y), Y === null)
          if (z)
            V.append(z);
          else
            for (let re = 0; re < O.length; re++) {
              const ie = O[re];
              V.append(ie), le = ie;
            }
        else if (z !== null)
          Y.insertBefore(z);
        else
          for (let re = 0; re < O.length; re++) {
            const ie = O[re];
            Y.insertBefore(ie), le = ie;
          }
      }
    else if (z)
      V.insertAfter(z);
    else
      for (let Y = O.length - 1; Y >= 0; Y--) {
        const re = O[Y];
        V.insertAfter(re), le = re;
      }
    const ae = e.$getPreviousSelection();
    e.$isRangeSelection(ae) && y(ae.anchor) && y(ae.focus) ? e.$setSelection(ae.clone()) : le !== null ? le.selectEnd() : E.dirty = !0;
  }
  function q(E, x) {
    const k = e.$getAdjacentNode(E.focus, x);
    return e.$isDecoratorNode(k) && !k.isIsolated() || e.$isElementNode(k) && !k.isInline() && !k.canBeEmpty();
  }
  function L(E, x, k, I) {
    E.modify(x ? "extend" : "move", k, I);
  }
  function R(E) {
    const x = E.anchor.getNode();
    return (e.$isRootNode(x) ? x : x.getParentOrThrow()).getDirection() === "rtl";
  }
  function T(E, x, k) {
    const I = R(E);
    L(E, x, k ? !I : I, "character");
  }
  function D(E) {
    const x = E.anchor, k = E.focus, F = x.getNode().getTopLevelElementOrThrow().getParentOrThrow();
    let P = F.getFirstDescendant(), O = F.getLastDescendant(), V = "element", U = "element", H = 0;
    e.$isTextNode(P) ? V = "text" : !e.$isElementNode(P) && P !== null && (P = P.getParentOrThrow()), e.$isTextNode(O) ? (U = "text", H = O.getTextContentSize()) : !e.$isElementNode(O) && O !== null && (O = O.getParentOrThrow()), P && O && (x.set(P.getKey(), 0, V), k.set(O.getKey(), H, U));
  }
  function A(E, x, k) {
    const I = E.getStyle(), z = s(I);
    return z !== null && z[x] || k;
  }
  function S(E, x, k = "") {
    let I = null;
    const z = E.getNodes(), F = E.anchor, P = E.focus, O = E.isBackward(), V = O ? P.offset : F.offset, U = O ? P.getNode() : F.getNode();
    if (E.style !== "") {
      const H = E.style, J = s(H);
      if (J !== null && x in J)
        return J[x];
    }
    for (let H = 0; H < z.length; H++) {
      const J = z[H];
      if (!(H !== 0 && V === 0 && J.is(U)) && e.$isTextNode(J)) {
        const le = A(J, x, k);
        if (I === null)
          I = le;
        else if (I !== le) {
          I = "";
          break;
        }
      }
    }
    return I === null ? k : I;
  }
  return hs.$addNodeStyle = f, hs.$cloneWithProperties = d, hs.$getSelectionStyleValueForProperty = S, hs.$isAtNodeEnd = p, hs.$isParentElementRTL = R, hs.$moveCaretSelection = L, hs.$moveCharacter = T, hs.$patchStyleText = $, hs.$selectAll = D, hs.$setBlocksType = v, hs.$shouldOverrideDefaultCharacterSelection = q, hs.$sliceSelectedTextNodeContent = _, hs.$wrapNodes = N, hs.createDOMRange = r, hs.createRectsFromDOMRange = i, hs.getStyleObjectFromCSS = s, hs.trimTextContentFromAnchor = g, hs;
}
var zR, XX;
function If() {
  return XX || (XX = 1, zR = process.env.NODE_ENV === "development" ? xHl() : EHl()), zR;
}
var JX;
function CHl() {
  if (JX)
    return Ps;
  JX = 1;
  var e = If(), t = lr();
  function n(i, a) {
    for (let s of a)
      if (i.type.startsWith(s))
        return !0;
    return !1;
  }
  function o(i, a) {
    for (; i !== t.$getRoot() && i != null; ) {
      if (a(i))
        return i;
      i = i.getParent();
    }
    return null;
  }
  function r(i) {
    return i.nodeType === 1;
  }
  return Ps.$splitNode = t.$splitNode, Ps.$dfs = function(i, a) {
    let s = [];
    i = (i || t.$getRoot()).getLatest(), a = a || (t.$isElementNode(i) ? i.getLastDescendant() : i);
    for (var c = i, l = 0; (c = c.getParent()) !== null; )
      l++;
    for (c = l; i !== null && !i.is(a); )
      if (s.push({ depth: c, node: i }), t.$isElementNode(i) && 0 < i.getChildrenSize())
        i = i.getFirstChild(), c++;
      else
        for (l = null; l === null && i !== null; )
          l = i.getNextSibling(), l === null ? (i = i.getParent(), c--) : i = l;
    return i !== null && i.is(a) && s.push({ depth: c, node: i }), s;
  }, Ps.$findMatchingParent = o, Ps.$getNearestBlockElementAncestorOrThrow = function(i) {
    if (i = o(i, (a) => t.$isElementNode(a) && !a.isInline()), !t.$isElementNode(i))
      throw Error("Minified Lexical error #4; visit https://lexical.dev/docs/error?code=4 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
    return i;
  }, Ps.$getNearestNodeOfType = function(i, a) {
    for (; i != null; ) {
      if (i instanceof a)
        return i;
      i = i.getParent();
    }
    return null;
  }, Ps.$insertNodeToNearestRoot = function(i) {
    var a = t.$getSelection();
    if (t.$isRangeSelection(a)) {
      var { focus: s } = a;
      if (a = s.getNode(), s = s.offset, t.$isRootOrShadowRoot(a))
        s = a.getChildAtIndex(s), s == null ? a.append(i) : s.insertBefore(i), i.selectNext();
      else {
        let c, l;
        t.$isTextNode(a) ? (c = a.getParentOrThrow(), l = a.getIndexWithinParent(), 0 < s && (l += 1, a.splitText(s))) : (c = a, l = s), [, a] = t.$splitNode(c, l), a.insertBefore(i), a.selectStart();
      }
    } else
      t.$isNodeSelection(a) || t.DEPRECATED_$isGridSelection(a) ? (a = a.getNodes(), a[a.length - 1].getTopLevelElementOrThrow().insertAfter(i)) : t.$getRoot().append(i), a = t.$createParagraphNode(), i.insertAfter(a), a.select();
    return i.getLatest();
  }, Ps.$restoreEditorState = function(i, a) {
    let s = /* @__PURE__ */ new Map(), c = i._pendingEditorState;
    for (let [l, u] of a._nodeMap) {
      let d = e.$cloneWithProperties(u);
      t.$isTextNode(d) && (d.__text = u.__text), s.set(l, d);
    }
    c && (c._nodeMap = s), i._dirtyType = 2, i = a._selection, t.$setSelection(i === null ? null : i.clone());
  }, Ps.$wrapNodeInElement = function(i, a) {
    return a = a(), i.replace(a), a.append(i), a;
  }, Ps.addClassNamesToElement = function(i, ...a) {
    a.forEach((s) => {
      typeof s == "string" && (s = s.split(" ").filter((c) => c !== ""), i.classList.add(...s));
    });
  }, Ps.isHTMLAnchorElement = function(i) {
    return r(i) && i.tagName === "A";
  }, Ps.isHTMLElement = r, Ps.isMimeType = n, Ps.mediaFileReader = function(i, a) {
    let s = i[Symbol.iterator]();
    return new Promise((c, l) => {
      let u = [], d = () => {
        const { done: _, value: p } = s.next();
        if (_)
          return c(u);
        const g = new FileReader();
        g.addEventListener("error", l), g.addEventListener("load", () => {
          const f = g.result;
          typeof f == "string" && u.push({ file: p, result: f }), d();
        }), n(p, a) ? g.readAsDataURL(p) : d();
      };
      d();
    });
  }, Ps.mergeRegister = function(...i) {
    return () => {
      i.forEach((a) => a());
    };
  }, Ps.registerNestedElementResolver = function(i, a, s, c) {
    return i.registerNodeTransform(a, (l) => {
      e: {
        for (var u = l.getChildren(), d = 0; d < u.length; d++)
          if (u[d] instanceof a) {
            u = null;
            break e;
          }
        for (u = l; u !== null; )
          if (d = u, u = u.getParent(), u instanceof a) {
            u = { child: d, parent: u };
            break e;
          }
        u = null;
      }
      if (u !== null) {
        const { child: _, parent: p } = u;
        if (_.is(l)) {
          if (c(p, l), l = _.getNextSiblings(), u = l.length, p.insertAfter(_), u !== 0) {
            d = s(p), _.insertAfter(d);
            for (let g = 0; g < u; g++)
              d.append(l[g]);
          }
          p.canBeEmpty() || p.getChildrenSize() !== 0 || p.remove();
        }
      }
    });
  }, Ps.removeClassNamesFromElement = function(i, ...a) {
    a.forEach((s) => {
      typeof s == "string" && i.classList.remove(...s.split(" "));
    });
  }, Ps;
}
var Ds = {}, QX;
function THl() {
  if (QX)
    return Ds;
  QX = 1;
  var e = If(), t = lr();
  function n(v, ...b) {
    b.forEach((y) => {
      if (typeof y == "string") {
        const w = y.split(" ").filter((N) => N !== "");
        v.classList.add(...w);
      }
    });
  }
  function o(v, ...b) {
    b.forEach((y) => {
      typeof y == "string" && v.classList.remove(...y.split(" "));
    });
  }
  function r(v, b) {
    for (const y of b)
      if (v.type.startsWith(y))
        return !0;
    return !1;
  }
  function i(v, b) {
    const y = v[Symbol.iterator]();
    return new Promise((w, N) => {
      const M = [], q = () => {
        const {
          done: L,
          value: R
        } = y.next();
        if (L)
          return w(M);
        const T = new FileReader();
        T.addEventListener("error", N), T.addEventListener("load", () => {
          const D = T.result;
          typeof D == "string" && M.push({
            file: R,
            result: D
          }), q();
        }), r(R, b) ? T.readAsDataURL(R) : q();
      };
      q();
    });
  }
  function a(v, b) {
    const y = [], w = (v || t.$getRoot()).getLatest(), N = b || (t.$isElementNode(w) ? w.getLastDescendant() : w);
    let M = w, q = s(M);
    for (; M !== null && !M.is(N); )
      if (y.push({
        depth: q,
        node: M
      }), t.$isElementNode(M) && M.getChildrenSize() > 0)
        M = M.getFirstChild(), q++;
      else {
        let L = null;
        for (; L === null && M !== null; )
          L = M.getNextSibling(), L === null ? (M = M.getParent(), q--) : M = L;
      }
    return M !== null && M.is(N) && y.push({
      depth: q,
      node: M
    }), y;
  }
  function s(v) {
    let b = v, y = 0;
    for (; (b = b.getParent()) !== null; )
      y++;
    return y;
  }
  function c(v, b) {
    let y = v;
    for (; y != null; ) {
      if (y instanceof b)
        return y;
      y = y.getParent();
    }
    return null;
  }
  function l(v) {
    const b = u(v, (y) => t.$isElementNode(y) && !y.isInline());
    if (!t.$isElementNode(b))
      throw Error(`Expected node ${v.__key} to have closest block element node.`);
    return b;
  }
  function u(v, b) {
    let y = v;
    for (; y !== t.$getRoot() && y != null; ) {
      if (b(y))
        return y;
      y = y.getParent();
    }
    return null;
  }
  function d(...v) {
    return () => {
      v.forEach((b) => b());
    };
  }
  function _(v, b, y, w) {
    const N = (L) => L instanceof b, M = (L) => {
      const R = L.getChildren();
      for (let A = 0; A < R.length; A++) {
        const S = R[A];
        if (N(S))
          return null;
      }
      let T = L, D = L;
      for (; T !== null; )
        if (D = T, T = T.getParent(), N(T))
          return {
            child: D,
            parent: T
          };
      return null;
    }, q = (L) => {
      const R = M(L);
      if (R !== null) {
        const {
          child: T,
          parent: D
        } = R;
        if (T.is(L)) {
          w(D, L);
          const A = T.getNextSiblings(), S = A.length;
          if (D.insertAfter(T), S !== 0) {
            const E = y(D);
            T.insertAfter(E);
            for (let x = 0; x < S; x++)
              E.append(A[x]);
          }
          !D.canBeEmpty() && D.getChildrenSize() === 0 && D.remove();
        }
      }
    };
    return v.registerNodeTransform(b, q);
  }
  function p(v, b) {
    const w = /* @__PURE__ */ new Map(), N = v._pendingEditorState;
    for (const [q, L] of b._nodeMap) {
      const R = e.$cloneWithProperties(L);
      t.$isTextNode(R) && (R.__text = L.__text), w.set(q, R);
    }
    N && (N._nodeMap = w), v._dirtyType = 2;
    const M = b._selection;
    t.$setSelection(M === null ? null : M.clone());
  }
  function g(v) {
    const b = t.$getSelection();
    if (t.$isRangeSelection(b)) {
      const {
        focus: y
      } = b, w = y.getNode(), N = y.offset;
      if (t.$isRootOrShadowRoot(w)) {
        const M = w.getChildAtIndex(N);
        M == null ? w.append(v) : M.insertBefore(v), v.selectNext();
      } else {
        let M, q;
        t.$isTextNode(w) ? (M = w.getParentOrThrow(), q = w.getIndexWithinParent(), N > 0 && (q += 1, w.splitText(N))) : (M = w, q = N);
        const [, L] = t.$splitNode(M, q);
        L.insertBefore(v), L.selectStart();
      }
    } else {
      if (t.$isNodeSelection(b) || t.DEPRECATED_$isGridSelection(b)) {
        const w = b.getNodes();
        w[w.length - 1].getTopLevelElementOrThrow().insertAfter(v);
      } else
        t.$getRoot().append(v);
      const y = t.$createParagraphNode();
      v.insertAfter(y), y.select();
    }
    return v.getLatest();
  }
  function f(v, b) {
    const y = b();
    return v.replace(y), y.append(v), y;
  }
  function h(v) {
    return $(v) && v.tagName === "A";
  }
  function $(v) {
    return v.nodeType === 1;
  }
  return Ds.$splitNode = t.$splitNode, Ds.$dfs = a, Ds.$findMatchingParent = u, Ds.$getNearestBlockElementAncestorOrThrow = l, Ds.$getNearestNodeOfType = c, Ds.$insertNodeToNearestRoot = g, Ds.$restoreEditorState = p, Ds.$wrapNodeInElement = f, Ds.addClassNamesToElement = n, Ds.isHTMLAnchorElement = h, Ds.isHTMLElement = $, Ds.isMimeType = r, Ds.mediaFileReader = i, Ds.mergeRegister = d, Ds.registerNestedElementResolver = _, Ds.removeClassNamesFromElement = o, Ds;
}
var RR, eJ;
function Ci() {
  return eJ || (eJ = 1, RR = process.env.NODE_ENV === "development" ? THl() : CHl()), RR;
}
var tJ;
function AHl() {
  if (tJ)
    return Ba;
  tJ = 1;
  var e = nbe();
  obe(), rbe(), ibe(), abe(), sbe(), cbe(), lbe(), ube(), dbe(), _be(), pbe(), mbe(), fbe(), gbe();
  var t = Ci(), n = lr();
  let o = (O) => O != null && e.languages.hasOwnProperty(O) ? O : void 0;
  function r(O, V) {
    for (let U of O.childNodes) {
      if (t.isHTMLElement(U) && U.tagName === V)
        return !0;
      r(U, V);
    }
    return !1;
  }
  class i extends n.ElementNode {
    static getType() {
      return "code";
    }
    static clone(V) {
      return new i(V.__language, V.__key);
    }
    constructor(V, U) {
      super(U), this.__language = o(V);
    }
    createDOM(V) {
      let U = document.createElement("code");
      return t.addClassNamesToElement(U, V.theme.code), U.setAttribute("spellcheck", "false"), (V = this.getLanguage()) && U.setAttribute("data-highlight-language", V), U;
    }
    updateDOM(V, U) {
      let H = this.__language;
      return V = V.__language, H ? H !== V && U.setAttribute("data-highlight-language", H) : V && U.removeAttribute("data-highlight-language"), !1;
    }
    static importDOM() {
      return { code: (V) => V.textContent != null && (/\r?\n/.test(V.textContent) || r(V, "BR")) ? { conversion: c, priority: 1 } : null, div: () => ({ conversion: l, priority: 1 }), pre: () => ({ conversion: c, priority: 0 }), table: (V) => g(V) ? { conversion: u, priority: 3 } : null, td: (V) => {
        let U = V.closest("table");
        return V.classList.contains("js-file-line") ? { conversion: _, priority: 3 } : U && g(U) ? { conversion: d, priority: 3 } : null;
      }, tr: (V) => (V = V.closest("table")) && g(V) ? { conversion: d, priority: 3 } : null };
    }
    static importJSON(V) {
      let U = a(V.language);
      return U.setFormat(V.format), U.setIndent(V.indent), U.setDirection(V.direction), U;
    }
    exportJSON() {
      return { ...super.exportJSON(), language: this.getLanguage(), type: "code", version: 1 };
    }
    insertNewAfter(V, U = !0) {
      var H = this.getChildren(), J = H.length;
      if (2 <= J && H[J - 1].getTextContent() === `
` && H[J - 2].getTextContent() === `
` && V.isCollapsed() && V.anchor.key === this.__key && V.anchor.offset === J)
        return H[J - 1].remove(), H[J - 2].remove(), V = n.$createParagraphNode(), this.insertAfter(V, U), V;
      if (U = V.anchor.getNode(), J = N(U), J != null) {
        for (H = 0, J = J.getTextContent(); H < J.length && /[\t ]/.test(J[H]); )
          H += 1;
        if (0 < H)
          return H = J.substring(0, H), H = y(H), U.insertAfter(H), V.insertNodes([n.$createLineBreakNode()]), H.select(), H;
      }
      return null;
    }
    canInsertTab() {
      let V = n.$getSelection();
      return !!(n.$isRangeSelection(V) && V.isCollapsed());
    }
    canIndent() {
      return !1;
    }
    collapseAtStart() {
      let V = n.$createParagraphNode();
      return this.getChildren().forEach((U) => V.append(U)), this.replace(V), !0;
    }
    setLanguage(V) {
      this.getWritable().__language = o(V);
    }
    getLanguage() {
      return this.getLatest().__language;
    }
  }
  function a(O) {
    return n.$applyNodeReplacement(new i(O));
  }
  function s(O) {
    return O instanceof i;
  }
  function c() {
    return { node: a(), preformatted: !0 };
  }
  function l(O) {
    let V = O.style.fontFamily.match("monospace") !== null;
    return V || p(O) ? { after: (U) => {
      let H = O.parentNode;
      return H != null && O !== H.lastChild && U.push(n.$createLineBreakNode()), U;
    }, node: V ? a() : null, preformatted: V } : { node: null };
  }
  function u() {
    return { node: a(), preformatted: !0 };
  }
  function d() {
    return { node: null };
  }
  function _(O) {
    return { after: (V) => (O.parentNode && O.parentNode.nextSibling && V.push(n.$createLineBreakNode()), V), node: null };
  }
  function p(O) {
    for (O = O.parentElement; O !== null; ) {
      if (O.style.fontFamily.match("monospace") !== null)
        return !0;
      O = O.parentElement;
    }
    return !1;
  }
  function g(O) {
    return O.classList.contains("js-file-line-container");
  }
  let f = { c: "C", clike: "C-like", cpp: "C++", css: "CSS", html: "HTML", java: "Java", js: "JavaScript", markdown: "Markdown", objc: "Objective-C", plain: "Plain Text", py: "Python", rust: "Rust", sql: "SQL", swift: "Swift", typescript: "TypeScript", xml: "XML" }, h = { cpp: "cpp", java: "java", javascript: "js", md: "markdown", plaintext: "plain", python: "py", text: "plain", ts: "typescript" };
  function $(O) {
    return h[O] || O;
  }
  class v extends n.TextNode {
    constructor(V, U, H) {
      super(V, H), this.__highlightType = U;
    }
    static getType() {
      return "code-highlight";
    }
    static clone(V) {
      return new v(V.__text, V.__highlightType || void 0, V.__key);
    }
    getHighlightType() {
      return this.getLatest().__highlightType;
    }
    createDOM(V) {
      let U = super.createDOM(V);
      return V = b(V.theme, this.__highlightType), t.addClassNamesToElement(U, V), U;
    }
    updateDOM(V, U, H) {
      let J = super.updateDOM(V, U, H);
      return V = b(H.theme, V.__highlightType), H = b(H.theme, this.__highlightType), V !== H && (V && t.removeClassNamesFromElement(
        U,
        V
      ), H && t.addClassNamesToElement(U, H)), J;
    }
    static importJSON(V) {
      let U = y(V.text, V.highlightType);
      return U.setFormat(V.format), U.setDetail(V.detail), U.setMode(V.mode), U.setStyle(V.style), U;
    }
    exportJSON() {
      return { ...super.exportJSON(), highlightType: this.getHighlightType(), type: "code-highlight", version: 1 };
    }
    setFormat() {
      return this;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return a();
    }
  }
  function b(O, V) {
    return V && O && O.codeHighlight && O.codeHighlight[V];
  }
  function y(O, V) {
    return n.$applyNodeReplacement(new v(O, V));
  }
  function w(O) {
    return O instanceof v;
  }
  function N(O) {
    let V = null, U = O.getPreviousSiblings();
    for (U.push(O); 0 < U.length && (O = U.pop(), w(O) && (V = O), !n.$isLineBreakNode(O)); )
      ;
    return V;
  }
  function M(O) {
    let V = null, U = O.getNextSiblings();
    for (U.unshift(O); 0 < U.length && (O = U.shift(), w(O) && (V = O), !n.$isLineBreakNode(O)); )
      ;
    return V;
  }
  let q = { defaultLanguage: "javascript", tokenize(O, V) {
    return e.tokenize(O, e.languages[V || ""] || e.languages[this.defaultLanguage]);
  } };
  function L(O, V) {
    var U = O.length;
    let H = -1;
    if (V)
      for (V = 0; V < U; V++) {
        let J = O[V];
        if (J !== " " && J !== "	") {
          H = V;
          break;
        }
      }
    else
      for (--U; -1 < U; U--)
        if (V = O[U], V !== " " && V !== "	") {
          H = U;
          break;
        }
    return H;
  }
  function R(O) {
    let V = null, U = -1;
    var H = O.getPreviousSiblings();
    for (H.push(O); 0 < H.length; ) {
      var J = H.pop();
      if (w(J)) {
        var le = J.getTextContent();
        le = L(le, !0), le !== -1 && (V = J, U = le);
      }
      if (n.$isLineBreakNode(J))
        break;
    }
    if (V === null)
      for (O = O.getNextSiblings(); 0 < O.length; ) {
        if (H = O.shift(), w(H) && (J = H.getTextContent(), J = L(J, !0), J !== -1)) {
          V = H, U = J;
          break;
        }
        if (n.$isLineBreakNode(H))
          break;
      }
    return { node: V, offset: U };
  }
  function T(O) {
    let V = null, U = -1;
    var H = O.getNextSiblings();
    for (H.unshift(O); 0 < H.length; ) {
      var J = H.shift();
      if (w(J)) {
        var le = J.getTextContent();
        le = L(le, !1), le !== -1 && (V = J, U = le + 1);
      }
      if (n.$isLineBreakNode(J))
        break;
    }
    if (V === null)
      for (O = O.getPreviousSiblings(); 0 < O.length; ) {
        if (H = O.pop(), w(H) && (J = H.getTextContent(), J = L(J, !1), J !== -1)) {
          V = H, U = J + 1;
          break;
        }
        if (n.$isLineBreakNode(H))
          break;
      }
    return { node: V, offset: U };
  }
  function D(O, V, U) {
    let H = O.getParent();
    s(H) ? S(H, V, U) : w(O) && O.replace(n.$createTextNode(O.__text));
  }
  let A = /* @__PURE__ */ new Set();
  function S(O, V, U) {
    let H = O.getKey();
    A.has(H) || (A.add(H), O.getLanguage() === void 0 && O.setLanguage(U.defaultLanguage), V.update(() => {
      x(H, () => {
        var J = n.$getNodeByKey(H);
        if (!s(J) || !J.isAttached())
          return !1;
        var le = J.getTextContent();
        le = U.tokenize(le, J.getLanguage() || U.defaultLanguage), le = E(le);
        var ae = J.getChildren();
        for (J = 0; J < ae.length && k(ae[J], le[J]); )
          J++;
        var Y = ae.length;
        let re = le.length, ie = Math.min(Y, re) - J, _e = 0;
        for (; _e < ie; )
          if (_e++, !k(ae[Y - _e], le[re - _e])) {
            _e--;
            break;
          }
        ae = J, Y -= _e, le = le.slice(J, re - _e);
        let { from: he, to: be, nodesForReplacement: Q } = { from: ae, nodesForReplacement: le, to: Y };
        return he !== be || Q.length ? (O.splice(he, be - he, Q), !0) : !1;
      });
    }, { onUpdate: () => {
      A.delete(H);
    }, skipTransforms: !0 }));
  }
  function E(O) {
    let V = [];
    return O.forEach((U) => {
      if (typeof U == "string") {
        U = U.split(`
`);
        for (var H = 0; H < U.length; H++) {
          let J = U[H];
          J.length && V.push(y(J)), H < U.length - 1 && V.push(n.$createLineBreakNode());
        }
      } else
        ({ content: H } = U), typeof H == "string" ? V.push(y(H, U.type)) : Array.isArray(H) && H.length === 1 && typeof H[0] == "string" ? V.push(y(H[0], U.type)) : Array.isArray(H) && V.push(...E(H));
    }), V;
  }
  function x(O, V) {
    if (O = n.$getNodeByKey(O), s(O) && O.isAttached()) {
      var U = n.$getSelection();
      if (n.$isRangeSelection(U)) {
        U = U.anchor;
        var H = U.offset, J = U.type === "element" && n.$isLineBreakNode(O.getChildAtIndex(U.offset - 1)), le = 0;
        if (!J) {
          let ae = U.getNode();
          le = H + ae.getPreviousSiblings().reduce((Y, re) => Y + re.getTextContentSize(), 0);
        }
        V() && (J ? U.getNode().select(H, H) : O.getChildren().some((ae) => {
          let Y = n.$isTextNode(ae);
          if (Y || n.$isLineBreakNode(ae)) {
            let re = ae.getTextContentSize();
            if (Y && re >= le)
              return ae.select(le, le), !0;
            le -= re;
          }
          return !1;
        }));
      } else
        V();
    }
  }
  function k(O, V) {
    return w(O) && w(V) ? O.__text === V.__text && O.__highlightType === V.__highlightType : !!(n.$isLineBreakNode(O) && n.$isLineBreakNode(V));
  }
  function I(O) {
    var V = n.$getSelection();
    if (!n.$isRangeSelection(V) || V.isCollapsed())
      return !1;
    V = V.getNodes();
    for (var U = 0; U < V.length; U++) {
      var H = V[U];
      if (!w(H) && !n.$isLineBreakNode(H))
        return !1;
    }
    for (U = N(V[0]), U != null && z(U, O), U = 1; U < V.length; U++)
      H = V[U], n.$isLineBreakNode(V[U - 1]) && w(H) && z(H, O);
    return !0;
  }
  function z(O, V) {
    let U = O.getTextContent();
    V === n.INDENT_CONTENT_COMMAND ? 0 < U.length && /\s/.test(U[0]) ? O.setTextContent("	" + U) : (V = y("	"), O.insertBefore(V)) : U.indexOf("	") === 0 && (U.length === 1 ? O.remove() : O.setTextContent(U.substring(1)));
  }
  function F(O, V) {
    let U = n.$getSelection();
    if (!n.$isRangeSelection(U))
      return !1;
    let { anchor: H, focus: J } = U, le = H.offset, ae = J.offset, Y = H.getNode(), re = J.getNode();
    var ie = O === n.KEY_ARROW_UP_COMMAND;
    if (!w(Y) || !w(re))
      return !1;
    if (!V.altKey) {
      if (U.isCollapsed()) {
        if (O = Y.getParentOrThrow(), ie && le === 0 && Y.getPreviousSibling() === null) {
          if (O.getPreviousSibling() === null)
            return O.selectPrevious(), V.preventDefault(), !0;
        } else if (!ie && le === Y.getTextContentSize() && Y.getNextSibling() === null && O.getNextSibling() === null)
          return O.selectNext(), V.preventDefault(), !0;
      }
      return !1;
    }
    var _e = N(Y);
    let he = M(re);
    if (_e == null || he == null)
      return !1;
    let be = _e.getNodesBetween(he);
    for (let me = 0; me < be.length; me++) {
      let ne = be[me];
      if (!w(ne) && !n.$isLineBreakNode(ne))
        return !1;
    }
    if (V.preventDefault(), V.stopPropagation(), V = ie ? _e.getPreviousSibling() : he.getNextSibling(), !n.$isLineBreakNode(V) || (_e = ie ? V.getPreviousSibling() : V.getNextSibling(), _e == null))
      return !0;
    ie = ie ? N(_e) : M(_e);
    let Q = ie ?? _e;
    return V.remove(), be.forEach((me) => me.remove()), O === n.KEY_ARROW_UP_COMMAND ? (be.forEach((me) => Q.insertBefore(me)), Q.insertBefore(V)) : (Q.insertAfter(V), Q = V, be.forEach((me) => {
      Q.insertAfter(me), Q = me;
    })), U.setTextNodeRange(Y, le, re, ae), !0;
  }
  function P(O, V) {
    let U = n.$getSelection();
    if (!n.$isRangeSelection(U))
      return !1;
    let { anchor: H, focus: J } = U, le = H.getNode(), ae = J.getNode();
    if (O = O === n.MOVE_TO_START, !w(le) || !w(ae))
      return !1;
    let Y, re;
    return O ? { node: Y, offset: re } = R(ae) : { node: Y, offset: re } = T(ae), Y !== null && re !== -1 && U.setTextNodeRange(Y, re, Y, re), V.preventDefault(), V.stopPropagation(), !0;
  }
  return Ba.$createCodeHighlightNode = y, Ba.$createCodeNode = a, Ba.$isCodeHighlightNode = w, Ba.$isCodeNode = s, Ba.CODE_LANGUAGE_FRIENDLY_NAME_MAP = f, Ba.CODE_LANGUAGE_MAP = h, Ba.CodeHighlightNode = v, Ba.CodeNode = i, Ba.DEFAULT_CODE_LANGUAGE = "javascript", Ba.PrismTokenizer = q, Ba.getCodeLanguages = () => Object.keys(e.languages).filter((O) => typeof e.languages[O] != "function").sort(), Ba.getDefaultCodeLanguage = () => "javascript", Ba.getEndOfCodeInLine = T, Ba.getFirstCodeHighlightNodeOfLine = N, Ba.getLanguageFriendlyName = function(O) {
    return O = $(O), f[O] || O;
  }, Ba.getLastCodeHighlightNodeOfLine = M, Ba.getStartOfCodeInLine = R, Ba.normalizeCodeLang = $, Ba.registerCodeHighlighting = function(O, V) {
    if (!O.hasNodes([i, v]))
      throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
    return V == null && (V = q), t.mergeRegister(
      O.registerMutationListener(i, (U) => {
        O.update(() => {
          for (let [le, ae] of U)
            if (ae !== "destroyed") {
              var H = n.$getNodeByKey(le);
              if (H !== null)
                e: {
                  var J = H;
                  if (H = O.getElementByKey(J.getKey()), H === null)
                    break e;
                  J = J.getChildren();
                  let Y = J.length;
                  if (Y === H.__cachedChildrenLength)
                    break e;
                  H.__cachedChildrenLength = Y;
                  let re = "1", ie = 1;
                  for (let _e = 0; _e < Y; _e++)
                    n.$isLineBreakNode(J[_e]) && (re += `
` + ++ie);
                  H.setAttribute("data-gutter", re);
                }
            }
        });
      }),
      O.registerNodeTransform(i, (U) => S(U, O, V)),
      O.registerNodeTransform(n.TextNode, (U) => D(U, O, V)),
      O.registerNodeTransform(v, (U) => D(U, O, V)),
      O.registerCommand(n.INDENT_CONTENT_COMMAND, () => I(n.INDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW),
      O.registerCommand(n.OUTDENT_CONTENT_COMMAND, () => I(n.OUTDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW),
      O.registerCommand(n.KEY_ARROW_UP_COMMAND, (U) => F(n.KEY_ARROW_UP_COMMAND, U), n.COMMAND_PRIORITY_LOW),
      O.registerCommand(n.KEY_ARROW_DOWN_COMMAND, (U) => F(n.KEY_ARROW_DOWN_COMMAND, U), n.COMMAND_PRIORITY_LOW),
      O.registerCommand(n.MOVE_TO_END, (U) => P(n.MOVE_TO_END, U), n.COMMAND_PRIORITY_LOW),
      O.registerCommand(n.MOVE_TO_START, (U) => P(n.MOVE_TO_START, U), n.COMMAND_PRIORITY_LOW)
    );
  }, Ba;
}
var Ua = {}, nJ;
function IHl() {
  if (nJ)
    return Ua;
  nJ = 1;
  var e = nbe();
  obe(), rbe(), ibe(), abe(), sbe(), cbe(), lbe(), ube(), dbe(), _be(), pbe(), mbe(), fbe(), gbe();
  var t = Ci(), n = lr();
  const o = (he) => he != null && e.languages.hasOwnProperty(he) ? he : void 0;
  function r(he, be) {
    for (const Q of he.childNodes) {
      if (t.isHTMLElement(Q) && Q.tagName === be)
        return !0;
      r(Q, be);
    }
    return !1;
  }
  const i = "data-highlight-language";
  class a extends n.ElementNode {
    /** @internal */
    static getType() {
      return "code";
    }
    static clone(be) {
      return new a(be.__language, be.__key);
    }
    constructor(be, Q) {
      super(Q), this.__language = o(be);
    }
    // View
    createDOM(be) {
      const Q = document.createElement("code");
      t.addClassNamesToElement(Q, be.theme.code), Q.setAttribute("spellcheck", "false");
      const me = this.getLanguage();
      return me && Q.setAttribute(i, me), Q;
    }
    updateDOM(be, Q, me) {
      const ne = this.__language, pe = be.__language;
      return ne ? ne !== pe && Q.setAttribute(i, ne) : pe && Q.removeAttribute(i), !1;
    }
    static importDOM() {
      return {
        // Typically <pre> is used for code blocks, and <code> for inline code styles
        // but if it's a multi line <code> we'll create a block. Pass through to
        // inline format handled by TextNode otherwise.
        code: (be) => be.textContent != null && (/\r?\n/.test(be.textContent) || r(be, "BR")) ? {
          conversion: l,
          priority: 1
        } : null,
        div: (be) => ({
          conversion: u,
          priority: 1
        }),
        pre: (be) => ({
          conversion: l,
          priority: 0
        }),
        table: (be) => $(be) ? {
          conversion: d,
          priority: 3
        } : null,
        td: (be) => {
          const Q = be, me = Q.closest("table");
          return h(Q) ? {
            conversion: p,
            priority: 3
          } : me && $(me) ? {
            conversion: _,
            priority: 3
          } : null;
        },
        tr: (be) => {
          const me = be.closest("table");
          return me && $(me) ? {
            conversion: _,
            priority: 3
          } : null;
        }
      };
    }
    static importJSON(be) {
      const Q = s(be.language);
      return Q.setFormat(be.format), Q.setIndent(be.indent), Q.setDirection(be.direction), Q;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        language: this.getLanguage(),
        type: "code",
        version: 1
      };
    }
    // Mutation
    insertNewAfter(be, Q = !0) {
      const me = this.getChildren(), ne = me.length;
      if (ne >= 2 && me[ne - 1].getTextContent() === `
` && me[ne - 2].getTextContent() === `
` && be.isCollapsed() && be.anchor.key === this.__key && be.anchor.offset === ne) {
        me[ne - 1].remove(), me[ne - 2].remove();
        const ve = n.$createParagraphNode();
        return this.insertAfter(ve, Q), ve;
      }
      const pe = be.anchor.getNode(), ge = A(pe);
      if (ge != null) {
        let ve = 0;
        const Te = ge.getTextContent();
        for (; ve < Te.length && /[\t ]/.test(Te[ve]); )
          ve += 1;
        if (ve > 0) {
          const Re = Te.substring(0, ve), Me = T(Re);
          return pe.insertAfter(Me), be.insertNodes([n.$createLineBreakNode()]), Me.select(), Me;
        }
      }
      return null;
    }
    canInsertTab() {
      const be = n.$getSelection();
      return !(!n.$isRangeSelection(be) || !be.isCollapsed());
    }
    canIndent() {
      return !1;
    }
    collapseAtStart() {
      const be = n.$createParagraphNode();
      return this.getChildren().forEach((me) => be.append(me)), this.replace(be), !0;
    }
    setLanguage(be) {
      const Q = this.getWritable();
      Q.__language = o(be);
    }
    getLanguage() {
      return this.getLatest().__language;
    }
  }
  function s(he) {
    return n.$applyNodeReplacement(new a(he));
  }
  function c(he) {
    return he instanceof a;
  }
  function l(he) {
    return {
      node: s(),
      preformatted: !0
    };
  }
  function u(he) {
    const be = he, Q = g(be);
    return !Q && !f(be) ? {
      node: null
    } : {
      after: (me) => {
        const ne = he.parentNode;
        return ne != null && he !== ne.lastChild && me.push(n.$createLineBreakNode()), me;
      },
      node: Q ? s() : null,
      preformatted: Q
    };
  }
  function d() {
    return {
      node: s(),
      preformatted: !0
    };
  }
  function _() {
    return {
      node: null
    };
  }
  function p(he) {
    const be = he;
    return {
      after: (Q) => (be.parentNode && be.parentNode.nextSibling && Q.push(n.$createLineBreakNode()), Q),
      node: null
    };
  }
  function g(he) {
    return he.style.fontFamily.match("monospace") !== null;
  }
  function f(he) {
    let be = he.parentElement;
    for (; be !== null; ) {
      if (g(be))
        return !0;
      be = be.parentElement;
    }
    return !1;
  }
  function h(he) {
    return he.classList.contains("js-file-line");
  }
  function $(he) {
    return he.classList.contains("js-file-line-container");
  }
  const v = "javascript", b = {
    c: "C",
    clike: "C-like",
    cpp: "C++",
    css: "CSS",
    html: "HTML",
    java: "Java",
    js: "JavaScript",
    markdown: "Markdown",
    objc: "Objective-C",
    plain: "Plain Text",
    py: "Python",
    rust: "Rust",
    sql: "SQL",
    swift: "Swift",
    typescript: "TypeScript",
    xml: "XML"
  }, y = {
    cpp: "cpp",
    java: "java",
    javascript: "js",
    md: "markdown",
    plaintext: "plain",
    python: "py",
    text: "plain",
    ts: "typescript"
  };
  function w(he) {
    return y[he] || he;
  }
  function N(he) {
    const be = w(he);
    return b[be] || be;
  }
  const M = () => v, q = () => Object.keys(e.languages).filter(
    // Prism has several language helpers mixed into languages object
    // so filtering them out here to get langs list
    (he) => typeof e.languages[he] != "function"
  ).sort();
  class L extends n.TextNode {
    /** @internal */
    constructor(be, Q, me) {
      super(be, me), this.__highlightType = Q;
    }
    static getType() {
      return "code-highlight";
    }
    static clone(be) {
      return new L(be.__text, be.__highlightType || void 0, be.__key);
    }
    getHighlightType() {
      return this.getLatest().__highlightType;
    }
    createDOM(be) {
      const Q = super.createDOM(be), me = R(be.theme, this.__highlightType);
      return t.addClassNamesToElement(Q, me), Q;
    }
    updateDOM(be, Q, me) {
      const ne = super.updateDOM(be, Q, me), pe = R(me.theme, be.__highlightType), ge = R(me.theme, this.__highlightType);
      return pe !== ge && (pe && t.removeClassNamesFromElement(Q, pe), ge && t.addClassNamesToElement(Q, ge)), ne;
    }
    static importJSON(be) {
      const Q = T(be.text, be.highlightType);
      return Q.setFormat(be.format), Q.setDetail(be.detail), Q.setMode(be.mode), Q.setStyle(be.style), Q;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        highlightType: this.getHighlightType(),
        type: "code-highlight",
        version: 1
      };
    }
    // Prevent formatting (bold, underline, etc)
    setFormat(be) {
      return this;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return s();
    }
  }
  function R(he, be) {
    return be && he && he.codeHighlight && he.codeHighlight[be];
  }
  function T(he, be) {
    return n.$applyNodeReplacement(new L(he, be));
  }
  function D(he) {
    return he instanceof L;
  }
  function A(he) {
    let be = null;
    const Q = he.getPreviousSiblings();
    for (Q.push(he); Q.length > 0; ) {
      const me = Q.pop();
      if (D(me) && (be = me), n.$isLineBreakNode(me))
        break;
    }
    return be;
  }
  function S(he) {
    let be = null;
    const Q = he.getNextSiblings();
    for (Q.unshift(he); Q.length > 0; ) {
      const me = Q.shift();
      if (D(me) && (be = me), n.$isLineBreakNode(me))
        break;
    }
    return be;
  }
  const E = {
    defaultLanguage: v,
    tokenize(he, be) {
      return e.tokenize(he, e.languages[be || ""] || e.languages[this.defaultLanguage]);
    }
  };
  function x(he) {
    return he === " " || he === "	";
  }
  function k(he, be) {
    const Q = he.length;
    let me = -1;
    if (be)
      for (let ne = 0; ne < Q; ne++) {
        const pe = he[ne];
        if (!x(pe)) {
          me = ne;
          break;
        }
      }
    else
      for (let ne = Q - 1; ne > -1; ne--) {
        const pe = he[ne];
        if (!x(pe)) {
          me = ne;
          break;
        }
      }
    return me;
  }
  function I(he) {
    let be = null, Q = -1;
    const me = he.getPreviousSiblings();
    for (me.push(he); me.length > 0; ) {
      const ne = me.pop();
      if (D(ne)) {
        const pe = ne.getTextContent(), ge = k(pe, !0);
        ge !== -1 && (be = ne, Q = ge);
      }
      if (n.$isLineBreakNode(ne))
        break;
    }
    if (be === null) {
      const ne = he.getNextSiblings();
      for (; ne.length > 0; ) {
        const pe = ne.shift();
        if (D(pe)) {
          const ge = pe.getTextContent(), ve = k(ge, !0);
          if (ve !== -1) {
            be = pe, Q = ve;
            break;
          }
        }
        if (n.$isLineBreakNode(pe))
          break;
      }
    }
    return {
      node: be,
      offset: Q
    };
  }
  function z(he) {
    let be = null, Q = -1;
    const me = he.getNextSiblings();
    for (me.unshift(he); me.length > 0; ) {
      const ne = me.shift();
      if (D(ne)) {
        const pe = ne.getTextContent(), ge = k(pe, !1);
        ge !== -1 && (be = ne, Q = ge + 1);
      }
      if (n.$isLineBreakNode(ne))
        break;
    }
    if (be === null) {
      const ne = he.getPreviousSiblings();
      for (; ne.length > 0; ) {
        const pe = ne.pop();
        if (D(pe)) {
          const ge = pe.getTextContent(), ve = k(ge, !1);
          if (ve !== -1) {
            be = pe, Q = ve + 1;
            break;
          }
        }
        if (n.$isLineBreakNode(pe))
          break;
      }
    }
    return {
      node: be,
      offset: Q
    };
  }
  function F(he, be, Q) {
    const me = he.getParent();
    c(me) ? V(me, be, Q) : D(he) && he.replace(n.$createTextNode(he.__text));
  }
  function P(he, be) {
    const Q = be.getElementByKey(he.getKey());
    if (Q === null)
      return;
    const me = he.getChildren(), ne = me.length;
    if (ne === Q.__cachedChildrenLength)
      return;
    Q.__cachedChildrenLength = ne;
    let pe = "1", ge = 1;
    for (let ve = 0; ve < ne; ve++)
      n.$isLineBreakNode(me[ve]) && (pe += `
` + ++ge);
    Q.setAttribute("data-gutter", pe);
  }
  const O = /* @__PURE__ */ new Set();
  function V(he, be, Q) {
    const me = he.getKey();
    O.has(me) || (O.add(me), he.getLanguage() === void 0 && he.setLanguage(Q.defaultLanguage), be.update(() => {
      H(me, () => {
        const ne = n.$getNodeByKey(me);
        if (!c(ne) || !ne.isAttached())
          return !1;
        const pe = ne.getTextContent(), ge = Q.tokenize(pe, ne.getLanguage() || Q.defaultLanguage), ve = U(ge), Te = J(ne.getChildren(), ve), {
          from: Re,
          to: Me,
          nodesForReplacement: et
        } = Te;
        return Re !== Me || et.length ? (he.splice(Re, Me - Re, et), !0) : !1;
      });
    }, {
      onUpdate: () => {
        O.delete(me);
      },
      skipTransforms: !0
    }));
  }
  function U(he) {
    const be = [];
    return he.forEach((Q) => {
      if (typeof Q == "string") {
        const me = Q.split(`
`);
        for (let ne = 0; ne < me.length; ne++) {
          const pe = me[ne];
          pe.length && be.push(T(pe)), ne < me.length - 1 && be.push(n.$createLineBreakNode());
        }
      } else {
        const {
          content: me
        } = Q;
        typeof me == "string" ? be.push(T(me, Q.type)) : Array.isArray(me) && me.length === 1 && typeof me[0] == "string" ? be.push(T(me[0], Q.type)) : Array.isArray(me) && be.push(...U(me));
      }
    }), be;
  }
  function H(he, be) {
    const Q = n.$getNodeByKey(he);
    if (!c(Q) || !Q.isAttached())
      return;
    const me = n.$getSelection();
    if (!n.$isRangeSelection(me)) {
      be();
      return;
    }
    const ne = me.anchor, pe = ne.offset, ge = ne.type === "element" && n.$isLineBreakNode(Q.getChildAtIndex(ne.offset - 1));
    let ve = 0;
    if (!ge) {
      const Re = ne.getNode();
      ve = pe + Re.getPreviousSiblings().reduce((Me, et) => Me + et.getTextContentSize(), 0);
    }
    if (be()) {
      if (ge) {
        ne.getNode().select(pe, pe);
        return;
      }
      Q.getChildren().some((Re) => {
        const Me = n.$isTextNode(Re);
        if (Me || n.$isLineBreakNode(Re)) {
          const et = Re.getTextContentSize();
          if (Me && et >= ve)
            return Re.select(ve, ve), !0;
          ve -= et;
        }
        return !1;
      });
    }
  }
  function J(he, be) {
    let Q = 0;
    for (; Q < he.length && le(he[Q], be[Q]); )
      Q++;
    const me = he.length, ne = be.length, pe = Math.min(me, ne) - Q;
    let ge = 0;
    for (; ge < pe; )
      if (ge++, !le(he[me - ge], be[ne - ge])) {
        ge--;
        break;
      }
    const ve = Q, Te = me - ge, Re = be.slice(Q, ne - ge);
    return {
      from: ve,
      nodesForReplacement: Re,
      to: Te
    };
  }
  function le(he, be) {
    return D(he) && D(be) ? he.__text === be.__text && he.__highlightType === be.__highlightType : !!(n.$isLineBreakNode(he) && n.$isLineBreakNode(be));
  }
  function ae(he) {
    const be = n.$getSelection();
    if (!n.$isRangeSelection(be) || be.isCollapsed())
      return !1;
    const Q = be.getNodes();
    for (let ne = 0; ne < Q.length; ne++) {
      const pe = Q[ne];
      if (!D(pe) && !n.$isLineBreakNode(pe))
        return !1;
    }
    const me = A(Q[0]);
    me != null && Y(me, he);
    for (let ne = 1; ne < Q.length; ne++) {
      const pe = Q[ne];
      n.$isLineBreakNode(Q[ne - 1]) && D(pe) && Y(pe, he);
    }
    return !0;
  }
  function Y(he, be) {
    const Q = he.getTextContent();
    if (be === n.INDENT_CONTENT_COMMAND)
      if (Q.length > 0 && /\s/.test(Q[0]))
        he.setTextContent("	" + Q);
      else {
        const me = T("	");
        he.insertBefore(me);
      }
    else
      Q.indexOf("	") === 0 && (Q.length === 1 ? he.remove() : he.setTextContent(Q.substring(1)));
  }
  function re(he, be) {
    const Q = n.$getSelection();
    if (!n.$isRangeSelection(Q))
      return !1;
    const {
      anchor: me,
      focus: ne
    } = Q, pe = me.offset, ge = ne.offset, ve = me.getNode(), Te = ne.getNode(), Re = he === n.KEY_ARROW_UP_COMMAND;
    if (!D(ve) || !D(Te))
      return !1;
    if (!be.altKey) {
      if (Q.isCollapsed()) {
        const He = ve.getParentOrThrow();
        if (Re && pe === 0 && ve.getPreviousSibling() === null) {
          if (He.getPreviousSibling() === null)
            return He.selectPrevious(), be.preventDefault(), !0;
        } else if (!Re && pe === ve.getTextContentSize() && ve.getNextSibling() === null && He.getNextSibling() === null)
          return He.selectNext(), be.preventDefault(), !0;
      }
      return !1;
    }
    const Me = A(ve), et = S(Te);
    if (Me == null || et == null)
      return !1;
    const st = Me.getNodesBetween(et);
    for (let He = 0; He < st.length; He++) {
      const Xe = st[He];
      if (!D(Xe) && !n.$isLineBreakNode(Xe))
        return !1;
    }
    be.preventDefault(), be.stopPropagation();
    const De = Re ? Me.getPreviousSibling() : et.getNextSibling();
    if (!n.$isLineBreakNode(De))
      return !0;
    const ze = Re ? De.getPreviousSibling() : De.getNextSibling();
    if (ze == null)
      return !0;
    const Pe = Re ? A(ze) : S(ze);
    let je = Pe ?? ze;
    return De.remove(), st.forEach((He) => He.remove()), he === n.KEY_ARROW_UP_COMMAND ? (st.forEach((He) => je.insertBefore(He)), je.insertBefore(De)) : (je.insertAfter(De), je = De, st.forEach((He) => {
      je.insertAfter(He), je = He;
    })), Q.setTextNodeRange(ve, pe, Te, ge), !0;
  }
  function ie(he, be) {
    const Q = n.$getSelection();
    if (!n.$isRangeSelection(Q))
      return !1;
    const {
      anchor: me,
      focus: ne
    } = Q, pe = me.getNode(), ge = ne.getNode(), ve = he === n.MOVE_TO_START;
    if (!D(pe) || !D(ge))
      return !1;
    let Te, Re;
    return ve ? {
      node: Te,
      offset: Re
    } = I(ge) : {
      node: Te,
      offset: Re
    } = z(ge), Te !== null && Re !== -1 && Q.setTextNodeRange(Te, Re, Te, Re), be.preventDefault(), be.stopPropagation(), !0;
  }
  function _e(he, be) {
    if (!he.hasNodes([a, L]))
      throw new Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
    return be == null && (be = E), t.mergeRegister(he.registerMutationListener(a, (Q) => {
      he.update(() => {
        for (const [me, ne] of Q)
          if (ne !== "destroyed") {
            const pe = n.$getNodeByKey(me);
            pe !== null && P(pe, he);
          }
      });
    }), he.registerNodeTransform(a, (Q) => V(Q, he, be)), he.registerNodeTransform(n.TextNode, (Q) => F(Q, he, be)), he.registerNodeTransform(L, (Q) => F(Q, he, be)), he.registerCommand(n.INDENT_CONTENT_COMMAND, (Q) => ae(n.INDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW), he.registerCommand(n.OUTDENT_CONTENT_COMMAND, (Q) => ae(n.OUTDENT_CONTENT_COMMAND), n.COMMAND_PRIORITY_LOW), he.registerCommand(n.KEY_ARROW_UP_COMMAND, (Q) => re(n.KEY_ARROW_UP_COMMAND, Q), n.COMMAND_PRIORITY_LOW), he.registerCommand(n.KEY_ARROW_DOWN_COMMAND, (Q) => re(n.KEY_ARROW_DOWN_COMMAND, Q), n.COMMAND_PRIORITY_LOW), he.registerCommand(n.MOVE_TO_END, (Q) => ie(n.MOVE_TO_END, Q), n.COMMAND_PRIORITY_LOW), he.registerCommand(n.MOVE_TO_START, (Q) => ie(n.MOVE_TO_START, Q), n.COMMAND_PRIORITY_LOW));
  }
  return Ua.$createCodeHighlightNode = T, Ua.$createCodeNode = s, Ua.$isCodeHighlightNode = D, Ua.$isCodeNode = c, Ua.CODE_LANGUAGE_FRIENDLY_NAME_MAP = b, Ua.CODE_LANGUAGE_MAP = y, Ua.CodeHighlightNode = L, Ua.CodeNode = a, Ua.DEFAULT_CODE_LANGUAGE = v, Ua.PrismTokenizer = E, Ua.getCodeLanguages = q, Ua.getDefaultCodeLanguage = M, Ua.getEndOfCodeInLine = z, Ua.getFirstCodeHighlightNodeOfLine = A, Ua.getLanguageFriendlyName = N, Ua.getLastCodeHighlightNodeOfLine = S, Ua.getStartOfCodeInLine = I, Ua.normalizeCodeLang = w, Ua.registerCodeHighlighting = _e, Ua;
}
const OHl = process.env.NODE_ENV === "development" ? IHl() : AHl();
var iT = OHl, hp = {}, oJ;
function NHl() {
  if (oJ)
    return hp;
  oJ = 1;
  var e = Ci(), t = lr();
  class n extends t.ElementNode {
    static getType() {
      return "link";
    }
    static clone(_) {
      return new n(_.__url, { rel: _.__rel, target: _.__target }, _.__key);
    }
    constructor(_, p = {}, g) {
      super(g);
      let { target: f = null, rel: h = null } = p;
      this.__url = _, this.__target = f, this.__rel = h;
    }
    createDOM(_) {
      let p = document.createElement("a");
      return p.href = this.__url, this.__target !== null && (p.target = this.__target), this.__rel !== null && (p.rel = this.__rel), e.addClassNamesToElement(p, _.theme.link), p;
    }
    updateDOM(_, p) {
      let g = this.__url, f = this.__target, h = this.__rel;
      return g !== _.__url && (p.href = g), f !== _.__target && (f ? p.target = f : p.removeAttribute("target")), h !== _.__rel && (h ? p.rel = h : p.removeAttribute("rel")), !1;
    }
    static importDOM() {
      return { a: () => ({ conversion: o, priority: 1 }) };
    }
    static importJSON(_) {
      let p = r(_.url, { rel: _.rel, target: _.target });
      return p.setFormat(_.format), p.setIndent(_.indent), p.setDirection(_.direction), p;
    }
    exportJSON() {
      return { ...super.exportJSON(), rel: this.getRel(), target: this.getTarget(), type: "link", url: this.getURL(), version: 1 };
    }
    getURL() {
      return this.getLatest().__url;
    }
    setURL(_) {
      this.getWritable().__url = _;
    }
    getTarget() {
      return this.getLatest().__target;
    }
    setTarget(_) {
      this.getWritable().__target = _;
    }
    getRel() {
      return this.getLatest().__rel;
    }
    setRel(_) {
      this.getWritable().__rel = _;
    }
    insertNewAfter(_, p = !0) {
      return _ = this.getParentOrThrow().insertNewAfter(_, p), t.$isElementNode(_) ? (p = r(this.__url, { rel: this.__rel, target: this.__target }), _.append(p), p) : null;
    }
    canInsertTextBefore() {
      return !1;
    }
    canInsertTextAfter() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isInline() {
      return !0;
    }
    extractWithChild(_, p) {
      if (!t.$isRangeSelection(p))
        return !1;
      _ = p.anchor.getNode();
      let g = p.focus.getNode();
      return this.isParentOf(_) && this.isParentOf(g) && 0 < p.getTextContent().length;
    }
  }
  function o(d) {
    let _ = null;
    if (e.isHTMLAnchorElement(d)) {
      let p = d.textContent;
      p !== null && p !== "" && (_ = r(d.getAttribute("href") || "", { rel: d.getAttribute("rel"), target: d.getAttribute("target") }));
    }
    return { node: _ };
  }
  function r(d, _) {
    return t.$applyNodeReplacement(new n(d, _));
  }
  function i(d) {
    return d instanceof n;
  }
  class a extends n {
    static getType() {
      return "autolink";
    }
    static clone(_) {
      return new a(_.__url, { rel: _.__rel, target: _.__target }, _.__key);
    }
    static importJSON(_) {
      let p = s(_.url, { rel: _.rel, target: _.target });
      return p.setFormat(_.format), p.setIndent(_.indent), p.setDirection(_.direction), p;
    }
    static importDOM() {
      return null;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "autolink", version: 1 };
    }
    insertNewAfter(_, p = !0) {
      return _ = this.getParentOrThrow().insertNewAfter(_, p), t.$isElementNode(_) ? (p = s(this.__url, {
        rel: this._rel,
        target: this.__target
      }), _.append(p), p) : null;
    }
  }
  function s(d, _) {
    return t.$applyNodeReplacement(new a(d, _));
  }
  let c = t.createCommand("TOGGLE_LINK_COMMAND");
  function l(d) {
    return u(d, (_) => i(_));
  }
  function u(d, _) {
    for (; d !== null && (d = d.getParent()) !== null && !_(d); )
      ;
    return d;
  }
  return hp.$createAutoLinkNode = s, hp.$createLinkNode = r, hp.$isAutoLinkNode = function(d) {
    return d instanceof a;
  }, hp.$isLinkNode = i, hp.AutoLinkNode = a, hp.LinkNode = n, hp.TOGGLE_LINK_COMMAND = c, hp.toggleLink = function(d, _ = {}) {
    let { target: p } = _, g = _.rel === void 0 ? "noopener" : _.rel;
    if (_ = t.$getSelection(), t.$isRangeSelection(_))
      if (_ = _.extract(), d === null)
        _.forEach((h) => {
          if (h = h.getParent(), i(h)) {
            let $ = h.getChildren();
            for (let v = 0; v < $.length; v++)
              h.insertBefore($[v]);
            h.remove();
          }
        });
      else {
        if (_.length === 1) {
          var f = _[0];
          if (f = i(f) ? f : l(f), f !== null) {
            f.setURL(d), p !== void 0 && f.setTarget(p), g !== null && f.setRel(g);
            return;
          }
        }
        let h = null, $ = null;
        _.forEach((v) => {
          var b = v.getParent();
          if (b !== $ && b !== null && (!t.$isElementNode(v) || v.isInline()))
            if (i(b))
              $ = b, b.setURL(d), p !== void 0 && b.setTarget(p), g !== null && $.setRel(g);
            else if (b.is(h) || (h = b, $ = r(d, { rel: g, target: p }), i(b) ? v.getPreviousSibling() === null ? b.insertBefore($) : b.insertAfter($) : v.insertBefore($)), i(v)) {
              if (!v.is($)) {
                if ($ !== null) {
                  b = v.getChildren();
                  for (let y = 0; y < b.length; y++)
                    $.append(b[y]);
                }
                v.remove();
              }
            } else
              $ !== null && $.append(v);
        });
      }
  }, hp;
}
var vp = {}, rJ;
function zHl() {
  if (rJ)
    return vp;
  rJ = 1;
  var e = Ci(), t = lr();
  class n extends t.ElementNode {
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "link";
    }
    static clone(g) {
      return new n(g.__url, {
        rel: g.__rel,
        target: g.__target
      }, g.__key);
    }
    constructor(g, f = {}, h) {
      super(h);
      const {
        target: $ = null,
        rel: v = null
      } = f;
      this.__url = g, this.__target = $, this.__rel = v;
    }
    createDOM(g) {
      const f = document.createElement("a");
      return f.href = this.__url, this.__target !== null && (f.target = this.__target), this.__rel !== null && (f.rel = this.__rel), e.addClassNamesToElement(f, g.theme.link), f;
    }
    updateDOM(g, f, h) {
      const $ = this.__url, v = this.__target, b = this.__rel;
      return $ !== g.__url && (f.href = $), v !== g.__target && (v ? f.target = v : f.removeAttribute("target")), b !== g.__rel && (b ? f.rel = b : f.removeAttribute("rel")), !1;
    }
    static importDOM() {
      return {
        a: (g) => ({
          conversion: o,
          priority: 1
        })
      };
    }
    static importJSON(g) {
      const f = r(g.url, {
        rel: g.rel,
        target: g.target
      });
      return f.setFormat(g.format), f.setIndent(g.indent), f.setDirection(g.direction), f;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        rel: this.getRel(),
        target: this.getTarget(),
        type: "link",
        url: this.getURL(),
        version: 1
      };
    }
    getURL() {
      return this.getLatest().__url;
    }
    setURL(g) {
      const f = this.getWritable();
      f.__url = g;
    }
    getTarget() {
      return this.getLatest().__target;
    }
    setTarget(g) {
      const f = this.getWritable();
      f.__target = g;
    }
    getRel() {
      return this.getLatest().__rel;
    }
    setRel(g) {
      const f = this.getWritable();
      f.__rel = g;
    }
    insertNewAfter(g, f = !0) {
      const h = this.getParentOrThrow().insertNewAfter(g, f);
      if (t.$isElementNode(h)) {
        const $ = r(this.__url, {
          rel: this.__rel,
          target: this.__target
        });
        return h.append($), $;
      }
      return null;
    }
    canInsertTextBefore() {
      return !1;
    }
    canInsertTextAfter() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isInline() {
      return !0;
    }
    extractWithChild(g, f, h) {
      if (!t.$isRangeSelection(f))
        return !1;
      const $ = f.anchor.getNode(), v = f.focus.getNode();
      return this.isParentOf($) && this.isParentOf(v) && f.getTextContent().length > 0;
    }
  }
  function o(p) {
    let g = null;
    if (e.isHTMLAnchorElement(p)) {
      const f = p.textContent;
      f !== null && f !== "" && (g = r(p.getAttribute("href") || "", {
        rel: p.getAttribute("rel"),
        target: p.getAttribute("target")
      }));
    }
    return {
      node: g
    };
  }
  function r(p, g) {
    return t.$applyNodeReplacement(new n(p, g));
  }
  function i(p) {
    return p instanceof n;
  }
  class a extends n {
    static getType() {
      return "autolink";
    }
    static clone(g) {
      return new a(g.__url, {
        rel: g.__rel,
        target: g.__target
      }, g.__key);
    }
    static importJSON(g) {
      const f = s(g.url, {
        rel: g.rel,
        target: g.target
      });
      return f.setFormat(g.format), f.setIndent(g.indent), f.setDirection(g.direction), f;
    }
    static importDOM() {
      return null;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "autolink",
        version: 1
      };
    }
    insertNewAfter(g, f = !0) {
      const h = this.getParentOrThrow().insertNewAfter(g, f);
      if (t.$isElementNode(h)) {
        const $ = s(this.__url, {
          rel: this._rel,
          target: this.__target
        });
        return h.append($), $;
      }
      return null;
    }
  }
  function s(p, g) {
    return t.$applyNodeReplacement(new a(p, g));
  }
  function c(p) {
    return p instanceof a;
  }
  const l = t.createCommand("TOGGLE_LINK_COMMAND");
  function u(p, g = {}) {
    const {
      target: f
    } = g, h = g.rel === void 0 ? "noopener" : g.rel, $ = t.$getSelection();
    if (!t.$isRangeSelection($))
      return;
    const v = $.extract();
    if (p === null)
      v.forEach((b) => {
        const y = b.getParent();
        if (i(y)) {
          const w = y.getChildren();
          for (let N = 0; N < w.length; N++)
            y.insertBefore(w[N]);
          y.remove();
        }
      });
    else {
      if (v.length === 1) {
        const w = v[0], N = i(w) ? w : d(w);
        if (N !== null) {
          N.setURL(p), f !== void 0 && N.setTarget(f), h !== null && N.setRel(h);
          return;
        }
      }
      let b = null, y = null;
      v.forEach((w) => {
        const N = w.getParent();
        if (!(N === y || N === null || t.$isElementNode(w) && !w.isInline())) {
          if (i(N)) {
            y = N, N.setURL(p), f !== void 0 && N.setTarget(f), h !== null && y.setRel(h);
            return;
          }
          if (N.is(b) || (b = N, y = r(p, {
            rel: h,
            target: f
          }), i(N) ? w.getPreviousSibling() === null ? N.insertBefore(y) : N.insertAfter(y) : w.insertBefore(y)), i(w)) {
            if (w.is(y))
              return;
            if (y !== null) {
              const M = w.getChildren();
              for (let q = 0; q < M.length; q++)
                y.append(M[q]);
            }
            w.remove();
            return;
          }
          y !== null && y.append(w);
        }
      });
    }
  }
  function d(p) {
    return _(p, (g) => i(g));
  }
  function _(p, g) {
    let f = p;
    for (; f !== null && (f = f.getParent()) !== null && !g(f); )
      ;
    return f;
  }
  return vp.$createAutoLinkNode = s, vp.$createLinkNode = r, vp.$isAutoLinkNode = c, vp.$isLinkNode = i, vp.AutoLinkNode = a, vp.LinkNode = n, vp.TOGGLE_LINK_COMMAND = l, vp.toggleLink = u, vp;
}
const RHl = process.env.NODE_ENV === "development" ? zHl() : NHl();
var bl = RHl, Ac = {}, iJ;
function PHl() {
  if (iJ)
    return Ac;
  iJ = 1;
  var e = lr(), t = Ci();
  function n(x) {
    throw Error(`Minified Lexical error #${x}; visit https://lexical.dev/docs/error?code=${x} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  function o(x) {
    let k = 1;
    for (x = x.getParent(); x != null; ) {
      if (y(x)) {
        if (x = x.getParent(), T(x)) {
          k++, x = x.getParent();
          continue;
        }
        n(40);
      }
      break;
    }
    return k;
  }
  function r(x) {
    x = x.getParent(), T(x) || n(40);
    let k = x;
    for (; k !== null; )
      k = k.getParent(), T(k) && (x = k);
    return x;
  }
  function i(x) {
    let k = [];
    x = x.getChildren().filter(y);
    for (let I = 0; I < x.length; I++) {
      let z = x[I], F = z.getFirstChild();
      T(F) ? k = k.concat(i(F)) : k.push(z);
    }
    return k;
  }
  function a(x) {
    return y(x) && T(x.getFirstChild());
  }
  function s(x) {
    for (; x.getNextSibling() == null && x.getPreviousSibling() == null; ) {
      let k = x.getParent();
      if (k == null || !y(x) && !T(x))
        break;
      x = k;
    }
    x.remove();
  }
  function c(x) {
    return b().append(x);
  }
  function l(x, k) {
    return y(x) && (k.length === 0 || k.length === 1 && x.is(k[0]) && x.getChildrenSize() === 0);
  }
  function u(x, k) {
    x.splice(x.getChildrenSize(), 0, k);
  }
  function d(x, k) {
    if (T(x))
      return x;
    let I = x.getPreviousSibling(), z = x.getNextSibling(), F = b();
    return F.setFormat(x.getFormatType()), F.setIndent(x.getIndent()), u(F, x.getChildren()), T(I) && k === I.getListType() ? (I.append(F), x.remove(), T(z) && k === z.getListType() && (u(I, z.getChildren()), z.remove()), I) : T(z) && k === z.getListType() ? (z.getFirstChildOrThrow().insertBefore(F), x.remove(), z) : (k = R(k), k.append(F), x.replace(k), p(k), k);
  }
  function _(x, k) {
    var I = x.getLastChild();
    let z = k.getFirstChild();
    I && z && a(I) && a(z) && (_(I.getFirstChild(), z.getFirstChild()), z.remove()), I = k.getChildren(), 0 < I.length && (x.append(...I), p(x)), k.remove();
  }
  function p(x, k) {
    if (x = k || x.getChildren(), x !== void 0)
      for (k = 0; k < x.length; k++) {
        let P = x[k];
        if (y(P)) {
          let O = P.getValue();
          var I = P, z = I.getParent(), F = 1;
          for (z != null && (T(z) ? F = z.getStart() : n(44)), I = I.getPreviousSiblings(), z = 0; z < I.length; z++) {
            let V = I[z];
            y(V) && !T(V.getFirstChild()) && F++;
          }
          O !== F && P.setValue(F);
        }
      }
  }
  function g(x) {
    if (!a(x)) {
      var k = x.getParent(), I = k ? k.getParent() : void 0, z = I ? I.getParent() : void 0;
      if (T(z) && y(I) && T(k)) {
        var F = k ? k.getFirstChild() : void 0, P = k ? k.getLastChild() : void 0;
        if (x.is(F))
          I.insertBefore(x), k.isEmpty() && I.remove();
        else if (x.is(P))
          I.insertAfter(x), k.isEmpty() && I.remove();
        else {
          var O = k.getListType();
          F = b();
          let V = R(O);
          F.append(V), x.getPreviousSiblings().forEach((U) => V.append(U)), P = b(), O = R(O), P.append(O), u(O, x.getNextSiblings()), I.insertBefore(F), I.insertAfter(P), I.replace(x);
        }
        p(k), p(z);
      }
    }
  }
  class f extends e.ElementNode {
    static getType() {
      return "listitem";
    }
    static clone(k) {
      return new f(k.__value, k.__checked, k.__key);
    }
    constructor(k, I, z) {
      super(z), this.__value = k === void 0 ? 1 : k, this.__checked = I;
    }
    createDOM(k) {
      let I = document.createElement("li"), z = this.getParent();
      return T(z) && z.getListType() === "check" && $(I, this, null), I.value = this.__value, h(I, k.theme, this), I;
    }
    updateDOM(k, I, z) {
      let F = this.getParent();
      return T(F) && F.getListType() === "check" && $(I, this, k), I.value = this.__value, h(I, z.theme, this), !1;
    }
    static transform() {
      return (k) => {
        let I = k.getParent();
        T(I) && (p(I), I.getListType() !== "check" && k.getChecked() != null && k.setChecked(void 0));
      };
    }
    static importDOM() {
      return { li: () => ({ conversion: v, priority: 0 }) };
    }
    static importJSON(k) {
      let I = new f(k.value, k.checked);
      return I.setFormat(k.format), I.getWritable().__indent = k.indent, I.setDirection(k.direction), I;
    }
    exportJSON() {
      return { ...super.exportJSON(), checked: this.getChecked(), type: "listitem", value: this.getValue(), version: 1 };
    }
    append(...k) {
      for (let I = 0; I < k.length; I++) {
        let z = k[I];
        if (e.$isElementNode(z) && this.canMergeWith(z)) {
          let F = z.getChildren();
          this.append(...F), z.remove();
        } else
          super.append(z);
      }
      return this;
    }
    replace(k, I) {
      if (y(k))
        return super.replace(k);
      this.setIndent(0);
      let z = this.getParentOrThrow();
      if (!T(z))
        return k;
      if (z.__first === this.getKey())
        z.insertBefore(k);
      else if (z.__last === this.getKey())
        z.insertAfter(k);
      else {
        let F = R(z.getListType()), P = this.getNextSibling();
        for (; P; ) {
          let O = P;
          P = P.getNextSibling(), F.append(O);
        }
        z.insertAfter(k), k.insertAfter(F);
      }
      return I && this.getChildren().forEach((F) => {
        k.append(F);
      }), this.remove(), z.getChildrenSize() === 0 && z.remove(), k;
    }
    insertAfter(k, I = !0) {
      var z = this.getParentOrThrow();
      T(z) || n(39);
      var F = this.getNextSiblings();
      if (y(k))
        return I = super.insertAfter(k, I), k = k.getParentOrThrow(), T(k) && p(k), I;
      if (T(k) && k.getListType() === z.getListType()) {
        for (z = k, k = k.getChildren(), F = k.length - 1; 0 <= F; F--)
          z = k[F], this.insertAfter(z, I);
        return z;
      }
      if (z.insertAfter(k, I), F.length !== 0) {
        let P = R(z.getListType());
        F.forEach((O) => P.append(O)), k.insertAfter(P, I);
      }
      return k;
    }
    remove(k) {
      let I = this.getPreviousSibling(), z = this.getNextSibling();
      super.remove(k), I && z && a(I) && a(z) ? (_(I.getFirstChild(), z.getFirstChild()), z.remove()) : z && (k = z.getParent(), T(k) && p(k));
    }
    insertNewAfter(k, I = !0) {
      return k = b(this.__checked == null ? void 0 : !1), this.insertAfter(k, I), k;
    }
    collapseAtStart(k) {
      let I = e.$createParagraphNode();
      this.getChildren().forEach((O) => I.append(O));
      var z = this.getParentOrThrow(), F = z.getParentOrThrow();
      let P = y(F);
      return z.getChildrenSize() === 1 ? P ? (z.remove(), F.select()) : (z.insertBefore(I), z.remove(), z = k.anchor, k = k.focus, F = I.getKey(), z.type === "element" && z.getNode().is(this) && z.set(F, z.offset, "element"), k.type === "element" && k.getNode().is(this) && k.set(F, k.offset, "element")) : (z.insertBefore(I), this.remove()), !0;
    }
    getValue() {
      return this.getLatest().__value;
    }
    setValue(k) {
      this.getWritable().__value = k;
    }
    getChecked() {
      return this.getLatest().__checked;
    }
    setChecked(k) {
      this.getWritable().__checked = k;
    }
    toggleChecked() {
      this.setChecked(!this.__checked);
    }
    getIndent() {
      var k = this.getParent();
      if (k === null)
        return this.getLatest().__indent;
      k = k.getParentOrThrow();
      let I = 0;
      for (; y(k); )
        k = k.getParentOrThrow().getParentOrThrow(), I++;
      return I;
    }
    setIndent(k) {
      if (!(typeof k == "number" && -1 < k))
        throw Error("Invalid indent value.");
      let I = this.getIndent();
      for (; I !== k; )
        if (I < k) {
          e: {
            var z = /* @__PURE__ */ new Set();
            if (a(this) || z.has(this.getKey()))
              break e;
            let V = this.getParent();
            var F = this.getNextSibling(), P = this.getPreviousSibling();
            if (a(F) && a(P)) {
              if (P = P.getFirstChild(), T(P)) {
                P.append(this);
                var O = F.getFirstChild();
                T(O) && (O = O.getChildren(), u(P, O), F.remove(), z.add(F.getKey())), p(P);
              }
            } else
              a(F) ? (F = F.getFirstChild(), T(F) && (z = F.getFirstChild(), z !== null && z.insertBefore(this), p(F))) : a(P) ? (F = P.getFirstChild(), T(F) && (F.append(this), p(F))) : T(V) && (z = b(), O = R(V.getListType()), z.append(O), O.append(this), P ? P.insertAfter(z) : F ? F.insertBefore(z) : V.append(z), p(O));
            T(V) && p(V);
          }
          I++;
        } else
          g(this), I--;
      return this;
    }
    insertBefore(k) {
      if (y(k)) {
        let I = this.getParentOrThrow();
        if (T(I)) {
          let z = this.getNextSiblings();
          p(I, z);
        }
      }
      return super.insertBefore(k);
    }
    canInsertAfter(k) {
      return y(k);
    }
    canReplaceWith(k) {
      return y(k);
    }
    canMergeWith(k) {
      return e.$isParagraphNode(k) || y(k);
    }
    extractWithChild(k, I) {
      if (!e.$isRangeSelection(I))
        return !1;
      k = I.anchor.getNode();
      let z = I.focus.getNode();
      return this.isParentOf(k) && this.isParentOf(z) && this.getTextContent().length === I.getTextContent().length;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return R("bullet");
    }
  }
  function h(x, k, I) {
    let z = [], F = [];
    var P = (k = k.list) ? k.listitem : void 0;
    if (k && k.nested)
      var O = k.nested.listitem;
    if (P !== void 0 && (P = P.split(" "), z.push(...P)), k) {
      P = I.getParent(), P = T(P) && P.getListType() === "check";
      let V = I.getChecked();
      P && !V || F.push(k.listitemUnchecked), P && V || F.push(k.listitemChecked), P && z.push(V ? k.listitemChecked : k.listitemUnchecked);
    }
    O !== void 0 && (O = O.split(" "), I.getChildren().some((V) => T(V)) ? z.push(...O) : F.push(...O)), 0 < F.length && t.removeClassNamesFromElement(x, ...F), 0 < z.length && t.addClassNamesToElement(
      x,
      ...z
    );
  }
  function $(x, k, I) {
    T(k.getFirstChild()) ? (x.removeAttribute("role"), x.removeAttribute("tabIndex"), x.removeAttribute("aria-checked")) : (x.setAttribute("role", "checkbox"), x.setAttribute("tabIndex", "-1"), I && k.__checked === I.__checked || x.setAttribute("aria-checked", k.getChecked() ? "true" : "false"));
  }
  function v(x) {
    return x = t.isHTMLElement(x) && x.getAttribute("aria-checked") === "true", { node: b(x) };
  }
  function b(x) {
    return e.$applyNodeReplacement(new f(void 0, x));
  }
  function y(x) {
    return x instanceof f;
  }
  class w extends e.ElementNode {
    static getType() {
      return "list";
    }
    static clone(k) {
      return new w(k.__listType || L[k.__tag], k.__start, k.__key);
    }
    constructor(k, I, z) {
      super(z), this.__listType = k = L[k] || k, this.__tag = k === "number" ? "ol" : "ul", this.__start = I;
    }
    getTag() {
      return this.__tag;
    }
    getListType() {
      return this.__listType;
    }
    getStart() {
      return this.__start;
    }
    createDOM(k) {
      let I = document.createElement(this.__tag);
      return this.__start !== 1 && I.setAttribute("start", String(this.__start)), I.__lexicalListType = this.__listType, N(I, k.theme, this), I;
    }
    updateDOM(k, I, z) {
      return k.__tag !== this.__tag ? !0 : (N(I, z.theme, this), !1);
    }
    static importDOM() {
      return { ol: () => ({ conversion: q, priority: 0 }), ul: () => ({ conversion: q, priority: 0 }) };
    }
    static importJSON(k) {
      let I = R(k.listType, k.start);
      return I.setFormat(k.format), I.setIndent(k.indent), I.setDirection(k.direction), I;
    }
    exportDOM(k) {
      return { element: k } = super.exportDOM(k), k && (this.__start !== 1 && k.setAttribute("start", String(this.__start)), this.__listType === "check" && k.setAttribute("__lexicalListType", "check")), { element: k };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        listType: this.getListType(),
        start: this.getStart(),
        tag: this.getTag(),
        type: "list",
        version: 1
      };
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
    append(...k) {
      for (let z = 0; z < k.length; z++) {
        var I = k[z];
        if (y(I))
          super.append(I);
        else {
          let F = b();
          T(I) || e.$isElementNode(I) && (I = e.$createTextNode(I.getTextContent())), F.append(I), super.append(F);
        }
      }
      return p(this), this;
    }
    extractWithChild(k) {
      return y(k);
    }
  }
  function N(x, k, I) {
    let z = [], F = [];
    var P = k.list;
    if (P !== void 0) {
      let V = P[`${I.__tag}Depth`] || [];
      k = o(I) - 1;
      let U = k % V.length;
      var O = V[U];
      let H = P[I.__tag], J;
      if (P = P.nested, P !== void 0 && P.list && (J = P.list), H !== void 0 && z.push(H), O !== void 0)
        for (O = O.split(" "), z.push(...O), O = 0; O < V.length; O++)
          O !== U && F.push(I.__tag + O);
      J !== void 0 && (I = J.split(" "), 1 < k ? z.push(...I) : F.push(...I));
    }
    0 < F.length && t.removeClassNamesFromElement(x, ...F), 0 < z.length && t.addClassNamesToElement(x, ...z);
  }
  function M(x) {
    let k = [];
    for (let z = 0; z < x.length; z++) {
      var I = x[z];
      y(I) ? (k.push(I), I = I.getChildren(), 1 < I.length && I.forEach((F) => {
        T(F) && k.push(c(F));
      })) : k.push(c(I));
    }
    return k;
  }
  function q(x) {
    let k = x.nodeName.toLowerCase(), I = null;
    return k === "ol" ? I = R("number", x.start) : k === "ul" && (I = t.isHTMLElement(x) && x.getAttribute("__lexicallisttype") === "check" ? R("check") : R("bullet")), { after: M, node: I };
  }
  let L = { ol: "number", ul: "bullet" };
  function R(x, k = 1) {
    return e.$applyNodeReplacement(new w(x, k));
  }
  function T(x) {
    return x instanceof w;
  }
  let D = e.createCommand("INSERT_UNORDERED_LIST_COMMAND"), A = e.createCommand("INSERT_ORDERED_LIST_COMMAND"), S = e.createCommand("INSERT_CHECK_LIST_COMMAND"), E = e.createCommand("REMOVE_LIST_COMMAND");
  return Ac.$createListItemNode = b, Ac.$createListNode = R, Ac.$getListDepth = o, Ac.$handleListInsertParagraph = function() {
    var x = e.$getSelection();
    if (!e.$isRangeSelection(x) || !x.isCollapsed() || (x = x.anchor.getNode(), !y(x) || x.getTextContent() !== ""))
      return !1;
    var k = r(x), I = x.getParent();
    T(I) || n(40);
    let z = I.getParent(), F;
    if (e.$isRootOrShadowRoot(z))
      F = e.$createParagraphNode(), k.insertAfter(F);
    else if (y(z))
      F = b(), z.insertAfter(F);
    else
      return !1;
    if (F.select(), k = x.getNextSiblings(), 0 < k.length) {
      let P = R(I.getListType());
      e.$isParagraphNode(F) ? F.insertAfter(P) : (I = b(), I.append(P), F.insertAfter(I)), k.forEach((O) => {
        O.remove(), P.append(O);
      });
    }
    return s(x), !0;
  }, Ac.$isListItemNode = y, Ac.$isListNode = T, Ac.INSERT_CHECK_LIST_COMMAND = S, Ac.INSERT_ORDERED_LIST_COMMAND = A, Ac.INSERT_UNORDERED_LIST_COMMAND = D, Ac.ListItemNode = f, Ac.ListNode = w, Ac.REMOVE_LIST_COMMAND = E, Ac.insertList = function(x, k) {
    x.update(() => {
      var I = e.$getSelection();
      if (e.$isRangeSelection(I) || e.DEPRECATED_$isGridSelection(I)) {
        var z = I.getNodes();
        I = I.anchor.getNode();
        var F = I.getParent();
        if (l(I, z))
          z = R(k), e.$isRootOrShadowRoot(F) ? (I.replace(z), F = b(), e.$isElementNode(I) && (F.setFormat(I.getFormatType()), F.setIndent(I.getIndent())), z.append(F)) : y(I) && (I = I.getParentOrThrow(), u(z, I.getChildren()), I.replace(z));
        else
          for (I = /* @__PURE__ */ new Set(), F = 0; F < z.length; F++) {
            var P = z[F];
            if (e.$isElementNode(P) && P.isEmpty() && !I.has(P.getKey()))
              d(
                P,
                k
              );
            else if (e.$isLeafNode(P))
              for (P = P.getParent(); P != null; ) {
                let V = P.getKey();
                if (T(P)) {
                  if (!I.has(V)) {
                    var O = R(k);
                    u(O, P.getChildren()), P.replace(O), p(O), I.add(V);
                  }
                  break;
                } else {
                  if (O = P.getParent(), e.$isRootOrShadowRoot(O) && !I.has(V)) {
                    I.add(V), d(P, k);
                    break;
                  }
                  P = O;
                }
              }
          }
      }
    });
  }, Ac.removeList = function(x) {
    x.update(() => {
      let k = e.$getSelection();
      if (e.$isRangeSelection(k)) {
        var I = /* @__PURE__ */ new Set(), z = k.getNodes(), F = k.anchor.getNode();
        if (l(F, z))
          I.add(r(F));
        else
          for (F = 0; F < z.length; F++) {
            var P = z[F];
            e.$isLeafNode(P) && (P = t.$getNearestNodeOfType(P, f), P != null && I.add(r(P)));
          }
        for (let O of I) {
          I = O, z = i(O);
          for (let V of z)
            z = e.$createParagraphNode(), u(z, V.getChildren()), I.insertAfter(z), I = z, V.__key === k.anchor.key && k.anchor.set(z.getKey(), 0, "element"), V.__key === k.focus.key && k.focus.set(z.getKey(), 0, "element"), V.remove();
          O.remove();
        }
      }
    });
  }, Ac;
}
var Ic = {}, aJ;
function DHl() {
  if (aJ)
    return Ic;
  aJ = 1;
  var e = lr(), t = Ci();
  function n(F) {
    let P = 1, O = F.getParent();
    for (; O != null; ) {
      if (q(O)) {
        const V = O.getParent();
        if (E(V)) {
          P++, O = V.getParent();
          continue;
        }
        throw Error("A ListItemNode must have a ListNode for a parent.");
      }
      return P;
    }
    return P;
  }
  function o(F) {
    let P = F.getParent();
    if (!E(P))
      throw Error("A ListItemNode must have a ListNode for a parent.");
    let O = P;
    for (; O !== null; )
      O = O.getParent(), E(O) && (P = O);
    return P;
  }
  function r(F) {
    let P = [];
    const O = F.getChildren().filter(q);
    for (let V = 0; V < O.length; V++) {
      const U = O[V], H = U.getFirstChild();
      E(H) ? P = P.concat(r(H)) : P.push(U);
    }
    return P;
  }
  function i(F) {
    return q(F) && E(F.getFirstChild());
  }
  function a(F) {
    let P = F;
    for (; P.getNextSibling() == null && P.getPreviousSibling() == null; ) {
      const O = P.getParent();
      if (O == null || !(q(P) || E(P)))
        break;
      P = O;
    }
    P.remove();
  }
  function s(F) {
    return M().append(F);
  }
  function c(F, P) {
    return q(F) && (P.length === 0 || P.length === 1 && F.is(P[0]) && F.getChildrenSize() === 0);
  }
  function l(F) {
    const P = F.getParent();
    let O = 1;
    if (P != null)
      if (E(P))
        O = P.getStart();
      else
        throw Error("$getListItemValue: list node is not parent of list item node");
    const V = F.getPreviousSiblings();
    for (let U = 0; U < V.length; U++) {
      const H = V[U];
      q(H) && !E(H.getFirstChild()) && O++;
    }
    return O;
  }
  function u(F, P) {
    F.update(() => {
      const O = e.$getSelection();
      if (e.$isRangeSelection(O) || e.DEPRECATED_$isGridSelection(O)) {
        const V = O.getNodes(), H = O.anchor.getNode(), J = H.getParent();
        if (c(H, V)) {
          const le = S(P);
          if (e.$isRootOrShadowRoot(J)) {
            H.replace(le);
            const ae = M();
            e.$isElementNode(H) && (ae.setFormat(H.getFormatType()), ae.setIndent(H.getIndent())), le.append(ae);
          } else if (q(H)) {
            const ae = H.getParentOrThrow();
            d(le, ae.getChildren()), ae.replace(le);
          }
          return;
        } else {
          const le = /* @__PURE__ */ new Set();
          for (let ae = 0; ae < V.length; ae++) {
            const Y = V[ae];
            if (e.$isElementNode(Y) && Y.isEmpty() && !le.has(Y.getKey())) {
              _(Y, P);
              continue;
            }
            if (e.$isLeafNode(Y)) {
              let re = Y.getParent();
              for (; re != null; ) {
                const ie = re.getKey();
                if (E(re)) {
                  if (!le.has(ie)) {
                    const _e = S(P);
                    d(_e, re.getChildren()), re.replace(_e), f(_e), le.add(ie);
                  }
                  break;
                } else {
                  const _e = re.getParent();
                  if (e.$isRootOrShadowRoot(_e) && !le.has(ie)) {
                    le.add(ie), _(re, P);
                    break;
                  }
                  re = _e;
                }
              }
            }
          }
        }
      }
    });
  }
  function d(F, P) {
    F.splice(F.getChildrenSize(), 0, P);
  }
  function _(F, P) {
    if (E(F))
      return F;
    const O = F.getPreviousSibling(), V = F.getNextSibling(), U = M();
    if (U.setFormat(F.getFormatType()), U.setIndent(F.getIndent()), d(U, F.getChildren()), E(O) && P === O.getListType())
      return O.append(U), F.remove(), E(V) && P === V.getListType() && (d(O, V.getChildren()), V.remove()), O;
    if (E(V) && P === V.getListType())
      return V.getFirstChildOrThrow().insertBefore(U), F.remove(), V;
    {
      const H = S(P);
      return H.append(U), F.replace(H), f(H), H;
    }
  }
  function p(F, P) {
    const O = F.getLastChild(), V = P.getFirstChild();
    O && V && i(O) && i(V) && (p(O.getFirstChild(), V.getFirstChild()), V.remove());
    const U = P.getChildren();
    U.length > 0 && (F.append(...U), f(F)), P.remove();
  }
  function g(F) {
    F.update(() => {
      const P = e.$getSelection();
      if (e.$isRangeSelection(P)) {
        const O = /* @__PURE__ */ new Set(), V = P.getNodes(), U = P.anchor.getNode();
        if (c(U, V))
          O.add(o(U));
        else
          for (let H = 0; H < V.length; H++) {
            const J = V[H];
            if (e.$isLeafNode(J)) {
              const le = t.$getNearestNodeOfType(J, b);
              le != null && O.add(o(le));
            }
          }
        for (const H of O) {
          let J = H;
          const le = r(H);
          for (const ae of le) {
            const Y = e.$createParagraphNode();
            d(Y, ae.getChildren()), J.insertAfter(Y), J = Y, ae.__key === P.anchor.key && P.anchor.set(Y.getKey(), 0, "element"), ae.__key === P.focus.key && P.focus.set(Y.getKey(), 0, "element"), ae.remove();
          }
          H.remove();
        }
      }
    });
  }
  function f(F, P) {
    const O = P || F.getChildren();
    if (O !== void 0)
      for (let V = 0; V < O.length; V++) {
        const U = O[V];
        if (q(U)) {
          const H = U.getValue(), J = l(U);
          H !== J && U.setValue(J);
        }
      }
  }
  function h(F) {
    const P = /* @__PURE__ */ new Set();
    if (i(F) || P.has(F.getKey()))
      return;
    const O = F.getParent(), V = F.getNextSibling(), U = F.getPreviousSibling();
    if (i(V) && i(U)) {
      const H = U.getFirstChild();
      if (E(H)) {
        H.append(F);
        const J = V.getFirstChild();
        if (E(J)) {
          const le = J.getChildren();
          d(H, le), V.remove(), P.add(V.getKey());
        }
        f(H);
      }
    } else if (i(V)) {
      const H = V.getFirstChild();
      if (E(H)) {
        const J = H.getFirstChild();
        J !== null && J.insertBefore(F), f(H);
      }
    } else if (i(U)) {
      const H = U.getFirstChild();
      E(H) && (H.append(F), f(H));
    } else if (E(O)) {
      const H = M(), J = S(O.getListType());
      H.append(J), J.append(F), U ? U.insertAfter(H) : V ? V.insertBefore(H) : O.append(H), f(J);
    }
    E(O) && f(O);
  }
  function $(F) {
    if (i(F))
      return;
    const P = F.getParent(), O = P ? P.getParent() : void 0, V = O ? O.getParent() : void 0;
    if (E(V) && q(O) && E(P)) {
      const U = P ? P.getFirstChild() : void 0, H = P ? P.getLastChild() : void 0;
      if (F.is(U))
        O.insertBefore(F), P.isEmpty() && O.remove();
      else if (F.is(H))
        O.insertAfter(F), P.isEmpty() && O.remove();
      else {
        const J = P.getListType(), le = M(), ae = S(J);
        le.append(ae), F.getPreviousSiblings().forEach((ie) => ae.append(ie));
        const Y = M(), re = S(J);
        Y.append(re), d(re, F.getNextSiblings()), O.insertBefore(le), O.insertAfter(Y), O.replace(F);
      }
      f(P), f(V);
    }
  }
  function v() {
    const F = e.$getSelection();
    if (!e.$isRangeSelection(F) || !F.isCollapsed())
      return !1;
    const P = F.anchor.getNode();
    if (!q(P) || P.getTextContent() !== "")
      return !1;
    const O = o(P), V = P.getParent();
    if (!E(V))
      throw Error("A ListItemNode must have a ListNode for a parent.");
    const U = V.getParent();
    let H;
    if (e.$isRootOrShadowRoot(U))
      H = e.$createParagraphNode(), O.insertAfter(H);
    else if (q(U))
      H = M(), U.insertAfter(H);
    else
      return !1;
    H.select();
    const J = P.getNextSiblings();
    if (J.length > 0) {
      const le = S(V.getListType());
      if (e.$isParagraphNode(H))
        H.insertAfter(le);
      else {
        const ae = M();
        ae.append(le), H.insertAfter(ae);
      }
      J.forEach((ae) => {
        ae.remove(), le.append(ae);
      });
    }
    return a(P), !0;
  }
  class b extends e.ElementNode {
    /** @internal */
    /** @internal */
    static getType() {
      return "listitem";
    }
    static clone(P) {
      return new b(P.__value, P.__checked, P.__key);
    }
    constructor(P, O, V) {
      super(V), this.__value = P === void 0 ? 1 : P, this.__checked = O;
    }
    createDOM(P) {
      const O = document.createElement("li"), V = this.getParent();
      return E(V) && V.getListType() === "check" && w(O, this, null), O.value = this.__value, y(O, P.theme, this), O;
    }
    updateDOM(P, O, V) {
      const U = this.getParent();
      return E(U) && U.getListType() === "check" && w(O, this, P), O.value = this.__value, y(O, V.theme, this), !1;
    }
    static transform() {
      return (P) => {
        const O = P.getParent();
        E(O) && (f(O), O.getListType() !== "check" && P.getChecked() != null && P.setChecked(void 0));
      };
    }
    static importDOM() {
      return {
        li: (P) => ({
          conversion: N,
          priority: 0
        })
      };
    }
    static importJSON(P) {
      const O = new b(P.value, P.checked);
      return O.setFormat(P.format), O.getWritable().__indent = P.indent, O.setDirection(P.direction), O;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        checked: this.getChecked(),
        type: "listitem",
        value: this.getValue(),
        version: 1
      };
    }
    append(...P) {
      for (let O = 0; O < P.length; O++) {
        const V = P[O];
        if (e.$isElementNode(V) && this.canMergeWith(V)) {
          const U = V.getChildren();
          this.append(...U), V.remove();
        } else
          super.append(V);
      }
      return this;
    }
    replace(P, O) {
      if (q(P))
        return super.replace(P);
      this.setIndent(0);
      const V = this.getParentOrThrow();
      if (!E(V))
        return P;
      if (V.__first === this.getKey())
        V.insertBefore(P);
      else if (V.__last === this.getKey())
        V.insertAfter(P);
      else {
        const U = S(V.getListType());
        let H = this.getNextSibling();
        for (; H; ) {
          const J = H;
          H = H.getNextSibling(), U.append(J);
        }
        V.insertAfter(P), P.insertAfter(U);
      }
      return O && this.getChildren().forEach((U) => {
        P.append(U);
      }), this.remove(), V.getChildrenSize() === 0 && V.remove(), P;
    }
    insertAfter(P, O = !0) {
      const V = this.getParentOrThrow();
      if (!E(V))
        throw Error("insertAfter: list node is not parent of list item node");
      const U = this.getNextSiblings();
      if (q(P)) {
        const H = super.insertAfter(P, O), J = P.getParentOrThrow();
        return E(J) && f(J), H;
      }
      if (E(P) && P.getListType() === V.getListType()) {
        let H = P;
        const J = P.getChildren();
        for (let le = J.length - 1; le >= 0; le--)
          H = J[le], this.insertAfter(H, O);
        return H;
      }
      if (V.insertAfter(P, O), U.length !== 0) {
        const H = S(V.getListType());
        U.forEach((J) => H.append(J)), P.insertAfter(H, O);
      }
      return P;
    }
    remove(P) {
      const O = this.getPreviousSibling(), V = this.getNextSibling();
      if (super.remove(P), O && V && i(O) && i(V))
        p(O.getFirstChild(), V.getFirstChild()), V.remove();
      else if (V) {
        const U = V.getParent();
        E(U) && f(U);
      }
    }
    insertNewAfter(P, O = !0) {
      const V = M(this.__checked == null ? void 0 : !1);
      return this.insertAfter(V, O), V;
    }
    collapseAtStart(P) {
      const O = e.$createParagraphNode();
      this.getChildren().forEach((le) => O.append(le));
      const U = this.getParentOrThrow(), H = U.getParentOrThrow(), J = q(H);
      if (U.getChildrenSize() === 1)
        if (J)
          U.remove(), H.select();
        else {
          U.insertBefore(O), U.remove();
          const le = P.anchor, ae = P.focus, Y = O.getKey();
          le.type === "element" && le.getNode().is(this) && le.set(Y, le.offset, "element"), ae.type === "element" && ae.getNode().is(this) && ae.set(Y, ae.offset, "element");
        }
      else
        U.insertBefore(O), this.remove();
      return !0;
    }
    getValue() {
      return this.getLatest().__value;
    }
    setValue(P) {
      const O = this.getWritable();
      O.__value = P;
    }
    getChecked() {
      return this.getLatest().__checked;
    }
    setChecked(P) {
      const O = this.getWritable();
      O.__checked = P;
    }
    toggleChecked() {
      this.setChecked(!this.__checked);
    }
    getIndent() {
      const P = this.getParent();
      if (P === null)
        return this.getLatest().__indent;
      let O = P.getParentOrThrow(), V = 0;
      for (; q(O); )
        O = O.getParentOrThrow().getParentOrThrow(), V++;
      return V;
    }
    setIndent(P) {
      if (!(typeof P == "number" && P > -1))
        throw Error("Invalid indent value.");
      let O = this.getIndent();
      for (; O !== P; )
        O < P ? (h(this), O++) : ($(this), O--);
      return this;
    }
    insertBefore(P) {
      if (q(P)) {
        const O = this.getParentOrThrow();
        if (E(O)) {
          const V = this.getNextSiblings();
          f(O, V);
        }
      }
      return super.insertBefore(P);
    }
    canInsertAfter(P) {
      return q(P);
    }
    canReplaceWith(P) {
      return q(P);
    }
    canMergeWith(P) {
      return e.$isParagraphNode(P) || q(P);
    }
    extractWithChild(P, O) {
      if (!e.$isRangeSelection(O))
        return !1;
      const V = O.anchor.getNode(), U = O.focus.getNode();
      return this.isParentOf(V) && this.isParentOf(U) && this.getTextContent().length === O.getTextContent().length;
    }
    isParentRequired() {
      return !0;
    }
    createParentElementNode() {
      return S("bullet");
    }
  }
  function y(F, P, O) {
    const V = [], U = [], H = P.list, J = H ? H.listitem : void 0;
    let le;
    if (H && H.nested && (le = H.nested.listitem), J !== void 0) {
      const ae = J.split(" ");
      V.push(...ae);
    }
    if (H) {
      const ae = O.getParent(), Y = E(ae) && ae.getListType() === "check", re = O.getChecked();
      (!Y || re) && U.push(H.listitemUnchecked), (!Y || !re) && U.push(H.listitemChecked), Y && V.push(re ? H.listitemChecked : H.listitemUnchecked);
    }
    if (le !== void 0) {
      const ae = le.split(" ");
      O.getChildren().some((Y) => E(Y)) ? V.push(...ae) : U.push(...ae);
    }
    U.length > 0 && t.removeClassNamesFromElement(F, ...U), V.length > 0 && t.addClassNamesToElement(F, ...V);
  }
  function w(F, P, O, V) {
    E(P.getFirstChild()) ? (F.removeAttribute("role"), F.removeAttribute("tabIndex"), F.removeAttribute("aria-checked")) : (F.setAttribute("role", "checkbox"), F.setAttribute("tabIndex", "-1"), (!O || P.__checked !== O.__checked) && F.setAttribute("aria-checked", P.getChecked() ? "true" : "false"));
  }
  function N(F) {
    const P = t.isHTMLElement(F) && F.getAttribute("aria-checked") === "true";
    return {
      node: M(P)
    };
  }
  function M(F) {
    return e.$applyNodeReplacement(new b(void 0, F));
  }
  function q(F) {
    return F instanceof b;
  }
  class L extends e.ElementNode {
    /** @internal */
    /** @internal */
    /** @internal */
    static getType() {
      return "list";
    }
    static clone(P) {
      const O = P.__listType || A[P.__tag];
      return new L(O, P.__start, P.__key);
    }
    constructor(P, O, V) {
      super(V);
      const U = A[P] || P;
      this.__listType = U, this.__tag = U === "number" ? "ol" : "ul", this.__start = O;
    }
    getTag() {
      return this.__tag;
    }
    getListType() {
      return this.__listType;
    }
    getStart() {
      return this.__start;
    }
    // View
    createDOM(P, O) {
      const V = this.__tag, U = document.createElement(V);
      return this.__start !== 1 && U.setAttribute("start", String(this.__start)), U.__lexicalListType = this.__listType, R(U, P.theme, this), U;
    }
    updateDOM(P, O, V) {
      return P.__tag !== this.__tag ? !0 : (R(O, V.theme, this), !1);
    }
    static importDOM() {
      return {
        ol: (P) => ({
          conversion: D,
          priority: 0
        }),
        ul: (P) => ({
          conversion: D,
          priority: 0
        })
      };
    }
    static importJSON(P) {
      const O = S(P.listType, P.start);
      return O.setFormat(P.format), O.setIndent(P.indent), O.setDirection(P.direction), O;
    }
    exportDOM(P) {
      const {
        element: O
      } = super.exportDOM(P);
      return O && (this.__start !== 1 && O.setAttribute("start", String(this.__start)), this.__listType === "check" && O.setAttribute("__lexicalListType", "check")), {
        element: O
      };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        listType: this.getListType(),
        start: this.getStart(),
        tag: this.getTag(),
        type: "list",
        version: 1
      };
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
    append(...P) {
      for (let O = 0; O < P.length; O++) {
        const V = P[O];
        if (q(V))
          super.append(V);
        else {
          const U = M();
          if (E(V))
            U.append(V);
          else if (e.$isElementNode(V)) {
            const H = e.$createTextNode(V.getTextContent());
            U.append(H);
          } else
            U.append(V);
          super.append(U);
        }
      }
      return f(this), this;
    }
    extractWithChild(P) {
      return q(P);
    }
  }
  function R(F, P, O) {
    const V = [], U = [], H = P.list;
    if (H !== void 0) {
      const J = H[`${O.__tag}Depth`] || [], le = n(O) - 1, ae = le % J.length, Y = J[ae], re = H[O.__tag];
      let ie;
      const _e = H.nested;
      if (_e !== void 0 && _e.list && (ie = _e.list), re !== void 0 && V.push(re), Y !== void 0) {
        const he = Y.split(" ");
        V.push(...he);
        for (let be = 0; be < J.length; be++)
          be !== ae && U.push(O.__tag + be);
      }
      if (ie !== void 0) {
        const he = ie.split(" ");
        le > 1 ? V.push(...he) : U.push(...he);
      }
    }
    U.length > 0 && t.removeClassNamesFromElement(F, ...U), V.length > 0 && t.addClassNamesToElement(F, ...V);
  }
  function T(F) {
    const P = [];
    for (let O = 0; O < F.length; O++) {
      const V = F[O];
      if (q(V)) {
        P.push(V);
        const U = V.getChildren();
        U.length > 1 && U.forEach((H) => {
          E(H) && P.push(s(H));
        });
      } else
        P.push(s(V));
    }
    return P;
  }
  function D(F) {
    const P = F.nodeName.toLowerCase();
    let O = null;
    if (P === "ol") {
      const V = F.start;
      O = S("number", V);
    } else
      P === "ul" && (t.isHTMLElement(F) && F.getAttribute("__lexicallisttype") === "check" ? O = S("check") : O = S("bullet"));
    return {
      after: T,
      node: O
    };
  }
  const A = {
    ol: "number",
    ul: "bullet"
  };
  function S(F, P = 1) {
    return e.$applyNodeReplacement(new L(F, P));
  }
  function E(F) {
    return F instanceof L;
  }
  const x = e.createCommand("INSERT_UNORDERED_LIST_COMMAND"), k = e.createCommand("INSERT_ORDERED_LIST_COMMAND"), I = e.createCommand("INSERT_CHECK_LIST_COMMAND"), z = e.createCommand("REMOVE_LIST_COMMAND");
  return Ic.$createListItemNode = M, Ic.$createListNode = S, Ic.$getListDepth = n, Ic.$handleListInsertParagraph = v, Ic.$isListItemNode = q, Ic.$isListNode = E, Ic.INSERT_CHECK_LIST_COMMAND = I, Ic.INSERT_ORDERED_LIST_COMMAND = k, Ic.INSERT_UNORDERED_LIST_COMMAND = x, Ic.ListItemNode = b, Ic.ListNode = L, Ic.REMOVE_LIST_COMMAND = z, Ic.insertList = u, Ic.removeList = g, Ic;
}
const LHl = process.env.NODE_ENV === "development" ? DHl() : PHl();
var Hl = LHl, sa = {}, h_ = {}, bp = {}, _E = {}, sJ;
function MHl() {
  if (sJ)
    return _E;
  sJ = 1;
  var e = If(), t = lr();
  function n(i, a, s, c = null) {
    let l = c != null ? a.isSelected() : !0, u = t.$isElementNode(a) && a.excludeFromCopy("html");
    var d = a;
    c !== null && (d = e.$cloneWithProperties(a), d = t.$isTextNode(d) && c != null ? e.$sliceSelectedTextNodeContent(c, d) : d);
    let _ = t.$isElementNode(d) ? d.getChildren() : [], { element: p, after: g } = d.exportDOM(i);
    if (!p)
      return !1;
    let f = new DocumentFragment();
    for (let h = 0; h < _.length; h++) {
      let $ = _[h], v = n(i, $, f, c);
      !l && t.$isElementNode(a) && v && a.extractWithChild($, c, "html") && (l = !0);
    }
    return l && !u ? (p.append(f), s.append(p), g && (i = g.call(
      d,
      p
    )) && p.replaceWith(i)) : s.append(f), l;
  }
  let o = /* @__PURE__ */ new Set(["STYLE"]);
  function r(i, a, s = /* @__PURE__ */ new Map(), c, l = !1) {
    let u = [];
    if (o.has(i.nodeName))
      return u;
    let d = null;
    var { nodeName: _ } = i, p = a._htmlConversions.get(_.toLowerCase());
    if (_ = null, p !== void 0)
      for (g of p)
        p = g(i), p !== null && (_ === null || _.priority < p.priority) && (_ = p);
    var g = (g = _ !== null ? _.conversion : null) ? g(i, void 0, l) : null;
    if (_ = null, g !== null) {
      if (_ = g.after, d = g.node, d !== null) {
        for (var [, f] of s)
          if (d = f(d, c), !d)
            break;
        d && u.push(d);
      }
      g.forChild != null && s.set(i.nodeName, g.forChild);
    }
    for (i = i.childNodes, c = [], f = 0; f < i.length; f++)
      c.push(...r(
        i[f],
        a,
        new Map(s),
        d,
        l || (g && g.preformatted) === !0
      ));
    return _ != null && (c = _(c)), d == null ? u = u.concat(c) : t.$isElementNode(d) && d.append(...c), u;
  }
  return _E.$generateHtmlFromNodes = function(i, a) {
    if (typeof document > "u" || typeof window > "u")
      throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
    let s = document.createElement("div"), c = t.$getRoot().getChildren();
    for (let l = 0; l < c.length; l++)
      n(i, c[l], s, a);
    return s.innerHTML;
  }, _E.$generateNodesFromDOM = function(i, a) {
    let s = [];
    a = a.body ? a.body.childNodes : [];
    for (let l = 0; l < a.length; l++) {
      var c = a[l];
      o.has(c.nodeName) || (c = r(c, i), c !== null && (s = s.concat(c)));
    }
    return s;
  }, _E;
}
var pE = {}, cJ;
function FHl() {
  if (cJ)
    return pE;
  cJ = 1;
  var e = If(), t = lr();
  function n(c, l) {
    let u = [];
    const d = l.body ? l.body.childNodes : [];
    for (let _ = 0; _ < d.length; _++) {
      const p = d[_];
      if (!a.has(p.nodeName)) {
        const g = s(p, c);
        g !== null && (u = u.concat(g));
      }
    }
    return u;
  }
  function o(c, l) {
    if (typeof document > "u" || typeof window > "u")
      throw new Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
    const u = document.createElement("div"), _ = t.$getRoot().getChildren();
    for (let p = 0; p < _.length; p++) {
      const g = _[p];
      r(c, g, u, l);
    }
    return u.innerHTML;
  }
  function r(c, l, u, d = null) {
    let _ = d != null ? l.isSelected() : !0;
    const p = t.$isElementNode(l) && l.excludeFromCopy("html");
    let g = l;
    if (d !== null) {
      let b = e.$cloneWithProperties(l);
      b = t.$isTextNode(b) && d != null ? e.$sliceSelectedTextNodeContent(d, b) : b, g = b;
    }
    const f = t.$isElementNode(g) ? g.getChildren() : [], {
      element: h,
      after: $
    } = g.exportDOM(c);
    if (!h)
      return !1;
    const v = new DocumentFragment();
    for (let b = 0; b < f.length; b++) {
      const y = f[b], w = r(c, y, v, d);
      !_ && t.$isElementNode(l) && w && l.extractWithChild(y, d, "html") && (_ = !0);
    }
    if (_ && !p) {
      if (h.append(v), u.append(h), $) {
        const b = $.call(g, h);
        b && h.replaceWith(b);
      }
    } else
      u.append(v);
    return _;
  }
  function i(c, l) {
    const {
      nodeName: u
    } = c, d = l._htmlConversions.get(u.toLowerCase());
    let _ = null;
    if (d !== void 0)
      for (const p of d) {
        const g = p(c);
        g !== null && (_ === null || _.priority < g.priority) && (_ = g);
      }
    return _ !== null ? _.conversion : null;
  }
  const a = /* @__PURE__ */ new Set(["STYLE"]);
  function s(c, l, u = /* @__PURE__ */ new Map(), d, _ = !1) {
    let p = [];
    if (a.has(c.nodeName))
      return p;
    let g = null;
    const f = i(c, l), h = f ? f(c, void 0, _) : null;
    let $ = null;
    if (h !== null) {
      if ($ = h.after, g = h.node, g !== null) {
        for (const [, y] of u)
          if (g = y(g, d), !g)
            break;
        g && p.push(g);
      }
      h.forChild != null && u.set(c.nodeName, h.forChild);
    }
    const v = c.childNodes;
    let b = [];
    for (let y = 0; y < v.length; y++)
      b.push(...s(v[y], l, new Map(u), g, _ || (h && h.preformatted) === !0));
    return $ != null && (b = $(b)), g == null ? p = p.concat(b) : t.$isElementNode(g) && g.append(...b), p;
  }
  return pE.$generateHtmlFromNodes = o, pE.$generateNodesFromDOM = n, pE;
}
const qHl = process.env.NODE_ENV === "development" ? FHl() : MHl();
var sk = qHl, lJ;
function jHl() {
  if (lJ)
    return bp;
  lJ = 1;
  var e = sk, t = If(), n = Ci(), o = lr();
  function r(f) {
    throw Error(`Minified Lexical error #${f}; visit https://lexical.dev/docs/error?code=${f} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  function i(f) {
    let h = o.$getSelection();
    if (h == null)
      throw Error("Expected valid LexicalSelection");
    return o.$isRangeSelection(h) && h.isCollapsed() || h.getNodes().length === 0 ? "" : e.$generateHtmlFromNodes(f, h);
  }
  function a(f) {
    let h = o.$getSelection();
    if (h == null)
      throw Error("Expected valid LexicalSelection");
    return o.$isRangeSelection(h) && h.isCollapsed() || h.getNodes().length === 0 ? null : JSON.stringify(d(f, h));
  }
  function s(f, h, $) {
    (o.DEPRECATED_$isGridSelection($) || n.$findMatchingParent($.anchor.getNode(), (v) => o.DEPRECATED_$isGridCellNode(v)) !== null && n.$findMatchingParent($.focus.getNode(), (v) => o.DEPRECATED_$isGridCellNode(v)) !== null) && h.length === 1 && o.DEPRECATED_$isGridNode(h[0]) ? l(h, $, !1, f) : c(h, $);
  }
  function c(f, h) {
    let $ = [], v = null;
    for (let b = 0; b < f.length; b++) {
      let y = f[b], w = o.$isLineBreakNode(y);
      if (w || o.$isDecoratorNode(y) && y.isInline() || o.$isElementNode(y) && y.isInline() || o.$isTextNode(y) || y.isParentRequired()) {
        if (v === null && (v = y.createParentElementNode(), $.push(v), w))
          continue;
        v !== null && v.append(y);
      } else
        $.push(y), v = null;
    }
    o.$isRangeSelection(h) ? h.insertNodes($) : o.DEPRECATED_$isGridSelection(h) && (f = h.anchor.getNode(), o.DEPRECATED_$isGridCellNode(f) || r(41), f.append(...$));
  }
  function l(f, h, $, v) {
    f.length === 1 && o.DEPRECATED_$isGridNode(f[0]) || r(42);
    var b = f[0];
    f = b.getChildren(), $ = b.getFirstChildOrThrow().getChildrenSize();
    var y = b.getChildrenSize(), w = n.$findMatchingParent(h.anchor.getNode(), (D) => o.DEPRECATED_$isGridCellNode(D));
    h = (b = w && n.$findMatchingParent(w, (D) => o.DEPRECATED_$isGridRowNode(D))) && n.$findMatchingParent(b, (D) => o.DEPRECATED_$isGridNode(D)), o.DEPRECATED_$isGridCellNode(w) && o.DEPRECATED_$isGridRowNode(b) && o.DEPRECATED_$isGridNode(h) || r(43);
    var N = b.getIndexWithinParent(), M = Math.min(h.getChildrenSize() - 1, N + y - 1);
    y = w.getIndexWithinParent(), w = Math.min(b.getChildrenSize() - 1, y + $ - 1), $ = Math.min(y, w), b = Math.min(N, M), y = Math.max(y, w), N = Math.max(N, M), M = h.getChildren(), w = 0;
    let q, L;
    for (let D = b; D <= N; D++) {
      var R = M[D];
      o.DEPRECATED_$isGridRowNode(R) || r(24);
      var T = f[w];
      o.DEPRECATED_$isGridRowNode(T) || r(24), R = R.getChildren(), T = T.getChildren();
      let A = 0;
      for (let S = $; S <= y; S++) {
        let E = R[S];
        o.DEPRECATED_$isGridCellNode(E) || r(25);
        let x = T[A];
        o.DEPRECATED_$isGridCellNode(x) || r(25), D === b && S === $ ? q = E.getKey() : D === N && S === y && (L = E.getKey());
        let k = E.getChildren();
        x.getChildren().forEach((I) => {
          o.$isTextNode(I) && o.$createParagraphNode().append(I), E.append(I);
        }), k.forEach((I) => I.remove()), A++;
      }
      w++;
    }
    q && L && (f = o.DEPRECATED_$createGridSelection(), f.set(h.getKey(), q, L), o.$setSelection(f), v.dispatchCommand(o.SELECTION_CHANGE_COMMAND, void 0));
  }
  function u(f, h, $, v = []) {
    let b = h != null ? $.isSelected(h) : !0, y = o.$isElementNode($) && $.excludeFromCopy("html");
    var w = $;
    if (h !== null) {
      var N = t.$cloneWithProperties($);
      w = N = o.$isTextNode(N) && h != null ? t.$sliceSelectedTextNodeContent(h, N) : N;
    }
    let M = o.$isElementNode(w) ? w.getChildren() : [];
    var q = w;
    N = q.exportJSON(), N.type !== q.constructor.getType() && r(58);
    var L = N.children;
    for (o.$isElementNode(q) && (Array.isArray(L) || r(59)), o.$isTextNode(w) && (w = w.__text, 0 < w.length ? N.text = w : b = !1), w = 0; w < M.length; w++)
      q = M[w], L = u(f, h, q, N.children), !b && o.$isElementNode($) && L && $.extractWithChild(q, h, "clone") && (b = !0);
    if (b && !y)
      v.push(N);
    else if (Array.isArray(N.children))
      for (f = 0; f < N.children.length; f++)
        v.push(N.children[f]);
    return b;
  }
  function d(f, h) {
    let $ = [], v = o.$getRoot().getChildren();
    for (let b = 0; b < v.length; b++)
      u(f, h, v[b], $);
    return { namespace: f._config.namespace, nodes: $ };
  }
  function _(f) {
    let h = [];
    for (let $ = 0; $ < f.length; $++) {
      let v = o.$parseSerializedNode(f[$]);
      o.$isTextNode(v) && t.$addNodeStyle(v), h.push(v);
    }
    return h;
  }
  let p = null;
  function g(f, h) {
    var $ = window.getSelection();
    if (!$)
      return !1;
    var v = $.anchorNode;
    if ($ = $.focusNode, v !== null && $ !== null && !o.isSelectionWithinEditor(f, v, $) || (h.preventDefault(), h = h.clipboardData, v = o.$getSelection(), h === null || v === null))
      return !1;
    $ = i(f), f = a(f);
    let b = "";
    return v !== null && (b = v.getTextContent()), $ !== null && h.setData("text/html", $), f !== null && h.setData("application/x-lexical-editor", f), h.setData("text/plain", b), !0;
  }
  return bp.$generateJSONFromSelectedNodes = d, bp.$generateNodesFromSerializedNodes = _, bp.$getHtmlContent = i, bp.$getLexicalContent = a, bp.$insertDataTransferForPlainText = function(f, h) {
    f = f.getData("text/plain"), f != null && h.insertRawText(f);
  }, bp.$insertDataTransferForRichText = function(f, h, $) {
    var v = f.getData("application/x-lexical-editor");
    if (v)
      try {
        let y = JSON.parse(v);
        if (y.namespace === $._config.namespace && Array.isArray(y.nodes)) {
          let w = _(y.nodes);
          return s($, w, h);
        }
      } catch {
      }
    if (v = f.getData("text/html"))
      try {
        var b = new DOMParser().parseFromString(v, "text/html");
        let y = e.$generateNodesFromDOM($, b);
        return s($, y, h);
      } catch {
      }
    if (f = f.getData("text/plain"), f != null)
      if (o.$isRangeSelection(h))
        for (f = f.split(/\r?\n/), $ = f.length, b = 0; b < $; b++)
          h.insertText(f[b]), b < $ - 1 && h.insertParagraph();
      else
        h.insertRawText(f);
  }, bp.$insertGeneratedNodes = s, bp.copyToClipboard = async function(f, h) {
    if (p !== null)
      return !1;
    if (h !== null)
      return new Promise((y) => {
        f.update(() => {
          y(g(f, h));
        });
      });
    var $ = f.getRootElement();
    let v = document.getSelection();
    if ($ === null || v === null)
      return !1;
    let b = document.createElement("span");
    return b.style.cssText = "position: fixed; top: -1000px;", b.append(document.createTextNode("#")), $.append(b), $ = new Range(), $.setStart(b, 0), $.setEnd(b, 1), v.removeAllRanges(), v.addRange($), new Promise((y) => {
      let w = f.registerCommand(o.COPY_COMMAND, (N) => (N instanceof ClipboardEvent && (w(), p !== null && (window.clearTimeout(p), p = null), y(g(f, N))), !0), o.COMMAND_PRIORITY_CRITICAL);
      p = window.setTimeout(() => {
        w(), p = null, y(!1);
      }, 50), document.execCommand("copy"), b.remove();
    });
  }, bp;
}
var yp = {}, uJ;
function VHl() {
  if (uJ)
    return yp;
  uJ = 1;
  var e = sk, t = If(), n = Ci(), o = lr();
  function r(b) {
    const y = o.$getSelection();
    if (y == null)
      throw Error("Expected valid LexicalSelection");
    return o.$isRangeSelection(y) && y.isCollapsed() || y.getNodes().length === 0 ? "" : e.$generateHtmlFromNodes(b, y);
  }
  function i(b) {
    const y = o.$getSelection();
    if (y == null)
      throw Error("Expected valid LexicalSelection");
    return o.$isRangeSelection(y) && y.isCollapsed() || y.getNodes().length === 0 ? null : JSON.stringify(p(b, y));
  }
  function a(b, y) {
    const w = b.getData("text/plain");
    w != null && y.insertRawText(w);
  }
  function s(b, y, w) {
    const N = b.getData("application/x-lexical-editor");
    if (N)
      try {
        const L = JSON.parse(N);
        if (L.namespace === w._config.namespace && Array.isArray(L.nodes)) {
          const R = g(L.nodes);
          return c(w, R, y);
        }
      } catch {
      }
    const M = b.getData("text/html");
    if (M)
      try {
        const R = new DOMParser().parseFromString(M, "text/html"), T = e.$generateNodesFromDOM(w, R);
        return c(w, T, y);
      } catch {
      }
    const q = b.getData("text/plain");
    if (q != null)
      if (o.$isRangeSelection(y)) {
        const L = q.split(/\r?\n/), R = L.length;
        for (let T = 0; T < R; T++)
          y.insertText(L[T]), T < R - 1 && y.insertParagraph();
      } else
        y.insertRawText(q);
  }
  function c(b, y, w) {
    if ((o.DEPRECATED_$isGridSelection(w) || n.$findMatchingParent(w.anchor.getNode(), (M) => o.DEPRECATED_$isGridCellNode(M)) !== null && n.$findMatchingParent(w.focus.getNode(), (M) => o.DEPRECATED_$isGridCellNode(M)) !== null) && y.length === 1 && o.DEPRECATED_$isGridNode(y[0])) {
      u(y, w, !1, b);
      return;
    }
    l(y, w);
  }
  function l(b, y) {
    const w = [];
    let N = null;
    for (let M = 0; M < b.length; M++) {
      const q = b[M], L = o.$isLineBreakNode(q);
      if (L || o.$isDecoratorNode(q) && q.isInline() || o.$isElementNode(q) && q.isInline() || o.$isTextNode(q) || q.isParentRequired()) {
        if (N === null && (N = q.createParentElementNode(), w.push(N), L))
          continue;
        N !== null && N.append(q);
      } else
        w.push(q), N = null;
    }
    if (o.$isRangeSelection(y))
      y.insertNodes(w);
    else if (o.DEPRECATED_$isGridSelection(y)) {
      const M = y.anchor.getNode();
      if (!o.DEPRECATED_$isGridCellNode(M))
        throw Error("Expected Grid Cell in Grid Selection");
      M.append(...w);
    }
  }
  function u(b, y, w, N) {
    if (b.length !== 1 || !o.DEPRECATED_$isGridNode(b[0]))
      throw Error("$mergeGridNodesStrategy: Expected Grid insertion.");
    const M = b[0], q = M.getChildren(), L = M.getFirstChildOrThrow().getChildrenSize(), R = M.getChildrenSize(), T = n.$findMatchingParent(y.anchor.getNode(), (J) => o.DEPRECATED_$isGridCellNode(J)), D = T && n.$findMatchingParent(T, (J) => o.DEPRECATED_$isGridRowNode(J)), A = D && n.$findMatchingParent(D, (J) => o.DEPRECATED_$isGridNode(J));
    if (!o.DEPRECATED_$isGridCellNode(T) || !o.DEPRECATED_$isGridRowNode(D) || !o.DEPRECATED_$isGridNode(A))
      throw Error("$mergeGridNodesStrategy: Expected selection to be inside of a Grid.");
    const S = D.getIndexWithinParent(), E = Math.min(A.getChildrenSize() - 1, S + R - 1), x = T.getIndexWithinParent(), k = Math.min(D.getChildrenSize() - 1, x + L - 1), I = Math.min(x, k), z = Math.min(S, E), F = Math.max(x, k), P = Math.max(S, E), O = A.getChildren();
    let V = 0, U, H;
    for (let J = z; J <= P; J++) {
      const le = O[J];
      if (!o.DEPRECATED_$isGridRowNode(le))
        throw Error("getNodes: expected to find GridRowNode");
      const ae = q[V];
      if (!o.DEPRECATED_$isGridRowNode(ae))
        throw Error("getNodes: expected to find GridRowNode");
      const Y = le.getChildren(), re = ae.getChildren();
      let ie = 0;
      for (let _e = I; _e <= F; _e++) {
        const he = Y[_e];
        if (!o.DEPRECATED_$isGridCellNode(he))
          throw Error("getNodes: expected to find GridCellNode");
        const be = re[ie];
        if (!o.DEPRECATED_$isGridCellNode(be))
          throw Error("getNodes: expected to find GridCellNode");
        J === z && _e === I ? U = he.getKey() : J === P && _e === F && (H = he.getKey());
        const Q = he.getChildren();
        be.getChildren().forEach((me) => {
          o.$isTextNode(me) && o.$createParagraphNode().append(me), he.append(me);
        }), Q.forEach((me) => me.remove()), ie++;
      }
      V++;
    }
    if (U && H) {
      const J = o.DEPRECATED_$createGridSelection();
      J.set(A.getKey(), U, H), o.$setSelection(J), N.dispatchCommand(o.SELECTION_CHANGE_COMMAND, void 0);
    }
  }
  function d(b) {
    const y = b.exportJSON(), w = b.constructor;
    if (y.type !== w.getType())
      throw Error(`LexicalNode: Node ${w.name} does not implement .exportJSON().`);
    const N = y.children;
    if (o.$isElementNode(b) && !Array.isArray(N))
      throw Error(`LexicalNode: Node ${w.name} is an element but .exportJSON() does not have a children array.`);
    return y;
  }
  function _(b, y, w, N = []) {
    let M = y != null ? w.isSelected(y) : !0;
    const q = o.$isElementNode(w) && w.excludeFromCopy("html");
    let L = w;
    if (y !== null) {
      let D = t.$cloneWithProperties(w);
      D = o.$isTextNode(D) && y != null ? t.$sliceSelectedTextNodeContent(y, D) : D, L = D;
    }
    const R = o.$isElementNode(L) ? L.getChildren() : [], T = d(L);
    if (o.$isTextNode(L)) {
      const D = L.__text;
      D.length > 0 ? T.text = D : M = !1;
    }
    for (let D = 0; D < R.length; D++) {
      const A = R[D], S = _(b, y, A, T.children);
      !M && o.$isElementNode(w) && S && w.extractWithChild(A, y, "clone") && (M = !0);
    }
    if (M && !q)
      N.push(T);
    else if (Array.isArray(T.children))
      for (let D = 0; D < T.children.length; D++) {
        const A = T.children[D];
        N.push(A);
      }
    return M;
  }
  function p(b, y) {
    const w = [], M = o.$getRoot().getChildren();
    for (let q = 0; q < M.length; q++) {
      const L = M[q];
      _(b, y, L, w);
    }
    return {
      namespace: b._config.namespace,
      nodes: w
    };
  }
  function g(b) {
    const y = [];
    for (let w = 0; w < b.length; w++) {
      const N = b[w], M = o.$parseSerializedNode(N);
      o.$isTextNode(M) && t.$addNodeStyle(M), y.push(M);
    }
    return y;
  }
  const f = 50;
  let h = null;
  async function $(b, y) {
    if (h !== null)
      return !1;
    if (y !== null)
      return new Promise((L, R) => {
        b.update(() => {
          L(v(b, y));
        });
      });
    const w = b.getRootElement(), N = document.getSelection();
    if (w === null || N === null)
      return !1;
    const M = document.createElement("span");
    M.style.cssText = "position: fixed; top: -1000px;", M.append(document.createTextNode("#")), w.append(M);
    const q = new Range();
    return q.setStart(M, 0), q.setEnd(M, 1), N.removeAllRanges(), N.addRange(q), new Promise((L, R) => {
      const T = b.registerCommand(o.COPY_COMMAND, (D) => (D instanceof ClipboardEvent && (T(), h !== null && (window.clearTimeout(h), h = null), L(v(b, D))), !0), o.COMMAND_PRIORITY_CRITICAL);
      h = window.setTimeout(() => {
        T(), h = null, L(!1);
      }, f), document.execCommand("copy"), M.remove();
    });
  }
  function v(b, y) {
    const w = window.getSelection();
    if (!w)
      return !1;
    const N = w.anchorNode, M = w.focusNode;
    if (N !== null && M !== null && !o.isSelectionWithinEditor(b, N, M))
      return !1;
    y.preventDefault();
    const q = y.clipboardData, L = o.$getSelection();
    if (q === null || L === null)
      return !1;
    const R = r(b), T = i(b);
    let D = "";
    return L !== null && (D = L.getTextContent()), R !== null && q.setData("text/html", R), T !== null && q.setData("application/x-lexical-editor", T), q.setData("text/plain", D), !0;
  }
  return yp.$generateJSONFromSelectedNodes = p, yp.$generateNodesFromSerializedNodes = g, yp.$getHtmlContent = r, yp.$getLexicalContent = i, yp.$insertDataTransferForPlainText = a, yp.$insertDataTransferForRichText = s, yp.$insertGeneratedNodes = c, yp.copyToClipboard = $, yp;
}
var PR, dJ;
function hbe() {
  return dJ || (dJ = 1, PR = process.env.NODE_ENV === "development" ? VHl() : jHl()), PR;
}
var _J;
function BHl() {
  if (_J)
    return h_;
  _J = 1;
  var e = hbe(), t = If(), n = Ci(), o = lr();
  function r(L, R) {
    return typeof document.caretRangeFromPoint < "u" ? (L = document.caretRangeFromPoint(L, R), L === null ? null : { node: L.startContainer, offset: L.startOffset }) : document.caretPositionFromPoint !== "undefined" ? (L = document.caretPositionFromPoint(L, R), L === null ? null : { node: L.offsetNode, offset: L.offset }) : null;
  }
  let i = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", a = i && "documentMode" in document ? document.documentMode : null, s = i && "InputEvent" in window && !a ? "getTargetRanges" in new window.InputEvent("input") : !1, c = i && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), l = i && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, u = i && /^(?=.*Chrome).*/i.test(navigator.userAgent), d = i && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !u, _ = o.createCommand("DRAG_DROP_PASTE_FILE");
  class p extends o.ElementNode {
    static getType() {
      return "quote";
    }
    static clone(R) {
      return new p(R.__key);
    }
    constructor(R) {
      super(R);
    }
    createDOM(R) {
      let T = document.createElement("blockquote");
      return n.addClassNamesToElement(T, R.theme.quote), T;
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { blockquote: () => ({ conversion: v, priority: 0 }) };
    }
    static importJSON(R) {
      let T = g();
      return T.setFormat(R.format), T.setIndent(R.indent), T.setDirection(R.direction), T;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "quote" };
    }
    insertNewAfter(R, T) {
      R = o.$createParagraphNode();
      let D = this.getDirection();
      return R.setDirection(D), this.insertAfter(R, T), R;
    }
    collapseAtStart() {
      let R = o.$createParagraphNode();
      return this.getChildren().forEach((T) => R.append(T)), this.replace(R), !0;
    }
  }
  function g() {
    return o.$applyNodeReplacement(new p());
  }
  class f extends o.ElementNode {
    static getType() {
      return "heading";
    }
    static clone(R) {
      return new f(R.__tag, R.__key);
    }
    constructor(R, T) {
      super(T), this.__tag = R;
    }
    getTag() {
      return this.__tag;
    }
    createDOM(R) {
      let T = this.__tag, D = document.createElement(T);
      return R = R.theme.heading, R !== void 0 && n.addClassNamesToElement(D, R[T]), D;
    }
    updateDOM() {
      return !1;
    }
    static importDOM() {
      return { h1: () => ({ conversion: $, priority: 0 }), h2: () => ({ conversion: $, priority: 0 }), h3: () => ({ conversion: $, priority: 0 }), h4: () => ({ conversion: $, priority: 0 }), h5: () => ({
        conversion: $,
        priority: 0
      }), h6: () => ({ conversion: $, priority: 0 }), p: (R) => (R = R.firstChild, R !== null && h(R) ? { conversion: () => ({ node: null }), priority: 3 } : null), span: (R) => h(R) ? { conversion: () => ({ node: b("h1") }), priority: 3 } : null };
    }
    static importJSON(R) {
      let T = b(R.tag);
      return T.setFormat(R.format), T.setIndent(R.indent), T.setDirection(R.direction), T;
    }
    exportJSON() {
      return { ...super.exportJSON(), tag: this.getTag(), type: "heading", version: 1 };
    }
    insertNewAfter(R, T = !0) {
      R = R ? R.anchor.offset : 0, R = 0 < R && R < this.getTextContentSize() ? b(this.getTag()) : o.$createParagraphNode();
      let D = this.getDirection();
      return R.setDirection(D), this.insertAfter(R, T), R;
    }
    collapseAtStart() {
      let R = this.isEmpty() ? o.$createParagraphNode() : b(this.getTag());
      return this.getChildren().forEach((T) => R.append(T)), this.replace(R), !0;
    }
    extractWithChild() {
      return !0;
    }
  }
  function h(L) {
    return L.nodeName.toLowerCase() === "span" ? L.style.fontSize === "26pt" : !1;
  }
  function $(L) {
    L = L.nodeName.toLowerCase();
    let R = null;
    return (L === "h1" || L === "h2" || L === "h3" || L === "h4" || L === "h5" || L === "h6") && (R = b(L)), { node: R };
  }
  function v() {
    return { node: g() };
  }
  function b(L) {
    return o.$applyNodeReplacement(new f(L));
  }
  function y(L, R) {
    L.preventDefault(), R.update(() => {
      let T = o.$getSelection(), D = L instanceof InputEvent || L instanceof KeyboardEvent ? null : L.clipboardData;
      D != null && (o.$isRangeSelection(T) || o.DEPRECATED_$isGridSelection(T)) && e.$insertDataTransferForRichText(D, T, R);
    }, { tag: "paste" });
  }
  async function w(L, R) {
    await e.copyToClipboard(R, L instanceof ClipboardEvent ? L : null), R.update(() => {
      let T = o.$getSelection();
      o.$isRangeSelection(T) ? T.removeText() : o.$isNodeSelection(T) && T.getNodes().forEach((D) => D.remove());
    });
  }
  function N(L) {
    let R = null;
    if (L instanceof DragEvent ? R = L.dataTransfer : L instanceof ClipboardEvent && (R = L.clipboardData), R === null)
      return [!1, [], !1];
    var T = R.types;
    return L = T.includes("Files"), T = T.includes("text/html") || T.includes("text/plain"), [L, Array.from(R.files), T];
  }
  function M(L, R) {
    var T = o.$getSelection();
    if (o.$isRangeSelection(T)) {
      var D = /* @__PURE__ */ new Set();
      T = T.getNodes();
      for (let A = 0; A < T.length; A++) {
        let S = T[A], E = S.getKey();
        if (D.has(E))
          continue;
        let x = n.$getNearestBlockElementAncestorOrThrow(S), k = x.getKey();
        x.canInsertTab() ? (L(S), D.add(E)) : x.canIndent() && !D.has(k) && (D.add(k), R(x));
      }
    }
  }
  function q(L) {
    return L = o.$getNearestNodeFromDOMNode(L), o.$isDecoratorNode(L);
  }
  return h_.$createHeadingNode = b, h_.$createQuoteNode = g, h_.$isHeadingNode = function(L) {
    return L instanceof f;
  }, h_.$isQuoteNode = function(L) {
    return L instanceof p;
  }, h_.DRAG_DROP_PASTE = _, h_.HeadingNode = f, h_.QuoteNode = p, h_.eventFiles = N, h_.registerRichText = function(L) {
    return n.mergeRegister(
      L.registerCommand(o.CLICK_COMMAND, () => {
        const R = o.$getSelection();
        return o.$isNodeSelection(R) ? (R.clear(), !0) : !1;
      }, 0),
      L.registerCommand(o.DELETE_CHARACTER_COMMAND, (R) => {
        const T = o.$getSelection();
        return o.$isRangeSelection(T) ? (T.deleteCharacter(R), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.DELETE_WORD_COMMAND, (R) => {
        const T = o.$getSelection();
        return o.$isRangeSelection(T) ? (T.deleteWord(R), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.DELETE_LINE_COMMAND, (R) => {
        const T = o.$getSelection();
        return o.$isRangeSelection(T) ? (T.deleteLine(R), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.CONTROLLED_TEXT_INSERTION_COMMAND, (R) => {
        const T = o.$getSelection();
        if (typeof R == "string")
          o.$isRangeSelection(T) ? T.insertText(R) : o.DEPRECATED_$isGridSelection(T);
        else {
          if (!o.$isRangeSelection(T) && !o.DEPRECATED_$isGridSelection(T))
            return !1;
          const D = R.dataTransfer;
          D != null ? e.$insertDataTransferForRichText(D, T, L) : o.$isRangeSelection(T) && (R = R.data) && T.insertText(R);
        }
        return !0;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.REMOVE_TEXT_COMMAND, () => {
        const R = o.$getSelection();
        return o.$isRangeSelection(R) ? (R.removeText(), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.FORMAT_TEXT_COMMAND, (R) => {
        const T = o.$getSelection();
        return o.$isRangeSelection(T) ? (T.formatText(R), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.FORMAT_ELEMENT_COMMAND, (R) => {
        var T = o.$getSelection();
        if (!o.$isRangeSelection(T) && !o.$isNodeSelection(T))
          return !1;
        T = T.getNodes();
        for (const D of T)
          n.$getNearestBlockElementAncestorOrThrow(D).setFormat(R);
        return !0;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.INSERT_LINE_BREAK_COMMAND, (R) => {
        const T = o.$getSelection();
        return o.$isRangeSelection(T) ? (T.insertLineBreak(R), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.INSERT_PARAGRAPH_COMMAND, () => {
        const R = o.$getSelection();
        return o.$isRangeSelection(R) ? (R.insertParagraph(), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(
        o.INDENT_CONTENT_COMMAND,
        () => (M(() => {
          L.dispatchCommand(o.CONTROLLED_TEXT_INSERTION_COMMAND, "	");
        }, (R) => {
          const T = R.getIndent();
          T !== 10 && R.setIndent(T + 1);
        }), !0),
        o.COMMAND_PRIORITY_EDITOR
      ),
      L.registerCommand(o.OUTDENT_CONTENT_COMMAND, () => (M((R) => {
        o.$isTextNode(R) && (R = R.getTextContent(), R[R.length - 1] === "	" && L.dispatchCommand(o.DELETE_CHARACTER_COMMAND, !0));
      }, (R) => {
        const T = R.getIndent();
        T !== 0 && R.setIndent(T - 1);
      }), !0), o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_ARROW_UP_COMMAND, (R) => {
        var T = o.$getSelection();
        if (o.$isNodeSelection(T) && !q(R.target)) {
          if (R = T.getNodes(), 0 < R.length)
            return R[0].selectPrevious(), !0;
        } else if (o.$isRangeSelection(T)) {
          if (T = o.$getAdjacentNode(T.focus, !0), o.$isDecoratorNode(T) && !T.isIsolated() && !T.isInline())
            return T.selectPrevious(), R.preventDefault(), !0;
          if (o.$isElementNode(T) && !T.isInline() && !T.canBeEmpty())
            return T.select(), R.preventDefault(), !0;
        }
        return !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_ARROW_DOWN_COMMAND, (R) => {
        var T = o.$getSelection();
        if (o.$isNodeSelection(T)) {
          if (R = T.getNodes(), 0 < R.length)
            return R[0].selectNext(
              0,
              0
            ), !0;
        } else if (o.$isRangeSelection(T)) {
          let D = T.focus;
          if (D.key === "root" && D.offset === o.$getRoot().getChildrenSize())
            return R.preventDefault(), !0;
          if (T = o.$getAdjacentNode(T.focus, !1), o.$isDecoratorNode(T) && !T.isIsolated() && !T.isInline())
            return T.selectNext(), R.preventDefault(), !0;
        }
        return !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_ARROW_LEFT_COMMAND, (R) => {
        const T = o.$getSelection();
        if (o.$isNodeSelection(T)) {
          var D = T.getNodes();
          if (0 < D.length)
            return R.preventDefault(), D[0].selectPrevious(), !0;
        }
        return o.$isRangeSelection(T) && t.$shouldOverrideDefaultCharacterSelection(T, !0) ? (D = R.shiftKey, R.preventDefault(), t.$moveCharacter(T, D, !0), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_ARROW_RIGHT_COMMAND, (R) => {
        const T = o.$getSelection();
        if (o.$isNodeSelection(T) && !q(R.target)) {
          var D = T.getNodes();
          if (0 < D.length)
            return R.preventDefault(), D[0].selectNext(0, 0), !0;
        }
        return o.$isRangeSelection(T) ? (D = R.shiftKey, t.$shouldOverrideDefaultCharacterSelection(T, !1) ? (R.preventDefault(), t.$moveCharacter(T, D, !1), !0) : !1) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_BACKSPACE_COMMAND, (R) => {
        if (q(R.target))
          return !1;
        const T = o.$getSelection();
        if (!o.$isRangeSelection(T))
          return !1;
        R.preventDefault(), { anchor: R } = T;
        const D = R.getNode();
        return T.isCollapsed() && R.offset === 0 && !o.$isRootNode(D) && 0 < n.$getNearestBlockElementAncestorOrThrow(D).getIndent() ? L.dispatchCommand(o.OUTDENT_CONTENT_COMMAND, void 0) : L.dispatchCommand(o.DELETE_CHARACTER_COMMAND, !0);
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_DELETE_COMMAND, (R) => {
        if (q(R.target))
          return !1;
        const T = o.$getSelection();
        return o.$isRangeSelection(T) ? (R.preventDefault(), L.dispatchCommand(o.DELETE_CHARACTER_COMMAND, !1)) : !1;
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.KEY_ENTER_COMMAND, (R) => {
        const T = o.$getSelection();
        if (!o.$isRangeSelection(T))
          return !1;
        if (R !== null) {
          if ((l || c || d) && s)
            return !1;
          if (R.preventDefault(), R.shiftKey)
            return L.dispatchCommand(o.INSERT_LINE_BREAK_COMMAND, !1);
        }
        return L.dispatchCommand(o.INSERT_PARAGRAPH_COMMAND, void 0);
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(
        o.KEY_ESCAPE_COMMAND,
        () => {
          const R = o.$getSelection();
          return o.$isRangeSelection(R) ? (L.blur(), !0) : !1;
        },
        o.COMMAND_PRIORITY_EDITOR
      ),
      L.registerCommand(o.DROP_COMMAND, (R) => {
        const [, T] = N(R);
        if (0 < T.length) {
          var D = r(R.clientX, R.clientY);
          if (D !== null) {
            const { offset: S, node: E } = D;
            var A = o.$getNearestNodeFromDOMNode(E);
            if (A !== null) {
              if (D = o.$createRangeSelection(), o.$isTextNode(A))
                D.anchor.set(A.getKey(), S, "text"), D.focus.set(A.getKey(), S, "text");
              else {
                const x = A.getParentOrThrow().getKey();
                A = A.getIndexWithinParent() + 1, D.anchor.set(
                  x,
                  A,
                  "element"
                ), D.focus.set(x, A, "element");
              }
              D = o.$normalizeSelection__EXPERIMENTAL(D), o.$setSelection(D);
            }
            L.dispatchCommand(_, T);
          }
          return R.preventDefault(), !0;
        }
        return R = o.$getSelection(), !!o.$isRangeSelection(R);
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.DRAGSTART_COMMAND, (R) => {
        [R] = N(R);
        const T = o.$getSelection();
        return !(R && !o.$isRangeSelection(T));
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.DRAGOVER_COMMAND, (R) => {
        var [T] = N(R);
        const D = o.$getSelection();
        return T && !o.$isRangeSelection(D) ? !1 : (T = r(R.clientX, R.clientY), T !== null && (T = o.$getNearestNodeFromDOMNode(T.node), o.$isDecoratorNode(T) && R.preventDefault()), !0);
      }, o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.COPY_COMMAND, (R) => (e.copyToClipboard(L, R instanceof ClipboardEvent ? R : null), !0), o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.CUT_COMMAND, (R) => (w(R, L), !0), o.COMMAND_PRIORITY_EDITOR),
      L.registerCommand(o.PASTE_COMMAND, (R) => {
        const [, T, D] = N(R);
        if (0 < T.length && !D)
          return L.dispatchCommand(_, T), !0;
        const A = o.$getSelection();
        return o.$isRangeSelection(A) || o.DEPRECATED_$isGridSelection(A) ? (y(R, L), !0) : !1;
      }, o.COMMAND_PRIORITY_EDITOR)
    );
  }, h_;
}
var v_ = {}, pJ;
function UHl() {
  if (pJ)
    return v_;
  pJ = 1;
  var e = hbe(), t = If(), n = Ci(), o = lr();
  function r(A, S) {
    if (typeof document.caretRangeFromPoint < "u") {
      const E = document.caretRangeFromPoint(A, S);
      return E === null ? null : {
        node: E.startContainer,
        offset: E.startOffset
      };
    } else if (document.caretPositionFromPoint !== "undefined") {
      const E = document.caretPositionFromPoint(A, S);
      return E === null ? null : {
        node: E.offsetNode,
        offset: E.offset
      };
    } else
      return null;
  }
  const i = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", a = i && "documentMode" in document ? document.documentMode : null, s = i && "InputEvent" in window && !a ? "getTargetRanges" in new window.InputEvent("input") : !1, c = i && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), l = i && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, u = i && /^(?=.*Chrome).*/i.test(navigator.userAgent), d = i && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !u, _ = o.createCommand("DRAG_DROP_PASTE_FILE");
  class p extends o.ElementNode {
    static getType() {
      return "quote";
    }
    static clone(S) {
      return new p(S.__key);
    }
    constructor(S) {
      super(S);
    }
    // View
    createDOM(S) {
      const E = document.createElement("blockquote");
      return n.addClassNamesToElement(E, S.theme.quote), E;
    }
    updateDOM(S, E) {
      return !1;
    }
    static importDOM() {
      return {
        blockquote: (S) => ({
          conversion: b,
          priority: 0
        })
      };
    }
    static importJSON(S) {
      const E = g();
      return E.setFormat(S.format), E.setIndent(S.indent), E.setDirection(S.direction), E;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "quote"
      };
    }
    // Mutation
    insertNewAfter(S, E) {
      const x = o.$createParagraphNode(), k = this.getDirection();
      return x.setDirection(k), this.insertAfter(x, E), x;
    }
    collapseAtStart() {
      const S = o.$createParagraphNode();
      return this.getChildren().forEach((x) => S.append(x)), this.replace(S), !0;
    }
  }
  function g() {
    return o.$applyNodeReplacement(new p());
  }
  function f(A) {
    return A instanceof p;
  }
  class h extends o.ElementNode {
    /** @internal */
    static getType() {
      return "heading";
    }
    static clone(S) {
      return new h(S.__tag, S.__key);
    }
    constructor(S, E) {
      super(E), this.__tag = S;
    }
    getTag() {
      return this.__tag;
    }
    // View
    createDOM(S) {
      const E = this.__tag, x = document.createElement(E), I = S.theme.heading;
      if (I !== void 0) {
        const z = I[E];
        n.addClassNamesToElement(x, z);
      }
      return x;
    }
    updateDOM(S, E) {
      return !1;
    }
    static importDOM() {
      return {
        h1: (S) => ({
          conversion: v,
          priority: 0
        }),
        h2: (S) => ({
          conversion: v,
          priority: 0
        }),
        h3: (S) => ({
          conversion: v,
          priority: 0
        }),
        h4: (S) => ({
          conversion: v,
          priority: 0
        }),
        h5: (S) => ({
          conversion: v,
          priority: 0
        }),
        h6: (S) => ({
          conversion: v,
          priority: 0
        }),
        p: (S) => {
          const x = S.firstChild;
          return x !== null && $(x) ? {
            conversion: () => ({
              node: null
            }),
            priority: 3
          } : null;
        },
        span: (S) => $(S) ? {
          conversion: (E) => ({
            node: y("h1")
          }),
          priority: 3
        } : null
      };
    }
    static importJSON(S) {
      const E = y(S.tag);
      return E.setFormat(S.format), E.setIndent(S.indent), E.setDirection(S.direction), E;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        tag: this.getTag(),
        type: "heading",
        version: 1
      };
    }
    // Mutation
    insertNewAfter(S, E = !0) {
      const x = S ? S.anchor.offset : 0, k = x > 0 && x < this.getTextContentSize() ? y(this.getTag()) : o.$createParagraphNode(), I = this.getDirection();
      return k.setDirection(I), this.insertAfter(k, E), k;
    }
    collapseAtStart() {
      const S = this.isEmpty() ? o.$createParagraphNode() : y(this.getTag());
      return this.getChildren().forEach((x) => S.append(x)), this.replace(S), !0;
    }
    extractWithChild() {
      return !0;
    }
  }
  function $(A) {
    return A.nodeName.toLowerCase() === "span" ? A.style.fontSize === "26pt" : !1;
  }
  function v(A) {
    const S = A.nodeName.toLowerCase();
    let E = null;
    return (S === "h1" || S === "h2" || S === "h3" || S === "h4" || S === "h5" || S === "h6") && (E = y(S)), {
      node: E
    };
  }
  function b() {
    return {
      node: g()
    };
  }
  function y(A) {
    return o.$applyNodeReplacement(new h(A));
  }
  function w(A) {
    return A instanceof h;
  }
  function N(A, S) {
    A.preventDefault(), S.update(() => {
      const E = o.$getSelection(), x = A instanceof InputEvent || A instanceof KeyboardEvent ? null : A.clipboardData;
      x != null && (o.$isRangeSelection(E) || o.DEPRECATED_$isGridSelection(E)) && e.$insertDataTransferForRichText(x, E, S);
    }, {
      tag: "paste"
    });
  }
  async function M(A, S) {
    await e.copyToClipboard(S, A instanceof ClipboardEvent ? A : null), S.update(() => {
      const E = o.$getSelection();
      o.$isRangeSelection(E) ? E.removeText() : o.$isNodeSelection(E) && E.getNodes().forEach((x) => x.remove());
    });
  }
  function q(A) {
    let S = null;
    if (A instanceof DragEvent ? S = A.dataTransfer : A instanceof ClipboardEvent && (S = A.clipboardData), S === null)
      return [!1, [], !1];
    const E = S.types, x = E.includes("Files"), k = E.includes("text/html") || E.includes("text/plain");
    return [x, Array.from(S.files), k];
  }
  function L(A, S) {
    const E = o.$getSelection();
    if (!o.$isRangeSelection(E))
      return;
    const x = /* @__PURE__ */ new Set(), k = E.getNodes();
    for (let I = 0; I < k.length; I++) {
      const z = k[I], F = z.getKey();
      if (x.has(F))
        continue;
      const P = n.$getNearestBlockElementAncestorOrThrow(z), O = P.getKey();
      P.canInsertTab() ? (A(z), x.add(F)) : P.canIndent() && !x.has(O) && (x.add(O), S(P));
    }
  }
  function R(A) {
    const S = o.$getNearestNodeFromDOMNode(A);
    return o.$isDecoratorNode(S);
  }
  function T(A) {
    const S = A.focus;
    return S.key === "root" && S.offset === o.$getRoot().getChildrenSize();
  }
  function D(A) {
    return n.mergeRegister(A.registerCommand(o.CLICK_COMMAND, (E) => {
      const x = o.$getSelection();
      return o.$isNodeSelection(x) ? (x.clear(), !0) : !1;
    }, 0), A.registerCommand(o.DELETE_CHARACTER_COMMAND, (E) => {
      const x = o.$getSelection();
      return o.$isRangeSelection(x) ? (x.deleteCharacter(E), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.DELETE_WORD_COMMAND, (E) => {
      const x = o.$getSelection();
      return o.$isRangeSelection(x) ? (x.deleteWord(E), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.DELETE_LINE_COMMAND, (E) => {
      const x = o.$getSelection();
      return o.$isRangeSelection(x) ? (x.deleteLine(E), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.CONTROLLED_TEXT_INSERTION_COMMAND, (E) => {
      const x = o.$getSelection();
      if (typeof E == "string")
        o.$isRangeSelection(x) ? x.insertText(E) : o.DEPRECATED_$isGridSelection(x);
      else {
        if (!o.$isRangeSelection(x) && !o.DEPRECATED_$isGridSelection(x))
          return !1;
        const k = E.dataTransfer;
        if (k != null)
          e.$insertDataTransferForRichText(k, x, A);
        else if (o.$isRangeSelection(x)) {
          const I = E.data;
          return I && x.insertText(I), !0;
        }
      }
      return !0;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.REMOVE_TEXT_COMMAND, () => {
      const E = o.$getSelection();
      return o.$isRangeSelection(E) ? (E.removeText(), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.FORMAT_TEXT_COMMAND, (E) => {
      const x = o.$getSelection();
      return o.$isRangeSelection(x) ? (x.formatText(E), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.FORMAT_ELEMENT_COMMAND, (E) => {
      const x = o.$getSelection();
      if (!o.$isRangeSelection(x) && !o.$isNodeSelection(x))
        return !1;
      const k = x.getNodes();
      for (const I of k)
        n.$getNearestBlockElementAncestorOrThrow(I).setFormat(E);
      return !0;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.INSERT_LINE_BREAK_COMMAND, (E) => {
      const x = o.$getSelection();
      return o.$isRangeSelection(x) ? (x.insertLineBreak(E), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.INSERT_PARAGRAPH_COMMAND, () => {
      const E = o.$getSelection();
      return o.$isRangeSelection(E) ? (E.insertParagraph(), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.INDENT_CONTENT_COMMAND, () => (L(() => {
      A.dispatchCommand(o.CONTROLLED_TEXT_INSERTION_COMMAND, "	");
    }, (E) => {
      const x = E.getIndent();
      x !== 10 && E.setIndent(x + 1);
    }), !0), o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.OUTDENT_CONTENT_COMMAND, () => (L((E) => {
      if (o.$isTextNode(E)) {
        const x = E.getTextContent();
        x[x.length - 1] === "	" && A.dispatchCommand(o.DELETE_CHARACTER_COMMAND, !0);
      }
    }, (E) => {
      const x = E.getIndent();
      x !== 0 && E.setIndent(x - 1);
    }), !0), o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_ARROW_UP_COMMAND, (E) => {
      const x = o.$getSelection();
      if (o.$isNodeSelection(x) && !R(E.target)) {
        const k = x.getNodes();
        if (k.length > 0)
          return k[0].selectPrevious(), !0;
      } else if (o.$isRangeSelection(x)) {
        const k = o.$getAdjacentNode(x.focus, !0);
        if (o.$isDecoratorNode(k) && !k.isIsolated() && !k.isInline())
          return k.selectPrevious(), E.preventDefault(), !0;
        if (o.$isElementNode(k) && !k.isInline() && !k.canBeEmpty())
          return k.select(), E.preventDefault(), !0;
      }
      return !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_ARROW_DOWN_COMMAND, (E) => {
      const x = o.$getSelection();
      if (o.$isNodeSelection(x)) {
        const k = x.getNodes();
        if (k.length > 0)
          return k[0].selectNext(0, 0), !0;
      } else if (o.$isRangeSelection(x)) {
        if (T(x))
          return E.preventDefault(), !0;
        const k = o.$getAdjacentNode(x.focus, !1);
        if (o.$isDecoratorNode(k) && !k.isIsolated() && !k.isInline())
          return k.selectNext(), E.preventDefault(), !0;
      }
      return !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_ARROW_LEFT_COMMAND, (E) => {
      const x = o.$getSelection();
      if (o.$isNodeSelection(x)) {
        const k = x.getNodes();
        if (k.length > 0)
          return E.preventDefault(), k[0].selectPrevious(), !0;
      }
      if (!o.$isRangeSelection(x))
        return !1;
      if (t.$shouldOverrideDefaultCharacterSelection(x, !0)) {
        const k = E.shiftKey;
        return E.preventDefault(), t.$moveCharacter(x, k, !0), !0;
      }
      return !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_ARROW_RIGHT_COMMAND, (E) => {
      const x = o.$getSelection();
      if (o.$isNodeSelection(x) && !R(E.target)) {
        const I = x.getNodes();
        if (I.length > 0)
          return E.preventDefault(), I[0].selectNext(0, 0), !0;
      }
      if (!o.$isRangeSelection(x))
        return !1;
      const k = E.shiftKey;
      return t.$shouldOverrideDefaultCharacterSelection(x, !1) ? (E.preventDefault(), t.$moveCharacter(x, k, !1), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_BACKSPACE_COMMAND, (E) => {
      if (R(E.target))
        return !1;
      const x = o.$getSelection();
      if (!o.$isRangeSelection(x))
        return !1;
      E.preventDefault();
      const {
        anchor: k
      } = x, I = k.getNode();
      return x.isCollapsed() && k.offset === 0 && !o.$isRootNode(I) && n.$getNearestBlockElementAncestorOrThrow(I).getIndent() > 0 ? A.dispatchCommand(o.OUTDENT_CONTENT_COMMAND, void 0) : A.dispatchCommand(o.DELETE_CHARACTER_COMMAND, !0);
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_DELETE_COMMAND, (E) => {
      if (R(E.target))
        return !1;
      const x = o.$getSelection();
      return o.$isRangeSelection(x) ? (E.preventDefault(), A.dispatchCommand(o.DELETE_CHARACTER_COMMAND, !1)) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_ENTER_COMMAND, (E) => {
      const x = o.$getSelection();
      if (!o.$isRangeSelection(x))
        return !1;
      if (E !== null) {
        if ((l || c || d) && s)
          return !1;
        if (E.preventDefault(), E.shiftKey)
          return A.dispatchCommand(o.INSERT_LINE_BREAK_COMMAND, !1);
      }
      return A.dispatchCommand(o.INSERT_PARAGRAPH_COMMAND, void 0);
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.KEY_ESCAPE_COMMAND, () => {
      const E = o.$getSelection();
      return o.$isRangeSelection(E) ? (A.blur(), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.DROP_COMMAND, (E) => {
      const [, x] = q(E);
      if (x.length > 0) {
        const I = E.clientX, z = E.clientY, F = r(I, z);
        if (F !== null) {
          const {
            offset: P,
            node: O
          } = F, V = o.$getNearestNodeFromDOMNode(O);
          if (V !== null) {
            const U = o.$createRangeSelection();
            if (o.$isTextNode(V))
              U.anchor.set(V.getKey(), P, "text"), U.focus.set(V.getKey(), P, "text");
            else {
              const J = V.getParentOrThrow().getKey(), le = V.getIndexWithinParent() + 1;
              U.anchor.set(J, le, "element"), U.focus.set(J, le, "element");
            }
            const H = o.$normalizeSelection__EXPERIMENTAL(U);
            o.$setSelection(H);
          }
          A.dispatchCommand(_, x);
        }
        return E.preventDefault(), !0;
      }
      const k = o.$getSelection();
      return !!o.$isRangeSelection(k);
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.DRAGSTART_COMMAND, (E) => {
      const [x] = q(E), k = o.$getSelection();
      return !(x && !o.$isRangeSelection(k));
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.DRAGOVER_COMMAND, (E) => {
      const [x] = q(E), k = o.$getSelection();
      if (x && !o.$isRangeSelection(k))
        return !1;
      const I = E.clientX, z = E.clientY, F = r(I, z);
      if (F !== null) {
        const P = o.$getNearestNodeFromDOMNode(F.node);
        o.$isDecoratorNode(P) && E.preventDefault();
      }
      return !0;
    }, o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.COPY_COMMAND, (E) => (e.copyToClipboard(A, E instanceof ClipboardEvent ? E : null), !0), o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.CUT_COMMAND, (E) => (M(E, A), !0), o.COMMAND_PRIORITY_EDITOR), A.registerCommand(o.PASTE_COMMAND, (E) => {
      const [, x, k] = q(E);
      if (x.length > 0 && !k)
        return A.dispatchCommand(_, x), !0;
      const I = o.$getSelection();
      return o.$isRangeSelection(I) || o.DEPRECATED_$isGridSelection(I) ? (N(E, A), !0) : !1;
    }, o.COMMAND_PRIORITY_EDITOR));
  }
  return v_.$createHeadingNode = y, v_.$createQuoteNode = g, v_.$isHeadingNode = w, v_.$isQuoteNode = f, v_.DRAG_DROP_PASTE = _, v_.HeadingNode = h, v_.QuoteNode = p, v_.eventFiles = q, v_.registerRichText = D, v_;
}
const GHl = process.env.NODE_ENV === "development" ? UHl() : BHl();
var mf = GHl, mJ;
function WHl() {
  if (mJ)
    return sa;
  mJ = 1;
  var e = lr(), t = iT, n = Hl, o = mf, r = Ci(), i = bl;
  function a(ne, pe) {
    let ge = {};
    for (let ve of ne)
      ne = pe(ve), ge[ne] ? ge[ne].push(ve) : ge[ne] = [ve];
    return ge;
  }
  function s(ne) {
    return ne = a(ne, (pe) => pe.type), { element: ne.element || [], textFormat: ne["text-format"] || [], textMatch: ne["text-match"] || [] };
  }
  let c = /[!-/:-@[-`{-~\s]/;
  function l(ne) {
    let pe = s(ne), ge = pe.textFormat.filter((ve) => ve.format.length === 1);
    return (ve) => {
      let Te = [];
      ve = (ve || e.$getRoot()).getChildren();
      for (let Re of ve)
        ve = u(Re, pe.element, ge, pe.textMatch), ve != null && Te.push(ve);
      return Te.join(`

`);
    };
  }
  function u(ne, pe, ge, ve) {
    for (let Te of pe)
      if (pe = Te.export(ne, (Re) => d(Re, ge, ve)), pe != null)
        return pe;
    return e.$isElementNode(ne) ? d(ne, ge, ve) : e.$isDecoratorNode(ne) ? ne.getTextContent() : null;
  }
  function d(ne, pe, ge) {
    let ve = [];
    ne = ne.getChildren();
    e:
      for (let Te of ne) {
        for (let Re of ge)
          if (ne = Re.export(Te, (Me) => d(Me, pe, ge), (Me, et) => _(Me, et, pe)), ne != null) {
            ve.push(ne);
            continue e;
          }
        e.$isLineBreakNode(Te) ? ve.push(`
`) : e.$isTextNode(Te) ? ve.push(_(Te, Te.getTextContent(), pe)) : e.$isElementNode(Te) ? ve.push(d(Te, pe, ge)) : e.$isDecoratorNode(Te) && ve.push(Te.getTextContent());
      }
    return ve.join("");
  }
  function _(ne, pe, ge) {
    let ve = pe.trim(), Te = ve, Re = /* @__PURE__ */ new Set();
    for (let et of ge) {
      ge = et.format[0];
      let st = et.tag;
      if (g(ne, ge) && !Re.has(ge)) {
        Re.add(ge);
        var Me = p(ne, !0);
        g(Me, ge) || (Te = st + Te), Me = p(ne, !1), g(Me, ge) || (Te += st);
      }
    }
    return pe.replace(ve, Te);
  }
  function p(ne, pe) {
    let ge = pe ? ne.getPreviousSibling() : ne.getNextSibling();
    for (ge || (ne = ne.getParentOrThrow(), ne.isInline() && (ge = pe ? ne.getPreviousSibling() : ne.getNextSibling())); ge; ) {
      if (e.$isElementNode(ge)) {
        if (!ge.isInline())
          break;
        if (ne = pe ? ge.getLastDescendant() : ge.getFirstDescendant(), e.$isTextNode(ne))
          return ne;
        ge = pe ? ge.getPreviousSibling() : ge.getNextSibling();
      }
      if (e.$isTextNode(ge))
        return ge;
      if (!e.$isElementNode(ge))
        break;
    }
    return null;
  }
  function g(ne, pe) {
    return e.$isTextNode(ne) && ne.hasFormat(pe);
  }
  let f = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", h = f && "documentMode" in document ? document.documentMode : null;
  f && "InputEvent" in window && !h && "getTargetRanges" in new window.InputEvent("input");
  let $ = f && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), v = f && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, b = f && /^(?=.*Chrome).*/i.test(navigator.userAgent), y = f && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !b, w = /^\s{0,3}$/, N = /^```(\w{1,10})?\s?$/;
  function M(ne) {
    let pe = s(ne), ge = T(pe.textFormat);
    return (ve, Te) => {
      ve = ve.split(`
`);
      var Re = ve.length;
      Te = Te || e.$getRoot(), Te.clear();
      for (let Xe = 0; Xe < Re; Xe++) {
        var Me = ve[Xe];
        e: {
          var et = ve, st = Xe, De = Te, ze = et[st].match(N);
          if (ze) {
            for (var Pe = st, je = et.length; ++Pe < je; )
              if (et[Pe].match(N)) {
                ze = t.$createCodeNode(ze[1]), et = e.$createTextNode(et.slice(st + 1, Pe).join(`
`)), ze.append(et), De.append(ze), De = [ze, Pe];
                break e;
              }
          }
          De = [null, st];
        }
        let [at, wt] = De;
        if (at != null)
          Xe = wt;
        else {
          De = Me, je = Te;
          var He = pe.element;
          Pe = ge, et = pe.textMatch, st = De.trim(), ze = e.$createTextNode(st), Me = e.$createParagraphNode(), Me.append(ze), je.append(Me);
          for (let { regExp: Je, replace: vt } of He)
            if (je = De.match(Je)) {
              ze.setTextContent(De.slice(je[0].length)), vt(Me, [ze], je, !0);
              break;
            }
          q(ze, Pe, et), Me.isAttached() && 0 < st.length && (De = Me.getPreviousSibling(), e.$isParagraphNode(De) || o.$isQuoteNode(De) || n.$isListNode(De)) && (Pe = De, n.$isListNode(De) && (De = De.getLastDescendant(), Pe = De == null ? null : r.$findMatchingParent(De, n.$isListItemNode)), Pe != null && 0 < Pe.getTextContentSize() && (Pe.splice(Pe.getChildrenSize(), 0, [e.$createLineBreakNode(), ...Me.getChildren()]), Me.remove()));
        }
      }
      ve = Te.getChildren();
      for (let Xe of ve)
        ve = Xe, e.$isParagraphNode(ve) ? (Re = ve.getFirstChild(), ve = Re == null || ve.getChildrenSize() === 1 && e.$isTextNode(Re) && w.test(Re.getTextContent())) : ve = !1, ve && Xe.remove();
    };
  }
  function q(ne, pe, ge) {
    var ve = ne.getTextContent();
    let Te = R(ve, pe);
    if (Te) {
      var Re, Me;
      if (Te[0] === ve)
        var et = ne;
      else {
        ve = Te.index || 0;
        let st = ve + Te[0].length;
        ve === 0 ? [et, Re] = ne.splitText(st) : [Me, et, Re] = ne.splitText(ve, st);
      }
      if (et.setTextContent(Te[2]), ne = pe.transformersByTag[Te[1]])
        for (let st of ne.format)
          et.hasFormat(st) || et.toggleFormat(st);
      et.hasFormat("code") || q(et, pe, ge), Me && q(Me, pe, ge), Re && q(Re, pe, ge);
    } else
      L(ne, ge);
  }
  function L(ne, pe) {
    e:
      for (; ne; ) {
        for (let ge of pe) {
          let ve = ne.getTextContent().match(ge.importRegExp);
          if (!ve)
            continue;
          let Te = ve.index || 0, Re = Te + ve[0].length, Me, et, st;
          Te === 0 ? [Me, ne] = ne.splitText(Re) : [et, Me, st] = ne.splitText(Te, Re), et && L(et, pe), st && (ne = st), ge.replace(Me, ve);
          continue e;
        }
        break;
      }
  }
  function R(ne, pe) {
    var ge = ne.match(pe.openTagsRegExp);
    if (ge == null)
      return null;
    for (let Re of ge) {
      var ve = Re.replace(/^\s/, "");
      if (ge = pe.fullMatchRegExpByTag[ve], ge != null && (ge = ne.match(ge), ve = pe.transformersByTag[ve], ge != null && ve != null)) {
        if (ve.intraword !== !1)
          return ge;
        var { index: Te = 0 } = ge;
        if (ve = ne[Te - 1], Te = ne[Te + ge[0].length], !(ve && !c.test(ve) || Te && !c.test(Te)))
          return ge;
      }
    }
    return null;
  }
  function T(ne) {
    let pe = {}, ge = {}, ve = [];
    for (let Te of ne) {
      ({ tag: ne } = Te), pe[ne] = Te;
      let Re = ne.replace(/(\*|\^|\+)/g, "\\$1");
      ve.push(Re), ge[ne] = $ || v || y ? new RegExp(`(${Re})(?![${Re}\\s])(.*?[^${Re}\\s])${Re}(?!${Re})`) : new RegExp(`(?<![\\\\${Re}])(${Re})((\\\\${Re})?.*?[^${Re}\\s](\\\\${Re})?)((?<!\\\\)|(?<=\\\\\\\\))(${Re})(?![\\\\${Re}])`);
    }
    return { fullMatchRegExpByTag: ge, openTagsRegExp: new RegExp(($ || v || y ? "" : "(?<![\\\\])") + "(" + ve.join("|") + ")", "g"), transformersByTag: pe };
  }
  function D(ne, pe, ge) {
    let ve = ge.length;
    for (; pe >= ve; pe--) {
      let Te = pe - ve;
      if (A(ne, Te, ge, 0, ve) && ne[Te + ve] !== " ")
        return Te;
    }
    return -1;
  }
  function A(ne, pe, ge, ve, Te) {
    for (let Re = 0; Re < Te; Re++)
      if (ne[pe + Re] !== ge[ve + Re])
        return !1;
    return !0;
  }
  let S = (ne) => (pe, ge, ve) => {
    ve = ne(ve), ve.append(...ge), pe.replace(ve), ve.select(0, 0);
  }, E = (ne) => (pe, ge, ve) => {
    var Te = pe.getPreviousSibling();
    const Re = n.$createListItemNode(ne === "check" ? ve[3] === "x" : void 0);
    n.$isListNode(Te) && Te.getListType() === ne ? (Te.append(Re), pe.remove()) : (Te = n.$createListNode(ne, ne === "number" ? Number(ve[2]) : void 0), Te.append(Re), pe.replace(Te)), Re.append(...ge), Re.select(0, 0), (pe = Math.floor(ve[1].length / 4)) && Re.setIndent(pe);
  }, x = (ne, pe, ge) => {
    const ve = [];
    var Te = ne.getChildren();
    let Re = 0;
    for (const et of Te)
      if (n.$isListItemNode(et)) {
        if (et.getChildrenSize() === 1 && (Te = et.getFirstChild(), n.$isListNode(Te))) {
          ve.push(x(Te, pe, ge + 1));
          continue;
        }
        Te = " ".repeat(4 * ge);
        var Me = ne.getListType();
        Me = Me === "number" ? `${ne.getStart() + Re}. ` : Me === "check" ? `- [${et.getChecked() ? "x" : " "}] ` : "- ", ve.push(Te + Me + pe(et)), Re++;
      }
    return ve.join(`
`);
  }, k = { dependencies: [o.HeadingNode], export: (ne, pe) => {
    if (!o.$isHeadingNode(ne))
      return null;
    const ge = Number(ne.getTag().slice(1));
    return "#".repeat(ge) + " " + pe(ne);
  }, regExp: /^(#{1,6})\s/, replace: S((ne) => o.$createHeadingNode("h" + ne[1].length)), type: "element" }, I = {
    dependencies: [o.QuoteNode],
    export: (ne, pe) => {
      if (!o.$isQuoteNode(ne))
        return null;
      ne = pe(ne).split(`
`), pe = [];
      for (const ge of ne)
        pe.push("> " + ge);
      return pe.join(`
`);
    },
    regExp: /^>\s/,
    replace: (ne, pe, ge, ve) => {
      if (ve && (ge = ne.getPreviousSibling(), o.$isQuoteNode(ge))) {
        ge.splice(ge.getChildrenSize(), 0, [e.$createLineBreakNode(), ...pe]), ge.select(0, 0), ne.remove();
        return;
      }
      ge = o.$createQuoteNode(), ge.append(...pe), ne.replace(ge), ge.select(0, 0);
    },
    type: "element"
  }, z = { dependencies: [t.CodeNode], export: (ne) => {
    if (!t.$isCodeNode(ne))
      return null;
    const pe = ne.getTextContent();
    return "```" + (ne.getLanguage() || "") + (pe ? `
` + pe : "") + "\n```";
  }, regExp: /^```(\w{1,10})?\s/, replace: S((ne) => t.$createCodeNode(ne ? ne[1] : void 0)), type: "element" }, F = { dependencies: [n.ListNode, n.ListItemNode], export: (ne, pe) => n.$isListNode(ne) ? x(ne, pe, 0) : null, regExp: /^(\s*)[-*+]\s/, replace: E("bullet"), type: "element" }, P = { dependencies: [n.ListNode, n.ListItemNode], export: (ne, pe) => n.$isListNode(ne) ? x(ne, pe, 0) : null, regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i, replace: E("check"), type: "element" }, O = { dependencies: [n.ListNode, n.ListItemNode], export: (ne, pe) => n.$isListNode(ne) ? x(ne, pe, 0) : null, regExp: /^(\s*)(\d{1,})\.\s/, replace: E("number"), type: "element" }, V = { format: ["code"], tag: "`", type: "text-format" }, U = { format: ["highlight"], tag: "==", type: "text-format" }, H = { format: ["bold", "italic"], tag: "***", type: "text-format" }, J = { format: ["bold", "italic"], intraword: !1, tag: "___", type: "text-format" }, le = { format: ["bold"], tag: "**", type: "text-format" }, ae = { format: ["bold"], intraword: !1, tag: "__", type: "text-format" }, Y = { format: ["strikethrough"], tag: "~~", type: "text-format" }, re = { format: ["italic"], tag: "*", type: "text-format" }, ie = { format: ["italic"], intraword: !1, tag: "_", type: "text-format" }, _e = { dependencies: [i.LinkNode], export: (ne, pe, ge) => {
    if (!i.$isLinkNode(ne))
      return null;
    pe = `[${ne.getTextContent()}](${ne.getURL()})`;
    const ve = ne.getFirstChild();
    return ne.getChildrenSize() === 1 && e.$isTextNode(ve) ? ge(ve, pe) : pe;
  }, importRegExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))/, regExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))$/, replace: (ne, pe) => {
    const [, ge, ve] = pe;
    pe = i.$createLinkNode(ve);
    const Te = e.$createTextNode(ge);
    Te.setFormat(ne.getFormat()), pe.append(Te), ne.replace(pe);
  }, trigger: ")", type: "text-match" }, he = [k, I, z, F, O], be = [V, H, J, le, ae, U, re, ie, Y], Q = [_e], me = [...he, ...be, ...Q];
  return sa.$convertFromMarkdownString = function(ne, pe = me, ge) {
    return M(pe)(ne, ge);
  }, sa.$convertToMarkdownString = function(ne = me, pe) {
    return l(ne)(pe);
  }, sa.BOLD_ITALIC_STAR = H, sa.BOLD_ITALIC_UNDERSCORE = J, sa.BOLD_STAR = le, sa.BOLD_UNDERSCORE = ae, sa.CHECK_LIST = P, sa.CODE = z, sa.ELEMENT_TRANSFORMERS = he, sa.HEADING = k, sa.HIGHLIGHT = U, sa.INLINE_CODE = V, sa.ITALIC_STAR = re, sa.ITALIC_UNDERSCORE = ie, sa.LINK = _e, sa.ORDERED_LIST = O, sa.QUOTE = I, sa.STRIKETHROUGH = Y, sa.TEXT_FORMAT_TRANSFORMERS = be, sa.TEXT_MATCH_TRANSFORMERS = Q, sa.TRANSFORMERS = me, sa.UNORDERED_LIST = F, sa.registerMarkdownShortcuts = function(ne, pe = me) {
    let ge = s(pe), ve = a(ge.textFormat, ({ tag: Re }) => Re[Re.length - 1]), Te = a(ge.textMatch, ({ trigger: Re }) => Re);
    for (let Re of pe)
      if (pe = Re.type, (pe === "element" || pe === "text-match") && !ne.hasNodes(Re.dependencies))
        throw Error("Minified Lexical error #79; visit https://lexical.dev/docs/error?code=79 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
    return ne.registerUpdateListener(({ tags: Re, dirtyLeaves: Me, editorState: et, prevEditorState: st }) => {
      if (!Re.has("historic")) {
        var De = et.read(e.$getSelection);
        if (Re = st.read(e.$getSelection), e.$isRangeSelection(Re) && e.$isRangeSelection(De) && De.isCollapsed()) {
          st = De.anchor.key;
          var ze = De.anchor.offset, Pe = et._nodeMap.get(st);
          e.$isTextNode(Pe) && Me.has(st) && (ze === 1 || ze === Re.anchor.offset + 1) && ne.update(() => {
            if (!Pe.hasFormat("code")) {
              var je = Pe.getParent();
              if (je !== null && !t.$isCodeNode(je)) {
                var He = De.anchor.offset;
                e: {
                  var Xe = ge.element, at = je.getParent();
                  if (e.$isRootOrShadowRoot(at) && je.getFirstChild() === Pe && (at = Pe.getTextContent(), at[He - 1] === " ")) {
                    for (let {
                      regExp: wn,
                      replace: un
                    } of Xe)
                      if ((Xe = at.match(wn)) && Xe[0].length === He) {
                        at = Pe.getNextSiblings();
                        let [pn, Dn] = Pe.splitText(He);
                        pn.remove(), at = Dn ? [Dn, ...at] : at, un(je, at, Xe, !1), je = !0;
                        break e;
                      }
                  }
                  je = !1;
                }
                if (!je) {
                  e: {
                    if (Xe = Pe.getTextContent(), je = Te[Xe[He - 1]], je != null) {
                      He < Xe.length && (Xe = Xe.slice(0, He));
                      for (Je of je)
                        if (je = Xe.match(Je.regExp), je !== null) {
                          Xe = je.index || 0, at = Xe + je[0].length;
                          var wt = void 0;
                          Xe === 0 ? [wt] = Pe.splitText(at) : [, wt] = Pe.splitText(Xe, at), wt.selectNext(0, 0), Je.replace(wt, je);
                          var Je = !0;
                          break e;
                        }
                    }
                    Je = !1;
                  }
                  if (!Je)
                    e: {
                      at = Pe.getTextContent(), --He;
                      var vt = at[He];
                      if (Je = ve[vt])
                        for (let wn of Je) {
                          var { tag: Ot } = wn;
                          Je = Ot.length;
                          let un = He - Je + 1;
                          if (!(1 < Je && !A(at, un, Ot, 0, Je) || at[un - 1] === " ") && (wt = at[He + 1], wn.intraword !== !1 || !wt || c.test(wt))) {
                            je = wt = Pe, Xe = D(at, un, Ot);
                            for (var Ft = je; 0 > Xe && (Ft = Ft.getPreviousSibling()) && !e.$isLineBreakNode(Ft); )
                              e.$isTextNode(Ft) && (Xe = Ft.getTextContent(), je = Ft, Xe = D(Xe, Xe.length, Ot));
                            if (!(0 > Xe || je === wt && Xe + Je === un || (Ot = je.getTextContent(), 0 < Xe && Ot[Xe - 1] === vt || (Ft = Ot[Xe - 1], wn.intraword === !1 && Ft && !c.test(Ft))))) {
                              at = wt.getTextContent(), at = at.slice(0, un) + at.slice(He + 1), wt.setTextContent(at), at = je === wt ? at : Ot, je.setTextContent(at.slice(0, Xe) + at.slice(Xe + Je)), at = e.$getSelection(), vt = e.$createRangeSelection(), e.$setSelection(vt), He = He - Je * (je === wt ? 2 : 1) + 1, vt.anchor.set(je.__key, Xe, "text"), vt.focus.set(wt.__key, He, "text");
                              for (let pn of wn.format)
                                vt.hasFormat(pn) || vt.formatText(pn);
                              vt.anchor.set(vt.focus.key, vt.focus.offset, vt.focus.type);
                              for (let pn of wn.format)
                                vt.hasFormat(pn) && vt.toggleFormat(pn);
                              e.$isRangeSelection(at) && (vt.format = at.format);
                              break e;
                            }
                          }
                        }
                    }
                }
              }
            }
          });
        }
      }
    });
  }, sa;
}
var ca = {}, fJ;
function HHl() {
  if (fJ)
    return ca;
  fJ = 1;
  var e = lr(), t = iT, n = Hl, o = mf, r = Ci(), i = bl;
  function a(ze, Pe) {
    const je = {};
    for (const He of ze) {
      const Xe = Pe(He);
      je[Xe] ? je[Xe].push(He) : je[Xe] = [He];
    }
    return je;
  }
  function s(ze) {
    const Pe = a(ze, (je) => je.type);
    return {
      element: Pe.element || [],
      textFormat: Pe["text-format"] || [],
      textMatch: Pe["text-match"] || []
    };
  }
  const c = /[!-/:-@[-`{-~\s]/;
  function l(ze) {
    const Pe = s(ze), je = Pe.textFormat.filter((He) => He.format.length === 1);
    return (He) => {
      const Xe = [], at = (He || e.$getRoot()).getChildren();
      for (const wt of at) {
        const Je = u(wt, Pe.element, je, Pe.textMatch);
        Je != null && Xe.push(Je);
      }
      return Xe.join(`

`);
    };
  }
  function u(ze, Pe, je, He) {
    for (const Xe of Pe) {
      const at = Xe.export(ze, (wt) => d(wt, je, He));
      if (at != null)
        return at;
    }
    return e.$isElementNode(ze) ? d(ze, je, He) : e.$isDecoratorNode(ze) ? ze.getTextContent() : null;
  }
  function d(ze, Pe, je) {
    const He = [], Xe = ze.getChildren();
    e:
      for (const at of Xe) {
        for (const wt of je) {
          const Je = wt.export(at, (vt) => d(vt, Pe, je), (vt, Ot) => _(vt, Ot, Pe));
          if (Je != null) {
            He.push(Je);
            continue e;
          }
        }
        e.$isLineBreakNode(at) ? He.push(`
`) : e.$isTextNode(at) ? He.push(_(at, at.getTextContent(), Pe)) : e.$isElementNode(at) ? He.push(d(at, Pe, je)) : e.$isDecoratorNode(at) && He.push(at.getTextContent());
      }
    return He.join("");
  }
  function _(ze, Pe, je) {
    const He = Pe.trim();
    let Xe = He;
    const at = /* @__PURE__ */ new Set();
    for (const wt of je) {
      const Je = wt.format[0], vt = wt.tag;
      if (g(ze, Je) && !at.has(Je)) {
        at.add(Je);
        const Ot = p(ze, !0);
        g(Ot, Je) || (Xe = vt + Xe);
        const Ft = p(ze, !1);
        g(Ft, Je) || (Xe += vt);
      }
    }
    return Pe.replace(He, Xe);
  }
  function p(ze, Pe) {
    let je = Pe ? ze.getPreviousSibling() : ze.getNextSibling();
    if (!je) {
      const He = ze.getParentOrThrow();
      He.isInline() && (je = Pe ? He.getPreviousSibling() : He.getNextSibling());
    }
    for (; je; ) {
      if (e.$isElementNode(je)) {
        if (!je.isInline())
          break;
        const He = Pe ? je.getLastDescendant() : je.getFirstDescendant();
        if (e.$isTextNode(He))
          return He;
        je = Pe ? je.getPreviousSibling() : je.getNextSibling();
      }
      if (e.$isTextNode(je))
        return je;
      if (!e.$isElementNode(je))
        return null;
    }
    return null;
  }
  function g(ze, Pe) {
    return e.$isTextNode(ze) && ze.hasFormat(Pe);
  }
  const f = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", h = f && "documentMode" in document ? document.documentMode : null;
  f && "InputEvent" in window && !h && "getTargetRanges" in new window.InputEvent("input");
  const $ = f && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), v = f && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, b = f && /^(?=.*Chrome).*/i.test(navigator.userAgent), y = f && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !b, w = /^\s{0,3}$/, N = /^```(\w{1,10})?\s?$/;
  function M(ze) {
    const Pe = s(ze), je = S(Pe.textFormat);
    return (He, Xe) => {
      const at = He.split(`
`), wt = at.length, Je = Xe || e.$getRoot();
      Je.clear();
      for (let Ot = 0; Ot < wt; Ot++) {
        const Ft = at[Ot], [wn, un] = R(at, Ot, Je);
        if (wn != null) {
          Ot = un;
          continue;
        }
        L(Ft, Je, Pe.element, je, Pe.textMatch);
      }
      const vt = Je.getChildren();
      for (const Ot of vt)
        q(Ot) && Ot.remove();
    };
  }
  function q(ze) {
    if (!e.$isParagraphNode(ze))
      return !1;
    const Pe = ze.getFirstChild();
    return Pe == null || ze.getChildrenSize() === 1 && e.$isTextNode(Pe) && w.test(Pe.getTextContent());
  }
  function L(ze, Pe, je, He, Xe) {
    const at = ze.trim(), wt = e.$createTextNode(at), Je = e.$createParagraphNode();
    Je.append(wt), Pe.append(Je);
    for (const {
      regExp: vt,
      replace: Ot
    } of je) {
      const Ft = ze.match(vt);
      if (Ft) {
        wt.setTextContent(ze.slice(Ft[0].length)), Ot(Je, [wt], Ft, !0);
        break;
      }
    }
    if (T(wt, He, Xe), Je.isAttached() && at.length > 0) {
      const vt = Je.getPreviousSibling();
      if (e.$isParagraphNode(vt) || o.$isQuoteNode(vt) || n.$isListNode(vt)) {
        let Ot = vt;
        if (n.$isListNode(vt)) {
          const Ft = vt.getLastDescendant();
          Ft == null ? Ot = null : Ot = r.$findMatchingParent(Ft, n.$isListItemNode);
        }
        Ot != null && Ot.getTextContentSize() > 0 && (Ot.splice(Ot.getChildrenSize(), 0, [e.$createLineBreakNode(), ...Je.getChildren()]), Je.remove());
      }
    }
  }
  function R(ze, Pe, je) {
    const He = ze[Pe].match(N);
    if (He) {
      let Xe = Pe;
      const at = ze.length;
      for (; ++Xe < at; )
        if (ze[Xe].match(N)) {
          const Je = t.$createCodeNode(He[1]), vt = e.$createTextNode(ze.slice(Pe + 1, Xe).join(`
`));
          return Je.append(vt), je.append(Je), [Je, Xe];
        }
    }
    return [null, Pe];
  }
  function T(ze, Pe, je) {
    const He = ze.getTextContent(), Xe = A(He, Pe);
    if (!Xe) {
      D(ze, je);
      return;
    }
    let at, wt, Je;
    if (Xe[0] === He)
      at = ze;
    else {
      const Ot = Xe.index || 0, Ft = Ot + Xe[0].length;
      Ot === 0 ? [at, wt] = ze.splitText(Ft) : [Je, at, wt] = ze.splitText(Ot, Ft);
    }
    at.setTextContent(Xe[2]);
    const vt = Pe.transformersByTag[Xe[1]];
    if (vt)
      for (const Ot of vt.format)
        at.hasFormat(Ot) || at.toggleFormat(Ot);
    at.hasFormat("code") || T(at, Pe, je), Je && T(Je, Pe, je), wt && T(wt, Pe, je);
  }
  function D(ze, Pe) {
    let je = ze;
    e:
      for (; je; ) {
        for (const He of Pe) {
          const Xe = je.getTextContent().match(He.importRegExp);
          if (!Xe)
            continue;
          const at = Xe.index || 0, wt = at + Xe[0].length;
          let Je, vt, Ot;
          at === 0 ? [Je, je] = je.splitText(wt) : [vt, Je, Ot] = je.splitText(at, wt), vt && D(vt, Pe), Ot && (je = Ot), He.replace(Je, Xe);
          continue e;
        }
        break;
      }
  }
  function A(ze, Pe) {
    const je = ze.match(Pe.openTagsRegExp);
    if (je == null)
      return null;
    for (const He of je) {
      const Xe = He.replace(/^\s/, ""), at = Pe.fullMatchRegExpByTag[Xe];
      if (at == null)
        continue;
      const wt = ze.match(at), Je = Pe.transformersByTag[Xe];
      if (wt != null && Je != null) {
        if (Je.intraword !== !1)
          return wt;
        const {
          index: vt = 0
        } = wt, Ot = ze[vt - 1], Ft = ze[vt + wt[0].length];
        if ((!Ot || c.test(Ot)) && (!Ft || c.test(Ft)))
          return wt;
      }
    }
    return null;
  }
  function S(ze) {
    const Pe = {}, je = {}, He = [], Xe = "(?<![\\\\])";
    for (const at of ze) {
      const {
        tag: wt
      } = at;
      Pe[wt] = at;
      const Je = wt.replace(/(\*|\^|\+)/g, "\\$1");
      He.push(Je), $ || v || y ? je[wt] = new RegExp(`(${Je})(?![${Je}\\s])(.*?[^${Je}\\s])${Je}(?!${Je})`) : je[wt] = new RegExp(`(?<![\\\\${Je}])(${Je})((\\\\${Je})?.*?[^${Je}\\s](\\\\${Je})?)((?<!\\\\)|(?<=\\\\\\\\))(${Je})(?![\\\\${Je}])`);
    }
    return {
      // Reg exp to find open tag + content + close tag
      fullMatchRegExpByTag: je,
      // Reg exp to find opening tags
      openTagsRegExp: new RegExp(($ || v || y ? "" : `${Xe}`) + "(" + He.join("|") + ")", "g"),
      transformersByTag: Pe
    };
  }
  function E(ze, Pe, je, He) {
    const Xe = ze.getParent();
    if (!e.$isRootOrShadowRoot(Xe) || ze.getFirstChild() !== Pe)
      return !1;
    const at = Pe.getTextContent();
    if (at[je - 1] !== " ")
      return !1;
    for (const {
      regExp: wt,
      replace: Je
    } of He) {
      const vt = at.match(wt);
      if (vt && vt[0].length === je) {
        const Ot = Pe.getNextSiblings(), [Ft, wn] = Pe.splitText(je);
        Ft.remove();
        const un = wn ? [wn, ...Ot] : Ot;
        return Je(ze, un, vt, !1), !0;
      }
    }
    return !1;
  }
  function x(ze, Pe, je) {
    let He = ze.getTextContent();
    const Xe = He[Pe - 1], at = je[Xe];
    if (at == null)
      return !1;
    Pe < He.length && (He = He.slice(0, Pe));
    for (const wt of at) {
      const Je = He.match(wt.regExp);
      if (Je === null)
        continue;
      const vt = Je.index || 0, Ot = vt + Je[0].length;
      let Ft;
      return vt === 0 ? [Ft] = ze.splitText(Ot) : [, Ft] = ze.splitText(vt, Ot), Ft.selectNext(0, 0), wt.replace(Ft, Je), !0;
    }
    return !1;
  }
  function k(ze, Pe, je) {
    const He = ze.getTextContent(), Xe = Pe - 1, at = He[Xe], wt = je[at];
    if (!wt)
      return !1;
    for (const Je of wt) {
      const {
        tag: vt
      } = Je, Ot = vt.length, Ft = Xe - Ot + 1;
      if (Ot > 1 && !z(He, Ft, vt, 0, Ot) || He[Ft - 1] === " ")
        continue;
      const wn = He[Xe + 1];
      if (Je.intraword === !1 && wn && !c.test(wn))
        continue;
      const un = ze;
      let pn = un, Dn = I(He, Ft, vt), Rn = pn;
      for (; Dn < 0 && (Rn = Rn.getPreviousSibling()) && !e.$isLineBreakNode(Rn); )
        if (e.$isTextNode(Rn)) {
          const $n = Rn.getTextContent();
          pn = Rn, Dn = I($n, $n.length, vt);
        }
      if (Dn < 0 || pn === un && Dn + Ot === Ft)
        continue;
      const Ln = pn.getTextContent();
      if (Dn > 0 && Ln[Dn - 1] === at)
        continue;
      const Yn = Ln[Dn - 1];
      if (Je.intraword === !1 && Yn && !c.test(Yn))
        continue;
      const Qt = un.getTextContent(), fn = Qt.slice(0, Ft) + Qt.slice(Xe + 1);
      un.setTextContent(fn);
      const qn = pn === un ? fn : Ln;
      pn.setTextContent(qn.slice(0, Dn) + qn.slice(Dn + Ot));
      const Xn = e.$getSelection(), Qn = e.$createRangeSelection();
      e.$setSelection(Qn);
      const In = Xe - Ot * (pn === un ? 2 : 1) + 1;
      Qn.anchor.set(pn.__key, Dn, "text"), Qn.focus.set(un.__key, In, "text");
      for (const $n of Je.format)
        Qn.hasFormat($n) || Qn.formatText($n);
      Qn.anchor.set(Qn.focus.key, Qn.focus.offset, Qn.focus.type);
      for (const $n of Je.format)
        Qn.hasFormat($n) && Qn.toggleFormat($n);
      return e.$isRangeSelection(Xn) && (Qn.format = Xn.format), !0;
    }
    return !1;
  }
  function I(ze, Pe, je) {
    const He = je.length;
    for (let Xe = Pe; Xe >= He; Xe--) {
      const at = Xe - He;
      if (z(ze, at, je, 0, He) && // Space after opening tag cancels transformation
      ze[at + He] !== " ")
        return at;
    }
    return -1;
  }
  function z(ze, Pe, je, He, Xe) {
    for (let at = 0; at < Xe; at++)
      if (ze[Pe + at] !== je[He + at])
        return !1;
    return !0;
  }
  function F(ze, Pe = et) {
    const je = s(Pe), He = a(je.textFormat, ({
      tag: wt
    }) => wt[wt.length - 1]), Xe = a(je.textMatch, ({
      trigger: wt
    }) => wt);
    for (const wt of Pe) {
      const Je = wt.type;
      if (Je === "element" || Je === "text-match") {
        const vt = wt.dependencies;
        if (!ze.hasNodes(vt))
          throw Error("MarkdownShortcuts: missing dependency for transformer. Ensure node dependency is included in editor initial config.");
      }
    }
    const at = (wt, Je, vt) => {
      E(wt, Je, vt, je.element) || x(Je, vt, Xe) || k(Je, vt, He);
    };
    return ze.registerUpdateListener(({
      tags: wt,
      dirtyLeaves: Je,
      editorState: vt,
      prevEditorState: Ot
    }) => {
      if (wt.has("historic"))
        return;
      const Ft = vt.read(e.$getSelection), wn = Ot.read(e.$getSelection);
      if (!e.$isRangeSelection(wn) || !e.$isRangeSelection(Ft) || !Ft.isCollapsed())
        return;
      const un = Ft.anchor.key, pn = Ft.anchor.offset, Dn = vt._nodeMap.get(un);
      !e.$isTextNode(Dn) || !Je.has(un) || pn !== 1 && pn !== wn.anchor.offset + 1 || ze.update(() => {
        if (Dn.hasFormat("code"))
          return;
        const Rn = Dn.getParent();
        Rn === null || t.$isCodeNode(Rn) || at(Rn, Dn, Ft.anchor.offset);
      });
    });
  }
  const P = (ze) => (Pe, je, He) => {
    const Xe = ze(He);
    Xe.append(...je), Pe.replace(Xe), Xe.select(0, 0);
  }, O = 4, V = (ze) => (Pe, je, He) => {
    const Xe = Pe.getPreviousSibling(), at = n.$createListItemNode(ze === "check" ? He[3] === "x" : void 0);
    if (n.$isListNode(Xe) && Xe.getListType() === ze)
      Xe.append(at), Pe.remove();
    else {
      const Je = n.$createListNode(ze, ze === "number" ? Number(He[2]) : void 0);
      Je.append(at), Pe.replace(Je);
    }
    at.append(...je), at.select(0, 0);
    const wt = Math.floor(He[1].length / O);
    wt && at.setIndent(wt);
  }, U = (ze, Pe, je) => {
    const He = [], Xe = ze.getChildren();
    let at = 0;
    for (const wt of Xe)
      if (n.$isListItemNode(wt)) {
        if (wt.getChildrenSize() === 1) {
          const Ft = wt.getFirstChild();
          if (n.$isListNode(Ft)) {
            He.push(U(Ft, Pe, je + 1));
            continue;
          }
        }
        const Je = " ".repeat(je * O), vt = ze.getListType(), Ot = vt === "number" ? `${ze.getStart() + at}. ` : vt === "check" ? `- [${wt.getChecked() ? "x" : " "}] ` : "- ";
        He.push(Je + Ot + Pe(wt)), at++;
      }
    return He.join(`
`);
  }, H = {
    dependencies: [o.HeadingNode],
    export: (ze, Pe) => {
      if (!o.$isHeadingNode(ze))
        return null;
      const je = Number(ze.getTag().slice(1));
      return "#".repeat(je) + " " + Pe(ze);
    },
    regExp: /^(#{1,6})\s/,
    replace: P((ze) => {
      const Pe = "h" + ze[1].length;
      return o.$createHeadingNode(Pe);
    }),
    type: "element"
  }, J = {
    dependencies: [o.QuoteNode],
    export: (ze, Pe) => {
      if (!o.$isQuoteNode(ze))
        return null;
      const je = Pe(ze).split(`
`), He = [];
      for (const Xe of je)
        He.push("> " + Xe);
      return He.join(`
`);
    },
    regExp: /^>\s/,
    replace: (ze, Pe, je, He) => {
      if (He) {
        const at = ze.getPreviousSibling();
        if (o.$isQuoteNode(at)) {
          at.splice(at.getChildrenSize(), 0, [e.$createLineBreakNode(), ...Pe]), at.select(0, 0), ze.remove();
          return;
        }
      }
      const Xe = o.$createQuoteNode();
      Xe.append(...Pe), ze.replace(Xe), Xe.select(0, 0);
    },
    type: "element"
  }, le = {
    dependencies: [t.CodeNode],
    export: (ze) => {
      if (!t.$isCodeNode(ze))
        return null;
      const Pe = ze.getTextContent();
      return "```" + (ze.getLanguage() || "") + (Pe ? `
` + Pe : "") + "\n```";
    },
    regExp: /^```(\w{1,10})?\s/,
    replace: P((ze) => t.$createCodeNode(ze ? ze[1] : void 0)),
    type: "element"
  }, ae = {
    dependencies: [n.ListNode, n.ListItemNode],
    export: (ze, Pe) => n.$isListNode(ze) ? U(ze, Pe, 0) : null,
    regExp: /^(\s*)[-*+]\s/,
    replace: V("bullet"),
    type: "element"
  }, Y = {
    dependencies: [n.ListNode, n.ListItemNode],
    export: (ze, Pe) => n.$isListNode(ze) ? U(ze, Pe, 0) : null,
    regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i,
    replace: V("check"),
    type: "element"
  }, re = {
    dependencies: [n.ListNode, n.ListItemNode],
    export: (ze, Pe) => n.$isListNode(ze) ? U(ze, Pe, 0) : null,
    regExp: /^(\s*)(\d{1,})\.\s/,
    replace: V("number"),
    type: "element"
  }, ie = {
    format: ["code"],
    tag: "`",
    type: "text-format"
  }, _e = {
    format: ["highlight"],
    tag: "==",
    type: "text-format"
  }, he = {
    format: ["bold", "italic"],
    tag: "***",
    type: "text-format"
  }, be = {
    format: ["bold", "italic"],
    intraword: !1,
    tag: "___",
    type: "text-format"
  }, Q = {
    format: ["bold"],
    tag: "**",
    type: "text-format"
  }, me = {
    format: ["bold"],
    intraword: !1,
    tag: "__",
    type: "text-format"
  }, ne = {
    format: ["strikethrough"],
    tag: "~~",
    type: "text-format"
  }, pe = {
    format: ["italic"],
    tag: "*",
    type: "text-format"
  }, ge = {
    format: ["italic"],
    intraword: !1,
    tag: "_",
    type: "text-format"
  }, ve = {
    dependencies: [i.LinkNode],
    export: (ze, Pe, je) => {
      if (!i.$isLinkNode(ze))
        return null;
      const He = `[${ze.getTextContent()}](${ze.getURL()})`, Xe = ze.getFirstChild();
      return ze.getChildrenSize() === 1 && e.$isTextNode(Xe) ? je(Xe, He) : He;
    },
    importRegExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))/,
    regExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))$/,
    replace: (ze, Pe) => {
      const [, je, He] = Pe, Xe = i.$createLinkNode(He), at = e.$createTextNode(je);
      at.setFormat(ze.getFormat()), Xe.append(at), ze.replace(Xe);
    },
    trigger: ")",
    type: "text-match"
  }, Te = [H, J, le, ae, re], Re = [ie, he, be, Q, me, _e, pe, ge, ne], Me = [ve], et = [...Te, ...Re, ...Me];
  function st(ze, Pe = et, je) {
    return M(Pe)(ze, je);
  }
  function De(ze = et, Pe) {
    return l(ze)(Pe);
  }
  return ca.$convertFromMarkdownString = st, ca.$convertToMarkdownString = De, ca.BOLD_ITALIC_STAR = he, ca.BOLD_ITALIC_UNDERSCORE = be, ca.BOLD_STAR = Q, ca.BOLD_UNDERSCORE = me, ca.CHECK_LIST = Y, ca.CODE = le, ca.ELEMENT_TRANSFORMERS = Te, ca.HEADING = H, ca.HIGHLIGHT = _e, ca.INLINE_CODE = ie, ca.ITALIC_STAR = pe, ca.ITALIC_UNDERSCORE = ge, ca.LINK = ve, ca.ORDERED_LIST = re, ca.QUOTE = J, ca.STRIKETHROUGH = ne, ca.TEXT_FORMAT_TRANSFORMERS = Re, ca.TEXT_MATCH_TRANSFORMERS = Me, ca.TRANSFORMERS = et, ca.UNORDERED_LIST = ae, ca.registerMarkdownShortcuts = F, ca;
}
const YHl = process.env.NODE_ENV === "development" ? HHl() : WHl();
var aT = YHl, DR = {}, dw = {}, gJ;
function KHl() {
  if (gJ)
    return dw;
  gJ = 1;
  var e = Fe;
  let t = e.createContext(null);
  return dw.LexicalComposerContext = t, dw.createLexicalComposerContext = function(n, o) {
    let r = null;
    return n != null && (r = n[1]), { getTheme: function() {
      return o ?? (r != null ? r.getTheme() : null);
    } };
  }, dw.useLexicalComposerContext = function() {
    let n = e.useContext(t);
    if (n == null)
      throw Error("Minified Lexical error #8; visit https://lexical.dev/docs/error?code=8 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
    return n;
  }, dw;
}
var _w = {}, hJ;
function ZHl() {
  if (hJ)
    return _w;
  hJ = 1;
  var e = Fe;
  const t = /* @__PURE__ */ e.createContext(null);
  function n(r, i) {
    let a = null;
    r != null && (a = r[1]);
    function s() {
      return i ?? (a != null ? a.getTheme() : null);
    }
    return {
      getTheme: s
    };
  }
  function o() {
    const r = e.useContext(t);
    if (r == null)
      throw Error("LexicalComposerContext.useLexicalComposerContext: cannot find a LexicalComposerContext");
    return r;
  }
  return _w.LexicalComposerContext = t, _w.createLexicalComposerContext = n, _w.useLexicalComposerContext = o, _w;
}
var LR, vJ;
function _a() {
  return vJ || (vJ = 1, LR = process.env.NODE_ENV === "development" ? ZHl() : KHl()), LR;
}
var bJ;
function XHl() {
  if (bJ)
    return DR;
  bJ = 1;
  var e = _a(), t = lr(), n = Fe;
  let o = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  var r = o ? n.useLayoutEffect : n.useEffect;
  let i = { tag: "history-merge" };
  function a(s, c) {
    if (c !== null) {
      if (c === void 0)
        s.update(() => {
          var l = t.$getRoot();
          if (l.isEmpty()) {
            let u = t.$createParagraphNode();
            l.append(u), l = o ? document.activeElement : null, (t.$getSelection() !== null || l !== null && l === s.getRootElement()) && u.select();
          }
        }, i);
      else if (c !== null)
        switch (typeof c) {
          case "string":
            let l = s.parseEditorState(c);
            s.setEditorState(l, i);
            break;
          case "object":
            s.setEditorState(c, i);
            break;
          case "function":
            s.update(() => {
              t.$getRoot().isEmpty() && c(s);
            }, i);
        }
    }
  }
  return DR.LexicalComposer = function({ initialConfig: s, children: c }) {
    let l = n.useMemo(() => {
      const { theme: u, namespace: d, editor__DEPRECATED: _, nodes: p, onError: g, editorState: f } = s, h = e.createLexicalComposerContext(null, u);
      let $ = _ || null;
      if ($ === null) {
        const v = t.createEditor({ editable: !1, namespace: d, nodes: p, onError: (b) => g(b, v), theme: u });
        a(v, f), $ = v;
      }
      return [$, h];
    }, []);
    return r(() => {
      let u = s.editable, [d] = l;
      d.setEditable(u !== void 0 ? u : !0);
    }, []), n.createElement(e.LexicalComposerContext.Provider, { value: l }, c);
  }, DR;
}
var MR = {}, yJ;
function JHl() {
  if (yJ)
    return MR;
  yJ = 1;
  var e = _a(), t = lr(), n = Fe;
  const o = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  var i = o ? n.useLayoutEffect : n.useEffect;
  const a = {
    tag: "history-merge"
  };
  function s({
    initialConfig: l,
    children: u
  }) {
    const d = n.useMemo(
      () => {
        const {
          theme: _,
          namespace: p,
          editor__DEPRECATED: g,
          nodes: f,
          onError: h,
          editorState: $
        } = l, v = e.createLexicalComposerContext(null, _);
        let b = g || null;
        if (b === null) {
          const y = t.createEditor({
            editable: !1,
            namespace: p,
            nodes: f,
            onError: (w) => h(w, y),
            theme: _
          });
          c(y, $), b = y;
        }
        return [b, v];
      },
      // We only do this for init
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );
    return i(() => {
      const _ = l.editable, [p] = d;
      p.setEditable(_ !== void 0 ? _ : !0);
    }, []), /* @__PURE__ */ n.createElement(e.LexicalComposerContext.Provider, {
      value: d
    }, u);
  }
  function c(l, u) {
    if (u !== null) {
      if (u === void 0)
        l.update(() => {
          const d = t.$getRoot();
          if (d.isEmpty()) {
            const _ = t.$createParagraphNode();
            d.append(_);
            const p = o ? document.activeElement : null;
            (t.$getSelection() !== null || p !== null && p === l.getRootElement()) && _.select();
          }
        }, a);
      else if (u !== null)
        switch (typeof u) {
          case "string": {
            const d = l.parseEditorState(u);
            l.setEditorState(d, a);
            break;
          }
          case "object": {
            l.setEditorState(u, a);
            break;
          }
          case "function": {
            l.update(() => {
              t.$getRoot().isEmpty() && u(l);
            }, a);
            break;
          }
        }
    }
  }
  return MR.LexicalComposer = s, MR;
}
const QHl = process.env.NODE_ENV === "development" ? JHl() : XHl();
var eYl = QHl, FR = {}, $J;
function tYl() {
  if ($J)
    return FR;
  $J = 1;
  var e = _a(), t = Fe, n = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  return FR.ContentEditable = function({ ariaActiveDescendant: o, ariaAutoComplete: r, ariaControls: i, ariaDescribedBy: a, ariaExpanded: s, ariaLabel: c, ariaLabelledBy: l, ariaMultiline: u, ariaOwns: d, ariaRequired: _, autoCapitalize: p, className: g, id: f, role: h = "textbox", spellCheck: $ = !0, style: v, tabIndex: b, "data-testid": y }) {
    let [w] = e.useLexicalComposerContext(), [N, M] = t.useState(!1), q = t.useCallback((L) => {
      w.setRootElement(L);
    }, [w]);
    return n(() => (M(w.isEditable()), w.registerEditableListener((L) => {
      M(L);
    })), [w]), t.createElement(
      "div",
      { "aria-activedescendant": N ? o : void 0, "aria-autocomplete": N ? r : "none", "aria-controls": N ? i : void 0, "aria-describedby": a, "aria-expanded": N && h === "combobox" ? !!s : void 0, "aria-label": c, "aria-labelledby": l, "aria-multiline": u, "aria-owns": N ? d : void 0, "aria-required": _, autoCapitalize: p, className: g, contentEditable: N, "data-testid": y, id: f, ref: q, role: N ? h : void 0, spellCheck: $, style: v, tabIndex: b }
    );
  }, FR;
}
var qR = {}, wJ;
function nYl() {
  if (wJ)
    return qR;
  wJ = 1;
  var e = _a(), t = Fe, r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  function i({
    ariaActiveDescendant: a,
    ariaAutoComplete: s,
    ariaControls: c,
    ariaDescribedBy: l,
    ariaExpanded: u,
    ariaLabel: d,
    ariaLabelledBy: _,
    ariaMultiline: p,
    ariaOwns: g,
    ariaRequired: f,
    autoCapitalize: h,
    className: $,
    id: v,
    role: b = "textbox",
    spellCheck: y = !0,
    style: w,
    tabIndex: N,
    "data-testid": M
  }) {
    const [q] = e.useLexicalComposerContext(), [L, R] = t.useState(!1), T = t.useCallback((D) => {
      q.setRootElement(D);
    }, [q]);
    return r(() => (R(q.isEditable()), q.registerEditableListener((D) => {
      R(D);
    })), [q]), /* @__PURE__ */ t.createElement("div", {
      "aria-activedescendant": L ? a : void 0,
      "aria-autocomplete": L ? s : "none",
      "aria-controls": L ? c : void 0,
      "aria-describedby": l,
      "aria-expanded": L && b === "combobox" ? !!u : void 0,
      "aria-label": d,
      "aria-labelledby": _,
      "aria-multiline": p,
      "aria-owns": L ? g : void 0,
      "aria-required": f,
      autoCapitalize: h,
      className: $,
      contentEditable: L,
      "data-testid": M,
      id: v,
      ref: T,
      role: L ? b : void 0,
      spellCheck: y,
      style: w,
      tabIndex: N
    });
  }
  return qR.ContentEditable = i, qR;
}
const oYl = process.env.NODE_ENV === "development" ? nYl() : tYl();
var rYl = oYl, jR, kJ;
function iYl() {
  if (kJ)
    return jR;
  kJ = 1;
  var e = Fe;
  function t(a, s) {
    return t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(c, l) {
      return c.__proto__ = l, c;
    }, t(a, s);
  }
  function n(a, s) {
    a.prototype = Object.create(s.prototype), a.prototype.constructor = a, t(a, s);
  }
  function o(a, s) {
    return a === void 0 && (a = []), s === void 0 && (s = []), a.length !== s.length || a.some(function(c, l) {
      return !Object.is(c, s[l]);
    });
  }
  var r = { error: null }, i = function(a) {
    function s() {
      for (var l, u = arguments.length, d = Array(u), _ = 0; _ < u; _++)
        d[_] = arguments[_];
      return l = a.call.apply(a, [this].concat(d)) || this, l.state = r, l.resetErrorBoundary = function() {
        for (var p, g = arguments.length, f = Array(g), h = 0; h < g; h++)
          f[h] = arguments[h];
        l.props.onReset == null || (p = l.props).onReset.apply(p, f), l.reset();
      }, l;
    }
    n(s, a), s.getDerivedStateFromError = function(l) {
      return { error: l };
    };
    var c = s.prototype;
    return c.reset = function() {
      this.setState(r);
    }, c.componentDidCatch = function(l, u) {
      var d, _;
      (d = (_ = this.props).onError) == null || d.call(_, l, u);
    }, c.componentDidUpdate = function(l, u) {
      var d = this.props.resetKeys;
      if (this.state.error !== null && u.error !== null && o(l.resetKeys, d)) {
        var _, p;
        (_ = (p = this.props).onResetKeysChange) == null || _.call(p, l.resetKeys, d), this.reset();
      }
    }, c.render = function() {
      var l = this.state.error, u = this.props, d = u.fallbackRender, _ = u.FallbackComponent;
      if (u = u.fallback, l !== null) {
        if (l = { error: l, resetErrorBoundary: this.resetErrorBoundary }, e.isValidElement(u))
          return u;
        if (typeof d == "function")
          return d(l);
        if (_)
          return e.createElement(_, l);
        throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }
      return this.props.children;
    }, s;
  }(e.Component);
  return jR = function({ children: a, onError: s }) {
    return e.createElement(i, { fallback: e.createElement("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" } }, "An error was thrown."), onError: s }, a);
  }, jR;
}
var VR, SJ;
function aYl() {
  if (SJ)
    return VR;
  SJ = 1;
  var e = Fe;
  function t(s, c) {
    return t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, d) {
      return u.__proto__ = d, u;
    }, t(s, c);
  }
  function n(s, c) {
    s.prototype = Object.create(c.prototype), s.prototype.constructor = s, t(s, c);
  }
  var o = function(c, l) {
    return c === void 0 && (c = []), l === void 0 && (l = []), c.length !== l.length || c.some(function(u, d) {
      return !Object.is(u, l[d]);
    });
  }, r = {
    error: null
  }, i = /* @__PURE__ */ function(s) {
    n(c, s);
    function c() {
      for (var u, d = arguments.length, _ = new Array(d), p = 0; p < d; p++)
        _[p] = arguments[p];
      return u = s.call.apply(s, [this].concat(_)) || this, u.state = r, u.resetErrorBoundary = function() {
        for (var g, f = arguments.length, h = new Array(f), $ = 0; $ < f; $++)
          h[$] = arguments[$];
        u.props.onReset == null || (g = u.props).onReset.apply(g, h), u.reset();
      }, u;
    }
    c.getDerivedStateFromError = function(d) {
      return {
        error: d
      };
    };
    var l = c.prototype;
    return l.reset = function() {
      this.setState(r);
    }, l.componentDidCatch = function(d, _) {
      var p, g;
      (p = (g = this.props).onError) == null || p.call(g, d, _);
    }, l.componentDidUpdate = function(d, _) {
      var p = this.state.error, g = this.props.resetKeys;
      if (p !== null && _.error !== null && o(d.resetKeys, g)) {
        var f, h;
        (f = (h = this.props).onResetKeysChange) == null || f.call(h, d.resetKeys, g), this.reset();
      }
    }, l.render = function() {
      var d = this.state.error, _ = this.props, p = _.fallbackRender, g = _.FallbackComponent, f = _.fallback;
      if (d !== null) {
        var h = {
          error: d,
          resetErrorBoundary: this.resetErrorBoundary
        };
        if (/* @__PURE__ */ e.isValidElement(f))
          return f;
        if (typeof p == "function")
          return p(h);
        if (g)
          return /* @__PURE__ */ e.createElement(g, h);
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }
      return this.props.children;
    }, c;
  }(e.Component);
  function a({
    children: s,
    onError: c
  }) {
    return /* @__PURE__ */ e.createElement(i, {
      fallback: /* @__PURE__ */ e.createElement("div", {
        style: {
          border: "1px solid #f00",
          color: "#f00",
          padding: "8px"
        }
      }, "An error was thrown."),
      onError: c
    }, s);
  }
  return VR = a, VR;
}
const sYl = process.env.NODE_ENV === "development" ? aYl() : iYl();
var cYl = sYl;
const lYl = /* @__PURE__ */ Mi(cYl);
var mE = {}, fE = {}, EJ;
function uYl() {
  if (EJ)
    return fE;
  EJ = 1;
  var e = Ci(), t = lr();
  function n(r, i, a, s, c) {
    if (r === null || a.size === 0 && s.size === 0 && !c)
      return 0;
    var l = i._selection, u = r._selection;
    if (c)
      return 1;
    if (!(t.$isRangeSelection(l) && t.$isRangeSelection(u) && u.isCollapsed() && l.isCollapsed()))
      return 0;
    c = i._nodeMap;
    let d = [];
    for (let _ of a)
      a = c.get(_), a !== void 0 && d.push(a);
    for (let [_, p] of s)
      p && (s = c.get(_), s === void 0 || t.$isRootNode(s) || d.push(s));
    return d.length === 0 ? 0 : 1 < d.length ? (s = i._nodeMap, i = s.get(l.anchor.key), u = s.get(u.anchor.key), i && u && !r._nodeMap.has(i.__key) && t.$isTextNode(i) && i.__text.length === 1 && l.anchor.offset === 1 ? 2 : 0) : (i = d[0], r = r._nodeMap.get(i.__key), !t.$isTextNode(r) || !t.$isTextNode(i) || r.__mode !== i.__mode || (r = r.__text, i = i.__text, r === i) || (l = l.anchor, u = u.anchor, l.key !== u.key || l.type !== "text") ? 0 : (l = l.offset, u = u.offset, r = i.length - r.length, r === 1 && u === l - 1 ? 2 : r === -1 && u === l + 1 ? 3 : r === -1 && u === l ? 4 : 0));
  }
  function o(r, i) {
    let a = Date.now(), s = 0;
    return (c, l, u, d, _, p) => {
      let g = Date.now();
      if (p.has("historic"))
        return s = 0, a = g, 2;
      let f = n(c, l, d, _, r.isComposing()), h = (() => {
        var $ = u === null || u.editor === r, v = p.has("history-push");
        if (!v && $ && p.has("history-merge"))
          return 0;
        if (c === null)
          return 1;
        var b = l._selection;
        if (!(0 < d.size || 0 < _.size))
          return b !== null ? 0 : 2;
        if (v === !1 && f !== 0 && f === s && g < a + i && $)
          return 0;
        if (d.size === 1) {
          {
            v = Array.from(d)[0], $ = c._nodeMap.get(v), v = l._nodeMap.get(v), b = c._selection;
            let y = l._selection, w = !1;
            t.$isRangeSelection(b) && t.$isRangeSelection(y) && (w = b.anchor.type === "element" && b.focus.type === "element" && y.anchor.type === "text" && y.focus.type === "text"), $ = !w && t.$isTextNode($) && t.$isTextNode(v) ? $.__type === v.__type && $.__text === v.__text && $.__mode === v.__mode && $.__detail === v.__detail && $.__style === v.__style && $.__format === v.__format && $.__parent === v.__parent : !1;
          }
          if ($)
            return 0;
        }
        return 1;
      })();
      return a = g, s = f, h;
    };
  }
  return fE.createEmptyHistoryState = function() {
    return { current: null, redoStack: [], undoStack: [] };
  }, fE.registerHistory = function(r, i, a) {
    let s = o(r, a);
    a = ({ editorState: u, prevEditorState: d, dirtyLeaves: _, dirtyElements: p, tags: g }) => {
      const f = i.current, h = i.redoStack, $ = i.undoStack, v = f === null ? null : f.editorState;
      if (f === null || u !== v) {
        if (_ = s(d, u, f, _, p, g), _ === 1)
          h.length !== 0 && (i.redoStack = [], r.dispatchCommand(t.CAN_REDO_COMMAND, !1)), f !== null && ($.push({ ...f, undoSelection: d.read(t.$getSelection) }), r.dispatchCommand(t.CAN_UNDO_COMMAND, !0));
        else if (_ === 2)
          return;
        i.current = { editor: r, editorState: u };
      }
    };
    let c = e.mergeRegister(
      r.registerCommand(
        t.UNDO_COMMAND,
        () => {
          let u = i.redoStack, d = i.undoStack;
          if (d.length !== 0) {
            let _ = i.current, p = d.pop();
            _ !== null && (u.push(_), r.dispatchCommand(t.CAN_REDO_COMMAND, !0)), d.length === 0 && r.dispatchCommand(t.CAN_UNDO_COMMAND, !1), i.current = p || null, p && p.editor.setEditorState(p.editorState.clone(p.undoSelection), { tag: "historic" });
          }
          return !0;
        },
        t.COMMAND_PRIORITY_EDITOR
      ),
      r.registerCommand(t.REDO_COMMAND, () => {
        let u = i.redoStack;
        var d = i.undoStack;
        if (u.length !== 0) {
          let _ = i.current;
          _ !== null && (d.push(_), r.dispatchCommand(t.CAN_UNDO_COMMAND, !0)), d = u.pop(), u.length === 0 && r.dispatchCommand(t.CAN_REDO_COMMAND, !1), i.current = d || null, d && d.editor.setEditorState(d.editorState, { tag: "historic" });
        }
        return !0;
      }, t.COMMAND_PRIORITY_EDITOR),
      r.registerCommand(t.CLEAR_EDITOR_COMMAND, () => (i.undoStack = [], i.redoStack = [], i.current = null, !1), t.COMMAND_PRIORITY_EDITOR),
      r.registerCommand(t.CLEAR_HISTORY_COMMAND, () => (i.undoStack = [], i.redoStack = [], i.current = null, r.dispatchCommand(t.CAN_REDO_COMMAND, !1), r.dispatchCommand(t.CAN_UNDO_COMMAND, !1), !0), t.COMMAND_PRIORITY_EDITOR),
      r.registerUpdateListener(a)
    ), l = r.registerUpdateListener(a);
    return () => {
      c(), l();
    };
  }, fE;
}
var gE = {}, xJ;
function dYl() {
  if (xJ)
    return gE;
  xJ = 1;
  var e = Ci(), t = lr();
  const n = 0, o = 1, r = 2, i = 0, a = 1, s = 2, c = 3, l = 4;
  function u(b, y, w) {
    const N = b._nodeMap, M = [];
    for (const q of y) {
      const L = N.get(q);
      L !== void 0 && M.push(L);
    }
    for (const [q, L] of w) {
      if (!L)
        continue;
      const R = N.get(q);
      R !== void 0 && !t.$isRootNode(R) && M.push(R);
    }
    return M;
  }
  function d(b, y, w, N, M) {
    if (b === null || w.size === 0 && N.size === 0 && !M)
      return i;
    const q = y._selection, L = b._selection;
    if (M)
      return a;
    if (!t.$isRangeSelection(q) || !t.$isRangeSelection(L) || !L.isCollapsed() || !q.isCollapsed())
      return i;
    const R = u(y, w, N);
    if (R.length === 0)
      return i;
    if (R.length > 1) {
      const F = y._nodeMap, P = F.get(q.anchor.key), O = F.get(L.anchor.key);
      return P && O && !b._nodeMap.has(P.__key) && t.$isTextNode(P) && P.__text.length === 1 && q.anchor.offset === 1 ? s : i;
    }
    const T = R[0], D = b._nodeMap.get(T.__key);
    if (!t.$isTextNode(D) || !t.$isTextNode(T) || D.__mode !== T.__mode)
      return i;
    const A = D.__text, S = T.__text;
    if (A === S)
      return i;
    const E = q.anchor, x = L.anchor;
    if (E.key !== x.key || E.type !== "text")
      return i;
    const k = E.offset, I = x.offset, z = S.length - A.length;
    return z === 1 && I === k - 1 ? s : z === -1 && I === k + 1 ? c : z === -1 && I === k ? l : i;
  }
  function _(b, y, w) {
    const N = y._nodeMap.get(b), M = w._nodeMap.get(b), q = y._selection, L = w._selection;
    let R = !1;
    return t.$isRangeSelection(q) && t.$isRangeSelection(L) && (R = q.anchor.type === "element" && q.focus.type === "element" && L.anchor.type === "text" && L.focus.type === "text"), !R && t.$isTextNode(N) && t.$isTextNode(M) ? N.__type === M.__type && N.__text === M.__text && N.__mode === M.__mode && N.__detail === M.__detail && N.__style === M.__style && N.__format === M.__format && N.__parent === M.__parent : !1;
  }
  function p(b, y) {
    let w = Date.now(), N = i;
    return (M, q, L, R, T, D) => {
      const A = Date.now();
      if (D.has("historic"))
        return N = i, w = A, r;
      const S = d(M, q, R, T, b.isComposing()), E = (() => {
        const x = L === null || L.editor === b, k = D.has("history-push");
        if (!k && x && D.has("history-merge"))
          return n;
        if (M === null)
          return o;
        const z = q._selection;
        if (!(R.size > 0 || T.size > 0))
          return z !== null ? n : r;
        if (k === !1 && S !== i && S === N && A < w + y && x)
          return n;
        if (R.size === 1) {
          const P = Array.from(R)[0];
          if (_(P, M, q))
            return n;
        }
        return o;
      })();
      return w = A, N = S, E;
    };
  }
  function g(b, y) {
    const w = y.redoStack, N = y.undoStack;
    if (w.length !== 0) {
      const M = y.current;
      M !== null && (N.push(M), b.dispatchCommand(t.CAN_UNDO_COMMAND, !0));
      const q = w.pop();
      w.length === 0 && b.dispatchCommand(t.CAN_REDO_COMMAND, !1), y.current = q || null, q && q.editor.setEditorState(q.editorState, {
        tag: "historic"
      });
    }
  }
  function f(b, y) {
    const w = y.redoStack, N = y.undoStack;
    if (N.length !== 0) {
      const q = y.current, L = N.pop();
      q !== null && (w.push(q), b.dispatchCommand(t.CAN_REDO_COMMAND, !0)), N.length === 0 && b.dispatchCommand(t.CAN_UNDO_COMMAND, !1), y.current = L || null, L && L.editor.setEditorState(L.editorState.clone(L.undoSelection), {
        tag: "historic"
      });
    }
  }
  function h(b) {
    b.undoStack = [], b.redoStack = [], b.current = null;
  }
  function $(b, y, w) {
    const N = p(b, w), M = ({
      editorState: R,
      prevEditorState: T,
      dirtyLeaves: D,
      dirtyElements: A,
      tags: S
    }) => {
      const E = y.current, x = y.redoStack, k = y.undoStack, I = E === null ? null : E.editorState;
      if (E !== null && R === I)
        return;
      const z = N(T, R, E, D, A, S);
      if (z === o)
        x.length !== 0 && (y.redoStack = [], b.dispatchCommand(t.CAN_REDO_COMMAND, !1)), E !== null && (k.push({
          ...E,
          undoSelection: T.read(t.$getSelection)
        }), b.dispatchCommand(t.CAN_UNDO_COMMAND, !0));
      else if (z === r)
        return;
      y.current = {
        editor: b,
        editorState: R
      };
    }, q = e.mergeRegister(b.registerCommand(t.UNDO_COMMAND, () => (f(b, y), !0), t.COMMAND_PRIORITY_EDITOR), b.registerCommand(t.REDO_COMMAND, () => (g(b, y), !0), t.COMMAND_PRIORITY_EDITOR), b.registerCommand(t.CLEAR_EDITOR_COMMAND, () => (h(y), !1), t.COMMAND_PRIORITY_EDITOR), b.registerCommand(t.CLEAR_HISTORY_COMMAND, () => (h(y), b.dispatchCommand(t.CAN_REDO_COMMAND, !1), b.dispatchCommand(t.CAN_UNDO_COMMAND, !1), !0), t.COMMAND_PRIORITY_EDITOR), b.registerUpdateListener(M)), L = b.registerUpdateListener(M);
    return () => {
      q(), L();
    };
  }
  function v() {
    return {
      current: null,
      redoStack: [],
      undoStack: []
    };
  }
  return gE.createEmptyHistoryState = v, gE.registerHistory = $, gE;
}
var BR, CJ;
function vbe() {
  return CJ || (CJ = 1, BR = process.env.NODE_ENV === "development" ? dYl() : uYl()), BR;
}
var TJ;
function _Yl() {
  if (TJ)
    return mE;
  TJ = 1;
  var e = _a(), t = vbe(), n = Fe;
  function o(r, i, a = 1e3) {
    let s = n.useMemo(() => i || t.createEmptyHistoryState(), [i]);
    n.useEffect(() => t.registerHistory(r, s, a), [a, r, s]);
  }
  return mE.createEmptyHistoryState = t.createEmptyHistoryState, mE.HistoryPlugin = function({ externalHistoryState: r }) {
    let [i] = e.useLexicalComposerContext();
    return o(i, r), null;
  }, mE;
}
var hE = {}, AJ;
function pYl() {
  if (AJ)
    return hE;
  AJ = 1;
  var e = _a(), t = vbe(), n = Fe;
  function o(i, a, s = 1e3) {
    const c = n.useMemo(() => a || t.createEmptyHistoryState(), [a]);
    n.useEffect(() => t.registerHistory(i, c, s), [s, i, c]);
  }
  function r({
    externalHistoryState: i
  }) {
    const [a] = e.useLexicalComposerContext();
    return o(a, i), null;
  }
  return hE.createEmptyHistoryState = t.createEmptyHistoryState, hE.HistoryPlugin = r, hE;
}
const mYl = process.env.NODE_ENV === "development" ? pYl() : _Yl();
var fYl = mYl, UR = {}, IJ;
function gYl() {
  if (IJ)
    return UR;
  IJ = 1;
  var e = bl, t = _a(), n = Ci(), o = lr(), r = Fe;
  return UR.LinkPlugin = function({ validateUrl: i }) {
    let [a] = t.useLexicalComposerContext();
    return r.useEffect(() => {
      if (!a.hasNodes([e.LinkNode]))
        throw Error("LinkPlugin: LinkNode not registered on editor");
      return n.mergeRegister(a.registerCommand(e.TOGGLE_LINK_COMMAND, (s) => {
        if (s === null)
          return e.toggleLink(s), !0;
        if (typeof s == "string")
          return i === void 0 || i(s) ? (e.toggleLink(s), !0) : !1;
        let { url: c, target: l, rel: u } = s;
        return e.toggleLink(c, { rel: u, target: l }), !0;
      }, o.COMMAND_PRIORITY_LOW), i !== void 0 ? a.registerCommand(
        o.PASTE_COMMAND,
        (s) => {
          let c = o.$getSelection();
          if (!o.$isRangeSelection(c) || c.isCollapsed() || !(s instanceof ClipboardEvent) || s.clipboardData == null)
            return !1;
          let l = s.clipboardData.getData("text");
          return i(l) ? c.getNodes().some((u) => o.$isElementNode(u)) ? !1 : (a.dispatchCommand(e.TOGGLE_LINK_COMMAND, l), s.preventDefault(), !0) : !1;
        },
        o.COMMAND_PRIORITY_LOW
      ) : () => {
      });
    }, [a, i]), null;
  }, UR;
}
var GR = {}, OJ;
function hYl() {
  if (OJ)
    return GR;
  OJ = 1;
  var e = bl, t = _a(), n = Ci(), o = lr(), r = Fe;
  function i({
    validateUrl: a
  }) {
    const [s] = t.useLexicalComposerContext();
    return r.useEffect(() => {
      if (!s.hasNodes([e.LinkNode]))
        throw new Error("LinkPlugin: LinkNode not registered on editor");
      return n.mergeRegister(s.registerCommand(e.TOGGLE_LINK_COMMAND, (c) => {
        if (c === null)
          return e.toggleLink(c), !0;
        if (typeof c == "string")
          return a === void 0 || a(c) ? (e.toggleLink(c), !0) : !1;
        {
          const {
            url: l,
            target: u,
            rel: d
          } = c;
          return e.toggleLink(l, {
            rel: d,
            target: u
          }), !0;
        }
      }, o.COMMAND_PRIORITY_LOW), a !== void 0 ? s.registerCommand(o.PASTE_COMMAND, (c) => {
        const l = o.$getSelection();
        if (!o.$isRangeSelection(l) || l.isCollapsed() || !(c instanceof ClipboardEvent) || c.clipboardData == null)
          return !1;
        const u = c.clipboardData.getData("text");
        return a(u) ? l.getNodes().some((d) => o.$isElementNode(d)) ? !1 : (s.dispatchCommand(e.TOGGLE_LINK_COMMAND, u), c.preventDefault(), !0) : !1;
      }, o.COMMAND_PRIORITY_LOW) : () => {
      });
    }, [s, a]), null;
  }
  return GR.LinkPlugin = i, GR;
}
const vYl = process.env.NODE_ENV === "development" ? hYl() : gYl();
var bYl = vYl, WR = {}, NJ;
function yYl() {
  if (NJ)
    return WR;
  NJ = 1;
  var e = Hl, t = _a(), n = Fe, o = Ci(), r = lr();
  function i(a) {
    n.useEffect(() => o.mergeRegister(a.registerCommand(e.INSERT_ORDERED_LIST_COMMAND, () => (e.insertList(a, "number"), !0), r.COMMAND_PRIORITY_LOW), a.registerCommand(e.INSERT_UNORDERED_LIST_COMMAND, () => (e.insertList(a, "bullet"), !0), r.COMMAND_PRIORITY_LOW), a.registerCommand(e.REMOVE_LIST_COMMAND, () => (e.removeList(a), !0), r.COMMAND_PRIORITY_LOW), a.registerCommand(r.INSERT_PARAGRAPH_COMMAND, () => !!e.$handleListInsertParagraph(), r.COMMAND_PRIORITY_LOW)), [a]);
  }
  return WR.ListPlugin = function() {
    let [a] = t.useLexicalComposerContext();
    return n.useEffect(() => {
      if (!a.hasNodes([e.ListNode, e.ListItemNode]))
        throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
    }, [a]), i(a), null;
  }, WR;
}
var HR = {}, zJ;
function $Yl() {
  if (zJ)
    return HR;
  zJ = 1;
  var e = Hl, t = _a(), n = Fe, o = Ci(), r = lr();
  function i(s) {
    n.useEffect(() => o.mergeRegister(s.registerCommand(e.INSERT_ORDERED_LIST_COMMAND, () => (e.insertList(s, "number"), !0), r.COMMAND_PRIORITY_LOW), s.registerCommand(e.INSERT_UNORDERED_LIST_COMMAND, () => (e.insertList(s, "bullet"), !0), r.COMMAND_PRIORITY_LOW), s.registerCommand(e.REMOVE_LIST_COMMAND, () => (e.removeList(s), !0), r.COMMAND_PRIORITY_LOW), s.registerCommand(r.INSERT_PARAGRAPH_COMMAND, () => !!e.$handleListInsertParagraph(), r.COMMAND_PRIORITY_LOW)), [s]);
  }
  function a() {
    const [s] = t.useLexicalComposerContext();
    return n.useEffect(() => {
      if (!s.hasNodes([e.ListNode, e.ListItemNode]))
        throw new Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
    }, [s]), i(s), null;
  }
  return HR.ListPlugin = a, HR;
}
const wYl = process.env.NODE_ENV === "development" ? $Yl() : yYl();
var kYl = wYl, vE = {}, gb = {}, YR = {}, RJ;
function SYl() {
  if (RJ)
    return YR;
  RJ = 1;
  var e = _a(), t = lr(), n = Fe;
  function o(r, i) {
    return r.getEditorState().read(() => {
      let a = t.$getNodeByKey(i);
      return a === null ? !1 : a.isSelected();
    });
  }
  return YR.useLexicalNodeSelection = function(r) {
    let [i] = e.useLexicalComposerContext(), [a, s] = n.useState(() => o(i, r));
    n.useEffect(() => {
      let u = !0, d = i.registerUpdateListener(() => {
        u && s(o(i, r));
      });
      return () => {
        u = !1, d();
      };
    }, [i, r]);
    let c = n.useCallback((u) => {
      i.update(() => {
        let d = t.$getSelection();
        t.$isNodeSelection(d) || (d = t.$createNodeSelection(), t.$setSelection(d)), u ? d.add(r) : d.delete(r);
      });
    }, [i, r]), l = n.useCallback(() => {
      i.update(() => {
        const u = t.$getSelection();
        t.$isNodeSelection(u) && u.clear();
      });
    }, [i]);
    return [a, c, l];
  }, YR;
}
var KR = {}, PJ;
function EYl() {
  if (PJ)
    return KR;
  PJ = 1;
  var e = _a(), t = lr(), n = Fe;
  function o(i, a) {
    return i.getEditorState().read(() => {
      const s = t.$getNodeByKey(a);
      return s === null ? !1 : s.isSelected();
    });
  }
  function r(i) {
    const [a] = e.useLexicalComposerContext(), [s, c] = n.useState(() => o(a, i));
    n.useEffect(() => {
      let d = !0;
      const _ = a.registerUpdateListener(() => {
        d && c(o(a, i));
      });
      return () => {
        d = !1, _();
      };
    }, [a, i]);
    const l = n.useCallback((d) => {
      a.update(() => {
        let _ = t.$getSelection();
        t.$isNodeSelection(_) || (_ = t.$createNodeSelection(), t.$setSelection(_)), d ? _.add(i) : _.delete(i);
      });
    }, [a, i]), u = n.useCallback(() => {
      a.update(() => {
        const d = t.$getSelection();
        t.$isNodeSelection(d) && d.clear();
      });
    }, [a]);
    return [s, l, u];
  }
  return KR.useLexicalNodeSelection = r, KR;
}
var ZR, DJ;
function bbe() {
  return DJ || (DJ = 1, ZR = process.env.NODE_ENV === "development" ? EYl() : SYl()), ZR;
}
var LJ;
function xYl() {
  if (LJ)
    return gb;
  LJ = 1;
  var e = _a(), t = bbe(), n = Ci(), o = lr(), r = Fe;
  let i = o.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
  function a({ nodeKey: d }) {
    let [_] = e.useLexicalComposerContext(), [p, g, f] = t.useLexicalNodeSelection(d), h = r.useCallback(($) => (p && o.$isNodeSelection(o.$getSelection()) && ($.preventDefault(), $ = o.$getNodeByKey(d), u($) && $.remove(), g(!1)), !1), [p, d, g]);
    return r.useEffect(() => n.mergeRegister(_.registerCommand(o.CLICK_COMMAND, ($) => {
      let v = _.getElementByKey(d);
      return $.target === v ? ($.shiftKey || f(), g(!p), !0) : !1;
    }, o.COMMAND_PRIORITY_LOW), _.registerCommand(o.KEY_DELETE_COMMAND, h, o.COMMAND_PRIORITY_LOW), _.registerCommand(
      o.KEY_BACKSPACE_COMMAND,
      h,
      o.COMMAND_PRIORITY_LOW
    )), [f, _, p, d, h, g]), r.useEffect(() => {
      let $ = _.getElementByKey(d);
      $ !== null && ($.className = p ? "selected" : "");
    }, [_, p, d]), null;
  }
  class s extends o.DecoratorNode {
    static getType() {
      return "horizontalrule";
    }
    static clone(_) {
      return new s(_.__key);
    }
    static importJSON() {
      return l();
    }
    static importDOM() {
      return { hr: () => ({ conversion: c, priority: 0 }) };
    }
    exportJSON() {
      return { type: "horizontalrule", version: 1 };
    }
    exportDOM() {
      return { element: document.createElement("hr") };
    }
    createDOM() {
      return document.createElement("hr");
    }
    getTextContent() {
      return `
`;
    }
    isInline() {
      return !1;
    }
    updateDOM() {
      return !1;
    }
    decorate() {
      return r.createElement(a, { nodeKey: this.__key });
    }
  }
  function c() {
    return { node: l() };
  }
  function l() {
    return o.$applyNodeReplacement(new s());
  }
  function u(d) {
    return d instanceof s;
  }
  return gb.$createHorizontalRuleNode = l, gb.$isHorizontalRuleNode = u, gb.HorizontalRuleNode = s, gb.INSERT_HORIZONTAL_RULE_COMMAND = i, gb;
}
var hb = {}, MJ;
function CYl() {
  if (MJ)
    return hb;
  MJ = 1;
  var e = _a(), t = bbe(), n = Ci(), o = lr(), r = Fe;
  const i = o.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
  function a({
    nodeKey: d
  }) {
    const [_] = e.useLexicalComposerContext(), [p, g, f] = t.useLexicalNodeSelection(d), h = r.useCallback(($) => {
      if (p && o.$isNodeSelection(o.$getSelection())) {
        $.preventDefault();
        const b = o.$getNodeByKey(d);
        u(b) && b.remove(), g(!1);
      }
      return !1;
    }, [p, d, g]);
    return r.useEffect(() => n.mergeRegister(_.registerCommand(o.CLICK_COMMAND, ($) => {
      const v = _.getElementByKey(d);
      return $.target === v ? ($.shiftKey || f(), g(!p), !0) : !1;
    }, o.COMMAND_PRIORITY_LOW), _.registerCommand(o.KEY_DELETE_COMMAND, h, o.COMMAND_PRIORITY_LOW), _.registerCommand(o.KEY_BACKSPACE_COMMAND, h, o.COMMAND_PRIORITY_LOW)), [f, _, p, d, h, g]), r.useEffect(() => {
      const $ = _.getElementByKey(d);
      $ !== null && ($.className = p ? "selected" : "");
    }, [_, p, d]), null;
  }
  class s extends o.DecoratorNode {
    static getType() {
      return "horizontalrule";
    }
    static clone(_) {
      return new s(_.__key);
    }
    static importJSON(_) {
      return l();
    }
    static importDOM() {
      return {
        hr: () => ({
          conversion: c,
          priority: 0
        })
      };
    }
    exportJSON() {
      return {
        type: "horizontalrule",
        version: 1
      };
    }
    exportDOM() {
      return {
        element: document.createElement("hr")
      };
    }
    createDOM() {
      return document.createElement("hr");
    }
    getTextContent() {
      return `
`;
    }
    isInline() {
      return !1;
    }
    updateDOM() {
      return !1;
    }
    decorate() {
      return /* @__PURE__ */ r.createElement(a, {
        nodeKey: this.__key
      });
    }
  }
  function c() {
    return {
      node: l()
    };
  }
  function l() {
    return o.$applyNodeReplacement(new s());
  }
  function u(d) {
    return d instanceof s;
  }
  return hb.$createHorizontalRuleNode = l, hb.$isHorizontalRuleNode = u, hb.HorizontalRuleNode = s, hb.INSERT_HORIZONTAL_RULE_COMMAND = i, hb;
}
var XR, FJ;
function ybe() {
  return FJ || (FJ = 1, XR = process.env.NODE_ENV === "development" ? CYl() : xYl()), XR;
}
var qJ;
function TYl() {
  if (qJ)
    return vE;
  qJ = 1;
  var e = aT, t = _a(), n = ybe(), o = Fe;
  let r = [{ dependencies: [n.HorizontalRuleNode], export: (i) => n.$isHorizontalRuleNode(i) ? "***" : null, regExp: /^(---|\*\*\*|___)\s?$/, replace: (i, a, s, c) => {
    a = n.$createHorizontalRuleNode(), c || i.getNextSibling() != null ? i.replace(a) : i.insertBefore(a), a.selectNext();
  }, type: "element" }, ...e.TRANSFORMERS];
  return vE.DEFAULT_TRANSFORMERS = r, vE.MarkdownShortcutPlugin = function({ transformers: i = r }) {
    let [a] = t.useLexicalComposerContext();
    return o.useEffect(() => e.registerMarkdownShortcuts(a, i), [a, i]), null;
  }, vE;
}
var bE = {}, jJ;
function AYl() {
  if (jJ)
    return bE;
  jJ = 1;
  var e = aT, t = _a(), n = ybe(), o = Fe;
  const i = [{
    dependencies: [n.HorizontalRuleNode],
    export: (s) => n.$isHorizontalRuleNode(s) ? "***" : null,
    regExp: /^(---|\*\*\*|___)\s?$/,
    replace: (s, c, l, u) => {
      const d = n.$createHorizontalRuleNode();
      u || s.getNextSibling() != null ? s.replace(d) : s.insertBefore(d), d.selectNext();
    },
    type: "element"
  }, ...e.TRANSFORMERS];
  function a({
    transformers: s = i
  }) {
    const [c] = t.useLexicalComposerContext();
    return o.useEffect(() => e.registerMarkdownShortcuts(c, s), [c, s]), null;
  }
  return bE.DEFAULT_TRANSFORMERS = i, bE.MarkdownShortcutPlugin = a, bE;
}
const IYl = process.env.NODE_ENV === "development" ? AYl() : TYl();
var OYl = IYl, JR = {}, QR, VJ;
function NYl() {
  if (VJ)
    return QR;
  VJ = 1;
  var e = _a(), t = Fe, n = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  function o(i) {
    let [a] = e.useLexicalComposerContext(), s = t.useMemo(() => i(a), [a, i]), c = t.useRef(s.initialValueFn()), [l, u] = t.useState(c.current);
    return n(() => {
      let { initialValueFn: d, subscribe: _ } = s, p = d();
      return c.current !== p && (c.current = p, u(p)), _((g) => {
        c.current = g, u(g);
      });
    }, [s, i]), l;
  }
  function r(i) {
    return { initialValueFn: () => i.isEditable(), subscribe: (a) => i.registerEditableListener(a) };
  }
  return QR = function() {
    return o(r);
  }, QR;
}
var eP, BJ;
function zYl() {
  if (BJ)
    return eP;
  BJ = 1;
  var e = _a(), t = Fe, r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? t.useLayoutEffect : t.useEffect;
  function i(c) {
    const [l] = e.useLexicalComposerContext(), u = t.useMemo(() => c(l), [l, c]), d = t.useRef(u.initialValueFn()), [_, p] = t.useState(d.current);
    return r(() => {
      const {
        initialValueFn: g,
        subscribe: f
      } = u, h = g();
      return d.current !== h && (d.current = h, p(h)), f(($) => {
        d.current = $, p($);
      });
    }, [u, c]), _;
  }
  function a(c) {
    return {
      initialValueFn: () => c.isEditable(),
      subscribe: (l) => c.registerEditableListener(l)
    };
  }
  function s() {
    return i(a);
  }
  return eP = s, eP;
}
var tP, UJ;
function $be() {
  return UJ || (UJ = 1, tP = process.env.NODE_ENV === "development" ? zYl() : NYl()), tP;
}
var Bm = {}, GJ;
function RYl() {
  if (GJ)
    return Bm;
  GJ = 1;
  var e = lr();
  function t(r, i = !0) {
    return r ? !1 : (r = n(), i && (r = r.trim()), r === "");
  }
  function n() {
    return e.$getRoot().getTextContent();
  }
  function o(r) {
    if (!t(r, !1))
      return !1;
    r = e.$getRoot().getChildren();
    let i = r.length;
    if (1 < i)
      return !1;
    for (let s = 0; s < i; s++) {
      var a = r[s];
      if (e.$isDecoratorNode(a))
        return !1;
      if (e.$isElementNode(a)) {
        if (!e.$isParagraphNode(a) || a.__indent !== 0)
          return !1;
        a = a.getChildren();
        let c = a.length;
        for (let l = 0; l < c; l++)
          if (!e.$isTextNode(a[s]))
            return !1;
      }
    }
    return !0;
  }
  return Bm.$canShowPlaceholder = o, Bm.$canShowPlaceholderCurry = function(r) {
    return () => o(r);
  }, Bm.$findTextIntersectionFromCharacters = function(r, i) {
    var a = r.getFirstChild();
    r = 0;
    e:
      for (; a !== null; ) {
        if (e.$isElementNode(a)) {
          var s = a.getFirstChild();
          if (s !== null) {
            a = s;
            continue;
          }
        } else if (e.$isTextNode(a)) {
          if (s = a.getTextContentSize(), r + s > i)
            return { node: a, offset: i - r };
          r += s;
        }
        if (s = a.getNextSibling(), s !== null)
          a = s;
        else {
          for (a = a.getParent(); a !== null; ) {
            if (s = a.getNextSibling(), s !== null) {
              a = s;
              continue e;
            }
            a = a.getParent();
          }
          break;
        }
      }
    return null;
  }, Bm.$isRootTextContentEmpty = t, Bm.$isRootTextContentEmptyCurry = function(r, i) {
    return () => t(r, i);
  }, Bm.$rootTextContent = n, Bm.registerLexicalTextEntity = function(r, i, a, s) {
    let c = (u) => {
      const d = e.$createTextNode(u.getTextContent());
      d.setFormat(u.getFormat()), u.replace(d);
    }, l = r.registerNodeTransform(e.TextNode, (u) => {
      if (u.isSimpleText()) {
        var d = u.getPreviousSibling(), _ = u.getTextContent(), p = u;
        if (e.$isTextNode(d)) {
          var g = d.getTextContent(), f = i(g + _);
          if (d instanceof a) {
            if (f === null || d.getLatest().__mode !== 0) {
              c(d);
              return;
            }
            if (f = f.end - g.length, 0 < f) {
              p = _.slice(0, f), p = g + p, d.select(), d.setTextContent(p), f === _.length ? u.remove() : (d = _.slice(f), u.setTextContent(d));
              return;
            }
          } else if (f === null || f.start < g.length)
            return;
        }
        for (; ; ) {
          if (u = i(_), _ = f = u === null ? "" : _.slice(u.end), f === "") {
            if (g = p.getNextSibling(), e.$isTextNode(g)) {
              if (f = p.getTextContent() + g.getTextContent(), f = i(f), f === null) {
                g instanceof a ? c(g) : g.markDirty();
                break;
              } else if (f.start !== 0)
                break;
            }
          } else if (g = i(f), g !== null && g.start === 0)
            break;
          if (u === null)
            break;
          if (u.start === 0 && e.$isTextNode(d) && d.isTextEntity())
            continue;
          let h;
          if (u.start === 0 ? [h, p] = p.splitText(u.end) : [, h, p] = p.splitText(u.start, u.end), u = s(h), h.replace(u), p == null)
            break;
        }
      }
    });
    return r = r.registerNodeTransform(a, (u) => {
      var d = u.getTextContent();
      const _ = i(d);
      _ === null || _.start !== 0 ? c(u) : d.length > _.end ? u.splitText(_.end) : (d = u.getPreviousSibling(), e.$isTextNode(d) && d.isTextEntity() && (c(d), c(u)), d = u.getNextSibling(), e.$isTextNode(d) && d.isTextEntity() && (c(d), u instanceof a && c(u)));
    }), [l, r];
  }, Bm;
}
var Um = {}, WJ;
function PYl() {
  if (WJ)
    return Um;
  WJ = 1;
  var e = lr();
  function t(c, l) {
    let u = c.getFirstChild(), d = 0;
    e:
      for (; u !== null; ) {
        if (e.$isElementNode(u)) {
          const g = u.getFirstChild();
          if (g !== null) {
            u = g;
            continue;
          }
        } else if (e.$isTextNode(u)) {
          const g = u.getTextContentSize();
          if (d + g > l)
            return {
              node: u,
              offset: l - d
            };
          d += g;
        }
        const _ = u.getNextSibling();
        if (_ !== null) {
          u = _;
          continue;
        }
        let p = u.getParent();
        for (; p !== null; ) {
          const g = p.getNextSibling();
          if (g !== null) {
            u = g;
            continue e;
          }
          p = p.getParent();
        }
        break;
      }
    return null;
  }
  function n(c, l = !0) {
    if (c)
      return !1;
    let u = r();
    return l && (u = u.trim()), u === "";
  }
  function o(c, l) {
    return () => n(c, l);
  }
  function r() {
    return e.$getRoot().getTextContent();
  }
  function i(c) {
    if (!n(c, !1))
      return !1;
    const u = e.$getRoot().getChildren(), d = u.length;
    if (d > 1)
      return !1;
    for (let _ = 0; _ < d; _++) {
      const p = u[_];
      if (e.$isDecoratorNode(p))
        return !1;
      if (e.$isElementNode(p)) {
        if (!e.$isParagraphNode(p) || p.__indent !== 0)
          return !1;
        const g = p.getChildren(), f = g.length;
        for (let h = 0; h < f; h++) {
          const $ = g[_];
          if (!e.$isTextNode($))
            return !1;
        }
      }
    }
    return !0;
  }
  function a(c) {
    return () => i(c);
  }
  function s(c, l, u, d) {
    const _ = (b) => b instanceof u, p = (b) => {
      const y = e.$createTextNode(b.getTextContent());
      y.setFormat(b.getFormat()), b.replace(y);
    }, g = (b) => b.getLatest().__mode, f = (b) => {
      if (!b.isSimpleText())
        return;
      const y = b.getPreviousSibling();
      let w = b.getTextContent(), N = b, M;
      if (e.$isTextNode(y)) {
        const q = y.getTextContent(), L = q + w, R = l(L);
        if (_(y))
          if (R === null || g(y) !== 0) {
            p(y);
            return;
          } else {
            const T = R.end - q.length;
            if (T > 0) {
              const D = w.slice(0, T), A = q + D;
              if (y.select(), y.setTextContent(A), T === w.length)
                b.remove();
              else {
                const S = w.slice(T);
                b.setTextContent(S);
              }
              return;
            }
          }
        else if (R === null || R.start < q.length)
          return;
      }
      for (; ; ) {
        M = l(w);
        let q = M === null ? "" : w.slice(M.end);
        if (w = q, q === "") {
          const T = N.getNextSibling();
          if (e.$isTextNode(T)) {
            q = N.getTextContent() + T.getTextContent();
            const D = l(q);
            if (D === null) {
              _(T) ? p(T) : T.markDirty();
              return;
            } else if (D.start !== 0)
              return;
          }
        } else {
          const T = l(q);
          if (T !== null && T.start === 0)
            return;
        }
        if (M === null)
          return;
        if (M.start === 0 && e.$isTextNode(y) && y.isTextEntity())
          continue;
        let L;
        M.start === 0 ? [L, N] = N.splitText(M.end) : [, L, N] = N.splitText(M.start, M.end);
        const R = d(L);
        if (L.replace(R), N == null)
          return;
      }
    }, h = (b) => {
      const y = b.getTextContent(), w = l(y);
      if (w === null || w.start !== 0) {
        p(b);
        return;
      }
      if (y.length > w.end) {
        b.splitText(w.end);
        return;
      }
      const N = b.getPreviousSibling();
      e.$isTextNode(N) && N.isTextEntity() && (p(N), p(b));
      const M = b.getNextSibling();
      e.$isTextNode(M) && M.isTextEntity() && (p(M), _(b) && p(b));
    }, $ = c.registerNodeTransform(e.TextNode, f), v = c.registerNodeTransform(u, h);
    return [$, v];
  }
  return Um.$canShowPlaceholder = i, Um.$canShowPlaceholderCurry = a, Um.$findTextIntersectionFromCharacters = t, Um.$isRootTextContentEmpty = n, Um.$isRootTextContentEmptyCurry = o, Um.$rootTextContent = r, Um.registerLexicalTextEntity = s, Um;
}
var nP, HJ;
function wbe() {
  return HJ || (HJ = 1, nP = process.env.NODE_ENV === "development" ? PYl() : RYl()), nP;
}
var oP = {}, YJ;
function DYl() {
  if (YJ)
    return oP;
  YJ = 1;
  var e = lr();
  return oP.registerDragonSupport = function(t) {
    let n = window.location.origin, o = (r) => {
      if (r.origin === n) {
        var i = t.getRootElement();
        if (document.activeElement === i && (i = r.data, typeof i == "string")) {
          try {
            var a = JSON.parse(i);
          } catch {
            return;
          }
          if (a && a.protocol === "nuanria_messaging" && a.type === "request" && (a = a.payload) && a.functionId === "makeChanges" && (a = a.args)) {
            const [s, c, l, u, d] = a;
            t.update(() => {
              const _ = e.$getSelection();
              if (e.$isRangeSelection(_)) {
                var p = _.anchor;
                let g = p.getNode(), f = 0, h = 0;
                e.$isTextNode(g) && 0 <= s && 0 <= c && (f = s, h = s + c, _.setTextNodeRange(g, f, g, h)), (f !== h || l !== "") && (_.insertRawText(l), g = p.getNode()), e.$isTextNode(g) && (f = u, h = u + d, p = g.getTextContentSize(), f = f > p ? p : f, h = h > p ? p : h, _.setTextNodeRange(g, f, g, h)), r.stopImmediatePropagation();
              }
            });
          }
        }
      }
    };
    return window.addEventListener("message", o, !0), () => {
      window.removeEventListener("message", o, !0);
    };
  }, oP;
}
var rP = {}, KJ;
function LYl() {
  if (KJ)
    return rP;
  KJ = 1;
  var e = lr();
  function t(n) {
    const o = window.location.origin, r = (i) => {
      if (i.origin !== o)
        return;
      const a = n.getRootElement();
      if (document.activeElement !== a)
        return;
      const s = i.data;
      if (typeof s == "string") {
        let c;
        try {
          c = JSON.parse(s);
        } catch {
          return;
        }
        if (c && c.protocol === "nuanria_messaging" && c.type === "request") {
          const l = c.payload;
          if (l && l.functionId === "makeChanges") {
            const u = l.args;
            if (u) {
              const [d, _, p, g, f, h] = u;
              n.update(() => {
                const $ = e.$getSelection();
                if (e.$isRangeSelection($)) {
                  const v = $.anchor;
                  let b = v.getNode(), y = 0, w = 0;
                  if (e.$isTextNode(b) && d >= 0 && _ >= 0 && (y = d, w = d + _, $.setTextNodeRange(b, y, b, w)), (y !== w || p !== "") && ($.insertRawText(p), b = v.getNode()), e.$isTextNode(b)) {
                    y = g, w = g + f;
                    const N = b.getTextContentSize();
                    y = y > N ? N : y, w = w > N ? N : w, $.setTextNodeRange(b, y, b, w);
                  }
                  i.stopImmediatePropagation();
                }
              });
            }
          }
        }
      }
    };
    return window.addEventListener("message", r, !0), () => {
      window.removeEventListener("message", r, !0);
    };
  }
  return rP.registerDragonSupport = t, rP;
}
var iP, ZJ;
function kbe() {
  return ZJ || (ZJ = 1, iP = process.env.NODE_ENV === "development" ? LYl() : DYl()), iP;
}
var XJ;
function MYl() {
  if (XJ)
    return JR;
  XJ = 1;
  var e = _a(), t = $be(), n = Fe, o = wbe(), r = Ci(), i = $v, a = kbe(), s = mf, c = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? n.useLayoutEffect : n.useEffect;
  function l(g) {
    return g.getEditorState().read(o.$canShowPlaceholderCurry(g.isComposing()));
  }
  function u(g) {
    let [f, h] = n.useState(() => l(g));
    return c(() => {
      function $() {
        let v = l(g);
        h(v);
      }
      return $(), r.mergeRegister(g.registerUpdateListener(() => {
        $();
      }), g.registerEditableListener(() => {
        $();
      }));
    }, [g]), f;
  }
  function d(g, f) {
    let [h, $] = n.useState(() => g.getDecorators());
    return c(() => g.registerDecoratorListener((v) => {
      i.flushSync(() => {
        $(v);
      });
    }), [g]), n.useEffect(() => {
      $(g.getDecorators());
    }, [g]), n.useMemo(() => {
      let v = [], b = Object.keys(h);
      for (let w = 0; w < b.length; w++) {
        var y = b[w];
        let N = n.createElement(f, { onError: (M) => g._onError(M) }, n.createElement(n.Suspense, { fallback: null }, h[y]));
        y = g.getElementByKey(y), y !== null && v.push(i.createPortal(N, y));
      }
      return v;
    }, [f, h, g]);
  }
  function _(g) {
    c(() => r.mergeRegister(s.registerRichText(g), a.registerDragonSupport(g)), [g]);
  }
  function p({ content: g }) {
    var [f] = e.useLexicalComposerContext();
    f = u(f);
    let h = t();
    return f ? typeof g == "function" ? g(h) : g : null;
  }
  return JR.RichTextPlugin = function({ contentEditable: g, placeholder: f, ErrorBoundary: h }) {
    let [$] = e.useLexicalComposerContext();
    return h = d($, h), _($), n.createElement(n.Fragment, null, g, n.createElement(p, { content: f }), h);
  }, JR;
}
var aP = {}, JJ;
function FYl() {
  if (JJ)
    return aP;
  JJ = 1;
  var e = _a(), t = $be(), n = Fe, o = wbe(), r = Ci(), i = $v, a = kbe(), s = mf, u = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? n.useLayoutEffect : n.useEffect;
  function d($) {
    return $.getEditorState().read(o.$canShowPlaceholderCurry($.isComposing()));
  }
  function _($) {
    const [v, b] = n.useState(() => d($));
    return u(() => {
      function y() {
        const w = d($);
        b(w);
      }
      return y(), r.mergeRegister($.registerUpdateListener(() => {
        y();
      }), $.registerEditableListener(() => {
        y();
      }));
    }, [$]), v;
  }
  function p($, v) {
    const [b, y] = n.useState(() => $.getDecorators());
    return u(() => $.registerDecoratorListener((w) => {
      i.flushSync(() => {
        y(w);
      });
    }), [$]), n.useEffect(() => {
      y($.getDecorators());
    }, [$]), n.useMemo(() => {
      const w = [], N = Object.keys(b);
      for (let M = 0; M < N.length; M++) {
        const q = N[M], L = /* @__PURE__ */ n.createElement(v, {
          onError: (T) => $._onError(T)
        }, /* @__PURE__ */ n.createElement(n.Suspense, {
          fallback: null
        }, b[q])), R = $.getElementByKey(q);
        R !== null && w.push(/* @__PURE__ */ i.createPortal(L, R));
      }
      return w;
    }, [v, b, $]);
  }
  function g($) {
    u(() => r.mergeRegister(s.registerRichText($), a.registerDragonSupport($)), [$]);
  }
  function f({
    contentEditable: $,
    placeholder: v,
    ErrorBoundary: b
  }) {
    const [y] = e.useLexicalComposerContext(), w = p(y, b);
    return g(y), /* @__PURE__ */ n.createElement(n.Fragment, null, $, /* @__PURE__ */ n.createElement(h, {
      content: v
    }), w);
  }
  function h({
    content: $
  }) {
    const [v] = e.useLexicalComposerContext(), b = _(v), y = t();
    return b ? typeof $ == "function" ? $(y) : $ : null;
  }
  return aP.RichTextPlugin = f, aP;
}
const qYl = process.env.NODE_ENV === "development" ? FYl() : MYl();
var jYl = qYl, qr = {}, QJ;
function VYl() {
  if (QJ)
    return qr;
  QJ = 1;
  var e = lr(), t = Ci();
  let n = { BOTH: 3, COLUMN: 2, NO_STATUS: 0, ROW: 1 };
  class o extends e.DEPRECATED_GridCellNode {
    static getType() {
      return "tablecell";
    }
    static clone(I) {
      let z = new o(I.__headerState, I.__colSpan, I.__width, I.__key);
      return z.__rowSpan = I.__rowSpan, z;
    }
    static importDOM() {
      return { td: () => ({ conversion: r, priority: 0 }), th: () => ({ conversion: r, priority: 0 }) };
    }
    static importJSON(I) {
      return i(I.headerState, I.colSpan, I.width || void 0);
    }
    constructor(I = n.NO_STATUS, z = 1, F, P) {
      super(z, P), this.__headerState = I, this.__width = F;
    }
    createDOM(I) {
      let z = document.createElement(this.getTag());
      return this.__width && (z.style.width = `${this.__width}px`), this.__colSpan !== 1 && (z.colSpan = this.__colSpan), this.__rowSpan !== 1 && (z.rowSpan = this.__rowSpan), t.addClassNamesToElement(z, I.theme.tableCell, this.hasHeader() && I.theme.tableCellHeader), z;
    }
    exportDOM(I) {
      if ({ element: I } = super.exportDOM(I), I) {
        let z = this.getParentOrThrow().getChildrenSize();
        I.style.border = "1px solid black", this.__colSpan !== 1 && (I.colSpan = this.__colSpan), this.__rowSpan !== 1 && (I.rowSpan = this.__rowSpan), I.style.width = `${this.getWidth() || Math.max(90, 700 / z)}px`, I.style.verticalAlign = "top", I.style.textAlign = "start", this.hasHeader() && (I.style.backgroundColor = "#f2f3f5");
      }
      return { element: I };
    }
    exportJSON() {
      return { ...super.exportJSON(), colSpan: super.__colSpan, headerState: this.__headerState, type: "tablecell", width: this.getWidth() };
    }
    getTag() {
      return this.hasHeader() ? "th" : "td";
    }
    setHeaderStyles(I) {
      return this.getWritable().__headerState = I, this.__headerState;
    }
    getHeaderStyles() {
      return this.getLatest().__headerState;
    }
    setWidth(I) {
      return this.getWritable().__width = I, this.__width;
    }
    getWidth() {
      return this.getLatest().__width;
    }
    toggleHeaderStyle(I) {
      let z = this.getWritable();
      return z.__headerState = (z.__headerState & I) === I ? z.__headerState - I : z.__headerState + I, z;
    }
    hasHeaderState(I) {
      return (this.getHeaderStyles() & I) === I;
    }
    hasHeader() {
      return this.getLatest().__headerState !== n.NO_STATUS;
    }
    updateDOM(I) {
      return I.__headerState !== this.__headerState || I.__width !== this.__width || I.__colSpan !== this.__colSpan || I.__rowSpan !== this.__rowSpan;
    }
    isShadowRoot() {
      return !0;
    }
    collapseAtStart() {
      return !0;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function r(k) {
    var I = k.nodeName.toLowerCase();
    return I = i(I === "th" ? n.ROW : n.NO_STATUS), I.__colSpan = k.colSpan, I.__rowSpan = k.rowSpan, { forChild: (z, F) => a(F) && !e.$isElementNode(z) ? (F = e.$createParagraphNode(), e.$isLineBreakNode(z) && z.getTextContent() === `
` ? null : (F.append(z), F)) : z, node: I };
  }
  function i(k, I = 1, z) {
    return e.$applyNodeReplacement(new o(k, I, z));
  }
  function a(k) {
    return k instanceof o;
  }
  class s extends e.DEPRECATED_GridRowNode {
    static getType() {
      return "tablerow";
    }
    static clone(I) {
      return new s(I.__height, I.__key);
    }
    static importDOM() {
      return { tr: () => ({ conversion: c, priority: 0 }) };
    }
    static importJSON(I) {
      return l(I.height);
    }
    constructor(I, z) {
      super(z), this.__height = I;
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "tablerow", version: 1 };
    }
    createDOM(I) {
      let z = document.createElement("tr");
      return this.__height && (z.style.height = `${this.__height}px`), t.addClassNamesToElement(z, I.theme.tableRow), z;
    }
    isShadowRoot() {
      return !0;
    }
    setHeight(I) {
      return this.getWritable().__height = I, this.__height;
    }
    getHeight() {
      return this.getLatest().__height;
    }
    updateDOM(I) {
      return I.__height !== this.__height;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function c() {
    return { node: l() };
  }
  function l(k) {
    return e.$applyNodeReplacement(new s(k));
  }
  function u(k) {
    return k instanceof s;
  }
  function d(k) {
    throw Error(`Minified Lexical error #${k}; visit https://lexical.dev/docs/error?code=${k} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
  }
  let _ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
  class p {
    constructor(I, z) {
      this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.listenersToRemove = /* @__PURE__ */ new Set(), this.tableNodeKey = z, this.editor = I, this.grid = { cells: [], columns: 0, rows: 0 }, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.trackTableGrid();
    }
    getGrid() {
      return this.grid;
    }
    removeListeners() {
      Array.from(this.listenersToRemove).forEach((I) => I());
    }
    trackTableGrid() {
      let I = new MutationObserver((z) => {
        this.editor.update(() => {
          var F = !1;
          for (let P = 0; P < z.length; P++) {
            const O = z[P].target.nodeName;
            if (O === "TABLE" || O === "TR") {
              F = !0;
              break;
            }
          }
          if (F) {
            if (F = this.editor.getElementByKey(this.tableNodeKey), !F)
              throw Error("Expected to find TableElement in DOM");
            this.grid = f(F);
          }
        });
      });
      this.editor.update(() => {
        let z = this.editor.getElementByKey(this.tableNodeKey);
        if (!z)
          throw Error("Expected to find TableElement in DOM");
        this.grid = f(z), I.observe(z, { childList: !0, subtree: !0 });
      });
    }
    clearHighlight() {
      this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), this.editor.update(() => {
        var I = e.$getNodeByKey(this.tableNodeKey);
        if (!T(I))
          throw Error("Expected TableNode.");
        if (I = this.editor.getElementByKey(this.tableNodeKey), !I)
          throw Error("Expected to find TableElement in DOM");
        I = f(I), h(I, null), e.$setSelection(null), this.editor.dispatchCommand(
          e.SELECTION_CHANGE_COMMAND,
          void 0
        );
      });
    }
    enableHighlightStyle() {
      this.editor.update(() => {
        let I = this.editor.getElementByKey(this.tableNodeKey);
        if (!I)
          throw Error("Expected to find TableElement in DOM");
        I.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
      });
    }
    disableHighlightStyle() {
      this.editor.update(() => {
        let I = this.editor.getElementByKey(this.tableNodeKey);
        if (!I)
          throw Error("Expected to find TableElement in DOM");
        I.classList.add("disable-selection"), this.hasHijackedSelectionStyles = !0;
      });
    }
    updateTableGridSelection(I) {
      I != null && I.gridKey === this.tableNodeKey ? (this.gridSelection = I, this.isHighlightingCells = !0, this.disableHighlightStyle(), h(this.grid, this.gridSelection)) : I == null && this.clearHighlight();
    }
    setFocusCellForSelection(I, z = !1) {
      this.editor.update(() => {
        var F = e.$getNodeByKey(this.tableNodeKey);
        if (!T(F))
          throw Error("Expected TableNode.");
        if (!this.editor.getElementByKey(this.tableNodeKey))
          throw Error("Expected to find TableElement in DOM");
        F = I.x;
        let P = I.y;
        if (this.focusCell = I, this.anchorCell !== null) {
          let O = _ ? (this.editor._window || window).getSelection() : null;
          O && O.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
        }
        if (!this.isHighlightingCells && (this.anchorX !== F || this.anchorY !== P || z))
          this.isHighlightingCells = !0, this.disableHighlightStyle();
        else if (F === this.focusX && P === this.focusY)
          return;
        this.focusX = F, this.focusY = P, this.isHighlightingCells && (F = e.$getNearestNodeFromDOMNode(I.elem), this.gridSelection != null && this.anchorCellNodeKey != null && a(F) && (F = F.getKey(), this.gridSelection = this.gridSelection.clone() || e.DEPRECATED_$createGridSelection(), this.focusCellNodeKey = F, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), e.$setSelection(this.gridSelection), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0), h(this.grid, this.gridSelection)));
      });
    }
    setAnchorCellForSelection(I) {
      this.isHighlightingCells = !1, this.anchorCell = I, this.anchorX = I.x, this.anchorY = I.y, this.editor.update(() => {
        var z = e.$getNearestNodeFromDOMNode(I.elem);
        a(z) && (z = z.getKey(), this.gridSelection = e.DEPRECATED_$createGridSelection(), this.anchorCellNodeKey = z);
      });
    }
    formatCells(I) {
      this.editor.update(() => {
        let z = e.$getSelection();
        e.DEPRECATED_$isGridSelection(z) || d(11);
        let F = e.$createRangeSelection(), P = F.anchor, O = F.focus;
        z.getNodes().forEach((V) => {
          a(V) && V.getTextContentSize() !== 0 && (P.set(V.getKey(), 0, "element"), O.set(V.getKey(), V.getChildrenSize(), "element"), F.formatText(I));
        }), e.$setSelection(z), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
    clearText() {
      this.editor.update(() => {
        let I = e.$getNodeByKey(this.tableNodeKey);
        if (!T(I))
          throw Error("Expected TableNode.");
        var z = e.$getSelection();
        e.DEPRECATED_$isGridSelection(z) || d(11), z = z.getNodes().filter(a), z.length === this.grid.columns * this.grid.rows ? (I.selectPrevious(), I.remove(), e.$getRoot().selectStart()) : (z.forEach((F) => {
          if (e.$isElementNode(F)) {
            let P = e.$createParagraphNode(), O = e.$createTextNode();
            P.append(O), F.append(P), F.getChildren().forEach((V) => {
              V !== P && V.remove();
            });
          }
        }), h(this.grid, null), e.$setSelection(null), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0));
      });
    }
  }
  function g(k) {
    for (; k != null; ) {
      let I = k.nodeName;
      if (I === "TD" || I === "TH") {
        if (k = k._cell, k === void 0)
          break;
        return k;
      }
      k = k.parentNode;
    }
    return null;
  }
  function f(k) {
    let I = [], z = { cells: I, columns: 0, rows: 0 };
    var F = k.firstChild;
    let P = k = 0;
    for (I.length = 0; F != null; ) {
      var O = F.nodeName;
      if (O === "TD" || O === "TH")
        O = { elem: F, highlighted: !1, x: k, y: P }, F._cell = O, I[P] === void 0 && (I[P] = []), I[P][k] = O;
      else if (O = F.firstChild, O != null) {
        F = O;
        continue;
      }
      if (O = F.nextSibling, O != null)
        k++, F = O;
      else if (O = F.parentNode, O != null) {
        if (F = O.nextSibling, F == null)
          break;
        P++, k = 0;
      }
    }
    return z.columns = k + 1, z.rows = P + 1, z;
  }
  function h(k, I) {
    let z = [], F = new Set(I ? I.getNodes() : []);
    return $(k, (P, O) => {
      let V = P.elem;
      F.has(O) ? (P.highlighted = !0, V.style.setProperty("background-color", "rgb(172, 206, 247)"), V.style.setProperty("caret-color", "transparent"), z.push(P)) : (P.highlighted = !1, V.style.removeProperty("background-color"), V.style.removeProperty("caret-color"), V.getAttribute("style") || V.removeAttribute("style"));
    }), z;
  }
  function $(k, I) {
    ({ cells: k } = k);
    for (let z = 0; z < k.length; z++) {
      let F = k[z];
      for (let P = 0; P < F.length; P++) {
        let O = F[P], V = e.$getNearestNodeFromDOMNode(O.elem);
        V !== null && I(O, V, { x: P, y: z });
      }
    }
  }
  function v(k) {
    k.disableHighlightStyle(), $(k.grid, (I) => {
      let z = I.elem;
      I.highlighted = !0, z.style.setProperty("background-color", "rgb(172, 206, 247)"), z.style.setProperty("caret-color", "transparent");
    });
  }
  function b(k) {
    k.enableHighlightStyle(), $(k.grid, (I) => {
      let z = I.elem;
      I.highlighted = !1, z.style.removeProperty("background-color"), z.style.removeProperty("caret-color"), z.getAttribute("style") || z.removeAttribute("style");
    });
  }
  let y = (k, I, z, F, P) => {
    const O = P === "forward";
    switch (P) {
      case "backward":
      case "forward":
        return z !== (O ? k.grid.columns - 1 : 0) ? M(I.getCellNodeFromCordsOrThrow(z + (O ? 1 : -1), F, k.grid)) : F !== (O ? k.grid.rows - 1 : 0) ? M(I.getCellNodeFromCordsOrThrow(O ? 0 : k.grid.columns - 1, F + (O ? 1 : -1), k.grid)) : O ? I.selectNext() : I.selectPrevious(), !0;
      case "up":
        return F !== 0 ? M(I.getCellNodeFromCordsOrThrow(z, F - 1, k.grid)) : I.selectPrevious(), !0;
      case "down":
        return F !== k.grid.rows - 1 ? M(I.getCellNodeFromCordsOrThrow(z, F + 1, k.grid)) : I.selectNext(), !0;
      default:
        return !1;
    }
  }, w = (k, I, z, F, P) => {
    const O = P === "forward";
    switch (P) {
      case "backward":
      case "forward":
        return z !== (O ? k.grid.columns - 1 : 0) && k.setFocusCellForSelection(I.getCellFromCordsOrThrow(z + (O ? 1 : -1), F, k.grid)), !0;
      case "up":
        return F !== 0 ? (k.setFocusCellForSelection(I.getCellFromCordsOrThrow(z, F - 1, k.grid)), !0) : !1;
      case "down":
        return F !== k.grid.rows - 1 ? (k.setFocusCellForSelection(I.getCellFromCordsOrThrow(z, F + 1, k.grid)), !0) : !1;
      default:
        return !1;
    }
  };
  function N(k, I) {
    if (e.$isRangeSelection(k) || e.DEPRECATED_$isGridSelection(k)) {
      let z = I.isParentOf(k.anchor.getNode());
      return k = I.isParentOf(k.focus.getNode()), z && k;
    }
    return !1;
  }
  function M(k) {
    let I = k.getChildren().find((z) => e.$isParagraphNode(z));
    e.$isParagraphNode(I) ? I.selectEnd() : k.selectEnd();
  }
  class q extends e.DEPRECATED_GridNode {
    static getType() {
      return "table";
    }
    static clone(I) {
      return new q(I.__key);
    }
    static importDOM() {
      return { table: () => ({ conversion: L, priority: 1 }) };
    }
    static importJSON() {
      return R();
    }
    constructor(I) {
      super(I);
    }
    exportJSON() {
      return { ...super.exportJSON(), type: "table", version: 1 };
    }
    createDOM(I) {
      let z = document.createElement("table");
      return t.addClassNamesToElement(z, I.theme.table), z;
    }
    updateDOM() {
      return !1;
    }
    exportDOM(I) {
      return { ...super.exportDOM(I), after: (z) => {
        if (z) {
          let F = z.cloneNode(), P = document.createElement("colgroup"), O = document.createElement("tbody");
          if (O.append(...z.children), z = this.getFirstChildOrThrow(), !u(z))
            throw Error("Expected to find row node.");
          z = z.getChildrenSize();
          for (let V = 0; V < z; V++) {
            let U = document.createElement("col");
            P.append(U);
          }
          return F.replaceChildren(P, O), F;
        }
      } };
    }
    canExtractContents() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isShadowRoot() {
      return !0;
    }
    getCordsFromCellNode(I, z) {
      let { rows: F, cells: P } = z;
      for (z = 0; z < F; z++) {
        var O = P[z];
        if (O == null)
          throw Error(`Row not found at y:${z}`);
        if (O = O.findIndex(({ elem: V }) => e.$getNearestNodeFromDOMNode(V) === I), O !== -1)
          return { x: O, y: z };
      }
      throw Error("Cell not found in table.");
    }
    getCellFromCords(I, z, F) {
      return { cells: F } = F, z = F[z], z == null ? null : (I = z[I], I ?? null);
    }
    getCellFromCordsOrThrow(I, z, F) {
      if (I = this.getCellFromCords(I, z, F), !I)
        throw Error("Cell not found at cords.");
      return I;
    }
    getCellNodeFromCords(I, z, F) {
      return I = this.getCellFromCords(I, z, F), I == null ? null : (I = e.$getNearestNodeFromDOMNode(I.elem), a(I) ? I : null);
    }
    getCellNodeFromCordsOrThrow(I, z, F) {
      if (I = this.getCellNodeFromCords(I, z, F), !I)
        throw Error("Node at cords not TableCellNode.");
      return I;
    }
    canSelectBefore() {
      return !0;
    }
    canIndent() {
      return !1;
    }
  }
  function L() {
    return { node: R() };
  }
  function R() {
    return e.$applyNodeReplacement(new q());
  }
  function T(k) {
    return k instanceof q;
  }
  function D(k) {
    if (k = t.$findMatchingParent(k, (I) => u(I)), u(k))
      return k;
    throw Error("Expected table cell to be inside of table row.");
  }
  function A(k) {
    if (k = t.$findMatchingParent(k, (I) => T(I)), T(k))
      return k;
    throw Error("Expected table cell to be inside of table.");
  }
  function S(k, I) {
    let z = A(k), { x: F, y: P } = z.getCordsFromCellNode(k, I);
    return { above: z.getCellNodeFromCords(F, P - 1, I), below: z.getCellNodeFromCords(F, P + 1, I), left: z.getCellNodeFromCords(F - 1, P, I), right: z.getCellNodeFromCords(F + 1, P, I) };
  }
  function E(k) {
    if (k = k.getFirstDescendant(), k === null)
      throw Error("Unexpected empty cell");
    k.getParentOrThrow().selectStart();
  }
  let x = e.createCommand("INSERT_TABLE_COMMAND");
  return qr.$createTableCellNode = i, qr.$createTableNode = R, qr.$createTableNodeWithDimensions = function(k, I, z = !0) {
    let F = R();
    for (let O = 0; O < k; O++) {
      let V = l();
      for (let U = 0; U < I; U++) {
        var P = n.NO_STATUS;
        typeof z == "object" ? (O === 0 && z.rows && (P |= n.ROW), U === 0 && z.columns && (P |= n.COLUMN)) : z && (O === 0 && (P |= n.ROW), U === 0 && (P |= n.COLUMN)), P = i(P);
        let H = e.$createParagraphNode();
        H.append(e.$createTextNode()), P.append(H), V.append(P);
      }
      F.append(V);
    }
    return F;
  }, qr.$createTableRowNode = l, qr.$deleteTableColumn = function(k, I) {
    let z = k.getChildren();
    for (let P = 0; P < z.length; P++) {
      var F = z[P];
      if (u(F)) {
        if (F = F.getChildren(), I >= F.length || 0 > I)
          throw Error("Table column target index out of range");
        F[I].remove();
      }
    }
    return k;
  }, qr.$deleteTableColumn__EXPERIMENTAL = function() {
    var k = e.$getSelection();
    if (!e.$isRangeSelection(k) && !e.DEPRECATED_$isGridSelection(k))
      throw Error("Expected a RangeSelection or GridSelection");
    var I = k.anchor.getNode();
    k = k.focus.getNode();
    let [z, , F] = e.DEPRECATED_$getNodeTriplet(I);
    [I] = e.DEPRECATED_$getNodeTriplet(k);
    let [P, O, V] = e.DEPRECATED_$computeGridMap(F, z, I);
    var { startColumn: U } = O;
    let { startRow: H, startColumn: J } = V;
    k = Math.min(U, J), U = Math.max(U + z.__colSpan - 1, J + I.__colSpan - 1);
    let le = U - k + 1;
    if (P[0].length === U - k + 1)
      F.selectPrevious(), F.remove();
    else {
      var ae = P.length;
      for (let Y = 0; Y < ae; Y++)
        for (let re = k; re <= U; re++) {
          let { cell: ie, startColumn: _e } = P[Y][re];
          _e < k ? re === k && ie.setColSpan(ie.__colSpan - Math.min(le, ie.__colSpan - (k - _e))) : _e + ie.__colSpan - 1 > U ? re === U && ie.setColSpan(ie.__colSpan - (U - _e + 1)) : ie.remove();
        }
      k = P[H], I = k[J + I.__colSpan], I !== void 0 ? ({ cell: I } = I, E(I)) : ({ cell: I } = k[J - 1], E(I));
    }
  }, qr.$deleteTableRow__EXPERIMENTAL = function() {
    var k = e.$getSelection();
    if (!e.$isRangeSelection(k) && !e.DEPRECATED_$isGridSelection(k))
      throw Error("Expected a RangeSelection or GridSelection");
    var I = k.anchor.getNode();
    k = k.focus.getNode();
    let [z, , F] = e.DEPRECATED_$getNodeTriplet(I);
    [k] = e.DEPRECATED_$getNodeTriplet(k);
    let [P, O, V] = e.DEPRECATED_$computeGridMap(F, z, k);
    ({ startRow: I } = O);
    var { startRow: U } = V;
    if (k = U + k.__rowSpan - 1, P.length === k - I + 1)
      F.remove();
    else {
      U = P[0].length;
      var H = P[k + 1], J = F.getChildAtIndex(k + 1);
      if (!e.DEPRECATED_$isGridRowNode(J))
        throw Error(`Expected GridNode childAtIndex(${String(k + 1)}) to be RowNode`);
      for (let re = k; re >= I; re--) {
        for (var le = U - 1; 0 <= le; le--) {
          let { cell: ie, startRow: _e, startColumn: he } = P[re][le];
          if (he === le && (re === I && _e < I && ie.setRowSpan(ie.__rowSpan - (_e - I)), _e >= I && _e + ie.__rowSpan - 1 > k))
            if (ie.setRowSpan(ie.__rowSpan - (k - _e + 1)), le === 0) {
              var ae = J, Y = ie;
              let be = ae.getFirstChild();
              be !== null ? ae.insertBefore(be) : ae.append(Y);
            } else
              ({ cell: ae } = H[le - 1]), ae.insertAfter(ie);
        }
        if (le = F.getChildAtIndex(re), !e.DEPRECATED_$isGridRowNode(le))
          throw Error(`Expected GridNode childAtIndex(${String(re)}) to be RowNode`);
        le.remove();
      }
      H !== void 0 ? ({ cell: I } = H[0], E(I)) : ({ cell: I } = P[I - 1][0], E(I));
    }
  }, qr.$getElementGridForTableNode = function(k, I) {
    if (k = k.getElementByKey(I.getKey()), k == null)
      throw Error("Table Element Not Found");
    return f(k);
  }, qr.$getTableCellNodeFromLexicalNode = function(k) {
    return k = t.$findMatchingParent(k, (I) => a(I)), a(k) ? k : null;
  }, qr.$getTableColumnIndexFromTableCellNode = function(k) {
    return D(k).getChildren().findIndex((I) => I.is(k));
  }, qr.$getTableNodeFromLexicalNodeOrThrow = A, qr.$getTableRowIndexFromTableCellNode = function(k) {
    let I = D(k);
    return A(I).getChildren().findIndex((z) => z.is(I));
  }, qr.$getTableRowNodeFromTableCellNodeOrThrow = D, qr.$insertTableColumn = function(k, I, z = !0, F, P) {
    let O = k.getChildren();
    for (let H = 0; H < O.length; H++) {
      let J = O[H];
      if (u(J))
        for (let le = 0; le < F; le++) {
          var V = J.getChildren();
          if (I >= V.length || 0 > I)
            throw Error("Table column target index out of range");
          V = V[I], a(V) || d(12);
          let { left: ae, right: Y } = S(V, P);
          var U = n.NO_STATUS;
          (ae && ae.hasHeaderState(n.ROW) || Y && Y.hasHeaderState(n.ROW)) && (U |= n.ROW), U = i(U), U.append(e.$createParagraphNode()), z ? V.insertAfter(U) : V.insertBefore(U);
        }
    }
    return k;
  }, qr.$insertTableColumn__EXPERIMENTAL = function(k = !0) {
    var I = e.$getSelection();
    if (!e.$isRangeSelection(I) && !e.DEPRECATED_$isGridSelection(I))
      throw Error("Expected a RangeSelection or GridSelection");
    I = I.focus.getNode();
    let [z, , F] = e.DEPRECATED_$getNodeTriplet(I), [P, O] = e.DEPRECATED_$computeGridMap(F, z, z);
    I = P.length;
    var { startColumn: V } = O;
    if (k)
      for (k = V + z.__colSpan - 1, V = 0; V < I; V++) {
        let { cell: U, startColumn: H } = P[V][k];
        H + U.__colSpan - 1 <= k ? U.insertAfter(i(n.NO_STATUS)) : U.setColSpan(U.__colSpan + 1);
      }
    else
      for (k = 0; k < I; k++) {
        let { cell: U, startColumn: H } = P[k][V];
        H === V ? U.insertBefore(i(n.NO_STATUS)) : U.setColSpan(U.__colSpan + 1);
      }
  }, qr.$insertTableRow = function(k, I, z = !0, F, P) {
    var O = k.getChildren();
    if (I >= O.length || 0 > I)
      throw Error("Table row target index out of range");
    if (I = O[I], u(I))
      for (O = 0; O < F; O++) {
        let U = I.getChildren(), H = U.length, J = l();
        for (let le = 0; le < H; le++) {
          var V = U[le];
          a(V) || d(12);
          let { above: ae, below: Y } = S(V, P);
          V = n.NO_STATUS;
          let re = ae && ae.getWidth() || Y && Y.getWidth() || void 0;
          (ae && ae.hasHeaderState(n.COLUMN) || Y && Y.hasHeaderState(n.COLUMN)) && (V |= n.COLUMN), V = i(V, 1, re), V.append(e.$createParagraphNode()), J.append(V);
        }
        z ? I.insertAfter(J) : I.insertBefore(J);
      }
    else
      throw Error("Row before insertion index does not exist.");
    return k;
  }, qr.$insertTableRow__EXPERIMENTAL = function(k = !0) {
    var I = e.$getSelection();
    if (!e.$isRangeSelection(I) && !e.DEPRECATED_$isGridSelection(I))
      throw Error("Expected a RangeSelection or GridSelection");
    I = I.focus.getNode();
    let [z, , F] = e.DEPRECATED_$getNodeTriplet(I), [P, O] = e.DEPRECATED_$computeGridMap(F, z, z);
    I = P[0].length;
    var { startRow: V } = O;
    if (k) {
      k = V + z.__rowSpan - 1;
      var U = P[k];
      V = l();
      for (var H = 0; H < I; H++) {
        let { cell: J, startRow: le } = U[H];
        le + J.__rowSpan - 1 <= k ? V.append(i(n.NO_STATUS)) : J.setRowSpan(J.__rowSpan + 1);
      }
      if (I = F.getChildAtIndex(k), !e.DEPRECATED_$isGridRowNode(I))
        throw Error("focusEndRow is not a GridRowNode");
      I.insertAfter(V);
    } else {
      for (U = P[V], k = l(), H = 0; H < I; H++) {
        let { cell: J, startRow: le } = U[H];
        le === V ? k.append(i(n.NO_STATUS)) : J.setRowSpan(J.__rowSpan + 1);
      }
      if (I = F.getChildAtIndex(V), !e.DEPRECATED_$isGridRowNode(I))
        throw Error("focusEndRow is not a GridRowNode");
      I.insertBefore(k);
    }
  }, qr.$isTableCellNode = a, qr.$isTableNode = T, qr.$isTableRowNode = u, qr.$removeTableRowAtIndex = function(k, I) {
    let z = k.getChildren();
    if (I >= z.length || 0 > I)
      throw Error("Expected table cell to be inside of table row.");
    return z[I].remove(), k;
  }, qr.INSERT_TABLE_COMMAND = x, qr.TableCellHeaderStates = n, qr.TableCellNode = o, qr.TableNode = q, qr.TableRowNode = s, qr.TableSelection = p, qr.applyTableHandlers = function(k, I, z) {
    let F = z.getRootElement();
    if (F === null)
      throw Error("No root element.");
    let P = new p(z, k.getKey());
    I.__lexicalTableSelection = P;
    let O = !1, V = !1;
    I.addEventListener("dblclick", (ae) => {
      let Y = g(ae.target);
      Y !== null && (ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), P.setAnchorCellForSelection(Y), P.setFocusCellForSelection(Y, !0), O = !1);
    }), I.addEventListener("mousedown", (ae) => {
      setTimeout(() => {
        if (ae.button === 0) {
          var Y = g(ae.target);
          Y !== null && (ae.preventDefault(), ae.stopPropagation(), ae.stopImmediatePropagation(), P.setAnchorCellForSelection(Y));
        }
      }, 0);
    }), I.addEventListener("mousemove", (ae) => {
      if (V && (ae.preventDefault(), ae.stopPropagation(), ae.stopImmediatePropagation()), O) {
        let Y = g(ae.target);
        if (Y !== null) {
          let re = Y.x, ie = Y.y;
          O && (P.anchorX !== re || P.anchorY !== ie || P.isHighlightingCells) && (ae.preventDefault(), P.setFocusCellForSelection(Y));
        }
      }
    }), I.addEventListener("mouseleave", () => {
    });
    let U = (ae) => {
      ae.button === 0 && z.update(() => {
        var Y = e.$getSelection();
        const re = ae.target;
        if (re instanceof Node) {
          if (e.DEPRECATED_$isGridSelection(Y) && Y.gridKey === P.tableNodeKey && F.contains(re))
            return P.clearHighlight();
          Y = e.$getNearestNodeFromDOMNode(re), Y !== null && t.$findMatchingParent(Y, e.DEPRECATED_$isGridNode) && (O = !0);
        }
      });
    };
    window.addEventListener("mousedown", U), P.listenersToRemove.add(() => window.removeEventListener("mousedown", U));
    let H = (ae) => {
      O && (ae.preventDefault(), ae.stopPropagation()), O = !1;
    };
    window.addEventListener("mouseup", H), P.listenersToRemove.add(() => window.removeEventListener("mouseup", H)), I.addEventListener("mouseup", H), P.listenersToRemove.add(() => I.removeEventListener("mouseup", H)), P.listenersToRemove.add(z.registerCommand(e.KEY_ARROW_DOWN_COMMAND, (ae) => {
      var Y = e.$getSelection();
      if (!N(Y, k))
        return !1;
      if (e.$isRangeSelection(Y)) {
        if (Y.isCollapsed()) {
          var re = t.$findMatchingParent(Y.anchor.getNode(), (_e) => a(_e));
          if (!a(re))
            return !1;
          var ie = k.getCordsFromCellNode(re, P.grid);
          if (Y = t.$findMatchingParent(Y.anchor.getNode(), (_e) => e.$isElementNode(_e)), Y == null)
            throw Error("Expected BlockNode Parent");
          if ((re = re.getLastChild()) && Y.isParentOf(re) || Y === re || ae.shiftKey)
            return ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), ae.shiftKey ? (P.setAnchorCellForSelection(k.getCellFromCordsOrThrow(ie.x, ie.y, P.grid)), w(P, k, ie.x, ie.y, "down")) : y(P, k, ie.x, ie.y, "down");
        }
      } else if (e.DEPRECATED_$isGridSelection(Y) && ae.shiftKey)
        return ie = Y.focus.getNode(), a(ie) ? (ie = k.getCordsFromCellNode(ie, P.grid), ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), w(P, k, ie.x, ie.y, "down")) : !1;
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), P.listenersToRemove.add(z.registerCommand(
      e.KEY_ARROW_UP_COMMAND,
      (ae) => {
        var Y = e.$getSelection();
        if (!N(Y, k))
          return !1;
        if (e.$isRangeSelection(Y)) {
          if (Y.isCollapsed()) {
            var re = t.$findMatchingParent(Y.anchor.getNode(), (_e) => a(_e));
            if (!a(re))
              return !1;
            var ie = k.getCordsFromCellNode(re, P.grid);
            if (Y = t.$findMatchingParent(Y.anchor.getNode(), (_e) => e.$isElementNode(_e)), Y == null)
              throw Error("Expected BlockNode Parent");
            if ((re = re.getLastChild()) && Y.isParentOf(re) || Y === re || ae.shiftKey)
              return ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), ae.shiftKey ? (P.setAnchorCellForSelection(k.getCellFromCordsOrThrow(
                ie.x,
                ie.y,
                P.grid
              )), w(P, k, ie.x, ie.y, "up")) : y(P, k, ie.x, ie.y, "up");
          }
        } else if (e.DEPRECATED_$isGridSelection(Y) && ae.shiftKey)
          return ie = Y.focus.getNode(), a(ie) ? (ie = k.getCordsFromCellNode(ie, P.grid), ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), w(P, k, ie.x, ie.y, "up")) : !1;
        return !1;
      },
      e.COMMAND_PRIORITY_HIGH
    )), P.listenersToRemove.add(z.registerCommand(e.KEY_ARROW_LEFT_COMMAND, (ae) => {
      var Y = e.$getSelection();
      if (!N(Y, k))
        return !1;
      if (e.$isRangeSelection(Y)) {
        if (Y.isCollapsed()) {
          var re = t.$findMatchingParent(
            Y.anchor.getNode(),
            (ie) => a(ie)
          );
          if (!a(re))
            return !1;
          if (re = k.getCordsFromCellNode(re, P.grid), t.$findMatchingParent(Y.anchor.getNode(), (ie) => e.$isElementNode(ie)) == null)
            throw Error("Expected BlockNode Parent");
          if (Y.anchor.offset === 0 || ae.shiftKey)
            return ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), ae.shiftKey ? (P.setAnchorCellForSelection(k.getCellFromCordsOrThrow(re.x, re.y, P.grid)), w(P, k, re.x, re.y, "backward")) : y(P, k, re.x, re.y, "backward");
        }
      } else if (e.DEPRECATED_$isGridSelection(Y) && ae.shiftKey)
        return Y = Y.focus.getNode(), a(Y) ? (Y = k.getCordsFromCellNode(Y, P.grid), ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), w(P, k, Y.x, Y.y, "backward")) : !1;
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), P.listenersToRemove.add(z.registerCommand(
      e.KEY_ARROW_RIGHT_COMMAND,
      (ae) => {
        var Y = e.$getSelection();
        if (!N(Y, k))
          return !1;
        if (e.$isRangeSelection(Y)) {
          if (Y.isCollapsed()) {
            var re = t.$findMatchingParent(Y.anchor.getNode(), (ie) => a(ie));
            if (!a(re))
              return !1;
            if (re = k.getCordsFromCellNode(re, P.grid), t.$findMatchingParent(Y.anchor.getNode(), (ie) => e.$isElementNode(ie)) == null)
              throw Error("Expected BlockNode Parent");
            if (Y.anchor.offset === Y.anchor.getNode().getTextContentSize() || ae.shiftKey)
              return ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), ae.shiftKey ? (P.setAnchorCellForSelection(k.getCellFromCordsOrThrow(re.x, re.y, P.grid)), w(P, k, re.x, re.y, "forward")) : y(P, k, re.x, re.y, "forward");
          }
        } else if (e.DEPRECATED_$isGridSelection(Y) && ae.shiftKey)
          return Y = Y.focus.getNode(), a(Y) ? (Y = k.getCordsFromCellNode(Y, P.grid), ae.preventDefault(), ae.stopImmediatePropagation(), ae.stopPropagation(), w(P, k, Y.x, Y.y, "forward")) : !1;
        return !1;
      },
      e.COMMAND_PRIORITY_HIGH
    ));
    let J = (ae) => () => {
      var Y = e.$getSelection();
      if (!N(Y, k))
        return !1;
      if (e.DEPRECATED_$isGridSelection(Y))
        return P.clearText(), !0;
      if (e.$isRangeSelection(Y)) {
        const _e = t.$findMatchingParent(Y.anchor.getNode(), (he) => a(he));
        if (!a(_e))
          return !1;
        var re = Y.anchor.getNode(), ie = Y.focus.getNode();
        if (re = k.isParentOf(re), ie = k.isParentOf(ie), re && !ie || ie && !re)
          return P.clearText(), !0;
        if (re = (ie = t.$findMatchingParent(Y.anchor.getNode(), (he) => e.$isElementNode(he))) && t.$findMatchingParent(ie, (he) => e.$isElementNode(he) && a(he.getParent())), !e.$isElementNode(re) || !e.$isElementNode(ie))
          return !1;
        if (ae === e.DELETE_LINE_COMMAND && re.getPreviousSibling() === null)
          return !0;
        if ((ae === e.DELETE_CHARACTER_COMMAND || ae === e.DELETE_WORD_COMMAND) && Y.isCollapsed() && Y.anchor.offset === 0 && ie !== re) {
          Y = ie.getChildren();
          const he = e.$createParagraphNode();
          return Y.forEach((be) => he.append(be)), ie.replace(he), ie.getWritable().__parent = _e.getKey(), !0;
        }
      }
      return !1;
    };
    [e.DELETE_WORD_COMMAND, e.DELETE_LINE_COMMAND, e.DELETE_CHARACTER_COMMAND].forEach((ae) => {
      P.listenersToRemove.add(z.registerCommand(
        ae,
        J(ae),
        e.COMMAND_PRIORITY_CRITICAL
      ));
    });
    let le = (ae) => {
      const Y = e.$getSelection();
      return N(Y, k) ? e.DEPRECATED_$isGridSelection(Y) ? (ae.preventDefault(), ae.stopPropagation(), P.clearText(), !0) : (e.$isRangeSelection(Y) && (ae = t.$findMatchingParent(Y.anchor.getNode(), (re) => a(re)), a(ae)), !1) : !1;
    };
    return P.listenersToRemove.add(z.registerCommand(e.KEY_BACKSPACE_COMMAND, le, e.COMMAND_PRIORITY_CRITICAL)), P.listenersToRemove.add(z.registerCommand(e.KEY_DELETE_COMMAND, le, e.COMMAND_PRIORITY_CRITICAL)), P.listenersToRemove.add(z.registerCommand(
      e.FORMAT_TEXT_COMMAND,
      (ae) => {
        let Y = e.$getSelection();
        return N(Y, k) ? e.DEPRECATED_$isGridSelection(Y) ? (P.formatCells(ae), !0) : (e.$isRangeSelection(Y) && (ae = t.$findMatchingParent(Y.anchor.getNode(), (re) => a(re)), a(ae)), !1) : !1;
      },
      e.COMMAND_PRIORITY_CRITICAL
    )), P.listenersToRemove.add(z.registerCommand(
      e.CONTROLLED_TEXT_INSERTION_COMMAND,
      () => {
        var ae = e.$getSelection();
        return N(ae, k) && (e.DEPRECATED_$isGridSelection(ae) ? P.clearHighlight() : e.$isRangeSelection(ae) && (ae = t.$findMatchingParent(ae.anchor.getNode(), (Y) => a(Y)), a(ae))), !1;
      },
      e.COMMAND_PRIORITY_CRITICAL
    )), P.listenersToRemove.add(z.registerCommand(e.KEY_TAB_COMMAND, (ae) => {
      var Y = e.$getSelection();
      if (!N(Y, k))
        return !1;
      if (e.$isRangeSelection(Y)) {
        let re = t.$findMatchingParent(Y.anchor.getNode(), (ie) => a(ie));
        if (!a(re))
          return !1;
        if (Y.isCollapsed())
          return Y = k.getCordsFromCellNode(re, P.grid), ae.preventDefault(), y(P, k, Y.x, Y.y, ae.shiftKey ? "backward" : "forward"), !0;
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), P.listenersToRemove.add(z.registerCommand(e.FOCUS_COMMAND, () => k.isSelected(), e.COMMAND_PRIORITY_HIGH)), P.listenersToRemove.add(z.registerCommand(e.SELECTION_CHANGE_COMMAND, () => {
      let ae = e.$getSelection();
      var Y = e.$getPreviousSelection();
      if (ae && e.$isRangeSelection(ae) && !ae.isCollapsed()) {
        var re = ae.anchor.getNode(), ie = ae.focus.getNode();
        re = k.isParentOf(re);
        var _e = k.isParentOf(ie);
        if (ie = re && !_e || _e && !re, re = re && _e && !k.isSelected(), ie)
          return Y = ae.isBackward(), re = e.$createRangeSelection(), ie = k.getKey(), re.anchor.set(ae.anchor.key, ae.anchor.offset, ae.anchor.type), re.focus.set(ie, Y ? 0 : k.getChildrenSize(), "element"), V = !0, e.$setSelection(re), v(P), !0;
        if (re && ({ grid: re } = P, ae.getNodes().filter(a).length === re.rows * re.columns)) {
          re = e.DEPRECATED_$createGridSelection(), ie = k.getKey(), _e = k.getFirstChildOrThrow().getFirstChild();
          let he = k.getLastChildOrThrow().getLastChild();
          if (_e != null && he != null)
            return re.set(ie, _e.getKey(), he.getKey()), e.$setSelection(re), P.updateTableGridSelection(re), !0;
        }
      }
      return ae && !ae.is(Y) && (e.DEPRECATED_$isGridSelection(ae) || e.DEPRECATED_$isGridSelection(Y)) && P.gridSelection && !P.gridSelection.is(Y) ? (e.DEPRECATED_$isGridSelection(ae) && ae.gridKey === P.tableNodeKey ? P.updateTableGridSelection(ae) : !e.DEPRECATED_$isGridSelection(ae) && e.DEPRECATED_$isGridSelection(Y) && Y.gridKey === P.tableNodeKey && P.updateTableGridSelection(null), !1) : (P.hasHijackedSelectionStyles && !k.isSelected() ? (b(P), V = !1) : !P.hasHijackedSelectionStyles && k.isSelected() && v(P), !1);
    }, e.COMMAND_PRIORITY_CRITICAL)), P;
  }, qr.getCellFromTarget = g, qr.getTableSelectionFromTableElement = function(k) {
    return k.__lexicalTableSelection;
  }, qr;
}
var jr = {}, eQ;
function BYl() {
  if (eQ)
    return jr;
  eQ = 1;
  var e = lr(), t = Ci();
  const n = {
    BOTH: 3,
    COLUMN: 2,
    NO_STATUS: 0,
    ROW: 1
  };
  class o extends e.DEPRECATED_GridCellNode {
    /** @internal */
    /** @internal */
    static getType() {
      return "tablecell";
    }
    static clone(me) {
      const ne = new o(me.__headerState, me.__colSpan, me.__width, me.__key);
      return ne.__rowSpan = me.__rowSpan, ne;
    }
    static importDOM() {
      return {
        td: (me) => ({
          conversion: r,
          priority: 0
        }),
        th: (me) => ({
          conversion: r,
          priority: 0
        })
      };
    }
    static importJSON(me) {
      return i(me.headerState, me.colSpan, me.width || void 0);
    }
    constructor(me = n.NO_STATUS, ne = 1, pe, ge) {
      super(ne, ge), this.__headerState = me, this.__width = pe;
    }
    createDOM(me) {
      const ne = document.createElement(this.getTag());
      return this.__width && (ne.style.width = `${this.__width}px`), this.__colSpan !== 1 && (ne.colSpan = this.__colSpan), this.__rowSpan !== 1 && (ne.rowSpan = this.__rowSpan), t.addClassNamesToElement(ne, me.theme.tableCell, this.hasHeader() && me.theme.tableCellHeader), ne;
    }
    exportDOM(me) {
      const {
        element: ne
      } = super.exportDOM(me);
      if (ne) {
        const pe = ne, ge = 700, ve = this.getParentOrThrow().getChildrenSize();
        pe.style.border = "1px solid black", this.__colSpan !== 1 && (pe.colSpan = this.__colSpan), this.__rowSpan !== 1 && (pe.rowSpan = this.__rowSpan), pe.style.width = `${this.getWidth() || Math.max(90, ge / ve)}px`, pe.style.verticalAlign = "top", pe.style.textAlign = "start", this.hasHeader() && (pe.style.backgroundColor = "#f2f3f5");
      }
      return {
        element: ne
      };
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        colSpan: super.__colSpan,
        headerState: this.__headerState,
        type: "tablecell",
        width: this.getWidth()
      };
    }
    getTag() {
      return this.hasHeader() ? "th" : "td";
    }
    setHeaderStyles(me) {
      const ne = this.getWritable();
      return ne.__headerState = me, this.__headerState;
    }
    getHeaderStyles() {
      return this.getLatest().__headerState;
    }
    setWidth(me) {
      const ne = this.getWritable();
      return ne.__width = me, this.__width;
    }
    getWidth() {
      return this.getLatest().__width;
    }
    toggleHeaderStyle(me) {
      const ne = this.getWritable();
      return (ne.__headerState & me) === me ? ne.__headerState -= me : ne.__headerState += me, ne;
    }
    hasHeaderState(me) {
      return (this.getHeaderStyles() & me) === me;
    }
    hasHeader() {
      return this.getLatest().__headerState !== n.NO_STATUS;
    }
    updateDOM(me) {
      return me.__headerState !== this.__headerState || me.__width !== this.__width || me.__colSpan !== this.__colSpan || me.__rowSpan !== this.__rowSpan;
    }
    isShadowRoot() {
      return !0;
    }
    collapseAtStart() {
      return !0;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function r(Q) {
    const me = Q, ne = Q.nodeName.toLowerCase(), pe = i(ne === "th" ? n.ROW : n.NO_STATUS);
    return pe.__colSpan = me.colSpan, pe.__rowSpan = me.rowSpan, {
      forChild: (ge, ve) => {
        if (a(ve) && !e.$isElementNode(ge)) {
          const Te = e.$createParagraphNode();
          return e.$isLineBreakNode(ge) && ge.getTextContent() === `
` ? null : (Te.append(ge), Te);
        }
        return ge;
      },
      node: pe
    };
  }
  function i(Q, me = 1, ne) {
    return e.$applyNodeReplacement(new o(Q, me, ne));
  }
  function a(Q) {
    return Q instanceof o;
  }
  class s extends e.DEPRECATED_GridRowNode {
    /** @internal */
    static getType() {
      return "tablerow";
    }
    static clone(me) {
      return new s(me.__height, me.__key);
    }
    static importDOM() {
      return {
        tr: (me) => ({
          conversion: c,
          priority: 0
        })
      };
    }
    static importJSON(me) {
      return l(me.height);
    }
    constructor(me, ne) {
      super(ne), this.__height = me;
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "tablerow",
        version: 1
      };
    }
    createDOM(me) {
      const ne = document.createElement("tr");
      return this.__height && (ne.style.height = `${this.__height}px`), t.addClassNamesToElement(ne, me.theme.tableRow), ne;
    }
    isShadowRoot() {
      return !0;
    }
    setHeight(me) {
      const ne = this.getWritable();
      return ne.__height = me, this.__height;
    }
    getHeight() {
      return this.getLatest().__height;
    }
    updateDOM(me) {
      return me.__height !== this.__height;
    }
    canBeEmpty() {
      return !1;
    }
    canIndent() {
      return !1;
    }
  }
  function c(Q) {
    return {
      node: l()
    };
  }
  function l(Q) {
    return e.$applyNodeReplacement(new s(Q));
  }
  function u(Q) {
    return Q instanceof s;
  }
  const d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", _ = (Q) => d ? (Q || window).getSelection() : null;
  class p {
    constructor(me, ne) {
      this.isHighlightingCells = !1, this.anchorX = -1, this.anchorY = -1, this.focusX = -1, this.focusY = -1, this.listenersToRemove = /* @__PURE__ */ new Set(), this.tableNodeKey = ne, this.editor = me, this.grid = {
        cells: [],
        columns: 0,
        rows: 0
      }, this.gridSelection = null, this.anchorCellNodeKey = null, this.focusCellNodeKey = null, this.anchorCell = null, this.focusCell = null, this.hasHijackedSelectionStyles = !1, this.trackTableGrid();
    }
    getGrid() {
      return this.grid;
    }
    removeListeners() {
      Array.from(this.listenersToRemove).forEach((me) => me());
    }
    trackTableGrid() {
      const me = new MutationObserver((ne) => {
        this.editor.update(() => {
          let pe = !1;
          for (let ve = 0; ve < ne.length; ve++) {
            const Me = ne[ve].target.nodeName;
            if (Me === "TABLE" || Me === "TR") {
              pe = !0;
              break;
            }
          }
          if (!pe)
            return;
          const ge = this.editor.getElementByKey(this.tableNodeKey);
          if (!ge)
            throw new Error("Expected to find TableElement in DOM");
          this.grid = b(ge);
        });
      });
      this.editor.update(() => {
        const ne = this.editor.getElementByKey(this.tableNodeKey);
        if (!ne)
          throw new Error("Expected to find TableElement in DOM");
        this.grid = b(ne), me.observe(ne, {
          childList: !0,
          subtree: !0
        });
      });
    }
    clearHighlight() {
      this.isHighlightingCells = !1, this.anchorX = -1, this.anchorY = -1, this.focusX = -1, this.focusY = -1, this.gridSelection = null, this.anchorCellNodeKey = null, this.focusCellNodeKey = null, this.anchorCell = null, this.focusCell = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), this.editor.update(() => {
        const me = e.$getNodeByKey(this.tableNodeKey);
        if (!x(me))
          throw new Error("Expected TableNode.");
        const ne = this.editor.getElementByKey(this.tableNodeKey);
        if (!ne)
          throw new Error("Expected to find TableElement in DOM");
        const pe = b(ne);
        y(pe, null), e.$setSelection(null), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
    enableHighlightStyle() {
      this.editor.update(() => {
        const me = this.editor.getElementByKey(this.tableNodeKey);
        if (!me)
          throw new Error("Expected to find TableElement in DOM");
        me.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
      });
    }
    disableHighlightStyle() {
      this.editor.update(() => {
        const me = this.editor.getElementByKey(this.tableNodeKey);
        if (!me)
          throw new Error("Expected to find TableElement in DOM");
        me.classList.add("disable-selection"), this.hasHijackedSelectionStyles = !0;
      });
    }
    updateTableGridSelection(me) {
      me != null && me.gridKey === this.tableNodeKey ? (this.gridSelection = me, this.isHighlightingCells = !0, this.disableHighlightStyle(), y(this.grid, this.gridSelection)) : me == null && this.clearHighlight();
    }
    setFocusCellForSelection(me, ne = !1) {
      this.editor.update(() => {
        const pe = e.$getNodeByKey(this.tableNodeKey);
        if (!x(pe))
          throw new Error("Expected TableNode.");
        if (!this.editor.getElementByKey(this.tableNodeKey))
          throw new Error("Expected to find TableElement in DOM");
        const ve = me.x, Te = me.y;
        if (this.focusCell = me, this.anchorCell !== null) {
          const Re = _(this.editor._window);
          Re && Re.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
        }
        if (!this.isHighlightingCells && (this.anchorX !== ve || this.anchorY !== Te || ne))
          this.isHighlightingCells = !0, this.disableHighlightStyle();
        else if (ve === this.focusX && Te === this.focusY)
          return;
        if (this.focusX = ve, this.focusY = Te, this.isHighlightingCells) {
          const Re = e.$getNearestNodeFromDOMNode(me.elem);
          if (this.gridSelection != null && this.anchorCellNodeKey != null && a(Re)) {
            const Me = Re.getKey();
            this.gridSelection = this.gridSelection.clone() || e.DEPRECATED_$createGridSelection(), this.focusCellNodeKey = Me, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), e.$setSelection(this.gridSelection), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0), y(this.grid, this.gridSelection);
          }
        }
      });
    }
    setAnchorCellForSelection(me) {
      this.isHighlightingCells = !1, this.anchorCell = me, this.anchorX = me.x, this.anchorY = me.y, this.editor.update(() => {
        const ne = e.$getNearestNodeFromDOMNode(me.elem);
        if (a(ne)) {
          const pe = ne.getKey();
          this.gridSelection = e.DEPRECATED_$createGridSelection(), this.anchorCellNodeKey = pe;
        }
      });
    }
    formatCells(me) {
      this.editor.update(() => {
        const ne = e.$getSelection();
        if (!e.DEPRECATED_$isGridSelection(ne))
          throw Error("Expected grid selection");
        const pe = e.$createRangeSelection(), ge = pe.anchor, ve = pe.focus;
        ne.getNodes().forEach((Te) => {
          a(Te) && Te.getTextContentSize() !== 0 && (ge.set(Te.getKey(), 0, "element"), ve.set(Te.getKey(), Te.getChildrenSize(), "element"), pe.formatText(me));
        }), e.$setSelection(ne), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
    clearText() {
      this.editor.update(() => {
        const me = e.$getNodeByKey(this.tableNodeKey);
        if (!x(me))
          throw new Error("Expected TableNode.");
        const ne = e.$getSelection();
        if (!e.DEPRECATED_$isGridSelection(ne))
          throw Error("Expected grid selection");
        const pe = ne.getNodes().filter(a);
        if (pe.length === this.grid.columns * this.grid.rows) {
          me.selectPrevious(), me.remove(), e.$getRoot().selectStart();
          return;
        }
        pe.forEach((ge) => {
          if (e.$isElementNode(ge)) {
            const ve = e.$createParagraphNode(), Te = e.$createTextNode();
            ve.append(Te), ge.append(ve), ge.getChildren().forEach((Re) => {
              Re !== ve && Re.remove();
            });
          }
        }), y(this.grid, null), e.$setSelection(null), this.editor.dispatchCommand(e.SELECTION_CHANGE_COMMAND, void 0);
      });
    }
  }
  const g = "__lexicalTableSelection";
  function f(Q, me, ne) {
    const pe = ne.getRootElement();
    if (pe === null)
      throw new Error("No root element.");
    const ge = new p(ne, Q.getKey());
    h(me, ge);
    let ve = !1, Te = !1;
    me.addEventListener("dblclick", (De) => {
      const ze = v(De.target);
      ze !== null && (De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), ge.setAnchorCellForSelection(ze), ge.setFocusCellForSelection(ze, !0), ve = !1);
    }), me.addEventListener("mousedown", (De) => {
      setTimeout(() => {
        if (De.button !== 0)
          return;
        const ze = v(De.target);
        ze !== null && (De.preventDefault(), De.stopPropagation(), De.stopImmediatePropagation(), ge.setAnchorCellForSelection(ze));
      }, 0);
    }), me.addEventListener("mousemove", (De) => {
      if (Te && (De.preventDefault(), De.stopPropagation(), De.stopImmediatePropagation()), ve) {
        const ze = v(De.target);
        if (ze !== null) {
          const Pe = ze.x, je = ze.y;
          ve && (ge.anchorX !== Pe || ge.anchorY !== je || ge.isHighlightingCells) && (De.preventDefault(), ge.setFocusCellForSelection(ze));
        }
      }
    }), me.addEventListener("mouseleave", () => {
    });
    const Re = (De) => {
      De.button === 0 && ne.update(() => {
        const ze = e.$getSelection(), Pe = De.target;
        if (Pe instanceof Node) {
          if (e.DEPRECATED_$isGridSelection(ze) && ze.gridKey === ge.tableNodeKey && pe.contains(Pe))
            return ge.clearHighlight();
          const je = e.$getNearestNodeFromDOMNode(Pe);
          je !== null && t.$findMatchingParent(je, e.DEPRECATED_$isGridNode) && (ve = !0);
        }
      });
    };
    window.addEventListener("mousedown", Re), ge.listenersToRemove.add(() => window.removeEventListener("mousedown", Re));
    const Me = (De) => {
      ve && (De.preventDefault(), De.stopPropagation()), ve = !1;
    };
    window.addEventListener("mouseup", Me), ge.listenersToRemove.add(() => window.removeEventListener("mouseup", Me)), me.addEventListener("mouseup", Me), ge.listenersToRemove.add(() => me.removeEventListener("mouseup", Me)), ge.listenersToRemove.add(ne.registerCommand(e.KEY_ARROW_DOWN_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      const Pe = "down";
      if (e.$isRangeSelection(ze)) {
        if (ze.isCollapsed()) {
          const je = t.$findMatchingParent(ze.anchor.getNode(), (Je) => a(Je));
          if (!a(je))
            return !1;
          const He = Q.getCordsFromCellNode(je, ge.grid), Xe = t.$findMatchingParent(ze.anchor.getNode(), (Je) => e.$isElementNode(Je));
          if (Xe == null)
            throw new Error("Expected BlockNode Parent");
          const at = je.getLastChild();
          if (at && Xe.isParentOf(at) || Xe === at || De.shiftKey)
            return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), De.shiftKey ? (ge.setAnchorCellForSelection(Q.getCellFromCordsOrThrow(He.x, He.y, ge.grid)), L(ge, Q, He.x, He.y, Pe)) : q(ge, Q, He.x, He.y, Pe);
        }
      } else if (e.DEPRECATED_$isGridSelection(ze) && De.shiftKey) {
        const je = ze.focus.getNode();
        if (!a(je))
          return !1;
        const He = Q.getCordsFromCellNode(je, ge.grid);
        return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), L(ge, Q, He.x, He.y, Pe);
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), ge.listenersToRemove.add(ne.registerCommand(e.KEY_ARROW_UP_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      const Pe = "up";
      if (e.$isRangeSelection(ze)) {
        if (ze.isCollapsed()) {
          const je = t.$findMatchingParent(ze.anchor.getNode(), (Je) => a(Je));
          if (!a(je))
            return !1;
          const He = Q.getCordsFromCellNode(je, ge.grid), Xe = t.$findMatchingParent(ze.anchor.getNode(), (Je) => e.$isElementNode(Je));
          if (Xe == null)
            throw new Error("Expected BlockNode Parent");
          const at = je.getLastChild();
          if (at && Xe.isParentOf(at) || Xe === at || De.shiftKey)
            return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), De.shiftKey ? (ge.setAnchorCellForSelection(Q.getCellFromCordsOrThrow(He.x, He.y, ge.grid)), L(ge, Q, He.x, He.y, Pe)) : q(ge, Q, He.x, He.y, Pe);
        }
      } else if (e.DEPRECATED_$isGridSelection(ze) && De.shiftKey) {
        const je = ze.focus.getNode();
        if (!a(je))
          return !1;
        const He = Q.getCordsFromCellNode(je, ge.grid);
        return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), L(ge, Q, He.x, He.y, Pe);
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), ge.listenersToRemove.add(ne.registerCommand(e.KEY_ARROW_LEFT_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      const Pe = "backward";
      if (e.$isRangeSelection(ze)) {
        if (ze.isCollapsed()) {
          const je = t.$findMatchingParent(ze.anchor.getNode(), (at) => a(at));
          if (!a(je))
            return !1;
          const He = Q.getCordsFromCellNode(je, ge.grid);
          if (t.$findMatchingParent(ze.anchor.getNode(), (at) => e.$isElementNode(at)) == null)
            throw new Error("Expected BlockNode Parent");
          if (ze.anchor.offset === 0 || De.shiftKey)
            return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), De.shiftKey ? (ge.setAnchorCellForSelection(Q.getCellFromCordsOrThrow(He.x, He.y, ge.grid)), L(ge, Q, He.x, He.y, Pe)) : q(ge, Q, He.x, He.y, Pe);
        }
      } else if (e.DEPRECATED_$isGridSelection(ze) && De.shiftKey) {
        const je = ze.focus.getNode();
        if (!a(je))
          return !1;
        const He = Q.getCordsFromCellNode(je, ge.grid);
        return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), L(ge, Q, He.x, He.y, Pe);
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), ge.listenersToRemove.add(ne.registerCommand(e.KEY_ARROW_RIGHT_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      const Pe = "forward";
      if (e.$isRangeSelection(ze)) {
        if (ze.isCollapsed()) {
          const je = t.$findMatchingParent(ze.anchor.getNode(), (at) => a(at));
          if (!a(je))
            return !1;
          const He = Q.getCordsFromCellNode(je, ge.grid);
          if (t.$findMatchingParent(ze.anchor.getNode(), (at) => e.$isElementNode(at)) == null)
            throw new Error("Expected BlockNode Parent");
          if (ze.anchor.offset === ze.anchor.getNode().getTextContentSize() || De.shiftKey)
            return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), De.shiftKey ? (ge.setAnchorCellForSelection(Q.getCellFromCordsOrThrow(He.x, He.y, ge.grid)), L(ge, Q, He.x, He.y, Pe)) : q(ge, Q, He.x, He.y, Pe);
        }
      } else if (e.DEPRECATED_$isGridSelection(ze) && De.shiftKey) {
        const je = ze.focus.getNode();
        if (!a(je))
          return !1;
        const He = Q.getCordsFromCellNode(je, ge.grid);
        return De.preventDefault(), De.stopImmediatePropagation(), De.stopPropagation(), L(ge, Q, He.x, He.y, Pe);
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH));
    const et = (De) => () => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      if (e.DEPRECATED_$isGridSelection(ze))
        return ge.clearText(), !0;
      if (e.$isRangeSelection(ze)) {
        const Pe = t.$findMatchingParent(ze.anchor.getNode(), (Ot) => a(Ot));
        if (!a(Pe))
          return !1;
        const je = ze.anchor.getNode(), He = ze.focus.getNode(), Xe = Q.isParentOf(je), at = Q.isParentOf(He);
        if (Xe && !at || at && !Xe)
          return ge.clearText(), !0;
        const Je = t.$findMatchingParent(ze.anchor.getNode(), (Ot) => e.$isElementNode(Ot)), vt = Je && t.$findMatchingParent(Je, (Ot) => e.$isElementNode(Ot) && a(Ot.getParent()));
        if (!e.$isElementNode(vt) || !e.$isElementNode(Je))
          return !1;
        if (De === e.DELETE_LINE_COMMAND && vt.getPreviousSibling() === null)
          return !0;
        if ((De === e.DELETE_CHARACTER_COMMAND || De === e.DELETE_WORD_COMMAND) && ze.isCollapsed() && ze.anchor.offset === 0 && Je !== vt) {
          const Ot = Je.getChildren(), Ft = e.$createParagraphNode();
          return Ot.forEach((wn) => Ft.append(wn)), Je.replace(Ft), Je.getWritable().__parent = Pe.getKey(), !0;
        }
      }
      return !1;
    };
    [e.DELETE_WORD_COMMAND, e.DELETE_LINE_COMMAND, e.DELETE_CHARACTER_COMMAND].forEach((De) => {
      ge.listenersToRemove.add(ne.registerCommand(De, et(De), e.COMMAND_PRIORITY_CRITICAL));
    });
    const st = (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      if (e.DEPRECATED_$isGridSelection(ze))
        return De.preventDefault(), De.stopPropagation(), ge.clearText(), !0;
      if (e.$isRangeSelection(ze)) {
        const Pe = t.$findMatchingParent(ze.anchor.getNode(), (je) => a(je));
        if (!a(Pe))
          return !1;
      }
      return !1;
    };
    return ge.listenersToRemove.add(ne.registerCommand(e.KEY_BACKSPACE_COMMAND, st, e.COMMAND_PRIORITY_CRITICAL)), ge.listenersToRemove.add(ne.registerCommand(e.KEY_DELETE_COMMAND, st, e.COMMAND_PRIORITY_CRITICAL)), ge.listenersToRemove.add(ne.registerCommand(e.FORMAT_TEXT_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      if (e.DEPRECATED_$isGridSelection(ze))
        return ge.formatCells(De), !0;
      if (e.$isRangeSelection(ze)) {
        const Pe = t.$findMatchingParent(ze.anchor.getNode(), (je) => a(je));
        if (!a(Pe))
          return !1;
      }
      return !1;
    }, e.COMMAND_PRIORITY_CRITICAL)), ge.listenersToRemove.add(ne.registerCommand(e.CONTROLLED_TEXT_INSERTION_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      if (e.DEPRECATED_$isGridSelection(ze))
        return ge.clearHighlight(), !1;
      if (e.$isRangeSelection(ze)) {
        const Pe = t.$findMatchingParent(ze.anchor.getNode(), (je) => a(je));
        if (!a(Pe))
          return !1;
      }
      return !1;
    }, e.COMMAND_PRIORITY_CRITICAL)), ge.listenersToRemove.add(ne.registerCommand(e.KEY_TAB_COMMAND, (De) => {
      const ze = e.$getSelection();
      if (!R(ze, Q))
        return !1;
      if (e.$isRangeSelection(ze)) {
        const Pe = t.$findMatchingParent(ze.anchor.getNode(), (je) => a(je));
        if (!a(Pe))
          return !1;
        if (ze.isCollapsed()) {
          const je = Q.getCordsFromCellNode(Pe, ge.grid);
          return De.preventDefault(), q(ge, Q, je.x, je.y, De.shiftKey ? "backward" : "forward"), !0;
        }
      }
      return !1;
    }, e.COMMAND_PRIORITY_HIGH)), ge.listenersToRemove.add(ne.registerCommand(e.FOCUS_COMMAND, (De) => Q.isSelected(), e.COMMAND_PRIORITY_HIGH)), ge.listenersToRemove.add(ne.registerCommand(e.SELECTION_CHANGE_COMMAND, (De) => {
      const ze = e.$getSelection(), Pe = e.$getPreviousSelection();
      if (ze && e.$isRangeSelection(ze) && !ze.isCollapsed()) {
        const je = ze.anchor.getNode(), He = ze.focus.getNode(), Xe = Q.isParentOf(je), at = Q.isParentOf(He), wt = Xe && !at || at && !Xe, Je = Xe && at && !Q.isSelected();
        if (wt) {
          const vt = ze.isBackward(), Ot = e.$createRangeSelection(), Ft = Q.getKey();
          return Ot.anchor.set(ze.anchor.key, ze.anchor.offset, ze.anchor.type), Ot.focus.set(Ft, vt ? 0 : Q.getChildrenSize(), "element"), Te = !0, e.$setSelection(Ot), N(ge), !0;
        } else if (Je) {
          const {
            grid: vt
          } = ge;
          if (ze.getNodes().filter(a).length === vt.rows * vt.columns) {
            const Ot = e.DEPRECATED_$createGridSelection(), Ft = Q.getKey(), wn = Q.getFirstChildOrThrow().getFirstChild(), un = Q.getLastChildOrThrow().getLastChild();
            if (wn != null && un != null)
              return Ot.set(Ft, wn.getKey(), un.getKey()), e.$setSelection(Ot), ge.updateTableGridSelection(Ot), !0;
          }
        }
      }
      return ze && !ze.is(Pe) && (e.DEPRECATED_$isGridSelection(ze) || e.DEPRECATED_$isGridSelection(Pe)) && ge.gridSelection && !ge.gridSelection.is(Pe) ? (e.DEPRECATED_$isGridSelection(ze) && ze.gridKey === ge.tableNodeKey ? ge.updateTableGridSelection(ze) : !e.DEPRECATED_$isGridSelection(ze) && e.DEPRECATED_$isGridSelection(Pe) && Pe.gridKey === ge.tableNodeKey && ge.updateTableGridSelection(null), !1) : (ge.hasHijackedSelectionStyles && !Q.isSelected() ? (M(ge), Te = !1) : !ge.hasHijackedSelectionStyles && Q.isSelected() && N(ge), !1);
    }, e.COMMAND_PRIORITY_CRITICAL)), ge;
  }
  function h(Q, me) {
    Q[g] = me;
  }
  function $(Q) {
    return Q[g];
  }
  function v(Q) {
    let me = Q;
    for (; me != null; ) {
      const ne = me.nodeName;
      if (ne === "TD" || ne === "TH") {
        const pe = me._cell;
        return pe === void 0 ? null : pe;
      }
      me = me.parentNode;
    }
    return null;
  }
  function b(Q) {
    const me = [], ne = {
      cells: me,
      columns: 0,
      rows: 0
    };
    let pe = Q.firstChild, ge = 0, ve = 0;
    for (me.length = 0; pe != null; ) {
      const Te = pe.nodeName;
      if (Te === "TD" || Te === "TH") {
        const st = {
          elem: pe,
          highlighted: !1,
          x: ge,
          y: ve
        };
        pe._cell = st, me[ve] === void 0 && (me[ve] = []), me[ve][ge] = st;
      } else {
        const et = pe.firstChild;
        if (et != null) {
          pe = et;
          continue;
        }
      }
      const Re = pe.nextSibling;
      if (Re != null) {
        ge++, pe = Re;
        continue;
      }
      const Me = pe.parentNode;
      if (Me != null) {
        const et = Me.nextSibling;
        if (et == null)
          break;
        ve++, ge = 0, pe = et;
      }
    }
    return ne.columns = ge + 1, ne.rows = ve + 1, ne;
  }
  function y(Q, me) {
    const ne = [], pe = new Set(me ? me.getNodes() : []);
    return w(Q, (ge, ve) => {
      const Te = ge.elem;
      pe.has(ve) ? (ge.highlighted = !0, Te.style.setProperty("background-color", "rgb(172, 206, 247)"), Te.style.setProperty("caret-color", "transparent"), ne.push(ge)) : (ge.highlighted = !1, Te.style.removeProperty("background-color"), Te.style.removeProperty("caret-color"), Te.getAttribute("style") || Te.removeAttribute("style"));
    }), ne;
  }
  function w(Q, me) {
    const {
      cells: ne
    } = Q;
    for (let pe = 0; pe < ne.length; pe++) {
      const ge = ne[pe];
      for (let ve = 0; ve < ge.length; ve++) {
        const Te = ge[ve], Re = e.$getNearestNodeFromDOMNode(Te.elem);
        Re !== null && me(Te, Re, {
          x: ve,
          y: pe
        });
      }
    }
  }
  function N(Q) {
    Q.disableHighlightStyle(), w(Q.grid, (me) => {
      const ne = me.elem;
      me.highlighted = !0, ne.style.setProperty("background-color", "rgb(172, 206, 247)"), ne.style.setProperty("caret-color", "transparent");
    });
  }
  function M(Q) {
    Q.enableHighlightStyle(), w(Q.grid, (me) => {
      const ne = me.elem;
      me.highlighted = !1, ne.style.removeProperty("background-color"), ne.style.removeProperty("caret-color"), ne.getAttribute("style") || ne.removeAttribute("style");
    });
  }
  const q = (Q, me, ne, pe, ge) => {
    const ve = ge === "forward";
    switch (ge) {
      case "backward":
      case "forward":
        return ne !== (ve ? Q.grid.columns - 1 : 0) ? T(me.getCellNodeFromCordsOrThrow(ne + (ve ? 1 : -1), pe, Q.grid)) : pe !== (ve ? Q.grid.rows - 1 : 0) ? T(me.getCellNodeFromCordsOrThrow(ve ? 0 : Q.grid.columns - 1, pe + (ve ? 1 : -1), Q.grid)) : ve ? me.selectNext() : me.selectPrevious(), !0;
      case "up":
        return pe !== 0 ? T(me.getCellNodeFromCordsOrThrow(ne, pe - 1, Q.grid)) : me.selectPrevious(), !0;
      case "down":
        return pe !== Q.grid.rows - 1 ? T(me.getCellNodeFromCordsOrThrow(ne, pe + 1, Q.grid)) : me.selectNext(), !0;
      default:
        return !1;
    }
  }, L = (Q, me, ne, pe, ge) => {
    const ve = ge === "forward";
    switch (ge) {
      case "backward":
      case "forward":
        return ne !== (ve ? Q.grid.columns - 1 : 0) && Q.setFocusCellForSelection(me.getCellFromCordsOrThrow(ne + (ve ? 1 : -1), pe, Q.grid)), !0;
      case "up":
        return pe !== 0 ? (Q.setFocusCellForSelection(me.getCellFromCordsOrThrow(ne, pe - 1, Q.grid)), !0) : !1;
      case "down":
        return pe !== Q.grid.rows - 1 ? (Q.setFocusCellForSelection(me.getCellFromCordsOrThrow(ne, pe + 1, Q.grid)), !0) : !1;
      default:
        return !1;
    }
  };
  function R(Q, me) {
    if (e.$isRangeSelection(Q) || e.DEPRECATED_$isGridSelection(Q)) {
      const ne = me.isParentOf(Q.anchor.getNode()), pe = me.isParentOf(Q.focus.getNode());
      return ne && pe;
    }
    return !1;
  }
  function T(Q) {
    const me = Q.getChildren().find((ne) => e.$isParagraphNode(ne));
    e.$isParagraphNode(me) ? me.selectEnd() : Q.selectEnd();
  }
  class D extends e.DEPRECATED_GridNode {
    /** @internal */
    static getType() {
      return "table";
    }
    static clone(me) {
      return new D(me.__key);
    }
    static importDOM() {
      return {
        table: (me) => ({
          conversion: S,
          priority: 1
        })
      };
    }
    static importJSON(me) {
      return E();
    }
    constructor(me) {
      super(me);
    }
    exportJSON() {
      return {
        ...super.exportJSON(),
        type: "table",
        version: 1
      };
    }
    createDOM(me, ne) {
      const pe = document.createElement("table");
      return t.addClassNamesToElement(pe, me.theme.table), pe;
    }
    updateDOM() {
      return !1;
    }
    exportDOM(me) {
      return {
        ...super.exportDOM(me),
        after: (ne) => {
          if (ne) {
            const pe = ne.cloneNode(), ge = document.createElement("colgroup"), ve = document.createElement("tbody");
            ve.append(...ne.children);
            const Te = this.getFirstChildOrThrow();
            if (!u(Te))
              throw new Error("Expected to find row node.");
            const Re = Te.getChildrenSize();
            for (let Me = 0; Me < Re; Me++) {
              const et = document.createElement("col");
              ge.append(et);
            }
            return pe.replaceChildren(ge, ve), pe;
          }
        }
      };
    }
    canExtractContents() {
      return !1;
    }
    canBeEmpty() {
      return !1;
    }
    isShadowRoot() {
      return !0;
    }
    getCordsFromCellNode(me, ne) {
      const {
        rows: pe,
        cells: ge
      } = ne;
      for (let ve = 0; ve < pe; ve++) {
        const Te = ge[ve];
        if (Te == null)
          throw new Error(`Row not found at y:${ve}`);
        const Re = Te.findIndex(({
          elem: Me
        }) => e.$getNearestNodeFromDOMNode(Me) === me);
        if (Re !== -1)
          return {
            x: Re,
            y: ve
          };
      }
      throw new Error("Cell not found in table.");
    }
    getCellFromCords(me, ne, pe) {
      const {
        cells: ge
      } = pe, ve = ge[ne];
      if (ve == null)
        return null;
      const Te = ve[me];
      return Te ?? null;
    }
    getCellFromCordsOrThrow(me, ne, pe) {
      const ge = this.getCellFromCords(me, ne, pe);
      if (!ge)
        throw new Error("Cell not found at cords.");
      return ge;
    }
    getCellNodeFromCords(me, ne, pe) {
      const ge = this.getCellFromCords(me, ne, pe);
      if (ge == null)
        return null;
      const ve = e.$getNearestNodeFromDOMNode(ge.elem);
      return a(ve) ? ve : null;
    }
    getCellNodeFromCordsOrThrow(me, ne, pe) {
      const ge = this.getCellNodeFromCords(me, ne, pe);
      if (!ge)
        throw new Error("Node at cords not TableCellNode.");
      return ge;
    }
    canSelectBefore() {
      return !0;
    }
    canIndent() {
      return !1;
    }
  }
  function A(Q, me) {
    const ne = Q.getElementByKey(me.getKey());
    if (ne == null)
      throw new Error("Table Element Not Found");
    return b(ne);
  }
  function S(Q) {
    return {
      node: E()
    };
  }
  function E() {
    return e.$applyNodeReplacement(new D());
  }
  function x(Q) {
    return Q instanceof D;
  }
  function k(Q, me, ne = !0) {
    const pe = E();
    for (let ge = 0; ge < Q; ge++) {
      const ve = l();
      for (let Te = 0; Te < me; Te++) {
        let Re = n.NO_STATUS;
        typeof ne == "object" ? (ge === 0 && ne.rows && (Re |= n.ROW), Te === 0 && ne.columns && (Re |= n.COLUMN)) : ne && (ge === 0 && (Re |= n.ROW), Te === 0 && (Re |= n.COLUMN));
        const Me = i(Re), et = e.$createParagraphNode();
        et.append(e.$createTextNode()), Me.append(et), ve.append(Me);
      }
      pe.append(ve);
    }
    return pe;
  }
  function I(Q) {
    const me = t.$findMatchingParent(Q, (ne) => a(ne));
    return a(me) ? me : null;
  }
  function z(Q) {
    const me = t.$findMatchingParent(Q, (ne) => u(ne));
    if (u(me))
      return me;
    throw new Error("Expected table cell to be inside of table row.");
  }
  function F(Q) {
    const me = t.$findMatchingParent(Q, (ne) => x(ne));
    if (x(me))
      return me;
    throw new Error("Expected table cell to be inside of table.");
  }
  function P(Q) {
    const me = z(Q);
    return F(me).getChildren().findIndex((pe) => pe.is(me));
  }
  function O(Q) {
    return z(Q).getChildren().findIndex((ne) => ne.is(Q));
  }
  function V(Q, me) {
    const ne = F(Q), {
      x: pe,
      y: ge
    } = ne.getCordsFromCellNode(Q, me);
    return {
      above: ne.getCellNodeFromCords(pe, ge - 1, me),
      below: ne.getCellNodeFromCords(pe, ge + 1, me),
      left: ne.getCellNodeFromCords(pe - 1, ge, me),
      right: ne.getCellNodeFromCords(pe + 1, ge, me)
    };
  }
  function U(Q, me) {
    const ne = Q.getChildren();
    if (me >= ne.length || me < 0)
      throw new Error("Expected table cell to be inside of table row.");
    return ne[me].remove(), Q;
  }
  function H(Q, me, ne = !0, pe, ge) {
    const ve = Q.getChildren();
    if (me >= ve.length || me < 0)
      throw new Error("Table row target index out of range");
    const Te = ve[me];
    if (u(Te))
      for (let Re = 0; Re < pe; Re++) {
        const Me = Te.getChildren(), et = Me.length, st = l();
        for (let De = 0; De < et; De++) {
          const ze = Me[De];
          if (!a(ze))
            throw Error("Expected table cell");
          const {
            above: Pe,
            below: je
          } = V(ze, ge);
          let He = n.NO_STATUS;
          const Xe = Pe && Pe.getWidth() || je && je.getWidth() || void 0;
          (Pe && Pe.hasHeaderState(n.COLUMN) || je && je.hasHeaderState(n.COLUMN)) && (He |= n.COLUMN);
          const at = i(He, 1, Xe);
          at.append(e.$createParagraphNode()), st.append(at);
        }
        ne ? Te.insertAfter(st) : Te.insertBefore(st);
      }
    else
      throw new Error("Row before insertion index does not exist.");
    return Q;
  }
  function J(Q = !0) {
    const me = e.$getSelection();
    if (!(e.$isRangeSelection(me) || e.DEPRECATED_$isGridSelection(me)))
      throw Error("Expected a RangeSelection or GridSelection");
    const ne = me.focus.getNode(), [pe, , ge] = e.DEPRECATED_$getNodeTriplet(ne), [ve, Te] = e.DEPRECATED_$computeGridMap(ge, pe, pe), Re = ve[0].length, {
      startRow: Me
    } = Te;
    if (Q) {
      const et = Me + pe.__rowSpan - 1, st = ve[et], De = l();
      for (let Pe = 0; Pe < Re; Pe++) {
        const {
          cell: je,
          startRow: He
        } = st[Pe];
        He + je.__rowSpan - 1 <= et ? De.append(i(n.NO_STATUS)) : je.setRowSpan(je.__rowSpan + 1);
      }
      const ze = ge.getChildAtIndex(et);
      if (!e.DEPRECATED_$isGridRowNode(ze))
        throw Error("focusEndRow is not a GridRowNode");
      ze.insertAfter(De);
    } else {
      const et = ve[Me], st = l();
      for (let ze = 0; ze < Re; ze++) {
        const {
          cell: Pe,
          startRow: je
        } = et[ze];
        je === Me ? st.append(i(n.NO_STATUS)) : Pe.setRowSpan(Pe.__rowSpan + 1);
      }
      const De = ge.getChildAtIndex(Me);
      if (!e.DEPRECATED_$isGridRowNode(De))
        throw Error("focusEndRow is not a GridRowNode");
      De.insertBefore(st);
    }
  }
  function le(Q, me, ne = !0, pe, ge) {
    const ve = Q.getChildren();
    for (let Te = 0; Te < ve.length; Te++) {
      const Re = ve[Te];
      if (u(Re))
        for (let Me = 0; Me < pe; Me++) {
          const et = Re.getChildren();
          if (me >= et.length || me < 0)
            throw new Error("Table column target index out of range");
          const st = et[me];
          if (!a(st))
            throw Error("Expected table cell");
          const {
            left: De,
            right: ze
          } = V(st, ge);
          let Pe = n.NO_STATUS;
          (De && De.hasHeaderState(n.ROW) || ze && ze.hasHeaderState(n.ROW)) && (Pe |= n.ROW);
          const je = i(Pe);
          je.append(e.$createParagraphNode()), ne ? st.insertAfter(je) : st.insertBefore(je);
        }
    }
    return Q;
  }
  function ae(Q = !0) {
    const me = e.$getSelection();
    if (!(e.$isRangeSelection(me) || e.DEPRECATED_$isGridSelection(me)))
      throw Error("Expected a RangeSelection or GridSelection");
    const ne = me.focus.getNode(), [pe, , ge] = e.DEPRECATED_$getNodeTriplet(ne), [ve, Te] = e.DEPRECATED_$computeGridMap(ge, pe, pe), Re = ve.length, {
      startColumn: Me
    } = Te;
    if (Q) {
      const et = Me + pe.__colSpan - 1;
      for (let st = 0; st < Re; st++) {
        const {
          cell: De,
          startColumn: ze
        } = ve[st][et];
        ze + De.__colSpan - 1 <= et ? De.insertAfter(i(n.NO_STATUS)) : De.setColSpan(De.__colSpan + 1);
      }
    } else
      for (let et = 0; et < Re; et++) {
        const {
          cell: st,
          startColumn: De
        } = ve[et][Me];
        De === Me ? st.insertBefore(i(n.NO_STATUS)) : st.setColSpan(st.__colSpan + 1);
      }
  }
  function Y(Q, me) {
    const ne = Q.getChildren();
    for (let pe = 0; pe < ne.length; pe++) {
      const ge = ne[pe];
      if (u(ge)) {
        const ve = ge.getChildren();
        if (me >= ve.length || me < 0)
          throw new Error("Table column target index out of range");
        ve[me].remove();
      }
    }
    return Q;
  }
  function re() {
    const Q = e.$getSelection();
    if (!(e.$isRangeSelection(Q) || e.DEPRECATED_$isGridSelection(Q)))
      throw Error("Expected a RangeSelection or GridSelection");
    const me = Q.anchor.getNode(), ne = Q.focus.getNode(), [pe, , ge] = e.DEPRECATED_$getNodeTriplet(me), [ve] = e.DEPRECATED_$getNodeTriplet(ne), [Te, Re, Me] = e.DEPRECATED_$computeGridMap(ge, pe, ve), {
      startRow: et
    } = Re, {
      startRow: st
    } = Me, De = st + ve.__rowSpan - 1;
    if (Te.length === De - et + 1) {
      ge.remove();
      return;
    }
    const ze = Te[0].length, Pe = Te[De + 1], je = ge.getChildAtIndex(De + 1);
    if (!e.DEPRECATED_$isGridRowNode(je))
      throw Error(`Expected GridNode childAtIndex(${String(De + 1)}) to be RowNode`);
    for (let He = De; He >= et; He--) {
      for (let at = ze - 1; at >= 0; at--) {
        const {
          cell: wt,
          startRow: Je,
          startColumn: vt
        } = Te[He][at];
        if (vt === at && (He === et && Je < et && wt.setRowSpan(wt.__rowSpan - (Je - et)), Je >= et && Je + wt.__rowSpan - 1 > De))
          if (wt.setRowSpan(wt.__rowSpan - (De - Je + 1)), at === 0)
            he(je, wt);
          else {
            const {
              cell: Ot
            } = Pe[at - 1];
            Ot.insertAfter(wt);
          }
      }
      const Xe = ge.getChildAtIndex(He);
      if (!e.DEPRECATED_$isGridRowNode(Xe))
        throw Error(`Expected GridNode childAtIndex(${String(He)}) to be RowNode`);
      Xe.remove();
    }
    if (Pe !== void 0) {
      const {
        cell: He
      } = Pe[0];
      _e(He);
    } else {
      const He = Te[et - 1], {
        cell: Xe
      } = He[0];
      _e(Xe);
    }
  }
  function ie() {
    const Q = e.$getSelection();
    if (!(e.$isRangeSelection(Q) || e.DEPRECATED_$isGridSelection(Q)))
      throw Error("Expected a RangeSelection or GridSelection");
    const me = Q.anchor.getNode(), ne = Q.focus.getNode(), [pe, , ge] = e.DEPRECATED_$getNodeTriplet(me), [ve] = e.DEPRECATED_$getNodeTriplet(ne), [Te, Re, Me] = e.DEPRECATED_$computeGridMap(ge, pe, ve), {
      startColumn: et
    } = Re, {
      startRow: st,
      startColumn: De
    } = Me, ze = Math.min(et, De), Pe = Math.max(et + pe.__colSpan - 1, De + ve.__colSpan - 1), je = Pe - ze + 1;
    if (Te[0].length === Pe - ze + 1) {
      ge.selectPrevious(), ge.remove();
      return;
    }
    const Xe = Te.length;
    for (let Je = 0; Je < Xe; Je++)
      for (let vt = ze; vt <= Pe; vt++) {
        const {
          cell: Ot,
          startColumn: Ft
        } = Te[Je][vt];
        if (Ft < ze) {
          if (vt === ze) {
            const wn = ze - Ft;
            Ot.setColSpan(Ot.__colSpan - // Possible overflow right too
            Math.min(je, Ot.__colSpan - wn));
          }
        } else if (Ft + Ot.__colSpan - 1 > Pe) {
          if (vt === Pe) {
            const wn = Pe - Ft + 1;
            Ot.setColSpan(Ot.__colSpan - wn);
          }
        } else
          Ot.remove();
      }
    const at = Te[st], wt = at[De + ve.__colSpan];
    if (wt !== void 0) {
      const {
        cell: Je
      } = wt;
      _e(Je);
    } else {
      const Je = at[De - 1], {
        cell: vt
      } = Je;
      _e(vt);
    }
  }
  function _e(Q) {
    const me = Q.getFirstDescendant();
    if (me === null)
      throw Error("Unexpected empty cell");
    me.getParentOrThrow().selectStart();
  }
  function he(Q, me) {
    const ne = Q.getFirstChild();
    ne !== null ? Q.insertBefore(ne) : Q.append(me);
  }
  const be = e.createCommand("INSERT_TABLE_COMMAND");
  return jr.$createTableCellNode = i, jr.$createTableNode = E, jr.$createTableNodeWithDimensions = k, jr.$createTableRowNode = l, jr.$deleteTableColumn = Y, jr.$deleteTableColumn__EXPERIMENTAL = ie, jr.$deleteTableRow__EXPERIMENTAL = re, jr.$getElementGridForTableNode = A, jr.$getTableCellNodeFromLexicalNode = I, jr.$getTableColumnIndexFromTableCellNode = O, jr.$getTableNodeFromLexicalNodeOrThrow = F, jr.$getTableRowIndexFromTableCellNode = P, jr.$getTableRowNodeFromTableCellNodeOrThrow = z, jr.$insertTableColumn = le, jr.$insertTableColumn__EXPERIMENTAL = ae, jr.$insertTableRow = H, jr.$insertTableRow__EXPERIMENTAL = J, jr.$isTableCellNode = a, jr.$isTableNode = x, jr.$isTableRowNode = u, jr.$removeTableRowAtIndex = U, jr.INSERT_TABLE_COMMAND = be, jr.TableCellHeaderStates = n, jr.TableCellNode = o, jr.TableNode = D, jr.TableRowNode = s, jr.TableSelection = p, jr.applyTableHandlers = f, jr.getCellFromTarget = v, jr.getTableSelectionFromTableElement = $, jr;
}
const UYl = process.env.NODE_ENV === "development" ? BYl() : VYl();
var sP = UYl;
const GYl = {
  placeholder: "editor-placeholder",
  paragraph: "editor-paragraph",
  heading: {
    h1: "editor-heading-h1",
    h2: "editor-heading-h2",
    h6: "editor-heading-h6"
  },
  list: {
    nested: {
      listitem: "editor-nested-listitem"
    },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
    listitem: "editor-listitem"
  },
  image: "editor-image",
  link: "editor-link",
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic"
  }
}, WYl = GYl;
var Mr = lr();
class u1 extends Mr.TextNode {
  static getType() {
    return "variable";
  }
  static clone(t) {
    return new u1(t.__text, t.__key);
  }
  constructor(t, n) {
    super(t, n);
  }
  createDOM(t) {
    const n = super.createDOM(t);
    return n.className = "bg-info", n.setAttribute("data-lexical-variable", "true"), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "variable",
      version: 1
    };
  }
  isTextEntity() {
    return !0;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
}
function Sbe(e = "") {
  const t = new u1(e);
  return t.setMode("segmented").toggleDirectionless(), Mr.$applyNodeReplacement(t);
}
var d1 = _a(), $p = {}, tQ;
function HYl() {
  if (tQ)
    return $p;
  tQ = 1;
  var e = _a(), t = Ci(), n = lr(), o = Fe, r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? o.useLayoutEffect : o.useEffect;
  class i {
    constructor(b) {
      this.key = b, this.ref = { current: null }, this.setRefElement = this.setRefElement.bind(this);
    }
    setRefElement(b) {
      this.ref = { current: b };
    }
  }
  let a = (v) => {
    var b = document.getElementById("typeahead-menu");
    if (b && (b = b.querySelector(".typeahead-popover"))) {
      var y = b.getBoundingClientRect();
      y.top + y.height > window.innerHeight && b.scrollIntoView({ block: "center" }), 0 > y.top && b.scrollIntoView({ block: "center" }), v.scrollIntoView({ block: "nearest" });
    }
  };
  function s(v, b) {
    var y = window.getSelection();
    if (y === null || !y.isCollapsed)
      return !1;
    let w = y.anchorNode;
    if (y = y.anchorOffset, w == null || y == null)
      return !1;
    try {
      b.setStart(w, v), b.setEnd(w, y);
    } catch {
      return !1;
    }
    return !0;
  }
  function c(v) {
    let b = null;
    return v.getEditorState().read(() => {
      var y = n.$getSelection();
      if (n.$isRangeSelection(y)) {
        var w = y.anchor;
        w.type !== "text" ? b = null : (y = w.getNode(), y.isSimpleText() ? (w = w.offset, b = y.getTextContent().slice(0, w)) : b = null);
      }
    }), b;
  }
  function l(v, b) {
    if (v = n.$getSelection(), !n.$isRangeSelection(v) || !v.isCollapsed())
      return null;
    var y = v.anchor;
    if (y.type !== "text" || (v = y.getNode(), !v.isSimpleText()))
      return null;
    y = y.offset;
    let w = v.getTextContent().slice(0, y);
    var N = b.matchingString;
    b = b.replaceableString.length;
    for (let q = b; q <= N.length; q++)
      w.substr(-q) === N.substr(0, q) && (b = q);
    if (b = y - b, 0 > b)
      return null;
    let M;
    return b === 0 ? [M] = v.splitText(y) : [, M] = v.splitText(b, y), M;
  }
  function u(v, b) {
    return b !== 0 ? !1 : v.getEditorState().read(() => {
      var y = n.$getSelection();
      return n.$isRangeSelection(y) ? (y = y.anchor.getNode().getPreviousSibling(), n.$isTextNode(y) && y.isTextEntity()) : !1;
    });
  }
  function d(v) {
    o.startTransition ? o.startTransition(v) : v();
  }
  function _(v, b) {
    let y = getComputedStyle(v), w = y.position === "absolute";
    if (b = b ? /(auto|scroll|hidden)/ : /(auto|scroll)/, y.position === "fixed")
      return document.body;
    for (; v = v.parentElement; )
      if (y = getComputedStyle(v), (!w || y.position !== "static") && b.test(y.overflow + y.overflowY + y.overflowX))
        return v;
    return document.body;
  }
  function p(v, b) {
    return v = v.getBoundingClientRect(), b = b.getBoundingClientRect(), v.top > b.top && v.top < b.bottom;
  }
  function g(v, b, y, w) {
    let [N] = e.useLexicalComposerContext();
    o.useEffect(() => {
      if (b != null && v != null) {
        let M = N.getRootElement(), q = M != null ? _(M, !1) : document.body, L = !1, R = p(b, q), T = function() {
          L || (window.requestAnimationFrame(function() {
            y(), L = !1;
          }), L = !0);
          const A = p(b, q);
          A !== R && (R = A, w != null && w(A));
        }, D = new ResizeObserver(y);
        return window.addEventListener("resize", y), document.addEventListener("scroll", T, { capture: !0, passive: !0 }), D.observe(b), () => {
          D.unobserve(b), window.removeEventListener("resize", y), document.removeEventListener(
            "scroll",
            T
          );
        };
      }
    }, [b, N, w, y, v]);
  }
  let f = n.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
  function h({ close: v, editor: b, anchorElementRef: y, resolution: w, options: N, menuRenderFn: M, onSelectOption: q }) {
    let [L, R] = o.useState(null);
    o.useEffect(() => {
      R(0);
    }, [w.match.matchingString]);
    let T = o.useCallback((S) => {
      b.update(() => {
        const E = l(b, w.match);
        q(S, E, v, w.match.matchingString);
      });
    }, [v, b, w.match, q]), D = o.useCallback((S) => {
      const E = b.getRootElement();
      E !== null && (E.setAttribute("aria-activedescendant", "typeahead-item-" + S), R(S));
    }, [b]);
    o.useEffect(
      () => () => {
        let S = b.getRootElement();
        S !== null && S.removeAttribute("aria-activedescendant");
      },
      [b]
    ), r(() => {
      N === null ? R(null) : L === null && D(0);
    }, [N, L, D]), o.useEffect(() => t.mergeRegister(b.registerCommand(f, ({ option: S }) => S.ref && S.ref.current != null ? (a(S.ref.current), !0) : !1, n.COMMAND_PRIORITY_LOW)), [b, D]), o.useEffect(() => t.mergeRegister(
      b.registerCommand(n.KEY_ARROW_DOWN_COMMAND, (S) => {
        if (N !== null && N.length && L !== null) {
          let E = L !== N.length - 1 ? L + 1 : 0;
          D(E);
          let x = N[E];
          x.ref != null && x.ref.current && b.dispatchCommand(f, { index: E, option: x }), S.preventDefault(), S.stopImmediatePropagation();
        }
        return !0;
      }, n.COMMAND_PRIORITY_LOW),
      b.registerCommand(n.KEY_ARROW_UP_COMMAND, (S) => {
        if (N !== null && N.length && L !== null) {
          var E = L !== 0 ? L - 1 : N.length - 1;
          D(E), E = N[E], E.ref != null && E.ref.current && a(E.ref.current), S.preventDefault(), S.stopImmediatePropagation();
        }
        return !0;
      }, n.COMMAND_PRIORITY_LOW),
      b.registerCommand(n.KEY_ESCAPE_COMMAND, (S) => (S.preventDefault(), S.stopImmediatePropagation(), v(), !0), n.COMMAND_PRIORITY_LOW),
      b.registerCommand(n.KEY_TAB_COMMAND, (S) => N === null || L === null || N[L] == null ? !1 : (S.preventDefault(), S.stopImmediatePropagation(), T(N[L]), !0), n.COMMAND_PRIORITY_LOW),
      b.registerCommand(n.KEY_ENTER_COMMAND, (S) => N === null || L === null || N[L] == null ? !1 : (S !== null && (S.preventDefault(), S.stopImmediatePropagation()), T(N[L]), !0), n.COMMAND_PRIORITY_LOW)
    ), [T, v, b, N, L, D]);
    let A = o.useMemo(() => ({ options: N, selectOptionAndCleanUp: T, selectedIndex: L, setHighlightedIndex: R }), [T, L, N]);
    return M(y, A, w.match.matchingString);
  }
  function $(v, b, y) {
    let [w] = e.useLexicalComposerContext(), N = o.useRef(document.createElement("div")), M = o.useCallback(() => {
      const L = w.getRootElement(), R = N.current;
      if (L !== null && v !== null) {
        const { left: T, top: D, width: A, height: S } = v.getRect();
        R.style.top = `${D + window.pageYOffset}px`, R.style.left = `${T + window.pageXOffset}px`, R.style.height = `${S}px`, R.style.width = `${A}px`, R.isConnected || (y != null && (R.className = y), R.setAttribute("aria-label", "Typeahead menu"), R.setAttribute("id", "typeahead-menu"), R.setAttribute(
          "role",
          "listbox"
        ), R.style.display = "block", R.style.position = "absolute", document.body.append(R)), N.current = R, L.setAttribute("aria-controls", "typeahead-menu");
      }
    }, [w, v, y]);
    o.useEffect(() => {
      let L = w.getRootElement();
      if (v !== null)
        return M(), () => {
          L !== null && L.removeAttribute("aria-controls");
          let R = N.current;
          R !== null && R.isConnected && R.remove();
        };
    }, [w, M, v]);
    let q = o.useCallback((L) => {
      v !== null && (L || b(null));
    }, [v, b]);
    return g(v, N.current, M, q), N;
  }
  return $p.LexicalNodeMenuPlugin = function({ options: v, nodeKey: b, onClose: y, onOpen: w, onSelectOption: N, menuRenderFn: M, anchorClassName: q }) {
    let [L] = e.useLexicalComposerContext(), [R, T] = o.useState(null);
    q = $(R, T, q);
    let D = o.useCallback(() => {
      T(null), y != null && R !== null && y();
    }, [y, R]), A = o.useCallback((E) => {
      T(E), w != null && R === null && w(E);
    }, [w, R]), S = o.useCallback(() => {
      b ? L.update(() => {
        const E = n.$getNodeByKey(b), x = L.getElementByKey(b);
        if (E != null && x != null) {
          const k = E.getTextContent();
          R != null && R.match.matchingString === k || d(() => A({ getRect: () => x.getBoundingClientRect(), match: { leadOffset: k.length, matchingString: k, replaceableString: k } }));
        }
      }) : b == null && R != null && D();
    }, [D, L, b, A, R]);
    return o.useEffect(() => {
      S();
    }, [S, b]), o.useEffect(() => {
      if (b != null)
        return L.registerUpdateListener(({ dirtyElements: E }) => {
          E.get(b) && S();
        });
    }, [L, S, b]), R === null || L === null ? null : o.createElement(h, { close: D, resolution: R, editor: L, anchorElementRef: q, options: v, menuRenderFn: M, onSelectOption: N });
  }, $p.LexicalTypeaheadMenuPlugin = function({ options: v, onQueryChange: b, onSelectOption: y, onOpen: w, onClose: N, menuRenderFn: M, triggerFn: q, anchorClassName: L }) {
    let [R] = e.useLexicalComposerContext(), [T, D] = o.useState(null);
    L = $(T, D, L);
    let A = o.useCallback(() => {
      D(null), N != null && T !== null && N();
    }, [N, T]), S = o.useCallback((E) => {
      D(E), w != null && T === null && w(E);
    }, [w, T]);
    return o.useEffect(() => {
      let E = R.registerUpdateListener(() => {
        R.getEditorState().read(() => {
          const x = document.createRange(), k = n.$getSelection(), I = c(R);
          if (n.$isRangeSelection(k) && k.isCollapsed() && I !== null && x !== null) {
            var z = q(I, R);
            b(z ? z.matchingString : null), z === null || u(R, z.leadOffset) || s(z.leadOffset, x) === null ? A() : d(() => S({ getRect: () => x.getBoundingClientRect(), match: z }));
          } else
            A();
        });
      });
      return () => {
        E();
      };
    }, [R, q, b, T, A, S]), T === null || R === null ? null : o.createElement(h, { close: A, resolution: T, editor: R, anchorElementRef: L, options: v, menuRenderFn: M, onSelectOption: y });
  }, $p.PUNCTUATION = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`, $p.SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND = f, $p.TypeaheadOption = i, $p.getScrollParent = _, $p.useBasicTypeaheadTriggerMatch = function(v, { minLength: b = 1, maxLength: y = 75 }) {
    return o.useCallback((w) => {
      if (w = new RegExp("(^|\\s|\\()([" + v + "]((?:[^" + (v + `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;\\s]){0,`) + y + "}))$").exec(w), w !== null) {
        let N = w[1], M = w[3];
        if (M.length >= b)
          return { leadOffset: w.index + N.length, matchingString: M, replaceableString: w[2] };
      }
      return null;
    }, [y, b, v]);
  }, $p.useDynamicPositioning = g, $p;
}
var wp = {}, nQ;
function YYl() {
  if (nQ)
    return wp;
  nQ = 1;
  var e = _a(), t = Ci(), n = lr(), o = Fe, a = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? o.useLayoutEffect : o.useEffect;
  const s = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`;
  class c {
    constructor(T) {
      this.key = T, this.ref = {
        current: null
      }, this.setRefElement = this.setRefElement.bind(this);
    }
    setRefElement(T) {
      this.ref = {
        current: T
      };
    }
  }
  const l = (R) => {
    const T = document.getElementById("typeahead-menu");
    if (!T)
      return;
    const D = T.querySelector(".typeahead-popover");
    if (!D)
      return;
    const A = D.getBoundingClientRect();
    A.top + A.height > window.innerHeight && D.scrollIntoView({
      block: "center"
    }), A.top < 0 && D.scrollIntoView({
      block: "center"
    }), R.scrollIntoView({
      block: "nearest"
    });
  };
  function u(R) {
    const T = R.anchor;
    if (T.type !== "text")
      return null;
    const D = T.getNode();
    if (!D.isSimpleText())
      return null;
    const A = T.offset;
    return D.getTextContent().slice(0, A);
  }
  function d(R, T) {
    const D = window.getSelection();
    if (D === null || !D.isCollapsed)
      return !1;
    const A = D.anchorNode, S = R, E = D.anchorOffset;
    if (A == null || E == null)
      return !1;
    try {
      T.setStart(A, S), T.setEnd(A, E);
    } catch {
      return !1;
    }
    return !0;
  }
  function _(R) {
    let T = null;
    return R.getEditorState().read(() => {
      const D = n.$getSelection();
      n.$isRangeSelection(D) && (T = u(D));
    }), T;
  }
  function p(R, T, D) {
    let A = D;
    for (let S = A; S <= T.length; S++)
      R.substr(-S) === T.substr(0, S) && (A = S);
    return A;
  }
  function g(R, T) {
    const D = n.$getSelection();
    if (!n.$isRangeSelection(D) || !D.isCollapsed())
      return null;
    const A = D.anchor;
    if (A.type !== "text")
      return null;
    const S = A.getNode();
    if (!S.isSimpleText())
      return null;
    const E = A.offset, x = S.getTextContent().slice(0, E), k = T.replaceableString.length, I = p(x, T.matchingString, k), z = E - I;
    if (z < 0)
      return null;
    let F;
    return z === 0 ? [F] = S.splitText(E) : [, F] = S.splitText(z, E), F;
  }
  function f(R, T) {
    return T !== 0 ? !1 : R.getEditorState().read(() => {
      const D = n.$getSelection();
      if (n.$isRangeSelection(D)) {
        const E = D.anchor.getNode().getPreviousSibling();
        return n.$isTextNode(E) && E.isTextEntity();
      }
      return !1;
    });
  }
  function h(R) {
    o.startTransition ? o.startTransition(R) : R();
  }
  function $(R, T) {
    let D = getComputedStyle(R);
    const A = D.position === "absolute", S = T ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
    if (D.position === "fixed")
      return document.body;
    for (let E = R; E = E.parentElement; )
      if (D = getComputedStyle(E), !(A && D.position === "static") && S.test(D.overflow + D.overflowY + D.overflowX))
        return E;
    return document.body;
  }
  function v(R, T) {
    const D = R.getBoundingClientRect(), A = T.getBoundingClientRect();
    return D.top > A.top && D.top < A.bottom;
  }
  function b(R, T, D, A) {
    const [S] = e.useLexicalComposerContext();
    o.useEffect(() => {
      if (T != null && R != null) {
        const E = S.getRootElement(), x = E != null ? $(E, !1) : document.body;
        let k = !1, I = v(T, x);
        const z = function() {
          k || (window.requestAnimationFrame(function() {
            D(), k = !1;
          }), k = !0);
          const P = v(T, x);
          P !== I && (I = P, A != null && A(P));
        }, F = new ResizeObserver(D);
        return window.addEventListener("resize", D), document.addEventListener("scroll", z, {
          capture: !0,
          passive: !0
        }), F.observe(T), () => {
          F.unobserve(T), window.removeEventListener("resize", D), document.removeEventListener("scroll", z);
        };
      }
    }, [T, S, A, D, R]);
  }
  const y = n.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
  function w({
    close: R,
    editor: T,
    anchorElementRef: D,
    resolution: A,
    options: S,
    menuRenderFn: E,
    onSelectOption: x
  }) {
    const [k, I] = o.useState(null);
    o.useEffect(() => {
      I(0);
    }, [A.match.matchingString]);
    const z = o.useCallback((O) => {
      T.update(() => {
        const V = g(T, A.match);
        x(O, V, R, A.match.matchingString);
      });
    }, [R, T, A.match, x]), F = o.useCallback((O) => {
      const V = T.getRootElement();
      V !== null && (V.setAttribute("aria-activedescendant", "typeahead-item-" + O), I(O));
    }, [T]);
    o.useEffect(() => () => {
      const O = T.getRootElement();
      O !== null && O.removeAttribute("aria-activedescendant");
    }, [T]), a(() => {
      S === null ? I(null) : k === null && F(0);
    }, [S, k, F]), o.useEffect(() => t.mergeRegister(T.registerCommand(y, ({
      option: O
    }) => O.ref && O.ref.current != null ? (l(O.ref.current), !0) : !1, n.COMMAND_PRIORITY_LOW)), [T, F]), o.useEffect(() => t.mergeRegister(T.registerCommand(n.KEY_ARROW_DOWN_COMMAND, (O) => {
      const V = O;
      if (S !== null && S.length && k !== null) {
        const U = k !== S.length - 1 ? k + 1 : 0;
        F(U);
        const H = S[U];
        H.ref != null && H.ref.current && T.dispatchCommand(y, {
          index: U,
          option: H
        }), V.preventDefault(), V.stopImmediatePropagation();
      }
      return !0;
    }, n.COMMAND_PRIORITY_LOW), T.registerCommand(n.KEY_ARROW_UP_COMMAND, (O) => {
      const V = O;
      if (S !== null && S.length && k !== null) {
        const U = k !== 0 ? k - 1 : S.length - 1;
        F(U);
        const H = S[U];
        H.ref != null && H.ref.current && l(H.ref.current), V.preventDefault(), V.stopImmediatePropagation();
      }
      return !0;
    }, n.COMMAND_PRIORITY_LOW), T.registerCommand(n.KEY_ESCAPE_COMMAND, (O) => {
      const V = O;
      return V.preventDefault(), V.stopImmediatePropagation(), R(), !0;
    }, n.COMMAND_PRIORITY_LOW), T.registerCommand(n.KEY_TAB_COMMAND, (O) => {
      const V = O;
      return S === null || k === null || S[k] == null ? !1 : (V.preventDefault(), V.stopImmediatePropagation(), z(S[k]), !0);
    }, n.COMMAND_PRIORITY_LOW), T.registerCommand(n.KEY_ENTER_COMMAND, (O) => S === null || k === null || S[k] == null ? !1 : (O !== null && (O.preventDefault(), O.stopImmediatePropagation()), z(S[k]), !0), n.COMMAND_PRIORITY_LOW)), [z, R, T, S, k, F]);
    const P = o.useMemo(() => ({
      options: S,
      selectOptionAndCleanUp: z,
      selectedIndex: k,
      setHighlightedIndex: I
    }), [z, k, S]);
    return E(D, P, A.match.matchingString);
  }
  function N(R, {
    minLength: T = 1,
    maxLength: D = 75
  }) {
    return o.useCallback((A) => {
      const S = "[^" + R + s + "\\s]", x = new RegExp("(^|\\s|\\()([" + R + "]((?:" + S + "){0," + D + "}))$").exec(A);
      if (x !== null) {
        const k = x[1], I = x[3];
        if (I.length >= T)
          return {
            leadOffset: x.index + k.length,
            matchingString: I,
            replaceableString: x[2]
          };
      }
      return null;
    }, [D, T, R]);
  }
  function M(R, T, D) {
    const [A] = e.useLexicalComposerContext(), S = o.useRef(document.createElement("div")), E = o.useCallback(() => {
      const k = A.getRootElement(), I = S.current;
      if (k !== null && R !== null) {
        const {
          left: z,
          top: F,
          width: P,
          height: O
        } = R.getRect();
        I.style.top = `${F + window.pageYOffset}px`, I.style.left = `${z + window.pageXOffset}px`, I.style.height = `${O}px`, I.style.width = `${P}px`, I.isConnected || (D != null && (I.className = D), I.setAttribute("aria-label", "Typeahead menu"), I.setAttribute("id", "typeahead-menu"), I.setAttribute("role", "listbox"), I.style.display = "block", I.style.position = "absolute", document.body.append(I)), S.current = I, k.setAttribute("aria-controls", "typeahead-menu");
      }
    }, [A, R, D]);
    o.useEffect(() => {
      const k = A.getRootElement();
      if (R !== null)
        return E(), () => {
          k !== null && k.removeAttribute("aria-controls");
          const I = S.current;
          I !== null && I.isConnected && I.remove();
        };
    }, [A, E, R]);
    const x = o.useCallback((k) => {
      R !== null && (k || T(null));
    }, [R, T]);
    return b(R, S.current, E, x), S;
  }
  function q({
    options: R,
    onQueryChange: T,
    onSelectOption: D,
    onOpen: A,
    onClose: S,
    menuRenderFn: E,
    triggerFn: x,
    anchorClassName: k
  }) {
    const [I] = e.useLexicalComposerContext(), [z, F] = o.useState(null), P = M(z, F, k), O = o.useCallback(() => {
      F(null), S != null && z !== null && S();
    }, [S, z]), V = o.useCallback((U) => {
      F(U), A != null && z === null && A(U);
    }, [A, z]);
    return o.useEffect(() => {
      const U = () => {
        I.getEditorState().read(() => {
          const J = document.createRange(), le = n.$getSelection(), ae = _(I);
          if (!n.$isRangeSelection(le) || !le.isCollapsed() || ae === null || J === null) {
            O();
            return;
          }
          const Y = x(ae, I);
          if (T(Y ? Y.matchingString : null), Y !== null && !f(I, Y.leadOffset) && d(Y.leadOffset, J) !== null) {
            h(() => V({
              getRect: () => J.getBoundingClientRect(),
              match: Y
            }));
            return;
          }
          O();
        });
      }, H = I.registerUpdateListener(U);
      return () => {
        H();
      };
    }, [I, x, T, z, O, V]), z === null || I === null ? null : /* @__PURE__ */ o.createElement(w, {
      close: O,
      resolution: z,
      editor: I,
      anchorElementRef: P,
      options: R,
      menuRenderFn: E,
      onSelectOption: D
    });
  }
  function L({
    options: R,
    nodeKey: T,
    onClose: D,
    onOpen: A,
    onSelectOption: S,
    menuRenderFn: E,
    anchorClassName: x
  }) {
    const [k] = e.useLexicalComposerContext(), [I, z] = o.useState(null), F = M(I, z, x), P = o.useCallback(() => {
      z(null), D != null && I !== null && D();
    }, [D, I]), O = o.useCallback((U) => {
      z(U), A != null && I === null && A(U);
    }, [A, I]), V = o.useCallback(() => {
      T ? k.update(() => {
        const U = n.$getNodeByKey(T), H = k.getElementByKey(T);
        if (U != null && H != null) {
          const J = U.getTextContent();
          (I == null || I.match.matchingString !== J) && h(() => O({
            getRect: () => H.getBoundingClientRect(),
            match: {
              leadOffset: J.length,
              matchingString: J,
              replaceableString: J
            }
          }));
        }
      }) : T == null && I != null && P();
    }, [P, k, T, O, I]);
    return o.useEffect(() => {
      V();
    }, [V, T]), o.useEffect(() => {
      if (T != null)
        return k.registerUpdateListener(({
          dirtyElements: U
        }) => {
          U.get(T) && V();
        });
    }, [k, V, T]), I === null || k === null ? null : /* @__PURE__ */ o.createElement(w, {
      close: P,
      resolution: I,
      editor: k,
      anchorElementRef: F,
      options: R,
      menuRenderFn: E,
      onSelectOption: S
    });
  }
  return wp.LexicalNodeMenuPlugin = L, wp.LexicalTypeaheadMenuPlugin = q, wp.PUNCTUATION = s, wp.SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND = y, wp.TypeaheadOption = c, wp.getScrollParent = $, wp.useBasicTypeaheadTriggerMatch = N, wp.useDynamicPositioning = b, wp;
}
const KYl = process.env.NODE_ENV === "development" ? YYl() : HYl();
var e6 = KYl;
function ZYl(e) {
  const t = e.getTextContent(), n = /\{[^}]+\}/g;
  let o;
  for (let r = 0; r < t.length; r++)
    if (n.lastIndex = r, o = n.exec(t), o !== null) {
      const i = o[0], a = o.index;
      r = a + i.length - 1;
      let s;
      a === 0 ? [s] = e.splitText(a + i.length) : [, s] = e.splitText(a, a + i.length);
      const c = Sbe(i);
      return s.replace(c), c;
    }
  return null;
}
function XYl(e) {
  yt(() => {
    if (!e.hasNodes([u1])) {
      console.error("VariableNode is not registered in the editor");
      return;
    }
    return e.registerNodeTransform(Mr.TextNode, (t) => {
      let n = t;
      for (; n !== null; ) {
        if (!n.isSimpleText())
          return;
        n = ZYl(n);
      }
    });
  }, [e]);
}
class JYl extends e6.TypeaheadOption {
  constructor(n) {
    super(n);
    vi(this, "name");
    this.name = n;
  }
}
function QYl({ variables: e }) {
  const { t } = kt(), [n] = d1.useLexicalComposerContext();
  XYl(n);
  const [o, r] = it(null), i = e6.useBasicTypeaheadTriggerMatch("{", {
    minLength: 0
  }), a = vn(() => e.filter((c) => c.toLowerCase().includes((o == null ? void 0 : o.toLowerCase()) ?? "")).map((c) => new JYl(c)), [e, o]), s = Yt(
    (c, l, u) => {
      n.update(() => {
        const d = Sbe(
          `{${t(`${c.name}_variable`).toUpperCase().replace(/ /g, "_")}}`
        );
        l && l.replace(d), d.select(), u();
      });
    },
    [n, t]
  );
  return /* @__PURE__ */ m(
    e6.LexicalTypeaheadMenuPlugin,
    {
      onQueryChange: r,
      onSelectOption: s,
      triggerFn: i,
      options: a,
      menuRenderFn: (c, { selectedIndex: l, selectOptionAndCleanUp: u, setHighlightedIndex: d }) => c.current && a.length ? My(
        /* @__PURE__ */ m(
          "div",
          {
            className: xe(
              "shadow-dropdown bg-default border-subtle mt-5 w-64 overflow-hidden rounded-md border",
              "typeahead-popover"
              // class required by Lexical
            ),
            children: /* @__PURE__ */ m("ul", { className: "max-h-64 list-none overflow-y-scroll md:max-h-80", children: a.map((_, p) => /* @__PURE__ */ de(
              "li",
              {
                id: `typeahead-item-${p}`,
                "aria-selected": l === p,
                tabIndex: -1,
                className: "focus:ring-brand-800 hover:bg-subtle hover:text-emphasis text-default aria-selected:bg-subtle aria-selected:text-emphasis cursor-pointer px-4 py-2 text-sm outline-none ring-inset transition first-of-type:rounded-t-[inherit] last-of-type:rounded-b-[inherit] focus:outline-none focus:ring-1",
                ref: _.setRefElement,
                role: "option",
                onClick: () => {
                  d(p), u(_);
                },
                onMouseEnter: () => {
                  d(p);
                },
                children: [
                  /* @__PURE__ */ m("p", { className: "text-sm font-semibold", children: `{${t(`${_.name}_variable`).toUpperCase().replace(/ /g, "_")}}` }),
                  /* @__PURE__ */ m("span", { className: "text-default text-sm", children: t(`${_.name}_info`) })
                ]
              },
              _.key
            )) })
          }
        ),
        c.current
      ) : null
    }
  );
}
var yE = {}, oQ;
function eKl() {
  if (oQ)
    return yE;
  oQ = 1;
  var e = bl, t = _a(), n = Ci(), o = lr(), r = Fe;
  function i(_, p) {
    for (let g = 0; g < p.length; g++) {
      let f = p[g](_);
      if (f)
        return f;
    }
    return null;
  }
  let a = /[.,;\s]/;
  function s(_) {
    _ = _.getPreviousSibling(), o.$isElementNode(_) && (_ = _.getLastDescendant());
    var p;
    return !(p = _ === null || o.$isLineBreakNode(_)) && (p = o.$isTextNode(_)) && (_ = _.getTextContent(), p = a.test(_[_.length - 1])), p;
  }
  function c(_) {
    return _ = _.getNextSibling(), o.$isElementNode(_) && (_ = _.getFirstDescendant()), _ === null || o.$isLineBreakNode(_) || o.$isTextNode(_) && a.test(_.getTextContent()[0]);
  }
  function l(_, p, g) {
    var f = _.getChildren();
    let h = f.length;
    for (let $ = 0; $ < h; $++) {
      let v = f[$];
      if (!o.$isTextNode(v) || !v.isSimpleText()) {
        u(_), g(null, _.getURL());
        return;
      }
    }
    f = _.getTextContent(), p = i(f, p), p === null || p.text !== f ? (u(_), g(null, _.getURL())) : s(_) && c(_) ? (f = _.getURL(), f !== p.url && (_.setURL(p.url), g(p.url, f)), p.attributes && (f = _.getRel(), f !== p.attributes.rel && (_.setRel(p.attributes.rel || null), g(p.attributes.rel || null, f)), f = _.getTarget(), f !== p.attributes.target && (_.setTarget(p.attributes.target || null), g(p.attributes.target || null, f)))) : (u(_), g(null, _.getURL()));
  }
  function u(_) {
    let p = _.getChildren();
    var g = p.length;
    for (--g; 0 <= g; g--)
      _.insertAfter(p[g]);
    return _.remove(), p.map((f) => f.getLatest());
  }
  function d(_, p, g) {
    r.useEffect(() => {
      if (!_.hasNodes([e.AutoLinkNode]))
        throw Error("Minified Lexical error #77; visit https://lexical.dev/docs/error?code=77 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
      let f = (h, $) => {
        g && g(h, $);
      };
      return n.mergeRegister(_.registerNodeTransform(o.TextNode, (h) => {
        var $ = h.getParentOrThrow(), v = h.getPreviousSibling();
        if (e.$isAutoLinkNode($))
          l($, p, f);
        else if (!e.$isLinkNode($)) {
          if (h.isSimpleText() && (a.test(h.getTextContent()[0]) || !e.$isAutoLinkNode(v))) {
            v = $ = h.getTextContent();
            let L = 0, R = h;
            for (var b; (b = i(v, p)) && b !== null; ) {
              let T = b.index, D = b.length, A = T + D;
              var y = L + T, w = L + A, N = $, M = h;
              if ((0 < y ? a.test(N[y - 1]) : s(M)) && (w < N.length ? a.test(N[w]) : c(M))) {
                var q = void 0;
                L + T === 0 ? [q, R] = R.splitText(L + D) : [, q, R] = R.splitText(L + T, L + T + D), y = e.$createAutoLinkNode(b.url, b.attributes), w = o.$createTextNode(b.text), w.setFormat(q.getFormat()), w.setDetail(q.getDetail()), y.append(w), q.replace(y), g && g(b.url, null), L = 0;
              } else
                L += A;
              v = v.substring(A);
            }
          }
          $ = h.getPreviousSibling(), b = h.getNextSibling(), q = h.getTextContent(), e.$isAutoLinkNode($) && !a.test(q[0]) && ($.append(h), l($, p, f), h = $.getURL(), g && g(null, h)), e.$isAutoLinkNode(b) && !a.test(q[q.length - 1]) && (u(b), l(b, p, f), h = b.getURL(), g && g(null, h));
        }
      }));
    }, [_, p, g]);
  }
  return yE.AutoLinkPlugin = function({ matchers: _, onChange: p }) {
    let [g] = t.useLexicalComposerContext();
    return d(g, _, p), null;
  }, yE.createLinkMatcherWithRegExp = function(_, p = (g) => g) {
    return (g) => {
      let f = _.exec(g);
      return f === null ? null : { index: f.index, length: f[0].length, text: f[0], url: p(g) };
    };
  }, yE;
}
var $E = {}, rQ;
function tKl() {
  if (rQ)
    return $E;
  rQ = 1;
  var e = bl, t = _a(), n = Ci(), o = lr(), r = Fe;
  function i(y, w = (N) => N) {
    return (N) => {
      const M = y.exec(N);
      return M === null ? null : {
        index: M.index,
        length: M[0].length,
        text: M[0],
        url: w(N)
      };
    };
  }
  function a(y, w) {
    for (let N = 0; N < w.length; N++) {
      const M = w[N](y);
      if (M)
        return M;
    }
    return null;
  }
  const s = /[.,;\s]/;
  function c(y) {
    return s.test(y);
  }
  function l(y) {
    return c(y[y.length - 1]);
  }
  function u(y) {
    return c(y[0]);
  }
  function d(y) {
    let w = y.getPreviousSibling();
    return o.$isElementNode(w) && (w = w.getLastDescendant()), w === null || o.$isLineBreakNode(w) || o.$isTextNode(w) && l(w.getTextContent());
  }
  function _(y) {
    let w = y.getNextSibling();
    return o.$isElementNode(w) && (w = w.getFirstDescendant()), w === null || o.$isLineBreakNode(w) || o.$isTextNode(w) && u(w.getTextContent());
  }
  function p(y, w, N, M) {
    return (y > 0 ? c(N[y - 1]) : d(M)) ? w < N.length ? c(N[w]) : _(M) : !1;
  }
  function g(y, w, N) {
    const M = y.getTextContent();
    let q = M, L = 0, R = y, T;
    for (; (T = a(q, w)) && T !== null; ) {
      const D = T.index, A = T.length, S = D + A;
      if (p(L + D, L + S, M, y)) {
        let x;
        L + D === 0 ? [x, R] = R.splitText(L + A) : [, x, R] = R.splitText(L + D, L + D + A);
        const k = e.$createAutoLinkNode(T.url, T.attributes), I = o.$createTextNode(T.text);
        I.setFormat(x.getFormat()), I.setDetail(x.getDetail()), k.append(I), x.replace(k), N(T.url, null), L = 0;
      } else
        L += S;
      q = q.substring(S);
    }
  }
  function f(y, w, N) {
    const M = y.getChildren(), q = M.length;
    for (let D = 0; D < q; D++) {
      const A = M[D];
      if (!o.$isTextNode(A) || !A.isSimpleText()) {
        $(y), N(null, y.getURL());
        return;
      }
    }
    const L = y.getTextContent(), R = a(L, w);
    if (R === null || R.text !== L) {
      $(y), N(null, y.getURL());
      return;
    }
    if (!d(y) || !_(y)) {
      $(y), N(null, y.getURL());
      return;
    }
    const T = y.getURL();
    if (T !== R.url && (y.setURL(R.url), N(R.url, T)), R.attributes) {
      const D = y.getRel();
      D !== R.attributes.rel && (y.setRel(R.attributes.rel || null), N(R.attributes.rel || null, D));
      const A = y.getTarget();
      A !== R.attributes.target && (y.setTarget(R.attributes.target || null), N(R.attributes.target || null, A));
    }
  }
  function h(y, w, N) {
    const M = y.getPreviousSibling(), q = y.getNextSibling(), L = y.getTextContent();
    e.$isAutoLinkNode(M) && !u(L) && (M.append(y), f(M, w, N), N(null, M.getURL())), e.$isAutoLinkNode(q) && !l(L) && ($(q), f(q, w, N), N(null, q.getURL()));
  }
  function $(y) {
    const w = y.getChildren(), N = w.length;
    for (let M = N - 1; M >= 0; M--)
      y.insertAfter(w[M]);
    return y.remove(), w.map((M) => M.getLatest());
  }
  function v(y, w, N) {
    r.useEffect(() => {
      if (!y.hasNodes([e.AutoLinkNode]))
        throw Error("LexicalAutoLinkPlugin: AutoLinkNode not registered on editor");
      const M = (q, L) => {
        N && N(q, L);
      };
      return n.mergeRegister(y.registerNodeTransform(o.TextNode, (q) => {
        const L = q.getParentOrThrow(), R = q.getPreviousSibling();
        e.$isAutoLinkNode(L) ? f(L, w, M) : e.$isLinkNode(L) || (q.isSimpleText() && (u(q.getTextContent()) || !e.$isAutoLinkNode(R)) && g(q, w, M), h(q, w, M));
      }));
    }, [y, w, N]);
  }
  function b({
    matchers: y,
    onChange: w
  }) {
    const [N] = t.useLexicalComposerContext();
    return v(N, y, w), null;
  }
  return $E.AutoLinkPlugin = b, $E.createLinkMatcherWithRegExp = i, $E;
}
const nKl = process.env.NODE_ENV === "development" ? tKl() : eKl();
var oKl = nKl;
const rKl = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/, iKl = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/, aKl = [
  (e) => {
    const t = rKl.exec(e);
    return t && {
      index: t.index,
      length: t[0].length,
      text: t[0],
      url: t[0]
    };
  },
  (e) => {
    const t = iKl.exec(e);
    return t && {
      index: t.index,
      length: t[0].length,
      text: t[0],
      url: `mailto:${t[0]}`
    };
  }
];
function sKl() {
  return /* @__PURE__ */ m(oKl.AutoLinkPlugin, { matchers: aKl });
}
function cKl({ editable: e }) {
  const [t] = d1.useLexicalComposerContext();
  return t.setEditable(e), null;
}
function lKl({ setText: e, plainText: t }) {
  const [n] = d1.useLexicalComposerContext();
  return yt(() => n.registerUpdateListener(({ editorState: o }) => {
    o.read(() => {
      if (t) {
        const r = Mr.$getRoot().getTextContent();
        e(r);
      }
    });
  }), [t]), null;
}
var ck = If(), t6 = Ci();
const uKl = (e) => {
  const { t } = kt(), [n, o] = it(""), r = NC("(max-width: 640px)"), i = vn(() => {
    const a = n.trim().toLowerCase();
    return a ? e.variables.filter((s) => {
      const c = s.toLowerCase(), l = t(`${s}_variable`).toLowerCase(), u = t(`${s}_info`).toLowerCase();
      return c.includes(a) || l.includes(a) || u.includes(a);
    }) : e.variables;
  }, [e.variables, n, t]);
  return /* @__PURE__ */ de(
    jd,
    {
      onOpenChange: (a) => {
        a || o("");
      },
      children: [
        /* @__PURE__ */ m(Hu, { "aria-label": "Add variable", className: "focus:bg-muted pt-[6px]", children: /* @__PURE__ */ m("div", { className: "items-center", children: e.isTextEditor ? /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ de("div", { className: "hidden sm:flex", children: [
            t("add_variable"),
            /* @__PURE__ */ m(qt, { name: "chevron-down", className: "ml-1 mt-[2px] h-4 w-4" })
          ] }),
          /* @__PURE__ */ m("div", { className: "block sm:hidden", children: e.addVariableButtonTop ? /* @__PURE__ */ de("div", { className: "flex", children: [
            t("add_variable"),
            /* @__PURE__ */ m(qt, { name: "chevron-down", className: "ml-1 mt-[2px] h-4 w-4" })
          ] }) : "+" })
        ] }) : /* @__PURE__ */ de("div", { className: "flex", children: [
          t("add_variable"),
          /* @__PURE__ */ m(qt, { name: "chevron-down", className: "ml-1 mt-[2px] h-4 w-4" })
        ] }) }) }),
        /* @__PURE__ */ m(Yu, { className: "w-52", children: /* @__PURE__ */ de("div", { className: "space-y-2 p-1", children: [
          /* @__PURE__ */ m("div", { className: "text-muted ml-1 text-left text-xs font-medium tracking-wide", children: t("add_dynamic_variables") }),
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
            Iu,
            {
              type: "text",
              size: "sm",
              value: n,
              onChange: (a) => o(a.target.value),
              placeholder: t("search_variables"),
              "aria-label": t("search_variables"),
              className: "border-subtle bg-default focus:ring-brand-800 w-full rounded-md border px-3 py-2 text-sm outline-none focus:ring-1"
            }
          ) }),
          /* @__PURE__ */ m("div", { className: "max-h-64 overflow-y-auto overflow-x-hidden md:max-h-80", children: i.length === 0 ? /* @__PURE__ */ m("div", { className: "text-subtle px-4 py-2 text-center text-sm", children: t("no_variables_found") }) : i.map((a) => /* @__PURE__ */ m(Pi, { className: "w-full p-1 hover:ring-0", children: /* @__PURE__ */ m(
            "div",
            {
              className: "w-full cursor-pointer rounded-md text-left transition-colors",
              onClick: () => {
                e.addVariable(t(`${a}_variable`)), o("");
              },
              children: /* @__PURE__ */ de("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ m(
                  "div",
                  {
                    className: xe(
                      "text-default font-mono text-sm",
                      r ? "break-all" : "truncate"
                    ),
                    children: `{${t(`${a}_variable`).toUpperCase().replace(/ /g, "_")}}`
                  }
                ),
                /* @__PURE__ */ m("div", { className: "text-muted hidden text-xs sm:block", children: t(`${a}_info`) })
              ] })
            },
            a
          ) }, a)) })
        ] }) })
      ]
    }
  );
}, Ebe = 1, dKl = /* @__PURE__ */ new Set(["paragraph", "h1", "h2", "ul", "ol"]), cP = {
  paragraph: "Normal",
  ol: "Numbered List",
  ul: "Bulleted List",
  h1: "Large Heading",
  h2: "Small Heading"
};
function iQ(e, t) {
  t === null ? (e.style.opacity = "0", e.style.top = "-1000px", e.style.left = "-1000px") : (e.style.opacity = "1", e.style.top = `${t.top + t.height + window.pageYOffset + 10}px`, e.style.left = `${t.left + window.pageXOffset - e.offsetWidth / 2 + t.width / 2}px`);
}
function _Kl({ editor: e }) {
  const t = xt(null), n = xt(!1), o = xt(null), [r, i] = it(""), [a, s] = it(!0), [c, l] = it(
    null
  ), u = Yt(() => {
    const d = Mr.$getSelection();
    if (Mr.$isRangeSelection(d)) {
      const h = xbe(d), $ = h.getParent();
      bl.$isLinkNode($) ? i($.getURL()) : bl.$isLinkNode(h) ? i(h.getURL()) : i("");
    }
    const _ = t.current, p = window.getSelection(), g = document.activeElement;
    if (_ === null)
      return;
    const f = e.getRootElement();
    if (d !== null && !(p != null && p.isCollapsed) && f !== null && f.contains((p == null ? void 0 : p.anchorNode) || null)) {
      const h = p == null ? void 0 : p.getRangeAt(0);
      let $;
      if ((p == null ? void 0 : p.anchorNode) === f) {
        let v = f;
        for (; v.firstElementChild != null; )
          v = v.firstElementChild;
        $ = v.getBoundingClientRect();
      } else
        $ = h == null ? void 0 : h.getBoundingClientRect();
      n.current || iQ(_, $ || null), l(d);
    } else
      (!g || g.className !== "link-input") && (iQ(_, null), l(null), s(!1), i(""));
    return !0;
  }, [e]);
  return yt(() => t6.mergeRegister(
    e.registerUpdateListener(({ editorState: d }) => {
      d.read(() => {
        u();
      });
    }),
    e.registerCommand(
      Mr.SELECTION_CHANGE_COMMAND,
      () => (u(), !0),
      Ebe
    )
  ), [e, u]), yt(() => {
    e.getEditorState().read(() => {
      u();
    });
  }, [e, u]), yt(() => {
    a && o.current && o.current.focus();
  }, [a]), /* @__PURE__ */ m("div", { ref: t, className: "link-editor", children: a ? /* @__PURE__ */ m(
    "input",
    {
      ref: o,
      className: "link-input",
      value: r,
      onChange: (d) => {
        i(d.target.value);
      },
      onKeyDown: (d) => {
        d.key === "Enter" ? (d.preventDefault(), c !== null && (r !== "" && e.dispatchCommand(bl.TOGGLE_LINK_COMMAND, r), s(!1))) : d.key === "Escape" && (d.preventDefault(), s(!1));
      }
    }
  ) : /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de("div", { className: "link-input", children: [
    /* @__PURE__ */ m("a", { href: r, target: "_blank", rel: "noopener noreferrer", children: r }),
    /* @__PURE__ */ m(
      "div",
      {
        className: "link-edit",
        role: "button",
        tabIndex: 0,
        onMouseDown: (d) => d.preventDefault(),
        onClick: () => {
          s(!0);
        }
      }
    )
  ] }) }) });
}
function xbe(e) {
  const t = e.anchor, n = e.focus, o = e.anchor.getNode(), r = e.focus.getNode();
  return o === r ? o : e.isBackward() ? ck.$isAtNodeEnd(n) ? o : r : ck.$isAtNodeEnd(t) ? r : o;
}
function pKl(e) {
  var y, w, N, M;
  const [t] = d1.useLexicalComposerContext(), n = xt(null), [o, r] = it("paragraph"), [i, a] = it(!1), [s, c] = it(!1), [l, u] = it(!1), d = () => {
    o !== "paragraph" && t.update(() => {
      const q = Mr.$getSelection();
      Mr.$isRangeSelection(q) && ck.$wrapNodes(q, () => Mr.$createParagraphNode());
    });
  }, _ = () => {
    o !== "h1" && t.update(() => {
      const q = Mr.$getSelection();
      Mr.$isRangeSelection(q) && ck.$wrapNodes(q, () => mf.$createHeadingNode("h1"));
    });
  }, p = () => {
    o !== "h2" && t.update(() => {
      const q = Mr.$getSelection();
      Mr.$isRangeSelection(q) && ck.$wrapNodes(q, () => mf.$createHeadingNode("h2"));
    });
  }, g = () => {
    o !== "ul" ? t.dispatchCommand(Hl.INSERT_UNORDERED_LIST_COMMAND, void 0) : t.dispatchCommand(Hl.REMOVE_LIST_COMMAND, void 0);
  }, f = () => {
    o !== "ol" ? t.dispatchCommand(Hl.INSERT_ORDERED_LIST_COMMAND, void 0) : t.dispatchCommand(Hl.REMOVE_LIST_COMMAND, void 0);
  }, h = (q) => {
    switch (q) {
      case "paragraph":
        d();
        break;
      case "ul":
        g();
        break;
      case "ol":
        f();
        break;
      case "h1":
        _();
        break;
      case "h2":
        p();
        break;
    }
  }, $ = Yt(() => {
    const q = Mr.$getSelection();
    if (Mr.$isRangeSelection(q)) {
      const L = q.anchor.getNode(), R = L.getKey() === "root" ? L : L.getTopLevelElementOrThrow(), T = R.getKey();
      if (t.getElementByKey(T) !== null)
        if (Hl.$isListNode(R)) {
          const E = t6.$getNearestNodeOfType(L, Hl.ListNode), x = E ? E.getTag() : R.getTag();
          r(x);
        } else {
          const E = mf.$isHeadingNode(R) ? R.getTag() : R.getType();
          r(E);
        }
      c(q.hasFormat("bold")), u(q.hasFormat("italic"));
      const A = xbe(q), S = A.getParent();
      bl.$isLinkNode(S) || bl.$isLinkNode(A) ? a(!0) : a(!1);
    }
  }, [t]), v = (q) => {
    t.update(() => {
      const L = Mr.$getSelection();
      Mr.$isRangeSelection(L) && t.update(() => {
        const R = `{${q.toUpperCase().replace(/ /g, "_")}}`;
        L == null || L.insertRawText(R);
      });
    });
  };
  yt(() => {
    e.firstRender || t.update(() => {
      const q = Mr.$getRoot();
      q && t.update(() => {
        const R = new DOMParser().parseFromString(e.getText(), "text/html"), T = sk.$generateNodesFromDOM(t, R), D = Mr.$createParagraphNode();
        q.clear().append(D), D.select(), Mr.$insertNodes(T);
      });
    });
  }, [e.updateTemplate]), yt(() => {
    e.setFirstRender && (e.setFirstRender(!1), t.update(() => {
      const L = new DOMParser().parseFromString(e.getText(), "text/html"), R = sk.$generateNodesFromDOM(t, L);
      Mr.$getRoot().select();
      try {
        Mr.$insertNodes(R);
      } catch {
        const T = Mr.$createParagraphNode();
        R.forEach((D) => T.append(D)), Mr.$getRoot().append(T);
      }
      t.registerUpdateListener(({ editorState: T, prevEditorState: D }) => {
        T.read(() => {
          const A = sk.$generateHtmlFromNodes(t).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
          e.setText(
            A.replace(
              /<p\s+class="editor-paragraph"[^>]*>\s*<br>\s*<\/p>/g,
              "<p class='editor-paragraph'></p>"
            )
          );
        }), D._selection || t.blur();
      });
    }));
  }, []), yt(() => t6.mergeRegister(
    t.registerUpdateListener(({ editorState: q }) => {
      q.read(() => {
        $();
      });
    }),
    t.registerCommand(
      Mr.SELECTION_CHANGE_COMMAND,
      (q, L) => ($(), !1),
      Ebe
    )
  ), [t, $]);
  const b = Yt(() => {
    i ? t.dispatchCommand(bl.TOGGLE_LINK_COMMAND, null) : t.dispatchCommand(bl.TOGGLE_LINK_COMMAND, "https://");
  }, [t, i]);
  return e.editable ? /* @__PURE__ */ m("div", { className: "toolbar flex", ref: n, children: /* @__PURE__ */ de(nt, { children: [
    !((y = e.excludedToolbarItems) != null && y.includes("blockType")) && dKl.has(o) && /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(jd, { children: [
      /* @__PURE__ */ m(Hu, { className: "text-subtle", children: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("span", { className: `icon${o}` }),
        /* @__PURE__ */ m("span", { className: "text text-default hidden sm:flex", children: cP[o] }),
        /* @__PURE__ */ m(qt, { name: "chevron-down", className: "text-default ml-2 h-4 w-4" })
      ] }) }),
      /* @__PURE__ */ m(Yu, { align: "start", children: Object.keys(cP).map((q) => /* @__PURE__ */ m(Pi, { className: "outline-none hover:ring-0 focus:ring-0", children: /* @__PURE__ */ m(
        Jt,
        {
          color: "minimal",
          type: "button",
          onClick: () => h(q),
          className: Ia(
            "w-full rounded-none focus:ring-0",
            o === q ? "bg-subtle w-full" : ""
          ),
          children: /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m("span", { className: `icon block-type ${q}` }),
            /* @__PURE__ */ m("span", { children: cP[q] })
          ] })
        }
      ) }, q)) })
    ] }) }),
    /* @__PURE__ */ de("div", { className: "flex gap-1", children: [
      !((w = e.excludedToolbarItems) != null && w.includes("bold")) && /* @__PURE__ */ m(
        Jt,
        {
          "aria-label": "Bold",
          color: "minimal",
          variant: "icon",
          type: "button",
          StartIcon: "bold",
          onClick: () => {
            t.dispatchCommand(Mr.FORMAT_TEXT_COMMAND, "bold");
          },
          className: s ? "bg-subtle" : ""
        }
      ),
      !((N = e.excludedToolbarItems) != null && N.includes("italic")) && /* @__PURE__ */ m(
        Jt,
        {
          "aria-label": "Italic",
          color: "minimal",
          variant: "icon",
          type: "button",
          StartIcon: "italic",
          onClick: () => {
            t.dispatchCommand(Mr.FORMAT_TEXT_COMMAND, "italic");
          },
          className: l ? "bg-subtle" : ""
        }
      ),
      !((M = e.excludedToolbarItems) != null && M.includes("link")) && /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(
          Jt,
          {
            "aria-label": "Link",
            color: "minimal",
            variant: "icon",
            type: "button",
            StartIcon: "link",
            onClick: b,
            className: i ? "bg-subtle" : ""
          }
        ),
        i && My(/* @__PURE__ */ m(_Kl, { editor: t }), document.body),
        " "
      ] })
    ] }),
    e.variables && /* @__PURE__ */ m("div", { className: `${e.addVariableButtonTop ? "-mt-10" : ""} ml-auto`, children: /* @__PURE__ */ m(
      uKl,
      {
        addVariable: v,
        isTextEditor: !0,
        variables: e.variables || [],
        addVariableButtonTop: e.addVariableButtonTop
      }
    ) })
  ] }) }) : null;
}
const mKl = () => {
  const [e] = d1.useLexicalComposerContext();
  return yt(() => {
    const t = e.registerCommand(
      Mr.KEY_ENTER_COMMAND,
      (n) => {
        const o = Mr.$getSelection();
        if (Mr.$isRangeSelection(o)) {
          const r = o.anchor.getNode();
          if (Hl.$isListItemNode(r) || Hl.$isListItemNode(r.getParent()))
            return !1;
          n.preventDefault();
          const i = Mr.$createLineBreakNode();
          return o.insertNodes([i]), !0;
        }
        return !1;
      },
      Mr.COMMAND_PRIORITY_HIGH
    );
    return () => {
      t();
    };
  }, [e]), null;
}, fKl = mKl, gKl = {
  theme: WYl,
  onError(e) {
    throw e;
  },
  namespace: "",
  nodes: [
    mf.HeadingNode,
    Hl.ListNode,
    Hl.ListItemNode,
    mf.QuoteNode,
    iT.CodeNode,
    iT.CodeHighlightNode,
    sP.TableNode,
    sP.TableCellNode,
    sP.TableRowNode,
    bl.AutoLinkNode,
    bl.LinkNode,
    u1
  ]
}, aV = (e) => {
  const t = e.editable ?? !0, n = e.plainText ?? !1;
  return /* @__PURE__ */ de("div", { className: "editor rounded-md", children: [
    e.label && /* @__PURE__ */ m("label", { className: "mb-1 block text-sm font-medium leading-6", children: e.label }),
    /* @__PURE__ */ de(eYl.LexicalComposer, { initialConfig: { ...gKl }, children: [
      /* @__PURE__ */ de("div", { className: "editor-container hover:border-emphasis focus-within:ring-brand-default !rounded-lg p-0 transition focus-within:ring-2 focus-within:ring-offset-0", children: [
        /* @__PURE__ */ m(
          pKl,
          {
            getText: e.getText,
            setText: e.setText,
            editable: t,
            excludedToolbarItems: e.excludedToolbarItems,
            variables: e.variables,
            addVariableButtonTop: e.addVariableButtonTop,
            updateTemplate: e.updateTemplate,
            firstRender: e.firstRender,
            setFirstRender: e.setFirstRender
          }
        ),
        /* @__PURE__ */ de(
          "div",
          {
            className: xe("editor-inner scroll-bar overflow-x-hidden", !t && "!bg-subtle"),
            style: { height: e.height, maxHeight: e.maxHeight },
            children: [
              /* @__PURE__ */ m(
                jYl.RichTextPlugin,
                {
                  contentEditable: /* @__PURE__ */ m(
                    rYl.ContentEditable,
                    {
                      readOnly: !t,
                      style: { height: e.height },
                      className: "editor-input focus:outline-none",
                      "data-testid": "editor-input"
                    }
                  ),
                  placeholder: e != null && e.placeholder ? /* @__PURE__ */ m("div", { className: "text-muted -mt-11 p-3 text-sm", children: e.placeholder }) : null,
                  ErrorBoundary: lYl
                }
              ),
              /* @__PURE__ */ m(kYl.ListPlugin, {}),
              /* @__PURE__ */ m(bYl.LinkPlugin, {}),
              /* @__PURE__ */ m(sKl, {}),
              /* @__PURE__ */ m(fKl, {}),
              e != null && e.variables ? /* @__PURE__ */ m(QYl, { variables: e.variables }) : null,
              /* @__PURE__ */ m(fYl.HistoryPlugin, {}),
              /* @__PURE__ */ m(
                OYl.MarkdownShortcutPlugin,
                {
                  transformers: e.disableLists ? aT.TRANSFORMERS.filter((o, r) => {
                    if (r !== 3 && r !== 4)
                      return o;
                  }) : aT.TRANSFORMERS
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ m(cKl, { editable: t }),
      /* @__PURE__ */ m(lKl, { setText: e.setText, plainText: n })
    ] })
  ] });
};
function hKl({
  form: e,
  isManagedEventType: t,
  handleSubmit: n,
  pageSlug: o,
  isPending: r,
  urlPrefix: i,
  SubmitButton: a
}) {
  const s = Kr(), { t: c } = kt(), [l, u] = it(!0), { register: d } = e;
  return /* @__PURE__ */ de(
    Y_,
    {
      form: e,
      handleSubmit: (_) => {
        n(_);
      },
      children: [
        /* @__PURE__ */ de("div", { className: "mt-3 space-y-6 pb-11", children: [
          /* @__PURE__ */ m(
            xr,
            {
              label: c("title"),
              placeholder: c("quick_chat"),
              "data-testid": "event-type-quick-chat",
              ...d("title"),
              onChange: (_) => {
                e.setValue("title", _ == null ? void 0 : _.target.value), e.formState.touchedFields.slug === void 0 && e.setValue("slug", ev(_ == null ? void 0 : _.target.value));
              }
            }
          ),
          i && i.length >= 21 ? /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ m(
              xr,
              {
                label: s ? "Slug" : `${c("url")}: ${i}`,
                required: !0,
                addOnLeading: s ? void 0 : /* @__PURE__ */ m("span", { className: "max-w-24 md:max-w-56", children: `/${t ? c("username_placeholder") : o}/` }),
                containerClassName: "[&>div]:gap-0",
                className: "pl-0",
                ...d("slug"),
                onChange: (_) => {
                  e.setValue("slug", ev(_ == null ? void 0 : _.target.value), { shouldTouch: !0 });
                }
              }
            ),
            t && !s && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: c("managed_event_url_clarification") })
          ] }) : /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ m(
              xr,
              {
                label: s ? "Slug" : c("url"),
                required: !0,
                addOnLeading: s ? void 0 : /* @__PURE__ */ m(
                  Sr,
                  {
                    content: `${i}/${t ? c("username_placeholder") : o}/`,
                    children: /* @__PURE__ */ m("span", { className: "max-w-24 md:max-w-56", children: `${i}/${t ? c("username_placeholder") : o}/` })
                  }
                ),
                containerClassName: "[&>div]:gap-0",
                className: "pl-0",
                ...d("slug"),
                onChange: (_) => {
                  e.setValue("slug", ev(_ == null ? void 0 : _.target.value), { shouldTouch: !0 });
                }
              }
            ),
            t && !s && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: c("managed_event_url_clarification") })
          ] }),
          /* @__PURE__ */ de(nt, { children: [
            s ? /* @__PURE__ */ m(Pde, { ...d("description"), placeholder: c("quick_video_meeting") }) : /* @__PURE__ */ m(
              aV,
              {
                label: c("description"),
                getText: () => t2.render(e.getValues("description") || ""),
                setText: (_) => e.setValue("description", iV(_)),
                excludedToolbarItems: ["blockType", "link"],
                placeholder: c("quick_video_meeting"),
                firstRender: l,
                setFirstRender: u,
                maxHeight: "200px"
              }
            ),
            /* @__PURE__ */ m("div", { className: "relative", children: /* @__PURE__ */ m(
              xr,
              {
                type: "number",
                required: !0,
                min: Fb,
                max: Mb,
                placeholder: "15",
                label: c("duration"),
                className: "pr-4",
                ...d("length", {
                  valueAsNumber: !0,
                  min: {
                    value: Fb,
                    message: c("duration_min_error", { min: Fb })
                  },
                  max: {
                    value: Mb,
                    message: c("duration_max_error", { max: Mb })
                  }
                }),
                addOnSuffix: c("minutes").toLowerCase()
              }
            ) })
          ] })
        ] }),
        a(r)
      ]
    }
  );
}
const vKl = /* @__PURE__ */ nu(Nsl);
function sV(e, t) {
  if (!e || !t || !e.length || !t.length)
    throw new Error("Bad alphabet");
  this.srcAlphabet = e, this.dstAlphabet = t;
}
sV.prototype.convert = function(e) {
  var t, n, o, r = {}, i = this.srcAlphabet.length, a = this.dstAlphabet.length, s = e.length, c = typeof e == "string" ? "" : [];
  if (!this.isValid(e))
    throw new Error('Number "' + e + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
  if (this.srcAlphabet === this.dstAlphabet)
    return e;
  for (t = 0; t < s; t++)
    r[t] = this.srcAlphabet.indexOf(e[t]);
  do {
    for (n = 0, o = 0, t = 0; t < s; t++)
      n = n * i + r[t], n >= a ? (r[o++] = parseInt(n / a, 10), n = n % a) : o > 0 && (r[o++] = 0);
    s = o, c = this.dstAlphabet.slice(n, n + 1).concat(c);
  } while (o !== 0);
  return c;
};
sV.prototype.isValid = function(e) {
  for (var t = 0; t < e.length; ++t)
    if (this.srcAlphabet.indexOf(e[t]) === -1)
      return !1;
  return !0;
};
var bKl = sV, yKl = bKl;
function _1(e, t) {
  var n = new yKl(e, t);
  return function(o) {
    return n.convert(o);
  };
}
_1.BIN = "01";
_1.OCT = "01234567";
_1.DEC = "0123456789";
_1.HEX = "0123456789abcdef";
var $Kl = _1;
const { v4: lP } = vKl, wE = $Kl, uP = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ", wKl = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~", kKl = {
  consistentLength: !0
};
let dP;
const aQ = (e, t, n) => {
  const o = t(e.toLowerCase().replace(/-/g, ""));
  return !n || !n.consistentLength ? o : o.padStart(
    n.shortIdLength,
    n.paddingChar
  );
}, SKl = (e, t) => {
  const o = t(e).padStart(32, "0").match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
  return [o[1], o[2], o[3], o[4], o[5]].join("-");
}, EKl = (e) => Math.ceil(Math.log(2 ** 128) / Math.log(e));
var xKl = (() => {
  const e = (t, n) => {
    const o = t || uP, r = { ...kKl, ...n };
    if ([...new Set(Array.from(o))].length !== o.length)
      throw new Error("The provided Alphabet has duplicate characters resulting in unreliable results");
    const i = EKl(o.length), a = {
      shortIdLength: i,
      consistentLength: r.consistentLength,
      paddingChar: o[0]
    }, s = wE(wE.HEX, o), c = wE(o, wE.HEX), l = () => aQ(lP(), s, a), u = {
      new: l,
      generate: l,
      uuid: lP,
      fromUUID: (d) => aQ(d, s, a),
      toUUID: (d) => SKl(d, c),
      alphabet: o,
      maxLength: i
    };
    return Object.freeze(u), u;
  };
  return e.constants = {
    flickrBase58: uP,
    cookieBase90: wKl
  }, e.uuid = lP, e.generate = () => (dP || (dP = e(uP).generate), dP()), e;
})();
const CKl = /* @__PURE__ */ Mi(xKl), Cbe = (e) => {
  const t = CKl(), n = `${e}:${(/* @__PURE__ */ new Date()).getTime()}`;
  return t.fromUUID(B5(n, B5.URL));
};
function TKl(e) {
  var t, n, o, r, i, a, s, c;
  if (e != null && e.userId && ((t = e == null ? void 0 : e.owner) != null && t.timeZone))
    return e.owner.timeZone;
  if (e != null && e.teamId) {
    if (e.hosts && e.hosts.length > 0 && ((o = (n = e.hosts[0]) == null ? void 0 : n.user) != null && o.timeZone))
      return e.hosts[0].user.timeZone;
    if ((r = e.team) != null && r.members && e.team.members.length > 0 && ((a = (i = e.team.members[0]) == null ? void 0 : i.user) != null && a.timeZone))
      return (c = (s = e.team.members[0]) == null ? void 0 : s.user) == null ? void 0 : c.timeZone;
  }
  return ht.tz.guess();
}
function AKl(e, t) {
  if (!e)
    return !1;
  if (t) {
    const n = ht().tz(t);
    return ht(e).tz(t).isBefore(n);
  } else {
    const n = ht();
    return ht(e).isBefore(n);
  }
}
function IKl(e, t) {
  return !t || t <= 0 ? !1 : e >= t;
}
function OKl(e, t) {
  return e.expiresAt ? AKl(e.expiresAt, t) : IKl(e.usageCount || 0, e.maxUsageCount);
}
function NKl() {
  const [e, t] = it(!1), n = () => {
  }, o = (a, s = {}) => {
    const { onSuccess: c = n, onFailure: l = n } = s;
    typeof navigator < "u" && navigator.clipboard ? navigator.clipboard.writeText(a).then(() => {
      t(!0), c();
    }).catch((u) => {
      l(), console.error("Copy to clipboard failed:", u);
    }) : (console.warn(
      `You need to use a secure context to use clipboard 
 Please use the following link: `,
      a
    ), l());
  }, r = () => {
    t(!1);
  }, i = (a, s = {}) => {
    var u;
    const { onSuccess: c = n, onFailure: l = n } = s;
    if ((u = navigator.clipboard) != null && u.write) {
      const d = new ClipboardItem({
        "text/plain": a.then((_) => new Blob([_], { type: "text/plain" })).catch(() => (l(), ""))
      });
      navigator.clipboard.write([d]), c();
    } else
      a.then((d) => o(d, s)).catch(() => l());
  };
  return yt(() => {
    if (e) {
      const a = setTimeout(r, 3e3);
      return () => clearTimeout(a);
    }
  }, [e]), { isCopied: e, copyToClipboard: o, resetCopyStatus: r, fetchAndCopyToClipboard: i };
}
const zKl = ({
  team: e,
  bookerUrl: t,
  setMultiplePrivateLinksVisible: n,
  userTimeZone: o
}) => {
  const r = No(), { t: i } = kt(), { copyToClipboard: a } = NKl(), [s] = qd(), [c, l] = it(!1), [u, d] = it(null), [_, p] = it("usage"), [g, f] = it(/* @__PURE__ */ new Date()), [h, $] = it(1), v = (y, w, N, M) => {
    if (y === null)
      return;
    const L = (r.getValues("multiplePrivateLinks") || []).map(
      (R) => typeof R == "string" ? { link: R, expiresAt: null, maxUsageCount: 1, usageCount: 0 } : R
    );
    if (w === "time") {
      const T = ht(N || g).format("YYYY-MM-DD"), D = ht.utc(`${T}T23:59:59.999Z`).toDate();
      L[y] = {
        ...L[y],
        expiresAt: D,
        maxUsageCount: null
      };
    } else
      w === "usage" && (L[y] = {
        ...L[y],
        expiresAt: null,
        maxUsageCount: M !== void 0 ? M : h
      });
    r.setValue("multiplePrivateLinks", L, {
      shouldDirty: !0,
      shouldTouch: !0,
      shouldValidate: !0
    });
  }, b = (y, w) => {
    if (d(y), w.expiresAt) {
      p("time");
      const N = ht.utc(w.expiresAt).format("YYYY-MM-DD");
      f(ht(N).toDate());
    } else
      p("usage"), $(w.maxUsageCount ?? 1);
    l(!0);
  };
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Bn,
      {
        name: "multiplePrivateLinks",
        control: r.control,
        render: ({ field: { value: y, onChange: w } }) => {
          y || (y = []);
          const N = y.map(
            (S) => typeof S == "string" ? { link: S, expiresAt: null, maxUsageCount: null, usageCount: 0 } : S
          ), { data: M } = hr.viewer.eventTypes.getHashedLinks.useQuery(
            { linkIds: N.map((S) => S.link) },
            {
              enabled: N.length > 0,
              refetchOnMount: !0
            }
          ), q = new Map((M == null ? void 0 : M.map((S) => [S.linkId, S])) || []), L = () => {
            var k, I;
            const S = ((I = (k = r.getValues("users")) == null ? void 0 : k[0]) == null ? void 0 : I.id) ?? (e == null ? void 0 : e.id);
            if (!S)
              return;
            const E = {
              link: Cbe(S),
              expiresAt: null,
              maxUsageCount: 1,
              usageCount: 0
            }, x = [...N, E];
            w(x);
          }, R = (S) => {
            const E = [...N];
            E.splice(S, 1), w(E), E.length === 0 && n && n(!1);
          }, T = (S) => {
            const E = q.get(S.link), x = (E == null ? void 0 : E.usageCount) ?? (S.usageCount || 0);
            return OKl(
              {
                expiresAt: S.expiresAt,
                maxUsageCount: S.maxUsageCount,
                usageCount: x
              },
              o
            );
          }, D = (S, E) => {
            const x = T(S), k = E ?? (S.usageCount || 0);
            if (S.expiresAt) {
              const I = ht.utc(S.expiresAt).format("MMM DD, YYYY");
              return x ? i("link_expired_on_date", { date: I }) : i("expires_on_date", { date: I });
            } else if (S.maxUsageCount !== void 0 && S.maxUsageCount !== null && !isNaN(Number(S.maxUsageCount))) {
              const I = S.maxUsageCount, z = I - k;
              return x ? i("usage_limit_reached") : z === 1 ? i("remainder_of_maximum_use_left_singular", {
                remainder: z,
                maximum: I
              }) : i("remainder_of_maximum_uses_left_plural", {
                remainder: z,
                maximum: I
              });
            }
            return i("remainder_of_maximum_use_left_singular", {
              remainder: "1",
              maximum: "1"
            });
          }, A = N.map((S, E) => {
            const x = T(S), k = !!S.expiresAt, I = k ? new Date(S.expiresAt).getTime() : null;
            return {
              val: S,
              originalIndex: E,
              expired: x,
              hasExpiry: k,
              expiryTime: I
            };
          }).sort((S, E) => S.expired !== E.expired ? S.expired ? 1 : -1 : !S.expired && !E.expired ? S.hasExpiry !== E.hasExpiry ? S.hasExpiry ? -1 : 1 : S.hasExpiry && E.hasExpiry ? S.expiryTime - E.expiryTime : E.originalIndex - S.originalIndex : S.originalIndex - E.originalIndex);
          return /* @__PURE__ */ de("ul", { ref: s, children: [
            A.map(({ val: S, originalIndex: E }, x) => {
              const k = `${t}/d/${S.link}/${r.getValues("slug")}`, I = q.get(S.link), z = (I == null ? void 0 : I.usageCount) ?? (S.usageCount || 0), F = T(S), P = D(S, z);
              return /* @__PURE__ */ de("li", { "data-testid": "add-single-use-link", className: "mb-4 flex flex-col", children: [
                /* @__PURE__ */ de("div", { className: "flex items-center", children: [
                  /* @__PURE__ */ m(
                    xr,
                    {
                      containerClassName: xe("w-full"),
                      disabled: F,
                      value: k,
                      readOnly: !0,
                      className: xe(F ? "bg-red-50 text-gray-400" : "bg-gray-50"),
                      "data-testid": "private-link-url",
                      addOnSuffix: F ? /* @__PURE__ */ m(Wi, { "data-testid": "private-link-expired", variant: "red", children: i("expired") }) : /* @__PURE__ */ m(Sr, { content: i("copy_link"), children: /* @__PURE__ */ m(
                        Jt,
                        {
                          type: "button",
                          color: "minimal",
                          size: "sm",
                          StartIcon: "copy",
                          onClick: () => {
                            a(k), ti(i("link_copied"), "success");
                          }
                        }
                      ) })
                    }
                  ),
                  /* @__PURE__ */ de("div", { className: "ml-2 flex items-center", children: [
                    !F && /* @__PURE__ */ m(
                      Jt,
                      {
                        type: "button",
                        color: "minimal",
                        variant: "icon",
                        StartIcon: "settings",
                        "data-testid": "private-link-settings",
                        onClick: () => b(E, S)
                      }
                    ),
                    /* @__PURE__ */ m(
                      Jt,
                      {
                        "data-testid": `remove-private-link-${E}`,
                        variant: "icon",
                        type: "button",
                        StartIcon: "trash-2",
                        color: "destructive",
                        className: "ml-1 border-none",
                        onClick: () => R(E)
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ m("div", { "data-testid": "private-link-description", className: "mt-1 text-sm text-gray-500", children: P })
              ] }, S.link);
            }),
            /* @__PURE__ */ m(
              Jt,
              {
                color: "minimal",
                StartIcon: "plus",
                onClick: L,
                "data-testid": "add-private-link-button",
                children: i("add_a_multiple_private_link")
              }
            )
          ] });
        }
      }
    ),
    /* @__PURE__ */ m(_v, { open: c, onOpenChange: l, children: /* @__PURE__ */ de(Ya, { title: i("link_settings"), type: "creation", children: [
      /* @__PURE__ */ m("div", { className: "mb-4 space-y-4", children: /* @__PURE__ */ de(
        zj,
        {
          className: "space-y-2",
          value: _,
          "data-testid": "private-link-radio-group",
          onValueChange: (y) => {
            p(y);
          },
          children: [
            /* @__PURE__ */ de(Eg, { value: "usage", "data-testid": "private-link-usage", className: "w-full text-sm", children: [
              /* @__PURE__ */ m("strong", { className: "mb-1 block", children: i("usage_based_expiration") }),
              /* @__PURE__ */ m("p", { children: _ !== "usage" ? i("usage_based_generic_expiration_description") : i(
                h === 1 ? "usage_based_expiration_description" : "usage_based_expiration_description_plural",
                { count: h || 0 }
              ) }),
              _ === "usage" && /* @__PURE__ */ m("div", { className: "mt-2 w-[180px]", children: /* @__PURE__ */ m(
                eyc,
                {
                  required: !0,
                  min: 1,
                  "data-testid": "private-link-usage-count",
                  placeholder: i("number_of_uses"),
                  value: h === null ? "" : h,
                  onChange: (y) => {
                    const w = y.target.value === "" ? null : parseInt(y.target.value);
                    y.target.value === "" ? $(null) : !isNaN(Number(w)) && Number(w) > 0 && $(w);
                  }
                }
              ) })
            ] }),
            /* @__PURE__ */ de(Eg, { "data-testid": "private-link-time", value: "time", className: "w-full text-sm", children: [
              /* @__PURE__ */ m("strong", { className: "mb-1 block", children: i("time_based_expiration") }),
              _ !== "time" ? i("time_based_generic_expiration_description") : i("time_based_expiration_description", {
                date: ht(g).format("MMM DD, YYYY")
              }),
              _ === "time" && /* @__PURE__ */ m("div", { className: "mt-2 w-[180px]", children: /* @__PURE__ */ m(
                s0c,
                {
                  "data-testid": "private-link-expiration-date",
                  date: g,
                  onDatesChange: (y) => {
                    f(y);
                  }
                }
              ) })
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ m("div", { className: "mb-4 mt-4 flex justify-end", children: /* @__PURE__ */ m(
        Jt,
        {
          type: "button",
          color: "primary",
          "data-testid": "private-link-expiration-settings-save",
          onClick: () => {
            _ === "time" ? v(u, "time", g) : v(u, "usage", void 0, h), l(!1);
          },
          children: i("save")
        }
      ) })
    ] }) })
  ] });
}, RKl = (e) => Zse(e);
function Tbe(e) {
  return sc[e.watch("type") || "text"];
}
const Abe = (e) => {
  const t = sc[e.type];
  return e.name === "location" ? { ...t, label: "Location" } : t;
}, PKl = function({
  title: t,
  description: n,
  addFieldLabel: o,
  formProp: r,
  disabled: i,
  LockedIcon: a,
  dataStore: s,
  shouldConsiderRequired: c,
  showPriceField: l,
  paymentCurrency: u = "USD",
  showPhoneAndEmailToggle: d = !1
}) {
  const _ = No(), [p] = qd(), { t: g } = kt(), { fields: f, swap: h, remove: $, update: v, append: b } = M0({
    control: _.control,
    // HACK: It allows any property name to be used for instead of `fields` property name
    name: r
  }), [y, w] = it({
    isOpen: !1,
    fieldIndex: -1,
    data: {}
  }), N = () => {
    w({
      isOpen: !0,
      fieldIndex: -1,
      data: null
    });
  }, M = (L, R) => {
    w({
      isOpen: !0,
      fieldIndex: L,
      data: R
    });
  }, q = (L) => {
    $(L);
  };
  return /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ de("div", { className: "text-default text-sm font-semibold leading-none ltr:mr-1 rtl:ml-1", children: [
        t,
        a
      ] }),
      /* @__PURE__ */ de("div", { className: "flex items-start justify-between", children: [
        /* @__PURE__ */ m("p", { className: "text-subtle mt-1 max-w-[280px] break-words text-sm sm:max-w-[500px]", children: n }),
        d && /* @__PURE__ */ m(
          lq,
          {
            value: (() => {
              const L = f.find((T) => T.name === "attendeePhoneNumber"), R = f.find((T) => T.name === "email");
              return L && !L.hidden && L.required && !(R != null && R.required) ? "phone" : "email";
            })(),
            options: [
              {
                value: "email",
                label: "Email",
                iconLeft: /* @__PURE__ */ m(qt, { name: "mail", className: "h-4 w-4" })
              },
              {
                value: "phone",
                label: "Phone",
                iconLeft: /* @__PURE__ */ m(qt, { name: "phone", className: "h-4 w-4" })
              }
            ],
            onValueChange: (L) => {
              const R = f.findIndex((D) => D.name === "attendeePhoneNumber"), T = f.findIndex((D) => D.name === "email");
              L === "email" ? (v(T, {
                ...f[T],
                hidden: !1,
                required: !0
              }), v(R, {
                ...f[R],
                hidden: !0,
                required: !1
              })) : L === "phone" && (v(T, {
                ...f[T],
                hidden: !0,
                required: !1
              }), v(R, {
                ...f[R],
                hidden: !1,
                required: !0
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ m("p", { className: "text-default mt-5 text-sm font-semibold leading-none ltr:mr-1 rtl:ml-1", children: g("questions") }),
      /* @__PURE__ */ m("p", { className: "text-subtle mt-1 max-w-[280px] break-words text-sm sm:max-w-[500px]", children: g("all_info_your_booker_provide") }),
      /* @__PURE__ */ m("ul", { ref: p, className: "border-subtle divide-subtle mt-4 divide-y rounded-md border", children: f.map((L, R) => {
        var V, U;
        let T = L.options ?? null;
        const D = [...L.sources || []], A = c ? c(L) : L.required;
        if (!T && L.getOptionsAt) {
          const {
            source: { label: H },
            value: J
          } = s.options[L.getOptionsAt] ?? [];
          T = J, T.forEach((le) => {
            D.push({
              id: le.value,
              label: H,
              type: "system"
            });
          });
        }
        GA.includes(L.type) && (L = { ...L, labelAsSafeHtml: Gj(L.label ?? "") });
        const S = (T == null ? void 0 : T.length) ?? 0, x = !!((U = L.optionsInputs) == null ? void 0 : U[(V = T == null ? void 0 : T[0]) == null ? void 0 : V.value]);
        if (L.hideWhenJustOneOption && S <= 1 && !x)
          return null;
        const k = Abe(L), I = L.editable === "system-but-optional", z = L.editable === "system-but-hidden", F = L.editable === "system", P = !F && !I && !z;
        if (!k)
          throw new Error(`Invalid field type - ${L.type}`);
        const O = D.reduce((H, J) => {
          const le = H[J.label] || [];
          return J.type === "user" || J.type === "default" || (le.push(J), H[J.label] = le), H;
        }, {});
        return /* @__PURE__ */ de(
          "li",
          {
            "data-testid": `field-${L.name}`,
            className: "hover:bg-muted group relative flex items-center justify-between p-4 transition",
            children: [
              !i && /* @__PURE__ */ de(nt, { children: [
                R >= 1 && /* @__PURE__ */ m(
                  "button",
                  {
                    type: "button",
                    className: "bg-default text-muted hover:text-emphasis disabled:hover:text-muted border-subtle hover:border-emphasis invisible absolute -left-[12px] -ml-4 -mt-4 mb-4 hidden h-6 w-6 scale-0 items-center justify-center rounded-md border p-1 transition-all hover:shadow disabled:hover:border-inherit disabled:hover:shadow-none group-hover:visible group-hover:scale-100 sm:ml-0 sm:flex",
                    onClick: () => h(R, R - 1),
                    children: /* @__PURE__ */ m(qt, { name: "arrow-up", className: "h-5 w-5" })
                  }
                ),
                R < f.length - 1 && /* @__PURE__ */ m(
                  "button",
                  {
                    type: "button",
                    className: "bg-default text-muted hover:border-emphasis border-subtle hover:text-emphasis disabled:hover:text-muted invisible absolute -left-[12px] -ml-4 mt-8 hidden h-6 w-6 scale-0 items-center justify-center rounded-md border p-1 transition-all hover:shadow disabled:hover:border-inherit disabled:hover:shadow-none group-hover:visible group-hover:scale-100 sm:ml-0 sm:flex",
                    onClick: () => h(R, R + 1),
                    children: /* @__PURE__ */ m(qt, { name: "arrow-down", className: "h-5 w-5" })
                  }
                )
              ] }),
              /* @__PURE__ */ de("div", { children: [
                /* @__PURE__ */ de("div", { className: "mr-4 flex flex-col lg:flex-row lg:items-center", children: [
                  /* @__PURE__ */ m("div", { className: "text-default text-sm font-semibold ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m(qKl, { field: L }) }),
                  /* @__PURE__ */ de("div", { className: "flex items-center space-x-2", children: [
                    L.hidden ? (
                      // Hidden field can't be required, so we don't need to show the Optional badge
                      /* @__PURE__ */ m(Wi, { variant: "grayWithoutHover", children: g("hidden") })
                    ) : /* @__PURE__ */ m(Wi, { variant: "grayWithoutHover", "data-testid": A ? "required" : "optional", children: g(A ? "required" : "optional") }),
                    Object.entries(O).map(([H, J], le) => (
                      // We don't know how to pluralize `sourceLabel` because it can be anything
                      /* @__PURE__ */ de(Wi, { variant: "blue", children: [
                        J.length,
                        " ",
                        J.length === 1 ? H : `${H}s`
                      ] }, le)
                    ))
                  ] })
                ] }),
                /* @__PURE__ */ m("p", { className: "text-subtle max-w-[280px] break-words pt-1 text-sm sm:max-w-[500px]", children: k.label })
              ] }),
              L.editable !== "user-readonly" && !i && /* @__PURE__ */ de("div", { className: "flex items-center space-x-2", children: [
                !F && !z && !i && /* @__PURE__ */ m(
                  as,
                  {
                    "data-testid": "toggle-field",
                    disabled: F,
                    checked: !L.hidden,
                    onCheckedChange: (H) => {
                      v(R, { ...L, hidden: !H });
                    },
                    tooltip: g("show_on_booking_page")
                  }
                ),
                P && /* @__PURE__ */ m(
                  Jt,
                  {
                    "data-testid": "delete-field-action",
                    color: "destructive",
                    disabled: !P,
                    variant: "icon",
                    onClick: () => {
                      q(R);
                    },
                    StartIcon: "trash-2"
                  }
                ),
                /* @__PURE__ */ m(
                  Jt,
                  {
                    "data-testid": "edit-field-action",
                    color: "secondary",
                    onClick: () => {
                      M(R, L);
                    },
                    children: g("edit")
                  }
                )
              ] })
            ]
          },
          L.name
        );
      }) }),
      !i && /* @__PURE__ */ m(
        Jt,
        {
          color: "minimal",
          "data-testid": "add-field",
          onClick: N,
          className: "mt-4",
          StartIcon: "plus",
          children: o
        }
      )
    ] }),
    y.isOpen && /* @__PURE__ */ m(
      MKl,
      {
        dialog: y,
        onOpenChange: (L) => w({
          isOpen: L,
          fieldIndex: -1,
          data: null
        }),
        handleSubmit: (L) => {
          const R = L.type || "text", T = !y.data;
          if (L.name === "guests" && R !== "multiemail") {
            ti(g("guests_field_must_be_multiemail"), "error");
            return;
          }
          if (T && f.some((D) => D.name === L.name)) {
            ti(g("form_builder_field_already_exists"), "error");
            return;
          }
          if (y.data)
            v(y.fieldIndex, L);
          else {
            const D = {
              ...L,
              type: R,
              sources: [
                {
                  label: "User",
                  type: "user",
                  id: "user",
                  fieldRequired: L.required
                }
              ]
            };
            D.editable = D.editable || "user", b(D);
          }
          w({
            isOpen: !1,
            fieldIndex: -1,
            data: null
          });
        },
        shouldConsiderRequired: c,
        showPriceField: l,
        paymentCurrency: u
      }
    )
  ] });
};
function DKl({
  label: e = "Options",
  value: t,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: n = () => {
  },
  className: o = "",
  readOnly: r = !1,
  showPrice: i = !1,
  paymentCurrency: a
}) {
  const { t: s } = kt(), [c] = qd();
  return t || n([
    {
      label: "Option 1",
      value: "Option 1"
    },
    {
      label: "Option 2",
      value: "Option 2"
    }
  ]), /* @__PURE__ */ de("div", { className: o, children: [
    /* @__PURE__ */ m(Ko, { children: e }),
    /* @__PURE__ */ de("div", { className: "bg-muted rounded-md p-4", "data-testid": "options-container", children: [
      /* @__PURE__ */ m("ul", { ref: c, className: "flex flex-col gap-3", children: t == null ? void 0 : t.map((l, u) => /* @__PURE__ */ m("li", { children: /* @__PURE__ */ de("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ de("div", { className: "relative flex-grow", children: [
          /* @__PURE__ */ m(
            Iu,
            {
              required: !0,
              value: l.label,
              onChange: (d) => {
                const _ = [...t || []];
                _.splice(u, 1, {
                  label: d.target.value,
                  value: d.target.value.trim()
                }), n(_);
              },
              readOnly: r,
              placeholder: s("enter_option", { index: u + 1 }),
              className: t.length > 2 && !r ? "pr-8" : ""
            }
          ),
          t.length > 2 && !r && /* @__PURE__ */ m(
            Jt,
            {
              type: "button",
              className: "absolute right-1 top-1/2 -translate-y-1/2 hover:!bg-transparent focus:!bg-transparent focus:!outline-none focus:!ring-0",
              size: "sm",
              color: "minimal",
              StartIcon: "x",
              onClick: () => {
                if (!t)
                  return;
                const d = [...t || []];
                d.splice(u, 1), n(d);
              }
            }
          )
        ] }),
        i && /* @__PURE__ */ m("div", { className: "w-24", children: /* @__PURE__ */ m(
          Da,
          {
            type: "number",
            min: 0,
            step: "0.01",
            value: l.price,
            onChange: (d) => {
              const _ = d.target.value, p = _ === "" ? void 0 : Number(_), g = [...t || []];
              g[u] = {
                ...l,
                price: p
              }, n(g);
            },
            readOnly: r,
            placeholder: "0",
            addOnLeading: ohe(a)
          }
        ) })
      ] }) }, u)) }),
      !r && /* @__PURE__ */ m(
        Jt,
        {
          color: "minimal",
          "data-testid": "add-option",
          className: "mt-3",
          onClick: () => {
            const l = [...t || []];
            l.push({ label: "", value: "", price: 0 }), n(l);
          },
          StartIcon: "plus",
          children: "Add an Option"
        }
      )
    ] })
  ] });
}
const LKl = ({ fieldForm: e }) => {
  const { t } = kt(), [n, o] = it(!0);
  return /* @__PURE__ */ de("div", { className: "mt-6", children: [
    /* @__PURE__ */ m(Ko, { children: t("label") }),
    /* @__PURE__ */ m(
      aV,
      {
        getText: () => t2.render(e.getValues("label") || ""),
        setText: (r) => {
          e.setValue("label", iV(r), { shouldDirty: !0 });
        },
        excludedToolbarItems: ["blockType", "bold", "italic"],
        disableLists: !0,
        firstRender: n,
        setFirstRender: o,
        placeholder: t(e.getValues("defaultLabel") || "")
      }
    )
  ] });
};
function MKl({
  dialog: e,
  onOpenChange: t,
  handleSubmit: n,
  shouldConsiderRequired: o,
  showPriceField: r,
  paymentCurrency: i
}) {
  const { t: a } = kt(), s = Kr(), c = W_({
    defaultValues: e.data || {}
    //resolver: zodResolver(fieldSchema),
  }), l = c.getValues("type");
  yt(() => {
    if (!l)
      return;
    const g = vj({
      type: l,
      variantsConfig: c.getValues("variantsConfig")
    });
    c.setValue("variantsConfig", g);
  }, [c]);
  const u = !!e.data, d = Tbe(c), _ = c.watch("variantsConfig"), p = Object.values(sc);
  return c.getValues("name"), /* @__PURE__ */ m(Ss, { open: e.isOpen, onOpenChange: t, modal: !1, children: /* @__PURE__ */ m(Ya, { className: "max-h-none", "data-testid": "edit-field-dialog", forceOverlayWhenNoModal: !0, children: /* @__PURE__ */ de(Y_, { id: "form-builder", form: c, handleSubmit: n, children: [
    /* @__PURE__ */ de("div", { className: "h-auto max-h-[85vh] overflow-auto", children: [
      /* @__PURE__ */ m(Sy, { title: a("add_a_booking_question"), subtitle: a("booking_questions_description") }),
      /* @__PURE__ */ m(
        iq,
        {
          defaultValue: sc.text,
          "data-testid": "test-field-type",
          id: "test-field-type",
          isDisabled: c.getValues("editable") === "system" || c.getValues("editable") === "system-but-optional",
          onChange: (g) => {
            const f = g == null ? void 0 : g.value;
            f && c.setValue("type", f, { shouldDirty: !0 });
          },
          value: e.data ? Abe(e.data) : sc[l],
          options: p.filter((g) => !g.systemOnly),
          label: a("input_type")
        }
      ),
      (() => {
        if (!_)
          return /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(
              Da,
              {
                required: !0,
                ...c.register("name"),
                containerClassName: "mt-6",
                onChange: (g) => {
                  c.setValue("name", RKl(g.target.value || ""), {
                    shouldDirty: !0
                  });
                },
                disabled: c.getValues("editable") === "system" || c.getValues("editable") === "system-but-optional",
                label: a("identifier")
              }
            ),
            /* @__PURE__ */ m(
              cc,
              {
                description: a("disable_input_if_prefilled"),
                ...c.register("disableOnPrefill", { setValueAs: Boolean })
              }
            ),
            /* @__PURE__ */ m("div", { children: l === "boolean" && !s ? /* @__PURE__ */ m(LKl, { fieldForm: c }) : /* @__PURE__ */ m(
              Da,
              {
                ...c.register("label"),
                required: !["system", "system-but-optional"].includes(c.getValues("editable") || ""),
                placeholder: a(c.getValues("defaultLabel") || ""),
                containerClassName: "mt-6",
                label: a("label")
              }
            ) }),
            d != null && d.isTextType ? /* @__PURE__ */ m(
              Da,
              {
                ...c.register("placeholder"),
                containerClassName: "mt-6",
                label: a("placeholder"),
                placeholder: a(c.getValues("defaultPlaceholder") || "")
              }
            ) : null,
            d != null && d.needsOptions && !c.getValues("getOptionsAt") ? /* @__PURE__ */ m(
              Bn,
              {
                name: "options",
                render: ({ field: { value: g, onChange: f } }) => /* @__PURE__ */ m(
                  DKl,
                  {
                    onChange: f,
                    value: g,
                    className: "mt-6",
                    showPrice: r && d.optionsSupportPricing,
                    paymentCurrency: i
                  }
                )
              }
            ) : null,
            d != null && d.supportsLengthCheck ? /* @__PURE__ */ m(FKl, { containerClassName: "mt-6", fieldForm: c }) : null,
            l === "email" && /* @__PURE__ */ m(
              Da,
              {
                ...c.register("requireEmails"),
                containerClassName: "mt-6",
                onChange: (g) => {
                  var f;
                  try {
                    Yx.parse(g.target.value), c.clearErrors("requireEmails");
                  } catch (h) {
                    h instanceof Du && c.setError("requireEmails", {
                      message: ((f = h.errors[0]) == null ? void 0 : f.message) || "Invalid input"
                    });
                  }
                },
                label: a("require_emails_that_contain"),
                placeholder: "gmail.com, hotmail.com, ..."
              }
            ),
            l === "email" && /* @__PURE__ */ m(
              Da,
              {
                ...c.register("excludeEmails"),
                containerClassName: "mt-6",
                onChange: (g) => {
                  var f;
                  try {
                    Yx.parse(g.target.value), c.clearErrors("excludeEmails");
                  } catch (h) {
                    h instanceof Du && c.setError("excludeEmails", {
                      message: ((f = h.errors[0]) == null ? void 0 : f.message) || "Invalid input"
                    });
                  }
                },
                label: a("exclude_emails_that_contain"),
                placeholder: "gmail.com, hotmail.com, ..."
              }
            ),
            r && d.supportsPricing && /* @__PURE__ */ m(
              Da,
              {
                ...c.register("price"),
                containerClassName: "mt-6",
                label: a("price"),
                type: "number",
                min: 0,
                placeholder: "0",
                addOnLeading: ohe(i)
              }
            ),
            /* @__PURE__ */ m("div", { className: "mt-6", children: /* @__PURE__ */ m(
              Bn,
              {
                name: "required",
                control: c.control,
                render: ({ field: { value: g, onChange: f } }) => {
                  let h = o ? o(c.getValues()) : g;
                  return h === void 0 && (h = !0, f(h)), /* @__PURE__ */ m(
                    cc,
                    {
                      "data-testid": "field-required",
                      disabled: c.getValues("editable") === "system",
                      checked: h,
                      onChange: ($) => {
                        f($.target.checked);
                      },
                      description: a("make_field_required")
                    }
                  );
                }
              }
            ) })
          ] });
        if (!d.isTextType)
          throw new Error("Variants are currently supported only with text type");
        return /* @__PURE__ */ m(VKl, { variantsConfig: _, fieldForm: c });
      })()
    ] }),
    /* @__PURE__ */ de(Wu, { className: "relative", children: [
      /* @__PURE__ */ m(Gs, { color: "secondary", children: a("cancel") }),
      /* @__PURE__ */ m(Jt, { "data-testid": "field-add-save", type: "submit", children: a(u ? "save" : "add") })
    ] })
  ] }) }) });
}
function FKl({
  fieldForm: e,
  containerClassName: t = "",
  className: n,
  ...o
}) {
  const { t: r } = kt(), i = Tbe(e);
  if (!i.supportsLengthCheck)
    return null;
  const a = i.supportsLengthCheck, s = a.maxLength;
  return /* @__PURE__ */ de("div", { className: xe("grid grid-cols-2 gap-4", n), ...o, children: [
    /* @__PURE__ */ m(
      Da,
      {
        ...e.register("minLength", {
          valueAsNumber: !0
        }),
        defaultValue: 0,
        containerClassName: t,
        label: r("min_characters"),
        type: "number",
        onChange: (c) => {
          e.setValue("minLength", parseInt(c.target.value ?? 0)), e.trigger("maxLength");
        },
        min: 0,
        max: e.getValues("maxLength") || s
      }
    ),
    /* @__PURE__ */ m(
      Da,
      {
        ...e.register("maxLength", {
          valueAsNumber: !0
        }),
        defaultValue: s,
        containerClassName: t,
        label: r("max_characters"),
        type: "number",
        onChange: (c) => {
          a && (e.setValue("maxLength", parseInt(c.target.value ?? s)), e.trigger("minLength"));
        },
        min: e.getValues("minLength") || 0,
        max: s
      }
    )
  ] });
}
function qKl({ field: e }) {
  var u, d, _;
  const { t } = kt(), n = sc[e.type], o = n == null ? void 0 : n.variantsConfig, r = o == null ? void 0 : o.variants, i = e.variantsConfig, a = i == null ? void 0 : i.variants, s = o == null ? void 0 : o.defaultVariant;
  if (!r || !i)
    return GA.includes(e.type) ? /* @__PURE__ */ m(
      "span",
      {
        dangerouslySetInnerHTML: {
          // Derive from field.label because label might change in b/w and field.labelAsSafeHtml will not be updated.
          __html: Gj(e.label || t(e.defaultLabel || "") || "")
        }
      }
    ) : /* @__PURE__ */ m("span", { children: e.label || t(e.defaultLabel || "") });
  const c = e.variant || s;
  if (!c)
    throw new Error(
      `Field has \`variantsConfig\` but no \`defaultVariant\`${JSON.stringify(o)}`
    );
  const l = ((_ = (d = (u = a == null ? void 0 : a[c]) == null ? void 0 : u.fields) == null ? void 0 : d[0]) == null ? void 0 : _.label) || "";
  return /* @__PURE__ */ m("span", { children: t(l) });
}
function jKl() {
  return null;
}
function VKl({
  fieldForm: e,
  variantsConfig: t
}) {
  var g;
  const { t: n } = kt();
  if (!t)
    throw new Error("VariantFields component needs variantsConfig");
  const o = (g = sc[e.getValues("type")]) == null ? void 0 : g.variantsConfig;
  if (!o)
    throw new Error("Configuration Issue: FieldType doesn't have `variantsConfig`");
  const r = n(o.toggleLabel || ""), i = o.defaultVariant, a = Object.keys(t.variants), s = a.filter((f) => f !== i);
  if (s.length > 1 && r)
    throw new Error("More than one other variant. Remove toggleLabel ");
  const c = s[0], l = e.watch("variant") || i, u = t.variants[l].fields, d = u.length === 1, _ = l === i, p = a.length === 2;
  return /* @__PURE__ */ de(nt, { children: [
    p ? /* @__PURE__ */ m(
      as,
      {
        classNames: { container: "mt-1" },
        checked: !_,
        label: r,
        "data-testid": "variant-toggle",
        onCheckedChange: (f) => {
          e.setValue("variant", f ? c : i);
        },
        tooltip: n("Toggle Variant")
      }
    ) : /* @__PURE__ */ m(jKl, {}),
    /* @__PURE__ */ m(
      Da,
      {
        required: !0,
        ...e.register("name"),
        containerClassName: "mt-6",
        disabled: e.getValues("editable") === "system" || e.getValues("editable") === "system-but-optional",
        label: n("identifier")
      }
    ),
    /* @__PURE__ */ m("div", { className: "mt-2", children: /* @__PURE__ */ m(
      cc,
      {
        description: n("disable_input_if_prefilled"),
        ...e.register("disableOnPrefill", { setValueAs: Boolean })
      }
    ) }),
    /* @__PURE__ */ m(
      "ul",
      {
        className: xe(
          d ? "" : "border-subtle divide-subtle mt-2 divide-y rounded-md border"
        ),
        children: u.map((f, h) => {
          const $ = `variantsConfig.variants.${l}.fields.${h}`, b = o.variants[l].fieldsMap[f.name];
          return /* @__PURE__ */ de("li", { className: xe(d ? "" : "p-4"), children: [
            !d && /* @__PURE__ */ de(Ko, { className: "flex justify-between", children: [
              /* @__PURE__ */ m("span", { children: `Field ${h + 1}` }),
              /* @__PURE__ */ m("span", { className: "text-muted", children: f.name })
            ] }),
            /* @__PURE__ */ m(
              Da,
              {
                ...e.register(`${$}.label`),
                value: f.label || "",
                placeholder: n((b == null ? void 0 : b.defaultLabel) || ""),
                containerClassName: "mt-6",
                label: n("label")
              }
            ),
            /* @__PURE__ */ pt(
              Da,
              {
                ...e.register(`${$}.placeholder`),
                key: f.name,
                value: f.placeholder || "",
                containerClassName: "mt-6",
                label: n("placeholder"),
                placeholder: n((b == null ? void 0 : b.defaultPlaceholder) || "")
              }
            ),
            /* @__PURE__ */ m("div", { className: "mt-6", children: /* @__PURE__ */ m(
              Bn,
              {
                name: `${$}.required`,
                control: e.control,
                render: ({ field: { onChange: y } }) => /* @__PURE__ */ m(
                  cc,
                  {
                    "data-testid": "field-required",
                    disabled: !(b != null && b.canChangeRequirability),
                    checked: f.required,
                    onChange: (w) => {
                      y(w.target.checked);
                    },
                    description: n("make_field_required")
                  }
                )
              }
            ) })
          ] }, f.name);
        })
      }
    )
  ] });
}
const BKl = ({
  align: e = "start",
  children: t,
  className: n
}) => /* @__PURE__ */ m(
  "div",
  {
    className: xe(
      "border-subtle bg-muted flex rounded-b-lg border px-6 py-4",
      e === "end" && "justify-end",
      n
    ),
    children: t
  }
), UKl = BKl, sQ = "metadata.bookerLayouts", GKl = ({
  title: e,
  description: t,
  name: n,
  fallbackToUserSettings: o,
  isDark: r,
  isDisabled: i = !1,
  isOuterBorder: a = !1,
  isLoading: s = !1,
  user: c,
  isUserLoading: l
}) => {
  const { control: u, getValues: d } = No(), { t: _ } = kt(), p = o && !d(n || sQ) || !1;
  return /* @__PURE__ */ de("div", { className: xe(a && "border-subtle rounded-lg border p-6"), children: [
    /* @__PURE__ */ de("div", { className: xe(a ? "pb-5" : "border-subtle rounded-t-xl border p-6"), children: [
      /* @__PURE__ */ m(Ko, { className: xe("mb-1 font-semibold", a ? "text-sm" : "text-base"), children: e || _("layout") }),
      /* @__PURE__ */ m("p", { className: "text-subtle max-w-full break-words text-sm leading-tight", children: t || _("bookerlayout_description") })
    ] }),
    /* @__PURE__ */ m(
      Bn,
      {
        control: p ? void 0 : u,
        name: n || sQ,
        render: ({ field: { value: g, onChange: f } }) => /* @__PURE__ */ de(nt, { children: [
          /* @__PURE__ */ m(
            WKl,
            {
              showUserSettings: p,
              settings: g,
              onChange: f,
              isDark: r,
              isOuterBorder: a,
              user: c,
              isUserLoading: l
            }
          ),
          !a && /* @__PURE__ */ m(UKl, { align: "end", children: /* @__PURE__ */ m(Jt, { loading: s, type: "submit", disabled: i, color: "primary", children: _("update") }) })
        ] })
      }
    )
  ] });
}, WKl = ({
  settings: e,
  onChange: t,
  showUserSettings: n,
  isDark: o,
  isOuterBorder: r,
  user: i,
  isUserLoading: a
}) => {
  const { t: s } = kt(), [c, l] = it(!1), u = n && !c, d = u ? i == null ? void 0 : i.defaultBookerLayouts : e, _ = (d == null ? void 0 : d.defaultLayout) || io.MONTH_VIEW, p = Wp.reduce(($, v) => ($[v] = d != null && d.enabledLayouts ? d.enabledLayouts.indexOf(v) > -1 : Qse.enabledLayouts.indexOf(v) > -1, $), {}), g = Yt(
    ($, v) => {
      const b = Object.keys(p).filter((N) => $ === N ? v === !0 : p[N] === !0), y = b.indexOf(_) === -1, w = b[0];
      t({
        enabledLayouts: b,
        // If default layout is toggled off, we set the default layout to the first enabled layout
        // if there's none enabled, we set it to month view.
        defaultLayout: y ? w || io.MONTH_VIEW : _
      });
    },
    [_, t, p]
  ), f = Yt(
    ($) => {
      t({
        enabledLayouts: Object.keys(p).filter(
          (v) => p[v] === !0
        ),
        defaultLayout: $
      });
    },
    [p, t]
  ), h = () => {
    l(!0), i != null && i.defaultBookerLayouts && t(i.defaultBookerLayouts);
  };
  return /* @__PURE__ */ de("div", { className: xe("space-y-5", !r && "border-subtle border-x px-6 py-8"), children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: xe(
          "flex flex-col gap-5 transition-opacity sm:flex-row sm:gap-3",
          u && "pointer-events-none opacity-40",
          u && a && "animate-pulse"
        ),
        children: Wp.map(($) => /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ de("label", { children: [
          /* @__PURE__ */ m(
            "img",
            {
              className: "mb-3 w-full max-w-none cursor-pointer",
              src: `/bookerlayout_${$}${o ? "_dark" : ""}.svg`,
              alt: "Layout preview"
            }
          ),
          /* @__PURE__ */ m(
            cc,
            {
              value: $,
              name: `bookerlayout_${$}`,
              description: s(`bookerlayout_${$}`),
              checked: p[$],
              onChange: (v) => g($, v.target.checked)
            }
          )
        ] }) }, $))
      }
    ),
    /* @__PURE__ */ de(
      "div",
      {
        hidden: Object.values(p).filter(($) => $ === !0).length <= 1,
        className: xe(
          "transition-opacity",
          u && "pointer-events-none opacity-40",
          u && a && "animate-pulse"
        ),
        children: [
          /* @__PURE__ */ m(Ko, { children: s("bookerlayout_default_title") }),
          /* @__PURE__ */ m(
            r1,
            {
              className: "border-subtle flex w-full gap-2 rounded-md border p-1",
              defaultValue: _,
              onValueChange: ($) => f($),
              children: Wp.map(($) => /* @__PURE__ */ de(
                i1,
                {
                  className: "aria-checked:bg-emphasis hover:[&:not(:disabled)]:bg-subtle focus:[&:not(:disabled)]:bg-subtle w-full rounded-[4px] p-1 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-40",
                  disabled: p[$] === !1,
                  value: $,
                  children: [
                    s(`bookerlayout_${$}`),
                    /* @__PURE__ */ m(a1, {})
                  ]
                },
                $
              ))
            },
            _
          )
        ]
      }
    ),
    u && /* @__PURE__ */ m("p", { className: "text-sm", children: /* @__PURE__ */ m(
      Ld,
      {
        t: s,
        i18nKey: "bookerlayout_override_global_settings",
        components: [
          /* @__PURE__ */ m(
            Ir,
            {
              target: "_blank",
              href: "/settings/my-account/appearance",
              className: "underline",
              children: "Appearance"
            },
            "appearance-link"
          ),
          /* @__PURE__ */ m(
            Jt,
            {
              onClick: h,
              color: "minimal",
              className: "h-fit p-0 font-normal underline hover:bg-transparent focus-visible:bg-transparent",
              children: "Override"
            },
            "override-button"
          )
        ]
      }
    ) })
  ] });
}, HKl = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
function YKl(e, t) {
  const [n, o] = e.split("@");
  return `${n}+${t}@${o}`;
}
const KKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const { clientId: n } = cr();
  return Hr({
    mutationFn: (r) => {
      const { email: i } = r, a = YKl(i, n);
      return At.post("/atoms/emails/verified-emails", {
        email: a
      }).then((s) => s.data);
    },
    onSuccess: (r) => {
      r.status === Nn ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    }
  });
}, ZKl = "use-get-verified-emails", Ibe = (e) => {
  const t = `/atoms/emails/verified-emails${e ? `?teamId=${e}` : ""}`, { isInit: n, accessToken: o } = cr();
  return mr({
    queryKey: [ZKl, e],
    queryFn: () => At == null ? void 0 : At.get(t).then((r) => {
      if (r.data.status === Nn)
        return r.data.data;
      throw new Error(r.data.error.message);
    }),
    enabled: n && !!o,
    staleTime: 5e3
  });
}, XKl = ({ username: e, showToast: t }) => {
  const { t: n } = kt(), [o, r] = it(""), [i, a] = it(!1), { refetch: s } = Ibe(), { mutateAsync: c } = KKl({
    onSuccess: () => {
      s(), t(n("email_verified"), "success");
    },
    onError: () => {
      t(n("something_went_wrong"), "error");
    }
  }), l = gve({
    email: o,
    name: e || n("there"),
    requiresBookerEmailVerification: !0
  }), { handleVerifyEmail: u } = l, d = fve({
    onSuccess: async () => {
      a(!1), r(""), await c({
        email: o
      });
    }
  });
  return /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ de("div", { className: "border-subtle border border-t-0 p-6", children: [
      /* @__PURE__ */ m(
        Ko,
        {
          className: xe("text-emphasis mb-2 block text-sm font-medium leading-none"),
          htmlFor: "add-verified-emails",
          children: n("add_verified_emails")
        }
      ),
      /* @__PURE__ */ m(
        xr,
        {
          id: "add-verified-emails",
          containerClassName: xe("w-full"),
          value: o,
          onChange: (_) => r(_.target.value),
          "data-testid": "add-verified-emails",
          addOnSuffix: /* @__PURE__ */ m(Sr, { content: n("add_verified_email"), children: /* @__PURE__ */ m(
            Jt,
            {
              type: "button",
              color: "minimal",
              size: "sm",
              StartIcon: "arrow-right",
              onClick: () => {
                o && HKl(o) && (a(!0), u());
              }
            }
          ) })
        }
      )
    ] }),
    /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
      Pge,
      {
        isOpenDialog: i,
        setIsOpenDialog: a,
        email: o,
        isUserSessionRequiredToVerify: !1,
        verifyCodeWithSessionNotRequired: d.verifyCodeWithSessionNotRequired,
        verifyCodeWithSessionRequired: d.verifyCodeWithSessionRequired,
        error: d.error,
        resetErrors: d.resetErrors,
        isPending: d.isPending,
        setIsPending: d.setIsPending
      }
    ) })
  ] });
}, JKl = XKl, QKl = (e) => {
  var f, h, $, v, b, y, w, N, M, q, L, R, T, D, A, S, E, x, k, I, z, F, P, O, V, U, H, J, le, ae, Y, re, ie, _e, he, be, Q, me, ne, pe, ge, ve, Te, Re, Me, et, st, De, ze, Pe, je, He, Xe, at, wt, Je, vt, Ot, Ft, wn, un, pn, Dn;
  const { t } = kt(), { placeHolder: n, close: o, setValue: r, event: i, isNameFieldSplit: a, customClassNames: s } = e, { register: c, handleSubmit: l, watch: u, getValues: d } = No(), _ = (Rn) => {
    r(Rn.customEventName), o();
  }, p = Gve({ ...i, eventName: u("customEventName") }), g = u("customEventName") === "" ? p : n;
  return /* @__PURE__ */ de(
    "form",
    {
      id: "custom-event-name",
      onSubmit: (Rn) => {
        Rn.preventDefault(), Rn.stopPropagation(), d("customEventName") === "" && r(""), l(_)(Rn);
      },
      children: [
        /* @__PURE__ */ m(
          xr,
          {
            label: t("event_name_in_calendar"),
            type: "text",
            placeholder: g,
            ...c("customEventName", {
              validate: (Rn) => {
                const Ln = Wve(Rn, i.bookingFields);
                return typeof Ln == "string" ? t("invalid_event_name_variables", { item: Ln }) : Ln;
              }
            }),
            containerClassName: (f = s == null ? void 0 : s.eventNameInput) == null ? void 0 : f.container,
            labelClassName: (h = s == null ? void 0 : s.eventNameInput) == null ? void 0 : h.label,
            className: xe("mb-0", ($ = s == null ? void 0 : s.eventNameInput) == null ? void 0 : $.input)
          }
        ),
        /* @__PURE__ */ de("div", { className: "pt-6 text-sm", children: [
          /* @__PURE__ */ de(
            "div",
            {
              className: xe(
                "bg-subtle mb-6 rounded-md p-2",
                (v = s == null ? void 0 : s.availableVariables) == null ? void 0 : v.container
              ),
              children: [
                /* @__PURE__ */ m(
                  "h1",
                  {
                    className: xe(
                      "text-emphasis mb-2 ml-1 font-medium",
                      (b = s == null ? void 0 : s.availableVariables) == null ? void 0 : b.header
                    ),
                    children: t("available_variables")
                  }
                ),
                /* @__PURE__ */ de(
                  "div",
                  {
                    className: xe(
                      "scroll-bar h-[216px] overflow-y-auto",
                      (y = s == null ? void 0 : s.availableVariables) == null ? void 0 : y.scrollArea
                    ),
                    children: [
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (N = (w = s == null ? void 0 : s.availableVariables) == null ? void 0 : w.variableItem) == null ? void 0 : N.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (q = (M = s == null ? void 0 : s.availableVariables) == null ? void 0 : M.variableItem) == null ? void 0 : q.variableName
                                ),
                                children: "{Event type title}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (R = (L = s == null ? void 0 : s.availableVariables) == null ? void 0 : L.variableItem) == null ? void 0 : R.variableDescription
                                ),
                                children: t("event_name_info")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (D = (T = s == null ? void 0 : s.availableVariables) == null ? void 0 : T.variableItem) == null ? void 0 : D.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (S = (A = s == null ? void 0 : s.availableVariables) == null ? void 0 : A.variableItem) == null ? void 0 : S.variableName
                                ),
                                children: "{Event duration}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (x = (E = s == null ? void 0 : s.availableVariables) == null ? void 0 : E.variableItem) == null ? void 0 : x.variableDescription
                                ),
                                children: t("event_duration_info")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (I = (k = s == null ? void 0 : s.availableVariables) == null ? void 0 : k.variableItem) == null ? void 0 : I.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (F = (z = s == null ? void 0 : s.availableVariables) == null ? void 0 : z.variableItem) == null ? void 0 : F.variableName
                                ),
                                children: "{Organiser}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (O = (P = s == null ? void 0 : s.availableVariables) == null ? void 0 : P.variableItem) == null ? void 0 : O.variableDescription
                                ),
                                children: t("your_full_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (U = (V = s == null ? void 0 : s.availableVariables) == null ? void 0 : V.variableItem) == null ? void 0 : U.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (J = (H = s == null ? void 0 : s.availableVariables) == null ? void 0 : H.variableItem) == null ? void 0 : J.variableName
                                ),
                                children: "{Organiser first name}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (ae = (le = s == null ? void 0 : s.availableVariables) == null ? void 0 : le.variableItem) == null ? void 0 : ae.variableDescription
                                ),
                                children: t("organizer_first_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (re = (Y = s == null ? void 0 : s.availableVariables) == null ? void 0 : Y.variableItem) == null ? void 0 : re.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (_e = (ie = s == null ? void 0 : s.availableVariables) == null ? void 0 : ie.variableItem) == null ? void 0 : _e.variableName
                                ),
                                children: "{Scheduler}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (be = (he = s == null ? void 0 : s.availableVariables) == null ? void 0 : he.variableItem) == null ? void 0 : be.variableDescription
                                ),
                                children: t("scheduler_full_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (me = (Q = s == null ? void 0 : s.availableVariables) == null ? void 0 : Q.variableItem) == null ? void 0 : me.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (pe = (ne = s == null ? void 0 : s.availableVariables) == null ? void 0 : ne.variableItem) == null ? void 0 : pe.variableName
                                ),
                                children: "{Scheduler first name}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (ve = (ge = s == null ? void 0 : s.availableVariables) == null ? void 0 : ge.variableItem) == null ? void 0 : ve.variableDescription
                                ),
                                children: t("scheduler_first_name")
                              }
                            )
                          ]
                        }
                      ),
                      a && /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (Re = (Te = s == null ? void 0 : s.availableVariables) == null ? void 0 : Te.variableItem) == null ? void 0 : Re.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (et = (Me = s == null ? void 0 : s.availableVariables) == null ? void 0 : Me.variableItem) == null ? void 0 : et.variableName
                                ),
                                children: "{Scheduler last name}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (De = (st = s == null ? void 0 : s.availableVariables) == null ? void 0 : st.variableItem) == null ? void 0 : De.variableDescription
                                ),
                                children: t("scheduler_last_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ de(
                        "div",
                        {
                          className: xe(
                            "mb-2.5 flex items-start font-normal",
                            (Pe = (ze = s == null ? void 0 : s.availableVariables) == null ? void 0 : ze.variableItem) == null ? void 0 : Pe.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (He = (je = s == null ? void 0 : s.availableVariables) == null ? void 0 : je.variableItem) == null ? void 0 : He.variableName
                                ),
                                children: "{Location}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: xe(
                                  "text-emphasis min-w-0 flex-1",
                                  (at = (Xe = s == null ? void 0 : s.availableVariables) == null ? void 0 : Xe.variableItem) == null ? void 0 : at.variableDescription
                                ),
                                children: t("location_info")
                              }
                            )
                          ]
                        }
                      ),
                      i.bookingFields && /* @__PURE__ */ m(
                        "p",
                        {
                          className: xe(
                            "text-subtle mb-2 ml-1 font-medium",
                            (wt = s == null ? void 0 : s.availableVariables) == null ? void 0 : wt.bookingFieldsHeader
                          ),
                          children: t("booking_question_response_variables")
                        }
                      ),
                      i.bookingFields && Object.keys(i.bookingFields).map((Rn, Ln) => {
                        var Yn, Qt, fn, qn, Xn, Qn, In, $n;
                        return /* @__PURE__ */ de(
                          "div",
                          {
                            className: xe(
                              "mb-2.5 flex items-start font-normal",
                              (Qt = (Yn = s == null ? void 0 : s.availableVariables) == null ? void 0 : Yn.bookingFieldItem) == null ? void 0 : Qt.container
                            ),
                            children: [
                              /* @__PURE__ */ m(
                                "p",
                                {
                                  className: xe(
                                    "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                    (qn = (fn = s == null ? void 0 : s.availableVariables) == null ? void 0 : fn.bookingFieldItem) == null ? void 0 : qn.fieldName
                                  ),
                                  children: `{${Rn}}`
                                }
                              ),
                              /* @__PURE__ */ m(
                                "p",
                                {
                                  className: xe(
                                    "text-emphasis min-w-0 flex-1 capitalize",
                                    (Qn = (Xn = s == null ? void 0 : s.availableVariables) == null ? void 0 : Xn.bookingFieldItem) == null ? void 0 : Qn.fieldValue
                                  ),
                                  children: ($n = (In = i.bookingFields) == null ? void 0 : In[Rn]) == null ? void 0 : $n.toString()
                                }
                              )
                            ]
                          },
                          Ln
                        );
                      })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ m(
            "h1",
            {
              className: xe(
                "mb-2 text-[14px] font-medium leading-4",
                (Je = s == null ? void 0 : s.previewSection) == null ? void 0 : Je.header
              ),
              children: t("preview")
            }
          ),
          /* @__PURE__ */ m(
            "div",
            {
              className: xe(
                "flex h-[212px] w-full rounded-md border-y bg-cover bg-center dark:invert",
                (vt = s == null ? void 0 : s.previewSection) == null ? void 0 : vt.previewContainer
              ),
              style: {
                backgroundImage: "url(/calendar-preview.svg)"
              },
              children: /* @__PURE__ */ m("div", { className: "m-auto flex items-center justify-center self-stretch", children: /* @__PURE__ */ de(
                "div",
                {
                  className: xe(
                    "bg-subtle ml-11 mt-3 box-border h-[110px] w-[120px] flex-col items-start gap-1 rounded-md border border-solid border-black text-[12px] leading-3",
                    (Ft = (Ot = s == null ? void 0 : s.previewSection) == null ? void 0 : Ot.previewEventBox) == null ? void 0 : Ft.container
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      "p",
                      {
                        className: xe(
                          "text-emphasis overflow-hidden text-ellipsis p-1.5 font-medium",
                          (un = (wn = s == null ? void 0 : s.previewSection) == null ? void 0 : wn.previewEventBox) == null ? void 0 : un.eventName
                        ),
                        children: p
                      }
                    ),
                    /* @__PURE__ */ m(
                      "p",
                      {
                        className: xe(
                          "text-default ml-1.5 text-[10px] font-normal",
                          (Dn = (pn = s == null ? void 0 : s.previewSection) == null ? void 0 : pn.previewEventBox) == null ? void 0 : Dn.eventTime
                        ),
                        children: "8 - 10 AM"
                      }
                    )
                  ]
                }
              ) })
            }
          )
        ] })
      ]
    }
  );
}, eZl = (e) => {
  const { t } = kt(), { defaultValue: n, placeHolder: o, close: r, setValue: i, event: a, isNameFieldSplit: s, customClassNames: c } = e, l = W_({
    defaultValues: {
      customEventName: n
    }
  });
  return /* @__PURE__ */ m(Ss, { open: !0, onOpenChange: r, children: /* @__PURE__ */ de(
    Ya,
    {
      title: t("custom_event_name"),
      description: t("custom_event_name_description"),
      type: "creation",
      enableOverflow: !0,
      children: [
        /* @__PURE__ */ m(hse, { ...l, children: /* @__PURE__ */ m(
          QKl,
          {
            event: a,
            close: r,
            setValue: i,
            placeHolder: o,
            defaultValue: n,
            isNameFieldSplit: s,
            customClassNames: c
          }
        ) }),
        /* @__PURE__ */ de(Wu, { children: [
          /* @__PURE__ */ m(Gs, { children: t("cancel") }),
          /* @__PURE__ */ m(Jt, { form: "custom-event-name", type: "submit", color: "primary", children: t("create") })
        ] })
      ]
    }
  ) });
}, tZl = eZl, cQ = ({
  checked: e,
  onCheckedChange: t,
  recipient: n,
  t: o,
  customClassNames: r
}) => {
  var d, _, p, g, f, h, $, v, b, y;
  const [i, a] = it(!1), [s, c] = it(""), l = o("confirm", { defaultValue: "confirm" }), u = o(n === "attendees" ? "disable_all_emails_to_attendees" : "disable_all_emails_to_hosts");
  return /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ m(Ss, { open: i, onOpenChange: (w) => a(w), children: /* @__PURE__ */ de(
      Ya,
      {
        title: u,
        Icon: "circle-alert",
        className: (d = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : d.container,
        children: [
          /* @__PURE__ */ m(
            "p",
            {
              className: xe("text-default text-sm", (_ = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : _.description),
              children: /* @__PURE__ */ m(Ld, { t: o, i18nKey: "disable_attendees_emails_description", values: { recipient: n } })
            }
          ),
          /* @__PURE__ */ m(
            "p",
            {
              className: xe(
                "text-default mb-1 mt-2 text-sm",
                (g = (p = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : p.confirmInput) == null ? void 0 : g.label
              ),
              children: o("type_confirm_to_continue")
            }
          ),
          /* @__PURE__ */ m(
            Da,
            {
              value: s,
              onChange: (w) => {
                c(w.target.value);
              }
            }
          ),
          /* @__PURE__ */ de(Wu, { className: (h = (f = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : f.dialogFooter) == null ? void 0 : h.container, children: [
            /* @__PURE__ */ m(Gs, { className: (v = ($ = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : $.dialogFooter) == null ? void 0 : v.cancelButton }),
            /* @__PURE__ */ m(
              Jt,
              {
                disabled: s.toLowerCase() !== l.toLowerCase(),
                onClick: () => {
                  t(!0), a(!1);
                },
                className: (y = (b = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : b.dialogFooter) == null ? void 0 : y.confirmButton,
                children: o("disable_email")
              }
            )
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ m(
      Jo,
      {
        labelClassName: xe("text-sm", r == null ? void 0 : r.label),
        toggleSwitchAtTheEnd: !0,
        switchContainerClassName: xe(
          "border-subtle rounded-lg border py-6 px-4 sm:px-6",
          r == null ? void 0 : r.container
        ),
        descriptionClassName: r == null ? void 0 : r.description,
        title: u,
        description: o("disable_all_emails_description"),
        checked: !!e,
        onCheckedChange: () => e ? t(!e) : a(!0)
      }
    )
  ] });
};
function nZl({
  metadata: e,
  eventType: t,
  requiresConfirmation: n,
  onRequiresConfirmation: o,
  seatsEnabled: r,
  customClassNames: i
}) {
  const { t: a } = kt(), [s, c] = it(
    e == null ? void 0 : e.requiresConfirmationThreshold
  ), l = { time: 30, unit: "minutes" }, u = No();
  yt(() => {
    n || u.setValue("metadata.requiresConfirmationThreshold", void 0, { shouldDirty: !0 });
  }, [n]);
  const { shouldLockDisableProps: d } = Bg({ eventType: t, translate: a, formMethods: u }), _ = d("requiresConfirmation"), p = [
    { label: a("minute_timeUnit"), value: "minutes" },
    { label: a("hour_timeUnit"), value: "hours" }
  ], g = p.find(
    ($) => {
      var v;
      return $.value === (((v = e == null ? void 0 : e.requiresConfirmationThreshold) == null ? void 0 : v.unit) ?? l.unit);
    }
  ), f = u.getValues("requiresConfirmationWillBlockSlot"), h = u.getValues("requiresConfirmationForFreeEmail");
  return /* @__PURE__ */ m("div", { className: "block items-start sm:flex", children: /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m(
    Bn,
    {
      name: "requiresConfirmation",
      control: u.control,
      render: () => {
        var $, v, b, y, w, N, M, q;
        return /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: xe("text-sm", i == null ? void 0 : i.label),
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: xe(
              "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              n && "rounded-b-none",
              i == null ? void 0 : i.container
            ),
            childrenClassName: xe("lg:ml-0", i == null ? void 0 : i.children),
            descriptionClassName: i == null ? void 0 : i.description,
            title: a("requires_confirmation"),
            "data-testid": "requires-confirmation",
            disabled: r || _.disabled,
            tooltip: r ? a("seat_options_doesnt_support_confirmation") : void 0,
            description: a("requires_confirmation_description"),
            checked: n,
            LockedIcon: _.LockedIcon,
            onCheckedChange: (L) => {
              u.setValue("requiresConfirmation", L, { shouldDirty: !0 }), L || (u.setValue("requiresConfirmationWillBlockSlot", !1, { shouldDirty: !0 }), u.setValue("requiresConfirmationForFreeEmail", !1, { shouldDirty: !0 })), o(L);
            },
            children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
              r1,
              {
                defaultValue: n ? s === void 0 ? "always" : "notice" : void 0,
                onValueChange: (L) => {
                  L === "always" ? (u.setValue("requiresConfirmation", !0, { shouldDirty: !0 }), o(!0), u.setValue("metadata.requiresConfirmationThreshold", void 0, {
                    shouldDirty: !0
                  }), c(void 0)) : L === "notice" && (u.setValue("requiresConfirmation", !0, { shouldDirty: !0 }), o(!0), u.setValue(
                    "metadata.requiresConfirmationThreshold",
                    s || l,
                    { shouldDirty: !0 }
                  ));
                },
                children: /* @__PURE__ */ de(
                  "div",
                  {
                    className: xe(
                      "flex flex-col flex-wrap justify-start gap-y-2",
                      i == null ? void 0 : i.radioGroupContainer
                    ),
                    children: [
                      (s === void 0 || !_.disabled) && /* @__PURE__ */ m(
                        G5,
                        {
                          label: a("always"),
                          disabled: _.disabled,
                          id: "always",
                          value: "always",
                          className: i == null ? void 0 : i.alwaysConfirmationRadio
                        }
                      ),
                      (s !== void 0 || !_.disabled) && /* @__PURE__ */ de(nt, { children: [
                        /* @__PURE__ */ m(
                          G5,
                          {
                            disabled: _.disabled,
                            className: xe(
                              "items-center",
                              ($ = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : $.container
                            ),
                            label: /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
                              Ld,
                              {
                                t: a,
                                i18nKey: "when_booked_with_less_than_notice",
                                components: [
                                  /* @__PURE__ */ de(
                                    "div",
                                    {
                                      className: "mx-2 inline-flex items-center",
                                      children: [
                                        /* @__PURE__ */ m(
                                          Iu,
                                          {
                                            type: "number",
                                            min: 1,
                                            disabled: _.disabled,
                                            onChange: (L) => {
                                              var T;
                                              const R = Number((T = L.target) == null ? void 0 : T.value);
                                              c({
                                                unit: (s == null ? void 0 : s.unit) ?? l.unit,
                                                time: R
                                              }), u.setValue(
                                                "metadata.requiresConfirmationThreshold.time",
                                                R,
                                                { shouldDirty: !0 }
                                              );
                                            },
                                            className: xe(
                                              "border-default h-9! !m-0 block w-16 rounded-r-none border-r-0 text-sm [appearance:textfield] focus:z-10 focus:border-r",
                                              (v = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : v.timeInput
                                            ),
                                            defaultValue: ((b = e == null ? void 0 : e.requiresConfirmationThreshold) == null ? void 0 : b.time) || 30
                                          }
                                        ),
                                        /* @__PURE__ */ m(
                                          "label",
                                          {
                                            className: xe(
                                              _.disabled && "cursor-not-allowed"
                                            ),
                                            children: /* @__PURE__ */ m(
                                              Di,
                                              {
                                                inputId: "notice",
                                                options: p,
                                                isSearchable: !1,
                                                isDisabled: _.disabled,
                                                className: (y = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : y.timeUnitSelect,
                                                innerClassNames: {
                                                  control: "rounded-l-none max-h-4 px-3 bg-subtle py-1"
                                                },
                                                onChange: (L) => {
                                                  c({
                                                    time: (s == null ? void 0 : s.time) ?? l.time,
                                                    unit: L == null ? void 0 : L.value
                                                  }), u.setValue(
                                                    "metadata.requiresConfirmationThreshold.unit",
                                                    L == null ? void 0 : L.value,
                                                    { shouldDirty: !0 }
                                                  );
                                                },
                                                defaultValue: g
                                              }
                                            )
                                          }
                                        )
                                      ]
                                    },
                                    "when_booked_with_less_than_notice"
                                  )
                                ]
                              }
                            ) }),
                            id: "notice",
                            value: "notice"
                          }
                        ),
                        /* @__PURE__ */ de("div", { className: "-ml-1 space-y-2", children: [
                          /* @__PURE__ */ m(
                            cc,
                            {
                              checked: f,
                              descriptionAsLabel: !0,
                              description: a("requires_confirmation_will_block_slot_description"),
                              className: (w = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : w.checkbox,
                              descriptionClassName: (N = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : N.checkboxDescription,
                              onChange: (L) => {
                                u.setValue("requiresConfirmationWillBlockSlot", L.target.checked, {
                                  shouldDirty: !0
                                });
                              }
                            }
                          ),
                          /* @__PURE__ */ m(
                            cc,
                            {
                              checked: h,
                              descriptionAsLabel: !0,
                              description: a("require_confirmation_for_free_email"),
                              className: (M = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : M.checkbox,
                              descriptionClassName: (q = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : q.checkboxDescription,
                              onChange: (L) => {
                                u.setValue("requiresConfirmationForFreeEmail", L.target.checked, {
                                  shouldDirty: !0
                                });
                              }
                            }
                          )
                        ] })
                      ] })
                    ]
                  }
                )
              }
            ) })
          }
        );
      }
    }
  ) }) });
}
const lQ = {
  DestinationCalendarSettings({
    showConnectedCalendarSettings: e,
    customClassNames: t,
    calendarsQuery: n,
    eventNameLocked: o,
    eventNamePlaceholder: r,
    setShowEventNameTip: i,
    verifiedSecondaryEmails: a,
    userEmail: s,
    isTeamEventType: c,
    showToast: l
  }) {
    var f, h, $, v, b, y, w, N, M, q, L, R, T;
    const { t: u } = kt(), d = No(), [_, p] = it(
      d.getValues("useEventTypeDestinationCalendarEmail")
    ), g = d.getValues("secondaryEmailId") || -1;
    return /* @__PURE__ */ de("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: [
      /* @__PURE__ */ de("div", { className: "flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: [
        e && /* @__PURE__ */ de(
          "div",
          {
            className: xe(
              "flex w-full flex-col",
              (f = t == null ? void 0 : t.destinationCalendar) == null ? void 0 : f.container
            ),
            children: [
              /* @__PURE__ */ m(
                Ko,
                {
                  className: xe(
                    "text-emphasis mb-0 font-medium",
                    (h = t == null ? void 0 : t.destinationCalendar) == null ? void 0 : h.label
                  ),
                  children: u("add_to_calendar")
                }
              ),
              /* @__PURE__ */ m(
                Bn,
                {
                  name: "destinationCalendar",
                  render: ({ field: { onChange: D, value: A } }) => /* @__PURE__ */ m(
                    ZUl,
                    {
                      value: A ? A.externalId : void 0,
                      onChange: D,
                      hidePlaceholder: !0,
                      hideAdvancedText: !0,
                      calendarsQueryData: n.data,
                      customClassNames: t == null ? void 0 : t.destinationCalendar
                    }
                  )
                }
              ),
              /* @__PURE__ */ m("p", { className: "text-subtle text-sm", children: u("select_which_cal") })
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: xe("w-full", ($ = t == null ? void 0 : t.eventName) == null ? void 0 : $.container), children: /* @__PURE__ */ m(
          xr,
          {
            label: u("event_name_in_calendar"),
            labelClassName: (v = t == null ? void 0 : t.eventName) == null ? void 0 : v.label,
            addOnClassname: (b = t == null ? void 0 : t.eventName) == null ? void 0 : b.addOn,
            className: (y = t == null ? void 0 : t.eventName) == null ? void 0 : y.input,
            type: "text",
            ...o,
            placeholder: r,
            ...d.register("eventName"),
            addOnSuffix: /* @__PURE__ */ m(
              Jt,
              {
                color: "minimal",
                size: "sm",
                "aria-label": "edit custom name",
                className: "hover:stroke-3 hover:text-emphasis min-w-fit !py-0 px-0 hover:bg-transparent",
                onClick: () => i((D) => !D),
                children: /* @__PURE__ */ m(qt, { name: "pencil", className: "h-4 w-4" })
              }
            )
          }
        ) })
      ] }),
      /* @__PURE__ */ de("div", { className: "space-y-2", children: [
        e && /* @__PURE__ */ m("div", { className: xe("w-full", (w = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : w.container), children: /* @__PURE__ */ m(
          as,
          {
            tooltip: u("if_enabled_email_address_as_organizer"),
            label: /* @__PURE__ */ de(nt, { children: [
              u("display_add_to_calendar_organizer"),
              /* @__PURE__ */ m(
                qt,
                {
                  name: "info",
                  className: "text-default hover:text-attention hover:bg-attention ms-1 inline h-4 w-4 rounded-md"
                }
              )
            ] }),
            checked: _,
            onCheckedChange: (D) => {
              p(D), d.setValue("useEventTypeDestinationCalendarEmail", D, {
                shouldDirty: !0
              }), D && l(u("reconnect_calendar_to_use"), "warning");
            }
          }
        ) }),
        !e && /* @__PURE__ */ m("p", { className: "text-emphasis mb-2 block text-sm font-medium leading-none", children: u("add_to_calendar") }),
        !_ && a.length > 0 && !c && /* @__PURE__ */ de("div", { className: xe("flex w-full flex-col", e && "pl-11"), children: [
          /* @__PURE__ */ m(
            iq,
            {
              placeholder: g === -1 && /* @__PURE__ */ de("span", { className: "text-default min-w-0 overflow-hidden truncate whitespace-nowrap", children: [
                /* @__PURE__ */ m(Wi, { variant: "blue", children: u("default") }),
                " ",
                s
              ] }),
              className: (M = (N = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : N.emailSelect) == null ? void 0 : M.select,
              containerClassName: (L = (q = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : q.emailSelect) == null ? void 0 : L.container,
              onChange: (D) => d.setValue("secondaryEmailId", D == null ? void 0 : D.value, { shouldDirty: !0 }),
              value: a.find(
                (D) => g !== -1 && D.value === g
              ),
              options: a
            }
          ),
          /* @__PURE__ */ m(
            "p",
            {
              className: xe(
                "text-subtle mt-2 text-sm",
                (T = (R = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : R.emailSelect) == null ? void 0 : T.displayEmailLabel
              ),
              children: u("display_email_as_organizer")
            }
          )
        ] })
      ] })
    ] });
  },
  DestinationCalendarSettingsSkeleton() {
    return /* @__PURE__ */ de("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: [
      /* @__PURE__ */ de("div", { className: "flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: [
        /* @__PURE__ */ de("div", { className: "flex w-full flex-col", children: [
          /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
          /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-10 w-full animate-pulse rounded-md" }),
          /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-4 w-48 animate-pulse rounded-md" })
        ] }),
        /* @__PURE__ */ de("div", { className: "w-full", children: [
          /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
          /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-10 w-full animate-pulse rounded-md" })
        ] })
      ] }),
      /* @__PURE__ */ de("div", { className: "space-y-2", children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-6 w-64 animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-10 w-full animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-48 animate-pulse rounded-md" })
      ] })
    ] });
  }
}, Obe = {
  CalendarSettingsSkeleton() {
    return /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m(lQ.DestinationCalendarSettingsSkeleton, {}),
      /* @__PURE__ */ m(pX, {})
    ] });
  },
  CalendarSettings({
    eventType: e,
    calendarsQuery: t,
    verifiedSecondaryEmails: n,
    userEmail: o,
    isTeamEventType: r,
    isChildrenManagedEventType: i,
    customClassNames: a,
    eventNameLocked: s,
    eventNamePlaceholder: c,
    setShowEventNameTip: l,
    showToast: u
  }) {
    var v, b;
    const d = No(), _ = Kr(), p = !r || i, g = t.isPending, f = !!((v = t.data) != null && v.connectedCalendars.length) && p, h = d.getValues("useEventLevelSelectedCalendars") ? Rw.EventType : Rw.User, $ = (b = t.data) == null ? void 0 : b.destinationCalendar;
    return g && p ? /* @__PURE__ */ m(Obe.CalendarSettingsSkeleton, {}) : /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m(
        lQ.DestinationCalendarSettings,
        {
          verifiedSecondaryEmails: n,
          userEmail: o,
          isTeamEventType: r,
          calendarsQuery: t,
          eventNameLocked: s,
          eventNamePlaceholder: c,
          setShowEventNameTip: l,
          showToast: u,
          showConnectedCalendarSettings: f,
          customClassNames: a
        }
      ),
      /* @__PURE__ */ m("div", { children: p ? f && /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(hT, { fallback: /* @__PURE__ */ m(pX, {}), children: !_ && /* @__PURE__ */ m(
        V7l,
        {
          eventTypeId: e.id,
          disabledScope: Rw.User,
          disableConnectionModification: !0,
          scope: h,
          destinationCalendarId: $ == null ? void 0 : $.externalId,
          setScope: (y) => {
            const w = y === Rw.EventType;
            d.setValue("useEventLevelSelectedCalendars", w, {
              shouldDirty: !0
            });
          }
        }
      ) }) }) : null })
    ] });
  }
}, oZl = ({
  eventType: e,
  team: t,
  calendarsQuery: n,
  user: o,
  isUserLoading: r,
  showToast: i,
  showBookerLayoutSelector: a,
  customClassNames: s,
  verifiedEmails: c,
  orgId: l,
  localeOptions: u
}) => {
  var Qn, In, $n, uo, go, Rr, qo, ho;
  const d = Kr(), _ = cr(), p = No(), { t: g } = kt(), [f, h] = it(!1), [$, v] = it(!1), [b, y] = it(!1), [w, N] = it(
    !!p.getValues("multiplePrivateLinks") && ((Qn = p.getValues("multiplePrivateLinks")) == null ? void 0 : Qn.length) !== 0
  ), [M, q] = it(
    !!p.getValues("interfaceLanguage")
  ), [L, R] = it(!!p.getValues("successRedirectUrl")), T = {}, D = e.workflows.map((Ut) => Ut.workflow), A = (o == null ? void 0 : o.theme) === "dark" || !(o != null && o.theme) && typeof document < "u" && document.documentElement.classList.contains("dark");
  p.getValues().bookingFields.forEach(({ name: Ut }) => {
    T[Ut] = `${Ut} input`;
  });
  const S = p.getValues().bookingFields.find((Ut) => Ut.name === "name"), E = (S && S.variant === "firstAndLastName") ?? !1, x = {
    attendeeName: g("scheduler"),
    eventType: p.getValues("title"),
    eventName: p.getValues("eventName"),
    host: ((In = p.getValues("users")[0]) == null ? void 0 : In.name) || "Nameless",
    bookingFields: T,
    eventDuration: p.getValues("length"),
    t: g
  }, [k, I] = it(
    p.getValues("requiresConfirmation")
  ), z = p.watch("seatsPerTimeSlotEnabled"), F = (p.getValues("locations") || []).length > 1, P = ((go = (uo = ($n = p.getValues("metadata")) == null ? void 0 : $n.apps) == null ? void 0 : uo.stripe) == null ? void 0 : go.enabled) === !0 && ((ho = (qo = (Rr = p.getValues("metadata")) == null ? void 0 : Rr.apps) == null ? void 0 : qo.stripe) == null ? void 0 : ho.paymentOption) === "HOLD", O = !!p.getValues("recurringEvent"), V = u && u.length > 0 ? [{ label: g("visitors_browser_language"), value: "" }, ...u] : [], U = e.schedulingType && e.schedulingType === Bs.ROUND_ROBIN, H = (Ut) => {
    const Kt = p.getValues("bookingFields");
    p.setValue(
      "bookingFields",
      Kt.map((an) => an.name === "guests" ? {
        ...an,
        hidden: !Ut,
        editable: Ut ? "system-but-optional" : "system-but-hidden"
      } : an),
      { shouldDirty: !0 }
    );
  }, { isChildrenManagedEventType: J, isManagedEventType: le, shouldLockDisableProps: ae, shouldLockIndicator: Y } = Bg({
    eventType: e,
    translate: g,
    formMethods: p
  }), re = Gve({
    ...x,
    eventName: p.watch("eventName")
  }), ie = ae("successRedirectUrl"), _e = ae("seatsPerTimeSlotEnabled"), he = ae("requiresBookerEmailVerification"), be = ae("canSendCalVideoTranscriptionEmails"), Q = ae("hideCalendarNotes"), me = ae("hideCalendarEventDetails"), ne = ae("eventTypeColor"), pe = ae("lockTimeZoneToggleOnBookingPage"), ge = ae("multiplePrivateLinks"), ve = ae("allowReschedulingPastBookings"), Te = ae("hideOrganizerEmail"), Re = ae("customReplyToEmail"), Me = ae("disableCancelling"), et = ae("disableRescheduling"), st = ae(
    "allowReschedulingCancelledBookings"
  ), { isLocked: De, ...ze } = ae("eventName");
  le && (ge.disabled = !0);
  const [Pe, je] = it(e.disableCancelling || !1), [He, Xe] = it(e.disableRescheduling || !1), [at, wt] = it(
    e.allowReschedulingCancelledBookings ?? !1
  ), Je = ae("showOptimizedSlots"), vt = () => h(!1), [Ot, Ft] = it(!!e.eventTypeColor), wn = p.watch("customReplyToEmail"), [un, pn] = it(
    e.eventTypeColor || {
      lightEventTypeColor: _F,
      darkEventTypeColor: pF
    }
  ), Dn = TKl({
    userId: e.userId,
    teamId: e.teamId,
    hosts: e.hosts,
    owner: e.owner,
    team: e.team
  });
  let Rn = [
    {
      label: (o == null ? void 0 : o.email) || "",
      value: -1
    },
    ...((o == null ? void 0 : o.secondaryEmails) || []).filter((Ut) => !!Ut.emailVerified).map((Ut) => ({ label: Ut.email, value: Ut.id }))
  ];
  const Ln = (Ut, Kt) => Ut.replace(`+${Kt}`, "");
  let Yn = (o == null ? void 0 : o.email) || "";
  d && _.clientId && (Rn = Rn.map((Ut) => ({
    ...Ut,
    label: Ln(Ut.label, _.clientId)
  })), Yn = Ln(Yn, _.clientId));
  const Qt = p.watch("metadata"), fn = vn(() => Lg({
    price: 0,
    currency: "",
    metadata: Qt
  }), [Qt]), qn = vn(
    () => !Number.isNaN(fn.price) && fn.price > 0,
    [fn]
  ), Xn = vn(() => d ? Gq : xq, [d]);
  return /* @__PURE__ */ de("div", { className: "flex flex-col space-y-4", children: [
    /* @__PURE__ */ m(
      Obe.CalendarSettings,
      {
        verifiedSecondaryEmails: Rn,
        userEmail: Yn,
        calendarsQuery: n,
        isTeamEventType: !!t,
        isChildrenManagedEventType: J,
        customClassNames: s,
        eventNameLocked: ze,
        eventNamePlaceholder: re,
        setShowEventNameTip: h,
        showToast: i,
        eventType: e
      }
    ),
    a && /* @__PURE__ */ m(
      GKl,
      {
        fallbackToUserSettings: !0,
        isDark: A,
        isOuterBorder: !0,
        user: o,
        isUserLoading: r
      }
    ),
    /* @__PURE__ */ de("div", { className: "border-subtle bg-muted rounded-lg border p-1", children: [
      /* @__PURE__ */ de("div", { className: "p-5", children: [
        /* @__PURE__ */ m("div", { className: "text-default text-sm font-semibold leading-none ltr:mr-1 rtl:ml-1", children: g("booking_questions_title") }),
        /* @__PURE__ */ m("p", { className: "text-subtle mt-1 max-w-[280px] break-words text-sm sm:max-w-[500px]", children: g("booking_questions_description") })
      ] }),
      /* @__PURE__ */ m("div", { className: "border-subtle bg-default rounded-lg border p-5", children: /* @__PURE__ */ m(
        PKl,
        {
          showPhoneAndEmailToggle: !0,
          title: g("confirmation"),
          description: g("what_booker_should_provide"),
          addFieldLabel: g("add_a_booking_question"),
          formProp: "bookingFields",
          ...ae("bookingFields"),
          dataStore: {
            options: {
              locations: {
                // FormBuilder doesn't handle plural for non-english languages. So, use english(Location) only. This is similar to 'Workflow'
                source: { label: "Location" },
                value: Ehe(p.getValues("locations") ?? [], g)
              }
            }
          },
          shouldConsiderRequired: (Ut) => Ut.name === "location" ? !0 : Ut.required,
          showPriceField: qn,
          paymentCurrency: (fn == null ? void 0 : fn.currency) || "usd"
        }
      ) })
    ] }),
    /* @__PURE__ */ m(
      nZl,
      {
        eventType: e,
        seatsEnabled: z,
        metadata: p.getValues("metadata"),
        requiresConfirmation: k,
        requiresConfirmationWillBlockSlot: p.getValues("requiresConfirmationWillBlockSlot"),
        onRequiresConfirmation: I,
        customClassNames: s == null ? void 0 : s.requiresConfirmation
      }
    ),
    !d && /* @__PURE__ */ de(nt, { children: [
      /* @__PURE__ */ m(
        Bn,
        {
          name: "disableCancelling",
          render: ({ field: { onChange: Ut } }) => /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: "text-sm",
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              title: g("disable_cancelling"),
              "data-testid": "disable-cancelling-toggle",
              ...Me,
              description: g("description_disable_cancelling"),
              checked: Pe,
              onCheckedChange: (Kt) => {
                je(Kt), Ut(Kt);
              }
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Bn,
        {
          name: "disableRescheduling",
          render: ({ field: { onChange: Ut } }) => /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: "text-sm",
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              title: g("disable_rescheduling"),
              "data-testid": "disable-rescheduling-toggle",
              ...et,
              description: g("description_disable_rescheduling"),
              checked: He,
              onCheckedChange: (Kt) => {
                Xe(Kt), Ut(Kt);
              }
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "canSendCalVideoTranscriptionEmails",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe(
                "text-sm",
                (an = s == null ? void 0 : s.canSendCalVideoTranscriptionEmails) == null ? void 0 : an.label
              ),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.canSendCalVideoTranscriptionEmails) == null ? void 0 : Gn.container
              ),
              title: g("send_cal_video_transcription_emails"),
              "data-testid": "send-cal-video-transcription-emails",
              ...be,
              description: g("description_send_cal_video_transcription_emails"),
              descriptionClassName: (An = s == null ? void 0 : s.canSendCalVideoTranscriptionEmails) == null ? void 0 : An.description,
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          );
        }
      }
    ),
    !d && /* @__PURE__ */ m(
      Bn,
      {
        name: "autoTranslateDescriptionEnabled",
        render: ({ field: { value: Ut, onChange: Kt } }) => /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: "text-sm",
            title: g("translate_description_button"),
            checked: Ut,
            onCheckedChange: (an) => Kt(an),
            disabled: !l,
            tooltip: l ? void 0 : g("orgs_upgrade_to_enable_feature"),
            "data-testid": "ai_translation_toggle",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
            description: g("translate_description_button_description")
          }
        )
      }
    ),
    !d && /* @__PURE__ */ m(
      Bn,
      {
        name: "interfaceLanguage",
        control: p.control,
        defaultValue: e.interfaceLanguage ?? "",
        render: ({ field: { value: Ut, onChange: Kt } }) => /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: "text-sm",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: xe(
              "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              M && "rounded-b-none"
            ),
            childrenClassName: "lg:ml-0",
            "data-testid": "event-interface-language-toggle",
            title: g("interface_language"),
            description: g("interface_language_description"),
            checked: M,
            ...Y("interfaceLanguage"),
            onCheckedChange: (an) => {
              q(an), an ? p.setValue("interfaceLanguage", "", { shouldDirty: !0 }) : p.setValue("interfaceLanguage", null, { shouldDirty: !0 });
            },
            children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
              Di,
              {
                "data-testid": "event-interface-language",
                className: "capitalize",
                options: V,
                onChange: (an) => {
                  Kt(an == null ? void 0 : an.value);
                },
                value: V.find((an) => an.value === Ut)
              }
            ) })
          }
        )
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "requiresBookerEmailVerification",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.bookerEmailVerification) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.bookerEmailVerification) == null ? void 0 : Gn.container
              ),
              title: g("requires_booker_email_verification"),
              "data-testid": "requires-booker-email-verification",
              ...he,
              description: g("description_requires_booker_email_verification"),
              descriptionClassName: (An = s == null ? void 0 : s.bookerEmailVerification) == null ? void 0 : An.description,
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "hideCalendarNotes",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.calendarNotes) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.calendarNotes) == null ? void 0 : Gn.container
              ),
              descriptionClassName: (An = s == null ? void 0 : s.calendarNotes) == null ? void 0 : An.description,
              "data-testid": "disable-notes",
              title: g("disable_notes"),
              ...Q,
              description: g("disable_notes_description"),
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "hideCalendarEventDetails",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.eventDetailsVisibility) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.eventDetailsVisibility) == null ? void 0 : Gn.container
              ),
              descriptionClassName: (An = s == null ? void 0 : s.eventDetailsVisibility) == null ? void 0 : An.description,
              title: g("hide_calendar_event_details"),
              ...me,
              description: g("description_hide_calendar_event_details"),
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "successRedirectUrl",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An, hn, zn, gn, kn, dt, Pt, cn, sn, ao, Ze;
          return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                L && "rounded-b-none",
                (Gn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Gn.container
              ),
              childrenClassName: xe("lg:ml-0", (An = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : An.children),
              descriptionClassName: (hn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : hn.description,
              title: g("redirect_success_booking"),
              "data-testid": "redirect-success-booking",
              ...ie,
              description: g("redirect_url_description"),
              checked: L,
              onCheckedChange: (bt) => {
                R(bt), Kt(bt ? Ut : "");
              },
              children: /* @__PURE__ */ de(
                "div",
                {
                  className: xe(
                    "border-subtle rounded-b-lg border border-t-0 p-6",
                    (gn = (zn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : zn.redirectUrlInput) == null ? void 0 : gn.container
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      xr,
                      {
                        className: xe("w-full", (dt = (kn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : kn.redirectUrlInput) == null ? void 0 : dt.input),
                        label: g("redirect_success_booking"),
                        labelClassName: (cn = (Pt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Pt.redirectUrlInput) == null ? void 0 : cn.label,
                        labelSrOnly: !0,
                        disabled: ie.disabled,
                        placeholder: g("external_redirect_url"),
                        "data-testid": "external-redirect-url",
                        required: L,
                        type: "text",
                        ...p.register("successRedirectUrl")
                      }
                    ),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        className: xe(
                          "mt-4",
                          (ao = (sn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : sn.forwardParamsCheckbox) == null ? void 0 : ao.container
                        ),
                        children: /* @__PURE__ */ m(
                          Bn,
                          {
                            name: "forwardParamsSuccessRedirect",
                            render: ({ field: { value: bt, onChange: Wt } }) => {
                              var xn, It, Jn, ur;
                              return /* @__PURE__ */ m(
                                cc,
                                {
                                  description: g("forward_params_redirect"),
                                  disabled: ie.disabled,
                                  className: (It = (xn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : xn.forwardParamsCheckbox) == null ? void 0 : It.checkbox,
                                  descriptionClassName: (ur = (Jn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Jn.forwardParamsCheckbox) == null ? void 0 : ur.description,
                                  onChange: (er) => Wt(er),
                                  checked: bt
                                }
                              );
                            }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        className: xe(
                          "p-1 text-sm text-orange-600",
                          p.getValues("successRedirectUrl") ? "block" : "hidden",
                          (Ze = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Ze.error
                        ),
                        "data-testid": "redirect-url-warning",
                        children: g("redirect_url_warning")
                      }
                    )
                  ]
                }
              )
            }
          ) });
        }
      }
    ),
    !d && /* @__PURE__ */ m(
      Bn,
      {
        name: "multiplePrivateLinks",
        render: () => /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: "text-sm",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: xe(
              "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              w && "rounded-b-none"
            ),
            childrenClassName: "lg:ml-0",
            "data-testid": "multiplePrivateLinksCheck",
            title: g("multiple_private_links_title"),
            ...ge,
            description: g("multiple_private_links_description", { appName: Kp }),
            tooltip: le ? g("managed_event_field_parent_control_disabled") : "",
            checked: w,
            onCheckedChange: (Ut) => {
              var Kt;
              Ut ? p.setValue(
                "multiplePrivateLinks",
                [Cbe(((Kt = p.getValues("users")[0]) == null ? void 0 : Kt.id) ?? (t == null ? void 0 : t.id))],
                { shouldDirty: !0 }
              ) : p.setValue("multiplePrivateLinks", [], { shouldDirty: !0 }), N(Ut);
            },
            children: !le && /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
              zKl,
              {
                team: t,
                bookerUrl: e.bookerUrl,
                setMultiplePrivateLinksVisible: N,
                userTimeZone: Dn
              }
            ) })
          }
        )
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "seatsPerTimeSlotEnabled",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An, hn;
          return /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(
              Jo,
              {
                labelClassName: xe("text-sm", (an = s == null ? void 0 : s.seatsOptions) == null ? void 0 : an.label),
                toggleSwitchAtTheEnd: !0,
                switchContainerClassName: xe(
                  "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                  Ut && "rounded-b-none",
                  (Gn = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Gn.container
                ),
                childrenClassName: xe("lg:ml-0", (An = s == null ? void 0 : s.seatsOptions) == null ? void 0 : An.children),
                descriptionClassName: (hn = s == null ? void 0 : s.seatsOptions) == null ? void 0 : hn.description,
                "data-testid": "offer-seats-toggle",
                title: g("offer_seats"),
                ..._e,
                description: g("offer_seats_description"),
                checked: Ut,
                disabled: P || F || !z && O,
                tooltip: F ? g("multilocation_doesnt_support_seats") : P ? g("no_show_fee_doesnt_support_seats") : O ? g("recurring_event_doesnt_support_seats") : void 0,
                onCheckedChange: (zn) => {
                  zn ? (H(!1), p.setValue("requiresConfirmation", !1, { shouldDirty: !0 }), I(!1), p.setValue("metadata.multipleDuration", void 0, { shouldDirty: !0 }), p.setValue("seatsPerTimeSlot", e.seatsPerTimeSlot ?? 2, {
                    shouldDirty: !0
                  })) : (p.setValue("seatsPerTimeSlot", null), H(!0)), Kt(zn);
                },
                children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
                  Bn,
                  {
                    name: "seatsPerTimeSlot",
                    render: ({ field: { value: zn, onChange: gn } }) => {
                      var kn, dt, Pt, cn, sn, ao, Ze, bt, Wt, xn;
                      return /* @__PURE__ */ de("div", { children: [
                        /* @__PURE__ */ m(
                          xr,
                          {
                            required: !0,
                            name: "seatsPerTimeSlot",
                            labelSrOnly: !0,
                            label: g("number_of_seats"),
                            type: "number",
                            disabled: _e.disabled,
                            value: zn > bS ? bS : zn ?? 1,
                            step: 1,
                            placeholder: "1",
                            min: 1,
                            max: bS,
                            containerClassName: xe(
                              "max-w-80",
                              (kn = s == null ? void 0 : s.seatsOptions) == null ? void 0 : kn.seatsInput.container
                            ),
                            addOnClassname: (dt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : dt.seatsInput.addOn,
                            className: (cn = (Pt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Pt.seatsInput) == null ? void 0 : cn.input,
                            labelClassName: (ao = (sn = s == null ? void 0 : s.seatsOptions) == null ? void 0 : sn.seatsInput) == null ? void 0 : ao.label,
                            addOnSuffix: g("seats"),
                            onChange: (It) => {
                              const Jn = parseInt(It.target.value);
                              gn(Math.min(Jn, bS));
                            },
                            "data-testid": "seats-per-time-slot"
                          }
                        ),
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: xe(
                              "mt-4",
                              (bt = (Ze = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Ze.showAttendeesCheckbox) == null ? void 0 : bt.container
                            ),
                            children: /* @__PURE__ */ m(
                              Bn,
                              {
                                name: "seatsShowAttendees",
                                render: ({ field: { value: It, onChange: Jn } }) => {
                                  var ur, er, ya, Ai;
                                  return /* @__PURE__ */ m(
                                    cc,
                                    {
                                      "data-testid": "show-attendees",
                                      description: g("show_attendees"),
                                      className: (er = (ur = s == null ? void 0 : s.seatsOptions) == null ? void 0 : ur.showAttendeesCheckbox) == null ? void 0 : er.checkbox,
                                      descriptionClassName: (Ai = (ya = s == null ? void 0 : s.seatsOptions) == null ? void 0 : ya.showAttendeesCheckbox) == null ? void 0 : Ai.description,
                                      disabled: _e.disabled,
                                      onChange: (Ka) => Jn(Ka),
                                      checked: It
                                    }
                                  );
                                }
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: xe(
                              "mt-2",
                              (xn = (Wt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Wt.showAvalableSeatCountCheckbox) == null ? void 0 : xn.container
                            ),
                            children: /* @__PURE__ */ m(
                              Bn,
                              {
                                name: "seatsShowAvailabilityCount",
                                render: ({ field: { value: It, onChange: Jn } }) => {
                                  var ur, er, ya, Ai;
                                  return /* @__PURE__ */ m(
                                    cc,
                                    {
                                      description: g("show_available_seats_count"),
                                      disabled: _e.disabled,
                                      onChange: (Ka) => Jn(Ka),
                                      checked: It,
                                      className: (er = (ur = s == null ? void 0 : s.seatsOptions) == null ? void 0 : ur.showAvalableSeatCountCheckbox) == null ? void 0 : er.checkbox,
                                      descriptionClassName: (Ai = (ya = s == null ? void 0 : s.seatsOptions) == null ? void 0 : ya.showAvalableSeatCountCheckbox) == null ? void 0 : Ai.description
                                    }
                                  );
                                }
                              }
                            )
                          }
                        )
                      ] });
                    }
                  }
                ) })
              }
            ),
            P && /* @__PURE__ */ m(Us, { severity: "warning", title: g("seats_and_no_show_fee_error") })
          ] });
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "hideOrganizerEmail",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.hideOrganizerEmail) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.hideOrganizerEmail) == null ? void 0 : Gn.container
              ),
              title: g("hide_organizer_email"),
              ...Te,
              description: g("hide_organizer_email_description"),
              descriptionClassName: (An = s == null ? void 0 : s.hideOrganizerEmail) == null ? void 0 : An.description,
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn),
              "data-testid": "hide-organizer-email"
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "lockTimeZoneToggleOnBookingPage",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var An, hn, zn;
          const an = p.getValues("lockedTimeZone"), Gn = Ut && (!(e.lockTimeZoneToggleOnBookingPage && !e.lockedTimeZone) || !!an);
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (An = s == null ? void 0 : s.timezoneLock) == null ? void 0 : An.label),
              descriptionClassName: (hn = s == null ? void 0 : s.timezoneLock) == null ? void 0 : hn.description,
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (zn = s == null ? void 0 : s.timezoneLock) == null ? void 0 : zn.container,
                Gn && "rounded-b-none"
              ),
              title: g("lock_timezone_toggle_on_booking_page"),
              ...pe,
              description: g("description_lock_timezone_toggle_on_booking_page"),
              checked: Ut,
              onCheckedChange: (gn) => {
                Kt(gn);
                const kn = gn ? e.lockedTimeZone ?? "Europe/London" : null;
                p.setValue("lockedTimeZone", kn, { shouldDirty: !0 });
              },
              "data-testid": "lock-timezone-toggle",
              childrenClassName: "lg:ml-0",
              children: Gn && /* @__PURE__ */ m("div", { className: "border-subtle flex flex-col gap-6 rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
                Bn,
                {
                  name: "lockedTimeZone",
                  control: p.control,
                  render: ({ field: { value: gn } }) => /* @__PURE__ */ de(nt, { children: [
                    /* @__PURE__ */ m(Ko, { className: "text-default mb-2 block text-sm font-medium", children: /* @__PURE__ */ m(nt, { children: g("timezone") }) }),
                    /* @__PURE__ */ m(
                      Xn,
                      {
                        id: "lockedTimeZone",
                        value: gn ?? "Europe/London",
                        onChange: (kn) => {
                          kn && p.setValue("lockedTimeZone", kn.value, { shouldDirty: !0 });
                        }
                      }
                    )
                  ] })
                }
              ) }) })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "allowReschedulingPastBookings",
        render: ({ field: { value: Ut, onChange: Kt } }) => /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: xe("text-sm"),
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: xe("border-subtle rounded-lg border py-6 px-4 sm:px-6"),
            title: g("allow_rescheduling_past_events"),
            ...ve,
            description: g("allow_rescheduling_past_events_description"),
            checked: Ut,
            onCheckedChange: (an) => Kt(an)
          }
        )
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "allowReschedulingCancelledBookings",
        render: ({ field: { onChange: Ut } }) => /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: "text-sm",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
            title: g("allow_rescheduling_cancelled_bookings"),
            "data-testid": "allow-rescheduling-cancelled-bookings-toggle",
            ...st,
            description: g("description_allow_rescheduling_cancelled_bookings"),
            checked: at,
            onCheckedChange: (Kt) => {
              wt(Kt), Ut(Kt);
            }
          }
        )
      }
    ),
    /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
      Bn,
      {
        name: "customReplyToEmail",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An, hn, zn;
          return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                !!Ut && "rounded-b-none",
                (Gn = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : Gn.container
              ),
              descriptionClassName: (An = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : An.description,
              childrenClassName: xe("lg:ml-0", (hn = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : hn.children),
              title: g("custom_reply_to_email_title"),
              ...Re,
              "data-testid": "custom-reply-to-email",
              description: g("custom_reply_to_email_description"),
              checked: !!wn,
              onCheckedChange: (gn) => {
                Kt(
                  gn && (wn || e.customReplyToEmail || (c == null ? void 0 : c[0])) || null
                );
              },
              children: [
                d && /* @__PURE__ */ m(JKl, { username: ((zn = e.users[0]) == null ? void 0 : zn.name) || "there", showToast: i }),
                /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
                  iq,
                  {
                    className: "w-full",
                    label: g("custom_reply_to_email_title"),
                    required: !!wn,
                    placeholder: g("select_verified_email"),
                    "data-testid": "custom-reply-to-email-input",
                    value: Ut ? { label: Ut, value: Ut } : void 0,
                    onChange: (gn) => Kt((gn == null ? void 0 : gn.value) || null),
                    options: (c == null ? void 0 : c.map((gn) => ({ label: gn, value: gn }))) || []
                  }
                ) })
              ]
            }
          ) });
        }
      }
    ) }),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "eventTypeColor",
        render: () => {
          var Ut, Kt, an, Gn, An, hn;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (Ut = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : Ut.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                Ot && "rounded-b-none",
                (Kt = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : Kt.container
              ),
              title: g("event_type_color"),
              ...ne,
              description: g("event_type_color_description"),
              descriptionClassName: (an = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : an.description,
              checked: Ot,
              onCheckedChange: (zn) => {
                const gn = zn ? un : null;
                p.setValue("eventTypeColor", gn, {
                  shouldDirty: !0
                }), Ft(zn);
              },
              childrenClassName: xe("lg:ml-0", (Gn = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : Gn.children),
              children: /* @__PURE__ */ de("div", { className: "border-subtle flex flex-col gap-6 rounded-b-lg border border-t-0 p-6", children: [
                /* @__PURE__ */ de("div", { children: [
                  /* @__PURE__ */ m("p", { className: "text-default mb-2 block text-sm font-medium", children: g("light_event_type_color") }),
                  /* @__PURE__ */ m(
                    Xw,
                    {
                      defaultValue: un.lightEventTypeColor,
                      onChange: (zn) => {
                        const gn = {
                          ...un,
                          lightEventTypeColor: zn
                        };
                        p.setValue("eventTypeColor", gn, { shouldDirty: !0 }), pn(gn), vH("#ffffff", zn) ? y(!1) : y(!0);
                      }
                    }
                  ),
                  b ? /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(
                    Us,
                    {
                      severity: "warning",
                      className: (An = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : An.warningText,
                      message: g("event_type_color_light_theme_contrast_error")
                    }
                  ) }) : null
                ] }),
                /* @__PURE__ */ de("div", { className: "mt-6 sm:mt-0", children: [
                  /* @__PURE__ */ m("p", { className: "text-default mb-2 block text-sm font-medium", children: g("dark_event_type_color") }),
                  /* @__PURE__ */ m(
                    Xw,
                    {
                      defaultValue: un.darkEventTypeColor,
                      onChange: (zn) => {
                        const gn = {
                          ...un,
                          darkEventTypeColor: zn
                        };
                        p.setValue("eventTypeColor", gn, { shouldDirty: !0 }), pn(gn), vH("#101010", zn) ? v(!1) : v(!0);
                      }
                    }
                  ),
                  $ ? /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(
                    Us,
                    {
                      severity: "warning",
                      className: (hn = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : hn.warningText,
                      message: g("event_type_color_dark_theme_contrast_error")
                    }
                  ) }) : null
                ] })
              ] })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "showOptimizedSlots",
        render: ({ field: { onChange: Ut, value: Kt } }) => {
          const an = Kt;
          return /* @__PURE__ */ m(
            Jo,
            {
              toggleSwitchAtTheEnd: !0,
              labelClassName: "text-sm",
              title: g("show_optimized_slots"),
              description: g("show_optimized_slots_description"),
              checked: an,
              ...Je,
              onCheckedChange: (Gn) => {
                Ut(Gn ?? !1);
              },
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                an && "rounded-b-none"
              )
            }
          );
        }
      }
    ),
    U && /* @__PURE__ */ m(
      Bn,
      {
        name: "rescheduleWithSameRoundRobinHost",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.roundRobinReschedule) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.roundRobinReschedule) == null ? void 0 : Gn.container
              ),
              title: g("reschedule_with_same_round_robin_host_title"),
              description: g("reschedule_with_same_round_robin_host_description"),
              descriptionClassName: (An = s == null ? void 0 : s.roundRobinReschedule) == null ? void 0 : An.description,
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          );
        }
      }
    ),
    G7l(D) && /* @__PURE__ */ m(
      Bn,
      {
        name: "metadata.disableStandardEmails.confirmation.attendee",
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.emailNotifications) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.emailNotifications) == null ? void 0 : Gn.container
              ),
              title: g("disable_attendees_confirmation_emails"),
              description: g("disable_attendees_confirmation_emails_description"),
              descriptionClassName: (An = s == null ? void 0 : s.emailNotifications) == null ? void 0 : An.description,
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          ) });
        }
      }
    ),
    U7l(D) && /* @__PURE__ */ m(
      Bn,
      {
        name: "metadata.disableStandardEmails.confirmation.host",
        defaultValue: !!p.getValues("seatsPerTimeSlot"),
        render: ({ field: { value: Ut, onChange: Kt } }) => {
          var an, Gn, An;
          return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (an = s == null ? void 0 : s.emailNotifications) == null ? void 0 : an.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Gn = s == null ? void 0 : s.emailNotifications) == null ? void 0 : Gn.container
              ),
              descriptionClassName: (An = s == null ? void 0 : s.emailNotifications) == null ? void 0 : An.description,
              title: g("disable_host_confirmation_emails"),
              description: g("disable_host_confirmation_emails_description"),
              checked: Ut,
              onCheckedChange: (hn) => Kt(hn)
            }
          ) });
        }
      }
    ),
    (t == null ? void 0 : t.parentId) && /* @__PURE__ */ de(nt, { children: [
      /* @__PURE__ */ m(
        Bn,
        {
          name: "metadata.disableStandardEmails.all.attendee",
          render: ({ field: { value: Ut, onChange: Kt } }) => /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
            cQ,
            {
              checked: Ut,
              onCheckedChange: Kt,
              recipient: "attendees",
              customClassNames: s == null ? void 0 : s.emailNotifications,
              t: g
            }
          ) })
        }
      ),
      /* @__PURE__ */ m(
        Bn,
        {
          name: "metadata.disableStandardEmails.all.host",
          defaultValue: !!p.getValues("seatsPerTimeSlot"),
          render: ({ field: { value: Ut, onChange: Kt } }) => /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
            cQ,
            {
              checked: Ut,
              onCheckedChange: Kt,
              recipient: "hosts",
              customClassNames: s == null ? void 0 : s.emailNotifications,
              t: g
            }
          ) })
        }
      )
    ] }),
    f && /* @__PURE__ */ m(
      tZl,
      {
        close: vt,
        setValue: (Ut) => p.setValue("eventName", Ut, { shouldDirty: !0 }),
        defaultValue: p.getValues("eventName"),
        placeHolder: re,
        isNameFieldSplit: E,
        event: x,
        customClassNames: s == null ? void 0 : s.customEventTypeModal
      }
    )
  ] });
}, rZl = (e) => {
  var i;
  const { isPending: t, data: n, error: o } = Uy({}), { data: r } = Ibe((i = e.team) == null ? void 0 : i.id);
  return /* @__PURE__ */ m(
    oZl,
    {
      ...e,
      calendarsQuery: { data: n, isPending: t, error: o },
      showBookerLayoutSelector: !1,
      verifiedEmails: r
    }
  );
}, iZl = rZl, aZl = ({ className: e }) => /* @__PURE__ */ m(
  "li",
  {
    className: xe(
      "border-subtle group flex w-full items-center justify-between rounded-sm border px-[10px] py-3",
      e
    ),
    children: /* @__PURE__ */ m("div", { className: "flex-grow truncate text-sm", children: /* @__PURE__ */ de("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ m(Yo, { className: "h-4 w-32" }),
      /* @__PURE__ */ m(Yo, { className: "h-4 w-4" })
    ] }) })
  }
), Nbe = Bt(
  ({ label: e, description: t, informationIconText: n, ...o }, r) => {
    const i = !e || o.descriptionAsLabel;
    return /* @__PURE__ */ de("div", { className: "block items-center sm:flex", children: [
      e && /* @__PURE__ */ m("div", { className: "min-w-48 mb-4 sm:mb-0", children: Fe.createElement(
        i ? "div" : "label",
        {
          className: "flex text-sm font-medium text-default",
          ...i ? {} : {
            htmlFor: o.id
          }
        },
        e
      ) }),
      /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ de("div", { className: "relative flex items-start", children: [
        Fe.createElement(
          i ? "label" : "div",
          {
            className: xe(
              "relative flex items-start",
              i ? "text-default" : "text-emphasis"
            )
          },
          /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m("div", { className: "flex h-5 items-center", children: /* @__PURE__ */ m(
              "input",
              {
                ...o,
                ref: r,
                type: "checkbox",
                className: "text-emphasis focus:ring-emphasis dark:text-muted border-default bg-default h-4 w-4 rounded transition"
              }
            ) }),
            /* @__PURE__ */ m("span", { className: "ms-2 text-sm", children: t })
          ] })
        ),
        n && /* @__PURE__ */ m(vC, { content: n })
      ] }) })
    ] });
  }
);
Nbe.displayName = "CheckboxField";
const l2 = Nbe, zbe = ({ ...e }) => {
  const { label: t, isDefault: n, isManaged: o = !1 } = e.data, { t: r } = kt();
  return /* @__PURE__ */ de(F_.Option, { ...e, children: [
    /* @__PURE__ */ m("span", { children: t }),
    n && /* @__PURE__ */ m(Wi, { variant: "blue", className: "ml-2", children: r("default") }),
    o && /* @__PURE__ */ m(Wi, { variant: "gray", className: "ml-2", children: r("managed") })
  ] });
}, Rbe = ({ ...e }) => {
  const { label: t, isDefault: n, isManaged: o = !1 } = e.data, { t: r } = kt();
  return /* @__PURE__ */ de(F_.SingleValue, { ...e, children: [
    /* @__PURE__ */ m("span", { children: t }),
    n && /* @__PURE__ */ m(Wi, { variant: "blue", className: "ml-2", children: r("default") }),
    o && /* @__PURE__ */ m(Wi, { variant: "gray", className: "ml-2", children: r("managed") })
  ] });
}, sT = (e, t) => Intl.DateTimeFormat(void 0, {
  hour: "numeric",
  minute: "numeric",
  hourCycle: t ? "h12" : "h24"
}).format(new Date(ht.utc(e).format("YYYY-MM-DDTHH:mm:ss"))), Pbe = hre(
  ({
    scheduleQueryData: e,
    isSchedulePending: t,
    user: n,
    editAvailabilityRedirectUrl: o,
    customClassNames: r
  }) => {
    const i = n == null ? void 0 : n.timeFormat, { t: a, i18n: s } = kt(), c = Uq(n == null ? void 0 : n.weekStart), l = (u) => {
      var d;
      return ((d = e == null ? void 0 : e.schedule) == null ? void 0 : d.filter((_) => _.days.includes((u + c) % 7))) || [];
    };
    return /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("div", { className: xe("border-subtle space-y-4 border-x p-6", r == null ? void 0 : r.tableContainer), children: /* @__PURE__ */ m("ol", { className: xe("table border-collapse text-sm", r == null ? void 0 : r.table), children: Qy(s.language, c, "long").map((u, d) => {
        const _ = !!l(d).length;
        return /* @__PURE__ */ de(
          "li",
          {
            className: xe(
              "my-6 flex border-transparent last:mb-2",
              r == null ? void 0 : r.tableRow
            ),
            children: [
              /* @__PURE__ */ m(
                "span",
                {
                  className: xe(
                    "w-20 font-medium sm:w-32 ",
                    _ ? "text-default" : "text-subtle line-through",
                    r == null ? void 0 : r.day
                  ),
                  children: u
                }
              ),
              t ? /* @__PURE__ */ m(Yo, { className: "block h-5 w-60" }) : _ ? /* @__PURE__ */ m("div", { className: "space-y-3 text-right", children: l(d).map((p, g) => /* @__PURE__ */ de(
                "div",
                {
                  className: xe(
                    "text-default flex items-center leading-4",
                    r == null ? void 0 : r.dayAvailabilityContainer
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      "span",
                      {
                        className: xe(
                          "w-16 sm:w-28 sm:text-left",
                          r == null ? void 0 : r.dayAvailabilityFrom
                        ),
                        children: sT(p.startTime, i === 12)
                      }
                    ),
                    /* @__PURE__ */ m("span", { className: xe("ms-4", r == null ? void 0 : r.dayAvailabilitySeperator), children: "-" }),
                    /* @__PURE__ */ m("div", { className: xe("ml-6 sm:w-28", r == null ? void 0 : r.dayAvailabilityTo), children: sT(p.endTime, i === 12) })
                  ]
                },
                g
              )) }) : /* @__PURE__ */ m(
                "span",
                {
                  className: xe("text-subtle ml-6 sm:ml-0", r == null ? void 0 : r.dayUnavailable),
                  children: a("unavailable")
                }
              )
            ]
          },
          u
        );
      }) }) }),
      /* @__PURE__ */ de("div", { className: "bg-muted border-subtle flex flex-col items-center gap-2 rounded-b-md border p-6 sm:flex-row sm:items-center sm:justify-between", children: [
        /* @__PURE__ */ m("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ de("span", { className: "text-default flex items-center justify-center text-center text-sm sm:justify-start", children: [
          /* @__PURE__ */ m(qt, { name: "globe", className: "h-3.5 w-3.5 ltr:mr-2 rtl:ml-2" }),
          (e == null ? void 0 : e.timeZone) || /* @__PURE__ */ m(Yo, { className: "block h-5 w-32" })
        ] }) }),
        !!(e != null && e.id) && !e.isManaged && !e.readOnly && !!o && /* @__PURE__ */ m(
          Jt,
          {
            href: o,
            disabled: t,
            color: "minimal",
            EndIcon: "external-link",
            target: "_blank",
            rel: "noopener noreferrer",
            children: a("edit_availability")
          }
        )
      ] })
    ] });
  }
);
Pbe.displayName = "EventTypeScheduleDetails";
const Dbe = hre(
  ({
    scheduleQueryData: e,
    isSchedulePending: t,
    user: n,
    restrictionScheduleRedirectUrl: o,
    customClassNames: r,
    useBookerTimezone: i
  }) => {
    const a = n == null ? void 0 : n.timeFormat, { t: s, i18n: c } = kt(), l = No(), { setValue: u, watch: d } = l, _ = Uq(n == null ? void 0 : n.weekStart), p = (f) => {
      var h;
      return ((h = e == null ? void 0 : e.schedule) == null ? void 0 : h.filter(($) => $.days.includes((f + _) % 7))) || [];
    }, g = d("useBookerTimezone");
    return yt(() => {
      g === void 0 && u("useBookerTimezone", i || !1, { shouldDirty: !1 });
    }, [g, u, i]), /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("div", { className: xe("border-subtle space-y-4 border-x p-6", r == null ? void 0 : r.tableContainer), children: /* @__PURE__ */ m("ol", { className: xe("table border-collapse text-sm", r == null ? void 0 : r.table), children: Qy(c.language, _, "long").map((f, h) => {
        const $ = !!p(h).length;
        return /* @__PURE__ */ de(
          "li",
          {
            className: xe(
              "my-6 flex border-transparent last:mb-2",
              r == null ? void 0 : r.tableRow
            ),
            children: [
              /* @__PURE__ */ m(
                "span",
                {
                  className: xe(
                    "w-20 font-medium sm:w-32 ",
                    $ ? "text-default" : "text-subtle line-through",
                    r == null ? void 0 : r.day
                  ),
                  children: f
                }
              ),
              t ? /* @__PURE__ */ m(Yo, { className: "block h-5 w-60" }) : $ ? /* @__PURE__ */ m("div", { className: "space-y-3 text-right", children: p(h).map((v, b) => /* @__PURE__ */ de(
                "div",
                {
                  className: xe(
                    "text-default flex items-center leading-4",
                    r == null ? void 0 : r.dayAvailabilityContainer
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      "span",
                      {
                        className: xe(
                          "w-16 sm:w-28 sm:text-left",
                          r == null ? void 0 : r.dayAvailabilityFrom
                        ),
                        children: sT(v.startTime, a === 12)
                      }
                    ),
                    /* @__PURE__ */ m("span", { className: xe("ms-4", r == null ? void 0 : r.dayAvailabilitySeperator), children: "-" }),
                    /* @__PURE__ */ m("div", { className: xe("ml-6 sm:w-28", r == null ? void 0 : r.dayAvailabilityTo), children: sT(v.endTime, a === 12) })
                  ]
                },
                b
              )) }) : /* @__PURE__ */ m(
                "span",
                {
                  className: xe("text-subtle ml-6 sm:ml-0", r == null ? void 0 : r.dayUnavailable),
                  children: s("unavailable")
                }
              )
            ]
          },
          f
        );
      }) }) }),
      /* @__PURE__ */ de("div", { className: "bg-muted border-subtle flex flex-col justify-center gap-2 rounded-b-md border p-6 sm:flex-row sm:justify-between", children: [
        /* @__PURE__ */ de("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ de(
            "span",
            {
              className: xe(
                "text-default flex items-center justify-center text-sm sm:justify-start",
                g && "text-muted line-through"
              ),
              children: [
                /* @__PURE__ */ m(
                  qt,
                  {
                    name: "globe",
                    className: xe("h-3.5 w-3.5 ltr:mr-2 rtl:ml-2", g && "text-muted")
                  }
                ),
                (e == null ? void 0 : e.timeZone) || /* @__PURE__ */ m(Yo, { className: "block h-5 w-32" })
              ]
            }
          ),
          /* @__PURE__ */ m("div", { className: "ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m(
            l2,
            {
              checked: g,
              disabled: t,
              description: s("use_booker_timezone"),
              informationIconText: s("use_booker_timezone_info"),
              onChange: (f) => {
                u("useBookerTimezone", f.target.checked, { shouldDirty: !0 });
              }
            }
          ) })
        ] }),
        !!(e != null && e.id) && !e.isManaged && !e.readOnly && !!o && /* @__PURE__ */ m(
          Jt,
          {
            href: o,
            disabled: t,
            color: "minimal",
            EndIcon: "external-link",
            target: "_blank",
            rel: "noopener noreferrer",
            children: s("edit_availability")
          }
        )
      ] })
    ] });
  }
);
Dbe.displayName = "EventTypeRestrictionScheduleDetails";
const n6 = ({
  eventType: e,
  schedulesQueryData: t,
  isSchedulesPending: n,
  customClassNames: o,
  fieldName: r = "schedule",
  scheduleQueryData: i,
  restrictionScheduleQueryData: a,
  isSchedulePending: s,
  isRestrictionSchedulePending: c,
  restrictionScheduleRedirectUrl: l,
  ...u
}) => {
  var L;
  const { t: d } = kt(), _ = No(), { shouldLockIndicator: p, shouldLockDisableProps: g, isManagedEventType: f, isChildrenManagedEventType: h } = Bg({ eventType: e, translate: d, formMethods: _ }), { watch: $, setValue: v } = _, b = r === "restrictionSchedule" ? "restrictionScheduleId" : r, y = $(b);
  if (yt(() => {
    var R, T;
    if (t && y !== 0 && !y) {
      let D;
      if (r === "restrictionSchedule" ? D = e.restrictionScheduleId || ((R = t.find((A) => A.isDefault)) == null ? void 0 : R.id) : D = f ? 0 : (T = t.find((A) => A.isDefault)) == null ? void 0 : T.id, !D && D !== 0)
        return;
      v(b, D, {
        shouldDirty: !0
      });
    }
  }, [y, t]), n || !t)
    return /* @__PURE__ */ m(aZl, {});
  const w = t.map((R) => ({
    value: R.id,
    label: R.name,
    isDefault: R.isDefault,
    isManaged: !1
  }));
  f && w.push({
    value: 0,
    label: d("members_default_schedule"),
    isDefault: !1,
    isManaged: !1
  }), h && y && !t.find((R) => R.id === y) ? w.push({
    value: y,
    label: e.scheduleName ?? d("default_schedule_name"),
    isDefault: !1,
    isManaged: !1
  }) : e.schedule && !t.find((R) => R.id === e.schedule) && w.push({
    value: e.schedule,
    label: e.scheduleName ?? d("default_schedule_name"),
    isDefault: !1,
    isManaged: !1
  }), r === "restrictionSchedule" && e.restrictionScheduleId && !t.find((R) => R.id === e.restrictionScheduleId) && w.push({
    value: e.restrictionScheduleId,
    label: e.restrictionScheduleName ?? d("default_schedule_name"),
    isDefault: !1,
    isManaged: !1
  });
  const N = r === "restrictionSchedule" ? w.filter((R) => R.value !== e.schedule) : w, M = r === "schedule" ? i : a, q = r === "schedule" ? s : c;
  return /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "border-subtle rounded-t-md border p-6",
          o == null ? void 0 : o.availabilitySectionContainer
        ),
        children: [
          /* @__PURE__ */ de(
            "label",
            {
              htmlFor: "availability",
              className: xe(
                "text-default mb-2 block text-sm font-medium leading-none",
                (L = o == null ? void 0 : o.availabilitySelect) == null ? void 0 : L.label
              ),
              children: [
                d("availability"),
                (f || h) && p(b)
              ]
            }
          ),
          /* @__PURE__ */ m(
            Bn,
            {
              name: b,
              render: ({ field: { onChange: R, value: T } }) => {
                var A, S;
                const D = N.find(
                  (E) => E.value === T
                );
                return /* @__PURE__ */ m(
                  Di,
                  {
                    placeholder: d("select"),
                    options: N,
                    isDisabled: g(b).disabled,
                    isSearchable: !1,
                    onChange: (E) => {
                      E && (R(E.value), r === "restrictionSchedule" && E.value && v("restrictionScheduleId", E.value, { shouldDirty: !0 }));
                    },
                    className: xe(
                      "block w-full min-w-0 flex-1 rounded-sm text-sm",
                      (A = o == null ? void 0 : o.availabilitySelect) == null ? void 0 : A.select
                    ),
                    value: D,
                    components: { Option: zbe, SingleValue: Rbe },
                    isMulti: !1,
                    innerClassNames: (S = o == null ? void 0 : o.availabilitySelect) == null ? void 0 : S.innerClassNames
                  }
                );
              }
            }
          )
        ]
      }
    ),
    y !== 0 && (r === "schedule" || r === "restrictionSchedule") ? r === "restrictionSchedule" ? /* @__PURE__ */ m(
      Dbe,
      {
        ...u,
        scheduleQueryData: M,
        isSchedulePending: q,
        customClassNames: o == null ? void 0 : o.availabilityTable,
        useBookerTimezone: e.useBookerTimezone,
        restrictionScheduleRedirectUrl: l
      }
    ) : /* @__PURE__ */ m(
      Pbe,
      {
        ...u,
        scheduleQueryData: M,
        isSchedulePending: q,
        customClassNames: o == null ? void 0 : o.availabilityTable
      }
    ) : f && r === "schedule" && /* @__PURE__ */ m("p", { className: "!mt-2 ml-1 text-sm text-gray-600", children: d("members_default_schedule_description") })
  ] });
}, sZl = ({
  host: e,
  index: t,
  teamMembers: n,
  hostScheduleQuery: o,
  customClassNames: r
}) => {
  const { t: i } = kt(), a = Kr(), s = No(), { getValues: c } = s, { data: l, isPending: u } = o({
    userId: e.userId
  }), d = l == null ? void 0 : l.schedules, _ = d == null ? void 0 : d.map((v) => ({
    value: v.id,
    label: v.name,
    isDefault: v.isDefault,
    isManaged: !1
  })), p = c(`hosts.${t}.scheduleId`), g = _ == null ? void 0 : _.find(
    (v) => {
      var b;
      return p ? v.value === p : v.value === ((b = d == null ? void 0 : d.find((y) => y.isDefault)) == null ? void 0 : b.id);
    }
  ), f = n.find((v) => v.id === e.userId), h = f == null ? void 0 : f.avatar, $ = f == null ? void 0 : f.name;
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de("div", { className: xe("flex w-full items-center", r == null ? void 0 : r.labelContainer), children: [
      !a && /* @__PURE__ */ m(Dd, { size: "sm", imageSrc: h, alt: $ || "" }),
      a && /* @__PURE__ */ m(qt, { name: "user", className: xe("h-4 w-4", r == null ? void 0 : r.labelAvatar) }),
      /* @__PURE__ */ m("p", { className: xe("text-emphasis my-auto ms-3 text-sm", r == null ? void 0 : r.label), children: $ })
    ] }),
    /* @__PURE__ */ m("div", { className: "flex w-full flex-col pt-2", children: u ? /* @__PURE__ */ m(pTe, { className: "mt-2 h-6 w-6" }) : /* @__PURE__ */ m(
      Bn,
      {
        name: `hosts.${t}.scheduleId`,
        render: ({ field: v }) => /* @__PURE__ */ m(
          Di,
          {
            placeholder: i("select"),
            options: _,
            isSearchable: !1,
            onChange: (b) => {
              v.onChange((b == null ? void 0 : b.value) || null);
            },
            className: xe(
              "block w-full min-w-0 flex-1 rounded-sm text-sm",
              r == null ? void 0 : r.select
            ),
            innerClassNames: r == null ? void 0 : r.innerClassNames,
            value: g,
            components: { Option: zbe, SingleValue: Rbe },
            isMulti: !1,
            isDisabled: u
          }
        )
      }
    ) })
  ] });
}, cZl = ({
  teamMembers: e,
  hostSchedulesQuery: t,
  customClassNames: n
}) => {
  const { t: o } = kt(), { watch: r } = No(), [i] = qd(), a = r("hosts");
  return /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "border-subtle flex flex-col rounded-md",
        n == null ? void 0 : n.teamAvailibilityContainer
      ),
      children: [
        /* @__PURE__ */ de(
          "div",
          {
            className: xe(
              "border-subtle mt-5 rounded-t-md border p-6 pb-5",
              n == null ? void 0 : n.chooseHostSchedulesLabelContainer
            ),
            children: [
              /* @__PURE__ */ m(
                Ko,
                {
                  className: xe("mb-1 text-sm font-semibold", n == null ? void 0 : n.chooseHostSchedulesLabel),
                  children: o("choose_hosts_schedule")
                }
              ),
              /* @__PURE__ */ m(
                "p",
                {
                  className: xe(
                    "text-subtle max-w-full break-words text-sm leading-tight",
                    n == null ? void 0 : n.chooseHostSchedulesLabelDescription
                  ),
                  children: o("hosts_schedule_description")
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-md border border-t-0 p-6", children: a && a.length > 0 ? /* @__PURE__ */ m(
          "ul",
          {
            className: xe("mb-4 mt-3 rounded-md", a.length >= 1 && "border-subtle border"),
            ref: i,
            children: a == null ? void 0 : a.map((s, c) => {
              var l;
              return /* @__PURE__ */ m(
                "li",
                {
                  className: xe(
                    `flex flex-col px-3 py-2 ${c === a.length - 1 ? "" : "border-subtle border-b"}`,
                    (l = n == null ? void 0 : n.teamMemberSchedule) == null ? void 0 : l.container
                  ),
                  children: /* @__PURE__ */ m(
                    sZl,
                    {
                      host: s,
                      index: c,
                      teamMembers: e,
                      hostScheduleQuery: t,
                      customClassNames: n == null ? void 0 : n.teamMemberSchedule
                    }
                  )
                },
                s.userId
              );
            })
          }
        ) : /* @__PURE__ */ m("p", { className: "text-subtle max-w-full break-words text-sm leading-tight", children: o("no_hosts_description") }) })
      ]
    }
  ) });
}, lZl = (e) => {
  const { setValue: t } = No(), [n, o] = it(!e), r = () => {
    t("schedule", null, { shouldDirty: !!e });
  };
  return {
    useHostSchedulesForTeamEvent: n,
    toggleScheduleState: (a) => {
      const s = !a;
      o(s), s && r();
    }
  };
}, uZl = (e) => {
  const { setValue: t } = No(), [n, o] = it(!!e);
  return {
    restrictScheduleForHosts: n,
    toggleRestrictScheduleState: (i) => {
      o(i), i || (t("restrictionScheduleId", null, { shouldDirty: !0 }), t("useBookerTimezone", !1, { shouldDirty: !0 }));
    }
  };
}, dZl = ({
  eventType: e,
  customClassNames: t,
  isRestrictionScheduleEnabled: n,
  ...o
}) => {
  const { t: r } = kt(), i = Kr(), { useHostSchedulesForTeamEvent: a, toggleScheduleState: s } = lZl(e.schedule), { restrictScheduleForHosts: c, toggleRestrictScheduleState: l } = uZl(
    e.restrictionScheduleId
  );
  return /* @__PURE__ */ de("div", { className: "space-y-4", children: [
    /* @__PURE__ */ de("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: [
      /* @__PURE__ */ m(
        Jo,
        {
          checked: !a,
          onCheckedChange: s,
          title: r("choose_common_schedule_team_event"),
          description: r("choose_common_schedule_team_event_description"),
          children: /* @__PURE__ */ m(
            n6,
            {
              customClassNames: t == null ? void 0 : t.userAvailability,
              eventType: e,
              fieldName: "schedule",
              ...o
            }
          )
        }
      ),
      a && /* @__PURE__ */ m("div", { className: "lg:ml-14", children: /* @__PURE__ */ m(
        cZl,
        {
          teamMembers: o.teamMembers,
          hostSchedulesQuery: o.hostSchedulesQuery,
          customClassNames: t == null ? void 0 : t.teamAvailability
        }
      ) })
    ] }),
    !i && n ? /* @__PURE__ */ m("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: /* @__PURE__ */ m(
      Jo,
      {
        checked: c,
        onCheckedChange: l,
        title: r("choose_restriction_schedule"),
        description: r("restriction_schedule_description"),
        children: /* @__PURE__ */ m(
          n6,
          {
            customClassNames: t == null ? void 0 : t.userAvailability,
            eventType: e,
            fieldName: "restrictionSchedule",
            ...o
          }
        )
      }
    ) }) : /* @__PURE__ */ m(nt, {})
  ] });
}, _Zl = ({ eventType: e, isTeamEvent: t, ...n }) => {
  var o;
  return t && e.schedulingType !== Bs.MANAGED ? /* @__PURE__ */ m(dZl, { eventType: e, ...n }) : /* @__PURE__ */ m(
    n6,
    {
      eventType: e,
      ...n,
      customClassNames: (o = n == null ? void 0 : n.customClassNames) == null ? void 0 : o.userAvailability
    }
  );
}, pZl = "user-schedules", mZl = () => {
  const { isInit: e } = cr(), t = `/${rs.availability}`, { isLoading: n, error: o, data: r } = mr({
    queryKey: [pZl],
    queryFn: () => At.get(t, {
      headers: { [Fy]: uEe }
    }).then((i) => {
      var a;
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error((a = i.data.error) == null ? void 0 : a.message);
    }),
    enabled: e
  });
  return { isLoading: n, error: o, data: r };
}, fZl = "use-team-members", gZl = ({ teamId: e }) => {
  const { organizationId: t } = cr();
  return mr({
    queryKey: [fZl, t, e],
    queryFn: async () => {
      const o = `/organizations/${t}/teams/${e}/memberships`;
      return At == null ? void 0 : At.get(o).then((r) => {
        if (r.data.status === Nn)
          return r.data.data;
        throw new Error(r.data.error.message);
      });
    },
    enabled: !!t && !!e
  });
}, hZl = "use-atom-host-schedule-by-id", vZl = ({ userId: e, teamId: t }) => {
  const { organizationId: n, userId: o } = cr();
  return mr({
    queryKey: [hZl, n, e],
    queryFn: async () => {
      const i = `/organizations/${n}/teams/${t}/users/${e}/schedules`;
      return At == null ? void 0 : At.get(i).then((a) => {
        var s, c;
        if (a.data.status === Nn)
          return { schedules: a.data.data.map((u) => ({
            id: u.id,
            name: u.name,
            isDefault: u.isDefault,
            userId: u.ownerId,
            readOnly: o !== e
          })) };
        throw new Error(((c = (s = a.data) == null ? void 0 : s.error) == null ? void 0 : c.message) ?? "Error while getting host schedules");
      });
    },
    enabled: !!n && !!t && !!e
  });
}, bZl = ({
  user: e,
  teamId: t,
  ...n
}) => {
  const r = No().watch("schedule"), { isLoading: i, data: a } = use(r == null ? void 0 : r.toString()), { data: s, isLoading: c } = mZl(), l = vZl, { data: u } = gZl({ teamId: t });
  return a ? /* @__PURE__ */ m(
    _Zl,
    {
      ...n,
      user: e,
      teamMembers: (u == null ? void 0 : u.map((d) => ({
        avatar: d.user.avatarUrl ?? "",
        id: d.userId,
        name: d.user.name
      }))) ?? [],
      schedulesQueryData: s,
      isSchedulesPending: c,
      isSchedulePending: i,
      hostSchedulesQuery: ({ userId: d }) => l({ userId: d, teamId: t }),
      scheduleQueryData: {
        ...a,
        isManaged: a.isManaged,
        readOnly: a.readOnly,
        id: a.id,
        timeZone: a.timeZone,
        schedule: (a.schedule || []).map((d) => ({
          id: d.id ?? null,
          startTime: new Date(d.startTime),
          endTime: new Date(d.endTime),
          userId: d.userId ?? null,
          eventTypeId: d.eventTypeId ?? null,
          scheduleId: d.scheduleId ?? null,
          date: d.date ? new Date(d.date) : null,
          days: d.days
        }))
      }
    }
  ) : /* @__PURE__ */ m(nt, {});
}, yZl = bZl, $Zl = () => [5, 10, 15, 20, 30, 45, 60, 90, 120], o6 = 60, r6 = 1440, uQ = 24;
function dQ(e, t, n) {
  const r = {
    minutes_minutes: () => n,
    minutes_hours: () => n / o6,
    minutes_days: () => n / r6,
    hours_minutes: () => n * o6,
    hours_hours: () => n,
    hours_days: () => n * uQ,
    days_minutes: () => n * r6,
    days_hours: () => n * uQ,
    days_days: () => n
  }[`${e}_${t}`], i = r();
  return Math.ceil(i);
}
function _Q(e) {
  return e % r6 === 0 ? "days" : e % o6 === 0 ? "hours" : "minutes";
}
function wZl({
  maxActiveBookingsPerBookerLocked: e
}) {
  const { t } = kt(), n = No(), [o, r] = it(
    (n.getValues("maxActiveBookingsPerBooker") ?? 0) > 0
  ), i = !!n.getValues("recurringEvent"), a = n.watch(
    "maxActiveBookingPerBookerOfferReschedule"
  );
  return /* @__PURE__ */ m(
    Bn,
    {
      name: "maxActiveBookingsPerBooker",
      render: ({ field: { onChange: s, value: c } }) => {
        const l = o;
        return /* @__PURE__ */ m(
          Jo,
          {
            labelClassName: xe("text-sm"),
            ...e,
            disabled: i || e.disabled,
            tooltip: i ? t("recurring_event_doesnt_support_booker_booking_limit") : "",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: xe(
              "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
              l && "rounded-b-none"
            ),
            childrenClassName: xe("lg:ml-0"),
            title: t("booker_booking_limit"),
            description: t("booker_booking_limit_description"),
            checked: l,
            onCheckedChange: (u) => {
              s(u ? 1 : null), r((d) => !d);
            },
            children: /* @__PURE__ */ de("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: [
              /* @__PURE__ */ m(
                xr,
                {
                  required: !0,
                  type: "number",
                  value: c ?? "",
                  disabled: e.disabled,
                  onChange: (u) => {
                    s(u.target.value === "" ? null : parseInt(u.target.value, 10));
                  },
                  min: 1,
                  step: 1,
                  containerClassName: xe("max-w-80"),
                  addOnSuffix: "bookings",
                  "data-testid": "booker-booking-limit-input"
                }
              ),
              /* @__PURE__ */ m(
                cc,
                {
                  checked: !!a,
                  descriptionAsLabel: !0,
                  description: t("offer_to_reschedule_last_booking"),
                  disabled: e.disabled,
                  onChange: (u) => {
                    n.setValue("maxActiveBookingPerBookerOfferReschedule", u.target.checked, {
                      shouldDirty: !0
                    });
                  }
                }
              )
            ] })
          }
        );
      }
    }
  );
}
const kZl = (e) => e === ic.ROLLING_WINDOW ? {
  value: ic.ROLLING,
  rollingExcludeUnavailableDays: !0
} : e === ic.ROLLING ? {
  value: ic.ROLLING,
  rollingExcludeUnavailableDays: !1
} : {
  value: e,
  rollingExcludeUnavailableDays: null
}, Lbe = (e) => e.value === ic.ROLLING && e.rollingExcludeUnavailableDays === !0 ? ic.ROLLING_WINDOW : e.value;
function SZl({
  isDisabled: e,
  formMethods: t,
  radioValue: n,
  customClassNames: o
}) {
  const { t: r } = kt();
  return /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "text-default mb-2 flex flex-col items-start text-sm sm:flex-row sm:items-center",
        o == null ? void 0 : o.wrapper
      ),
      children: [
        /* @__PURE__ */ de("div", { className: "flex w-full items-center sm:w-auto", children: [
          !e && /* @__PURE__ */ m(
            i1,
            {
              id: n,
              value: n,
              className: "min-w-4 bg-default border-default flex h-4 w-4 cursor-pointer items-center rounded-full border focus:border-2 focus:outline-none ltr:mr-2 rtl:ml-2",
              children: /* @__PURE__ */ m(a1, { className: "after:bg-inverted relative flex h-4 w-4 items-center justify-center after:block after:h-2 after:w-2 after:rounded-full" })
            }
          ),
          /* @__PURE__ */ m("span", { children: r("within_date_range") })
        ] }),
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
          "div",
          {
            className: xe(
              "me-2 ms-0 mt-2 w-full sm:ms-2 sm:mt-0 sm:w-auto",
              o == null ? void 0 : o.datePickerWraper
            ),
            children: /* @__PURE__ */ m(
              Bn,
              {
                name: "periodDates",
                render: ({ field: { onChange: i } }) => /* @__PURE__ */ m(
                  Kyc,
                  {
                    dates: {
                      startDate: t.getValues("periodDates").startDate,
                      endDate: t.getValues("periodDates").endDate
                    },
                    disabled: e,
                    onDatesChange: ({ startDate: a, endDate: s }) => {
                      i({
                        startDate: a,
                        endDate: s
                      });
                    },
                    className: o == null ? void 0 : o.datePicker
                  }
                )
              }
            )
          }
        ) })
      ]
    }
  );
}
function EZl({
  radioValue: e,
  isDisabled: t,
  formMethods: n,
  onChange: o,
  rollingExcludeUnavailableDays: r,
  customClassNames: i
}) {
  var u, d;
  const { t: a } = kt(), s = [
    { value: 0, label: a("business_days") },
    { value: 1, label: a("calendar_days") }
  ], c = () => s.find((_) => _.value === (n.getValues("periodCountCalendarDays") === !0 ? 1 : 0)), l = n.watch("periodDays");
  return /* @__PURE__ */ de(
    "div",
    {
      className: xe(
        "text-default mb-2 flex flex-wrap items-baseline text-sm",
        i == null ? void 0 : i.container
      ),
      children: [
        !t && /* @__PURE__ */ m(
          i1,
          {
            id: e,
            value: e,
            className: "min-w-4 bg-default border-default flex h-4 w-4 cursor-pointer items-center rounded-full border focus:border-2 focus:outline-none ltr:mr-2 rtl:ml-2",
            children: /* @__PURE__ */ m(a1, { className: "after:bg-inverted relative flex h-4 w-4 items-center justify-center after:block after:h-2 after:w-2 after:rounded-full" })
          }
        ),
        /* @__PURE__ */ de("div", { children: [
          /* @__PURE__ */ de("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              xr,
              {
                labelSrOnly: !0,
                type: "number",
                className: xe(
                  "border-default my-0 block w-16 text-sm [appearance:textfield]",
                  i == null ? void 0 : i.textField
                ),
                placeholder: "30",
                disabled: t,
                min: 0,
                max: r ? RM : void 0,
                ...n.register("periodDays", { valueAsNumber: !0 })
              }
            ),
            /* @__PURE__ */ m(
              Di,
              {
                options: s,
                isSearchable: !1,
                isDisabled: t,
                onChange: o,
                name: "periodCoundCalendarDays",
                value: c(),
                defaultValue: c(),
                className: xe(
                  "!mt-0 ml-2 w-28 shrink sm:w-36",
                  (u = i == null ? void 0 : i.periodTypeSelect) == null ? void 0 : u.select
                ),
                innerClassNames: (d = i == null ? void 0 : i.periodTypeSelect) == null ? void 0 : d.innerClassNames
              }
            ),
            /* @__PURE__ */ de("span", { className: "me-2 ms-2", children: [
              " ",
              a("into_the_future")
            ] })
          ] }),
          /* @__PURE__ */ m("div", { className: "-ml-6 flex flex-col py-2", children: /* @__PURE__ */ de("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              l2,
              {
                checked: !!r,
                disabled: t,
                description: a("always_show_x_days", {
                  x: l
                }),
                onChange: (_) => {
                  const p = _.target.checked;
                  n.setValue(
                    "periodDays",
                    Math.min(l, RM)
                  ), n.setValue(
                    "periodType",
                    Lbe({
                      value: ic.ROLLING,
                      rollingExcludeUnavailableDays: p
                    }),
                    { shouldDirty: !0 }
                  );
                }
              }
            ),
            /* @__PURE__ */ m(Sr, { content: a("always_show_x_days_description", {
              x: l
            }), children: /* @__PURE__ */ m(
              qt,
              {
                name: "info",
                className: "text-default hover:text-attention hover:bg-attention ms-1 inline h-4 w-4 rounded-md"
              }
            ) })
          ] }) })
        ] })
      ]
    }
  );
}
const xZl = Fe.forwardRef(function({ customClassNames: t, ...n }, o) {
  const { t: r } = kt(), { setValue: i, getValues: a } = No(), s = [
    {
      label: r("minutes"),
      value: "minutes"
    },
    {
      label: r("hours"),
      value: "hours"
    },
    {
      label: r("days"),
      value: "days"
    }
  ], [c, l] = it({
    type: _Q(a(n.name)),
    value: dQ(
      "minutes",
      _Q(a(n.name)),
      a(n.name)
    )
  });
  return yt(() => {
    i(
      n.name,
      dQ(
        c.type,
        "minutes",
        c.value
      ),
      { shouldDirty: !0 }
    );
  }, [c, i, n.name]), /* @__PURE__ */ de("div", { className: "flex items-end justify-end", children: [
    /* @__PURE__ */ de("div", { className: "w-1/2 md:w-full", children: [
      /* @__PURE__ */ m(
        Da,
        {
          required: !0,
          disabled: n.disabled,
          defaultValue: c.value,
          onChange: (u) => l({
            ...c,
            value: parseInt(u.target.value || "0", 10)
          }),
          label: r("minimum_booking_notice"),
          type: "number",
          placeholder: "0",
          className: xe("mb-0 h-9 ltr:mr-2 rtl:ml-2", t == null ? void 0 : t.input),
          min: 0
        }
      ),
      /* @__PURE__ */ m("input", { type: "hidden", ref: o, ...n })
    ] }),
    /* @__PURE__ */ m(
      Di,
      {
        isSearchable: !1,
        isDisabled: n.disabled,
        className: xe(
          "mb-0 ml-2 h-9 w-full capitalize md:min-w-[150px] md:max-w-[200px]",
          t == null ? void 0 : t.select
        ),
        innerClassNames: t == null ? void 0 : t.innerClassNames,
        defaultValue: s.find(
          (u) => u.value === c.type
        ),
        onChange: (u) => {
          u && l({
            ...c,
            type: u.value
          });
        },
        options: s
      }
    )
  ] });
}), CZl = ({ eventType: e, customClassNames: t }) => {
  var v, b, y, w, N, M, q, L, R, T, D, A, S, E, x, k, I, z, F, P, O, V, U, H, J, le, ae, Y, re, ie;
  const { t: n, i18n: o } = kt(), r = No();
  r.getValues("recurringEvent");
  const { shouldLockIndicator: i, shouldLockDisableProps: a } = Bg({
    eventType: e,
    translate: n,
    formMethods: r
  }), s = a("bookingLimits"), c = a("durationLimits"), l = a("onlyShowFirstAvailableSlot"), u = a("periodType"), d = a("offsetStart"), _ = a("maxActiveBookingsPerBooker"), [p, g] = it(r.getValues("offsetStart") > 0);
  it(
    (r.getValues("maxActiveBookingsPerBooker") ?? 0) > 0
  );
  const f = r.watch("offsetStart"), h = /* @__PURE__ */ new Date();
  h.setHours(9, 0, 0, 0);
  const $ = new Date(h.getTime() + f * 60 * 1e3);
  return /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "border-subtle space-y-6 rounded-lg border p-6",
          (v = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : v.container
        ),
        children: [
          /* @__PURE__ */ de("div", { className: "flex flex-col space-y-4  lg:flex-row lg:space-x-4 lg:space-y-0", children: [
            /* @__PURE__ */ de(
              "div",
              {
                className: xe(
                  "w-full",
                  (y = (b = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : b.beforeBufferSelect) == null ? void 0 : y.container
                ),
                children: [
                  /* @__PURE__ */ de(
                    Ko,
                    {
                      htmlFor: "beforeBufferTime",
                      className: (N = (w = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : w.beforeBufferSelect) == null ? void 0 : N.label,
                      children: [
                        n("before_event"),
                        i("beforeBufferTime")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    Bn,
                    {
                      name: "beforeEventBuffer",
                      render: ({ field: { onChange: _e, value: he } }) => {
                        var Q, me, ne, pe;
                        const be = [
                          {
                            label: n("event_buffer_default"),
                            value: 0
                          },
                          ...$Zl().map((ge) => ({
                            label: `${ge} ${n("minutes")}`,
                            value: ge
                          }))
                        ];
                        return /* @__PURE__ */ m(
                          Di,
                          {
                            isSearchable: !1,
                            onChange: (ge) => {
                              ge && _e(ge.value);
                            },
                            isDisabled: a("beforeBufferTime").disabled,
                            defaultValue: be.find((ge) => ge.value === he) || be[0],
                            options: be,
                            className: xe(
                              (me = (Q = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : Q.beforeBufferSelect) == null ? void 0 : me.select
                            ),
                            innerClassNames: (pe = (ne = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : ne.beforeBufferSelect) == null ? void 0 : pe.innerClassNames
                          }
                        );
                      }
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ de(
              "div",
              {
                className: xe(
                  "w-full",
                  (q = (M = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : M.afterBufferSelect) == null ? void 0 : q.container
                ),
                children: [
                  /* @__PURE__ */ de(
                    Ko,
                    {
                      htmlFor: "afterBufferTime",
                      className: (R = (L = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : L.afterBufferSelect) == null ? void 0 : R.label,
                      children: [
                        n("after_event"),
                        i("afterBufferTime")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    Bn,
                    {
                      name: "afterEventBuffer",
                      render: ({ field: { onChange: _e, value: he } }) => {
                        var Q, me, ne, pe;
                        const be = [
                          {
                            label: n("event_buffer_default"),
                            value: 0
                          },
                          ...[5, 10, 15, 20, 30, 45, 60, 90, 120].map((ge) => ({
                            label: `${ge} ${n("minutes")}`,
                            value: ge
                          }))
                        ];
                        return /* @__PURE__ */ m(
                          Di,
                          {
                            isSearchable: !1,
                            onChange: (ge) => {
                              ge && _e(ge.value);
                            },
                            isDisabled: a("afterBufferTime").disabled,
                            defaultValue: be.find((ge) => ge.value === he) || be[0],
                            options: be,
                            className: xe(
                              (me = (Q = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : Q.afterBufferSelect) == null ? void 0 : me.select
                            ),
                            innerClassNames: (pe = (ne = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : ne.afterBufferSelect) == null ? void 0 : pe.innerClassNames
                          }
                        );
                      }
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ de("div", { className: "flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: [
            /* @__PURE__ */ de(
              "div",
              {
                className: xe(
                  "w-full",
                  (D = (T = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : T.minimumNoticeInput) == null ? void 0 : D.container
                ),
                children: [
                  /* @__PURE__ */ de(
                    Ko,
                    {
                      htmlFor: "minimumBookingNotice",
                      className: (S = (A = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : A.minimumNoticeInput) == null ? void 0 : S.label,
                      children: [
                        n("minimum_booking_notice"),
                        i("minimumBookingNotice")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    xZl,
                    {
                      customClassNames: (E = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : E.minimumNoticeInput,
                      disabled: a("minimumBookingNotice").disabled,
                      ...r.register("minimumBookingNotice")
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ de(
              "div",
              {
                className: xe(
                  "w-full",
                  (k = (x = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : x.timeSlotIntervalSelect) == null ? void 0 : k.container
                ),
                children: [
                  /* @__PURE__ */ de(
                    Ko,
                    {
                      htmlFor: "slotInterval",
                      className: (z = (I = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : I.timeSlotIntervalSelect) == null ? void 0 : z.label,
                      children: [
                        n("slot_interval"),
                        i("slotInterval")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    Bn,
                    {
                      name: "slotInterval",
                      render: () => {
                        var he, be, Q, me;
                        const _e = [
                          {
                            label: n("slot_interval_default"),
                            value: -1
                          },
                          ...[5, 10, 15, 20, 30, 45, 60, 75, 90, 105, 120].map((ne) => ({
                            label: `${ne} ${n("minutes")}`,
                            value: ne
                          }))
                        ];
                        return /* @__PURE__ */ m(
                          Di,
                          {
                            isSearchable: !1,
                            isDisabled: a("slotInterval").disabled,
                            onChange: (ne) => {
                              r.setValue("slotInterval", ne && (ne.value || 0) > 0 ? ne.value : null, {
                                shouldDirty: !0
                              });
                            },
                            defaultValue: _e.find(
                              (ne) => ne.value === r.getValues("slotInterval")
                            ) || _e[0],
                            options: _e,
                            className: (be = (he = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : he.timeSlotIntervalSelect) == null ? void 0 : be.select,
                            innerClassNames: (me = (Q = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : Q.timeSlotIntervalSelect) == null ? void 0 : me.innerClassNames
                          }
                        );
                      }
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "bookingLimits",
        render: ({ field: { value: _e } }) => {
          var be, Q, me, ne, pe, ge;
          const he = Object.keys(_e ?? {}).length > 0;
          return /* @__PURE__ */ m(
            Jo,
            {
              toggleSwitchAtTheEnd: !0,
              labelClassName: xe("text-sm", (be = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : be.label),
              title: n("limit_booking_frequency"),
              ...s,
              description: n("limit_booking_frequency_description"),
              checked: he,
              onCheckedChange: (ve) => {
                ve ? r.setValue(
                  "bookingLimits",
                  {
                    PER_DAY: 1
                  },
                  { shouldDirty: !0 }
                ) : r.setValue("bookingLimits", {}, { shouldDirty: !0 });
              },
              switchContainerClassName: xe(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                he && "rounded-b-none",
                (Q = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : Q.container
              ),
              childrenClassName: xe("lg:ml-0", (me = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : me.children),
              descriptionClassName: (ne = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : ne.description,
              children: /* @__PURE__ */ m(
                "div",
                {
                  className: xe(
                    "border-subtle rounded-b-lg border border-t-0 p-6",
                    (pe = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : pe.intervalLimitContainer
                  ),
                  children: /* @__PURE__ */ m(
                    pQ,
                    {
                      disabled: s.disabled,
                      propertyName: "bookingLimits",
                      defaultLimit: 1,
                      step: 1,
                      customClassNames: (ge = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : ge.intervalLimitItem
                    }
                  )
                }
              )
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "onlyShowFirstAvailableSlot",
        render: ({ field: { onChange: _e, value: he } }) => {
          var Q, me, ne, pe;
          const be = he;
          return /* @__PURE__ */ m(
            Jo,
            {
              toggleSwitchAtTheEnd: !0,
              labelClassName: xe("text-sm", (Q = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : Q.label),
              title: n("only_show_first_available_slot"),
              description: n("only_show_first_available_slot_description"),
              checked: be,
              ...l,
              onCheckedChange: (ge) => {
                _e(ge ?? !1);
              },
              switchContainerClassName: xe(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                be && "rounded-b-none",
                (me = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : me.container
              ),
              childrenClassName: (ne = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : ne.children,
              descriptionClassName: (pe = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : pe.description
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "durationLimits",
        render: ({ field: { onChange: _e, value: he } }) => {
          var Q, me, ne, pe, ge;
          const be = Object.keys(he ?? {}).length > 0;
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (Q = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : Q.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                be && "rounded-b-none",
                (me = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : me.container
              ),
              childrenClassName: xe("lg:ml-0", (ne = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : ne.children),
              descriptionClassName: (pe = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : pe.description,
              title: n("limit_total_booking_duration"),
              description: n("limit_total_booking_duration_description"),
              ...c,
              checked: be,
              onCheckedChange: (ve) => {
                _e(ve ? {
                  PER_DAY: 60
                } : {});
              },
              children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
                pQ,
                {
                  propertyName: "durationLimits",
                  defaultLimit: 60,
                  disabled: c.disabled,
                  step: 15,
                  textFieldSuffix: n("minutes"),
                  customClassNames: (ge = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : ge.intervalLimitItem
                }
              ) })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      wZl,
      {
        maxActiveBookingsPerBookerLocked: _
      }
    ),
    /* @__PURE__ */ m(
      Bn,
      {
        name: "periodType",
        render: ({ field: { onChange: _e, value: he } }) => {
          var ne, pe, ge, ve, Te, Re;
          const be = he && he !== "UNLIMITED", { value: Q, rollingExcludeUnavailableDays: me } = kZl(
            r.watch("periodType")
          );
          return /* @__PURE__ */ m(
            Jo,
            {
              labelClassName: xe("text-sm", (ne = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : ne.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: xe(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                be && "rounded-b-none",
                (pe = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : pe.container
              ),
              childrenClassName: xe("lg:ml-0", (ge = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : ge.children),
              descriptionClassName: (ve = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : ve.description,
              title: n("limit_future_bookings"),
              description: n("limit_future_bookings_description"),
              ...u,
              checked: be,
              onCheckedChange: (Me) => (Me && !r.getValues("periodDays") && r.setValue("periodDays", 30, { shouldDirty: !0 }), _e(Me ? ic.ROLLING : ic.UNLIMITED)),
              children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ de(
                r1,
                {
                  value: Q,
                  onValueChange: (Me) => {
                    r.setValue(
                      "periodType",
                      Lbe({
                        value: Me,
                        rollingExcludeUnavailableDays: r.getValues("rollingExcludeUnavailableDays")
                      }),
                      {
                        shouldDirty: !0
                      }
                    );
                  },
                  children: [
                    (u.disabled ? Q === ic.ROLLING : !0) && /* @__PURE__ */ m(
                      EZl,
                      {
                        rollingExcludeUnavailableDays: !!me,
                        radioValue: ic.ROLLING,
                        isDisabled: u.disabled,
                        formMethods: r,
                        customClassNames: (Te = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : Te.rollingLimit,
                        onChange: (Me) => {
                          r.setValue("periodCountCalendarDays", (Me == null ? void 0 : Me.value) === 1, {
                            shouldDirty: !0
                          });
                        }
                      }
                    ),
                    (u.disabled ? Q === ic.RANGE : !0) && /* @__PURE__ */ m(
                      SZl,
                      {
                        radioValue: ic.RANGE,
                        customClassNames: (Re = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : Re.rangeLimit,
                        isDisabled: u.disabled,
                        formMethods: r
                      }
                    )
                  ]
                }
              ) })
            }
          );
        }
      }
    ),
    r.getValues("offsetStart") > 0 && /* @__PURE__ */ m(
      Jo,
      {
        labelClassName: xe("text-sm", (F = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : F.label),
        toggleSwitchAtTheEnd: !0,
        switchContainerClassName: xe(
          "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
          p && "rounded-b-none",
          (P = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : P.container
        ),
        childrenClassName: xe("lg:ml-0", (O = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : O.children),
        title: n("offset_toggle"),
        descriptionClassName: (V = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : V.description,
        description: n("offset_toggle_description"),
        ...d,
        checked: p,
        onCheckedChange: (_e) => {
          g(_e), _e || r.setValue("offsetStart", 0, { shouldDirty: !0 });
        },
        children: /* @__PURE__ */ m("div", { className: xe("border-subtle rounded-b-lg border border-t-0 p-6"), children: /* @__PURE__ */ m(
          xr,
          {
            required: !0,
            type: "number",
            containerClassName: xe(
              "max-w-80",
              (H = (U = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : U.offsetInput) == null ? void 0 : H.container
            ),
            labelClassName: (le = (J = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : J.offsetInput) == null ? void 0 : le.label,
            addOnClassname: (Y = (ae = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : ae.offsetInput) == null ? void 0 : Y.addOn,
            className: (ie = (re = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : re.offsetInput) == null ? void 0 : ie.input,
            label: n("offset_start"),
            ...r.register("offsetStart", { setValueAs: (_e) => Number(_e) }),
            addOnSuffix: /* @__PURE__ */ m(nt, { children: n("minutes") }),
            hint: n("offset_start_description", {
              originalTime: h.toLocaleTimeString(o.language, { timeStyle: "short" }),
              adjustedTime: $.toLocaleTimeString(o.language, { timeStyle: "short" })
            })
          }
        ) })
      }
    )
  ] });
}, i6 = nT.map((e) => ({
  value: e,
  label: `Per ${O7l(e)}`
})), TZl = ({
  limitKey: e,
  step: t,
  value: n,
  textFieldSuffix: o,
  selectOptions: r,
  hasDeleteButton: i,
  disabled: a,
  onDelete: s,
  onLimitChange: c,
  onIntervalSelect: l,
  customClassNames: u
}) => {
  var d, _;
  return /* @__PURE__ */ de(
    "div",
    {
      "data-testid": "add-limit",
      className: xe(
        "mb-4 flex w-full min-w-0 items-center gap-x-2 text-sm rtl:space-x-reverse",
        u == null ? void 0 : u.container
      ),
      children: [
        /* @__PURE__ */ m(
          xr,
          {
            required: !0,
            type: "number",
            containerClassName: o ? "w-32 sm:w-44 -mb-1 shrink" : "w-14 sm:w-16 mb-0 shrink",
            className: xe("mb-0", u == null ? void 0 : u.limitText),
            placeholder: `${n}`,
            disabled: a,
            min: t,
            step: t,
            defaultValue: n,
            addOnSuffix: o,
            onChange: (p) => c(e, parseInt(p.target.value || "0", 10))
          }
        ),
        /* @__PURE__ */ m(
          Di,
          {
            options: r,
            isSearchable: !1,
            isDisabled: a,
            defaultValue: i6.find((p) => p.value === e),
            onChange: l,
            className: xe("w-36", (d = u == null ? void 0 : u.limitSelect) == null ? void 0 : d.select),
            innerClassNames: (_ = u == null ? void 0 : u.limitSelect) == null ? void 0 : _.innerClassNames
          }
        ),
        i && !a && /* @__PURE__ */ m(
          Jt,
          {
            variant: "icon",
            StartIcon: "trash-2",
            color: "destructive",
            className: xe("border-none", u == null ? void 0 : u.addLimitButton),
            onClick: () => s(e)
          }
        )
      ]
    },
    e
  );
}, pQ = ({
  propertyName: e,
  defaultLimit: t,
  step: n,
  textFieldSuffix: o,
  disabled: r,
  customClassNames: i
}) => {
  const { watch: a, setValue: s, control: c } = No(), l = a(e), { t: u } = kt(), [d] = qd();
  return /* @__PURE__ */ m(
    Bn,
    {
      name: e,
      control: c,
      render: ({ field: { value: _, onChange: p } }) => {
        const g = _, f = () => {
          if (!g || !l)
            return;
          const h = Object.keys(l), [$] = Object.values(i6).filter(
            (v) => !h.includes(v.value)
          );
          !$ || !h.length || s(
            e,
            // TODO: Remove @ts-ignore, type error no longer exists in later TS versions.
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            {
              ...l,
              [$.value]: t
            },
            { shouldDirty: !0 }
          );
        };
        return /* @__PURE__ */ de("ul", { ref: d, children: [
          g && l && Object.entries(g).sort(([h], [$]) => nT.indexOf(h) - nT.indexOf($)).map(([h, $]) => {
            const v = h;
            return /* @__PURE__ */ m(
              TZl,
              {
                limitKey: v,
                step: n,
                value: $,
                disabled: r,
                textFieldSuffix: o,
                hasDeleteButton: Object.keys(g).length > 1,
                selectOptions: i6.filter(
                  (b) => !Object.keys(g).includes(b.value)
                ),
                onLimitChange: (b, y) => (
                  // @ts-expect-error FIXME Fix these typings
                  s(`${e}.${b}`, y, { shouldDirty: !0 })
                ),
                onDelete: (b) => {
                  const y = g;
                  delete y[b], p(y);
                },
                onIntervalSelect: (b) => {
                  const y = g, w = l[v];
                  delete y[v];
                  const N = {
                    ...y,
                    // Set limit to new selected value (in the example above this means we set the limit to per_week here).
                    [b == null ? void 0 : b.value]: w
                  };
                  p(N);
                },
                customClassNames: i
              },
              h
            );
          }),
          g && Object.keys(g).length <= 3 && !r && /* @__PURE__ */ m(Jt, { color: "minimal", StartIcon: "plus", onClick: f, children: u("add_limit") })
        ] });
      }
    }
  );
}, AZl = (e) => /* @__PURE__ */ m(CZl, { ...e }), IZl = AZl, Mbe = Fe.createContext({
  getAppData: () => ({}),
  setAppData: () => ({})
}), Ssu = () => Fe.useContext(Mbe), OZl = Mbe;
function Fbe(e) {
  const { componentMap: t, slug: n, wrapperClassName: o, ...r } = e, i = n === "stripe" ? "stripepayment" : n;
  if (!t[i])
    return null;
  const a = t[i];
  return /* @__PURE__ */ m("div", { className: o || "", children: /* @__PURE__ */ m(a, { ...r }) });
}
const mQ = (e) => {
  const { app: t, getAppData: n, setAppData: o, LockedIcon: r, disabled: i, onAppInstallSuccess: a } = e;
  return /* @__PURE__ */ m(kme, { message: `There is some problem with ${t.name} App`, children: /* @__PURE__ */ m(OZl.Provider, { value: { getAppData: n, setAppData: o, LockedIcon: r, disabled: i }, children: /* @__PURE__ */ m(
    Fbe,
    {
      slug: t.slug === "stripe" ? "stripepayment" : t.slug,
      componentMap: vil,
      ...e,
      onAppInstallSuccess: a
    }
  ) }) });
}, NZl = () => {
  var a;
  const e = No(), t = ((a = e.watch("metadata")) == null ? void 0 : a.apps) || {}, n = (s) => {
    e.setValue(
      "metadata",
      {
        ...e.getValues("metadata"),
        apps: s
      },
      { shouldDirty: !0 }
    );
  }, o = (s) => function(c) {
    const l = t[s] || {};
    return c ? l[c] : l;
  }, r = e.getValues("metadata");
  return { getAppDataGetter: o, getAppDataSetter: (s, c, l) => function(u, d) {
    var g;
    const _ = ((g = e.getValues("metadata")) == null ? void 0 : g.apps) || {}, p = _[s];
    n({
      ..._,
      [s]: {
        ...p,
        [u]: d,
        credentialId: l,
        appCategories: c
      }
    });
  }, eventTypeFormMetadata: r };
}, zZl = NZl, fQ = "get-stripe-check", qbe = ({ teamId: e, onCheckError: t, initialData: n, onCheckSuccess: o }) => {
  var _, p;
  const { isInit: r, accessToken: i, organizationId: a } = cr(), s = qc();
  let c = "/stripe/check";
  e && a && (c = `/organizations/${a}/teams/${e}/stripe/check`);
  const {
    data: l,
    refetch: u,
    isLoading: d
  } = mr({
    queryKey: [fQ, e, a],
    enabled: r && !!i,
    queryFn: () => At == null ? void 0 : At.get(c).then(({ data: g }) => g.status === Nn ? (o == null || o(), { status: Nn, data: { allowConnect: !1, checked: !0 } }) : (t == null || t(g), { status: Ig, data: { allowConnect: !0, checked: !0 } })).catch((g) => (t == null || t(g), { status: Ig, data: { allowConnect: !0, checked: !0 } })),
    initialData: n
  });
  return {
    allowConnect: ((_ = l == null ? void 0 : l.data) == null ? void 0 : _.allowConnect) ?? !1,
    checked: ((p = l == null ? void 0 : l.data) == null ? void 0 : p.checked) ?? !1,
    refetch: () => {
      s.setQueryData([fQ, e, a], {
        status: Nn,
        data: { allowConnect: !1, checked: !1 }
      }), u();
    },
    isLoading: d
  };
}, RZl = (e, t, n) => {
  const { organizationId: o } = cr();
  let r = "/stripe/connect";
  n && o && (r = `/organizations/${o}/teams/${n}/stripe/connect`);
  const i = new URLSearchParams();
  e && i.append("returnTo", e), t && i.append("onErrorReturnTo", t);
  const a = i.toString() ? `${r}?${i.toString()}` : r;
  return mr({
    queryKey: ["get-stripe-connect-redirect-uri", n, o],
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => At == null ? void 0 : At.get(a).then(({ data: s }) => {
      if (s.status === Nn)
        return s.data.authUrl;
      if (s.status === Ig)
        throw new Error(s.error.message);
      return "";
    })
  });
}, PZl = (e, t, n) => {
  const { refetch: o } = RZl(e, t, n);
  return { connect: async () => {
    const i = await o();
    i.data && (window.location.href = i.data);
  } };
}, DZl = ({
  teamId: e,
  icon: t,
  color: n,
  isClickable: o,
  label: r,
  className: i,
  loadingLabel: a,
  alreadyConnectedLabel: s,
  redir: c,
  errorRedir: l,
  onCheckError: u,
  initialData: d,
  onCheckSuccess: _
}) => {
  const { t: p } = kt();
  let g = r || p("stripe_connect_atom_label");
  const { connect: f } = PZl(c, l, e), { allowConnect: h, checked: $, isLoading: v } = qbe({
    onCheckError: u,
    onCheckSuccess: _,
    initialData: d,
    teamId: e
  }), b = !$ || !h;
  return $ ? h || (g = s || p("stripe_connect_atom_already_connected_label")) : g = a || p("stripe_connect_atom_loading_label"), /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m(
    Jt,
    {
      StartIcon: t || "credit-card",
      color: n || "primary",
      disabled: o ? !1 : b,
      className: ar(
        "",
        "md:rounded-md",
        i,
        v && "animate-pulse bg-gray-200",
        b && "cursor-not-allowed",
        !b && "cursor-pointer"
      ),
      onClick: () => f(),
      children: g
    }
  ) });
}, LZl = "use-event-app-integration", MZl = (e, t) => {
  const n = `/atoms/event-types-app/${e}${t ? `?teamId=${t}` : ""}`, { isInit: o, accessToken: r } = cr();
  return mr({
    queryKey: [LZl, e],
    queryFn: () => At == null ? void 0 : At.get(n).then((i) => {
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error(i.data.error.message);
    }),
    enabled: !!e && o && !!r
  });
}, FZl = ({ eventType: e }) => {
  const { allowConnect: t, checked: n } = qbe({ teamId: e.teamId }), o = !n || !t;
  return n ? /* @__PURE__ */ m("div", { children: o ? /* @__PURE__ */ m(qZl, { eventType: e }) : /* @__PURE__ */ m(
    e$,
    {
      Icon: "grid-3x3",
      headline: "Stripe not connected",
      description: "You need to connect Stripe to use this feature. Please click on the button below to connect.",
      buttonRaw: /* @__PURE__ */ m(
        DZl,
        {
          teamId: e.teamId,
          label: "Connect to Stripe",
          loadingLabel: "Connect to Stripe",
          alreadyConnectedLabel: "Connect to Stripe",
          isClickable: !0,
          color: "secondary",
          redir: window.location.href
        }
      )
    }
  ) }) : /* @__PURE__ */ m("div", { children: "Checking..." });
}, qZl = ({ eventType: e }) => {
  const { getAppDataGetter: t, getAppDataSetter: n, eventTypeFormMetadata: o } = zZl(), { data: r, isLoading: i } = MZl("stripe", e.teamId), a = {
    ...r == null ? void 0 : r.app,
    logo: `https://app.cal.com${r == null ? void 0 : r.app.logo}`
  };
  if (i || !r)
    return null;
  if (a.teams && a.teams.length > 0) {
    const s = a.teams.find((c) => c.teamId === e.teamId);
    return s ? /* @__PURE__ */ m(
      mQ,
      {
        getAppData: t(a.slug),
        setAppData: n(
          a.slug,
          a.categories,
          s.credentialId
        ),
        app: {
          ...a,
          credentialOwner: {
            name: s.name,
            avatar: s.logoUrl,
            teamId: s.teamId,
            credentialId: s.credentialId
          }
        },
        eventType: e,
        eventTypeFormMetadata: o
      },
      (a.slug ?? r.app.slug) + s.credentialId
    ) : null;
  }
  return /* @__PURE__ */ m(
    mQ,
    {
      getAppData: t(a.slug),
      setAppData: n(
        a.slug,
        a.categories,
        a.userCredentialIds && a.userCredentialIds[0]
      ),
      app: a,
      eventType: e,
      eventTypeFormMetadata: o
    },
    a.slug
  );
}, jZl = FZl;
function VZl({
  eventType: e,
  paymentEnabled: t,
  customClassNames: n
}) {
  var _, p, g, f, h, $, v, b, y, w, N, M;
  const { t: o } = kt(), r = No(), [i, a] = it(
    r.getValues("recurringEvent")
  ), s = !!r.getValues("seatsPerTimeSlot"), c = !!r.getValues("maxActiveBookingsPerBooker"), l = Object.entries(jb).filter(([q, L]) => isNaN(Number(q)) && Number(L) < 3).map(([q, L]) => ({
    label: o(`${q.toString().toLowerCase()}`, { count: i == null ? void 0 : i.interval }),
    value: L.toString()
  })), { shouldLockDisableProps: u } = Bg({ eventType: e, translate: o, formMethods: r }), d = u("recurringEvent");
  return /* @__PURE__ */ m("div", { className: xe("block items-start sm:flex", n == null ? void 0 : n.container), children: /* @__PURE__ */ m("div", { className: t ? "" : "w-full", children: t ? /* @__PURE__ */ m(
    Us,
    {
      severity: "warning",
      className: n == null ? void 0 : n.paymentAlert,
      title: o("warning_payment_recurring_event")
    }
  ) : /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Us,
      {
        className: xe("mb-4", n == null ? void 0 : n.experimentalAlert),
        severity: "warning",
        title: "Experimental: Recurring Events are currently experimental and causes some issues sometimes when checking for availability. We are working on fixing this."
      }
    ),
    /* @__PURE__ */ m(
      Jo,
      {
        labelClassName: xe("text-sm", (_ = n == null ? void 0 : n.recurringToggle) == null ? void 0 : _.label),
        toggleSwitchAtTheEnd: !0,
        switchContainerClassName: xe(
          "border-subtle rounded-lg border py-6 px-4 sm:px-6",
          i !== null && "rounded-b-none",
          (p = n == null ? void 0 : n.recurringToggle) == null ? void 0 : p.container
        ),
        childrenClassName: xe("lg:ml-0", (g = n == null ? void 0 : n.recurringToggle) == null ? void 0 : g.children),
        descriptionClassName: (f = n == null ? void 0 : n.recurringToggle) == null ? void 0 : f.description,
        title: o("recurring_event"),
        ...d,
        description: o("recurring_event_description"),
        checked: !!i,
        "data-testid": "recurring-event-check",
        disabled: !i && s || c,
        tooltip: s ? o("seats_doesnt_support_recurring") : c ? o("booking_limit_per_booker_doesnt_support_recurring") : void 0,
        onCheckedChange: (q) => {
          if (!q)
            r.setValue("recurringEvent", null, { shouldDirty: !0 }), a(null);
          else {
            const L = e.recurringEvent || {
              interval: 1,
              count: 12,
              freq: jb.WEEKLY
            };
            r.setValue("recurringEvent", L, { shouldDirty: !0 }), a(L);
          }
        },
        children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: i && /* @__PURE__ */ de("div", { "data-testid": "recurring-event-collapsible", className: "text-sm", children: [
          /* @__PURE__ */ de("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              "p",
              {
                className: xe(
                  "text-emphasis ltr:mr-2 rtl:ml-2",
                  (h = n == null ? void 0 : n.frequencyInput) == null ? void 0 : h.label
                ),
                children: o("repeats_every")
              }
            ),
            /* @__PURE__ */ m(
              xr,
              {
                disabled: d.disabled,
                type: "number",
                min: "1",
                max: "20",
                className: xe("mb-0", ($ = n == null ? void 0 : n.frequencyInput) == null ? void 0 : $.input),
                defaultValue: i.interval,
                onChange: (q) => {
                  const L = {
                    ...i,
                    interval: parseInt(q == null ? void 0 : q.target.value)
                  };
                  r.setValue("recurringEvent", L, { shouldDirty: !0 }), a(L);
                }
              }
            ),
            /* @__PURE__ */ m(
              Di,
              {
                options: l,
                value: l[i.freq],
                isSearchable: !1,
                className: xe(
                  "w-18 ml-2 block min-w-0 rounded-md text-sm",
                  (v = n == null ? void 0 : n.frequencyUnitSelect) == null ? void 0 : v.select
                ),
                innerClassNames: (b = n == null ? void 0 : n.frequencyUnitSelect) == null ? void 0 : b.innerClassNames,
                isDisabled: d.disabled,
                onChange: (q) => {
                  const L = {
                    ...i,
                    freq: parseInt((q == null ? void 0 : q.value) || `${jb.WEEKLY}`)
                  };
                  r.setValue("recurringEvent", L, { shouldDirty: !0 }), a(L);
                }
              }
            )
          ] }),
          /* @__PURE__ */ de(
            "div",
            {
              className: xe(
                "mt-4 flex items-center",
                (y = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : y.container
              ),
              children: [
                /* @__PURE__ */ m(
                  "p",
                  {
                    className: xe(
                      "text-emphasis ltr:mr-2 rtl:ml-2",
                      (w = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : w.labelText
                    ),
                    children: o("for_a_maximum_of")
                  }
                ),
                /* @__PURE__ */ m(
                  xr,
                  {
                    disabled: d.disabled,
                    type: "number",
                    min: "1",
                    max: "24",
                    defaultValue: i.count,
                    className: xe("mb-0", (N = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : N.countInput),
                    onChange: (q) => {
                      const L = {
                        ...i,
                        count: parseInt(q == null ? void 0 : q.target.value)
                      };
                      r.setValue("recurringEvent", L, { shouldDirty: !0 }), a(L);
                    }
                  }
                ),
                /* @__PURE__ */ m(
                  "p",
                  {
                    className: xe(
                      "text-emphasis ltr:ml-2 rtl:mr-2",
                      (M = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : M.suffixText
                    ),
                    children: o("events", {
                      count: i.count
                    })
                  }
                )
              ]
            }
          )
        ] }) })
      }
    )
  ] }) }) });
}
const BZl = ({ eventType: e, customClassNames: t }) => {
  const o = Lg({
    ...e,
    metadata: kj.parse(e.metadata)
  }).price > 0;
  return /* @__PURE__ */ m(
    VZl,
    {
      paymentEnabled: o,
      eventType: e,
      customClassNames: t
    }
  );
}, UZl = (e) => /* @__PURE__ */ m(BZl, { ...e }), GZl = UZl, gQ = ({
  icon: e,
  label: t,
  value: n,
  customClassNames: o
}) => {
  const r = Kr(), i = (a) => {
    switch (a) {
      case "phone":
        return /* @__PURE__ */ m(qt, { name: "phone", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "userPhone":
        return /* @__PURE__ */ m(qt, { name: "phone", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "inPerson":
        return /* @__PURE__ */ m(qt, { name: "map-pin", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "attendeeInPerson":
        return /* @__PURE__ */ m(qt, { name: "map-pin", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "link":
        return /* @__PURE__ */ m(qt, { name: "link", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "somewhereElse":
        return /* @__PURE__ */ m(qt, { name: "map", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      default:
        return /* @__PURE__ */ m(qt, { name: "video", className: xe("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
    }
  };
  return r ? /* @__PURE__ */ de("div", { className: xe("flex items-center gap-3", o == null ? void 0 : o.optionWrapper), children: [
    i(n),
    /* @__PURE__ */ m("span", { className: xe("text-sm font-medium", o == null ? void 0 : o.optionLabel), children: t })
  ] }) : /* @__PURE__ */ de("div", { className: "flex items-center gap-3", children: [
    e && /* @__PURE__ */ m("img", { src: e, alt: "cover", className: xe("h-3.5 w-3.5", Wge(e)) }),
    /* @__PURE__ */ m("span", { className: xe(" text-sm font-medium"), children: t })
  ] });
};
function hQ({
  customClassNames: e,
  ...t
}) {
  const n = Kr();
  return /* @__PURE__ */ m(
    Di,
    {
      name: "location",
      id: "location-select",
      "data-testid": "location-select",
      components: {
        Option: (o) => /* @__PURE__ */ m(F_.Option, { ...o, children: /* @__PURE__ */ m("div", { "data-testid": `location-select-item-${o.data.value}`, children: /* @__PURE__ */ m(
          gQ,
          {
            icon: o.data.icon,
            label: o.data.label,
            value: o.data.value,
            customClassNames: e
          }
        ) }) }),
        SingleValue: (o) => /* @__PURE__ */ m(F_.SingleValue, { ...o, children: /* @__PURE__ */ m("div", { "data-testid": `location-select-item-${o.data.value}`, children: /* @__PURE__ */ m(
          gQ,
          {
            icon: o.data.icon,
            label: o.data.label,
            value: o.data.value,
            customClassNames: e
          }
        ) }) })
      },
      formatOptionLabel: (o, r) => /* @__PURE__ */ de("div", { className: "flex items-center gap-3", children: [
        o.icon && !n && /* @__PURE__ */ m(
          "img",
          {
            src: o.icon,
            alt: "app-icon",
            className: xe(o.icon.includes("-dark") && "dark:invert", "h-5 w-5")
          }
        ),
        /* @__PURE__ */ m("span", { children: o.label })
      ] }),
      formatGroupLabel: (o) => /* @__PURE__ */ m("p", { className: xe("text-default text-xs font-medium", e == null ? void 0 : e.groupLabel), children: o.label }),
      ...t
    }
  );
}
const WZl = ({ children: e }) => /* @__PURE__ */ m("div", { className: "bg-muted mt-2 space-y-2 rounded-lg p-4", children: /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m("div", { className: "flex flex-col gap-4", children: e }) }) }), jbe = WZl, HZl = ({ calVideoSettings: e }) => {
  var s;
  const { t } = kt(), n = No(), o = Kr(), [r, i] = it(!1), [a] = qd();
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(Sr, { content: "expandable", side: "right", className: "lg:hidden", children: /* @__PURE__ */ de(
      "button",
      {
        "aria-expanded": r,
        onClick: () => i(!r),
        className: xe(
          "todesktop:py-[7px] text-default group flex w-full items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
          "[&[aria-current='page']]:!bg-transparent",
          "[&[aria-current='page']]:text-emphasis mt-0.5 text-sm"
        ),
        children: [
          /* @__PURE__ */ m("span", { className: "hidden w-full justify-between truncate text-ellipsis lg:flex", children: t(r ? "hide_advanced_settings" : "show_advanced_settings") }),
          /* @__PURE__ */ m(qt, { name: r ? "chevron-up" : "chevron-down", className: "ml-auto h-4 w-4" })
        ]
      }
    ) }),
    /* @__PURE__ */ m("div", { ref: a, children: r && /* @__PURE__ */ de(jbe, { children: [
      /* @__PURE__ */ m(
        Bn,
        {
          name: "calVideoSettings.disableRecordingForGuests",
          defaultValue: !!(e != null && e.disableRecordingForGuests),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            Jo,
            {
              title: t("disable_recording_for_guests"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Bn,
        {
          name: "calVideoSettings.disableRecordingForOrganizer",
          defaultValue: !!(e != null && e.disableRecordingForOrganizer),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            Jo,
            {
              title: t("disable_recording_for_organizer"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      !o && /* @__PURE__ */ m(
        Bn,
        {
          name: "calVideoSettings.enableAutomaticRecordingForOrganizer",
          defaultValue: !!(e != null && e.enableAutomaticRecordingForOrganizer),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            Jo,
            {
              title: t("enable_automatic_recording"),
              labelClassName: "text-sm",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Bn,
        {
          name: "calVideoSettings.enableAutomaticTranscription",
          defaultValue: !!(e != null && e.enableAutomaticTranscription),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            Jo,
            {
              title: t("enable_automatic_transcription"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      !o && /* @__PURE__ */ m(
        Bn,
        {
          name: "calVideoSettings.disableTranscriptionForGuests",
          defaultValue: !!(e != null && e.disableTranscriptionForGuests),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            Jo,
            {
              title: t("disable_transcription_for_guests"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      !o && /* @__PURE__ */ m(
        Bn,
        {
          name: "calVideoSettings.disableTranscriptionForOrganizer",
          defaultValue: !!(e != null && e.disableTranscriptionForOrganizer),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            Jo,
            {
              title: t("disable_transcription_for_organizer"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(xh, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        xr,
        {
          label: t("enter_redirect_url_on_exit_description"),
          defaultValue: (e == null ? void 0 : e.redirectUrlOnExit) || "",
          "data-testid": "calVideoSettings.redirectUrlOnExit",
          containerClassName: "mt-4",
          className: "leading-6",
          ...n.register("calVideoSettings.redirectUrlOnExit", {
            setValueAs: (c) => !c || c.trim() === "" ? null : c
          })
        }
      ),
      /* @__PURE__ */ m(
        BA,
        {
          errors: (s = n.formState.errors) == null ? void 0 : s.calVideoSettings,
          name: "redirectUrlOnExit",
          className: xe("text-error text-sm"),
          as: "div",
          id: "calVideoSettings.redirectUrlOnExit-error"
        }
      )
    ] }) })
  ] });
}, YZl = HZl, KZl = (e) => {
  const { t } = kt(), { eventLocationType: n, index: o, customClassNames: r, disableLocationProp: i, label: a, ...s } = e;
  if (No(), (n == null ? void 0 : n.organizerInputType) === "text") {
    const { defaultValue: c, ...l } = s;
    return /* @__PURE__ */ m(
      Bn,
      {
        name: `locations.${o}.${n.defaultValueVariable}`,
        defaultValue: c,
        render: ({ field: { onChange: u, value: d } }) => /* @__PURE__ */ m(
          xr,
          {
            label: a ? t(a) : null,
            name: `locations[${o}].${n.defaultValueVariable}`,
            placeholder: t(n.organizerInputPlaceholder || ""),
            type: "text",
            required: !0,
            onChange: u,
            value: d,
            ...i ? { disabled: !0 } : {},
            className: xe("my-0", r == null ? void 0 : r.addressInput),
            ...l
          }
        )
      }
    );
  } else if ((n == null ? void 0 : n.organizerInputType) === "phone") {
    const { defaultValue: c, ...l } = s;
    return /* @__PURE__ */ m(
      Bn,
      {
        name: `locations.${o}.${n.defaultValueVariable}`,
        defaultValue: c,
        render: ({ field: { onChange: u, value: d } }) => /* @__PURE__ */ m(
          xhe,
          {
            required: !0,
            disabled: i,
            placeholder: t(n.organizerInputPlaceholder || ""),
            name: `locations[${o}].${n.defaultValueVariable}`,
            className: r == null ? void 0 : r.phoneInput,
            value: d,
            onChange: u,
            ...l
          }
        )
      }
    );
  }
  return null;
}, Vbe = KZl, ZZl = ({
  field: e,
  index: t,
  disableLocationProp: n,
  customClassNames: o
}) => {
  var d, _, p, g, f, h;
  const { t: r } = kt(), { getValues: i, control: a, formState: s } = No(), { update: c } = M0({
    control: a,
    name: "locations"
  }), l = e, u = Xl(e.type);
  return u ? /* @__PURE__ */ de(jbe, { children: [
    /* @__PURE__ */ m(
      Vbe,
      {
        label: "organizerInputLabel" in u ? u == null ? void 0 : u.organizerInputLabel : null,
        "data-testid": `${u.type}-location-input`,
        defaultValue: l ? l[u.defaultValueVariable] : void 0,
        eventLocationType: u,
        index: t,
        customClassNames: (d = o == null ? void 0 : o.organizerContactInput) == null ? void 0 : d.locationInput,
        disableLocationProp: n
      }
    ),
    /* @__PURE__ */ m(
      BA,
      {
        errors: (p = (_ = s.errors) == null ? void 0 : _.locations) == null ? void 0 : p[t],
        name: u.defaultValueVariable,
        className: xe(
          "text-error my-1 ml-6 text-sm",
          (g = o == null ? void 0 : o.organizerContactInput) == null ? void 0 : g.errorMessage
        ),
        as: "div",
        id: "location-error"
      }
    ),
    u.organizerInputType && /* @__PURE__ */ m(
      l2,
      {
        name: `locations[${t}].displayLocationPublicly`,
        "data-testid": "display-location",
        disabled: n,
        defaultChecked: l == null ? void 0 : l.displayLocationPublicly,
        description: r("display_location_label"),
        className: (h = (f = o == null ? void 0 : o.organizerContactInput) == null ? void 0 : f.publicDisplayCheckbox) == null ? void 0 : h.checkbox,
        onChange: ($) => {
          const v = i("locations")[t];
          c(t, {
            ...v,
            displayLocationPublicly: $.target.checked
          });
        },
        informationIconText: r("display_location_info_badge")
      }
    ),
    (u == null ? void 0 : u.supportsCustomLabel) && /* @__PURE__ */ m(
      xr,
      {
        label: r("location_custom_label_input_label"),
        name: `locations[${t}].customLabel`,
        type: "text",
        defaultValue: l == null ? void 0 : l.customLabel,
        onChange: ($) => {
          const v = i("locations")[t];
          c(t, {
            ...v,
            customLabel: $.target.value
          });
        }
      }
    )
  ] }) : null;
}, XZl = ZZl, JZl = (e, t) => {
  for (const n of t) {
    const o = n.options.find((r) => r.value === e);
    if (o)
      return o;
  }
}, QZl = ({
  eventType: e,
  locationOptions: t
}) => {
  const n = e.locations && e.locations.length > 0 && t.some((r) => r.options.find((i) => i.value === e.locations[0].type)), o = e.locations && e.locations.length > 0 && !n && {
    slug: e.locations[0].type.replace("integrations:", "").replace(":", "-").replace("_video", ""),
    name: e.locations[0].type.replace("integrations:", "").replace(":", " ").replace("_video", "").split(" ").map((r) => r[0].toUpperCase() + r.slice(1)).join(" ")
  };
  return { locationAvailable: n, locationDetails: o };
}, eXl = ({
  isChildrenManagedEventType: e,
  disableLocationProp: t,
  isManagedEventType: n,
  getValues: o,
  setValue: r,
  control: i,
  formState: a,
  team: s,
  eventType: c,
  prefillLocation: l,
  customClassNames: u,
  ...d
}) => {
  var S, E, x;
  const { t: _ } = kt(), {
    fields: p,
    append: g,
    remove: f,
    update: h
  } = M0({
    control: i,
    name: "locations"
  });
  No();
  const $ = d.locationOptions.map((k) => {
    const I = k.options.filter((z) => s != null && s.id ? !0 : z.label !== _("organizer_default_conferencing_app"));
    return {
      ...k,
      options: I
    };
  }), [v] = qd(), b = !!o("seatsPerTimeSlot"), y = ((S = o("locations")) == null ? void 0 : S.filter((k) => !!Xl(k.type))) || [], w = n ? (E = $.find((k) => k.label === _("default"))) == null ? void 0 : E.options[0] : void 0, { locationDetails: N, locationAvailable: M } = QZl({
    eventType: c,
    locationOptions: d.locationOptions
  }), [q, L] = it(!1), R = w || null, [T, D] = it(
    R
  );
  yt(() => {
    if (l) {
      const k = l.value;
      !y.find((z) => z.type === k) && !b && (g({
        type: k,
        credentialId: l == null ? void 0 : l.credentialId
      }), D(l));
    }
  }, [l, b]);
  const A = Kr();
  return /* @__PURE__ */ de("div", { className: xe("w-full", u == null ? void 0 : u.container), children: [
    /* @__PURE__ */ de("ul", { ref: v, className: xe("space-y-2"), children: [
      p.map((k, I) => {
        var V, U, H, J, le, ae, Y, re, ie;
        const z = Xl(k.type), F = k, P = k.type === "integrations:daily", O = JZl(k.type, $);
        return /* @__PURE__ */ de("li", { children: [
          /* @__PURE__ */ de("div", { className: "flex w-full items-center", children: [
            /* @__PURE__ */ m(
              hQ,
              {
                name: `locations[${I}].type`,
                placeholder: _("select"),
                options: $,
                isDisabled: t,
                defaultValue: O,
                isSearchable: !1,
                className: xe(
                  "block min-w-0 flex-1 rounded-sm text-sm",
                  (V = u == null ? void 0 : u.locationSelect) == null ? void 0 : V.selectWrapper
                ),
                customClassNames: u == null ? void 0 : u.locationSelect,
                menuPlacement: "auto",
                onChange: (_e) => {
                  if (L(!1), _e != null && _e.value) {
                    const he = _e.value, be = Xl(he);
                    if (!be)
                      return;
                    const Q = be.organizerInputType || !(y != null && y.find((ne) => ne.type === he)), me = (be == null ? void 0 : be.organizerInputType) === "text" && be.defaultValueVariable === "link";
                    Q ? h(I, {
                      type: he,
                      ..._e.credentialId && {
                        credentialId: _e.credentialId,
                        teamName: _e.teamName ?? void 0
                      },
                      ...me && {
                        link: ""
                      }
                    }) : (h(I, {
                      type: k.type,
                      ...k.credentialId && {
                        credentialId: k.credentialId,
                        teamName: k.teamName ?? void 0
                      }
                    }), ti(_("location_already_exists"), "warning"));
                  }
                }
              }
            ),
            !(t && e) && /* @__PURE__ */ m(
              "button",
              {
                "data-testid": `delete-locations.${I}.type`,
                className: xe("min-h-9 block h-9 px-2", u == null ? void 0 : u.removeLocationButton),
                type: "button",
                onClick: () => {
                  f(I);
                },
                "aria-label": _("remove"),
                children: /* @__PURE__ */ m("div", { className: "h-4 w-4", children: /* @__PURE__ */ m(
                  qt,
                  {
                    name: "x",
                    className: xe(
                      "border-l-1 hover:text-emphasis text-subtle h-4 w-4",
                      u == null ? void 0 : u.removeLocationIcon
                    )
                  }
                ) })
              }
            )
          ] }),
          P && !A && /* @__PURE__ */ m(YZl, {}),
          z != null && z.supportsCustomLabel && (z != null && z.type) ? /* @__PURE__ */ m(
            XZl,
            {
              field: k,
              index: I,
              disableLocationProp: t,
              customClassNames: u
            }
          ) : z != null && z.organizerInputType ? /* @__PURE__ */ de("div", { className: "mt-2 space-y-2", children: [
            /* @__PURE__ */ de("div", { className: "w-full", children: [
              /* @__PURE__ */ de("div", { className: "flex gap-2", children: [
                /* @__PURE__ */ m("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ m(qt, { name: "corner-down-right", className: "h-4 w-4" }) }),
                /* @__PURE__ */ m(
                  Vbe,
                  {
                    "data-testid": `${z.type}-location-input`,
                    defaultValue: F ? F[z.defaultValueVariable] : void 0,
                    eventLocationType: z,
                    index: I,
                    customClassNames: (U = u == null ? void 0 : u.organizerContactInput) == null ? void 0 : U.locationInput,
                    disableLocationProp: t
                  }
                )
              ] }),
              /* @__PURE__ */ m(
                BA,
                {
                  errors: (J = (H = a.errors) == null ? void 0 : H.locations) == null ? void 0 : J[I],
                  name: z.defaultValueVariable,
                  className: xe(
                    "text-error my-1 ml-6 text-sm",
                    (le = u == null ? void 0 : u.organizerContactInput) == null ? void 0 : le.errorMessage
                  ),
                  as: "div",
                  id: "location-error"
                }
              )
            ] }),
            /* @__PURE__ */ m(
              "div",
              {
                className: xe(
                  "ml-6",
                  (Y = (ae = u == null ? void 0 : u.organizerContactInput) == null ? void 0 : ae.publicDisplayCheckbox) == null ? void 0 : Y.container
                ),
                children: /* @__PURE__ */ m(
                  l2,
                  {
                    name: `locations[${I}].displayLocationPublicly`,
                    "data-testid": "display-location",
                    disabled: t,
                    defaultChecked: F == null ? void 0 : F.displayLocationPublicly,
                    description: _("display_location_label"),
                    className: (ie = (re = u == null ? void 0 : u.organizerContactInput) == null ? void 0 : re.publicDisplayCheckbox) == null ? void 0 : ie.checkbox,
                    onChange: (_e) => {
                      const he = o("locations")[I];
                      h(I, {
                        ...he,
                        displayLocationPublicly: _e.target.checked
                      });
                    },
                    informationIconText: _("display_location_info_badge")
                  }
                )
              }
            )
          ] }) : null
        ] }, k.id);
      }),
      (y.length === 0 || q) && /* @__PURE__ */ m("div", { className: "flex", children: /* @__PURE__ */ m(
        hQ,
        {
          defaultMenuIsOpen: q,
          placeholder: _("select"),
          options: $,
          value: T,
          isDisabled: t,
          defaultValue: w,
          isSearchable: !1,
          className: xe(
            "block w-full min-w-0 flex-1 rounded-sm text-sm",
            (x = u == null ? void 0 : u.locationSelect) == null ? void 0 : x.selectWrapper
          ),
          customClassNames: u == null ? void 0 : u.locationSelect,
          menuPlacement: "auto",
          onChange: (k) => {
            if (L(!1), k != null && k.value) {
              const I = k.value, z = Xl(I);
              if (!z)
                return;
              z.organizerInputType || !y.find((P) => P.type === I) ? (g({
                type: I,
                ...k.credentialId && {
                  credentialId: k.credentialId,
                  teamName: k.teamName ?? void 0
                }
              }), D(k)) : (ti(_("location_already_exists"), "warning"), D(null));
            }
          }
        }
      ) }),
      y.some(
        (k) => {
          var I;
          return k.type === nil && ((I = d.destinationCalendar) == null ? void 0 : I.integration) !== "google_calendar";
        }
      ) && /* @__PURE__ */ de("div", { className: "text-default flex items-center text-sm", children: [
        /* @__PURE__ */ m("div", { className: "mr-1.5 h-3 w-3", children: /* @__PURE__ */ m(qt, { name: "check", className: "h-3 w-3" }) }),
        /* @__PURE__ */ m("p", { className: "text-default text-sm", children: /* @__PURE__ */ m(
          Ld,
          {
            t: _,
            i18nKey: "event_type_requires_google_calendar",
            components: [
              /* @__PURE__ */ m(
                Ir,
                {
                  className: "cursor-pointer text-blue-500 underline",
                  href: "/apps/google-calendar",
                  children: "here"
                },
                "event_type_requires_google_calendar"
              )
            ]
          }
        ) })
      ] }),
      e && !M && N && /* @__PURE__ */ de("p", { className: "pl-1 text-sm leading-none text-red-600", children: [
        _("app_not_connected", { appName: N.name }),
        " ",
        /* @__PURE__ */ m("a", { className: "underline", href: `${Wa}/apps/${N.slug}`, children: _("connect_now") })
      ] }),
      y.length > 0 && !t && //  && !isChildrenManagedEventType : Add this to hide add-location button only when location is disabled by Admin
      /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
        Jt,
        {
          "data-testid": "add-location",
          StartIcon: "plus",
          color: "minimal",
          disabled: b,
          className: xe(u == null ? void 0 : u.addLocationButton),
          tooltip: b ? _("seats_option_doesnt_support_multi_location") : void 0,
          onClick: () => L(!0),
          children: _("add_location")
        }
      ) })
    ] }),
    d.showAppStoreLink && !A && /* @__PURE__ */ m("p", { className: "text-default mt-2 text-sm", children: /* @__PURE__ */ m(
      Ld,
      {
        t: _,
        i18nKey: "cant_find_the_right_conferencing_app_visit_our_app_store",
        components: [
          /* @__PURE__ */ m(
            Ir,
            {
              className: "cursor-pointer text-blue-500 underline",
              href: "/apps/categories/conferencing",
              children: "App Store"
            },
            "cant_find_the_right_conferencing_app_visit_our_app_store"
          )
        ]
      }
    ) })
  ] });
}, tXl = eXl, nXl = (e) => {
  var D, A, S, E, x, k, I, z, F, P, O, V, U, H, J, le, ae, Y, re, ie, _e, he, be, Q, me, ne, pe, ge, ve, Te, Re, Me, et, st, De, ze, Pe, je, He, Xe, at, wt, Je, vt, Ot, Ft, wn, un, pn, Dn, Rn, Ln, Yn, Qt, fn, qn, Xn, Qn, In;
  const { t } = kt(), n = Kr(), o = No(), { eventType: r, team: i, urlPrefix: a, hasOrgBranding: s, customClassNames: c, orgId: l } = e, [u, d] = it(
    (D = o.getValues("metadata")) == null ? void 0 : D.multipleDuration
  ), [_, p] = it(!0), g = o.watch("seatsPerTimeSlotEnabled"), f = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    50,
    60,
    75,
    80,
    90,
    120,
    150,
    180,
    240,
    300,
    360,
    420,
    480
  ].map(($n) => ({
    value: $n,
    label: t("multiple_duration_mins", { count: $n })
  })), [h, $] = it(f.filter(($n) => u == null ? void 0 : u.includes($n.value))), [v, b] = it(
    h.find(($n) => $n.value === o.getValues("length")) ?? null
  ), { isChildrenManagedEventType: y, isManagedEventType: w, shouldLockIndicator: N, shouldLockDisableProps: M } = Bg({ eventType: r, translate: t, formMethods: o }), q = M("length"), L = M("description"), R = M("slug"), T = M("title");
  return /* @__PURE__ */ m("div", { children: /* @__PURE__ */ de("div", { className: xe("space-y-4", c == null ? void 0 : c.wrapper), children: [
    /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "border-subtle space-y-6 rounded-lg border p-6",
          (A = c == null ? void 0 : c.titleSection) == null ? void 0 : A.container
        ),
        children: [
          /* @__PURE__ */ m(
            xr,
            {
              required: !0,
              containerClassName: xe((E = (S = c == null ? void 0 : c.titleSection) == null ? void 0 : S.titleInput) == null ? void 0 : E.container),
              labelClassName: xe((k = (x = c == null ? void 0 : c.titleSection) == null ? void 0 : x.titleInput) == null ? void 0 : k.label),
              className: xe((z = (I = c == null ? void 0 : c.titleSection) == null ? void 0 : I.titleInput) == null ? void 0 : z.input),
              label: t("title"),
              ...w || y ? T : {},
              defaultValue: r.title,
              "data-testid": "event-title",
              ...o.register("title")
            }
          ),
          /* @__PURE__ */ m("div", { children: n ? /* @__PURE__ */ m(
            Pde,
            {
              ...o.register("description", {
                disabled: L.disabled
              }),
              placeholder: t("quick_video_meeting"),
              className: (P = (F = c == null ? void 0 : c.titleSection) == null ? void 0 : F.descriptionInput) == null ? void 0 : P.input,
              labelProps: {
                className: (V = (O = c == null ? void 0 : c.titleSection) == null ? void 0 : O.descriptionInput) == null ? void 0 : V.label
              }
            }
          ) : /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ de(Ko, { htmlFor: "editor", children: [
              t("description"),
              (w || y) && N("description")
            ] }),
            /* @__PURE__ */ m(
              aV,
              {
                getText: () => t2.render(o.getValues("description") || ""),
                setText: ($n) => o.setValue("description", iV($n), { shouldDirty: !0 }),
                excludedToolbarItems: ["blockType"],
                placeholder: t("quick_video_meeting"),
                editable: !L.disabled,
                firstRender: _,
                setFirstRender: p
              }
            )
          ] }) }),
          /* @__PURE__ */ m(
            xr,
            {
              required: !0,
              label: n ? "Slug" : t("URL"),
              ...w || y ? R : {},
              defaultValue: r.slug,
              "data-testid": "event-slug",
              containerClassName: xe(
                "[&>div]:gap-0",
                (H = (U = c == null ? void 0 : c.titleSection) == null ? void 0 : U.urlInput) == null ? void 0 : H.container
              ),
              labelClassName: xe((le = (J = c == null ? void 0 : c.titleSection) == null ? void 0 : J.urlInput) == null ? void 0 : le.label),
              className: xe("pl-0", (Y = (ae = c == null ? void 0 : c.titleSection) == null ? void 0 : ae.urlInput) == null ? void 0 : Y.input),
              addOnLeading: n ? void 0 : /* @__PURE__ */ de(nt, { children: [
                a,
                "/",
                w ? t("username_placeholder") : i ? (s ? "" : "team/") + i.slug : o.getValues("users")[0].username,
                "/"
              ] }),
              ...o.register("slug", {
                setValueAs: ($n) => mF($n)
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "border-subtle rounded-lg border p-6",
          (re = c == null ? void 0 : c.durationSection) == null ? void 0 : re.container
        ),
        children: [
          u ? /* @__PURE__ */ de(
            "div",
            {
              className: xe(
                "space-y-6",
                (he = (_e = (ie = c == null ? void 0 : c.durationSection) == null ? void 0 : ie.multipleDuration) == null ? void 0 : _e.availableDurationsSelect) == null ? void 0 : he.container
              ),
              children: [
                /* @__PURE__ */ de("div", { children: [
                  /* @__PURE__ */ m(
                    Gl,
                    {
                      as: Ko,
                      loadingClassName: "w-16",
                      className: (me = (Q = (be = c == null ? void 0 : c.durationSection) == null ? void 0 : be.multipleDuration) == null ? void 0 : Q.availableDurationsSelect) == null ? void 0 : me.label,
                      children: t("available_durations")
                    }
                  ),
                  /* @__PURE__ */ m(
                    Di,
                    {
                      isMulti: !0,
                      defaultValue: h,
                      name: "metadata.multipleDuration",
                      isSearchable: !1,
                      isDisabled: q.disabled,
                      className: xe(
                        "h-auto !min-h-[36px] text-sm",
                        (ge = (pe = (ne = c == null ? void 0 : c.durationSection) == null ? void 0 : ne.multipleDuration) == null ? void 0 : pe.availableDurationsSelect) == null ? void 0 : ge.select
                      ),
                      innerClassNames: (Re = (Te = (ve = c == null ? void 0 : c.durationSection) == null ? void 0 : ve.multipleDuration) == null ? void 0 : Te.availableDurationsSelect) == null ? void 0 : Re.innerClassNames,
                      options: f,
                      value: h,
                      onChange: ($n) => {
                        let uo = [...$n];
                        uo = uo.sort((Rr, qo) => (Rr == null ? void 0 : Rr.value) - (qo == null ? void 0 : qo.value));
                        const go = uo.map((Rr) => Rr.value);
                        d(go), $(uo), uo.find((Rr) => Rr.value === (v == null ? void 0 : v.value)) || (uo.length > 0 ? (b(uo[0]), o.setValue("length", uo[0].value, { shouldDirty: !0 })) : b(null)), uo.length === 1 && v === null && (b(uo[0]), o.setValue("length", uo[0].value, { shouldDirty: !0 })), o.setValue("metadata.multipleDuration", go, { shouldDirty: !0 });
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ de(
                  "div",
                  {
                    className: (st = (et = (Me = c == null ? void 0 : c.durationSection) == null ? void 0 : Me.multipleDuration) == null ? void 0 : et.defaultDurationSelect) == null ? void 0 : st.container,
                    children: [
                      /* @__PURE__ */ de(
                        Gl,
                        {
                          as: Ko,
                          loadingClassName: "w-16",
                          className: (Pe = (ze = (De = c == null ? void 0 : c.durationSection) == null ? void 0 : De.multipleDuration) == null ? void 0 : ze.defaultDurationSelect) == null ? void 0 : Pe.label,
                          children: [
                            t("default_duration"),
                            N("length")
                          ]
                        }
                      ),
                      /* @__PURE__ */ m(
                        Di,
                        {
                          value: v,
                          isSearchable: !1,
                          name: "length",
                          className: xe(
                            "text-sm",
                            (Xe = (He = (je = c == null ? void 0 : c.durationSection) == null ? void 0 : je.multipleDuration) == null ? void 0 : He.defaultDurationSelect) == null ? void 0 : Xe.select
                          ),
                          innerClassNames: (Je = (wt = (at = c == null ? void 0 : c.durationSection) == null ? void 0 : at.multipleDuration) == null ? void 0 : wt.defaultDurationSelect) == null ? void 0 : Je.innerClassNames,
                          isDisabled: q.disabled,
                          noOptionsMessage: () => t("default_duration_no_options"),
                          options: h,
                          onChange: ($n) => {
                            b(
                              h.find((uo) => uo.value === ($n == null ? void 0 : $n.value)) ?? null
                            ), $n && o.setValue("length", $n.value, { shouldDirty: !0 });
                          }
                        }
                      )
                    ]
                  }
                )
              ]
            }
          ) : /* @__PURE__ */ m(
            xr,
            {
              required: !0,
              type: "number",
              containerClassName: xe(
                (Ot = (vt = c == null ? void 0 : c.durationSection) == null ? void 0 : vt.singleDurationInput) == null ? void 0 : Ot.container
              ),
              labelClassName: xe((wn = (Ft = c == null ? void 0 : c.durationSection) == null ? void 0 : Ft.singleDurationInput) == null ? void 0 : wn.label),
              className: xe((pn = (un = c == null ? void 0 : c.durationSection) == null ? void 0 : un.singleDurationInput) == null ? void 0 : pn.input),
              "data-testid": "duration",
              ...w || y ? q : {},
              label: t("duration"),
              defaultValue: o.getValues("length") ?? 15,
              ...o.register("length", {
                valueAsNumber: !0,
                min: {
                  value: Fb,
                  message: t("duration_min_error", { min: Fb })
                },
                max: {
                  value: Mb,
                  message: t("duration_max_error", { max: Mb })
                }
              }),
              addOnSuffix: /* @__PURE__ */ m(nt, { children: t("minutes") }),
              min: Fb,
              max: Mb
            }
          ),
          !q.disabled && /* @__PURE__ */ m("div", { className: "!mt-4 [&_label]:my-1 [&_label]:font-normal", children: /* @__PURE__ */ m(
            Jo,
            {
              title: t("allow_multiple_durations"),
              checked: u !== void 0,
              disabled: g,
              tooltip: g ? t("seat_options_doesnt_multiple_durations") : void 0,
              labelClassName: (Rn = (Dn = c == null ? void 0 : c.durationSection) == null ? void 0 : Dn.selectDurationToggle) == null ? void 0 : Rn.label,
              descriptionClassName: (Yn = (Ln = c == null ? void 0 : c.durationSection) == null ? void 0 : Ln.selectDurationToggle) == null ? void 0 : Yn.description,
              switchContainerClassName: (fn = (Qt = c == null ? void 0 : c.durationSection) == null ? void 0 : Qt.selectDurationToggle) == null ? void 0 : fn.container,
              childrenClassName: (Xn = (qn = c == null ? void 0 : c.durationSection) == null ? void 0 : qn.selectDurationToggle) == null ? void 0 : Xn.children,
              onCheckedChange: () => {
                u !== void 0 ? (d(void 0), $([]), b(null), o.setValue("metadata.multipleDuration", void 0, { shouldDirty: !0 }), o.setValue("length", r.length, { shouldDirty: !0 })) : (d([]), o.setValue("metadata.multipleDuration", [], { shouldDirty: !0 }), o.setValue("length", 0, { shouldDirty: !0 }));
              }
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ m(
      "div",
      {
        className: xe(
          "border-subtle rounded-lg border p-6",
          (Qn = c == null ? void 0 : c.locationSection) == null ? void 0 : Qn.container
        ),
        children: /* @__PURE__ */ de("div", { children: [
          /* @__PURE__ */ de(
            Gl,
            {
              as: Ko,
              loadingClassName: "w-16",
              htmlFor: "locations",
              className: (In = c == null ? void 0 : c.locationSection) == null ? void 0 : In.label,
              children: [
                t("location"),
                N("locations")
              ]
            }
          ),
          /* @__PURE__ */ m(
            Bn,
            {
              name: "locations",
              control: o.control,
              defaultValue: r.locations || [],
              render: () => /* @__PURE__ */ m(
                tXl,
                {
                  showAppStoreLink: !0,
                  isChildrenManagedEventType: y,
                  isManagedEventType: w,
                  disableLocationProp: M("locations").disabled,
                  getValues: o.getValues,
                  setValue: o.setValue,
                  control: o.control,
                  formState: o.formState,
                  ...e,
                  customClassNames: c == null ? void 0 : c.locationSection
                }
              )
            }
          )
        ] })
      }
    )
  ] }) });
}, oXl = (e) => /* @__PURE__ */ m(nXl, { ...e, urlPrefix: "", hasOrgBranding: !1 }), rXl = oXl, iXl = ({ ...e }) => /* @__PURE__ */ m(N$e, { ...e }), aXl = ({ ...e }) => (hr.useUtils().viewer.appRoutingForms.getAttributesForTeam.prefetch({
  teamId: e.teamId
}), /* @__PURE__ */ m(N$e, { ...e }));
var xg = {}, _P = {}, a6 = { exports: {} }, pP, vQ;
function cV() {
  if (vQ)
    return pP;
  vQ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return pP = e, pP;
}
var mP, bQ;
function sXl() {
  if (bQ)
    return mP;
  bQ = 1;
  var e = cV();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, mP = function() {
    function o(a, s, c, l, u, d) {
      if (d !== e) {
        var _ = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw _.name = "Invariant Violation", _;
      }
    }
    o.isRequired = o;
    function r() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, mP;
}
var kE = { exports: {} }, ci = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yQ;
function cXl() {
  return yQ || (yQ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function b(_e) {
      return typeof _e == "string" || typeof _e == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _e === o || _e === l || _e === i || _e === r || _e === d || _e === _ || typeof _e == "object" && _e !== null && (_e.$$typeof === g || _e.$$typeof === p || _e.$$typeof === a || _e.$$typeof === s || _e.$$typeof === u || _e.$$typeof === h || _e.$$typeof === $ || _e.$$typeof === v || _e.$$typeof === f);
    }
    function y(_e) {
      if (typeof _e == "object" && _e !== null) {
        var he = _e.$$typeof;
        switch (he) {
          case t:
            var be = _e.type;
            switch (be) {
              case c:
              case l:
              case o:
              case i:
              case r:
              case d:
                return be;
              default:
                var Q = be && be.$$typeof;
                switch (Q) {
                  case s:
                  case u:
                  case g:
                  case p:
                  case a:
                    return Q;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var w = c, N = l, M = s, q = a, L = t, R = u, T = o, D = g, A = p, S = n, E = i, x = r, k = d, I = !1;
    function z(_e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(_e) || y(_e) === c;
    }
    function F(_e) {
      return y(_e) === l;
    }
    function P(_e) {
      return y(_e) === s;
    }
    function O(_e) {
      return y(_e) === a;
    }
    function V(_e) {
      return typeof _e == "object" && _e !== null && _e.$$typeof === t;
    }
    function U(_e) {
      return y(_e) === u;
    }
    function H(_e) {
      return y(_e) === o;
    }
    function J(_e) {
      return y(_e) === g;
    }
    function le(_e) {
      return y(_e) === p;
    }
    function ae(_e) {
      return y(_e) === n;
    }
    function Y(_e) {
      return y(_e) === i;
    }
    function re(_e) {
      return y(_e) === r;
    }
    function ie(_e) {
      return y(_e) === d;
    }
    ci.AsyncMode = w, ci.ConcurrentMode = N, ci.ContextConsumer = M, ci.ContextProvider = q, ci.Element = L, ci.ForwardRef = R, ci.Fragment = T, ci.Lazy = D, ci.Memo = A, ci.Portal = S, ci.Profiler = E, ci.StrictMode = x, ci.Suspense = k, ci.isAsyncMode = z, ci.isConcurrentMode = F, ci.isContextConsumer = P, ci.isContextProvider = O, ci.isElement = V, ci.isForwardRef = U, ci.isFragment = H, ci.isLazy = J, ci.isMemo = le, ci.isPortal = ae, ci.isProfiler = Y, ci.isStrictMode = re, ci.isSuspense = ie, ci.isValidElementType = b, ci.typeOf = y;
  }()), ci;
}
var li = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $Q;
function lXl() {
  if ($Q)
    return li;
  $Q = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var N = w.$$typeof;
      switch (N) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case o:
            case i:
            case r:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case g:
                case p:
                case a:
                  return w;
                default:
                  return N;
              }
          }
        case n:
          return N;
      }
    }
  }
  function y(w) {
    return b(w) === l;
  }
  return li.AsyncMode = c, li.ConcurrentMode = l, li.ContextConsumer = s, li.ContextProvider = a, li.Element = t, li.ForwardRef = u, li.Fragment = o, li.Lazy = g, li.Memo = p, li.Portal = n, li.Profiler = i, li.StrictMode = r, li.Suspense = d, li.isAsyncMode = function(w) {
    return y(w) || b(w) === c;
  }, li.isConcurrentMode = y, li.isContextConsumer = function(w) {
    return b(w) === s;
  }, li.isContextProvider = function(w) {
    return b(w) === a;
  }, li.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, li.isForwardRef = function(w) {
    return b(w) === u;
  }, li.isFragment = function(w) {
    return b(w) === o;
  }, li.isLazy = function(w) {
    return b(w) === g;
  }, li.isMemo = function(w) {
    return b(w) === p;
  }, li.isPortal = function(w) {
    return b(w) === n;
  }, li.isProfiler = function(w) {
    return b(w) === i;
  }, li.isStrictMode = function(w) {
    return b(w) === r;
  }, li.isSuspense = function(w) {
    return b(w) === d;
  }, li.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === o || w === l || w === i || w === r || w === d || w === _ || typeof w == "object" && w !== null && (w.$$typeof === g || w.$$typeof === p || w.$$typeof === a || w.$$typeof === s || w.$$typeof === u || w.$$typeof === h || w.$$typeof === $ || w.$$typeof === v || w.$$typeof === f);
  }, li.typeOf = b, li;
}
var wQ;
function Bbe() {
  return wQ || (wQ = 1, process.env.NODE_ENV === "production" ? kE.exports = lXl() : kE.exports = cXl()), kE.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fP, kQ;
function uXl() {
  if (kQ)
    return fP;
  kQ = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fP = r() ? Object.assign : function(i, a) {
    for (var s, c = o(i), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (c[d] = s[d]);
      if (e) {
        l = e(s);
        for (var _ = 0; _ < l.length; _++)
          n.call(s, l[_]) && (c[l[_]] = s[l[_]]);
      }
    }
    return c;
  }, fP;
}
var gP, SQ;
function Ube() {
  return SQ || (SQ = 1, gP = Function.call.bind(Object.prototype.hasOwnProperty)), gP;
}
var hP, EQ;
function dXl() {
  if (EQ)
    return hP;
  EQ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = cV(), n = {}, o = Ube();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function r(i, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (o(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var _ = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw _.name = "Invariant Violation", _;
            }
            d = i[u](a, u, c, s, null, t);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var p = l ? l() : "";
            e(
              "Failed " + s + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, hP = r, hP;
}
var vP, xQ;
function _Xl() {
  if (xQ)
    return vP;
  xQ = 1;
  var e = Bbe(), t = uXl(), n = cV(), o = Ube(), r = dXl(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return vP = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(F) {
      var P = F && (l && F[l] || F[u]);
      if (typeof P == "function")
        return P;
    }
    var _ = "<<anonymous>>", p = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: v(),
      arrayOf: b,
      element: y(),
      elementType: w(),
      instanceOf: N,
      node: R(),
      objectOf: q,
      oneOf: M,
      oneOfType: L,
      shape: D,
      exact: A
    };
    function g(F, P) {
      return F === P ? F !== 0 || 1 / F === 1 / P : F !== F && P !== P;
    }
    function f(F, P) {
      this.message = F, this.data = P && typeof P == "object" ? P : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function h(F) {
      if (process.env.NODE_ENV !== "production")
        var P = {}, O = 0;
      function V(H, J, le, ae, Y, re, ie) {
        if (ae = ae || _, re = re || le, ie !== n) {
          if (c) {
            var _e = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw _e.name = "Invariant Violation", _e;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var he = ae + ":" + le;
            !P[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            O < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + re + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), P[he] = !0, O++);
          }
        }
        return J[le] == null ? H ? J[le] === null ? new f("The " + Y + " `" + re + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new f("The " + Y + " `" + re + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : F(J, le, ae, Y, re);
      }
      var U = V.bind(null, !1);
      return U.isRequired = V.bind(null, !0), U;
    }
    function $(F) {
      function P(O, V, U, H, J, le) {
        var ae = O[V], Y = x(ae);
        if (Y !== F) {
          var re = k(ae);
          return new f(
            "Invalid " + H + " `" + J + "` of type " + ("`" + re + "` supplied to `" + U + "`, expected ") + ("`" + F + "`."),
            { expectedType: F }
          );
        }
        return null;
      }
      return h(P);
    }
    function v() {
      return h(a);
    }
    function b(F) {
      function P(O, V, U, H, J) {
        if (typeof F != "function")
          return new f("Property `" + J + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var le = O[V];
        if (!Array.isArray(le)) {
          var ae = x(le);
          return new f("Invalid " + H + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + U + "`, expected an array."));
        }
        for (var Y = 0; Y < le.length; Y++) {
          var re = F(le, Y, U, H, J + "[" + Y + "]", n);
          if (re instanceof Error)
            return re;
        }
        return null;
      }
      return h(P);
    }
    function y() {
      function F(P, O, V, U, H) {
        var J = P[O];
        if (!s(J)) {
          var le = x(J);
          return new f("Invalid " + U + " `" + H + "` of type " + ("`" + le + "` supplied to `" + V + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(F);
    }
    function w() {
      function F(P, O, V, U, H) {
        var J = P[O];
        if (!e.isValidElementType(J)) {
          var le = x(J);
          return new f("Invalid " + U + " `" + H + "` of type " + ("`" + le + "` supplied to `" + V + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(F);
    }
    function N(F) {
      function P(O, V, U, H, J) {
        if (!(O[V] instanceof F)) {
          var le = F.name || _, ae = z(O[V]);
          return new f("Invalid " + H + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + U + "`, expected ") + ("instance of `" + le + "`."));
        }
        return null;
      }
      return h(P);
    }
    function M(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function P(O, V, U, H, J) {
        for (var le = O[V], ae = 0; ae < F.length; ae++)
          if (g(le, F[ae]))
            return null;
        var Y = JSON.stringify(F, function(ie, _e) {
          var he = k(_e);
          return he === "symbol" ? String(_e) : _e;
        });
        return new f("Invalid " + H + " `" + J + "` of value `" + String(le) + "` " + ("supplied to `" + U + "`, expected one of " + Y + "."));
      }
      return h(P);
    }
    function q(F) {
      function P(O, V, U, H, J) {
        if (typeof F != "function")
          return new f("Property `" + J + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var le = O[V], ae = x(le);
        if (ae !== "object")
          return new f("Invalid " + H + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + U + "`, expected an object."));
        for (var Y in le)
          if (o(le, Y)) {
            var re = F(le, Y, U, H, J + "." + Y, n);
            if (re instanceof Error)
              return re;
          }
        return null;
      }
      return h(P);
    }
    function L(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var P = 0; P < F.length; P++) {
        var O = F[P];
        if (typeof O != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + I(O) + " at index " + P + "."
          ), a;
      }
      function V(U, H, J, le, ae) {
        for (var Y = [], re = 0; re < F.length; re++) {
          var ie = F[re], _e = ie(U, H, J, le, ae, n);
          if (_e == null)
            return null;
          _e.data && o(_e.data, "expectedType") && Y.push(_e.data.expectedType);
        }
        var he = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new f("Invalid " + le + " `" + ae + "` supplied to " + ("`" + J + "`" + he + "."));
      }
      return h(V);
    }
    function R() {
      function F(P, O, V, U, H) {
        return S(P[O]) ? null : new f("Invalid " + U + " `" + H + "` supplied to " + ("`" + V + "`, expected a ReactNode."));
      }
      return h(F);
    }
    function T(F, P, O, V, U) {
      return new f(
        (F || "React class") + ": " + P + " type `" + O + "." + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function D(F) {
      function P(O, V, U, H, J) {
        var le = O[V], ae = x(le);
        if (ae !== "object")
          return new f("Invalid " + H + " `" + J + "` of type `" + ae + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var Y in F) {
          var re = F[Y];
          if (typeof re != "function")
            return T(U, H, J, Y, k(re));
          var ie = re(le, Y, U, H, J + "." + Y, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return h(P);
    }
    function A(F) {
      function P(O, V, U, H, J) {
        var le = O[V], ae = x(le);
        if (ae !== "object")
          return new f("Invalid " + H + " `" + J + "` of type `" + ae + "` " + ("supplied to `" + U + "`, expected `object`."));
        var Y = t({}, O[V], F);
        for (var re in Y) {
          var ie = F[re];
          if (o(F, re) && typeof ie != "function")
            return T(U, H, J, re, k(ie));
          if (!ie)
            return new f(
              "Invalid " + H + " `" + J + "` key `" + re + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(O[V], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(F), null, "  ")
            );
          var _e = ie(le, re, U, H, J + "." + re, n);
          if (_e)
            return _e;
        }
        return null;
      }
      return h(P);
    }
    function S(F) {
      switch (typeof F) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !F;
        case "object":
          if (Array.isArray(F))
            return F.every(S);
          if (F === null || s(F))
            return !0;
          var P = d(F);
          if (P) {
            var O = P.call(F), V;
            if (P !== F.entries) {
              for (; !(V = O.next()).done; )
                if (!S(V.value))
                  return !1;
            } else
              for (; !(V = O.next()).done; ) {
                var U = V.value;
                if (U && !S(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function E(F, P) {
      return F === "symbol" ? !0 : P ? P["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && P instanceof Symbol : !1;
    }
    function x(F) {
      var P = typeof F;
      return Array.isArray(F) ? "array" : F instanceof RegExp ? "object" : E(P, F) ? "symbol" : P;
    }
    function k(F) {
      if (typeof F > "u" || F === null)
        return "" + F;
      var P = x(F);
      if (P === "object") {
        if (F instanceof Date)
          return "date";
        if (F instanceof RegExp)
          return "regexp";
      }
      return P;
    }
    function I(F) {
      var P = k(F);
      switch (P) {
        case "array":
        case "object":
          return "an " + P;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + P;
        default:
          return P;
      }
    }
    function z(F) {
      return !F.constructor || !F.constructor.name ? _ : F.constructor.name;
    }
    return p.checkPropTypes = r, p.resetWarningCache = r.resetWarningCache, p.PropTypes = p, p;
  }, vP;
}
if (process.env.NODE_ENV !== "production") {
  var pXl = Bbe(), mXl = !0;
  a6.exports = _Xl()(pXl.isElement, mXl);
} else
  a6.exports = sXl()();
var Oa = a6.exports;
const vb = /* @__PURE__ */ Mi(Oa);
var bP = {}, yP = { exports: {} }, CQ;
function uc() {
  return CQ || (CQ = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(Dt, function() {
      var n = Array.prototype.slice;
      function o(G, ce) {
        ce && (G.prototype = Object.create(ce.prototype)), G.prototype.constructor = G;
      }
      function r(G) {
        return c(G) ? G : he(G);
      }
      o(i, r);
      function i(G) {
        return l(G) ? G : be(G);
      }
      o(a, r);
      function a(G) {
        return u(G) ? G : Q(G);
      }
      o(s, r);
      function s(G) {
        return c(G) && !d(G) ? G : me(G);
      }
      function c(G) {
        return !!(G && G[p]);
      }
      function l(G) {
        return !!(G && G[g]);
      }
      function u(G) {
        return !!(G && G[f]);
      }
      function d(G) {
        return l(G) || u(G);
      }
      function _(G) {
        return !!(G && G[h]);
      }
      r.isIterable = c, r.isKeyed = l, r.isIndexed = u, r.isAssociative = d, r.isOrdered = _, r.Keyed = i, r.Indexed = a, r.Set = s;
      var p = "@@__IMMUTABLE_ITERABLE__@@", g = "@@__IMMUTABLE_KEYED__@@", f = "@@__IMMUTABLE_INDEXED__@@", h = "@@__IMMUTABLE_ORDERED__@@", $ = "delete", v = 5, b = 1 << v, y = b - 1, w = {}, N = { value: !1 }, M = { value: !1 };
      function q(G) {
        return G.value = !1, G;
      }
      function L(G) {
        G && (G.value = !0);
      }
      function R() {
      }
      function T(G, ce) {
        ce = ce || 0;
        for (var Se = Math.max(0, G.length - ce), Ie = new Array(Se), Ae = 0; Ae < Se; Ae++)
          Ie[Ae] = G[Ae + ce];
        return Ie;
      }
      function D(G) {
        return G.size === void 0 && (G.size = G.__iterate(S)), G.size;
      }
      function A(G, ce) {
        if (typeof ce != "number") {
          var Se = ce >>> 0;
          if ("" + Se !== ce || Se === 4294967295)
            return NaN;
          ce = Se;
        }
        return ce < 0 ? D(G) + ce : ce;
      }
      function S() {
        return !0;
      }
      function E(G, ce, Se) {
        return (G === 0 || Se !== void 0 && G <= -Se) && (ce === void 0 || Se !== void 0 && ce >= Se);
      }
      function x(G, ce) {
        return I(G, ce, 0);
      }
      function k(G, ce) {
        return I(G, ce, ce);
      }
      function I(G, ce, Se) {
        return G === void 0 ? Se : G < 0 ? Math.max(0, ce + G) : ce === void 0 ? G : Math.min(ce, G);
      }
      var z = 0, F = 1, P = 2, O = typeof Symbol == "function" && Symbol.iterator, V = "@@iterator", U = O || V;
      function H(G) {
        this.next = G;
      }
      H.prototype.toString = function() {
        return "[Iterator]";
      }, H.KEYS = z, H.VALUES = F, H.ENTRIES = P, H.prototype.inspect = H.prototype.toSource = function() {
        return this.toString();
      }, H.prototype[U] = function() {
        return this;
      };
      function J(G, ce, Se, Ie) {
        var Ae = G === 0 ? ce : G === 1 ? Se : [ce, Se];
        return Ie ? Ie.value = Ae : Ie = {
          value: Ae,
          done: !1
        }, Ie;
      }
      function le() {
        return { value: void 0, done: !0 };
      }
      function ae(G) {
        return !!ie(G);
      }
      function Y(G) {
        return G && typeof G.next == "function";
      }
      function re(G) {
        var ce = ie(G);
        return ce && ce.call(G);
      }
      function ie(G) {
        var ce = G && (O && G[O] || G[V]);
        if (typeof ce == "function")
          return ce;
      }
      function _e(G) {
        return G && typeof G.length == "number";
      }
      o(he, r);
      function he(G) {
        return G == null ? et() : c(G) ? G.toSeq() : ze(G);
      }
      he.of = function() {
        return he(arguments);
      }, he.prototype.toSeq = function() {
        return this;
      }, he.prototype.toString = function() {
        return this.__toString("Seq {", "}");
      }, he.prototype.cacheResult = function() {
        return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
      }, he.prototype.__iterate = function(G, ce) {
        return je(this, G, ce, !0);
      }, he.prototype.__iterator = function(G, ce) {
        return He(this, G, ce, !0);
      }, o(be, he);
      function be(G) {
        return G == null ? et().toKeyedSeq() : c(G) ? l(G) ? G.toSeq() : G.fromEntrySeq() : st(G);
      }
      be.prototype.toKeyedSeq = function() {
        return this;
      }, o(Q, he);
      function Q(G) {
        return G == null ? et() : c(G) ? l(G) ? G.entrySeq() : G.toIndexedSeq() : De(G);
      }
      Q.of = function() {
        return Q(arguments);
      }, Q.prototype.toIndexedSeq = function() {
        return this;
      }, Q.prototype.toString = function() {
        return this.__toString("Seq [", "]");
      }, Q.prototype.__iterate = function(G, ce) {
        return je(this, G, ce, !1);
      }, Q.prototype.__iterator = function(G, ce) {
        return He(this, G, ce, !1);
      }, o(me, he);
      function me(G) {
        return (G == null ? et() : c(G) ? l(G) ? G.entrySeq() : G : De(G)).toSetSeq();
      }
      me.of = function() {
        return me(arguments);
      }, me.prototype.toSetSeq = function() {
        return this;
      }, he.isSeq = Re, he.Keyed = be, he.Set = me, he.Indexed = Q;
      var ne = "@@__IMMUTABLE_SEQ__@@";
      he.prototype[ne] = !0, o(pe, Q);
      function pe(G) {
        this._array = G, this.size = G.length;
      }
      pe.prototype.get = function(G, ce) {
        return this.has(G) ? this._array[A(this, G)] : ce;
      }, pe.prototype.__iterate = function(G, ce) {
        for (var Se = this._array, Ie = Se.length - 1, Ae = 0; Ae <= Ie; Ae++)
          if (G(Se[ce ? Ie - Ae : Ae], Ae, this) === !1)
            return Ae + 1;
        return Ae;
      }, pe.prototype.__iterator = function(G, ce) {
        var Se = this._array, Ie = Se.length - 1, Ae = 0;
        return new H(
          function() {
            return Ae > Ie ? le() : J(G, Ae, Se[ce ? Ie - Ae++ : Ae++]);
          }
        );
      }, o(ge, be);
      function ge(G) {
        var ce = Object.keys(G);
        this._object = G, this._keys = ce, this.size = ce.length;
      }
      ge.prototype.get = function(G, ce) {
        return ce !== void 0 && !this.has(G) ? ce : this._object[G];
      }, ge.prototype.has = function(G) {
        return this._object.hasOwnProperty(G);
      }, ge.prototype.__iterate = function(G, ce) {
        for (var Se = this._object, Ie = this._keys, Ae = Ie.length - 1, Ge = 0; Ge <= Ae; Ge++) {
          var Qe = Ie[ce ? Ae - Ge : Ge];
          if (G(Se[Qe], Qe, this) === !1)
            return Ge + 1;
        }
        return Ge;
      }, ge.prototype.__iterator = function(G, ce) {
        var Se = this._object, Ie = this._keys, Ae = Ie.length - 1, Ge = 0;
        return new H(function() {
          var Qe = Ie[ce ? Ae - Ge : Ge];
          return Ge++ > Ae ? le() : J(G, Qe, Se[Qe]);
        });
      }, ge.prototype[h] = !0, o(ve, Q);
      function ve(G) {
        this._iterable = G, this.size = G.length || G.size;
      }
      ve.prototype.__iterateUncached = function(G, ce) {
        if (ce)
          return this.cacheResult().__iterate(G, ce);
        var Se = this._iterable, Ie = re(Se), Ae = 0;
        if (Y(Ie))
          for (var Ge; !(Ge = Ie.next()).done && G(Ge.value, Ae++, this) !== !1; )
            ;
        return Ae;
      }, ve.prototype.__iteratorUncached = function(G, ce) {
        if (ce)
          return this.cacheResult().__iterator(G, ce);
        var Se = this._iterable, Ie = re(Se);
        if (!Y(Ie))
          return new H(le);
        var Ae = 0;
        return new H(function() {
          var Ge = Ie.next();
          return Ge.done ? Ge : J(G, Ae++, Ge.value);
        });
      }, o(Te, Q);
      function Te(G) {
        this._iterator = G, this._iteratorCache = [];
      }
      Te.prototype.__iterateUncached = function(G, ce) {
        if (ce)
          return this.cacheResult().__iterate(G, ce);
        for (var Se = this._iterator, Ie = this._iteratorCache, Ae = 0; Ae < Ie.length; )
          if (G(Ie[Ae], Ae++, this) === !1)
            return Ae;
        for (var Ge; !(Ge = Se.next()).done; ) {
          var Qe = Ge.value;
          if (Ie[Ae] = Qe, G(Qe, Ae++, this) === !1)
            break;
        }
        return Ae;
      }, Te.prototype.__iteratorUncached = function(G, ce) {
        if (ce)
          return this.cacheResult().__iterator(G, ce);
        var Se = this._iterator, Ie = this._iteratorCache, Ae = 0;
        return new H(function() {
          if (Ae >= Ie.length) {
            var Ge = Se.next();
            if (Ge.done)
              return Ge;
            Ie[Ae] = Ge.value;
          }
          return J(G, Ae, Ie[Ae++]);
        });
      };
      function Re(G) {
        return !!(G && G[ne]);
      }
      var Me;
      function et() {
        return Me || (Me = new pe([]));
      }
      function st(G) {
        var ce = Array.isArray(G) ? new pe(G).fromEntrySeq() : Y(G) ? new Te(G).fromEntrySeq() : ae(G) ? new ve(G).fromEntrySeq() : typeof G == "object" ? new ge(G) : void 0;
        if (!ce)
          throw new TypeError(
            "Expected Array or iterable object of [k, v] entries, or keyed object: " + G
          );
        return ce;
      }
      function De(G) {
        var ce = Pe(G);
        if (!ce)
          throw new TypeError(
            "Expected Array or iterable object of values: " + G
          );
        return ce;
      }
      function ze(G) {
        var ce = Pe(G) || typeof G == "object" && new ge(G);
        if (!ce)
          throw new TypeError(
            "Expected Array or iterable object of values, or keyed object: " + G
          );
        return ce;
      }
      function Pe(G) {
        return _e(G) ? new pe(G) : Y(G) ? new Te(G) : ae(G) ? new ve(G) : void 0;
      }
      function je(G, ce, Se, Ie) {
        var Ae = G._cache;
        if (Ae) {
          for (var Ge = Ae.length - 1, Qe = 0; Qe <= Ge; Qe++) {
            var gt = Ae[Se ? Ge - Qe : Qe];
            if (ce(gt[1], Ie ? gt[0] : Qe, G) === !1)
              return Qe + 1;
          }
          return Qe;
        }
        return G.__iterateUncached(ce, Se);
      }
      function He(G, ce, Se, Ie) {
        var Ae = G._cache;
        if (Ae) {
          var Ge = Ae.length - 1, Qe = 0;
          return new H(function() {
            var gt = Ae[Se ? Ge - Qe : Qe];
            return Qe++ > Ge ? le() : J(ce, Ie ? gt[0] : Qe - 1, gt[1]);
          });
        }
        return G.__iteratorUncached(ce, Se);
      }
      function Xe(G, ce) {
        return ce ? at(ce, G, "", { "": G }) : wt(G);
      }
      function at(G, ce, Se, Ie) {
        return Array.isArray(ce) ? G.call(Ie, Se, Q(ce).map(function(Ae, Ge) {
          return at(G, Ae, Ge, ce);
        })) : Je(ce) ? G.call(Ie, Se, be(ce).map(function(Ae, Ge) {
          return at(G, Ae, Ge, ce);
        })) : ce;
      }
      function wt(G) {
        return Array.isArray(G) ? Q(G).map(wt).toList() : Je(G) ? be(G).map(wt).toMap() : G;
      }
      function Je(G) {
        return G && (G.constructor === Object || G.constructor === void 0);
      }
      function vt(G, ce) {
        if (G === ce || G !== G && ce !== ce)
          return !0;
        if (!G || !ce)
          return !1;
        if (typeof G.valueOf == "function" && typeof ce.valueOf == "function") {
          if (G = G.valueOf(), ce = ce.valueOf(), G === ce || G !== G && ce !== ce)
            return !0;
          if (!G || !ce)
            return !1;
        }
        return !!(typeof G.equals == "function" && typeof ce.equals == "function" && G.equals(ce));
      }
      function Ot(G, ce) {
        if (G === ce)
          return !0;
        if (!c(ce) || G.size !== void 0 && ce.size !== void 0 && G.size !== ce.size || G.__hash !== void 0 && ce.__hash !== void 0 && G.__hash !== ce.__hash || l(G) !== l(ce) || u(G) !== u(ce) || _(G) !== _(ce))
          return !1;
        if (G.size === 0 && ce.size === 0)
          return !0;
        var Se = !d(G);
        if (_(G)) {
          var Ie = G.entries();
          return ce.every(function(Nt, Ct) {
            var Be = Ie.next().value;
            return Be && vt(Be[1], Nt) && (Se || vt(Be[0], Ct));
          }) && Ie.next().done;
        }
        var Ae = !1;
        if (G.size === void 0)
          if (ce.size === void 0)
            typeof G.cacheResult == "function" && G.cacheResult();
          else {
            Ae = !0;
            var Ge = G;
            G = ce, ce = Ge;
          }
        var Qe = !0, gt = ce.__iterate(function(Nt, Ct) {
          if (Se ? !G.has(Nt) : Ae ? !vt(Nt, G.get(Ct, w)) : !vt(G.get(Ct, w), Nt))
            return Qe = !1, !1;
        });
        return Qe && G.size === gt;
      }
      o(Ft, Q);
      function Ft(G, ce) {
        if (!(this instanceof Ft))
          return new Ft(G, ce);
        if (this._value = G, this.size = ce === void 0 ? 1 / 0 : Math.max(0, ce), this.size === 0) {
          if (wn)
            return wn;
          wn = this;
        }
      }
      Ft.prototype.toString = function() {
        return this.size === 0 ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
      }, Ft.prototype.get = function(G, ce) {
        return this.has(G) ? this._value : ce;
      }, Ft.prototype.includes = function(G) {
        return vt(this._value, G);
      }, Ft.prototype.slice = function(G, ce) {
        var Se = this.size;
        return E(G, ce, Se) ? this : new Ft(this._value, k(ce, Se) - x(G, Se));
      }, Ft.prototype.reverse = function() {
        return this;
      }, Ft.prototype.indexOf = function(G) {
        return vt(this._value, G) ? 0 : -1;
      }, Ft.prototype.lastIndexOf = function(G) {
        return vt(this._value, G) ? this.size : -1;
      }, Ft.prototype.__iterate = function(G, ce) {
        for (var Se = 0; Se < this.size; Se++)
          if (G(this._value, Se, this) === !1)
            return Se + 1;
        return Se;
      }, Ft.prototype.__iterator = function(G, ce) {
        var Se = this, Ie = 0;
        return new H(
          function() {
            return Ie < Se.size ? J(G, Ie++, Se._value) : le();
          }
        );
      }, Ft.prototype.equals = function(G) {
        return G instanceof Ft ? vt(this._value, G._value) : Ot(G);
      };
      var wn;
      function un(G, ce) {
        if (!G)
          throw new Error(ce);
      }
      o(pn, Q);
      function pn(G, ce, Se) {
        if (!(this instanceof pn))
          return new pn(G, ce, Se);
        if (un(Se !== 0, "Cannot step a Range by 0"), G = G || 0, ce === void 0 && (ce = 1 / 0), Se = Se === void 0 ? 1 : Math.abs(Se), ce < G && (Se = -Se), this._start = G, this._end = ce, this._step = Se, this.size = Math.max(0, Math.ceil((ce - G) / Se - 1) + 1), this.size === 0) {
          if (Dn)
            return Dn;
          Dn = this;
        }
      }
      pn.prototype.toString = function() {
        return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
      }, pn.prototype.get = function(G, ce) {
        return this.has(G) ? this._start + A(this, G) * this._step : ce;
      }, pn.prototype.includes = function(G) {
        var ce = (G - this._start) / this._step;
        return ce >= 0 && ce < this.size && ce === Math.floor(ce);
      }, pn.prototype.slice = function(G, ce) {
        return E(G, ce, this.size) ? this : (G = x(G, this.size), ce = k(ce, this.size), ce <= G ? new pn(0, 0) : new pn(this.get(G, this._end), this.get(ce, this._end), this._step));
      }, pn.prototype.indexOf = function(G) {
        var ce = G - this._start;
        if (ce % this._step === 0) {
          var Se = ce / this._step;
          if (Se >= 0 && Se < this.size)
            return Se;
        }
        return -1;
      }, pn.prototype.lastIndexOf = function(G) {
        return this.indexOf(G);
      }, pn.prototype.__iterate = function(G, ce) {
        for (var Se = this.size - 1, Ie = this._step, Ae = ce ? this._start + Se * Ie : this._start, Ge = 0; Ge <= Se; Ge++) {
          if (G(Ae, Ge, this) === !1)
            return Ge + 1;
          Ae += ce ? -Ie : Ie;
        }
        return Ge;
      }, pn.prototype.__iterator = function(G, ce) {
        var Se = this.size - 1, Ie = this._step, Ae = ce ? this._start + Se * Ie : this._start, Ge = 0;
        return new H(function() {
          var Qe = Ae;
          return Ae += ce ? -Ie : Ie, Ge > Se ? le() : J(G, Ge++, Qe);
        });
      }, pn.prototype.equals = function(G) {
        return G instanceof pn ? this._start === G._start && this._end === G._end && this._step === G._step : Ot(this, G);
      };
      var Dn;
      o(Rn, r);
      function Rn() {
        throw TypeError("Abstract");
      }
      o(Ln, Rn);
      function Ln() {
      }
      o(Yn, Rn);
      function Yn() {
      }
      o(Qt, Rn);
      function Qt() {
      }
      Rn.Keyed = Ln, Rn.Indexed = Yn, Rn.Set = Qt;
      var fn = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(ce, Se) {
        ce = ce | 0, Se = Se | 0;
        var Ie = ce & 65535, Ae = Se & 65535;
        return Ie * Ae + ((ce >>> 16) * Ae + Ie * (Se >>> 16) << 16 >>> 0) | 0;
      };
      function qn(G) {
        return G >>> 1 & 1073741824 | G & 3221225471;
      }
      function Xn(G) {
        if (G === !1 || G === null || G === void 0 || typeof G.valueOf == "function" && (G = G.valueOf(), G === !1 || G === null || G === void 0))
          return 0;
        if (G === !0)
          return 1;
        var ce = typeof G;
        if (ce === "number") {
          if (G !== G || G === 1 / 0)
            return 0;
          var Se = G | 0;
          for (Se !== G && (Se ^= G * 4294967295); G > 4294967295; )
            G /= 4294967295, Se ^= G;
          return qn(Se);
        }
        if (ce === "string")
          return G.length > an ? Qn(G) : In(G);
        if (typeof G.hashCode == "function")
          return G.hashCode();
        if (ce === "object")
          return $n(G);
        if (typeof G.toString == "function")
          return In(G.toString());
        throw new Error("Value type " + ce + " cannot be hashed.");
      }
      function Qn(G) {
        var ce = hn[G];
        return ce === void 0 && (ce = In(G), An === Gn && (An = 0, hn = {}), An++, hn[G] = ce), ce;
      }
      function In(G) {
        for (var ce = 0, Se = 0; Se < G.length; Se++)
          ce = 31 * ce + G.charCodeAt(Se) | 0;
        return qn(ce);
      }
      function $n(G) {
        var ce;
        if (qo && (ce = ho.get(G), ce !== void 0) || (ce = G[Kt], ce !== void 0) || !go && (ce = G.propertyIsEnumerable && G.propertyIsEnumerable[Kt], ce !== void 0 || (ce = Rr(G), ce !== void 0)))
          return ce;
        if (ce = ++Ut, Ut & 1073741824 && (Ut = 0), qo)
          ho.set(G, ce);
        else {
          if (uo !== void 0 && uo(G) === !1)
            throw new Error("Non-extensible objects are not allowed as keys.");
          if (go)
            Object.defineProperty(G, Kt, {
              enumerable: !1,
              configurable: !1,
              writable: !1,
              value: ce
            });
          else if (G.propertyIsEnumerable !== void 0 && G.propertyIsEnumerable === G.constructor.prototype.propertyIsEnumerable)
            G.propertyIsEnumerable = function() {
              return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            }, G.propertyIsEnumerable[Kt] = ce;
          else if (G.nodeType !== void 0)
            G[Kt] = ce;
          else
            throw new Error("Unable to set a non-enumerable property on object.");
        }
        return ce;
      }
      var uo = Object.isExtensible, go = function() {
        try {
          return Object.defineProperty({}, "@", {}), !0;
        } catch {
          return !1;
        }
      }();
      function Rr(G) {
        if (G && G.nodeType > 0)
          switch (G.nodeType) {
            case 1:
              return G.uniqueID;
            case 9:
              return G.documentElement && G.documentElement.uniqueID;
          }
      }
      var qo = typeof WeakMap == "function", ho;
      qo && (ho = /* @__PURE__ */ new WeakMap());
      var Ut = 0, Kt = "__immutablehash__";
      typeof Symbol == "function" && (Kt = Symbol(Kt));
      var an = 16, Gn = 255, An = 0, hn = {};
      function zn(G) {
        un(
          G !== 1 / 0,
          "Cannot perform this action with an infinite size."
        );
      }
      o(gn, Ln);
      function gn(G) {
        return G == null ? er() : kn(G) && !_(G) ? G : er().withMutations(function(ce) {
          var Se = i(G);
          zn(Se.size), Se.forEach(function(Ie, Ae) {
            return ce.set(Ae, Ie);
          });
        });
      }
      gn.of = function() {
        var G = n.call(arguments, 0);
        return er().withMutations(function(ce) {
          for (var Se = 0; Se < G.length; Se += 2) {
            if (Se + 1 >= G.length)
              throw new Error("Missing value for key: " + G[Se]);
            ce.set(G[Se], G[Se + 1]);
          }
        });
      }, gn.prototype.toString = function() {
        return this.__toString("Map {", "}");
      }, gn.prototype.get = function(G, ce) {
        return this._root ? this._root.get(0, void 0, G, ce) : ce;
      }, gn.prototype.set = function(G, ce) {
        return ya(this, G, ce);
      }, gn.prototype.setIn = function(G, ce) {
        return this.updateIn(G, w, function() {
          return ce;
        });
      }, gn.prototype.remove = function(G) {
        return ya(this, G, w);
      }, gn.prototype.deleteIn = function(G) {
        return this.updateIn(G, function() {
          return w;
        });
      }, gn.prototype.update = function(G, ce, Se) {
        return arguments.length === 1 ? G(this) : this.updateIn([G], ce, Se);
      }, gn.prototype.updateIn = function(G, ce, Se) {
        Se || (Se = ce, ce = void 0);
        var Ie = mi(
          this,
          lu(G),
          ce,
          Se
        );
        return Ie === w ? void 0 : Ie;
      }, gn.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : er();
      }, gn.prototype.merge = function() {
        return ji(this, void 0, arguments);
      }, gn.prototype.mergeWith = function(G) {
        var ce = n.call(arguments, 1);
        return ji(this, G, ce);
      }, gn.prototype.mergeIn = function(G) {
        var ce = n.call(arguments, 1);
        return this.updateIn(
          G,
          er(),
          function(Se) {
            return typeof Se.merge == "function" ? Se.merge.apply(Se, ce) : ce[ce.length - 1];
          }
        );
      }, gn.prototype.mergeDeep = function() {
        return ji(this, Ks, arguments);
      }, gn.prototype.mergeDeepWith = function(G) {
        var ce = n.call(arguments, 1);
        return ji(this, Or(G), ce);
      }, gn.prototype.mergeDeepIn = function(G) {
        var ce = n.call(arguments, 1);
        return this.updateIn(
          G,
          er(),
          function(Se) {
            return typeof Se.mergeDeep == "function" ? Se.mergeDeep.apply(Se, ce) : ce[ce.length - 1];
          }
        );
      }, gn.prototype.sort = function(G) {
        return fi(Kc(this, G));
      }, gn.prototype.sortBy = function(G, ce) {
        return fi(Kc(this, ce, G));
      }, gn.prototype.withMutations = function(G) {
        var ce = this.asMutable();
        return G(ce), ce.wasAltered() ? ce.__ensureOwner(this.__ownerID) : this;
      }, gn.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new R());
      }, gn.prototype.asImmutable = function() {
        return this.__ensureOwner();
      }, gn.prototype.wasAltered = function() {
        return this.__altered;
      }, gn.prototype.__iterator = function(G, ce) {
        return new Wt(this, G, ce);
      }, gn.prototype.__iterate = function(G, ce) {
        var Se = this, Ie = 0;
        return this._root && this._root.iterate(function(Ae) {
          return Ie++, G(Ae[1], Ae[0], Se);
        }, ce), Ie;
      }, gn.prototype.__ensureOwner = function(G) {
        return G === this.__ownerID ? this : G ? Jn(this.size, this._root, G, this.__hash) : (this.__ownerID = G, this.__altered = !1, this);
      };
      function kn(G) {
        return !!(G && G[dt]);
      }
      gn.isMap = kn;
      var dt = "@@__IMMUTABLE_MAP__@@", Pt = gn.prototype;
      Pt[dt] = !0, Pt[$] = Pt.remove, Pt.removeIn = Pt.deleteIn;
      function cn(G, ce) {
        this.ownerID = G, this.entries = ce;
      }
      cn.prototype.get = function(G, ce, Se, Ie) {
        for (var Ae = this.entries, Ge = 0, Qe = Ae.length; Ge < Qe; Ge++)
          if (vt(Se, Ae[Ge][0]))
            return Ae[Ge][1];
        return Ie;
      }, cn.prototype.update = function(G, ce, Se, Ie, Ae, Ge, Qe) {
        for (var gt = Ae === w, Nt = this.entries, Ct = 0, Be = Nt.length; Ct < Be && !vt(Ie, Nt[Ct][0]); Ct++)
          ;
        var We = Ct < Be;
        if (We ? Nt[Ct][1] === Ae : gt)
          return this;
        if (L(Qe), (gt || !We) && L(Ge), !(gt && Nt.length === 1)) {
          if (!We && !gt && Nt.length >= ep)
            return Q_(G, Nt, Ie, Ae);
          var mt = G && G === this.ownerID, Gt = mt ? Nt : T(Nt);
          return We ? gt ? Ct === Be - 1 ? Gt.pop() : Gt[Ct] = Gt.pop() : Gt[Ct] = [Ie, Ae] : Gt.push([Ie, Ae]), mt ? (this.entries = Gt, this) : new cn(G, Gt);
        }
      };
      function sn(G, ce, Se) {
        this.ownerID = G, this.bitmap = ce, this.nodes = Se;
      }
      sn.prototype.get = function(G, ce, Se, Ie) {
        ce === void 0 && (ce = Xn(Se));
        var Ae = 1 << ((G === 0 ? ce : ce >>> G) & y), Ge = this.bitmap;
        return Ge & Ae ? this.nodes[Gd(Ge & Ae - 1)].get(G + v, ce, Se, Ie) : Ie;
      }, sn.prototype.update = function(G, ce, Se, Ie, Ae, Ge, Qe) {
        Se === void 0 && (Se = Xn(Ie));
        var gt = (ce === 0 ? Se : Se >>> ce) & y, Nt = 1 << gt, Ct = this.bitmap, Be = (Ct & Nt) !== 0;
        if (!Be && Ae === w)
          return this;
        var We = Gd(Ct & Nt - 1), mt = this.nodes, Gt = Be ? mt[We] : void 0, on = Ai(Gt, G, ce + v, Se, Ie, Ae, Ge, Qe);
        if (on === Gt)
          return this;
        if (!Be && on && mt.length >= ss)
          return Pr(G, mt, Ct, gt, on);
        if (Be && !on && mt.length === 2 && Ka(mt[We ^ 1]))
          return mt[We ^ 1];
        if (Be && on && mt.length === 1 && Ka(on))
          return on;
        var no = G && G === this.ownerID, gr = Be ? on ? Ct : Ct ^ Nt : Ct | Nt, Xo = Be ? on ? Hc(mt, We, on, no) : Wd(mt, We, no) : iu(mt, We, on, no);
        return no ? (this.bitmap = gr, this.nodes = Xo, this) : new sn(G, gr, Xo);
      };
      function ao(G, ce, Se) {
        this.ownerID = G, this.count = ce, this.nodes = Se;
      }
      ao.prototype.get = function(G, ce, Se, Ie) {
        ce === void 0 && (ce = Xn(Se));
        var Ae = (G === 0 ? ce : ce >>> G) & y, Ge = this.nodes[Ae];
        return Ge ? Ge.get(G + v, ce, Se, Ie) : Ie;
      }, ao.prototype.update = function(G, ce, Se, Ie, Ae, Ge, Qe) {
        Se === void 0 && (Se = Xn(Ie));
        var gt = (ce === 0 ? Se : Se >>> ce) & y, Nt = Ae === w, Ct = this.nodes, Be = Ct[gt];
        if (Nt && !Be)
          return this;
        var We = Ai(Be, G, ce + v, Se, Ie, Ae, Ge, Qe);
        if (We === Be)
          return this;
        var mt = this.count;
        if (!Be)
          mt++;
        else if (!We && (mt--, mt < _c))
          return cm(G, Ct, mt, gt);
        var Gt = G && G === this.ownerID, on = Hc(Ct, gt, We, Gt);
        return Gt ? (this.count = mt, this.nodes = on, this) : new ao(G, mt, on);
      };
      function Ze(G, ce, Se) {
        this.ownerID = G, this.keyHash = ce, this.entries = Se;
      }
      Ze.prototype.get = function(G, ce, Se, Ie) {
        for (var Ae = this.entries, Ge = 0, Qe = Ae.length; Ge < Qe; Ge++)
          if (vt(Se, Ae[Ge][0]))
            return Ae[Ge][1];
        return Ie;
      }, Ze.prototype.update = function(G, ce, Se, Ie, Ae, Ge, Qe) {
        Se === void 0 && (Se = Xn(Ie));
        var gt = Ae === w;
        if (Se !== this.keyHash)
          return gt ? this : (L(Qe), L(Ge), Wc(this, G, ce, Se, [Ie, Ae]));
        for (var Nt = this.entries, Ct = 0, Be = Nt.length; Ct < Be && !vt(Ie, Nt[Ct][0]); Ct++)
          ;
        var We = Ct < Be;
        if (We ? Nt[Ct][1] === Ae : gt)
          return this;
        if (L(Qe), (gt || !We) && L(Ge), gt && Be === 2)
          return new bt(G, this.keyHash, Nt[Ct ^ 1]);
        var mt = G && G === this.ownerID, Gt = mt ? Nt : T(Nt);
        return We ? gt ? Ct === Be - 1 ? Gt.pop() : Gt[Ct] = Gt.pop() : Gt[Ct] = [Ie, Ae] : Gt.push([Ie, Ae]), mt ? (this.entries = Gt, this) : new Ze(G, this.keyHash, Gt);
      };
      function bt(G, ce, Se) {
        this.ownerID = G, this.keyHash = ce, this.entry = Se;
      }
      bt.prototype.get = function(G, ce, Se, Ie) {
        return vt(Se, this.entry[0]) ? this.entry[1] : Ie;
      }, bt.prototype.update = function(G, ce, Se, Ie, Ae, Ge, Qe) {
        var gt = Ae === w, Nt = vt(Ie, this.entry[0]);
        if (Nt ? Ae === this.entry[1] : gt)
          return this;
        if (L(Qe), gt) {
          L(Ge);
          return;
        }
        return Nt ? G && G === this.ownerID ? (this.entry[1] = Ae, this) : new bt(G, this.keyHash, [Ie, Ae]) : (L(Ge), Wc(this, G, ce, Xn(Ie), [Ie, Ae]));
      }, cn.prototype.iterate = Ze.prototype.iterate = function(G, ce) {
        for (var Se = this.entries, Ie = 0, Ae = Se.length - 1; Ie <= Ae; Ie++)
          if (G(Se[ce ? Ae - Ie : Ie]) === !1)
            return !1;
      }, sn.prototype.iterate = ao.prototype.iterate = function(G, ce) {
        for (var Se = this.nodes, Ie = 0, Ae = Se.length - 1; Ie <= Ae; Ie++) {
          var Ge = Se[ce ? Ae - Ie : Ie];
          if (Ge && Ge.iterate(G, ce) === !1)
            return !1;
        }
      }, bt.prototype.iterate = function(G, ce) {
        return G(this.entry);
      }, o(Wt, H);
      function Wt(G, ce, Se) {
        this._type = ce, this._reverse = Se, this._stack = G._root && It(G._root);
      }
      Wt.prototype.next = function() {
        for (var G = this._type, ce = this._stack; ce; ) {
          var Se = ce.node, Ie = ce.index++, Ae;
          if (Se.entry) {
            if (Ie === 0)
              return xn(G, Se.entry);
          } else if (Se.entries) {
            if (Ae = Se.entries.length - 1, Ie <= Ae)
              return xn(G, Se.entries[this._reverse ? Ae - Ie : Ie]);
          } else if (Ae = Se.nodes.length - 1, Ie <= Ae) {
            var Ge = Se.nodes[this._reverse ? Ae - Ie : Ie];
            if (Ge) {
              if (Ge.entry)
                return xn(G, Ge.entry);
              ce = this._stack = It(Ge, ce);
            }
            continue;
          }
          ce = this._stack = this._stack.__prev;
        }
        return le();
      };
      function xn(G, ce) {
        return J(G, ce[0], ce[1]);
      }
      function It(G, ce) {
        return {
          node: G,
          index: 0,
          __prev: ce
        };
      }
      function Jn(G, ce, Se, Ie) {
        var Ae = Object.create(Pt);
        return Ae.size = G, Ae._root = ce, Ae.__ownerID = Se, Ae.__hash = Ie, Ae.__altered = !1, Ae;
      }
      var ur;
      function er() {
        return ur || (ur = Jn(0));
      }
      function ya(G, ce, Se) {
        var Ie, Ae;
        if (G._root) {
          var Ge = q(N), Qe = q(M);
          if (Ie = Ai(G._root, G.__ownerID, 0, void 0, ce, Se, Ge, Qe), !Qe.value)
            return G;
          Ae = G.size + (Ge.value ? Se === w ? -1 : 1 : 0);
        } else {
          if (Se === w)
            return G;
          Ae = 1, Ie = new cn(G.__ownerID, [[ce, Se]]);
        }
        return G.__ownerID ? (G.size = Ae, G._root = Ie, G.__hash = void 0, G.__altered = !0, G) : Ie ? Jn(Ae, Ie) : er();
      }
      function Ai(G, ce, Se, Ie, Ae, Ge, Qe, gt) {
        return G ? G.update(ce, Se, Ie, Ae, Ge, Qe, gt) : Ge === w ? G : (L(gt), L(Qe), new bt(ce, Ie, [Ae, Ge]));
      }
      function Ka(G) {
        return G.constructor === bt || G.constructor === Ze;
      }
      function Wc(G, ce, Se, Ie, Ae) {
        if (G.keyHash === Ie)
          return new Ze(ce, Ie, [G.entry, Ae]);
        var Ge = (Se === 0 ? G.keyHash : G.keyHash >>> Se) & y, Qe = (Se === 0 ? Ie : Ie >>> Se) & y, gt, Nt = Ge === Qe ? [Wc(G, ce, Se + v, Ie, Ae)] : (gt = new bt(ce, Ie, Ae), Ge < Qe ? [G, gt] : [gt, G]);
        return new sn(ce, 1 << Ge | 1 << Qe, Nt);
      }
      function Q_(G, ce, Se, Ie) {
        G || (G = new R());
        for (var Ae = new bt(G, Xn(Se), [Se, Ie]), Ge = 0; Ge < ce.length; Ge++) {
          var Qe = ce[Ge];
          Ae = Ae.update(G, 0, void 0, Qe[0], Qe[1]);
        }
        return Ae;
      }
      function cm(G, ce, Se, Ie) {
        for (var Ae = 0, Ge = 0, Qe = new Array(Se), gt = 0, Nt = 1, Ct = ce.length; gt < Ct; gt++, Nt <<= 1) {
          var Be = ce[gt];
          Be !== void 0 && gt !== Ie && (Ae |= Nt, Qe[Ge++] = Be);
        }
        return new sn(G, Ae, Qe);
      }
      function Pr(G, ce, Se, Ie, Ae) {
        for (var Ge = 0, Qe = new Array(b), gt = 0; Se !== 0; gt++, Se >>>= 1)
          Qe[gt] = Se & 1 ? ce[Ge++] : void 0;
        return Qe[Ie] = Ae, new ao(G, Ge + 1, Qe);
      }
      function ji(G, ce, Se) {
        for (var Ie = [], Ae = 0; Ae < Se.length; Ae++) {
          var Ge = Se[Ae], Qe = i(Ge);
          c(Ge) || (Qe = Qe.map(function(gt) {
            return Xe(gt);
          })), Ie.push(Qe);
        }
        return Xr(G, ce, Ie);
      }
      function Ks(G, ce, Se) {
        return G && G.mergeDeep && c(ce) ? G.mergeDeep(ce) : vt(G, ce) ? G : ce;
      }
      function Or(G) {
        return function(ce, Se, Ie) {
          if (ce && ce.mergeDeepWith && c(Se))
            return ce.mergeDeepWith(G, Se);
          var Ae = G(ce, Se, Ie);
          return vt(ce, Ae) ? ce : Ae;
        };
      }
      function Xr(G, ce, Se) {
        return Se = Se.filter(function(Ie) {
          return Ie.size !== 0;
        }), Se.length === 0 ? G : G.size === 0 && !G.__ownerID && Se.length === 1 ? G.constructor(Se[0]) : G.withMutations(function(Ie) {
          for (var Ae = ce ? function(Qe, gt) {
            Ie.update(
              gt,
              w,
              function(Nt) {
                return Nt === w ? Qe : ce(Nt, Qe, gt);
              }
            );
          } : function(Qe, gt) {
            Ie.set(gt, Qe);
          }, Ge = 0; Ge < Se.length; Ge++)
            Se[Ge].forEach(Ae);
        });
      }
      function mi(G, ce, Se, Ie) {
        var Ae = G === w, Ge = ce.next();
        if (Ge.done) {
          var Qe = Ae ? Se : G, gt = Ie(Qe);
          return gt === Qe ? G : gt;
        }
        un(
          Ae || G && G.set,
          "invalid keyPath"
        );
        var Nt = Ge.value, Ct = Ae ? w : G.get(Nt, w), Be = mi(
          Ct,
          ce,
          Se,
          Ie
        );
        return Be === Ct ? G : Be === w ? G.remove(Nt) : (Ae ? er() : G).set(Nt, Be);
      }
      function Gd(G) {
        return G = G - (G >> 1 & 1431655765), G = (G & 858993459) + (G >> 2 & 858993459), G = G + (G >> 4) & 252645135, G = G + (G >> 8), G = G + (G >> 16), G & 127;
      }
      function Hc(G, ce, Se, Ie) {
        var Ae = Ie ? G : T(G);
        return Ae[ce] = Se, Ae;
      }
      function iu(G, ce, Se, Ie) {
        var Ae = G.length + 1;
        if (Ie && ce + 1 === Ae)
          return G[ce] = Se, G;
        for (var Ge = new Array(Ae), Qe = 0, gt = 0; gt < Ae; gt++)
          gt === ce ? (Ge[gt] = Se, Qe = -1) : Ge[gt] = G[gt + Qe];
        return Ge;
      }
      function Wd(G, ce, Se) {
        var Ie = G.length - 1;
        if (Se && ce === Ie)
          return G.pop(), G;
        for (var Ae = new Array(Ie), Ge = 0, Qe = 0; Qe < Ie; Qe++)
          Qe === ce && (Ge = 1), Ae[Qe] = G[Qe + Ge];
        return Ae;
      }
      var ep = b / 4, ss = b / 2, _c = b / 4;
      o(Co, Yn);
      function Co(G) {
        var ce = au();
        if (G == null)
          return ce;
        if (Hd(G))
          return G;
        var Se = a(G), Ie = Se.size;
        return Ie === 0 ? ce : (zn(Ie), Ie > 0 && Ie < b ? Sl(0, Ie, v, null, new Zs(Se.toArray())) : ce.withMutations(function(Ae) {
          Ae.setSize(Ie), Se.forEach(function(Ge, Qe) {
            return Ae.set(Qe, Ge);
          });
        }));
      }
      Co.of = function() {
        return this(arguments);
      }, Co.prototype.toString = function() {
        return this.__toString("List [", "]");
      }, Co.prototype.get = function(G, ce) {
        if (G = A(this, G), G >= 0 && G < this.size) {
          G += this._origin;
          var Se = Kd(this, G);
          return Se && Se.array[G & y];
        }
        return ce;
      }, Co.prototype.set = function(G, ce) {
        return tp(this, G, ce);
      }, Co.prototype.remove = function(G) {
        return this.has(G) ? G === 0 ? this.shift() : G === this.size - 1 ? this.pop() : this.splice(G, 1) : this;
      }, Co.prototype.insert = function(G, ce) {
        return this.splice(G, 0, ce);
      }, Co.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = v, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : au();
      }, Co.prototype.push = function() {
        var G = arguments, ce = this.size;
        return this.withMutations(function(Se) {
          Cs(Se, 0, ce + G.length);
          for (var Ie = 0; Ie < G.length; Ie++)
            Se.set(ce + Ie, G[Ie]);
        });
      }, Co.prototype.pop = function() {
        return Cs(this, 0, -1);
      }, Co.prototype.unshift = function() {
        var G = arguments;
        return this.withMutations(function(ce) {
          Cs(ce, -G.length);
          for (var Se = 0; Se < G.length; Se++)
            ce.set(Se, G[Se]);
        });
      }, Co.prototype.shift = function() {
        return Cs(this, 1);
      }, Co.prototype.merge = function() {
        return Zd(this, void 0, arguments);
      }, Co.prototype.mergeWith = function(G) {
        var ce = n.call(arguments, 1);
        return Zd(this, G, ce);
      }, Co.prototype.mergeDeep = function() {
        return Zd(this, Ks, arguments);
      }, Co.prototype.mergeDeepWith = function(G) {
        var ce = n.call(arguments, 1);
        return Zd(this, Or(G), ce);
      }, Co.prototype.setSize = function(G) {
        return Cs(this, 0, G);
      }, Co.prototype.slice = function(G, ce) {
        var Se = this.size;
        return E(G, ce, Se) ? this : Cs(
          this,
          x(G, Se),
          k(ce, Se)
        );
      }, Co.prototype.__iterator = function(G, ce) {
        var Se = 0, Ie = Ju(this, ce);
        return new H(function() {
          var Ae = Ie();
          return Ae === cs ? le() : J(G, Se++, Ae);
        });
      }, Co.prototype.__iterate = function(G, ce) {
        for (var Se = 0, Ie = Ju(this, ce), Ae; (Ae = Ie()) !== cs && G(Ae, Se++, this) !== !1; )
          ;
        return Se;
      }, Co.prototype.__ensureOwner = function(G) {
        return G === this.__ownerID ? this : G ? Sl(this._origin, this._capacity, this._level, this._root, this._tail, G, this.__hash) : (this.__ownerID = G, this);
      };
      function Hd(G) {
        return !!(G && G[xs]);
      }
      Co.isList = Hd;
      var xs = "@@__IMMUTABLE_LIST__@@", ea = Co.prototype;
      ea[xs] = !0, ea[$] = ea.remove, ea.setIn = Pt.setIn, ea.deleteIn = ea.removeIn = Pt.removeIn, ea.update = Pt.update, ea.updateIn = Pt.updateIn, ea.mergeIn = Pt.mergeIn, ea.mergeDeepIn = Pt.mergeDeepIn, ea.withMutations = Pt.withMutations, ea.asMutable = Pt.asMutable, ea.asImmutable = Pt.asImmutable, ea.wasAltered = Pt.wasAltered;
      function Zs(G, ce) {
        this.array = G, this.ownerID = ce;
      }
      Zs.prototype.removeBefore = function(G, ce, Se) {
        if (Se === ce ? 1 << ce : this.array.length === 0)
          return this;
        var Ie = Se >>> ce & y;
        if (Ie >= this.array.length)
          return new Zs([], G);
        var Ae = Ie === 0, Ge;
        if (ce > 0) {
          var Qe = this.array[Ie];
          if (Ge = Qe && Qe.removeBefore(G, ce - v, Se), Ge === Qe && Ae)
            return this;
        }
        if (Ae && !Ge)
          return this;
        var gt = su(this, G);
        if (!Ae)
          for (var Nt = 0; Nt < Ie; Nt++)
            gt.array[Nt] = void 0;
        return Ge && (gt.array[Ie] = Ge), gt;
      }, Zs.prototype.removeAfter = function(G, ce, Se) {
        if (Se === (ce ? 1 << ce : 0) || this.array.length === 0)
          return this;
        var Ie = Se - 1 >>> ce & y;
        if (Ie >= this.array.length)
          return this;
        var Ae;
        if (ce > 0) {
          var Ge = this.array[Ie];
          if (Ae = Ge && Ge.removeAfter(G, ce - v, Se), Ae === Ge && Ie === this.array.length - 1)
            return this;
        }
        var Qe = su(this, G);
        return Qe.array.splice(Ie + 1), Ae && (Qe.array[Ie] = Ae), Qe;
      };
      var cs = {};
      function Ju(G, ce) {
        var Se = G._origin, Ie = G._capacity, Ae = Yc(Ie), Ge = G._tail;
        return Qe(G._root, G._level, 0);
        function Qe(Ct, Be, We) {
          return Be === 0 ? gt(Ct, We) : Nt(Ct, Be, We);
        }
        function gt(Ct, Be) {
          var We = Be === Ae ? Ge && Ge.array : Ct && Ct.array, mt = Be > Se ? 0 : Se - Be, Gt = Ie - Be;
          return Gt > b && (Gt = b), function() {
            if (mt === Gt)
              return cs;
            var on = ce ? --Gt : mt++;
            return We && We[on];
          };
        }
        function Nt(Ct, Be, We) {
          var mt, Gt = Ct && Ct.array, on = We > Se ? 0 : Se - We >> Be, no = (Ie - We >> Be) + 1;
          return no > b && (no = b), function() {
            do {
              if (mt) {
                var gr = mt();
                if (gr !== cs)
                  return gr;
                mt = null;
              }
              if (on === no)
                return cs;
              var Xo = ce ? --no : on++;
              mt = Qe(
                Gt && Gt[Xo],
                Be - v,
                We + (Xo << Be)
              );
            } while (!0);
          };
        }
      }
      function Sl(G, ce, Se, Ie, Ae, Ge, Qe) {
        var gt = Object.create(ea);
        return gt.size = ce - G, gt._origin = G, gt._capacity = ce, gt._level = Se, gt._root = Ie, gt._tail = Ae, gt.__ownerID = Ge, gt.__hash = Qe, gt.__altered = !1, gt;
      }
      var Qu;
      function au() {
        return Qu || (Qu = Sl(0, 0, v));
      }
      function tp(G, ce, Se) {
        if (ce = A(G, ce), ce !== ce)
          return G;
        if (ce >= G.size || ce < 0)
          return G.withMutations(function(Qe) {
            ce < 0 ? Cs(Qe, ce).set(0, Se) : Cs(Qe, 0, ce + 1).set(ce, Se);
          });
        ce += G._origin;
        var Ie = G._tail, Ae = G._root, Ge = q(M);
        return ce >= Yc(G._capacity) ? Ie = Yd(Ie, G.__ownerID, 0, ce, Se, Ge) : Ae = Yd(Ae, G.__ownerID, G._level, ce, Se, Ge), Ge.value ? G.__ownerID ? (G._root = Ae, G._tail = Ie, G.__hash = void 0, G.__altered = !0, G) : Sl(G._origin, G._capacity, G._level, Ae, Ie) : G;
      }
      function Yd(G, ce, Se, Ie, Ae, Ge) {
        var Qe = Ie >>> Se & y, gt = G && Qe < G.array.length;
        if (!gt && Ae === void 0)
          return G;
        var Nt;
        if (Se > 0) {
          var Ct = G && G.array[Qe], Be = Yd(Ct, ce, Se - v, Ie, Ae, Ge);
          return Be === Ct ? G : (Nt = su(G, ce), Nt.array[Qe] = Be, Nt);
        }
        return gt && G.array[Qe] === Ae ? G : (L(Ge), Nt = su(G, ce), Ae === void 0 && Qe === Nt.array.length - 1 ? Nt.array.pop() : Nt.array[Qe] = Ae, Nt);
      }
      function su(G, ce) {
        return ce && G && ce === G.ownerID ? G : new Zs(G ? G.array.slice() : [], ce);
      }
      function Kd(G, ce) {
        if (ce >= Yc(G._capacity))
          return G._tail;
        if (ce < 1 << G._level + v) {
          for (var Se = G._root, Ie = G._level; Se && Ie > 0; )
            Se = Se.array[ce >>> Ie & y], Ie -= v;
          return Se;
        }
      }
      function Cs(G, ce, Se) {
        ce !== void 0 && (ce = ce | 0), Se !== void 0 && (Se = Se | 0);
        var Ie = G.__ownerID || new R(), Ae = G._origin, Ge = G._capacity, Qe = Ae + ce, gt = Se === void 0 ? Ge : Se < 0 ? Ge + Se : Ae + Se;
        if (Qe === Ae && gt === Ge)
          return G;
        if (Qe >= gt)
          return G.clear();
        for (var Nt = G._level, Ct = G._root, Be = 0; Qe + Be < 0; )
          Ct = new Zs(Ct && Ct.array.length ? [void 0, Ct] : [], Ie), Nt += v, Be += 1 << Nt;
        Be && (Qe += Be, Ae += Be, gt += Be, Ge += Be);
        for (var We = Yc(Ge), mt = Yc(gt); mt >= 1 << Nt + v; )
          Ct = new Zs(Ct && Ct.array.length ? [Ct] : [], Ie), Nt += v;
        var Gt = G._tail, on = mt < We ? Kd(G, gt - 1) : mt > We ? new Zs([], Ie) : Gt;
        if (Gt && mt > We && Qe < Ge && Gt.array.length) {
          Ct = su(Ct, Ie);
          for (var no = Ct, gr = Nt; gr > v; gr -= v) {
            var Xo = We >>> gr & y;
            no = no.array[Xo] = su(no.array[Xo], Ie);
          }
          no.array[We >>> v & y] = Gt;
        }
        if (gt < Ge && (on = on && on.removeAfter(Ie, 0, gt)), Qe >= mt)
          Qe -= mt, gt -= mt, Nt = v, Ct = null, on = on && on.removeBefore(Ie, 0, Qe);
        else if (Qe > Ae || mt < We) {
          for (Be = 0; Ct; ) {
            var fc = Qe >>> Nt & y;
            if (fc !== mt >>> Nt & y)
              break;
            fc && (Be += (1 << Nt) * fc), Nt -= v, Ct = Ct.array[fc];
          }
          Ct && Qe > Ae && (Ct = Ct.removeBefore(Ie, Nt, Qe - Be)), Ct && mt < We && (Ct = Ct.removeAfter(Ie, Nt, mt - Be)), Be && (Qe -= Be, gt -= Be);
        }
        return G.__ownerID ? (G.size = gt - Qe, G._origin = Qe, G._capacity = gt, G._level = Nt, G._root = Ct, G._tail = on, G.__hash = void 0, G.__altered = !0, G) : Sl(Qe, gt, Nt, Ct, on);
      }
      function Zd(G, ce, Se) {
        for (var Ie = [], Ae = 0, Ge = 0; Ge < Se.length; Ge++) {
          var Qe = Se[Ge], gt = a(Qe);
          gt.size > Ae && (Ae = gt.size), c(Qe) || (gt = gt.map(function(Nt) {
            return Xe(Nt);
          })), Ie.push(gt);
        }
        return Ae > G.size && (G = G.setSize(Ae)), Xr(G, ce, Ie);
      }
      function Yc(G) {
        return G < b ? 0 : G - 1 >>> v << v;
      }
      o(fi, gn);
      function fi(G) {
        return G == null ? Jd() : pc(G) ? G : Jd().withMutations(function(ce) {
          var Se = i(G);
          zn(Se.size), Se.forEach(function(Ie, Ae) {
            return ce.set(Ae, Ie);
          });
        });
      }
      fi.of = function() {
        return this(arguments);
      }, fi.prototype.toString = function() {
        return this.__toString("OrderedMap {", "}");
      }, fi.prototype.get = function(G, ce) {
        var Se = this._map.get(G);
        return Se !== void 0 ? this._list.get(Se)[1] : ce;
      }, fi.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : Jd();
      }, fi.prototype.set = function(G, ce) {
        return Dr(this, G, ce);
      }, fi.prototype.remove = function(G) {
        return Dr(this, G, w);
      }, fi.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
      }, fi.prototype.__iterate = function(G, ce) {
        var Se = this;
        return this._list.__iterate(
          function(Ie) {
            return Ie && G(Ie[1], Ie[0], Se);
          },
          ce
        );
      }, fi.prototype.__iterator = function(G, ce) {
        return this._list.fromEntrySeq().__iterator(G, ce);
      }, fi.prototype.__ensureOwner = function(G) {
        if (G === this.__ownerID)
          return this;
        var ce = this._map.__ensureOwner(G), Se = this._list.__ensureOwner(G);
        return G ? Xd(ce, Se, G, this.__hash) : (this.__ownerID = G, this._map = ce, this._list = Se, this);
      };
      function pc(G) {
        return kn(G) && _(G);
      }
      fi.isOrderedMap = pc, fi.prototype[h] = !0, fi.prototype[$] = fi.prototype.remove;
      function Xd(G, ce, Se, Ie) {
        var Ae = Object.create(fi.prototype);
        return Ae.size = G ? G.size : 0, Ae._map = G, Ae._list = ce, Ae.__ownerID = Se, Ae.__hash = Ie, Ae;
      }
      var ed;
      function Jd() {
        return ed || (ed = Xd(er(), au()));
      }
      function Dr(G, ce, Se) {
        var Ie = G._map, Ae = G._list, Ge = Ie.get(ce), Qe = Ge !== void 0, gt, Nt;
        if (Se === w) {
          if (!Qe)
            return G;
          Ae.size >= b && Ae.size >= Ie.size * 2 ? (Nt = Ae.filter(function(Ct, Be) {
            return Ct !== void 0 && Ge !== Be;
          }), gt = Nt.toKeyedSeq().map(function(Ct) {
            return Ct[0];
          }).flip().toMap(), G.__ownerID && (gt.__ownerID = Nt.__ownerID = G.__ownerID)) : (gt = Ie.remove(ce), Nt = Ge === Ae.size - 1 ? Ae.pop() : Ae.set(Ge, void 0));
        } else if (Qe) {
          if (Se === Ae.get(Ge)[1])
            return G;
          gt = Ie, Nt = Ae.set(Ge, [ce, Se]);
        } else
          gt = Ie.set(ce, Ae.size), Nt = Ae.set(Ae.size, [ce, Se]);
        return G.__ownerID ? (G.size = gt.size, G._map = gt, G._list = Nt, G.__hash = void 0, G) : Xd(gt, Nt);
      }
      o(Po, be);
      function Po(G, ce) {
        this._iter = G, this._useKeys = ce, this.size = G.size;
      }
      Po.prototype.get = function(G, ce) {
        return this._iter.get(G, ce);
      }, Po.prototype.has = function(G) {
        return this._iter.has(G);
      }, Po.prototype.valueSeq = function() {
        return this._iter.valueSeq();
      }, Po.prototype.reverse = function() {
        var G = this, ce = np(this, !0);
        return this._useKeys || (ce.valueSeq = function() {
          return G._iter.toSeq().reverse();
        }), ce;
      }, Po.prototype.map = function(G, ce) {
        var Se = this, Ie = nd(this, G, ce);
        return this._useKeys || (Ie.valueSeq = function() {
          return Se._iter.toSeq().map(G, ce);
        }), Ie;
      }, Po.prototype.__iterate = function(G, ce) {
        var Se = this, Ie;
        return this._iter.__iterate(
          this._useKeys ? function(Ae, Ge) {
            return G(Ae, Ge, Se);
          } : (Ie = ce ? $a(this) : 0, function(Ae) {
            return G(Ae, ce ? --Ie : Ie++, Se);
          }),
          ce
        );
      }, Po.prototype.__iterator = function(G, ce) {
        if (this._useKeys)
          return this._iter.__iterator(G, ce);
        var Se = this._iter.__iterator(F, ce), Ie = ce ? $a(this) : 0;
        return new H(function() {
          var Ae = Se.next();
          return Ae.done ? Ae : J(G, ce ? --Ie : Ie++, Ae.value, Ae);
        });
      }, Po.prototype[h] = !0, o(mc, Q);
      function mc(G) {
        this._iter = G, this.size = G.size;
      }
      mc.prototype.includes = function(G) {
        return this._iter.includes(G);
      }, mc.prototype.__iterate = function(G, ce) {
        var Se = this, Ie = 0;
        return this._iter.__iterate(function(Ae) {
          return G(Ae, Ie++, Se);
        }, ce);
      }, mc.prototype.__iterator = function(G, ce) {
        var Se = this._iter.__iterator(F, ce), Ie = 0;
        return new H(function() {
          var Ae = Se.next();
          return Ae.done ? Ae : J(G, Ie++, Ae.value, Ae);
        });
      }, o(El, me);
      function El(G) {
        this._iter = G, this.size = G.size;
      }
      El.prototype.has = function(G) {
        return this._iter.includes(G);
      }, El.prototype.__iterate = function(G, ce) {
        var Se = this;
        return this._iter.__iterate(function(Ie) {
          return G(Ie, Ie, Se);
        }, ce);
      }, El.prototype.__iterator = function(G, ce) {
        var Se = this._iter.__iterator(F, ce);
        return new H(function() {
          var Ie = Se.next();
          return Ie.done ? Ie : J(G, Ie.value, Ie.value, Ie);
        });
      }, o(xl, be);
      function xl(G) {
        this._iter = G, this.size = G.size;
      }
      xl.prototype.entrySeq = function() {
        return this._iter.toSeq();
      }, xl.prototype.__iterate = function(G, ce) {
        var Se = this;
        return this._iter.__iterate(function(Ie) {
          if (Ie) {
            dm(Ie);
            var Ae = c(Ie);
            return G(
              Ae ? Ie.get(1) : Ie[1],
              Ae ? Ie.get(0) : Ie[0],
              Se
            );
          }
        }, ce);
      }, xl.prototype.__iterator = function(G, ce) {
        var Se = this._iter.__iterator(F, ce);
        return new H(function() {
          for (; ; ) {
            var Ie = Se.next();
            if (Ie.done)
              return Ie;
            var Ae = Ie.value;
            if (Ae) {
              dm(Ae);
              var Ge = c(Ae);
              return J(
                G,
                Ge ? Ae.get(0) : Ae[0],
                Ge ? Ae.get(1) : Ae[1],
                Ie
              );
            }
          }
        });
      }, mc.prototype.cacheResult = Po.prototype.cacheResult = El.prototype.cacheResult = xl.prototype.cacheResult = ta;
      function td(G) {
        var ce = wa(G);
        return ce._iter = G, ce.size = G.size, ce.flip = function() {
          return G;
        }, ce.reverse = function() {
          var Se = G.reverse.apply(this);
          return Se.flip = function() {
            return G.reverse();
          }, Se;
        }, ce.has = function(Se) {
          return G.includes(Se);
        }, ce.includes = function(Se) {
          return G.has(Se);
        }, ce.cacheResult = ta, ce.__iterateUncached = function(Se, Ie) {
          var Ae = this;
          return G.__iterate(function(Ge, Qe) {
            return Se(Qe, Ge, Ae) !== !1;
          }, Ie);
        }, ce.__iteratorUncached = function(Se, Ie) {
          if (Se === P) {
            var Ae = G.__iterator(Se, Ie);
            return new H(function() {
              var Ge = Ae.next();
              if (!Ge.done) {
                var Qe = Ge.value[0];
                Ge.value[0] = Ge.value[1], Ge.value[1] = Qe;
              }
              return Ge;
            });
          }
          return G.__iterator(
            Se === F ? z : F,
            Ie
          );
        }, ce;
      }
      function nd(G, ce, Se) {
        var Ie = wa(G);
        return Ie.size = G.size, Ie.has = function(Ae) {
          return G.has(Ae);
        }, Ie.get = function(Ae, Ge) {
          var Qe = G.get(Ae, w);
          return Qe === w ? Ge : ce.call(Se, Qe, Ae, G);
        }, Ie.__iterateUncached = function(Ae, Ge) {
          var Qe = this;
          return G.__iterate(
            function(gt, Nt, Ct) {
              return Ae(ce.call(Se, gt, Nt, Ct), Nt, Qe) !== !1;
            },
            Ge
          );
        }, Ie.__iteratorUncached = function(Ae, Ge) {
          var Qe = G.__iterator(P, Ge);
          return new H(function() {
            var gt = Qe.next();
            if (gt.done)
              return gt;
            var Nt = gt.value, Ct = Nt[0];
            return J(
              Ae,
              Ct,
              ce.call(Se, Nt[1], Ct, G),
              gt
            );
          });
        }, Ie;
      }
      function np(G, ce) {
        var Se = wa(G);
        return Se._iter = G, Se.size = G.size, Se.reverse = function() {
          return G;
        }, G.flip && (Se.flip = function() {
          var Ie = td(G);
          return Ie.reverse = function() {
            return G.flip();
          }, Ie;
        }), Se.get = function(Ie, Ae) {
          return G.get(ce ? Ie : -1 - Ie, Ae);
        }, Se.has = function(Ie) {
          return G.has(ce ? Ie : -1 - Ie);
        }, Se.includes = function(Ie) {
          return G.includes(Ie);
        }, Se.cacheResult = ta, Se.__iterate = function(Ie, Ae) {
          var Ge = this;
          return G.__iterate(function(Qe, gt) {
            return Ie(Qe, gt, Ge);
          }, !Ae);
        }, Se.__iterator = function(Ie, Ae) {
          return G.__iterator(Ie, !Ae);
        }, Se;
      }
      function Qd(G, ce, Se, Ie) {
        var Ae = wa(G);
        return Ie && (Ae.has = function(Ge) {
          var Qe = G.get(Ge, w);
          return Qe !== w && !!ce.call(Se, Qe, Ge, G);
        }, Ae.get = function(Ge, Qe) {
          var gt = G.get(Ge, w);
          return gt !== w && ce.call(Se, gt, Ge, G) ? gt : Qe;
        }), Ae.__iterateUncached = function(Ge, Qe) {
          var gt = this, Nt = 0;
          return G.__iterate(function(Ct, Be, We) {
            if (ce.call(Se, Ct, Be, We))
              return Nt++, Ge(Ct, Ie ? Be : Nt - 1, gt);
          }, Qe), Nt;
        }, Ae.__iteratorUncached = function(Ge, Qe) {
          var gt = G.__iterator(P, Qe), Nt = 0;
          return new H(function() {
            for (; ; ) {
              var Ct = gt.next();
              if (Ct.done)
                return Ct;
              var Be = Ct.value, We = Be[0], mt = Be[1];
              if (ce.call(Se, mt, We, G))
                return J(Ge, Ie ? We : Nt++, mt, Ct);
            }
          });
        }, Ae;
      }
      function lm(G, ce, Se) {
        var Ie = gn().asMutable();
        return G.__iterate(function(Ae, Ge) {
          Ie.update(
            ce.call(Se, Ae, Ge, G),
            0,
            function(Qe) {
              return Qe + 1;
            }
          );
        }), Ie.asImmutable();
      }
      function ma(G, ce, Se) {
        var Ie = l(G), Ae = (_(G) ? fi() : gn()).asMutable();
        G.__iterate(function(Qe, gt) {
          Ae.update(
            ce.call(Se, Qe, gt, G),
            function(Nt) {
              return Nt = Nt || [], Nt.push(Ie ? [gt, Qe] : Qe), Nt;
            }
          );
        });
        var Ge = Cl(G);
        return Ae.map(function(Qe) {
          return _o(G, Ge(Qe));
        });
      }
      function e_(G, ce, Se, Ie) {
        var Ae = G.size;
        if (ce !== void 0 && (ce = ce | 0), Se !== void 0 && (Se === 1 / 0 ? Se = Ae : Se = Se | 0), E(ce, Se, Ae))
          return G;
        var Ge = x(ce, Ae), Qe = k(Se, Ae);
        if (Ge !== Ge || Qe !== Qe)
          return e_(G.toSeq().cacheResult(), ce, Se, Ie);
        var gt = Qe - Ge, Nt;
        gt === gt && (Nt = gt < 0 ? 0 : gt);
        var Ct = wa(G);
        return Ct.size = Nt === 0 ? Nt : G.size && Nt || void 0, !Ie && Re(G) && Nt >= 0 && (Ct.get = function(Be, We) {
          return Be = A(this, Be), Be >= 0 && Be < Nt ? G.get(Be + Ge, We) : We;
        }), Ct.__iterateUncached = function(Be, We) {
          var mt = this;
          if (Nt === 0)
            return 0;
          if (We)
            return this.cacheResult().__iterate(Be, We);
          var Gt = 0, on = !0, no = 0;
          return G.__iterate(function(gr, Xo) {
            if (!(on && (on = Gt++ < Ge)))
              return no++, Be(gr, Ie ? Xo : no - 1, mt) !== !1 && no !== Nt;
          }), no;
        }, Ct.__iteratorUncached = function(Be, We) {
          if (Nt !== 0 && We)
            return this.cacheResult().__iterator(Be, We);
          var mt = Nt !== 0 && G.__iterator(Be, We), Gt = 0, on = 0;
          return new H(function() {
            for (; Gt++ < Ge; )
              mt.next();
            if (++on > Nt)
              return le();
            var no = mt.next();
            return Ie || Be === F ? no : Be === z ? J(Be, on - 1, void 0, no) : J(Be, on - 1, no.value[1], no);
          });
        }, Ct;
      }
      function cu(G, ce, Se) {
        var Ie = wa(G);
        return Ie.__iterateUncached = function(Ae, Ge) {
          var Qe = this;
          if (Ge)
            return this.cacheResult().__iterate(Ae, Ge);
          var gt = 0;
          return G.__iterate(
            function(Nt, Ct, Be) {
              return ce.call(Se, Nt, Ct, Be) && ++gt && Ae(Nt, Ct, Qe);
            }
          ), gt;
        }, Ie.__iteratorUncached = function(Ae, Ge) {
          var Qe = this;
          if (Ge)
            return this.cacheResult().__iterator(Ae, Ge);
          var gt = G.__iterator(P, Ge), Nt = !0;
          return new H(function() {
            if (!Nt)
              return le();
            var Ct = gt.next();
            if (Ct.done)
              return Ct;
            var Be = Ct.value, We = Be[0], mt = Be[1];
            return ce.call(Se, mt, We, Qe) ? Ae === P ? Ct : J(Ae, We, mt, Ct) : (Nt = !1, le());
          });
        }, Ie;
      }
      function op(G, ce, Se, Ie) {
        var Ae = wa(G);
        return Ae.__iterateUncached = function(Ge, Qe) {
          var gt = this;
          if (Qe)
            return this.cacheResult().__iterate(Ge, Qe);
          var Nt = !0, Ct = 0;
          return G.__iterate(function(Be, We, mt) {
            if (!(Nt && (Nt = ce.call(Se, Be, We, mt))))
              return Ct++, Ge(Be, Ie ? We : Ct - 1, gt);
          }), Ct;
        }, Ae.__iteratorUncached = function(Ge, Qe) {
          var gt = this;
          if (Qe)
            return this.cacheResult().__iterator(Ge, Qe);
          var Nt = G.__iterator(P, Qe), Ct = !0, Be = 0;
          return new H(function() {
            var We, mt, Gt;
            do {
              if (We = Nt.next(), We.done)
                return Ie || Ge === F ? We : Ge === z ? J(Ge, Be++, void 0, We) : J(Ge, Be++, We.value[1], We);
              var on = We.value;
              mt = on[0], Gt = on[1], Ct && (Ct = ce.call(Se, Gt, mt, gt));
            } while (Ct);
            return Ge === P ? We : J(Ge, mt, Gt, We);
          });
        }, Ae;
      }
      function um(G, ce) {
        var Se = l(G), Ie = [G].concat(ce).map(function(Qe) {
          return c(Qe) ? Se && (Qe = i(Qe)) : Qe = Se ? st(Qe) : De(Array.isArray(Qe) ? Qe : [Qe]), Qe;
        }).filter(function(Qe) {
          return Qe.size !== 0;
        });
        if (Ie.length === 0)
          return G;
        if (Ie.length === 1) {
          var Ae = Ie[0];
          if (Ae === G || Se && l(Ae) || u(G) && u(Ae))
            return Ae;
        }
        var Ge = new pe(Ie);
        return Se ? Ge = Ge.toKeyedSeq() : u(G) || (Ge = Ge.toSetSeq()), Ge = Ge.flatten(!0), Ge.size = Ie.reduce(
          function(Qe, gt) {
            if (Qe !== void 0) {
              var Nt = gt.size;
              if (Nt !== void 0)
                return Qe + Nt;
            }
          },
          0
        ), Ge;
      }
      function ls(G, ce, Se) {
        var Ie = wa(G);
        return Ie.__iterateUncached = function(Ae, Ge) {
          var Qe = 0, gt = !1;
          function Nt(Ct, Be) {
            var We = this;
            Ct.__iterate(function(mt, Gt) {
              return (!ce || Be < ce) && c(mt) ? Nt(mt, Be + 1) : Ae(mt, Se ? Gt : Qe++, We) === !1 && (gt = !0), !gt;
            }, Ge);
          }
          return Nt(G, 0), Qe;
        }, Ie.__iteratorUncached = function(Ae, Ge) {
          var Qe = G.__iterator(Ae, Ge), gt = [], Nt = 0;
          return new H(function() {
            for (; Qe; ) {
              var Ct = Qe.next();
              if (Ct.done !== !1) {
                Qe = gt.pop();
                continue;
              }
              var Be = Ct.value;
              if (Ae === P && (Be = Be[1]), (!ce || gt.length < ce) && c(Be))
                gt.push(Qe), Qe = Be.__iterator(Ae, Ge);
              else
                return Se ? Ct : J(Ae, Nt++, Be, Ct);
            }
            return le();
          });
        }, Ie;
      }
      function Rf(G, ce, Se) {
        var Ie = Cl(G);
        return G.toSeq().map(
          function(Ae, Ge) {
            return Ie(ce.call(Se, Ae, Ge, G));
          }
        ).flatten(!0);
      }
      function Pf(G, ce) {
        var Se = wa(G);
        return Se.size = G.size && G.size * 2 - 1, Se.__iterateUncached = function(Ie, Ae) {
          var Ge = this, Qe = 0;
          return G.__iterate(
            function(gt, Nt) {
              return (!Qe || Ie(ce, Qe++, Ge) !== !1) && Ie(gt, Qe++, Ge) !== !1;
            },
            Ae
          ), Qe;
        }, Se.__iteratorUncached = function(Ie, Ae) {
          var Ge = G.__iterator(F, Ae), Qe = 0, gt;
          return new H(function() {
            return (!gt || Qe % 2) && (gt = Ge.next(), gt.done) ? gt : Qe % 2 ? J(Ie, Qe++, ce) : J(Ie, Qe++, gt.value, gt);
          });
        }, Se;
      }
      function Kc(G, ce, Se) {
        ce || (ce = Tl);
        var Ie = l(G), Ae = 0, Ge = G.toSeq().map(
          function(Qe, gt) {
            return [gt, Qe, Ae++, Se ? Se(Qe, gt, G) : Qe];
          }
        ).toArray();
        return Ge.sort(function(Qe, gt) {
          return ce(Qe[3], gt[3]) || Qe[2] - gt[2];
        }).forEach(
          Ie ? function(Qe, gt) {
            Ge[gt].length = 2;
          } : function(Qe, gt) {
            Ge[gt] = Qe[1];
          }
        ), Ie ? be(Ge) : u(G) ? Q(Ge) : me(Ge);
      }
      function t_(G, ce, Se) {
        if (ce || (ce = Tl), Se) {
          var Ie = G.toSeq().map(function(Ae, Ge) {
            return [Ae, Se(Ae, Ge, G)];
          }).reduce(function(Ae, Ge) {
            return od(ce, Ae[1], Ge[1]) ? Ge : Ae;
          });
          return Ie && Ie[0];
        } else
          return G.reduce(function(Ae, Ge) {
            return od(ce, Ae, Ge) ? Ge : Ae;
          });
      }
      function od(G, ce, Se) {
        var Ie = G(Se, ce);
        return Ie === 0 && Se !== ce && (Se == null || Se !== Se) || Ie > 0;
      }
      function rd(G, ce, Se) {
        var Ie = wa(G);
        return Ie.size = new pe(Se).map(function(Ae) {
          return Ae.size;
        }).min(), Ie.__iterate = function(Ae, Ge) {
          for (var Qe = this.__iterator(F, Ge), gt, Nt = 0; !(gt = Qe.next()).done && Ae(gt.value, Nt++, this) !== !1; )
            ;
          return Nt;
        }, Ie.__iteratorUncached = function(Ae, Ge) {
          var Qe = Se.map(
            function(Ct) {
              return Ct = r(Ct), re(Ge ? Ct.reverse() : Ct);
            }
          ), gt = 0, Nt = !1;
          return new H(function() {
            var Ct;
            return Nt || (Ct = Qe.map(function(Be) {
              return Be.next();
            }), Nt = Ct.some(function(Be) {
              return Be.done;
            })), Nt ? le() : J(
              Ae,
              gt++,
              ce.apply(null, Ct.map(function(Be) {
                return Be.value;
              }))
            );
          });
        }, Ie;
      }
      function _o(G, ce) {
        return Re(G) ? ce : G.constructor(ce);
      }
      function dm(G) {
        if (G !== Object(G))
          throw new TypeError("Expected [K, V] tuple: " + G);
      }
      function $a(G) {
        return zn(G.size), D(G);
      }
      function Cl(G) {
        return l(G) ? i : u(G) ? a : s;
      }
      function wa(G) {
        return Object.create(
          (l(G) ? be : u(G) ? Q : me).prototype
        );
      }
      function ta() {
        return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : he.prototype.cacheResult.call(this);
      }
      function Tl(G, ce) {
        return G > ce ? 1 : G < ce ? -1 : 0;
      }
      function lu(G) {
        var ce = re(G);
        if (!ce) {
          if (!_e(G))
            throw new TypeError("Expected iterable or array-like: " + G);
          ce = re(r(G));
        }
        return ce;
      }
      o(Zo, Ln);
      function Zo(G, ce) {
        var Se, Ie = function(Qe) {
          if (Qe instanceof Ie)
            return Qe;
          if (!(this instanceof Ie))
            return new Ie(Qe);
          if (!Se) {
            Se = !0;
            var gt = Object.keys(G);
            Zc(Ae, gt), Ae.size = gt.length, Ae._name = ce, Ae._keys = gt, Ae._defaultValues = G;
          }
          this._map = gn(Qe);
        }, Ae = Ie.prototype = Object.create(nn);
        return Ae.constructor = Ie, Ie;
      }
      Zo.prototype.toString = function() {
        return this.__toString(po(this) + " {", "}");
      }, Zo.prototype.has = function(G) {
        return this._defaultValues.hasOwnProperty(G);
      }, Zo.prototype.get = function(G, ce) {
        if (!this.has(G))
          return ce;
        var Se = this._defaultValues[G];
        return this._map ? this._map.get(G, Se) : Se;
      }, Zo.prototype.clear = function() {
        if (this.__ownerID)
          return this._map && this._map.clear(), this;
        var G = this.constructor;
        return G._empty || (G._empty = Ts(this, er()));
      }, Zo.prototype.set = function(G, ce) {
        if (!this.has(G))
          throw new Error('Cannot set unknown key "' + G + '" on ' + po(this));
        if (this._map && !this._map.has(G)) {
          var Se = this._defaultValues[G];
          if (ce === Se)
            return this;
        }
        var Ie = this._map && this._map.set(G, ce);
        return this.__ownerID || Ie === this._map ? this : Ts(this, Ie);
      }, Zo.prototype.remove = function(G) {
        if (!this.has(G))
          return this;
        var ce = this._map && this._map.remove(G);
        return this.__ownerID || ce === this._map ? this : Ts(this, ce);
      }, Zo.prototype.wasAltered = function() {
        return this._map.wasAltered();
      }, Zo.prototype.__iterator = function(G, ce) {
        var Se = this;
        return i(this._defaultValues).map(function(Ie, Ae) {
          return Se.get(Ae);
        }).__iterator(G, ce);
      }, Zo.prototype.__iterate = function(G, ce) {
        var Se = this;
        return i(this._defaultValues).map(function(Ie, Ae) {
          return Se.get(Ae);
        }).__iterate(G, ce);
      }, Zo.prototype.__ensureOwner = function(G) {
        if (G === this.__ownerID)
          return this;
        var ce = this._map && this._map.__ensureOwner(G);
        return G ? Ts(this, ce, G) : (this.__ownerID = G, this._map = ce, this);
      };
      var nn = Zo.prototype;
      nn[$] = nn.remove, nn.deleteIn = nn.removeIn = Pt.removeIn, nn.merge = Pt.merge, nn.mergeWith = Pt.mergeWith, nn.mergeIn = Pt.mergeIn, nn.mergeDeep = Pt.mergeDeep, nn.mergeDeepWith = Pt.mergeDeepWith, nn.mergeDeepIn = Pt.mergeDeepIn, nn.setIn = Pt.setIn, nn.update = Pt.update, nn.updateIn = Pt.updateIn, nn.withMutations = Pt.withMutations, nn.asMutable = Pt.asMutable, nn.asImmutable = Pt.asImmutable;
      function Ts(G, ce, Se) {
        var Ie = Object.create(Object.getPrototypeOf(G));
        return Ie._map = ce, Ie.__ownerID = Se, Ie;
      }
      function po(G) {
        return G._name || G.constructor.name || "Record";
      }
      function Zc(G, ce) {
        try {
          ce.forEach(_m.bind(void 0, G));
        } catch {
        }
      }
      function _m(G, ce) {
        Object.defineProperty(G, ce, {
          get: function() {
            return this.get(ce);
          },
          set: function(Se) {
            un(this.__ownerID, "Cannot set on an immutable record."), this.set(ce, Se);
          }
        });
      }
      o(Er, Qt);
      function Er(G) {
        return G == null ? Ma() : uu(G) && !_(G) ? G : Ma().withMutations(function(ce) {
          var Se = s(G);
          zn(Se.size), Se.forEach(function(Ie) {
            return ce.add(Ie);
          });
        });
      }
      Er.of = function() {
        return this(arguments);
      }, Er.fromKeys = function(G) {
        return this(i(G).keySeq());
      }, Er.prototype.toString = function() {
        return this.__toString("Set {", "}");
      }, Er.prototype.has = function(G) {
        return this._map.has(G);
      }, Er.prototype.add = function(G) {
        return As(this, this._map.set(G, !0));
      }, Er.prototype.remove = function(G) {
        return As(this, this._map.remove(G));
      }, Er.prototype.clear = function() {
        return As(this, this._map.clear());
      }, Er.prototype.union = function() {
        var G = n.call(arguments, 0);
        return G = G.filter(function(ce) {
          return ce.size !== 0;
        }), G.length === 0 ? this : this.size === 0 && !this.__ownerID && G.length === 1 ? this.constructor(G[0]) : this.withMutations(function(ce) {
          for (var Se = 0; Se < G.length; Se++)
            s(G[Se]).forEach(function(Ie) {
              return ce.add(Ie);
            });
        });
      }, Er.prototype.intersect = function() {
        var G = n.call(arguments, 0);
        if (G.length === 0)
          return this;
        G = G.map(function(Se) {
          return s(Se);
        });
        var ce = this;
        return this.withMutations(function(Se) {
          ce.forEach(function(Ie) {
            G.every(function(Ae) {
              return Ae.includes(Ie);
            }) || Se.remove(Ie);
          });
        });
      }, Er.prototype.subtract = function() {
        var G = n.call(arguments, 0);
        if (G.length === 0)
          return this;
        G = G.map(function(Se) {
          return s(Se);
        });
        var ce = this;
        return this.withMutations(function(Se) {
          ce.forEach(function(Ie) {
            G.some(function(Ae) {
              return Ae.includes(Ie);
            }) && Se.remove(Ie);
          });
        });
      }, Er.prototype.merge = function() {
        return this.union.apply(this, arguments);
      }, Er.prototype.mergeWith = function(G) {
        var ce = n.call(arguments, 1);
        return this.union.apply(this, ce);
      }, Er.prototype.sort = function(G) {
        return Za(Kc(this, G));
      }, Er.prototype.sortBy = function(G, ce) {
        return Za(Kc(this, ce, G));
      }, Er.prototype.wasAltered = function() {
        return this._map.wasAltered();
      }, Er.prototype.__iterate = function(G, ce) {
        var Se = this;
        return this._map.__iterate(function(Ie, Ae) {
          return G(Ae, Ae, Se);
        }, ce);
      }, Er.prototype.__iterator = function(G, ce) {
        return this._map.map(function(Se, Ie) {
          return Ie;
        }).__iterator(G, ce);
      }, Er.prototype.__ensureOwner = function(G) {
        if (G === this.__ownerID)
          return this;
        var ce = this._map.__ensureOwner(G);
        return G ? this.__make(ce, G) : (this.__ownerID = G, this._map = ce, this);
      };
      function uu(G) {
        return !!(G && G[du]);
      }
      Er.isSet = uu;
      var du = "@@__IMMUTABLE_SET__@@", na = Er.prototype;
      na[du] = !0, na[$] = na.remove, na.mergeDeep = na.merge, na.mergeDeepWith = na.mergeWith, na.withMutations = Pt.withMutations, na.asMutable = Pt.asMutable, na.asImmutable = Pt.asImmutable, na.__empty = Ma, na.__make = pm;
      function As(G, ce) {
        return G.__ownerID ? (G.size = ce.size, G._map = ce, G) : ce === G._map ? G : ce.size === 0 ? G.__empty() : G.__make(ce);
      }
      function pm(G, ce) {
        var Se = Object.create(na);
        return Se.size = G ? G.size : 0, Se._map = G, Se.__ownerID = ce, Se;
      }
      var n_;
      function Ma() {
        return n_ || (n_ = pm(er()));
      }
      o(Za, Er);
      function Za(G) {
        return G == null ? Ol() : Al(G) ? G : Ol().withMutations(function(ce) {
          var Se = s(G);
          zn(Se.size), Se.forEach(function(Ie) {
            return ce.add(Ie);
          });
        });
      }
      Za.of = function() {
        return this(arguments);
      }, Za.fromKeys = function(G) {
        return this(i(G).keySeq());
      }, Za.prototype.toString = function() {
        return this.__toString("OrderedSet {", "}");
      };
      function Al(G) {
        return uu(G) && _(G);
      }
      Za.isOrderedSet = Al;
      var Il = Za.prototype;
      Il[h] = !0, Il.__empty = Ol, Il.__make = rp;
      function rp(G, ce) {
        var Se = Object.create(Il);
        return Se.size = G ? G.size : 0, Se._map = G, Se.__ownerID = ce, Se;
      }
      var id;
      function Ol() {
        return id || (id = rp(Jd()));
      }
      o(To, Yn);
      function To(G) {
        return G == null ? sd() : Na(G) ? G : sd().unshiftAll(G);
      }
      To.of = function() {
        return this(arguments);
      }, To.prototype.toString = function() {
        return this.__toString("Stack [", "]");
      }, To.prototype.get = function(G, ce) {
        var Se = this._head;
        for (G = A(this, G); Se && G--; )
          Se = Se.next;
        return Se ? Se.value : ce;
      }, To.prototype.peek = function() {
        return this._head && this._head.value;
      }, To.prototype.push = function() {
        if (arguments.length === 0)
          return this;
        for (var G = this.size + arguments.length, ce = this._head, Se = arguments.length - 1; Se >= 0; Se--)
          ce = {
            value: arguments[Se],
            next: ce
          };
        return this.__ownerID ? (this.size = G, this._head = ce, this.__hash = void 0, this.__altered = !0, this) : Xc(G, ce);
      }, To.prototype.pushAll = function(G) {
        if (G = a(G), G.size === 0)
          return this;
        zn(G.size);
        var ce = this.size, Se = this._head;
        return G.reverse().forEach(function(Ie) {
          ce++, Se = {
            value: Ie,
            next: Se
          };
        }), this.__ownerID ? (this.size = ce, this._head = Se, this.__hash = void 0, this.__altered = !0, this) : Xc(ce, Se);
      }, To.prototype.pop = function() {
        return this.slice(1);
      }, To.prototype.unshift = function() {
        return this.push.apply(this, arguments);
      }, To.prototype.unshiftAll = function(G) {
        return this.pushAll(G);
      }, To.prototype.shift = function() {
        return this.pop.apply(this, arguments);
      }, To.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : sd();
      }, To.prototype.slice = function(G, ce) {
        if (E(G, ce, this.size))
          return this;
        var Se = x(G, this.size), Ie = k(ce, this.size);
        if (Ie !== this.size)
          return Yn.prototype.slice.call(this, G, ce);
        for (var Ae = this.size - Se, Ge = this._head; Se--; )
          Ge = Ge.next;
        return this.__ownerID ? (this.size = Ae, this._head = Ge, this.__hash = void 0, this.__altered = !0, this) : Xc(Ae, Ge);
      }, To.prototype.__ensureOwner = function(G) {
        return G === this.__ownerID ? this : G ? Xc(this.size, this._head, G, this.__hash) : (this.__ownerID = G, this.__altered = !1, this);
      }, To.prototype.__iterate = function(G, ce) {
        if (ce)
          return this.reverse().__iterate(G);
        for (var Se = 0, Ie = this._head; Ie && G(Ie.value, Se++, this) !== !1; )
          Ie = Ie.next;
        return Se;
      }, To.prototype.__iterator = function(G, ce) {
        if (ce)
          return this.reverse().__iterator(G);
        var Se = 0, Ie = this._head;
        return new H(function() {
          if (Ie) {
            var Ae = Ie.value;
            return Ie = Ie.next, J(G, Se++, Ae);
          }
          return le();
        });
      };
      function Na(G) {
        return !!(G && G[fa]);
      }
      To.isStack = Na;
      var fa = "@@__IMMUTABLE_STACK__@@", Is = To.prototype;
      Is[fa] = !0, Is.withMutations = Pt.withMutations, Is.asMutable = Pt.asMutable, Is.asImmutable = Pt.asImmutable, Is.wasAltered = Pt.wasAltered;
      function Xc(G, ce, Se, Ie) {
        var Ae = Object.create(Is);
        return Ae.size = G, Ae._head = ce, Ae.__ownerID = Se, Ae.__hash = Ie, Ae.__altered = !1, Ae;
      }
      var ad;
      function sd() {
        return ad || (ad = Xc(0));
      }
      function Xs(G, ce) {
        var Se = function(Ie) {
          G.prototype[Ie] = ce[Ie];
        };
        return Object.keys(ce).forEach(Se), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(ce).forEach(Se), G;
      }
      r.Iterator = H, Xs(r, {
        // ### Conversion to other types
        toArray: function() {
          zn(this.size);
          var G = new Array(this.size || 0);
          return this.valueSeq().__iterate(function(ce, Se) {
            G[Se] = ce;
          }), G;
        },
        toIndexedSeq: function() {
          return new mc(this);
        },
        toJS: function() {
          return this.toSeq().map(
            function(G) {
              return G && typeof G.toJS == "function" ? G.toJS() : G;
            }
          ).__toJS();
        },
        toJSON: function() {
          return this.toSeq().map(
            function(G) {
              return G && typeof G.toJSON == "function" ? G.toJSON() : G;
            }
          ).__toJS();
        },
        toKeyedSeq: function() {
          return new Po(this, !0);
        },
        toMap: function() {
          return gn(this.toKeyedSeq());
        },
        toObject: function() {
          zn(this.size);
          var G = {};
          return this.__iterate(function(ce, Se) {
            G[Se] = ce;
          }), G;
        },
        toOrderedMap: function() {
          return fi(this.toKeyedSeq());
        },
        toOrderedSet: function() {
          return Za(l(this) ? this.valueSeq() : this);
        },
        toSet: function() {
          return Er(l(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
          return new El(this);
        },
        toSeq: function() {
          return u(this) ? this.toIndexedSeq() : l(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
          return To(l(this) ? this.valueSeq() : this);
        },
        toList: function() {
          return Co(l(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
          return "[Iterable]";
        },
        __toString: function(G, ce) {
          return this.size === 0 ? G + ce : G + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + ce;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
          var G = n.call(arguments, 0);
          return _o(this, um(this, G));
        },
        includes: function(G) {
          return this.some(function(ce) {
            return vt(ce, G);
          });
        },
        entries: function() {
          return this.__iterator(P);
        },
        every: function(G, ce) {
          zn(this.size);
          var Se = !0;
          return this.__iterate(function(Ie, Ae, Ge) {
            if (!G.call(ce, Ie, Ae, Ge))
              return Se = !1, !1;
          }), Se;
        },
        filter: function(G, ce) {
          return _o(this, Qd(this, G, ce, !0));
        },
        find: function(G, ce, Se) {
          var Ie = this.findEntry(G, ce);
          return Ie ? Ie[1] : Se;
        },
        forEach: function(G, ce) {
          return zn(this.size), this.__iterate(ce ? G.bind(ce) : G);
        },
        join: function(G) {
          zn(this.size), G = G !== void 0 ? "" + G : ",";
          var ce = "", Se = !0;
          return this.__iterate(function(Ie) {
            Se ? Se = !1 : ce += G, ce += Ie != null ? Ie.toString() : "";
          }), ce;
        },
        keys: function() {
          return this.__iterator(z);
        },
        map: function(G, ce) {
          return _o(this, nd(this, G, ce));
        },
        reduce: function(G, ce, Se) {
          zn(this.size);
          var Ie, Ae;
          return arguments.length < 2 ? Ae = !0 : Ie = ce, this.__iterate(function(Ge, Qe, gt) {
            Ae ? (Ae = !1, Ie = Ge) : Ie = G.call(Se, Ie, Ge, Qe, gt);
          }), Ie;
        },
        reduceRight: function(G, ce, Se) {
          var Ie = this.toKeyedSeq().reverse();
          return Ie.reduce.apply(Ie, arguments);
        },
        reverse: function() {
          return _o(this, np(this, !0));
        },
        slice: function(G, ce) {
          return _o(this, e_(this, G, ce, !0));
        },
        some: function(G, ce) {
          return !this.every(Xa(G), ce);
        },
        sort: function(G) {
          return _o(this, Kc(this, G));
        },
        values: function() {
          return this.__iterator(F);
        },
        // ### More sequential methods
        butLast: function() {
          return this.slice(0, -1);
        },
        isEmpty: function() {
          return this.size !== void 0 ? this.size === 0 : !this.some(function() {
            return !0;
          });
        },
        count: function(G, ce) {
          return D(
            G ? this.toSeq().filter(G, ce) : this
          );
        },
        countBy: function(G, ce) {
          return lm(this, G, ce);
        },
        equals: function(G) {
          return Ot(this, G);
        },
        entrySeq: function() {
          var G = this;
          if (G._cache)
            return new pe(G._cache);
          var ce = G.toSeq().map(ip).toIndexedSeq();
          return ce.fromEntrySeq = function() {
            return G.toSeq();
          }, ce;
        },
        filterNot: function(G, ce) {
          return this.filter(Xa(G), ce);
        },
        findEntry: function(G, ce, Se) {
          var Ie = Se;
          return this.__iterate(function(Ae, Ge, Qe) {
            if (G.call(ce, Ae, Ge, Qe))
              return Ie = [Ge, Ae], !1;
          }), Ie;
        },
        findKey: function(G, ce) {
          var Se = this.findEntry(G, ce);
          return Se && Se[0];
        },
        findLast: function(G, ce, Se) {
          return this.toKeyedSeq().reverse().find(G, ce, Se);
        },
        findLastEntry: function(G, ce, Se) {
          return this.toKeyedSeq().reverse().findEntry(G, ce, Se);
        },
        findLastKey: function(G, ce) {
          return this.toKeyedSeq().reverse().findKey(G, ce);
        },
        first: function() {
          return this.find(S);
        },
        flatMap: function(G, ce) {
          return _o(this, Rf(this, G, ce));
        },
        flatten: function(G) {
          return _o(this, ls(this, G, !0));
        },
        fromEntrySeq: function() {
          return new xl(this);
        },
        get: function(G, ce) {
          return this.find(function(Se, Ie) {
            return vt(Ie, G);
          }, void 0, ce);
        },
        getIn: function(G, ce) {
          for (var Se = this, Ie = lu(G), Ae; !(Ae = Ie.next()).done; ) {
            var Ge = Ae.value;
            if (Se = Se && Se.get ? Se.get(Ge, w) : w, Se === w)
              return ce;
          }
          return Se;
        },
        groupBy: function(G, ce) {
          return ma(this, G, ce);
        },
        has: function(G) {
          return this.get(G, w) !== w;
        },
        hasIn: function(G) {
          return this.getIn(G, w) !== w;
        },
        isSubset: function(G) {
          return G = typeof G.includes == "function" ? G : r(G), this.every(function(ce) {
            return G.includes(ce);
          });
        },
        isSuperset: function(G) {
          return G = typeof G.isSubset == "function" ? G : r(G), G.isSubset(this);
        },
        keyOf: function(G) {
          return this.findKey(function(ce) {
            return vt(ce, G);
          });
        },
        keySeq: function() {
          return this.toSeq().map(Fa).toIndexedSeq();
        },
        last: function() {
          return this.toSeq().reverse().first();
        },
        lastKeyOf: function(G) {
          return this.toKeyedSeq().reverse().keyOf(G);
        },
        max: function(G) {
          return t_(this, G);
        },
        maxBy: function(G, ce) {
          return t_(this, ce, G);
        },
        min: function(G) {
          return t_(this, G ? Vi(G) : oa);
        },
        minBy: function(G, ce) {
          return t_(this, ce ? Vi(ce) : oa, G);
        },
        rest: function() {
          return this.slice(1);
        },
        skip: function(G) {
          return this.slice(Math.max(0, G));
        },
        skipLast: function(G) {
          return _o(this, this.toSeq().reverse().skip(G).reverse());
        },
        skipWhile: function(G, ce) {
          return _o(this, op(this, G, ce, !0));
        },
        skipUntil: function(G, ce) {
          return this.skipWhile(Xa(G), ce);
        },
        sortBy: function(G, ce) {
          return _o(this, Kc(this, ce, G));
        },
        take: function(G) {
          return this.slice(0, Math.max(0, G));
        },
        takeLast: function(G) {
          return _o(this, this.toSeq().reverse().take(G).reverse());
        },
        takeWhile: function(G, ce) {
          return _o(this, cu(this, G, ce));
        },
        takeUntil: function(G, ce) {
          return this.takeWhile(Xa(G), ce);
        },
        valueSeq: function() {
          return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
          return this.__hash || (this.__hash = Do(this));
        }
        // ### Internal
        // abstract __iterate(fn, reverse)
        // abstract __iterator(type, reverse)
      });
      var fr = r.prototype;
      fr[p] = !0, fr[U] = fr.values, fr.__toJS = fr.toArray, fr.__toStringMapper = Bi, fr.inspect = fr.toSource = function() {
        return this.toString();
      }, fr.chain = fr.flatMap, fr.contains = fr.includes, Xs(i, {
        // ### More sequential methods
        flip: function() {
          return _o(this, td(this));
        },
        mapEntries: function(G, ce) {
          var Se = this, Ie = 0;
          return _o(
            this,
            this.toSeq().map(
              function(Ae, Ge) {
                return G.call(ce, [Ge, Ae], Ie++, Se);
              }
            ).fromEntrySeq()
          );
        },
        mapKeys: function(G, ce) {
          var Se = this;
          return _o(
            this,
            this.toSeq().flip().map(
              function(Ie, Ae) {
                return G.call(ce, Ie, Ae, Se);
              }
            ).flip()
          );
        }
      });
      var Ii = i.prototype;
      Ii[g] = !0, Ii[U] = fr.entries, Ii.__toJS = fr.toObject, Ii.__toStringMapper = function(G, ce) {
        return JSON.stringify(ce) + ": " + Bi(G);
      }, Xs(a, {
        // ### Conversion to other types
        toKeyedSeq: function() {
          return new Po(this, !1);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(G, ce) {
          return _o(this, Qd(this, G, ce, !1));
        },
        findIndex: function(G, ce) {
          var Se = this.findEntry(G, ce);
          return Se ? Se[0] : -1;
        },
        indexOf: function(G) {
          var ce = this.keyOf(G);
          return ce === void 0 ? -1 : ce;
        },
        lastIndexOf: function(G) {
          var ce = this.lastKeyOf(G);
          return ce === void 0 ? -1 : ce;
        },
        reverse: function() {
          return _o(this, np(this, !1));
        },
        slice: function(G, ce) {
          return _o(this, e_(this, G, ce, !1));
        },
        splice: function(G, ce) {
          var Se = arguments.length;
          if (ce = Math.max(ce | 0, 0), Se === 0 || Se === 2 && !ce)
            return this;
          G = x(G, G < 0 ? this.count() : this.size);
          var Ie = this.slice(0, G);
          return _o(
            this,
            Se === 1 ? Ie : Ie.concat(T(arguments, 2), this.slice(G + ce))
          );
        },
        // ### More collection methods
        findLastIndex: function(G, ce) {
          var Se = this.findLastEntry(G, ce);
          return Se ? Se[0] : -1;
        },
        first: function() {
          return this.get(0);
        },
        flatten: function(G) {
          return _o(this, ls(this, G, !1));
        },
        get: function(G, ce) {
          return G = A(this, G), G < 0 || this.size === 1 / 0 || this.size !== void 0 && G > this.size ? ce : this.find(function(Se, Ie) {
            return Ie === G;
          }, void 0, ce);
        },
        has: function(G) {
          return G = A(this, G), G >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || G < this.size : this.indexOf(G) !== -1);
        },
        interpose: function(G) {
          return _o(this, Pf(this, G));
        },
        interleave: function() {
          var G = [this].concat(T(arguments)), ce = rd(this.toSeq(), Q.of, G), Se = ce.flatten(!0);
          return ce.size && (Se.size = ce.size * G.length), _o(this, Se);
        },
        keySeq: function() {
          return pn(0, this.size);
        },
        last: function() {
          return this.get(-1);
        },
        skipWhile: function(G, ce) {
          return _o(this, op(this, G, ce, !1));
        },
        zip: function() {
          var G = [this].concat(T(arguments));
          return _o(this, rd(this, Jr, G));
        },
        zipWith: function(G) {
          var ce = T(arguments);
          return ce[0] = this, _o(this, rd(this, G, ce));
        }
      }), a.prototype[f] = !0, a.prototype[h] = !0, Xs(s, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(G, ce) {
          return this.has(G) ? G : ce;
        },
        includes: function(G) {
          return this.has(G);
        },
        // ### More sequential methods
        keySeq: function() {
          return this.valueSeq();
        }
      }), s.prototype.has = fr.includes, s.prototype.contains = s.prototype.includes, Xs(be, i.prototype), Xs(Q, a.prototype), Xs(me, s.prototype), Xs(Ln, i.prototype), Xs(Yn, a.prototype), Xs(Qt, s.prototype);
      function Fa(G, ce) {
        return ce;
      }
      function ip(G, ce) {
        return [ce, G];
      }
      function Xa(G) {
        return function() {
          return !G.apply(this, arguments);
        };
      }
      function Vi(G) {
        return function() {
          return -G.apply(this, arguments);
        };
      }
      function Bi(G) {
        return typeof G == "string" ? JSON.stringify(G) : String(G);
      }
      function Jr() {
        return T(arguments);
      }
      function oa(G, ce) {
        return G < ce ? 1 : G > ce ? -1 : 0;
      }
      function Do(G) {
        if (G.size === 1 / 0)
          return 0;
        var ce = _(G), Se = l(G), Ie = ce ? 1 : 0, Ae = G.__iterate(
          Se ? ce ? function(Ge, Qe) {
            Ie = 31 * Ie + mm(Xn(Ge), Xn(Qe)) | 0;
          } : function(Ge, Qe) {
            Ie = Ie + mm(Xn(Ge), Xn(Qe)) | 0;
          } : ce ? function(Ge) {
            Ie = 31 * Ie + Xn(Ge) | 0;
          } : function(Ge) {
            Ie = Ie + Xn(Ge) | 0;
          }
        );
        return Jc(Ae, Ie);
      }
      function Jc(G, ce) {
        return ce = fn(ce, 3432918353), ce = fn(ce << 15 | ce >>> -15, 461845907), ce = fn(ce << 13 | ce >>> -13, 5), ce = (ce + 3864292196 | 0) ^ G, ce = fn(ce ^ ce >>> 16, 2246822507), ce = fn(ce ^ ce >>> 13, 3266489909), ce = qn(ce ^ ce >>> 16), ce;
      }
      function mm(G, ce) {
        return G ^ ce + 2654435769 + (G << 6) + (G >> 2) | 0;
      }
      var fm = {
        Iterable: r,
        Seq: he,
        Collection: Rn,
        Map: gn,
        OrderedMap: fi,
        List: Co,
        Stack: To,
        Set: Er,
        OrderedSet: Za,
        Record: Zo,
        Range: pn,
        Repeat: Ft,
        is: vt,
        fromJS: Xe
      };
      return fm;
    });
  }(yP)), yP.exports;
}
var Lr = {};
const Zu = /* @__PURE__ */ nu(dgc);
var TQ;
function Pv() {
  if (TQ)
    return Lr;
  TQ = 1;
  var e = Tn;
  Object.defineProperty(Lr, "__esModule", {
    value: !0
  }), Lr.removePathsInTree = Lr.removeIsLockedInTree = Lr.isEmptyTree = Lr.hasChildren = Lr.getTreeBadFields = Lr.getTotalRulesCountInTree = Lr.getTotalReordableNodesCountInTree = Lr.getSwitchValues = Lr.getLightTree = Lr.getItemByPath = Lr.getFlatTree = Lr.fixPathsInTree = Lr.fixEmptyGroupsInTree = Lr.expandTreeSubpath = Lr.expandTreePath = void 0;
  var t = e(Zu), n = e(Yr()), o = e(uc()), r = function(y) {
    for (var w = arguments.length, N = new Array(w > 1 ? w - 1 : 0), M = 1; M < w; M++)
      N[M - 1] = arguments[M];
    return y.interpose("children1").withMutations(function(q) {
      return q.skip(1), q.push.apply(q, N), q;
    });
  };
  Lr.expandTreePath = r;
  var i = function(y) {
    for (var w = arguments.length, N = new Array(w > 1 ? w - 1 : 0), M = 1; M < w; M++)
      N[M - 1] = arguments[M];
    return y.interpose("children1").withMutations(function(q) {
      return q.push.apply(q, N), q;
    });
  };
  Lr.expandTreeSubpath = i;
  var a = function(y, w) {
    var N = new o.default.OrderedMap((0, n.default)({}, y.get("id"), y)), M = y;
    return w.forEach(function(q) {
      M = N.get(q), N = M.get("children1");
    }), M;
  };
  Lr.getItemByPath = a;
  var s = function(y) {
    var w = y;
    function N(M, q) {
      var L = q.push(M.get("id"));
      M.get("path") && (w = w.removeIn(r(L, "path")));
      var R = M.get("children1");
      R && R.map(function(T, D) {
        N(T, L);
      });
    }
    return N(y, new o.default.List()), w;
  };
  Lr.removePathsInTree = s;
  var c = function(y) {
    var w = y;
    function N(M, q) {
      var L = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, R = q.push(M.get("id")), T = M.getIn(["properties", "isLocked"]);
      L && T && (w = w.deleteIn(r(R, "properties", "isLocked")));
      var D = M.get("children1");
      D && D.map(function(A, S) {
        N(A, R, T || L);
      });
    }
    return N(y, new o.default.List()), w;
  };
  Lr.removeIsLockedInTree = c;
  var l = function(y) {
    var w = y;
    function N(M, q, L, R) {
      if (M) {
        var T = M.get("path"), D = M.get("id"), A = D || R, S = q.push(A);
        (!T || !T.equals(S)) && (w = w.setIn(r(S, "path"), S)), D || (w = w.setIn(r(S, "id"), A));
        var E = M.get("children1");
        E && (E.constructor.name == "Map" && (w = w.setIn(r(S, "children1"), new o.default.OrderedMap(E))), E.map(function(x, k) {
          N(x, S, L + 1, k);
        }));
      }
    }
    return N(y, new o.default.List(), 0), w;
  };
  Lr.fixPathsInTree = l;
  var u = function(y) {
    var w = y;
    function N(M, q, L, R) {
      if (!M)
        return !1;
      var T = M.get("id") || R, D = q.push(T), A = M.get("children1");
      if (A) {
        var S = A.map(function(E, x) {
          return N(E, D, L + 1, x);
        }).reduce(function(E, x) {
          return E && x;
        }, !0);
        if ((A.size == 0 || S) && L > 0)
          return w = w.deleteIn(r(D)), !0;
      }
      return !1;
    }
    return N(y, new o.default.List(), 0), w;
  };
  Lr.fixEmptyGroupsInTree = u;
  var d = function(y) {
    var w = [], N = {}, M = 0;
    function q(A, S, E, x, k, I, z, F, P) {
      var O = A.get("type"), V = A.get("collapsed"), U = A.get("id"), H = A.get("children1"), J = A.getIn(["properties", "isLocked"]), le = H ? H.map(function(Q, me) {
        return me;
      }) : null, ae = O == "rule_group", Y = !k && (!H || ae), re = w.length, ie = M;
      if (w.push(U), E || (M += 1), z.height = (z.height || 0) + 1, N[U] = {
        type: O,
        parent: S.length ? S[S.length - 1] : null,
        parentType: F,
        caseId: O == "case_group" ? U : P,
        isDefaultCase: O == "case_group" && !H,
        path: S.concat(U),
        lev: I,
        leaf: !H,
        index: re,
        id: U,
        children: le,
        leafsCount: 0,
        _top: re,
        _height: he - re,
        top: E ? null : ie,
        height: be,
        bottom: (E ? null : ie) + be,
        collapsed: V,
        node: A,
        isLocked: J || x
      }, H) {
        var _e = {};
        H.map(function(Q, me) {
          q(Q, S.concat(U), E || V, x || J, k || ae, I + 1, _e, O, O == "case_group" ? U : P);
        }), V || (z.height = (z.height || 0) + (_e.height || 0));
      }
      P && Y && N[P].leafsCount++;
      var he = w.length, be = z.height;
      Object.assign(N[U], {
        _height: he - re,
        height: be,
        bottom: (E ? null : ie) + be
      });
    }
    q(y, [], !1, !1, !1, 0, {}, null, null);
    for (var L = 0; L < w.length; L++) {
      var R = L > 0 ? w[L - 1] : null, T = L < w.length - 1 ? w[L + 1] : null, D = N[w[L]];
      D.prev = R, D.next = T;
    }
    return {
      flat: w,
      items: N
    };
  };
  Lr.getFlatTree = d;
  var _ = function(y) {
    if (!y)
      return -1;
    var w = 0;
    function N(M, q, L) {
      var R, T, D;
      typeof M.get == "function" ? (R = M.get("id"), T = M.get("children1"), D = M.get("type")) : (R = M.id, T = M.children1, D = M.type);
      var A = D == "rule_group";
      w++, T && !A && T.map(function(S, E) {
        N(S, q.concat(R));
      });
    }
    return N(y, []), w - 1;
  };
  Lr.getTotalReordableNodesCountInTree = _;
  var p = function(y) {
    if (!y)
      return -1;
    var w = 0;
    function N(M, q, L) {
      var R, T, D;
      typeof M.get == "function" ? (R = M.get("id"), T = M.get("children1"), D = M.get("type")) : (R = M.id, T = M.children1, D = M.type);
      var A = D == "rule_group";
      T && !A ? T.map(function(S, E) {
        N(S, q.concat(R));
      }) : w++;
    }
    return N(y, []), w;
  };
  Lr.getTotalRulesCountInTree = p;
  var g = function(y) {
    var w = [];
    function N(M, q, L) {
      var R = M.get("id"), T = M.get("children1"), D = M.getIn(["properties", "valueError"]), A = M.getIn(["properties", "field"]);
      D && D.size > 0 && D.filter(function(S) {
        return S != null;
      }).size > 0 && w.push(A), T && T.map(function(S, E) {
        N(S, q.concat(R));
      });
    }
    return y && N(y, []), Array.from(new Set(w));
  };
  Lr.getTreeBadFields = g;
  var f = function(y) {
    var w = y;
    function N(M, q) {
      M.path && delete M.path, q && delete M.id;
      var L = M.properties;
      L && L.operatorOptions == null && delete L.operatorOptions;
      var R = M.children1;
      if (R)
        for (var T in R)
          N(R[T], T);
    }
    return N(y, null), w;
  };
  Lr.getLightTree = f;
  var h = function(y) {
    var w = [], N = y.get("children1");
    return N && N.map(function(M) {
      var q = M.getIn(["properties", "value"]), L;
      q && q.size == 1 ? (L = q.get(0), Array.isArray(L) && L.length == 0 && (L = null)) : L = null, w = [].concat((0, t.default)(w), [L]);
    }), w;
  };
  Lr.getSwitchValues = h;
  var $ = function(y) {
    return !y.get("children1") || y.get("children1").size == 0;
  };
  Lr.isEmptyTree = $;
  var v = function(y, w) {
    return y.getIn(r(w, "children1")).size > 0;
  };
  return Lr.hasChildren = v, Lr;
}
var Ca = {}, $P = {}, AQ;
function Ug() {
  return AQ || (AQ = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = 0, n = function() {
      var r = ((/* @__PURE__ */ new Date()).getTime().toString(16) + "FF").substr(0, 11), i = "ssssssss-xxxx-4xxx-yxxx-x".replace(/[xys]/g, function(a) {
        var s = a === "s" ? Math.floor(Math.random() * 16) : t++ & 15, c = a === "x" ? s : s & 3 | 8;
        return c.toString(16);
      });
      return i + r;
    };
    e.default = n;
  }($P)), $P;
}
var vs = {}, wP, IQ;
function fXl() {
  if (IQ)
    return wP;
  IQ = 1;
  var e = r2;
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return wP = t, wP;
}
var kP, OQ;
function gXl() {
  if (OQ)
    return kP;
  OQ = 1;
  function e(t) {
    var n = this.__data__, o = n.delete(t);
    return this.size = n.size, o;
  }
  return kP = e, kP;
}
var SP, NQ;
function hXl() {
  if (NQ)
    return SP;
  NQ = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return SP = e, SP;
}
var EP, zQ;
function vXl() {
  if (zQ)
    return EP;
  zQ = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return EP = e, EP;
}
var xP, RQ;
function bXl() {
  if (RQ)
    return xP;
  RQ = 1;
  var e = r2, t = Kj, n = Zj, o = 200;
  function r(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < o - 1)
        return c.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(c);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return xP = r, xP;
}
var CP, PQ;
function u2() {
  if (PQ)
    return CP;
  PQ = 1;
  var e = r2, t = fXl(), n = gXl(), o = hXl(), r = vXl(), i = bXl();
  function a(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = o, a.prototype.has = r, a.prototype.set = i, CP = a, CP;
}
var TP, DQ;
function Gbe() {
  if (DQ)
    return TP;
  DQ = 1;
  var e = Rv, t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return TP = t, TP;
}
var AP, LQ;
function d2() {
  if (LQ)
    return AP;
  LQ = 1;
  var e = Gbe();
  function t(n, o, r) {
    o == "__proto__" && e ? e(n, o, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }) : n[o] = r;
  }
  return AP = t, AP;
}
var IP, MQ;
function Wbe() {
  if (MQ)
    return IP;
  MQ = 1;
  var e = d2(), t = l1();
  function n(o, r, i) {
    (i !== void 0 && !t(o[r], i) || i === void 0 && !(r in o)) && e(o, r, i);
  }
  return IP = n, IP;
}
var OP, FQ;
function yXl() {
  if (FQ)
    return OP;
  FQ = 1;
  function e(t) {
    return function(n, o, r) {
      for (var i = -1, a = Object(n), s = r(n), c = s.length; c--; ) {
        var l = s[t ? c : ++i];
        if (o(a[l], l, a) === !1)
          break;
      }
      return n;
    };
  }
  return OP = e, OP;
}
var NP, qQ;
function Hbe() {
  if (qQ)
    return NP;
  qQ = 1;
  var e = yXl(), t = e();
  return NP = t, NP;
}
var Pw = { exports: {} };
Pw.exports;
var jQ;
function Ybe() {
  return jQ || (jQ = 1, function(e, t) {
    var n = K_, o = t && !t.nodeType && t, r = o && !0 && e && !e.nodeType && e, i = r && r.exports === o, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function c(l, u) {
      if (u)
        return l.slice();
      var d = l.length, _ = s ? s(d) : new l.constructor(d);
      return l.copy(_), _;
    }
    e.exports = c;
  }(Pw, Pw.exports)), Pw.exports;
}
var zP, VQ;
function Kbe() {
  if (VQ)
    return zP;
  VQ = 1;
  var e = K_, t = e.Uint8Array;
  return zP = t, zP;
}
var RP, BQ;
function lV() {
  if (BQ)
    return RP;
  BQ = 1;
  var e = Kbe();
  function t(n) {
    var o = new n.constructor(n.byteLength);
    return new e(o).set(new e(n)), o;
  }
  return RP = t, RP;
}
var PP, UQ;
function Zbe() {
  if (UQ)
    return PP;
  UQ = 1;
  var e = lV();
  function t(n, o) {
    var r = o ? e(n.buffer) : n.buffer;
    return new n.constructor(r, n.byteOffset, n.length);
  }
  return PP = t, PP;
}
var DP, GQ;
function $Xl() {
  if (GQ)
    return DP;
  GQ = 1;
  var e = Vd, t = Object.create, n = /* @__PURE__ */ function() {
    function o() {
    }
    return function(r) {
      if (!e(r))
        return {};
      if (t)
        return t(r);
      o.prototype = r;
      var i = new o();
      return o.prototype = void 0, i;
    };
  }();
  return DP = n, DP;
}
var LP, WQ;
function uV() {
  if (WQ)
    return LP;
  WQ = 1;
  var e = Wme, t = e(Object.getPrototypeOf, Object);
  return LP = t, LP;
}
var MP, HQ;
function Xbe() {
  if (HQ)
    return MP;
  HQ = 1;
  var e = $Xl(), t = uV(), n = Vq;
  function o(r) {
    return typeof r.constructor == "function" && !n(r) ? e(t(r)) : {};
  }
  return MP = o, MP;
}
var FP, YQ;
function wXl() {
  if (YQ)
    return FP;
  YQ = 1;
  var e = EA, t = Cf;
  function n(o) {
    return t(o) && e(o);
  }
  return FP = n, FP;
}
var qP, KQ;
function Jbe() {
  if (KQ)
    return qP;
  KQ = 1;
  var e = n$, t = uV(), n = Cf, o = "[object Object]", r = Function.prototype, i = Object.prototype, a = r.toString, s = i.hasOwnProperty, c = a.call(Object);
  function l(u) {
    if (!n(u) || e(u) != o)
      return !1;
    var d = t(u);
    if (d === null)
      return !0;
    var _ = s.call(d, "constructor") && d.constructor;
    return typeof _ == "function" && _ instanceof _ && a.call(_) == c;
  }
  return qP = l, qP;
}
var jP, ZQ;
function Qbe() {
  if (ZQ)
    return jP;
  ZQ = 1;
  function e(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  return jP = e, jP;
}
var VP, XQ;
function dV() {
  if (XQ)
    return VP;
  XQ = 1;
  var e = d2(), t = l1(), n = Object.prototype, o = n.hasOwnProperty;
  function r(i, a, s) {
    var c = i[a];
    (!(o.call(i, a) && t(c, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return VP = r, VP;
}
var BP, JQ;
function f$() {
  if (JQ)
    return BP;
  JQ = 1;
  var e = dV(), t = d2();
  function n(o, r, i, a) {
    var s = !i;
    i || (i = {});
    for (var c = -1, l = r.length; ++c < l; ) {
      var u = r[c], d = a ? a(i[u], o[u], u, i, o) : void 0;
      d === void 0 && (d = o[u]), s ? t(i, u, d) : e(i, u, d);
    }
    return i;
  }
  return BP = n, BP;
}
var UP, QQ;
function kXl() {
  if (QQ)
    return UP;
  QQ = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var o in Object(t))
        n.push(o);
    return n;
  }
  return UP = e, UP;
}
var GP, eee;
function SXl() {
  if (eee)
    return GP;
  eee = 1;
  var e = Vd, t = Vq, n = kXl(), o = Object.prototype, r = o.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), c = [];
    for (var l in a)
      l == "constructor" && (s || !r.call(a, l)) || c.push(l);
    return c;
  }
  return GP = i, GP;
}
var WP, tee;
function p1() {
  if (tee)
    return WP;
  tee = 1;
  var e = Gme, t = SXl(), n = EA;
  function o(r) {
    return n(r) ? e(r, !0) : t(r);
  }
  return WP = o, WP;
}
var HP, nee;
function EXl() {
  if (nee)
    return HP;
  nee = 1;
  var e = f$(), t = p1();
  function n(o) {
    return e(o, t(o));
  }
  return HP = n, HP;
}
var YP, oee;
function xXl() {
  if (oee)
    return YP;
  oee = 1;
  var e = Wbe(), t = Ybe(), n = Zbe(), o = jme, r = Xbe(), i = wA, a = Z_, s = wXl(), c = kA, l = Bq, u = Vd, d = Jbe(), _ = jq, p = Qbe(), g = EXl();
  function f(h, $, v, b, y, w, N) {
    var M = p(h, v), q = p($, v), L = N.get(q);
    if (L) {
      e(h, v, L);
      return;
    }
    var R = w ? w(M, q, v + "", h, $, N) : void 0, T = R === void 0;
    if (T) {
      var D = a(q), A = !D && c(q), S = !D && !A && _(q);
      R = q, D || A || S ? a(M) ? R = M : s(M) ? R = o(M) : A ? (T = !1, R = t(q, !0)) : S ? (T = !1, R = n(q, !0)) : R = [] : d(q) || i(q) ? (R = M, i(M) ? R = g(M) : (!u(M) || l(M)) && (R = r(q))) : T = !1;
    }
    T && (N.set(q, R), y(R, q, b, w, N), N.delete(q)), e(h, v, R);
  }
  return YP = f, YP;
}
var KP, ree;
function eye() {
  if (ree)
    return KP;
  ree = 1;
  var e = u2(), t = Wbe(), n = Hbe(), o = xXl(), r = Vd, i = p1(), a = Qbe();
  function s(c, l, u, d, _) {
    c !== l && n(l, function(p, g) {
      if (_ || (_ = new e()), r(p))
        o(c, l, g, u, s, d, _);
      else {
        var f = d ? d(a(c, g), p, g + "", c, l, _) : void 0;
        f === void 0 && (f = p), t(c, g, f);
      }
    }, i);
  }
  return KP = s, KP;
}
var ZP, iee;
function _V() {
  if (iee)
    return ZP;
  iee = 1;
  function e(t) {
    return t;
  }
  return ZP = e, ZP;
}
var XP, aee;
function CXl() {
  if (aee)
    return XP;
  aee = 1;
  function e(t, n, o) {
    switch (o.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, o[0]);
      case 2:
        return t.call(n, o[0], o[1]);
      case 3:
        return t.call(n, o[0], o[1], o[2]);
    }
    return t.apply(n, o);
  }
  return XP = e, XP;
}
var JP, see;
function tye() {
  if (see)
    return JP;
  see = 1;
  var e = CXl(), t = Math.max;
  function n(o, r, i) {
    return r = t(r === void 0 ? o.length - 1 : r, 0), function() {
      for (var a = arguments, s = -1, c = t(a.length - r, 0), l = Array(c); ++s < c; )
        l[s] = a[r + s];
      s = -1;
      for (var u = Array(r + 1); ++s < r; )
        u[s] = a[s];
      return u[r] = i(l), e(o, this, u);
    };
  }
  return JP = n, JP;
}
var QP, cee;
function TXl() {
  if (cee)
    return QP;
  cee = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return QP = e, QP;
}
var eD, lee;
function AXl() {
  if (lee)
    return eD;
  lee = 1;
  var e = TXl(), t = Gbe(), n = _V(), o = t ? function(r, i) {
    return t(r, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return eD = o, eD;
}
var tD, uee;
function IXl() {
  if (uee)
    return tD;
  uee = 1;
  var e = 800, t = 16, n = Date.now;
  function o(r) {
    var i = 0, a = 0;
    return function() {
      var s = n(), c = t - (s - a);
      if (a = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return r.apply(void 0, arguments);
    };
  }
  return tD = o, tD;
}
var nD, dee;
function nye() {
  if (dee)
    return nD;
  dee = 1;
  var e = AXl(), t = IXl(), n = t(e);
  return nD = n, nD;
}
var oD, _ee;
function OXl() {
  if (_ee)
    return oD;
  _ee = 1;
  var e = _V(), t = tye(), n = nye();
  function o(r, i) {
    return n(t(r, i, e), r + "");
  }
  return oD = o, oD;
}
var rD, pee;
function oye() {
  if (pee)
    return rD;
  pee = 1;
  var e = l1(), t = EA, n = SA, o = Vd;
  function r(i, a, s) {
    if (!o(s))
      return !1;
    var c = typeof a;
    return (c == "number" ? t(s) && n(a, s.length) : c == "string" && a in s) ? e(s[a], i) : !1;
  }
  return rD = r, rD;
}
var iD, mee;
function rye() {
  if (mee)
    return iD;
  mee = 1;
  var e = OXl(), t = oye();
  function n(o) {
    return e(function(r, i) {
      var a = -1, s = i.length, c = s > 1 ? i[s - 1] : void 0, l = s > 2 ? i[2] : void 0;
      for (c = o.length > 3 && typeof c == "function" ? (s--, c) : void 0, l && t(i[0], i[1], l) && (c = s < 3 ? void 0 : c, s = 1), r = Object(r); ++a < s; ) {
        var u = i[a];
        u && o(r, u, a, c);
      }
      return r;
    });
  }
  return iD = n, iD;
}
var aD, fee;
function NXl() {
  if (fee)
    return aD;
  fee = 1;
  var e = eye(), t = rye(), n = t(function(o, r, i) {
    e(o, r, i);
  });
  return aD = n, aD;
}
var sD, gee;
function zXl() {
  if (gee)
    return sD;
  gee = 1;
  var e = eye(), t = rye(), n = t(function(o, r, i, a) {
    e(o, r, i, a);
  });
  return sD = n, sD;
}
var pw = {}, cD = {}, lD = {}, Qr = {}, ko = {}, hee;
function Ti() {
  if (hee)
    return ko;
  hee = 1;
  var e = Tn, t = xo;
  Object.defineProperty(ko, "__esModule", {
    value: !0
  }), ko.applyToJS = O, ko.mapListValues = ko.logger = ko.listValuesToArray = ko.isJsonLogic = ko.isImmutable = ko.immutableEqual = ko.getValueInListValues = ko.getTitleInListValues = ko.getLogger = ko.getItemInListValues = ko.getFirstDefined = ko.flatizeTreeData = ko.escapeRegExp = ko.eqSet = ko.eqArrSet = ko.defaultValue = ko.defaultTreeDataMap = ko.deepEqual = void 0, ko.mergeArraysSmart = U, ko.shallowEqual = ko.removePrefixPath = ko.normalizeListValues = void 0, ko.sleep = F, ko.toImmutableList = V, ko.truncateString = void 0;
  var n = e(Gu()), o = e(Zu), r = e(xo), i = s(uc());
  function a(Y) {
    if (typeof WeakMap != "function")
      return null;
    var re = /* @__PURE__ */ new WeakMap(), ie = /* @__PURE__ */ new WeakMap();
    return (a = function(he) {
      return he ? ie : re;
    })(Y);
  }
  function s(Y, re) {
    if (!re && Y && Y.__esModule)
      return Y;
    if (Y === null || t(Y) !== "object" && typeof Y != "function")
      return { default: Y };
    var ie = a(re);
    if (ie && ie.has(Y))
      return ie.get(Y);
    var _e = {}, he = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var be in Y)
      if (be !== "default" && Object.prototype.hasOwnProperty.call(Y, be)) {
        var Q = he ? Object.getOwnPropertyDescriptor(Y, be) : null;
        Q && (Q.get || Q.set) ? Object.defineProperty(_e, be, Q) : _e[be] = Y[be];
      }
    return _e.default = Y, ie && ie.set(Y, _e), _e;
  }
  function c(Y, re) {
    var ie = typeof Symbol < "u" && Y[Symbol.iterator] || Y["@@iterator"];
    if (!ie) {
      if (Array.isArray(Y) || (ie = l(Y)) || re && Y && typeof Y.length == "number") {
        ie && (Y = ie);
        var _e = 0, he = function() {
        };
        return { s: he, n: function() {
          return _e >= Y.length ? { done: !0 } : { done: !1, value: Y[_e++] };
        }, e: function(pe) {
          throw pe;
        }, f: he };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var be = !0, Q = !1, me;
    return { s: function() {
      ie = ie.call(Y);
    }, n: function() {
      var pe = ie.next();
      return be = pe.done, pe;
    }, e: function(pe) {
      Q = !0, me = pe;
    }, f: function() {
      try {
        !be && ie.return != null && ie.return();
      } finally {
        if (Q)
          throw me;
      }
    } };
  }
  function l(Y, re) {
    if (Y) {
      if (typeof Y == "string")
        return u(Y, re);
      var ie = Object.prototype.toString.call(Y).slice(8, -1);
      if (ie === "Object" && Y.constructor && (ie = Y.constructor.name), ie === "Map" || ie === "Set")
        return Array.from(Y);
      if (ie === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ie))
        return u(Y, re);
    }
  }
  function u(Y, re) {
    (re == null || re > Y.length) && (re = Y.length);
    for (var ie = 0, _e = new Array(re); ie < re; ie++)
      _e[ie] = Y[ie];
    return _e;
  }
  var d = function(re, ie) {
    return typeof re > "u" ? ie : re;
  };
  ko.defaultValue = d;
  var _ = function(re, ie, _e) {
    if (!ie || re.length <= ie)
      return re;
    var he = re.substr(0, ie - 1);
    return (_e ? he.substr(0, he.lastIndexOf(" ")) : he) + "...";
  };
  ko.truncateString = _;
  var p = function(re, ie) {
    return re === ie ? !0 : re.equals(ie);
  };
  ko.immutableEqual = p;
  var g = function(re, ie) {
    return re === ie ? !0 : i.Map.isMap(re) ? re.equals(ie) : JSON.stringify(re) == JSON.stringify(ie);
  };
  ko.deepEqual = g;
  var f = function(re, ie) {
    if (re.size !== ie.size)
      return !1;
    var _e = c(re), he;
    try {
      for (_e.s(); !(he = _e.n()).done; ) {
        var be = he.value;
        if (!ie.has(be))
          return !1;
      }
    } catch (Q) {
      _e.e(Q);
    } finally {
      _e.f();
    }
    return !0;
  };
  ko.eqSet = f;
  var h = function(re, ie) {
    return f(new Set(re), new Set(ie));
  };
  ko.eqArrSet = h;
  var $ = function(re, ie) {
    var _e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return re === ie ? !0 : Array.isArray(re) ? v(re, ie, _e) : i.Map.isMap(re) ? re.equals(ie) : (0, r.default)(re) == "object" ? b(re, ie, _e) : re === ie;
  };
  ko.shallowEqual = $;
  function v(Y, re) {
    var ie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (Y === re)
      return !0;
    if (!Y || !re)
      return !1;
    var _e = Y.length;
    if (re.length !== _e)
      return !1;
    for (var he = 0; he < _e; he++) {
      var be = ie ? $(Y[he], re[he], ie) : Y[he] === re[he];
      if (!be)
        return !1;
    }
    return !0;
  }
  function b(Y, re) {
    var ie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (Y === re)
      return !0;
    if (!Y || !re)
      return !1;
    var _e = Object.keys(Y), he = Object.keys(re), be = _e.length;
    if (he.length !== be)
      return !1;
    for (var Q = 0; Q < be; Q++) {
      var me = _e[Q], ne = ie ? $(Y[me], re[me], ie) : Y[me] === re[me];
      if (!ne)
        return !1;
    }
    return !0;
  }
  var y = function(re) {
    return re.replace(/[.*+?^${}()|[\]\\/]/g, "\\$&");
  };
  ko.escapeRegExp = y;
  var w = function(re) {
    return (0, r.default)(re) == "object" && re !== null;
  }, N = function(re, ie) {
    return w(re) ? re : {
      value: re,
      title: ie !== void 0 ? ie : re
    };
  }, M = function(re) {
    if (!w(re))
      return re;
    if (Array.isArray(re))
      return re.map(function(be) {
        return N(be);
      });
    var ie = [];
    for (var _e in re) {
      var he = re[_e];
      ie.push(N(_e, he));
    }
    return ie;
  };
  ko.listValuesToArray = M;
  var q = function(re, ie) {
    if (Array.isArray(re)) {
      var _e = re.map(function(he) {
        return N(he);
      });
      return _e.find(function(he) {
        return he.value === ie;
      }) || _e.find(function(he) {
        return "".concat(he.value) === ie;
      });
    } else
      return re[ie] !== void 0 ? N(ie, re[ie]) : void 0;
  };
  ko.getItemInListValues = q;
  var L = function(re, ie) {
    if (re == null)
      return ie;
    var _e = q(re, ie);
    return _e !== void 0 ? _e.title : ie;
  };
  ko.getTitleInListValues = L;
  var R = function(re, ie) {
    if (re == null)
      return ie;
    var _e = q(re, ie);
    return _e !== void 0 ? _e.value : ie;
  };
  ko.getValueInListValues = R;
  var T = function(re, ie) {
    var _e = [];
    if (Array.isArray(re)) {
      var he = c(re), be;
      try {
        for (he.s(); !(be = he.n()).done; ) {
          var Q = be.value, me = ie(N(Q));
          me != null && _e.push(me);
        }
      } catch (ge) {
        he.e(ge);
      } finally {
        he.f();
      }
    } else
      for (var ne in re) {
        var pe = ie(N(ne, re[ne]));
        pe != null && _e.push(pe);
      }
    return _e;
  };
  ko.mapListValues = T;
  var D = {
    id: "value",
    pId: "parent",
    rootPId: void 0
  };
  ko.defaultTreeDataMap = D;
  var A = function(re) {
    var ie = D, _e, he, be = function me(ne, pe, ge) {
      if (ne.children) {
        ge == 1 && (ne[ie.pId] = ie.rootPId);
        var ve = ne.children.length, Te = c(ne.children), Re;
        try {
          for (Te.s(); !(Re = Te.n()).done; ) {
            var Me = Re.value;
            Me[ie.pId] = ne[ie.id], _e++, pe.splice(_e, 0, Me), he++, me(Me, pe, ge + 1);
          }
        } catch (et) {
          Te.e(et);
        } finally {
          Te.f();
        }
        delete ne.children, ve == 0 && (pe.splice(_e, 1), _e--, he--);
      }
    };
    if (Array.isArray(re))
      for (he = re.length, _e = 0; _e < he; _e++) {
        var Q = re[_e];
        w(Q) && (Q[ie.pId] !== void 0 && Q[ie.pId] != ie.rootPId || be(Q, re, 1));
      }
    return re;
  };
  ko.flatizeTreeData = A;
  var S = function Y(re, ie) {
    var _e = D, he = q(re, ie), be = he ? he[_e.pId] : void 0, Q = be ? re.find(function(me) {
      return me[_e.id] === be;
    }) : void 0;
    return Q ? [Q.value].concat((0, o.default)(Y(re, Q.value))) : [];
  }, E = function(re, ie) {
    var _e = D, he = q(re, ie);
    return he ? re.filter(function(be) {
      return be[_e.pId] === he[_e.id];
    }).map(function(be) {
      return be.value;
    }) : [];
  }, x = function(re, ie, _e) {
    var he = c(re), be;
    try {
      for (he.s(); !(be = he.n()).done; ) {
        var Q = be.value;
        if (Q.path = S(re, Q.value), ie.treeSelectOnlyLeafs != !1) {
          var me = E(re, Q.value);
          _e || (Q.selectable = me.length == 0);
        }
      }
    } catch (ne) {
      he.e(ne);
    } finally {
      he.f();
    }
    return re;
  }, k = function(re, ie, _e) {
    var he = ["treeselect", "treemultiselect"].includes(ie), be = ["multiselect", "treemultiselect"].includes(ie);
    return he && (re = M(re), re = A(re), re = x(re, _e, be)), re;
  };
  ko.normalizeListValues = k;
  var I = function(re, ie) {
    if (!re)
      return re;
    for (var _e = !0, he = 0; he < ie.length; he++) {
      var be = ie[he];
      if (!(re[he] !== void 0 && be == re[he])) {
        _e = !1;
        break;
      }
    }
    return _e ? re.slice(ie.length) : re;
  };
  ko.removePrefixPath = I;
  var z = function(re) {
    return (0, r.default)(re) === "object" && re !== null && !Array.isArray(re) && Object.keys(re).length === 1;
  };
  ko.isJsonLogic = z;
  function F(Y) {
    return new Promise(function(re) {
      setTimeout(re, Y);
    });
  }
  var P = function(re) {
    return (0, r.default)(re) === "object" && re !== null && typeof re.toJS == "function";
  };
  ko.isImmutable = P;
  function O(Y) {
    return P(Y) ? Y.toJS() : Y;
  }
  function V(Y) {
    return P(Y) ? Y : new i.default.List(Y);
  }
  function U(Y, re) {
    return Y || (Y = []), re || (re = []), re.map(function(ie) {
      return [ie, Y.indexOf(ie)];
    }).map(function(ie, _e, he) {
      var be = (0, n.default)(ie, 2), Q = be[0], me = be[1];
      if (me == -1) {
        var ne = he.slice(_e + 1), pe = he.slice(0, _e), ge = pe.reverse().find(function(Te) {
          var Re = (0, n.default)(Te, 2);
          Re[0];
          var Me = Re[1];
          return Me != -1;
        }), ve = ne.find(function(Te) {
          var Re = (0, n.default)(Te, 2);
          Re[0];
          var Me = Re[1];
          return Me != -1;
        });
        return ve ? [Q, "before", ve[0]] : ge ? [Q, "after", ge[0]] : [Q, "append", null];
      } else
        return null;
    }).filter(function(ie) {
      return ie !== null;
    }).reduce(function(ie, _e) {
      var he = (0, n.default)(_e, 3), be = he[0], Q = he[1], me = he[2], ne = ie.indexOf(me);
      return ie.indexOf(be) == -1 && (ne > -1 ? ie.splice(ne + (Q == "after" ? 1 : 0), 0, be) : ie.splice(Q == "append" ? 1 / 0 : 0, 0, be)), ie;
    }, Y.slice());
  }
  var H = function() {
    return process && process.env && process.env.NODE_ENV == "development";
  }, J = function() {
    var re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, ie = re ?? H();
    return ie ? console : {
      error: function() {
      },
      log: function() {
      },
      warn: function() {
      },
      debug: function() {
      },
      info: function() {
      }
    };
  };
  ko.getLogger = J;
  var le = function() {
    for (var re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ie, _e = 0; _e < re.length; _e++) {
      var he = re[_e];
      if (he !== void 0) {
        ie = he;
        break;
      }
    }
    return ie;
  };
  ko.getFirstDefined = le;
  var ae = J();
  return ko.logger = ae, ko;
}
var gh = {}, uD, vee;
function RXl() {
  if (vee)
    return uD;
  vee = 1;
  function e(t, n) {
    for (var o = -1, r = t == null ? 0 : t.length; ++o < r && n(t[o], o, t) !== !1; )
      ;
    return t;
  }
  return uD = e, uD;
}
var dD, bee;
function PXl() {
  if (bee)
    return dD;
  bee = 1;
  var e = f$(), t = Tf;
  function n(o, r) {
    return o && e(r, t(r), o);
  }
  return dD = n, dD;
}
var _D, yee;
function DXl() {
  if (yee)
    return _D;
  yee = 1;
  var e = f$(), t = p1();
  function n(o, r) {
    return o && e(r, t(r), o);
  }
  return _D = n, _D;
}
var pD, $ee;
function LXl() {
  if ($ee)
    return pD;
  $ee = 1;
  function e(t, n) {
    for (var o = -1, r = t == null ? 0 : t.length, i = 0, a = []; ++o < r; ) {
      var s = t[o];
      n(s, o, t) && (a[i++] = s);
    }
    return a;
  }
  return pD = e, pD;
}
var mD, wee;
function iye() {
  if (wee)
    return mD;
  wee = 1;
  function e() {
    return [];
  }
  return mD = e, mD;
}
var fD, kee;
function pV() {
  if (kee)
    return fD;
  kee = 1;
  var e = LXl(), t = iye(), n = Object.prototype, o = n.propertyIsEnumerable, r = Object.getOwnPropertySymbols, i = r ? function(a) {
    return a == null ? [] : (a = Object(a), e(r(a), function(s) {
      return o.call(a, s);
    }));
  } : t;
  return fD = i, fD;
}
var gD, See;
function MXl() {
  if (See)
    return gD;
  See = 1;
  var e = f$(), t = pV();
  function n(o, r) {
    return e(o, t(o), r);
  }
  return gD = n, gD;
}
var hD, Eee;
function mV() {
  if (Eee)
    return hD;
  Eee = 1;
  function e(t, n) {
    for (var o = -1, r = n.length, i = t.length; ++o < r; )
      t[i + o] = n[o];
    return t;
  }
  return hD = e, hD;
}
var vD, xee;
function aye() {
  if (xee)
    return vD;
  xee = 1;
  var e = mV(), t = uV(), n = pV(), o = iye(), r = Object.getOwnPropertySymbols, i = r ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : o;
  return vD = i, vD;
}
var bD, Cee;
function FXl() {
  if (Cee)
    return bD;
  Cee = 1;
  var e = f$(), t = aye();
  function n(o, r) {
    return e(o, t(o), r);
  }
  return bD = n, bD;
}
var yD, Tee;
function sye() {
  if (Tee)
    return yD;
  Tee = 1;
  var e = mV(), t = Z_;
  function n(o, r, i) {
    var a = r(o);
    return t(o) ? a : e(a, i(o));
  }
  return yD = n, yD;
}
var $D, Aee;
function cye() {
  if (Aee)
    return $D;
  Aee = 1;
  var e = sye(), t = pV(), n = Tf;
  function o(r) {
    return e(r, n, t);
  }
  return $D = o, $D;
}
var wD, Iee;
function fV() {
  if (Iee)
    return wD;
  Iee = 1;
  var e = sye(), t = aye(), n = p1();
  function o(r) {
    return e(r, n, t);
  }
  return wD = o, wD;
}
var kD, Oee;
function qXl() {
  if (Oee)
    return kD;
  Oee = 1;
  var e = Rv, t = K_, n = e(t, "DataView");
  return kD = n, kD;
}
var SD, Nee;
function jXl() {
  if (Nee)
    return SD;
  Nee = 1;
  var e = Rv, t = K_, n = e(t, "Promise");
  return SD = n, SD;
}
var ED, zee;
function VXl() {
  if (zee)
    return ED;
  zee = 1;
  var e = Rv, t = K_, n = e(t, "Set");
  return ED = n, ED;
}
var xD, Ree;
function BXl() {
  if (Ree)
    return xD;
  Ree = 1;
  var e = Rv, t = K_, n = e(t, "WeakMap");
  return xD = n, xD;
}
var CD, Pee;
function _2() {
  if (Pee)
    return CD;
  Pee = 1;
  var e = qXl(), t = Kj, n = jXl(), o = VXl(), r = BXl(), i = n$, a = kve(), s = "[object Map]", c = "[object Object]", l = "[object Promise]", u = "[object Set]", d = "[object WeakMap]", _ = "[object DataView]", p = a(e), g = a(t), f = a(n), h = a(o), $ = a(r), v = i;
  return (e && v(new e(new ArrayBuffer(1))) != _ || t && v(new t()) != s || n && v(n.resolve()) != l || o && v(new o()) != u || r && v(new r()) != d) && (v = function(b) {
    var y = i(b), w = y == c ? b.constructor : void 0, N = w ? a(w) : "";
    if (N)
      switch (N) {
        case p:
          return _;
        case g:
          return s;
        case f:
          return l;
        case h:
          return u;
        case $:
          return d;
      }
    return y;
  }), CD = v, CD;
}
var TD, Dee;
function UXl() {
  if (Dee)
    return TD;
  Dee = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(o) {
    var r = o.length, i = new o.constructor(r);
    return r && typeof o[0] == "string" && t.call(o, "index") && (i.index = o.index, i.input = o.input), i;
  }
  return TD = n, TD;
}
var AD, Lee;
function GXl() {
  if (Lee)
    return AD;
  Lee = 1;
  var e = lV();
  function t(n, o) {
    var r = o ? e(n.buffer) : n.buffer;
    return new n.constructor(r, n.byteOffset, n.byteLength);
  }
  return AD = t, AD;
}
var ID, Mee;
function WXl() {
  if (Mee)
    return ID;
  Mee = 1;
  var e = /\w*$/;
  function t(n) {
    var o = new n.constructor(n.source, e.exec(n));
    return o.lastIndex = n.lastIndex, o;
  }
  return ID = t, ID;
}
var OD, Fee;
function HXl() {
  if (Fee)
    return OD;
  Fee = 1;
  var e = t$, t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function o(r) {
    return n ? Object(n.call(r)) : {};
  }
  return OD = o, OD;
}
var ND, qee;
function YXl() {
  if (qee)
    return ND;
  qee = 1;
  var e = lV(), t = GXl(), n = WXl(), o = HXl(), r = Zbe(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", c = "[object Number]", l = "[object RegExp]", u = "[object Set]", d = "[object String]", _ = "[object Symbol]", p = "[object ArrayBuffer]", g = "[object DataView]", f = "[object Float32Array]", h = "[object Float64Array]", $ = "[object Int8Array]", v = "[object Int16Array]", b = "[object Int32Array]", y = "[object Uint8Array]", w = "[object Uint8ClampedArray]", N = "[object Uint16Array]", M = "[object Uint32Array]";
  function q(L, R, T) {
    var D = L.constructor;
    switch (R) {
      case p:
        return e(L);
      case i:
      case a:
        return new D(+L);
      case g:
        return t(L, T);
      case f:
      case h:
      case $:
      case v:
      case b:
      case y:
      case w:
      case N:
      case M:
        return r(L, T);
      case s:
        return new D();
      case c:
      case d:
        return new D(L);
      case l:
        return n(L);
      case u:
        return new D();
      case _:
        return o(L);
    }
  }
  return ND = q, ND;
}
var zD, jee;
function KXl() {
  if (jee)
    return zD;
  jee = 1;
  var e = _2(), t = Cf, n = "[object Map]";
  function o(r) {
    return t(r) && e(r) == n;
  }
  return zD = o, zD;
}
var RD, Vee;
function ZXl() {
  if (Vee)
    return RD;
  Vee = 1;
  var e = KXl(), t = Fq, n = qq, o = n && n.isMap, r = o ? t(o) : e;
  return RD = r, RD;
}
var PD, Bee;
function XXl() {
  if (Bee)
    return PD;
  Bee = 1;
  var e = _2(), t = Cf, n = "[object Set]";
  function o(r) {
    return t(r) && e(r) == n;
  }
  return PD = o, PD;
}
var DD, Uee;
function JXl() {
  if (Uee)
    return DD;
  Uee = 1;
  var e = XXl(), t = Fq, n = qq, o = n && n.isSet, r = o ? t(o) : e;
  return DD = r, DD;
}
var LD, Gee;
function QXl() {
  if (Gee)
    return LD;
  Gee = 1;
  var e = u2(), t = RXl(), n = dV(), o = PXl(), r = DXl(), i = Ybe(), a = jme, s = MXl(), c = FXl(), l = cye(), u = fV(), d = _2(), _ = UXl(), p = YXl(), g = Xbe(), f = Z_, h = kA, $ = ZXl(), v = Vd, b = JXl(), y = Tf, w = p1(), N = 1, M = 2, q = 4, L = "[object Arguments]", R = "[object Array]", T = "[object Boolean]", D = "[object Date]", A = "[object Error]", S = "[object Function]", E = "[object GeneratorFunction]", x = "[object Map]", k = "[object Number]", I = "[object Object]", z = "[object RegExp]", F = "[object Set]", P = "[object String]", O = "[object Symbol]", V = "[object WeakMap]", U = "[object ArrayBuffer]", H = "[object DataView]", J = "[object Float32Array]", le = "[object Float64Array]", ae = "[object Int8Array]", Y = "[object Int16Array]", re = "[object Int32Array]", ie = "[object Uint8Array]", _e = "[object Uint8ClampedArray]", he = "[object Uint16Array]", be = "[object Uint32Array]", Q = {};
  Q[L] = Q[R] = Q[U] = Q[H] = Q[T] = Q[D] = Q[J] = Q[le] = Q[ae] = Q[Y] = Q[re] = Q[x] = Q[k] = Q[I] = Q[z] = Q[F] = Q[P] = Q[O] = Q[ie] = Q[_e] = Q[he] = Q[be] = !0, Q[A] = Q[S] = Q[V] = !1;
  function me(ne, pe, ge, ve, Te, Re) {
    var Me, et = pe & N, st = pe & M, De = pe & q;
    if (ge && (Me = Te ? ge(ne, ve, Te, Re) : ge(ne)), Me !== void 0)
      return Me;
    if (!v(ne))
      return ne;
    var ze = f(ne);
    if (ze) {
      if (Me = _(ne), !et)
        return a(ne, Me);
    } else {
      var Pe = d(ne), je = Pe == S || Pe == E;
      if (h(ne))
        return i(ne, et);
      if (Pe == I || Pe == L || je && !Te) {
        if (Me = st || je ? {} : g(ne), !et)
          return st ? c(ne, r(Me, ne)) : s(ne, o(Me, ne));
      } else {
        if (!Q[Pe])
          return Te ? ne : {};
        Me = p(ne, Pe, et);
      }
    }
    Re || (Re = new e());
    var He = Re.get(ne);
    if (He)
      return He;
    Re.set(ne, Me), b(ne) ? ne.forEach(function(wt) {
      Me.add(me(wt, pe, ge, wt, ne, Re));
    }) : $(ne) && ne.forEach(function(wt, Je) {
      Me.set(Je, me(wt, pe, ge, Je, ne, Re));
    });
    var Xe = De ? st ? u : l : st ? w : y, at = ze ? void 0 : Xe(ne);
    return t(at || ne, function(wt, Je) {
      at && (Je = wt, wt = ne[Je]), n(Me, Je, me(wt, pe, ge, Je, ne, Re));
    }), Me;
  }
  return LD = me, LD;
}
var MD, Wee;
function m1() {
  if (Wee)
    return MD;
  Wee = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return MD = e, MD;
}
var FD, Hee;
function eJl() {
  if (Hee)
    return FD;
  Hee = 1;
  function e(t, n, o) {
    var r = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), o = o > i ? i : o, o < 0 && (o += i), i = n > o ? 0 : o - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++r < i; )
      a[r] = t[r + n];
    return a;
  }
  return FD = e, FD;
}
var qD, Yee;
function tJl() {
  if (Yee)
    return qD;
  Yee = 1;
  var e = a2, t = eJl();
  function n(o, r) {
    return r.length < 2 ? o : e(o, t(r, 0, -1));
  }
  return qD = n, qD;
}
var jD, Kee;
function nJl() {
  if (Kee)
    return jD;
  Kee = 1;
  var e = p$, t = m1(), n = tJl(), o = m$;
  function r(i, a) {
    return a = e(a, i), i = n(i, a), i == null || delete i[o(t(a))];
  }
  return jD = r, jD;
}
var VD, Zee;
function oJl() {
  if (Zee)
    return VD;
  Zee = 1;
  var e = Jbe();
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return VD = t, VD;
}
var BD, Xee;
function rJl() {
  if (Xee)
    return BD;
  Xee = 1;
  var e = t$, t = wA, n = Z_, o = e ? e.isConcatSpreadable : void 0;
  function r(i) {
    return n(i) || t(i) || !!(o && i && i[o]);
  }
  return BD = r, BD;
}
var UD, Jee;
function iJl() {
  if (Jee)
    return UD;
  Jee = 1;
  var e = mV(), t = rJl();
  function n(o, r, i, a, s) {
    var c = -1, l = o.length;
    for (i || (i = t), s || (s = []); ++c < l; ) {
      var u = o[c];
      r > 0 && i(u) ? r > 1 ? n(u, r - 1, i, a, s) : e(s, u) : a || (s[s.length] = u);
    }
    return s;
  }
  return UD = n, UD;
}
var GD, Qee;
function aJl() {
  if (Qee)
    return GD;
  Qee = 1;
  var e = iJl();
  function t(n) {
    var o = n == null ? 0 : n.length;
    return o ? e(n, 1) : [];
  }
  return GD = t, GD;
}
var WD, ete;
function lye() {
  if (ete)
    return WD;
  ete = 1;
  var e = aJl(), t = tye(), n = nye();
  function o(r) {
    return n(t(r, void 0, e), r + "");
  }
  return WD = o, WD;
}
var HD, tte;
function Of() {
  if (tte)
    return HD;
  tte = 1;
  var e = Lq, t = QXl(), n = nJl(), o = p$, r = f$(), i = oJl(), a = lye(), s = fV(), c = 1, l = 2, u = 4, d = a(function(_, p) {
    var g = {};
    if (_ == null)
      return g;
    var f = !1;
    p = e(p, function($) {
      return $ = o($, _), f || (f = $.length > 1), $;
    }), r(_, s(_), g), f && (g = t(g, c | l | u, i));
    for (var h = p.length; h--; )
      n(g, p[h]);
    return g;
  });
  return HD = d, HD;
}
var nte;
function f1() {
  if (nte)
    return gh;
  nte = 1;
  var e = Tn;
  Object.defineProperty(gh, "__esModule", {
    value: !0
  }), gh.validateValue = gh.validateTree = void 0;
  var t = e(Zu), n = e(Gu()), o = e(xo), r = Qi(), i = Es(), a = Ti(), s = kl(), c = e(Of()), l = uc(), u = function(N) {
    return (0, o.default)(N) == "object" && N !== null && Array.isArray(N) ? "array" : (0, o.default)(N);
  }, d = function(N, M) {
    return u(N) == M || M == "number" && !isNaN(N);
  }, _ = function(N, M, q, L, R, T) {
    R === void 0 && (R = q.settings.removeEmptyGroupsOnLoad), T === void 0 && (T = q.settings.removeIncompleteRulesOnLoad);
    var D = {
      config: q,
      oldConfig: L,
      removeEmptyGroups: R,
      removeIncompleteRules: T
    };
    return p(N, [], null, {}, D);
  };
  gh.validateTree = _;
  function p(w, N, M, q, L) {
    var R = w.get("type"), T = w.get("children1");
    return (R === "group" || R === "rule_group" || R == "case_group" || R == "switch_group") && T && T.size ? g(w, N, M, q, L) : R === "rule" ? f(w, N, M, q, L) : w;
  }
  function g(w, N, M, q, L) {
    var R = L.removeEmptyGroups, T = w.get("id"), D = w.get("children1"), A = D;
    !T && M && (T = M, w = w.set("id", T), q.sanitized = !0);
    var S = {};
    D = D.map(function(x, k) {
      return p(x, N.concat(T), k, S, L);
    }), R && (D = D.filter(function(x) {
      return x != null;
    }));
    var E = S.sanitized || A.size != D.size;
    return !D.size && R && N.length && (E = !0, w = void 0), E && (q.sanitized = !0), E && w && (w = w.set("children1", D)), w;
  }
  function f(w, N, M, q, L) {
    var R = L.removeIncompleteRules, T = L.config, D = L.oldConfig, A = T.settings.showErrorMessage, S = w.get("id"), E = w.get("properties"), x = E.get("field") || null, k = E.get("operator") || null, I = E.get("operatorOptions"), z = E.get("valueSrc"), F = E.get("value"), P = E.get("valueError"), O = {
      field: x,
      operator: k,
      operatorOptions: I ? I.toJS() : {},
      valueSrc: z ? z.toJS() : null,
      value: F ? F.toJS() : null,
      valueError: P ? P.toJS() : null
    };
    x && k && F && F.includes(void 0), !S && M && (S = M, w = w.set("id", S), q.sanitized = !0);
    var V = x ? (0, r.getFieldConfig)(T, x) : null;
    x && !V && (a.logger.warn("No config for field ".concat(x)), x = null), x == null && (E = ["operator", "operatorOptions", "valueSrc", "value"].reduce(function(he, be) {
      return he.delete(be);
    }, E), k = null), (k == "range_between" || k == "range_not_between") && (k = k == "range_between" ? "between" : "not_between", console.info("Fixed operator ".concat(E.get("operator"), " to ").concat(k)), E = E.set("operator", k));
    var U = k ? (0, r.getOperatorConfig)(T, k, x) : null;
    k && !U && (console.warn("No config for operator ".concat(k)), k = null);
    var H = x ? (0, i.getOperatorsForField)(T, x) : [];
    H ? k && H.indexOf(k) == -1 && (k == "is_empty" || k == "is_not_empty" ? (k = k == "is_empty" ? "is_null" : "is_not_null", console.info("Fixed operator ".concat(E.get("operator"), " to ").concat(k, " for ").concat(x)), E = E.set("operator", k)) : (console.warn("Operator ".concat(k, " is not supported for field ").concat(x)), k = null)) : (console.warn("Type of field ".concat(x, " is not supported")), k = null), k == null && (E = E.delete("operatorOptions"), E = E.delete("valueSrc"), E = E.delete("value")), I = E.get("operatorOptions"), k && (0, a.defaultValue)(U.cardinality, 1), !k || I && !U.options ? (I = null, E = E.delete("operatorOptions")) : k && !I && U.options && (I = (0, s.defaultOperatorOptions)(T, k, x), E = E.set("operatorOptions", I)), z = E.get("valueSrc"), F = E.get("value");
    var J = (0, i.getNewValueForFieldOp)(T, D, E, x, k, null, !0), le = J.newValue, ae = J.newValueSrc, Y = J.newValueError;
    F = le, z = ae, P = Y, E = E.set("value", F), E = E.set("valueSrc", z), A && (E = E.set("valueError", P));
    var re = {
      field: x,
      operator: k,
      operatorOptions: I ? I.toJS() : {},
      valueSrc: z ? z.toJS() : null,
      value: F ? F.toJS() : null,
      valueError: P ? P.toJS() : null
    }, ie = !(0, a.deepEqual)(O, re), _e = x && k && F && !F.includes(void 0);
    return ie && (q.sanitized = !0), !_e && R ? w = void 0 : ie && (w = w.set("properties", E)), w;
  }
  var h = function(N, M, q, L, R, T, D, A) {
    var S = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, E = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1, x = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : !0, k = null, I = R;
    if (R != null) {
      if (D == "field") {
        var z = b(M, q, R, D, T, A, N), F = (0, n.default)(z, 2);
        k = F[0], I = F[1];
      } else if (D == "func") {
        var P = y(M, q, R, D, T, A, N, L, E, S), O = (0, n.default)(P, 2);
        k = O[0], I = O[1];
      } else if (D == "value" || !D) {
        var V = v(M, q, R, D, T, A, N, L, E, S), U = (0, n.default)(V, 2);
        k = U[0], I = U[1];
      }
      if (!k) {
        (0, r.getFieldConfig)(N, q);
        var H = (0, i.getWidgetForFieldOp)(N, q, L, D), J = L ? (0, r.getOperatorConfig)(N, L, q) : null, le = (0, c.default)((0, r.getFieldWidgetConfig)(N, q, L, H, D), ["factory"]), ae = D == "field" ? (0, r.getFieldConfig)(N, R) : null, Y = le, re = le.validateValue;
        if (typeof re == "function") {
          var ie = [I, Y, L, J];
          D == "field" && ie.push(ae);
          var _e = re.apply(void 0, ie);
          typeof _e == "boolean" ? _e == !1 && (k = "Invalid value") : k = _e;
        }
      }
    }
    return x && k && console.warn("[RAQB validate]", "Field ".concat(q, ": ").concat(k)), [k, k ? R : I];
  };
  gh.validateValue = h;
  var $ = function(N, M) {
    var q = l.List.isList(N) ? N.toJS() : N instanceof Array ? (0, t.default)(N) : void 0;
    if (q) {
      for (var L = 0; L < q.length; L++) {
        var R = (0, a.getItemInListValues)(M, q[L]);
        if (R == null)
          return ["Value ".concat(N[L], " is not in list of values"), q];
        q[L] = R.value;
      }
      return [null, q];
    } else {
      var T = (0, a.getItemInListValues)(M, N);
      return T == null ? ["Value ".concat(N, " is not in list of values"), N] : (N = T.value, [null, N]);
    }
  }, v = function(N, M, q, L, R, T, D) {
    var A = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    if (M) {
      var S = (0, r.getFieldConfig)(D, M), E = (0, i.getWidgetForFieldOp)(D, M, A, L), x = D.widgets[E], k = x.type, I = x.jsType, z = S.fieldSettings;
      if (R != k)
        return ["Value should have type ".concat(k, ", but got value of type ").concat(R), q];
      if (I && !d(q, I) && !z.listValues)
        return ["Value should have JS type ".concat(I, ", but got value of type ").concat((0, o.default)(q)), q];
      if (z) {
        var F = T || z.listValues;
        if (F && !z.allowCustomValues)
          return $(q, F);
        if (z.min != null && q < z.min)
          return ["Value ".concat(q, " < min ").concat(z.min), q];
        if (z.max != null && q > z.max)
          return ["Value ".concat(q, " > max ").concat(z.max), q];
      }
    }
    return [null, q];
  }, b = function(N, M, q, L, R, T, D) {
    var A = D.settings.fieldSeparator, S = (0, o.default)(M) == "object" && (M == null ? void 0 : M._isFuncArg), E = Array.isArray(N) ? N.join(A) : N, x = Array.isArray(q) ? q.join(A) : q, k = (0, r.getFieldConfig)(D, q);
    return k ? x == E && !S ? ["Can't compare field ".concat(N, " with itself"), q] : R && R != k.type ? ["Field ".concat(q, " is of type ").concat(k.type, ", but expected ").concat(R), q] : [null, q] : ["Unknown field ".concat(q), q];
  }, y = function(N, M, q, L, R, T, D) {
    var A = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, S = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, E = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1, x = q;
    if (q) {
      var k = q.get("func");
      if (k) {
        var I = (0, r.getFuncConfig)(D, k);
        if (I) {
          if (R && I.returnType != R)
            return ["Function ".concat(k, " should return value of type ").concat(I.returnType, ", but got ").concat(R), q];
          for (var z in I.args) {
            var F = I.args[z], P = x.get("args"), O = P ? P.get(z) : void 0, V = (0, r.getFieldConfig)(D, F), U = O ? O.get("value") : void 0, H = O ? O.get("valueSrc") : void 0;
            if (U !== void 0) {
              var J = h(D, N, V, A, U, F.type, H, T, E, S, !1), le = (0, n.default)(J, 2), ae = le[0], Y = le[1];
              if (ae !== null)
                if (E)
                  x = x.deleteIn(["args", z]), F.defaultValue !== void 0 && (x = x.setIn(["args", z, "value"], F.defaultValue), x = x.setIn(["args", z, "valueSrc"], "value"));
                else
                  return ["Invalid value of arg ".concat(z, " for func ").concat(k, ": ").concat(ae), q];
              else
                Y !== U && (x = x.setIn(["args", z, "value"], Y));
            } else if (S && F.defaultValue === void 0 && !E)
              return ["Value of arg ".concat(z, " for func ").concat(k, " is required"), q];
          }
        } else
          return ["Unknown function ".concat(k), q];
      }
    }
    return [null, x];
  };
  return gh;
}
var ote;
function Es() {
  if (ote)
    return Qr;
  ote = 1;
  var e = Tn;
  Object.defineProperty(Qr, "__esModule", {
    value: !0
  }), Qr.getWidgetsForFieldOp = Qr.getWidgetForFieldOp = Qr.getValueSourcesForFieldOp = Qr.getValueLabel = Qr.getOperatorsForField = Qr.getNewValueForFieldOp = Qr.getFuncPathLabels = Qr.getFirstOperator = Qr.getFirstField = Qr.getFieldPathLabels = Qr.getFieldPath = Qr.getFieldPartsConfigs = Qr.formatFieldName = Qr.filterValueSourcesForField = void 0;
  var t = e(xo), n = e(Zu), o = e(Gu()), r = Qi(), i = Ti(), a = e(uc()), s = f1(), c = e(m1()), l = ["select", "multiselect", "treeselect", "treemultiselect"], u = function(R) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, D = arguments.length > 2 ? arguments[2] : void 0, A = arguments.length > 3 ? arguments[3] : void 0, S = arguments.length > 4 ? arguments[4] : void 0, E = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, x = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !0;
    T || (T = R);
    var k = D.get("field"), I = D.get("operator"), z = D.get("value"), F = D.get("valueSrc", new a.default.List()), P = D.get("valueType", new a.default.List()), O = D.get("asyncListValues"), V = R.settings, U = V.convertableWidgets, H = V.clearValueOnChangeField, J = V.clearValueOnChangeOp, le = V.showErrorMessage, ae = (0, r.getOperatorConfig)(R, S, A), Y = S ? (0, i.defaultValue)(ae.cardinality, 1) : null, re = (0, r.getFieldConfig)(T, k), ie = (0, r.getFieldConfig)(R, A), _e = k && I && S && z != null && (!E || E == "field" && !H || E == "operator" && !J) && re && ie && re.type == ie.type;
    _e && l.includes(re.type) && E == "field" && (_e = !1);
    for (var he = 0; he < Y; he++) {
      var be = F.get(he) || null, Q = M(T, k, I, be), me = M(R, A, S, be), ne = be == "value" ? Q : M(T, k, I, "value"), pe = be == "value" ? me : M(R, A, S, "value"), ge = pe == ne || (U[ne] || []).includes(pe);
      ge || (_e = !1);
    }
    I != S && [I, S].includes("proximity") && (_e = !1);
    var ve = (0, r.getFieldWidgetConfig)(R, A, S, null, F.first()), Te = N(R, A, S), Re = {}, Me = Array.from({
      length: Y
    }, function() {
      return null;
    });
    if (_e)
      for (var et = function(Je) {
        var vt = z.get(Je), Ot = P.get(Je) || null, Ft = F.get(Je) || null, wn = Te.find(function(fn) {
          return fn == Ft;
        }) != null;
        !wn && Je > 0 && Ft == null && (wn = !0);
        var un = !x, pn = O, Dn = (0, s.validateValue)(R, A, A, S, vt, Ot, Ft, pn, x, un), Rn = (0, o.default)(Dn, 2), Ln = Rn[0], Yn = Rn[1], Qt = !Ln;
        if (!Qt && le && E != "field")
          Me[Je] = Ln;
        else {
          if (!wn || !Qt)
            return _e = !1, "break";
          x && Yn !== vt && (Re[Je] = Yn);
        }
      }, st = 0; st < Y; st++) {
        var De = et(st);
        if (De === "break")
          break;
      }
    var ze = null, Pe = null, je = null, He = null;
    if (ze = new a.default.List(Array.from({
      length: Y
    }, function(wt, Je) {
      var vt = void 0;
      if (_e)
        Je < z.size && (vt = z.get(Je), Re[Je] !== void 0 && (vt = Re[Je]));
      else if (Y == 1) {
        var Ot;
        vt = (0, i.getFirstDefined)([ie == null ? void 0 : ie.defaultValue, ie == null || (Ot = ie.fieldSettings) === null || Ot === void 0 ? void 0 : Ot.defaultValue, ve == null ? void 0 : ve.defaultValue]);
      }
      return vt;
    })), Pe = new a.default.List(Array.from({
      length: Y
    }, function(wt, Je) {
      var vt = null;
      return _e ? Je < F.size && (vt = F.get(Je)) : (Te.length == 1 || Te.length > 1) && (vt = Te[0]), vt;
    })), le) {
      if (ae && ae.validateValues && Pe.toJS().filter(function(wt) {
        return wt == "value" || wt == null;
      }).length == Y) {
        var Xe = ve && ve.toJS ? ze.toJS().map(function(wt) {
          return ve.toJS(wt, ve);
        }) : ze.toJS(), at = ae.validateValues(Xe);
        le && Me.push(at);
      }
      He = new a.default.List(Me);
    }
    return je = new a.default.List(Array.from({
      length: Y
    }, function(wt, Je) {
      var vt = null;
      return _e ? Je < P.size && (vt = P.get(Je)) : Y == 1 && ve && ve.type !== void 0 ? vt = ve.type : Y == 1 && ie && ie.type !== void 0 && (vt = ie.type == "!group" ? "number" : ie.type), vt;
    })), {
      canReuseValue: _e,
      newValue: ze,
      newValueSrc: Pe,
      newValueType: je,
      newValueError: He,
      operatorCardinality: Y
    };
  };
  Qr.getNewValueForFieldOp = u;
  var d = function(R) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, D = R.settings.fieldSeparator, A = typeof T == "string" ? T.split(D) : T, S = T ? (0, r.getFieldRawConfig)(R, T) : R, E = S, x = null, k = [];
    do {
      var I = E === R ? R.fields : E.subfields;
      if (!I || !Object.keys(I).length) {
        E = x = null;
        break;
      }
      x = Object.keys(I)[0], k.push(x), E = I[x];
    } while (E.type == "!struct" || E.type == "!group");
    return (A || []).concat(k).join(D);
  };
  Qr.getFirstField = d;
  var _ = function(R, T) {
    var D = (0, r.getFieldConfig)(R, T), A = D ? D.operators : [];
    return A;
  };
  Qr.getOperatorsForField = _;
  var p = function(R, T) {
    var D = _(R, T);
    return D ? D[0] : null;
  };
  Qr.getFirstOperator = p;
  var g = function(R, T) {
    var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (!R)
      return null;
    var A = T.settings.fieldSeparator, S = Array.isArray(R) ? R : R.split(A);
    return D ? S : S.map(function(E, x, k) {
      return k.slice(0, x + 1);
    }).map(function(E) {
      return E.join(A);
    });
  };
  Qr.getFieldPath = g;
  var f = function(R, T) {
    var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return h(R, T, D, "funcs", "subfields");
  };
  Qr.getFuncPathLabels = f;
  var h = function(R, T) {
    var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "fields", S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "subfields";
    if (!R)
      return null;
    var E = T.settings.fieldSeparator, x = Array.isArray(R) ? R : R.split(E), k = D ? Array.isArray(D) ? D : D.split(E) : [];
    return x.slice(k.length).map(function(I, z, F) {
      return F.slice(0, z + 1);
    }).map(function(I) {
      return [].concat((0, n.default)(k), (0, n.default)(I)).join(E);
    }).map(function(I) {
      var z = (0, r.getFieldRawConfig)(T, I, A, S);
      return z && z.label || z && (0, c.default)(I.split(E));
    }).filter(function(I) {
      return I != null;
    });
  };
  Qr.getFieldPathLabels = h;
  var $ = function(R, T) {
    var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!R)
      return null;
    var A = D && (0, r.getFieldRawConfig)(T, D) || null, S = T.settings.fieldSeparator, E = Array.isArray(R) ? R : R.split(S), x = D ? Array.isArray(D) ? D : D.split(S) : [];
    return E.slice(x.length).map(function(k, I, z) {
      return z.slice(0, I + 1);
    }).map(function(k) {
      return {
        part: [].concat((0, n.default)(x), (0, n.default)(k)).join(S),
        key: k[k.length - 1]
      };
    }).map(function(k) {
      var I = k.part, z = k.key, F = (0, r.getFieldRawConfig)(T, I);
      return {
        key: z,
        cnf: F
      };
    }).map(function(k, I, z) {
      var F = k.key, P = k.cnf, O = I > 0 ? z[I - 1].cnf : A;
      return [F, P, O];
    });
  };
  Qr.getFieldPartsConfigs = $;
  var v = function(R, T, D, A) {
    var S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, E = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, x = T && (0, t.default)(T) == "object" && !!T.func && !!T.arg, k = R.settings.showLabels, I = (0, r.getFieldConfig)(R, T), z = (0, r.getFieldWidgetConfig)(R, T, D, null, S) || {}, F = (0, r.getOperatorConfig)(R, D, T) || {}, P = E ? 1 : F.cardinality, O = null;
    if (P > 1) {
      var V = z.valueLabels || F.valueLabels;
      V && (O = V[A]), O && (0, t.default)(O) != "object" && (O = {
        label: O,
        placeholder: O
      }), O || (O = {
        label: R.settings.valueLabel + " " + (A + 1),
        placeholder: R.settings.valuePlaceholder + " " + (A + 1)
      });
    } else {
      var U = z.valueLabel, H = z.valuePlaceholder;
      x && (U || (U = I.label || T.arg), !H && !k && (H = I.label || T.arg)), O = {
        label: U || R.settings.valueLabel,
        placeholder: H || R.settings.valuePlaceholder
      };
    }
    return O;
  };
  Qr.getValueLabel = v;
  function b(L, R) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, A = [], S = [];
    if (!R)
      return {
        widgets: A,
        valueSrcs: S
      };
    var E = (0, t.default)(R) == "object" && (!!R.func && !!R.arg || R._isFuncArg), x = (0, r.getFieldConfig)(L, R), k = T ? L.operators[T] : null;
    if (x && x.widgets) {
      var I = function(O) {
        var V = x.widgets[O], U = L.widgets[O].valueSrc || "value", H = !0;
        if (O == "field" && (H = H && w(L, ["field"], x).length > 0), O == "func" && (H = H && w(L, ["func"], x).length > 0), D == "value" && !V.operators && !E && R != "!case_value" && (H = !1), V.operators && T && (H = H && V.operators.indexOf(T) != -1), D && D != U && D != "const" && (H = !1), k && k.cardinality == 0 && U != "value" && (H = !1), H) {
          A.push(O);
          var J = x.valueSources && x.valueSources.indexOf(U) != -1;
          k && k.valueSources && k.valueSources.indexOf(U) == -1 && (J = !1), J && !S.find(function(le) {
            return le == U;
          }) && S.push(U);
        }
      };
      for (var z in x.widgets)
        I(z);
    }
    var F = function(O) {
      var V = 0;
      return x.preferWidgets ? x.preferWidgets.includes(O) && (V += 10 - x.preferWidgets.indexOf(O)) : O == x.mainWidget && (V += 100), O == "field" && (V -= 1), O == "func" && (V -= 2), V;
    };
    return A.sort(function(P, O) {
      return F(O) - F(P);
    }), {
      widgets: A,
      valueSrcs: S
    };
  }
  var y = function(R, T, D) {
    var A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, S = b(R, T, D, A), E = S.widgets;
    return E;
  };
  Qr.getWidgetsForFieldOp = y;
  var w = function(R, T, D) {
    return D ? T.filter(function(A) {
      var S = !0;
      if (A == "field" && R._fieldsCntByType) {
        var E = D._isFuncArg ? 0 : 1;
        S = S && R._fieldsCntByType[D.type] > E;
      }
      return A == "func" && (R._funcsCntByType && (S = S && !!R._funcsCntByType[D.type]), D.funcs && (S = S && D.funcs.length > 0)), S;
    }) : T;
  };
  Qr.filterValueSourcesForField = w;
  var N = function(R, T, D) {
    var A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, S = b(R, T, D, null), E = S.valueSrcs, x = w(R, E, A);
    return x;
  };
  Qr.getValueSourcesForFieldOp = N;
  var M = function(R, T, D) {
    var A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, S = b(R, T, D, A), E = S.widgets, x = null;
    return E.length && (x = E[0]), x;
  };
  Qr.getWidgetForFieldOp = M;
  var q = function(R, T, D) {
    var A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (R) {
      var S = (0, r.getFieldConfig)(T, R) || {}, E = T.settings.fieldSeparator, x = Array.isArray(R) ? R : R.split(E), k = Array.isArray(R) ? R.join(E) : R;
      if (S.tableName) {
        var I = (0, n.default)(x);
        I[0] = S.tableName, k = I.join(E);
      }
      if (S.fieldName && (k = S.fieldName), A) {
        var z = (0, r.getFieldConfig)(T, A) || {}, F = A;
        z.fieldName && (F = z.fieldName), k.indexOf(F + E) == 0 ? k = k.slice((F + E).length) : D.errors.push("Can't cut group ".concat(F, " from field ").concat(k));
      }
      return k;
    }
  };
  return Qr.formatFieldName = q, Qr;
}
var b_ = {}, YD, rte;
function sJl() {
  if (rte)
    return YD;
  rte = 1;
  var e = Hbe(), t = Tf;
  function n(o, r) {
    return o && e(o, r, t);
  }
  return YD = n, YD;
}
var KD, ite;
function cJl() {
  if (ite)
    return KD;
  ite = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return KD = t, KD;
}
var ZD, ate;
function lJl() {
  if (ate)
    return ZD;
  ate = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return ZD = e, ZD;
}
var XD, ste;
function uJl() {
  if (ste)
    return XD;
  ste = 1;
  var e = Zj, t = cJl(), n = lJl();
  function o(r) {
    var i = -1, a = r == null ? 0 : r.length;
    for (this.__data__ = new e(); ++i < a; )
      this.add(r[i]);
  }
  return o.prototype.add = o.prototype.push = t, o.prototype.has = n, XD = o, XD;
}
var JD, cte;
function dJl() {
  if (cte)
    return JD;
  cte = 1;
  function e(t, n) {
    for (var o = -1, r = t == null ? 0 : t.length; ++o < r; )
      if (n(t[o], o, t))
        return !0;
    return !1;
  }
  return JD = e, JD;
}
var QD, lte;
function _Jl() {
  if (lte)
    return QD;
  lte = 1;
  function e(t, n) {
    return t.has(n);
  }
  return QD = e, QD;
}
var e3, ute;
function uye() {
  if (ute)
    return e3;
  ute = 1;
  var e = uJl(), t = dJl(), n = _Jl(), o = 1, r = 2;
  function i(a, s, c, l, u, d) {
    var _ = c & o, p = a.length, g = s.length;
    if (p != g && !(_ && g > p))
      return !1;
    var f = d.get(a), h = d.get(s);
    if (f && h)
      return f == s && h == a;
    var $ = -1, v = !0, b = c & r ? new e() : void 0;
    for (d.set(a, s), d.set(s, a); ++$ < p; ) {
      var y = a[$], w = s[$];
      if (l)
        var N = _ ? l(w, y, $, s, a, d) : l(y, w, $, a, s, d);
      if (N !== void 0) {
        if (N)
          continue;
        v = !1;
        break;
      }
      if (b) {
        if (!t(s, function(M, q) {
          if (!n(b, q) && (y === M || u(y, M, c, l, d)))
            return b.push(q);
        })) {
          v = !1;
          break;
        }
      } else if (!(y === w || u(y, w, c, l, d))) {
        v = !1;
        break;
      }
    }
    return d.delete(a), d.delete(s), v;
  }
  return e3 = i, e3;
}
var t3, dte;
function pJl() {
  if (dte)
    return t3;
  dte = 1;
  function e(t) {
    var n = -1, o = Array(t.size);
    return t.forEach(function(r, i) {
      o[++n] = [i, r];
    }), o;
  }
  return t3 = e, t3;
}
var n3, _te;
function mJl() {
  if (_te)
    return n3;
  _te = 1;
  function e(t) {
    var n = -1, o = Array(t.size);
    return t.forEach(function(r) {
      o[++n] = r;
    }), o;
  }
  return n3 = e, n3;
}
var o3, pte;
function fJl() {
  if (pte)
    return o3;
  pte = 1;
  var e = t$, t = Kbe(), n = l1(), o = uye(), r = pJl(), i = mJl(), a = 1, s = 2, c = "[object Boolean]", l = "[object Date]", u = "[object Error]", d = "[object Map]", _ = "[object Number]", p = "[object RegExp]", g = "[object Set]", f = "[object String]", h = "[object Symbol]", $ = "[object ArrayBuffer]", v = "[object DataView]", b = e ? e.prototype : void 0, y = b ? b.valueOf : void 0;
  function w(N, M, q, L, R, T, D) {
    switch (q) {
      case v:
        if (N.byteLength != M.byteLength || N.byteOffset != M.byteOffset)
          return !1;
        N = N.buffer, M = M.buffer;
      case $:
        return !(N.byteLength != M.byteLength || !T(new t(N), new t(M)));
      case c:
      case l:
      case _:
        return n(+N, +M);
      case u:
        return N.name == M.name && N.message == M.message;
      case p:
      case f:
        return N == M + "";
      case d:
        var A = r;
      case g:
        var S = L & a;
        if (A || (A = i), N.size != M.size && !S)
          return !1;
        var E = D.get(N);
        if (E)
          return E == M;
        L |= s, D.set(N, M);
        var x = o(A(N), A(M), L, R, T, D);
        return D.delete(N), x;
      case h:
        if (y)
          return y.call(N) == y.call(M);
    }
    return !1;
  }
  return o3 = w, o3;
}
var r3, mte;
function gJl() {
  if (mte)
    return r3;
  mte = 1;
  var e = cye(), t = 1, n = Object.prototype, o = n.hasOwnProperty;
  function r(i, a, s, c, l, u) {
    var d = s & t, _ = e(i), p = _.length, g = e(a), f = g.length;
    if (p != f && !d)
      return !1;
    for (var h = p; h--; ) {
      var $ = _[h];
      if (!(d ? $ in a : o.call(a, $)))
        return !1;
    }
    var v = u.get(i), b = u.get(a);
    if (v && b)
      return v == a && b == i;
    var y = !0;
    u.set(i, a), u.set(a, i);
    for (var w = d; ++h < p; ) {
      $ = _[h];
      var N = i[$], M = a[$];
      if (c)
        var q = d ? c(M, N, $, a, i, u) : c(N, M, $, i, a, u);
      if (!(q === void 0 ? N === M || l(N, M, s, c, u) : q)) {
        y = !1;
        break;
      }
      w || (w = $ == "constructor");
    }
    if (y && !w) {
      var L = i.constructor, R = a.constructor;
      L != R && "constructor" in i && "constructor" in a && !(typeof L == "function" && L instanceof L && typeof R == "function" && R instanceof R) && (y = !1);
    }
    return u.delete(i), u.delete(a), y;
  }
  return r3 = r, r3;
}
var i3, fte;
function hJl() {
  if (fte)
    return i3;
  fte = 1;
  var e = u2(), t = uye(), n = fJl(), o = gJl(), r = _2(), i = Z_, a = kA, s = jq, c = 1, l = "[object Arguments]", u = "[object Array]", d = "[object Object]", _ = Object.prototype, p = _.hasOwnProperty;
  function g(f, h, $, v, b, y) {
    var w = i(f), N = i(h), M = w ? u : r(f), q = N ? u : r(h);
    M = M == l ? d : M, q = q == l ? d : q;
    var L = M == d, R = q == d, T = M == q;
    if (T && a(f)) {
      if (!a(h))
        return !1;
      w = !0, L = !1;
    }
    if (T && !L)
      return y || (y = new e()), w || s(f) ? t(f, h, $, v, b, y) : n(f, h, M, $, v, b, y);
    if (!($ & c)) {
      var D = L && p.call(f, "__wrapped__"), A = R && p.call(h, "__wrapped__");
      if (D || A) {
        var S = D ? f.value() : f, E = A ? h.value() : h;
        return y || (y = new e()), b(S, E, $, v, y);
      }
    }
    return T ? (y || (y = new e()), o(f, h, $, v, b, y)) : !1;
  }
  return i3 = g, i3;
}
var a3, gte;
function dye() {
  if (gte)
    return a3;
  gte = 1;
  var e = hJl(), t = Cf;
  function n(o, r, i, a, s) {
    return o === r ? !0 : o == null || r == null || !t(o) && !t(r) ? o !== o && r !== r : e(o, r, i, a, n, s);
  }
  return a3 = n, a3;
}
var s3, hte;
function vJl() {
  if (hte)
    return s3;
  hte = 1;
  var e = u2(), t = dye(), n = 1, o = 2;
  function r(i, a, s, c) {
    var l = s.length, u = l, d = !c;
    if (i == null)
      return !u;
    for (i = Object(i); l--; ) {
      var _ = s[l];
      if (d && _[2] ? _[1] !== i[_[0]] : !(_[0] in i))
        return !1;
    }
    for (; ++l < u; ) {
      _ = s[l];
      var p = _[0], g = i[p], f = _[1];
      if (d && _[2]) {
        if (g === void 0 && !(p in i))
          return !1;
      } else {
        var h = new e();
        if (c)
          var $ = c(g, f, p, i, a, h);
        if (!($ === void 0 ? t(f, g, n | o, c, h) : $))
          return !1;
      }
    }
    return !0;
  }
  return s3 = r, s3;
}
var c3, vte;
function _ye() {
  if (vte)
    return c3;
  vte = 1;
  var e = Vd;
  function t(n) {
    return n === n && !e(n);
  }
  return c3 = t, c3;
}
var l3, bte;
function bJl() {
  if (bte)
    return l3;
  bte = 1;
  var e = _ye(), t = Tf;
  function n(o) {
    for (var r = t(o), i = r.length; i--; ) {
      var a = r[i], s = o[a];
      r[i] = [a, s, e(s)];
    }
    return r;
  }
  return l3 = n, l3;
}
var u3, yte;
function pye() {
  if (yte)
    return u3;
  yte = 1;
  function e(t, n) {
    return function(o) {
      return o == null ? !1 : o[t] === n && (n !== void 0 || t in Object(o));
    };
  }
  return u3 = e, u3;
}
var d3, $te;
function yJl() {
  if ($te)
    return d3;
  $te = 1;
  var e = vJl(), t = bJl(), n = pye();
  function o(r) {
    var i = t(r);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(a) {
      return a === r || e(a, r, i);
    };
  }
  return d3 = o, d3;
}
var _3, wte;
function $Jl() {
  if (wte)
    return _3;
  wte = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return _3 = e, _3;
}
var p3, kte;
function wJl() {
  if (kte)
    return p3;
  kte = 1;
  var e = p$, t = wA, n = Z_, o = SA, r = Mq, i = m$;
  function a(s, c, l) {
    c = e(c, s);
    for (var u = -1, d = c.length, _ = !1; ++u < d; ) {
      var p = i(c[u]);
      if (!(_ = s != null && l(s, p)))
        break;
      s = s[p];
    }
    return _ || ++u != d ? _ : (d = s == null ? 0 : s.length, !!d && r(d) && o(p, d) && (n(s) || t(s)));
  }
  return p3 = a, p3;
}
var m3, Ste;
function mye() {
  if (Ste)
    return m3;
  Ste = 1;
  var e = $Jl(), t = wJl();
  function n(o, r) {
    return o != null && t(o, r, e);
  }
  return m3 = n, m3;
}
var f3, Ete;
function kJl() {
  if (Ete)
    return f3;
  Ete = 1;
  var e = dye(), t = Tve, n = mye(), o = Yj, r = _ye(), i = pye(), a = m$, s = 1, c = 2;
  function l(u, d) {
    return o(u) && r(d) ? i(a(u), d) : function(_) {
      var p = t(_, u);
      return p === void 0 && p === d ? n(_, u) : e(d, p, s | c);
    };
  }
  return f3 = l, f3;
}
var g3, xte;
function SJl() {
  if (xte)
    return g3;
  xte = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return g3 = e, g3;
}
var h3, Cte;
function EJl() {
  if (Cte)
    return h3;
  Cte = 1;
  var e = a2;
  function t(n) {
    return function(o) {
      return e(o, n);
    };
  }
  return h3 = t, h3;
}
var v3, Tte;
function xJl() {
  if (Tte)
    return v3;
  Tte = 1;
  var e = SJl(), t = EJl(), n = Yj, o = m$;
  function r(i) {
    return n(i) ? e(o(i)) : t(i);
  }
  return v3 = r, v3;
}
var b3, Ate;
function fye() {
  if (Ate)
    return b3;
  Ate = 1;
  var e = yJl(), t = kJl(), n = _V(), o = Z_, r = xJl();
  function i(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? o(a) ? t(a[0], a[1]) : e(a) : r(a);
  }
  return b3 = i, b3;
}
var y3, Ite;
function p2() {
  if (Ite)
    return y3;
  Ite = 1;
  var e = d2(), t = sJl(), n = fye();
  function o(r, i) {
    var a = {};
    return i = n(i, 3), t(r, function(s, c, l) {
      e(a, c, i(s, c, l));
    }), a;
  }
  return y3 = o, y3;
}
var Ote;
function dc() {
  if (Ote)
    return b_;
  Ote = 1;
  var e = Tn;
  Object.defineProperty(b_, "__esModule", {
    value: !0
  }), b_.useOnPropsChanged = b_.pureShouldComponentUpdate = b_.liteShouldComponentUpdate = b_.bindActionCreators = void 0;
  var t = e(Fe), n = e(p2()), o = Ti(), r = function(u, d) {
    return function(_, p) {
      var g = u.props, f = u.state, h = _ != g || p != f;
      if (h && f == p && g != _) {
        var $ = [];
        for (var v in _) {
          var b = _[v] != g[v];
          b && (d[v] == "ignore" ? b = !1 : d[v] == "shallow_deep" ? b = !(0, o.shallowEqual)(_[v], g[v], !0) : d[v] == "shallow" ? b = !(0, o.shallowEqual)(_[v], g[v]) : typeof d[v] == "function" && (b = d[v](_[v], g[v], p))), b && $.push(v);
        }
        $.length || (h = !1);
      }
      return h;
    };
  };
  b_.liteShouldComponentUpdate = r;
  var i = function(u) {
    return function(d, _) {
      return !(0, o.shallowEqual)(u.props, d) || !(0, o.shallowEqual)(u.state, _);
    };
  };
  b_.pureShouldComponentUpdate = i;
  var a = function() {
    var u = t.default.version.split(".").map(parseInt.bind(null, 10));
    return u[0] == 16 && u[1] >= 3 || u[0] > 16;
  }, s = function(u) {
    a ? u.UNSAFE_componentWillReceiveProps = function(d) {
      u.onPropsChanged(d);
    } : u.componentWillReceiveProps = function(d) {
      u.onPropsChanged(d);
    };
  };
  b_.useOnPropsChanged = s;
  var c = function(u, d, _) {
    return (0, n.default)(u, function(p) {
      return function() {
        for (var g = arguments.length, f = new Array(g), h = 0; h < g; h++)
          f[h] = arguments[h];
        return _(p.apply(void 0, [d].concat(f)));
      };
    });
  };
  return b_.bindActionCreators = c, b_;
}
var $3 = { exports: {} }, Nte;
function m2() {
  return Nte || (Nte = 1, function(e) {
    var t = function() {
      function n(_, p) {
        return p != null && _ instanceof p;
      }
      var o;
      try {
        o = Map;
      } catch {
        o = function() {
        };
      }
      var r;
      try {
        r = Set;
      } catch {
        r = function() {
        };
      }
      var i;
      try {
        i = Promise;
      } catch {
        i = function() {
        };
      }
      function a(_, p, g, f, h) {
        typeof p == "object" && (g = p.depth, f = p.prototype, h = p.includeNonEnumerable, p = p.circular);
        var $ = [], v = [], b = typeof Buffer < "u";
        typeof p > "u" && (p = !0), typeof g > "u" && (g = 1 / 0);
        function y(w, N) {
          if (w === null)
            return null;
          if (N === 0)
            return w;
          var M, q;
          if (typeof w != "object")
            return w;
          if (n(w, o))
            M = new o();
          else if (n(w, r))
            M = new r();
          else if (n(w, i))
            M = new i(function(k, I) {
              w.then(function(z) {
                k(y(z, N - 1));
              }, function(z) {
                I(y(z, N - 1));
              });
            });
          else if (a.__isArray(w))
            M = [];
          else if (a.__isRegExp(w))
            M = new RegExp(w.source, d(w)), w.lastIndex && (M.lastIndex = w.lastIndex);
          else if (a.__isDate(w))
            M = new Date(w.getTime());
          else {
            if (b && Buffer.isBuffer(w))
              return Buffer.allocUnsafe ? M = Buffer.allocUnsafe(w.length) : M = new Buffer(w.length), w.copy(M), M;
            n(w, Error) ? M = Object.create(w) : typeof f > "u" ? (q = Object.getPrototypeOf(w), M = Object.create(q)) : (M = Object.create(f), q = f);
          }
          if (p) {
            var L = $.indexOf(w);
            if (L != -1)
              return v[L];
            $.push(w), v.push(M);
          }
          n(w, o) && w.forEach(function(k, I) {
            var z = y(I, N - 1), F = y(k, N - 1);
            M.set(z, F);
          }), n(w, r) && w.forEach(function(k) {
            var I = y(k, N - 1);
            M.add(I);
          });
          for (var R in w) {
            var T;
            q && (T = Object.getOwnPropertyDescriptor(q, R)), !(T && T.set == null) && (M[R] = y(w[R], N - 1));
          }
          if (Object.getOwnPropertySymbols)
            for (var D = Object.getOwnPropertySymbols(w), R = 0; R < D.length; R++) {
              var A = D[R], S = Object.getOwnPropertyDescriptor(w, A);
              S && !S.enumerable && !h || (M[A] = y(w[A], N - 1), S.enumerable || Object.defineProperty(M, A, {
                enumerable: !1
              }));
            }
          if (h)
            for (var E = Object.getOwnPropertyNames(w), R = 0; R < E.length; R++) {
              var x = E[R], S = Object.getOwnPropertyDescriptor(w, x);
              S && S.enumerable || (M[x] = y(w[x], N - 1), Object.defineProperty(M, x, {
                enumerable: !1
              }));
            }
          return M;
        }
        return y(_, g);
      }
      a.clonePrototype = function(p) {
        if (p === null)
          return null;
        var g = function() {
        };
        return g.prototype = p, new g();
      };
      function s(_) {
        return Object.prototype.toString.call(_);
      }
      a.__objToStr = s;
      function c(_) {
        return typeof _ == "object" && s(_) === "[object Date]";
      }
      a.__isDate = c;
      function l(_) {
        return typeof _ == "object" && s(_) === "[object Array]";
      }
      a.__isArray = l;
      function u(_) {
        return typeof _ == "object" && s(_) === "[object RegExp]";
      }
      a.__isRegExp = u;
      function d(_) {
        var p = "";
        return _.global && (p += "g"), _.ignoreCase && (p += "i"), _.multiline && (p += "m"), p;
      }
      return a.__getRegExpFlags = d, a;
    }();
    e.exports && (e.exports = t);
  }($3)), $3.exports;
}
var zte;
function CJl() {
  return zte || (zte = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = y(Fe), d = t(Oa), _ = Qi(), p = Es(), g = Ti(), f = dc(), h = t(m1()), $ = t(Tf), v = t(m2());
    function b(R) {
      if (typeof WeakMap != "function")
        return null;
      var T = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
      return (b = function(S) {
        return S ? D : T;
      })(R);
    }
    function y(R, T) {
      if (!T && R && R.__esModule)
        return R;
      if (R === null || n(R) !== "object" && typeof R != "function")
        return { default: R };
      var D = b(T);
      if (D && D.has(R))
        return D.get(R);
      var A = {}, S = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in R)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(R, E)) {
          var x = S ? Object.getOwnPropertyDescriptor(R, E) : null;
          x && (x.get || x.set) ? Object.defineProperty(A, E, x) : A[E] = R[E];
        }
      return A.default = R, D && D.set(R, A), A;
    }
    function w(R, T) {
      var D = Object.keys(R);
      if (Object.getOwnPropertySymbols) {
        var A = Object.getOwnPropertySymbols(R);
        T && (A = A.filter(function(S) {
          return Object.getOwnPropertyDescriptor(R, S).enumerable;
        })), D.push.apply(D, A);
      }
      return D;
    }
    function N(R) {
      for (var T = 1; T < arguments.length; T++) {
        var D = arguments[T] != null ? arguments[T] : {};
        T % 2 ? w(Object(D), !0).forEach(function(A) {
          (0, o.default)(R, A, D[A]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(D)) : w(Object(D)).forEach(function(A) {
          Object.defineProperty(R, A, Object.getOwnPropertyDescriptor(D, A));
        });
      }
      return R;
    }
    function M(R) {
      var T = q();
      return function() {
        var A = (0, l.default)(R), S;
        if (T) {
          var E = (0, l.default)(this).constructor;
          S = Reflect.construct(A, arguments, E);
        } else
          S = A.apply(this, arguments);
        return (0, c.default)(this, S);
      };
    }
    function q() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var L = /* @__PURE__ */ function(R) {
      (0, s.default)(D, R);
      var T = M(D);
      function D(A) {
        var S;
        return (0, r.default)(this, D), S = T.call(this, A), (0, f.useOnPropsChanged)((0, a.default)(S)), S.onPropsChanged(A), S;
      }
      return (0, i.default)(D, [{
        key: "onPropsChanged",
        value: function(S) {
          var E = this.props, x = ["config", "field", "operator", "isFuncArg", "parentField"], k = ["config", "field", "operator", "value", "placeholder", "isFuncArg", "parentField"], I = !this.items || x.map(function(F) {
            return S[F] !== E[F];
          }).filter(function(F) {
            return F;
          }).length > 0, z = !this.meta || k.map(function(F) {
            return S[F] !== E[F];
          }).filter(function(F) {
            return F;
          }).length > 0;
          I && (this.items = this.getItems(S)), z && (this.meta = this.getMeta(S));
        }
      }, {
        key: "getItems",
        value: function(S) {
          var E = S.config, x = S.field, k = S.operator, I = S.parentField, z = S.isFuncArg, F = S.fieldDefinition, P = E.settings.canCompareFieldWithField, O = E.settings.fieldSeparator, V = typeof I == "string" ? I.split(O) : I, U = I ? (0, _.getFieldConfig)(E, I) : null, H = I ? U && U.subfields : E.fields, J = this.filterFields(E, H, x, I, V, k, P, z, F), le = this.buildOptions(V, E, J, V);
          return le;
        }
      }, {
        key: "getMeta",
        value: function(S) {
          var E = S.config, x = S.field;
          S.operator;
          var k = S.value, I = S.placeholder, z = S.isFuncArg, F = S.parentField, P = E.settings, O = P.fieldPlaceholder, V = P.fieldSeparatorDisplay, U = k, H = !!k, J = (0, _.getFieldConfig)(E, x), le = J.widgets.field, ae = le && le.widgetProps || {}, Y = H ? null : z && I || ae.valuePlaceholder || O, re = H ? (0, _.getFieldConfig)(E, U) : null, ie = re || {}, _e = (0, p.getFieldPath)(U, E), he = (0, p.getFieldPath)(U, E, !0), be = this.getFieldLabel(re, U, E), Q = (0, p.getFieldPathLabels)(U, E), me = Q ? Q.join(V) : null;
          (me == be || F) && (me = null);
          var ne = ie.label2;
          return {
            placeholder: Y,
            selectedKey: U,
            selectedKeys: _e,
            selectedPath: he,
            selectedLabel: be,
            selectedOpts: ie,
            selectedAltLabel: ne,
            selectedFullLabel: me
          };
        }
      }, {
        key: "filterFields",
        value: function(S, E, x, k, I, z, F, P, O) {
          E = (0, v.default)(E);
          var V = S.settings.fieldSeparator, U = (0, _.getFieldConfig)(S, x), H, J = (0, p.getWidgetForFieldOp)(S, x, z, "value");
          if (P && O)
            H = O.type;
          else if (J) {
            var le = S.widgets[J], ae = le.type;
            H = ae;
          } else
            H = U.type;
          function Y(re, ie) {
            for (var _e in re) {
              var he = re[_e].subfields, be = (ie || []).concat(_e), Q = be.join(V), me = (0, _.getFieldConfig)(S, Q);
              if (!me)
                delete re[_e];
              else if (me.type == "!struct" || me.type == "!group")
                Y(he, be) == 0 && delete re[_e];
              else {
                var ne = me.type == H && (P ? !0 : Q != x), pe = F || S.settings.canCompareFieldWithField;
                pe && (ne = ne && pe(x, U, Q, me, z)), ne || delete re[_e];
              }
            }
            return (0, $.default)(re).length;
          }
          return Y(E, I || []), E;
        }
      }, {
        key: "buildOptions",
        value: function(S, E, x) {
          var k = this, I = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, z = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
          if (!x)
            return null;
          var F = E.settings, P = F.fieldSeparator, O = F.fieldSeparatorDisplay, V = I ? I.join(P) + P : "";
          return (0, $.default)(x).map(function(U) {
            var H = x[U], J = k.getFieldLabel(H, U, E), le = (0, p.getFieldPathLabels)(U, E), ae = le.join(O);
            (ae == J || S) && (ae = null);
            var Y = H.label2, re = H.tooltip, ie = (I || []).concat(U);
            if (!H.hideForCompare)
              return H.type == "!struct" || H.type == "!group" ? {
                key: U,
                path: V + U,
                label: J,
                fullLabel: ae,
                altLabel: Y,
                tooltip: re,
                items: k.buildOptions(S, E, H.subfields, ie, J)
              } : {
                key: U,
                path: V + U,
                label: J,
                fullLabel: ae,
                altLabel: Y,
                tooltip: re,
                grouplabel: z
              };
          }).filter(function(U) {
            return !!U;
          });
        }
      }, {
        key: "getFieldLabel",
        value: function(S, E, x) {
          if (!E)
            return null;
          var k = x.settings.fieldSeparator, I = x.settings.maxLabelsLength, z = Array.isArray(E) ? E : E.split(k), F = S.label || (0, h.default)(z);
          return F = (0, g.truncateString)(F, I), F;
        }
      }, {
        key: "render",
        value: function() {
          var S = this.props, E = S.config, x = S.customProps, k = S.setValue, I = S.readonly, z = S.id, F = S.groupId, P = E.settings.renderField, O = N({
            config: E,
            customProps: x,
            setField: k,
            readonly: I,
            items: this.items,
            id: z,
            groupId: F
          }, this.meta);
          return P(O);
        }
      }]), D;
    }(u.PureComponent);
    e.default = L, L.propTypes = {
      id: d.default.string,
      groupId: d.default.string,
      setValue: d.default.func.isRequired,
      config: d.default.object.isRequired,
      field: d.default.string.isRequired,
      value: d.default.string,
      operator: d.default.string,
      customProps: d.default.object,
      readonly: d.default.bool,
      parentField: d.default.string
    };
  }(lD)), lD;
}
var w3 = {};
const Ys = /* @__PURE__ */ nu(dxe);
var k3 = {}, Rte;
function TJl() {
  return Rte || (Rte = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = y(Fe), d = t(Oa), _ = Qi(), p = Es(), g = Ti(), f = dc(), h = t(m1()), $ = t(Tf), v = t(m2());
    function b(R) {
      if (typeof WeakMap != "function")
        return null;
      var T = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
      return (b = function(S) {
        return S ? D : T;
      })(R);
    }
    function y(R, T) {
      if (!T && R && R.__esModule)
        return R;
      if (R === null || n(R) !== "object" && typeof R != "function")
        return { default: R };
      var D = b(T);
      if (D && D.has(R))
        return D.get(R);
      var A = {}, S = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in R)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(R, E)) {
          var x = S ? Object.getOwnPropertyDescriptor(R, E) : null;
          x && (x.get || x.set) ? Object.defineProperty(A, E, x) : A[E] = R[E];
        }
      return A.default = R, D && D.set(R, A), A;
    }
    function w(R, T) {
      var D = Object.keys(R);
      if (Object.getOwnPropertySymbols) {
        var A = Object.getOwnPropertySymbols(R);
        T && (A = A.filter(function(S) {
          return Object.getOwnPropertyDescriptor(R, S).enumerable;
        })), D.push.apply(D, A);
      }
      return D;
    }
    function N(R) {
      for (var T = 1; T < arguments.length; T++) {
        var D = arguments[T] != null ? arguments[T] : {};
        T % 2 ? w(Object(D), !0).forEach(function(A) {
          (0, o.default)(R, A, D[A]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(D)) : w(Object(D)).forEach(function(A) {
          Object.defineProperty(R, A, Object.getOwnPropertyDescriptor(D, A));
        });
      }
      return R;
    }
    function M(R) {
      var T = q();
      return function() {
        var A = (0, l.default)(R), S;
        if (T) {
          var E = (0, l.default)(this).constructor;
          S = Reflect.construct(A, arguments, E);
        } else
          S = A.apply(this, arguments);
        return (0, c.default)(this, S);
      };
    }
    function q() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var L = /* @__PURE__ */ function(R) {
      (0, s.default)(D, R);
      var T = M(D);
      function D(A) {
        var S;
        return (0, r.default)(this, D), S = T.call(this, A), (0, f.useOnPropsChanged)((0, a.default)(S)), S.onPropsChanged(A), S;
      }
      return (0, i.default)(D, [{
        key: "onPropsChanged",
        value: function(S) {
          var E = this.props, x = ["config", "field", "operator"], k = ["config", "field", "value"], I = !this.items || x.map(function(F) {
            return S[F] !== E[F];
          }).filter(function(F) {
            return F;
          }).length > 0, z = !this.meta || k.map(function(F) {
            return S[F] !== E[F];
          }).filter(function(F) {
            return F;
          }).length > 0;
          z && (this.meta = this.getMeta(S)), I && (this.items = this.getItems(S));
        }
      }, {
        key: "getItems",
        value: function(S) {
          var E = S.config, x = S.field, k = S.operator, I = S.parentFuncs, z = E.settings.canUseFuncForField, F = this.filterFuncs(E, E.funcs, x, k, z, I), P = this.buildOptions(E, F);
          return P;
        }
      }, {
        key: "getMeta",
        value: function(S) {
          var E = S.config, x = S.field, k = S.value, I = E.settings, z = I.funcPlaceholder, F = I.fieldSeparatorDisplay, P = k, O = !!k, V = (0, _.getFieldConfig)(E, x), U = V.widgets.field;
          U && U.widgetProps;
          var H = O ? null : z, J = O ? (0, _.getFuncConfig)(E, P) : null, le = J || {}, ae = (0, p.getFieldPath)(P, E), Y = (0, p.getFieldPath)(P, E, !0), re = this.getFuncLabel(J, P, E), ie = (0, p.getFuncPathLabels)(P, E), _e = ie ? ie.join(F) : null;
          return _e == re && (_e = null), {
            placeholder: H,
            selectedKey: P,
            selectedKeys: ae,
            selectedPath: Y,
            selectedLabel: re,
            selectedOpts: le,
            selectedFullLabel: _e
          };
        }
      }, {
        key: "filterFuncs",
        value: function(S, E, x, k, I, z) {
          E = (0, v.default)(E);
          var F = S.settings.fieldSeparator, P = (0, _.getFieldConfig)(S, x), O, V = (0, p.getWidgetForFieldOp)(S, x, k, "value");
          if (V) {
            var U = S.widgets[V], H = U.type;
            O = H;
          } else
            O = P.type;
          function J(le, ae) {
            for (var Y in le) {
              var re = le[Y].subfields, ie = (ae || []).concat(Y), _e = ie.join(F), he = (0, _.getFuncConfig)(S, _e);
              if (he.type == "!struct")
                J(re, ie) == 0 && delete le[Y];
              else {
                var be = he.returnType == O;
                P.funcs && (be = be && P.funcs.includes(_e)), I && (be = be && I(x, P, _e, he, k)), z && z.includes(_e) && (be = !1), be || delete le[Y];
              }
            }
            return (0, $.default)(le).length;
          }
          return J(E, []), E;
        }
      }, {
        key: "buildOptions",
        value: function(S, E) {
          var x = this, k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, I = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
          if (!E)
            return null;
          var z = S.settings, F = z.fieldSeparator, P = z.fieldSeparatorDisplay, O = k ? k.join(F) + F : "";
          return (0, $.default)(E).map(function(V) {
            var U = E[V], H = x.getFuncLabel(U, V, S), J = (0, p.getFuncPathLabels)(V, S), le = J.join(P);
            le == H && (le = null);
            var ae = U.tooltip, Y = (k || []).concat(V);
            return U.type == "!struct" ? {
              key: V,
              path: O + V,
              label: H,
              fullLabel: le,
              tooltip: ae,
              items: x.buildOptions(S, U.subfields, Y, H)
            } : {
              key: V,
              path: O + V,
              label: H,
              fullLabel: le,
              tooltip: ae,
              grouplabel: I
            };
          });
        }
      }, {
        key: "getFuncLabel",
        value: function(S, E, x) {
          if (!E)
            return null;
          var k = x.settings.fieldSeparator, I = x.settings.maxLabelsLength, z = Array.isArray(E) ? E : E.split(k), F = S.label || (0, h.default)(z);
          return F = (0, g.truncateString)(F, I), F;
        }
      }, {
        key: "render",
        value: function() {
          var S = this.props, E = S.config, x = S.customProps, k = S.setValue, I = S.readonly, z = S.id, F = S.groupId, P = E.settings.renderFunc, O = N({
            config: E,
            customProps: x,
            readonly: I,
            setField: k,
            items: this.items,
            id: z,
            groupId: F
          }, this.meta);
          return P(O);
        }
      }]), D;
    }(u.PureComponent);
    e.default = L, L.propTypes = {
      id: d.default.string,
      groupId: d.default.string,
      config: d.default.object.isRequired,
      field: d.default.string.isRequired,
      operator: d.default.string,
      customProps: d.default.object,
      value: d.default.string,
      setValue: d.default.func.isRequired,
      readonly: d.default.bool,
      parentFuncs: d.default.array
    };
  }(k3)), k3;
}
var S3 = {}, E3, Pte;
function AJl() {
  if (Pte)
    return E3;
  Pte = 1;
  var e = Math.ceil, t = Math.max;
  function n(o, r, i, a) {
    for (var s = -1, c = t(e((r - o) / (i || 1)), 0), l = Array(c); c--; )
      l[a ? c : ++s] = o, o += i;
    return l;
  }
  return E3 = n, E3;
}
var x3, Dte;
function gye() {
  if (Dte)
    return x3;
  Dte = 1;
  var e = Qme, t = 1 / 0, n = 17976931348623157e292;
  function o(r) {
    if (!r)
      return r === 0 ? r : 0;
    if (r = e(r), r === t || r === -t) {
      var i = r < 0 ? -1 : 1;
      return i * n;
    }
    return r === r ? r : 0;
  }
  return x3 = o, x3;
}
var C3, Lte;
function IJl() {
  if (Lte)
    return C3;
  Lte = 1;
  var e = AJl(), t = oye(), n = gye();
  function o(r) {
    return function(i, a, s) {
      return s && typeof s != "number" && t(i, a, s) && (a = s = void 0), i = n(i), a === void 0 ? (a = i, i = 0) : a = n(a), s = s === void 0 ? i < a ? 1 : -1 : n(s), e(i, a, s, r);
    };
  }
  return C3 = o, C3;
}
var T3, Mte;
function hye() {
  if (Mte)
    return T3;
  Mte = 1;
  var e = IJl(), t = e();
  return T3 = t, T3;
}
var A3, Fte;
function OJl() {
  if (Fte)
    return A3;
  Fte = 1;
  var e = dV(), t = p$, n = SA, o = Vd, r = m$;
  function i(a, s, c, l) {
    if (!o(a))
      return a;
    s = t(s, a);
    for (var u = -1, d = s.length, _ = d - 1, p = a; p != null && ++u < d; ) {
      var g = r(s[u]), f = c;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return a;
      if (u != _) {
        var h = p[g];
        f = l ? l(h, g, p) : void 0, f === void 0 && (f = o(h) ? h : n(s[u + 1]) ? [] : {});
      }
      e(p, g, f), p = p[g];
    }
    return a;
  }
  return A3 = i, A3;
}
var I3, qte;
function vye() {
  if (qte)
    return I3;
  qte = 1;
  var e = a2, t = OJl(), n = p$;
  function o(r, i, a) {
    for (var s = -1, c = i.length, l = {}; ++s < c; ) {
      var u = i[s], d = e(r, u);
      a(d, u) && t(l, n(u, r), d);
    }
    return l;
  }
  return I3 = o, I3;
}
var O3, jte;
function NJl() {
  if (jte)
    return O3;
  jte = 1;
  var e = vye(), t = mye();
  function n(o, r) {
    return e(o, r, function(i, a) {
      return t(o, a);
    });
  }
  return O3 = n, O3;
}
var N3, Vte;
function Dv() {
  if (Vte)
    return N3;
  Vte = 1;
  var e = NJl(), t = lye(), n = t(function(o, r) {
    return o == null ? {} : e(o, r);
  });
  return N3 = n, N3;
}
var z3 = {};
const g1 = /* @__PURE__ */ nu(yrc);
var Bte;
function zJl() {
  return Bte || (Bte = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(g1);
    t(Fe);
    var o = Ti(), r = ["factory"], i = function(s) {
      var c = s.delta, l = s.isFuncArg;
      s.valueSrc;
      var u = s.value, d = s.valueError, _ = s.asyncListValues, p = s.isSpecialRange, g = s.fieldDefinition;
      s.widget;
      var f = s.widgetDefinition, h = s.widgetValueLabel, $ = s.valueLabels, v = s.textSeparators, b = s.setValueHandler, y = s.config, w = s.field, N = s.operator, M = s.readonly, q = s.parentField, L = s.parentFuncs, R = s.id, T = s.groupId, D = f.factory, A = (0, n.default)(f, r), S = l && g.valueSources && g.valueSources.length == 1 && g.valueSources[0] == "const", E = g.defaultValue;
      if (!D)
        return "?";
      var x = p ? [u.get(0), u.get(1)] : u ? u.get(c) : void 0, k = d && (p ? [d.get(0), d.get(1)] : d.get(c)) || null;
      p && x[0] === void 0 && x[1] === void 0 && (x = void 0);
      var I = g || {}, z = I.fieldSettings, F = Object.assign({}, A, z, {
        config: y,
        field: w,
        parentField: q,
        parentFuncs: L,
        fieldDefinition: g,
        operator: N,
        delta: c,
        isSpecialRange: p,
        isFuncArg: l,
        value: x,
        valueError: k,
        label: h.label,
        placeholder: h.placeholder,
        placeholders: $ ? $.placeholder : null,
        textSeparators: v,
        setValue: b,
        readonly: M,
        asyncListValues: _,
        id: R,
        groupId: T
      });
      return S && E ? typeof E == "boolean" ? E ? F.labelYes || "YES" : F.labelNo || "NO" : z.listValues ? Array.isArray(E) ? E.map(function(P) {
        return (0, o.getTitleInListValues)(z.listValues, P) || P;
      }).join(", ") : (0, o.getTitleInListValues)(z.listValues, E) || E : "" + E : D(F);
    };
    e.default = i;
  }(z3)), z3;
}
var y_ = {}, Ute;
function im() {
  if (Ute)
    return y_;
  Ute = 1;
  var e = Tn;
  Object.defineProperty(y_, "__esModule", {
    value: !0
  }), y_.dummyFn = y_.DragIcon = y_.ConfirmFn = y_.Col = void 0;
  var t = e(Ys), n = e(g1), o = e(Fe), r = ["children"], i = function(u) {
    var d = u.children, _ = (0, n.default)(u, r);
    return /* @__PURE__ */ o.default.createElement("div", _, d);
  };
  y_.Col = i;
  var a = function() {
  };
  y_.dummyFn = a;
  var s = function() {
    return /* @__PURE__ */ o.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "gray",
      width: "18px",
      height: "18px"
    }, /* @__PURE__ */ o.default.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), /* @__PURE__ */ o.default.createElement("path", {
      d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    }));
  };
  y_.DragIcon = s;
  var c = function(u) {
    return function(d) {
      var _ = d.config.settings.useConfirm, p = _ ? _() : null;
      return /* @__PURE__ */ o.default.createElement(u, (0, t.default)({}, d, {
        confirmFn: p
      }));
    };
  };
  return y_.ConfirmFn = c, y_;
}
var Gte;
function f2() {
  return Gte || (Gte = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Ys), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = N(Fe), d = t(Oa), _ = t(hye()), p = Qi(), g = Es(), f = Ti(), h = dc(), $ = t(Dv()), v = t(uc()), b = t(zJl()), y = im();
    function w(T) {
      if (typeof WeakMap != "function")
        return null;
      var D = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap();
      return (w = function(E) {
        return E ? A : D;
      })(T);
    }
    function N(T, D) {
      if (!D && T && T.__esModule)
        return T;
      if (T === null || n(T) !== "object" && typeof T != "function")
        return { default: T };
      var A = w(D);
      if (A && A.has(T))
        return A.get(T);
      var S = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var x in T)
        if (x !== "default" && Object.prototype.hasOwnProperty.call(T, x)) {
          var k = E ? Object.getOwnPropertyDescriptor(T, x) : null;
          k && (k.get || k.set) ? Object.defineProperty(S, x, k) : S[x] = T[x];
        }
      return S.default = T, A && A.set(T, S), S;
    }
    function M(T) {
      var D = q();
      return function() {
        var S = (0, l.default)(T), E;
        if (D) {
          var x = (0, l.default)(this).constructor;
          E = Reflect.construct(S, arguments, x);
        } else
          E = S.apply(this, arguments);
        return (0, c.default)(this, E);
      };
    }
    function q() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var L = {
      cardinality: 1
    }, R = /* @__PURE__ */ function(T) {
      (0, s.default)(A, T);
      var D = M(A);
      function A(S) {
        var E;
        return (0, r.default)(this, A), E = D.call(this, S), E._setValue = function(x, k, I, z, F, P) {
          if (x && Array.isArray(z)) {
            var O = [E.props.value.get(0), E.props.value.get(1)];
            O[0] != z[0] && E.props.setValue(0, z[0], I, F, P), O[1] != z[1] && E.props.setValue(1, z[1], I, F, P);
          } else
            E.props.setValue(k, z, I, F, P);
        }, E._onChangeValueSrc = function(x, k) {
          E.props.setValueSrc(x, k);
        }, E.renderWidget = function(x, k, I) {
          var z = I.config, F = I.isFuncArg, P = I.leftField, O = I.operator, V = I.value, U = I.valueError, H = I.readonly, J = I.parentField, le = I.parentFuncs, ae = I.id, Y = I.groupId, re = z.settings, ie = k.widgets, _e = k.iValues, he = k.aField, be = F ? _e : V, Q = F ? P : he, me = ie[x], ne = me.valueSrc, pe = me.valueLabel, ge = re.showLabels ? /* @__PURE__ */ u.default.createElement("label", {
            className: "rule--label"
          }, pe.label) : null;
          return /* @__PURE__ */ u.default.createElement("div", {
            key: "widget-" + Q + "-" + x,
            className: "widget--widget"
          }, ne == "func" ? null : ge, /* @__PURE__ */ u.default.createElement(b.default, (0, o.default)({
            id: ae,
            groupId: Y,
            valueSrc: ne,
            delta: x,
            value: be,
            valueError: U,
            isFuncArg: F
          }, (0, $.default)(k, ["isSpecialRange", "fieldDefinition", "asyncListValues"]), (0, $.default)(ie[x], ["widget", "widgetDefinition", "widgetValueLabel", "valueLabels", "textSeparators", "setValueHandler"]), {
            config: z,
            field: Q,
            parentField: J,
            parentFuncs: le,
            operator: O,
            readonly: H
          })));
        }, E.renderValueSources = function(x, k, I) {
          var z = I.config, F = I.isFuncArg, P = I.leftField, O = I.operator, V = I.readonly, U = z.settings, H = k.valueSources, J = k.widgets, le = k.aField, ae = F ? P : le, Y = J[x], re = Y.valueSrc, ie = Y.setValueSrcHandler, _e = U.valueSourcesInfo, he = U.renderValueSources, be = H.map(function(me) {
            return [me, {
              label: _e[me].label
            }];
          }), Q = U.showLabels ? /* @__PURE__ */ u.default.createElement("label", {
            className: "rule--label"
          }, " ") : null;
          return H.length > 1 && !V && /* @__PURE__ */ u.default.createElement("div", {
            key: "valuesrc-" + ae + "-" + x,
            className: "widget--valuesrc"
          }, Q, /* @__PURE__ */ u.default.createElement(he, {
            key: "valuesrc-" + x,
            delta: x,
            valueSources: be,
            valueSrc: re,
            config: z,
            field: ae,
            operator: O,
            setValueSrc: ie,
            readonly: V,
            title: U.valueSourcesPopupTitle
          }));
        }, E.renderSep = function(x, k, I) {
          var z = I.config, F = k.widgets, P = z.settings, O = F[x].sepText, V = P.showLabels ? /* @__PURE__ */ u.default.createElement("label", {
            className: "rule--label"
          }, " ") : null;
          return O && /* @__PURE__ */ u.default.createElement("div", {
            key: "widget-separators-" + x,
            className: "widget--sep"
          }, V, /* @__PURE__ */ u.default.createElement("span", null, O));
        }, E.renderWidgetDelta = function(x) {
          var k = E.renderSep(x, E.meta, E.props), I = E.renderValueSources(x, E.meta, E.props), z = E.renderWidget(x, E.meta, E.props);
          return [k, I, z];
        }, (0, h.useOnPropsChanged)((0, a.default)(E)), E.onPropsChanged(S), E;
      }
      return (0, i.default)(A, [{
        key: "onPropsChanged",
        value: function(E) {
          var x = this.props, k = ["config", "field", "fieldFunc", "fieldArg", "leftField", "operator", "valueSrc", "isFuncArg", "asyncListValues"], I = !this.meta || k.map(function(z) {
            return E[z] !== x[z] || z == "isFuncArg" && E.isFuncArg && E.value !== x.value;
          }).filter(function(z) {
            return z;
          }).length > 0;
          I && (this.meta = this.getMeta(E));
        }
      }, {
        key: "getMeta",
        value: function(E) {
          var x = this, k = E.config, I = E.field, z = E.fieldFunc, F = E.fieldArg, P = E.operator, O = E.valueSrc, V = E.value, U = E.isForRuleGruop, H = E.isCaseValue, J = E.isFuncArg, le = E.leftField, ae = E.asyncListValues, Y = J ? {
            func: z,
            arg: F
          } : I, re = O, ie = V;
          (J || U || H) && (re = v.default.List([O]), ie = v.default.List([V]));
          var _e = (0, p.getFieldConfig)(k, Y), he = (0, g.getWidgetForFieldOp)(k, Y, P);
          (0, g.getWidgetsForFieldOp)(k, Y, P);
          var be = J ? L : (0, p.getOperatorConfig)(k, P, Y);
          if ((_e == null || be == null) && !H)
            return null;
          var Q = be == null ? void 0 : be.isSpecialRange, me = Q && (re.get(0) == "field" || re.get(1) == "field"), ne = Q && !me, pe = ne ? 1 : (0, f.defaultValue)(be == null ? void 0 : be.cardinality, 1);
          if (pe === 0)
            return null;
          var ge = (0, g.getValueSourcesForFieldOp)(k, Y, P, _e, J ? le : null), ve = (0, _.default)(0, pe).map(function(Te) {
            var Re, Me = re.get(Te) || null, et = (0, g.getWidgetForFieldOp)(k, Y, P, Me), st = (0, p.getFieldWidgetConfig)(k, Y, P, et, Me);
            me && (et = st.singleWidget, st = (0, p.getFieldWidgetConfig)(k, Y, P, et, Me));
            var De = (Re = st) === null || Re === void 0 ? void 0 : Re.type, ze = (0, g.getValueLabel)(k, Y, P, Te, Me, ne), Pe = (0, g.getValueLabel)(k, Y, P, Te, null, ne), je = be != null && be.textSeparators ? be == null ? void 0 : be.textSeparators[Te] : null, He = x._onChangeValueSrc.bind(x, Te), Xe = null, at = null;
            Q && (Xe = [(0, g.getValueLabel)(k, Y, P, 0), (0, g.getValueLabel)(k, Y, P, 1)], Xe = {
              placeholder: [Xe[0].placeholder, Xe[1].placeholder],
              label: [Xe[0].label, Xe[1].label]
            }, at = be == null ? void 0 : be.textSeparators);
            var wt = x._setValue.bind(x, Q, Te, De);
            return {
              valueSrc: Me,
              valueLabel: ze,
              widget: et,
              sepText: je,
              setValueSrcHandler: He,
              widgetDefinition: st,
              widgetValueLabel: Pe,
              valueLabels: Xe,
              textSeparators: at,
              setValueHandler: wt
            };
          });
          return {
            defaultWidget: he,
            fieldDefinition: _e,
            operatorDefinition: be,
            isSpecialRange: ne,
            cardinality: pe,
            valueSources: ge,
            widgets: ve,
            iValues: ie,
            //correct for isFuncArg
            aField: Y,
            //correct for isFuncArg
            asyncListValues: ae
          };
        }
      }, {
        key: "render",
        value: function() {
          if (!this.meta)
            return null;
          var E = this.meta, x = E.defaultWidget, k = E.cardinality;
          if (!x)
            return null;
          var I = x;
          return /* @__PURE__ */ u.default.createElement(y.Col, {
            className: "rule--widget rule--widget--".concat(I.toUpperCase()),
            key: "widget-col-" + I
          }, (0, _.default)(0, k).map(this.renderWidgetDelta));
        }
      }]), A;
    }(u.PureComponent);
    e.default = R, R.propTypes = {
      config: d.default.object.isRequired,
      value: d.default.any,
      //instanceOf(Immutable.List)
      valueSrc: d.default.any,
      //instanceOf(Immutable.List)
      valueError: d.default.any,
      field: d.default.string,
      operator: d.default.string,
      readonly: d.default.bool,
      asyncListValues: d.default.array,
      id: d.default.string,
      groupId: d.default.string,
      //actions
      setValue: d.default.func,
      setValueSrc: d.default.func,
      // for isFuncArg
      isFuncArg: d.default.bool,
      fieldFunc: d.default.string,
      fieldArg: d.default.string,
      leftField: d.default.string,
      // for RuleGroupExt
      isForRuleGruop: d.default.bool,
      parentField: d.default.string,
      // for func in func
      parentFuncs: d.default.array,
      // for case_value
      isCaseValue: d.default.bool
    };
  }(S3)), S3;
}
var yu = {}, Wte;
function Lv() {
  if (Wte)
    return yu;
  Wte = 1;
  var e = Tn;
  Object.defineProperty(yu, "__esModule", {
    value: !0
  }), yu.setFunc = yu.setArgValueSrc = yu.setArgValue = yu.completeValue = yu.completeFuncValue = void 0;
  var t = e(xo), n = Qi(), o = Es(), r = e(uc()), i = function(p) {
    return (0, t.default)(p) == "object" && p !== null && !Array.isArray(p);
  }, a = function(p, g, f) {
    return g == "func" ? s(p, f) : p;
  };
  yu.completeValue = a;
  var s = function(p, g) {
    var f = function($) {
      if ($) {
        var v = $.get("func"), b = v && (0, n.getFuncConfig)(g, v);
        if (b) {
          var y = $, w = !1;
          for (var N in b.args) {
            var M = b.args[N], q = M.valueSources, L = M.isOptional, R = M.defaultValue, T = (0, o.filterValueSourcesForField)(g, q, M), D = y.get("args"), A = T.length == 1 ? T[0] : void 0, S = D ? D.get(N) : void 0, E = S ? S.get("value") : void 0, x = (S ? S.get("valueSrc") : void 0) || A;
            if (E !== void 0) {
              var k = a(E, x, g);
              if (k === void 0 || (k !== E && (y = y.setIn(["args", N, "value"], k)), w))
                return;
            } else if (R !== void 0 && !i(R))
              y = y.setIn(["args", N, "value"], l(M)), y = y.setIn(["args", N, "valueSrc"], "value");
            else if (L)
              w = !0;
            else
              return;
          }
          return y;
        }
      }
    };
    return f(p);
  };
  yu.completeFuncValue = s;
  var c = function(p, g, f) {
    var h = f.settings.fieldSeparator;
    p = p || new r.default.Map(), Array.isArray(g) && (g = g.join(h)), p = p.set("func", g), p = p.set("args", new r.default.Map());
    var $ = g && (0, n.getFuncConfig)(f, g);
    if ($)
      for (var v in $.args) {
        var b = $.args[v], y = b.valueSources, w = b.defaultValue, N = (0, o.filterValueSourcesForField)(f, y, b), M = N.length ? N[0] : void 0, q = w ? i(w) && w.func ? "func" : "value" : void 0, L = q || M;
        w !== void 0 && (p = p.setIn(["args", v, "value"], l(b))), L && (p = p.setIn(["args", v, "valueSrc"], L));
      }
    return p;
  };
  yu.setFunc = c;
  var l = function(p) {
    var g = p.defaultValue;
    return i(g) && !r.default.Map.isMap(g) && g.func ? r.default.fromJS(g, function(f, h) {
      return r.default.Iterable.isIndexed(h) ? h.toList() : h.toOrderedMap();
    }) : g;
  }, u = function(p, g, f, h, $) {
    if (p && p.get("func")) {
      p = p.setIn(["args", g, "value"], f);
      var v = h.valueSources, b = (0, o.filterValueSourcesForField)($, v, h), y = b.length == 1 ? b[0] : void 0;
      y && (p = p.setIn(["args", g, "valueSrc"], y));
    }
    return p;
  };
  yu.setArgValue = u;
  var d = function(p, g, f, h, $) {
    return p && p.get("func") && (p = p.setIn(["args", g], new r.default.Map({
      valueSrc: f
    }))), p;
  };
  return yu.setArgValueSrc = d, yu;
}
var Hte;
function RJl() {
  return Hte || (Hte = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Ys), r = t(Zu), i = t(ki), a = t(Si), s = t(Hs()), c = t(Ei), l = t(xi()), u = t(oi()), d = y(Fe), _ = t(Oa), p = t(TJl()), g = Qi(), f = t(f2()), h = im(), $ = Lv(), v = dc();
    function b(L) {
      if (typeof WeakMap != "function")
        return null;
      var R = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
      return (b = function(A) {
        return A ? T : R;
      })(L);
    }
    function y(L, R) {
      if (!R && L && L.__esModule)
        return L;
      if (L === null || n(L) !== "object" && typeof L != "function")
        return { default: L };
      var T = b(R);
      if (T && T.has(L))
        return T.get(L);
      var D = {}, A = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var S in L)
        if (S !== "default" && Object.prototype.hasOwnProperty.call(L, S)) {
          var E = A ? Object.getOwnPropertyDescriptor(L, S) : null;
          E && (E.get || E.set) ? Object.defineProperty(D, S, E) : D[S] = L[S];
        }
      return D.default = L, T && T.set(L, D), D;
    }
    function w(L) {
      var R = N();
      return function() {
        var D = (0, u.default)(L), A;
        if (R) {
          var S = (0, u.default)(this).constructor;
          A = Reflect.construct(D, arguments, S);
        } else
          A = D.apply(this, arguments);
        return (0, l.default)(this, A);
      };
    }
    function N() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = /* @__PURE__ */ function(L) {
      (0, c.default)(T, L);
      var R = w(T);
      function T(D) {
        var A;
        return (0, i.default)(this, T), A = R.call(this, D), A.setFunc = function(S) {
          A.props.setValue((0, $.setFunc)(A.props.value, S, A.props.config));
        }, A.setArgValue = function(S, E) {
          var x = A.props.config, k = A.meta.funcDefinition, I = k.args, z = I[S];
          A.props.setValue((0, $.setArgValue)(A.props.value, S, E, z, x));
        }, A.setArgValueSrc = function(S, E) {
          var x = A.props.config, k = A.meta.funcDefinition, I = k.args, z = I[S];
          A.props.setValue((0, $.setArgValueSrc)(A.props.value, S, E, z, x));
        }, A.renderFuncSelect = function() {
          var S = A.props, E = S.config, x = S.field, k = S.operator, I = S.customProps, z = S.value, F = S.readonly, P = S.parentFuncs, O = S.id, V = S.groupId, U = z ? z.get("func") : null, H = {
            value: U,
            setValue: A.setFunc,
            config: E,
            field: x,
            operator: k,
            customProps: I,
            readonly: F,
            parentFuncs: P,
            id: O,
            groupId: V
          }, J = E.settings, le = J.showLabels, ae = J.funcLabel, Y = le ? /* @__PURE__ */ d.default.createElement("label", {
            className: "rule--label"
          }, ae) : null;
          return /* @__PURE__ */ d.default.createElement(h.Col, {
            key: "func",
            className: "rule--func"
          }, Y, /* @__PURE__ */ d.default.createElement(p.default, H));
        }, A.renderArgLabel = function(S, E) {
          var x = E.valueSources, k = E.type, I = E.showPrefix, z = E.label, F = A.props.config, P = x && x.length == 1 && x[0] == "const", O = !F.settings.showLabels && (k == "boolean" || P) && I;
          return O ? /* @__PURE__ */ d.default.createElement(h.Col, {
            className: "rule--func--arg-label"
          }, z || S) : null;
        }, A.renderArgLabelSep = function(S, E) {
          var x = E.valueSources, k = E.type, I = E.showPrefix, z = A.props.config, F = x && x.length == 1 && x[0] == "const", P = !z.settings.showLabels && (k == "boolean" || F) && I;
          return P ? /* @__PURE__ */ d.default.createElement(h.Col, {
            className: "rule--func--arg-label-sep"
          }, ":") : null;
        }, A.renderArgVal = function(S, E, x) {
          var k = A.props, I = k.config, z = k.field;
          k.operator;
          var F = k.value, P = k.readonly, O = k.parentFuncs, V = k.id, U = k.groupId, H = F ? F.getIn(["args", E]) : null, J = H ? H.get("value") : void 0, le = x.valueSources.length == 1 ? x.valueSources[0] : void 0, ae = H ? H.get("valueSrc") || le || "value" : le, Y = {
            config: I,
            fieldFunc: S,
            fieldArg: E,
            leftField: z,
            operator: null,
            value: J,
            valueSrc: ae,
            setValue: A.setArgValue,
            setValueSrc: A.setArgValueSrc,
            funcKey: S,
            argKey: E,
            argDefinition: x,
            readonly: P,
            parentFuncs: O,
            id: V,
            groupId: U
          };
          return /* @__PURE__ */ d.default.createElement(h.Col, {
            className: "rule--func--arg-value"
          }, /* @__PURE__ */ d.default.createElement(q, Y));
        }, A.renderArgSep = function(S, E, x, k) {
          var I = k.renderSeps;
          return x ? /* @__PURE__ */ d.default.createElement(h.Col, {
            className: "rule--func--arg-sep"
          }, I ? I[x - 1] : ", ") : null;
        }, A.renderBracketBefore = function(S) {
          var E = S.renderBrackets;
          return /* @__PURE__ */ d.default.createElement(h.Col, {
            key: "before_args",
            className: "rule--func--bracket-before"
          }, E ? E[0] : "(");
        }, A.renderBracketAfter = function(S) {
          var E = S.renderBrackets;
          return /* @__PURE__ */ d.default.createElement(h.Col, {
            key: "after_args",
            className: "rule--func--bracket-after"
          }, E ? E[1] : ")");
        }, A.renderFuncArgs = function() {
          var S = A.meta, E = S.funcDefinition, x = S.funcKey;
          if (!x)
            return null;
          var k = E.args;
          return k ? /* @__PURE__ */ d.default.createElement(d.default.Fragment, null, A.renderBracketBefore(E), /* @__PURE__ */ d.default.createElement(h.Col, {
            key: "args",
            className: "rule--func--args"
          }, Object.keys(k).map(function(I, z) {
            return /* @__PURE__ */ d.default.createElement(h.Col, {
              key: "arg-".concat(I, "-").concat(z),
              className: "rule--func--arg"
            }, A.renderArgSep(I, k[I], z, E), A.renderArgLabel(I, k[I]), A.renderArgLabelSep(I, k[I]), A.renderArgVal(x, I, k[I]));
          })), A.renderBracketAfter(E)) : null;
        }, (0, v.useOnPropsChanged)((0, s.default)(A)), A.onPropsChanged(D), A;
      }
      return (0, a.default)(T, [{
        key: "onPropsChanged",
        value: function(A) {
          var S = this.props, E = ["config", "field", "operator", "value"], x = !this.meta || E.map(function(k) {
            return A[k] !== S[k];
          }).filter(function(k) {
            return k;
          }).length > 0;
          x && (this.meta = this.getMeta(A));
        }
      }, {
        key: "getMeta",
        value: function(A) {
          var S = A.config;
          A.field, A.operator;
          var E = A.value, x = E ? E.get("func") : null, k = x ? (0, g.getFuncConfig)(S, x) : null;
          return {
            funcDefinition: k,
            funcKey: x
          };
        }
      }, {
        key: "render",
        value: function() {
          return /* @__PURE__ */ d.default.createElement(h.Col, {
            className: "rule--func--wrapper"
          }, this.renderFuncSelect(), this.renderFuncArgs());
        }
      }]), T;
    }(d.PureComponent);
    e.default = M, M.propTypes = {
      id: _.default.string,
      groupId: _.default.string,
      config: _.default.object.isRequired,
      field: _.default.string.isRequired,
      operator: _.default.string,
      customProps: _.default.object,
      value: _.default.object,
      //instanceOf(Immutable.Map) //with keys 'func' and `args`
      setValue: _.default.func.isRequired,
      readonly: _.default.bool,
      parentFuncs: _.default.array
    };
    var q = /* @__PURE__ */ function(L) {
      (0, c.default)(T, L);
      var R = w(T);
      function T() {
        var D;
        (0, i.default)(this, T);
        for (var A = arguments.length, S = new Array(A), E = 0; E < A; E++)
          S[E] = arguments[E];
        return D = R.call.apply(R, [this].concat(S)), D.setValue = function(x, k, I) {
          var z = D.props, F = z.setValue, P = z.argKey;
          F(P, k);
        }, D.setValueSrc = function(x, k, I) {
          var z = D.props, F = z.setValueSrc, P = z.argKey;
          F(P, k);
        }, D;
      }
      return (0, a.default)(T, [{
        key: "render",
        value: function() {
          var A = this.props, S = A.funcKey, E = A.parentFuncs;
          return /* @__PURE__ */ d.default.createElement(f.default, (0, o.default)({}, this.props, {
            setValue: this.setValue,
            setValueSrc: this.setValueSrc,
            isFuncArg: !0,
            parentFuncs: [].concat((0, r.default)(E || []), [S])
          }));
        }
      }]), T;
    }(d.PureComponent);
    q.propTypes = {
      funcKey: _.default.string.isRequired,
      argKey: _.default.string.isRequired,
      setValue: _.default.func.isRequired,
      setValueSrc: _.default.func.isRequired,
      readonly: _.default.bool,
      parentFuncs: _.default.array,
      id: _.default.string,
      groupId: _.default.string
    };
  }(w3)), w3;
}
var R3 = {}, P3 = {}, Yte;
function PJl() {
  return Yte || (Yte = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = t(Ug()), i = function(s) {
      var c = s.value, l = s.setValue;
      s.config;
      var u = s.labelYes, d = s.labelNo, _ = s.readonly, p = s.customProps, g = p === void 0 ? {} : p, f = g.radioYes || {}, h = g.radioNo || {}, $ = function(w) {
        return l(w.target.value == "true");
      }, v = (0, r.default)(), b = (0, r.default)();
      return /* @__PURE__ */ o.default.createElement(o.default.Fragment, null, /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: v,
        type: "radio",
        id: v,
        value: !0,
        checked: !!c,
        disabled: _,
        onChange: $
      }, f)), /* @__PURE__ */ o.default.createElement("label", {
        style: {
          display: "inline"
        },
        key: v + "label",
        htmlFor: v
      }, u), /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: b,
        type: "radio",
        id: b,
        value: !1,
        checked: !c,
        disabled: _,
        onChange: $
      }, h)), /* @__PURE__ */ o.default.createElement("label", {
        style: {
          display: "inline"
        },
        key: b + "label",
        htmlFor: b
      }, d));
    };
    e.default = i;
  }(P3)), P3;
}
var D3 = {}, Kte;
function DJl() {
  return Kte || (Kte = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, u = a.placeholder, d = a.maxLength, _ = a.customProps, p = function(h) {
        var $ = h.target.value;
        $ === "" && ($ = void 0), c($);
      }, g = s || "";
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "text",
        value: g,
        placeholder: u,
        disabled: l,
        onChange: p,
        maxLength: d
      }, _));
    };
    e.default = r;
  }(D3)), D3;
}
var L3 = {}, Zte;
function LJl() {
  return Zte || (Zte = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, u = a.placeholder, d = a.maxLength;
      a.maxRows;
      var _ = a.fullWidth, p = a.customProps, g = function($) {
        var v = $.target.value;
        v === "" && (v = void 0), c(v);
      }, f = s || "";
      return /* @__PURE__ */ o.default.createElement("textarea", (0, n.default)({
        value: f,
        placeholder: u,
        disabled: l,
        onChange: g,
        maxLength: d,
        style: {
          width: _ ? "100%" : void 0
        }
      }, p));
    };
    e.default = r;
  }(L3)), L3;
}
var M3 = {};
//! moment.js
//! version : 2.29.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var bye;
function Un() {
  return bye.apply(null, arguments);
}
function MJl(e) {
  bye = e;
}
function B_(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function iv(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Wr(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function gV(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Wr(e, t))
      return !1;
  return !0;
}
function Vl(e) {
  return e === void 0;
}
function $f(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function h1(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function yye(e, t) {
  var n = [], o, r = e.length;
  for (o = 0; o < r; ++o)
    n.push(t(e[o], o));
  return n;
}
function fg(e, t) {
  for (var n in t)
    Wr(t, n) && (e[n] = t[n]);
  return Wr(t, "toString") && (e.toString = t.toString), Wr(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function am(e, t, n, o) {
  return Uye(e, t, n, o, !0).utc();
}
function FJl() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function sr(e) {
  return e._pf == null && (e._pf = FJl()), e._pf;
}
var s6;
Array.prototype.some ? s6 = Array.prototype.some : s6 = function(e) {
  var t = Object(this), n = t.length >>> 0, o;
  for (o = 0; o < n; o++)
    if (o in t && e.call(this, t[o], o, t))
      return !0;
  return !1;
};
function hV(e) {
  if (e._isValid == null) {
    var t = sr(e), n = s6.call(t.parsedDateParts, function(r) {
      return r != null;
    }), o = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
    if (e._strict && (o = o && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = o;
    else
      return o;
  }
  return e._isValid;
}
function g2(e) {
  var t = am(NaN);
  return e != null ? fg(sr(t), e) : sr(t).userInvalidated = !0, t;
}
var Xte = Un.momentProperties = [], F3 = !1;
function vV(e, t) {
  var n, o, r, i = Xte.length;
  if (Vl(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Vl(t._i) || (e._i = t._i), Vl(t._f) || (e._f = t._f), Vl(t._l) || (e._l = t._l), Vl(t._strict) || (e._strict = t._strict), Vl(t._tzm) || (e._tzm = t._tzm), Vl(t._isUTC) || (e._isUTC = t._isUTC), Vl(t._offset) || (e._offset = t._offset), Vl(t._pf) || (e._pf = sr(t)), Vl(t._locale) || (e._locale = t._locale), i > 0)
    for (n = 0; n < i; n++)
      o = Xte[n], r = t[o], Vl(r) || (e[o] = r);
  return e;
}
function v1(e) {
  vV(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), F3 === !1 && (F3 = !0, Un.updateOffset(this), F3 = !1);
}
function U_(e) {
  return e instanceof v1 || e != null && e._isAMomentObject != null;
}
function $ye(e) {
  Un.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Bd(e, t) {
  var n = !0;
  return fg(function() {
    if (Un.deprecationHandler != null && Un.deprecationHandler(null, e), n) {
      var o = [], r, i, a, s = arguments.length;
      for (i = 0; i < s; i++) {
        if (r = "", typeof arguments[i] == "object") {
          r += `
[` + i + "] ";
          for (a in arguments[0])
            Wr(arguments[0], a) && (r += a + ": " + arguments[0][a] + ", ");
          r = r.slice(0, -2);
        } else
          r = arguments[i];
        o.push(r);
      }
      $ye(
        e + `
Arguments: ` + Array.prototype.slice.call(o).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Jte = {};
function wye(e, t) {
  Un.deprecationHandler != null && Un.deprecationHandler(e, t), Jte[e] || ($ye(t), Jte[e] = !0);
}
Un.suppressDeprecationWarnings = !1;
Un.deprecationHandler = null;
function sm(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function qJl(e) {
  var t, n;
  for (n in e)
    Wr(e, n) && (t = e[n], sm(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function c6(e, t) {
  var n = fg({}, e), o;
  for (o in t)
    Wr(t, o) && (iv(e[o]) && iv(t[o]) ? (n[o] = {}, fg(n[o], e[o]), fg(n[o], t[o])) : t[o] != null ? n[o] = t[o] : delete n[o]);
  for (o in e)
    Wr(e, o) && !Wr(t, o) && iv(e[o]) && (n[o] = fg({}, n[o]));
  return n;
}
function bV(e) {
  e != null && this.set(e);
}
var l6;
Object.keys ? l6 = Object.keys : l6 = function(e) {
  var t, n = [];
  for (t in e)
    Wr(e, t) && n.push(t);
  return n;
};
var jJl = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function VJl(e, t, n) {
  var o = this._calendar[e] || this._calendar.sameElse;
  return sm(o) ? o.call(t, n) : o;
}
function Qp(e, t, n) {
  var o = "" + Math.abs(e), r = t - o.length, i = e >= 0;
  return (i ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + o;
}
var yV = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, SE = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, q3 = {}, Xb = {};
function lo(e, t, n, o) {
  var r = o;
  typeof o == "string" && (r = function() {
    return this[o]();
  }), e && (Xb[e] = r), t && (Xb[t[0]] = function() {
    return Qp(r.apply(this, arguments), t[1], t[2]);
  }), n && (Xb[n] = function() {
    return this.localeData().ordinal(
      r.apply(this, arguments),
      e
    );
  });
}
function BJl(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function UJl(e) {
  var t = e.match(yV), n, o;
  for (n = 0, o = t.length; n < o; n++)
    Xb[t[n]] ? t[n] = Xb[t[n]] : t[n] = BJl(t[n]);
  return function(r) {
    var i = "", a;
    for (a = 0; a < o; a++)
      i += sm(t[a]) ? t[a].call(r, e) : t[a];
    return i;
  };
}
function gx(e, t) {
  return e.isValid() ? (t = kye(t, e.localeData()), q3[t] = q3[t] || UJl(t), q3[t](e)) : e.localeData().invalidDate();
}
function kye(e, t) {
  var n = 5;
  function o(r) {
    return t.longDateFormat(r) || r;
  }
  for (SE.lastIndex = 0; n >= 0 && SE.test(e); )
    e = e.replace(
      SE,
      o
    ), SE.lastIndex = 0, n -= 1;
  return e;
}
var GJl = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function WJl(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(yV).map(function(o) {
    return o === "MMMM" || o === "MM" || o === "DD" || o === "dddd" ? o.slice(1) : o;
  }).join(""), this._longDateFormat[e]);
}
var HJl = "Invalid date";
function YJl() {
  return this._invalidDate;
}
var KJl = "%d", ZJl = /\d{1,2}/;
function XJl(e) {
  return this._ordinal.replace("%d", e);
}
var JJl = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function QJl(e, t, n, o) {
  var r = this._relativeTime[n];
  return sm(r) ? r(e, t, n, o) : r.replace(/%d/i, e);
}
function eQl(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return sm(n) ? n(t) : n.replace(/%s/i, t);
}
var lk = {};
function Uc(e, t) {
  var n = e.toLowerCase();
  lk[n] = lk[n + "s"] = lk[t] = e;
}
function Ud(e) {
  return typeof e == "string" ? lk[e] || lk[e.toLowerCase()] : void 0;
}
function $V(e) {
  var t = {}, n, o;
  for (o in e)
    Wr(e, o) && (n = Ud(o), n && (t[n] = e[o]));
  return t;
}
var Sye = {};
function Gc(e, t) {
  Sye[e] = t;
}
function tQl(e) {
  var t = [], n;
  for (n in e)
    Wr(e, n) && t.push({ unit: n, priority: Sye[n] });
  return t.sort(function(o, r) {
    return o.priority - r.priority;
  }), t;
}
function h2(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Td(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function br(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = Td(t)), n;
}
function g$(e, t) {
  return function(n) {
    return n != null ? (Eye(this, e, n), Un.updateOffset(this, t), this) : cT(this, e);
  };
}
function cT(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function Eye(e, t, n) {
  e.isValid() && !isNaN(n) && (t === "FullYear" && h2(e.year()) && e.month() === 1 && e.date() === 29 ? (n = br(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    n,
    e.month(),
    k2(n, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
}
function nQl(e) {
  return e = Ud(e), sm(this[e]) ? this[e]() : this;
}
function oQl(e, t) {
  if (typeof e == "object") {
    e = $V(e);
    var n = tQl(e), o, r = n.length;
    for (o = 0; o < r; o++)
      this[n[o].unit](e[n[o].unit]);
  } else if (e = Ud(e), sm(this[e]))
    return this[e](t);
  return this;
}
var xye = /\d/, Xu = /\d\d/, Cye = /\d{3}/, wV = /\d{4}/, v2 = /[+-]?\d{6}/, pa = /\d\d?/, Tye = /\d\d\d\d?/, Aye = /\d\d\d\d\d\d?/, b2 = /\d{1,3}/, kV = /\d{1,4}/, y2 = /[+-]?\d{1,6}/, h$ = /\d+/, $2 = /[+-]?\d+/, rQl = /Z|[+-]\d\d:?\d\d/gi, w2 = /Z|[+-]\d\d(?::?\d\d)?/gi, iQl = /[+-]?\d+(\.\d{1,3})?/, b1 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, lT;
lT = {};
function Zn(e, t, n) {
  lT[e] = sm(t) ? t : function(o, r) {
    return o && n ? n : t;
  };
}
function aQl(e, t) {
  return Wr(lT, e) ? lT[e](t._strict, t._locale) : new RegExp(sQl(e));
}
function sQl(e) {
  return Ou(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, o, r, i) {
        return n || o || r || i;
      }
    )
  );
}
function Ou(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var u6 = {};
function qi(e, t) {
  var n, o = t, r;
  for (typeof e == "string" && (e = [e]), $f(t) && (o = function(i, a) {
    a[t] = br(i);
  }), r = e.length, n = 0; n < r; n++)
    u6[e[n]] = o;
}
function y1(e, t) {
  qi(e, function(n, o, r, i) {
    r._w = r._w || {}, t(n, r._w, r, i);
  });
}
function cQl(e, t, n) {
  t != null && Wr(u6, e) && u6[e](t, n._a, n, e);
}
var Lc = 0, rf = 1, Mp = 2, $s = 3, z_ = 4, af = 5, Bh = 6, lQl = 7, uQl = 8;
function dQl(e, t) {
  return (e % t + t) % t;
}
var Ga;
Array.prototype.indexOf ? Ga = Array.prototype.indexOf : Ga = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function k2(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = dQl(t, 12);
  return e += (t - n) / 12, n === 1 ? h2(e) ? 29 : 28 : 31 - n % 7 % 2;
}
lo("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
lo("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
lo("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Uc("month", "M");
Gc("month", 8);
Zn("M", pa);
Zn("MM", pa, Xu);
Zn("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Zn("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
qi(["M", "MM"], function(e, t) {
  t[rf] = br(e) - 1;
});
qi(["MMM", "MMMM"], function(e, t, n, o) {
  var r = n._locale.monthsParse(e, o, n._strict);
  r != null ? t[rf] = r : sr(n).invalidMonth = e;
});
var _Ql = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Iye = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Oye = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, pQl = b1, mQl = b1;
function fQl(e, t) {
  return e ? B_(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Oye).test(t) ? "format" : "standalone"][e.month()] : B_(this._months) ? this._months : this._months.standalone;
}
function gQl(e, t) {
  return e ? B_(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Oye.test(t) ? "format" : "standalone"][e.month()] : B_(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function hQl(e, t, n) {
  var o, r, i, a = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], o = 0; o < 12; ++o)
      i = am([2e3, o]), this._shortMonthsParse[o] = this.monthsShort(
        i,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[o] = this.months(i, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (r = Ga.call(this._shortMonthsParse, a), r !== -1 ? r : null) : (r = Ga.call(this._longMonthsParse, a), r !== -1 ? r : null) : t === "MMM" ? (r = Ga.call(this._shortMonthsParse, a), r !== -1 ? r : (r = Ga.call(this._longMonthsParse, a), r !== -1 ? r : null)) : (r = Ga.call(this._longMonthsParse, a), r !== -1 ? r : (r = Ga.call(this._shortMonthsParse, a), r !== -1 ? r : null));
}
function vQl(e, t, n) {
  var o, r, i;
  if (this._monthsParseExact)
    return hQl.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), o = 0; o < 12; o++) {
    if (r = am([2e3, o]), n && !this._longMonthsParse[o] && (this._longMonthsParse[o] = new RegExp(
      "^" + this.months(r, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[o] = new RegExp(
      "^" + this.monthsShort(r, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[o] && (i = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[o] = new RegExp(i.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[o].test(e))
      return o;
    if (n && t === "MMM" && this._shortMonthsParse[o].test(e))
      return o;
    if (!n && this._monthsParse[o].test(e))
      return o;
  }
}
function Nye(e, t) {
  var n;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = br(t);
    else if (t = e.localeData().monthsParse(t), !$f(t))
      return e;
  }
  return n = Math.min(e.date(), k2(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
}
function zye(e) {
  return e != null ? (Nye(this, e), Un.updateOffset(this, !0), this) : cT(this, "Month");
}
function bQl() {
  return k2(this.year(), this.month());
}
function yQl(e) {
  return this._monthsParseExact ? (Wr(this, "_monthsRegex") || Rye.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Wr(this, "_monthsShortRegex") || (this._monthsShortRegex = pQl), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function $Ql(e) {
  return this._monthsParseExact ? (Wr(this, "_monthsRegex") || Rye.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Wr(this, "_monthsRegex") || (this._monthsRegex = mQl), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Rye() {
  function e(a, s) {
    return s.length - a.length;
  }
  var t = [], n = [], o = [], r, i;
  for (r = 0; r < 12; r++)
    i = am([2e3, r]), t.push(this.monthsShort(i, "")), n.push(this.months(i, "")), o.push(this.months(i, "")), o.push(this.monthsShort(i, ""));
  for (t.sort(e), n.sort(e), o.sort(e), r = 0; r < 12; r++)
    t[r] = Ou(t[r]), n[r] = Ou(n[r]);
  for (r = 0; r < 24; r++)
    o[r] = Ou(o[r]);
  this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
lo("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Qp(e, 4) : "+" + e;
});
lo(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
lo(0, ["YYYY", 4], 0, "year");
lo(0, ["YYYYY", 5], 0, "year");
lo(0, ["YYYYYY", 6, !0], 0, "year");
Uc("year", "y");
Gc("year", 1);
Zn("Y", $2);
Zn("YY", pa, Xu);
Zn("YYYY", kV, wV);
Zn("YYYYY", y2, v2);
Zn("YYYYYY", y2, v2);
qi(["YYYYY", "YYYYYY"], Lc);
qi("YYYY", function(e, t) {
  t[Lc] = e.length === 2 ? Un.parseTwoDigitYear(e) : br(e);
});
qi("YY", function(e, t) {
  t[Lc] = Un.parseTwoDigitYear(e);
});
qi("Y", function(e, t) {
  t[Lc] = parseInt(e, 10);
});
function uk(e) {
  return h2(e) ? 366 : 365;
}
Un.parseTwoDigitYear = function(e) {
  return br(e) + (br(e) > 68 ? 1900 : 2e3);
};
var Pye = g$("FullYear", !0);
function wQl() {
  return h2(this.year());
}
function kQl(e, t, n, o, r, i, a) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, o, r, i, a), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, o, r, i, a), s;
}
function c0(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function uT(e, t, n) {
  var o = 7 + t - n, r = (7 + c0(e, 0, o).getUTCDay() - t) % 7;
  return -r + o - 1;
}
function Dye(e, t, n, o, r) {
  var i = (7 + n - o) % 7, a = uT(e, o, r), s = 1 + 7 * (t - 1) + i + a, c, l;
  return s <= 0 ? (c = e - 1, l = uk(c) + s) : s > uk(e) ? (c = e + 1, l = s - uk(e)) : (c = e, l = s), {
    year: c,
    dayOfYear: l
  };
}
function l0(e, t, n) {
  var o = uT(e.year(), t, n), r = Math.floor((e.dayOfYear() - o - 1) / 7) + 1, i, a;
  return r < 1 ? (a = e.year() - 1, i = r + ff(a, t, n)) : r > ff(e.year(), t, n) ? (i = r - ff(e.year(), t, n), a = e.year() + 1) : (a = e.year(), i = r), {
    week: i,
    year: a
  };
}
function ff(e, t, n) {
  var o = uT(e, t, n), r = uT(e + 1, t, n);
  return (uk(e) - o + r) / 7;
}
lo("w", ["ww", 2], "wo", "week");
lo("W", ["WW", 2], "Wo", "isoWeek");
Uc("week", "w");
Uc("isoWeek", "W");
Gc("week", 5);
Gc("isoWeek", 5);
Zn("w", pa);
Zn("ww", pa, Xu);
Zn("W", pa);
Zn("WW", pa, Xu);
y1(
  ["w", "ww", "W", "WW"],
  function(e, t, n, o) {
    t[o.substr(0, 1)] = br(e);
  }
);
function SQl(e) {
  return l0(e, this._week.dow, this._week.doy).week;
}
var EQl = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function xQl() {
  return this._week.dow;
}
function CQl() {
  return this._week.doy;
}
function TQl(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function AQl(e) {
  var t = l0(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
lo("d", 0, "do", "day");
lo("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
lo("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
lo("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
lo("e", 0, 0, "weekday");
lo("E", 0, 0, "isoWeekday");
Uc("day", "d");
Uc("weekday", "e");
Uc("isoWeekday", "E");
Gc("day", 11);
Gc("weekday", 11);
Gc("isoWeekday", 11);
Zn("d", pa);
Zn("e", pa);
Zn("E", pa);
Zn("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Zn("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Zn("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
y1(["dd", "ddd", "dddd"], function(e, t, n, o) {
  var r = n._locale.weekdaysParse(e, o, n._strict);
  r != null ? t.d = r : sr(n).invalidWeekday = e;
});
y1(["d", "e", "E"], function(e, t, n, o) {
  t[o] = br(e);
});
function IQl(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function OQl(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function SV(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var NQl = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Lye = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), zQl = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), RQl = b1, PQl = b1, DQl = b1;
function LQl(e, t) {
  var n = B_(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? SV(n, this._week.dow) : e ? n[e.day()] : n;
}
function MQl(e) {
  return e === !0 ? SV(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function FQl(e) {
  return e === !0 ? SV(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function qQl(e, t, n) {
  var o, r, i, a = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], o = 0; o < 7; ++o)
      i = am([2e3, 1]).day(o), this._minWeekdaysParse[o] = this.weekdaysMin(
        i,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[o] = this.weekdaysShort(
        i,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[o] = this.weekdays(i, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (r = Ga.call(this._weekdaysParse, a), r !== -1 ? r : null) : t === "ddd" ? (r = Ga.call(this._shortWeekdaysParse, a), r !== -1 ? r : null) : (r = Ga.call(this._minWeekdaysParse, a), r !== -1 ? r : null) : t === "dddd" ? (r = Ga.call(this._weekdaysParse, a), r !== -1 || (r = Ga.call(this._shortWeekdaysParse, a), r !== -1) ? r : (r = Ga.call(this._minWeekdaysParse, a), r !== -1 ? r : null)) : t === "ddd" ? (r = Ga.call(this._shortWeekdaysParse, a), r !== -1 || (r = Ga.call(this._weekdaysParse, a), r !== -1) ? r : (r = Ga.call(this._minWeekdaysParse, a), r !== -1 ? r : null)) : (r = Ga.call(this._minWeekdaysParse, a), r !== -1 || (r = Ga.call(this._weekdaysParse, a), r !== -1) ? r : (r = Ga.call(this._shortWeekdaysParse, a), r !== -1 ? r : null));
}
function jQl(e, t, n) {
  var o, r, i;
  if (this._weekdaysParseExact)
    return qQl.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), o = 0; o < 7; o++) {
    if (r = am([2e3, 1]).day(o), n && !this._fullWeekdaysParse[o] && (this._fullWeekdaysParse[o] = new RegExp(
      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[o] || (i = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[o] = new RegExp(i.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[o].test(e))
      return o;
    if (n && t === "ddd" && this._shortWeekdaysParse[o].test(e))
      return o;
    if (n && t === "dd" && this._minWeekdaysParse[o].test(e))
      return o;
    if (!n && this._weekdaysParse[o].test(e))
      return o;
  }
}
function VQl(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = IQl(e, this.localeData()), this.add(e - t, "d")) : t;
}
function BQl(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function UQl(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = OQl(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function GQl(e) {
  return this._weekdaysParseExact ? (Wr(this, "_weekdaysRegex") || EV.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Wr(this, "_weekdaysRegex") || (this._weekdaysRegex = RQl), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function WQl(e) {
  return this._weekdaysParseExact ? (Wr(this, "_weekdaysRegex") || EV.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Wr(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = PQl), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function HQl(e) {
  return this._weekdaysParseExact ? (Wr(this, "_weekdaysRegex") || EV.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Wr(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = DQl), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function EV() {
  function e(u, d) {
    return d.length - u.length;
  }
  var t = [], n = [], o = [], r = [], i, a, s, c, l;
  for (i = 0; i < 7; i++)
    a = am([2e3, 1]).day(i), s = Ou(this.weekdaysMin(a, "")), c = Ou(this.weekdaysShort(a, "")), l = Ou(this.weekdays(a, "")), t.push(s), n.push(c), o.push(l), r.push(s), r.push(c), r.push(l);
  t.sort(e), n.sort(e), o.sort(e), r.sort(e), this._weekdaysRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + o.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function xV() {
  return this.hours() % 12 || 12;
}
function YQl() {
  return this.hours() || 24;
}
lo("H", ["HH", 2], 0, "hour");
lo("h", ["hh", 2], 0, xV);
lo("k", ["kk", 2], 0, YQl);
lo("hmm", 0, 0, function() {
  return "" + xV.apply(this) + Qp(this.minutes(), 2);
});
lo("hmmss", 0, 0, function() {
  return "" + xV.apply(this) + Qp(this.minutes(), 2) + Qp(this.seconds(), 2);
});
lo("Hmm", 0, 0, function() {
  return "" + this.hours() + Qp(this.minutes(), 2);
});
lo("Hmmss", 0, 0, function() {
  return "" + this.hours() + Qp(this.minutes(), 2) + Qp(this.seconds(), 2);
});
function Mye(e, t) {
  lo(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
Mye("a", !0);
Mye("A", !1);
Uc("hour", "h");
Gc("hour", 13);
function Fye(e, t) {
  return t._meridiemParse;
}
Zn("a", Fye);
Zn("A", Fye);
Zn("H", pa);
Zn("h", pa);
Zn("k", pa);
Zn("HH", pa, Xu);
Zn("hh", pa, Xu);
Zn("kk", pa, Xu);
Zn("hmm", Tye);
Zn("hmmss", Aye);
Zn("Hmm", Tye);
Zn("Hmmss", Aye);
qi(["H", "HH"], $s);
qi(["k", "kk"], function(e, t, n) {
  var o = br(e);
  t[$s] = o === 24 ? 0 : o;
});
qi(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
qi(["h", "hh"], function(e, t, n) {
  t[$s] = br(e), sr(n).bigHour = !0;
});
qi("hmm", function(e, t, n) {
  var o = e.length - 2;
  t[$s] = br(e.substr(0, o)), t[z_] = br(e.substr(o)), sr(n).bigHour = !0;
});
qi("hmmss", function(e, t, n) {
  var o = e.length - 4, r = e.length - 2;
  t[$s] = br(e.substr(0, o)), t[z_] = br(e.substr(o, 2)), t[af] = br(e.substr(r)), sr(n).bigHour = !0;
});
qi("Hmm", function(e, t, n) {
  var o = e.length - 2;
  t[$s] = br(e.substr(0, o)), t[z_] = br(e.substr(o));
});
qi("Hmmss", function(e, t, n) {
  var o = e.length - 4, r = e.length - 2;
  t[$s] = br(e.substr(0, o)), t[z_] = br(e.substr(o, 2)), t[af] = br(e.substr(r));
});
function KQl(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var ZQl = /[ap]\.?m?\.?/i, XQl = g$("Hours", !0);
function JQl(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var qye = {
  calendar: jJl,
  longDateFormat: GJl,
  invalidDate: HJl,
  ordinal: KJl,
  dayOfMonthOrdinalParse: ZJl,
  relativeTime: JJl,
  months: _Ql,
  monthsShort: Iye,
  week: EQl,
  weekdays: NQl,
  weekdaysMin: zQl,
  weekdaysShort: Lye,
  meridiemParse: ZQl
}, ha = {}, mw = {}, u0;
function QQl(e, t) {
  var n, o = Math.min(e.length, t.length);
  for (n = 0; n < o; n += 1)
    if (e[n] !== t[n])
      return n;
  return o;
}
function Qte(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function eeu(e) {
  for (var t = 0, n, o, r, i; t < e.length; ) {
    for (i = Qte(e[t]).split("-"), n = i.length, o = Qte(e[t + 1]), o = o ? o.split("-") : null; n > 0; ) {
      if (r = S2(i.slice(0, n).join("-")), r)
        return r;
      if (o && o.length >= n && QQl(i, o) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return u0;
}
function teu(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function S2(e) {
  var t = null, n;
  if (ha[e] === void 0 && typeof module < "u" && module && module.exports && teu(e))
    try {
      t = u0._abbr, n = require, n("./locale/" + e), Cg(t);
    } catch {
      ha[e] = null;
    }
  return ha[e];
}
function Cg(e, t) {
  var n;
  return e && (Vl(t) ? n = Nf(e) : n = CV(e, t), n ? u0 = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), u0._abbr;
}
function CV(e, t) {
  if (t !== null) {
    var n, o = qye;
    if (t.abbr = e, ha[e] != null)
      wye(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), o = ha[e]._config;
    else if (t.parentLocale != null)
      if (ha[t.parentLocale] != null)
        o = ha[t.parentLocale]._config;
      else if (n = S2(t.parentLocale), n != null)
        o = n._config;
      else
        return mw[t.parentLocale] || (mw[t.parentLocale] = []), mw[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return ha[e] = new bV(c6(o, t)), mw[e] && mw[e].forEach(function(r) {
      CV(r.name, r.config);
    }), Cg(e), ha[e];
  } else
    return delete ha[e], null;
}
function neu(e, t) {
  if (t != null) {
    var n, o, r = qye;
    ha[e] != null && ha[e].parentLocale != null ? ha[e].set(c6(ha[e]._config, t)) : (o = S2(e), o != null && (r = o._config), t = c6(r, t), o == null && (t.abbr = e), n = new bV(t), n.parentLocale = ha[e], ha[e] = n), Cg(e);
  } else
    ha[e] != null && (ha[e].parentLocale != null ? (ha[e] = ha[e].parentLocale, e === Cg() && Cg(e)) : ha[e] != null && delete ha[e]);
  return ha[e];
}
function Nf(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return u0;
  if (!B_(e)) {
    if (t = S2(e), t)
      return t;
    e = [e];
  }
  return eeu(e);
}
function oeu() {
  return l6(ha);
}
function TV(e) {
  var t, n = e._a;
  return n && sr(e).overflow === -2 && (t = n[rf] < 0 || n[rf] > 11 ? rf : n[Mp] < 1 || n[Mp] > k2(n[Lc], n[rf]) ? Mp : n[$s] < 0 || n[$s] > 24 || n[$s] === 24 && (n[z_] !== 0 || n[af] !== 0 || n[Bh] !== 0) ? $s : n[z_] < 0 || n[z_] > 59 ? z_ : n[af] < 0 || n[af] > 59 ? af : n[Bh] < 0 || n[Bh] > 999 ? Bh : -1, sr(e)._overflowDayOfYear && (t < Lc || t > Mp) && (t = Mp), sr(e)._overflowWeeks && t === -1 && (t = lQl), sr(e)._overflowWeekday && t === -1 && (t = uQl), sr(e).overflow = t), e;
}
var reu = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ieu = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, aeu = /Z|[+-]\d\d(?::?\d\d)?/, EE = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], j3 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], seu = /^\/?Date\((-?\d+)/i, ceu = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, leu = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function jye(e) {
  var t, n, o = e._i, r = reu.exec(o) || ieu.exec(o), i, a, s, c, l = EE.length, u = j3.length;
  if (r) {
    for (sr(e).iso = !0, t = 0, n = l; t < n; t++)
      if (EE[t][1].exec(r[1])) {
        a = EE[t][0], i = EE[t][2] !== !1;
        break;
      }
    if (a == null) {
      e._isValid = !1;
      return;
    }
    if (r[3]) {
      for (t = 0, n = u; t < n; t++)
        if (j3[t][1].exec(r[3])) {
          s = (r[2] || " ") + j3[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!i && s != null) {
      e._isValid = !1;
      return;
    }
    if (r[4])
      if (aeu.exec(r[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = a + (s || "") + (c || ""), IV(e);
  } else
    e._isValid = !1;
}
function ueu(e, t, n, o, r, i) {
  var a = [
    deu(e),
    Iye.indexOf(t),
    parseInt(n, 10),
    parseInt(o, 10),
    parseInt(r, 10)
  ];
  return i && a.push(parseInt(i, 10)), a;
}
function deu(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function _eu(e) {
  return e.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function peu(e, t, n) {
  if (e) {
    var o = Lye.indexOf(e), r = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (o !== r)
      return sr(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function meu(e, t, n) {
  if (e)
    return leu[e];
  if (t)
    return 0;
  var o = parseInt(n, 10), r = o % 100, i = (o - r) / 100;
  return i * 60 + r;
}
function Vye(e) {
  var t = ceu.exec(_eu(e._i)), n;
  if (t) {
    if (n = ueu(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !peu(t[1], n, e))
      return;
    e._a = n, e._tzm = meu(t[8], t[9], t[10]), e._d = c0.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), sr(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function feu(e) {
  var t = seu.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (jye(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Vye(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Un.createFromInputFallback(e);
}
Un.createFromInputFallback = Bd(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function kb(e, t, n) {
  return e ?? t ?? n;
}
function geu(e) {
  var t = new Date(Un.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function AV(e) {
  var t, n, o = [], r, i, a;
  if (!e._d) {
    for (r = geu(e), e._w && e._a[Mp] == null && e._a[rf] == null && heu(e), e._dayOfYear != null && (a = kb(e._a[Lc], r[Lc]), (e._dayOfYear > uk(a) || e._dayOfYear === 0) && (sr(e)._overflowDayOfYear = !0), n = c0(a, 0, e._dayOfYear), e._a[rf] = n.getUTCMonth(), e._a[Mp] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = o[t] = r[t];
    for (; t < 7; t++)
      e._a[t] = o[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[$s] === 24 && e._a[z_] === 0 && e._a[af] === 0 && e._a[Bh] === 0 && (e._nextDay = !0, e._a[$s] = 0), e._d = (e._useUTC ? c0 : kQl).apply(
      null,
      o
    ), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[$s] = 24), e._w && typeof e._w.d < "u" && e._w.d !== i && (sr(e).weekdayMismatch = !0);
  }
}
function heu(e) {
  var t, n, o, r, i, a, s, c, l;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (i = 1, a = 4, n = kb(
    t.GG,
    e._a[Lc],
    l0(da(), 1, 4).year
  ), o = kb(t.W, 1), r = kb(t.E, 1), (r < 1 || r > 7) && (c = !0)) : (i = e._locale._week.dow, a = e._locale._week.doy, l = l0(da(), i, a), n = kb(t.gg, e._a[Lc], l.year), o = kb(t.w, l.week), t.d != null ? (r = t.d, (r < 0 || r > 6) && (c = !0)) : t.e != null ? (r = t.e + i, (t.e < 0 || t.e > 6) && (c = !0)) : r = i), o < 1 || o > ff(n, i, a) ? sr(e)._overflowWeeks = !0 : c != null ? sr(e)._overflowWeekday = !0 : (s = Dye(n, o, r, i, a), e._a[Lc] = s.year, e._dayOfYear = s.dayOfYear);
}
Un.ISO_8601 = function() {
};
Un.RFC_2822 = function() {
};
function IV(e) {
  if (e._f === Un.ISO_8601) {
    jye(e);
    return;
  }
  if (e._f === Un.RFC_2822) {
    Vye(e);
    return;
  }
  e._a = [], sr(e).empty = !0;
  var t = "" + e._i, n, o, r, i, a, s = t.length, c = 0, l, u;
  for (r = kye(e._f, e._locale).match(yV) || [], u = r.length, n = 0; n < u; n++)
    i = r[n], o = (t.match(aQl(i, e)) || [])[0], o && (a = t.substr(0, t.indexOf(o)), a.length > 0 && sr(e).unusedInput.push(a), t = t.slice(
      t.indexOf(o) + o.length
    ), c += o.length), Xb[i] ? (o ? sr(e).empty = !1 : sr(e).unusedTokens.push(i), cQl(i, o, e)) : e._strict && !o && sr(e).unusedTokens.push(i);
  sr(e).charsLeftOver = s - c, t.length > 0 && sr(e).unusedInput.push(t), e._a[$s] <= 12 && sr(e).bigHour === !0 && e._a[$s] > 0 && (sr(e).bigHour = void 0), sr(e).parsedDateParts = e._a.slice(0), sr(e).meridiem = e._meridiem, e._a[$s] = veu(
    e._locale,
    e._a[$s],
    e._meridiem
  ), l = sr(e).era, l !== null && (e._a[Lc] = e._locale.erasConvertYear(l, e._a[Lc])), AV(e), TV(e);
}
function veu(e, t, n) {
  var o;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (o = e.isPM(n), o && t < 12 && (t += 12), !o && t === 12 && (t = 0)), t);
}
function beu(e) {
  var t, n, o, r, i, a, s = !1, c = e._f.length;
  if (c === 0) {
    sr(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (r = 0; r < c; r++)
    i = 0, a = !1, t = vV({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[r], IV(t), hV(t) && (a = !0), i += sr(t).charsLeftOver, i += sr(t).unusedTokens.length * 10, sr(t).score = i, s ? i < o && (o = i, n = t) : (o == null || i < o || a) && (o = i, n = t, a && (s = !0));
  fg(e, n || t);
}
function yeu(e) {
  if (!e._d) {
    var t = $V(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = yye(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(o) {
        return o && parseInt(o, 10);
      }
    ), AV(e);
  }
}
function $eu(e) {
  var t = new v1(TV(Bye(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Bye(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || Nf(e._l), t === null || n === void 0 && t === "" ? g2({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), U_(t) ? new v1(TV(t)) : (h1(t) ? e._d = t : B_(n) ? beu(e) : n ? IV(e) : weu(e), hV(e) || (e._d = null), e));
}
function weu(e) {
  var t = e._i;
  Vl(t) ? e._d = new Date(Un.now()) : h1(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? feu(e) : B_(t) ? (e._a = yye(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), AV(e)) : iv(t) ? yeu(e) : $f(t) ? e._d = new Date(t) : Un.createFromInputFallback(e);
}
function Uye(e, t, n, o, r) {
  var i = {};
  return (t === !0 || t === !1) && (o = t, t = void 0), (n === !0 || n === !1) && (o = n, n = void 0), (iv(e) && gV(e) || B_(e) && e.length === 0) && (e = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = r, i._l = n, i._i = e, i._f = t, i._strict = o, $eu(i);
}
function da(e, t, n, o) {
  return Uye(e, t, n, o, !1);
}
var keu = Bd(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = da.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : g2();
  }
), Seu = Bd(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = da.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : g2();
  }
);
function Gye(e, t) {
  var n, o;
  if (t.length === 1 && B_(t[0]) && (t = t[0]), !t.length)
    return da();
  for (n = t[0], o = 1; o < t.length; ++o)
    (!t[o].isValid() || t[o][e](n)) && (n = t[o]);
  return n;
}
function Eeu() {
  var e = [].slice.call(arguments, 0);
  return Gye("isBefore", e);
}
function xeu() {
  var e = [].slice.call(arguments, 0);
  return Gye("isAfter", e);
}
var Ceu = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, fw = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Teu(e) {
  var t, n = !1, o, r = fw.length;
  for (t in e)
    if (Wr(e, t) && !(Ga.call(fw, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (o = 0; o < r; ++o)
    if (e[fw[o]]) {
      if (n)
        return !1;
      parseFloat(e[fw[o]]) !== br(e[fw[o]]) && (n = !0);
    }
  return !0;
}
function Aeu() {
  return this._isValid;
}
function Ieu() {
  return J_(NaN);
}
function E2(e) {
  var t = $V(e), n = t.year || 0, o = t.quarter || 0, r = t.month || 0, i = t.week || t.isoWeek || 0, a = t.day || 0, s = t.hour || 0, c = t.minute || 0, l = t.second || 0, u = t.millisecond || 0;
  this._isValid = Teu(t), this._milliseconds = +u + l * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +a + i * 7, this._months = +r + o * 3 + n * 12, this._data = {}, this._locale = Nf(), this._bubble();
}
function hx(e) {
  return e instanceof E2;
}
function d6(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Oeu(e, t, n) {
  var o = Math.min(e.length, t.length), r = Math.abs(e.length - t.length), i = 0, a;
  for (a = 0; a < o; a++)
    (n && e[a] !== t[a] || !n && br(e[a]) !== br(t[a])) && i++;
  return i + r;
}
function Wye(e, t) {
  lo(e, 0, 0, function() {
    var n = this.utcOffset(), o = "+";
    return n < 0 && (n = -n, o = "-"), o + Qp(~~(n / 60), 2) + t + Qp(~~n % 60, 2);
  });
}
Wye("Z", ":");
Wye("ZZ", "");
Zn("Z", w2);
Zn("ZZ", w2);
qi(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = OV(w2, e);
});
var Neu = /([\+\-]|\d\d)/gi;
function OV(e, t) {
  var n = (t || "").match(e), o, r, i;
  return n === null ? null : (o = n[n.length - 1] || [], r = (o + "").match(Neu) || ["-", 0, 0], i = +(r[1] * 60) + br(r[2]), i === 0 ? 0 : r[0] === "+" ? i : -i);
}
function NV(e, t) {
  var n, o;
  return t._isUTC ? (n = t.clone(), o = (U_(e) || h1(e) ? e.valueOf() : da(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + o), Un.updateOffset(n, !1), n) : da(e).local();
}
function _6(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Un.updateOffset = function() {
};
function zeu(e, t, n) {
  var o = this._offset || 0, r;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = OV(w2, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (r = _6(this)), this._offset = e, this._isUTC = !0, r != null && this.add(r, "m"), o !== e && (!t || this._changeInProgress ? Kye(
      this,
      J_(e - o, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Un.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? o : _6(this);
}
function Reu(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Peu(e) {
  return this.utcOffset(0, e);
}
function Deu(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(_6(this), "m")), this;
}
function Leu() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = OV(rQl, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Meu(e) {
  return this.isValid() ? (e = e ? da(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Feu() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function qeu() {
  if (!Vl(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return vV(e, this), e = Bye(e), e._a ? (t = e._isUTC ? am(e._a) : da(e._a), this._isDSTShifted = this.isValid() && Oeu(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function jeu() {
  return this.isValid() ? !this._isUTC : !1;
}
function Veu() {
  return this.isValid() ? this._isUTC : !1;
}
function Hye() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Beu = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Ueu = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function J_(e, t) {
  var n = e, o = null, r, i, a;
  return hx(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : $f(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (o = Beu.exec(e)) ? (r = o[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: br(o[Mp]) * r,
    h: br(o[$s]) * r,
    m: br(o[z_]) * r,
    s: br(o[af]) * r,
    ms: br(d6(o[Bh] * 1e3)) * r
    // the millisecond decimal point is included in the match
  }) : (o = Ueu.exec(e)) ? (r = o[1] === "-" ? -1 : 1, n = {
    y: hh(o[2], r),
    M: hh(o[3], r),
    w: hh(o[4], r),
    d: hh(o[5], r),
    h: hh(o[6], r),
    m: hh(o[7], r),
    s: hh(o[8], r)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (a = Geu(
    da(n.from),
    da(n.to)
  ), n = {}, n.ms = a.milliseconds, n.M = a.months), i = new E2(n), hx(e) && Wr(e, "_locale") && (i._locale = e._locale), hx(e) && Wr(e, "_isValid") && (i._isValid = e._isValid), i;
}
J_.fn = E2.prototype;
J_.invalid = Ieu;
function hh(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function ene(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function Geu(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = NV(t, e), e.isBefore(t) ? n = ene(e, t) : (n = ene(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Yye(e, t) {
  return function(n, o) {
    var r, i;
    return o !== null && !isNaN(+o) && (wye(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), i = n, n = o, o = i), r = J_(n, o), Kye(this, r, e), this;
  };
}
function Kye(e, t, n, o) {
  var r = t._milliseconds, i = d6(t._days), a = d6(t._months);
  e.isValid() && (o = o ?? !0, a && Nye(e, cT(e, "Month") + a * n), i && Eye(e, "Date", cT(e, "Date") + i * n), r && e._d.setTime(e._d.valueOf() + r * n), o && Un.updateOffset(e, i || a));
}
var Weu = Yye(1, "add"), Heu = Yye(-1, "subtract");
function Zye(e) {
  return typeof e == "string" || e instanceof String;
}
function Yeu(e) {
  return U_(e) || h1(e) || Zye(e) || $f(e) || Zeu(e) || Keu(e) || e === null || e === void 0;
}
function Keu(e) {
  var t = iv(e) && !gV(e), n = !1, o = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], r, i, a = o.length;
  for (r = 0; r < a; r += 1)
    i = o[r], n = n || Wr(e, i);
  return t && n;
}
function Zeu(e) {
  var t = B_(e), n = !1;
  return t && (n = e.filter(function(o) {
    return !$f(o) && Zye(e);
  }).length === 0), t && n;
}
function Xeu(e) {
  var t = iv(e) && !gV(e), n = !1, o = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], r, i;
  for (r = 0; r < o.length; r += 1)
    i = o[r], n = n || Wr(e, i);
  return t && n;
}
function Jeu(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function Qeu(e, t) {
  arguments.length === 1 && (arguments[0] ? Yeu(arguments[0]) ? (e = arguments[0], t = void 0) : Xeu(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || da(), o = NV(n, this).startOf("day"), r = Un.calendarFormat(this, o) || "sameElse", i = t && (sm(t[r]) ? t[r].call(this, n) : t[r]);
  return this.format(
    i || this.localeData().calendar(r, this, da(n))
  );
}
function etu() {
  return new v1(this);
}
function ttu(e, t) {
  var n = U_(e) ? e : da(e);
  return this.isValid() && n.isValid() ? (t = Ud(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function ntu(e, t) {
  var n = U_(e) ? e : da(e);
  return this.isValid() && n.isValid() ? (t = Ud(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function otu(e, t, n, o) {
  var r = U_(e) ? e : da(e), i = U_(t) ? t : da(t);
  return this.isValid() && r.isValid() && i.isValid() ? (o = o || "()", (o[0] === "(" ? this.isAfter(r, n) : !this.isBefore(r, n)) && (o[1] === ")" ? this.isBefore(i, n) : !this.isAfter(i, n))) : !1;
}
function rtu(e, t) {
  var n = U_(e) ? e : da(e), o;
  return this.isValid() && n.isValid() ? (t = Ud(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (o = n.valueOf(), this.clone().startOf(t).valueOf() <= o && o <= this.clone().endOf(t).valueOf())) : !1;
}
function itu(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function atu(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function stu(e, t, n) {
  var o, r, i;
  if (!this.isValid())
    return NaN;
  if (o = NV(e, this), !o.isValid())
    return NaN;
  switch (r = (o.utcOffset() - this.utcOffset()) * 6e4, t = Ud(t), t) {
    case "year":
      i = vx(this, o) / 12;
      break;
    case "month":
      i = vx(this, o);
      break;
    case "quarter":
      i = vx(this, o) / 3;
      break;
    case "second":
      i = (this - o) / 1e3;
      break;
    case "minute":
      i = (this - o) / 6e4;
      break;
    case "hour":
      i = (this - o) / 36e5;
      break;
    case "day":
      i = (this - o - r) / 864e5;
      break;
    case "week":
      i = (this - o - r) / 6048e5;
      break;
    default:
      i = this - o;
  }
  return n ? i : Td(i);
}
function vx(e, t) {
  if (e.date() < t.date())
    return -vx(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), o = e.clone().add(n, "months"), r, i;
  return t - o < 0 ? (r = e.clone().add(n - 1, "months"), i = (t - o) / (o - r)) : (r = e.clone().add(n + 1, "months"), i = (t - o) / (r - o)), -(n + i) || 0;
}
Un.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Un.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function ctu() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function ltu(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? gx(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : sm(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", gx(n, "Z")) : gx(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function utu() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, o, r, i;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', o = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = "-MM-DD[T]HH:mm:ss.SSS", i = t + '[")]', this.format(n + o + r + i);
}
function dtu(e) {
  e || (e = this.isUtc() ? Un.defaultFormatUtc : Un.defaultFormat);
  var t = gx(this, e);
  return this.localeData().postformat(t);
}
function _tu(e, t) {
  return this.isValid() && (U_(e) && e.isValid() || da(e).isValid()) ? J_({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function ptu(e) {
  return this.from(da(), e);
}
function mtu(e, t) {
  return this.isValid() && (U_(e) && e.isValid() || da(e).isValid()) ? J_({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function ftu(e) {
  return this.to(da(), e);
}
function Xye(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Nf(e), t != null && (this._locale = t), this);
}
var Jye = Bd(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Qye() {
  return this._locale;
}
var dT = 1e3, Jb = 60 * dT, _T = 60 * Jb, e$e = (365 * 400 + 97) * 24 * _T;
function Qb(e, t) {
  return (e % t + t) % t;
}
function t$e(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - e$e : new Date(e, t, n).valueOf();
}
function n$e(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - e$e : Date.UTC(e, t, n);
}
function gtu(e) {
  var t, n;
  if (e = Ud(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? n$e : t$e, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Qb(
        t + (this._isUTC ? 0 : this.utcOffset() * Jb),
        _T
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Qb(t, Jb);
      break;
    case "second":
      t = this._d.valueOf(), t -= Qb(t, dT);
      break;
  }
  return this._d.setTime(t), Un.updateOffset(this, !0), this;
}
function htu(e) {
  var t, n;
  if (e = Ud(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? n$e : t$e, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += _T - Qb(
        t + (this._isUTC ? 0 : this.utcOffset() * Jb),
        _T
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Jb - Qb(t, Jb) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += dT - Qb(t, dT) - 1;
      break;
  }
  return this._d.setTime(t), Un.updateOffset(this, !0), this;
}
function vtu() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function btu() {
  return Math.floor(this.valueOf() / 1e3);
}
function ytu() {
  return new Date(this.valueOf());
}
function $tu() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function wtu() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function ktu() {
  return this.isValid() ? this.toISOString() : null;
}
function Stu() {
  return hV(this);
}
function Etu() {
  return fg({}, sr(this));
}
function xtu() {
  return sr(this).overflow;
}
function Ctu() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
lo("N", 0, 0, "eraAbbr");
lo("NN", 0, 0, "eraAbbr");
lo("NNN", 0, 0, "eraAbbr");
lo("NNNN", 0, 0, "eraName");
lo("NNNNN", 0, 0, "eraNarrow");
lo("y", ["y", 1], "yo", "eraYear");
lo("y", ["yy", 2], 0, "eraYear");
lo("y", ["yyy", 3], 0, "eraYear");
lo("y", ["yyyy", 4], 0, "eraYear");
Zn("N", zV);
Zn("NN", zV);
Zn("NNN", zV);
Zn("NNNN", Mtu);
Zn("NNNNN", Ftu);
qi(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, o) {
    var r = n._locale.erasParse(e, o, n._strict);
    r ? sr(n).era = r : sr(n).invalidEra = e;
  }
);
Zn("y", h$);
Zn("yy", h$);
Zn("yyy", h$);
Zn("yyyy", h$);
Zn("yo", qtu);
qi(["y", "yy", "yyy", "yyyy"], Lc);
qi(["yo"], function(e, t, n, o) {
  var r;
  n._locale._eraYearOrdinalRegex && (r = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[Lc] = n._locale.eraYearOrdinalParse(e, r) : t[Lc] = parseInt(e, 10);
});
function Ttu(e, t) {
  var n, o, r, i = this._eras || Nf("en")._eras;
  for (n = 0, o = i.length; n < o; ++n) {
    switch (typeof i[n].since) {
      case "string":
        r = Un(i[n].since).startOf("day"), i[n].since = r.valueOf();
        break;
    }
    switch (typeof i[n].until) {
      case "undefined":
        i[n].until = 1 / 0;
        break;
      case "string":
        r = Un(i[n].until).startOf("day").valueOf(), i[n].until = r.valueOf();
        break;
    }
  }
  return i;
}
function Atu(e, t, n) {
  var o, r, i = this.eras(), a, s, c;
  for (e = e.toUpperCase(), o = 0, r = i.length; o < r; ++o)
    if (a = i[o].name.toUpperCase(), s = i[o].abbr.toUpperCase(), c = i[o].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return i[o];
          break;
        case "NNNN":
          if (a === e)
            return i[o];
          break;
        case "NNNNN":
          if (c === e)
            return i[o];
          break;
      }
    else if ([a, s, c].indexOf(e) >= 0)
      return i[o];
}
function Itu(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Un(e.since).year() : Un(e.since).year() + (t - e.offset) * n;
}
function Otu() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].name;
  return "";
}
function Ntu() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].narrow;
  return "";
}
function ztu() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].abbr;
  return "";
}
function Rtu() {
  var e, t, n, o, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = r[e].since <= r[e].until ? 1 : -1, o = this.clone().startOf("day").valueOf(), r[e].since <= o && o <= r[e].until || r[e].until <= o && o <= r[e].since)
      return (this.year() - Un(r[e].since).year()) * n + r[e].offset;
  return this.year();
}
function Ptu(e) {
  return Wr(this, "_erasNameRegex") || RV.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Dtu(e) {
  return Wr(this, "_erasAbbrRegex") || RV.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Ltu(e) {
  return Wr(this, "_erasNarrowRegex") || RV.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function zV(e, t) {
  return t.erasAbbrRegex(e);
}
function Mtu(e, t) {
  return t.erasNameRegex(e);
}
function Ftu(e, t) {
  return t.erasNarrowRegex(e);
}
function qtu(e, t) {
  return t._eraYearOrdinalRegex || h$;
}
function RV() {
  var e = [], t = [], n = [], o = [], r, i, a = this.eras();
  for (r = 0, i = a.length; r < i; ++r)
    t.push(Ou(a[r].name)), e.push(Ou(a[r].abbr)), n.push(Ou(a[r].narrow)), o.push(Ou(a[r].name)), o.push(Ou(a[r].abbr)), o.push(Ou(a[r].narrow));
  this._erasRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
lo(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
lo(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function x2(e, t) {
  lo(0, [e, e.length], 0, t);
}
x2("gggg", "weekYear");
x2("ggggg", "weekYear");
x2("GGGG", "isoWeekYear");
x2("GGGGG", "isoWeekYear");
Uc("weekYear", "gg");
Uc("isoWeekYear", "GG");
Gc("weekYear", 1);
Gc("isoWeekYear", 1);
Zn("G", $2);
Zn("g", $2);
Zn("GG", pa, Xu);
Zn("gg", pa, Xu);
Zn("GGGG", kV, wV);
Zn("gggg", kV, wV);
Zn("GGGGG", y2, v2);
Zn("ggggg", y2, v2);
y1(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, o) {
    t[o.substr(0, 2)] = br(e);
  }
);
y1(["gg", "GG"], function(e, t, n, o) {
  t[o] = Un.parseTwoDigitYear(e);
});
function jtu(e) {
  return o$e.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Vtu(e) {
  return o$e.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Btu() {
  return ff(this.year(), 1, 4);
}
function Utu() {
  return ff(this.isoWeekYear(), 1, 4);
}
function Gtu() {
  var e = this.localeData()._week;
  return ff(this.year(), e.dow, e.doy);
}
function Wtu() {
  var e = this.localeData()._week;
  return ff(this.weekYear(), e.dow, e.doy);
}
function o$e(e, t, n, o, r) {
  var i;
  return e == null ? l0(this, o, r).year : (i = ff(e, o, r), t > i && (t = i), Htu.call(this, e, t, n, o, r));
}
function Htu(e, t, n, o, r) {
  var i = Dye(e, t, n, o, r), a = c0(i.year, 0, i.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
lo("Q", 0, "Qo", "quarter");
Uc("quarter", "Q");
Gc("quarter", 7);
Zn("Q", xye);
qi("Q", function(e, t) {
  t[rf] = (br(e) - 1) * 3;
});
function Ytu(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
lo("D", ["DD", 2], "Do", "date");
Uc("date", "D");
Gc("date", 9);
Zn("D", pa);
Zn("DD", pa, Xu);
Zn("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
qi(["D", "DD"], Mp);
qi("Do", function(e, t) {
  t[Mp] = br(e.match(pa)[0]);
});
var r$e = g$("Date", !0);
lo("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Uc("dayOfYear", "DDD");
Gc("dayOfYear", 4);
Zn("DDD", b2);
Zn("DDDD", Cye);
qi(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = br(e);
});
function Ktu(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
lo("m", ["mm", 2], 0, "minute");
Uc("minute", "m");
Gc("minute", 14);
Zn("m", pa);
Zn("mm", pa, Xu);
qi(["m", "mm"], z_);
var Ztu = g$("Minutes", !1);
lo("s", ["ss", 2], 0, "second");
Uc("second", "s");
Gc("second", 15);
Zn("s", pa);
Zn("ss", pa, Xu);
qi(["s", "ss"], af);
var Xtu = g$("Seconds", !1);
lo("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
lo(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
lo(0, ["SSS", 3], 0, "millisecond");
lo(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
lo(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
lo(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
lo(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
lo(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
lo(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Uc("millisecond", "ms");
Gc("millisecond", 16);
Zn("S", b2, xye);
Zn("SS", b2, Xu);
Zn("SSS", b2, Cye);
var gg, i$e;
for (gg = "SSSS"; gg.length <= 9; gg += "S")
  Zn(gg, h$);
function Jtu(e, t) {
  t[Bh] = br(("0." + e) * 1e3);
}
for (gg = "S"; gg.length <= 9; gg += "S")
  qi(gg, Jtu);
i$e = g$("Milliseconds", !1);
lo("z", 0, 0, "zoneAbbr");
lo("zz", 0, 0, "zoneName");
function Qtu() {
  return this._isUTC ? "UTC" : "";
}
function enu() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var mn = v1.prototype;
mn.add = Weu;
mn.calendar = Qeu;
mn.clone = etu;
mn.diff = stu;
mn.endOf = htu;
mn.format = dtu;
mn.from = _tu;
mn.fromNow = ptu;
mn.to = mtu;
mn.toNow = ftu;
mn.get = nQl;
mn.invalidAt = xtu;
mn.isAfter = ttu;
mn.isBefore = ntu;
mn.isBetween = otu;
mn.isSame = rtu;
mn.isSameOrAfter = itu;
mn.isSameOrBefore = atu;
mn.isValid = Stu;
mn.lang = Jye;
mn.locale = Xye;
mn.localeData = Qye;
mn.max = Seu;
mn.min = keu;
mn.parsingFlags = Etu;
mn.set = oQl;
mn.startOf = gtu;
mn.subtract = Heu;
mn.toArray = $tu;
mn.toObject = wtu;
mn.toDate = ytu;
mn.toISOString = ltu;
mn.inspect = utu;
typeof Symbol < "u" && Symbol.for != null && (mn[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
mn.toJSON = ktu;
mn.toString = ctu;
mn.unix = btu;
mn.valueOf = vtu;
mn.creationData = Ctu;
mn.eraName = Otu;
mn.eraNarrow = Ntu;
mn.eraAbbr = ztu;
mn.eraYear = Rtu;
mn.year = Pye;
mn.isLeapYear = wQl;
mn.weekYear = jtu;
mn.isoWeekYear = Vtu;
mn.quarter = mn.quarters = Ytu;
mn.month = zye;
mn.daysInMonth = bQl;
mn.week = mn.weeks = TQl;
mn.isoWeek = mn.isoWeeks = AQl;
mn.weeksInYear = Gtu;
mn.weeksInWeekYear = Wtu;
mn.isoWeeksInYear = Btu;
mn.isoWeeksInISOWeekYear = Utu;
mn.date = r$e;
mn.day = mn.days = VQl;
mn.weekday = BQl;
mn.isoWeekday = UQl;
mn.dayOfYear = Ktu;
mn.hour = mn.hours = XQl;
mn.minute = mn.minutes = Ztu;
mn.second = mn.seconds = Xtu;
mn.millisecond = mn.milliseconds = i$e;
mn.utcOffset = zeu;
mn.utc = Peu;
mn.local = Deu;
mn.parseZone = Leu;
mn.hasAlignedHourOffset = Meu;
mn.isDST = Feu;
mn.isLocal = jeu;
mn.isUtcOffset = Veu;
mn.isUtc = Hye;
mn.isUTC = Hye;
mn.zoneAbbr = Qtu;
mn.zoneName = enu;
mn.dates = Bd(
  "dates accessor is deprecated. Use date instead.",
  r$e
);
mn.months = Bd(
  "months accessor is deprecated. Use month instead",
  zye
);
mn.years = Bd(
  "years accessor is deprecated. Use year instead",
  Pye
);
mn.zone = Bd(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Reu
);
mn.isDSTShifted = Bd(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  qeu
);
function tnu(e) {
  return da(e * 1e3);
}
function nnu() {
  return da.apply(null, arguments).parseZone();
}
function a$e(e) {
  return e;
}
var Zr = bV.prototype;
Zr.calendar = VJl;
Zr.longDateFormat = WJl;
Zr.invalidDate = YJl;
Zr.ordinal = XJl;
Zr.preparse = a$e;
Zr.postformat = a$e;
Zr.relativeTime = QJl;
Zr.pastFuture = eQl;
Zr.set = qJl;
Zr.eras = Ttu;
Zr.erasParse = Atu;
Zr.erasConvertYear = Itu;
Zr.erasAbbrRegex = Dtu;
Zr.erasNameRegex = Ptu;
Zr.erasNarrowRegex = Ltu;
Zr.months = fQl;
Zr.monthsShort = gQl;
Zr.monthsParse = vQl;
Zr.monthsRegex = $Ql;
Zr.monthsShortRegex = yQl;
Zr.week = SQl;
Zr.firstDayOfYear = CQl;
Zr.firstDayOfWeek = xQl;
Zr.weekdays = LQl;
Zr.weekdaysMin = FQl;
Zr.weekdaysShort = MQl;
Zr.weekdaysParse = jQl;
Zr.weekdaysRegex = GQl;
Zr.weekdaysShortRegex = WQl;
Zr.weekdaysMinRegex = HQl;
Zr.isPM = KQl;
Zr.meridiem = JQl;
function pT(e, t, n, o) {
  var r = Nf(), i = am().set(o, t);
  return r[n](i, e);
}
function s$e(e, t, n) {
  if ($f(e) && (t = e, e = void 0), e = e || "", t != null)
    return pT(e, t, n, "month");
  var o, r = [];
  for (o = 0; o < 12; o++)
    r[o] = pT(e, o, n, "month");
  return r;
}
function PV(e, t, n, o) {
  typeof e == "boolean" ? ($f(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, $f(t) && (n = t, t = void 0), t = t || "");
  var r = Nf(), i = e ? r._week.dow : 0, a, s = [];
  if (n != null)
    return pT(t, (n + i) % 7, o, "day");
  for (a = 0; a < 7; a++)
    s[a] = pT(t, (a + i) % 7, o, "day");
  return s;
}
function onu(e, t) {
  return s$e(e, t, "months");
}
function rnu(e, t) {
  return s$e(e, t, "monthsShort");
}
function inu(e, t, n) {
  return PV(e, t, n, "weekdays");
}
function anu(e, t, n) {
  return PV(e, t, n, "weekdaysShort");
}
function snu(e, t, n) {
  return PV(e, t, n, "weekdaysMin");
}
Cg("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = br(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
Un.lang = Bd(
  "moment.lang is deprecated. Use moment.locale instead.",
  Cg
);
Un.langData = Bd(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Nf
);
var Gm = Math.abs;
function cnu() {
  var e = this._data;
  return this._milliseconds = Gm(this._milliseconds), this._days = Gm(this._days), this._months = Gm(this._months), e.milliseconds = Gm(e.milliseconds), e.seconds = Gm(e.seconds), e.minutes = Gm(e.minutes), e.hours = Gm(e.hours), e.months = Gm(e.months), e.years = Gm(e.years), this;
}
function c$e(e, t, n, o) {
  var r = J_(t, n);
  return e._milliseconds += o * r._milliseconds, e._days += o * r._days, e._months += o * r._months, e._bubble();
}
function lnu(e, t) {
  return c$e(this, e, t, 1);
}
function unu(e, t) {
  return c$e(this, e, t, -1);
}
function tne(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function dnu() {
  var e = this._milliseconds, t = this._days, n = this._months, o = this._data, r, i, a, s, c;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += tne(p6(n) + t) * 864e5, t = 0, n = 0), o.milliseconds = e % 1e3, r = Td(e / 1e3), o.seconds = r % 60, i = Td(r / 60), o.minutes = i % 60, a = Td(i / 60), o.hours = a % 24, t += Td(a / 24), c = Td(l$e(t)), n += c, t -= tne(p6(c)), s = Td(n / 12), n %= 12, o.days = t, o.months = n, o.years = s, this;
}
function l$e(e) {
  return e * 4800 / 146097;
}
function p6(e) {
  return e * 146097 / 4800;
}
function _nu(e) {
  if (!this.isValid())
    return NaN;
  var t, n, o = this._milliseconds;
  if (e = Ud(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + o / 864e5, n = this._months + l$e(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(p6(this._months)), e) {
      case "week":
        return t / 7 + o / 6048e5;
      case "day":
        return t + o / 864e5;
      case "hour":
        return t * 24 + o / 36e5;
      case "minute":
        return t * 1440 + o / 6e4;
      case "second":
        return t * 86400 + o / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + o;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function pnu() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + br(this._months / 12) * 31536e6 : NaN;
}
function zf(e) {
  return function() {
    return this.as(e);
  };
}
var mnu = zf("ms"), fnu = zf("s"), gnu = zf("m"), hnu = zf("h"), vnu = zf("d"), bnu = zf("w"), ynu = zf("M"), $nu = zf("Q"), wnu = zf("y");
function knu() {
  return J_(this);
}
function Snu(e) {
  return e = Ud(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Mv(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Enu = Mv("milliseconds"), xnu = Mv("seconds"), Cnu = Mv("minutes"), Tnu = Mv("hours"), Anu = Mv("days"), Inu = Mv("months"), Onu = Mv("years");
function Nnu() {
  return Td(this.days() / 7);
}
var Xm = Math.round, Nb = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function znu(e, t, n, o, r) {
  return r.relativeTime(t || 1, !!n, e, o);
}
function Rnu(e, t, n, o) {
  var r = J_(e).abs(), i = Xm(r.as("s")), a = Xm(r.as("m")), s = Xm(r.as("h")), c = Xm(r.as("d")), l = Xm(r.as("M")), u = Xm(r.as("w")), d = Xm(r.as("y")), _ = i <= n.ss && ["s", i] || i < n.s && ["ss", i] || a <= 1 && ["m"] || a < n.m && ["mm", a] || s <= 1 && ["h"] || s < n.h && ["hh", s] || c <= 1 && ["d"] || c < n.d && ["dd", c];
  return n.w != null && (_ = _ || u <= 1 && ["w"] || u < n.w && ["ww", u]), _ = _ || l <= 1 && ["M"] || l < n.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d], _[2] = t, _[3] = +e > 0, _[4] = o, znu.apply(null, _);
}
function Pnu(e) {
  return e === void 0 ? Xm : typeof e == "function" ? (Xm = e, !0) : !1;
}
function Dnu(e, t) {
  return Nb[e] === void 0 ? !1 : t === void 0 ? Nb[e] : (Nb[e] = t, e === "s" && (Nb.ss = t - 1), !0);
}
function Lnu(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, o = Nb, r, i;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (o = Object.assign({}, Nb, t), t.s != null && t.ss == null && (o.ss = t.s - 1)), r = this.localeData(), i = Rnu(this, !n, o, r), n && (i = r.pastFuture(+this, i)), r.postformat(i);
}
var V3 = Math.abs;
function bb(e) {
  return (e > 0) - (e < 0) || +e;
}
function C2() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = V3(this._milliseconds) / 1e3, t = V3(this._days), n = V3(this._months), o, r, i, a, s = this.asSeconds(), c, l, u, d;
  return s ? (o = Td(e / 60), r = Td(o / 60), e %= 60, o %= 60, i = Td(n / 12), n %= 12, a = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = s < 0 ? "-" : "", l = bb(this._months) !== bb(s) ? "-" : "", u = bb(this._days) !== bb(s) ? "-" : "", d = bb(this._milliseconds) !== bb(s) ? "-" : "", c + "P" + (i ? l + i + "Y" : "") + (n ? l + n + "M" : "") + (t ? u + t + "D" : "") + (r || o || e ? "T" : "") + (r ? d + r + "H" : "") + (o ? d + o + "M" : "") + (e ? d + a + "S" : "")) : "P0D";
}
var zr = E2.prototype;
zr.isValid = Aeu;
zr.abs = cnu;
zr.add = lnu;
zr.subtract = unu;
zr.as = _nu;
zr.asMilliseconds = mnu;
zr.asSeconds = fnu;
zr.asMinutes = gnu;
zr.asHours = hnu;
zr.asDays = vnu;
zr.asWeeks = bnu;
zr.asMonths = ynu;
zr.asQuarters = $nu;
zr.asYears = wnu;
zr.valueOf = pnu;
zr._bubble = dnu;
zr.clone = knu;
zr.get = Snu;
zr.milliseconds = Enu;
zr.seconds = xnu;
zr.minutes = Cnu;
zr.hours = Tnu;
zr.days = Anu;
zr.weeks = Nnu;
zr.months = Inu;
zr.years = Onu;
zr.humanize = Lnu;
zr.toISOString = C2;
zr.toString = C2;
zr.toJSON = C2;
zr.locale = Xye;
zr.localeData = Qye;
zr.toIsoString = Bd(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  C2
);
zr.lang = Jye;
lo("X", 0, 0, "unix");
lo("x", 0, 0, "valueOf");
Zn("x", $2);
Zn("X", iQl);
qi("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
qi("x", function(e, t, n) {
  n._d = new Date(br(e));
});
//! moment.js
Un.version = "2.29.3";
MJl(da);
Un.fn = mn;
Un.min = Eeu;
Un.max = xeu;
Un.now = Ceu;
Un.utc = am;
Un.unix = tnu;
Un.months = onu;
Un.isDate = h1;
Un.locale = Cg;
Un.invalid = g2;
Un.duration = J_;
Un.isMoment = U_;
Un.weekdays = inu;
Un.parseZone = nnu;
Un.localeData = Nf;
Un.isDuration = hx;
Un.monthsShort = rnu;
Un.weekdaysMin = snu;
Un.defineLocale = CV;
Un.updateLocale = neu;
Un.locales = oeu;
Un.weekdaysShort = anu;
Un.normalizeUnits = Ud;
Un.relativeTimeRounding = Pnu;
Un.relativeTimeThreshold = Dnu;
Un.calendarFormat = Jeu;
Un.prototype = mn;
Un.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Mnu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Un
}, Symbol.toStringTag, { value: "Module" })), Fv = /* @__PURE__ */ nu(Mnu);
var nne;
function Fnu() {
  return nne || (nne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe);
    t(Fv);
    var r = function(a) {
      var s = a.value, c = a.setValue;
      a.config, a.valueFormat;
      var l = a.readonly, u = a.customProps, d = function(p) {
        var g = p.target.value;
        g == "" && (g = void 0), c(g);
      };
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "date",
        value: s || "",
        disabled: l,
        onChange: d
      }, u));
    };
    e.default = r;
  }(M3)), M3;
}
var B3 = {}, one;
function qnu() {
  return one || (one = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config, a.valueFormat, a.use12Hours;
      var l = a.readonly, u = a.customProps, d = function(p) {
        var g = p.target.value;
        g == "" && (g = void 0), c(g);
      };
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "time",
        value: s || "",
        disabled: l,
        onChange: d
      }, u));
    };
    e.default = r;
  }(B3)), B3;
}
var U3 = {}, rne;
function jnu() {
  return rne || (rne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = t(Fv), i = function(s) {
      var c = s.value, l = s.setValue;
      s.config;
      var u = s.valueFormat;
      s.use12Hours;
      var d = s.readonly, _ = s.customProps, p = function(h) {
        var $ = h.target.value;
        $ == "" ? $ = void 0 : $ = (0, r.default)(new Date($)).format(u), l($);
      }, g = c;
      return c ? g = (0, r.default)(c).format("YYYY-MM-DDTHH:mm") : g = "", /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "datetime-local",
        value: g,
        disabled: d,
        onChange: p
      }, _));
    };
    e.default = i;
  }(U3)), U3;
}
var G3 = {}, ine;
function Vnu() {
  return ine || (ine = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = Ti(), i = t(Of()), a = function(c) {
      var l = c.listValues, u = c.value, d = c.setValue;
      c.allowCustomValues;
      var _ = c.readonly, p = c.customProps, g = function() {
        return (0, r.mapListValues)(l, function(v) {
          var b = v.title, y = v.value;
          return /* @__PURE__ */ o.default.createElement("option", {
            key: y,
            value: y
          }, b);
        });
      }, f = function(v) {
        for (var b = [], y = v.options, w = 0; w < y.length; w++) {
          var N = y[w];
          N.selected && b.push(N.value);
        }
        return b.length || (b = void 0), b;
      }, h = function(v) {
        return d(f(v.target));
      };
      return /* @__PURE__ */ o.default.createElement("select", (0, n.default)({
        multiple: !0,
        onChange: h,
        value: u,
        disabled: _
      }, (0, i.default)(p, ["showSearch", "input", "showCheckboxes"])), g());
    };
    e.default = a;
  }(G3)), G3;
}
var W3 = {}, ane;
function Bnu() {
  return ane || (ane = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = Ti(), i = t(Of()), a = function(c) {
      var l = c.listValues, u = c.value, d = c.setValue;
      c.allowCustomValues;
      var _ = c.readonly, p = c.customProps, g = function() {
        return (0, r.mapListValues)(l, function(v) {
          var b = v.title, y = v.value;
          return /* @__PURE__ */ o.default.createElement("option", {
            key: y,
            value: y
          }, b);
        });
      }, f = function(v) {
        return d(v.target.value);
      }, h = u != null;
      return /* @__PURE__ */ o.default.createElement("select", (0, n.default)({
        onChange: f,
        value: h ? u : "",
        disabled: _
      }, (0, i.default)(p, ["showSearch", "input"])), !h && /* @__PURE__ */ o.default.createElement("option", {
        disabled: !0,
        value: ""
      }), g());
    };
    e.default = a;
  }(W3)), W3;
}
var H3 = {}, sne;
function Unu() {
  return sne || (sne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, u = a.min, d = a.max, _ = a.step, p = a.placeholder, g = a.customProps, f = function(v) {
        var b = v.target.value;
        b === "" || b === null ? b = void 0 : b = Number(b), c(b);
      }, h = s ?? "";
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "number",
        value: h,
        placeholder: p,
        disabled: l,
        min: u,
        max: d,
        step: _,
        onChange: f
      }, g));
    };
    e.default = r;
  }(H3)), H3;
}
var Y3 = {}, cne;
function Gnu() {
  return cne || (cne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Ys), o = t(Fe), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, u = a.min, d = a.max, _ = a.step, p = a.placeholder, g = a.customProps, f = g === void 0 ? {} : g, h = f.input || {}, $ = f.slider || f, v = function(w) {
        var N = w.target.value;
        N === "" || N === null ? N = void 0 : N = Number(N), c(N);
      }, b = s ?? "";
      return [/* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: "number",
        type: "number",
        value: b,
        placeholder: p,
        disabled: l,
        min: u,
        max: d,
        step: _,
        onChange: v
      }, h)), /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: "range",
        type: "range",
        value: b,
        disabled: l,
        min: u,
        max: d,
        step: _,
        onChange: v
      }, $))];
    };
    e.default = r;
  }(Y3)), Y3;
}
var K3 = {}, lne;
function Wnu() {
  return lne || (lne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Fe), o = function(i) {
      var a = i.items, s = i.setField, c = i.selectedKey, l = i.readonly, u = function p(g) {
        return g.map(function(f) {
          var h = f.items, $ = f.path, v = f.label, b = f.disabled;
          return h ? /* @__PURE__ */ n.default.createElement("optgroup", {
            disabled: b,
            key: $,
            label: v
          }, p(h)) : /* @__PURE__ */ n.default.createElement("option", {
            disabled: b,
            key: $,
            value: $
          }, v);
        });
      }, d = function(g) {
        return s(g.target.value);
      }, _ = c != null;
      return /* @__PURE__ */ n.default.createElement("select", {
        onChange: d,
        value: _ ? c : "",
        disabled: l
      }, !_ && /* @__PURE__ */ n.default.createElement("option", {
        disabled: !0,
        value: ""
      }), u(a));
    };
    e.default = o;
  }(K3)), K3;
}
var Z3 = {}, une;
function Hnu() {
  return une || (une = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Fe), o = function(i) {
      var a = i.id, s = i.not, c = i.setNot, l = i.conjunctionOptions, u = i.setConjunction, d = i.disabled, _ = i.readonly, p = i.config, g = i.showNot, f = i.notLabel, h = Object.keys(l).length, $ = d, v = p.settings.forceShowConj, b = v || h > 1 && !$, y = function() {
        return Object.keys(l).map(function(L) {
          var R = l[L], T = R.id, D = R.name, A = R.label, S = R.checked, E = u.isDummyFn ? "__dummy" : "";
          return (_ || d) && !S ? null : [/* @__PURE__ */ n.default.createElement("input", {
            key: T + E,
            type: "radio",
            id: T + E,
            name: D + E,
            checked: S,
            disabled: _ || d,
            value: L,
            onChange: N
          }), /* @__PURE__ */ n.default.createElement("label", {
            key: T + E + "label",
            htmlFor: T + E
          }, A)];
        });
      }, w = function() {
        var L = "not";
        return [/* @__PURE__ */ n.default.createElement("input", {
          key: a + L,
          type: "checkbox",
          id: a + L,
          checked: s,
          disabled: _,
          onChange: M
        }), /* @__PURE__ */ n.default.createElement("label", {
          key: a + L + "label",
          htmlFor: a + L
        }, f || "NOT")];
      }, N = function(L) {
        return u(L.target.value);
      }, M = function(L) {
        return c(L.target.checked);
      };
      return [g && w(), b && y()];
    };
    e.default = o;
  }(Z3)), Z3;
}
var X3 = {}, dne;
function Ynu() {
  return dne || (dne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Fe), o = function(i) {
      var a = i.type, s = i.label, c = i.onClick, l = i.readonly;
      i.config;
      var u = {
        addRuleGroup: "+",
        addRuleGroupExt: "+",
        delGroup: "x",
        delRuleGroup: "x",
        delRule: "x"
      }, d = s || u[a];
      return /* @__PURE__ */ n.default.createElement("button", {
        onClick: c,
        type: "button",
        disabled: l
      }, d);
    };
    e.default = o;
  }(X3)), X3;
}
var J3 = {}, _ne;
function Knu() {
  return _ne || (_ne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Fe), o = function(i) {
      var a = i.children;
      return i.config, /* @__PURE__ */ n.default.createElement(n.default.Fragment, null, a);
    };
    e.default = o;
  }(J3)), J3;
}
var Q3 = {}, pne;
function Znu() {
  return pne || (pne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Gu()), o = t(Fe), r = function(a) {
      a.config;
      var s = a.valueSources, c = a.valueSrc;
      a.title;
      var l = a.setValueSrc, u = a.readonly, d = function(g) {
        return g.map(function(f) {
          var h = (0, n.default)(f, 2), $ = h[0], v = h[1];
          return /* @__PURE__ */ o.default.createElement("option", {
            key: $,
            value: $
          }, v.label);
        });
      }, _ = function(g) {
        return l(g.target.value);
      };
      return /* @__PURE__ */ o.default.createElement("select", {
        onChange: _,
        value: c,
        disabled: u
      }, d(s));
    };
    e.default = r;
  }(Q3)), Q3;
}
var eL = {}, mne;
function Xnu() {
  return mne || (mne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Fe), o = function(i) {
      var a = i.value, s = i.setValue, c = i.label, l = i.id;
      i.config;
      var u = i.type, d = function(g) {
        return s(g.target.checked);
      }, _ = u;
      return [/* @__PURE__ */ n.default.createElement("input", {
        key: l + _,
        type: "checkbox",
        id: l + _,
        checked: !!a,
        onChange: d
      }), /* @__PURE__ */ n.default.createElement("label", {
        key: l + _ + "label",
        htmlFor: l + _
      }, c)];
    };
    e.default = o;
  }(eL)), eL;
}
var tL = {}, fne;
function Jnu() {
  return fne || (fne = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = function(o) {
      var r = o.onOk;
      o.okText, o.cancelText;
      var i = o.title;
      confirm(i) && r();
    };
    e.default = t;
  }(tL)), tL;
}
var gne;
function Qnu() {
  return gne || (gne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "VanillaBooleanWidget", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(e, "VanillaButton", {
      enumerable: !0,
      get: function() {
        return g.default;
      }
    }), Object.defineProperty(e, "VanillaButtonGroup", {
      enumerable: !0,
      get: function() {
        return f.default;
      }
    }), Object.defineProperty(e, "VanillaConjs", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), Object.defineProperty(e, "VanillaDateTimeWidget", {
      enumerable: !0,
      get: function() {
        return s.default;
      }
    }), Object.defineProperty(e, "VanillaDateWidget", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "VanillaFieldSelect", {
      enumerable: !0,
      get: function() {
        return _.default;
      }
    }), Object.defineProperty(e, "VanillaMultiSelectWidget", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(e, "VanillaNumberWidget", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), e.VanillaProvider = void 0, Object.defineProperty(e, "VanillaSelectWidget", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    }), Object.defineProperty(e, "VanillaSliderWidget", {
      enumerable: !0,
      get: function() {
        return d.default;
      }
    }), Object.defineProperty(e, "VanillaSwitch", {
      enumerable: !0,
      get: function() {
        return $.default;
      }
    }), Object.defineProperty(e, "VanillaTextAreaWidget", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(e, "VanillaTextWidget", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    }), Object.defineProperty(e, "VanillaTimeWidget", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    }), Object.defineProperty(e, "VanillaValueSources", {
      enumerable: !0,
      get: function() {
        return h.default;
      }
    }), Object.defineProperty(e, "vanillaConfirm", {
      enumerable: !0,
      get: function() {
        return v.default;
      }
    }), t(Fe);
    var n = t(PJl()), o = t(DJl()), r = t(LJl()), i = t(Fnu()), a = t(qnu()), s = t(jnu()), c = t(Vnu()), l = t(Bnu()), u = t(Unu()), d = t(Gnu()), _ = t(Wnu()), p = t(Hnu()), g = t(Ynu()), f = t(Knu()), h = t(Znu()), $ = t(Xnu()), v = t(Jnu()), b = function(w) {
      w.config;
      var N = w.children;
      return N;
    };
    e.VanillaProvider = b;
  }(R3)), R3;
}
var hne;
function DV() {
  return hne || (hne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = {
      ValueFieldWidget: !0,
      FuncWidget: !0
    };
    Object.defineProperty(e, "FuncWidget", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(e, "ValueFieldWidget", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    });
    var o = t(CJl()), r = t(RJl()), i = Qnu();
    Object.keys(i).forEach(function(a) {
      a === "default" || a === "__esModule" || Object.prototype.hasOwnProperty.call(n, a) || a in e && e[a] === i[a] || Object.defineProperty(e, a, {
        enumerable: !0,
        get: function() {
          return i[a];
        }
      });
    });
  }(cD)), cD;
}
var vne;
function v$() {
  if (vne)
    return pw;
  vne = 1;
  var e = Tn, t = xo;
  Object.defineProperty(pw, "__esModule", {
    value: !0
  }), pw.settings = void 0;
  var n = i(DV()), o = e(Fe);
  function r(f) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
    return (r = function(b) {
      return b ? $ : h;
    })(f);
  }
  function i(f, h) {
    if (!h && f && f.__esModule)
      return f;
    if (f === null || t(f) !== "object" && typeof f != "function")
      return { default: f };
    var $ = r(h);
    if ($ && $.has(f))
      return $.get(f);
    var v = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in f)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(f, y)) {
        var w = b ? Object.getOwnPropertyDescriptor(f, y) : null;
        w && (w.get || w.set) ? Object.defineProperty(v, y, w) : v[y] = f[y];
      }
    return v.default = f, $ && $.set(f, v), v;
  }
  var a = n.VanillaFieldSelect, s = n.VanillaConjs, c = n.VanillaButton, l = n.VanillaButtonGroup, u = n.VanillaProvider, d = n.VanillaValueSources, _ = n.vanillaConfirm, p = n.VanillaSwitch, g = {
    formatField: function(h, $, v, b, y, w) {
      return w ? v : h;
    },
    renderField: function(h) {
      return /* @__PURE__ */ o.default.createElement(a, h);
    },
    renderOperator: function(h) {
      return /* @__PURE__ */ o.default.createElement(a, h);
    },
    renderFunc: function(h) {
      return /* @__PURE__ */ o.default.createElement(a, h);
    },
    renderConjs: function(h) {
      return /* @__PURE__ */ o.default.createElement(s, h);
    },
    renderSwitch: function(h) {
      return /* @__PURE__ */ o.default.createElement(p, h);
    },
    renderButton: function(h) {
      return /* @__PURE__ */ o.default.createElement(c, h);
    },
    renderButtonGroup: function(h) {
      return /* @__PURE__ */ o.default.createElement(l, h);
    },
    renderProvider: function(h) {
      return /* @__PURE__ */ o.default.createElement(u, h);
    },
    renderValueSources: function(h) {
      return /* @__PURE__ */ o.default.createElement(d, h);
    },
    renderConfirm: _,
    renderSwitchPrefix: function() {
      return /* @__PURE__ */ o.default.createElement(o.default.Fragment, null, "Conditions");
    },
    valueSourcesInfo: {
      value: {}
    },
    fieldSeparator: ".",
    fieldSeparatorDisplay: ".",
    renderSize: "small",
    maxLabelsLength: 100,
    canReorder: !0,
    canRegroup: !0,
    showLock: !1,
    canDeleteLocked: !1,
    showNot: !0,
    canLeaveEmptyGroup: !0,
    shouldCreateEmptyGroup: !1,
    forceShowConj: !1,
    canShortMongoQuery: !0,
    removeEmptyGroupsOnLoad: !0,
    removeIncompleteRulesOnLoad: !1,
    groupActionsPosition: "topRight",
    // oneOf [topLeft, topCenter, topRight, bottomLeft, bottomCenter, bottomRight]
    setOpOnChangeField: ["keep", "default"],
    // 'default' (default if present), 'keep' (keep prev from last field), 'first', 'none'
    groupOperators: ["some", "all", "none"],
    convertableWidgets: {
      number: ["slider", "rangeslider"],
      slider: ["number", "rangeslider"],
      rangeslider: ["number", "slider"],
      text: ["textarea"],
      textarea: ["text"]
    },
    // localization
    locale: {
      moment: "en"
    },
    valueLabel: "Value",
    valuePlaceholder: "Value",
    fieldLabel: "Field",
    operatorLabel: "Operator",
    funcLabel: "Function",
    fieldPlaceholder: "Select field",
    funcPlaceholder: "Select function",
    operatorPlaceholder: "Select operator",
    lockLabel: "Lock",
    lockedLabel: "Locked",
    deleteLabel: null,
    addGroupLabel: "Add group",
    addCaseLabel: "Add condition",
    addDefaultCaseLabel: "Add default condition",
    defaultCaseLabel: "Default:",
    addRuleLabel: "Add rule",
    addSubRuleLabel: "Add sub rule",
    delGroupLabel: "",
    notLabel: "Not",
    valueSourcesPopupTitle: "Select value source",
    removeRuleConfirmOptions: null,
    removeGroupConfirmOptions: null,
    defaultGroupConjunction: "AND",
    jsonLogic: {
      groupVarKey: "var",
      altVarKey: "var",
      lockedOp: "locked"
    }
  };
  return pw.settings = g, pw;
}
var bne;
function Qi() {
  if (bne)
    return vs;
  bne = 1;
  var e = Tn;
  Object.defineProperty(vs, "__esModule", {
    value: !0
  }), vs.normalizeField = vs.getOperatorConfig = vs.getFuncConfig = vs.getFuncArgConfig = vs.getFieldWidgetConfig = vs.getFieldRawConfig = vs.getFieldConfig = vs.extendConfig = void 0;
  var t = e(xo), n = e(Zu), o = e(NXl()), r = e(zXl()), i = v$(), a = e(Fv), s = Ti(), c = Es(), l = e(m2());
  function u(T, D) {
    var A = typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
    if (!A) {
      if (Array.isArray(T) || (A = d(T)) || D && T && typeof T.length == "number") {
        A && (T = A);
        var S = 0, E = function() {
        };
        return { s: E, n: function() {
          return S >= T.length ? { done: !0 } : { done: !1, value: T[S++] };
        }, e: function(F) {
          throw F;
        }, f: E };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var x = !0, k = !1, I;
    return { s: function() {
      A = A.call(T);
    }, n: function() {
      var F = A.next();
      return x = F.done, F;
    }, e: function(F) {
      k = !0, I = F;
    }, f: function() {
      try {
        !x && A.return != null && A.return();
      } finally {
        if (k)
          throw I;
      }
    } };
  }
  function d(T, D) {
    if (T) {
      if (typeof T == "string")
        return _(T, D);
      var A = Object.prototype.toString.call(T).slice(8, -1);
      if (A === "Object" && T.constructor && (A = T.constructor.name), A === "Map" || A === "Set")
        return Array.from(T);
      if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A))
        return _(T, D);
    }
  }
  function _(T, D) {
    (D == null || D > T.length) && (D = T.length);
    for (var A = 0, S = new Array(D); A < D; A++)
      S[A] = T[A];
    return S;
  }
  var p = function(D) {
    return D.__extended || (D.settings = (0, o.default)({}, i.settings, D.settings), D._fieldsCntByType = {}, D._funcsCntByType = {}, D.types = (0, l.default)(D.types), g(D.types, D), D.fields = (0, l.default)(D.fields), D.__fieldNames = {}, h(D.fields, D), D.funcs = (0, l.default)(D.funcs), $(D.funcs, D), a.default.locale(D.settings.locale.moment), Object.defineProperty(D, "__extended", {
      enumerable: !1,
      writable: !1,
      value: !0
    })), D;
  };
  vs.extendConfig = p;
  function g(T, D) {
    for (var A in T) {
      var S = T[A];
      f(A, S, D);
    }
  }
  function f(T, D, A) {
    var S = null, E = null;
    D.mainWidget = D.mainWidget || Object.keys(D.widgets).filter(function(O) {
      return O != "field" && O != "func";
    })[0];
    for (var x in D.widgets) {
      var k = D.widgets[x];
      if (k.operators) {
        var I = k.operators;
        D.excludeOperators && (I = I.filter(function(O) {
          return !D.excludeOperators.includes(O);
        })), S = (0, s.mergeArraysSmart)(S, I);
      }
      k.defaultOperator && (E = k.defaultOperator), x == D.mainWidget && (k = (0, o.default)({}, {
        widgetProps: D.mainWidgetProps || {}
      }, k)), D.widgets[x] = k;
    }
    D.valueSources || (D.valueSources = Object.keys(A.settings.valueSourcesInfo));
    var z = u(D.valueSources), F;
    try {
      for (z.s(); !(F = z.n()).done; ) {
        var P = F.value;
        P != "value" && !D.widgets[P] && (D.widgets[P] = {});
      }
    } catch (O) {
      z.e(O);
    } finally {
      z.f();
    }
    !D.operators && S && (D.operators = Array.from(new Set(S))), !D.defaultOperator && E && (D.defaultOperator = E);
  }
  function h(T, D) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    for (var S in T)
      v(T[S], D, [].concat((0, n.default)(A), [S])), T[S].subfields && h(T[S].subfields, D, [].concat((0, n.default)(A), [S]));
  }
  function $(T, D) {
    if (T)
      for (var A in T) {
        var S = T[A];
        S.returnType && (D._funcsCntByType[S.returnType] || (D._funcsCntByType[S.returnType] = 0), D._funcsCntByType[S.returnType]++);
        for (var E in S.args)
          v(S.args[E], D, null, !0);
        if (S.args) {
          var x = Object.keys(S.args), k = !0, I = u(x.reverse()), z;
          try {
            for (I.s(); !(z = I.n()).done; ) {
              var F = z.value, P = S.args[F];
              !k && P.isOptional && delete P.isOptional, P.isOptional || (k = !1);
            }
          } catch (O) {
            I.e(O);
          } finally {
            I.f();
          }
        }
        S.subfields && $(S.subfields, D);
      }
  }
  function v(T, D) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, E = null, x = null, k = D.types[T.type], I = T.excludeOperators || [];
    if (T.type != "!struct" && T.type != "!group") {
      if (!k) {
        T.disabled = !0;
        return;
      }
      S || (D._fieldsCntByType[T.type] || (D._fieldsCntByType[T.type] = 0), D._fieldsCntByType[T.type]++), T.widgets || (T.widgets = {}), S && (T._isFuncArg = !0), T.mainWidget = T.mainWidget || k.mainWidget, T.valueSources = T.valueSources || k.valueSources;
      var z = k.excludeOperators || [];
      for (var F in k.widgets) {
        var P = T.widgets[F] || {}, O = k.widgets[F] || {};
        S || function() {
          var ae = [].concat((0, n.default)(I), (0, n.default)(z)), Y = T.preferWidgets && (F == "field" || T.preferWidgets.includes(F)) || ae.length > 0;
          if (P.operators) {
            var re = P.operators.filter(function(_e) {
              return !ae.includes(_e);
            });
            E = [].concat((0, n.default)(E || []), (0, n.default)(re));
          } else if (Y && O.operators) {
            var ie = O.operators.filter(function(_e) {
              return !ae.includes(_e);
            });
            E = [].concat((0, n.default)(E || []), (0, n.default)(ie));
          }
          P.defaultOperator && (x = P.defaultOperator);
        }(), F == T.mainWidget && (P = (0, o.default)({}, {
          widgetProps: T.mainWidgetProps || {}
        }, P)), T.widgets[F] = P;
      }
      S || (!T.operators && E && (T.operators = Array.from(new Set(E))), !T.defaultOperator && x && (T.defaultOperator = x));
      var V = ["listValues", "allowCustomValues", "validateValue"];
      T.fieldSettings || (T.fieldSettings = {});
      for (var U = 0, H = V; U < H.length; U++) {
        var J = H[U];
        T[J] && (T.fieldSettings[J] = T[J], delete T[J]);
      }
      T.fieldSettings.listValues && (T.fieldSettings.listValues = (0, s.normalizeListValues)(T.fieldSettings.listValues, T.type, T.fieldSettings));
    }
    var le = y(D, A);
    le && (T.fieldName = le), A && T.fieldName && (D.__fieldNames[T.fieldName] = A);
  }
  var b = function(D, A) {
    var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "fields", E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "subfields";
    if (!A)
      return null;
    if (A == "!case_value")
      return {
        type: "case_value",
        mainWidget: "case_value",
        widgets: {
          case_value: D.widgets.case_value
        }
      };
    var x = D.settings.fieldSeparator, k = Array.isArray(A) ? A : A.split(x), I = D[S];
    if (!I)
      return null;
    for (var z = I, F = null, P = [], O = 0; O < k.length; O++) {
      var V = k[O];
      P.push(V);
      var U = P.join(x);
      F = z[U], O < k.length - 1 && (F && F[E] ? (z = F[E], P = []) : F = null);
    }
    return F;
  };
  vs.getFieldRawConfig = b;
  var y = function(D, A) {
    if (!A)
      return null;
    for (var S = D.settings.fieldSeparator, E = (0, n.default)(A), x = [], k, I; (k = E.pop()) !== void 0 && E.length > 0; )
      if (x.unshift(k), I = b(D, E), I.fieldName)
        return [I.fieldName].concat(x).join(S);
    return null;
  }, w = function(D, A) {
    var S = D.settings.fieldSeparator, E = Array.isArray(A) ? A.join(S) : A;
    return D.__fieldNames[E] ? D.__fieldNames[E].join(S) : E;
  };
  vs.normalizeField = w;
  var N = function(D, A) {
    if (!A)
      return null;
    var S = b(D, A, "funcs", "subfields");
    return S || null;
  };
  vs.getFuncConfig = N;
  var M = function(D, A, S) {
    var E = N(D, A);
    if (!E)
      return null;
    var x = E.args && E.args[S] || null;
    if (!x)
      return null;
    var k = D.types[x.type] || {}, I = (0, r.default)({}, k, x || {}, function(z, F, P, O, V, U) {
      if (Array.isArray(z))
        return F;
    });
    return I;
  };
  vs.getFuncArgConfig = M;
  var q = function(D, A) {
    if (!A)
      return null;
    if ((0, t.default)(A) == "object" && !A.func && A.type)
      return A;
    if ((0, t.default)(A) == "object" && A.func && A.arg)
      return M(D, A.func, A.arg);
    var S = b(D, A);
    if (!S)
      return null;
    var E = D.types[S.type] || {}, x = (0, r.default)({}, E, S || {}, function(k, I, z, F, P, O) {
      if (Array.isArray(k))
        return I;
    });
    return x;
  };
  vs.getFieldConfig = q;
  var L = function(D, A) {
    var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!A)
      return null;
    var E = D.operators[A];
    if (S) {
      var x = q(D, S), k = (0, c.getWidgetForFieldOp)(D, S, A), I = D.widgets[k] || {}, z = (x && x.widgets ? x.widgets[k] : {}) || {}, F = (I.opProps || {})[A], P = (z.opProps || {})[A], O = (0, o.default)({}, E, F, P);
      return O;
    } else
      return E;
  };
  vs.getOperatorConfig = L;
  var R = function(D, A, S) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (!A || !(S || E) && x != "const" && A != "!case_value")
      return null;
    var k = q(D, A);
    E || (E = (0, c.getWidgetForFieldOp)(D, A, S, x));
    var I = D.widgets[E] || {}, z = (k && k.widgets ? k.widgets[E] : {}) || {}, F = z.widgetProps || {}, P = (x == "value" || !x) && k && k.fieldSettings || {}, O = (0, o.default)({}, I, F, P);
    return O;
  };
  return vs.getFieldWidgetConfig = R, vs;
}
var yne;
function kl() {
  if (yne)
    return Ca;
  yne = 1;
  var e = Tn;
  Object.defineProperty(Ca, "__esModule", {
    value: !0
  }), Ca.defaultRuleProperties = Ca.defaultRule = Ca.defaultRoot = Ca.defaultOperatorOptions = Ca.defaultOperator = Ca.defaultItemProperties = Ca.defaultGroupProperties = Ca.defaultGroupConjunction = Ca.defaultField = Ca.defaultConjunction = void 0;
  var t = e(Yr()), n = e(uc()), o = e(Ug()), r = Qi(), i = Es();
  function a(v, b) {
    var y = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var w = Object.getOwnPropertySymbols(v);
      b && (w = w.filter(function(N) {
        return Object.getOwnPropertyDescriptor(v, N).enumerable;
      })), y.push.apply(y, w);
    }
    return y;
  }
  function s(v) {
    for (var b = 1; b < arguments.length; b++) {
      var y = arguments[b] != null ? arguments[b] : {};
      b % 2 ? a(Object(y), !0).forEach(function(w) {
        (0, t.default)(v, w, y[w]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(y)) : a(Object(y)).forEach(function(w) {
        Object.defineProperty(v, w, Object.getOwnPropertyDescriptor(y, w));
      });
    }
    return v;
  }
  var c = function(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return typeof b.settings.defaultField == "function" ? b.settings.defaultField(w) : b.settings.defaultField || (y ? (0, i.getFirstField)(b, w) : null);
  };
  Ca.defaultField = c;
  var l = function(b, y) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, N = (0, r.getFieldConfig)(b, y), M = N && N.operators || [], q = N && N.defaultOperator;
    M.includes(q) || (q = null), !q && w && (q = (0, i.getFirstOperator)(b, y));
    var L = typeof b.settings.defaultOperator == "function" ? b.settings.defaultOperator(y, N) : q;
    return L;
  };
  Ca.defaultOperator = l;
  var u = function(b, y, w) {
    var N = y ? (0, r.getOperatorConfig)(b, y, w) : null;
    return N && N.options ? new n.default.Map(N.options && N.options.defaults || {}) : null;
  };
  Ca.defaultOperatorOptions = u;
  var d = function(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, N = null, M = null, q = b.settings, L = q.setDefaultFieldAndOp, R = q.showErrorMessage;
    if (w) {
      var T, D;
      N = w == null || (T = w.properties) === null || T === void 0 ? void 0 : T.field, M = w == null || (D = w.properties) === null || D === void 0 ? void 0 : D.operator;
    } else
      L && (N = c(b, !0, y), M = l(b, N));
    var A = new n.default.Map({
      field: N,
      operator: M,
      value: new n.default.List(),
      valueSrc: new n.default.List(),
      //used for complex operators like proximity
      operatorOptions: u(b, M, N)
    });
    if (R && (A = A.set("valueError", new n.default.List())), N && M) {
      var S = (0, i.getNewValueForFieldOp)(b, b, A, N, M, "operator", !1), E = S.newValue, x = S.newValueSrc, k = S.newValueType, I = S.newValueError;
      A = A.set("value", E).set("valueSrc", x).set("valueType", k), R && (A = A.set("valueError", I));
    }
    return A;
  };
  Ca.defaultRuleProperties = d;
  var _ = function(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    y = (0, r.getFieldConfig)(b, y);
    var w = y && y.conjunctions || Object.keys(b.conjunctions);
    return w.length == 1 ? w[0] : b.settings.defaultGroupConjunction || b.settings.defaultConjunction || w[0];
  };
  Ca.defaultGroupConjunction = _;
  var p = function(b) {
    return b.settings.defaultConjunction || Object.keys(b.conjunctions)[0];
  };
  Ca.defaultConjunction = p;
  var g = function(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return new n.default.Map({
      conjunction: _(b, y),
      not: !1
    });
  };
  Ca.defaultGroupProperties = g;
  var f = function(b, y) {
    var w;
    return y && y.type == "group" ? g(b, y == null || (w = y.properties) === null || w === void 0 ? void 0 : w.field) : d(b, null, y);
  };
  Ca.defaultItemProperties = f;
  var h = function(b, y) {
    return (0, t.default)({}, b, new n.default.Map({
      type: "rule",
      id: b,
      properties: d(y)
    }));
  };
  Ca.defaultRule = h;
  var $ = function(b) {
    return b.tree ? new n.default.Map(b.tree) : new n.default.Map({
      type: "group",
      id: (0, o.default)(),
      children1: new n.default.OrderedMap(s({}, h((0, o.default)(), b))),
      properties: g(b)
    });
  };
  return Ca.defaultRoot = $, Ca;
}
var Vo = {}, $ne;
function b$() {
  if ($ne)
    return Vo;
  $ne = 1, Object.defineProperty(Vo, "__esModule", {
    value: !0
  }), Vo.SET_VALUE_SRC = Vo.SET_VALUE = Vo.SET_TREE = Vo.SET_OPERATOR_OPTION = Vo.SET_OPERATOR = Vo.SET_NOT = Vo.SET_LOCK = Vo.SET_FIELD = Vo.SET_DRAG_START = Vo.SET_DRAG_PROGRESS = Vo.SET_DRAG_END = Vo.SET_CONJUNCTION = Vo.REMOVE_RULE = Vo.REMOVE_GROUP = Vo.PLACEMENT_PREPEND = Vo.PLACEMENT_BEFORE = Vo.PLACEMENT_APPEND = Vo.PLACEMENT_AFTER = Vo.MOVE_ITEM = Vo.ADD_RULE = Vo.ADD_GROUP = Vo.ADD_CASE_GROUP = void 0;
  var e = "ADD_GROUP";
  Vo.ADD_GROUP = e;
  var t = "ADD_CASE_GROUP";
  Vo.ADD_CASE_GROUP = t;
  var n = "REMOVE_GROUP";
  Vo.REMOVE_GROUP = n;
  var o = "SET_CONJUNCTION";
  Vo.SET_CONJUNCTION = o;
  var r = "SET_NOT";
  Vo.SET_NOT = r;
  var i = "ADD_RULE";
  Vo.ADD_RULE = i;
  var a = "REMOVE_RULE";
  Vo.REMOVE_RULE = a;
  var s = "SET_FIELD";
  Vo.SET_FIELD = s;
  var c = "SET_OPERATOR";
  Vo.SET_OPERATOR = c;
  var l = "SET_VALUE";
  Vo.SET_VALUE = l;
  var u = "SET_VALUE_SRC";
  Vo.SET_VALUE_SRC = u;
  var d = "SET_OPERATOR_OPTION";
  Vo.SET_OPERATOR_OPTION = d;
  var _ = "SET_LOCK";
  Vo.SET_LOCK = _;
  var p = "SET_TREE";
  Vo.SET_TREE = p;
  var g = "MOVE_ITEM";
  Vo.MOVE_ITEM = g;
  var f = "after";
  Vo.PLACEMENT_AFTER = f;
  var h = "before";
  Vo.PLACEMENT_BEFORE = h;
  var $ = "append";
  Vo.PLACEMENT_APPEND = $;
  var v = "prepend";
  Vo.PLACEMENT_PREPEND = v;
  var b = "SET_DRAG_PROGRESS";
  Vo.SET_DRAG_PROGRESS = b;
  var y = "SET_DRAG_START";
  Vo.SET_DRAG_START = y;
  var w = "SET_DRAG_END";
  return Vo.SET_DRAG_END = w, Vo;
}
var wne;
function eou() {
  return wne || (wne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Gu()), r = t(Yr()), i = t(uc()), a = Pv(), s = kl(), c = $(b$()), l = t(Ug()), u = Qi(), d = Es(), _ = Ti(), p = f1(), g = t(Of()), f = t(p2());
    function h(ae) {
      if (typeof WeakMap != "function")
        return null;
      var Y = /* @__PURE__ */ new WeakMap(), re = /* @__PURE__ */ new WeakMap();
      return (h = function(_e) {
        return _e ? re : Y;
      })(ae);
    }
    function $(ae, Y) {
      if (!Y && ae && ae.__esModule)
        return ae;
      if (ae === null || n(ae) !== "object" && typeof ae != "function")
        return { default: ae };
      var re = h(Y);
      if (re && re.has(ae))
        return re.get(ae);
      var ie = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var he in ae)
        if (he !== "default" && Object.prototype.hasOwnProperty.call(ae, he)) {
          var be = _e ? Object.getOwnPropertyDescriptor(ae, he) : null;
          be && (be.get || be.set) ? Object.defineProperty(ie, he, be) : ie[he] = ae[he];
        }
      return ie.default = ae, re && re.set(ae, ie), ie;
    }
    function v(ae, Y) {
      var re = typeof Symbol < "u" && ae[Symbol.iterator] || ae["@@iterator"];
      if (!re) {
        if (Array.isArray(ae) || (re = b(ae)) || Y && ae && typeof ae.length == "number") {
          re && (ae = re);
          var ie = 0, _e = function() {
          };
          return { s: _e, n: function() {
            return ie >= ae.length ? { done: !0 } : { done: !1, value: ae[ie++] };
          }, e: function(ne) {
            throw ne;
          }, f: _e };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var he = !0, be = !1, Q;
      return { s: function() {
        re = re.call(ae);
      }, n: function() {
        var ne = re.next();
        return he = ne.done, ne;
      }, e: function(ne) {
        be = !0, Q = ne;
      }, f: function() {
        try {
          !he && re.return != null && re.return();
        } finally {
          if (be)
            throw Q;
        }
      } };
    }
    function b(ae, Y) {
      if (ae) {
        if (typeof ae == "string")
          return y(ae, Y);
        var re = Object.prototype.toString.call(ae).slice(8, -1);
        if (re === "Object" && ae.constructor && (re = ae.constructor.name), re === "Map" || re === "Set")
          return Array.from(ae);
        if (re === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(re))
          return y(ae, Y);
      }
    }
    function y(ae, Y) {
      (Y == null || Y > ae.length) && (Y = ae.length);
      for (var re = 0, ie = new Array(Y); re < Y; re++)
        ie[re] = ae[re];
      return ie;
    }
    function w(ae, Y) {
      var re = Object.keys(ae);
      if (Object.getOwnPropertySymbols) {
        var ie = Object.getOwnPropertySymbols(ae);
        Y && (ie = ie.filter(function(_e) {
          return Object.getOwnPropertyDescriptor(ae, _e).enumerable;
        })), re.push.apply(re, ie);
      }
      return re;
    }
    function N(ae) {
      for (var Y = 1; Y < arguments.length; Y++) {
        var re = arguments[Y] != null ? arguments[Y] : {};
        Y % 2 ? w(Object(re), !0).forEach(function(ie) {
          (0, r.default)(ae, ie, re[ie]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ae, Object.getOwnPropertyDescriptors(re)) : w(Object(re)).forEach(function(ie) {
          Object.defineProperty(ae, ie, Object.getOwnPropertyDescriptor(re, ie));
        });
      }
      return ae;
    }
    var M = function(Y, re, ie, _e, he, be) {
      var Q = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, me = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, ne = be.settings.shouldCreateEmptyGroup, pe = re.push(_e), ge = !ne, ve = !!(me != null && me.isDefaultCase), Te = Y;
      return Y = S(Y, re, ie, _e, (0, s.defaultGroupProperties)(be).merge(he || {}), be, Q), Y !== Te && (!Q && !ve && (Y = Y.setIn((0, a.expandTreePath)(pe, "children1"), new i.default.OrderedMap()), ge && (Y = S(Y, pe, "rule", (0, l.default)(), (0, s.defaultRuleProperties)(be), be))), Y = (0, a.fixPathsInTree)(Y)), Y;
    }, q = function(Y, re, ie) {
      Y = E(Y, re);
      var _e = ie.settings.canLeaveEmptyGroup, he = re.slice(0, -1), be = !(0, a.hasChildren)(Y, he);
      return be && !_e && (Y = (0, a.fixEmptyGroupsInTree)(Y), (0, a.isEmptyTree)(Y) && !_e && (Y = S(Y, new i.default.List(), "rule", (0, l.default)(), (0, s.defaultRuleProperties)(ie), ie))), Y = (0, a.fixPathsInTree)(Y), Y;
    }, L = function(Y, re, ie) {
      Y = E(Y, re);
      var _e = ie.settings.canLeaveEmptyGroup, he = re.pop(), be = Y.getIn((0, a.expandTreePath)(he)), Q = be.getIn(["properties", "field"]), me = be.getIn(["properties", "operator"]);
      be.getIn(["properties", "value", 0]);
      var ne = Q ? (0, u.getFieldConfig)(ie, Q) : null, pe = me ? (0, u.getOperatorConfig)(ie, me, Q) : null, ge = Q && me && pe.cardinality != 0, ve = be.get("type") == "rule_group", Te = !(0, a.hasChildren)(Y, he), Re = ve ? ge && ne.initialEmptyWhere : _e;
      return Te && !Re && (ve && (Y = Y.deleteIn((0, a.expandTreePath)(he))), Y = (0, a.fixEmptyGroupsInTree)(Y), (0, a.isEmptyTree)(Y) && !_e && (Y = S(Y, new i.default.List(), "rule", (0, l.default)(), (0, s.defaultRuleProperties)(ie), ie))), Y = (0, a.fixPathsInTree)(Y), Y;
    }, R = function(Y, re, ie) {
      return Y.setIn((0, a.expandTreePath)(re, "properties", "not"), ie);
    }, T = function(Y, re, ie) {
      return (0, a.removeIsLockedInTree)(Y.setIn((0, a.expandTreePath)(re, "properties", "isLocked"), ie));
    }, D = function(Y, re, ie) {
      return Y.setIn((0, a.expandTreePath)(re, "properties", "conjunction"), ie);
    }, A = function ae(Y, re, ie) {
      ie && Array.isArray(ie) && (re.children1 = new i.default.OrderedMap(ie.reduce(function(_e, he) {
        var be = (0, l.default)(), Q = N(N({}, he), {}, {
          properties: (0, s.defaultItemProperties)(Y, he).merge(he.properties || {}),
          id: be
        });
        return ae(Y, Q, Q.children1), N(N({}, _e), {}, (0, r.default)({}, be, new i.default.Map(Q)));
      }, {})));
    }, S = function(Y, re, ie, _e, he, be) {
      var Q = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
      if (ie == "switch_group")
        throw new Error("Can't add switch_group programmatically");
      var me = be.settings, ne = me.maxNumberOfCases, pe = me.maxNumberOfRules, ge = me.maxNesting, ve = Y.get("type"), Te = ve == "switch_group", Re = Y.getIn((0, a.expandTreePath)(re)), Me = Te ? Y.getIn((0, a.expandTreePath)(re.take(2))) : null, et = (0, a.expandTreePath)(re, "children1"), st = Y.getIn(et), De = !!st && st.size, ze = De ? st.size : null, Pe, je;
      ie == "case_group" ? (Pe = ze, je = ne) : ie == "group" ? (Pe = re.size, je = ge) : (Re == null ? void 0 : Re.get("type")) == "rule_group" || (Pe = Te ? (0, a.getTotalRulesCountInTree)(Me) : (0, a.getTotalRulesCountInTree)(Y), je = pe);
      var He = je && Pe ? Pe < je : !0, Xe = {
        type: ie,
        id: _e,
        properties: he
      };
      A(be, Xe, Q);
      var at = ie == "case_group" && De && st.last().get("children1") == null;
      if (He) {
        var wt = new i.default.OrderedMap((0, r.default)({}, _e, new i.default.Map(Xe)));
        if (!De)
          Y = Y.setIn(et, wt);
        else if (at) {
          var Je, vt = st.last(), Ot = new i.default.OrderedMap((Je = {}, (0, r.default)(Je, _e, new i.default.Map(Xe)), (0, r.default)(Je, vt.get("id"), vt), Je));
          Y = Y.deleteIn((0, a.expandTreePath)(et, "children1", vt.get("id"))), Y = Y.mergeIn(et, Ot);
        } else
          Y = Y.mergeIn(et, wt);
        Y = (0, a.fixPathsInTree)(Y);
      }
      return Y;
    }, E = function(Y, re) {
      return Y = Y.deleteIn((0, a.expandTreePath)(re)), Y = (0, a.fixPathsInTree)(Y), Y;
    }, x = function(Y, re, ie, _e, he) {
      var be = (0, a.getItemByPath)(Y, re), Q = re.pop(), me = re.size > 1 ? (0, a.getItemByPath)(Y, Q) : null, ne = me ? me.get("children1") : null, pe = (0, a.getItemByPath)(Y, ie), ge = _e == c.PLACEMENT_APPEND || _e == c.PLACEMENT_PREPEND ? ie : ie.pop(), ve = _e == c.PLACEMENT_APPEND || _e == c.PLACEMENT_PREPEND ? pe : ie.size > 1 ? (0, a.getItemByPath)(Y, ge) : null, Te = ve ? ve.get("children1") : null;
      if (!me || !ve)
        return Y;
      var Re = me.get("id") == ve.get("id"), Me = ge.size < Q.size && (0, _.deepEqual)(ge.toArray(), Q.toArray().slice(0, ge.size)), et = ge.size > Q.size && (0, _.deepEqual)(Q.toArray(), ge.toArray().slice(0, Q.size)), st = null, De = null;
      Me ? st = i.default.List(Q.toArray().slice(ge.size)) : et && (De = i.default.List(ge.toArray().slice(Q.size)));
      var ze = Te, Pe = ne;
      return et || (Pe = Pe.delete(be.get("id"))), Re ? ze = Pe : Me && (ze = ze.updateIn((0, a.expandTreeSubpath)(st, "children1"), function(je) {
        return Pe;
      })), _e == c.PLACEMENT_BEFORE || _e == c.PLACEMENT_AFTER ? ze = i.default.OrderedMap().withMutations(function(je) {
        var He = v(ze.entries()), Xe;
        try {
          for (He.s(); !(Xe = He.n()).done; ) {
            var at = (0, o.default)(Xe.value, 2), wt = at[0], Je = at[1];
            wt == pe.get("id") && _e == c.PLACEMENT_BEFORE && je.set(be.get("id"), be), je.set(wt, Je), wt == pe.get("id") && _e == c.PLACEMENT_AFTER && je.set(be.get("id"), be);
          }
        } catch (vt) {
          He.e(vt);
        } finally {
          He.f();
        }
      }) : _e == c.PLACEMENT_APPEND ? ze = ze.merge((0, r.default)({}, be.get("id"), be)) : _e == c.PLACEMENT_PREPEND && (ze = i.default.OrderedMap((0, r.default)({}, be.get("id"), be)).merge(ze)), et && (Pe = Pe.updateIn((0, a.expandTreeSubpath)(De, "children1"), function(je) {
        return ze;
      }), Pe = Pe.delete(be.get("id"))), !Re && !Me && (Y = Y.updateIn((0, a.expandTreePath)(Q, "children1"), function(je) {
        return Pe;
      })), et || (Y = Y.updateIn((0, a.expandTreePath)(ge, "children1"), function(je) {
        return ze;
      })), Y = (0, a.fixPathsInTree)(Y), Y;
    }, k = function(Y, re, ie, _e) {
      if (!ie)
        return E(Y, re);
      var he = _e.settings, be = he.fieldSeparator, Q = he.setOpOnChangeField, me = he.showErrorMessage;
      Array.isArray(ie) && (ie = ie.join(be));
      var ne = Y.getIn((0, a.expandTreePath)(re, "type")), pe = Y.getIn((0, a.expandTreePath)(re, "properties")), ge = ne == "rule_group", ve = (0, u.getFieldConfig)(_e, ie), Te = ve.type == "!group", Re = Te && ve.mode == "array", Me = ge != Te, et = pe.get("operator"), st = pe.get("operatorOptions");
      pe.get("field"), pe.get("value"), pe.get("valueSrc", new i.default.List()), pe.get("valueType", new i.default.List());
      var De = ve && ve.operators.indexOf(et) !== -1 ? et : null, ze = null, Pe = (0, d.getOperatorsForField)(_e, ie);
      if (Pe && Pe.length == 1)
        ze = Pe[0];
      else if (Pe && Pe.length > 1) {
        var je = v(Q || []), He;
        try {
          for (je.s(); !(He = je.n()).done; ) {
            var Xe = He.value;
            if (Xe == "keep" && !Me ? ze = De : Xe == "default" ? ze = (0, s.defaultOperator)(_e, ie, !1) : Xe == "first" && (ze = (0, d.getFirstOperator)(_e, ie)), ze)
              break;
          }
        } catch (wn) {
          je.e(wn);
        } finally {
          je.f();
        }
      }
      if (!Te && !ve.operators)
        return console.warn("Type ".concat(ve.type, " is not supported")), Y;
      if (ge && !Te && (Y = Y.setIn((0, a.expandTreePath)(re, "type"), "rule"), Y = Y.deleteIn((0, a.expandTreePath)(re, "children1")), Y = Y.setIn((0, a.expandTreePath)(re, "properties"), new i.default.OrderedMap())), Te) {
        Y = Y.setIn((0, a.expandTreePath)(re, "type"), "rule_group");
        var at = (0, d.getNewValueForFieldOp)(_e, _e, pe, ie, ze, "field", !0);
        at.canReuseValue;
        var wt = at.newValue, Je = at.newValueSrc, vt = at.newValueType, Ot = at.operatorCardinality, Ft = (0, s.defaultGroupProperties)(_e, ve).merge({
          field: ie,
          mode: ve.mode
        });
        return Re && (Ft = Ft.merge({
          operator: ze,
          value: wt,
          valueSrc: Je,
          valueType: vt
        })), Y = Y.setIn((0, a.expandTreePath)(re, "children1"), new i.default.OrderedMap()), Y = Y.setIn((0, a.expandTreePath)(re, "properties"), Ft), ve.initialEmptyWhere && Ot == 1 || (Y = S(Y, re, "rule", (0, l.default)(), (0, s.defaultRuleProperties)(_e, ie), _e)), Y = (0, a.fixPathsInTree)(Y), Y;
      }
      return Y.updateIn((0, a.expandTreePath)(re, "properties"), function(wn) {
        return wn.withMutations(function(un) {
          var pn = (0, d.getNewValueForFieldOp)(_e, _e, un, ie, ze, "field", !0), Dn = pn.canReuseValue, Rn = pn.newValue, Ln = pn.newValueSrc, Yn = pn.newValueType, Qt = pn.newValueError;
          me && (un = un.set("valueError", Qt));
          var fn = Dn ? st : (0, s.defaultOperatorOptions)(_e, ze, ie);
          return un.set("field", ie).set("operator", ze).set("operatorOptions", fn).set("value", Rn).set("valueSrc", Ln).set("valueType", Yn).delete("asyncListValues");
        });
      });
    }, I = function(Y, re, ie, _e) {
      var he = _e.settings.showErrorMessage, be = Y.getIn((0, a.expandTreePath)(re, "properties")), Q = Y.getIn((0, a.expandTreePath)(re, "children1")), me = be.get("field"), ne = (0, u.getFieldConfig)(_e, me), pe = ne.type == "!group", ge = (0, u.getOperatorConfig)(_e, ie, me), ve = ge ? (0, _.defaultValue)(ge.cardinality, 1) : null;
      return Y = Y.updateIn((0, a.expandTreePath)(re, "properties"), function(Te) {
        return Te.withMutations(function(Re) {
          var Me = Re.get("field"), et = Re.get("operatorOptions");
          Re.get("value", new i.default.List()), Re.get("valueSrc", new i.default.List()), Re.get("operator");
          var st = (0, d.getNewValueForFieldOp)(_e, _e, Re, Me, ie, "operator", !0), De = st.canReuseValue, ze = st.newValue, Pe = st.newValueSrc, je = st.newValueType, He = st.newValueError;
          he && (Re = Re.set("valueError", He));
          var Xe = De ? et : (0, s.defaultOperatorOptions)(_e, ie, Me);
          return De || (Re = Re.delete("asyncListValues")), Re.set("operator", ie).set("operatorOptions", Xe).set("value", ze).set("valueSrc", Pe).set("valueType", je);
        });
      }), pe && ve == 0 && Q.size == 0 && (Y = S(Y, re, "rule", (0, l.default)(), (0, s.defaultRuleProperties)(_e, me), _e)), Y;
    }, z = function(Y, re, ie, _e, he, be, Q, me) {
      var ne = be.settings, pe = ne.fieldSeparator, ge = ne.showErrorMessage, ve, Te = Y.getIn((0, a.expandTreePath)(re, "properties", "valueSrc", ie + "")) || null;
      Te === "field" && Array.isArray(_e) && (_e = _e.join(pe));
      var Re = Y.getIn((0, a.expandTreePath)(re, "properties", "field")) || null, Me = Y.getIn((0, a.expandTreePath)(re, "properties", "operator")) || null, et = (0, u.getOperatorConfig)(be, Me, Re), st = Me ? (0, _.defaultValue)(et.cardinality, 1) : null, De = !1, ze = !1, Pe = he || V(_e, Te, be), je = (0, p.validateValue)(be, Re, Re, Me, _e, Pe, Te, Q, ze, De), He = (0, o.default)(je, 2), Xe = He[0], at = He[1], wt = !Xe;
      if (wt && at !== _e && (_e = at), ge) {
        var Je = (0, d.getWidgetForFieldOp)(be, Re, Me, Te), vt = (0, u.getFieldWidgetConfig)(be, Re, Me, Je, Te), Ot = Array.from({
          length: st
        }, function(Qt, fn) {
          return Y.getIn((0, a.expandTreePath)(re, "properties", "valueSrc", fn + "")) || null;
        });
        if (et && et.validateValues && Ot.filter(function(Qt) {
          return Qt == "value" || Qt == null;
        }).length == st) {
          var Ft = Array.from({
            length: st
          }, function(Qt, fn) {
            return fn == ie ? _e : Y.getIn((0, a.expandTreePath)(re, "properties", "value", fn + "")) || null;
          }), wn = vt && vt.toJS ? Ft.map(function(Qt) {
            return vt.toJS(Qt, vt);
          }) : Ft, un = et.validateValues(wn);
          Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueError", st), un);
        }
      }
      var pn = Y.getIn((0, a.expandTreePath)(re, "properties", "value"));
      pn || (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "value"), new i.default.List(new Array(st))).setIn((0, a.expandTreePath)(re, "properties", "valueType"), new i.default.List(new Array(st))).setIn((0, a.expandTreePath)(re, "properties", "valueError"), new i.default.List(new Array(st))));
      var Dn = Y.getIn((0, a.expandTreePath)(re, "properties", "value", ie + "")), Rn = Y.getIn((0, a.expandTreePath)(re, "properties", "valueError", ie)), Ln = Dn == null, Yn = !!Rn;
      return (wt || ge) && (Y = Y.deleteIn((0, a.expandTreePath)(re, "properties", "asyncListValues")), typeof _e > "u" ? (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "value", ie + ""), void 0), Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueType", ie + ""), null)) : (Q && (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "asyncListValues"), Q)), Y = Y.setIn((0, a.expandTreePath)(re, "properties", "value", ie + ""), _e), Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueType", ie + ""), Pe), ve = me && !Ln && !Yn)), ge && (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueError", ie), Xe)), me && (wt && Yn || !wt && !Yn) && (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueError", ie), Xe), ve = !1), {
        tree: Y,
        isInternalValueChange: ve
      };
    }, F = function(Y, re, ie, _e, he) {
      var be = he.settings.showErrorMessage, Q = Y.getIn((0, a.expandTreePath)(re, "properties", "field")) || null, me = Y.getIn((0, a.expandTreePath)(re, "properties", "operator")) || null;
      if (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "value", ie + ""), void 0), Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueType", ie + ""), null), Y = Y.deleteIn((0, a.expandTreePath)(re, "properties", "asyncListValues")), be) {
        Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueError", ie), null);
        var ne = (0, u.getOperatorConfig)(he, me, Q), pe = me ? (0, _.defaultValue)(ne.cardinality, 1) : null;
        ne.validateValues && (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueError", pe), null));
      }
      if (typeof _e > "u" ? Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueSrc", ie + ""), null) : Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueSrc", ie + ""), _e), _e) {
        var ge = Y.getIn((0, a.expandTreePath)(re, "properties")), ve = (0, d.getNewValueForFieldOp)(he, he, ge, Q, me, "valueSrc", !0), Te = ve.canReuseValue, Re = ve.newValue, Me = ve.newValueSrc, et = ve.newValueType;
        ve.newValueError, !Te && Me.get(ie) == _e && (Y = Y.setIn((0, a.expandTreePath)(re, "properties", "value", ie + ""), Re.get(ie)), Y = Y.setIn((0, a.expandTreePath)(re, "properties", "valueType", ie + ""), et.get(ie)));
      }
      return Y;
    }, P = function(Y, re, ie, _e) {
      return Y.setIn((0, a.expandTreePath)(re, "properties", "operatorOptions", ie), _e);
    }, O = function(Y, re) {
      var ie = re.settings.canLeaveEmptyGroup;
      return ie || (Y = (0, a.fixEmptyGroupsInTree)(Y)), Y;
    }, V = function(Y, re, ie) {
      var _e = null;
      if (Y) {
        if (re === "field") {
          var he = (0, u.getFieldConfig)(ie, Y);
          he && (_e = he.type);
        } else if (re === "func") {
          var be = Y.get("func");
          if (be) {
            var Q = (0, u.getFuncConfig)(ie, be);
            Q && (_e = Q.returnType);
          }
        }
      }
      return _e;
    }, U = function(Y, re) {
      var ie = Y.getIn((0, a.expandTreePath)(re, "properties", "field")) || null;
      return ie;
    }, H = {
      dragging: {
        id: null,
        x: null,
        y: null,
        w: null,
        h: null
      },
      mousePos: {},
      dragStart: {
        id: null
      }
    }, J = function(Y, re) {
      var ie = ["config", "asyncListValues", "__isInternal"], _e = [c.SET_TREE, c.SET_DRAG_START, c.SET_DRAG_PROGRESS, c.SET_DRAG_END], he = (0, f.default)((0, g.default)(Y, ie), _.applyToJS), be = Y.path && U(re.tree, Y.path) || Y.field;
      return be && (he.affectedField = be), (_e.includes(Y.type) || Y.type.indexOf("@@redux") == 0) && (he = null), he;
    }, le = function(Y) {
      var re = (0, s.defaultRoot)(Y), ie = Object.assign({}, {
        tree: re
      }, H);
      return function() {
        var _e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ie, he = arguments.length > 1 ? arguments[1] : void 0, be = {
          __isInternalValueChange: void 0,
          __lastAction: void 0
        }, Q = {}, me = J(he, _e);
        switch (he.type) {
          case c.SET_TREE: {
            Q.tree = he.tree;
            break;
          }
          case c.ADD_CASE_GROUP: {
            Q.tree = M(_e.tree, he.path, "case_group", he.id, he.properties, he.config, he.children, he.meta);
            break;
          }
          case c.ADD_GROUP: {
            Q.tree = M(_e.tree, he.path, "group", he.id, he.properties, he.config, he.children, he.meta);
            break;
          }
          case c.REMOVE_GROUP: {
            Q.tree = q(_e.tree, he.path, he.config);
            break;
          }
          case c.ADD_RULE: {
            Q.tree = S(_e.tree, he.path, he.ruleType, he.id, he.properties, he.config, he.children);
            break;
          }
          case c.REMOVE_RULE: {
            Q.tree = L(_e.tree, he.path, he.config);
            break;
          }
          case c.SET_CONJUNCTION: {
            Q.tree = D(_e.tree, he.path, he.conjunction);
            break;
          }
          case c.SET_NOT: {
            Q.tree = R(_e.tree, he.path, he.not);
            break;
          }
          case c.SET_FIELD: {
            Q.tree = k(_e.tree, he.path, he.field, he.config);
            break;
          }
          case c.SET_LOCK: {
            Q.tree = T(_e.tree, he.path, he.lock);
            break;
          }
          case c.SET_OPERATOR: {
            Q.tree = I(_e.tree, he.path, he.operator, he.config);
            break;
          }
          case c.SET_VALUE: {
            var ne = z(_e.tree, he.path, he.delta, he.value, he.valueType, he.config, he.asyncListValues, he.__isInternal), pe = ne.tree, ge = ne.isInternalValueChange;
            Q.__isInternalValueChange = ge, Q.tree = pe;
            break;
          }
          case c.SET_VALUE_SRC: {
            Q.tree = F(_e.tree, he.path, he.delta, he.srcKey, he.config);
            break;
          }
          case c.SET_OPERATOR_OPTION: {
            Q.tree = P(_e.tree, he.path, he.name, he.value);
            break;
          }
          case c.MOVE_ITEM: {
            Q.tree = x(_e.tree, he.fromPath, he.toPath, he.placement, he.config);
            break;
          }
          case c.SET_DRAG_START: {
            Q.dragStart = he.dragStart, Q.dragging = he.dragging, Q.mousePos = he.mousePos;
            break;
          }
          case c.SET_DRAG_PROGRESS: {
            Q.mousePos = he.mousePos, Q.dragging = he.dragging;
            break;
          }
          case c.SET_DRAG_END: {
            Q.tree = O(_e.tree, Y), Q = N(N({}, Q), H);
            break;
          }
        }
        return me && (Q.__lastAction = me), N(N(N({}, _e), be), Q);
      };
    };
    e.default = le;
  }(bP)), bP;
}
var nL = {}, kne;
function T2() {
  return kne || (kne = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Fe), o = /* @__PURE__ */ n.default.createContext();
    e.default = o;
  }(nL)), nL;
}
function oc(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Sne = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), oL = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Tg = {
  INIT: "@@redux/INIT" + oL(),
  REPLACE: "@@redux/REPLACE" + oL(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + oL();
  }
};
function u$e(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function tou(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (rou(e))
    return "date";
  if (oou(e))
    return "error";
  var n = nou(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function nou(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function oou(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function rou(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function tg(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = tou(e)), t;
}
function LV(e, t, n) {
  var o;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? oc(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oc(1) : "Expected the enhancer to be a function. Instead, received: '" + tg(n) + "'");
    return n(LV)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? oc(2) : "Expected the root reducer to be a function. Instead, received: '" + tg(e) + "'");
  var r = e, i = t, a = [], s = a, c = !1;
  function l() {
    s === a && (s = a.slice());
  }
  function u() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oc(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function d(f) {
    if (typeof f != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oc(4) : "Expected the listener to be a function. Instead, received: '" + tg(f) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oc(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var h = !0;
    return l(), s.push(f), function() {
      if (h) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? oc(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        h = !1, l();
        var v = s.indexOf(f);
        s.splice(v, 1), a = null;
      }
    };
  }
  function _(f) {
    if (!u$e(f))
      throw new Error(process.env.NODE_ENV === "production" ? oc(7) : "Actions must be plain objects. Instead, the actual type was: '" + tg(f) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof f.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oc(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oc(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, i = r(i, f);
    } finally {
      c = !1;
    }
    for (var h = a = s, $ = 0; $ < h.length; $++) {
      var v = h[$];
      v();
    }
    return f;
  }
  function p(f) {
    if (typeof f != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oc(10) : "Expected the nextReducer to be a function. Instead, received: '" + tg(f));
    r = f, _({
      type: Tg.REPLACE
    });
  }
  function g() {
    var f, h = d;
    return f = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(v) {
        if (typeof v != "object" || v === null)
          throw new Error(process.env.NODE_ENV === "production" ? oc(11) : "Expected the observer to be an object. Instead, received: '" + tg(v) + "'");
        function b() {
          v.next && v.next(u());
        }
        b();
        var y = h(b);
        return {
          unsubscribe: y
        };
      }
    }, f[Sne] = function() {
      return this;
    }, f;
  }
  return _({
    type: Tg.INIT
  }), o = {
    dispatch: _,
    subscribe: d,
    getState: u,
    replaceReducer: p
  }, o[Sne] = g, o;
}
var iou = LV;
function m6(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function aou(e, t, n, o) {
  var r = Object.keys(t), i = n && n.type === Tg.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (r.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!u$e(e))
    return "The " + i + ' has unexpected type of "' + tg(e) + '". Expected argument to be an object with the following ' + ('keys: "' + r.join('", "') + '"');
  var a = Object.keys(e).filter(function(s) {
    return !t.hasOwnProperty(s) && !o[s];
  });
  if (a.forEach(function(s) {
    o[s] = !0;
  }), !(n && n.type === Tg.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + i + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + r.join('", "') + '". Unexpected keys will be ignored.');
}
function sou(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], o = n(void 0, {
      type: Tg.INIT
    });
    if (typeof o > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oc(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: Tg.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oc(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + Tg.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function cou(e) {
  for (var t = Object.keys(e), n = {}, o = 0; o < t.length; o++) {
    var r = t[o];
    process.env.NODE_ENV !== "production" && typeof e[r] > "u" && m6('No reducer provided for key "' + r + '"'), typeof e[r] == "function" && (n[r] = e[r]);
  }
  var i = Object.keys(n), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var s;
  try {
    sou(n);
  } catch (c) {
    s = c;
  }
  return function(l, u) {
    if (l === void 0 && (l = {}), s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      var d = aou(l, n, u, a);
      d && m6(d);
    }
    for (var _ = !1, p = {}, g = 0; g < i.length; g++) {
      var f = i[g], h = n[f], $ = l[f], v = h($, u);
      if (typeof v > "u") {
        var b = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? oc(14) : "When called with an action of type " + (b ? '"' + String(b) + '"' : "(unknown type)") + ', the slice reducer for key "' + f + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      p[f] = v, _ = _ || v !== $;
    }
    return _ = _ || i.length !== Object.keys(l).length, _ ? p : l;
  };
}
function Ene(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function lou(e, t) {
  if (typeof e == "function")
    return Ene(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? oc(16) : "bindActionCreators expected an object or a function, but instead received: '" + tg(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var n = {};
  for (var o in e) {
    var r = e[o];
    typeof r == "function" && (n[o] = Ene(r, t));
  }
  return n;
}
function d$e() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(o) {
    return o;
  } : t.length === 1 ? t[0] : t.reduce(function(o, r) {
    return function() {
      return o(r.apply(void 0, arguments));
    };
  });
}
function uou() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    return function() {
      var r = o.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? oc(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, a = {
        getState: r.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(a);
      });
      return i = d$e.apply(void 0, s)(r.dispatch), Fo(Fo({}, r), {}, {
        dispatch: i
      });
    };
  };
}
function xne() {
}
process.env.NODE_ENV !== "production" && typeof xne.name == "string" && xne.name !== "isCrushed" && m6('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');
const dou = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __DO_NOT_USE__ActionTypes: Tg,
  applyMiddleware: uou,
  bindActionCreators: lou,
  combineReducers: cou,
  compose: d$e,
  createStore: LV,
  legacy_createStore: iou
}, Symbol.toStringTag, { value: "Module" })), _ou = /* @__PURE__ */ nu(dou);
var G_ = /* @__PURE__ */ Fe.createContext(null);
process.env.NODE_ENV !== "production" && (G_.displayName = "ReactRedux");
function pou(e) {
  e();
}
var _$e = pou, mou = function(t) {
  return _$e = t;
}, fou = function() {
  return _$e;
};
function gou() {
  var e = fou(), t = null, n = null;
  return {
    clear: function() {
      t = null, n = null;
    },
    notify: function() {
      e(function() {
        for (var r = t; r; )
          r.callback(), r = r.next;
      });
    },
    get: function() {
      for (var r = [], i = t; i; )
        r.push(i), i = i.next;
      return r;
    },
    subscribe: function(r) {
      var i = !0, a = n = {
        callback: r,
        next: null,
        prev: n
      };
      return a.prev ? a.prev.next = a : t = a, function() {
        !i || t === null || (i = !1, a.next ? a.next.prev = a.prev : n = a.prev, a.prev ? a.prev.next = a.next : t = a.next);
      };
    }
  };
}
var Cne = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function MV(e, t) {
  var n, o = Cne;
  function r(d) {
    return c(), o.subscribe(d);
  }
  function i() {
    o.notify();
  }
  function a() {
    u.onStateChange && u.onStateChange();
  }
  function s() {
    return !!n;
  }
  function c() {
    n || (n = t ? t.addNestedSub(a) : e.subscribe(a), o = gou());
  }
  function l() {
    n && (n(), n = void 0, o.clear(), o = Cne);
  }
  var u = {
    addNestedSub: r,
    notifyNestedSubs: i,
    handleChangeWrapper: a,
    isSubscribed: s,
    trySubscribe: c,
    tryUnsubscribe: l,
    getListeners: function() {
      return o;
    }
  };
  return u;
}
var mT = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? lc : yt;
function p$e(e) {
  var t = e.store, n = e.context, o = e.children, r = vn(function() {
    var s = MV(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), i = vn(function() {
    return t.getState();
  }, [t]);
  mT(function() {
    var s = r.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), i !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [r, i]);
  var a = n || G_;
  return /* @__PURE__ */ Fe.createElement(a.Provider, {
    value: r
  }, o);
}
process.env.NODE_ENV !== "production" && (p$e.propTypes = {
  store: vb.shape({
    subscribe: vb.func.isRequired,
    dispatch: vb.func.isRequired,
    getState: vb.func.isRequired
  }),
  context: vb.object,
  children: vb.any
});
var f6 = { exports: {} }, zi = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tne;
function hou() {
  return Tne || (Tne = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, o = 60108, r = 60114, i = 60109, a = 60110, s = 60112, c = 60113, l = 60120, u = 60115, d = 60116, _ = 60121, p = 60122, g = 60117, f = 60129, h = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var $ = Symbol.for;
      e = $("react.element"), t = $("react.portal"), n = $("react.fragment"), o = $("react.strict_mode"), r = $("react.profiler"), i = $("react.provider"), a = $("react.context"), s = $("react.forward_ref"), c = $("react.suspense"), l = $("react.suspense_list"), u = $("react.memo"), d = $("react.lazy"), _ = $("react.block"), p = $("react.server.block"), g = $("react.fundamental"), $("react.scope"), $("react.opaque.id"), f = $("react.debug_trace_mode"), $("react.offscreen"), h = $("react.legacy_hidden");
    }
    var v = !1;
    function b(ie) {
      return !!(typeof ie == "string" || typeof ie == "function" || ie === n || ie === r || ie === f || ie === o || ie === c || ie === l || ie === h || v || typeof ie == "object" && ie !== null && (ie.$$typeof === d || ie.$$typeof === u || ie.$$typeof === i || ie.$$typeof === a || ie.$$typeof === s || ie.$$typeof === g || ie.$$typeof === _ || ie[0] === p));
    }
    function y(ie) {
      if (typeof ie == "object" && ie !== null) {
        var _e = ie.$$typeof;
        switch (_e) {
          case e:
            var he = ie.type;
            switch (he) {
              case n:
              case r:
              case o:
              case c:
              case l:
                return he;
              default:
                var be = he && he.$$typeof;
                switch (be) {
                  case a:
                  case s:
                  case d:
                  case u:
                  case i:
                    return be;
                  default:
                    return _e;
                }
            }
          case t:
            return _e;
        }
      }
    }
    var w = a, N = i, M = e, q = s, L = n, R = d, T = u, D = t, A = r, S = o, E = c, x = !1, k = !1;
    function I(ie) {
      return x || (x = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(ie) {
      return k || (k = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(ie) {
      return y(ie) === a;
    }
    function P(ie) {
      return y(ie) === i;
    }
    function O(ie) {
      return typeof ie == "object" && ie !== null && ie.$$typeof === e;
    }
    function V(ie) {
      return y(ie) === s;
    }
    function U(ie) {
      return y(ie) === n;
    }
    function H(ie) {
      return y(ie) === d;
    }
    function J(ie) {
      return y(ie) === u;
    }
    function le(ie) {
      return y(ie) === t;
    }
    function ae(ie) {
      return y(ie) === r;
    }
    function Y(ie) {
      return y(ie) === o;
    }
    function re(ie) {
      return y(ie) === c;
    }
    zi.ContextConsumer = w, zi.ContextProvider = N, zi.Element = M, zi.ForwardRef = q, zi.Fragment = L, zi.Lazy = R, zi.Memo = T, zi.Portal = D, zi.Profiler = A, zi.StrictMode = S, zi.Suspense = E, zi.isAsyncMode = I, zi.isConcurrentMode = z, zi.isContextConsumer = F, zi.isContextProvider = P, zi.isElement = O, zi.isForwardRef = V, zi.isFragment = U, zi.isLazy = H, zi.isMemo = J, zi.isPortal = le, zi.isProfiler = ae, zi.isStrictMode = Y, zi.isSuspense = re, zi.isValidElementType = b, zi.typeOf = y;
  }()), zi;
}
var Ri = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ane;
function vou() {
  if (Ane)
    return Ri;
  Ane = 1;
  var e = 60103, t = 60106, n = 60107, o = 60108, r = 60114, i = 60109, a = 60110, s = 60112, c = 60113, l = 60120, u = 60115, d = 60116, _ = 60121, p = 60122, g = 60117, f = 60129, h = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var $ = Symbol.for;
    e = $("react.element"), t = $("react.portal"), n = $("react.fragment"), o = $("react.strict_mode"), r = $("react.profiler"), i = $("react.provider"), a = $("react.context"), s = $("react.forward_ref"), c = $("react.suspense"), l = $("react.suspense_list"), u = $("react.memo"), d = $("react.lazy"), _ = $("react.block"), p = $("react.server.block"), g = $("react.fundamental"), f = $("react.debug_trace_mode"), h = $("react.legacy_hidden");
  }
  function v(A) {
    if (typeof A == "object" && A !== null) {
      var S = A.$$typeof;
      switch (S) {
        case e:
          switch (A = A.type, A) {
            case n:
            case r:
            case o:
            case c:
            case l:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case a:
                case s:
                case d:
                case u:
                case i:
                  return A;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  var b = i, y = e, w = s, N = n, M = d, q = u, L = t, R = r, T = o, D = c;
  return Ri.ContextConsumer = a, Ri.ContextProvider = b, Ri.Element = y, Ri.ForwardRef = w, Ri.Fragment = N, Ri.Lazy = M, Ri.Memo = q, Ri.Portal = L, Ri.Profiler = R, Ri.StrictMode = T, Ri.Suspense = D, Ri.isAsyncMode = function() {
    return !1;
  }, Ri.isConcurrentMode = function() {
    return !1;
  }, Ri.isContextConsumer = function(A) {
    return v(A) === a;
  }, Ri.isContextProvider = function(A) {
    return v(A) === i;
  }, Ri.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === e;
  }, Ri.isForwardRef = function(A) {
    return v(A) === s;
  }, Ri.isFragment = function(A) {
    return v(A) === n;
  }, Ri.isLazy = function(A) {
    return v(A) === d;
  }, Ri.isMemo = function(A) {
    return v(A) === u;
  }, Ri.isPortal = function(A) {
    return v(A) === t;
  }, Ri.isProfiler = function(A) {
    return v(A) === r;
  }, Ri.isStrictMode = function(A) {
    return v(A) === o;
  }, Ri.isSuspense = function(A) {
    return v(A) === c;
  }, Ri.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === n || A === r || A === f || A === o || A === c || A === l || A === h || typeof A == "object" && A !== null && (A.$$typeof === d || A.$$typeof === u || A.$$typeof === i || A.$$typeof === a || A.$$typeof === s || A.$$typeof === g || A.$$typeof === _ || A[0] === p);
  }, Ri.typeOf = v, Ri;
}
process.env.NODE_ENV === "production" ? f6.exports = vou() : f6.exports = hou();
var Ine = f6.exports, bou = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], you = ["reactReduxForwardedRef"], $ou = [], wou = [null, null], kou = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function Sou(e, t) {
  var n = e[1];
  return [t.payload, n + 1];
}
function One(e, t, n) {
  mT(function() {
    return e.apply(void 0, t);
  }, n);
}
function Eou(e, t, n, o, r, i, a) {
  e.current = o, t.current = r, n.current = !1, i.current && (i.current = null, a());
}
function xou(e, t, n, o, r, i, a, s, c, l) {
  if (e) {
    var u = !1, d = null, _ = function() {
      if (!u) {
        var f = t.getState(), h, $;
        try {
          h = o(f, r.current);
        } catch (v) {
          $ = v, d = v;
        }
        $ || (d = null), h === i.current ? a.current || c() : (i.current = h, s.current = h, a.current = !0, l({
          type: "STORE_UPDATED",
          payload: {
            error: $
          }
        }));
      }
    };
    n.onStateChange = _, n.trySubscribe(), _();
    var p = function() {
      if (u = !0, n.tryUnsubscribe(), n.onStateChange = null, d)
        throw d;
    };
    return p;
  }
}
var Cou = function() {
  return [null, 0];
};
function m$e(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.getDisplayName, r = o === void 0 ? function(N) {
    return "ConnectAdvanced(" + N + ")";
  } : o, i = n.methodName, a = i === void 0 ? "connectAdvanced" : i, s = n.renderCountProp, c = s === void 0 ? void 0 : s, l = n.shouldHandleStateChanges, u = l === void 0 ? !0 : l, d = n.storeKey, _ = d === void 0 ? "store" : d, p = n.withRef, g = p === void 0 ? !1 : p, f = n.forwardRef, h = f === void 0 ? !1 : f, $ = n.context, v = $ === void 0 ? G_ : $, b = gk(n, bou);
  if (process.env.NODE_ENV !== "production") {
    if (c !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (g)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var y = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (_ !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + y);
  }
  var w = v;
  return function(M) {
    if (process.env.NODE_ENV !== "production" && !Ine.isValidElementType(M))
      throw new Error("You must pass a component to the function returned by " + (a + ". Instead received " + kou(M)));
    var q = M.displayName || M.name || "Component", L = r(q), R = Tt({}, b, {
      getDisplayName: r,
      methodName: a,
      renderCountProp: c,
      shouldHandleStateChanges: u,
      storeKey: _,
      displayName: L,
      wrappedComponentName: q,
      WrappedComponent: M
    }), T = b.pure;
    function D(k) {
      return e(k.dispatch, R);
    }
    var A = T ? vn : function(k) {
      return k();
    };
    function S(k) {
      var I = vn(function() {
        var Me = k.reactReduxForwardedRef, et = gk(k, you);
        return [k.context, Me, et];
      }, [k]), z = I[0], F = I[1], P = I[2], O = vn(function() {
        return z && z.Consumer && Ine.isContextConsumer(/* @__PURE__ */ Fe.createElement(z.Consumer, null)) ? z : w;
      }, [z, w]), V = bo(O), U = !!k.store && !!k.store.getState && !!k.store.dispatch, H = !!V && !!V.store;
      if (process.env.NODE_ENV !== "production" && !U && !H)
        throw new Error('Could not find "store" in the context of ' + ('"' + L + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + L + " in connect options."));
      var J = U ? k.store : V.store, le = vn(function() {
        return D(J);
      }, [J]), ae = vn(function() {
        if (!u)
          return wou;
        var Me = MV(J, U ? null : V.subscription), et = Me.notifyNestedSubs.bind(Me);
        return [Me, et];
      }, [J, U, V]), Y = ae[0], re = ae[1], ie = vn(function() {
        return U ? V : Tt({}, V, {
          subscription: Y
        });
      }, [U, V, Y]), _e = A0(Sou, $ou, Cou), he = _e[0], be = he[0], Q = _e[1];
      if (be && be.error)
        throw be.error;
      var me = xt(), ne = xt(P), pe = xt(), ge = xt(!1), ve = A(function() {
        return pe.current && P === ne.current ? pe.current : le(J.getState(), P);
      }, [J, be, P]);
      One(Eou, [ne, me, ge, P, ve, pe, re]), One(xou, [u, J, Y, le, ne, me, ge, pe, re, Q], [J, Y, le]);
      var Te = vn(function() {
        return /* @__PURE__ */ Fe.createElement(M, Tt({}, ve, {
          ref: F
        }));
      }, [F, M, ve]), Re = vn(function() {
        return u ? /* @__PURE__ */ Fe.createElement(O.Provider, {
          value: ie
        }, Te) : Te;
      }, [O, Te, ie]);
      return Re;
    }
    var E = T ? Fe.memo(S) : S;
    if (E.WrappedComponent = M, E.displayName = S.displayName = L, h) {
      var x = Fe.forwardRef(function(I, z) {
        return /* @__PURE__ */ Fe.createElement(E, Tt({}, I, {
          reactReduxForwardedRef: z
        }));
      });
      return x.displayName = L, x.WrappedComponent = M, f7(x, M);
    }
    return f7(E, M);
  };
}
function Nne(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function bx(e, t) {
  if (Nne(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), o = Object.keys(t);
  if (n.length !== o.length)
    return !1;
  for (var r = 0; r < n.length; r++)
    if (!Object.prototype.hasOwnProperty.call(t, n[r]) || !Nne(e[n[r]], t[n[r]]))
      return !1;
  return !0;
}
function Tou(e, t) {
  var n = {}, o = function(a) {
    var s = e[a];
    typeof s == "function" && (n[a] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var r in e)
    o(r);
  return n;
}
function Aou(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function f$e(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function g$e(e, t, n) {
  Aou(e) || f$e(n + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function FV(e) {
  return function(n, o) {
    var r = e(n, o);
    function i() {
      return r;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function zne(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function h$e(e, t) {
  return function(o, r) {
    var i = r.displayName, a = function(c, l) {
      return a.dependsOnOwnProps ? a.mapToProps(c, l) : a.mapToProps(c);
    };
    return a.dependsOnOwnProps = !0, a.mapToProps = function(c, l) {
      a.mapToProps = e, a.dependsOnOwnProps = zne(e);
      var u = a(c, l);
      return typeof u == "function" && (a.mapToProps = u, a.dependsOnOwnProps = zne(u), u = a(c, l)), process.env.NODE_ENV !== "production" && g$e(u, i, t), u;
    }, a;
  };
}
function Iou(e) {
  return typeof e == "function" ? h$e(e, "mapDispatchToProps") : void 0;
}
function Oou(e) {
  return e ? void 0 : FV(function(t) {
    return {
      dispatch: t
    };
  });
}
function Nou(e) {
  return e && typeof e == "object" ? FV(function(t) {
    return Tou(e, t);
  }) : void 0;
}
const zou = [Iou, Oou, Nou];
function Rou(e) {
  return typeof e == "function" ? h$e(e, "mapStateToProps") : void 0;
}
function Pou(e) {
  return e ? void 0 : FV(function() {
    return {};
  });
}
const Dou = [Rou, Pou];
function Lou(e, t, n) {
  return Tt({}, n, e, t);
}
function Mou(e) {
  return function(n, o) {
    var r = o.displayName, i = o.pure, a = o.areMergedPropsEqual, s = !1, c;
    return function(u, d, _) {
      var p = e(u, d, _);
      return s ? (!i || !a(p, c)) && (c = p) : (s = !0, c = p, process.env.NODE_ENV !== "production" && g$e(c, r, "mergeProps")), c;
    };
  };
}
function Fou(e) {
  return typeof e == "function" ? Mou(e) : void 0;
}
function qou(e) {
  return e ? void 0 : function() {
    return Lou;
  };
}
const jou = [Fou, qou];
function rL(e, t, n) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || f$e("The selector for " + t + " of " + n + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + n + ".");
}
function Vou(e, t, n, o) {
  rL(e, "mapStateToProps", o), rL(t, "mapDispatchToProps", o), rL(n, "mergeProps", o);
}
var Bou = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function Uou(e, t, n, o) {
  return function(i, a) {
    return n(e(i, a), t(o, a), a);
  };
}
function Gou(e, t, n, o, r) {
  var i = r.areStatesEqual, a = r.areOwnPropsEqual, s = r.areStatePropsEqual, c = !1, l, u, d, _, p;
  function g(b, y) {
    return l = b, u = y, d = e(l, u), _ = t(o, u), p = n(d, _, u), c = !0, p;
  }
  function f() {
    return d = e(l, u), t.dependsOnOwnProps && (_ = t(o, u)), p = n(d, _, u), p;
  }
  function h() {
    return e.dependsOnOwnProps && (d = e(l, u)), t.dependsOnOwnProps && (_ = t(o, u)), p = n(d, _, u), p;
  }
  function $() {
    var b = e(l, u), y = !s(b, d);
    return d = b, y && (p = n(d, _, u)), p;
  }
  function v(b, y) {
    var w = !a(y, u), N = !i(b, l);
    return l = b, u = y, w && N ? f() : w ? h() : N ? $() : p;
  }
  return function(y, w) {
    return c ? v(y, w) : g(y, w);
  };
}
function Wou(e, t) {
  var n = t.initMapStateToProps, o = t.initMapDispatchToProps, r = t.initMergeProps, i = gk(t, Bou), a = n(e, i), s = o(e, i), c = r(e, i);
  process.env.NODE_ENV !== "production" && Vou(a, s, c, i.displayName);
  var l = i.pure ? Gou : Uou;
  return l(a, s, c, e, i);
}
var Hou = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function iL(e, t, n) {
  for (var o = t.length - 1; o >= 0; o--) {
    var r = t[o](e);
    if (r)
      return r;
  }
  return function(i, a) {
    throw new Error("Invalid value of type " + typeof e + " for " + n + " argument when connecting component " + a.wrappedComponentName + ".");
  };
}
function You(e, t) {
  return e === t;
}
function Kou(e) {
  var t = e === void 0 ? {} : e, n = t.connectHOC, o = n === void 0 ? m$e : n, r = t.mapStateToPropsFactories, i = r === void 0 ? Dou : r, a = t.mapDispatchToPropsFactories, s = a === void 0 ? zou : a, c = t.mergePropsFactories, l = c === void 0 ? jou : c, u = t.selectorFactory, d = u === void 0 ? Wou : u;
  return function(p, g, f, h) {
    h === void 0 && (h = {});
    var $ = h, v = $.pure, b = v === void 0 ? !0 : v, y = $.areStatesEqual, w = y === void 0 ? You : y, N = $.areOwnPropsEqual, M = N === void 0 ? bx : N, q = $.areStatePropsEqual, L = q === void 0 ? bx : q, R = $.areMergedPropsEqual, T = R === void 0 ? bx : R, D = gk($, Hou), A = iL(p, i, "mapStateToProps"), S = iL(g, s, "mapDispatchToProps"), E = iL(f, l, "mergeProps");
    return o(d, Tt({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(k) {
        return "Connect(" + k + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!p,
      // passed through to selectorFactory
      initMapStateToProps: A,
      initMapDispatchToProps: S,
      initMergeProps: E,
      pure: b,
      areStatesEqual: w,
      areOwnPropsEqual: M,
      areStatePropsEqual: L,
      areMergedPropsEqual: T
    }, D));
  };
}
const Zou = /* @__PURE__ */ Kou();
function v$e() {
  var e = bo(G_);
  if (process.env.NODE_ENV !== "production" && !e)
    throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
  return e;
}
function qV(e) {
  e === void 0 && (e = G_);
  var t = e === G_ ? v$e : function() {
    return bo(e);
  };
  return function() {
    var o = t(), r = o.store;
    return r;
  };
}
var b$e = /* @__PURE__ */ qV();
function y$e(e) {
  e === void 0 && (e = G_);
  var t = e === G_ ? b$e : qV(e);
  return function() {
    var o = t();
    return o.dispatch;
  };
}
var Xou = /* @__PURE__ */ y$e(), Jou = function(t, n) {
  return t === n;
};
function Qou(e, t, n, o) {
  var r = A0(function(g) {
    return g + 1;
  }, 0), i = r[1], a = vn(function() {
    return MV(n, o);
  }, [n, o]), s = xt(), c = xt(), l = xt(), u = xt(), d = n.getState(), _;
  try {
    if (e !== c.current || d !== l.current || s.current) {
      var p = e(d);
      u.current === void 0 || !t(p, u.current) ? _ = p : _ = u.current;
    } else
      _ = u.current;
  } catch (g) {
    throw s.current && (g.message += `
The error may be correlated with this previous error:
` + s.current.stack + `

`), g;
  }
  return mT(function() {
    c.current = e, l.current = d, u.current = _, s.current = void 0;
  }), mT(function() {
    function g() {
      try {
        var f = n.getState();
        if (f === l.current)
          return;
        var h = c.current(f);
        if (t(h, u.current))
          return;
        u.current = h, l.current = f;
      } catch ($) {
        s.current = $;
      }
      i();
    }
    return a.onStateChange = g, a.trySubscribe(), g(), function() {
      return a.tryUnsubscribe();
    };
  }, [n, a]), _;
}
function $$e(e) {
  e === void 0 && (e = G_);
  var t = e === G_ ? v$e : function() {
    return bo(e);
  };
  return function(o, r) {
    if (r === void 0 && (r = Jou), process.env.NODE_ENV !== "production") {
      if (!o)
        throw new Error("You must pass a selector to useSelector");
      if (typeof o != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    var i = t(), a = i.store, s = i.subscription, c = Qou(o, r, a, s);
    return TSe(c), c;
  };
}
var eru = /* @__PURE__ */ $$e();
mou(bre);
const tru = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Provider: p$e,
  ReactReduxContext: G_,
  batch: bre,
  connect: Zou,
  connectAdvanced: m$e,
  createDispatchHook: y$e,
  createSelectorHook: $$e,
  createStoreHook: qV,
  shallowEqual: bx,
  useDispatch: Xou,
  useSelector: eru,
  useStore: b$e
}, Symbol.toStringTag, { value: "Module" })), A2 = /* @__PURE__ */ nu(tru);
var $_ = {}, bs = {}, Rne;
function nru() {
  if (Rne)
    return bs;
  Rne = 1;
  var e = Tn, t = xo;
  Object.defineProperty(bs, "__esModule", {
    value: !0
  }), bs.setTree = bs.removeRule = bs.removeGroup = bs.moveItem = bs.addRule = bs.addGroup = bs.addDefaultCaseGroup = bs.addCaseGroup = void 0;
  var n = e(Ug()), o = Ti(), r = kl(), i = s(b$());
  e(uc());
  function a(h) {
    if (typeof WeakMap != "function")
      return null;
    var $ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (a = function(y) {
      return y ? v : $;
    })(h);
  }
  function s(h, $) {
    if (!$ && h && h.__esModule)
      return h;
    if (h === null || t(h) !== "object" && typeof h != "function")
      return { default: h };
    var v = a($);
    if (v && v.has(h))
      return v.get(h);
    var b = {}, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in h)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(h, w)) {
        var N = y ? Object.getOwnPropertyDescriptor(h, w) : null;
        N && (N.get || N.set) ? Object.defineProperty(b, w, N) : b[w] = h[w];
      }
    return b.default = h, v && v.set(h, b), b;
  }
  var c = function($, v) {
    return {
      type: i.SET_TREE,
      tree: v
    };
  };
  bs.setTree = c;
  var l = function($, v, b) {
    var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "rule", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    return {
      type: i.ADD_RULE,
      ruleType: y,
      children: w,
      path: (0, o.toImmutableList)(v),
      id: (0, n.default)(),
      properties: (0, r.defaultRuleProperties)($).merge(b || {}),
      config: $
    };
  };
  bs.addRule = l;
  var u = function($, v) {
    return {
      type: i.REMOVE_RULE,
      path: (0, o.toImmutableList)(v),
      config: $
    };
  };
  bs.removeRule = u;
  var d = function($, v, b) {
    var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      type: i.ADD_CASE_GROUP,
      path: (0, o.toImmutableList)(v),
      children: y,
      id: (0, n.default)(),
      properties: (0, r.defaultGroupProperties)($).merge(b || {}),
      config: $,
      meta: {
        isDefaultCase: !0
      }
    };
  };
  bs.addDefaultCaseGroup = d;
  var _ = function($, v, b) {
    var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      type: i.ADD_CASE_GROUP,
      path: (0, o.toImmutableList)(v),
      children: y,
      id: (0, n.default)(),
      properties: (0, r.defaultGroupProperties)($).merge(b || {}),
      config: $
    };
  };
  bs.addCaseGroup = _;
  var p = function($, v, b) {
    var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      type: i.ADD_GROUP,
      path: (0, o.toImmutableList)(v),
      children: y,
      id: (0, n.default)(),
      properties: (0, r.defaultGroupProperties)($).merge(b || {}),
      config: $
    };
  };
  bs.addGroup = p;
  var g = function($, v) {
    return {
      type: i.REMOVE_GROUP,
      path: (0, o.toImmutableList)(v),
      config: $
    };
  };
  bs.removeGroup = g;
  var f = function($, v, b, y) {
    return {
      type: i.MOVE_ITEM,
      fromPath: (0, o.toImmutableList)(v),
      toPath: (0, o.toImmutableList)(b),
      placement: y,
      config: $
    };
  };
  return bs.moveItem = f, bs;
}
var Wm = {}, Pne;
function oru() {
  if (Pne)
    return Wm;
  Pne = 1;
  var e = xo;
  Object.defineProperty(Wm, "__esModule", {
    value: !0
  }), Wm.setNot = Wm.setLock = Wm.setConjunction = void 0;
  var t = r(b$()), n = Ti();
  function o(c) {
    if (typeof WeakMap != "function")
      return null;
    var l = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap();
    return (o = function(_) {
      return _ ? u : l;
    })(c);
  }
  function r(c, l) {
    if (!l && c && c.__esModule)
      return c;
    if (c === null || e(c) !== "object" && typeof c != "function")
      return { default: c };
    var u = o(l);
    if (u && u.has(c))
      return u.get(c);
    var d = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in c)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(c, p)) {
        var g = _ ? Object.getOwnPropertyDescriptor(c, p) : null;
        g && (g.get || g.set) ? Object.defineProperty(d, p, g) : d[p] = c[p];
      }
    return d.default = c, u && u.set(c, d), d;
  }
  var i = function(l, u, d) {
    return {
      type: t.SET_CONJUNCTION,
      path: (0, n.toImmutableList)(u),
      conjunction: d
    };
  };
  Wm.setConjunction = i;
  var a = function(l, u, d) {
    return {
      type: t.SET_NOT,
      path: (0, n.toImmutableList)(u),
      not: d
    };
  };
  Wm.setNot = a;
  var s = function(l, u, d) {
    return {
      type: t.SET_LOCK,
      path: (0, n.toImmutableList)(u),
      lock: d
    };
  };
  return Wm.setLock = s, Wm;
}
var $u = {}, Dne;
function rru() {
  if (Dne)
    return $u;
  Dne = 1;
  var e = xo;
  Object.defineProperty($u, "__esModule", {
    value: !0
  }), $u.setValueSrc = $u.setValue = $u.setOperatorOption = $u.setOperator = $u.setField = void 0;
  var t = r(b$()), n = Ti();
  function o(u) {
    if (typeof WeakMap != "function")
      return null;
    var d = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (o = function(g) {
      return g ? _ : d;
    })(u);
  }
  function r(u, d) {
    if (!d && u && u.__esModule)
      return u;
    if (u === null || e(u) !== "object" && typeof u != "function")
      return { default: u };
    var _ = o(d);
    if (_ && _.has(u))
      return _.get(u);
    var p = {}, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in u)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(u, f)) {
        var h = g ? Object.getOwnPropertyDescriptor(u, f) : null;
        h && (h.get || h.set) ? Object.defineProperty(p, f, h) : p[f] = u[f];
      }
    return p.default = u, _ && _.set(u, p), p;
  }
  var i = function(d, _, p) {
    return {
      type: t.SET_FIELD,
      path: (0, n.toImmutableList)(_),
      field: p,
      config: d
    };
  };
  $u.setField = i;
  var a = function(d, _, p) {
    return {
      type: t.SET_OPERATOR,
      path: (0, n.toImmutableList)(_),
      operator: p,
      config: d
    };
  };
  $u.setOperator = a;
  var s = function(d, _, p, g, f, h, $) {
    return {
      type: t.SET_VALUE,
      path: (0, n.toImmutableList)(_),
      delta: p,
      value: g,
      valueType: f,
      asyncListValues: h,
      config: d,
      __isInternal: $
    };
  };
  $u.setValue = s;
  var c = function(d, _, p, g) {
    return {
      type: t.SET_VALUE_SRC,
      path: (0, n.toImmutableList)(_),
      delta: p,
      srcKey: g,
      config: d
    };
  };
  $u.setValueSrc = c;
  var l = function(d, _, p, g) {
    return {
      type: t.SET_OPERATOR_OPTION,
      path: (0, n.toImmutableList)(_),
      name: p,
      value: g,
      config: d
    };
  };
  return $u.setOperatorOption = l, $u;
}
var Hm = {}, Lne;
function iru() {
  if (Lne)
    return Hm;
  Lne = 1;
  var e = xo;
  Object.defineProperty(Hm, "__esModule", {
    value: !0
  }), Hm.setDragStart = Hm.setDragProgress = Hm.setDragEnd = void 0;
  var t = o(b$());
  function n(s) {
    if (typeof WeakMap != "function")
      return null;
    var c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (n = function(d) {
      return d ? l : c;
    })(s);
  }
  function o(s, c) {
    if (!c && s && s.__esModule)
      return s;
    if (s === null || e(s) !== "object" && typeof s != "function")
      return { default: s };
    var l = n(c);
    if (l && l.has(s))
      return l.get(s);
    var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var _ in s)
      if (_ !== "default" && Object.prototype.hasOwnProperty.call(s, _)) {
        var p = d ? Object.getOwnPropertyDescriptor(s, _) : null;
        p && (p.get || p.set) ? Object.defineProperty(u, _, p) : u[_] = s[_];
      }
    return u.default = s, l && l.set(s, u), u;
  }
  var r = function(c, l) {
    return {
      type: t.SET_DRAG_PROGRESS,
      mousePos: c,
      dragging: l
    };
  };
  Hm.setDragProgress = r;
  var i = function(c, l, u) {
    return {
      type: t.SET_DRAG_START,
      dragStart: c,
      dragging: l,
      mousePos: u
    };
  };
  Hm.setDragStart = i;
  var a = function() {
    return {
      type: t.SET_DRAG_END
    };
  };
  return Hm.setDragEnd = a, Hm;
}
var Mne;
function jV() {
  if (Mne)
    return $_;
  Mne = 1;
  var e = xo;
  Object.defineProperty($_, "__esModule", {
    value: !0
  }), $_.tree = $_.rule = $_.group = $_.drag = void 0;
  var t = a(nru());
  $_.tree = t;
  var n = a(oru());
  $_.group = n;
  var o = a(rru());
  $_.rule = o;
  var r = a(iru());
  $_.drag = r;
  function i(s) {
    if (typeof WeakMap != "function")
      return null;
    var c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (i = function(d) {
      return d ? l : c;
    })(s);
  }
  function a(s, c) {
    if (!c && s && s.__esModule)
      return s;
    if (s === null || e(s) !== "object" && typeof s != "function")
      return { default: s };
    var l = i(c);
    if (l && l.has(s))
      return l.get(s);
    var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var _ in s)
      if (_ !== "default" && Object.prototype.hasOwnProperty.call(s, _)) {
        var p = d ? Object.getOwnPropertyDescriptor(s, _) : null;
        p && (p.get || p.set) ? Object.defineProperty(u, _, p) : u[_] = s[_];
      }
    return u.default = s, l && l.set(s, u), u;
  }
  return $_;
}
var aL = {}, Fne;
function aru() {
  return Fne || (Fne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.validateAndFixTree = e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = v(Fe), d = t(Oa), _ = v(jV()), p = Pv(), g = Ti(), f = dc(), h = f1();
    function $(L) {
      if (typeof WeakMap != "function")
        return null;
      var R = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
      return ($ = function(A) {
        return A ? T : R;
      })(L);
    }
    function v(L, R) {
      if (!R && L && L.__esModule)
        return L;
      if (L === null || n(L) !== "object" && typeof L != "function")
        return { default: L };
      var T = $(R);
      if (T && T.has(L))
        return T.get(L);
      var D = {}, A = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var S in L)
        if (S !== "default" && Object.prototype.hasOwnProperty.call(L, S)) {
          var E = A ? Object.getOwnPropertyDescriptor(L, S) : null;
          E && (E.get || E.set) ? Object.defineProperty(D, S, E) : D[S] = L[S];
        }
      return D.default = L, T && T.set(L, D), D;
    }
    function b(L, R) {
      var T = Object.keys(L);
      if (Object.getOwnPropertySymbols) {
        var D = Object.getOwnPropertySymbols(L);
        R && (D = D.filter(function(A) {
          return Object.getOwnPropertyDescriptor(L, A).enumerable;
        })), T.push.apply(T, D);
      }
      return T;
    }
    function y(L) {
      for (var R = 1; R < arguments.length; R++) {
        var T = arguments[R] != null ? arguments[R] : {};
        R % 2 ? b(Object(T), !0).forEach(function(D) {
          (0, o.default)(L, D, T[D]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(T)) : b(Object(T)).forEach(function(D) {
          Object.defineProperty(L, D, Object.getOwnPropertyDescriptor(T, D));
        });
      }
      return L;
    }
    function w(L) {
      var R = N();
      return function() {
        var D = (0, l.default)(L), A;
        if (R) {
          var S = (0, l.default)(this).constructor;
          A = Reflect.construct(D, arguments, S);
        } else
          A = D.apply(this, arguments);
        return (0, c.default)(this, A);
      };
    }
    function N() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = function(R, T, D, A) {
      var S = (0, h.validateTree)(R, T, D, A);
      return S = (0, p.fixPathsInTree)(S), S;
    };
    e.validateAndFixTree = M;
    var q = /* @__PURE__ */ function(L) {
      (0, s.default)(T, L);
      var R = w(T);
      function T(D) {
        var A;
        return (0, r.default)(this, T), A = R.call(this, D), (0, f.useOnPropsChanged)((0, a.default)(A)), A._updateActions(D), A.validatedTree = A.validateTree(D, D), A;
      }
      return (0, i.default)(T, [{
        key: "validateTree",
        value: function(A, S) {
          return M(A.tree, S.tree, A.config, S.config);
        }
      }, {
        key: "_updateActions",
        value: function(A) {
          var S = A.config, E = A.dispatch;
          this.actions = (0, f.bindActionCreators)(y(y(y({}, _.tree), _.group), _.rule), S, E);
        }
      }, {
        key: "onPropsChanged",
        value: function(A) {
          var S = A.onChange, E = this.props.config, x = A.tree, k = A.config, I = this.validatedTree;
          this.validatedTree = x, E !== k && (this._updateActions(A), this.validatedTree = this.validateTree(A, this.props));
          var z = !(0, g.immutableEqual)(this.validatedTree, I);
          z && S && S(this.validatedTree, k, A.__lastAction);
        }
      }, {
        key: "render",
        value: function() {
          var A = this.props, S = A.config, E = A.renderBuilder, x = A.dispatch, k = A.__isInternalValueChange, I = {
            tree: this.validatedTree,
            actions: this.actions,
            config: S,
            dispatch: x,
            __isInternalValueChange: k
          };
          return E(I);
        }
      }]), T;
    }(u.PureComponent);
    e.default = q, q.propTypes = {
      config: d.default.object.isRequired,
      onChange: d.default.func,
      renderBuilder: d.default.func,
      tree: d.default.any
      //instanceOf(Immutable.Map)
      //dispatch: PropTypes.func.isRequired,
    };
  }(aL)), aL;
}
var qne;
function sru() {
  return qne || (qne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = q(Fe), d = t(Oa), _ = t(eou()), p = t(T2()), g = _ou, f = A2, h = q(jV()), $ = Qi(), v = Ti(), b = kl(), y = dc(), w = t(Dv()), N = q(aru());
    function M(x) {
      if (typeof WeakMap != "function")
        return null;
      var k = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap();
      return (M = function(F) {
        return F ? I : k;
      })(x);
    }
    function q(x, k) {
      if (!k && x && x.__esModule)
        return x;
      if (x === null || n(x) !== "object" && typeof x != "function")
        return { default: x };
      var I = M(k);
      if (I && I.has(x))
        return I.get(x);
      var z = {}, F = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var P in x)
        if (P !== "default" && Object.prototype.hasOwnProperty.call(x, P)) {
          var O = F ? Object.getOwnPropertyDescriptor(x, P) : null;
          O && (O.get || O.set) ? Object.defineProperty(z, P, O) : z[P] = x[P];
        }
      return z.default = x, I && I.set(x, z), z;
    }
    function L(x, k) {
      var I = Object.keys(x);
      if (Object.getOwnPropertySymbols) {
        var z = Object.getOwnPropertySymbols(x);
        k && (z = z.filter(function(F) {
          return Object.getOwnPropertyDescriptor(x, F).enumerable;
        })), I.push.apply(I, z);
      }
      return I;
    }
    function R(x) {
      for (var k = 1; k < arguments.length; k++) {
        var I = arguments[k] != null ? arguments[k] : {};
        k % 2 ? L(Object(I), !0).forEach(function(z) {
          (0, o.default)(x, z, I[z]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(I)) : L(Object(I)).forEach(function(z) {
          Object.defineProperty(x, z, Object.getOwnPropertyDescriptor(I, z));
        });
      }
      return x;
    }
    function T(x) {
      var k = D();
      return function() {
        var z = (0, l.default)(x), F;
        if (k) {
          var P = (0, l.default)(this).constructor;
          F = Reflect.construct(z, arguments, P);
        } else
          F = z.apply(this, arguments);
        return (0, c.default)(this, F);
      };
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var A = ["conjunctions", "fields", "types", "operators", "widgets", "settings", "funcs"], S = (0, f.connect)(function(x) {
      return {
        tree: x.tree,
        __isInternalValueChange: x.__isInternalValueChange,
        __lastAction: x.__lastAction
      };
    }, null, null, {
      context: p.default
    })(N.default);
    S.displayName = "ConnectedQuery";
    var E = /* @__PURE__ */ function(x) {
      (0, s.default)(I, x);
      var k = T(I);
      function I(z, F) {
        var P;
        (0, r.default)(this, I), P = k.call(this, z, F), P.shouldComponentUpdate = (0, y.liteShouldComponentUpdate)((0, a.default)(P), {
          value: function(ae, Y, re) {
            return !1;
          }
        }), (0, y.useOnPropsChanged)((0, a.default)(P));
        var O = (0, w.default)(z, A), V = (0, $.extendConfig)(O), U = z.value, H = U ? (0, N.validateAndFixTree)(U, null, O, O) : null, J = (0, _.default)(R(R({}, O), {}, {
          tree: H
        }));
        return P.state = {
          store: (0, g.createStore)(J),
          config: V
        }, P;
      }
      return (0, i.default)(I, [{
        key: "onPropsChanged",
        value: function(F) {
          var P = this, O = (0, w.default)(this.props, A), V = (0, w.default)(F, A), U = !(0, v.shallowEqual)(O, V, !0);
          U && (V = (0, $.extendConfig)(V), this.setState({
            config: V
          }));
          var H = this.state.store.getState().tree, J = !(0, v.immutableEqual)(F.value, this.props.value) && !(0, v.immutableEqual)(F.value, H);
          if (J) {
            var le = F.value || (0, b.defaultRoot)(R(R({}, F), {}, {
              tree: null
            })), ae = (0, N.validateAndFixTree)(le, null, V, O);
            return Promise.resolve().then(function() {
              P.state.store.dispatch(h.tree.setTree(F, ae));
            });
          }
        }
      }, {
        key: "render",
        value: function() {
          var F = this.props, P = F.renderBuilder, O = F.get_children, V = F.onChange, U = F.settings, H = this.state, J = H.config, le = H.store, ae = U.renderProvider;
          return /* @__PURE__ */ u.default.createElement(ae, {
            config: J
          }, /* @__PURE__ */ u.default.createElement(f.Provider, {
            store: le,
            context: p.default
          }, /* @__PURE__ */ u.default.createElement(S, {
            store: le,
            config: J,
            onChange: V,
            renderBuilder: P || O
          })));
        }
      }]), I;
    }(u.Component);
    e.default = E, E.propTypes = {
      //config
      conjunctions: d.default.object.isRequired,
      fields: d.default.object.isRequired,
      types: d.default.object.isRequired,
      operators: d.default.object.isRequired,
      widgets: d.default.object.isRequired,
      settings: d.default.object.isRequired,
      onChange: d.default.func,
      renderBuilder: d.default.func,
      value: d.default.any
      //instanceOf(Immutable.Map)
    };
  }(_P)), _P;
}
var sL = {}, gw = {}, cL = {}, lL = {}, jne;
function cru() {
  return jne || (jne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(ki), r = t(Si), i = t(Ei), a = t(xi()), s = t(oi()), c = f(Fe), l = t(Oa), u = t(T2()), d = Qi(), _ = dc(), p = A2;
    function g(w) {
      if (typeof WeakMap != "function")
        return null;
      var N = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap();
      return (g = function(L) {
        return L ? M : N;
      })(w);
    }
    function f(w, N) {
      if (!N && w && w.__esModule)
        return w;
      if (w === null || n(w) !== "object" && typeof w != "function")
        return { default: w };
      var M = g(N);
      if (M && M.has(w))
        return M.get(w);
      var q = {}, L = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var R in w)
        if (R !== "default" && Object.prototype.hasOwnProperty.call(w, R)) {
          var T = L ? Object.getOwnPropertyDescriptor(w, R) : null;
          T && (T.get || T.set) ? Object.defineProperty(q, R, T) : q[R] = w[R];
        }
      return q.default = w, M && M.set(w, q), q;
    }
    function h(w) {
      var N = $();
      return function() {
        var q = (0, s.default)(w), L;
        if (N) {
          var R = (0, s.default)(this).constructor;
          L = Reflect.construct(q, arguments, R);
        } else
          L = q.apply(this, arguments);
        return (0, a.default)(this, L);
      };
    }
    function $() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var v = jg, b = function(N) {
      var M;
      return M = /* @__PURE__ */ function(q) {
        (0, i.default)(R, q);
        var L = h(R);
        function R(T) {
          var D;
          return (0, o.default)(this, R), D = L.call(this, T), D.dummyFn = function() {
          }, D.removeSelf = function() {
            D.props.actions.removeRule(D.props.path);
          }, D.setLock = function() {
            var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            D.props.actions.setLock(D.props.path, A);
          }, D.setField = function(A) {
            D.props.actions.setField(D.props.path, A);
          }, D.setOperator = function(A) {
            D.props.actions.setOperator(D.props.path, A);
          }, D.setOperatorOption = function(A, S) {
            D.props.actions.setOperatorOption(D.props.path, A, S);
          }, D.setValue = function(A, S, E, x, k) {
            D.props.actions.setValue(D.props.path, A, S, E, x, k);
          }, D.setValueSrc = function(A, S) {
            D.props.actions.setValueSrc(D.props.path, A, S);
          }, D.dummyFn.isDummyFn = !0, D;
        }
        return (0, r.default)(R, [{
          key: "shouldComponentUpdate",
          value: function(D, A) {
            var S = this.props, E = this.state, x = (0, _.pureShouldComponentUpdate)(this)(D, A);
            if (x && E == A && S != D) {
              var k = D.dragging.id || S.dragging.id, I = k == D.id, z = [];
              for (var F in D) {
                var P = D[F] != S[F];
                F == "dragging" && !I && (P = !1), P && z.push(F);
              }
              z.length || (x = !1);
            }
            return x;
          }
        }, {
          key: "render",
          value: function() {
            var D = this.props.dragging.id == this.props.id, A = (0, d.getFieldConfig)(this.props.config, this.props.field), S = this.props.config.settings.showErrorMessage;
            A && A.type == "!struct";
            var E = !D && this.props.isDraggingTempo, x = this.props.valueError, k = x && x.toArray().filter(function(z) {
              return !!z;
            }).shift() || null, I = k != null && S;
            return /* @__PURE__ */ c.default.createElement("div", {
              className: v("group-or-rule-container", "rule-container", I ? "rule-with-error" : null),
              "data-id": this.props.id
            }, [D ? /* @__PURE__ */ c.default.createElement(N, {
              key: "dragging",
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: !0,
              isDraggingTempo: !0,
              dragging: this.props.dragging,
              setField: this.dummyFn,
              setOperator: this.dummyFn,
              setOperatorOption: this.dummyFn,
              setLock: this.dummyFn,
              removeSelf: this.dummyFn,
              setValue: this.dummyFn,
              setValueSrc: this.dummyFn,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              value: this.props.value || null,
              valueSrc: this.props.valueSrc || null,
              valueError: this.props.valueError || null,
              operatorOptions: this.props.operatorOptions,
              config: this.props.config,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              asyncListValues: this.props.asyncListValues,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            }) : null, /* @__PURE__ */ c.default.createElement(N, {
              key: this.props.id,
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: D,
              isDraggingTempo: E,
              onDragStart: this.props.onDragStart,
              setLock: E ? this.dummyFn : this.setLock,
              removeSelf: E ? this.dummyFn : this.removeSelf,
              setField: E ? this.dummyFn : this.setField,
              setOperator: E ? this.dummyFn : this.setOperator,
              setOperatorOption: E ? this.dummyFn : this.setOperatorOption,
              setValue: E ? this.dummyFn : this.setValue,
              setValueSrc: E ? this.dummyFn : this.setValueSrc,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              value: this.props.value || null,
              valueSrc: this.props.valueSrc || null,
              valueError: this.props.valueError || null,
              operatorOptions: this.props.operatorOptions,
              config: this.props.config,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              asyncListValues: this.props.asyncListValues,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            })]);
          }
        }]), R;
      }(c.Component), M.propTypes = {
        id: l.default.string.isRequired,
        groupId: l.default.string,
        config: l.default.object.isRequired,
        path: l.default.any.isRequired,
        //instanceOf(Immutable.List)
        operator: l.default.string,
        field: l.default.string,
        actions: l.default.object.isRequired,
        //{removeRule: Funciton, setField, setOperator, setOperatorOption, setValue, setValueSrc, ...}
        onDragStart: l.default.func,
        value: l.default.any,
        //depends on widget
        valueSrc: l.default.any,
        asyncListValues: l.default.array,
        valueError: l.default.any,
        operatorOptions: l.default.object,
        reordableNodesCnt: l.default.number,
        parentField: l.default.string,
        //from RuleGroup
        isLocked: l.default.bool,
        isTrueLocked: l.default.bool,
        //connected:
        dragging: l.default.object,
        //{id, x, y, w, h}
        isDraggingTempo: l.default.bool
      }, M;
    }, y = function(N) {
      var M = (0, p.connect)(function(q) {
        return {
          dragging: q.dragging
        };
      }, null, null, {
        context: u.default
      })(b(N));
      return M.displayName = "ConnectedRuleContainer", M;
    };
    e.default = y;
  }(lL)), lL;
}
var uL = {}, Vne;
function y$() {
  return Vne || (Vne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Ys), r = t(g1), i = t(ki), a = t(Si), s = t(Ei), c = t(xi()), l = t(oi()), u = g(Fe), d = t(Oa), _ = ["isDraggingTempo", "isDraggingMe", "dragging"];
    function p(b) {
      if (typeof WeakMap != "function")
        return null;
      var y = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap();
      return (p = function(M) {
        return M ? w : y;
      })(b);
    }
    function g(b, y) {
      if (!y && b && b.__esModule)
        return b;
      if (b === null || n(b) !== "object" && typeof b != "function")
        return { default: b };
      var w = p(y);
      if (w && w.has(b))
        return w.get(b);
      var N = {}, M = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var q in b)
        if (q !== "default" && Object.prototype.hasOwnProperty.call(b, q)) {
          var L = M ? Object.getOwnPropertyDescriptor(b, q) : null;
          L && (L.get || L.set) ? Object.defineProperty(N, q, L) : N[q] = b[q];
        }
      return N.default = b, w && w.set(b, N), N;
    }
    function f(b) {
      var y = h();
      return function() {
        var N = (0, l.default)(b), M;
        if (y) {
          var q = (0, l.default)(this).constructor;
          M = Reflect.construct(N, arguments, q);
        } else
          M = N.apply(this, arguments);
        return (0, c.default)(this, M);
      };
    }
    function h() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var $ = jg, v = function(y) {
      return function(w) {
        var N;
        return N = /* @__PURE__ */ function(M) {
          (0, s.default)(L, M);
          var q = f(L);
          function L(R) {
            var T;
            return (0, i.default)(this, L), T = q.call(this, R), T.handleDraggerMouseDown = function(D) {
              var A = T.props.id, S = T.wrapper.current;
              T.props.onDragStart && T.props.onDragStart(A, S, D);
            }, T.wrapper = /* @__PURE__ */ u.default.createRef(), T;
          }
          return (0, a.default)(L, [{
            key: "render",
            value: function() {
              var T = this.props, D = T.isDraggingTempo, A = T.isDraggingMe, S = T.dragging, E = (0, r.default)(T, _), x = E.isTrueLocked, k = {};
              A && D && (k = {
                top: S.y,
                left: S.x,
                width: S.w
              });
              var I = $(y, "group-or-rule", A && D ? "qb-draggable" : null, A && !D ? "qb-placeholder" : null, x ? "locked" : null);
              return /* @__PURE__ */ u.default.createElement("div", {
                className: I,
                style: k,
                ref: this.wrapper,
                "data-id": this.props.id
              }, /* @__PURE__ */ u.default.createElement(w, (0, o.default)({
                handleDraggerMouseDown: this.handleDraggerMouseDown,
                isDraggingMe: A,
                isDraggingTempo: D
              }, E)));
            }
          }]), L;
        }(u.PureComponent), N.propTypes = {
          isDraggingTempo: d.default.bool,
          isDraggingMe: d.default.bool,
          onDragStart: d.default.func,
          dragging: d.default.object,
          //{id, x, y, w, h}
          isLocked: d.default.bool,
          isTrueLocked: d.default.bool
        }, N;
      };
    };
    e.default = v;
  }(uL)), uL;
}
var dL = {}, _L = {}, pL, Bne;
function lru() {
  if (Bne)
    return pL;
  Bne = 1;
  var e = Lq, t = fye(), n = vye(), o = fV();
  function r(i, a) {
    if (i == null)
      return {};
    var s = e(o(i), function(c) {
      return [c];
    });
    return a = t(a), n(i, s, function(c, l) {
      return a(c, l[0]);
    });
  }
  return pL = r, pL;
}
var Une;
function uru() {
  return Une || (Une = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = v(Fe), d = t(Oa), _ = Qi(), p = t(Tf), g = t(lru()), f = t(p2()), h = dc();
    function $(q) {
      if (typeof WeakMap != "function")
        return null;
      var L = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap();
      return ($ = function(D) {
        return D ? R : L;
      })(q);
    }
    function v(q, L) {
      if (!L && q && q.__esModule)
        return q;
      if (q === null || n(q) !== "object" && typeof q != "function")
        return { default: q };
      var R = $(L);
      if (R && R.has(q))
        return R.get(q);
      var T = {}, D = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var A in q)
        if (A !== "default" && Object.prototype.hasOwnProperty.call(q, A)) {
          var S = D ? Object.getOwnPropertyDescriptor(q, A) : null;
          S && (S.get || S.set) ? Object.defineProperty(T, A, S) : T[A] = q[A];
        }
      return T.default = q, R && R.set(q, T), T;
    }
    function b(q, L) {
      var R = Object.keys(q);
      if (Object.getOwnPropertySymbols) {
        var T = Object.getOwnPropertySymbols(q);
        L && (T = T.filter(function(D) {
          return Object.getOwnPropertyDescriptor(q, D).enumerable;
        })), R.push.apply(R, T);
      }
      return R;
    }
    function y(q) {
      for (var L = 1; L < arguments.length; L++) {
        var R = arguments[L] != null ? arguments[L] : {};
        L % 2 ? b(Object(R), !0).forEach(function(T) {
          (0, o.default)(q, T, R[T]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(R)) : b(Object(R)).forEach(function(T) {
          Object.defineProperty(q, T, Object.getOwnPropertyDescriptor(R, T));
        });
      }
      return q;
    }
    function w(q) {
      var L = N();
      return function() {
        var T = (0, l.default)(q), D;
        if (L) {
          var A = (0, l.default)(this).constructor;
          D = Reflect.construct(T, arguments, A);
        } else
          D = T.apply(this, arguments);
        return (0, c.default)(this, D);
      };
    }
    function N() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = /* @__PURE__ */ function(q) {
      (0, s.default)(R, q);
      var L = w(R);
      function R(T) {
        var D;
        return (0, r.default)(this, R), D = L.call(this, T), (0, h.useOnPropsChanged)((0, a.default)(D)), D.onPropsChanged(T), D;
      }
      return (0, i.default)(R, [{
        key: "onPropsChanged",
        value: function(D) {
          var A = this.props, S = ["config", "selectedField", "selectedOperator"], E = !this.meta || S.map(function(x) {
            return D[x] !== A[x];
          }).filter(function(x) {
            return x;
          }).length > 0;
          E && (this.meta = this.getMeta(D));
        }
      }, {
        key: "getMeta",
        value: function(D) {
          var A = D.config, S = D.selectedField, E = D.selectedOperator, x = (0, _.getFieldConfig)(A, S), k = x == null ? void 0 : x.operators, I = (0, f.default)((0, g.default)(A.operators, function(ae, Y) {
            return (k == null ? void 0 : k.indexOf(Y)) !== -1;
          }), function(ae, Y) {
            return (0, _.getOperatorConfig)(A, Y, S);
          }), z = this.buildOptions(A, I, k), F = !!E, P = F ? I[E] : null, O = P || {}, V = this.props.config.settings.operatorPlaceholder, U = E, H = F ? [U] : null, J = H, le = O.label;
          return {
            placeholder: V,
            items: z,
            selectedKey: U,
            selectedKeys: H,
            selectedPath: J,
            selectedLabel: le,
            selectedOpts: O,
            fieldConfig: x
          };
        }
      }, {
        key: "buildOptions",
        value: function(D, A, S) {
          return !A || !S ? null : (0, p.default)(A).sort(function(E, x) {
            return S.indexOf(E) - S.indexOf(x);
          }).map(function(E) {
            var x = A[E], k = x.label;
            return {
              key: E,
              path: E,
              label: k
            };
          });
        }
      }, {
        key: "render",
        value: function() {
          var D = this.props, A = D.config, S = D.customProps, E = D.setOperator, x = D.readonly, k = D.id, I = D.groupId, z = A.settings.renderOperator, F = y({
            id: k,
            groupId: I,
            config: A,
            customProps: S,
            readonly: x,
            setField: E
          }, this.meta);
          return F.items ? z(F) : null;
        }
      }]), R;
    }(u.PureComponent);
    e.default = M, M.propTypes = {
      id: d.default.string,
      groupId: d.default.string,
      config: d.default.object.isRequired,
      selectedField: d.default.string,
      selectedOperator: d.default.string,
      readonly: d.default.bool,
      //actions
      setOperator: d.default.func.isRequired
    };
  }(_L)), _L;
}
var Gne;
function w$e() {
  return Gne || (Gne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(ki), r = t(Si), i = t(Ei), a = t(xi()), s = t(oi()), c = _(Fe), l = t(uru()), u = im();
    function d(h) {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
      return (d = function(y) {
        return y ? v : $;
      })(h);
    }
    function _(h, $) {
      if (!$ && h && h.__esModule)
        return h;
      if (h === null || n(h) !== "object" && typeof h != "function")
        return { default: h };
      var v = d($);
      if (v && v.has(h))
        return v.get(h);
      var b = {}, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var w in h)
        if (w !== "default" && Object.prototype.hasOwnProperty.call(h, w)) {
          var N = y ? Object.getOwnPropertyDescriptor(h, w) : null;
          N && (N.get || N.set) ? Object.defineProperty(b, w, N) : b[w] = h[w];
        }
      return b.default = h, v && v.set(h, b), b;
    }
    function p(h) {
      var $ = g();
      return function() {
        var b = (0, s.default)(h), y;
        if ($) {
          var w = (0, s.default)(this).constructor;
          y = Reflect.construct(b, arguments, w);
        } else
          y = b.apply(this, arguments);
        return (0, a.default)(this, y);
      };
    }
    function g() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var f = /* @__PURE__ */ function(h) {
      (0, i.default)(v, h);
      var $ = p(v);
      function v() {
        return (0, o.default)(this, v), $.apply(this, arguments);
      }
      return (0, r.default)(v, [{
        key: "render",
        value: function() {
          var y = this.props, w = y.config, N = y.selectedField, M = y.selectedOperator, q = y.setOperator, L = y.selectedFieldPartsLabels, R = y.showOperator, T = y.showOperatorLabel, D = y.selectedFieldWidgetConfig, A = y.readonly, S = y.id, E = y.groupId, x = R && /* @__PURE__ */ c.default.createElement(u.Col, {
            key: "operators-for-" + (L || []).join("_"),
            className: "rule--operator"
          }, w.settings.showLabels && /* @__PURE__ */ c.default.createElement("label", {
            className: "rule--label"
          }, w.settings.operatorLabel), /* @__PURE__ */ c.default.createElement(l.default, {
            key: "operator",
            config: w,
            selectedField: N,
            selectedOperator: M,
            setOperator: q,
            readonly: A,
            id: S,
            groupId: E
          })), k = T && /* @__PURE__ */ c.default.createElement(u.Col, {
            key: "operators-for-" + (L || []).join("_"),
            className: "rule--operator"
          }, /* @__PURE__ */ c.default.createElement("div", {
            className: "rule--operator"
          }, w.settings.showLabels ? /* @__PURE__ */ c.default.createElement("label", {
            className: "rule--label"
          }, " ") : null, /* @__PURE__ */ c.default.createElement("span", null, D.operatorInlineLabel)));
          return [x, k];
        }
      }]), v;
    }(c.PureComponent);
    e.default = f;
  }(dL)), dL;
}
var mL = {}, fL = {}, Wne;
function dru() {
  return Wne || (Wne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = b(Fe), d = t(Oa), _ = Qi(), p = Es(), g = Ti(), f = dc(), h = t(m1()), $ = t(Tf);
    function v(L) {
      if (typeof WeakMap != "function")
        return null;
      var R = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
      return (v = function(A) {
        return A ? T : R;
      })(L);
    }
    function b(L, R) {
      if (!R && L && L.__esModule)
        return L;
      if (L === null || n(L) !== "object" && typeof L != "function")
        return { default: L };
      var T = v(R);
      if (T && T.has(L))
        return T.get(L);
      var D = {}, A = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var S in L)
        if (S !== "default" && Object.prototype.hasOwnProperty.call(L, S)) {
          var E = A ? Object.getOwnPropertyDescriptor(L, S) : null;
          E && (E.get || E.set) ? Object.defineProperty(D, S, E) : D[S] = L[S];
        }
      return D.default = L, T && T.set(L, D), D;
    }
    function y(L, R) {
      var T = Object.keys(L);
      if (Object.getOwnPropertySymbols) {
        var D = Object.getOwnPropertySymbols(L);
        R && (D = D.filter(function(A) {
          return Object.getOwnPropertyDescriptor(L, A).enumerable;
        })), T.push.apply(T, D);
      }
      return T;
    }
    function w(L) {
      for (var R = 1; R < arguments.length; R++) {
        var T = arguments[R] != null ? arguments[R] : {};
        R % 2 ? y(Object(T), !0).forEach(function(D) {
          (0, o.default)(L, D, T[D]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(T)) : y(Object(T)).forEach(function(D) {
          Object.defineProperty(L, D, Object.getOwnPropertyDescriptor(T, D));
        });
      }
      return L;
    }
    function N(L) {
      var R = M();
      return function() {
        var D = (0, l.default)(L), A;
        if (R) {
          var S = (0, l.default)(this).constructor;
          A = Reflect.construct(D, arguments, S);
        } else
          A = D.apply(this, arguments);
        return (0, c.default)(this, A);
      };
    }
    function M() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var q = /* @__PURE__ */ function(L) {
      (0, s.default)(T, L);
      var R = N(T);
      function T(D) {
        var A;
        return (0, r.default)(this, T), A = R.call(this, D), (0, f.useOnPropsChanged)((0, a.default)(A)), A.onPropsChanged(D), A;
      }
      return (0, i.default)(T, [{
        key: "onPropsChanged",
        value: function(A) {
          var S = this.props, E = ["selectedField", "config", "parentField"], x = !this.meta || E.map(function(k) {
            return A[k] !== S[k];
          }).filter(function(k) {
            return k;
          }).length > 0;
          x && (this.meta = this.getMeta(A));
        }
      }, {
        key: "getMeta",
        value: function(A) {
          var S = A.selectedField, E = A.config, x = A.parentField, k = S, I = E.settings, z = I.maxLabelsLength, F = I.fieldSeparatorDisplay, P = I.fieldPlaceholder, O = I.fieldSeparator, V = !!S, U = V ? null : (0, g.truncateString)(P, z), H = V ? (0, _.getFieldConfig)(E, k) : null, J = H || {}, le = (0, p.getFieldPath)(k, E), ae = (0, p.getFieldPath)(k, E, !0), Y = this.getFieldLabel(H, k, E), re = (0, p.getFieldPathLabels)(k, E), ie = re ? re.join(F) : null;
          (ie == Y || x) && (ie = null);
          var _e = J.label2, he = typeof x == "string" ? x.split(O) : x, be = x ? (0, _.getFieldConfig)(E, x) : null, Q = x ? be && be.subfields : E.fields, me = this.buildOptions(he, E, Q, he);
          return {
            placeholder: U,
            items: me,
            parentField: x,
            selectedKey: k,
            selectedKeys: le,
            selectedPath: ae,
            selectedLabel: Y,
            selectedOpts: J,
            selectedAltLabel: _e,
            selectedFullLabel: ie
          };
        }
      }, {
        key: "getFieldLabel",
        value: function(A, S, E) {
          if (!S)
            return null;
          var x = E.settings.fieldSeparator, k = E.settings.maxLabelsLength, I = Array.isArray(S) ? S : S.split(x), z = A && A.label || (0, h.default)(I);
          return z = (0, g.truncateString)(z, k), z;
        }
      }, {
        key: "buildOptions",
        value: function(A, S, E) {
          var x = this, k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, I = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
          if (!E)
            return null;
          var z = S.settings, F = z.fieldSeparator, P = z.fieldSeparatorDisplay, O = k ? k.join(F) + F : "";
          return (0, $.default)(E).map(function(V) {
            var U = E[V], H = x.getFieldLabel(U, V, S), J = (0, p.getFieldPathLabels)(O + V, S), le = J.join(P);
            (le == H || A) && (le = null);
            var ae = U.label2, Y = U.tooltip, re = (k || []).concat(V), ie = U.disabled;
            if (!U.hideForSelect)
              return U.type == "!struct" ? {
                disabled: ie,
                key: V,
                path: O + V,
                label: H,
                fullLabel: le,
                altLabel: ae,
                tooltip: Y,
                items: x.buildOptions(A, S, U.subfields, re, H)
              } : {
                disabled: ie,
                key: V,
                path: O + V,
                label: H,
                fullLabel: le,
                altLabel: ae,
                tooltip: Y,
                grouplabel: I
              };
          }).filter(function(V) {
            return !!V;
          });
        }
      }, {
        key: "render",
        value: function() {
          var A = this.props, S = A.config, E = A.customProps, x = A.setField, k = A.readonly, I = A.id, z = A.groupId, F = S.settings.renderField, P = w({
            id: I,
            groupId: z,
            config: S,
            customProps: E,
            readonly: k,
            setField: x
          }, this.meta);
          return F(P);
        }
      }]), T;
    }(u.PureComponent);
    e.default = q, q.propTypes = {
      id: d.default.string,
      groupId: d.default.string,
      config: d.default.object.isRequired,
      selectedField: d.default.string,
      parentField: d.default.string,
      customProps: d.default.object,
      readonly: d.default.bool,
      //actions
      setField: d.default.func.isRequired
    };
  }(fL)), fL;
}
var Hne;
function VV() {
  return Hne || (Hne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(ki), r = t(Si), i = t(Ei), a = t(xi()), s = t(oi()), c = _(Fe), l = t(dru()), u = im();
    function d(h) {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
      return (d = function(y) {
        return y ? v : $;
      })(h);
    }
    function _(h, $) {
      if (!$ && h && h.__esModule)
        return h;
      if (h === null || n(h) !== "object" && typeof h != "function")
        return { default: h };
      var v = d($);
      if (v && v.has(h))
        return v.get(h);
      var b = {}, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var w in h)
        if (w !== "default" && Object.prototype.hasOwnProperty.call(h, w)) {
          var N = y ? Object.getOwnPropertyDescriptor(h, w) : null;
          N && (N.get || N.set) ? Object.defineProperty(b, w, N) : b[w] = h[w];
        }
      return b.default = h, v && v.set(h, b), b;
    }
    function p(h) {
      var $ = g();
      return function() {
        var b = (0, s.default)(h), y;
        if ($) {
          var w = (0, s.default)(this).constructor;
          y = Reflect.construct(b, arguments, w);
        } else
          y = b.apply(this, arguments);
        return (0, a.default)(this, y);
      };
    }
    function g() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var f = /* @__PURE__ */ function(h) {
      (0, i.default)(v, h);
      var $ = p(v);
      function v() {
        return (0, o.default)(this, v), $.apply(this, arguments);
      }
      return (0, r.default)(v, [{
        key: "render",
        value: function() {
          var y = this.props, w = y.config, N = y.selectedField, M = y.setField, q = y.parentField, L = y.classname, R = y.readonly, T = y.id, D = y.groupId;
          return /* @__PURE__ */ c.default.createElement(u.Col, {
            className: L
          }, w.settings.showLabels && /* @__PURE__ */ c.default.createElement("label", {
            className: "rule--label"
          }, w.settings.fieldLabel), /* @__PURE__ */ c.default.createElement(l.default, {
            config: w,
            selectedField: N,
            parentField: q,
            setField: M,
            customProps: w.settings.customFieldSelectProps,
            readonly: R,
            id: T,
            groupId: D
          }));
        }
      }]), v;
    }(c.PureComponent);
    e.default = f;
  }(mL)), mL;
}
var gL = {}, Yne;
function _ru() {
  return Yne || (Yne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(g1), r = t(ki), i = t(Si), a = t(Ei), s = t(xi()), c = t(oi()), l = g(Fe), u = t(Oa), d = Qi(), _ = ["factory"];
    function p(v) {
      if (typeof WeakMap != "function")
        return null;
      var b = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap();
      return (p = function(N) {
        return N ? y : b;
      })(v);
    }
    function g(v, b) {
      if (!b && v && v.__esModule)
        return v;
      if (v === null || n(v) !== "object" && typeof v != "function")
        return { default: v };
      var y = p(b);
      if (y && y.has(v))
        return y.get(v);
      var w = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var M in v)
        if (M !== "default" && Object.prototype.hasOwnProperty.call(v, M)) {
          var q = N ? Object.getOwnPropertyDescriptor(v, M) : null;
          q && (q.get || q.set) ? Object.defineProperty(w, M, q) : w[M] = v[M];
        }
      return w.default = v, y && y.set(v, w), w;
    }
    function f(v) {
      var b = h();
      return function() {
        var w = (0, c.default)(v), N;
        if (b) {
          var M = (0, c.default)(this).constructor;
          N = Reflect.construct(w, arguments, M);
        } else
          N = w.apply(this, arguments);
        return (0, s.default)(this, N);
      };
    }
    function h() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var $ = /* @__PURE__ */ function(v) {
      (0, a.default)(y, v);
      var b = f(y);
      function y() {
        return (0, r.default)(this, y), b.apply(this, arguments);
      }
      return (0, i.default)(y, [{
        key: "render",
        value: function() {
          if (!this.props.selectedOperator)
            return null;
          var N = (0, d.getOperatorConfig)(this.props.config, this.props.selectedOperator, this.props.selectedField);
          if (typeof N.options > "u")
            return null;
          var M = N.options, q = M.factory, L = (0, o.default)(M, _), R = Object.assign({}, L, {
            config: this.props.config,
            field: this.props.selectedField,
            operator: this.props.selectedOperator,
            options: this.props.operatorOptions,
            setOption: this.props.setOperatorOption,
            readonly: this.props.readonly
          }), T = q(R), D = this.props.selectedOperator;
          return /* @__PURE__ */ l.default.createElement("div", {
            className: "rule--operator rule--operator--".concat(D.toUpperCase())
          }, T);
        }
      }]), y;
    }(l.PureComponent);
    e.default = $, $.propTypes = {
      config: u.default.object.isRequired,
      operatorOptions: u.default.any.isRequired,
      //instanceOf(Immutable.Map)
      selectedField: u.default.string.isRequired,
      selectedOperator: u.default.string.isRequired,
      readonly: u.default.bool,
      //actions
      setOperatorOption: u.default.func.isRequired
    };
  }(gL)), gL;
}
var Kne;
function pru() {
  return Kne || (Kne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Yr()), r = t(ki), i = t(Si), a = t(Hs()), s = t(Ei), c = t(xi()), l = t(oi()), u = R(Fe), d = t(Oa), _ = t(cru()), p = t(y$()), g = t(w$e()), f = t(VV()), h = t(f2()), $ = t(_ru()), v = Qi(), b = Es(), y = dc(), w = im(), N, M, q;
    function L(I) {
      if (typeof WeakMap != "function")
        return null;
      var z = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap();
      return (L = function(O) {
        return O ? F : z;
      })(I);
    }
    function R(I, z) {
      if (!z && I && I.__esModule)
        return I;
      if (I === null || n(I) !== "object" && typeof I != "function")
        return { default: I };
      var F = L(z);
      if (F && F.has(I))
        return F.get(I);
      var P = {}, O = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var V in I)
        if (V !== "default" && Object.prototype.hasOwnProperty.call(I, V)) {
          var U = O ? Object.getOwnPropertyDescriptor(I, V) : null;
          U && (U.get || U.set) ? Object.defineProperty(P, V, U) : P[V] = I[V];
        }
      return P.default = I, F && F.set(I, P), P;
    }
    function T(I, z) {
      var F = Object.keys(I);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(I);
        z && (P = P.filter(function(O) {
          return Object.getOwnPropertyDescriptor(I, O).enumerable;
        })), F.push.apply(F, P);
      }
      return F;
    }
    function D(I) {
      for (var z = 1; z < arguments.length; z++) {
        var F = arguments[z] != null ? arguments[z] : {};
        z % 2 ? T(Object(F), !0).forEach(function(P) {
          (0, o.default)(I, P, F[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(I, Object.getOwnPropertyDescriptors(F)) : T(Object(F)).forEach(function(P) {
          Object.defineProperty(I, P, Object.getOwnPropertyDescriptor(F, P));
        });
      }
      return I;
    }
    function A(I) {
      var z = S();
      return function() {
        var P = (0, l.default)(I), O;
        if (z) {
          var V = (0, l.default)(this).constructor;
          O = Reflect.construct(P, arguments, V);
        } else
          O = P.apply(this, arguments);
        return (0, c.default)(this, O);
      };
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var E = jg, x = (N = (0, p.default)("rule"), (0, _.default)(M = N(M = (0, w.ConfirmFn)(M = (q = /* @__PURE__ */ function(I) {
      (0, s.default)(F, I);
      var z = A(F);
      function F(P) {
        var O;
        return (0, r.default)(this, F), O = z.call(this, P), (0, y.useOnPropsChanged)((0, a.default)(O)), O.removeSelf = O.removeSelf.bind((0, a.default)(O)), O.setLock = O.setLock.bind((0, a.default)(O)), O.onPropsChanged(P), O;
      }
      return (0, i.default)(F, [{
        key: "onPropsChanged",
        value: function(O) {
          var V = this.props, U = ["selectedField", "selectedOperator", "config", "reordableNodesCnt", "isLocked"], H = !this.meta || U.map(function(J) {
            return O[J] !== V[J];
          }).filter(function(J) {
            return J;
          }).length > 0;
          H && (this.meta = this.getMeta(O));
        }
      }, {
        key: "getMeta",
        value: function(O) {
          var V = O.selectedField, U = O.selectedOperator, H = O.config, J = O.reordableNodesCnt, le = O.isLocked, ae = (0, b.getFieldPathLabels)(V, H), Y = (0, v.getFieldConfig)(H, V), re = Y && Y.type == "!struct", ie = V && U && !re, _e = (0, v.getOperatorConfig)(H, U, V), he = _e && _e.options != null, be = (0, v.getFieldWidgetConfig)(H, V, U) || {}, Q = be.hideOperator, me = H.settings.canReorder && J > 1 && !le, ne = V && !Q, pe = V && Q && be.operatorInlineLabel, ge = ie, ve = ie && he;
          return {
            selectedFieldPartsLabels: ae,
            selectedFieldWidgetConfig: be,
            showDragIcon: me,
            showOperator: ne,
            showOperatorLabel: pe,
            showWidget: ge,
            showOperatorOptions: ve
          };
        }
      }, {
        key: "setLock",
        value: function(O) {
          this.props.setLock(O);
        }
      }, {
        key: "removeSelf",
        value: function() {
          var O = this, V = this.props.confirmFn, U = this.props.config.settings, H = U.renderConfirm, J = U.removeRuleConfirmOptions, le = function() {
            O.props.removeSelf();
          };
          J && !this.isEmptyCurrentRule() ? H(D(D({}, J), {}, {
            onOk: le,
            onCancel: null,
            confirmFn: V
          })) : le();
        }
      }, {
        key: "isEmptyCurrentRule",
        value: function() {
          return !(this.props.selectedField !== null && this.props.selectedOperator !== null && this.props.value.filter(function(O) {
            return O !== void 0;
          }).size > 0);
        }
      }, {
        key: "renderField",
        value: function() {
          var O = this.props, V = O.config, U = O.isLocked, H = V.settings.immutableFieldsMode;
          return /* @__PURE__ */ u.default.createElement(f.default, {
            key: "field",
            classname: "rule--field",
            config: V,
            selectedField: this.props.selectedField,
            setField: H ? w.dummyFn : this.props.setField,
            parentField: this.props.parentField,
            readonly: H || U,
            id: this.props.id,
            groupId: this.props.groupId
          });
        }
      }, {
        key: "renderOperator",
        value: function() {
          var O = this.props, V = O.config, U = O.isLocked, H = this.meta, J = H.selectedFieldPartsLabels, le = H.selectedFieldWidgetConfig, ae = H.showOperator, Y = H.showOperatorLabel, re = V.settings.immutableOpsMode;
          return /* @__PURE__ */ u.default.createElement(g.default, {
            key: "operator",
            config: V,
            selectedField: this.props.selectedField,
            selectedOperator: this.props.selectedOperator,
            setOperator: re ? w.dummyFn : this.props.setOperator,
            selectedFieldPartsLabels: J,
            showOperator: ae,
            showOperatorLabel: Y,
            selectedFieldWidgetConfig: le,
            readonly: re || U,
            id: this.props.id,
            groupId: this.props.groupId
          });
        }
      }, {
        key: "renderWidget",
        value: function() {
          var O = this.props, V = O.config, U = O.valueError, H = O.isLocked, J = this.meta.showWidget, le = V.settings.immutableValuesMode;
          if (!J)
            return null;
          var ae = /* @__PURE__ */ u.default.createElement(h.default, {
            key: "values",
            field: this.props.selectedField,
            parentField: this.props.parentField,
            operator: this.props.selectedOperator,
            value: this.props.value,
            valueSrc: this.props.valueSrc,
            asyncListValues: this.props.asyncListValues,
            valueError: U,
            config: V,
            setValue: le ? w.dummyFn : this.props.setValue,
            setValueSrc: le ? w.dummyFn : this.props.setValueSrc,
            readonly: le || H,
            id: this.props.id,
            groupId: this.props.groupId
          });
          return /* @__PURE__ */ u.default.createElement(w.Col, {
            key: "widget-for-" + this.props.selectedOperator,
            className: "rule--value"
          }, ae);
        }
      }, {
        key: "renderOperatorOptions",
        value: function() {
          var O = this.props.config, V = this.meta.showOperatorOptions, U = O.settings, H = U.immutableOpsMode, J = U.immutableValuesMode;
          if (!V)
            return null;
          var le = /* @__PURE__ */ u.default.createElement($.default, {
            key: "operatorOptions",
            selectedField: this.props.selectedField,
            selectedOperator: this.props.selectedOperator,
            operatorOptions: this.props.operatorOptions,
            setOperatorOption: H ? w.dummyFn : this.props.setOperatorOption,
            config: O,
            readonly: J
          });
          return /* @__PURE__ */ u.default.createElement(w.Col, {
            key: "op-options-for-" + this.props.selectedOperator,
            className: "rule--operator-options"
          }, le);
        }
      }, {
        key: "renderBeforeWidget",
        value: function() {
          var O = this.props.config, V = O.settings.renderBeforeWidget;
          return V && /* @__PURE__ */ u.default.createElement(w.Col, {
            key: "before-widget-for-" + this.props.selectedOperator,
            className: "rule--before-widget"
          }, typeof V == "function" ? V(this.props) : V);
        }
      }, {
        key: "renderAfterWidget",
        value: function() {
          var O = this.props.config, V = O.settings.renderAfterWidget;
          return V && /* @__PURE__ */ u.default.createElement(w.Col, {
            key: "after-widget-for-" + this.props.selectedOperator,
            className: "rule--after-widget"
          }, typeof V == "function" ? V(this.props) : V);
        }
      }, {
        key: "renderError",
        value: function() {
          var O = this.props, V = O.config, U = O.valueError, H = V.settings, J = H.renderRuleError, le = H.showErrorMessage, ae = U && U.toArray().filter(function(Y) {
            return !!Y;
          }).shift() || null;
          return le && ae && /* @__PURE__ */ u.default.createElement("div", {
            className: "rule--error"
          }, J ? J({
            error: ae
          }) : ae);
        }
      }, {
        key: "renderDrag",
        value: function() {
          var O = this.meta.showDragIcon;
          return O && /* @__PURE__ */ u.default.createElement("span", {
            key: "rule-drag-icon",
            className: "qb-drag-handler rule--drag-handler",
            onMouseDown: this.props.handleDraggerMouseDown
          }, /* @__PURE__ */ u.default.createElement(w.DragIcon, null), " ");
        }
      }, {
        key: "renderDel",
        value: function() {
          var O = this.props, V = O.config, U = O.isLocked, H = V.settings, J = H.deleteLabel, le = H.immutableGroupsMode, ae = H.renderButton, Y = H.canDeleteLocked;
          return !le && (!U || U && Y) && /* @__PURE__ */ u.default.createElement(ae, {
            type: "delRule",
            onClick: this.removeSelf,
            label: J,
            config: V
          });
        }
      }, {
        key: "renderLock",
        value: function() {
          var O = this.props, V = O.config, U = O.isLocked, H = O.isTrueLocked, J = O.id, le = V.settings, ae = le.lockLabel, Y = le.lockedLabel, re = le.showLock, ie = le.renderSwitch;
          return re && !(U && !H) && /* @__PURE__ */ u.default.createElement(ie, {
            type: "lock",
            id: J,
            value: U,
            setValue: this.setLock,
            label: ae,
            checkedLabel: Y,
            hideLabel: !0,
            config: V
          });
        }
      }, {
        key: "render",
        value: function() {
          var O = this.meta, V = O.showOperatorOptions, U = O.selectedFieldWidgetConfig, H = this.props, J = H.valueSrc, le = H.value, ae = H.config, Y = J.first() == "value" && !V && le.size == 1 && U.fullWidth, re = ae.settings.renderButtonGroup, ie = [this.renderField(), this.renderOperator(), this.renderBeforeWidget(), this.renderWidget(), this.renderAfterWidget(), this.renderOperatorOptions()], _e = /* @__PURE__ */ u.default.createElement("div", {
            key: "rule-body",
            className: E("rule--body", Y && "can--shrink--value")
          }, ie), he = this.renderError(), be = this.renderDrag(), Q = this.renderLock(), me = this.renderDel();
          return /* @__PURE__ */ u.default.createElement(u.default.Fragment, null, be, /* @__PURE__ */ u.default.createElement("div", {
            className: "rule--body--wrapper"
          }, _e, he), /* @__PURE__ */ u.default.createElement("div", {
            className: "rule--header"
          }, /* @__PURE__ */ u.default.createElement(re, {
            config: ae
          }, Q, me)));
        }
      }]), F;
    }(u.PureComponent), q.propTypes = {
      id: d.default.string.isRequired,
      groupId: d.default.string,
      selectedField: d.default.string,
      selectedOperator: d.default.string,
      operatorOptions: d.default.object,
      config: d.default.object.isRequired,
      value: d.default.any,
      //depends on widget
      valueSrc: d.default.any,
      asyncListValues: d.default.array,
      isDraggingMe: d.default.bool,
      isDraggingTempo: d.default.bool,
      parentField: d.default.string,
      //from RuleGroup
      valueError: d.default.any,
      isLocked: d.default.bool,
      isTrueLocked: d.default.bool,
      //path: PropTypes.instanceOf(Immutable.List),
      //actions
      handleDraggerMouseDown: d.default.func,
      setField: d.default.func,
      setOperator: d.default.func,
      setOperatorOption: d.default.func,
      setLock: d.default.func,
      removeSelf: d.default.func,
      setValue: d.default.func,
      setValueSrc: d.default.func,
      reordableNodesCnt: d.default.number
    }, q)) || M) || M) || M), k = x;
    e.default = k;
  }(cL)), cL;
}
var hL = {}, vL, Zne;
function mru() {
  if (Zne)
    return vL;
  Zne = 1;
  function e(t, n, o) {
    return t === t && (o !== void 0 && (t = t <= o ? t : o), n !== void 0 && (t = t >= n ? t : n)), t;
  }
  return vL = e, vL;
}
var bL, Xne;
function fru() {
  if (Xne)
    return bL;
  Xne = 1;
  var e = gye();
  function t(n) {
    var o = e(n), r = o % 1;
    return o === o ? r ? o - r : o : 0;
  }
  return bL = t, bL;
}
var yL, Jne;
function gru() {
  if (Jne)
    return yL;
  Jne = 1;
  var e = mru(), t = xve, n = fru(), o = Cve;
  function r(i, a, s) {
    return i = o(i), s = s == null ? 0 : e(n(s), 0, i.length), a = t(a), i.slice(s, s + a.length) == a;
  }
  return yL = r, yL;
}
var $L = {}, Qne;
function $1() {
  return Qne || (Qne = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(ki), r = t(Si), i = t(Hs()), a = t(Ei), s = t(xi()), c = t(oi()), l = $(Fe), u = t(Oa), d = t(p2()), _ = t(T2()), p = dc(), g = A2, f = kl();
    function h(N) {
      if (typeof WeakMap != "function")
        return null;
      var M = /* @__PURE__ */ new WeakMap(), q = /* @__PURE__ */ new WeakMap();
      return (h = function(R) {
        return R ? q : M;
      })(N);
    }
    function $(N, M) {
      if (!M && N && N.__esModule)
        return N;
      if (N === null || n(N) !== "object" && typeof N != "function")
        return { default: N };
      var q = h(M);
      if (q && q.has(N))
        return q.get(N);
      var L = {}, R = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var T in N)
        if (T !== "default" && Object.prototype.hasOwnProperty.call(N, T)) {
          var D = R ? Object.getOwnPropertyDescriptor(N, T) : null;
          D && (D.get || D.set) ? Object.defineProperty(L, T, D) : L[T] = N[T];
        }
      return L.default = N, q && q.set(N, L), L;
    }
    function v(N) {
      var M = b();
      return function() {
        var L = (0, c.default)(N), R;
        if (M) {
          var T = (0, c.default)(this).constructor;
          R = Reflect.construct(L, arguments, T);
        } else
          R = L.apply(this, arguments);
        return (0, s.default)(this, R);
      };
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var y = function(M) {
      var q;
      return q = /* @__PURE__ */ function(L) {
        (0, a.default)(T, L);
        var R = v(T);
        function T(D) {
          var A;
          return (0, o.default)(this, T), A = R.call(this, D), A._selectedConjunction = function(S) {
            return S = S || A.props, S.conjunction || (0, f.defaultGroupConjunction)(S.config, S.field);
          }, A.setConjunction = function() {
            var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            A.props.actions.setConjunction(A.props.path, S);
          }, A.setNot = function() {
            var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            A.props.actions.setNot(A.props.path, S);
          }, A.setLock = function() {
            var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            A.props.actions.setLock(A.props.path, S);
          }, A.dummyFn = function() {
          }, A.removeSelf = function() {
            A.props.actions.removeGroup(A.props.path);
          }, A.addGroup = function() {
            A.props.actions.addGroup(A.props.path);
          }, A.addCaseGroup = function() {
            A.props.actions.addCaseGroup(A.props.path);
          }, A.addDefaultCaseGroup = function() {
            A.props.actions.addDefaultCaseGroup(A.props.path);
          }, A.addRule = function() {
            A.props.actions.addRule(A.props.path);
          }, A.setField = function(S) {
            A.props.actions.setField(A.props.path, S);
          }, A.setOperator = function(S) {
            A.props.actions.setOperator(A.props.path, S);
          }, A.setValue = function(S, E, x) {
            A.props.actions.setValue(A.props.path, S, E, x);
          }, (0, p.useOnPropsChanged)((0, i.default)(A)), A.selectedConjunction = A._selectedConjunction(D), A.conjunctionOptions = A._getConjunctionOptions(D), A.dummyFn.isDummyFn = !0, A;
        }
        return (0, r.default)(T, [{
          key: "shouldComponentUpdate",
          value: function(A, S) {
            var E = this.props, x = this.state, k = (0, p.pureShouldComponentUpdate)(this)(A, S);
            if (k && x == S && E != A) {
              var I = A.dragging.id || E.dragging.id, z = I == A.id, F = [];
              for (var P in A) {
                var O = A[P] != E[P];
                P == "dragging" && !z && (O = !1), O && F.push(P);
              }
              F.length || (k = !1);
            }
            return k;
          }
        }, {
          key: "onPropsChanged",
          value: function(A) {
            var S = A.config;
            A.id;
            var E = A.conjunction, x = this.props.config, k = this.props.conjunction;
            (x != S || k != E) && (this.selectedConjunction = this._selectedConjunction(A), this.conjunctionOptions = this._getConjunctionOptions(A));
          }
        }, {
          key: "_getConjunctionOptions",
          value: function(A) {
            var S = this;
            return (0, d.default)(A.config.conjunctions, function(E, x) {
              return {
                id: "conjunction-".concat(A.id, "-").concat(x),
                name: "conjunction[".concat(A.id, "]"),
                key: x,
                label: E.label,
                checked: x === S._selectedConjunction(A)
              };
            });
          }
        }, {
          key: "render",
          value: function() {
            var A = this.props.dragging.id == this.props.id, S = this.props.path.size, E = this.props.config.settings.maxNesting, x = !A && this.props.isDraggingTempo, k = typeof E > "u" || S < E, I = S == 1;
            return /* @__PURE__ */ l.default.createElement("div", {
              className: "group-or-rule-container group-container",
              "data-id": this.props.id
            }, [A ? /* @__PURE__ */ l.default.createElement(M, {
              key: "dragging",
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: !0,
              isDraggingTempo: !0,
              dragging: this.props.dragging,
              isRoot: I,
              allowFurtherNesting: k,
              conjunctionOptions: this.conjunctionOptions,
              not: this.props.not,
              selectedConjunction: this.selectedConjunction,
              setConjunction: this.dummyFn,
              setNot: this.dummyFn,
              setLock: this.dummyFn,
              removeSelf: this.dummyFn,
              addGroup: this.dummyFn,
              addCaseGroup: this.dummyFn,
              addDefaultCaseGroup: this.dummyFn,
              addRule: this.dummyFn,
              setField: this.dummyFn,
              setOperator: this.dummyFn,
              setValue: this.dummyFn,
              value: this.props.value || null,
              config: this.props.config,
              children1: this.props.children1,
              actions: this.props.actions,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            }) : null, /* @__PURE__ */ l.default.createElement(M, {
              key: this.props.id,
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: A,
              isDraggingTempo: x,
              onDragStart: this.props.onDragStart,
              isRoot: I,
              allowFurtherNesting: k,
              conjunctionOptions: this.conjunctionOptions,
              not: this.props.not,
              selectedConjunction: this.selectedConjunction,
              setConjunction: x ? this.dummyFn : this.setConjunction,
              setNot: x ? this.dummyFn : this.setNot,
              setLock: x ? this.dummyFn : this.setLock,
              removeSelf: x ? this.dummyFn : this.removeSelf,
              addGroup: x ? this.dummyFn : this.addGroup,
              addCaseGroup: x ? this.dummyFn : this.addCaseGroup,
              addDefaultCaseGroup: x ? this.dummyFn : this.addDefaultCaseGroup,
              addRule: x ? this.dummyFn : this.addRule,
              setField: x ? this.dummyFn : this.setField,
              setOperator: x ? this.dummyFn : this.setOperator,
              setValue: x ? this.dummyFn : this.setValue,
              value: this.props.value || null,
              config: this.props.config,
              children1: this.props.children1,
              actions: this.props.actions,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            })]);
          }
        }]), T;
      }(l.Component), q.propTypes = {
        //tree: PropTypes.instanceOf(Immutable.Map).isRequired,
        config: u.default.object.isRequired,
        actions: u.default.object.isRequired,
        //{setConjunction: Funciton, removeGroup, addGroup, addRule, ...}
        path: u.default.any.isRequired,
        //instanceOf(Immutable.List)
        id: u.default.string.isRequired,
        groupId: u.default.string,
        not: u.default.bool,
        conjunction: u.default.string,
        children1: u.default.any,
        //instanceOf(Immutable.OrderedMap)
        onDragStart: u.default.func,
        reordableNodesCnt: u.default.number,
        field: u.default.string,
        // for RuleGroup
        parentField: u.default.string,
        //from RuleGroup
        isLocked: u.default.bool,
        isTrueLocked: u.default.bool,
        //connected:
        dragging: u.default.object,
        //{id, x, y, w, h}
        isDraggingTempo: u.default.bool
      }, q;
    }, w = function(M) {
      var q = (0, g.connect)(function(L) {
        return {
          dragging: L.dragging
        };
      }, null, null, {
        context: _.default
      })(y(M));
      return q.displayName = "ConnectedGroupContainer", q;
    };
    e.default = w;
  }($L)), $L;
}
var hw = {}, eoe;
function k$e() {
  if (eoe)
    return hw;
  eoe = 1;
  var e = Tn, t = xo;
  Object.defineProperty(hw, "__esModule", {
    value: !0
  }), hw.GroupActions = void 0;
  var n = e(ki), o = e(Si), r = e(Ei), i = e(xi()), a = e(oi()), s = l(Fe);
  function c(f) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
    return (c = function(b) {
      return b ? $ : h;
    })(f);
  }
  function l(f, h) {
    if (!h && f && f.__esModule)
      return f;
    if (f === null || t(f) !== "object" && typeof f != "function")
      return { default: f };
    var $ = c(h);
    if ($ && $.has(f))
      return $.get(f);
    var v = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in f)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(f, y)) {
        var w = b ? Object.getOwnPropertyDescriptor(f, y) : null;
        w && (w.get || w.set) ? Object.defineProperty(v, y, w) : v[y] = f[y];
      }
    return v.default = f, $ && $.set(f, v), v;
  }
  function u(f) {
    var h = d();
    return function() {
      var v = (0, a.default)(f), b;
      if (h) {
        var y = (0, a.default)(this).constructor;
        b = Reflect.construct(v, arguments, y);
      } else
        b = v.apply(this, arguments);
      return (0, i.default)(this, b);
    };
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = {
    topLeft: "group--actions--tl",
    topCenter: "group--actions--tc",
    topRight: "group--actions--tr",
    bottomLeft: "group--actions--bl",
    bottomCenter: "group--actions--bc",
    bottomRight: "group--actions--br"
  }, p = "topRight", g = /* @__PURE__ */ function(f) {
    (0, r.default)($, f);
    var h = u($);
    function $() {
      return (0, n.default)(this, $), h.apply(this, arguments);
    }
    return (0, o.default)($, [{
      key: "render",
      value: function() {
        var b = this.props, y = b.config, w = b.addRule, N = b.addGroup, M = b.removeSelf, q = b.setLock, L = b.isLocked, R = b.isTrueLocked, T = b.id, D = b.canAddGroup, A = b.canAddRule, S = b.canDeleteGroup, E = y.settings, x = E.immutableGroupsMode, k = E.addRuleLabel, I = E.addGroupLabel, z = E.delGroupLabel, F = E.groupActionsPosition, P = E.renderButton, O = E.renderSwitch, V = E.renderButtonGroup, U = E.lockLabel, H = E.lockedLabel, J = E.showLock, le = E.canDeleteLocked, ae = _[F || p], Y = J && !(L && !R) && /* @__PURE__ */ s.default.createElement(O, {
          type: "lock",
          id: T,
          value: L,
          setValue: q,
          label: U,
          checkedLabel: H,
          config: y
        }), re = !x && A && !L && /* @__PURE__ */ s.default.createElement(P, {
          type: "addRule",
          onClick: w,
          label: k,
          readonly: L,
          config: y
        }), ie = !x && D && !L && /* @__PURE__ */ s.default.createElement(P, {
          type: "addGroup",
          onClick: N,
          label: I,
          readonly: L,
          config: y
        }), _e = !x && S && (!L || L && le) && /* @__PURE__ */ s.default.createElement(P, {
          type: "delGroup",
          onClick: M,
          label: z,
          config: y
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions ".concat(ae)
        }, /* @__PURE__ */ s.default.createElement(V, {
          config: y
        }, Y, re, ie, _e));
      }
    }]), $;
  }(s.PureComponent);
  return hw.GroupActions = g, hw;
}
var toe;
function w1() {
  return toe || (toe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.BasicGroup = void 0;
    var o = t(Ys), r = t(Yr()), i = t(ki), a = t(Si), s = t(Hs()), c = t(Ei), l = t(xi()), u = t(oi()), d = y(Fe), _ = t(Oa), p = t(gru()), g = t($1()), f = t(y$()), h = S$e(), $ = k$e(), v = im();
    function b(A) {
      if (typeof WeakMap != "function")
        return null;
      var S = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
      return (b = function(k) {
        return k ? E : S;
      })(A);
    }
    function y(A, S) {
      if (!S && A && A.__esModule)
        return A;
      if (A === null || n(A) !== "object" && typeof A != "function")
        return { default: A };
      var E = b(S);
      if (E && E.has(A))
        return E.get(A);
      var x = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var I in A)
        if (I !== "default" && Object.prototype.hasOwnProperty.call(A, I)) {
          var z = k ? Object.getOwnPropertyDescriptor(A, I) : null;
          z && (z.get || z.set) ? Object.defineProperty(x, I, z) : x[I] = A[I];
        }
      return x.default = A, E && E.set(A, x), x;
    }
    function w(A, S) {
      var E = Object.keys(A);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(A);
        S && (x = x.filter(function(k) {
          return Object.getOwnPropertyDescriptor(A, k).enumerable;
        })), E.push.apply(E, x);
      }
      return E;
    }
    function N(A) {
      for (var S = 1; S < arguments.length; S++) {
        var E = arguments[S] != null ? arguments[S] : {};
        S % 2 ? w(Object(E), !0).forEach(function(x) {
          (0, r.default)(A, x, E[x]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(E)) : w(Object(E)).forEach(function(x) {
          Object.defineProperty(A, x, Object.getOwnPropertyDescriptor(E, x));
        });
      }
      return A;
    }
    function M(A) {
      var S = q();
      return function() {
        var x = (0, u.default)(A), k;
        if (S) {
          var I = (0, u.default)(this).constructor;
          k = Reflect.construct(x, arguments, I);
        } else
          k = x.apply(this, arguments);
        return (0, l.default)(this, k);
      };
    }
    function q() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var L = jg, R = "topRight", T = /* @__PURE__ */ function(A) {
      (0, c.default)(E, A);
      var S = M(E);
      function E(x) {
        var k;
        return (0, i.default)(this, E), k = S.call(this, x), k.childrenClassName = function() {
          return "";
        }, k.renderBeforeActions = function() {
          var I = k.props.config.settings.renderBeforeActions;
          return I == null ? null : typeof I == "function" ? /* @__PURE__ */ d.default.createElement(I, k.props) : I;
        }, k.renderAfterActions = function() {
          var I = k.props.config.settings.renderAfterActions;
          return I == null ? null : typeof I == "function" ? /* @__PURE__ */ d.default.createElement(I, k.props) : I;
        }, k.removeSelf = k.removeSelf.bind((0, s.default)(k)), k.setLock = k.setLock.bind((0, s.default)(k)), k.renderItem = k.renderItem.bind((0, s.default)(k)), k;
      }
      return (0, a.default)(E, [{
        key: "isGroupTopPosition",
        value: function() {
          return (0, p.default)(this.props.config.settings.groupActionsPosition || R, "top");
        }
      }, {
        key: "setLock",
        value: function(k) {
          this.props.setLock(k);
        }
      }, {
        key: "removeSelf",
        value: function() {
          var k = this, I = this.props.confirmFn, z = this.props.config.settings, F = z.renderConfirm, P = z.removeGroupConfirmOptions, O = function() {
            k.props.removeSelf();
          };
          P && !this.isEmptyCurrentGroup() ? F(N(N({}, P), {}, {
            onOk: O,
            onCancel: null,
            confirmFn: I
          })) : O();
        }
      }, {
        key: "isEmptyCurrentGroup",
        value: function() {
          var k = this.props.children1;
          return !k || k.size == 0 || k.size == 1 && this.isEmpty(k.first());
        }
      }, {
        key: "isEmpty",
        value: function(k) {
          var I = k.get("type") == "group" || k.get("type") == "rule_group";
          return I ? this.isEmptyGroup(k) : this.isEmptyRule(k);
        }
      }, {
        key: "isEmptyGroup",
        value: function(k) {
          var I = k.get("children1");
          return !I || I.size == 0 || I.size == 1 && this.isEmpty(I.first());
        }
      }, {
        key: "isEmptyRule",
        value: function(k) {
          var I = k.get("properties");
          return !(I.get("field") !== null && I.get("operator") !== null && I.get("value").filter(function(z) {
            return z !== void 0;
          }).size > 0);
        }
      }, {
        key: "render",
        value: function() {
          return /* @__PURE__ */ d.default.createElement(d.default.Fragment, null, this.renderHeaderWrapper(), this.renderChildrenWrapper(), this.renderFooterWrapper());
        }
      }, {
        key: "showNot",
        value: function() {
          var k = this.props.config;
          return k.settings.showNot;
        }
        // show conjs for 2+ children?
      }, {
        key: "showConjs",
        value: function() {
          var k = this.props, I = k.conjunctionOptions;
          k.children1, k.config;
          var z = Object.keys(I).length;
          return z > 1 || this.showNot();
        }
      }, {
        key: "isOneChild",
        value: function() {
          var k = this.props.children1;
          return k ? k.size < 2 : !0;
        }
      }, {
        key: "renderChildrenWrapper",
        value: function() {
          var k = this.props.children1;
          return k && /* @__PURE__ */ d.default.createElement("div", {
            key: "group-children",
            className: L("group--children", this.showConjs() ? "" : "hide--conjs", this.isOneChild() ? "hide--line" : "", this.isOneChild() ? "one--child" : "", this.childrenClassName())
          }, this.renderChildren());
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          var k = this.isGroupTopPosition();
          return /* @__PURE__ */ d.default.createElement("div", {
            key: "group-header",
            className: L("group--header", this.isOneChild() ? "one--child" : "")
          }, this.renderHeader(), k && this.renderBeforeActions(), k && this.renderActions(), k && this.renderAfterActions());
        }
      }, {
        key: "renderFooterWrapper",
        value: function() {
          var k = this.isGroupTopPosition();
          return !k && /* @__PURE__ */ d.default.createElement("div", {
            key: "group-footer",
            className: "group--footer"
          }, this.renderBeforeActions(), this.renderActions(), this.renderAfterActions());
        }
      }, {
        key: "renderActions",
        value: function() {
          var k = this.props, I = k.config, z = k.addRule, F = k.addGroup, P = k.isLocked, O = k.isTrueLocked, V = k.id;
          return /* @__PURE__ */ d.default.createElement($.GroupActions, {
            config: I,
            addRule: z,
            addGroup: F,
            canAddGroup: this.canAddGroup(),
            canAddRule: this.canAddRule(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: P,
            isTrueLocked: O,
            id: V
          });
        }
      }, {
        key: "canAddGroup",
        value: function() {
          return this.props.allowFurtherNesting;
        }
      }, {
        key: "canAddRule",
        value: function() {
          var k = this.props.config.settings.maxNumberOfRules, I = this.props.totalRulesCnt;
          return k ? I < k : !0;
        }
      }, {
        key: "canDeleteGroup",
        value: function() {
          return !this.props.isRoot;
        }
      }, {
        key: "renderChildren",
        value: function() {
          var k = this.props.children1;
          return k ? k.map(this.renderItem).toList() : null;
        }
      }, {
        key: "renderItem",
        value: function(k) {
          var I = this.props, z = I.config, F = I.actions, P = I.onDragStart, O = I.isLocked, V = k.get("type") == "group" && k.getIn(["properties", "field"]) != null, U = V ? "rule_group" : k.get("type");
          return /* @__PURE__ */ d.default.createElement(h.Item, (0, o.default)({}, this.extraPropsForItem(k), {
            key: k.get("id"),
            id: k.get("id"),
            groupId: I.id,
            path: k.get("path"),
            type: U,
            properties: k.get("properties"),
            config: z,
            actions: F,
            children1: k.get("children1"),
            reordableNodesCnt: this.reordableNodesCntForItem(k),
            totalRulesCnt: this.totalRulesCntForItem(k),
            parentReordableNodesCnt: this.reordableNodesCnt(),
            onDragStart: P,
            isDraggingTempo: this.props.isDraggingTempo,
            isParentLocked: O
          }));
        }
      }, {
        key: "extraPropsForItem",
        value: function(k) {
          return {};
        }
      }, {
        key: "reordableNodesCnt",
        value: function() {
          return this.props.isLocked ? 0 : this.props.reordableNodesCnt;
        }
      }, {
        key: "totalRulesCntForItem",
        value: function(k) {
          return this.props.totalRulesCnt;
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(k) {
          return this.props.isLocked ? 0 : this.reordableNodesCnt();
        }
      }, {
        key: "showDragIcon",
        value: function() {
          var k = this.props, I = k.config, z = k.isRoot, F = k.isLocked, P = this.reordableNodesCnt();
          return I.settings.canReorder && !z && P > 1 && !F;
        }
      }, {
        key: "renderDrag",
        value: function() {
          var k = this.props.handleDraggerMouseDown, I = this.showDragIcon() && /* @__PURE__ */ d.default.createElement("span", {
            key: "group-drag-icon",
            className: "qb-drag-handler group--drag-handler",
            onMouseDown: k
          }, /* @__PURE__ */ d.default.createElement(v.DragIcon, null), " ");
          return I;
        }
      }, {
        key: "conjunctionOptions",
        value: function() {
          var k = this.props.conjunctionOptions;
          return k;
        }
      }, {
        key: "renderConjs",
        value: function() {
          var k = this.props, I = k.config, z = k.children1, F = k.id, P = k.selectedConjunction, O = k.setConjunction, V = k.not, U = k.setNot, H = k.isLocked, J = I.settings, le = J.immutableGroupsMode, ae = J.renderConjs;
          J.showNot;
          var Y = J.notLabel, re = this.conjunctionOptions();
          if (!this.showConjs() || !z || !z.size)
            return null;
          var ie = {
            disabled: this.isOneChild(),
            readonly: le || H,
            selectedConjunction: P,
            setConjunction: le ? v.dummyFn : O,
            conjunctionOptions: re,
            config: I,
            not: V || !1,
            id: F,
            setNot: le ? v.dummyFn : U,
            notLabel: Y,
            showNot: this.showNot(),
            isLocked: H
          };
          return /* @__PURE__ */ d.default.createElement(ae, ie);
        }
      }, {
        key: "renderHeader",
        value: function() {
          return /* @__PURE__ */ d.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }]), E;
    }(d.PureComponent);
    e.BasicGroup = T, T.propTypes = {
      //tree: PropTypes.instanceOf(Immutable.Map).isRequired,
      reordableNodesCnt: _.default.number,
      conjunctionOptions: _.default.object.isRequired,
      allowFurtherNesting: _.default.bool.isRequired,
      isRoot: _.default.bool.isRequired,
      not: _.default.bool,
      selectedConjunction: _.default.string,
      config: _.default.object.isRequired,
      id: _.default.string.isRequired,
      groupId: _.default.string,
      path: _.default.any,
      //instanceOf(Immutable.List)
      children1: _.default.any,
      //instanceOf(Immutable.OrderedMap)
      isDraggingMe: _.default.bool,
      isDraggingTempo: _.default.bool,
      isLocked: _.default.bool,
      isTrueLocked: _.default.bool,
      //actions
      handleDraggerMouseDown: _.default.func,
      onDragStart: _.default.func,
      addRule: _.default.func.isRequired,
      addGroup: _.default.func.isRequired,
      removeSelf: _.default.func.isRequired,
      setConjunction: _.default.func.isRequired,
      setNot: _.default.func.isRequired,
      setLock: _.default.func.isRequired,
      actions: _.default.object.isRequired
    };
    var D = (0, g.default)((0, f.default)("group")((0, v.ConfirmFn)(T)));
    e.default = D;
  }(hL)), hL;
}
var wL = {}, kL = { exports: {} }, SL = { exports: {} }, noe;
function hru() {
  return noe || (noe = 1, function(e) {
    var t = oi();
    function n(o, r) {
      for (; !Object.prototype.hasOwnProperty.call(o, r) && (o = t(o), o !== null); )
        ;
      return o;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(SL)), SL.exports;
}
var ooe;
function BV() {
  return ooe || (ooe = 1, function(e) {
    var t = hru();
    function n() {
      return typeof Reflect < "u" && Reflect.get ? (e.exports = n = Reflect.get.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = n = function(r, i, a) {
        var s = t(r, i);
        if (s) {
          var c = Object.getOwnPropertyDescriptor(s, i);
          return c.get ? c.get.call(arguments.length < 3 ? r : a) : c.value;
        }
      }, e.exports.__esModule = !0, e.exports.default = e.exports), n.apply(this, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(kL)), kL.exports;
}
var vw = {}, roe;
function vru() {
  if (roe)
    return vw;
  roe = 1;
  var e = Tn, t = xo;
  Object.defineProperty(vw, "__esModule", {
    value: !0
  }), vw.RuleGroupActions = void 0;
  var n = e(ki), o = e(Si), r = e(Ei), i = e(xi()), a = e(oi()), s = l(Fe);
  function c(p) {
    if (typeof WeakMap != "function")
      return null;
    var g = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (c = function($) {
      return $ ? f : g;
    })(p);
  }
  function l(p, g) {
    if (!g && p && p.__esModule)
      return p;
    if (p === null || t(p) !== "object" && typeof p != "function")
      return { default: p };
    var f = c(g);
    if (f && f.has(p))
      return f.get(p);
    var h = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in p)
      if (v !== "default" && Object.prototype.hasOwnProperty.call(p, v)) {
        var b = $ ? Object.getOwnPropertyDescriptor(p, v) : null;
        b && (b.get || b.set) ? Object.defineProperty(h, v, b) : h[v] = p[v];
      }
    return h.default = p, f && f.set(p, h), h;
  }
  function u(p) {
    var g = d();
    return function() {
      var h = (0, a.default)(p), $;
      if (g) {
        var v = (0, a.default)(this).constructor;
        $ = Reflect.construct(h, arguments, v);
      } else
        $ = h.apply(this, arguments);
      return (0, i.default)(this, $);
    };
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = /* @__PURE__ */ function(p) {
    (0, r.default)(f, p);
    var g = u(f);
    function f() {
      return (0, n.default)(this, f), g.apply(this, arguments);
    }
    return (0, o.default)(f, [{
      key: "render",
      value: function() {
        var $ = this.props, v = $.config, b = $.addRule, y = $.canAddRule, w = $.canDeleteGroup, N = $.removeSelf, M = $.setLock, q = $.isLocked, L = $.isTrueLocked, R = $.id, T = v.settings, D = T.immutableGroupsMode, A = T.addRuleLabel, S = T.delGroupLabel, E = T.renderButton, x = T.renderSwitch, k = T.renderButtonGroup, I = T.lockLabel, z = T.lockedLabel, F = T.showLock, P = T.canDeleteLocked, O = F && !(q && !L) && /* @__PURE__ */ s.default.createElement(x, {
          type: "lock",
          id: R,
          value: q,
          setValue: M,
          label: I,
          checkedLabel: z,
          hideLabel: !0,
          config: v
        }), V = !D && y && !q && /* @__PURE__ */ s.default.createElement(E, {
          type: "addRuleGroup",
          onClick: b,
          label: A,
          readonly: q,
          config: v
        }), U = !D && w && (!q || q && P) && /* @__PURE__ */ s.default.createElement(E, {
          type: "delRuleGroup",
          onClick: N,
          label: S,
          config: v
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions"
        }, /* @__PURE__ */ s.default.createElement(k, {
          config: v
        }, O, V, U));
      }
    }]), f;
  }(s.PureComponent);
  return vw.RuleGroupActions = _, vw;
}
var ioe;
function bru() {
  return ioe || (ioe = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Yr()), o = t(ki), r = t(Si), i = t(Hs()), a = t(BV()), s = t(Ei), c = t(xi()), l = t(oi()), u = t(Fe), d = t(Oa), _ = t($1()), p = t(y$()), g = w1(), f = vru(), h = t(VV()), $ = dc(), v = im(), b, y, w;
    function N(D, A) {
      var S = Object.keys(D);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(D);
        A && (E = E.filter(function(x) {
          return Object.getOwnPropertyDescriptor(D, x).enumerable;
        })), S.push.apply(S, E);
      }
      return S;
    }
    function M(D) {
      for (var A = 1; A < arguments.length; A++) {
        var S = arguments[A] != null ? arguments[A] : {};
        A % 2 ? N(Object(S), !0).forEach(function(E) {
          (0, n.default)(D, E, S[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(S)) : N(Object(S)).forEach(function(E) {
          Object.defineProperty(D, E, Object.getOwnPropertyDescriptor(S, E));
        });
      }
      return D;
    }
    function q(D) {
      var A = L();
      return function() {
        var E = (0, l.default)(D), x;
        if (A) {
          var k = (0, l.default)(this).constructor;
          x = Reflect.construct(E, arguments, k);
        } else
          x = E.apply(this, arguments);
        return (0, c.default)(this, x);
      };
    }
    function L() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var R = (b = (0, p.default)("group rule_group"), (0, _.default)(y = b(y = (0, v.ConfirmFn)(y = (w = /* @__PURE__ */ function(D) {
      (0, s.default)(S, D);
      var A = q(S);
      function S(E) {
        var x;
        return (0, o.default)(this, S), x = A.call(this, E), x.childrenClassName = function() {
          return "rule_group--children";
        }, x.renderHeaderWrapper = function() {
          return null;
        }, x.renderFooterWrapper = function() {
          return null;
        }, x.renderConjs = function() {
          return null;
        }, x.canAddGroup = function() {
          return !1;
        }, x.canAddRule = function() {
          return !0;
        }, x.canDeleteGroup = function() {
          return !1;
        }, (0, $.useOnPropsChanged)((0, i.default)(x)), x.onPropsChanged(E), x;
      }
      return (0, r.default)(S, [{
        key: "onPropsChanged",
        value: function(x) {
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(x) {
          if (this.props.isLocked)
            return 0;
          var k = this.props.children1;
          return k.size;
        }
      }, {
        key: "renderChildrenWrapper",
        value: function() {
          return /* @__PURE__ */ u.default.createElement(u.default.Fragment, null, this.renderDrag(), this.renderField(), this.renderActions(), (0, a.default)((0, l.default)(S.prototype), "renderChildrenWrapper", this).call(this));
        }
      }, {
        key: "renderField",
        value: function() {
          var x = this.props, k = x.config, I = x.selectedField, z = x.setField, F = x.parentField, P = x.id, O = x.groupId, V = x.isLocked, U = k.settings.immutableFieldsMode;
          return /* @__PURE__ */ u.default.createElement(h.default, {
            key: "field",
            classname: "group--field",
            config: k,
            selectedField: I,
            setField: z,
            parentField: F,
            readonly: U || V,
            id: P,
            groupId: O
          });
        }
      }, {
        key: "renderActions",
        value: function() {
          var x = this.props, k = x.config, I = x.addRule, z = x.isLocked, F = x.isTrueLocked, P = x.id;
          return /* @__PURE__ */ u.default.createElement(f.RuleGroupActions, {
            config: k,
            addRule: I,
            canAddRule: this.canAddRule(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: z,
            isTrueLocked: F,
            id: P
          });
        }
      }, {
        key: "extraPropsForItem",
        value: function(x) {
          return {
            parentField: this.props.selectedField
          };
        }
      }]), S;
    }(g.BasicGroup), w.propTypes = M(M({}, g.BasicGroup.propTypes), {}, {
      selectedField: d.default.string,
      parentField: d.default.string,
      setField: d.default.func
    }), w)) || y) || y) || y), T = R;
    e.default = T;
  }(wL)), wL;
}
var EL = {}, bw = {}, aoe;
function yru() {
  if (aoe)
    return bw;
  aoe = 1;
  var e = Tn, t = xo;
  Object.defineProperty(bw, "__esModule", {
    value: !0
  }), bw.RuleGroupExtActions = void 0;
  var n = e(ki), o = e(Si), r = e(Ei), i = e(xi()), a = e(oi()), s = l(Fe);
  function c(p) {
    if (typeof WeakMap != "function")
      return null;
    var g = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (c = function($) {
      return $ ? f : g;
    })(p);
  }
  function l(p, g) {
    if (!g && p && p.__esModule)
      return p;
    if (p === null || t(p) !== "object" && typeof p != "function")
      return { default: p };
    var f = c(g);
    if (f && f.has(p))
      return f.get(p);
    var h = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in p)
      if (v !== "default" && Object.prototype.hasOwnProperty.call(p, v)) {
        var b = $ ? Object.getOwnPropertyDescriptor(p, v) : null;
        b && (b.get || b.set) ? Object.defineProperty(h, v, b) : h[v] = p[v];
      }
    return h.default = p, f && f.set(p, h), h;
  }
  function u(p) {
    var g = d();
    return function() {
      var h = (0, a.default)(p), $;
      if (g) {
        var v = (0, a.default)(this).constructor;
        $ = Reflect.construct(h, arguments, v);
      } else
        $ = h.apply(this, arguments);
      return (0, i.default)(this, $);
    };
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = /* @__PURE__ */ function(p) {
    (0, r.default)(f, p);
    var g = u(f);
    function f() {
      return (0, n.default)(this, f), g.apply(this, arguments);
    }
    return (0, o.default)(f, [{
      key: "render",
      value: function() {
        var $ = this.props, v = $.config, b = $.addRule, y = $.canAddRule, w = $.canDeleteGroup, N = $.removeSelf, M = $.setLock, q = $.isLocked, L = $.isTrueLocked, R = $.id, T = v.settings, D = T.immutableGroupsMode, A = T.addSubRuleLabel, S = T.delGroupLabel, E = T.renderButton, x = T.renderSwitch, k = T.renderButtonGroup, I = T.lockLabel, z = T.lockedLabel, F = T.showLock, P = T.canDeleteLocked, O = F && !(q && !L) && /* @__PURE__ */ s.default.createElement(x, {
          type: "lock",
          id: R,
          value: q,
          setValue: M,
          label: I,
          checkedLabel: z,
          config: v
        }), V = !D && y && !q && /* @__PURE__ */ s.default.createElement(E, {
          type: "addRuleGroupExt",
          onClick: b,
          label: A,
          readonly: q,
          config: v
        }), U = !D && w && (!q || q && P) && /* @__PURE__ */ s.default.createElement(E, {
          type: "delRuleGroup",
          onClick: N,
          label: S,
          config: v
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions group--actions--tr"
        }, /* @__PURE__ */ s.default.createElement(k, {
          config: v
        }, O, V, U));
      }
    }]), f;
  }(s.PureComponent);
  return bw.RuleGroupExtActions = _, bw;
}
var soe;
function $ru() {
  return soe || (soe = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Yr()), o = t(ki), r = t(Si), i = t(Hs()), a = t(BV()), s = t(Ei), c = t(xi()), l = t(oi()), u = t(Fe), d = t(Oa), _ = t($1()), p = t(y$()), g = w1(), f = yru(), h = t(VV()), $ = t(w$e()), v = dc(), b = im(), y = Qi(), w = t(f2()), N, M, q;
    function L(z, F) {
      var P = Object.keys(z);
      if (Object.getOwnPropertySymbols) {
        var O = Object.getOwnPropertySymbols(z);
        F && (O = O.filter(function(V) {
          return Object.getOwnPropertyDescriptor(z, V).enumerable;
        })), P.push.apply(P, O);
      }
      return P;
    }
    function R(z) {
      for (var F = 1; F < arguments.length; F++) {
        var P = arguments[F] != null ? arguments[F] : {};
        F % 2 ? L(Object(P), !0).forEach(function(O) {
          (0, n.default)(z, O, P[O]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(z, Object.getOwnPropertyDescriptors(P)) : L(Object(P)).forEach(function(O) {
          Object.defineProperty(z, O, Object.getOwnPropertyDescriptor(P, O));
        });
      }
      return z;
    }
    function T(z, F) {
      var P = typeof Symbol < "u" && z[Symbol.iterator] || z["@@iterator"];
      if (!P) {
        if (Array.isArray(z) || (P = D(z)) || F && z && typeof z.length == "number") {
          P && (z = P);
          var O = 0, V = function() {
          };
          return { s: V, n: function() {
            return O >= z.length ? { done: !0 } : { done: !1, value: z[O++] };
          }, e: function(ae) {
            throw ae;
          }, f: V };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var U = !0, H = !1, J;
      return { s: function() {
        P = P.call(z);
      }, n: function() {
        var ae = P.next();
        return U = ae.done, ae;
      }, e: function(ae) {
        H = !0, J = ae;
      }, f: function() {
        try {
          !U && P.return != null && P.return();
        } finally {
          if (H)
            throw J;
        }
      } };
    }
    function D(z, F) {
      if (z) {
        if (typeof z == "string")
          return A(z, F);
        var P = Object.prototype.toString.call(z).slice(8, -1);
        if (P === "Object" && z.constructor && (P = z.constructor.name), P === "Map" || P === "Set")
          return Array.from(z);
        if (P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P))
          return A(z, F);
      }
    }
    function A(z, F) {
      (F == null || F > z.length) && (F = z.length);
      for (var P = 0, O = new Array(F); P < F; P++)
        O[P] = z[P];
      return O;
    }
    function S(z) {
      var F = E();
      return function() {
        var O = (0, l.default)(z), V;
        if (F) {
          var U = (0, l.default)(this).constructor;
          V = Reflect.construct(O, arguments, U);
        } else
          V = O.apply(this, arguments);
        return (0, c.default)(this, V);
      };
    }
    function E() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var x = jg, k = (N = (0, p.default)("group rule_group_ext"), (0, _.default)(M = N(M = (0, b.ConfirmFn)(M = (q = /* @__PURE__ */ function(z) {
      (0, s.default)(P, z);
      var F = S(P);
      function P(O) {
        var V;
        return (0, o.default)(this, P), V = F.call(this, O), V.childrenClassName = function() {
          return "rule_group_ext--children";
        }, V.renderFooterWrapper = function() {
          return null;
        }, V.canAddGroup = function() {
          return !1;
        }, V.canAddRule = function() {
          return !0;
        }, V.canDeleteGroup = function() {
          return !0;
        }, (0, v.useOnPropsChanged)((0, i.default)(V)), V.onPropsChanged(O), V;
      }
      return (0, r.default)(P, [{
        key: "onPropsChanged",
        value: function(V) {
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          return /* @__PURE__ */ u.default.createElement("div", {
            key: "group-header",
            className: x("group--header", this.isOneChild() ? "one--child" : "", this.showDragIcon() ? "with--drag" : "hide--drag", this.showConjs() && (!this.isOneChild() || this.showNot()) ? "with--conjs" : "hide--conjs")
          }, this.renderHeader(), this.renderGroupField(), this.renderActions());
        }
      }, {
        key: "renderHeader",
        value: function() {
          return /* @__PURE__ */ u.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }, {
        key: "renderGroupField",
        value: function() {
          return /* @__PURE__ */ u.default.createElement("div", {
            className: "group--field--count--rule"
          }, this.renderField(), this.renderOperator(), this.renderWidget());
        }
      }, {
        key: "showNot",
        value: function() {
          var V = this.props, U = V.config, H = V.selectedField;
          V.selectedOperator;
          var J = (0, y.getFieldConfig)(U, H) || {};
          return J.showNot != null ? J.showNot : U.settings.showNot;
        }
      }, {
        key: "conjunctionOptions",
        value: function() {
          var V = this.props, U = V.config, H = V.selectedField;
          V.selectedOperator;
          var J = (0, y.getFieldConfig)(U, H) || {}, le = (0, a.default)((0, l.default)(P.prototype), "conjunctionOptions", this).call(this);
          if (J.conjunctions) {
            var ae = {}, Y = T(J.conjunctions), re;
            try {
              for (Y.s(); !(re = Y.n()).done; ) {
                var ie = re.value;
                ae[ie] = le[ie];
              }
            } catch (_e) {
              Y.e(_e);
            } finally {
              Y.f();
            }
            le = ae;
          }
          return le;
        }
      }, {
        key: "renderField",
        value: function() {
          var V = this.props, U = V.config, H = V.selectedField, J = V.setField, le = V.parentField, ae = V.id, Y = V.groupId, re = V.isLocked, ie = U.settings.immutableFieldsMode;
          return /* @__PURE__ */ u.default.createElement(h.default, {
            key: "field",
            classname: "rule--field",
            config: U,
            selectedField: H,
            setField: J,
            parentField: le,
            readonly: ie || re,
            id: ae,
            groupId: Y
          });
        }
      }, {
        key: "renderOperator",
        value: function() {
          var V = this.props, U = V.config, H = V.selectedField, J = V.selectedOperator, le = V.setField, ae = V.setOperator, Y = V.isLocked, re = U.settings.immutableFieldsMode, ie = (0, y.getFieldWidgetConfig)(U, H, J) || {}, _e = ie.hideOperator, he = H && _e && ie.operatorInlineLabel, be = H && !_e;
          return /* @__PURE__ */ u.default.createElement($.default, {
            key: "operator",
            classname: "group--operator",
            config: U,
            selectedField: H,
            selectedOperator: J,
            setField: le,
            setOperator: ae,
            selectedFieldPartsLabels: ["group"],
            showOperator: be,
            showOperatorLabel: he,
            selectedFieldWidgetConfig: ie,
            readonly: re || Y,
            id: this.props.id,
            groupId: this.props.groupId
          });
        }
      }, {
        key: "renderWidget",
        value: function() {
          var V = this.props, U = V.config, H = V.selectedField, J = V.selectedOperator, le = V.isLocked, ae = U.settings.immutableValuesMode, Y = H && J, re = Y;
          if (!re)
            return null;
          var ie = /* @__PURE__ */ u.default.createElement(w.default, {
            key: "values",
            isForRuleGruop: !0,
            field: this.props.selectedField,
            operator: this.props.selectedOperator,
            value: this.props.value,
            valueSrc: "value",
            valueError: null,
            config: U,
            setValue: ae ? b.dummyFn : this.props.setValue,
            setValueSrc: b.dummyFn,
            readonly: ae || le,
            id: this.props.id,
            groupId: this.props.groupId
          });
          return /* @__PURE__ */ u.default.createElement(b.Col, {
            key: "widget-for-" + this.props.selectedOperator,
            className: "rule--value"
          }, ie);
        }
      }, {
        key: "renderActions",
        value: function() {
          var V = this.props, U = V.config, H = V.addRule, J = V.isLocked, le = V.isTrueLocked, ae = V.id;
          return /* @__PURE__ */ u.default.createElement(f.RuleGroupExtActions, {
            config: U,
            addRule: H,
            canAddRule: this.canAddRule(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: J,
            isTrueLocked: le,
            id: ae
          });
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(V) {
          if (this.props.isLocked)
            return 0;
          var U = this.props.children1;
          return U.size;
        }
      }, {
        key: "extraPropsForItem",
        value: function(V) {
          return {
            parentField: this.props.selectedField
          };
        }
      }]), P;
    }(g.BasicGroup), q.propTypes = R(R({}, g.BasicGroup.propTypes), {}, {
      selectedField: d.default.string,
      selectedOperator: d.default.string,
      value: d.default.any,
      parentField: d.default.string,
      setField: d.default.func,
      setOperator: d.default.func,
      setValue: d.default.func
    }), q)) || M) || M) || M), I = k;
    e.default = I;
  }(EL)), EL;
}
var xL = {}, yw = {}, coe;
function wru() {
  if (coe)
    return yw;
  coe = 1;
  var e = Tn, t = xo;
  Object.defineProperty(yw, "__esModule", {
    value: !0
  }), yw.SwitchGroupActions = void 0;
  var n = e(ki), o = e(Si), r = e(Ei), i = e(xi()), a = e(oi()), s = l(Fe);
  function c(f) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
    return (c = function(b) {
      return b ? $ : h;
    })(f);
  }
  function l(f, h) {
    if (!h && f && f.__esModule)
      return f;
    if (f === null || t(f) !== "object" && typeof f != "function")
      return { default: f };
    var $ = c(h);
    if ($ && $.has(f))
      return $.get(f);
    var v = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in f)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(f, y)) {
        var w = b ? Object.getOwnPropertyDescriptor(f, y) : null;
        w && (w.get || w.set) ? Object.defineProperty(v, y, w) : v[y] = f[y];
      }
    return v.default = f, $ && $.set(f, v), v;
  }
  function u(f) {
    var h = d();
    return function() {
      var v = (0, a.default)(f), b;
      if (h) {
        var y = (0, a.default)(this).constructor;
        b = Reflect.construct(v, arguments, y);
      } else
        b = v.apply(this, arguments);
      return (0, i.default)(this, b);
    };
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = {
    topLeft: "group--actions--tl",
    topCenter: "group--actions--tc",
    topRight: "group--actions--tr",
    bottomLeft: "group--actions--bl",
    bottomCenter: "group--actions--bc",
    bottomRight: "group--actions--br"
  }, p = "topRight", g = /* @__PURE__ */ function(f) {
    (0, r.default)($, f);
    var h = u($);
    function $() {
      return (0, n.default)(this, $), h.apply(this, arguments);
    }
    return (0, o.default)($, [{
      key: "render",
      value: function() {
        var b = this.props, y = b.config, w = b.addCaseGroup, N = b.addDefaultCaseGroup, M = b.setLock, q = b.isLocked, L = b.isTrueLocked, R = b.id, T = b.canAddGroup, D = b.canAddDefault, A = y.settings, S = A.immutableGroupsMode, E = A.addCaseLabel, x = A.addDefaultCaseLabel, k = A.groupActionsPosition, I = A.renderButton, z = A.renderSwitch, F = A.renderButtonGroup, P = A.lockLabel, O = A.lockedLabel, V = A.showLock, U = _[k || p], H = V && !(q && !L) && /* @__PURE__ */ s.default.createElement(z, {
          type: "lock",
          id: R,
          value: q,
          setValue: M,
          label: P,
          checkedLabel: O,
          config: y
        }), J = !S && T && !q && /* @__PURE__ */ s.default.createElement(I, {
          type: "addCaseGroup",
          onClick: w,
          label: E,
          readonly: q,
          config: y
        }), le = !S && D && !q && /* @__PURE__ */ s.default.createElement(I, {
          type: "addDefaultCaseGroup",
          onClick: N,
          label: x,
          readonly: q,
          config: y
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions ".concat(U)
        }, /* @__PURE__ */ s.default.createElement(F, {
          config: y
        }, H, J, le));
      }
    }]), $;
  }(s.PureComponent);
  return yw.SwitchGroupActions = g, yw;
}
var loe;
function kru() {
  return loe || (loe = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Yr()), o = t(ki), r = t(Si), i = t(Hs()), a = t(Ei), s = t(xi()), c = t(oi()), l = t(Fe);
    t(Oa);
    var u = t($1()), d = t(y$()), _ = w1(), p = wru(), g = dc(), f = im(), h = Pv(), $, v, b;
    function y(T, D) {
      var A = Object.keys(T);
      if (Object.getOwnPropertySymbols) {
        var S = Object.getOwnPropertySymbols(T);
        D && (S = S.filter(function(E) {
          return Object.getOwnPropertyDescriptor(T, E).enumerable;
        })), A.push.apply(A, S);
      }
      return A;
    }
    function w(T) {
      for (var D = 1; D < arguments.length; D++) {
        var A = arguments[D] != null ? arguments[D] : {};
        D % 2 ? y(Object(A), !0).forEach(function(S) {
          (0, n.default)(T, S, A[S]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(A)) : y(Object(A)).forEach(function(S) {
          Object.defineProperty(T, S, Object.getOwnPropertyDescriptor(A, S));
        });
      }
      return T;
    }
    function N(T) {
      var D = M();
      return function() {
        var S = (0, c.default)(T), E;
        if (D) {
          var x = (0, c.default)(this).constructor;
          E = Reflect.construct(S, arguments, x);
        } else
          E = S.apply(this, arguments);
        return (0, s.default)(this, E);
      };
    }
    function M() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var q = jg, L = ($ = (0, d.default)("group switch_group"), (0, u.default)(v = $(v = (0, f.ConfirmFn)(v = (b = /* @__PURE__ */ function(T) {
      (0, a.default)(A, T);
      var D = N(A);
      function A(S) {
        var E;
        return (0, o.default)(this, A), E = D.call(this, S), E.childrenClassName = function() {
          return "switch_group--children";
        }, E.renderFooterWrapper = function() {
          return null;
        }, E.hasDefaultCase = function() {
          return E.props.children1.size && E.props.children1.filter(function(x) {
            return x.get("children1") == null;
          }).size > 0;
        }, (0, g.useOnPropsChanged)((0, i.default)(E)), E.onPropsChanged(S), E;
      }
      return (0, r.default)(A, [{
        key: "onPropsChanged",
        value: function(E) {
        }
      }, {
        key: "canAddGroup",
        value: function() {
          var E = this.props.config.settings.maxNumberOfCases, x = this.props.children1.size;
          return E ? x < E : !0;
        }
      }, {
        key: "canAddRule",
        value: function() {
          return !1;
        }
      }, {
        key: "reordableNodesCnt",
        value: function() {
          var E = this.props.children1.size, x = E;
          return this.hasDefaultCase() && x--, x;
        }
      }, {
        key: "totalRulesCntForItem",
        value: function(E) {
          return (0, h.getTotalRulesCountInTree)(E);
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(E) {
          if (this.props.isLocked)
            return 0;
          var x = this.props.config.settings, k = x.canLeaveEmptyCase, I = x.canRegroupCases, z = this.props.children1.size, F = z;
          this.hasDefaultCase() && F--;
          var P = (0, h.getTotalReordableNodesCountInTree)(E), O = P;
          return O == 1 && I && k && F > 1 && (O = 111), O;
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          return /* @__PURE__ */ l.default.createElement("div", {
            key: "group-header",
            className: q("group--header", this.isOneChild() ? "one--child" : "", this.showDragIcon() ? "with--drag" : "hide--drag", this.showConjs() && (!this.isOneChild() || this.showNot()) ? "with--conjs" : "hide--conjs")
          }, this.renderHeader(), this.renderActions());
        }
      }, {
        key: "renderHeader",
        value: function() {
          return /* @__PURE__ */ l.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }, {
        key: "renderConjs",
        value: function() {
          var E = this.props.config.settings.renderSwitchPrefix;
          return E ? E() : null;
        }
      }, {
        key: "showNot",
        value: function() {
          return !1;
        }
      }, {
        key: "renderActions",
        value: function() {
          var E = this.props, x = E.config, k = E.addCaseGroup, I = E.addDefaultCaseGroup, z = E.isLocked, F = E.isTrueLocked, P = E.id;
          return /* @__PURE__ */ l.default.createElement(p.SwitchGroupActions, {
            config: x,
            addCaseGroup: k,
            addDefaultCaseGroup: I,
            canAddDefault: !this.hasDefaultCase(),
            canAddGroup: this.canAddGroup(),
            setLock: this.setLock,
            isLocked: z,
            isTrueLocked: F,
            id: P
          });
        }
      }]), A;
    }(_.BasicGroup), b.propTypes = w({}, _.BasicGroup.propTypes), b)) || v) || v) || v), R = L;
    e.default = R;
  }(xL)), xL;
}
var CL = {}, uoe;
function Sru() {
  return uoe || (uoe = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Yr()), o = t(ki), r = t(Si), i = t(Hs()), a = t(BV()), s = t(Ei), c = t(xi()), l = t(oi()), u = t(Fe), d = t(Oa), _ = t($1()), p = t(y$()), g = w1(), f = k$e(), h = dc(), $ = im(), v = t(f2()), b, y, w;
    function N(A, S) {
      var E = Object.keys(A);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(A);
        S && (x = x.filter(function(k) {
          return Object.getOwnPropertyDescriptor(A, k).enumerable;
        })), E.push.apply(E, x);
      }
      return E;
    }
    function M(A) {
      for (var S = 1; S < arguments.length; S++) {
        var E = arguments[S] != null ? arguments[S] : {};
        S % 2 ? N(Object(E), !0).forEach(function(x) {
          (0, n.default)(A, x, E[x]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(E)) : N(Object(E)).forEach(function(x) {
          Object.defineProperty(A, x, Object.getOwnPropertyDescriptor(E, x));
        });
      }
      return A;
    }
    function q(A) {
      var S = L();
      return function() {
        var x = (0, l.default)(A), k;
        if (S) {
          var I = (0, l.default)(this).constructor;
          k = Reflect.construct(x, arguments, I);
        } else
          k = x.apply(this, arguments);
        return (0, c.default)(this, k);
      };
    }
    function L() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var R = jg, T = (b = (0, p.default)("group case_group"), (0, _.default)(y = b(y = (0, $.ConfirmFn)(y = (w = /* @__PURE__ */ function(A) {
      (0, s.default)(E, A);
      var S = q(E);
      function E(x) {
        var k;
        return (0, o.default)(this, E), k = S.call(this, x), k.childrenClassName = function() {
          return "case_group--children";
        }, k.renderFooterWrapper = function() {
          return null;
        }, (0, h.useOnPropsChanged)((0, i.default)(k)), k.onPropsChanged(x), k;
      }
      return (0, r.default)(E, [{
        key: "onPropsChanged",
        value: function(k) {
        }
      }, {
        key: "isDefaultCase",
        value: function() {
          return this.props.children1 == null;
        }
      }, {
        key: "reordableNodesCnt",
        value: function() {
          return this.props.parentReordableNodesCnt;
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(k) {
          return this.props.isLocked ? 0 : this.props.reordableNodesCnt;
        }
      }, {
        key: "totalRulesCntForItem",
        value: function(k) {
          return this.props.totalRulesCnt;
        }
      }, {
        key: "showDragIcon",
        value: function() {
          return this.isDefaultCase() ? !1 : (0, a.default)((0, l.default)(E.prototype), "showDragIcon", this).call(this);
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          return /* @__PURE__ */ u.default.createElement("div", {
            key: "group-header",
            className: R("group--header", this.isOneChild() ? "one--child" : "", this.showDragIcon() ? "with--drag" : "hide--drag", this.showConjs() && (!this.isOneChild() || this.showNot()) ? "with--conjs" : "hide--conjs")
          }, this.renderHeaderLeft(), this.renderHeaderCenter(), this.renderActions());
        }
      }, {
        key: "renderChildrenWrapper",
        value: function() {
          return this.isDefaultCase() ? null : /* @__PURE__ */ u.default.createElement("div", {
            className: "case_group--body"
          }, this.renderCondition(), this.renderValue());
        }
      }, {
        key: "renderHeaderLeft",
        value: function() {
          if (this.isDefaultCase()) {
            var k = this.props.config.settings.defaultCaseLabel;
            return k || "";
          }
          return /* @__PURE__ */ u.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }, {
        key: "renderCondition",
        value: function() {
          return this.isDefaultCase() ? null : (0, a.default)((0, l.default)(E.prototype), "renderChildrenWrapper", this).call(this);
        }
      }, {
        key: "renderHeaderCenter",
        value: function() {
          return this.isDefaultCase() ? this.renderValue() : null;
        }
      }, {
        key: "canAddGroup",
        value: function() {
          return this.isDefaultCase() ? !1 : (0, a.default)((0, l.default)(E.prototype), "canAddGroup", this).call(this);
        }
      }, {
        key: "canAddRule",
        value: function() {
          return this.isDefaultCase() ? !1 : (0, a.default)((0, l.default)(E.prototype), "canAddRule", this).call(this);
        }
      }, {
        key: "renderValue",
        value: function() {
          var k = this.props, I = k.config, z = k.isLocked, F = k.value, P = k.setValue, O = k.id, V = I.settings.immutableValuesMode, U = /* @__PURE__ */ u.default.createElement(v.default, {
            key: "values",
            isCaseValue: !0,
            field: "!case_value",
            operator: null,
            value: F,
            valueSrc: "value",
            valueError: null,
            config: I,
            setValue: V ? $.dummyFn : P,
            setValueSrc: $.dummyFn,
            readonly: V || z,
            id: O,
            groupId: null
          });
          return /* @__PURE__ */ u.default.createElement($.Col, {
            className: "case_group--value"
          }, U);
        }
      }, {
        key: "renderActions",
        value: function() {
          var k = this.props, I = k.config, z = k.addGroup, F = k.addRule, P = k.isLocked, O = k.isTrueLocked, V = k.id;
          return /* @__PURE__ */ u.default.createElement(f.GroupActions, {
            config: I,
            addGroup: z,
            addRule: F,
            canAddRule: this.canAddRule(),
            canAddGroup: this.canAddGroup(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: P,
            isTrueLocked: O,
            id: V
          });
        }
      }, {
        key: "isEmptyCurrentGroup",
        value: function() {
          var k = this.props.value, I = k && k.size ? k.get(0) : null, z = I != null && (Array.isArray(I) ? I.length > 0 : !0);
          return (0, a.default)((0, l.default)(E.prototype), "isEmptyCurrentGroup", this).call(this) && !z;
        }
      }]), E;
    }(g.BasicGroup), w.propTypes = M(M({}, g.BasicGroup.propTypes), {}, {
      parentReordableNodesCnt: d.default.number,
      value: d.default.any,
      setValue: d.default.func
    }), w)) || y) || y) || y), D = T;
    e.default = D;
  }(CL)), CL;
}
var doe;
function S$e() {
  if (doe)
    return gw;
  doe = 1;
  var e = Tn, t = xo;
  Object.defineProperty(gw, "__esModule", {
    value: !0
  }), gw.Item = void 0;
  var n = e(g1), o = e(ki), r = e(Si), i = e(Ei), a = e(xi()), s = e(oi()), c = e(Ys), l = e(Yr()), u = y(Fe), d = e(Oa), _ = e(pru()), p = e(w1()), g = e(bru()), f = e($ru()), h = e(kru()), $ = e(Sru()), v = ["type"];
  function b(A) {
    if (typeof WeakMap != "function")
      return null;
    var S = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
    return (b = function(k) {
      return k ? E : S;
    })(A);
  }
  function y(A, S) {
    if (!S && A && A.__esModule)
      return A;
    if (A === null || t(A) !== "object" && typeof A != "function")
      return { default: A };
    var E = b(S);
    if (E && E.has(A))
      return E.get(A);
    var x = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var I in A)
      if (I !== "default" && Object.prototype.hasOwnProperty.call(A, I)) {
        var z = k ? Object.getOwnPropertyDescriptor(A, I) : null;
        z && (z.get || z.set) ? Object.defineProperty(x, I, z) : x[I] = A[I];
      }
    return x.default = A, E && E.set(A, x), x;
  }
  function w(A) {
    var S = N();
    return function() {
      var x = (0, s.default)(A), k;
      if (S) {
        var I = (0, s.default)(this).constructor;
        k = Reflect.construct(x, arguments, I);
      } else
        k = x.apply(this, arguments);
      return (0, a.default)(this, k);
    };
  }
  function N() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function M(A, S) {
    var E = Object.keys(A);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(A);
      S && (x = x.filter(function(k) {
        return Object.getOwnPropertyDescriptor(A, k).enumerable;
      })), E.push.apply(E, x);
    }
    return E;
  }
  function q(A) {
    for (var S = 1; S < arguments.length; S++) {
      var E = arguments[S] != null ? arguments[S] : {};
      S % 2 ? M(Object(E), !0).forEach(function(x) {
        (0, l.default)(A, x, E[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(E)) : M(Object(E)).forEach(function(x) {
        Object.defineProperty(A, x, Object.getOwnPropertyDescriptor(E, x));
      });
    }
    return A;
  }
  var L = ["rule", "group", "rule_group", "switch_group", "case_group"], R = function(S) {
    var E = S.properties.toObject(), x = q({}, E);
    return S.isParentLocked && (x.isLocked = !0), E.isLocked && (x.isTrueLocked = !0), x;
  }, T = {
    rule: function(S) {
      return /* @__PURE__ */ u.default.createElement(_.default, (0, c.default)({}, R(S), {
        id: S.id,
        groupId: S.groupId,
        path: S.path,
        actions: S.actions,
        reordableNodesCnt: S.reordableNodesCnt,
        totalRulesCnt: S.totalRulesCnt,
        config: S.config,
        onDragStart: S.onDragStart,
        isDraggingTempo: S.isDraggingTempo,
        parentField: S.parentField,
        parentReordableNodesCnt: S.parentReordableNodesCnt
      }));
    },
    group: function(S) {
      return /* @__PURE__ */ u.default.createElement(p.default, (0, c.default)({}, R(S), {
        id: S.id,
        groupId: S.groupId,
        path: S.path,
        actions: S.actions,
        config: S.config,
        reordableNodesCnt: S.reordableNodesCnt,
        totalRulesCnt: S.totalRulesCnt,
        onDragStart: S.onDragStart,
        isDraggingTempo: S.isDraggingTempo,
        children1: S.children1,
        parentField: null,
        parentReordableNodesCnt: S.parentReordableNodesCnt
      }));
    },
    rule_group: function(S) {
      return /* @__PURE__ */ u.default.createElement(g.default, (0, c.default)({}, R(S), {
        id: S.id,
        groupId: S.groupId,
        path: S.path,
        actions: S.actions,
        config: S.config,
        reordableNodesCnt: S.reordableNodesCnt,
        totalRulesCnt: S.totalRulesCnt,
        onDragStart: S.onDragStart,
        isDraggingTempo: S.isDraggingTempo,
        children1: S.children1,
        parentField: S.parentField,
        parentReordableNodesCnt: S.parentReordableNodesCnt
      }));
    },
    rule_group_ext: function(S) {
      return /* @__PURE__ */ u.default.createElement(f.default, (0, c.default)({}, R(S), {
        id: S.id,
        groupId: S.groupId,
        path: S.path,
        actions: S.actions,
        config: S.config,
        reordableNodesCnt: S.reordableNodesCnt,
        totalRulesCnt: S.totalRulesCnt,
        onDragStart: S.onDragStart,
        isDraggingTempo: S.isDraggingTempo,
        children1: S.children1,
        parentField: S.parentField,
        parentReordableNodesCnt: S.parentReordableNodesCnt
      }));
    },
    switch_group: function(S) {
      return /* @__PURE__ */ u.default.createElement(h.default, (0, c.default)({}, R(S), {
        id: S.id,
        groupId: S.groupId,
        path: S.path,
        actions: S.actions,
        config: S.config,
        reordableNodesCnt: S.reordableNodesCnt,
        totalRulesCnt: S.totalRulesCnt,
        onDragStart: S.onDragStart,
        isDraggingTempo: S.isDraggingTempo,
        children1: S.children1,
        parentField: null,
        parentReordableNodesCnt: S.parentReordableNodesCnt
      }));
    },
    case_group: function(S) {
      return /* @__PURE__ */ u.default.createElement($.default, (0, c.default)({}, R(S), {
        id: S.id,
        groupId: S.groupId,
        path: S.path,
        actions: S.actions,
        config: S.config,
        reordableNodesCnt: S.reordableNodesCnt,
        totalRulesCnt: S.totalRulesCnt,
        onDragStart: S.onDragStart,
        isDraggingTempo: S.isDraggingTempo,
        children1: S.children1,
        parentField: null,
        parentReordableNodesCnt: S.parentReordableNodesCnt
      }));
    }
  }, D = /* @__PURE__ */ function(A) {
    (0, i.default)(E, A);
    var S = w(E);
    function E() {
      return (0, o.default)(this, E), S.apply(this, arguments);
    }
    return (0, r.default)(E, [{
      key: "render",
      value: function() {
        var k = this.props, I = k.type, z = (0, n.default)(k, v), F = z.properties.get("mode"), P = F == "array" ? "_ext" : "", O = T[I + P];
        return O ? O(z) : null;
      }
    }]), E;
  }(u.PureComponent);
  return gw.Item = D, D.propTypes = {
    //tree: PropTypes.instanceOf(Immutable.Map).isRequired,
    config: d.default.object.isRequired,
    id: d.default.string.isRequired,
    groupId: d.default.string,
    type: d.default.oneOf(L).isRequired,
    path: d.default.any.isRequired,
    //instanceOf(Immutable.List)
    properties: d.default.any.isRequired,
    //instanceOf(Immutable.Map)
    children1: d.default.any,
    //instanceOf(Immutable.OrderedMap)
    actions: d.default.object.isRequired,
    reordableNodesCnt: d.default.number,
    onDragStart: d.default.func,
    parentField: d.default.string,
    //from RuleGroup
    isDraggingTempo: d.default.bool,
    isParentLocked: d.default.bool
  }, gw;
}
var TL = {}, _oe;
function Eru() {
  return _oe || (_oe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Ys), r = t(Zu), i = t(ki), a = t(Si), s = t(Hs()), c = t(Ei), l = t(xi()), u = t(oi()), d = N(Fe), _ = A2, p = Pv(), g = Ti(), f = t(T2()), h = N(b$()), $ = t(m2()), v = t(Oa), b = N(jV()), y = dc();
    function w(T) {
      if (typeof WeakMap != "function")
        return null;
      var D = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap();
      return (w = function(E) {
        return E ? A : D;
      })(T);
    }
    function N(T, D) {
      if (!D && T && T.__esModule)
        return T;
      if (T === null || n(T) !== "object" && typeof T != "function")
        return { default: T };
      var A = w(D);
      if (A && A.has(T))
        return A.get(T);
      var S = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var x in T)
        if (x !== "default" && Object.prototype.hasOwnProperty.call(T, x)) {
          var k = E ? Object.getOwnPropertyDescriptor(T, x) : null;
          k && (k.get || k.set) ? Object.defineProperty(S, x, k) : S[x] = T[x];
        }
      return S.default = T, A && A.set(T, S), S;
    }
    function M(T) {
      var D = q();
      return function() {
        var S = (0, u.default)(T), E;
        if (D) {
          var x = (0, u.default)(this).constructor;
          E = Reflect.construct(S, arguments, x);
        } else
          E = S.apply(this, arguments);
        return (0, l.default)(this, E);
      };
    }
    function q() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var L = function(D) {
      var A, S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      return A = /* @__PURE__ */ function(E) {
        (0, c.default)(k, E);
        var x = M(k);
        function k(I) {
          var z;
          return (0, i.default)(this, k), z = x.call(this, I), z._getEventTarget = function(F, P) {
            return F && F.__mocked_window || document.body || window;
          }, z.onDragStart = function(F, P, O) {
            var V = P.closest(".query-builder");
            document.body.classList.add("qb-dragging"), V.classList.add("qb-dragging");
            var U = V.closest(".query-builder-container") || V;
            U = z._getScrollParent(U) || document.body;
            var H = U.scrollTop;
            z._getDraggableNodeEl(V), z._getPlaceholderNodeEl(V);
            var J = V.querySelectorAll(".group--children"), le = J.length ? J[0] : null, ae;
            le && (ae = window.getComputedStyle(le, null).getPropertyValue("padding-left"), ae = parseInt(ae));
            var Y = {
              id: F,
              x: P.offsetLeft,
              y: P.offsetTop,
              w: P.offsetWidth,
              h: P.offsetHeight,
              itemInfo: z.tree.items[F],
              paddingLeft: ae
            }, re = {
              id: F,
              x: P.offsetLeft,
              y: P.offsetTop,
              scrollTop: H,
              clientX: O.clientX,
              clientY: O.clientY,
              itemInfo: (0, $.default)(z.tree.items[F]),
              treeEl: V,
              treeElContainer: U
            }, ie = {
              clientX: O.clientX,
              clientY: O.clientY
            }, _e = z._getEventTarget(O, re);
            z.eventTarget = _e, _e.addEventListener("mousemove", z.onDrag), _e.addEventListener("mouseup", z.onDragEnd), z.props.setDragStart(re, Y, ie);
          }, z.onDrag = function(F) {
            var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, O = Object.assign({}, z.props.dragging), V = z.props.dragStart, U = O.paddingLeft, H = V.treeElContainer, J = H.scrollTop;
            if (O.itemInfo = z.tree.items[O.id], !!O.itemInfo) {
              var le = {
                clientX: F.clientX,
                clientY: F.clientY
              }, ae = {
                clientX: V.clientX,
                clientY: V.clientY
              };
              if (F.__mock_dom) {
                var Y = V.treeEl, re = z._getDraggableNodeEl(Y), ie = z._getPlaceholderNodeEl(Y);
                F.__mock_dom({
                  treeEl: Y,
                  dragEl: re,
                  plhEl: ie
                });
              }
              if (!V.plX) {
                var _e = V.treeEl, he = z._getPlaceholderNodeEl(_e);
                he && (V.plX = he.getBoundingClientRect().left + window.scrollX, V.plY = he.getBoundingClientRect().top + window.scrollY);
              }
              var be = V.x, Q = V.y, me = V.clientX, ne = V.clientY, pe = V.scrollTop, ge = {
                x: be + (F.clientX - me),
                y: Q + (F.clientY - ne) + (J - pe)
              };
              O.x = ge.x, O.y = ge.y, O.paddingLeft = U, O.mousePos = le, O.startMousePos = ae, z.props.setDragProgress(le, O);
              var ve = P ? z.handleDrag(O, F, S) : !1;
              ve || F.preventDefault && F.preventDefault();
            }
          }, z.onDragEnd = function() {
            var F = z.props.dragStart.treeEl;
            z.props.setDragEnd(), F.classList.remove("qb-dragging"), document.body.classList.remove("qb-dragging"), z._cacheEls = {};
            var P = z.eventTarget || z._getEventTarget();
            P.removeEventListener("mousemove", z.onDrag), P.removeEventListener("mouseup", z.onDragEnd);
          }, (0, y.useOnPropsChanged)((0, s.default)(z)), z.onPropsChanged(I), z;
        }
        return (0, a.default)(k, [{
          key: "onPropsChanged",
          value: function(z) {
            this.tree = (0, p.getFlatTree)(z.tree);
          }
        }, {
          key: "shouldComponentUpdate",
          value: function(z, F) {
            var P = this.props, O = this.state, V = (0, y.pureShouldComponentUpdate)(this)(z, F);
            if (V && O == F && P != z) {
              var U = [];
              for (var H in z) {
                var J = z[H] != P[H];
                J && H != "dragging" && H != "mousePos" && U.push(H);
              }
              U.length || (V = !1);
            }
            return V;
          }
        }, {
          key: "componentDidUpdate",
          value: function(z, F) {
            var P = this.props.dragging, O = this.props.dragStart;
            if (O && O.id && (P.itemInfo = this.tree.items[P.id], P.itemInfo && (P.itemInfo.index != O.itemInfo.index || P.itemInfo.parent != O.itemInfo.parent))) {
              var V = O.treeEl, U = O.treeElContainer, H = this._getPlaceholderNodeEl(V, !0);
              if (H) {
                var J = H.getBoundingClientRect().left + window.scrollX, le = H.getBoundingClientRect().top + window.scrollY, ae = O.plX, Y = O.plY, re = U.scrollTop;
                O.plX = J, O.plY = le, O.itemInfo = (0, $.default)(P.itemInfo), O.y = H.offsetTop, O.x = H.offsetLeft, O.clientY += le - Y, O.clientX += J - ae, U != document.body && (O.scrollTop = re), this.onDrag(this.props.mousePos, !1);
              }
            }
          }
        }, {
          key: "_getNodeElById",
          value: function(z, F) {
            var P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            if (F == null)
              return null;
            this._cacheEls || (this._cacheEls = {});
            var O = this._cacheEls[F];
            return O && document.contains(O) && !P || (O = z.querySelector('.group-or-rule-container[data-id="' + F + '"]'), this._cacheEls[F] = O), O;
          }
        }, {
          key: "_getDraggableNodeEl",
          value: function(z) {
            var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            this._cacheEls || (this._cacheEls = {});
            var P = this._cacheEls.draggable;
            if (P && document.contains(P) && !F)
              return P;
            var O = z.getElementsByClassName("qb-draggable");
            return P = O.length ? O[0] : null, this._cacheEls.draggable = P, P;
          }
        }, {
          key: "_getPlaceholderNodeEl",
          value: function(z) {
            var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            this._cacheEls || (this._cacheEls = {});
            var P = this._cacheEls.placeholder;
            if (P && document.contains(P) && !F)
              return P;
            var O = z.getElementsByClassName("qb-placeholder");
            return P = O.length ? O[0] : null, this._cacheEls.placeholder = P, P;
          }
        }, {
          key: "_isScrollable",
          value: function(z) {
            var F = window.getComputedStyle(z)["overflow-y"];
            return (F === "scroll" || F === "auto") && z.scrollHeight > z.offsetHeight;
          }
        }, {
          key: "_getScrollParent",
          value: function(z) {
            return z == null ? null : z === document.body || this._isScrollable(z) ? z : this._getScrollParent(z.parentNode);
          }
        }, {
          key: "handleDrag",
          value: function(z, F, P) {
            var O = this, V = !0, U = z.itemInfo, H = z.paddingLeft, J = null, le = this.props.dragStart.treeEl, ae = z.id, Y = this._getDraggableNodeEl(le), re = this._getPlaceholderNodeEl(le), ie, _e, he, be;
            if (Y && re) {
              if (ie = Y.getBoundingClientRect(), _e = re.getBoundingClientRect(), !_e.width)
                return;
              var Q = {
                hrz: 0,
                vrt: 0
              };
              ie.top < _e.top ? Q.vrt = -1 : ie.bottom > _e.bottom && (Q.vrt = 1), ie.left > _e.left ? Q.hrz = 1 : ie.left < _e.left && (Q.hrz = -1), be = le.getBoundingClientRect();
              var me = {
                x: be.left + (be.right - be.left) / 2,
                y: Q.vrt >= 0 ? ie.bottom : ie.top
              }, ne;
              if (F.__mocked_hov_container)
                ne = F.__mocked_hov_container;
              else {
                var pe = document.elementFromPoint(me.x, me.y - 1);
                if (ne = pe ? pe.closest(".group-or-rule-container") : null, !ne && pe && pe.classList.contains("query-builder-container")) {
                  var ge, ve = pe == null || (ge = pe.firstChild) === null || ge === void 0 ? void 0 : ge.firstChild;
                  ve && ve.classList.contains("group-or-rule-container") && (ne = ve);
                }
              }
              if (!ne)
                g.logger.log("out of tree bounds!");
              else {
                var Te = ne.classList.contains("group-container"), Re = ne.getAttribute("data-id"), Me = ne, et = !1, st = !1;
                if (Me) {
                  he = Me.getBoundingClientRect();
                  var De = he.bottom - he.top, ze = this.tree.items[Re], Pe = null, je = null, He = null, Xe = null;
                  if (Q.vrt == 0)
                    He = U, je = re, je && (Pe = je.getBoundingClientRect());
                  else if (Te) {
                    if (Q.vrt > 0) {
                      var at = ne.getElementsByClassName("group--header"), wt = at.length ? at[0] : null;
                      if (wt) {
                        var Je = wt.getBoundingClientRect(), vt = Je.bottom - Je.top, Ot = ie.bottom - Je.top > vt * 3 / 4;
                        Ot && ze.top > z.itemInfo.top && (He = ze, Pe = Je, je = wt, st = !0);
                      }
                    } else if (Q.vrt < 0 && ze.lev >= U.lev) {
                      var Ft = he.bottom - ie.top >= 2;
                      Ft && ze.top < z.itemInfo.top && (He = ze, Pe = he, je = Me, et = !0);
                    }
                    if (!st && !et || V) {
                      var wn = Q.vrt < 0 ? he.bottom - ie.top > De - 5 : ie.bottom - he.top > De - 5;
                      wn && (!st && !et && (He = ze, Pe = he, je = Me), Xe = ze);
                    }
                  } else {
                    var un = Q.vrt < 0 ? he.bottom - ie.top > De / 2 : ie.bottom - he.top > De / 2;
                    un && (He = ze, Pe = he, je = Me);
                  }
                  var pn = He && He.id == ae;
                  if (Pe) {
                    var Dn = ie.left - be.left;
                    Pe.left - be.left;
                    var Rn = Math.max(0, Math.round(Dn / H)), Ln = [], Yn = [];
                    if (!pn) {
                      if (Te && (et ? Ln.push([h.PLACEMENT_APPEND, He, He.lev + 1]) : st && Ln.push([h.PLACEMENT_PREPEND, He, He.lev + 1]), Xe)) {
                        var Qt = Xe.lev == 0, fn = Xe.type == "case_group" && U.type != "case_group", qn = Xe.prev && this.tree.items[Xe.prev].caseId, Xn = Xe.next && this.tree.items[Xe.next].caseId;
                        U.caseId == qn && (qn = null), U.caseId == Xn && (Xn = null);
                        var Qn = qn && this.tree.items[qn], In = Xn && this.tree.items[Xn];
                        Q.vrt > 0 ? Qt ? Yn.push([h.PLACEMENT_APPEND, Xe, Xe.lev + 1]) : fn && In ? Yn.push([h.PLACEMENT_PREPEND, In, In.lev + 1]) : Yn.push([h.PLACEMENT_AFTER, Xe, Xe.lev]) : Q.vrt < 0 && (Qt ? Yn.push([h.PLACEMENT_PREPEND, Xe, Xe.lev + 1]) : fn && Qn ? Yn.push([h.PLACEMENT_APPEND, Qn, Qn.lev + 1]) : Yn.push([h.PLACEMENT_BEFORE, Xe, Xe.lev]));
                      }
                      !et && !st && (Q.vrt < 0 ? Ln.push([h.PLACEMENT_BEFORE, He, He.lev]) : Q.vrt > 0 && Ln.push([h.PLACEMENT_AFTER, He, He.lev]));
                    }
                    var $n = function(an) {
                      var Gn = an[1], An = U.caseId ? O.tree.items[U.caseId] : null, hn = Gn.caseId ? O.tree.items[Gn.caseId] : null;
                      return [].concat((0, r.default)(an), [An, hn]);
                    };
                    Ln = Ln.map($n), Yn = Yn.map($n), Ln = Ln.filter(function(Kt) {
                      var an = Kt[0], Gn = Kt[1];
                      if ((an == h.PLACEMENT_BEFORE || an == h.PLACEMENT_AFTER) && Gn.parent == null || Gn.collapsed && (an == h.PLACEMENT_APPEND || an == h.PLACEMENT_PREPEND))
                        return !1;
                      var An = Gn.id == U.id;
                      if (!An) {
                        for (var hn = Gn; hn.parent; )
                          if (hn = O.tree.items[hn.parent], hn.id == U.id) {
                            An = !0;
                            break;
                          }
                      }
                      return !An;
                    }).map(function(Kt) {
                      var an = Kt[0], Gn = Kt[1];
                      Kt[2], Kt[3], Kt[4];
                      var An = null;
                      return an == h.PLACEMENT_APPEND || an == h.PLACEMENT_PREPEND ? An = Gn : An = O.tree.items[Gn.parent], An && An.parent == null && (An = null), Kt[5] = An, Kt;
                    });
                    var uo = null, go = Ln.filter(function(Kt) {
                      return O.canMove(U, Kt[1], Kt[0], Kt[3], Kt[4], Kt[5], P);
                    });
                    go.length == 0 && Yn.length > 0 && (go = Yn.filter(function(Kt) {
                      return O.canMove(U, Kt[1], Kt[0], Kt[3], Kt[4], Kt[5], P);
                    }));
                    var Rr = go.map(function(Kt) {
                      return Kt[2];
                    }), qo = U.lev, ho = Rr.concat(qo), Ut = null;
                    ho.indexOf(Rn) != -1 ? Ut = Rn : Rn > Math.max.apply(Math, (0, r.default)(ho)) ? Ut = Math.max.apply(Math, (0, r.default)(ho)) : Rn < Math.min.apply(Math, (0, r.default)(ho)) && (Ut = Math.min.apply(Math, (0, r.default)(ho))), uo = go.find(function(Kt) {
                      return Kt[2] == Ut;
                    }), !pn && !uo && go.length && (uo = go[0]), J = uo;
                  }
                }
              }
            }
            return J ? (this.move(U, J[1], J[0], J[3]), !0) : !1;
          }
        }, {
          key: "canMove",
          value: function(z, F, P, O, V, U, H) {
            if (!z || !F || z.id === F.id)
              return !1;
            var J = this.props.config.settings, le = J.canRegroup, ae = J.canRegroupCases, Y = J.maxNesting, re = J.maxNumberOfRules, ie = J.canLeaveEmptyCase, _e = U ? U.lev + 1 : F.lev, he = P == h.PLACEMENT_BEFORE || P == h.PLACEMENT_AFTER, be = P == h.PLACEMENT_PREPEND || P == h.PLACEMENT_APPEND, Q = he && F.lev == 1 || be && F.lev == 0, me = z.parent != F.parent, ne = be || me, pe = z.type == "case_group" && !Q || z.parentType == "rule_group" || F.type == "rule_group" || F.parentType == "rule_group" || z.type != "case_group" && F.type == "case_group" && he || z.type != "case_group" && F.type == "switch_group" || !ae && z.caseId != F.caseId, ge = F.isLocked || z.isLocked || U && U.isLocked;
            if (Y && _e > Y || ne && (!le || pe || ge))
              return !1;
            if (z.type != "case_group" && z.caseId != F.caseId) {
              var ve = O ? O._height == 2 : !1, Te = V ? V.leafsCount + 1 : 0;
              if (re && Te > re || ve && !ie)
                return !1;
            }
            if (z.type == "case_group" && (z.isDefaultCase || F.isDefaultCase || F.type == "switch_group" && P == h.PLACEMENT_APPEND))
              return !1;
            var Re = !0;
            return H && (Re = H(z.node.toJS(), F.node.toJS(), P, U ? U.node.toJS() : null)), Re;
          }
        }, {
          key: "move",
          value: function(z, F, P, O) {
            this.props.actions.moveItem(z.path, F.path, P);
          }
        }, {
          key: "render",
          value: function() {
            return /* @__PURE__ */ d.default.createElement(D, (0, o.default)({}, this.props, {
              onDragStart: this.onDragStart
            }));
          }
        }]), k;
      }(d.Component), A.propTypes = {
        tree: v.default.any.isRequired,
        //instanceOf(Immutable.Map)
        actions: v.default.object.isRequired
        // {moveItem: Function, ..}
        //... see Builder
      }, A;
    }, R = function(D) {
      var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, S = (0, _.connect)(function(E) {
        return {
          dragging: E.dragging,
          dragStart: E.dragStart,
          mousePos: E.mousePos
        };
      }, {
        setDragStart: b.drag.setDragStart,
        setDragProgress: b.drag.setDragProgress,
        setDragEnd: b.drag.setDragEnd
      }, null, {
        context: f.default
      })(L(D, A));
      return S.displayName = "ConnectedSortableContainer", S;
    };
    e.default = R;
  }(TL)), TL;
}
var poe;
function xru() {
  return poe || (poe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(ki), r = t(Si), i = t(Ei), a = t(xi()), s = t(oi()), c = v(Fe), l = t(Oa), u = v(uc()), d = S$e(), _ = t(Eru()), p = Pv();
    t(Ug());
    var g = dc(), f, h;
    function $(N) {
      if (typeof WeakMap != "function")
        return null;
      var M = /* @__PURE__ */ new WeakMap(), q = /* @__PURE__ */ new WeakMap();
      return ($ = function(R) {
        return R ? q : M;
      })(N);
    }
    function v(N, M) {
      if (!M && N && N.__esModule)
        return N;
      if (N === null || n(N) !== "object" && typeof N != "function")
        return { default: N };
      var q = $(M);
      if (q && q.has(N))
        return q.get(N);
      var L = {}, R = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var T in N)
        if (T !== "default" && Object.prototype.hasOwnProperty.call(N, T)) {
          var D = R ? Object.getOwnPropertyDescriptor(N, T) : null;
          D && (D.get || D.set) ? Object.defineProperty(L, T, D) : L[T] = N[T];
        }
      return L.default = N, q && q.set(N, L), L;
    }
    function b(N) {
      var M = y();
      return function() {
        var L = (0, s.default)(N), R;
        if (M) {
          var T = (0, s.default)(this).constructor;
          R = Reflect.construct(L, arguments, T);
        } else
          R = L.apply(this, arguments);
        return (0, a.default)(this, R);
      };
    }
    function y() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var w = (0, _.default)(f = (h = /* @__PURE__ */ function(N) {
      (0, i.default)(q, N);
      var M = b(q);
      function q(L) {
        var R;
        return (0, o.default)(this, q), R = M.call(this, L), R._updPath(L), R;
      }
      return (0, r.default)(q, [{
        key: "shouldComponentUpdate",
        value: function(R, T) {
          var D = this.props, A = (0, g.pureShouldComponentUpdate)(this)(R, T);
          if (A) {
            var S = [];
            for (var E in R) {
              var x = R[E] !== D[E];
              x && E != "__isInternalValueChange" && S.push(E);
            }
            S.length || (A = !1), S.length == 1 && S[0] == "tree" && R.__isInternalValueChange && (A = !1);
          }
          return A;
        }
      }, {
        key: "_updPath",
        value: function(R) {
          var T = R.tree.get("id");
          this.path = u.default.List.of(T);
        }
      }, {
        key: "render",
        value: function() {
          var R = this.props.tree, T = R.get("type"), D = T == "switch_group", A = D ? null : (0, p.getTotalReordableNodesCountInTree)(R), S = D ? null : (0, p.getTotalRulesCountInTree)(R), E = R.get("id");
          return /* @__PURE__ */ c.default.createElement(d.Item, {
            key: E,
            id: E,
            path: this.path,
            type: T,
            properties: R.get("properties") || new u.Map(),
            config: this.props.config,
            actions: this.props.actions,
            children1: R.get("children1") || new u.Map(),
            reordableNodesCnt: A,
            totalRulesCnt: S,
            parentReordableNodesCnt: 0,
            onDragStart: this.props.onDragStart
          });
        }
      }]), q;
    }(c.Component), h.propTypes = {
      tree: l.default.any.isRequired,
      //instanceOf(Immutable.Map)
      config: l.default.object.isRequired,
      actions: l.default.object.isRequired,
      onDragStart: l.default.func
    }, h)) || f;
    e.default = w;
  }(sL)), sL;
}
var AL = {}, $w = {}, moe;
function Cru() {
  if (moe)
    return $w;
  moe = 1;
  var e = Tn;
  Object.defineProperty($w, "__esModule", {
    value: !0
  }), $w.queryBuilderFormat = void 0;
  var t = e(Yr()), n = Ti(), o = Qi(), r = kl(), i = Es();
  Lv();
  var a = uc();
  function s(p, g) {
    var f = Object.keys(p);
    if (Object.getOwnPropertySymbols) {
      var h = Object.getOwnPropertySymbols(p);
      g && (h = h.filter(function($) {
        return Object.getOwnPropertyDescriptor(p, $).enumerable;
      })), f.push.apply(f, h);
    }
    return f;
  }
  function c(p) {
    for (var g = 1; g < arguments.length; g++) {
      var f = arguments[g] != null ? arguments[g] : {};
      g % 2 ? s(Object(f), !0).forEach(function(h) {
        (0, t.default)(p, h, f[h]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(p, Object.getOwnPropertyDescriptors(f)) : s(Object(f)).forEach(function(h) {
        Object.defineProperty(p, h, Object.getOwnPropertyDescriptor(f, h));
      });
    }
    return p;
  }
  var l = function(g, f) {
    var h = {
      usedFields: []
    }, $ = u(g, f, h);
    if ($)
      return c(c({}, $), h);
  };
  $w.queryBuilderFormat = l;
  var u = function(g, f, h) {
    if (g) {
      var $ = g.get("type"), v = g.get("children1");
      if (($ === "group" || $ === "rule_group") && v && v.size)
        return d(g, f, h);
      if ($ === "rule")
        return _(g, f, h);
    }
  }, d = function(g, f, h) {
    var $ = g.get("properties") || new a.Map(), v = g.get("children1"), b = g.get("id"), y = v.map(function(q) {
      return u(q, f, h);
    }).filter(function(q) {
      return typeof q < "u";
    });
    if (y.size) {
      var w = $.get("conjunction");
      w || (w = (0, r.defaultConjunction)(f));
      var N = $.get("not"), M = {
        id: b,
        rules: y.toList(),
        condition: w.toUpperCase(),
        not: N
      };
      return M;
    }
  }, _ = function(g, f, h) {
    var $ = g.get("properties") || new a.Map(), v = g.get("id"), b = $.get("operator"), y = $.get("operatorOptions"), w = $.get("field"), N = $.get("value"), M = $.get("valueSrc"), q = $.get("valueType"), L = N.filter(function(O) {
      return O === void 0;
    }).size > 0;
    if (!(w == null || b == null || L)) {
      var R = (0, o.getFieldConfig)(f, w) || {}, T = (0, o.getOperatorConfig)(f, b, w) || {}, D = R.type || "undefined", A = (0, n.defaultValue)(T.cardinality, 1), S = f.types[R.type] || {}, E = (0, i.formatFieldName)(w, f, h);
      if (!(N.size < A)) {
        h.usedFields.indexOf(w) == -1 && h.usedFields.push(w), N = N.toArray(), M = M.toArray(), q = q.toArray();
        for (var x = [], k = 0; k < N.length; k++) {
          var I = {
            type: q[k],
            value: N[k]
          };
          if (x.push(I), M[k] == "field") {
            var z = N[k];
            h.usedFields.indexOf(z) == -1 && h.usedFields.push(z);
          }
        }
        var F = y ? y.toJS() : null;
        F && !Object.keys(F).length && (F = null);
        var P = {
          id: v,
          fieldName: E,
          type: D,
          input: S.mainWidget,
          operator: b
        };
        return F && (P.operatorOptions = F), P.values = x, P;
      }
    }
  };
  return $w;
}
var ww = {}, IL = { exports: {} }, OL = { exports: {} }, foe;
function Tru() {
  return foe || (foe = 1, function(e) {
    function t(n) {
      if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
        return Array.from(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(OL)), OL.exports;
}
var goe;
function UV() {
  return goe || (goe = 1, function(e) {
    var t = Eae(), n = Tru(), o = xae(), r = Cae();
    function i(a) {
      return t(a) || n(a) || o(a) || r();
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(IL)), IL.exports;
}
var hoe;
function Aru() {
  if (hoe)
    return ww;
  hoe = 1;
  var e = Tn;
  Object.defineProperty(ww, "__esModule", {
    value: !0
  }), ww.jsonLogicFormat = void 0;
  var t = e(Zu), n = e(UV()), o = e(Yr()), r = Ti(), i = Qi(), a = Es(), s = kl(), c = Lv(), l = uc(), u = e(Of()), d = e(Dv());
  function _(T, D) {
    var A = Object.keys(T);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(T);
      D && (S = S.filter(function(E) {
        return Object.getOwnPropertyDescriptor(T, E).enumerable;
      })), A.push.apply(A, S);
    }
    return A;
  }
  function p(T) {
    for (var D = 1; D < arguments.length; D++) {
      var A = arguments[D] != null ? arguments[D] : {};
      D % 2 ? _(Object(A), !0).forEach(function(S) {
        (0, o.default)(T, S, A[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(A)) : _(Object(A)).forEach(function(S) {
        Object.defineProperty(T, S, Object.getOwnPropertyDescriptor(A, S));
      });
    }
    return T;
  }
  function g(T, D) {
    var A = typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
    if (!A) {
      if (Array.isArray(T) || (A = f(T)) || D && T && typeof T.length == "number") {
        A && (T = A);
        var S = 0, E = function() {
        };
        return { s: E, n: function() {
          return S >= T.length ? { done: !0 } : { done: !1, value: T[S++] };
        }, e: function(F) {
          throw F;
        }, f: E };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var x = !0, k = !1, I;
    return { s: function() {
      A = A.call(T);
    }, n: function() {
      var F = A.next();
      return x = F.done, F;
    }, e: function(F) {
      k = !0, I = F;
    }, f: function() {
      try {
        !x && A.return != null && A.return();
      } finally {
        if (k)
          throw I;
      }
    } };
  }
  function f(T, D) {
    if (T) {
      if (typeof T == "string")
        return h(T, D);
      var A = Object.prototype.toString.call(T).slice(8, -1);
      if (A === "Object" && T.constructor && (A = T.constructor.name), A === "Map" || A === "Set")
        return Array.from(T);
      if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A))
        return h(T, D);
    }
  }
  function h(T, D) {
    (D == null || D > T.length) && (D = T.length);
    for (var A = 0, S = new Array(D); A < D; A++)
      S[A] = T[A];
    return S;
  }
  var $ = function(D, A) {
    var S = {
      usedFields: [],
      errors: []
    }, E = v(D, A, S, !0), x = S.errors, k = S.usedFields, I = A.settings.fieldSeparator, z = {}, F = g(k), P;
    try {
      for (F.s(); !(P = F.n()).done; )
        for (var O = P.value, V = (0, i.getFieldConfig)(A, O) || {}, U = O.split(I), H = z, J = 0; J < U.length; J++) {
          var le = U[J], ae = (0, i.getFieldConfig)(A, U.slice(0, J + 1)) || {};
          J != U.length - 1 ? ae.type == "!group" && ae.mode != "struct" ? (H[le] || (H[le] = [{}]), H = H[le][0]) : (H[le] || (H[le] = {}), H = H[le]) : H[le] || (H[le] = null);
        }
    } catch (Y) {
      F.e(Y);
    } finally {
      F.f();
    }
    return {
      errors: x,
      logic: E,
      data: z
    };
  };
  ww.jsonLogicFormat = $;
  var v = function(D, A, S, E) {
    var x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (D) {
      var k = D.get("type"), I = D.get("properties") || new l.Map(), z = I.get("isLocked"), F = A.settings.jsonLogic.lockedOp, P;
      return k === "group" || k === "rule_group" ? P = b(D, A, S, E, x) : k === "rule" && (P = y(D, A, S, x)), z && P && F && (P = (0, o.default)({}, F, P)), P;
    }
  }, b = function(D, A, S, E) {
    var x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, k = D.get("type"), I = D.get("properties") || new l.Map(), z = I.get("mode"), F = D.get("children1"), P = I.get("field");
    if (F) {
      var O = I.get("conjunction");
      O || (O = (0, s.defaultConjunction)(A));
      var V = A.conjunctions[O], U = V.jsonLogicConj || O.toLowerCase(), H = I.get("not");
      if (U != "and" && U != "or") {
        S.errors.push("Conjunction ".concat(U, " is not supported"));
        return;
      }
      var J = k === "rule_group" && !E, le = J && z != "struct" ? P : x, ae = I.get("operator"), Y = ae && (0, i.getOperatorConfig)(A, ae, P) || null, re = w(A, I, S, ae, x), ie = J && (!ae || Y.cardinality == 0), _e = F.map(function(pe) {
        return v(pe, A, S, !1, le);
      }).filter(function(pe) {
        return typeof pe < "u";
      });
      if (J && z != "struct" && !ie) {
        if (re == null)
          return;
      } else if (!_e.size)
        return;
      var he = {};
      if (_e.size == 1 && !E ? he = _e.first() : he[U] = _e.toList().toJS(), H && (he = {
        "!": he
      }), J && z != "struct") {
        var be = q(S, A, P, x);
        if (ie) {
          var Q = ae || "some";
          he = (0, o.default)({}, Q, [be, he]);
        } else {
          var me = _e.size ? {
            filter: [be, he]
          } : be, ne = {
            reduce: [me, {
              "+": [1, {
                var: "accumulator"
              }]
            }, 0]
          };
          he = R(A, I, ne, re, ae);
        }
      }
      return he;
    }
  }, y = function(D, A, S) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, x = D.get("properties") || new l.Map(), k = x.get("field"), I = x.get("operator"), z = x.get("operatorOptions");
    if (z = z ? z.toJS() : null, z && !Object.keys(z).length && (z = null), !(k == null || I == null)) {
      var F = (0, i.getFieldConfig)(A, k) || {}, P = (0, i.getOperatorConfig)(A, I, k) || {}, O = P.reversedOp, V = (0, i.getOperatorConfig)(A, O, k) || {}, U = !1;
      if (!P.jsonLogic && !V.jsonLogic) {
        S.errors.push("Operator ".concat(I, " is not supported"));
        return;
      }
      if (!P.jsonLogic && V.jsonLogic) {
        U = !0;
        var H = [O, I];
        I = H[0], O = H[1];
        var J = [V, P];
        P = J[0], V = J[1];
      }
      var le = w(A, x, S, I, E);
      if (le !== void 0) {
        var ae = q(S, A, k, E);
        return R(A, x, ae, le, I, z, F, U);
      }
    }
  }, w = function(D, A, S, E, x) {
    var k = A.get("field"), I = A.get("valueSrc"), z = A.get("valueType"), F = (0, i.getFieldConfig)(D, k) || {}, P = (0, i.getOperatorConfig)(D, E, k) || {}, O = (0, r.defaultValue)(P.cardinality, 1), V = A.get("value"), U = A.get("asyncListValues");
    if (V != null) {
      var H = S.usedFields, J = V.map(function(ae, Y) {
        var re = I ? I.get(Y) : null, ie = z ? z.get(Y) : null, _e = (0, c.completeValue)(ae, re, D), he = (0, a.getWidgetForFieldOp)(D, k, E, re), be = (0, u.default)((0, i.getFieldWidgetConfig)(D, k, E, he, re), ["factory"]), Q = N(S, D, _e, re, ie, be, F, E, P, x, U);
        return Q;
      }), le = J.filter(function(ae) {
        return ae === void 0;
      }).size > 0;
      if (J.size < O || le) {
        S.usedFields = H;
        return;
      }
      return O > 1 ? J.toArray() : O == 1 ? J.first() : null;
    }
  }, N = function(D, A, S, E, x, k, I, z, F) {
    var P = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, O = arguments.length > 10 ? arguments[10] : void 0;
    if (S !== void 0) {
      var V;
      if (E == "field")
        V = q(D, A, S, P);
      else if (E == "func")
        V = M(D, A, S, P);
      else if (typeof k.jsonLogic == "function") {
        var U = k.jsonLogic, H = [
          S,
          p(p({}, (0, d.default)(I, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: O
          }),
          //useful options: valueFormat for date/time
          (0, u.default)(k, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
        ];
        z && (H.push(z), H.push(F)), V = U.apply(void 0, H);
      } else
        V = S;
      return V;
    }
  }, M = function(D, A, S) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, x = S.get("func"), k = S.get("args"), I = (0, i.getFuncConfig)(A, x);
    if (!I.jsonLogic) {
      D.errors.push("Func ".concat(x, " is not supported"));
      return;
    }
    var z = {};
    for (var F in I.args) {
      var P = I.args[F], O = (0, i.getFieldConfig)(A, P), V = k ? k.get(F) : void 0, U = V ? V.get("value") : void 0, H = V ? V.get("valueSrc") : void 0, J = N(D, A, U, H, P.type, O, P, null, null, E);
      if (U != null && J === void 0) {
        D.errors.push("Can't format value of arg ".concat(F, " for func ").concat(x));
        return;
      }
      J !== void 0 && (z[F] = J);
    }
    var le = Object.values(z), ae;
    if (typeof I.jsonLogic == "function") {
      var Y = I.jsonLogic, re = [z];
      ae = Y.apply(void 0, re);
    } else {
      var ie = I.jsonLogic || x, _e = !!I.jsonLogicIsMethod;
      if (_e) {
        var he = (0, n.default)(le), be = he[0], Q = he.slice(1);
        Q.length ? ae = {
          method: [be, ie, Q]
        } : ae = {
          method: [be, ie]
        };
      } else
        ae = (0, o.default)({}, ie, le);
    }
    return ae;
  }, q = function(D, A, S) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, x = A.settings, k = x.fieldSeparator, I = x.jsonLogic, z;
    if (S) {
      Array.isArray(S) && (S = S.join(k));
      var F = (0, i.getFieldConfig)(A, S) || {}, P = S;
      if (F.fieldName && (P = F.fieldName), E) {
        var O = (0, i.getFieldConfig)(A, E) || {}, V = E;
        O.fieldName && (V = O.fieldName), P.indexOf(V + k) == 0 ? P = P.slice((V + k).length) : D.errors.push("Can't cut group ".concat(V, " from field ").concat(P));
      }
      var U = F.jsonLogicVar || (F.type == "!group" ? I.groupVarKey : "var");
      z = (0, o.default)({}, U, P), D.usedFields.indexOf(S) == -1 && D.usedFields.push(S);
    }
    return z;
  }, L = function(D, A, S, E) {
    var x = D, k = (0, r.defaultValue)(A.cardinality, 1), I = (0, r.defaultValue)(A._jsonLogicIsRevArgs, !1);
    typeof A.jsonLogic == "string" && (x = A.jsonLogic);
    var z = ["<", "<=", ">", ">="], F = ["==", "!="], P = function(V, U, H, J, le) {
      return k == 0 && F.includes(x) ? (0, o.default)({}, x, [S, null]) : k == 0 ? (0, o.default)({}, x, S) : k == 1 && I ? (0, o.default)({}, x, [E, S]) : k == 1 ? (0, o.default)({}, x, [S, E]) : k == 2 && z.includes(x) ? (0, o.default)({}, x, [E[0], S, E[1]]) : (0, o.default)({}, x, [S].concat((0, t.default)(E)));
    };
    return P;
  }, R = function(D, A, S, E, x) {
    var k = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, I = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, z = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : !1, F = A.get("field"), P = (0, i.getOperatorConfig)(D, x, F) || {}, O = typeof P.jsonLogic == "function" ? P.jsonLogic : L(x, P, S, E), V = [S, x, E, (0, u.default)(P, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), k, I], U = O.apply(void 0, V);
    return z && (U = {
      "!": U
    }), U;
  };
  return ww;
}
var vh = {}, voe;
function Iru() {
  if (voe)
    return vh;
  voe = 1;
  var e = Tn;
  Object.defineProperty(vh, "__esModule", {
    value: !0
  }), vh.mongodbFormat = vh._mongodbFormat = void 0;
  var t = e(Gu()), n = e(Yr()), o = e(Zu), r = e(xo), i = Ti(), a = Qi(), s = Es(), c = kl(), l = Lv(), u = e(Of()), d = e(Dv()), _ = uc(), p = v$();
  function g(R, T) {
    var D = Object.keys(R);
    if (Object.getOwnPropertySymbols) {
      var A = Object.getOwnPropertySymbols(R);
      T && (A = A.filter(function(S) {
        return Object.getOwnPropertyDescriptor(R, S).enumerable;
      })), D.push.apply(D, A);
    }
    return D;
  }
  function f(R) {
    for (var T = 1; T < arguments.length; T++) {
      var D = arguments[T] != null ? arguments[T] : {};
      T % 2 ? g(Object(D), !0).forEach(function(A) {
        (0, n.default)(R, A, D[A]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(D)) : g(Object(D)).forEach(function(A) {
        Object.defineProperty(R, A, Object.getOwnPropertyDescriptor(D, A));
      });
    }
    return R;
  }
  var h = function(T) {
    return (0, r.default)(T) == "object" && T !== null && !Array.isArray(T);
  }, $ = function(T, D) {
    return v(T, D, !1);
  };
  vh.mongodbFormat = $;
  var v = function(T, D) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, S = {
      errors: []
    }, E = b([], T, D, S);
    return A ? [E, S.errors] : (S.errors.length && console.warn("Errors while exporting to MongoDb:", S.errors), E);
  };
  vh._mongodbFormat = v;
  var b = function(T, D, A, S) {
    var E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, x = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0, k = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : void 0, I = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : void 0;
    if (D) {
      var z = D.get("type");
      if (z === "group" || z === "rule_group")
        return y(T, D, A, S, E, x, k, I);
      if (z === "rule")
        return w(T, D, A, S, E, x, k, I);
    }
  }, y = function(T, D, A, S) {
    var E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, x = D.get("type"), k = D.get("properties") || new _.Map(), I = D.get("children1"), z = A.settings.canShortMongoQuery;
    if (I) {
      var F = T.filter(function(ge) {
        return ge.get("type") == "rule_group";
      }).length > 0, P = T.filter(function(ge) {
        return ge.get("type") == "rule_group";
      }).map(function(ge) {
        return ge.get("properties").get("field");
      }).slice(-1).pop(), O = F && P, V = x === "rule_group" ? k.get("field") : null, U = M(V, A, S, O), H = (0, a.getFieldConfig)(A, V) || {}, J = H.mode, le = V && J == "array", ae = E ? !k.get("not") : k.get("not"), Y = I.map(function(ge) {
        return b([].concat((0, o.default)(T), [D]), ge, A, S, ae, !0, J == "array" ? function(ve) {
          return "$$el.".concat(ve);
        } : void 0);
      }).filter(function(ge) {
        return typeof ge < "u";
      });
      if (!(!le && !Y.size)) {
        var re = k.get("conjunction");
        re || (re = (0, c.defaultConjunction)(A));
        var ie = A.conjunctions[re], _e = ie.reversedConj;
        ae && _e && (re = _e, ie = A.conjunctions[re]);
        var he = ie.mongoConj, be;
        if (Y.size == 1)
          be = Y.first();
        else if (Y.size > 1) {
          var Q = Y.toList().toJS(), me = z && he == "$and";
          me && (be = Q.reduce(function(ge, ve) {
            if (ge) {
              for (var Te in ve) {
                if (Te[0] == "$") {
                  ge = void 0;
                  break;
                }
                if (ge[Te] == null)
                  ge[Te] = ve[Te];
                else {
                  var Re = ge[Te], Me = ve[Te];
                  h(Re) || (Re = {
                    $eq: Re
                  }), h(Me) || (Me = {
                    $eq: Me
                  });
                  var et = Object.keys(Re)[0], st = Object.keys(Me)[0];
                  if (et == st) {
                    ge = void 0;
                    break;
                  }
                  ge[Te] = Object.assign({}, Re, Me);
                }
              }
              return ge;
            }
          }, {})), be || (be = (0, n.default)({}, he, Q));
        }
        if (V)
          if (J == "array") {
            var ne = {
              $size: U
            }, pe = be ? {
              $size: {
                $filter: {
                  input: "$" + U,
                  as: "el",
                  cond: be
                }
              }
            } : ne;
            be = b(T, D.set("type", "rule"), A, S, !1, !1, function(ge) {
              return pe;
            }, ne), be = {
              $expr: be
            };
          } else
            be = (0, n.default)({}, U, {
              $elemMatch: be
            });
        return be;
      }
    }
  }, w = function(T, D, A, S) {
    var E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, x = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0, k = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : void 0, I = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : void 0, z = D.get("properties") || new _.Map(), F = T.filter(function(je) {
      return je.get("type") == "rule_group";
    }).length > 0, P = T.filter(function(je) {
      return je.get("type") == "rule_group";
    }).map(function(je) {
      return je.get("properties").get("field");
    }).slice(-1).pop(), O = F && P, V = z.get("operator"), U = z.get("operatorOptions"), H = z.get("field"), J = z.get("value"), le = z.get("valueSrc"), ae = z.get("valueType"), Y = z.get("asyncListValues");
    if (!(H == null || V == null || J === void 0)) {
      var re = (0, a.getFieldConfig)(A, H) || {}, ie = (0, a.getOperatorConfig)(A, V, H) || {}, _e = ie.reversedOp, he = (0, a.getOperatorConfig)(A, _e, H) || {}, be = (0, i.defaultValue)(ie.cardinality, 1), Q = E;
      if (Q && _e) {
        var me = [_e, V];
        V = me[0], _e = me[1];
        var ne = [he, ie];
        ie = ne[0], he = ne[1], Q = !1;
      }
      var pe = M(H, A, S, O), ge = [], ve = [], Te = !1, Re = J.map(function(je, He) {
        var Xe = le ? le.get(He) : null, at = ae ? ae.get(He) : null, wt = (0, l.completeValue)(je, Xe, A), Je = (0, s.getWidgetForFieldOp)(A, H, V, Xe), vt = (0, u.default)((0, a.getFieldWidgetConfig)(A, H, V, Je, Xe), ["factory"]), Ot = N(S, A, wt, Xe, at, vt, re, O, V, ie, Y), Ft = (0, t.default)(Ot, 2), wn = Ft[0], un = Ft[1];
        return wn !== void 0 && (Te = Te || un, ge.push(Xe), ve.push(at)), wn;
      });
      k && (Te = !0);
      var Me = Te && x, et = Re.filter(function(je) {
        return je === void 0;
      }).size > 0;
      if (!(Re.size < be || et)) {
        var st = be > 1 ? Re.toArray() : be == 1 ? Re.first() : null, De = ie.mongoFormatOp;
        if (!De) {
          S.errors.push("Operator ".concat(V, " is not supported"));
          return;
        }
        var ze = [k ? k(pe) : pe, V, I !== void 0 && st == null ? I : st, Te, ge.length > 1 ? ge : ge[0], ve.length > 1 ? ve : ve[0], (0, u.default)(ie, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), U, re], Pe = De.apply(void 0, ze);
        return Me && (Pe = {
          $expr: Pe
        }), Q && (Pe = {
          $not: Pe
        }), Pe;
      }
    }
  }, N = function(T, D, A, S, E, x, k, I, z, F, P) {
    if (A === void 0)
      return [void 0, !1];
    var O, V = !1;
    if (S == "field") {
      var U = q(T, D, A, I), H = (0, t.default)(U, 2);
      O = H[0], V = H[1];
    } else if (S == "func") {
      var J = L(T, D, A, I), le = (0, t.default)(J, 2);
      O = le[0], V = le[1];
    } else if (typeof x.mongoFormatValue == "function") {
      var ae = x.mongoFormatValue, Y = [
        A,
        f(f({}, (0, d.default)(k, ["fieldSettings", "listValues"])), {}, {
          asyncListValues: P
        }),
        //useful options: valueFormat for date/time
        (0, u.default)(x, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
      ];
      z && (Y.push(z), Y.push(F)), O = ae.apply(void 0, Y);
    } else
      O = A;
    return [O, V];
  }, M = function(T, D, A, S) {
    if (T) {
      var E = (0, a.getFieldConfig)(D, T) || {}, x = D.settings.fieldSeparator;
      Array.isArray(T) || T.split(x);
      var k = Array.isArray(T) ? T.join(x) : T;
      if (E.fieldName && (k = E.fieldName), S) {
        var I = (0, a.getFieldConfig)(D, S) || {}, z = S;
        I.fieldName && (z = I.fieldName), k.indexOf(z + ".") == 0 ? k = k.slice((z + ".").length) : A.errors.push("Can't cut group ".concat(z, " from field ").concat(k));
      }
      return k;
    }
  }, q = function(T, D, A, S) {
    var E = D.settings.fieldSeparator, x, k = !0;
    if (A) {
      var I = (0, a.getFieldConfig)(D, A) || {}, z = Array.isArray(A) ? A : A.split(E);
      (0, s.getFieldPath)(A, D);
      var F = (0, s.getFieldPathLabels)(A, D), P = F ? F.join(E) : null, O = D.settings.formatField || p.settings.formatField, V = M(A, D, T, S), U = O(V, z, P, I, D, !1);
      x = "$" + U;
    }
    return [x, k];
  }, L = function(T, D, A, S) {
    var E = !0, x, k = A.get("func"), I = A.get("args"), z = (0, a.getFuncConfig)(D, k), F = z.mongoFunc || k, P = z.mongoArgsAsObject, O = {}, V = 0, U = void 0;
    for (var H in z.args) {
      var J = z.args[H], le = (0, a.getFieldConfig)(D, J), ae = I ? I.get(H) : void 0, Y = ae ? ae.get("value") : void 0, re = ae ? ae.get("valueSrc") : void 0, ie = ae ? ae.get("asyncListValues") : void 0, _e = (0, s.getWidgetForFieldOp)(D, le, null, re), he = (0, u.default)((0, a.getFieldWidgetConfig)(D, le, null, _e, re), ["factory"]), be = N(T, D, Y, re, J.type, he, le, S, null, null, ie), Q = (0, t.default)(be, 2), me = Q[0];
      if (Q[1], Y != null && me === void 0)
        return T.errors.push("Can't format value of arg ".concat(H, " for func ").concat(k)), [void 0, !1];
      V++, me !== void 0 && (O[H] = me, U = me);
    }
    if (typeof z.mongoFormatFunc == "function") {
      var ne = z.mongoFormatFunc, pe = [O];
      x = ne.apply(void 0, pe);
    } else {
      if (z.mongoFormatFunc === null)
        return T.errors.push("Functon ".concat(F, " is not supported")), [void 0, !1];
      P ? x = (0, n.default)({}, F, O) : V == 1 && U !== void 0 ? x = (0, n.default)({}, F, U) : x = (0, n.default)({}, F, Object.values(O));
    }
    return [x, E];
  };
  return vh;
}
var bh = {}, tc = {}, NL = {}, boe;
function Oru() {
  return boe || (boe = 1, function(e) {
    var t = e, n = /`/g, o = /\./g, r = /[\0\b\t\n\r\x1a\"\'\\]/g, i = {
      "\0": "\\0",
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\r": "\\r",
      "": "\\Z",
      '"': '\\"',
      "'": "\\'",
      "\\": "\\\\"
    };
    t.escapeId = function(u, d) {
      if (Array.isArray(u)) {
        for (var _ = "", p = 0; p < u.length; p++)
          _ += (p === 0 ? "" : ", ") + t.escapeId(u[p], d);
        return _;
      } else
        return d ? "`" + String(u).replace(n, "``") + "`" : "`" + String(u).replace(n, "``").replace(o, "`.`") + "`";
    }, t.escape = function(u, d, _) {
      if (u == null)
        return "NULL";
      switch (typeof u) {
        case "boolean":
          return u ? "true" : "false";
        case "number":
          return u + "";
        case "object":
          return Object.prototype.toString.call(u) === "[object Date]" ? t.dateToString(u, _ || "local") : Array.isArray(u) ? t.arrayToList(u, _) : Buffer.isBuffer(u) ? t.bufferToString(u) : typeof u.toSqlString == "function" ? String(u.toSqlString()) : d ? a(u.toString()) : t.objectToValues(u, _);
        default:
          return a(u);
      }
    }, t.arrayToList = function(u, d) {
      for (var _ = "", p = 0; p < u.length; p++) {
        var g = u[p];
        Array.isArray(g) ? _ += (p === 0 ? "" : ", ") + "(" + t.arrayToList(g, d) + ")" : _ += (p === 0 ? "" : ", ") + t.escape(g, !0, d);
      }
      return _;
    }, t.format = function(u, d, _, p) {
      if (d == null)
        return u;
      Array.isArray(d) || (d = [d]);
      for (var g = 0, f = /\?+/g, h = "", $ = 0, v; $ < d.length && (v = f.exec(u)); ) {
        var b = v[0].length;
        if (!(b > 2)) {
          var y = b === 2 ? t.escapeId(d[$]) : t.escape(d[$], _, p);
          h += u.slice(g, v.index) + y, g = f.lastIndex, $++;
        }
      }
      return g === 0 ? u : g < u.length ? h + u.slice(g) : h;
    }, t.dateToString = function(u, d) {
      var _ = new Date(u);
      if (isNaN(_.getTime()))
        return "NULL";
      var p, g, f, h, $, v, b;
      if (d === "local")
        p = _.getFullYear(), g = _.getMonth() + 1, f = _.getDate(), h = _.getHours(), $ = _.getMinutes(), v = _.getSeconds(), b = _.getMilliseconds();
      else {
        var y = c(d);
        y !== !1 && y !== 0 && _.setTime(_.getTime() + y * 6e4), p = _.getUTCFullYear(), g = _.getUTCMonth() + 1, f = _.getUTCDate(), h = _.getUTCHours(), $ = _.getUTCMinutes(), v = _.getUTCSeconds(), b = _.getUTCMilliseconds();
      }
      var w = s(p, 4) + "-" + s(g, 2) + "-" + s(f, 2) + " " + s(h, 2) + ":" + s($, 2) + ":" + s(v, 2) + "." + s(b, 3);
      return a(w);
    }, t.bufferToString = function(u) {
      return "X" + a(u.toString("hex"));
    }, t.objectToValues = function(u, d) {
      var _ = "";
      for (var p in u) {
        var g = u[p];
        typeof g != "function" && (_ += (_.length === 0 ? "" : ", ") + t.escapeId(p) + " = " + t.escape(g, !0, d));
      }
      return _;
    }, t.raw = function(u) {
      if (typeof u != "string")
        throw new TypeError("argument sql must be a string");
      return {
        toSqlString: function() {
          return u;
        }
      };
    };
    function a(l) {
      for (var u = r.lastIndex = 0, d = "", _; _ = r.exec(l); )
        d += l.slice(u, _.index) + i[_[0]], u = r.lastIndex;
      return u === 0 ? "'" + l + "'" : u < l.length ? "'" + d + l.slice(u) + "'" : "'" + d + "'";
    }
    function s(l, u) {
      for (l = l.toString(); l.length < u; )
        l = "0" + l;
      return l;
    }
    function c(l) {
      if (l === "Z")
        return 0;
      var u = l.match(/([\+\-\s])(\d\d):?(\d\d)?/);
      return u ? (u[1] === "-" ? -1 : 1) * (parseInt(u[2], 10) + (u[3] ? parseInt(u[3], 10) : 0) / 60) * 60 : !1;
    }
  }(NL)), NL;
}
var zL, yoe;
function Nru() {
  return yoe || (yoe = 1, zL = Oru()), zL;
}
var $oe;
function I2() {
  if ($oe)
    return tc;
  $oe = 1;
  var e = Tn;
  Object.defineProperty(tc, "__esModule", {
    value: !0
  }), tc.sqlEmptyValue = tc.spelImportConcat = tc.spelFormatConcat = tc.spelFixList = tc.spelEscape = tc.mongoEmptyValue = tc.SqlString = void 0;
  var t = e(xo), n = Nru();
  tc.SqlString = n, n.trim = function(d) {
    return d.charAt(0) == "'" ? d.substring(1, d.length - 1) : d;
  }, n.escapeLike = function(d) {
    var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, g = n.escape(d);
    return g = n.trim(g), g = g.replace(/[%_]/g, "\\$&"), g = (_ ? "%" : "") + g + (p ? "%" : ""), g = "'" + g + "'", g;
  };
  var o = function(_) {
    var p = "''", g = _ == null ? void 0 : _.type;
    return g == "date" ? p = "'0000-00-00'" : g == "datetime" ? p = "'0000-00-00 00:00'" : g == "time" ? p = "'00:00'" : g == "number" && (p = "0"), p;
  };
  tc.sqlEmptyValue = o;
  var r = function(_) {
    var p = "", g = _ == null ? void 0 : _.type;
    return g == "number" && (p = 0), p;
  };
  tc.mongoEmptyValue = r;
  var i = function(_) {
    return "'" + _.replace(/'/g, "''") + "'";
  }, a = function(_) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g, f, h = ["int", "float"];
    _.map(function(b) {
      if (b != null) {
        if (typeof b == "string")
          f = "String";
        else if (typeof b == "number")
          f = Number.isInteger(b) ? "int" : "float";
        else
          throw new Error("spelEscape: Can't use value ".concat(b, " in array"));
        if (!g)
          g = f;
        else if (g != f)
          if (h.includes(g) && h.includes(f))
            g = "float";
          else
            throw new Error("spelEscape: Can't use different types in array: found ".concat(g, " and ").concat(f));
      }
    }), g || (g = "String");
    var $;
    g == "float" ? $ = _.map(function(b) {
      return c(b, !0);
    }) : $ = _.map(function(b) {
      return c(b);
    });
    var v;
    return p ? v = "new ".concat(g, "[]{").concat($.join(", "), "}") : v = "{".concat($.join(", "), "}"), v;
  }, s = function(_) {
    return "".concat(_, ".?[true]");
  };
  tc.spelFixList = s;
  var c = function(_) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (_ == null)
      return "null";
    switch ((0, t.default)(_)) {
      case "boolean":
        return _ ? "true" : "false";
      case "number":
        return !Number.isFinite(_) || isNaN(_) ? void 0 : _ + (!Number.isInteger(_) || p ? "f" : "");
      case "object":
        if (Array.isArray(_))
          return a(_, g);
        throw new Error("spelEscape: Object is not supported");
      default:
        return i(_);
    }
  };
  tc.spelEscape = c;
  var l = function(_) {
    return _ && Array.isArray(_) && _.length ? _.map(function(p) {
      if (p.type == "const")
        return c(p.value);
      if (p.type == "property")
        return "" + p.value;
      if (p.type == "variable")
        return "#" + p.value;
    }).filter(function(p) {
      return p != null;
    }).join(" + ") : "null";
  };
  tc.spelFormatConcat = l;
  var u = function(_) {
    if (_ == null)
      return [void 0, []];
    var p = [], g = _.valueType == "case_value" ? _.value : [_], f = g.map(function(h) {
      if (h.valueSrc == "value")
        return h.value === null ? void 0 : {
          type: "const",
          value: h.value
        };
      if (h.valueSrc == "field")
        return {
          type: h.isVariable ? "variable" : "property",
          value: h.value
        };
      p.push("Unsupported valueSrc ".concat(h.valueSrc, " in concatenation"));
    }).filter(function(h) {
      return h != null;
    });
    return [f, p];
  };
  return tc.spelImportConcat = u, tc;
}
var woe;
function zru() {
  if (woe)
    return bh;
  woe = 1;
  var e = Tn;
  Object.defineProperty(bh, "__esModule", {
    value: !0
  }), bh.sqlFormat = bh._sqlFormat = void 0;
  var t = e(Gu()), n = e(Yr()), o = Qi(), r = Es(), i = e(Of()), a = e(Dv()), s = Ti(), c = kl(), l = v$(), u = Lv(), d = uc(), _ = I2();
  function p(q, L) {
    var R = Object.keys(q);
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(q);
      L && (T = T.filter(function(D) {
        return Object.getOwnPropertyDescriptor(q, D).enumerable;
      })), R.push.apply(R, T);
    }
    return R;
  }
  function g(q) {
    for (var L = 1; L < arguments.length; L++) {
      var R = arguments[L] != null ? arguments[L] : {};
      L % 2 ? p(Object(R), !0).forEach(function(T) {
        (0, n.default)(q, T, R[T]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(R)) : p(Object(R)).forEach(function(T) {
        Object.defineProperty(q, T, Object.getOwnPropertyDescriptor(R, T));
      });
    }
    return q;
  }
  var f = function(L, R) {
    return h(L, R, !1);
  };
  bh.sqlFormat = f;
  var h = function(L, R) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, D = {
      errors: []
    }, A = $(L, R, D);
    return T ? [A, D.errors] : (D.errors.length && console.warn("Errors while exporting to SQL:", D.errors), A);
  };
  bh._sqlFormat = h;
  var $ = function(L, R, T) {
    if (L) {
      var D = L.get("type"), A = L.get("children1");
      if ((D === "group" || D === "rule_group") && A && A.size)
        return v(L, R, T);
      if (D === "rule")
        return y(L, R, T);
    }
  }, v = function(L, R, T) {
    var D = L.get("type"), A = L.get("properties") || new d.Map(), S = L.get("children1"), E = D === "rule_group" ? A.get("field") : null, x = (0, o.getFieldConfig)(R, E) || {};
    x.mode == "array" && T.errors.push("Aggregation is not supported for ".concat(E));
    var k = A.get("not"), I = S.map(function(P) {
      return $(P, R, T);
    }).filter(function(P) {
      return typeof P < "u";
    });
    if (I.size) {
      var z = A.get("conjunction");
      z || (z = (0, c.defaultConjunction)(R));
      var F = R.conjunctions[z];
      return F.sqlFormatConj(I, z, k);
    }
  }, b = function(L, R) {
    var T = R.sqlOp || L, D = (0, s.defaultValue)(R.cardinality, 1), A;
    return D == 0 ? A = function(E, x, k, I, z, F, P, O) {
      return "".concat(E, " ").concat(T);
    } : D == 1 ? A = function(E, x, k, I, z, F, P, O) {
      return "".concat(E, " ").concat(T, " ").concat(k);
    } : D == 2 && (A = function(E, x, k, I, z, F, P, O) {
      var V = k.first(), U = k.get(1);
      return "".concat(E, " ").concat(T, " ").concat(V, " AND ").concat(U);
    }), A;
  }, y = function(L, R, T) {
    var D = L.get("properties") || new d.Map(), A = D.get("field"), S = D.get("operator"), E = D.get("operatorOptions"), x = D.get("valueSrc"), k = D.get("valueType"), I = D.get("value"), z = D.get("asyncListValues");
    if (!(A == null || S == null)) {
      var F = (0, o.getFieldConfig)(R, A) || {}, P = (0, o.getOperatorConfig)(R, S, A) || {}, O = P.reversedOp, V = (0, o.getOperatorConfig)(R, O, A) || {}, U = (0, s.defaultValue)(P.cardinality, 1), H = !1, J = P.sqlOp || P.sqlFormatOp, le = V.sqlOp || V.sqlFormatOp;
      if (!J && !le) {
        T.errors.push("Operator ".concat(S, " is not supported"));
        return;
      }
      if (!le && le) {
        H = !0;
        var ae = [O, S];
        S = ae[0], O = ae[1];
        var Y = [V, P];
        P = Y[0], V = Y[1];
      }
      var re = [], ie = [], _e = I.map(function(ge, ve) {
        var Te = x ? x.get(ve) : null, Re = k ? k.get(ve) : null, Me = (0, u.completeValue)(ge, Te, R), et = (0, r.getWidgetForFieldOp)(R, A, S, Te), st = (0, i.default)((0, o.getFieldWidgetConfig)(R, A, S, et, Te), ["factory"]), De = w(T, R, Me, Te, Re, st, F, S, P, z);
        return De !== void 0 && (re.push(Te), ie.push(Re)), De;
      }), he = _e.filter(function(ge) {
        return ge === void 0;
      }).size > 0;
      if (!(he || _e.size < U)) {
        var be = U == 1 ? _e.first() : _e, Q = P.sqlFormatOp || b(S, P);
        if (!Q) {
          T.errors.push("Operator ".concat(S, " is not supported"));
          return;
        }
        var me = N(T, R, A), ne = [me, S, be, re.length > 1 ? re : re[0], ie.length > 1 ? ie : ie[0], (0, i.default)(P, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), E, F], pe;
        if (pe = Q.apply(void 0, ne), H && (pe = R.settings.sqlFormatReverse(pe)), pe === void 0) {
          T.errors.push("Operator ".concat(S, " is not supported for value source ").concat(re.join(", ")));
          return;
        }
        return pe;
      }
    }
  }, w = function(L, R, T, D, A, S, E, x, k, I) {
    if (T !== void 0) {
      var z;
      if (D == "field")
        z = N(L, R, T);
      else if (D == "func")
        z = M(L, R, T);
      else if (typeof S.sqlFormatValue == "function") {
        var F = S.sqlFormatValue, P = [
          T,
          g(g({}, (0, a.default)(E, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: I
          }),
          //useful options: valueFormat for date/time
          (0, i.default)(S, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
        ];
        if (x && (P.push(x), P.push(k)), D == "field") {
          var O = (0, o.getFieldConfig)(R, T) || {};
          P.push(O);
        }
        z = F.apply(void 0, P);
      } else
        z = _.SqlString.escape(T);
      return z;
    }
  }, N = function(L, R, T) {
    if (T) {
      var D = R.settings.fieldSeparator, A = (0, o.getFieldConfig)(R, T) || {}, S = Array.isArray(T) ? T : T.split(D);
      (0, r.getFieldPath)(T, R);
      var E = (0, r.getFieldPathLabels)(T, R), x = E ? E.join(D) : null, k = R.settings.formatField || l.settings.formatField, I = (0, r.formatFieldName)(T, R, L), z = k(I, S, x, A, R);
      return z;
    }
  }, M = function(L, R, T) {
    var D = T.get("func"), A = T.get("args"), S = (0, o.getFuncConfig)(R, D), E = S.sqlFunc || D, x = {};
    for (var k in S.args) {
      var I = S.args[k], z = (0, o.getFieldConfig)(R, I), F = A ? A.get(k) : void 0, P = F ? F.get("value") : void 0, O = F ? F.get("valueSrc") : void 0, V = F ? F.get("asyncListValues") : void 0, U = w(L, R, P, O, I.type, z, I, null, null, V);
      if (P != null && U === void 0) {
        L.errors.push("Can't format value of arg ".concat(k, " for func ").concat(D));
        return;
      }
      U !== void 0 && (x[k] = U);
    }
    var H;
    if (typeof S.sqlFormatFunc == "function") {
      var J = S.sqlFormatFunc, le = [x];
      H = J.apply(void 0, le);
    } else {
      var ae = Object.entries(x).map(function(Y) {
        var re = (0, t.default)(Y, 2);
        re[0];
        var ie = re[1];
        return ie;
      }).join(", ");
      H = "".concat(E, "(").concat(ae, ")");
    }
    return H;
  };
  return bh;
}
var yh = {}, koe;
function Rru() {
  if (koe)
    return yh;
  koe = 1;
  var e = Tn;
  Object.defineProperty(yh, "__esModule", {
    value: !0
  }), yh.spelFormat = yh._spelFormat = void 0;
  var t = e(UV()), n = e(Yr()), o = e(Gu()), r = Qi(), i = Es(), a = e(Of()), s = e(Dv()), c = Ti(), l = kl();
  v$();
  var u = Lv(), d = uc(), _ = I2();
  function p(A, S) {
    var E = Object.keys(A);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(A);
      S && (x = x.filter(function(k) {
        return Object.getOwnPropertyDescriptor(A, k).enumerable;
      })), E.push.apply(E, x);
    }
    return E;
  }
  function g(A) {
    for (var S = 1; S < arguments.length; S++) {
      var E = arguments[S] != null ? arguments[S] : {};
      S % 2 ? p(Object(E), !0).forEach(function(x) {
        (0, n.default)(A, x, E[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(E)) : p(Object(E)).forEach(function(x) {
        Object.defineProperty(A, x, Object.getOwnPropertyDescriptor(E, x));
      });
    }
    return A;
  }
  var f = function(S, E) {
    return h(S, E, !1);
  };
  yh.spelFormat = f;
  var h = function(S, E) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, k = {
      errors: []
    }, I = $(S, E, k, null);
    return x ? [I, k.errors] : (k.errors.length && console.warn("Errors while exporting to SpEL:", k.errors), I);
  };
  yh._spelFormat = h;
  var $ = function(S, E, x) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (S) {
      var I = S.get("type");
      if (I === "group" || I === "rule_group")
        return y(S, E, x, k);
      if (I === "rule")
        return q(S, E, x, k);
      if (I == "switch_group")
        return b(S, E, x);
      if (I == "case_group")
        return v(S, E, x, k);
    }
  }, v = function(S, E, x) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, I = S.get("type");
    if (I != "case_group") {
      x.errors.push("Unexpected child of type ".concat(I, " inside switch"));
      return;
    }
    var z = S.get("properties") || new d.Map(), F = L(E, z, x, null, k, "!case_value"), P = (0, o.default)(F, 3), O = P[0];
    P[1], P[2];
    var V = y(S, E, x, k);
    return [V, O];
  }, b = function(S, E, x) {
    S.get("properties") || new d.Map();
    var k = S.get("children1");
    if (k) {
      var I = k.map(function(le) {
        return v(le, E, x, null);
      }).filter(function(le) {
        return typeof le < "u";
      }).toArray();
      if (I.length) {
        if (I.length == 1 && !I[0][0])
          return I[0][1];
        for (var z = [], F = 0; F < I.length; F++)
          F != I.length - 1 && !I[F][0] ? x.errors.push("No condition for case ".concat(F)) : (z.push(I[F]), F == I.length - 1 && I[F][0] && z.push([void 0, null]));
        for (var P = "", O = "", V = 0; V < z.length; V++) {
          var U = (0, o.default)(z[V], 2), H = U[0], J = U[1];
          J == null && (J = "null"), H == null && (H = "true"), V != z.length - 1 ? (P += "(".concat(H, " ? ").concat(J, " : "), O += ")") : P += "".concat(J);
        }
        return P + O;
      }
    }
  }, y = function(S, E, x) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, I = S.get("type"), z = S.get("properties") || new d.Map(), F = z.get("mode"), P = S.get("children1"), O = z.get("field");
    if (P) {
      var V = z.get("conjunction");
      V || (V = (0, l.defaultConjunction)(E));
      var U = E.conjunctions[V], H = z.get("not"), J = I === "rule_group", le = J && F != "struct", ae = le ? O : k, Y = (0, r.getFieldConfig)(E, ae) || {}, re = Y.isSpelArray, ie = z.get("operator");
      !ie && (!F || F == "some") && (ie = "some");
      var _e = M(E, ie, O), he = _e != ie, be = ie && (0, r.getOperatorConfig)(E, _e, O) || null, Q = J && (!_e || be.cardinality == 0), me = L(E, z, x, _e, k, null), ne = (0, o.default)(me, 3), pe = ne[0], ge = ne[1], ve = ne[2], Te = P.map(function(He) {
        return $(He, E, x, ae);
      }).filter(function(He) {
        return typeof He < "u";
      });
      if (le && !Q) {
        if (pe == null)
          return;
      } else if (!Te.size)
        return;
      var Re = J, Me = Te.size ? U.spelFormatConj(Te, V, H, Re) : null, et;
      if (le) {
        var st = T(x, E, O, k), De = re ? ".length" : ".size()", ze = "".concat(st).concat(De), Pe = Me ? "".concat(st, ".?[").concat(Me, "]").concat(De) : ze, je = Q ? ze : pe;
        et = N(x, E, z, Pe, je, _e, ge, ve, he);
      } else
        et = Me;
      return et;
    }
  }, w = function(S, E) {
    var x = E.spelOp;
    if (x) {
      var k = x[0] == "$", I = x[0] == "." || k, z = I ? x.slice(1) : x, F, P = (0, c.defaultValue)(E.cardinality, 1);
      return P == 0 ? F = function(V, U, H, J, le, ae, Y, re) {
        return I ? "".concat(V, ".").concat(z, "()") : "".concat(V, " ").concat(z);
      } : P == 1 && (F = function(V, U, H, J, le, ae, Y, re) {
        return k ? "".concat(H, ".").concat(z, "(").concat(V, ")") : I ? "".concat(V, ".").concat(z, "(").concat(H, ")") : "".concat(V, " ").concat(z, " ").concat(H);
      }), F;
    }
  }, N = function(S, E, x, k, I, z, F, P) {
    var O = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, V = x.get("field"), U = (0, r.getOperatorConfig)(E, z, V) || {}, H = (0, r.getFieldConfig)(E, V) || {}, J = x.get("operatorOptions"), le = U.spelFormatOp || w(z, U);
    if (!le) {
      S.errors.push("Operator ".concat(z, " is not supported"));
      return;
    }
    var ae = [k, z, I, F, P, (0, a.default)(U, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), J, H], Y;
    return Y = le.apply(void 0, ae), O && (Y = E.settings.spelFormatReverse(Y)), Y === void 0 && S.errors.push("Operator ".concat(z, " is not supported for value source ").concat(F)), Y;
  }, M = function(S, E, x) {
    if (E) {
      var k = (0, r.getOperatorConfig)(S, E, x) || {}, I = k.reversedOp, z = (0, r.getOperatorConfig)(S, I, x) || {}, F = k.spelOp || k.spelFormatOp, P = z.spelOp || z.spelFormatOp;
      if (!(!F && !P)) {
        if (!F && P) {
          var O = [I, E];
          E = O[0], I = O[1];
          var V = [z, k];
          k = V[0], z = V[1];
        }
        return E;
      }
    }
  }, q = function(S, E, x) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, I = S.get("properties") || new d.Map(), z = I.get("field"), F = I.get("operator");
    if (!(z == null || F == null)) {
      var P = M(E, F, z);
      if (!P) {
        x.errors.push("Operator ".concat(F, " is not supported"));
        return;
      }
      var O = P != F, V = L(E, I, x, P, k, null), U = (0, o.default)(V, 3), H = U[0], J = U[1], le = U[2];
      if (H !== void 0) {
        var ae = T(x, E, z, k), Y = N(x, E, I, ae, H, P, J, le, O);
        return Y;
      }
    }
  }, L = function(S, E, x, k, I) {
    var z = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, F = E.get("field"), P = E.get("valueSrc"), O = E.get("valueType");
    (z == "!case_value" || O && O.get(0) == "case_value") && (F = "!case_value");
    var V = (0, r.getFieldConfig)(S, F) || {}, U = (0, r.getOperatorConfig)(S, k, F) || {}, H = (0, c.defaultValue)(U.cardinality, 1), J = E.get("value"), le = E.get("asyncListValues"), ae = [], Y = [], re;
    if (J != null) {
      var ie = J.map(function(he, be) {
        var Q = P ? P.get(be) : null, me = O ? O.get(be) : null, ne = (0, u.completeValue)(he, Q, S), pe = (0, i.getWidgetForFieldOp)(S, F, k, Q), ge = (0, a.default)((0, r.getFieldWidgetConfig)(S, F, k, pe, Q), ["factory"]), ve = R(x, S, ne, Q, me, ge, V, k, U, I, le);
        return ve !== void 0 && (ae.push(Q), Y.push(me)), ve;
      }), _e = ie.filter(function(he) {
        return he === void 0;
      }).size > 0;
      ie.size < H || _e || (re = H > 1 ? ie.toArray() : H == 1 ? ie.first() : null);
    }
    return [re, ae.length > 1 ? ae : ae[0], Y.length > 1 ? Y : Y[0]];
  }, R = function(S, E, x, k, I, z, F, P, O) {
    var V = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, U = arguments.length > 10 ? arguments[10] : void 0;
    if (x !== void 0) {
      var H;
      if (k == "field")
        H = T(S, E, x, V);
      else if (k == "func")
        H = D(S, E, x, V);
      else if (typeof z.spelFormatValue == "function") {
        var J = z.spelFormatValue, le = [
          x,
          g(g({}, (0, s.default)(F, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: U
          }),
          //useful options: valueFormat for date/time
          (0, a.default)(z, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
        ];
        if (P && (le.push(P), le.push(O)), k == "field") {
          var ae = (0, r.getFieldConfig)(E, x) || {};
          le.push(ae);
        }
        H = J.apply(void 0, le);
      } else
        H = (0, _.spelEscape)(x);
      return H;
    }
  }, T = function(S, E, x) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (x) {
      var I = E.settings.fieldSeparator, z = (0, r.getFieldConfig)(E, x) || {}, F = Array.isArray(x) ? x : x.split(I);
      (0, i.getFieldPath)(x, E, k);
      var P = (0, i.getFieldPartsConfigs)(x, E, k), O = E.settings.formatSpelField, V = (0, i.formatFieldName)(x, E, S);
      if (k) {
        var U = (0, r.getFieldConfig)(E, k) || {}, H = k;
        U.fieldName && (H = U.fieldName), V.indexOf(H + I) == 0 ? V = V.slice((H + I).length) : S.errors.push("Can't cut group ".concat(H, " from field ").concat(V));
      }
      var J = P.map(function(ae) {
        var Y = (0, o.default)(ae, 3), re = Y[0], ie = Y[1], _e = Y[2], he;
        _e && (_e.type == "!struct" || _e.type == "!group" && _e.mode == "struct" ? he = ie.isSpelMap ? "map" : "class" : _e.type == "!group" ? he = ie.isSpelItemMap ? "[map]" : "[class]" : he = "class");
        var be = ie == null ? void 0 : ie.isSpelVariable;
        return {
          key: re,
          parent: he,
          isSpelVariable: be
        };
      }), le = O(V, k, F, J, z, E);
      return le;
    }
  }, D = function(S, E, x) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, I = x.get("func"), z = x.get("args"), F = (0, r.getFuncConfig)(E, I), P = F.spelFunc || I, O = {};
    for (var V in F.args) {
      var U = F.args[V], H = (0, r.getFieldConfig)(E, U), J = z ? z.get(V) : void 0, le = J ? J.get("value") : void 0, ae = J ? J.get("valueSrc") : void 0, Y = J ? J.get("asyncListValues") : void 0, re = R(S, E, le, ae, U.type, H, U, null, null, k, Y);
      if (le != null && re === void 0) {
        S.errors.push("Can't format value of arg ".concat(V, " for func ").concat(I));
        return;
      }
      re !== void 0 && (O[V] = re);
    }
    var ie;
    if (typeof F.spelFormatFunc == "function") {
      var _e = F.spelFormatFunc, he = [O];
      ie = _e.apply(void 0, he);
    } else {
      var be = Object.entries(O).map(function(pe) {
        var ge = (0, o.default)(pe, 2);
        ge[0];
        var ve = ge[1];
        return ve;
      });
      if (P[0] == "." && be.length) {
        var Q = (0, t.default)(be), me = Q[0], ne = Q.slice(1);
        ie = "".concat(me).concat(P, "(").concat(ne.join(", "), ")");
      } else
        ie = "".concat(P, "(").concat(be.join(", "), ")");
    }
    return ie;
  };
  return yh;
}
var kw = {}, Soe;
function Pru() {
  if (Soe)
    return kw;
  Soe = 1;
  var e = Tn;
  Object.defineProperty(kw, "__esModule", {
    value: !0
  }), kw.queryString = void 0;
  var t = e(Yr()), n = e(Gu()), o = e(Zu), r = Qi(), i = Es(), a = e(Of()), s = e(Dv()), c = Ti(), l = kl(), u = v$(), d = Lv(), _ = uc();
  function p(q, L) {
    var R = Object.keys(q);
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(q);
      L && (T = T.filter(function(D) {
        return Object.getOwnPropertyDescriptor(q, D).enumerable;
      })), R.push.apply(R, T);
    }
    return R;
  }
  function g(q) {
    for (var L = 1; L < arguments.length; L++) {
      var R = arguments[L] != null ? arguments[L] : {};
      L % 2 ? p(Object(R), !0).forEach(function(T) {
        (0, t.default)(q, T, R[T]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(R)) : p(Object(R)).forEach(function(T) {
        Object.defineProperty(q, T, Object.getOwnPropertyDescriptor(R, T));
      });
    }
    return q;
  }
  var f = function(L, R) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, D = {
      errors: []
    }, A = h(L, R, D, T, null);
    return D.errors.length && console.warn("Errors while exporting to string:", D.errors), A;
  };
  kw.queryString = f;
  var h = function(L, R, T) {
    var D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (L) {
      var S = L.get("type");
      if (L.get("children1"), S === "group" || S === "rule_group")
        return $(L, R, T, D, A);
      if (S === "rule")
        return y(L, R, T, D, A);
    }
  }, $ = function(L, R, T) {
    var D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, S = L.get("type"), E = L.get("properties") || new _.Map(), x = E.get("mode"), k = L.get("children1");
    if (k) {
      var I = S === "rule_group", z = I && x == "array" ? E.get("field") : null, F = I && x == "array", P = E.get("not"), O = k.map(function(ie) {
        return h(ie, R, T, D, z);
      }).filter(function(ie) {
        return typeof ie < "u";
      });
      if (!(!F && !O.size)) {
        var V = E.get("conjunction");
        V || (V = (0, l.defaultConjunction)(R));
        var U = R.conjunctions[V], H = O.size ? U.formatConj(O, V, P, D) : null, J;
        if (z) {
          var le = y(L, R, T, D, A, !0);
          if (le) {
            var ae, Y = le.pop(), re = [H].concat((0, o.default)(le));
            J = (ae = R.settings).formatAggr.apply(ae, (0, o.default)(re)), Y && (J = R.settings.formatReverse(J, null, null, null, null, D));
          }
        } else
          J = H;
        return J;
      }
    }
  }, v = function(L, R, T, D, A, S) {
    var E = R.get("field"), x = R.get("valueSrc"), k = R.get("valueType"), I = (0, r.getFieldConfig)(L, E) || {}, z = D || R.get("operator"), F = (0, r.getOperatorConfig)(L, z, E) || {}, P = (0, c.defaultValue)(F.cardinality, 1), O = R.get("value"), V = R.get("asyncListValues"), U = [], H = [], J;
    if (O != null) {
      var le = O.map(function(Y, re) {
        var ie = x ? x.get(re) : null, _e = k ? k.get(re) : null, he = (0, d.completeValue)(Y, ie, L), be = (0, i.getWidgetForFieldOp)(L, E, z, ie), Q = (0, a.default)((0, r.getFieldWidgetConfig)(L, E, z, be, ie), ["factory"]), me = w(L, T, he, ie, _e, Q, I, z, F, A, S, V);
        return me !== void 0 && (U.push(ie), H.push(_e)), me;
      }), ae = le.filter(function(Y) {
        return Y === void 0;
      }).size > 0;
      ae || le.size < P || (J = P == 1 ? le.first() : le);
    }
    return [J, U.length > 1 ? U : U[0], H.length > 1 ? H : H[0]];
  }, b = function(L, R) {
    var T = R.labelForFormat || L, D = (0, c.defaultValue)(R.cardinality, 1), A;
    return D == 0 ? A = function(E, x, k, I, z, F, P, O) {
      return "".concat(E, " ").concat(T);
    } : D == 1 ? A = function(E, x, k, I, z, F, P, O) {
      return "".concat(E, " ").concat(T, " ").concat(k);
    } : D == 2 && (A = function(E, x, k, I, z, F, P, O) {
      var V = k.first(), U = k.get(1);
      return "".concat(E, " ").concat(T, " ").concat(V, " AND ").concat(U);
    }), A;
  }, y = function(L, R, T) {
    var D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, S = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, E = L.get("properties") || new _.Map(), x = E.get("field"), k = E.get("operator"), I = E.get("operatorOptions");
    if (!(x == null || k == null)) {
      var z = (0, r.getFieldConfig)(R, x) || {}, F = (0, r.getOperatorConfig)(R, k, x) || {}, P = F.reversedOp, O = (0, r.getOperatorConfig)(R, P, x) || {}, V = !1, U = F.formatOp;
      if (!U && P && (U = O.formatOp, U)) {
        V = !0;
        var H = [P, k];
        k = H[0], P = H[1];
        var J = [O, F];
        F = J[0], O = J[1];
      }
      if (U || (U = b(k, F)), !!U) {
        var le = N(R, T, x, D, A), ae = v(R, E, T, k, D, A), Y = (0, n.default)(ae, 3), re = Y[0], ie = Y[1], _e = Y[2];
        if (re !== void 0) {
          var he = [le, k, re, ie, _e, (0, a.default)(F, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), I, D, z, V];
          if (S)
            return he;
          var be = U.apply(void 0, he);
          return V && (be = R.settings.formatReverse(be, k, P, F, O, D)), be;
        }
      }
    }
  }, w = function(L, R, T, D, A, S, E, x, k, I) {
    var z = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : null, F = arguments.length > 11 ? arguments[11] : void 0;
    if (T !== void 0) {
      var P;
      if (D == "field")
        P = N(L, R, T, I, z);
      else if (D == "func")
        P = M(L, R, T, I, z);
      else if (typeof S.formatValue == "function") {
        var O = S.formatValue, V = [
          T,
          g(g({}, (0, s.default)(E, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: F
          }),
          //useful options: valueFormat for date/time
          (0, a.default)(S, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"]),
          I
        ];
        if (x && (V.push(x), V.push(k)), D == "field") {
          var U = (0, r.getFieldConfig)(L, T) || {};
          V.push(U);
        }
        P = O.apply(void 0, V);
      } else
        P = T;
      return P;
    }
  }, N = function(L, R, T, D) {
    var A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, S = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0, E = L.settings, x = E.fieldSeparator, k = E.fieldSeparatorDisplay, I = null;
    if (T) {
      var z = (0, r.getFieldConfig)(L, T) || {}, F = Array.isArray(T) ? T : T.split(x);
      (0, i.getFieldPath)(T, L);
      var P = (0, i.getFieldPathLabels)(T, L, S ? A : null), O = P ? P.join(k) : null, V = z.label2 || O, U = L.settings.formatField || u.settings.formatField, H = (0, i.formatFieldName)(T, L, R, S ? A : null);
      I = U(H, F, V, z, L, D);
    }
    return I;
  }, M = function(L, R, T, D) {
    var A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, S = T.get("func"), E = T.get("args"), x = (0, r.getFuncConfig)(L, S), k = D && x.label || S, I = {}, z = {};
    for (var F in x.args) {
      var P = x.args[F], O = (0, r.getFieldConfig)(L, P), V = E ? E.get(F) : void 0, U = V ? V.get("value") : void 0, H = V ? V.get("valueSrc") : void 0, J = V ? V.get("asyncListValues") : void 0, le = w(L, R, U, H, P.type, O, P, null, null, D, A, J), ae = D && P.label || F;
      le !== void 0 && (I[F] = le, z[ae] = le);
    }
    var Y = null;
    if (typeof x.formatFunc == "function") {
      var re = x.formatFunc, ie = [I, D];
      Y = re.apply(void 0, ie);
    } else {
      var _e = Object.entries(z).map(function(he) {
        var be = (0, n.default)(he, 2), Q = be[0], me = be[1];
        return D ? "".concat(Q, ": ").concat(me) : "".concat(me);
      }).join(", ");
      Y = "".concat(k, "(").concat(_e, ")");
    }
    return Y;
  };
  return kw;
}
var xE = {}, Eoe;
function Dru() {
  if (Eoe)
    return xE;
  Eoe = 1;
  var e = Tn;
  Object.defineProperty(xE, "__esModule", {
    value: !0
  }), xE.elasticSearchFormat = f;
  var t = e(Yr()), n = Es(), o = kl();
  function r(h, $) {
    var v = Object.keys(h);
    if (Object.getOwnPropertySymbols) {
      var b = Object.getOwnPropertySymbols(h);
      $ && (b = b.filter(function(y) {
        return Object.getOwnPropertyDescriptor(h, y).enumerable;
      })), v.push.apply(v, b);
    }
    return v;
  }
  function i(h) {
    for (var $ = 1; $ < arguments.length; $++) {
      var v = arguments[$] != null ? arguments[$] : {};
      $ % 2 ? r(Object(v), !0).forEach(function(b) {
        (0, t.default)(h, b, v[b]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(v)) : r(Object(v)).forEach(function(b) {
        Object.defineProperty(h, b, Object.getOwnPropertyDescriptor(v, b));
      });
    }
    return h;
  }
  function a(h) {
    if (h == null)
      return null;
    var $ = h.split(",").map(Number);
    return {
      top_left: {
        lat: $[0],
        lon: $[1]
      },
      bottom_right: {
        lat: $[2],
        lon: $[3]
      }
    };
  }
  function s(h, $) {
    if (h.length > 1)
      return {
        gte: "".concat(h[0]),
        lte: "".concat(h[1])
      };
    var v = h[0];
    switch ($) {
      case "on_date":
      case "not_on_date":
      case "equal":
      case "select_equals":
      case "not_equal":
        return {
          gte: "".concat(v, "||/d"),
          lte: "".concat(v, "||+1d")
        };
      case "less_or_equal":
        return {
          lte: "".concat(v)
        };
      case "greater_or_equal":
        return {
          gte: "".concat(v)
        };
      case "less":
        return {
          lt: "".concat(v)
        };
      case "greater":
        return {
          gte: "".concat(v)
        };
      default:
        return;
    }
  }
  function c(h) {
    return {
      value: "*" + h + "*"
    };
  }
  function l(h) {
    switch (h) {
      case "AND":
        return "must";
      case "OR":
        return "should";
      case "NOT":
        return "must_not";
      default:
        return;
    }
  }
  function u(h) {
    return {
      value: h
    };
  }
  function d(h, $) {
    return h;
  }
  function _(h, $, v, b, y) {
    var w = d(b);
    switch (h) {
      case "filter":
        return {
          script: y.operators[v].elasticSearchScript(b, $)
        };
      case "exists":
        return {
          field: b
        };
      case "match":
        return (0, t.default)({}, w, $[0]);
      case "term":
        return (0, t.default)({}, b, $[0]);
      case "geo_bounding_box":
        return (0, t.default)({}, b, a($[0]));
      case "range":
        return (0, t.default)({}, b, s($, v));
      case "wildcard":
        return (0, t.default)({}, b, c($[0]));
      case "regexp":
        return (0, t.default)({}, b, u($[0]));
      default:
        return;
    }
  }
  function p(h, $, v, b, y) {
    if (!(!h || !v || $ == null)) {
      var w = v, N = b.operators[w];
      if (N) {
        var M = N, q = M.elasticSearchQueryType, L = !1;
        if (!q && N.reversedOp) {
          L = !0, w = N.reversedOp, N = b.operators[w];
          var R = N;
          q = R.elasticSearchQueryType;
        }
        var T = (0, n.getWidgetForFieldOp)(b, h, w, y), D = b.widgets[T], A = D.elasticSearchFormatValue, S;
        if (typeof q == "function" ? S = q(T) : S = q, !!S) {
          var E;
          return typeof A == "function" ? E = A(S, $, w, h, b) : E = _(S, $, w, h, b), L ? {
            bool: {
              must_not: (0, t.default)({}, S, i({}, E))
            }
          } : (0, t.default)({}, S, i({}, E));
        }
      }
    }
  }
  function g(h, $, v, b) {
    if (!(!h || !h.size)) {
      var y = h.valueSeq().toArray(), w = l($), N = y.map(function(q) {
        return v(q, b);
      }).filter(function(q) {
        return q !== void 0;
      });
      if (N.length) {
        var M = N.flat(1 / 0);
        return {
          bool: (0, t.default)({}, w, M)
        };
      }
    }
  }
  function f(h, $) {
    if (h) {
      var v = h.get("type"), b = h.get("properties") || /* @__PURE__ */ new Map();
      if (v === "rule" && b.get("field")) {
        var y, w, N = b.get("operator"), M = b.get("field"), q = b.get("value").toJS();
        (y = b.get("valueType")) === null || y === void 0 || y.get(0);
        var L = (w = b.get("valueSrc")) === null || w === void 0 ? void 0 : w.get(0);
        return L === "func" ? void 0 : q && Array.isArray(q[0]) ? q[0].map(function(D) {
          return p(M, [D], N, $, L);
        }) : p(M, q, N, $, L);
      }
      if (v === "group" || v === "rule_group") {
        var R = b.get("conjunction");
        R || (R = (0, o.defaultConjunction)($));
        var T = h.get("children1");
        return g(T, R, f, $);
      }
    }
  }
  return xE;
}
var xoe;
function Lru() {
  return xoe || (xoe = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = Cru();
    Object.keys(t).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === t[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return t[c];
        }
      });
    });
    var n = Aru();
    Object.keys(n).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === n[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return n[c];
        }
      });
    });
    var o = Iru();
    Object.keys(o).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === o[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return o[c];
        }
      });
    });
    var r = zru();
    Object.keys(r).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === r[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return r[c];
        }
      });
    });
    var i = Rru();
    Object.keys(i).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === i[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return i[c];
        }
      });
    });
    var a = Pru();
    Object.keys(a).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === a[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return a[c];
        }
      });
    });
    var s = Dru();
    Object.keys(s).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === s[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return s[c];
        }
      });
    });
  }(AL)), AL;
}
var RL = {}, PL = {}, Coe;
function GV() {
  return Coe || (Coe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isImmutableTree = e.getTree = e.checkTree = void 0, Object.defineProperty(e, "isJsonLogic", {
      enumerable: !0,
      get: function() {
        return c.isJsonLogic;
      }
    }), e.loadTree = e.isValidTree = e.isTree = void 0;
    var o = t(xo), r = u(uc()), i = f1(), a = Qi(), s = Pv(), c = Ti();
    function l(v) {
      if (typeof WeakMap != "function")
        return null;
      var b = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap();
      return (l = function(N) {
        return N ? y : b;
      })(v);
    }
    function u(v, b) {
      if (!b && v && v.__esModule)
        return v;
      if (v === null || n(v) !== "object" && typeof v != "function")
        return { default: v };
      var y = l(b);
      if (y && y.has(v))
        return y.get(v);
      var w = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var M in v)
        if (M !== "default" && Object.prototype.hasOwnProperty.call(v, M)) {
          var q = N ? Object.getOwnPropertyDescriptor(v, M) : null;
          q && (q.get || q.set) ? Object.defineProperty(w, M, q) : w[M] = v[M];
        }
      return w.default = v, y && y.set(v, w), w;
    }
    var d = function(b) {
      var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (b) {
        var w = b;
        return w = w.toJS(), y && (w = (0, s.getLightTree)(w)), w;
      }
    };
    e.getTree = d;
    var _ = function(b) {
      if (f(b))
        return b;
      if (h(b))
        return $(b);
      if (typeof b == "string" && b.startsWith('["~#iM"'))
        throw "You are trying to load query in obsolete serialization format (Immutable string) which is not supported in versions starting from 2.1.17";
      if (typeof b == "string")
        return $(JSON.parse(b));
      throw "Can't load tree!";
    };
    e.loadTree = _;
    var p = function(b, y) {
      if (b) {
        var w = (0, a.extendConfig)(y);
        return (0, i.validateTree)(b, null, w, w);
      }
    };
    e.checkTree = p;
    var g = function(b) {
      return (0, s.getTreeBadFields)(b).length == 0;
    };
    e.isValidTree = g;
    var f = function(b) {
      return r.Map.isMap(b);
    };
    e.isImmutableTree = f;
    var h = function(b) {
      return (0, o.default)(b) == "object" && (b.type == "group" || b.type == "switch_group");
    };
    e.isTree = h;
    function $(v) {
      return (0, r.fromJS)(v, function(b, y) {
        var w;
        if (b == "properties") {
          w = y.toOrderedMap();
          for (var N = 0; N < 2; N++) {
            var M;
            ((M = w.get("value")) === null || M === void 0 ? void 0 : M.get(N)) === null && (w = w.setIn(["value", N], void 0));
          }
        } else if (b == "value" && y.get(0) && y.get(0).toJS !== void 0) {
          var q = y.get(0).toJS();
          q.func ? w = y.toOrderedMap() : w = r.default.List.of(q);
        } else
          b == "asyncListValues" ? w = y.toJS() : w = r.default.Iterable.isIndexed(y) ? y.toList() : y.toOrderedMap();
        return w;
      });
    }
  }(PL)), PL;
}
var $h = {}, Toe;
function Mru() {
  if (Toe)
    return $h;
  Toe = 1;
  var e = Tn;
  Object.defineProperty($h, "__esModule", {
    value: !0
  }), $h.loadFromJsonLogic = $h._loadFromJsonLogic = void 0;
  var t = e(Zu), n = e(UV()), o = e(Yr()), r = e(Gu()), i = e(Ug()), a = Ti(), s = Qi(), c = Es(), l = GV(), u = kl(), d = e(Fv);
  function _(A, S) {
    var E = Object.keys(A);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(A);
      S && (x = x.filter(function(k) {
        return Object.getOwnPropertyDescriptor(A, k).enumerable;
      })), E.push.apply(E, x);
    }
    return E;
  }
  function p(A) {
    for (var S = 1; S < arguments.length; S++) {
      var E = arguments[S] != null ? arguments[S] : {};
      S % 2 ? _(Object(E), !0).forEach(function(x) {
        (0, o.default)(A, x, E[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(E)) : _(Object(E)).forEach(function(x) {
        Object.defineProperty(A, x, Object.getOwnPropertyDescriptor(E, x));
      });
    }
    return A;
  }
  var g = function(S) {
    return Array.from(new Set(S));
  }, f = function(S, E) {
    return h(S, E, !1);
  };
  $h.loadFromJsonLogic = f;
  var h = function(S, E) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, k = {
      errors: []
    }, I = (0, s.extendConfig)(E), z = $(I), F = S ? v(S, z, I, "rule", k) : void 0;
    F && F.type != "group" && (F = L(F, I));
    var P = F ? (0, l.loadTree)(F) : void 0;
    return x ? [P, k.errors] : (k.errors.length && console.warn("Errors while importing from JsonLogic:", k.errors), P);
  };
  $h._loadFromJsonLogic = h;
  var $ = function(S) {
    var E = {};
    for (var x in S.operators) {
      var k = S.operators[x];
      if (typeof k.jsonLogic == "string") {
        var I = (k._jsonLogicIsRevArgs ? "#" : "") + k.jsonLogic + "/" + (0, a.defaultValue)(k.cardinality, 1);
        E[I] || (E[I] = []), E[I].push(x);
      } else if (typeof k.jsonLogic2 == "string") {
        var z = k.jsonLogic2 + "/" + (0, a.defaultValue)(k.cardinality, 1);
        E[z] || (E[z] = []), E[z].push(x);
      }
    }
    var F = {};
    for (var P in S.conjunctions) {
      var O = S.conjunctions[P], V = O.jsonLogicConj || P.toLowerCase();
      F[V] = P;
    }
    var U = {};
    for (var H in S.funcs) {
      var J = S.funcs[H], le = void 0;
      J.jsonLogicIsMethod ? le = "#" + J.jsonLogic : typeof J.jsonLogic == "string" && (le = J.jsonLogic), le && (U[le] || (U[le] = []), U[le].push(H));
    }
    var ae = S.settings.jsonLogic, Y = ae.groupVarKey, re = ae.altVarKey;
    return {
      operators: E,
      conjunctions: F,
      funcs: U,
      varKeys: ["var", Y, re]
    };
  }, v = function A(S, E, x, k, I) {
    var z = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, F = arguments.length > 6 ? arguments[6] : void 0, P = arguments.length > 7 ? arguments[7] : void 0, O = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null, V, U;
    (0, a.isJsonLogic)(S) && (V = Object.keys(S)[0], U = S[V], Array.isArray(U) || (U = [U]));
    var H, J = I.errors.length, le = x.settings.jsonLogic.lockedOp, ae = V == "!" && U.length == 1 && U[0] && (0, a.isJsonLogic)(U[0]) && E.varKeys.includes(Object.keys(U[0])[0]), Y = V == "!" && !ae, re = le && V == le;
    re ? H = A(U[0], E, x, k, I, z, F, P, O, !0) : Y ? H = A(U[0], E, x, k, I, !z, F, P, O) : k == "val" ? H = y(V, U, E, x, z, I, O) || w(V, U, E, x, z, F, I, O) || b(S, F, P, x, I) : k == "rule" && (H = N(V, U, E, x, z, I, O, !1) || D(V, U, E, x, z, I, O));
    var ie = I.errors.length;
    return V != "!" && H === void 0 && ie == J && I.errors.push("Can't parse logic ".concat(JSON.stringify(S))), re && (H.properties.isLocked = !0), H;
  }, b = function(S, E, x, k, I) {
    if (S !== void 0) {
      var z = k.widgets[x || E.mainWidget];
      if (!z) {
        I.errors.push("No widget for type ".concat(E.type));
        return;
      }
      if ((0, a.isJsonLogic)(S)) {
        I.errors.push("Unexpected logic in value: ".concat(JSON.stringify(S)));
        return;
      }
      if (E && E.type == "time" && typeof S == "number") {
        var F = Math.floor(S / 60 / 60) % 24, P = Math.floor(S / 60) % 60, O = S % 60, V = z.valueFormat;
        if (V) {
          var U = new Date(S);
          U.setMilliseconds(0), U.setHours(F), U.setMinutes(P), U.setSeconds(O), S = (0, d.default)(U).format(V);
        } else
          S = "".concat(F, ":").concat(P, ":").concat(O);
      }
      if (E && ["date", "datetime"].includes(E.type) && S && !(S instanceof Date))
        try {
          var H = new Date(S);
          H instanceof Date && H.toISOString() === S && (S = H);
        } catch {
          I.errors.push("Can't convert value ".concat(S, " as Date")), S = void 0;
        }
      if (S instanceof Date && E) {
        var J = z.valueFormat;
        J && (S = (0, d.default)(S).format(J));
      }
      var le;
      if (S && E.fieldSettings && E.fieldSettings.asyncFetch) {
        var ae = Array.isArray(S) ? S : [S];
        le = ae;
      }
      return {
        valueSrc: "value",
        value: S,
        valueType: z.type,
        asyncListValues: le
      };
    }
  }, y = function(S, E, x, k, I, z) {
    var F = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, P = k.settings.fieldSeparator;
    if (x.varKeys.includes(S) && typeof E[0] == "string") {
      var O = E[0];
      F && (O = [F, O].join(P)), O = (0, s.normalizeField)(k, O);
      var V = (0, s.getFieldConfig)(k, O);
      if (!V) {
        z.errors.push("No config for field ".concat(O));
        return;
      }
      return {
        valueSrc: "field",
        value: O,
        valueType: V.type
      };
    }
  }, w = function(S, E, x, k, I, z, F) {
    var P = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    if (S) {
      var O, V, U, H = S == "method";
      if (H) {
        var J, le, ae = (0, n.default)(E);
        J = ae[0], O = ae[1], le = ae.slice(2), V = [J].concat((0, t.default)(le));
      } else
        O = S, V = E;
      var Y = (H ? "#" : "") + O, re = (x.funcs[Y] || []).filter(function(Te) {
        return z ? k.funcs[Te].returnType == z.type : !0;
      });
      if (re.length)
        U = re[0];
      else
        for (var ie = (0, o.default)({}, S, E), _e = 0, he = Object.entries(k.funcs || {}); _e < he.length; _e++) {
          var be = (0, r.default)(he[_e], 2), Q = be[0], me = be[1];
          if (me.jsonLogicImport && me.returnType == z.type) {
            var ne = void 0;
            try {
              ne = me.jsonLogicImport(ie);
            } catch {
            }
            ne && (U = Q, V = ne);
          }
        }
      if (U && U) {
        var pe = k.funcs[U], ge = Object.keys(pe.args || {}), ve = V.reduce(function(Te, Re, Me) {
          var et = ge[Me], st = pe.args[et], De = v(Re, x, k, "val", F, !1, st, null, P);
          if (De === void 0 && (De = st.defaultValue, De === void 0)) {
            F.errors.push("No value for arg ".concat(et, " of func ").concat(U));
            return;
          }
          return p(p({}, Te), {}, (0, o.default)({}, et, De));
        }, {});
        return {
          valueSrc: "func",
          value: {
            func: U,
            args: ve
          },
          valueType: pe.returnType
        };
      }
    }
  }, N = function(S, E, x, k, I, z) {
    var F = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, P = x.conjunctions[S], O = k.settings.fieldSeparator, V = F ? (0, s.getFieldConfig)(k, F) : null;
    if ((V == null ? void 0 : V.type) == "!group", P) {
      var U = "group", H = E.map(function(he) {
        return v(he, x, k, "rule", z, !1, null, null, F);
      }).filter(function(he) {
        return he !== void 0;
      }).reduce(function(he, be) {
        return p(p({}, he), {}, (0, o.default)({}, be.id, be));
      }, {}), J = Object.values(H).map(function(he) {
        var be;
        return he == null || (be = he.properties) === null || be === void 0 ? void 0 : be.field;
      }).filter(function(he) {
        return he && he.includes(O);
      }), le = Object.fromEntries(g(J).map(function(he) {
        var be = he.split(O), Q = Object.fromEntries(be.slice(0, -1).map(function(me, ne, pe) {
          return [].concat((0, t.default)(pe.slice(0, ne)), [me]);
        }).map(function(me) {
          return [me.join(O), (0, s.getFieldConfig)(k, me)];
        }).filter(function(me) {
          var ne = (0, r.default)(me, 2);
          ne[0];
          var pe = ne[1];
          return pe.type == "!group";
        }));
        return [he, Object.keys(Q)];
      }));
      Object.values(H).map(function(he) {
        var be;
        return he == null || (be = he.properties) === null || be === void 0 ? void 0 : be.field;
      }).map(function(he) {
        return le[he];
      }).filter(function(he) {
        return he && he.length;
      });
      var ae = g(Object.values(le).flat());
      M(ae);
      var Y = {
        conjunction: P,
        not: I
      }, re = (0, i.default)(), ie = {}, _e = {};
      return Object.entries(H).map(function(he) {
        var be = (0, r.default)(he, 2), Q = be[0], me = be[1];
        if (me.type == "group" || me.type == "rule_group")
          ie[Q] = me;
        else {
          var ne, pe = me == null || (ne = me.properties) === null || ne === void 0 ? void 0 : ne.field, ge = le[pe], ve = ge == null ? void 0 : ge.at(-1);
          if (!ve)
            ie[Q] = me;
          else {
            var Te = ie, Re = F ? F.split(O) : [], Me = (0, a.shallowEqual)(Re, ve.split(O).slice(0, Re.length));
            Me || (Re = []);
            var et = ve.split(O).slice(Re.length).map(function(st, De, ze) {
              return [].concat((0, t.default)(Re), (0, t.default)(ze.slice(0, De)), [st]).join(O);
            }).map(function(st) {
              return (0, s.normalizeField)(k, st);
            }).map(function(st) {
              return {
                f: st,
                fc: (0, s.getFieldConfig)(k, st) || {}
              };
            }).filter(function(st) {
              var De = st.fc;
              return De.type != "!struct";
            });
            et.map(function(st, De) {
              var ze = st.f, Pe = st.fc, je = _e[ze];
              je || (je = (0, i.default)(), _e[ze] = je, Te[je] = {
                type: "rule_group",
                id: je,
                children1: {},
                properties: {
                  conjunction: P,
                  not: !1,
                  field: ze,
                  mode: Pe.mode
                }
              }), Te = Te[je].children1;
            }), Te[Q] = me;
          }
        }
      }), {
        type: U,
        id: re,
        children1: ie,
        properties: Y
      };
    }
  }, M = function(S) {
    for (var E = (0, t.default)(S).sort(function(I, z) {
      return I.length - z.length;
    }), x = 0; x < E.length; x++)
      for (var k = x + 1; k < E.length; k++)
        E[k].indexOf(E[x]) == 0 && (E.splice(k, 1), k--);
    return E;
  }, q = function(S, E, x, k, I) {
    if (S)
      return {
        type: "rule_group",
        id: (0, i.default)(),
        children1: (0, o.default)({}, S.id, S),
        properties: {
          conjunction: I || (0, u.defaultGroupConjunction)(k, x),
          not: !1,
          field: E
        }
      };
  }, L = function(S, E) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return {
      type: "group",
      id: (0, i.default)(),
      children1: (0, o.default)({}, S.id, S),
      properties: {
        conjunction: (0, u.defaultConjunction)(E),
        not: x
      }
    };
  }, R = function(S, E, x, k, I, z, F) {
    var P = [], O = T(S, E, x, k, I, z, P, !1) || T(S, E, x, k, I, z, P, !0);
    if (!O) {
      F.errors.push(P.join("; ") || "Unknown op ".concat(S, "/").concat(E));
      return;
    }
    return O;
  }, T = function(S, E, x, k, I, z, F, P) {
    var O = S == "all" && (0, a.isJsonLogic)(x[1]) && Object.keys(x[1])[0] == "in", V = !O && z.settings.groupOperators.includes(S), U = ["==", "!="], H = V ? 0 : E - 1;
    (V || U.includes(S) && H == 1 && x[1] === null) && (H = 0);
    var J = S + "/" + H, le = z.settings.fieldSeparator, ae = I.operators[(P ? "#" : "") + J];
    if (ae) {
      var Y, re = [], ie = ["<", "<=", ">", ">="];
      if (ie.includes(S) && E == 3)
        Y = x[1], re = [x[0], x[2]];
      else if (P)
        Y = x[1], re = [x[0]];
      else {
        var _e = (0, n.default)(x);
        Y = _e[0], re = _e.slice(1);
      }
      if (!(0, a.isJsonLogic)(Y)) {
        F.push("Incorrect operands for ".concat(S, ": ").concat(JSON.stringify(x)));
        return;
      }
      var he = Object.keys(Y)[0], be = Object.values(Y)[0], Q, me;
      if (I.varKeys.includes(he) && typeof be == "string" && (Q = be), V && (me = re[0], re = []), he == "reduce" && Array.isArray(be) && be.length == 3) {
        var ne = be, pe = (0, r.default)(ne, 3), ge = pe[0], ve = pe[1], Te = pe[2];
        if ((0, a.isJsonLogic)(ge) && Te == 0 && (0, a.isJsonLogic)(ve) && Array.isArray(ve["+"]) && ve["+"][0] == 1 && (0, a.isJsonLogic)(ve["+"][1]) && ve["+"][1].var == "accumulator")
          if (he = Object.keys(ge)[0], be = Object.values(ge)[0], he == "filter") {
            var Re = be, Me = (0, r.default)(Re, 2), et = Me[0], st = Me[1];
            (0, a.isJsonLogic)(et) && (he = Object.keys(et)[0], be = Object.values(et)[0], I.varKeys.includes(he) && typeof be == "string" && (Q = be, me = st));
          } else
            I.varKeys.includes(he) && typeof be == "string" && (Q = be);
      }
      if (!Q) {
        F.push("Unknown field ".concat(JSON.stringify(Y)));
        return;
      }
      k && (Q = [k, Q].join(le)), Q = (0, s.normalizeField)(z, Q);
      var De = (0, s.getFieldConfig)(z, Q);
      if (!De) {
        F.push("No config for field ".concat(Q));
        return;
      }
      var ze = ae[0];
      if (ae.length > 1 && De && De.operators) {
        if (ae = ae.filter(function(Pe) {
          return De.operators.includes(Pe);
        }), ae.length == 0) {
          F.push("No corresponding ops for field ".concat(Q));
          return;
        }
        ze = ae[0];
      }
      return {
        field: Q,
        fieldConfig: De,
        opKey: ze,
        args: re,
        having: me
      };
    }
  }, D = function A(S, E, x, k, I, z) {
    var F = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    if (S) {
      var P = E.length;
      if (S == "all" && (0, a.isJsonLogic)(E[1])) {
        var O = Object.keys(E[1])[0];
        O == "in" && (E = [E[0], E[1][O][1]], S = S + "-" + O);
      }
      var V = R(S, P, E, F, x, k, z);
      if (V) {
        var U = V.field, H = V.fieldConfig, J = V.opKey, le = V.args, ae = V.having, Y = k.operators[J];
        H.showNot !== void 0 ? H.showNot : k.settings.showNot;
        var re = !0, ie, _e;
        if (H.type == "!group" && ae) {
          ie = Object.keys(ae)[0], _e = ae[ie], Array.isArray(_e) || (_e = [_e]);
          var he = ie == "!" && _e.length == 1 && _e[0] && (0, a.isJsonLogic)(_e[0]) && x.varKeys.includes(Object.keys(_e[0])[0]);
          ie == "!" && !he && (I = !I, ae = ae["!"], ie = Object.keys(ae)[0], _e = ae[ie], Array.isArray(_e) || (_e = [_e]));
        }
        I && re && Y.reversedOp && (I = !1, J = Y.reversedOp, Y = k.operators[J]);
        var be = (0, c.getWidgetForFieldOp)(k, U, J), Q = le.map(function(Te) {
          return v(Te, x, k, "val", z, !1, H, be, F);
        });
        if (!Q.filter(function(Te) {
          return Te === void 0;
        }).length) {
          var me;
          if (H.type == "!group" && ae) {
            if (x.conjunctions[ie] !== void 0)
              me = N(ie, _e, x, k, I, z, U, !0), I = !1;
            else {
              var ne, pe = A(ie, _e, x, k, I && re, z, U);
              I && re && !(pe != null && (ne = pe.properties) !== null && ne !== void 0 && ne.not) && (I = !1), me = q(pe, U, H, k, x.conjunctions.and);
            }
            if (!me)
              return;
            me.type = "rule_group", I && Object.assign(me.properties, {
              not: I
            }), Object.assign(me.properties, {
              field: U,
              mode: H.mode,
              operator: J
            }), H.mode == "array" && Object.assign(me.properties, {
              value: Q.map(function(Te) {
                return Te.value;
              }),
              valueSrc: Q.map(function(Te) {
                return Te.valueSrc;
              }),
              valueType: Q.map(function(Te) {
                return Te.valueType;
              })
            });
          } else if (H.type == "!group" && !ae)
            me = {
              type: "rule_group",
              id: (0, i.default)(),
              children1: {},
              properties: {
                conjunction: (0, u.defaultGroupConjunction)(k, H),
                not: I,
                mode: H.mode,
                field: U,
                operator: J
              }
            }, H.mode == "array" && Object.assign(me.properties, {
              value: Q.map(function(Te) {
                return Te.value;
              }),
              valueSrc: Q.map(function(Te) {
                return Te.valueSrc;
              }),
              valueType: Q.map(function(Te) {
                return Te.valueType;
              })
            });
          else {
            var ge = Q.map(function(Te) {
              return Te.asyncListValues;
            }).filter(function(Te) {
              return Te != null;
            }), ve = ge.length ? ge[0] : void 0;
            me = {
              type: "rule",
              id: (0, i.default)(),
              properties: {
                field: U,
                operator: J,
                value: Q.map(function(Te) {
                  return Te.value;
                }),
                valueSrc: Q.map(function(Te) {
                  return Te.valueSrc;
                }),
                valueType: Q.map(function(Te) {
                  return Te.valueType;
                }),
                asyncListValues: ve
              }
            }, I && (me = L(me, k, I));
          }
          return me;
        }
      }
    }
  };
  return $h;
}
var wh = {}, DL = { exports: {} }, Aoe;
function Fru() {
  return Aoe || (Aoe = 1, function(e, t) {
    (function(o, r) {
      e.exports = r();
    })(Dt, function() {
      return (
        /******/
        function(n) {
          var o = {};
          function r(i) {
            if (o[i])
              return o[i].exports;
            var a = o[i] = {
              /******/
              i,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return n[i].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
          }
          return r.m = n, r.c = o, r.d = function(i, a, s) {
            r.o(i, a) || Object.defineProperty(i, a, {
              /******/
              configurable: !1,
              /******/
              enumerable: !0,
              /******/
              get: s
              /******/
            });
          }, r.n = function(i) {
            var a = i && i.__esModule ? (
              /******/
              function() {
                return i.default;
              }
            ) : (
              /******/
              function() {
                return i;
              }
            );
            return r.d(a, "a", a), a;
          }, r.o = function(i, a) {
            return Object.prototype.hasOwnProperty.call(i, a);
          }, r.p = "", r(r.s = 3);
        }([
          /* 0 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            });
            function i(a, s) {
              var c = {}, l = a || "Abstract", u = [], d = null, _;
              if (c._type = l, c.getType = function() {
                return l;
              }, c.setType = function(h) {
                l = h;
              }, c.getChildren = function() {
                return u;
              }, c.addChild = function(h) {
                if (h) {
                  if (!h.setParent)
                    throw {
                      name: "Error",
                      message: "Trying to add a child which is not a node: " + JSON.stringify(h)
                    };
                  h.setParent(c), u.push(h);
                }
              }, c.getParent = function() {
                return d;
              }, c.setParent = function(h) {
                d = h;
              }, c.getContext = function(h) {
                return _ || h.activeContext.peek();
              }, c.setContext = function(h) {
                _ = h;
              }, c.getStartPosition = function() {
                return s >> 16;
              }, c.getEndPosition = function() {
                return s & 65535;
              }, c.getValue = function() {
                throw {
                  name: "MethodNotImplementedException",
                  message: "SpelNode#getValue() must be overridden."
                };
              }, c.toString = function() {
                var h = "Kind: " + c.getType();
                h += ", Children: [";
                for (var $ = 0, v = c.getChildren().length; $ < v; $ += 1)
                  h += "{" + c.getChildren()[$] + "}, ";
                return h += "]", h;
              }, s === 0)
                throw {
                  name: "Error",
                  message: "Position cannot be 0"
                };
              for (var p = arguments.length, g = Array(p > 2 ? p - 2 : 0), f = 2; f < p; f++)
                g[f - 2] = arguments[f];
              return g && g.forEach(function(h) {
                c.addChild(h);
              }), c;
            }
            o.SpelNode = {
              create: i
            };
          },
          /* 1 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Stack = i;
            function i(a) {
              this.elements = a || [];
            }
            i.prototype.push = function(a) {
              return this.elements.push(a), a;
            }, i.prototype.pop = function() {
              return this.elements.pop();
            }, i.prototype.peek = function() {
              return this.elements[this.elements.length - 1];
            }, i.prototype.empty = function() {
              return this.elements.length > 0;
            }, i.prototype.search = function(a) {
              return this.elements.length - this.elements.indexOf(a);
            };
          },
          /* 2 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            });
            var i = {
              LITERAL_INT: 1,
              //tested
              LITERAL_LONG: 2,
              //tested
              LITERAL_HEXINT: 3,
              //tested
              LITERAL_HEXLONG: 4,
              //tested
              LITERAL_STRING: 5,
              //tested
              LITERAL_REAL: 6,
              //tested
              LITERAL_REAL_FLOAT: 7,
              //tested
              LPAREN: "(",
              //tested
              RPAREN: ")",
              //tested
              COMMA: ",",
              //tested
              IDENTIFIER: 0,
              //tested
              COLON: ":",
              //tested
              HASH: "#",
              //tested
              RSQUARE: "]",
              //tested
              LSQUARE: "[",
              //tested
              LCURLY: "{",
              //tested
              RCURLY: "}",
              //tested
              DOT: ".",
              //tested
              PLUS: "+",
              //tested
              STAR: "*",
              //tested
              MINUS: "-",
              //tested
              SELECT_FIRST: "^[",
              //tested
              SELECT_LAST: "$[",
              //tested
              QMARK: "?",
              //tested
              PROJECT: "![",
              //tested
              DIV: "/",
              //tested
              GE: ">=",
              //tested
              GT: ">",
              //tested
              LE: "<=",
              //tested
              LT: "<",
              //tested
              EQ: "==",
              //tested
              NE: "!=",
              //tested
              MOD: "%",
              //tested
              NOT: "!",
              //tested
              ASSIGN: "=",
              //tested
              INSTANCEOF: "instanceof",
              //test fails
              MATCHES: "matches",
              //test fails
              BETWEEN: "between",
              //test fails
              SELECT: "?[",
              //tested
              POWER: "^",
              //tested
              ELVIS: "?:",
              //tested
              SAFE_NAVI: "?.",
              //tested
              BEAN_REF: "@",
              //tested
              SYMBOLIC_OR: "||",
              //tested
              SYMBOLIC_AND: "&&",
              //tested
              INC: "++",
              //tested
              DEC: "--"
              //tested
            };
            function a(c) {
              this.type = c, this.tokenChars = i[c], this._hasPayload = typeof i[c] != "string", typeof i[c] == "number" && (this._ordinal = i[c]);
            }
            for (var s in i)
              i.hasOwnProperty(s) && (a[s] = new a(s));
            a.prototype.toString = function() {
              return this.type + (this.tokenChars.length !== 0 ? "(" + this.tokenChars + ")" : "");
            }, a.prototype.getLength = function() {
              return this.tokenChars.length;
            }, a.prototype.hasPayload = function() {
              return this._hasPayload;
            }, a.prototype.valueOf = function(c) {
              for (var l in i)
                if (i.hasOwnProperty(l) && i[l] === c)
                  return a[l];
            }, a.prototype.ordinal = function() {
              return this._ordinal;
            }, o.TokenKind = a;
          },
          /* 3 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.StandardContext = o.SpelExpressionEvaluator = void 0;
            var i = r(4), a = r(50);
            o.SpelExpressionEvaluator = i.SpelExpressionEvaluator, o.StandardContext = a.StandardContext;
          },
          /* 4 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.SpelExpressionEvaluator = void 0;
            var i = r(5), a = r(1), s = {};
            function c(l, u, d) {
              var _ = new a.Stack(), p;
              return u || (u = {}), _.push(u), p = {
                rootContext: u,
                activeContext: _,
                locals: d
              }, l.getValue(p);
            }
            s.compile = function(l) {
              var u = (0, i.SpelExpressionParser)().parse(l);
              return {
                eval: function(_, p) {
                  return c(u, _, p);
                },
                _compiledExpression: u
              };
            }, s.eval = function(l, u, d) {
              return s.compile(l).eval(u, d);
            }, o.SpelExpressionEvaluator = s;
          },
          /* 5 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.SpelExpressionParser = void 0;
            var i = r(2), a = r(6), s = r(8), c = r(9), l = r(10), u = r(11), d = r(12), _ = r(13), p = r(14), g = r(15), f = r(16), h = r(17), $ = r(18), v = r(19), b = r(20), y = r(21), w = r(22), N = r(23), M = r(24), q = r(25), L = r(26), R = r(27), T = r(28), D = r(29), A = r(30), S = r(31), E = r(32), x = r(33), k = r(34), I = r(35), z = r(36), F = r(37), P = r(38), O = r(39), V = r(40), U = r(41), H = r(42), J = r(43), le = r(44), ae = r(45), Y = r(46), re = r(47), ie = r(48), _e = r(49);
            o.SpelExpressionParser = function() {
              var be = new RegExp("[\\p{L}\\p{N}_$]+"), Q = [], me, ne, pe, ge;
              function ve(Ze) {
              }
              function Te(Ze, bt) {
                try {
                  me = Ze, ne = a.Tokenizer.tokenize(Ze), pe = ne.length, ge = 0, Q = [];
                  var Wt = Re();
                  return An() && gn(zn().startPos, "MORE_INPUT", hn().toString()), Wt;
                } catch (xn) {
                  throw xn.message;
                }
              }
              function Re() {
                var Ze = Me();
                if (An()) {
                  var bt = zn();
                  if (bt.getKind() === i.TokenKind.ASSIGN) {
                    Ze === null && (Ze = u.NullLiteral.create(ao(bt.startPos - 1, bt.endPos - 1))), hn();
                    var Wt = Me();
                    return $.Assign.create(sn(bt), Ze, Wt);
                  }
                  if (bt.getKind() === i.TokenKind.ELVIS) {
                    Ze === null && (Ze = u.NullLiteral.create(ao(bt.startPos - 1, bt.endPos - 2))), hn();
                    var xn = Re();
                    return xn === null && (xn = u.NullLiteral.create(ao(bt.startPos + 1, bt.endPos + 1))), P.Elvis.create(sn(bt), Ze, xn);
                  }
                  if (bt.getKind() === i.TokenKind.QMARK) {
                    Ze === null && (Ze = u.NullLiteral.create(ao(bt.startPos - 1, bt.endPos - 1))), hn();
                    var It = Re();
                    qo(i.TokenKind.COLON);
                    var Jn = Re();
                    return F.Ternary.create(sn(bt), Ze, It, Jn);
                  }
                }
                return Ze;
              }
              function Me() {
                for (var Ze = et(); an("or") || ho(i.TokenKind.SYMBOLIC_OR); ) {
                  var bt = hn(), Wt = et();
                  dt(bt, Ze, Wt), Ze = I.OpOr.create(sn(bt), Ze, Wt);
                }
                return Ze;
              }
              function et() {
                for (var Ze = st(); an("and") || ho(i.TokenKind.SYMBOLIC_AND); ) {
                  var bt = hn(), Wt = st();
                  dt(bt, Ze, Wt), Ze = k.OpAnd.create(sn(bt), Ze, Wt);
                }
                return Ze;
              }
              function st() {
                var Ze = De(), bt = Rr();
                if (bt !== null) {
                  var Wt = hn(), xn = De();
                  dt(Wt, Ze, xn);
                  var It = bt.kind;
                  if (bt.isNumericRelationalOperator()) {
                    var Jn = sn(Wt);
                    return It === i.TokenKind.GT ? w.OpGT.create(Jn, Ze, xn) : It === i.TokenKind.LT ? M.OpLT.create(Jn, Ze, xn) : It === i.TokenKind.LE ? N.OpLE.create(Jn, Ze, xn) : It === i.TokenKind.GE ? y.OpGE.create(Jn, Ze, xn) : It === i.TokenKind.EQ ? v.OpEQ.create(Jn, Ze, xn) : b.OpNE.create(Jn, Ze, xn);
                  }
                  return It === i.TokenKind.INSTANCEOF ? J.OpInstanceof.create(sn(Wt), Ze, xn) : It === i.TokenKind.MATCHES ? z.OpMatches.create(sn(Wt), Ze, xn) : le.OpBetween.create(sn(Wt), Ze, xn);
                }
                return Ze;
              }
              function De() {
                for (var Ze = ze(); Kt(i.TokenKind.PLUS, i.TokenKind.MINUS, i.TokenKind.INC); ) {
                  var bt = hn(), Wt = ze();
                  cn(bt, Wt), bt.getKind() === i.TokenKind.PLUS ? Ze = q.OpPlus.create(sn(bt), Ze, Wt) : bt.getKind() === i.TokenKind.MINUS && (Ze = L.OpMinus.create(sn(bt), Ze, Wt));
                }
                return Ze;
              }
              function ze() {
                for (var Ze = Pe(); Kt(i.TokenKind.STAR, i.TokenKind.DIV, i.TokenKind.MOD); ) {
                  var bt = hn(), Wt = Pe();
                  dt(bt, Ze, Wt), bt.getKind() === i.TokenKind.STAR ? Ze = R.OpMultiply.create(sn(bt), Ze, Wt) : bt.getKind() === i.TokenKind.DIV ? Ze = T.OpDivide.create(sn(bt), Ze, Wt) : Ze = D.OpModulus.create(sn(bt), Ze, Wt);
                }
                return Ze;
              }
              function Pe() {
                var Ze = je(), bt;
                if (ho(i.TokenKind.POWER)) {
                  bt = hn();
                  var Wt = je();
                  return cn(bt, Wt), A.OpPower.create(sn(bt), Ze, Wt);
                }
                return Ze !== null && Kt(i.TokenKind.INC, i.TokenKind.DEC) ? (bt = hn(), bt.getKind() === i.TokenKind.INC ? S.OpInc.create(sn(bt), !0, Ze) : E.OpDec.create(sn(bt), !0, Ze)) : Ze;
              }
              function je() {
                var Ze, bt;
                return Kt(i.TokenKind.PLUS, i.TokenKind.MINUS, i.TokenKind.NOT) ? (Ze = hn(), bt = je(), Ze.getKind() === i.TokenKind.NOT ? x.OpNot.create(sn(Ze), bt) : Ze.getKind() === i.TokenKind.PLUS ? q.OpPlus.create(sn(Ze), bt) : L.OpMinus.create(sn(Ze), bt)) : Kt(i.TokenKind.INC, i.TokenKind.DEC) ? (Ze = hn(), bt = je(), Ze.getKind() === i.TokenKind.INC ? S.OpInc.create(sn(Ze), !1, bt) : E.OpDec.create(sn(Ze), !1, bt)) : He();
              }
              function He() {
                var Ze = [], bt = wn();
                for (Ze.push(bt); Xe(); )
                  Ze.push($n());
                return Ze.length === 1 ? Ze[0] : f.CompoundExpression.create(ao(bt.getStartPosition(), Ze[Ze.length - 1].getEndPosition()), Ze);
              }
              function Xe() {
                var Ze = null;
                return Kt(i.TokenKind.DOT, i.TokenKind.SAFE_NAVI) ? Ze = wt() : Ze = at(), Ze === null ? !1 : (In(Ze), !0);
              }
              function at() {
                return ho(i.TokenKind.LSQUARE) && Yn() ? $n() : null;
              }
              function wt() {
                var Ze = hn(), bt = Ze.getKind() === i.TokenKind.SAFE_NAVI;
                return Xn(bt) || Je() || Rn(bt) || Qt(bt) ? $n() : (zn() === null ? gn(Ze.startPos, "OOD") : gn(Ze.startPos, "UNEXPECTED_DATA_AFTER_DOT", kn(zn())), null);
              }
              function Je() {
                if (!ho(i.TokenKind.HASH))
                  return !1;
                var Ze = hn(), bt = qo(i.TokenKind.IDENTIFIER), Wt = vt();
                return Wt === null ? (In(g.VariableReference.create(bt.data, ao(Ze.startPos, bt.endPos))), !0) : (In(d.FunctionReference.create(bt.data, ao(Ze.startPos, bt.endPos), Wt)), !0);
              }
              function vt() {
                if (!ho(i.TokenKind.LPAREN))
                  return null;
                var Ze = [];
                return Ft(Ze), qo(i.TokenKind.RPAREN), Ze;
              }
              function Ot(Ze) {
                ho(i.TokenKind.LPAREN) || gn(sn(zn()), "MISSING_CONSTRUCTOR_ARGS"), Ft(Ze), qo(i.TokenKind.RPAREN);
              }
              function Ft(Ze) {
                var bt = zn().startPos, Wt;
                do {
                  hn();
                  var xn = zn();
                  xn === null && gn(bt, "RUN_OUT_OF_ARGUMENTS"), xn.getKind() !== i.TokenKind.RPAREN && Ze.push(Re()), Wt = zn();
                } while (Wt !== null && Wt.kind === i.TokenKind.COMMA);
                Wt === null && gn(bt, "RUN_OUT_OF_ARGUMENTS");
              }
              function wn() {
                return uo() || go() || pn() || Dn() || Qn() || Xn(!1) || Je() || un() || Rn(!1) || Qt(!1) || Yn() || Ln() ? $n() : null;
              }
              function un() {
                if (ho(i.TokenKind.BEAN_REF)) {
                  var Ze = hn(), bt = null, Wt = null;
                  ho(i.TokenKind.IDENTIFIER) ? (bt = qo(i.TokenKind.IDENTIFIER), Wt = bt.data) : ho(i.TokenKind.LITERAL_STRING) ? (bt = qo(i.TokenKind.LITERAL_STRING), Wt = bt.stringValue(), Wt = Wt.substring(1, Wt.length() - 1)) : gn(Ze.startPos, "INVALID_BEAN_REFERENCE");
                  var xn = Y.BeanReference.create(sn(bt), Wt);
                  return In(xn), !0;
                }
                return !1;
              }
              function pn() {
                if (ho(i.TokenKind.IDENTIFIER)) {
                  var Ze = zn();
                  if (Ze.stringValue() !== "T")
                    return !1;
                  var bt = hn();
                  if (ho(i.TokenKind.RSQUARE))
                    return In(p.PropertyReference.create(bt.stringValue(), sn(bt))), !0;
                  qo(i.TokenKind.LPAREN);
                  for (var Wt = fn(), xn = 0; Ut(i.TokenKind.LSQUARE, !0); )
                    qo(i.TokenKind.RSQUARE), xn++;
                  return qo(i.TokenKind.RPAREN), In(ae.TypeReference.create(sn(Ze), Wt, xn)), !0;
                }
                return !1;
              }
              function Dn() {
                if (ho(i.TokenKind.IDENTIFIER)) {
                  var Ze = zn();
                  return Ze.stringValue().toLowerCase() !== "null" ? !1 : (hn(), In(u.NullLiteral.create(sn(Ze))), !0);
                }
                return !1;
              }
              function Rn(Ze) {
                var bt = zn();
                if (!Ut(i.TokenKind.PROJECT, !0))
                  return !1;
                var Wt = Re();
                return qo(i.TokenKind.RSQUARE), In(H.Projection.create(Ze, sn(bt), Wt)), !0;
              }
              function Ln() {
                var Ze = zn(), bt = [];
                if (!Ut(i.TokenKind.LCURLY, !0))
                  return !1;
                var Wt = null, xn = zn();
                if (Ut(i.TokenKind.RCURLY, !0))
                  Wt = O.InlineList.create(ao(Ze.startPos, xn.endPos));
                else if (Ut(i.TokenKind.COLON, !0))
                  xn = qo(i.TokenKind.RCURLY), Wt = V.InlineMap.create(ao(Ze.startPos, xn.endPos));
                else {
                  var It = Re();
                  if (ho(i.TokenKind.RCURLY))
                    bt.push(It), xn = qo(i.TokenKind.RCURLY), Wt = O.InlineList.create(ao(Ze.startPos, xn.endPos), bt);
                  else if (Ut(i.TokenKind.COMMA, !0)) {
                    bt.push(It);
                    do
                      bt.push(Re());
                    while (Ut(i.TokenKind.COMMA, !0));
                    xn = qo(i.TokenKind.RCURLY), Wt = O.InlineList.create(sn(Ze.startPos, xn.endPos), bt);
                  } else if (Ut(i.TokenKind.COLON, !0)) {
                    var Jn = [];
                    for (Jn.push(It), Jn.push(Re()); Ut(i.TokenKind.COMMA, !0); )
                      Jn.push(Re()), qo(i.TokenKind.COLON), Jn.push(Re());
                    xn = qo(i.TokenKind.RCURLY), Wt = V.InlineMap.create(ao(Ze.startPos, xn.endPos), Jn);
                  } else
                    gn(Ze.startPos, "OOD");
                }
                return In(Wt), !0;
              }
              function Yn() {
                var Ze = zn();
                if (!Ut(i.TokenKind.LSQUARE, !0))
                  return !1;
                var bt = Re();
                return qo(i.TokenKind.RSQUARE), In(h.Indexer.create(sn(Ze), bt)), !0;
              }
              function Qt(Ze) {
                var bt = zn();
                if (!Gn())
                  return !1;
                hn();
                var Wt = Re();
                return Wt === null && gn(sn(bt), "MISSING_SELECTION_EXPRESSION"), qo(i.TokenKind.RSQUARE), bt.getKind() === i.TokenKind.SELECT_FIRST ? In(U.Selection.create(Ze, U.Selection.FIRST, sn(bt), Wt)) : bt.getKind() === i.TokenKind.SELECT_LAST ? In(U.Selection.create(Ze, U.Selection.LAST, sn(bt), Wt)) : In(U.Selection.create(Ze, U.Selection.ALL, sn(bt), Wt)), !0;
              }
              function fn() {
                for (var Ze = [], bt = zn(); qn(bt); )
                  hn(), bt.kind !== i.TokenKind.DOT && Ze.push(re.Identifier.create(bt.stringValue(), sn(bt))), bt = zn();
                Ze.length || (bt === null && gn(me.length(), "OOD"), gn(bt.startPos, "NOT_EXPECTED_TOKEN", "qualified ID", bt.getKind().toString().toLowerCase()));
                var Wt = ao(Ze[0].getStartPosition(), Ze[Ze.length - 1].getEndPosition());
                return ie.QualifiedIdentifier.create(Wt, Ze);
              }
              function qn(Ze) {
                if (Ze === null || Ze.kind === i.TokenKind.LITERAL_STRING)
                  return !1;
                if (Ze.kind === i.TokenKind.DOT || Ze.kind === i.TokenKind.IDENTIFIER)
                  return !0;
                var bt = Ze.stringValue();
                return bt && bt.length && be.test(bt);
              }
              function Xn(Ze) {
                if (ho(i.TokenKind.IDENTIFIER)) {
                  var bt = hn(), Wt = vt();
                  return Wt === null ? (In(p.PropertyReference.create(Ze, bt.stringValue(), sn(bt))), !0) : (In(_.MethodReference.create(Ze, bt.stringValue(), sn(bt), Wt)), !0);
                }
                return !1;
              }
              function Qn() {
                if (an("new")) {
                  var Ze = hn();
                  if (ho(i.TokenKind.RSQUARE))
                    return In(p.PropertyReference.create(Ze.stringValue(), sn(Ze))), !0;
                  var bt = fn(), Wt = [];
                  if (Wt.push(bt), ho(i.TokenKind.LSQUARE)) {
                    for (var xn = []; Ut(i.TokenKind.LSQUARE, !0); )
                      ho(i.TokenKind.RSQUARE) ? xn.push(null) : xn.push(Re()), qo(i.TokenKind.RSQUARE);
                    Ln() && Wt.push($n()), In(_e.ConstructorReference.create(sn(Ze), xn, Wt));
                  } else
                    Ot(Wt), In(_e.ConstructorReference.create(sn(Ze), Wt));
                  return !0;
                }
                return !1;
              }
              function In(Ze) {
                Q.push(Ze);
              }
              function $n() {
                return Q.pop();
              }
              function uo() {
                var Ze = zn();
                if (Ze === null)
                  return !1;
                if (Ze.getKind() === i.TokenKind.LITERAL_INT || Ze.getKind() === i.TokenKind.LITERAL_LONG)
                  In(c.NumberLiteral.create(parseInt(Ze.stringValue(), 10), sn(Ze)));
                else if (Ze.getKind() === i.TokenKind.LITERAL_REAL || Ze.getKind() === i.TokenKind.LITERAL_REAL_FLOAT)
                  In(c.NumberLiteral.create(parseFloat(Ze.stringValue()), sn(Ze)));
                else if (Ze.getKind() === i.TokenKind.LITERAL_HEXINT || Ze.getKind() === i.TokenKind.LITERAL_HEXLONG)
                  In(c.NumberLiteral.create(parseInt(Ze.stringValue(), 16), sn(Ze)));
                else if (an("true"))
                  In(s.BooleanLiteral.create(!0, sn(Ze)));
                else if (an("false"))
                  In(s.BooleanLiteral.create(!1, sn(Ze)));
                else if (Ze.getKind() === i.TokenKind.LITERAL_STRING)
                  In(l.StringLiteral.create(Ze.stringValue(), sn(Ze)));
                else
                  return !1;
                return hn(), !0;
              }
              function go() {
                if (ho(i.TokenKind.LPAREN)) {
                  hn();
                  var Ze = Re();
                  return qo(i.TokenKind.RPAREN), In(Ze), !0;
                } else
                  return !1;
              }
              function Rr() {
                var Ze = zn();
                if (Ze === null)
                  return null;
                if (Ze.isNumericRelationalOperator())
                  return Ze;
                if (Ze.isIdentifier()) {
                  var bt = Ze.stringValue();
                  if (bt.toLowerCase() === "instanceof")
                    return Ze.asInstanceOfToken();
                  if (bt.toLowerCase() === "matches")
                    return Ze.asMatchesToken();
                  if (bt.toLowerCase() === "between")
                    return Ze.asBetweenToken();
                }
                return null;
              }
              function qo(Ze) {
                var bt = hn();
                return bt === null && gn(me.length, "OOD"), bt.getKind() !== Ze && gn(bt.startPos, "NOT_EXPECTED_TOKEN", Ze.toString().toLowerCase(), bt.getKind().toString().toLowerCase()), bt;
              }
              function ho(Ze) {
                return Ut(Ze, !1);
              }
              function Ut(Ze, bt) {
                if (!An())
                  return !1;
                var Wt = zn();
                return Wt.getKind() === Ze ? (bt && ge++, !0) : Ze === i.TokenKind.IDENTIFIER && Wt.getKind().ordinal() >= i.TokenKind.DIV.ordinal() && Wt.getKind().ordinal() <= i.TokenKind.NOT.ordinal() && Wt.data !== null;
              }
              function Kt() {
                if (!An())
                  return !1;
                for (var Ze = zn(), bt = Array.prototype.slice.call(arguments), Wt = 0, xn = bt.length; Wt < xn; Wt += 1)
                  if (Ze.getKind() === bt[Wt])
                    return !0;
                return !1;
              }
              function an(Ze) {
                if (!An())
                  return !1;
                var bt = zn();
                return bt.getKind() === i.TokenKind.IDENTIFIER && bt.stringValue().toLowerCase() === Ze.toLowerCase();
              }
              function Gn() {
                if (!An())
                  return !1;
                var Ze = zn();
                return Ze.getKind() === i.TokenKind.SELECT || Ze.getKind() === i.TokenKind.SELECT_FIRST || Ze.getKind() === i.TokenKind.SELECT_LAST;
              }
              function An() {
                return ge < ne.length;
              }
              function hn() {
                return ge >= pe ? null : ne[ge++];
              }
              function zn() {
                return ge >= pe ? null : ne[ge];
              }
              function gn(Ze, bt, Wt, xn) {
                throw Wt && (bt += `
Expected: ` + Wt), xn && (bt += `
Actual: ` + xn), {
                  name: "InternalParseException",
                  message: "Error occurred while attempting to parse expression '" + me + "' at position " + Ze + ". Message: " + bt
                };
              }
              function kn(Ze) {
                return Ze.getKind().hasPayload() ? Ze.stringValue() : Ze.getKind().toString().toLowerCase();
              }
              function dt(Ze, bt, Wt) {
                Pt(Ze, bt), cn(Ze, Wt);
              }
              function Pt(Ze, bt) {
                bt === null && gn(Ze.startPos, "LEFT_OPERAND_PROBLEM");
              }
              function cn(Ze, bt) {
                bt === null && gn(Ze.startPos, "RIGHT_OPERAND_PROBLEM");
              }
              function sn(Ze) {
                return (Ze.startPos << 16) + Ze.endPos;
              }
              function ao(Ze, bt) {
                return (Ze << 16) + bt;
              }
              return {
                setConfiguration: ve,
                parse: Te
              };
            };
          },
          /* 6 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Tokenizer = void 0;
            var i = r(7), a = r(2), s = ["DIV", "EQ", "GE", "GT", "LE", "LT", "MOD", "NE", "NOT"], c = [], l = 1, u = 2, d = 4;
            function _() {
              var g;
              for (g = 48; g <= 57; g += 1)
                c[g] |= l | u;
              for (g = 65; g <= 70; g += 1)
                c[g] |= u;
              for (g = 97; g <= 102; g += 1)
                c[g] |= u;
              for (g = 65; g <= 90; g += 1)
                c[g] |= d;
              for (g = 97; g <= 122; g += 1)
                c[g] |= d;
            }
            _();
            function p(g) {
              var f = g, h = g + "\0", $ = h.length, v = 0, b = [];
              function y() {
                for (var J; v < $; )
                  if (J = h[v], U(J))
                    q();
                  else
                    switch (J) {
                      case "+":
                        A(a.TokenKind.INC) ? E(a.TokenKind.INC) : S(a.TokenKind.PLUS);
                        break;
                      case "_":
                        q();
                        break;
                      case "-":
                        A(a.TokenKind.DEC) ? E(a.TokenKind.DEC) : S(a.TokenKind.MINUS);
                        break;
                      case ":":
                        S(a.TokenKind.COLON);
                        break;
                      case ".":
                        S(a.TokenKind.DOT);
                        break;
                      case ",":
                        S(a.TokenKind.COMMA);
                        break;
                      case "*":
                        S(a.TokenKind.STAR);
                        break;
                      case "/":
                        S(a.TokenKind.DIV);
                        break;
                      case "%":
                        S(a.TokenKind.MOD);
                        break;
                      case "(":
                        S(a.TokenKind.LPAREN);
                        break;
                      case ")":
                        S(a.TokenKind.RPAREN);
                        break;
                      case "[":
                        S(a.TokenKind.LSQUARE);
                        break;
                      case "#":
                        S(a.TokenKind.HASH);
                        break;
                      case "]":
                        S(a.TokenKind.RSQUARE);
                        break;
                      case "{":
                        S(a.TokenKind.LCURLY);
                        break;
                      case "}":
                        S(a.TokenKind.RCURLY);
                        break;
                      case "@":
                        S(a.TokenKind.BEAN_REF);
                        break;
                      case "^":
                        A(a.TokenKind.SELECT_FIRST) ? E(a.TokenKind.SELECT_FIRST) : S(a.TokenKind.POWER);
                        break;
                      case "!":
                        A(a.TokenKind.NE) ? E(a.TokenKind.NE) : A(a.TokenKind.PROJECT) ? E(a.TokenKind.PROJECT) : S(a.TokenKind.NOT);
                        break;
                      case "=":
                        A(a.TokenKind.EQ) ? E(a.TokenKind.EQ) : S(a.TokenKind.ASSIGN);
                        break;
                      case "&":
                        if (!A(a.TokenKind.SYMBOLIC_AND))
                          throw {
                            name: "SpelParseException",
                            message: "Missing character '&' in expression (" + f + ") at position " + v
                          };
                        E(a.TokenKind.SYMBOLIC_AND);
                        break;
                      case "|":
                        if (!A(a.TokenKind.SYMBOLIC_OR))
                          throw {
                            name: "SpelParseException",
                            message: "Missing character '|' in expression (" + f + ") at position " + v
                          };
                        E(a.TokenKind.SYMBOLIC_OR);
                        break;
                      case "?":
                        A(a.TokenKind.SELECT) ? E(a.TokenKind.SELECT) : A(a.TokenKind.ELVIS) ? E(a.TokenKind.ELVIS) : A(a.TokenKind.SAFE_NAVI) ? E(a.TokenKind.SAFE_NAVI) : S(a.TokenKind.QMARK);
                        break;
                      case "$":
                        A(a.TokenKind.SELECT_LAST) ? E(a.TokenKind.SELECT_LAST) : q();
                        break;
                      case ">":
                        A(a.TokenKind.GE) ? E(a.TokenKind.GE) : S(a.TokenKind.GT);
                        break;
                      case "<":
                        A(a.TokenKind.LE) ? E(a.TokenKind.LE) : S(a.TokenKind.LT);
                        break;
                      case "0":
                      case "1":
                      case "2":
                      case "3":
                      case "4":
                      case "5":
                      case "6":
                      case "7":
                      case "8":
                      case "9":
                        M(J === "0");
                        break;
                      case " ":
                      case "	":
                      case "\r":
                      case `
`:
                        v += 1;
                        break;
                      case "'":
                        w();
                        break;
                      case '"':
                        N();
                        break;
                      case "\0":
                        v += 1;
                        break;
                      case "\\":
                        throw {
                          name: "SpelParseException",
                          message: "Unexpected escape character in expression (" + f + ") at position " + v
                        };
                      default:
                        throw {
                          name: "SpelParseException",
                          message: "Cannot handle character '" + J + "' in expression (" + f + ") at position " + v
                        };
                    }
              }
              function w() {
                for (var J = v, le = !1, ae; !le; )
                  if (v += 1, ae = h[v], ae === "'" && (h[v + 1] === "'" ? v += 1 : le = !0), ae.charCodeAt(0) === 0)
                    throw {
                      name: "SpelParseException",
                      message: "Non-terminating quoted string in expression (" + f + ") at position " + v
                    };
                v += 1, b.push(new i.Token(a.TokenKind.LITERAL_STRING, D(J, v), J, v));
              }
              function N() {
                for (var J = v, le = !1, ae; !le; )
                  if (v += 1, ae = h[v], ae === '"' && (h[v + 1] === '"' ? v += 1 : le = !0), ae.charCodeAt(0) === 0)
                    throw {
                      name: "SpelParseException",
                      message: "Non-terminating double-quoted string in expression (" + f + ") at position " + v
                    };
                v += 1, b.push(new i.Token(a.TokenKind.LITERAL_STRING, D(J, v), J, v));
              }
              function M(J) {
                var le = !1, ae = v, Y = h[v + 1], re = Y === "x" || Y === "X", ie, _e, he, be;
                if (J && re) {
                  v = v + 1;
                  do
                    v += 1;
                  while (H(h[v]));
                  I("L", "l") ? (R(D(ae + 2, v), !0, ae, v), v += 1) : R(D(ae + 2, v), !1, ae, v);
                  return;
                }
                do
                  v += 1;
                while (V(h[v]));
                if (Y = h[v], Y === ".") {
                  le = !0, ie = v;
                  do
                    v += 1;
                  while (V(h[v]));
                  if (v === ie + 1) {
                    v = ie, L(D(ae, v), !1, ae, v);
                    return;
                  }
                }
                if (_e = v, I("L", "l")) {
                  if (le)
                    throw {
                      name: "SpelParseException",
                      message: "Real cannot be long in expression (" + f + ") at position " + v
                    };
                  L(D(ae, _e), !0, ae, _e), v += 1;
                } else if (z(h[v])) {
                  le = !0, v += 1, he = h[v], O(he) && (v += 1);
                  do
                    v += 1;
                  while (V(h[v]));
                  be = !1, F(h[v]) ? (be = !0, v += 1, _e = v) : P(h[v]) && (v += 1, _e = v), T(D(ae, v), be, ae, v);
                } else
                  Y = h[v], be = !1, F(Y) ? (le = !0, be = !0, v += 1, _e = v) : P(Y) && (le = !0, v += 1, _e = v), le ? T(D(ae, _e), be, ae, _e) : L(D(ae, _e), !1, ae, _e);
              }
              function q() {
                var J = v, le, ae, Y;
                do
                  v += 1;
                while (k(h[v]));
                if (le = D(J, v), (v - J === 2 || v - J === 3) && (ae = le.toUpperCase(), Y = s.indexOf(ae), Y >= 0)) {
                  x(a.TokenKind.valueOf(ae), J, le);
                  return;
                }
                b.push(new i.Token(a.TokenKind.IDENTIFIER, le.replace("\0", ""), J, v));
              }
              function L(J, le, ae, Y) {
                le ? b.push(new i.Token(a.TokenKind.LITERAL_LONG, J, ae, Y)) : b.push(new i.Token(a.TokenKind.LITERAL_INT, J, ae, Y));
              }
              function R(J, le, ae, Y) {
                if (J.length === 0)
                  throw le ? {
                    name: "SpelParseException",
                    message: "Not a long in expression (" + f + ") at position " + v
                  } : {
                    name: "SpelParseException",
                    message: "Not an int in expression (" + f + ") at position " + v
                  };
                le ? b.push(new i.Token(a.TokenKind.LITERAL_HEXLONG, J, ae, Y)) : b.push(new i.Token(a.TokenKind.LITERAL_HEXINT, J, ae, Y));
              }
              function T(J, le, ae, Y) {
                le ? b.push(new i.Token(a.TokenKind.LITERAL_REAL_FLOAT, J, ae, Y)) : b.push(new i.Token(a.TokenKind.LITERAL_REAL, J, ae, Y));
              }
              function D(J, le) {
                return h.substring(J, le);
              }
              function A(J) {
                return J.tokenChars.length === 2 && h[v] === J.tokenChars[0] ? h[v + 1] === J.tokenChars[1] : !1;
              }
              function S(J) {
                b.push(new i.Token(J, null, v, v + 1)), v += 1;
              }
              function E(J) {
                b.push(new i.Token(J, null, v, v + 2)), v += 2;
              }
              function x(J, le, ae) {
                b.push(new i.Token(J, ae, le, le + J.getLength()));
              }
              function k(J) {
                return U(J) || V(J) || J === "_" || J === "$";
              }
              function I(J, le) {
                var ae = h[v];
                return ae === J || ae === le;
              }
              function z(J) {
                return J === "e" || J === "E";
              }
              function F(J) {
                return J === "f" || J === "F";
              }
              function P(J) {
                return J === "d" || J === "D";
              }
              function O(J) {
                return J === "+" || J === "-";
              }
              function V(J) {
                return J.charCodeAt(0) > 255 ? !1 : (c[J.charCodeAt(0)] & l) !== 0;
              }
              function U(J) {
                return J.charCodeAt(0) > 255 ? !1 : (c[J.charCodeAt(0)] & d) !== 0;
              }
              function H(J) {
                return J.charCodeAt(0) > 255 ? !1 : (c[J.charCodeAt(0)] & u) !== 0;
              }
              return y(), b;
            }
            o.Tokenizer = {
              tokenize: p
            };
          },
          /* 7 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Token = void 0;
            var i = r(2);
            function a(s, c, l, u) {
              this.kind = s, this.startPos = l, this.endPos = u, c && (this.data = c);
            }
            a.prototype.getKind = function() {
              return this.kind;
            }, a.prototype.toString = function() {
              var s = "[";
              return s += this.kind.toString(), this.kind.hasPayload() && (s += ":" + this.data), s += "]", s += "(" + this.startPos + "," + this.endPos + ")", s;
            }, a.prototype.isIdentifier = function() {
              return this.kind === i.TokenKind.IDENTIFIER;
            }, a.prototype.isNumericRelationalOperator = function() {
              return this.kind === i.TokenKind.GT || this.kind === i.TokenKind.GE || this.kind === i.TokenKind.LT || this.kind === i.TokenKind.LE || this.kind === i.TokenKind.EQ || this.kind === i.TokenKind.NE;
            }, a.prototype.stringValue = function() {
              return this.data;
            }, a.prototype.asInstanceOfToken = function() {
              return new a(i.TokenKind.INSTANCEOF, this.startPos, this.endPos);
            }, a.prototype.asMatchesToken = function() {
              return new a(i.TokenKind.MATCHES, this.startPos, this.endPos);
            }, a.prototype.asBetweenToken = function() {
              return new a(i.TokenKind.BETWEEN, this.startPos, this.endPos);
            }, a.prototype.getStartPosition = function() {
              return this.startPos;
            }, a.prototype.getEndPosition = function() {
              return this.endPos;
            }, o.Token = a;
          },
          /* 8 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.BooleanLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("boolean", c);
              return l.getValue = function() {
                return s;
              }, l.setValue = function(u) {
                return s = u;
              }, l;
            }
            o.BooleanLiteral = {
              create: a
            };
          },
          /* 9 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.NumberLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("number", c);
              return l.getValue = function() {
                return s;
              }, l.setValue = function(u) {
                return s = u;
              }, l;
            }
            o.NumberLiteral = {
              create: a
            };
          },
          /* 10 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.StringLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("string", c);
              function u(d) {
                return (d[0] === "'" && d[d.length - 1] === "'" || d[0] === '"' && d[d.length - 1] === '"') && (d = d.substring(1, d.length - 1)), d.replace(/''/g, "'").replace(/""/g, '"');
              }
              return s = u(s), l.getValue = function() {
                return s;
              }, l.setValue = function(d) {
                return s = d;
              }, l;
            }
            o.StringLiteral = {
              create: a
            };
          },
          /* 11 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.NullLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("null", c);
              return l.getValue = function() {
                return null;
              }, l;
            }
            o.NullLiteral = {
              create: a
            };
          },
          /* 12 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.FunctionReference = void 0;
            var i = r(0), a = r(1);
            function s(c, l, u) {
              var d = i.SpelNode.create("function", l);
              return d.getRaw = function() {
                return {
                  functionName: c,
                  args: u
                };
              }, d.getValue = function(_) {
                var p = _.locals || {}, g = _.rootContext, f = [];
                if (u.forEach(function(h) {
                  var $ = _.activeContext;
                  _.activeContext = new a.Stack(), _.activeContext.push(_.rootContext), f.push(h.getValue(_)), _.activeContext = $;
                }), p[c])
                  return p[c].apply(g, f);
                throw {
                  name: "FunctionDoesNotExistException",
                  message: "Function '" + c + "' does not exist."
                };
              }, d;
            }
            o.FunctionReference = {
              create: s
            };
          },
          /* 13 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.MethodReference = void 0;
            var i = r(0), a = r(1);
            function s(c, l, u, d) {
              var _ = i.SpelNode.create("method", u);
              return _.getRaw = function() {
                return {
                  methodName: l,
                  args: d
                };
              }, _.getValue = function(p) {
                var g = p.activeContext.peek(), f = [], h;
                if (!g)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to look up property '" + l + "' for an undefined context."
                  };
                function $(v) {
                  if (v == null) {
                    if (c)
                      return null;
                    throw {
                      name: "NullPointerException",
                      message: "Method " + l + " does not exist."
                    };
                  }
                  return v;
                }
                if (d.forEach(function(v) {
                  var b = p.activeContext;
                  p.activeContext = new a.Stack(), p.activeContext.push(p.rootContext), f.push(v.getValue(p)), p.activeContext = b;
                }), l.substr(0, 3) === "get" && !g[l])
                  return $(g[l.charAt(3).toLowerCase() + l.substring(4)]);
                if (l.substr(0, 3) === "set" && !g[l])
                  return g[l.charAt(3).toLowerCase() + l.substring(4)] = f[0];
                if (Array.isArray(g)) {
                  if (l === "size")
                    return g.length;
                  if (l === "contains")
                    return g.includes(f[0]);
                }
                return h = $(g[l]), h ? h.apply(g, f) : null;
              }, _;
            }
            o.MethodReference = {
              create: s
            };
          },
          /* 14 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.PropertyReference = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("property", l);
              return u.getRaw = function() {
                return c;
              }, u.getValue = function(d) {
                var _ = d.activeContext.peek();
                if (!_) {
                  if (s)
                    return null;
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to look up property '" + c + "' for an undefined context."
                  };
                }
                if (_[c] === void 0 || _[c] === null) {
                  if (s)
                    return null;
                  if (c === "size" && Array.isArray(_))
                    return _.length;
                  throw {
                    name: "NullPointerException",
                    message: "Property '" + c + "' does not exist."
                  };
                }
                return _[c];
              }, u.setValue = function(d, _) {
                var p = _.activeContext.peek();
                if (!p)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to assign property '" + c + "' for an undefined context."
                  };
                return p[c] = d;
              }, u.getName = function() {
                return c;
              }, u;
            }
            o.PropertyReference = {
              create: a
            };
          },
          /* 15 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.VariableReference = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("variable", c);
              return l.getRaw = function() {
                return s;
              }, l.getValue = function(u) {
                var d = u.activeContext.peek(), _ = u.locals;
                if (!d)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to look up variable '" + s + "' for an undefined context."
                  };
                return s === "this" ? d : s === "root" ? u.rootContext : _[s];
              }, l.setValue = function(u, d) {
                var _ = d.locals;
                return _[s] = u;
              }, l;
            }
            o.VariableReference = {
              create: a
            };
          },
          /* 16 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.CompoundExpression = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create.apply(null, ["compound", s].concat(c));
              function u(d) {
                var _ = l.getChildren().length, p;
                for (p = 0; p < _; p += 1)
                  l.getChildren()[p].getType() === "indexer" ? d.activeContext.push(d.activeContext.peek()[l.getChildren()[p].getValue(d)]) : d.activeContext.push(l.getChildren()[p].getValue(d));
                return function() {
                  for (p = 0; p < _; p += 1)
                    d.activeContext.pop();
                };
              }
              return l.getValue = function(d) {
                var _ = d.activeContext.peek(), p;
                if (!_)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to evaluate compound expression with an undefined context."
                  };
                var g = u(d);
                return p = d.activeContext.peek(), g(), p;
              }, l.setValue = function(d, _) {
                var p = u(_), g = l.getChildren().length;
                return _.activeContext.pop(), d = l.getChildren()[g - 1].setValue(d, _), _.activeContext.push(null), p(), d;
              }, l;
            }
            o.CompoundExpression = {
              create: a
            };
          },
          /* 17 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Indexer = void 0;
            var i = r(0), a = r(1);
            function s(c, l) {
              var u = i.SpelNode.create.apply(null, ["indexer", c].concat(l));
              return u.getValue = function(d) {
                var _ = d.activeContext, p, g = u.getChildren().length, f, h;
                if (d.activeContext = new a.Stack(), d.activeContext.push(d.rootContext), p = d.activeContext.peek(), !p)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to evaluate compound expression with an undefined context."
                  };
                for (f = 0; f < g; f += 1)
                  d.activeContext.push(u.getChildren()[f].getValue(d));
                for (h = d.activeContext.peek(), f = 0; f < g; f += 1)
                  d.activeContext.pop();
                return d.activeContext = _, h;
              }, u;
            }
            o.Indexer = {
              create: s
            };
          },
          /* 18 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Assign = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("assign", s, c, l);
              return u.getValue = function(d) {
                var _ = d.activeContext.peek();
                if (!_)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to assign property '" + c.getValue(d) + "' for an undefined context."
                  };
                return c.setValue(l.getValue(d), d);
              }, u;
            }
            o.Assign = {
              create: a
            };
          },
          /* 19 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpEQ = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-eq", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) === l.getValue(d);
              }, u;
            }
            o.OpEQ = {
              create: a
            };
          },
          /* 20 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpNE = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-ne", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) !== l.getValue(d);
              }, u;
            }
            o.OpNE = {
              create: a
            };
          },
          /* 21 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpGE = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-ge", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) >= l.getValue(d);
              }, u;
            }
            o.OpGE = {
              create: a
            };
          },
          /* 22 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpGT = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-gt", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) > l.getValue(d);
              }, u;
            }
            o.OpGT = {
              create: a
            };
          },
          /* 23 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpLE = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-le", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) <= l.getValue(d);
              }, u;
            }
            o.OpLE = {
              create: a
            };
          },
          /* 24 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpLT = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-lt", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) < l.getValue(d);
              }, u;
            }
            o.OpLT = {
              create: a
            };
          },
          /* 25 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpPlus = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-plus", s, c, l);
              return u.getValue = function(d) {
                return l ? c.getValue(d) + l.getValue(d) : +c.getValue(d);
              }, u;
            }
            o.OpPlus = {
              create: a
            };
          },
          /* 26 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpMinus = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-minus", s, c, l);
              return u.getValue = function(d) {
                return l ? c.getValue(d) - l.getValue(d) : -c.getValue(d);
              }, u;
            }
            o.OpMinus = {
              create: a
            };
          },
          /* 27 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpMultiply = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-multiply", s, c, l);
              return u.getValue = function(d) {
                var _ = c.getValue(d), p = l.getValue(d);
                if (typeof _ == "number" && typeof p == "number")
                  return _ * p;
                if (typeof _ == "string" && typeof p == "number") {
                  for (var g = "", f = 0; f < p; f += 1)
                    g += _;
                  return g;
                }
                return null;
              }, u;
            }
            o.OpMultiply = {
              create: a
            };
          },
          /* 28 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpDivide = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-divide", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) / l.getValue(d);
              }, u;
            }
            o.OpDivide = {
              create: a
            };
          },
          /* 29 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpModulus = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-modulus", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) % l.getValue(d);
              }, u;
            }
            o.OpModulus = {
              create: a
            };
          },
          /* 30 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpPower = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-power", s, c, l);
              return u.getValue = function(d) {
                return Math.pow(c.getValue(d), l.getValue(d));
              }, u;
            }
            o.OpPower = {
              create: a
            };
          },
          /* 31 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpInc = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-inc", s, l);
              return u.getValue = function(d) {
                var _ = l.getValue(d);
                return l.setValue(_ + 1, d), c ? _ : _ + 1;
              }, u;
            }
            o.OpInc = {
              create: a
            };
          },
          /* 32 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpDec = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-dec", s, l);
              return u.getValue = function(d) {
                var _ = l.getValue(d);
                return l.setValue(_ - 1, d), c ? _ : _ - 1;
              }, u;
            }
            o.OpDec = {
              create: a
            };
          },
          /* 33 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpNot = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("op-not", s, c);
              return l.getValue = function(u) {
                return !c.getValue(u);
              }, l;
            }
            o.OpNot = {
              create: a
            };
          },
          /* 34 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpAnd = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-and", s, c, l);
              return u.getValue = function(d) {
                return !!c.getValue(d) && !!l.getValue(d);
              }, u;
            }
            o.OpAnd = {
              create: a
            };
          },
          /* 35 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpOr = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("op-or", s, c, l);
              return u.getValue = function(d) {
                return !!c.getValue(d) || !!l.getValue(d);
              }, u;
            }
            o.OpOr = {
              create: a
            };
          },
          /* 36 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpMatches = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("matches", s, c, l);
              return u.getValue = function(d) {
                var _ = c.getValue(d), p = l.getValue(d);
                try {
                  var g = new RegExp(p);
                  return !!g.exec(_);
                } catch (f) {
                  throw {
                    name: "EvaluationException",
                    message: f.toString()
                  };
                }
              }, u;
            }
            o.OpMatches = {
              create: a
            };
          },
          /* 37 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Ternary = void 0;
            var i = r(0);
            function a(s, c, l, u) {
              var d = i.SpelNode.create("ternary", s, c, l, u);
              return d.getValue = function(_) {
                return c.getValue(_) ? l.getValue(_) : u.getValue(_);
              }, d;
            }
            o.Ternary = {
              create: a
            };
          },
          /* 38 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Elvis = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("elvis", s, c, l);
              return u.getValue = function(d) {
                return c.getValue(d) !== null ? c.getValue(d) : l.getValue(d);
              }, u;
            }
            o.Elvis = {
              create: a
            };
          },
          /* 39 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.InlineList = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("list", s), u = [].concat(c || []);
              return l.getRaw = function() {
                return u;
              }, l.getValue = function(d) {
                return u.map(function(_) {
                  return _.getValue(d);
                });
              }, l;
            }
            o.InlineList = {
              create: a
            };
          },
          /* 40 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.InlineMap = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("map", s), u = [].concat(c || []);
              return l.getValue = function(d) {
                var _ = !0, p = null, g = {};
                return u.forEach(function(f) {
                  _ ? f.getType() === "property" ? p = f.getName() : p = f.getValue(d) : g[p] = f.getValue(d), _ = !_;
                }), g;
              }, l;
            }
            o.InlineMap = {
              create: a
            };
          },
          /* 41 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Selection = void 0;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
              return typeof d;
            } : function(d) {
              return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
            }, a = r(0);
            function s(d, _, p) {
              var g = !1;
              return p.activeContext.push(d), g = _.getValue(p), p.activeContext.pop(), g;
            }
            function c(d, _, p, g) {
              var f = d.filter(function(h) {
                return s(h, p, g);
              });
              switch (_) {
                case "ALL":
                  return f;
                case "FIRST":
                  return f[0] || null;
                case "LAST":
                  return f.length ? f[f.length - 1] : null;
              }
            }
            function l(d, _, p, g) {
              var f = {}, h, $, v = [], b = {};
              for ($ in d)
                d.hasOwnProperty($) && (h = {
                  key: $,
                  value: d[$]
                }, s(h, p, g) && v.push(h));
              switch (_) {
                case "ALL":
                  return v.forEach(function(y) {
                    f[y.key] = y.value;
                  }), f;
                case "FIRST":
                  return v.length ? (b[v[0].key] = v[0].value, b) : null;
                case "LAST":
                  return v.length ? (b[v[v.length - 1].key] = v[v.length - 1].value, b) : null;
              }
              v.forEach(function(y) {
                f[y.key] = y.value;
              });
            }
            function u(d, _, p, g) {
              var f = a.SpelNode.create("selection", p, g);
              return f.getValue = function(h) {
                var $ = h.activeContext.peek();
                if ($) {
                  if (Array.isArray($))
                    return c($, _, g, h);
                  if ((typeof $ > "u" ? "undefined" : i($)) === "object")
                    return l($, _, g, h);
                }
                return null;
              }, f;
            }
            o.Selection = {
              create: u,
              FIRST: "FIRST",
              LAST: "LAST",
              ALL: "ALL"
            };
          },
          /* 42 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Projection = void 0;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            }, a = r(0);
            function s(l, u, d) {
              return l.map(function(_) {
                var p;
                return d.activeContext.push(_), p = u.getValue(d), d.activeContext.pop(), p;
              });
            }
            function c(l, u, d) {
              var _ = a.SpelNode.create("projection", u, d);
              return _.getValue = function(p) {
                var g = p.activeContext.peek(), f = [], h;
                if (Array.isArray(g))
                  return s(g, d, p);
                if ((typeof g > "u" ? "undefined" : i(g)) === "object") {
                  for (h in g)
                    g.hasOwnProperty(h) && f.push(g[h]);
                  return s(f, d, p);
                }
                return null;
              }, _;
            }
            o.Projection = {
              create: c
            };
          },
          /* 43 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpInstanceof = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("instanceof", s, c, l);
              return u.getValue = function(d) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "OpInstanceOf: Not implemented"
                };
              }, u;
            }
            o.OpInstanceof = {
              create: a
            };
          },
          /* 44 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpBetween = void 0;
            var i = r(0);
            function a(s, c, l) {
              var u = i.SpelNode.create("between", s, c, l);
              return u.getValue = function(d) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "OpBetween: Not implemented"
                };
              }, u;
            }
            o.OpBetween = {
              create: a
            };
          },
          /* 45 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.TypeReference = void 0;
            var i = r(0);
            function a(s, u, l) {
              var u = i.SpelNode.create("typeref", s, u);
              return u.getValue = function(d) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "TypeReference: Not implemented"
                };
              }, u;
            }
            o.TypeReference = {
              create: a
            };
          },
          /* 46 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.BeanReference = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("beanref", s);
              return l.getValue = function(u) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "BeanReference: Not implemented"
                };
              }, l;
            }
            o.BeanReference = {
              create: a
            };
          },
          /* 47 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Identifier = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("identifier", c);
              return l.getRaw = function() {
                return s;
              }, l.getValue = function(u) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "Identifier: Not implemented"
                };
              }, l;
            }
            o.Identifier = {
              create: a
            };
          },
          /* 48 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.QualifiedIdentifier = void 0;
            var i = r(0);
            function a(c) {
              if (Array.isArray(c)) {
                for (var l = 0, u = Array(c.length); l < c.length; l++)
                  u[l] = c[l];
                return u;
              } else
                return Array.from(c);
            }
            function s(c, l) {
              var u = i.SpelNode.create.apply(i.SpelNode, ["qualifiedidentifier", c].concat(a(l)));
              return u.getRaw = function() {
                return l.map(function(d) {
                  return d.getRaw();
                });
              }, u.getValue = function(d) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "QualifiedIdentifier: Not implemented"
                };
              }, u;
            }
            o.QualifiedIdentifier = {
              create: s
            };
          },
          /* 49 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.ConstructorReference = void 0;
            var i = r(0), a = r(1);
            function s(u) {
              if (Array.isArray(u)) {
                for (var d = 0, _ = Array(u.length); d < u.length; d++)
                  _[d] = u[d];
                return _;
              } else
                return Array.from(u);
            }
            function c(u) {
              return Array.isArray(u) ? u : Array.from(u);
            }
            function l(u, d, _) {
              var p = _ !== void 0, g;
              p ? g = d.length && d[0] && d[0].getType() === "number" ? d[0].getValue() : null : (_ = d, d = void 0);
              var f = _, h = c(f);
              h[0];
              var $ = h.slice(1), v = i.SpelNode.create.apply(i.SpelNode, ["constructorref", u].concat(s(_)));
              return v.getRaw = function() {
                return g;
              }, v.getValue = function(b) {
                if (p && $.length <= 1) {
                  var y = [];
                  return $.forEach(function(w) {
                    var N = b.activeContext;
                    b.activeContext = new a.Stack(), b.activeContext.push(b.rootContext), y.push(w.getValue(b)), b.activeContext = N;
                  }), $.length === 1 ? y[0] : g ? new Array(g) : [];
                }
                throw {
                  name: "MethodNotImplementedException",
                  message: "ConstructorReference: Not implemented"
                };
              }, v;
            }
            o.ConstructorReference = {
              create: l
            };
          },
          /* 50 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            });
            function i(a, s) {
              var c = {};
              return c.authentication = a || {}, c.principal = s || {}, c.hasRole = function(l) {
                var u = !1;
                return !l || !c.authentication && !Array.isArray(c.authentication.authorities) ? !1 : (c.authentication.authorities.forEach(function(d) {
                  d.authority.toLowerCase() === l.toLowerCase() && (u = !0);
                }), u);
              }, c.hasPermission = function() {
                var l = Array.prototype.slice.call(arguments);
                if (l.length === 1)
                  return c.hasRole(l[0]);
              }, c;
            }
            o.StandardContext = {
              create: i
            };
          }
          /******/
        ])
      );
    });
  }(DL)), DL.exports;
}
var Ioe;
function qru() {
  if (Ioe)
    return wh;
  Ioe = 1;
  var e = Tn;
  Object.defineProperty(wh, "__esModule", {
    value: !0
  }), wh.loadFromSpel = wh._loadFromSpel = void 0;
  var t = e(Gu()), n = e(xo), o = e(Yr()), r = e(Zu), i = Fru(), a = e(Ug()), s = Qi(), c = Es(), l = GV(), u = kl(), d = Ti(), _ = e(Fv);
  function p(E, x) {
    var k = Object.keys(E);
    if (Object.getOwnPropertySymbols) {
      var I = Object.getOwnPropertySymbols(E);
      x && (I = I.filter(function(z) {
        return Object.getOwnPropertyDescriptor(E, z).enumerable;
      })), k.push.apply(k, I);
    }
    return k;
  }
  function g(E) {
    for (var x = 1; x < arguments.length; x++) {
      var k = arguments[x] != null ? arguments[x] : {};
      x % 2 ? p(Object(k), !0).forEach(function(I) {
        (0, o.default)(E, I, k[I]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(k)) : p(Object(k)).forEach(function(I) {
        Object.defineProperty(E, I, Object.getOwnPropertyDescriptor(k, I));
      });
    }
    return E;
  }
  var f = function(x, k) {
    return h(x, k, !0);
  };
  wh.loadFromSpel = f;
  var h = function(x, k) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, z = {
      errors: []
    }, F = (0, s.extendConfig)(k), P = b(F), O, V, U = void 0;
    try {
      var H = i.SpelExpressionEvaluator.compile(x);
      O = H._compiledExpression;
    } catch (le) {
      z.errors.push(le);
    }
    O && (d.logger.debug("compiledExpression:", O), V = $(O, z), d.logger.debug("convertedObj:", V, z), U = L(V, P, F, z), U && U.type != "group" && U.type != "switch_group" && (U = S(U, F)), d.logger.debug("jsTree:", U));
    var J = U ? (0, l.loadTree)(U) : void 0;
    return I ? [J, z.errors] : (z.errors.length && console.warn("Errors while importing from SpEL:", z.errors), J);
  };
  wh._loadFromSpel = h;
  var $ = function E(x, k) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, z = x.getType(), F = x.getChildren().map(function(ve) {
      return E(ve, k, x);
    });
    if ((z == "op-or" || z == "op-and") && (F = F.reduce(function(ve, Te) {
      var Re = Te.type == z && !Te.not, Me = Re ? Te.children : [Te];
      return [].concat((0, r.default)(ve), (0, r.default)(Me));
    }, [])), z == "op-not")
      return F.length != 1 && k.errors.push("Operator NOT should have 1 child, but got ".concat(F.length, "}")), g(g({}, F[0]), {}, {
        not: !F[0].not
      });
    if (z == "compound") {
      F = F.filter(function(ve) {
        var Te = ve.type == "selection" && ve.children.length == 1 && ve.children[0].type == "boolean" && ve.children[0].val == !0;
        return !Te;
      });
      var P = F.find(function(ve) {
        return ve.type == "selection";
      });
      P && P.children.length != 1 && k.errors.push("Selection should have 1 child, but got ".concat(P.children.length));
      var O = P ? P.children[0] : null, V = F[F.length - 1], U = V.type == "method" && V.val.methodName == "size" || V.type == "!func" && V.methodName == "size", H = V.type == "property" && V.val == "length", J = F.filter(function(ve) {
        return ve !== P && ve !== V;
      }), le = {
        type: "compound",
        children: J
      };
      if (U || H)
        return {
          type: "!aggr",
          filter: O,
          source: le
        };
      if (F = F.filter(function(ve) {
        var Te = ve.type == "variable" && ve.val == "this", Re = ve.type == "variable" && ve.val == "root";
        return !(Te || Re);
      }), F = F.map(function(ve) {
        return ve.type == "indexer" && ve.children.length == 1 ? {
          type: "indexer",
          val: ve.children[0].val,
          itype: ve.children[0].type
        } : ve;
      }), V.type == "method") {
        var ae = F.filter(function(ve) {
          return ve !== V;
        });
        return {
          type: "!func",
          obj: ae,
          methodName: V.val.methodName,
          args: V.val.args
        };
      }
      if (V.type == "!func") {
        var Y = F.filter(function(ve) {
          return ve !== V;
        });
        return g(g({}, V), {}, {
          obj: Y
        });
      }
    }
    var re;
    try {
      x.getRaw ? re = x.getRaw() : x.getValue.length == 0 && (re = x.getValue());
    } catch (ve) {
      d.logger.error("[spel2js] Error in getValue()", ve);
    }
    if (z == "ternary" && (re = v(F)), (0, n.default)(re) === "object" && re !== null && (re.methodName || re.functionName) && (re.args = re.args.map(function(ve) {
      return E(ve, k, x);
    })), z == "list" && (re = re.map(function(ve) {
      return E(ve, k, x);
    }), !I && re.length == 1))
      return re[0];
    if (z == "constructorref") {
      var ie = F.find(function(ve) {
        return ve.type == "qualifiedidentifier";
      }), _e = ie == null ? void 0 : ie.val;
      if (!_e) {
        k.errors.push("Can't find qualifiedidentifier in constructorref children: ".concat(JSON.stringify(F)));
        return;
      }
      var he = F.filter(function(ve) {
        return ve.type != "qualifiedidentifier";
      });
      return {
        type: "!new",
        cls: _e,
        args: he
      };
    }
    if (z == "typeref") {
      var be = F.find(function(ve) {
        return ve.type == "qualifiedidentifier";
      }), Q = be == null ? void 0 : be.val;
      if (!Q) {
        k.errors.push("Can't find qualifiedidentifier in typeref children: ".concat(JSON.stringify(F)));
        return;
      }
      return F.filter(function(ve) {
        return ve.type != "qualifiedidentifier";
      }), {
        type: "!type",
        cls: Q
      };
    }
    if (z == "function" || z == "method") {
      var me = re, ne = me.functionName, pe = me.methodName, ge = me.args;
      return {
        type: "!func",
        methodName: ne || pe,
        isVar: z == "function",
        args: ge
      };
    }
    return {
      type: z,
      children: F,
      val: re
    };
  }, v = function(x) {
    var k = [];
    function I(z) {
      var F = (0, t.default)(z, 3), P = F[0], O = F[1], V = F[2];
      k.push([P, O]), (V == null ? void 0 : V.type) == "ternary" ? I(V.children) : k.push([void 0, V]);
    }
    return I(x), k;
  }, b = function(x) {
    var k = {}, I = function(Y) {
      var re = x.operators[Y];
      if (re.spelOps)
        re.spelOps.forEach(function(_e) {
          var he = _e;
          k[he] || (k[he] = []), k[he].push(Y);
        });
      else if (re.spelOp) {
        var ie = re.spelOp;
        k[ie] || (k[ie] = []), k[ie].push(Y);
      } else
        d.logger.log("[spel] No spelOp for operator ".concat(Y));
    };
    for (var z in x.operators)
      I(z);
    var F = {};
    for (var P in x.conjunctions) {
      var O = x.conjunctions[P], V = O.spelConj || P.toLowerCase();
      F[V] = P;
    }
    var U = {};
    for (var H in x.funcs) {
      var J = x.funcs[H], le = void 0;
      typeof J.spelFunc == "string" && (le = J.spelFunc), le && (U[le] || (U[le] = []), U[le].push(H));
    }
    return {
      operators: k,
      conjunctions: F,
      funcs: U
    };
  }, y = function(x, k) {
    var I = !1, z = x.map(function(F) {
      if (F.type == "variable" || F.type == "property" || F.type == "indexer" && F.itype == "string")
        return F.val;
      I = !0, k.errors.push("Unexpected item in compound: ".concat(JSON.stringify(F)));
    });
    return I ? void 0 : z;
  }, w = function E(x, k, I, z, F) {
    if (x != null) {
      var P = I.settings.fieldSeparator, O = {
        number: "number",
        string: "text",
        boolean: "boolean",
        null: "null"
        // should not be
      }, V = F != null && F._groupField ? [F == null ? void 0 : F._groupField] : [];
      if (x.type == "compound") {
        var U, H, J = y(x.children, z);
        if (!J)
          return;
        var le = [].concat(V, (0, r.default)(J)), ae = ((U = x.children) === null || U === void 0 || (H = U[0]) === null || H === void 0 ? void 0 : H.type) == "variable";
        return {
          valueSrc: "field",
          //valueType: todo
          isVariable: ae,
          value: le.join(P)
        };
      } else if (x.type == "variable" || x.type == "property") {
        var Y = [].concat(V, [x.val]), re = x.type == "variable";
        return {
          valueSrc: "field",
          //valueType: todo
          isVariable: re,
          value: Y.join(P)
        };
      } else if (O[x.type]) {
        var ie = x.val, _e = O[x.type];
        return F != null && F.isUnary && (ie = -ie), {
          valueSrc: "value",
          valueType: _e,
          value: ie
        };
      } else if (x.type == "list") {
        var he, be = x.val.map(function($n) {
          return E($n, k, I, z, x);
        });
        be.length && ((he = be[0]) === null || he === void 0 || he.valueType);
        var Q = be.map(function($n) {
          return $n == null ? void 0 : $n.value;
        }), me = "multiselect";
        return {
          valueSrc: "value",
          valueType: me,
          value: Q
        };
      } else if (x.type == "!func") {
        var ne, pe = x.obj, ge = x.methodName, ve = x.args;
        x.isVar;
        var Te = (ne = {}, (0, o.default)(ne, ".contains", "like"), (0, o.default)(ne, ".startsWith", "starts_with"), (0, o.default)(ne, ".endsWith", "ends_with"), (0, o.default)(ne, "$contains", "select_any_in"), ne), Re = ve.map(function($n) {
          return E($n, k, I, z, g(g({}, x), {}, {
            _groupField: F == null ? void 0 : F._groupField
          }));
        });
        if (ge == "contains" && pe && pe[0].type == "list") {
          var Me = pe.map(function($n) {
            return E($n, k, I, z, x);
          });
          if (!(Re.length == 1 && Re[0].valueSrc == "field")) {
            z.errors.push("Expected arg to method ".concat(ge, " to be field but got: ").concat(JSON.stringify(Re)));
            return;
          }
          var et = Re[0].value;
          if (!(Me.length == 1 && Me[0].valueType == "multiselect")) {
            z.errors.push("Expected object of method ".concat(ge, " to be inline list but got: ").concat(JSON.stringify(Me)));
            return;
          }
          var st = Te["$" + ge], De = Me[0];
          return N(I, z, et, st, [De]);
        } else if (Te["." + ge]) {
          var ze = Te["." + ge], Pe = y(pe, z);
          if (Pe && Re.length == 1) {
            var je = [].concat(V, (0, r.default)(Pe)), He = je.join(P);
            return N(I, z, He, ze, Re);
          }
        } else if (ge == "parse" && pe && pe[0].type == "!new" && pe[0].cls.at(-1) == "SimpleDateFormat") {
          var Xe = pe[0].args.map(function($n) {
            return E($n, k, I, z, g(g({}, x), {}, {
              _groupField: F == null ? void 0 : F._groupField
            }));
          });
          if (!(Xe.length == 1 && Xe[0].valueType == "text")) {
            z.errors.push("Expected args of ".concat(pe[0].cls.join("."), ".").concat(ge, " to be 1 string but got: ").concat(JSON.stringify(Xe)));
            return;
          }
          if (!(Re.length == 1 && Re[0].valueType == "text")) {
            z.errors.push("Expected args of ".concat(pe[0].cls.join("."), " to be 1 string but got: ").concat(JSON.stringify(Re)));
            return;
          }
          var at = Xe[0].value, wt = Re[0].value, Je = at.includes(" ") ? "datetime" : "date", vt = null, Ot = Je, Ft = (0, s.getFieldConfig)(I, vt), wn = I.widgets[Ot || (Ft == null ? void 0 : Ft.mainWidget)], un = wn.valueFormat, pn = (0, _.default)(wt, _.default.ISO_8601), Dn = pn.isValid() ? pn.format(un) : void 0;
          return {
            valueSrc: "value",
            valueType: Je,
            value: Dn
          };
        } else if (ge == "parse" && pe && pe[0].type == "!type" && pe[0].cls.at(-1) == "LocalTime") {
          if (!(Re.length == 1 && Re[0].valueType == "text")) {
            z.errors.push("Expected args of ".concat(pe[0].cls.join("."), " to be 1 string but got: ").concat(JSON.stringify(Re)));
            return;
          }
          var Rn = Re[0].value, Ln = "time", Yn = null, Qt = Ln, fn = (0, s.getFieldConfig)(I, Yn), qn = I.widgets[Qt || (fn == null ? void 0 : fn.mainWidget)], Xn = qn.valueFormat, Qn = (0, _.default)(Rn, "HH:mm:ss"), In = Qn.isValid() ? Qn.format(Xn) : void 0;
          return {
            valueSrc: "value",
            valueType: Ln,
            value: In
          };
        } else
          z.errors.push("Unsupported method ".concat(ge));
      } else {
        if (x.type == "op-plus" && (F == null ? void 0 : F.type) == "ternary")
          return D(x, k, I, z);
        z.errors.push("Can't convert arg of type ".concat(x.type));
      }
    }
  }, N = function(x, k, I, z, F) {
    if (!F.filter(function(le) {
      return le === void 0;
    }).length) {
      var P = (0, s.getFieldConfig)(x, I);
      if (!P) {
        k.errors.push("No config for field ".concat(I));
        return;
      }
      var O = (0, c.getWidgetForFieldOp)(x, I, z), V = x.widgets[O || P.mainWidget], U = F.map(function(le) {
        return le.asyncListValues;
      }).filter(function(le) {
        return le != null;
      }), H = U.length ? U[0] : void 0, J = {
        type: "rule",
        id: (0, a.default)(),
        properties: {
          field: I,
          operator: z,
          value: F.map(function(le) {
            return le.value;
          }),
          valueSrc: F.map(function(le) {
            return le.valueSrc;
          }),
          valueType: F.map(function(le) {
            return le.valueSrc == "value" && ((V == null ? void 0 : V.type) || (P == null ? void 0 : P.type)) || le.valueType;
          }),
          asyncListValues: H
        }
      };
      return J;
    }
  }, M = function(x, k, I, z, F) {
    var P = x.groupFilter, O = x.groupFieldValue;
    if (O.valueSrc != "field")
      throw "Bad groupFieldValue: ".concat(JSON.stringify(O));
    var V = O.value, U = N(z, F, V, k, I);
    if (U) {
      var H = (0, s.getFieldConfig)(z, V), J = H == null ? void 0 : H.mode, le = g(g({}, P || {}), {}, {
        type: "rule_group",
        properties: g(g(g({}, U.properties), (P == null ? void 0 : P.properties) || {}), {}, {
          mode: J
        })
      });
      return le.id || (le.id = (0, a.default)()), le;
    }
  }, q = function(x, k, I, z, F, P) {
    var O = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    if (x.type == k.type)
      if (x.type == "!aggr") {
        var V = [x.source, k.source].map(function(ie) {
          return w(ie, z, F, P, g(g({}, I), {}, {
            _groupField: O == null ? void 0 : O._groupField
          }));
        }), U = (0, t.default)(V, 2), H = U[0], J = U[1];
        return H.value == J.value;
      } else {
        var le = [x, k].map(function(ie) {
          return w(ie, z, F, P, g(g({}, I), {}, {
            _groupField: O == null ? void 0 : O._groupField
          }));
        }), ae = (0, t.default)(le, 2), Y = ae[0], re = ae[1];
        return Y.value == re.value;
      }
    return !1;
  }, L = function E(x, k, I, z) {
    var F = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (x) {
      var P;
      if (x.type.indexOf("op-") == 0) {
        var O = x.type.slice(3), V = (O == "minus" || O == "plus") && x.children.length == 1;
        if (V)
          return x.isUnary = !0, E(x.children[0], k, I, z, x);
        var U = O == "and" && x.children.length == 2 && x.children[0].type == "op-ge" && x.children[1].type == "op-le", H = O == "or" && x.children.length == 2 && x.children[0].type == "op-lt" && x.children[1].type == "op-gt", J = U || H;
        if (J) {
          var le = (0, t.default)(x.children[0].children, 2), ae = le[0], Y = le[1], re = (0, t.default)(x.children[1].children, 2), ie = re[0], _e = re[1], he = Y.type == "number" && _e.type == "number", be = q(ae, ie, x, k, I, z, F);
          if (he && be) {
            Y.val, _e.val;
            var Q = {
              type: "op-between",
              children: [ae, Y, _e]
            };
            return E(Q, k, I, z, F);
          }
        }
        var me = k.operators[O], ne;
        O == "eq" && x.children[1].type == "null" ? ne = "is_null" : O == "ne" && x.children[1].type == "null" ? ne = "is_not_null" : O == "le" && x.children[1].type == "string" && x.children[1].val == "" ? ne = "is_empty" : O == "gt" && x.children[1].type == "string" && x.children[1].val == "" ? ne = "is_not_empty" : O == "between" && (ne = "between", me = ["between"]);
        var pe = function() {
          return x.children.map(function(vt) {
            return E(vt, k, I, z, g(g({}, x), {}, {
              _groupField: F == null ? void 0 : F._groupField
            }));
          });
        };
        if (O == "and" || O == "or") {
          var ge = {}, ve = pe();
          ve.forEach(function(Je) {
            if (Je) {
              var vt = (0, a.default)();
              Je.id = vt, Je.type != null ? ge[vt] = Je : z.errors.push("Bad item in AND/OR: ".concat(JSON.stringify(Je)));
            }
          }), P = {
            type: "group",
            id: (0, a.default)(),
            children1: ge,
            properties: {
              conjunction: k.conjunctions[O],
              not: x.not
            }
          };
        } else if (me) {
          var Te = pe(), Re = Te[0], Me = Te.slice(1);
          if (ne = me[0], Re)
            if (Re.groupFieldValue) {
              Re.groupFieldValue.valueSrc != "field" && z.errors.push("Expected group field ".concat(JSON.stringify(Re)));
              var et = Re.groupFieldValue.value, st = Me[0];
              st && st.groupFieldValue && st.groupFieldValue.valueSrc == "field" && st.groupFieldValue.value == et ? (ne = "all", Me = []) : ne == "equal" && st.valueSrc == "value" && st.valueType == "number" && st.value == 0 ? (ne = "none", Me = []) : ne == "greater" && st.valueSrc == "value" && st.valueType == "number" && st.value == 0 && (ne = "some", Me = []), P = M(Re, ne, Me, I, z);
            } else {
              Re.valueSrc != "field" && z.errors.push("Expected field ".concat(JSON.stringify(Re)));
              var De = Re.value;
              if (me.length > 1) {
                d.logger.warn("[spel] Spel operator ".concat(O, " can be mapped to ").concat(me));
                var ze = me.map(function(Je) {
                  return {
                    op: Je,
                    widget: (0, c.getWidgetForFieldOp)(I, De, Je)
                  };
                });
                if (O == "eq") {
                  var Pe = ze.find(function(Je) {
                    Je.op;
                    var vt = Je.widget;
                    return vt != "field";
                  });
                  ne = Pe.op;
                }
              }
              P = N(I, z, De, ne, Me);
            }
        } else
          F || (P = R(x, k, I, z)), P || z.errors.push("Can't convert op ".concat(O));
      } else if (x.type == "!aggr") {
        var je, He = E(x.source, k, I, z, g(g({}, x), {}, {
          _groupField: F == null ? void 0 : F._groupField
        })), Xe = E(x.filter, k, I, z, g(g({}, x), {}, {
          _groupField: He == null ? void 0 : He.value
        }));
        ((je = Xe) === null || je === void 0 ? void 0 : je.type) == "rule" && (Xe = S(Xe, I)), P = {
          groupFilter: Xe,
          groupFieldValue: He
        }, F || (P = void 0, z.errors.push("Unexpected !aggr in root"));
      } else if (x.type == "ternary") {
        var at = {};
        x.val.forEach(function(Je) {
          var vt = (0, t.default)(Je, 2), Ot = vt[0], Ft = vt[1], wn = T(Ot, Ft, k, I, z, x);
          wn && (at[wn.id] = wn);
        }), P = {
          type: "switch_group",
          id: (0, a.default)(),
          children1: at,
          properties: {}
        };
      } else if (P = w(x, k, I, z, F), P && !P.type && !F) {
        var wt = R(x, k, I, z);
        wt ? P = wt : (P = void 0, z.errors.push("Can't convert rule of type ".concat(x.type, ", it looks like var/literal")));
      }
      return P;
    }
  }, R = function(x, k, I, z) {
    var F = {}, P = null, O = T(P, x, k, I, z);
    O && (F[O.id] = O);
    var V = {
      type: "switch_group",
      id: (0, a.default)(),
      children1: F,
      properties: {}
    };
    return V;
  }, T = function(x, k, I, z, F) {
    var P = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, O = A(z, F, I, k, P), V;
    return x ? (V = L(x, I, z, F, P), V && V.type ? (V.type != "group" && (V = S(V, z)), V.type = "case_group") : (F.errors.push("Unexpected case: ".concat(JSON.stringify(V))), V = void 0)) : V = {
      id: (0, a.default)(),
      type: "case_group",
      properties: {}
    }, V && (V.properties = g(g({}, V.properties), O)), V;
  }, D = function(x, k, I, z) {
    var F = [];
    function P(O) {
      O.map(function(V) {
        if (V.type == "op-plus")
          P(V.children);
        else {
          var U = w(V, k, I, z, x);
          U ? F.push(U) : z.errors.push("Can't convert ".concat(V.type, " in concatenation"));
        }
      });
    }
    return P(x.children), {
      valueSrc: "value",
      valueType: "case_value",
      value: F
    };
  }, A = function(x, k, I, z) {
    var F = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, P = {}, O;
    (z == null ? void 0 : z.type) == "op-plus" ? O = D(z, I, x, k) : O = w(z, I, x, k, F);
    var V = x.widgets.case_value, U = V == null ? void 0 : V.spelImportValue;
    if (U) {
      var H = U(O), J = (0, t.default)(H, 2), le = J[0], ae = J[1];
      ae.map(function(Y) {
        return k.errors.push(Y);
      }), le && (P = {
        value: [le],
        valueSrc: ["value"],
        valueType: ["case_value"]
      });
    } else
      k.errors.push("No fucntion to import case value");
    return P;
  }, S = function(x, k) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return {
      type: "group",
      id: (0, a.default)(),
      children1: (0, o.default)({}, x.id, x),
      properties: {
        conjunction: (0, u.defaultConjunction)(k),
        not: I
      }
    };
  };
  return wh;
}
var Ooe;
function jru() {
  return Ooe || (Ooe = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = GV();
    Object.keys(t).forEach(function(r) {
      r === "default" || r === "__esModule" || r in e && e[r] === t[r] || Object.defineProperty(e, r, {
        enumerable: !0,
        get: function() {
          return t[r];
        }
      });
    });
    var n = Mru();
    Object.keys(n).forEach(function(r) {
      r === "default" || r === "__esModule" || r in e && e[r] === n[r] || Object.defineProperty(e, r, {
        enumerable: !0,
        get: function() {
          return n[r];
        }
      });
    });
    var o = qru();
    Object.keys(o).forEach(function(r) {
      r === "default" || r === "__esModule" || r in e && e[r] === o[r] || Object.defineProperty(e, r, {
        enumerable: !0,
        get: function() {
          return o[r];
        }
      });
    });
  }(RL)), RL;
}
var LL = {}, ML = {}, Noe;
function Vru() {
  return Noe || (Noe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Ys), r = t(ki), i = t(Si), a = t(Ei), s = t(xi()), c = t(oi()), l = p(Fe), u = t(Oa), d = t(hye());
    function _($) {
      if (typeof WeakMap != "function")
        return null;
      var v = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
      return (_ = function(w) {
        return w ? b : v;
      })($);
    }
    function p($, v) {
      if (!v && $ && $.__esModule)
        return $;
      if ($ === null || n($) !== "object" && typeof $ != "function")
        return { default: $ };
      var b = _(v);
      if (b && b.has($))
        return b.get($);
      var y = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var N in $)
        if (N !== "default" && Object.prototype.hasOwnProperty.call($, N)) {
          var M = w ? Object.getOwnPropertyDescriptor($, N) : null;
          M && (M.get || M.set) ? Object.defineProperty(y, N, M) : y[N] = $[N];
        }
      return y.default = $, b && b.set($, y), y;
    }
    function g($) {
      var v = f();
      return function() {
        var y = (0, c.default)($), w;
        if (v) {
          var N = (0, c.default)(this).constructor;
          w = Reflect.construct(y, arguments, N);
        } else
          w = y.apply(this, arguments);
        return (0, s.default)(this, w);
      };
    }
    function f() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var h = /* @__PURE__ */ function($) {
      (0, a.default)(b, $);
      var v = g(b);
      function b() {
        var y;
        (0, r.default)(this, b);
        for (var w = arguments.length, N = new Array(w), M = 0; M < w; M++)
          N[M] = arguments[M];
        return y = v.call.apply(v, [this].concat(N)), y.handleChange = function(q) {
          y.props.setOption("proximity", parseInt(q));
        }, y;
      }
      return (0, i.default)(b, [{
        key: "render",
        value: function() {
          var w = this.props, N = w.defaults, M = w.options, q = w.config, L = w.optionLabel, R = w.optionPlaceholder, T = w.customProps, D = w.minProximity, A = w.maxProximity, S = w.optionTextBefore, E = w.readonly, x = q.settings, k = q.widgets, I = N ? N.proximity : void 0, z = x.showLabels, F = M.get("proximity", I), P = (0, d.default)(D, A + 1).map(function(V) {
            return {
              title: V,
              value: V
            };
          }), O = k.select.factory;
          return /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--PROXIMITY"
          }, /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--options"
          }, z && /* @__PURE__ */ l.default.createElement("label", {
            className: "rule--label"
          }, L), !z && S && /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--options--sep"
          }, /* @__PURE__ */ l.default.createElement("span", null, S)), /* @__PURE__ */ l.default.createElement(O, (0, o.default)({
            config: q,
            value: F,
            listValues: P,
            setValue: this.handleChange,
            readonly: E,
            placeholder: R
          }, T))), /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--widgets"
          }, this.props.children));
        }
      }]), b;
    }(l.PureComponent);
    e.default = h, h.propTypes = {
      config: u.default.object.isRequired,
      setOption: u.default.func.isRequired,
      options: u.default.any.isRequired,
      //instanceOf(Immutable.Map)
      minProximity: u.default.number,
      maxProximity: u.default.number,
      optionPlaceholder: u.default.string,
      optionTextBefore: u.default.string,
      optionLabel: u.default.string,
      customProps: u.default.object,
      readonly: u.default.bool
      //children
    }, h.defaultProps = {
      customProps: {},
      minProximity: 2,
      maxProximity: 10,
      optionPlaceholder: "Select words between",
      optionLabel: "Words between",
      optionTextBefore: null
    };
  }(ML)), ML;
}
var zoe;
function E$e() {
  return zoe || (zoe = 1, function(e) {
    var t = Tn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ProximityOperator", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    });
    var n = t(Vru());
  }(LL)), LL;
}
var FL = {}, w_ = {}, Roe;
function Bru() {
  if (Roe)
    return w_;
  Roe = 1;
  var e = Tn;
  Object.defineProperty(w_, "__esModule", {
    value: !0
  }), w_.simulateAsyncFetch = w_.mergeListValues = w_.listValueToOption = w_.getListValue = void 0;
  var t = e(dA()), n = e(Zu), o = e(_A()), r = Ti(), i = function(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3;
    return /* @__PURE__ */ function() {
      var p = (0, o.default)(/* @__PURE__ */ t.default.mark(function g(f, h, $) {
        var v, b, y, w, N, M;
        return t.default.wrap(function(L) {
          for (; ; )
            switch (L.prev = L.next) {
              case 0:
                return v = $.pageSize != null ? $.pageSize : d, b = (0, r.listValuesToArray)(u).filter(function(R) {
                  var T = R.title;
                  return f == null ? !0 : T.toUpperCase().indexOf(f.toUpperCase()) != -1;
                }), v && Math.ceil(b.length / v), y = h || 0, w = v ? b.slice(y, y + v) : b, N = v ? y + w.length : null, M = v ? N < b.length : !1, console.debug("simulateAsyncFetch", {
                  search: f,
                  offset: h,
                  values: w,
                  hasMore: M,
                  filtered: b
                }), L.next = 11, (0, r.sleep)(_);
              case 11:
                return L.abrupt("return", {
                  values: w,
                  hasMore: M
                });
              case 12:
              case "end":
                return L.stop();
            }
        }, g);
      }));
      return function(g, f, h) {
        return p.apply(this, arguments);
      };
    }();
  };
  w_.simulateAsyncFetch = i;
  var a = function(u, d) {
    var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (!d)
      return u;
    var p = u || [], g = d.filter(function(h) {
      return p.find(function($) {
        return $.value == h.value;
      }) == null;
    }), f = _ ? [].concat((0, n.default)(g), (0, n.default)(p)) : [].concat((0, n.default)(p), (0, n.default)(g));
    return f;
  };
  w_.mergeListValues = a;
  var s = function(u) {
    if (u == null)
      return null;
    var d = u.title, _ = u.value, p = u.disabled, g = u.groupTitle, f = u.renderTitle, h = {
      title: d,
      value: _
    };
    return p && (h.disabled = p), g && (h.groupTitle = g), f && (h.renderTitle = f), h;
  };
  w_.listValueToOption = s;
  var c = function(u, d) {
    return (0, r.mapListValues)(d, function(_) {
      return _.value === u ? _ : null;
    }).filter(function(_) {
      return _ !== null;
    }).shift();
  };
  return w_.getListValue = c, w_;
}
var Poe;
function Uru() {
  return Poe || (Poe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.TreeUtils = e.ExportUtils = e.DefaultUtils = e.ConfigUtils = void 0, Object.defineProperty(e, "getSwitchValues", {
      enumerable: !0,
      get: function() {
        return c.getSwitchValues;
      }
    }), Object.defineProperty(e, "simulateAsyncFetch", {
      enumerable: !0,
      get: function() {
        return r.simulateAsyncFetch;
      }
    }), Object.defineProperty(e, "uuid", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "validateTree", {
      enumerable: !0,
      get: function() {
        return o.validateTree;
      }
    });
    var o = f1(), r = Bru(), i = t(Ug()), a = d(Qi());
    e.ConfigUtils = a;
    var s = d(kl());
    e.DefaultUtils = s;
    var c = d(Pv());
    e.TreeUtils = c;
    var l = d(I2());
    e.ExportUtils = l;
    function u(_) {
      if (typeof WeakMap != "function")
        return null;
      var p = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
      return (u = function(h) {
        return h ? g : p;
      })(_);
    }
    function d(_, p) {
      if (!p && _ && _.__esModule)
        return _;
      if (_ === null || n(_) !== "object" && typeof _ != "function")
        return { default: _ };
      var g = u(p);
      if (g && g.has(_))
        return g.get(_);
      var f = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var $ in _)
        if ($ !== "default" && Object.prototype.hasOwnProperty.call(_, $)) {
          var v = h ? Object.getOwnPropertyDescriptor(_, $) : null;
          v && (v.get || v.set) ? Object.defineProperty(f, $, v) : f[$] = _[$];
        }
      return f.default = _, g && g.set(_, f), f;
    }
  }(FL)), FL;
}
var wu = {}, Doe;
function Gru() {
  if (Doe)
    return wu;
  Doe = 1;
  var e = Tn;
  Object.defineProperty(wu, "__esModule", {
    value: !0
  }), wu.UPPER = wu.RELATIVE_DATETIME = wu.NOW = wu.LOWER = wu.LINEAR_REGRESSION = void 0;
  var t = e(Fv), n = {
    label: "Now",
    returnType: "datetime",
    jsonLogic: "now",
    //todo: document option `jsonLogicCustomOps`
    //todo: add util to return all used custom ops to be added by user with `jsonLogic.add_operation`
    jsonLogicCustomOps: {
      now: function() {
        return /* @__PURE__ */ new Date();
      }
    },
    spelFunc: "new java.util.Date()",
    sqlFormatFunc: function() {
      return "NOW()";
    },
    mongoFormatFunc: function() {
      return /* @__PURE__ */ new Date();
    },
    formatFunc: function() {
      return "NOW";
    }
  };
  wu.NOW = n;
  var o = {
    label: "Relative",
    returnType: "datetime",
    renderBrackets: ["", ""],
    renderSeps: ["", "", ""],
    jsonLogic: function(c) {
      var l = c.date, u = c.op, d = c.val, _ = c.dim;
      return {
        date_add: [l, d * (u == "minus" ? -1 : 1), _]
      };
    },
    jsonLogicImport: function(c) {
      var l = c.date_add[0], u = Math.abs(c.date_add[1]), d = c.date_add[1] >= 0 ? "plus" : "minus", _ = c.date_add[2];
      return [l, d, u, _];
    },
    jsonLogicCustomOps: {
      date_add: function(c, l, u) {
        return (0, t.default)(c).add(l, u).toDate();
      }
    },
    // MySQL
    //todo: other SQL dialects?
    sqlFormatFunc: function(c) {
      var l = c.date, u = c.op, d = c.val, _ = c.dim;
      return "DATE_ADD(".concat(l, ", INTERVAL ").concat(parseInt(d) * (u == "minus" ? -1 : 1), " ").concat(_.replace(/^'|'$/g, ""), ")");
    },
    mongoFormatFunc: null,
    //todo: support?
    //todo: spel
    formatFunc: function(c) {
      var l = c.date, u = c.op, d = c.val, _ = c.dim;
      return d ? "".concat(l, " ").concat(u == "minus" ? "-" : "+", " ").concat(d, " ").concat(_) : l;
    },
    args: {
      date: {
        label: "Date",
        type: "datetime",
        defaultValue: {
          func: "NOW",
          args: []
        },
        valueSources: ["func", "field"]
      },
      op: {
        label: "Op",
        type: "select",
        defaultValue: "plus",
        valueSources: ["value"],
        mainWidgetProps: {
          customProps: {
            showSearch: !1
          }
        },
        fieldSettings: {
          listValues: {
            plus: "+",
            minus: "-"
          }
        }
      },
      val: {
        label: "Value",
        type: "number",
        fieldSettings: {
          min: 0
        },
        defaultValue: 0,
        valueSources: ["value"]
      },
      dim: {
        label: "Dimension",
        type: "select",
        defaultValue: "day",
        valueSources: ["value"],
        mainWidgetProps: {
          customProps: {
            showSearch: !1
          }
        },
        fieldSettings: {
          listValues: {
            day: "day",
            week: "week",
            month: "month",
            year: "year"
          }
        }
      }
    }
  };
  wu.RELATIVE_DATETIME = o;
  var r = {
    label: "Lowercase",
    mongoFunc: "$toLower",
    jsonLogic: "toLowerCase",
    spelFunc: ".toLowerCase",
    //jsonLogicIsMethod: true, // Removed in JsonLogic 2.x due to Prototype Pollution
    jsonLogicCustomOps: {
      toLowerCase: function(c) {
        return c.toLowerCase();
      }
    },
    returnType: "text",
    args: {
      str: {
        label: "String",
        type: "text",
        valueSources: ["value", "field"]
      }
    }
  };
  wu.LOWER = r;
  var i = {
    label: "Uppercase",
    mongoFunc: "$toUpper",
    jsonLogic: "toUpperCase",
    spelFunc: ".toUpperCase",
    //jsonLogicIsMethod: true, // Removed in JsonLogic 2.x due to Prototype Pollution
    jsonLogicCustomOps: {
      toUpperCase: function(c) {
        return c.toUpperCase();
      }
    },
    returnType: "text",
    args: {
      str: {
        label: "String",
        type: "text",
        valueSources: ["value", "field"]
      }
    }
  };
  wu.UPPER = i;
  var a = {
    label: "Linear regression",
    returnType: "number",
    formatFunc: function(c, l) {
      var u = c.coef, d = c.bias, _ = c.val;
      return "(".concat(u, " * ").concat(_, " + ").concat(d, ")");
    },
    sqlFormatFunc: function(c) {
      var l = c.coef, u = c.bias, d = c.val;
      return "(".concat(l, " * ").concat(d, " + ").concat(u, ")");
    },
    spelFormatFunc: function(c) {
      var l = c.coef, u = c.bias, d = c.val;
      return "(".concat(l, " * ").concat(d, " + ").concat(u, ")");
    },
    mongoFormatFunc: function(c) {
      var l = c.coef, u = c.bias, d = c.val;
      return {
        $sum: [{
          $multiply: [l, d]
        }, u]
      };
    },
    jsonLogic: function(c) {
      var l = c.coef, u = c.bias, d = c.val;
      return {
        "+": [{
          "*": [l, d]
        }, u]
      };
    },
    jsonLogicImport: function(c) {
      var l = c["+"][0]["*"][0], u = c["+"][0]["*"][1], d = c["+"][1];
      return [l, u, d];
    },
    renderBrackets: ["", ""],
    renderSeps: [" * ", " + "],
    args: {
      coef: {
        label: "Coef",
        type: "number",
        defaultValue: 1,
        valueSources: ["value"]
      },
      val: {
        label: "Value",
        type: "number",
        valueSources: ["value", "field"]
      },
      bias: {
        label: "Bias",
        type: "number",
        defaultValue: 0,
        valueSources: ["value"]
      }
    }
  };
  return wu.LINEAR_REGRESSION = a, wu;
}
var qL = {}, Loe;
function Wru() {
  return Loe || (Loe = 1, function(e) {
    var t = Tn, n = xo;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.stringifyForDisplay = e.mongoFormatOp2 = e.mongoFormatOp1 = e.default = void 0;
    var o = t(Yr()), r = t(Fe), i = _(DV()), a = _(E$e()), s = I2(), c = Ti(), l = t(Fv), u = v$();
    function d(P) {
      if (typeof WeakMap != "function")
        return null;
      var O = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap();
      return (d = function(H) {
        return H ? V : O;
      })(P);
    }
    function _(P, O) {
      if (!O && P && P.__esModule)
        return P;
      if (P === null || n(P) !== "object" && typeof P != "function")
        return { default: P };
      var V = d(O);
      if (V && V.has(P))
        return V.get(P);
      var U = {}, H = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var J in P)
        if (J !== "default" && Object.prototype.hasOwnProperty.call(P, J)) {
          var le = H ? Object.getOwnPropertyDescriptor(P, J) : null;
          le && (le.get || le.set) ? Object.defineProperty(U, J, le) : U[J] = P[J];
        }
      return U.default = P, V && V.set(P, U), U;
    }
    function p(P, O) {
      var V = Object.keys(P);
      if (Object.getOwnPropertySymbols) {
        var U = Object.getOwnPropertySymbols(P);
        O && (U = U.filter(function(H) {
          return Object.getOwnPropertyDescriptor(P, H).enumerable;
        })), V.push.apply(V, U);
      }
      return V;
    }
    function g(P) {
      for (var O = 1; O < arguments.length; O++) {
        var V = arguments[O] != null ? arguments[O] : {};
        O % 2 ? p(Object(V), !0).forEach(function(U) {
          (0, o.default)(P, U, V[U]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(P, Object.getOwnPropertyDescriptors(V)) : p(Object(V)).forEach(function(U) {
          Object.defineProperty(P, U, Object.getOwnPropertyDescriptor(V, U));
        });
      }
      return P;
    }
    var f = i.VanillaBooleanWidget, h = i.VanillaTextWidget, $ = i.VanillaTextAreaWidget, v = i.VanillaDateWidget, b = i.VanillaTimeWidget, y = i.VanillaDateTimeWidget, w = i.VanillaMultiSelectWidget, N = i.VanillaSelectWidget, M = i.VanillaNumberWidget, q = i.VanillaSliderWidget, L = i.ValueFieldWidget, R = i.FuncWidget, T = a.ProximityOperator, D = {
      AND: {
        label: "And",
        mongoConj: "$and",
        jsonLogicConj: "and",
        sqlConj: "AND",
        spelConj: "and",
        spelConjs: ["and", "&&"],
        reversedConj: "OR",
        formatConj: function(O, V, U, H) {
          return O.size > 1 ? (U ? "NOT " : "") + "(" + O.join(" " + (H ? "AND" : "&&") + " ") + ")" : (U ? "NOT (" : "") + O.first() + (U ? ")" : "");
        },
        sqlFormatConj: function(O, V, U) {
          return O.size > 1 ? (U ? "NOT " : "") + "(" + O.join(" AND ") + ")" : (U ? "NOT (" : "") + O.first() + (U ? ")" : "");
        },
        spelFormatConj: function(O, V, U, H) {
          return U && (H = !1), O.size > 1 ? (U ? "!" : "") + (H ? "" : "(") + O.join(" && ") + (H ? "" : ")") : (U ? "!(" : "") + O.first() + (U ? ")" : "");
        }
      },
      OR: {
        label: "Or",
        mongoConj: "$or",
        jsonLogicConj: "or",
        sqlConj: "OR",
        spelConj: "or",
        spelConjs: ["or", "||"],
        reversedConj: "AND",
        formatConj: function(O, V, U, H) {
          return O.size > 1 ? (U ? "NOT " : "") + "(" + O.join(" " + (H ? "OR" : "||") + " ") + ")" : (U ? "NOT (" : "") + O.first() + (U ? ")" : "");
        },
        sqlFormatConj: function(O, V, U) {
          return O.size > 1 ? (U ? "NOT " : "") + "(" + O.join(" OR ") + ")" : (U ? "NOT (" : "") + O.first() + (U ? ")" : "");
        },
        spelFormatConj: function(O, V, U, H) {
          return U && (H = !1), O.size > 1 ? (U ? "!" : "") + (H ? "" : "(") + O.join(" || ") + (H ? "" : ")") : (U ? "!(" : "") + O.first() + (U ? ")" : "");
        }
      }
    }, A = function(O, V, U, H, J, le, ae, Y, re, ie, _e, he) {
      var be = typeof H == "string" && !H.startsWith("$") ? "$" + H : H, Q = V(le, he);
      if (Q !== void 0)
        return U ? !ae && (!O || O == "$eq") ? (0, o.default)({}, H, {
          $ne: Q
        }) : ae ? {
          $not: (0, o.default)({}, O, [be, Q])
        } : (0, o.default)({}, H, {
          $not: (0, o.default)({}, O, Q)
        }) : !ae && (!O || O == "$eq") ? (0, o.default)({}, H, Q) : ae ? (0, o.default)({}, O, [be, Q]) : (0, o.default)({}, H, (0, o.default)({}, O, Q));
    };
    e.mongoFormatOp1 = A;
    var S = function(O, V, U, H, J, le, ae, Y, re, ie, _e) {
      var he = typeof U == "string" && !U.startsWith("$") ? "$" + U : U;
      if (V) {
        var be;
        return le ? {
          $not: {
            $and: [(0, o.default)({}, O[0], [he, J[0]]), (0, o.default)({}, O[1], [he, J[1]])]
          }
        } : (0, o.default)({}, U, {
          $not: (be = {}, (0, o.default)(be, O[0], J[0]), (0, o.default)(be, O[1], J[1]), be)
        });
      } else {
        var Q;
        return le ? {
          $and: [(0, o.default)({}, O[0], [he, J[0]]), (0, o.default)({}, O[1], [he, J[1]])]
        } : (0, o.default)({}, U, (Q = {}, (0, o.default)(Q, O[0], J[0]), (0, o.default)(Q, O[1], J[1]), Q));
      }
    };
    e.mongoFormatOp2 = S;
    var E = {
      equal: {
        label: "==",
        labelForFormat: "==",
        sqlOp: "=",
        spelOp: "==",
        spelOps: ["==", "eq"],
        reversedOp: "not_equal",
        formatOp: function(O, V, U, H, J, le, ae, Y, re) {
          var ie = Y ? "=" : le.label;
          return J == "boolean" && Y ? U == "No" ? "NOT ".concat(O) : "".concat(O) : "".concat(O, " ").concat(ie, " ").concat(U);
        },
        mongoFormatOp: A.bind(null, "$eq", function(P) {
          return P;
        }, !1),
        jsonLogic: "==",
        elasticSearchQueryType: "term"
      },
      not_equal: {
        isNotOp: !0,
        label: "!=",
        labelForFormat: "!=",
        sqlOp: "<>",
        spelOp: "!=",
        spelOps: ["!=", "ne"],
        reversedOp: "equal",
        formatOp: function(O, V, U, H, J, le, ae, Y, re) {
          return J == "boolean" && Y ? U == "No" ? "".concat(O) : "NOT ".concat(O) : "".concat(O, " ").concat(le.label, " ").concat(U);
        },
        mongoFormatOp: A.bind(null, "$ne", function(P) {
          return P;
        }, !1),
        jsonLogic: "!="
      },
      less: {
        label: "<",
        labelForFormat: "<",
        sqlOp: "<",
        spelOp: "<",
        spelOps: ["<", "lt"],
        reversedOp: "greater_or_equal",
        mongoFormatOp: A.bind(null, "$lt", function(P) {
          return P;
        }, !1),
        jsonLogic: "<",
        elasticSearchQueryType: "range"
      },
      less_or_equal: {
        label: "<=",
        labelForFormat: "<=",
        sqlOp: "<=",
        spelOp: "<=",
        spelOps: ["<=", "le"],
        reversedOp: "greater",
        mongoFormatOp: A.bind(null, "$lte", function(P) {
          return P;
        }, !1),
        jsonLogic: "<=",
        elasticSearchQueryType: "range"
      },
      greater: {
        label: ">",
        labelForFormat: ">",
        sqlOp: ">",
        spelOp: ">",
        spelOps: [">", "gt"],
        reversedOp: "less_or_equal",
        mongoFormatOp: A.bind(null, "$gt", function(P) {
          return P;
        }, !1),
        jsonLogic: ">",
        elasticSearchQueryType: "range"
      },
      greater_or_equal: {
        label: ">=",
        labelForFormat: ">=",
        sqlOp: ">=",
        spelOp: ">=",
        spelOps: [">=", "ge"],
        reversedOp: "less",
        mongoFormatOp: A.bind(null, "$gte", function(P) {
          return P;
        }, !1),
        jsonLogic: ">=",
        elasticSearchQueryType: "range"
      },
      like: {
        label: "Contains",
        labelForFormat: "Contains",
        reversedOp: "not_like",
        sqlOp: "LIKE",
        spelOp: ".contains",
        spelOps: ["matches", ".contains"],
        mongoFormatOp: A.bind(null, "$regex", function(P) {
          return typeof P == "string" ? (0, c.escapeRegExp)(P) : void 0;
        }, !1),
        //jsonLogic: (field, op, val) => ({ "in": [val, field] }),
        jsonLogic: "in",
        _jsonLogicIsRevArgs: !0,
        valueSources: ["value"],
        elasticSearchQueryType: "regexp"
      },
      not_like: {
        isNotOp: !0,
        label: "Not contains",
        reversedOp: "like",
        labelForFormat: "Not Contains",
        sqlOp: "NOT LIKE",
        mongoFormatOp: A.bind(null, "$regex", function(P) {
          return typeof P == "string" ? (0, c.escapeRegExp)(P) : void 0;
        }, !0),
        valueSources: ["value"]
      },
      starts_with: {
        label: "Starts with",
        labelForFormat: "Starts with",
        sqlOp: "LIKE",
        spelOp: ".startsWith",
        spelOps: ["matches", ".startsWith"],
        mongoFormatOp: A.bind(null, "$regex", function(P) {
          return typeof P == "string" ? "^" + (0, c.escapeRegExp)(P) : void 0;
        }, !1),
        jsonLogic: void 0,
        // not supported
        valueSources: ["value"]
      },
      ends_with: {
        label: "Ends with",
        labelForFormat: "Ends with",
        sqlOp: "LIKE",
        spelOp: ".endsWith",
        spelOps: ["matches", ".endsWith"],
        mongoFormatOp: A.bind(null, "$regex", function(P) {
          return typeof P == "string" ? (0, c.escapeRegExp)(P) + "$" : void 0;
        }, !1),
        jsonLogic: void 0,
        // not supported
        valueSources: ["value"]
      },
      between: {
        label: "Between",
        labelForFormat: "BETWEEN",
        sqlOp: "BETWEEN",
        cardinality: 2,
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = U.first(), ie = U.get(1);
          return Y ? "".concat(O, " BETWEEN ").concat(re, " AND ").concat(ie) : "".concat(O, " >= ").concat(re, " && ").concat(O, " <= ").concat(ie);
        },
        spelFormatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = U[0], ie = U[1];
          return "".concat(O, " >= ").concat(re, " && ").concat(O, " <= ").concat(ie);
        },
        mongoFormatOp: S.bind(null, ["$gte", "$lte"], !1),
        valueLabels: ["Value from", "Value to"],
        textSeparators: [null, "and"],
        reversedOp: "not_between",
        jsonLogic: "<=",
        validateValues: function(O) {
          return O[0] != null && O[1] != null ? O[0] <= O[1] ? null : "Invalid range" : null;
        },
        elasticSearchQueryType: function(O) {
          return O === "time" ? "filter" : "range";
        }
      },
      not_between: {
        isNotOp: !0,
        label: "Not between",
        labelForFormat: "NOT BETWEEN",
        sqlOp: "NOT BETWEEN",
        cardinality: 2,
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = U.first(), ie = U.get(1);
          return Y ? "".concat(O, " NOT BETWEEN ").concat(re, " AND ").concat(ie) : "(".concat(O, " < ").concat(re, " || ").concat(O, " > ").concat(ie, ")");
        },
        spelFormatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = U[0], ie = U[1];
          return "(".concat(O, " < ").concat(re, " || ").concat(O, " > ").concat(ie, ")");
        },
        mongoFormatOp: S.bind(null, ["$gte", "$lte"], !0),
        valueLabels: ["Value from", "Value to"],
        textSeparators: [null, "and"],
        reversedOp: "between",
        validateValues: function(O) {
          return O[0] != null && O[1] != null ? O[0] <= O[1] ? null : "Invalid range" : null;
        }
      },
      is_empty: {
        label: "Is empty",
        labelForFormat: "IS EMPTY",
        cardinality: 0,
        reversedOp: "is_not_empty",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return Y ? "".concat(O, " IS EMPTY") : "!".concat(O);
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = (0, s.sqlEmptyValue)(Y);
          return "COALESCE(".concat(O, ", ").concat(re, ") = ").concat(re);
        },
        spelFormatOp: function(O, V, U, H, J, le, ae, Y) {
          return "".concat(O, " <= ''");
        },
        mongoFormatOp: A.bind(null, "$in", function(P, O) {
          return [(0, s.mongoEmptyValue)(O), null];
        }, !1),
        jsonLogic: "!"
      },
      is_not_empty: {
        isNotOp: !0,
        label: "Is not empty",
        labelForFormat: "IS NOT EMPTY",
        cardinality: 0,
        reversedOp: "is_empty",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return Y ? "".concat(O, " IS NOT EMPTY") : "!!".concat(O);
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = (0, s.sqlEmptyValue)(Y);
          return "COALESCE(".concat(O, ", ").concat(re, ") <> ").concat(re);
        },
        spelFormatOp: function(O, V, U, H, J, le, ae, Y) {
          return "".concat(O, " > ''");
        },
        mongoFormatOp: A.bind(null, "$nin", function(P, O) {
          return [(0, s.mongoEmptyValue)(O), null];
        }, !1),
        jsonLogic: "!!",
        elasticSearchQueryType: "exists"
      },
      is_null: {
        label: "Is null",
        labelForFormat: "IS NULL",
        sqlOp: "IS NULL",
        cardinality: 0,
        reversedOp: "is_not_null",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return Y ? "".concat(O, " IS NULL") : "!".concat(O);
        },
        spelFormatOp: function(O, V, U, H, J, le, ae, Y) {
          return "".concat(O, " == null");
        },
        // check if value is null OR not exists
        mongoFormatOp: A.bind(null, "$eq", function(P) {
          return null;
        }, !1),
        jsonLogic: "=="
      },
      is_not_null: {
        label: "Is not null",
        labelForFormat: "IS NOT NULL",
        sqlOp: "IS NOT NULL",
        cardinality: 0,
        reversedOp: "is_null",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return Y ? "".concat(O, " IS NOT NULL") : "!!".concat(O);
        },
        spelFormatOp: function(O, V, U, H, J, le, ae, Y) {
          return "".concat(O, " != null");
        },
        // check if value exists and is not null
        mongoFormatOp: A.bind(null, "$ne", function(P) {
          return null;
        }, !1),
        jsonLogic: "!=",
        elasticSearchQueryType: "exists"
      },
      select_equals: {
        label: "==",
        labelForFormat: "==",
        sqlOp: "=",
        // enum/set
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = Y ? "=" : "==";
          return "".concat(O, " ").concat(re, " ").concat(U);
        },
        spelOp: "==",
        spelOps: ["==", "eq"],
        mongoFormatOp: A.bind(null, "$eq", function(P) {
          return P;
        }, !1),
        reversedOp: "select_not_equals",
        jsonLogic: "==",
        elasticSearchQueryType: "term"
      },
      select_not_equals: {
        isNotOp: !0,
        label: "!=",
        labelForFormat: "!=",
        sqlOp: "<>",
        // enum/set
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return "".concat(O, " != ").concat(U);
        },
        spelOp: "!=",
        spelOps: ["!=", "ne"],
        mongoFormatOp: A.bind(null, "$ne", function(P) {
          return P;
        }, !1),
        reversedOp: "select_equals",
        jsonLogic: "!="
      },
      select_any_in: {
        label: "Any in",
        labelForFormat: "IN",
        sqlOp: "IN",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return H == "value" ? "".concat(O, " IN (").concat(U.join(", "), ")") : "".concat(O, " IN (").concat(U, ")");
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          if (H == "value")
            return "".concat(O, " IN (").concat(U.join(", "), ")");
        },
        spelOp: "$contains",
        // tip: $ means first arg is object
        mongoFormatOp: A.bind(null, "$in", function(P) {
          return P;
        }, !1),
        reversedOp: "select_not_any_in",
        jsonLogic: "in",
        elasticSearchQueryType: "term"
      },
      select_not_any_in: {
        isNotOp: !0,
        label: "Not in",
        labelForFormat: "NOT IN",
        sqlOp: "NOT IN",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return H == "value" ? "".concat(O, " NOT IN (").concat(U.join(", "), ")") : "".concat(O, " NOT IN (").concat(U, ")");
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          if (H == "value")
            return "".concat(O, " NOT IN (").concat(U.join(", "), ")");
        },
        mongoFormatOp: A.bind(null, "$nin", function(P) {
          return P;
        }, !1),
        reversedOp: "select_any_in"
      },
      //todo: multiselect_contains - for SpEL it would be `.containsAll`
      multiselect_equals: {
        label: "Equals",
        labelForFormat: "==",
        sqlOp: "=",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = Y ? "=" : "==";
          return H == "value" ? "".concat(O, " ").concat(re, " [").concat(U.join(", "), "]") : "".concat(O, " ").concat(re, " ").concat(U);
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          if (H == "value")
            return "".concat(O, " = '").concat(U.map(function(re) {
              return s.SqlString.trim(re);
            }).join(","), "'");
        },
        spelOp: ".equals",
        mongoFormatOp: A.bind(null, "$eq", function(P) {
          return P;
        }, !1),
        reversedOp: "multiselect_not_equals",
        jsonLogic2: "all-in",
        jsonLogic: function(O, V, U) {
          return {
            // it's not "equals", but "includes" operator - just for example
            all: [O, {
              in: [{
                var: ""
              }, U]
            }]
          };
        },
        elasticSearchQueryType: "term"
      },
      multiselect_not_equals: {
        isNotOp: !0,
        label: "Not equals",
        labelForFormat: "!=",
        sqlOp: "<>",
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          return H == "value" ? "".concat(O, " != [").concat(U.join(", "), "]") : "".concat(O, " != ").concat(U);
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          if (H == "value")
            return "".concat(O, " != '").concat(U.map(function(re) {
              return s.SqlString.trim(re);
            }).join(","), "'");
        },
        mongoFormatOp: A.bind(null, "$ne", function(P) {
          return P;
        }, !1),
        reversedOp: "multiselect_equals"
      },
      proximity: {
        label: "Proximity search",
        cardinality: 2,
        valueLabels: [{
          label: "Word 1",
          placeholder: "Enter first word"
        }, {
          label: "Word 2",
          placeholder: "Enter second word"
        }],
        textSeparators: [
          //'Word 1',
          //'Word 2'
        ],
        formatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = U.first(), ie = U.get(1), _e = ae.get("proximity");
          return "".concat(O, " ").concat(re, " NEAR/").concat(_e, " ").concat(ie);
        },
        sqlFormatOp: function(O, V, U, H, J, le, ae, Y) {
          var re = U.first(), ie = U.get(1), _e = s.SqlString.trim(re), he = s.SqlString.trim(ie), be = ae.get("proximity");
          return "CONTAINS(".concat(O, ", 'NEAR((").concat(_e, ", ").concat(he, "), ").concat(be, ")')");
        },
        mongoFormatOp: void 0,
        // not supported
        jsonLogic: void 0,
        // not supported
        options: {
          optionLabel: "Near",
          // label on top of "near" selectbox (for config.settings.showLabels==true)
          optionTextBefore: "Near",
          // label before "near" selectbox (for config.settings.showLabels==false)
          optionPlaceholder: "Select words between",
          // placeholder for "near" selectbox
          factory: function(O) {
            return /* @__PURE__ */ r.default.createElement(T, O);
          },
          minProximity: 2,
          maxProximity: 10,
          defaults: {
            proximity: 2
          }
        }
      },
      some: {
        label: "Some",
        labelForFormat: "SOME",
        cardinality: 0,
        jsonLogic: "some",
        spelFormatOp: function(O) {
          return "".concat(O, " > 0");
        },
        mongoFormatOp: A.bind(null, "$gt", function(P) {
          return 0;
        }, !1)
      },
      all: {
        label: "All",
        labelForFormat: "ALL",
        cardinality: 0,
        jsonLogic: "all",
        spelFormatOp: function(O, V, U) {
          return "".concat(O, " == ").concat(U);
        },
        mongoFormatOp: A.bind(null, "$eq", function(P) {
          return P;
        }, !1)
      },
      none: {
        label: "None",
        labelForFormat: "NONE",
        cardinality: 0,
        jsonLogic: "none",
        spelFormatOp: function(O) {
          return "".concat(O, " == 0");
        },
        mongoFormatOp: A.bind(null, "$eq", function(P) {
          return 0;
        }, !1)
      }
    }, x = function(O) {
      return O == null ? "NULL" : O.toString();
    };
    e.stringifyForDisplay = x;
    var k = {
      text: {
        type: "text",
        jsType: "string",
        valueSrc: "value",
        valueLabel: "String",
        valuePlaceholder: "Enter string",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(h, O);
        },
        formatValue: function(O, V, U, H) {
          return H ? x(O) : JSON.stringify(O);
        },
        spelFormatValue: function(O, V, U, H, J) {
          if (J.spelOp == "matches" && H != "regex") {
            var le;
            return H == "starts_with" ? le = "(?s)^".concat((0, c.escapeRegExp)(O), ".*") : H == "ends_with" ? le = "(?s).*".concat((0, c.escapeRegExp)(O), "$") : le = "(?s).*".concat((0, c.escapeRegExp)(O), ".*"), (0, s.spelEscape)(le);
          } else
            return (0, s.spelEscape)(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return J.sqlOp == "LIKE" || J.sqlOp == "NOT LIKE" ? s.SqlString.escapeLike(O, H != "starts_with", H != "ends_with") : s.SqlString.escape(O);
        },
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        }
      },
      textarea: {
        type: "text",
        jsType: "string",
        valueSrc: "value",
        valueLabel: "Text",
        valuePlaceholder: "Enter text",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement($, O);
        },
        formatValue: function(O, V, U, H) {
          return H ? x(O) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return J.sqlOp == "LIKE" || J.sqlOp == "NOT LIKE" ? s.SqlString.escapeLike(O, H != "starts_with", H != "ends_with") : s.SqlString.escape(O);
        },
        spelFormatValue: function(O) {
          return (0, s.spelEscape)(O);
        },
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        },
        fullWidth: !0
      },
      number: {
        type: "number",
        jsType: "number",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(M, O);
        },
        valueLabel: "Number",
        valuePlaceholder: "Enter number",
        valueLabels: [{
          label: "Number from",
          placeholder: "Enter number from"
        }, {
          label: "Number to",
          placeholder: "Enter number to"
        }],
        formatValue: function(O, V, U, H) {
          return H ? x(O) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return s.SqlString.escape(O);
        },
        spelFormatValue: function(O, V, U) {
          var H = U.step && !Number.isInteger(U.step);
          return (0, s.spelEscape)(O, H);
        },
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        }
      },
      slider: {
        type: "number",
        jsType: "number",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(q, O);
        },
        valueLabel: "Number",
        valuePlaceholder: "Enter number or move slider",
        formatValue: function(O, V, U, H) {
          return H ? x(O) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return s.SqlString.escape(O);
        },
        spelFormatValue: function(O) {
          return (0, s.spelEscape)(O);
        },
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        }
      },
      select: {
        type: "select",
        jsType: "string",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(N, O);
        },
        valueLabel: "Value",
        valuePlaceholder: "Select value",
        formatValue: function(O, V, U, H) {
          var J = (0, c.getTitleInListValues)(V.fieldSettings.listValues || V.asyncListValues, O);
          return H ? x(J) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return s.SqlString.escape(O);
        },
        spelFormatValue: function(O) {
          return (0, s.spelEscape)(O);
        },
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        }
      },
      multiselect: {
        type: "multiselect",
        jsType: "array",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(w, O);
        },
        valueLabel: "Values",
        valuePlaceholder: "Select values",
        formatValue: function(O, V, U, H) {
          var J = O.map(function(le) {
            return (0, c.getTitleInListValues)(V.fieldSettings.listValues || V.asyncListValues, le);
          });
          return H ? J.map(x) : O.map(JSON.stringify);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return O.map(function(le) {
            return s.SqlString.escape(le);
          });
        },
        spelFormatValue: function(O, V, U, H, J) {
          var le = J.spelOp && J.spelOp[0] == "$", ae = (0, s.spelEscape)(O);
          return le && (ae = (0, s.spelFixList)(ae)), ae;
        },
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        }
      },
      date: {
        type: "date",
        jsType: "string",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(v, O);
        },
        dateFormat: "DD.MM.YYYY",
        valueFormat: "YYYY-MM-DD",
        useKeyboard: !0,
        valueLabel: "Date",
        valuePlaceholder: "Enter date",
        valueLabels: [{
          label: "Date from",
          placeholder: "Enter date from"
        }, {
          label: "Date to",
          placeholder: "Enter date to"
        }],
        formatValue: function(O, V, U, H) {
          var J = (0, l.default)(O, U.valueFormat);
          return H ? J.format(U.dateFormat) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          var le = (0, l.default)(O, U.valueFormat);
          return s.SqlString.escape(le.format("YYYY-MM-DD"));
        },
        spelFormatValue: function(O, V, U, H, J) {
          var le = (0, l.default)(O, U.valueFormat);
          return "new java.text.SimpleDateFormat('yyyy-MM-dd').parse('".concat(le.format("YYYY-MM-DD"), "')");
        },
        jsonLogic: function(O, V, U) {
          return (0, l.default)(O, U.valueFormat).toDate();
        },
        toJS: function(O, V) {
          var U = (0, l.default)(O, V.valueFormat);
          return U.isValid() ? U.toDate() : void 0;
        },
        mongoFormatValue: function(O, V, U) {
          var H = (0, l.default)(O, U.valueFormat);
          return H.isValid() ? H.toDate() : void 0;
        }
      },
      time: {
        type: "time",
        jsType: "string",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(b, O);
        },
        timeFormat: "HH:mm",
        valueFormat: "HH:mm:ss",
        use12Hours: !1,
        useKeyboard: !0,
        valueLabel: "Time",
        valuePlaceholder: "Enter time",
        valueLabels: [{
          label: "Time from",
          placeholder: "Enter time from"
        }, {
          label: "Time to",
          placeholder: "Enter time to"
        }],
        formatValue: function(O, V, U, H) {
          var J = (0, l.default)(O, U.valueFormat);
          return H ? J.format(U.timeFormat) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          var le = (0, l.default)(O, U.valueFormat);
          return s.SqlString.escape(le.format("HH:mm:ss"));
        },
        spelFormatValue: function(O, V, U, H, J) {
          var le = (0, l.default)(O, U.valueFormat);
          return "T(java.time.LocalTime).parse('".concat(le.format("HH:mm:ss"), "')");
        },
        jsonLogic: function(O, V, U) {
          var H = (0, l.default)(O, U.valueFormat);
          return H.get("hour") * 60 * 60 + H.get("minute") * 60 + H.get("second");
        },
        toJS: function(O, V) {
          var U = (0, l.default)(O, V.valueFormat);
          return U.isValid() ? U.get("hour") * 60 * 60 + U.get("minute") * 60 + U.get("second") : void 0;
        },
        mongoFormatValue: function(O, V, U) {
          var H = (0, l.default)(O, U.valueFormat);
          return H.get("hour") * 60 * 60 + H.get("minute") * 60 + H.get("second");
        },
        elasticSearchFormatValue: function(O, V, U, H) {
          return {
            script: {
              script: {
                source: "doc[".concat(H, "][0].getHour() >== params.min && doc[").concat(H, "][0].getHour() <== params.max"),
                params: {
                  min: V[0],
                  max: V[1]
                }
              }
            }
          };
        }
      },
      datetime: {
        type: "datetime",
        jsType: "string",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(y, O);
        },
        timeFormat: "HH:mm",
        dateFormat: "DD.MM.YYYY",
        valueFormat: "YYYY-MM-DD HH:mm:ss",
        use12Hours: !1,
        useKeyboard: !0,
        valueLabel: "Datetime",
        valuePlaceholder: "Enter datetime",
        valueLabels: [{
          label: "Datetime from",
          placeholder: "Enter datetime from"
        }, {
          label: "Datetime to",
          placeholder: "Enter datetime to"
        }],
        formatValue: function(O, V, U, H) {
          var J = (0, l.default)(O, U.valueFormat);
          return H ? J.format(U.dateFormat + " " + U.timeFormat) : JSON.stringify(O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          var le = (0, l.default)(O, U.valueFormat);
          return s.SqlString.escape(le.toDate());
        },
        spelFormatValue: function(O, V, U, H, J) {
          var le = (0, l.default)(O, U.valueFormat);
          return "new java.text.SimpleDateFormat('yyyy-MM-dd HH:mm:ss').parse('".concat(le.format("YYYY-MM-DD HH:mm:ss"), "')");
        },
        jsonLogic: function(O, V, U) {
          return (0, l.default)(O, U.valueFormat).toDate();
        },
        toJS: function(O, V) {
          var U = (0, l.default)(O, V.valueFormat);
          return U.isValid() ? U.toDate() : void 0;
        },
        mongoFormatValue: function(O, V, U) {
          var H = (0, l.default)(O, U.valueFormat);
          return H.isValid() ? H.toDate() : void 0;
        }
      },
      boolean: {
        type: "boolean",
        jsType: "boolean",
        valueSrc: "value",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(f, O);
        },
        labelYes: "Yes",
        labelNo: "No",
        formatValue: function(O, V, U, H) {
          return H ? O ? "Yes" : "No" : JSON.stringify(!!O);
        },
        sqlFormatValue: function(O, V, U, H, J) {
          return s.SqlString.escape(O);
        },
        spelFormatValue: function(O, V, U, H, J) {
          return (0, s.spelEscape)(O);
        },
        defaultValue: !1,
        toJS: function(O, V) {
          return O;
        },
        mongoFormatValue: function(O, V, U) {
          return O;
        }
      },
      field: {
        valueSrc: "field",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(L, O);
        },
        formatValue: function(O, V, U, H, J, le, ae) {
          return H && ae.label || O;
        },
        sqlFormatValue: function(O, V, U, H, J, le) {
          return O;
        },
        spelFormatValue: function(O, V, U, H, J) {
          return O;
        },
        valueLabel: "Field to compare",
        valuePlaceholder: "Select field to compare",
        customProps: {
          showSearch: !0
        }
      },
      func: {
        valueSrc: "func",
        factory: function(O) {
          return /* @__PURE__ */ r.default.createElement(R, O);
        },
        valueLabel: "Function",
        valuePlaceholder: "Select function",
        customProps: {
          //showSearch: true
        }
      },
      case_value: {
        valueSrc: "value",
        type: "case_value",
        spelFormatValue: function(O) {
          return (0, s.spelEscape)(O === "" ? null : O);
        },
        spelImportValue: function(O) {
          return [O.value, []];
        },
        factory: function(O) {
          var V = O.value, U = O.setValue;
          return /* @__PURE__ */ r.default.createElement("input", {
            type: "text",
            value: V || "",
            onChange: function(J) {
              return U(J.target.value);
            }
          });
        }
      }
    }, I = {
      text: {
        defaultOperator: "equal",
        mainWidget: "text",
        widgets: {
          text: {
            operators: ["equal", "not_equal", "like", "not_like", "starts_with", "ends_with", "proximity", "is_empty", "is_not_empty", "is_null", "is_not_null"],
            widgetProps: {},
            opProps: {}
          },
          textarea: {
            operators: ["equal", "not_equal", "like", "not_like", "starts_with", "ends_with", "is_empty", "is_not_empty", "is_null", "is_not_null"],
            widgetProps: {},
            opProps: {}
          },
          field: {
            operators: [
              //unary ops (like `is_empty`) will be excluded anyway, see getWidgetsForFieldOp()
              "equal",
              "not_equal",
              "proximity"
              //can exclude if you want
            ]
          }
        }
      },
      number: {
        defaultOperator: "equal",
        mainWidget: "number",
        widgets: {
          number: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          },
          slider: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      date: {
        defaultOperator: "equal",
        widgets: {
          date: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      time: {
        defaultOperator: "equal",
        widgets: {
          time: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      datetime: {
        defaultOperator: "equal",
        widgets: {
          datetime: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      select: {
        mainWidget: "select",
        defaultOperator: "select_equals",
        widgets: {
          select: {
            operators: [
              "select_equals",
              "select_not_equals",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ],
            widgetProps: {
              customProps: {
                showSearch: !0
              }
            }
          },
          multiselect: {
            operators: [
              "select_any_in",
              "select_not_any_in",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      multiselect: {
        defaultOperator: "multiselect_equals",
        widgets: {
          multiselect: {
            operators: [
              "multiselect_equals",
              "multiselect_not_equals",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      boolean: {
        defaultOperator: "equal",
        widgets: {
          boolean: {
            operators: ["equal", "not_equal", "is_null", "is_not_null"],
            widgetProps: {
              //you can enable this if you don't use fields as value sources
              // hideOperator: true,
              // operatorInlineLabel: "is",
            }
          },
          field: {
            operators: ["equal", "not_equal"]
          }
        }
      },
      "!group": {
        defaultOperator: "some",
        mainWidget: "number",
        widgets: {
          number: {
            widgetProps: {
              min: 0
            },
            operators: [
              // w/o operand
              "some",
              "all",
              "none",
              // w/ operand - count
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between"
            ],
            opProps: {
              equal: {
                label: "Count =="
              },
              not_equal: {
                label: "Count !="
              },
              less: {
                label: "Count <"
              },
              less_or_equal: {
                label: "Count <="
              },
              greater: {
                label: "Count >"
              },
              greater_or_equal: {
                label: "Count >="
              },
              between: {
                label: "Count between"
              },
              not_between: {
                label: "Count not between"
              }
            }
          }
        }
      },
      case_value: {
        mainWidget: "case_value",
        widgets: {
          case_value: {}
        }
      }
    }, z = g(g({}, u.settings), {}, {
      formatField: function(O, V, U, H, J, le) {
        return le ? U : O;
      },
      formatSpelField: function(O, V, U, H, J, le) {
        var ae = H.map(function(Y, re) {
          var ie = Y.key, _e = Y.parent;
          return re == 0 ? _e == "[map]" ? "#this[".concat((0, s.spelEscape)(ie), "]") : (_e == "[class]", ie) : _e == "map" || _e == "[map]" ? "[".concat((0, s.spelEscape)(ie), "]") : (_e == "class" || _e == "[class]", ".".concat(ie));
        }).join("");
        return J.isSpelVariable && (ae = "#" + ae), ae;
      },
      sqlFormatReverse: function(O) {
        if (O != null)
          return "NOT(" + O + ")";
      },
      spelFormatReverse: function(O) {
        if (O != null)
          return "!(" + O + ")";
      },
      formatReverse: function(O, V, U, H, J, le) {
        if (O != null)
          return le ? "NOT (" + O + ")" : "!(" + O + ")";
      },
      formatAggr: function(O, V, U, H, J, le, ae, Y, re, ie) {
        var _e = ae.labelForFormat, he = ae.cardinality;
        if (he == 0) {
          var be = O ? " HAVE ".concat(O) : "";
          return "".concat(_e, " OF ").concat(V).concat(be);
        } else if (he == null || he == 1) {
          var Q = O ? " WHERE ".concat(O) : "";
          return "COUNT OF ".concat(V).concat(Q, " ").concat(_e, " ").concat(H);
        } else if (he == 2) {
          var me = O ? " WHERE ".concat(O) : "", ne = H.first(), pe = H.get(1);
          return "COUNT OF ".concat(V).concat(me, " ").concat(_e, " ").concat(ne, " AND ").concat(pe);
        }
      },
      canCompareFieldWithField: function(O, V, U, H) {
        return !0;
      },
      // enable compare fields
      valueSourcesInfo: {
        value: {
          label: "Value"
        },
        field: {
          label: "Field",
          widget: "field"
        },
        func: {
          label: "Function",
          widget: "func"
        }
      },
      customFieldSelectProps: {
        showSearch: !0
      },
      defaultSliderWidth: "200px",
      defaultSelectWidth: "200px",
      defaultSearchWidth: "100px",
      defaultMaxRows: 5
    }), F = {
      conjunctions: D,
      operators: E,
      widgets: k,
      types: I,
      settings: z
    };
    e.default = F;
  }(qL)), qL;
}
(function(e) {
  var t = Tn, n = xo;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "BasicConfig", {
    enumerable: !0,
    get: function() {
      return _.default;
    }
  }), e.BasicFuncs = void 0, Object.defineProperty(e, "Builder", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), e.Operators = e.Import = e.Export = void 0, Object.defineProperty(e, "Query", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), e.Widgets = e.Utils = void 0;
  var o = t(Yr()), r = t(sru()), i = t(xru()), a = g(Lru());
  e.Export = a;
  var s = g(jru());
  e.Import = s;
  var c = g(DV());
  e.Widgets = c;
  var l = g(E$e());
  e.Operators = l;
  var u = g(Uru()), d = g(Gru());
  e.BasicFuncs = d;
  var _ = t(Wru());
  function p(v) {
    if (typeof WeakMap != "function")
      return null;
    var b = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap();
    return (p = function(N) {
      return N ? y : b;
    })(v);
  }
  function g(v, b) {
    if (!b && v && v.__esModule)
      return v;
    if (v === null || n(v) !== "object" && typeof v != "function")
      return { default: v };
    var y = p(b);
    if (y && y.has(v))
      return y.get(v);
    var w = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var M in v)
      if (M !== "default" && Object.prototype.hasOwnProperty.call(v, M)) {
        var q = N ? Object.getOwnPropertyDescriptor(v, M) : null;
        q && (q.get || q.set) ? Object.defineProperty(w, M, q) : w[M] = v[M];
      }
    return w.default = v, y && y.set(v, w), w;
  }
  function f(v, b) {
    var y = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var w = Object.getOwnPropertySymbols(v);
      b && (w = w.filter(function(N) {
        return Object.getOwnPropertyDescriptor(v, N).enumerable;
      })), y.push.apply(y, w);
    }
    return y;
  }
  function h(v) {
    for (var b = 1; b < arguments.length; b++) {
      var y = arguments[b] != null ? arguments[b] : {};
      b % 2 ? f(Object(y), !0).forEach(function(w) {
        (0, o.default)(v, w, y[w]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(y)) : f(Object(y)).forEach(function(w) {
        Object.defineProperty(v, w, Object.getOwnPropertyDescriptor(y, w));
      });
    }
    return v;
  }
  var $ = h(h(h({}, u), a), s);
  e.Utils = $;
})(xg);
var R_ = /* @__PURE__ */ ((e) => (e.FormFields = "FormFields", e.Attributes = "Attributes", e))(R_ || {});
const xd = function(e, t) {
  return e ? /* @__PURE__ */ m(t, { ...e }) : /* @__PURE__ */ m("div", {});
}, {
  TextWidget: x$e,
  TextAreaWidget: Hru,
  MultiSelectWidget: Yru,
  SelectWidget: Kru,
  NumberWidget: Zru,
  FieldSelect: jL,
  Conjs: Xru,
  Button: Jru,
  ButtonGroup: Qru,
  Provider: eiu
} = Th, tiu = (e) => xd(e, x$e), niu = (e) => xd(e, Hru), oiu = (e) => xd(e, Zru), riu = (e) => xd(e, Yru), iiu = (e) => xd(e, Kru), aiu = (e) => e ? /* @__PURE__ */ m(x$e, { type: "tel", ...e }) : /* @__PURE__ */ m("div", {}), siu = (e) => e ? /* @__PURE__ */ m(
  Rde,
  {
    onChange: (t) => {
      const n = t.target.value;
      e.setValue(n);
    },
    containerClassName: "w-full mb-2",
    ...e
  }
) : /* @__PURE__ */ m("div", {});
function ciu(e) {
  return {
    ...e,
    text: {
      ...e.text,
      factory: tiu
    },
    textarea: {
      ...e.textarea,
      factory: niu
    },
    number: {
      ...e.number,
      factory: oiu
    },
    multiselect: {
      ...e.multiselect,
      factory: riu
    },
    select: {
      ...e.select,
      factory: iiu
    },
    phone: {
      ...e.text,
      factory: aiu,
      valuePlaceholder: "Enter Phone Number"
    },
    email: {
      ...e.text,
      factory: siu
    }
  };
}
const liu = {
  renderField: (e) => xd(e, jL),
  renderOperator: (e) => xd(e, jL),
  renderFunc: (e) => xd(e, jL),
  renderConjs: (e) => xd(e, Xru),
  renderButton: (e) => xd(e, Jru),
  renderButtonGroup: (e) => xd(e, Qru),
  renderProvider: (e) => xd(e, eiu)
};
function uiu(e) {
  return {
    ...e,
    ...liu
  };
}
function diu({
  config: e
}) {
  const { settings: t, widgets: n, ...o } = e;
  return {
    ...o,
    settings: uiu(t),
    widgets: ciu(n)
  };
}
var Dw = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.NUMBER = "number", e.TEXTAREA = "textarea", e.SINGLE_SELECT = "select", e.MULTI_SELECT = "multiselect", e.PHONE = "phone", e.EMAIL = "email", e))(Dw || {});
const _iu = [
  {
    label: "Short Text",
    value: "text"
    /* TEXT */
  },
  {
    label: "Number",
    value: "number"
    /* NUMBER */
  },
  {
    label: "Long Text",
    value: "textarea"
    /* TEXTAREA */
  },
  {
    label: "Single Selection",
    value: "select"
    /* SINGLE_SELECT */
  },
  {
    label: "Multiple Selection",
    value: "multiselect"
    /* MULTI_SELECT */
  },
  {
    label: "Phone",
    value: "phone"
    /* PHONE */
  },
  {
    label: "Email",
    value: "email"
    /* EMAIL */
  }
], piu = {
  AND: {
    label: "And",
    jsonLogicConj: "and",
    reversedConj: "OR",
    formatConj: () => "",
    sqlFormatConj: () => "",
    spelFormatConj: () => "",
    mongoConj: ""
  },
  OR: {
    label: "Or",
    jsonLogicConj: "or",
    reversedConj: "AND",
    formatConj: () => "",
    sqlFormatConj: () => "",
    spelFormatConj: () => "",
    mongoConj: ""
  }
}, miu = {
  equal: {
    label: "Equals",
    labelForFormat: "==",
    reversedOp: "not_equal",
    jsonLogic: "=="
  },
  not_equal: {
    isNotOp: !0,
    label: "Does not equal",
    labelForFormat: "!=",
    reversedOp: "equal",
    jsonLogic: "!="
  },
  less: {
    label: "Less than",
    labelForFormat: "<",
    reversedOp: "greater_or_equal",
    jsonLogic: "<"
  },
  less_or_equal: {
    label: "Less than or equal to",
    labelForFormat: "<=",
    reversedOp: "greater",
    jsonLogic: "<="
  },
  greater: {
    label: "Greater than",
    labelForFormat: ">",
    reversedOp: "less_or_equal",
    jsonLogic: ">"
  },
  greater_or_equal: {
    label: "Greater than or equal to",
    labelForFormat: ">=",
    reversedOp: "less",
    jsonLogic: ">="
  },
  like: {
    label: "Contains",
    labelForFormat: "Contains",
    reversedOp: "not_like",
    jsonLogic: "in",
    _jsonLogicIsRevArgs: !0,
    valueSources: ["value"]
  },
  not_like: {
    isNotOp: !0,
    label: "Not contains",
    reversedOp: "like",
    labelForFormat: "Not Contains",
    valueSources: ["value"]
  },
  starts_with: {
    label: "Starts with",
    labelForFormat: "Starts with",
    jsonLogic: "starts_with",
    valueSources: ["value"]
  },
  //   ends_with: {
  //     label: "Ends with",
  //     labelForFormat: "Ends with",
  //     jsonLogic: undefined, // not supported
  //     valueSources: ["value"],
  //   },
  between: {
    label: "Between",
    labelForFormat: "BETWEEN",
    cardinality: 2,
    valueLabels: ["Value from", "Value to"],
    reversedOp: "not_between",
    jsonLogic: (e, t, n) => {
      const o = parseInt(n[0], 10), r = parseInt(n[1], 10);
      return {
        and: [{ ">=": [e, o] }, { "<=": [e, r] }]
      };
    }
  },
  not_between: {
    isNotOp: !0,
    label: "Not between",
    labelForFormat: "NOT BETWEEN",
    cardinality: 2,
    valueLabels: ["Value from", "Value to"],
    reversedOp: "between",
    jsonLogic: (e, t, n) => {
      const o = parseInt(n[0], 10), r = parseInt(n[1], 10);
      return {
        or: [{ "<": [e, o] }, { ">": [e, r] }]
      };
    }
  },
  is_empty: {
    label: "Is empty",
    labelForFormat: "IS EMPTY",
    cardinality: 0,
    reversedOp: "is_not_empty",
    jsonLogic: "!"
  },
  is_not_empty: {
    isNotOp: !0,
    label: "Is not empty",
    labelForFormat: "IS NOT EMPTY",
    cardinality: 0,
    reversedOp: "is_empty",
    jsonLogic: "!!"
  },
  /**
   * We don't need these operators
   */
  //   is_null: {
  //     label: "Is null",
  //     labelForFormat: "IS NULL",
  //     cardinality: 0,
  //     reversedOp: "is_not_null",
  //     jsonLogic: "==",
  //   },
  //   is_not_null: {
  //     label: "Is not null",
  //     labelForFormat: "IS NOT NULL",
  //     cardinality: 0,
  //     reversedOp: "is_null",
  //     jsonLogic: "!=",
  //   },
  select_equals: {
    label: "Equals",
    labelForFormat: "==",
    reversedOp: "select_not_equals",
    jsonLogic: "=="
  },
  select_not_equals: {
    isNotOp: !0,
    label: "Does not equal",
    labelForFormat: "!=",
    reversedOp: "select_equals",
    jsonLogic: "!="
  },
  select_any_in: {
    label: "Any in",
    labelForFormat: "IN",
    reversedOp: "select_not_any_in",
    jsonLogic: "in"
  },
  select_not_any_in: {
    isNotOp: !0,
    label: "Not any in",
    labelForFormat: "NOT IN",
    reversedOp: "select_any_in"
  },
  // We define this operator but use it conditionally for multiselect for Attributes only
  multiselect_some_in: {
    label: "Any in",
    jsonLogic: (e, t, n) => ({
      // Tested in jsonLogic.test.ts
      some: [e, { in: [{ var: "" }, n] }]
    })
  },
  multiselect_not_some_in: {
    label: "Not any in",
    reversedOp: "multiselect_some_in"
  },
  multiselect_equals: {
    label: "All in",
    reversedOp: "multiselect_not_equals",
    // jsonLogic2: "all-in",
    jsonLogic: (e, t, n, ...o) => ({
      // This is wrongly implemented as "includes". This isn't "equals". Because if field is ["a" ] and vals is ["a", "b"], it still matches. Expectation would probably be that it should be a strict match(["a", "b"] or ["b", "a"])
      all: [e, { in: [{ var: "" }, n] }]
    })
  },
  multiselect_not_equals: {
    isNotOp: !0,
    label: "Not all in",
    reversedOp: "multiselect_equals"
  },
  some: {
    label: "Some",
    labelForFormat: "SOME",
    cardinality: 0,
    jsonLogic: "some"
  },
  all: {
    label: "All",
    labelForFormat: "ALL",
    cardinality: 0
  },
  none: {
    label: "None",
    labelForFormat: "NONE",
    cardinality: 0,
    jsonLogic: "none"
  }
}, fiu = {
  text: {
    type: "text",
    jsType: "string",
    valueSrc: "value",
    valueLabel: "String",
    valuePlaceholder: "Enter string",
    toJS: (e) => e
  },
  textarea: {
    type: "text",
    jsType: "string",
    valueSrc: "value",
    valueLabel: "Text",
    valuePlaceholder: "Enter text",
    toJS: (e) => e
  },
  number: {
    type: "number",
    jsType: "number",
    valueSrc: "value",
    valueLabel: "Number",
    valuePlaceholder: "Enter number",
    toJS: (e) => e
  },
  select: {
    type: "select",
    jsType: "string",
    valueSrc: "value",
    valueLabel: "Value",
    valuePlaceholder: "Select value",
    toJS: (e) => e
  },
  multiselect: {
    type: "multiselect",
    jsType: "array",
    valueSrc: "value",
    valueLabel: "Values",
    valuePlaceholder: "Select values",
    toJS: (e) => e
  }
}, giu = {
  text: {
    defaultOperator: "equal",
    mainWidget: "text",
    widgets: {
      text: {
        // Note: any operator mentioned here but isn't defined in operators will be automatically excluded
        operators: [
          "equal",
          "not_equal",
          "like",
          "not_like",
          "starts_with",
          "ends_with",
          "proximity",
          "is_empty",
          "is_not_empty",
          "is_null",
          "is_not_null"
        ],
        widgetProps: {},
        opProps: {}
      },
      textarea: {
        operators: [
          "equal",
          "not_equal",
          "like",
          "not_like",
          "starts_with",
          "ends_with",
          "is_empty",
          "is_not_empty",
          "is_null",
          "is_not_null"
        ],
        widgetProps: {},
        opProps: {}
      }
    }
  },
  number: {
    defaultOperator: "equal",
    mainWidget: "number",
    widgets: {
      number: {
        operators: [
          "equal",
          "not_equal",
          "less",
          "less_or_equal",
          "greater",
          "greater_or_equal",
          "between",
          "not_between",
          // "is_empty",
          // "is_not_empty",
          "is_null",
          "is_not_null"
        ]
      }
      //   slider: {
      //     operators: [
      //       "equal",
      //       "not_equal",
      //       "less",
      //       "less_or_equal",
      //       "greater",
      //       "greater_or_equal",
      //       // "is_empty",
      //       // "is_not_empty",
      //       "is_null",
      //       "is_not_null",
      //     ],
      //   },
    }
  },
  select: {
    mainWidget: "select",
    defaultOperator: "select_equals",
    widgets: {
      select: {
        operators: ["select_equals", "select_not_equals"],
        widgetProps: {
          customProps: {
            showSearch: !0
          }
        }
      },
      multiselect: {
        operators: ["select_any_in", "select_not_any_in"]
      }
    }
  },
  multiselect: {
    defaultOperator: "multiselect_equals",
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals", "is_null", "is_not_null"]
      }
    }
  }
  //   "!group": {
  //     defaultOperator: "some",
  //     mainWidget: "number",
  //     widgets: {
  //       number: {
  //         widgetProps: {
  //           min: 0,
  //         },
  //         operators: [
  //           // w/o operand
  //           "some",
  //           "all",
  //           "none",
  //           // w/ operand - count
  //           "equal",
  //           "not_equal",
  //           "less",
  //           "less_or_equal",
  //           "greater",
  //           "greater_or_equal",
  //           "between",
  //           "not_between",
  //         ],
  //         opProps: {
  //           equal: {
  //             label: "Count ==",
  //           },
  //           not_equal: {
  //             label: "Count !=",
  //           },
  //           less: {
  //             label: "Count <",
  //           },
  //           less_or_equal: {
  //             label: "Count <=",
  //           },
  //           greater: {
  //             label: "Count >",
  //           },
  //           greater_or_equal: {
  //             label: "Count >=",
  //           },
  //           between: {
  //             label: "Count between",
  //           },
  //           not_between: {
  //             label: "Count not between",
  //           },
  //         },
  //       },
  //     },
  //   },
  //   case_value: {
  //     mainWidget: "case_value",
  //     widgets: {
  //       case_value: {},
  //     },
  //   },
}, hiu = {
  setOpOnChangeField: ["keep", "default"]
  // 'default' (default if present), 'keep' (keep prev from last field), 'first', 'none'
}, ul = {
  conjunctions: piu,
  operators: miu,
  widgets: fiu,
  types: giu,
  settings: hiu
};
function C$e(e) {
  return {
    ...ul.widgets,
    phone: {
      ...ul.widgets.text
    },
    email: {
      ...ul.widgets.text
    }
  };
}
function T$e(e) {
  const t = ul.types.multiselect.widgets.multiselect.operators || [];
  return e === R_.Attributes && t.push("multiselect_some_in", "multiselect_not_some_in"), {
    ...ul.types,
    phone: {
      ...ul.types.text,
      widgets: {
        ...ul.types.text.widgets
      }
    },
    email: {
      ...ul.types.text,
      widgets: {
        ...ul.types.text.widgets
      }
    },
    multiselect: {
      ...ul.types.multiselect,
      widgets: {
        ...ul.types.multiselect.widgets,
        multiselect: {
          ...ul.types.multiselect.widgets.multiselect,
          operators: [...t]
        }
      }
    }
  };
}
function A$e(e) {
  return {
    ...ul.operators
  };
}
function I$e(e) {
  return {
    ...ul.conjunctions
  };
}
function O$e() {
  return {
    ...ul.settings,
    groupActionsPosition: "bottomCenter",
    // TODO: Test it and then enable it. It might allow us to show better error messages.
    // But it doesn't detect every kind of error like an operator gone missing e.g. what happened in https://github.com/calcom/cal.com/pull/17102
    showErrorMessage: !0,
    // Disable groups
    maxNesting: 1
  };
}
const viu = {
  conjunctions: I$e(R_.FormFields),
  operators: A$e(R_.FormFields),
  types: T$e(R_.FormFields),
  widgets: C$e(R_.FormFields),
  settings: O$e()
}, biu = {
  conjunctions: I$e(R_.Attributes),
  operators: A$e(R_.Attributes),
  types: T$e(R_.Attributes),
  widgets: C$e(R_.Attributes),
  settings: O$e()
}, yiu = viu, Moe = biu, $iu = (e) => `{field:${e}}`, wiu = /* @__PURE__ */ new Map([
  [yS.SINGLE_SELECT, Dw.SINGLE_SELECT],
  [yS.MULTI_SELECT, Dw.MULTI_SELECT],
  [yS.TEXT, Dw.TEXT],
  [yS.NUMBER, Dw.NUMBER]
]);
function kiu(e) {
  return e.map((t) => {
    const n = wiu.get(t.type);
    if (!n)
      throw new Error(`Unsupported attribute type:${t.type}`);
    return {
      label: t.name,
      id: t.id,
      type: n,
      options: t.options.map((o) => ({
        title: o.value,
        // We have to use something that doesn't change often. ID of attribute never changes. Changing means a saved value will become invalid
        value: o.id
      }))
    };
  });
}
function Siu({
  attributes: e,
  /**
   * It is the fields that makes up additional options to be matched with for the single select/multiselect attributes.
   * They are shown as 'Value of field <field-label>' in the dropdown.
   */
  dynamicOperandFields: t = []
}) {
  const n = kiu(e), o = {};
  return n.forEach((i) => {
    const a = i.type;
    if (_iu.map((s) => s.value).includes(a)) {
      const c = yiu.widgets[a].type, u = [...t.map((_) => ({
        title: `Value of field '${_.label}'`,
        value: $iu(_.id)
      })), ...i.options];
      o[i.id] = {
        label: i.label,
        type: c,
        valueSources: ["value"],
        fieldSettings: {
          // IMPORTANT: listValues must be undefined for non-select/multiselect fields otherwise RAQB doesn't like it. It ends up considering all the text values as per the listValues too which could be empty as well making all values invalid
          listValues: a === "select" || a === "multiselect" ? u : void 0
        }
      };
    } else
      throw new Error(`Unsupported field type:${i.type}`);
  }), {
    ...{
      ...Moe,
      operators: { ...Moe.operators }
    },
    fields: o
  };
}
function g6(e, t) {
  if (e === t)
    return !0;
  if (e == null || t == null)
    return !1;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((n, o) => g6(n, t[o]));
  if (typeof e == "object" && typeof t == "object") {
    const n = Object.keys(e), o = Object.keys(t);
    return n.length !== o.length ? !1 : n.every((r) => Object.prototype.hasOwnProperty.call(t, r) ? g6(e[r], t[r]) : !1);
  }
  return e === t;
}
function Eiu() {
  return { id: xg.Utils.uuid(), type: "group" };
}
const xiu = ({
  queryValue: e,
  config: t
}) => {
  const n = e || Eiu(), o = xg.Utils.checkTree(xg.Utils.loadTree(n), t);
  return {
    state: {
      tree: o,
      config: t
    },
    queryValue: xg.Utils.getTree(o)
  };
};
function Ciu(e) {
  const { data: t, isPending: n } = hr.viewer.appRoutingForms.getAttributesForTeam.useQuery({
    teamId: e
  });
  return {
    attributes: t,
    isPending: n
  };
}
function Tiu({
  attributes: e,
  teamId: t,
  queryValue: n,
  onQueryValueChange: o,
  className: r
}) {
  const i = Siu({
    attributes: e
  }), [a, s] = it(n), c = diu({
    config: i,
    configFor: R_.Attributes
  }), l = xiu({
    queryValue: a,
    config: c
  }), u = Yt(
    (_) => /* @__PURE__ */ m("div", { className: "query-builder-container", "data-testid": "query-builder-container", children: /* @__PURE__ */ m("div", { className: "query-builder qb-lite", children: /* @__PURE__ */ m(xg.Builder, { ..._ }) }) }),
    []
  );
  function d(_) {
    const p = xg.Utils.getTree(_);
    g6(p, a) || (s(p), o({
      queryValue: p
    }));
  }
  return (
    // cal-query-builder class has special styling through global CSS, allowing us to customize RAQB
    /* @__PURE__ */ de("div", { children: [
      /* @__PURE__ */ m("div", { className: xe("cal-query-builder", r), children: /* @__PURE__ */ m(
        xg.Query,
        {
          ...c,
          value: l.state.tree,
          onChange: d,
          renderBuilder: u
        }
      ) }),
      /* @__PURE__ */ m("div", { className: "mt-4 text-sm", children: /* @__PURE__ */ m(Aiu, { teamId: t, queryValue: a }) })
    ] })
  );
}
function Aiu({
  teamId: e,
  queryValue: t
}) {
  const { t: n } = kt(), o = t != null && t.children1 ? Object.values(t.children1).some(
    (s) => {
      var c, l, u, d;
      return ((l = (c = s.properties) == null ? void 0 : c.value) == null ? void 0 : l[0]) !== void 0 && ((d = (u = s.properties) == null ? void 0 : u.value) == null ? void 0 : d[0]) !== null;
    }
  ) : !1, { data: r, isPending: i } = hr.viewer.attributes.findTeamMembersMatchingAttributeLogic.useQuery(
    {
      teamId: e,
      attributesQueryValue: t,
      _enablePerf: !0
    },
    {
      enabled: o
    }
  );
  if (!o)
    return /* @__PURE__ */ m("div", { className: "border-subtle bg-muted mt-4 space-y-3 rounded-md border p-4", children: /* @__PURE__ */ m("div", { className: "text-subtle flex items-center text-sm font-medium", children: /* @__PURE__ */ m("span", { children: n("no_filter_set") }) }) });
  if (i)
    return /* @__PURE__ */ de(
      "div",
      {
        className: "border-subtle bg-muted mt-4 space-y-3 rounded-md border p-4",
        "data-testid": "segment_loading_state",
        children: [
          /* @__PURE__ */ m("div", { className: "text-emphasis flex items-center text-sm font-medium", children: /* @__PURE__ */ m("div", { className: "bg-subtle h-4 w-32 animate-pulse rounded" }) }),
          /* @__PURE__ */ m("ul", { className: "divide-subtle divide-y", children: [...Array(3)].map((s, c) => /* @__PURE__ */ m("li", { className: "flex items-center py-2", children: /* @__PURE__ */ de("div", { className: "flex flex-1 items-center space-x-2 text-sm", children: [
            /* @__PURE__ */ m("div", { className: "bg-subtle h-4 w-24 animate-pulse rounded" }),
            /* @__PURE__ */ m("div", { className: "bg-subtle h-4 w-32 animate-pulse rounded" })
          ] }) }, c)) })
        ]
      }
    );
  if (!r)
    return /* @__PURE__ */ m("span", { children: n("something_went_wrong") });
  const { result: a } = r;
  return /* @__PURE__ */ de("div", { className: "border-subtle bg-muted mt-4 space-y-3 rounded-md border p-4", children: [
    /* @__PURE__ */ m("div", { className: "text-emphasis flex items-center text-sm font-medium", children: /* @__PURE__ */ m("span", { children: n("x_matching_members", { x: (a == null ? void 0 : a.length) ?? 0 }) }) }),
    /* @__PURE__ */ m("ul", { className: "divide-subtle divide-y", children: a == null ? void 0 : a.map((s) => /* @__PURE__ */ m("li", { className: "flex items-center py-2", children: /* @__PURE__ */ de("div", { className: "flex flex-1 items-center space-x-2 text-sm", children: [
      /* @__PURE__ */ m("span", { className: "font-medium", children: s.name }),
      /* @__PURE__ */ de("span", { className: "text-subtle", children: [
        "(",
        s.email,
        ")"
      ] })
    ] }) }, s.id)) })
  ] });
}
function Iiu({
  teamId: e,
  queryValue: t,
  onQueryValueChange: n,
  className: o
}) {
  const { attributes: r, isPending: i } = Ciu(e), { t: a } = kt();
  return i ? /* @__PURE__ */ m("span", { children: "Loading..." }) : r ? /* @__PURE__ */ m(
    Tiu,
    {
      teamId: e,
      attributes: r,
      queryValue: t,
      onQueryValueChange: n,
      className: o
    }
  ) : (console.error("Error fetching attributes"), /* @__PURE__ */ m("span", { children: a("something_went_wrong") }));
}
const Oiu = ({
  assignAllTeamMembers: e,
  setAssignAllTeamMembers: t,
  onActive: n,
  onInactive: o,
  customClassNames: r
}) => {
  const { t: i } = kt(), { setValue: a } = No();
  return /* @__PURE__ */ m(
    Bn,
    {
      name: "assignAllTeamMembers",
      render: () => /* @__PURE__ */ m(
        Jo,
        {
          "data-testid": "assign-all-team-members-toggle",
          title: i("automatically_add_all_team_members"),
          labelClassName: xe("mt-[3px] text-sm", r == null ? void 0 : r.label),
          switchContainerClassName: r == null ? void 0 : r.container,
          checked: e,
          onCheckedChange: (s) => {
            a("assignAllTeamMembers", s, { shouldDirty: !0 }), t(s), s ? n() : o && o();
          }
        }
      )
    }
  );
}, h6 = Oiu, Niu = ({ id: e, name: t, username: n, avatar: o, email: r, defaultScheduleId: i }, a) => ({
  value: `${e || ""}`,
  label: `${t || r || ""}${n ? "" : ` (${a})`}`,
  avatar: o,
  email: r,
  defaultScheduleId: i
}), ziu = (e, t) => e.label < t.label ? -1 : e.label > t.label ? 1 : 0, Riu = ({
  labelText: e,
  placeholder: t,
  options: n = [],
  isFixed: o,
  value: r,
  onChange: i,
  helperText: a,
  isRRWeightsEnabled: s,
  groupId: c,
  customClassNames: l,
  ...u
}) => /* @__PURE__ */ m("div", { className: "flex flex-col rounded-md", children: /* @__PURE__ */ de("div", { children: [
  e ? /* @__PURE__ */ m(Ko, { children: e }) : /* @__PURE__ */ m(nt, {}),
  /* @__PURE__ */ m(
    H7l,
    {
      isOptionDisabled: (d) => !!r.find((_) => _.userId.toString() === d.value),
      onChange: (d) => {
        i && i(
          d.map((_) => ({
            isFixed: o,
            userId: parseInt(_.value, 10),
            priority: _.priority ?? 2,
            weight: _.weight ?? 100,
            scheduleId: _.defaultScheduleId,
            groupId: _.groupId
          }))
        );
      },
      value: (r || []).filter(({ isFixed: d }) => o === d).reduce((d, _) => {
        const p = n.find((g) => g.value === _.userId.toString());
        return p && d.push({
          ...p,
          priority: _.priority ?? 2,
          isFixed: o,
          weight: _.weight ?? 100,
          groupId: _.groupId
        }), d;
      }, []),
      controlShouldRenderValue: !1,
      options: n,
      placeholder: t,
      isRRWeightsEnabled: s,
      customClassNames: l,
      groupId: c,
      ...u
    }
  )
] }) });
function Piu({
  teamId: e,
  assignRRMembersUsingSegment: t,
  setAssignRRMembersUsingSegment: n,
  rrSegmentQueryValue: o,
  setRrSegmentQueryValue: r,
  className: i
}) {
  const { t: a } = kt(), s = ({ queryValue: l }) => {
    r(l);
  }, c = Kr();
  return /* @__PURE__ */ m(
    Bn,
    {
      name: "assignRRMembersUsingSegment",
      render: () => /* @__PURE__ */ m(
        Jo,
        {
          noIndentation: !0,
          "data-testid": "segment-toggle",
          title: a("filter_by_attributes"),
          labelClassName: "mt-0.5 font-normal",
          checked: t,
          onCheckedChange: (l) => {
            n(l);
          },
          children: !c && /* @__PURE__ */ m(
            Iiu,
            {
              teamId: e,
              queryValue: o,
              onQueryValueChange: s,
              className: i
            }
          )
        }
      )
    }
  );
}
function Diu({
  assignAllTeamMembers: e,
  assignRRMembersUsingSegment: t,
  isAssigningAllTeamMembersApplicable: n,
  isSegmentApplicable: o
}) {
  return e ? o ? "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_APPLICABLE" : "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_NOT_APPLICABLE" : t && o ? "TEAM_MEMBERS_IN_SEGMENT_ENABLED" : n ? "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_APPLICABLE" : "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_NOT_APPLICABLE";
}
function Liu() {
  const { getValues: e, setValue: t, watch: n } = No(), o = n("assignRRMembersUsingSegment"), r = (s) => t("assignRRMembersUsingSegment", s, { shouldDirty: !0 }), i = e("rrSegmentQueryValue");
  return {
    assignRRMembersUsingSegment: o,
    setAssignRRMembersUsingSegment: r,
    rrSegmentQueryValue: i,
    setRrSegmentQueryValue: (s) => t("rrSegmentQueryValue", s, { shouldDirty: !0 })
  };
}
function N$e({
  teamMembers: e,
  value: t,
  onChange: n,
  assignAllTeamMembers: o,
  setAssignAllTeamMembers: r,
  automaticAddAllEnabled: i,
  onActive: a,
  isFixed: s,
  placeholder: c = "",
  isRRWeightsEnabled: l,
  teamId: u,
  isSegmentApplicable: d,
  groupId: _,
  customClassNames: p,
  ...g
}) {
  const { t: f } = kt();
  No();
  const {
    assignRRMembersUsingSegment: h,
    setAssignRRMembersUsingSegment: $,
    rrSegmentQueryValue: v,
    setRrSegmentQueryValue: b
  } = Liu(), y = Diu({
    assignAllTeamMembers: o,
    assignRRMembersUsingSegment: h,
    isAssigningAllTeamMembersApplicable: i,
    isSegmentApplicable: d
  }), w = () => {
    $(!1);
  };
  switch (y) {
    case "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_APPLICABLE":
    case "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_NOT_APPLICABLE":
    case "TEAM_MEMBERS_IN_SEGMENT_ENABLED":
      return /* @__PURE__ */ de(nt, { children: [
        !_ && /* @__PURE__ */ m(
          h6,
          {
            assignAllTeamMembers: o,
            setAssignAllTeamMembers: r,
            onActive: a,
            onInactive: w,
            customClassNames: p == null ? void 0 : p.assingAllTeamMembers
          }
        ),
        y !== "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_NOT_APPLICABLE" && /* @__PURE__ */ m("div", { className: "mt-2", children: /* @__PURE__ */ m(
          Piu,
          {
            teamId: u,
            assignRRMembersUsingSegment: h,
            setAssignRRMembersUsingSegment: $,
            rrSegmentQueryValue: v,
            setRrSegmentQueryValue: b
          }
        ) })
      ] });
    case "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_NOT_APPLICABLE":
    case "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_APPLICABLE":
      return /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("div", { className: "mb-2", children: y === "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_APPLICABLE" && !_ && /* @__PURE__ */ m(
          h6,
          {
            assignAllTeamMembers: o,
            setAssignAllTeamMembers: r,
            onActive: a,
            onInactive: w,
            customClassNames: p == null ? void 0 : p.assingAllTeamMembers
          }
        ) }),
        /* @__PURE__ */ m("div", { className: "mb-2", children: /* @__PURE__ */ m(
          Riu,
          {
            "data-testid": g["data-testid"],
            value: t,
            onChange: n,
            isFixed: s,
            className: "mb-2",
            options: e.map((N) => ({
              ...N,
              groupId: _
            })).sort(ziu),
            placeholder: c ?? f("add_attendees"),
            isRRWeightsEnabled: l,
            groupId: _,
            customClassNames: p == null ? void 0 : p.teamMemberSelect
          }
        ) })
      ] });
  }
}
const v6 = ({
  containerClassName: e,
  ...t
}) => {
  const n = Kr(), o = vn(
    () => n ? iXl : aXl,
    [n]
  );
  return /* @__PURE__ */ m("div", { className: "rounded-md", children: /* @__PURE__ */ m("div", { className: `flex flex-col rounded-md pb-2 pt-6 ${e}`, children: /* @__PURE__ */ m(o, { ...t }) }) });
}, Miu = ({
  options: e = [],
  value: t = [],
  customClassNames: n,
  ...o
}) => {
  var a, s, c;
  const { t: r } = kt(), [i] = qd();
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Di,
      {
        name: o.name,
        placeholder: r("select"),
        options: e,
        className: (a = n == null ? void 0 : n.assignToSelect) == null ? void 0 : a.select,
        innerClassNames: (s = n == null ? void 0 : n.assignToSelect) == null ? void 0 : s.innerClassNames,
        value: t,
        isMulti: !0,
        ...o
      }
    ),
    /* @__PURE__ */ m(
      "ul",
      {
        className: xe(
          "border-subtle divide-subtle mt-3 divide-y rounded-md",
          t.length >= 1 && "border",
          (c = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : c.container
        ),
        ref: i,
        children: t.map((l, u) => {
          var d, _, p, g, f, h, $, v, b, y, w, N, M, q, L, R, T, D, A, S, E, x, k, I, z, F, P, O, V;
          return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ de(
            "div",
            {
              className: xe(
                "flex flex-row items-center gap-3 p-3",
                (_ = (d = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : d.listItem) == null ? void 0 : _.container
              ),
              children: [
                /* @__PURE__ */ m(
                  Dd,
                  {
                    size: "mdLg",
                    className: xe(
                      "overflow-visible",
                      (g = (p = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : p.listItem) == null ? void 0 : g.avatar
                    ),
                    imageSrc: l.owner.avatar,
                    alt: l.owner.name || l.owner.email || ""
                  }
                ),
                /* @__PURE__ */ de("div", { className: "flex w-full flex-row justify-between", children: [
                  /* @__PURE__ */ de("div", { className: "flex flex-col", children: [
                    /* @__PURE__ */ de(
                      "span",
                      {
                        className: xe(
                          "text text-sm font-semibold leading-none",
                          (h = (f = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : f.listItem) == null ? void 0 : h.name
                        ),
                        children: [
                          l.owner.name || l.owner.email,
                          /* @__PURE__ */ de(
                            "div",
                            {
                              className: xe(
                                "flex flex-row gap-1",
                                (v = ($ = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : $.listItem) == null ? void 0 : v.badgeContainer
                              ),
                              children: [
                                l.owner.membership === Ilc.OWNER ? /* @__PURE__ */ m(
                                  Wi,
                                  {
                                    variant: "gray",
                                    className: (y = (b = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : b.listItem) == null ? void 0 : y.ownerBadge,
                                    children: r("owner")
                                  }
                                ) : /* @__PURE__ */ m(
                                  Wi,
                                  {
                                    variant: "gray",
                                    className: (N = (w = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : w.listItem) == null ? void 0 : N.memberBadge,
                                    children: r("member")
                                  }
                                ),
                                l.hidden && /* @__PURE__ */ m(
                                  Wi,
                                  {
                                    variant: "gray",
                                    className: (q = (M = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : M.listItem) == null ? void 0 : q.hiddenBadge,
                                    children: r("hidden")
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    l.owner.username && /* @__PURE__ */ m(
                      "small",
                      {
                        className: xe(
                          "text-subtle font-normal leading-normal",
                          (R = (L = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : L.listItem) == null ? void 0 : R.eventLink
                        ),
                        children: `/${l.owner.username}/${l.slug}`
                      }
                    )
                  ] }),
                  /* @__PURE__ */ de("div", { className: xe("flex flex-row items-center gap-2"), children: [
                    /* @__PURE__ */ m(
                      Sr,
                      {
                        className: (D = (T = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : T.listItem) == null ? void 0 : D.showOnProfileTooltip,
                        content: r("show_eventtype_on_profile"),
                        children: /* @__PURE__ */ m("div", { className: "self-center rounded-md p-2", children: /* @__PURE__ */ m(
                          as,
                          {
                            name: "Hidden",
                            checked: !l.hidden,
                            onCheckedChange: (U) => {
                              const H = t.map(
                                (J) => J.owner.id === l.owner.id ? { ...J, hidden: !U } : J
                              );
                              o.onChange(H);
                            }
                          }
                        ) })
                      }
                    ),
                    /* @__PURE__ */ de($A, { combined: !0, children: [
                      l.created && l.owner.username && /* @__PURE__ */ m(
                        Sr,
                        {
                          className: (S = (A = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : A.listItem) == null ? void 0 : S.previewEventTypeTooltip,
                          content: r("preview"),
                          children: /* @__PURE__ */ m(
                            Jt,
                            {
                              "data-testid": "preview-button",
                              color: "secondary",
                              target: "_blank",
                              variant: "icon",
                              className: (x = (E = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : E.listItem) == null ? void 0 : x.previewEventTypeButton,
                              href: `${Ry(
                                ((I = (k = l.owner.profile) == null ? void 0 : k.organization) == null ? void 0 : I.slug) ?? null
                              )}/${(z = l.owner) == null ? void 0 : z.username}/${l.slug}`,
                              StartIcon: "external-link"
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ m(
                        Sr,
                        {
                          className: (P = (F = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : F.listItem) == null ? void 0 : P.deleteEventTypeTooltip,
                          content: r("delete"),
                          children: /* @__PURE__ */ m(
                            Jt,
                            {
                              color: "secondary",
                              target: "_blank",
                              variant: "icon",
                              className: (V = (O = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : O.listItem) == null ? void 0 : V.deleteEventTypeButton,
                              onClick: () => o.onChange(t.filter((U) => U.owner.id !== l.owner.id)),
                              StartIcon: "x"
                            }
                          )
                        }
                      )
                    ] })
                  ] })
                ] })
              ]
            }
          ) }, u);
        })
      }
    )
  ] });
}, Fiu = Miu, qiu = (e, t) => {
  const n = typeof e == "string" ? e : jiu(e), o = new Blob([n], { type: "text/plain" }), r = window.URL.createObjectURL(o), i = document.createElement("a");
  i.href = r, i.download = t, i.click(), window.URL.revokeObjectURL(r);
}, jiu = (e) => {
  if (!e.length)
    return "";
  const t = Object.keys(e[0]);
  return [
    // Header row
    t.map((o) => Foe(o)).join(","),
    // Data rows
    ...e.map(
      (o) => t.map((r) => {
        const i = o[r];
        return Foe((i == null ? void 0 : i.toString()) ?? "");
      }).join(",")
    )
  ].join(`
`);
}, Foe = (e) => e.includes('"') ? `"${e.replace(/"/g, '""')}"` : e.includes(",") || e.includes(`
`) ? `"${e}"` : e, z$e = (e) => /* @__PURE__ */ m(xce, { ...e });
z$e.displayName = "Sheet";
const Viu = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(Cce, { ref: n, className: xe(e), ...t }));
Viu.displayName = "Sheet.Trigger";
const R$e = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(wF, { ref: n, className: xe(e), ...t }));
R$e.displayName = "Sheet.Close";
const P$e = Ece;
P$e.displayName = "SheetPortal";
const D$e = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Tce,
  {
    ref: n,
    className: xe(
      // base
      "fixed inset-0 z-50 overflow-y-auto",
      // background color
      "bg-black/30",
      // transition
      "data-[state=closed]:animate-hide data-[state=open]:animate-dialogOverlayShow",
      e
    ),
    ...t,
    style: {
      animationDuration: "400ms",
      animationFillMode: "backwards"
    }
  }
));
D$e.displayName = "SheetOverlay";
const L$e = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(P$e, { children: /* @__PURE__ */ m(D$e, { children: /* @__PURE__ */ m(
  Ace,
  {
    ref: n,
    className: xe(
      // base
      "fixed inset-y-4 mx-auto flex w-[95vw] flex-1 flex-col overflow-y-auto rounded-xl border p-4 shadow-lg focus:outline-none sm:right-2 sm:max-w-lg sm:p-6",
      // "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm sm:p-6 p-4 shadow-lg rounded-xl border ",
      // border color
      "border-subtle",
      // background color
      "bg-default",
      // transition
      "data-[state=closed]:animate-SheetSlideRightAndFade data-[state=open]:animate-SheetSlideLeftAndFade",
      e
    ),
    ...t
  }
) }) }));
L$e.displayName = "SheetContent";
const M$e = Ue.forwardRef(({ children: e, className: t, showCloseButton: n = !0, ...o }, r) => /* @__PURE__ */ de("div", { ref: r, className: "flex items-start justify-between gap-x-4 pb-2", ...o, children: [
  /* @__PURE__ */ m("div", { className: xe("mt-1 flex flex-col gap-y-1", t), children: e }),
  n && /* @__PURE__ */ m(wF, { asChild: !0, children: /* @__PURE__ */ m(Jt, { variant: "icon", StartIcon: "x", color: "minimal", className: "aspect-square p-1" }) })
] }));
M$e.displayName = "Sheet.Header";
const F$e = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Ice,
  {
    ref: n,
    className: xe(
      // base
      "font-sans text-xl font-semibold",
      // text color
      "text-emphasis",
      e
    ),
    ...t
  }
));
F$e.displayName = "SheetTitle";
const q$e = Ue.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: xe("flex-1 overflow-y-auto py-4", e), ...t })
);
q$e.displayName = "Sheet.Body";
const Biu = Ue.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Oce,
  {
    ref: n,
    className: xe("text-subtle text-sm leading-none", e),
    ...t
  }
));
Biu.displayName = "SheetDescription";
const j$e = ({ className: e, ...t }) => /* @__PURE__ */ m(
  "div",
  {
    className: xe(
      "border-muted flex flex-col-reverse gap-2 border-t pt-4 sm:flex-row sm:justify-end",
      e
    ),
    ...t
  }
);
j$e.displayName = "SheetFooter";
const V$e = ({
  initialTeamMembers: e,
  assignRRMembersUsingSegment: t,
  matchingTeamMembersWithResult: n,
  value: o
}) => {
  const r = vn(() => t && (n != null && n.result) ? n.result.map((a) => ({
    value: a.id.toString(),
    label: a.name || a.email,
    email: a.email,
    avatar: ""
  })) : e, [t, n, e]), i = vn(
    () => r.reduce((a, s) => {
      const c = o.find((l) => l.userId === parseInt(s.value, 10));
      return a[s.value] = (c == null ? void 0 : c.weight) ?? 100, a;
    }, {}),
    [r, o]
  );
  return {
    teamMembers: r,
    localWeightsInitialValues: i
  };
}, Uiu = ({
  initialTeamMembers: e,
  assignRRMembersUsingSegment: t,
  teamId: n,
  orgId: o,
  queryValue: r,
  value: i
}) => {
  const { isInit: a } = cr(), s = `/atoms/organizations/${o}/teams/${n}/members-matching-attribute?${new URLSearchParams(
    {
      attributesQueryValue: r ? JSON.stringify(r) : "",
      enablePerf: "true"
    }
  )}`, { data: c, isPending: l } = mr({
    queryKey: ["teamMembersMatchingAttribute", n, o, r],
    queryFn: async () => At == null ? void 0 : At.get(s).then((_) => {
      if (_.data.status === Nn)
        return _.data.data;
      throw new Error(_.data.error.message);
    }),
    enabled: a && !!n && !!o
  }), { teamMembers: u, localWeightsInitialValues: d } = V$e({
    initialTeamMembers: e,
    assignRRMembersUsingSegment: t,
    matchingTeamMembersWithResult: c,
    value: i
  });
  return {
    teamMembers: u,
    localWeightsInitialValues: d,
    isPending: l
  };
}, Giu = ({
  initialTeamMembers: e,
  assignRRMembersUsingSegment: t,
  teamId: n,
  queryValue: o,
  value: r
}) => {
  const { data: i, isPending: a } = hr.viewer.attributes.findTeamMembersMatchingAttributeLogic.useQuery(
    {
      teamId: n || 0,
      attributesQueryValue: o,
      _enablePerf: !0
    },
    {
      enabled: t && !!o && !!n
    }
  ), { teamMembers: s, localWeightsInitialValues: c } = V$e({
    initialTeamMembers: e,
    assignRRMembersUsingSegment: t,
    matchingTeamMembersWithResult: i,
    value: r
  });
  return {
    teamMembers: s,
    localWeightsInitialValues: c,
    isPending: a
  };
}, Wiu = ({ member: e, onWeightChange: t }) => {
  const [n, o] = it(!1), r = xt(null);
  return yt(() => {
    n && r.current && r.current.focus();
  }, [n]), /* @__PURE__ */ de("div", { className: "border-subtle flex h-12 items-center border-b px-3 py-1 last:border-b-0", children: [
    /* @__PURE__ */ m(Dd, { size: "sm", imageSrc: e.avatar, alt: e.label, className: "min-w-10" }),
    /* @__PURE__ */ m("span", { className: "text-emphasis ml-3 flex-grow text-sm", children: e.label }),
    /* @__PURE__ */ m("div", { className: "ml-auto flex h-full items-center", children: n ? /* @__PURE__ */ m("div", { className: "flex h-full items-center", children: /* @__PURE__ */ de("div", { className: "relative flex h-full items-center", children: [
      /* @__PURE__ */ m(
        "input",
        {
          ref: r,
          type: "number",
          min: "0",
          inputMode: "numeric",
          className: "bg-muted border-default text-emphasis h-7 w-12 rounded-l-sm border px-2 text-sm [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
          defaultValue: e.weight ?? 100,
          onBlur: (i) => {
            const a = parseInt(i.target.value);
            isNaN(a) || t(e.value, a), o(!1);
          },
          onKeyDown: (i) => {
            if (i.key === "Enter") {
              const a = i.target, s = parseInt(a.value);
              isNaN(s) || t(e.value, s), o(!1);
            }
            i.key === "Escape" && o(!1);
          }
        }
      ),
      /* @__PURE__ */ m("span", { className: "text-default border-default bg-muted flex h-7 items-center rounded-r-sm border border-l-0 px-2 text-sm", children: "%" })
    ] }) }) : /* @__PURE__ */ de(
      "button",
      {
        className: "text-emphasis hover:bg-subtle decoration-emphasis flex h-7 items-center rounded-sm px-2 text-sm underline underline-offset-4",
        onClick: () => o(!0),
        children: [
          e.weight ?? 100,
          "%"
        ]
      }
    ) })
  ] });
}, Hiu = ({
  teamMembers: e,
  value: t,
  onChange: n,
  assignAllTeamMembers: o,
  assignRRMembersUsingSegment: r,
  teamId: i,
  queryValue: a
}) => {
  const [s, c] = it(!1), { t: l } = kt(), [u, d] = it(""), p = Kr() ? Uiu : Giu, { teamMembers: g, localWeightsInitialValues: f } = p({
    initialTeamMembers: e,
    assignRRMembersUsingSegment: r,
    teamId: i,
    queryValue: a,
    value: t
  }), [h, $] = it(f), [v, b] = it([]), [y, w] = it(!0), N = (T, D) => {
    $((A) => ({ ...A, [T]: D }));
  }, M = () => {
    const T = new Map(
      t.filter((A) => !A.isFixed).map((A) => [A.userId.toString(), A])
    ), D = g.map((A) => {
      const S = T.get(A.value);
      return S ? {
        ...S,
        userId: parseInt(A.value, 10),
        isFixed: (S == null ? void 0 : S.isFixed) ?? !1,
        priority: (S == null ? void 0 : S.priority) ?? 0,
        weight: h[A.value] ?? (S == null ? void 0 : S.weight) ?? 100,
        groupId: (S == null ? void 0 : S.groupId) ?? null
      } : null;
    }).filter(Boolean);
    n(D), c(!1);
  }, q = () => {
    const T = g.map((D) => ({
      id: D.value,
      name: D.label,
      email: D.email,
      weight: h[D.value] ?? 100
    }));
    qiu(T, "team-members-weights.csv");
  }, L = (T) => {
    var S;
    if (!((S = T.target.files) != null && S.length))
      return;
    const D = T.target.files[0], A = new FileReader();
    A.onload = async (E) => {
      var F;
      if (!((F = E.target) != null && F.result))
        return;
      const k = E.target.result.split(`
`), I = { ...h }, z = [];
      for (let P = 1; P < k.length; P++) {
        const O = k[P].trim();
        if (!O)
          continue;
        const [, , V, U] = O.split(",");
        if (!V || !U)
          continue;
        const H = g.find((le) => le.email === V);
        if (!H) {
          z.push({ email: V, error: l("member_not_found") });
          continue;
        }
        const J = parseInt(U);
        if (isNaN(J) || J <= 0) {
          z.push({ email: V, error: l("invalid_weight") });
          continue;
        }
        I[H.value] = J;
      }
      $(I), b(z), z.length > 0 ? ti(l("weights_updated_with_errors", { count: z.length }), "warning") : ti(l("weights_updated_from_csv"), "success"), T.target.value = "";
    }, A.readAsText(D);
  }, R = vn(() => g.map((T) => ({
    ...T,
    weight: h[T.value]
  })).filter(
    (T) => T.label.toLowerCase().includes(u.toLowerCase()) || T.email.toLowerCase().includes(u.toLowerCase())
  ).filter((T) => o || t.some((D) => !D.isFixed && D.userId === parseInt(T.value, 10))), [g, h, u, o, t]);
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ m(
      Jt,
      {
        color: "secondary",
        className: "-ml-2 -mt-2 mb-2 w-fit",
        onClick: () => {
          c(!0);
        },
        children: l("edit_team_member_weights")
      }
    ),
    /* @__PURE__ */ m(z$e, { open: s, onOpenChange: c, children: /* @__PURE__ */ m("form", { className: "flex h-full flex-col", children: /* @__PURE__ */ de(L$e, { children: [
      /* @__PURE__ */ de(M$e, { children: [
        /* @__PURE__ */ m(F$e, { children: l("edit_team_member_weights") }),
        /* @__PURE__ */ m("div", { className: "text-subtle text-sm", children: /* @__PURE__ */ m(
          Ld,
          {
            t: l,
            i18nKey: "weights_description",
            components: [
              /* @__PURE__ */ m(
                Ir,
                {
                  className: "underline underline-offset-2",
                  target: "_blank",
                  href: "https://cal.com/docs/enterprise-features/teams/round-robin-scheduling#weights",
                  children: "Learn more"
                },
                "weights_description"
              )
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ de(q$e, { className: "mt-4 flex h-full flex-col space-y-6 p-1", children: [
        /* @__PURE__ */ de("div", { className: "flex justify-start gap-2", children: [
          /* @__PURE__ */ de("label", { className: Ix({ color: "secondary" }), children: [
            /* @__PURE__ */ m(qt, { name: "upload", className: "mr-2 h-4 w-4" }),
            /* @__PURE__ */ m("input", { type: "file", accept: ".csv", className: "hidden", onChange: L }),
            l("upload")
          ] }),
          /* @__PURE__ */ m(Jt, { color: "secondary", StartIcon: "download", onClick: q, children: l("download") })
        ] }),
        /* @__PURE__ */ m(
          xr,
          {
            placeholder: l("search"),
            value: u,
            onChange: (T) => d(T.target.value.toLowerCase()),
            addOnLeading: /* @__PURE__ */ m(qt, { name: "search", className: "text-subtle h-4 w-4", "aria-hidden": "true", focusable: "false" })
          }
        ),
        /* @__PURE__ */ de("div", { className: "flex max-h-[80dvh] flex-col overflow-y-auto rounded-md border", children: [
          R.map((T) => /* @__PURE__ */ m(Wiu, { member: T, onWeightChange: N }, T.value)),
          R.length === 0 && /* @__PURE__ */ m("div", { className: "text-subtle py-4 text-center text-sm", children: l("no_members_found") })
        ] }),
        v.length > 0 && /* @__PURE__ */ de("div", { className: "mt-4", children: [
          /* @__PURE__ */ de(
            "button",
            {
              className: "flex w-full items-center justify-between rounded-md border bg-red-50 p-3 text-sm text-red-900",
              onClick: () => w(!y),
              children: [
                /* @__PURE__ */ de("div", { className: "flex items-center space-x-2", children: [
                  /* @__PURE__ */ m(qt, { name: "info", className: "h-4 w-4" }),
                  /* @__PURE__ */ m("span", { children: l("csv_upload_errors", { count: v.length }) })
                ] }),
                /* @__PURE__ */ m(qt, { name: "chevron-down", className: "h-4 w-4" })
              ]
            }
          ),
          y && /* @__PURE__ */ m("div", { className: "mt-2 space-y-2", children: v.map((T, D) => /* @__PURE__ */ de(
            "div",
            {
              className: "rounded-md border border-red-100 bg-red-50 p-3 text-sm text-red-900",
              children: [
                /* @__PURE__ */ de("strong", { children: [
                  T.email,
                  ":"
                ] }),
                " ",
                T.error
              ]
            },
            D
          )) })
        ] })
      ] }),
      /* @__PURE__ */ de(j$e, { children: [
        /* @__PURE__ */ m(R$e, { asChild: !0, children: /* @__PURE__ */ m(
          Jt,
          {
            color: "minimal",
            onClick: () => {
              $(f), d("");
            },
            children: l("cancel")
          }
        ) }),
        /* @__PURE__ */ m(Jt, { onClick: M, children: l("done") })
      ] })
    ] }) }) })
  ] });
}, Yiu = (e, t, n) => ({
  slug: t,
  hidden: !1,
  created: !1,
  owner: {
    id: e.id,
    name: e.name ?? "",
    email: e.email,
    username: e.username ?? "",
    membership: e.membership,
    eventTypeSlugs: e.eventTypes ?? [],
    avatar: e.avatar,
    profile: e.profile
  },
  value: `${e.id ?? ""}`,
  label: `${e.name || e.email || ""}${e.username ? "" : ` (${n})`}`
}), Kiu = ({
  options: e = [],
  value: t,
  onChange: n,
  customClassNames: o,
  ...r
}) => {
  var a, s;
  const { t: i } = kt();
  return /* @__PURE__ */ m("div", { className: xe("flex flex-col space-y-5", (a = o == null ? void 0 : o.assignToSelect) == null ? void 0 : a.container), children: /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ m(Ko, { className: (s = o == null ? void 0 : o.assignToSelect) == null ? void 0 : s.label, children: i("assign_to") }),
    /* @__PURE__ */ m(
      Fiu,
      {
        "aria-label": "assignment-dropdown",
        "data-testid": "assignment-dropdown",
        onChange: (c) => {
          n && n(
            c.map((l) => ({
              ...l
            }))
          );
        },
        value: t,
        options: e.filter((c) => !t.find((l) => l.owner.id.toString() === c.value)),
        controlShouldRenderValue: !1,
        customClassNames: o,
        ...r
      }
    )
  ] }) });
}, qoe = ({ t: e }) => /* @__PURE__ */ m(
  Ld,
  {
    t: e,
    i18nKey: "fixed_host_helper",
    components: [
      /* @__PURE__ */ m(
        Ir,
        {
          className: "underline underline-offset-2",
          target: "_blank",
          href: "https://cal.com/docs/enterprise-features/teams/round-robin-scheduling#fixed-hosts",
          children: "Learn more"
        },
        "fixed_host_helper"
      )
    ]
  }
), joe = ({
  teamId: e,
  teamMembers: t,
  value: n,
  onChange: o,
  assignAllTeamMembers: r,
  setAssignAllTeamMembers: i,
  isRoundRobinEvent: a = !1,
  customClassNames: s
}) => {
  const { t: c } = kt(), { getValues: l, setValue: u } = No(), d = a && l("hosts").some((h) => h.isFixed), [_, p] = it(d), g = Yt(() => {
    const h = l("hosts");
    u(
      "hosts",
      t.map(($) => {
        const v = h.find((b) => b.userId === parseInt($.value, 10));
        return {
          isFixed: !0,
          userId: parseInt($.value, 10),
          priority: (v == null ? void 0 : v.priority) ?? 2,
          weight: (v == null ? void 0 : v.weight) ?? 100,
          // if host was already added, retain scheduleId and groupId
          scheduleId: (v == null ? void 0 : v.scheduleId) || $.defaultScheduleId,
          groupId: (v == null ? void 0 : v.groupId) || null
        };
      }),
      { shouldDirty: !0 }
    );
  }, [l, u, t]), f = Yt(
    (h) => {
      if (!h) {
        const $ = l("hosts").filter((v) => !v.isFixed).sort((v, b) => (b.priority ?? 2) - (v.priority ?? 2));
        u("hosts", $, { shouldDirty: !0 });
      }
      p(h);
    },
    [l, u]
  );
  return /* @__PURE__ */ m("div", { className: xe("mt-5 rounded-lg", s == null ? void 0 : s.container), children: a ? /* @__PURE__ */ m(
    Jo,
    {
      "data-testid": "fixed-hosts-switch",
      toggleSwitchAtTheEnd: !0,
      title: c("fixed_hosts"),
      description: /* @__PURE__ */ m(qoe, { t: c }),
      checked: _ && !r,
      hideSwitch: r,
      labelClassName: xe("text-sm", s == null ? void 0 : s.label),
      descriptionClassName: xe("text-sm text-subtle", s == null ? void 0 : s.description),
      switchContainerClassName: s == null ? void 0 : s.container,
      onCheckedChange: f,
      childrenClassName: xe("lg:ml-0", s == null ? void 0 : s.children),
      children: /* @__PURE__ */ m("div", { className: "border-subtle flex flex-col gap-6 rounded-bl-md rounded-br-md border border-t-0 px-6", children: /* @__PURE__ */ m(
        v6,
        {
          "data-testid": "fixed-hosts-select",
          groupId: null,
          placeholder: c("add_a_member"),
          teamId: e,
          teamMembers: t,
          customClassNames: s == null ? void 0 : s.addMembers,
          value: n,
          onChange: o,
          assignAllTeamMembers: r,
          setAssignAllTeamMembers: i,
          automaticAddAllEnabled: !a,
          isFixed: !0,
          onActive: g
        }
      ) })
    }
  ) : /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de(
      "div",
      {
        className: xe(
          "border-subtle mt-5 rounded-t-md border p-6 pb-5",
          s == null ? void 0 : s.container
        ),
        children: [
          /* @__PURE__ */ m(Ko, { className: xe("mb-1 text-sm font-semibold", s == null ? void 0 : s.label), children: c("fixed_hosts") }),
          /* @__PURE__ */ m(
            "p",
            {
              className: xe(
                "text-subtle max-w-full break-words text-sm leading-tight",
                s == null ? void 0 : s.description
              ),
              children: /* @__PURE__ */ m(qoe, { t: c })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-md border border-t-0 px-6", children: /* @__PURE__ */ m(
      v6,
      {
        teamId: e,
        groupId: null,
        teamMembers: t,
        value: n,
        onChange: o,
        assignAllTeamMembers: r,
        setAssignAllTeamMembers: i,
        automaticAddAllEnabled: !a,
        isFixed: !0,
        customClassNames: s == null ? void 0 : s.addMembers,
        onActive: g
      }
    ) })
  ] }) });
}, Ziu = ({
  orgId: e,
  teamMembers: t,
  value: n,
  onChange: o,
  assignAllTeamMembers: r,
  setAssignAllTeamMembers: i,
  customClassNames: a,
  teamId: s,
  isSegmentApplicable: c
}) => {
  var R;
  const { t: l } = kt(), { setValue: u, getValues: d, control: _, formState: p } = No(), g = d("assignRRMembersUsingSegment"), f = cf({
    control: _,
    name: "isRRWeightsEnabled"
  }), h = cf({
    control: _,
    name: "rrSegmentQueryValue"
  }), $ = cf({
    control: _,
    name: "hostGroups"
  }), v = (T, D) => {
    D(T);
    const A = d("hosts"), S = A.filter((k) => k.isFixed), x = A.filter((k) => !k.isFixed).sort((k, I) => s0(k, I, T));
    u("hosts", [...S, ...x]);
  }, b = (T) => {
    const A = d("hosts").filter((E) => E.isFixed), S = T.sort((E, x) => s0(E, x, !0));
    u("hosts", [...A, ...S], { shouldDirty: !0 });
  }, y = Yt(() => {
    const T = d("hosts"), D = T.filter((S) => !S.isFixed), A = T.filter((S) => S.isFixed);
    if (($ == null ? void 0 : $.length) === 0 && D.length > 0) {
      const S = { id: ok(), name: "" }, E = { id: ok(), name: "" };
      u("hostGroups", [S, E], { shouldDirty: !0 });
      const k = D.map((I) => !I.groupId && !I.isFixed ? { ...I, groupId: S.id } : I);
      u("hosts", [...A, ...k], { shouldDirty: !0 });
    } else {
      const S = { id: ok(), name: "" }, E = [...$, S];
      u("hostGroups", E, { shouldDirty: !0 });
    }
    r && (u("assignAllTeamMembers", !1, { shouldDirty: !0 }), i(!1));
  }, [$, d, u, r, i]), w = Yt(
    (T, D) => {
      const A = ($ == null ? void 0 : $.map((S) => S.id === T ? { ...S, name: D } : S)) || [];
      u("hostGroups", A, { shouldDirty: !0 });
    },
    [$, u]
  ), N = Yt(
    (T) => {
      const D = ($ == null ? void 0 : $.filter((S) => S.id !== T)) || [];
      u("hostGroups", D, { shouldDirty: !0 });
      const A = n.filter((S) => S.groupId !== T);
      o(A), u("hosts", A, { shouldDirty: !0 });
    },
    [$, u, n, o]
  ), M = Yt(
    (T) => {
      const D = d("hosts");
      u(
        "hosts",
        t.map((A) => {
          const S = D.find((E) => E.userId === parseInt(A.value, 10));
          return {
            isFixed: !1,
            userId: parseInt(A.value, 10),
            priority: (S == null ? void 0 : S.priority) ?? 2,
            weight: (S == null ? void 0 : S.weight) ?? 100,
            // if host was already added, retain scheduleId and groupId
            scheduleId: (S == null ? void 0 : S.scheduleId) || A.defaultScheduleId,
            groupId: (S == null ? void 0 : S.groupId) || T
          };
        }),
        { shouldDirty: !0 }
      );
    },
    [d, u, t]
  ), q = ({
    groupId: T,
    containerClassName: D
  }) => /* @__PURE__ */ m(
    v6,
    {
      placeholder: l("add_a_member"),
      teamId: s,
      teamMembers: t,
      value: n,
      onChange: o,
      assignAllTeamMembers: r,
      setAssignAllTeamMembers: i,
      isSegmentApplicable: c,
      automaticAddAllEnabled: !0,
      isRRWeightsEnabled: f,
      isFixed: !1,
      groupId: T,
      containerClassName: D || (r ? "-mt-4" : ""),
      onActive: () => M(T),
      customClassNames: a == null ? void 0 : a.addMembers
    }
  ), L = () => n.filter((D) => !D.isFixed && !D.groupId).length === 0 ? null : /* @__PURE__ */ de("div", { className: "border-subtle my-4 rounded-md border p-4 pb-0", children: [
    /* @__PURE__ */ m("div", { className: "-mb-4 flex items-center justify-between", children: /* @__PURE__ */ m("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ m("span", { className: "text-default text-sm font-medium", children: `Group ${$.length + 1}` }) }) }),
    /* @__PURE__ */ m(q, { groupId: null })
  ] });
  return /* @__PURE__ */ de("div", { className: xe("rounded-lg"), children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: xe(
          "border-subtle mt-5 rounded-t-md border p-6 pb-5",
          a == null ? void 0 : a.container
        ),
        children: /* @__PURE__ */ de("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ m(Ko, { className: xe("mb-1 text-sm font-semibold", a == null ? void 0 : a.label), children: l("round_robin_hosts") }),
            /* @__PURE__ */ m(
              "p",
              {
                className: xe(
                  "text-subtle max-w-full break-words text-sm leading-tight",
                  a == null ? void 0 : a.description
                ),
                children: ($ == null ? void 0 : $.length) > 0 ? l("round_robin_groups_helper") : l("round_robin_helper")
              }
            )
          ] }),
          /* @__PURE__ */ m(Jt, { color: "secondary", size: "sm", StartIcon: "plus", onClick: y, children: l("add_group") })
        ] })
      }
    ),
    /* @__PURE__ */ de("div", { className: "border-subtle rounded-b-md border border-t-0 px-6 pt-4", children: [
      /* @__PURE__ */ m(nt, { children: /* @__PURE__ */ m(
        Bn,
        {
          name: "isRRWeightsEnabled",
          render: ({ field: { value: T, onChange: D } }) => {
            var A, S, E;
            return /* @__PURE__ */ m(
              Jo,
              {
                title: l("enable_weights"),
                description: /* @__PURE__ */ m(Uve, { t: l }),
                checked: T,
                switchContainerClassName: (A = a == null ? void 0 : a.enableWeights) == null ? void 0 : A.container,
                labelClassName: (S = a == null ? void 0 : a.enableWeights) == null ? void 0 : S.label,
                descriptionClassName: (E = a == null ? void 0 : a.enableWeights) == null ? void 0 : E.description,
                onCheckedChange: (x) => v(x, D),
                children: /* @__PURE__ */ m(
                  Hiu,
                  {
                    teamMembers: t,
                    value: n,
                    onChange: b,
                    assignAllTeamMembers: r,
                    assignRRMembersUsingSegment: g,
                    teamId: s,
                    queryValue: h
                  }
                )
              }
            );
          }
        }
      ) }),
      $.length ? /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(L, {}),
        $.map((T, D) => {
          const A = D + 1;
          return /* @__PURE__ */ de("div", { className: "border-subtle my-4 rounded-md border p-4 pb-0", children: [
            /* @__PURE__ */ de("div", { className: "-mb-4 flex items-center justify-between", children: [
              /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ m(
                "input",
                {
                  type: "text",
                  value: T.name ?? "",
                  onChange: (S) => w(T.id, S.target.value),
                  className: "border-none bg-transparent p-0 text-sm font-medium focus:outline-none focus:ring-0",
                  placeholder: `Group ${A}`
                }
              ) }),
              /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  onClick: () => N(T.id),
                  className: "text-subtle hover:text-default rounded p-1",
                  children: /* @__PURE__ */ m(qt, { name: "x", className: "h-4 w-4" })
                }
              )
            ] }),
            /* @__PURE__ */ m(q, { groupId: T.id })
          ] }, D);
        })
      ] }) : /* @__PURE__ */ m(q, { groupId: ((R = $[0]) == null ? void 0 : R.id) ?? null })
    ] })
  ] });
}, Xiu = ({
  childrenEventTypeOptions: e,
  assignAllTeamMembers: t,
  setAssignAllTeamMembers: n,
  customClassNames: o
}) => {
  const { setValue: r } = No();
  return /* @__PURE__ */ m(
    "div",
    {
      className: xe(
        "border-subtle mt-6 space-y-5 rounded-lg border px-4 py-6 sm:px-6",
        o == null ? void 0 : o.container
      ),
      children: /* @__PURE__ */ de("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ m(
          h6,
          {
            assignAllTeamMembers: t,
            setAssignAllTeamMembers: n,
            customClassNames: o == null ? void 0 : o.assignAllTeamMembers,
            onActive: () => r("children", e, { shouldDirty: !0 })
          }
        ),
        t ? /* @__PURE__ */ m(nt, {}) : /* @__PURE__ */ m(
          Bn,
          {
            name: "children",
            render: ({ field: { onChange: i, value: a } }) => /* @__PURE__ */ m(
              Kiu,
              {
                value: a,
                options: e,
                onChange: i,
                customClassNames: o == null ? void 0 : o.childrenEventTypesList
              }
            )
          }
        )
      ] })
    }
  );
}, Jiu = ({
  orgId: e,
  teamId: t,
  teamMembers: n,
  assignAllTeamMembers: o,
  setAssignAllTeamMembers: r,
  customClassNames: i,
  isSegmentApplicable: a
}) => {
  const {
    control: s,
    setValue: c,
    getValues: l,
    formState: { submitCount: u }
  } = No(), d = cf({
    control: s,
    name: "schedulingType"
  }), _ = xt(null);
  yt(() => {
    var g;
    if (!_.current || ((g = _.current) == null ? void 0 : g.submitCount) !== u) {
      _.current = { hosts: l("hosts"), schedulingType: d, submitCount: u };
      return;
    }
    c(
      "hosts",
      _.current.schedulingType === d ? _.current.hosts : [],
      { shouldDirty: !0 }
    );
  }, [d, c, l, u]);
  const p = (g) => {
    const f = l("hosts");
    return g.map((h) => {
      const $ = f.find((v) => v.userId === h.userId);
      return $ ? {
        ...h,
        scheduleId: $.scheduleId,
        groupId: $.groupId
      } : h;
    });
  };
  return /* @__PURE__ */ m(
    Bn,
    {
      name: "hosts",
      render: ({ field: { onChange: g, value: f } }) => {
        const h = {
          COLLECTIVE: /* @__PURE__ */ m(
            joe,
            {
              teamId: t,
              teamMembers: n,
              value: f,
              onChange: ($) => {
                g([...p($)]);
              },
              assignAllTeamMembers: o,
              setAssignAllTeamMembers: r,
              customClassNames: i == null ? void 0 : i.fixedHosts
            }
          ),
          ROUND_ROBIN: /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(
              joe,
              {
                teamId: t,
                teamMembers: n,
                value: f,
                onChange: ($) => {
                  g([...f.filter((v) => !v.isFixed), ...p($)]);
                },
                assignAllTeamMembers: o,
                setAssignAllTeamMembers: r,
                isRoundRobinEvent: !0,
                customClassNames: i == null ? void 0 : i.fixedHosts
              }
            ),
            /* @__PURE__ */ m(
              Ziu,
              {
                orgId: e,
                teamId: t,
                teamMembers: n,
                value: f,
                onChange: ($) => {
                  const v = [...f.filter((b) => b.isFixed), ...p($)];
                  g(v);
                },
                assignAllTeamMembers: o,
                setAssignAllTeamMembers: r,
                customClassNames: i == null ? void 0 : i.roundRobinHosts,
                isSegmentApplicable: a
              }
            )
          ] }),
          MANAGED: /* @__PURE__ */ m(nt, {})
        };
        return d ? h[d] : /* @__PURE__ */ m(nt, {});
      }
    }
  );
}, Qiu = ({
  team: e,
  teamMembers: t,
  eventType: n,
  customClassNames: o,
  orgId: r,
  isSegmentApplicable: i
}) => {
  var N, M, q, L, R, T, D;
  const { t: a } = kt(), s = [
    {
      value: "COLLECTIVE",
      label: a("collective")
      // description: t("collective_description"),
    },
    {
      value: "ROUND_ROBIN",
      label: a("round_robin")
      // description: t("round_robin_description"),
    }
  ], c = (A) => {
    var S;
    return !!((S = n.team) != null && S.parentId) || !!A.username;
  }, l = t.filter(c).map((A) => Niu(A, a("pending"))), u = t.filter(c).map((A) => Yiu(
    {
      ...A,
      eventTypes: A.eventTypes.filter(
        (S) => S !== n.slug || !n.children.some((E) => E.owner.id === A.id)
      )
    },
    n.slug,
    a("pending")
  )), d = n.schedulingType === Bs.MANAGED, { getValues: _, setValue: p, control: g } = No(), [f, h] = it(
    _("assignAllTeamMembers") ?? !1
  ), $ = () => {
    p("assignRRMembersUsingSegment", !1, { shouldDirty: !0 }), p("assignAllTeamMembers", !1, { shouldDirty: !0 }), h(!1);
  }, v = Yt(
    (A, S) => {
      A && (S(A), $());
    },
    [p, h]
  ), b = (A, S) => {
    S(A === "loadBalancing" ? 3 : null);
  }, y = cf({
    control: g,
    name: "schedulingType"
  }), w = cf({
    control: g,
    name: "hostGroups"
  });
  return /* @__PURE__ */ de("div", { children: [
    e && !d && /* @__PURE__ */ de(nt, { children: [
      /* @__PURE__ */ de(
        "div",
        {
          className: xe(
            "border-subtle flex flex-col rounded-md",
            (N = o == null ? void 0 : o.assignmentType) == null ? void 0 : N.container
          ),
          children: [
            /* @__PURE__ */ de("div", { className: "border-subtle rounded-t-md border p-6 pb-5", children: [
              /* @__PURE__ */ m(
                Ko,
                {
                  className: xe("mb-1 text-sm font-semibold", (M = o == null ? void 0 : o.assignmentType) == null ? void 0 : M.label),
                  children: a("assignment")
                }
              ),
              /* @__PURE__ */ m(
                "p",
                {
                  className: xe(
                    "text-subtle max-w-full break-words text-sm leading-tight",
                    (q = o == null ? void 0 : o.assignmentType) == null ? void 0 : q.description
                  ),
                  children: a("assignment_description")
                }
              )
            ] }),
            /* @__PURE__ */ de(
              "div",
              {
                className: xe(
                  "border-subtle rounded-b-md border border-t-0 p-6",
                  (R = (L = o == null ? void 0 : o.assignmentType) == null ? void 0 : L.schedulingTypeSelect) == null ? void 0 : R.container
                ),
                children: [
                  /* @__PURE__ */ m(Ko, { className: (D = (T = o == null ? void 0 : o.assignmentType) == null ? void 0 : T.schedulingTypeSelect) == null ? void 0 : D.label, children: a("scheduling_type") }),
                  /* @__PURE__ */ m(
                    Bn,
                    {
                      name: "schedulingType",
                      render: ({ field: { value: A, onChange: S } }) => {
                        var E, x, k, I;
                        return /* @__PURE__ */ m(
                          Di,
                          {
                            options: s,
                            value: s.find((z) => z.value === A),
                            className: xe(
                              "w-full",
                              (x = (E = o == null ? void 0 : o.assignmentType) == null ? void 0 : E.schedulingTypeSelect) == null ? void 0 : x.select
                            ),
                            innerClassNames: (I = (k = o == null ? void 0 : o.assignmentType) == null ? void 0 : k.schedulingTypeSelect) == null ? void 0 : I.innerClassNames,
                            onChange: (z) => v(z == null ? void 0 : z.value, S)
                          }
                        );
                      }
                    }
                  )
                ]
              }
            )
          ]
        }
      ),
      y === "ROUND_ROBIN" && /* @__PURE__ */ de("div", { className: "border-subtle mt-4 flex flex-col rounded-md", children: [
        /* @__PURE__ */ de("div", { className: "border-subtle rounded-t-md border p-6 pb-5", children: [
          /* @__PURE__ */ m(Ko, { className: "mb-1 text-sm font-semibold", children: a("rr_distribution_method") }),
          /* @__PURE__ */ m("p", { className: "text-subtle max-w-full break-words text-sm leading-tight", children: a("rr_distribution_method_description") })
        ] }),
        /* @__PURE__ */ de("div", { className: "border-subtle rounded-b-md border border-t-0 p-6", children: [
          /* @__PURE__ */ m(
            Bn,
            {
              name: "maxLeadThreshold",
              render: ({ field: { value: A, onChange: S } }) => {
                var E, x, k, I;
                return /* @__PURE__ */ de(
                  zj,
                  {
                    onValueChange: (z) => b(z, S),
                    className: "mt-1 flex flex-col gap-4",
                    children: [
                      /* @__PURE__ */ de(
                        Eg,
                        {
                          value: "maximizeAvailability",
                          checked: A === null,
                          className: "w-full text-sm",
                          classNames: { container: "w-full" },
                          children: [
                            /* @__PURE__ */ m("strong", { className: "mb-1 block", children: a("rr_distribution_method_availability_title") }),
                            /* @__PURE__ */ m("p", { children: a("rr_distribution_method_availability_description") })
                          ]
                        }
                      ),
                      (E = n.team) != null && E.rrTimestampBasis && ((x = n.team) == null ? void 0 : x.rrTimestampBasis) !== YG.CREATED_AT || (w == null ? void 0 : w.length) > 1 ? /* @__PURE__ */ m(
                        Sr,
                        {
                          content: (k = n.team) != null && k.rrTimestampBasis && ((I = n.team) == null ? void 0 : I.rrTimestampBasis) !== YG.CREATED_AT ? a("rr_load_balancing_disabled") : a("rr_load_balancing_disabled_with_groups"),
                          children: /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ de(
                            Eg,
                            {
                              value: "loadBalancing",
                              checked: A !== null,
                              className: "text-sm",
                              disabled: !0,
                              classNames: { container: "w-full" },
                              children: [
                                /* @__PURE__ */ m("strong", { className: "mb-1", children: a("rr_distribution_method_balanced_title") }),
                                /* @__PURE__ */ m("p", { children: a("rr_distribution_method_balanced_description") })
                              ]
                            }
                          ) })
                        }
                      ) : /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ de(
                        Eg,
                        {
                          value: "loadBalancing",
                          checked: A !== null,
                          className: "text-sm",
                          classNames: { container: "w-full" },
                          children: [
                            /* @__PURE__ */ m("strong", { className: "mb-1", children: a("rr_distribution_method_balanced_title") }),
                            /* @__PURE__ */ m("p", { children: a("rr_distribution_method_balanced_description") })
                          ]
                        }
                      ) })
                    ]
                  }
                );
              }
            }
          ),
          /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(
            Bn,
            {
              name: "includeNoShowInRRCalculation",
              render: ({ field: { value: A, onChange: S } }) => /* @__PURE__ */ m(
                Jo,
                {
                  title: a("include_no_show_in_rr_calculation"),
                  labelClassName: "mt-1.5",
                  checked: A,
                  onCheckedChange: (E) => S(E)
                }
              )
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ m(
        Jiu,
        {
          orgId: r,
          isSegmentApplicable: i,
          teamId: e.id,
          assignAllTeamMembers: f,
          setAssignAllTeamMembers: h,
          teamMembers: l,
          customClassNames: o == null ? void 0 : o.hosts
        }
      )
    ] }),
    e && d && /* @__PURE__ */ m(
      Xiu,
      {
        assignAllTeamMembers: f,
        setAssignAllTeamMembers: h,
        childrenEventTypeOptions: u,
        customClassNames: o == null ? void 0 : o.childrenEventTypes
      }
    )
  ] });
}, eau = (e) => /* @__PURE__ */ m(Qiu, { ...e, isSegmentApplicable: !1 }), tau = eau, nau = Bt(function(t, n) {
  const {
    tabs: o = ["setup", "availability", "team", "limits", "advanced", "recurring", "payments"],
    onSuccess: r,
    onError: i,
    onDeleteSuccess: a,
    onDeleteError: s,
    id: c,
    allowDelete: l = !0,
    customClassNames: u,
    disableToasts: d = !1,
    isDryRun: _ = !1,
    onFormStateChange: p,
    ...g
  } = t, { t: f } = kt(), { toast: h } = wf(), { organizationId: $ } = cr(), v = xt(!1), b = xt(!1), { eventType: y, locationOptions: w, team: N, teamMembers: M, destinationCalendar: q } = g, [L, R] = it([]), { data: T, isLoading: D } = Ev(), A = () => {
    d || H(f("event_type_deleted_successfully")), v.current = !0, R([]), a == null || a();
  }, S = (ie) => {
    d || H(ie.message), s == null || s(ie.message);
  }, E = m7l({
    onSuccess: async () => {
      A();
    },
    onError: (ie) => {
      S(ie);
    }
  }), x = f7l({
    onSuccess: async () => {
      A();
    },
    onError: (ie) => {
      S(ie);
    }
  }), k = h7l({
    onSuccess: async () => {
      var _e, he;
      const ie = I.getValues();
      ie.children = ie.children.map((be) => ({
        ...be,
        created: !0
      })), ie.assignAllTeamMembers = ie.assignAllTeamMembers || !1, I.reset(ie), d || h({ description: f("event_type_updated_successfully", { eventTypeTitle: y.title }) }), r == null || r(ie), (he = (_e = P.current) == null ? void 0 : _e.onSuccess) == null || he.call(_e);
    },
    async onSettled() {
    },
    onError: (ie) => {
      var me, ne;
      const _e = I.getValues(), he = ie == null ? void 0 : ie.message, be = f(he || ie.message);
      d || h({ description: be }), i == null || i(_e, ie);
      const Q = new Error(be);
      (ne = (me = P.current) == null ? void 0 : me.onError) == null || ne.call(me, Q);
    },
    teamId: N == null ? void 0 : N.id
  }), { form: I, handleSubmit: z } = z7l({
    eventType: y,
    onSubmit: (ie) => {
      var _e, he;
      _ ? (h({ description: f("event_type_updated_successfully", { eventTypeTitle: y.title }) }), (he = (_e = P.current) == null ? void 0 : _e.onSuccess) == null || he.call(_e)) : k.mutate(ie);
    },
    onFormStateChange: p
  }), F = xt(null), P = xt({}), O = Yt(
    (ie) => {
      ie && (P.current = ie), F.current ? F.current.click() : I.handleSubmit((_e) => {
        var he, be;
        try {
          z(_e), (he = ie == null ? void 0 : ie.onSuccess) == null || he.call(ie);
        } catch (Q) {
          (be = ie == null ? void 0 : ie.onError) == null || be.call(ie, Q);
        }
      })();
    },
    [z, I]
  ), V = Yt(async () => ({
    isValid: await I.trigger(),
    errors: I.formState.errors
  }), [I]);
  fre(
    n,
    () => ({
      validateForm: V,
      handleFormSubmit: O
    }),
    [V, O]
  );
  const U = I.watch("slug") ?? y.slug, H = (ie, _e) => {
    d || h({ description: ie });
  }, J = {
    setup: o.includes("setup") ? /* @__PURE__ */ m(
      rXl,
      {
        eventType: y,
        locationOptions: w,
        team: N,
        teamMembers: M,
        destinationCalendar: q,
        customClassNames: u == null ? void 0 : u.eventSetupTab
      }
    ) : /* @__PURE__ */ m(nt, {}),
    availability: o.includes("availability") ? /* @__PURE__ */ m(
      yZl,
      {
        eventType: y,
        isTeamEvent: !!N,
        user: T == null ? void 0 : T.data,
        teamId: N == null ? void 0 : N.id,
        customClassNames: u == null ? void 0 : u.eventAvailabilityTab
      }
    ) : /* @__PURE__ */ m(nt, {}),
    team: o.includes("team") ? /* @__PURE__ */ m(
      tau,
      {
        team: N,
        eventType: y,
        teamMembers: M,
        customClassNames: u == null ? void 0 : u.eventAssignmentTab,
        orgId: $
      }
    ) : /* @__PURE__ */ m(nt, {}),
    advanced: o.includes("advanced") ? /* @__PURE__ */ m(
      iZl,
      {
        eventType: y,
        team: N,
        user: T == null ? void 0 : T.data,
        isUserLoading: D,
        showToast: H,
        customClassNames: u == null ? void 0 : u.eventAdvancedTab
      }
    ) : /* @__PURE__ */ m(nt, {}),
    payments: o.includes("payments") ? /* @__PURE__ */ m(jZl, { eventType: y }) : /* @__PURE__ */ m(nt, {}),
    limits: o.includes("limits") ? /* @__PURE__ */ m(
      IZl,
      {
        eventType: y,
        customClassNames: u == null ? void 0 : u.eventLimitsTab
      }
    ) : /* @__PURE__ */ m(nt, {}),
    instant: /* @__PURE__ */ m(nt, {}),
    recurring: o.includes("recurring") ? /* @__PURE__ */ m(
      GZl,
      {
        eventType: y,
        customClassNames: u == null ? void 0 : u.eventRecurringTab
      }
    ) : /* @__PURE__ */ m(nt, {}),
    apps: /* @__PURE__ */ m(nt, {}),
    workflows: /* @__PURE__ */ m(nt, {}),
    webhooks: /* @__PURE__ */ m(nt, {}),
    ai: /* @__PURE__ */ m(nt, {})
  };
  P7l({
    watchTrigger: null,
    isTeamEventTypeDeleted: v.current,
    isleavingWithoutAssigningHosts: b.current,
    isTeamEventType: !!N,
    assignedUsers: y.children,
    hosts: y.hosts,
    assignAllTeamMembers: y.assignAllTeamMembers,
    isManagedEventType: y.schedulingType === Bs.MANAGED,
    onError: () => {
    },
    onStart: () => {
    },
    onEnd: () => {
    }
  });
  const le = () => {
    l && !_ && (v.current = !0, N != null && N.id ? x.mutate({ eventTypeId: c, teamId: N.id }) : E.mutate(c)), _ && A();
  }, ae = (ie) => {
    R(ie);
  }, { tabsNavigation: Y, currentTab: re } = D7l({
    formMethods: I,
    eventType: y,
    team: N,
    tabs: o
  });
  return /* @__PURE__ */ m(is, { customClassName: u == null ? void 0 : u.atomsWrapper, children: /* @__PURE__ */ m(
    _7l,
    {
      ...g,
      tabMap: J,
      onDelete: le,
      onConflict: ae,
      handleSubmit: z,
      formMethods: I,
      isUpdating: k.isPending,
      isPlatform: !0,
      tabName: re,
      tabsNavigation: Y,
      allowDelete: l,
      saveButtonRef: F,
      children: /* @__PURE__ */ m(nt, { children: L.length ? /* @__PURE__ */ m(
        p7l,
        {
          slugExistsChildrenDialogOpen: L,
          isPending: I.formState.isSubmitting,
          onOpenChange: () => {
            R([]);
          },
          slug: U,
          onConfirm: (ie) => {
            ie.preventDefault(), z(I.getValues()), R([]);
          }
        }
      ) : null })
    }
  ) });
}), Esu = Bt(function(t, n) {
  const {
    id: o,
    tabs: r,
    onSuccess: i,
    onError: a,
    onDeleteSuccess: s,
    onDeleteError: c,
    allowDelete: l = !0,
    customClassNames: u,
    isDryRun: d,
    disableToasts: _,
    onFormStateChange: p
  } = t, { data: g } = g7l(o), f = qc();
  return yt(() => () => {
    g && (f.invalidateQueries({
      queryKey: [J5, o]
    }), f.resetQueries({
      queryKey: [J5, o]
    }));
  }, [f, o, g]), g ? /* @__PURE__ */ m(Wy, { children: /* @__PURE__ */ m(
    nau,
    {
      ...g,
      id: o,
      tabs: r,
      onSuccess: i,
      onError: a,
      onDeleteSuccess: s,
      onDeleteError: c,
      allowDelete: l,
      customClassNames: u,
      isDryRun: d,
      onFormStateChange: p,
      ref: n,
      disableToasts: _
    }
  ) }) : null;
});
function oau(e) {
  return /* @__PURE__ */ m(Ss, { name: "Account check", open: e.open, onOpenChange: e.onOpenChange, children: /* @__PURE__ */ m(
    Ya,
    {
      type: "creation",
      title: "Connecting with MS Teams requires a work/school Microsoft account.",
      description: "If you continue with a personal account you will receive an error",
      children: /* @__PURE__ */ m(Wu, { showDivider: !0, className: "mt-6", children: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m(
          Gs,
          {
            type: "button",
            color: "secondary",
            tabIndex: -1,
            onClick: () => {
              var t;
              (t = e.onOpenChange) == null || t.call(e, !1);
            },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ m(Jt, { type: "button", onClick: e.handleSubmit, children: "Continue" })
      ] }) })
    }
  ) });
}
const rau = (e) => /* @__PURE__ */ m(
  Fbe,
  {
    wrapperClassName: "border-t border-subtle p-6",
    componentMap: hil,
    ...e
  }
);
function iau({
  locationType: e,
  setLocationType: t,
  onSuccess: n,
  handleUpdateUserDefaultConferencingApp: o
}) {
  const { t: r } = kt(), i = Xl(e.type), a = W_({
    resolver: K0(
      oe.object({ link: oe.string().regex(new RegExp((i == null ? void 0 : i.urlRegExp) ?? "")) })
    )
  });
  return /* @__PURE__ */ m(Ss, { open: !!e, onOpenChange: () => t(void 0), children: /* @__PURE__ */ m(
    Ya,
    {
      title: r("default_app_link_title"),
      description: r("default_app_link_description"),
      type: "creation",
      Icon: "circle-alert",
      children: /* @__PURE__ */ m(
        Y_,
        {
          form: a,
          handleSubmit: (s) => {
            o({
              appSlug: e.slug,
              appLink: s.link,
              onSuccessCallback: () => {
                n();
              },
              onErrorCallback: () => {
                ti("Invalid App Link Format", "error");
              }
            }), t(void 0);
          },
          children: /* @__PURE__ */ de(nt, { children: [
            /* @__PURE__ */ m(
              xr,
              {
                type: "text",
                required: !0,
                ...a.register("link"),
                placeholder: e.organizerInputPlaceholder ?? "",
                label: e.label ?? ""
              }
            ),
            /* @__PURE__ */ de(Wu, { showDivider: !0, className: "mt-8", children: [
              /* @__PURE__ */ m(Gs, {}),
              /* @__PURE__ */ m(Jt, { color: "primary", type: "submit", children: r("save") })
            ] })
          ] })
        }
      )
    }
  ) });
}
function aau({
  credentialId: e
}) {
  return typeof e == "number" && e < 0;
}
const sau = aau, cau = ({
  data: e,
  handleDisconnect: t,
  variant: n,
  listClassName: o,
  defaultConferencingApp: r,
  handleUpdateUserDefaultConferencingApp: i,
  handleBulkUpdateDefaultLocation: a,
  isBulkUpdateDefaultLocationPending: s,
  eventTypes: c,
  isEventTypesFetching: l,
  handleConnectDisconnectIntegrationMenuToggle: u,
  handleBulkEditDialogToggle: d
}) => {
  const [_, p] = it(!1), [g, f] = it(
    void 0
  ), h = Yt(() => {
    p(!0), ti("Default app updated successfully", "success");
  }, []), $ = ({ item: w }) => {
    var q, L, R;
    const N = w == null ? void 0 : w.slug, M = N === (r == null ? void 0 : r.appSlug) || N === "daily-video" && !(r != null && r.appSlug);
    return /* @__PURE__ */ m(
      Hve,
      {
        description: w.description,
        title: w.name,
        logo: w.logo,
        isDefault: M,
        shouldHighlight: !0,
        slug: w.slug,
        invalidCredential: w != null && w.invalidCredentialIds ? w.invalidCredentialIds.length > 0 : !1,
        credentialOwner: w == null ? void 0 : w.credentialOwner,
        actions: (q = w.credentialOwner) != null && q.readOnly ? null : /* @__PURE__ */ m("div", { className: "flex justify-end", children: /* @__PURE__ */ de(jd, { modal: !1, children: [
          /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(Jt, { StartIcon: "ellipsis", variant: "icon", color: "secondary" }) }),
          /* @__PURE__ */ de(Yu, { children: [
            !M && n === "conferencing" && /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
              ba,
              {
                type: "button",
                color: "secondary",
                StartIcon: "video",
                onClick: () => {
                  var D;
                  const T = iil(((D = w == null ? void 0 : w.locationOption) == null ? void 0 : D.value) ?? "");
                  (T == null ? void 0 : T.linkType) === "static" ? f({ ...T, slug: N }) : i({
                    appSlug: N,
                    onSuccessCallback: () => p(!0),
                    onErrorCallback: () => {
                    }
                  });
                },
                children: y("set_as_default")
              }
            ) }),
            /* @__PURE__ */ m(
              lau,
              {
                credentialId: ((L = w.credentialOwner) == null ? void 0 : L.credentialId) || w.userCredentialIds[0],
                type: w.type,
                app: w.slug,
                isGlobal: w.isGlobal,
                installed: !0,
                invalidCredentialIds: w.invalidCredentialIds,
                handleDisconnect: t,
                teamId: w.credentialOwner ? (R = w.credentialOwner) == null ? void 0 : R.teamId : void 0,
                handleConnectDisconnectIntegrationMenuToggle: u
              }
            )
          ] })
        ] }) }),
        children: /* @__PURE__ */ m(rau, { slug: w.slug })
      },
      w.name
    );
  }, b = e.items.filter((w) => w.teams.length).map((w) => {
    const N = [];
    w.userCredentialIds.length && N.push(/* @__PURE__ */ m($, { item: w }));
    for (const M of w.teams)
      M && N.push(
        /* @__PURE__ */ m(
          $,
          {
            item: {
              ...w,
              credentialOwner: {
                name: M.name,
                avatar: M.logoUrl,
                teamId: M.teamId,
                credentialId: M.credentialId,
                readOnly: !M.isAdmin
              }
            }
          }
        )
      );
    return N;
  }), { t: y } = kt();
  return /* @__PURE__ */ de(nt, { children: [
    /* @__PURE__ */ de(Wj, { className: o, children: [
      b.map((w) => w.map((N) => N)),
      e.items.filter((w) => w.invalidCredentialIds).map((w, N) => {
        if (!w.teams.length)
          return /* @__PURE__ */ m($, { item: w }, N);
      })
    ] }),
    g && /* @__PURE__ */ m(
      iau,
      {
        locationType: g,
        setLocationType: () => f(void 0),
        onSuccess: h,
        handleUpdateUserDefaultConferencingApp: i
      }
    ),
    _ && /* @__PURE__ */ m(
      G_e,
      {
        bulkUpdateFunction: a,
        open: _,
        setOpen: p,
        isPending: s,
        description: y("default_conferencing_bulk_description"),
        eventTypes: c,
        isEventTypesFetching: l,
        handleBulkEditDialogToggle: d
      }
    )
  ] });
};
function lau(e) {
  const { type: t, credentialId: n, isGlobal: o, installed: r, handleDisconnect: i, teamId: a, app: s } = e, { t: c } = kt();
  return n || t === "stripe_payment" || o ? /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(
    ba,
    {
      color: "destructive",
      onClick: () => i(n, s, a),
      disabled: o || sau({ credentialId: n }),
      StartIcon: "trash",
      children: c("remove_app")
    }
  ) }) : r ? /* @__PURE__ */ m(
    Yge,
    {
      type: t,
      render: (l) => /* @__PURE__ */ m(Jt, { color: "secondary", ...l, "data-testid": "integration-connection-button", children: c("install") }),
      onChanged: e.handleConnectDisconnectIntegrationMenuToggle
    }
  ) : /* @__PURE__ */ m("div", { className: "flex items-center truncate", children: /* @__PURE__ */ m(Us, { severity: "warning", title: c("not_installed") }) });
}
function uau({
  credentialId: e,
  app: t,
  isOpen: n,
  handleModelClose: o,
  teamId: r,
  handleRemoveApp: i
}) {
  const { t: a } = kt(), s = Kr();
  return /* @__PURE__ */ m(Ss, { open: n, onOpenChange: o, children: /* @__PURE__ */ m(
    pv,
    {
      variety: "danger",
      title: a("remove_app"),
      confirmBtnText: a("yes_remove_app"),
      onConfirm: () => {
        s && t && e ? i({ credentialId: e, app: t, teamId: r, callback: () => o() }) : e && i({ credentialId: e, teamId: r, callback: () => o() });
      },
      children: /* @__PURE__ */ m("p", { className: "mt-5", children: a("are_you_sure_you_want_to_remove_this_app") })
    }
  ) });
}
function dau({
  children: e,
  title: t,
  description: n,
  CTA: o,
  ctaClassName: r,
  borderInShellHeader: i,
  backButton: a
}) {
  return /* @__PURE__ */ de("div", { children: [
    /* @__PURE__ */ m(
      "header",
      {
        className: xe(
          "border-subtle mx-auto flex justify-between",
          i && "rounded-t-lg border px-4 py-6 sm:px-6",
          i === void 0 && "mb-8 border-b pb-8"
        ),
        children: /* @__PURE__ */ de("div", { className: "flex w-full items-center justify-between gap-2", children: [
          /* @__PURE__ */ de("div", { className: "flex items-center", children: [
            a && /* @__PURE__ */ m("a", { href: "javascript:history.back()", children: /* @__PURE__ */ m(qt, { name: "arrow-left", className: "mr-7" }) }),
            /* @__PURE__ */ de("div", { children: [
              t ? /* @__PURE__ */ m("h1", { className: "font-cal text-emphasis mb-1 text-xl font-semibold leading-5 tracking-wide", children: t }) : /* @__PURE__ */ m("div", { className: "bg-emphasis mb-1 h-5 w-24 animate-pulse rounded-lg" }),
              n ? /* @__PURE__ */ m("p", { className: "text-default text-sm ltr:mr-4 rtl:ml-4", children: n }) : /* @__PURE__ */ m("div", { className: "bg-emphasis h-5 w-32 animate-pulse rounded-lg" })
            ] })
          ] }),
          /* @__PURE__ */ m("div", { className: xe("flex-shrink-0", r), children: o })
        ] })
      }
    ),
    /* @__PURE__ */ m(hT, { fallback: /* @__PURE__ */ m(qt, { name: "loader", className: "mx-auto my-5 animate-spin" }), children: e })
  ] });
}
const _au = ({
  onSuccess: e = () => {
  },
  onError: t = () => {
  },
  onSettled: n = () => {
  },
  teamId: o
}) => {
  const { organizationId: r } = cr();
  return Hr({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i || i.length < 1)
        throw new Error("Event type ids are required");
      let a = `/atoms/${rs.eventTypes}/bulk-update-to-default-location`;
      return o && (a = `/atoms/organizations/${r}/teams/${o}/${rs.eventTypes}/bulk-update-to-default-location`), At == null ? void 0 : At.patch(a, { eventTypeIds: i }).then((s) => {
        if (s.data.status === Nn)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, pau = "use-get-event-types", mau = (e, t = !1) => {
  const { isInit: n, accessToken: o, organizationId: r } = cr();
  let i = "/atoms/event-types";
  return e && (i = `/atoms/organizations/${r}/teams/${e}/event-types`), mr({
    queryKey: [pau, e, r],
    queryFn: () => At == null ? void 0 : At.get(i).then((a) => {
      if (a.data.status === Nn)
        return a.data.data;
      throw new Error(a.data.error.message);
    }),
    enabled: n && !!o && !t
  });
}, Lw = "get-installed-conferencing-apps", fau = (e) => {
  const { isInit: t, accessToken: n, organizationId: o } = cr();
  let r = "/atoms/conferencing";
  return e && (r = `/atoms/organizations/${o}/teams/${e}/conferencing`), mr({
    queryKey: [Lw, e, o],
    queryFn: () => At == null ? void 0 : At.get(r).then((i) => {
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error(i.data.error.message);
    }).catch(() => {
      throw new Error("Failed to get installed conferencing apps");
    }),
    enabled: t && !!n
  });
}, gau = ({ returnTo: e, onErrorReturnTo: t, teamId: n }) => {
  const { organizationId: o } = cr();
  let r = `conferencing/${zb}/oauth/auth-url`;
  n && (r = `organizations/${o}/teams/${n}/conferencing/${zb}/oauth/auth-url`);
  const i = new URLSearchParams();
  e && i.append("returnTo", e), t && i.append("onErrorReturnTo", t);
  const a = i.toString() ? `${r}?${i.toString()}` : r;
  return mr({
    queryKey: ["get-zoom-auth-url", n, o],
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => At == null ? void 0 : At.get(a).then(({ data: s }) => {
      if (s.status === Nn)
        return s.data.url;
      if (s.status === Ig)
        throw new Error(s.error.message);
      return "";
    })
  });
}, hau = ({
  returnTo: e,
  onErrorReturnTo: t,
  teamId: n
}) => {
  const { organizationId: o } = cr();
  let r = `conferencing/${Rb}/oauth/auth-url`;
  n && (r = `organizations/${o}/teams/${n}/conferencing/${Rb}/oauth/auth-url`);
  const i = new URLSearchParams();
  e && i.append("returnTo", e), t && i.append("onErrorReturnTo", t);
  const a = i.toString() ? `${r}?${i.toString()}` : r;
  return mr({
    queryKey: ["get-office365-auth-url", n, o],
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => At == null ? void 0 : At.get(a).then(({ data: s }) => {
      if (s.status === Nn)
        return s.data.url;
      if (s.status === Ig)
        throw new Error(s.error.message);
      return "";
    })
  });
}, vau = ({ onSuccess: e, onError: t, teamId: n, returnTo: o, onErrorReturnTo: r } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const { organizationId: i } = cr();
  return Hr({
    mutationFn: (a) => {
      let s = `/conferencing/${a}/connect`;
      n && (s = `/organizations/${i}/teams/${n}/conferencing/${a}/connect`);
      const c = new URLSearchParams();
      o && c.append("returnTo", o), r && c.append("onErrorReturnTo", r);
      const l = c.toString() ? `${s}?${c.toString()}` : s;
      return At == null ? void 0 : At.post(l).then((u) => {
        if (u.data.status === Nn)
          return { status: u.data };
        throw new Error(u.data.error.message);
      });
    },
    onSuccess: e,
    onError: t
  });
}, bau = (e) => {
  const { refetch: t } = gau(e), { refetch: n } = hau(e), o = vau(e);
  return { connect: async (i) => {
    switch (i) {
      case zb:
        const a = await t();
        a.data && (window.location.href = a.data);
        break;
      case Rb:
        const s = await n();
        s.data && (window.location.href = s.data);
        break;
      case IE:
        o.mutate(i);
    }
  } };
}, yau = ({ onSuccess: e, onError: t, onSettled: n, teamId: o }) => {
  const { organizationId: r } = cr();
  return Hr({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i)
        throw new Error("app is required");
      let a = `/conferencing/${i}/disconnect`;
      return o && (a = `/organizations/${r}/teams/${o}/conferencing/${i}/disconnect`), At == null ? void 0 : At.delete(a).then((s) => {
        if (s.data.status !== Nn)
          throw new Error(s.data.error.message);
      });
    }
  });
}, Mw = "use-get-default-conferencing-app", $au = (e) => {
  const { isInit: t, accessToken: n, organizationId: o } = cr();
  let r = "/conferencing/default";
  return e && (r = `/organizations/${o}/teams/${e}/conferencing/default`), mr({
    queryKey: [Mw, e, o],
    queryFn: () => At == null ? void 0 : At.get(r).then((i) => {
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error(i.data.error.message);
    }),
    enabled: t && !!n
  });
}, wau = ({
  onSuccess: e,
  onError: t,
  onSettled: n,
  teamId: o
}) => {
  const { organizationId: r } = cr();
  return Hr({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i)
        throw new Error("app is required");
      let a = `/conferencing/${i}/default`;
      return o && (a = `/organizations/${r}/teams/${o}/conferencing/${i}/default`), At == null ? void 0 : At.post(a).then((s) => {
        if (s.data.status !== Nn)
          throw new Error(s.data.error.message);
      });
    }
  });
}, kau = () => /* @__PURE__ */ m(Tq, { children: /* @__PURE__ */ de("div", { className: "divide-subtle border-subtle space-y-6 rounded-b-lg border border-t-0 px-6 py-4", children: [
  /* @__PURE__ */ m(Yo, { className: "h-8 w-full" }),
  /* @__PURE__ */ m(Yo, { className: "h-8 w-full" })
] }) }), xsu = ({
  disableToasts: e = !1,
  returnTo: t,
  onErrorReturnTo: n,
  teamId: o,
  apps: r,
  disableBulkUpdateEventTypes: i = !1
}) => {
  var S;
  const { t: a } = kt(), s = qc(), { toast: c } = wf(), l = (E, x) => {
    e || c({ description: E });
  }, [u, d] = A0(
    (E, x) => ({ ...E, ...x }),
    {
      isOpen: !1,
      credentialId: null,
      app: null
    }
  ), [_, p] = it(!1), g = () => {
    d({ isOpen: !1, credentialId: null, app: null });
  }, f = (E, x) => {
    d({ isOpen: !0, credentialId: E, app: x });
  }, h = fau(o), { data: $ } = $au(o), { data: v, isFetching: b } = mau(
    o,
    i
  ), y = yau({
    onSuccess: () => {
      l(a("app_removed_successfully")), g(), s.invalidateQueries({
        queryKey: [Lw]
      }), s.resetQueries({
        queryKey: [Mw]
      });
    },
    onError: () => {
      l(a("error_removing_app")), g();
    },
    teamId: o
  }), w = wau({
    teamId: o
  }), N = _au({
    teamId: o
  }), M = ({ app: E }) => {
    E && y.mutate(E);
  }, q = ({
    appSlug: E,
    onSuccessCallback: x,
    onErrorCallback: k
  }) => {
    w.mutate(E, {
      onSuccess: () => {
        l("Default app updated successfully"), s.invalidateQueries({ queryKey: [Mw] }), !i && x();
      },
      onError: (I) => {
        l(`Error: ${I.message}`), k();
      }
    });
  }, L = ({ eventTypeIds: E, callback: x }) => {
    if (i) {
      x();
      return;
    }
    N.mutate(E, {
      onSuccess: () => {
        s.invalidateQueries({ queryKey: [Mw] }), x();
      }
    });
  }, R = () => {
    s.invalidateQueries({ queryKey: [Lw] });
  }, T = () => {
    s.invalidateQueries({ queryKey: [Mw] });
  }, { connect: D } = bau({
    onSuccess: () => {
      l("app installed successfully"), s.invalidateQueries({ queryKey: [Lw] });
    },
    onError: () => {
      s.invalidateQueries({ queryKey: [Lw] }), l("Error: unable to install app");
    },
    returnTo: t,
    onErrorReturnTo: n,
    teamId: o
  }), A = ({ installedApps: E }) => /* @__PURE__ */ de(jd, { children: [
    /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(Jt, { color: "secondary", StartIcon: "plus", children: a("add") }) }),
    /* @__PURE__ */ de(Yu, { children: [
      E && !E.find((x) => x.slug === IE) && (!r || r.includes(IE)) && /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(ba, { color: "secondary", onClick: () => D(IE), children: a("google_meet") }) }),
      E && !E.find((x) => x.slug === zb) && (!r || r.includes(zb)) && /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(ba, { color: "secondary", onClick: () => D(zb), children: a("zoom") }) }),
      E && !E.find((x) => x.slug === Rb) && (!r || r.includes(Rb)) && /* @__PURE__ */ m(Pi, { children: /* @__PURE__ */ m(ba, { color: "secondary", onClick: () => p(!0), children: a("office_365_video") }) })
    ] })
  ] });
  return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m(
    dau,
    {
      title: a("conferencing"),
      description: a("conferencing_description"),
      CTA: /* @__PURE__ */ m(A, { installedApps: (S = h.data) == null ? void 0 : S.items }),
      borderInShellHeader: !0,
      children: /* @__PURE__ */ de(nt, { children: [
        /* @__PURE__ */ m("div", { className: "bg-default w-full sm:mx-0 xl:mt-0", children: /* @__PURE__ */ m(
          yve,
          {
            query: h,
            customLoader: /* @__PURE__ */ m(kau, {}),
            success: ({ data: E }) => E.items.length ? /* @__PURE__ */ m(
              cau,
              {
                listClassName: "rounded-lg rounded-t-none border-t-0 max-w-full",
                handleDisconnect: f,
                data: E,
                variant: "conferencing",
                defaultConferencingApp: $,
                handleUpdateUserDefaultConferencingApp: q,
                handleBulkUpdateDefaultLocation: L,
                isBulkUpdateDefaultLocationPending: N == null ? void 0 : N.isPending,
                eventTypes: v == null ? void 0 : v.eventTypes,
                isEventTypesFetching: b,
                handleConnectDisconnectIntegrationMenuToggle: R,
                handleBulkEditDialogToggle: T
              }
            ) : /* @__PURE__ */ m(
              e$,
              {
                Icon: "calendar",
                headline: a("no_category_apps", {
                  category: a("conferencing").toLowerCase()
                }),
                description: a("no_category_apps_description_conferencing"),
                buttonRaw: /* @__PURE__ */ m(A, { installedApps: E == null ? void 0 : E.items })
              }
            )
          }
        ) }),
        /* @__PURE__ */ m(
          uau,
          {
            handleModelClose: g,
            isOpen: u.isOpen,
            credentialId: u.credentialId,
            app: u.app,
            handleRemoveApp: M
          }
        ),
        /* @__PURE__ */ m(
          oau,
          {
            open: _,
            onOpenChange: p,
            handleSubmit: () => D(Rb)
          }
        )
      ] })
    }
  ) });
}, Sau = ({ onSuccess: e, onError: t, onSettled: n }) => Hr({
  onSuccess: e,
  onError: t,
  onSettled: n,
  mutationFn: (o) => {
    const r = `/${rs.eventTypes}`;
    return At == null ? void 0 : At.post(r, o, {
      headers: { [Fy]: k6 }
    }).then((i) => {
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error(i.data.error.message);
    });
  }
}), Eau = ({ onSuccess: e, onError: t, onSettled: n }) => {
  const { organizationId: o } = cr();
  return Hr({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: ({ teamId: r, ...i }) => {
      if (!r)
        throw new Error("Event type id is required");
      const a = `/organizations/${o}/teams/${r}/event-types`;
      return At == null ? void 0 : At.post(a, i, {
        headers: { [Fy]: k6 }
      }).then((s) => {
        if (s.data.status === Nn)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, Voe = ({
  submitLabel: e,
  cancelLabel: t,
  isPending: n,
  customClassNames: o,
  onCancel: r
}) => /* @__PURE__ */ de("div", { className: ar("flex flex-row gap-4", o == null ? void 0 : o.container), children: [
  /* @__PURE__ */ m(Jt, { type: "submit", loading: n, className: o == null ? void 0 : o.submit, children: e }),
  r && /* @__PURE__ */ m(
    Jt,
    {
      color: "secondary",
      type: "button",
      loading: n,
      className: o == null ? void 0 : o.cancel,
      onClick: () => r(),
      children: t
    }
  )
] }), Csu = ({
  teamId: e,
  onSuccess: t,
  onError: n,
  customClassNames: o,
  onCancel: r,
  isDryRun: i = !1
}) => {
  const { form: a, isManagedEventType: s } = X7l(), c = Sau({ onSuccess: t, onError: n }), l = Eau({ onSuccess: t, onError: n }), { data: u } = VUl(), d = u == null ? void 0 : u.find((g) => g.id === e), { t: _ } = kt(), p = {
    canCreateEventType: (d == null ? void 0 : d.role) === "ADMIN" || (d == null ? void 0 : d.role) === "OWNER"
  };
  return e && d ? /* @__PURE__ */ m(is, { customClassName: o == null ? void 0 : o.atomsWrapper, children: /* @__PURE__ */ m(
    Y7l,
    {
      teamSlug: d == null ? void 0 : d.slug,
      teamId: e,
      permissions: p,
      urlPrefix: "",
      isPending: l.isPending,
      form: a,
      isManagedEventType: s,
      handleSubmit: (g) => {
        !i && l.mutate({
          lengthInMinutes: g.length,
          title: g.title,
          slug: g.slug,
          description: g.description ?? "",
          schedulingType: g.schedulingType ?? "COLLECTIVE",
          hosts: [],
          teamId: e
        });
      },
      SubmitButton: (g) => Voe({
        isPending: g,
        onCancel: r,
        submitLabel: _("continue"),
        cancelLabel: _("cancel"),
        customClassNames: o == null ? void 0 : o.buttons
      })
    }
  ) }) : /* @__PURE__ */ m(is, { customClassName: o == null ? void 0 : o.atomsWrapper, children: /* @__PURE__ */ m(
    hKl,
    {
      urlPrefix: "",
      isPending: c.isPending,
      form: a,
      isManagedEventType: s,
      handleSubmit: (g) => {
        !i && c.mutate({
          lengthInMinutes: g.length,
          title: g.title,
          slug: g.slug,
          description: g.description ?? ""
        });
      },
      SubmitButton: (g) => Voe({
        isPending: g,
        onCancel: r,
        submitLabel: _("continue"),
        cancelLabel: _("cancel"),
        customClassNames: o == null ? void 0 : o.buttons
      })
    }
  ) });
}, xau = "use-event-app-integration", Cau = ({
  uid: e,
  onEventTypePaymentInfoSuccess: t,
  onEventTypePaymentInfoFailure: n
}) => {
  const o = `/atoms/payment/${e}`, { isInit: r, accessToken: i } = cr();
  return mr({
    queryKey: [xau, e],
    queryFn: () => At == null ? void 0 : At.get(o).then((a) => {
      if (a.data.status === Nn)
        return t == null || t(), a.data.data;
      throw n == null || n(), new Error(a.data.error.message);
    }),
    enabled: !!e && r && !!i
  });
}, Tau = Fe.lazy(() => import("./StripePaymentForm-ggnWFKBm.js")), Tsu = ({
  paymentUid: e,
  onPaymentSuccess: t,
  onPaymentCancellation: n,
  onEventTypePaymentInfoSuccess: o,
  onEventTypePaymentInfoFailure: r
}) => {
  const { t: i } = kt(), { data: a, isLoading: s } = Cau({
    uid: e,
    onEventTypePaymentInfoSuccess: o,
    onEventTypePaymentInfoFailure: r
  }), c = a == null ? void 0 : a.booking.title, l = Qge(), u = vr.getItem("timeOption.preferredTimeZone") || zy, d = ht.utc(a == null ? void 0 : a.booking.startTime).tz(u);
  if (s)
    return /* @__PURE__ */ m("h1", { className: "p-4 pt-4 text-xl", children: "Loading..." });
  if (!a)
    return /* @__PURE__ */ de("h1", { className: "p-4 text-xl", children: [
      "No payment found with UID - ",
      e
    ] });
  const _ = Lg(a == null ? void 0 : a.eventType);
  return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(hT, { fallback: /* @__PURE__ */ m(nt, {}), children: /* @__PURE__ */ m("main", { className: "mx-auto", children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0", children: /* @__PURE__ */ de("div", { className: "inset-0 my-4 transition-opacity sm:my-0", "aria-hidden": "true", children: [
    /* @__PURE__ */ m("span", { className: "hidden sm:inline-block sm:h-screen sm:align-middle", "aria-hidden": "true", children: "​" }),
    /* @__PURE__ */ de(
      "div",
      {
        className: ar(
          "main bg-default border-subtle inline-block transform overflow-hidden rounded-lg border px-8 pb-4 pt-5 text-left align-bottom transition-all  sm:my-8 sm:w-full sm:max-w-lg sm:py-6 sm:align-middle"
        ),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "modal-headline",
        children: [
          /* @__PURE__ */ de("div", { children: [
            /* @__PURE__ */ m("div", { className: "bg-success mx-auto flex h-12 w-12 items-center justify-center rounded-full", children: /* @__PURE__ */ m(Nal, { currency: _.currency, className: "h-8 w-8 text-green-600" }) }),
            /* @__PURE__ */ de("div", { className: "mt-3 text-center sm:mt-5", children: [
              /* @__PURE__ */ m("h3", { className: "text-emphasis text-2xl font-semibold leading-6", id: "modal-headline", children: _.paymentOption === "HOLD" ? i("complete_your_booking") : i("payment") }),
              /* @__PURE__ */ de("div", { className: "text-default mt-4 grid grid-cols-3 border-b border-t py-4 text-left dark:border-gray-900 dark:text-gray-300", children: [
                /* @__PURE__ */ m("div", { className: "font-medium", children: i("what") }),
                /* @__PURE__ */ m("div", { className: "col-span-2 mb-6", children: c }),
                /* @__PURE__ */ m("div", { className: "font-medium", children: i("when") }),
                /* @__PURE__ */ de("div", { className: "col-span-2 mb-6", children: [
                  d.format("dddd, DD MMMM YYYY"),
                  /* @__PURE__ */ m("br", {}),
                  d.format(l ? "H:mm" : "h:mma"),
                  " - ",
                  a.eventType.length,
                  " mins",
                  " ",
                  /* @__PURE__ */ de("span", { className: "text-subtle", children: [
                    "(",
                    u,
                    ")"
                  ] })
                ] }),
                a.booking.location && /* @__PURE__ */ de(nt, { children: [
                  /* @__PURE__ */ m("div", { className: "font-medium", children: i("where") }),
                  /* @__PURE__ */ m("div", { className: "col-span-2 mb-6", children: cil(a.booking.location, i) })
                ] }),
                /* @__PURE__ */ m("div", { className: "font-medium", children: a.payment.paymentOption === "HOLD" ? i("no_show_fee") : i("price") }),
                /* @__PURE__ */ m("div", { className: "col-span-2 mb-6 font-semibold", children: /* @__PURE__ */ m(
                  rhe,
                  {
                    currency: _.currency,
                    price: _.price,
                    displayAlternateSymbol: !1
                  }
                ) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ de("div", { children: [
            a.payment.success && !a.payment.refunded && /* @__PURE__ */ m("div", { className: "text-default mt-4 text-center dark:text-gray-300", children: i("paid") }),
            a.payment.appId === "stripe" && !a.payment.success && /* @__PURE__ */ m(
              Tau,
              {
                clientSecret: a.clientSecret,
                payment: a.payment,
                eventType: a.eventType,
                user: a.user,
                location: a.booking.location,
                booking: a.booking,
                uid: e,
                onPaymentSuccess: t,
                onPaymentCancellation: n
              }
            ),
            a.payment.refunded && /* @__PURE__ */ m("div", { className: "text-default mt-4 text-center dark:text-gray-300", children: i("refunded") })
          ] }),
          !a.profile.hideBranding && /* @__PURE__ */ m("div", { className: "text-muted dark:text-inverted mt-4 border-t pt-4 text-center text-xs dark:border-gray-900", children: /* @__PURE__ */ m("a", { href: `${Vw}/signup`, children: i("create_booking_link_with_calcom", { appName: Kp }) }) })
        ]
      }
    )
  ] }) }) }) }) }) }) });
}, Aau = "use-organization-bookings", Asu = (e) => {
  const { organizationId: t } = cr(), n = `/organizations/${t}/bookings`;
  return mr({
    queryKey: [Aau, ...Iau(e)],
    queryFn: async () => At.get(n, {
      params: e
    }).then((r) => {
      var i, a;
      if (r.data.status === Nn)
        return r.data.data;
      throw new Error((a = (i = r.data) == null ? void 0 : i.error) == null ? void 0 : a.message);
    })
  });
};
function Iau(e) {
  return [...Hj(e), e.userIds];
}
const Oau = "use-organization-user-bookings", Isu = (e, t) => {
  const { organizationId: n } = cr(), o = `/organizations/${n}/users/${e}/bookings`;
  return mr({
    queryKey: [Oau, e, ...Hj(t)],
    queryFn: async () => At.get(o, {
      params: t
    }).then((i) => {
      var a, s;
      if (i.data.status === Nn)
        return i.data.data;
      throw new Error((s = (a = i.data) == null ? void 0 : a.error) == null ? void 0 : s.message);
    })
  });
}, Nau = ({
  extraDays: e,
  schedule: t,
  isLoading: n,
  event: o
}) => {
  var p, g;
  const r = _n((f) => f.selectedDate), i = _n((f) => f.selectedDuration), a = zc("overlayCalendar") === "true" || (vr == null ? void 0 : vr.getItem("overlayCalendarSwitchDefault")), s = i || ((p = o == null ? void 0 : o.data) == null ? void 0 : p.length) || 30, c = ive({ schedule: t, eventDuration: s }), l = r ? ht(r).toDate() : ht().toDate(), u = ht(l).add(e - 1, "day").toDate(), { data: d } = RUl({
    take: 150,
    skip: 0,
    status: ["upcoming", "past", "recurring"],
    eventTypeId: (g = o == null ? void 0 : o.data) == null ? void 0 : g.id,
    afterStart: l.toISOString(),
    beforeEnd: u.toISOString()
  });
  yt(() => {
  }, [a]);
  const _ = vn(() => d ? d == null ? void 0 : d.map((f) => ({
    id: f.id,
    title: f.title ?? "Busy",
    start: new Date(f.start),
    end: new Date(f.end),
    options: {
      borderColor: "black",
      status: f.status.toUpperCase(),
      "data-test-id": "troubleshooter-busy-event",
      className: "border-[1.5px]"
    }
  })) : [], [d]);
  return /* @__PURE__ */ m("div", { className: "h-full [--calendar-dates-sticky-offset:66px]", children: /* @__PURE__ */ m(
    cve,
    {
      isPending: n,
      availableTimeslots: c,
      startHour: 0,
      endHour: 23,
      events: _,
      startDate: l,
      endDate: u,
      gridCellsPerHour: 60 / s,
      hoverEventDuration: s,
      hideHeader: !0
    }
  ) });
}, zau = "use-team-event-type", Rau = (e, t, n, o) => {
  const { organizationId: r } = cr(), i = t;
  let a = `/organizations/${r}/teams/${e}/event-types?eventSlug=${i}`;
  return r || (a = `/teams/${e}/event-types?eventSlug=${i}`), o !== void 0 && (a += `&hostsLimit=${o}`), mr({
    queryKey: [zau, t, r, e],
    queryFn: async () => {
      if (e && t && n)
        return At == null ? void 0 : At.get(a).then((c) => {
          if (c.data.status === Nn)
            return c.data.data;
          throw new Error(c.data.error.message);
        });
    },
    enabled: !!e && !!t && !!n
  });
}, Pau = (e) => {
  var M, q, L, R, T;
  const t = !!e.teamId, n = e.teamId ? e.teamId : void 0, o = vn(() => e.username ? hve(e.username) : "", [e.username]), { isPending: r } = NUl(o, e.eventSlug, t), { isPending: i } = Rau(n, e.eventSlug, t), a = _n((D) => D.selectedDuration), s = pve({
    username: o,
    eventSlug: e.eventSlug,
    isTeamEvent: t,
    teamId: n,
    selectedDuration: a
  }), c = uve((q = (M = s.data) == null ? void 0 : M.profile) == null ? void 0 : q.bookerLayouts), [l, u] = _n(
    (D) => [D.state, D.setState],
    Xi
  ), d = _n((D) => D.selectedDate), _ = ht(d).format("YYYY-MM-DD"), p = _n((D) => D.month), [g] = _n((D) => [D.dayCount, D.setDayCount], Xi), { prefetchNextMonth: f, monthCount: h } = dve({
    date: _,
    month: p,
    bookerLayout: c,
    bookerState: l
  }), [$, v] = Rj({
    month: p,
    monthCount: h,
    dayCount: g,
    prefetchNextMonth: f,
    selectedDate: d
  }), { timezone: b } = Mg(), y = vn(() => yf(o ?? "").length > 1, [o]), w = _n((D) => D.bookingData);
  fF({
    ...e,
    eventId: (L = s == null ? void 0 : s.data) == null ? void 0 : L.id,
    layout: "week_view",
    username: o,
    bookingData: w,
    isPlatform: !0,
    allowUpdatingUrlParams: !1
  });
  const N = mve({
    usernameList: yf(o),
    eventTypeId: ((R = s == null ? void 0 : s.data) == null ? void 0 : R.id) ?? 0,
    startTime: $,
    endTime: v,
    timeZone: b,
    duration: a ?? void 0,
    teamMemberEmail: void 0,
    ...t ? {
      isTeamEvent: t,
      teamId: n
    } : {},
    enabled: !!(n || o) && !!p && !!b && (t ? !i : !r) && !!((T = s == null ? void 0 : s.data) != null && T.id),
    orgSlug: void 0,
    eventTypeSlug: y ? "dynamic" : e.eventSlug || ""
  });
  return /* @__PURE__ */ de(is, { children: [
    /* @__PURE__ */ m(eg, { area: "header", className: "bg-default dark:bg-muted sticky top-0 z-10", children: /* @__PURE__ */ m(
      rve,
      {
        isCalendarView: !0,
        isMyLink: !0,
        eventSlug: e.eventSlug,
        enabledLayouts: c.bookerLayouts.enabledLayouts,
        extraDays: 7,
        isMobile: !1,
        nextSlots: 6
      }
    ) }),
    /* @__PURE__ */ m(
      eg,
      {
        area: "main",
        visible: !0,
        className: "border-subtle sticky top-0 ml-[-1px] h-full md:border-l",
        children: /* @__PURE__ */ m(Nau, { extraDays: 7, schedule: N.data, isLoading: N.isPending, event: s })
      },
      "large-calendar"
    )
  ] });
}, Osu = (e) => /* @__PURE__ */ m(Wy, { children: /* @__PURE__ */ m(Pau, { ...e }) }), B$e = "use-atom-user-schedules", Dau = () => {
  const e = "atoms/schedules/all", { isInit: t, accessToken: n } = cr(), { isLoading: o, error: r, data: i, refetch: a } = mr({
    queryKey: [B$e],
    queryFn: () => At.get(e).then((s) => {
      var c;
      if (s.data.status === Nn)
        return s.data.data;
      throw new Error((c = s.data.error) == null ? void 0 : c.message);
    }),
    enabled: t && !!n
  });
  return { isLoading: o, error: r, data: i, refetch: a };
}, Lau = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = qc();
  return Hr({
    mutationFn: async (o) => {
      const r = "atoms/schedules/create";
      return (await At.post(r, o)).data;
    },
    onSuccess: (o) => {
      o.status === Nn ? (e == null || e(o), n.invalidateQueries({ queryKey: [D0] }), n.invalidateQueries({ queryKey: [B$e] })) : t == null || t(o);
    },
    onError: (o) => {
      t == null || t(o);
    }
  });
}, Mau = ({
  onSuccess: e,
  onError: t,
  onCancel: n,
  customClassNames: o,
  disableToasts: r = !1
}) => {
  var d, _, p;
  const { toast: i } = wf(), { t: a } = kt(), s = W_(), { register: c } = s, { mutateAsync: l, isPending: u } = Lau({
    onSuccess: (g) => {
      r || i({
        description: a("schedule_created_successfully", { scheduleName: g.data.schedule.name })
      }), s.reset(), e == null || e(g.data.schedule.id);
    },
    onError: (g) => {
      t == null || t(g), r || i({
        description: `Could not create schedule: ${g.error.message}`
      });
    }
  });
  return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ de(
    Y_,
    {
      className: o == null ? void 0 : o.formWrapper,
      form: s,
      handleSubmit: async (g) => {
        await l(g);
      },
      children: [
        /* @__PURE__ */ m(
          Da,
          {
            className: o == null ? void 0 : o.inputField,
            label: a("name"),
            type: "text",
            id: "name",
            required: !0,
            placeholder: a("default_schedule_name"),
            ...c("name", {
              setValueAs: (g) => !g || g.trim() === "" ? null : g
            })
          }
        ),
        /* @__PURE__ */ de(
          "div",
          {
            className: ar(
              "mt-5 justify-end space-x-2 rtl:space-x-reverse sm:mt-4 sm:flex",
              (d = o == null ? void 0 : o.actionsButtons) == null ? void 0 : d.container
            ),
            children: [
              n && /* @__PURE__ */ m(
                Jt,
                {
                  type: "button",
                  color: "secondary",
                  onClick: n,
                  className: (_ = o == null ? void 0 : o.actionsButtons) == null ? void 0 : _.close,
                  children: a("close")
                }
              ),
              /* @__PURE__ */ de(
                Jt,
                {
                  type: "submit",
                  loading: u,
                  className: (p = o == null ? void 0 : o.actionsButtons) == null ? void 0 : p.continue,
                  children: [
                    " ",
                    a("continue")
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, Nsu = ({
  name: e,
  customClassNames: t,
  onSuccess: n,
  onError: o,
  disableToasts: r = !1
}) => {
  var c, l, u;
  const { t: i } = kt(), [a, s] = it(!1);
  return /* @__PURE__ */ m(is, { children: /* @__PURE__ */ de($F, { open: a, onOpenChange: s, children: [
    /* @__PURE__ */ m(Sce, { asChild: !0, children: /* @__PURE__ */ m(
      Jt,
      {
        type: "button",
        "data-testid": e,
        className: t == null ? void 0 : t.createScheduleButton,
        StartIcon: "plus",
        onClick: () => s(!0),
        children: e ?? i("new")
      }
    ) }),
    /* @__PURE__ */ m(kF, { className: "bg-default text-default", children: /* @__PURE__ */ m(
      Mau,
      {
        customClassNames: {
          formWrapper: t == null ? void 0 : t.formWrapper,
          inputField: t == null ? void 0 : t.inputField,
          actionsButtons: {
            container: (c = t == null ? void 0 : t.actionsButtons) == null ? void 0 : c.container,
            continue: (l = t == null ? void 0 : t.actionsButtons) == null ? void 0 : l.continue,
            close: (u = t == null ? void 0 : t.actionsButtons) == null ? void 0 : u.close
          }
        },
        onSuccess: (d) => {
          s(!1), n == null || n(d);
        },
        onError: o,
        onCancel: () => s(!1),
        disableToasts: r
      }
    ) })
  ] }) });
};
function Fau({
  schedule: e,
  deleteFunction: t,
  displayOptions: n,
  updateDefault: o,
  isDeletable: r,
  duplicateFunction: i,
  redirectUrl: a
}) {
  const { t: s, i18n: c } = kt();
  return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ de("div", { className: "hover:bg-muted flex items-center justify-between px-3 py-5 transition sm:px-4", children: [
    /* @__PURE__ */ m("div", { className: "group flex w-full items-center justify-between ", children: /* @__PURE__ */ de(Ir, { href: a, className: "flex-grow truncate text-sm", title: e.name, children: [
      /* @__PURE__ */ de("div", { className: "space-x-2 rtl:space-x-reverse", children: [
        /* @__PURE__ */ m("span", { className: "text-emphasis truncate font-medium", children: e.name }),
        e.isDefault && /* @__PURE__ */ m(Wi, { variant: "gray", className: "text-xs", children: s("default") })
      ] }),
      /* @__PURE__ */ de("p", { className: "text-subtle mt-1", children: [
        e.availability.filter((l) => !!l.days.length).map(
          (l) => spe(l, {
            locale: c.language,
            hour12: n == null ? void 0 : n.hour12
          })
        ).sort(Xme(c.language, n == null ? void 0 : n.weekStart)).map((l, u) => /* @__PURE__ */ de(Ha, { children: [
          l,
          /* @__PURE__ */ m("br", {})
        ] }, u)),
        (e.timeZone || (n == null ? void 0 : n.timeZone)) && /* @__PURE__ */ de("span", { className: "my-1 flex items-center first-letter:text-xs", children: [
          /* @__PURE__ */ m(qt, { name: "globe", className: "h-3.5 w-3.5" }),
          " ",
          e.timeZone ?? (n == null ? void 0 : n.timeZone)
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ de(jd, { children: [
      /* @__PURE__ */ m(Hu, { asChild: !0, children: /* @__PURE__ */ m(
        Jt,
        {
          "data-testid": "schedule-more",
          type: "button",
          variant: "icon",
          color: "secondary",
          StartIcon: "ellipsis"
        }
      ) }),
      /* @__PURE__ */ de(Yu, { children: [
        !e.isDefault && /* @__PURE__ */ m(Pi, { className: "min-w-40 focus:ring-muted", children: /* @__PURE__ */ m(
          ba,
          {
            type: "button",
            StartIcon: "star",
            onClick: () => {
              o({
                scheduleId: e.id,
                isDefault: !0
              });
            },
            children: s("set_as_default")
          }
        ) }),
        /* @__PURE__ */ m(Pi, { className: "outline-none", children: /* @__PURE__ */ m(
          ba,
          {
            type: "button",
            "data-testid": `schedule-duplicate${e.id}`,
            StartIcon: "copy",
            onClick: () => {
              i({
                scheduleId: e.id
              });
            },
            children: s("duplicate")
          }
        ) }),
        /* @__PURE__ */ m(Pi, { className: "min-w-40 focus:ring-muted", children: /* @__PURE__ */ m(
          ba,
          {
            type: "button",
            color: "destructive",
            StartIcon: "trash",
            "data-testid": "delete-schedule",
            className: "rounded-t-none",
            onClick: () => {
              r ? t({
                scheduleId: e.id
              }) : ti(s("requires_at_least_one_schedule"), "error");
            },
            children: s("delete")
          }
        ) })
      ] })
    ] })
  ] }) }, e.id);
}
const qau = (e) => ({
  ...e,
  availability: e.availability.map((t) => ({
    ...t,
    startTime: new Date(t.startTime),
    endTime: new Date(t.endTime),
    date: t.date ? new Date(t.date) : null
  }))
}), jau = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = qc();
  return Hr({
    mutationFn: async ({ scheduleId: o }) => {
      const r = `atoms/schedules/${o}/duplicate`;
      return (await At.post(r)).data;
    },
    onSuccess: (o) => {
      o.status === Nn ? (e == null || e(o), n.invalidateQueries({ queryKey: [D0] })) : t == null || t(o);
    },
    onError: (o) => {
      t == null || t(o);
    }
  });
};
function Vau(e, t) {
  const n = xt(t);
  yt(() => {
    n.current = t;
  }), yt(() => {
    e.filter((r) => r.isDefault).length === 0 && e.length > 0 && n.current(e[0].id);
  }, [e]);
}
const zsu = ({ getScheduleUrl: e } = {}) => {
  const [t] = qd(), { toast: n } = wf(), { t: o } = kt(), {
    data: r,
    isLoading: i,
    refetch: a
  } = Dau(), { data: s, isLoading: c } = Ev(), { mutate: l } = dse({
    onSuccess: () => {
      n({
        description: "Schedule updated successfully"
      }), a();
    },
    onError: (p) => {
      n({
        description: `Could not update schedule: ${p.error.message}`
      });
    }
  }), { mutate: u } = jau({
    onSuccess: () => {
      n({
        description: "Schedule created successfully"
      }), a();
    },
    onError: (p) => {
      n({
        description: `Could not duplicate schedule: ${p.error.message}`
      });
    }
  }), { mutate: d } = _se({
    onSuccess: () => {
      n({
        description: "Schedule deleted successfully"
      }), a();
    },
    onError: (p) => {
      n({
        description: `Could not delete schedule: ${p.error.message}`
      });
    }
  });
  Vau((r == null ? void 0 : r.schedules) ?? [], (p) => {
    l({
      scheduleId: p,
      body: {
        isDefault: !0
      }
    });
  });
  const _ = r == null ? void 0 : r.schedules.map((p) => qau(p));
  return i || c ? /* @__PURE__ */ m(nt, { children: o("loading") }) : !i && (_ == null ? void 0 : _.length) === 0 ? /* @__PURE__ */ m(
    e$,
    {
      Icon: "clock",
      headline: o("no_schedules_present"),
      description: o("create_new_schedule"),
      className: "w-full"
    }
  ) : /* @__PURE__ */ m(is, { children: /* @__PURE__ */ m("div", { className: "border-subtle bg-default overflow-hidden rounded-md border", children: /* @__PURE__ */ m("ul", { className: "divide-subtle divide-y", "data-testid": "schedules", ref: t, children: _ == null ? void 0 : _.map((p) => /* @__PURE__ */ m(
    Fau,
    {
      displayOptions: {
        hour12: s != null && s.data.timeFormat ? s.data.timeFormat === 12 : void 0,
        timeZone: s == null ? void 0 : s.data.timeZone,
        weekStart: (s == null ? void 0 : s.data.weekStart) || "Sunday"
      },
      schedule: p,
      isDeletable: _.length !== 1,
      redirectUrl: e ? e(p.id) : "#",
      updateDefault: () => {
        l({
          scheduleId: p.id,
          body: {
            isDefault: !0
          }
        });
      },
      deleteFunction: async () => await d({ id: p.id }),
      duplicateFunction: () => u({ scheduleId: p.id })
    },
    p.id
  )) }) }) });
};
export {
  Yde as $,
  BUl as A,
  Jt as B,
  Due as C,
  Kyc as D,
  Rde as E,
  Y_ as F,
  NK as G,
  Fbc as H,
  Da as I,
  Us as J,
  zK as K,
  Ko as L,
  psu as M,
  eyc as N,
  Sal as O,
  Qbc as P,
  Sr as Q,
  qt as R,
  Di as S,
  xq as T,
  mTe as U,
  oe as V,
  Wa as W,
  xcl as X,
  Ef as Y,
  AK as Z,
  IK as _,
  B_e as a,
  xsu as a$,
  $j as a0,
  yj as a1,
  vrl as a2,
  ti as a3,
  Ow as a4,
  Bs as a5,
  RK as a6,
  Vge as a7,
  Prl as a8,
  r1 as a9,
  rsu as aA,
  _U as aB,
  lse as aC,
  _su as aD,
  QZ as aE,
  cr as aF,
  Uy as aG,
  hsu as aH,
  vsu as aI,
  NUl as aJ,
  Fcl as aK,
  bsu as aL,
  ysu as aM,
  RUl as aN,
  Ev as aO,
  vve as aP,
  $su as aQ,
  DUl as aR,
  LUl as aS,
  MUl as aT,
  FUl as aU,
  qUl as aV,
  VUl as aW,
  WUl as aX,
  eGl as aY,
  wsu as aZ,
  Esu as a_,
  G5 as aa,
  i1 as ab,
  a1 as ac,
  Ss as ad,
  Ya as ae,
  Wu as af,
  Gs as ag,
  qd as ah,
  av as ai,
  ru as aj,
  hr as ak,
  Yge as al,
  Kr as am,
  Ir as an,
  stl as ao,
  Otl as ap,
  Mi as aq,
  oau as ar,
  vb as as,
  jme as at,
  Lq as au,
  Tf as av,
  Z_ as aw,
  Vy as ax,
  vr as ay,
  dsu as az,
  cc as b,
  DZl as b0,
  Csu as b1,
  Tsu as b2,
  Sau as b3,
  Eau as b4,
  Asu as b5,
  Isu as b6,
  Osu as b7,
  Nsu as b8,
  Mau as b9,
  zsu as ba,
  Kw as c,
  Pde as d,
  Iu as e,
  xr as f,
  Mbc as g,
  iq as h,
  G0 as i,
  isu as j,
  Nde as k,
  lq as l,
  s0c as m,
  Xw as n,
  Jo as o,
  as as p,
  $_e as q,
  xe as r,
  Kde as s,
  xf as t,
  Zde as u,
  mil as v,
  kt as w,
  Nr as x,
  Ssu as y,
  b7l as z
};
